/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1541);
	__webpack_require__(945);
	__webpack_require__(945);
	module.exports = __webpack_require__(1173);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(166);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	var createNonEnumerableProperty = __webpack_require__(58);
	var defineBuiltIn = __webpack_require__(40);
	var defineGlobalProperty = __webpack_require__(401);
	var copyConstructorProperties = __webpack_require__(227);
	var isForced = __webpack_require__(233);
	
	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	module.exports = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = globalThis;
	  } else if (STATIC) {
	    target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = globalThis[TARGET] && globalThis[TARGET].prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Use: const _ = make_(localTranslations)
	// _('i18nId') is translation
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stateActions = __webpack_require__(5);
	
	var _stateDucksCategories = __webpack_require__(615);
	
	var _stateDucksSources = __webpack_require__(616);
	
	var _stateStore = __webpack_require__(271);
	
	var _stateStore2 = _interopRequireDefault(_stateStore);
	
	var dict = undefined;
	var requested = false;
	var promiseForTranslations = undefined;
	
	var getPromiseForTranslations = function getPromiseForTranslations() {
	
	    if (!dict && !requested) {
	        make_();
	    }
	
	    return promiseForTranslations;
	};
	
	exports.getPromiseForTranslations = getPromiseForTranslations;
	var make_ = function make_(prefix) {
	    return function (id) {
	        var forceLang = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	        if (!dict) {
	            var sDict = _stateStore2['default'].getState().dict;
	            if (sDict._gen) {
	                dict = sDict;
	            } else {
	                if (!requested) {
	
	                    promiseForTranslations = new Promise(function (resolve, reject) {
	
	                        window.setTimeout(function () {
	                            return _stateStore2['default'].dispatch((0, _stateActions.getTranslations)()).then(function (result) {
	                                return resolve(result);
	                            });
	                        }, 0);
	                    });
	                    dict;
	                    //promiseForTranslations = new Promise((resolve, reject) => { resolve() })
	                    promiseForTranslations.then(function (result) {
	                        return result;
	                    });
	
	                    //setTimeout(() => store.dispatch(getTranslations()), 0)
	                }
	                requested = true;
	                return '…';
	            }
	        }
	
	        return (prefix && dict[prefix + '_' + id] || dict[id] || {})[forceLang ? forceLang : global.lang] || (prefix ? '[' + prefix + '_' + id + ']' : '[' + id + ']');
	    };
	};
	
	var catsDict = undefined;
	var catsRequested = false;
	var catIdToString = function catIdToString(catId) {
	    var callBack = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    if (!catsDict) {
	        var sDict = _stateStore2['default'].getState().categories;
	        if (sDict._gen) {
	            catsDict = sDict;
	            if (typeof callBack == 'function') {
	                callBack(null, null);
	            }
	        } else {
	            if (!catsRequested) {
	                setTimeout(function () {
	                    return _stateStore2['default'].dispatch((0, _stateDucksCategories.getCategories)()).then(function (result) {
	                        if (typeof callBack === 'function') {
	                            callBack(result, null);
	                        }
	                    })['catch'](function (err) {
	                        if (typeof callBack === 'function') {
	                            callBack(null, err);
	                        }
	                    });
	                }, 0);
	            } else {
	                if (typeof callBack == 'function') {
	                    callBack(null, null);
	                }
	            }
	
	            catsRequested = true;
	
	            // While we are fetching, show nothing
	            return '…';
	        }
	    } else {
	        if (typeof callBack == 'function') {
	            callBack(null, null);
	        }
	    }
	
	    var cat = catsDict[catId];
	    if (cat) {
	        var _name = cat[global.lang] || cat.key || '[' + catId + ']';
	        return _name;
	    }
	    return '[' + catId + ' (?)]';
	};
	
	exports.catIdToString = catIdToString;
	var sourcesDict = undefined;
	var sourcesRequested = false;
	var sourceIdToObj = function sourceIdToObj(sourceId) {
	    var callBack = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    if (!sourcesDict) {
	        var sDict = _stateStore2['default'].getState().sources;
	        if (sDict._gen) {
	            sourcesDict = sDict;
	            if (typeof callBack == 'function') {
	                callBack(null, null);
	            }
	        } else {
	            if (!sourcesRequested) {
	                setTimeout(function () {
	                    return _stateStore2['default'].dispatch((0, _stateDucksSources.getSources)()).then(function (result) {
	                        if (typeof callBack == 'function') {
	                            callBack(result, null);
	                        }
	                    })['catch'](function (err) {
	                        if (typeof callBack == 'function') {
	                            callBack(null, err);
	                        }
	                    });
	                }, 0);
	            } else {
	                if (typeof callBack == 'function') {
	                    callBack(null, null);
	                }
	            }
	            sourcesRequested = true;
	            // While we are fetching, show nothing
	            return { name: '…', url: '' };
	        }
	    } else {
	        if (typeof callBack == 'function') {
	            callBack(null, null);
	        }
	    }
	
	    var source = sourcesDict[sourceId];
	    if (source) {
	        var _name2 = source[global.lang] || source.key || '[' + sourceId + ']';
	        return { name: _name2, url: source.url };
	    }
	    return '[' + sourceId + ' (?)]';
	};
	
	exports.sourceIdToObj = sourceIdToObj;
	exports['default'] = make_;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(2075);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(2076);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* globals isClient */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _this=this;var _extends=Object.assign || function(target){for(var i=1;i < arguments.length;i++) {var source=arguments[i];for(var key in source) {if(Object.prototype.hasOwnProperty.call(source,key)){target[key] = source[key];}}}return target;};exports.setInbox = setInbox;exports.setOutbox = setOutbox;exports.gotFinances = gotFinances;exports.fetchClientData = fetchClientData;exports.gotAdminDocs = gotAdminDocs;function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _stateConstants=__webpack_require__(11);var _stateConstants2=_interopRequireDefault(_stateConstants);var _lodashObject=__webpack_require__(330);var _reactGa=__webpack_require__(212);var _reactGa2=_interopRequireDefault(_reactGa);var _libHelpers=__webpack_require__(24);var _api=__webpack_require__(125);var _json2csv=__webpack_require__(1675);var _json2csv2=_interopRequireDefault(_json2csv);var _fileSaver=__webpack_require__(1658);var _fileSaver2=_interopRequireDefault(_fileSaver);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _moment=__webpack_require__(12);var _moment2=_interopRequireDefault(_moment);var _underscore=__webpack_require__(22);var _underscore2=_interopRequireDefault(_underscore);var _lodash=__webpack_require__(329);var _lodash2=_interopRequireDefault(_lodash);var _nestedProperty=__webpack_require__(10);var _nestedProperty2=_interopRequireDefault(_nestedProperty);var _componentsOfficeSignatureGenerator=__webpack_require__(608);var _componentsOfficeSignatureGenerator2=_interopRequireDefault(_componentsOfficeSignatureGenerator);var _libI18n=__webpack_require__(3);var _libI18n2=_interopRequireDefault(_libI18n);var _uuidV4=__webpack_require__(61);var _uuidV42=_interopRequireDefault(_uuidV4);var _jsCookie=__webpack_require__(733);var _jsCookie2=_interopRequireDefault(_jsCookie);var translate=(0,_libI18n2['default'])('');var STALE_TIME=5 * 60 * 1000;var setNotification=function setNotification(msg,nType){return {type:_stateConstants2['default'].NOTIFICATION_SET,msg:msg,nType:nType};};exports.setNotification = setNotification;var disableBackgroundProcesses=function disableBackgroundProcesses(backgroundProcessesDisabled){return {type:_stateConstants2['default'].DISABLE_BACKGROUND_PROCESSES,backgroundProcessesDisabled:backgroundProcessesDisabled};};exports.disableBackgroundProcesses = disableBackgroundProcesses;var clearNotification=function clearNotification(){return {type:_stateConstants2['default'].NOTIFICATION_CLEAR};};exports.clearNotification = clearNotification;var checkIfIE=function checkIfIE(){return function(dispatch){var isIE=Boolean(global.document && global.document.documentMode);dispatch({type:_stateConstants2['default'].SET_IS_IE,isIE:isIE});};};exports.checkIfIE = checkIfIE;var gotContacts=function gotContacts(contacts){return {type:_stateConstants2['default'].FETCHED_CONTACTS,contacts:contacts};};exports.gotContacts = gotContacts;var formatContact=function formatContact(contact){Object.keys(contact).forEach(function(index){if(contact[index] === null){contact[index] = "";}});return _extends({},contact,{original:JSON.stringify(contact),address:contact.street && contact.houseNum && (contact.zip || contact.city)?contact.street + ' ' + contact.houseNum + ', ' + contact.zip + ' ' + contact.city:'',birthday:contact.birthday?(0,_libHelpers.formatDate)(contact.birthday,'eu'):'',phone:contact.phone,email:contact.email});};var loadContacts=function loadContacts(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getContacts')).then(function(data){return dispatch(gotContacts(data.map(formatContact)));});};};exports.loadContacts = loadContacts;var setContact=function setContact(data){return function(dispatch){return dispatch((0,_api.apiCall)('/api/contact/' + (data._id || ''),{data:data})).then(function(){return dispatch(loadContacts());})['catch'](function(){return dispatch(setNotification('Could not save the contact!','error'));});};};exports.setContact = setContact;var showContactModal=function showContactModal(id){return {type:_stateConstants2['default'].SHOW_CONTACT_MODAL,id:id};};exports.showContactModal = showContactModal;var hideContactModal=function hideContactModal(){return {type:_stateConstants2['default'].HIDE_CONTACT_MODAL};};exports.hideContactModal = hideContactModal;var zoomContact=function zoomContact(id){return {type:_stateConstants2['default'].ZOOM_CONTACT,id:id};};exports.zoomContact = zoomContact;var closeContact=function closeContact(){return {type:_stateConstants2['default'].CLOSE_CONTACT};};exports.closeContact = closeContact;var removeContactById=function removeContactById(id){return function(dispatch){return dispatch((0,_api.apiCall)('/api/delContact/' + id,{method:'POST'})).then(function(){return dispatch(loadContacts());})['catch'](function(err){return console.warn(err);});};};exports.removeContactById = removeContactById;var setLang=function setLang(lang){return function(dispatch){if(lang){localStorage.setItem('clientLanguage',lang);}else {lang = localStorage.getItem('clientLanguage') || 'nl';}global.lang = lang;dispatch({type:_stateConstants2['default'].LANG_SET,lang:lang});};};exports.setLang = setLang;var acceptCookies=function acceptCookies(){return function(dispatch,getState){var cookiesAccepted=getState().auth.cookiesAccepted;if(!cookiesAccepted){_jsCookie2['default'].set('cookiesAccepted',("bd446f0a-08ae-41f0-8823-15e1acb0e459"),{expires:365});dispatch({type:_stateConstants2['default'].COOKIES_ACCEPTED});}return true;};};exports.acceptCookies = acceptCookies;var validateCookie=function validateCookie(){return function(dispatch,getState){var cookiesAccepted=getState().auth.cookiesAccepted;if(cookiesAccepted){var cookie=_jsCookie2['default'].get('cookiesAccepted');var cookieVersion=("bd446f0a-08ae-41f0-8823-15e1acb0e459");if(cookie !== cookieVersion){dispatch(cleanCookies());}}return true;};};exports.validateCookie = validateCookie;var cleanCookies=function cleanCookies(){return {type:_stateConstants2['default'].COOKIES_CLEAN};};exports.cleanCookies = cleanCookies;var setAppParam=function setAppParam(param){return {type:_stateConstants2['default'].SET_APP_PARAM,param:param};};exports.setAppParam = setAppParam;var setAppData=function setAppData(data){return {type:_stateConstants2['default'].APP_CHANGED,data:data};};var setNews=function setNews(items,lastLoginTime){return {type:_stateConstants2['default'].GOT_NEWS,items:items,ts:Date.now(),lastLogin:lastLoginTime};};exports.setNews = setNews;var getNews=function getNews(){return function(dispatch,getState){var _getState=getState();var ts=_getState.news.ts;var lang=_getState.app.lang;var newsList=null;if(!ts || Date.now() - ts > STALE_TIME){return dispatch((0,_api.apiCall)('/api/getNews',{lang:lang})).then(function(news){newsList = news;return dispatch(getLoginRecord());}, // Ignore errors
	function(){return dispatch(setNews([]));}).then(function(res){return dispatch(setNews(newsList,res.lastLoginTime));});}return Promise.resolve();};};exports.getNews = getNews;var selectNews=function selectNews(itemId){return {type:_stateConstants2['default'].NEWS_SELECT,itemId:itemId};};exports.selectNews = selectNews;var setFlash=function setFlash(items){return {type:_stateConstants2['default'].GOT_FLASH,items:items,ts:Date.now()};};exports.setFlash = setFlash;var getFlash=function getFlash(){var force=arguments.length <= 0 || arguments[0] === undefined?false:arguments[0];return function(dispatch,getState){var _getState2=getState();var ts=_getState2.flash.ts;var lang=_getState2.app.lang;if(force || !ts || Date.now() - ts > STALE_TIME){return dispatch((0,_api.apiCall)('/api/getFlashes',{lang:lang})).then(function(flash){return dispatch(setFlash(flash));}, // Ignore errors
	function(){return dispatch(setFlash([]));});}return Promise.resolve();};};exports.getFlash = getFlash;var setOpened=function setOpened(itemId){return {type:_stateConstants2['default'].ITEM_ZOOMED,itemId:itemId};};exports.setOpened = setOpened;var setOpenedSubmenu=function setOpenedSubmenu(itemId){var initialArguments=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];return {type:_stateConstants2['default'].SUBMENU_ITEM_ZOOMED,itemId:itemId,initialArguments:initialArguments};};exports.setOpenedSubmenu = setOpenedSubmenu;var setBrNr=function setBrNr(brNr){return {type:_stateConstants2['default'].BRNR_USED,brNr:brNr};};exports.setBrNr = setBrNr;var removeNewsZoom=function removeNewsZoom(){return {type:_stateConstants2['default'].NEWS_ZOOM_CLOSED};};exports.removeNewsZoom = removeNewsZoom;var setNewsFilter=function setNewsFilter(filter){return {type:_stateConstants2['default'].NEWS_FILTERED,filter:filter};};exports.setNewsFilter = setNewsFilter;var setNewLoaded=function setNewLoaded(filter){return {type:_stateConstants2['default'].NEWS_LOADED};};exports.setNewLoaded = setNewLoaded;var setFaq=function setFaq(items){return {type:_stateConstants2['default'].GOT_FAQ,items:items,ts:Date.now()};};exports.setFaq = setFaq;var getFaq=function getFaq(){return function(dispatch,getState){var _getState3=getState();var ts=_getState3.faq.ts;var lang=_getState3.app.lang;if(!ts || Date.now() - ts > STALE_TIME){return dispatch((0,_api.apiCall)('/api/getFaqs',{lang:lang})).then(function(faq){return dispatch(setFaq(faq));}, // Ignore errors
	function(){return dispatch(setFaq([]));});}return Promise.resolve();};};exports.getFaq = getFaq;var setFaqFilter=function setFaqFilter(filter){return {type:_stateConstants2['default'].FAQ_FILTERED,filter:filter};};exports.setFaqFilter = setFaqFilter;var setLinks=function setLinks(items){return {type:_stateConstants2['default'].GOT_LINKS,items:items,ts:Date.now()};};exports.setLinks = setLinks;var getLinks=function getLinks(){return function(dispatch,getState){var _getState4=getState();var ts=_getState4.links.ts;var lang=_getState4.app.lang;if(!ts || Date.now() - ts > STALE_TIME){return dispatch((0,_api.apiCall)('/api/getLinks',{lang:lang})).then(function(links){return dispatch(setLinks(links));}, // Ignore errors
	function(){return dispatch(setLinks([]));});}return Promise.resolve();};};exports.getLinks = getLinks;var setLinksFilter=function setLinksFilter(filter){return {type:_stateConstants2['default'].LINKS_FILTERED,filter:filter};};exports.setLinksFilter = setLinksFilter;var setAppModule=function setAppModule(module,id,search){return {type:_stateConstants2['default'].SET_APP_MODULE,module:module,id:id,search:search};};exports.setAppModule = setAppModule;var setCustomDsDocumentsModule=function setCustomDsDocumentsModule(module,preSortDocumentsFromClient){var id=arguments.length <= 2 || arguments[2] === undefined?'':arguments[2];return {type:_stateConstants2['default'].SET_APP_MODULE,module:module,preSortDocumentsFromClient:preSortDocumentsFromClient,id:id};};exports.setCustomDsDocumentsModule = setCustomDsDocumentsModule;var toggleMenu=function toggleMenu(state){return {type:_stateConstants2['default'].TOGGLE_MENU,state:state};};exports.toggleMenu = toggleMenu;var toggleSubMenu=function toggleSubMenu(state){return {type:_stateConstants2['default'].TOGGLE_SUB_MENU,state:state};};exports.toggleSubMenu = toggleSubMenu;var loggedOut=function loggedOut(){return {type:_stateConstants2['default'].LOGGED_OUT};};var changeAuthState=function changeAuthState(authState,options){return {type:_stateConstants2['default'].AUTH_STATE_CHANGED,authState:authState,options:options};};exports.changeAuthState = changeAuthState;function setInbox(data){return {type:_stateConstants2['default'].GOT_INBOX,data:data,ts:Date.now()};}var getUnreadTicketsNum=function getUnreadTicketsNum(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getTicketsUnreadNum',{noLoader:true})).then(function(number){return dispatch({type:_stateConstants2['default'].SET_UNREAD_NUM,number:number});});};};exports.getUnreadTicketsNum = getUnreadTicketsNum;var getInbox=function getInbox(force){return function(dispatch,getState){var ts=getState().inbox.ts;if(force || !ts || Date.now() - ts > STALE_TIME){return dispatch(getDsDocsAndPackages()).then(function(){return dispatch((0,_api.apiCall)('/api/getTickets')).then(function(inbox){return dispatch(setInbox(inbox));}, // Ignore errors
	function(){return dispatch(setInbox([]));});});}return Promise.resolve();};};exports.getInbox = getInbox;var updateInbox=function updateInbox(){return function(dispatch,getState){if(getState().app.module === _stateConstants2['default'].INBOX){return dispatch(getInbox());}else {return dispatch(getUnreadTicketsNum());}};};exports.updateInbox = updateInbox; /*************************************************
	 * START SECTION OF INTERVAL CHECKING OF INBOX ***
	 *************************************************/ // setup global variable to store the timer ID to control the calls
	if(!window.unreadTimer){window.unreadTimer = 0;} /**
	 * Function to call to refresh the inbox
	 * @param {*} dispatch
	 * @param {*} getState
	 * @returns
	 */var checkUnread=function checkUnread(dispatch,getState){ // Process blocker check by STORE flag
	// --- originally invented to protect an iframe in DSWizard, to disable rendering origin to avoid refresh
	if(getState().app.backgroundProcessesDisabled){ // keep the timer loop alive, restart
	startTimerForInboxRefresh(dispatch,getState); // skip other steps, don't call any API
	return Promise.resolve();} // for logged users call the API, but in case of error stop repeated timer
	// EXIT point
	if(getState().auth.isLoggedIn){ // call the AIP
	return dispatch(updateInbox()) // user session is valid and the request had a valid response
	.then(function(){ // restart the timer again
	startTimerForInboxRefresh(dispatch,getState);}) // in case of ERROR stop the inbox refresher (mean not authenticated)
	['catch'](function(err){ // stop timer to avoid unnecessary call
	stopTimerForInboxRefresh();return err;});} // retry to check the login state
	startTimerForInboxRefresh(dispatch,getState);return Promise.resolve();}; /**
	 * Stis function start firstly the checking of inbox emails
	 * @returns
	 */var startUnreadChecking=function startUnreadChecking(){return function(dispatch,getState){ // stop timer to avoid unnecessary call
	stopTimerForInboxRefresh(); // fire the first call and start timer
	checkUnread(dispatch,getState);};};exports.startUnreadChecking = startUnreadChecking; /**
	 * Set the timer to start the API call
	 */var startTimerForInboxRefresh=function startTimerForInboxRefresh(dispatch,getState){ // stop timer to avoid unnecessary call
	stopTimerForInboxRefresh();window.unreadTimer = setTimeout(checkUnread,60000,dispatch,getState);}; /**
	 * Clear timer to stop calling the API
	 * @returns
	 */var stopTimerForInboxRefresh=function stopTimerForInboxRefresh(){return function(dispatch){ // eslint-disable-line no-unused-vars
	if(window.unreadTimer){clearTimeout(window.unreadTimer);window.unreadTimer = undefined;}};};exports.stopTimerForInboxRefresh = stopTimerForInboxRefresh; /***************************************
	 * END OF INTERVAL CHECKING OF INBOX ***
	 ***************************************/var navigateToDsDocumentFromTicket=function navigateToDsDocumentFromTicket(documentId,module,currentModule){return function(dispatch){return dispatch({type:_stateConstants2['default'].NAVIGATE_TO_DSDOCUMENT,module:module,name:'detailedDSDocument',itemId:documentId,currentModule:currentModule});};};exports.navigateToDsDocumentFromTicket = navigateToDsDocumentFromTicket;var logout=function logout(){return function(dispatch){if(true){dispatch(stopTimerForInboxRefresh());}var gone=function gone(){return dispatch(loggedOut());};dispatch((0,_api.apiCall)('/auth/logout')).then(gone,gone);};};exports.logout = logout;var filterTicket=function filterTicket(selectValue){return {type:_stateConstants2['default'].SET_FILTERED,selectValue:selectValue};};exports.filterTicket = filterTicket; /************************************************************
	 * Actions for OUTBOX
	 ************************************************************/function setOutbox(data){return {type:_stateConstants2['default'].GOT_OUTBOX,data:data,ts:Date.now()};}var getOutbox=function getOutbox(force){return function(dispatch,getState){var ts=getState().outbox.ts;if(force || !ts || Date.now() - ts > STALE_TIME){return dispatch((0,_api.apiCall)('/api/getEmails')).then(function(inbox){return dispatch(setOutbox(inbox));}, // Ignore errors
	function(){return dispatch(setOutbox([]));});}return Promise.resolve();};};exports.getOutbox = getOutbox;var updateOutbox=function updateOutbox(){return function(dispatch,getState){if(getState().app.module === _stateConstants2['default'].OUTBOX){dispatch(getOutbox());}};};exports.updateOutbox = updateOutbox;var filterOutbox=function filterOutbox(){var selectValue=arguments.length <= 0 || arguments[0] === undefined?null:arguments[0];var startDate=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var endDate=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];return {type:_stateConstants2['default'].OUTBOX_SET_FILTERED,selectValue:selectValue,startDate:startDate,endDate:endDate};};exports.filterOutbox = filterOutbox;var _archiveEmails=function _archiveEmails(itemIds,dispatch){return dispatch((0,_api.apiCall)('/api/updateEmails',{data:{emailIds:itemIds,attributes:{archived:true}}})).then(function(){return dispatch(getOutbox(true));});};var archiveEmail=function archiveEmail(items){return function(dispatch){var itemIds=items.filter(function(i){return i.checked === true;}).map(function(i){return i.id;});return _archiveEmails(itemIds,dispatch);};};exports.archiveEmail = archiveEmail;var archiveAllEmail=function archiveAllEmail(items){return function(dispatch){var itemIds=items && items.map(function(i){return i.id;}) || [];return _archiveEmails(itemIds,dispatch);};};exports.archiveAllEmail = archiveAllEmail;var setOutboxEmailOpened=function setOutboxEmailOpened(itemId){return {type:_stateConstants2['default'].OUTBOX_ITEM_ZOOMED,itemId:itemId};};exports.setOutboxEmailOpened = setOutboxEmailOpened;var setOutboxSubModule=function setOutboxSubModule(name,subModuleZoom){return {type:_stateConstants2['default'].SET_OUTBOX_SUB_MODULE,name:name,subModuleZoom:subModuleZoom};};exports.setOutboxSubModule = setOutboxSubModule;var setSeenOutboxEmail=function setSeenOutboxEmail(itemId){return function(dispatch){return dispatch((0,_api.apiCall)('/api/updateEmails',{data:{emailIds:[itemId],attributes:{seenInOutbox:true}}})).then(function(){return dispatch(getOutbox(true));});};};exports.setSeenOutboxEmail = setSeenOutboxEmail;var syncEmailPdf=function syncEmailPdf(emailId){return function(dispatch){return dispatch((0,_api.apiCall)('/syncEmailPdf',{data:{emailId:emailId}}));};};exports.syncEmailPdf = syncEmailPdf; /************************************************************
	 * End of OUTBOX actions
	 ************************************************************/ /************************************************************
	 * Actions for emailSender
	 ************************************************************/var getEmailTemplate=function getEmailTemplate(moduleKey){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getEmailTemplates',{data:{moduleKey:moduleKey}}))['catch'](function(){return dispatch(setNotification('Could not fetch the email templates!','error'));});};};exports.getEmailTemplate = getEmailTemplate; // Get templates only for invitation
	var getInvitationTemplates=function getInvitationTemplates(moduleKey,packageId){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getInvitationTemplates',{data:{moduleKey:moduleKey,packageId:packageId}}))['catch'](function(){return dispatch(setNotification('Could not fetch the invitation email templates!','error'));});};};exports.getInvitationTemplates = getInvitationTemplates; /**
	 * Preset module to load templates.
	 * @param {*} moduleKey used to init the correct templates and related with module
	 * @param {*} modalId
	  * @returns
	 */var setEmailSenderModule=function setEmailSenderModule(moduleKey){var modalId=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];return {type:_stateConstants2['default'].SET_EMAIL_SENDER_MODULE,moduleKey:moduleKey,modalId:modalId};};exports.setEmailSenderModule = setEmailSenderModule; /**
	 * Pop up the modal when everything is initialised and loaded
	 * @returns
	 */var showEmailSenderModal=function showEmailSenderModal(){return {type:_stateConstants2['default'].SHOW_EMAIL_SENDER_MODAL};};exports.showEmailSenderModal = showEmailSenderModal;var hideEmailSenderModal=function hideEmailSenderModal(){return {type:_stateConstants2['default'].HIDE_EMAIL_SENDER_MODAL};};exports.hideEmailSenderModal = hideEmailSenderModal;var showEmailSenderConfirmationModal=function showEmailSenderConfirmationModal(modalId,title,message,flag,payload){return {type:_stateConstants2['default'].SHOW_EMAIL_SENDER_CONF_MODAL,modalId:modalId,confirmationModal:{message:message,title:title,flag:flag,payload:payload,result:false}};};exports.showEmailSenderConfirmationModal = showEmailSenderConfirmationModal;var hideEmailSenderConfirmationModal=function hideEmailSenderConfirmationModal(modalId,result){return {type:_stateConstants2['default'].HIDE_EMAIL_SENDER_CONF_MODAL,modalId:modalId,result:result};};exports.hideEmailSenderConfirmationModal = hideEmailSenderConfirmationModal;var showEmailSenderAttachmentModal=function showEmailSenderAttachmentModal(modalId,title,message,flag,payload){return {type:_stateConstants2['default'].SHOW_EMAIL_SENDER_ATT_MODAL,attachmentModal:{modalId:modalId,message:message,title:title,flag:flag,payload:payload,result:false}};};exports.showEmailSenderAttachmentModal = showEmailSenderAttachmentModal; /* export const updateModuleOptions = (moduleOptions) => ({
	    type: c.EMAIL_SENDER_UPDATE_MODULE_OPTIONS,
	    moduleOptions
	}) */var hideEmailSenderAttachmentModal=function hideEmailSenderAttachmentModal(result){return {type:_stateConstants2['default'].HIDE_EMAIL_SENDER_ATT_MODAL,result:result};};exports.hideEmailSenderAttachmentModal = hideEmailSenderAttachmentModal;var sendEmailBySender=function sendEmailBySender(email){return function(dispatch){return dispatch((0,_api.apiCall)('/api/sendEmail',{data:email}));};};exports.sendEmailBySender = sendEmailBySender;var getActualizedPackageForInvitation=function getActualizedPackageForInvitation(packageId){return function callee$1$0(dispatch){var actualizedPackage;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('/api/actualizePackageForInvitation',{data:{packageId:packageId}})));case 3:actualizedPackage = context$2$0.sent;return context$2$0.abrupt('return',actualizedPackage);case 7:context$2$0.prev = 7;context$2$0.t0 = context$2$0['catch'](0);console.warn(context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 11:case 'end':return context$2$0.stop();}},null,_this,[[0,7]]);};};exports.getActualizedPackageForInvitation = getActualizedPackageForInvitation; /**
	 * This function will open the emailServerConfig modal in case sending email addres server config is missing
	 * the senderName parameter BEWB-322
	 * @param {*} senderEmailAddress
	 * @returns
	 */var showEmailServerConfigModal=function showEmailServerConfigModal(senderEmailAddress){return {type:_stateConstants2['default'].SHOW_EMAIL_SERVER_CONFIG_MODAL,senderEmailAddress:senderEmailAddress};};exports.showEmailServerConfigModal = showEmailServerConfigModal;var hideEmailServerConfigModal=function hideEmailServerConfigModal(serverConfigIsSaved){return {type:_stateConstants2['default'].HIDE_EMAIL_SERVER_CONFIG_MODAL,serverConfigIsSaved:serverConfigIsSaved};};exports.hideEmailServerConfigModal = hideEmailServerConfigModal; /**
	 * This function will do the precache of documents for email attachments.
	 * @param {object} attachment - {id, typeDocument} - the ID of the oracle document, and the typeDocument
	 *   param value if exists
	 * @param {bool} noLoader - if true the the spinner will displayed until the response finished
	 */var preCacheDocuments=function preCacheDocuments(attachment){var noLoader=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];return function(dispatch){ // prepare typeDocumentParam for precache
	var typeUrlParamString='';if(attachment && attachment.typeDocument){typeUrlParamString = '&type=' + attachment.typeDocument;}return dispatch((0,_api.apiCall)('/data/document?id=' + attachment.id + '&cacheOnly=1' + typeUrlParamString,{noLoader:noLoader,noCache:false}));};};exports.preCacheDocuments = preCacheDocuments; /**
	 * This function will precache a bunch of document.
	 * @param {object} documents - {id, typeDocument} - the ID of the oracle document, and the typeDocument
	 *   param value if exists
	 * @param {bool} noLoader - if true the the spinner will displayed until the response finished
	 */var preCacheDocumentsBulk=function preCacheDocumentsBulk(documents){var noLoader=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];return function(dispatch){return dispatch((0,_api.apiCall)('/cacheDocuments',{data:{documents:documents},noLoader:false}));};};exports.preCacheDocumentsBulk = preCacheDocumentsBulk; /**
	 * set document id to the store for download
	 * @param {*} id
	 */var setEmailDocumentId=function setEmailDocumentId(id){return {type:_stateConstants2['default'].SET_EMAIL_DOCUMENT_ID,id:id};};exports.setEmailDocumentId = setEmailDocumentId;var setEmailSenderExternalAttachments=function setEmailSenderExternalAttachments(externalAttachments){return {type:_stateConstants2['default'].SET_EMAIL_EXTERNAL_ATTACHMENTS,externalAttachments:externalAttachments};};exports.setEmailSenderExternalAttachments = setEmailSenderExternalAttachments; /* END Actions for emailSender
	 ************************************************************/ /************************************************************
	 * START Actions for EmailRecentRecipients ******************************/ /**
	 *
	 * @param {*} brokerNumber
	 */var loadEmailRecentRecipients=function loadEmailRecentRecipients(brokerNumber){return function(dispatch){return dispatch((0,_api.apiCall)('/data/getEmailRecentRecipients',{data:{brokerNumber:brokerNumber},noLoader:false,noCache:true})).then(function(result){return result && Array.isArray(result) && result || [];})['catch'](function(){dispatch(setNotification('Could not load the recent recipients list!','error'));return Promise.resolve([]);});};};exports.loadEmailRecentRecipients = loadEmailRecentRecipients; /**
	 *
	 * @param {*} brokerNumber
	 * @param {*} email
	 * @param {*} lang
	 */var addEmailRecentRecipients=function addEmailRecentRecipients(brokerNumber,email,lang){return function(dispatch){return dispatch((0,_api.apiCall)('/data/addEmailRecentRecipients',{data:{brokerNumber:brokerNumber,email:email,lang:lang},noLoader:false,noCache:true})).then(function(data){return data;})['catch'](function(){return dispatch(setNotification('Could not add the recipient to the list of recently used email-addresses!','error'));});};};exports.addEmailRecentRecipients = addEmailRecentRecipients; /**
	 *
	 * @param {*} brokerNumber
	 * @param {*} email
	 */var removeEmailRecentRecipients=function removeEmailRecentRecipients(brokerNumber,email){return function(dispatch){return dispatch((0,_api.apiCall)('/data/removeEmailRecentRecipients',{data:{brokerNumber:brokerNumber,email:email},noLoader:false,noCache:true})).then(function(data){return data;})['catch'](function(){return dispatch(setNotification('Could not remove the recipient to the list of recently used email-addresses!','error'));});};};exports.removeEmailRecentRecipients = removeEmailRecentRecipients; /* END Actions for EmailRecentRecipients
	 ************************************************************/ /************************************************************
	 * START Actions for signature ******************************/var gotSignatures=function gotSignatures(signatures){return {type:_stateConstants2['default'].FETCHED_SIGNATURES,signatures:signatures};};exports.gotSignatures = gotSignatures;var formatSignature=function formatSignature(signature){Object.keys(signature).forEach(function(index){if(signature[index] === null){signature[index] = "";}});return _extends({},signature);};var loadSignatures=function loadSignatures(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getSignatures',{noLoader:false,noCache:true})).then(function(data){return dispatch(gotSignatures(data.map(formatSignature)));})['catch'](function(){return dispatch(setNotification('Could not refresh the Signature list!','error'));});};};exports.loadSignatures = loadSignatures;var setSignature=function setSignature(data){return function(dispatch){return dispatch((0,_api.apiCall)('/api/signature/' + (data._id || ''),{data:data,noLoader:false,noCache:true})).then(function(data){return dispatch(loadSignatures()).then(function(){return data;});})['catch'](function(){return dispatch(setNotification('Could not save the signature!','error'));});};};exports.setSignature = setSignature;var zoomSignature=function zoomSignature(id){return {type:_stateConstants2['default'].ZOOM_SIGNATURE,id:id};};exports.zoomSignature = zoomSignature;var closeSignature=function closeSignature(){return {type:_stateConstants2['default'].CLOSE_SIGNATURE};};exports.closeSignature = closeSignature;var removeSignatureById=function removeSignatureById(id){return function(dispatch){return dispatch((0,_api.apiCall)('/api/delSignature/' + id,{method:'POST',noLoader:false,noCache:true})).then(function(){return dispatch(loadSignatures());})['catch'](function(err){console.warn(err);setNotification('Could not save the signature!','error');});};};exports.removeSignatureById = removeSignatureById;var initSignatureAutomaticGenerator=function initSignatureAutomaticGenerator(){return function(dispatch,getState){dispatch(fetchOfficeData()).then(function(response){dispatch(loadSignatures()).then(function(response){var _getState5=getState();var app=_getState5.app;var office=_getState5.office;var signatures=office.signatures;var appLanguage=app.lang;var userFullName=(app.firstName || "") + " " + (app.lastName || "");userFullName = String(userFullName).trim();var promises=[];if(office.brokers){dispatch({type:_stateConstants2['default'].SHOW_LOADER});Object.keys(office.brokers).map(function(brNr,key){var theBroker=office.brokers[brNr];var canBrokerEdit=false;var needRegenerate=false;var signatureId=null;if(!theBroker.main || theBroker.main.modifySignature === undefined){return;}if(theBroker.main.modifySignature === true || theBroker.main.modifySignature === "true"){canBrokerEdit = true;}var brokerSignatures=signatures.filter(function(item){return item.brokerNumber == brNr;});var theBrokerName=theBroker.main && theBroker.main.name || "";var replacementData=null;var generatedHash=null;if(brokerSignatures.length < 1){needRegenerate = true;}else {if(canBrokerEdit === false){brokerSignatures.map(function(signature,key){if(signature.generatedHash === undefined || signature.generatedHash === null || signature.generatedHash == ''){needRegenerate = true;}else {replacementData = (0,_componentsOfficeSignatureGenerator.generateSignatureReplaceData)(theBroker,app.userId,userFullName,appLanguage);generatedHash = (0,_componentsOfficeSignatureGenerator.generateUniqueHashFromSignatureData)(replacementData);if(generatedHash !== signature.generatedHash){needRegenerate = true;}}signatureId = signature._id;});}}if(needRegenerate === true){promises.push(new Promise(function(resolve,reject){var theBroker=office.brokers[brNr];(0,_componentsOfficeSignatureGenerator2['default'])(theBroker,app.userId,userFullName,lang).then(function(content){var replacementData=(0,_componentsOfficeSignatureGenerator.generateSignatureReplaceData)(theBroker,app.userId,userFullName,appLanguage);var generatedHash=(0,_componentsOfficeSignatureGenerator.generateUniqueHashFromSignatureData)(replacementData);var defaultValues={name:"",content:"",isDefault:false,createdAt:"",updatedAt:"",generatedHash:""};defaultValues.name = theBrokerName + " - " + brNr + " (" + (0,_moment2['default'])().format("DD-MM-YYYY HH:mm:ss") + ")";defaultValues.content = content;defaultValues.isDefault = true;defaultValues.brokerNumber = brNr;defaultValues.generatedHash = generatedHash;if(signatureId !== null){defaultValues._id = signatureId;}return defaultValues;}).then(function(signature){var canEdit=theBroker && theBroker.main && theBroker.main.modifySignature;canEdit = canEdit === "false"?false:canEdit === "true"?true:!!canEdit;if(signature.content){if(canEdit){signature.content = (0,_componentsOfficeSignatureGenerator.replacePlaceholderToTransparentLogo)(signature.content);}else {signature.content = (0,_componentsOfficeSignatureGenerator.replacePlaceholderToNothing)(signature.content);}}var newSignature={_id:signature._id,name:signature.name,content:signature.content,isDefault:signature.isDefault,brokerNumber:signature.brokerNumber,generatedHash:signature.generatedHash};return dispatch(setSignature(newSignature));}).then(function(response){resolve(response);})['catch'](function(error){reject(error);});}));}});if(promises.length < 1){dispatch({type:_stateConstants2['default'].HIDE_LOADER});return;}Promise.all(promises).then(function(){dispatch({type:_stateConstants2['default'].HIDE_LOADER});})['catch'](function(error){dispatch({type:_stateConstants2['default'].HIDE_LOADER});});}});});};};exports.initSignatureAutomaticGenerator = initSignatureAutomaticGenerator; /* END Actions for signature
	 ************************************************************/ /************************************************************
	 * START Actions for localUpload ******************************/var localUploadHandler=function localUploadHandler(blobInfo,success,failure){return function(dispatch,getState){var xhr=undefined,formData=undefined;xhr = new XMLHttpRequest();xhr.withCredentials = false;(0,_libI18n.getPromiseForTranslations)().then(function(){xhr.open('POST','api/uploadLocal');xhr.setRequestHeader('x-csrf-token',translate('csrfclienttoken'));xhr.onload = function(){var json=undefined;if(xhr.status != 200){failure('HTTP Error: ' + xhr.status);return;}json = JSON.parse(xhr.responseText);if(!json || !json.success || typeof json.success.location != 'string'){failure('Invalid JSON: ' + xhr.responseText);return;}var finalLocation=json.success.location;if(json.success.location){var indexOf=json.success.location.indexOf("uploads/localUploads/");if(indexOf != -1){finalLocation = json.success.location.substring(indexOf);finalLocation = window.location.protocol + '//' + (window.location.href.split("/")[2] + '/' + finalLocation).replace("\/\/","\/");}}success(finalLocation);};formData = new FormData();formData.append('type','emailImage');formData.append('fileName',blobInfo.filename());formData.append('comment',"Uploaded from email sender.");formData.append('file',blobInfo.blob(),blobInfo.filename());xhr.send(formData);});};};exports.localUploadHandler = localUploadHandler; /* END Actions for localUpload
	 ************************************************************/var fetchAgendaData=function fetchAgendaData(noCache){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getEvents',{noCache:noCache})).then(function(response){return dispatch({type:_stateConstants2['default'].SET_AGENDA_DATA,response:response});})['catch'](function(){return dispatch(setNotification('Could not fetch the events data!','error'));});};};exports.fetchAgendaData = fetchAgendaData;var updateSubscribers=function updateSubscribers(subscriberIds,dateId){return function(dispatch){return dispatch((0,_api.apiCall)('/api/updateSubscr',{data:{subscriberIds:subscriberIds,dateId:dateId}})).then(function(){return dispatch(fetchAgendaData(true));})['catch'](function(){return dispatch(setNotification('Could not update the subscriber list!','error'));});};};exports.updateSubscribers = updateSubscribers;var fetchUserData=function fetchUserData(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getContacts')).then(function(response){return dispatch({type:_stateConstants2['default'].GOT_USERS,response:response});});};};exports.fetchUserData = fetchUserData;var setApp=function setApp(data){return function(dispatch){dispatch(setAppData(data));if(true){dispatch(startUnreadChecking());} // Set task list for starting point
	dispatch(taskModuleListGetDefaultColors());dispatch(taskModuleListGetUserColors());dispatch(taskModuleListGet());dispatch(getOutbox());dispatch(fetchStaffList());dispatch(getNews());if(data.tickets){dispatch(setInbox(data.tickets));}if(data.articles){if(data.articles.news){dispatch(setNews(data.articles.news));}if(data.articles.faq){dispatch(setFaq(data.articles.faq));}}if(data.links){dispatch(setLinks(data.links));} // wait for translations (if loaded the i18n -> _make)
	if(_libI18n.getPromiseForTranslations){(0,_libI18n.getPromiseForTranslations)().then(function(){dispatch(initSignatureAutomaticGenerator());});}else {dispatch(initSignatureAutomaticGenerator());}};};exports.setApp = setApp;var setClientApp=function setClientApp(data){return function(dispatch){dispatch(setAppData(data));};};var areAllSelected=function areAllSelected(visibleItems){return {type:_stateConstants2['default'].ARE_SELECTED,visibleItems:visibleItems};};exports.areAllSelected = areAllSelected;function gotFinances(data){return {type:_stateConstants2['default'].FETCHED_OFFICE_FINANCES,data:data};}var fetchFinances=function fetchFinances(query){return function(dispatch,getState){var brNr=getState().app.brNr;return dispatch((0,_api.apiCall)('/data/officeFinances',{data:{brokerNumber:brNr,startDate:query.startDate?(0,_moment2['default'])(query.startDate).format("YYYY-MM-DD"):'',endDate:query.endDate?(0,_moment2['default'])(query.endDate).format("YYYY-MM-DD"):'',contractNumber:query.contractNumber || '',searchParameter:query.type || 'b'}})).then(function(data){ // store result
	dispatch(gotFinances(data)); // promise resolve with response data
	return data;});};};exports.fetchFinances = fetchFinances;var archive=function archive(items){return function(dispatch){var itemIds=items.filter(function(i){return i.checked === true;}).map(function(i){return i.id;});var data={ticketIds:itemIds,status:{archived:true}};return dispatch((0,_api.apiCall)('/api/updateTickets',{data:data})).then(function(){return dispatch(getInbox(true));});};};exports.archive = archive;var fetchOneTicketById=function fetchOneTicketById(ticketId){return function(dispatch){try{var ticket=dispatch((0,_api.apiCall)('/api/getOneTicketById',{data:{ticketId:ticketId}}));return ticket;}catch(error) {return error;}};};exports.fetchOneTicketById = fetchOneTicketById;var selectItems=function selectItems(items){return {type:_stateConstants2['default'].SET_ALL_CHECKED,items:items};};exports.selectItems = selectItems;var deselectItems=function deselectItems(){return {type:_stateConstants2['default'].SET_ALL_UNCHECKED};};exports.deselectItems = deselectItems;var setTicketUnread=function setTicketUnread(id,unread){return function(dispatch){var data={type:_stateConstants2['default'].INBOX_ITEMS_STATUS,ticketIds:[id],status:{unread:unread}};return dispatch((0,_api.apiCall)('/api/updateTickets',{noLoader:true,data:data})).then(function(){return dispatch(data);});};};exports.setTicketUnread = setTicketUnread;var setCheckBox=function setCheckBox(id){return {type:_stateConstants2['default'].SET_CHECKBOX,id:id};};exports.setCheckBox = setCheckBox; /**
	 * Procedure to link a client id to a contract using updateErrorBlocRetour oracle API and update linkedClient
	 * @param {*} ticketId
	 * @param {*} clientId
	 * @param {*} blockretId
	 * @returns
	 */var updateErrorBlocRetour=function updateErrorBlocRetour(ticketId,clientId,blockretId){return function(dispatch){var data={ticketId:ticketId,clientId:clientId,blockretId:blockretId};return dispatch((0,_api.apiCall)('/api/updateErrorBlocRetour',{data:data})).then(function(res){dispatch(getInbox(true));return res;})['catch'](function(error){return error;});};};exports.updateErrorBlocRetour = updateErrorBlocRetour; /**
	 * List of actions used in client profile form
	 */var initializeProfileForm=function initializeProfileForm(clientData,clientId,formType){return {type:_stateConstants2['default'].INITIALIZE_CLIENT_PROFILE_FORM,clientData:clientData,clientId:clientId,formType:formType};};exports.initializeProfileForm = initializeProfileForm;var setProfileFormCheckbox=function setProfileFormCheckbox(id,type){return {type:_stateConstants2['default'].SET_PROFILE_FORM_CHECKBOX,id:id,format:type};};exports.setProfileFormCheckbox = setProfileFormCheckbox;var cleanProfileFormCheckbox=function cleanProfileFormCheckbox(){return {type:_stateConstants2['default'].CLEAN_PROFILE_FORM_CHECKBOX};};exports.cleanProfileFormCheckbox = cleanProfileFormCheckbox;var cleanClientProfileForm=function cleanClientProfileForm(){return {type:_stateConstants2['default'].CLEAN_CLIENT_PROFILE_FORM};};exports.cleanClientProfileForm = cleanClientProfileForm;var clientProfileFormSentToFalse=function clientProfileFormSentToFalse(){return {type:_stateConstants2['default'].SENT_TO_FALSE_CLIENT_PROFILE_FORM};};exports.clientProfileFormSentToFalse = clientProfileFormSentToFalse;var clientProfileFormGetRelations=function clientProfileFormGetRelations(clientNumber){return function(dispatch){dispatch({type:"SHOW_LOADER"});return dispatch(fetchRelationClient(clientNumber)).then(function(response){dispatch({type:"HIDE_LOADER"});return response;});};};exports.clientProfileFormGetRelations = clientProfileFormGetRelations;var changeListDefaultError=function changeListDefaultError(listType,listValue){return {type:_stateConstants2['default'].TOGGLE_LIST_DEFAULT_CLIENT_PROFILE_FORM,listType:listType,listValue:listValue};};exports.changeListDefaultError = changeListDefaultError;var toggleModalClientProfileForm=function toggleModalClientProfileForm(modalStatus){return {type:_stateConstants2['default'].TOGGLE_MODAL_CLIENT_PROFILE_FORM,modalStatus:modalStatus};};exports.toggleModalClientProfileForm = toggleModalClientProfileForm;var fetchExistingClients=function fetchExistingClients(data){return function(dispatch){return dispatch((0,_api.apiCall)('/data/clients',{data:(0,_libHelpers.trimObject)(data)})).then(function(response){dispatch({type:_stateConstants2['default'].FETCH_CLIENTS_CLIENT_PROFILE_FORM,response:response});});};};exports.fetchExistingClients = fetchExistingClients;var fetchRelationClient=function fetchRelationClient(data){return function(dispatch){return dispatch((0,_api.apiCall)('/data/clients',{data:(0,_libHelpers.trimObject)(data)})).then(function(response){return _extends({},response);});};};exports.fetchRelationClient = fetchRelationClient;var fetchExistingClient=function fetchExistingClient(clientId,companyId){return function(dispatch){return dispatch((0,_api.apiCall)('/data/client',{data:{clientId:clientId}})).then(function(response){if(typeof response == 'string'){response = response.replace(/\r\"/g,'"');response = JSON.parse(response);}if(companyId){response.contracts = response.contracts.filter(function(i){return i.contractMain.insuranceCompanyId == companyId;});}dispatch({type:_stateConstants2['default'].FETCH_CLIENT_CLIENT_PROFILE_FORM,clientId:clientId,response:response});dispatch({type:_stateConstants2['default'].SET_CLIENT_DATA,clientId:clientId,response:response});return response;});};};exports.fetchExistingClient = fetchExistingClient;var updateClientProfile=function updateClientProfile(data,clientId){var companyId=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];return function(dispatch){dispatch((0,_api.apiCall)('/api/updateClient/' + clientId,{data:data})).then(function(data){if(data.result){if(typeof data.result == 'string'){data.result = data.result.replace(/\r?\n|\r/g,'');data.result = data.result.replace(/\"W/g,'W');data.result = data.result.replace(/R\"/g,'R');data.result = JSON.parse(data.result);}var clientData=data.result;if(Number(clientData.error) == 0){dispatch(toggleModalClientProfileForm(false));dispatch(fetchClient(clientId,companyId));dispatch(setOpened(clientId));dispatch(setClientSubModule('profile'));dispatch(setB2bCompanyOpened(clientId));dispatch(setB2bCompanySubModule('profile'));dispatch({type:_stateConstants2['default'].UPDATE_CLIENT_PROFILE_RESULT,ok:true});}else {dispatch({type:_stateConstants2['default'].UPDATE_CLIENT_PROFILE_RESULT,ok:clientData.errorString});}}})['catch'](function(err){dispatch({type:_stateConstants2['default'].UPDATE_CLIENT_PROFILE_RESULT,err:err});});return dispatch({type:_stateConstants2['default'].FORM_SUBMITTED});};};exports.updateClientProfile = updateClientProfile;var updateEasinsureClient=function updateEasinsureClient(profileData){return function(dispatch){return dispatch((0,_api.apiCall)('/data/easinsureClient',{method:'POST',data:profileData})).then(function(data){if(!data){throw new Error('No data received (say: easinsureClient)');}var result=typeof data.result === 'string'?JSON.parse(data.result):null;if(result && result.error === 0){dispatch(fetchClientData()); // refresh the client data
	}return result; // return the error (null or response result)
	})['catch'](function(err){console.warn(err);return err.message;});};};exports.updateEasinsureClient = updateEasinsureClient;var createClientProfile=function createClientProfile(data){return function(dispatch){dispatch((0,_api.apiCall)('/api/createClient',{data:data})).then(function(data){if(data.result){if(typeof data.result == 'string'){data.result = data.result.replace(/\r?\n|\r/g,'');data.result = data.result.replace(/\"W/g,'W');data.result = data.result.replace(/R\"/g,'R');data.result = JSON.parse(data.result);}var clientData=data.result;if(Number(clientData.error) == 0){dispatch(toggleModalClientProfileForm(false));dispatch(setOpened(clientData.clientId));dispatch(setClientSubModule('profile'));dispatch(setB2bCompanyOpened(clientData.clientId));dispatch(setB2bCompanySubModule('profile'));dispatch({type:_stateConstants2['default'].UPDATE_CLIENT_PROFILE_RESULT,ok:true});}else {dispatch({type:_stateConstants2['default'].UPDATE_CLIENT_PROFILE_RESULT,ok:clientData.errorString});}}})['catch'](function(err){return dispatch({type:_stateConstants2['default'].UPDATE_CLIENT_PROFILE_RESULT,err:err});});return dispatch({type:_stateConstants2['default'].FORM_SUBMITTED});};};exports.createClientProfile = createClientProfile;var setClientCreateContractState=function setClientCreateContractState(createContractState){return function(dispatch){return dispatch({type:_stateConstants2['default'].SET_CLIENT_CREATE_CONTRACT_STATE,createContractState:createContractState});};};exports.setClientCreateContractState = setClientCreateContractState; /** END CLIENT PROFILE FORM ACTIONS **/var selectVisibleItems=function selectVisibleItems(visibleItems){return {type:_stateConstants2['default'].SET_ALL_VISIBLE_CHECKED,visibleItems:visibleItems};};exports.selectVisibleItems = selectVisibleItems;var selectUnreadItems=function selectUnreadItems(items){return {type:_stateConstants2['default'].SET_UNREAD_CHECKED,items:items};};exports.selectUnreadItems = selectUnreadItems;var setInboxFilter=function setInboxFilter(filter){return {type:_stateConstants2['default'].TICKETS_FILTERED,filter:filter};};exports.setInboxFilter = setInboxFilter;var setOfficeSubModule=function setOfficeSubModule(subModuleName){return {type:_stateConstants2['default'].SET_OFFICE_SUB_MODULE,subModuleName:subModuleName};};exports.setOfficeSubModule = setOfficeSubModule;var setGeneral=function setGeneral(generalData){return {type:_stateConstants2['default'].SET_GENERAL,generalData:generalData};};exports.setGeneral = setGeneral;var setOfficeData=function setOfficeData(brokers,accountManagers){return {type:_stateConstants2['default'].SET_OFFICE_DATA,brokers:brokers,accountManagers:accountManagers};};var fetchOfficeData=function fetchOfficeData(){var resetSelectedBroker=arguments.length <= 0 || arguments[0] === undefined?false:arguments[0];return function(dispatch,getState){return dispatch((0,_api.apiCall)('/data/office')).then(function(data){var brokers={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=data.officeInfo.brokers[Symbol.iterator](),_step;!(_iteratorNormalCompletion = (_step = _iterator.next()).done);_iteratorNormalCompletion = true) {var broker=_step.value;if(broker.main.website.slice(0,4) !== 'http'){broker.main.website = 'http://' + broker.main.website;}brokers[broker.brokerNumber] = broker;}}catch(err) {_didIteratorError = true;_iteratorError = err;}finally {try{if(!_iteratorNormalCompletion && _iterator['return']){_iterator['return']();}}finally {if(_didIteratorError){throw _iteratorError;}}}var officeDataPromise=dispatch(setOfficeData(brokers,data.accountManagers)); //remove selected broker if this is from kantoor and is internal user
	if(resetSelectedBroker){dispatch(setBrNr(''));} // preventing unnecessary change of the current brokerNumber and if is office then there should not be  preselected broker number
	if(!getState().app.brNr && !resetSelectedBroker){dispatch(setBrNr(data.officeInfo.brokers[0].brokerNumber));}return data;});};};exports.fetchOfficeData = fetchOfficeData;var fetchClaims=function fetchClaims(data){return function callee$1$0(dispatch){var response,claimNumber;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.transactionCall)('/data/claims',{data:(0,_libHelpers.trimObject)(data),noCache:true,noLoader:true})));case 3:response = context$2$0.sent;context$2$0.next = 6;return regeneratorRuntime.awrap(dispatch({type:_stateConstants2['default'].SET_CLAIMS_DATA,response:response}));case 6:if(response.length === 1){claimNumber = response[0].main.claimNumber;dispatch(setOpened(claimNumber));}return context$2$0.abrupt('return',response);case 10:context$2$0.prev = 10;context$2$0.t0 = context$2$0['catch'](0);console.warn(context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 14:case 'end':return context$2$0.stop();}},null,_this,[[0,10]]);};};exports.fetchClaims = fetchClaims;var navigateToConnexClaim=function navigateToConnexClaim(module,claimNumber){return function(dispatch){return dispatch((0,_api.transactionCall)('/data/claims',{data:(0,_libHelpers.trimObject)({claimNumber:claimNumber}),noCache:true,noLoader:true})).then(function(res){dispatch({type:_stateConstants2['default'].SET_APP_MODULE,module:module});dispatch({type:_stateConstants2['default'].SET_CLAIMS_DATA,response:res});dispatch(setOpened(claimNumber));return;});};};exports.navigateToConnexClaim = navigateToConnexClaim;var setClientSubModule=function setClientSubModule(name,subModuleZoom){var createContractState=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];return {type:_stateConstants2['default'].SET_CLIENT_SUB_MODULE,name:name,subModuleZoom:subModuleZoom,createContractState:createContractState};};exports.setClientSubModule = setClientSubModule;var setClientData=function setClientData(data){return {type:_stateConstants2['default'].SET_CLIENTS_DATA,response:data};};exports.setClientData = setClientData;var fetchClients=function fetchClients(data){var justReturn=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];return function(dispatch){return dispatch((0,_api.apiCall)('/data/clients',{data:(0,_libHelpers.trimObject)(data)})).then(function(response){dispatch(setClientData(response));if(response.length === 1 && !justReturn){var clientId=response[0].clientId;dispatch(setOpened(clientId)); // TODO this will skip all other filters, God mode for contractNumber
	var contractNumber=data.contractNumber && data.contractNumber.trim() || false;var tarificationNumber=data.tarificationNumber && data.tarificationNumber.trim() || false;var claimNumber=data.claimNumber && data.claimNumber.trim() || false;var claimRefBroker=data.claimRefBroker && data.claimRefBroker.trim() || false;if(contractNumber){dispatch(setClientSubModule('contracts',{contractNumber:contractNumber}));}else if(tarificationNumber){dispatch(setClientSubModule('tarification',{tarificationNumber:tarificationNumber}));}else if(claimNumber){dispatch(setClientSubModule('claims',{claimNumber:claimNumber}));}else if(claimRefBroker){dispatch(setClientSubModule('claims',{claimRefBroker:claimRefBroker}));}else {if(data && data.characteristicType && data.characteristicValue){dispatch(setClientSubModule('contracts',{characteristicType:data.characteristicType,characteristicValue:data.characteristicValue}));}}}return response;});};};exports.fetchClients = fetchClients;var fetchClientFinances=function fetchClientFinances(clientId){return function(dispatch){return dispatch((0,_api.apiCall)('/data/getClientTransactions',{data:{clientId:clientId}})).then(function(_ref){var transactions=_ref.transactions;return dispatch({type:_stateConstants2['default'].FETCHED_CLIENT_FINANCES,transactions:transactions,clientId:clientId});});};};exports.fetchClientFinances = fetchClientFinances; /**
	 * This function will fetch the claims data for a client and put it in the redux store.
	 * @param {*} clientId
	 * @returns
	 */var fetchClientClaims=function fetchClientClaims(clientId){return function callee$1$0(dispatch){var response;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.transactionCall)('/data/getClientClaims',{data:{clientId:clientId},noLoader:true,noCache:true})));case 3:response = context$2$0.sent;dispatch({type:_stateConstants2['default'].FETCHED_CLIENT_CLAIMS,clientId:clientId,response:response});return context$2$0.abrupt('return',response);case 8:context$2$0.prev = 8;context$2$0.t0 = context$2$0['catch'](0);console.error('Failed to fetch client claims:',context$2$0.t0);throw context$2$0.t0;case 12:case 'end':return context$2$0.stop();}},null,_this,[[0,8]]);};};exports.fetchClientClaims = fetchClientClaims;var fetchClientOneClaim=function fetchClientOneClaim(clientId,claimId,userId){return function callee$1$0(dispatch){var fetchClaimsResponse;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('/data/getClientClaims',{data:{clientId:clientId,userId:userId},noLoader:true,noCache:true})));case 3:fetchClaimsResponse = context$2$0.sent;if(!(fetchClaimsResponse && fetchClaimsResponse.claims)){context$2$0.next = 6;break;}return context$2$0.abrupt('return',fetchClaimsResponse.claims.find(function(oneClaim){return oneClaim.claimMain.claimId === claimId;}));case 6:context$2$0.next = 11;break;case 8:context$2$0.prev = 8;context$2$0.t0 = context$2$0['catch'](0);return context$2$0.abrupt('return',context$2$0.t0);case 11:case 'end':return context$2$0.stop();}},null,_this,[[0,8]]);};};exports.fetchClientOneClaim = fetchClientOneClaim; /*
	    // ------------------ for fetchClientClaims
	    // original solution
	
	    export const fetchClientClaims = (clientId) => dispatch =>
		dispatch(apiCall('/data/getClientClaims', {data: {clientId}}))
	    .then(response =>
	        dispatch({type: c.FETCHED_CLIENT_CLAIMS, clientId, response})
	    )
	*/ /**
	 * This action will fetch a search result from server, looking for claims when client module is active
	 * @param {*} data
	 */var fetchClaimsExtraDetails=function fetchClaimsExtraDetails(data){return function(dispatch){return dispatch((0,_api.transactionCall)('/data/claims',{data:(0,_libHelpers.trimObject)(data),noCache:true,noLoader:true})).then(function(response){return dispatch({type:_stateConstants2['default'].CLIENT_LOAD_CLAIMS_EXTRA,response:response});});};};exports.fetchClaimsExtraDetails = fetchClaimsExtraDetails;var fetchClientContract=function fetchClientContract(contractId){return function(dispatch){return dispatch((0,_api.apiCall)('/data/getClientContract',{data:{contractId:contractId}})).then(function(response){return dispatch({type:_stateConstants2['default'].FETCHED_CLIENT_CONTRACT,contractId:contractId,response:response});});};};exports.fetchClientContract = fetchClientContract;var fetchClient=function fetchClient(clientId){var companyId=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];var returnClient=arguments.length <= 2 || arguments[2] === undefined?false:arguments[2];return function(dispatch,getState){return dispatch((0,_api.apiCall)('/data/client',{data:{clientId:clientId}})).then(function(response){if(typeof response == 'string'){ // Try to fix the error
	response = response.replace(/\r\"/g,'"');try{response = JSON.parse(response);}catch(e) {response = {}; // error in the above string (in this case, yes)!
	}}if(companyId && response.contracts != undefined){response.contracts = response.contracts.filter(function(i){return i.contractMain.insuranceCompanyId == companyId;});}dispatch({type:_stateConstants2['default'].SET_CLIENT_DATA,clientId:clientId,response:response});if(returnClient){return response;}return {client:getState().DSDocuments.client};});};};exports.fetchClient = fetchClient;var setClientOptionsDict=function setClientOptionsDict(clientOptionsDict){return {type:_stateConstants2['default'].SET_CLIENT_OPTIONS_DICT,clientOptionsDict:clientOptionsDict};};exports.setClientOptionsDict = setClientOptionsDict;var fetchClientOptionsDict=function fetchClientOptionsDict(){return function(dispatch){return dispatch((0,_api.apiCall)('/dict/client/aml')).then(function(dict){dispatch(setClientOptionsDict(dict));return dict;});};};exports.fetchClientOptionsDict = fetchClientOptionsDict;var createClientTarification=function createClientTarification(tarificationData){return function(dispatch){return dispatch((0,_api.apiCall)('data/createClientTarification',{data:tarificationData})).then(function(res){return res;})['catch'](function(err){console.warn(err);});};};exports.createClientTarification = createClientTarification;var fetchClientTarifications=function fetchClientTarifications(clientId){return function(dispatch){return dispatch((0,_api.apiCall)('data/getClientTarifications',{data:{clientId:clientId}})).then(function(response){try{var tarifications=response.tarifications;return dispatch({type:_stateConstants2['default'].FETCHED_CLIENT_TARIFICATIONS,clientId:clientId,tarifications:tarifications});}catch(error) {console.warn(error);}});};};exports.fetchClientTarifications = fetchClientTarifications;var fetchClientTarification=function fetchClientTarification(tarificationId){return function(dispatch){return dispatch((0,_api.apiCall)('data/getClientTarification',{data:{tarificationId:tarificationId}})).then(function(response){return dispatch({type:_stateConstants2['default'].FETCHED_CLIENT_TARIFICATION_DATA,response:response});});};};exports.fetchClientTarification = fetchClientTarification; /**
	 * Fetch the list of tarificatins for tarification mapping to contract
	 * @param {*} clientId
	 * @returns
	 */var fetchUploadTarifications=function fetchUploadTarifications(clientId){return function callee$1$0(dispatch){var getUploadTarificationsResponse;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getUploadTarifications',{data:{clientId:clientId}})));case 3:getUploadTarificationsResponse = context$2$0.sent;if(!getUploadTarificationsResponse){context$2$0.next = 6;break;}return context$2$0.abrupt('return',getUploadTarificationsResponse);case 6:context$2$0.next = 12;break;case 8:context$2$0.prev = 8;context$2$0.t0 = context$2$0['catch'](0);console.warn(context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 12:case 'end':return context$2$0.stop();}},null,_this,[[0,8]]);};};exports.fetchUploadTarifications = fetchUploadTarifications; /**
	 * Fetch one tarification details for mapping
	 * @param {*} tarificationId
	 * @returns
	 */var fetchOneTarificationDataForIndexMap=function fetchOneTarificationDataForIndexMap(tarificationId,indexTypes){return function callee$1$0(dispatch){var getUploadTarificationsResponse;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getOneTarificationDataForIndexMap',{data:{tarificationId:tarificationId,indexTypes:indexTypes}})));case 3:getUploadTarificationsResponse = context$2$0.sent;if(!getUploadTarificationsResponse){context$2$0.next = 6;break;}return context$2$0.abrupt('return',getUploadTarificationsResponse);case 6:context$2$0.next = 12;break;case 8:context$2$0.prev = 8;context$2$0.t0 = context$2$0['catch'](0);console.warn(context$2$0.t0);return context$2$0.abrupt('return',[]);case 12:case 'end':return context$2$0.stop();}},null,_this,[[0,8]]);};};exports.fetchOneTarificationDataForIndexMap = fetchOneTarificationDataForIndexMap;var filterClientFinances=function filterClientFinances(data){return {type:_stateConstants2['default'].FILTER_ITEMS,data:{startDate:data.startDate || '',endDate:data.endDate || '',contractNumber:data.contractNumber || '',invoiceNumber:data.invoiceNumber || '',paymentReference:data.paymentReference || ''}};};exports.filterClientFinances = filterClientFinances;var getClientId=function getClientId(contractId,claimId,tarificationId){return function(dispatch){return dispatch((0,_api.apiCall)('/data/getClientId',{data:{contractId:contractId,claimId:claimId,tarificationId:tarificationId}})).then(function callee$2$0(response){return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:dispatch({type:_stateConstants2['default'].GET_CLIENT_ID,clientId:response && response.clientId || false});return context$3$0.abrupt('return',response && response.clientId || false);case 2:case 'end':return context$3$0.stop();}},null,_this);})['catch'](function(err){dispatch(setNotification(err,'error'));dispatch({type:_stateConstants2['default'].GET_CLIENT_ID,clientId:false});return false;});};};exports.getClientId = getClientId;var initContract=function initContract(brokerNumber){return function(dispatch){return dispatch((0,_api.apiCall)('/data/initContract',{data:{brokerNumber:brokerNumber}}));};};exports.initContract = initContract;var createContract=function createContract(apiArguments){return function(dispatch){return dispatch((0,_api.apiCall)('/data/createContract',{data:apiArguments}));};};exports.createContract = createContract;var checkSMStoken=function checkSMStoken(token){var onlyTesting=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];var autoLogin=arguments.length <= 2 || arguments[2] === undefined?false:arguments[2];return function(dispatch){return dispatch((0,_api.apiCall)("/auth/SMStoken",{data:{passcode:token,autoLogin:autoLogin}})).then(function(response){if(response.auth){localStorage.smsToken = token; //dispatch(getLoginRecordAndUpdate(response.userId, response.user))
	dispatch(saveUserLoginRecord(response.userId,response.user));dispatch(setApp(response));dispatch(setLang(response.lang));if(response.resetPassword){dispatch(changeAuthState('passwordChange'));}else {dispatch(updateInbox());dispatch({type:_stateConstants2['default'].LOG_IN});}}else if(!onlyTesting){if(response.removeAutoLogin && response.removeAutoLogin === true){localStorage.removeItem('smsToken');return;}if(response.freeze && response.freeze === true){if(response.time && response.time == '30s'){dispatch((0,_api.hasErrors)('freeze30s'));}if(response.time && response.time == '1m'){dispatch((0,_api.hasErrors)('freeze1m'));}if(response.time && response.time == '30m'){dispatch((0,_api.hasErrors)('freeze30m'));}}else if(response.blocked && response.blocked === true){dispatch(changeAuthState(''));setTimeout(function(){dispatch((0,_api.hasErrors)('blocked'));},1000);}else {dispatch((0,_api.hasErrors)('sms'));}}});};};exports.checkSMStoken = checkSMStoken;var getLoginRecord=function getLoginRecord(){return function(dispatch){return dispatch((0,_api.apiCall)('api/getUserLoginRecord')).then(function(data){return data;});};};var saveUserLoginRecord=function saveUserLoginRecord(userId,user){return function(dispatch){return dispatch((0,_api.apiCall)('api/saveUserLoginRecord',{data:{userId:userId,userFullName:user}}));};};var resendSMStoken=function resendSMStoken(){return function(dispatch,getState){return dispatch((0,_api.apiCall)("/auth/newToken",{method:'POST'})).then(function(){var options=getState().auth.options;dispatch(changeAuthState('sms',_extends({},options,{smsSent:true,smsResent:true})));})['catch'](function(){return dispatch((0,_api.hasErrors)('sms'));});};};exports.resendSMStoken = resendSMStoken;var retrievePassword=function retrievePassword(email){return function(dispatch){return dispatch((0,_api.apiCall)("/auth/retrievePassword",{data:{email:email}})).then(function(response){dispatch(changeAuthState('passwordReset',_extends({},response)));});};};exports.retrievePassword = retrievePassword;var passwordChangeRequired=function passwordChangeRequired(resetPassword){return {type:_stateConstants2['default'].APP_PASSWORD_CHANGED,resetPassword:resetPassword};};exports.passwordChangeRequired = passwordChangeRequired;var changePassword=function changePassword(oldPassword,newPassword){return function(dispatch){return dispatch((0,_api.apiCall)('/api/chpwd',{data:{oldPassword:oldPassword,newPassword:newPassword}})).then(function(response){if(response.error === false || response.error === 'false'){dispatch(passwordChangeRequired(false));dispatch(changeAuthState(''));dispatch(updateInbox());dispatch({type:_stateConstants2['default'].LOG_IN});}else {dispatch((0,_api.hasErrors)('passwordCannotBeOldone'));}})['catch'](function(){return dispatch((0,_api.hasErrors)('oldPasswordWrong'));});};};exports.changePassword = changePassword; // Check if our session is still valid
	var checkLoggedIn=function checkLoggedIn(){return function(dispatch){return dispatch((0,_api.apiCall)("/api/userInfo")).then(function(userInfo){dispatch(setApp(userInfo));dispatch(updateInbox());dispatch({type:_stateConstants2['default'].LOG_IN});},function(){return false;});};};exports.checkLoggedIn = checkLoggedIn;var logIn=function logIn(username,password){var lang=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];return function(dispatch){var url= false?'/auth/loginClient':'/auth/login';var data={username:username,password:password};if(lang){data.lang = lang;}dispatch((0,_api.apiCall)(url,{data:data})).then(function(response){_reactGa2['default'].event({category:'User',action:response.user + ' logged in'});dispatch(setLang(response.lang));if(false){dispatch(setClientApp(response));if(response.resetPassword){dispatch(changeAuthState('passwordChange'));}else {dispatch({type:_stateConstants2['default'].LOG_IN});}}else {dispatch({type:_stateConstants2['default'].SET_PASSWORD,password:password});dispatch(changeAuthState('sms',_extends({},response,{smsResent:false})));if(localStorage.smsToken){dispatch(checkSMStoken(localStorage.smsToken,false,true))['catch'](function(){return false;});}}},function(err){if(err.status === 401 || err && err.status === 403){dispatch((0,_api.hasErrors)('usernameAndPassword'));}});};};exports.logIn = logIn; // UPLOAD
	var getUploadDict=function getUploadDict(){return function(dispatch,getState){if(!getState().uploads.dict){return dispatch((0,_api.apiCall)('/dict/uploads')).then(function(response){return dispatch({type:_stateConstants2['default'].SET_UPLOAD_DICT,dict:response});});}};};exports.getUploadDict = getUploadDict;var goToFileForm=function goToFileForm(groupId){var forceDescription=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];return function(dispatch){return dispatch({type:_stateConstants2['default'].GO_TO_FILE_FORM,groupId:groupId,comment:forceDescription});};};exports.goToFileForm = goToFileForm;var goBackToUploadType=function goBackToUploadType(){return function(dispatch){dispatch({type:_stateConstants2['default'].GO_BACK_TO_UPLOAD_TYPE});return Promise.resolve();};};exports.goBackToUploadType = goBackToUploadType;var showUploadModal=function showUploadModal(uploadType,uploadTypeId){var uploadForceState=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];var forceDescription=arguments.length <= 3 || arguments[3] === undefined?null:arguments[3];var claimStatusAndQualification=arguments.length <= 4 || arguments[4] === undefined?null:arguments[4];var forcedDocumentFromClaimWizard=arguments.length <= 5 || arguments[5] === undefined?'':arguments[5];return function callee$1$0(dispatch){var url,claimRequiredDocumentsRes,uploadTypesRes,forcedDocumentObj,keys,uploadTypeIndex;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;url = '/api/uploadTypes/' + uploadType;claimRequiredDocumentsRes = undefined;context$2$0.next = 5;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)(url)));case 5:uploadTypesRes = context$2$0.sent;if(!(claimStatusAndQualification && (claimStatusAndQualification.claimStatus === '1' || claimStatusAndQualification.claimStatus === '8' || claimStatusAndQualification.claimStatus === '9'))){context$2$0.next = 11;break;}context$2$0.next = 9;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('/data/getClaimRequiredDocuments',{data:_extends({},claimStatusAndQualification)})));case 9:claimRequiredDocumentsRes = context$2$0.sent;if(claimRequiredDocumentsRes){uploadTypesRes[1] = claimRequiredDocumentsRes;}case 11: // if uploader is opened from a dsWizard that is opened from a claimWizard we need to force a document type for which the uploader is opened to groupType 1
	if(forcedDocumentFromClaimWizard){forcedDocumentObj = {};forcedDocumentObj[forcedDocumentFromClaimWizard] = {max:0,min:0};uploadTypesRes[1] = forcedDocumentObj;}dispatch({type:_stateConstants2['default'].SHOW_UPLOAD_MODAL,uploadType:uploadType,uploadInfo:uploadTypesRes,uploadTypeId:uploadTypeId});keys = Object.keys(uploadTypesRes);context$2$0.t0 = uploadForceState;context$2$0.next = context$2$0.t0 === _stateConstants.UPLOADER_STATE_NEW_POLICY?17:context$2$0.t0 === _stateConstants.UPLOADER_STATE_POLICY_FILE?20:23;break;case 17:uploadTypeIndex = keys.indexOf(_stateConstants.UPLOADER_STATE_NEW_POLICY_ID);if(uploadTypeIndex !== -1){dispatch(goToFileForm(keys[uploadTypeIndex],forceDescription));}else {if(keys.length === 1){dispatch(goToFileForm(keys[0]));}}return context$2$0.abrupt('break',24);case 20:uploadTypeIndex = keys.indexOf(_stateConstants.UPLOADER_STATE_POLICY_FILE_ID);if(uploadTypeIndex !== -1){dispatch(goToFileForm(keys[uploadTypeIndex],forceDescription));}else {if(keys.length === 1){dispatch(goToFileForm(keys[0]));}}return context$2$0.abrupt('break',24);case 23:if(keys.length === 1){dispatch(goToFileForm(keys[0]));}case 24:context$2$0.next = 29;break;case 26:context$2$0.prev = 26;context$2$0.t1 = context$2$0['catch'](0);console.warn(context$2$0.t1);case 29:case 'end':return context$2$0.stop();}},null,_this,[[0,26]]);};};exports.showUploadModal = showUploadModal;var hideUploadModal=function hideUploadModal(){return {type:_stateConstants2['default'].HIDE_UPLOAD_MODAL};};exports.hideUploadModal = hideUploadModal;var changeFileDate=function changeFileDate(date,file,filetype){return {type:_stateConstants2['default'].CHANGE_FILE_DATE,date:date,file:file,filetype:filetype};};exports.changeFileDate = changeFileDate;var removeFile=function removeFile(file,fileType){return {type:_stateConstants2['default'].REMOVE_FILE,file:file,fileType:fileType};};exports.removeFile = removeFile;var unAllocateFile=function unAllocateFile(file,fileTypeId){return {type:_stateConstants2['default'].UN_ALLOCATE_FILE,file:file,fileType:fileTypeId};};exports.unAllocateFile = unAllocateFile;var allocateFiles=function allocateFiles(typeId,file){return {type:_stateConstants2['default'].ALLOCATE_FILE,typeId:typeId,file:file};};exports.allocateFiles = allocateFiles;var addFiles=function addFiles(files){return {type:_stateConstants2['default'].ADD_FILES,files:files};};exports.addFiles = addFiles; /**
	 *
	 * @param {*} files
	 * @param {Boolean} disableUploadToOracle  V8.0 - can be uploaded file only to the will-broker server temporary, whn it is true
	 * @returns
	 */var startUpload=function startUpload(files){var disableUploadToOracle=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];return function callee$1$0(dispatch,getState){var groupId,uploadId,uploadInfo,fData,uploadPromises,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_loop,_iterator2,_step2,_iteratorNormalCompletion3,_didIteratorError3,_iteratorError3,_iterator3,_step3,allUploadResult;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:groupId = getState().uploads.groupId;uploadId = getState().uploads.uploadId;uploadInfo = getState().uploads.uploadInfo.filter(function(info){return info.id === groupId;})[0];fData = undefined;uploadPromises = [];dispatch({type:_stateConstants2['default'].UPLOAD_CLEAR_ERROR});context$2$0.next = 8;return regeneratorRuntime.awrap((0,_libI18n.getPromiseForTranslations)());case 8:_iteratorNormalCompletion2 = true;_didIteratorError2 = false;_iteratorError2 = undefined;context$2$0.prev = 11;_loop = function(){var type=_step2.value;if(type.files){_iteratorNormalCompletion3 = true;_didIteratorError3 = false;_iteratorError3 = undefined;try{var _loop2=function(){var file=_step3.value; //if file origin is tarification we will use the new index type migration
	if(file.name){var oneFilePromise=new Promise(function(resolveFileUpload,rejectFileUpload){ // I am not sure when and why is calling start upload when the files are already uploaded, or are under progress.
	// So here I will not resolve my promise, because for that is only one way, finishing an upload, else that must be rejected.
	if(file.done || !file.error && file.progress > 0){return rejectFileUpload({filetype:type.id,fileId:file.fileId,error:"Unwanted call for restarting an already started upload."});} // if (file.origin && file.origin === 'ORIGIN_ORACLE_TARIFICATION') {
	// } else {
	fData = new FormData();fData.append('disableUploadToOracle',disableUploadToOracle);fData.append('uploadId',uploadId);fData.append('type',type.id);fData.append('comment',file.name);fData.append('originalFileName',file.name);fData.append('date',(0,_libHelpers.serverDateFormat)(file.lastModified));if(file.origin && file.origin === 'DS_ORIGIN_ORACLE'){fData.append('origin',file.origin);fData.append('oracleDocumentId',file.fileId);fData.append('documentTypeIdx',file.documentTypeIdx);fData.append('oracleDocumentType',file.typeDocument);}fData.append('file',files[file.fileId]);var request=new XMLHttpRequest();request.onreadystatechange = function(){if(request.readyState === 4){ // EXIT POINT status not 200
	if(request.status !== 200){dispatch({type:_stateConstants2['default'].UPLOAD_ERROR,filetype:type.id,fileId:file.fileId}); // rejecting promise of this individual upload
	return rejectFileUpload({filetype:type.id,fileId:file.fileId,error:"request.status !== 200"});} // status is 200
	try{var resp=JSON.parse(request.response);var errorFound=_nestedProperty2['default'].get(resp,"success.error") || _nestedProperty2['default'].get(resp,"error");if(errorFound){var statusText=undefined;if(_nestedProperty2['default'].get(resp,"success.error") === "conversionFail"){statusText = translate("unknownErrorOccurred");}else {statusText = _nestedProperty2['default'].get(resp,"success.error") || translate("unknownErrorOccurred") + ": " + _nestedProperty2['default'].get(resp,"message") || translate("unknownErrorOccurred") + ": " + JSON.stringify(request.responseText);}dispatch({type:_stateConstants2['default'].UPLOAD_ERROR,filetype:type.id,fileId:file.fileId,error:statusText}); // rejecting promise of this individual upload
	return rejectFileUpload({filetype:type.id,fileId:file.fileId,error:statusText});}else {dispatch({type:_stateConstants2['default'].UPLOAD_DONE,filetype:type.id,fileId:file.fileId,response:_nestedProperty2['default'].get(resp,"success")}); // resolving promise of this individual upload
	return resolveFileUpload({filetype:type.id,fileId:file.fileId,response:_nestedProperty2['default'].get(resp,"success")});}}catch(err) {var statusText=_nestedProperty2['default'].get(request,"response.message") || JSON.stringify(request.responseText);var error={status:'error',data:translate("unknownErrorOccurred") + ": " + statusText};dispatch({type:_stateConstants2['default'].UPLOAD_ERROR,filetype:type.id,fileId:file.fileId,error:error}); // rejecting promise of this individual upload
	return rejectFileUpload({filetype:type.id,fileId:file.fileId,error:error});}}};request.upload.addEventListener('progress',function(e){var progress=e.loaded / e.total;dispatch({type:_stateConstants2['default'].UPLOAD_PROGRESS,filetype:type.id,fileId:file.fileId,progress:progress});},false);request.open('POST','/api/upload',true);request.setRequestHeader('x-csrf-token',translate('csrfclienttoken'));request.send(fData); // }
	}); // collect upload promises
	uploadPromises.push(oneFilePromise);}};for(_iterator3 = type.files[Symbol.iterator]();!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done);_iteratorNormalCompletion3 = true) {_loop2();}}catch(err) {_didIteratorError3 = true;_iteratorError3 = err;}finally {try{if(!_iteratorNormalCompletion3 && _iterator3['return']){_iterator3['return']();}}finally {if(_didIteratorError3){throw _iteratorError3;}}}}};for(_iterator2 = uploadInfo.fileTypes[Symbol.iterator]();!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);_iteratorNormalCompletion2 = true) {_loop();} // fire all upload together, not matter if some of the failed from point of view this branch of process.
	// error handling is made by dispatching values in store, in a lower level, individually for each file.
	context$2$0.next = 20;break;case 16:context$2$0.prev = 16;context$2$0.t0 = context$2$0['catch'](11);_didIteratorError2 = true;_iteratorError2 = context$2$0.t0;case 20:context$2$0.prev = 20;context$2$0.prev = 21;if(!_iteratorNormalCompletion2 && _iterator2['return']){_iterator2['return']();}case 23:context$2$0.prev = 23;if(!_didIteratorError2){context$2$0.next = 26;break;}throw _iteratorError2;case 26:return context$2$0.finish(23);case 27:return context$2$0.finish(20);case 28:allUploadResult = Promise.allSettled(uploadPromises) // when all upload is done, this then actually made for debugging only
	.then(function(results){return results;}) // handle errors
	['catch'](function(err){console.warn("Upload files ",err);return err;});dispatch({type:_stateConstants2['default'].START_UPLOAD});return context$2$0.abrupt('return',allUploadResult);case 31:case 'end':return context$2$0.stop();}},null,_this,[[11,16,20,28],[21,,23,27]]);};};exports.startUpload = startUpload; /**
	 *
	 * @param {*} comment
	 * @param {*} files
	 */var uploadFiles=function uploadFiles(comment,files){var disableUploadToOracle=arguments.length <= 2 || arguments[2] === undefined?false:arguments[2];return function callee$1$0(dispatch,getState){var data,response,_iteratorNormalCompletion4,_didIteratorError4,_iteratorError4,_iterator4,_step4,_iteratorNormalCompletion5,_didIteratorError5,_iteratorError5,_iterator5,_step5;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:if(!getState().uploads.uploadId){context$2$0.next = 2;break;}return context$2$0.abrupt('return',dispatch(startUpload(files,disableUploadToOracle)));case 2:data = undefined;context$2$0.t0 = getState().uploads.uploadType;context$2$0.next = context$2$0.t0 === 'client'?6:context$2$0.t0 === 'contract'?8:context$2$0.t0 === 'claim'?10:context$2$0.t0 === 'tarification'?12:13;break;case 6:data = {type:getState().uploads.groupId,clientId:getState().uploads.uploadTypeId};return context$2$0.abrupt('break',14);case 8:data = {type:getState().uploads.groupId,contractId:getState().uploads.uploadTypeId};return context$2$0.abrupt('break',14);case 10:data = {type:getState().uploads.groupId,claimId:getState().uploads.uploadTypeId};return context$2$0.abrupt('break',14);case 12:data = {type:getState().uploads.groupId,tarificationId:getState().uploads.uploadTypeId};case 13:return context$2$0.abrupt('break',14);case 14: // if there is a comment filled in the popup textarea, wil be attached to the upload for oracle
	if(comment){data.comment = comment;} // when the files are stored only on willemot-broker server, they are not sent to ORACLE. The result filenames
	// are returned
	if(disableUploadToOracle){data.disableUploadToOracle = disableUploadToOracle;} // call the createUpload API to get an uploadId from Oracle to continue the upload by a second step.
	context$2$0.next = 18;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('/api/createUpload',{data:data})));case 18:response = context$2$0.sent;context$2$0.prev = 19; // in case when dont have provided uploadId by oracle
	if(!response.uploadId){(function(){var groupId=getState().uploads.groupId;var uploadInfo=getState().uploads.uploadInfo.find(function(info){return info.id === groupId;});var errors=[];_iteratorNormalCompletion4 = true;_didIteratorError4 = false;_iteratorError4 = undefined;try{for(_iterator4 = uploadInfo.fileTypes[Symbol.iterator]();!(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done);_iteratorNormalCompletion4 = true) {var _type=_step4.value;if(_type.files){_iteratorNormalCompletion5 = true;_didIteratorError5 = false;_iteratorError5 = undefined;try{for(_iterator5 = _type.files[Symbol.iterator]();!(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done);_iteratorNormalCompletion5 = true) {var _file=_step5.value;if(_file.name){var error=translate("unknownErrorOccurred");errors.push({type:_stateConstants2['default'].UPLOAD_ERROR,filetype:_type.id,fileId:_file.fileId,error:error});dispatch({type:_stateConstants2['default'].UPLOAD_ERROR,filetype:_type.id,fileId:_file.fileId,error:error});}}}catch(err) {_didIteratorError5 = true;_iteratorError5 = err;}finally {try{if(!_iteratorNormalCompletion5 && _iterator5['return']){_iterator5['return']();}}finally {if(_didIteratorError5){throw _iteratorError5;}}}}} // EXIT POINT
	}catch(err) {_didIteratorError4 = true;_iteratorError4 = err;}finally {try{if(!_iteratorNormalCompletion4 && _iterator4['return']){_iterator4['return']();}}finally {if(_didIteratorError4){throw _iteratorError4;}}}throw new Error(errors);})();}dispatch({type:_stateConstants2['default'].SET_UPLOAD_ID,uploadId:response.uploadId}); // when the uploadID arrived start uploading the file using a second API call
	return context$2$0.abrupt('return',dispatch(startUpload(files,disableUploadToOracle)));case 25:context$2$0.prev = 25;context$2$0.t1 = context$2$0['catch'](19);console.warn('create upload error ',context$2$0.t1);return context$2$0.abrupt('return',context$2$0.t1);case 29:case 'end':return context$2$0.stop();}},null,_this,[[19,25]]);};};exports.uploadFiles = uploadFiles;var getUploads=function getUploads(type,id,force){return function(dispatch,getState){var data=undefined;var _getState6=getState();var files=_getState6.files;var actFiles=files[type][id];switch(type){case 'client':data = {clientId:id};break;case 'contract':data = {contractId:id};break;case 'claim':data = {claimId:id};break;case 'tarification':data = {tarificationId:id};break;default:break;}if(!actFiles || Date.now() - actFiles.ts > STALE_TIME || force){return dispatch((0,_api.apiCall)('/api/getUploads',{data:data})).then(function(response){dispatch({type:_stateConstants2['default'].GET_UPLOADS,files:response,uploadType:type,typeId:id});});}return Promise.resolve();};};exports.getUploads = getUploads;var updateCommentBemDoc=function updateCommentBemDoc(_ref2){var documentId=_ref2.documentId;var bemComment=_ref2.bemComment;var typeId=_ref2.typeId;var uploadId=_ref2.uploadId;var uploadType=_ref2.uploadType;return function(dispatch,getState){var isFile=Boolean(documentId); // chech if is document part of file or document
	dispatch((0,_api.apiCall)('/data/updateCommentBemDoc',{method:'POST',data:{documentId:isFile?documentId:uploadId,bemComment:bemComment.commentValue}})).then(function(response){if(!response){throw new Error('No data received (say: updateCommentBemDoc)');}if(response && response[0].error === 0){var actionData={typeId:typeId,uploadId:uploadId,uploadType:uploadType,documentId:documentId,bemComment:bemComment};switch(uploadType){case 'client':dispatch(_extends({type:isFile?_stateConstants2['default'].CLIENT_FILE_DOC_UPDATE_BEM_COMMENT:_stateConstants2['default'].CLIENT_DOC_UPDATE_BEM_COMMENT},actionData));break;case 'claim':{var _getState7=getState();var app=_getState7.app;dispatch(_extends({type:isFile?_stateConstants2['default'].CLAIM_FILE_DOC_UPDATE_BEM_COMMENT:_stateConstants2['default'].CLAIM_DOCUMENT_DOC_UPDATE_BEM_COMMENT},actionData,{clientNumber:app.opened}));break;}case 'contract':{dispatch(_extends({type:isFile?_stateConstants2['default'].CONTRACT_FILE_DOC_UPDATE_BEM_COMMENT:_stateConstants2['default'].CONTRACT_DOCUMENT_DOC_UPDATE_BEM_COMMENT},actionData));break;}case 'tarification':dispatch(_extends({type:_stateConstants2['default'].TARIFICATION_DOC_UPDATE_BEM_COMMENT},actionData));break;default:return response;}dispatch(setNotification(translate('Comment_updated'),'success'));}if(response && response[0].error === 1){dispatch(setNotification(translate('Update_failed,_document_id_not_found'),'error'));}return response;})['catch'](function(err){console.warn(err);dispatch(setNotification(translate('Comment_update_failed'),'error'));});};};exports.updateCommentBemDoc = updateCommentBemDoc;var cancelUpload=function cancelUpload(){return function(dispatch,getState){var _getState8=getState();var uploads=_getState8.uploads;if(uploads.uploadType && uploads.uploadTypeId){dispatch(getUploads(uploads.uploadType,uploads.uploadTypeId,true));}dispatch({type:_stateConstants2['default'].CANCEL_UPLOAD});};};exports.cancelUpload = cancelUpload;var updateCommentOnFileUpload=function updateCommentOnFileUpload(comment){return function(dispatch){dispatch({type:_stateConstants2['default'].UPDATE_UPLOAD_COMMENT,comment:comment});};};exports.updateCommentOnFileUpload = updateCommentOnFileUpload;var initAdditionalUpload=function initAdditionalUpload(uploadType,uploadTypeId,item){return function(dispatch,getState){var dict=getState().uploads.dict; // TODO change type title to id when oracle sends it
	var groupId=(0,_lodashObject.findKey)(dict.uploadType,function(i){return i.nl === item.type || i.fr === item.type;});var url='/api/uploadTypes/' + uploadType;dispatch((0,_api.apiCall)(url)).then(function(response){dispatch({type:_stateConstants2['default'].SHOW_UPLOAD_MODAL,uploadType:uploadType,uploadInfo:response,uploadTypeId:uploadTypeId});dispatch({type:_stateConstants2['default'].GO_TO_FILE_FORM,groupId:groupId,uploadId:item.uploadId,comment:item.comment});if(item.documents){var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{var _loop3=function(){var document=_step6.value;var documentTypeId=(0,_lodashObject.findKey)(dict[uploadType],function(i){return i.nl === document.documentType || i.fr === document.documentType;});dispatch(addFiles(documentTypeId,[document]));};for(var _iterator6=item.documents[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done);_iteratorNormalCompletion6 = true) {_loop3();}}catch(err) {_didIteratorError6 = true;_iteratorError6 = err;}finally {try{if(!_iteratorNormalCompletion6 && _iterator6['return']){_iterator6['return']();}}finally {if(_didIteratorError6){throw _iteratorError6;}}}}});};};exports.initAdditionalUpload = initAdditionalUpload;var getTranslations=function getTranslations(){return function(dispatch){return dispatch((0,_api.apiCall)('/translations')).then(function(response){return dispatch({type:_stateConstants2['default'].GOT_TRANSLATIONS,dict:response});}, // We update so that translationIds become visible, see i18n
	function(){return dispatch({type:_stateConstants2['default'].GOT_TRANSLATIONS,dict:{FAIL:true}});});};};exports.getTranslations = getTranslations; // Registration
	var sendForm=function sendForm(data){return function(dispatch){dispatch((0,_api.apiCall)('/register',{data:data})).then(function(){return dispatch({type:_stateConstants2['default'].REG_RESULT,ok:true});},function(err){return dispatch({type:_stateConstants2['default'].REG_RESULT,err:err});});return dispatch({type:_stateConstants2['default'].FORM_SUBMITTED});};};exports.sendForm = sendForm;var backToForm=function backToForm(){return {type:_stateConstants2['default'].RESET_REG};};exports.backToForm = backToForm;function fetchClientData(){return function(dispatch){dispatch((0,_api.apiCall)('/data/client')).then(function(response){return dispatch({type:_stateConstants2['default'].SET_CLIENT,response:response});});};}var setContractFilter=function setContractFilter(filter){return {type:_stateConstants2['default'].SET_FILTER,filter:filter};};exports.setContractFilter = setContractFilter;var fetchContractData=function fetchContractData(id){return function(dispatch,getState){var contracts=getState().client.contracts;var contract=undefined;var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=Object.keys(contracts)[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done);_iteratorNormalCompletion7 = true) {var k=_step7.value;var _iteratorNormalCompletion8=true;var _didIteratorError8=false;var _iteratorError8=undefined;try{for(var _iterator8=contracts[k][Symbol.iterator](),_step8;!(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done);_iteratorNormalCompletion8 = true) {var _c=_step8.value;if(_c.contractId === id){contract = _c;}}}catch(err) {_didIteratorError8 = true;_iteratorError8 = err;}finally {try{if(!_iteratorNormalCompletion8 && _iterator8['return']){_iterator8['return']();}}finally {if(_didIteratorError8){throw _iteratorError8;}}}}}catch(err) {_didIteratorError7 = true;_iteratorError7 = err;}finally {try{if(!_iteratorNormalCompletion7 && _iterator7['return']){_iterator7['return']();}}finally {if(_didIteratorError7){throw _iteratorError7;}}}if(contract && !contract.contractDetails){return dispatch((0,_api.apiCall)('/data/getClientContract',{data:{contractId:id}})).then(function(response){return dispatch({type:_stateConstants2['default'].SET_CONTRACT_DETAILS,response:response,id:id});});}};};exports.fetchContractData = fetchContractData; /**
	 * This function fetch the client claims data to store and return with a promise.
	  * @returns promise and set result in the redux-store
	 */var fetchClaimsData=function fetchClaimsData(){return function(dispatch,getState){var claims=getState().client.claims;if(claims.length === 0){return dispatch((0,_api.apiCall)('/data/getClientClaims')).then(function(response){return dispatch({type:_stateConstants2['default'].SET_CLIENT_CLAIMS,response:response});});}};};exports.fetchClaimsData = fetchClaimsData; /**
	 *  This function will fetch the claim details by claimId
	 */var getClaimDetail=function getClaimDetail(claimId){return function(dispatch,getState){var claims=getState().client.claims;if(claims.length === 0){return dispatch((0,_api.apiCall)('/data/getClaimDetail',{data:{claimId:claimId}})).then(function(response){return dispatch({type:_stateConstants2['default'].SET_CLAIM_DETAIL,response:response});});}};};exports.getClaimDetail = getClaimDetail;var getWebapps=function getWebapps(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getWebapps')).then(function(response){return dispatch({type:_stateConstants2['default'].GOT_WEBAPPS,response:response});});};};exports.getWebapps = getWebapps;var fetchSubscribersList=function fetchSubscribersList(id){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getSubscribers/' + id)).then(function(response){var subscribers=response.subscriberIds || response;var formattedSub=subscribers.map(function(sub){return {officeId:sub.officeId,broker:sub.brokerName,firstName:sub.name && sub.name.first,lastName:sub.name && sub.name.last,street:(0,_classnames2['default'])(sub.street,sub.houseNum,sub.houseNumExt),zip:(0,_classnames2['default'])(sub.zip,sub.city),birthday:(0,_libHelpers.formatDate)(sub.birthday),email:sub.email};});var fields=['officeId','broker','firstName','lastName','street','zip','birthday','email'];var fieldNames=['OfficeNr','Broker','Naam','Vrnaam','Adres','Gemeente','GeboorteD','Email'];(0,_json2csv2['default'])({data:formattedSub,fields:fields,fieldNames:fieldNames,del:';'},function(err,csv){if(err){dispatch(setNotification(err,'error'));}else {var blob=new Blob([csv],{type:"text/csv;charset=utf-8"});_fileSaver2['default'].saveAs(blob,'event-subscribers.csv');}});});};};exports.fetchSubscribersList = fetchSubscribersList;var fetchAdminDocsPs={};var fetchAdminDocs=function fetchAdminDocs(brNr){return function(dispatch){var p=fetchAdminDocsPs[brNr];if(!p){var data={brokerNumber:brNr};p = fetchAdminDocsPs[brNr] = dispatch((0,_api.apiCall)('/api/getAdminDoc',{data:data})).then(function(data){return dispatch(gotAdminDocs(data,brNr));});var clear=function clear(){fetchAdminDocsPs[brNr] = null;};p.then(clear,clear);}return p;};};exports.fetchAdminDocs = fetchAdminDocs;function gotAdminDocs(data,brNr){return {type:_stateConstants2['default'].FETCHED_ADMIN_DOCS,data:data,brNr:brNr};} // b2bCompany module related actions
	var setB2BInsuranceCompany=function setB2BInsuranceCompany(b2bInsuranceCompany){return {type:_stateConstants2['default'].SET_B2B_INSURANCE_COMPANY,b2bInsuranceCompany:b2bInsuranceCompany};};exports.setB2BInsuranceCompany = setB2BInsuranceCompany;var setB2bCompanySubModule=function setB2bCompanySubModule(name,subModuleZoom){return {type:_stateConstants2['default'].SET_B2BCOMPANY_SUB_MODULE,name:name,subModuleZoom:subModuleZoom};};exports.setB2bCompanySubModule = setB2bCompanySubModule;var setB2bCompanyBrNr=function setB2bCompanyBrNr(brNr){return {type:_stateConstants2['default'].B2BCOMPANY_BRNR_USED,brNr:brNr};};exports.setB2bCompanyBrNr = setB2bCompanyBrNr;var setB2bCompanyOpened=function setB2bCompanyOpened(itemId){return {type:_stateConstants2['default'].B2BCOMPANY_ITEM_ZOOMED,itemId:itemId};};exports.setB2bCompanyOpened = setB2bCompanyOpened;var setB2bCompanySearchByContractNumber=function setB2bCompanySearchByContractNumber(isByContractNumber){return {type:_stateConstants2['default'].B2BCOMPANY_SEARCH_BY_CONTRACT_NUMBER,isByContractNumber:isByContractNumber};};exports.setB2bCompanySearchByContractNumber = setB2bCompanySearchByContractNumber;var fetchB2bCompanyClients=function fetchB2bCompanyClients(data){return function(dispatch){return dispatch((0,_api.apiCall)('/data/clients',{data:(0,_libHelpers.trimObject)(data)})).then(function(response){dispatch({type:_stateConstants2['default'].SET_B2BCOMPANY_CLIENTS_DATA,response:response});if(response.length === 1){var clientId=response[0].clientId;dispatch(setB2bCompanyOpened(clientId));if(data.contractNumber){var contractNumber=data.contractNumber;dispatch(setB2bCompanySearchByContractNumber(true));dispatch(setB2bCompanySubModule('profile',{contractNumber:contractNumber}));}else {dispatch(setB2bCompanySearchByContractNumber(false));}}});};};exports.fetchB2bCompanyClients = fetchB2bCompanyClients;var setB2bCompanyPolicyActions=function setB2bCompanyPolicyActions(policyActions,policySubActions){return {type:_stateConstants2['default'].B2BCOMPANY_GET_ACTIONS,policyActions:policyActions,policySubActions:policySubActions};};exports.setB2bCompanyPolicyActions = setB2bCompanyPolicyActions;var setB2bCompanyCompanyDetails=function setB2bCompanyCompanyDetails(b2bCompanyCompany){return {type:_stateConstants2['default'].B2BCOMPANY_SET_COMPANY,b2bCompanyCompany:b2bCompanyCompany};};exports.setB2bCompanyCompanyDetails = setB2bCompanyCompanyDetails;var b2bCompanySwitchSubActions=function b2bCompanySwitchSubActions(policySubActions){return {type:_stateConstants2['default'].B2BCOMPANY_SWITCH_ACTION,policySubActions:policySubActions};};exports.b2bCompanySwitchSubActions = b2bCompanySwitchSubActions;var fetchB2bCompanyPolicyActionsDict=function fetchB2bCompanyPolicyActionsDict(){return function(dispatch){return dispatch((0,_api.apiCall)('/dict/b2bCompany')).then(function(dict){return dispatch(setB2bCompanyPolicyActionsDict(dict));});};};exports.fetchB2bCompanyPolicyActionsDict = fetchB2bCompanyPolicyActionsDict;var setB2bCompanyPolicyActionsDict=function setB2bCompanyPolicyActionsDict(b2bCompanyActionsDict){return {type:_stateConstants2['default'].B2BCOMPANY_SET_ACTIONS_DICT,b2bCompanyActionsDict:b2bCompanyActionsDict};};exports.setB2bCompanyPolicyActionsDict = setB2bCompanyPolicyActionsDict;var fetchB2bCompanyPolicyActions=function fetchB2bCompanyPolicyActions(clientId,b2bInsuranceCompany){return function(dispatch){return dispatch((0,_api.apiCall)('/api/b2bCompany')).then(function(data){var policyAction={};var policySubActions={};var b2bCompanyData={};var b2bCompanyCompany={};var _iteratorNormalCompletion9=true;var _didIteratorError9=false;var _iteratorError9=undefined;try{for(var _iterator9=(data || [])[Symbol.iterator](),_step9;!(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done);_iteratorNormalCompletion9 = true) {var oneData=_step9.value;if(_underscore2['default'].isEqual(oneData.company.companyId,b2bInsuranceCompany)){b2bCompanyData = oneData.actionTypes;b2bCompanyCompany = oneData.company;break;}}}catch(err) {_didIteratorError9 = true;_iteratorError9 = err;}finally {try{if(!_iteratorNormalCompletion9 && _iterator9['return']){_iterator9['return']();}}finally {if(_didIteratorError9){throw _iteratorError9;}}}if(!_lodash2['default'].isEmpty(b2bCompanyData)){if(b2bCompanyData && b2bCompanyData){var _iteratorNormalCompletion10=true;var _didIteratorError10=false;var _iteratorError10=undefined;try{for(var _iterator10=(b2bCompanyData || [])[Symbol.iterator](),_step10;!(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done);_iteratorNormalCompletion10 = true) {var cAction=_step10.value;policyAction[cAction.action] = cAction;}}catch(err) {_didIteratorError10 = true;_iteratorError10 = err;}finally {try{if(!_iteratorNormalCompletion10 && _iterator10['return']){_iterator10['return']();}}finally {if(_didIteratorError10){throw _iteratorError10;}}}}}var firstCategoryKey=policyAction && Object.keys(policyAction)[0] || false;var firstCategory=firstCategoryKey && policyAction[firstCategoryKey].actionCategories || false;var _iteratorNormalCompletion11=true;var _didIteratorError11=false;var _iteratorError11=undefined;try{for(var _iterator11=(firstCategory || [])[Symbol.iterator](),_step11;!(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done);_iteratorNormalCompletion11 = true) {var cSubAction=_step11.value;policySubActions[cSubAction.category] = cSubAction;}}catch(err) {_didIteratorError11 = true;_iteratorError11 = err;}finally {try{if(!_iteratorNormalCompletion11 && _iterator11['return']){_iterator11['return']();}}finally {if(_didIteratorError11){throw _iteratorError11;}}}dispatch(setB2bCompanyPolicyActions(policyAction,policySubActions));dispatch(setB2bCompanyCompanyDetails(b2bCompanyCompany));dispatch(getB2bCompanyB2BTransactions({companyId:b2bCompanyCompany.companyId,clientId:clientId}));return {policyAction:policyAction,policySubActions:policySubActions,b2bCompanyCompany:b2bCompanyCompany};});};};exports.fetchB2bCompanyPolicyActions = fetchB2bCompanyPolicyActions;var gotB2bCompanyPolicy=function gotB2bCompanyPolicy(policies){return {type:_stateConstants2['default'].B2BCOMPANY_FETCHED_POLICIES,policies:policies};};exports.gotB2bCompanyPolicy = gotB2bCompanyPolicy;var setB2bCompanySelectedPolicy=function setB2bCompanySelectedPolicy(selectedPolicy){return {type:_stateConstants2['default'].SET_B2BCOMPANY_SELECTED_POLICY,selectedPolicy:selectedPolicy};};exports.setB2bCompanySelectedPolicy = setB2bCompanySelectedPolicy;var B2bCompanyStartB2BAction=function B2bCompanyStartB2BAction(args){return function(dispatch){var data={clientId:args.clientId,brokerNumber:args.brokerNumber,companyId:args.companyId,action:args.action,category:args.category,contractNumber:args.contractNumber,contractId:args.contractId,b2bScenario:args.b2bScenario,actionCode:args.actionCode,domain:args.domain,transactionId:args.transactionId || "",recupCode:args.recupCode || ""}; /*if (err) {
			return dispatch(setNotification(err, 'error'))
		}*/return dispatch((0,_api.apiCall)('/api/startB2BAction',{data:(0,_libHelpers.trimObject)(data)})).then(function(data){dispatch(setB2bCompanyB2BTransactionDetails(data));dispatch(getB2bCompanyB2BTransactions({companyId:args.companyId,clientId:args.clientId}));return data;})['catch'](function(err){return dispatch(setNotification('Could not effect this action on policy!','error'));});};};exports.B2bCompanyStartB2BAction = B2bCompanyStartB2BAction; /**
	 * This action for start the vivium recuperation. This is a separated function for vivium at the moment (02.11.2017)
	 * @param {*} args
	 */var B2bCompanyB2bActionRecup=function B2bCompanyB2bActionRecup(args){return function(dispatch){var data={transactionId:args.transactionId || ""};return dispatch((0,_api.apiCall)('/api/B2BActionRecup',{data:(0,_libHelpers.trimObject)(data)})).then(function(data){ // We dont have to do nothing with this. This contains only a status message.
	return data;})['catch'](function(err){return dispatch(setNotification('Could not effect the recuperation!','error'));});};};exports.B2bCompanyB2bActionRecup = B2bCompanyB2bActionRecup;var setB2bCompanyB2BTransactionDetails=function setB2bCompanyB2BTransactionDetails(transactionDetails){return {type:_stateConstants2['default'].B2BCOMPANY_SET_TRANSACTION_DETAILS,transactionDetails:transactionDetails};};exports.setB2bCompanyB2BTransactionDetails = setB2bCompanyB2BTransactionDetails;var getB2bCompanyB2BTransactions=function getB2bCompanyB2BTransactions(args){return function(dispatch){var data={clientId:args.clientId,companyId:args.companyId};return dispatch((0,_api.apiCall)('/api/getB2BTransactions',{data:(0,_libHelpers.trimObject)(data)})).then(function(data){ // convert the transaction date format for every transaction
	var transactions=data && data.transactions && data.transactions.map(function(currentValue,index){return _extends({},currentValue,{transactionDate:(0,_moment2['default'])(currentValue.transactionDate,"YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm")});}) || [];dispatch(setB2bCompanyB2BTransactions(transactions));});};};exports.getB2bCompanyB2BTransactions = getB2bCompanyB2BTransactions;var setB2bCompanyB2BTransactions=function setB2bCompanyB2BTransactions(B2BTransactions){return {type:_stateConstants2['default'].B2BCOMPANY_SET_TRANSACTIONS,B2BTransactions:B2BTransactions};};exports.setB2bCompanyB2BTransactions = setB2bCompanyB2BTransactions;var formatB2bCompanyPolicy=function formatB2bCompanyPolicy(policy){Object.keys(policy).forEach(function(index){if(policy[index] === null){policy[index] = "";}});return _extends({},policy,{original:JSON.stringify(policy),address:policy.street && policy.houseNum && policy.zip && policy.city?policy.street + ' ' + policy.houseNum + ', ' + policy.zip + ' ' + policy.city:'',birthday:policy.birthday?(0,_libHelpers.formatDate)(policy.birthday,'eu'):'',phone:policy.phone,email:policy.email});};var loadB2bCompanyPolicy=function loadB2bCompanyPolicy(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getB2bCompanyPolicies')).then(function(data){return dispatch(gotB2bCompanyPolicy(data.map(formatB2bCompanyPolicy)));});};};exports.loadB2bCompanyPolicy = loadB2bCompanyPolicy;var setB2bCompanyPolicy=function setB2bCompanyPolicy(data){return function(dispatch){return dispatch((0,_api.apiCall)('/api/b2bCompany/' + (data._id || ''),{data:data})) //.then(() => dispatch(loadB2bCompanyPolicies()))
	['catch'](function(){return dispatch(setNotification('Could not save the policy!','error'));});};};exports.setB2bCompanyPolicy = setB2bCompanyPolicy;var showB2bCompanyPolicyModal=function showB2bCompanyPolicyModal(id){return {type:_stateConstants2['default'].SHOW_B2BCOMPANY_POLICY_MODAL,id:id};};exports.showB2bCompanyPolicyModal = showB2bCompanyPolicyModal;var hideB2bCompanyPolicyModal=function hideB2bCompanyPolicyModal(){return {type:_stateConstants2['default'].HIDE_B2BCOMPANY_POLICY_MODAL};};exports.hideB2bCompanyPolicyModal = hideB2bCompanyPolicyModal;var setB2bCompanyClientAction=function setB2bCompanyClientAction(currentClientAction){return {type:_stateConstants2['default'].B2BCOMPANY_CLIENT_ACTION_USED,currentClientAction:currentClientAction};};exports.setB2bCompanyClientAction = setB2bCompanyClientAction;var setB2bCompanyClientSubAction=function setB2bCompanyClientSubAction(currentClientSubAction){return {type:_stateConstants2['default'].B2BCOMPANY_CLIENT_SUB_ACTION_USED,currentClientSubAction:currentClientSubAction};};exports.setB2bCompanyClientSubAction = setB2bCompanyClientSubAction;var setB2bCompanyBrokersData=function setB2bCompanyBrokersData(brokers,accountManagers){return {type:_stateConstants2['default'].SET_B2BCOMPANY_BROKERS_DATA,brokers:brokers,accountManagers:accountManagers};};var fetchB2bCompanyBrokers=function fetchB2bCompanyBrokers(){return function(dispatch){return dispatch((0,_api.apiCall)('/data/office')).then(function(data){var brokers={};var _iteratorNormalCompletion12=true;var _didIteratorError12=false;var _iteratorError12=undefined;try{for(var _iterator12=data.officeInfo.brokers[Symbol.iterator](),_step12;!(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done);_iteratorNormalCompletion12 = true) {var broker=_step12.value;if(broker.main.website.slice(0,4) !== 'http'){broker.main.website = 'http://' + broker.main.website;}brokers[broker.brokerNumber] = broker;}}catch(err) {_didIteratorError12 = true;_iteratorError12 = err;}finally {try{if(!_iteratorNormalCompletion12 && _iterator12['return']){_iterator12['return']();}}finally {if(_didIteratorError12){throw _iteratorError12;}}}dispatch(setB2bCompanyBrokersData(brokers,data.accountManagers));dispatch(setB2bCompanyBrNr(data.officeInfo.brokers[0].brokerNumber));});};};exports.fetchB2bCompanyBrokers = fetchB2bCompanyBrokers; /** TASK MODULE ACTIONS
	***********************************************************************************************************************/ /**
	 * Modals related actions
	 * Here you can find all the list getters
	 */var taskModuleListGet=function taskModuleListGet(){return function(dispatch){dispatch((0,_api.apiCall)('/api/getTasks')).then(function(data){dispatch(taskModuleListSet(data));});};};exports.taskModuleListGet = taskModuleListGet;var taskModuleListSet=function taskModuleListSet(tasks){return {type:_stateConstants2['default'].TASK_MODULE_LIST_SET,tasks:tasks};};var taskModuleListGetDefaultColors=function taskModuleListGetDefaultColors(){return function(dispatch){dispatch((0,_api.apiCall)('/api/getTaskDefaultColors')).then(function(data){dispatch(taskModuleListDefaultColorsSet(data));});};};exports.taskModuleListGetDefaultColors = taskModuleListGetDefaultColors;var taskModuleListDefaultColorsSet=function taskModuleListDefaultColorsSet(taskColors){return {type:_stateConstants2['default'].TASK_MODULE_LIST_DEFAULT_COLORS_SET,taskColors:taskColors};};var taskModuleListGetUserColors=function taskModuleListGetUserColors(){return function(dispatch){dispatch((0,_api.apiCall)('/api/getTaskUserColors')).then(function(data){dispatch(taskModuleListUserColorsSet(data));dispatch(taskModuleFilterClean());});};};exports.taskModuleListGetUserColors = taskModuleListGetUserColors;var taskModuleListUserColorsSet=function taskModuleListUserColorsSet(taskColors){return {type:_stateConstants2['default'].TASK_MODULE_LIST_USER_COLORS_SET,taskColors:taskColors};}; /**
	 * Modals related actions
	 *
	 * Here you can find all actions that are related to modals
	 */var taskModuleModalToggle=function taskModuleModalToggle(modalType){return {type:_stateConstants2['default'].TASK_MODULE_MODAL_TOGGLE,modalType:modalType};};exports.taskModuleModalToggle = taskModuleModalToggle;var taskModuleModalNotificationSet=function taskModuleModalNotificationSet(notificationType){var itemId=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];return function(dispatch){dispatch({type:_stateConstants2['default'].TASK_MODULE_MODAL_NOTIFICATION_SET,notificationData:{notificationType:notificationType,itemId:itemId}});dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_NOTIFICATION));};};exports.taskModuleModalNotificationSet = taskModuleModalNotificationSet;var taskModuleModalNotificationReset=function taskModuleModalNotificationReset(){return {type:_stateConstants2['default'].TASK_MODULE_MODAL_NOTIFICATION_RESET};};exports.taskModuleModalNotificationReset = taskModuleModalNotificationReset; /**
	 * Forms related actions
	 *
	 * Here you can find all the global form actions
	 */var taskModuleFormCleanAction=function taskModuleFormCleanAction(formType){return function(dispatch){dispatch(taskModuleFormClean(formType));};};exports.taskModuleFormCleanAction = taskModuleFormCleanAction;var taskModuleFormEditSetAction=function taskModuleFormEditSetAction(formType,entityId){return function(dispatch){dispatch(taskModuleFormEditSet(formType,entityId));};};exports.taskModuleFormEditSetAction = taskModuleFormEditSetAction;var taskModuleFormError=function taskModuleFormError(error,formType){return {type:_stateConstants2['default'].TASK_MODULE_FORM_ERROR,response:{error:error,formType:formType}};};var taskModuleFormClean=function taskModuleFormClean(formType){return {type:_stateConstants2['default'].TASK_MODULE_FORM_CLEAN,formType:formType};};var taskModuleFormCleanMessage=function taskModuleFormCleanMessage(formType){return {type:_stateConstants2['default'].TASK_MODULE_FORM_CLEAN_MESSAGE,formType:formType};};var taskModuleFormEditSet=function taskModuleFormEditSet(formType,entityId){return {type:_stateConstants2['default'].TASK_MODULE_FORM_EDIT_SET,response:{entityId:entityId,formType:formType}};}; /**
	 * Task form related actions
	 *
	 * Here you can find all actions that are related to task form
	 */var taskModuleFormCreateTask=function taskModuleFormCreateTask(taskData){return function(dispatch){dispatch(taskModuleFormCleanMessage('manageTask'));dispatch((0,_api.apiCall)('/api/createTask',{data:taskData})).then(function(data){dispatch(taskModuleListGet());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_TASK));dispatch(taskModuleFormClean('taskForm'));},function(err){return dispatch(taskModuleFormError(err,'manageTask'));});};};exports.taskModuleFormCreateTask = taskModuleFormCreateTask;var taskModuleFormUpdateTask=function taskModuleFormUpdateTask(taskData){return function(dispatch){dispatch(taskModuleFormCleanMessage('manageTask'));dispatch((0,_api.apiCall)('/api/updateTask',{data:taskData})).then(function(data){dispatch(taskModuleListGet());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_TASK));dispatch(taskModuleFormClean('manageTask'));},function(err){return dispatch({type:_stateConstants2['default'].TASK_MODULE_FORM_TASK_ERROR,err:err});});};};exports.taskModuleFormUpdateTask = taskModuleFormUpdateTask;var taskModuleTaskDelete=function taskModuleTaskDelete(items){return function(dispatch){var itemIds=items.filter(function(i){return i.checked === true;}).map(function(i){return i;});itemIds = itemIds.filter(function(item){return !item.hidden;}).map(function(i){return i.id;});dispatch((0,_api.apiCall)('/api/deleteTask',{data:{taskIds:itemIds}})).then(function(data){dispatch(taskModuleListGet());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_NOTIFICATION));dispatch(taskModuleModalNotificationReset());});};};exports.taskModuleTaskDelete = taskModuleTaskDelete; /**
	 * TaskColorCode form related actions
	 *
	 * Here you can find all actions that are related to task form
	 */var taskModuleFormCreateTaskColor=function taskModuleFormCreateTaskColor(taskColorData){return function(dispatch){dispatch(taskModuleFormCleanMessage('manageColorPicker'));dispatch((0,_api.apiCall)('/api/createTaskColor',{data:taskColorData})).then(function(data){dispatch(taskModuleListGetUserColors());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER));dispatch(taskModuleFormClean('manageColorPicker'));},function(err){return dispatch(taskModuleFormError(err,'manageColorPicker'));});};};exports.taskModuleFormCreateTaskColor = taskModuleFormCreateTaskColor;var taskModuleFormUpdateTaskColor=function taskModuleFormUpdateTaskColor(taskColorData){return function(dispatch){dispatch(taskModuleFormCleanMessage('manageColorPicker'));dispatch((0,_api.apiCall)('/api/updateTaskColor',{data:taskColorData})).then(function(data){dispatch(taskModuleListGetUserColors());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER));dispatch(taskModuleFormClean('manageColorPicker'));dispatch(taskModuleListGet());},function(err){return dispatch(taskModuleFormError(err,'manageColorPicker'));});};};exports.taskModuleFormUpdateTaskColor = taskModuleFormUpdateTaskColor;var taskModuleTaskColorDelete=function taskModuleTaskColorDelete(taskColorId){return function(dispatch){dispatch((0,_api.apiCall)('/api/deleteTaskColor',{data:{id:taskColorId}})).then(function(data){dispatch(taskModuleListGetUserColors());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_NOTIFICATION));dispatch(taskModuleModalNotificationReset());dispatch(taskModuleListGet());});};};exports.taskModuleTaskColorDelete = taskModuleTaskColorDelete;var taskModuleTaskColorReset=function taskModuleTaskColorReset(){return function(dispatch){dispatch((0,_api.apiCall)('/api/resetTaskColor',{data:{}})).then(function(data){dispatch(taskModuleListGetUserColors());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_NOTIFICATION));dispatch(taskModuleModalNotificationReset());dispatch(taskModuleListGet());});};};exports.taskModuleTaskColorReset = taskModuleTaskColorReset; /**
	 * Task filter actions
	 *
	 * Here you can find all filter actions for task module
	 */var taskModuleFilter=function taskModuleFilter(filterStatusValue,filterColorValue){return {type:_stateConstants2['default'].TASK_MODULE_FILTER,filterOptions:{filterStatusValue:filterStatusValue,filterColorValue:filterColorValue}};};exports.taskModuleFilter = taskModuleFilter;var taskModuleFilterClean=function taskModuleFilterClean(){return {type:_stateConstants2['default'].TASK_MODULE_FILTER_CLEAN};};exports.taskModuleFilterClean = taskModuleFilterClean; /**
	 * Task items checkbox actions
	 *
	 * Here you can find all actions that help the table list to check items
	 */var taskModuleItemCheck=function taskModuleItemCheck(itemId){return {type:_stateConstants2['default'].TASK_MODULE_ITEM_SET_CHECK,itemId:itemId};};exports.taskModuleItemCheck = taskModuleItemCheck;var taskModuleItemCheckAllVisible=function taskModuleItemCheckAllVisible(visibleItems){return {type:_stateConstants2['default'].TASK_MODULE_ITEM_SET_CHECK_ALL_VISIBLE,visibleItems:visibleItems};};exports.taskModuleItemCheckAllVisible = taskModuleItemCheckAllVisible; /** INBOX AND TASK LIST RELATED ACTIONS - THIS FUNCTIONS ARE RELATED TO TICKET AND TASK MODELS
	***********************************************************************************************************************/var fetchStaffList=function fetchStaffList(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getStaffList',{data:{}})).then(function(response){dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_SET_STAFF_LIST,response:response});});};};exports.fetchStaffList = fetchStaffList;var resetStaffList=function resetStaffList(){return function(dispatch){return dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_RESET_STAFF_LIST});};};exports.resetStaffList = resetStaffList;var archiveToggleModal=function archiveToggleModal(){return function(dispatch){return dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_MODAL_TOGGLE});};};exports.archiveToggleModal = archiveToggleModal;var archiveRelational=function archiveRelational(items,type){return function(dispatch){var itemsData={noRelation:[],relation:[]};var itemIds=items.filter(function(i){return i.checked === true;}).map(function(value,key){if(value.ticketUniqueId == "" || value.ticketUniqueId === undefined || value.ticketUniqueId === null || value.ticketUniqueId === "undefined" || value.ticketUniqueId === "null"){itemsData.noRelation.push(value);}else {itemsData.relation.push(value.ticketUniqueId);}});if(type == 'all' && itemsData.noRelation.length > 0){dispatch(archive(itemsData.noRelation));}var data={ticketIds:itemsData.relation,type:type};return dispatch((0,_api.apiCall)('/api/archiveTicketsRelation',{data:data})).then(function(){return dispatch(getInbox(true));});};};exports.archiveRelational = archiveRelational; /**
	 * Old task generator for ticket
	 * NOT USED - we use generateTaskWithRelation --> to implement multiple relations
	 * NOT REMOVED UNTIL EVERY TEST IS WORKING CORRECTLY
	 */var generateTaskFromTicket=function generateTaskFromTicket(data){return function(dispatch){data.users = data.users.filter(function(item){return item.selected;}); // If the user confirmed to arhive the tickets
	if(data.confirm && data.confirm === true){dispatch(archiveRelational(data.items,'all')).then(function(){dispatch((0,_api.apiCall)('/api/generateTaskFromTicket',{data:data})).then(function(response){dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS,response:response});dispatch(getInbox(true));dispatch(resetStaffList());},function(err){return dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_CONVERT_TICKET_ERROR,err:err});});});}else {dispatch((0,_api.apiCall)('/api/generateTaskFromTicket',{data:data})).then(function(response){dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS,response:response});dispatch(getInbox(true));dispatch(resetStaffList());},function(err){return dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_CONVERT_TICKET_ERROR,err:err});});}};};exports.generateTaskFromTicket = generateTaskFromTicket;var forceUncheckSelectedTickets=function forceUncheckSelectedTickets(){return function(dispatch){dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_CLEAN_SELECTED_ITEMS});};};exports.forceUncheckSelectedTickets = forceUncheckSelectedTickets;var sendTaskToUser=function sendTaskToUser(data){return function(dispatch){data.users = data.users.filter(function(item){return item.selected;});data.items = data.items.filter(function(item){return item.checked;});dispatch((0,_api.apiCall)('/api/sendTask',{data:data})).then(function(response){dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS,response:response});dispatch(taskModuleListGet());dispatch(resetStaffList());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_SEND_TASK));},function(err){return dispatch({type:_stateConstants2['default'].INBOX_ARCHIVE_CONVERT_TICKET_ERROR,err:err});});};};exports.sendTaskToUser = sendTaskToUser;var setTaskReaded=function setTaskReaded(data){return function(dispatch){dispatch((0,_api.apiCall)('/api/setTaskReaded',{data:data})).then(function(response){dispatch({type:_stateConstants2['default'].TASK_MODULE_ITEM_READED,response:response});});};};exports.setTaskReaded = setTaskReaded;var appGetNofitications=function appGetNofitications(type){return function(dispatch){dispatch((0,_api.apiCall)('/getNotifications',{data:{type:type}})).then(function(response){dispatch({type:_stateConstants2['default'].SET_APP_NOTIFICATIONS,response:response});});};};exports.appGetNofitications = appGetNofitications; /** TASK CREATOR ACTIONS
	*****************************************************************************************/var taskCreatorModalToggle=function taskCreatorModalToggle(){return {type:_stateConstants2['default'].TASK_CREATOR_MODAL_TOGGLE};};exports.taskCreatorModalToggle = taskCreatorModalToggle;var taskCreatorGenerateWithRelations=function taskCreatorGenerateWithRelations(data){return function(dispatch){data.users = data.users.filter(function(item){return item.selected;});if(data.isArchiveConfirmation && data.isArchiveConfirmation === true){if(data.convertionType == 'outbox'){(function(){var outboxItemIds=data.items.map(function(value){return value.taskRelation;});dispatch((0,_api.apiCall)('/api/generateTaskWithRelations',{data:data})).then(function(response){_archiveEmails(outboxItemIds,dispatch).then(function(){dispatch({type:_stateConstants2['default'].TASK_CREATOR_CONVERTION_SUCCESS,response:response});});},function(err){return dispatch({type:_stateConstants2['default'].TASK_CREATOR_CONVERTION_FAIL,err:err});});})();}if(data.convertionType == 'inbox'){dispatch((0,_api.apiCall)('/api/generateTaskWithRelations',{data:data})).then(function(response){dispatch(taskCreatorArchiveTicketsRelational(data.items)).then(function(){dispatch({type:_stateConstants2['default'].TASK_CREATOR_CONVERTION_SUCCESS,response:response});});},function(err){return dispatch({type:_stateConstants2['default'].TASK_CREATOR_CONVERTION_FAIL,err:err});});}}else {dispatch((0,_api.apiCall)('/api/generateTaskWithRelations',{data:data})).then(function(response){dispatch({type:_stateConstants2['default'].TASK_CREATOR_CONVERTION_SUCCESS,response:response});if(data.convertionType === 'outbox'){dispatch(getOutbox(true));}if(data.convertionType === 'inbox'){dispatch(getInbox(true));}if(data.convertionType === 'task'){dispatch(taskModuleListGet());}if(data.convertionType === 'taskCreate'){dispatch(taskModuleListGet());dispatch(taskModuleModalToggle(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_TASK));dispatch(taskModuleFormClean('taskForm'));}},function(err){return dispatch({type:_stateConstants2['default'].TASK_CREATOR_CONVERTION_FAIL,err:err});});}};};exports.taskCreatorGenerateWithRelations = taskCreatorGenerateWithRelations;var taskCreatorArchiveTicketsRelational=function taskCreatorArchiveTicketsRelational(taskItems){return function(dispatch){var itemsData={noRelation:[],relation:[]};taskItems.map(function(value,key){if(value.ticketMsgLink == "" || value.ticketMsgLink === undefined || value.ticketMsgLink === null || value.ticketMsgLink === "undefined" || value.ticketMsgLink === "null"){if(value.ticketReferral !== undefined && value.ticketReferral !== null){itemsData.noRelation.push(value.ticketReferral);}}else {itemsData.relation.push(value.ticketMsgLink);}});var relationalData={ticketIds:itemsData.relation,type:'all'};var noRelationData={ticketIds:itemsData.noRelation,status:{archived:true}};if(itemsData.noRelation.length > 0){dispatch((0,_api.apiCall)('/api/updateTickets',{data:noRelationData}));}return dispatch((0,_api.apiCall)('/api/archiveTicketsRelation',{data:relationalData})).then(function(){return dispatch(getInbox(true));});};};exports.taskCreatorArchiveTicketsRelational = taskCreatorArchiveTicketsRelational;var setAccountConfirmationHash=function setAccountConfirmationHash(hash){return {type:_stateConstants2['default'].SET_ACCOUNT_CONFIRMATION_HASH,payload:hash};};exports.setAccountConfirmationHash = setAccountConfirmationHash;var createConfirmationToken=function createConfirmationToken(hash){return function(dispatch,getState){return dispatch((0,_api.apiCall)("/newConfirmationToken",{data:{hash:hash}}));};};exports.createConfirmationToken = createConfirmationToken;var validateConfirmationToken=function validateConfirmationToken(hash,token){return function(dispatch,getState){return dispatch((0,_api.apiCall)("/verifyConfirmationToken",{data:{hash:hash,passcode:token}})).then(function(response){return response;});};};exports.validateConfirmationToken = validateConfirmationToken;var setAccountConfirmationStep=function setAccountConfirmationStep(step){return {type:_stateConstants2['default'].SET_ACCOUNT_CONFIRMATION_STEP,payload:step};};exports.setAccountConfirmationStep = setAccountConfirmationStep;var cleanAccountConfirmation=function cleanAccountConfirmation(){return {type:_stateConstants2['default'].CLEAN_ACCOUNT_CONFIRMATION};};exports.cleanAccountConfirmation = cleanAccountConfirmation;var createNewClient=function createNewClient(password,hash){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/createNewClient',{data:{password:password,hash:hash}})).then(function(res){return res;});};};exports.createNewClient = createNewClient;var checkIfClientExistApi=function checkIfClientExistApi(hash){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/validateClientHash',{data:{hash:hash}})).then(function(res){return res;});};};exports.checkIfClientExistApi = checkIfClientExistApi;var refreshHashAndTokenApi=function refreshHashAndTokenApi(hash){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/refreshClientHash',{data:{hash:hash}})).then(function(res){return res;});};};exports.refreshHashAndTokenApi = refreshHashAndTokenApi; /************************************************************
	 * Actions for Client Confirmation
	************************************************************/var showPrintModal=function showPrintModal(modalId,title,message,flag,payload){return {type:_stateConstants2['default'].SHOW_PRINT_MODAL,modalId:modalId,printModal:{message:message,title:title,flag:flag,payload:payload,result:false}};};exports.showPrintModal = showPrintModal;var hidePrintModal=function hidePrintModal(modalId,result){return {type:_stateConstants2['default'].HIDE_PRINT_MODAL,modalId:modalId,result:result};};exports.hidePrintModal = hidePrintModal; /************************************************************
	 * Actions for DSDOCUMENT
	 ************************************************************/ /**
	 *  Trigger reducer to store dsdocuments list
	 * @param {*} data
	 * @param {*} state
	 */var setDSDocuments=function setDSDocuments(data,state){var DigitalSignature=state.app.security.DigitalSignature;return {type:_stateConstants2['default'].GOT_DSDOCUMENTS,data:data,ts:Date.now()};};exports.setDSDocuments = setDSDocuments; /**
	 * Fetch dsdocuments from API
	 * @param {*} dsdocument
	 * @param {*} state
	 */var getDSDocuments=function getDSDocuments(force){return function(dispatch,getState){var ts=getState().DSDocuments.ts;if(force || !ts || Date.now() - ts > STALE_TIME){return dispatch((0,_api.apiCall)('/api/getDSDocuments')).then(function(dsdocuments){return dispatch(setDSDocuments(dsdocuments,getState()));}, // Ignore errors
	function(){return dispatch(setDSDocuments([],getState()));});}return Promise.resolve();};};exports.getDSDocuments = getDSDocuments; /**
	 *  Trigger reducer to store DSDataSet
	 * @param {*} data
	 */var setDSDataSets=function setDSDataSets(data){return {type:_stateConstants2['default'].GOT_DSDATASET,data:data};};exports.setDSDataSets = setDSDataSets; /**
	 * Fetch datasets from API
	 * @param {*} dataset id
	 * @param {*} state
	 */var getDSDataSets=function getDSDataSets(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getDSDataSets',{data:{}})).then(function(dataset){return dispatch(setDSDataSets(dataset));}, // Ignore errors
	function(){return dispatch(setDSDataSets([]));});};};exports.getDSDataSets = getDSDataSets; /**
	 * Fetch teamSubgroups from API
	 */var fetchTeamSubgroups=function fetchTeamSubgroups(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getTeamSubgroups',{data:{}})).then(function(subgroups){dispatch(setTeamSubgroups(subgroups));return subgroups;}, // Ignore errors
	function(err){console.error(err);dispatch(setTeamSubgroups([]));return [];});};};exports.fetchTeamSubgroups = fetchTeamSubgroups; /**
	 * Fetch dataset from API
	 * @param {*} datasetName
	 * @param {*} clientId
	 * @param {*} brokerNumber
	 * @param {*} language
	 * @param {*} contractId
	 * @param {*} claimId
	 */var getDSDataSet=function getDSDataSet(datasetName,clientId,brokerNumber,language,contractId,claimId,brokerClient){return function(dispatch){var extraParams={};if(clientId){extraParams.clientId = clientId;}if(contractId){extraParams.contractId = contractId;}if(claimId){extraParams.claimId = claimId;}if(brokerClient){extraParams.brokerClient = brokerClient;}return dispatch((0,_api.apiCall)('/api/getDSDataSet',{data:_extends({datasetName:datasetName,brokerNumber:brokerNumber,language:language},extraParams)}));};};exports.getDSDataSet = getDSDataSet; /**
	 * Used to retrive a given options list from connective that we use to populate options list to selects in DSDocuments
	 * @param {*} lists the list of objects that contain the parameter name and the list name we need to retrieve
	 * @param {*} language the language fo the options we need
	 * @returns
	 */var getLists=function getLists(lists,language){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getLists',{data:{lists:lists,language:language}}));};};exports.getLists = getLists; /**
	 *  Trigger reducer to store DSDataSet
	 * @param {*} data
	 */var setTeamSubgroups=function setTeamSubgroups(data){return {type:_stateConstants2['default'].GOT_TEAM_SUBGROUPS,data:data};};exports.setTeamSubgroups = setTeamSubgroups; /**
	 * Fetch dataset from API
	 * @param {array} formInputs The list of the DsWizard input fields, with names and values together.
	 * @returns The created package instance from the server.
	 */var upsertDSPackage=function upsertDSPackage(formInputs){return function(dispatch){ // in case of company, force fill the First and Last name to be accepted by connective.
	// TODO find an elegant solution, ask connective for an improved service, where is not required this fields
	if(!formInputs.clientFirstName || formInputs.clientFirstName.length === 0){formInputs.clientFirstName = '⠀';}if(!formInputs.clientLastName || formInputs.clientLastName.length === 0){formInputs.clientLastName = '⠀';}return dispatch((0,_api.apiCall)('/api/upsertDSPackage',{data:_extends({},formInputs)})).then(function(dsPackage){return dispatch(getDsDocsAndPackages(true,false,null,null,true)).then(function(){return dsPackage;});}, // TODO must got a way to avoid to load again all of the documents
	// Ignore errors
	function(err){return dispatch(getDsDocsAndPackages(true,false,null,null,true)).then(function(){return {}; // no package received
	});});};};exports.upsertDSPackage = upsertDSPackage; /**
	 * Fetch DSPackages from API for current user
	 */var upsertDSPackageEmailStatus=function upsertDSPackageEmailStatus(packageId,emailId,mailOptions){return function(dispatch){return dispatch((0,_api.apiCall)('/api/upsertDSPackageEmailHistory',{data:{packageId:packageId,emailId:emailId,mailOptions:mailOptions}}));};};exports.upsertDSPackageEmailStatus = upsertDSPackageEmailStatus; /**
	 *  Trigger reducer to store DSDataSet
	 * @param {*} data
	 */var setDSPackages=function setDSPackages(data){return {type:_stateConstants2['default'].GOT_DSPACKAGES,data:data};};exports.setDSPackages = setDSPackages; /**
	 * Fetch DSPackages from API for current user
	 */var getDSPackages=function getDSPackages(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getDSPackages',{data:{}})).then(function(result){return dispatch(setDSPackages(result));}, // Ignore errors
	function(){return dispatch(setDSPackages([]));});};};exports.getDSPackages = getDSPackages; /**
	 *  Trigger reducer to store docs and packages
	 * @param {*} data
	 */var setDsDocsAndPackages=function setDsDocsAndPackages(data){return {type:_stateConstants2['default'].GOT_DSDOCS_AND_PACKAGES,data:data};};exports.setDsDocsAndPackages = setDsDocsAndPackages; /**
	 * Fetch docs and packages from API for current user
	 *
	 * @param {*} noCache switch for use cache
	 * @param {*} noLoader switch for spinner (true -> no spiner)
	 * @returns
	 */var getDsDocsAndPackages=function getDsDocsAndPackages(noCache,noLoader,alienUserId,packageId){if(noCache === undefined)noCache = false;if(noLoader === undefined)noLoader = false;var onlyActiveTemplates=arguments.length <= 4 || arguments[4] === undefined?false:arguments[4];return function(dispatch){return dispatch((0,_api.apiCall)('/api/getDSPackagesAndDocuments',{data:{userId:alienUserId,packageId:packageId,onlyActiveTemplates:onlyActiveTemplates},noLoader:noLoader,noCache:noCache})).then(function callee$2$0(result){var resultOfSet;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:context$3$0.next = 2;return regeneratorRuntime.awrap(dispatch(setDsDocsAndPackages(result)));case 2:resultOfSet = context$3$0.sent;return context$3$0.abrupt('return',resultOfSet.data);case 4:case 'end':return context$3$0.stop();}},null,_this);}, // Ignore errors
	function(err){console.warn("getDsDocsAndPackages: err: ",err);return dispatch(setDsDocsAndPackages([]));});};};exports.getDsDocsAndPackages = getDsDocsAndPackages;var setPaginatedPackages=function setPaginatedPackages(returnedData){return {type:_stateConstants2['default'].GOT_PAGINATED_PACKAGES,data:{paginatedPackages:returnedData.packageData.data,totalPackageRecords:returnedData.packageData.totalRecords,paginationData:returnedData.paginationData}};}; // indexTypeMap: returnedData.indexTypeMap
	var resetDSPackagesPaginationData=function resetDSPackagesPaginationData(){return {type:_stateConstants2['default'].RESET_PAGINATED_DATA,data:{}};};exports.resetDSPackagesPaginationData = resetDSPackagesPaginationData;var getPaginatedPackagesList=function getPaginatedPackagesList(data){return function callee$1$0(dispatch){var response,resultOfSetData;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('api/getDsPackagesListPaginated',{data:data})));case 3:response = context$2$0.sent;if(!response){context$2$0.next = 9;break;}context$2$0.next = 7;return regeneratorRuntime.awrap(dispatch(setPaginatedPackages(_extends({},response,{paginationData:data}))));case 7:resultOfSetData = context$2$0.sent;return context$2$0.abrupt('return',resultOfSetData.data);case 9:return context$2$0.abrupt('return');case 12:context$2$0.prev = 12;context$2$0.t0 = context$2$0['catch'](0); // Ignore errors
	console.warn('getPaginatedPackagesList: err: ',context$2$0.t0);return context$2$0.abrupt('return',dispatch(setPaginatedPackages({paginatedPackages:[],totalPackageRecords:0,paginationData:data})));case 16:case 'end':return context$2$0.stop();}},null,_this,[[0,12]]);};};exports.getPaginatedPackagesList = getPaginatedPackagesList;var getOneDsPackageById=function getOneDsPackageById(packageId){return function callee$1$0(dispatch){var response;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('api/getOneDsPackageById',{data:{packageId:packageId}})));case 3:response = context$2$0.sent;return context$2$0.abrupt('return',response);case 7:context$2$0.prev = 7;context$2$0.t0 = context$2$0['catch'](0);return context$2$0.abrupt('return',context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,7]]);};};exports.getOneDsPackageById = getOneDsPackageById; /**
	 * API call to get documents id's that require contract linking
	 * @param {} clientId
	 */var getDsDocsToLinkWithContract=function getDsDocsToLinkWithContract(filterData){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getDsDocsToLinkWithContract',{data:{clientId:filterData.clientId,staffList:filterData.staffList,brokerNumbersList:filterData.brokerNumbersList}})).then(function(result){return result;});};};exports.getDsDocsToLinkWithContract = getDsDocsToLinkWithContract; // TODO could be optimize by fetch and update only the affected document.
	/**
	 * Upsert document
	 * @param {*} values
	 * @returns the updated document
	 */var upsertDSDocumentAndFetchAllData=function upsertDSDocumentAndFetchAllData(data){return function callee$1$0(dispatch){var documentData,connectiveFormFields,upsertDocumentReq;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;documentData = data.documentData;connectiveFormFields = data.connectiveFormFields;context$2$0.next = 5;return regeneratorRuntime.awrap(dispatch(upsertDSDocument(documentData)));case 5:upsertDocumentReq = context$2$0.sent; //create connective form fields if there are any
	if(connectiveFormFields && connectiveFormFields.length > 0){dispatch(upsertDSDocumentConnectiveFields(connectiveFormFields,documentData._id));}dispatch(getDsDocsAndPackages(true,false,null,null,true));return context$2$0.abrupt('return',upsertDocumentReq);case 11:context$2$0.prev = 11;context$2$0.t0 = context$2$0['catch'](0);console.error(context$2$0.t0);return context$2$0.abrupt('return',dispatch(getDsDocsAndPackages(true,false,null,null,true)));case 15:case 'end':return context$2$0.stop();}},null,_this,[[0,11]]);};};exports.upsertDSDocumentAndFetchAllData = upsertDSDocumentAndFetchAllData; /**
	 * Upsert dsDocument
	 * @param {*} values
	 * @returns the updated document
	 */var upsertDSDocument=function upsertDSDocument(values){return function(dispatch){var upsertDocumentPromise=dispatch((0,_api.apiCall)('/api/upsertDSDocument',{data:{dsdocument:values}}));return upsertDocumentPromise.then(function(result){return Promise.resolve(result);})['catch'](function(err){return Promise.reject(err);});};};exports.upsertDSDocument = upsertDSDocument;var upsertDSDocumentConnectiveFields=function upsertDSDocumentConnectiveFields(connectiveFormFields,dsDocumentId){return function callee$1$0(dispatch){var upsertDSDocumentFormFieldsReq;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('/api/upsertDSDocumentConnectiveFields',{data:{connectiveFormFields:connectiveFormFields,dsDocumentId:dsDocumentId}})));case 3:upsertDSDocumentFormFieldsReq = context$2$0.sent;return context$2$0.abrupt('return',upsertDSDocumentFormFieldsReq);case 7:context$2$0.prev = 7;context$2$0.t0 = context$2$0['catch'](0);console.error(context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,7]]);};}; /**
	 * Upsert printable document
	 * @param {*} values
	 * @param {*} canvasImages
	 * @returns the creted printable document
	 */var createPrintableDocument=function createPrintableDocument(values,canvasImages){return function(dispatch){var upsertDocumentPromise=dispatch((0,_api.apiCall)('/api/createPrintableDocument',{data:{printableDocument:values,canvasImages:canvasImages}}));return upsertDocumentPromise.then(function(result){return Promise.resolve(result);})['catch'](function(err){console.error(err);return Promise.reject(err);});};};exports.createPrintableDocument = createPrintableDocument; /**
	 * Upsert more documents
	 * @param {*} dsDocuments array of updates for one or more documents
	 * @return the updated Documents
	 */var updateManyDocuments=function updateManyDocuments(documentIdsList,updates){return function callee$1$0(dispatch){var response;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('/api/updateManyDocuments',{data:{documentIdsList:documentIdsList,updates:updates}})));case 3:response = context$2$0.sent;return context$2$0.abrupt('return',response);case 7:context$2$0.prev = 7;context$2$0.t0 = context$2$0['catch'](0);return context$2$0.abrupt('return',context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,7]]);};};exports.updateManyDocuments = updateManyDocuments; /**
	 * Gets the signers related to a given document
	 * @param {*} data
	 * @returns a list of signers
	 */var getDSStakeholders=function getDSStakeholders(stakeholders){var noLoader=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];return function(dispatch){var getDSStakholderPromise=dispatch((0,_api.apiCall)('/api/getDSStakeholders',{data:{stakeholders:stakeholders},noLoader:noLoader}));return getDSStakholderPromise.then(function(result){return Promise.resolve(result);})['catch'](function(err){return Promise.reject(err);});};};exports.getDSStakeholders = getDSStakeholders;var updateDSStakeholder=function updateDSStakeholder(data){return function(dispatch){var umpdateStakeholderRequest=dispatch((0,_api.apiCall)('/api/updateDSStakeholder',{data:data}));return umpdateStakeholderRequest.then(function(result){return Promise.resolve(result);})['catch'](function(err){return Promise.reject(err);});};};exports.updateDSStakeholder = updateDSStakeholder;var getStakeholdersByPackageId=function getStakeholdersByPackageId(packageId){return function(dispatch){var umpdateStakeholderRequest=dispatch((0,_api.apiCall)('/api/getStakeholdersByPackageId',{data:{packageId:packageId}}));return umpdateStakeholderRequest.then(function(result){return Promise.resolve(result);})['catch'](function(err){return Promise.reject(err);});};};exports.getStakeholdersByPackageId = getStakeholdersByPackageId; /**
	 *  Trigger reducer to store DSDocumentTemplates
	 * @param {*} data
	 */var setDSDocumentTemplates=function setDSDocumentTemplates(data){return {type:_stateConstants2['default'].GOT_DSDOCUMENT_TEMPLATE,data:data};};exports.setDSDocumentTemplates = setDSDocumentTemplates; /**
	 * Fetch templates from API
	 */var getDSDocumentTemplates=function getDSDocumentTemplates(){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/getDSDocumentTemplates')).then(function(result){dispatch(setDSDocumentTemplates(result));return result;}, // Ignore errors
	function(){return dispatch(setDSDocumentTemplates([]));});};};exports.getDSDocumentTemplates = getDSDocumentTemplates; /**
	 * Fetch templates from API
	 */var getDSDocumentTemplate=function getDSDocumentTemplate(id){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/getDSDocumentTemplate',{data:{id:id}}));};};exports.getDSDocumentTemplate = getDSDocumentTemplate; /**
	 * Fetch templates signers type list from API
	 * * @param {Array} templateIdList
	 */var getTemplatesSigners=function getTemplatesSigners(templateIdList){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getDSDocumentTemplatesSigners',{data:{templateIdList:templateIdList}}));};};exports.getTemplatesSigners = getTemplatesSigners; /**
	 * Trigger reducer to store one dsdocument
	 * @param {*} dsdocument
	 * @param {*} state
	 */var setDSDocument=function setDSDocument(dsdocument,state){ //const {DigitalSignature} = state.app.security
	return {type:_stateConstants2['default'].GOT_DSDOCUMENT,dsdocument:dsdocument};};exports.setDSDocument = setDSDocument; /**
	 * Fetch one dsdocument from API
	 * @param {*} dsdocument
	 * @param {*} state
	 */var getDSDocument=function getDSDocument(id){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/getDSDocument',{data:{id:id}})).then(function(dsdocument){dispatch(setDSDocument(dsdocument /* , getState() */));return dsdocument;}, // Ignore errors
	function(){return dispatch(setDSDocument({} /* , getState() */));});};};exports.getDSDocument = getDSDocument; /**
	 * Fetch the configurations for digital signature system
	 * @param {*} dsdocument
	 * @param {*} state
	 */var getDSDocumentConfig=function getDSDocumentConfig(key){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/getDSDocumentConfig',{data:{key:key}})).then(function(config){return dispatch({type:_stateConstants2['default'].GOT_DS_CONFIG,config:config});}, // Ignore errors
	function(err){return dispatch({type:_stateConstants2['default'].GOT_DS_CONFIG,config:config});});};};exports.getDSDocumentConfig = getDSDocumentConfig; /**
	 * Filter DSDocuments action triggered by overview tools
	 * @param {*} selectValue
	 * @param {*} startDate
	 * @param {*} endDate
	 */var filterDSDocuments=function filterDSDocuments(){var selectValue=arguments.length <= 0 || arguments[0] === undefined?null:arguments[0];var startDate=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var endDate=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];return function(dispatch,getState){var DigitalSignature=getState().app.security.DigitalSignature;return dispatch({type:_stateConstants2['default'].DSDOCUMENT_SET_FILTERED,selectValue:selectValue,startDate:startDate,DigitalSignatureHelpers:DigitalSignature,endDate:endDate});};};exports.filterDSDocuments = filterDSDocuments; /**
	 * Archive all dsdocument selected
	 * @param {*} itemIds
	 * @param {*} dispatch
	 */var _archiveDSDocumentPackages=function _archiveDSDocumentPackages(itemIds,staffList,brokerNumbersList,dispatch){if(itemIds === undefined)itemIds = [];return dispatch((0,_api.apiCall)('/api/archiveDSDocumentPackages',{data:{DSDocumentIds:itemIds,staffList:staffList,brokerNumbersList:brokerNumbersList,attributes:{archived:true}}})); // .then(() => dispatch(getDsDocsAndPackages(true)))
	}; /**
	 * Wrapper for archive all selected DSDocuments by API
	 * @param {*} items
	 */var archiveDSDocumentPackages=function archiveDSDocumentPackages(items,staffList,brokerNumbersList){return function(dispatch){var itemIds=items.filter(function(i){return i.checked === true;}).map(function(i){return i.id;});return _archiveDSDocumentPackages(itemIds,staffList,brokerNumbersList,dispatch);};};exports.archiveDSDocumentPackages = archiveDSDocumentPackages; /**
	 * Archive all DSDocuments
	 * @param {*} items
	 */var archiveAllDSDocumentPackages=function archiveAllDSDocumentPackages(paginationData){return function(dispatch){ // const itemIds = items && items.map(i => i.id) || []
	return dispatch((0,_api.apiCall)('/api/archiveAllDSDocumentPackages',{data:{paginationData:paginationData,attributes:{archived:true}}}));};};exports.archiveAllDSDocumentPackages = archiveAllDSDocumentPackages; /**
	 * Set the selected DSDocuments id to opened by the specific sub-module
	 * @param {*} itemId
	 */var setDSDocumentsOpened=function setDSDocumentsOpened(itemId){return {type:_stateConstants2['default'].DSDOCUMENT_ITEM_ZOOMED,itemId:itemId};};exports.setDSDocumentsOpened = setDSDocumentsOpened; /**
	 * 	Set the selected DsDocuments package id vy the specific sub-module
	 * @param {*} packageId
	 * @returns
	 */var setDSDocumentsOpenedPackage=function setDSDocumentsOpenedPackage(packageId){return {type:_stateConstants2['default'].DSDOCUMENT_PACKAGE_ZOOMED,packageId:packageId};};exports.setDSDocumentsOpenedPackage = setDSDocumentsOpenedPackage; /**
	 * Set DSDocuments SubModule (for example open the detailed page by module keyword)
	 * @param {*} name
	 * @param {*} subModuleZoom
	 */var setDSDocumentsSubModule=function setDSDocumentsSubModule(name,subModuleZoom){return {type:_stateConstants2['default'].SET_DSDOCUMENT_SUB_MODULE,name:name,subModuleZoom:subModuleZoom};};exports.setDSDocumentsSubModule = setDSDocumentsSubModule; /**
	 * Update DSDocumentPackage by API request
	 * @param {*} data
	 */var updateDSDocumentPackage=function updateDSDocumentPackage(data){return function(dispatch){return dispatch((0,_api.apiCall)('/api/updateDSDocumentPackage',{data:{DSDocumentPackage:data}})).then(function(){return dispatch(getDsDocsAndPackages(true,false,null,null,true));});};};exports.updateDSDocumentPackage = updateDSDocumentPackage; /**
	 * Update executeFullDSDocumentWizard by API request
	 * @param {*} data
	 * @param {string} usersProcessFlagName optional parameter, what let you follow up the process state on server by that
	 */var executeFullDSDocumentWizardOnServer=function executeFullDSDocumentWizardOnServer(packageId){var usersProcessFlagName=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var noLoader=arguments.length <= 2 || arguments[2] === undefined?false:arguments[2];return function(dispatch){var apiArguments={data:{packageId:packageId},noLoader:noLoader};if(usersProcessFlagName){apiArguments.data.usersProcessFlagName = usersProcessFlagName;}else {apiArguments.data.usersProcessFlagName = _stateConstants2['default'].USERS_PROCESS_FLAG_DEFAULT;}return dispatch((0,_api.apiCall)('/api/executeFullDSDocumentWizard',apiArguments)).then(function(resultOfAPICall){if(!resultOfAPICall || resultOfAPICall.msg == "ERROR"){return Promise.reject(resultOfAPICall);}return dispatch(getDsDocsAndPackages(true,true,null,null,true)).then(function(){return resultOfAPICall;})['catch'](function(err){return resultOfAPICall;});})['catch'](function(err){return dispatch(getDsDocsAndPackages(true,true,null,null,true)).then(function(){return Promise.reject(err);})['catch'](function(err){ //dispatch(setNotification(translate('thereWasAnErrorWhenCreatePackage') + JSON.stringify(err), 'error'))
	return Promise.reject(err);});});};};exports.executeFullDSDocumentWizardOnServer = executeFullDSDocumentWizardOnServer; /**
	 * Set setDSWizard opened or close
	 * @param {bool} name
	 */var setDSWizard=function setDSWizard(DSWizardOpened){var moduleKey=arguments.length <= 1 || arguments[1] === undefined?'':arguments[1];var mifidKey=arguments.length <= 2 || arguments[2] === undefined?'':arguments[2];return {type:_stateConstants2['default'].SET_DS_WIZARD,DSWizardOpened:DSWizardOpened,moduleKey:moduleKey,mifidKey:mifidKey};};exports.setDSWizard = setDSWizard; /**
	 * Set setOpenInvitationEditor opened or close
	 * @param {bool} name
	 */var setOpenInvitationEditor=function setOpenInvitationEditor(forceOpenInvitationEditor){var moduleKey=arguments.length <= 1 || arguments[1] === undefined?'':arguments[1];return {type:_stateConstants2['default'].SET_DS_INVITATION_EDITOR,forceOpenInvitationEditor:forceOpenInvitationEditor,moduleKey:moduleKey};};exports.setOpenInvitationEditor = setOpenInvitationEditor; /**
	 * Set forceOpenInvitationFromTicket opened or close
	 * @param {bool} name
	 */var setOpenInvitationEditorFromTicket=function setOpenInvitationEditorFromTicket(forceOpenInvitationFromTicket){var moduleKey=arguments.length <= 1 || arguments[1] === undefined?'':arguments[1];return {type:_stateConstants2['default'].SET_DS_INVITATION_EDITOR_FROM_TICKET,forceOpenInvitationFromTicket:forceOpenInvitationFromTicket,moduleKey:moduleKey};};exports.setOpenInvitationEditorFromTicket = setOpenInvitationEditorFromTicket; /**
	 * Will send an reminder to client
	 */var resendClientRemainder=function resendClientRemainder(packageId){var stakeholderId=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];return function(dispatch){return dispatch((0,_api.apiCall)('/api/resendClientRemainder',{data:{packageId:packageId,stakeholderId:stakeholderId}}))['catch'](function(err){console.warn(err);return err;});};};exports.resendClientRemainder = resendClientRemainder; /**
	 * Generate PDF and return the lin toward it.
	 * @param {*} data
	 */var getHalfFilledPdfForPrint=function getHalfFilledPdfForPrint(dsdocumentId){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getHalfFilledPdfForPrint',{dsdocumentId:dsdocumentId}));};};exports.getHalfFilledPdfForPrint = getHalfFilledPdfForPrint; /**
	 * Generate PDF and return the lin toward it.
	 * @param {*} data
	 */var getFilledPrintablePdfDocument=function getFilledPrintablePdfDocument(documentId){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getFilledPrintablePdfDocument',{printableDocumentId:documentId}));};};exports.getFilledPrintablePdfDocument = getFilledPrintablePdfDocument; /**
	 * Get updatable Packages List by API request
	 * @param {*} data
	 */var getUpdatablePackagesList=function getUpdatablePackagesList(){return function(dispatch){return dispatch((0,_api.apiCall)('/api/getUpdatablePackagesList',{data:{}}));};};exports.getUpdatablePackagesList = getUpdatablePackagesList; /**
	 * Update Packages List by API request
	 * @param {*} data
	 */var updatePackagesFromConnective=function updatePackagesFromConnective(idList){return function(dispatch){return dispatch((0,_api.apiCall)('/api/updatePackagesFromConnective',{data:{idList:idList},noLoader:true}));};};exports.updatePackagesFromConnective = updatePackagesFromConnective; /**
	 * Update Packages List by API request
	 * @param {*} data
	 */var uploadDocumentIfItIsSigned=function uploadDocumentIfItIsSigned(packageId,documentId){return function(dispatch){return dispatch((0,_api.apiCall)('/api/uploadDocumentIfItIsSigned',{data:{packageId:packageId,documentId:documentId},noLoader:false}))['catch'](function(err){return Promise.resolve(err);});};};exports.uploadDocumentIfItIsSigned = uploadDocumentIfItIsSigned; /**
	 * Update Packages List by API request
	 * @param {*} data
	 */var uploadReadyDocuments=function uploadReadyDocuments(packageId){return function(dispatch){return dispatch((0,_api.apiCall)('/api/uploadReadyDocuments',{data:{packageId:packageId},noLoader:false}))['catch'](function(err){return Promise.resolve(err);});};};exports.uploadReadyDocuments = uploadReadyDocuments; /************************************************************
	 * End of DSDocuments
	 */ /************************************************************
	 * START Actions for emailServer *
	 ******************************/ /**
	  * This function call the save API for email server configs
	  * @param {object} data - record information, with different props because of security
	  */var saveEmailServer=function saveEmailServer(data){return function(dispatch){return dispatch((0,_api.apiCall)('/api/saveEmailServer',{data:data}))['catch'](function(err){return dispatch(setNotification('Could not save the email server configuration!' + JSON.stringify(err),'error'));});};};exports.saveEmailServer = saveEmailServer; /**
	 * This function call the delete API for email server configs
	 * @param {string} id - the id of the configuration record
	 */var deleteEmailServer=function deleteEmailServer(id){return function(dispatch){return dispatch((0,_api.apiCall)('/api/deleteEmailServer',{data:{id:id}}))['catch'](function(err){return dispatch(setNotification('Could not delete the email server configuration!' + JSON.stringify(err),'error'));});};};exports.deleteEmailServer = deleteEmailServer; /**
	 * This function call the load API for email server configs.
	 * @param {string} emailAddress - must be a valid email address
	 */var loadEmailServer=function loadEmailServer(emailAddress){return function(dispatch){return dispatch((0,_api.apiCall)('/api/loadEmailServer',{data:{emailAddress:emailAddress}})).then(function(result){if(!result || result.error || !result._id){return Promise.reject(null);}result.autotls = _nestedProperty2['default'].get(result,"autotls")?true:false;result.auth_user = _nestedProperty2['default'].get(result,"auth.user");result.auth_password = _nestedProperty2['default'].get(result,"auth.password");result.tls_rejectUnauthorized = _nestedProperty2['default'].get(result,"tls.rejectUnauthorized");return result;}) //.catch((err) => err)
	;};};exports.loadEmailServer = loadEmailServer; /**
	 * Send the form information without saving it, and an email-address to test the settings. The email will be sent immediately.
	 * @param {object} data - the form values (server configurations), and the recipient email-address to test.
	 */var sendTestEmailWithConfig=function sendTestEmailWithConfig(data){return function(dispatch){return dispatch((0,_api.apiCall)('/api/testEmailServer',{data:data}))['catch'](function(err){ // dispatch(setNotification('Could not test the email server configuration!' + JSON.stringify(err), 'error'))
	console.warn("Error output of server response: ",err);return Promise.reject({serverResponse:_extends({},err,{body:err?err.body:null,bodyUsed:err?err.bodyUsed:null,headers:err?err.headers:null,ok:err?err.ok:null,redirected:err?err.redirected:null,status:err?err.status:null,statusText:err?err.statusText:null,type:err?err.type:null,url:err?err.url:null})});});};};exports.sendTestEmailWithConfig = sendTestEmailWithConfig; // following commented code are for testing...
	/* eturn new Promise((resolve, reject)=>{
		let expiredWait = false
		let setExpiredWaitTrue = () => {
			console.log(" FORCE STOP WAITING ")
			expiredWait = true
		}
		setTimeout(setExpiredWaitTrue, 3000)
	
		return waitFor(
			()=> (err && (Object.keys(err).length > 0)) || expiredWait,
			reject({
				serverResponse: JSON.parse(JSON.stringify(err))
			})
		)
	
	})
	
	const waitFor = (condition, callback) => {
	    if(!condition()) {
	        console.log('waiting')
	        setTimeout(waitFor.bind(null, condition, callback), 100)
	    } else {
	        console.log('done')
	        return callback()
	    }
	} */ /* END Actions for emailServer
	 ************************************************************/ /************************************************************
	 * START Actions for emailServer *
	 ******************************/var reportError=function reportError(data){return function(dispatch){return dispatch((0,_api.apiCall)('/browserError',{data:data})).then(function(res){return res;})['catch'](function(err){console.warn("Error output of server response: ",err);});};};exports.reportError = reportError; /*****************************
	 * END Actions for emailServer
	 ****************************/ /**********************************
	 * START Actions for Client Notes *
	 **********************************/var saveClinetNote=function saveClinetNote(data){return function(dispatch){return dispatch((0,_api.apiCall)('/data/saveClientNote',{data:data})).then(function(res){return res;})['catch'](function(err){return dispatch(setNotification('Could not save the clientNote!' + JSON.stringify(err),'error'));});};};exports.saveClinetNote = saveClinetNote;var getClientNote=function getClientNote(data){return function(dispatch){return dispatch((0,_api.apiCall)('/data/getClientNote',{data:data})).then(function(res){return res;})['catch'](function(err){return dispatch(setNotification('Could not get clientNote!' + JSON.stringify(err),'error'));});};};exports.getClientNote = getClientNote;var deleteClientNote=function deleteClientNote(data){return function(dispatch){return dispatch((0,_api.apiCall)('/data/deleteClientNote',{data:data})).then(function(res){return res;})['catch'](function(err){return dispatch(setNotification('Could not delete clientNote!' + JSON.stringify(err),'error'));});};};exports.deleteClientNote = deleteClientNote;var showLoader=function showLoader(){return function(dispatch){dispatch({type:_stateConstants2['default'].SHOW_LOADER});};};exports.showLoader = showLoader;var hideLoader=function hideLoader(){return function(dispatch){dispatch({type:_stateConstants2['default'].HIDE_LOADER});};};exports.hideLoader = hideLoader; /**
	 * API call to update flag for user process from server in store.
	 * This update the store for
	 * @param {string} flagName
	 */var fetchUsersProcessFlag=function fetchUsersProcessFlag(flagName,referenceId){return function(dispatch,getState){var _getState9=getState();var UsersProcessFlag=_getState9.UsersProcessFlag;var currentFlag=_nestedProperty2['default'].get(UsersProcessFlag,referenceId);var isActiveProcess=_nestedProperty2['default'].get(currentFlag,"isActive");return dispatch((0,_api.apiCall)('/api/getUsersProcessFlag',{data:{flagName:flagName,referenceId:referenceId}})).then(function(usersProcessFlagRecord){ // if (usersProcessFlagRecord) {
	// update in store the feched information about the users process flag
	dispatch({type:_stateConstants2['default'].USERS_PROCESS_FLAG_ARRIVED,referenceId:referenceId,record:usersProcessFlagRecord}); // }
	return isActiveProcess;});};};exports.fetchUsersProcessFlag = fetchUsersProcessFlag; /**
	 * Stop to check the server
	 * @param {*} flagName
	 * @param {*} referenceId
	 * @returns
	 */var stopUsersProcessFlagWatch=function stopUsersProcessFlagWatch(flagName,referenceId){return function(dispatch,getState){return dispatch({type:_stateConstants2['default'].USERS_PROCESS_FLAG_STOP_WATCH,referenceId:referenceId});};};exports.stopUsersProcessFlagWatch = stopUsersProcessFlagWatch; /**
	 * Start to check the server after process
	 * @param {String} flagName The name to help to assign the current progress in database
	 * @param {String} referenceId The reference ID (unique) to help to assign the current progress in database
	 * @param {Numeric} checkpointCount the number of the stations of the progress
	 * @returns
	 */var startUsersProcessFlagWatch=function startUsersProcessFlagWatch(flagName,referenceId,checkpointCount){return function(dispatch,getState){return dispatch({type:_stateConstants2['default'].USERS_PROCESS_FLAG_START_WATCH,referenceId:referenceId,checkpointCount:checkpointCount});};};exports.startUsersProcessFlagWatch = startUsersProcessFlagWatch; /**
	 * Remove the process reference from store
	 * @param {*} flagName
	 * @param {*} referenceId
	 * @returns
	 */var removeUsersProcessFlagWatch=function removeUsersProcessFlagWatch(flagName,referenceId){return function(dispatch,getState){return dispatch({type:_stateConstants2['default'].USERS_PROCESS_FLAG_REMOVE,referenceId:referenceId});};};exports.removeUsersProcessFlagWatch = removeUsersProcessFlagWatch; /**
	 * This function do repeated call recursively to check a process status and update it in the redux store.
	 * Can be stopped by dispatching stopUsersProcessFlagWatch
	 * @param {*} flagName
	 * @param {*} referenceId
	 */var doUsersProcessFlagWatch=function doUsersProcessFlagWatch(flagName,referenceId){return function(dispatch,getState){setTimeout(function callee$2$0(){var isActiveProcess;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:context$3$0.next = 2;return regeneratorRuntime.awrap(dispatch(fetchUsersProcessFlag(flagName,referenceId)));case 2:isActiveProcess = context$3$0.sent; // exiting condition from recursive operation
	if(isActiveProcess){dispatch(doUsersProcessFlagWatch(flagName,referenceId));}case 4:case 'end':return context$3$0.stop();}},null,_this);},1000);};};exports.doUsersProcessFlagWatch = doUsersProcessFlagWatch; /**
	 * API call to get image list about a pdf document.
	 * @param {string} dsdocumentId
	 */var getImageListAboutPDF=function getImageListAboutPDF(dsDocumentId){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/documentToImagesInfo/' + dsDocumentId));};};exports.getImageListAboutPDF = getImageListAboutPDF; /* This action can open or close a general information popup from any of the modules.
	 * Th rendering is inserted in the main part of rendering.
	 * @param {*} isOpened
	 * @param {*} msg
	 * @returns
	 */var setVersionCheckNotification=function setVersionCheckNotification(isOpened){var title=arguments.length <= 1 || arguments[1] === undefined?'':arguments[1];var msg=arguments.length <= 2 || arguments[2] === undefined?'':arguments[2];return {type:_stateConstants2['default'].VERSION_CHECK_NOTIFICATION_SET,title:title,msg:msg,isOpened:isOpened};};exports.setVersionCheckNotification = setVersionCheckNotification; /**
	 * API call to get documents size list
	 * @param {array} generatedDocs - optional [templateId, templateId, templateId, ...]
	 * @param {array} oracleDocs - optional [ {oracleDocumentId: <string>, oracleDocumentType: <string>}, ... ]
	 * @param {array} uploadedDocs - optional [temporaryFileRecordId, temporaryFileRecordId, temporaryFileRecordId, ...]
	 * @returns is the same structure as the call arguments but contains a "size prop in plus at the records"
	 */var fetchDsDocumentSizeList=function fetchDsDocumentSizeList(){var generatedDocs=arguments.length <= 0 || arguments[0] === undefined?null:arguments[0];var oracleDocs=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var uploadedDocs=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];return function(dispatch,getState){var data={};if(oracleDocs){data.DS_ORIGIN_ORACLE = oracleDocs;}if(generatedDocs){data.DS_ORIGIN_GENERATED = generatedDocs;}if(uploadedDocs){data.DS_ORIGIN_LOCAL_UPLOAD = uploadedDocs;}return dispatch((0,_api.apiCall)('/utilities/countAssetSizes/',{data:data}));};};exports.fetchDsDocumentSizeList = fetchDsDocumentSizeList; /**
	 *
	 * @param {*} tempFileId
	 * @returns
	 */var removeTemporaryUpload=function removeTemporaryUpload(tempFileId){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/removeTemporaryUpload',{data:{ids:tempFileId}}));};};exports.removeTemporaryUpload = removeTemporaryUpload; /**
	 *
	 * @returns {claimsAvailable: boolean, count: number}
	 */var getDSDocumentTemplateClaimsAvailability=function getDSDocumentTemplateClaimsAvailability(){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/getDSDocumentTemplateClaimsAvailability'));};};exports.getDSDocumentTemplateClaimsAvailability = getDSDocumentTemplateClaimsAvailability; /**
	 *
	 * @returns {claimsAvailable: boolean, count: number}
	 */var recreateDsPackage=function recreateDsPackage(packageId){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/dsSystem/package/' + packageId + '/recreate'));};};exports.recreateDsPackage = recreateDsPackage; /**
	 *
	 * @returns {pckage: obj}
	 */var handlePackageAfterPrint=function handlePackageAfterPrint(packageId){return function(dispatch,getState){return dispatch((0,_api.apiCall)('/api/dsSystem/package/' + packageId + '/handlePackageAfterPrint'));};};exports.handlePackageAfterPrint = handlePackageAfterPrint; /**********************************
	 * START Actions for search Broker info *
	 **********************************/var getBrokerInfo=function getBrokerInfo(brokerNumber){return function callee$1$0(dispatch,getState){var res,brokersCopy,accountManagers;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getBrokerInfo',{data:{brokerNumber:brokerNumber}})));case 3:res = context$2$0.sent;if(!(res && res.brokerNumber)){context$2$0.next = 22;break;}context$2$0.t0 = res.main.language;context$2$0.next = context$2$0.t0 === '1'?8:context$2$0.t0 === '2'?10:context$2$0.t0 === '3'?12:14;break;case 8:res.main.language = 'nl';return context$2$0.abrupt('break',16);case 10:res.main.language = 'fr';return context$2$0.abrupt('break',16);case 12:res.main.language = 'en';return context$2$0.abrupt('break',16);case 14:res.main.language = 'nl';return context$2$0.abrupt('break',16);case 16:brokersCopy = _extends({},getState().office.brokers);accountManagers = _extends({},getState().office.accountManagers);brokersCopy[res.brokerNumber] = res;dispatch(setOfficeData(brokersCopy,accountManagers));dispatch(setBrNr(res.brokerNumber));return context$2$0.abrupt('return',res);case 22:context$2$0.next = 29;break;case 24:context$2$0.prev = 24;context$2$0.t1 = context$2$0['catch'](0);dispatch(setBrNr(''));console.warn('Error calling getBrokerInfo: ',context$2$0.t1);return context$2$0.abrupt('return',context$2$0.t1);case 29:case 'end':return context$2$0.stop();}},null,_this,[[0,24]]);};};exports.getBrokerInfo = getBrokerInfo;var createLocalUploadFilesFromAttachments=function createLocalUploadFilesFromAttachments(files){return function callee$1$0(dispatch){var createLocalsResponse;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('api/createLocalUploadFilesFromAttachments',{data:{files:files}})));case 3:createLocalsResponse = context$2$0.sent;return context$2$0.abrupt('return',createLocalsResponse);case 7:context$2$0.prev = 7;context$2$0.t0 = context$2$0['catch'](0);console.warn('create local upload files from template attachments fail: ',context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,7]]);};};exports.createLocalUploadFilesFromAttachments = createLocalUploadFilesFromAttachments; // ================================
	// #region Version 10.0 Digital Claim wizard
	// ================================
	var getProductsAndRisksRequest=function getProductsAndRisksRequest(contractId,claimDate){return function callee$1$0(dispatch){var getProductsAndRisksRes;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getProductsAndRisks',{data:{contractId:contractId,claimDate:claimDate}})));case 3:getProductsAndRisksRes = context$2$0.sent;return context$2$0.abrupt('return',getProductsAndRisksRes);case 7:context$2$0.prev = 7;context$2$0.t0 = context$2$0['catch'](0);console.warn('getProductsAndRisks error ::: ',context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,7]]);};};exports.getProductsAndRisksRequest = getProductsAndRisksRequest;var getDocumentationRequest=function getDocumentationRequest(qualificationNumber,subQualificationNumber){return function callee$1$0(dispatch){var getDocumentationRes;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getDocumentation',{data:{qualificationNumber:qualificationNumber,subQualificationNumber:subQualificationNumber}})));case 3:getDocumentationRes = context$2$0.sent;if(getDocumentationRes){dispatch(setDocumentation(getDocumentationRes));}context$2$0.next = 10;break;case 7:context$2$0.prev = 7;context$2$0.t0 = context$2$0['catch'](0);console.warn('getDocumentation error ::: ',context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,7]]);};};exports.getDocumentationRequest = getDocumentationRequest;var setDocumentation=function setDocumentation(_ref3){var documents=_ref3.documents;var involvedParties=_ref3.involvedParties;var optionalParties=_ref3.optionalParties;return function(dispatch){return dispatch({type:_stateConstants2['default'].SET_CLAIM_WIZARD_DOCUMENTATION,documents:documents,involvedParties:involvedParties,optionalParties:optionalParties});};};var getQualificationsRequest=function getQualificationsRequest(branch,contractId,contractIdHist){return function callee$1$0(dispatch){var getQualificationsRes;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getQualifications',{data:{branch:branch,contractId:contractId,contractIdHist:contractIdHist}})));case 3:getQualificationsRes = context$2$0.sent;return context$2$0.abrupt('return',getQualificationsRes);case 7:context$2$0.prev = 7;context$2$0.t0 = context$2$0['catch'](0);console.warn('getQualifications error ::: ',context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 11:case 'end':return context$2$0.stop();}},null,_this,[[0,7]]);};};exports.getQualificationsRequest = getQualificationsRequest;var createClaim=function createClaim(args){return function callee$1$0(dispatch){return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;return context$2$0.abrupt('return',dispatch((0,_api.apiCall)('data/createClaim',{data:_extends({},args)})));case 4:context$2$0.prev = 4;context$2$0.t0 = context$2$0['catch'](0);console.warn('createClaim error ::: ',context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 8:case 'end':return context$2$0.stop();}},null,_this,[[0,4]]);};};exports.createClaim = createClaim; /**
	 * Updates contact parameters for claimWizard step one 
	 * Tese parameters are updated both in Oracle and Mongo
	 * @param {*} args list of arguments defined by client that are alowed to be updated
	 * @returns 
	 */var updateClaimContact=function updateClaimContact(args){return function callee$1$0(dispatch){return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/updateClaimContact',{data:_extends({},args)})));case 3:return context$2$0.abrupt('return',context$2$0.sent);case 6:context$2$0.prev = 6;context$2$0.t0 = context$2$0['catch'](0);console.warn('updateClaimContact error ::: ',context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,6]]);};};exports.updateClaimContact = updateClaimContact; /**
	 * A general update call that will actualizerd the claimWizard package record in mongo only
	 * Usage:
	 * 1.To update dsDocumetPackage list in mongo after creating a new dsPackage in claimWizard
	 * @param {*} args 
	 * @returns 
	 */var updateClaimWizardPackage=function updateClaimWizardPackage(claimWizardPackageId,args){return function callee$1$0(dispatch){var updateResponse;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/updateClaimWizardPackage',{data:{claimWizardPackageId:claimWizardPackageId,argsToUpdate:args}})));case 3:updateResponse = context$2$0.sent;if(!updateResponse){context$2$0.next = 6;break;}return context$2$0.abrupt('return',dispatch(setDocumentsForStepThree(claimWizardPackageId,updateResponse)));case 6:return context$2$0.abrupt('return',updateResponse);case 9:context$2$0.prev = 9;context$2$0.t0 = context$2$0['catch'](0);console.warn('updateClaimWizardPackage error ::: ',context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 13:case 'end':return context$2$0.stop();}},null,_this,[[0,9]]);};};exports.updateClaimWizardPackage = updateClaimWizardPackage;var updateClaimStatus=function updateClaimStatus(args){return function callee$1$0(dispatch){return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/updateClaimStatus',{data:_extends({},args)})));case 3:return context$2$0.abrupt('return',context$2$0.sent);case 6:context$2$0.prev = 6;context$2$0.t0 = context$2$0['catch'](0);console.warn('updateClaimStatus error ::: ',context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,6]]);};};exports.updateClaimStatus = updateClaimStatus;var updateInvolvedParties=function updateInvolvedParties(args){return function callee$1$0(dispatch){return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/updateInvolvedParties',{data:_extends({},args)})));case 3:return context$2$0.abrupt('return',context$2$0.sent);case 6:context$2$0.prev = 6;context$2$0.t0 = context$2$0['catch'](0);console.warn('updateInvolvedParties error ::: ',context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 10:case 'end':return context$2$0.stop();}},null,_this,[[0,6]]);};};exports.updateInvolvedParties = updateInvolvedParties;var getClaimWizardPackage=function getClaimWizardPackage(args){return function callee$1$0(dispatch){var claimDataRes;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getClaimWizardPackage',{data:_extends({},args)})));case 3:claimDataRes = context$2$0.sent;if(claimDataRes){dispatch(setClaimData(claimDataRes));}return context$2$0.abrupt('return',claimDataRes);case 8:context$2$0.prev = 8;context$2$0.t0 = context$2$0['catch'](0);console.warn('getClaimWizardPackage error ::: ',context$2$0.t0);return context$2$0.abrupt('return',null);case 12:case 'end':return context$2$0.stop();}},null,_this,[[0,8]]);};};exports.getClaimWizardPackage = getClaimWizardPackage;var fetchAllClaimWizardPackages=function fetchAllClaimWizardPackages(data){return function callee$1$0(dispatch){var response;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.transactionCall)('/data/claims',{data:(0,_libHelpers.trimObject)(data),noCache:true,noLoader:true})));case 3:response = context$2$0.sent;context$2$0.next = 6;return regeneratorRuntime.awrap(dispatch(setAllClaimWizardPackages(response)));case 6:return context$2$0.abrupt('return',response);case 9:context$2$0.prev = 9;context$2$0.t0 = context$2$0['catch'](0);console.warn('Error fetching all claim wizard packages:',context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 13:case 'end':return context$2$0.stop();}},null,_this,[[0,9]]);};};exports.fetchAllClaimWizardPackages = fetchAllClaimWizardPackages;var initializeClientProfileFromPackage=function initializeClientProfileFromPackage(claimWizardPackages,clientId,formType){return function(dispatch){var clientPackage=claimWizardPackages.find(function(pkg){return pkg.clientId === clientId;});if(clientPackage && clientPackage.clientData){dispatch(initializeProfileForm(clientPackage.clientData,clientId,formType));}else {console.error('Client with ID ' + clientId + ' not found in claimWizardPackages.');}};};exports.initializeClientProfileFromPackage = initializeClientProfileFromPackage; /**
	 * Set claim data after claim creation and claim contact update these will also require to navigate to step 2
	 * When setting initial claim data for existing claim default step will be 1
	 * @param {*} claimData 
	 * @param {*} wizardStep 
	 * @returns 
	 */var setClaimData=function setClaimData(claimData){var wizardStep=arguments.length <= 1 || arguments[1] === undefined?'1':arguments[1];return function(dispatch){return dispatch({type:_stateConstants2['default'].SET_CLAIM_WIZARD_DATA,claimData:claimData});};};var toggleLegalAid=function toggleLegalAid(isLegalAid){return function(dispatch){return dispatch({type:_stateConstants2['default'].TOGGLE_LEGAL_AID,isLegalAid:isLegalAid});};};exports.toggleLegalAid = toggleLegalAid;var resetClaimWizard=function resetClaimWizard(){return function(dispatch){return dispatch({type:_stateConstants2['default'].RESET_CLAIM_WIZARD});};};exports.resetClaimWizard = resetClaimWizard;var setClaimWizardStep=function setClaimWizardStep(wizardStep){return function(dispatch){return dispatch({type:_stateConstants2['default'].SET_CLAIM_WIZARD_STEP,wizardStep:wizardStep});};};exports.setClaimWizardStep = setClaimWizardStep;var addOptionalParty=function addOptionalParty(){return function(dispatch){return dispatch({type:_stateConstants2['default'].ADD_OPTIONAL_PARTY});};};exports.addOptionalParty = addOptionalParty;var updatePartyField=function updatePartyField(value,partyId,field){return function(dispatch){return dispatch({type:_stateConstants2['default'].UPDATE_PARTY_FIELD,partyId:partyId,value:value,field:field});};};exports.updatePartyField = updatePartyField;var removeOptionalParty=function removeOptionalParty(partyId){return function(dispatch){return dispatch({type:_stateConstants2['default'].REMOVE_OPTIONAL_PARTY,partyId:partyId});};};exports.removeOptionalParty = removeOptionalParty;var setDocumentsForStepThree=function setDocumentsForStepThree(claimPackageId,claimWizardPackage){return function callee$1$0(dispatch){var dsDocumentTemplates,claimWizardDocuments,dsDocumentPackages;return regeneratorRuntime.async(function callee$1$0$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('/api/getDSDocumentTemplates',{data:{availableOnModules:['DS_MODULE_CLAIM_WIZARD']}})));case 3:dsDocumentTemplates = context$2$0.sent;context$2$0.next = 6;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getClaimWizardDocuments',{data:{claimPackageId:claimPackageId}})));case 6:claimWizardDocuments = context$2$0.sent;context$2$0.next = 9;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/getClaimWizardDsPackages',{data:{dsPackageIds:claimWizardPackage.dsPackages.map(function(onePackage){return onePackage.dsPackage;})}})));case 9:dsDocumentPackages = context$2$0.sent;return context$2$0.abrupt('return',dispatch({type:_stateConstants2['default'].SET_DOCUMENTS_FOR_STEP_THREE,claimWizardDocuments:claimWizardDocuments,dsDocumentTemplates:dsDocumentTemplates,dsDocumentPackages:dsDocumentPackages}));case 13:context$2$0.prev = 13;context$2$0.t0 = context$2$0['catch'](0);console.warn('setDocumentsForStepThree error ::: ',context$2$0.t0);case 16:case 'end':return context$2$0.stop();}},null,_this,[[0,13]]);};};exports.setDocumentsForStepThree = setDocumentsForStepThree;var setAlternativeDocType=function setAlternativeDocType(alternativeSelectionId,docType){return function(dispatch){return dispatch({type:_stateConstants2['default'].SET_ALTERNATIVE_DOC_TYPE,alternativeSelectionId:alternativeSelectionId,docType:docType});};};exports.setAlternativeDocType = setAlternativeDocType;var addClaimWizardOptionalDocument=function addClaimWizardOptionalDocument(){return function(dispatch){return dispatch({type:_stateConstants2['default'].ADD_OPTIONAL_CLAIM_DOCUMENT});};};exports.addClaimWizardOptionalDocument = addClaimWizardOptionalDocument;var updateClaimWizardOptionalDocument=function updateClaimWizardOptionalDocument(docType,tempId){return function(dispatch){return dispatch({type:_stateConstants2['default'].UPDATE_CLAIM_WIZARD_OPTIONAL_DOCUMENT,docType:docType,tempId:tempId});};};exports.updateClaimWizardOptionalDocument = updateClaimWizardOptionalDocument;var removeClaimWizardOptionalDocument=function removeClaimWizardOptionalDocument(tempId){return function(dispatch){return dispatch({type:_stateConstants2['default'].REMOVE_CLAIM_WIZARD_OPTIONAL_DOCUMENT,tempId:tempId});};};exports.removeClaimWizardOptionalDocument = removeClaimWizardOptionalDocument;var addFilesToClaimWizardState=function addFilesToClaimWizardState(files){return function(dispatch){return dispatch({type:_stateConstants2['default'].ADD_FILES_TO_CLAIM_WIZARD,files:files});};};exports.addFilesToClaimWizardState = addFilesToClaimWizardState;var removeDocumentFileFromClaimWizard=function removeDocumentFileFromClaimWizard(fileId){return function(dispatch){return dispatch({type:_stateConstants2['default'].REMOVE_DOCUMENT_FILE_FROM_CLAIM_WIZARD,fileId:fileId});};};exports.removeDocumentFileFromClaimWizard = removeDocumentFileFromClaimWizard;var uploadClaimWizardDocuments=function uploadClaimWizardDocuments(files,claimId,claimWizardPackageId){return function callee$1$0(dispatch,getState){var _iteratorNormalCompletion13,_didIteratorError13,_iteratorError13,_iterator13,_step13,_ret6;return regeneratorRuntime.async(function callee$1$0$(context$2$0){var _this4=this;while(1) switch(context$2$0.prev = context$2$0.next){case 0:context$2$0.prev = 0;context$2$0.next = 3;return regeneratorRuntime.awrap((function callee$2$0(){var defaultGroupType,createUploadRes,uploadPromises,_loop4,_ret7,allUploadResult;return regeneratorRuntime.async(function callee$2$0$(context$3$0){var _this3=this;while(1) switch(context$3$0.prev = context$3$0.next){case 0:defaultGroupType = '1';context$3$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('api/createUpload',{data:{type:defaultGroupType,claimId:claimId}})));case 3:createUploadRes = context$3$0.sent;if(createUploadRes.uploadId){context$3$0.next = 8;break;}console.warn('uploadClaimWizardDocuments error ::: ',createUploadRes); // if there is an error in create upload create a wizrdError param in the state and add this error for step 3
	dispatch(updateFileUploadStatus(file.fileId,'error',translate('unknownErrorOccurred')));return context$3$0.abrupt('return',{v:{error:translate('unknownErrorOccurred')}});case 8:uploadPromises = [];_iteratorNormalCompletion13 = true;_didIteratorError13 = false;_iteratorError13 = undefined;context$3$0.prev = 12;_loop4 = function(){var file=_step13.value;if(file.name){ // if file is from dsPackage skip it
	if(file.dsPackageStatus){return 'continue';} // if file is already uploaded or has an error skip it
	if(file.uploaded || file.error){console.warn('file already uploaded or error ::: ',file);return 'continue';} // create a promise for each file upload
	var oneFilePromise=new Promise(function(resolveFileUpload,rejectFileUpload){var fData=undefined;fData = new FormData();fData.append('uploadId',createUploadRes.uploadId);fData.append('type',file.docType);fData.append('comment',file.name);fData.append('originalFileName',file.name);fData.append('date',(0,_libHelpers.serverDateFormat)(file.lastModified));fData.append('file',file.file);var request=new XMLHttpRequest();request.onreadystatechange = function(){if(request.readyState === 4){ // EXIT POINT status not 200
	if(request.status !== 200){dispatch(updateFileUploadStatus(file.fileId,'failed',translate('unknownErrorOccurred'))); // rejecting promise of this individual upload
	return rejectFileUpload({filetype:type.id,fileId:file.fileId,error:"request.status !== 200"});} // status is 200
	try{var resp=JSON.parse(request.response);var errorFound=_nestedProperty2['default'].get(resp,"success.error") || _nestedProperty2['default'].get(resp,"error");if(errorFound){var statusText=undefined;if(_nestedProperty2['default'].get(resp,"success.error") === "conversionFail"){statusText = translate("unknownErrorOccurred");}else {statusText = _nestedProperty2['default'].get(resp,"success.error") || translate("unknownErrorOccurred") + ": " + _nestedProperty2['default'].get(resp,"message") || translate("unknownErrorOccurred") + ": " + JSON.stringify(request.responseText);}dispatch(updateFileUploadStatus(file.fileId,'failed',statusText)); // rejecting promise of this individual upload
	return rejectFileUpload({filetype:type.id,fileId:file.fileId,error:statusText});}else {dispatch(updateFileUploadStatus(file.fileId,'success')); // resolving promise of this individual upload
	return resolveFileUpload({filetype:file.docType,fileId:file.fileId,response:_nestedProperty2['default'].get(resp,"success")});}}catch(err) {var statusText=_nestedProperty2['default'].get(request,"response.message") || JSON.stringify(request.responseText);var error={status:'error',data:translate("unknownErrorOccurred") + ": " + statusText};dispatch(updateFileUploadStatus(file.fileId,'error',error.data)); // rejecting promise of this individual upload
	return rejectFileUpload({filetype:file.docType,fileId:file.fileId,error:error});}}};request.open('POST','/api/upload',true);request.setRequestHeader('x-csrf-token',translate('csrfclienttoken'));request.send(fData);}); // collect upload promises
	uploadPromises.push(oneFilePromise);}};_iterator13 = files[Symbol.iterator]();case 15:if(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done){context$3$0.next = 22;break;}_ret7 = _loop4();if(!(_ret7 === 'continue')){context$3$0.next = 19;break;}return context$3$0.abrupt('continue',19);case 19:_iteratorNormalCompletion13 = true;context$3$0.next = 15;break;case 22:context$3$0.next = 28;break;case 24:context$3$0.prev = 24;context$3$0.t0 = context$3$0['catch'](12);_didIteratorError13 = true;_iteratorError13 = context$3$0.t0;case 28:context$3$0.prev = 28;context$3$0.prev = 29;if(!_iteratorNormalCompletion13 && _iterator13['return']){_iterator13['return']();}case 31:context$3$0.prev = 31;if(!_didIteratorError13){context$3$0.next = 34;break;}throw _iteratorError13;case 34:return context$3$0.finish(31);case 35:return context$3$0.finish(28);case 36:allUploadResult = Promise.allSettled(uploadPromises).then(function callee$3$0(results){var _iteratorNormalCompletion14,_didIteratorError14,_iteratorError14,_loop5,_iterator14,_step14;return regeneratorRuntime.async(function callee$3$0$(context$4$0){var _this2=this;while(1) switch(context$4$0.prev = context$4$0.next){case 0:_iteratorNormalCompletion14 = true;_didIteratorError14 = false;_iteratorError14 = undefined;context$4$0.prev = 3;_loop5 = function callee$4$0(){var oneResult,fileData,args,createClaimDocRes;return regeneratorRuntime.async(function callee$4$0$(context$5$0){while(1) switch(context$5$0.prev = context$5$0.next){case 0:oneResult = _step14.value;if(!(oneResult.status === 'fulfilled')){context$5$0.next = 7;break;}fileData = getState().claimWizard.documentFiles.find(function(onFile){return oneResult.value.fileId === onFile.fileId;});args = {name:fileData.name,docType:fileData.docType,mainDocType:fileData.mainDocType,alternativeId:fileData.alternativeId,uploadId:oneResult.value.response.uploadImageId,fileSize:fileData.size,uploaded:fileData.uploaded,claimPackage:claimWizardPackageId};context$5$0.next = 6;return regeneratorRuntime.awrap(dispatch((0,_api.apiCall)('data/createClaimWizardDocument',{data:_extends({},args)})));case 6:createClaimDocRes = context$5$0.sent;case 7:case 'end':return context$5$0.stop();}},null,_this2);};_iterator14 = results[Symbol.iterator]();case 6:if(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done){context$4$0.next = 12;break;}context$4$0.next = 9;return regeneratorRuntime.awrap(_loop5());case 9:_iteratorNormalCompletion14 = true;context$4$0.next = 6;break;case 12:context$4$0.next = 18;break;case 14:context$4$0.prev = 14;context$4$0.t0 = context$4$0['catch'](3);_didIteratorError14 = true;_iteratorError14 = context$4$0.t0;case 18:context$4$0.prev = 18;context$4$0.prev = 19;if(!_iteratorNormalCompletion14 && _iterator14['return']){_iterator14['return']();}case 21:context$4$0.prev = 21;if(!_didIteratorError14){context$4$0.next = 24;break;}throw _iteratorError14;case 24:return context$4$0.finish(21);case 25:return context$4$0.finish(18);case 26:return context$4$0.abrupt('return',results);case 27:case 'end':return context$4$0.stop();}},null,_this3,[[3,14,18,26],[19,,21,25]]);})['catch'](function(err){console.warn("Upload files ",err);return err;});return context$3$0.abrupt('return',{v:allUploadResult});case 38:case 'end':return context$3$0.stop();}},null,_this4,[[12,24,28,36],[29,,31,35]]);})());case 3:_ret6 = context$2$0.sent;if(!(typeof _ret6 === 'object')){context$2$0.next = 6;break;}return context$2$0.abrupt('return',_ret6.v);case 6:context$2$0.next = 12;break;case 8:context$2$0.prev = 8;context$2$0.t0 = context$2$0['catch'](0);console.warn('uploadClaimWizardDocument error ::: ',context$2$0.t0);return context$2$0.abrupt('return',context$2$0.t0);case 12:case 'end':return context$2$0.stop();}},null,_this,[[0,8]]);};};exports.uploadClaimWizardDocuments = uploadClaimWizardDocuments;var updateFileUploadStatus=function updateFileUploadStatus(fileId,status,message){return function(dispatch){return dispatch({type:_stateConstants2['default'].UPDATE_FILE_UPLOAD_STATUS,fileId:fileId,status:status,message:message});};};var setAllClaimWizardPackages=function setAllClaimWizardPackages(claimWizardPackages){return function(dispatch){return dispatch({type:_stateConstants2['default'].SET_ALL_CLAIMWIZARD_PACKAGES,claimWizardPackages:claimWizardPackages});};};exports.setAllClaimWizardPackages = setAllClaimWizardPackages;var clearClaimWizardPackages=function clearClaimWizardPackages(){return function(dispatch){return dispatch({type:_stateConstants2['default'].CLEAR_CLAIM_WIZARD_PACKAGES});};};exports.clearClaimWizardPackages = clearClaimWizardPackages;var claimConfirmation=function claimConfirmation(claimId){return function(dispath){return dispath((0,_api.apiCall)('data/claimConfirmation',{data:{claimId:claimId}}));};};exports.claimConfirmation = claimConfirmation;var updateClaimComment=function updateClaimComment(claimId,comment){return function(dispath){return dispath((0,_api.apiCall)('data/updateClaimComment',{data:{claimId:claimId,comment:comment}}));};};exports.updateClaimComment = updateClaimComment;var setHasSubQualifications=function setHasSubQualifications(hasSubQualifications){return function(dispatch){return dispatch({type:_stateConstants2['default'].SET_CLAIM_WIZARD_SUBQUALIFICATION,hasSubQualifications:hasSubQualifications});};};exports.setHasSubQualifications = setHasSubQualifications;var navigateToClientClaims=function navigateToClientClaims(clientId,claimId,claimNumber){return function(dispatch){dispatch(setAppModule(_stateConstants2['default'].CLIENTS,clientId));dispatch(setClientSubModule('claims',{claimNumber:claimNumber}));dispatch(setOpenedSubmenu(claimId));};};exports.navigateToClientClaims = navigateToClientClaims;var navigateToClientContracts=function navigateToClientContracts(clientId,contractId){return function(dispatch){dispatch(setAppModule(_stateConstants2['default'].CLIENTS,clientId));dispatch(setOpenedSubmenu(contractId));dispatch(setClientSubModule('contracts'));};};exports.navigateToClientContracts = navigateToClientContracts; // #endregion
	// on claim details page, when the claim status is 1 || 8 || 9  for groupType 1 we need to force mandatory documents for wizard and claim
	// if uploadId already got from oracle should start the upload and return
	// else create upload on Oracle
	//determine on witch module must upload the files based on uploadTypeId (selected by dropdown before upload)
	//in this response Ann returns the aml translation number instead of "nl" of "fr" for language so to use it we need to
	// turn it in values we can use so far there are 3 options 1 : Nl 2: FR; 3: EN
	// add this broker data to existing brokers list
	// update list of dsDocumentPackages in store if response is successful
	// get dsDocumentTemplates available on claim wizard
	//  API to return the documents for step 3 storred in the mongo db
	//must have a default group type for create upload when we upload documents from claimWizard
	// create mongo records for uploaded files
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_BIND = __webpack_require__(230);
	
	var FunctionPrototype = Function.prototype;
	var call = FunctionPrototype.call;
	var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
	
	module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call.apply(fn, arguments);
	  };
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	var check = function (it) {
	  return it && it.Math === Math && it;
	};
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	module.exports =
	  // eslint-disable-next-line es/no-global-this -- safe
	  check(typeof globalThis == 'object' && globalThis) ||
	  check(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check(typeof self == 'object' && self) ||
	  check(typeof global == 'object' && global) ||
	  check(typeof this == 'object' && this) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	* @license nested-property https://github.com/cosmosio/nested-property
	*
	* The MIT License (MIT)
	*
	* Copyright (c) 2014-2015 Olivier Scherrer <pode.fr@gmail.com>
	*/
	"use strict";
	
	module.exports = {
	  set: setNestedProperty,
	  get: getNestedProperty,
	  has: hasNestedProperty,
	  hasOwn: function (object, property, options) {
	      return this.has(object, property, options || {own: true});
	  },
	  isIn: isInNestedProperty
	};
	
	/**
	 * Get the property of an object nested in one or more objects
	 * given an object such as a.b.c.d = 5, getNestedProperty(a, "b.c.d") will return 5.
	 * @param {Object} object the object to get the property from
	 * @param {String} property the path to the property as a string
	 * @returns the object or the the property value if found
	 */
	function getNestedProperty(object, property) {
	    if (object && typeof object == "object") {
	        if (typeof property == "string" && property !== "") {
	            var split = property.split(".");
	            return split.reduce(function (obj, prop) {
	                return obj && obj[prop];
	            }, object);
	        } else if (typeof property == "number") {
	            return object[property];
	        } else {
	            return object;
	        }
	    } else {
	        return object;
	    }
	}
	
	/**
	 * Tell if a nested object has a given property (or array a given index)
	 * given an object such as a.b.c.d = 5, hasNestedProperty(a, "b.c.d") will return true.
	 * It also returns true if the property is in the prototype chain.
	 * @param {Object} object the object to get the property from
	 * @param {String} property the path to the property as a string
	 * @param {Object} options:
	 *  - own: set to reject properties from the prototype
	 * @returns true if has (property in object), false otherwise
	 */
	function hasNestedProperty(object, property, options) {
	    options = options || {};
	
	    if (object && typeof object == "object") {
	        if (typeof property == "string" && property !== "") {
	            var split = property.split(".");
	            return split.reduce(function (obj, prop, idx, array) {
	                if (idx == array.length - 1) {
	                    if (options.own) {
	                        return !!(obj && obj.hasOwnProperty(prop));
	                    } else {
	                        return !!(obj !== null && typeof obj == "object" && prop in obj);
	                    }
	                }
	                return obj && obj[prop];
	            }, object);
	        } else if (typeof property == "number") {
	            return property in object;
	        } else {
	            return false;
	        }
	    } else {
	        return false;
	    }
	}
	
	/**
	 * Set the property of an object nested in one or more objects
	 * If the property doesn't exist, it gets created.
	 * @param {Object} object
	 * @param {String} property
	 * @param value the value to set
	 * @returns object if no assignment was made or the value if the assignment was made
	 */
	function setNestedProperty(object, property, value) {
	    if (object && typeof object == "object") {
	        if (typeof property == "string" && property !== "") {
	            var split = property.split(".");
	            return split.reduce(function (obj, prop, idx) {
	                obj[prop] = obj[prop] || {};
	                if (split.length == (idx + 1)) {
	                    obj[prop] = value;
	                }
	                return obj[prop];
	            }, object);
	        } else if (typeof property == "number") {
	            object[property] = value;
	            return object[property];
	        } else {
	            return object;
	        }
	    } else {
	        return object;
	    }
	}
	
	/**
	 * Tell if an object is on the path to a nested property
	 * If the object is on the path, and the path exists, it returns true, and false otherwise.
	 * @param {Object} object to get the nested property from
	 * @param {String} property name of the nested property
	 * @param {Object} objectInPath the object to check
	 * @param {Object} options:
	 *  - validPath: return false if the path is invalid, even if the object is in the path
	 * @returns {boolean} true if the object is on the path
	 */
	function isInNestedProperty(object, property, objectInPath, options) {
	    options = options || {};
	
	    if (object && typeof object == "object") {
	        if (typeof property == "string" && property !== "") {
	            var split = property.split("."),
	                isIn = false,
	                pathExists;
	
	            pathExists = !!split.reduce(function (obj, prop) {
	                isIn = isIn || obj === objectInPath || (!!obj && obj[prop] === objectInPath);
	                return obj && obj[prop];
	            }, object);
	
	            if (options.validPath) {
	                return isIn && pathExists;
	            } else {
	                return isIn;
	            }
	        } else {
	            return false;
	        }
	    } else {
	        return false;
	    }
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = {
	  FORM_SUBMITTED: 'FORM_SUBMITTED',
	  REG_RESULT: 'REG_RESULT',
	  RESET_REG: 'RESET_REG',
	  APP_CHANGED: 'APP_CHANGED',
	  APP_PASSWORD_CHANGED: 'APP_PASSWORD_CHANGED',
	  GOT_NEWS: 'GOT_NEWS',
	  GOT_FLASH: 'GOT_FLASH',
	  ITEM_ZOOMED: 'ITEM_ZOOMED',
	  BRNR_USED: 'BRNR_USED',
	  NEWS_FILTERED: 'NEWS_FILTERED',
	  NEWS_LOADED: 'NEWS_LOADED',
	  GOT_FAQ: 'GOT_FAQ',
	  FAQ_FILTERED: 'FAQ_FILTERED',
	  GOT_LINKS: 'GOT_LINKS',
	  LINKS_FILTERED: 'LINKS_FILTERED',
	  FETCHED_LINKS: 'FETCHED_LINKS',
	  FETCHED_CONTACTS: 'FETCHED_CONTACTS',
	  NEWS_ZOOM_CLOSED: 'NEWS_ZOOM_CLOSED',
	  NEWS_SELECT: 'NEWS_SELECT',
	  GOT_INBOX: 'GOT_INBOX',
	  TICKETS_FILTERED: 'TICKETS_FILTERED',
	  SET_CHECKBOX: 'SET_CHECKBOX',
	  SET_ALL_VISIBLE_CHECKED: 'SET_ALL_VISIBLE_CHECKED',
	  SET_ALL_CHECKED: 'SET_ALL_CHECKED',
	  SET_ALL_UNCHECKED: 'SET_ALL_UNCHECKED',
	  SET_APP_MODULE: 'SET_APP_MODULE',
	  TOGGLE_MENU: 'TOGGLE_MENU',
	  TOGGLE_SUB_MENU: 'TOGGLE_SUB_MENU',
	  MEDIA_CHANGED: 'MEDIA_CHANGED',
	  LOG_IN: 'LOG_IN',
	  LOGGED_OUT: 'LOGGED_OUT',
	  SHOW_LOADER: 'SHOW_LOADER',
	  HIDE_LOADER: 'HIDE_LOADER',
	  FORCE_SET_LOADER: 'FORCE_SET_LOADER',
	  GOT_FINANCES: 'GOT_FINANCES',
	  FETCHED_OFFICE_FINANCES: 'FETCHED_OFFICE_FINANCES',
	  BAD_CREDENTIALS: 'BAD_CREDENTIALS',
	  AUTH_STATE_CHANGED: 'AUTH_STATE_CHANGED',
	  HAS_ERRORS: 'HAS_ERRORS',
	  LANG_SET: 'LANG_SET',
	  SHOW_UPLOAD_MODAL: 'SHOW_UPLOAD_MODAL',
	  HIDE_UPLOAD_MODAL: 'HIDE_UPLOAD_MODAL',
	  GO_TO_FILE_FORM: 'GO_TO_FILE_FORM',
	  GO_BACK_TO_UPLOAD_TYPE: 'GO_BACK_TO_UPLOAD_TYPE',
	  CANCEL_UPLOAD: 'CANCEL_UPLOAD',
	  ALLOCATE_FILE: 'ALLOCATE_FILE',
	  UN_ALLOCATE_FILE: 'UN_ALLOCATE_FILE',
	  ADD_FILES: 'ADD_FILES',
	  UPLOAD_FILES: 'UPLOAD_FILES',
	  UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
	  START_UPLOAD: 'START_UPLOAD',
	  SET_UPLOAD_DICT: 'SET_UPLOAD_DICT',
	  SET_GENERAL: 'SET_GENERAL',
	  SET_OFFICE_SUB_MODULE: 'SET_OFFICE_SUB_MODULE',
	  SET_OFFICE_DATA: 'SET_OFFICE_DATA',
	  UPDATE_OFFICE_DATA: 'UPDATE_OFFICE_DATA',
	  CHANGE_FILE_DATE: 'CHANGE_FILE_DATE',
	  REMOVE_FILE: 'REMOVE_FILE',
	  GET_UPLOADS: 'GET_UPLOADS',
	  CLIENT_DOC_UPDATE_BEM_COMMENT: 'CLIENT_DOC_UPDATE_BEM_COMMENT',
	  CLIENT_FILE_DOC_UPDATE_BEM_COMMENT: 'CLIENT_FILE_DOC_UPDATE_BEM_COMMENT',
	  TARIFICATION_DOC_UPDATE_BEM_COMMENT: 'TARIFICATION_DOC_UPDATE_BEM_COMMENT',
	  CONTRACT_DOCUMENT_DOC_UPDATE_BEM_COMMENT: 'CONTRACT_DOCUMENT_DOC_UPDATE_BEM_COMMENT',
	  CONTRACT_FILE_DOC_UPDATE_BEM_COMMENT: 'CONTRACT_FILE_DOC_UPDATE_BEM_COMMENT',
	  CLAIM_DOCUMENT_DOC_UPDATE_BEM_COMMENT: 'CLAIM_DOCUMENT_DOC_UPDATE_BEM_COMMENT',
	  CLAIM_FILE_DOC_UPDATE_BEM_COMMENT: 'CLAIM_FILE_DOC_UPDATE_BEM_COMMENT',
	  UPDATE_UPLOAD_COMMENT: 'UPDATE_UPLOAD_COMMENT',
	  INBOX: 'INBOX',
	  OUTBOX: 'OUTBOX',
	  AGENDA: 'AGENDA',
	  CLIENTS: 'CLIENTS',
	  LINKS: 'LINKS',
	  PRODUCTION: 'PRODUCTION',
	  B2B: 'B2B',
	  INSURANCE_COMPANY: 'INSURANCE_COMPANY',
	  PVVERZEKERINGENCVBA: 'insuranceCompany2320',
	  GENERALIBELGIUM: 'insuranceCompany2321',
	  CLAIMS: 'CLAIMS',
	  CONTRACTS: 'CONTRACTS',
	  PROFILE: 'PROFILE',
	  WILLDOC: 'WILLDOC',
	  OFFICE: 'OFFICE',
	  METRO: 'METRO',
	  NOT_FOUND: 'NOT_FOUND',
	  SET_EMAIL_DOCUMENT_ID: 'SET_EMAIL_DOCUMENT_ID',
	  EMAILDOCUMENT: 'EMAILDOCUMENT',
	  NEWS: 'NEWS',
	  LOGIN: 'LOGIN',
	  FAQ: 'FAQ',
	  WEBAPPS: 'WEBAPPS',
	  PRIVACY: 'PRIVACY',
	  SHOW_CONTACT_MODAL: 'SHOW_CONTACT_MODAL',
	  HIDE_CONTACT_MODAL: 'HIDE_CONTACT_MODAL',
	  ZOOM_CONTACT: 'ZOOM_CONTACT',
	  CLOSE_CONTACT: 'CLOSE_CONTACT',
	  CLAIMS: 'CLAIMS',
	  SET_CLAIMS_DATA: 'SET_CLAIMS_DATA',
	  SET_CLIENTS_DATA: 'SET_CLIENTS_DATA',
	  SET_CLIENT_SUB_MODULE: 'SET_CLIENT_SUB_MODULE',
	  SET_CLIENT_DATA: 'SET_CLIENT_DATA',
	  SET_CLIENT_OPTIONS_DICT: 'SET_CLIENT_OPTIONS_DICT',
	  SET_CLIENT_CREATE_CONTRACT_STATE: 'SET_CLIENT_CREATE_CONTRACT_STATE',
	  INITIALIZE_CLIENT_PROFILE_FORM: 'INITIALIZE_CLIENT_PROFILE_FORM',
	  FETCH_CLIENTS_CLIENT_PROFILE_FORM: 'FETCH_CLIENTS_CLIENT_PROFILE_FORM',
	  FETCH_CLIENT_CLIENT_PROFILE_FORM: 'FETCH_CLIENT_CLIENT_PROFILE_FORM',
	  TOGGLE_MODAL_CLIENT_PROFILE_FORM: 'TOGGLE_MODAL_CLIENT_PROFILE_FORM',
	  TOGGLE_LIST_DEFAULT_CLIENT_PROFILE_FORM: 'TOGGLE_LIST_DEFAULT_CLIENT_PROFILE_FORM',
	  CLEAN_CLIENT_PROFILE_FORM: 'CLEAN_CLIENT_PROFILE_FORM',
	  SET_PROFILE_FORM_CHECKBOX: 'SET_PROFILE_FORM_CHECKBOX',
	  CLEAN_PROFILE_FORM_CHECKBOX: 'CLEAN_PROFILE_FORM_CHECKBOX',
	  UPDATE_CLIENT_PROFILE_RESULT: 'UPDATE_CLIENT_PROFILE_RESULT',
	  FETCH_RELATION_CLIENT_PROFILE_FORM: 'FETCH_RELATION_CLIENT_PROFILE_FORM',
	  SENT_TO_FALSE_CLIENT_PROFILE_FORM: 'SENT_TO_FALSE_CLIENT_PROFILE_FORM',
	  CLIENT_LOAD_CLAIMS_EXTRA: 'CLIENT_LOAD_CLAIMS_EXTRA',
	  FETCHED_CLIENT_FINANCES: 'FETCHED_CLIENT_FINANCES',
	  FILTER_ITEMS: 'FILTER_ITEMS',
	  FETCHED_CLIENT_CLAIMS: 'FETCHED_CLIENT_CLAIMS',
	  SUBMENU_ITEM_ZOOMED: 'SUBMENU_ITEM_ZOOMED',
	  FETCHED_CLIENT_CONTRACT: 'FETCHED_CLIENT_CONTRACT',
	  SET_AGENDA_DATA: 'SET_AGENDA_DATA',
	  SET_UPLOAD_ID: 'SET_UPLOAD_ID',
	  UPLOAD_DONE: 'UPLOAD_DONE',
	  UPLOAD_ERROR: 'UPLOAD_ERROR',
	  UPLOAD_CLEAR_ERROR: 'UPLOAD_CLEAR_ERROR',
	  INBOX_ITEMS_STATUS: 'INBOX_ITEMS_STATUS',
	  FETCHED_CLIENT_TARIFICATIONS: 'FETCHED_CLIENT_TARIFICATIONS',
	  FETCHED_CLIENT_TARIFICATION_DATA: 'FETCHED_CLIENT_TARIFICATION_DATA',
	  SET_UNREAD_CHECKED: 'SET_UNREAD_CHECKED',
	  GOT_TRANSLATIONS: 'GOT_TRANSLATIONS',
	  SET_UNREAD_NUM: 'SET_UNREAD_NUM',
	  SET_ITEM_UNREAD: 'SET_ITEM_UNREAD',
	  GOT_OUTBOX: 'GOT_OUTBOX',
	  OUTBOX_ITEMS_STATUS: 'OUTBOX_ITEMS_STATUS',
	  OUTBOX_ITEM_ZOOMED: 'OUTBOX_ITEM_ZOOMED',
	  SET_OUTBOX_SUB_MODULE: 'SET_OUTBOX_SUB_MODULE',
	  OUTBOX_SET_FILTERED: 'OUTBOX_SET_FILTERED',
	  SET_EMAIL_SENDER_MODULE: 'SET_EMAIL_SENDER_MODULE',
	  SHOW_EMAIL_SENDER_MODAL: 'SHOW_EMAIL_SENDER_MODAL',
	  HIDE_EMAIL_SENDER_MODAL: 'HIDE_EMAIL_SENDER_MODAL',
	  SHOW_EMAIL_SENDER_CONF_MODAL: 'SHOW_EMAIL_SENDER_CONF_MODAL',
	  HIDE_EMAIL_SENDER_CONF_MODAL: 'HIDE_EMAIL_SENDER_CONF_MODAL',
	  SHOW_EMAIL_SENDER_ATT_MODAL: 'SHOW_EMAIL_SENDER_ATT_MODAL',
	  HIDE_EMAIL_SENDER_ATT_MODAL: 'HIDE_EMAIL_SENDER_ATT_MODAL',
	  SET_EMAIL_EXTERNAL_ATTACHMENTS: 'SET_EMAIL_EXTERNAL_ATTACHMENTS',
	  SHOW_EMAIL_SERVER_CONFIG_MODAL: 'SHOW_EMAIL_SERVER_CONFIG_MODAL',
	  HIDE_EMAIL_SERVER_CONFIG_MODAL: 'HIDE_EMAIL_SERVER_CONFIG_MODAL',
	  FETCHED_SIGNATURES: 'FETCHED_SIGNATURES',
	  ZOOM_SIGNATURE: 'ZOOM_SIGNATURE',
	  CLOSE_SIGNATURE: 'CLOSE_SIGNATURE',
	  SET_CLIENT: 'SET_CLIENT',
	  SET_FILTER: 'SET_FILTER',
	  SET_CONTRACT_DETAILS: 'SET_CONTRACT_DETAILS',
	  SET_CLIENT_CLAIMS: 'SET_CLIENT_CLAIMS',
	  SET_CLAIM_DETAIL: 'SET_CLAIM_DETAIL',
	  SET_FILTERED: 'SET_FILTERED',
	  SET_IS_IE: 'SET_IS_IE',
	  GOT_WEBAPPS: 'GOT_WEBAPPS',
	  GOT_USERS: 'GOT_USERS',
	  SET_SUBSCRIBERS: 'SET_SUBSCRIBERS',
	  FETCHED_ADMIN_DOCS: 'FETCHED_ADMIN_DOCS',
	  SET_ADMIN_DICT: 'SET_ADMIN_DICT',
	  COOKIES_ACCEPTED: 'COOKIES_ACCEPTED',
	  COOKIES_CLEAN: 'COOKIES_CLEAN',
	  NOTIFICATION_SET: 'NOTIFICATION_SET',
	  NOTIFICATION_CLEAR: 'NOTIFICATION_CLEAR',
	  WEBAPPS: 'WEBAPPS',
	  SET_PASSWORD: 'SET_PASSWORD',
	  SET_B2B_INSURANCE_COMPANY: 'SET_B2B_INSURANCE_COMPANY',
	  SET_B2BCOMPANY_BROKERS_DATA: 'SET_B2BCOMPANY_BROKERS_DATA',
	  SET_B2BCOMPANY_SUB_MODULE: 'SET_B2BCOMPANY_SUB_MODULE',
	  B2BCOMPANY_BRNR_USED: 'B2BCOMPANY_BRNR_USED',
	  SET_B2BCOMPANY_CLIENTS_DATA: 'SET_B2BCOMPANY_CLIENTS_DATA',
	  B2BCOMPANY_ITEM_ZOOMED: 'B2BCOMPANY_ITEM_ZOOMED',
	  SET_B2BCOMPANY_SELECTED_POLICY: 'SET_B2BCOMPANY_SELECTED_POLICY',
	  SHOW_B2BCOMPANY_POLICY_MODAL: 'SHOW_B2BCOMPANY_POLICY_MODAL',
	  HIDE_B2BCOMPANY_POLICY_MODAL: 'HIDE_B2BCOMPANY_POLICY_MODAL',
	  B2BCOMPANY_GET_ACTIONS: 'B2BCOMPANY_GET_ACTIONS',
	  B2BCOMPANY_SWITCH_ACTION: 'B2BCOMPANY_SWITCH_ACTION',
	  B2BCOMPANY_FETCHED_POLICIES: 'B2BCOMPANY_FETCHED_POLICIES',
	  B2BCOMPANY_CLIENT_ACTION_USED: 'B2BCOMPANY_CLIENT_ACTION_USED',
	  B2BCOMPANY_CLIENT_SUB_ACTION_USED: 'B2BCOMPANY_CLIENT_SUB_ACTION_USED',
	  B2BCOMPANY_SET_ACTIONS_DICT: 'B2BCOMPANY_SET_ACTIONS_DICT',
	  B2BCOMPANY_SET_TRANSACTION_DETAILS: 'B2BCOMPANY_SET_TRANSACTION_DETAILS',
	  B2BCOMPANY_SET_COMPANY: 'B2BCOMPANY_SET_COMPANY',
	  B2BCOMPANY_SET_TRANSACTIONS: 'B2BCOMPANY_SET_TRANSACTIONS',
	  B2BCOMPANY_SEARCH_BY_CONTRACT_NUMBER: 'B2BCOMPANY_SEARCH_BY_CONTRACT_NUMBER',
	  TASKLIST: 'TASKLIST',
	  TASK_MODULE_LIST_SET: 'TASK_MODULE_LIST_SET',
	  TASK_MODULE_LIST_DEFAULT_COLORS_SET: 'TASK_MODULE_LIST_DEFAULT_COLORS_SET',
	  TASK_MODULE_LIST_USER_COLORS_SET: 'TASK_MODULE_LIST_USER_COLORS_SET',
	  TASK_MODULE_FILTER: 'TASK_MODULE_FILTER',
	  TASK_MODULE_FILTER_CLEAN: 'TASK_MODULE_FILTER_CLEAN',
	  TASK_MODULE_MODAL_TOGGLE: 'TASK_MODULE_MODAL_TOGGLE',
	  TASK_MODULE_MODAL_NOTIFICATION_SET: 'TASK_MODULE_MODAL_NOTIFICATION_SET',
	  TASK_MODULE_MODAL_NAME_MANAGE_TASK: 'TASK_MODULE_MODAL_NAME_MANAGE_TASK',
	  TASK_MODULE_MODAL_NAME_MANAGE_COLORS: 'TASK_MODULE_MODAL_NAME_MANAGE_COLORS',
	  TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER: 'TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER',
	  TASK_MODULE_MODAL_NAME_NOTIFICATION: 'TASK_MODULE_MODAL_NAME_NOTIFICATION',
	  TASK_MODULE_MODAL_NAME_SEND_TASK: 'TASK_MODULE_MODAL_NAME_SEND_TASK',
	  TASK_MODULE_MODAL_NOTIFICATION_RESET: 'TASK_MODULE_MODAL_NOTIFICATION_RESET',
	  TASK_MODULE_FORM_ERROR: 'TASK_MODULE_FORM_ERROR',
	  TASK_MODULE_FORM_CLEAN: 'TASK_MODULE_FORM_CLEAN',
	  TASK_MODULE_FORM_CLEAN_MESSAGE: 'TASK_MODULE_FORM_CLEAN_MESSAGE',
	  TASK_MODULE_FORM_EDIT_SET: 'TASK_MODULE_FORM_EDIT_SET',
	  TASK_MODULE_ITEM_SET_CHECK: 'TASK_MODULE_ITEM_SET_CHECK',
	  TASK_MODULE_ITEM_SET_CHECK_ALL_VISIBLE: 'TASK_MODULE_ITEM_SET_CHECK_ALL_VISIBLE',
	  INBOX_ARCHIVE_SET_STAFF_LIST: 'INBOX_ARCHIVE_SET_STAFF_LIST',
	  INBOX_ARCHIVE_RESET_STAFF_LIST: 'INBOX_ARCHIVE_RESET_STAFF_LIST',
	  INBOX_ARCHIVE_MODAL_TOGGLE: 'INBOX_ARCHIVE_MODAL_TOGGLE',
	  INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS: 'INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS',
	  INBOX_ARCHIVE_CONVERT_TICKET_ERROR: 'INBOX_ARCHIVE_CONVERT_TICKET_ERROR',
	  INBOX_ARCHIVE_CLEAN_SELECTED_ITEMS: 'INBOX_ARCHIVE_CLEAN_SELECTED_ITEMS',
	  SET_APP_NOTIFICATIONS: 'SET_APP_NOTIFICATIONS',
	  TASK_MODULE_ITEM_READED: 'TASK_MODULE_ITEM_READED',
	  GET_CLIENT_ID: 'GET_CLIENT_ID',
	  TASK_CREATOR_MODAL_TOGGLE: 'TASK_CREATOR_MODAL_TOGGLE',
	  TASK_CREATOR_CONVERTION_SUCCESS: 'TASK_CREATOR_CONVERTION_SUCCESS',
	  TASK_CREATOR_CONVERTION_FAIL: 'TASK_CREATOR_CONVERTION_FAIL',
	  CONTRACT_PRE_PROPOSAL: 'CONTRACT_PRE_PROPOSAL',
	  CONTRACT_PRE_MANDATE: 'CONTRACT_PRE_MANDATE',
	  UPLOADER_STATE_NEW_POLICY: 'UPLOADER_STATE_NEW_POLICY',
	  UPLOADER_STATE_NEW_POLICY_ID: '17',
	  UPLOADER_STATE_POLICY_FILE: 'UPLOADER_STATE_POLICY_FILE',
	  UPLOADER_STATE_POLICY_FILE_ID: '2',
	  ACCOUNT_CONFIRMATION: 'ACCOUNT_CONFIRMATION',
	  SET_ACCOUNT_CONFIRMATION_STEP: 'SET_ACCOUNT_CONFIRMATION_STEP',
	  SET_ACCOUNT_CONFIRMATION_HASH: 'SET_ACCOUNT_CONFIRMATION_HASH',
	  CLEAN_ACCOUNT_CONFIRMATION: 'CLEAN_ACCOUNT_CONFIRMATION',
	  SHOW_PRINT_MODAL: 'SHOW_PRINT_MODAL',
	  HIDE_PRINT_MODAL: 'HIDE_PRINT_MODAL',
	  DSDOCUMENTS: 'DSDOCUMENTS',
	  GOT_DSDOCUMENTS: 'GOT_DSDOCUMENTS',
	  GOT_DSDOCUMENT: 'GOT_DSDOCUMENT',
	  DSDOCUMENT_ITEMS_STATUS: 'DSDOCUMENT_ITEMS_STATUS',
	  DSDOCUMENT_ITEM_ZOOMED: 'DSDOCUMENT_ITEM_ZOOMED',
	  DSDOCUMENT_PACKAGE_ZOOMED: 'DSDOCUMENT_PACKAGE_ZOOMED',
	  SET_DSDOCUMENT_SUB_MODULE: 'SET_DSDOCUMENT_SUB_MODULE',
	  DSDOCUMENT_SET_FILTERED: 'DSDOCUMENT_SET_FILTERED',
	  GOT_DS_CONFIG: 'GOT_DS_CONFIG',
	  GOT_DSDATASET: 'GOT_DSDATASET',
	  GOT_DSDOCUMENT_TEMPLATE: 'GOT_DSDOCUMENT_TEMPLATE',
	  GOT_DSPACKAGES: 'GOT_DSPACKAGES',
	  GOT_DSDOCS_AND_PACKAGES: 'GOT_DSDOCS_AND_PACKAGES',
	  GOT_TEAM_SUBGROUPS: 'GOT_TEAM_SUBGROUPS',
	  GOT_PAGINATED_PACKAGES: 'GOT_PAGINATED_PACKAGES',
	  RESET_PAGINATED_DATA: 'RESET_PAGINATED_DATA',
	  DS_INITIALIZED: 'initialized',
	  DS_FILLED_BY_BROKER: 'filledByBroker',
	  DS_GENERATED: 'generated',
	  DS_PACKAGE_CREATED: 'packageCreated',
	  DS_DOCUMENTS_UPLOADED_CONNECTIVE: 'documentsUploadedConnective',
	  DS_PACKAGE_STATUS_DRAFT: 'packageStatusDraft',
	  DS_PACKAGE_STATUS_PENDING: 'packageStatusPending',
	  DS_PACKAGE_STATUS_IN_PROGGRESS: 'packageStatusInProgress',
	  DS_PACKAGE_STATUS_ENDING: 'packageStatusEnding',
	  DS_PACKAGE_STATUS_REJECTED: 'packageStatusRejected',
	  DS_PACKAGE_STATUS_REVOKED: 'packageStatusRevoked',
	  DS_PACKAGE_STATUS_EXPIRED: 'packageStatusExpired',
	  DS_PACKAGE_STATUS_FAILED: 'packageStatusFailed',
	  DS_PACKAGE_STATUS_FINISHED: 'packageStatusFinished',
	  DS_PACKAGE_STATUS_DELETED: 'packageStatusDeleted',
	  DS_DOCUMENTS_DOWNLOADED: 'documentsDownloaded',
	  DS_DOCUMENTS_TRANSFERRED_TO_ORACLE: 'documentsTransferredToOracle',
	  DS_DOCUMENTS_SENT_A_COPY_FOR_CLIENT: 'emailSentWithSignedDocs',
	  DS_DOCUMENTS_ERROR: 'documentError',
	  DS_DOCUMENTS_GENERAL_ERROR: 'generalError',
	  DS_TEAM_LEVEN: 'LEVEN',
	  DS_TEAM_LEVEN_INDEX: '1',
	  DIGITAL_SIGNATURE_SETTINGS: 'DIGITAL_SIGNATURE_SETTINGS',
	  DSWIZARD_STEP_1_COMPOSE_PACKAGE: 'DSWIZARD_STEP_1_COMPOSE_PACKAGE',
	  DSWIZARD_STEP_2_FILL_DOCUMENTS: 'DSWIZARD_STEP_2_FILL_DOCUMENTS',
	  DSWIZARD_STEP_3_BROKER_FILLING: 'DSWIZARD_STEP_3_BROKER_FILLING',
	  DSWIZARD_STEP_4_SEND_TO_CONNECTIVE: 'DSWIZARD_STEP_4_SEND_TO_CONNECTIVE',
	  DSWIZARD_STEP_WAITING: 'DSWIZARD_STEP_WAITING',
	  SET_DS_WIZARD: 'SET_DS_WIZARD',
	  SET_DS_INVITATION_EDITOR: 'SET_DS_INVITATION_EDITOR',
	  SET_DS_INVITATION_EDITOR_FROM_TICKET: 'SET_DS_INVITATION_EDITOR_FROM_TICKET',
	  DS_MODULE_CLIENT_PROFILE: 'DS_MODULE_CLIENT_PROFILE',
	  DS_MODULE_CLIENT_CONTRACT: 'DS_MODULE_CLIENT_CONTRACT',
	  DS_MODULE_CLIENT_CONTRACT_PREM: 'DS_MODULE_CLIENT_CONTRACT_PREM',
	  DS_MODULE_CLIENT_CLAIMS: 'DS_MODULE_CLIENT_CLAIMS',
	  DS_MODULE_CLIENT_TARIFICATION: 'DS_MODULE_CLIENT_TARIFICATION',
	  DS_MODULE_OFFICE: 'DS_MODULE_OFFICE',
	  DS_MODULE_CLAIM_WIZARD: 'DS_MODULE_CLAIM_WIZARD',
	  SET_CLAIM_WIZARD_SUBQUALIFICATION: 'SET_CLAIM_WIZARD_SUBQUALIFICATION',
	  DSDOC_IFRAME_PRE_REF: 'DSDOC_IFRAME_PRE_REF_',
	  DSDOC_PLACEHOLDER_ELEMENT_REF: 'DSDOC_PLACEHOLDER_ELEMENT_REF',
	  CLIENT_TYPE_PERSON: 'CLIENT_TYPE_PERSON',
	  CLIENT_TYPE_COMPANY: 'CLIENT_TYPE_COMPANY',
	  DISABLE_BACKGROUND_PROCESSES: 'DISABLE_BACKGROUND_PROCESSES',
	  NAVIGATE_TO_DSDOCUMENT: 'NAVIGATE_TO_DSDOCUMENT',
	  DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS: 'DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS',
	  DSDOCUMENT_EMAIL_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS: 'DSDOCUMENT_EMAIL_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS',
	  DSDOCUMENT_PHONE_NUMBER_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS: 'DSDOCUMENT_PHONE_NUMBER_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS',
	  USERS_PROCESS_FLAG_ARRIVED: 'USERS_PROCESS_FLAG_ARRIVED',
	  USERS_PROCESS_FLAG_STOP_WATCH: 'USERS_PROCESS_FLAG_STOP_WATCH',
	  USERS_PROCESS_FLAG_START_WATCH: 'USERS_PROCESS_FLAG_START_WATCH',
	  USERS_PROCESS_FLAG_REMOVE: 'USERS_PROCESS_FLAG_REMOVE',
	  USERS_PROCESS_FLAG_DEFAULT: 'USERS_PROCESS_FLAG_DEFAULT',
	  VERSION_CHECK_NOTIFICATION_SET: 'VERSION_CHECK_NOTIFICATION_SET',
	  CLAIM_DOCUMENTS_TAB: 'CLAIM_DOCUMENTS_TAB',
	  CONTRACT_DOCUMENTS_TAB: 'CONTRACT_DOCUMENTS_TAB',
	  TARIFICATION_DOCUMENTS_TAB: 'TARIFICATION_DOCUMENTS_TAB',
	  PROFILE_DOCUMENTS_TAB: 'PROFILE_DOCUMENTS_TAB',
	  TICKET_DOCUMENTS_TAB: 'TICKET_DOCUMENTS_TAB',
	  EMAILER_MODAL_ID_DSWIZARD_STEP_3: 'EMAILER_MODAL_ID_DSWIZARD_STEP_3',
	  EMAILER_MODAL_ID_PACKAGE_DETAILS: 'EMAILER_MODAL_ID_PACKAGE_DETAILS',
	  EMAILER_MODAL_ID_PACKAGE_DETAILS_2: 'EMAILER_MODAL_ID_PACKAGE_DETAILS_2',
	  EMAILER_MODAL_ID_EDIT_EMAIL_OF_PACAKGE: 'EMAILER_MODAL_ID_EDIT_EMAIL_OF_PACAKGE',
	  EMAILER_MODAL_HIDDEN_IN_PACKAGE_DETAILS: 'EMAILER_MODAL_HIDDEN_IN_PACKAGE_DETAILS',
	  EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT: 'EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT',
	  SET_CLAIM_WIZARD_STEP: 'SET_CLAIM_WIZARD_STEP',
	  SET_CLAIM_WIZARD_DATA: 'SET_CLAIM_WIZARD_DATA',
	  SET_ALL_CLAIMWIZARD_PACKAGES: 'SET_ALL_CLAIMWIZARD_PACKAGES',
	  CLEAR_CLAIM_WIZARD_PACKAGES: 'CLEAR_CLAIM_WIZARD_PACKAGES',
	  TOGGLE_LEGAL_AID: 'TOGGLE_LEGAL_AID',
	  SET_CLAIM_WIZARD_DOCUMENTATION: 'SET_CLAIM_WIZARD_DOCUMENTATION',
	  RESET_CLAIM_WIZARD: 'RESET_CLAIM_WIZARD',
	  ADD_OPTIONAL_PARTY: 'ADD_OPTIONAL_PARTY',
	  REMOVE_OPTIONAL_PARTY: 'REMOVE_OPTIONAL_PARTY',
	  UPDATE_PARTY_FIELD: 'UPDATE_PARTY_FIELD',
	  SET_DOCUMENTS_FOR_STEP_THREE: 'SET_DOCUMENTS_FOR_STEP_THREE',
	  SET_ALTERNATIVE_DOC_TYPE: 'SET_ALTERNATIVE_DOC_TYPE',
	  ADD_OPTIONAL_CLAIM_DOCUMENT: 'ADD_OPTIONAL_CLAIM_DOCUMENT',
	  UPDATE_CLAIM_WIZARD_OPTIONAL_DOCUMENT: 'UPDATE_CLAIM_WIZARD_OPTIONAL_DOCUMENT',
	  REMOVE_CLAIM_WIZARD_OPTIONAL_DOCUMENT: 'REMOVE_CLAIM_WIZARD_OPTIONAL_DOCUMENT',
	  ADD_FILES_TO_CLAIM_WIZARD: 'ADD_FILES_TO_CLAIM_WIZARD',
	  REMOVE_DOCUMENT_FILE_FROM_CLAIM_WIZARD: 'REMOVE_DOCUMENT_FILE_FROM_CLAIM_WIZARD',
	  UPDATE_FILE_UPLOAD_STATUS: 'UPDATE_FILE_UPLOAD_STATUS'
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1887)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)(module)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1895)();
	}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	// Detect IE8's incomplete defineProperty implementation
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
	});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2057);
	


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
	
	var _flattenNames = __webpack_require__(2161);
	
	var _flattenNames2 = _interopRequireDefault(_flattenNames);
	
	var _mergeClasses = __webpack_require__(2163);
	
	var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
	
	var _autoprefix = __webpack_require__(2158);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _hover2 = __webpack_require__(2160);
	
	var _hover3 = _interopRequireDefault(_hover2);
	
	var _active = __webpack_require__(2159);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _loop2 = __webpack_require__(2162);
	
	var _loop3 = _interopRequireDefault(_loop2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.hover = _hover3.default;
	exports.handleHover = _hover3.default;
	exports.handleActive = _active2.default;
	exports.loop = _loop3.default;
	var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
	  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    activations[_key - 1] = arguments[_key];
	  }
	
	  var activeNames = (0, _flattenNames2.default)(activations);
	  var merged = (0, _mergeClasses2.default)(classes, activeNames);
	  return (0, _autoprefix2.default)(merged);
	};
	
	exports.default = ReactCSS;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactable = __webpack_require__(2150);
	
	var _reactMotion = __webpack_require__(340);
	
	var _reactCollapse = __webpack_require__(467);
	
	var _reactCollapse2 = _interopRequireDefault(_reactCollapse);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	Object.defineProperty(exports, 'Thead', {
		enumerable: true,
		get: function get() {
			return _reactable.Thead;
		}
	});
	Object.defineProperty(exports, 'Th', {
		enumerable: true,
		get: function get() {
			return _reactable.Th;
		}
	});
	Object.defineProperty(exports, 'Tr', {
		enumerable: true,
		get: function get() {
			return _reactable.Tr;
		}
	});
	Object.defineProperty(exports, 'Td', {
		enumerable: true,
		get: function get() {
			return _reactable.Td;
		}
	});
	
	var _ = (0, _libI18n2['default'])();
	
	var CollapseTdContent = (function (_Component) {
		_inherits(CollapseTdContent, _Component);
	
		_createClass(CollapseTdContent, null, [{
			key: 'propTypes',
			value: {
				innerWidth: _react.PropTypes.number
			},
			enumerable: true
		}]);
	
		function CollapseTdContent(props) {
			_classCallCheck(this, _CollapseTdContent);
	
			_get(Object.getPrototypeOf(_CollapseTdContent.prototype), 'constructor', this).call(this, props);
			this.state = { width: 100 };
		}
	
		_createClass(CollapseTdContent, [{
			key: 'calcWidth',
			value: function calcWidth() {
				var findTr = this.wrapper;
				while (findTr && findTr.tagName !== 'TR') {
					findTr = findTr.parentElement;
				}
				if (findTr) {
					var width = findTr.clientWidth;
					if (this.state.width !== width) {
						this.setState({ width: width });
					}
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.calcWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.innerWidth !== this.props.innerWidth) {
					this.calcWidth();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var _props$isOpened = _props.isOpened;
				var isOpened = _props$isOpened === undefined ? false : _props$isOpened;
				var children = _props.children;
				var width = this.state.width;
	
				return _react2['default'].createElement(
					'div',
					{
						ref: function (el) {
							return _this.wrapper = el;
						},
						className: (0, _classnames2['default'])(_reactableScss2['default'].collapseWrap)
					},
					_react2['default'].createElement(
						_reactMotion.Motion,
						{ style: { d: (0, _reactMotion.spring)(isOpened ? 0 : -90) } },
						function (_ref) {
							var d = _ref.d;
							return _react2['default'].createElement(
								'div',
								{ className: _reactableScss2['default'].arrow, style: { transform: 'rotate(' + d + 'deg)' } },
								' '
							);
						}
					),
					_react2['default'].createElement(
						_reactCollapse2['default'],
						{
							keepCollapsedContent: true,
							isOpened: isOpened,
							onClick: function (ev) {
								return ev.stopPropagation();
							},
							style: { width: width }
						},
						children
					)
				);
			}
		}]);
	
		var _CollapseTdContent = CollapseTdContent;
		CollapseTdContent = (0, _reactRedux.connect)(function (state) {
			return {
				innerWidth: state.responsive.innerWidth
			};
		})(CollapseTdContent) || CollapseTdContent;
		return CollapseTdContent;
	})(_react.Component);
	
	var collapseTd = function collapseTd(_ref2) {
		var column = _ref2.column;
	
		var rest = _objectWithoutProperties(_ref2, ['column']);
	
		return _react2['default'].createElement(
			_reactable.Td,
			{ column: column },
			_react2['default'].createElement(CollapseTdContent, rest)
		);
	};
	
	exports.collapseTd = collapseTd;
	var collapseTdWithClass = function collapseTdWithClass(_ref3) {
		var column = _ref3.column;
		var className = _ref3.className;
	
		var rest = _objectWithoutProperties(_ref3, ['column', 'className']);
	
		return _react2['default'].createElement(
			_reactable.Td,
			{ column: column, className: className },
			_react2['default'].createElement(CollapseTdContent, rest)
		);
	};
	
	exports.collapseTdWithClass = collapseTdWithClass;
	
	var ConnTable = (function (_Component2) {
		_inherits(ConnTable, _Component2);
	
		function ConnTable() {
			_classCallCheck(this, _ConnTable);
	
			_get(Object.getPrototypeOf(_ConnTable.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ConnTable, [{
			key: 'visibleItems',
			value: function visibleItems() {
				return this.table.visibleItems();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props2 = this.props;
				var className = _props2.className;
	
				var rest = _objectWithoutProperties(_props2, ['className']);
	
				// TODO: make reactable reset page when children change, this is a terrible hack
				return _react2['default'].createElement(
					'div',
					{ className: (0, _classnames2['default'])(_reactableScss2['default'].tableContainer, className) },
					_react2['default'].createElement(_reactable.Table, _extends({
						key: this.props.children.toString().length,
						filterPlaceholder: _('filter'),
						ref: function (el) {
							_this2.table = el;
						},
						itemsPerPage: 10,
						topPagination: true,
						bottomPagination: true,
						filterCleanBtn: true
					}, rest))
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				className: _react.PropTypes.string,
				children: _react.PropTypes.node
			},
			enumerable: true
		}]);
	
		var _ConnTable = ConnTable;
		ConnTable = (0, _reactRedux.connect)(function (state) {
			return {
				locale: state.app.lang
			};
		}, null, null, { withRef: true })(ConnTable) || ConnTable;
		return ConnTable;
	})(_react.Component);
	
	var Table = (function (_Component3) {
		_inherits(Table, _Component3);
	
		function Table() {
			_classCallCheck(this, Table);
	
			_get(Object.getPrototypeOf(Table.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Table, [{
			key: 'visibleItems',
			value: function visibleItems() {
				return this.table.getWrappedInstance().visibleItems();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2['default'].createElement(ConnTable, _extends({ ref: function (el) {
						_this3.table = el;
					} }, this.props));
			}
		}]);
	
		return Table;
	})(_react.Component);

	exports.Table = Table;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(98);
	
	var $String = String;
	
	module.exports = function (argument) {
	  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String(argument);
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_BIND = __webpack_require__(230);
	
	var call = Function.prototype.call;
	
	module.exports = NATIVE_BIND ? call.bind(call) : function () {
	  return call.apply(call, arguments);
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(25);
	
	var $String = String;
	var $TypeError = TypeError;
	
	// `Assert: Type(argument) is Object`
	module.exports = function (argument) {
	  if (isObject(argument)) return argument;
	  throw new $TypeError($String(argument) + ' is not an object');
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.6
	  //     https://underscorejs.org
	  //     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.6';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global) ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || (type === 'object' && !!obj);
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  var hasStringTagBug = (
	        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  function ie10IsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key] === true; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = toArray(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = (array && max(array, getLength).length) || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;
	
	})));
	//# sourceMappingURL=underscore-umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTkiIGhlaWdodD0iMTE4IiB2aWV3Qm94PSIwIDAgMTE5IDExOCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDIpIj48cGF0aCBzdHJva2U9IiMwMDMzNjYiIHN0cm9rZS13aWR0aD0iNCIgZD0iTTY5LjkzIDgwLjMybDEwLjYtMTAuNiAzMi44OCAzMi44Ny0xMC42IDEwLjZ6Ii8+PHBhdGggZmlsbD0iIzAwMzM2NiIgZD0iTTYyLjg2IDU5LjY4TDc3IDczLjgzbC0yLjgyIDIuODJMNjAuMDMgNjIuNXoiLz48Y2lyY2xlIGN4PSIzNiIgY3k9IjM2IiByPSIzNiIgc3Ryb2tlPSIjMDAzMzY2IiBzdHJva2Utd2lkdGg9IjQiLz48cGF0aCBzdHJva2U9IiMwMDMzNjYiIHN0cm9rZS13aWR0aD0iNCIgZD0iTTI0LjUgMjQuNWwyMyAyM20wLTIzbC0yMyAyMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjwvc3ZnPgo="

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(329);
	
	var _reactGa = __webpack_require__(212);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _debug = __webpack_require__(708);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _componentsBpostSelectJson = __webpack_require__(309);
	
	var _componentsBpostSelectJson2 = _interopRequireDefault(_componentsBpostSelectJson);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var info = (0, _debug2['default'])('helpers:info');
	
	// @params: files/modelname/item id/filename/originalname[?download]
	var getFileNameAndUrl = function getFileNameAndUrl(type, id, _ref, download) {
	    var filename = _ref.filename;
	    var originalname = _ref.originalname;
	    return {
	        url: '/files/' + type + '/' + id + '/' + filename + '/' + originalname + (download ? '?download' : ''),
	        name: originalname
	    };
	};
	
	exports.getFileNameAndUrl = getFileNameAndUrl;
	// Time & date stuff
	
	var timeSince = function timeSince(date) {
	    var seconds = Math.floor((new Date() - date) / 1000);
	
	    var interval = Math.floor(seconds / 31536000);
	
	    if (interval > 1) {
	        return interval + ' years';
	    }
	    interval = Math.floor(seconds / 2592000);
	    if (interval > 1) {
	        return interval + ' months';
	    }
	    interval = Math.floor(seconds / 86400);
	    if (interval > 1) {
	        return interval + ' days';
	    }
	    interval = Math.floor(seconds / 3600);
	    if (interval > 1) {
	        return interval + ' hours';
	    }
	    interval = Math.floor(seconds / 60);
	    if (interval > 1) {
	        return interval + ' minutes';
	    }
	    return Math.floor(seconds) + ' seconds';
	};
	
	exports.timeSince = timeSince;
	var isValidDate = function isValidDate(d) {
	    if (Object.prototype.toString.call(d) !== "[object Date]") {
	        return false;
	    }
	    return !isNaN(d.getTime());
	};
	
	exports.isValidDate = isValidDate;
	var toDate = function toDate(date) {
	    if (!date) {
	        return false;
	    }
	
	    var theDate = undefined;
	
	    if (typeof date === 'string') {
	        if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d/.test(date)) {
	            theDate = new Date(date);
	        } else {
	            date = date.trim();
	            var parts = undefined;
	            if (date.split('/').length === 3) {
	                parts = date.split('/');
	            } else if (date.split('-').length === 3) {
	                parts = date.split('-');
	            } else if (date.split('.').length === 3) {
	                parts = date.split('.');
	            } else {
	                // no idea of what was sent, return FALSE
	                return false;
	            }
	            if (parts[2].length === 4) {
	                theDate = new Date(parts[2] + '/' + parts[1] + '/' + parts[0]);
	            } else if (parts[0].length === 4) {
	                theDate = new Date(parts[0] + '/' + parts[1] + '/' + parts[2]);
	            } else {
	                // no clear year
	                return false;
	            }
	        }
	    } else if ((0, _lodash.isDate)(date)) {
	        theDate = date;
	    } else {
	        return false;
	    }
	    return theDate;
	};
	
	exports.toDate = toDate;
	/**
	 * This function return with a formatted date like a string if valid,
	 * else give the today date formatted to 'YYYY/MM/DD'
	 * @param {*} date
	 */
	var serverDateFormat = function serverDateFormat(date) {
	    if (!(0, _moment2['default'])(date).isValid()) {
	        return (0, _moment2['default'])().format("YYYY/MM/DD");
	    }
	
	    return (0, _moment2['default'])(date).format("YYYY/MM/DD");
	};
	
	exports.serverDateFormat = serverDateFormat;
	var formatDate = function formatDate(date) {
	    var locale = arguments.length <= 1 || arguments[1] === undefined ? 'eu' : arguments[1];
	
	    var dateToPrettify = toDate(date);
	    if (!dateToPrettify) {
	        return false;
	    }
	    if (locale === 'eu') {
	        return (0, _moment2['default'])(date).format("DD-MM-YYYY");
	    }
	    // default to ISO
	    return (0, _moment2['default'])(date).format("YYYY-MM-DD");
	};
	
	exports.formatDate = formatDate;
	
	var DateFormatter = (function () {
	    function DateFormatter(date) {
	        _classCallCheck(this, DateFormatter);
	
	        this.date = toDate(date);
	    }
	
	    _createClass(DateFormatter, [{
	        key: 'valueOf',
	        value: function valueOf() {
	            return this.date ? this.date.valueOf() : '';
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            return this.date ? formatDate(this.date, 'eu') : '';
	        }
	    }]);
	
	    return DateFormatter;
	})();
	
	var dateFormatter = function dateFormatter(date) {
	    return new DateFormatter(date);
	};
	
	exports.dateFormatter = dateFormatter;
	// Google maps
	
	var initializeMap = function initializeMap(el, lat, lng) {
	    if (!lat || !lng) {
	        info('no latlng');
	        return;
	    }
	    // Map
	
	    __webpack_require__(1665).load(function (google) {
	        var mapOptions = {
	            center: {
	                lat: lat,
	                lng: lng
	            },
	            zoom: 14,
	            zoomControl: true,
	            mapTypeControl: true,
	            scaleControl: true,
	            streetViewControl: true,
	            rotateControl: true,
	            scrollwheel: false,
	            mapTypeId: google.maps.MapTypeId.ROADMAP,
	            // streetViewControl: false,
	            // panControl: false,
	            disableDefaultUI: true
	        };
	
	        // map = new google.maps.Map(document.getElementById("map"), mapOptions);
	        var map = new google.maps.Map(el.get(0), mapOptions);
	        el.addClass('generated');
	
	        var marker = new google.maps.Marker({
	            position: {
	                lat: lat,
	                lng: lng
	            },
	            map: map,
	            title: 'title'
	        });
	
	        marker.setMap(map);
	    });
	};
	
	exports.initializeMap = initializeMap;
	// If the cookie 'name' we are looking for can be found in the string,
	// then the string, which lies between characters 'from' and 'to' (options.from, options.to) will be returned.
	// Returned value will not contain 'from' and 'to'.
	var readCookie = function readCookie(name, options) {
	    if (document.cookie.includes(name)) {
	        var cookie = document.cookie.slice(document.cookie.search(name));
	
	        var startPos = cookie.indexOf(options.from) + 1;
	        var endPos = cookie.indexOf(options.to);
	
	        return cookie.substring(startPos, endPos);
	    }
	    return false;
	};
	
	exports.readCookie = readCookie;
	var fillVersion = function fillVersion($here) {
	    var cp = '© ' + new Date().getFullYear() + ' WILLEMOT NV';
	    var version = ("10.0-159-ge9cd7ea95") || "dev";
	    $here.find('.copyright').text(cp);
	    $here.find('.version').text(version);
	};
	
	exports.fillVersion = fillVersion;
	global.reacts = [];
	var mountReact = function mountReact(domEl, App, attrs) {
	    var React = __webpack_require__(1);
	    var ReactDom = __webpack_require__(45);
	    var cE = React.createElement;
	
	    // ***NOTE*** this leaks unless you unmount again after using it
	    ReactDom.render(cE(App, attrs), domEl);
	    global.reacts.push({
	        el: domEl,
	        unmountFn: function unmountFn() {
	            global.reacts = global.reacts.filter(function (e) {
	                return e !== domEl;
	            });
	            ReactDom.unmountComponentAtNode(domEl);
	        }
	    });
	};
	
	exports.mountReact = mountReact;
	// Create an application
	// Right now only adds store to context
	var makeApp = function makeApp(El) {
	    var React = __webpack_require__(1);
	    var cE = React.createElement;
	
	    var _require = __webpack_require__(4);
	
	    var Provider = _require.Provider;
	
	    var store = __webpack_require__(271);
	
	    var App = function App(props) {
	        return cE(Provider, { store: store }, cE(El, props));
	    };
	
	    return App;
	};
	
	exports.makeApp = makeApp;
	var trimObject = function trimObject(data) {
	    var trimmed = {};
	    for (var prop in data) {
	        if (data[prop] != null) {
	            trimmed[prop] = data[prop].trim();
	        }
	    }
	    return trimmed;
	};
	
	exports.trimObject = trimObject;
	var hasContent = function hasContent(data) {
	    for (var prop in data) {
	        if (data[prop] != null && data[prop] !== '') {
	            return true;
	        }
	    }
	    return false;
	};
	
	exports.hasContent = hasContent;
	// Google Analytics
	var initializeGa = function initializeGa(host) {
	    if (host === 'broker.willemot.be') {
	        return _reactGa2['default'].initialize('UA-70685630-2');
	    } else if (host === 'my.easinsure.be') {
	        return _reactGa2['default'].initialize('UA-70685630-1');
	    }
	    return;
	};
	
	exports.initializeGa = initializeGa;
	// Oracle provided translations handlers
	
	/**
	 * This function give a language code by a language name translated on any language supported.
	 * For example: return nl if input is "Nederlands" or "Néerlandais" or "Nederlands".
	 * @param {string} clientLanguage - the name of the language of the client in supported language.
	 * @param {object} clientOptionsDict - oracle provided language stack
	 * @returns clientLanguageCode - the code of client language "nl", "fr", "en". If no match then "nl".
	 */
	var getTheLanguageCodeByAnyLanguageOnAnyLanguage = function getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguage, clientOptionsDict) {
	    var clientLanguageCode = '';
	    var clientLanguageIndex = '';
	
	    // finding the index in translations of the word in any language.
	    if (clientOptionsDict && clientOptionsDict.TAAL) {
	        var keysForClientOpsDict = Object.keys(clientOptionsDict.TAAL);
	        keysForClientOpsDict.forEach(function (oneKeyOfDict) {
	            var languageDictInThreeLang = clientOptionsDict.TAAL[oneKeyOfDict];
	
	            if (Object.keys(languageDictInThreeLang).length > 0) {
	                var languageCodes = Object.keys(languageDictInThreeLang);
	                languageCodes.forEach(function (code) {
	                    if (clientLanguage.localeCompare(languageDictInThreeLang[code]) === 0) {
	                        clientLanguageIndex = oneKeyOfDict;
	                    }
	                });
	            }
	        });
	    }
	
	    // index of word in translations decide the language code
	    switch (clientLanguageIndex * 1) {
	        case 1:
	            clientLanguageCode = 'nl';
	            break;
	        case 2:
	            clientLanguageCode = 'fr';
	            break;
	        case 3:
	            clientLanguageCode = 'en';
	            break;
	        default:
	            clientLanguageCode = 'nl';
	    }
	
	    return clientLanguageCode;
	};
	
	exports.getTheLanguageCodeByAnyLanguageOnAnyLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage;
	/**
	 * This function give the language name on user language of the client language.
	 * For example: return "Néerlandais" on "fr" if input is "Nederlands" or "Néerlandais" or "Nederlands".
	 * @param {string} clientLanguage - the name of the language of the client in supported language.
	 * @param {object} clientOptionsDict - oracle provided language stack
	 * @param {string} appLanguage - language code
	 * @returns clientLanguageCode - the code of client language "nl", "fr", "en". If no match then "nl".
	 */
	var getTheLanguageOnAppLangByAnyLanguage = function getTheLanguageOnAppLangByAnyLanguage(clientLanguage, clientOptionsDict, appLanguage) {
	    var clientLanguageTranslated = '';
	
	    // finding the translation for current user of the language name
	    if (clientOptionsDict.TAAL) {
	        var keysForClientOpsDict = Object.keys(clientOptionsDict.TAAL);
	        keysForClientOpsDict.forEach(function (oneKeyOfDict) {
	            var languageDictInThreeLang = clientOptionsDict.TAAL[oneKeyOfDict];
	            if (Object.keys(languageDictInThreeLang).length > 0) {
	                var languageCodes = Object.keys(languageDictInThreeLang);
	                languageCodes.forEach(function (code) {
	                    if (clientLanguage.localeCompare(languageDictInThreeLang[code]) === 0) {
	                        clientLanguageTranslated = _nestedProperty2['default'].get(languageDictInThreeLang, appLanguage);
	                    }
	                });
	            }
	        });
	    }
	
	    return clientLanguageTranslated;
	};
	
	exports.getTheLanguageOnAppLangByAnyLanguage = getTheLanguageOnAppLangByAnyLanguage;
	/**
	 * This function give the gender name on user language.
	 * @param {string} genderCode - the code of the gender
	 * @param {object} clientOptionsDict - oracle provided language stack
	 * @param {string} appLanguage - language code
	 * @returns genderTranslated - the translation.
	 */
	var getTheGenderOnAppLangByAnyCode = function getTheGenderOnAppLangByAnyCode(genderCode, clientOptionsDict, appLanguage) {
	    var genderTranslated = genderCode;
	    var genderIndex = 1;
	
	    if (genderCode == 'M') {
	        genderIndex = 1;
	    } else {
	        if (genderCode == 'V' || genderCode == 'F') {
	            genderIndex = 2;
	        }
	    }
	
	    // finding the translation for current user of the language name
	    if (clientOptionsDict.GESLACHT) {
	        genderTranslated = _nestedProperty2['default'].get(clientOptionsDict, "GESLACHT." + genderIndex + "." + appLanguage) || genderCode;
	    }
	
	    return genderTranslated;
	};
	
	exports.getTheGenderOnAppLangByAnyCode = getTheGenderOnAppLangByAnyCode;
	/**
	 * This function find the contractId of of a claim from the contracts of the client
	 * by a contract number from a claim.
	 * @param {object} contracts - all of the client contracts
	 * @param {string} claimContractNumber - the contractNumber of the selected claim
	 * @returns {string} contractId related by the claim, else an empty string if no match of contractNumbers.
	 */
	var findContractIdByContractNumber = function findContractIdByContractNumber(contracts, claimContractNumber) {
	    var matchContractId = '';
	
	    if (contracts && Object.keys(contracts).length > 0 && claimContractNumber) {
	        Object.keys(contracts).forEach(function (oneContractKey) {
	            var oneContract = contracts[oneContractKey];
	
	            // skipping other kind of module properties, only the contract matters
	            if (oneContract && typeof oneContract == 'object' && oneContract.hasOwnProperty('contractNumber') && oneContract.hasOwnProperty('contractId')) {
	                var contractId = _nestedProperty2['default'].get(oneContract, "contractId");
	                var contractNumber = _nestedProperty2['default'].get(oneContract, "contractNumber");
	
	                if (claimContractNumber == contractNumber) {
	                    matchContractId = contractId;
	                }
	            }
	        });
	    }
	
	    return matchContractId;
	};
	
	exports.findContractIdByContractNumber = findContractIdByContractNumber;
	/*
	 * Generate option array based on requested object data
	 * @param Object optionsData
	 * @param String language
	 *
	 * @return array
	 */
	var generateOptionsObject = function generateOptionsObject(optionsData, language) {
	    var optionsArray = [];
	
	    Object.keys(optionsData).map(function (key, index) {
	        optionsArray.push({ value: key, label: optionsData[key][language] });
	    });
	
	    return optionsArray;
	};
	
	/**
	 * This function create a
	 *
	 * @param {object} optionsData
	 */
	var generateGlobalOptionsObject = function generateGlobalOptionsObject(optionsData) {
	    var optionsArray = [];
	
	    Object.keys(optionsData).map(function (key, index) {
	        optionsArray.push({ value: key, label: optionsData[key] });
	    });
	
	    return optionsArray;
	};
	
	exports.generateGlobalOptionsObject = generateGlobalOptionsObject;
	/**
	 * Generates the client dictionaries to have a same place for each dictionary
	 * @param {Object} clientOptionsDict The translate list from state.client.clientOptionsDict
	 * @param {string} language The language of the application - state.app.lang
	 */
	var generateClientDicts = function generateClientDicts(clientOptionsDict, language) {
	    var clientDictionaries = {};
	
	    if (clientOptionsDict == undefined) {
	        return clientDictionaries;
	    }
	
	    clientDictionaries['personType'] = generateOptionsObject(clientOptionsDict.PERSOONSTYPE, language);
	    clientDictionaries['gender'] = generateOptionsObject(clientOptionsDict.GESLACHT, language);
	    clientDictionaries['nationality'] = generateOptionsObject(clientOptionsDict.NATIONALITEIT, language);
	    clientDictionaries['language'] = generateOptionsObject(clientOptionsDict.TAAL, language);
	    clientDictionaries['title'] = generateOptionsObject(clientOptionsDict.AANSPREKING, language);
	    clientDictionaries['licenceCategory'] = generateOptionsObject(clientOptionsDict.RB_CATEGORIE, language);
	    clientDictionaries['relationType'] = generateOptionsObject(clientOptionsDict.HOEDANIGHEID, language);
	    clientDictionaries['country'] = generateOptionsObject(clientOptionsDict.LAND, language);
	    clientDictionaries['legalForm'] = generateOptionsObject(clientOptionsDict.RECHTSVORM, language);
	    clientDictionaries['globalCountry'] = generateGlobalOptionsObject(clientOptionsDict.LAND);
	    clientDictionaries['profession'] = generateOptionsObject(clientOptionsDict.profession, language);
	    clientDictionaries['activSector'] = generateOptionsObject(clientOptionsDict.activSector, language);
	    clientDictionaries['socialStatus'] = generateOptionsObject(clientOptionsDict.socialStatus, language);
	    clientDictionaries['taxStatus'] = generateOptionsObject(clientOptionsDict.taxStatus, language);
	    clientDictionaries['ppp'] = generateOptionsObject(clientOptionsDict.ppp, language);
	    clientDictionaries['birthCountry'] = generateOptionsObject(clientOptionsDict.LAND, language);
	    clientDictionaries['maritalStatus'] = generateOptionsObject(clientOptionsDict.maritalStatus, language);
	    clientDictionaries['involvedParties'] = generateOptionsObject(clientOptionsDict.BTR_SUBTYPE, language);
	    clientDictionaries['documentTypeOptions'] = generateOptionsObject(clientOptionsDict.claim, language);
	    clientDictionaries['birthLocality'] = _componentsBpostSelectJson2['default'].map(function (_ref2) {
	        var zip = _ref2.zip;
	        var city = _ref2.city;
	
	        var search = city.toLowerCase().split(/[^a-z]+/).join('|');
	        return {
	            value: zip + '&' + city,
	            label: zip + ' - ' + city,
	            search: '|' + city + '|' + search
	        };
	    });
	
	    return clientDictionaries;
	};
	
	exports.generateClientDicts = generateClientDicts;
	/**
	 * This function give a language code by a client type name translated on any language supported.
	 * For example: return PERSON if input is "Fysisch persoon" on nl language.
	 * @param {string} clientTypeWord - the name of the language of the client in supported language.
	 * @param {object} clientOptionsDict - oracle provided language stack
	 * @returns clientLanguageCode - the code of client type "PERSON", "COMPANY". If no match then "PERSON".
	 */
	var getTheClientTypeCodeByAnyLanguageOnAnyLanguage = function getTheClientTypeCodeByAnyLanguageOnAnyLanguage(clientTypeWord, clientOptionsDict) {
	    var clientTypeCode = c.CLIENT_TYPE_PERSON;
	    var clientTypeIndex = '';
	    /*  This are the translations provided by oracle each time, from this we find the corect index.
	        First is PERSON second is COMPANY
	    1:
	        en: "Fysisch persoon"
	        fr: "Personne physique"
	        nl: "Fysisch persoon"
	     2:
	        en: "Rechtspersoon"
	        fr: "Personne morale"
	        nl: "Rechtspersoon"
	    */
	
	    // finding the index in translations of the word in any language.
	    if (clientOptionsDict && clientOptionsDict.PERSOONSTYPE) {
	        var keysForClientOpsDict = Object.keys(clientOptionsDict.PERSOONSTYPE);
	        keysForClientOpsDict.forEach(function (oneKeyOfDict) {
	            var languageDictInThreeLang = clientOptionsDict.PERSOONSTYPE[oneKeyOfDict];
	
	            if (Object.keys(languageDictInThreeLang).length > 0) {
	                var languageCodes = Object.keys(languageDictInThreeLang); // nl fr en
	                languageCodes.forEach(function (code) {
	                    if (clientTypeWord.localeCompare(languageDictInThreeLang[code]) === 0) {
	                        clientTypeIndex = oneKeyOfDict;
	                    }
	                });
	            }
	        });
	    }
	
	    // index of word in translations decide the type code
	    switch (clientTypeIndex * 1) {
	        case 1:
	            clientTypeCode = c.CLIENT_TYPE_PERSON;
	            break;
	        case 2:
	            clientTypeCode = c.CLIENT_TYPE_COMPANY;
	            break;
	        default:
	            clientTypeCode = c.CLIENT_TYPE_PERSON;
	    }
	
	    return clientTypeCode;
	};
	
	exports.getTheClientTypeCodeByAnyLanguageOnAnyLanguage = getTheClientTypeCodeByAnyLanguageOnAnyLanguage;
	var trimCharacterFromLeft = function trimCharacterFromLeft(str, ch) {
	    var start = 0,
	        end = str.length;
	
	    while (start < end && str[start] === ch) ++start;
	
	    /* while(end > start && str[end - 1] === ch)
	        --end; */
	
	    return start > 0 || end < str.length ? str.substring(start, end) : str;
	};
	
	exports.trimCharacterFromLeft = trimCharacterFromLeft;
	var canSendInvitation = function canSendInvitation(dsPackage) {
	    var statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed', 'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError', 'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError'];
	    var blocked = false;
	
	    if (dsPackage && dsPackage.statusHistory) {
	        dsPackage.statusHistory.forEach(function (oneStatus) {
	            if (statusBlackList.includes(oneStatus.status)) {
	                blocked = true;
	            }
	        });
	    }
	
	    var packageStatusError = dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked;
	
	    // case fo failed package does not send remainder
	    return !packageStatusError ? true : false;
	};
	
	exports.canSendInvitation = canSendInvitation;
	/**
	 * Converts a string to a boolean
	 * @param {string} string e.g. 'true' or 'false'
	 * @returns {boolean}
	 */
	var stringToBoolean = function stringToBoolean(string) {
	    if (typeof string === 'boolean') return string; // eslint-disable-line curly
	    if (typeof string === 'string') {
	        if (string === 'true') return true; // eslint-disable-line curly
	        if (string === 'false') return false; // eslint-disable-line curly
	    }
	    return false; // Default false value
	};
	exports.stringToBoolean = stringToBoolean;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(28);
	
	module.exports = function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_ARRAY_BUFFER = __webpack_require__(394);
	var DESCRIPTORS = __webpack_require__(14);
	var globalThis = __webpack_require__(9);
	var isCallable = __webpack_require__(28);
	var isObject = __webpack_require__(25);
	var hasOwn = __webpack_require__(29);
	var classof = __webpack_require__(98);
	var tryToString = __webpack_require__(154);
	var createNonEnumerableProperty = __webpack_require__(58);
	var defineBuiltIn = __webpack_require__(40);
	var defineBuiltInAccessor = __webpack_require__(50);
	var isPrototypeOf = __webpack_require__(74);
	var getPrototypeOf = __webpack_require__(84);
	var setPrototypeOf = __webpack_require__(100);
	var wellKnownSymbol = __webpack_require__(27);
	var uid = __webpack_require__(194);
	var InternalStateModule = __webpack_require__(49);
	
	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	var Int8Array = globalThis.Int8Array;
	var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
	var Uint8ClampedArray = globalThis.Uint8ClampedArray;
	var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
	var TypedArray = Int8Array && getPrototypeOf(Int8Array);
	var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
	var ObjectPrototype = Object.prototype;
	var TypeError = globalThis.TypeError;
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
	var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
	// Fixing native typed arrays in Opera Presto crashes the browser, see #595
	var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(globalThis.opera) !== 'Opera';
	var TYPED_ARRAY_TAG_REQUIRED = false;
	var NAME, Constructor, Prototype;
	
	var TypedArrayConstructorsList = {
	  Int8Array: 1,
	  Uint8Array: 1,
	  Uint8ClampedArray: 1,
	  Int16Array: 2,
	  Uint16Array: 2,
	  Int32Array: 4,
	  Uint32Array: 4,
	  Float32Array: 4,
	  Float64Array: 8
	};
	
	var BigIntArrayConstructorsList = {
	  BigInt64Array: 8,
	  BigUint64Array: 8
	};
	
	var isView = function isView(it) {
	  if (!isObject(it)) return false;
	  var klass = classof(it);
	  return klass === 'DataView'
	    || hasOwn(TypedArrayConstructorsList, klass)
	    || hasOwn(BigIntArrayConstructorsList, klass);
	};
	
	var getTypedArrayConstructor = function (it) {
	  var proto = getPrototypeOf(it);
	  if (!isObject(proto)) return;
	  var state = getInternalState(proto);
	  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
	};
	
	var isTypedArray = function (it) {
	  if (!isObject(it)) return false;
	  var klass = classof(it);
	  return hasOwn(TypedArrayConstructorsList, klass)
	    || hasOwn(BigIntArrayConstructorsList, klass);
	};
	
	var aTypedArray = function (it) {
	  if (isTypedArray(it)) return it;
	  throw new TypeError('Target is not a typed array');
	};
	
	var aTypedArrayConstructor = function (C) {
	  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
	  throw new TypeError(tryToString(C) + ' is not a typed array constructor');
	};
	
	var exportTypedArrayMethod = function (KEY, property, forced, options) {
	  if (!DESCRIPTORS) return;
	  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
	    var TypedArrayConstructor = globalThis[ARRAY];
	    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
	      delete TypedArrayConstructor.prototype[KEY];
	    } catch (error) {
	      // old WebKit bug - some methods are non-configurable
	      try {
	        TypedArrayConstructor.prototype[KEY] = property;
	      } catch (error2) { /* empty */ }
	    }
	  }
	  if (!TypedArrayPrototype[KEY] || forced) {
	    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
	      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
	  }
	};
	
	var exportTypedArrayStaticMethod = function (KEY, property, forced) {
	  var ARRAY, TypedArrayConstructor;
	  if (!DESCRIPTORS) return;
	  if (setPrototypeOf) {
	    if (forced) for (ARRAY in TypedArrayConstructorsList) {
	      TypedArrayConstructor = globalThis[ARRAY];
	      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
	        delete TypedArrayConstructor[KEY];
	      } catch (error) { /* empty */ }
	    }
	    if (!TypedArray[KEY] || forced) {
	      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
	      try {
	        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
	      } catch (error) { /* empty */ }
	    } else return;
	  }
	  for (ARRAY in TypedArrayConstructorsList) {
	    TypedArrayConstructor = globalThis[ARRAY];
	    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
	      defineBuiltIn(TypedArrayConstructor, KEY, property);
	    }
	  }
	};
	
	for (NAME in TypedArrayConstructorsList) {
	  Constructor = globalThis[NAME];
	  Prototype = Constructor && Constructor.prototype;
	  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
	  else NATIVE_ARRAY_BUFFER_VIEWS = false;
	}
	
	for (NAME in BigIntArrayConstructorsList) {
	  Constructor = globalThis[NAME];
	  Prototype = Constructor && Constructor.prototype;
	  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
	}
	
	// WebKit bug - typed arrays constructors prototype is Object.prototype
	if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
	  // eslint-disable-next-line no-shadow -- safe
	  TypedArray = function TypedArray() {
	    throw new TypeError('Incorrect invocation');
	  };
	  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
	    if (globalThis[NAME]) setPrototypeOf(globalThis[NAME], TypedArray);
	  }
	}
	
	if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
	  TypedArrayPrototype = TypedArray.prototype;
	  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
	    if (globalThis[NAME]) setPrototypeOf(globalThis[NAME].prototype, TypedArrayPrototype);
	  }
	}
	
	// WebKit bug - one more object in Uint8ClampedArray prototype chain
	if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
	  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
	}
	
	if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
	  TYPED_ARRAY_TAG_REQUIRED = true;
	  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
	    configurable: true,
	    get: function () {
	      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
	    }
	  });
	  for (NAME in TypedArrayConstructorsList) if (globalThis[NAME]) {
	    createNonEnumerableProperty(globalThis[NAME], TYPED_ARRAY_TAG, NAME);
	  }
	}
	
	module.exports = {
	  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
	  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
	  aTypedArray: aTypedArray,
	  aTypedArrayConstructor: aTypedArrayConstructor,
	  exportTypedArrayMethod: exportTypedArrayMethod,
	  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
	  getTypedArrayConstructor: getTypedArrayConstructor,
	  isView: isView,
	  isTypedArray: isTypedArray,
	  TypedArray: TypedArray,
	  TypedArrayPrototype: TypedArrayPrototype
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var shared = __webpack_require__(190);
	var hasOwn = __webpack_require__(29);
	var uid = __webpack_require__(194);
	var NATIVE_SYMBOL = __webpack_require__(193);
	var USE_SYMBOL_AS_UID = __webpack_require__(696);
	
	var Symbol = globalThis.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;
	
	module.exports = function (name) {
	  if (!hasOwn(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
	      ? Symbol[name]
	      : createWellKnownSymbol('Symbol.' + name);
	  } return WellKnownSymbolsStore[name];
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	var documentAll = typeof document == 'object' && document.all;
	
	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll;
	} : function (argument) {
	  return typeof argument == 'function';
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var toObject = __webpack_require__(31);
	
	var hasOwnProperty = uncurryThis({}.hasOwnProperty);
	
	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	module.exports = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var requireObjectCoercible = __webpack_require__(41);
	
	var $Object = Object;
	
	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	module.exports = function (argument) {
	  return $Object(requireObjectCoercible(argument));
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var isCallable = __webpack_require__(28);
	
	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};
	
	module.exports = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toLength = __webpack_require__(76);
	
	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	module.exports = function (obj) {
	  return toLength(obj.length);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(93);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectWrapScss = __webpack_require__(1626);
	
	var _SelectWrapScss2 = _interopRequireDefault(_SelectWrapScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _reactSelect = __webpack_require__(105);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var i18selectWrap = (0, _libI18n2['default'])('selectWrapper');
	var i18claimsZoom = (0, _libI18n2['default'])('claimsZoom');
	
	var selectInFocusWithin = false;
	
	var customCreatableSelectStyles = {
	    control: function control(base, _ref) {
	        var isDisabled = _ref.isDisabled;
	        var isFocused = _ref.isFocused;
	
	        selectInFocusWithin = isFocused;
	        return _extends({}, base, {
	            fontSize: "12px",
	            color: "#000",
	            opacity: isDisabled ? 0.5 : 1,
	            borderRadius: "2px",
	            borderStyle: "solid",
	            borderWidth: "1px",
	            borderColor: isFocused ? "#08c #0099e6 #0099e6" : "#d9d9d9 #ccc #b3b3b3",
	            backgroundColor: isDisabled ? "#F6F6F6" : "#FFFFFF",
	            minHeight: "25px",
	            boxShadow: null,
	            padding: 0,
	            margin: 0,
	            overflow: isFocused ? null : "hidden",
	            "&:focus": {
	                borderColor: "#08c #0099e6 #0099e6"
	            }
	        });
	    },
	    menu: function menu(base) {
	        return _extends({}, base, {
	            borderRadius: 2,
	            hyphens: "auto",
	            marginTop: 0,
	            textAlign: "left",
	            wordWrap: "break-word"
	        });
	    },
	    menuList: function menuList(base) {
	        return _extends({}, base, {
	            padding: 0,
	            verticalAlign: "baseline",
	            fontSize: "12px"
	        });
	    },
	    singleValue: function singleValue(base) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "34px",
	            color: "#333333",
	            fontSize: "12px"
	        });
	    },
	    option: function option(base, state) {
	        return _extends({}, base, {
	            backgroundColor: state.isFocused ? '#f2f9fc' : 'transparent',
	            color: state.isFocused ? '#333' : '#666',
	            "&:hover": {
	                color: '#333',
	                backgroundColor: '#f2f9fc'
	            }
	        });
	    },
	    valueContainer: function valueContainer(base) {
	        return _extends({}, base, {
	            margin: 0,
	            padding: "0px 8px",
	            height: "100%",
	            fontSize: "12px"
	        });
	    },
	    clearIndicator: function clearIndicator(base) {
	        return _extends({}, base, {
	            padding: 0,
	            "& svg": {
	                height: "13px",
	                width: "13px",
	
	                "&:hover": {
	                    color: "#d0021b"
	                }
	            }
	        });
	    },
	    dropdownIndicator: function dropdownIndicator(base) {
	        return _extends({}, base, {
	            marginTop: 0,
	            padding: 0
	        });
	    },
	    placeholder: function placeholder(base) {
	        return _extends({}, base, {
	            overflow: "hidden",
	            textOverflow: "ellipsis"
	        });
	    },
	    multiValueRemove: function multiValueRemove(base) {
	        return _extends({}, base, {
	            borderRadius: "2px 0 0 2px",
	            borderRight: "1px solid rgba(70,178,112, 0.24)",
	            "&:hover": {
	                backgroundColor: '#ddeff7',
	                color: '#0077b3'
	            },
	            "& svg": {
	                height: "10px",
	                width: "10px"
	            }
	        });
	    },
	    indicatorSeparator: function indicatorSeparator(base) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "0",
	            top: 0
	        });
	    },
	    input: function input(base) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: "2px 0 0 0",
	            height: "20px",
	            top: 0,
	            fontSize: '12px',
	            lineHeight: '0.8em',
	            caretColor: 'transparent',
	            width: selectInFocusWithin ? '100%!important' : 'auto',
	            div: {
	                width: selectInFocusWithin ? '100%!important' : 'auto',
	                input: {
	                    width: selectInFocusWithin ? '100%!important' : 'auto'
	                }
	            }
	        });
	    },
	    noOptionsMessage: function noOptionsMessage(base) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            fontSize: '0.78em'
	        });
	    }
	};
	
	function noOptionsMessage(_ref2) {
	    var inputValue = _ref2.inputValue;
	    // eslint-disable-line no-unused-vars
	    return i18claimsZoom('noResultsText');
	}
	
	var DropdownIndicator = function DropdownIndicator(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.DropdownIndicator,
	        props,
	        _react2['default'].createElement(
	            'span',
	            { className: _SelectWrapScss2['default'].downArrowHolder },
	            _react2['default'].createElement('span', { className: _SelectWrapScss2['default'].downArrow })
	        )
	    );
	};
	
	var NoOptionsMessage = function NoOptionsMessage(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.NoOptionsMessage,
	        _extends({}, props, { className: _SelectWrapScss2['default'].noOptionsMessage }),
	        i18selectWrap('noOptions')
	    );
	};
	/**
	 * Base Wrapper for React Select Component
	 * @param {Object} props - react-select@2.4.4 props
	 */
	var ReactSelect = function ReactSelect(props) {
	    return _react2['default'].createElement(_reactSelect2['default'], _extends({}, props, {
	        noOptionsMessage: noOptionsMessage,
	        classNamePrefix: 'select',
	        styles: _extends({}, customCreatableSelectStyles),
	        components: _extends({ DropdownIndicator: DropdownIndicator, NoOptionsMessage: NoOptionsMessage }, props.components)
	    }));
	};
	exports.ReactSelect = ReactSelect;
	ReactSelect.propTypes = {
	    components: _react.PropTypes.object
	};
	
	var SelectWrapper = function SelectWrapper(_ref3) {
	    var value = _ref3.value;
	    var options = _ref3.options;
	    var onBlur = _ref3.onBlur;
	    var onChange = _ref3.onChange;
	
	    var props = _objectWithoutProperties(_ref3, ['value', 'options', 'onBlur', 'onChange']);
	
	    var selectedValue = value;
	    if (typeof selectedValue === 'string') {
	        selectedValue = options.find(function (option) {
	            return option.value === selectedValue;
	        }); // This code enables the select to work with the new react-select
	    }
	    return _react2['default'].createElement(ReactSelect, _extends({
	        placeholder: '',
	        value: selectedValue,
	        options: options,
	        isClearable: false,
	        isSearchable: false,
	        onChange: function (newValue) {
	            return onChange(newValue);
	        },
	        onBlur: function () {
	            return onBlur ? onBlur(selectedValue) : null;
	        }
	    }, props));
	};
	exports.SelectWrapper = SelectWrapper;
	SelectWrapper.propTypes = {
	    value: _react.PropTypes.any,
	    options: _react.PropTypes.array,
	    onBlur: _react.PropTypes.func,
	    onChange: _react.PropTypes.func
	};
	
	var SearchableSelectWrapper = function SearchableSelectWrapper(_ref4) {
	    var value = _ref4.value;
	    var options = _ref4.options;
	    var onBlur = _ref4.onBlur;
	    var onChange = _ref4.onChange;
	
	    var props = _objectWithoutProperties(_ref4, ['value', 'options', 'onBlur', 'onChange']);
	
	    var selectedValue = value;
	    if (typeof selectedValue === 'string') {
	        // This code enables the select to work with the new react-select
	        selectedValue = options.find(function (option) {
	            return option.value === selectedValue;
	        });
	    }
	
	    return _react2['default'].createElement(ReactSelect, _extends({
	        placeholder: '',
	        value: selectedValue,
	        options: options,
	        onChange: function (newValue) {
	            return onChange(newValue);
	        },
	        onBlur: function () {
	            return onBlur ? onBlur(selectedValue) : null;
	        }
	    }, props, {
	        isSearchable: true // Searchable is true by default
	    }));
	};
	exports.SearchableSelectWrapper = SearchableSelectWrapper;
	SearchableSelectWrapper.propTypes = {
	    value: _react.PropTypes.any,
	    options: _react.PropTypes.array,
	    onBlur: _react.PropTypes.func,
	    onChange: _react.PropTypes.func
	};
	
	//this piece of art is here because handleOnBlur doesn't update the state before handleMenuClose reads it
	var forceMenuOpen = false;
	/**
	 * select used for client profile edit BEWB 804 to have a dynamic options list for some fields with one option 
	 * acting as a toggle button to show more or less options
	 */
	
	var SearchableDynamicListSelectWrapper = (function (_Component) {
	    _inherits(SearchableDynamicListSelectWrapper, _Component);
	
	    _createClass(SearchableDynamicListSelectWrapper, null, [{
	        key: 'propTypes',
	        value: {
	            value: _react.PropTypes.any,
	            options: _react.PropTypes.array,
	            onBlur: _react.PropTypes.func,
	            onChange: _react.PropTypes.func,
	            toggleShowFullList: _react.PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function SearchableDynamicListSelectWrapper(props) {
	        _classCallCheck(this, SearchableDynamicListSelectWrapper);
	
	        _get(Object.getPrototypeOf(SearchableDynamicListSelectWrapper.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            menuIsOpen: false,
	            selectedValue: ''
	        };
	    }
	
	    _createClass(SearchableDynamicListSelectWrapper, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props;
	            var value = _props.value;
	            var options = _props.options;
	            var toggleShowFullList = _props.toggleShowFullList;
	
	            if (value) {
	
	                if (typeof value === 'string') {
	                    // This code enables the select to work with the new react-select
	                    var selectedValue = options.some(function (option) {
	                        return option.value === value;
	                    });
	                    if (!selectedValue) {
	                        toggleShowFullList('see_more_results');
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(newVal) {
	            var _props2, onChange, toggleShowFullList, value;
	
	            return regeneratorRuntime.async(function handleChange$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        onChange = _props2.onChange;
	                        toggleShowFullList = _props2.toggleShowFullList;
	                        value = newVal.value;
	
	                        if (!(value === 'see_more_results' || value === 'see_less_results')) {
	                            context$2$0.next = 12;
	                            break;
	                        }
	
	                        toggleShowFullList(value);
	                        forceMenuOpen = true;
	                        context$2$0.next = 9;
	                        return regeneratorRuntime.awrap(this.setState({ menuIsOpen: true }));
	
	                    case 9:
	                        onChange({});
	                        context$2$0.next = 16;
	                        break;
	
	                    case 12:
	                        forceMenuOpen = false;
	                        context$2$0.next = 15;
	                        return regeneratorRuntime.awrap(this.setState({ menuIsOpen: false }));
	
	                    case 15:
	                        onChange(newVal);
	
	                    case 16:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'handleMenuClose',
	        value: function handleMenuClose() {
	            if (forceMenuOpen) {
	                this.setState({ menuIsOpen: true });
	            } else {
	                this.setState({ menuIsOpen: false });
	            }
	        }
	    }, {
	        key: 'handleMenuOpen',
	        value: function handleMenuOpen() {
	            this.setState({ menuIsOpen: true });
	        }
	    }, {
	        key: 'handleOnBlur',
	        value: function handleOnBlur() {
	            var _props3 = this.props;
	            var value = _props3.value;
	            var onBlur = _props3.onBlur;
	            var options = _props3.options;
	
	            forceMenuOpen = false;
	
	            this.setState({ forceMenuOpen: false, menuIsOpen: false }, function () {
	                var selectedValue = value;
	
	                if (typeof selectedValue === 'string') {
	                    // This code enables the select to work with the new react-select
	                    selectedValue = options.find(function (option) {
	                        return option.value === selectedValue;
	                    });
	                }
	                if (onBlur) {
	                    return onBlur(selectedValue);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props4 = this.props;
	            var value = _props4.value;
	            var options = _props4.options;
	            var onBlur = _props4.onBlur;
	            var menuIsOpen = /*selectedValue*/this.state.menuIsOpen;
	
	            var selectedValue = value;
	
	            if (typeof selectedValue === 'string') {
	                // This code enables the select to work with the new react-select
	                selectedValue = options.find(function (option) {
	                    return option.value === selectedValue;
	                });
	            }
	            return _react2['default'].createElement(ReactSelect, {
	                placeholder: '',
	                value: selectedValue,
	                options: options,
	                onChange: function (newValue) {
	                    return _this.handleChange(newValue);
	                },
	                onBlur: function () {
	                    return _this.handleOnBlur();
	                },
	                // {...this.props}
	                isSearchable: true, // Searchable is true by default
	                menuIsOpen: menuIsOpen,
	                onMenuClose: function () {
	                    return _this.handleMenuClose();
	                },
	                onMenuOpen: function () {
	                    return _this.handleMenuOpen();
	                }
	            });
	        }
	    }]);
	
	    return SearchableDynamicListSelectWrapper;
	})(_react.Component);
	
	exports.SearchableDynamicListSelectWrapper = SearchableDynamicListSelectWrapper;
	exports['default'] = SelectWrapper;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__(1925);
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__(468);
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__(1926);
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__(1927);
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Raised = __webpack_require__(1928);
	
	Object.defineProperty(exports, 'Raised', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Raised).default;
	  }
	});
	
	var _Saturation = __webpack_require__(1929);
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(834);
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Swatch = __webpack_require__(1930);
	
	Object.defineProperty(exports, 'Swatch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(28);
	var tryToString = __webpack_require__(154);
	
	var $TypeError = TypeError;
	
	// `Assert: IsCallable(argument) is true`
	module.exports = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw new $TypeError(tryToString(argument) + ' is not a function');
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(28);
	var definePropertyModule = __webpack_require__(42);
	var makeBuiltIn = __webpack_require__(410);
	var defineGlobalProperty = __webpack_require__(401);
	
	module.exports = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;
	    else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];
	      else if (O[key]) simple = true;
	    } catch (error) { /* empty */ }
	    if (simple) O[key] = value;
	    else definePropertyModule.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  } return O;
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isNullOrUndefined = __webpack_require__(64);
	
	var $TypeError = TypeError;
	
	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	module.exports = function (it) {
	  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
	  return it;
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var IE8_DOM_DEFINE = __webpack_require__(665);
	var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(697);
	var anObject = __webpack_require__(20);
	var toPropertyKey = __webpack_require__(133);
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE = 'configurable';
	var WRITABLE = 'writable';
	
	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  } return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = false;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var trunc = __webpack_require__(675);
	
	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	module.exports = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc(number);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1980);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var DOMProperty = __webpack_require__(210);
	var ReactDOMComponentFlags = __webpack_require__(839);
	
	var invariant = __webpack_require__(21);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1718),
	    baseMatchesProperty = __webpack_require__(1719),
	    identity = __webpack_require__(204),
	    isArray = __webpack_require__(30),
	    property = __webpack_require__(1864);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_WEAK_MAP = __webpack_require__(698);
	var globalThis = __webpack_require__(9);
	var isObject = __webpack_require__(25);
	var createNonEnumerableProperty = __webpack_require__(58);
	var hasOwn = __webpack_require__(29);
	var shared = __webpack_require__(423);
	var sharedKey = __webpack_require__(293);
	var hiddenKeys = __webpack_require__(232);
	
	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError = globalThis.TypeError;
	var WeakMap = globalThis.WeakMap;
	var set, get, has;
	
	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};
	
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};
	
	if (NATIVE_WEAK_MAP || shared.state) {
	  var store = shared.state || (shared.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwn(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return hasOwn(it, STATE);
	  };
	}
	
	module.exports = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var makeBuiltIn = __webpack_require__(410);
	var defineProperty = __webpack_require__(42);
	
	module.exports = function (target, name, descriptor) {
	  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
	  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
	  return defineProperty.f(target, name, descriptor);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject = __webpack_require__(185);
	var requireObjectCoercible = __webpack_require__(41);
	
	module.exports = function (it) {
	  return IndexedObject(requireObjectCoercible(it));
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(91);
	var uncurryThis = __webpack_require__(8);
	var IndexedObject = __webpack_require__(185);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var arraySpeciesCreate = __webpack_require__(226);
	
	var push = uncurryThis([].push);
	
	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_MAP = TYPE === 1;
	  var IS_FILTER = TYPE === 2;
	  var IS_SOME = TYPE === 3;
	  var IS_EVERY = TYPE === 4;
	  var IS_FIND_INDEX = TYPE === 6;
	  var IS_FILTER_REJECT = TYPE === 7;
	  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var length = lengthOfArrayLike(self);
	    var boundFunction = bind(callbackfn, that);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push(target, value);      // filter
	        } else switch (TYPE) {
	          case 4: return false;             // every
	          case 7: push(target, value);      // filterReject
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod(7)
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	var toString = uncurryThis({}.toString);
	var stringSlice = uncurryThis(''.slice);
	
	module.exports = function (it) {
	  return stringSlice(toString(it), 8, -1);
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"outboxModule":"_2GPYtK9fL_NdrzEVanaqZO","mainTitleDiv":"_2tuiAe8icI3dK1qzOeNjTc","moduleControls":"Spe0kIuQVNC_gMnNKyiFb","backToList":"luuOVALYzC_ONcPQFh8wc","hidden":"_2kGtZgtS5-tCm1MenYetyS","mainTitleContainer":"_3TyxrMaDWMTDZ4L7hdJ3vK","mainTitle":"s-62qRGsOEpgYhK3zNMEF","results":"_1i1heSsJoFASA_L8d60Edn","datePickerContainer":"_3-IvKQvQDfKXxVp-C8475p","submitContainer":"_3VqoS2b22YbqWa6ijFO95c","inputContainer":"lZ8g1F_rQejGxvyyR3cPl","label":"BcvY9EfDoSwq-rOvUhGQH","inputSubmit":"_2Lokv2ReScRlByHROPj9JV","inputForm":"_3ljBNBhv5lfZz0l95PVZC3","fixDatePickerSize":"_20XzOkXriRxoXrV37VsMU8","selectStyle":"_32NIxklx-D-64ru9FrAR3G","statusFailed":"_2OFPDax9gBCfk-wbrhd19n","statusResent":"x0qxfISAzZ6JQD1XA2p3G","marginBot":"P17jJ3cahclGJCRP5YT4j","status":"_3mfRt0dz3Gv-YIDvCWAOEZ","documentTypeSpan":"_1jwuMsaVf8UyyB6z6SEs3I","documentDescriptionSpan":"aPlhlBr_YJozmfvOrwd3u","buttonContainer":"_2N7uRYltbZYWJsQz55u-Fp","greyButton":"_1uN8fYYidXbYQO_AaIM48l","enabled":"HKRADQ5YuDrOgWEKe-wBx","trFirstColumnHidden":"_2kQdgWK6ChWEujHlpYyRFd","subject":"_2Itsfy1E0U0NDCZHM2AlcI","toEmailAddress":"CeCbE9siPwISXMErAMa87","from":"_1cYlVaFmmLWLpAXstssaex","content":"_1SeH8wQU0S8h6q9rOv2LVH","attachments":"_2uHEZTxJcxiX4Qg95Caex","goToLinkTable":"_1c8zlGQw6nvdm52a-7LEli","documentsModalContent":"VK0mskBYHQGpCq78E5_8m","columnContainer":"RgjGRs9FBJ-mZ-vI5fmKu","oneRowItem":"_1JaawKDBGiLqDP30fMalGZ","autoHeight":"_3UuJGSrD9moXIFaK_X-yvs","whitespacePre":"_30McNiZK79tspY01XDZXj8","modalFormContent":"uTqY_nD-9Z_we7r78ghd4","documentsModalButtons":"_2QiNDyF3Uu5oTiSoAENGFo","cancel":"_208xl5P1Df2AJzRCSaUkSf","greenButton":"_3YoHoWlcy40ZSruluO0Xq8","secondSigner":"_26aBzlj0PrZgBbGlxuY7D0","title":"_2nhtRgaMHyYBctCdrpvl0e","message":"KmjXP1JZytY2IbMOcGV8W","errorMessage":"_1varuaVkknJnDoXvaDUC8M","dsDocumentDescriptionContainer":"_ZBn5ix--bKs_nnFwdktF","contentTitle":"_1H1AqJQaRmVHXrSH6UYrq0","checkIcon":"_3ZFv8fmfvAaz9TVXwCuY3B","editDocumentButton":"_2N29XzP8Ofv1INYLzpkmJD","btnText":"_1Y2EcpImMrTAlJ7QpdbMNg","emptyPrintSpace":"_1h6RMl23I71PLJD6qQiFfh","resendModalContainer":"Zxgo-YVDOcUhkHC7knH-f","packageDocumentContainer":"_1Ta5BBnB4FG5QQOO50Q3I5","packageDocumentDetailRow":"ZSj9Upu22OukZiNUXO8mB","row":"_1OD6gzDXAGIf_6pM_1TRWS","fillButtonContainer":"_2mGrFea9_umnod1N9HLlGZ","alignRight":"_2aYKgxea3X8egOTW_3fjgg","autoWidth":"_1W7aBjzGe3aG_9SK-ZyEZy","operationsRow":"_16ILLGRFsbg1yRs7dvaa-H","removeDocumentBtn":"_39bwIZonau6V7kCYwWuahM","onlyInfo":"_2dP0ZBvonLas7KXJs0ff43","errorMessageContainer":"c6NLkWfav5UCvOPEEGyBc","none":"wxrn8MJOrYsmsEk_FoKBA","textAlignLeft":"_3QnoeAJmTizw41X8Dx-nGi","progress":"_3ltIsd13Qos-hNzS4Zalhv","progressDotsContainer":"OscXUij0CAx04IsyVpLbu","progressDot":"O3o6MeOwJCWnL5UtxmWKd","progressDotInProgress":"_35TgXbJfTmsHMmCSlnWrlg","progressDotFilled":"_3Dq9xJQG-UyNZ7jb2i99VJ","progressLine":"_3BlwN3grWJSoQVLFqo-Q3j","progressText":"_2xFzIBAQAtfFsyHLEGBltY","formInputContainer":"_1H8dbqJEn4rq5yGnhPw37z","noHeight":"_1yT696lryfawKIccnPDLjj","marginBottomS":"GjvakiNwmg4DO2x0kYArs","formLabel":"ieYIQ1ok3iriU5sknDdfu","infoIcon":"_3WUfXz8EbtEt-5KUujZ2G5","infoIconText":"_36T4Bd5v9xgxh_82WJrDko","short1":"_1CMC9yoti4EFk3nJPjxJpl","short2":"_3rZXmh0v0EqOy5CZrJgBpH","short3":"_2EwPoHWSf6YbB8RVhodqsd","short4":"_1j1fxy_rKIMUJGC8gVwIRE","short5":"_6TL2ulGWf5CJvRpihUK1p","short8":"_11oLyXKFTLQmG5C66HPJOU","titleLabel":"wwayzWidfq26j6S8HK0NT","formInput":"_3GQxGBmhwTeNOFI06BDBWC","phoneCode":"_3GceKnV67B4JDHl8-yCTOV","long":"_3HABNS5vZk9kQcMXv521We","shortMargin":"_3FqpxeJwnYRL_--pVnyufn","formInputCreatableSelect":"_13HqbppkR7c1l9ym_ON2SB","sizeS":"_35UdWj8wvb-k0FkTNTJ1iM","sizeXS":"_1Y_yR60xNyiQXoh-uZvmFk","formInputText":"_1H3QqDFBbSgoSU-KnOrmZ3","sizeL":"_1wf59svdQQDtNzdBVQrwIN","sizeM":"_3TJVFaXnzbZN7D4JrfVAGw","sizeMS":"_3Zoh2Y2cN2Btg3dxfRGmy","inputsForceRow":"SqVVyPD6GAGq-4_IHmPKN","marginLeftS":"_2XE-huxOZpyDvEnVchwui8","last":"FXsza4-XEMXjgqNcBmJDM","first":"_1ZE20SZ48ISiMyxQbxTw5E","flexLast":"_1iF8Is7NUG4eNC3LHm_1W8","iframeContainer":"_2W0CnvRTC6a03zfv2fAeS2","documentImagesMainContainer":"_16Xiqs6Mr-vK5hxgdNhCN1","imageListContainer":"_1tDAbkydXYnjuecdJM7m7T","maximizeModalContent":"_2PE7LymmOkmgr4D81UyEiI","contractDateInputContainerLong":"_1brN42iFOJNgyC8pj7z028","contractDateInput":"_12u0Adp4ezZ1uTdoYPiE_9","displayNone":"_2U24q9dsPMuPnxX662jMB2","greenButtonDsList":"ZerrVjWDIc2ig6hpisRj7","marginLeft1em":"_3okoCTUanNyIgl8v1y8f-Q","signersAreaLabel":"_1As87rMPCROr1KmEMeYHfL","signaturePlaceBox":"_2RZ95f6kir21ZH4Fqvzcsu","addDocumentButtonContainer":"_1Hf4uiqTcHZ4MNOcfQzt_b","uploadButton":"_2Xk9jHX51MML5U73MVPpBy","iconContainer":"_1SAYzehwJ5aYoaqMUBqPvO","dsListButtonsWrapper":"_2nh8MeKQ_xBfygtniXRgHn","linkButton":"_3mXBlgudSHKncX-51aF6mz","iconTextOrganizer":"A6MCR2LRG3nqu1x_z6XX3","buttonIcon":"ZvaCYXfv8PGqa64PCw00J","buttonText":"_2oIUfzT7rbQHSVvM15Rvtr","emailButtonIcon":"TcD-8MKrzdcHCWAPZ7uHy","grow":"_3jgNR0YotEy3XdOSES3jLJ","alignStart":"_3RE4a_BnvWPOEpPvJAUUtg"};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  'countBy': __webpack_require__(1798),
	  'each': __webpack_require__(789),
	  'eachRight': __webpack_require__(1802),
	  'every': __webpack_require__(1805),
	  'filter': __webpack_require__(1808),
	  'find': __webpack_require__(1809),
	  'findLast': __webpack_require__(1812),
	  'flatMap': __webpack_require__(1815),
	  'flatMapDeep': __webpack_require__(1816),
	  'flatMapDepth': __webpack_require__(1817),
	  'forEach': __webpack_require__(790),
	  'forEachRight': __webpack_require__(791),
	  'groupBy': __webpack_require__(1824),
	  'includes': __webpack_require__(1828),
	  'invokeMap': __webpack_require__(1832),
	  'keyBy': __webpack_require__(1852),
	  'map': __webpack_require__(87),
	  'orderBy': __webpack_require__(1861),
	  'partition': __webpack_require__(1862),
	  'reduce': __webpack_require__(1865),
	  'reduceRight': __webpack_require__(1866),
	  'reject': __webpack_require__(1867),
	  'sample': __webpack_require__(1869),
	  'sampleSize': __webpack_require__(1870),
	  'shuffle': __webpack_require__(1873),
	  'size': __webpack_require__(1874),
	  'some': __webpack_require__(1875),
	  'sortBy': __webpack_require__(1876)
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _createAll2 = __webpack_require__(2203);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);
	
	var actionTypes = _createAll.actionTypes,
	    addArrayValue = _createAll.addArrayValue,
	    autofill = _createAll.autofill,
	    autofillWithKey = _createAll.autofillWithKey,
	    blur = _createAll.blur,
	    change = _createAll.change,
	    changeWithKey = _createAll.changeWithKey,
	    destroy = _createAll.destroy,
	    focus = _createAll.focus,
	    reducer = _createAll.reducer,
	    reduxForm = _createAll.reduxForm,
	    removeArrayValue = _createAll.removeArrayValue,
	    getValues = _createAll.getValues,
	    initialize = _createAll.initialize,
	    initializeWithKey = _createAll.initializeWithKey,
	    propTypes = _createAll.propTypes,
	    reset = _createAll.reset,
	    startAsyncValidation = _createAll.startAsyncValidation,
	    startSubmit = _createAll.startSubmit,
	    stopAsyncValidation = _createAll.stopAsyncValidation,
	    stopSubmit = _createAll.stopSubmit,
	    swapArrayValues = _createAll.swapArrayValues,
	    touch = _createAll.touch,
	    touchWithKey = _createAll.touchWithKey,
	    untouch = _createAll.untouch,
	    untouchWithKey = _createAll.untouchWithKey;
	exports.actionTypes = actionTypes;
	exports.addArrayValue = addArrayValue;
	exports.autofill = autofill;
	exports.autofillWithKey = autofillWithKey;
	exports.blur = blur;
	exports.change = change;
	exports.changeWithKey = changeWithKey;
	exports.destroy = destroy;
	exports.focus = focus;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.removeArrayValue = removeArrayValue;
	exports.getValues = getValues;
	exports.initialize = initialize;
	exports.initializeWithKey = initializeWithKey;
	exports.propTypes = propTypes;
	exports.reset = reset;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.swapArrayValues = swapArrayValues;
	exports.touch = touch;
	exports.touchWithKey = touchWithKey;
	exports.untouch = untouch;
	exports.untouchWithKey = untouchWithKey;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var definePropertyModule = __webpack_require__(42);
	var createPropertyDescriptor = __webpack_require__(82);
	
	module.exports = DESCRIPTORS ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var call = __webpack_require__(19);
	var propertyIsEnumerableModule = __webpack_require__(289);
	var createPropertyDescriptor = __webpack_require__(82);
	var toIndexedObject = __webpack_require__(51);
	var toPropertyKey = __webpack_require__(133);
	var hasOwn = __webpack_require__(29);
	var IE8_DOM_DEFINE = __webpack_require__(665);
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (IE8_DOM_DEFINE) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(457),
	    createAssigner = __webpack_require__(201);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(1013);
	var bytesToUuid = __webpack_require__(1012);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(1142);
	
	Object.defineProperty(exports, 'DatePicker', {
	  enumerable: true,
	  get: function get() {
	    return _DatePicker.DatePicker;
	  }
	});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(27);
	var create = __webpack_require__(73);
	var defineProperty = __webpack_require__(42).f;
	
	var UNSCOPABLES = wellKnownSymbol('unscopables');
	var ArrayPrototype = Array.prototype;
	
	// Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype[UNSCOPABLES] === undefined) {
	  defineProperty(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: create(null)
	  });
	}
	
	// add a key to Array.prototype[@@unscopables]
	module.exports = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';
	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	module.exports = function (it) {
	  return it === null || it === undefined;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineProperty = __webpack_require__(42).f;
	var hasOwn = __webpack_require__(29);
	var wellKnownSymbol = __webpack_require__(27);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	
	module.exports = function (target, TAG, STATIC) {
	  if (target && !STATIC) target = target.prototype;
	  if (target && !hasOwn(target, TO_STRING_TAG)) {
	    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
	  }
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path = __webpack_require__(417);
	var hasOwn = __webpack_require__(29);
	var wrappedWellKnownSymbolModule = __webpack_require__(699);
	var defineProperty = __webpack_require__(42).f;
	
	module.exports = function (NAME) {
	  var Symbol = path.Symbol || (path.Symbol = {});
	  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
	    value: wrappedWellKnownSymbolModule.f(NAME)
	  });
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(156),
	    getRawTag = __webpack_require__(1746),
	    objectToString = __webpack_require__(1773);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(141),
	    isLength = __webpack_require__(328);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(737),
	    baseKeys = __webpack_require__(456),
	    isArrayLike = __webpack_require__(69);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(737),
	    baseKeysIn = __webpack_require__(1716),
	    isArrayLike = __webpack_require__(69);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(41);
	var toString = __webpack_require__(18);
	
	var quot = /"/g;
	var replace = uncurryThis(''.replace);
	
	// `CreateHTML` abstract operation
	// https://tc39.es/ecma262/#sec-createhtml
	module.exports = function (string, tag, attribute, value) {
	  var S = toString(requireObjectCoercible(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* global ActiveXObject -- old IE, WSH */
	var anObject = __webpack_require__(20);
	var definePropertiesModule = __webpack_require__(413);
	var enumBugKeys = __webpack_require__(402);
	var hiddenKeys = __webpack_require__(232);
	var html = __webpack_require__(664);
	var documentCreateElement = __webpack_require__(280);
	var sharedKey = __webpack_require__(293);
	
	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	
	var EmptyConstructor = function () { /* empty */ };
	
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};
	
	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
	  activeXDocument = null;
	  return temp;
	};
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};
	
	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = typeof document != 'undefined'
	    ? document.domain && activeXDocument
	      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	      : NullProtoObjectViaIFrame()
	    : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	
	hiddenKeys[IE_PROTO] = true;
	
	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	// check the existence of a method, lowercase
	// of a tag and escaping quotes in arguments
	module.exports = function (METHOD_NAME) {
	  return fails(function () {
	    var test = ''[METHOD_NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  });
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(44);
	
	var min = Math.min;
	
	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	module.exports = function (argument) {
	  var len = toIntegerOrInfinity(argument);
	  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createEmotion = _interopDefault(__webpack_require__(1542));
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var _createEmotion = createEmotion(context),
	    flush = _createEmotion.flush,
	    hydrate = _createEmotion.hydrate,
	    cx = _createEmotion.cx,
	    merge = _createEmotion.merge,
	    getRegisteredStyles = _createEmotion.getRegisteredStyles,
	    injectGlobal = _createEmotion.injectGlobal,
	    keyframes = _createEmotion.keyframes,
	    css = _createEmotion.css,
	    sheet = _createEmotion.sheet,
	    caches = _createEmotion.caches;
	
	exports.flush = flush;
	exports.hydrate = hydrate;
	exports.cx = cx;
	exports.merge = merge;
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.injectGlobal = injectGlobal;
	exports.keyframes = keyframes;
	exports.css = css;
	exports.sheet = sheet;
	exports.caches = caches;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  'castArray': __webpack_require__(1793),
	  'clone': __webpack_require__(1794),
	  'cloneDeep': __webpack_require__(786),
	  'cloneDeepWith': __webpack_require__(1795),
	  'cloneWith': __webpack_require__(1796),
	  'conformsTo': __webpack_require__(1797),
	  'eq': __webpack_require__(161),
	  'gt': __webpack_require__(1825),
	  'gte': __webpack_require__(1826),
	  'isArguments': __webpack_require__(205),
	  'isArray': __webpack_require__(30),
	  'isArrayBuffer': __webpack_require__(1833),
	  'isArrayLike': __webpack_require__(69),
	  'isArrayLikeObject': __webpack_require__(792),
	  'isBoolean': __webpack_require__(1834),
	  'isBuffer': __webpack_require__(162),
	  'isDate': __webpack_require__(1835),
	  'isElement': __webpack_require__(1836),
	  'isEmpty': __webpack_require__(1837),
	  'isEqual': __webpack_require__(1838),
	  'isEqualWith': __webpack_require__(1839),
	  'isError': __webpack_require__(1840),
	  'isFinite': __webpack_require__(1841),
	  'isFunction': __webpack_require__(141),
	  'isInteger': __webpack_require__(793),
	  'isLength': __webpack_require__(328),
	  'isMap': __webpack_require__(794),
	  'isMatch': __webpack_require__(1842),
	  'isMatchWith': __webpack_require__(1843),
	  'isNaN': __webpack_require__(1844),
	  'isNative': __webpack_require__(1845),
	  'isNil': __webpack_require__(1846),
	  'isNull': __webpack_require__(1847),
	  'isNumber': __webpack_require__(795),
	  'isObject': __webpack_require__(56),
	  'isObjectLike': __webpack_require__(48),
	  'isPlainObject': __webpack_require__(120),
	  'isRegExp': __webpack_require__(1848),
	  'isSafeInteger': __webpack_require__(1849),
	  'isSet': __webpack_require__(796),
	  'isString': __webpack_require__(251),
	  'isSymbol': __webpack_require__(206),
	  'isTypedArray': __webpack_require__(207),
	  'isUndefined': __webpack_require__(797),
	  'isWeakMap': __webpack_require__(1850),
	  'isWeakSet': __webpack_require__(1851),
	  'lt': __webpack_require__(1853),
	  'lte': __webpack_require__(1854),
	  'toArray': __webpack_require__(1878),
	  'toFinite': __webpack_require__(803),
	  'toInteger': __webpack_require__(121),
	  'toLength': __webpack_require__(1879),
	  'toNumber': __webpack_require__(331),
	  'toPlainObject': __webpack_require__(806),
	  'toSafeInteger': __webpack_require__(1880),
	  'toString': __webpack_require__(807)
	};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAzMzY2Ij48cGF0aCBkPSJNMjgwLTEyMHEtMzMgMC01Ni41LTIzLjVUMjAwLTIwMHYtNTIwaC00MHYtODBoMjAwdi00MGgyNDB2NDBoMjAwdjgwaC00MHY1MjBxMCAzMy0yMy41IDU2LjVUNjgwLTEyMEgyODBabTQwMC02MDBIMjgwdjUyMGg0MDB2LTUyMFpNMzYwLTI4MGg4MHYtMzYwaC04MHYzNjBabTE2MCAwaDgwdi0zNjBoLTgwdjM2MFpNMjgwLTcyMHY1MjAtNTIwWiIvPjwvc3ZnPg=="

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _DSWizard = __webpack_require__(595);
	
	var _DSWizard2 = _interopRequireDefault(_DSWizard);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _DSWizardHelperScss = __webpack_require__(196);
	
	var _DSWizardHelperScss2 = _interopRequireDefault(_DSWizardHelperScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('mifidButton');
	
	/**
	 * This module render a button witch can be used to open DSDocument wizard
	 */
	
	var MifidButton = (function (_React$Component) {
	    _inherits(MifidButton, _React$Component);
	
	    _createClass(MifidButton, null, [{
	        key: 'propTypes',
	        value: {
	            callBackOnClose: _react2['default'].PropTypes.func,
	            callBackOnCloseClaimWizard: _react2['default'].PropTypes.func,
	            moduleKeyToSet: _react2['default'].PropTypes.string,
	            subModuleKeyToSet: _react2['default'].PropTypes.string,
	            isResume: _react2['default'].PropTypes.bool,
	            packageId: _react2['default'].PropTypes.string,
	
	            clientId: _react2['default'].PropTypes.string,
	            contractId: _react2['default'].PropTypes.string,
	            claimId: _react2['default'].PropTypes.string,
	
	            tarificationId: _react2['default'].PropTypes.string,
	            tarificationNumber: _react2['default'].PropTypes.string,
	
	            lang: _react2['default'].PropTypes.string,
	            disabled: _react2['default'].PropTypes.bool,
	
	            forceGetClient: _react2['default'].PropTypes.bool,
	            hideButton: _react2['default'].PropTypes.bool,
	            buttonText: _react2['default'].PropTypes.string,
	
	            customModalTitle1: _react2['default'].PropTypes.string,
	            customModalTitle2: _react2['default'].PropTypes.string,
	            customModalTitle3: _react2['default'].PropTypes.string,
	            customModalDescriptionStep1: _react2['default'].PropTypes.string,
	            customModalDescriptionStep2: _react2['default'].PropTypes.string,
	            customModalDescriptionStep3: _react2['default'].PropTypes.string,
	            stakeholders: _react2['default'].PropTypes.array,
	            moduleOptions: _react2['default'].PropTypes.object,
	            alienUserId: _react2['default'].PropTypes.string,
	
	            ticketId: _react2['default'].PropTypes.string,
	            ticketDocuments: _react2['default'].PropTypes.array,
	            selectedTicketDocuments: _react2['default'].PropTypes.array,
	            emailAttachmentTicketDocuments: _react2['default'].PropTypes.array,
	            openTrigger: _react2['default'].PropTypes.bool,
	            onlyIcon: _react2['default'].PropTypes.bool,
	            mifidKey: _react2['default'].PropTypes.string,
	            brokerFromOffice: _react2['default'].PropTypes.object
	        },
	        enumerable: true
	    }]);
	
	    function MifidButton(props) {
	        _classCallCheck(this, _MifidButton);
	
	        _get(Object.getPrototypeOf(_MifidButton.prototype), 'constructor', this).call(this, props);
	
	        this.getIcon = function (menuName) {
	            try {
	                return __webpack_require__(262)("./icn-" + menuName + '.svg');
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        };
	
	        var brokerFromOffice = props.brokerFromOffice;
	        this.state = {
	            brokerFromOffice: brokerFromOffice
	        };
	    }
	
	    /**
	     * This function fired when the module attached
	     */
	
	    _createClass(MifidButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props, disabled, moduleKeyToSet, currentModule, ticketDocuments, brokerFromOffice, moduleOptions, dispatch, getBrokerInfoRes;
	
	            return regeneratorRuntime.async(function componentDidMount$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props = this.props;
	                        disabled = _props.disabled;
	                        moduleKeyToSet = _props.moduleKeyToSet;
	                        currentModule = _props.currentModule;
	                        ticketDocuments = _props.ticketDocuments;
	                        brokerFromOffice = _props.brokerFromOffice;
	                        moduleOptions = _props.moduleOptions;
	                        dispatch = _props.dispatch;
	
	                        if (!disabled && (moduleKeyToSet === c.DS_MODULE_CLIENT_CONTRACT_PREM || ticketDocuments) && currentModule !== 'DSDOCUMENTS') {
	                            this.openDSWizardModal();
	                        }
	
	                        if (!(moduleKeyToSet === c.DS_MODULE_OFFICE && !brokerFromOffice && moduleOptions.brokerNumber)) {
	                            context$2$0.next = 14;
	                            break;
	                        }
	
	                        context$2$0.next = 12;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getBrokerInfo)(moduleOptions.brokerNumber)));
	
	                    case 12:
	                        getBrokerInfoRes = context$2$0.sent;
	
	                        this.setState({ brokerFromOffice: getBrokerInfoRes });
	
	                    case 14:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.openTrigger !== nextProps.openTrigger && nextProps.openTrigger) {
	                this.openDSWizardModal();
	            }
	
	            if (nextProps.brokerFromOffice !== this.props.brokerFromOffice) {
	                this.setState({
	                    brokerFromOffice: nextProps.brokerFromOffice
	                });
	            }
	        }
	
	        /**
	         * This function helps to use an icon on a safe way
	         */
	    }, {
	        key: 'openDSWizardModal',
	
	        /**
	         * This function will open a modal for DSWizard.
	         */
	        value: function openDSWizardModal() {
	            var e = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	            var _props2 = this.props;
	            var dispatch = _props2.dispatch;
	            var moduleKeyToSet = _props2.moduleKeyToSet;
	            var mifidKey = _props2.mifidKey;
	
	            // preventing click if existing event found
	            if (e) {
	                e.preventDefault();
	            }
	
	            // set physical module for package, make sure that have value, and that is valid for the mifid wizard
	            var moduleKeyForPackage = '';
	            switch (moduleKeyToSet) {
	                case c.DS_MODULE_CLIENT_PROFILE:
	                    {
	                        moduleKeyForPackage = c.DS_MODULE_CLIENT_PROFILE;
	                        break;
	                    }
	                case c.DS_MODULE_CLIENT_CONTRACT:
	                    {
	                        moduleKeyForPackage = c.DS_MODULE_CLIENT_CONTRACT;
	                        break;
	                    }
	                case c.DS_MODULE_CLIENT_CONTRACT_PREM:
	                    {
	                        moduleKeyForPackage = c.DS_MODULE_CLIENT_CONTRACT_PREM;
	                        break;
	                    }
	                case c.DS_MODULE_CLIENT_CLAIMS:
	                    {
	                        moduleKeyForPackage = c.DS_MODULE_CLIENT_CLAIMS;
	                        break;
	                    }
	                case c.DS_MODULE_CLIENT_TARIFICATION:
	                    {
	                        moduleKeyForPackage = c.DS_MODULE_CLIENT_TARIFICATION;
	                        break;
	                    }
	                case c.DS_MODULE_OFFICE:
	                    {
	                        moduleKeyForPackage = c.DS_MODULE_OFFICE;
	                        break;
	                    }
	                case c.DS_MODULE_CLAIM_WIZARD:
	                    {
	                        moduleKeyForPackage = c.DS_MODULE_CLAIM_WIZARD;
	                        break;
	                    }
	                default:
	                    {
	                        moduleKeyForPackage = c.DS_MODULE_CLIENT_PROFILE;
	                    }
	            }
	
	            dispatch((0, _stateActions.setDSWizard)(true, moduleKeyForPackage, mifidKey));
	        }
	
	        /**
	         * OnClose event of ds wizard.
	         */
	    }, {
	        key: 'onCloseDSWizard',
	        value: function onCloseDSWizard(clientId, entityId) {
	            var callBackOnClose = this.props.callBackOnClose;
	
	            callBackOnClose(clientId, entityId);
	        }
	    }, {
	        key: 'onCloseDSWizardFromClaimWizard',
	        value: function onCloseDSWizardFromClaimWizard(packageId) {
	            var callBackOnCloseClaimWizard = this.props.callBackOnCloseClaimWizard;
	
	            if (_underscore2['default'].isFunction(callBackOnCloseClaimWizard)) {
	                callBackOnCloseClaimWizard(packageId);
	            }
	        }
	
	        /**
	         * Main render function
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props3 = this.props;
	            var DSWizardOpened = _props3.DSWizardOpened;
	            var moduleOptions = _props3.moduleOptions;
	            var lang = _props3.lang;
	            var packageId = _props3.packageId;
	            var clientId = _props3.clientId;
	            var contractId = _props3.contractId;
	            var claimId = _props3.claimId;
	            var isResume = _props3.isResume;
	            var disabled = _props3.disabled;
	            var forceGetClient = _props3.forceGetClient;
	            var hideButton = _props3.hideButton;
	            var tarificationId = _props3.tarificationId;
	            var tarificationNumber = _props3.tarificationNumber;
	            var buttonText = _props3.buttonText;
	            var customModalTitle1 = _props3.customModalTitle1;
	            var customModalDescriptionStep1 = _props3.customModalDescriptionStep1;
	            var onlyIcon = _props3.onlyIcon;
	            var customModalTitle2 = _props3.customModalTitle2;
	            var customModalDescriptionStep2 = _props3.customModalDescriptionStep2;
	            var customModalTitle3 = _props3.customModalTitle3;
	            var customModalDescriptionStep3 = _props3.customModalDescriptionStep3;
	            var subModuleKeyToSet = _props3.subModuleKeyToSet;
	            var openedMifidKey = _props3.openedMifidKey;
	            var mifidKey = _props3.mifidKey;
	            var stakeholders = _props3.stakeholders;
	            var alienUserId = _props3.alienUserId;
	            var ticketId = _props3.ticketId;
	            var ticketDocuments = _props3.ticketDocuments;
	            var selectedTicketDocuments = _props3.selectedTicketDocuments;
	            var emailAttachmentTicketDocuments = _props3.emailAttachmentTicketDocuments;
	            var claimNumber = _props3.claimNumber;
	            var claimWizardDocType = _props3.claimWizardDocType;
	            var brokerFromOffice = this.state.brokerFromOffice;
	
	            var buttonLabel = isResume ? _('resumeToEdit') : _('mifidButtonLabel');
	
	            // if there is set the property on react element "buttonText", then overwrite the original functionality
	            if (buttonText) {
	                buttonLabel = buttonText;
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].mifidButtonContainer, onlyIcon ? _DSWizardHelperScss2['default'].onlyIcon : ''), key: "mifidButton" },
	                !hideButton && _react2['default'].createElement(
	                    'div',
	                    {
	                        key: "btnMifid",
	                        className: (0, _classnames2['default'])(onlyIcon ? _DSWizardHelperScss2['default'].onlyIcon : _DSWizardHelperScss2['default'].grayButtonFlex, onlyIcon ? _DSWizardHelperScss2['default'].onlyIcon : _DSWizardHelperScss2['default'].mifidButton, disabled ? _DSWizardHelperScss2['default'].disabled : ''),
	                        onClick: function (e) {
	                            return !disabled ? _this.openDSWizardModal(e) : e.preventDefault();
	                        }
	                    },
	                    _react2['default'].createElement('img', { className: (0, _classnames2['default'])(onlyIcon ? _DSWizardHelperScss2['default'].mifidNoMarginIcon : _DSWizardHelperScss2['default'].mifidButtonIcon), src: onlyIcon ? this.getIcon('dsdocuments-blue') : this.getIcon('dsdocuments-white') }),
	                    ' ',
	                    onlyIcon ? '' : buttonLabel
	                ),
	                DSWizardOpened && (!openedMifidKey || openedMifidKey === mifidKey) && _react2['default'].createElement(_DSWizard2['default'], {
	                    step: c.DSWIZARD_STEP_1_COMPOSE_PACKAGE,
	                    subModuleKey: subModuleKeyToSet,
	                    packageId: packageId,
	                    clientId: clientId,
	                    contractId: contractId,
	                    claimId: claimId,
	                    claimNumber: claimNumber,
	                    tarificationId: tarificationId,
	                    tarificationNumber: tarificationNumber,
	                    lang: lang,
	                    callBackOnClose: function (clientId, entityId) {
	                        _this.onCloseDSWizard(clientId, entityId);
	                    },
	                    callBackOnCloseFromClaimWizard: function (packageId) {
	                        _this.onCloseDSWizardFromClaimWizard(packageId);
	                    },
	                    forceGetClient: forceGetClient,
	                    customModalTitle1: customModalTitle1,
	                    customModalTitle2: customModalTitle2,
	                    customModalTitle3: customModalTitle3,
	                    customModalDescriptionStep1: customModalDescriptionStep1,
	                    customModalDescriptionStep2: customModalDescriptionStep2,
	                    customModalDescriptionStep3: customModalDescriptionStep3,
	                    stakeholders: stakeholders,
	                    moduleOptions: moduleOptions,
	                    alienUserId: alienUserId,
	                    ticketId: ticketId,
	                    ticketDocuments: ticketDocuments,
	                    selectedTicketDocuments: selectedTicketDocuments,
	                    emailAttachmentTicketDocuments: emailAttachmentTicketDocuments,
	                    brokerFromOffice: brokerFromOffice,
	                    claimWizardDocType: claimWizardDocType
	                })
	            );
	        }
	    }]);
	
	    var _MifidButton = MifidButton;
	    MifidButton = (0, _reactRedux.connect)(function (state) {
	        return {
	            DSWizardOpened: state.DSDocuments.DSWizardOpened,
	            moduleKey: state.DSDocuments.moduleKey,
	            lang: state.app.lang,
	            currentModule: state.app.module,
	            openedMifidKey: state.DSDocuments.openedMifidKey
	        };
	    })(MifidButton) || MifidButton;
	    return MifidButton;
	})(_react2['default'].Component);
	
	exports['default'] = MifidButton;
	module.exports = exports['default'];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noResultsScss = __webpack_require__(1618);
	
	var _noResultsScss2 = _interopRequireDefault(_noResultsScss);
	
	var _resourcesImagesIcnNoResultSvg = __webpack_require__(23);
	
	var _resourcesImagesIcnNoResultSvg2 = _interopRequireDefault(_resourcesImagesIcnNoResultSvg);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('noResults');
	
	var NoResults = function NoResults(_ref) {
		var type = _ref.type;
		return _react2['default'].createElement(
			'div',
			{ className: _noResultsScss2['default'].msgContainer },
			_react2['default'].createElement(
				'div',
				{ className: _noResultsScss2['default'].msg },
				_react2['default'].createElement(
					'div',
					{ className: _noResultsScss2['default'].imageContainer },
					_react2['default'].createElement('img', { src: _resourcesImagesIcnNoResultSvg2['default'] })
				),
				_react2['default'].createElement(
					'div',
					{ className: _noResultsScss2['default'].textContainer },
					_(type)
				)
			)
		);
	};
	NoResults.propTypes = {
		type: _react2['default'].PropTypes.string.isRequired
	};
	
	exports['default'] = NoResults;
	module.exports = exports['default'];

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(91);
	var call = __webpack_require__(19);
	var anObject = __webpack_require__(20);
	var tryToString = __webpack_require__(154);
	var isArrayIteratorMethod = __webpack_require__(406);
	var lengthOfArrayLike = __webpack_require__(34);
	var isPrototypeOf = __webpack_require__(74);
	var getIterator = __webpack_require__(284);
	var getIteratorMethod = __webpack_require__(231);
	var iteratorClose = __webpack_require__(286);
	
	var $TypeError = TypeError;
	
	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};
	
	var ResultPrototype = Result.prototype;
	
	module.exports = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_RECORD = !!(options && options.IS_RECORD);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = bind(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;
	
	  var stop = function (condition) {
	    if (iterator) iteratorClose(iterator, 'normal', condition);
	    return new Result(true, condition);
	  };
	
	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    } return INTERRUPTED ? fn(value, stop) : fn(value);
	  };
	
	  if (IS_RECORD) {
	    iterator = iterable.iterator;
	  } else if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && isPrototypeOf(ResultPrototype, result)) return result;
	      } return new Result(false);
	    }
	    iterator = getIterator(iterable, iterFn);
	  }
	
	  next = IS_RECORD ? iterable.next : iterator.next;
	  while (!(step = call(next, iterator)).done) {
	    try {
	      result = callFn(step.value);
	    } catch (error) {
	      iteratorClose(iterator, 'throw', error);
	    }
	    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
	  } return new Result(false);
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(29);
	var isCallable = __webpack_require__(28);
	var toObject = __webpack_require__(31);
	var sharedKey = __webpack_require__(293);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(400);
	
	var IE_PROTO = sharedKey('IE_PROTO');
	var $Object = Object;
	var ObjectPrototype = $Object.prototype;
	
	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
	  var object = toObject(O);
	  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
	  var constructor = object.constructor;
	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  } return object instanceof $Object ? ObjectPrototype : null;
	};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	var $TypeError = TypeError;
	
	module.exports = function (passed, required) {
	  if (passed < required) throw new $TypeError('Not enough arguments');
	  return passed;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(769);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(157),
	    baseIteratee = __webpack_require__(47),
	    baseMap = __webpack_require__(750),
	    isArray = __webpack_require__(30);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	module.exports = uncurryThis([].slice);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_BIND = __webpack_require__(230);
	
	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var call = FunctionPrototype.call;
	
	// eslint-disable-next-line es/no-reflect -- safe
	module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(130);
	var aCallable = __webpack_require__(39);
	var NATIVE_BIND = __webpack_require__(230);
	
	var bind = uncurryThis(uncurryThis.bind);
	
	// optional / simple context binding
	module.exports = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	// eslint-disable-next-line es/no-set -- safe
	var SetPrototype = Set.prototype;
	
	module.exports = {
	  // eslint-disable-next-line es/no-set -- safe
	  Set: Set,
	  add: uncurryThis(SetPrototype.add),
	  has: uncurryThis(SetPrototype.has),
	  remove: uncurryThis(SetPrototype['delete']),
	  proto: SetPrototype
	};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isvalidColorString = exports.red = exports.getContrastingColor = exports.isValidHex = exports.toState = exports.simpleCheckForValidColor = undefined;
	
	var _each = __webpack_require__(789);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _tinycolor = __webpack_require__(2245);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var simpleCheckForValidColor = exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
	  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
	  var checked = 0;
	  var passed = 0;
	  (0, _each2.default)(keysToCheck, function (letter) {
	    if (data[letter]) {
	      checked += 1;
	      if (!isNaN(data[letter])) {
	        passed += 1;
	      }
	      if (letter === 's' || letter === 'l') {
	        var percentPatt = /^\d+%$/;
	        if (percentPatt.test(data[letter])) {
	          passed += 1;
	        }
	      }
	    }
	  });
	  return checked === passed ? data : false;
	};
	
	var toState = exports.toState = function toState(data, oldHue) {
	  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	  var hsl = color.toHsl();
	  var hsv = color.toHsv();
	  var rgb = color.toRgb();
	  var hex = color.toHex();
	  if (hsl.s === 0) {
	    hsl.h = oldHue || 0;
	    hsv.h = oldHue || 0;
	  }
	  var transparent = hex === '000000' && rgb.a === 0;
	
	  return {
	    hsl: hsl,
	    hex: transparent ? 'transparent' : '#' + hex,
	    rgb: rgb,
	    hsv: hsv,
	    oldHue: data.h || oldHue || hsl.h,
	    source: data.source
	  };
	};
	
	var isValidHex = exports.isValidHex = function isValidHex(hex) {
	  if (hex === 'transparent') {
	    return true;
	  }
	  // disable hex4 and hex8
	  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
	  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
	};
	
	var getContrastingColor = exports.getContrastingColor = function getContrastingColor(data) {
	  if (!data) {
	    return '#fff';
	  }
	  var col = toState(data);
	  if (col.hex === 'transparent') {
	    return 'rgba(0,0,0,0.4)';
	  }
	  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
	  return yiq >= 128 ? '#000' : '#fff';
	};
	
	var red = exports.red = {
	  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
	  hex: '#ff0000',
	  rgb: { r: 255, g: 0, b: 0, a: 1 },
	  hsv: { h: 0, s: 1, v: 1, a: 1 }
	};
	
	var isvalidColorString = exports.isvalidColorString = function isvalidColorString(string, type) {
	  var stringWithoutDegree = string.replace('°', '');
	  return (0, _tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	"use strict";
	
	var validator = {};
	
	validator.isAnEmail = function (value) {
		var regex = /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
	
		return regex.test(value);
	};
	validator.isAnURL = function (value) {
		var regex = /^(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/;
		return regex.test(value);
	};
	validator.isNotEmpty = function (value) {
		return value.length > 0;
	};
	validator.isAString = function (value) {
		var regex = /^[a-zA-Z]+$/;
		return regex.test(value);
	};
	validator.isAnInteger = function (value) {
		var regex = /^\d+$/;
		return regex.test(value);
	};
	validator.isAPhoneNumber = function (value) {
		var regex = /^[0-9+\(\)#\.\s\/ext-]+$/;
		return regex.test(value);
	};
	
	// is for dd/mm/yyyy and dd-mm-yyyy and dd.mm.yyyy
	validator.isDate = function (value) {
		var regex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})/;
		return regex.test(value);
	};
	validator.passwordRules = function (value) {
		var regex = /^(?=[^0-9])(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])[a-zA-Z0-9]{8,}$/;
	
		if (regex.test(value)) {
			// can not begin with a digit & can not contain / or @
			var newRules = /^\d+/;
			return !newRules.test(value);
		} else {
			return false;
		}
	};
	
	module.exports = validator;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isPrototypeOf = __webpack_require__(74);
	
	var $TypeError = TypeError;
	
	module.exports = function (it, Prototype) {
	  if (isPrototypeOf(Prototype, it)) return it;
	  throw new $TypeError('Incorrect invocation');
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(429);
	var isCallable = __webpack_require__(28);
	var classofRaw = __webpack_require__(53);
	var wellKnownSymbol = __webpack_require__(27);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var $Object = Object;
	
	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};
	
	// getting tag from ES6+ `Object.prototype.toString`
	module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	
	var navigator = globalThis.navigator;
	var userAgent = navigator && navigator.userAgent;
	
	module.exports = userAgent ? String(userAgent) : '';


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable no-proto -- safe */
	var uncurryThisAccessor = __webpack_require__(283);
	var isObject = __webpack_require__(25);
	var requireObjectCoercible = __webpack_require__(41);
	var aPossiblePrototype = __webpack_require__(637);
	
	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    requireObjectCoercible(O);
	    aPossiblePrototype(proto);
	    if (!isObject(O)) return O;
	    if (CORRECT_SETTER) setter(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"arrow":"_1wfGKP99zV2SALdMF85IZX","collapseWrap":"_2Ce20EtiT4FkYUo91JnIKw","tableContainer":"_3YvtaorUSLeC1MO4PJ5uhV","documentHidden":"mRNmAiLYmOxv8Dw-w3IC6","tableTitle":"_3frmSc23aiF3pEa8wA9MSP","pdfIcon":"_1z3zXdLATs_CVc5CtoN81V","date":"_2V9AOlvBpEETg3DowWRI3D","typeCol":"_3jCosGWMRANI6GsAZr2J8I"};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(314),
	    baseAssignValue = __webpack_require__(136);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(36);
	
	var CallbackQueue = __webpack_require__(837);
	var PooledClass = __webpack_require__(164);
	var ReactFeatureFlags = __webpack_require__(842);
	var ReactReconciler = __webpack_require__(211);
	var Transaction = __webpack_require__(335);
	
	var invariant = __webpack_require__(21);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "SelectBase", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Async", {
	  enumerable: true,
	  get: function get() {
	    return _Async.default;
	  }
	});
	Object.defineProperty(exports, "makeAsyncSelect", {
	  enumerable: true,
	  get: function get() {
	    return _Async.makeAsyncSelect;
	  }
	});
	Object.defineProperty(exports, "AsyncCreatable", {
	  enumerable: true,
	  get: function get() {
	    return _AsyncCreatable.default;
	  }
	});
	Object.defineProperty(exports, "Creatable", {
	  enumerable: true,
	  get: function get() {
	    return _Creatable.default;
	  }
	});
	Object.defineProperty(exports, "makeCreatableSelect", {
	  enumerable: true,
	  get: function get() {
	    return _Creatable.makeCreatableSelect;
	  }
	});
	Object.defineProperty(exports, "createFilter", {
	  enumerable: true,
	  get: function get() {
	    return _filters.createFilter;
	  }
	});
	Object.defineProperty(exports, "makeAnimated", {
	  enumerable: true,
	  get: function get() {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "components", {
	  enumerable: true,
	  get: function get() {
	    return _index2.components;
	  }
	});
	Object.defineProperty(exports, "mergeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _styles.mergeStyles;
	  }
	});
	Object.defineProperty(exports, "defaultTheme", {
	  enumerable: true,
	  get: function get() {
	    return _theme.defaultTheme;
	  }
	});
	exports.default = void 0;
	
	var _Select = _interopRequireDefault(__webpack_require__(342));
	
	var _stateManager = _interopRequireDefault(__webpack_require__(343));
	
	var _Async = _interopRequireWildcard(__webpack_require__(868));
	
	var _AsyncCreatable = _interopRequireDefault(__webpack_require__(2079));
	
	var _Creatable = _interopRequireWildcard(__webpack_require__(165));
	
	var _filters = __webpack_require__(877);
	
	var _index = _interopRequireDefault(__webpack_require__(2086));
	
	var _index2 = __webpack_require__(493);
	
	var _styles = __webpack_require__(879);
	
	var _theme = __webpack_require__(880);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _stateManager.default)(_Select.default);
	
	exports.default = _default;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	/**
	 * Popup content for status explainer
	 * @param {*} doc
	 */
	var statusExplainerPopup = function statusExplainerPopup(title, content, callBack, ok) {
	    return _react2['default'].createElement(
	        'div',
	        { className: _documentsScss2['default'].documentsModalContent },
	        _react2['default'].createElement(
	            'span',
	            { className: _documentsScss2['default'].title },
	            title
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: _documentsScss2['default'].message },
	            _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].dsDocumentDescriptionContainer },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].content },
	                    content
	                )
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: _documentsScss2['default'].documentsModalButtons },
	            _react2['default'].createElement('input', {
	                onClick: function () {
	                    callBack();
	                },
	                type: 'button',
	                className: _documentsScss2['default'].greenButton + " enabled",
	                value: ok + ""
	            })
	        )
	    );
	};
	
	exports.statusExplainerPopup = statusExplainerPopup;
	/**
	 * General customization for modals in DSDocuments module
	 * Mostly is the same like in other modules but sometimes is customized
	 */
	var customModalStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        whiteSpace: 'pre-wrap',
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        width: '70%',
	        height: 'auto'
	    }
	};
	
	exports.customModalStyles = customModalStyles;
	/**
	 * General customization for modals in DSDocuments module
	 * Mostly is the same like in other modules but sometimes is customized
	 */
	var customModalStylesForFillForm = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        width: '90%',
	        height: '90%'
	    }
	};
	
	exports.customModalStylesForFillForm = customModalStylesForFillForm;
	/**
	* THis function helps to generate a translation key by status
	*/
	var getStatusTranslationKey = function getStatusTranslationKey(status) {
	    if (!status) {
	        return 'status_none';
	    }
	    return 'status_' + status.charAt(0).toUpperCase() + status.slice(1);
	};
	
	exports.getStatusTranslationKey = getStatusTranslationKey;
	/**
	* THis function helps to generate a translation key for description of status
	*/
	var getStatusDescriptionTranslationKey = function getStatusDescriptionTranslationKey(status) {
	    if (!status) {
	        return 'status_description_none';
	    }
	
	    return 'status_description_' + status.charAt(0).toUpperCase() + status.slice(1);
	};
	
	exports.getStatusDescriptionTranslationKey = getStatusDescriptionTranslationKey;
	/**
	* This function returns true if a status is a fail for dsdocuments
	*/
	var isAFailStatus = function isAFailStatus(status) {
	    if (!status) {
	        return false;
	    }
	
	    return [c.DS_PACKAGE_STATUS_FAILED, c.DS_DOCUMENTS_ERROR, c.DS_PACKAGE_STATUS_REJECTED, c.DS_PACKAGE_STATUS_REVOKED, c.DS_PACKAGE_STATUS_EXPIRED, c.DS_PACKAGE_STATUS_FAILED].includes(status);
	};
	
	exports.isAFailStatus = isAFailStatus;
	var escapeSpecialChars = function escapeSpecialChars(inputString) {
	    return inputString.replace(/\\n/g, "\\n").replace(/\\'/g, "\\'").replace(/\\"/g, '\\"').replace(/\\&/g, "\\&").replace(/\\r/g, "\\r").replace(/\\t/g, "\\t").replace(/\\b/g, "\\b").replace(/\\f/g, "\\f");
	};
	
	exports.escapeSpecialChars = escapeSpecialChars;
	/**
	* This function provide false if the package must be locked.
	* @param {*} statusHistory
	*/
	var shouldEditThePackage = function shouldEditThePackage(statusHistory, isEditable) {
	    var should = true;
	
	    // v6.5 implemented to detect if the package is editable or not, for the old records must be checked the status history
	    // in case when the isEditable is null or undefined then that is an old record before v6.5, no to be considered as condition
	    if (isEditable === false) {
	        should = false;
	        return should;
	    }
	
	    // v6.0 checking the status history
	    if (!statusHistory) {
	        return true;
	    }
	
	    // v6.0 checking the status history
	    statusHistory.forEach(function (oneStatus) {
	        if (oneStatus.status === c.DS_PACKAGE_STATUS_PENDING) {
	            should = false;
	        }
	    });
	
	    return should;
	};
	
	exports.shouldEditThePackage = shouldEditThePackage;
	/**
	 * Check if all stakeholders have signed
	 * @param {*} dsPackage
	 * @returns
	 */
	var stakeholdersCanSign = function stakeholdersCanSign(dsPackage) {
	    var canSign = false;
	    if (!dsPackage) {
	        return;
	    }
	    dsPackage.dsStakeholders.forEach(function (stakeholder) {
	        if (stakeholder.roles && stakeholder.roles.length > 0) {
	
	            stakeholder.roles.forEach(function (role) {
	                if (role.type === 'signer' && role.status === 'Available') {
	                    canSign = true;
	                }
	            });
	        }
	    });
	    return canSign;
	};
	
	exports.stakeholdersCanSign = stakeholdersCanSign;
	/**
	 * Check if stakeholder has available action used for sending invitation to sign
	 * @param {*} stakeholder 
	 * @returns Boolean
	 */
	var stakeholderMustAct = function stakeholderMustAct(stakeholder) {
	
	    var mustAct = false;
	    if (stakeholder.roles && stakeholder.roles.length > 0) {
	
	        stakeholder.roles.forEach(function (role) {
	            if (role.type === 'signer' && role.status === 'Available' || role.type === 'formFiller' && role.status === 'Available') {
	                mustAct = true;
	            }
	        });
	    }
	
	    return mustAct;
	};
	
	exports.stakeholderMustAct = stakeholderMustAct;
	/**
	 * Check if all stakeholders have signed
	 * @param {*} dsPackage
	 * @returns
	 */
	var stakeholdersNeedInvitation = function stakeholdersNeedInvitation(dsPackage) {
	    var notInvited = false;
	    if (!dsPackage) {
	        return;
	    }
	
	    dsPackage.dsStakeholders.forEach(function (stakeholder) {
	        if (!stakeholder.isInvited && stakeholder.signerType !== "BROKER") {
	            notInvited = true;
	        }
	    });
	
	    return notInvited;
	};
	
	exports.stakeholdersNeedInvitation = stakeholdersNeedInvitation;
	/**
	* This function checks if a document is signed.
	* @param {*} document
	* @returns
	*/
	var isSignedTheDocument = function isSignedTheDocument(document) {
	    var isSigned = false;
	
	    if (document && document['package'] && document['package'].statusHistory) {
	        document['package'].statusHistory.forEach(function (oneStatus, index) {
	            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
	                isSigned = true;
	            }
	        });
	    }
	
	    return isSigned;
	};
	
	exports.isSignedTheDocument = isSignedTheDocument;
	/**
	 * This function return true when there is a linking action required for an entity.
	 * @param {*} dsDocument
	 * @returns Boolean - true is must be linked to an entity and not linked yet, false if not required linking
	 * or already linked.
	 */
	var shouldToLinkWithContract = function shouldToLinkWithContract(dsDocument) {
	    // if uploaded or there are wrong paramteres the return false
	    if (!dsDocument || dsDocument.uploadedToOracle) {
	        return false;
	    }
	
	    // collecting the logical values for determination of result
	    var isRequiredContractId = _nestedProperty2['default'].get(dsDocument, "documentTemplate.uploadedOnModule") === c.DS_MODULE_CLIENT_CONTRACT;
	
	    // the template is not contract based
	    if (!isRequiredContractId) {
	        return false;
	    }
	
	    var hasContractId = _nestedProperty2['default'].get(dsDocument, "contractId");
	
	    // determine the result
	    return isRequiredContractId && !hasContractId;
	};
	
	exports.shouldToLinkWithContract = shouldToLinkWithContract;
	/**
	 * This function return true when there is a linking action required for a claim.
	 * @param {*} dsDocument
	 * @returns Boolean - true is must be linked to a claim and not linked yet, false if not required linking
	 * or already linked.
	 */
	var shouldToLinkWithClaim = function shouldToLinkWithClaim(dsDocument) {
	    // if uploaded or there are wrong paramteres the return false
	    if (!dsDocument || dsDocument.uploadedToOracle) {
	        return false;
	    }
	
	    // collecting the logical values for determination of result
	    var isRequiredClaimId = _nestedProperty2['default'].get(dsDocument, "documentTemplate.uploadedOnModule") === c.DS_MODULE_CLIENT_CLAIMS;
	
	    // the template is not claim based
	    if (!isRequiredClaimId) {
	        return false;
	    }
	
	    var hasClaimId = _nestedProperty2['default'].get(dsDocument, "claimId");
	
	    // determine the result
	    return isRequiredClaimId && !hasClaimId;
	};
	
	exports.shouldToLinkWithClaim = shouldToLinkWithClaim;
	/**
	 * This function return true when there is a linking action required for a tarification.
	 * @param {*} dsDocument
	 * @returns Boolean - true is must be linked to a tarification and not linked yet, false if not required linking
	 * or already linked.
	 */
	var shouldToLinkWithTarification = function shouldToLinkWithTarification(dsDocument) {
	    // if uploaded or there are wrong paramteres the return false
	    if (!dsDocument || dsDocument.uploadedToOracle) {
	        return false;
	    }
	
	    // collecting the logical values for determination of result
	    var isRequiredTarificationId = _nestedProperty2['default'].get(dsDocument, "documentTemplate.uploadedOnModule") === c.DS_MODULE_CLIENT_TARIFICATION;
	
	    // the template is not tarification based
	    if (!isRequiredTarificationId) {
	        return false;
	    }
	
	    var hasTarificationId = _nestedProperty2['default'].get(dsDocument, "tarificationId");
	
	    // determine the result
	    return isRequiredTarificationId && !hasTarificationId;
	};
	exports.shouldToLinkWithTarification = shouldToLinkWithTarification;
	/* <span className={styles.contentTitle}>{title}</span> */

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _KeyValueScss = __webpack_require__(1583);
	
	var _KeyValueScss2 = _interopRequireDefault(_KeyValueScss);
	
	var KeyValue = function KeyValue(_ref) {
		var array = _ref.array;
		var divider = _ref.divider;
		var _ref$customClass = _ref.customClass;
		var customClass = _ref$customClass === undefined ? '' : _ref$customClass;
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])(_KeyValueScss2['default'].moduleSectionContent, customClass) },
			_react2['default'].createElement(
				'div',
				{ className: _KeyValueScss2['default'].detailsContainer },
				array.map(function (column, key) {
					return _react2['default'].createElement(
						'div',
						{ key: key, className: _KeyValueScss2['default'].keyValueColumn },
						column.map(function (item, key) {
							return _react2['default'].createElement(
								'div',
								{
									key: key,
									className: (0, _classnames2['default'])(_KeyValueScss2['default'].keyValuePair, divider === true && _KeyValueScss2['default'].divider)
								},
								!item.noLabel ? _react2['default'].createElement(
									'div',
									{ className: _KeyValueScss2['default'].keyCont },
									_react2['default'].createElement(
										'div',
										{ className: _KeyValueScss2['default'].key },
										item.label
									)
								) : '',
								item.value && _react2['default'].createElement(
									'div',
									{ className: _KeyValueScss2['default'].valCont },
									_react2['default'].createElement(
										'div',
										{ className: _KeyValueScss2['default'].value },
										item.value
									)
								)
							);
						})
					);
				})
			)
		);
	};
	
	KeyValue.propTypes = {
		array: _react2['default'].PropTypes.array.isRequired,
		divider: _react2['default'].PropTypes.bool
	};
	
	exports['default'] = KeyValue;
	module.exports = exports['default'];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _2 = __webpack_require__(1100);
	
	var _3 = _interopRequireDefault(_2);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _emailSenderModalScss = __webpack_require__(303);
	
	var _emailSenderModalScss2 = _interopRequireDefault(_emailSenderModalScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('emailSender');
	
	/**
	 * This module render a button witch can be used to open a mail sender modal.
	 */
	
	var EmailButton = (function (_React$Component) {
	    _inherits(EmailButton, _React$Component);
	
	    _createClass(EmailButton, null, [{
	        key: 'propTypes',
	        value: {
	            moduleKeyToSet: _react2['default'].PropTypes.string.isRequired,
	            moduleOptions: _react2['default'].PropTypes.object,
	            initialArguments: _react2['default'].PropTypes.any,
	            customButtonLabel: _react2['default'].PropTypes.string,
	            customClassName: _react2['default'].PropTypes.string,
	            isWhiteIcon: _react2['default'].PropTypes.bool,
	            // used to recognise the current modal if there is more emailer button on the page.
	            // without this you cant open/close them separately, because are driven by store
	            modalId: _react2['default'].PropTypes.string,
	            onInit: _react2['default'].PropTypes.func,
	            onSent: _react2['default'].PropTypes.func,
	            onSentLate: _react2['default'].PropTypes.func, // after hitting ok on confirmation button
	            hideCC: _react2['default'].PropTypes.bool,
	            multiLanguage: _react2['default'].PropTypes.bool,
	            serialSending: _react2['default'].PropTypes.bool,
	            getDSStakeholders: _react2['default'].PropTypes.func,
	            isCreatable: _react2['default'].PropTypes.bool,
	            forceIsMulti: _react2['default'].PropTypes.bool,
	            forceOpen: _react2['default'].PropTypes.bool,
	            onCancel: _react2['default'].PropTypes.func,
	            hideButton: _react2['default'].PropTypes.bool,
	            noLabel: _react2['default'].PropTypes.bool
	        },
	        enumerable: true
	    }]);
	
	    function EmailButton(props) {
	        _classCallCheck(this, _EmailButton);
	
	        _get(Object.getPrototypeOf(_EmailButton.prototype), 'constructor', this).call(this, props);
	
	        this.getIcon = function (menuName) {
	            var isWhite = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            try {
	                return isWhite ? __webpack_require__(592)("./m-" + menuName + '.svg') : __webpack_require__(2332)("./icn-" + menuName + '-white.svg');
	            } catch (err) {
	                console.log(err);
	
	                return __webpack_require__(23);
	            }
	        };
	
	        this.state = { buttonLabel: "", customClassName: props.customClassName };
	    }
	
	    /**
	     * This function fired when the module attached
	     */
	
	    _createClass(EmailButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // decide auto open
	            var autoEmailModalOpen = this.getAutoOpen(this.props);
	
	            if (autoEmailModalOpen) {
	                this.openEmailModal();
	            }
	
	            // get label for button
	            var buttonLabel = this.getButtonLabel(this.props);
	            var customClassName = this.props.customClassName ? this.props.customClassName : (0, _classnames2['default'])(_emailSenderModalScss2['default'].grayButton, _emailSenderModalScss2['default'].emailButton);
	
	            this.setState({ buttonLabel: buttonLabel, customClassName: customClassName });
	
	            // must be a function but optional, do not check if it is a function, to get error in case someone use it wrongly
	            if (this.props.onInit) {
	                var result = this.props.onInit();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var buttonLabel = this.getButtonLabel(nextProps);
	
	            this.setState({ buttonLabel: buttonLabel });
	        }
	
	        /**
	         *
	         * @param {*} props
	         * @returns
	         */
	    }, {
	        key: 'getButtonLabel',
	        value: function getButtonLabel(props) {
	            var clientsProfileKey = _nestedProperty2['default'].get(props, "EmailTemplateRelations.EmailTemplateModules.clientsProfile.value");
	            // decide label by module
	            var buttonLabel = props.moduleKeyToSet == clientsProfileKey ? _('sendEmailOffer') : _('sendEmail');
	
	            // decide label by customization parameter
	            buttonLabel = props.customButtonLabel ? props.customButtonLabel : buttonLabel;
	
	            return buttonLabel;
	        }
	
	        /**
	         *
	         * for further operation
	         * @param {*} props
	         * @returns
	         */
	    }, {
	        key: 'getAutoOpen',
	        value: function getAutoOpen(props) {
	            var initialArguments = props.initialArguments;
	            var initialArgumentsFromStore = props.initialArgumentsFromStore;
	
	            // decide to open the emailer automated or not
	            var autoEmailModalOpen = false;
	
	            var initArgs = initialArguments || initialArgumentsFromStore;
	
	            if (initArgs) {
	                autoEmailModalOpen = initArgs.autoEmailModalOpen || false;
	            }
	
	            return autoEmailModalOpen;
	        }
	
	        /**
	         * This function helps to use an icon on a safe way
	         */
	
	    }, {
	        key: 'openEmailModal',
	
	        /**
	         * This function will open a modal for sending email contains the associated template.
	         */
	        value: function openEmailModal() {
	            var _props, dispatch, moduleKeyToSet, modalId, isInvitation, packageStatusCheck, canOpenInvitationModal;
	
	            return regeneratorRuntime.async(function openEmailModal$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props = this.props;
	                        dispatch = _props.dispatch;
	                        moduleKeyToSet = _props.moduleKeyToSet;
	                        modalId = _props.modalId;
	                        isInvitation = _props.isInvitation;
	                        packageStatusCheck = _props.packageStatusCheck;
	
	                        if (!(isInvitation && packageStatusCheck)) {
	                            context$2$0.next = 12;
	                            break;
	                        }
	
	                        context$2$0.next = 9;
	                        return regeneratorRuntime.awrap(packageStatusCheck());
	
	                    case 9:
	                        canOpenInvitationModal = context$2$0.sent;
	
	                        if (canOpenInvitationModal) {
	                            context$2$0.next = 12;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return');
	
	                    case 12:
	                        // set the moduleKey to trigger the email sender modal with the correct templates
	                        dispatch((0, _stateActions.setEmailSenderModule)(moduleKeyToSet, modalId));
	
	                    case 13:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Main render function
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props2 = this.props;
	            var moduleKey = _props2.moduleKey;
	            var moduleOptions = _props2.moduleOptions;
	            var isWhiteIcon = _props2.isWhiteIcon;
	            var modalIdOpened = _props2.modalIdOpened;
	            var hideButton = _props2.hideButton;
	            var initialArgumentsFromStore = _props2.initialArgumentsFromStore;
	            var initialArguments = _props2.initialArguments;
	            var noLabel = _props2.noLabel;
	            var _state = this.state;
	            var buttonLabel = _state.buttonLabel;
	            var customClassName = _state.customClassName;
	
	            var modalId = this.props.modalId ? this.props.modalId : "";
	
	            // set module options extras from initial arguments
	            if (initialArgumentsFromStore && Object.keys(initialArgumentsFromStore).length > 0) {
	                moduleOptions.autoSelectTemplate = moduleOptions.autoSelectTemplate || initialArgumentsFromStore.autoSelectTemplate ? true : false;
	                moduleOptions.startedFromModule = initialArgumentsFromStore.startedFromModule || null;
	                moduleOptions.quickReply = initialArgumentsFromStore.quickReply ? true : false;
	                moduleOptions.ticketId = initialArgumentsFromStore.ticketId || '';
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { key: "emailSenderButtonContainer_" + modalId },
	                !hideButton && _react2['default'].createElement(
	                    'div',
	                    {
	                        key: "btnSendMail_" + modalId,
	                        className: customClassName,
	                        onClick: function (e) {
	                            e.preventDefault();
	                            _this.openEmailModal();
	                        }
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _emailSenderModalScss2['default'].iconTextOrganizer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _emailSenderModalScss2['default'].buttonIcon, key: "emailSenderButtonContainer_iconTextOrganizerbuttonIcon" },
	                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(noLabel ? _emailSenderModalScss2['default'].emailButtonNoLabelIcon : _emailSenderModalScss2['default'].emailButtonIcon), src: noLabel ? this.getIcon('inbox-blue', isWhiteIcon) : this.getIcon('inbox', isWhiteIcon) })
	                        ),
	                        !noLabel && _react2['default'].createElement(
	                            'div',
	                            { className: _emailSenderModalScss2['default'].buttonText, key: "emailSenderButtonContainer_iconTextOrganizerbuttonText" },
	                            buttonLabel
	                        )
	                    )
	                ),
	                moduleKey && (modalIdOpened === modalId || !modalIdOpened && !modalId) && _react2['default'].createElement(_3['default'], {
	                    moduleOptions: moduleOptions,
	                    modalId: modalId,
	                    onSent: this.props.onSent,
	                    onSentLate: this.props.onSentLate,
	                    hideCC: this.props.hideCC,
	                    multiLanguage: this.props.multiLanguage,
	                    serialSending: this.props.serialSending,
	                    getDSStakeholders: this.props.getDSStakeholders,
	                    isCreatable: this.props.isCreatable,
	                    forceIsMulti: this.props.forceIsMulti,
	                    onCancel: this.props.onCancel,
	                    forceOpen: this.props.forceOpen,
	                    key: "emailSenderButtonContainer_EmailSender_integrated"
	                })
	            );
	        }
	    }]);
	
	    var _EmailButton = EmailButton;
	    EmailButton = (0, _reactRedux.connect)(function (state) {
	        return {
	            moduleKey: state.emailSender.moduleKey,
	            modalIdOpened: state.emailSender.modalIdOpened,
	            EmailTemplateRelations: state.app.security.EmailTemplateRelations,
	            initialArgumentsFromStore: state.clients.initialArguments
	        };
	    })(EmailButton) || EmailButton;
	    return EmailButton;
	})(_react2['default'].Component);
	
	exports['default'] = EmailButton;
	module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputScss = __webpack_require__(1611);
	
	var _inputScss2 = _interopRequireDefault(_inputScss);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('');
	
	var TernaryInput = function TernaryInput(props) {
		var options = [{ value: 'true', label: _('Yes') }, { value: 'false', label: _('No') }];
	
		var handleBlur = function handleBlur(e) {
			// New version of react-select does not pass the event to onBlur, but value (hardcodeed by us)
			// Made this way to support both versions of react-select (version 1 and 2)
			// Resolves issue with usage of redux-form and react-select
			if (e && typeof e.preventDefault === 'function') {
				e.preventDefault();
			}
		};
	
		return _react2['default'].createElement(_componentsSharedSelectSelectWrap.SelectWrapper, _extends({}, props, {
			isClearable: true,
			onBlur: handleBlur,
			options: options
		}));
	};
	
	/**
	 * Input component
	 * @description Be aware that onChange argument could be an event or a string("")
	*/
	
	var Input = (function (_Component) {
		_inherits(Input, _Component);
	
		function Input() {
			var _this = this;
	
			_classCallCheck(this, Input);
	
			_get(Object.getPrototypeOf(Input.prototype), 'constructor', this).apply(this, arguments);
	
			this.handleChange = function (e) {
				_this.props.onChange(e);
			};
	
			this.handleClear = function (event) {
				event.stopPropagation();
				_this.props.onChange(""); // TODO: pass event to onChange with value = ""
				if (typeof _this.props.onClear === 'function') {
					_this.props.onClear();
				}
			};
		}
	
		_createClass(Input, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var type = _props.type;
				var value = _props.value;
				var hideCancel = _props.hideCancel;
				var onClear = _props.onClear;
	
				var props = _objectWithoutProperties(_props, ['type', 'value', 'hideCancel', 'onClear']);
	
				// eslint-disable-line no-unused-vars
				return _react2['default'].createElement(
					'div',
					{ className: _inputScss2['default'].inputContainer },
					type === 'ternary' ? _react2['default'].createElement(TernaryInput, _extends({}, props, {
						value: value,
						onChange: this.handleChange
					})) : _react2['default'].createElement(
						'div',
						null,
						_react2['default'].createElement('input', _extends({}, props, {
							type: type,
							value: value,
							onChange: this.handleChange
						})),
						Boolean(value) && _react2['default'].createElement(
							'button',
							{
								type: 'button',
								onClick: this.handleClear,
								style: {
									opacity: hideCancel ? 0 : 1,
									pointerEvents: hideCancel ? 'none' : 'auto'
								},
								className: _inputScss2['default'].removeInput
							},
							_react2['default'].createElement(
								'span',
								{ className: _inputScss2['default'].cross },
								'×'
							)
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				onChange: _react.PropTypes.func.isRequired,
				type: _react.PropTypes.string.isRequired,
				value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
				onClear: _react.PropTypes.func,
				hideCancel: _react.PropTypes.bool
			},
			enumerable: true
		}]);
	
		return Input;
	})(_react.Component);
	
	exports['default'] = Input;
	module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable react/no-danger */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HtmlContentScss = __webpack_require__(723);
	
	var _HtmlContentScss2 = _interopRequireDefault(_HtmlContentScss);
	
	var HtmlContent = function HtmlContent(_ref) {
		var content = _ref.content;
		var className = _ref.className;
		return _react2["default"].createElement("div", {
			className: _HtmlContentScss2["default"].content + " " + className,
			dangerouslySetInnerHTML: { __html: content }
		});
	};
	HtmlContent.propTypes = {
		content: _react2["default"].PropTypes.string
	};
	
	exports["default"] = HtmlContent;
	module.exports = exports["default"];

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1180);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1179);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(376);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(376);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	module.exports = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call -- required for testing
	    method.call(null, argument || function () { return 1; }, 1);
	  });
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var userAgent = __webpack_require__(99);
	
	var process = globalThis.process;
	var Deno = globalThis.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;
	
	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}
	
	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}
	
	module.exports = version;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(39);
	var isNullOrUndefined = __webpack_require__(64);
	
	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	module.exports = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(44);
	
	var max = Math.max;
	var min = Math.min;
	
	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	module.exports = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var call = __webpack_require__(19);
	var DESCRIPTORS = __webpack_require__(14);
	var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(430);
	var ArrayBufferViewCore = __webpack_require__(26);
	var ArrayBufferModule = __webpack_require__(273);
	var anInstance = __webpack_require__(97);
	var createPropertyDescriptor = __webpack_require__(82);
	var createNonEnumerableProperty = __webpack_require__(58);
	var isIntegralNumber = __webpack_require__(407);
	var toLength = __webpack_require__(76);
	var toIndex = __webpack_require__(428);
	var toOffset = __webpack_require__(694);
	var toUint8Clamped = __webpack_require__(1246);
	var toPropertyKey = __webpack_require__(133);
	var hasOwn = __webpack_require__(29);
	var classof = __webpack_require__(98);
	var isObject = __webpack_require__(25);
	var isSymbol = __webpack_require__(150);
	var create = __webpack_require__(73);
	var isPrototypeOf = __webpack_require__(74);
	var setPrototypeOf = __webpack_require__(100);
	var getOwnPropertyNames = __webpack_require__(152).f;
	var typedArrayFrom = __webpack_require__(695);
	var forEach = __webpack_require__(52).forEach;
	var setSpecies = __webpack_require__(189);
	var defineBuiltInAccessor = __webpack_require__(50);
	var definePropertyModule = __webpack_require__(42);
	var getOwnPropertyDescriptorModule = __webpack_require__(59);
	var arrayFromConstructorAndList = __webpack_require__(274);
	var InternalStateModule = __webpack_require__(49);
	var inheritIfRequired = __webpack_require__(148);
	
	var getInternalState = InternalStateModule.get;
	var setInternalState = InternalStateModule.set;
	var enforceInternalState = InternalStateModule.enforce;
	var nativeDefineProperty = definePropertyModule.f;
	var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	var RangeError = globalThis.RangeError;
	var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
	var ArrayBufferPrototype = ArrayBuffer.prototype;
	var DataView = ArrayBufferModule.DataView;
	var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
	var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
	var TypedArray = ArrayBufferViewCore.TypedArray;
	var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
	var isTypedArray = ArrayBufferViewCore.isTypedArray;
	var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	var WRONG_LENGTH = 'Wrong length';
	
	var addGetter = function (it, key) {
	  defineBuiltInAccessor(it, key, {
	    configurable: true,
	    get: function () {
	      return getInternalState(this)[key];
	    }
	  });
	};
	
	var isArrayBuffer = function (it) {
	  var klass;
	  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
	};
	
	var isTypedArrayIndex = function (target, key) {
	  return isTypedArray(target)
	    && !isSymbol(key)
	    && key in target
	    && isIntegralNumber(+key)
	    && key >= 0;
	};
	
	var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
	  key = toPropertyKey(key);
	  return isTypedArrayIndex(target, key)
	    ? createPropertyDescriptor(2, target[key])
	    : nativeGetOwnPropertyDescriptor(target, key);
	};
	
	var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
	  key = toPropertyKey(key);
	  if (isTypedArrayIndex(target, key)
	    && isObject(descriptor)
	    && hasOwn(descriptor, 'value')
	    && !hasOwn(descriptor, 'get')
	    && !hasOwn(descriptor, 'set')
	    // TODO: add validation descriptor w/o calling accessors
	    && !descriptor.configurable
	    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
	    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
	  ) {
	    target[key] = descriptor.value;
	    return target;
	  } return nativeDefineProperty(target, key, descriptor);
	};
	
	if (DESCRIPTORS) {
	  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
	    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
	    definePropertyModule.f = wrappedDefineProperty;
	    addGetter(TypedArrayPrototype, 'buffer');
	    addGetter(TypedArrayPrototype, 'byteOffset');
	    addGetter(TypedArrayPrototype, 'byteLength');
	    addGetter(TypedArrayPrototype, 'length');
	  }
	
	  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
	    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
	    defineProperty: wrappedDefineProperty
	  });
	
	  module.exports = function (TYPE, wrapper, CLAMPED) {
	    var BYTES = TYPE.match(/\d+/)[0] / 8;
	    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + TYPE;
	    var SETTER = 'set' + TYPE;
	    var NativeTypedArrayConstructor = globalThis[CONSTRUCTOR_NAME];
	    var TypedArrayConstructor = NativeTypedArrayConstructor;
	    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
	    var exported = {};
	
	    var getter = function (that, index) {
	      var data = getInternalState(that);
	      return data.view[GETTER](index * BYTES + data.byteOffset, true);
	    };
	
	    var setter = function (that, index, value) {
	      var data = getInternalState(that);
	      data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
	    };
	
	    var addElement = function (that, index) {
	      nativeDefineProperty(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	
	    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
	      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
	        anInstance(that, TypedArrayConstructorPrototype);
	        var index = 0;
	        var byteOffset = 0;
	        var buffer, byteLength, length;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new ArrayBuffer(byteLength);
	        } else if (isArrayBuffer(data)) {
	          buffer = data;
	          byteOffset = toOffset(offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw new RangeError(WRONG_LENGTH);
	            byteLength = $len - byteOffset;
	            if (byteLength < 0) throw new RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + byteOffset > $len) throw new RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (isTypedArray(data)) {
	          return arrayFromConstructorAndList(TypedArrayConstructor, data);
	        } else {
	          return call(typedArrayFrom, TypedArrayConstructor, data);
	        }
	        setInternalState(that, {
	          buffer: buffer,
	          byteOffset: byteOffset,
	          byteLength: byteLength,
	          length: length,
	          view: new DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	
	      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
	      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
	    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
	      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
	        anInstance(dummy, TypedArrayConstructorPrototype);
	        return inheritIfRequired(function () {
	          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
	          if (isArrayBuffer(data)) return $length !== undefined
	            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
	            : typedArrayOffset !== undefined
	              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
	              : new NativeTypedArrayConstructor(data);
	          if (isTypedArray(data)) return arrayFromConstructorAndList(TypedArrayConstructor, data);
	          return call(typedArrayFrom, TypedArrayConstructor, data);
	        }(), dummy, TypedArrayConstructor);
	      });
	
	      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
	      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
	        if (!(key in TypedArrayConstructor)) {
	          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
	        }
	      });
	      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
	    }
	
	    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
	      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
	    }
	
	    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
	
	    if (TYPED_ARRAY_TAG) {
	      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
	    }
	
	    var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;
	
	    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
	
	    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
	      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
	    }
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
	      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
	    }
	
	    setSpecies(CONSTRUCTOR_NAME);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1682),
	    Map = __webpack_require__(447),
	    Promise = __webpack_require__(1684),
	    Set = __webpack_require__(1685),
	    WeakMap = __webpack_require__(1687),
	    baseGetTag = __webpack_require__(68),
	    toSource = __webpack_require__(783);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    getPrototype = __webpack_require__(322),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(803);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(164);
	
	var emptyFunction = __webpack_require__(93);
	var warning = __webpack_require__(35);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSWizardHelperScss = __webpack_require__(196);
	
	var _DSWizardHelperScss2 = _interopRequireDefault(_DSWizardHelperScss);
	
	var _reactSelectLibCreatable = __webpack_require__(165);
	
	var _reactSelectLibCreatable2 = _interopRequireDefault(_reactSelectLibCreatable);
	
	var _reactSelect = __webpack_require__(105);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _environmentsCoffee = __webpack_require__(392);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ = (0, _libI18n2['default'])('dswizard');
	
	var selectInFocusWithin = false;
	/**
	 * Customization object for the react-select using the same style like other components on tha site.
	 */
	var customCreatableSelectStyles = {
	    control: function control(base, state) {
	        selectInFocusWithin = state.isFocused;
	        return _extends({}, base, {
	            flex: "4",
	            fontSize: "12px",
	            display: "flex",
	            justifyContent: "flex-end",
	            alignItems: "flex-end",
	            color: "#000",
	            backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
	            borderColor: "#d9d9d9 #ccc #b3b3b3",
	            borderRadius: "2px",
	            border: "1px solid #d9d9d9",
	            minHeight: "25px",
	            maxHeight: "auto",
	            //height: state.isFocused ? "auto" : "25px",
	            boxShadow: state.isFocused ? null : null,
	            "&:hover": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            "&:focus": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            padding: 0,
	            margin: 0,
	            overflow: state.isFocused ? null : "hidden"
	        });
	    },
	    menu: function menu(base) {
	        return _extends({}, base, {
	            borderRadius: 2,
	            hyphens: "auto",
	            marginTop: 0,
	            textAlign: "left",
	            wordWrap: "break-word"
	        });
	    },
	    menuList: function menuList(base) {
	        return _extends({}, base, {
	            padding: 0,
	            verticalAlign: "baseline"
	        });
	    },
	    singleValue: function singleValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            color: "black"
	        });
	    },
	    multiValue: function multiValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            maxHeight: "18px",
	            border: "0.5px solid #003366",
	            background: '#003366',
	            color: "black",
	            div: {
	                color: "black",
	                fontSize: '1.2em',
	                lineHeight: '0.8em'
	            }
	        });
	    },
	    /* noOptionsMessage: (base, state) => ({
	        ...base,
	        padding: 0,
	        height: "20px",
	        lineHeight: "16px"
	    }), */
	    option: function option(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            fontSize: '1em',
	            maxHeight: "25px"
	        });
	    },
	    valueContainer: function valueContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            top: 0
	        });
	    },
	    multiValueRemove: function multiValueRemove(base, state) {
	        return _extends({}, base, {
	            display: state.isDisabled ? "none" : null,
	            padding: 0
	        });
	    },
	    clearIndicator: function clearIndicator(base, state) {
	        return _extends({}, base, {
	            padding: 0
	        });
	    },
	    dropdownIndicator: function dropdownIndicator(base, state) {
	        return _extends({}, base, {
	            marginTop: 0,
	            padding: 0
	        });
	    },
	    indicatorsContainer: function indicatorsContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "23px",
	            top: 0
	        });
	    },
	    indicatorSeparator: function indicatorSeparator(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "0",
	            top: 0
	        });
	    },
	    group: function group(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            top: 0
	        });
	    },
	    groupHeading: function groupHeading(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            top: 0
	        });
	    },
	    input: function input(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: "2px 0 0 0",
	            height: "20px",
	            top: 0,
	            fontSize: '1.2em',
	            lineHeight: '0.8em',
	            width: selectInFocusWithin ? '100%!important' : 'auto',
	            div: {
	                width: selectInFocusWithin ? '100%!important' : 'auto',
	                input: {
	                    width: selectInFocusWithin ? '100%!important' : 'auto'
	                }
	            }
	        });
	    },
	    noOptionsMessage: function noOptionsMessage(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            fontSize: '1em'
	        });
	    },
	    placeholder: function placeholder(base, state) {
	        return _extends({}, base, {
	            fontSize: '1.1em',
	            lineHeight: '1.1em'
	        });
	    }
	};
	
	exports.customCreatableSelectStyles = customCreatableSelectStyles;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var DropdownIndicator = function DropdownIndicator(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.DropdownIndicator,
	        props,
	        _react2['default'].createElement(
	            'span',
	            { className: _DSWizardHelperScss2['default'].downArrowHolder },
	            _react2['default'].createElement('span', { className: _DSWizardHelperScss2['default'].downArrow })
	        )
	    );
	};
	
	exports.DropdownIndicator = DropdownIndicator;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var NoOptionsMessage = function NoOptionsMessage(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.NoOptionsMessage,
	        props,
	        props.selectProps.noOptionsLabel || _('noOptions')
	    );
	};
	
	exports.NoOptionsMessage = NoOptionsMessage;
	var getDeleteIcon = function getDeleteIcon() {
	    try {
	        return __webpack_require__(79);
	    } catch (err) {
	        return __webpack_require__(23);
	    }
	};
	
	/**
	 *
	 * @param {*} props
	 */
	var SelectRemovableOption = function SelectRemovableOption(props) {
	    return _react2['default'].createElement(
	        'div',
	        { className: _DSWizardHelperScss2['default'].creatableOptionContainer },
	        _react2['default'].createElement(_reactSelect.components.Option, _extends({}, props, { className: _DSWizardHelperScss2['default'].creatableOptionItem })),
	        props.data.isRecent ? _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(
	                'button',
	                { type: 'button', className: _DSWizardHelperScss2['default'].creatableOptionItem, onClick: function (event) {
	                        event.preventDefault();
	                        props['delete'](props.value);
	                    } },
	                _react2['default'].createElement('img', { src: getDeleteIcon() })
	            )
	        ) : null
	    );
	};
	
	/**
	 * This is a custom MultiValueRemove for react select to be able set a separate unremovable value in dropdown
	 * but the rest is still dynamic
	 * @param {object} props
	 */
	var MultiValueRemove = function MultiValueRemove(props) {
	    return _react2['default'].createElement(
	        _reactSelect.components.MultiValueRemove,
	        props,
	        !props.data.isPermanentSelected ? props.children : null,
	        !props.data.isPermanentSelected ? props.children : null
	    );
	};
	
	var MultiValueContainer = function MultiValueContainer(props) {
	    return _react2['default'].createElement(
	        'span',
	        { className: _DSWizardHelperScss2['default'].elementsInRow },
	        props.data.firstCC ? _react2['default'].createElement(
	            'span',
	            { className: _DSWizardHelperScss2['default'].elementsInRow },
	            _react2['default'].createElement(
	                'span',
	                { className: _DSWizardHelperScss2['default'].ccSpan },
	                'CC: '
	            ),
	            ' ',
	            _react2['default'].createElement(_reactSelect.components.MultiValueContainer, props)
	        ) : _react2['default'].createElement(_reactSelect.components.MultiValueContainer, props)
	    );
	};
	
	var ValueContainer = function ValueContainer(_ref) {
	    var children = _ref.children;
	
	    var props = _objectWithoutProperties(_ref, ['children']);
	
	    // sort the recipients and mark the first CC to render a separator between recipients
	    /* if (children && children[0] && children[0].length) {
	        children[0].sort((a,b) => {
	            return a.props.data.isCC > b.props.data.isCC ? 1 : -1
	        })
	        let firstCCIndex = -1
	        children[0].forEach((item, index)=>{
	            firstCCIndex === -1 && item.props.data.isCC ? (firstCCIndex = index) : null
	        })
	        if (firstCCIndex !== -1) {
	            children[0][firstCCIndex].props.data.firstCC = true
	        }
	    } */
	    return _react2['default'].createElement(
	        _reactSelect.components.ValueContainer,
	        _extends({}, props, { className: _DSWizardHelperScss2['default'].selectValueContainer }),
	        _react2['default'].createElement(
	            'div',
	            { className: _DSWizardHelperScss2['default'].composeRecipients },
	            children
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: _DSWizardHelperScss2['default'].ccButtonHolder },
	            props.selectProps.showExtraButton ? _react2['default'].createElement(
	                'div',
	                { className: _DSWizardHelperScss2['default'].ccButtonInSelect, onClick: function (e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        props.selectProps.onClickExtraButton(e);
	                    } },
	                'CC'
	            ) : null
	        )
	    );
	};
	
	/**
	 * To validate the inserting value you can use this property for CreatableSelect
	 * "isValidNewOption={(value)=>{
	 *      return isAnEmail(value.trim())
	 * }}"
	 *
	 */
	
	var CustomSelect = (function (_React$Component) {
	    _inherits(CustomSelect, _React$Component);
	
	    _createClass(CustomSelect, null, [{
	        key: 'propTypes',
	        value: {
	            formatCreateLabel: _react2['default'].PropTypes.string,
	            customClassName: _react2['default'].PropTypes.string,
	            handleOnBlur: _react2['default'].PropTypes.func,
	            setDeleteItemByOption: _react2['default'].PropTypes.func,
	            showExtraButton: _react2['default'].PropTypes.bool,
	            isCreatableSelect: _react2['default'].PropTypes.bool,
	            onClickExtraButton: _react2['default'].PropTypes.func
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            isCreatableSelect: true
	        },
	        enumerable: true
	    }]);
	
	    function CustomSelect(props) {
	        _classCallCheck(this, CustomSelect);
	
	        _get(Object.getPrototypeOf(CustomSelect.prototype), 'constructor', this).call(this, props);
	    }
	
	    //--------------------------------------------------------------------------------------------
	    // Section of random stuffs/tools for DSWizard what are used for processing/resolving few simple tings
	    // and take place in the code.
	    //--------------------------------------------------------------------------------------------
	
	    /**
	    * Determine if the form is valid for tarification module.
	    * @param {*} moduleKey
	    * @param {*} packageDSDocuments
	    * @returns Bool - true if the requirements are satisfied
	    */
	
	    /**
	     * Must handle on blur because else loose values. ()
	     * @param {*} event
	     */
	
	    _createClass(CustomSelect, [{
	        key: 'handleOnBlur',
	        value: function handleOnBlur(event) {
	            var /* value, */onChange = this.props.onChange;
	
	            /*let newValue = []
	             if (value && value.value) {
	                newValue = newValue.concat( value.value )
	            }
	             if (event && event.target && event.target.value) {
	                newValue.push({label: event.target.value, value: event.target.value})
	            } */
	
	            // add values to the list when blur, otherwise that will be lost
	            onChange({ label: event.target.value, value: event.target.value });
	
	            return newValue;
	        }
	
	        /**
	         * Render creatable select
	         */
	    }, {
	        key: 'renderCreatable',
	        value: function renderCreatable() {
	            var _this = this;
	
	            var _props = this.props;
	            var formatCreateLabel = _props.formatCreateLabel;
	            var handleOnBlur = _props.handleOnBlur;
	            var customClassName = _props.customClassName;
	            var showExtraButton = _props.showExtraButton;
	            var onClickExtraButton = _props.onClickExtraButton;
	            var setDeleteItemByOption = _props.setDeleteItemByOption;
	            var noOptionsLabel = _props.noOptionsLabel;
	
	            return _react2['default'].createElement(_reactSelectLibCreatable2['default'], _extends({}, this.props, {
	                onBlur: function (e) {
	                    if (handleOnBlur) {
	                        handleOnBlur(e);
	                    } else {
	                        _this.handleOnBlur(e);
	                    }
	                },
	                noOptionsLabel: noOptionsLabel,
	                openMenuOnFocus: true,
	                placeholder: '',
	                onBlurResetsInput: false,
	                isSearchable: true,
	                styles: customCreatableSelectStyles,
	                formatCreateLabel: function (value) {
	                    return formatCreateLabel + ' ' + value;
	                },
	                components: {
	                    DropdownIndicator: DropdownIndicator, NoOptionsMessage: NoOptionsMessage, Option: function Option(p) {
	                        return SelectRemovableOption(_extends({}, p, { 'delete': setDeleteItemByOption }));
	                    },
	                    MultiValueRemove: MultiValueRemove, /* MultiValueContainer,*/ValueContainer: ValueContainer
	                },
	                className: customClassName,
	                showExtraButton: showExtraButton && !isDisabled,
	                onClickExtraButton: onClickExtraButton
	            }));
	        }
	
	        /**
	         * Render regular select
	         */
	    }, {
	        key: 'renderSelect',
	        value: function renderSelect() {
	            var _this2 = this;
	
	            var _props2 = this.props;
	            var handleOnBlur = _props2.handleOnBlur;
	            var customClassName = _props2.customClassName;
	            var showExtraButton = _props2.showExtraButton;
	            var onClickExtraButton = _props2.onClickExtraButton;
	            var setDeleteItemByOption = _props2.setDeleteItemByOption;
	            var noOptionsLabel = _props2.noOptionsLabel;
	
	            // placeholder={_('searchPromptText')}
	            return _react2['default'].createElement(_reactSelect2['default'], _extends({}, this.props, {
	                value: this.props.value || "",
	                onBlur: function (e) {
	                    if (handleOnBlur) {
	                        handleOnBlur(e);
	                    } else {
	                        _this2.handleOnBlur(e);
	                    }
	                },
	                noOptionsLabel: noOptionsLabel,
	                openMenuOnFocus: true,
	                placeholder: '',
	                onBlurResetsInput: false,
	                isSearchable: true,
	                styles: customCreatableSelectStyles,
	                components: { DropdownIndicator: DropdownIndicator, NoOptionsMessage: NoOptionsMessage, Option: function Option(p) {
	                        return SelectRemovableOption(_extends({}, p, { 'delete': setDeleteItemByOption }));
	                    },
	                    MultiValueRemove: MultiValueRemove, /* MultiValueContainer,*/ValueContainer: ValueContainer },
	                className: customClassName,
	                showExtraButton: showExtraButton && !isDisabled,
	                onClickExtraButton: onClickExtraButton
	            }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isCreatableSelect = this.props.isCreatableSelect;
	
	            return isCreatableSelect ? this.renderCreatable() : this.renderSelect();
	        }
	    }]);
	
	    return CustomSelect;
	})(_react2['default'].Component);
	
	exports['default'] = CustomSelect;
	var isATarificationAndHasAMarkedTemplate = function isATarificationAndHasAMarkedTemplate(moduleKey, packageDSDocuments, subModuleKey) {
	    // check if we are on tarification module to check the specific rules for this module
	    var isRequiredTarification = moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION;
	
	    // check if there is set one of the marked document templates to be able to validate the form.
	    var hasSetOneObligatedTemplate = false;
	    if (packageDSDocuments) {
	        packageDSDocuments.forEach(function (oneDocument) {
	            hasSetOneObligatedTemplate = hasSetOneObligatedTemplate || _nestedProperty2['default'].get(oneDocument, "documentTemplate.requiredOnOffers");
	        });
	    }
	
	    return isRequiredTarification && hasSetOneObligatedTemplate;
	};
	
	exports.isATarificationAndHasAMarkedTemplate = isATarificationAndHasAMarkedTemplate;
	/**
	* Determine if the form is valid for mandate (prem) module.
	* @param {*} moduleKey
	* @param {*} packageDSDocuments
	* @returns Bool - true if the requirements are satisfied
	*/
	var isMandateAndHasAMarkedTemplate = function isMandateAndHasAMarkedTemplate(moduleKey, packageDSDocuments, subModuleKey) {
	    // check if we are on mandate module to check the specific rules for this module
	    var isRequiredMandate = moduleKey === c.DS_MODULE_CLIENT_CONTRACT_PREM;
	
	    // check if there is set one of the marked document templates to be able to validate the form.
	    var hasSetOneObligatedTemplate = false;
	    if (packageDSDocuments) {
	        packageDSDocuments.forEach(function (oneDocument) {
	            hasSetOneObligatedTemplate = hasSetOneObligatedTemplate || _nestedProperty2['default'].get(oneDocument, "documentTemplate.requiredOnPrem");
	        });
	    }
	
	    return isRequiredMandate && hasSetOneObligatedTemplate;
	};
	exports.isMandateAndHasAMarkedTemplate = isMandateAndHasAMarkedTemplate;
	/**
	 * Get the moduleKey from package if loaded
	 */
	var getModuleKeyOfPackage = function getModuleKeyOfPackage(packageDSDocuments) {
	    var packageInstance = {};
	    if (packageDSDocuments) {
	        packageInstance = _nestedProperty2['default'].get(packageDSDocuments, "0.package");
	    }
	
	    return _nestedProperty2['default'].get(packageInstance, "uploadedOnModule");
	};
	
	exports.getModuleKeyOfPackage = getModuleKeyOfPackage;
	/**
	 * Get the suModuleKey from package if loaded
	 */
	var getSubModuleKeyOfPackage = function getSubModuleKeyOfPackage(packageDSDocuments) {
	    var packageInstance = {};
	    if (packageDSDocuments) {
	        packageInstance = _nestedProperty2['default'].get(packageDSDocuments, "0.package");
	    }
	
	    return _nestedProperty2['default'].get(packageInstance, "subModuleKey");
	};
	
	exports.getSubModuleKeyOfPackage = getSubModuleKeyOfPackage;
	/**
	 * This function provide a list for select of intervals durations
	 */
	var getRemainderIntervalOptionList = function getRemainderIntervalOptionList(security) {
	    var remainderIntervalOptions = _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervals");
	    //nesProp.get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervalRepeat")
	
	    if (remainderIntervalOptions) {
	        remainderIntervalOptions = remainderIntervalOptions.map(function (item) {
	            return _extends({}, item, {
	                label: _('remainderIntervalOptions_' + item.value)
	            });
	        });
	    }
	
	    return remainderIntervalOptions;
	};
	
	exports.getRemainderIntervalOptionList = getRemainderIntervalOptionList;
	/**
	 * This function provide a list for select of intervals repeats
	 */
	var getRemainderRepeatsOptionList = function getRemainderRepeatsOptionList(security) {
	    var remainderRepeatsOptions = _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervalRepeat");
	
	    if (remainderRepeatsOptions) {
	        remainderRepeatsOptions = remainderRepeatsOptions.map(function (item) {
	            return _extends({}, item, {
	                label: _('remainderRepeatsOptions_' + item.value)
	            });
	        });
	    }
	
	    return remainderRepeatsOptions;
	};
	
	exports.getRemainderRepeatsOptionList = getRemainderRepeatsOptionList;
	/**
	* This function provide a list for select of document types
	*/
	var getDocumentTemplateOptionList = function getDocumentTemplateOptionList(templates, lang, moduleKey, subModuleKey) {
	    var returnOnlyRequiredOnPrem = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
	    var doctypeFromClaimWizard = arguments.length <= 5 || arguments[5] === undefined ? '' : arguments[5];
	
	    var result = [];
	
	    // no templates found
	    if (!templates || templates.length == 0) {
	        console.warn("Trying to process template list, but no template loaded yet.");
	        return result;
	    }
	
	    // check if there is prem case or if wizard is from office module or claim wizard where the documents are strict restricted and preselected
	    var isPrem = moduleKey === c.DS_MODULE_CLIENT_CONTRACT_PREM;
	    var isOffice = moduleKey === c.DS_MODULE_OFFICE;
	    var isClaimWizard = moduleKey === c.DS_MODULE_CLAIM_WIZARD;
	    var isClaimsModule = moduleKey === c.DS_MODULE_CLIENT_CLAIMS;
	
	    // filter the available templates for the current module
	    result = templates.filter(function (item) {
	        var isEnabled = false;
	        var noModuleRestriction = !item.availableOnModule || item.availableOnModule.length == 0;
	
	        // no restriction, means is available
	        if (noModuleRestriction && !isPrem && !isOffice && !isClaimWizard && !isClaimsModule) {
	            isEnabled = true;
	        }
	
	        // check the current module in the template whitelist
	        if (!noModuleRestriction) {
	            var matches = item.availableOnModule.filter(function (oneModuleFlag) {
	                var shouldKeep = false;
	
	                // normal case, keep the templates enabled on the template
	                if (oneModuleFlag.module == moduleKey) {
	                    shouldKeep = true;
	                }
	
	                // BEWB-880 there should be available only documents that have available on tarification module and if is detail page just remove the ones that are required for offers
	                if (moduleKey == c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey == c.DS_MODULE_CLIENT_TARIFICATION && item.requiredOnOffers) {
	                    shouldKeep = false;
	                }
	
	                //handle new prem functionality when requiredOnPrem should not be visible in regular options list but has to be selected by default
	                if (isPrem && (!item.requiredOnPrem && returnOnlyRequiredOnPrem || item.requiredOnPrem && !returnOnlyRequiredOnPrem)) {
	                    shouldKeep = false;
	                } else if (isPrem && item.requiredOnPrem && returnOnlyRequiredOnPrem) {
	                    shouldKeep = true;
	                }
	
	                // when is claimWizardModule, document template available shout match lowValue to document type from claimWizard
	                if (isClaimWizard && oneModuleFlag.module === moduleKey && item.indexType.lowValue && item.indexType.lowValue === doctypeFromClaimWizard) {
	                    shouldKeep = true;
	                } else if (isClaimWizard && oneModuleFlag.module === moduleKey && item.indexType.lowValue && item.indexType.lowValue !== doctypeFromClaimWizard) {
	                    shouldKeep = false;
	                }
	                return shouldKeep;
	            });
	
	            if (matches.length > 0) {
	                isEnabled = true;
	            }
	        }
	
	        return isEnabled;
	    });
	
	    // reconstruct hierarchy
	    result = result.map(function (item) {
	        return {
	            label: item && item.title && (item.title[lang] || item.title['nl'] || item.title['fr'] || item.title['en']) || '!!! no title template',
	            value: item._id,
	            teamList: item.teamList,
	            teamSubgroupList: item.levenSubgroups
	        };
	    });
	
	    // sort result in Alphabetic order
	    result = result.sort(function (item, item2) {
	        if (item.label < item2.label) {
	            return -1;
	        }
	        if (item.label > item2.label) {
	            return 1;
	        }
	        if (item.label === item2.label) {
	            return 0;
	        }
	    }) || [];
	
	    return result;
	};
	
	exports.getDocumentTemplateOptionList = getDocumentTemplateOptionList;
	/**
	 * This function provide a list for select of languages
	 */
	var getLanguageOptionList = function getLanguageOptionList() {
	    return [{ value: 'nl', label: _("nl") }, { value: 'fr', label: _("fr") }];
	};
	
	exports.getLanguageOptionList = getLanguageOptionList;
	/***
	 * This function return a the list of teams on the preferred language.
	 * The result is in [{value:, label:},...] form to be digestible for Select input.
	 *
	 * @param {*} clientOptionsDict
	 * @param {*} appLanguage
	 * @returns
	 */
	
	//{value: 'en', label: _("en")},
	var getTeamsOptionList = function getTeamsOptionList(clientOptionsDict, appLanguage) {
	    var rawWillemotTeams = clientOptionsDict && clientOptionsDict['TEAM_WILLEMOT'] || {};
	    var teams = [];
	
	    Object.keys(rawWillemotTeams).forEach(function (key) {
	        teams.push({
	            value: key,
	            label: rawWillemotTeams[key][appLanguage]
	        });
	    });
	
	    return teams;
	};
	
	exports.getTeamsOptionList = getTeamsOptionList;
	/***
	 * This function return a the list of team subgroups on the preferred language.
	 * The result is in [{value:, label:},...] form to be digestible for Select input.
	 *
	 * @param {*} clientOptionsDict
	 * @param {*} appLanguage
	 * @returns
	 */
	var getTeamSubgroupsOptionList = function getTeamSubgroupsOptionList(subgroupsList, appLanguage) {
	    var subGroups = [];
	
	    if (!subgroupsList || subgroupsList.length === 0) {
	        return [];
	    }
	
	    subgroupsList.forEach(function (oneSubgroup) {
	        subGroups.push({
	            value: String(oneSubgroup._id),
	            label: oneSubgroup[appLanguage] || oneSubgroup['nl']
	        });
	    });
	
	    return subGroups;
	};
	
	exports.getTeamSubgroupsOptionList = getTeamSubgroupsOptionList;
	/**
	 * This function will return true in case when all of the packages has tarification number set.
	 * Will return with false when one of the documents template require tarification number but not set.
	 * @param {*} packageDSDocuments
	 */
	var allDocumentsHasTarificationNumber = function allDocumentsHasTarificationNumber(packageDSDocuments) {
	
	    // if no documents then no tarification id needed
	    if (!packageDSDocuments || packageDSDocuments.length == 0) {
	        return true;
	    }
	
	    // initialise result value
	    var allHasTarificationNumber = true;
	
	    // iterate the array for values
	    packageDSDocuments.forEach(function (oneDocument, index) {
	        var oneTemplate = _nestedProperty2['default'].get(packageDSDocuments, index + ".documentTemplate");
	        var subModuleKey = _nestedProperty2['default'].get(packageDSDocuments, index + ".subModuleKey");
	        var isTarificationModuleRequired = _nestedProperty2['default'].get(oneTemplate, "uploadedOnModule") == c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION;
	        var hasTarificationNumber = _nestedProperty2['default'].get(packageDSDocuments, index + ".tarificationNumber");
	
	        // in case when a template require a tarification number but there is not tarification linked, we set the result to false
	        if (isTarificationModuleRequired && !hasTarificationNumber) {
	            allHasTarificationNumber = false;
	        }
	    });
	
	    return allHasTarificationNumber;
	};
	
	exports.allDocumentsHasTarificationNumber = allDocumentsHasTarificationNumber;
	/**
	 * This function will return the list of tarificationNumbers used
	 * @param {Array} packageDSDocuments
	 * @returns Array with objects
	 */
	var getDocumentsTarificationNumbersList = function getDocumentsTarificationNumbersList(packageDSDocuments) {
	
	    // if no documents then no tarification id needed
	    if (!packageDSDocuments || packageDSDocuments.length == 0) {
	        return [];
	    }
	
	    // initialise result value
	    var numbersList = [];
	
	    // iterate the array for values
	    packageDSDocuments.forEach(function (oneDocument, index) {
	        var oneTemplate = _nestedProperty2['default'].get(packageDSDocuments, index + ".documentTemplate");
	        var isTarificationModuleRequired = _nestedProperty2['default'].get(oneTemplate, "uploadedOnModule") !== c.DS_MODULE_CLIENT_TARIFICATION;
	        var tarificationNumber = _nestedProperty2['default'].get(packageDSDocuments, index + ".tarificationNumber");
	        var tarificationId = _nestedProperty2['default'].get(packageDSDocuments, index + ".tarificationId");
	
	        // in case when a template require a tarification number but there is not tarification linked, we set the result to false
	        if (isTarificationModuleRequired && tarificationNumber) {
	            numbersList.push({ tarificationId: tarificationId, tarificationNumber: tarificationNumber });
	        }
	    });
	
	    return numbersList;
	};
	
	exports.getDocumentsTarificationNumbersList = getDocumentsTarificationNumbersList;
	/**
	 * Filter the team list for the current broker using the values got from auth procedure.
	 * If no whitelist for the current broker, then no teams can be selected in the form.
	 * @param {*} teamsOptions
	 * @param {*} whiteList
	 * @param {*} brokerNumber
	 * @returns
	 */
	var filterTeamsForBroker = function filterTeamsForBroker(teamsOptions, whiteList, brokerNumber) {
	    // parameter check
	    if (!teamsOptions || !whiteList || !brokerNumber) {
	        return [];
	    }
	
	    // select whitelist by broker number
	    var currentWhiteList = _nestedProperty2['default'].get(whiteList, brokerNumber);
	
	    // no white list the no teams can be selected
	    if (!currentWhiteList || currentWhiteList.length == 0) {
	        return [];
	    }
	
	    // filter the list by broker white list
	    var filteredTeams = teamsOptions.filter(function (oneTeamOption) {
	        // determine initial value for the flag what decide if the current option can be used by the broker
	        var canKeep = false;
	
	        // check if the team can be remain
	        currentWhiteList.forEach(function (oneWhiteTeam) {
	            if (String(oneWhiteTeam) === String(oneTeamOption.value)) {
	                canKeep = true;
	            }
	        });
	
	        return canKeep;
	    });
	
	    return filteredTeams;
	};
	
	exports.filterTeamsForBroker = filterTeamsForBroker;
	/**
	 * Filter the team list for the current broker using the values got from auth procedure.
	 * If no whitelist for the current broker, then no teams can be selected in the form.
	 * @param {*} documentTemplateOptions
	 * @param {*} whiteList
	 * @param {*} brokerNumber
	 * @param {*} teamIndex
	 * @param {*} teamSubgroupId
	 * @returns
	 */
	var filterTemplatesForBroker = function filterTemplatesForBroker(documentTemplateOptions, whiteList, brokerNumber) {
	    var teamIndex = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	    var teamSubgroupId = arguments.length <= 4 || arguments[4] === undefined ? "" : arguments[4];
	
	    // parameter check
	    if (!documentTemplateOptions || !whiteList || !brokerNumber) {
	        console.error("filterTemplatesForBroker NO ARGS: ", "documentTemplateOptions: ", documentTemplateOptions);
	        console.error("filterTemplatesForBroker NO ARGS: ", "whiteList: ", whiteList);
	        console.error("filterTemplatesForBroker NO ARGS: ", "brokerNumber: ", brokerNumber);
	        return [];
	    }
	
	    // select whitelist by broker number
	    var currentWhiteList = _nestedProperty2['default'].get(whiteList, brokerNumber);
	
	    // no white list the no teams can be selected
	    if (!currentWhiteList || currentWhiteList.length == 0) {
	        return [];
	    }
	
	    // filter the list by broker white list
	    var filteredTemplates = documentTemplateOptions.filter(function (oneTemplateOption) {
	        // determine initial value for the flag what decide if the current option can be used by the broker
	        var canKeep = false;
	        var templateTeamList = _nestedProperty2['default'].get(oneTemplateOption, "teamList") || [];
	
	        // check if the team can be remain
	        currentWhiteList.forEach(function (oneWhiteTeam) {
	            templateTeamList.forEach(function (oneTemplateTeam) {
	                // can keep if the whitelists are intersected
	                if (String(oneWhiteTeam) === String(oneTemplateTeam.teamIndex)) {
	                    // can keep if there is a selected team and that is supported by the template
	                    if (!teamIndex || teamIndex && String(teamIndex) === String(oneTemplateTeam.teamIndex)) {
	                        if (teamSubgroupId && oneTemplateOption.teamSubgroupList && oneTemplateOption.teamSubgroupList.length > 0) {
	                            oneTemplateOption.teamSubgroupList.forEach(function (oneSubgroup) {
	                                // if there is a subgroup selected and a template has a list of subgroups, then must be filtered for the group
	                                if (String(oneSubgroup.subgroup) === String(teamSubgroupId)) {
	                                    canKeep = true;
	                                }
	                            });
	                        } else {
	                            // if not subgroup specified then the template should keep for listing
	                            canKeep = true;
	                        }
	                    }
	                }
	            });
	        });
	
	        return canKeep;
	    });
	
	    return filteredTemplates;
	};
	
	exports.filterTemplatesForBroker = filterTemplatesForBroker;
	/**
	 * Returns a whitelist object with arrays containing indexes of teams for the brokers
	 * @param {*} brokers - brokers list from Oracle: {brNr: main: teamsWillemot: []}
	 * @returns object with arrays, indexed by brokerNumber
	 */
	var processBrokerWhiteListFromBrokersList = function processBrokerWhiteListFromBrokersList(brokers) {
	    if (!brokers) {
	        return {};
	    }
	
	    var brokerNumberList = Object.keys(brokers);
	
	    if (brokerNumberList.length === 0) {
	        return {};
	    }
	
	    var result = {};
	
	    brokerNumberList.forEach(function (brokerNumber) {
	        var oneBroker = brokers[brokerNumber];
	        var teamsWilleot = _nestedProperty2['default'].get(oneBroker, "main.teamsWillemot");
	
	        result[brokerNumber] = teamsWilleot;
	    });
	
	    return result;
	};
	
	exports.processBrokerWhiteListFromBrokersList = processBrokerWhiteListFromBrokersList;
	/**
	 * This function parse a package after documents with template what are sent to connective.
	 * If there is documents sent to connective then return true, else return false.
	 * @param {*} packageDSDocuments - list of documents from state store
	 * @returns Boolean
	 */
	var areThereDocumentSentToConnective = function areThereDocumentSentToConnective(packageDSDocuments, DSDocumentOriginTypes) {
	
	    // if no documents then no documents sent for connective
	    if (!packageDSDocuments || packageDSDocuments.length == 0) {
	        return false;
	    }
	
	    // initialise result value
	    var areDocuments = false;
	
	    // parse all documents to know if there is a document for signing or not
	    packageDSDocuments.forEach(function (oneDocument) {
	        var oneTemplate = _nestedProperty2['default'].get(oneDocument, "documentTemplate");
	        var mustBeSignedThisDocument = isDocumentMustBeSigned(DSDocumentOriginTypes, oneDocument.origin, oneTemplate);
	
	        areDocuments = areDocuments || mustBeSignedThisDocument;
	    });
	
	    return areDocuments;
	};
	
	exports.areThereDocumentSentToConnective = areThereDocumentSentToConnective;
	//--------------------------------------------------------------------------------------------
	// Section where to hold few functions for the DSWizard form.
	// Here are the functions what are necessary to exists, but not needed to see all the time to
	// understand how it is working generally
	//--------------------------------------------------------------------------------------------
	
	/**
	 *
	 * @param {*} formInputs
	 * @param {*} valueList
	 * @returns Patched form inputs
	 */
	var patchFormInputValuesByValueList = function patchFormInputValuesByValueList(formInputs, valueList) {
	    if (!formInputs || !valueList) {
	        return formInputs;
	    }
	
	    var inputNameList = Object.keys(formInputs);
	    var valueNameList = Object.keys(valueList);
	
	    inputNameList.forEach(function (oneInputName) {
	        valueNameList.forEach(function (oneValueName) {
	            if (oneInputName === oneValueName) {
	                formInputs[oneInputName].value = valueList[oneValueName];
	            }
	        });
	    });
	
	    return formInputs;
	};
	
	exports.patchFormInputValuesByValueList = patchFormInputValuesByValueList;
	/**
	 * Return true if there are any of fill ins
	 * @param {number} packageDSDocuments
	 * @returns Boolean - is there is any of the document is filled in the return true
	 */
	var checkDocumentAfterFillIns = function checkDocumentAfterFillIns(packageDSDocuments) {
	    var thereIsAFillIn = false;
	
	    if (!packageDSDocuments || packageDSDocuments.length == 0) {
	        return thereIsAFillIn;
	    }
	
	    packageDSDocuments.forEach(function (item) {
	        if (item.brokerFilledValues && item.brokerFilledValues.length > 0) {
	            thereIsAFillIn = true;
	        }
	    });
	
	    return thereIsAFillIn;
	};
	
	exports.checkDocumentAfterFillIns = checkDocumentAfterFillIns;
	/**
	 * This function find a document from an array of docs by Id
	 * @param {*} docId
	 * @param {*} docList
	 * @returns Document instance from the array
	 */
	var findDocumentFromListById = function findDocumentFromListById(docId, docList) {
	    if (!docList || docList.length == 0 || !docId) {
	        return false;
	    }
	
	    var docListFiltered = docList.filter(function (item) {
	        return String(item._id) === String(docId);
	    });
	
	    if (!docListFiltered || docListFiltered.length == 0) {
	        return false;
	    }
	
	    var theDoc = docListFiltered[0];
	
	    return theDoc;
	};
	
	exports.findDocumentFromListById = findDocumentFromListById;
	/**
	 * This function validate the fill ins and placeholder existence for all of the docs in the list
	 * @param {array} docList DsDocument instance list
	 * @param {number} totalNumberOfSigners stakeholder total count
	 * @param {object} DSDocumentOriginTypes Constants for document origin operations
	 * @returns Document instances with errors or false when there are no errors
	 */
	var getTheListOfInvalidDocuments = function getTheListOfInvalidDocuments(docList, totalNumberOfSigners, DSDocumentOriginTypes) {
	    if (!docList || docList.length == 0) {
	        return false;
	    }
	
	    // result is the list of docs with issues by fields detected from template
	    var docListFiltered = docList.filter(function (item) {
	        return !isValidDocument(item, totalNumberOfSigners, DSDocumentOriginTypes);
	    });
	
	    if (!docListFiltered || docListFiltered.length == 0) {
	        return false;
	    }
	
	    return docListFiltered;
	};
	
	exports.getTheListOfInvalidDocuments = getTheListOfInvalidDocuments;
	/**
	 * This function validate the signers count used.
	 * @param {array} docList DsDocument instance list
	 * @param {number} stakeholders stakeholder total count
	 * @param {object} DSDocumentOriginTypes Constants for document origin operations
	 * @param {object} signerAvailabilityOfTemplates availability
	 * @returns {stakeholderUsageMap, areNonUsedStakeholders}
	 * stakeholderUsageMap object with id value as prop name and boolean value, means is used or not as signer in a ny doc
	 * areNonUsedStakeholders boolean value
	 */
	var isUsedAllOfStakeholders = function isUsedAllOfStakeholders(docList, stakeholders, DSDocumentOriginTypes, signerAvailabilityOfTemplates) {
	    var stakeholderUsageMap = {};
	    var stakeholdersMap = {};
	
	    for (var j = 0; j < stakeholders.length; j++) {
	        var oneStake = stakeholders[j];
	        stakeholderUsageMap[oneStake._id] = oneStake;
	    }
	
	    for (var j = 0; j < stakeholders.length; j++) {
	        var oneStake = stakeholders[j];
	        stakeholdersMap[oneStake._id] = oneStake;
	    }
	
	    if (!docList || docList.length == 0) {
	        return stakeholderUsageMap;
	    }
	
	    // result is the list of docs with issues by fields detected from template
	    for (var i = 0; i < docList.length; i++) {
	        var oneDoc = docList[i];
	
	        // check the uploaded and oracle documents for placed placeholders by stakeholder Id to check the usage
	        if (oneDoc.origin !== DSDocumentOriginTypes.DS_ORIGIN_GENERATED) {
	
	            if (oneDoc.signatureManualPlaceholders && oneDoc.signatureManualPlaceholders.length) {
	                for (var j = 0; j < oneDoc.signatureManualPlaceholders.length; j++) {
	                    var holder = oneDoc.signatureManualPlaceholders[j];
	
	                    stakeholderUsageMap[holder.stakeholderId] = false;
	                } // j var
	            }
	        } else {
	                (function () {
	                    // check the generated documents for placed placeholders by signature placeholder usage
	                    var isItExistFirstSignerPlaceholder = false;
	                    var isItExistSecondSignerPlaceholder = false;
	                    var isItExistBrokerSignerPlaceholder = false;
	                    var templateId = oneDoc.documentTemplateId;
	
	                    // extend the languageWhiteList with the values what support the selected template (check html existence in record)
	                    if (signerAvailabilityOfTemplates && signerAvailabilityOfTemplates.length > 0 && templateId) {
	                        // find template in the list of all templates
	                        var signerAvailabilities = signerAvailabilityOfTemplates.filter(function (item) {
	                            return item.templateId === templateId;
	                        });
	
	                        var signerAvailability = _nestedProperty2['default'].get(signerAvailabilities, "0");
	
	                        // see in the console, if the template have no signer configured in the template content.
	                        if (!signerAvailability) {
	                            console.warn("No signer types available for the template to validate stakeholder usage: ", templateId && templateId._id, "signer types:", signerAvailability);
	                        }
	
	                        if (signerAvailability && signerAvailability.signerTypes) {
	                            isItExistFirstSignerPlaceholder = isItExistFirstSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("CLIENT");
	                            isItExistSecondSignerPlaceholder = isItExistSecondSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("OTHER_PERSON");
	                            isItExistBrokerSignerPlaceholder = isItExistBrokerSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("BROKER");
	                        }
	                    }
	
	                    // iterate existing stakeholders, if they are supported by the template to be able to mark the usage of it.
	                    // if finally there is some stakeholder who are not listed anywhere stays undefined in the stakeholderUsageMap object
	                    for (var j = 0; j < stakeholders.length; j++) {
	                        var oneStake = stakeholders[j];
	
	                        if (oneStake.signerType === "CLIENT" && isItExistFirstSignerPlaceholder) {
	                            stakeholderUsageMap[oneStake._id] = false;
	                        }
	                        if (oneStake.signerType === "OTHER_PERSON" && isItExistSecondSignerPlaceholder) {
	                            stakeholderUsageMap[oneStake._id] = false;
	                        }
	                        if (oneStake.signerType === "BROKER" && isItExistBrokerSignerPlaceholder) {
	                            stakeholderUsageMap[oneStake._id] = false;
	                        }
	                    } // j var
	                })();
	            }
	    } // main for with i var
	
	    var idArray = Object.keys(stakeholderUsageMap);
	
	    var areNonUsedStakeholders = false;
	
	    for (var j = 0; j < idArray.length; j++) {
	        if (stakeholderUsageMap[idArray[j]]) {
	            areNonUsedStakeholders = true;
	        }
	    }
	
	    return { stakeholderUsageMap: stakeholderUsageMap, areNonUsedStakeholders: areNonUsedStakeholders };
	};
	
	exports.isUsedAllOfStakeholders = isUsedAllOfStakeholders;
	/**
	 * @param {array} docList DsDocument instance list
	 * @param {object} DSDocumentOriginTypes Constants for document origin operations
	 */
	var areThereSignableDocuments = function areThereSignableDocuments(docList, DSDocumentOriginTypes) {
	    var mustSigned = false;
	
	    // result is the list of docs with issues by fields detected from template
	    for (var i = 0; i < docList.length; i++) {
	        var oneDoc = docList[i];
	
	        // check the uploaded and oracle documents for placed placeholders by stakeholder Id to check the usage
	        if (oneDoc.origin !== DSDocumentOriginTypes.DS_ORIGIN_GENERATED) {
	            mustSigned = mustSigned && true;
	            break;
	        } else {
	            // let templateId = oneDoc.templateId
	            // // extend the languageWhiteList with the values what support the selected template (check html existence in record)
	            // if (templates && templates.length && templateId) {
	            //     // find template in the list of all templates
	            //     let templateForTheNewDoc = templates.filter((item) => {
	            //         return (item._id === templateId)
	            //     })
	
	            //     // get the template instance from result
	            //     let templateInstance = nesProp.get(templateForTheNewDoc, "0")
	            // }
	
	            mustSigned = mustSigned && oneDoc.documentTemplate.mustBeSigned;
	        }
	    }
	
	    return mustSigned;
	};
	
	exports.areThereSignableDocuments = areThereSignableDocuments;
	/**
	 * This function do a general check for a document if it is valid. The origin of document is taken in consideration.
	 * Error message is set on error
	 * @param {*} document
	 * @param {*} totalNumberOfSigners
	 * @param {*} DSDocumentOriginTypes
	 * @returns
	 */
	var isValidDocument = function isValidDocument(document, totalNumberOfSigners, DSDocumentOriginTypes) {
	    var isValid = false;
	    switch (document.origin) {
	        case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD:
	            {
	                isValid = isPlacedSignaturePlaceholder(document, totalNumberOfSigners);
	                if (document.isAttachment) {
	                    isValid = true;
	                }
	                break;
	            }
	        case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:
	            {
	                isValid = isPlacedSignaturePlaceholder(document, totalNumberOfSigners);
	                break;
	            }
	
	        case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
	        default:
	            {
	                isValid = isValidTheTemplateFill(document);
	
	                // common properties to provide error about a document.
	                // For e.g.: the external validation result, or missing signature placeholder
	                if (document && document.errorMessages && document.errorMessages.length > 0) {
	                    // in case when we have any message about the fields, then the document is invalid
	                    isValid = false;
	                }
	            }
	    }
	
	    return isValid;
	};
	
	exports.isValidDocument = isValidDocument;
	/**
	 * This function checks a document if filled valid. Checking if the required field are valid and if touched the file.
	 * @param {*} dsDocument
	 * @returns
	 */
	var isValidTheTemplateFill = function isValidTheTemplateFill(dsDocument) {
	    var isValidTheDoc = true;
	
	    if (dsDocument && dsDocument.brokerFilledValues) {
	        dsDocument.brokerFilledValues.forEach(function (onField) {
	            if (onField && onField.required && !onField.value) {
	                isValidTheDoc = false;
	            }
	        });
	    } else {
	        isValidTheDoc = false;
	    }
	
	    return isValidTheDoc;
	};
	
	exports.isValidTheTemplateFill = isValidTheTemplateFill;
	/**
	 * Check if signature placeholders are set for document, and all of the signers are added well. No duplicated signers found.
	 * @param {object} document
	 * @param {number} totalNumberOfSigners
	 * @returns boolean
	 */
	var isPlacedSignaturePlaceholder = function isPlacedSignaturePlaceholder(document, totalNumberOfSigners) {
	    var isValid = false;
	    // check if there is any placeholder, and all of the signers are added to the document
	    // <amount> === (totalNumberOfSigners*1)
	    if (document && document.signatureManualPlaceholders && document.signatureManualPlaceholders.length > 0) {
	
	        var stakeholderIdList = document.signatureManualPlaceholders.map(function (onPHolder) {
	            return onPHolder.stakeholderId;
	        }).filter(function (item) {
	            return !!item;
	        });
	
	        // check if no duplicated elements, all are unique stakeholders
	        // rule is: minimum one stakeholder must added (meeting on 22.03.2023)
	        // this rule is no more needed but the snippet is "&& (stakeholderIdList.length === new Set(stakeholderIdList).size)"
	        if (stakeholderIdList && stakeholderIdList.length > 0) {
	            isValid = true;
	        }
	    }
	
	    return isValid;
	};
	
	/**
	 * Filter documents if documents ar loaded.
	 * @param {*} documents
	 * @param {*} packageId
	 * @returns
	*/
	var filterDocumentsByPackageId = function filterDocumentsByPackageId(documents, packageId) {
	    var packageDSDocuments = documents && documents.filter(function (item) {
	        return _nestedProperty2['default'].get(item, "packageId") === packageId;
	    }) || [];
	    return packageDSDocuments;
	};
	
	exports.filterDocumentsByPackageId = filterDocumentsByPackageId;
	/**
	 * This function will check a given documents list for documents that require signing
	 * @param {*} packageDSDocuments
	 * @param {*} DSDocumentOriginTypes the origin types struct
	 * @returns boolean
	 */
	var requireSigning = function requireSigning(packageDSDocuments, DSDocumentOriginTypes) {
	    var docRequireSign = packageDSDocuments.find(function (oneDoc) {
	
	        var isNeededToSign = false;
	        switch (oneDoc.origin) {
	            case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD:
	            case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:
	                {
	                    isNeededToSign = true;
	                    break;
	                }
	
	            case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
	            default:
	                {
	                    isNeededToSign = oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned;
	                }
	        }
	
	        return isNeededToSign;
	    });
	
	    return docRequireSign ? true : false;
	};
	
	exports.requireSigning = requireSigning;
	/**
	 *
	 * @param {*} packageDSDocuments
	 * @param {*} DSDocumentOriginTypes
	 * @returns
	 */
	var requireSmsOtpSigning = function requireSmsOtpSigning(packageDSDocuments, DSDocumentOriginTypes) {
	    var sigType = packageDSDocuments.find(function (oneDoc) {
	
	        var isNeededSmsOtp = false;
	        switch (oneDoc.origin) {
	            case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD:
	            case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:
	                {
	                    isNeededSmsOtp = true;
	                    break;
	                }
	
	            case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
	            default:
	                {
	                    isNeededSmsOtp = oneDoc.documentTemplate && oneDoc.documentTemplate.digitalSignatureType == 'SmsOtp';
	                }
	        }
	
	        return isNeededSmsOtp;
	    });
	    return sigType ? true : false;
	};
	
	exports.requireSmsOtpSigning = requireSmsOtpSigning;
	/**
	 * Check selected email address to saved vilemot addresses
	 * @param {*} email
	 * @returns
	 */
	var isWillemotEmail = function isWillemotEmail(email) {
	    if (_environmentsCoffee.WillemotEmails) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = _environmentsCoffee.WillemotEmails[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var willMail = _step.value;
	
	                if (email.includes(willMail)) {
	                    return true;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    }
	
	    return false;
	};
	
	exports.isWillemotEmail = isWillemotEmail;
	/**
	 * Get all of the client contract numbers in a list what is digestible for react select.
	 */
	var getContractNumbersInOptionList = function getContractNumbersInOptionList(client) {
	    var result = [];
	    var contracts = _nestedProperty2['default'].get(client, "contracts");
	
	    if (!contracts || contracts.length === 0) {
	        return result;
	    }
	
	    var objKeys = Object.keys(contracts);
	    result = objKeys && objKeys.map(function (oneKey) {
	        var contractNumber = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.contractNumber");
	        var contractId = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.contractId");
	        return { label: contractNumber, value: contractNumber, contractId: contractId };
	    });
	
	    return result;
	};
	
	exports.getContractNumbersInOptionList = getContractNumbersInOptionList;
	/**
	 * This function select an id from parameters by
	 * @param {*} moduleType
	 */
	var getEntityIdByModule = function getEntityIdByModule(moduleType, clientId, contractId, claimId, tarificationId) {
	    switch (moduleType) {
	        case "client":
	            {
	                return clientId;
	            }
	        case "contract":
	            {
	                return contractId;
	            }
	        case "tarification":
	            {
	                return tarificationId;
	            }
	        case "claim":
	            {
	                return claimId;
	            }
	    }
	};
	
	exports.getEntityIdByModule = getEntityIdByModule;
	/**
	 * This function select an id from parameters by
	 * @param {*} moduleKey is a constant what is used to initialise the DSWizard, the value is
	 * determined by the given properties of the parent module. All of the possible values are stored as constants.
	 * This function translate the moduleKey value for the uploader module to be initialised correctly.
	 * Cant be used the same constants because the cases differs, don't cover each other, but can be reduced, this is
	 * what does this function exactly.
	 *
	 * @return {String} - argument for moduleType of uploader component.
	 */
	var getModuleTypeByModuleKey = function getModuleTypeByModuleKey(moduleKey) {
	    switch (moduleKey) {
	        case c.DS_MODULE_CLIENT_PROFILE:
	            {
	                return "client";
	            }
	        case c.DS_MODULE_CLIENT_CONTRACT:
	            {
	                return "contract";
	            }
	        case c.DS_MODULE_CLIENT_CONTRACT_PREM:
	            {
	                return "contract";
	            }
	        case c.DS_MODULE_CLIENT_CLAIMS:
	            {
	                return "claim";
	            }
	        case c.DS_MODULE_CLIENT_TARIFICATION:
	            {
	                return "tarification";
	            }
	        case c.DS_MODULE_CLAIM_WIZARD:
	            {
	                return "claim";
	            }
	    }
	};
	
	exports.getModuleTypeByModuleKey = getModuleTypeByModuleKey;
	/**
	 * This function select an id from parameters by
	 * @param {*} moduleKey is a constant what is used to initialise the DSWizard and will
	 * associate with a module key for Emailer system
	 * The module assigning keywords are not the same because, the components have a different amount and kind of sens
	 * of modules, and was implemented in different age of the project.
	 * @return {String} - argument for moduleType of uploader component.
	 */
	var getEmailerModuleKeyByWizardModuleKey = function getEmailerModuleKeyByWizardModuleKey(moduleKey) {
	
	    switch (moduleKey) {
	        case c.DS_MODULE_CLIENT_PROFILE:
	            {
	                return "clientsProfile";
	            }
	        case c.DS_MODULE_CLIENT_CONTRACT:
	            {
	                return "clientsDetailsContract";
	            }
	        case c.DS_MODULE_CLIENT_CONTRACT_PREM:
	            {
	                return "clientsDetailsContract";
	            }
	        case c.DS_MODULE_CLIENT_CLAIMS:
	            {
	                return "clientsClaimsDetail";
	            }
	        case c.DS_MODULE_CLIENT_TARIFICATION:
	            {
	                return "clientTarificationDetails";
	            }
	        case c.DS_MODULE_CLAIM_WIZARD:
	            {
	                return "clientsClaimsDetail";
	            }
	        case c.DS_MODULE_OFFICE:
	            {
	                return 'mifid';
	            }
	    }
	};
	
	exports.getEmailerModuleKeyByWizardModuleKey = getEmailerModuleKeyByWizardModuleKey;
	/**
	 * This function determine if a document must be signed.
	 * @param {object} DSDocumentOriginTypes
	 * @param {string} origin
	 * @param {object} documentTemplate
	 * @returns
	 */
	var isDocumentMustBeSigned = function isDocumentMustBeSigned(DSDocumentOriginTypes, origin) {
	    var documentTemplate = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    switch (origin) {
	        case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD:
	            {
	                return true;
	                break;
	            }
	        case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:
	            {
	                return true;
	                break;
	            }
	        case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
	        default:
	            {
	                return !!(documentTemplate && documentTemplate.mustBeSigned);
	            }
	    }
	};
	
	exports.isDocumentMustBeSigned = isDocumentMustBeSigned;
	/**
	 * This function provide the number of the documents in package what require signing and have template.
	 * @param {*} packageDSDocuments the list of the documents in the package
	 * @param {*} DSDocumentOriginTypes the list of the origin types
	 * @returns <Number> from 0 to the number of the documents found by criteria
	 */
	var getCountOfGeneratedDocumentsWhatRequireSigning = function getCountOfGeneratedDocumentsWhatRequireSigning(packageDSDocuments, DSDocumentOriginTypes) {
	    // initialise result value
	    var count = 0;
	
	    // if no documents then no documents sent for connective
	    if (!packageDSDocuments || packageDSDocuments.length == 0) {
	        return count;
	    }
	
	    // parse all documents to know if there is a document for signing or not
	    packageDSDocuments.forEach(function (oneDocument) {
	        var oneTemplate = _nestedProperty2['default'].get(oneDocument, "documentTemplate");
	        var mustBeSignedThisDocument = isDocumentMustBeSigned(DSDocumentOriginTypes, oneDocument.origin, oneTemplate);
	
	        if (oneTemplate && oneDocument.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED && mustBeSignedThisDocument) {
	            count += 1;
	        }
	    });
	
	    return count;
	};
	
	exports.getCountOfGeneratedDocumentsWhatRequireSigning = getCountOfGeneratedDocumentsWhatRequireSigning;
	/**
	* When opening the dsWizard from package details we need to reconstruct the selelected listh for oracle documents
	* @param {*} packageDocuments
	*/
	var setOracleSelectedDocuments = function setOracleSelectedDocuments(packageDocuments) {
	    var selectedClaimRelatedOraDocuments = [];
	    var selectedContractRelatedOraDocuments = [];
	    var selectedTarificationRelatedOraDocuments = [];
	    var selectedClientRelatedOraDocuments = [];
	    var selectedTicketRelatedOraDocuments = [];
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = packageDocuments[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var oneDoc = _step2.value;
	
	            var documentObject = {
	                oracleDocumentId: oneDoc.oracleDocumentId,
	                id: oneDoc.oracleDocumentId,
	                oracleDocumentType: oneDoc.oracleDocumentType || 'D',
	                documentSelectionTab: oneDoc.documentSelectionTab
	            };
	
	            switch (oneDoc.documentSelectionTab) {
	                case 'CLAIM_DOCUMENTS_TAB':
	                    selectedClaimRelatedOraDocuments.push(documentObject);
	                    break;
	                case 'CONTRACT_DOCUMENTS_TAB':
	                    selectedContractRelatedOraDocuments.push(documentObject);
	                    break;
	                case 'TARIFICATION_DOCUMENTS_TAB':
	                    selectedTarificationRelatedOraDocuments.push(documentObject);
	                    break;
	                case 'PROFILE_DOCUMENTS_TAB':
	                    selectedClientRelatedOraDocuments.push(documentObject);
	                    break;
	                case 'TICKET_DOCUMENTS_TAB':
	                    selectedTicketRelatedOraDocuments.push(documentObject);
	                    break;
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                _iterator2['return']();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return {
	        selectedClaimRelatedOraDocuments: selectedClaimRelatedOraDocuments,
	        selectedContractRelatedOraDocuments: selectedContractRelatedOraDocuments,
	        selectedTarificationRelatedOraDocuments: selectedTarificationRelatedOraDocuments,
	        selectedClientRelatedOraDocuments: selectedClientRelatedOraDocuments,
	        selectedTicketRelatedOraDocuments: selectedTicketRelatedOraDocuments
	    };
	};
	
	exports.setOracleSelectedDocuments = setOracleSelectedDocuments;
	/**
	* This function will transform the uploader provided document result to a structure for selected oracle documents for signing
	* @param {array} selectedUploaderDocs
	* @param {string} documentSelectionTab
	*/
	var prepareOracleDocumentsFromUploaderSelectionDocList = function prepareOracleDocumentsFromUploaderSelectionDocList(selectedUploaderDocs, documentSelectionTab, claimWizardDocType) {
	    var resultAtt = [];
	
	    if (!_underscore2['default'].isEmpty(selectedUploaderDocs)) {
	        selectedUploaderDocs.forEach(function (doc) {
	            resultAtt.push({
	                oracleDocumentId: doc.ticketDocumentId || doc.id || doc.oracleDocumentId,
	                id: doc.ticketDocumentId || doc.id || doc.oracleDocumentId,
	                oracleDocumentName: doc.name || doc.ticketDocumentId || doc.oracleDocumentId,
	                //if dsWizard has a claimWizardDocType then use it, else use the ticketDocumentType, else use the oracleDocumentType
	                oracleDocumentType: claimWizardDocType || doc.ticketDocumentType || doc.oracleDocumentType || 'D',
	                documentSelectionTab: documentSelectionTab,
	                oracleDocumentUploadDate: doc.date || ''
	            });
	        });
	    }
	
	    return resultAtt;
	};
	
	exports.prepareOracleDocumentsFromUploaderSelectionDocList = prepareOracleDocumentsFromUploaderSelectionDocList;
	/**
	 *
	 * @param {*} templateId
	 * @param {*} templates
	 * @param {*} languageOptions
	 */
	var getLanguageOptionsByTemplateId = function getLanguageOptionsByTemplateId(templateId, templates, languageOptions) {
	    // language can be selected depending on template
	    var languagesList = ['nl', 'fr'];
	    var languageWhiteList = [];
	
	    // extend the languageWhiteList with the values what support the selected template (check html existence in record)
	    if (templates && templates.length && templateId) {
	        (function () {
	            // find template in the list of all templates
	            var templateForTheNewDoc = templates.filter(function (item) {
	                return item._id === templateId;
	            });
	
	            // get the template instance from result
	            var templateInstance = _nestedProperty2['default'].get(templateForTheNewDoc, "0");
	            // check the languages if exist in template, what mean check the html path have value on that language index
	            languagesList.forEach(function (oneLang) {
	                var langIndex = oneLang === 'nl' ? 0 : oneLang === 'fr' ? 1 : 2;
	
	                if (_nestedProperty2['default'].get(templateInstance, "templateContent.htmlPath." + langIndex)) {
	                    languageWhiteList.push(oneLang);
	                }
	            });
	        })();
	    }
	
	    // compose the language list for the current Select element in the render, using th whitelist created using the template.
	    var filteredLanguageOptions = languageOptions.filter(function (item) {
	        return languageWhiteList.includes(item.value);
	    });
	
	    return filteredLanguageOptions;
	};
	
	exports.getLanguageOptionsByTemplateId = getLanguageOptionsByTemplateId;
	/**
	* Check if documents are already added to package
	* @param {*} oraDocument
	* @param {*} packageDSDocuments
	* @returns
	*/
	var oraDocumentAlreadyInList = function oraDocumentAlreadyInList(oraDocument, packageDSDocuments) {
	    return packageDSDocuments.some(function (onePackageDoc) {
	        return onePackageDoc.oracleDocumentId === oraDocument.id;
	    });
	};
	
	exports.oraDocumentAlreadyInList = oraDocumentAlreadyInList;
	/**
	 *
	 * @param {*} oracleIdToRemove
	 * @param {*} selectedOraDocuments
	 */
	var removeSelectedDocumentFromOraDocuments = function removeSelectedDocumentFromOraDocuments(oracleIdToRemove, selectedOraDocuments) {
	    if (!oracleIdToRemove || !selectedOraDocuments) {
	        return selectedOraDocuments;
	    }
	
	    // filter out document by oracle id got bo cursor id
	    return selectedOraDocuments.filter(function (oneDoc) {
	        return oneDoc.oracleDocumentId !== oracleIdToRemove;
	    });
	};
	
	exports.removeSelectedDocumentFromOraDocuments = removeSelectedDocumentFromOraDocuments;
	/**
	 *
	 * @param {*} cursor
	 * @param {*} packageDSDocuments
	 */
	var getOracleIdByCursorFromPackageDSDocuments = function getOracleIdByCursorFromPackageDSDocuments(cursor, packageDSDocuments) {
	    var oracleId = undefined;
	
	    // filter the document by cursor
	    packageDSDocuments.forEach(function (oneDocument) {
	        //extract the oracle Id document to remove from other lists
	        if (oneDocument.cursor === cursor && oneDocument.oracleDocumentId) {
	            oracleId = oneDocument.oracleDocumentId;
	        }
	    });
	
	    return oracleId;
	};
	
	exports.getOracleIdByCursorFromPackageDSDocuments = getOracleIdByCursorFromPackageDSDocuments;
	/**
	 * This function remove a dsdocument from the list of documents in the package and put the list
	 * back in the state.
	 * @param {*} cursor
	 * @param {*} packageDSDocuments
	 */
	var removeDSDocumentFromThePackage = function removeDSDocumentFromThePackage(cursor, packageDSDocuments) {
	    // filter the document by cursor
	    return packageDSDocuments.filter(function (oneDocument) {
	        return oneDocument.cursor !== cursor;
	    });
	};
	
	exports.removeDSDocumentFromThePackage = removeDSDocumentFromThePackage;
	// export const fetchFileSizesForDsDocuments = async () => {
	
	// }
	
	var getSignerAdderButtonsFlags = function getSignerAdderButtonsFlags(packageDSDocuments, DSDocumentOriginTypes, isPrem, signerAvailabilityOfTemplates) {
	    var listOfGeneratedDocuments = packageDSDocuments && packageDSDocuments.filter(function (item) {
	        return item.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED;
	    });
	    var thereAreOtherDocumentsThanGenerated = listOfGeneratedDocuments.length !== packageDSDocuments.length;
	
	    // init existence of signers placeholders
	    // in case of existence a PDF document, what is not generated, then must let to use all fo the signer types
	    var isItExistFirstSignerPlaceholder = thereAreOtherDocumentsThanGenerated ? true : false;
	    var isItExistSecondSignerPlaceholder = thereAreOtherDocumentsThanGenerated ? true : false;
	    var isItExistBrokerSignerPlaceholder = thereAreOtherDocumentsThanGenerated ? true : false;
	
	    // check if generated documents provides signers
	    if (listOfGeneratedDocuments && signerAvailabilityOfTemplates) {
	        var _loop = function (i) {
	            var oneDoc = listOfGeneratedDocuments[i];
	            var templateId = oneDoc.documentTemplateId;
	
	            // extend the languageWhiteList with the values what support the selected template (check html existence in record)
	            if (signerAvailabilityOfTemplates && signerAvailabilityOfTemplates.length > 0 && templateId) {
	                // find template in the list of all templates
	                var signerAvailabilities = signerAvailabilityOfTemplates.filter(function (item) {
	                    return item.templateId === templateId;
	                });
	
	                var signerAvailability = _nestedProperty2['default'].get(signerAvailabilities, "0");
	
	                // see in the console, if the template have no signer configured in the template content.
	                if (!signerAvailability) {
	                    console.warn("No signer types available for the selected template: ", templateId && templateId._id, "signer types:", signerAvailability);
	                }
	
	                if (signerAvailability && signerAvailability.signerTypes) {
	                    isItExistFirstSignerPlaceholder = isItExistFirstSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("CLIENT");
	                    isItExistSecondSignerPlaceholder = isItExistSecondSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("OTHER_PERSON");
	                    isItExistBrokerSignerPlaceholder = isItExistBrokerSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("BROKER");
	                }
	            }
	        };
	
	        for (var i = 0; i < listOfGeneratedDocuments.length; i++) {
	            _loop(i);
	        }
	    }
	
	    // no broker in prem, does not matter anything, -- update BEWB - 706 broker button is now available in prem
	    // isItExistBrokerSignerPlaceholder = isItExistBrokerSignerPlaceholder ? (isPrem ? false : true) : false
	
	    return {
	        isItExistFirstSignerPlaceholder: isItExistFirstSignerPlaceholder,
	        isItExistSecondSignerPlaceholder: isItExistSecondSignerPlaceholder,
	        isItExistBrokerSignerPlaceholder: isItExistBrokerSignerPlaceholder
	    };
	};
	exports.getSignerAdderButtonsFlags = getSignerAdderButtonsFlags;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _this2 = this;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _stateActions = __webpack_require__(5);
	
	var _componentsEnvironmentsCoffee = __webpack_require__(392);
	
	var translate = (0, _libI18n2['default'])('');
	
	var STALE_TIME = 1 * 1000;
	var cache = {};
	
	var showLoader = function showLoader(path) {
	    return { type: _stateConstants2['default'].SHOW_LOADER, path: path };
	};
	
	exports.showLoader = showLoader;
	var hideLoader = function hideLoader(path) {
	    return { type: _stateConstants2['default'].HIDE_LOADER, path: path };
	};
	
	exports.hideLoader = hideLoader;
	/**
	 * TAKE care because this function will overwrite the accumulated value for determine the spinner status.
	 * @param {*} loaderValue
	 * @returns
	 */
	var forceSetLoader = function forceSetLoader(loaderValue) {
	    return { type: _stateConstants2['default'].FORCE_SET_LOADER, loaderValue: loaderValue };
	};
	
	exports.forceSetLoader = forceSetLoader;
	var hasErrors = function hasErrors(id) {
	    return { type: _stateConstants2['default'].HAS_ERRORS, id: id };
	};
	
	exports.hasErrors = hasErrors;
	var badCreds = function badCreds() {
	    return { type: _stateConstants2['default'].BAD_CREDENTIALS };
	};
	
	exports.badCreds = badCreds;
	var apiCallReal = function apiCallReal(path, dispatch) {
	    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var lang, noCache, noLoader, data, method, queueTransactionId, canCache, showSpinner, key, headers, ret, myInit, resP, hide, hideErr;
	    return regeneratorRuntime.async(function apiCallReal$(context$1$0) {
	        var _this = this;
	
	        while (1) switch (context$1$0.prev = context$1$0.next) {
	            case 0:
	                lang = options.lang;
	                noCache = options.noCache;
	                noLoader = options.noLoader;
	                data = options.data;
	                method = options.method;
	                queueTransactionId = options.queueTransactionId;
	
	                if (queueTransactionId) {
	                    _nestedProperty2['default'].set(data, "queueTransactionId", queueTransactionId);
	                }
	
	                canCache = !noCache && !data && (!method || method === 'GET');
	
	                if (lang) {
	                    data = data ? _extends({}, data, { lang: lang }) : { lang: lang };
	                }
	                if (!method) {
	                    method = data ? 'POST' : 'GET';
	                }
	                showSpinner = !noLoader;
	                key = canCache && path + '?' + lang;
	
	                if (!(key && cache[key])) {
	                    context$1$0.next = 14;
	                    break;
	                }
	
	                return context$1$0.abrupt('return', cache[key]);
	
	            case 14:
	
	                if (showSpinner) {
	                    dispatch(showLoader(path));
	                }
	
	                headers = {
	                    'accept': 'application/json',
	                    'content-type': 'application/json'
	                };
	
	                if (!('GET' === method || '/translations' === path)) {
	                    context$1$0.next = 19;
	                    break;
	                }
	
	                context$1$0.next = 23;
	                break;
	
	            case 19:
	                context$1$0.next = 21;
	                return regeneratorRuntime.awrap((0, _libI18n.getPromiseForTranslations)());
	
	            case 21:
	                ret = context$1$0.sent;
	
	                headers['x-csrf-token'] = translate('csrfclienttoken');
	
	            case 23:
	
	                // send to the server the curent app version
	                headers['x-agent-app-version'] = _componentsEnvironmentsCoffee.AgentAppVersion;
	
	                myInit = {
	                    method: method,
	                    body: data && JSON.stringify(data),
	                    credentials: 'include',
	                    headers: headers,
	                    mode: 'cors'
	                };
	                resP = fetch(path, myInit).then(function callee$1$0(r) {
	                    var newAppVersion, textOfModal, resultJson;
	                    return regeneratorRuntime.async(function callee$1$0$(context$2$0) {
	                        while (1) switch (context$2$0.prev = context$2$0.next) {
	                            case 0:
	                                newAppVersion = r.headers.get("x-agent-app-version");
	
	                                // check the Agent app build version validity, the loaded version is deprecated the show a notification
	                                if (newAppVersion && newAppVersion !== _componentsEnvironmentsCoffee.AgentAppVersion) {
	                                    try {
	                                        textOfModal = translate("invalidAgentAppVersionDesc");
	
	                                        textOfModal = textOfModal.replace("{{oldVersion}}", _componentsEnvironmentsCoffee.AgentAppVersion);
	                                        textOfModal = textOfModal.replace("{{newVersion}}", newAppVersion);
	
	                                        dispatch((0, _stateActions.setVersionCheckNotification)(true, translate("invalidAgentAppVersionTitle"), textOfModal));
	                                    } catch (error) {
	                                        console.log(error);
	                                        console.log("version mismatch");
	                                    }
	                                }
	
	                                if (r.ok) {
	                                    context$2$0.next = 4;
	                                    break;
	                                }
	
	                                return context$2$0.abrupt('return', Promise.reject(r));
	
	                            case 4:
	                                context$2$0.next = 6;
	                                return regeneratorRuntime.awrap(r.json());
	
	                            case 6:
	                                resultJson = context$2$0.sent;
	                                return context$2$0.abrupt('return', resultJson);
	
	                            case 8:
	                            case 'end':
	                                return context$2$0.stop();
	                        }
	                    }, null, _this);
	                })['catch'](function callee$1$0(err) {
	                    var resultJson;
	                    return regeneratorRuntime.async(function callee$1$0$(context$2$0) {
	                        while (1) switch (context$2$0.prev = context$2$0.next) {
	                            case 0:
	                                if (err && err.status === 401 || err && err.status === 403) {
	                                    dispatch(badCreds());
	                                } else if (err && err.status >= 500) {
	                                    dispatch(hasErrors('connection'));
	                                }
	
	                                context$2$0.next = 3;
	                                return regeneratorRuntime.awrap(err.json());
	
	                            case 3:
	                                resultJson = context$2$0.sent;
	                                return context$2$0.abrupt('return', Promise.reject(resultJson));
	
	                            case 5:
	                            case 'end':
	                                return context$2$0.stop();
	                        }
	                    }, null, _this);
	                }).then(function (r) {
	                    if (r.error) {
	                        // For now, assume all api errors are server errors
	                        dispatch(hasErrors('connection'));
	                        return Promise.reject(r);
	                    }
	                    if (r.success != null) {
	                        return r.success;
	                    }
	                    // Old-style API
	                    return r;
	                });
	
	                if (key) {
	                    // clear cache entry after STALE_TIME
	                    resP = resP.then(function (res) {
	                        setTimeout(function () {
	                            delete cache[key];
	                        }, STALE_TIME);
	                        return res;
	                    }, function (err) {
	                        setTimeout(function () {
	                            delete cache[key];
	                        }, STALE_TIME / 3);
	                        return Promise.reject(err);
	                    });
	                    cache[key] = resP;
	                }
	
	                // Hide loader in parallel to other callbacks
	                if (showSpinner) {
	                    hide = function hide(resultOfCall) {
	                        dispatch(hideLoader(path));
	                        return resultOfCall;
	                    };
	
	                    hideErr = function hideErr(resultOfCall) {
	                        dispatch(hideLoader(path));
	                        return Promise.reject(resultOfCall);
	                    };
	
	                    resP.then(hide, hideErr);
	                }
	
	                return context$1$0.abrupt('return', resP);
	
	            case 29:
	            case 'end':
	                return context$1$0.stop();
	        }
	    }, null, _this2);
	};
	
	exports.apiCallReal = apiCallReal;
	// TODO make this middleware
	var apiCall = function apiCall(path, options) {
	    return function (dispatch) {
	        return apiCallReal(path, dispatch, options);
	    };
	};
	
	exports.apiCall = apiCall;
	// constant for the multi step transactional call
	var API_TRANSACTION_STATUS_WAIT = "wait";
	var API_TRANSACTION_STATUS_ERROR = "error";
	var API_TRANSACTION_STATUS_DONE = "done";
	var API_TRANSACTION_CHECK_INTERVAL_SEC = 2;
	var API_TRANSACTION_PATIENCE_DURATION_SEC = 80; // do call the server if this time elapse, no hope to get response
	
	/**
	 * Wrapper for apiCall what extend the calling by transactionId and make possible longer calls. Avoid response cut out.
	 * This Function call more api calls then one. Expensive to use but sometimes necessary.
	 * @param {string} uri path of API request
	 * @param {object} requestParameters parameters for api request
	 */
	var transactionCall = function transactionCall(uri) {
	    var requestParameters = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    return function (dispatch) {
	        // prepare transaction
	        var queueTransactionId = (0, _uuidV42['default'])();
	
	        // set for apiCall parameters the transactionId
	        _nestedProperty2['default'].set(requestParameters, "queueTransactionId", queueTransactionId);
	
	        // the following piece of code can help to test session management.
	        /*  let inceaseTEst = 0
	        let testerId = setInterval(() => {
	            dispatch(apiCall('data/increaseSessionCounter', {noCache: true, noLoader: true}))
	            inceaseTEst++
	            if (inceaseTEst>100) {
	                clearInterval(testerId)
	            }
	            console.log("inceaseTEst", inceaseTEst)
	        }, 500) */
	
	        // create a promise for starting the calls, this will be resolved only when we the final response arrived
	        // even if that is an error. In case of simple API response, without the multi step functionality,
	        // this promise give a normal/regular response. On short responses also give immediate response.
	        var transactionPromise = new Promise(function (resolveTransaction, rejectTransaction) {
	            // show spiner
	            dispatch(showLoader(uri));
	
	            // in case when the server never will return a response
	            setTimeout(function () {
	                // clear timer for rechecking
	                clearInterval(timerIdForCheckResponse);
	                timerIdForCheckResponse = false;
	
	                return rejectTransaction({ error: translate("serverTimeoutStopLoading") + " Transaction ID: " + queueTransactionId });
	            }, API_TRANSACTION_PATIENCE_DURATION_SEC * 1000);
	
	            // create timer, to call the API call periodically in case when necessary
	            // the instant response kill it immediately and return with the result
	            var timerIdForCheckResponse = setInterval(function () {
	
	                // when the timer was disabled but somehow this method was started again skip it
	                if (!timerIdForCheckResponse) {
	                    return;
	                }
	
	                // Use a normal call and check the response. If the response contains the transaction specific
	                // arguments, that means the server-side data provider is upgraded and ready for fetch by multi-steps,
	                // else handle the request like a normal/regular API response.
	                return dispatch(apiCall(uri, requestParameters))
	
	                // expected response data structure:
	                // {status: <string>, data: <any - the expected form/hierarchy of the regular response>}
	                .then(function (response) {
	
	                    // when the timer was disabled but somehow this method was started again skip it
	                    if (!timerIdForCheckResponse) {
	                        return;
	                    }
	
	                    // try to get the queueTransactionStatus if exist, if not then process like a normal API call response
	                    var queueTransactionStatus = _nestedProperty2['default'].get(response, "queueTransactionStatus");
	                    // this argument will be set by server in case of http error
	                    var queueError = _nestedProperty2['default'].get(response, "error");
	
	                    // in case of general http error
	                    if (!queueTransactionStatus && queueError && queueError.length) {
	                        queueTransactionStatus = API_TRANSACTION_STATUS_ERROR;
	                    }
	
	                    // determine what to do by analyzing the status of response
	                    switch (queueTransactionStatus) {
	                        case API_TRANSACTION_STATUS_WAIT:
	                            {
	                                // do nothing, just wait and let the timer to call again the checking
	                                console.log("WAITING for multi step transaction, status = ", queueTransactionStatus);
	                                console.log("WAITING for multi step transaction, statusId = ", queueTransactionId);
	                                return response;
	                                break;
	                            }
	                        case API_TRANSACTION_STATUS_ERROR:
	                            {
	                                // clear timer for rechecking
	                                clearInterval(timerIdForCheckResponse);
	                                timerIdForCheckResponse = false;
	
	                                // stop spinner
	                                // dispatch(hideLoader(uri))
	
	                                return rejectTransaction(response);
	                                break;
	                            }
	                        case API_TRANSACTION_STATUS_DONE:
	                            {
	                                console.log("queueTransactionStatus ", API_TRANSACTION_STATUS_DONE);
	                                // clear timer for rechecking
	                                clearInterval(timerIdForCheckResponse);
	                                timerIdForCheckResponse = false;
	
	                                // fetch the final valuable data
	                                var resultData = _nestedProperty2['default'].get(response, "data");
	
	                                // stop spinner
	                                // dispatch(hideLoader(uri))
	
	                                // simplify the response
	                                return resolveTransaction(resultData);
	                                break;
	                            }
	                        // this case when the multi step transaction technology is not implemented on the server
	                        // in this case this wrapper behave like a normal apiCall,
	                        // so let the outer algorith to do, what they want with the response
	                        default:
	                            {
	                                // clear timer for rechecking
	                                clearInterval(timerIdForCheckResponse);
	                                timerIdForCheckResponse = false;
	
	                                // stop spinner
	                                // dispatch(hideLoader(uri))
	
	                                return resolveTransaction(response);
	                                break;
	                            }
	                    }
	                    // --- end api call block
	                })['catch'](function (err) {
	
	                    // stop spinner
	                    // dispatch(hideLoader(uri))
	                    return rejectTransaction(err);
	                });
	                // --- end of timer block
	            }, API_TRANSACTION_CHECK_INTERVAL_SEC * 1000);
	
	            // --- end of master transaction promise
	        }).then(function (result) {
	            // stop spinner
	            dispatch(hideLoader(0));
	            //dispatch(forceSetLoader(0))
	            return result;
	        })['catch'](function (err) {
	            // stop spinner
	            dispatch(hideLoader(0));
	            //dispatch(forceSetLoader(0))
	            return err;
	        });
	
	        return transactionPromise;
	    };
	};
	exports.transactionCall = transactionCall;
	// second part of the CSRF token will be sent in translation, do if request is to get
	// the translations, we have no i18n initialized yet
	// also we don't need to send CSRF tokens with the GET request

	// 'keep-alive': 'timeout=5, max=100000'

	// no CSRF token for translations and for get requests
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1670)))

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(223)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var definePropertyModule = __webpack_require__(42);
	var createPropertyDescriptor = __webpack_require__(82);
	
	module.exports = function (object, key, value) {
	  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
	  else object[key] = value;
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var classofRaw = __webpack_require__(53);
	var uncurryThis = __webpack_require__(8);
	
	module.exports = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(53);
	
	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	module.exports = Array.isArray || function isArray(argument) {
	  return classof(argument) === 'Array';
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(39);
	
	var $TypeError = TypeError;
	
	var PromiseCapability = function (C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aCallable(resolve);
	  this.reject = aCallable(reject);
	};
	
	// `NewPromiseCapability` abstract operation
	// https://tc39.es/ecma262/#sec-newpromisecapability
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toPrimitive = __webpack_require__(298);
	var isSymbol = __webpack_require__(150);
	
	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	module.exports = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(705);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"notificationWrapper":"_1qU_rqBptBK1MUdhC9ntNA","authWrappNew":"_MjGhz5YZpjrg0p_abSNa","authFormsOverlay":"_359G0axaCB8IG-T3n9ZgK9","authFormsContainer":"_2gFDn5QvR8UxxPnih446lF","changePaswordFormsContainer":"_1zOQuEvVNmxrYT6MQgM3oc","authFormsContainerBig":"_1Ie1-mGpxYXFWzT90hNt-z","form":"_3X4zmNgAzerqo0Tv7hwdME","privacyContainer":"_2g0xSsaKdRt_PpLQQKM1HX","info":"_1iT50E5vh-cerQhUc8EObk","backLink":"_2ZFgZtigxEFV-bzUtygsOv","formGroup":"_11DC2sIBniCzqvo1vY_Qu7","langSelector":"_3JQdVvbkCLcuE9xGzenKjt","formPaswordChangeGroup":"_2e2OW9gVNjT-4amQDHQZDG","submitButton":"_1Q3vzVQSqNKzoynhy1YTSM","accountConfirmationSubmitButton":"_14db7reR7aTztYKo7PHV4G","registerButton":"_3wES4aPbTtS_baQX0VCmQD","additionalOption":"_7SlCnj91OVe-POTXezn7Q","loginForm":"_2d2rkhi_hqXw1RYoEg63mp","langChanger":"_2NToZeDNoF0IcQQ1idAyA8","selectedLanguage":"_12Qa038yQX4_yyfUQIeKCj","formImage":"_3M5_lAyOKbjOksF5ZKz27k","passwordChangeImage":"_1tf1ZxwJzLN487EWkuyIIu","errorMessage":"R4rg085o3R49h4BWjrURt","privacyCheckboxLabel":"_3T0G51WMuh_k5AoNRI0ImO","paswordChangeInfo":"_1BQf1oG-PEuSmjau7kdJUa","mobile":"_1nGbMuVfiYF87pOdOg7KDx","disclaimer":"_3-qNCGYHo4hfSShDZPhrJV","privacy":"_2xKxQmp3DzUR4mEcrpNSER","secondLink":"_1kOJcZa0-znAf-eL_aOfKl","version":"_10l63xPbSX6IPso9lCQvP"};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(767);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(158),
	    createBaseEach = __webpack_require__(762);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(204);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(30),
	    isKey = __webpack_require__(463),
	    stringToPath = __webpack_require__(1786),
	    toString = __webpack_require__(807);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(206);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObject = __webpack_require__(56);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _uploaderScss = __webpack_require__(305);
	
	var _uploaderScss2 = _interopRequireDefault(_uploaderScss);
	
	var _uploaderModal = __webpack_require__(1154);
	
	var _uploaderModal2 = _interopRequireDefault(_uploaderModal);
	
	var _uploaderTable = __webpack_require__(1155);
	
	var _uploaderTable2 = _interopRequireDefault(_uploaderTable);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var Uploader = (function (_React$Component) {
	    _inherits(Uploader, _React$Component);
	
	    _createClass(Uploader, null, [{
	        key: 'propTypes',
	        value: {
	            type: _react2['default'].PropTypes.string.isRequired,
	            id: _react2['default'].PropTypes.string,
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            uploadInfo: _react2['default'].PropTypes.array,
	            modalIsOpen: _react2['default'].PropTypes.bool.isRequired,
	            selectable: _react2['default'].PropTypes.bool,
	            selected: _react2['default'].PropTypes.array,
	            selectedUpdaterCallback: _react2['default'].PropTypes.func,
	            forceState: _react2['default'].PropTypes.string,
	            forceDescription: _react2['default'].PropTypes.string,
	            clientId: _react2['default'].PropTypes.string,
	            onlyUploadButton: _react2['default'].PropTypes.bool,
	            disableUploadToOracle: _react2['default'].PropTypes.bool,
	            onSelectDocuments: _react2['default'].PropTypes.func,
	            classNameExtra: _react2['default'].PropTypes.any,
	            claimWizardDocType: _react2['default'].PropTypes.string,
	            claimStatusAndQualification: _react2['default'].PropTypes.any
	        },
	        enumerable: true
	    }]);
	
	    function Uploader(props) {
	        _classCallCheck(this, _Uploader);
	
	        _get(Object.getPrototypeOf(_Uploader.prototype), 'constructor', this).call(this, props);
	        this.state = { isLoaded: false };
	    }
	
	    _createClass(Uploader, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this = this;
	
	            var _props = this.props;
	            var type = _props.type;
	            var id = _props.id;
	            var dispatch = _props.dispatch;
	            var forceState = _props.forceState;
	            var forceDescription = _props.forceDescription;
	
	            // create first parallel promise
	            var promiseGetUploadDict = new Promise(function (resolve, reject) {
	                var promiseResult = dispatch((0, _stateActions.getUploadDict)());
	
	                if (promiseResult && typeof promiseResult.then === "function") {
	                    promiseResult.then(function () {
	                        return resolve();
	                    });
	                } else {
	                    return resolve();
	                }
	            });
	
	            // create second parallel promise
	            var promiseGetUploads = new Promise(function (resolve, reject) {
	                // BEWB-511: we can show tarification upload category without tarification documents
	                if (!id) {
	                    return resolve();
	                }
	                var promiseResult = dispatch((0, _stateActions.getUploads)(type, id, false));
	
	                if (promiseResult && typeof promiseResult.then === "function") {
	                    promiseResult.then(function () {
	                        return resolve();
	                    });
	                } else {
	                    return resolve();
	                }
	            });
	
	            // promise all the promises and at the end can pop up the modal if necessary.
	            Promise.all([promiseGetUploadDict, promiseGetUploads]).then(function (values) {
	                _this.setState({ isLoaded: true });
	
	                // automatic modal opening when force state of uploading passed by props.
	                if (forceState) {
	                    _this.openModal(forceState, forceDescription);
	                }
	            });
	        }
	
	        /**
	         * This will be call always when receive props
	         * @param {*} nextProps
	         */
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var forceState = this.props.forceState;
	
	            // automatic modal opening when force state of uploading type passed by props.
	            // open it just in that case when there are forceState value, else let the user to choose an option by selector
	            if (nextProps.forceState !== forceState && nextProps.forceState) {
	                this.openModal(nextProps.forceState, nextProps.forceDescription);
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            var forceState = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	            var forceDescription = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	            var _props2 = this.props;
	            var type = _props2.type;
	            var id = _props2.id;
	            var claimStatusAndQualification = _props2.claimStatusAndQualification;
	            var claimWizardDocType = _props2.claimWizardDocType;
	            var dispatch = _props2.dispatch;
	
	            // when uploader is on claim detail and claim status is 8 or 9 and qualification details are available we should force
	            // required documents for wizard and claim finalization process to the document types === '1'
	            if (type === 'claim' && claimStatusAndQualification && (claimStatusAndQualification.claimStatus === '1' || claimStatusAndQualification.claimStatus === '8' || claimStatusAndQualification.claimStatus === '9')) {
	                dispatch((0, _stateActions.showUploadModal)(type, id, forceState, forceDescription, claimStatusAndQualification));
	                return;
	            }
	
	            // if uploader is on dsWizard that is opened from claimWizard we need to force a claimWizardDocType to groupType === '1', there should be only this doctype to list
	            if (type === 'claim' && claimWizardDocType) {
	                dispatch((0, _stateActions.showUploadModal)(type, id, forceState, forceDescription, null, claimWizardDocType));
	                return;
	            }
	            dispatch((0, _stateActions.showUploadModal)(type, id, forceState, forceDescription));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props;
	            var modalIsOpen = _props3.modalIsOpen;
	            var uploadInfo = _props3.uploadInfo;
	            var onlyUploadButton = _props3.onlyUploadButton;
	            var onSelectDocuments = _props3.onSelectDocuments;
	            var disableUploadToOracle = _props3.disableUploadToOracle;
	            var type = _props3.type;
	            var claimStatusAndQualification = _props3.claimStatusAndQualification;
	            var classNameExtra = _props3.classNameExtra;
	            var step = _props3.step;
	            var claimWizardDocType = _props3.claimWizardDocType;
	            var isLoaded = this.state.isLoaded;
	
	            var isUnfinishedClaim = false;
	            if (type === 'claim' && claimStatusAndQualification && (claimStatusAndQualification.claimStatus === '1' || claimStatusAndQualification.claimStatus === '8' || claimStatusAndQualification.claimStatus === '9')) {
	                isUnfinishedClaim = true;
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_uploaderTable2['default'], _extends({}, this.props, {
	                    openModal: function () {
	                        return _this2.openModal();
	                    },
	                    onlyUploadButton: onlyUploadButton,
	                    classNameExtra: classNameExtra
	                })),
	                uploadInfo && isLoaded && _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        style: {
	                            overlay: customStyles.overlay,
	                            content: _extends({}, customStyles.content, step === 0 && { overflow: 'visible' })
	                        },
	                        className: _uploaderScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(_uploaderModal2['default'], _extends({}, this.props, {
	                        onSelectDocuments: onSelectDocuments,
	                        disableUploadToOracle: disableUploadToOracle,
	                        claimWizardDocType: claimWizardDocType,
	                        isUnfinishedClaim: isUnfinishedClaim
	                    }))
	                )
	            );
	        }
	    }]);
	
	    var _Uploader = Uploader;
	    Uploader = (0, _reactRedux.connect)(function (state) {
	        var clientAccess = state.app.security.actions;
	        var canCreateMifid = false;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createmifid') {
	                canCreateMifid = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        var canUpload = false;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'upload') {
	                canUpload = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        return {
	            dict: state.uploads.dict,
	            uploadInfo: state.uploads.uploadInfo,
	            uploadId: state.uploads.uploadId,
	            error: state.uploads.error,
	            comment: state.uploads.comment,
	            modalIsOpen: state.uploads.modalIsOpen,
	            step: state.uploads.step,
	            done: state.uploads.done,
	            groupId: state.uploads.groupId,
	            unallocatedFiles: state.uploads.unallocatedFiles,
	            files: state.files,
	            canCreateMifid: canCreateMifid,
	            canUpload: canUpload
	        };
	    })(Uploader) || Uploader;
	    return Uploader;
	})(_react2['default'].Component);
	
	exports['default'] = Uploader;
	module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(222);
	var IE8_DOM_DEFINE = __webpack_require__(624);
	var toPrimitive = __webpack_require__(387);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(127) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var has = __webpack_require__(92).has;
	
	// Perform ? RequireInternalSlot(M, [[SetData]])
	module.exports = function (it) {
	  has(it);
	  return it;
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(39);
	var anObject = __webpack_require__(20);
	var call = __webpack_require__(19);
	var toIntegerOrInfinity = __webpack_require__(44);
	var getIteratorDirect = __webpack_require__(1230);
	
	var INVALID_SIZE = 'Invalid size';
	var $RangeError = RangeError;
	var $TypeError = TypeError;
	var max = Math.max;
	
	var SetRecord = function (set, intSize) {
	  this.set = set;
	  this.size = max(intSize, 0);
	  this.has = aCallable(set.has);
	  this.keys = aCallable(set.keys);
	};
	
	SetRecord.prototype = {
	  getIterator: function () {
	    return getIteratorDirect(anObject(call(this.keys, this.set)));
	  },
	  includes: function (it) {
	    return call(this.has, this.set, it);
	  }
	};
	
	// `GetSetRecord` abstract operation
	// https://tc39.es/proposal-set-methods/#sec-getsetrecord
	module.exports = function (obj) {
	  anObject(obj);
	  var numSize = +obj.size;
	  // NOTE: If size is undefined, then numSize will be NaN
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
	  var intSize = toIntegerOrInfinity(numSize);
	  if (intSize < 0) throw new $RangeError(INVALID_SIZE);
	  return new SetRecord(obj, intSize);
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(28);
	var isObject = __webpack_require__(25);
	var setPrototypeOf = __webpack_require__(100);
	
	// makes subclassing work correct for wrapped built-ins
	module.exports = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if (
	    // it can work only with native `setPrototypeOf`
	    setPrototypeOf &&
	    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	    isCallable(NewTarget = dummy.constructor) &&
	    NewTarget !== Wrapper &&
	    isObject(NewTargetPrototype = NewTarget.prototype) &&
	    NewTargetPrototype !== Wrapper.prototype
	  ) setPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var hiddenKeys = __webpack_require__(232);
	var isObject = __webpack_require__(25);
	var hasOwn = __webpack_require__(29);
	var defineProperty = __webpack_require__(42).f;
	var getOwnPropertyNamesModule = __webpack_require__(152);
	var getOwnPropertyNamesExternalModule = __webpack_require__(414);
	var isExtensible = __webpack_require__(415);
	var uid = __webpack_require__(194);
	var FREEZING = __webpack_require__(183);
	
	var REQUIRED = false;
	var METADATA = uid('meta');
	var id = 0;
	
	var setMetadata = function (it) {
	  defineProperty(it, METADATA, { value: {
	    objectID: 'O' + id++, // object ID
	    weakData: {}          // weak collections IDs
	  } });
	};
	
	var fastKey = function (it, create) {
	  // return a primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!hasOwn(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMetadata(it);
	  // return object ID
	  } return it[METADATA].objectID;
	};
	
	var getWeakData = function (it, create) {
	  if (!hasOwn(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMetadata(it);
	  // return the store of weak collections IDs
	  } return it[METADATA].weakData;
	};
	
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
	  return it;
	};
	
	var enable = function () {
	  meta.enable = function () { /* empty */ };
	  REQUIRED = true;
	  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
	  var splice = uncurryThis([].splice);
	  var test = {};
	  test[METADATA] = 1;
	
	  // prevent exposing of metadata key
	  if (getOwnPropertyNames(test).length) {
	    getOwnPropertyNamesModule.f = function (it) {
	      var result = getOwnPropertyNames(it);
	      for (var i = 0, length = result.length; i < length; i++) {
	        if (result[i] === METADATA) {
	          splice(result, i, 1);
	          break;
	        }
	      } return result;
	    };
	
	    $({ target: 'Object', stat: true, forced: true }, {
	      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
	    });
	  }
	};
	
	var meta = module.exports = {
	  enable: enable,
	  fastKey: fastKey,
	  getWeakData: getWeakData,
	  onFreeze: onFreeze
	};
	
	hiddenKeys[METADATA] = true;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(33);
	var isCallable = __webpack_require__(28);
	var isPrototypeOf = __webpack_require__(74);
	var USE_SYMBOL_AS_UID = __webpack_require__(696);
	
	var $Object = Object;
	
	module.exports = USE_SYMBOL_AS_UID ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
	};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	
	module.exports = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
	  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
	  var next = record.next;
	  var step, result;
	  while (!(step = call(next, iterator)).done) {
	    result = fn(step.value);
	    if (result !== undefined) return result;
	  }
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var internalObjectKeys = __webpack_require__(680);
	var enumBugKeys = __webpack_require__(402);
	
	var hiddenKeys = enumBugKeys.concat('length', 'prototype');
	
	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys(O, hiddenKeys);
	};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(33);
	
	var createSetLike = function (size) {
	  return {
	    size: size,
	    has: function () {
	      return false;
	    },
	    keys: function () {
	      return {
	        next: function () {
	          return { done: true };
	        }
	      };
	    }
	  };
	};
	
	module.exports = function (name) {
	  var Set = getBuiltIn('Set');
	  try {
	    new Set()[name](createSetLike(0));
	    try {
	      // late spec change, early WebKit ~ Safari 17.0 beta implementation does not pass it
	      // https://github.com/tc39/proposal-set-methods/pull/88
	      new Set()[name](createSetLike(-1));
	      return false;
	    } catch (error2) {
	      return true;
	    }
	  } catch (error) {
	    return false;
	  }
	};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

	'use strict';
	var $String = String;
	
	module.exports = function (argument) {
	  try {
	    return $String(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"markdown":"_3JBfSoNYFNx9lkZjCDtbqO","main-sub-div":"_1IuVBzDPTo-K6z1wP8Su2b","details-container":"_2Ih0cV6ZrctLLg5_taFpR7","module-wrap":"_2paZJphhOgPCxq4ZrmUna7","module-section":"_3GWaOTndsgujivmQlS0WXG","module-section-heading":"_1d9g2SEFX7yLv8of-p68M0","module-section-content":"GuYkRLDyIDUCPhPwH7Az-","top-border":"_1dltpOgmotAJ_xeixxAo6v","bottom-border":"_2qTeuua8t2P9aLfWguejLZ","bottom-border-thick":"_2DBAnH6Jf6MtwKYAWNgCB_","border":"_3MDhrswm6E-em37q4gwoTX","green-link":"vS8_rbRsC3luHmWlgmUhg","custom-select":"_3E-DN78qXRCTVLhyCp5fug","greyButton":"_2aVm18u4E-x1AmnOk7W4GZ","grayButtonFlex":"_273Xo1OfS_zGCKtTTzbN7x","refreshButton":"qmwqvTguN_0W_yaAkNTj","iconContainer":"_7TzCa5r09SxjHGK6L0D75","btn":"kgJv_73fjpUoJ-EDiYVbs","green":"WKDd-F_s6LXrhjSgSZuvy","inline-button":"_2vnDGBnaPpkLlsWIpb3ebc","link-button":"_1k5HHV8r-PpSPXnk3WQlOJ","dropdown-group":"qtp5zawvriYoIERZNpPOf","dropdown-indicator":"_15h6LX9GgvgH_nVDKIcF2u","dropdown-arrow":"_30MetvNPer197cHM2mRI6t","buttonGreen":"_3g5urYl8InomoDAIMuTK5s","pull-left":"_3xKC3PMm7Wwpa7ZTquIRaD","pull-right":"_3bR1oCNPjGday6zs75Fqp_","clearfix":"_3O_XBv_PNxhIRwe7eqmU7L","grey-color-theme":"_2J2L3F2S5D__3EY2EKHY0w","grey-select":"TxFQH8wWbsvYGwFd3NKma","main-search":"_1RZIzqNk57FM-BdjXBOpvj","left-logo":"_3v6ZdzWnvn3-FWZ7H-xkdM","small-input":"_3wlBRHqTBtc_szk5ZFGUoc","app-container":"_2aqEp6pqRTW9vAscJ4bCiU","app-container-row":"L0Lai7z22C2O7if9EC5J3","main-content-container":"Y7jp_BJD90oZmKzmQkPHp","main":"_3ffaeNy8m5lhXpIFXh1FnQ","mobile-header":"_3AaSmMW1sCjx7pyWT3WF6L","button-menu":"_1Vcu1RdBh-gKVnzpp1CnPv","mobile-glyph-container":"_3FlAzjVnT8sfyrRe2XdCy_","text-menu":"_1tjjy-2WP5VCO4bxzKzfZG","icon-menu":"_3KR_69Y6iA4k7ia-qdDg9g","logo-glyph-white-m":"_2rEmNLjKkHIz4uDOkA8XT2","search-container":"_3xaDUzjXFw4S7ke4s-jSXx","search-logo":"_34TapJWsE52hPGDXYmaxrK","main-hr":"_1isogvH_ZMJpEQMq4swWl3","main-title-div":"_17TE_UsoUQmonIumDcNWOS","main-checkbox":"oQoi0Zu8E4XGixQfck_y2","main-nav-container":"_2bzUmHI0ax-A6BQhYpEl9-","expand":"_3GANujPZBY98g4WjxwqyhC","narrow":"LSemrvsxUQM7nbZgcozMn","nav-logo":"_2mFLf4JFl_ilNWLk5ICL6c","nav-icon-text":"_2OM4mDAfQ5L6WB2JzgE5OA","button-toggle":"_2-LcxtlOaNER39N2Xiv1nB","nav-wrapper":"_1nx-hVYaNWubTDFzVfnLrF","inactive":"z82BeimvqLIkoBJ-JXED","news":"_2sz1OTefotmoRxySLp5yrj","inbox":"_1GQ2aaNhao6VEMq1y4woNV","outbox":"XjHb7hFqllt_1RCxmp5zX","agenda":"iKtR1_ZoV8P7xk0RBwSyL","office":"_13f2OowrOSRaUQpZzMA26e","clients":"_2Hp7eKcANHPz3P65yjURBF","production":"_3S9rIIYhdwntHmh8ggUgxm","claims":"p-VQnXHW1FUQl090Zn3l","willdoc":"p9l0-_gWu-Qt_6iCCKurJ","faq":"_2NxbGApUEKTQEms8jbuLJX","links":"_2eXNTlmEt7upwLTwmr_whG","logout":"_1z5AeAsOgqP4L6hOc0JHp4","active":"_3vowoLCmw0xBvjHpBjHQm9","disclaimer":"_3L7h8oap83__afh8YedkCy","logo":"_1CgViQTyZPDPe35x_bh3p","will-logo":"_38UkDsH-60IhZ9BrNEk7Qz","logo-glyph-white":"_3G6yjwSEobRsW_JQJJWlpx","nav-icon-div":"_2_V43_XwG1K4M29rPJ8XZg","nav-icon":"_2WPoENOtBF1aKa2wWiwq9V","icon-mid":"_3f_4ltOYBmPOGw5BYwfYOl","icon-container":"_1J5VfXiqk3Tl8QleJFNulJ","st-menu-open":"_3I1vPcC3Bnn8mTAsVBGEMa","st-effect-2":"_2sVxulROBKVgBBirEd3vJb","subNav":"_2kIbJ5pmkqc0Vf82j4ikdO","headingcell":"_1DvYhw2wXIjEVcLletgBJ9","cell":"_2VP0oI9hCh54Hx_zi5TA3W","arrow-row":"_2dXbwyU8hcKEHyvwSOi5wV","table-row":"UpN4D58zbkl13ZKaKxgxI","hover-table":"_2oVLtYM9Z35BDLYuvvWCcd","pointer-table":"_2wn694KhcUsQDgzoNGMvd3","table-heading":"_2nTX1NETkXckfK9sQewnBl","table-content":"_3CK1GwNz061tR3j0zi6RC4","main-title-container":"_1obDgYWX3Mj8E_HUDlf86H","main-title":"DzN8Hs0-f3KzPm2TfpcE3","sub-title":"_3owDcjLzwvdI_AMZ4MqfZC","group":"_2oF5amx6DOKzW1G8Sf1nhX","clear":"_19nCqTxHxMaW9gBQDth3hn","anIcon":"_60kv205e9ASPtJ5JJXFMv","button":"_3Wc6yuLdMQfxYU5q2r_RzH","inputDiv":"_3TAVp9Eno2m9L2T861vQ-T","hidden":"_1oTodbgCeZgHA5yiHryRFe","template":"_2iW0oOl-YHwvVUL1cmIe78","app":"_2AkqRKBROxKIbbdyGbQmn_","grayBody":"_3rlqEoImoUEoGTAUL0SJT4","centerContent":"_1vOZm7_g_jyn6rqO_gP900","centerPage":"CvO_rIuyeNUtm-EbFGoLF","flex1":"_17qbo_ArpkaFR4Oy4smqZw","error":"_2fzIppgA3W1MFlCfRkCrci","key-value-column":"_1aahx2YtJBfMs-7eulf-Kp","keyValuePair":"ksZRbGMP5OMj5rddu_WWG","key":"_2RVkBFxAWTPd9dNfKdyipu","value":"_1HxKrbOtukFnMJAbgUJLwG","drop-container":"_1-AVlm6LL2sB2OOAtZgRGU","pdf-icon":"xoekFuR3yRqpEFxVXd-Nv","reactable-header-sort-asc":"_3dHCCwb8nwpcVhK9bUyu8A","reactable-header-sort-desc":"_36Md7h8MCinfwdHjEUmS7g","reactable-pagination":"_2X181uID5jdY8m0yFpQ2m3","reactable-current-page":"_20ifbHbTbrBl6lgc0BXmw6","upload":"_3Jm2dxeOlSRJ708FPHYPMc","input-calendar-value":"yfYiXrYxCHlSkwtvuWqSj","input-calendar-clear":"_8Wt1-1gHAlNAjskjdAZrv","input-calendar-wrapper":"_39J9DijcgAW3lSE3DuaKxL","today":"_1uuvBBxeyCni2_MkOF8bDB","view":"_1x9RlgyZcIYuo0g77nKbzT","days-view":"_1yTS_Cv70swgfjRF_iYQqq","navigation-wrapper":"_1agF2qAVek2igzV5P7s1Ft","undefined":"_3ZkZmOadsVq4h1wWnSp9u7","null":"_1fdpwmcclP8RHGDPh8Evj4","false":"_3LKSetrYBiH0m9DzdjOSnI","tox":"_1qp90HoOLA-Dk-YYzPz4mL","tox-editor-header":"_3joqwaZaTcL4TGqSg-3ipt","claimWizardButtonContainer":"_3W63lo5TL8KS1ka14HGoI4","claimWizardButtonIcon":"x4dNcNtWjkwZ6wNJylYNi","claimWizardButton":"_3gydMG4YhVonRcW2bBEQCZ","disabled":"_7qzG5Gd62DMfhe8NUoOO","modalContent":"_2Q_71j0cQo-9QBBypRRABq","columnContainer":"_26MsLKzPGGcORKoNXFFiEw","oneRowItem":"_37pWoIEYyIu3GEDQsTapfS","autoHeight":"_1efbV9SVOeddP26QeuF_yp","whitespacePre":"_3NtLILu7FGSYijucufILlI","fillMostFieldsLabel":"_2O9fiohU0dQXXnGb8APNM5","modalFormContent":"_3z9l2Mfjmj78v6k9Nkjcg2","formInputContainer":"_1iccqVSfGZ7vijEYd1vmd","docSectionTitle":"_2BnvyP8Sb35EZzBxKsHA0","noHeight":"_23MAe3phkFjMaAopuXerDd","marginBottomS":"S-AvKPG867fbiWquNG4U0","formLabel":"_3b1A73N581yKGyA3E0nyjL","infoIcon":"_19sZMvK7PDDnLpHmfqhSCN","infoIconText":"_1_03Ddb8yevljraQecnu5Z","short1":"_21yZUX5IGQ4gttH85yZkfW","short2":"_3pQNKuNYE6zdJBKvtpAp1v","short3":"C5bCrh-uWf55PYqpp3c4_","short4":"_2Y7Yx5jrNi-qroNGVeEDnR","short5":"hYhElBXn_ux11h1MZkr-k","short8":"_5U73r1GZBw8iJdIs95zVu","maxWidthStepTwoLeft":"_3Qx3jmIed_ZuLAM0dk_lbT","maxWidthStepTwoRight":"_1DNXwcm3Fe2zxDLnVl81Z_","dropdownWidth":"WBlQy442Xzs-f0qJPgEWO","boxMinWidth":"_38v7TvAi9PWKRgNhzqd7ZP","titleLabel":"_3okf2vOEgd8Imqdh9C0u7K","formInput":"_1si_wFpj4L84pRO5pvXgn1","phoneCode":"_3V5QczLn7IrG3Bhfio0bve","long":"_21bXgFnzHagSOYWk4HBfLZ","alignRight":"_1RdcvYlg1c96i3z3Aqf21-","shortMargin":"_2iG9S9naUYop1Nnc6uQFGB","formInputCreatableSelect":"_37G3fdCZMcceA6JGJYPpTX","sizeS":"_2pMrAuMvAuYfOjUsKxLqN9","sizeL":"_3XWPu3NH_G56S-ZqVNvH5T","sizeM":"_1jWDdAKr2lvv3YyoIJ-TFO","sizeXS":"RSROgBN6-A5HTr1pWHBtS","marginRightS":"l5AHusOv2NjuiwxRFL4QU","fixeMaxWidth":"_33gNW7ZAkyDqLqM07fBs5s","formInputCreatableSelectfixedMinWidth":"_17xLlR12l7aD0bzlLbMYBS","formInputText":"_2y3PXpc6BbardyvUlr5eF6","formInputCheckboxLeft":"K6yUzGLrndDjP3hBLAorZ","sizeMS":"tntEkN4X0A6LfhxbrRiir","sizeXXS":"E_eCv9AytfUA7BuUdRLy1","sizeExtraSmall":"_2fYk-45meiFzdzoK7jUAn4","inputsForceRow":"_2toCjJ9V7lGNPueWwLK8rM","spaceBetween":"zMP-9n-cdZthHtWTE6Bdt","marginLeftS":"uZ-zNttOcaGY0HWxARGgA","last":"_34VR9XbdN3wuNKhN71IiOF","first":"_1BwVfBLEb-W00wzOOkmFjO","small":"_1bQbBOiLM2rjbLrUasgjxv","formSeparator":"_1CuUhJ_tLX0hmXIiVX2Rew","secondSigner":"_2dSk1-yFB9bmy7xDnR_smO","title":"_2sSalCXfaOOhCpm0nexWcu","sectionWrapper":"_3B4QTeLb1Bdxv01eIo0ZyL","missingInfoWrapper":"_1u-UJiDP0AG8Fqtp2MDn-4","missingInfoTitle":"_3aD-iIyEQgIxHjjOPYPNmO","missingInfoSubtitle":"_4eydxthSy1GrF-nzSYQ3I","missingInfo":"_3UNrW-qv8iO13hGXi3xpAz","missingInfoLabel":"_1lv9dpcVem0v8c6LTJe_-b","missingInfoValue":"_2vd0k7igKUhpNMY8nrWWCm","documentHandlerSection":"_1dQp4bX9J2okeVv8f4vXlT","noPadding":"_3xX-VY9BMBYHANP8q2s3cB","buttonsWrapper":"_1sOfeu2ceOgGRaZBjeWQxn","dropzone":"_36YCk00AKaD-J65QKj_8zr","drag":"x2UuwQNsEO_yiYsi-EdNL","max":"_3lLWs96HTlVh8QcP7dTDN","dropzonePlaceholder":"_1MF1rQmbhbk_Vhq_aqV6n9","mifiButton":"_2pz3ZGArgZ2AWWiu-IO-HZ","documentListContainer":"_3g6sbOVvt0S-Chrjk5oBSK","documentListItem":"_3R3xsh7HuwxseDphh7hSDO","documentName":"eC5gYkZOUioOC8nPVrdcx","documentStatus":"_2PxIZ4pAXPwvehBwbLJW7z","statusLabel":"_334iEu8psn_kEKkjH0cfSg","documentStatusValue":"_2bcM3l0-LTFBxEpm2ew3RR","documentActionButtons":"_2G0HuDV6fWuzoSoxIS7VcQ","removeDocumentBtn":"_1yPC4O84HJFAvZjc4jh9fd","invisible":"_2imA2ID_xsG5_e80-lwdQl","greenButton":"_21X1eyie_n3TGxq0W7UXnr","icon":"_3Y2qmoILMlFZXEwKJhq6vA","directSignButton":"_2yoYPvXhEmwPQdm5EG_--V","mifidWrapper":"_3YH7doPFH59VMzJiKt2JvF","buttonCustomizationRenew":"_2f94_fzS_FL-VlbrIUbk0J","docTypeControlWrapper":"_2eSzMs9BMe3xHAKUXn7Rvp","docTypeSelector":"_3Dy4buHVPm6P5-Pecx8M5v","docRemoveWrapper":"_16r6GWcocLQ-MOqtGngTkb","stepFourComment":"_3-bgkjvhVmhZlyEBaaOWaB","removePartyWrapper":"_27YNGzzjBNRmJoYtA1hT50","removePartyBtn":"sUbJfA_Ct90O3NOV5FZzP","errorMessageContainer":"_1W4rmbjYS2Cy9WWFZi4Xew","none":"_3alGU1iyyZ99_toBh__j9S","errorMessage":"_2_DNrntQGwScfYemLhUpFk","textAlignLeft":"bLmVtu0Y4EK5Zg6oxiTGv","tooltip":"_2OBOSwvhbSiuQOs0_F7zwa","directSignButtonWrapper":"_3MUE9KWr701oZ4gq1y7d8V","recreatePackageWrapper":"_3TItpOSs3VPLelfcnepHl4","inviteToSignWrapper":"_2l5ZRj67WSjSp8owqOjGzk","removeDocumentBtnWrapper":"_28KRinDBu2xLYMdgSW1tm9","reminderButtonWrapper":"AA-ZgqqcW0-w0qO2uzr7H","directSignTooltip":"_2St9XpKRcOUdxXOvKoj-Xr","recreateTooltip":"_1PhxnxOvSYjR5UgnEpYd8s","mifidTooltip":"ld5BbhXNPWMOB5Vgd1vIf","inviteToSignTooltip":"_3hOQDysc8gdu9dRbMd96LT","removeDocumentBtnToolti":"_3K8H3D1uKfkT6YQscBHFmn","reminderTooltip":"_2aDS3AiHPKv0LWi8U-OExT"};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(453),
	    keys = __webpack_require__(70);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(749),
	    getValue = __webpack_require__(1747);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(86),
	    stubFalse = __webpack_require__(802);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)(module)))

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1893)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 164 */
[2356, 32],
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeCreatableSelect = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Select = _interopRequireDefault(__webpack_require__(342));
	
	var _utils = __webpack_require__(344);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(343));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var compareOption = function compareOption() {
	  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var option = arguments.length > 1 ? arguments[1] : undefined;
	  var candidate = String(inputValue).toLowerCase();
	  var optionValue = String(option.value).toLowerCase();
	  var optionLabel = String(option.label).toLowerCase();
	  return optionValue === candidate || optionLabel === candidate;
	};
	
	var builtins = {
	  formatCreateLabel: function formatCreateLabel(inputValue) {
	    return "Create \"".concat(inputValue, "\"");
	  },
	  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
	    return !(!inputValue || selectValue.some(function (option) {
	      return compareOption(inputValue, option);
	    }) || selectOptions.some(function (option) {
	      return compareOption(inputValue, option);
	    }));
	  },
	  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
	    return {
	      label: optionLabel,
	      value: inputValue,
	      __isNew__: true
	    };
	  }
	};
	
	var defaultProps = _objectSpread({
	  allowCreateWhileLoading: false,
	  createOptionPosition: 'last'
	}, builtins);
	
	exports.defaultProps = defaultProps;
	
	var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Creatable, _Component);
	
	    function Creatable(props) {
	      var _this;
	
	      _classCallCheck(this, Creatable);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Creatable).call(this, props));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	        var _this$props = _this.props,
	            getNewOptionData = _this$props.getNewOptionData,
	            inputValue = _this$props.inputValue,
	            isMulti = _this$props.isMulti,
	            onChange = _this$props.onChange,
	            onCreateOption = _this$props.onCreateOption,
	            value = _this$props.value;
	
	        if (actionMeta.action !== 'select-option') {
	          return onChange(newValue, actionMeta);
	        }
	
	        var newOption = _this.state.newOption;
	        var valueArray = Array.isArray(newValue) ? newValue : [newValue];
	
	        if (valueArray[valueArray.length - 1] === newOption) {
	          if (onCreateOption) onCreateOption(inputValue);else {
	            var newOptionData = getNewOptionData(inputValue, inputValue);
	            var newActionMeta = {
	              action: 'create-option'
	            };
	
	            if (isMulti) {
	              onChange([].concat(_toConsumableArray((0, _utils.cleanValue)(value)), [newOptionData]), newActionMeta);
	            } else {
	              onChange(newOptionData, newActionMeta);
	            }
	          }
	          return;
	        }
	
	        onChange(newValue, actionMeta);
	      });
	
	      var options = props.options || [];
	      _this.state = {
	        newOption: undefined,
	        options: options
	      };
	      return _this;
	    }
	
	    _createClass(Creatable, [{
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
	            createOptionPosition = nextProps.createOptionPosition,
	            formatCreateLabel = nextProps.formatCreateLabel,
	            getNewOptionData = nextProps.getNewOptionData,
	            inputValue = nextProps.inputValue,
	            isLoading = nextProps.isLoading,
	            isValidNewOption = nextProps.isValidNewOption,
	            value = nextProps.value;
	        var options = nextProps.options || [];
	        var newOption = this.state.newOption;
	
	        if (isValidNewOption(inputValue, (0, _utils.cleanValue)(value), options)) {
	          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
	        } else {
	          newOption = undefined;
	        }
	
	        this.setState({
	          newOption: newOption,
	          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
	        });
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var props = _extends({}, this.props);
	
	        var options = this.state.options;
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          options: options,
	          onChange: this.onChange
	        }));
	      }
	    }]);
	
	    return Creatable;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	}; // TODO: do this in package entrypoint
	
	
	exports.makeCreatableSelect = makeCreatableSelect;
	var SelectCreatable = makeCreatableSelect(_Select.default);
	
	var _default = (0, _stateManager.default)(SelectCreatable);
	
	exports.default = _default;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactBaseClasses = __webpack_require__(895);
	var ReactChildren = __webpack_require__(2138);
	var ReactDOMFactories = __webpack_require__(2140);
	var ReactElement = __webpack_require__(213);
	var ReactPropTypes = __webpack_require__(2141);
	var ReactVersion = __webpack_require__(2142);
	
	var createReactClass = __webpack_require__(2143);
	var onlyChild = __webpack_require__(2147);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(332);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(242));
	util.inherits = __webpack_require__(198);
	/*</replacement>*/
	
	var Readable = __webpack_require__(906);
	var Writable = __webpack_require__(500);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	//import warning from 'warning'
	
	"use strict";
	
	exports.__esModule = true;
	function deprecate(fn) {
	  return fn;
	  //return function () {
	  //  warning(false, '[history] ' + message)
	  //  return fn.apply(this, arguments)
	  //}
	}
	
	exports["default"] = deprecate;
	module.exports = exports["default"];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(170);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _extractPath = __webpack_require__(918);
	
	var _extractPath2 = _interopRequireDefault(_extractPath);
	
	function parsePath(path) {
	  var pathname = _extractPath2['default'](path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}
	
	exports['default'] = parsePath;
	module.exports = exports['default'];

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/BE_Logo_OVB_Willemot_Blue_cmyk.svg";

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAfCAYAAAAMeVbNAAAAAXNSR0IArs4c6QAAAtdJREFUSA2tlU1oE1EQgGfe7iYpVUuLmtqC9qZei0XxH2kPHgRvPUpN2UaTNS2UIiL01osHS0KSEvyJtgdB0IsgBQ8qWNRDBQ8KKooo1dqmFsXSZLM7TgpbNtpNXn8ePN7b+flmdt4fAreeSKyjNK62FaH47noy+dnLD3uiF7qEUG4A0SMvIw95IyAEC5bZ5hUAw9HeQUQU6cTVQQ/IiuJzRt8lVhzhvrdgF46tFECs6CkrJHoFSFd8wvckFIns+tdtfXCmpePDSa8A64aXsvUKsCFwdwBN0Z46JVJLirU2QjjOG+KE4082vOX5fQ7wgscda4YvWvnRgOI/w9vxsgN3jf6wETPWDL+ZSn1h2G4XcHkajvZdBIHN0jXXI72tXYaxbZlQZYKEJAXXz8cOCwEv/aDcqsIsU0vBEaEGAJ8j2XfLvKt8yNVc2D8IcAt3DiLfpDK3AHIC0QdUfC+PBpCCL+Ryf/jWbAbSNm84fFNDQ5BL8gkVOMVwlA0glTnf96XD8oF7a3c02rJh8HA4vB0ID5BtDoFNWU1oY0syiQjVM9cCHVyH+bnp6de56ak4EU2BLzDJd8qhavyKW1HX9a28x/ttiwbq65sawQ+nGT6LgN9Q4HiPEZtCEAsEtsKvmVYkq/1aIvHVCVoRLnyBs8SeDBoQfpxgsGJZ1h0VxLAlzFpFaEd5HTo5mMI6VSNlH4Mrw0OhUINaU9sPKA7ath0vUHE8m0p9dzJyjZMnDSPdUlSbbWvhVyaTmXXp4L/MdT22U/hwjE9AE2dzL5OM32YHcju55w8TiTx/f3TLnHnZgnZ3x4L8+w/4EZjhRZzL/8YhNvQEOxCvsSxzrLH3AKhBRAqAmd+fzabnvRxl5OXwfH4CfEonmItv0iMjP2UAlWzK4LwgJhs/ruSwGl1ZzVfjKGO7lDm/SHUyJ04GuGQj7DrgR05FC0f5IDzj3ibtXM2QoMW0qP0vjbn33v3KbfMAAAAASUVORK5CYII="

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./BE_Logo_OVB_Willemot_Blue_cmyk.svg": 171,
		"./BE_Logo_OVB_Willemot_White.svg": 354,
		"./Ryan-Taylor-Green-Tick.svg": 527,
		"./Willemot_wefacilitateyourbusiness__1_RGB.png": 2265,
		"./Willemot_wefacilitateyourbusiness__1_RGB_400achtergrondBroker (1).jpg": 2266,
		"./a-arrow_1x.png": 2267,
		"./a-arrow_2x.png": 952,
		"./a-edit_1x.png": 2268,
		"./a-edit_1x_blue.svg": 355,
		"./a-edit_1x_green-bkup.png": 2269,
		"./a-edit_1x_green.png": 2270,
		"./a-edit_2x.png": 953,
		"./a-info_1x.png": 2271,
		"./a-info_2x.png": 528,
		"./a-jump-green.png": 2272,
		"./a-jump-ovbblue.svg": 529,
		"./a-location_1x.png": 2273,
		"./a-location_2x.png": 530,
		"./a-open_with-gray.png": 954,
		"./a-open_with-green.png": 2274,
		"./a-open_with-green.svg": 955,
		"./a-people_1x.png": 2275,
		"./a-people_2x.png": 531,
		"./a-resize_with-green.png": 2276,
		"./a-trash_1x.png": 2277,
		"./a-trash_1x_ovbBlue.svg": 79,
		"./a-trash_2x.png": 956,
		"./arrow-down_1x.png": 2278,
		"./arrow-down_2x.png": 957,
		"./arrow_back_1x.png": 2279,
		"./arrow_back_2x.png": 958,
		"./autorenew.svg": 532,
		"./autorenew_white.svg": 959,
		"./baseline-direct-Sign24px-green.svg": 960,
		"./baseline-reply-24px-green.svg": 961,
		"./baseline-reply-to-willemot-24px-green.svg": 962,
		"./baseline-send-reminder-24px-green.svg": 963,
		"./c-automotive_1x.png": 2280,
		"./c-automotive_2x.png": 964,
		"./c-credit_1x.png": 2281,
		"./c-credit_2x.png": 965,
		"./c-family 2.png": 2282,
		"./c-family_1x.png": 2283,
		"./c-family_2x.png": 966,
		"./c-fire_1x.png": 2284,
		"./c-fire_2x.png": 967,
		"./c-health_1x.png": 2285,
		"./c-health_2x.png": 968,
		"./c-home_1x.png": 2286,
		"./c-home_2x.png": 969,
		"./c-life_1x.png": 2287,
		"./c-life_2x.png": 970,
		"./c-misc_1x.png": 2288,
		"./c-misc_2x.png": 971,
		"./c-transport_1x.png": 2289,
		"./c-transport_2x.png": 972,
		"./c-workinjuries_1x.png": 2290,
		"./c-workinjuries_2x.png": 973,
		"./close_1x.png": 2291,
		"./close_2x.png": 533,
		"./corner.svg": 534,
		"./create-24px.svg": 974,
		"./document_1x.png": 2292,
		"./document_2x.png": 975,
		"./dropdown-arrow_1x.png": 2293,
		"./dropdown-arrow_2x.png": 976,
		"./ic_delete_forever_black_24px.svg": 977,
		"./ic_do_not_disturb_black_24px.svg": 261,
		"./ic_done_gray_32px.svg": 978,
		"./ic_done_green_32px.svg": 979,
		"./ic_done_white_32px.svg": 980,
		"./icn-agenda.svg": 535,
		"./icn-automotive.svg": 536,
		"./icn-b2b.svg": 537,
		"./icn-claimWizard-white.svg": 356,
		"./icn-claims.svg": 538,
		"./icn-clients.svg": 539,
		"./icn-contracts.svg": 540,
		"./icn-credit.svg": 541,
		"./icn-dashboard_1x.png": 2294,
		"./icn-dashboard_2x.png": 981,
		"./icn-dsdocuments-blue.svg": 542,
		"./icn-dsdocuments-green.svg": 543,
		"./icn-dsdocuments-white.svg": 357,
		"./icn-dsdocuments.svg": 544,
		"./icn-events_1x.png": 2295,
		"./icn-events_2x.png": 982,
		"./icn-family.svg": 545,
		"./icn-faq.svg": 546,
		"./icn-fire.svg": 547,
		"./icn-generali.svg": 548,
		"./icn-health.svg": 549,
		"./icn-home.svg": 550,
		"./icn-inbox-blue.svg": 551,
		"./icn-inbox-white.svg": 358,
		"./icn-inbox.svg": 552,
		"./icn-info.svg": 553,
		"./icn-life.svg": 554,
		"./icn-link_1x.png": 2296,
		"./icn-link_1x_blue.svg": 555,
		"./icn-link_2x.png": 983,
		"./icn-links.svg": 556,
		"./icn-logout.svg": 557,
		"./icn-marketing_1x.png": 2297,
		"./icn-marketing_2x.png": 984,
		"./icn-misc.svg": 558,
		"./icn-news.svg": 559,
		"./icn-no-result.svg": 23,
		"./icn-office.svg": 560,
		"./icn-outbox.svg": 561,
		"./icn-outline-location_on-24px.svg": 562,
		"./icn-production.svg": 563,
		"./icn-tasklist.svg": 564,
		"./icn-transport.svg": 565,
		"./icn-webapps.svg": 566,
		"./icn-willdoc.svg": 567,
		"./icn-workinjuries.svg": 568,
		"./icon-cancel.svg": 569,
		"./l-logo_1x.png": 2298,
		"./l-logo_2x.png": 985,
		"./logo-glyph-white-m_1x.png": 2299,
		"./logo-glyph-white-m_2x.png": 986,
		"./logo-glyph-white_1x.png": 2300,
		"./logo-glyph-white_2x.png": 987,
		"./logo_1x.png": 2301,
		"./logo_2x.png": 988,
		"./m-agenda.svg": 570,
		"./m-b2b.svg": 571,
		"./m-claims.svg": 572,
		"./m-client_1x.png": 2302,
		"./m-client_2x.png": 989,
		"./m-clients.svg": 573,
		"./m-dashboard_1x.png": 2303,
		"./m-dashboard_2x.png": 990,
		"./m-dsdocuments.svg": 574,
		"./m-faq.svg": 575,
		"./m-generali.svg": 576,
		"./m-inbox-blue.svg": 577,
		"./m-inbox.svg": 578,
		"./m-link_1x.png": 2304,
		"./m-link_2x.png": 991,
		"./m-links.svg": 579,
		"./m-logo_1x.png": 2305,
		"./m-logo_2x.png": 992,
		"./m-logout.svg": 359,
		"./m-marketing_1x.png": 2306,
		"./m-marketing_2x.png": 993,
		"./m-news.svg": 580,
		"./m-office.svg": 581,
		"./m-outbox.svg": 582,
		"./m-production.svg": 583,
		"./m-tasklist.svg": 584,
		"./m-webapps.svg": 585,
		"./m-willdoc.svg": 586,
		"./menu_1x.png": 2307,
		"./menu_2x.png": 587,
		"./minus_1x.png": 2308,
		"./minus_2x.png": 994,
		"./n-avatar_1x.png": 2309,
		"./n-avatar_2x.png": 995,
		"./n-claims_1x.png": 2310,
		"./n-claims_2x.png": 996,
		"./n-contracts_1x.png": 2311,
		"./n-contracts_2x.png": 997,
		"./n-source_1x.png": 2312,
		"./n-source_2x.png": 998,
		"./n-tag_1x.png": 2313,
		"./n-tag_2x.png": 999,
		"./notification-bell.svg": 1000,
		"./office-logo_1x.png": 2314,
		"./office-logo_2x.png": 1001,
		"./p-avatar_1x.png": 2315,
		"./p-avatar_2x.png": 1002,
		"./p-close_1x.png": 1003,
		"./p-close_2x.png": 1004,
		"./pdf-icon_1x.png": 172,
		"./pdf-icon_2x.png": 1005,
		"./person_search_green.svg": 588,
		"./plus_1x.png": 2316,
		"./plus_2x.png": 1006,
		"./print-black-18dp.svg": 360,
		"./print-white-18dp.svg": 1007,
		"./pro-arrow_1x.png": 2317,
		"./pro-arrow_2x.png": 589,
		"./r-close_1x.png": 2318,
		"./r-close_2x.png": 1008,
		"./recycle.svg": 1009,
		"./search_1x.png": 2319,
		"./search_2x.png": 1010
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 173;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(340);
	
	var RefreshBtn = (function (_React$Component) {
		_inherits(RefreshBtn, _React$Component);
	
		_createClass(RefreshBtn, null, [{
			key: 'propTypes',
			value: {
				className: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		function RefreshBtn(props) {
			_classCallCheck(this, RefreshBtn);
	
			_get(Object.getPrototypeOf(RefreshBtn.prototype), 'constructor', this).call(this, props);
			this.state = { isPressed: false, rotate: 0 };
		}
	
		_createClass(RefreshBtn, [{
			key: 'handleMouseDown',
			value: function handleMouseDown() {
				this.setState({ isPressed: true });
			}
		}, {
			key: 'handleMouseUp',
			value: function handleMouseUp() {
				var rotate = this.state.rotate;
	
				this.setState({ isPressed: false, rotate: rotate - 360 });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var rotate = this.state.rotate;
	
				return _react2['default'].createElement(
					_reactMotion.Motion,
					{ style: { rotate: (0, _reactMotion.spring)(rotate) } },
					function (_ref) {
						var rotate = _ref.rotate;
						return _react2['default'].createElement(
							'div',
							_extends({}, _this.props, { onMouseDown: function () {
									return _this.handleMouseDown();
								}, onMouseUp: function () {
									return _this.handleMouseUp();
								}, className: 'refreshButton ' + (_this.props.className || '') }),
							_react2['default'].createElement(
								'div',
								{ className: 'iconContainer', style: { transform: 'rotate(' + rotate + 'deg)' } },
								_react2['default'].createElement('img', { src: __webpack_require__(2263) })
							)
						);
					}
				);
			}
		}]);
	
		return RefreshBtn;
	})(_react2['default'].Component);
	
	exports['default'] = RefreshBtn;
	module.exports = exports['default'];

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tooManyResultsScss = __webpack_require__(1628);
	
	var _tooManyResultsScss2 = _interopRequireDefault(_tooManyResultsScss);
	
	var _resourcesImagesIcnNoResultSvg = __webpack_require__(23);
	
	var _resourcesImagesIcnNoResultSvg2 = _interopRequireDefault(_resourcesImagesIcnNoResultSvg);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('tooManyResults');
	
	var TooManyResults = function TooManyResults(_ref) {
		var type = _ref.type;
		return _react2['default'].createElement(
			'div',
			{ className: _tooManyResultsScss2['default'].msgContainer },
			_react2['default'].createElement(
				'div',
				{ className: _tooManyResultsScss2['default'].msg },
				_react2['default'].createElement(
					'div',
					{ className: _tooManyResultsScss2['default'].imageContainer },
					_react2['default'].createElement('img', { src: _resourcesImagesIcnNoResultSvg2['default'] })
				),
				_react2['default'].createElement(
					'div',
					{ className: _tooManyResultsScss2['default'].textContainer },
					_(type)
				)
			)
		);
	};
	TooManyResults.propTypes = {
		type: _react2['default'].PropTypes.string.isRequired
	};
	
	exports['default'] = TooManyResults;
	module.exports = exports['default'];

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(128);
	var core = __webpack_require__(126);
	var ctx = __webpack_require__(622);
	var hide = __webpack_require__(177);
	var has = __webpack_require__(144);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(145);
	var createDesc = __webpack_require__(269);
	module.exports = __webpack_require__(127) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(625);
	var defined = __webpack_require__(377);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(384)('wks');
	var uid = __webpack_require__(270);
	var Symbol = __webpack_require__(128).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	'use strict';
	var $TypeError = TypeError;
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
	
	module.exports = function (it) {
	  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
	  return it;
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ENVIRONMENT = __webpack_require__(281);
	
	module.exports = ENVIRONMENT === 'NODE';


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
	  return Object.isExtensible(Object.preventExtensions({}));
	});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var hasOwn = __webpack_require__(29);
	
	var FunctionPrototype = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
	
	var EXISTS = hasOwn(FunctionPrototype, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
	var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));
	
	module.exports = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	var classof = __webpack_require__(53);
	
	var $Object = Object;
	var split = uncurryThis(''.split);
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	module.exports = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) === 'String' ? split(it, '') : $Object(it);
	} : $Object;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	var isCallable = __webpack_require__(28);
	var classof = __webpack_require__(98);
	var getBuiltIn = __webpack_require__(33);
	var inspectSource = __webpack_require__(405);
	
	var noop = function () { /* empty */ };
	var construct = getBuiltIn('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec = uncurryThis(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
	
	var isConstructorModern = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  try {
	    construct(noop, [], argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};
	
	var isConstructorLegacy = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  switch (classof(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction': return false;
	  }
	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
	  } catch (error) {
	    return true;
	  }
	};
	
	isConstructorLegacy.sham = true;
	
	// `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor
	module.exports = !construct || fails(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call)
	    || !isConstructorModern(Object)
	    || !isConstructorModern(function () { called = true; })
	    || called;
	}) ? isConstructorLegacy : isConstructorModern;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	
	module.exports = globalThis.Promise;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var iterateSimple = __webpack_require__(151);
	var SetHelpers = __webpack_require__(92);
	
	var Set = SetHelpers.Set;
	var SetPrototype = SetHelpers.proto;
	var forEach = uncurryThis(SetPrototype.forEach);
	var keys = uncurryThis(SetPrototype.keys);
	var next = keys(new Set()).next;
	
	module.exports = function (set, fn, interruptible) {
	  return interruptible ? iterateSimple({ iterator: keys(set), next: next }, fn) : forEach(set, fn);
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(33);
	var defineBuiltInAccessor = __webpack_require__(50);
	var wellKnownSymbol = __webpack_require__(27);
	var DESCRIPTORS = __webpack_require__(14);
	
	var SPECIES = wellKnownSymbol('species');
	
	module.exports = function (CONSTRUCTOR_NAME) {
	  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
	
	  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
	    defineBuiltInAccessor(Constructor, SPECIES, {
	      configurable: true,
	      get: function () { return this; }
	    });
	  }
	};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var store = __webpack_require__(423);
	
	module.exports = function (key, value) {
	  return store[key] || (store[key] = value || {});
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(20);
	var aConstructor = __webpack_require__(393);
	var isNullOrUndefined = __webpack_require__(64);
	var wellKnownSymbol = __webpack_require__(27);
	
	var SPECIES = wellKnownSymbol('species');
	
	// `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor
	module.exports = function (O, defaultConstructor) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
	};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(41);
	var toString = __webpack_require__(18);
	var whitespaces = __webpack_require__(301);
	
	var replace = uncurryThis(''.replace);
	var ltrim = RegExp('^[' + whitespaces + ']+');
	var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');
	
	// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
	var createMethod = function (TYPE) {
	  return function ($this) {
	    var string = toString(requireObjectCoercible($this));
	    if (TYPE & 1) string = replace(string, ltrim, '');
	    if (TYPE & 2) string = replace(string, rtrim, '$1');
	    return string;
	  };
	};
	
	module.exports = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod(3)
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-symbol -- required for testing */
	var V8_VERSION = __webpack_require__(115);
	var fails = __webpack_require__(6);
	var globalThis = __webpack_require__(9);
	
	var $String = globalThis.String;
	
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol('symbol detection');
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
	  // of course, fail.
	  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
	});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	var id = 0;
	var postfix = Math.random();
	var toString = uncurryThis(1.0.toString);
	
	module.exports = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"markdown":"_3QR8v81YmTdIOS7dQrVeZW","main-sub-div":"_2nRXcRsC1ixIswb3FQJi69","details-container":"_3DHRSE5L462WdL94J5meVU","module-wrap":"_1s-1O-NsXJxzMtlbVCg0T1","module-section":"Npv2N22z-Qrt_E7eRasLl","module-section-heading":"_1xzk1uSJ7buq83Zt8AdTlw","module-section-content":"_1NLhMWEzAoZOgYDn2CEO-v","top-border":"_3oOgG4R2U37zrwkQBXq1MK","bottom-border":"_3G0CM5HheQ5Q6JqOepB81l","bottom-border-thick":"YLFuit6NcWC9niNoFP3oJ","border":"_1NiatZWO1lGtj_4HFS4o3m","green-link":"qtHszRISZ90nNGGPAjFrq","custom-select":"_2rDSljf_dNmcUUCWSHj9ob","greyButton":"_3lBWMCiU7BiyLampMtw_CM","grayButtonFlex":"EE3CAGaYtFCCKy6WzbfUd","refreshButton":"Uf5UKDzHhAkN9kz46NGDw","iconContainer":"_3titVYqanAkVUUBNBXbZ1i","btn":"_1FlzAwejNmUxK3evcM1woV","green":"csSLflii47jySaHaHRbMz","inline-button":"_12_MiNjz37Ai0eKzF7pXiy","link-button":"IKd8W7aZhOdKFd29ADSRd","dropdown-group":"_2tBJpd_d30DMb2uBZCkhF1","dropdown-indicator":"_3gtBjhNnEzvkewpY2eyHfK","dropdown-arrow":"_1W9A9Gakyp_i5XhpMwu3jU","buttonGreen":"wcQhDlp9l4GL5vUDRnOz5","pull-left":"_22rujgiiJLxInJMWtLRiub","pull-right":"_1vb2yGzVSWXieOxzMyfVLF","clearfix":"_2TE0DrGmQQkbx7CiJe_sou","grey-color-theme":"_2ZWksDS_X6IgdHQy7AMGff","grey-select":"_1gt5Qv4rlapS1dMtw_KccE","main-search":"_3CBcPcPepkTQf5IiPVGiEu","left-logo":"_3c4pURIOi0U048fUKTjlz5","small-input":"_19AnU39prETe971zBIBaln","app-container":"_1gwEaPP8yAERp4J7KhB-OV","app-container-row":"FDBPm8iOtG4E7Rm-HORiw","main-content-container":"_3hMkhmgBN2mz0AhC53c4gs","main":"fw8XG36yl_xIF-sT03v0k","mobile-header":"_3kY6CfvYxjvQIc0IhSUfrP","button-menu":"QA1vF1jyVH3Xin6RdLYvz","mobile-glyph-container":"_2T99onma0B8Y4WHC2ex5oJ","text-menu":"_2uTPdVRSXXYVZiW2TBDkmY","icon-menu":"_26NjqpEi_FSo6H2Hi8Mwg5","logo-glyph-white-m":"_1BYwafLzWPadii27ciIS8X","search-container":"_1HmMF0Db3yTT_m4156tGZe","search-logo":"_1mmhLQNSrpH-s1GWWqu4bT","main-hr":"_25kXNH-JNEnDhEIw25AnwZ","main-title-div":"BhnBAcpzZZuvYSEiqkURD","main-checkbox":"_3WR-XfHPY578vLO5TXJMvM","main-nav-container":"mPv4OczOSj6aheVzvTCng","expand":"_1K4ZBjwn0yNiV7dQIpJ9T5","narrow":"_1HWvEHUARRmYRv5HAtfsb8","nav-logo":"_2OzMVOgI2wXjHQj_iCJWqt","nav-icon-text":"rPHy4QoCYBqb11s_v_iQH","button-toggle":"_1TuCxhfPOrEwKkUmUp9Dg-","nav-wrapper":"_2YKEuLaHUewFoj23ScDrlq","inactive":"_1rb0Xpx8pXhc93CmklI0Yc","news":"_2eCGw-u2BMJTLPI2jBeRkq","inbox":"_14ao-i8A8-fxBEI4uKmkZ_","outbox":"_3F2aRkgMepqL_JTfwiW09T","agenda":"_1XsW2__MfFmMBo6-C2Ly16","office":"_2MxxiA-uU28dpRj1b61bgQ","clients":"_3FElyVKsdVlA0KFWbb08BW","production":"_2GkiplNfZxW-cL4UQUVN8e","claims":"_27_GhrdpuYEJA-O-1yiG7I","willdoc":"_1qWesujcvlT1_-M56qvxv_","faq":"_3PyflS6Ce_wNxryAy7a-zK","links":"_1Z0ZqTIgog9DNTap1iqB_R","logout":"_3sGS-GOTgTofEAmll-05ua","active":"_3q4Y6MR8iaRQthJ_xJ36gV","disclaimer":"_2iSx_0xRiMwlxv_CVbgHiK","logo":"_1A212reJNMr2ughqC7temj","will-logo":"fl2qLIWGNia9QUZDDMWke","logo-glyph-white":"_3JA5aun7vWSyKy3D2rROzz","nav-icon-div":"_1lCnzsPNTtGyGuO1uLDKfn","nav-icon":"_1nRHEaowl4NDCWzXTZqgbm","icon-mid":"_3Bayp9IIGuCrq0hq-Pz1kW","icon-container":"_2Sb7Jk5UKfSlXoNA7va0l8","st-menu-open":"_2dEfn1Ps9OqFl0Tnw1NbQq","st-effect-2":"_3OjkmqK5rrkMMw18veUb1y","subNav":"_3dFIQIqdlyU2skrtZpU5hE","headingcell":"_3rpLUQNcdulc4AnHHmOl4g","cell":"B0CgVP5CA8W88Pf5hwsf-","arrow-row":"hQix5IxrnXoLezpffBfTz","table-row":"_1ZVdUd7crFj7PDNCyPu0ug","hover-table":"_3HZN0M_w6GrVoEI5prRl20","pointer-table":"_2LTsrPVwOlPsnZ-tN1fPr3","table-heading":"_1h2F3ZOuEhc3-QBaw1vnuK","table-content":"_3Ia5fgIbQo5vKCYKcAaib2","main-title-container":"_1sEZpfWn5hX2QHbGEpSst8","main-title":"odVu3P3elFNOHF_SUY73N","sub-title":"_2Bt-aBlwhFpUYoGZvPoYHu","group":"_2AjzcMAJpn53qEGc2hl_pp","clear":"_3qHavSe86gNhfD0ho16v1_","anIcon":"_1qB5aLnlwjlS1rHwluMk39","button":"_1OmSc_OpvGGbE771O5nmFj","inputDiv":"_3w_kOLaDLamntKNGwjqWev","hidden":"_2RU0meiLGaO6Np9cm8vzyS","template":"_2hU7Ez59haobBFNzLpp2v1","app":"_2cfVJT7orMEQKbgaXTYtFz","grayBody":"_6s7nxastJS0tFrLwKzGG2","centerContent":"_2hTYstMiuPB64YxPJpOmHV","centerPage":"_28Jg28u40A83VtvNdj3hw7","flex1":"ijMy0dcOsQdjTJBHwbk6M","error":"_2zcFv8toiccssLOlZdxE5B","key-value-column":"_2KYfhmu0VruJal4-sUzllu","keyValuePair":"_162Wdz_Cd9zY-2oGipojym","key":"_1LeNpuoWCHHQRDWjnKW9on","value":"_1Tw5z5kUhgXH7auy8ke56i","drop-container":"_3WNUWOQ7t4dpC0lg8bZtld","pdf-icon":"_3zSbydu6Fk6eqE1QJ5GP14","reactable-header-sort-asc":"_8hnWiiG5ssrlDwMhBt6J3","reactable-header-sort-desc":"bVJaRq69ROY6ZPEgO6sDl","reactable-pagination":"_3ytI3wwnqLwLxWltiSE3ZR","reactable-current-page":"_1DhcnFTxk_emk1g3QHesLK","upload":"_3D_4PFWOOLOqbVNWgJOwLA","input-calendar-value":"_1fqq65zksVQTh-PdAeYYHR","input-calendar-clear":"_3dJvcS9sL_hYX850Q3x-gZ","input-calendar-wrapper":"_3BuBnMVT4Db5tz5TjSsHUh","today":"_2jme-Fe5qs57KNOBWjhO4u","view":"_3nUlpSKRhi-LTQf8kKd5f-","days-view":"_11IuT6DdPWthKQOLkmAvGh","navigation-wrapper":"_2fqaPGpCf1RwCYUHCxyLrL","undefined":"XMMIlnEidAX3DaG0P2k0j","null":"CyP9kMOzWLlDNNEBiImwb","false":"_3PlApZKXxkIDZEOq5gOLnF","tox":"_1hm4aG-aQJi0X4LFwpDx0U","tox-editor-header":"_3zCpLIZ6OeTJzVSSOLjDRb","mifidButtonContainer":"_2yfuvNFlX-dTAHo7ZZblOB","mifidButton":"wkHkP7tRVf2e5W_QEQUrg","onlyIcon":"_1SgwmZmcaJjwi42ALex9JU","disabled":"_2w_LAfdIZ-GqtFNKJNRRWl","mifidButtonIcon":"_1V383TzwOohO5GqqYUqDr","mifidNoMarginIcon":"_3GafHMi1iz0ZORtg86PWvO","formInput":"_1civ_XrI7SYF9c0PQq1EsH","sizeL":"_3Ono6uBPqB_lQhGHFweCy8","downArrowHolder":"_3VXbjSt78GPPbeQzt6SlZ6","downArrow":"_1wmg57hx3opicGw_Opeh0b","creatableSelectInput":"OOf4ONhIJnYMRhtW-dosU","creatableOptionContainer":"_1S17Ggyqqz4dJFsk5e0kv5","creatableOptionItem":"_3mfNeEv1bftFMCx62AZwtw"};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"overdueWrapper":"_1mR2dZCS3FzGED8dgo-1HG","relatedTasks":"_2CHUB_PcjzDyRKANSxvwYd","greyButton":"_1U63KHV84CioUU2T9PO7k3","enabled":"_3h4TjigLzLaq6gHrxQjStC","error":"_1LnaMrMuwhENIMmwk7gObb","formError":"_2GCbrhBCssI73qBxV20_UO","results":"_1MuU1ikCZwEyzTE0gJYcvw","unread":"_8lphNvki9S2M0rVnApwqY","buttonContainer":"_13RqRtD7dcoQo28teENsRx","greenButton":"_1RGPzjUftCnXvXZQDvGv71","datepickerFlexRow":"_3hRbONP7QM3BIk6U7oCJr9","datepickerLabelField":"_2Uguy24QacVEQIFqIJekyE","todoModalContent":"_3z9i8SFrh8R0wvj3faeYC_","modalSubtitle":"MDyINMSJxhVbFIZGqgudN","staffItemsList":"_3NSV6qF2BktJ-w29vJxzhD","colSm":"_2yjNxz01xtpnTz4baHQX5P","colXs":"z34FeXrckijKNCFpLn94y","todoModalButtons":"iFdEBskJyj6idcUqDp-Sc","confirmationMessage":"_354VZLgM6RJOtQoWEDa5v9","noresults":"_1V14lmnfR8XmkHIzhGqvXQ","tableContainer":"_2mNHDLWeKF3jcoPr_jLJr7","colorPickerWrapper":"_-cT_6EJktOgqATp-dUUjR","customSketchPicker":"_3hOGFGI9dBACIUSsVTQDkx","editFieldButton":"_59M679CMRkPC7New2Hxft","subContentWrapper":"_1gTSiNtsZ2F1uyXChu6Z5q","title":"_3k-LqkMQQPpgvU8x5TfR-S","cancel":"_2Cxnn6pxnr2Nay4g3RFI4G","next":"_3NPLj-Y0r3EosAINblkWla","datepicker__input-container":"ict9pe9YOHb4tz3G7y3vZ","documentsWrapper":"_3U3pbJZGvgUVKZKz8mmrD1","documents":"_1qL11yZJr9P_63TCbgr5WP","archiveModalContent":"_22H5qy-MQNGklOUqQAyw6l","ticketList":"_2trMuEEJFGiVgrUTTp2BPw","ticketItem":"_2GLfcEvC5a3v_hLM4qxN-n","ticketField":"_1spcCgt6i7iDfIywdbxkBh","dateInput":"_17cHmmfm8FGJf0-VN1AdzV","archiveSubtitle":"_3DJJDe4D2lOztE3jDXh6Y-","archiveSubtitleLast":"oSAbuuPArkONkjULIdzL_","usersList":"_20C_hshdiHpmqye9ES1t1J","archiveModalButtons":"_3kHGYkYnFTzcXdqkoSVXyQ","message":"_35mkVIMT5rkXZNzyCx8NIg"};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(139),
	    toKey = __webpack_require__(140);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(204),
	    overRest = __webpack_require__(778),
	    setToString = __webpack_require__(782);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(200),
	    isIterateeCall = __webpack_require__(202);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(161),
	    isArrayLike = __webpack_require__(69),
	    isIndex = __webpack_require__(323),
	    isObject = __webpack_require__(56);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(769);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)(module)))

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1707),
	    isObjectLike = __webpack_require__(48);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1715),
	    baseUnary = __webpack_require__(159),
	    nodeUtil = __webpack_require__(203);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(758),
	    keys = __webpack_require__(70);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(470);
	var setInnerHTML = __webpack_require__(337);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(478);
	var setTextContent = __webpack_require__(855);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(21);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(2003);
	var ReactInstrumentation = __webpack_require__(95);
	
	var warning = __webpack_require__(35);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(13));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 10);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'arguments\');');
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'set\', fieldsObject);');
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'send\', fieldObject);');
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail["default"])(s)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase["default"])(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(11));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread({}, Defaults, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return _react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	});
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactCurrentOwner = __webpack_require__(123);
	
	var warning = __webpack_require__(35);
	var canDefineProperty = __webpack_require__(899);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(897);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 214 */
195,
/* 215 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.makeFieldValue = makeFieldValue;
	exports.isFieldValue = isFieldValue;
	var flag = '_isFieldValue';
	var isObject = function isObject(object) {
	  return typeof object === 'object';
	};
	
	function makeFieldValue(object) {
	  if (object && isObject(object)) {
	    // This flag has to be enumerable, because otherwise it is not possible
	    // to serialize object with this field.
	    // The consequence is you lose information that particular field is
	    // field or nested group of fields, so you're not able to fetch
	    // field value from state when it has been affected in some way
	    // by serializing/using immutable and so on.
	    // @fixme marking field as leaf should be made in other way
	    Object.defineProperty(object, flag, { value: true, enumerable: true });
	  }
	  return object;
	}
	
	function isFieldValue(object) {
	  return !!(object && isObject(object) && object[flag]);
	}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _this = this;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('claimWizard');
	
	// ================================
	// #region Form Fields
	// ================================
	
	var stepOneFormFields = ['stepOne.selfManaging', // only show if user is allowed to mandate tis is determined in office, if is not allowed default is false
	'stepOne.brokerName', // not editable autofill from office, consultation only
	'stepOne.claimNumber', // first touch is empty (claim has no yet been created) autofill, not editable
	'stepOne.clientName', // autofill from client consultation only
	'stepOne.mobileNumber', // both phoneNumber and mobileNumber fields are automatically filled in with default data from getClient
	'stepOne.phoneNumber', // need to create 2 list of phones numbers one for gsm and one for landline
	'stepOne.email', //auto fill with default from getClient also user could type in a different email
	'stepOne.accountNumber', // bank account auto fill from list of bank accounts from getClient also user could type in a different IBAN (no default)
	'stepOne.accountConfirmation', // boolean not sent to API, user needs to confirm bank account
	'stepOne.claimDate', // mandatory date picker field
	'stepOne.claimRefBroker', // Input filed where user can add his own reference not mandatory
	'stepOne.productId', // List of products from getProductsAndRisks call
	'stepOne.riskId', // List of risk from the product selected from getProductsAndRisks call
	'stepOne.riskDescription', // Translations based on riskId - used for claim list description
	'stepOne.qualificationNumber', // List of qualifications from the getQualification call based on selected product branch
	'stepOne.qualificationLabel', // Translations based on qualificationNumber - used for claim list description
	'stepOne.subQualificationNumber', // List of subQualifications from the selected qualification
	'stepOne.contractIdHist', 'stepFour.claimComment' // used in step 4 to create or update claim comment
	];
	
	exports.stepOneFormFields = stepOneFormFields;
	// #endregion
	
	// ================================
	// #region Form Validations
	// ================================
	
	var disableRiskAndQualificationFields = function disableRiskAndQualificationFields(productField) {
	    var isDisabled = true;
	    if (productField && productField.value) {
	        isDisabled = false;
	    }
	    return isDisabled;
	};
	
	exports.disableRiskAndQualificationFields = disableRiskAndQualificationFields;
	var validate = function validate(values, props) {
	    var hasSubQualifications = props.hasSubQualifications;
	
	    var errors = { stepOne: {} };
	
	    // Unified validation for email, mobileNumber, and phoneNumber
	    var hasContactInfo = values.stepOne.email || values.stepOne.mobileNumber || values.stepOne.phoneNumber;
	
	    if (!hasContactInfo) {
	        errors.stepOne.email = _('requiredContactInfo');
	    } else {
	        if (values.stepOne.mobileNumber && !/^\d+$/.test(values.stepOne.mobileNumber)) {
	            errors.stepOne.mobileNumber = _('invalidMobileNumber');
	        }
	        if (values.stepOne.phoneNumber && !/^\d+$/.test(values.stepOne.phoneNumber)) {
	            errors.stepOne.phoneNumber = _('invalidPhoneNumber');
	        }
	        if (values.stepOne.mobileNumber && values.stepOne.mobileNumber.length > 20) {
	            errors.stepOne.mobileNumber = _('mobileNumberMaxLength20');
	        }
	        if (values.stepOne.phoneNumber && values.stepOne.phoneNumber.length > 20) {
	            errors.stepOne.phoneNumber = _('phoneNumberMaxLength20');
	        }
	        if (values.stepOne.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.stepOne.email)) {
	            errors.stepOne.email = _('invalidEmail');
	        }
	    }
	
	    if (values.stepOne.accountNumber) {
	        if (values.stepOne.accountNumber.length > 20) {
	            errors.stepOne.accountNumber = _('invalidAccountNumber');
	        }
	        if (!values.stepOne.accountConfirmation) {
	            errors.stepOne.accountConfirmation = _('requiredAccountConfirmation');
	        }
	    }
	
	    if (!values.stepOne.claimDate) {
	        errors.stepOne.claimDate = _('requiredClaimDate');
	    }
	
	    if (!values.stepOne.productId) {
	        errors.stepOne.productId = _('requiredProduct');
	    }
	
	    if (!values.stepOne.riskId) {
	        errors.stepOne.riskId = _('requiredRisk');
	    }
	
	    if (!values.stepOne.qualificationNumber) {
	        errors.stepOne.qualificationNumber = _('requiredQualification');
	    }
	
	    if (hasSubQualifications && !values.stepOne.subQualificationNumber) {
	        errors.stepOne.subQualificationNumber = _('requiredSubQualification');
	    }
	
	    return errors;
	};
	
	exports.validate = validate;
	/**
	     * check if there are missing documents and also handles case when there are alternative documents selected
	     * @returns array of missing documents
	     */
	var missingWizardDocuments = function missingWizardDocuments(missingInfo, oraDocuments, docsFromDocumentation, documentFiles) {
	    var missingDocuments = [];
	    if (missingInfo && missingInfo.documents && missingInfo.documents.length > 0) {
	        var _iteratorNormalCompletion;
	
	        var _didIteratorError;
	
	        var _iteratorError;
	
	        var _iterator, _step;
	
	        var _ret = (function () {
	            _iteratorNormalCompletion = true;
	            _didIteratorError = false;
	            _iteratorError = undefined;
	
	            try {
	                var _loop = function () {
	                    var oneDoc = _step.value;
	
	                    if (oraDocuments && oraDocuments.length > 0 && oneDoc.required === 'Wizard') {
	                        var missingDocumentData = oraDocuments.find(function (doc) {
	                            return doc.docType === oneDoc.docType;
	                        });
	                        if (missingDocumentData && missingDocumentData.alternativeDocTypes && missingDocumentData.alternativeDocTypes.length > 0) {
	                            (function () {
	                                //loop through alternative documents and if one alternative has altDocCount > 0, then it is selected
	                                var selectedAlternative = missingDocumentData.alternativeDocTypes.find(function (altDoc) {
	                                    return +altDoc.altDocCount > 0;
	                                });
	                                if (selectedAlternative) {
	                                    missingDocuments.push.apply(missingDocuments, _toConsumableArray(missingDocumentData.alternativeDocTypes.filter(function (altDoc) {
	                                        return +altDoc.altDocCount === 0 && altDoc.alternativeNr === selectedAlternative.alternativeNr;
	                                    }).map(function (altDoc) {
	                                        return altDoc.altDocType;
	                                    }) || []));
	                                } else {
	                                    missingDocuments.push(oneDoc.docType);
	                                }
	                            })();
	                        } else if (missingDocumentData && missingDocumentData.docCount && +missingDocumentData.docCount <= 0) {
	                            missingDocuments.push(oneDoc.docType);
	                        }
	                    }
	                };
	
	                for (_iterator = missingInfo.documents[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    _loop();
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator['return']) {
	                        _iterator['return']();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var finalResults = [];
	            //Check if there are documents uploaded that are pending approval from oracle
	            missingDocuments.forEach(function (oneMissingDoc) {
	                var relevantDocumentFiles = documentFiles.filter(function (oneFile) {
	                    return oneFile.uploaded && oneFile.docType === oneMissingDoc || oneFile.mainDocType;
	                });
	                if (!relevantDocumentFiles) {
	                    finalResults.push(file.docType);
	                } else {
	                    //at this point the missing document has a upload or a alternative has a upload
	                    var _iteratorNormalCompletion2 = true;
	                    var _didIteratorError2 = false;
	                    var _iteratorError2 = undefined;
	
	                    try {
	                        var _loop2 = function () {
	                            var file = _step2.value;
	
	                            // check if file is an alternative, if it is we must check if there are alternatives without upload
	                            if (file.mainDocType && file.alternativeId) {
	                                var documentFromDocumentation = docsFromDocumentation.find(function (oneDoc) {
	                                    return oneDoc.docType === file.mainDocType;
	                                });
	                                if (documentFromDocumentation) {
	                                    var alternativeType = documentFromDocumentation.alternativeDocTypes.find(function (oneAltType) {
	                                        return oneAltType.alternativeNr === file.alternativeId;
	                                    });
	                                    if (alternativeType) {
	                                        _iteratorNormalCompletion3 = true;
	                                        _didIteratorError3 = false;
	                                        _iteratorError3 = undefined;
	
	                                        try {
	                                            var _loop3 = function () {
	                                                var oneAlt = _step3.value;
	
	                                                if (!documentFiles.some(function (oneFile) {
	                                                    return oneFile.uploaded && oneFile.docType === oneAlt;
	                                                })) {
	                                                    finalResults.push(oneAlt);
	                                                }
	                                            };
	
	                                            for (_iterator3 = alternativeType.alternatives[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                                                _loop3();
	                                            }
	                                        } catch (err) {
	                                            _didIteratorError3 = true;
	                                            _iteratorError3 = err;
	                                        } finally {
	                                            try {
	                                                if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	                                                    _iterator3['return']();
	                                                }
	                                            } finally {
	                                                if (_didIteratorError3) {
	                                                    throw _iteratorError3;
	                                                }
	                                            }
	                                        }
	                                    }
	                                }
	                            }
	                        };
	
	                        for (var _iterator2 = relevantDocumentFiles[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                            var _iteratorNormalCompletion3;
	
	                            var _didIteratorError3;
	
	                            var _iteratorError3;
	
	                            var _iterator3, _step3;
	
	                            _loop2();
	                        }
	                    } catch (err) {
	                        _didIteratorError2 = true;
	                        _iteratorError2 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                                _iterator2['return']();
	                            }
	                        } finally {
	                            if (_didIteratorError2) {
	                                throw _iteratorError2;
	                            }
	                        }
	                    }
	                }
	            });
	
	            return {
	                v: [].concat(_toConsumableArray(new Set(finalResults)))
	            };
	        })();
	
	        if (typeof _ret === 'object') return _ret.v;
	    }
	};
	
	exports.missingWizardDocuments = missingWizardDocuments;
	// #endregion
	
	// ================================
	// #region Form Handlers
	// ================================
	
	var updatedFormValue = function updatedFormValue(value, field, dispatch) {
	    dispatch({
	        type: "redux-form/CHANGE",
	        field: field.name,
	        value: value && value.value || '',
	        touch: value && value.value ? !!value.value : false,
	        form: "claimWizardForm"
	    });
	};
	
	exports.updatedFormValue = updatedFormValue;
	var setInitialValues = function setInitialValues(dispatch, existingClaimPackage, fields, _ref) {
	    var brokerName = _ref.brokerName;
	    var clientData = _ref.clientData;
	    var mobilePhoneOptions = _ref.mobilePhoneOptions;
	    var phoneNumberOptions = _ref.phoneNumberOptions;
	    var emailOptions = _ref.emailOptions;
	    var claimComment = _ref.claimComment;
	
	    Object.keys(fields.stepOne).forEach(function (key) {
	        if (existingClaimPackage && existingClaimPackage[key]) {
	            updatedFormValue({ value: existingClaimPackage[key], touched: true }, fields.stepOne[key], dispatch);
	        } else {
	            switch (key) {
	                case 'selfManaging':
	                    updatedFormValue({ value: 'false', touched: true }, fields.stepOne[key], dispatch);
	                    break;
	                case 'brokerName':
	                    updatedFormValue({ value: brokerName, touched: true }, fields.stepOne[key], dispatch);
	                    break;
	                case 'clientName':
	                    updatedFormValue({ value: clientData.main.name, touched: true }, fields.stepOne[key], dispatch);
	                    break;
	                case 'claimDate':
	                    updatedFormValue({ value: existingClaimPackage && Object.keys(existingClaimPackage).length > 0 ? (0, _moment2['default'])().format('YYYY-MM-DD') : "", touched: true }, fields.stepOne[key], dispatch);
	                    break;
	                case 'mobileNumber':
	                    {
	                        var defaultPhoneNumber = mobilePhoneOptions.find(function (oneNumber) {
	                            return oneNumber['default'];
	                        });
	                        updatedFormValue({
	                            value: defaultPhoneNumber ? defaultPhoneNumber.value : '',
	                            touched: false
	                        }, fields.stepOne[key], dispatch);
	                        break;
	                    }
	                case 'phoneNumber':
	                    {
	                        var defaultPhoneNumber = phoneNumberOptions.find(function (oneNumber) {
	                            return oneNumber['default'];
	                        });
	                        updatedFormValue({
	                            value: defaultPhoneNumber ? defaultPhoneNumber.value : '',
	                            touched: false
	                        }, fields.stepOne[key], dispatch);
	                        break;
	                    }
	                case 'email':
	                    {
	                        var defaultEmail = emailOptions.find(function (oneNumber) {
	                            return oneNumber['default'];
	                        });
	                        updatedFormValue({
	                            value: defaultEmail ? defaultEmail.value : '',
	                            touched: false
	                        }, fields.stepOne[key], dispatch);
	                        break;
	                    }
	                default:
	                    break;
	            }
	        }
	    });
	    if (claimComment) {
	        updatedFormValue({ value: claimComment, touched: true }, fields.stepFour.claimComment, dispatch);
	    }
	};
	
	exports.setInitialValues = setInitialValues;
	var updateFormFieldsAfterClaimUpdate = function updateFormFieldsAfterClaimUpdate(dispatch, fields, claimData) {
	    Object.keys(claimData).forEach(function (key) {
	        if (fields.stepOne[key]) {
	            updatedFormValue({ value: claimData[key], touched: true }, fields.stepOne[key], dispatch);
	        }
	    });
	};
	
	exports.updateFormFieldsAfterClaimUpdate = updateFormFieldsAfterClaimUpdate;
	var resetProductAndRisk = function resetProductAndRisk(fields, dispatch) {
	    updatedFormValue({ value: '', touched: true }, fields.stepOne.productId, dispatch);
	    updatedFormValue({ value: '', touched: true }, fields.stepOne.riskId, dispatch);
	    updatedFormValue({ value: '', touched: true }, fields.stepOne.riskDescription, dispatch);
	    updatedFormValue({ value: '', touched: true }, fields.stepOne.qualificationNumber, dispatch);
	    updatedFormValue({ value: '', touched: true }, fields.stepOne.subQualificationNumber, dispatch);
	};
	
	exports.resetProductAndRisk = resetProductAndRisk;
	var prepareDataForClaim = function prepareDataForClaim(formData) {
	    var claimArgs = {};
	    Object.keys(formData).forEach(function (key) {
	        claimArgs[key] = formData[key].value;
	    });
	    return claimArgs;
	};
	
	exports.prepareDataForClaim = prepareDataForClaim;
	var prepareDataForUpdateContact = function prepareDataForUpdateContact(claimData, fields) {
	    var updateArgs = {
	        mongoRecordId: claimData._id,
	        claimId: claimData.claimId,
	        clientId: claimData.clientId,
	        mobileNumber: fields.mobileNumber.value,
	        phoneNumber: fields.phoneNumber.value,
	        email: fields.email.value,
	        accountNumber: fields.accountNumber.value,
	        claimRefBroker: fields.claimRefBroker.value,
	        accountConfirmation: fields.accountConfirmation.value
	    };
	    return updateArgs;
	};
	
	exports.prepareDataForUpdateContact = prepareDataForUpdateContact;
	var generateInvolvedPartiesData = function generateInvolvedPartiesData(involvedPartiesData) {
	    var involvedParties = [];
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	        var _loop4 = function () {
	            var oneInvParty = _step4.value;
	
	            var onePartyData = {
	                partyNumber: oneInvParty.partyNumber
	            };
	            Object.keys(oneInvParty.fields).forEach(function (key) {
	                onePartyData[key] = oneInvParty.fields[key].value;
	            });
	            involvedParties.push(onePartyData);
	        };
	
	        for (var _iterator4 = involvedPartiesData[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            _loop4();
	        }
	    } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion4 && _iterator4['return']) {
	                _iterator4['return']();
	            }
	        } finally {
	            if (_didIteratorError4) {
	                throw _iteratorError4;
	            }
	        }
	    }
	
	    return involvedParties;
	};
	
	exports.generateInvolvedPartiesData = generateInvolvedPartiesData;
	// #endregion
	
	// ================================
	// #region List Options
	// ================================
	
	var setMobilePhoneOptions = function setMobilePhoneOptions(phoneNumbers) {
	    var result = [];
	
	    phoneNumbers.forEach(function (oneNumber) {
	        if (typeof oneNumber.mobile === 'boolean' && oneNumber.mobile || oneNumber.mobile === 'true') {
	            var oneOption = {
	                label: oneNumber.number,
	                value: oneNumber.number
	            };
	            if (typeof oneNumber['default'] === 'boolean' && oneNumber['default'] || oneNumber['default'] === 'true') {
	                oneOption['default'] = true;
	            }
	            result.push(oneOption);
	        }
	    });
	    // fix for when there are no mobile numbers and list is empty and the selector fails to input a custom value
	    if (result.length === 0) {
	        result.push({ label: '', value: '' });
	    }
	    return result;
	};
	
	exports.setMobilePhoneOptions = setMobilePhoneOptions;
	var setPhoneNumbersOptions = function setPhoneNumbersOptions(phoneNumbers) {
	    var result = [];
	    phoneNumbers.forEach(function (oneNumber) {
	        if (typeof oneNumber.mobile === 'boolean' && !oneNumber.mobile || oneNumber.mobile === 'false') {
	            var oneOption = {
	                label: oneNumber.number,
	                value: oneNumber.number
	            };
	            if (typeof oneNumber['default'] === 'boolean' && oneNumber['default'] || oneNumber['default'] === 'true') {
	                oneOption['default'] = true;
	            }
	            result.push(oneOption);
	        }
	    });
	    // fix for when there are no mobile numbers and list is empty and the selector fails to input a custom value
	    if (result.length === 0) {
	        result.push({ label: '', value: '' });
	    }
	    return result;
	};
	
	exports.setPhoneNumbersOptions = setPhoneNumbersOptions;
	var setEmailOptions = function setEmailOptions(emailsList) {
	    var result = emailsList.map(function (emailOption) {
	        return {
	            label: emailOption.email, value: emailOption.email,
	            'default': typeof emailOption['default'] === 'boolean' ? emailOption['default'] : emailOption['default'] === 'true' ? true : false
	        };
	    });
	
	    if (result.length === 0) {
	        result.push({ label: '', value: '' });
	    }
	    return result;
	};
	
	exports.setEmailOptions = setEmailOptions;
	var setAccountOptions = function setAccountOptions(accountNumbers) {
	    return accountNumbers.map(function (oneAccount) {
	        return { label: oneAccount.IBAN, value: oneAccount.IBAN };
	    });
	};
	
	exports.setAccountOptions = setAccountOptions;
	var setRiskAndQualificationsOptions = function setRiskAndQualificationsOptions(dispatch, productId, productList, selfManaging, contractId, contractIdHist) {
	    var riskOptionsList, qualificationOptionsList, qualificationList, product, branch, qualificationsRes;
	    return regeneratorRuntime.async(function setRiskAndQualificationsOptions$(context$1$0) {
	        while (1) switch (context$1$0.prev = context$1$0.next) {
	            case 0:
	                riskOptionsList = [];
	                qualificationOptionsList = [];
	                qualificationList = [];
	                product = productList.find(function (oneProduct) {
	                    return oneProduct.productId === productId;
	                });
	
	                if (!product) {
	                    context$1$0.next = 13;
	                    break;
	                }
	
	                branch = product.branch;
	                context$1$0.next = 8;
	                return regeneratorRuntime.awrap(getQualifications(dispatch, branch, contractId, contractIdHist));
	
	            case 8:
	                qualificationsRes = context$1$0.sent;
	
	                if (qualificationsRes) {
	                    qualificationList = qualificationsRes.qualifications;
	                }
	                if (selfManaging === 'true') {
	                    qualificationList = qualificationList.filter(function (qualification) {
	                        return qualification.legalAid === 'false';
	                    });
	                }
	                qualificationOptionsList = qualificationList.map(function (oneQualification) {
	                    return {
	                        value: oneQualification.qualificationNumber,
	                        label: oneQualification.qualificationName
	                    };
	                });
	                // set the risk options
	                riskOptionsList = product.risks.map(function (oneRisk) {
	                    return { value: oneRisk.riskId, label: oneRisk.riskDescription };
	                });
	                //reset selected
	
	            case 13:
	                riskOptionsList.sort(function (a, b) {
	                    return a.label.localeCompare(b.label);
	                });
	                qualificationOptionsList.sort(function (a, b) {
	                    return a.label.localeCompare(b.label);
	                });
	                return context$1$0.abrupt('return', { riskOptionsList: riskOptionsList, qualificationList: qualificationList, qualificationOptionsList: qualificationOptionsList });
	
	            case 16:
	            case 'end':
	                return context$1$0.stop();
	        }
	    }, null, _this);
	};
	
	exports.setRiskAndQualificationsOptions = setRiskAndQualificationsOptions;
	// #endregion
	
	// ================================
	// #region API requests
	// ================================
	
	var getAndSetProductsAndRisks = function getAndSetProductsAndRisks(dispatch, contractId, claimDate, fields) {
	    var result, productsList, productListOptions, contractIdHist, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, oneProduct;
	
	    return regeneratorRuntime.async(function getAndSetProductsAndRisks$(context$1$0) {
	        while (1) switch (context$1$0.prev = context$1$0.next) {
	            case 0:
	                context$1$0.prev = 0;
	                context$1$0.next = 3;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.getProductsAndRisksRequest)(contractId, claimDate)));
	
	            case 3:
	                result = context$1$0.sent;
	
	                if (!(result && result.products)) {
	                    context$1$0.next = 30;
	                    break;
	                }
	
	                productsList = result && result.products || [];
	                productListOptions = [];
	                contractIdHist = result && result.contractIdHist || '';
	                _iteratorNormalCompletion5 = true;
	                _didIteratorError5 = false;
	                _iteratorError5 = undefined;
	                context$1$0.prev = 11;
	
	                for (_iterator5 = productsList[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                    oneProduct = _step5.value;
	
	                    productListOptions.push({
	                        label: oneProduct.product + ' - ' + oneProduct.option,
	                        value: oneProduct.productId
	                    });
	                }
	                context$1$0.next = 19;
	                break;
	
	            case 15:
	                context$1$0.prev = 15;
	                context$1$0.t0 = context$1$0['catch'](11);
	                _didIteratorError5 = true;
	                _iteratorError5 = context$1$0.t0;
	
	            case 19:
	                context$1$0.prev = 19;
	                context$1$0.prev = 20;
	
	                if (!_iteratorNormalCompletion5 && _iterator5['return']) {
	                    _iterator5['return']();
	                }
	
	            case 22:
	                context$1$0.prev = 22;
	
	                if (!_didIteratorError5) {
	                    context$1$0.next = 25;
	                    break;
	                }
	
	                throw _iteratorError5;
	
	            case 25:
	                return context$1$0.finish(22);
	
	            case 26:
	                return context$1$0.finish(19);
	
	            case 27:
	                productListOptions.sort(function (a, b) {
	                    return a.label.localeCompare(b.label);
	                });
	                //update to new contractIdHist
	                updatedFormValue({ value: contractIdHist, touched: true }, fields.stepOne.contractIdHist, dispatch);
	
	                return context$1$0.abrupt('return', { productsList: productsList, productListOptions: productListOptions });
	
	            case 30:
	                return context$1$0.abrupt('return', { productsList: [], productListOptions: [] });
	
	            case 33:
	                context$1$0.prev = 33;
	                context$1$0.t1 = context$1$0['catch'](0);
	
	                console.error('getAndSetProductsAndRisks error: ', context$1$0.t1);
	                return context$1$0.abrupt('return', { productsList: [], productListOptions: [] });
	
	            case 37:
	            case 'end':
	                return context$1$0.stop();
	        }
	    }, null, _this, [[0, 33], [11, 15, 19, 27], [20,, 22, 26]]);
	};
	
	exports.getAndSetProductsAndRisks = getAndSetProductsAndRisks;
	var getQualifications = function getQualifications(dispatch, branch, contractId, contractIdHist) {
	    var result;
	    return regeneratorRuntime.async(function getQualifications$(context$1$0) {
	        while (1) switch (context$1$0.prev = context$1$0.next) {
	            case 0:
	                context$1$0.prev = 0;
	                result = dispatch((0, _stateActions.getQualificationsRequest)(branch, contractId, contractIdHist));
	
	                if (!result) {
	                    context$1$0.next = 4;
	                    break;
	                }
	
	                return context$1$0.abrupt('return', result);
	
	            case 4:
	                context$1$0.next = 9;
	                break;
	
	            case 6:
	                context$1$0.prev = 6;
	                context$1$0.t0 = context$1$0['catch'](0);
	
	                console.warn('Error getting qualifications: ', context$1$0.t0);
	
	            case 9:
	            case 'end':
	                return context$1$0.stop();
	        }
	    }, null, _this, [[0, 6]]);
	};
	
	exports.getQualifications = getQualifications;
	var saveNewClaim = function saveNewClaim(dispatch, claimArgs) {
	    return regeneratorRuntime.async(function saveNewClaim$(context$1$0) {
	        while (1) switch (context$1$0.prev = context$1$0.next) {
	            case 0:
	                context$1$0.prev = 0;
	                context$1$0.next = 3;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.createClaim)(claimArgs)));
	
	            case 3:
	                context$1$0.next = 5;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimArgs.contractId })));
	
	            case 5:
	                context$1$0.next = 7;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.getDocumentationRequest)(claimArgs.qualificationNumber, claimArgs.subQualificationNumber)));
	
	            case 7:
	                context$1$0.next = 9;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.setClaimWizardStep)('2')));
	
	            case 9:
	                context$1$0.next = 14;
	                break;
	
	            case 11:
	                context$1$0.prev = 11;
	                context$1$0.t0 = context$1$0['catch'](0);
	
	                console.warn(context$1$0.t0);
	
	            case 14:
	            case 'end':
	                return context$1$0.stop();
	        }
	    }, null, _this, [[0, 11]]);
	};
	
	exports.saveNewClaim = saveNewClaim;
	var updateClaimContactAndSetStep2 = function updateClaimContactAndSetStep2(dispatch, claimData, fields) {
	    var updateArguments;
	    return regeneratorRuntime.async(function updateClaimContactAndSetStep2$(context$1$0) {
	        while (1) switch (context$1$0.prev = context$1$0.next) {
	            case 0:
	                updateArguments = prepareDataForUpdateContact(claimData, fields.stepOne);
	
	                updateArguments.brokerNumber = claimData.brokerNumber;
	                context$1$0.next = 4;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateClaimContact)(updateArguments)));
	
	            case 4:
	                context$1$0.next = 6;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimData.contractId })));
	
	            case 6:
	                context$1$0.next = 8;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.getDocumentationRequest)(claimData.qualificationNumber, claimData.subQualificationNumber)));
	
	            case 8:
	                context$1$0.next = 10;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.setClaimWizardStep)('2')));
	
	            case 10:
	            case 'end':
	                return context$1$0.stop();
	        }
	    }, null, _this);
	};
	
	exports.updateClaimContactAndSetStep2 = updateClaimContactAndSetStep2;
	var getClaimMongoRecord = function getClaimMongoRecord(dispatch, args) {
	    var claimMongoRecord;
	    return regeneratorRuntime.async(function getClaimMongoRecord$(context$1$0) {
	        while (1) switch (context$1$0.prev = context$1$0.next) {
	            case 0:
	                context$1$0.prev = 0;
	                context$1$0.next = 3;
	                return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)(args)));
	
	            case 3:
	                claimMongoRecord = context$1$0.sent;
	
	                if (!claimMongoRecord) {
	                    context$1$0.next = 8;
	                    break;
	                }
	
	                return context$1$0.abrupt('return', claimMongoRecord);
	
	            case 8:
	                console.warn("No claimMongoRecord found:", args);
	                return context$1$0.abrupt('return', null);
	
	            case 10:
	                context$1$0.next = 16;
	                break;
	
	            case 12:
	                context$1$0.prev = 12;
	                context$1$0.t0 = context$1$0['catch'](0);
	
	                console.error("Error in getClaimMongoRecord:", context$1$0.t0);
	                return context$1$0.abrupt('return', null);
	
	            case 16:
	            case 'end':
	                return context$1$0.stop();
	        }
	    }, null, _this, [[0, 12]]);
	};
	
	exports.getClaimMongoRecord = getClaimMongoRecord;
	var openOverviewPdf = function openOverviewPdf(claimPackageId) {
	    var overviewPDFLink, w, onLoadWindowPromise;
	    return regeneratorRuntime.async(function openOverviewPdf$(context$1$0) {
	        while (1) switch (context$1$0.prev = context$1$0.next) {
	            case 0:
	                overviewPDFLink = 'api/getOverviewPdfForPrint/' + claimPackageId;
	                w = window.open(overviewPDFLink, '_blank');
	                onLoadWindowPromise = new Promise(function (resolve) {
	                    w.addEventListener('load', function () {
	                        resolve();
	                    }, true);
	                });
	                context$1$0.next = 5;
	                return regeneratorRuntime.awrap(onLoadWindowPromise);
	
	            case 5:
	            case 'end':
	                return context$1$0.stop();
	        }
	    }, null, _this);
	};
	
	exports.openOverviewPdf = openOverviewPdf;
	// #endregion

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClaimWizardScss = __webpack_require__(155);
	
	var _ClaimWizardScss2 = _interopRequireDefault(_ClaimWizardScss);
	
	var WizardModalContent = function WizardModalContent(_ref) {
	    var modalTitle = _ref.modalTitle;
	    var children = _ref.children;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: _ClaimWizardScss2['default'].modalContent, key: 'wizardModalContent' },
	        _react2['default'].createElement(
	            'span',
	            { className: _ClaimWizardScss2['default'].title },
	            modalTitle
	        ),
	        children
	    );
	};
	
	exports['default'] = WizardModalContent;
	module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentPageDomScss = __webpack_require__(1633);
	
	var _ComponentPageDomScss2 = _interopRequireDefault(_ComponentPageDomScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var ComponentPageDom = function ComponentPageDom(_ref) {
		var title = _ref.title;
		var subtitle = _ref.subtitle;
		var children = _ref.children;
		var noHeader = _ref.noHeader;
		var extraClassName = _ref.extraClassName;
		var extraClassNameMainSubDiv = _ref.extraClassNameMainSubDiv;
		var _ref$usesBackButton = _ref.usesBackButton;
		var usesBackButton = _ref$usesBackButton === undefined ? false : _ref$usesBackButton;
		var _ref$backButtonOnClick = _ref.backButtonOnClick;
		var backButtonOnClick = _ref$backButtonOnClick === undefined ? null : _ref$backButtonOnClick;
		var _ref$backButtonLabel = _ref.backButtonLabel;
		var backButtonLabel = _ref$backButtonLabel === undefined ? "back" : _ref$backButtonLabel;
	
		var showHeader = !noHeader;
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])(_ComponentPageDomScss2['default'].pageModule, extraClassName ? extraClassName : {}) },
			_react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])(_ComponentPageDomScss2['default'].mainSubDiv, extraClassNameMainSubDiv ? extraClassNameMainSubDiv : {}) },
				showHeader && _react2['default'].createElement(
					'div',
					{ className: _ComponentPageDomScss2['default'].mainTitleDiv + ' bottom-border' },
					_react2['default'].createElement(
						'div',
						{ className: _ComponentPageDomScss2['default'].mainTitleContainer },
						_react2['default'].createElement(
							'h2',
							null,
							title
						),
						_react2['default'].createElement(
							'h3',
							null,
							subtitle
						)
					),
					usesBackButton && _react2['default'].createElement(
						'div',
						{ className: _ComponentPageDomScss2['default'].moduleControls },
						_react2['default'].createElement(
							'div',
							{ className: _ComponentPageDomScss2['default'].buttonOrganizer },
							_react2['default'].createElement(
								'button',
								{
									className: _ComponentPageDomScss2['default'].backToList,
									onClick: function () {
										if (typeof backButtonOnClick == "function") {
											return backButtonOnClick();
										}
	
										return;
									}
								},
								"← " + backButtonLabel
							)
						)
					)
				),
				children
			)
		);
	};
	ComponentPageDom.propTypes = {
		title: _react.PropTypes.string.isRequired,
		subtitle: _react.PropTypes.string.isRequired,
		children: _react2['default'].PropTypes.node,
		noHeader: _react2['default'].PropTypes.bool
	};
	exports['default'] = ComponentPageDom;
	module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementsGrailScss = __webpack_require__(1640);
	
	var _elementsGrailScss2 = _interopRequireDefault(_elementsGrailScss);
	
	var cloneWithClass = function cloneWithClass(elems) {
		for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			args[_key - 1] = arguments[_key];
		}
	
		if (!elems) {
			return;
		}
		var el = _react2['default'].Children.only(elems);
		return _react2['default'].cloneElement(el, { className: _classnames2['default'].apply(undefined, [el.props.className].concat(args)) });
	};
	// Performs flexbox Holy Grail layout
	// elements must accept given classnames
	var Grail = function Grail(_ref) {
		var stretch = _ref.stretch;
		var noScroll = _ref.noScroll;
		var header = _ref.header;
		var children = _ref.children;
		var content = _ref.content;
		var nav = _ref.nav;
		var aside = _ref.aside;
		var footer = _ref.footer;
		var wrapperClass = _ref.wrapperClass;
		var extraClassName = _ref.extraClassName;
		var extraContentClassName = _ref.extraContentClassName;
	
		var rest = _objectWithoutProperties(_ref, ['stretch', 'noScroll', 'header', 'children', 'content', 'nav', 'aside', 'footer', 'wrapperClass', 'extraClassName', 'extraContentClassName']);
	
		var scrollStyle = noScroll || _elementsGrailScss2['default'].scroll;
		var stretchStyle = stretch && _elementsGrailScss2['default'].stretch;
	
		var headEl = cloneWithClass(header, _elementsGrailScss2['default'].header);
		var navEl = cloneWithClass(nav, _elementsGrailScss2['default'].nav);
		var contEl = cloneWithClass(children || content, _elementsGrailScss2['default'].content, scrollStyle);
		var asideEl = cloneWithClass(aside, _elementsGrailScss2['default'].aside);
		var footerEl = cloneWithClass(footer, _elementsGrailScss2['default'].footer);
		return _react2['default'].createElement(
			'div',
			_extends({}, rest, { className: (0, _classnames2['default'])(_elementsGrailScss2['default'].holyGrail, scrollStyle, stretchStyle, rest.className, extraClassName ? extraClassName : '') }),
			headEl,
			_react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])(_elementsGrailScss2['default'].ieWrap, scrollStyle, _elementsGrailScss2['default'].screenResizer, extraContentClassName) },
				_react2['default'].createElement(
					'div',
					{ className: (0, _classnames2['default'])(_elementsGrailScss2['default'].body, scrollStyle, wrapperClass) },
					contEl,
					navEl,
					asideEl
				)
			),
			footerEl
		);
	};
	exports['default'] = Grail;
	module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(1178);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(178);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIndexedObject = __webpack_require__(51);
	var toAbsoluteIndex = __webpack_require__(117);
	var lengthOfArrayLike = __webpack_require__(34);
	
	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    if (length === 0) return !IS_INCLUDES && -1;
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el !== el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value !== value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var wellKnownSymbol = __webpack_require__(27);
	var V8_VERSION = __webpack_require__(115);
	
	var SPECIES = wellKnownSymbol('species');
	
	module.exports = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION >= 51 || !fails(function () {
	    var array = [];
	    var constructor = array.constructor = {};
	    constructor[SPECIES] = function () {
	      return { foo: 1 };
	    };
	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var arraySpeciesConstructor = __webpack_require__(1223);
	
	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(29);
	var ownKeys = __webpack_require__(416);
	var getOwnPropertyDescriptorModule = __webpack_require__(59);
	var definePropertyModule = __webpack_require__(42);
	
	module.exports = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	module.exports = function (value, done) {
	  return { value: value, done: done };
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineBuiltIn = __webpack_require__(40);
	
	module.exports = function (target, src, options) {
	  for (var key in src) defineBuiltIn(target, key, src[key], options);
	  return target;
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = (function () { /* empty */ }).bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(98);
	var getMethod = __webpack_require__(116);
	var isNullOrUndefined = __webpack_require__(64);
	var Iterators = __webpack_require__(234);
	var wellKnownSymbol = __webpack_require__(27);
	
	var ITERATOR = wellKnownSymbol('iterator');
	
	module.exports = function (it) {
	  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
	    || getMethod(it, '@@iterator')
	    || Iterators[classof(it)];
	};


/***/ }),
/* 232 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = {};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var isCallable = __webpack_require__(28);
	
	var replacement = /#|\.prototype\./;
	
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value === POLYFILL ? true
	    : value === NATIVE ? false
	    : isCallable(detection) ? fails(detection)
	    : !!detection;
	};
	
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	
	module.exports = isForced;


/***/ }),
/* 234 */
232,
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toString = __webpack_require__(18);
	
	module.exports = function (argument, $default) {
	  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var internalObjectKeys = __webpack_require__(680);
	var enumBugKeys = __webpack_require__(402);
	
	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	module.exports = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys);
	};


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (exec) {
	  try {
	    return { error: false, value: exec() };
	  } catch (error) {
	    return { error: true, value: error };
	  }
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var NativePromiseConstructor = __webpack_require__(187);
	var isCallable = __webpack_require__(28);
	var isForced = __webpack_require__(233);
	var inspectSource = __webpack_require__(405);
	var wellKnownSymbol = __webpack_require__(27);
	var ENVIRONMENT = __webpack_require__(281);
	var IS_PURE = __webpack_require__(43);
	var V8_VERSION = __webpack_require__(115);
	
	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
	var SPECIES = wellKnownSymbol('species');
	var SUBCLASSING = false;
	var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis.PromiseRejectionEvent);
	
	var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
	  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
	  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
	  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	  // We can't detect it synchronously, so just check versions
	  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
	  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
	  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
	  // We can't use @@species feature detection in V8 since it causes
	  // deoptimization and performance degradation
	  // https://github.com/zloirock/core-js/issues/679
	  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
	    // Detect correctness of subclassing with @@species support
	    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
	    var FakePromise = function (exec) {
	      exec(function () { /* empty */ }, function () { /* empty */ });
	    };
	    var constructor = promise.constructor = {};
	    constructor[SPECIES] = FakePromise;
	    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
	    if (!SUBCLASSING) return true;
	  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	  } return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
	});
	
	module.exports = {
	  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
	  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
	  SUBCLASSING: SUBCLASSING
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var anObject = __webpack_require__(20);
	var isCallable = __webpack_require__(28);
	var classof = __webpack_require__(53);
	var regexpExec = __webpack_require__(418);
	
	var $TypeError = TypeError;
	
	// `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (isCallable(exec)) {
	    var result = call(exec, R, S);
	    if (result !== null) anObject(result);
	    return result;
	  }
	  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
	  throw new $TypeError('RegExp#exec called on incompatible receiver');
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var hasOwn = __webpack_require__(29);
	var isPrototypeOf = __webpack_require__(74);
	var regExpFlags = __webpack_require__(419);
	
	var RegExpPrototype = RegExp.prototype;
	
	module.exports = function (R) {
	  var flags = R.flags;
	  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
	    ? call(regExpFlags, R) : flags;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThisAccessor = __webpack_require__(283);
	var SetHelpers = __webpack_require__(92);
	
	module.exports = uncurryThisAccessor(SetHelpers.proto, 'size', 'get') || function (set) {
	  return set.size;
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(632).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ }),
/* 243 */
[2339, 825, 433, 443],
/* 244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"formContainerOuter":"_2WZ8Atr0Dx9vAnmELJWAKt","clientsMain":"_1IzaVYE-elW3AG6GXRUCzM","clientsSearchContainer":"jRPad9TcT8RFjW3DBsYwO","hidden":"_2bNOo7tIfKe5KuXHn8DOJp","formContainer":"UTPqsMNodSp3mxgshG1Dv","column":"naSXn71YxEYa3yHk-oW9P","searchContainer":"_2PTfjzr32hTIWRsaWa7t_Z","searchContainerSeparated":"_2petERRcfJMErlRqKKhU_i","label":"Q6YuGHrrr3RELRZ6zjasH","error":"_3xfeMhc6l8LZizzwQ5qXOt","clientSearchInput":"_7940m4d6ZZCR8_9WIqrDP","inputCharacteristics":"_23J-9m7iMYiwmMhb_9h4K5","disabled":"_2MHok7fUgzP3nyhKQOQCAn","clientSearchInputLong":"_2uv3_m1YvwUp07kwKkYCrS","fullColumn":"yGas5rDBp7BhGkZ-x9OpH","greyButton":"Ypczh8vUOa_IRn6zbdKCK","enabled":"_3UPH3MDIgNWtPRcc-I37AO","greenButton":"m_C8zFz7DrpGFs4beMfDs","customCreateModal":"_2mbJoZpVRlTkR30clqn4Nf","isOpened":"_11XPqV5TaW7KpIdNo3npR_","overlayMap":"_-wKGNyQi6hbgpPCwLhwZX"};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"error":"_10hC8O76CqdMJ-DAUZYFpp","datepicker__input-container":"_1qfz0SK-S7Nysmi0hyefiM","moduleSection":"_3YWutQ61Zoy2Fe0gI-skVy","clientsTableContainer":"_1UM8TgIHEcVDL8irCpUxpD","iconContainer":"_2XY6TxekNWuym6cOjEtv57","addFieldButton":"_1OhO3rf8xc4SU6zdJ9KfG5","greyButton":"_2Sy1TjOb9vS3iCy_YjkZEX","editFieldButton":"_15xNdqy0rnk2k1pKqH6B67","removeFieldsButton":"_1ChpwuItfyuNf3Jn6cfSmo","datepickerLabelField":"_3Hcp6XCt2oaKGjdzfedSss","clientModalContent":"ltrh1HS7E-DrbWKwP-uPA","title":"_20zyGhHM9bIIIIRtT4XWF2","cancel":"_1H52TJ-k-O-BS0sHWLApN6","next":"_1A1z5Ptnngpr-9LIWSPtkk","enabled":"CGapT79qVu7ErnsEXJ8DK","clientModalButtons":"_3mMZ3fFBNNOPdoxwd2yCxt"};

/***/ }),
/* 246 */
[2342, 1569, 1568, 1570, 1571, 712, 195, 1572, 1667, 1666, 442, 1668],
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(311),
	    arrayEach = __webpack_require__(449),
	    assignValue = __webpack_require__(314),
	    baseAssign = __webpack_require__(741),
	    baseAssignIn = __webpack_require__(1698),
	    cloneBuffer = __webpack_require__(759),
	    copyArray = __webpack_require__(249),
	    copySymbols = __webpack_require__(1740),
	    copySymbolsIn = __webpack_require__(1741),
	    getAllKeys = __webpack_require__(770),
	    getAllKeysIn = __webpack_require__(460),
	    getTag = __webpack_require__(119),
	    initCloneArray = __webpack_require__(1753),
	    initCloneByTag = __webpack_require__(1754),
	    initCloneObject = __webpack_require__(774),
	    isArray = __webpack_require__(30),
	    isBuffer = __webpack_require__(162),
	    isMap = __webpack_require__(794),
	    isObject = __webpack_require__(56),
	    isSet = __webpack_require__(796),
	    keys = __webpack_require__(70),
	    keysIn = __webpack_require__(71);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(450),
	    isFlattenable = __webpack_require__(1755);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isArray = __webpack_require__(30),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var EventPluginRegistry = __webpack_require__(471);
	var EventPluginUtils = __webpack_require__(472);
	var ReactErrorUtils = __webpack_require__(476);
	
	var accumulateInto = __webpack_require__(848);
	var forEachAccumulated = __webpack_require__(849);
	var invariant = __webpack_require__(21);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(252);
	var EventPluginUtils = __webpack_require__(472);
	
	var accumulateInto = __webpack_require__(848);
	var forEachAccumulated = __webpack_require__(849);
	var warning = __webpack_require__(35);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(122);
	
	var getEventTarget = __webpack_require__(481);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 256 */
32,
/* 257 */
[2339, 923, 503, 506],
/* 258 */
[2342, 2173, 2172, 2174, 2175, 911, 214, 2176, 2180, 2179, 505, 2181],
/* 259 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/easinsure/easinsure-logotype-slogan.svg";

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDAwMDAwIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xMiAyQzYuNDggMiAyIDYuNDggMiAxMnM0LjQ4IDEwIDEwIDEwIDEwLTQuNDggMTAtMTBTMTcuNTIgMiAxMiAyem0wIDE4Yy00LjQyIDAtOC0zLjU4LTgtOCAwLTEuODUuNjMtMy41NSAxLjY5LTQuOUwxNi45IDE4LjMxQzE1LjU1IDE5LjM3IDEzLjg1IDIwIDEyIDIwem02LjMxLTMuMUw3LjEgNS42OUM4LjQ1IDQuNjMgMTAuMTUgNCAxMiA0YzQuNDIgMCA4IDMuNTggOCA4IDAgMS44NS0uNjMgMy41NS0xLjY5IDQuOXoiLz4KPC9zdmc+"

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./icn-agenda.svg": 535,
		"./icn-automotive.svg": 536,
		"./icn-b2b.svg": 537,
		"./icn-claimWizard-white.svg": 356,
		"./icn-claims.svg": 538,
		"./icn-clients.svg": 539,
		"./icn-contracts.svg": 540,
		"./icn-credit.svg": 541,
		"./icn-dsdocuments-blue.svg": 542,
		"./icn-dsdocuments-green.svg": 543,
		"./icn-dsdocuments-white.svg": 357,
		"./icn-dsdocuments.svg": 544,
		"./icn-family.svg": 545,
		"./icn-faq.svg": 546,
		"./icn-fire.svg": 547,
		"./icn-generali.svg": 548,
		"./icn-health.svg": 549,
		"./icn-home.svg": 550,
		"./icn-inbox-blue.svg": 551,
		"./icn-inbox-white.svg": 358,
		"./icn-inbox.svg": 552,
		"./icn-info.svg": 553,
		"./icn-life.svg": 554,
		"./icn-link_1x_blue.svg": 555,
		"./icn-links.svg": 556,
		"./icn-logout.svg": 557,
		"./icn-misc.svg": 558,
		"./icn-news.svg": 559,
		"./icn-no-result.svg": 23,
		"./icn-office.svg": 560,
		"./icn-outbox.svg": 561,
		"./icn-outline-location_on-24px.svg": 562,
		"./icn-production.svg": 563,
		"./icn-tasklist.svg": 564,
		"./icn-transport.svg": 565,
		"./icn-webapps.svg": 566,
		"./icn-willdoc.svg": 567,
		"./icn-workinjuries.svg": 568
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 262;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Index = __webpack_require__(1038);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _ClaimWizardScss = __webpack_require__(155);
	
	var _ClaimWizardScss2 = _interopRequireDefault(_ClaimWizardScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _claimsWizardService = __webpack_require__(217);
	
	// variables out of module
	var _ = (0, _libI18n2["default"])('claimWizard');
	
	var ClaimWizardButton = (function (_Component) {
	    _inherits(ClaimWizardButton, _Component);
	
	    _createClass(ClaimWizardButton, null, [{
	        key: "propTypes",
	        value: {
	            contractNumber: _react2["default"].PropTypes.string,
	            claimNumber: _react2["default"].PropTypes.string,
	            contractId: _react2["default"].PropTypes.string,
	            contractNumber: _react2["default"].PropTypes.string,
	            clientId: _react2["default"].PropTypes.string,
	            onGoing: _react2["default"].PropTypes.bool,
	            isDigitalTable: _react2["default"].PropTypes.bool,
	            isClientContract: _react2["default"].PropTypes.bool,
	            onCloseMethod: _react2["default"].PropTypes.func
	        },
	        enumerable: true
	    }, {
	        key: "defaultProps",
	        value: {
	            onGoing: false,
	            isDigitalTable: false,
	            isClientContract: false
	        },
	        enumerable: true
	    }]);
	
	    function ClaimWizardButton(props) {
	        var _this = this;
	
	        _classCallCheck(this, _ClaimWizardButton);
	
	        _get(Object.getPrototypeOf(_ClaimWizardButton.prototype), "constructor", this).call(this, props);
	
	        this.onOpenClaimWizard = function callee$2$0() {
	            var _props, dispatch, contractId, claimNumber, isDigitalTable, args, claimData;
	
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        _props = this.props;
	                        dispatch = _props.dispatch;
	                        contractId = _props.contractId;
	                        claimNumber = _props.claimNumber;
	                        isDigitalTable = _props.isDigitalTable;
	                        args = {};
	
	                        if (claimNumber) {
	                            args.claimNumber = claimNumber;
	                        }
	                        if (contractId) {
	                            args.contractId = contractId;
	                        }
	
	                        if (!isDigitalTable) {
	                            context$3$0.next = 13;
	                            break;
	                        }
	
	                        context$3$0.next = 11;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.getClaimMongoRecord)(dispatch, args));
	
	                    case 11:
	                        claimData = context$3$0.sent;
	
	                        if (!claimData) {
	                            console.warn("No claim data found for the given arguments:", args);
	                            this.setState({ claimData: {} });
	                        } else {
	                            this.setState({ claimData: claimData });
	                        }
	
	                    case 13:
	
	                        this.setState({ claimWizardIsOpened: true });
	
	                    case 14:
	                    case "end":
	                        return context$3$0.stop();
	                }
	            }, null, _this);
	        };
	
	        this.onCloseClaimWizard = function callee$2$0() {
	            var _props2, dispatch, contractId, claimNumber, isClientContract, onCloseMethod, args, claimData;
	
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        contractId = _props2.contractId;
	                        claimNumber = _props2.claimNumber;
	                        isClientContract = _props2.isClientContract;
	                        onCloseMethod = _props2.onCloseMethod;
	
	                        if (!isClientContract) {
	                            context$3$0.next = 14;
	                            break;
	                        }
	
	                        args = {};
	
	                        if (claimNumber) {
	                            args.claimNumber = claimNumber;
	                        }
	                        if (contractId) {
	                            args.contractId = contractId;
	                        }
	
	                        context$3$0.next = 12;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.getClaimMongoRecord)(dispatch, args));
	
	                    case 12:
	                        claimData = context$3$0.sent;
	
	                        if (!claimData) {
	                            console.warn("No claim data found for the given arguments:", args);
	                            this.setState({ claimData: {} });
	                        } else {
	                            this.setState({ claimData: claimData });
	                        }
	
	                    case 14:
	
	                        this.setState({ claimWizardIsOpened: false });
	
	                        if (onCloseMethod) {
	                            onCloseMethod();
	                        }
	
	                    case 16:
	                    case "end":
	                        return context$3$0.stop();
	                }
	            }, null, _this);
	        };
	
	        this.getIcon = function (menuName) {
	            try {
	                return __webpack_require__(262)("./icn-" + menuName + ".svg");
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        };
	
	        this.state = {
	            claimWizardIsOpened: false,
	            claimData: {}
	        };
	    }
	
	    _createClass(ClaimWizardButton, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props3, dispatch, contractId, claimNumber, args, claimData;
	
	            return regeneratorRuntime.async(function componentDidMount$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props3 = this.props;
	                        dispatch = _props3.dispatch;
	                        contractId = _props3.contractId;
	                        claimNumber = _props3.claimNumber;
	                        args = {};
	
	                        if (claimNumber) {
	                            args.claimNumber = claimNumber;
	                        }
	                        if (contractId) {
	                            args.contractId = contractId;
	                        }
	
	                        context$2$0.prev = 7;
	                        context$2$0.next = 10;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.getClaimMongoRecord)(dispatch, args));
	
	                    case 10:
	                        claimData = context$2$0.sent;
	
	                        if (!claimData) {
	                            console.warn("No claim data found for the given arguments:", args);
	                            this.setState({ claimData: {} });
	                        } else {
	                            this.setState({ claimData: claimData });
	                        }
	                        context$2$0.next = 18;
	                        break;
	
	                    case 14:
	                        context$2$0.prev = 14;
	                        context$2$0.t0 = context$2$0["catch"](7);
	
	                        console.error("Error fetching claim data:", context$2$0.t0);
	                        this.setState({ claimData: {} });
	
	                    case 18:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this, [[7, 14]]);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props;
	            var canCreateClaim = _props4.canCreateClaim;
	            var contractId = _props4.contractId;
	            var claimNumber = _props4.claimNumber;
	            var clientId = _props4.clientId;
	            var brokerNumber = _props4.brokerNumber;
	            var onGoing = _props4.onGoing;
	            var isClientContract = _props4.isClientContract;
	            var contractNumber = _props4.contractNumber;
	            var _state = this.state;
	            var claimWizardIsOpened = _state.claimWizardIsOpened;
	            var claimData = _state.claimData;
	
	            var disabled = false;
	
	            var claimStatus = claimData ? claimData.claimStatus : null;
	
	            return _react2["default"].createElement(
	                "div",
	                { className: _ClaimWizardScss2["default"].claimWizardButtonContainer },
	                canCreateClaim && _react2["default"].createElement(
	                    "div",
	                    {
	                        key: "claimWizardBtn",
	                        className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].grayButtonFlex, _ClaimWizardScss2["default"].claimWizardButton, disabled ? _ClaimWizardScss2["default"].disabled : ''),
	                        onClick: function (e) {
	                            return !disabled ? _this2.onOpenClaimWizard(e) : e.preventDefault();
	                        }
	                    },
	                    _react2["default"].createElement("img", { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].claimWizardButtonIcon), src: this.getIcon('claimWizard-white') }),
	                    claimData && claimStatus === '8' || onGoing ? _('continueClaimButton') : _('createClaimButton')
	                ),
	                claimWizardIsOpened && _react2["default"].createElement(_Index2["default"], {
	                    contractId: contractId,
	                    claimNumber: claimNumber,
	                    contractNumber: contractNumber,
	                    clientId: clientId,
	                    brokerNumber: brokerNumber,
	                    claimWizardIsOpened: claimWizardIsOpened,
	                    closeWizard: function () {
	                        return _this2.onCloseClaimWizard();
	                    },
	                    onGoing: onGoing,
	                    isClientContract: isClientContract
	                })
	            );
	        }
	    }]);
	
	    var _ClaimWizardButton = ClaimWizardButton;
	    ClaimWizardButton = (0, _reactRedux.connect)(function (state) {
	        var userAccess = state.app.security.actions;
	        var canCreateClaim = false;
	        userAccess.forEach(function (item, key) {
	            if (item.actionName == 'createclaim') {
	                canCreateClaim = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        return {
	            canCreateClaim: canCreateClaim
	        };
	    })(ClaimWizardButton) || ClaimWizardButton;
	    return ClaimWizardButton;
	})(_react.Component);
	
	exports["default"] = ClaimWizardButton;
	module.exports = exports["default"];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactLibReact = __webpack_require__(166);
	
	var _reactLibReact2 = _interopRequireDefault(_reactLibReact);
	
	var _reminderEmailStatusDialogScss = __webpack_require__(1582);
	
	var _reminderEmailStatusDialogScss2 = _interopRequireDefault(_reminderEmailStatusDialogScss);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('reminderStatus');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var ReminderEmailStatusDialog = (function (_React$Component) {
	    _inherits(ReminderEmailStatusDialog, _React$Component);
	
	    _createClass(ReminderEmailStatusDialog, null, [{
	        key: 'propTypes',
	        value: {
	            isOpen: _reactLibReact.PropTypes.bool.isRequired,
	            success: _reactLibReact.PropTypes.bool.isRequired,
	            invitationBlocked: _reactLibReact.PropTypes.bool.isRequired,
	            closeModal: _reactLibReact.PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    function ReminderEmailStatusDialog(props) {
	        _classCallCheck(this, ReminderEmailStatusDialog);
	
	        _get(Object.getPrototypeOf(ReminderEmailStatusDialog.prototype), 'constructor', this).call(this, props);
	        this.state = {};
	    }
	
	    /**
	    *  This function render the success / fail modal for manual reminder email sender.
	    */
	
	    _createClass(ReminderEmailStatusDialog, [{
	        key: 'reminderConfirmationModalContent',
	        value: function reminderConfirmationModalContent() {
	            var _props = this.props;
	            var closeModal = _props.closeModal;
	            var success = _props.success;
	            var invitationBlocked = _props.invitationBlocked;
	
	            return _reactLibReact2['default'].createElement(
	                'div',
	                { className: _reminderEmailStatusDialogScss2['default'].modalContent },
	                _reactLibReact2['default'].createElement(
	                    'span',
	                    { className: _reminderEmailStatusDialogScss2['default'].title },
	                    _('reminderConfirmationModalTitle')
	                ),
	                _reactLibReact2['default'].createElement(
	                    'span',
	                    { className: _reminderEmailStatusDialogScss2['default'].message },
	                    invitationBlocked ? _("invitationEmailBlockMessage") : success ? _("reminderConfirmationModalSuccess") : _("reminderConfirmationModalFail")
	                ),
	                _reactLibReact2['default'].createElement(
	                    'div',
	                    { className: _reminderEmailStatusDialogScss2['default'].modalButtons },
	                    _reactLibReact2['default'].createElement(
	                        'div',
	                        { className: _reminderEmailStatusDialogScss2['default'].greyButton + " enabled",
	                            onClick: function () {
	                                return closeModal();
	                            }
	                        },
	                        _('ok')
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isOpen = this.props.isOpen;
	
	            return _reactLibReact2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: isOpen,
	                    style: customStyles,
	                    key: "reminderConfirmationModalKey",
	                    contentLabel: ""
	                },
	                this.reminderConfirmationModalContent()
	            );
	        }
	    }]);
	
	    return ReminderEmailStatusDialog;
	})(_reactLibReact2['default'].Component);
	
	exports['default'] = ReminderEmailStatusDialog;
	module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(57);
	
	var _clientProfileFormScss = __webpack_require__(1601);
	
	var _clientProfileFormScss2 = _interopRequireDefault(_clientProfileFormScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _libHelpers = __webpack_require__(24);
	
	var _clientProfileFormResults = __webpack_require__(1086);
	
	var _clientProfileFormResults2 = _interopRequireDefault(_clientProfileFormResults);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libValidator = __webpack_require__(96);
	
	/**
	 * Import actions to help the state control
	 */
	
	var _stateActions = __webpack_require__(5);
	
	/**
	 * Components to implement layout
	 */
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _input = __webpack_require__(109);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _emailListSelect = __webpack_require__(1096);
	
	var _emailListSelect2 = _interopRequireDefault(_emailListSelect);
	
	var _licensesListSelect = __webpack_require__(1107);
	
	var _licensesListSelect2 = _interopRequireDefault(_licensesListSelect);
	
	var _ibansListSelect = __webpack_require__(1102);
	
	var _ibansListSelect2 = _interopRequireDefault(_ibansListSelect);
	
	var _phoneListSelect = __webpack_require__(1139);
	
	var _phoneListSelect2 = _interopRequireDefault(_phoneListSelect);
	
	var _relationListSelect = __webpack_require__(1141);
	
	var _relationListSelect2 = _interopRequireDefault(_relationListSelect);
	
	var _clientAddressList = __webpack_require__(1079);
	
	var _clientAddressList2 = _interopRequireDefault(_clientAddressList);
	
	//import BirthPlaceAddressList from '../birthPlaceAddressList'
	/**
	 * Helper functions to handle data
	 */
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	// Set the translation category
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        zIndex: 2
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'visible',
	        padding: '0em'
	    }
	};var _ = (0, _libI18n2['default'])('clients');
	var lodash = lodash;
	
	var generateUUIdForLists = function generateUUIdForLists(listForUuid) {
	    if (listForUuid && listForUuid.length && listForUuid.length > 0) {
	        listForUuid.map(function (entityValue, entityIndex) {
	            listForUuid[entityIndex]['uniqueId'] = (0, _uuidV42['default'])();
	        });
	    }
	
	    return listForUuid;
	};
	
	/**
	 * Generate field implements a field generator wrapper just to add field error
	 *
	 * @param React Component
	 * @param React field data
	 *
	 * @return HTML Component
	 */
	var generateField = function generateField(component, field) {
	    return _react2['default'].createElement(
	        'div',
	        null,
	        component,
	        field.error && field.touched && _react2['default'].createElement(
	            'div',
	            { className: _clientProfileFormScss2['default'].error },
	            ' ',
	            field.error,
	            ' '
	        )
	    );
	};
	
	var normalizeData = function normalizeData(clientData, appLanguage, clientOptionsDict) {
	    // Normalize person type
	    if (clientData && clientData.main.clientType && clientData.main.clientType != undefined) {
	        clientOptionsDict.personType.map(function (item) {
	            if (clientData.main.clientType == item.label) {
	                clientData.main.clientType = item.value;
	            }
	        });
	    }
	
	    // get the client data legalForm value. Attention, sometimes that has no exact match, must be compared lowercased
	    var clientLegalForm = _nestedProperty2['default'].get(clientData, "main.legalForm");
	    var clientLegalFormId = _nestedProperty2['default'].get(clientData, "main.legalFormId");
	
	    if (clientLegalForm && clientOptionsDict.legalForm) {
	        clientOptionsDict.legalForm.map(function (item) {
	            if (String(clientLegalForm).toUpperCase() == String(item.label).toUpperCase()) {
	                clientData.main.legalForm = item.label;
	                clientData.main.legalFormId = item.value;
	            }
	        });
	    }
	
	    // Normalize gender
	    if (clientData && clientData.detail.gender && clientData.detail.gender != undefined) {
	        clientOptionsDict.gender.map(function (item) {
	            if (clientData.detail.gender == item.label.substring(0, 1)) {
	                clientData.detail.gender = item.value;
	            }
	        });
	    }
	
	    // Normalize nationality
	    if (clientData && clientData.detail.nationality && clientData.detail.nationality != undefined) {
	        clientOptionsDict.nationality.map(function (item) {
	            if (clientData.detail.nationality == item.label) {
	                clientData.detail.nationality = item.value;
	            }
	        });
	    }
	
	    // Normalize title
	    if (clientData && clientData.detail.title && clientData.detail.title != undefined) {
	        clientOptionsDict.title.map(function (item) {
	            if (clientData.detail.title == item.label) {
	                clientData.detail.title = item.value;
	            }
	        });
	    }
	
	    // Normalize birthCountry
	    if (clientData && clientData.detail.birthCountry && clientData.detail.birthCountry != undefined) {
	        clientOptionsDict.birthCountry.map(function (item) {
	            if (clientData.detail.birthCountry == item.label) {
	                clientData.detail.birthCountry = item.value;
	            }
	        });
	    }
	
	    // Normalize maritalStatus
	    if (clientData && clientData.detail.maritalStatus && clientData.detail.maritalStatus != undefined) {
	        clientOptionsDict.maritalStatus.map(function (item) {
	            if (clientData.detail.maritalStatus == item.label) {
	                clientData.detail.maritalStatus = item.value;
	            }
	        });
	    }
	
	    // Normalize ppp
	
	    if (clientData && clientData.detail.ppp && clientData.detail.ppp != undefined) {
	        clientOptionsDict.ppp.map(function (item) {
	            if (clientData.detail.ppp == item.label) {
	                clientData.detail.ppp = item.value;
	            }
	        });
	    }
	
	    // Normalize profession
	    if (clientData && clientData.detail.profession && clientData.detail.profession != undefined) {
	        clientOptionsDict.profession.map(function (item) {
	            if (clientData.detail.profession == item.label) {
	                clientData.detail.profession = item.value;
	            }
	        });
	    }
	
	    // Normalize activSector
	    if (clientData && clientData.detail.activSector && clientData.detail.activSector != undefined) {
	        clientOptionsDict.activSector.map(function (item) {
	            if (clientData.detail.activSector == item.label) {
	                clientData.detail.activSector = item.value;
	            }
	        });
	    }
	
	    // Normalize socialStatus
	    if (clientData && clientData.detail.socialStatus && clientData.detail.socialStatus != undefined) {
	        clientOptionsDict.socialStatus.map(function (item) {
	            if (clientData.detail.socialStatus == item.label) {
	                clientData.detail.socialStatus = item.value;
	            }
	        });
	    }
	
	    // Normalize taxStatus
	    if (clientData && clientData.detail.taxStatus && clientData.detail.taxStatus != undefined) {
	        clientOptionsDict.taxStatus.map(function (item) {
	            if (clientData.detail.taxStatus == item.label) {
	                clientData.detail.taxStatus = item.value;
	            }
	        });
	    }
	
	    // Normalize language
	    if (clientData && clientData.detail.language && clientData.detail.language != undefined) {
	        clientOptionsDict.language.map(function (item) {
	            if (clientData.detail.language == item.label) {
	                clientData.detail.language = item.value;
	            }
	        });
	    }
	
	    // Normalize email default
	    if (clientData && clientData.detail && clientData.detail.emails) {
	        clientData.detail.emails = clientData.detail.emails.map(function (item) {
	
	            if (item != undefined) {
	                var emailIsDefault = item['default'];
	                if (!_underscore2['default'].isBoolean(emailIsDefault)) {
	                    emailIsDefault = item['default'] === "true" || item['default'] == true ? true : false;
	                }
	
	                var itemFormated = {
	                    'default': emailIsDefault,
	                    email: item.email
	                };
	
	                return itemFormated;
	            } else {
	                return item;
	            }
	        });
	    }
	
	    // normalize phone numbers default && mobile
	    if (clientData && clientData.detail && clientData.detail.phoneNumbers) {
	        clientData.detail.phoneNumbers = clientData.detail.phoneNumbers.map(function (item) {
	            var itemFormated = {
	                'default': item['default'] === "true" || item['default'] === true ? true : false,
	                number: item.number,
	                mobile: item.mobile === "true" || item.mobile === true ? true : false
	            };
	
	            return itemFormated;
	        });
	    }
	
	    // normalize main address
	    if (clientData && clientData.main && clientData.main.mainAddress) {
	        clientData.main.mainAddress.zipCity = clientData.main.mainAddress.postalCode + '_' + clientData.main.mainAddress.locality;
	
	        if (clientData.main.mainAddress.country != undefined) {
	            clientOptionsDict.country.map(function (index) {
	                if (clientData.main.mainAddress.country == index.label) {
	                    clientData.main.mainAddress.country = index.value;
	                }
	            });
	
	            if (typeof clientData.main.mainAddress.country == 'string') {
	                clientOptionsDict.globalCountry.map(function (index) {
	                    if (index.label['en'] == clientData.main.mainAddress.country) {
	                        clientData.main.mainAddress.country = index.value;
	                    } else if (index.label['fr'] == clientData.main.mainAddress.country) {
	                        clientData.main.mainAddress.country = index.value;
	                    } else if (index.label['nl'] == clientData.main.mainAddress.country) {
	                        clientData.main.mainAddress.country = index.value;
	                    }
	                });
	            }
	        }
	    }
	
	    // normalize correspondance address
	    if (clientData && clientData.detail && clientData.detail.correspondanceAddress) {
	        clientData.detail.correspondanceAddress.zipCity = clientData.detail.correspondanceAddress.postalCode + '_' + clientData.detail.correspondanceAddress.locality;
	
	        if (clientData.detail.correspondanceAddress.country != undefined) {
	            clientOptionsDict.country.map(function (index) {
	                if (clientData.detail.correspondanceAddress.country == index.label) {
	                    clientData.detail.correspondanceAddress.country = index.value;
	                }
	            });
	
	            if (typeof clientData.detail.correspondanceAddress.country == 'string') {
	                clientOptionsDict.globalCountry.map(function (index) {
	                    if (index.label['en'] == clientData.detail.correspondanceAddress.country) {
	                        clientData.detail.correspondanceAddress.country = index.value;
	                    } else if (index.label['fr'] == clientData.detail.correspondanceAddress.country) {
	                        clientData.detail.correspondanceAddress.country = index.value;
	                    } else if (index.label['nl'] == clientData.detail.correspondanceAddress.country) {
	                        clientData.detail.correspondanceAddress.country = index.value;
	                    }
	                });
	            }
	        }
	    }
	
	    // normalize relations data
	    if (clientData && clientData.detail && clientData.detail.contacts) {
	        clientData.detail.contacts = clientData.detail.contacts.map(function (item) {
	            var itemFormated = {
	                contactName: item.contactName,
	                contactNumber: item.contactNumber,
	                contactdateOfBirth: item.contactdateOfBirth,
	                contactgender: item.contactgender,
	                contactType: item.contactType
	            };
	
	            clientOptionsDict.gender.map(function (index3) {
	                if (item.contactgender == index3.label.substring(0, 1)) {
	                    itemFormated['contactgender'] = index3.value;
	                }
	            });
	
	            clientOptionsDict.relationType.map(function (index2) {
	                if (itemFormated.contactType == index2.label) {
	                    itemFormated['contactType'] = index2.value;
	                }
	            });
	
	            itemFormated['contactFirstName'] = item.contactFirstName;
	            itemFormated['contactLastName'] = item.contactName;
	
	            return itemFormated;
	        });
	    }
	
	    return clientData;
	};
	
	/**
	 * Implement validate function to handle the form inputs
	 */
	var validate = function validate(values) {
	    var errors = undefined;
	    errors = {
	        detail: {
	            emails: [],
	            licences: [],
	            phoneNumbers: [],
	            accountNumbers: [],
	            contacts: [],
	            correspondanceAddress: {}
	        },
	        main: {
	            mainAddress: {}
	        }
	    };
	
	    // Set the validation type
	    var validationType = Number(values.main.clientType) == 1 ? 'pr' : 'cp';
	
	    /**
	     * Custom validations for person type
	     */
	    if (validationType == 'pr') {
	        if (values.main.lastName == '' || values.main.lastName == undefined) {
	            errors.main.lastName = _('requiredField');
	        }
	
	        if (values.main.lastName != undefined && values.main.lastName.length > 50) {
	            errors.main.lastName = _('maxLength50');
	        }
	
	        if (values.main.firstName != undefined && values.main.firstName.length > 50) {
	            errors.main.firstName = _('maxLength50');
	        }
	
	        if (values.main.firstName == '' || values.main.firstName == undefined) {
	            errors.main.firstName = _('requiredField');
	        }
	
	        if (values.detail.title == '' || values.detail.title == undefined) {
	            errors.detail.title = _('requiredField');
	        }
	
	        if (values.detail.language == '' || values.detail.language == undefined) {
	            errors.detail.language = _('requiredField');
	        }
	
	        if (values.detail.nationality == '' || values.detail.nationality == undefined) {
	            errors.detail.nationality = _('requiredField');
	        }
	
	        if (values.detail.gender == '' || values.detail.gender == undefined) {
	            errors.detail.gender = _('requiredField');
	        }
	
	        if (values.detail.birthCountry && values.detail.birthCountry === '1') {
	            if (values.detail.birthPostalCode == '' || values.detail.birthPostalCode == undefined) {
	                errors.detail.birthPostalCode = _('requiredField');
	            }
	
	            if (values.detail.birthLocality == '' || values.detail.birthLocality == undefined) {
	                errors.detail.birthLocality = _('requiredField');
	            }
	        }
	    }
	
	    if (validationType == 'cp') {
	        if (values.main.lastName == '' || values.main.lastName == undefined) {
	            errors.main.lastName = _('requiredField');
	        }
	
	        if (values.main.legalForm == '' || values.main.legalForm == undefined) {
	            errors.main.legalForm = _('requiredField');
	        }
	
	        if (values.detail.language == '' || values.detail.language == undefined) {
	            errors.detail.language = _('requiredField');
	        }
	    }
	
	    if (values.main.mainAddress.country == '' || values.main.mainAddress == undefined) {
	        errors.main.mainAddress.country = _('requiredField');
	    }
	
	    if (values.main.mainAddress.street == '' || values.main.mainAddress.street == undefined) {
	        errors.main.mainAddress.street = _('requiredField');
	    }
	
	    /** REMOVED AS REQUESTED BY WILLEMOT
	    if(values.main.mainAddress.street != undefined && values.main.mainAddress.street.length > 50)
	    {
	        errors.main.mainAddress.street = _('maxLength50')
	    }*/
	
	    if (values.main.mainAddress.number == '' || values.main.mainAddress.number == undefined) {
	        errors.main.mainAddress.number = _('requiredField');
	    }
	    if (values.main.mainAddress.number != undefined && values.main.mainAddress.number.length > 10) {
	        errors.main.mainAddress.number = _('maxLength10');
	    }
	
	    if (values.main.mainAddress.extension != undefined && values.main.mainAddress.extension.length > 10) {
	        errors.main.mainAddress.extension = _('maxLength10');
	    }
	
	    if (values.main.mainAddress.country == 1) {
	        if (values.main.mainAddress.zipCity == '' || values.main.mainAddress.zipCity == undefined) {
	            errors.main.mainAddress.zipCity = _('requiredField');
	        }
	    } else {
	        if (values.main.mainAddress.postalCode == '' || values.main.mainAddress.postalCode == undefined) {
	            errors.main.mainAddress.postalCode = _('requiredField');
	        }
	
	        if (values.main.mainAddress.locality == '' || values.main.mainAddress.locality == undefined) {
	            errors.main.mainAddress.locality = _('requiredField');
	        }
	    }
	
	    if (values.main.companyRegistrationNumber != undefined && values.main.companyRegistrationNumber.length > 20) {
	        errors.main.companyRegistrationNumber = _('maxLength10');
	    }
	
	    /**
	     * Update correspondanceAddress validation based on Brecht request
	     * Now validate all fields if one of the data is not empty
	     */
	    if (values.detail.correspondanceAddress != undefined) {
	        var emptyFields = true;
	
	        // Check if there is any populated field
	        Object.keys(values.detail.correspondanceAddress).forEach(function (key) {
	            var correspondanceField = values.detail.correspondanceAddress[key];
	
	            if (key == 'zipCity') {
	                if (Number(values.detail.correspondanceAddress.country) == 1) {
	                    if (correspondanceField != "" && correspondanceField != undefined && correspondanceField != "_") {
	                        emptyFields = false;
	                    }
	                }
	            } else {
	                if (correspondanceField != "" && correspondanceField != undefined) {
	                    emptyFields = false;
	                }
	            }
	        });
	
	        // Validate every required field if one field is empty
	        if (emptyFields == false) {
	            if (values.detail.correspondanceAddress.country == '' || values.detail.correspondanceAddress.country == undefined) {
	                errors.detail.correspondanceAddress.country = _('requiredField');
	            }
	
	            if (values.detail.correspondanceAddress.street == '' || values.detail.correspondanceAddress.street == undefined) {
	                errors.detail.correspondanceAddress.street = _('requiredField');
	            }
	
	            if (values.detail.correspondanceAddress.number == '' || values.detail.correspondanceAddress.number == undefined) {
	                errors.detail.correspondanceAddress.number = _('requiredField');
	            }
	            if (values.detail.correspondanceAddress.number != undefined && values.detail.correspondanceAddress.number.length > 10) {
	                errors.detail.correspondanceAddress.number = _('maxLength10');
	            }
	
	            if (values.detail.correspondanceAddress.extension != undefined && values.detail.correspondanceAddress.extension.length > 10) {
	                errors.detail.correspondanceAddress.extension = _('maxLength10');
	            }
	
	            if (values.detail.correspondanceAddress.country == 1) {
	                if (values.detail.correspondanceAddress.zipCity == '' || values.detail.correspondanceAddress.zipCity == undefined || values.detail.correspondanceAddress.zipCity == "_") {
	                    errors.detail.correspondanceAddress.zipCity = _('requiredField');
	                }
	            } else {
	                if (values.detail.correspondanceAddress.postalCode == '' || values.detail.correspondanceAddress.postalCode == undefined) {
	                    errors.detail.correspondanceAddress.postalCode = _('requiredField');
	                }
	
	                if (values.detail.correspondanceAddress.locality == '' || values.detail.correspondanceAddress.locality == undefined) {
	                    errors.detail.correspondanceAddress.locality = _('requiredField');
	                }
	            }
	        }
	    }
	
	    // Validate companyRegistrationNumber as Brecht requested V3
	    if (values.main.companyRegistrationNumber && values.main.companyRegistrationNumber != undefined && values.main.companyRegistrationNumber != "") {
	        var invalidCRN = true;
	
	        /**
	         * Check regex for companyRegistrationNumber
	         * Test for: (BE) + (4 numbers) . ( 3 numbers) . ( 3 numbers)
	         * Regex code ^(BE)+(\d{4}).(\d{3}).(\d{3})$
	         */
	        if (/^(BE)+(\d{4}).(\d{3}).(\d{3})$/i.test(values.main.companyRegistrationNumber)) {
	            invalidCRN = false;
	        }
	
	        /**
	         * Check regex for companyRegistrationNumber
	         * Test for: (4 numbers) . ( 3 numbers) . ( 3 numbers)
	         * Regex code ^(\d{4}).(\d{3}).(\d{3})$
	         */
	        if (/^(\d{4}).(\d{3}).(\d{3})$/i.test(values.main.companyRegistrationNumber)) {
	            invalidCRN = false;
	        }
	
	        /**
	         * Check regex for companyRegistrationNumber
	         * Test for: (3 numbers) . ( 3 numbers) . ( 3 numbers)
	         * Regex code ^(\d{3}).(\d{3}).(\d{3})$
	         */
	        if (/^(\d{3}).(\d{3}).(\d{3})$/i.test(values.main.companyRegistrationNumber)) {
	            invalidCRN = false;
	        }
	
	        /**
	         * Check regex for companyRegistrationNumber
	         * Test for: (BE) + ( 10 numbers)
	         * Regex code ^(BE)+(\d{10})$
	         */
	        if (/^(BE)+(\d{10})$/i.test(values.main.companyRegistrationNumber)) {
	            invalidCRN = false;
	        }
	
	        /**
	         * Check regex for companyRegistrationNumber
	         * Test for: ( 10 numbers)
	         * Regex code ^(\d{10})$
	         */
	        if (/^(\d{10})$/i.test(values.main.companyRegistrationNumber)) {
	            invalidCRN = false;
	        }
	
	        /**
	         * Check regex for companyRegistrationNumber
	         * Test for: ( 10 numbers)
	         * Regex code ^(\d{10})$
	         */
	        if (/^(\d{9})$/i.test(values.main.companyRegistrationNumber)) {
	            invalidCRN = false;
	        }
	
	        if (invalidCRN == true) {
	            errors.main.companyRegistrationNumber = _('invalidCompanyRegistrationNumber');
	        }
	    }
	
	    /**
	     * Validate email address data
	     */
	    if (values.detail.emails.length > 0) {
	        values.detail.emails.map(function (key, index) {
	            //here
	            if (!(0, _libValidator.isAnEmail)(key.email)) {
	                if (errors.detail.emails[index] == undefined) {
	                    errors.detail.emails[index] = {
	                        email: _('invalidEmail')
	                    };
	                } else {
	                    errors.detail.emails[index]['email'] = _('invalidEmail');
	                }
	            }
	
	            if (key.email.length > 200) {
	                if (errors.detail.emails[index] == undefined) {
	                    errors.detail.emails[index] = {
	                        email: _('maxLength200')
	                    };
	                } else {
	                    errors.detail.emails[index]['email'] = _('maxLength200');
	                }
	            }
	        });
	    }
	
	    /**
	     * Validate phone numbers data
	     */
	    if (values.detail.phoneNumbers.length > 0) {
	        values.detail.phoneNumbers.map(function (key, index) {
	            if (key.number == undefined || key.number == '') {
	                if (errors.detail.phoneNumbers[index] == undefined) {
	                    errors.detail.phoneNumbers[index] = {
	                        number: _('requiredField')
	                    };
	                } else {
	                    errors.detail.phoneNumbers[index]['number'] = _('requiredField');
	                }
	            }
	
	            if (key.number != undefined && key.number.length > 20) {
	                if (errors.detail.phoneNumbers[index] == undefined) {
	                    errors.detail.phoneNumbers[index] = {
	                        number: _('maxLength20')
	                    };
	                } else {
	                    errors.detail.phoneNumbers[index]['number'] = _('maxLength20');
	                }
	            }
	
	            /**
	             * Add validation for phone numbers if the input value is just numeric
	             */
	            if (key.number != undefined && key.number.length > 0) {
	                if (!/^\d+$/i.test(key.number)) {
	                    if (errors.detail.phoneNumbers[index] == undefined) {
	                        errors.detail.phoneNumbers[index] = {
	                            number: _('justNumbers')
	                        };
	                    } else {
	                        errors.detail.phoneNumbers[index]['number'] = _('justNumbers');
	                    }
	                }
	            }
	        });
	    }
	
	    /**
	     * Validate account numbers
	     */
	    if (values.detail.accountNumbers.length > 0) {
	        values.detail.accountNumbers.map(function (key, index) {
	
	            if (key.IBAN == undefined || key.IBAN == '') {
	                if (errors.detail.accountNumbers[index] == undefined) {
	                    errors.detail.accountNumbers[index] = {
	                        IBAN: _('requiredField')
	                    };
	                } else {
	                    errors.detail.accountNumbers[index]['IBAN'] = _('requiredField');
	                }
	            }
	
	            if (key.IBAN != undefined && key.IBAN.length > 20) {
	                if (errors.detail.accountNumbers[index] == undefined) {
	                    errors.detail.accountNumbers[index] = {
	                        IBAN: _('maxLength20')
	                    };
	                } else {
	                    errors.detail.accountNumbers[index]['IBAN'] = _('maxLength20');
	                }
	            }
	        });
	    }
	
	    /**
	     * Validate licences
	     * Remove as Brecht requested
	     */
	    /**if(values.detail.licences.length > 0)
	    {
	        values.detail.licences.map((key, index) => {
	              if(key.licenceDate == undefined || key.licenceDate == '')
	            {
	                if(errors.detail.licences[index] == undefined)
	                {
	                    errors.detail.licences[index] = {
	                        licenceDate: _('requiredField')
	                    }
	                }
	                else
	                {
	                    errors.detail.licences[index]['licenceDate'] = _('requiredField')
	                }
	            }
	        })
	    } **/
	
	    /**
	     * Validate contacts
	     */
	    if (values.detail.contacts.length > 0) {
	        values.detail.contacts.map(function (key, index) {
	            if (key.contactLastName == '' || key.contactLastName == undefined) {
	                if (errors.detail.contacts[index] == undefined) {
	                    errors.detail.contacts[index] = {
	                        contactLastName: _('requiredField')
	                    };
	                } else {
	                    errors.detail.contacts[index]['contactLastName'] = _('requiredField');
	                }
	            }
	
	            if (key.contactLastName != undefined && key.contactLastName.length > 50) {
	                if (errors.detail.contacts[index] == undefined) {
	                    errors.detail.contacts[index] = {
	                        contactLastName: _('maxLength50')
	                    };
	                } else {
	                    errors.detail.contacts[index]['contactLastName'] = _('maxLength50');
	                }
	            }
	
	            if (key.contactFirstName != undefined && key.contactFirstName.length > 50) {
	                if (errors.detail.contacts[index] == undefined) {
	                    errors.detail.contacts[index] = {
	                        contactFirstName: _('maxLength50')
	                    };
	                } else {
	                    errors.detail.contacts[index]['contactFirstName'] = _('maxLength50');
	                }
	            }
	
	            if (key.contactType == '' || key.contactType == undefined) {
	                if (errors.detail.contacts[index] == undefined) {
	                    errors.detail.contacts[index] = {
	                        contactType: _('requiredField')
	                    };
	                } else {
	                    errors.detail.contacts[index]['contactType'] = _('requiredField');
	                }
	            }
	        });
	    }
	
	    return errors;
	};
	
	/**
	 * Create connect to get requested states and actions
	 */
	
	/**
	 * Creates the edit profile component
	 */
	
	var ClientProfileForm = (function (_Component) {
	    _inherits(ClientProfileForm, _Component);
	
	    _createClass(ClientProfileForm, null, [{
	        key: 'propTypes',
	        value: {
	            fields: _react2['default'].PropTypes.object.isRequired,
	            handleSubmit: _react2['default'].PropTypes.func.isRequired,
	            clientOptionsDict: _react2['default'].PropTypes.array
	        },
	        enumerable: true
	    }]);
	
	    function ClientProfileForm(props) {
	        var _this = this;
	
	        _classCallCheck(this, _ClientProfileForm);
	
	        _get(Object.getPrototypeOf(_ClientProfileForm.prototype), 'constructor', this).call(this, props);
	
	        this.toggleShowFullProfessionList = function (value) {
	            if (value === 'see_more_results') {
	                _this.setState({ showProfessionFullList: true });
	            } else if (value === 'see_less_results') {
	                _this.setState({ showProfessionFullList: false });
	            }
	        };
	
	        this.handleSubmit = this.handleSubmit.bind(this);
	        this.zoomTo = this.zoomTo.bind(this);
	        this.state = {
	            modalIsOpen: false,
	            clientDictionary: [],
	            errorReportSent: false,
	            showProfessionFullList: false,
	            showActivSectorFullList: false
	        };
	    }
	
	    _createClass(ClientProfileForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var clientOptionsDict = _props.clientOptionsDict;
	
	            if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
	                dispatch((0, _stateActions.fetchClientOptionsDict)()).then(function (dictionary) {
	                    _this2.setClientOptionsDict(dictionary);
	                });
	            } else {
	                if (!this.state.clientDictionary) {
	                    this.setClientOptionsDict(clientOptionsDict);
	                }
	            }
	
	            dispatch((0, _stateActions.clientProfileFormSentToFalse)());
	        }
	    }, {
	        key: 'onBirthCoutryChangeHandler',
	        value: function onBirthCoutryChangeHandler(e) {
	            var _props2 = this.props;
	            var dispatch = _props2.dispatch;
	            var fields = _props2.fields;
	
	            var birthCountryInitialValues = fields.detail.birthCountry.initialValue;
	            var birthLocalityInitialValues = fields.detail.birthLocality.initialValue || '';
	            var birthPostalCodeInitialValues = fields.detail.birthPostalCode.initialValue || '';
	            var birthZipCityInitialValues = fields.detail.birthZipCity.initialValue;
	
	            if (e.value === birthCountryInitialValues) {
	
	                dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthCountry", e.value));
	                dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthLocality", birthLocalityInitialValues));
	                dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthPostalCode", birthPostalCodeInitialValues));
	                dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthZipCity", birthZipCityInitialValues));
	            } else {
	                dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthCountry", e.value));
	                dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthLocality", ''));
	                dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthPostalCode", ''));
	                dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthZipCity", ''));
	            }
	        }
	    }, {
	        key: 'onBirthZipCityChangeHandler',
	        value: function onBirthZipCityChangeHandler(e) {
	            var dispatch = this.props.dispatch;
	
	            var split = e.value.split('&');
	            dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthPostalCode", split[0]));
	            dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthLocality", split[1]));
	            dispatch((0, _reduxForm.change)("clientProfileEdit", "detail.birthZipCity", e.value));
	        }
	
	        /**
	         * Set client options dict in to the state
	         * @param {object} dictionary - contains the dictionary
	         */
	    }, {
	        key: 'setClientOptionsDict',
	        value: function setClientOptionsDict(dictionary) {
	            var appLanguage = this.props.appLanguage;
	
	            this.setState({ clientDictionary: (0, _libHelpers.generateClientDicts)(dictionary, appLanguage) });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var _props3 = this.props;
	            var dispatch = _props3.dispatch;
	            var cleanProfileFormCheckbox = _props3.cleanProfileFormCheckbox;
	
	            // need to clean da form data to -- i think soo
	            dispatch(cleanProfileFormCheckbox());
	            dispatch((0, _stateActions.cleanClientProfileForm)());
	            dispatch((0, _stateActions.clientProfileFormSentToFalse)());
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            var _props4 = this.props;
	            var dispatch = _props4.dispatch;
	            var errorReport = _props4.errorReport;
	            var errorReportSent = this.state.errorReportSent;
	
	            if (!errorReportSent && errorReport) {
	                dispatch((0, _stateActions.reportError)(errorReport)).then(function (res) {
	                    _this3.setState({ errorReportSent: true });
	                })['catch'](function (err) {
	                    return console.warn(err);
	                });
	            }
	        }
	
	        /**
	         * Trim whitespaces by walkin trought the hole object values.
	         * @param {*} obj
	         * @returns
	         */
	    }, {
	        key: 'trimWhitespaceForValueProps',
	        value: function trimWhitespaceForValueProps(obj) {
	            var keyName = arguments.length <= 1 || arguments[1] === undefined ? "" : arguments[1];
	
	            // when we the object is a end of the object tree and the key is "value" (the form elements value prorp)
	            // only on that caset to TRIM the string, in test we don't touch nothing.
	            if (typeof obj === 'string' && keyName === 'value') {
	                return obj.trim();
	            } else if (typeof obj === 'object' && obj !== null) {
	                for (var key in obj) {
	                    if (obj.hasOwnProperty(key)) {
	                        // go deeper
	                        obj[key] = this.trimWhitespaceForValueProps(obj[key], key);
	                    }
	                }
	                return obj;
	            } else {
	                return obj;
	            }
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            e.preventDefault();
	            var _props5 = this.props;
	            var dispatch = _props5.dispatch;
	            var clientId = _props5.clientId;
	            var appLanguage = _props5.appLanguage;
	            var formType = _props5.formType;
	            var invalid = _props5.invalid;
	            var fields = _props5.fields;
	            var changeListDefaultError = _props5.changeListDefaultError;
	            var b2bCompanyCompany = _props5.b2bCompanyCompany;
	
	            var isDefaultEmail = false;
	            var isSetDefaultPhone = false;
	
	            if (fields.detail.emails.length > 0) {
	                fields.detail.emails.map(function (key, index) {
	                    if (key['default'].checked == true) {
	                        isDefaultEmail = true;
	                    }
	                });
	            } else {
	                isDefaultEmail = true;
	            }
	
	            if (fields.detail.phoneNumbers.length > 0) {
	                fields.detail.phoneNumbers.map(function (onePhoneNumber, index) {
	                    if (onePhoneNumber['default'].checked == true) {
	                        isSetDefaultPhone = true;
	                    }
	                });
	            } else {
	                isSetDefaultPhone = true;
	            }
	
	            dispatch(changeListDefaultError('email', !isDefaultEmail));
	            dispatch(changeListDefaultError('phone', !isSetDefaultPhone));
	
	            var formData = JSON.parse(JSON.stringify(fields));
	
	            // legalForm translate to ID for oracle call
	            if (fields.main.clientType.value == 2) {
	                formData.main.legalForm.value = formData.main.legalFormId ? formData.main.legalFormId.value : formData.main.legalForm.value;
	
	                if (formData && formData.main && formData.main.legalFormId) {
	                    delete formData.main.legalFormId;
	                }
	            }
	
	            if (invalid == true || isDefaultEmail == false || isSetDefaultPhone == false) {
	                this.openNotificationModal();
	                this.props.touchAll();
	            } else {
	
	                formData = this.trimWhitespaceForValueProps(formData);
	
	                if (formType == 'edit') {
	                    dispatch((0, _stateActions.updateClientProfile)(formData, clientId, b2bCompanyCompany && b2bCompanyCompany.companyId || null));
	                } else {
	                    dispatch((0, _stateActions.createClientProfile)(formData));
	                }
	            }
	        }
	    }, {
	        key: 'zoomTo',
	        value: function zoomTo(clientNumber) {
	            var _props6 = this.props;
	            var dispatch = _props6.dispatch;
	            var setOpened = _props6.setOpened;
	            var setClientSubModule = _props6.setClientSubModule;
	            var setB2bCompanyOpened = _props6.setB2bCompanyOpened;
	            var setB2bCompanySubModule = _props6.setB2bCompanySubModule;
	
	            dispatch(setOpened(clientNumber));
	            dispatch(setClientSubModule('profile'));
	
	            dispatch(setB2bCompanyOpened(clientNumber));
	            dispatch(setB2bCompanySubModule('profile'));
	        }
	    }, {
	        key: 'loadClientData',
	        value: function loadClientData(clientId) {
	            var _props7 = this.props;
	            var dispatch = _props7.dispatch;
	            var fetchExistingClient = _props7.fetchExistingClient;
	
	            dispatch(fetchExistingClient(clientId));
	        }
	    }, {
	        key: 'handleFormChange',
	        value: function handleFormChange(event) {
	            var _props8 = this.props;
	            var dispatch = _props8.dispatch;
	            var fetchExistingClients = _props8.fetchExistingClients;
	            var _props8$fields = _props8.fields;
	            var main = _props8$fields.main;
	            var detail = _props8$fields.detail;
	
	            var clientQuery = {
	                name: '',
	                street: '',
	                postalCode: '',
	                dateOfBirth: '',
	                companyRegistrationNumber: '',
	                email: '',
	                phoneNumber: ''
	            };
	
	            var clientFirstName = '';
	            var clientLastName = '';
	            var streetAddress = '';
	            var streetNumber = '';
	            var streetBus = '';
	            var postalCode = '';
	            var dateOfBirth = '';
	            var companyRegistrationNumber = '';
	            var email = '';
	            var phoneNumber = '';
	
	            if (main.firstName && main.firstName.value && main.firstName.value != undefined) {
	                clientFirstName = main.firstName.value;
	            }
	
	            if (main.lastName && main.lastName.value && main.lastName.value != undefined) {
	                clientLastName = main.lastName.value;
	            }
	
	            if (main.mainAddress && main.mainAddress.street && main.mainAddress.street.value != undefined) {
	                streetAddress = main.mainAddress.street;
	            }
	
	            if (main.mainAddress && main.mainAddress.number && main.mainAddress.number.value != undefined) {
	                streetNumber = main.mainAddress.number;
	            }
	
	            if (main.mainAddress && main.mainAddress.extension && main.mainAddress.extension.value != undefined) {
	                streetBus = main.mainAddress.extension;
	            }
	
	            if (main.mainAddress && main.mainAddress.postalCode && main.mainAddress.postalCode.value != undefined) {
	                postalCode = main.mainAddress.postalCode;
	            }
	
	            if (main.dateOfBirth && main.dateOfBirth.value && main.dateOfBirth.value != undefined) {
	                dateOfBirth = main.dateOfBirth.value;
	            }
	
	            if (main.companyRegistrationNumber && main.companyRegistrationNumber.value && main.companyRegistrationNumber.value != undefined) {
	                companyRegistrationNumber = main.companyRegistrationNumber.value;
	            }
	
	            clientQuery['name'] = clientLastName + ' ' + clientFirstName;
	            clientQuery['street'] = streetAddress + ' ' + streetNumber + ' ' + streetBus;
	            clientQuery['postalCode'] = postalCode;
	            clientQuery['dateOfBirth'] = dateOfBirth;
	            clientQuery['companyRegistrationNumber'] = companyRegistrationNumber;
	            clientQuery['email'] = email;
	            clientQuery['phoneNumber'] = phoneNumber;
	
	            dispatch(fetchExistingClients(clientQuery));
	        }
	    }, {
	        key: 'makeOnBlur',
	        value: function makeOnBlur(field) {
	            var _this4 = this;
	
	            return function (event) {
	                field.onChange(event);
	                _this4.handleFormChange(event);
	            };
	        }
	    }, {
	        key: 'openNotificationModal',
	        value: function openNotificationModal() {
	            this.setState({ modalIsOpen: !this.state.modalIsOpen });
	        }
	
	        /**
	         * This function will handle toggle between showing partial list and full list of options for
	         * profession list when user clicks on show more option
	         * @param {*} value 
	         */
	    }, {
	        key: 'toggleShowFullActivSectorList',
	
	        /**
	         * This function will handle toggle between showing partial list and full list of options for 
	         * activ sector when user clicks on show more option
	         * @param {*} value 
	         */
	        value: function toggleShowFullActivSectorList(value) {
	            if (value === 'see_more_results') {
	                this.setState({ showActivSectorFullList: true });
	            } else if (value === 'see_less_results') {
	                this.setState({ showActivSectorFullList: false });
	            }
	        }
	
	        /**
	         * This functionality provides partial or full list for profession options
	         * The partial list is hardcoded for it is provided in BEWB - 804 
	         * @param {*} professionFullList 
	         * @returns 
	         */
	    }, {
	        key: 'getProfessionOptionsList',
	        value: function getProfessionOptionsList(professionFullList) {
	            var showProfessionFullList = this.state.showProfessionFullList;
	
	            // this a partial list provided by client in task BEWB-804
	            var hardcodedMinimalList = ['2', '3', '8', '1', '10', '11', '12', '7', '26', '9', '37', '6', '41', '23', '15'];
	            if (!showProfessionFullList) {
	                return professionFullList.filter(function (oneProfession) {
	                    return hardcodedMinimalList.some(function (e) {
	                        return e == oneProfession.value;
	                    });
	                });
	            }
	            return professionFullList;
	        }
	
	        /**
	        * This functionality provides partial or full list for sectors options
	        * The partial list is hardcoded for it is provided in BEWB - 804 
	        * @param {*} activSectorFullList 
	        * @returns 
	        */
	    }, {
	        key: 'getActivSectorOptionsList',
	        value: function getActivSectorOptionsList(activSectorFullList) {
	            var showActivSectorFullList = this.state.showActivSectorFullList;
	
	            var hardcodedMinimalList = ['80', '85', '91', '129', '51', '114', '45', '65', '72', '55', '40', '70', '128', '76', '126', '127', '92', '119', '52', '109', '66'];
	            // this a partial list provided by client in task BEWB-804
	            if (!showActivSectorFullList) {
	                return activSectorFullList.filter(function (oneProfession) {
	                    return hardcodedMinimalList.some(function (e) {
	                        return e == oneProfession.value;
	                    });
	                });
	            }
	            return activSectorFullList;
	        }
	
	        /**
	         * Implements the render function for the component
	         * Renders the component form data
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _props9 = this.props;
	            var _props9$fields = _props9.fields;
	            var main = _props9$fields.main;
	            var detail = _props9$fields.detail;
	            var selectedCheckboxes = _props9.selectedCheckboxes;
	            var dispatch = _props9.dispatch;
	            var formStatus = _props9.formStatus;
	            var setProfileFormCheckbox = _props9.setProfileFormCheckbox;
	            var data = _props9.data;
	            var formType = _props9.formType;
	            var existingClients = _props9.existingClients;
	            var modalStatus = _props9.modalStatus;
	            var clientId = _props9.clientId;
	            var setSubModule = _props9.setSubModule;
	            var formErrors = _props9.formErrors;
	            var canCreateOnlyLegalClient = _props9.canCreateOnlyLegalClient;
	            var canModifyOnlyLegalClient = _props9.canModifyOnlyLegalClient;
	            var clientOptionsDict = this.props.clientOptionsDict;
	            var _state = this.state;
	            var modalIsOpen = _state.modalIsOpen;
	            var clientDictionary = _state.clientDictionary;
	            var showProfessionFullList = _state.showProfessionFullList;
	            var showActivSectorFullList = _state.showActivSectorFullList;
	
	            if (clientDictionary != undefined && clientDictionary.length > 1) {
	                clientOptionsDict = clientDictionary;
	            }
	
	            var openModal = function openModal(e) {
	                e.preventDefault();
	            };
	
	            openModal = this.props.openModal;
	
	            var zoomTo = function zoomTo(clientNumber) {
	                _this5.zoomTo(clientNumber);
	            };
	
	            var loadClientData = function loadClientData(clientId) {
	                _this5.loadClientData(clientId);
	            };
	
	            var generalInformationColumns = [];
	
	            //if the form is type create, and the user has create rights only for legal client we need to force clientType to  "2" (Rechtspersoon)
	            if (formType == 'create' && canCreateOnlyLegalClient && +main.clientType.value == 1) {
	                dispatch((0, _reduxForm.change)('clientProfileEdit', 'main.clientType', '2'));
	            }
	            var professionOptions = this.getProfessionOptionsList(clientOptionsDict.profession);
	            if (showProfessionFullList) {
	                professionOptions.push({ value: 'see_less_results', label: _('showLessResults') });
	            } else {
	                professionOptions.push({ value: 'see_more_results', label: _('showMoreResults') });
	            }
	
	            var activSectorOptionsList = this.getActivSectorOptionsList(clientOptionsDict.activSector);
	            if (showActivSectorFullList) {
	                activSectorOptionsList.push({ value: 'see_less_results', label: _('showLessResults') });
	            } else {
	                activSectorOptionsList.push({ value: 'see_more_results', label: _('showMoreResults') });
	            }
	
	            /**
	             * If the form type is create then print other form elements
	             */
	            if (formType == 'create') {
	                if (main.clientType.value == 2) {
	                    generalInformationColumns = [[{ label: _('clientType') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({ isDisabled: canCreateOnlyLegalClient }, main.clientType, { options: clientOptionsDict.personType, isSearchable: true })), main.clientType) }, { label: _('lastName') + ' *', value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, main.lastName, { onBlur: this.makeOnBlur(main.lastName) })), main.lastName) }, { label: _('legalForm') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({
	                            isSearchable: true,
	                            onBlur: this.makeOnBlur(main.legalFormId)
	                        }, main.legalFormId, {
	                            options: clientOptionsDict.legalForm,
	                            onChange: function (newValue) {
	                                main.legalFormId.onChange(newValue.value);
	                                main.legalForm.onChange(newValue.label);
	                                main.legalFormId.value = newValue.value;
	                                main.legalForm.value = newValue.label;
	                                return newValue;
	                            }
	                        })), main.legalFormId)
	                    }, { label: _('nationality'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.nationality, { options: clientOptionsDict.nationality, isSearchable: true })), detail.nationality) }], [{ label: _('language') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.language, { options: clientOptionsDict.language, isSearchable: true })), detail.language) }, { label: _('companyRegistrationNumber'), value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, main.companyRegistrationNumber, { onBlur: this.makeOnBlur(main.companyRegistrationNumber) })), main.companyRegistrationNumber) }, { label: _('activSector'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.activSector, { options: clientOptionsDict.activSector, isSearchable: true })), detail.activSector) }, { label: _('taxStatus'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.taxStatus, { options: clientOptionsDict.taxStatus, isSearchable: true })), detail.taxStatus) }]];
	                } else {
	                    generalInformationColumns = [[{ label: _('clientType') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, main.clientType, { options: clientOptionsDict.personType, isSearchable: true })), main.clientType) }, { label: _('lastName') + ' *', value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, main.lastName, { onBlur: this.makeOnBlur(main.lastName) })), main.lastName) }, { label: _('firstName') + ' *', value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, main.firstName, { onBlur: this.makeOnBlur(main.firstName) })), main.firstName) }, { label: _('gender') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.gender, { options: clientOptionsDict.gender, isSearchable: true })), detail.gender) }, { label: _('nationalIdNumber'), value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, detail.nationalIdNumber, { onBlur: this.makeOnBlur(detail.nationalIdNumber) })), detail.nationalIdNumber) }, { label: _('nationality') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.nationality, { options: clientOptionsDict.nationality, isSearchable: true })), detail.nationality) }, { label: _('language') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.language, { options: clientOptionsDict.language, isSearchable: true })), detail.language) }, { label: _('ppp'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.ppp, { options: clientOptionsDict.ppp, isSearchable: true })), detail.ppp) }], [{ label: _('dateOfBirth'), value: generateField(_react2['default'].createElement(_componentsSharedDatePicker.DatePicker, _extends({}, main.dateOfBirth, { onBlur: this.makeOnBlur(main.dateOfBirth) })), main.dateOfBirth) }, { label: _('birthCountry'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.birthCountry, { options: clientOptionsDict.birthCountry, isSearchable: true })), detail.birthCountry) }, { label: _('maritalStatus'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.maritalStatus, { options: clientOptionsDict.maritalStatus, isSearchable: true })), detail.maritalStatus) }, { label: _('clientTitle') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.title, { options: clientOptionsDict.title, isSearchable: true })), detail.title) }, { label: _('companyRegistrationNumber'), value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, main.companyRegistrationNumber, { onBlur: this.makeOnBlur(main.companyRegistrationNumber) })), main.companyRegistrationNumber) }, { label: _('profession'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableDynamicListSelectWrapper, _extends({}, detail.profession, { toggleShowFullList: this.toggleShowFullProfessionList.bind(this), options: professionOptions, isSearchable: true })), detail.profession) }, { label: _('activSector'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableDynamicListSelectWrapper, _extends({}, detail.activSector, { toggleShowFullList: this.toggleShowFullActivSectorList.bind(this), options: activSectorOptionsList, isSearchable: true })), detail.activSector) }, { label: _('socialStatus'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.socialStatus, { options: clientOptionsDict.socialStatus, isSearchable: true })), detail.socialStatus) }, { label: _('taxStatus'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.taxStatus, { options: clientOptionsDict.taxStatus, isSearchable: true })), detail.taxStatus) }]];
	                }
	            } else {
	                if (main.clientType.value == 2) {
	                    generalInformationColumns = [[{ label: _('legalForm') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, main.legalFormId, {
	                            options: clientOptionsDict.legalForm,
	                            onChange: function (newValue) {
	                                main.legalFormId.onChange(newValue.value);
	                                main.legalForm.onChange(newValue.label);
	                                main.legalFormId.value = newValue.value;
	                                main.legalForm.value = newValue.label;
	                            }
	                        })), main.legalFormId)
	                    }, { label: _('nationality'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.nationality, { options: clientOptionsDict.nationality, isSearchable: true })), detail.nationality) }, { label: _('language') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.language, { options: clientOptionsDict.language, isSearchable: true })), detail.language) }], [{ label: _('companyRegistrationNumber'), value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, main.companyRegistrationNumber, { searchable: true })), main.companyRegistrationNumber) }, { label: _('activSector'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.activSector, { options: clientOptionsDict.activSector, isSearchable: true })), detail.activSector) }, { label: _('taxStatus'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.taxStatus, { options: clientOptionsDict.taxStatus, isSearchable: true })), detail.taxStatus) }]];
	                } else {
	                    generalInformationColumns = [[{ label: _('gender') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.gender, { options: clientOptionsDict.gender, isSearchable: true })), detail.gender) }, { label: _('clientTitle') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.title, { options: clientOptionsDict.title, isSearchable: true })), detail.title) }, { label: _('nationalIdNumber'), value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, detail.nationalIdNumber, { onBlur: this.makeOnBlur(detail.nationalIdNumber) })), detail.nationalIdNumber) }, { label: _('nationality') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.nationality, { options: clientOptionsDict.nationality, isSearchable: true })), detail.nationality) }, { label: _('language') + ' *', value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.language, { options: clientOptionsDict.language, isSearchable: true })), detail.language) }, { label: _('ppp'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.ppp, { options: clientOptionsDict.ppp, isSearchable: true })), detail.ppp) }], [{ label: _('dateOfBirth'), value: generateField(_react2['default'].createElement(_componentsSharedDatePicker.DatePicker, main.dateOfBirth), main.dateOfBirth) }, { label: _('birthCountry'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.birthCountry, { options: clientOptionsDict.birthCountry, isSearchable: true, onChange: function (e) {
	                                return _this5.onBirthCoutryChangeHandler(e);
	                            } })), detail.birthCountry) }, { label: _('maritalStatus'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.maritalStatus, { options: clientOptionsDict.maritalStatus, isSearchable: true })), detail.maritalStatus) }, { label: _('companyRegistrationNumber'), value: generateField(_react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, main.companyRegistrationNumber)), main.companyRegistrationNumber) }, { label: _('profession'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableDynamicListSelectWrapper, _extends({}, detail.profession, { toggleShowFullList: this.toggleShowFullProfessionList.bind(this), options: professionOptions, isSearchable: true })), detail.profession) }, { label: _('activSector'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableDynamicListSelectWrapper, _extends({}, detail.activSector, { toggleShowFullList: this.toggleShowFullActivSectorList.bind(this), options: activSectorOptionsList, isSearchable: true })), detail.activSector) }, { label: _('socialStatus'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.socialStatus, { options: clientOptionsDict.socialStatus, isSearchable: true })), detail.socialStatus) }, { label: _('taxStatus'), value: generateField(_react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.taxStatus, { options: clientOptionsDict.taxStatus, isSearchable: true })), detail.taxStatus) }]];
	                }
	            }
	
	            if (main.clientType.value == 1 && detail.birthCountry.value && detail.birthCountry.value === '1') {
	                var _generalInformationColumns$1;
	
	                generalInformationColumns = [].concat(_toConsumableArray(generalInformationColumns));
	                (_generalInformationColumns$1 = generalInformationColumns[1]).splice.apply(_generalInformationColumns$1, [1, 1].concat([{ label: _('birthCountry'), value: generateField(_react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({ style: { marginBottom: '10px' } }, detail.birthCountry, { options: clientOptionsDict.birthCountry, isSearchable: true, onChange: function (e) {
	                                return _this5.onBirthCoutryChangeHandler(e);
	                            } })),
	                        _react2['default'].createElement(
	                            'label',
	                            null,
	                            ' ',
	                            _('birthPlaceCodeAndLocality'),
	                            ' * '
	                        ),
	                        _react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, detail.birthZipCity, { options: clientOptionsDict.birthLocality, isSearchable: true, onChange: function (e) {
	                                return _this5.onBirthZipCityChangeHandler(e);
	                            } }))
	                    ), detail.birthCountry) }]));
	            } else if (main.clientType.value == 1 && detail.birthCountry.value && detail.birthCountry.value !== '1') {
	                var _generalInformationColumns$12;
	
	                generalInformationColumns = [].concat(_toConsumableArray(generalInformationColumns));
	                (_generalInformationColumns$12 = generalInformationColumns[1]).splice.apply(_generalInformationColumns$12, [1, 1].concat([{ label: _('birthCountry'), value: generateField(_react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({ style: { marginBottom: '10px' } }, detail.birthCountry, { options: clientOptionsDict.birthCountry, isSearchable: true, onChange: function (e) {
	                                return _this5.onBirthCoutryChangeHandler(e);
	                            } })),
	                        _react2['default'].createElement(
	                            'label',
	                            null,
	                            _('birthPostalCode'),
	                            ' '
	                        ),
	                        _react2['default'].createElement(_input2['default'], _extends({ style: { marginBottom: '10px' }, type: 'text' }, detail.birthPostalCode, { onBlur: this.makeOnBlur(detail.birthPostalCode) })),
	                        _react2['default'].createElement(
	                            'label',
	                            null,
	                            _('birthLocality'),
	                            ' '
	                        ),
	                        _react2['default'].createElement(_input2['default'], _extends({ type: 'text' }, detail.birthLocality, { onBlur: this.makeOnBlur(detail.birthLocality) }))
	                    ), detail.birthCountry) }]));
	            }
	
	            var generalExtended = [[{ label: _('ibans'), value: generateField(_react2['default'].createElement(_ibansListSelect2['default'], { data: detail.accountNumbers }), detail.accountNumbers) }], [{ label: _('licenses'), value: generateField(_react2['default'].createElement(_licensesListSelect2['default'], { data: detail.licences, selectCategoryOptions: clientOptionsDict.licenceCategory }), detail.licences) }]];
	
	            var addressColumns = [[{ noLabel: true, value: generateField(_react2['default'].createElement(_clientAddressList2['default'], { data: main.mainAddress, countryOptions: clientOptionsDict.country, title: _('mainAddress'), addType: 'mainaddress', dispatch: dispatch }), main.mainAddress) }], [{ noLabel: true, value: generateField(_react2['default'].createElement(_clientAddressList2['default'], { data: detail.correspondanceAddress, countryOptions: clientOptionsDict.country, title: _('correspondanceAddress'), addType: 'corressadd', dispatch: dispatch }), detail.correspondanceAddress) }]];
	
	            var contactColumns = [[{ label: _('emails'), value: generateField(_react2['default'].createElement(_emailListSelect2['default'], { dispatch: dispatch, data: detail.emails, formStatus: formStatus }), detail.emails) }, { label: _('relation'), value: generateField(_react2['default'].createElement(_relationListSelect2['default'], { data: detail.contacts, setProfileFormCheckbox: setProfileFormCheckbox, dispatch: dispatch, selectedCheckboxes: selectedCheckboxes, relationOptions: clientOptionsDict.relationType, genderOptions: clientOptionsDict.gender, officeClients: existingClients }), detail.contacts) }], [{ label: _('phoneNumbers'), value: generateField(_react2['default'].createElement(_phoneListSelect2['default'], { dispatch: dispatch, data: detail.phoneNumbers, formStatus: formStatus }), detail.phoneNumbers) }]];
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.handleSubmit, className: _clientProfileFormScss2['default'].clientProfileForm },
	                    formType == 'create' && _react2['default'].createElement(
	                        'div',
	                        { className: _clientProfileFormScss2['default'].mainTitleDiv },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientProfileFormScss2['default'].mainTitleContainer },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _clientProfileFormScss2['default'].mainTitle },
	                                _('createClient')
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'h3',
	                        { className: _clientProfileFormScss2['default'].informationTitle },
	                        _('generalInformation')
	                    ),
	                    _react2['default'].createElement(_KeyValue2['default'], { array: generalInformationColumns, customClass: _clientProfileFormScss2['default'].KeyValue }),
	                    _react2['default'].createElement(_KeyValue2['default'], { array: generalExtended, customClass: _clientProfileFormScss2['default'].KeyValue, divider: true }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientProfileFormScss2['default'].clientProfileResultsWrapper },
	                        formType == 'create' && _react2['default'].createElement(_clientProfileFormResults2['default'], { data: existingClients, zoomTo: zoomTo, loadClientData: loadClientData })
	                    ),
	                    _react2['default'].createElement(
	                        'h3',
	                        { className: _clientProfileFormScss2['default'].informationTitleBorder },
	                        _('addressInformation')
	                    ),
	                    _react2['default'].createElement(_KeyValue2['default'], { array: addressColumns, customClass: _clientProfileFormScss2['default'].AddressKeyValue, divider: true }),
	                    _react2['default'].createElement(
	                        'h3',
	                        { className: _clientProfileFormScss2['default'].informationTitleBorder },
	                        _('contactInformation')
	                    ),
	                    _react2['default'].createElement(_KeyValue2['default'], { array: contactColumns, customClass: _clientProfileFormScss2['default'].KeyValue, divider: true }),
	                    formErrors.sent == true && formErrors.problem != null && _react2['default'].createElement(
	                        'div',
	                        { className: _clientProfileFormScss2['default'].formError },
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _('createClientError')
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            _('createClientRefError')
	                        ),
	                        formErrors.problem
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientProfileFormScss2['default'].buttons },
	                        formType == 'create' && _react2['default'].createElement(
	                            'button',
	                            {
	                                className: '' + _clientProfileFormScss2['default'].cancel,
	                                type: 'submit',
	                                onClick: function (e) {
	                                    return openModal(e);
	                                }
	                            },
	                            _('cancel')
	                        ),
	                        formType == 'edit' && _react2['default'].createElement(
	                            'button',
	                            {
	                                className: '' + _clientProfileFormScss2['default'].cancel,
	                                type: 'submit',
	                                onClick: function (e) {
	                                    e.preventDefault();
	                                    if (modalStatus) {
	                                        openModal(e);
	                                    }
	
	                                    if (!modalStatus) {
	                                        setSubModule('profile');
	                                    }
	                                }
	                            },
	                            _('cancel')
	                        ),
	                        _react2['default'].createElement(
	                            'button',
	                            {
	                                className: _clientProfileFormScss2['default'].next + ' + ' + _clientProfileFormScss2['default'].enabled,
	                                disabled: formStatus.isSending,
	                                type: 'submit'
	                            },
	                            _('save')
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        style: customStyles,
	                        contentLabel: 'Modal'
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientProfileFormScss2['default'].verifyModalContent },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: _clientProfileFormScss2['default'].title },
	                            _("requiredFieldsWarningTitle")
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _clientProfileFormScss2['default'].message },
	                            _("requiredFieldsWarningMessage")
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientProfileFormScss2['default'].verifyModalButtons },
	                            _react2['default'].createElement('input', {
	                                onClick: function () {
	                                    return _this5.openNotificationModal();
	                                },
	                                type: 'button',
	                                className: _clientProfileFormScss2['default'].greyButton + " enabled",
	                                value: _("requriedFieldsButtonText")
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _ClientProfileForm = ClientProfileForm;
	    ClientProfileForm = (0, _reduxForm.reduxForm)({
	        form: "clientProfileEdit",
	        fields: ['main.clientType', 'main.legalForm', 'main.legalFormId', 'main.name', 'main.firstName', 'main.lastName', 'main.clientNumber', 'detail.gender', 'detail.title', 'detail.nationality', 'detail.language', 'detail.birthCountry', 'detail.birthPostalCode', 'detail.birthLocality', 'detail.birthZipCity', 'detail.maritalStatus', 'detail.profession', 'detail.activSector', 'detail.socialStatus', 'detail.taxStatus', 'detail.ppp', 'detail.nationalIdNumber', 'detail.emails[]', 'detail.emails[].email', 'detail.emails[].default', 'detail.emails[].uniqueId', 'detail.licences[]', 'detail.licences[].licenceCategory', 'detail.licences[].licenceDate', 'detail.licences[].uniqueId', 'main.mainAddress.country', 'main.mainAddress.extension', 'main.mainAddress.locality', 'main.mainAddress.number', 'main.mainAddress.postalCode', 'main.mainAddress.street', 'main.mainAddress.zipCity', 'main.dateOfBirth', 'main.companyRegistrationNumber', 'detail.phoneNumbers[]', 'detail.phoneNumbers[].default', 'detail.phoneNumbers[].mobile', 'detail.phoneNumbers[].number', 'detail.phoneNumbers[].uniqueId', 'detail.accountNumbers[]', 'detail.accountNumbers[].BIC', 'detail.accountNumbers[].IBAN', 'detail.accountNumbers[].uniqueId', 'detail.contacts[]', 'detail.contacts[].contactName', 'detail.contacts[].contactFirstName', 'detail.contacts[].contactLastName', 'detail.contacts[].contactNumber', 'detail.contacts[].contactType', 'detail.contacts[].contactdateOfBirth', 'detail.contacts[].contactgender', 'detail.contacts[].uniqueId', 'detail.correspondanceAddress.country', 'detail.correspondanceAddress.extension', 'detail.correspondanceAddress.locality', 'detail.correspondanceAddress.number', 'detail.correspondanceAddress.postalCode', 'detail.correspondanceAddress.street', 'detail.correspondanceAddress.zipCity'],
	        validate: validate
	    })(ClientProfileForm) || ClientProfileForm;
	    ClientProfileForm = (0, _reactRedux.connect)(function (state) {
	        // The current appLanguage
	        var appLanguage = state.app.lang;
	
	        var errorReport = null;
	
	        // Get the general state data from the clientProfileForm state
	        var _state$clientProfileForm = state.clientProfileForm;
	        var clientId = _state$clientProfileForm.clientId;
	        var formStatus = _state$clientProfileForm.formStatus;
	        var selectedCheckboxes = _state$clientProfileForm.selectedCheckboxes;
	        var type = _state$clientProfileForm.type;
	        var clientData = state.clientProfileForm.clientData;
	
	        // Generate options for client select lists
	        var clientOptionsDict = (0, _libHelpers.generateClientDicts)(state.client.clientOptionsDict, appLanguage);
	
	        if (type == 'edit') {
	            clientData = normalizeData(clientData, appLanguage, clientOptionsDict);
	
	            if (clientData['detail'].birthCountry === "1") {
	                clientData['detail'].birthZipCity = clientData['detail'].birthPostalCode + '&' + clientData['detail'].birthLocality;
	            }
	
	            //This because of issue BEWB-312 in order to detect error in production
	            if (clientData.main.clientType === "2") {
	                (function () {
	                    var legalFormHasCorrectValue = false,
	                        clientLegalForm = _nestedProperty2['default'].get(clientData, "main.legalForm"),
	                        clientLegalFormId = _nestedProperty2['default'].get(clientData, "main.legalFormId"),
	                        clientLanguage = _nestedProperty2['default'].get(clientData, "detail.language");
	
	                    clientOptionsDict.legalForm.map(function (item) {
	                        if (String(clientLegalForm).toUpperCase() == String(item.label).toUpperCase()) {
	                            legalFormHasCorrectValue = true;
	                        }
	                    });
	
	                    if (clientLegalForm && !legalFormHasCorrectValue) {
	                        var error = {
	                            level: "debug",
	                            moduleName: "clientProfile",
	                            message: "Selection list not match for legalForm = " + clientLegalForm + " id = " + clientLegalFormId,
	                            details: {
	                                clientData: clientData,
	                                clientLegalForm: clientLegalForm,
	                                clientLegalFormId: clientLegalFormId,
	                                legalFormDict: clientOptionsDict.legalForm,
	                                appLanguage: appLanguage,
	                                clientLanguage: clientLanguage,
	                                browserError: true,
	                                sendReport: true
	                            }
	                        };
	                        errorReport = {
	                            error: error,
	                            version: ("10.0-159-ge9cd7ea95")
	                        };
	                    }
	                })();
	            }
	        }
	
	        if (type == 'create') {
	            clientData['main'] = {
	                clientType: "1",
	                mainAddress: {
	                    country: "1"
	                }
	            };
	
	            clientData['detail'] = {
	
	                correspondanceAddress: {
	                    country: undefined
	                },
	                nationality: "1",
	                language: "1"
	            };
	        }
	
	        if (clientData && clientData.detail != undefined) {
	            clientData.detail.accountNumbers && generateUUIdForLists(clientData.detail.accountNumbers);
	            clientData.detail.licences && generateUUIdForLists(clientData.detail.licences);
	            clientData.detail.emails && generateUUIdForLists(clientData.detail.emails);
	            clientData.detail.phoneNumbers && generateUUIdForLists(clientData.detail.phoneNumbers);
	            clientData.detail.contacts && generateUUIdForLists(clientData.detail.contacts);
	        }
	
	        return {
	            initialValues: clientData,
	            subModule: state.clients.subModule,
	            appLanguage: appLanguage,
	            clientData: clientData,
	            clientId: clientId,
	            formStatus: formStatus,
	            selectedCheckboxes: selectedCheckboxes,
	            formType: type,
	            clientOptionsDict: clientOptionsDict,
	            setProfileFormCheckbox: _stateActions.setProfileFormCheckbox,
	            cleanProfileFormCheckbox: _stateActions.cleanProfileFormCheckbox,
	            data: state.clients.data,
	            existingClients: state.clientProfileForm.existingClients,
	            fetchExistingClients: _stateActions.fetchExistingClients,
	            setOpened: _stateActions.setOpened, setClientSubModule: _stateActions.setClientSubModule, setB2bCompanyOpened: _stateActions.setB2bCompanyOpened, setB2bCompanySubModule: _stateActions.setB2bCompanySubModule,
	            fetchExistingClient: _stateActions.fetchExistingClient,
	            changeListDefaultError: _stateActions.changeListDefaultError,
	            b2bCompanyCompany: state.b2bCompany.b2bCompanyCompany,
	            modalStatus: state.clientProfileForm.clientModal,
	            formErrors: state.clientProfileForm.formStatus,
	            errorReport: errorReport
	        };
	    })(ClientProfileForm) || ClientProfileForm;
	    return ClientProfileForm;
	})(_react.Component);
	
	exports['default'] = ClientProfileForm;
	module.exports = exports['default'];

	/**
	 * The redux form contains all the form fields what we require
	 */

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(629);
	var enumBugKeys = __webpack_require__(378);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var makeStore, store;
	
	makeStore = __webpack_require__(1176);
	
	store = makeStore();
	
	module.exports = store;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var charAt = __webpack_require__(294).charAt;
	
	// `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? charAt(S, index).length : 1);
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(14);
	var NATIVE_ARRAY_BUFFER = __webpack_require__(394);
	var FunctionName = __webpack_require__(184);
	var createNonEnumerableProperty = __webpack_require__(58);
	var defineBuiltInAccessor = __webpack_require__(50);
	var defineBuiltIns = __webpack_require__(229);
	var fails = __webpack_require__(6);
	var anInstance = __webpack_require__(97);
	var toIntegerOrInfinity = __webpack_require__(44);
	var toLength = __webpack_require__(76);
	var toIndex = __webpack_require__(428);
	var fround = __webpack_require__(672);
	var IEEE754 = __webpack_require__(1233);
	var getPrototypeOf = __webpack_require__(84);
	var setPrototypeOf = __webpack_require__(100);
	var arrayFill = __webpack_require__(396);
	var arraySlice = __webpack_require__(89);
	var inheritIfRequired = __webpack_require__(148);
	var copyConstructorProperties = __webpack_require__(227);
	var setToStringTag = __webpack_require__(65);
	var InternalStateModule = __webpack_require__(49);
	
	var PROPER_FUNCTION_NAME = FunctionName.PROPER;
	var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length';
	var WRONG_INDEX = 'Wrong index';
	var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
	var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
	var setInternalState = InternalStateModule.set;
	var NativeArrayBuffer = globalThis[ARRAY_BUFFER];
	var $ArrayBuffer = NativeArrayBuffer;
	var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
	var $DataView = globalThis[DATA_VIEW];
	var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
	var ObjectPrototype = Object.prototype;
	var Array = globalThis.Array;
	var RangeError = globalThis.RangeError;
	var fill = uncurryThis(arrayFill);
	var reverse = uncurryThis([].reverse);
	
	var packIEEE754 = IEEE754.pack;
	var unpackIEEE754 = IEEE754.unpack;
	
	var packInt8 = function (number) {
	  return [number & 0xFF];
	};
	
	var packInt16 = function (number) {
	  return [number & 0xFF, number >> 8 & 0xFF];
	};
	
	var packInt32 = function (number) {
	  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
	};
	
	var unpackInt32 = function (buffer) {
	  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
	};
	
	var packFloat32 = function (number) {
	  return packIEEE754(fround(number), 23, 4);
	};
	
	var packFloat64 = function (number) {
	  return packIEEE754(number, 52, 8);
	};
	
	var addGetter = function (Constructor, key, getInternalState) {
	  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
	    configurable: true,
	    get: function () {
	      return getInternalState(this)[key];
	    }
	  });
	};
	
	var get = function (view, count, index, isLittleEndian) {
	  var store = getInternalDataViewState(view);
	  var intIndex = toIndex(index);
	  var boolIsLittleEndian = !!isLittleEndian;
	  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
	  var bytes = store.bytes;
	  var start = intIndex + store.byteOffset;
	  var pack = arraySlice(bytes, start, start + count);
	  return boolIsLittleEndian ? pack : reverse(pack);
	};
	
	var set = function (view, count, index, conversion, value, isLittleEndian) {
	  var store = getInternalDataViewState(view);
	  var intIndex = toIndex(index);
	  var pack = conversion(+value);
	  var boolIsLittleEndian = !!isLittleEndian;
	  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
	  var bytes = store.bytes;
	  var start = intIndex + store.byteOffset;
	  for (var i = 0; i < count; i++) bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
	};
	
	if (!NATIVE_ARRAY_BUFFER) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, ArrayBufferPrototype);
	    var byteLength = toIndex(length);
	    setInternalState(this, {
	      type: ARRAY_BUFFER,
	      bytes: fill(Array(byteLength), 0),
	      byteLength: byteLength
	    });
	    if (!DESCRIPTORS) {
	      this.byteLength = byteLength;
	      this.detached = false;
	    }
	  };
	
	  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, DataViewPrototype);
	    anInstance(buffer, ArrayBufferPrototype);
	    var bufferState = getInternalArrayBufferState(buffer);
	    var bufferLength = bufferState.byteLength;
	    var offset = toIntegerOrInfinity(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw new RangeError('Wrong offset');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw new RangeError(WRONG_LENGTH);
	    setInternalState(this, {
	      type: DATA_VIEW,
	      buffer: buffer,
	      byteLength: byteLength,
	      byteOffset: offset,
	      bytes: bufferState.bytes
	    });
	    if (!DESCRIPTORS) {
	      this.buffer = buffer;
	      this.byteLength = byteLength;
	      this.byteOffset = offset;
	    }
	  };
	
	  DataViewPrototype = $DataView[PROTOTYPE];
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
	    addGetter($DataView, 'buffer', getInternalDataViewState);
	    addGetter($DataView, 'byteLength', getInternalDataViewState);
	    addGetter($DataView, 'byteOffset', getInternalDataViewState);
	  }
	
	  defineBuiltIns(DataViewPrototype, {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packInt8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packInt8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
	    }
	  });
	} else {
	  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
	  /* eslint-disable no-new, sonar/inconsistent-function-call -- required for testing */
	  if (!fails(function () {
	    NativeArrayBuffer(1);
	  }) || !fails(function () {
	    new NativeArrayBuffer(-1);
	  }) || fails(function () {
	    new NativeArrayBuffer();
	    new NativeArrayBuffer(1.5);
	    new NativeArrayBuffer(NaN);
	    return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
	  })) {
	    /* eslint-enable no-new, sonar/inconsistent-function-call -- required for testing */
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, ArrayBufferPrototype);
	      return inheritIfRequired(new NativeArrayBuffer(toIndex(length)), this, $ArrayBuffer);
	    };
	
	    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;
	
	    ArrayBufferPrototype.constructor = $ArrayBuffer;
	
	    copyConstructorProperties($ArrayBuffer, NativeArrayBuffer);
	  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
	    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
	  }
	
	  // WebKit bug - the same parent prototype for typed arrays and data view
	  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
	    setPrototypeOf(DataViewPrototype, ObjectPrototype);
	  }
	
	  // iOS Safari 7.x bug
	  var testView = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
	  testView.setInt8(0, 2147483648);
	  testView.setInt8(1, 2147483649);
	  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8(this, byteOffset, value << 24 >> 24);
	    }
	  }, { unsafe: true });
	}
	
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	
	module.exports = {
	  ArrayBuffer: $ArrayBuffer,
	  DataView: $DataView
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var lengthOfArrayLike = __webpack_require__(34);
	
	module.exports = function (Constructor, list, $length) {
	  var index = 0;
	  var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
	  var result = new Constructor(length);
	  while (length > index) result[index] = list[index++];
	  return result;
	};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(91);
	var IndexedObject = __webpack_require__(185);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	
	// `Array.prototype.{ findLast, findLastIndex }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_FIND_LAST_INDEX = TYPE === 1;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var index = lengthOfArrayLike(self);
	    var boundFunction = bind(callbackfn, that);
	    var value, result;
	    while (index-- > 0) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (result) switch (TYPE) {
	        case 0: return value; // findLast
	        case 1: return index; // findLastIndex
	      }
	    }
	    return IS_FIND_LAST_INDEX ? -1 : undefined;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.findLast` method
	  // https://github.com/tc39/proposal-array-find-from-last
	  findLast: createMethod(0),
	  // `Array.prototype.findLastIndex` method
	  // https://github.com/tc39/proposal-array-find-from-last
	  findLastIndex: createMethod(1)
	};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(39);
	var toObject = __webpack_require__(31);
	var IndexedObject = __webpack_require__(185);
	var lengthOfArrayLike = __webpack_require__(34);
	
	var $TypeError = TypeError;
	
	var REDUCE_EMPTY = 'Reduce of empty array with no initial value';
	
	// `Array.prototype.{ reduce, reduceRight }` methods implementation
	var createMethod = function (IS_RIGHT) {
	  return function (that, callbackfn, argumentsLength, memo) {
	    var O = toObject(that);
	    var self = IndexedObject(O);
	    var length = lengthOfArrayLike(O);
	    aCallable(callbackfn);
	    if (length === 0 && argumentsLength < 2) throw new $TypeError(REDUCE_EMPTY);
	    var index = IS_RIGHT ? length - 1 : 0;
	    var i = IS_RIGHT ? -1 : 1;
	    if (argumentsLength < 2) while (true) {
	      if (index in self) {
	        memo = self[index];
	        index += i;
	        break;
	      }
	      index += i;
	      if (IS_RIGHT ? index < 0 : length <= index) {
	        throw new $TypeError(REDUCE_EMPTY);
	      }
	    }
	    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
	      memo = callbackfn(memo, self[index], index, O);
	    }
	    return memo;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.reduce` method
	  // https://tc39.es/ecma262/#sec-array.prototype.reduce
	  left: createMethod(false),
	  // `Array.prototype.reduceRight` method
	  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
	  right: createMethod(true)
	};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(27);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var called = 0;
	  var iteratorWithReturn = {
	    next: function () {
	      return { done: !!called++ };
	    },
	    'return': function () {
	      SAFE_CLOSING = true;
	    }
	  };
	  iteratorWithReturn[ITERATOR] = function () {
	    return this;
	  };
	  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
	  Array.from(iteratorWithReturn, function () { throw 2; });
	} catch (error) { /* empty */ }
	
	module.exports = function (exec, SKIP_CLOSING) {
	  try {
	    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
	  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
	  var ITERATION_SUPPORT = false;
	  try {
	    var object = {};
	    object[ITERATOR] = function () {
	      return {
	        next: function () {
	          return { done: ITERATION_SUPPORT = true };
	        }
	      };
	    };
	    exec(object);
	  } catch (error) { /* empty */ }
	  return ITERATION_SUPPORT;
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(8);
	var isForced = __webpack_require__(233);
	var defineBuiltIn = __webpack_require__(40);
	var InternalMetadataModule = __webpack_require__(149);
	var iterate = __webpack_require__(83);
	var anInstance = __webpack_require__(97);
	var isCallable = __webpack_require__(28);
	var isNullOrUndefined = __webpack_require__(64);
	var isObject = __webpack_require__(25);
	var fails = __webpack_require__(6);
	var checkCorrectnessOfIteration = __webpack_require__(277);
	var setToStringTag = __webpack_require__(65);
	var inheritIfRequired = __webpack_require__(148);
	
	module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
	  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
	  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var NativeConstructor = globalThis[CONSTRUCTOR_NAME];
	  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
	  var Constructor = NativeConstructor;
	  var exported = {};
	
	  var fixMethod = function (KEY) {
	    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
	    defineBuiltIn(NativePrototype, KEY,
	      KEY === 'add' ? function add(value) {
	        uncurriedNativeMethod(this, value === 0 ? 0 : value);
	        return this;
	      } : KEY === 'delete' ? function (key) {
	        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : KEY === 'get' ? function get(key) {
	        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : KEY === 'has' ? function has(key) {
	        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : function set(key, value) {
	        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
	        return this;
	      }
	    );
	  };
	
	  var REPLACE = isForced(
	    CONSTRUCTOR_NAME,
	    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
	      new NativeConstructor().entries().next();
	    }))
	  );
	
	  if (REPLACE) {
	    // create collection constructor
	    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
	    InternalMetadataModule.enable();
	  } else if (isForced(CONSTRUCTOR_NAME, true)) {
	    var instance = new Constructor();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
	    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    // eslint-disable-next-line no-new -- required for testing
	    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new NativeConstructor();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	
	    if (!ACCEPT_ITERABLES) {
	      Constructor = wrapper(function (dummy, iterable) {
	        anInstance(dummy, NativePrototype);
	        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
	        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	        return that;
	      });
	      Constructor.prototype = NativePrototype;
	      NativePrototype.constructor = Constructor;
	    }
	
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	
	    // weak collections should not contains .clear method
	    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
	  }
	
	  exported[CONSTRUCTOR_NAME] = Constructor;
	  $({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);
	
	  setToStringTag(Constructor, CONSTRUCTOR_NAME);
	
	  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
	
	  return Constructor;
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var tryToString = __webpack_require__(154);
	
	var $TypeError = TypeError;
	
	module.exports = function (O, P) {
	  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var isObject = __webpack_require__(25);
	
	var document = globalThis.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS = isObject(document) && isObject(document.createElement);
	
	module.exports = function (it) {
	  return EXISTS ? document.createElement(it) : {};
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* global Bun, Deno -- detection */
	var globalThis = __webpack_require__(9);
	var userAgent = __webpack_require__(99);
	var classof = __webpack_require__(53);
	
	var userAgentStartsWith = function (string) {
	  return userAgent.slice(0, string.length) === string;
	};
	
	module.exports = (function () {
	  if (userAgentStartsWith('Bun/')) return 'BUN';
	  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
	  if (userAgentStartsWith('Deno/')) return 'DENO';
	  if (userAgentStartsWith('Node.js/')) return 'NODE';
	  if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
	  if (globalThis.Deno && typeof Deno.version == 'object') return 'DENO';
	  if (classof(globalThis.process) === 'process') return 'NODE';
	  if (globalThis.window && globalThis.document) return 'BROWSER';
	  return 'REST';
	})();


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4` since it's moved to entry points
	__webpack_require__(431);
	var call = __webpack_require__(19);
	var defineBuiltIn = __webpack_require__(40);
	var regexpExec = __webpack_require__(418);
	var fails = __webpack_require__(6);
	var wellKnownSymbol = __webpack_require__(27);
	var createNonEnumerableProperty = __webpack_require__(58);
	
	var SPECIES = wellKnownSymbol('species');
	var RegExpPrototype = RegExp.prototype;
	
	module.exports = function (KEY, exec, FORCED, SHAM) {
	  var SYMBOL = wellKnownSymbol(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegExp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) !== 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	
	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {};
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }
	
	    re.exec = function () {
	      execCalled = true;
	      return null;
	    };
	
	    re[SYMBOL]('');
	    return !execCalled;
	  });
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    FORCED
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      var $exec = regexp.exec;
	      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return { done: true, value: call(nativeRegExpMethod, regexp, str, arg2) };
	        }
	        return { done: true, value: call(nativeMethod, str, regexp, arg2) };
	      }
	      return { done: false };
	    });
	
	    defineBuiltIn(String.prototype, KEY, methods[0]);
	    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
	  }
	
	  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
	};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(39);
	
	module.exports = function (object, key, method) {
	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
	  } catch (error) { /* empty */ }
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var aCallable = __webpack_require__(39);
	var anObject = __webpack_require__(20);
	var tryToString = __webpack_require__(154);
	var getIteratorMethod = __webpack_require__(231);
	
	var $TypeError = TypeError;
	
	module.exports = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
	  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
	  throw new $TypeError(tryToString(argument) + ' is not iterable');
	};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(25);
	var classof = __webpack_require__(53);
	var wellKnownSymbol = __webpack_require__(27);
	
	var MATCH = wellKnownSymbol('match');
	
	// `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
	};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var anObject = __webpack_require__(20);
	var getMethod = __webpack_require__(116);
	
	module.exports = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject(iterator);
	  try {
	    innerResult = getMethod(iterator, 'return');
	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }
	    innerResult = call(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }
	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject(innerResult);
	  return value;
	};


/***/ }),
/* 287 */
/***/ (function(module, exports) {

	'use strict';
	// eslint-disable-next-line es/no-math-expm1 -- safe
	var $expm1 = Math.expm1;
	var exp = Math.exp;
	
	// `Math.expm1` method implementation
	// https://tc39.es/ecma262/#sec-math.expm1
	module.exports = (!$expm1
	  // Old FF bug
	  // eslint-disable-next-line no-loss-of-precision -- required for old engines
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) !== -2e-17
	) ? function expm1(x) {
	  var n = +x;
	  return n === 0 ? n : n > -1e-6 && n < 1e-6 ? n + n * n / 2 : exp(n) - 1;
	} : $expm1;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

	'use strict';
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);
	
	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable no-undef, no-useless-call, sonar/no-reference-error -- required for testing */
	/* eslint-disable es/no-legacy-object-prototype-accessor-methods -- required for testing */
	var IS_PURE = __webpack_require__(43);
	var globalThis = __webpack_require__(9);
	var fails = __webpack_require__(6);
	var WEBKIT = __webpack_require__(403);
	
	// Forced replacement object prototype accessors methods
	module.exports = IS_PURE || !fails(function () {
	  // This feature detection crashes old WebKit
	  // https://github.com/zloirock/core-js/issues/232
	  if (WEBKIT && WEBKIT < 535) return;
	  var key = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, key, function () { /* empty */ });
	  delete globalThis[key];
	});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var NativePromiseConstructor = __webpack_require__(187);
	var checkCorrectnessOfIteration = __webpack_require__(277);
	var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(238).CONSTRUCTOR;
	
	module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
	  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
	});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var globalThis = __webpack_require__(9);
	
	// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
	var $RegExp = globalThis.RegExp;
	
	var UNSUPPORTED_Y = fails(function () {
	  var re = $RegExp('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') !== null;
	});
	
	// UC Browser bug
	// https://github.com/zloirock/core-js/issues/1008
	var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
	  return !$RegExp('a', 'y').sticky;
	});
	
	var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = $RegExp('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') !== null;
	});
	
	module.exports = {
	  BROKEN_CARET: BROKEN_CARET,
	  MISSED_STICKY: MISSED_STICKY,
	  UNSUPPORTED_Y: UNSUPPORTED_Y
	};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var shared = __webpack_require__(190);
	var uid = __webpack_require__(194);
	
	var keys = shared('keys');
	
	module.exports = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var toIntegerOrInfinity = __webpack_require__(44);
	var toString = __webpack_require__(18);
	var requireObjectCoercible = __webpack_require__(41);
	
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var stringSlice = uncurryThis(''.slice);
	
	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString(requireObjectCoercible($this));
	    var position = toIntegerOrInfinity(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING
	          ? charAt(S, position)
	          : first
	        : CONVERT_TO_STRING
	          ? stringSlice(S, position, position + 2)
	          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};
	
	module.exports = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(44);
	var toString = __webpack_require__(18);
	var requireObjectCoercible = __webpack_require__(41);
	
	var $RangeError = RangeError;
	
	// `String.prototype.repeat` method implementation
	// https://tc39.es/ecma262/#sec-string.prototype.repeat
	module.exports = function repeat(count) {
	  var str = toString(requireObjectCoercible(this));
	  var result = '';
	  var n = toIntegerOrInfinity(count);
	  if (n < 0 || n === Infinity) throw new $RangeError('Wrong number of repetitions');
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
	  return result;
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var apply = __webpack_require__(90);
	var bind = __webpack_require__(91);
	var isCallable = __webpack_require__(28);
	var hasOwn = __webpack_require__(29);
	var fails = __webpack_require__(6);
	var html = __webpack_require__(664);
	var arraySlice = __webpack_require__(89);
	var createElement = __webpack_require__(280);
	var validateArgumentsLength = __webpack_require__(85);
	var IS_IOS = __webpack_require__(656);
	var IS_NODE = __webpack_require__(182);
	
	var set = globalThis.setImmediate;
	var clear = globalThis.clearImmediate;
	var process = globalThis.process;
	var Dispatch = globalThis.Dispatch;
	var Function = globalThis.Function;
	var MessageChannel = globalThis.MessageChannel;
	var String = globalThis.String;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var $location, defer, channel, port;
	
	fails(function () {
	  // Deno throws a ReferenceError on `location` access without `--location` flag
	  $location = globalThis.location;
	});
	
	var run = function (id) {
	  if (hasOwn(queue, id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	
	var runner = function (id) {
	  return function () {
	    run(id);
	  };
	};
	
	var eventListener = function (event) {
	  run(event.data);
	};
	
	var globalPostMessageDefer = function (id) {
	  // old engines have not location.origin
	  globalThis.postMessage(String(id), $location.protocol + '//' + $location.host);
	};
	
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!set || !clear) {
	  set = function setImmediate(handler) {
	    validateArgumentsLength(arguments.length, 1);
	    var fn = isCallable(handler) ? handler : Function(handler);
	    var args = arraySlice(arguments, 1);
	    queue[++counter] = function () {
	      apply(fn, undefined, args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clear = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (IS_NODE) {
	    defer = function (id) {
	      process.nextTick(runner(id));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(runner(id));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  // except iOS - https://github.com/zloirock/core-js/issues/624
	  } else if (MessageChannel && !IS_IOS) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = eventListener;
	    defer = bind(port.postMessage, port);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (
	    globalThis.addEventListener &&
	    isCallable(globalThis.postMessage) &&
	    !globalThis.importScripts &&
	    $location && $location.protocol !== 'file:' &&
	    !fails(globalPostMessageDefer)
	  ) {
	    defer = globalPostMessageDefer;
	    globalThis.addEventListener('message', eventListener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in createElement('script')) {
	    defer = function (id) {
	      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(runner(id), 0);
	    };
	  }
	}
	
	module.exports = {
	  set: set,
	  clear: clear
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	// `thisNumberValue` abstract operation
	// https://tc39.es/ecma262/#sec-thisnumbervalue
	module.exports = uncurryThis(1.0.valueOf);


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var isObject = __webpack_require__(25);
	var isSymbol = __webpack_require__(150);
	var getMethod = __webpack_require__(116);
	var ordinaryToPrimitive = __webpack_require__(682);
	var wellKnownSymbol = __webpack_require__(27);
	
	var $TypeError = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	
	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	module.exports = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw new $TypeError("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var speciesConstructor = __webpack_require__(191);
	
	var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
	var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
	
	// a part of `TypedArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#typedarray-species-create
	module.exports = function (originalArray) {
	  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
	};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var wellKnownSymbol = __webpack_require__(27);
	var DESCRIPTORS = __webpack_require__(14);
	var IS_PURE = __webpack_require__(43);
	
	var ITERATOR = wellKnownSymbol('iterator');
	
	module.exports = !fails(function () {
	  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
	  var url = new URL('b?a=1&b=2&c=3', 'https://a');
	  var params = url.searchParams;
	  var params2 = new URLSearchParams('a=1&a=2&b=3');
	  var result = '';
	  url.pathname = 'c%20d';
	  params.forEach(function (value, key) {
	    params['delete']('b');
	    result += key + value;
	  });
	  params2['delete']('a', 2);
	  // `undefined` case is a Chromium 117 bug
	  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
	  params2['delete']('b', undefined);
	  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
	    || (!params.size && (IS_PURE || !DESCRIPTORS))
	    || !params.sort
	    || url.href !== 'https://a/c%20d?a=1&c=3'
	    || params.get('c') !== '3'
	    || String(new URLSearchParams('?a=1')) !== 'a=1'
	    || !params[ITERATOR]
	    // throws in Edge
	    || new URL('https://a@b').username !== 'a'
	    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
	    // not punycoded in Edge
	    || new URL('https://тест').host !== 'xn--e1aybc'
	    // not escaped in Chrome 62-
	    || new URL('https://a#б').hash !== '#%D0%B1'
	    // fails in Chrome 66-
	    || result !== 'a1c3'
	    // throws in Safari
	    || new URL('https://x', undefined).host !== 'x';
	});


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	// a string of all valid unicode whitespaces
	module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
	  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIndexedObject = __webpack_require__(51);
	var addToUnscopables = __webpack_require__(63);
	var Iterators = __webpack_require__(234);
	var InternalStateModule = __webpack_require__(49);
	var defineProperty = __webpack_require__(42).f;
	var defineIterator = __webpack_require__(409);
	var createIterResultObject = __webpack_require__(228);
	var IS_PURE = __webpack_require__(43);
	var DESCRIPTORS = __webpack_require__(14);
	
	var ARRAY_ITERATOR = 'Array Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
	
	// `Array.prototype.entries` method
	// https://tc39.es/ecma262/#sec-array.prototype.entries
	// `Array.prototype.keys` method
	// https://tc39.es/ecma262/#sec-array.prototype.keys
	// `Array.prototype.values` method
	// https://tc39.es/ecma262/#sec-array.prototype.values
	// `Array.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
	// `CreateArrayIterator` internal method
	// https://tc39.es/ecma262/#sec-createarrayiterator
	module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
	  setInternalState(this, {
	    type: ARRAY_ITERATOR,
	    target: toIndexedObject(iterated), // target
	    index: 0,                          // next index
	    kind: kind                         // kind
	  });
	// `%ArrayIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
	}, function () {
	  var state = getInternalState(this);
	  var target = state.target;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = null;
	    return createIterResultObject(undefined, true);
	  }
	  switch (state.kind) {
	    case 'keys': return createIterResultObject(index, false);
	    case 'values': return createIterResultObject(target[index], false);
	  } return createIterResultObject([index, target[index]], false);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values%
	// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
	// https://tc39.es/ecma262/#sec-createmappedargumentsobject
	var values = Iterators.Arguments = Iterators.Array;
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	// V8 ~ Chrome 45- bug
	if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
	  defineProperty(values, 'name', { value: 'values' });
	} catch (error) { /* empty */ }


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"templateBasicStyleAuto":"_2MnSaSKdN-wnPlXpfqFgH8","withPointer":"Gc4w6R8S83SPu29vpAQhw","modal":"_3eI7aWa5KWo3P331zon_9C","title":"_1VGxzivZoT5qhK_aiZcJ8H","contentWrapper":"_2CzTP9teJ7866b2eQD_DQ_","content":"gROa6ERtRc4DPIWOH-B4B","noMarginBottom":"NsOLRalg_QvmCn1SRv4it","multiLanguageTabContent":"_23U7LvzNbyJuVU4LfIvVoE","formGroup":"_1bBf_pjyCnFKgFMEo7ioJF","signature":"_29gdmYl1vVI5rn5qpEFxGk","errorMessage":"YNwnRVxyUsJIu7CW8JpXS","inARow":"Cvox4nyWAIEnaPjobfhgU","formLabel":"_1qWINkilTPaR7ayeqZbU-1","formInput":"_1ooZ_Bd-vDrXcgiRfGAHPv","noMarginRight":"Y60njkepFqA-AJZQ8Xjz2","negativeMarginOne":"ZL3w3fMlUQv_dbMuo-sWr","marginPlusOne":"_3QWc8P9yo85L6Y3U0PAzf","sizeL":"_37WNhy1iSYXrTGU_Ed464y","sizeM":"_220WiSGV610xqi0zJkFjr7","sizeS":"_3xOp0BBGYgM4OqNQu7KPY3","sizeMS":"_1qPYmfsBTb-T0uVyhluf-A","sizeXS":"_1Otc1HscZsbmOZUM-MmgOB","visibleNone":"_3davtrNi1OatWZVBPYEKcf","marginBottomS":"of-OQTtvHvs7-YuMPArrR","formInputText":"_1vHU1fXmSaIUfElFaO760O","recipientContainer":"_1FIKRpcE5j1pPsOZUv04z1","recipientButtonsLabel":"_3wJl8YmNDg4OKV5JTrnUek","recipientButtonsContainer":"EL8vYeRhxVH2SQNOd84TA","recipientButton":"_1x5J815MfKLkUUHQ6IVH3N","variablesContainer":"Z72dEd2tfunQA_hvvU32-","variableTab":"_2kflRPu9bFto44ruwKP8sD","languageRow":"_1efyP6dAyx6s6UvARsihSs","languageRowActive":"afD2BH9FLeIcNR3fsrI0z","languageRowTopLine":"_3_f3NVMK4qf6bl9FEI45_n","select":"_3OnkIM_xENLne1c_XZVrDx","buttons":"_1UprZ5wSs5c3m9VJa2R9Wd","enabled":"_1Zh64cOIkCkvXhOvslIZAZ","next":"_1hrcrOaR3eL5xeJFq1BGHA","disabled":"_1ZA4m6crSI7Aagqrc4Ipe9","cancelButton":"_1RH_wedGCVoUajKhCwd8nh","attachmentsFormGroup":"_1ibSq8-a7ZNAvAAXUS_tZZ","noAttachmentText":"_2AnV5vGzGe0exzWuHoLZl2","clientRecipientPrivacyStatementText":"vpIPCmTMBWG7DJWTLXK8u","leftRightAlign":"Y3FZDDgyvhK4VTgkKEGKV","attachmentsContainer":"_3wWMMCqMyDr6Vuui_AhA_T","attachHeader":"_1RC8ay8RoR2_YFS6fuHOXQ","attachRowsContainer":"_1jSLXNWGB_S34F_PmKFpz-","attachRow":"_3lL-hpUOwjqKkflLhnOTGQ","icon":"_3OemoF5ORV7Tblh89F2OFZ","fileName":"ORyjICXO9UCKlg7i3ohe0","fileNameInput":"_2IAEx0Fw035S92ZAUJesgW","date":"_3jjBW_XkBTFZlkOd9DmQoy","operation":"_1mjxI4QS8VQVrgbJTkXLXu","hardAttachments":"_224u6mY9HtR8keryOMaQDv","attachRowError":"_3OEb0jEQI5BZJasmn6gxIA","grayButton":"_3qzE5ahqVz1DgmPdvXj1jv","emailButton":"_2sUKE66LygZnzj3h8Ct2MK","emailButtonIcon":"_3GIrF6OMH38MKXFUPnpD76","emailButtonNoLabelIcon":"rTw-aRd1I18ZJ5ciF4CtY","downArrowHolder":"H8rRZV8sEebL79JLd7tjS","downArrow":"_3_DNAwaBpUbJ8jQ-jTrtlB","creatableSelectInput":"jjN6Bj_EOhunsSFGhceBy","creatableOptionContainer":"y-cAFEg_XXK3waBEeQ06I","creatableOptionItem":"_1dG_EAmdxMJ3ZGutEuVDa3","elementsInRow":"_3LLM16OgdLxHQac5qHb6SV","ccSpan":"HSzoRYx7eAj7vKPd_yiCI","selectValueContainerSingle":"sPIEotx7PjeQIfDUnmQbM","composeRecipients":"_9SXfVtHSFIQV_Gi4x6Gjf","selectValueContainer":"_39VLNDOoaXoBkeggAq0Xve","ccButtonHolder":"NmQquLNI3c7r-Nqfi2Wjg","ccButtonInSelect":"_2V2okJGtW7-io2iD6MIznG","iconTextOrganizer":"_1YTlBkZxQIrmxtk2z6IkEj","buttonIcon":"_2g3BUMM2DmU0sxwCQH4L1K","buttonText":"_1GInq_TQ0FcnRK8lBGI-Sh"};

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"buttonsContainer":"_1pkorn66j_hGHXujIHZrtm","enabled":"_375vTmPWWKIVIF9i4aUl3v","greyButton":"_3gl_VGsjMTvDPBkqd8Kxp6","buttons":"_1pQXVsZtm66NmZUbP9mCPE","next":"_36EHudBHB9XSJ6T-QnCwpX","contactForm":"_3Y20ULr0mSoaazgapuwHHd","inputRow":"_3FwCl1GItFD2b80XSB00fs","little":"_2nANmtoeZpnmorraE1GndV","half":"x6h_3N73f0LoZupzKrzEs","full":"_3qbX74KnmE-ivuPEpgdqRy","contactInput":"_1lf1at5SvXphhkaxXEaUzy","gemPostcode":"_2DjuRH8btV_b4oY7vprfKg","error":"_3I0Wl4EvvVhqOccO6_XsxZ","longInput":"_2rfuFx70Nr_z1RGzDQd2o2","shortSelect":"_3cDe5PtlHqC-3YTJpErQKi","addressWrapper":"_3CGHj-lK1X4HVpurtbisX4","addressInfo":"_2EpyhfjKJq7viYJ3hQzbx1"};

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_3bIM4VPP7ECKBNClJ74Eem","uploadsContainer":"_3H07UBcDC_NibPbBYzgXTS","uploadButton":"_34JYc8unzSlWt4dbkrmi3S","iconContainer":"_2U3qCwuLQEMMsbTPZJUkL3","reactable-pagination":"_161yD9b_FZ0vEnBWNTIPqr","documentTypeCol":"_8VxOeB54Hwnu7X1I3w5qt","userComment":"_3rgmTjdbsgsIw7ABGzKOTM","documentRowHolder":"dPlZPXOu0eiQT9X1wPXp4","documentType":"_2yE3RHNFLT2uPwjORPIiBp","collapseFiles":"_2PjM0tUYGMjAwBOzjzcHlv","modal":"_3IL6Cmu8jATHMEOKC7FD1g","title":"_1hKUHiiYhdrfd9jLGWS707","contentWrapper":"_2r03bp1zGG8w8JPyEnjuEP","tarificationDocumentsTitle":"_1K56zmyBLDQegztpP99v5N","tarificationDocumentListElem":"fLA2QI17GpNko7h47tkqq","tarificationDocumentListElemInput":"WiFypG2PTUDttaLf1UP8Y","tariffInputLabelWrapper":"_5PSW7F0h981z91kNiX6Ao","select":"SoZQlb6vr6YFTFNXHHZiB","buttons":"j9rzS219e74BUHT0Qe0fH","next":"_38bnMwnw1PLiQCVNbuqXPW","enabled":"_3-5sn1wbfJUS2k3O9gZim","dropZoneContainer":"NQfHUb6M5aXo3OGCKK0Lh","dropzone":"Cl9CoBbTtB9vbCKL_JyuP","documentsContainer":"_1lInS9Zm3zYuwhcQan0-nm","unprocessedDocumentsWrapper":"d9FAmC-MShTvKx1jpY1cx","uploadButtonsWrapper":"_3tTI4VAPol6PWrhgvsDyzK","docTypesContainer":"_3vofz7oYSKKVXGxjrSU4Of","fileForm":"_3snyvLIEUaN4A0TZ59AjQ2","dropType":"qdevriC0v5D8N5b6Uy2w5","dropTypeTitle":"_2bv1-pI6DOtm1F5BV-kA9G","minMaxFiles":"_14ovnUmpap9u6kmgdoynms","filesCount":"_5hKyRyX9Tv1viduG-7Odl","mandateDropZoneWrapper":"_2j064AidmAGjppQh3ph3D5","drag":"_35za6IMbazEVBDr-h0jQue","max":"_2AqIGs4TfCux9FI-M22jTz","dropzonePlaceholder":"_1qWlthYzWE9uMLNIskc4o","leftDropType":"_1SAHyHmoW1Ab8eRroYfxVF","dropzoneFiles":"_21_pUqFdwWmt774Ya8idO0","dropzoneFile":"_3QRYgtK2E4ZgxWYvNIn2LV","remove":"_3OffD7g7K5GIno8Vvs1OiM","preview":"tAzvzd9urxuTXlweMw6Ro","name":"p1HE7m7eUx7GFB3zJCVWw","date":"_1DQBBiBZqaXgCPf1e45q80","formInput":"cwmreqJtxwDmjsQYmcXzh","progressBarContainer":"_3UprOjzojWZmIZEGDLvdlK","virusDetected":"_3NC6uxQhACHw6k01Cjc7Bw","progressBar":"yCi7jOTVPXCLDMdL3ZCpB","errorContainer":"_3PBBKbbW92xFgtCwQnY2EC","uploadError":"QMVr8afGudUFBO9DYyUQT","commentWrapper":"_16BSmhtxm9_vRb9_TuK2V0","uploadComment":"_1gfw85h0ja7JuSFs03nmiU","uploadCommentTitle":"_1VGMYT7sLAwqZgoqV-VZCT","disabled":"_1-qX2_edABiCKrIWdou6aU","collapseFilesArrow":"_34yeAMdcfznp_LscuBteSw","arrowDown":"_2K0CyirW7zRvHiafOEP-Db","rowIcon":"_2Vuw40of508om31dVsZ8Fz","uploadCommentContainer":"_2zyKN4UlVNRcCQQwZ62UWX","icon":"_244S1vc5zBXYtDFA_jSF6L","documentMetaCol":"_2MkKHFFQ0Lm2yesSM0shmG","hiddenTd":"_3GjUrfKfSkN0ZR36LbrG4Y","onlyRow":"_1f9YBpCQVvj7shsYokGOH0","collapseContent":"_315oqZDyVbek6sYsKmfvbe","documents":"WSrXPItXBUWr6_Gk1_ovd","file":"H7_rgLZ33RzwC4uSusSUP"};

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"leftColumn":"kIOjPBSEwj41ch_AjgY0c","voidBorder":"RoWL3qW0_5XugxtX15lyc","newsItem":"_3mlmDK-GFB9P9bpl5obtjJ","newsTitle":"_22GImNk9UGTpHMt0WmPSkk","printIcon":"_3JBDTE8FPlXLLbpTAqC7ao","newsInfoDiv":"_2V1VSrGgmutb4Dp-QuIJON","date":"_2qayM_450KnwWLHel9n0EB","teaser":"_-oAQ0z8prK0FD88oy7DiO","newsCenter":"LraF09cjBOQ2VnEHYqozH","fixHeight":"_2g5OK2RIVqyQNyOeFYIuob","newsContainer":"gcr4o2lzq7-LzDRntroVo","title":"_1bJji0RVLhAeH6cdCtirAh","pubDate":"YtDTOcyK1iTgRn3Pn4cvJ","content":"_3STmjt35m-w7CRPuUICzSd","cta":"_18qXkq3_iztDiSKmBEF_kv","footer":"_1Sv1GGlVSZAkERqmR4gnWQ","division":"_8imO7mhmmE2d0jDZJxCys","linkList":"_3pFjhMIyPW-f6Ydg8BndgJ","overlayCont":"_20-DMKz2aAZGSTEG08bxGV","overlay":"QVAXO-xoNntYvmaix-nFv","divide":"rVm4YLecixA0_li3BaNW-","active":"_3FzrKr24IJytfsBqxkD4-u","first":"_1IV63gmAJZKG4Oy1rskagw","last":"_1tYXz397ifJ6zgozQW0stD","fixMobileContent":"_1XjWZ-wYa71dxJm8Vzc5Sz","fixMobilePadding":"_16GncqPOnD7E7mUDNt-mPX","extraClass":"m_Jtwx0fhDJFBdpMGEo73","contentWrapper":"_3yvFuw2R8ivtmmlHIIj07v"};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports = [{"zip":"1000","city":"Bruxelles"},{"zip":"1000","city":"Brussel"},{"zip":"1005","city":"Brusselse Hoofdstedelijke Raad"},{"zip":"1005","city":"Conseil Region Bruxelles-Capitale"},{"zip":"1005","city":"Ver.Verg.Gemeensch.Gemeensch.Comm."},{"zip":"1005","city":"Ass. Réun. Com. Communau. Commune"},{"zip":"1006","city":"Raad Vlaamse Gemeenschapscommissie"},{"zip":"1007","city":"Ass. Commiss. Communau. française"},{"zip":"1008","city":"Chambre des Représentants"},{"zip":"1008","city":"Kamer van Volksvertegenwoordigers"},{"zip":"1009","city":"Senat de Belgique"},{"zip":"1009","city":"Belgische Senaat"},{"zip":"1010","city":"Rijksadministratief Centrum"},{"zip":"1010","city":"Cité Administrative de l'Etat"},{"zip":"1011","city":"Vlaamse Raad - Vlaams Parlement"},{"zip":"1012","city":"Parlement de la Communauté française"},{"zip":"1020","city":"Brussel (Laken)"},{"zip":"1020","city":"Laeken (Bruxelles)"},{"zip":"1020","city":"Laken (Brussel)"},{"zip":"1020","city":"Bruxelles (Laeken)"},{"zip":"1030","city":"Bruxelles (Schaerbeek)"},{"zip":"1030","city":"Schaarbeek"},{"zip":"1030","city":"Schaerbeek"},{"zip":"1030","city":"Brussel (Schaarbeek)"},{"zip":"1031","city":"Organisations Sociales Chrétiennes"},{"zip":"1031","city":"Christelijke Sociale Organisaties"},{"zip":"1035","city":"Ministere Region Bruxelles-Capital"},{"zip":"1035","city":"Ministerie Brussels Hoofdst. Gewest"},{"zip":"1040","city":"Etterbeek"},{"zip":"1040","city":"Bruxelles (Etterbeek)"},{"zip":"1040","city":"Brussel (Etterbeek)"},{"zip":"1041","city":"International Press Center"},{"zip":"1043","city":"VRT"},{"zip":"1044","city":"RTBF"},{"zip":"1045","city":"D.I.V."},{"zip":"1047","city":"Parlement Européen"},{"zip":"1047","city":"Europees Parlement"},{"zip":"1048","city":"E.U.-Raad"},{"zip":"1048","city":"U.E.-Conseil"},{"zip":"1049","city":"E.U.-Commissie"},{"zip":"1049","city":"U.E.-Commission"},{"zip":"1050","city":"Brussel (Elsene)"},{"zip":"1050","city":"Ixelles"},{"zip":"1050","city":"Bruxelles (Ixelles)"},{"zip":"1050","city":"Elsene"},{"zip":"1060","city":"Saint-Gilles"},{"zip":"1060","city":"Sint-Gillis"},{"zip":"1060","city":"Brussel (Sint-Gillis)"},{"zip":"1060","city":"Bruxelles (Saint-Gilles)"},{"zip":"1070","city":"Anderlecht"},{"zip":"1070","city":"Brussel (Anderlecht)"},{"zip":"1070","city":"Bruxelles (Anderlecht)"},{"zip":"1080","city":"Bruxelles (Molenbeek-Saint-Jean)"},{"zip":"1080","city":"Molenbeek-Saint-Jean"},{"zip":"1080","city":"Brussel (Sint-Jans-Molenbeek)"},{"zip":"1080","city":"Sint-Jans-Molenbeek"},{"zip":"1081","city":"Brussel (Koekelberg)"},{"zip":"1081","city":"Bruxelles (Koekelberg)"},{"zip":"1081","city":"Koekelberg"},{"zip":"1082","city":"Sint-Agatha-Berchem"},{"zip":"1082","city":"Berchem-Sainte-Agathe"},{"zip":"1082","city":"Brussel (Sint-Agatha-Berchem)"},{"zip":"1082","city":"Bruxelles (Berchem-Sainte-Agathe)"},{"zip":"1083","city":"Brussel (Ganshoren)"},{"zip":"1083","city":"Ganshoren"},{"zip":"1083","city":"Bruxelles (Ganshoren)"},{"zip":"1090","city":"Brussel (Jette)"},{"zip":"1090","city":"Jette"},{"zip":"1090","city":"Bruxelles (Jette)"},{"zip":"1100","city":"Postcheque"},{"zip":"1105","city":"SOC"},{"zip":"1110","city":"NAVO - NATO"},{"zip":"1110","city":"OTAN - NATO"},{"zip":"1120","city":"Brussel (Neder-Over-Heembeek)"},{"zip":"1120","city":"Bruxelles (Neder-Over-Heembeek)"},{"zip":"1120","city":"Neder-Over-Heembeek (Bru.)"},{"zip":"1130","city":"Haren (Brussel)"},{"zip":"1130","city":"Haren (Bruxelles)"},{"zip":"1130","city":"Bruxelles (Haeren)"},{"zip":"1130","city":"Brussel (Haren)"},{"zip":"1140","city":"Bruxelles (Evere)"},{"zip":"1140","city":"Evere"},{"zip":"1140","city":"Brussel (Evere)"},{"zip":"1150","city":"Woluwe-Saint-Pierre"},{"zip":"1150","city":"Bruxelles (Woluwe-Saint-Pierre)"},{"zip":"1150","city":"Brussel (Sint-Pieters-Woluwe)"},{"zip":"1150","city":"Sint-Pieters-Woluwe"},{"zip":"1160","city":"Auderghem"},{"zip":"1160","city":"Brussel (Oudergem)"},{"zip":"1160","city":"Bruxelles (Auderghem)"},{"zip":"1160","city":"Oudergem"},{"zip":"1170","city":"Brussel (Watermaal-Bosvoorde)"},{"zip":"1170","city":"Watermael-Boitsfort"},{"zip":"1170","city":"Watermaal-Bosvoorde"},{"zip":"1170","city":"Bruxelles (Watermael-Boitsfort)"},{"zip":"1180","city":"Ukkel"},{"zip":"1180","city":"Uccle"},{"zip":"1180","city":"Bruxelles (Uccle)"},{"zip":"1180","city":"Brussel (Ukkel)"},{"zip":"1190","city":"Forest"},{"zip":"1190","city":"Vorst"},{"zip":"1190","city":"Bruxelles (Forest)"},{"zip":"1190","city":"Brussel (Vorst)"},{"zip":"1200","city":"Bruxelles (Woluwe-Saint-Lambert)"},{"zip":"1200","city":"Brussel (Sint-Lambrechts-Woluwe)"},{"zip":"1200","city":"Sint-Lambrechts-Woluwe"},{"zip":"1200","city":"Woluwe-Saint-Lambert"},{"zip":"1201","city":"R.T.L. - T.V.I."},{"zip":"1210","city":"Sint-Joost-ten-Node"},{"zip":"1210","city":"Bruxelles (Saint-Josse-ten-Noode)"},{"zip":"1210","city":"Saint-Josse-ten-Noode"},{"zip":"1210","city":"Brussel (Sint-Joost-ten-Node)"},{"zip":"1212","city":"FOD Mobiliteit"},{"zip":"1212","city":"SPF Mobilité"},{"zip":"1300","city":"Limal"},{"zip":"1300","city":"Wavre"},{"zip":"1301","city":"Bierges"},{"zip":"1310","city":"La Hulpe"},{"zip":"1315","city":"Glimes"},{"zip":"1315","city":"Piètrebais"},{"zip":"1315","city":"Incourt"},{"zip":"1315","city":"Opprebais"},{"zip":"1315","city":"Roux-Miroir"},{"zip":"1320","city":"Nodebais"},{"zip":"1320","city":"Hamme-Mille"},{"zip":"1320","city":"l'Ecluse"},{"zip":"1320","city":"Beauvechain"},{"zip":"1320","city":"Tourinnes-la-Grosse"},{"zip":"1325","city":"Dion-Valmont"},{"zip":"1325","city":"Longueville"},{"zip":"1325","city":"Corroy-le-Grand"},{"zip":"1325","city":"Bonlez"},{"zip":"1325","city":"Chaumont-Gistoux"},{"zip":"1330","city":"Rixensart"},{"zip":"1331","city":"Rosières"},{"zip":"1332","city":"Genval"},{"zip":"1340","city":"Ottignies"},{"zip":"1340","city":"Ottignies-Louvain-la-Neuve"},{"zip":"1341","city":"Céroux-Mousty"},{"zip":"1342","city":"Limelette"},{"zip":"1348","city":"Louvain-la-Neuve"},{"zip":"1350","city":"Noduwez"},{"zip":"1350","city":"Folx-les-Caves"},{"zip":"1350","city":"Orp-Jauche"},{"zip":"1350","city":"Orp-le-Grand"},{"zip":"1350","city":"Marilles"},{"zip":"1350","city":"Jauche"},{"zip":"1350","city":"Jandrain-Jandrenouille"},{"zip":"1350","city":"Enines"},{"zip":"1357","city":"Opheylissem"},{"zip":"1357","city":"Linsmeau"},{"zip":"1357","city":"Hélécine"},{"zip":"1357","city":"Neerheylissem"},{"zip":"1360","city":"Malèves-Sainte-Marie-Wastines"},{"zip":"1360","city":"Thorembais-les-Béguines"},{"zip":"1360","city":"Thorembais-Saint-Trond"},{"zip":"1360","city":"Orbais"},{"zip":"1360","city":"Perwez"},{"zip":"1367","city":"Geest-Gérompont-Petit-Rosière"},{"zip":"1367","city":"Bomal (Bt.)"},{"zip":"1367","city":"Mont-Saint-André"},{"zip":"1367","city":"Ramillies"},{"zip":"1367","city":"Grand-Rosière-Hottomont"},{"zip":"1367","city":"Huppaye"},{"zip":"1367","city":"Autre-Eglise"},{"zip":"1367","city":"Gérompont"},{"zip":"1370","city":"Saint-Jean-Geest"},{"zip":"1370","city":"Saint-Remy-Geest"},{"zip":"1370","city":"Jauchelette"},{"zip":"1370","city":"Zétrud-Lumay"},{"zip":"1370","city":"Jodoigne-Souveraine"},{"zip":"1370","city":"Piétrain"},{"zip":"1370","city":"Dongelberg"},{"zip":"1370","city":"Jodoigne"},{"zip":"1370","city":"Lathuy"},{"zip":"1370","city":"Mélin"},{"zip":"1380","city":"Maransart"},{"zip":"1380","city":"Ohain"},{"zip":"1380","city":"Plancenoit"},{"zip":"1380","city":"Lasne"},{"zip":"1380","city":"Lasne-Chapelle-Saint-Lambert"},{"zip":"1380","city":"Couture-Saint-Germain"},{"zip":"1390","city":"Bossut-Gottechain"},{"zip":"1390","city":"Nethen"},{"zip":"1390","city":"Archennes"},{"zip":"1390","city":"Grez-Doiceau"},{"zip":"1390","city":"Biez"},{"zip":"1400","city":"Nivelles"},{"zip":"1400","city":"Monstreux"},{"zip":"1401","city":"Baulers"},{"zip":"1402","city":"Thines"},{"zip":"1404","city":"Bornival"},{"zip":"1410","city":"Waterloo"},{"zip":"1414","city":"Promo-Control"},{"zip":"1420","city":"Braine-l'Alleud"},{"zip":"1421","city":"Ophain-Bois-Seigneur-Isaac"},{"zip":"1428","city":"Lillois-Witterzée"},{"zip":"1430","city":"Rebecq"},{"zip":"1430","city":"Bierghes"},{"zip":"1430","city":"Quenast"},{"zip":"1430","city":"Rebecq-Rognon"},{"zip":"1435","city":"Mont-Saint-Guibert"},{"zip":"1435","city":"Corbais"},{"zip":"1435","city":"Hévillers"},{"zip":"1440","city":"Braine-le-Château"},{"zip":"1440","city":"Wauthier-Braine"},{"zip":"1450","city":"Gentinnes"},{"zip":"1450","city":"Saint-Géry"},{"zip":"1450","city":"Chastre-Villeroux-Blanmont"},{"zip":"1450","city":"Cortil-Noirmont"},{"zip":"1450","city":"Chastre"},{"zip":"1457","city":"Tourinnes-Saint-Lambert"},{"zip":"1457","city":"Walhain"},{"zip":"1457","city":"Nil-Saint-Vincent-Saint-Martin"},{"zip":"1457","city":"Walhain-Saint-Paul"},{"zip":"1460","city":"Ittre"},{"zip":"1460","city":"Virginal-Samme"},{"zip":"1461","city":"Haut-Ittre"},{"zip":"1470","city":"Genappe"},{"zip":"1470","city":"Bousval"},{"zip":"1470","city":"Baisy-Thy"},{"zip":"1471","city":"Loupoigne"},{"zip":"1472","city":"GENAPPE"},{"zip":"1472","city":"Vieux-Genappe"},{"zip":"1473","city":"Glabais"},{"zip":"1474","city":"Ways"},{"zip":"1476","city":"Houtain-le-Val"},{"zip":"1480","city":"Oisquercq"},{"zip":"1480","city":"Saintes"},{"zip":"1480","city":"Clabecq"},{"zip":"1480","city":"Tubize"},{"zip":"1490","city":"Court-Saint-Etienne"},{"zip":"1495","city":"Tilly"},{"zip":"1495","city":"Mellery"},{"zip":"1495","city":"Sart-Dames-Avelines"},{"zip":"1495","city":"Marbais (Bt.)"},{"zip":"1495","city":"Villers-la-Ville"},{"zip":"1500","city":"Halle"},{"zip":"1501","city":"Buizingen"},{"zip":"1502","city":"Lembeek"},{"zip":"1540","city":"Pajottegem(Herfelingen)"},{"zip":"1540","city":"Pajottegem(Herne)"},{"zip":"1541","city":"Sint-Pieters-Kapelle (Bt.)"},{"zip":"1547","city":"Bever"},{"zip":"1547","city":"Bievene"},{"zip":"1560","city":"Hoeilaart"},{"zip":"1570","city":"Pajottegem(Vollezele)"},{"zip":"1570","city":"Pajottegem(Galmaarden)"},{"zip":"1570","city":"Pajottegem(Tollembeek)"},{"zip":"1600","city":"Oudenaken"},{"zip":"1600","city":"Sint-Laureins-Berchem"},{"zip":"1600","city":"Sint-Pieters-Leeuw"},{"zip":"1601","city":"Ruisbroek (Bt.)"},{"zip":"1602","city":"Vlezenbeek"},{"zip":"1620","city":"Drogenbos"},{"zip":"1630","city":"Linkebeek"},{"zip":"1640","city":"Rhode-Saint-Genese"},{"zip":"1640","city":"Sint-Genesius-Rode"},{"zip":"1650","city":"Beersel"},{"zip":"1651","city":"Lot"},{"zip":"1652","city":"Alsemberg"},{"zip":"1653","city":"Dworp"},{"zip":"1654","city":"Huizingen"},{"zip":"1670","city":"Pepingen"},{"zip":"1670","city":"Bogaarden"},{"zip":"1670","city":"Heikruis"},{"zip":"1671","city":"Elingen"},{"zip":"1673","city":"Beert"},{"zip":"1674","city":"Bellingen"},{"zip":"1700","city":"Sint-Martens-Bodegem"},{"zip":"1700","city":"Sint-Ulriks-Kapelle"},{"zip":"1700","city":"Dilbeek"},{"zip":"1701","city":"Itterbeek"},{"zip":"1702","city":"Groot-Bijgaarden"},{"zip":"1703","city":"Schepdaal"},{"zip":"1730","city":"Kobbegem"},{"zip":"1730","city":"Mollem"},{"zip":"1730","city":"Asse"},{"zip":"1730","city":"Bekkerzeel"},{"zip":"1731","city":"Zellik"},{"zip":"1731","city":"Relegem"},{"zip":"1740","city":"Ternat"},{"zip":"1741","city":"Wambeek"},{"zip":"1742","city":"Sint-Katherina-Lombeek"},{"zip":"1745","city":"Opwijk"},{"zip":"1745","city":"Mazenzele"},{"zip":"1750","city":"Sint-Martens-Lennik"},{"zip":"1750","city":"Sint-Kwintens-Lennik"},{"zip":"1750","city":"Gaasbeek"},{"zip":"1750","city":"Lennik"},{"zip":"1755","city":"Pajottegem(Oetingen)"},{"zip":"1755","city":"Pajottegem(Leerbeek)"},{"zip":"1755","city":"Pajottegem(Gooik)"},{"zip":"1755","city":"Pajottegem(Kester)"},{"zip":"1760","city":"Pamel"},{"zip":"1760","city":"Strijtem"},{"zip":"1760","city":"Onze-Lieve-Vrouw-Lombeek"},{"zip":"1760","city":"Roosdaal"},{"zip":"1761","city":"Borchtlombeek"},{"zip":"1770","city":"Liedekerke"},{"zip":"1780","city":"Wemmel"},{"zip":"1785","city":"Hamme (Bt.)"},{"zip":"1785","city":"Brussegem"},{"zip":"1785","city":"Merchtem"},{"zip":"1790","city":"Affligem"},{"zip":"1790","city":"Teralfene"},{"zip":"1790","city":"Hekelgem"},{"zip":"1790","city":"Essene"},{"zip":"1800","city":"Peutie"},{"zip":"1800","city":"Vilvoorde"},{"zip":"1804","city":"Cargovil"},{"zip":"1818","city":"VTM"},{"zip":"1820","city":"Melsbroek"},{"zip":"1820","city":"Steenokkerzeel"},{"zip":"1820","city":"Perk"},{"zip":"1830","city":"Machelen (Bt.)"},{"zip":"1831","city":"Diegem"},{"zip":"1840","city":"Steenhuffel"},{"zip":"1840","city":"Malderen"},{"zip":"1840","city":"Londerzeel"},{"zip":"1850","city":"Grimbergen"},{"zip":"1851","city":"Humbeek"},{"zip":"1852","city":"Beigem"},{"zip":"1853","city":"Strombeek-Bever"},{"zip":"1860","city":"Meise"},{"zip":"1861","city":"Wolvertem"},{"zip":"1880","city":"Ramsdonk"},{"zip":"1880","city":"Kapelle-op-den-Bos"},{"zip":"1880","city":"Nieuwenrode"},{"zip":"1910","city":"Kampenhout"},{"zip":"1910","city":"Buken"},{"zip":"1910","city":"Berg (Bt.)"},{"zip":"1910","city":"Nederokkerzeel"},{"zip":"1930","city":"Nossegem"},{"zip":"1930","city":"Zaventem"},{"zip":"1930","city":"Alst"},{"zip":"1931","city":"Brucargo"},{"zip":"1932","city":"Sint-Stevens-Woluwe"},{"zip":"1933","city":"Sterrebeek"},{"zip":"1934","city":"Brussel X-Luchthaven Remailing"},{"zip":"1934","city":"Bruxelles X-Aeroport Remailing"},{"zip":"1950","city":"Kraainem"},{"zip":"1970","city":"Wezembeek-Oppem"},{"zip":"1980","city":"Zemst"},{"zip":"1980","city":"Eppegem"},{"zip":"1981","city":"Hofstade (Bt.)"},{"zip":"1982","city":"Elewijt"},{"zip":"1982","city":"Weerde"},{"zip":"2000","city":"Antwerpen"},{"zip":"2018","city":"Antwerpen"},{"zip":"2020","city":"Antwerpen"},{"zip":"2030","city":"Antwerpen"},{"zip":"2040","city":"Lillo"},{"zip":"2040","city":"Zandvliet"},{"zip":"2040","city":"Berendrecht"},{"zip":"2040","city":"Antwerpen"},{"zip":"2050","city":"Antwerpen"},{"zip":"2060","city":"Antwerpen"},{"zip":"2070","city":"Burcht"},{"zip":"2070","city":"Zwijndrecht"},{"zip":"2100","city":"Deurne (Antwerpen)"},{"zip":"2110","city":"Wijnegem"},{"zip":"2140","city":"Borgerhout (Antwerpen)"},{"zip":"2150","city":"Antwerpen(Borsbeek (Antw.))"},{"zip":"2160","city":"Wommelgem"},{"zip":"2170","city":"Merksem (Antwerpen)"},{"zip":"2180","city":"Ekeren (Antwerpen)"},{"zip":"2200","city":"Noorderwijk"},{"zip":"2200","city":"Herentals"},{"zip":"2200","city":"Morkhoven"},{"zip":"2220","city":"Hallaar"},{"zip":"2220","city":"Heist-op-den-Berg"},{"zip":"2221","city":"Booischot"},{"zip":"2222","city":"Wiekevorst"},{"zip":"2222","city":"Itegem"},{"zip":"2223","city":"Schriek"},{"zip":"2230","city":"Ramsel"},{"zip":"2230","city":"Herselt"},{"zip":"2235","city":"Westmeerbeek"},{"zip":"2235","city":"Houtvenne"},{"zip":"2235","city":"Hulshout"},{"zip":"2240","city":"Zandhoven"},{"zip":"2240","city":"Massenhoven"},{"zip":"2240","city":"Viersel"},{"zip":"2242","city":"Pulderbos"},{"zip":"2243","city":"Pulle"},{"zip":"2250","city":"Olen"},{"zip":"2260","city":"Oevel"},{"zip":"2260","city":"Zoerle-Parwijs"},{"zip":"2260","city":"Westerlo"},{"zip":"2260","city":"Tongerlo (Antw.)"},{"zip":"2270","city":"Herenthout"},{"zip":"2275","city":"Wechelderzande"},{"zip":"2275","city":"Poederlee"},{"zip":"2275","city":"Lille"},{"zip":"2275","city":"Gierle"},{"zip":"2280","city":"Grobbendonk"},{"zip":"2288","city":"Bouwel"},{"zip":"2290","city":"Vorselaar"},{"zip":"2300","city":"Turnhout"},{"zip":"2310","city":"Rijkevorsel"},{"zip":"2320","city":"Hoogstraten"},{"zip":"2321","city":"Meer"},{"zip":"2322","city":"Minderhout"},{"zip":"2323","city":"Wortel"},{"zip":"2328","city":"Meerle"},{"zip":"2330","city":"Merksplas"},{"zip":"2340","city":"Vlimmeren"},{"zip":"2340","city":"Beerse"},{"zip":"2350","city":"Vosselaar"},{"zip":"2360","city":"Oud-Turnhout"},{"zip":"2370","city":"Arendonk"},{"zip":"2380","city":"Ravels"},{"zip":"2381","city":"Weelde"},{"zip":"2382","city":"Poppel"},{"zip":"2387","city":"Baarle-Hertog"},{"zip":"2390","city":"Westmalle"},{"zip":"2390","city":"Malle"},{"zip":"2390","city":"Oostmalle"},{"zip":"2400","city":"Mol"},{"zip":"2430","city":"Vorst (Kempen)"},{"zip":"2430","city":"Laakdal"},{"zip":"2430","city":"Eindhout"},{"zip":"2431","city":"Veerle"},{"zip":"2431","city":"Varendonk"},{"zip":"2440","city":"Geel"},{"zip":"2450","city":"Meerhout"},{"zip":"2460","city":"Tielen"},{"zip":"2460","city":"Lichtaart"},{"zip":"2460","city":"Kasterlee"},{"zip":"2470","city":"Retie"},{"zip":"2480","city":"Dessel"},{"zip":"2490","city":"Balen"},{"zip":"2491","city":"Olmen"},{"zip":"2500","city":"Koningshooikt"},{"zip":"2500","city":"Lier"},{"zip":"2520","city":"Oelegem"},{"zip":"2520","city":"Broechem"},{"zip":"2520","city":"Emblem"},{"zip":"2520","city":"Ranst"},{"zip":"2530","city":"Boechout"},{"zip":"2531","city":"Vremde"},{"zip":"2540","city":"Hove"},{"zip":"2547","city":"Lint"},{"zip":"2550","city":"Waarloos"},{"zip":"2550","city":"Kontich"},{"zip":"2560","city":"Kessel"},{"zip":"2560","city":"Bevel"},{"zip":"2560","city":"Nijlen"},{"zip":"2570","city":"Duffel"},{"zip":"2580","city":"Putte"},{"zip":"2580","city":"Beerzel"},{"zip":"2590","city":"Berlaar"},{"zip":"2590","city":"Gestel"},{"zip":"2600","city":"Berchem (Antwerpen)"},{"zip":"2610","city":"Wilrijk (Antwerpen)"},{"zip":"2620","city":"Hemiksem"},{"zip":"2627","city":"Schelle"},{"zip":"2630","city":"Aartselaar"},{"zip":"2640","city":"Mortsel"},{"zip":"2650","city":"Edegem"},{"zip":"2660","city":"Hoboken (Antwerpen)"},{"zip":"2800","city":"Walem"},{"zip":"2800","city":"Mechelen"},{"zip":"2801","city":"Heffen"},{"zip":"2811","city":"Hombeek"},{"zip":"2811","city":"Leest"},{"zip":"2812","city":"Muizen (Mechelen)"},{"zip":"2820","city":"Bonheiden"},{"zip":"2820","city":"Rijmenam"},{"zip":"2830","city":"Tisselt"},{"zip":"2830","city":"Willebroek"},{"zip":"2830","city":"Blaasveld"},{"zip":"2830","city":"Heindonk"},{"zip":"2840","city":"Rumst"},{"zip":"2840","city":"Reet"},{"zip":"2840","city":"Terhagen"},{"zip":"2845","city":"Niel"},{"zip":"2850","city":"Boom"},{"zip":"2860","city":"Sint-Katelijne-Waver"},{"zip":"2861","city":"Onze-Lieve-Vrouw-Waver"},{"zip":"2870","city":"Ruisbroek (Antw.)"},{"zip":"2870","city":"Liezele"},{"zip":"2870","city":"Breendonk"},{"zip":"2870","city":"Puurs-Sint-Amands"},{"zip":"2880","city":"Hingene"},{"zip":"2880","city":"Mariekerke (Bornem)"},{"zip":"2880","city":"Weert"},{"zip":"2880","city":"Bornem"},{"zip":"2890","city":"Lippelo"},{"zip":"2890","city":"Oppuurs"},{"zip":"2890","city":"Puurs-Sint-Amands"},{"zip":"2900","city":"Schoten"},{"zip":"2910","city":"Essen"},{"zip":"2920","city":"Kalmthout"},{"zip":"2930","city":"Brasschaat"},{"zip":"2940","city":"Hoevenen"},{"zip":"2940","city":"Stabroek"},{"zip":"2950","city":"Kapellen (Antw.)"},{"zip":"2960","city":"Sint-Lenaarts"},{"zip":"2960","city":"Brecht"},{"zip":"2960","city":"Sint-Job-in-'t-Goor"},{"zip":"2970","city":"Schilde"},{"zip":"2970","city":"'s Gravenwezel"},{"zip":"2980","city":"Zoersel"},{"zip":"2980","city":"Halle (Kempen)"},{"zip":"2990","city":"Loenhout"},{"zip":"2990","city":"Wuustwezel"},{"zip":"3000","city":"Leuven"},{"zip":"3001","city":"Heverlee"},{"zip":"3010","city":"Kessel-Lo (Leuven)"},{"zip":"3012","city":"Wilsele"},{"zip":"3018","city":"Wijgmaal (Brabant)"},{"zip":"3020","city":"Veltem-Beisem"},{"zip":"3020","city":"Herent"},{"zip":"3020","city":"Winksele"},{"zip":"3040","city":"Neerijse"},{"zip":"3040","city":"Huldenberg"},{"zip":"3040","city":"Sint-Agatha-Rode"},{"zip":"3040","city":"Ottenburg"},{"zip":"3040","city":"Loonbeek"},{"zip":"3050","city":"Oud-Heverlee"},{"zip":"3051","city":"Sint-Joris-Weert"},{"zip":"3052","city":"Blanden"},{"zip":"3053","city":"Haasrode"},{"zip":"3054","city":"Vaalbeek"},{"zip":"3060","city":"Korbeek-Dijle"},{"zip":"3060","city":"Bertem"},{"zip":"3061","city":"Leefdaal"},{"zip":"3070","city":"Kortenberg"},{"zip":"3071","city":"Erps-Kwerps"},{"zip":"3078","city":"Everberg"},{"zip":"3078","city":"Meerbeek"},{"zip":"3080","city":"Tervuren"},{"zip":"3080","city":"Vossem"},{"zip":"3080","city":"Duisburg"},{"zip":"3090","city":"Overijse"},{"zip":"3110","city":"Rotselaar"},{"zip":"3111","city":"Wezemaal"},{"zip":"3118","city":"Werchter"},{"zip":"3120","city":"Tremelo"},{"zip":"3128","city":"Baal"},{"zip":"3130","city":"Betekom"},{"zip":"3130","city":"Begijnendijk"},{"zip":"3140","city":"Keerbergen"},{"zip":"3150","city":"Wespelaar"},{"zip":"3150","city":"Tildonk"},{"zip":"3150","city":"Haacht"},{"zip":"3190","city":"Boortmeerbeek"},{"zip":"3191","city":"Hever"},{"zip":"3195","city":"1 JUBAIL"},{"zip":"3200","city":"Aarschot"},{"zip":"3200","city":"Gelrode"},{"zip":"3201","city":"Langdorp"},{"zip":"3202","city":"Rillaar"},{"zip":"3210","city":"Linden"},{"zip":"3210","city":"Lubbeek"},{"zip":"3211","city":"Binkom"},{"zip":"3212","city":"Pellenberg"},{"zip":"3220","city":"Kortrijk-Dutsel"},{"zip":"3220","city":"Holsbeek"},{"zip":"3220","city":"Sint-Pieters-Rode"},{"zip":"3221","city":"Nieuwrode"},{"zip":"3270","city":"Scherpenheuvel-Zichem"},{"zip":"3270","city":"Scherpenheuvel"},{"zip":"3271","city":"Zichem"},{"zip":"3271","city":"Averbode"},{"zip":"3272","city":"Messelbroek"},{"zip":"3272","city":"Testelt"},{"zip":"3290","city":"Webbekom"},{"zip":"3290","city":"Schaffen"},{"zip":"3290","city":"Deurne (Bt.)"},{"zip":"3290","city":"Diest"},{"zip":"3293","city":"Kaggevinne"},{"zip":"3294","city":"Molenstede"},{"zip":"3300","city":"Goetsenhoven"},{"zip":"3300","city":"Bost"},{"zip":"3300","city":"Kumtich"},{"zip":"3300","city":"Hakendover"},{"zip":"3300","city":"Oorbeek"},{"zip":"3300","city":"Sint-Margriete-Houtem (Tienen)"},{"zip":"3300","city":"Tienen"},{"zip":"3300","city":"Oplinter"},{"zip":"3300","city":"Vissenaken"},{"zip":"3320","city":"Hoegaarden"},{"zip":"3320","city":"Meldert (Bt.)"},{"zip":"3321","city":"Outgaarden"},{"zip":"3350","city":"Drieslinter"},{"zip":"3350","city":"Neerhespen"},{"zip":"3350","city":"Neerlinter"},{"zip":"3350","city":"Linter"},{"zip":"3350","city":"Orsmaal-Gussenhoven"},{"zip":"3350","city":"Overhespen"},{"zip":"3350","city":"Wommersom"},{"zip":"3350","city":"Melkwezer"},{"zip":"3360","city":"Opvelp"},{"zip":"3360","city":"Korbeek-Lo"},{"zip":"3360","city":"Bierbeek"},{"zip":"3360","city":"Lovenjoel"},{"zip":"3370","city":"Kerkom"},{"zip":"3370","city":"Willebringen"},{"zip":"3370","city":"Vertrijk"},{"zip":"3370","city":"Neervelp"},{"zip":"3370","city":"Roosbeek"},{"zip":"3370","city":"Boutersem"},{"zip":"3380","city":"Bunsbeek"},{"zip":"3380","city":"Glabbeek-Zuurbemde"},{"zip":"3381","city":"Kapellen (Bt.)"},{"zip":"3384","city":"Attenrode"},{"zip":"3390","city":"Sint-Joris-Winge"},{"zip":"3390","city":"Tielt (Bt.)"},{"zip":"3390","city":"Tielt-Winge"},{"zip":"3390","city":"Houwaart"},{"zip":"3391","city":"Meensel-Kiezegem"},{"zip":"3400","city":"Wange"},{"zip":"3400","city":"Laar"},{"zip":"3400","city":"Overwinden"},{"zip":"3400","city":"Eliksem"},{"zip":"3400","city":"Neerwinden"},{"zip":"3400","city":"Landen"},{"zip":"3400","city":"Ezemaal"},{"zip":"3400","city":"Rumsdorp"},{"zip":"3401","city":"Walshoutem"},{"zip":"3401","city":"Walsbets"},{"zip":"3401","city":"Waasmont"},{"zip":"3401","city":"Wezeren"},{"zip":"3404","city":"Neerlanden"},{"zip":"3404","city":"Attenhoven"},{"zip":"3440","city":"Helen-Bos"},{"zip":"3440","city":"Zoutleeuw"},{"zip":"3440","city":"Budingen"},{"zip":"3440","city":"Dormaal"},{"zip":"3440","city":"Halle-Booienhoven"},{"zip":"3450","city":"Grazen"},{"zip":"3450","city":"Geetbets"},{"zip":"3454","city":"Rummen"},{"zip":"3460","city":"Assent"},{"zip":"3460","city":"Bekkevoort"},{"zip":"3461","city":"Molenbeek-Wersbeek"},{"zip":"3470","city":"Ransberg"},{"zip":"3470","city":"Kortenaken"},{"zip":"3471","city":"Hoeleden"},{"zip":"3472","city":"Kersbeek-Miskom"},{"zip":"3473","city":"Waanrode"},{"zip":"3500","city":"Hasselt(Hasselt)"},{"zip":"3500","city":"Hasselt(St-Lambrechts-Herk)"},{"zip":"3501","city":"Wimmertingen"},{"zip":"3510","city":"Kermt (Hasselt)"},{"zip":"3510","city":"Spalbeek"},{"zip":"3511","city":"Kuringen"},{"zip":"3511","city":"Stokrooie"},{"zip":"3512","city":"Stevoort"},{"zip":"3520","city":"Zonhoven"},{"zip":"3530","city":"Houthalen"},{"zip":"3530","city":"Houthalen-Helchteren"},{"zip":"3530","city":"Helchteren"},{"zip":"3540","city":"Berbroek"},{"zip":"3540","city":"Herk-de-Stad"},{"zip":"3540","city":"Donk"},{"zip":"3540","city":"Schulen"},{"zip":"3545","city":"Zelem"},{"zip":"3545","city":"Halen"},{"zip":"3545","city":"Loksbergen"},{"zip":"3550","city":"Zolder"},{"zip":"3550","city":"Heusden (Limb.)"},{"zip":"3550","city":"Heusden-Zolder"},{"zip":"3560","city":"Meldert (Limb.)"},{"zip":"3560","city":"Lummen"},{"zip":"3560","city":"Linkhout"},{"zip":"3570","city":"Alken"},{"zip":"3580","city":"Beringen"},{"zip":"3581","city":"Beverlo"},{"zip":"3582","city":"Koersel"},{"zip":"3583","city":"Paal"},{"zip":"3590","city":"Diepenbeek"},{"zip":"3600","city":"Genk"},{"zip":"3620","city":"Gellik"},{"zip":"3620","city":"Veldwezelt"},{"zip":"3620","city":"Neerharen"},{"zip":"3620","city":"Lanaken"},{"zip":"3621","city":"Rekem"},{"zip":"3630","city":"Opgrimbie"},{"zip":"3630","city":"Maasmechelen"},{"zip":"3630","city":"Vucht"},{"zip":"3630","city":"Mechelen-aan-de-Maas"},{"zip":"3630","city":"Meeswijk"},{"zip":"3630","city":"Leut"},{"zip":"3630","city":"Eisden"},{"zip":"3631","city":"Uikhoven"},{"zip":"3631","city":"Boorsem"},{"zip":"3640","city":"Molenbeersel"},{"zip":"3640","city":"Kessenich"},{"zip":"3640","city":"Kinrooi"},{"zip":"3640","city":"Ophoven"},{"zip":"3650","city":"Rotem"},{"zip":"3650","city":"Elen"},{"zip":"3650","city":"Stokkem"},{"zip":"3650","city":"Dilsen-Stokkem"},{"zip":"3650","city":"Lanklaar"},{"zip":"3660","city":"Oudsbergen"},{"zip":"3665","city":"As"},{"zip":"3668","city":"Niel-bij-As"},{"zip":"3670","city":"Oudsbergen"},{"zip":"3670","city":"Ellikom"},{"zip":"3670","city":"Neerglabbeek"},{"zip":"3670","city":"Gruitrode"},{"zip":"3670","city":"Meeuwen"},{"zip":"3670","city":"Wijshagen"},{"zip":"3680","city":"Maaseik"},{"zip":"3680","city":"Opoeteren"},{"zip":"3680","city":"Neeroeteren"},{"zip":"3690","city":"Zutendaal"},{"zip":"3700","city":"Tongeren-Borgloon(Kolmont (Tongeren))"},{"zip":"3700","city":"Tongeren-Borgloon(Koninksem)"},{"zip":"3700","city":"Tongeren-Borgloon(Diets-Heur)"},{"zip":"3700","city":"Tongeren-Borgloon(Mal)"},{"zip":"3700","city":"Tongeren-Borgloon('S Herenelderen)"},{"zip":"3700","city":"Tongeren-Borgloon(Lauw)"},{"zip":"3700","city":"Tongeren-Borgloon(Rutten)"},{"zip":"3700","city":"Tongeren-Borgloon(Sluizen)"},{"zip":"3700","city":"Tongeren-Borgloon(Berg (Limb.))"},{"zip":"3700","city":"Tongeren-Borgloon(Riksingen)"},{"zip":"3700","city":"Tongeren-Borgloon(Henis)"},{"zip":"3700","city":"Tongeren-Borgloon(Widooie)"},{"zip":"3700","city":"Tongeren-Borgloon(Neerrepen)"},{"zip":"3700","city":"Tongeren-Borgloon(Nerem)"},{"zip":"3700","city":"Tongeren-Borgloon(Tongeren)"},{"zip":"3700","city":"Tongeren-Borgloon(Vreren)"},{"zip":"3700","city":"Tongeren-Borgloon(Haren (Tongeren))"},{"zip":"3700","city":"Tongeren-Borgloon(Piringen)"},{"zip":"3700","city":"Tongeren-Borgloon(Overrepen)"},{"zip":"3717","city":"Herstappe"},{"zip":"3720","city":"Hasselt(Kortessem)"},{"zip":"3721","city":"Vliermaalroot"},{"zip":"3722","city":"Wintershoven"},{"zip":"3723","city":"Guigoven"},{"zip":"3724","city":"Vliermaal"},{"zip":"3730","city":"Bilzen-Hoeselt(St-Huibrechts-Hern)"},{"zip":"3730","city":"Bilzen-Hoeselt(Romershoven)"},{"zip":"3730","city":"Bilzen-Hoeselt(Werm)"},{"zip":"3730","city":"Bilzen-Hoeselt(Hoeselt)"},{"zip":"3732","city":"Schalkhoven"},{"zip":"3740","city":"Bilzen-Hoeselt(Mopertingen)"},{"zip":"3740","city":"Bilzen-Hoeselt(Spouwen)"},{"zip":"3740","city":"Bilzen-Hoeselt(Beverst)"},{"zip":"3740","city":"Bilzen-Hoeselt(Munsterbilzen)"},{"zip":"3740","city":"Bilzen-Hoeselt(Waltwilder)"},{"zip":"3740","city":"Bilzen-Hoeselt(Kleine-Spouwen)"},{"zip":"3740","city":"Bilzen-Hoeselt(Rosmeer)"},{"zip":"3740","city":"Bilzen-Hoeselt(Bilzen)"},{"zip":"3740","city":"Bilzen-Hoeselt(Grote-Spouwen)"},{"zip":"3740","city":"Bilzen-Hoeselt(Hees)"},{"zip":"3740","city":"Bilzen-Hoeselt(Rijkhoven)"},{"zip":"3740","city":"Bilzen-Hoeselt(Eigenbilzen)"},{"zip":"3742","city":"Martenslinde"},{"zip":"3746","city":"Hoelbeek"},{"zip":"3770","city":"Val-Meer"},{"zip":"3770","city":"Membruggen"},{"zip":"3770","city":"Vlijtingen"},{"zip":"3770","city":"Kanne"},{"zip":"3770","city":"Vroenhoven"},{"zip":"3770","city":"Zichen-Zussen-Bolder"},{"zip":"3770","city":"Herderen"},{"zip":"3770","city":"Genoelselderen"},{"zip":"3770","city":"Riemst"},{"zip":"3770","city":"Millen"},{"zip":"3790","city":"Sint-Martens-Voeren"},{"zip":"3790","city":"Mouland"},{"zip":"3790","city":"Voeren"},{"zip":"3790","city":"Moelingen"},{"zip":"3790","city":"Fourons"},{"zip":"3790","city":"Fouron-Saint-Martin"},{"zip":"3791","city":"Remersdaal"},{"zip":"3792","city":"Sint-Pieters-Voeren"},{"zip":"3792","city":"Fouron-Saint-Pierre"},{"zip":"3793","city":"Teuven"},{"zip":"3798","city":"Fouron-le-Comte"},{"zip":"3798","city":"'s Gravenvoeren"},{"zip":"3800","city":"Kerkom-bij-Sint-Truiden"},{"zip":"3800","city":"Zepperen"},{"zip":"3800","city":"Gelinden"},{"zip":"3800","city":"Engelmanshoven"},{"zip":"3800","city":"Ordingen"},{"zip":"3800","city":"Brustem"},{"zip":"3800","city":"Aalst (Limb.)"},{"zip":"3800","city":"Groot-Gelmen"},{"zip":"3800","city":"Sint-Truiden"},{"zip":"3800","city":"Halmaal"},{"zip":"3803","city":"Gorsem"},{"zip":"3803","city":"Wilderen"},{"zip":"3803","city":"Runkelen"},{"zip":"3803","city":"Duras"},{"zip":"3806","city":"Velm"},{"zip":"3830","city":"Berlingen"},{"zip":"3830","city":"Wellen"},{"zip":"3831","city":"Herten"},{"zip":"3832","city":"Ulbeek"},{"zip":"3840","city":"Tongeren-Borgloon(Voort)"},{"zip":"3840","city":"Tongeren-Borgloon(Jesseren)"},{"zip":"3840","city":"Tongeren-Borgloon(Rijkel)"},{"zip":"3840","city":"Tongeren-Borgloon(Groot-Loon)"},{"zip":"3840","city":"Tongeren-Borgloon(Kerniel)"},{"zip":"3840","city":"Tongeren-Borgloon(Kuttekoven)"},{"zip":"3840","city":"Tongeren-Borgloon(Kolmont (Borgloon))"},{"zip":"3840","city":"Tongeren-Borgloon(Hendrieken)"},{"zip":"3840","city":"Tongeren-Borgloon(Gors-Opleeuw)"},{"zip":"3840","city":"Tongeren-Borgloon(Hoepertingen)"},{"zip":"3840","city":"Tongeren-Borgloon(Gotem)"},{"zip":"3840","city":"Tongeren-Borgloon(Broekom)"},{"zip":"3840","city":"Tongeren-Borgloon(Haren (Borgloon))"},{"zip":"3840","city":"Tongeren-Borgloon(Bommershoven)"},{"zip":"3840","city":"Tongeren-Borgloon(Borgloon)"},{"zip":"3850","city":"Nieuwerkerken (Limb.)"},{"zip":"3850","city":"Binderveld"},{"zip":"3850","city":"Wijer"},{"zip":"3850","city":"Kozen"},{"zip":"3870","city":"Batsheers"},{"zip":"3870","city":"Heers"},{"zip":"3870","city":"Gutschoven"},{"zip":"3870","city":"Rukkelingen-Loon"},{"zip":"3870","city":"Heks"},{"zip":"3870","city":"Klein-Gelmen"},{"zip":"3870","city":"Mechelen-Bovelingen"},{"zip":"3870","city":"Opheers"},{"zip":"3870","city":"Mettekoven"},{"zip":"3870","city":"Veulen"},{"zip":"3870","city":"Vechmaal"},{"zip":"3870","city":"Horpmaal"},{"zip":"3870","city":"Bovelingen"},{"zip":"3890","city":"Gingelom"},{"zip":"3890","city":"Kortijs"},{"zip":"3890","city":"Boekhout"},{"zip":"3890","city":"Vorsen"},{"zip":"3890","city":"Niel-bij-Sint-Truiden"},{"zip":"3890","city":"Montenaken"},{"zip":"3890","city":"Jeuk"},{"zip":"3891","city":"Borlo"},{"zip":"3891","city":"Muizen (Limb.)"},{"zip":"3891","city":"Mielen-Boven-Aalst"},{"zip":"3891","city":"Buvingen"},{"zip":"3900","city":"Pelt"},{"zip":"3910","city":"Sint-Huibrechts-Lille"},{"zip":"3910","city":"Pelt"},{"zip":"3920","city":"Lommel"},{"zip":"3930","city":"Achel"},{"zip":"3930","city":"Hamont"},{"zip":"3930","city":"Hamont-Achel"},{"zip":"3940","city":"Hechtel"},{"zip":"3940","city":"Hechtel-Eksel"},{"zip":"3941","city":"Eksel"},{"zip":"3945","city":"Tessenderlo- Ham(Ham)"},{"zip":"3945","city":"Tessenderlo- Ham(Oostham)"},{"zip":"3945","city":"Tessenderlo- Ham(Kwaadmechelen)"},{"zip":"3950","city":"Kaulille"},{"zip":"3950","city":"Reppel"},{"zip":"3950","city":"Bocholt"},{"zip":"3960","city":"Beek"},{"zip":"3960","city":"Opitter"},{"zip":"3960","city":"Tongerlo (Limb.)"},{"zip":"3960","city":"Bree"},{"zip":"3960","city":"Gerdingen"},{"zip":"3970","city":"Leopoldsburg"},{"zip":"3971","city":"Heppen"},{"zip":"3980","city":"Tessenderlo- Ham(Tessenderlo)"},{"zip":"3990","city":"Wijchmaal"},{"zip":"3990","city":"Peer"},{"zip":"3990","city":"Kleine-Brogel"},{"zip":"3990","city":"Grote-Brogel"},{"zip":"4000","city":"Glain"},{"zip":"4000","city":"Rocourt"},{"zip":"4000","city":"Liège"},{"zip":"4020","city":"Bressoux"},{"zip":"4020","city":"Wandre"},{"zip":"4020","city":"Liège"},{"zip":"4020","city":"Jupille-sur-Meuse"},{"zip":"4030","city":"Grivegnée"},{"zip":"4030","city":"Liège"},{"zip":"4031","city":"Angleur"},{"zip":"4032","city":"Chênée"},{"zip":"4040","city":"Herstal"},{"zip":"4041","city":"Milmort"},{"zip":"4041","city":"Vottem"},{"zip":"4042","city":"Liers"},{"zip":"4050","city":"Chaudfontaine"},{"zip":"4051","city":"Vaux-sous-Chèvremont"},{"zip":"4052","city":"Beaufays"},{"zip":"4053","city":"Embourg"},{"zip":"4090","city":"F.B.A. (Forces Belges en Allemagne)"},{"zip":"4090","city":"B.S.D. (Belg. Strijdkr. Duitsland)"},{"zip":"4100","city":"Boncelles"},{"zip":"4100","city":"Seraing"},{"zip":"4101","city":"Jemeppe-sur-Meuse"},{"zip":"4102","city":"Ougrée"},{"zip":"4120","city":"Ehein"},{"zip":"4120","city":"Rotheux-Rimière"},{"zip":"4120","city":"Neupré"},{"zip":"4121","city":"Neuville-en-Condroz"},{"zip":"4122","city":"Plainevaux"},{"zip":"4130","city":"Esneux"},{"zip":"4130","city":"Tilff"},{"zip":"4140","city":"Rouvreux"},{"zip":"4140","city":"Dolembreux"},{"zip":"4140","city":"Sprimont"},{"zip":"4140","city":"Gomzé-Andoumont"},{"zip":"4141","city":"Louveigné"},{"zip":"4160","city":"Anthisnes"},{"zip":"4161","city":"Villers-aux-Tours"},{"zip":"4162","city":"Hody"},{"zip":"4163","city":"Tavier"},{"zip":"4170","city":"Comblain-au-Pont"},{"zip":"4171","city":"Poulseur"},{"zip":"4180","city":"Hamoir"},{"zip":"4180","city":"Comblain-Fairon"},{"zip":"4180","city":"Comblain-la-Tour"},{"zip":"4181","city":"Filot"},{"zip":"4190","city":"Xhoris"},{"zip":"4190","city":"Ferrières"},{"zip":"4190","city":"My"},{"zip":"4190","city":"Vieuxville"},{"zip":"4190","city":"Werbomont"},{"zip":"4210","city":"Burdinne"},{"zip":"4210","city":"Lamontzée"},{"zip":"4210","city":"Hannêche"},{"zip":"4210","city":"Marneffe"},{"zip":"4210","city":"Oteppe"},{"zip":"4217","city":"Héron"},{"zip":"4217","city":"Waret-l'Evêque"},{"zip":"4217","city":"Lavoir"},{"zip":"4218","city":"Couthuin"},{"zip":"4219","city":"Acosse"},{"zip":"4219","city":"Ambresin"},{"zip":"4219","city":"Wasseiges"},{"zip":"4219","city":"Meeffe"},{"zip":"4250","city":"Hollogne-sur-Geer"},{"zip":"4250","city":"Geer"},{"zip":"4250","city":"Boëlhe"},{"zip":"4250","city":"Lens-Saint-Servais"},{"zip":"4252","city":"Omal"},{"zip":"4253","city":"Darion"},{"zip":"4254","city":"Ligney"},{"zip":"4257","city":"Corswarem"},{"zip":"4257","city":"Berloz"},{"zip":"4257","city":"Rosoux-Crenwick"},{"zip":"4260","city":"Ciplet"},{"zip":"4260","city":"Fumal"},{"zip":"4260","city":"Fallais"},{"zip":"4260","city":"Braives"},{"zip":"4260","city":"Avennes"},{"zip":"4260","city":"Ville-en-Hesbaye"},{"zip":"4261","city":"Latinne"},{"zip":"4263","city":"Tourinne (Lg.)"},{"zip":"4280","city":"Abolens"},{"zip":"4280","city":"Lens-Saint-Remy"},{"zip":"4280","city":"Blehen"},{"zip":"4280","city":"Bertrée"},{"zip":"4280","city":"Hannut"},{"zip":"4280","city":"Avin"},{"zip":"4280","city":"Avernas-le-Bauduin"},{"zip":"4280","city":"Poucet"},{"zip":"4280","city":"Grand-Hallet"},{"zip":"4280","city":"Trognée"},{"zip":"4280","city":"Moxhe"},{"zip":"4280","city":"Thisnes"},{"zip":"4280","city":"Petit-Hallet"},{"zip":"4280","city":"Merdorp"},{"zip":"4280","city":"Villers-le-Peuplier"},{"zip":"4280","city":"Wansin"},{"zip":"4280","city":"Crehen"},{"zip":"4280","city":"Cras-Avernas"},{"zip":"4287","city":"Pellaines"},{"zip":"4287","city":"Racour"},{"zip":"4287","city":"Lincent"},{"zip":"4300","city":"Lantremange"},{"zip":"4300","city":"Grand-Axhe"},{"zip":"4300","city":"Bovenistier"},{"zip":"4300","city":"Bettincourt"},{"zip":"4300","city":"Oleye"},{"zip":"4300","city":"Bleret"},{"zip":"4300","city":"Waremme"},{"zip":"4317","city":"Les Waleffes"},{"zip":"4317","city":"Viemme"},{"zip":"4317","city":"Aineffe"},{"zip":"4317","city":"Borlez"},{"zip":"4317","city":"Faimes"},{"zip":"4317","city":"Celles (Lg.)"},{"zip":"4340","city":"Awans"},{"zip":"4340","city":"Villers-l'Evêque"},{"zip":"4340","city":"Othée"},{"zip":"4340","city":"Fooz"},{"zip":"4342","city":"Hognoul"},{"zip":"4347","city":"Noville (Lg.)"},{"zip":"4347","city":"Voroux-Goreux"},{"zip":"4347","city":"Fexhe-le-Haut-Clocher"},{"zip":"4347","city":"Freloux"},{"zip":"4347","city":"Roloux"},{"zip":"4350","city":"Lamine"},{"zip":"4350","city":"Pousset"},{"zip":"4350","city":"Momalle"},{"zip":"4350","city":"Remicourt"},{"zip":"4351","city":"Hodeige"},{"zip":"4357","city":"Jeneffe (Lg.)"},{"zip":"4357","city":"Limont"},{"zip":"4357","city":"Donceel"},{"zip":"4357","city":"Haneffe"},{"zip":"4360","city":"Oreye"},{"zip":"4360","city":"Lens-sur-Geer"},{"zip":"4360","city":"Otrange"},{"zip":"4360","city":"Grandville"},{"zip":"4360","city":"Bergilers"},{"zip":"4367","city":"Kemexhe"},{"zip":"4367","city":"Thys"},{"zip":"4367","city":"Crisnée"},{"zip":"4367","city":"Odeur"},{"zip":"4367","city":"Fize-le-Marsal"},{"zip":"4400","city":"Flémalle-Grande"},{"zip":"4400","city":"Mons-lez-Liège"},{"zip":"4400","city":"Flémalle-Haute"},{"zip":"4400","city":"Chokier"},{"zip":"4400","city":"Gleixhe"},{"zip":"4400","city":"Ivoz-Ramet"},{"zip":"4400","city":"Awirs"},{"zip":"4400","city":"Flémalle"},{"zip":"4420","city":"Tilleur"},{"zip":"4420","city":"Montegnée"},{"zip":"4420","city":"Saint-Nicolas (Lg.)"},{"zip":"4430","city":"Ans"},{"zip":"4431","city":"Loncin"},{"zip":"4432","city":"Alleur"},{"zip":"4432","city":"Xhendremael"},{"zip":"4450","city":"Juprelle"},{"zip":"4450","city":"Lantin"},{"zip":"4450","city":"Slins"},{"zip":"4451","city":"Voroux-lez-Liers"},{"zip":"4452","city":"Wihogne"},{"zip":"4452","city":"Paifve"},{"zip":"4453","city":"Villers-Saint-Siméon"},{"zip":"4458","city":"Fexhe-Slins"},{"zip":"4460","city":"Horion-Hozémont"},{"zip":"4460","city":"Grâce-Berleur"},{"zip":"4460","city":"Bierset"},{"zip":"4460","city":"Velroux"},{"zip":"4460","city":"Hollogne-aux-Pierres"},{"zip":"4460","city":"Grâce-Hollogne"},{"zip":"4470","city":"Saint-Georges-sur-Meuse"},{"zip":"4480","city":"Hermalle-sous-Huy"},{"zip":"4480","city":"Clermont-sous-Huy"},{"zip":"4480","city":"Engis"},{"zip":"4500","city":"Ben-Ahin"},{"zip":"4500","city":"Tihange"},{"zip":"4500","city":"Huy"},{"zip":"4520","city":"Wanze"},{"zip":"4520","city":"Bas-Oha"},{"zip":"4520","city":"Vinalmont"},{"zip":"4520","city":"Antheit"},{"zip":"4520","city":"Moha"},{"zip":"4520","city":"Huccorgne"},{"zip":"4530","city":"Fize-Fontaine"},{"zip":"4530","city":"Vieux-Waleffe"},{"zip":"4530","city":"Vaux-et-Borset"},{"zip":"4530","city":"Villers-le-Bouillet"},{"zip":"4530","city":"Warnant-Dreye"},{"zip":"4537","city":"Chapon-Seraing"},{"zip":"4537","city":"Seraing-le-Château"},{"zip":"4537","city":"Verlaine"},{"zip":"4540","city":"Ampsin"},{"zip":"4540","city":"Jehay"},{"zip":"4540","city":"Amay"},{"zip":"4540","city":"Flône"},{"zip":"4540","city":"Ombret"},{"zip":"4550","city":"Nandrin"},{"zip":"4550","city":"Villers-le-Temple"},{"zip":"4550","city":"Saint-Séverin"},{"zip":"4550","city":"Yernée-Fraineux"},{"zip":"4557","city":"Seny"},{"zip":"4557","city":"Soheit-Tinlot"},{"zip":"4557","city":"Ramelot"},{"zip":"4557","city":"Fraiture"},{"zip":"4557","city":"Abée"},{"zip":"4557","city":"Tinlot"},{"zip":"4560","city":"Ocquier"},{"zip":"4560","city":"Pailhe"},{"zip":"4560","city":"Clavier"},{"zip":"4560","city":"Terwagne"},{"zip":"4560","city":"Les Avins"},{"zip":"4560","city":"Bois-et-Borsu"},{"zip":"4570","city":"Marchin"},{"zip":"4570","city":"Vyle-et-Tharoul"},{"zip":"4577","city":"Outrelouxhe"},{"zip":"4577","city":"Strée-lez-Huy"},{"zip":"4577","city":"Vierset-Barse"},{"zip":"4577","city":"Modave"},{"zip":"4590","city":"Warzée"},{"zip":"4590","city":"Ouffet"},{"zip":"4590","city":"Ellemelle"},{"zip":"4600","city":"Lanaye"},{"zip":"4600","city":"Richelle"},{"zip":"4600","city":"Lixhe"},{"zip":"4600","city":"Visé"},{"zip":"4601","city":"Argenteau"},{"zip":"4602","city":"Cheratte"},{"zip":"4606","city":"Saint-André"},{"zip":"4607","city":"Feneur"},{"zip":"4607","city":"Bombaye"},{"zip":"4607","city":"Berneau"},{"zip":"4607","city":"Dalhem"},{"zip":"4607","city":"Mortroux"},{"zip":"4608","city":"Warsage"},{"zip":"4608","city":"Neufchâteau (Lg.)"},{"zip":"4610","city":"Queue-du-Bois"},{"zip":"4610","city":"Bellaire"},{"zip":"4610","city":"Beyne-Heusay"},{"zip":"4620","city":"Fléron"},{"zip":"4621","city":"Retinne"},{"zip":"4623","city":"Magnée"},{"zip":"4624","city":"Romsée"},{"zip":"4630","city":"Soumagne"},{"zip":"4630","city":"Micheroux"},{"zip":"4630","city":"Tignée"},{"zip":"4630","city":"Ayeneux"},{"zip":"4631","city":"Evegnée"},{"zip":"4632","city":"Cérexhe-Heuseux"},{"zip":"4633","city":"Melen"},{"zip":"4650","city":"Chaineux"},{"zip":"4650","city":"Julémont"},{"zip":"4650","city":"Grand-Rechain"},{"zip":"4650","city":"Herve"},{"zip":"4651","city":"Battice"},{"zip":"4652","city":"Xhendelesse"},{"zip":"4653","city":"Bolland"},{"zip":"4654","city":"Charneux"},{"zip":"4670","city":"Trembleur"},{"zip":"4670","city":"Mortier"},{"zip":"4670","city":"Blégny"},{"zip":"4671","city":"Saive"},{"zip":"4671","city":"Barchon"},{"zip":"4671","city":"Housse"},{"zip":"4672","city":"Saint-Remy (Lg.)"},{"zip":"4680","city":"Oupeye"},{"zip":"4680","city":"Hermée"},{"zip":"4681","city":"Hermalle-sous-Argenteau"},{"zip":"4682","city":"Houtain-Saint-Siméon"},{"zip":"4682","city":"Heure-le-Romain"},{"zip":"4683","city":"Vivegnis"},{"zip":"4684","city":"Haccourt"},{"zip":"4690","city":"Eben-Emael"},{"zip":"4690","city":"Roclenge-sur-Geer"},{"zip":"4690","city":"Glons"},{"zip":"4690","city":"Boirs"},{"zip":"4690","city":"Wonck"},{"zip":"4690","city":"Bassenge"},{"zip":"4700","city":"Eupen"},{"zip":"4701","city":"Kettenis"},{"zip":"4710","city":"Lontzen"},{"zip":"4711","city":"Walhorn"},{"zip":"4720","city":"Kelmis"},{"zip":"4720","city":"La Calamine"},{"zip":"4721","city":"Neu-Moresnet"},{"zip":"4728","city":"Hergenrath"},{"zip":"4730","city":"Hauset"},{"zip":"4730","city":"Raeren"},{"zip":"4731","city":"Eynatten"},{"zip":"4750","city":"Butgenbach"},{"zip":"4750","city":"Bütgenbach"},{"zip":"4750","city":"Elsenborn"},{"zip":"4760","city":"Bullange"},{"zip":"4760","city":"Büllingen"},{"zip":"4760","city":"Manderfeld"},{"zip":"4761","city":"Rocherath"},{"zip":"4770","city":"Meyerode"},{"zip":"4770","city":"Amel"},{"zip":"4770","city":"Amblève"},{"zip":"4771","city":"Heppenbach"},{"zip":"4780","city":"Saint-Vith"},{"zip":"4780","city":"Recht"},{"zip":"4780","city":"Sankt Vith"},{"zip":"4782","city":"Schönberg"},{"zip":"4782","city":"Schoenberg"},{"zip":"4783","city":"Lommersweiler"},{"zip":"4784","city":"Crombach"},{"zip":"4790","city":"Reuland"},{"zip":"4790","city":"Burg-Reuland"},{"zip":"4791","city":"Thommen"},{"zip":"4800","city":"Petit-Rechain"},{"zip":"4800","city":"Verviers"},{"zip":"4800","city":"Lambermont"},{"zip":"4800","city":"Ensival"},{"zip":"4801","city":"Stembert"},{"zip":"4802","city":"Heusy"},{"zip":"4820","city":"Dison"},{"zip":"4821","city":"Andrimont"},{"zip":"4830","city":"Limbourg"},{"zip":"4831","city":"Bilstain"},{"zip":"4834","city":"Goé"},{"zip":"4837","city":"Baelen (Lg.)"},{"zip":"4837","city":"Membach"},{"zip":"4840","city":"Welkenraedt"},{"zip":"4841","city":"Henri-Chapelle"},{"zip":"4845","city":"Sart-lez-Spa"},{"zip":"4845","city":"Jalhay"},{"zip":"4850","city":"Plombières"},{"zip":"4850","city":"Moresnet"},{"zip":"4850","city":"Montzen"},{"zip":"4851","city":"Gemmenich"},{"zip":"4851","city":"Sippenaeken"},{"zip":"4852","city":"Hombourg"},{"zip":"4860","city":"Cornesse"},{"zip":"4860","city":"Wegnez"},{"zip":"4860","city":"Pepinster"},{"zip":"4861","city":"Soiron"},{"zip":"4870","city":"Fraipont"},{"zip":"4870","city":"Forêt"},{"zip":"4870","city":"Nessonvaux"},{"zip":"4870","city":"Trooz"},{"zip":"4877","city":"Olne"},{"zip":"4880","city":"Aubel"},{"zip":"4890","city":"Thimister-Clermont"},{"zip":"4890","city":"Thimister"},{"zip":"4890","city":"Clermont (Lg.)"},{"zip":"4900","city":"Spa"},{"zip":"4910","city":"Polleur"},{"zip":"4910","city":"Theux"},{"zip":"4910","city":"La Reid"},{"zip":"4920","city":"Ernonheid"},{"zip":"4920","city":"Aywaille"},{"zip":"4920","city":"Sougné-Remouchamps"},{"zip":"4920","city":"Harzé"},{"zip":"4950","city":"Robertville"},{"zip":"4950","city":"Faymonville"},{"zip":"4950","city":"Sourbrodt"},{"zip":"4950","city":"Waimes"},{"zip":"4950","city":"Weismes"},{"zip":"4960","city":"Malmedy"},{"zip":"4960","city":"Bevercé"},{"zip":"4960","city":"Bellevaux-Ligneuville"},{"zip":"4970","city":"Stavelot"},{"zip":"4970","city":"Francorchamps"},{"zip":"4980","city":"Trois-Ponts"},{"zip":"4980","city":"Fosse (Lg.)"},{"zip":"4980","city":"Wanne"},{"zip":"4983","city":"Basse-Bodeux"},{"zip":"4987","city":"Stoumont"},{"zip":"4987","city":"Lorcé"},{"zip":"4987","city":"Chevron"},{"zip":"4987","city":"La Gleize"},{"zip":"4987","city":"Rahier"},{"zip":"4990","city":"Lierneux"},{"zip":"4990","city":"Arbrefontaine"},{"zip":"4990","city":"Bra"},{"zip":"5000","city":"Namur"},{"zip":"5000","city":"Beez"},{"zip":"5001","city":"Belgrade"},{"zip":"5002","city":"Saint-Servais"},{"zip":"5003","city":"Saint-Marc"},{"zip":"5004","city":"Bouge"},{"zip":"5020","city":"Daussoulx"},{"zip":"5020","city":"Suarlée"},{"zip":"5020","city":"Flawinne"},{"zip":"5020","city":"Vedrin"},{"zip":"5020","city":"Malonne"},{"zip":"5020","city":"Champion"},{"zip":"5020","city":"Temploux"},{"zip":"5021","city":"Boninne"},{"zip":"5022","city":"Cognelée"},{"zip":"5024","city":"Marche-les-Dames"},{"zip":"5024","city":"Gelbressée"},{"zip":"5030","city":"Gembloux"},{"zip":"5030","city":"Sauvenière"},{"zip":"5030","city":"Beuzet"},{"zip":"5030","city":"Lonzée"},{"zip":"5030","city":"Ernage"},{"zip":"5030","city":"Grand-Manil"},{"zip":"5031","city":"Grand-Leez"},{"zip":"5032","city":"Bothey"},{"zip":"5032","city":"Bossière"},{"zip":"5032","city":"Mazy"},{"zip":"5032","city":"Corroy-le-Château"},{"zip":"5032","city":"Isnes"},{"zip":"5060","city":"Tamines"},{"zip":"5060","city":"Auvelais"},{"zip":"5060","city":"Velaine-sur-Sambre"},{"zip":"5060","city":"Keumiée"},{"zip":"5060","city":"Falisolle"},{"zip":"5060","city":"Arsimont"},{"zip":"5060","city":"Sambreville"},{"zip":"5060","city":"Moignelée"},{"zip":"5070","city":"Sart-Saint-Laurent"},{"zip":"5070","city":"Sart-Eustache"},{"zip":"5070","city":"Aisemont"},{"zip":"5070","city":"Vitrival"},{"zip":"5070","city":"Le Roux"},{"zip":"5070","city":"Fosses-la-Ville"},{"zip":"5080","city":"Emines"},{"zip":"5080","city":"La Bruyère"},{"zip":"5080","city":"Rhisnes"},{"zip":"5080","city":"Villers-lez-Heest"},{"zip":"5080","city":"Warisoulx"},{"zip":"5081","city":"Saint-Denis-Bovesse"},{"zip":"5081","city":"Meux"},{"zip":"5081","city":"Bovesse"},{"zip":"5100","city":"Naninne"},{"zip":"5100","city":"Jambes (Namur)"},{"zip":"5100","city":"Wépion"},{"zip":"5100","city":"Wierde"},{"zip":"5100","city":"Dave"},{"zip":"5101","city":"Lives-sur-Meuse"},{"zip":"5101","city":"Erpent"},{"zip":"5101","city":"Loyers"},{"zip":"5140","city":"Tongrinne"},{"zip":"5140","city":"Boignée"},{"zip":"5140","city":"Sombreffe"},{"zip":"5140","city":"Ligny"},{"zip":"5150","city":"Floriffoux"},{"zip":"5150","city":"Franière"},{"zip":"5150","city":"Floreffe"},{"zip":"5150","city":"Soye (Nam.)"},{"zip":"5170","city":"Rivière"},{"zip":"5170","city":"Profondeville"},{"zip":"5170","city":"Bois-de-Villers"},{"zip":"5170","city":"Lustin"},{"zip":"5170","city":"Arbre (Nam.)"},{"zip":"5170","city":"Lesve"},{"zip":"5190","city":"Jemeppe-sur-Sambre"},{"zip":"5190","city":"Onoz"},{"zip":"5190","city":"Mornimont"},{"zip":"5190","city":"Spy"},{"zip":"5190","city":"Moustier-sur-Sambre"},{"zip":"5190","city":"Saint-Martin"},{"zip":"5190","city":"Balâtre"},{"zip":"5190","city":"Ham-sur-Sambre"},{"zip":"5300","city":"Landenne"},{"zip":"5300","city":"Andenne"},{"zip":"5300","city":"Coutisse"},{"zip":"5300","city":"Thon"},{"zip":"5300","city":"Bonneville"},{"zip":"5300","city":"Vezin"},{"zip":"5300","city":"Sclayn"},{"zip":"5300","city":"Seilles"},{"zip":"5300","city":"Maizeret"},{"zip":"5300","city":"Namêche"},{"zip":"5310","city":"Leuze (Nam.)"},{"zip":"5310","city":"Liernu"},{"zip":"5310","city":"Aische-en-Refail"},{"zip":"5310","city":"Dhuy"},{"zip":"5310","city":"Branchon"},{"zip":"5310","city":"Waret-la-Chaussée"},{"zip":"5310","city":"Mehaigne"},{"zip":"5310","city":"Longchamps (Nam.)"},{"zip":"5310","city":"Boneffe"},{"zip":"5310","city":"Upigny"},{"zip":"5310","city":"Noville-sur-Méhaigne"},{"zip":"5310","city":"Bolinne"},{"zip":"5310","city":"Saint-Germain"},{"zip":"5310","city":"Hanret"},{"zip":"5310","city":"Taviers (Nam.)"},{"zip":"5310","city":"Eghezée"},{"zip":"5330","city":"Maillen"},{"zip":"5330","city":"Assesse"},{"zip":"5330","city":"Sart-Bernard"},{"zip":"5332","city":"Crupet"},{"zip":"5333","city":"Sorinne-la-Longue"},{"zip":"5334","city":"Florée"},{"zip":"5336","city":"Courrière"},{"zip":"5340","city":"Sorée"},{"zip":"5340","city":"Haltinne"},{"zip":"5340","city":"Gesves"},{"zip":"5340","city":"Mozet"},{"zip":"5340","city":"Faulx-les-Tombes"},{"zip":"5350","city":"Ohey"},{"zip":"5350","city":"Evelette"},{"zip":"5351","city":"Haillot"},{"zip":"5352","city":"Perwez-Haillot"},{"zip":"5353","city":"Goesnes"},{"zip":"5354","city":"Jallet"},{"zip":"5360","city":"Natoye"},{"zip":"5360","city":"Hamois"},{"zip":"5361","city":"Mohiville"},{"zip":"5361","city":"Scy"},{"zip":"5362","city":"Achet"},{"zip":"5363","city":"Emptinne"},{"zip":"5364","city":"Schaltin"},{"zip":"5370","city":"Flostoy"},{"zip":"5370","city":"Jeneffe (Nam.)"},{"zip":"5370","city":"Verlée"},{"zip":"5370","city":"Havelange"},{"zip":"5370","city":"Barvaux-Condroz"},{"zip":"5370","city":"Porcheresse (Nam.)"},{"zip":"5372","city":"Méan"},{"zip":"5374","city":"Maffe"},{"zip":"5376","city":"Miécret"},{"zip":"5377","city":"Hogne"},{"zip":"5377","city":"Sinsin"},{"zip":"5377","city":"Waillet"},{"zip":"5377","city":"Noiseux"},{"zip":"5377","city":"Nettinne"},{"zip":"5377","city":"Heure (Nam.)"},{"zip":"5377","city":"Baillonville"},{"zip":"5377","city":"Somme-Leuze"},{"zip":"5377","city":"Bonsin"},{"zip":"5380","city":"Bierwart"},{"zip":"5380","city":"Noville-les-Bois"},{"zip":"5380","city":"Fernelmont"},{"zip":"5380","city":"Marchovelette"},{"zip":"5380","city":"Forville"},{"zip":"5380","city":"Pontillas"},{"zip":"5380","city":"Hemptinne (Fernelmont)"},{"zip":"5380","city":"Cortil-Wodon"},{"zip":"5380","city":"Franc-Waret"},{"zip":"5380","city":"Tillier"},{"zip":"5380","city":"Hingeon"},{"zip":"5500","city":"Furfooz"},{"zip":"5500","city":"Dréhance"},{"zip":"5500","city":"Dinant"},{"zip":"5500","city":"Anseremme"},{"zip":"5500","city":"Bouvignes-sur-Meuse"},{"zip":"5500","city":"Falmagne"},{"zip":"5500","city":"Falmignoul"},{"zip":"5501","city":"Lisogne"},{"zip":"5502","city":"Thynes"},{"zip":"5503","city":"Sorinnes"},{"zip":"5504","city":"Foy-Notre-Dame"},{"zip":"5520","city":"Anthée"},{"zip":"5520","city":"Onhaye"},{"zip":"5521","city":"Serville"},{"zip":"5522","city":"Falaën"},{"zip":"5523","city":"Weillen"},{"zip":"5523","city":"Sommière"},{"zip":"5524","city":"Gerin"},{"zip":"5530","city":"Mont (Nam.)"},{"zip":"5530","city":"Evrehailles"},{"zip":"5530","city":"Yvoir"},{"zip":"5530","city":"Spontin"},{"zip":"5530","city":"Purnode"},{"zip":"5530","city":"Godinne"},{"zip":"5530","city":"Houx"},{"zip":"5530","city":"Dorinne"},{"zip":"5530","city":"Durnal"},{"zip":"5537","city":"Denée"},{"zip":"5537","city":"Annevoie-Rouillon"},{"zip":"5537","city":"Haut-le-Wastia"},{"zip":"5537","city":"Warnant"},{"zip":"5537","city":"Sosoye"},{"zip":"5537","city":"Bioul"},{"zip":"5537","city":"Anhée"},{"zip":"5540","city":"Hermeton-sur-Meuse"},{"zip":"5540","city":"Waulsort"},{"zip":"5540","city":"Hastière-Lavaux"},{"zip":"5540","city":"Hastière"},{"zip":"5541","city":"Hastière-par-Delà"},{"zip":"5542","city":"Blaimont"},{"zip":"5543","city":"Heer"},{"zip":"5544","city":"Agimont"},{"zip":"5550","city":"Chairière"},{"zip":"5550","city":"Bagimont"},{"zip":"5550","city":"Bohan"},{"zip":"5550","city":"Alle"},{"zip":"5550","city":"Vresse-sur-Semois"},{"zip":"5550","city":"Nafraiture"},{"zip":"5550","city":"Mouzaive"},{"zip":"5550","city":"Sugny"},{"zip":"5550","city":"Pussemange"},{"zip":"5550","city":"Orchimont"},{"zip":"5550","city":"Laforêt"},{"zip":"5550","city":"Membre"},{"zip":"5555","city":"Naomé"},{"zip":"5555","city":"Bievre"},{"zip":"5555","city":"Gros-Fays"},{"zip":"5555","city":"Monceau-en-Ardenne"},{"zip":"5555","city":"Cornimont"},{"zip":"5555","city":"Graide"},{"zip":"5555","city":"Petit-Fays"},{"zip":"5555","city":"Bellefontaine (Nam.)"},{"zip":"5555","city":"Baillamont"},{"zip":"5555","city":"Oizy"},{"zip":"5560","city":"Mesnil-Saint-Blaise"},{"zip":"5560","city":"Mesnil-Eglise"},{"zip":"5560","city":"Ciergnon"},{"zip":"5560","city":"Finnevaux"},{"zip":"5560","city":"Hulsonniaux"},{"zip":"5560","city":"Houyet"},{"zip":"5561","city":"Celles (Nam.)"},{"zip":"5562","city":"Custinne"},{"zip":"5563","city":"Hour"},{"zip":"5564","city":"Wanlin"},{"zip":"5570","city":"Javingue"},{"zip":"5570","city":"Winenne"},{"zip":"5570","city":"Vonêche"},{"zip":"5570","city":"Baronville"},{"zip":"5570","city":"Wancennes"},{"zip":"5570","city":"Honnay"},{"zip":"5570","city":"Dion"},{"zip":"5570","city":"Felenne"},{"zip":"5570","city":"Beauraing"},{"zip":"5570","city":"Feschaux"},{"zip":"5571","city":"Wiesme"},{"zip":"5572","city":"Focant"},{"zip":"5573","city":"Martouzin-Neuville"},{"zip":"5574","city":"Pondrôme"},{"zip":"5575","city":"Louette-Saint-Denis"},{"zip":"5575","city":"Gedinne"},{"zip":"5575","city":"Louette-Saint-Pierre"},{"zip":"5575","city":"Patignies"},{"zip":"5575","city":"Willerzie"},{"zip":"5575","city":"Vencimont"},{"zip":"5575","city":"Sart-Custinne"},{"zip":"5575","city":"Malvoisin"},{"zip":"5575","city":"Rienne"},{"zip":"5575","city":"Bourseigne-Neuve"},{"zip":"5575","city":"Bourseigne-Vieille"},{"zip":"5575","city":"Houdremont"},{"zip":"5576","city":"Froidfontaine"},{"zip":"5580","city":"Eprave"},{"zip":"5580","city":"Lessive"},{"zip":"5580","city":"Jemelle"},{"zip":"5580","city":"Lavaux-Sainte-Anne"},{"zip":"5580","city":"Rochefort"},{"zip":"5580","city":"Han-sur-Lesse"},{"zip":"5580","city":"Villers-sur-Lesse"},{"zip":"5580","city":"Mont-Gauthier"},{"zip":"5580","city":"Wavreille"},{"zip":"5580","city":"Buissonville"},{"zip":"5580","city":"Ave-et-Auffe"},{"zip":"5590","city":"Serinchamps"},{"zip":"5590","city":"Conneux"},{"zip":"5590","city":"Sovet"},{"zip":"5590","city":"Ciney"},{"zip":"5590","city":"Achêne"},{"zip":"5590","city":"Haversin"},{"zip":"5590","city":"Braibant"},{"zip":"5590","city":"Leignon"},{"zip":"5590","city":"Pessoux"},{"zip":"5590","city":"Chevetogne"},{"zip":"5600","city":"Jamagne"},{"zip":"5600","city":"Romedenne"},{"zip":"5600","city":"Franchimont"},{"zip":"5600","city":"Merlemont"},{"zip":"5600","city":"Philippeville"},{"zip":"5600","city":"Surice"},{"zip":"5600","city":"Neuville (Philippeville)"},{"zip":"5600","city":"Villers-en-Fagne"},{"zip":"5600","city":"Villers-le-Gambon"},{"zip":"5600","city":"Vodecée"},{"zip":"5600","city":"Omezée"},{"zip":"5600","city":"Samart"},{"zip":"5600","city":"Sart-en-Fagne"},{"zip":"5600","city":"Sautour"},{"zip":"5600","city":"Fagnolle"},{"zip":"5600","city":"Roly"},{"zip":"5600","city":"Jamiolle"},{"zip":"5620","city":"Flavion"},{"zip":"5620","city":"Florennes"},{"zip":"5620","city":"Corenne"},{"zip":"5620","city":"Hemptinne-lez-Florennes"},{"zip":"5620","city":"Morville"},{"zip":"5620","city":"Saint-Aubin"},{"zip":"5620","city":"Rosée"},{"zip":"5621","city":"Morialmé"},{"zip":"5621","city":"Hanzinne"},{"zip":"5621","city":"Hanzinelle"},{"zip":"5621","city":"Thy-le-Bauduin"},{"zip":"5630","city":"Cerfontaine"},{"zip":"5630","city":"Daussois"},{"zip":"5630","city":"Silenrieux"},{"zip":"5630","city":"Soumoy"},{"zip":"5630","city":"Senzeille"},{"zip":"5630","city":"Villers-Deux-Eglises"},{"zip":"5640","city":"Mettet"},{"zip":"5640","city":"Saint-Gérard"},{"zip":"5640","city":"Oret"},{"zip":"5640","city":"Biesme"},{"zip":"5640","city":"Biesmerée"},{"zip":"5640","city":"Graux"},{"zip":"5641","city":"Furnaux"},{"zip":"5644","city":"Ermeton-sur-Biert"},{"zip":"5646","city":"Stave"},{"zip":"5650","city":"Castillon"},{"zip":"5650","city":"Pry"},{"zip":"5650","city":"Fraire"},{"zip":"5650","city":"Fontenelle"},{"zip":"5650","city":"Yves-Gomezée"},{"zip":"5650","city":"Vogenée"},{"zip":"5650","city":"Chastrès"},{"zip":"5650","city":"Clermont (Nam.)"},{"zip":"5650","city":"Walcourt"},{"zip":"5651","city":"Gourdinne"},{"zip":"5651","city":"Thy-le-Château"},{"zip":"5651","city":"Somzée"},{"zip":"5651","city":"Laneffe"},{"zip":"5651","city":"Rognée"},{"zip":"5651","city":"Berzée"},{"zip":"5651","city":"Tarcienne"},{"zip":"5660","city":"Boussu-en-Fagne"},{"zip":"5660","city":"Aublain"},{"zip":"5660","city":"Frasnes (Nam.)"},{"zip":"5660","city":"Brûly-de-Pesche"},{"zip":"5660","city":"Couvin"},{"zip":"5660","city":"Cul-des-Sarts"},{"zip":"5660","city":"Gonrieux"},{"zip":"5660","city":"Brûly"},{"zip":"5660","city":"Mariembourg"},{"zip":"5660","city":"Pesche"},{"zip":"5660","city":"Petigny"},{"zip":"5660","city":"Petite-Chapelle"},{"zip":"5660","city":"Presgaux"},{"zip":"5660","city":"Dailly"},{"zip":"5670","city":"Le Mesnil"},{"zip":"5670","city":"Dourbes"},{"zip":"5670","city":"Mazée"},{"zip":"5670","city":"Viroinval"},{"zip":"5670","city":"Vierves-sur-Viroin"},{"zip":"5670","city":"Oignies-en-Thiérache"},{"zip":"5670","city":"Olloy-sur-Viroin"},{"zip":"5670","city":"Treignes"},{"zip":"5670","city":"Nismes"},{"zip":"5680","city":"Doische"},{"zip":"5680","city":"Matagne-la-Grande"},{"zip":"5680","city":"Matagne-la-Petite"},{"zip":"5680","city":"Niverlée"},{"zip":"5680","city":"Romerée"},{"zip":"5680","city":"Vodelée"},{"zip":"5680","city":"Soulme"},{"zip":"5680","city":"Gimnée"},{"zip":"5680","city":"Gochenée"},{"zip":"5680","city":"Vaucelles"},{"zip":"6000","city":"Charleroi"},{"zip":"6001","city":"Marcinelle"},{"zip":"6010","city":"Couillet"},{"zip":"6020","city":"Dampremy"},{"zip":"6030","city":"Marchienne-au-Pont"},{"zip":"6030","city":"Goutroux"},{"zip":"6031","city":"Monceau-sur-Sambre"},{"zip":"6032","city":"Mont-sur-Marchienne"},{"zip":"6040","city":"Jumet (Charleroi)"},{"zip":"6041","city":"Gosselies"},{"zip":"6042","city":"Lodelinsart"},{"zip":"6043","city":"Ransart"},{"zip":"6044","city":"Roux"},{"zip":"6060","city":"Gilly (Charleroi)"},{"zip":"6061","city":"Montignies-sur-Sambre"},{"zip":"6110","city":"Montigny-le-Tilleul"},{"zip":"6111","city":"Landelies"},{"zip":"6120","city":"Cour-sur-Heure"},{"zip":"6120","city":"Nalinnes"},{"zip":"6120","city":"Marbaix (Ht.)"},{"zip":"6120","city":"Ham-sur-Heure"},{"zip":"6120","city":"Ham-sur-Heure-Nalinnes"},{"zip":"6120","city":"Jamioulx"},{"zip":"6140","city":"Fontaine-l'Evêque"},{"zip":"6141","city":"Forchies-la-Marche"},{"zip":"6142","city":"Leernes"},{"zip":"6150","city":"Anderlues"},{"zip":"6180","city":"Courcelles"},{"zip":"6181","city":"Gouy-lez-Piéton"},{"zip":"6182","city":"Souvret"},{"zip":"6183","city":"Trazegnies"},{"zip":"6200","city":"Bouffioulx"},{"zip":"6200","city":"Châtelineau"},{"zip":"6200","city":"Châtelet"},{"zip":"6210","city":"Villers-Perwin"},{"zip":"6210","city":"Rèves"},{"zip":"6210","city":"Frasnes-lez-Gosselies"},{"zip":"6210","city":"Les Bons Villers"},{"zip":"6210","city":"Wayaux"},{"zip":"6211","city":"Mellet"},{"zip":"6220","city":"Lambusart"},{"zip":"6220","city":"Wangenies"},{"zip":"6220","city":"Heppignies"},{"zip":"6220","city":"Fleurus"},{"zip":"6221","city":"Saint-Amand"},{"zip":"6222","city":"Brye"},{"zip":"6223","city":"Wagnelée"},{"zip":"6224","city":"Wanfercée-Baulet"},{"zip":"6230","city":"Pont-à-Celles"},{"zip":"6230","city":"Obaix"},{"zip":"6230","city":"Thiméon"},{"zip":"6230","city":"Viesville"},{"zip":"6230","city":"Buzet"},{"zip":"6238","city":"Luttre"},{"zip":"6238","city":"Liberchies"},{"zip":"6240","city":"Pironchamps"},{"zip":"6240","city":"Farciennes"},{"zip":"6250","city":"Aiseau"},{"zip":"6250","city":"Presles"},{"zip":"6250","city":"Pont-de-Loup"},{"zip":"6250","city":"Aiseau-Presles"},{"zip":"6250","city":"Roselies"},{"zip":"6280","city":"Acoz"},{"zip":"6280","city":"Loverval"},{"zip":"6280","city":"Joncret"},{"zip":"6280","city":"Gerpinnes"},{"zip":"6280","city":"Villers-Poterie"},{"zip":"6280","city":"Gougnies"},{"zip":"6440","city":"Vergnies"},{"zip":"6440","city":"Boussu-lez-Walcourt"},{"zip":"6440","city":"Froidchapelle"},{"zip":"6440","city":"Fourbechies"},{"zip":"6441","city":"Erpion"},{"zip":"6460","city":"Salles"},{"zip":"6460","city":"Villers-la-Tour"},{"zip":"6460","city":"Chimay"},{"zip":"6460","city":"Bailièvre"},{"zip":"6460","city":"Robechies"},{"zip":"6460","city":"Saint-Remy (Ht.)"},{"zip":"6461","city":"Virelles"},{"zip":"6462","city":"Vaulx-lez-Chimay"},{"zip":"6463","city":"Lompret"},{"zip":"6464","city":"Rièzes"},{"zip":"6464","city":"Baileux"},{"zip":"6464","city":"l'Escaillère"},{"zip":"6464","city":"Forges"},{"zip":"6464","city":"Bourlers"},{"zip":"6470","city":"Sivry"},{"zip":"6470","city":"Sivry-Rance"},{"zip":"6470","city":"Sautin"},{"zip":"6470","city":"Grandrieu"},{"zip":"6470","city":"Rance"},{"zip":"6470","city":"Montbliart"},{"zip":"6500","city":"Renlies"},{"zip":"6500","city":"Beaumont"},{"zip":"6500","city":"Solre-Saint-Géry"},{"zip":"6500","city":"Thirimont"},{"zip":"6500","city":"Leugnies"},{"zip":"6500","city":"Barbençon"},{"zip":"6500","city":"Leval-Chaudeville"},{"zip":"6511","city":"Strée (Ht.)"},{"zip":"6530","city":"Thuin"},{"zip":"6530","city":"Leers-et-Fosteau"},{"zip":"6531","city":"Biesme-sous-Thuin"},{"zip":"6532","city":"Ragnies"},{"zip":"6533","city":"Biercée"},{"zip":"6534","city":"Gozée"},{"zip":"6536","city":"Donstiennes"},{"zip":"6536","city":"Thuillies"},{"zip":"6540","city":"Lobbes"},{"zip":"6540","city":"Mont-Sainte-Geneviève"},{"zip":"6542","city":"Sars-la-Buissière"},{"zip":"6543","city":"Bienne-lez-Happart"},{"zip":"6560","city":"Bersillies-l'Abbaye"},{"zip":"6560","city":"Erquelinnes"},{"zip":"6560","city":"Hantes-Wihéries"},{"zip":"6560","city":"Montignies-Saint-Christophe"},{"zip":"6560","city":"Solre-sur-Sambre"},{"zip":"6560","city":"Grand-Reng"},{"zip":"6567","city":"Merbes-le-Château"},{"zip":"6567","city":"Merbes-Sainte-Marie"},{"zip":"6567","city":"Labuissière"},{"zip":"6567","city":"Fontaine-Valmont"},{"zip":"6590","city":"Momignies"},{"zip":"6591","city":"Macon"},{"zip":"6592","city":"Monceau-Imbrechies"},{"zip":"6593","city":"Macquenoise"},{"zip":"6594","city":"Beauwelz"},{"zip":"6596","city":"Forge-Philippe"},{"zip":"6596","city":"Seloignes"},{"zip":"6600","city":"Bastogne(Bastogne)"},{"zip":"6600","city":"Bastogne(Wardin)"},{"zip":"6600","city":"Bastogne(Villers-La-Bonne-Eau)"},{"zip":"6600","city":"Bastogne(Longvilly)"},{"zip":"6600","city":"Bastogne(Noville (Lux.))"},{"zip":"6630","city":"Martelange"},{"zip":"6637","city":"Hollange"},{"zip":"6637","city":"Fauvillers"},{"zip":"6637","city":"Tintange"},{"zip":"6640","city":"Sibret"},{"zip":"6640","city":"Vaux-lez-Rosières"},{"zip":"6640","city":"Vaux-sur-Sure"},{"zip":"6640","city":"Hompré"},{"zip":"6640","city":"Morhet"},{"zip":"6640","city":"Nives"},{"zip":"6642","city":"Juseret"},{"zip":"6660","city":"Houffalize"},{"zip":"6660","city":"Nadrin"},{"zip":"6661","city":"Tailles"},{"zip":"6661","city":"Mont (Lux.)"},{"zip":"6662","city":"Tavigny"},{"zip":"6663","city":"Mabompré"},{"zip":"6666","city":"Wibrin"},{"zip":"6670","city":"Gouvy"},{"zip":"6670","city":"Limerlé"},{"zip":"6671","city":"Bovigny"},{"zip":"6672","city":"Beho"},{"zip":"6673","city":"Cherain"},{"zip":"6674","city":"Montleban"},{"zip":"6680","city":"Tillet"},{"zip":"6680","city":"Sainte-Ode"},{"zip":"6680","city":"Amberloup"},{"zip":"6681","city":"Lavacherie"},{"zip":"6686","city":"Flamierge"},{"zip":"6687","city":"Bastogne(Bertogne)"},{"zip":"6688","city":"Longchamps (Lux.)"},{"zip":"6690","city":"Vielsalm"},{"zip":"6690","city":"Bihain"},{"zip":"6692","city":"Petit-Thier"},{"zip":"6698","city":"Grand-Halleux"},{"zip":"6700","city":"Bonnert"},{"zip":"6700","city":"Toernich"},{"zip":"6700","city":"Arlon"},{"zip":"6700","city":"Heinsch"},{"zip":"6704","city":"Guirsch"},{"zip":"6706","city":"Autelbas"},{"zip":"6717","city":"Thiaumont"},{"zip":"6717","city":"Attert"},{"zip":"6717","city":"Nobressart"},{"zip":"6717","city":"Tontelange"},{"zip":"6717","city":"Nothomb"},{"zip":"6720","city":"Hachy"},{"zip":"6720","city":"Habay-la-Neuve"},{"zip":"6720","city":"Habay"},{"zip":"6721","city":"Anlier"},{"zip":"6723","city":"Habay-la-Vieille"},{"zip":"6724","city":"Houdemont"},{"zip":"6724","city":"Rulles"},{"zip":"6724","city":"Marbehan"},{"zip":"6730","city":"Bellefontaine (Lux.)"},{"zip":"6730","city":"Rossignol"},{"zip":"6730","city":"Tintigny"},{"zip":"6730","city":"Saint-Vincent"},{"zip":"6740","city":"Sainte-Marie-sur-Semois"},{"zip":"6740","city":"Etalle"},{"zip":"6740","city":"Villers-sur-Semois"},{"zip":"6741","city":"Vance"},{"zip":"6742","city":"Chantemelle"},{"zip":"6743","city":"Buzenol"},{"zip":"6747","city":"Meix-le-Tige"},{"zip":"6747","city":"Châtillon"},{"zip":"6747","city":"Saint-Léger (Lux.)"},{"zip":"6750","city":"Musson"},{"zip":"6750","city":"Signeulx"},{"zip":"6750","city":"Mussy-la-Ville"},{"zip":"6760","city":"Bleid"},{"zip":"6760","city":"Virton"},{"zip":"6760","city":"Ruette"},{"zip":"6760","city":"Ethe"},{"zip":"6761","city":"Latour"},{"zip":"6762","city":"Saint-Mard"},{"zip":"6767","city":"Rouvroy"},{"zip":"6767","city":"Torgny"},{"zip":"6767","city":"Lamorteau"},{"zip":"6767","city":"Dampicourt"},{"zip":"6767","city":"Harnoncourt"},{"zip":"6769","city":"Gérouville"},{"zip":"6769","city":"Villers-la-Loue"},{"zip":"6769","city":"Meix-Devant-Virton"},{"zip":"6769","city":"Robelmont"},{"zip":"6769","city":"Sommethonne"},{"zip":"6780","city":"Hondelange"},{"zip":"6780","city":"Messancy"},{"zip":"6780","city":"Wolkrange"},{"zip":"6781","city":"Sélange"},{"zip":"6782","city":"Habergy"},{"zip":"6790","city":"Aubange"},{"zip":"6791","city":"Athus"},{"zip":"6792","city":"Halanzy"},{"zip":"6792","city":"Rachecourt"},{"zip":"6800","city":"Moircy"},{"zip":"6800","city":"Sainte-Marie-Chevigny"},{"zip":"6800","city":"Libramont-Chevigny"},{"zip":"6800","city":"Bras"},{"zip":"6800","city":"Freux"},{"zip":"6800","city":"Remagne"},{"zip":"6800","city":"Recogne"},{"zip":"6800","city":"Saint-Pierre"},{"zip":"6810","city":"Jamoigne"},{"zip":"6810","city":"Chiny"},{"zip":"6810","city":"Izel"},{"zip":"6811","city":"Les Bulles"},{"zip":"6812","city":"Suxy"},{"zip":"6813","city":"Termes"},{"zip":"6820","city":"Florenville"},{"zip":"6820","city":"Muno"},{"zip":"6820","city":"Fontenoille"},{"zip":"6820","city":"Sainte-Cécile"},{"zip":"6821","city":"Lacuisine"},{"zip":"6823","city":"Villers-Devant-Orval"},{"zip":"6824","city":"Chassepierre"},{"zip":"6830","city":"Rochehaut"},{"zip":"6830","city":"Poupehan"},{"zip":"6830","city":"Les Hayons"},{"zip":"6830","city":"Bouillon"},{"zip":"6831","city":"Noirefontaine"},{"zip":"6832","city":"Sensenruth"},{"zip":"6833","city":"Vivy"},{"zip":"6833","city":"Ucimont"},{"zip":"6834","city":"Bellevaux"},{"zip":"6836","city":"Dohan"},{"zip":"6838","city":"Corbion"},{"zip":"6840","city":"Tournay"},{"zip":"6840","city":"Neufchâteau"},{"zip":"6840","city":"Hamipré"},{"zip":"6840","city":"Grapfontaine"},{"zip":"6840","city":"Grandvoir"},{"zip":"6840","city":"Longlier"},{"zip":"6850","city":"Carlsbourg"},{"zip":"6850","city":"Offagne"},{"zip":"6850","city":"Paliseul"},{"zip":"6851","city":"Nollevaux"},{"zip":"6852","city":"Maissin"},{"zip":"6852","city":"Opont"},{"zip":"6853","city":"Framont"},{"zip":"6856","city":"Fays-les-Veneurs"},{"zip":"6860","city":"Léglise"},{"zip":"6860","city":"Mellier"},{"zip":"6860","city":"Witry"},{"zip":"6860","city":"Ebly"},{"zip":"6860","city":"Assenois"},{"zip":"6870","city":"Mirwart"},{"zip":"6870","city":"Vesqueville"},{"zip":"6870","city":"Arville"},{"zip":"6870","city":"Awenne"},{"zip":"6870","city":"Saint-Hubert"},{"zip":"6870","city":"Hatrival"},{"zip":"6880","city":"Bertrix"},{"zip":"6880","city":"Cugnon"},{"zip":"6880","city":"Orgeo"},{"zip":"6880","city":"Auby-sur-Semois"},{"zip":"6880","city":"Jehonville"},{"zip":"6887","city":"Saint-Médard"},{"zip":"6887","city":"Straimont"},{"zip":"6887","city":"Herbeumont"},{"zip":"6890","city":"Libin"},{"zip":"6890","city":"Redu"},{"zip":"6890","city":"Ochamps"},{"zip":"6890","city":"Transinne"},{"zip":"6890","city":"Anloy"},{"zip":"6890","city":"Villance"},{"zip":"6890","city":"Smuid"},{"zip":"6900","city":"Marche-en-Famenne"},{"zip":"6900","city":"Humain"},{"zip":"6900","city":"Waha"},{"zip":"6900","city":"Hargimont"},{"zip":"6900","city":"Aye"},{"zip":"6900","city":"On"},{"zip":"6900","city":"Roy"},{"zip":"6920","city":"Wellin"},{"zip":"6920","city":"Sohier"},{"zip":"6921","city":"Chanly"},{"zip":"6922","city":"Halma"},{"zip":"6924","city":"Lomprez"},{"zip":"6927","city":"Tellin"},{"zip":"6927","city":"Bure"},{"zip":"6927","city":"Grupont"},{"zip":"6927","city":"Resteigne"},{"zip":"6929","city":"Porcheresse (Lux.)"},{"zip":"6929","city":"Daverdisse"},{"zip":"6929","city":"Haut-Fays"},{"zip":"6929","city":"Gembes"},{"zip":"6940","city":"Wéris"},{"zip":"6940","city":"Septon"},{"zip":"6940","city":"Grandhan"},{"zip":"6940","city":"Durbuy"},{"zip":"6940","city":"Barvaux-sur-Ourthe"},{"zip":"6941","city":"Bende"},{"zip":"6941","city":"Villers-Sainte-Gertrude"},{"zip":"6941","city":"Izier"},{"zip":"6941","city":"Bomal-sur-Ourthe"},{"zip":"6941","city":"Tohogne"},{"zip":"6941","city":"Heyd"},{"zip":"6941","city":"Borlon"},{"zip":"6950","city":"Nassogne"},{"zip":"6950","city":"Harsin"},{"zip":"6951","city":"Bande"},{"zip":"6952","city":"Grune"},{"zip":"6953","city":"Ambly"},{"zip":"6953","city":"Forrières"},{"zip":"6953","city":"Lesterny"},{"zip":"6953","city":"Masbourg"},{"zip":"6960","city":"Harre"},{"zip":"6960","city":"Malempré"},{"zip":"6960","city":"Manhay"},{"zip":"6960","city":"Odeigne"},{"zip":"6960","city":"Dochamps"},{"zip":"6960","city":"Vaux-Chavanne"},{"zip":"6960","city":"Grandmenil"},{"zip":"6970","city":"Tenneville"},{"zip":"6971","city":"Champlon"},{"zip":"6972","city":"Erneuville"},{"zip":"6980","city":"La Roche-en-Ardenne"},{"zip":"6980","city":"Beausaint"},{"zip":"6982","city":"Samrée"},{"zip":"6983","city":"Ortho"},{"zip":"6984","city":"Hives"},{"zip":"6986","city":"Halleux"},{"zip":"6987","city":"Hodister"},{"zip":"6987","city":"Marcourt"},{"zip":"6987","city":"Rendeux"},{"zip":"6987","city":"Beffe"},{"zip":"6990","city":"Fronville"},{"zip":"6990","city":"Marenne"},{"zip":"6990","city":"Hampteau"},{"zip":"6990","city":"Hotton"},{"zip":"6997","city":"Amonines"},{"zip":"6997","city":"Erezée"},{"zip":"6997","city":"Soy"},{"zip":"6997","city":"Mormont"},{"zip":"7000","city":"Mons"},{"zip":"7010","city":"S.H.A.P.E. Belgique"},{"zip":"7010","city":"S.H.A.P.E. België"},{"zip":"7011","city":"Ghlin"},{"zip":"7012","city":"Flénu"},{"zip":"7012","city":"Jemappes"},{"zip":"7020","city":"Maisières"},{"zip":"7020","city":"Nimy"},{"zip":"7021","city":"Havré"},{"zip":"7022","city":"Hyon"},{"zip":"7022","city":"Mesvin"},{"zip":"7022","city":"Harveng"},{"zip":"7022","city":"Harmignies"},{"zip":"7022","city":"Nouvelles"},{"zip":"7024","city":"Ciply"},{"zip":"7030","city":"Saint-Symphorien"},{"zip":"7031","city":"Villers-Saint-Ghislain"},{"zip":"7032","city":"Spiennes"},{"zip":"7033","city":"Cuesmes"},{"zip":"7034","city":"Obourg"},{"zip":"7034","city":"Saint-Denis (Ht.)"},{"zip":"7040","city":"Quévy"},{"zip":"7040","city":"Genly"},{"zip":"7040","city":"Asquillies"},{"zip":"7040","city":"Blaregnies"},{"zip":"7040","city":"Bougnies"},{"zip":"7040","city":"Goegnies-Chaussée"},{"zip":"7040","city":"Aulnois"},{"zip":"7040","city":"Quévy-le-Petit"},{"zip":"7040","city":"Quévy-le-Grand"},{"zip":"7041","city":"Havay"},{"zip":"7041","city":"Givry"},{"zip":"7050","city":"Masnuy-Saint-Jean (Jurbise)"},{"zip":"7050","city":"Masnuy-Saint-Pierre"},{"zip":"7050","city":"Erbaut"},{"zip":"7050","city":"Herchies"},{"zip":"7050","city":"Erbisoeul"},{"zip":"7050","city":"Jurbise"},{"zip":"7060","city":"Horrues"},{"zip":"7060","city":"Soignies"},{"zip":"7061","city":"Casteau (Soignies)"},{"zip":"7061","city":"Thieusies"},{"zip":"7062","city":"Naast"},{"zip":"7063","city":"Chaussée-Notre-Dame-Louvignies"},{"zip":"7063","city":"Neufvilles"},{"zip":"7070","city":"Mignault"},{"zip":"7070","city":"Le Roeulx"},{"zip":"7070","city":"Ville-sur-Haine (Le Roeulx)"},{"zip":"7070","city":"Thieu"},{"zip":"7070","city":"Gottignies"},{"zip":"7080","city":"Sars-la-Bruyère"},{"zip":"7080","city":"Frameries"},{"zip":"7080","city":"La Bouverie"},{"zip":"7080","city":"Noirchain"},{"zip":"7080","city":"Eugies (Frameries)"},{"zip":"7090","city":"Ronquières"},{"zip":"7090","city":"Hennuyères"},{"zip":"7090","city":"Henripont"},{"zip":"7090","city":"Braine-le-Comte"},{"zip":"7090","city":"Steenkerque (Ht.)"},{"zip":"7090","city":"Petit-Roeulx-lez-Braine"},{"zip":"7100","city":"Haine-Saint-Paul"},{"zip":"7100","city":"Trivières"},{"zip":"7100","city":"Haine-Saint-Pierre"},{"zip":"7100","city":"Saint-Vaast"},{"zip":"7100","city":"La Louvière"},{"zip":"7110","city":"Maurage"},{"zip":"7110","city":"Houdeng-Goegnies (La Louvière)"},{"zip":"7110","city":"Boussoit"},{"zip":"7110","city":"Houdeng-Aimeries"},{"zip":"7110","city":"Strépy-Bracquegnies"},{"zip":"7120","city":"Rouveroy (Ht.)"},{"zip":"7120","city":"Vellereille-le-Sec"},{"zip":"7120","city":"Vellereille-les-Brayeux"},{"zip":"7120","city":"Croix-lez-Rouveroy"},{"zip":"7120","city":"Fauroeulx"},{"zip":"7120","city":"Estinnes-au-Val"},{"zip":"7120","city":"Estinnes-au-Mont"},{"zip":"7120","city":"Estinnes"},{"zip":"7120","city":"Haulchin"},{"zip":"7120","city":"Peissant"},{"zip":"7130","city":"Binche"},{"zip":"7130","city":"Bray"},{"zip":"7130","city":"Battignies"},{"zip":"7131","city":"Waudrez"},{"zip":"7133","city":"Buvrinnes"},{"zip":"7134","city":"Péronnes-lez-Binche"},{"zip":"7134","city":"Leval-Trahegnies"},{"zip":"7134","city":"Epinois"},{"zip":"7134","city":"Ressaix"},{"zip":"7140","city":"Morlanwelz-Mariemont"},{"zip":"7140","city":"Morlanwelz"},{"zip":"7141","city":"Mont-Sainte-Aldegonde"},{"zip":"7141","city":"Carnières"},{"zip":"7160","city":"Godarville"},{"zip":"7160","city":"Piéton"},{"zip":"7160","city":"Chapelle-lez-Herlaimont"},{"zip":"7170","city":"Manage"},{"zip":"7170","city":"Bois-d'Haine"},{"zip":"7170","city":"Bellecourt"},{"zip":"7170","city":"La Hestre"},{"zip":"7170","city":"Fayt-lez-Manage"},{"zip":"7180","city":"Seneffe"},{"zip":"7181","city":"Arquennes"},{"zip":"7181","city":"Petit-Roeulx-lez-Nivelles"},{"zip":"7181","city":"Familleureux"},{"zip":"7181","city":"Feluy"},{"zip":"7190","city":"Ecaussinnes-d'Enghien"},{"zip":"7190","city":"Marche-lez-Ecaussinnes"},{"zip":"7190","city":"Ecaussinnes"},{"zip":"7191","city":"Ecaussinnes-Lalaing"},{"zip":"7300","city":"Boussu"},{"zip":"7301","city":"Hornu"},{"zip":"7320","city":"Bernissart"},{"zip":"7321","city":"Blaton"},{"zip":"7321","city":"Harchies"},{"zip":"7322","city":"Ville-Pommeroeul"},{"zip":"7322","city":"Pommeroeul"},{"zip":"7330","city":"Saint-Ghislain"},{"zip":"7331","city":"Baudour"},{"zip":"7332","city":"Neufmaison"},{"zip":"7332","city":"Sirault"},{"zip":"7333","city":"Tertre"},{"zip":"7334","city":"Villerot"},{"zip":"7334","city":"Hautrage"},{"zip":"7340","city":"Colfontaine"},{"zip":"7340","city":"Warquignies"},{"zip":"7340","city":"Paturages"},{"zip":"7340","city":"Wasmes"},{"zip":"7350","city":"Hainin"},{"zip":"7350","city":"Thulin"},{"zip":"7350","city":"Hensies"},{"zip":"7350","city":"Montroeul-sur-Haine"},{"zip":"7370","city":"Wihéries"},{"zip":"7370","city":"Elouges"},{"zip":"7370","city":"Blaugies"},{"zip":"7370","city":"Dour"},{"zip":"7380","city":"Baisieux"},{"zip":"7380","city":"Quiévrain"},{"zip":"7382","city":"Audregnies"},{"zip":"7387","city":"Angreau"},{"zip":"7387","city":"Angre"},{"zip":"7387","city":"Honnelles"},{"zip":"7387","city":"Roisin"},{"zip":"7387","city":"Autreppe"},{"zip":"7387","city":"Marchipont"},{"zip":"7387","city":"Onnezies"},{"zip":"7387","city":"Fayt-le-Franc"},{"zip":"7387","city":"Montignies-sur-Roc"},{"zip":"7387","city":"Athis"},{"zip":"7387","city":"Erquennes"},{"zip":"7390","city":"Wasmuel"},{"zip":"7390","city":"Quaregnon"},{"zip":"7500","city":"Ere"},{"zip":"7500","city":"Saint-Maur"},{"zip":"7500","city":"Tournai"},{"zip":"7501","city":"Orcq"},{"zip":"7502","city":"Esplechin"},{"zip":"7503","city":"Froyennes"},{"zip":"7504","city":"Froidmont"},{"zip":"7506","city":"Willemeau"},{"zip":"7520","city":"Ramegnies-Chin"},{"zip":"7520","city":"Templeuve"},{"zip":"7521","city":"Chercq"},{"zip":"7522","city":"Marquain"},{"zip":"7522","city":"Lamain"},{"zip":"7522","city":"Blandain"},{"zip":"7522","city":"Hertain"},{"zip":"7530","city":"Gaurain-Ramecroix (Tournai)"},{"zip":"7531","city":"Havinnes"},{"zip":"7532","city":"Beclers"},{"zip":"7533","city":"Thimougies"},{"zip":"7534","city":"Maulde"},{"zip":"7534","city":"Barry"},{"zip":"7536","city":"Vaulx (Tournai)"},{"zip":"7538","city":"Vezon"},{"zip":"7540","city":"Quartes"},{"zip":"7540","city":"Rumillies"},{"zip":"7540","city":"Melles"},{"zip":"7540","city":"Kain"},{"zip":"7542","city":"Mont-Saint-Aubert"},{"zip":"7543","city":"Mourcourt"},{"zip":"7548","city":"Warchin"},{"zip":"7600","city":"Péruwelz"},{"zip":"7601","city":"Roucourt"},{"zip":"7602","city":"Bury"},{"zip":"7603","city":"Bon-Secours"},{"zip":"7604","city":"Wasmes-Audemez-Briffoeil"},{"zip":"7604","city":"Baugnies"},{"zip":"7604","city":"Braffe"},{"zip":"7604","city":"Brasmenil"},{"zip":"7604","city":"Callenelle"},{"zip":"7608","city":"Wiers"},{"zip":"7610","city":"Rumes"},{"zip":"7611","city":"La Glanerie"},{"zip":"7618","city":"Taintignies"},{"zip":"7620","city":"Bléharies"},{"zip":"7620","city":"Wez-Velvain"},{"zip":"7620","city":"Brunehaut"},{"zip":"7620","city":"Guignies"},{"zip":"7620","city":"Hollain"},{"zip":"7620","city":"Jollain-Merlin"},{"zip":"7621","city":"Lesdain"},{"zip":"7622","city":"Laplaigne"},{"zip":"7623","city":"Rongy"},{"zip":"7624","city":"Howardries"},{"zip":"7640","city":"Antoing"},{"zip":"7640","city":"Péronnes-lez-Antoing"},{"zip":"7640","city":"Maubray"},{"zip":"7641","city":"Bruyelle"},{"zip":"7642","city":"Calonne"},{"zip":"7643","city":"Fontenoy"},{"zip":"7700","city":"Luingne"},{"zip":"7700","city":"Moeskroen"},{"zip":"7700","city":"Mouscron"},{"zip":"7711","city":"Dottenijs"},{"zip":"7711","city":"Dottignies"},{"zip":"7712","city":"Herseaux"},{"zip":"7730","city":"Néchin"},{"zip":"7730","city":"Saint-Léger (Ht.)"},{"zip":"7730","city":"Estaimbourg"},{"zip":"7730","city":"Estaimpuis"},{"zip":"7730","city":"Evregnies"},{"zip":"7730","city":"Leers-Nord"},{"zip":"7730","city":"Bailleul"},{"zip":"7740","city":"Warcoing"},{"zip":"7740","city":"Pecq"},{"zip":"7742","city":"Hérinnes-lez-Pecq"},{"zip":"7743","city":"Obigies"},{"zip":"7743","city":"Esquelmes"},{"zip":"7750","city":"Amougies"},{"zip":"7750","city":"Orroir"},{"zip":"7750","city":"Mont-de-l'Enclus"},{"zip":"7750","city":"Russeignies"},{"zip":"7750","city":"Anseroeul"},{"zip":"7760","city":"Pottes"},{"zip":"7760","city":"Popuelles"},{"zip":"7760","city":"Molenbaix"},{"zip":"7760","city":"Escanaffles"},{"zip":"7760","city":"Celles (Ht.)"},{"zip":"7760","city":"Velaines"},{"zip":"7780","city":"Comines-Warneton"},{"zip":"7780","city":"Komen"},{"zip":"7780","city":"Komen-Waasten"},{"zip":"7780","city":"Comines"},{"zip":"7781","city":"Houthem (Comines)"},{"zip":"7782","city":"Ploegsteert"},{"zip":"7783","city":"Bizet"},{"zip":"7784","city":"Bas-Warneton"},{"zip":"7784","city":"Waasten"},{"zip":"7784","city":"Neerwaasten"},{"zip":"7784","city":"Warneton"},{"zip":"7800","city":"Ath"},{"zip":"7800","city":"Lanquesaint"},{"zip":"7801","city":"Irchonwelz"},{"zip":"7802","city":"Ormeignies"},{"zip":"7803","city":"Bouvignies"},{"zip":"7804","city":"Rebaix"},{"zip":"7804","city":"Ostiches"},{"zip":"7810","city":"Maffle"},{"zip":"7811","city":"Arbre (Ht.)"},{"zip":"7812","city":"Villers-Notre-Dame"},{"zip":"7812","city":"Villers-Saint-Amand"},{"zip":"7812","city":"Ligne"},{"zip":"7812","city":"Moulbaix"},{"zip":"7812","city":"Houtaing"},{"zip":"7812","city":"Mainvault"},{"zip":"7822","city":"Ghislenghien"},{"zip":"7822","city":"Isières"},{"zip":"7822","city":"Meslin-l'Evêque"},{"zip":"7823","city":"Gibecq"},{"zip":"7830","city":"Hellebecq"},{"zip":"7830","city":"Graty"},{"zip":"7830","city":"Silly"},{"zip":"7830","city":"Thoricourt"},{"zip":"7830","city":"Gondregnies"},{"zip":"7830","city":"Fouleng"},{"zip":"7830","city":"Hoves (Ht.)"},{"zip":"7830","city":"Bassilly"},{"zip":"7850","city":"Enghien"},{"zip":"7850","city":"Petit-Enghien"},{"zip":"7850","city":"Edingen"},{"zip":"7850","city":"Mark"},{"zip":"7850","city":"Marcq"},{"zip":"7850","city":"Lettelingen"},{"zip":"7860","city":"Lessines"},{"zip":"7861","city":"Wannebecq"},{"zip":"7861","city":"Papignies"},{"zip":"7862","city":"Ogy"},{"zip":"7863","city":"Ghoy"},{"zip":"7864","city":"Deux-Acren"},{"zip":"7866","city":"Bois-de-Lessines"},{"zip":"7866","city":"Ollignies"},{"zip":"7870","city":"Montignies-lez-Lens"},{"zip":"7870","city":"Lens"},{"zip":"7870","city":"Cambron-Saint-Vincent"},{"zip":"7870","city":"Bauffe"},{"zip":"7870","city":"Lombise"},{"zip":"7880","city":"Flobecq"},{"zip":"7880","city":"Vloesberg"},{"zip":"7890","city":"Wodecq"},{"zip":"7890","city":"Ellezelles"},{"zip":"7890","city":"Lahamaide"},{"zip":"7900","city":"Grandmetz"},{"zip":"7900","city":"Leuze-en-Hainaut"},{"zip":"7901","city":"Thieulain"},{"zip":"7903","city":"Chapelle-à-Oie"},{"zip":"7903","city":"Blicquy"},{"zip":"7903","city":"Chapelle-à-Wattines"},{"zip":"7904","city":"Tourpes"},{"zip":"7904","city":"Pipaix"},{"zip":"7904","city":"Willaupuis"},{"zip":"7906","city":"Gallaix"},{"zip":"7910","city":"Arc-Wattripont"},{"zip":"7910","city":"Wattripont"},{"zip":"7910","city":"Cordes"},{"zip":"7910","city":"Anvaing"},{"zip":"7910","city":"Ellignies-lez-Frasnes"},{"zip":"7910","city":"Frasnes-lez-Anvaing"},{"zip":"7910","city":"Forest (Ht.)"},{"zip":"7910","city":"Arc-Ainières"},{"zip":"7911","city":"Herquegies"},{"zip":"7911","city":"Oeudeghien"},{"zip":"7911","city":"Moustier (Ht.)"},{"zip":"7911","city":"Montroeul-au-Bois"},{"zip":"7911","city":"Buissenal"},{"zip":"7911","city":"Frasnes-lez-Buissenal"},{"zip":"7911","city":"Hacquegnies"},{"zip":"7912","city":"Dergneau"},{"zip":"7912","city":"Saint-Sauveur"},{"zip":"7940","city":"Cambron-Casteau"},{"zip":"7940","city":"Brugelette"},{"zip":"7941","city":"Attre"},{"zip":"7942","city":"Mévergnies-lez-Lens"},{"zip":"7943","city":"Gages"},{"zip":"7950","city":"Huissignies"},{"zip":"7950","city":"Tongre-Saint-Martin"},{"zip":"7950","city":"Grosage"},{"zip":"7950","city":"Chièvres"},{"zip":"7950","city":"Ladeuze"},{"zip":"7951","city":"Tongre-Notre-Dame"},{"zip":"7970","city":"Beloeil"},{"zip":"7971","city":"Thumaide"},{"zip":"7971","city":"Ramegnies"},{"zip":"7971","city":"Basècles"},{"zip":"7971","city":"Wadelincourt"},{"zip":"7972","city":"Quevaucamps"},{"zip":"7972","city":"Ellignies-Sainte-Anne"},{"zip":"7972","city":"Aubechies"},{"zip":"7973","city":"Stambruges"},{"zip":"7973","city":"Grandglise"},{"zip":"8000","city":"SINT-ANDRIES"},{"zip":"8000","city":"Brugge"},{"zip":"8000","city":"Koolkerke"},{"zip":"8020","city":"Ruddervoorde"},{"zip":"8020","city":"Oostkamp"},{"zip":"8020","city":"Hertsberge"},{"zip":"8020","city":"Waardamme"},{"zip":"8200","city":"Sint-Michiels"},{"zip":"8200","city":"Sint-Andries"},{"zip":"8210","city":"Veldegem"},{"zip":"8210","city":"Zedelgem"},{"zip":"8210","city":"Loppem"},{"zip":"8211","city":"Aartrijke"},{"zip":"8300","city":"Westkapelle"},{"zip":"8300","city":"Knokke"},{"zip":"8300","city":"Knokke-Heist"},{"zip":"8301","city":"Heist-aan-Zee"},{"zip":"8301","city":"Ramskapelle (Knokke-Heist)"},{"zip":"8310","city":"Assebroek"},{"zip":"8310","city":"Sint-Kruis (Brugge)"},{"zip":"8340","city":"Moerkerke"},{"zip":"8340","city":"Damme"},{"zip":"8340","city":"Hoeke"},{"zip":"8340","city":"Sijsele"},{"zip":"8340","city":"Oostkerke (Damme)"},{"zip":"8340","city":"Lapscheure"},{"zip":"8370","city":"Blankenberge"},{"zip":"8370","city":"Uitkerke"},{"zip":"8377","city":"Nieuwmunster"},{"zip":"8377","city":"Zuienkerke"},{"zip":"8377","city":"Meetkerke"},{"zip":"8377","city":"Houtave"},{"zip":"8380","city":"Lissewege"},{"zip":"8380","city":"Dudzele"},{"zip":"8380","city":"Zeebrugge (Brugge)"},{"zip":"8400","city":"Oostende"},{"zip":"8400","city":"Zandvoorde (Oostende)"},{"zip":"8400","city":"Stene"},{"zip":"8420","city":"Wenduine"},{"zip":"8420","city":"Klemskerke"},{"zip":"8420","city":"De Haan"},{"zip":"8421","city":"Vlissegem"},{"zip":"8430","city":"Middelkerke"},{"zip":"8431","city":"Wilskerke"},{"zip":"8432","city":"Leffinge"},{"zip":"8433","city":"Mannekensvere"},{"zip":"8433","city":"Schore"},{"zip":"8433","city":"Slijpe"},{"zip":"8433","city":"Spermalie"},{"zip":"8433","city":"Sint-Pieters-Kapelle (W.-Vl.)"},{"zip":"8434","city":"Westende"},{"zip":"8434","city":"Lombardsijde"},{"zip":"8450","city":"Bredene"},{"zip":"8460","city":"Westkerke"},{"zip":"8460","city":"Oudenburg"},{"zip":"8460","city":"Ettelgem"},{"zip":"8460","city":"Roksem"},{"zip":"8470","city":"Zevekote"},{"zip":"8470","city":"Moere"},{"zip":"8470","city":"Gistel"},{"zip":"8470","city":"Snaaskerke"},{"zip":"8480","city":"Eernegem"},{"zip":"8480","city":"Ichtegem"},{"zip":"8480","city":"Bekegem"},{"zip":"8490","city":"Stalhille"},{"zip":"8490","city":"Jabbeke"},{"zip":"8490","city":"Zerkegem"},{"zip":"8490","city":"Varsenare"},{"zip":"8490","city":"BRUSSEL"},{"zip":"8490","city":"Snellegem"},{"zip":"8500","city":"Kortrijk"},{"zip":"8501","city":"Heule"},{"zip":"8501","city":"Bissegem"},{"zip":"8510","city":"Rollegem"},{"zip":"8510","city":"Marke (Kortrijk)"},{"zip":"8510","city":"Kooigem"},{"zip":"8510","city":"Bellegem"},{"zip":"8511","city":"Aalbeke"},{"zip":"8520","city":"Kuurne"},{"zip":"8530","city":"Harelbeke"},{"zip":"8531","city":"Hulste"},{"zip":"8531","city":"Bavikhove"},{"zip":"8540","city":"Deerlijk"},{"zip":"8550","city":"Zwevegem"},{"zip":"8551","city":"Heestert"},{"zip":"8552","city":"Moen"},{"zip":"8553","city":"Otegem"},{"zip":"8554","city":"Sint-Denijs"},{"zip":"8560","city":"Moorsele"},{"zip":"8560","city":"Gullegem"},{"zip":"8560","city":"Wevelgem"},{"zip":"8570","city":"Gijzelbrechtegem"},{"zip":"8570","city":"Anzegem"},{"zip":"8570","city":"Vichte"},{"zip":"8570","city":"Ingooigem"},{"zip":"8572","city":"Kaster"},{"zip":"8573","city":"Tiegem"},{"zip":"8580","city":"Avelgem"},{"zip":"8581","city":"Waarmaarde"},{"zip":"8581","city":"Kerkhove"},{"zip":"8582","city":"Outrijve"},{"zip":"8583","city":"Bossuit"},{"zip":"8587","city":"Helkijn"},{"zip":"8587","city":"Espierres"},{"zip":"8587","city":"Spiere-Helkijn"},{"zip":"8587","city":"Spiere"},{"zip":"8587","city":"Helchin"},{"zip":"8587","city":"Espierres-Helchin"},{"zip":"8600","city":"Lampernisse"},{"zip":"8600","city":"Stuivekenskerke"},{"zip":"8600","city":"Kaaskerke"},{"zip":"8600","city":"Esen"},{"zip":"8600","city":"Driekapellen"},{"zip":"8600","city":"Diksmuide"},{"zip":"8600","city":"Beerst"},{"zip":"8600","city":"Vladslo"},{"zip":"8600","city":"Leke"},{"zip":"8600","city":"Woumen"},{"zip":"8600","city":"Oostkerke (Diksmuide)"},{"zip":"8600","city":"Pervijze"},{"zip":"8600","city":"Oudekapelle"},{"zip":"8600","city":"Keiem"},{"zip":"8600","city":"Sint-Jacobs-Kapelle"},{"zip":"8600","city":"Nieuwkapelle"},{"zip":"8610","city":"Kortemark"},{"zip":"8610","city":"Handzame"},{"zip":"8610","city":"Zarren"},{"zip":"8610","city":"Werken"},{"zip":"8620","city":"Ramskapelle (Nieuwpoort)"},{"zip":"8620","city":"Nieuwpoort"},{"zip":"8620","city":"Sint-Joris (Nieuwpoort)"},{"zip":"8630","city":"Zoutenaaie"},{"zip":"8630","city":"Booitshoeke"},{"zip":"8630","city":"Beauvoorde"},{"zip":"8630","city":"Avekapelle"},{"zip":"8630","city":"Steenkerke (W.-Vl.)"},{"zip":"8630","city":"Vinkem"},{"zip":"8630","city":"Eggewaartskapelle"},{"zip":"8630","city":"Houtem (W.-Vl.)"},{"zip":"8630","city":"Bulskamp"},{"zip":"8630","city":"Wulveringem"},{"zip":"8630","city":"Veurne"},{"zip":"8630","city":"De Moeren"},{"zip":"8640","city":"Westvleteren"},{"zip":"8640","city":"Vleteren"},{"zip":"8640","city":"Oostvleteren"},{"zip":"8640","city":"Woesten"},{"zip":"8647","city":"Pollinkhove"},{"zip":"8647","city":"Reninge"},{"zip":"8647","city":"Lo-Reninge"},{"zip":"8647","city":"Lo"},{"zip":"8647","city":"Noordschote"},{"zip":"8650","city":"Houthulst"},{"zip":"8650","city":"Klerken"},{"zip":"8650","city":"Merkem"},{"zip":"8660","city":"De Panne"},{"zip":"8660","city":"Adinkerke"},{"zip":"8670","city":"Wulpen"},{"zip":"8670","city":"Oostduinkerke"},{"zip":"8670","city":"Koksijde"},{"zip":"8680","city":"Zande"},{"zip":"8680","city":"Koekelare"},{"zip":"8680","city":"Bovekerke"},{"zip":"8690","city":"Hoogstade"},{"zip":"8690","city":"Sint-Rijkers"},{"zip":"8690","city":"Alveringem"},{"zip":"8690","city":"Oeren"},{"zip":"8691","city":"Beveren-aan-den-Ijzer"},{"zip":"8691","city":"Leisele"},{"zip":"8691","city":"Izenberge"},{"zip":"8691","city":"Stavele"},{"zip":"8691","city":"Gijverinkhove"},{"zip":"8700","city":"Tielt(Kanegem)"},{"zip":"8700","city":"Tielt(Schuiferskapelle)"},{"zip":"8700","city":"Tielt(Aarsele)"},{"zip":"8700","city":"Tielt(Tielt)"},{"zip":"8710","city":"Wielsbeke"},{"zip":"8710","city":"Sint-Baafs-Vijve"},{"zip":"8710","city":"Ooigem"},{"zip":"8720","city":"Markegem"},{"zip":"8720","city":"Dentergem"},{"zip":"8720","city":"Oeselgem"},{"zip":"8720","city":"Wakken"},{"zip":"8730","city":"Sint-Joris (Beernem)"},{"zip":"8730","city":"Oedelem"},{"zip":"8730","city":"Beernem"},{"zip":"8740","city":"Pittem"},{"zip":"8740","city":"Egem"},{"zip":"8750","city":"Wingene(Zwevezele)"},{"zip":"8750","city":"Wingene(Wingene)"},{"zip":"8755","city":"Wingene(Ruiselede)"},{"zip":"8760","city":"Tielt(Meulebeke)"},{"zip":"8770","city":"Ingelmunster"},{"zip":"8780","city":"Oostrozebeke"},{"zip":"8790","city":"Waregem"},{"zip":"8791","city":"Beveren (Leie)"},{"zip":"8792","city":"Desselgem"},{"zip":"8793","city":"Sint-Eloois-Vijve"},{"zip":"8800","city":"Oekene"},{"zip":"8800","city":"Rumbeke"},{"zip":"8800","city":"Beveren (Roeselare)"},{"zip":"8800","city":"Roeselare"},{"zip":"8810","city":"Lichtervelde"},{"zip":"8820","city":"Torhout"},{"zip":"8830","city":"Gits"},{"zip":"8830","city":"Hooglede"},{"zip":"8840","city":"Westrozebeke"},{"zip":"8840","city":"Staden"},{"zip":"8840","city":"Oostnieuwkerke"},{"zip":"8850","city":"Ardooie"},{"zip":"8851","city":"Koolskamp"},{"zip":"8860","city":"Lendelede"},{"zip":"8870","city":"Izegem"},{"zip":"8870","city":"Emelgem"},{"zip":"8870","city":"Kachtem"},{"zip":"8880","city":"Ledegem"},{"zip":"8880","city":"Rollegem-Kapelle"},{"zip":"8880","city":"Sint-Eloois-Winkel"},{"zip":"8890","city":"Moorslede"},{"zip":"8890","city":"Dadizele"},{"zip":"8900","city":"Sint-Jan"},{"zip":"8900","city":"Brielen"},{"zip":"8900","city":"Dikkebus"},{"zip":"8900","city":"Ieper"},{"zip":"8902","city":"Voormezele"},{"zip":"8902","city":"Hollebeke"},{"zip":"8902","city":"Zillebeke"},{"zip":"8904","city":"Boezinge"},{"zip":"8904","city":"Zuidschote"},{"zip":"8906","city":"Elverdinge"},{"zip":"8908","city":"Vlamertinge"},{"zip":"8920","city":"Langemark"},{"zip":"8920","city":"Langemark-Poelkapelle"},{"zip":"8920","city":"Bikschote"},{"zip":"8920","city":"Poelkapelle"},{"zip":"8930","city":"Lauwe"},{"zip":"8930","city":"Menen"},{"zip":"8930","city":"Rekkem"},{"zip":"8940","city":"Wervik"},{"zip":"8940","city":"Geluwe"},{"zip":"8950","city":"Heuvelland"},{"zip":"8950","city":"Nieuwkerke"},{"zip":"8951","city":"Dranouter"},{"zip":"8952","city":"Wulvergem"},{"zip":"8953","city":"Wijtschate"},{"zip":"8954","city":"Westouter"},{"zip":"8956","city":"Kemmel"},{"zip":"8957","city":"Messines"},{"zip":"8957","city":"Mesen"},{"zip":"8958","city":"Loker"},{"zip":"8970","city":"Poperinge"},{"zip":"8970","city":"Reningelst"},{"zip":"8972","city":"Proven"},{"zip":"8972","city":"Krombeke"},{"zip":"8972","city":"Roesbrugge-Haringe"},{"zip":"8978","city":"Watou"},{"zip":"8980","city":"Zandvoorde (Zonnebeke)"},{"zip":"8980","city":"Geluveld"},{"zip":"8980","city":"Passendale"},{"zip":"8980","city":"Beselare"},{"zip":"8980","city":"Zonnebeke"},{"zip":"9000","city":"Gent"},{"zip":"9030","city":"Mariakerke (Gent)"},{"zip":"9031","city":"Drongen"},{"zip":"9032","city":"Wondelgem"},{"zip":"9040","city":"Sint-Amandsberg (Gent)"},{"zip":"9041","city":"Oostakker"},{"zip":"9042","city":"Desteldonk"},{"zip":"9042","city":"Sint-Kruis-Winkel"},{"zip":"9042","city":"Mendonk"},{"zip":"9050","city":"Ledeberg (Gent)"},{"zip":"9050","city":"Gentbrugge"},{"zip":"9051","city":"Sint-Denijs-Westrem"},{"zip":"9051","city":"Afsnee"},{"zip":"9052","city":"Zwijnaarde"},{"zip":"9060","city":"Zelzate"},{"zip":"9070","city":"Destelbergen"},{"zip":"9070","city":"Heusden (O.-Vl.)"},{"zip":"9080","city":"Lochristi(Lochristi)"},{"zip":"9080","city":"Lochristi(Zeveneken)"},{"zip":"9080","city":"Lochristi(Zaffelare)"},{"zip":"9080","city":"Lochristi(Beervelde)"},{"zip":"9090","city":"Merelbeke - Melle(Gontrode)"},{"zip":"9090","city":"Merelbeke - Melle(Melle)"},{"zip":"9100","city":"Sint-Niklaas"},{"zip":"9100","city":"BRUSSEL"},{"zip":"9100","city":"Nieuwkerken-Waas"},{"zip":"9111","city":"Belsele (Sint-Niklaas)"},{"zip":"9112","city":"Sinaai-Waas"},{"zip":"9120","city":"Kallo (Beveren-Waas)"},{"zip":"9120","city":"BRUSSEL"},{"zip":"9120","city":"Melsele"},{"zip":"9120","city":"Beveren-Waas"},{"zip":"9120","city":"Vrasene"},{"zip":"9120","city":"Haasdonk"},{"zip":"9130","city":"Kallo (Kieldrecht)"},{"zip":"9130","city":"Verrebroek"},{"zip":"9130","city":"Doel"},{"zip":"9130","city":"Kieldrecht (Beveren)"},{"zip":"9140","city":"Temse"},{"zip":"9140","city":"Elversele"},{"zip":"9140","city":"Tielrode"},{"zip":"9140","city":"Steendorp"},{"zip":"9150","city":"Rupelmonde"},{"zip":"9150","city":"Kruibeke"},{"zip":"9150","city":"Bazel"},{"zip":"9160","city":"Lokeren(Lokeren)"},{"zip":"9160","city":"Lokeren(Daknam)"},{"zip":"9160","city":"Lokeren(Eksaarde)"},{"zip":"9170","city":"Sint-Pauwels"},{"zip":"9170","city":"De Klinge"},{"zip":"9170","city":"Sint-Gillis-Waas"},{"zip":"9170","city":"Meerdonk"},{"zip":"9180","city":"Lokeren(Moerbeke-Waas)"},{"zip":"9185","city":"Lochristi(Wachtebeke)"},{"zip":"9190","city":"Stekene"},{"zip":"9190","city":"Kemzeke"},{"zip":"9200","city":"Appels"},{"zip":"9200","city":"Oudegem"},{"zip":"9200","city":"Schoonaarde"},{"zip":"9200","city":"Mespelare"},{"zip":"9200","city":"Dendermonde"},{"zip":"9200","city":"Grembergen"},{"zip":"9200","city":"Sint-Gillis-bij-Dendermonde"},{"zip":"9200","city":"Baasrode"},{"zip":"9220","city":"Moerzeke"},{"zip":"9220","city":"Hamme (O.-Vl.)"},{"zip":"9230","city":"Massemen"},{"zip":"9230","city":"Wetteren"},{"zip":"9230","city":"Westrem"},{"zip":"9240","city":"Zele"},{"zip":"9250","city":"Waasmunster"},{"zip":"9255","city":"Opdorp"},{"zip":"9255","city":"Buggenhout"},{"zip":"9260","city":"Serskamp"},{"zip":"9260","city":"Schellebelle"},{"zip":"9260","city":"Wichelen"},{"zip":"9270","city":"Kalken"},{"zip":"9270","city":"Laarne"},{"zip":"9280","city":"Lebbeke"},{"zip":"9280","city":"Wieze"},{"zip":"9280","city":"Denderbelle"},{"zip":"9290","city":"Berlare"},{"zip":"9290","city":"Uitbergen"},{"zip":"9290","city":"Overmere"},{"zip":"9300","city":"Aalst"},{"zip":"9308","city":"Gijzegem"},{"zip":"9308","city":"Hofstade (O.-Vl.)"},{"zip":"9310","city":"Baardegem"},{"zip":"9310","city":"Meldert (O.-Vl.)"},{"zip":"9310","city":"Herdersem"},{"zip":"9310","city":"Moorsel"},{"zip":"9320","city":"Nieuwerkerken (Aalst)"},{"zip":"9320","city":"Erembodegem (Aalst)"},{"zip":"9340","city":"Lede"},{"zip":"9340","city":"Impe"},{"zip":"9340","city":"Smetlede"},{"zip":"9340","city":"Wanzele"},{"zip":"9340","city":"Oordegem"},{"zip":"9400","city":"Nederhasselt"},{"zip":"9400","city":"Lieferinge"},{"zip":"9400","city":"Voorde"},{"zip":"9400","city":"Okegem"},{"zip":"9400","city":"Appelterre-Eichem"},{"zip":"9400","city":"Denderwindeke"},{"zip":"9400","city":"Ninove"},{"zip":"9401","city":"Pollare"},{"zip":"9402","city":"Meerbeke"},{"zip":"9403","city":"Neigem"},{"zip":"9404","city":"Aspelare"},{"zip":"9406","city":"Outer"},{"zip":"9420","city":"Ottergem"},{"zip":"9420","city":"Vlekkem"},{"zip":"9420","city":"Mere"},{"zip":"9420","city":"Bambrugge"},{"zip":"9420","city":"Erpe-Mere"},{"zip":"9420","city":"Erpe"},{"zip":"9420","city":"Erondegem"},{"zip":"9420","city":"Burst"},{"zip":"9420","city":"Aaigem"},{"zip":"9450","city":"Denderhoutem"},{"zip":"9450","city":"Haaltert"},{"zip":"9450","city":"Heldergem"},{"zip":"9451","city":"Kerksken"},{"zip":"9470","city":"Denderleeuw"},{"zip":"9472","city":"Iddergem"},{"zip":"9473","city":"Welle"},{"zip":"9500","city":"Nederboelare"},{"zip":"9500","city":"Viane"},{"zip":"9500","city":"Moerbeke"},{"zip":"9500","city":"Goeferdinge"},{"zip":"9500","city":"Onkerzele"},{"zip":"9500","city":"Overboelare"},{"zip":"9500","city":"Geraardsbergen"},{"zip":"9500","city":"Zarlardinge"},{"zip":"9500","city":"Ophasselt"},{"zip":"9506","city":"Zandbergen"},{"zip":"9506","city":"Nieuwenhove"},{"zip":"9506","city":"Smeerebbe-Vloerzegem"},{"zip":"9506","city":"Grimminge"},{"zip":"9506","city":"Schendelbeke"},{"zip":"9506","city":"Idegem"},{"zip":"9506","city":"Waarbeke"},{"zip":"9520","city":"Bavegem"},{"zip":"9520","city":"Sint-Lievens-Houtem"},{"zip":"9520","city":"Vlierzele"},{"zip":"9520","city":"Zonnegem"},{"zip":"9521","city":"Letterhoutem"},{"zip":"9550","city":"Woubrechtegem"},{"zip":"9550","city":"Sint-Antelinks"},{"zip":"9550","city":"Hillegem"},{"zip":"9550","city":"Steenhuize-Wijnhuize"},{"zip":"9550","city":"Herzele"},{"zip":"9550","city":"Sint-Lievens-Esse"},{"zip":"9551","city":"Ressegem"},{"zip":"9552","city":"Borsbeke"},{"zip":"9570","city":"Lierde"},{"zip":"9570","city":"Deftinge"},{"zip":"9570","city":"Sint-Maria-Lierde"},{"zip":"9571","city":"Hemelveerdegem"},{"zip":"9572","city":"Sint-Martens-Lierde"},{"zip":"9600","city":"Renaix"},{"zip":"9600","city":"Ronse"},{"zip":"9620","city":"Elene"},{"zip":"9620","city":"Grotenberge"},{"zip":"9620","city":"Sint-Goriks-Oudenhove"},{"zip":"9620","city":"Leeuwergem"},{"zip":"9620","city":"Oombergen (Zottegem)"},{"zip":"9620","city":"Strijpen"},{"zip":"9620","city":"Zottegem"},{"zip":"9620","city":"Sint-Maria-Oudenhove (Zottegem)"},{"zip":"9620","city":"Erwetegem"},{"zip":"9620","city":"Velzeke-Ruddershove"},{"zip":"9620","city":"Godveerdegem"},{"zip":"9630","city":"Munkzwalm"},{"zip":"9630","city":"Meilegem"},{"zip":"9630","city":"Hundelgem"},{"zip":"9630","city":"Dikkele"},{"zip":"9630","city":"Sint-Maria-Latem"},{"zip":"9630","city":"Beerlegem"},{"zip":"9630","city":"Roborst"},{"zip":"9630","city":"Zwalm"},{"zip":"9630","city":"Paulatem"},{"zip":"9630","city":"Sint-Denijs-Boekel"},{"zip":"9630","city":"Sint-Blasius-Boekel"},{"zip":"9630","city":"Rozebeke"},{"zip":"9636","city":"Nederzwalm-Hermelgem"},{"zip":"9660","city":"Brakel"},{"zip":"9660","city":"Opbrakel"},{"zip":"9660","city":"Nederbrakel"},{"zip":"9660","city":"Zegelsem"},{"zip":"9660","city":"Elst"},{"zip":"9660","city":"Michelbeke"},{"zip":"9660","city":"Everbeek"},{"zip":"9660","city":"ASSENEDE"},{"zip":"9661","city":"Parike"},{"zip":"9667","city":"Horebeke"},{"zip":"9667","city":"Sint-Maria-Horebeke"},{"zip":"9667","city":"Sint-Kornelis-Horebeke"},{"zip":"9680","city":"Etikhove"},{"zip":"9680","city":"BRUSSEL"},{"zip":"9680","city":"Maarke-Kerkem"},{"zip":"9680","city":"Maarkedal"},{"zip":"9681","city":"Nukerke"},{"zip":"9688","city":"Schorisse"},{"zip":"9690","city":"Ruien"},{"zip":"9690","city":"Kluisbergen"},{"zip":"9690","city":"Zulzeke"},{"zip":"9690","city":"Kwaremont"},{"zip":"9690","city":"Berchem (O.-Vl.)"},{"zip":"9700","city":"Mater"},{"zip":"9700","city":"Eine"},{"zip":"9700","city":"Edelare"},{"zip":"9700","city":"Ename"},{"zip":"9700","city":"Bevere"},{"zip":"9700","city":"Leupegem"},{"zip":"9700","city":"Oudenaarde"},{"zip":"9700","city":"Welden"},{"zip":"9700","city":"Volkegem"},{"zip":"9700","city":"Nederename"},{"zip":"9700","city":"Mullem"},{"zip":"9700","city":"Heurne"},{"zip":"9700","city":"Melden"},{"zip":"9750","city":"Ouwegem"},{"zip":"9750","city":"Huise"},{"zip":"9750","city":"Kruisem"},{"zip":"9770","city":"Kruisem"},{"zip":"9771","city":"Nokere"},{"zip":"9772","city":"Wannegem-Lede"},{"zip":"9790","city":"Wortegem"},{"zip":"9790","city":"Wortegem-Petegem"},{"zip":"9790","city":"Elsegem"},{"zip":"9790","city":"Ooike (Wortegem-Petegem)"},{"zip":"9790","city":"Petegem-aan-de-Schelde"},{"zip":"9790","city":"Moregem"},{"zip":"9800","city":"Astene"},{"zip":"9800","city":"Meigem"},{"zip":"9800","city":"Bachte-Maria-Leerne"},{"zip":"9800","city":"Grammene"},{"zip":"9800","city":"Wontergem"},{"zip":"9800","city":"Sint-Martens-Leerne"},{"zip":"9800","city":"Vinkt"},{"zip":"9800","city":"Zeveren"},{"zip":"9800","city":"Gottem"},{"zip":"9800","city":"Petegem-aan-de-Leie"},{"zip":"9800","city":"Deinze"},{"zip":"9810","city":"Nazareth - De Pinte(Eke)"},{"zip":"9810","city":"Nazareth - De Pinte(Nazareth)"},{"zip":"9820","city":"Merelbeke - Melle(Schelderode)"},{"zip":"9820","city":"Merelbeke - Melle(Munte)"},{"zip":"9820","city":"Merelbeke - Melle(Merelbeke)"},{"zip":"9820","city":"Merelbeke - Melle(Bottelare)"},{"zip":"9820","city":"Merelbeke - Melle(Lemberge)"},{"zip":"9820","city":"Merelbeke - Melle(Melsen)"},{"zip":"9830","city":"Sint-Martens-Latem"},{"zip":"9831","city":"Deurle"},{"zip":"9840","city":"Nazareth - De Pinte(De Pinte)"},{"zip":"9840","city":"Nazareth - De Pinte(Zevergem)"},{"zip":"9850","city":"Vosselare"},{"zip":"9850","city":"Deinze"},{"zip":"9850","city":"Landegem"},{"zip":"9850","city":"Hansbeke"},{"zip":"9850","city":"Merendree"},{"zip":"9850","city":"Poesele"},{"zip":"9860","city":"Landskouter"},{"zip":"9860","city":"Scheldewindeke"},{"zip":"9860","city":"Oosterzele"},{"zip":"9860","city":"Moortsele"},{"zip":"9860","city":"Gijzenzele"},{"zip":"9860","city":"Balegem"},{"zip":"9870","city":"Olsene"},{"zip":"9870","city":"Zulte"},{"zip":"9870","city":"Machelen (O.-Vl.)"},{"zip":"9880","city":"Lotenhulle"},{"zip":"9880","city":"Aalter"},{"zip":"9880","city":"Poeke"},{"zip":"9881","city":"Bellem"},{"zip":"9890","city":"Vurste"},{"zip":"9890","city":"Baaigem"},{"zip":"9890","city":"Gavere"},{"zip":"9890","city":"Dikkelvenne"},{"zip":"9890","city":"Asper"},{"zip":"9890","city":"Semmerzake"},{"zip":"9900","city":"Eeklo"},{"zip":"9910","city":"Aalter"},{"zip":"9910","city":"Ursel"},{"zip":"9920","city":"Lievegem"},{"zip":"9921","city":"Vinderhoute"},{"zip":"9930","city":"Lievegem"},{"zip":"9931","city":"Oostwinkel"},{"zip":"9932","city":"Ronsele"},{"zip":"9940","city":"Ertvelde"},{"zip":"9940","city":"Evergem"},{"zip":"9940","city":"Sleidinge"},{"zip":"9940","city":"Kluizen"},{"zip":"9950","city":"Lievegem"},{"zip":"9960","city":"Assenede"},{"zip":"9961","city":"Boekhoute"},{"zip":"9968","city":"Bassevelde"},{"zip":"9968","city":"Oosteeklo"},{"zip":"9970","city":"Kaprijke"},{"zip":"9971","city":"Lembeke"},{"zip":"9980","city":"Sint-Laureins"},{"zip":"9981","city":"Sint-Margriete"},{"zip":"9982","city":"Sint-Jan-in-Eremo"},{"zip":"9988","city":"Watervliet"},{"zip":"9988","city":"Waterland-Oudeman"},{"zip":"9990","city":"Maldegem"},{"zip":"9991","city":"Adegem"},{"zip":"9992","city":"Middelburg"},{"zip":"9999","city":"Foutieve gemeente"}]

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1760),
	    listCacheDelete = __webpack_require__(1761),
	    listCacheGet = __webpack_require__(1762),
	    listCacheHas = __webpack_require__(1763),
	    listCacheSet = __webpack_require__(1764);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(310),
	    stackClear = __webpack_require__(1778),
	    stackDelete = __webpack_require__(1779),
	    stackGet = __webpack_require__(1780),
	    stackHas = __webpack_require__(1781),
	    stackSet = __webpack_require__(1782);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(136),
	    eq = __webpack_require__(161);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(161);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1710),
	    isObjectLike = __webpack_require__(48);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(314),
	    castPath = __webpack_require__(139),
	    isIndex = __webpack_require__(323),
	    isObject = __webpack_require__(56),
	    toKey = __webpack_require__(140);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	      return object;
	    }
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(1688),
	    baseAggregator = __webpack_require__(1697),
	    baseIteratee = __webpack_require__(47),
	    isArray = __webpack_require__(30);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(331);
	
	/**
	 * Creates a function that performs a relational operation on two values.
	 *
	 * @private
	 * @param {Function} operator The function to perform the operation.
	 * @returns {Function} Returns the new relational operation function.
	 */
	function createRelationalOperation(operator) {
	  return function(value, other) {
	    if (!(typeof value == 'string' && typeof other == 'string')) {
	      value = toNumber(value);
	      other = toNumber(other);
	    }
	    return operator(value, other);
	  };
	}
	
	module.exports = createRelationalOperation;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1756);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(777);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(160);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(754);
	
	/**
	 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	 *
	 * @private
	 * @param {Array} array The array to shuffle.
	 * @param {number} [size=array.length] The size of `array`.
	 * @returns {Array} Returns `array`.
	 */
	function shuffleSelf(array, size) {
	  var index = -1,
	      length = array.length,
	      lastIndex = length - 1;
	
	  size = size === undefined ? length : size;
	  while (++index < size) {
	    var rand = baseRandom(index, lastIndex),
	        value = array[rand];
	
	    array[rand] = array[index];
	    array[index] = value;
	  }
	  array.length = size;
	  return array;
	}
	
	module.exports = shuffleSelf;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(158),
	    castFunction = __webpack_require__(138);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(142)(module)))

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  'assign': __webpack_require__(1790),
	  'assignIn': __webpack_require__(784),
	  'assignInWith': __webpack_require__(785),
	  'assignWith': __webpack_require__(1791),
	  'at': __webpack_require__(1792),
	  'create': __webpack_require__(1799),
	  'defaults': __webpack_require__(1800),
	  'defaultsDeep': __webpack_require__(1801),
	  'entries': __webpack_require__(1803),
	  'entriesIn': __webpack_require__(1804),
	  'extend': __webpack_require__(1806),
	  'extendWith': __webpack_require__(1807),
	  'findKey': __webpack_require__(1811),
	  'findLastKey': __webpack_require__(1814),
	  'forIn': __webpack_require__(1819),
	  'forInRight': __webpack_require__(1820),
	  'forOwn': __webpack_require__(326),
	  'forOwnRight': __webpack_require__(1821),
	  'functions': __webpack_require__(1822),
	  'functionsIn': __webpack_require__(1823),
	  'get': __webpack_require__(327),
	  'has': __webpack_require__(1827),
	  'hasIn': __webpack_require__(465),
	  'invert': __webpack_require__(1829),
	  'invertBy': __webpack_require__(1830),
	  'invoke': __webpack_require__(1831),
	  'keys': __webpack_require__(70),
	  'keysIn': __webpack_require__(71),
	  'mapKeys': __webpack_require__(1855),
	  'mapValues': __webpack_require__(1856),
	  'merge': __webpack_require__(60),
	  'mergeWith': __webpack_require__(798),
	  'omit': __webpack_require__(1859),
	  'omitBy': __webpack_require__(1860),
	  'pick': __webpack_require__(1863),
	  'pickBy': __webpack_require__(800),
	  'result': __webpack_require__(1868),
	  'set': __webpack_require__(1871),
	  'setWith': __webpack_require__(1872),
	  'toPairs': __webpack_require__(804),
	  'toPairsIn': __webpack_require__(805),
	  'transform': __webpack_require__(1881),
	  'unset': __webpack_require__(1882),
	  'update': __webpack_require__(1883),
	  'updateWith': __webpack_require__(1884),
	  'values': __webpack_require__(208),
	  'valuesIn': __webpack_require__(1885)
	};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(1733),
	    isObject = __webpack_require__(56),
	    isSymbol = __webpack_require__(206);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var EventPluginRegistry = __webpack_require__(471);
	var ReactEventEmitterMixin = __webpack_require__(1995);
	var ViewportMetrics = __webpack_require__(847);
	
	var getVendorPrefixedEventName = __webpack_require__(2027);
	var isEventSupported = __webpack_require__(482);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(255);
	var ViewportMetrics = __webpack_require__(847);
	
	var getEventModifierState = __webpack_require__(480);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(21);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	var DOMNamespaces = __webpack_require__(470);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(478);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// TODO: Need better, more complete, and more methodical key definitions
	
	var Keys = {
	  backspace: 8,
	  del: 46,
	  delete: 46,
	  tab: 9,
	  enter: 13,
	  'return': 13,
	  esc: 27,
	  space: 32,
	  pageUp: 33,
	  pageDown: 34,
	  end: 35,
	  home: 36,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221
	};
	
	// Add uppercase versions of keys above for backwards compatibility
	Object.keys(Keys).forEach(function (key) {
	  return Keys[key.toUpperCase()] = Keys[key];
	});
	
	'0123456789'.split('').forEach(function (num, index) {
	  return Keys[num] = index + 48;
	});
	
	'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (letter, index) {
	  Keys[letter] = index + 65;
	  Keys[letter.toLowerCase()] = index + 65;
	});
	
	// fn keys
	[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach(function (item, index) {
	  return Keys['f' + index] = 111 + index;
	});
	
	var modifiers = exports.modifiers = {
	  control: 'ctrl',
	  ctrl: 'ctrl',
	  shift: 'shift',
	  meta: 'meta',
	  cmd: 'meta',
	  command: 'meta',
	  option: 'alt',
	  alt: 'alt'
	};
	
	var ALL_KEYS = exports.ALL_KEYS = Symbol('ALL_KEYS');
	
	var ALL_PRINTABLE_KEYS = exports.ALL_PRINTABLE_KEYS = Symbol('ALL_PRINTABLE_KEYS');
	
	exports.default = Keys;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports._resetStore = _resetStore;
	exports.activate = activate;
	exports.deleteInstance = deleteInstance;
	exports.findBindingForEvent = findBindingForEvent;
	exports.getBinding = getBinding;
	exports.getInstances = getInstances;
	exports.isEmpty = isEmpty;
	exports.setBinding = setBinding;
	
	var _match_keys = __webpack_require__(862);
	
	var _match_keys2 = _interopRequireDefault(_match_keys);
	
	var _parse_keys = __webpack_require__(863);
	
	var _parse_keys2 = _interopRequireDefault(_parse_keys);
	
	var _uuid = __webpack_require__(2051);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * @module store
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     */
	
	
	/**
	 * private
	 *
	 */
	
	// dict for class prototypes => bindings
	var _handlers = new Map();
	
	// all mounted instances that have keybindings
	var _instances = new Set();
	
	// for testing
	function _resetStore() {
	  _handlers.clear();
	  _instances.clear();
	}
	
	/**
	 * activate
	 *
	 * @access public
	 * @param {object} instance Instantiated class that extended React.Component, to be focused to receive keydown events
	 */
	function activate(instances) {
	  var instancesArray = [].concat(instances);
	
	  // if no components were found as ancestors of the event target,
	  // effectively deactivate keydown handling by capping the set of instances
	  // with `null`.
	  if (!instancesArray.length) {
	    _instances.add(null);
	  } else {
	    _instances.delete(null);
	
	    // deleting and then adding the instance(s) has the effect of sorting the set
	    // according to instance activation (ascending)
	    instancesArray.forEach(function (instance) {
	      _instances.delete(instance);
	      _instances.add(instance);
	    });
	  }
	};
	
	/**
	 * deleteInstance
	 *
	 * @access public
	 * @param {object} target Instantiated class that extended React.Component
	 * @return {boolean} The value set.has( target ) would have returned prior to deletion
	 */
	function deleteInstance(target) {
	  _instances.delete(target);
	};
	
	function findBindingForEvent(event) {
	  if (!_instances.has(null)) {
	    var keyMatchesEvent = function keyMatchesEvent(keySet) {
	      return (0, _match_keys2.default)({ keySet: keySet, event: event });
	    };
	
	    // loop through instances in reverse activation order so that most
	    // recently activated instance gets first dibs on event
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = [].concat(_toConsumableArray(_instances)).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var instance = _step.value;
	
	        var bindings = getBinding(instance.constructor.prototype);
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = bindings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _step2$value = _slicedToArray(_step2.value, 2),
	                keySets = _step2$value[0],
	                fn = _step2$value[1];
	
	            if (keySets.some(keyMatchesEvent)) {
	              // return when matching keybinding is found - i.e. only one
	              // keybound component can respond to a given key code. to get around this,
	              // scope a common ancestor component class with @keydown and use
	              // @keydownScoped to bind the duplicate keys in your child components
	              // (or just inspect nextProps.keydown.event).
	              return { fn: fn, instance: instance };
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return null;
	};
	
	/**
	 * getBinding
	 *
	 * @access public
	 * @param {object} target Class used as key in dict of key bindings
	 * @return {object} The object containing bindings for the given class
	 */
	function getBinding(_ref) {
	  var __reactKeydownUUID = _ref.__reactKeydownUUID;
	
	  return _handlers.get(__reactKeydownUUID);
	};
	
	/**
	 * getInstances
	 *
	 * @access public
	 * @return {set} All stored instances (all mounted component instances with keybindings)
	 */
	function getInstances() {
	  return _instances;
	};
	
	/**
	 * isEmpty
	 *
	 * @access public
	 * @return {number} Size of the set of all stored instances
	 */
	function isEmpty() {
	  return !_instances.size;
	};
	
	/**
	 * setBinding
	 *
	 * @access public
	 * @param {object} args All arguments necessary to set the binding
	 * @param {array} args.keys Key codes that should trigger the fn
	 * @param {function} args.fn The callback to be triggered when given keys are pressed
	 * @param {object} args.target The decorated class
	 */
	function setBinding(_ref2) {
	  var keys = _ref2.keys,
	      fn = _ref2.fn,
	      target = _ref2.target;
	
	  var keySets = (0, _parse_keys2.default)(keys);
	
	  var __reactKeydownUUID = target.__reactKeydownUUID;
	
	  if (!__reactKeydownUUID) {
	    target.__reactKeydownUUID = (0, _uuid2.default)();
	    _handlers.set(target.__reactKeydownUUID, new Map([[keySets, fn]]));
	  } else {
	    _handlers.get(__reactKeydownUUID).set(keySets, fn);
	  }
	};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(2063);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(2064);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(2065);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(2068);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(865);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(341);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(2067);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _memoizeOne = _interopRequireDefault(__webpack_require__(809));
	
	var _Menu = __webpack_require__(492);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(878));
	
	var _filters = __webpack_require__(877);
	
	var _index = __webpack_require__(2096);
	
	var _index2 = __webpack_require__(2080);
	
	var _utils = __webpack_require__(344);
	
	var _builtins = __webpack_require__(2087);
	
	var _index3 = __webpack_require__(493);
	
	var _styles = __webpack_require__(879);
	
	var _theme = __webpack_require__(880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  backspaceRemovesValue: true,
	  blurInputOnSelect: (0, _utils.isTouchCapable)(),
	  captureMenuScroll: !(0, _utils.isTouchCapable)(),
	  closeMenuOnSelect: true,
	  closeMenuOnScroll: false,
	  components: {},
	  controlShouldRenderValue: true,
	  escapeClearsValue: false,
	  filterOption: (0, _filters.createFilter)(),
	  formatGroupLabel: _builtins.formatGroupLabel,
	  getOptionLabel: _builtins.getOptionLabel,
	  getOptionValue: _builtins.getOptionValue,
	  isDisabled: false,
	  isLoading: false,
	  isMulti: false,
	  isRtl: false,
	  isSearchable: true,
	  isOptionDisabled: _builtins.isOptionDisabled,
	  loadingMessage: function loadingMessage() {
	    return 'Loading...';
	  },
	  maxMenuHeight: 300,
	  minMenuHeight: 140,
	  menuIsOpen: false,
	  menuPlacement: 'bottom',
	  menuPosition: 'absolute',
	  menuShouldBlockScroll: false,
	  menuShouldScrollIntoView: !(0, _utils.isMobileDevice)(),
	  noOptionsMessage: function noOptionsMessage() {
	    return 'No options';
	  },
	  openMenuOnFocus: false,
	  openMenuOnClick: true,
	  options: [],
	  pageSize: 5,
	  placeholder: 'Select...',
	  screenReaderStatus: function screenReaderStatus(_ref) {
	    var count = _ref.count;
	    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
	  },
	  styles: {},
	  tabIndex: '0',
	  tabSelectsValue: true
	};
	exports.defaultProps = defaultProps;
	var instanceId = 1;
	
	var Select =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Select, _Component);
	
	  // Misc. Instance Properties
	  // ------------------------------
	  // TODO
	  // Refs
	  // ------------------------------
	  // Lifecycle
	  // ------------------------------
	  function Select(_props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      ariaLiveSelection: '',
	      ariaLiveContext: '',
	      focusedOption: null,
	      focusedValue: null,
	      inputIsHidden: false,
	      isFocused: false,
	      menuOptions: {
	        render: [],
	        focusable: []
	      },
	      selectValue: []
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isComposing", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
	      _this.controlRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
	      _this.focusedOptionRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
	      _this.menuListRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
	      _this.inputRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components) {
	      _this.components = (0, _index3.defaultComponents)({
	        components: components
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          name = _this$props.name;
	      onChange(newValue, _objectSpread({}, actionMeta, {
	        name: name
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
	      var option = arguments.length > 2 ? arguments[2] : undefined;
	      var _this$props2 = _this.props,
	          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
	          isMulti = _this$props2.isMulti;
	
	      _this.onInputChange('', {
	        action: 'set-value'
	      });
	
	      if (closeMenuOnSelect) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } // when the select value should change, we should reset focusedValue
	
	
	      _this.clearFocusValueOnUpdate = true;
	
	      _this.onChange(newValue, {
	        action: action,
	        option: option
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
	      var _this$props3 = _this.props,
	          blurInputOnSelect = _this$props3.blurInputOnSelect,
	          isMulti = _this$props3.isMulti;
	      var selectValue = _this.state.selectValue;
	
	      if (isMulti) {
	        if (_this.isOptionSelected(newValue, selectValue)) {
	          var candidate = _this.getOptionValue(newValue);
	
	          _this.setValue(selectValue.filter(function (i) {
	            return _this.getOptionValue(i) !== candidate;
	          }), 'deselect-option', newValue);
	
	          _this.announceAriaLiveSelection({
	            event: 'deselect-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          if (!_this.isOptionDisabled(newValue, selectValue)) {
	            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);
	
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue)
	              }
	            });
	          } else {
	            // announce that option is disabled
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue),
	                isDisabled: true
	              }
	            });
	          }
	        }
	      } else {
	        if (!_this.isOptionDisabled(newValue, selectValue)) {
	          _this.setValue(newValue, 'select-option');
	
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          // announce that option is disabled
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue),
	              isDisabled: true
	            }
	          });
	        }
	      }
	
	      if (blurInputOnSelect) {
	        _this.blurInput();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
	      var selectValue = _this.state.selectValue;
	
	      var candidate = _this.getOptionValue(removedValue);
	
	      _this.onChange(selectValue.filter(function (i) {
	        return _this.getOptionValue(i) !== candidate;
	      }), {
	        action: 'remove-value',
	        removedValue: removedValue
	      });
	
	      _this.announceAriaLiveSelection({
	        event: 'remove-value',
	        context: {
	          value: removedValue ? _this.getOptionLabel(removedValue) : ''
	        }
	      });
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
	      var isMulti = _this.props.isMulti;
	
	      _this.onChange(isMulti ? [] : null, {
	        action: 'clear'
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
	      var selectValue = _this.state.selectValue;
	      var lastSelectedValue = selectValue[selectValue.length - 1];
	
	      _this.announceAriaLiveSelection({
	        event: 'pop-value',
	        context: {
	          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
	        }
	      });
	
	      _this.onChange(selectValue.slice(0, selectValue.length - 1), {
	        action: 'pop-value',
	        removedValue: lastSelectedValue
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
	      return _this.props.getOptionLabel(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
	      return _this.props.getOptionValue(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
	      var base = _styles.defaultStyles[key](props);
	
	      base.boxSizing = 'border-box';
	      var custom = _this.props.styles[key];
	      return custom ? custom(base, props) : base;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
	      return "".concat(_this.instancePrefix, "-").concat(element);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
	      var menuIsOpen = _this.props.menuIsOpen;
	      var _this$state = _this.state,
	          menuOptions = _this$state.menuOptions,
	          focusedOption = _this$state.focusedOption;
	      if (!focusedOption || !menuIsOpen) return undefined;
	      var index = menuOptions.focusable.indexOf(focusedOption);
	      var option = menuOptions.render[index];
	      return option && option.key;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
	      var event = _ref2.event,
	          context = _ref2.context;
	
	      _this.setState({
	        ariaLiveSelection: (0, _index2.valueEventAriaMessage)(event, context)
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
	      var event = _ref3.event,
	          context = _ref3.context;
	
	      _this.setState({
	        ariaLiveContext: (0, _index2.instructionsAriaMessage)(event, _objectSpread({}, context, {
	          label: _this.props['aria-label']
	        }))
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
	      if (event.button !== 0) {
	        return;
	      }
	
	      event.stopPropagation();
	      event.preventDefault();
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
	      _this.blockOptionHover = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
	      var openMenuOnClick = _this.props.openMenuOnClick;
	
	      if (!_this.state.isFocused) {
	        if (openMenuOnClick) {
	          _this.openAfterFocus = true;
	        }
	
	        _this.focusInput();
	      } else if (!_this.props.menuIsOpen) {
	        if (openMenuOnClick) {
	          _this.openMenu('first');
	        }
	      } else {
	        //$FlowFixMe
	        if (event.target.tagName !== 'INPUT') {
	          _this.onMenuClose();
	        }
	      } //$FlowFixMe
	
	
	      if (event.target.tagName !== 'INPUT') {
	        event.preventDefault();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      if (_this.props.isDisabled) return;
	      var _this$props4 = _this.props,
	          isMulti = _this$props4.isMulti,
	          menuIsOpen = _this$props4.menuIsOpen;
	
	      _this.focusInput();
	
	      if (menuIsOpen) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } else {
	        _this.openMenu('first');
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      _this.clearValue();
	
	      event.stopPropagation();
	      _this.openAfterFocus = false;
	      setTimeout(function () {
	        return _this.focusInput();
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
	      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
	        if (event.target instanceof HTMLElement && (0, _utils.isDocumentElement)(event.target)) {
	          _this.props.onMenuClose();
	        }
	      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
	        if (_this.props.closeMenuOnScroll(event)) {
	          _this.props.onMenuClose();
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
	      _this.isComposing = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
	      _this.isComposing = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
	      var touches = _ref4.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      _this.initialTouchX = touch.clientX;
	      _this.initialTouchY = touch.clientY;
	      _this.userIsDragging = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
	      var touches = _ref5.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
	      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
	      var moveThreshold = 5;
	      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
	      if (_this.userIsDragging) return; // close the menu if the user taps outside
	      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
	      // on events on child elements, not the document (which we've attached this handler to).
	
	      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
	        _this.blurInput();
	      } // reset move vars
	
	
	      _this.initialTouchX = 0;
	      _this.initialTouchY = 0;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onControlMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onClearIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onDropdownIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
	      var inputValue = event.currentTarget.value;
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.onInputChange(inputValue, {
	        action: 'input-change'
	      });
	
	      _this.onMenuOpen();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
	      var _this$props5 = _this.props,
	          isSearchable = _this$props5.isSearchable,
	          isMulti = _this$props5.isMulti;
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	
	      _this.setState({
	        isFocused: true
	      });
	
	      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
	        _this.openMenu('first');
	      }
	
	      _this.openAfterFocus = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
	      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
	        _this.inputRef.focus();
	
	        return;
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      _this.onInputChange('', {
	        action: 'input-blur'
	      });
	
	      _this.onMenuClose();
	
	      _this.setState({
	        focusedValue: null,
	        isFocused: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
	      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
	        return;
	      }
	
	      _this.setState({
	        focusedOption: focusedOption
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
	      var _this$props6 = _this.props,
	          hideSelectedOptions = _this$props6.hideSelectedOptions,
	          isMulti = _this$props6.isMulti;
	      if (hideSelectedOptions === undefined) return isMulti;
	      return hideSelectedOptions;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
	      var _this$props7 = _this.props,
	          isMulti = _this$props7.isMulti,
	          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
	          escapeClearsValue = _this$props7.escapeClearsValue,
	          inputValue = _this$props7.inputValue,
	          isClearable = _this$props7.isClearable,
	          isDisabled = _this$props7.isDisabled,
	          menuIsOpen = _this$props7.menuIsOpen,
	          onKeyDown = _this$props7.onKeyDown,
	          tabSelectsValue = _this$props7.tabSelectsValue,
	          openMenuOnFocus = _this$props7.openMenuOnFocus;
	      var _this$state2 = _this.state,
	          focusedOption = _this$state2.focusedOption,
	          focusedValue = _this$state2.focusedValue,
	          selectValue = _this$state2.selectValue;
	      if (isDisabled) return;
	
	      if (typeof onKeyDown === 'function') {
	        onKeyDown(event);
	
	        if (event.defaultPrevented) {
	          return;
	        }
	      } // Block option hover events when the user has just pressed a key
	
	
	      _this.blockOptionHover = true;
	
	      switch (event.key) {
	        case 'ArrowLeft':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('previous');
	
	          break;
	
	        case 'ArrowRight':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('next');
	
	          break;
	
	        case 'Delete':
	        case 'Backspace':
	          if (inputValue) return;
	
	          if (focusedValue) {
	            _this.removeValue(focusedValue);
	          } else {
	            if (!backspaceRemovesValue) return;
	
	            if (isMulti) {
	              _this.popValue();
	            } else if (isClearable) {
	              _this.clearValue();
	            }
	          }
	
	          break;
	
	        case 'Tab':
	          if (_this.isComposing) return;
	
	          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
	          // option is already selected; it breaks the flow of navigation
	          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
	            return;
	          }
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'Enter':
	          if (event.keyCode === 229) {
	            // ignore the keydown event from an Input Method Editor(IME)
	            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
	            break;
	          }
	
	          if (menuIsOpen) {
	            if (!focusedOption) return;
	            if (_this.isComposing) return;
	
	            _this.selectOption(focusedOption);
	
	            break;
	          }
	
	          return;
	
	        case 'Escape':
	          if (menuIsOpen) {
	            _this.inputIsHiddenAfterUpdate = false;
	
	            _this.onInputChange('', {
	              action: 'menu-close'
	            });
	
	            _this.onMenuClose();
	          } else if (isClearable && escapeClearsValue) {
	            _this.clearValue();
	          }
	
	          break;
	
	        case ' ':
	          // space
	          if (inputValue) {
	            return;
	          }
	
	          if (!menuIsOpen) {
	            _this.openMenu('first');
	
	            break;
	          }
	
	          if (!focusedOption) return;
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'ArrowUp':
	          if (menuIsOpen) {
	            _this.focusOption('up');
	          } else {
	            _this.openMenu('last');
	          }
	
	          break;
	
	        case 'ArrowDown':
	          if (menuIsOpen) {
	            _this.focusOption('down');
	          } else {
	            _this.openMenu('first');
	          }
	
	          break;
	
	        case 'PageUp':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pageup');
	
	          break;
	
	        case 'PageDown':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pagedown');
	
	          break;
	
	        case 'Home':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('first');
	
	          break;
	
	        case 'End':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('last');
	
	          break;
	
	        default:
	          return;
	      }
	
	      event.preventDefault();
	    });
	
	    var value = _props.value;
	    _this.cacheComponents = (0, _memoizeOne.default)(_this.cacheComponents, _reactFastCompare.default).bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    _this.cacheComponents(_props.components);
	
	    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
	
	    var _selectValue = (0, _utils.cleanValue)(value);
	
	    var _menuOptions = _this.buildMenuOptions(_props, _selectValue);
	
	    _this.state.menuOptions = _menuOptions;
	    _this.state.selectValue = _selectValue;
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListeningComposition();
	      this.startListeningToTouch();
	
	      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
	        // Listen to all scroll events, and filter them out inside of 'onScroll'
	        document.addEventListener('scroll', this.onScroll, true);
	      }
	
	      if (this.props.autoFocus) {
	        this.focusInput();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props8 = this.props,
	          options = _this$props8.options,
	          value = _this$props8.value,
	          inputValue = _this$props8.inputValue; // re-cache custom components
	
	      this.cacheComponents(nextProps.components); // rebuild the menu options
	
	      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
	        var selectValue = (0, _utils.cleanValue)(nextProps.value);
	        var menuOptions = this.buildMenuOptions(nextProps, selectValue);
	        var focusedValue = this.getNextFocusedValue(selectValue);
	        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
	        this.setState({
	          menuOptions: menuOptions,
	          selectValue: selectValue,
	          focusedOption: focusedOption,
	          focusedValue: focusedValue
	        });
	      } // some updates should toggle the state of the input visibility
	
	
	      if (this.inputIsHiddenAfterUpdate != null) {
	        this.setState({
	          inputIsHidden: this.inputIsHiddenAfterUpdate
	        });
	        delete this.inputIsHiddenAfterUpdate;
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props9 = this.props,
	          isDisabled = _this$props9.isDisabled,
	          menuIsOpen = _this$props9.menuIsOpen;
	      var isFocused = this.state.isFocused;
	
	      if ( // ensure focus is restored correctly when the control becomes enabled
	      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
	      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
	        this.focusInput();
	      } // scroll the focused option into view if necessary
	
	
	      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
	        (0, _utils.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
	      }
	
	      this.scrollToFocusedOptionOnUpdate = false;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListeningComposition();
	      this.stopListeningToTouch();
	      document.removeEventListener('scroll', this.onScroll, true);
	    }
	  }, {
	    key: "onMenuOpen",
	    // ==============================
	    // Consumer Handlers
	    // ==============================
	    value: function onMenuOpen() {
	      this.props.onMenuOpen();
	    }
	  }, {
	    key: "onMenuClose",
	    value: function onMenuClose() {
	      var _this$props10 = this.props,
	          isSearchable = _this$props10.isSearchable,
	          isMulti = _this$props10.isMulti;
	      this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	      this.onInputChange('', {
	        action: 'menu-close'
	      });
	      this.props.onMenuClose();
	    }
	  }, {
	    key: "onInputChange",
	    value: function onInputChange(newValue, actionMeta) {
	      this.props.onInputChange(newValue, actionMeta);
	    } // ==============================
	    // Methods
	    // ==============================
	
	  }, {
	    key: "focusInput",
	    value: function focusInput() {
	      if (!this.inputRef) return;
	      this.inputRef.focus();
	    }
	  }, {
	    key: "blurInput",
	    value: function blurInput() {
	      if (!this.inputRef) return;
	      this.inputRef.blur();
	    } // aliased for consumers
	
	  }, {
	    key: "openMenu",
	    value: function openMenu(focusOption) {
	      var _this$state3 = this.state,
	          menuOptions = _this$state3.menuOptions,
	          selectValue = _this$state3.selectValue,
	          isFocused = _this$state3.isFocused;
	      var isMulti = this.props.isMulti;
	      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
	
	      if (!isMulti) {
	        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
	
	        if (selectedIndex > -1) {
	          openAtIndex = selectedIndex;
	        }
	      } // only scroll if the menu isn't already open
	
	
	      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
	      this.inputIsHiddenAfterUpdate = false;
	      this.onMenuOpen();
	      this.setState({
	        focusedValue: null,
	        focusedOption: menuOptions.focusable[openAtIndex]
	      });
	      this.announceAriaLiveContext({
	        event: 'menu'
	      });
	    }
	  }, {
	    key: "focusValue",
	    value: function focusValue(direction) {
	      var _this$props11 = this.props,
	          isMulti = _this$props11.isMulti,
	          isSearchable = _this$props11.isSearchable;
	      var _this$state4 = this.state,
	          selectValue = _this$state4.selectValue,
	          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
	
	      if (!isMulti) return;
	      this.setState({
	        focusedOption: null
	      });
	      var focusedIndex = selectValue.indexOf(focusedValue);
	
	      if (!focusedValue) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'value'
	        });
	      }
	
	      var lastIndex = selectValue.length - 1;
	      var nextFocus = -1;
	      if (!selectValue.length) return;
	
	      switch (direction) {
	        case 'previous':
	          if (focusedIndex === 0) {
	            // don't cycle from the start to the end
	            nextFocus = 0;
	          } else if (focusedIndex === -1) {
	            // if nothing is focused, focus the last value first
	            nextFocus = lastIndex;
	          } else {
	            nextFocus = focusedIndex - 1;
	          }
	
	          break;
	
	        case 'next':
	          if (focusedIndex > -1 && focusedIndex < lastIndex) {
	            nextFocus = focusedIndex + 1;
	          }
	
	          break;
	      }
	
	      if (nextFocus === -1) {
	        this.announceAriaLiveContext({
	          event: 'input',
	          context: {
	            isSearchable: isSearchable,
	            isMulti: isMulti
	          }
	        });
	      }
	
	      this.setState({
	        inputIsHidden: nextFocus === -1 ? false : true,
	        focusedValue: selectValue[nextFocus]
	      });
	    }
	  }, {
	    key: "focusOption",
	    value: function focusOption() {
	      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
	      var pageSize = this.props.pageSize;
	      var _this$state5 = this.state,
	          focusedOption = _this$state5.focusedOption,
	          menuOptions = _this$state5.menuOptions;
	      var options = menuOptions.focusable;
	      if (!options.length) return;
	      var nextFocus = 0; // handles 'first'
	
	      var focusedIndex = options.indexOf(focusedOption);
	
	      if (!focusedOption) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'menu'
	        });
	      }
	
	      if (direction === 'up') {
	        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
	      } else if (direction === 'down') {
	        nextFocus = (focusedIndex + 1) % options.length;
	      } else if (direction === 'pageup') {
	        nextFocus = focusedIndex - pageSize;
	        if (nextFocus < 0) nextFocus = 0;
	      } else if (direction === 'pagedown') {
	        nextFocus = focusedIndex + pageSize;
	        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
	      } else if (direction === 'last') {
	        nextFocus = options.length - 1;
	      }
	
	      this.scrollToFocusedOptionOnUpdate = true;
	      this.setState({
	        focusedOption: options[nextFocus],
	        focusedValue: null
	      });
	      this.announceAriaLiveContext({
	        event: 'menu',
	        context: {
	          isDisabled: (0, _builtins.isOptionDisabled)(options[nextFocus])
	        }
	      });
	    }
	  }, {
	    key: "getTheme",
	    // ==============================
	    // Getters
	    // ==============================
	    value: function getTheme() {
	      // Use the default theme if there are no customizations.
	      if (!this.props.theme) {
	        return _theme.defaultTheme;
	      } // If the theme prop is a function, assume the function
	      // knows how to merge the passed-in default theme with
	      // its own modifications.
	
	
	      if (typeof this.props.theme === 'function') {
	        return this.props.theme(_theme.defaultTheme);
	      } // Otherwise, if a plain theme object was passed in,
	      // overlay it with the default theme.
	
	
	      return _objectSpread({}, _theme.defaultTheme, this.props.theme);
	    }
	  }, {
	    key: "getCommonProps",
	    value: function getCommonProps() {
	      var clearValue = this.clearValue,
	          getStyles = this.getStyles,
	          setValue = this.setValue,
	          selectOption = this.selectOption,
	          props = this.props;
	      var classNamePrefix = props.classNamePrefix,
	          isMulti = props.isMulti,
	          isRtl = props.isRtl,
	          options = props.options;
	      var selectValue = this.state.selectValue;
	      var hasValue = this.hasValue();
	
	      var getValue = function getValue() {
	        return selectValue;
	      };
	
	      var cx = _utils.classNames.bind(null, classNamePrefix);
	
	      return {
	        cx: cx,
	        clearValue: clearValue,
	        getStyles: getStyles,
	        getValue: getValue,
	        hasValue: hasValue,
	        isMulti: isMulti,
	        isRtl: isRtl,
	        options: options,
	        selectOption: selectOption,
	        setValue: setValue,
	        selectProps: props,
	        theme: this.getTheme()
	      };
	    }
	  }, {
	    key: "getNextFocusedValue",
	    value: function getNextFocusedValue(nextSelectValue) {
	      if (this.clearFocusValueOnUpdate) {
	        this.clearFocusValueOnUpdate = false;
	        return null;
	      }
	
	      var _this$state6 = this.state,
	          focusedValue = _this$state6.focusedValue,
	          lastSelectValue = _this$state6.selectValue;
	      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
	
	      if (lastFocusedIndex > -1) {
	        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
	
	        if (nextFocusedIndex > -1) {
	          // the focused value is still in the selectValue, return it
	          return focusedValue;
	        } else if (lastFocusedIndex < nextSelectValue.length) {
	          // the focusedValue is not present in the next selectValue array by
	          // reference, so return the new value at the same index
	          return nextSelectValue[lastFocusedIndex];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getNextFocusedOption",
	    value: function getNextFocusedOption(options) {
	      var lastFocusedOption = this.state.focusedOption;
	      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
	    }
	  }, {
	    key: "hasValue",
	    value: function hasValue() {
	      var selectValue = this.state.selectValue;
	      return selectValue.length > 0;
	    }
	  }, {
	    key: "hasOptions",
	    value: function hasOptions() {
	      return !!this.state.menuOptions.render.length;
	    }
	  }, {
	    key: "countOptions",
	    value: function countOptions() {
	      return this.state.menuOptions.focusable.length;
	    }
	  }, {
	    key: "isClearable",
	    value: function isClearable() {
	      var _this$props12 = this.props,
	          isClearable = _this$props12.isClearable,
	          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
	      // multi select, by default, IS clearable
	
	      if (isClearable === undefined) return isMulti;
	      return isClearable;
	    }
	  }, {
	    key: "isOptionDisabled",
	    value: function isOptionDisabled(option, selectValue) {
	      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
	    }
	  }, {
	    key: "isOptionSelected",
	    value: function isOptionSelected(option, selectValue) {
	      var _this2 = this;
	
	      if (selectValue.indexOf(option) > -1) return true;
	
	      if (typeof this.props.isOptionSelected === 'function') {
	        return this.props.isOptionSelected(option, selectValue);
	      }
	
	      var candidate = this.getOptionValue(option);
	      return selectValue.some(function (i) {
	        return _this2.getOptionValue(i) === candidate;
	      });
	    }
	  }, {
	    key: "filterOption",
	    value: function filterOption(option, inputValue) {
	      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
	    }
	  }, {
	    key: "formatOptionLabel",
	    value: function formatOptionLabel(data, context) {
	      if (typeof this.props.formatOptionLabel === 'function') {
	        var inputValue = this.props.inputValue;
	        var selectValue = this.state.selectValue;
	        return this.props.formatOptionLabel(data, {
	          context: context,
	          inputValue: inputValue,
	          selectValue: selectValue
	        });
	      } else {
	        return this.getOptionLabel(data);
	      }
	    }
	  }, {
	    key: "formatGroupLabel",
	    value: function formatGroupLabel(data) {
	      return this.props.formatGroupLabel(data);
	    } // ==============================
	    // Mouse Handlers
	    // ==============================
	
	  }, {
	    key: "startListeningComposition",
	    // ==============================
	    // Composition Handlers
	    // ==============================
	    value: function startListeningComposition() {
	      if (document && document.addEventListener) {
	        document.addEventListener('compositionstart', this.onCompositionStart, false);
	        document.addEventListener('compositionend', this.onCompositionEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningComposition",
	    value: function stopListeningComposition() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('compositionstart', this.onCompositionStart);
	        document.removeEventListener('compositionend', this.onCompositionEnd);
	      }
	    }
	  }, {
	    key: "startListeningToTouch",
	    // ==============================
	    // Touch Handlers
	    // ==============================
	    value: function startListeningToTouch() {
	      if (document && document.addEventListener) {
	        document.addEventListener('touchstart', this.onTouchStart, false);
	        document.addEventListener('touchmove', this.onTouchMove, false);
	        document.addEventListener('touchend', this.onTouchEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningToTouch",
	    value: function stopListeningToTouch() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('touchstart', this.onTouchStart);
	        document.removeEventListener('touchmove', this.onTouchMove);
	        document.removeEventListener('touchend', this.onTouchEnd);
	      }
	    }
	  }, {
	    key: "buildMenuOptions",
	    // ==============================
	    // Menu Options
	    // ==============================
	    value: function buildMenuOptions(props, selectValue) {
	      var _this3 = this;
	
	      var _props$inputValue = props.inputValue,
	          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
	          options = props.options;
	
	      var toOption = function toOption(option, id) {
	        var isDisabled = _this3.isOptionDisabled(option, selectValue);
	
	        var isSelected = _this3.isOptionSelected(option, selectValue);
	
	        var label = _this3.getOptionLabel(option);
	
	        var value = _this3.getOptionValue(option);
	
	        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
	          label: label,
	          value: value,
	          data: option
	        }, inputValue)) {
	          return;
	        }
	
	        var onHover = isDisabled ? undefined : function () {
	          return _this3.onOptionHover(option);
	        };
	        var onSelect = isDisabled ? undefined : function () {
	          return _this3.selectOption(option);
	        };
	        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
	        return {
	          innerProps: {
	            id: optionId,
	            onClick: onSelect,
	            onMouseMove: onHover,
	            onMouseOver: onHover,
	            tabIndex: -1
	          },
	          data: option,
	          isDisabled: isDisabled,
	          isSelected: isSelected,
	          key: optionId,
	          label: label,
	          type: 'option',
	          value: value
	        };
	      };
	
	      return options.reduce(function (acc, item, itemIndex) {
	        if (item.options) {
	          // TODO needs a tidier implementation
	          if (!_this3.hasGroups) _this3.hasGroups = true;
	          var items = item.options;
	          var children = items.map(function (child, i) {
	            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
	            if (option) acc.focusable.push(child);
	            return option;
	          }).filter(Boolean);
	
	          if (children.length) {
	            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
	            acc.render.push({
	              type: 'group',
	              key: groupId,
	              data: item,
	              options: children
	            });
	          }
	        } else {
	          var option = toOption(item, "".concat(itemIndex));
	
	          if (option) {
	            acc.render.push(option);
	            acc.focusable.push(item);
	          }
	        }
	
	        return acc;
	      }, {
	        render: [],
	        focusable: []
	      });
	    } // ==============================
	    // Renderers
	    // ==============================
	
	  }, {
	    key: "constructAriaLiveMessage",
	    value: function constructAriaLiveMessage() {
	      var _this$state7 = this.state,
	          ariaLiveContext = _this$state7.ariaLiveContext,
	          selectValue = _this$state7.selectValue,
	          focusedValue = _this$state7.focusedValue,
	          focusedOption = _this$state7.focusedOption;
	      var _this$props13 = this.props,
	          options = _this$props13.options,
	          menuIsOpen = _this$props13.menuIsOpen,
	          inputValue = _this$props13.inputValue,
	          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.
	
	      var focusedValueMsg = focusedValue ? (0, _index2.valueFocusAriaMessage)({
	        focusedValue: focusedValue,
	        getOptionLabel: this.getOptionLabel,
	        selectValue: selectValue
	      }) : ''; // An aria live message representing the currently focused option in the select.
	
	      var focusedOptionMsg = focusedOption && menuIsOpen ? (0, _index2.optionFocusAriaMessage)({
	        focusedOption: focusedOption,
	        getOptionLabel: this.getOptionLabel,
	        options: options
	      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
	
	      var resultsMsg = (0, _index2.resultsAriaMessage)({
	        inputValue: inputValue,
	        screenReaderMessage: screenReaderStatus({
	          count: this.countOptions()
	        })
	      });
	      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      var _this$props14 = this.props,
	          isDisabled = _this$props14.isDisabled,
	          isSearchable = _this$props14.isSearchable,
	          inputId = _this$props14.inputId,
	          inputValue = _this$props14.inputValue,
	          tabIndex = _this$props14.tabIndex;
	      var Input = this.components.Input;
	      var inputIsHidden = this.state.inputIsHidden;
	      var id = inputId || this.getElementId('input');
	
	      if (!isSearchable) {
	        // use a dummy input to maintain focus/blur functionality
	        return _react.default.createElement(_index.DummyInput, {
	          id: id,
	          innerRef: this.getInputRef,
	          onBlur: this.onInputBlur,
	          onChange: _utils.noop,
	          onFocus: this.onInputFocus,
	          readOnly: true,
	          disabled: isDisabled,
	          tabIndex: tabIndex,
	          value: ""
	        });
	      } // aria attributes makes the JSX "noisy", separated for clarity
	
	
	      var ariaAttributes = {
	        'aria-autocomplete': 'list',
	        'aria-label': this.props['aria-label'],
	        'aria-labelledby': this.props['aria-labelledby']
	      };
	      var _this$commonProps = this.commonProps,
	          cx = _this$commonProps.cx,
	          theme = _this$commonProps.theme,
	          selectProps = _this$commonProps.selectProps;
	      return _react.default.createElement(Input, _extends({
	        autoCapitalize: "none",
	        autoComplete: "off",
	        autoCorrect: "off",
	        cx: cx,
	        getStyles: this.getStyles,
	        id: id,
	        innerRef: this.getInputRef,
	        isDisabled: isDisabled,
	        isHidden: inputIsHidden,
	        onBlur: this.onInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.onInputFocus,
	        selectProps: selectProps,
	        spellCheck: "false",
	        tabIndex: tabIndex,
	        theme: theme,
	        type: "text",
	        value: inputValue
	      }, ariaAttributes));
	    }
	  }, {
	    key: "renderPlaceholderOrValue",
	    value: function renderPlaceholderOrValue() {
	      var _this4 = this;
	
	      var _this$components = this.components,
	          MultiValue = _this$components.MultiValue,
	          MultiValueContainer = _this$components.MultiValueContainer,
	          MultiValueLabel = _this$components.MultiValueLabel,
	          MultiValueRemove = _this$components.MultiValueRemove,
	          SingleValue = _this$components.SingleValue,
	          Placeholder = _this$components.Placeholder;
	      var commonProps = this.commonProps;
	      var _this$props15 = this.props,
	          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
	          isDisabled = _this$props15.isDisabled,
	          isMulti = _this$props15.isMulti,
	          inputValue = _this$props15.inputValue,
	          placeholder = _this$props15.placeholder;
	      var _this$state8 = this.state,
	          selectValue = _this$state8.selectValue,
	          focusedValue = _this$state8.focusedValue,
	          isFocused = _this$state8.isFocused;
	
	      if (!this.hasValue() || !controlShouldRenderValue) {
	        return inputValue ? null : _react.default.createElement(Placeholder, _extends({}, commonProps, {
	          key: "placeholder",
	          isDisabled: isDisabled,
	          isFocused: isFocused
	        }), placeholder);
	      }
	
	      if (isMulti) {
	        var selectValues = selectValue.map(function (opt) {
	          var isOptionFocused = opt === focusedValue;
	          return _react.default.createElement(MultiValue, _extends({}, commonProps, {
	            components: {
	              Container: MultiValueContainer,
	              Label: MultiValueLabel,
	              Remove: MultiValueRemove
	            },
	            isFocused: isOptionFocused,
	            isDisabled: isDisabled,
	            key: _this4.getOptionValue(opt),
	            removeProps: {
	              onClick: function onClick() {
	                return _this4.removeValue(opt);
	              },
	              onTouchEnd: function onTouchEnd() {
	                return _this4.removeValue(opt);
	              },
	              onMouseDown: function onMouseDown(e) {
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            },
	            data: opt
	          }), _this4.formatOptionLabel(opt, 'value'));
	        });
	        return selectValues;
	      }
	
	      if (inputValue) {
	        return null;
	      }
	
	      var singleValue = selectValue[0];
	      return _react.default.createElement(SingleValue, _extends({}, commonProps, {
	        data: singleValue,
	        isDisabled: isDisabled
	      }), this.formatOptionLabel(singleValue, 'value'));
	    }
	  }, {
	    key: "renderClearIndicator",
	    value: function renderClearIndicator() {
	      var ClearIndicator = this.components.ClearIndicator;
	      var commonProps = this.commonProps;
	      var _this$props16 = this.props,
	          isDisabled = _this$props16.isDisabled,
	          isLoading = _this$props16.isLoading;
	      var isFocused = this.state.isFocused;
	
	      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
	        return null;
	      }
	
	      var innerProps = {
	        onMouseDown: this.onClearIndicatorMouseDown,
	        onTouchEnd: this.onClearIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(ClearIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderLoadingIndicator",
	    value: function renderLoadingIndicator() {
	      var LoadingIndicator = this.components.LoadingIndicator;
	      var commonProps = this.commonProps;
	      var _this$props17 = this.props,
	          isDisabled = _this$props17.isDisabled,
	          isLoading = _this$props17.isLoading;
	      var isFocused = this.state.isFocused;
	      if (!LoadingIndicator || !isLoading) return null;
	      var innerProps = {
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(LoadingIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderIndicatorSeparator",
	    value: function renderIndicatorSeparator() {
	      var _this$components2 = this.components,
	          DropdownIndicator = _this$components2.DropdownIndicator,
	          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
	
	      if (!DropdownIndicator || !IndicatorSeparator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      return _react.default.createElement(IndicatorSeparator, _extends({}, commonProps, {
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderDropdownIndicator",
	    value: function renderDropdownIndicator() {
	      var DropdownIndicator = this.components.DropdownIndicator;
	      if (!DropdownIndicator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      var innerProps = {
	        onMouseDown: this.onDropdownIndicatorMouseDown,
	        onTouchEnd: this.onDropdownIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(DropdownIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this5 = this;
	
	      var _this$components3 = this.components,
	          Group = _this$components3.Group,
	          GroupHeading = _this$components3.GroupHeading,
	          Menu = _this$components3.Menu,
	          MenuList = _this$components3.MenuList,
	          MenuPortal = _this$components3.MenuPortal,
	          LoadingMessage = _this$components3.LoadingMessage,
	          NoOptionsMessage = _this$components3.NoOptionsMessage,
	          Option = _this$components3.Option;
	      var commonProps = this.commonProps;
	      var _this$state9 = this.state,
	          focusedOption = _this$state9.focusedOption,
	          menuOptions = _this$state9.menuOptions;
	      var _this$props18 = this.props,
	          captureMenuScroll = _this$props18.captureMenuScroll,
	          inputValue = _this$props18.inputValue,
	          isLoading = _this$props18.isLoading,
	          loadingMessage = _this$props18.loadingMessage,
	          minMenuHeight = _this$props18.minMenuHeight,
	          maxMenuHeight = _this$props18.maxMenuHeight,
	          menuIsOpen = _this$props18.menuIsOpen,
	          menuPlacement = _this$props18.menuPlacement,
	          menuPosition = _this$props18.menuPosition,
	          menuPortalTarget = _this$props18.menuPortalTarget,
	          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
	          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
	          noOptionsMessage = _this$props18.noOptionsMessage,
	          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
	          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
	      if (!menuIsOpen) return null; // TODO: Internal Option Type here
	
	      var render = function render(props) {
	        // for performance, the menu options in state aren't changed when the
	        // focused option changes so we calculate additional props based on that
	        var isFocused = focusedOption === props.data;
	        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
	        return _react.default.createElement(Option, _extends({}, commonProps, props, {
	          isFocused: isFocused
	        }), _this5.formatOptionLabel(props.data, 'menu'));
	      };
	
	      var menuUI;
	
	      if (this.hasOptions()) {
	        menuUI = menuOptions.render.map(function (item) {
	          if (item.type === 'group') {
	            var type = item.type,
	                group = _objectWithoutProperties(item, ["type"]);
	
	            var headingId = "".concat(item.key, "-heading");
	            return _react.default.createElement(Group, _extends({}, commonProps, group, {
	              Heading: GroupHeading,
	              headingProps: {
	                id: headingId
	              },
	              label: _this5.formatGroupLabel(item.data)
	            }), item.options.map(function (option) {
	              return render(option);
	            }));
	          } else if (item.type === 'option') {
	            return render(item);
	          }
	        });
	      } else if (isLoading) {
	        var message = loadingMessage({
	          inputValue: inputValue
	        });
	        if (message === null) return null;
	        menuUI = _react.default.createElement(LoadingMessage, commonProps, message);
	      } else {
	        var _message = noOptionsMessage({
	          inputValue: inputValue
	        });
	
	        if (_message === null) return null;
	        menuUI = _react.default.createElement(NoOptionsMessage, commonProps, _message);
	      }
	
	      var menuPlacementProps = {
	        minMenuHeight: minMenuHeight,
	        maxMenuHeight: maxMenuHeight,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition,
	        menuShouldScrollIntoView: menuShouldScrollIntoView
	      };
	
	      var menuElement = _react.default.createElement(_Menu.MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
	        var ref = _ref6.ref,
	            _ref6$placerProps = _ref6.placerProps,
	            placement = _ref6$placerProps.placement,
	            maxHeight = _ref6$placerProps.maxHeight;
	        return _react.default.createElement(Menu, _extends({}, commonProps, menuPlacementProps, {
	          innerRef: ref,
	          innerProps: {
	            onMouseDown: _this5.onMenuMouseDown,
	            onMouseMove: _this5.onMenuMouseMove
	          },
	          isLoading: isLoading,
	          placement: placement
	        }), _react.default.createElement(_index.ScrollCaptor, {
	          isEnabled: captureMenuScroll,
	          onTopArrive: onMenuScrollToTop,
	          onBottomArrive: onMenuScrollToBottom
	        }, _react.default.createElement(_index.ScrollBlock, {
	          isEnabled: menuShouldBlockScroll
	        }, _react.default.createElement(MenuList, _extends({}, commonProps, {
	          innerRef: _this5.getMenuListRef,
	          isLoading: isLoading,
	          maxHeight: maxHeight
	        }), menuUI))));
	      }); // positioning behaviour is almost identical for portalled and fixed,
	      // so we use the same component. the actual portalling logic is forked
	      // within the component based on `menuPosition`
	
	
	      return menuPortalTarget || menuPosition === 'fixed' ? _react.default.createElement(MenuPortal, _extends({}, commonProps, {
	        appendTo: menuPortalTarget,
	        controlElement: this.controlRef,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition
	      }), menuElement) : menuElement;
	    }
	  }, {
	    key: "renderFormField",
	    value: function renderFormField() {
	      var _this6 = this;
	
	      var _this$props19 = this.props,
	          delimiter = _this$props19.delimiter,
	          isDisabled = _this$props19.isDisabled,
	          isMulti = _this$props19.isMulti,
	          name = _this$props19.name;
	      var selectValue = this.state.selectValue;
	      if (!name || isDisabled) return;
	
	      if (isMulti) {
	        if (delimiter) {
	          var value = selectValue.map(function (opt) {
	            return _this6.getOptionValue(opt);
	          }).join(delimiter);
	          return _react.default.createElement("input", {
	            name: name,
	            type: "hidden",
	            value: value
	          });
	        } else {
	          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
	            return _react.default.createElement("input", {
	              key: "i-".concat(i),
	              name: name,
	              type: "hidden",
	              value: _this6.getOptionValue(opt)
	            });
	          }) : _react.default.createElement("input", {
	            name: name,
	            type: "hidden"
	          });
	          return _react.default.createElement("div", null, input);
	        }
	      } else {
	        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
	
	        return _react.default.createElement("input", {
	          name: name,
	          type: "hidden",
	          value: _value
	        });
	      }
	    }
	  }, {
	    key: "renderLiveRegion",
	    value: function renderLiveRegion() {
	      if (!this.state.isFocused) return null;
	      return _react.default.createElement(_index.A11yText, {
	        "aria-live": "assertive"
	      }, _react.default.createElement("p", {
	        id: "aria-selection-event"
	      }, "\xA0", this.state.ariaLiveSelection), _react.default.createElement("p", {
	        id: "aria-context"
	      }, "\xA0", this.constructAriaLiveMessage()));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$components4 = this.components,
	          Control = _this$components4.Control,
	          IndicatorsContainer = _this$components4.IndicatorsContainer,
	          SelectContainer = _this$components4.SelectContainer,
	          ValueContainer = _this$components4.ValueContainer;
	      var _this$props20 = this.props,
	          className = _this$props20.className,
	          id = _this$props20.id,
	          isDisabled = _this$props20.isDisabled,
	          menuIsOpen = _this$props20.menuIsOpen;
	      var isFocused = this.state.isFocused;
	      var commonProps = this.commonProps = this.getCommonProps();
	      return _react.default.createElement(SelectContainer, _extends({}, commonProps, {
	        className: className,
	        innerProps: {
	          id: id,
	          onKeyDown: this.onKeyDown
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }), this.renderLiveRegion(), _react.default.createElement(Control, _extends({}, commonProps, {
	        innerRef: this.getControlRef,
	        innerProps: {
	          onMouseDown: this.onControlMouseDown,
	          onTouchEnd: this.onControlTouchEnd
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused,
	        menuIsOpen: menuIsOpen
	      }), _react.default.createElement(ValueContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderPlaceholderOrValue(), this.renderInput()), _react.default.createElement(IndicatorsContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
	    }
	  }]);
	
	  return Select;
	}(_react.Component);
	
	exports.default = Select;
	
	_defineProperty(Select, "defaultProps", defaultProps);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  defaultInputValue: '',
	  defaultMenuIsOpen: false,
	  defaultValue: null
	};
	exports.defaultProps = defaultProps;
	
	var manageState = function manageState(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(StateManager, _Component);
	
	    function StateManager() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, StateManager);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
	        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
	        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
	        _this.callProp('onChange', value, actionMeta);
	
	        _this.setState({
	          value: value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
	        // TODO: for backwards compatibility, we allow the prop to return a new
	        // value, but now inputValue is a controllable prop we probably shouldn't
	        var newValue = _this.callProp('onInputChange', value, actionMeta);
	
	        _this.setState({
	          inputValue: newValue !== undefined ? newValue : value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
	        _this.callProp('onMenuOpen');
	
	        _this.setState({
	          menuIsOpen: true
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
	        _this.callProp('onMenuClose');
	
	        _this.setState({
	          menuIsOpen: false
	        });
	      });
	
	      return _this;
	    }
	
	    _createClass(StateManager, [{
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "getProp",
	      value: function getProp(key) {
	        return this.props[key] !== undefined ? this.props[key] : this.state[key];
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "callProp",
	      value: function callProp(name) {
	        if (typeof this.props[name] === 'function') {
	          var _this$props;
	
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          return (_this$props = this.props)[name].apply(_this$props, args);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            defaultInputValue = _this$props2.defaultInputValue,
	            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
	            defaultValue = _this$props2.defaultValue,
	            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
	
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          inputValue: this.getProp('inputValue'),
	          menuIsOpen: this.getProp('menuIsOpen'),
	          onChange: this.onChange,
	          onInputChange: this.onInputChange,
	          onMenuClose: this.onMenuClose,
	          onMenuOpen: this.onMenuOpen,
	          value: this.getProp('value')
	        }));
	      }
	    }]);
	
	    return StateManager;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	var _default = manageState;
	exports.default = _default;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.classNames = classNames;
	exports.handleInputChange = handleInputChange;
	exports.isDocumentElement = isDocumentElement;
	exports.normalizedHeight = normalizedHeight;
	exports.getScrollTop = getScrollTop;
	exports.scrollTo = scrollTo;
	exports.getScrollParent = getScrollParent;
	exports.animatedScrollTo = animatedScrollTo;
	exports.scrollIntoView = scrollIntoView;
	exports.getBoundingClientObj = getBoundingClientObj;
	exports.toKey = toKey;
	exports.isTouchCapable = isTouchCapable;
	exports.isMobileDevice = isMobileDevice;
	exports.cleanValue = exports.emptyString = exports.noop = void 0;
	
	var _raf = _interopRequireDefault(__webpack_require__(163));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	// ==============================
	// NO OP
	// ==============================
	var noop = function noop() {};
	
	exports.noop = noop;
	
	var emptyString = function emptyString() {
	  return '';
	}; // ==============================
	// Class Name Prefixer
	// ==============================
	
	/**
	 String representation of component state for styling with class names.
	
	 Expects an array of strings OR a string/object pair:
	 - className(['comp', 'comp-arg', 'comp-arg-2'])
	   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
	 - className('comp', { some: true, state: false })
	   @returns 'react-select__comp react-select__comp--some'
	*/
	
	
	exports.emptyString = emptyString;
	
	function applyPrefixToName(prefix, name) {
	  if (!name) {
	    return prefix;
	  } else if (name[0] === '-') {
	    return prefix + name;
	  } else {
	    return prefix + '__' + name;
	  }
	}
	
	function classNames(prefix, cssKey, state, className) {
	  var arr = [cssKey, className];
	
	  if (state && prefix) {
	    for (var key in state) {
	      if (state.hasOwnProperty(key) && state[key]) {
	        arr.push("".concat(applyPrefixToName(prefix, key)));
	      }
	    }
	  }
	
	  return arr.filter(function (i) {
	    return i;
	  }).map(function (i) {
	    return String(i).trim();
	  }).join(' ');
	} // ==============================
	// Clean Value
	// ==============================
	
	
	var cleanValue = function cleanValue(value) {
	  if (Array.isArray(value)) return value.filter(Boolean);
	  if (_typeof(value) === 'object' && value !== null) return [value];
	  return [];
	}; // ==============================
	// Handle Input Change
	// ==============================
	
	
	exports.cleanValue = cleanValue;
	
	function handleInputChange(inputValue, actionMeta, onInputChange) {
	  if (onInputChange) {
	    var newValue = onInputChange(inputValue, actionMeta);
	    if (typeof newValue === 'string') return newValue;
	  }
	
	  return inputValue;
	} // ==============================
	// Scroll Helpers
	// ==============================
	
	
	function isDocumentElement(el) {
	  return [document.documentElement, document.body, window].indexOf(el) > -1;
	} // Normalized Scroll Top
	// ------------------------------
	
	
	function normalizedHeight(el) {
	  if (isDocumentElement(el)) {
	    return window.innerHeight;
	  }
	
	  return el.clientHeight;
	} // Normalized scrollTo & scrollTop
	// ------------------------------
	
	
	function getScrollTop(el) {
	  if (isDocumentElement(el)) {
	    return window.pageYOffset;
	  }
	
	  return el.scrollTop;
	}
	
	function scrollTo(el, top) {
	  // with a scroll distance, we perform scroll on the element
	  if (isDocumentElement(el)) {
	    window.scrollTo(0, top);
	    return;
	  }
	
	  el.scrollTop = top;
	} // Get Scroll Parent
	// ------------------------------
	
	
	function getScrollParent(element) {
	  var style = getComputedStyle(element);
	  var excludeStaticParent = style.position === 'absolute';
	  var overflowRx = /(auto|scroll)/;
	  var docEl = document.documentElement; // suck it, flow...
	
	  if (style.position === 'fixed') return docEl;
	
	  for (var parent = element; parent = parent.parentElement;) {
	    style = getComputedStyle(parent);
	
	    if (excludeStaticParent && style.position === 'static') {
	      continue;
	    }
	
	    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
	      return parent;
	    }
	  }
	
	  return docEl;
	} // Animated Scroll To
	// ------------------------------
	
	/**
	  @param t: time (elapsed)
	  @param b: initial value
	  @param c: amount of change
	  @param d: duration
	*/
	
	
	function easeOutCubic(t, b, c, d) {
	  return c * ((t = t / d - 1) * t * t + 1) + b;
	}
	
	function animatedScrollTo(element, to) {
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
	  var start = getScrollTop(element);
	  var change = to - start;
	  var increment = 10;
	  var currentTime = 0;
	
	  function animateScroll() {
	    currentTime += increment;
	    var val = easeOutCubic(currentTime, start, change, duration);
	    scrollTo(element, val);
	
	    if (currentTime < duration) {
	      (0, _raf.default)(animateScroll);
	    } else {
	      callback(element);
	    }
	  }
	
	  animateScroll();
	} // Scroll Into View
	// ------------------------------
	
	
	function scrollIntoView(menuEl, focusedEl) {
	  var menuRect = menuEl.getBoundingClientRect();
	  var focusedRect = focusedEl.getBoundingClientRect();
	  var overScroll = focusedEl.offsetHeight / 3;
	
	  if (focusedRect.bottom + overScroll > menuRect.bottom) {
	    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
	  } else if (focusedRect.top - overScroll < menuRect.top) {
	    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
	  }
	} // ==============================
	// Get bounding client object
	// ==============================
	// cannot get keys using array notation with DOMRect
	
	
	function getBoundingClientObj(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    bottom: rect.bottom,
	    height: rect.height,
	    left: rect.left,
	    right: rect.right,
	    top: rect.top,
	    width: rect.width
	  };
	}
	
	// ==============================
	// String to Key (kebabify)
	// ==============================
	function toKey(str) {
	  return str.replace(/\W/g, '-');
	} // ==============================
	// Touch Capability Detector
	// ==============================
	
	
	function isTouchCapable() {
	  try {
	    document.createEvent('TouchEvent');
	    return true;
	  } catch (e) {
	    return false;
	  }
	} // ==============================
	// Mobile Device Detector
	// ==============================
	
	
	function isMobileDevice() {
	  try {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	  } catch (e) {
	    return false;
	  }
	}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultCellRangeRenderer = exports.Grid = exports.default = undefined;
	
	var _Grid2 = __webpack_require__(2118);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _defaultCellRangeRenderer2 = __webpack_require__(892);
	
	var _defaultCellRangeRenderer3 = _interopRequireDefault(_defaultCellRangeRenderer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid3.default;
	exports.Grid = _Grid3.default;
	exports.defaultCellRangeRenderer = _defaultCellRangeRenderer3.default;

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.filterPropsFrom = filterPropsFrom;
	var internalProps = {
	    column: true,
	    columns: true,
	    sortable: true,
	    filterable: true,
	    sortBy: true,
	    defaultSort: true,
	    itemsPerPage: true,
	    childNode: true,
	    data: true,
	    children: true,
	    topPagination: true,
	    middlePagination: true,
	    itemsNumber: true,
	    numPages: true,
	    currentPage: true,
	    topPaginationElem: true,
	    middlePaginationElem: true,
	    filtering: true,
	    onFilter: true,
	    filterCleanBtn: true,
	    onClean: true,
	    onPageChange: true,
	    filterPlaceholder: true,
	    currentFilter: true,
	    sort: true,
	    sortableColumns: true,
	    onSort: true,
	    locale: true
	};
	
	function filterPropsFrom(baseProps) {
	    baseProps = baseProps || {};
	    var props = {};
	    for (var key in baseProps) {
	        if (!(key in internalProps)) {
	            props[key] = baseProps[key];
	        }
	    }
	
	    return props;
	}


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.unsafe = unsafe;
	exports.isUnsafe = isUnsafe;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Unsafe = (function () {
	    function Unsafe(content) {
	        _classCallCheck(this, Unsafe);
	
	        this.content = content;
	    }
	
	    _createClass(Unsafe, [{
	        key: "toString",
	        value: function toString() {
	            return this.content;
	        }
	    }]);
	
	    return Unsafe;
	})();
	
	function unsafe(str) {
	    return new Unsafe(str);
	}
	
	;
	
	function isUnsafe(obj) {
	    return obj instanceof Unsafe;
	}
	
	;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  // FIXME: Work around our browser history not working correctly on Chrome
	  // iOS: https://github.com/rackt/react-router/issues/2565
	  if (ua.indexOf('CriOS') !== -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValid;
	function isValid(error) {
	  if (Array.isArray(error)) {
	    return error.reduce(function (valid, errorValue) {
	      return valid && isValid(errorValue);
	    }, true);
	  }
	  if (error && typeof error === 'object') {
	    return Object.keys(error).reduce(function (valid, key) {
	      return valid && isValid(error[key]);
	    }, true);
	  }
	  return !error;
	}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(943);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2233);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2232);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2231);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(942);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(944);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(632)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/icn-plus.svg";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/BE_Logo_OVB_Willemot_White.svg";

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAzMzY2Ij48cGF0aCBkPSJNMjAwLTIwMGg1MC40Nmw0MDkuNDYtNDA5LjQ2LTUwLjQ2LTUwLjQ2TDIwMC0yNTAuNDZWLTIwMFptLTYwIDYwdi0xMzUuMzhsNTI3LjYyLTUyNy4zOXE5LjA3LTguMjQgMjAuMDMtMTIuNzMgMTAuOTctNC41IDIzLTQuNXQyMy4zIDQuMjdxMTEuMjggNC4yNyAxOS45NyAxMy41OGw0OC44NSA0OS40NnE5LjMxIDguNjkgMTMuMjcgMjAgMy45NiAxMS4zMSAzLjk2IDIyLjYyIDAgMTIuMDctNC4xMiAyMy4wMy00LjEyIDEwLjk3LTEzLjExIDIwLjA0TDI3NS4zOC0xNDBIMTQwWm02MjAuMzgtNTcwLjE1LTUwLjIzLTUwLjIzIDUwLjIzIDUwLjIzWm0tMTI2LjEzIDc1LjktMjQuNzktMjUuNjcgNTAuNDYgNTAuNDYtMjUuNjctMjQuNzlaIi8+PC9zdmc+"

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjRkZGRkZGIj48cGF0aCBkPSJNMjAwLTgwcS0zMyAwLTU2LjUtMjMuNVQxMjAtMTYwdi0xNjBxMC0zMyAyMy41LTU2LjVUMjAwLTQwMGg1NjBxMzMgMCA1Ni41IDIzLjVUODQwLTMyMHYxNjBxMCAzMy0yMy41IDU2LjVUNzYwLTgwSDIwMFptMC04MGg1NjB2LTE2MEgyMDB2MTYwWm02MS0zMDBMNjAtNTc0bDI0MC00MC02NS0yMzUgMTk5IDE0MSAxMjAtMjEyIDQwIDI0MCAyMzUtNjUtMTQxIDE5OSAxNTIgODZINjc4bC0xMDYtNjAgNjItODgtMTA0IDI5LTE4LTEwNi01MiA5My04OC02MiAyOSAxMDQtMTA2IDE4IDEyMCA3MkgyNjFabTIyNiAwWm0tNyAyMjBaIi8+PC9zdmc+"

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-dsdocuments-white.svg";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-inbox-white.svg";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-logout.svg";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/print-black-18dp.svg";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _WizardButtonsScss = __webpack_require__(1578);
	
	var _WizardButtonsScss2 = _interopRequireDefault(_WizardButtonsScss);
	
	function WizardButtons(props) {
	    var leftBtn = props.leftBtn;
	    var cancelBtn = props.cancelBtn;
	    var nextBtn = props.nextBtn;
	    var previousBtn = props.previousBtn;
	    var middleActionBtn = props.middleActionBtn;
	
	    var renderBtn = function renderBtn(btnData, style) {
	        var disabled = btnData.disabled;
	        var method = btnData.method;
	        var isHidden = btnData.isHidden;
	        var label = btnData.label;
	
	        return isHidden ? '' : _react2['default'].createElement(
	            'button',
	            {
	                type: 'button',
	                className: style,
	                disabled: disabled,
	                onClick: function (e) {
	                    e.preventDefault();
	                    method();
	                }
	            },
	            label
	        );
	    };
	
	    return _react2['default'].createElement(
	        'div',
	        { className: _WizardButtonsScss2['default'].buttonsWrapper },
	        _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])(_WizardButtonsScss2['default'].modalButtons, _WizardButtonsScss2['default'].leftBtnContainer) },
	            leftBtn && !leftBtn.isHidden && renderBtn(leftBtn, _WizardButtonsScss2['default'].greenButton + " enabled")
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: _WizardButtonsScss2['default'].modalButtons },
	            cancelBtn && _react2['default'].createElement(
	                'div',
	                {
	                    onClick: cancelBtn.method,
	                    className: _WizardButtonsScss2['default'].cancel
	                },
	                cancelBtn.label
	            ),
	            previousBtn && !previousBtn.isHidden && renderBtn(previousBtn, _WizardButtonsScss2['default'].greenButton + " enabled"),
	            middleActionBtn && !middleActionBtn.isHidden && renderBtn(middleActionBtn, _WizardButtonsScss2['default'].greenButton + " enabled"),
	            nextBtn && renderBtn(nextBtn, _WizardButtonsScss2['default'].greenButton + " enabled")
	        )
	    );
	}
	
	exports['default'] = WizardButtons;
	module.exports = exports['default'];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelectLibCreatable = __webpack_require__(165);
	
	var _reactSelectLibCreatable2 = _interopRequireDefault(_reactSelectLibCreatable);
	
	var _customStylesJs = __webpack_require__(594);
	
	var _reactSelect = __webpack_require__(105);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _WizardReactSelectScss = __webpack_require__(1579);
	
	var _WizardReactSelectScss2 = _interopRequireDefault(_WizardReactSelectScss);
	
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var DropdownIndicator = function DropdownIndicator(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.DropdownIndicator,
	        props,
	        _react2['default'].createElement(
	            'span',
	            { className: _WizardReactSelectScss2['default'].downArrowHolder },
	            _react2['default'].createElement('span', { className: _WizardReactSelectScss2['default'].downArrow })
	        )
	    );
	};
	
	exports.DropdownIndicator = DropdownIndicator;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var NoOptionsMessage = function NoOptionsMessage(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.NoOptionsMessage,
	        props,
	        props.selectProps.noOptionsLabel || _('noOptions')
	    );
	};
	
	exports.NoOptionsMessage = NoOptionsMessage;
	var getDeleteIcon = function getDeleteIcon() {
	    try {
	        return __webpack_require__(79);
	    } catch (err) {
	        return __webpack_require__(23);
	    }
	};
	
	/**
	 *
	 * @param {*} props
	 */
	var SelectRemovableOption = function SelectRemovableOption(props) {
	    return _react2['default'].createElement(
	        'div',
	        { className: _WizardReactSelectScss2['default'].creatableOptionContainer },
	        _react2['default'].createElement(_reactSelect.components.Option, _extends({}, props, { className: _WizardReactSelectScss2['default'].creatableOptionItem })),
	        props.data.isRecent ? _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(
	                'button',
	                { type: 'button', className: _WizardReactSelectScss2['default'].creatableOptionItem, onClick: function (event) {
	                        event.preventDefault();
	                        props['delete'](props.value);
	                    } },
	                _react2['default'].createElement('img', { src: getDeleteIcon() })
	            )
	        ) : null
	    );
	};
	
	/**
	 * This is a custom MultiValueRemove for react select to be able set a separate unremovable value in dropdown
	 * but the rest is still dynamic
	 * @param {object} props
	 */
	var MultiValueRemove = function MultiValueRemove(props) {
	    return _react2['default'].createElement(
	        _reactSelect.components.MultiValueRemove,
	        props,
	        !props.data.isPermanentSelected ? props.children : null,
	        !props.data.isPermanentSelected ? props.children : null
	    );
	};
	
	var ValueContainer = function ValueContainer(_ref) {
	    var children = _ref.children;
	
	    var props = _objectWithoutProperties(_ref, ['children']);
	
	    return _react2['default'].createElement(
	        _reactSelect.components.ValueContainer,
	        _extends({}, props, { className: _WizardReactSelectScss2['default'].selectValueContainer }),
	        _react2['default'].createElement(
	            'div',
	            { className: _WizardReactSelectScss2['default'].composeRecipients },
	            children
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: _WizardReactSelectScss2['default'].ccButtonHolder },
	            props.selectProps.showExtraButton ? _react2['default'].createElement(
	                'div',
	                { className: _WizardReactSelectScss2['default'].ccButtonInSelect, onClick: function (e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        props.selectProps.onClickExtraButton(e);
	                    } },
	                'CC'
	            ) : null
	        )
	    );
	};
	
	var CreatableSelectWrapper = function CreatableSelectWrapper(_ref2) {
	    var value = _ref2.value;
	    var options = _ref2.options;
	    var onBlur = _ref2.onBlur;
	    var onChange = _ref2.onChange;
	    var formatCreateLabel = _ref2.formatCreateLabel;
	    var isCreatableSelect = _ref2.isCreatableSelect;
	    var noOptionsLabel = _ref2.noOptionsLabel;
	
	    var props = _objectWithoutProperties(_ref2, ['value', 'options', 'onBlur', 'onChange', 'formatCreateLabel', 'isCreatableSelect', 'noOptionsLabel']);
	
	    var selectedValue = value;
	    if (typeof selectedValue === 'string') {
	        // This code enables the select to work with the new react-select
	        selectedValue = options && options.length > 0 ? options.find(function (option) {
	            return option.value === selectedValue;
	        }) || { value: selectedValue, label: selectedValue } : null;
	    }
	
	    if (isCreatableSelect) {
	        return _react2['default'].createElement(_reactSelectLibCreatable2['default'], _extends({
	            placeholder: '',
	            value: selectedValue,
	            options: options,
	            onChange: function (newValue) {
	                return onChange(newValue);
	            },
	            onBlur: function (ev) {
	                onChange && ev.target.value ? onChange({ label: ev.target.value, value: ev.target.value }) : null;
	            }
	        }, props, {
	            isSearchable: true, // Searchable is true by default
	            styles: _customStylesJs.customCreatableSelectStyles,
	            formatCreateLabel: function (value) {
	                return formatCreateLabel + ' ' + value;
	            },
	            components: {
	                DropdownIndicator: DropdownIndicator, NoOptionsMessage: NoOptionsMessage,
	                // Option: (p) => (SelectRemovableOption({ ...p, delete: setDeleteItemByOption })),
	                MultiValueRemove: MultiValueRemove, /* MultiValueContainer,*/ValueContainer: ValueContainer
	            }
	        }));
	    } else {
	        return _react2['default'].createElement(_reactSelect2['default'], _extends({}, props, {
	            value: selectedValue,
	            // onBlur={(ev) => {
	            //     onChange ? onChange({ label: ev.target.value, value: ev.target.value }) : null
	            // }}
	            onChange: function (newValue) {
	                return onChange(newValue);
	            },
	            options: options,
	            noOptionsLabel: noOptionsLabel,
	            openMenuOnFocus: true,
	            placeholder: '',
	            onBlurResetsInput: false,
	            isSearchable: true,
	            styles: _customStylesJs.customCreatableSelectStyles,
	            components: {
	                DropdownIndicator: DropdownIndicator, NoOptionsMessage: NoOptionsMessage,
	                // Option: (p) => (SelectRemovableOption({ ...p, delete: setDeleteItemByOption })),
	                MultiValueRemove: MultiValueRemove, /* MultiValueContainer,*/ValueContainer: ValueContainer
	            }
	            // className={customClassName}
	            // showExtraButton={showExtraButton && !isDisabled}
	            // onClickExtraButton={onClickExtraButton}
	        }));
	    }
	};
	exports.CreatableSelectWrapper = CreatableSelectWrapper;
	CreatableSelectWrapper.propTypes = {
	    value: _react.PropTypes.any,
	    options: _react.PropTypes.array,
	    onBlur: _react.PropTypes.func,
	    onChange: _react.PropTypes.func,
	    formatCreateLabel: _react2['default'].PropTypes.string
	};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	//import cs from 'classnames'
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	// import * as c from 'state/constants'
	
	// init translations
	var _ = (0, _libI18n2['default'])('dswizard');
	
	var AreYouSureModal = (function (_Component) {
	    _inherits(AreYouSureModal, _Component);
	
	    function AreYouSureModal() {
	        _classCallCheck(this, AreYouSureModal);
	
	        _get(Object.getPrototypeOf(AreYouSureModal.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(AreYouSureModal, [{
	        key: 'render',
	
	        /**
	         * Content of are you sure modal
	         */
	        value: function render() {
	            var _props = this.props;
	            var isOpenAreYouSure = _props.isOpenAreYouSure;
	            var style = _props.style;
	            var isOpen = _props.isOpen;
	            var contentLabel = _props.contentLabel;
	            var didClose = _props.didClose;
	
	            var htmlContent = false;
	            var message1 = _nestedProperty2['default'].get(isOpenAreYouSure, "message1") || "";
	            var isErrorMessage = _nestedProperty2['default'].get(isOpenAreYouSure, "isErrorMessage") || false;
	
	            if (isOpenAreYouSure && message1 && typeof message1 === 'string') {
	                if (message1.includes("<!DOCTYPE HTML PUBLIC")) {
	                    htmlContent = message1;
	                }
	            }
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: isOpen,
	                    style: style,
	                    contentLabel: contentLabel,
	                    key: "AreYouSureModalKey" + (0, _uuidV42['default'])()
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalContent, key: 'rootComponentOfDsWizardAreYouSureModalRender' },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _documentsScss2['default'].title },
	                        isOpenAreYouSure.title
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: isErrorMessage ? _documentsScss2['default'].errorMessage : _documentsScss2['default'].message },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _documentsScss2['default'].resendModalContainer },
	                            isOpenAreYouSure && _react2['default'].createElement(
	                                'div',
	                                null,
	                                isOpenAreYouSure.message
	                            ),
	                            isOpenAreYouSure && message1 && _react2['default'].createElement(
	                                'div',
	                                { key: 'detailsDivInModal' },
	                                _('details') + ": ",
	                                htmlContent && _react2['default'].createElement('div', { key: 'htmlContent', dangerouslySetInnerHTML: { __html: String(htmlContent).toString() } }),
	                                !htmlContent && _react2['default'].createElement(
	                                    'div',
	                                    { key: 'moHtmlContent' },
	                                    ' ',
	                                    message1,
	                                    ' '
	                                )
	                            ),
	                            isOpenAreYouSure && isOpenAreYouSure.message2 && _react2['default'].createElement(
	                                'div',
	                                null,
	                                isOpenAreYouSure.message2
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentsModalButtons },
	                        !(isOpenAreYouSure && isOpenAreYouSure.noCancelButton === true) && _react2['default'].createElement(
	                            'div',
	                            {
	                                onClick: function () {
	                                    if (typeof isOpenAreYouSure.callBackCancel === 'function') {
	                                        isOpenAreYouSure.callBackCancel();
	                                        didClose();
	                                    }
	                                },
	                                className: _documentsScss2['default'].cancel
	                            },
	                            _("cancel")
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            {
	                                onClick: function () {
	                                    if (typeof isOpenAreYouSure.callBackOk === 'function') {
	                                        isOpenAreYouSure.callBackOk();
	                                        didClose();
	                                    }
	                                },
	                                className: _documentsScss2['default'].greenButton + " enabled"
	                            },
	                            _("ok")
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            isOpenAreYouSure: _react.PropTypes.object,
	            isOpen: _react.PropTypes.bool,
	            style: _react.PropTypes.object,
	            contentLabel: _react.PropTypes.string,
	            didClose: _react.PropTypes.func,
	            noCancelButton: _react.PropTypes.bool
	        },
	        enumerable: true
	    }]);
	
	    return AreYouSureModal;
	})(_react.Component);
	
	exports['default'] = AreYouSureModal;
	module.exports = exports['default'];

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _DSWizardHelperScss = __webpack_require__(196);
	
	var _DSWizardHelperScss2 = _interopRequireDefault(_DSWizardHelperScss);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _documentsHelpers = __webpack_require__(106);
	
	var _linkToContractAndUploadDocumentsDsPackageLinkAndUploadButton = __webpack_require__(1051);
	
	var _linkToContractAndUploadDocumentsDsPackageLinkAndUploadButton2 = _interopRequireDefault(_linkToContractAndUploadDocumentsDsPackageLinkAndUploadButton);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	/**
	 * This module wraps buttons that needs to be rendered  on the documents list
	 */
	
	var DsListButtonsWrapper = (function (_Component) {
	    _inherits(DsListButtonsWrapper, _Component);
	
	    _createClass(DsListButtonsWrapper, null, [{
	        key: 'propTypes',
	        value: {
	            dsPackage: _react2['default'].PropTypes.object,
	            templates: _react2['default'].PropTypes.array,
	            isDsList: _react2['default'].PropTypes.bool,
	            // openLinkAndUploadWizard: React.PropTypes.func,
	            method: _react2['default'].PropTypes.func,
	            key: _react2['default'].PropTypes.string,
	            canCreateMifid: _react2['default'].PropTypes.bool,
	            forceOpenInvitationEditor: _react2['default'].PropTypes.bool
	        },
	        enumerable: true
	    }]);
	
	    function DsListButtonsWrapper(props) {
	        _classCallCheck(this, DsListButtonsWrapper);
	
	        _get(Object.getPrototypeOf(DsListButtonsWrapper.prototype), 'constructor', this).call(this, props);
	
	        this.getIcon = function (menuName) {
	            var isWhite = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            try {
	                return isWhite ? __webpack_require__(592)("./m-" + menuName + '.svg') : __webpack_require__(262)("./icn-" + menuName + '.svg');
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        };
	
	        this.state = {
	            dsPackage: {}
	        };
	    }
	
	    /**
	     * Checks if package has stakeholders that haven't signed yet
	     * @param {*} dsPackage
	     * @returns Boolean
	     */
	
	    _createClass(DsListButtonsWrapper, [{
	        key: 'hasUnfinishedStakeholder',
	        value: function hasUnfinishedStakeholder(dsPackage) {
	            var hasUnfinishedStakeholder = false;
	            dsPackage.dsStakeholders.map(function (oneStakeholder) {
	                if (!oneStakeholder.finished && oneStakeholder.signerType !== "BROKER") {
	                    hasUnfinishedStakeholder = true;
	                }
	            });
	            return hasUnfinishedStakeholder;
	        }
	
	        /**
	         * This function helps to use an icon on a safe way
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var dsPackage = _props.dsPackage;
	            var method = _props.method;
	            var isDsList = _props.isDsList;
	            var sendRemindersMethod = _props.sendRemindersMethod;
	            var directSignMethod = _props.directSignMethod;
	            var canCreateMifid = _props.canCreateMifid;
	            var zoomTo = _props.zoomTo;
	            var showInvitation = _props.showInvitation;
	            var sendInvitationMethod = _props.sendInvitationMethod;
	
	            var isEditableThePackage = (0, _documentsHelpers.shouldEditThePackage)(_nestedProperty2['default'].get(dsPackage, "statusHistory"), _nestedProperty2['default'].get(dsPackage, "isEditable"));
	
	            var blocked = false;
	            var statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed', 'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError', 'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError', 'printed'];
	            if (dsPackage && dsPackage.statusHistory) {
	                dsPackage.statusHistory.forEach(function (oneStatus) {
	                    if (statusBlackList.includes(oneStatus.status)) {
	                        blocked = true;
	                    }
	                });
	            }
	
	            var packageStatusError = dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_documentsScss2['default'].dsListButtonsWrapper) },
	                _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_documentsScss2['default'].marginBot, _documentsScss2['default'].linkButton) },
	                    _react2['default'].createElement(_linkToContractAndUploadDocumentsDsPackageLinkAndUploadButton2['default'], {
	                        packageIsEditable: dsPackage.isisEditable,
	                        dsPackage: dsPackage,
	                        openLinkAndUploadWizard: function (dsPackage) {
	                            return method(dsPackage);
	                        }
	                    })
	                ),
	                !packageStatusError && isDsList && dsPackage.mustBeSigned && !dsPackage.hasFinishStatus && this.hasUnfinishedStakeholder(dsPackage) && !(0, _documentsHelpers.shouldEditThePackage)(dsPackage.statusHistory, dsPackage.isEditable) && !(0, _documentsHelpers.stakeholdersNeedInvitation)(dsPackage) && _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_documentsScss2['default'].marginBot, _documentsScss2['default'].grow) },
	                    _react2['default'].createElement(
	                        'button',
	                        { className: (0, _classnames2['default'])(_documentsScss2['default'].greenButton, _documentsScss2['default'].greenButtonDsList, "enabled", _documentsScss2['default'].grow),
	                            onClick: function (ev) {
	                                ev.stopPropagation();
	                                return sendRemindersMethod(dsPackage.id);
	                            } },
	                        _('sendRemindersButton')
	                    )
	                ),
	                !packageStatusError && showInvitation && isDsList && dsPackage.mustBeSigned && !dsPackage.hasFinishStatus && (0, _documentsHelpers.stakeholdersNeedInvitation)(dsPackage) && !(0, _documentsHelpers.shouldEditThePackage)(dsPackage.statusHistory, dsPackage.isEditable) && _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_documentsScss2['default'].marginBot, _documentsScss2['default'].grow), key: "invitationeditable" + dsPackage.id },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            key: "btnMifid",
	                            className: (0, _classnames2['default'])(_documentsScss2['default'].greenButton, _documentsScss2['default'].greenButtonDsList, "enabled", _DSWizardHelperScss2['default'].grayButtonFlex, _DSWizardHelperScss2['default'].mifidButton, _documentsScss2['default'].grow /*(disabled ? styles.disabled : '')*/),
	                            onClick: function (e) {
	                                e.stopPropagation();
	                                sendInvitationMethod(dsPackage.id);
	                            }
	                        },
	                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_documentsScss2['default'].emailButtonIcon), src: this.getIcon('inbox', true) }),
	                        ' ',
	                        _('customizeInvitationEmail')
	                    )
	                ),
	                !packageStatusError && !isEditableThePackage && dsPackage.mustBeSigned && (0, _documentsHelpers.stakeholdersCanSign)(dsPackage) && _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_documentsScss2['default'].marginBot, _documentsScss2['default'].grow) },
	                    _react2['default'].createElement(
	                        'button',
	                        { className: (0, _classnames2['default'])(_documentsScss2['default'].greenButton, _documentsScss2['default'].greenButtonDsList, "enabled", _documentsScss2['default'].grow),
	                            onClick: function (ev) {
	                                ev.stopPropagation();
	                                return directSignMethod(dsPackage.id);
	                            } },
	                        _("directSignButton")
	                    )
	                ),
	                isEditableThePackage && canCreateMifid && _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_documentsScss2['default'].marginBot, _documentsScss2['default'].grow), key: "mifidButton" },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            key: "btnMifid",
	                            className: (0, _classnames2['default'])(_documentsScss2['default'].greenButton, _documentsScss2['default'].greenButtonDsList, "enabled", _DSWizardHelperScss2['default'].grayButtonFlex, _DSWizardHelperScss2['default'].mifidButton, _documentsScss2['default'].grow /*(disabled ? styles.disabled : '')*/),
	                            onClick: function (e) {
	                                e.stopPropagation();
	                                zoomTo(dsPackage, true);
	                            }
	                        },
	                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_documentsScss2['default'].emailButtonIcon), src: this.getIcon('dsdocuments-white') }),
	                        ' ',
	                        _('resumeToEdit')
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DsListButtonsWrapper;
	})(_react.Component);
	
	exports['default'] = DsListButtonsWrapper;
	module.exports = exports['default'];
	/* {oneDoc && oneDoc.uploadedToOracle ? _("documentAlreadyUploaded") : ""} */

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _bpostSelectJson = __webpack_require__(309);
	
	var _bpostSelectJson2 = _interopRequireDefault(_bpostSelectJson);
	
	var _reactSelectLibCreatable = __webpack_require__(165);
	
	var _reactSelectLibCreatable2 = _interopRequireDefault(_reactSelectLibCreatable);
	
	var _reactSelect = __webpack_require__(105);
	
	var _bpostSelectScss = __webpack_require__(1591);
	
	var _bpostSelectScss2 = _interopRequireDefault(_bpostSelectScss);
	
	var options = _bpostSelectJson2['default'].map(function (_ref) {
	  var zip = _ref.zip;
	  var city = _ref.city;
	
	  var search = city.toLowerCase().split(/[^a-z]+/).join('|');
	  return {
	    value: zip + '_' + city,
	    label: zip + ', ' + city,
	    search: '|' + zip + '|' + search
	  };
	});
	
	var matcher = function matcher(filter) {
	  return function (option) {
	    var l = '|' + filter.toLowerCase().replace(/[^a-z0-9]/, '|');
	    return option.search.includes(l);
	  };
	};
	
	var filterOptions = function filterOptions(options, filter) {
	  return filter ? options.filter(matcher(filter)) : [];
	};
	
	var BpostSelect = function BpostSelect(props) {
	  return _react2['default'].createElement(_componentsSharedSelectSelectWrap.SelectWrapper, _extends({}, props, {
	    isSearchable: true,
	    isClearable: true,
	    onBlur: function () {
	      return props.onBlur();
	    },
	    options: options,
	    filterOptions: filterOptions
	  }));
	};
	
	exports.BpostSelect = BpostSelect;
	var selectInFocusWithin = false;
	
	var customCreatableSelectStyles = {
	  control: function control(base, state) {
	    selectInFocusWithin = state.isFocused;
	    return _extends({}, base, {
	      flex: "4",
	      fontSize: "1em",
	      display: "flex",
	      justifyContent: "flex-end",
	      alignItems: "flex-end",
	      color: "#000",
	      backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
	      borderColor: "#d9d9d9 #ccc #b3b3b3",
	      borderRadius: "2px",
	      border: "1px solid #d9d9d9",
	      minHeight: "25px",
	      maxHeight: "auto",
	      //height: state.isFocused ? "auto" : "25px",
	      boxShadow: state.isFocused ? null : null,
	      "&:hover": {
	        borderColor: "#d9d9d9 #ccc #b3b3b3"
	      },
	      "&:focus": {
	        borderColor: "#d9d9d9 #ccc #b3b3b3"
	      },
	      padding: 0,
	      margin: 0,
	      overflow: state.isFocused ? null : "hidden"
	    });
	  },
	  menu: function menu(base) {
	    return _extends({}, base, {
	      borderRadius: 2,
	      hyphens: "auto",
	      marginTop: 0,
	      textAlign: "left",
	      wordWrap: "break-word"
	    });
	  },
	  menuList: function menuList(base) {
	    return _extends({}, base, {
	      padding: 0,
	      verticalAlign: "baseline"
	    });
	  },
	  singleValue: function singleValue(base, state) {
	    return _extends({}, base, {
	      minHeight: "16px",
	      lineHeight: "14px",
	      color: "black",
	      fontSize: "0.8em"
	    });
	  },
	  /* noOptionsMessage: (base, state) => ({
	    ...base,
	    padding: 0,
	    height: "20px",
	    lineHeight: "16px"
	  }), */
	  option: function option(base, state) {
	    return _extends({}, base, {
	      padding: 0,
	      fontSize: '0.8em',
	      maxHeight: "25px"
	    });
	  },
	  valueContainer: function valueContainer(base, state) {
	    return _extends({}, base, {
	      padding: 0,
	      margin: 0,
	      top: 0
	    });
	  },
	  clearIndicator: function clearIndicator(base, state) {
	    return _extends({}, base, {
	      padding: 0
	    });
	  },
	  dropdownIndicator: function dropdownIndicator(base, state) {
	    return _extends({}, base, {
	      marginTop: 0,
	      padding: 0
	    });
	  },
	  indicatorsContainer: function indicatorsContainer(base, state) {
	    return _extends({}, base, {
	      padding: 0,
	      margin: 0,
	      height: "23px",
	      top: 0
	    });
	  },
	  indicatorSeparator: function indicatorSeparator(base, state) {
	    return _extends({}, base, {
	      padding: 0,
	      margin: 0,
	      height: "0",
	      top: 0
	    });
	  },
	  group: function group(base, state) {
	    return _extends({}, base, {
	      padding: 0,
	      margin: 0,
	      height: "20px",
	      top: 0
	    });
	  },
	  groupHeading: function groupHeading(base, state) {
	    return _extends({}, base, {
	      padding: 0,
	      margin: 0,
	      height: "20px",
	      top: 0
	    });
	  },
	  input: function input(base, state) {
	    return _extends({}, base, {
	      padding: 0,
	      margin: "2px 0 0 0",
	      height: "20px",
	      top: 0,
	      fontSize: '0.8em',
	      lineHeight: '1.1em',
	      width: selectInFocusWithin ? '100%!important' : 'auto',
	      div: {
	        width: selectInFocusWithin ? '100%!important' : 'auto',
	        input: {
	          width: selectInFocusWithin ? '100%!important' : 'auto'
	        }
	      }
	    });
	  },
	  noOptionsMessage: function noOptionsMessage(base, state) {
	    return _extends({}, base, {
	      padding: 0,
	      margin: 0,
	      height: "20px",
	      fontSize: '0.8em'
	    });
	  },
	  placeholder: function placeholder(base, state) {
	    return _extends({}, base, {
	      fontSize: '0.8em',
	      lineHeight: '1.1em'
	    });
	  }
	};
	
	exports.customCreatableSelectStyles = customCreatableSelectStyles;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var DropdownIndicator = function DropdownIndicator(props) {
	  return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	    _reactSelect.components.DropdownIndicator,
	    props,
	    _react2['default'].createElement(
	      'span',
	      { className: _bpostSelectScss2['default'].downArrowHolder },
	      _react2['default'].createElement('span', { className: _bpostSelectScss2['default'].downArrow })
	    )
	  );
	};
	
	exports.DropdownIndicator = DropdownIndicator;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var NoOptionsMessage = function NoOptionsMessage(props) {
	  return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	    _reactSelect.components.NoOptionsMessage,
	    props,
	    _('noOptions')
	  );
	};
	
	exports.NoOptionsMessage = NoOptionsMessage;
	var BpostSelectCreatable = function BpostSelectCreatable(props) {
	  return _react2['default'].createElement(_reactSelectLibCreatable2['default'], _extends({}, props, {
	    placeholder: '',
	    options: options,
	    isClearable: true,
	    isSearchable: true,
	    isMulti: false,
	    onBlur: function () {
	      return props.onBlur();
	    },
	    onBlurResetsInput: false,
	    styles: customCreatableSelectStyles,
	    components: { DropdownIndicator: DropdownIndicator, NoOptionsMessage: NoOptionsMessage },
	    formatCreateLabel: function (value) {
	      return props.createLabel + ' ' + value;
	    },
	    filterOption: (0, _reactSelect.createFilter)({
	      ignoreCase: true,
	      ignoreAccents: true,
	      trim: true
	    }),
	    // matchFrom: 'start',
	    value: props.value && props.value.value,
	    onChange: function (value) {
	      return props.onChangeOther(value);
	    }
	  }));
	};
	
	exports.BpostSelectCreatable = BpostSelectCreatable;
	var BpostInput = function BpostInput(props) {
	  return _react2['default'].createElement('input', _extends({}, props, {
	    type: 'text',
	    className: props.className,
	    onChange: props.onChange
	  }));
	};
	
	exports.BpostInput = BpostInput;
	exports['default'] = BpostSelect;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x11, _x12, _x13) { var _again = true; _function: while (_again) { var object = _x11, property = _x12, receiver = _x13; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x11 = parent; _x12 = property; _x13 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(4);
	
	var _elementsReactSelect2Wrapper = __webpack_require__(374);
	
	var _elementsReactSelect2Wrapper2 = _interopRequireDefault(_elementsReactSelect2Wrapper);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _stateActions = __webpack_require__(5);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _clientContractCreateScss = __webpack_require__(1597);
	
	var _clientContractCreateScss2 = _interopRequireDefault(_clientContractCreateScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _stateConstants = __webpack_require__(11);
	
	var _ = (0, _libI18n2['default'])('clientContractCreate');
	
	var customStylesForModal = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var fieldsForFill = {
	    selectedBroker: '',
	    instigatorValue: '',
	    contractNumber: '',
	    selectedCompany: '',
	    selectedStartDate: '', selectedEndDate: '',
	    selectedDueDate: '',
	    selectedDueDateDay: '',
	    selectedDueDateMonth: '',
	    selectedPeriodicity: '',
	    selectedBranch: '',
	    riskDescription1: '',
	    riskDescription2: '',
	    changeRequest: false,
	    commentChangeRequest: ''
	};
	
	/**
	 * Resetable state hierarchy and values for this module.
	 */
	var resetableState = _extends({
	    allFieldDisabled: true,
	    policyHolder: '',
	    contractId: '',
	    contract: false,
	    waitingModal: false,
	    validationErrors: {},
	    hasError: false
	}, fieldsForFill);
	
	/**
	 * Default state hierarchy and values for this module.
	 */
	var permanentState = {
	    brokerOptions: [],
	    companiesOptions: [],
	    periodicityOptions: [],
	    branchOptions: [],
	    dueDateMonthsOptions: [],
	    dueDateDaysOptions: []
	};
	
	var ClientContractCreate = (function (_React$Component) {
	    _inherits(ClientContractCreate, _React$Component);
	
	    _createClass(ClientContractCreate, null, [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            modalIsOpen: _react2['default'].PropTypes.bool,
	            closeModal: _react2['default'].PropTypes.func,
	            clientId: _react2['default'].PropTypes.string,
	            policyHolder: _react2['default'].PropTypes.string,
	            isPrem: _react2['default'].PropTypes.bool,
	            tarificationNumber: _react2['default'].PropTypes.string
	        },
	
	        /**
	         * Pad start function implemented because of IE11 not support
	         */
	        enumerable: true
	    }]);
	
	    /**
	     * Constructor
	     * @param {*} props
	     */
	
	    function ClientContractCreate(props) {
	        var _this = this;
	
	        _classCallCheck(this, _ClientContractCreate);
	
	        _get(Object.getPrototypeOf(_ClientContractCreate.prototype), 'constructor', this).call(this, props);
	
	        this.padStart = function (str, targetLength, padString) {
	            str = String(str);
	            targetLength = targetLength >> 0; //truncate if number or convert non-number to 0
	            padString = String(typeof padString !== 'undefined' ? padString : ' ');
	            if (str.length > targetLength) {
	                return String(str);
	            } else {
	                targetLength = targetLength - str.length;
	                if (targetLength > padString.length) {
	                    padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
	                }
	                return padString.slice(0, targetLength) + String(str);
	            }
	        };
	
	        this.handleBrokerChange = function (selectedBroker) {
	            var mandate = _this.props.isPrem;
	
	            _this.setFieldTouched('selectedBroker');
	            _this.getDataAfterChange(selectedBroker, mandate);
	        };
	
	        this.performGetDataAfterChange = function callee$2$0(selectedBroker, selectedBrokerNr, mandate) {
	            var _ret;
	
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                var _this3 = this;
	
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        context$3$0.prev = 0;
	                        context$3$0.next = 3;
	                        return regeneratorRuntime.awrap((function callee$3$0() {
	                            var _props, dispatch, tarificationNumber, isOffer;
	
	                            return regeneratorRuntime.async(function callee$3$0$(context$4$0) {
	                                var _this2 = this;
	
	                                while (1) switch (context$4$0.prev = context$4$0.next) {
	                                    case 0:
	                                        _props = this.props;
	                                        dispatch = _props.dispatch;
	                                        tarificationNumber = _props.tarificationNumber;
	                                        isOffer = tarificationNumber ? true : false;
	                                        context$4$0.next = 6;
	                                        return regeneratorRuntime.awrap(this.resetForm());
	
	                                    case 6:
	                                        // reflect the broker change to the state after resetting the form
	                                        this.setState({ selectedBroker: selectedBroker });
	
	                                        // if empty broker selected nothing to do, no api call required for additional data
	
	                                        if (selectedBrokerNr) {
	                                            context$4$0.next = 10;
	                                            break;
	                                        }
	
	                                        // hide field, because no broker selected, to initContract to be called,
	                                        // to decide if necessary to show this field
	                                        this.initializeInstigator("false");
	
	                                        return context$4$0.abrupt('return', {
	                                            v: undefined
	                                        });
	
	                                    case 10:
	                                        context$4$0.next = 12;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.initContract)(selectedBrokerNr)).then(function (result) {
	
	                                            // init companies options for select
	                                            _this2.initializeCompanies(result && result.companies);
	
	                                            // init periodicity options for select
	                                            _this2.initializePeriodicities(result && result.periodicities);
	
	                                            // init periodicity options for select
	                                            _this2.initializeBranch(result && result.branche, mandate, isOffer);
	
	                                            // init instigator field
	                                            _this2.initializeInstigator(result && result.instigator);
	                                        }));
	
	                                    case 12:
	
	                                        this.disableFieldsOnEmptyBroker(selectedBroker && selectedBroker.value);
	
	                                    case 13:
	                                    case 'end':
	                                        return context$4$0.stop();
	                                }
	                            }, null, _this3);
	                        })());
	
	                    case 3:
	                        _ret = context$3$0.sent;
	
	                        if (!(typeof _ret === 'object')) {
	                            context$3$0.next = 6;
	                            break;
	                        }
	
	                        return context$3$0.abrupt('return', _ret.v);
	
	                    case 6:
	                        context$3$0.next = 11;
	                        break;
	
	                    case 8:
	                        context$3$0.prev = 8;
	                        context$3$0.t0 = context$3$0['catch'](0);
	
	                        console.warn(context$3$0.t0);
	
	                    case 11:
	                    case 'end':
	                        return context$3$0.stop();
	                }
	            }, null, _this, [[0, 8]]);
	        };
	
	        var initDatesValues = this.generateDates();
	
	        permanentState.dueDateMonthsOptions = this.getMonthsOptions();
	        permanentState.dueDateDaysOptions = this.getDaysOptions();
	
	        this.state = _extends({}, permanentState, resetableState, {
	            contract: props.contract,
	            policyHolder: props.policyHolder
	        }, initDatesValues);
	    }
	
	    /**
	     * This will give a list for a month selector dropdown
	     */
	
	    _createClass(ClientContractCreate, [{
	        key: 'getMonthsOptions',
	        value: function getMonthsOptions() {
	            var months = [];
	            for (var i = 1; i < 13; i++) {
	                months.push({
	                    value: String(i),
	                    label: this.padStart(String(i), 2, '0')
	                });
	            }
	
	            return months;
	        }
	
	        /**
	         * This will give a list for a month selector dropdown
	         */
	    }, {
	        key: 'getDaysOptions',
	        value: function getDaysOptions() {
	            var monthNumber = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
	
	            var days = [];
	            var daysCount = (0, _moment2['default'])((0, _moment2['default'])().format("YYYY") + "-" + this.padStart(String(monthNumber), 2, '0'), "YYYY-MM").daysInMonth();
	            for (var i = 1; i < daysCount; i++) {
	                days.push({
	                    value: String(i),
	                    label: this.padStart(String(i), 2, '0')
	                });
	            }
	
	            return days;
	        }
	
	        /**
	         * This will initialize the module after mounting.
	         */
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            this.initializeBrokerOptions().then(function (brokerOptions) {
	                // if only one broker has the current office then select the first one
	                if (brokerOptions && brokerOptions.length === 1) {
	                    _this4.handleBrokerChange(brokerOptions[0]);
	                }
	            });
	        }
	
	        /**
	         * This function will reset the variable values in the form fields
	         */
	    }, {
	        key: 'resetForm',
	        value: function resetForm() {
	            var _this5 = this;
	
	            var initDatesValues = this.generateDates();
	
	            return new Promise(function (resolve) {
	                _this5.setState(_extends({}, resetableState, {
	                    policyHolder: _this5.props.policyHolder
	                }, initDatesValues), resolve);
	            });
	        }
	
	        /**
	         *  This function validate the form using state.
	         */
	    }, {
	        key: 'validateForm',
	        value: function validateForm(nextState) {
	            var selectedBroker = nextState.selectedBroker;
	            var selectedPeriodicity = nextState.selectedPeriodicity;
	            var selectedCompany = nextState.selectedCompany;
	            var selectedBranch = nextState.selectedBranch;
	            var contractNumber = nextState.contractNumber;
	            var selectedStartDate = nextState.selectedStartDate;
	            var selectedEndDate = nextState.selectedEndDate;
	            var selectedDueDate = nextState.selectedDueDate;
	            var selectedDueDateDay = nextState.selectedDueDateDay;
	            var selectedDueDateMonth = nextState.selectedDueDateMonth;
	            var riskDescription1 = nextState.riskDescription1;
	            var riskDescription2 = nextState.riskDescription2;
	            var validationErrors = nextState.validationErrors;
	            var instigatorValue = nextState.instigatorValue;
	            var changeRequest = nextState.changeRequest;
	            var commentChangeRequest = nextState.commentChangeRequest;
	            var isPrem = this.props.isPrem;
	
	            var errors = validationErrors && _extends({}, validationErrors) || {};
	            var hasError = false;
	
	            _nestedProperty2['default'].set(errors, 'selectedBroker.message', '');
	            if (!selectedBroker) {
	                _nestedProperty2['default'].set(errors, 'selectedBroker.message', _('missingBroker'));
	                hasError = true;
	            }
	
	            _nestedProperty2['default'].set(errors, 'instigatorValue.message', '');
	            if (isNaN(instigatorValue)) {
	                _nestedProperty2['default'].set(errors, 'instigatorValue.message', _('instigatorValueIsNotANumber'));
	                hasError = true;
	            }
	
	            _nestedProperty2['default'].set(errors, 'selectedPeriodicity.message', '');
	            if (!selectedPeriodicity) {
	                _nestedProperty2['default'].set(errors, 'selectedPeriodicity.message', _('missingPeriodicity'));
	                hasError = true;
	            }
	
	            _nestedProperty2['default'].set(errors, 'selectedCompany.message', '');
	            if (!selectedCompany) {
	                _nestedProperty2['default'].set(errors, 'selectedCompany.message', _('missingCompany'));
	                hasError = true;
	            }
	
	            _nestedProperty2['default'].set(errors, 'selectedBranch.message', '');
	            if (!selectedBranch) {
	                _nestedProperty2['default'].set(errors, 'selectedBranch.message', _('missingBranch'));
	                hasError = true;
	            }
	
	            _nestedProperty2['default'].set(errors, 'contractNumber.message', '');
	
	            _nestedProperty2['default'].set(errors, 'selectedStartDate.message', '');
	            if (!selectedStartDate) {
	                _nestedProperty2['default'].set(errors, 'selectedStartDate.message', _('missingStartDate'));
	                hasError = true;
	            } else {
	                if (!(0, _moment2['default'])(selectedStartDate, "YYYY-MM-DD").isValid()) {
	                    _nestedProperty2['default'].set(errors, 'selectedStartDate.message', _('wrongFormatStartDate'));
	                    hasError = true;
	                } else {
	                    if ((0, _moment2['default'])().diff((0, _moment2['default'])(selectedStartDate, "YYYY-MM-DD"), 'days', true) >= 1) {
	                        _nestedProperty2['default'].set(errors, 'selectedStartDate.message', _('clientContractCreate_createPrevErrorMessage2'));
	                        hasError = true;
	                    }
	                }
	            }
	
	            _nestedProperty2['default'].set(errors, 'selectedEndDate.message', '');
	            if (!selectedEndDate) {
	                _nestedProperty2['default'].set(errors, 'selectedEndDate.message', _('missingEndDate'));
	                hasError = true;
	            } else {
	                if (!(0, _moment2['default'])(selectedEndDate, "YYYY-MM-DD").isValid()) {
	                    _nestedProperty2['default'].set(errors, 'selectedEndDate.message', _('wrongFormatEndDate'));
	                    hasError = true;
	                }
	            }
	
	            //let selectedDueDate = String(selectedDueDateDay).padStart(2, "0") + "-" + String(selectedDueDateMonth).padStart(2, "0")
	
	            _nestedProperty2['default'].set(errors, 'selectedDueDate.message', '');
	            if (!selectedDueDate) {
	                _nestedProperty2['default'].set(errors, 'selectedDueDate.message', _('missingDueDate'));
	                hasError = true;
	            } else {
	                if (!(0, _moment2['default'])(selectedDueDate, "DD-MM").isValid()) {
	                    _nestedProperty2['default'].set(errors, 'selectedDueDate.message', _('wrongFormatDueDate'));
	                    hasError = true;
	                }
	            }
	
	            if (selectedStartDate && selectedEndDate) {
	                var startDate = (0, _moment2['default'])(selectedStartDate, "YYYY-MM-DD");
	                var endDate = (0, _moment2['default'])(selectedEndDate, "YYYY-MM-DD");
	
	                if (startDate.isAfter(endDate)) {
	                    _nestedProperty2['default'].set(errors, 'selectedEndDate.message', _('wrongEndDate'));
	                    hasError = true;
	                }
	
	                /*  if (selectedDueDate) {
	                    let dueDate = moment(selectedDueDate, "YYYY-MM-DD")
	                     if (!dueDate.isSameOrAfter(startDate)) {
	                        nesProp.set(errors, 'selectedDueDate.message', _('wrongDueDate'))
	                        hasError = true
	                    }
	                } */
	            }
	
	            _nestedProperty2['default'].set(errors, 'riskDescription1.message', '');
	            if (riskDescription1 && riskDescription1.trim().length > 50) {
	                _nestedProperty2['default'].set(errors, 'riskDescription1.message', _('tooLongRiskDescription1'));
	                hasError = true;
	            }
	
	            if (!riskDescription1) {
	                _nestedProperty2['default'].set(errors, 'riskDescription1.message', _('requiredRiskDescription1'));
	                hasError = true;
	            }
	
	            _nestedProperty2['default'].set(errors, 'riskDescription2.message', '');
	            if (riskDescription2 && riskDescription2.trim().length > 50) {
	                _nestedProperty2['default'].set(errors, 'riskDescription2.message', _('tooLongRiskDescription2'));
	                hasError = true;
	            }
	
	            // must filled in the risk description 1 before fill the risk description 2
	            if (!riskDescription1 && riskDescription2) {
	                _nestedProperty2['default'].set(errors, 'riskDescription2.message', _('missingRiskDescription1'));
	                hasError = true;
	            }
	
	            if (changeRequest && !commentChangeRequest.trim()) {
	                _nestedProperty2['default'].set(errors, 'commentChangeRequest.message', _('missingChangeRequestComment'));
	                hasError = true;
	            }
	
	            if (isPrem && !contractNumber.trim()) {
	                _nestedProperty2['default'].set(errors, 'contractNumber.message', _('missingContractNumber'));
	                hasError = true;
	            }
	
	            return { errors: errors, hasError: hasError };
	        }
	
	        /**
	         * This function called in every update of module
	         * @param {*} nextProps
	         * @param {*} nextState
	         */
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            var _this6 = this;
	
	            // validate the form and check if update required (fields are changed)
	            var validation = this.validateForm(nextState);
	            var _state = this.state;
	            var validationErrors = _state.validationErrors;
	            var hasError = _state.hasError;
	
	            // check if update required
	            var mustUpdate = validation.hasError !== hasError;
	            mustUpdate = mustUpdate || JSON.stringify(validationErrors) !== JSON.stringify(validation.errors);
	
	            // update errors in state if necessary
	            if (mustUpdate) {
	                this.setState({ validationErrors: validation.errors, hasError: validation.hasError }, function () {
	                    _this6.forceUpdate();
	                });
	            }
	        }
	
	        /**
	         * Generate the new default values for dates
	         * @param {string} predefinedStartDate
	         */
	    }, {
	        key: 'generateDates',
	        value: function generateDates() {
	            var predefinedStartDate = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	            var startDate = predefinedStartDate ? (0, _moment2['default'])(predefinedStartDate, "YYYY-MM-DD").format("YYYY-MM-DD") : (0, _moment2['default'])(new Date()).format("YYYY-MM-DD");
	
	            var endDate = (0, _moment2['default'])(startDate, "YYYY-MM-DD").add(1, 'years').subtract(1, 'days').format("YYYY-MM-DD");
	            var dueDate = (0, _moment2['default'])(startDate, "YYYY-MM-DD").format("DD-MM");
	
	            return {
	                selectedStartDate: startDate,
	                selectedEndDate: endDate,
	                selectedDueDate: dueDate
	            };
	        }
	
	        /**
	        * This function will set state for the broker selector input.
	        * Insert the list of broker like an array contains plain JS objects (label, value).
	        */
	    }, {
	        key: 'initializeBrokerOptions',
	        value: function initializeBrokerOptions() {
	            var _this7 = this;
	
	            var brokers = this.props.brokers;
	
	            var brokerObjKeys = brokers && Object.keys(brokers) || [];
	            var brokerOptions = brokers && Object.keys(brokers).map(function (brokerKey) {
	                return {
	                    value: brokers[brokerKey].brokerNumber,
	                    label: brokers[brokerKey].brokerNumber + " - " + brokers[brokerKey].main.name
	                };
	            });
	
	            return new Promise(function (resolve, reject) {
	                _this7.setState({ brokerOptions: brokerOptions }, function () {
	                    resolve(brokerOptions);
	                });
	            });
	        }
	
	        /**
	         *  This function initialize the options for the select input in form for companies.
	         * @param {array} companiesResult - contains the result of initContract from oracle.
	         */
	    }, {
	        key: 'initializeCompanies',
	        value: function initializeCompanies(companiesResult) {
	            var companiesOptions = [];
	
	            if (companiesResult) {
	                companiesResult.forEach(function (element) {
	                    companiesOptions.push({
	                        value: element.companyId,
	                        label: element.companyNumber + " " + element.companyName,
	                        sortIndex: element.companyNumber
	                    });
	                });
	            }
	
	            if (companiesOptions && companiesOptions.length > 0) {
	                companiesOptions = companiesOptions.sort(function (companyA, companyB) {
	                    if (Number(companyA.sortIndex) < Number(companyB.sortIndex)) {
	                        return -1;
	                    }
	                    if (!Number(companyA.sortIndex) > Number(companyB.sortIndex)) {
	                        return 1;
	                    }
	                    if (Number(companyA.sortIndex) === Number(companyB.sortIndex)) {
	                        return 0;
	                    }
	                });
	            }
	
	            this.setState({ companiesOptions: companiesOptions });
	        }
	
	        /**
	         *  This function initialize the options for the select input in form for companies.
	         * @param {array} periodicityResult - come the result of initContract from oracle.
	         */
	    }, {
	        key: 'initializePeriodicities',
	        value: function initializePeriodicities(periodicityResult) {
	            var _this8 = this;
	
	            var periodicityOptions = [];
	
	            if (periodicityResult) {
	                periodicityResult.forEach(function (element) {
	                    periodicityOptions.push({
	                        value: element.periodicityValue,
	                        label: element.periodicityMeaning
	                    });
	
	                    var isDefault = String(element.periodicityDefault).toLowerCase().trim() === "true" ? true : String(element.periodicityDefault).toLowerCase().trim() === "false" ? false : true;
	
	                    // set selected the default
	                    if (isDefault) {
	                        _this8.handlePeriodicityChange({
	                            value: element.periodicityValue,
	                            label: element.periodicityMeaning
	                        });
	                    }
	                });
	            }
	
	            this.setState({ periodicityOptions: periodicityOptions });
	        }
	
	        /**
	         *  This function initialize the options for the select input in form for branches.
	         * @param {array} branchResult - come the result of initContract from oracle.
	         */
	    }, {
	        key: 'initializeBranch',
	        value: function initializeBranch(branchResult, mandate, isOffer) {
	            var _this9 = this;
	
	            var branchOptions = [];
	            if (branchResult) {
	                branchResult.forEach(function (element) {
	                    var elemMandate = element.mandate && element.mandate === 'true' ? true : false;
	                    var elemFromOffer = element.fromOffer && element.fromOffer === 'true' ? true : false;
	
	                    if (!mandate && !isOffer && !elemFromOffer && !elemMandate) {
	                        branchOptions.push(_this9.createBrachOption(element));
	                    }
	
	                    if (mandate && elemMandate) {
	                        branchOptions.push(_this9.createBrachOption(element));
	                    }
	
	                    if (elemFromOffer && isOffer) {
	                        branchOptions.push(_this9.createBrachOption(element));
	                    }
	                });
	            }
	
	            if (branchOptions && branchOptions.length > 0) {
	                branchOptions = branchOptions.sort(function (branchA, branchB) {
	                    if (Number(branchA.sortIndex) < Number(branchB.sortIndex)) {
	                        return -1;
	                    }
	                    if (!Number(branchA.sortIndex) > Number(branchB.sortIndex)) {
	                        return 1;
	                    }
	                    if (Number(branchA.sortIndex) === Number(branchB.sortIndex)) {
	                        return 0;
	                    }
	                });
	            }
	
	            this.setState({ branchOptions: branchOptions });
	        }
	
	        /**
	         * Create branch element for select list
	         * 
	         * @param {*} element 
	         * @returns 
	         */
	    }, {
	        key: 'createBrachOption',
	        value: function createBrachOption(element) {
	            return {
	                value: element.branche,
	                sortIndex: element.branche,
	                label: element.branche + " " + element.brancheDescription,
	                risk1: element.risk1,
	                risk2: element.risk2
	            };
	        }
	
	        /**
	         *  This function initialize the instigator input visibility.
	         * @param {array} instigator - come the result of initContract from oracle.
	         */
	    }, {
	        key: 'initializeInstigator',
	        value: function initializeInstigator(instigator) {
	            var boolInstigator = instigator && (instigator === "true" || instigator === true) ? true : false;
	            this.setState({ instigator: boolInstigator });
	        }
	
	        /**
	         * Handle mobile touch
	         * @param {*} field
	         */
	    }, {
	        key: 'touch',
	        value: function touch(field) {
	            field.onBlur();
	        }
	
	        /**
	         * This function will disable all fields depending on broker number
	         */
	    }, {
	        key: 'disableFieldsOnEmptyBroker',
	        value: function disableFieldsOnEmptyBroker(selectedBrokerNumber) {
	            this.setState({ allFieldDisabled: !Boolean(selectedBrokerNumber) });
	        }
	
	        /**
	         * This function set a field touched
	         * @param {string} fieldName - a state property name of this module what contains an input value
	         */
	    }, {
	        key: 'setFieldTouched',
	        value: function setFieldTouched(fieldName) {
	            var validationErrors = this.state.validationErrors;
	
	            if (typeof fieldName == 'string') {
	                _nestedProperty2['default'].set(validationErrors, fieldName + '.touched', true);
	            } else {
	                Object.keys(fieldName).forEach(function (oneFieldName) {
	                    _nestedProperty2['default'].set(validationErrors, oneFieldName + '.touched', true);
	                });
	            }
	
	            this.setState({ validationErrors: validationErrors }, function () {
	                // debug place
	            });
	        }
	    }, {
	        key: 'getDataAfterChange',
	
	        //should remove madate change handler this will never change
	        value: function getDataAfterChange(selectedBroker, mandate) {
	            var _this10 = this;
	
	            try {
	                var _ret2 = (function () {
	                    var selectedBrokerNr = selectedBroker && selectedBroker.value || '';
	
	                    var oldBroker = _nestedProperty2['default'].get(_this10.state, "selectedBroker.value");
	                    var oldMandate = _nestedProperty2['default'].get(_this10.state, "mandate");
	
	                    // no change do nothing
	                    if (selectedBrokerNr === oldBroker && mandate === oldMandate) {
	                        return {
	                            v: undefined
	                        };
	                    }
	
	                    // if user changes a preexisting value, a confirmation popup is required
	                    if (selectedBrokerNr && oldBroker) {
	                        _this10.switchWaitingModal(true, _("areYouSureToClearForm"), _("clearForm"), function () {
	                            var shouldContinue = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	                            if (shouldContinue) {
	                                _this10.performGetDataAfterChange(selectedBroker, selectedBrokerNr, mandate);
	                            }
	                            _this10.switchWaitingModal(false);
	                            return;
	                        });
	                    } else if (selectedBrokerNr && !oldBroker) {
	                        _this10.performGetDataAfterChange(selectedBroker, selectedBrokerNr, mandate);
	                    }
	                })();
	
	                if (typeof _ret2 === 'object') return _ret2.v;
	            } catch (error) {
	                console.warn(error);
	            }
	        }
	
	        /**
	         * This function fetches information and sets form fields data when the broker selection is changes
	         * @param {*} selectedBroker
	         * @param {*} selectedBrokerNr
	         * @param {*} mandate
	         * @returns  void
	         */
	    }, {
	        key: 'handleCompanyChange',
	
	        /**
	         * This function handle the onChange of the company select input.
	         * @param {object} selectedCompany - select input value to set in state for handle form.
	         */
	        value: function handleCompanyChange(selectedCompany) {
	            this.setFieldTouched('selectedCompany');
	            this.setState({ selectedCompany: selectedCompany });
	        }
	
	        /**
	         * This function handle the onChange of the periodicity select input.
	         * @param {object} selectedPeriodicity - select input value to set in state for handle form.
	         */
	    }, {
	        key: 'handlePeriodicityChange',
	        value: function handlePeriodicityChange(selectedPeriodicity) {
	            this.setFieldTouched('selectedPeriodicity');
	            this.setState({ selectedPeriodicity: selectedPeriodicity });
	        }
	
	        /**
	         * This function handle the onChange of the branch select input.
	         * @param {object} selectedBranch - select input value to set in state for handle form.
	         */
	    }, {
	        key: 'handleBranchChange',
	        value: function handleBranchChange(selectedBranch) {
	            this.setFieldTouched('selectedBranch');
	            this.setState({ selectedBranch: selectedBranch });
	        }
	
	        /**
	         * This function handle the input change of due date month.
	         * @param {*} selectedDueDateMonth
	         */
	        /* handleDueDateMonthChange(selectedDueDateMonth) {
	            this.setFieldTouched('selectedDueDateMonth')
	            this.setFieldTouched('selectedDueDate')
	             let selectedDueDateDay = this.state.selectedDueDateDay
	             this.setState({ selectedDueDate: String(selectedDueDateDay).padStart(2, "0") + "-" + String(selectedDueDateMonth).padStart(2, "0") })
	            this.setState({ selectedDueDateMonth })
	        } */
	
	        /**
	         * This function handle the input change of due date say.
	         * @param {*} selectedDueDateDay
	         */
	        /* handleDueDateDayChange(selectedDueDateDay) {
	            this.setFieldTouched('selectedDueDateDay')
	            this.setFieldTouched('selectedDueDate')
	             let selectedDueDateMonth = this.state.selectedDueDateMonth
	             this.setState({ selectedDueDate: String(selectedDueDateDay).padStart(2, "0") + "-" + String(selectedDueDateMonth).padStart(2, "0") })
	            this.setState({ selectedDueDateDay })
	        } */
	
	        /**
	         * This function
	         * @param {*} isConfirmed
	         */
	    }, {
	        key: 'handleCloseModel',
	        value: function handleCloseModel(isConfirmed) {
	            var _props2, closeModal, dispatch, clientId, tarificationNumber, isPrev, createContractParams, error, errorCode;
	
	            return regeneratorRuntime.async(function handleCloseModel$(context$2$0) {
	                var _this12 = this;
	
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        closeModal = _props2.closeModal;
	                        dispatch = _props2.dispatch;
	                        clientId = _props2.clientId;
	                        tarificationNumber = _props2.tarificationNumber;
	                        isPrev = _nestedProperty2['default'].get(this.props, "isPrem") ? false : true;
	
	                        if (isConfirmed) {
	                            context$2$0.next = 9;
	                            break;
	                        }
	
	                        this.setState(resetableState);
	                        return context$2$0.abrupt('return', closeModal());
	
	                    case 9:
	                        createContractParams = {};
	
	                        //get the mandate from props and will have to handle the 2 new fields for Prem
	                        createContractParams.mandate = _nestedProperty2['default'].get(this.props, "isPrem");
	                        createContractParams.mandateNumber = _nestedProperty2['default'].get(this.state, "contractNumber");
	                        createContractParams.instigatorValue = _nestedProperty2['default'].get(this.state, "instigatorValue");
	                        createContractParams.clientId = clientId;
	                        createContractParams.brokerNumber = _nestedProperty2['default'].get(this.state, "selectedBroker.value");
	                        createContractParams.companyId = _nestedProperty2['default'].get(this.state, "selectedCompany.value");
	                        createContractParams.contractStartDate = _nestedProperty2['default'].get(this.state, "selectedStartDate");
	                        createContractParams.contractEndDate = _nestedProperty2['default'].get(this.state, "selectedEndDate");
	                        createContractParams.dueDate = _nestedProperty2['default'].get(this.state, "selectedDueDate");
	                        createContractParams.periodityValue = _nestedProperty2['default'].get(this.state, "selectedPeriodicity.value");
	                        createContractParams.branch = _nestedProperty2['default'].get(this.state, "selectedBranch.value");
	                        createContractParams.riskValue1 = _nestedProperty2['default'].get(this.state, "riskDescription1").trim();
	                        createContractParams.riskValue2 = _nestedProperty2['default'].get(this.state, "riskDescription2").trim();
	                        createContractParams.changeRequest = _nestedProperty2['default'].get(this.state, "changeRequest") ? '1' : '0';
	                        createContractParams.commentChangeRequest = _nestedProperty2['default'].get(this.state, "commentChangeRequest").trim();
	                        if (tarificationNumber) {
	                            createContractParams.tarificationNumber = tarificationNumber;
	                        }
	
	                        context$2$0.prev = 26;
	                        context$2$0.next = 29;
	                        return regeneratorRuntime.awrap((function callee$2$0() {
	                            var result, error;
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                var _this11 = this;
	
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        context$3$0.next = 2;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.createContract)(createContractParams)));
	
	                                    case 2:
	                                        result = context$3$0.sent;
	                                        error = _nestedProperty2['default'].get(result, "error");
	
	                                        if (!(error && String(error) !== '0' && String(error) !== '')) {
	                                            context$3$0.next = 6;
	                                            break;
	                                        }
	
	                                        throw error;
	
	                                    case 6:
	
	                                        //determine what kind of contract has been saved (PREM or PREV)
	
	                                        //Show the modal with the success messages
	                                        this.switchWaitingModal(true, isPrev ? _("createPrevSuccessMessage") : _("createPremSuccessMessage"), isPrev ? _("createPrevSuccessTitle") : _("createPremSuccessTitle"), function () {
	                                            var shouldContinue = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	                                            _this11.switchWaitingModal(false);
	                                            var contractNumber = _nestedProperty2['default'].get(result, "contractNumber");
	                                            var contractId = _nestedProperty2['default'].get(result, "contractId");
	
	                                            _this11.setState({ contractId: contractId });
	                                            _this11.setState({ contractNumber: contractNumber });
	                                            _this11.setState({ mandate: true });
	
	                                            dispatch((0, _stateActions.fetchClient)(clientId)).then(function () {
	                                                dispatch((0, _stateActions.setClientSubModule)('contracts', { contractNumber: contractNumber }, isPrev ? _stateConstants.CONTRACT_PRE_PROPOSAL : _stateConstants.CONTRACT_PRE_MANDATE));
	                                            });
	
	                                            _this11.handleCloseModel(false);
	                                        });
	
	                                    case 7:
	                                    case 'end':
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this12);
	                        })());
	
	                    case 29:
	                        context$2$0.next = 37;
	                        break;
	
	                    case 31:
	                        context$2$0.prev = 31;
	                        context$2$0.t0 = context$2$0['catch'](26);
	                        error = _nestedProperty2['default'].get(context$2$0.t0, "error");
	                        errorCode = Number(error);
	
	                        // if error code not in the list then that is not recognized by the system and set
	                        // to the unknown error
	                        if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].indexOf(errorCode) == -1) {
	                            errorCode = 3;
	                        }
	
	                        // show notification modal about error
	                        this.switchWaitingModal(true, _("createPrevErrorMessage" + errorCode), _("createPremErrorTitle"), function () {
	                            var shouldContinue = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	                            _this12.switchWaitingModal(false);
	                        });
	
	                    case 37:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[26, 31]]);
	        }
	
	        /**
	         * This function handle the waiting modal
	         * @param {bool} show - modal show or hide
	         * @param {string} text - modal content
	         * @param {string} title - modal title
	         * @param {function} waitingModalOkButtonCallback is empty the no button shown, else ok button call
	         */
	    }, {
	        key: 'switchWaitingModal',
	        value: function switchWaitingModal() {
	            var show = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	            var text = arguments.length <= 1 || arguments[1] === undefined ? "" : arguments[1];
	            var title = arguments.length <= 2 || arguments[2] === undefined ? "" : arguments[2];
	            var waitingModalOkButtonCallback = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	            var waitingModalOkButtonLink = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
	            this.setState({
	                waitingModal: show,
	                waitingModalText: text,
	                waitingModalTitle: title,
	                waitingModalOkButtonCallback: waitingModalOkButtonCallback,
	                waitingModalOkButtonLink: waitingModalOkButtonLink
	            });
	        }
	
	        /**
	         *  This function render the waiting modal content until the zipped documents prepare.
	         */
	    }, {
	        key: 'waitingPopup',
	        value: function waitingPopup() {
	            var _state2 = this.state;
	            var waitingModalText = _state2.waitingModalText;
	            var waitingModalTitle = _state2.waitingModalTitle;
	            var waitingModalOkButtonCallback = _state2.waitingModalOkButtonCallback;
	            var waitingModal = _state2.waitingModal;
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: waitingModal,
	                    style: customStylesForModal,
	                    className: _clientContractCreateScss2['default'].modal,
	                    key: "archiveConfirmPopupKey",
	                    contentLabel: ""
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientContractCreateScss2['default'].title },
	                    waitingModalTitle
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientContractCreateScss2['default'].contentWrapper },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractCreateScss2['default'].content, key: "formContainerKey" },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientContractCreateScss2['default'].whitespacePre },
	                            waitingModalText
	                        ),
	                        waitingModalOkButtonCallback && typeof waitingModalOkButtonCallback == 'function' && _react2['default'].createElement(
	                            'div',
	                            { className: _clientContractCreateScss2['default'].buttons, key: "closeModalKey" },
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        return waitingModalOkButtonCallback(false);
	                                    },
	                                    className: _clientContractCreateScss2['default'].cancel
	                                },
	                                _("cancel")
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    className: (0, _classnames2['default'])(_clientContractCreateScss2['default'].next, _clientContractCreateScss2['default'].enabled),
	                                    onClick: function () {
	                                        return waitingModalOkButtonCallback(true);
	                                    }
	                                },
	                                _('ok')
	                            )
	                        )
	                    )
	                )
	            );
	        }
	
	        /**
	         * This function handle the start date change. Update the due date if necessary.
	         */
	    }, {
	        key: 'handleChangeStartDate',
	        value: function handleChangeStartDate(value) {
	            var selectedDueDate = this.state.selectedDueDate;
	
	            var forceDuedate = selectedDueDate;
	            this.setFieldTouched('selectedStartDate');
	            var dueDateMoment = (0, _moment2['default'])(selectedDueDate, "DD-MM");
	            var startDateMoment = (0, _moment2['default'])(value, "YYYY-MM-DD");
	
	            // change the dueDate if: no valid due date
	            // && dueDateMoment.isBefore( startDateMoment )
	
	            if (!dueDateMoment.isValid() || startDateMoment.isValid()) {
	                var setThisValueForDueDate = startDateMoment && startDateMoment.format("DD-MM");
	                this.setState({ selectedDueDate: setThisValueForDueDate });
	            }
	
	            // when start date set, then automatically set the end date also like the due date
	            if (startDateMoment.isValid()) {
	                var generateDates = this.generateDates(startDateMoment.format("YYYY-MM-DD"));
	                var newSelectedEndDate = generateDates.selectedEndDate;
	                this.setState({ selectedEndDate: newSelectedEndDate });
	            }
	
	            this.setState({ selectedStartDate: value });
	        }
	
	        /**
	         * Main render method
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this13 = this;
	
	            var _props3 = this.props;
	            var modalIsOpen = _props3.modalIsOpen;
	            var closeModal = _props3.closeModal;
	            var isPrem = _props3.isPrem;
	            var canCreateMifid = _props3.canCreateMifid;
	            var clientId = _props3.clientId;
	            var _state3 = this.state;
	            var allFieldDisabled = _state3.allFieldDisabled;
	            var brokerOptions = _state3.brokerOptions;
	            var selectedBroker = _state3.selectedBroker;
	            var periodicityOptions = _state3.periodicityOptions;
	            var selectedPeriodicity = _state3.selectedPeriodicity;
	            var companiesOptions = _state3.companiesOptions;
	            var selectedCompany = _state3.selectedCompany;
	            var branchOptions = _state3.branchOptions;
	            var selectedBranch = _state3.selectedBranch;
	            var policyHolder = _state3.policyHolder;
	            var contractNumber = _state3.contractNumber;
	            var selectedStartDate = _state3.selectedStartDate;
	            var selectedEndDate = _state3.selectedEndDate;
	            var selectedDueDate = _state3.selectedDueDate;
	            var riskDescription1 = _state3.riskDescription1;
	            var riskDescription2 = _state3.riskDescription2;
	            var validationErrors = _state3.validationErrors;
	            var hasError = _state3.hasError;
	            var dueDateMonthsOptions = _state3.dueDateMonthsOptions;
	            var dueDateDaysOptions = _state3.dueDateDaysOptions;
	            var selectedDueDateDay = _state3.selectedDueDateDay;
	            var selectedDueDateMonth = _state3.selectedDueDateMonth;
	            var instigator = _state3.instigator;
	            var instigatorValue = _state3.instigatorValue;
	            var contractId = _state3.contractId;
	            var changeRequest = _state3.changeRequest;
	            var commentChangeRequest = _state3.commentChangeRequest;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: closeModal,
	                        style: customStylesForModal,
	                        className: _clientContractCreateScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    isPrem ? _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractCreateScss2['default'].title },
	                        _("createMandateModalTitle")
	                    ) : _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractCreateScss2['default'].title },
	                        _("createContractModalTitle")
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractCreateScss2['default'].contentWrapper, key: "contentWrapperKey" },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientContractCreateScss2['default'].content, key: "formContainerKey" },
	                            _react2['default'].createElement(
	                                'form',
	                                { method: 'post', className: _clientContractCreateScss2['default'].form },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "brokerNumberKey" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientContractCreateScss2['default'].inputLabel },
	                                        _("brokerNumber")
	                                    ),
	                                    _react2['default'].createElement(_elementsReactSelect2Wrapper2['default'], {
	                                        value: selectedBroker,
	                                        onChange: function (value) {
	                                            return _this13.handleBrokerChange(value);
	                                        },
	                                        options: brokerOptions,
	                                        // openMenuOnFocus={true} - removed this line as it causes the select dropdown to appear after confirmation modal
	                                        placeholder: '',
	                                        onBlurResetsInput: false,
	                                        isSearchable: true,
	                                        isClearable: true
	                                    })
	                                ),
	                                _nestedProperty2['default'].get(validationErrors, "selectedBroker.message") && _nestedProperty2['default'].get(validationErrors, "selectedBroker.touched") && _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "brokerNumberErrorKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].inputRowError },
	                                        validationErrors.selectedBroker.message
	                                    )
	                                ),
	                                instigator && _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "instigatorKey" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientContractCreateScss2['default'].inputLabel },
	                                        _("applicantNumber")
	                                    ),
	                                    _react2['default'].createElement('input', { type: 'text',
	                                        className: _clientContractCreateScss2['default'].instigatorInput,
	                                        disabled: allFieldDisabled,
	                                        value: instigatorValue,
	                                        onChange: function (value) {
	                                            _this13.setFieldTouched('instigatorValue');
	                                            _this13.setState({ instigatorValue: value && value.target.value || "" });
	                                        }
	                                    })
	                                ),
	                                _nestedProperty2['default'].get(validationErrors, "instigatorValue.message") && _nestedProperty2['default'].get(validationErrors, "instigatorValue.touched") && _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "instigatorValueErrorKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].inputRowError },
	                                        validationErrors.instigatorValue.message
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "policyHolderKey" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientContractCreateScss2['default'].inputLabel },
	                                        _("policyHolder")
	                                    ),
	                                    _react2['default'].createElement('input', {
	                                        type: 'text',
	                                        className: _clientContractCreateScss2['default'].contractInput,
	                                        value: policyHolder,
	                                        disabled: true
	                                    })
	                                ),
	                                isPrem ? _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "contractNumberKey" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientContractCreateScss2['default'].inputLabel },
	                                        _("contractNumber")
	                                    ),
	                                    _react2['default'].createElement('input', { type: 'text',
	                                        className: _clientContractCreateScss2['default'].contractInput,
	                                        disabled: allFieldDisabled,
	                                        value: contractNumber,
	                                        onChange: function (value) {
	                                            _this13.setFieldTouched('contractNumber');
	                                            _this13.setState({ contractNumber: value && value.target.value || "" });
	                                        }
	                                    })
	                                ) : null,
	                                isPrem ? _nestedProperty2['default'].get(validationErrors, "contractNumber.message") && _nestedProperty2['default'].get(validationErrors, "contractNumber.touched") && _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "contractNumberErrorKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].inputRowError },
	                                        validationErrors.contractNumber.message
	                                    )
	                                ) : null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "companyKey" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientContractCreateScss2['default'].inputLabel },
	                                        _("company")
	                                    ),
	                                    _react2['default'].createElement(_elementsReactSelect2Wrapper2['default'], {
	                                        options: companiesOptions,
	                                        value: selectedCompany,
	                                        onChange: function (value) {
	                                            return _this13.handleCompanyChange(value);
	                                        },
	                                        isSearchable: true,
	                                        isClearable: true,
	                                        placeholder: '',
	                                        isDisabled: allFieldDisabled,
	                                        className: (0, _classnames2['default'])("identificationForCompanySelector"),
	                                        onBlur: function (e) {
	                                            // this is a fix for an issue of IE11, to disable dropdown autoclose
	                                            // when scroll by clicking with cursor on scrollbar
	                                            var focusedElement = document.activeElement;
	                                            var parentClassName = _nestedProperty2['default'].get(focusedElement, "parentElement.parentElement.parentElement.className");
	                                            var isItSelf = String(parentClassName).includes("identificationForCompanySelector");
	
	                                            if (isItSelf) {
	
	                                                e.cancelBubbling = true;
	
	                                                e.stopPropagation();
	                                                //e.stopImmediatePropagation()
	                                                e.preventDefault();
	
	                                                e.nativeEvent.cancelBubbling = true;
	
	                                                e.nativeEvent.stopPropagation();
	                                                e.nativeEvent.stopImmediatePropagation();
	                                                e.nativeEvent.preventDefault();
	                                                throw null;
	
	                                                return false;
	                                            }
	                                        }
	                                    })
	                                ),
	                                _nestedProperty2['default'].get(validationErrors, "selectedCompany.message") && _nestedProperty2['default'].get(validationErrors, "selectedCompany.touched") && _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "companyErrorKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].inputRowError },
	                                        validationErrors.selectedCompany.message
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "startDateEndDateKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].column, key: "startDateKey" },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                { className: _clientContractCreateScss2['default'].pickerLabel },
	                                                _("startDate")
	                                            ),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: _clientContractCreateScss2['default'].contractDateInputContainer },
	                                                _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, {
	                                                    className: allFieldDisabled ? _clientContractCreateScss2['default'].contractDateInputDisabled : _clientContractCreateScss2['default'].contractDateInput,
	                                                    disabled: allFieldDisabled,
	                                                    onChange: function (value) {
	                                                        _this13.handleChangeStartDate(value);
	                                                    },
	                                                    minDate: (0, _moment2['default'])().format(),
	                                                    startDate: selectedStartDate,
	                                                    endDate: selectedEndDate,
	                                                    value: selectedStartDate || (0, _moment2['default'])().format(),
	                                                    dateError: function () {},
	                                                    onBlur: function (value) {
	                                                        var strValue = (0, _moment2['default'])(value).format("YYYY-MM-DD");
	                                                        _this13.handleChangeStartDate(strValue);
	                                                    }
	                                                })
	                                            )
	                                        ),
	                                        _nestedProperty2['default'].get(validationErrors, "selectedStartDate.message") && _nestedProperty2['default'].get(validationErrors, "selectedStartDate.touched") && _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow, key: "startDateEndDateErrorKey" },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _clientContractCreateScss2['default'].inputRowError },
	                                                validationErrors.selectedStartDate.message
	                                            )
	                                        )
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].column, key: "endDateKey" },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                { className: _clientContractCreateScss2['default'].pickerLabel },
	                                                _("endDate")
	                                            ),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: _clientContractCreateScss2['default'].contractDateInputContainer },
	                                                _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, {
	                                                    className: _clientContractCreateScss2['default'].contractDateInput,
	                                                    disabled: allFieldDisabled,
	                                                    onChange: function (value) {
	                                                        _this13.setFieldTouched('selectedEndDate');
	                                                        _this13.setState({ selectedEndDate: value });
	                                                    },
	                                                    minDate: (0, _moment2['default'])().format(),
	                                                    startDate: selectedStartDate,
	                                                    endDate: selectedEndDate,
	                                                    value: selectedEndDate,
	                                                    dateError: function () {}
	                                                })
	                                            )
	                                        ),
	                                        _nestedProperty2['default'].get(validationErrors, "selectedEndDate.message") && _nestedProperty2['default'].get(validationErrors, "selectedEndDate.touched") && _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow, key: "startDateEndDateError2Key" },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _clientContractCreateScss2['default'].inputRowError },
	                                                validationErrors.selectedEndDate.message
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "dueDateKey2" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientContractCreateScss2['default'].dueDateLabel },
	                                        _("dueDate")
	                                    ),
	                                    _react2['default'].createElement(
	                                        'span',
	                                        { className: _clientContractCreateScss2['default'].contractDateInputContainerLong },
	                                        _react2['default'].createElement('input', {
	                                            type: 'text',
	                                            className: _clientContractCreateScss2['default'].contractInput,
	                                            disabled: allFieldDisabled,
	                                            value: selectedDueDate,
	                                            maxLength: '5',
	                                            onChange: function (value) {
	                                                _this13.setFieldTouched('selectedDueDate');
	                                                _this13.setState({ selectedDueDate: value.target.value });
	                                            },
	                                            onBlur: function () {
	                                                var momentDueDate = (0, _moment2['default'])(selectedDueDate, "DD-MM");
	                                                var momentStartDate = (0, _moment2['default'])(selectedStartDate, "YYYY-MM-DD");
	
	                                                if (momentDueDate.isValid()) {
	                                                    _this13.setState({ selectedDueDate: momentDueDate.format("DD-MM") });
	                                                } else {
	                                                    if (momentStartDate.isValid()) {
	                                                        _this13.setState({ selectedDueDate: momentStartDate.format("DD-MM") });
	                                                    }
	                                                }
	                                            }
	                                        })
	                                    )
	                                ),
	                                _nestedProperty2['default'].get(validationErrors, "selectedDueDate.message") && _nestedProperty2['default'].get(validationErrors, "selectedDueDate.touched") && _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "dueDateErrorKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].inputRowError },
	                                        validationErrors.selectedDueDate.message
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "periodicityKey" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientContractCreateScss2['default'].inputLabel },
	                                        _("periodicity")
	                                    ),
	                                    _react2['default'].createElement(_elementsReactSelect2Wrapper2['default'], {
	                                        options: periodicityOptions,
	                                        value: selectedPeriodicity,
	                                        onChange: function (value) {
	                                            return _this13.handlePeriodicityChange(value);
	                                        },
	                                        isSearchable: true,
	                                        isClearable: true,
	                                        placeholder: '',
	                                        isDisabled: allFieldDisabled
	                                    })
	                                ),
	                                _nestedProperty2['default'].get(validationErrors, "selectedPeriodicity.message") && _nestedProperty2['default'].get(validationErrors, "selectedPeriodicity.touched") && _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "periodicityErrorKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].inputRowError },
	                                        validationErrors.selectedPeriodicity.message
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "branchKey" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientContractCreateScss2['default'].inputLabel },
	                                        _("branch")
	                                    ),
	                                    _react2['default'].createElement(_elementsReactSelect2Wrapper2['default'], {
	                                        options: branchOptions,
	                                        value: selectedBranch,
	                                        onChange: function (value) {
	                                            return _this13.handleBranchChange(value);
	                                        },
	                                        isSearchable: true,
	                                        isClearable: true,
	                                        placeholder: '',
	                                        isDisabled: allFieldDisabled
	                                    })
	                                ),
	                                _nestedProperty2['default'].get(validationErrors, "selectedBranch.message") && _nestedProperty2['default'].get(validationErrors, "selectedBranch.touched") && _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "branchErrorKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].inputRowError },
	                                        validationErrors.selectedBranch.message
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "riskDescriptionContainerKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: (0, _classnames2['default'])(_clientContractCreateScss2['default'].labelColumn, _clientContractCreateScss2['default'].riskDescriptionsLabel), key: "risk1Key" },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow, key: "riskDescriptionKey" },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                { className: _clientContractCreateScss2['default'].inputLabel },
	                                                _("riskDescription")
	                                            )
	                                        )
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].labelColumn, key: "risk2Key" },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow, key: "riskInputKey" },
	                                            _react2['default'].createElement('input', {
	                                                type: 'text',
	                                                className: _clientContractCreateScss2['default'].contractInput,
	                                                disabled: allFieldDisabled,
	                                                value: riskDescription1,
	                                                onChange: function (value) {
	                                                    _this13.setFieldTouched('riskDescription1');
	                                                    _this13.setState({ riskDescription1: value && value.target.value || "" });
	                                                },
	                                                placeholder: selectedBranch && selectedBranch.risk1 || ''
	                                            })
	                                        ),
	                                        _nestedProperty2['default'].get(validationErrors, "riskDescription1.message") && _nestedProperty2['default'].get(validationErrors, "riskDescription1.touched") && _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow, key: "riskInputErrorKey" },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _clientContractCreateScss2['default'].inputRowError },
	                                                validationErrors.riskDescription1.message
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow, key: "risk2Key" },
	                                            _react2['default'].createElement('input', {
	                                                type: 'text',
	                                                className: _clientContractCreateScss2['default'].contractInput,
	                                                disabled: allFieldDisabled || !riskDescription1,
	                                                value: riskDescription2,
	                                                onChange: function (value) {
	                                                    _this13.setFieldTouched('riskDescription2');
	                                                    _this13.setState({ riskDescription2: value && value.target.value || "" });
	                                                },
	                                                placeholder: selectedBranch && selectedBranch.risk2 || ''
	                                            })
	                                        ),
	                                        _nestedProperty2['default'].get(validationErrors, "riskDescription2.message") && _nestedProperty2['default'].get(validationErrors, "riskDescription2.touched") && _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow, key: "risk2InputErrorKey" },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _clientContractCreateScss2['default'].inputRowError },
	                                                validationErrors.riskDescription2.message
	                                            )
	                                        )
	                                    )
	                                ),
	                                isPrem ? _react2['default'].createElement(
	                                    'div',
	                                    null,
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { key: "changeRequestKey" },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].changeRequestField },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                { className: _clientContractCreateScss2['default'].changeRequestInputLabel },
	                                                _("changeRequestLabel")
	                                            ),
	                                            _react2['default'].createElement('input', {
	                                                className: _clientContractCreateScss2['default'].changeRequest,
	                                                type: 'checkbox',
	                                                checked: changeRequest,
	                                                disabled: allFieldDisabled,
	                                                onChange: function (ev) {
	                                                    ev.stopPropagation();
	                                                    _this13.setState({ changeRequest: !changeRequest });
	                                                }
	                                            })
	                                        )
	                                    ),
	                                    changeRequest ? _react2['default'].createElement(
	                                        'div',
	                                        null,
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].changeRequestField, key: "commentChangeRequestLabelKey" },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _clientContractCreateScss2['default'].commentChangeRequestInputLabelWrapper },
	                                                _react2['default'].createElement(
	                                                    'div',
	                                                    { className: _clientContractCreateScss2['default'].commentChangeRequestInputLabelDiv },
	                                                    _react2['default'].createElement(
	                                                        'label',
	                                                        { className: _clientContractCreateScss2['default'].commentChangeRequestInputLabel },
	                                                        _("commentChangeRequestLabel")
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].changeRequestField, key: "commentChangeRequestTextareaKey" },
	                                            _react2['default'].createElement('textarea', {
	                                                className: _clientContractCreateScss2['default'].commentChangeRequestText,
	                                                ref: 'commentChangeRequest',
	                                                rows: '3',
	                                                value: String(commentChangeRequest || ''),
	                                                onChange: function (value) {
	                                                    _this13.setFieldTouched('commentChangeRequest');
	                                                    _this13.setState({ commentChangeRequest: value && value.target.value || "" });
	                                                }
	                                            })
	                                        ),
	                                        _nestedProperty2['default'].get(validationErrors, "commentChangeRequest.message") && _nestedProperty2['default'].get(validationErrors, "commentChangeRequest.touched") && !commentChangeRequest && _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientContractCreateScss2['default'].inputRow, key: "mentionInputErrorKey" },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _clientContractCreateScss2['default'].inputRowError },
	                                                validationErrors.commentChangeRequest.message
	                                            )
	                                        )
	                                    ) : null,
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _clientContractCreateScss2['default'].inputRow, key: "pleaseConfirmThePremProposalKey" },
	                                        _react2['default'].createElement(
	                                            'label',
	                                            { className: (0, _classnames2['default'])(_clientContractCreateScss2['default'].inputLabel, _clientContractCreateScss2['default'].confirmProposalText) },
	                                            _("pleaseConfirmThePremProposal")
	                                        )
	                                    )
	                                ) : _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].inputRow, key: "pleaseConfirmTheProposalKey" },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: (0, _classnames2['default'])(_clientContractCreateScss2['default'].inputLabel, _clientContractCreateScss2['default'].confirmProposalText) },
	                                        _("pleaseConfirmTheProposal")
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractCreateScss2['default'].buttons, key: "closeModalKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "closeModalCanceKey",
	                                            onClick: function () {
	                                                _this13.handleCloseModel(false);
	                                            },
	                                            className: (0, _classnames2['default'])(_clientContractCreateScss2['default'].cancel)
	                                        },
	                                        _("cancel")
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "closeModalConfirmKey",
	                                            onClick: function () {
	                                                if (!hasError) {
	                                                    _this13.handleCloseModel(true);
	                                                } else {
	                                                    _this13.setFieldTouched(fieldsForFill);
	                                                }
	                                            },
	                                            className: (0, _classnames2['default'])(_clientContractCreateScss2['default'].next, _clientContractCreateScss2['default'].enabled)
	                                        },
	                                        _("confirm")
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                this.waitingPopup()
	            );
	        }
	    }]);
	
	    var _ClientContractCreate = ClientContractCreate;
	    ClientContractCreate = (0, _reactRedux.connect)(function (state) {
	
	        var clientAccess = state.app.security.actions;
	        var canCreateMifid = false;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createmifid') {
	                canCreateMifid = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        return {
	            security: state.app.security,
	            brokers: state.office.brokers,
	            canCreateMifid: canCreateMifid
	        };
	    })(ClientContractCreate) || ClientContractCreate;
	    return ClientContractCreate;
	})(_react2['default'].Component);
	
	exports['default'] = ClientContractCreate;
	module.exports = exports['default'];

	// perform change actions

	// Call initContract api to get information for the selected broker, the result contains values for the
	// drop-down inputs and risk descriptions, etc.
	// this can be run parallel with the set state of broker until the value not affect the initializations

	// prepare params for api call

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _emailServerConfigDialogScss = __webpack_require__(1608);
	
	var _emailServerConfigDialogScss2 = _interopRequireDefault(_emailServerConfigDialogScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('emailSenderConfigDialog');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        wordWrap: "break-word"
	    }
	};
	
	var EmailServerConfigDialog = (function (_React$Component) {
	    _inherits(EmailServerConfigDialog, _React$Component);
	
	    _createClass(EmailServerConfigDialog, null, [{
	        key: 'propTypes',
	        value: {
	            modalIsOpen: _react2['default'].PropTypes.bool,
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function EmailServerConfigDialog(props) {
	        _classCallCheck(this, _EmailServerConfigDialog);
	
	        _get(Object.getPrototypeOf(_EmailServerConfigDialog.prototype), 'constructor', this).call(this, props);
	        this.state = { senderName: '', hasError: false, errorMessage: '' };
	    }
	
	    _createClass(EmailServerConfigDialog, [{
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var modalIsOpen = _props.modalIsOpen;
	            var onCancel = _props.onCancel;
	            var onConfirmation = _props.onConfirmation;
	            var senderEmailAddress = _props.senderEmailAddress;
	            var dispatch = _props.dispatch;
	            var _state = this.state;
	            var senderName = _state.senderName;
	            var hasError = _state.hasError;
	            var errorMessage = _state.errorMessage;
	
	            var config = {
	                emailAddress: senderEmailAddress,
	                senderName: senderName
	            };
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _emailServerConfigDialogScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _emailServerConfigDialogScss2['default'].title },
	                            _('emailConfigModalTitle')
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _emailServerConfigDialogScss2['default'].contentWrapper },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _emailServerConfigDialogScss2['default'].content },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _emailServerConfigDialogScss2['default'].formInputContainer },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _emailServerConfigDialogScss2['default'].formLabel },
	                                        _('emailAddressInUse'),
	                                        ':'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'span',
	                                        null,
	                                        senderEmailAddress
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _emailServerConfigDialogScss2['default'].formInputContainer },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _emailServerConfigDialogScss2['default'].formLabel },
	                                        _('senderName'),
	                                        ':*'
	                                    ),
	                                    _react2['default'].createElement('input', {
	                                        className: (0, _classnames2['default'])(_emailServerConfigDialogScss2['default'].formInput, _emailServerConfigDialogScss2['default'].formInputText),
	                                        type: 'text',
	                                        value: senderName,
	                                        placeholder: _('senderNamePlaceholder'),
	                                        onChange: function (e) {
	                                            _this.setState({ senderName: e.target.value });
	                                        },
	                                        onBlur: function () {
	                                            if (!senderName) {
	                                                _this.setState({ hasError: true, errorMessage: _('senderNameError') });
	                                            } else if (senderName && senderName.includes('@')) {
	                                                _this.setState({ hasError: true, errorMessage: _('invalidCharacter') });
	                                            } else _this.setState({ hasError: false });
	                                        },
	                                        ref: 'senderName',
	                                        name: 'senderName'
	                                    })
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    null,
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _emailServerConfigDialogScss2['default'].errorMessage },
	                                        hasError && errorMessage
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _emailServerConfigDialogScss2['default'].buttons },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: onCancel,
	                                        className: _emailServerConfigDialogScss2['default'].cancel
	                                    },
	                                    _('cancel')
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            if (!senderName) {
	                                                _this.setState({ hasError: true });
	                                                return;
	                                            }
	                                            if (hasError) {
	                                                return;
	                                            }
	                                            onConfirmation(config);
	                                        },
	                                        className: (0, _classnames2['default'])(_emailServerConfigDialogScss2['default'].next, _emailServerConfigDialogScss2['default'].enabled)
	                                    },
	                                    _('confirm')
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _EmailServerConfigDialog = EmailServerConfigDialog;
	    EmailServerConfigDialog = (0, _reactRedux.connect)(function (state) {
	        return {
	            senderEmailAddress: state.emailSender.senderEmailAddress
	        };
	    })(EmailServerConfigDialog) || EmailServerConfigDialog;
	    return EmailServerConfigDialog;
	})(_react2['default'].Component);
	
	exports['default'] = EmailServerConfigDialog;
	module.exports = exports['default'];

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	/**
	 * This function fetch by regular expression the img tags src values from a string what contains html.
	 * Return an array of strings of urls.
	 * @param {string} html
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var fetchSrcValuesFromHtml = function fetchSrcValuesFromHtml(html) {
	    var srcValueList = [];
	
	    if (!html) {
	        return srcValueList;
	    }
	
	    var regexImgs = /<img(.*?)src=["'](.*?)["'](.*?)>/g;
	    var foundImgs = html.match(regexImgs);
	
	    if (!foundImgs || foundImgs.length == 0) {
	        return srcValueList;
	    }
	    var regexSrc = /src=["'](.*?)["']/g;
	    var foundSrc = false;
	
	    foundImgs.forEach(function (oneImg) {
	        foundSrc = oneImg.match(regexSrc);
	
	        if (!foundSrc || foundSrc.length == 0) {
	            return;
	        }
	
	        var cleanUrl = foundSrc[0].substring(5, foundSrc[0].length - 1);
	        srcValueList.push(cleanUrl);
	    });
	
	    return srcValueList;
	};
	exports.fetchSrcValuesFromHtml = fetchSrcValuesFromHtml;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _infoModalScss = __webpack_require__(1610);
	
	var _infoModalScss2 = _interopRequireDefault(_infoModalScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        wordWrap: "break-word"
	    }
	};
	
	var InfoModal = (function (_React$Component) {
	    _inherits(InfoModal, _React$Component);
	
	    _createClass(InfoModal, null, [{
	        key: 'propTypes',
	        value: {
	            isOpen: _react2['default'].PropTypes.bool,
	            title: _react2['default'].PropTypes.string,
	            content: _react2['default'].PropTypes.string,
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func,
	            cancelLabel: _react2['default'].PropTypes.string,
	            confirmationLabel: _react2['default'].PropTypes.string,
	            options: _react2['default'].PropTypes.object
	        },
	        enumerable: true
	    }]);
	
	    function InfoModal(props) {
	        _classCallCheck(this, InfoModal);
	
	        _get(Object.getPrototypeOf(InfoModal.prototype), 'constructor', this).call(this, props);
	        //this.handleKeyPress = this.handleKeyPress.bind(this);
	        this.state = { templates: null };
	    }
	
	    /* componentWillUnmount () {
	    	document.body.removeEventListener('keyup', this.props.onCancel, false);
	    }
	    	handleKeyPress (evt) {
	    	if (vkey[evt.keyCode] === '<escape>') {
	    		this.props.onCancel();
	    	}
	    }
	    	componentDidMount() {
	           document.body.addEventListener('keyup', this.props.onCancel, false);
	       } */
	
	    _createClass(InfoModal, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var isOpen = _props.isOpen;
	            var onCancel = _props.onCancel;
	            var onConfirmation = _props.onConfirmation;
	            var cancelLabel = _props.cancelLabel;
	            var confirmationLabel = _props.confirmationLabel;
	            var options = _props.options;
	            var title = _props.title;
	            var content = _props.content;
	
	            var noCancelButton = _nestedProperty2['default'].get(options, 'noCancelButton');
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: isOpen,
	                    onCancel: onCancel,
	                    style: customStyles,
	                    className: _infoModalScss2['default'].modal,
	                    contentLabel: ""
	                },
	                _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _infoModalScss2['default'].title },
	                        title
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _infoModalScss2['default'].contentWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _infoModalScss2['default'].content },
	                            content
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _infoModalScss2['default'].buttons },
	                            !noCancelButton && _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        return onCancel();
	                                    },
	                                    className: _infoModalScss2['default'].cancel
	                                },
	                                cancelLabel
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        return onConfirmation();
	                                    },
	                                    className: (0, _classnames2['default'])(_infoModalScss2['default'].next, _infoModalScss2['default'].enabled)
	                                },
	                                confirmationLabel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InfoModal;
	})(_react2['default'].Component);
	
	exports['default'] = InfoModal;
	module.exports = exports['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _contactModal = __webpack_require__(1118);
	
	var _contactModal2 = _interopRequireDefault(_contactModal);
	
	var _contactZoom = __webpack_require__(1119);
	
	var _contactZoom2 = _interopRequireDefault(_contactZoom);
	
	var _contactsList = __webpack_require__(1120);
	
	var _contactsList2 = _interopRequireDefault(_contactsList);
	
	var _contactsScss = __webpack_require__(304);
	
	var _contactsScss2 = _interopRequireDefault(_contactsScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libHelpers = __webpack_require__(24);
	
	var _bpostSelectJson = __webpack_require__(309);
	
	var _bpostSelectJson2 = _interopRequireDefault(_bpostSelectJson);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var customStyles = {
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -50%)',
			padding: '0',
			overflow: 'visible'
		}
	};
	var zipCodeOptions = _bpostSelectJson2['default'].map(function (_ref) {
		var zip = _ref.zip;
		var city = _ref.city;
	
		var search = city.toLowerCase().split(/[^a-z]+/).join('|');
		return {
			value: zip + '_' + city,
			label: zip + ', ' + city,
			search: '|' + zip + '|' + search
		};
	});
	
	var ContactNameValue = function ContactNameValue(_ref2) {
		var contact = _ref2.contact;
		var name = contact.name;
	
		if (!name) {
			return _react2['default'].createElement(
				'span',
				null,
				'? ?'
			);
		}
		var fullName = name.first + ' ' + name.last;
		return _react2['default'].createElement(
			'div',
			null,
			fullName
		);
	};
	exports.ContactNameValue = ContactNameValue;
	ContactNameValue.propTypes = {
		contact: _react.PropTypes.object
	};
	
	var Contacts = (function (_React$Component) {
		_inherits(Contacts, _React$Component);
	
		_createClass(Contacts, null, [{
			key: 'propTypes',
			value: {
				contacts: _react2['default'].PropTypes.array,
				contactZoom: _react2['default'].PropTypes.object,
				contactModal: _react2['default'].PropTypes.object,
				dispatch: _react2['default'].PropTypes.func.isRequired,
				clientOptionsDict: _react2['default'].PropTypes.object,
				appLanguage: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		function Contacts(props) {
			_classCallCheck(this, _Contacts);
	
			_get(Object.getPrototypeOf(_Contacts.prototype), 'constructor', this).call(this, props);
	
			this.onCloseModal = this.onCloseModal.bind(this);
			this.onShowContactModal = this.onShowContactModal.bind(this);
			this.onContactClicked = this.onContactClicked.bind(this);
			this.onRemoveContact = this.onRemoveContact.bind(this);
			this.onCloseContact = this.onCloseContact.bind(this);
			this.onSaveContact = this.onSaveContact.bind(this);
	
			this.state = { countries: [], countriesMultiLang: {} };
		}
	
		_createClass(Contacts, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this = this;
	
				var _props = this.props;
				var dispatch = _props.dispatch;
				var clientOptionsDict = _props.clientOptionsDict;
	
				if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
					dispatch((0, _stateActions.fetchClientOptionsDict)()).then(function (dictionary) {
						_this.setClientOptionsDict(dictionary);
					});
				} else {
					if (!this.state.clientDictionary) {
						this.setClientOptionsDict(clientOptionsDict);
					}
				}
			}
	
			/**
	   * Set client options dict in to the state
	   * @param {object} dictionary - contains the dictionary
	   */
		}, {
			key: 'setClientOptionsDict',
			value: function setClientOptionsDict(dictionary) {
				var appLanguage = this.props.appLanguage;
	
				var clientDict = (0, _libHelpers.generateClientDicts)(dictionary, appLanguage);
				this.setState({ clientDictionary: clientDict });
				this.setState({ countries: clientDict.country });
	
				this.setState({ countriesMultiLang: {
						nl: (0, _libHelpers.generateGlobalOptionsObject)(dictionary.LAND, "nl"),
						fr: (0, _libHelpers.generateGlobalOptionsObject)(dictionary.LAND, "fr"),
						en: (0, _libHelpers.generateGlobalOptionsObject)(dictionary.LAND, "en")
					} });
			}
	
			/* componentWillMount() {
	      const {dispatch, clientOptionsDict} = this.props
	       // load client option dict from oracle
	      if (!clientOptionsDict || clientOptionsDict.length < 1) {
	          dispatch(fetchClientOptionsDict()).then((response) => {
	               // find all belgium translation variation by oracle
	              let nlBelgium = this.getBelgiumTranslationsByLang(response, "nl") || []
	              let frBelgium = this.getBelgiumTranslationsByLang(response, "fr") || []
	              let enBelgium = this.getBelgiumTranslationsByLang(response, "en") || []
	               // filter the unnecessary redundant data
	              let noDuplicates = []
	              nlBelgium.concat(frBelgium).concat(enBelgium).forEach((item) => {
	                  if (noDuplicates.indexOf(item) === -1) {
	                      noDuplicates.push(item)
	                  }
	              })
	               this.setState({belgiumWords: noDuplicates})
	          })
	      }
	  } */
	
			/**
	   *  This function collect all of the variation of spelling and writing of the Blegium word.
	   * @param {object} clientOptionsDict - oracle provided translations
	   * @param {string} language - nl fr en
	   */
		}, {
			key: 'getBelgiumTranslationsByLang',
			value: function getBelgiumTranslationsByLang(clientOptionsDict, language) {
				var clientDictionaryCountryBelgium = [];
	
				if (!clientOptionsDict) {
					return clientDictionaryCountryBelgium;
				}
	
				var countries = clientOptionsDict.LAND;
				clientDictionaryCountryBelgium = Object.keys(countries)
				// keep all translations matched by a few correct spelled version of the name
				.filter(function (key) {
					return String(countries[key][language]).toLowerCase().trim() == 'België'.toLowerCase() || String(countries[key][language]).toLowerCase().trim() == 'Belgique'.toLowerCase() || String(countries[key][language]).toLowerCase().trim() == 'Belgium'.toLowerCase() || String(countries[key][language]).toLowerCase().trim() == 'Koninkrijk België'.toLowerCase() || String(countries[key][language]).toLowerCase().trim() == 'Royaume de Belgique'.toLowerCase() || String(countries[key][language]).toLowerCase().trim() == 'Kingdom of Belgium'.toLowerCase();
				}).map(function (key) {
					return Object.keys(countries[key]).map(function (langKey) {
						return countries[key][langKey];
					});
				});
	
				// initial possible variations inserted to the white list.
				var translations = ['belgie', 'belgium', 'koninkrijk belgie', 'koninkrijk belgië', 'royaume de belgique', 'kingdom of belgium'];
	
				// reduce the array
				if (clientDictionaryCountryBelgium) {
					clientDictionaryCountryBelgium.forEach(function (oneArray) {
						if (oneArray) {
							oneArray.forEach(function (oneTrans) {
								// use lowercase words rto compare
								translations.push(String(oneTrans).toLowerCase());
							});
						}
					});
				}
	
				return translations;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var dispatch = this.props.dispatch;
	
				// TODO this should be part of app state so URL can have contact
				dispatch((0, _stateActions.closeContact)());
				this.refresh();
			}
		}, {
			key: 'refresh',
			value: function refresh() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.loadContacts)());
			}
		}, {
			key: 'onCloseModal',
			value: function onCloseModal() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.hideContactModal)());
			}
		}, {
			key: 'onShowContactModal',
			value: function onShowContactModal(id) {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.showContactModal)(id));
			}
		}, {
			key: 'onContactClicked',
			value: function onContactClicked(id) {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.zoomContact)(id));
			}
		}, {
			key: 'onSaveContact',
			value: function onSaveContact(data) {
				var _props2 = this.props;
				var dispatch = _props2.dispatch;
				var contactModal = _props2.contactModal;
	
				if (contactModal.contactId) {
					data._id = contactModal.contactId;
				}
	
				var formattedData = {};
	
				for (var value in data) {
					if (data[value] === undefined) {
						formattedData[value] = '';
					} else {
						formattedData[value] = data[value];
					}
				}
	
				formattedData.name = { first: formattedData.firstName, last: formattedData.lastName };
				formattedData.birthday = formattedData.birthday.replace(/\//g, '-');
	
				formattedData.zipCity = formattedData.zipCity.split(/[_,](.+)/);
	
				if (formattedData.zipCity && formattedData.zipCity.length > 1) {
					formattedData.zip = formattedData.zipCity[0];
					formattedData.city = formattedData.zipCity[1];
				} else {
					formattedData.zip = '';
					formattedData.city = formattedData.zipCity && formattedData.zipCity.join("") || '';
				}
	
				delete formattedData.zipCity;
				delete formattedData.firstName;
				delete formattedData.lastName;
	
				this.initialized = false;
				dispatch((0, _stateActions.setContact)(formattedData));
				this.onCloseModal();
			}
		}, {
			key: 'onRemoveContact',
			value: function onRemoveContact(data) {
				var dispatch = this.props.dispatch;
	
				var r = confirm(_('delConf'));
				if (r === true) {
					data._deleted = true;
					dispatch((0, _stateActions.removeContactById)(data._id));
					dispatch((0, _stateActions.closeContact)());
				}
			}
		}, {
			key: 'onCloseContact',
			value: function onCloseContact() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.closeContact)());
			}
	
			/**
	   * This function try to find the country name in translations. In the database from some reason not stored as an ID,
	   * so mut be done this complicated method to select the saved value from a list.
	   * @param {*} countryNameLabel
	   */
		}, {
			key: 'getTheCountryId',
			value: function getTheCountryId(countryNameLabel) {
				var _state = this.state;
				var countries = _state.countries;
				var countriesMultiLang = _state.countriesMultiLang;
	
				var resultId = countries && _nestedProperty2['default'].get(countries.filter(function (oneCountry) {
					return String(oneCountry.label).trim().toLowerCase() == String(countryNameLabel).trim().toLowerCase();
				}), "0.value") || 0;
	
				if (!resultId) {
					resultId = countriesMultiLang.nl && _nestedProperty2['default'].get(countriesMultiLang.nl.filter(function (oneCountry) {
						return String(oneCountry.label).trim().toLowerCase() == String(countryNameLabel).trim().toLowerCase();
					}), "0.value") || 0;
				}
	
				if (!resultId) {
					resultId = countriesMultiLang.fr && _nestedProperty2['default'].get(countriesMultiLang.fr.filter(function (oneCountry) {
						return String(oneCountry.label).trim().toLowerCase() == String(countryNameLabel).trim().toLowerCase();
					}), "0.value") || 0;
				}
	
				if (!resultId) {
					resultId = countriesMultiLang.en && _nestedProperty2['default'].get(countriesMultiLang.en.filter(function (oneCountry) {
						return String(oneCountry.label).trim().toLowerCase() == String(countryNameLabel).trim().toLowerCase();
					}), "0.value") || 0;
				}
	
				return resultId;
			}
		}, {
			key: 'render',
			value: function render() {
				var _props3 = this.props;
				var contacts = _props3.contacts;
				var contactZoom = _props3.contactZoom;
				var contactModal = _props3.contactModal;
				var countries = this.state.countries;
	
				var contact = {};
				var initialValues = {};
	
				if (!contacts) {
					return false;
				}
	
				if (contactZoom && contactZoom.visible) {
					contact = contacts.filter(function (item) {
						return item._id === contactZoom.contactId;
					})[0];
	
					if (contactModal && contactModal.visible) {
						var _contact$birthday$split = contact.birthday.split("-");
	
						var _contact$birthday$split2 = _slicedToArray(_contact$birthday$split, 3);
	
						var yyyy = _contact$birthday$split2[0];
						var mm = _contact$birthday$split2[1];
						var dd = _contact$birthday$split2[2];
	
						var birthday = dd + '/' + mm + '/' + yyyy;
						var zipCity = '' + (contact.zip && contact.zip + ", " || "") + (contact.city || "");
						var zipCityUnderscore = '' + (contact.zip && contact.zip + "_" || "") + (contact.city || "");
						var _name = contact.name || {};
	
						var zipCityPrepare = '';
	
						if (zipCodeOptions) {
							// find the free typed value if is set in the dropdown
							var isThereAnyMatch = zipCodeOptions.filter(function (item) {
								return String(item.label).indexOf(contact.zip) !== -1 || String(item.value).indexOf(contact.zip) !== -1 || String(item.label).indexOf(contact.city) !== -1 || String(item.value).indexOf(contact.city) !== -1;
							});
	
							if (isThereAnyMatch.length > 0) {
								zipCityPrepare = isThereAnyMatch[0].value;
							}
						}
	
						var countryNameLabel = _nestedProperty2['default'].get(contact, "country") || '';
						var selectedCountryId = this.getTheCountryId(countryNameLabel);
	
						initialValues = {
							firstName: _name.first || "",
							lastName: _name.last || "",
							birthday: (0, _libHelpers.formatDate)(birthday, 'us'),
							email: contact.email || "",
							street: contact.street || "",
							houseNum: contact.houseNum || "",
							houseNumExt: contact.houseNumExt || "",
							zipCity: zipCity,
							zipCitySelected: zipCityPrepare,
							zipTyped: contact.zip,
							cityTyped: contact.city,
							mobile: contact.mobile || "",
							phone: contact.phone || "",
							country: selectedCountryId || "",
							language: contact.language || ""
						};
					}
				}
	
				return _react2['default'].createElement(
					'div',
					{ className: _contactsScss2['default'].contactsTable },
					!contactZoom || !contactZoom.visible ? _react2['default'].createElement(_contactsList2['default'], {
						contacts: contacts,
						onShowContactModal: this.onShowContactModal,
						onContactClicked: this.onContactClicked
					}) : _react2['default'].createElement(_contactZoom2['default'], {
						contact: contact,
						onShowContactModal: this.onShowContactModal,
						onRemoveContact: this.onRemoveContact,
						onCloseContact: this.onCloseContact
					}),
					contactModal.visible && _react2['default'].createElement(
						_reactModal2['default'],
						{
							isOpen: true,
							onRequestClose: this.onCloseModal,
							style: customStyles,
							className: _contactsScss2['default'].modal
						},
						_react2['default'].createElement(_contactModal2['default'], {
							initialValues: initialValues,
							onCloseModal: this.onCloseModal,
							onSaveContact: this.onSaveContact,
							countries: countries,
							zipCodeOptions: zipCodeOptions
						})
					)
				);
			}
		}]);
	
		var _Contacts = Contacts;
		Contacts = (0, _reactRedux.connect)(function (state) {
			return {
				contacts: state.office.contacts,
				contactZoom: state.office.contactZoom,
				contactModal: state.office.contactModal,
				clientOptionsDict: state.client.clientOptionsDict,
				appLanguage: state.app.lang
			};
		})(Contacts) || Contacts;
		return Contacts;
	})(_react2['default'].Component);
	
	exports['default'] = Contacts;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable import/no-extraneous-dependencies */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var translate = (0, _libI18n2['default'])('office');
	
	exports['default'] = translate;
	module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _taskCreatorForm = __webpack_require__(1145);
	
	var _taskCreatorForm2 = _interopRequireDefault(_taskCreatorForm);
	
	var modalStyle = {
	    overlay: {
	        position: "fixed",
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: "flex",
	        justifyContent: "center",
	        alignItems: "center",
	        backgroundColor: "rgba(255, 255, 255, 0.75)"
	    },
	    content: {
	        position: "relative",
	        top: "initial",
	        bottom: "initial",
	        left: "initial",
	        right: "initial",
	        maxHeight: "90%",
	        overflow: "auto",
	        padding: "0"
	    }
	};
	
	/**
	 * Task creator implements a modal interface to convert an entity or a group of entities as a task|tasks
	 * this component requires some properties
	 */
	
	var TaskCreator = (function (_Component) {
	    _inherits(TaskCreator, _Component);
	
	    function TaskCreator() {
	        _classCallCheck(this, _TaskCreator);
	
	        _get(Object.getPrototypeOf(_TaskCreator.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(TaskCreator, [{
	        key: "render",
	        value: function render() {
	            return _react2["default"].createElement(
	                "div",
	                null,
	                _react2["default"].createElement(
	                    _reactModal2["default"],
	                    { isOpen: this.props.modalIsOpen, style: modalStyle, contentLabel: "" },
	                    _react2["default"].createElement(_taskCreatorForm2["default"], this.props)
	                )
	            );
	        }
	    }], [{
	        key: "propTypes",
	        value: {
	            modalTitle: _react.PropTypes.string.isRequired,
	            taskItems: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            staffItems: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            convertionType: _react.PropTypes.string.isRequired,
	            modalIsOpen: _react.PropTypes.bool,
	            taskCreatorModalToggle: _react.PropTypes.func.isRequired,
	            taskCreatorGenerateWithRelations: _react.PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    var _TaskCreator = TaskCreator;
	    TaskCreator = (0, _reactRedux.connect)(function (_ref) {
	        var _ref$taskCreator = _ref.taskCreator;
	        var modalIsOpen = _ref$taskCreator.modalIsOpen;
	        var error = _ref$taskCreator.error;
	        var statusText = _ref$taskCreator.statusText;
	        return { modalIsOpen: modalIsOpen, error: error, statusText: statusText };
	    }, { taskCreatorModalToggle: _stateActions.taskCreatorModalToggle, taskCreatorGenerateWithRelations: _stateActions.taskCreatorGenerateWithRelations })(TaskCreator) || TaskCreator;
	    return TaskCreator;
	})(_react.Component);
	
	exports["default"] = TaskCreator;
	module.exports = exports["default"];

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _libHelpers = __webpack_require__(24);
	
	var DateValue = function DateValue(_ref) {
		var date = _ref.date;
	
		var rest = _objectWithoutProperties(_ref, ["date"]);
	
		return _react2["default"].createElement(
			"span",
			rest,
			(0, _libHelpers.formatDate)(date)
		);
	};
	exports["default"] = DateValue;
	module.exports = exports["default"];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(105);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _ReactSelect2WrapperScss = __webpack_require__(1638);
	
	var _ReactSelect2WrapperScss2 = _interopRequireDefault(_ReactSelect2WrapperScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('selectWrapper');
	
	var selectInFocusWithin = false;
	
	/**
	 * Customization object for the react-select using the same style like other components on tha site.
	 */
	var customCreatableSelectStyles = {
	    control: function control(base, state) {
	        selectInFocusWithin = state.isFocused;
	        return _extends({}, base, {
	            flex: "4",
	            fontSize: "12px",
	            display: "flex",
	            justifyContent: "flex-end",
	            alignItems: "flex-end",
	            color: "#000",
	            backgroundColor: state.isDisabled ? "#F6F6F6" : "#FFFFFF",
	            borderColor: "#d9d9d9 #ccc #b3b3b3",
	            borderRadius: "2px",
	            border: "1px solid #d9d9d9",
	            minHeight: "25px",
	            maxHeight: "auto",
	            //height: state.isFocused ? "auto" : "25px",
	            boxShadow: state.isFocused ? null : null,
	            "&:hover": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            "&:focus": {
	                borderColor: "#A6C8FF #A6C8FF #A6C8FF"
	            },
	            padding: 0,
	            margin: 0,
	            overflow: state.isFocused ? null : "hidden"
	        });
	    },
	    menu: function menu(base) {
	        return _extends({}, base, {
	            borderRadius: 2,
	            hyphens: "auto",
	            marginTop: 0,
	            textAlign: "left",
	            wordWrap: "break-word"
	        });
	    },
	    menuList: function menuList(base) {
	        return _extends({}, base, {
	            padding: 0,
	            verticalAlign: "baseline"
	        });
	    },
	    singleValue: function singleValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            color: "#333333",
	            fontSize: "12px"
	        });
	    },
	    option: function option(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            fontSize: '0.80em',
	            maxHeight: "25px"
	        });
	    },
	    valueContainer: function valueContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            top: 0,
	
	            fontSize: "12px"
	        });
	    },
	    clearIndicator: function clearIndicator(base, state) {
	        return _extends({}, base, {
	            padding: 0
	        });
	    },
	    dropdownIndicator: function dropdownIndicator(base, state) {
	        return _extends({}, base, {
	            marginTop: 0,
	            padding: 0
	        });
	    },
	    indicatorsContainer: function indicatorsContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "23px",
	            top: 0
	        });
	    },
	    indicatorSeparator: function indicatorSeparator(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "0",
	            top: 0
	        });
	    },
	    input: function input(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: "2px 0 0 0",
	            height: "20px",
	            top: 0,
	            fontSize: '12px',
	            lineHeight: '0.8em',
	            width: selectInFocusWithin ? '100%!important' : 'auto',
	            div: {
	                width: selectInFocusWithin ? '100%!important' : 'auto',
	                input: {
	                    width: selectInFocusWithin ? '100%!important' : 'auto'
	                }
	            }
	        });
	    },
	    noOptionsMessage: function noOptionsMessage(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            fontSize: '0.78em'
	        });
	    }
	};
	
	exports.customCreatableSelectStyles = customCreatableSelectStyles;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var DropdownIndicator = function DropdownIndicator(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.DropdownIndicator,
	        props,
	        _react2['default'].createElement(
	            'span',
	            { className: _ReactSelect2WrapperScss2['default'].downArrowHolder },
	            _react2['default'].createElement('span', { className: _ReactSelect2WrapperScss2['default'].downArrow })
	        )
	    );
	};
	
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var NoOptionsMessage = function NoOptionsMessage(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.NoOptionsMessage,
	        _extends({}, props, { className: _ReactSelect2WrapperScss2['default'].noOptionsMessage }),
	        _('noOptions')
	    );
	};
	
	/**
	 * This component make easy to use the react select 2 on a general way.
	 */
	
	var ReactSelect2 = (function (_React$Component) {
	    _inherits(ReactSelect2, _React$Component);
	
	    /**
	     * Constructor
	     * @param {*} props
	     */
	
	    function ReactSelect2(props) {
	        _classCallCheck(this, ReactSelect2);
	
	        _get(Object.getPrototypeOf(ReactSelect2.prototype), 'constructor', this).call(this, props);
	    }
	
	    /**
	     * Render the select
	     */
	
	    _createClass(ReactSelect2, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(_reactSelect2['default'], _extends({}, this.props, {
	                styles: _extends({}, customCreatableSelectStyles, this.props.customStyles),
	                components: { DropdownIndicator: DropdownIndicator, NoOptionsMessage: NoOptionsMessage }
	            }));
	        }
	    }]);
	
	    return ReactSelect2;
	})(_react2['default'].Component);
	
	exports['default'] = ReactSelect2;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(619);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1182);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1181);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 378 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(222);
	var dPs = __webpack_require__(1200);
	var enumBugKeys = __webpack_require__(378);
	var IE_PROTO = __webpack_require__(383)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(623)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(1194).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(145).f;
	var has = __webpack_require__(144);
	var TAG = __webpack_require__(180)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(384)('keys');
	var uid = __webpack_require__(270);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(126);
	var global = __webpack_require__(128);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(266) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(377);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(178);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(128);
	var core = __webpack_require__(126);
	var LIBRARY = __webpack_require__(266);
	var wksExt = __webpack_require__(389);
	var defineProperty = __webpack_require__(145).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(180);


/***/ }),
/* 390 */
[2336, 442, 246, 2238, 195, 434],
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var Disclaimer, E, N, React, __, assign, translations,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	React = __webpack_require__(1);
	
	E = React.createElement;
	
	N = {};
	
	assign = __webpack_require__(330).assign;
	
	translations = {
	  disclaimer: "Disclaimer",
	  disclaimerUrl: "http://www.willemot.eu/disclaimer/"
	};
	
	__ = function(t) {
	  return translations[t] || t;
	};
	
	Disclaimer = (function(superClass) {
	  extend(Disclaimer, superClass);
	
	  function Disclaimer() {
	    return Disclaimer.__super__.constructor.apply(this, arguments);
	  }
	
	  Disclaimer.prototype.render = function() {
	    return E('a', assign({
	      href: __("disclaimerUrl"),
	      target: '_blank',
	      rel: "noopener noreferrer"
	    }, this.props), __("disclaimer"));
	  };
	
	  return Disclaimer;
	
	})(React.Component);
	
	module.exports = Disclaimer;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	module.exports = {
	  B2bCompanyGeneraliUri: "https://auth.be.athora.site/login/WillemotSessionInit.jsp?o=1",
	  B2bCompanyVerzekeringenUri: "/b2bconnection/vivium?",
	  WillemotEmails: ['@willemot1841.be', '@ovb.willemot.eu', '@willemot.be', '@izegemverzekeringen.be', '@knokkeverzekeringen.be', '@sintniklaasverzekeringen.be', '@easinsure.be', '@verzekeringsplanner.be'],
	  AgentAppVersion: "10.0"
	};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isConstructor = __webpack_require__(186);
	var tryToString = __webpack_require__(154);
	
	var $TypeError = TypeError;
	
	// `Assert: IsConstructor(argument) is true`
	module.exports = function (argument) {
	  if (isConstructor(argument)) return argument;
	  throw new $TypeError(tryToString(argument) + ' is not a constructor');
	};


/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	// eslint-disable-next-line es/no-typed-arrays -- safe
	module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
	var fails = __webpack_require__(6);
	
	module.exports = fails(function () {
	  if (typeof ArrayBuffer == 'function') {
	    var buffer = new ArrayBuffer(8);
	    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
	    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
	  }
	});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toObject = __webpack_require__(31);
	var toAbsoluteIndex = __webpack_require__(117);
	var lengthOfArrayLike = __webpack_require__(34);
	
	// `Array.prototype.fill` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.fill
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = lengthOfArrayLike(O);
	  var argumentsLength = arguments.length;
	  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
	  var end = argumentsLength > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var isArray = __webpack_require__(131);
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Safari < 13 does not throw an error in this case
	var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
	  // makes no sense without proper strict mode support
	  if (this !== undefined) return true;
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', { writable: false }).length = 1;
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	}();
	
	module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
	  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
	    throw new $TypeError('Cannot set read only .length');
	  } return O.length = length;
	} : function (O, length) {
	  return O.length = length;
	};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var arraySlice = __webpack_require__(89);
	
	var floor = Math.floor;
	
	var sort = function (array, comparefn) {
	  var length = array.length;
	
	  if (length < 8) {
	    // insertion sort
	    var i = 1;
	    var element, j;
	
	    while (i < length) {
	      j = i;
	      element = array[i];
	      while (j && comparefn(array[j - 1], element) > 0) {
	        array[j] = array[--j];
	      }
	      if (j !== i++) array[j] = element;
	    }
	  } else {
	    // merge sort
	    var middle = floor(length / 2);
	    var left = sort(arraySlice(array, 0, middle), comparefn);
	    var right = sort(arraySlice(array, middle), comparefn);
	    var llength = left.length;
	    var rlength = right.length;
	    var lindex = 0;
	    var rindex = 0;
	
	    while (lindex < llength || rindex < rlength) {
	      array[lindex + rindex] = (lindex < llength && rindex < rlength)
	        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
	        : lindex < llength ? left[lindex++] : right[rindex++];
	    }
	  }
	
	  return array;
	};
	
	module.exports = sort;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(27);
	
	var MATCH = wellKnownSymbol('match');
	
	module.exports = function (METHOD_NAME) {
	  var regexp = /./;
	  try {
	    '/./'[METHOD_NAME](regexp);
	  } catch (error1) {
	    try {
	      regexp[MATCH] = false;
	      return '/./'[METHOD_NAME](regexp);
	    } catch (error2) { /* empty */ }
	  } return false;
	};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	module.exports = !fails(function () {
	  function F() { /* empty */ }
	  F.prototype.constructor = null;
	  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	
	module.exports = function (key, value) {
	  try {
	    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    globalThis[key] = value;
	  } return value;
	};


/***/ }),
/* 402 */
/***/ (function(module, exports) {

	'use strict';
	// IE8- don't enum bug keys
	module.exports = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(99);
	
	var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
	
	module.exports = !!webkit && +webkit[1];


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	var $Error = Error;
	var replace = uncurryThis(''.replace);
	
	var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
	// eslint-disable-next-line redos/no-vulnerable -- safe
	var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
	var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
	
	module.exports = function (stack, dropEntries) {
	  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
	    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
	  } return stack;
	};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var isCallable = __webpack_require__(28);
	var store = __webpack_require__(423);
	
	var functionToString = uncurryThis(Function.toString);
	
	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(store.inspectSource)) {
	  store.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}
	
	module.exports = store.inspectSource;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(27);
	var Iterators = __webpack_require__(234);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var ArrayPrototype = Array.prototype;
	
	// check on default Array iterator
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
	};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(25);
	
	var floor = Math.floor;
	
	// `IsIntegralNumber` abstract operation
	// https://tc39.es/ecma262/#sec-isintegralnumber
	// eslint-disable-next-line es/no-number-isinteger -- safe
	module.exports = Number.isInteger || function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var IteratorPrototype = __webpack_require__(670).IteratorPrototype;
	var create = __webpack_require__(73);
	var createPropertyDescriptor = __webpack_require__(82);
	var setToStringTag = __webpack_require__(65);
	var Iterators = __webpack_require__(234);
	
	var returnThis = function () { return this; };
	
	module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
	  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
	  Iterators[TO_STRING_TAG] = returnThis;
	  return IteratorConstructor;
	};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var IS_PURE = __webpack_require__(43);
	var FunctionName = __webpack_require__(184);
	var isCallable = __webpack_require__(28);
	var createIteratorConstructor = __webpack_require__(408);
	var getPrototypeOf = __webpack_require__(84);
	var setPrototypeOf = __webpack_require__(100);
	var setToStringTag = __webpack_require__(65);
	var createNonEnumerableProperty = __webpack_require__(58);
	var defineBuiltIn = __webpack_require__(40);
	var wellKnownSymbol = __webpack_require__(27);
	var Iterators = __webpack_require__(234);
	var IteratorsCore = __webpack_require__(670);
	
	var PROPER_FUNCTION_NAME = FunctionName.PROPER;
	var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
	var IteratorPrototype = IteratorsCore.IteratorPrototype;
	var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
	var ITERATOR = wellKnownSymbol('iterator');
	var KEYS = 'keys';
	var VALUES = 'values';
	var ENTRIES = 'entries';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
	  createIteratorConstructor(IteratorConstructor, NAME, next);
	
	  var getIterationMethod = function (KIND) {
	    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
	    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
	
	    switch (KIND) {
	      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
	      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
	      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
	    }
	
	    return function () { return new IteratorConstructor(this); };
	  };
	
	  var TO_STRING_TAG = NAME + ' Iterator';
	  var INCORRECT_VALUES_NAME = false;
	  var IterablePrototype = Iterable.prototype;
	  var nativeIterator = IterablePrototype[ITERATOR]
	    || IterablePrototype['@@iterator']
	    || DEFAULT && IterablePrototype[DEFAULT];
	  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
	  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
	  var CurrentIteratorPrototype, methods, KEY;
	
	  // fix native
	  if (anyNativeIterator) {
	    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
	    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
	      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
	        if (setPrototypeOf) {
	          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
	        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
	          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
	        }
	      }
	      // Set @@toStringTag to native iterators
	      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
	      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
	    }
	  }
	
	  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
	  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
	    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
	      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
	    } else {
	      INCORRECT_VALUES_NAME = true;
	      defaultIterator = function values() { return call(nativeIterator, this); };
	    }
	  }
	
	  // export additional methods
	  if (DEFAULT) {
	    methods = {
	      values: getIterationMethod(VALUES),
	      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
	      entries: getIterationMethod(ENTRIES)
	    };
	    if (FORCED) for (KEY in methods) {
	      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
	        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
	      }
	    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
	  }
	
	  // define iterator
	  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
	    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
	  }
	  Iterators[NAME] = defaultIterator;
	
	  return methods;
	};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	var isCallable = __webpack_require__(28);
	var hasOwn = __webpack_require__(29);
	var DESCRIPTORS = __webpack_require__(14);
	var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(184).CONFIGURABLE;
	var inspectSource = __webpack_require__(405);
	var InternalStateModule = __webpack_require__(49);
	
	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	var $String = String;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	var stringSlice = uncurryThis(''.slice);
	var replace = uncurryThis(''.replace);
	var join = uncurryThis([].join);
	
	var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
	  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
	});
	
	var TEMPLATE = String(String).split('String');
	
	var makeBuiltIn = module.exports = function (value, name, options) {
	  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
	    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
	  }
	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;
	  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
	    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
	    else value.name = name;
	  }
	  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
	    defineProperty(value, 'length', { value: options.arity });
	  }
	  try {
	    if (options && hasOwn(options, 'constructor') && options.constructor) {
	      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
	    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) { /* empty */ }
	  var state = enforceInternalState(value);
	  if (!hasOwn(state, 'source')) {
	    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
	  } return value;
	};
	
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required
	Function.prototype.toString = makeBuiltIn(function toString() {
	  return isCallable(this) && getInternalState(this).source || inspectSource(this);
	}, 'toString');


/***/ }),
/* 411 */
/***/ (function(module, exports) {

	'use strict';
	// `Math.sign` method implementation
	// https://tc39.es/ecma262/#sec-math.sign
	// eslint-disable-next-line es/no-math-sign -- safe
	module.exports = Math.sign || function sign(x) {
	  var n = +x;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
	};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isRegExp = __webpack_require__(285);
	
	var $TypeError = TypeError;
	
	module.exports = function (it) {
	  if (isRegExp(it)) {
	    throw new $TypeError("The method doesn't accept regular expressions");
	  } return it;
	};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(697);
	var definePropertyModule = __webpack_require__(42);
	var anObject = __webpack_require__(20);
	var toIndexedObject = __webpack_require__(51);
	var objectKeys = __webpack_require__(236);
	
	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
	  return O;
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-object-getownpropertynames -- safe */
	var classof = __webpack_require__(53);
	var toIndexedObject = __webpack_require__(51);
	var $getOwnPropertyNames = __webpack_require__(152).f;
	var arraySlice = __webpack_require__(89);
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return $getOwnPropertyNames(it);
	  } catch (error) {
	    return arraySlice(windowNames);
	  }
	};
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && classof(it) === 'Window'
	    ? getWindowNames(it)
	    : $getOwnPropertyNames(toIndexedObject(it));
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var isObject = __webpack_require__(25);
	var classof = __webpack_require__(53);
	var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(395);
	
	// eslint-disable-next-line es/no-object-isextensible -- safe
	var $isExtensible = Object.isExtensible;
	var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });
	
	// `Object.isExtensible` method
	// https://tc39.es/ecma262/#sec-object.isextensible
	module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
	  if (!isObject(it)) return false;
	  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
	  return $isExtensible ? $isExtensible(it) : true;
	} : $isExtensible;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(33);
	var uncurryThis = __webpack_require__(8);
	var getOwnPropertyNamesModule = __webpack_require__(152);
	var getOwnPropertySymbolsModule = __webpack_require__(288);
	var anObject = __webpack_require__(20);
	
	var concat = uncurryThis([].concat);
	
	// all object keys, includes non-enumerable and symbols
	module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	
	module.exports = globalThis;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
	/* eslint-disable regexp/no-useless-quantifier -- testing */
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(18);
	var regexpFlags = __webpack_require__(419);
	var stickyHelpers = __webpack_require__(292);
	var shared = __webpack_require__(190);
	var create = __webpack_require__(73);
	var getInternalState = __webpack_require__(49).get;
	var UNSUPPORTED_DOT_ALL = __webpack_require__(420);
	var UNSUPPORTED_NCG = __webpack_require__(686);
	
	var nativeReplace = shared('native-string-replace', String.prototype.replace);
	var nativeExec = RegExp.prototype.exec;
	var patchedExec = nativeExec;
	var charAt = uncurryThis(''.charAt);
	var indexOf = uncurryThis(''.indexOf);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  call(nativeExec, re1, 'a');
	  call(nativeExec, re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	})();
	
	var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
	
	if (PATCH) {
	  patchedExec = function exec(string) {
	    var re = this;
	    var state = getInternalState(re);
	    var str = toString(string);
	    var raw = state.raw;
	    var result, reCopy, lastIndex, match, i, object, group;
	
	    if (raw) {
	      raw.lastIndex = re.lastIndex;
	      result = call(patchedExec, raw, str);
	      re.lastIndex = raw.lastIndex;
	      return result;
	    }
	
	    var groups = state.groups;
	    var sticky = UNSUPPORTED_Y && re.sticky;
	    var flags = call(regexpFlags, re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;
	
	    if (sticky) {
	      flags = replace(flags, 'y', '');
	      if (indexOf(flags, 'g') === -1) {
	        flags += 'g';
	      }
	
	      strCopy = stringSlice(str, re.lastIndex);
	      // Support anchored sticky behavior.
	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      }
	      // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.
	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
	
	    match = call(nativeExec, sticky ? reCopy : re, strCopy);
	
	    if (sticky) {
	      if (match) {
	        match.input = stringSlice(match.input, charsAdded);
	        match[0] = stringSlice(match[0], charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
	      call(nativeReplace, match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    if (match && groups) {
	      match.groups = object = create(null);
	      for (i = 0; i < groups.length; i++) {
	        group = groups[i];
	        object[group[0]] = match[group[1]];
	      }
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(20);
	
	// `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.hasIndices) result += 'd';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.unicodeSets) result += 'v';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var globalThis = __webpack_require__(9);
	
	// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
	var $RegExp = globalThis.RegExp;
	
	module.exports = fails(function () {
	  var re = $RegExp('.', 's');
	  return !(re.dotAll && re.test('\n') && re.flags === 's');
	});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var apply = __webpack_require__(90);
	var isCallable = __webpack_require__(28);
	var ENVIRONMENT = __webpack_require__(281);
	var USER_AGENT = __webpack_require__(99);
	var arraySlice = __webpack_require__(89);
	var validateArgumentsLength = __webpack_require__(85);
	
	var Function = globalThis.Function;
	// dirty IE9- and Bun 0.3.0- checks
	var WRAP = /MSIE .\./.test(USER_AGENT) || ENVIRONMENT === 'BUN' && (function () {
	  var version = globalThis.Bun.version.split('.');
	  return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
	})();
	
	// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
	// https://github.com/oven-sh/bun/issues/1633
	module.exports = function (scheduler, hasTimeArg) {
	  var firstParamIndex = hasTimeArg ? 2 : 1;
	  return WRAP ? function (handler, timeout /* , ...arguments */) {
	    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
	    var fn = isCallable(handler) ? handler : Function(handler);
	    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
	    var callback = boundArgs ? function () {
	      apply(fn, this, params);
	    } : fn;
	    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
	  } : scheduler;
	};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var SetHelpers = __webpack_require__(92);
	var iterate = __webpack_require__(188);
	
	var Set = SetHelpers.Set;
	var add = SetHelpers.add;
	
	module.exports = function (set) {
	  var result = new Set();
	  iterate(set, function (it) {
	    add(result, it);
	  });
	  return result;
	};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var IS_PURE = __webpack_require__(43);
	var globalThis = __webpack_require__(9);
	var defineGlobalProperty = __webpack_require__(401);
	
	var SHARED = '__core-js_shared__';
	var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});
	
	(store.versions || (store.versions = [])).push({
	  version: '3.38.1',
	  mode: IS_PURE ? 'pure' : 'global',
	  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var uncurryThis = __webpack_require__(8);
	var toLength = __webpack_require__(76);
	var toString = __webpack_require__(18);
	var $repeat = __webpack_require__(295);
	var requireObjectCoercible = __webpack_require__(41);
	
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	var ceil = Math.ceil;
	
	// `String.prototype.{ padStart, padEnd }` methods implementation
	var createMethod = function (IS_END) {
	  return function ($this, maxLength, fillString) {
	    var S = toString(requireObjectCoercible($this));
	    var intMaxLength = toLength(maxLength);
	    var stringLength = S.length;
	    var fillStr = fillString === undefined ? ' ' : toString(fillString);
	    var fillLen, stringFiller;
	    if (intMaxLength <= stringLength || fillStr === '') return S;
	    fillLen = intMaxLength - stringLength;
	    stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
	    if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
	    return IS_END ? S + stringFiller : stringFiller + S;
	  };
	};
	
	module.exports = {
	  // `String.prototype.padStart` method
	  // https://tc39.es/ecma262/#sec-string.prototype.padstart
	  start: createMethod(false),
	  // `String.prototype.padEnd` method
	  // https://tc39.es/ecma262/#sec-string.prototype.padend
	  end: createMethod(true)
	};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var PROPER_FUNCTION_NAME = __webpack_require__(184).PROPER;
	var fails = __webpack_require__(6);
	var whitespaces = __webpack_require__(301);
	
	var non = '\u200B\u0085\u180E';
	
	// check that a method works with the correct list
	// of whitespaces and has a correct name
	module.exports = function (METHOD_NAME) {
	  return fails(function () {
	    return !!whitespaces[METHOD_NAME]()
	      || non[METHOD_NAME]() !== non
	      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
	  });
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var fails = __webpack_require__(6);
	var V8 = __webpack_require__(115);
	var ENVIRONMENT = __webpack_require__(281);
	
	var structuredClone = globalThis.structuredClone;
	
	module.exports = !!structuredClone && !fails(function () {
	  // prevent V8 ArrayBufferDetaching protector cell invalidation and performance degradation
	  // https://github.com/zloirock/core-js/issues/679
	  if ((ENVIRONMENT === 'DENO' && V8 > 92) || (ENVIRONMENT === 'NODE' && V8 > 94) || (ENVIRONMENT === 'BROWSER' && V8 > 97)) return false;
	  var buffer = new ArrayBuffer(8);
	  var clone = structuredClone(buffer, { transfer: [buffer] });
	  return buffer.byteLength !== 0 || clone.byteLength !== 8;
	});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toPrimitive = __webpack_require__(298);
	
	var $TypeError = TypeError;
	
	// `ToBigInt` abstract operation
	// https://tc39.es/ecma262/#sec-tobigint
	module.exports = function (argument) {
	  var prim = toPrimitive(argument, 'number');
	  if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
	  // eslint-disable-next-line es/no-bigint -- safe
	  return BigInt(prim);
	};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(44);
	var toLength = __webpack_require__(76);
	
	var $RangeError = RangeError;
	
	// `ToIndex` abstract operation
	// https://tc39.es/ecma262/#sec-toindex
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toIntegerOrInfinity(it);
	  var length = toLength(number);
	  if (number !== length) throw new $RangeError('Wrong length or index');
	  return length;
	};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(27);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};
	
	test[TO_STRING_TAG] = 'z';
	
	module.exports = String(test) === '[object z]';


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable no-new, sonar/inconsistent-function-call -- required for testing */
	var globalThis = __webpack_require__(9);
	var fails = __webpack_require__(6);
	var checkCorrectnessOfIteration = __webpack_require__(277);
	var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(26).NATIVE_ARRAY_BUFFER_VIEWS;
	
	var ArrayBuffer = globalThis.ArrayBuffer;
	var Int8Array = globalThis.Int8Array;
	
	module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
	  Int8Array(1);
	}) || !fails(function () {
	  new Int8Array(-1);
	}) || !checkCorrectnessOfIteration(function (iterable) {
	  new Int8Array();
	  new Int8Array(null);
	  new Int8Array(1.5);
	  new Int8Array(iterable);
	}, true) || fails(function () {
	  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
	  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
	});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var exec = __webpack_require__(418);
	
	// `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec
	$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
	  exec: exec
	});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * cssfilter
	 *
	 * @author 老雷<leizongmin@gmail.com>
	 */
	
	var DEFAULT = __webpack_require__(706);
	var FilterCSS = __webpack_require__(1546);
	
	
	/**
	 * XSS过滤
	 *
	 * @param {String} css 要过滤的CSS代码
	 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
	 * @return {String}
	 */
	function filterCSS (html, options) {
	  var xss = new FilterCSS(options);
	  return xss.process(html);
	}
	
	
	// 输出
	exports = module.exports = filterCSS;
	exports.FilterCSS = FilterCSS;
	for (var i in DEFAULT) exports[i] = DEFAULT[i];
	
	// 在浏览器端使用
	if (typeof window !== 'undefined') {
	  window.filterCSS = module.exports;
	}


/***/ }),
/* 433 */
[2338, 434, 712, 195, 728],
/* 434 */
[2340, 246],
/* 435 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var R = typeof Reflect === 'object' ? Reflect : null
	var ReflectApply = R && typeof R.apply === 'function'
	  ? R.apply
	  : function ReflectApply(target, receiver, args) {
	    return Function.prototype.apply.call(target, receiver, args);
	  }
	
	var ReflectOwnKeys
	if (R && typeof R.ownKeys === 'function') {
	  ReflectOwnKeys = R.ownKeys
	} else if (Object.getOwnPropertySymbols) {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target)
	      .concat(Object.getOwnPropertySymbols(target));
	  };
	} else {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target);
	  };
	}
	
	function ProcessEmitWarning(warning) {
	  if (console && console.warn) console.warn(warning);
	}
	
	var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
	  return value !== value;
	}
	
	function EventEmitter() {
	  EventEmitter.init.call(this);
	}
	module.exports = EventEmitter;
	module.exports.once = once;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._eventsCount = 0;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;
	
	function checkListener(listener) {
	  if (typeof listener !== 'function') {
	    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	  }
	}
	
	Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	  enumerable: true,
	  get: function() {
	    return defaultMaxListeners;
	  },
	  set: function(arg) {
	    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
	      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
	    }
	    defaultMaxListeners = arg;
	  }
	});
	
	EventEmitter.init = function() {
	
	  if (this._events === undefined ||
	      this._events === Object.getPrototypeOf(this)._events) {
	    this._events = Object.create(null);
	    this._eventsCount = 0;
	  }
	
	  this._maxListeners = this._maxListeners || undefined;
	};
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
	    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
	  }
	  this._maxListeners = n;
	  return this;
	};
	
	function _getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}
	
	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return _getMaxListeners(this);
	};
	
	EventEmitter.prototype.emit = function emit(type) {
	  var args = [];
	  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
	  var doError = (type === 'error');
	
	  var events = this._events;
	  if (events !== undefined)
	    doError = (doError && events.error === undefined);
	  else if (!doError)
	    return false;
	
	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    var er;
	    if (args.length > 0)
	      er = args[0];
	    if (er instanceof Error) {
	      // Note: The comments on the `throw` lines are intentional, they show
	      // up in Node's output if this results in an unhandled exception.
	      throw er; // Unhandled 'error' event
	    }
	    // At least give some kind of context to the user
	    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
	    err.context = er;
	    throw err; // Unhandled 'error' event
	  }
	
	  var handler = events[type];
	
	  if (handler === undefined)
	    return false;
	
	  if (typeof handler === 'function') {
	    ReflectApply(handler, this, args);
	  } else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      ReflectApply(listeners[i], this, args);
	  }
	
	  return true;
	};
	
	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;
	
	  checkListener(listener);
	
	  events = target._events;
	  if (events === undefined) {
	    events = target._events = Object.create(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener !== undefined) {
	      target.emit('newListener', type,
	                  listener.listener ? listener.listener : listener);
	
	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }
	
	  if (existing === undefined) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	        prepend ? [listener, existing] : [existing, listener];
	      // If we've already got an array, just append.
	    } else if (prepend) {
	      existing.unshift(listener);
	    } else {
	      existing.push(listener);
	    }
	
	    // Check for listener leak
	    m = _getMaxListeners(target);
	    if (m > 0 && existing.length > m && !existing.warned) {
	      existing.warned = true;
	      // No error code for this since it is a Warning
	      // eslint-disable-next-line no-restricted-syntax
	      var w = new Error('Possible EventEmitter memory leak detected. ' +
	                          existing.length + ' ' + String(type) + ' listeners ' +
	                          'added. Use emitter.setMaxListeners() to ' +
	                          'increase limit');
	      w.name = 'MaxListenersExceededWarning';
	      w.emitter = target;
	      w.type = type;
	      w.count = existing.length;
	      ProcessEmitWarning(w);
	    }
	  }
	
	  return target;
	}
	
	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };
	
	function onceWrapper() {
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    if (arguments.length === 0)
	      return this.listener.call(this.target);
	    return this.listener.apply(this.target, arguments);
	  }
	}
	
	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = onceWrapper.bind(state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}
	
	EventEmitter.prototype.once = function once(type, listener) {
	  checkListener(listener);
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};
	
	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      checkListener(listener);
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };
	
	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;
	
	      checkListener(listener);
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      list = events[type];
	      if (list === undefined)
	        return this;
	
	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = Object.create(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;
	
	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0)
	          return this;
	
	        if (position === 0)
	          list.shift();
	        else {
	          spliceOne(list, position);
	        }
	
	        if (list.length === 1)
	          events[type] = list[0];
	
	        if (events.removeListener !== undefined)
	          this.emit('removeListener', type, originalListener || listener);
	      }
	
	      return this;
	    };
	
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	
	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      // not listening for removeListener, no need to emit
	      if (events.removeListener === undefined) {
	        if (arguments.length === 0) {
	          this._events = Object.create(null);
	          this._eventsCount = 0;
	        } else if (events[type] !== undefined) {
	          if (--this._eventsCount === 0)
	            this._events = Object.create(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }
	
	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = Object.keys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = Object.create(null);
	        this._eventsCount = 0;
	        return this;
	      }
	
	      listeners = events[type];
	
	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners !== undefined) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }
	
	      return this;
	    };
	
	function _listeners(target, type, unwrap) {
	  var events = target._events;
	
	  if (events === undefined)
	    return [];
	
	  var evlistener = events[type];
	  if (evlistener === undefined)
	    return [];
	
	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
	
	  return unwrap ?
	    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}
	
	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};
	
	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};
	
	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;
	
	  if (events !== undefined) {
	    var evlistener = events[type];
	
	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener !== undefined) {
	      return evlistener.length;
	    }
	  }
	
	  return 0;
	}
	
	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	};
	
	function arrayClone(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}
	
	function spliceOne(list, index) {
	  for (; index + 1 < list.length; index++)
	    list[index] = list[index + 1];
	  list.pop();
	}
	
	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}
	
	function once(emitter, name) {
	  return new Promise(function (resolve, reject) {
	    function errorListener(err) {
	      emitter.removeListener(name, resolver);
	      reject(err);
	    }
	
	    function resolver() {
	      if (typeof emitter.removeListener === 'function') {
	        emitter.removeListener('error', errorListener);
	      }
	      resolve([].slice.call(arguments));
	    };
	
	    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
	    if (name !== 'error') {
	      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
	    }
	  });
	}
	
	function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
	  if (typeof emitter.on === 'function') {
	    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
	  }
	}
	
	function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
	  if (typeof emitter.on === 'function') {
	    if (flags.once) {
	      emitter.once(name, listener);
	    } else {
	      emitter.on(name, listener);
	    }
	  } else if (typeof emitter.addEventListener === 'function') {
	    // EventTarget does not have `error` event semantics like Node
	    // EventEmitters, we do not listen for `error` events here.
	    emitter.addEventListener(name, function wrapListener(arg) {
	      // IE does not have builtin `{ once: true }` support so we
	      // have to do it manually.
	      if (flags.once) {
	        emitter.removeEventListener(name, wrapListener);
	      }
	      listener(arg);
	    });
	  } else {
	    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
	  }
	}


/***/ }),
/* 436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"b2bCompanyModule":"lHlyySeUhX9eLfSEjW0-7","b2bCompany":"_3aC0ryK9OpxBY86k09qGOJ","mainTitleDiv":"_34nodtJeMn59FrmSr1TI1R","mainTitleContainer":"_1B1mHbgk55Mtpcwa9Fq6ep","mainTitle":"_1py8nvT2QwYfopXEcFn1qy","officeNumber":"_2FkAhOupxDlmVDdIMx1IuX","Navigation":"_3zwm0jRF7d0mLwU7471z1W","headingDiv":"_10eAVl-mz31UVYfvY-LdnM","headingCell":"_29Ytnb7GLA4bvwQDukA6V3","active":"_1tmJ3r6hCSZlg1rjR1Q6qz","clientsSearchContainer":"L0p1kgjqBs1osG6-709Vv","hidden":"vLri3ZKPcPrImW9cEQ1O_","brokerSelectorContainer":"_2I3oBOFWZ6AQllCXNO6l9L","column":"_2gSpI2GjBKXG51IUteHVGz","brokerSelectorContent":"_3CuSVr0nKQNBHREt4CBlH-","label":"Jo1Ql-EXbBisVHSfq7ZuY","brokerSelector":"_3uwfGB_WpudvseD48bV05x","searchSubSubTitle":"_3iazFCvpN3sg_VdvluGGfi","formContainer":"_1T_q39BYGOPZ4HT-PAj65R","searchContainer":"NCBVzbh2j_TUZ6hRNJrHP","clientSearchInput":"_2FiWnHvLdK1sWQZPSZds0g","clientSearchButtonContainer":"_3QPgFOnOFYZzNpZ2CiLNfm","greyButton":"_2fRmCJ1lEwSuFlrq8ymxO7","left":"_2lPGmNhF7_0vOkkHfWgkG8","customCreateModal":"_7cwNUXiPtBEc9TftoeTeu","isOpened":"dI9UInc0Nk2jjIzhpwXsn","overlayMap":"_3tV1I-zh4NyzChP1N7Iaco"};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"claimsMain":"_3Qv3kUeFW3osLnL4Qwtmsc","claimsSearchContainer":"_24qo13reTCDtsUSLdAoh9m","hidden":"PPsYiFJThMXlCznSSrqOG","formContainer":"OkiLPk6_iGqCfuWlwoSnR","column":"_2ICH6aEWURso2jTbBGsWQh","searchContainer":"_2fScsv-JdumQ7hudtgH4A3","label":"_1FlmOqvPOBg0wH40_BRAp8","claimsSearchInput":"AmGO7Qnbrb0Kt2seyKepL","dropContainer":"_3KKk5KU7K06m2m0Tu3dndy","dropdown":"_3pxWpDCgHffUGkQNR7noTi","claimsSearchDropdown":"THDbMSeds2dpJiYpLiyJT","subNavContainer":"s0kqh5ltmnZZA-TFYbPEh","tab":"_2mwH9rXJXLymGTFML-5Lqa","active":"MmcsFojdUzP59ObzLguv_","greyButton":"_3hM0W3HY8rclTL6FeEVfHt","reactable-pagination":"_2dtVgHxIGt_w6O3OCt3GSY","claimsZoomContainer":"_2Szpr-wF_TUEAFcUA9qOm6"};

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"formContent":"A0jSq3VlFzPNFtejkUj5j","saveNotification":"_3ZEFkm0qCADv5q1oglMfWs","saveNotificationSmall":"_3B3arUDtAoPeXKJLZmWxEt","formInputContainer":"_1xxFmMbOIhVrusGt_Fw2Bi","titleLabel":"_3lniAczUkrrkUUL6V_wT_8","formLabel":"YdWhF5KyCNOdrvfPmb2o1","formInput":"_2zh3lUBU64ROeXCRje5qx1","formInputWithError":"jJzCipKnXged_uUnNsRze","errorMessageContainer":"_3s5xTa4Mwy6eB8WMi_WpjH","formCheckbox":"_3bU1HCB0Wyjz_hrywamLiw","shortMargin":"_1dS00Rjlb1IRhVr2R6Ktqx","errorMessage":"_3jMaqGjIvR7uVu2YSmlswQ","formInputCreatableSelect":"Q8lwNveMcmbTIStjin9wz","sizeS":"_2c9DL8ySIxU38URfkiB42L","sizeXS":"_1UZfboCrUsjwXt37drYgme","formInputText":"_2mkSaxxcMIS1LZB3wx8FJ6","fixIEHorizontals":"_2kj0LI1UVbX4yZeA_HMTVX","sizeL":"_3PDYxHr9aVuwHMOjojXvDv","sizeM":"CAHzW_1hsIac1JybbJ7X_","sizeMS":"_2BMio932vuJP0f-xSTtEyP","icon":"_2FKRL6OAiNlLjCJCpWoisT","iconMargined":"_3EDtW3LvlKtmsVNSrFb_va","tooltip":"_23JKSNJAZyKABaan6Yks9H","tooltiptext":"F_aiF6TjIt861gjpLbkd8","w500":"_22FsUmQiU9DCdT0EnVwbay","w600":"_21U_F-M7Bu_rZtx4Yn8O2N","buttonContainer":"_2V9hzD-JJx8dNAZD-46myF","greyButton":"_2W_Rx8oH4qQ4u0Q9gXTp7N","enabled":"I7M3PBgl_OG-ROj0v62V6","buttonSizeM":"_3yZhUNMwvQ71JKsSElVWfT"};

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"borderedImage":"cHJicg42PC3zkWYTumxdQ","buttonsContainer":"_2maJ-DcEvZb4bGB8XNR9Nx","greyButton":"eJu4FGouPK2tbSsR8scoI","enabled":"bstS1pUCXLAn6lTKpgO8x","clearTableBorder":"_3lk63M9vP5Fmx8l6yDCAAo","dateWidth":"h2wat_BtjLmEh9VVM6zGg","buttons":"_2mPvj2wn8cKRNcfz7GLMQN","next":"_30army06eNCKj9MyOgGHnK","buttonGreen":"_3jhAIKXsb2GdC_PPHEs_bu","signatureForm":"_2lZtwdnbZNfTvCsjYPxBmN","formGroup":"_2XYZgYSrdnm8CDTs_Kfi37","subline":"_3SG28KZpv6b1EE3QHKGqjZ","inARow":"MOliYWo2mSoTY_Cplbl2P","note":"_27KGLNgeZnfxNJhx8tGeB8","formLabel":"VcRmdpQsIBkJnZRFaQ-ay","inputHolder":"KN1iZQWm6EqGSlBLo86To","formInput":"_1Qb6UuPow764GcLFvcb2Dr","textInput":"_1_NyNi9Z_fEa1_K6h4lX6Q","errorMessage":"_2jEOfUCh4SCGBVXigPBflI","onlyValue":"_1IDrYR8_IAX3yh8Lm5Fm2O","sizeM":"_3RR55tPwFJ56WdPG4Md_Go","sizeS":"_2TwrS0-s553QeMlMQ3KHGH","sizeXS":"Gp0FN_2FMxwu-JL4QHTNN","cancelButton":"_16CTwszz3O8uV_DFKhXLrZ","htmlTableHolder":"_2DerQJuFFpScPejrzydsST","tableSignatureField":"_3sKxM1z-Zn9t6eup6EvlAg","tableDateField":"q6mE_8asrTPxGINXjOWEp"};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"outboxModule":"_29i_Hj4OKfrz5s9JGI-diB","mainTitleDiv":"XgqOrpl0_vR4HphOflK2f","moduleControls":"_3XwDDfPgYEAxmvmLoCHg9e","backToList":"ttH-KhN_GstsvvdgENXB4","hidden":"_1gDMFoxK2YmcXgrcNM591Z","mainTitleContainer":"_3-pqVPV0S7FvoGTolMTCCj","mainTitle":"_1CgG-M8SdE_GVc2hn4IXTt","results":"nnjrsZLcla39daxN5MIJq","datePickerContainer":"_20bTpvsx3pCCe1RMUtqGmT","submitContainer":"_3128Gcus-i92eN0JSzt8mT","inputContainer":"_3zd4QiZv9ue_ayF9CFSKPx","label":"RMd3FT-kwm7OGsGSYmauL","inputSubmit":"_279ryyL7vbBih7rBw-6mBE","inputForm":"_3warh1vqUSxL_DYemC0Nqg","fixDatePickerSize":"_15OqcoycFHwrbA6LCmkSPB","selectStyle":"_19iQqv9C2NWQ9BW-tR8GUt","statusFailed":"_1evJeyy6xguR3CBMgz4sk5","statusResent":"_2-EpigCuaP_1-5_tgP3fEM","buttonContainer":"_29xoqqcpmIbcgU0iy8Rofq","greyButton":"_2UXVbGzQNCSk14ZDjmkNAJ","enabled":"mPCN0xcgZIKeWs98BjdcQ","failedUnSeen":"_1hBI8FxWDZxIbz_yIcxO4z","trFirstColumnHidden":"_1XFVA-Oqvze9vmhpFl2Zqo","subject":"_3bBwQQtdnKRPyKK5XUNin","toEmailAddress":"_10Aqje5M-hcfiqSpo_gSCr","from":"_1zFu2CjVRIZubRgyLi0La5","content":"_2IsAPEl9ilbljgZXbbVn6J","attachments":"_2IrtO93s8d6dmBL7OdRAHR","archiveModalContent":"_28WPxK-UtLeZW0JjwYyNIy","archiveModalButtons":"_12eWytu83ciERhxO8CjvIJ","cancel":"gLZ-Vad1dSaINYVQ2GeXN","title":"C4Utcc1B0YAWxXUpHW-ee","message":"_1ed5ReFWbSFFdsZcePePfv","emailBodyContainer":"_3gwDjHbSAknk_sZxIrtkwv","resendModalContainer":"_19IEewFdoaZ18FCLjaHgm2","formInputContainer":"_3C1MFADc2-zo3yAISEZDCc","formLabel":"_2aPQTwHE4h9TTnTTUMNCOZ","formInput":"_38YLjWwF_vH_QXWlRsVBcm","ieFixHeight":"_2xdC34sFkZ4gVwcHTbPlU1","width3":"_2Z-QEzeh6v3WHZxlOm_AfA","width7":"_1HaHvEMj9QSqrnuofXoOMP","errorMessage":"_2P6-piKWyhQlaXnW54f7pu","regenerateButton":"_1NksO2LLRDm-fUdWS5RpLw","regenerateButtonIcon":"QO_IFIfdjwi9nIGUaQqv_"};

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"itemsContainer":"_1aJqQPALOOZU94_WTPq4ft","item":"_2nPesKR_LkwwhmHxI1FT44","imageContainer":"_2UyXGgdsOv2-4L7urexShs","descContainer":"_1CAHcftOAKOyxk28vnLUEo","docFillerContainer":"nhSA-uZMUX4j4xHULYAQQ","iframeContainer":"_3E5wkVn4vy4eVbUeF2a4HY","maxHeight":"yuQ97Jeantl0B4IU0KSyG","mainSubDiv":"_3oZk6YSMjBzBzHE0YMvQt","itemFlex":"_30iWv39tiNSlWCtbfdVlXO","webAppForm":"GgHk8yS5NuC9to0DlD5Ox","formInputContainer":"_2Jt1sMP3x0jrI84qRhiVE9","formLabel":"dUFy5RzA85zM3jvAOAbGY","formInput":"_1N2F7RS0TXmshcEgUXtFxg","formInputText":"_1cJsqlceamfjWyCzyoc96T","formInputCreatableSelect":"_1YdWSFELGq7A7xphgxokxU","sizeS":"zEaTT8Ps6FzIdPJTwgvWv","sizeXS":"_2z6swOumQM6z2u2wIHRzvd"};

/***/ }),
/* 442 */
[2341, 1661],
/* 443 */
[2344, 434],
/* 444 */
[2346, 729],
/* 445 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = [{"countryName":"Afghanistan","phoneCode":"0093"},{"countryName":"Åland Islands","phoneCode":"00358"},{"countryName":"Albania","phoneCode":"00355"},{"countryName":"Algeria","phoneCode":"00213"},{"countryName":"American Samoa","phoneCode":"001684"},{"countryName":"Andorra","phoneCode":"00376"},{"countryName":"Angola","phoneCode":"00244"},{"countryName":"Anguilla","phoneCode":"001264"},{"countryName":"Antarctica","phoneCode":"00672"},{"countryName":"Antigua and Barbuda","phoneCode":"001268"},{"countryName":"Argentina","phoneCode":"0054"},{"countryName":"Armenia","phoneCode":"00374"},{"countryName":"Aruba","phoneCode":"00297"},{"countryName":"Australia","phoneCode":"0061"},{"countryName":"Austria","phoneCode":"0043"},{"countryName":"Azerbaijan","phoneCode":"00994"},{"countryName":"Bahamas","phoneCode":"001242"},{"countryName":"Bahrain","phoneCode":"00973"},{"countryName":"Bangladesh","phoneCode":"00880"},{"countryName":"Barbados","phoneCode":"001246"},{"countryName":"Belarus","phoneCode":"00375"},{"countryName":"Belgium","phoneCode":"0032"},{"countryName":"Belize","phoneCode":"00501"},{"countryName":"Benin","phoneCode":"00229"},{"countryName":"Bermuda","phoneCode":"001441"},{"countryName":"Bhutan","phoneCode":"00975"},{"countryName":"Bolivia, Plurinational State of bolivia","phoneCode":"00591"},{"countryName":"Bosnia and Herzegovina","phoneCode":"00387"},{"countryName":"Botswana","phoneCode":"00267"},{"countryName":"Bouvet Island","phoneCode":"0047"},{"countryName":"Brazil","phoneCode":"0055"},{"countryName":"British Indian Ocean Territory","phoneCode":"00246"},{"countryName":"Brunei Darussalam","phoneCode":"00673"},{"countryName":"Bulgaria","phoneCode":"00359"},{"countryName":"Burkina Faso","phoneCode":"00226"},{"countryName":"Burundi","phoneCode":"00257"},{"countryName":"Cambodia","phoneCode":"00855"},{"countryName":"Cameroon","phoneCode":"00237"},{"countryName":"Canada","phoneCode":"001"},{"countryName":"Cape Verde","phoneCode":"00238"},{"countryName":"Cayman Islands","phoneCode":"00345"},{"countryName":"Central African Republic","phoneCode":"00236"},{"countryName":"Chad","phoneCode":"00235"},{"countryName":"Chile","phoneCode":"0056"},{"countryName":"China","phoneCode":"0086"},{"countryName":"Christmas Island","phoneCode":"0061"},{"countryName":"Cocos (Keeling) Islands","phoneCode":"0061"},{"countryName":"Colombia","phoneCode":"0057"},{"countryName":"Comoros","phoneCode":"00269"},{"countryName":"Congo","phoneCode":"00242"},{"countryName":"Congo, The Democratic Republic of the Congo","phoneCode":"00243"},{"countryName":"Cook Islands","phoneCode":"00682"},{"countryName":"Costa Rica","phoneCode":"00506"},{"countryName":"Cote d'Ivoire","phoneCode":"00225"},{"countryName":"Croatia","phoneCode":"00385"},{"countryName":"Cuba","phoneCode":"0053"},{"countryName":"Cyprus","phoneCode":"00357"},{"countryName":"Czech Republic","phoneCode":"00420"},{"countryName":"Denmark","phoneCode":"0045"},{"countryName":"Djibouti","phoneCode":"00253"},{"countryName":"Dominica","phoneCode":"001767"},{"countryName":"Dominican Republic","phoneCode":"001849"},{"countryName":"Ecuador","phoneCode":"00593"},{"countryName":"Egypt","phoneCode":"0020"},{"countryName":"El Salvador","phoneCode":"00503"},{"countryName":"Equatorial Guinea","phoneCode":"00240"},{"countryName":"Eritrea","phoneCode":"00291"},{"countryName":"Estonia","phoneCode":"00372"},{"countryName":"Ethiopia","phoneCode":"00251"},{"countryName":"Falkland Islands (Malvinas)","phoneCode":"00500"},{"countryName":"Faroe Islands","phoneCode":"00298"},{"countryName":"Fiji","phoneCode":"00679"},{"countryName":"Finland","phoneCode":"00358"},{"countryName":"France","phoneCode":"0033"},{"countryName":"French Guiana","phoneCode":"00594"},{"countryName":"French Polynesia","phoneCode":"00689"},{"countryName":"French Southern Territories","phoneCode":"00262"},{"countryName":"Gabon","phoneCode":"00241"},{"countryName":"Gambia","phoneCode":"00220"},{"countryName":"Georgia","phoneCode":"00995"},{"countryName":"Germany","phoneCode":"0049"},{"countryName":"Ghana","phoneCode":"00233"},{"countryName":"Gibraltar","phoneCode":"00350"},{"countryName":"Greece","phoneCode":"0030"},{"countryName":"Greenland","phoneCode":"00299"},{"countryName":"Grenada","phoneCode":"001473"},{"countryName":"Guadeloupe","phoneCode":"00590"},{"countryName":"Guam","phoneCode":"001671"},{"countryName":"Guatemala","phoneCode":"00502"},{"countryName":"Guernsey","phoneCode":"0044"},{"countryName":"Guinea","phoneCode":"00224"},{"countryName":"Guinea-Bissau","phoneCode":"00245"},{"countryName":"Guyana","phoneCode":"00592"},{"countryName":"Haiti","phoneCode":"00509"},{"countryName":"Heard Island and Mcdonald Islands","phoneCode":"000"},{"countryName":"Holy See (Vatican City State)","phoneCode":"00379"},{"countryName":"Honduras","phoneCode":"00504"},{"countryName":"Hong Kong","phoneCode":"00852"},{"countryName":"Hungary","phoneCode":"0036"},{"countryName":"Iceland","phoneCode":"00354"},{"countryName":"India","phoneCode":"0091"},{"countryName":"Indonesia","phoneCode":"0062"},{"countryName":"Iran, Islamic Republic of Persian Gulf","phoneCode":"0098"},{"countryName":"Iraq","phoneCode":"00964"},{"countryName":"Ireland","phoneCode":"00353"},{"countryName":"Isle of Man","phoneCode":"0044"},{"countryName":"Israel","phoneCode":"00972"},{"countryName":"Italy","phoneCode":"0039"},{"countryName":"Jamaica","phoneCode":"001876"},{"countryName":"Japan","phoneCode":"0081"},{"countryName":"Jersey","phoneCode":"0044"},{"countryName":"Jordan","phoneCode":"00962"},{"countryName":"Kazakhstan","phoneCode":"007"},{"countryName":"Kenya","phoneCode":"00254"},{"countryName":"Kiribati","phoneCode":"00686"},{"countryName":"Korea, Democratic People's Republic of Korea","phoneCode":"00850"},{"countryName":"Korea, Republic of South Korea","phoneCode":"0082"},{"countryName":"Kosovo","phoneCode":"00383"},{"countryName":"Kuwait","phoneCode":"00965"},{"countryName":"Kyrgyzstan","phoneCode":"00996"},{"countryName":"Laos","phoneCode":"00856"},{"countryName":"Latvia","phoneCode":"00371"},{"countryName":"Lebanon","phoneCode":"00961"},{"countryName":"Lesotho","phoneCode":"00266"},{"countryName":"Liberia","phoneCode":"00231"},{"countryName":"Libyan Arab Jamahiriya","phoneCode":"00218"},{"countryName":"Liechtenstein","phoneCode":"00423"},{"countryName":"Lithuania","phoneCode":"00370"},{"countryName":"Luxembourg","phoneCode":"00352"},{"countryName":"Macao","phoneCode":"00853"},{"countryName":"Macedonia","phoneCode":"00389"},{"countryName":"Madagascar","phoneCode":"00261"},{"countryName":"Malawi","phoneCode":"00265"},{"countryName":"Malaysia","phoneCode":"0060"},{"countryName":"Maldives","phoneCode":"00960"},{"countryName":"Mali","phoneCode":"00223"},{"countryName":"Malta","phoneCode":"00356"},{"countryName":"Marshall Islands","phoneCode":"00692"},{"countryName":"Martinique","phoneCode":"00596"},{"countryName":"Mauritania","phoneCode":"00222"},{"countryName":"Mauritius","phoneCode":"00230"},{"countryName":"Mayotte","phoneCode":"00262"},{"countryName":"Mexico","phoneCode":"0052"},{"countryName":"Micronesia, Federated States of Micronesia","phoneCode":"00691"},{"countryName":"Moldova","phoneCode":"00373"},{"countryName":"Monaco","phoneCode":"00377"},{"countryName":"Mongolia","phoneCode":"00976"},{"countryName":"Montenegro","phoneCode":"00382"},{"countryName":"Montserrat","phoneCode":"001664"},{"countryName":"Morocco","phoneCode":"00212"},{"countryName":"Mozambique","phoneCode":"00258"},{"countryName":"Myanmar","phoneCode":"0095"},{"countryName":"Namibia","phoneCode":"00264"},{"countryName":"Nauru","phoneCode":"00674"},{"countryName":"Nepal","phoneCode":"00977"},{"countryName":"Netherlands","phoneCode":"0031"},{"countryName":"Netherlands Antilles","phoneCode":"00599"},{"countryName":"New Caledonia","phoneCode":"00687"},{"countryName":"New Zealand","phoneCode":"0064"},{"countryName":"Nicaragua","phoneCode":"00505"},{"countryName":"Niger","phoneCode":"00227"},{"countryName":"Nigeria","phoneCode":"00234"},{"countryName":"Niue","phoneCode":"00683"},{"countryName":"Norfolk Island","phoneCode":"00672"},{"countryName":"Northern Mariana Islands","phoneCode":"001670"},{"countryName":"Norway","phoneCode":"0047"},{"countryName":"Oman","phoneCode":"00968"},{"countryName":"Pakistan","phoneCode":"0092"},{"countryName":"Palau","phoneCode":"00680"},{"countryName":"Palestinian Territory, Occupied","phoneCode":"00970"},{"countryName":"Panama","phoneCode":"00507"},{"countryName":"Papua New Guinea","phoneCode":"00675"},{"countryName":"Paraguay","phoneCode":"00595"},{"countryName":"Peru","phoneCode":"0051"},{"countryName":"Philippines","phoneCode":"0063"},{"countryName":"Pitcairn","phoneCode":"0064"},{"countryName":"Poland","phoneCode":"0048"},{"countryName":"Portugal","phoneCode":"00351"},{"countryName":"Puerto Rico","phoneCode":"001939"},{"countryName":"Qatar","phoneCode":"00974"},{"countryName":"Romania","phoneCode":"0040"},{"countryName":"Russia","phoneCode":"007"},{"countryName":"Rwanda","phoneCode":"00250"},{"countryName":"Reunion","phoneCode":"00262"},{"countryName":"Saint Barthelemy","phoneCode":"00590"},{"countryName":"Saint Helena, Ascension and Tristan Da Cunha","phoneCode":"00290"},{"countryName":"Saint Kitts and Nevis","phoneCode":"001869"},{"countryName":"Saint Lucia","phoneCode":"001758"},{"countryName":"Saint Martin","phoneCode":"00590"},{"countryName":"Saint Pierre and Miquelon","phoneCode":"00508"},{"countryName":"Saint Vincent and the Grenadines","phoneCode":"001784"},{"countryName":"Samoa","phoneCode":"00685"},{"countryName":"San Marino","phoneCode":"00378"},{"countryName":"Sao Tome and Principe","phoneCode":"00239"},{"countryName":"Saudi Arabia","phoneCode":"00966"},{"countryName":"Senegal","phoneCode":"00221"},{"countryName":"Serbia","phoneCode":"00381"},{"countryName":"Seychelles","phoneCode":"00248"},{"countryName":"Sierra Leone","phoneCode":"00232"},{"countryName":"Singapore","phoneCode":"0065"},{"countryName":"Slovakia","phoneCode":"00421"},{"countryName":"Slovenia","phoneCode":"00386"},{"countryName":"Solomon Islands","phoneCode":"00677"},{"countryName":"Somalia","phoneCode":"00252"},{"countryName":"South Africa","phoneCode":"0027"},{"countryName":"South Sudan","phoneCode":"00211"},{"countryName":"South Georgia and the South Sandwich Islands","phoneCode":"00500"},{"countryName":"Spain","phoneCode":"0034"},{"countryName":"Sri Lanka","phoneCode":"0094"},{"countryName":"Sudan","phoneCode":"00249"},{"countryName":"Suriname","phoneCode":"00597"},{"countryName":"Svalbard and Jan Mayen","phoneCode":"0047"},{"countryName":"Swaziland","phoneCode":"00268"},{"countryName":"Sweden","phoneCode":"0046"},{"countryName":"Switzerland","phoneCode":"0041"},{"countryName":"Syrian Arab Republic","phoneCode":"00963"},{"countryName":"Taiwan","phoneCode":"00886"},{"countryName":"Tajikistan","phoneCode":"00992"},{"countryName":"Tanzania, United Republic of Tanzania","phoneCode":"00255"},{"countryName":"Thailand","phoneCode":"0066"},{"countryName":"Timor-Leste","phoneCode":"00670"},{"countryName":"Togo","phoneCode":"00228"},{"countryName":"Tokelau","phoneCode":"00690"},{"countryName":"Tonga","phoneCode":"00676"},{"countryName":"Trinidad and Tobago","phoneCode":"001868"},{"countryName":"Tunisia","phoneCode":"00216"},{"countryName":"Turkey","phoneCode":"0090"},{"countryName":"Turkmenistan","phoneCode":"00993"},{"countryName":"Turks and Caicos Islands","phoneCode":"001649"},{"countryName":"Tuvalu","phoneCode":"00688"},{"countryName":"Uganda","phoneCode":"00256"},{"countryName":"Ukraine","phoneCode":"00380"},{"countryName":"United Arab Emirates","phoneCode":"00971"},{"countryName":"United Kingdom","phoneCode":"0044"},{"countryName":"United States","phoneCode":"001"},{"countryName":"Uruguay","phoneCode":"00598"},{"countryName":"Uzbekistan","phoneCode":"00998"},{"countryName":"Vanuatu","phoneCode":"00678"},{"countryName":"Venezuela, Bolivarian Republic of Venezuela","phoneCode":"0058"},{"countryName":"Vietnam","phoneCode":"0084"},{"countryName":"Virgin Islands, British","phoneCode":"001284"},{"countryName":"Virgin Islands, U.S.","phoneCode":"001340"},{"countryName":"Wallis and Futuna","phoneCode":"00681"},{"countryName":"Yemen","phoneCode":"00967"},{"countryName":"Zambia","phoneCode":"00260"},{"countryName":"Zimbabwe","phoneCode":"00263"}]

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(160),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1765),
	    mapCacheDelete = __webpack_require__(1766),
	    mapCacheGet = __webpack_require__(1767),
	    mapCacheHas = __webpack_require__(1768),
	    mapCacheSet = __webpack_require__(1769);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 449 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 452 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(763);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForRight = __webpack_require__(745),
	    keys = __webpack_require__(70);
	
	/**
	 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwnRight(object, iteratee) {
	  return object && baseForRight(object, iteratee, keys);
	}
	
	module.exports = baseForOwnRight;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(311),
	    baseIsEqual = __webpack_require__(317);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(250),
	    nativeKeys = __webpack_require__(1771);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(311),
	    assignMergeValue = __webpack_require__(740),
	    baseFor = __webpack_require__(453),
	    baseMergeDeep = __webpack_require__(1720),
	    isObject = __webpack_require__(56),
	    keysIn = __webpack_require__(71),
	    safeGet = __webpack_require__(780);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(736);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(1818),
	    overRest = __webpack_require__(778),
	    setToString = __webpack_require__(782);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(747),
	    getSymbolsIn = __webpack_require__(771),
	    keysIn = __webpack_require__(71);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(775),
	    keys = __webpack_require__(70);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(313),
	    stubArray = __webpack_require__(801);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(30),
	    isSymbol = __webpack_require__(206);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1704),
	    hasPath = __webpack_require__(772);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export
	
	var Collapse = __webpack_require__(1914).default;
	
	module.exports = Collapse;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _checkboard = __webpack_require__(1961);
	
	var checkboard = _interopRequireWildcard(_checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkboard = exports.Checkboard = function Checkboard(_ref) {
	  var white = _ref.white,
	      grey = _ref.grey,
	      size = _ref.size,
	      renderers = _ref.renderers,
	      borderRadius = _ref.borderRadius,
	      boxShadow = _ref.boxShadow,
	      children = _ref.children;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      grid: {
	        borderRadius: borderRadius,
	        boxShadow: boxShadow,
	        absolute: '0px 0px 0px 0px',
	        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
	      }
	    }
	  });
	  return (0, _react.isValidElement)(children) ? _react2.default.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : _react2.default.createElement('div', { style: styles.grid });
	};
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: 'transparent',
	  grey: 'rgba(0,0,0,.08)',
	  renderers: {}
	};
	
	exports.default = Checkboard;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(209);
	var Danger = __webpack_require__(1972);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(95);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(478);
	var setInnerHTML = __webpack_require__(337);
	var setTextContent = __webpack_require__(855);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactErrorUtils = __webpack_require__(476);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(35);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactPropTypesSecret = __webpack_require__(2001);
	var propTypesFactory = __webpack_require__(827);
	
	var React = __webpack_require__(166);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(35);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(21);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(123);
	var ReactInstanceMap = __webpack_require__(254);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactUpdates = __webpack_require__(104);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(35);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var emptyFunction = __webpack_require__(93);
	var warning = __webpack_require__(35);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	var CONSTANTS = {
	
	  // Positions
	  positions: {
	    tl: 'tl',
	    tr: 'tr',
	    tc: 'tc',
	    bl: 'bl',
	    br: 'br',
	    bc: 'bc'
	  },
	
	  // Levels
	  levels: {
	    success: 'success',
	    error: 'error',
	    warning: 'warning',
	    info: 'info'
	  },
	
	  // Notification defaults
	  notification: {
	    title: null,
	    message: null,
	    level: null,
	    position: 'tr',
	    autoDismiss: 5,
	    dismissible: 'both',
	    action: null
	  }
	};
	
	
	module.exports = CONSTANTS;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collapse = exports.collapseDuration = exports.Fade = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(883);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Fade = function Fade(_ref) {
	  var Tag = _ref.component,
	      _ref$duration = _ref.duration,
	      duration = _ref$duration === void 0 ? 1 : _ref$duration,
	      inProp = _ref.in,
	      onExited = _ref.onExited,
	      props = _objectWithoutProperties(_ref, ["component", "duration", "in", "onExited"]);
	
	  var transition = {
	    entering: {
	      opacity: 0
	    },
	    entered: {
	      opacity: 1,
	      transition: "opacity ".concat(duration, "ms")
	    },
	    exiting: {
	      opacity: 0
	    },
	    exited: {
	      opacity: 0
	    }
	  };
	  return _react.default.createElement(_reactTransitionGroup.Transition, {
	    mountOnEnter: true,
	    unmountOnExit: true,
	    in: inProp,
	    timeout: duration
	  }, function (state) {
	    var innerProps = {
	      style: _objectSpread({}, transition[state])
	    };
	    return _react.default.createElement(Tag, _extends({
	      innerProps: innerProps
	    }, props));
	  });
	}; // ==============================
	// Collapse Transition
	// ==============================
	
	
	exports.Fade = Fade;
	var collapseDuration = 260;
	exports.collapseDuration = collapseDuration;
	
	// wrap each MultiValue with a collapse transition; decreases width until
	// finally removing from DOM
	var Collapse =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Collapse, _Component);
	
	  function Collapse() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Collapse);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "duration", collapseDuration);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rafID", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      width: 'auto'
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transition", {
	      exiting: {
	        width: 0,
	        transition: "width ".concat(_this.duration, "ms ease-out")
	      },
	      exited: {
	        width: 0
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getWidth", function (ref) {
	      if (ref && isNaN(_this.state.width)) {
	        /*
	          Here we're invoking requestAnimationFrame with a callback invoking our
	          call to getBoundingClientRect and setState in order to resolve an edge case
	          around portalling. Certain portalling solutions briefly remove children from the DOM
	          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
	          while the Select component is in this state.
	        */
	        // cannot use `offsetWidth` because it is rounded
	        _this.rafID = window.requestAnimationFrame(function () {
	          var _ref$getBoundingClien = ref.getBoundingClientRect(),
	              width = _ref$getBoundingClien.width;
	
	          _this.setState({
	            width: width
	          });
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function (width) {
	      return {
	        overflow: 'hidden',
	        whiteSpace: 'nowrap',
	        width: width
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransition", function (state) {
	      return _this.transition[state];
	    });
	
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.rafID) {
	        window.cancelAnimationFrame(this.rafID);
	      }
	    } // width must be calculated; cannot transition from `undefined` to `number`
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          inProp = _this$props.in;
	      var width = this.state.width;
	      return _react.default.createElement(_reactTransitionGroup.Transition, {
	        enter: false,
	        mountOnEnter: true,
	        unmountOnExit: true,
	        in: inProp,
	        timeout: this.duration
	      }, function (state) {
	        var style = _objectSpread({}, _this2.getStyle(width), _this2.getTransition(state));
	
	        return _react.default.createElement("div", {
	          ref: _this2.getWidth,
	          style: style
	        }, children);
	      });
	    }
	  }]);
	
	  return Collapse;
	}(_react.Component);
	
	exports.Collapse = Collapse;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMenuPlacement = getMenuPlacement;
	exports.MenuPortal = exports.menuPortalCSS = exports.LoadingMessage = exports.NoOptionsMessage = exports.loadingMessageCSS = exports.noOptionsMessageCSS = exports.MenuList = exports.menuListCSS = exports.default = exports.MenuPlacer = exports.menuCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	var _reactDom = __webpack_require__(45);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _utils = __webpack_require__(344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getMenuPlacement(_ref) {
	  var maxHeight = _ref.maxHeight,
	      menuEl = _ref.menuEl,
	      minHeight = _ref.minHeight,
	      placement = _ref.placement,
	      shouldScroll = _ref.shouldScroll,
	      isFixedPosition = _ref.isFixedPosition,
	      theme = _ref.theme;
	  var spacing = theme.spacing;
	  var scrollParent = (0, _utils.getScrollParent)(menuEl);
	  var defaultState = {
	    placement: 'bottom',
	    maxHeight: maxHeight
	  }; // something went wrong, return default state
	
	  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
	  // the menu is rendered
	
	  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
	      scrollHeight = _scrollParent$getBoun.height;
	
	  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
	      menuBottom = _menuEl$getBoundingCl.bottom,
	      menuHeight = _menuEl$getBoundingCl.height,
	      menuTop = _menuEl$getBoundingCl.top;
	
	  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
	      containerTop = _menuEl$offsetParent$.top;
	
	  var viewHeight = window.innerHeight;
	  var scrollTop = (0, _utils.getScrollTop)(scrollParent);
	  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
	  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
	  var viewSpaceAbove = containerTop - marginTop;
	  var viewSpaceBelow = viewHeight - menuTop;
	  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
	  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
	  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
	  var scrollUp = scrollTop + menuTop - marginTop;
	  var scrollDuration = 160;
	
	  switch (placement) {
	    case 'auto':
	    case 'bottom':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceBelow >= menuHeight) {
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
	        }
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
	        } // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	
	        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
	        return {
	          placement: 'bottom',
	          maxHeight: constrainedHeight
	        };
	      } // 4. Forked beviour when there isn't enough space below
	      // AUTO: flip the menu, render above
	
	
	      if (placement === 'auto' || isFixedPosition) {
	        // may need to be constrained after flipping
	        var _constrainedHeight = maxHeight;
	        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
	
	        if (spaceAbove >= minHeight) {
	          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight
	        };
	      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
	
	
	      if (placement === 'bottom') {
	        (0, _utils.scrollTo)(scrollParent, scrollDown);
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      }
	
	      break;
	
	    case 'top':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceAbove >= menuHeight) {
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
	        }
	
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight2
	        };
	      } // 4. not enough space, the browser WILL NOT increase scrollable area when
	      // absolutely positioned element rendered above the viewport (only below).
	      // Flip the menu, render below
	
	
	      return {
	        placement: 'bottom',
	        maxHeight: maxHeight
	      };
	
	    default:
	      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
	  } // fulfil contract with flow: implicit return value of undefined
	
	
	  return defaultState;
	} // Menu Component
	// ------------------------------
	
	
	function alignToControl(placement) {
	  var placementToCSSProp = {
	    bottom: 'top',
	    top: 'bottom'
	  };
	  return placement ? placementToCSSProp[placement] : 'bottom';
	}
	
	var coercePlacement = function coercePlacement(p) {
	  return p === 'auto' ? 'bottom' : p;
	};
	
	var menuCSS = function menuCSS(_ref2) {
	  var _ref3;
	
	  var placement = _ref2.placement,
	      _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      spacing = _ref2$theme.spacing,
	      colors = _ref2$theme.colors;
	  return _ref3 = {
	    label: 'menu'
	  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
	}; // NOTE: internal only
	
	
	exports.menuCSS = menuCSS;
	
	var MenuPlacer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MenuPlacer, _Component);
	
	  function MenuPlacer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, MenuPlacer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      maxHeight: _this.props.maxMenuHeight,
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
	      var _this$props = _this.props,
	          minMenuHeight = _this$props.minMenuHeight,
	          maxMenuHeight = _this$props.maxMenuHeight,
	          menuPlacement = _this$props.menuPlacement,
	          menuPosition = _this$props.menuPosition,
	          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
	          theme = _this$props.theme;
	      var getPortalPlacement = _this.context.getPortalPlacement;
	      if (!ref) return; // DO NOT scroll if position is fixed
	
	      var isFixedPosition = menuPosition === 'fixed';
	      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
	      var state = getMenuPlacement({
	        maxHeight: maxMenuHeight,
	        menuEl: ref,
	        minHeight: minMenuHeight,
	        placement: menuPlacement,
	        shouldScroll: shouldScroll,
	        isFixedPosition: isFixedPosition,
	        theme: theme
	      });
	      if (getPortalPlacement) getPortalPlacement(state);
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
	      var menuPlacement = _this.props.menuPlacement;
	      var placement = _this.state.placement || coercePlacement(menuPlacement);
	      return _objectSpread({}, _this.props, {
	        placement: placement,
	        maxHeight: _this.state.maxHeight
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(MenuPlacer, [{
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return children({
	        ref: this.getPlacement,
	        placerProps: this.getUpdatedProps()
	      });
	    }
	  }]);
	
	  return MenuPlacer;
	}(_react.Component);
	
	exports.MenuPlacer = MenuPlacer;
	
	_defineProperty(MenuPlacer, "contextTypes", {
	  getPortalPlacement: _propTypes.default.func
	});
	
	var Menu = function Menu(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  var cn = cx(
	  /*#__PURE__*/
	  (0, _emotion.css)(getStyles('menu', props)), {
	    menu: true
	  }, className);
	  return _react.default.createElement("div", _extends({
	    className: cn
	  }, innerProps, {
	    ref: innerRef
	  }), children);
	};
	
	var _default = Menu; // ==============================
	// Menu List
	// ==============================
	
	exports.default = _default;
	
	var menuListCSS = function menuListCSS(_ref4) {
	  var maxHeight = _ref4.maxHeight,
	      baseUnit = _ref4.theme.spacing.baseUnit;
	  return {
	    maxHeight: maxHeight,
	    overflowY: 'auto',
	    paddingBottom: baseUnit,
	    paddingTop: baseUnit,
	    position: 'relative',
	    // required for offset[Height, Top] > keyboard scroll
	    WebkitOverflowScrolling: 'touch'
	  };
	};
	
	exports.menuListCSS = menuListCSS;
	
	var MenuList = function MenuList(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isMulti = props.isMulti,
	      innerRef = props.innerRef;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('menuList', props)), {
	      'menu-list': true,
	      'menu-list--is-multi': isMulti
	    }, className),
	    ref: innerRef
	  }, children);
	}; // ==============================
	// Menu Notices
	// ==============================
	
	
	exports.MenuList = MenuList;
	
	var noticeCSS = function noticeCSS(_ref5) {
	  var _ref5$theme = _ref5.theme,
	      baseUnit = _ref5$theme.spacing.baseUnit,
	      colors = _ref5$theme.colors;
	  return {
	    color: colors.neutral40,
	    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
	    textAlign: 'center'
	  };
	};
	
	var noOptionsMessageCSS = noticeCSS;
	exports.noOptionsMessageCSS = noOptionsMessageCSS;
	var loadingMessageCSS = noticeCSS;
	exports.loadingMessageCSS = loadingMessageCSS;
	
	var NoOptionsMessage = function NoOptionsMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('noOptionsMessage', props)), {
	      'menu-notice': true,
	      'menu-notice--no-options': true
	    }, className)
	  }, innerProps), children);
	};
	
	exports.NoOptionsMessage = NoOptionsMessage;
	NoOptionsMessage.defaultProps = {
	  children: 'No options'
	};
	
	var LoadingMessage = function LoadingMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('loadingMessage', props)), {
	      'menu-notice': true,
	      'menu-notice--loading': true
	    }, className)
	  }, innerProps), children);
	};
	
	exports.LoadingMessage = LoadingMessage;
	LoadingMessage.defaultProps = {
	  children: 'Loading...'
	}; // ==============================
	// Menu Portal
	// ==============================
	
	var menuPortalCSS = function menuPortalCSS(_ref6) {
	  var rect = _ref6.rect,
	      offset = _ref6.offset,
	      position = _ref6.position;
	  return {
	    left: rect.left,
	    position: position,
	    top: offset,
	    width: rect.width,
	    zIndex: 1
	  };
	};
	
	exports.menuPortalCSS = menuPortalCSS;
	
	var MenuPortal =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MenuPortal, _Component2);
	
	  function MenuPortal() {
	    var _getPrototypeOf3;
	
	    var _this2;
	
	    _classCallCheck(this, MenuPortal);
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
	      var placement = _ref7.placement;
	      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
	
	      if (placement !== initialPlacement) {
	        _this2.setState({
	          placement: placement
	        });
	      }
	    });
	
	    return _this2;
	  }
	
	  _createClass(MenuPortal, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        getPortalPlacement: this.getPortalPlacement
	      };
	    } // callback for occassions where the menu must "flip"
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          appendTo = _this$props2.appendTo,
	          children = _this$props2.children,
	          controlElement = _this$props2.controlElement,
	          menuPlacement = _this$props2.menuPlacement,
	          position = _this$props2.menuPosition,
	          getStyles = _this$props2.getStyles;
	      var isFixed = position === 'fixed'; // bail early if required elements aren't present
	
	      if (!appendTo && !isFixed || !controlElement) {
	        return null;
	      }
	
	      var placement = this.state.placement || coercePlacement(menuPlacement);
	      var rect = (0, _utils.getBoundingClientObj)(controlElement);
	      var scrollDistance = isFixed ? 0 : window.pageYOffset;
	      var offset = rect[placement] + scrollDistance;
	      var state = {
	        offset: offset,
	        position: position,
	        rect: rect
	      }; // same wrapper element whether fixed or portalled
	
	      var menuWrapper = _react.default.createElement("div", {
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('menuPortal', state))
	      }, children);
	
	      return appendTo ? (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper;
	    }
	  }]);
	
	  return MenuPortal;
	}(_react.Component);
	
	exports.MenuPortal = MenuPortal;
	
	_defineProperty(MenuPortal, "childContextTypes", {
	  getPortalPlacement: _propTypes.default.func
	});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultComponents = exports.components = void 0;
	
	var _containers = __webpack_require__(876);
	
	var _indicators = __webpack_require__(494);
	
	var _Control = _interopRequireDefault(__webpack_require__(869));
	
	var _Group = _interopRequireWildcard(__webpack_require__(870));
	
	var _Input = _interopRequireDefault(__webpack_require__(871));
	
	var _Menu = _interopRequireWildcard(__webpack_require__(492));
	
	var _MultiValue = _interopRequireWildcard(__webpack_require__(872));
	
	var _Option = _interopRequireDefault(__webpack_require__(873));
	
	var _Placeholder = _interopRequireDefault(__webpack_require__(874));
	
	var _SingleValue = _interopRequireDefault(__webpack_require__(875));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var components = {
	  ClearIndicator: _indicators.ClearIndicator,
	  Control: _Control.default,
	  DropdownIndicator: _indicators.DropdownIndicator,
	  DownChevron: _indicators.DownChevron,
	  CrossIcon: _indicators.CrossIcon,
	  Group: _Group.default,
	  GroupHeading: _Group.GroupHeading,
	  IndicatorsContainer: _containers.IndicatorsContainer,
	  IndicatorSeparator: _indicators.IndicatorSeparator,
	  Input: _Input.default,
	  LoadingIndicator: _indicators.LoadingIndicator,
	  Menu: _Menu.default,
	  MenuList: _Menu.MenuList,
	  MenuPortal: _Menu.MenuPortal,
	  LoadingMessage: _Menu.LoadingMessage,
	  NoOptionsMessage: _Menu.NoOptionsMessage,
	  MultiValue: _MultiValue.default,
	  MultiValueContainer: _MultiValue.MultiValueContainer,
	  MultiValueLabel: _MultiValue.MultiValueLabel,
	  MultiValueRemove: _MultiValue.MultiValueRemove,
	  Option: _Option.default,
	  Placeholder: _Placeholder.default,
	  SelectContainer: _containers.SelectContainer,
	  SingleValue: _SingleValue.default,
	  ValueContainer: _containers.ValueContainer
	};
	exports.components = components;
	
	var defaultComponents = function defaultComponents(props) {
	  return _objectSpread({}, components, props.components);
	};
	
	exports.defaultComponents = defaultComponents;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoadingIndicator = exports.loadingIndicatorCSS = exports.IndicatorSeparator = exports.indicatorSeparatorCSS = exports.ClearIndicator = exports.clearIndicatorCSS = exports.DropdownIndicator = exports.dropdownIndicatorCSS = exports.DownChevron = exports.CrossIcon = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// ==============================
	// Dropdown & Clear Icons
	// ==============================
	var Svg = function Svg(_ref) {
	  var size = _ref.size,
	      props = _objectWithoutProperties(_ref, ["size"]);
	
	  return _react.default.createElement("svg", _extends({
	    height: size,
	    width: size,
	    viewBox: "0 0 20 20",
	    "aria-hidden": "true",
	    focusable: "false",
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      display: 'inline-block',
	      fill: 'currentColor',
	      lineHeight: 1,
	      stroke: 'currentColor',
	      strokeWidth: 0
	    })
	  }, props));
	};
	
	var CrossIcon = function CrossIcon(props) {
	  return _react.default.createElement(Svg, _extends({
	    size: 20
	  }, props), _react.default.createElement("path", {
	    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
	  }));
	};
	
	exports.CrossIcon = CrossIcon;
	
	var DownChevron = function DownChevron(props) {
	  return _react.default.createElement(Svg, _extends({
	    size: 20
	  }, props), _react.default.createElement("path", {
	    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
	  }));
	}; // ==============================
	// Dropdown & Clear Buttons
	// ==============================
	
	
	exports.DownChevron = DownChevron;
	
	var baseCSS = function baseCSS(_ref2) {
	  var isFocused = _ref2.isFocused,
	      _ref2$theme = _ref2.theme,
	      baseUnit = _ref2$theme.spacing.baseUnit,
	      colors = _ref2$theme.colors;
	  return {
	    label: 'indicatorContainer',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    ':hover': {
	      color: isFocused ? colors.neutral80 : colors.neutral40
	    }
	  };
	};
	
	var dropdownIndicatorCSS = baseCSS;
	exports.dropdownIndicatorCSS = dropdownIndicatorCSS;
	
	var DropdownIndicator = function DropdownIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('dropdownIndicator', props)), {
	      'indicator': true,
	      'dropdown-indicator': true
	    }, className)
	  }), children || _react.default.createElement(DownChevron, null));
	};
	
	exports.DropdownIndicator = DropdownIndicator;
	var clearIndicatorCSS = baseCSS;
	exports.clearIndicatorCSS = clearIndicatorCSS;
	
	var ClearIndicator = function ClearIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('clearIndicator', props)), {
	      'indicator': true,
	      'clear-indicator': true
	    }, className)
	  }), children || _react.default.createElement(CrossIcon, null));
	}; // ==============================
	// Separator
	// ==============================
	
	
	exports.ClearIndicator = ClearIndicator;
	
	var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
	  var isDisabled = _ref3.isDisabled,
	      _ref3$theme = _ref3.theme,
	      baseUnit = _ref3$theme.spacing.baseUnit,
	      colors = _ref3$theme.colors;
	  return {
	    label: 'indicatorSeparator',
	    alignSelf: 'stretch',
	    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
	    marginBottom: baseUnit * 2,
	    marginTop: baseUnit * 2,
	    width: 1
	  };
	};
	
	exports.indicatorSeparatorCSS = indicatorSeparatorCSS;
	
	var IndicatorSeparator = function IndicatorSeparator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("span", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('indicatorSeparator', props)), {
	      'indicator-separator': true
	    }, className)
	  }));
	}; // ==============================
	// Loading
	// ==============================
	
	
	exports.IndicatorSeparator = IndicatorSeparator;
	var keyframesName = 'react-select-loading-indicator';
	var keyframesInjected = false;
	
	var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
	  var isFocused = _ref4.isFocused,
	      size = _ref4.size,
	      _ref4$theme = _ref4.theme,
	      colors = _ref4$theme.colors,
	      baseUnit = _ref4$theme.spacing.baseUnit;
	  return {
	    label: 'loadingIndicator',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    alignSelf: 'center',
	    fontSize: size,
	    lineHeight: 1,
	    marginRight: size,
	    textAlign: 'center',
	    verticalAlign: 'middle'
	  };
	};
	
	exports.loadingIndicatorCSS = loadingIndicatorCSS;
	
	var LoadingDot = function LoadingDot(_ref5) {
	  var color = _ref5.color,
	      delay = _ref5.delay,
	      offset = _ref5.offset;
	  return _react.default.createElement("span", {
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      animationDuration: '1s',
	      animationDelay: "".concat(delay, "ms"),
	      animationIterationCount: 'infinite',
	      animationName: keyframesName,
	      animationTimingFunction: 'ease-in-out',
	      backgroundColor: color,
	      borderRadius: '1em',
	      display: 'inline-block',
	      marginLeft: offset ? '1em' : null,
	      height: '1em',
	      verticalAlign: 'top',
	      width: '1em'
	    })
	  });
	};
	
	var LoadingIndicator = function LoadingIndicator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isFocused = props.isFocused,
	      isRtl = props.isRtl,
	      colors = props.theme.colors;
	  var color = isFocused ? colors.neutral80 : colors.neutral20;
	
	  if (!keyframesInjected) {
	    // eslint-disable-next-line no-unused-expressions
	    (0, _emotion.injectGlobal)("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");
	    keyframesInjected = true;
	  }
	
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('loadingIndicator', props)), {
	      'indicator': true,
	      'loading-indicator': true
	    }, className)
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 0,
	    offset: isRtl
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 160,
	    offset: true
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 320,
	    offset: !isRtl
	  }));
	};
	
	exports.LoadingIndicator = LoadingIndicator;
	LoadingIndicator.defaultProps = {
	  size: 4
	};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(45);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var NodeResolver =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(NodeResolver, _Component);
	
	  function NodeResolver() {
	    _classCallCheck(this, NodeResolver);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
	  }
	
	  _createClass(NodeResolver, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.innerRef((0, _reactDom.findDOMNode)(this));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.innerRef(null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return NodeResolver;
	}(_react.Component);
	
	exports.default = NodeResolver;

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	/* eslint-disable vars-on-top, no-var, prefer-template */
	var isRegExp = function (re) { 
	  return re instanceof RegExp;
	};
	var escapeRegExp = function escapeRegExp(string) {
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	    reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  return (string && reHasRegExpChar.test(string))
	    ? string.replace(reRegExpChar, '\\$&')
	    : string;
	};
	var isString = function (value) {
	  return typeof value === 'string';
	};
	var flatten = function (array) {
	  var newArray = [];
	
	  array.forEach(function (item) {
	    if (Array.isArray(item)) {
	      newArray = newArray.concat(item);
	    } else {
	      newArray.push(item);
	    }
	  });
	
	  return newArray;
	};
	
	/**
	 * Given a string, replace every substring that is matched by the `match` regex
	 * with the result of calling `fn` on matched substring. The result will be an
	 * array with all odd indexed elements containing the replacements. The primary
	 * use case is similar to using String.prototype.replace except for React.
	 *
	 * React will happily render an array as children of a react element, which
	 * makes this approach very useful for tasks like surrounding certain text
	 * within a string with react elements.
	 *
	 * Example:
	 * matchReplace(
	 *   'Emphasize all phone numbers like 884-555-4443.',
	 *   /([\d|-]+)/g,
	 *   (number, i) => <strong key={i}>{number}</strong>
	 * );
	 * // => ['Emphasize all phone numbers like ', <strong>884-555-4443</strong>, '.'
	 *
	 * @param {string} str
	 * @param {RegExp|str} match Must contain a matching group
	 * @param {function} fn
	 * @return {array}
	 */
	function replaceString(str, match, fn) {
	  var curCharStart = 0;
	  var curCharLen = 0;
	
	  if (str === '') {
	    return str;
	  } else if (!str || !isString(str)) {
	    throw new TypeError('First argument to react-string-replace#replaceString must be a string');
	  }
	
	  var re = match;
	
	  if (!isRegExp(re)) {
	    re = new RegExp('(' + escapeRegExp(re) + ')', 'gi');
	  }
	
	  var result = str.split(re);
	
	  // Apply fn to all odd elements
	  for (var i = 1, length = result.length; i < length; i += 2) {
	    /** @see {@link https://github.com/iansinnott/react-string-replace/issues/74} */
	    if (result[i] === undefined || result[i - 1] === undefined) {
	      console.warn('reactStringReplace: Encountered undefined value during string replacement. Your RegExp may not be working the way you expect.');
	      continue;
	    }
	
	    curCharLen = result[i].length;
	    curCharStart += result[i - 1].length;
	    result[i] = fn(result[i], i, curCharStart);
	    curCharStart += curCharLen;
	  }
	
	  return result;
	}
	
	module.exports = function reactStringReplace(source, match, fn) {
	  if (!Array.isArray(source)) source = [source];
	
	  return flatten(source.map(function(x) {
	    return isString(x) ? replaceString(x, match, fn) : x;
	  }));
	};


/***/ }),
/* 497 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SortDirection = {
	  /**
	   * Sort items in ascending order.
	   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
	   */
	  ASC: 'ASC',
	
	  /**
	   * Sort items in descending order.
	   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
	   */
	  DESC: 'DESC'
	};
	
	exports.default = SortDirection;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCallbackMemoizer;
	/**
	 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
	 */
	function createCallbackMemoizer() {
	  var requireAllKeys = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	  var cachedIndices = {};
	
	  return function (_ref) {
	    var callback = _ref.callback;
	    var indices = _ref.indices;
	
	    var keys = Object.keys(indices);
	    var allInitialized = !requireAllKeys || keys.every(function (key) {
	      var value = indices[key];
	      return Array.isArray(value) ? value.length > 0 : value >= 0;
	    });
	    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
	      var cachedValue = cachedIndices[key];
	      var value = indices[key];
	
	      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
	    });
	
	    cachedIndices = indices;
	
	    if (allInitialized && indexChanged) {
	      callback(indices);
	    }
	  };
	}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unsafe = __webpack_require__(347);
	
	var _libFilter_props_from = __webpack_require__(346);
	
	var Th = (function (_React$Component) {
	    _inherits(Th, _React$Component);
	
	    function Th() {
	        _classCallCheck(this, Th);
	
	        _get(Object.getPrototypeOf(Th.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Th, [{
	        key: 'render',
	        value: function render() {
	            var childProps = undefined;
	
	            if ((0, _unsafe.isUnsafe)(this.props.children)) {
	                return _react2['default'].createElement('th', _extends({}, (0, _libFilter_props_from.filterPropsFrom)(this.props), {
	                    dangerouslySetInnerHTML: { __html: this.props.children.toString() } }));
	            } else {
	                return _react2['default'].createElement(
	                    'th',
	                    (0, _libFilter_props_from.filterPropsFrom)(this.props),
	                    this.props.children
	                );
	            }
	        }
	    }]);
	
	    return Th;
	})(_react2['default'].Component);
	
	exports.Th = Th;
	;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(332);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(242));
	util.inherits = __webpack_require__(198);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(2322)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(909);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(352).Buffer;
	var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(908);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(167);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(167);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	
	  // reuse the free corkReq.
	  state.corkedRequestsFree.next = corkReq;
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103), __webpack_require__(512).setImmediate, (function() { return this; }())))

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(906);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(500);
	exports.Duplex = __webpack_require__(167);
	exports.Transform = __webpack_require__(907);
	exports.PassThrough = __webpack_require__(2165);


/***/ }),
/* 502 */
[2336, 505, 258, 2199, 214, 504],
/* 503 */
[2338, 504, 911, 214, 912],
/* 504 */
[2340, 258],
/* 505 */
[2341, 2177],
/* 506 */
[2344, 504],
/* 507 */
[2346, 913],
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(170);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
	var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
	var BLUR = exports.BLUR = 'redux-form/BLUR';
	var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
	var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
	var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
	var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
	var RESET = exports.RESET = 'redux-form/RESET';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
	var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
	var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
	var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
	var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapValues;
	/**
	 * Maps all the values in the given object through the given function and saves them, by key, to a result object
	 */
	function mapValues(obj, fn) {
	  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
	    var _extends2;
	
	    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
	  }, {}) : obj;
	}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initialState = exports.globalErrorKey = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _initialState, _behaviors;
	
	var _actionTypes = __webpack_require__(509);
	
	var _mapValues = __webpack_require__(510);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _read = __webpack_require__(939);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _write = __webpack_require__(940);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValuesFromState = __webpack_require__(936);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	var _initializeState = __webpack_require__(937);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	var _resetState = __webpack_require__(2219);
	
	var _resetState2 = _interopRequireDefault(_resetState);
	
	var _setErrors = __webpack_require__(2220);
	
	var _setErrors2 = _interopRequireDefault(_setErrors);
	
	var _fieldValue = __webpack_require__(216);
	
	var _normalizeFields = __webpack_require__(2215);
	
	var _normalizeFields2 = _interopRequireDefault(_normalizeFields);
	
	var _createInitialState = __webpack_require__(929);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var globalErrorKey = exports.globalErrorKey = '_error';
	
	var initialState = exports.initialState = (_initialState = {
	  _active: undefined,
	  _asyncValidating: false
	}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);
	
	var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
	  var path = _ref.path,
	      index = _ref.index,
	      value = _ref.value,
	      fields = _ref.fields;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
	  if (index === undefined) {
	    arrayCopy.push(newValue);
	  } else {
	    arrayCopy.splice(index, 0, newValue);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
	  var field = _ref2.field,
	      value = _ref2.value;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true }),
	        asyncError = _previous$value$autof.asyncError,
	        submitError = _previous$value$autof.submitError,
	        result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);
	
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
	  var field = _ref3.field,
	      value = _ref3.value,
	      touch = _ref3.touch;
	
	  var _active = state._active,
	      stateCopy = _objectWithoutProperties(state, ['_active']);
	
	  if (_active && _active !== field) {
	    // remove _active from state
	    stateCopy._active = _active;
	  }
	  return (0, _write2.default)(field, function (previous) {
	    var result = _extends({}, previous);
	    if (value !== undefined) {
	      result.value = value;
	    }
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, stateCopy);
	}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
	  var field = _ref4.field,
	      value = _ref4.value,
	      touch = _ref4.touch;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value = _extends({}, previous, { value: value }),
	        asyncError = _previous$value.asyncError,
	        submitError = _previous$value.submitError,
	        autofilled = _previous$value.autofilled,
	        result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);
	
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.DESTROY] = function () {
	  return undefined;
	}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
	  var field = _ref5.field;
	
	  var stateCopy = (0, _write2.default)(field, function (previous) {
	    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
	  }, state);
	  stateCopy._active = field;
	  return stateCopy;
	}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
	  var data = _ref6.data,
	      fields = _ref6.fields,
	      overwriteValues = _ref6.overwriteValues;
	
	  return (0, _createInitialState2.default)(data, fields, state, overwriteValues);
	}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
	  var path = _ref7.path,
	      index = _ref7.index;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  if (index === undefined) {
	    arrayCopy.pop();
	  } else if (isNaN(index)) {
	    delete arrayCopy[index];
	  } else {
	    arrayCopy.splice(index, 1);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.RESET] = function (state) {
	  var _extends2;
	
	  return _extends({}, (0, _resetState2.default)(state), (_extends2 = {
	    _active: undefined,
	    _asyncValidating: false
	  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = state._initialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
	  var field = _ref8.field;
	
	  return _extends({}, state, {
	    _asyncValidating: field || true
	  });
	}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	  return _extends({}, state, {
	    _submitting: true
	  });
	}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
	  var _extends3;
	
	  var errors = _ref9.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends3 = {
	    _asyncValidating: false
	  }, _extends3[globalErrorKey] = errors && errors[globalErrorKey], _extends3));
	}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
	  var _extends4;
	
	  var errors = _ref10.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends4 = {}, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4._submitting = false, _extends4._submitFailed = !!(errors && Object.keys(errors).length), _extends4));
	}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
	  return _extends({}, state, {
	    _submitFailed: true
	  });
	}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
	  var path = _ref11.path,
	      indexA = _ref11.indexA,
	      indexB = _ref11.indexB;
	
	  var array = (0, _read2.default)(path, state);
	  var arrayLength = array.length;
	  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
	    return state; // do nothing
	  }
	  var stateCopy = _extends({}, state);
	  var arrayCopy = [].concat(array);
	  arrayCopy[indexA] = array[indexB];
	  arrayCopy[indexB] = array[indexA];
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
	  var fields = _ref12.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
	    }, accumulator);
	  }, state));
	}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
	  var fields = _ref13.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      if (value) {
	        var touched = value.touched,
	            rest = _objectWithoutProperties(value, ['touched']);
	
	        return (0, _fieldValue.makeFieldValue)(rest);
	      }
	      return (0, _fieldValue.makeFieldValue)(value);
	    }, accumulator);
	  }, state));
	}, _behaviors);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var behavior = behaviors[action.type];
	  return behavior ? behavior(state, action) : state;
	};
	
	function formReducer() {
	  var _extends10;
	
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var form = action.form,
	      key = action.key,
	      rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare
	
	
	  if (!form) {
	    return state;
	  }
	  if (key) {
	    var _extends7, _extends8;
	
	    if (action.type === _actionTypes.DESTROY) {
	      var _extends6;
	
	      return _extends({}, state, (_extends6 = {}, _extends6[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
	        var _extends5;
	
	        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[stateKey] = state[form][stateKey], _extends5));
	      }, {}), _extends6));
	    }
	    return _extends({}, state, (_extends8 = {}, _extends8[form] = _extends({}, state[form], (_extends7 = {}, _extends7[key] = reducer((state[form] || {})[key], rest), _extends7)), _extends8));
	  }
	  if (action.type === _actionTypes.DESTROY) {
	    return Object.keys(state).reduce(function (accumulator, formName) {
	      var _extends9;
	
	      return formName === form ? accumulator : _extends({}, accumulator, (_extends9 = {}, _extends9[formName] = state[formName], _extends9));
	    }, {});
	  }
	  return _extends({}, state, (_extends10 = {}, _extends10[form] = reducer(state[form], rest), _extends10));
	}
	
	/**
	 * Adds additional functionality to the reducer
	 */
	function decorate(target) {
	  target.plugin = function plugin(reducers) {
	    var _this = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
	        return pluginReducer(result[key] || initialState, action);
	      }));
	    });
	  };
	
	  target.normalize = function normalize(normalizers) {
	    var _this2 = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this2(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
	        var runNormalize = function runNormalize(previous, currentResult) {
	          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
	          var formResult = _extends({}, initialState, currentResult);
	          var values = (0, _getValuesFromState2.default)(formResult);
	          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
	        };
	        if (action.key) {
	          var _extends11;
	
	          return _extends({}, result[form], (_extends11 = {}, _extends11[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends11));
	        }
	        return runNormalize(state[form], result[form]);
	      }));
	    });
	  };
	
	  return target;
	}
	
	exports.default = decorate(formReducer);

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(2240);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "default" icons for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/icons/default')
	//   ES2015:
	//     import 'tinymce/icons/default'
	__webpack_require__(2246);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "charmap" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/charmap')
	//   ES2015:
	//     import 'tinymce/plugins/charmap'
	__webpack_require__(2247);

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "code" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/code')
	//   ES2015:
	//     import 'tinymce/plugins/code'
	__webpack_require__(2248);

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "fullscreen" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/fullscreen')
	//   ES2015:
	//     import 'tinymce/plugins/fullscreen'
	__webpack_require__(2249);

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "image" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/image')
	//   ES2015:
	//     import 'tinymce/plugins/image'
	__webpack_require__(2250);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "link" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/link')
	//   ES2015:
	//     import 'tinymce/plugins/link'
	__webpack_require__(2251);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "paste" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/paste')
	//   ES2015:
	//     import 'tinymce/plugins/paste'
	__webpack_require__(2252);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "preview" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/preview')
	//   ES2015:
	//     import 'tinymce/plugins/preview'
	__webpack_require__(2253);

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "searchreplace" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/searchreplace')
	//   ES2015:
	//     import 'tinymce/plugins/searchreplace'
	__webpack_require__(2254);

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "table" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/table')
	//   ES2015:
	//     import 'tinymce/plugins/table'
	__webpack_require__(2255);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "textcolor" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/textcolor')
	//   ES2015:
	//     import 'tinymce/plugins/textcolor'
	__webpack_require__(2256);

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "visualchars" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/visualchars')
	//   ES2015:
	//     import 'tinymce/plugins/visualchars'
	__webpack_require__(2257);

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "silver" theme for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/themes/silver')
	//   ES2015:
	//     import 'tinymce/themes/silver'
	__webpack_require__(2258);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var typeOf$1 = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      if (x === undefined) {
	        return 'undefined';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isEquatableType = function (x) {
	      return [
	        'undefined',
	        'boolean',
	        'number',
	        'string',
	        'function',
	        'xml',
	        'null'
	      ].indexOf(x) !== -1;
	    };
	
	    var sort$1 = function (xs, compareFn) {
	      var clone = Array.prototype.slice.call(xs);
	      return clone.sort(compareFn);
	    };
	
	    var contramap = function (eqa, f) {
	      return eq$2(function (x, y) {
	        return eqa.eq(f(x), f(y));
	      });
	    };
	    var eq$2 = function (f) {
	      return { eq: f };
	    };
	    var tripleEq = eq$2(function (x, y) {
	      return x === y;
	    });
	    var eqString = tripleEq;
	    var eqArray = function (eqa) {
	      return eq$2(function (x, y) {
	        if (x.length !== y.length) {
	          return false;
	        }
	        var len = x.length;
	        for (var i = 0; i < len; i++) {
	          if (!eqa.eq(x[i], y[i])) {
	            return false;
	          }
	        }
	        return true;
	      });
	    };
	    var eqSortedArray = function (eqa, compareFn) {
	      return contramap(eqArray(eqa), function (xs) {
	        return sort$1(xs, compareFn);
	      });
	    };
	    var eqRecord = function (eqa) {
	      return eq$2(function (x, y) {
	        var kx = Object.keys(x);
	        var ky = Object.keys(y);
	        if (!eqSortedArray(eqString).eq(kx, ky)) {
	          return false;
	        }
	        var len = kx.length;
	        for (var i = 0; i < len; i++) {
	          var q = kx[i];
	          if (!eqa.eq(x[q], y[q])) {
	            return false;
	          }
	        }
	        return true;
	      });
	    };
	    var eqAny = eq$2(function (x, y) {
	      if (x === y) {
	        return true;
	      }
	      var tx = typeOf$1(x);
	      var ty = typeOf$1(y);
	      if (tx !== ty) {
	        return false;
	      }
	      if (isEquatableType(tx)) {
	        return x === y;
	      } else if (tx === 'array') {
	        return eqArray(eqAny).eq(x, y);
	      } else if (tx === 'object') {
	        return eqRecord(eqAny).eq(x, y);
	      }
	      return false;
	    });
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType$1 = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq$1 = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString$1 = isType$1('string');
	    var isObject = isType$1('object');
	    var isArray$1 = isType$1('array');
	    var isNull = eq$1(null);
	    var isBoolean = isSimpleType('boolean');
	    var isUndefined = eq$1(undefined);
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var compose1 = function (fbc, fab) {
	      return function (a) {
	        return fbc(fab(a));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    var tripleEquals = function (a, b) {
	      return a === b;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function (t) {
	        return !f(t);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var apply = function (f) {
	      return f();
	    };
	    var call = function (f) {
	      f();
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from$1 = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from$1
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var indexOf$2 = function (xs, x) {
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Optional.none() : Optional.some(r);
	    };
	    var contains$3 = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map$3 = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each$k = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var partition = function (xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i) ? pass : fail;
	        arr.push(x);
	      }
	      return {
	        pass: pass,
	        fail: fail
	      };
	    };
	    var filter$4 = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each$k(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var findUntil$1 = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find$3 = function (xs, pred) {
	      return findUntil$1(xs, pred, never);
	    };
	    var findIndex$2 = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(i);
	        }
	      }
	      return Optional.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray$1(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map$3(xs, f));
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var difference = function (a1, a2) {
	      return filter$4(a1, function (x) {
	        return !contains$3(a2, x);
	      });
	    };
	    var mapToObject = function (xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	    var sort = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	    var get$a = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get$a(xs, 0);
	    };
	    var last$2 = function (xs) {
	      return get$a(xs, xs.length - 1);
	    };
	    var from = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty$1 = Object.hasOwnProperty;
	    var each$j = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map$2 = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each$j(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each$j(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var bifilter = function (obj, pred) {
	      var t = {};
	      var f = {};
	      internalFilter(obj, pred, objAcc(t), objAcc(f));
	      return {
	        t: t,
	        f: f
	      };
	    };
	    var filter$3 = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var mapToArray = function (obj, f) {
	      var r = [];
	      each$j(obj, function (value, name) {
	        r.push(f(value, name));
	      });
	      return r;
	    };
	    var values = function (obj) {
	      return mapToArray(obj, identity);
	    };
	    var get$9 = function (obj, key) {
	      return has$2(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has$2 = function (obj, key) {
	      return hasOwnProperty$1.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has$2(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	    var equal$1 = function (a1, a2, eq) {
	      if (eq === void 0) {
	        eq = eqAny;
	      }
	      return eqRecord(eq).eq(a1, a2);
	    };
	
	    var isArray = Array.isArray;
	    var toArray$1 = function (obj) {
	      if (!isArray(obj)) {
	        var array = [];
	        for (var i = 0, l = obj.length; i < l; i++) {
	          array[i] = obj[i];
	        }
	        return array;
	      } else {
	        return obj;
	      }
	    };
	    var each$i = function (o, cb, s) {
	      var n, l;
	      if (!o) {
	        return false;
	      }
	      s = s || o;
	      if (o.length !== undefined) {
	        for (n = 0, l = o.length; n < l; n++) {
	          if (cb.call(s, o[n], n, o) === false) {
	            return false;
	          }
	        }
	      } else {
	        for (n in o) {
	          if (has$2(o, n)) {
	            if (cb.call(s, o[n], n, o) === false) {
	              return false;
	            }
	          }
	        }
	      }
	      return true;
	    };
	    var map$1 = function (array, callback) {
	      var out = [];
	      each$i(array, function (item, index) {
	        out.push(callback(item, index, array));
	      });
	      return out;
	    };
	    var filter$2 = function (a, f) {
	      var o = [];
	      each$i(a, function (v, index) {
	        if (!f || f(v, index, a)) {
	          o.push(v);
	        }
	      });
	      return o;
	    };
	    var indexOf$1 = function (a, v) {
	      if (a) {
	        for (var i = 0, l = a.length; i < l; i++) {
	          if (a[i] === v) {
	            return i;
	          }
	        }
	      }
	      return -1;
	    };
	    var reduce = function (collection, iteratee, accumulator, thisArg) {
	      var acc = isUndefined(accumulator) ? collection[0] : accumulator;
	      for (var i = 0; i < collection.length; i++) {
	        acc = iteratee.call(thisArg, acc, collection[i], i);
	      }
	      return acc;
	    };
	    var findIndex$1 = function (array, predicate, thisArg) {
	      var i, l;
	      for (i = 0, l = array.length; i < l; i++) {
	        if (predicate.call(thisArg, array[i], i, array)) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var last$1 = function (collection) {
	      return collection[collection.length - 1];
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __rest(s, e) {
	      var t = {};
	      for (var p in s)
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	          t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	            t[p[i]] = s[p[i]];
	        }
	      return t;
	    }
	    function __spreadArray(to, from, pack) {
	      if (pack || arguments.length === 2)
	        for (var i = 0, l = from.length, ar; i < l; i++) {
	          if (ar || !(i in from)) {
	            if (!ar)
	              ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	          }
	        }
	      return to.concat(ar || Array.prototype.slice.call(from));
	    }
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var DeviceType = function (os, browser, userAgent, mediaMatch) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isMobile = os.isiOS() || os.isAndroid();
	      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
	      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
	      var isPhone = isiPhone || isMobile && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      var isDesktop = !isPhone && !isTablet && !iOSwebview;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview),
	        isDesktop: constant(isDesktop)
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$2 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu$4(group(1), group(2));
	    };
	    var detect$3 = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown$2();
	      }
	      return find$2(versionRegexes, cleanedAgent);
	    };
	    var unknown$2 = function () {
	      return nu$4(0, 0);
	    };
	    var nu$4 = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu$4,
	      detect: detect$3,
	      unknown: unknown$2
	    };
	
	    var detectBrowser$1 = function (browsers, userAgentData) {
	      return findMap(userAgentData.brands, function (uaBrand) {
	        var lcBrand = uaBrand.brand.toLowerCase();
	        return find$3(browsers, function (browser) {
	          var _a;
	          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
	        }).map(function (info) {
	          return {
	            current: info.name,
	            version: Version.nu(parseInt(uaBrand.version, 10), 0)
	          };
	        });
	      });
	    };
	
	    var detect$2 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find$3(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$2(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$2(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	
	    var removeFromStart = function (str, numChars) {
	      return str.substring(numChars);
	    };
	
	    var checkRange = function (str, substr, start) {
	      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
	    };
	    var removeLeading = function (str, prefix) {
	      return startsWith(str, prefix) ? removeFromStart(str, prefix.length) : str;
	    };
	    var contains$2 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var startsWith = function (str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	    var blank = function (r) {
	      return function (s) {
	        return s.replace(r, '');
	      };
	    };
	    var trim$4 = blank(/^\s+|\s+$/g);
	    var lTrim = blank(/^\s+/g);
	    var rTrim = blank(/\s+$/g);
	    var isNotEmpty = function (s) {
	      return s.length > 0;
	    };
	    var isEmpty$3 = function (s) {
	      return !isNotEmpty(s);
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$2(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$2(uastring, 'edge/') && contains$2(uastring, 'chrome') && contains$2(uastring, 'safari') && contains$2(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        brand: 'Chromium',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$2(uastring, 'chrome') && !contains$2(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$2(uastring, 'msie') || contains$2(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$2(uastring, 'safari') || contains$2(uastring, 'mobile/')) && contains$2(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$2(uastring, 'iphone') || contains$2(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('mac os x'),
	        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      },
	      {
	        name: 'ChromeOS',
	        search: checkContains('cros'),
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie$1 = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var unknown$1 = function () {
	      return nu$3({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$3 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isBrowser = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge),
	        isChrome: isBrowser(chrome),
	        isIE: isBrowser(ie$1),
	        isOpera: isBrowser(opera),
	        isFirefox: isBrowser(firefox),
	        isSafari: isBrowser(safari)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$3,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie$1),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var chromeos = 'ChromeOS';
	    var unknown = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isOS = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows),
	        isiOS: isOS(ios),
	        isAndroid: isOS(android),
	        isOSX: isOS(osx),
	        isLinux: isOS(linux),
	        isSolaris: isOS(solaris),
	        isFreeBSD: isOS(freebsd),
	        isChromeOS: isOS(chromeos)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd),
	      chromeos: constant(chromeos)
	    };
	
	    var detect$1 = function (userAgent, userAgentDataOpt, mediaMatch) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = userAgentDataOpt.bind(function (userAgentData) {
	        return detectBrowser$1(browsers, userAgentData);
	      }).orThunk(function () {
	        return detectBrowser(browsers, userAgent);
	      }).fold(Browser.unknown, Browser.nu);
	      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$1 };
	
	    var mediaMatch = function (query) {
	      return window.matchMedia(query).matches;
	    };
	    var platform$2 = cached(function () {
	      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
	    });
	    var detect = function () {
	      return platform$2();
	    };
	
	    var userAgent = navigator.userAgent;
	    var platform$1 = detect();
	    var browser$4 = platform$1.browser;
	    var os = platform$1.os;
	    var deviceType = platform$1.deviceType;
	    var webkit = /WebKit/.test(userAgent) && !browser$4.isEdge();
	    var fileApi = 'FormData' in window && 'FileReader' in window && 'URL' in window && !!URL.createObjectURL;
	    var windowsPhone = userAgent.indexOf('Windows Phone') !== -1;
	    var Env = {
	      opera: browser$4.isOpera(),
	      webkit: webkit,
	      ie: browser$4.isIE() || browser$4.isEdge() ? browser$4.version.major : false,
	      gecko: browser$4.isFirefox(),
	      mac: os.isOSX() || os.isiOS(),
	      iOS: deviceType.isiPad() || deviceType.isiPhone(),
	      android: os.isAndroid(),
	      contentEditable: true,
	      transparentSrc: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
	      caretAfter: true,
	      range: window.getSelection && 'Range' in window,
	      documentMode: browser$4.isIE() ? document.documentMode || 7 : 10,
	      fileApi: fileApi,
	      ceFalse: true,
	      cacheSuffix: null,
	      container: null,
	      experimentalShadowDom: false,
	      canHaveCSP: !browser$4.isIE(),
	      desktop: deviceType.isDesktop(),
	      windowsPhone: windowsPhone,
	      browser: {
	        current: browser$4.current,
	        version: browser$4.version,
	        isChrome: browser$4.isChrome,
	        isEdge: browser$4.isEdge,
	        isFirefox: browser$4.isFirefox,
	        isIE: browser$4.isIE,
	        isOpera: browser$4.isOpera,
	        isSafari: browser$4.isSafari
	      },
	      os: {
	        current: os.current,
	        version: os.version,
	        isAndroid: os.isAndroid,
	        isChromeOS: os.isChromeOS,
	        isFreeBSD: os.isFreeBSD,
	        isiOS: os.isiOS,
	        isLinux: os.isLinux,
	        isOSX: os.isOSX,
	        isSolaris: os.isSolaris,
	        isWindows: os.isWindows
	      },
	      deviceType: {
	        isDesktop: deviceType.isDesktop,
	        isiPad: deviceType.isiPad,
	        isiPhone: deviceType.isiPhone,
	        isPhone: deviceType.isPhone,
	        isTablet: deviceType.isTablet,
	        isTouch: deviceType.isTouch,
	        isWebView: deviceType.isWebView
	      }
	    };
	
	    var whiteSpaceRegExp$2 = /^\s*|\s*$/g;
	    var trim$3 = function (str) {
	      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp$2, '');
	    };
	    var is$3 = function (obj, type) {
	      if (!type) {
	        return obj !== undefined;
	      }
	      if (type === 'array' && isArray(obj)) {
	        return true;
	      }
	      return typeof obj === type;
	    };
	    var makeMap$4 = function (items, delim, map) {
	      var i;
	      items = items || [];
	      delim = delim || ',';
	      if (typeof items === 'string') {
	        items = items.split(delim);
	      }
	      map = map || {};
	      i = items.length;
	      while (i--) {
	        map[items[i]] = {};
	      }
	      return map;
	    };
	    var hasOwnProperty = has$2;
	    var create$9 = function (s, p, root) {
	      var self = this;
	      var sp, scn, c, de = 0;
	      s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
	      var cn = s[3].match(/(^|\.)(\w+)$/i)[2];
	      var ns = self.createNS(s[3].replace(/\.\w+$/, ''), root);
	      if (ns[cn]) {
	        return;
	      }
	      if (s[2] === 'static') {
	        ns[cn] = p;
	        if (this.onCreate) {
	          this.onCreate(s[2], s[3], ns[cn]);
	        }
	        return;
	      }
	      if (!p[cn]) {
	        p[cn] = function () {
	        };
	        de = 1;
	      }
	      ns[cn] = p[cn];
	      self.extend(ns[cn].prototype, p);
	      if (s[5]) {
	        sp = self.resolve(s[5]).prototype;
	        scn = s[5].match(/\.(\w+)$/i)[1];
	        c = ns[cn];
	        if (de) {
	          ns[cn] = function () {
	            return sp[scn].apply(this, arguments);
	          };
	        } else {
	          ns[cn] = function () {
	            this.parent = sp[scn];
	            return c.apply(this, arguments);
	          };
	        }
	        ns[cn].prototype[cn] = ns[cn];
	        self.each(sp, function (f, n) {
	          ns[cn].prototype[n] = sp[n];
	        });
	        self.each(p, function (f, n) {
	          if (sp[n]) {
	            ns[cn].prototype[n] = function () {
	              this.parent = sp[n];
	              return f.apply(this, arguments);
	            };
	          } else {
	            if (n !== cn) {
	              ns[cn].prototype[n] = f;
	            }
	          }
	        });
	      }
	      self.each(p.static, function (f, n) {
	        ns[cn][n] = f;
	      });
	    };
	    var extend$6 = function (obj) {
	      var exts = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        exts[_i - 1] = arguments[_i];
	      }
	      for (var i = 0; i < exts.length; i++) {
	        var ext = exts[i];
	        for (var name_1 in ext) {
	          if (has$2(ext, name_1)) {
	            var value = ext[name_1];
	            if (value !== undefined) {
	              obj[name_1] = value;
	            }
	          }
	        }
	      }
	      return obj;
	    };
	    var walk$3 = function (o, f, n, s) {
	      s = s || this;
	      if (o) {
	        if (n) {
	          o = o[n];
	        }
	        each$i(o, function (o, i) {
	          if (f.call(s, o, i, n) === false) {
	            return false;
	          }
	          walk$3(o, f, n, s);
	        });
	      }
	    };
	    var createNS = function (n, o) {
	      var i, v;
	      o = o || window;
	      n = n.split('.');
	      for (i = 0; i < n.length; i++) {
	        v = n[i];
	        if (!o[v]) {
	          o[v] = {};
	        }
	        o = o[v];
	      }
	      return o;
	    };
	    var resolve$3 = function (n, o) {
	      var i, l;
	      o = o || window;
	      n = n.split('.');
	      for (i = 0, l = n.length; i < l; i++) {
	        o = o[n[i]];
	        if (!o) {
	          break;
	        }
	      }
	      return o;
	    };
	    var explode$4 = function (s, d) {
	      if (!s || is$3(s, 'array')) {
	        return s;
	      }
	      return map$1(s.split(d || ','), trim$3);
	    };
	    var _addCacheSuffix = function (url) {
	      var cacheSuffix = Env.cacheSuffix;
	      if (cacheSuffix) {
	        url += (url.indexOf('?') === -1 ? '?' : '&') + cacheSuffix;
	      }
	      return url;
	    };
	    var Tools = {
	      trim: trim$3,
	      isArray: isArray,
	      is: is$3,
	      toArray: toArray$1,
	      makeMap: makeMap$4,
	      each: each$i,
	      map: map$1,
	      grep: filter$2,
	      inArray: indexOf$1,
	      hasOwn: hasOwnProperty,
	      extend: extend$6,
	      create: create$9,
	      walk: walk$3,
	      createNS: createNS,
	      resolve: resolve$3,
	      explode: explode$4,
	      _addCacheSuffix: _addCacheSuffix
	    };
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom$2(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom$2(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom$2(node);
	    };
	    var fromDom$2 = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint$1 = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom$2);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml$1,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom$2,
	      fromPoint: fromPoint$1
	    };
	
	    var toArray = function (target, f) {
	      var r = [];
	      var recurse = function (e) {
	        r.push(e);
	        return f(e);
	      };
	      var cur = f(target);
	      do {
	        cur = cur.bind(recurse);
	      } while (cur.isSome());
	      return r;
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    var COMMENT = 8;
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var is$2 = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map$3(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom;
	      var d2 = e2.dom;
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return documentPositionContainedBy(e1.dom, e2.dom);
	    };
	    var contains$1 = function (e1, e2) {
	      return detect().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
	    };
	
	    typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var name = function (element) {
	      var r = element.dom.nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isComment$1 = function (element) {
	      return type(element) === COMMENT || name(element) === '#comment';
	    };
	    var isElement$6 = isType(ELEMENT);
	    var isText$8 = isType(TEXT);
	    var isDocument$2 = isType(DOCUMENT);
	    var isDocumentFragment$1 = isType(DOCUMENT_FRAGMENT);
	    var isTag = function (tag) {
	      return function (e) {
	        return isElement$6(e) && name(e) === tag;
	      };
	    };
	
	    var owner$1 = function (element) {
	      return SugarElement.fromDom(element.dom.ownerDocument);
	    };
	    var documentOrOwner = function (dos) {
	      return isDocument$2(dos) ? dos : owner$1(dos);
	    };
	    var documentElement = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.documentElement);
	    };
	    var defaultView = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
	    };
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var parents$1 = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom;
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = SugarElement.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var siblings = function (element) {
	      var filterSelf = function (elements) {
	        return filter$4(elements, function (x) {
	          return !eq(element, x);
	        });
	      };
	      return parent(element).map(children).map(filterSelf).getOr([]);
	    };
	    var prevSibling = function (element) {
	      return Optional.from(element.dom.previousSibling).map(SugarElement.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
	    };
	    var prevSiblings = function (element) {
	      return reverse(toArray(element, prevSibling));
	    };
	    var nextSiblings = function (element) {
	      return toArray(element, nextSibling);
	    };
	    var children = function (element) {
	      return map$3(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var child$1 = function (element, index) {
	      var cs = element.dom.childNodes;
	      return Optional.from(cs[index]).map(SugarElement.fromDom);
	    };
	    var firstChild = function (element) {
	      return child$1(element, 0);
	    };
	    var lastChild = function (element) {
	      return child$1(element, element.dom.childNodes.length - 1);
	    };
	    var childNodesCount = function (element) {
	      return element.dom.childNodes.length;
	    };
	
	    var getHead = function (doc) {
	      var b = doc.dom.head;
	      if (b === null || b === undefined) {
	        throw new Error('Head is not available yet');
	      }
	      return SugarElement.fromDom(b);
	    };
	
	    var isShadowRoot = function (dos) {
	      return isDocumentFragment$1(dos) && isNonNullable(dos.dom.host);
	    };
	    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
	    var isSupported$1 = constant(supported);
	    var getRootNode = supported ? function (e) {
	      return SugarElement.fromDom(e.dom.getRootNode());
	    } : documentOrOwner;
	    var getStyleContainer = function (dos) {
	      return isShadowRoot(dos) ? dos : getHead(documentOrOwner(dos));
	    };
	    var getShadowRoot = function (e) {
	      var r = getRootNode(e);
	      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
	    };
	    var getShadowHost = function (e) {
	      return SugarElement.fromDom(e.dom.host);
	    };
	    var getOriginalEventTarget = function (event) {
	      if (isSupported$1() && isNonNullable(event.target)) {
	        var el = SugarElement.fromDom(event.target);
	        if (isElement$6(el) && isOpenShadowHost(el)) {
	          if (event.composed && event.composedPath) {
	            var composedPath = event.composedPath();
	            if (composedPath) {
	              return head(composedPath);
	            }
	          }
	        }
	      }
	      return Optional.from(event.target);
	    };
	    var isOpenShadowHost = function (element) {
	      return isNonNullable(element.dom.shadowRoot);
	    };
	
	    var before$4 = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var after$3 = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append$1(v, element);
	        });
	      }, function (v) {
	        before$4(v, element);
	      });
	    };
	    var prepend = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append$1(parent, element);
	      }, function (v) {
	        parent.dom.insertBefore(element.dom, v.dom);
	      });
	    };
	    var append$1 = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	    var wrap$3 = function (element, wrapper) {
	      before$4(element, wrapper);
	      append$1(wrapper, element);
	    };
	
	    var before$3 = function (marker, elements) {
	      each$k(elements, function (x) {
	        before$4(marker, x);
	      });
	    };
	    var append = function (parent, elements) {
	      each$k(elements, function (x) {
	        append$1(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom.textContent = '';
	      each$k(children(element), function (rogue) {
	        remove$7(rogue);
	      });
	    };
	    var remove$7 = function (element) {
	      var dom = element.dom;
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children$1 = children(wrapper);
	      if (children$1.length > 0) {
	        before$3(wrapper, children$1);
	      }
	      remove$7(wrapper);
	    };
	
	    var inBody = function (element) {
	      var dom = isText$8(element) ? element.dom.parentNode : element.dom;
	      if (dom === undefined || dom === null || dom.ownerDocument === null) {
	        return false;
	      }
	      var doc = dom.ownerDocument;
	      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
	        return doc.body.contains(dom);
	      }, compose1(inBody, getShadowHost));
	    };
	
	    var r = function (left, top) {
	      var translate = function (x, y) {
	        return r(left + x, top + y);
	      };
	      return {
	        left: left,
	        top: top,
	        translate: translate
	      };
	    };
	    var SugarPosition = r;
	
	    var boxPosition = function (dom) {
	      var box = dom.getBoundingClientRect();
	      return SugarPosition(box.left, box.top);
	    };
	    var firstDefinedOrZero = function (a, b) {
	      if (a !== undefined) {
	        return a;
	      } else {
	        return b !== undefined ? b : 0;
	      }
	    };
	    var absolute = function (element) {
	      var doc = element.dom.ownerDocument;
	      var body = doc.body;
	      var win = doc.defaultView;
	      var html = doc.documentElement;
	      if (body === element.dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
	      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
	      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
	      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
	      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
	    };
	    var viewport = function (element) {
	      var dom = element.dom;
	      var doc = dom.ownerDocument;
	      var body = doc.body;
	      if (body === dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      if (!inBody(element)) {
	        return SugarPosition(0, 0);
	      }
	      return boxPosition(dom);
	    };
	
	    var get$8 = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return SugarPosition(x, y);
	    };
	    var to = function (x, y, _DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var win = doc.defaultView;
	      if (win) {
	        win.scrollTo(x, y);
	      }
	    };
	    var intoView = function (element, alignToTop) {
	      var isSafari = detect().browser.isSafari();
	      if (isSafari && isFunction(element.dom.scrollIntoViewIfNeeded)) {
	        element.dom.scrollIntoViewIfNeeded(false);
	      } else {
	        element.dom.scrollIntoView(alignToTop);
	      }
	    };
	
	    var get$7 = function (_win) {
	      var win = _win === undefined ? window : _win;
	      if (detect().browser.isFirefox()) {
	        return Optional.none();
	      } else {
	        return Optional.from(win['visualViewport']);
	      }
	    };
	    var bounds = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        right: x + width,
	        bottom: y + height
	      };
	    };
	    var getBounds = function (_win) {
	      var win = _win === undefined ? window : _win;
	      var doc = win.document;
	      var scroll = get$8(SugarElement.fromDom(doc));
	      return get$7(win).fold(function () {
	        var html = win.document.documentElement;
	        var width = html.clientWidth;
	        var height = html.clientHeight;
	        return bounds(scroll.left, scroll.top, width, height);
	      }, function (visualViewport) {
	        return bounds(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
	      });
	    };
	
	    var isNodeType = function (type) {
	      return function (node) {
	        return !!node && node.nodeType === type;
	      };
	    };
	    var isRestrictedNode = function (node) {
	      return !!node && !Object.getPrototypeOf(node);
	    };
	    var isElement$5 = isNodeType(1);
	    var matchNodeNames = function (names) {
	      var lowercasedNames = names.map(function (s) {
	        return s.toLowerCase();
	      });
	      return function (node) {
	        if (node && node.nodeName) {
	          var nodeName = node.nodeName.toLowerCase();
	          return contains$3(lowercasedNames, nodeName);
	        }
	        return false;
	      };
	    };
	    var matchStyleValues = function (name, values) {
	      var items = values.toLowerCase().split(' ');
	      return function (node) {
	        if (isElement$5(node)) {
	          for (var i = 0; i < items.length; i++) {
	            var computed = node.ownerDocument.defaultView.getComputedStyle(node, null);
	            var cssValue = computed ? computed.getPropertyValue(name) : null;
	            if (cssValue === items[i]) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	    };
	    var hasAttribute = function (attrName) {
	      return function (node) {
	        return isElement$5(node) && node.hasAttribute(attrName);
	      };
	    };
	    var hasAttributeValue = function (attrName, attrValue) {
	      return function (node) {
	        return isElement$5(node) && node.getAttribute(attrName) === attrValue;
	      };
	    };
	    var isBogus$2 = function (node) {
	      return isElement$5(node) && node.hasAttribute('data-mce-bogus');
	    };
	    var isBogusAll$1 = function (node) {
	      return isElement$5(node) && node.getAttribute('data-mce-bogus') === 'all';
	    };
	    var isTable$3 = function (node) {
	      return isElement$5(node) && node.tagName === 'TABLE';
	    };
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (isElement$5(node)) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var isTextareaOrInput = matchNodeNames([
	      'textarea',
	      'input'
	    ]);
	    var isText$7 = isNodeType(3);
	    var isComment = isNodeType(8);
	    var isDocument$1 = isNodeType(9);
	    var isDocumentFragment = isNodeType(11);
	    var isBr$5 = matchNodeNames(['br']);
	    var isImg = matchNodeNames(['img']);
	    var isContentEditableTrue$4 = hasContentEditableState('true');
	    var isContentEditableFalse$b = hasContentEditableState('false');
	    var isTableCell$5 = matchNodeNames([
	      'td',
	      'th'
	    ]);
	    var isMedia$2 = matchNodeNames([
	      'video',
	      'audio',
	      'object',
	      'embed'
	    ]);
	
	    var is$1 = function (lhs, rhs, comparator) {
	      if (comparator === void 0) {
	        comparator = tripleEquals;
	      }
	      return lhs.exists(function (left) {
	        return comparator(left, rhs);
	      });
	    };
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
	    };
	    var lift3 = function (oa, ob, oc, f) {
	      return oa.isSome() && ob.isSome() && oc.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie(), oc.getOrDie())) : Optional.none();
	    };
	    var someIf = function (b, a) {
	      return b ? Optional.some(a) : Optional.none();
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString$1(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set$1 = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var setAll$1 = function (element, attrs) {
	      var dom = element.dom;
	      each$j(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var get$6 = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var getOpt = function (element, key) {
	      return Optional.from(get$6(element, key));
	    };
	    var has$1 = function (element, key) {
	      var dom = element.dom;
	      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
	    };
	    var remove$6 = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	    var clone$3 = function (element) {
	      return foldl(element.dom.attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString$1(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var setAll = function (element, css) {
	      var dom = element.dom;
	      each$j(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$5 = function (element, property) {
	      var dom = element.dom;
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw = function (element, property) {
	      var dom = element.dom;
	      var raw = getUnsafeProperty(dom, property);
	      return Optional.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var getAllRaw = function (element) {
	      var css = {};
	      var dom = element.dom;
	      if (isSupported(dom)) {
	        for (var i = 0; i < dom.style.length; i++) {
	          var ruleName = dom.style.item(i);
	          css[ruleName] = dom.style[ruleName];
	        }
	      }
	      return css;
	    };
	    var reflow = function (e) {
	      return e.dom.offsetWidth;
	    };
	
	    var browser$3 = detect().browser;
	    var firstElement = function (nodes) {
	      return find$3(nodes, isElement$6);
	    };
	    var getTableCaptionDeltaY = function (elm) {
	      if (browser$3.isFirefox() && name(elm) === 'table') {
	        return firstElement(children(elm)).filter(function (elm) {
	          return name(elm) === 'caption';
	        }).bind(function (caption) {
	          return firstElement(nextSiblings(caption)).map(function (body) {
	            var bodyTop = body.dom.offsetTop;
	            var captionTop = caption.dom.offsetTop;
	            var captionHeight = caption.dom.offsetHeight;
	            return bodyTop <= captionTop ? -captionHeight : 0;
	          });
	        }).getOr(0);
	      } else {
	        return 0;
	      }
	    };
	    var hasChild = function (elm, child) {
	      return elm.children && contains$3(elm.children, child);
	    };
	    var getPos = function (body, elm, rootElm) {
	      var x = 0, y = 0;
	      var doc = body.ownerDocument;
	      rootElm = rootElm ? rootElm : body;
	      if (elm) {
	        if (rootElm === body && elm.getBoundingClientRect && get$5(SugarElement.fromDom(body), 'position') === 'static') {
	          var pos = elm.getBoundingClientRect();
	          x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - doc.documentElement.clientLeft;
	          y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - doc.documentElement.clientTop;
	          return {
	            x: x,
	            y: y
	          };
	        }
	        var offsetParent = elm;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType && !hasChild(offsetParent, rootElm)) {
	          var castOffsetParent = offsetParent;
	          x += castOffsetParent.offsetLeft || 0;
	          y += castOffsetParent.offsetTop || 0;
	          offsetParent = castOffsetParent.offsetParent;
	        }
	        offsetParent = elm.parentNode;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType && !hasChild(offsetParent, rootElm)) {
	          x -= offsetParent.scrollLeft || 0;
	          y -= offsetParent.scrollTop || 0;
	          offsetParent = offsetParent.parentNode;
	        }
	        y += getTableCaptionDeltaY(SugarElement.fromDom(elm));
	      }
	      return {
	        x: x,
	        y: y
	      };
	    };
	
	    var exports$1 = {}, module$1 = { exports: exports$1 };
	    (function (define, exports, module, require) {
	      (function (global, factory) {
	        typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.EphoxContactWrapper = factory());
	      }(this, function () {
	        var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	        var promise = { exports: {} };
	        (function (module) {
	          (function (root) {
	            var setTimeoutFunc = setTimeout;
	            function noop() {
	            }
	            function bind(fn, thisArg) {
	              return function () {
	                fn.apply(thisArg, arguments);
	              };
	            }
	            function Promise(fn) {
	              if (typeof this !== 'object')
	                throw new TypeError('Promises must be constructed via new');
	              if (typeof fn !== 'function')
	                throw new TypeError('not a function');
	              this._state = 0;
	              this._handled = false;
	              this._value = undefined;
	              this._deferreds = [];
	              doResolve(fn, this);
	            }
	            function handle(self, deferred) {
	              while (self._state === 3) {
	                self = self._value;
	              }
	              if (self._state === 0) {
	                self._deferreds.push(deferred);
	                return;
	              }
	              self._handled = true;
	              Promise._immediateFn(function () {
	                var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	                if (cb === null) {
	                  (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	                  return;
	                }
	                var ret;
	                try {
	                  ret = cb(self._value);
	                } catch (e) {
	                  reject(deferred.promise, e);
	                  return;
	                }
	                resolve(deferred.promise, ret);
	              });
	            }
	            function resolve(self, newValue) {
	              try {
	                if (newValue === self)
	                  throw new TypeError('A promise cannot be resolved with itself.');
	                if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                  var then = newValue.then;
	                  if (newValue instanceof Promise) {
	                    self._state = 3;
	                    self._value = newValue;
	                    finale(self);
	                    return;
	                  } else if (typeof then === 'function') {
	                    doResolve(bind(then, newValue), self);
	                    return;
	                  }
	                }
	                self._state = 1;
	                self._value = newValue;
	                finale(self);
	              } catch (e) {
	                reject(self, e);
	              }
	            }
	            function reject(self, newValue) {
	              self._state = 2;
	              self._value = newValue;
	              finale(self);
	            }
	            function finale(self) {
	              if (self._state === 2 && self._deferreds.length === 0) {
	                Promise._immediateFn(function () {
	                  if (!self._handled) {
	                    Promise._unhandledRejectionFn(self._value);
	                  }
	                });
	              }
	              for (var i = 0, len = self._deferreds.length; i < len; i++) {
	                handle(self, self._deferreds[i]);
	              }
	              self._deferreds = null;
	            }
	            function Handler(onFulfilled, onRejected, promise) {
	              this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	              this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	              this.promise = promise;
	            }
	            function doResolve(fn, self) {
	              var done = false;
	              try {
	                fn(function (value) {
	                  if (done)
	                    return;
	                  done = true;
	                  resolve(self, value);
	                }, function (reason) {
	                  if (done)
	                    return;
	                  done = true;
	                  reject(self, reason);
	                });
	              } catch (ex) {
	                if (done)
	                  return;
	                done = true;
	                reject(self, ex);
	              }
	            }
	            Promise.prototype['catch'] = function (onRejected) {
	              return this.then(null, onRejected);
	            };
	            Promise.prototype.then = function (onFulfilled, onRejected) {
	              var prom = new this.constructor(noop);
	              handle(this, new Handler(onFulfilled, onRejected, prom));
	              return prom;
	            };
	            Promise.all = function (arr) {
	              var args = Array.prototype.slice.call(arr);
	              return new Promise(function (resolve, reject) {
	                if (args.length === 0)
	                  return resolve([]);
	                var remaining = args.length;
	                function res(i, val) {
	                  try {
	                    if (val && (typeof val === 'object' || typeof val === 'function')) {
	                      var then = val.then;
	                      if (typeof then === 'function') {
	                        then.call(val, function (val) {
	                          res(i, val);
	                        }, reject);
	                        return;
	                      }
	                    }
	                    args[i] = val;
	                    if (--remaining === 0) {
	                      resolve(args);
	                    }
	                  } catch (ex) {
	                    reject(ex);
	                  }
	                }
	                for (var i = 0; i < args.length; i++) {
	                  res(i, args[i]);
	                }
	              });
	            };
	            Promise.resolve = function (value) {
	              if (value && typeof value === 'object' && value.constructor === Promise) {
	                return value;
	              }
	              return new Promise(function (resolve) {
	                resolve(value);
	              });
	            };
	            Promise.reject = function (value) {
	              return new Promise(function (resolve, reject) {
	                reject(value);
	              });
	            };
	            Promise.race = function (values) {
	              return new Promise(function (resolve, reject) {
	                for (var i = 0, len = values.length; i < len; i++) {
	                  values[i].then(resolve, reject);
	                }
	              });
	            };
	            Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
	              setImmediate(fn);
	            } : function (fn) {
	              setTimeoutFunc(fn, 0);
	            };
	            Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	              if (typeof console !== 'undefined' && console) {
	                console.warn('Possible Unhandled Promise Rejection:', err);
	              }
	            };
	            Promise._setImmediateFn = function _setImmediateFn(fn) {
	              Promise._immediateFn = fn;
	            };
	            Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	              Promise._unhandledRejectionFn = fn;
	            };
	            if (module.exports) {
	              module.exports = Promise;
	            } else if (!root.Promise) {
	              root.Promise = Promise;
	            }
	          }(commonjsGlobal));
	        }(promise));
	        var promisePolyfill = promise.exports;
	        var Global = function () {
	          if (typeof window !== 'undefined') {
	            return window;
	          } else {
	            return Function('return this;')();
	          }
	        }();
	        var promisePolyfill_1 = { boltExport: Global.Promise || promisePolyfill };
	        return promisePolyfill_1;
	      }));
	    }(undefined, exports$1, module$1));
	    var Promise$1 = module$1.exports.boltExport;
	
	    var nu$1 = function (baseFn) {
	      var data = Optional.none();
	      var callbacks = [];
	      var map = function (f) {
	        return nu$1(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	      var get = function (nCallback) {
	        if (isReady()) {
	          call(nCallback);
	        } else {
	          callbacks.push(nCallback);
	        }
	      };
	      var set = function (x) {
	        if (!isReady()) {
	          data = Optional.some(x);
	          run(callbacks);
	          callbacks = [];
	        }
	      };
	      var isReady = function () {
	        return data.isSome();
	      };
	      var run = function (cbs) {
	        each$k(cbs, call);
	      };
	      var call = function (cb) {
	        data.each(function (x) {
	          setTimeout(function () {
	            cb(x);
	          }, 0);
	        });
	      };
	      baseFn(set);
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	    var pure$1 = function (a) {
	      return nu$1(function (callback) {
	        callback(a);
	      });
	    };
	    var LazyValue = {
	      nu: nu$1,
	      pure: pure$1
	    };
	
	    var errorReporter = function (err) {
	      setTimeout(function () {
	        throw err;
	      }, 0);
	    };
	    var make = function (run) {
	      var get = function (callback) {
	        run().then(callback, errorReporter);
	      };
	      var map = function (fab) {
	        return make(function () {
	          return run().then(fab);
	        });
	      };
	      var bind = function (aFutureB) {
	        return make(function () {
	          return run().then(function (v) {
	            return aFutureB(v).toPromise();
	          });
	        });
	      };
	      var anonBind = function (futureB) {
	        return make(function () {
	          return run().then(function () {
	            return futureB.toPromise();
	          });
	        });
	      };
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	      var toCached = function () {
	        var cache = null;
	        return make(function () {
	          if (cache === null) {
	            cache = run();
	          }
	          return cache;
	        });
	      };
	      var toPromise = run;
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        toCached: toCached,
	        toPromise: toPromise,
	        get: get
	      };
	    };
	    var nu = function (baseFn) {
	      return make(function () {
	        return new Promise$1(baseFn);
	      });
	    };
	    var pure = function (a) {
	      return make(function () {
	        return Promise$1.resolve(a);
	      });
	    };
	    var Future = {
	      nu: nu,
	      pure: pure
	    };
	
	    var par$1 = function (asyncValues, nu) {
	      return nu(function (callback) {
	        var r = [];
	        var count = 0;
	        var cb = function (i) {
	          return function (value) {
	            r[i] = value;
	            count++;
	            if (count >= asyncValues.length) {
	              callback(r);
	            }
	          };
	        };
	        if (asyncValues.length === 0) {
	          callback([]);
	        } else {
	          each$k(asyncValues, function (asyncValue, i) {
	            asyncValue.get(cb(i));
	          });
	        }
	      });
	    };
	
	    var par = function (futures) {
	      return par$1(futures, Future.nu);
	    };
	
	    var value$1 = function (o) {
	      var or = function (_opt) {
	        return value$1(o);
	      };
	      var orThunk = function (_f) {
	        return value$1(o);
	      };
	      var map = function (f) {
	        return value$1(f(o));
	      };
	      var mapError = function (_f) {
	        return value$1(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOptional = function () {
	        return Optional.some(o);
	      };
	      return {
	        isValue: always,
	        isError: never,
	        getOr: constant(o),
	        getOrThunk: constant(o),
	        getOrDie: constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOptional: toOptional
	      };
	    };
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = identity;
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (_f) {
	        return error(message);
	      };
	      var mapError = function (f) {
	        return error(f(message));
	      };
	      var bind = function (_f) {
	        return error(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        isValue: never,
	        isError: always,
	        getOr: identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOptional: Optional.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error(err);
	      }, value$1);
	    };
	    var Result = {
	      value: value$1,
	      error: error,
	      fromOption: fromOption
	    };
	
	    var generate$1 = function (cases) {
	      if (!isArray$1(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each$k(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray$1(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          var argLength = args.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains$3(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              var foldArgs = [];
	              for (var _i = 0; _i < arguments.length; _i++) {
	                foldArgs[_i] = arguments[_i];
	              }
	              if (foldArgs.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
	              }
	              var target = foldArgs[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate$1 };
	
	    Adt.generate([
	      {
	        bothErrors: [
	          'error1',
	          'error2'
	        ]
	      },
	      {
	        firstError: [
	          'error1',
	          'value2'
	        ]
	      },
	      {
	        secondError: [
	          'value1',
	          'error2'
	        ]
	      },
	      {
	        bothValues: [
	          'value1',
	          'value2'
	        ]
	      }
	    ]);
	    var unite = function (result) {
	      return result.fold(identity, identity);
	    };
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      if (is(scope, a)) {
	        return Optional.some(scope);
	      } else if (isFunction(isRoot) && isRoot(scope)) {
	        return Optional.none();
	      } else {
	        return ancestor(scope, a, isRoot);
	      }
	    }
	
	    var ancestor$3 = function (scope, predicate, isRoot) {
	      var element = scope.dom;
	      var stop = isFunction(isRoot) ? isRoot : never;
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        if (predicate(el)) {
	          return Optional.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest$3 = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor$3, scope, predicate, isRoot);
	    };
	    var sibling$2 = function (scope, predicate) {
	      var element = scope.dom;
	      if (!element.parentNode) {
	        return Optional.none();
	      }
	      return child(SugarElement.fromDom(element.parentNode), function (x) {
	        return !eq(scope, x) && predicate(x);
	      });
	    };
	    var child = function (scope, predicate) {
	      var pred = function (node) {
	        return predicate(SugarElement.fromDom(node));
	      };
	      var result = find$3(scope.dom.childNodes, pred);
	      return result.map(SugarElement.fromDom);
	    };
	
	    var ancestor$2 = function (scope, selector, isRoot) {
	      return ancestor$3(scope, function (e) {
	        return is$2(e, selector);
	      }, isRoot);
	    };
	    var descendant = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$2 = function (scope, selector, isRoot) {
	      var is = function (element, selector) {
	        return is$2(element, selector);
	      };
	      return ClosestOrAncestor(is, ancestor$2, scope, selector, isRoot);
	    };
	
	    var promiseObj = window.Promise ? window.Promise : Promise$1;
	
	    var requestAnimationFramePromise;
	    var requestAnimationFrame = function (callback, element) {
	      var requestAnimationFrameFunc = window.requestAnimationFrame;
	      var vendors = [
	        'ms',
	        'moz',
	        'webkit'
	      ];
	      var featurefill = function (cb) {
	        window.setTimeout(cb, 0);
	      };
	      for (var i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
	        requestAnimationFrameFunc = window[vendors[i] + 'RequestAnimationFrame'];
	      }
	      if (!requestAnimationFrameFunc) {
	        requestAnimationFrameFunc = featurefill;
	      }
	      requestAnimationFrameFunc(callback, element);
	    };
	    var wrappedSetTimeout = function (callback, time) {
	      if (typeof time !== 'number') {
	        time = 0;
	      }
	      return setTimeout(callback, time);
	    };
	    var wrappedSetInterval = function (callback, time) {
	      if (typeof time !== 'number') {
	        time = 1;
	      }
	      return setInterval(callback, time);
	    };
	    var wrappedClearTimeout = function (id) {
	      return clearTimeout(id);
	    };
	    var wrappedClearInterval = function (id) {
	      return clearInterval(id);
	    };
	    var debounce = function (callback, time) {
	      var timer;
	      var func = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        clearTimeout(timer);
	        timer = wrappedSetTimeout(function () {
	          callback.apply(this, args);
	        }, time);
	      };
	      func.stop = function () {
	        clearTimeout(timer);
	      };
	      return func;
	    };
	    var Delay = {
	      requestAnimationFrame: function (callback, element) {
	        if (requestAnimationFramePromise) {
	          requestAnimationFramePromise.then(callback);
	          return;
	        }
	        requestAnimationFramePromise = new promiseObj(function (resolve) {
	          if (!element) {
	            element = document.body;
	          }
	          requestAnimationFrame(resolve, element);
	        }).then(callback);
	      },
	      setTimeout: wrappedSetTimeout,
	      setInterval: wrappedSetInterval,
	      setEditorTimeout: function (editor, callback, time) {
	        return wrappedSetTimeout(function () {
	          if (!editor.removed) {
	            callback();
	          }
	        }, time);
	      },
	      setEditorInterval: function (editor, callback, time) {
	        var timer = wrappedSetInterval(function () {
	          if (!editor.removed) {
	            callback();
	          } else {
	            clearInterval(timer);
	          }
	        }, time);
	        return timer;
	      },
	      debounce: debounce,
	      throttle: debounce,
	      clearInterval: wrappedClearInterval,
	      clearTimeout: wrappedClearTimeout
	    };
	
	    var StyleSheetLoader = function (documentOrShadowRoot, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var idCount = 0;
	      var loadedStates = {};
	      var edos = SugarElement.fromDom(documentOrShadowRoot);
	      var doc = documentOrOwner(edos);
	      var maxLoadTime = settings.maxLoadTime || 5000;
	      var _setReferrerPolicy = function (referrerPolicy) {
	        settings.referrerPolicy = referrerPolicy;
	      };
	      var addStyle = function (element) {
	        append$1(getStyleContainer(edos), element);
	      };
	      var removeStyle = function (id) {
	        var styleContainer = getStyleContainer(edos);
	        descendant(styleContainer, '#' + id).each(remove$7);
	      };
	      var getOrCreateState = function (url) {
	        return get$9(loadedStates, url).getOrThunk(function () {
	          return {
	            id: 'mce-u' + idCount++,
	            passed: [],
	            failed: [],
	            count: 0
	          };
	        });
	      };
	      var load = function (url, success, failure) {
	        var link;
	        var urlWithSuffix = Tools._addCacheSuffix(url);
	        var state = getOrCreateState(urlWithSuffix);
	        loadedStates[urlWithSuffix] = state;
	        state.count++;
	        var resolve = function (callbacks, status) {
	          var i = callbacks.length;
	          while (i--) {
	            callbacks[i]();
	          }
	          state.status = status;
	          state.passed = [];
	          state.failed = [];
	          if (link) {
	            link.onload = null;
	            link.onerror = null;
	            link = null;
	          }
	        };
	        var passed = function () {
	          return resolve(state.passed, 2);
	        };
	        var failed = function () {
	          return resolve(state.failed, 3);
	        };
	        var wait = function (testCallback, waitCallback) {
	          if (!testCallback()) {
	            if (Date.now() - startTime < maxLoadTime) {
	              Delay.setTimeout(waitCallback);
	            } else {
	              failed();
	            }
	          }
	        };
	        var waitForWebKitLinkLoaded = function () {
	          wait(function () {
	            var styleSheets = documentOrShadowRoot.styleSheets;
	            var i = styleSheets.length;
	            while (i--) {
	              var styleSheet = styleSheets[i];
	              var owner = styleSheet.ownerNode;
	              if (owner && owner.id === link.id) {
	                passed();
	                return true;
	              }
	            }
	            return false;
	          }, waitForWebKitLinkLoaded);
	        };
	        if (success) {
	          state.passed.push(success);
	        }
	        if (failure) {
	          state.failed.push(failure);
	        }
	        if (state.status === 1) {
	          return;
	        }
	        if (state.status === 2) {
	          passed();
	          return;
	        }
	        if (state.status === 3) {
	          failed();
	          return;
	        }
	        state.status = 1;
	        var linkElem = SugarElement.fromTag('link', doc.dom);
	        setAll$1(linkElem, {
	          rel: 'stylesheet',
	          type: 'text/css',
	          id: state.id
	        });
	        var startTime = Date.now();
	        if (settings.contentCssCors) {
	          set$1(linkElem, 'crossOrigin', 'anonymous');
	        }
	        if (settings.referrerPolicy) {
	          set$1(linkElem, 'referrerpolicy', settings.referrerPolicy);
	        }
	        link = linkElem.dom;
	        link.onload = waitForWebKitLinkLoaded;
	        link.onerror = failed;
	        addStyle(linkElem);
	        set$1(linkElem, 'href', urlWithSuffix);
	      };
	      var loadF = function (url) {
	        return Future.nu(function (resolve) {
	          load(url, compose(resolve, constant(Result.value(url))), compose(resolve, constant(Result.error(url))));
	        });
	      };
	      var loadAll = function (urls, success, failure) {
	        par(map$3(urls, loadF)).get(function (result) {
	          var parts = partition(result, function (r) {
	            return r.isValue();
	          });
	          if (parts.fail.length > 0) {
	            failure(parts.fail.map(unite));
	          } else {
	            success(parts.pass.map(unite));
	          }
	        });
	      };
	      var unload = function (url) {
	        var urlWithSuffix = Tools._addCacheSuffix(url);
	        get$9(loadedStates, urlWithSuffix).each(function (state) {
	          var count = --state.count;
	          if (count === 0) {
	            delete loadedStates[urlWithSuffix];
	            removeStyle(state.id);
	          }
	        });
	      };
	      var unloadAll = function (urls) {
	        each$k(urls, function (url) {
	          unload(url);
	        });
	      };
	      return {
	        load: load,
	        loadAll: loadAll,
	        unload: unload,
	        unloadAll: unloadAll,
	        _setReferrerPolicy: _setReferrerPolicy
	      };
	    };
	
	    var create$8 = function () {
	      var map = new WeakMap();
	      var forElement = function (referenceElement, settings) {
	        var root = getRootNode(referenceElement);
	        var rootDom = root.dom;
	        return Optional.from(map.get(rootDom)).getOrThunk(function () {
	          var sl = StyleSheetLoader(rootDom, settings);
	          map.set(rootDom, sl);
	          return sl;
	        });
	      };
	      return { forElement: forElement };
	    };
	    var instance = create$8();
	
	    var DomTreeWalker = function () {
	      function DomTreeWalker(startNode, rootNode) {
	        this.node = startNode;
	        this.rootNode = rootNode;
	        this.current = this.current.bind(this);
	        this.next = this.next.bind(this);
	        this.prev = this.prev.bind(this);
	        this.prev2 = this.prev2.bind(this);
	      }
	      DomTreeWalker.prototype.current = function () {
	        return this.node;
	      };
	      DomTreeWalker.prototype.next = function (shallow) {
	        this.node = this.findSibling(this.node, 'firstChild', 'nextSibling', shallow);
	        return this.node;
	      };
	      DomTreeWalker.prototype.prev = function (shallow) {
	        this.node = this.findSibling(this.node, 'lastChild', 'previousSibling', shallow);
	        return this.node;
	      };
	      DomTreeWalker.prototype.prev2 = function (shallow) {
	        this.node = this.findPreviousNode(this.node, 'lastChild', 'previousSibling', shallow);
	        return this.node;
	      };
	      DomTreeWalker.prototype.findSibling = function (node, startName, siblingName, shallow) {
	        var sibling, parent;
	        if (node) {
	          if (!shallow && node[startName]) {
	            return node[startName];
	          }
	          if (node !== this.rootNode) {
	            sibling = node[siblingName];
	            if (sibling) {
	              return sibling;
	            }
	            for (parent = node.parentNode; parent && parent !== this.rootNode; parent = parent.parentNode) {
	              sibling = parent[siblingName];
	              if (sibling) {
	                return sibling;
	              }
	            }
	          }
	        }
	      };
	      DomTreeWalker.prototype.findPreviousNode = function (node, startName, siblingName, shallow) {
	        var sibling, parent, child;
	        if (node) {
	          sibling = node[siblingName];
	          if (this.rootNode && sibling === this.rootNode) {
	            return;
	          }
	          if (sibling) {
	            if (!shallow) {
	              for (child = sibling[startName]; child; child = child[startName]) {
	                if (!child[startName]) {
	                  return child;
	                }
	              }
	            }
	            return sibling;
	          }
	          parent = node.parentNode;
	          if (parent && parent !== this.rootNode) {
	            return parent;
	          }
	        }
	      };
	      return DomTreeWalker;
	    }();
	
	    var blocks = [
	      'article',
	      'aside',
	      'details',
	      'div',
	      'dt',
	      'figcaption',
	      'footer',
	      'form',
	      'fieldset',
	      'header',
	      'hgroup',
	      'html',
	      'main',
	      'nav',
	      'section',
	      'summary',
	      'body',
	      'p',
	      'dl',
	      'multicol',
	      'dd',
	      'figure',
	      'address',
	      'center',
	      'blockquote',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'listing',
	      'xmp',
	      'pre',
	      'plaintext',
	      'menu',
	      'dir',
	      'ul',
	      'ol',
	      'li',
	      'hr',
	      'table',
	      'tbody',
	      'thead',
	      'tfoot',
	      'th',
	      'tr',
	      'td',
	      'caption'
	    ];
	    var tableCells = [
	      'td',
	      'th'
	    ];
	    var tableSections = [
	      'thead',
	      'tbody',
	      'tfoot'
	    ];
	    var textBlocks = [
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'p',
	      'div',
	      'address',
	      'pre',
	      'form',
	      'blockquote',
	      'center',
	      'dir',
	      'fieldset',
	      'header',
	      'footer',
	      'article',
	      'section',
	      'hgroup',
	      'aside',
	      'nav',
	      'figure'
	    ];
	    var headings = [
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6'
	    ];
	    var listItems$1 = [
	      'li',
	      'dd',
	      'dt'
	    ];
	    var lists = [
	      'ul',
	      'ol',
	      'dl'
	    ];
	    var wsElements = [
	      'pre',
	      'script',
	      'textarea',
	      'style'
	    ];
	    var lazyLookup = function (items) {
	      var lookup;
	      return function (node) {
	        lookup = lookup ? lookup : mapToObject(items, always);
	        return has$2(lookup, name(node));
	      };
	    };
	    var isHeading = lazyLookup(headings);
	    var isBlock$2 = lazyLookup(blocks);
	    var isTable$2 = function (node) {
	      return name(node) === 'table';
	    };
	    var isInline$1 = function (node) {
	      return isElement$6(node) && !isBlock$2(node);
	    };
	    var isBr$4 = function (node) {
	      return isElement$6(node) && name(node) === 'br';
	    };
	    var isTextBlock$2 = lazyLookup(textBlocks);
	    var isList = lazyLookup(lists);
	    var isListItem = lazyLookup(listItems$1);
	    var isTableSection = lazyLookup(tableSections);
	    var isTableCell$4 = lazyLookup(tableCells);
	    var isWsPreserveElement = lazyLookup(wsElements);
	
	    var ancestor$1 = function (scope, selector, isRoot) {
	      return ancestor$2(scope, selector, isRoot).isSome();
	    };
	
	    var zeroWidth = '\uFEFF';
	    var nbsp = '\xA0';
	    var isZwsp$1 = function (char) {
	      return char === zeroWidth;
	    };
	    var removeZwsp = function (s) {
	      return s.replace(/\uFEFF/g, '');
	    };
	
	    var ZWSP$1 = zeroWidth;
	    var isZwsp = isZwsp$1;
	    var trim$2 = removeZwsp;
	
	    var isElement$4 = isElement$5;
	    var isText$6 = isText$7;
	    var isCaretContainerBlock$1 = function (node) {
	      if (isText$6(node)) {
	        node = node.parentNode;
	      }
	      return isElement$4(node) && node.hasAttribute('data-mce-caret');
	    };
	    var isCaretContainerInline = function (node) {
	      return isText$6(node) && isZwsp(node.data);
	    };
	    var isCaretContainer$2 = function (node) {
	      return isCaretContainerBlock$1(node) || isCaretContainerInline(node);
	    };
	    var hasContent = function (node) {
	      return node.firstChild !== node.lastChild || !isBr$5(node.firstChild);
	    };
	    var insertInline$1 = function (node, before) {
	      var doc = node.ownerDocument;
	      var textNode = doc.createTextNode(ZWSP$1);
	      var parentNode = node.parentNode;
	      if (!before) {
	        var sibling = node.nextSibling;
	        if (isText$6(sibling)) {
	          if (isCaretContainer$2(sibling)) {
	            return sibling;
	          }
	          if (startsWithCaretContainer$1(sibling)) {
	            sibling.splitText(1);
	            return sibling;
	          }
	        }
	        if (node.nextSibling) {
	          parentNode.insertBefore(textNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(textNode);
	        }
	      } else {
	        var sibling = node.previousSibling;
	        if (isText$6(sibling)) {
	          if (isCaretContainer$2(sibling)) {
	            return sibling;
	          }
	          if (endsWithCaretContainer$1(sibling)) {
	            return sibling.splitText(sibling.data.length - 1);
	          }
	        }
	        parentNode.insertBefore(textNode, node);
	      }
	      return textNode;
	    };
	    var isBeforeInline = function (pos) {
	      var container = pos.container();
	      if (!isText$7(container)) {
	        return false;
	      }
	      return container.data.charAt(pos.offset()) === ZWSP$1 || pos.isAtStart() && isCaretContainerInline(container.previousSibling);
	    };
	    var isAfterInline = function (pos) {
	      var container = pos.container();
	      if (!isText$7(container)) {
	        return false;
	      }
	      return container.data.charAt(pos.offset() - 1) === ZWSP$1 || pos.isAtEnd() && isCaretContainerInline(container.nextSibling);
	    };
	    var createBogusBr = function () {
	      var br = document.createElement('br');
	      br.setAttribute('data-mce-bogus', '1');
	      return br;
	    };
	    var insertBlock$1 = function (blockName, node, before) {
	      var doc = node.ownerDocument;
	      var blockNode = doc.createElement(blockName);
	      blockNode.setAttribute('data-mce-caret', before ? 'before' : 'after');
	      blockNode.setAttribute('data-mce-bogus', 'all');
	      blockNode.appendChild(createBogusBr());
	      var parentNode = node.parentNode;
	      if (!before) {
	        if (node.nextSibling) {
	          parentNode.insertBefore(blockNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(blockNode);
	        }
	      } else {
	        parentNode.insertBefore(blockNode, node);
	      }
	      return blockNode;
	    };
	    var startsWithCaretContainer$1 = function (node) {
	      return isText$6(node) && node.data[0] === ZWSP$1;
	    };
	    var endsWithCaretContainer$1 = function (node) {
	      return isText$6(node) && node.data[node.data.length - 1] === ZWSP$1;
	    };
	    var trimBogusBr = function (elm) {
	      var brs = elm.getElementsByTagName('br');
	      var lastBr = brs[brs.length - 1];
	      if (isBogus$2(lastBr)) {
	        lastBr.parentNode.removeChild(lastBr);
	      }
	    };
	    var showCaretContainerBlock = function (caretContainer) {
	      if (caretContainer && caretContainer.hasAttribute('data-mce-caret')) {
	        trimBogusBr(caretContainer);
	        caretContainer.removeAttribute('data-mce-caret');
	        caretContainer.removeAttribute('data-mce-bogus');
	        caretContainer.removeAttribute('style');
	        caretContainer.removeAttribute('_moz_abspos');
	        return caretContainer;
	      }
	      return null;
	    };
	    var isRangeInCaretContainerBlock = function (range) {
	      return isCaretContainerBlock$1(range.startContainer);
	    };
	
	    var isContentEditableTrue$3 = isContentEditableTrue$4;
	    var isContentEditableFalse$a = isContentEditableFalse$b;
	    var isBr$3 = isBr$5;
	    var isText$5 = isText$7;
	    var isInvalidTextElement = matchNodeNames([
	      'script',
	      'style',
	      'textarea'
	    ]);
	    var isAtomicInline = matchNodeNames([
	      'img',
	      'input',
	      'textarea',
	      'hr',
	      'iframe',
	      'video',
	      'audio',
	      'object',
	      'embed'
	    ]);
	    var isTable$1 = matchNodeNames(['table']);
	    var isCaretContainer$1 = isCaretContainer$2;
	    var isCaretCandidate$3 = function (node) {
	      if (isCaretContainer$1(node)) {
	        return false;
	      }
	      if (isText$5(node)) {
	        return !isInvalidTextElement(node.parentNode);
	      }
	      return isAtomicInline(node) || isBr$3(node) || isTable$1(node) || isNonUiContentEditableFalse(node);
	    };
	    var isUnselectable = function (node) {
	      return isElement$5(node) && node.getAttribute('unselectable') === 'true';
	    };
	    var isNonUiContentEditableFalse = function (node) {
	      return isUnselectable(node) === false && isContentEditableFalse$a(node);
	    };
	    var isInEditable = function (node, root) {
	      for (node = node.parentNode; node && node !== root; node = node.parentNode) {
	        if (isNonUiContentEditableFalse(node)) {
	          return false;
	        }
	        if (isContentEditableTrue$3(node)) {
	          return true;
	        }
	      }
	      return true;
	    };
	    var isAtomicContentEditableFalse = function (node) {
	      if (!isNonUiContentEditableFalse(node)) {
	        return false;
	      }
	      return foldl(from(node.getElementsByTagName('*')), function (result, elm) {
	        return result || isContentEditableTrue$3(elm);
	      }, false) !== true;
	    };
	    var isAtomic$1 = function (node) {
	      return isAtomicInline(node) || isAtomicContentEditableFalse(node);
	    };
	    var isEditableCaretCandidate$1 = function (node, root) {
	      return isCaretCandidate$3(node) && isInEditable(node, root);
	    };
	
	    var whiteSpaceRegExp$1 = /^[ \t\r\n]*$/;
	    var isWhitespaceText = function (text) {
	      return whiteSpaceRegExp$1.test(text);
	    };
	
	    var hasWhitespacePreserveParent = function (node, rootNode) {
	      var rootElement = SugarElement.fromDom(rootNode);
	      var startNode = SugarElement.fromDom(node);
	      return ancestor$1(startNode, 'pre,code', curry(eq, rootElement));
	    };
	    var isWhitespace = function (node, rootNode) {
	      return isText$7(node) && isWhitespaceText(node.data) && hasWhitespacePreserveParent(node, rootNode) === false;
	    };
	    var isNamedAnchor = function (node) {
	      return isElement$5(node) && node.nodeName === 'A' && !node.hasAttribute('href') && (node.hasAttribute('name') || node.hasAttribute('id'));
	    };
	    var isContent$1 = function (node, rootNode) {
	      return isCaretCandidate$3(node) && isWhitespace(node, rootNode) === false || isNamedAnchor(node) || isBookmark(node);
	    };
	    var isBookmark = hasAttribute('data-mce-bookmark');
	    var isBogus$1 = hasAttribute('data-mce-bogus');
	    var isBogusAll = hasAttributeValue('data-mce-bogus', 'all');
	    var isEmptyNode = function (targetNode, skipBogus) {
	      var brCount = 0;
	      if (isContent$1(targetNode, targetNode)) {
	        return false;
	      } else {
	        var node = targetNode.firstChild;
	        if (!node) {
	          return true;
	        }
	        var walker = new DomTreeWalker(node, targetNode);
	        do {
	          if (skipBogus) {
	            if (isBogusAll(node)) {
	              node = walker.next(true);
	              continue;
	            }
	            if (isBogus$1(node)) {
	              node = walker.next();
	              continue;
	            }
	          }
	          if (isBr$5(node)) {
	            brCount++;
	            node = walker.next();
	            continue;
	          }
	          if (isContent$1(node, targetNode)) {
	            return false;
	          }
	          node = walker.next();
	        } while (node);
	        return brCount <= 1;
	      }
	    };
	    var isEmpty$2 = function (elm, skipBogus) {
	      if (skipBogus === void 0) {
	        skipBogus = true;
	      }
	      return isEmptyNode(elm.dom, skipBogus);
	    };
	
	    var isSpan = function (node) {
	      return node.nodeName.toLowerCase() === 'span';
	    };
	    var isInlineContent = function (node, root) {
	      return isNonNullable(node) && (isContent$1(node, root) || isInline$1(SugarElement.fromDom(node)));
	    };
	    var surroundedByInlineContent = function (node, root) {
	      var prev = new DomTreeWalker(node, root).prev(false);
	      var next = new DomTreeWalker(node, root).next(false);
	      var prevIsInline = isUndefined(prev) || isInlineContent(prev, root);
	      var nextIsInline = isUndefined(next) || isInlineContent(next, root);
	      return prevIsInline && nextIsInline;
	    };
	    var isBookmarkNode$2 = function (node) {
	      return isSpan(node) && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	    var isKeepTextNode = function (node, root) {
	      return isText$7(node) && node.data.length > 0 && surroundedByInlineContent(node, root);
	    };
	    var isKeepElement = function (node) {
	      return isElement$5(node) ? node.childNodes.length > 0 : false;
	    };
	    var isDocument = function (node) {
	      return isDocumentFragment(node) || isDocument$1(node);
	    };
	    var trimNode = function (dom, node, root) {
	      var rootNode = root || node;
	      if (isElement$5(node) && isBookmarkNode$2(node)) {
	        return node;
	      }
	      var children = node.childNodes;
	      for (var i = children.length - 1; i >= 0; i--) {
	        trimNode(dom, children[i], rootNode);
	      }
	      if (isElement$5(node)) {
	        var currentChildren = node.childNodes;
	        if (currentChildren.length === 1 && isBookmarkNode$2(currentChildren[0])) {
	          node.parentNode.insertBefore(currentChildren[0], node);
	        }
	      }
	      if (!isDocument(node) && !isContent$1(node, rootNode) && !isKeepElement(node) && !isKeepTextNode(node, rootNode)) {
	        dom.remove(node);
	      }
	      return node;
	    };
	
	    var makeMap$3 = Tools.makeMap;
	    var attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	    var textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	    var rawCharsRegExp = /[<>&\"\']/g;
	    var entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi;
	    var asciiMap = {
	      128: '\u20AC',
	      130: '\u201A',
	      131: '\u0192',
	      132: '\u201E',
	      133: '\u2026',
	      134: '\u2020',
	      135: '\u2021',
	      136: '\u02c6',
	      137: '\u2030',
	      138: '\u0160',
	      139: '\u2039',
	      140: '\u0152',
	      142: '\u017d',
	      145: '\u2018',
	      146: '\u2019',
	      147: '\u201C',
	      148: '\u201D',
	      149: '\u2022',
	      150: '\u2013',
	      151: '\u2014',
	      152: '\u02DC',
	      153: '\u2122',
	      154: '\u0161',
	      155: '\u203A',
	      156: '\u0153',
	      158: '\u017e',
	      159: '\u0178'
	    };
	    var baseEntities = {
	      '"': '&quot;',
	      '\'': '&#39;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '&': '&amp;',
	      '`': '&#96;'
	    };
	    var reverseEntities = {
	      '&lt;': '<',
	      '&gt;': '>',
	      '&amp;': '&',
	      '&quot;': '"',
	      '&apos;': '\''
	    };
	    var nativeDecode = function (text) {
	      var elm = SugarElement.fromTag('div').dom;
	      elm.innerHTML = text;
	      return elm.textContent || elm.innerText || text;
	    };
	    var buildEntitiesLookup = function (items, radix) {
	      var i, chr, entity;
	      var lookup = {};
	      if (items) {
	        items = items.split(',');
	        radix = radix || 10;
	        for (i = 0; i < items.length; i += 2) {
	          chr = String.fromCharCode(parseInt(items[i], radix));
	          if (!baseEntities[chr]) {
	            entity = '&' + items[i + 1] + ';';
	            lookup[chr] = entity;
	            lookup[entity] = chr;
	          }
	        }
	        return lookup;
	      }
	    };
	    var namedEntities = buildEntitiesLookup('50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' + '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' + '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' + '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' + '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' + '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' + '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' + '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' + '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' + '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' + 'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' + 'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' + 't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' + 'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' + 'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' + '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' + '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' + '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' + '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' + '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' + 'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' + 'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' + 'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' + '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' + '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
	    var encodeRaw = function (text, attr) {
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        return baseEntities[chr] || chr;
	      });
	    };
	    var encodeAllRaw = function (text) {
	      return ('' + text).replace(rawCharsRegExp, function (chr) {
	        return baseEntities[chr] || chr;
	      });
	    };
	    var encodeNumeric = function (text, attr) {
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        if (chr.length > 1) {
	          return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
	        }
	        return baseEntities[chr] || '&#' + chr.charCodeAt(0) + ';';
	      });
	    };
	    var encodeNamed = function (text, attr, entities) {
	      entities = entities || namedEntities;
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        return baseEntities[chr] || entities[chr] || chr;
	      });
	    };
	    var getEncodeFunc = function (name, entities) {
	      var entitiesMap = buildEntitiesLookup(entities) || namedEntities;
	      var encodeNamedAndNumeric = function (text, attr) {
	        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	          if (baseEntities[chr] !== undefined) {
	            return baseEntities[chr];
	          }
	          if (entitiesMap[chr] !== undefined) {
	            return entitiesMap[chr];
	          }
	          if (chr.length > 1) {
	            return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
	          }
	          return '&#' + chr.charCodeAt(0) + ';';
	        });
	      };
	      var encodeCustomNamed = function (text, attr) {
	        return encodeNamed(text, attr, entitiesMap);
	      };
	      var nameMap = makeMap$3(name.replace(/\+/g, ','));
	      if (nameMap.named && nameMap.numeric) {
	        return encodeNamedAndNumeric;
	      }
	      if (nameMap.named) {
	        if (entities) {
	          return encodeCustomNamed;
	        }
	        return encodeNamed;
	      }
	      if (nameMap.numeric) {
	        return encodeNumeric;
	      }
	      return encodeRaw;
	    };
	    var decode = function (text) {
	      return text.replace(entityRegExp, function (all, numeric) {
	        if (numeric) {
	          if (numeric.charAt(0).toLowerCase() === 'x') {
	            numeric = parseInt(numeric.substr(1), 16);
	          } else {
	            numeric = parseInt(numeric, 10);
	          }
	          if (numeric > 65535) {
	            numeric -= 65536;
	            return String.fromCharCode(55296 + (numeric >> 10), 56320 + (numeric & 1023));
	          }
	          return asciiMap[numeric] || String.fromCharCode(numeric);
	        }
	        return reverseEntities[all] || namedEntities[all] || nativeDecode(all);
	      });
	    };
	    var Entities = {
	      encodeRaw: encodeRaw,
	      encodeAllRaw: encodeAllRaw,
	      encodeNumeric: encodeNumeric,
	      encodeNamed: encodeNamed,
	      getEncodeFunc: getEncodeFunc,
	      decode: decode
	    };
	
	    var mapCache = {}, dummyObj = {};
	    var makeMap$2 = Tools.makeMap, each$h = Tools.each, extend$5 = Tools.extend, explode$3 = Tools.explode, inArray$2 = Tools.inArray;
	    var split$1 = function (items, delim) {
	      items = Tools.trim(items);
	      return items ? items.split(delim || ' ') : [];
	    };
	    var createMap = function (defaultValue, extendWith) {
	      var value = makeMap$2(defaultValue, ' ', makeMap$2(defaultValue.toUpperCase(), ' '));
	      return extend$5(value, extendWith);
	    };
	    var getTextRootBlockElements = function (schema) {
	      return createMap('td th li dt dd figcaption caption details summary', schema.getTextBlockElements());
	    };
	    var compileSchema = function (type) {
	      var schema = {};
	      var globalAttributes, blockContent;
	      var phrasingContent, flowContent, html4BlockContent, html4PhrasingContent;
	      var add = function (name, attributes, children) {
	        var ni, attributesOrder, element;
	        var arrayToMap = function (array, obj) {
	          var map = {};
	          var i, l;
	          for (i = 0, l = array.length; i < l; i++) {
	            map[array[i]] = obj || {};
	          }
	          return map;
	        };
	        children = children || [];
	        attributes = attributes || '';
	        if (typeof children === 'string') {
	          children = split$1(children);
	        }
	        var names = split$1(name);
	        ni = names.length;
	        while (ni--) {
	          attributesOrder = split$1([
	            globalAttributes,
	            attributes
	          ].join(' '));
	          element = {
	            attributes: arrayToMap(attributesOrder),
	            attributesOrder: attributesOrder,
	            children: arrayToMap(children, dummyObj)
	          };
	          schema[names[ni]] = element;
	        }
	      };
	      var addAttrs = function (name, attributes) {
	        var ni, schemaItem, i, l;
	        var names = split$1(name);
	        ni = names.length;
	        var attrs = split$1(attributes);
	        while (ni--) {
	          schemaItem = schema[names[ni]];
	          for (i = 0, l = attrs.length; i < l; i++) {
	            schemaItem.attributes[attrs[i]] = {};
	            schemaItem.attributesOrder.push(attrs[i]);
	          }
	        }
	      };
	      if (mapCache[type]) {
	        return mapCache[type];
	      }
	      globalAttributes = 'id accesskey class dir lang style tabindex title role';
	      blockContent = 'address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul';
	      phrasingContent = 'a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd ' + 'label map noscript object q s samp script select small span strong sub sup ' + 'textarea u var #text #comment';
	      if (type !== 'html4') {
	        globalAttributes += ' contenteditable contextmenu draggable dropzone ' + 'hidden spellcheck translate';
	        blockContent += ' article aside details dialog figure main header footer hgroup section nav';
	        phrasingContent += ' audio canvas command datalist mark meter output picture ' + 'progress time wbr video ruby bdi keygen';
	      }
	      if (type !== 'html5-strict') {
	        globalAttributes += ' xml:lang';
	        html4PhrasingContent = 'acronym applet basefont big font strike tt';
	        phrasingContent = [
	          phrasingContent,
	          html4PhrasingContent
	        ].join(' ');
	        each$h(split$1(html4PhrasingContent), function (name) {
	          add(name, '', phrasingContent);
	        });
	        html4BlockContent = 'center dir isindex noframes';
	        blockContent = [
	          blockContent,
	          html4BlockContent
	        ].join(' ');
	        flowContent = [
	          blockContent,
	          phrasingContent
	        ].join(' ');
	        each$h(split$1(html4BlockContent), function (name) {
	          add(name, '', flowContent);
	        });
	      }
	      flowContent = flowContent || [
	        blockContent,
	        phrasingContent
	      ].join(' ');
	      add('html', 'manifest', 'head body');
	      add('head', '', 'base command link meta noscript script style title');
	      add('title hr noscript br');
	      add('base', 'href target');
	      add('link', 'href rel media hreflang type sizes hreflang');
	      add('meta', 'name http-equiv content charset');
	      add('style', 'media type scoped');
	      add('script', 'src async defer type charset');
	      add('body', 'onafterprint onbeforeprint onbeforeunload onblur onerror onfocus ' + 'onhashchange onload onmessage onoffline ononline onpagehide onpageshow ' + 'onpopstate onresize onscroll onstorage onunload', flowContent);
	      add('address dt dd div caption', '', flowContent);
	      add('h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn', '', phrasingContent);
	      add('blockquote', 'cite', flowContent);
	      add('ol', 'reversed start type', 'li');
	      add('ul', '', 'li');
	      add('li', 'value', flowContent);
	      add('dl', '', 'dt dd');
	      add('a', 'href target rel media hreflang type', phrasingContent);
	      add('q', 'cite', phrasingContent);
	      add('ins del', 'cite datetime', flowContent);
	      add('img', 'src sizes srcset alt usemap ismap width height');
	      add('iframe', 'src name width height', flowContent);
	      add('embed', 'src type width height');
	      add('object', 'data type typemustmatch name usemap form width height', [
	        flowContent,
	        'param'
	      ].join(' '));
	      add('param', 'name value');
	      add('map', 'name', [
	        flowContent,
	        'area'
	      ].join(' '));
	      add('area', 'alt coords shape href target rel media hreflang type');
	      add('table', 'border', 'caption colgroup thead tfoot tbody tr' + (type === 'html4' ? ' col' : ''));
	      add('colgroup', 'span', 'col');
	      add('col', 'span');
	      add('tbody thead tfoot', '', 'tr');
	      add('tr', '', 'td th');
	      add('td', 'colspan rowspan headers', flowContent);
	      add('th', 'colspan rowspan headers scope abbr', flowContent);
	      add('form', 'accept-charset action autocomplete enctype method name novalidate target', flowContent);
	      add('fieldset', 'disabled form name', [
	        flowContent,
	        'legend'
	      ].join(' '));
	      add('label', 'form for', phrasingContent);
	      add('input', 'accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate ' + 'formtarget height list max maxlength min multiple name pattern readonly required size src step type value width');
	      add('button', 'disabled form formaction formenctype formmethod formnovalidate formtarget name type value', type === 'html4' ? flowContent : phrasingContent);
	      add('select', 'disabled form multiple name required size', 'option optgroup');
	      add('optgroup', 'disabled label', 'option');
	      add('option', 'disabled label selected value');
	      add('textarea', 'cols dirname disabled form maxlength name readonly required rows wrap');
	      add('menu', 'type label', [
	        flowContent,
	        'li'
	      ].join(' '));
	      add('noscript', '', flowContent);
	      if (type !== 'html4') {
	        add('wbr');
	        add('ruby', '', [
	          phrasingContent,
	          'rt rp'
	        ].join(' '));
	        add('figcaption', '', flowContent);
	        add('mark rt rp summary bdi', '', phrasingContent);
	        add('canvas', 'width height', flowContent);
	        add('video', 'src crossorigin poster preload autoplay mediagroup loop ' + 'muted controls width height buffered', [
	          flowContent,
	          'track source'
	        ].join(' '));
	        add('audio', 'src crossorigin preload autoplay mediagroup loop muted controls ' + 'buffered volume', [
	          flowContent,
	          'track source'
	        ].join(' '));
	        add('picture', '', 'img source');
	        add('source', 'src srcset type media sizes');
	        add('track', 'kind src srclang label default');
	        add('datalist', '', [
	          phrasingContent,
	          'option'
	        ].join(' '));
	        add('article section nav aside main header footer', '', flowContent);
	        add('hgroup', '', 'h1 h2 h3 h4 h5 h6');
	        add('figure', '', [
	          flowContent,
	          'figcaption'
	        ].join(' '));
	        add('time', 'datetime', phrasingContent);
	        add('dialog', 'open', flowContent);
	        add('command', 'type label icon disabled checked radiogroup command');
	        add('output', 'for form name', phrasingContent);
	        add('progress', 'value max', phrasingContent);
	        add('meter', 'value min max low high optimum', phrasingContent);
	        add('details', 'open', [
	          flowContent,
	          'summary'
	        ].join(' '));
	        add('keygen', 'autofocus challenge disabled form keytype name');
	      }
	      if (type !== 'html5-strict') {
	        addAttrs('script', 'language xml:space');
	        addAttrs('style', 'xml:space');
	        addAttrs('object', 'declare classid code codebase codetype archive standby align border hspace vspace');
	        addAttrs('embed', 'align name hspace vspace');
	        addAttrs('param', 'valuetype type');
	        addAttrs('a', 'charset name rev shape coords');
	        addAttrs('br', 'clear');
	        addAttrs('applet', 'codebase archive code object alt name width height align hspace vspace');
	        addAttrs('img', 'name longdesc align border hspace vspace');
	        addAttrs('iframe', 'longdesc frameborder marginwidth marginheight scrolling align');
	        addAttrs('font basefont', 'size color face');
	        addAttrs('input', 'usemap align');
	        addAttrs('select');
	        addAttrs('textarea');
	        addAttrs('h1 h2 h3 h4 h5 h6 div p legend caption', 'align');
	        addAttrs('ul', 'type compact');
	        addAttrs('li', 'type');
	        addAttrs('ol dl menu dir', 'compact');
	        addAttrs('pre', 'width xml:space');
	        addAttrs('hr', 'align noshade size width');
	        addAttrs('isindex', 'prompt');
	        addAttrs('table', 'summary width frame rules cellspacing cellpadding align bgcolor');
	        addAttrs('col', 'width align char charoff valign');
	        addAttrs('colgroup', 'width align char charoff valign');
	        addAttrs('thead', 'align char charoff valign');
	        addAttrs('tr', 'align char charoff valign bgcolor');
	        addAttrs('th', 'axis align char charoff valign nowrap bgcolor width height');
	        addAttrs('form', 'accept');
	        addAttrs('td', 'abbr axis scope align char charoff valign nowrap bgcolor width height');
	        addAttrs('tfoot', 'align char charoff valign');
	        addAttrs('tbody', 'align char charoff valign');
	        addAttrs('area', 'nohref');
	        addAttrs('body', 'background bgcolor text link vlink alink');
	      }
	      if (type !== 'html4') {
	        addAttrs('input button select textarea', 'autofocus');
	        addAttrs('input textarea', 'placeholder');
	        addAttrs('a', 'download');
	        addAttrs('link script img', 'crossorigin');
	        addAttrs('img', 'loading');
	        addAttrs('iframe', 'sandbox seamless allowfullscreen loading');
	      }
	      each$h(split$1('a form meter progress dfn'), function (name) {
	        if (schema[name]) {
	          delete schema[name].children[name];
	        }
	      });
	      delete schema.caption.children.table;
	      delete schema.script;
	      mapCache[type] = schema;
	      return schema;
	    };
	    var compileElementMap = function (value, mode) {
	      var styles;
	      if (value) {
	        styles = {};
	        if (typeof value === 'string') {
	          value = { '*': value };
	        }
	        each$h(value, function (value, key) {
	          styles[key] = styles[key.toUpperCase()] = mode === 'map' ? makeMap$2(value, /[, ]/) : explode$3(value, /[, ]/);
	        });
	      }
	      return styles;
	    };
	    var Schema = function (settings) {
	      var elements = {};
	      var children = {};
	      var patternElements = [];
	      var customElementsMap = {}, specialElements = {};
	      var createLookupTable = function (option, defaultValue, extendWith) {
	        var value = settings[option];
	        if (!value) {
	          value = mapCache[option];
	          if (!value) {
	            value = createMap(defaultValue, extendWith);
	            mapCache[option] = value;
	          }
	        } else {
	          value = makeMap$2(value, /[, ]/, makeMap$2(value.toUpperCase(), /[, ]/));
	        }
	        return value;
	      };
	      settings = settings || {};
	      var schemaItems = compileSchema(settings.schema);
	      if (settings.verify_html === false) {
	        settings.valid_elements = '*[*]';
	      }
	      var validStyles = compileElementMap(settings.valid_styles);
	      var invalidStyles = compileElementMap(settings.invalid_styles, 'map');
	      var validClasses = compileElementMap(settings.valid_classes, 'map');
	      var whiteSpaceElementsMap = createLookupTable('whitespace_elements', 'pre script noscript style textarea video audio iframe object code');
	      var selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
	      var shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' + 'meta param embed source wbr track');
	      var boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' + 'noshade nowrap readonly selected autoplay loop controls');
	      var nonEmptyOrMoveCaretBeforeOnEnter = 'td th iframe video audio object script code';
	      var nonEmptyElementsMap = createLookupTable('non_empty_elements', nonEmptyOrMoveCaretBeforeOnEnter + ' pre', shortEndedElementsMap);
	      var moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', nonEmptyOrMoveCaretBeforeOnEnter + ' table', shortEndedElementsMap);
	      var textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' + 'blockquote center dir fieldset header footer article section hgroup aside main nav figure');
	      var blockElementsMap = createLookupTable('block_elements', 'hr table tbody thead tfoot ' + 'th tr td li ol ul caption dl dt dd noscript menu isindex option ' + 'datalist select optgroup figcaption details summary', textBlockElementsMap);
	      var textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font s strike u var cite ' + 'dfn code mark q sup sub samp');
	      each$h((settings.special || 'script noscript iframe noframes noembed title style textarea xmp').split(' '), function (name) {
	        specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
	      });
	      var patternToRegExp = function (str) {
	        return new RegExp('^' + str.replace(/([?+*])/g, '.$1') + '$');
	      };
	      var addValidElements = function (validElements) {
	        var ei, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder, prefix, outputName, globalAttributes, globalAttributesOrder, value;
	        var elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)])?$/, attrRuleRegExp = /^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/, hasPatternsRegExp = /[*?+]/;
	        if (validElements) {
	          var validElementsArr = split$1(validElements, ',');
	          if (elements['@']) {
	            globalAttributes = elements['@'].attributes;
	            globalAttributesOrder = elements['@'].attributesOrder;
	          }
	          for (ei = 0, el = validElementsArr.length; ei < el; ei++) {
	            matches = elementRuleRegExp.exec(validElementsArr[ei]);
	            if (matches) {
	              prefix = matches[1];
	              elementName = matches[2];
	              outputName = matches[3];
	              attrData = matches[5];
	              attributes = {};
	              attributesOrder = [];
	              element = {
	                attributes: attributes,
	                attributesOrder: attributesOrder
	              };
	              if (prefix === '#') {
	                element.paddEmpty = true;
	              }
	              if (prefix === '-') {
	                element.removeEmpty = true;
	              }
	              if (matches[4] === '!') {
	                element.removeEmptyAttrs = true;
	              }
	              if (globalAttributes) {
	                each$j(globalAttributes, function (value, key) {
	                  attributes[key] = value;
	                });
	                attributesOrder.push.apply(attributesOrder, globalAttributesOrder);
	              }
	              if (attrData) {
	                attrData = split$1(attrData, '|');
	                for (ai = 0, al = attrData.length; ai < al; ai++) {
	                  matches = attrRuleRegExp.exec(attrData[ai]);
	                  if (matches) {
	                    attr = {};
	                    attrType = matches[1];
	                    attrName = matches[2].replace(/[\\:]:/g, ':');
	                    prefix = matches[3];
	                    value = matches[4];
	                    if (attrType === '!') {
	                      element.attributesRequired = element.attributesRequired || [];
	                      element.attributesRequired.push(attrName);
	                      attr.required = true;
	                    }
	                    if (attrType === '-') {
	                      delete attributes[attrName];
	                      attributesOrder.splice(inArray$2(attributesOrder, attrName), 1);
	                      continue;
	                    }
	                    if (prefix) {
	                      if (prefix === '=') {
	                        element.attributesDefault = element.attributesDefault || [];
	                        element.attributesDefault.push({
	                          name: attrName,
	                          value: value
	                        });
	                        attr.defaultValue = value;
	                      }
	                      if (prefix === ':') {
	                        element.attributesForced = element.attributesForced || [];
	                        element.attributesForced.push({
	                          name: attrName,
	                          value: value
	                        });
	                        attr.forcedValue = value;
	                      }
	                      if (prefix === '<') {
	                        attr.validValues = makeMap$2(value, '?');
	                      }
	                    }
	                    if (hasPatternsRegExp.test(attrName)) {
	                      element.attributePatterns = element.attributePatterns || [];
	                      attr.pattern = patternToRegExp(attrName);
	                      element.attributePatterns.push(attr);
	                    } else {
	                      if (!attributes[attrName]) {
	                        attributesOrder.push(attrName);
	                      }
	                      attributes[attrName] = attr;
	                    }
	                  }
	                }
	              }
	              if (!globalAttributes && elementName === '@') {
	                globalAttributes = attributes;
	                globalAttributesOrder = attributesOrder;
	              }
	              if (outputName) {
	                element.outputName = elementName;
	                elements[outputName] = element;
	              }
	              if (hasPatternsRegExp.test(elementName)) {
	                element.pattern = patternToRegExp(elementName);
	                patternElements.push(element);
	              } else {
	                elements[elementName] = element;
	              }
	            }
	          }
	        }
	      };
	      var setValidElements = function (validElements) {
	        elements = {};
	        patternElements = [];
	        addValidElements(validElements);
	        each$h(schemaItems, function (element, name) {
	          children[name] = element.children;
	        });
	      };
	      var addCustomElements = function (customElements) {
	        var customElementRegExp = /^(~)?(.+)$/;
	        if (customElements) {
	          mapCache.text_block_elements = mapCache.block_elements = null;
	          each$h(split$1(customElements, ','), function (rule) {
	            var matches = customElementRegExp.exec(rule), inline = matches[1] === '~', cloneName = inline ? 'span' : 'div', name = matches[2];
	            children[name] = children[cloneName];
	            customElementsMap[name] = cloneName;
	            if (!inline) {
	              blockElementsMap[name.toUpperCase()] = {};
	              blockElementsMap[name] = {};
	            }
	            if (!elements[name]) {
	              var customRule = elements[cloneName];
	              customRule = extend$5({}, customRule);
	              delete customRule.removeEmptyAttrs;
	              delete customRule.removeEmpty;
	              elements[name] = customRule;
	            }
	            each$h(children, function (element, elmName) {
	              if (element[cloneName]) {
	                children[elmName] = element = extend$5({}, children[elmName]);
	                element[name] = element[cloneName];
	              }
	            });
	          });
	        }
	      };
	      var addValidChildren = function (validChildren) {
	        var childRuleRegExp = /^([+\-]?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)\[([^\]]+)]$/;
	        mapCache[settings.schema] = null;
	        if (validChildren) {
	          each$h(split$1(validChildren, ','), function (rule) {
	            var matches = childRuleRegExp.exec(rule);
	            var parent, prefix;
	            if (matches) {
	              prefix = matches[1];
	              if (prefix) {
	                parent = children[matches[2]];
	              } else {
	                parent = children[matches[2]] = { '#comment': {} };
	              }
	              parent = children[matches[2]];
	              each$h(split$1(matches[3], '|'), function (child) {
	                if (prefix === '-') {
	                  delete parent[child];
	                } else {
	                  parent[child] = {};
	                }
	              });
	            }
	          });
	        }
	      };
	      var getElementRule = function (name) {
	        var element = elements[name], i;
	        if (element) {
	          return element;
	        }
	        i = patternElements.length;
	        while (i--) {
	          element = patternElements[i];
	          if (element.pattern.test(name)) {
	            return element;
	          }
	        }
	      };
	      if (!settings.valid_elements) {
	        each$h(schemaItems, function (element, name) {
	          elements[name] = {
	            attributes: element.attributes,
	            attributesOrder: element.attributesOrder
	          };
	          children[name] = element.children;
	        });
	        if (settings.schema !== 'html5') {
	          each$h(split$1('strong/b em/i'), function (item) {
	            var items = split$1(item, '/');
	            elements[items[1]].outputName = items[0];
	          });
	        }
	        each$h(textInlineElementsMap, function (_val, name) {
	          if (elements[name]) {
	            if (settings.padd_empty_block_inline_children) {
	              elements[name].paddInEmptyBlock = true;
	            }
	            elements[name].removeEmpty = true;
	          }
	        });
	        each$h(split$1('ol ul blockquote a table tbody'), function (name) {
	          if (elements[name]) {
	            elements[name].removeEmpty = true;
	          }
	        });
	        each$h(split$1('p h1 h2 h3 h4 h5 h6 th td pre div address caption li'), function (name) {
	          elements[name].paddEmpty = true;
	        });
	        each$h(split$1('span'), function (name) {
	          elements[name].removeEmptyAttrs = true;
	        });
	      } else {
	        setValidElements(settings.valid_elements);
	      }
	      addCustomElements(settings.custom_elements);
	      addValidChildren(settings.valid_children);
	      addValidElements(settings.extended_valid_elements);
	      addValidChildren('+ol[ul|ol],+ul[ul|ol]');
	      each$h({
	        dd: 'dl',
	        dt: 'dl',
	        li: 'ul ol',
	        td: 'tr',
	        th: 'tr',
	        tr: 'tbody thead tfoot',
	        tbody: 'table',
	        thead: 'table',
	        tfoot: 'table',
	        legend: 'fieldset',
	        area: 'map',
	        param: 'video audio object'
	      }, function (parents, item) {
	        if (elements[item]) {
	          elements[item].parentsRequired = split$1(parents);
	        }
	      });
	      if (settings.invalid_elements) {
	        each$h(explode$3(settings.invalid_elements), function (item) {
	          if (elements[item]) {
	            delete elements[item];
	          }
	        });
	      }
	      if (!getElementRule('span')) {
	        addValidElements('span[!data-mce-type|*]');
	      }
	      var getValidStyles = constant(validStyles);
	      var getInvalidStyles = constant(invalidStyles);
	      var getValidClasses = constant(validClasses);
	      var getBoolAttrs = constant(boolAttrMap);
	      var getBlockElements = constant(blockElementsMap);
	      var getTextBlockElements = constant(textBlockElementsMap);
	      var getTextInlineElements = constant(textInlineElementsMap);
	      var getShortEndedElements = constant(shortEndedElementsMap);
	      var getSelfClosingElements = constant(selfClosingElementsMap);
	      var getNonEmptyElements = constant(nonEmptyElementsMap);
	      var getMoveCaretBeforeOnEnterElements = constant(moveCaretBeforeOnEnterElementsMap);
	      var getWhiteSpaceElements = constant(whiteSpaceElementsMap);
	      var getSpecialElements = constant(specialElements);
	      var isValidChild = function (name, child) {
	        var parent = children[name.toLowerCase()];
	        return !!(parent && parent[child.toLowerCase()]);
	      };
	      var isValid = function (name, attr) {
	        var attrPatterns, i;
	        var rule = getElementRule(name);
	        if (rule) {
	          if (attr) {
	            if (rule.attributes[attr]) {
	              return true;
	            }
	            attrPatterns = rule.attributePatterns;
	            if (attrPatterns) {
	              i = attrPatterns.length;
	              while (i--) {
	                if (attrPatterns[i].pattern.test(name)) {
	                  return true;
	                }
	              }
	            }
	          } else {
	            return true;
	          }
	        }
	        return false;
	      };
	      var getCustomElements = constant(customElementsMap);
	      return {
	        children: children,
	        elements: elements,
	        getValidStyles: getValidStyles,
	        getValidClasses: getValidClasses,
	        getBlockElements: getBlockElements,
	        getInvalidStyles: getInvalidStyles,
	        getShortEndedElements: getShortEndedElements,
	        getTextBlockElements: getTextBlockElements,
	        getTextInlineElements: getTextInlineElements,
	        getBoolAttrs: getBoolAttrs,
	        getElementRule: getElementRule,
	        getSelfClosingElements: getSelfClosingElements,
	        getNonEmptyElements: getNonEmptyElements,
	        getMoveCaretBeforeOnEnterElements: getMoveCaretBeforeOnEnterElements,
	        getWhiteSpaceElements: getWhiteSpaceElements,
	        getSpecialElements: getSpecialElements,
	        isValidChild: isValidChild,
	        isValid: isValid,
	        getCustomElements: getCustomElements,
	        addValidElements: addValidElements,
	        setValidElements: setValidElements,
	        addCustomElements: addCustomElements,
	        addValidChildren: addValidChildren
	      };
	    };
	
	    var toHex = function (match, r, g, b) {
	      var hex = function (val) {
	        val = parseInt(val, 10).toString(16);
	        return val.length > 1 ? val : '0' + val;
	      };
	      return '#' + hex(r) + hex(g) + hex(b);
	    };
	    var Styles = function (settings, schema) {
	      var _this = this;
	      var rgbRegExp = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi;
	      var urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi;
	      var styleRegExp = /\s*([^:]+):\s*([^;]+);?/g;
	      var trimRightRegExp = /\s+$/;
	      var i;
	      var encodingLookup = {};
	      var validStyles;
	      var invalidStyles;
	      var invisibleChar = zeroWidth;
	      settings = settings || {};
	      if (schema) {
	        validStyles = schema.getValidStyles();
	        invalidStyles = schema.getInvalidStyles();
	      }
	      var encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
	      for (i = 0; i < encodingItems.length; i++) {
	        encodingLookup[encodingItems[i]] = invisibleChar + i;
	        encodingLookup[invisibleChar + i] = encodingItems[i];
	      }
	      return {
	        toHex: function (color) {
	          return color.replace(rgbRegExp, toHex);
	        },
	        parse: function (css) {
	          var styles = {};
	          var matches, name, value, isEncoded;
	          var urlConverter = settings.url_converter;
	          var urlConverterScope = settings.url_converter_scope || _this;
	          var compress = function (prefix, suffix, noJoin) {
	            var top = styles[prefix + '-top' + suffix];
	            if (!top) {
	              return;
	            }
	            var right = styles[prefix + '-right' + suffix];
	            if (!right) {
	              return;
	            }
	            var bottom = styles[prefix + '-bottom' + suffix];
	            if (!bottom) {
	              return;
	            }
	            var left = styles[prefix + '-left' + suffix];
	            if (!left) {
	              return;
	            }
	            var box = [
	              top,
	              right,
	              bottom,
	              left
	            ];
	            i = box.length - 1;
	            while (i--) {
	              if (box[i] !== box[i + 1]) {
	                break;
	              }
	            }
	            if (i > -1 && noJoin) {
	              return;
	            }
	            styles[prefix + suffix] = i === -1 ? box[0] : box.join(' ');
	            delete styles[prefix + '-top' + suffix];
	            delete styles[prefix + '-right' + suffix];
	            delete styles[prefix + '-bottom' + suffix];
	            delete styles[prefix + '-left' + suffix];
	          };
	          var canCompress = function (key) {
	            var value = styles[key], i;
	            if (!value) {
	              return;
	            }
	            value = value.split(' ');
	            i = value.length;
	            while (i--) {
	              if (value[i] !== value[0]) {
	                return false;
	              }
	            }
	            styles[key] = value[0];
	            return true;
	          };
	          var compress2 = function (target, a, b, c) {
	            if (!canCompress(a)) {
	              return;
	            }
	            if (!canCompress(b)) {
	              return;
	            }
	            if (!canCompress(c)) {
	              return;
	            }
	            styles[target] = styles[a] + ' ' + styles[b] + ' ' + styles[c];
	            delete styles[a];
	            delete styles[b];
	            delete styles[c];
	          };
	          var encode = function (str) {
	            isEncoded = true;
	            return encodingLookup[str];
	          };
	          var decode = function (str, keepSlashes) {
	            if (isEncoded) {
	              str = str.replace(/\uFEFF[0-9]/g, function (str) {
	                return encodingLookup[str];
	              });
	            }
	            if (!keepSlashes) {
	              str = str.replace(/\\([\'\";:])/g, '$1');
	            }
	            return str;
	          };
	          var decodeSingleHexSequence = function (escSeq) {
	            return String.fromCharCode(parseInt(escSeq.slice(1), 16));
	          };
	          var decodeHexSequences = function (value) {
	            return value.replace(/\\[0-9a-f]+/gi, decodeSingleHexSequence);
	          };
	          var processUrl = function (match, url, url2, url3, str, str2) {
	            str = str || str2;
	            if (str) {
	              str = decode(str);
	              return '\'' + str.replace(/\'/g, '\\\'') + '\'';
	            }
	            url = decode(url || url2 || url3);
	            if (!settings.allow_script_urls) {
	              var scriptUrl = url.replace(/[\s\r\n]+/g, '');
	              if (/(java|vb)script:/i.test(scriptUrl)) {
	                return '';
	              }
	              if (!settings.allow_svg_data_urls && /^data:image\/svg/i.test(scriptUrl)) {
	                return '';
	              }
	            }
	            if (urlConverter) {
	              url = urlConverter.call(urlConverterScope, url, 'style');
	            }
	            return 'url(\'' + url.replace(/\'/g, '\\\'') + '\')';
	          };
	          if (css) {
	            css = css.replace(/[\u0000-\u001F]/g, '');
	            css = css.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function (str) {
	              return str.replace(/[;:]/g, encode);
	            });
	            while (matches = styleRegExp.exec(css)) {
	              styleRegExp.lastIndex = matches.index + matches[0].length;
	              name = matches[1].replace(trimRightRegExp, '').toLowerCase();
	              value = matches[2].replace(trimRightRegExp, '');
	              if (name && value) {
	                name = decodeHexSequences(name);
	                value = decodeHexSequences(value);
	                if (name.indexOf(invisibleChar) !== -1 || name.indexOf('"') !== -1) {
	                  continue;
	                }
	                if (!settings.allow_script_urls && (name === 'behavior' || /expression\s*\(|\/\*|\*\//.test(value))) {
	                  continue;
	                }
	                if (name === 'font-weight' && value === '700') {
	                  value = 'bold';
	                } else if (name === 'color' || name === 'background-color') {
	                  value = value.toLowerCase();
	                }
	                value = value.replace(rgbRegExp, toHex);
	                value = value.replace(urlOrStrRegExp, processUrl);
	                styles[name] = isEncoded ? decode(value, true) : value;
	              }
	            }
	            compress('border', '', true);
	            compress('border', '-width');
	            compress('border', '-color');
	            compress('border', '-style');
	            compress('padding', '');
	            compress('margin', '');
	            compress2('border', 'border-width', 'border-style', 'border-color');
	            if (styles.border === 'medium none') {
	              delete styles.border;
	            }
	            if (styles['border-image'] === 'none') {
	              delete styles['border-image'];
	            }
	          }
	          return styles;
	        },
	        serialize: function (styles, elementName) {
	          var css = '';
	          var serializeStyles = function (name) {
	            var value;
	            var styleList = validStyles[name];
	            if (styleList) {
	              for (var i_1 = 0, l = styleList.length; i_1 < l; i_1++) {
	                name = styleList[i_1];
	                value = styles[name];
	                if (value) {
	                  css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	                }
	              }
	            }
	          };
	          var isValid = function (name, elementName) {
	            var styleMap = invalidStyles['*'];
	            if (styleMap && styleMap[name]) {
	              return false;
	            }
	            styleMap = invalidStyles[elementName];
	            return !(styleMap && styleMap[name]);
	          };
	          if (elementName && validStyles) {
	            serializeStyles('*');
	            serializeStyles(elementName);
	          } else {
	            each$j(styles, function (value, name) {
	              if (value && (!invalidStyles || isValid(name, elementName))) {
	                css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	              }
	            });
	          }
	          return css;
	        }
	      };
	    };
	
	    var deprecated = {
	      keyLocation: true,
	      layerX: true,
	      layerY: true,
	      returnValue: true,
	      webkitMovementX: true,
	      webkitMovementY: true,
	      keyIdentifier: true,
	      mozPressure: true
	    };
	    var isNativeEvent = function (event) {
	      return event instanceof Event || isFunction(event.initEvent);
	    };
	    var hasIsDefaultPrevented = function (event) {
	      return event.isDefaultPrevented === always || event.isDefaultPrevented === never;
	    };
	    var needsNormalizing = function (event) {
	      return isNullable(event.preventDefault) || isNativeEvent(event);
	    };
	    var clone$2 = function (originalEvent, data) {
	      var event = data !== null && data !== void 0 ? data : {};
	      for (var name_1 in originalEvent) {
	        if (!has$2(deprecated, name_1)) {
	          event[name_1] = originalEvent[name_1];
	        }
	      }
	      if (isNonNullable(event.composedPath)) {
	        event.composedPath = function () {
	          return originalEvent.composedPath();
	        };
	      }
	      return event;
	    };
	    var normalize$3 = function (type, originalEvent, fallbackTarget, data) {
	      var _a;
	      var event = clone$2(originalEvent, data);
	      event.type = type;
	      if (isNullable(event.target)) {
	        event.target = (_a = event.srcElement) !== null && _a !== void 0 ? _a : fallbackTarget;
	      }
	      if (needsNormalizing(originalEvent)) {
	        event.preventDefault = function () {
	          event.defaultPrevented = true;
	          event.isDefaultPrevented = always;
	          if (isFunction(originalEvent.preventDefault)) {
	            originalEvent.preventDefault();
	          } else if (isNativeEvent(originalEvent)) {
	            originalEvent.returnValue = false;
	          }
	        };
	        event.stopPropagation = function () {
	          event.cancelBubble = true;
	          event.isPropagationStopped = always;
	          if (isFunction(originalEvent.stopPropagation)) {
	            originalEvent.stopPropagation();
	          } else if (isNativeEvent(originalEvent)) {
	            originalEvent.cancelBubble = true;
	          }
	        };
	        event.stopImmediatePropagation = function () {
	          event.isImmediatePropagationStopped = always;
	          event.stopPropagation();
	        };
	        if (!hasIsDefaultPrevented(event)) {
	          event.isDefaultPrevented = event.defaultPrevented === true ? always : never;
	          event.isPropagationStopped = event.cancelBubble === true ? always : never;
	          event.isImmediatePropagationStopped = never;
	        }
	      }
	      return event;
	    };
	
	    var eventExpandoPrefix = 'mce-data-';
	    var mouseEventRe = /^(?:mouse|contextmenu)|click/;
	    var addEvent = function (target, name, callback, capture) {
	      if (target.addEventListener) {
	        target.addEventListener(name, callback, capture || false);
	      } else if (target.attachEvent) {
	        target.attachEvent('on' + name, callback);
	      }
	    };
	    var removeEvent = function (target, name, callback, capture) {
	      if (target.removeEventListener) {
	        target.removeEventListener(name, callback, capture || false);
	      } else if (target.detachEvent) {
	        target.detachEvent('on' + name, callback);
	      }
	    };
	    var isMouseEvent = function (event) {
	      return isNonNullable(event) && mouseEventRe.test(event.type);
	    };
	    var fix = function (originalEvent, data) {
	      var event = normalize$3(originalEvent.type, originalEvent, document, data);
	      if (isMouseEvent(originalEvent) && isUndefined(originalEvent.pageX) && !isUndefined(originalEvent.clientX)) {
	        var eventDoc = event.target.ownerDocument || document;
	        var doc = eventDoc.documentElement;
	        var body = eventDoc.body;
	        var mouseEvent = event;
	        mouseEvent.pageX = originalEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	        mouseEvent.pageY = originalEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	      }
	      if (isUndefined(event.metaKey)) {
	        event.metaKey = false;
	      }
	      return event;
	    };
	    var bindOnReady = function (win, callback, eventUtils) {
	      var doc = win.document, event = { type: 'ready' };
	      if (eventUtils.domLoaded) {
	        callback(event);
	        return;
	      }
	      var isDocReady = function () {
	        return doc.readyState === 'complete' || doc.readyState === 'interactive' && doc.body;
	      };
	      var readyHandler = function () {
	        removeEvent(win, 'DOMContentLoaded', readyHandler);
	        removeEvent(win, 'load', readyHandler);
	        if (!eventUtils.domLoaded) {
	          eventUtils.domLoaded = true;
	          callback(event);
	        }
	        win = null;
	      };
	      if (isDocReady()) {
	        readyHandler();
	      } else {
	        addEvent(win, 'DOMContentLoaded', readyHandler);
	      }
	      if (!eventUtils.domLoaded) {
	        addEvent(win, 'load', readyHandler);
	      }
	    };
	    var EventUtils = function () {
	      function EventUtils() {
	        this.domLoaded = false;
	        this.events = {};
	        this.count = 1;
	        this.expando = eventExpandoPrefix + (+new Date()).toString(32);
	        this.hasMouseEnterLeave = 'onmouseenter' in document.documentElement;
	        this.hasFocusIn = 'onfocusin' in document.documentElement;
	        this.count = 1;
	      }
	      EventUtils.prototype.bind = function (target, names, callback, scope) {
	        var self = this;
	        var id, callbackList, i, name, fakeName, nativeHandler, capture;
	        var win = window;
	        var defaultNativeHandler = function (evt) {
	          self.executeHandlers(fix(evt || win.event), id);
	        };
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return;
	        }
	        if (!target[self.expando]) {
	          id = self.count++;
	          target[self.expando] = id;
	          self.events[id] = {};
	        } else {
	          id = target[self.expando];
	        }
	        scope = scope || target;
	        var namesList = names.split(' ');
	        i = namesList.length;
	        while (i--) {
	          name = namesList[i];
	          nativeHandler = defaultNativeHandler;
	          fakeName = capture = false;
	          if (name === 'DOMContentLoaded') {
	            name = 'ready';
	          }
	          if (self.domLoaded && name === 'ready' && target.readyState === 'complete') {
	            callback.call(scope, fix({ type: name }));
	            continue;
	          }
	          if (!self.hasMouseEnterLeave) {
	            fakeName = self.mouseEnterLeave[name];
	            if (fakeName) {
	              nativeHandler = function (evt) {
	                var current = evt.currentTarget;
	                var related = evt.relatedTarget;
	                if (related && current.contains) {
	                  related = current.contains(related);
	                } else {
	                  while (related && related !== current) {
	                    related = related.parentNode;
	                  }
	                }
	                if (!related) {
	                  evt = fix(evt || win.event);
	                  evt.type = evt.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
	                  evt.target = current;
	                  self.executeHandlers(evt, id);
	                }
	              };
	            }
	          }
	          if (!self.hasFocusIn && (name === 'focusin' || name === 'focusout')) {
	            capture = true;
	            fakeName = name === 'focusin' ? 'focus' : 'blur';
	            nativeHandler = function (evt) {
	              evt = fix(evt || win.event);
	              evt.type = evt.type === 'focus' ? 'focusin' : 'focusout';
	              self.executeHandlers(evt, id);
	            };
	          }
	          callbackList = self.events[id][name];
	          if (!callbackList) {
	            self.events[id][name] = callbackList = [{
	                func: callback,
	                scope: scope
	              }];
	            callbackList.fakeName = fakeName;
	            callbackList.capture = capture;
	            callbackList.nativeHandler = nativeHandler;
	            if (name === 'ready') {
	              bindOnReady(target, nativeHandler, self);
	            } else {
	              addEvent(target, fakeName || name, nativeHandler, capture);
	            }
	          } else {
	            if (name === 'ready' && self.domLoaded) {
	              callback(fix({ type: name }));
	            } else {
	              callbackList.push({
	                func: callback,
	                scope: scope
	              });
	            }
	          }
	        }
	        target = callbackList = null;
	        return callback;
	      };
	      EventUtils.prototype.unbind = function (target, names, callback) {
	        var callbackList, i, ci, name, eventMap;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return this;
	        }
	        var id = target[this.expando];
	        if (id) {
	          eventMap = this.events[id];
	          if (names) {
	            var namesList = names.split(' ');
	            i = namesList.length;
	            while (i--) {
	              name = namesList[i];
	              callbackList = eventMap[name];
	              if (callbackList) {
	                if (callback) {
	                  ci = callbackList.length;
	                  while (ci--) {
	                    if (callbackList[ci].func === callback) {
	                      var nativeHandler = callbackList.nativeHandler;
	                      var fakeName = callbackList.fakeName, capture = callbackList.capture;
	                      callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
	                      callbackList.nativeHandler = nativeHandler;
	                      callbackList.fakeName = fakeName;
	                      callbackList.capture = capture;
	                      eventMap[name] = callbackList;
	                    }
	                  }
	                }
	                if (!callback || callbackList.length === 0) {
	                  delete eventMap[name];
	                  removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	                }
	              }
	            }
	          } else {
	            each$j(eventMap, function (callbackList, name) {
	              removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	            });
	            eventMap = {};
	          }
	          for (name in eventMap) {
	            if (has$2(eventMap, name)) {
	              return this;
	            }
	          }
	          delete this.events[id];
	          try {
	            delete target[this.expando];
	          } catch (ex) {
	            target[this.expando] = null;
	          }
	        }
	        return this;
	      };
	      EventUtils.prototype.fire = function (target, name, args) {
	        var id;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return this;
	        }
	        var event = fix({
	          type: name,
	          target: target
	        }, args);
	        do {
	          id = target[this.expando];
	          if (id) {
	            this.executeHandlers(event, id);
	          }
	          target = target.parentNode || target.ownerDocument || target.defaultView || target.parentWindow;
	        } while (target && !event.isPropagationStopped());
	        return this;
	      };
	      EventUtils.prototype.clean = function (target) {
	        var i, children;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return this;
	        }
	        if (target[this.expando]) {
	          this.unbind(target);
	        }
	        if (!target.getElementsByTagName) {
	          target = target.document;
	        }
	        if (target && target.getElementsByTagName) {
	          this.unbind(target);
	          children = target.getElementsByTagName('*');
	          i = children.length;
	          while (i--) {
	            target = children[i];
	            if (target[this.expando]) {
	              this.unbind(target);
	            }
	          }
	        }
	        return this;
	      };
	      EventUtils.prototype.destroy = function () {
	        this.events = {};
	      };
	      EventUtils.prototype.cancel = function (e) {
	        if (e) {
	          e.preventDefault();
	          e.stopImmediatePropagation();
	        }
	        return false;
	      };
	      EventUtils.prototype.executeHandlers = function (evt, id) {
	        var container = this.events[id];
	        var callbackList = container && container[evt.type];
	        if (callbackList) {
	          for (var i = 0, l = callbackList.length; i < l; i++) {
	            var callback = callbackList[i];
	            if (callback && callback.func.call(callback.scope, evt) === false) {
	              evt.preventDefault();
	            }
	            if (evt.isImmediatePropagationStopped()) {
	              return;
	            }
	          }
	        }
	      };
	      EventUtils.Event = new EventUtils();
	      return EventUtils;
	    }();
	
	    var support, Expr, getText, isXML, tokenize, compile, select$1, outermostContext, sortInput, hasDuplicate, setDocument, document$1, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, expando = 'sizzle' + -new Date(), preferredDoc = window.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	        }
	        return 0;
	      }, strundefined = typeof undefined, MAX_NEGATIVE = 1 << 31, hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push$1 = arr.push, slice$1 = arr.slice, indexOf = arr.indexOf || function (elem) {
	        var i = 0, len = this.length;
	        for (; i < len; i++) {
	          if (this[i] === elem) {
	            return i;
	          }
	        }
	        return -1;
	      }, booleans = 'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped', whitespace = '[\\x20\\t\\r\\n\\f]', identifier = '(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+', attributes = '\\[' + whitespace + '*(' + identifier + ')(?:' + whitespace + '*([*^$|!~]?=)' + whitespace + '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' + identifier + '))|)' + whitespace + '*\\]', pseudos = ':(' + identifier + ')(?:\\((' + '(\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|' + '((?:\\\\.|[^\\\\()[\\]]|' + attributes + ')*)|' + '.*' + ')\\)|)', rtrim = new RegExp('^' + whitespace + '+|((?:^|[^\\\\])(?:\\\\.)*)' + whitespace + '+$', 'g'), rcomma = new RegExp('^' + whitespace + '*,' + whitespace + '*'), rcombinators = new RegExp('^' + whitespace + '*([>+~]|' + whitespace + ')' + whitespace + '*'), rattributeQuotes = new RegExp('=' + whitespace + '*([^\\]\'"]*?)' + whitespace + '*\\]', 'g'), rpseudo = new RegExp(pseudos), ridentifier = new RegExp('^' + identifier + '$'), matchExpr = {
	        ID: new RegExp('^#(' + identifier + ')'),
	        CLASS: new RegExp('^\\.(' + identifier + ')'),
	        TAG: new RegExp('^(' + identifier + '|[*])'),
	        ATTR: new RegExp('^' + attributes),
	        PSEUDO: new RegExp('^' + pseudos),
	        CHILD: new RegExp('^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' + whitespace + '*(even|odd|(([+-]|)(\\d*)n|)' + whitespace + '*(?:([+-]|)' + whitespace + '*(\\d+)|))' + whitespace + '*\\)|)', 'i'),
	        bool: new RegExp('^(?:' + booleans + ')$', 'i'),
	        needsContext: new RegExp('^' + whitespace + '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' + whitespace + '*((?:-\\d)?\\d*)' + whitespace + '*\\)|)(?=[^-]|$)', 'i')
	      }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, rquickExpr$1 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, rescape = /'|\\/g, runescape = new RegExp('\\\\([\\da-f]{1,6}' + whitespace + '?|(' + whitespace + ')|.)', 'ig'), funescape = function (_, escaped, escapedWhitespace) {
	        var high = '0x' + escaped - 65536;
	        return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
	      };
	    try {
	      push$1.apply(arr = slice$1.call(preferredDoc.childNodes), preferredDoc.childNodes);
	      arr[preferredDoc.childNodes.length].nodeType;
	    } catch (e) {
	      push$1 = {
	        apply: arr.length ? function (target, els) {
	          push_native.apply(target, slice$1.call(els));
	        } : function (target, els) {
	          var j = target.length, i = 0;
	          while (target[j++] = els[i++]) {
	          }
	          target.length = j - 1;
	        }
	      };
	    }
	    var Sizzle = function (selector, context, results, seed) {
	      var match, elem, m, nodeType, i, groups, old, nid, newContext, newSelector;
	      if ((context ? context.ownerDocument || context : preferredDoc) !== document$1) {
	        setDocument(context);
	      }
	      context = context || document$1;
	      results = results || [];
	      if (!selector || typeof selector !== 'string') {
	        return results;
	      }
	      if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
	        return [];
	      }
	      if (documentIsHTML && !seed) {
	        if (match = rquickExpr$1.exec(selector)) {
	          if (m = match[1]) {
	            if (nodeType === 9) {
	              elem = context.getElementById(m);
	              if (elem && elem.parentNode) {
	                if (elem.id === m) {
	                  results.push(elem);
	                  return results;
	                }
	              } else {
	                return results;
	              }
	            } else {
	              if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && contains(context, elem) && elem.id === m) {
	                results.push(elem);
	                return results;
	              }
	            }
	          } else if (match[2]) {
	            push$1.apply(results, context.getElementsByTagName(selector));
	            return results;
	          } else if ((m = match[3]) && support.getElementsByClassName) {
	            push$1.apply(results, context.getElementsByClassName(m));
	            return results;
	          }
	        }
	        if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
	          nid = old = expando;
	          newContext = context;
	          newSelector = nodeType === 9 && selector;
	          if (nodeType === 1 && context.nodeName.toLowerCase() !== 'object') {
	            groups = tokenize(selector);
	            if (old = context.getAttribute('id')) {
	              nid = old.replace(rescape, '\\$&');
	            } else {
	              context.setAttribute('id', nid);
	            }
	            nid = '[id=\'' + nid + '\'] ';
	            i = groups.length;
	            while (i--) {
	              groups[i] = nid + toSelector(groups[i]);
	            }
	            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
	            newSelector = groups.join(',');
	          }
	          if (newSelector) {
	            try {
	              push$1.apply(results, newContext.querySelectorAll(newSelector));
	              return results;
	            } catch (qsaError) {
	            } finally {
	              if (!old) {
	                context.removeAttribute('id');
	              }
	            }
	          }
	        }
	      }
	      return select$1(selector.replace(rtrim, '$1'), context, results, seed);
	    };
	    function createCache() {
	      var keys = [];
	      function cache(key, value) {
	        if (keys.push(key + ' ') > Expr.cacheLength) {
	          delete cache[keys.shift()];
	        }
	        return cache[key + ' '] = value;
	      }
	      return cache;
	    }
	    function markFunction(fn) {
	      fn[expando] = true;
	      return fn;
	    }
	    function siblingCheck(a, b) {
	      var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
	      if (diff) {
	        return diff;
	      }
	      if (cur) {
	        while (cur = cur.nextSibling) {
	          if (cur === b) {
	            return -1;
	          }
	        }
	      }
	      return a ? 1 : -1;
	    }
	    function createInputPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return name === 'input' && elem.type === type;
	      };
	    }
	    function createButtonPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return (name === 'input' || name === 'button') && elem.type === type;
	      };
	    }
	    function createPositionalPseudo(fn) {
	      return markFunction(function (argument) {
	        argument = +argument;
	        return markFunction(function (seed, matches) {
	          var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
	          while (i--) {
	            if (seed[j = matchIndexes[i]]) {
	              seed[j] = !(matches[j] = seed[j]);
	            }
	          }
	        });
	      });
	    }
	    function testContext(context) {
	      return context && typeof context.getElementsByTagName !== strundefined && context;
	    }
	    support = Sizzle.support = {};
	    isXML = Sizzle.isXML = function (elem) {
	      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	      return documentElement ? documentElement.nodeName !== 'HTML' : false;
	    };
	    setDocument = Sizzle.setDocument = function (node) {
	      var hasCompare, doc = node ? node.ownerDocument || node : preferredDoc, parent = doc.defaultView;
	      function getTop(win) {
	        try {
	          return win.top;
	        } catch (ex) {
	        }
	        return null;
	      }
	      if (doc === document$1 || doc.nodeType !== 9 || !doc.documentElement) {
	        return document$1;
	      }
	      document$1 = doc;
	      docElem = doc.documentElement;
	      documentIsHTML = !isXML(doc);
	      if (parent && parent !== getTop(parent)) {
	        if (parent.addEventListener) {
	          parent.addEventListener('unload', function () {
	            setDocument();
	          }, false);
	        } else if (parent.attachEvent) {
	          parent.attachEvent('onunload', function () {
	            setDocument();
	          });
	        }
	      }
	      support.attributes = true;
	      support.getElementsByTagName = true;
	      support.getElementsByClassName = rnative.test(doc.getElementsByClassName);
	      support.getById = true;
	      Expr.find.ID = function (id, context) {
	        if (typeof context.getElementById !== strundefined && documentIsHTML) {
	          var m = context.getElementById(id);
	          return m && m.parentNode ? [m] : [];
	        }
	      };
	      Expr.filter.ID = function (id) {
	        var attrId = id.replace(runescape, funescape);
	        return function (elem) {
	          return elem.getAttribute('id') === attrId;
	        };
	      };
	      Expr.find.TAG = support.getElementsByTagName ? function (tag, context) {
	        if (typeof context.getElementsByTagName !== strundefined) {
	          return context.getElementsByTagName(tag);
	        }
	      } : function (tag, context) {
	        var elem, tmp = [], i = 0, results = context.getElementsByTagName(tag);
	        if (tag === '*') {
	          while (elem = results[i++]) {
	            if (elem.nodeType === 1) {
	              tmp.push(elem);
	            }
	          }
	          return tmp;
	        }
	        return results;
	      };
	      Expr.find.CLASS = support.getElementsByClassName && function (className, context) {
	        if (documentIsHTML) {
	          return context.getElementsByClassName(className);
	        }
	      };
	      rbuggyMatches = [];
	      rbuggyQSA = [];
	      support.disconnectedMatch = true;
	      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join('|'));
	      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join('|'));
	      hasCompare = rnative.test(docElem.compareDocumentPosition);
	      contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
	        var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
	        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
	      } : function (a, b) {
	        if (b) {
	          while (b = b.parentNode) {
	            if (b === a) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	      sortOrder = hasCompare ? function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	          return 0;
	        }
	        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
	        if (compare) {
	          return compare;
	        }
	        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
	        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
	          if (a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
	            return -1;
	          }
	          if (b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
	            return 1;
	          }
	          return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
	        }
	        return compare & 4 ? -1 : 1;
	      } : function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	          return 0;
	        }
	        var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [a], bp = [b];
	        if (!aup || !bup) {
	          return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
	        } else if (aup === bup) {
	          return siblingCheck(a, b);
	        }
	        cur = a;
	        while (cur = cur.parentNode) {
	          ap.unshift(cur);
	        }
	        cur = b;
	        while (cur = cur.parentNode) {
	          bp.unshift(cur);
	        }
	        while (ap[i] === bp[i]) {
	          i++;
	        }
	        return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
	      };
	      return doc;
	    };
	    Sizzle.matches = function (expr, elements) {
	      return Sizzle(expr, null, null, elements);
	    };
	    Sizzle.matchesSelector = function (elem, expr) {
	      if ((elem.ownerDocument || elem) !== document$1) {
	        setDocument(elem);
	      }
	      expr = expr.replace(rattributeQuotes, '=\'$1\']');
	      if (support.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
	        try {
	          var ret = matches.call(elem, expr);
	          if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
	            return ret;
	          }
	        } catch (e) {
	        }
	      }
	      return Sizzle(expr, document$1, null, [elem]).length > 0;
	    };
	    Sizzle.contains = function (context, elem) {
	      if ((context.ownerDocument || context) !== document$1) {
	        setDocument(context);
	      }
	      return contains(context, elem);
	    };
	    Sizzle.attr = function (elem, name) {
	      if ((elem.ownerDocument || elem) !== document$1) {
	        setDocument(elem);
	      }
	      var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
	      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
	    };
	    Sizzle.error = function (msg) {
	      throw new Error('Syntax error, unrecognized expression: ' + msg);
	    };
	    Sizzle.uniqueSort = function (results) {
	      var elem, duplicates = [], j = 0, i = 0;
	      hasDuplicate = !support.detectDuplicates;
	      sortInput = !support.sortStable && results.slice(0);
	      results.sort(sortOrder);
	      if (hasDuplicate) {
	        while (elem = results[i++]) {
	          if (elem === results[i]) {
	            j = duplicates.push(i);
	          }
	        }
	        while (j--) {
	          results.splice(duplicates[j], 1);
	        }
	      }
	      sortInput = null;
	      return results;
	    };
	    getText = Sizzle.getText = function (elem) {
	      var node, ret = '', i = 0, nodeType = elem.nodeType;
	      if (!nodeType) {
	        while (node = elem[i++]) {
	          ret += getText(node);
	        }
	      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
	        if (typeof elem.textContent === 'string') {
	          return elem.textContent;
	        } else {
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            ret += getText(elem);
	          }
	        }
	      } else if (nodeType === 3 || nodeType === 4) {
	        return elem.nodeValue;
	      }
	      return ret;
	    };
	    Expr = Sizzle.selectors = {
	      cacheLength: 50,
	      createPseudo: markFunction,
	      match: matchExpr,
	      attrHandle: {},
	      find: {},
	      relative: {
	        '>': {
	          dir: 'parentNode',
	          first: true
	        },
	        ' ': { dir: 'parentNode' },
	        '+': {
	          dir: 'previousSibling',
	          first: true
	        },
	        '~': { dir: 'previousSibling' }
	      },
	      preFilter: {
	        ATTR: function (match) {
	          match[1] = match[1].replace(runescape, funescape);
	          match[3] = (match[3] || match[4] || match[5] || '').replace(runescape, funescape);
	          if (match[2] === '~=') {
	            match[3] = ' ' + match[3] + ' ';
	          }
	          return match.slice(0, 4);
	        },
	        CHILD: function (match) {
	          match[1] = match[1].toLowerCase();
	          if (match[1].slice(0, 3) === 'nth') {
	            if (!match[3]) {
	              Sizzle.error(match[0]);
	            }
	            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === 'even' || match[3] === 'odd'));
	            match[5] = +(match[7] + match[8] || match[3] === 'odd');
	          } else if (match[3]) {
	            Sizzle.error(match[0]);
	          }
	          return match;
	        },
	        PSEUDO: function (match) {
	          var excess, unquoted = !match[6] && match[2];
	          if (matchExpr.CHILD.test(match[0])) {
	            return null;
	          }
	          if (match[3]) {
	            match[2] = match[4] || match[5] || '';
	          } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, true)) && (excess = unquoted.indexOf(')', unquoted.length - excess) - unquoted.length)) {
	            match[0] = match[0].slice(0, excess);
	            match[2] = unquoted.slice(0, excess);
	          }
	          return match.slice(0, 3);
	        }
	      },
	      filter: {
	        TAG: function (nodeNameSelector) {
	          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
	          return nodeNameSelector === '*' ? function () {
	            return true;
	          } : function (elem) {
	            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
	          };
	        },
	        CLASS: function (className) {
	          var pattern = classCache[className + ' '];
	          return pattern || (pattern = new RegExp('(^|' + whitespace + ')' + className + '(' + whitespace + '|$)')) && classCache(className, function (elem) {
	            return pattern.test(typeof elem.className === 'string' && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute('class') || '');
	          });
	        },
	        ATTR: function (name, operator, check) {
	          return function (elem) {
	            var result = Sizzle.attr(elem, name);
	            if (result == null) {
	              return operator === '!=';
	            }
	            if (!operator) {
	              return true;
	            }
	            result += '';
	            return operator === '=' ? result === check : operator === '!=' ? result !== check : operator === '^=' ? check && result.indexOf(check) === 0 : operator === '*=' ? check && result.indexOf(check) > -1 : operator === '$=' ? check && result.slice(-check.length) === check : operator === '~=' ? (' ' + result + ' ').indexOf(check) > -1 : operator === '|=' ? result === check || result.slice(0, check.length + 1) === check + '-' : false;
	          };
	        },
	        CHILD: function (type, what, argument, first, last) {
	          var simple = type.slice(0, 3) !== 'nth', forward = type.slice(-4) !== 'last', ofType = what === 'of-type';
	          return first === 1 && last === 0 ? function (elem) {
	            return !!elem.parentNode;
	          } : function (elem, context, xml) {
	            var cache, outerCache, node, diff, nodeIndex, start, dir = simple !== forward ? 'nextSibling' : 'previousSibling', parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType;
	            if (parent) {
	              if (simple) {
	                while (dir) {
	                  node = elem;
	                  while (node = node[dir]) {
	                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
	                      return false;
	                    }
	                  }
	                  start = dir = type === 'only' && !start && 'nextSibling';
	                }
	                return true;
	              }
	              start = [forward ? parent.firstChild : parent.lastChild];
	              if (forward && useCache) {
	                outerCache = parent[expando] || (parent[expando] = {});
	                cache = outerCache[type] || [];
	                nodeIndex = cache[0] === dirruns && cache[1];
	                diff = cache[0] === dirruns && cache[2];
	                node = nodeIndex && parent.childNodes[nodeIndex];
	                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	                  if (node.nodeType === 1 && ++diff && node === elem) {
	                    outerCache[type] = [
	                      dirruns,
	                      nodeIndex,
	                      diff
	                    ];
	                    break;
	                  }
	                }
	              } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
	                diff = cache[1];
	              } else {
	                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	                  if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
	                    if (useCache) {
	                      (node[expando] || (node[expando] = {}))[type] = [
	                        dirruns,
	                        diff
	                      ];
	                    }
	                    if (node === elem) {
	                      break;
	                    }
	                  }
	                }
	              }
	              diff -= last;
	              return diff === first || diff % first === 0 && diff / first >= 0;
	            }
	          };
	        },
	        PSEUDO: function (pseudo, argument) {
	          var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error('unsupported pseudo: ' + pseudo);
	          if (fn[expando]) {
	            return fn(argument);
	          }
	          if (fn.length > 1) {
	            args = [
	              pseudo,
	              pseudo,
	              '',
	              argument
	            ];
	            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
	              var idx, matched = fn(seed, argument), i = matched.length;
	              while (i--) {
	                idx = indexOf.call(seed, matched[i]);
	                seed[idx] = !(matches[idx] = matched[i]);
	              }
	            }) : function (elem) {
	              return fn(elem, 0, args);
	            };
	          }
	          return fn;
	        }
	      },
	      pseudos: {
	        not: markFunction(function (selector) {
	          var input = [], results = [], matcher = compile(selector.replace(rtrim, '$1'));
	          return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
	            var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
	            while (i--) {
	              if (elem = unmatched[i]) {
	                seed[i] = !(matches[i] = elem);
	              }
	            }
	          }) : function (elem, context, xml) {
	            input[0] = elem;
	            matcher(input, null, xml, results);
	            input[0] = null;
	            return !results.pop();
	          };
	        }),
	        has: markFunction(function (selector) {
	          return function (elem) {
	            return Sizzle(selector, elem).length > 0;
	          };
	        }),
	        contains: markFunction(function (text) {
	          text = text.replace(runescape, funescape);
	          return function (elem) {
	            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
	          };
	        }),
	        lang: markFunction(function (lang) {
	          if (!ridentifier.test(lang || '')) {
	            Sizzle.error('unsupported lang: ' + lang);
	          }
	          lang = lang.replace(runescape, funescape).toLowerCase();
	          return function (elem) {
	            var elemLang;
	            do {
	              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute('xml:lang') || elem.getAttribute('lang')) {
	                elemLang = elemLang.toLowerCase();
	                return elemLang === lang || elemLang.indexOf(lang + '-') === 0;
	              }
	            } while ((elem = elem.parentNode) && elem.nodeType === 1);
	            return false;
	          };
	        }),
	        target: function (elem) {
	          var hash = window.location && window.location.hash;
	          return hash && hash.slice(1) === elem.id;
	        },
	        root: function (elem) {
	          return elem === docElem;
	        },
	        focus: function (elem) {
	          return elem === document$1.activeElement && (!document$1.hasFocus || document$1.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	        },
	        enabled: function (elem) {
	          return elem.disabled === false;
	        },
	        disabled: function (elem) {
	          return elem.disabled === true;
	        },
	        checked: function (elem) {
	          var nodeName = elem.nodeName.toLowerCase();
	          return nodeName === 'input' && !!elem.checked || nodeName === 'option' && !!elem.selected;
	        },
	        selected: function (elem) {
	          if (elem.parentNode) {
	            elem.parentNode.selectedIndex;
	          }
	          return elem.selected === true;
	        },
	        empty: function (elem) {
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            if (elem.nodeType < 6) {
	              return false;
	            }
	          }
	          return true;
	        },
	        parent: function (elem) {
	          return !Expr.pseudos.empty(elem);
	        },
	        header: function (elem) {
	          return rheader.test(elem.nodeName);
	        },
	        input: function (elem) {
	          return rinputs.test(elem.nodeName);
	        },
	        button: function (elem) {
	          var name = elem.nodeName.toLowerCase();
	          return name === 'input' && elem.type === 'button' || name === 'button';
	        },
	        text: function (elem) {
	          var attr;
	          return elem.nodeName.toLowerCase() === 'input' && elem.type === 'text' && ((attr = elem.getAttribute('type')) == null || attr.toLowerCase() === 'text');
	        },
	        first: createPositionalPseudo(function () {
	          return [0];
	        }),
	        last: createPositionalPseudo(function (matchIndexes, length) {
	          return [length - 1];
	        }),
	        eq: createPositionalPseudo(function (matchIndexes, length, argument) {
	          return [argument < 0 ? argument + length : argument];
	        }),
	        even: createPositionalPseudo(function (matchIndexes, length) {
	          var i = 0;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        odd: createPositionalPseudo(function (matchIndexes, length) {
	          var i = 1;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        lt: createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; --i >= 0;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        gt: createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; ++i < length;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        })
	      }
	    };
	    Expr.pseudos.nth = Expr.pseudos.eq;
	    each$k([
	      'radio',
	      'checkbox',
	      'file',
	      'password',
	      'image'
	    ], function (i) {
	      Expr.pseudos[i] = createInputPseudo(i);
	    });
	    each$k([
	      'submit',
	      'reset'
	    ], function (i) {
	      Expr.pseudos[i] = createButtonPseudo(i);
	    });
	    function setFilters() {
	    }
	    setFilters.prototype = Expr.filters = Expr.pseudos;
	    Expr.setFilters = new setFilters();
	    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
	      var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + ' '];
	      if (cached) {
	        return parseOnly ? 0 : cached.slice(0);
	      }
	      soFar = selector;
	      groups = [];
	      preFilters = Expr.preFilter;
	      while (soFar) {
	        if (!matched || (match = rcomma.exec(soFar))) {
	          if (match) {
	            soFar = soFar.slice(match[0].length) || soFar;
	          }
	          groups.push(tokens = []);
	        }
	        matched = false;
	        if (match = rcombinators.exec(soFar)) {
	          matched = match.shift();
	          tokens.push({
	            value: matched,
	            type: match[0].replace(rtrim, ' ')
	          });
	          soFar = soFar.slice(matched.length);
	        }
	        for (type in Expr.filter) {
	          if (!Expr.filter.hasOwnProperty(type)) {
	            continue;
	          }
	          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
	            matched = match.shift();
	            tokens.push({
	              value: matched,
	              type: type,
	              matches: match
	            });
	            soFar = soFar.slice(matched.length);
	          }
	        }
	        if (!matched) {
	          break;
	        }
	      }
	      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
	    };
	    function toSelector(tokens) {
	      var i = 0, len = tokens.length, selector = '';
	      for (; i < len; i++) {
	        selector += tokens[i].value;
	      }
	      return selector;
	    }
	    function addCombinator(matcher, combinator, base) {
	      var dir = combinator.dir, checkNonElements = base && dir === 'parentNode', doneName = done++;
	      return combinator.first ? function (elem, context, xml) {
	        while (elem = elem[dir]) {
	          if (elem.nodeType === 1 || checkNonElements) {
	            return matcher(elem, context, xml);
	          }
	        }
	      } : function (elem, context, xml) {
	        var oldCache, outerCache, newCache = [
	            dirruns,
	            doneName
	          ];
	        if (xml) {
	          while (elem = elem[dir]) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              if (matcher(elem, context, xml)) {
	                return true;
	              }
	            }
	          }
	        } else {
	          while (elem = elem[dir]) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              outerCache = elem[expando] || (elem[expando] = {});
	              if ((oldCache = outerCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
	                return newCache[2] = oldCache[2];
	              } else {
	                outerCache[dir] = newCache;
	                if (newCache[2] = matcher(elem, context, xml)) {
	                  return true;
	                }
	              }
	            }
	          }
	        }
	      };
	    }
	    function elementMatcher(matchers) {
	      return matchers.length > 1 ? function (elem, context, xml) {
	        var i = matchers.length;
	        while (i--) {
	          if (!matchers[i](elem, context, xml)) {
	            return false;
	          }
	        }
	        return true;
	      } : matchers[0];
	    }
	    function multipleContexts(selector, contexts, results) {
	      var i = 0, len = contexts.length;
	      for (; i < len; i++) {
	        Sizzle(selector, contexts[i], results);
	      }
	      return results;
	    }
	    function condense(unmatched, map, filter, context, xml) {
	      var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
	      for (; i < len; i++) {
	        if (elem = unmatched[i]) {
	          if (!filter || filter(elem, context, xml)) {
	            newUnmatched.push(elem);
	            if (mapped) {
	              map.push(i);
	            }
	          }
	        }
	      }
	      return newUnmatched;
	    }
	    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
	      if (postFilter && !postFilter[expando]) {
	        postFilter = setMatcher(postFilter);
	      }
	      if (postFinder && !postFinder[expando]) {
	        postFinder = setMatcher(postFinder, postSelector);
	      }
	      return markFunction(function (seed, results, context, xml) {
	        var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(selector || '*', context.nodeType ? [context] : context, []), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
	        if (matcher) {
	          matcher(matcherIn, matcherOut, context, xml);
	        }
	        if (postFilter) {
	          temp = condense(matcherOut, postMap);
	          postFilter(temp, [], context, xml);
	          i = temp.length;
	          while (i--) {
	            if (elem = temp[i]) {
	              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
	            }
	          }
	        }
	        if (seed) {
	          if (postFinder || preFilter) {
	            if (postFinder) {
	              temp = [];
	              i = matcherOut.length;
	              while (i--) {
	                if (elem = matcherOut[i]) {
	                  temp.push(matcherIn[i] = elem);
	                }
	              }
	              postFinder(null, matcherOut = [], temp, xml);
	            }
	            i = matcherOut.length;
	            while (i--) {
	              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) {
	                seed[temp] = !(results[temp] = elem);
	              }
	            }
	          }
	        } else {
	          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
	          if (postFinder) {
	            postFinder(null, results, matcherOut, xml);
	          } else {
	            push$1.apply(results, matcherOut);
	          }
	        }
	      });
	    }
	    function matcherFromTokens(tokens) {
	      var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[' '], i = leadingRelative ? 1 : 0, matchContext = addCombinator(function (elem) {
	          return elem === checkContext;
	        }, implicitRelative, true), matchAnyContext = addCombinator(function (elem) {
	          return indexOf.call(checkContext, elem) > -1;
	        }, implicitRelative, true), matchers = [function (elem, context, xml) {
	            var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
	            checkContext = null;
	            return ret;
	          }];
	      for (; i < len; i++) {
	        if (matcher = Expr.relative[tokens[i].type]) {
	          matchers = [addCombinator(elementMatcher(matchers), matcher)];
	        } else {
	          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
	          if (matcher[expando]) {
	            j = ++i;
	            for (; j < len; j++) {
	              if (Expr.relative[tokens[j].type]) {
	                break;
	              }
	            }
	            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === ' ' ? '*' : '' })).replace(rtrim, '$1'), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
	          }
	          matchers.push(matcher);
	        }
	      }
	      return elementMatcher(matchers);
	    }
	    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
	      var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function (seed, context, xml, results, outermost) {
	          var elem, j, matcher, matchedCount = 0, i = '0', unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG('*', outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
	          if (outermost) {
	            outermostContext = context !== document$1 && context;
	          }
	          for (; i !== len && (elem = elems[i]) != null; i++) {
	            if (byElement && elem) {
	              j = 0;
	              while (matcher = elementMatchers[j++]) {
	                if (matcher(elem, context, xml)) {
	                  results.push(elem);
	                  break;
	                }
	              }
	              if (outermost) {
	                dirruns = dirrunsUnique;
	              }
	            }
	            if (bySet) {
	              if (elem = !matcher && elem) {
	                matchedCount--;
	              }
	              if (seed) {
	                unmatched.push(elem);
	              }
	            }
	          }
	          matchedCount += i;
	          if (bySet && i !== matchedCount) {
	            j = 0;
	            while (matcher = setMatchers[j++]) {
	              matcher(unmatched, setMatched, context, xml);
	            }
	            if (seed) {
	              if (matchedCount > 0) {
	                while (i--) {
	                  if (!(unmatched[i] || setMatched[i])) {
	                    setMatched[i] = pop.call(results);
	                  }
	                }
	              }
	              setMatched = condense(setMatched);
	            }
	            push$1.apply(results, setMatched);
	            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
	              Sizzle.uniqueSort(results);
	            }
	          }
	          if (outermost) {
	            dirruns = dirrunsUnique;
	            outermostContext = contextBackup;
	          }
	          return unmatched;
	        };
	      return bySet ? markFunction(superMatcher) : superMatcher;
	    }
	    compile = Sizzle.compile = function (selector, match) {
	      var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + ' '];
	      if (!cached) {
	        if (!match) {
	          match = tokenize(selector);
	        }
	        i = match.length;
	        while (i--) {
	          cached = matcherFromTokens(match[i]);
	          if (cached[expando]) {
	            setMatchers.push(cached);
	          } else {
	            elementMatchers.push(cached);
	          }
	        }
	        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
	        cached.selector = selector;
	      }
	      return cached;
	    };
	    select$1 = Sizzle.select = function (selector, context, results, seed) {
	      var i, tokens, token, type, find, compiled = typeof selector === 'function' && selector, match = !seed && tokenize(selector = compiled.selector || selector);
	      results = results || [];
	      if (match.length === 1) {
	        tokens = match[0] = match[0].slice(0);
	        if (tokens.length > 2 && (token = tokens[0]).type === 'ID' && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
	          context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
	          if (!context) {
	            return results;
	          } else if (compiled) {
	            context = context.parentNode;
	          }
	          selector = selector.slice(tokens.shift().value.length);
	        }
	        i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
	        while (i--) {
	          token = tokens[i];
	          if (Expr.relative[type = token.type]) {
	            break;
	          }
	          if (find = Expr.find[type]) {
	            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
	              tokens.splice(i, 1);
	              selector = seed.length && toSelector(tokens);
	              if (!selector) {
	                push$1.apply(results, seed);
	                return results;
	              }
	              break;
	            }
	          }
	        }
	      }
	      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, rsibling.test(selector) && testContext(context.parentNode) || context);
	      return results;
	    };
	    support.sortStable = expando.split('').sort(sortOrder).join('') === expando;
	    support.detectDuplicates = !!hasDuplicate;
	    setDocument();
	    support.sortDetached = true;
	
	    var doc = document;
	    var push = Array.prototype.push;
	    var slice = Array.prototype.slice;
	    var rquickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
	    var Event$1 = EventUtils.Event;
	    var skipUniques = Tools.makeMap('children,contents,next,prev');
	    var isDefined = function (obj) {
	      return typeof obj !== 'undefined';
	    };
	    var isString = function (obj) {
	      return typeof obj === 'string';
	    };
	    var isWindow = function (obj) {
	      return obj && obj === obj.window;
	    };
	    var createFragment$1 = function (html, fragDoc) {
	      fragDoc = fragDoc || doc;
	      var container = fragDoc.createElement('div');
	      var frag = fragDoc.createDocumentFragment();
	      container.innerHTML = html;
	      var node;
	      while (node = container.firstChild) {
	        frag.appendChild(node);
	      }
	      return frag;
	    };
	    var domManipulate = function (targetNodes, sourceItem, callback, reverse) {
	      var i;
	      if (isString(sourceItem)) {
	        sourceItem = createFragment$1(sourceItem, getElementDocument(targetNodes[0]));
	      } else if (sourceItem.length && !sourceItem.nodeType) {
	        sourceItem = DomQuery.makeArray(sourceItem);
	        if (reverse) {
	          for (i = sourceItem.length - 1; i >= 0; i--) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        } else {
	          for (i = 0; i < sourceItem.length; i++) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        }
	        return targetNodes;
	      }
	      if (sourceItem.nodeType) {
	        i = targetNodes.length;
	        while (i--) {
	          callback.call(targetNodes[i], sourceItem);
	        }
	      }
	      return targetNodes;
	    };
	    var hasClass = function (node, className) {
	      return node && className && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    };
	    var wrap$2 = function (elements, wrapper, all) {
	      var lastParent, newWrapper;
	      wrapper = DomQuery(wrapper)[0];
	      elements.each(function () {
	        var self = this;
	        if (!all || lastParent !== self.parentNode) {
	          lastParent = self.parentNode;
	          newWrapper = wrapper.cloneNode(false);
	          self.parentNode.insertBefore(newWrapper, self);
	          newWrapper.appendChild(self);
	        } else {
	          newWrapper.appendChild(self);
	        }
	      });
	      return elements;
	    };
	    var numericCssMap = Tools.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
	    var booleanMap = Tools.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
	    var propFix = {
	      for: 'htmlFor',
	      class: 'className',
	      readonly: 'readOnly'
	    };
	    var cssFix = { float: 'cssFloat' };
	    var attrHooks = {}, cssHooks = {};
	    var DomQueryConstructor = function (selector, context) {
	      return new DomQuery.fn.init(selector, context);
	    };
	    var inArray$1 = function (item, array) {
	      var i;
	      if (array.indexOf) {
	        return array.indexOf(item);
	      }
	      i = array.length;
	      while (i--) {
	        if (array[i] === item) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var whiteSpaceRegExp = /^\s*|\s*$/g;
	    var trim$1 = function (str) {
	      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp, '');
	    };
	    var each$g = function (obj, callback) {
	      var length, key, i, value;
	      if (obj) {
	        length = obj.length;
	        if (length === undefined) {
	          for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	              value = obj[key];
	              if (callback.call(value, key, value) === false) {
	                break;
	              }
	            }
	          }
	        } else {
	          for (i = 0; i < length; i++) {
	            value = obj[i];
	            if (callback.call(value, i, value) === false) {
	              break;
	            }
	          }
	        }
	      }
	      return obj;
	    };
	    var grep$2 = function (array, callback) {
	      var out = [];
	      each$g(array, function (i, item) {
	        if (callback(item, i)) {
	          out.push(item);
	        }
	      });
	      return out;
	    };
	    var getElementDocument = function (element) {
	      if (!element) {
	        return doc;
	      }
	      if (element.nodeType === 9) {
	        return element;
	      }
	      return element.ownerDocument;
	    };
	    DomQueryConstructor.fn = DomQueryConstructor.prototype = {
	      constructor: DomQueryConstructor,
	      selector: '',
	      context: null,
	      length: 0,
	      init: function (selector, context) {
	        var self = this;
	        var match, node;
	        if (!selector) {
	          return self;
	        }
	        if (selector.nodeType) {
	          self.context = self[0] = selector;
	          self.length = 1;
	          return self;
	        }
	        if (context && context.nodeType) {
	          self.context = context;
	        } else {
	          if (context) {
	            return DomQuery(selector).attr(context);
	          }
	          self.context = context = document;
	        }
	        if (isString(selector)) {
	          self.selector = selector;
	          if (selector.charAt(0) === '<' && selector.charAt(selector.length - 1) === '>' && selector.length >= 3) {
	            match = [
	              null,
	              selector,
	              null
	            ];
	          } else {
	            match = rquickExpr.exec(selector);
	          }
	          if (match) {
	            if (match[1]) {
	              node = createFragment$1(selector, getElementDocument(context)).firstChild;
	              while (node) {
	                push.call(self, node);
	                node = node.nextSibling;
	              }
	            } else {
	              node = getElementDocument(context).getElementById(match[2]);
	              if (!node) {
	                return self;
	              }
	              if (node.id !== match[2]) {
	                return self.find(selector);
	              }
	              self.length = 1;
	              self[0] = node;
	            }
	          } else {
	            return DomQuery(context).find(selector);
	          }
	        } else {
	          this.add(selector, false);
	        }
	        return self;
	      },
	      toArray: function () {
	        return Tools.toArray(this);
	      },
	      add: function (items, sort) {
	        var self = this;
	        var nodes, i;
	        if (isString(items)) {
	          return self.add(DomQuery(items));
	        }
	        if (sort !== false) {
	          nodes = DomQuery.unique(self.toArray().concat(DomQuery.makeArray(items)));
	          self.length = nodes.length;
	          for (i = 0; i < nodes.length; i++) {
	            self[i] = nodes[i];
	          }
	        } else {
	          push.apply(self, DomQuery.makeArray(items));
	        }
	        return self;
	      },
	      attr: function (name, value) {
	        var self = this;
	        var hook;
	        if (typeof name === 'object') {
	          each$g(name, function (name, value) {
	            self.attr(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            var hook;
	            if (this.nodeType === 1) {
	              hook = attrHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	              if (value === null) {
	                this.removeAttribute(name, 2);
	              } else {
	                this.setAttribute(name, value, 2);
	              }
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType === 1) {
	            hook = attrHooks[name];
	            if (hook && hook.get) {
	              return hook.get(self[0], name);
	            }
	            if (booleanMap[name]) {
	              return self.prop(name) ? name : undefined;
	            }
	            value = self[0].getAttribute(name, 2);
	            if (value === null) {
	              value = undefined;
	            }
	          }
	          return value;
	        }
	        return self;
	      },
	      removeAttr: function (name) {
	        return this.attr(name, null);
	      },
	      prop: function (name, value) {
	        var self = this;
	        name = propFix[name] || name;
	        if (typeof name === 'object') {
	          each$g(name, function (name, value) {
	            self.prop(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            if (this.nodeType === 1) {
	              this[name] = value;
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType && name in self[0]) {
	            return self[0][name];
	          }
	          return value;
	        }
	        return self;
	      },
	      css: function (name, value) {
	        var self = this;
	        var elm, hook;
	        var camel = function (name) {
	          return name.replace(/-(\D)/g, function (a, b) {
	            return b.toUpperCase();
	          });
	        };
	        var dashed = function (name) {
	          return name.replace(/[A-Z]/g, function (a) {
	            return '-' + a;
	          });
	        };
	        if (typeof name === 'object') {
	          each$g(name, function (name, value) {
	            self.css(name, value);
	          });
	        } else {
	          if (isDefined(value)) {
	            name = camel(name);
	            if (typeof value === 'number' && !numericCssMap[name]) {
	              value = value.toString() + 'px';
	            }
	            self.each(function () {
	              var style = this.style;
	              hook = cssHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	              try {
	                this.style[cssFix[name] || name] = value;
	              } catch (ex) {
	              }
	              if (value === null || value === '') {
	                if (style.removeProperty) {
	                  style.removeProperty(dashed(name));
	                } else {
	                  style.removeAttribute(name);
	                }
	              }
	            });
	          } else {
	            elm = self[0];
	            hook = cssHooks[name];
	            if (hook && hook.get) {
	              return hook.get(elm);
	            }
	            if (elm.ownerDocument.defaultView) {
	              try {
	                return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(name));
	              } catch (ex) {
	                return undefined;
	              }
	            } else if (elm.currentStyle) {
	              return elm.currentStyle[camel(name)];
	            } else {
	              return '';
	            }
	          }
	        }
	        return self;
	      },
	      remove: function () {
	        var self = this;
	        var node, i = this.length;
	        while (i--) {
	          node = self[i];
	          Event$1.clean(node);
	          if (node.parentNode) {
	            node.parentNode.removeChild(node);
	          }
	        }
	        return this;
	      },
	      empty: function () {
	        var self = this;
	        var node, i = this.length;
	        while (i--) {
	          node = self[i];
	          while (node.firstChild) {
	            node.removeChild(node.firstChild);
	          }
	        }
	        return this;
	      },
	      html: function (value) {
	        var self = this;
	        var i;
	        if (isDefined(value)) {
	          i = self.length;
	          try {
	            while (i--) {
	              self[i].innerHTML = value;
	            }
	          } catch (ex) {
	            DomQuery(self[i]).empty().append(value);
	          }
	          return self;
	        }
	        return self[0] ? self[0].innerHTML : '';
	      },
	      text: function (value) {
	        var self = this;
	        var i;
	        if (isDefined(value)) {
	          i = self.length;
	          while (i--) {
	            if ('innerText' in self[i]) {
	              self[i].innerText = value;
	            } else {
	              self[0].textContent = value;
	            }
	          }
	          return self;
	        }
	        return self[0] ? self[0].innerText || self[0].textContent : '';
	      },
	      append: function () {
	        return domManipulate(this, arguments, function (node) {
	          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
	            this.appendChild(node);
	          }
	        });
	      },
	      prepend: function () {
	        return domManipulate(this, arguments, function (node) {
	          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
	            this.insertBefore(node, this.firstChild);
	          }
	        }, true);
	      },
	      before: function () {
	        var self = this;
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this);
	          });
	        }
	        return self;
	      },
	      after: function () {
	        var self = this;
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this.nextSibling);
	          }, true);
	        }
	        return self;
	      },
	      appendTo: function (val) {
	        DomQuery(val).append(this);
	        return this;
	      },
	      prependTo: function (val) {
	        DomQuery(val).prepend(this);
	        return this;
	      },
	      replaceWith: function (content) {
	        return this.before(content).remove();
	      },
	      wrap: function (content) {
	        return wrap$2(this, content);
	      },
	      wrapAll: function (content) {
	        return wrap$2(this, content, true);
	      },
	      wrapInner: function (content) {
	        this.each(function () {
	          DomQuery(this).contents().wrapAll(content);
	        });
	        return this;
	      },
	      unwrap: function () {
	        return this.parent().each(function () {
	          DomQuery(this).replaceWith(this.childNodes);
	        });
	      },
	      clone: function () {
	        var result = [];
	        this.each(function () {
	          result.push(this.cloneNode(true));
	        });
	        return DomQuery(result);
	      },
	      addClass: function (className) {
	        return this.toggleClass(className, true);
	      },
	      removeClass: function (className) {
	        return this.toggleClass(className, false);
	      },
	      toggleClass: function (className, state) {
	        var self = this;
	        if (typeof className !== 'string') {
	          return self;
	        }
	        if (className.indexOf(' ') !== -1) {
	          each$g(className.split(' '), function () {
	            self.toggleClass(this, state);
	          });
	        } else {
	          self.each(function (index, node) {
	            var classState = hasClass(node, className);
	            if (classState !== state) {
	              var existingClassName = node.className;
	              if (classState) {
	                node.className = trim$1((' ' + existingClassName + ' ').replace(' ' + className + ' ', ' '));
	              } else {
	                node.className += existingClassName ? ' ' + className : className;
	              }
	            }
	          });
	        }
	        return self;
	      },
	      hasClass: function (className) {
	        return hasClass(this[0], className);
	      },
	      each: function (callback) {
	        return each$g(this, callback);
	      },
	      on: function (name, callback) {
	        return this.each(function () {
	          Event$1.bind(this, name, callback);
	        });
	      },
	      off: function (name, callback) {
	        return this.each(function () {
	          Event$1.unbind(this, name, callback);
	        });
	      },
	      trigger: function (name) {
	        return this.each(function () {
	          if (typeof name === 'object') {
	            Event$1.fire(this, name.type, name);
	          } else {
	            Event$1.fire(this, name);
	          }
	        });
	      },
	      show: function () {
	        return this.css('display', '');
	      },
	      hide: function () {
	        return this.css('display', 'none');
	      },
	      slice: function () {
	        return DomQuery(slice.apply(this, arguments));
	      },
	      eq: function (index) {
	        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
	      },
	      first: function () {
	        return this.eq(0);
	      },
	      last: function () {
	        return this.eq(-1);
	      },
	      find: function (selector) {
	        var i, l;
	        var ret = [];
	        for (i = 0, l = this.length; i < l; i++) {
	          DomQuery.find(selector, this[i], ret);
	        }
	        return DomQuery(ret);
	      },
	      filter: function (selector) {
	        if (typeof selector === 'function') {
	          return DomQuery(grep$2(this.toArray(), function (item, i) {
	            return selector(i, item);
	          }));
	        }
	        return DomQuery(DomQuery.filter(selector, this.toArray()));
	      },
	      closest: function (selector) {
	        var result = [];
	        if (selector instanceof DomQuery) {
	          selector = selector[0];
	        }
	        this.each(function (i, node) {
	          while (node) {
	            if (typeof selector === 'string' && DomQuery(node).is(selector)) {
	              result.push(node);
	              break;
	            } else if (node === selector) {
	              result.push(node);
	              break;
	            }
	            node = node.parentNode;
	          }
	        });
	        return DomQuery(result);
	      },
	      offset: function (offset) {
	        var elm, doc, docElm;
	        var x = 0, y = 0, pos;
	        if (!offset) {
	          elm = this[0];
	          if (elm) {
	            doc = elm.ownerDocument;
	            docElm = doc.documentElement;
	            if (elm.getBoundingClientRect) {
	              pos = elm.getBoundingClientRect();
	              x = pos.left + (docElm.scrollLeft || doc.body.scrollLeft) - docElm.clientLeft;
	              y = pos.top + (docElm.scrollTop || doc.body.scrollTop) - docElm.clientTop;
	            }
	          }
	          return {
	            left: x,
	            top: y
	          };
	        }
	        return this.css(offset);
	      },
	      push: push,
	      sort: Array.prototype.sort,
	      splice: Array.prototype.splice
	    };
	    Tools.extend(DomQueryConstructor, {
	      extend: Tools.extend,
	      makeArray: function (object) {
	        if (isWindow(object) || object.nodeType) {
	          return [object];
	        }
	        return Tools.toArray(object);
	      },
	      inArray: inArray$1,
	      isArray: Tools.isArray,
	      each: each$g,
	      trim: trim$1,
	      grep: grep$2,
	      find: Sizzle,
	      expr: Sizzle.selectors,
	      unique: Sizzle.uniqueSort,
	      text: Sizzle.getText,
	      contains: Sizzle.contains,
	      filter: function (expr, elems, not) {
	        var i = elems.length;
	        if (not) {
	          expr = ':not(' + expr + ')';
	        }
	        while (i--) {
	          if (elems[i].nodeType !== 1) {
	            elems.splice(i, 1);
	          }
	        }
	        if (elems.length === 1) {
	          elems = DomQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [];
	        } else {
	          elems = DomQuery.find.matches(expr, elems);
	        }
	        return elems;
	      }
	    });
	    var dir = function (el, prop, until) {
	      var matched = [];
	      var cur = el[prop];
	      if (typeof until !== 'string' && until instanceof DomQuery) {
	        until = until[0];
	      }
	      while (cur && cur.nodeType !== 9) {
	        if (until !== undefined) {
	          if (cur === until) {
	            break;
	          }
	          if (typeof until === 'string' && DomQuery(cur).is(until)) {
	            break;
	          }
	        }
	        if (cur.nodeType === 1) {
	          matched.push(cur);
	        }
	        cur = cur[prop];
	      }
	      return matched;
	    };
	    var sibling$1 = function (node, siblingName, nodeType, until) {
	      var result = [];
	      if (until instanceof DomQuery) {
	        until = until[0];
	      }
	      for (; node; node = node[siblingName]) {
	        if (nodeType && node.nodeType !== nodeType) {
	          continue;
	        }
	        if (until !== undefined) {
	          if (node === until) {
	            break;
	          }
	          if (typeof until === 'string' && DomQuery(node).is(until)) {
	            break;
	          }
	        }
	        result.push(node);
	      }
	      return result;
	    };
	    var firstSibling = function (node, siblingName, nodeType) {
	      for (node = node[siblingName]; node; node = node[siblingName]) {
	        if (node.nodeType === nodeType) {
	          return node;
	        }
	      }
	      return null;
	    };
	    each$g({
	      parent: function (node) {
	        var parent = node.parentNode;
	        return parent && parent.nodeType !== 11 ? parent : null;
	      },
	      parents: function (node) {
	        return dir(node, 'parentNode');
	      },
	      next: function (node) {
	        return firstSibling(node, 'nextSibling', 1);
	      },
	      prev: function (node) {
	        return firstSibling(node, 'previousSibling', 1);
	      },
	      children: function (node) {
	        return sibling$1(node.firstChild, 'nextSibling', 1);
	      },
	      contents: function (node) {
	        return Tools.toArray((node.nodeName === 'iframe' ? node.contentDocument || node.contentWindow.document : node).childNodes);
	      }
	    }, function (name, fn) {
	      DomQueryConstructor.fn[name] = function (selector) {
	        var self = this;
	        var result = [];
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	        if (this.length > 1) {
	          if (!skipUniques[name]) {
	            result = DomQuery.unique(result);
	          }
	          if (name.indexOf('parents') === 0) {
	            result = result.reverse();
	          }
	        }
	        var wrappedResult = DomQuery(result);
	        if (selector) {
	          return wrappedResult.filter(selector);
	        }
	        return wrappedResult;
	      };
	    });
	    each$g({
	      parentsUntil: function (node, until) {
	        return dir(node, 'parentNode', until);
	      },
	      nextUntil: function (node, until) {
	        return sibling$1(node, 'nextSibling', 1, until).slice(1);
	      },
	      prevUntil: function (node, until) {
	        return sibling$1(node, 'previousSibling', 1, until).slice(1);
	      }
	    }, function (name, fn) {
	      DomQueryConstructor.fn[name] = function (selector, filter) {
	        var self = this;
	        var result = [];
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	        if (this.length > 1) {
	          result = DomQuery.unique(result);
	          if (name.indexOf('parents') === 0 || name === 'prevUntil') {
	            result = result.reverse();
	          }
	        }
	        var wrappedResult = DomQuery(result);
	        if (filter) {
	          return wrappedResult.filter(filter);
	        }
	        return wrappedResult;
	      };
	    });
	    DomQueryConstructor.fn.is = function (selector) {
	      return !!selector && this.filter(selector).length > 0;
	    };
	    DomQueryConstructor.fn.init.prototype = DomQueryConstructor.fn;
	    DomQueryConstructor.overrideDefaults = function (callback) {
	      var defaults;
	      var sub = function (selector, context) {
	        defaults = defaults || callback();
	        if (arguments.length === 0) {
	          selector = defaults.element;
	        }
	        if (!context) {
	          context = defaults.context;
	        }
	        return new sub.fn.init(selector, context);
	      };
	      DomQuery.extend(sub, this);
	      return sub;
	    };
	    DomQueryConstructor.attrHooks = attrHooks;
	    DomQueryConstructor.cssHooks = cssHooks;
	    var DomQuery = DomQueryConstructor;
	
	    var each$f = Tools.each;
	    var grep$1 = Tools.grep;
	    var isIE = Env.ie;
	    var simpleSelectorRe = /^([a-z0-9],?)+$/i;
	    var setupAttrHooks = function (styles, settings, getContext) {
	      var keepValues = settings.keep_values;
	      var keepUrlHook = {
	        set: function ($elm, value, name) {
	          if (settings.url_converter && value !== null) {
	            value = settings.url_converter.call(settings.url_converter_scope || getContext(), value, name, $elm[0]);
	          }
	          $elm.attr('data-mce-' + name, value).attr(name, value);
	        },
	        get: function ($elm, name) {
	          return $elm.attr('data-mce-' + name) || $elm.attr(name);
	        }
	      };
	      var attrHooks = {
	        style: {
	          set: function ($elm, value) {
	            if (value !== null && typeof value === 'object') {
	              $elm.css(value);
	              return;
	            }
	            if (keepValues) {
	              $elm.attr('data-mce-style', value);
	            }
	            if (value !== null && typeof value === 'string') {
	              $elm.removeAttr('style');
	              $elm.css(styles.parse(value));
	            } else {
	              $elm.attr('style', value);
	            }
	          },
	          get: function ($elm) {
	            var value = $elm.attr('data-mce-style') || $elm.attr('style');
	            value = styles.serialize(styles.parse(value), $elm[0].nodeName);
	            return value;
	          }
	        }
	      };
	      if (keepValues) {
	        attrHooks.href = attrHooks.src = keepUrlHook;
	      }
	      return attrHooks;
	    };
	    var updateInternalStyleAttr = function (styles, $elm) {
	      var rawValue = $elm.attr('style');
	      var value = styles.serialize(styles.parse(rawValue), $elm[0].nodeName);
	      if (!value) {
	        value = null;
	      }
	      $elm.attr('data-mce-style', value);
	    };
	    var findNodeIndex = function (node, normalized) {
	      var idx = 0, lastNodeType, nodeType;
	      if (node) {
	        for (lastNodeType = node.nodeType, node = node.previousSibling; node; node = node.previousSibling) {
	          nodeType = node.nodeType;
	          if (normalized && nodeType === 3) {
	            if (nodeType === lastNodeType || !node.nodeValue.length) {
	              continue;
	            }
	          }
	          idx++;
	          lastNodeType = nodeType;
	        }
	      }
	      return idx;
	    };
	    var DOMUtils = function (doc, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var addedStyles = {};
	      var win = window;
	      var files = {};
	      var counter = 0;
	      var stdMode = true;
	      var boxModel = true;
	      var styleSheetLoader = instance.forElement(SugarElement.fromDom(doc), {
	        contentCssCors: settings.contentCssCors,
	        referrerPolicy: settings.referrerPolicy
	      });
	      var boundEvents = [];
	      var schema = settings.schema ? settings.schema : Schema({});
	      var styles = Styles({
	        url_converter: settings.url_converter,
	        url_converter_scope: settings.url_converter_scope
	      }, settings.schema);
	      var events = settings.ownEvents ? new EventUtils() : EventUtils.Event;
	      var blockElementsMap = schema.getBlockElements();
	      var $ = DomQuery.overrideDefaults(function () {
	        return {
	          context: doc,
	          element: self.getRoot()
	        };
	      });
	      var isBlock = function (node) {
	        if (typeof node === 'string') {
	          return !!blockElementsMap[node];
	        } else if (node) {
	          var type = node.nodeType;
	          if (type) {
	            return !!(type === 1 && blockElementsMap[node.nodeName]);
	          }
	        }
	        return false;
	      };
	      var get = function (elm) {
	        return elm && doc && isString$1(elm) ? doc.getElementById(elm) : elm;
	      };
	      var $$ = function (elm) {
	        return $(typeof elm === 'string' ? get(elm) : elm);
	      };
	      var getAttrib = function (elm, name, defaultVal) {
	        var hook, value;
	        var $elm = $$(elm);
	        if ($elm.length) {
	          hook = attrHooks[name];
	          if (hook && hook.get) {
	            value = hook.get($elm, name);
	          } else {
	            value = $elm.attr(name);
	          }
	        }
	        if (typeof value === 'undefined') {
	          value = defaultVal || '';
	        }
	        return value;
	      };
	      var getAttribs = function (elm) {
	        var node = get(elm);
	        if (!node) {
	          return [];
	        }
	        return node.attributes;
	      };
	      var setAttrib = function (elm, name, value) {
	        if (value === '') {
	          value = null;
	        }
	        var $elm = $$(elm);
	        var originalValue = $elm.attr(name);
	        if (!$elm.length) {
	          return;
	        }
	        var hook = attrHooks[name];
	        if (hook && hook.set) {
	          hook.set($elm, value, name);
	        } else {
	          $elm.attr(name, value);
	        }
	        if (originalValue !== value && settings.onSetAttrib) {
	          settings.onSetAttrib({
	            attrElm: $elm,
	            attrName: name,
	            attrValue: value
	          });
	        }
	      };
	      var clone = function (node, deep) {
	        if (!isIE || node.nodeType !== 1 || deep) {
	          return node.cloneNode(deep);
	        } else {
	          var clone_1 = doc.createElement(node.nodeName);
	          each$f(getAttribs(node), function (attr) {
	            setAttrib(clone_1, attr.nodeName, getAttrib(node, attr.nodeName));
	          });
	          return clone_1;
	        }
	      };
	      var getRoot = function () {
	        return settings.root_element || doc.body;
	      };
	      var getViewPort = function (argWin) {
	        var vp = getBounds(argWin);
	        return {
	          x: vp.x,
	          y: vp.y,
	          w: vp.width,
	          h: vp.height
	        };
	      };
	      var getPos$1 = function (elm, rootElm) {
	        return getPos(doc.body, get(elm), rootElm);
	      };
	      var setStyle = function (elm, name, value) {
	        var $elm = isString$1(name) ? $$(elm).css(name, value) : $$(elm).css(name);
	        if (settings.update_styles) {
	          updateInternalStyleAttr(styles, $elm);
	        }
	      };
	      var setStyles = function (elm, stylesArg) {
	        var $elm = $$(elm).css(stylesArg);
	        if (settings.update_styles) {
	          updateInternalStyleAttr(styles, $elm);
	        }
	      };
	      var getStyle = function (elm, name, computed) {
	        var $elm = $$(elm);
	        if (computed) {
	          return $elm.css(name);
	        }
	        name = name.replace(/-(\D)/g, function (a, b) {
	          return b.toUpperCase();
	        });
	        if (name === 'float') {
	          name = Env.browser.isIE() ? 'styleFloat' : 'cssFloat';
	        }
	        return $elm[0] && $elm[0].style ? $elm[0].style[name] : undefined;
	      };
	      var getSize = function (elm) {
	        var w, h;
	        elm = get(elm);
	        w = getStyle(elm, 'width');
	        h = getStyle(elm, 'height');
	        if (w.indexOf('px') === -1) {
	          w = 0;
	        }
	        if (h.indexOf('px') === -1) {
	          h = 0;
	        }
	        return {
	          w: parseInt(w, 10) || elm.offsetWidth || elm.clientWidth,
	          h: parseInt(h, 10) || elm.offsetHeight || elm.clientHeight
	        };
	      };
	      var getRect = function (elm) {
	        elm = get(elm);
	        var pos = getPos$1(elm);
	        var size = getSize(elm);
	        return {
	          x: pos.x,
	          y: pos.y,
	          w: size.w,
	          h: size.h
	        };
	      };
	      var is = function (elm, selector) {
	        var i;
	        if (!elm) {
	          return false;
	        }
	        if (!Array.isArray(elm)) {
	          if (selector === '*') {
	            return elm.nodeType === 1;
	          }
	          if (simpleSelectorRe.test(selector)) {
	            var selectors = selector.toLowerCase().split(/,/);
	            var elmName = elm.nodeName.toLowerCase();
	            for (i = selectors.length - 1; i >= 0; i--) {
	              if (selectors[i] === elmName) {
	                return true;
	              }
	            }
	            return false;
	          }
	          if (elm.nodeType && elm.nodeType !== 1) {
	            return false;
	          }
	        }
	        var elms = !Array.isArray(elm) ? [elm] : elm;
	        return Sizzle(selector, elms[0].ownerDocument || elms[0], null, elms).length > 0;
	      };
	      var getParents = function (elm, selector, root, collect) {
	        var result = [];
	        var selectorVal;
	        var node = get(elm);
	        collect = collect === undefined;
	        root = root || (getRoot().nodeName !== 'BODY' ? getRoot().parentNode : null);
	        if (Tools.is(selector, 'string')) {
	          selectorVal = selector;
	          if (selector === '*') {
	            selector = function (node) {
	              return node.nodeType === 1;
	            };
	          } else {
	            selector = function (node) {
	              return is(node, selectorVal);
	            };
	          }
	        }
	        while (node) {
	          if (node === root || isNullable(node.nodeType) || isDocument$1(node) || isDocumentFragment(node)) {
	            break;
	          }
	          if (!selector || typeof selector === 'function' && selector(node)) {
	            if (collect) {
	              result.push(node);
	            } else {
	              return [node];
	            }
	          }
	          node = node.parentNode;
	        }
	        return collect ? result : null;
	      };
	      var getParent = function (node, selector, root) {
	        var parents = getParents(node, selector, root, false);
	        return parents && parents.length > 0 ? parents[0] : null;
	      };
	      var _findSib = function (node, selector, name) {
	        var func = selector;
	        if (node) {
	          if (typeof selector === 'string') {
	            func = function (node) {
	              return is(node, selector);
	            };
	          }
	          for (node = node[name]; node; node = node[name]) {
	            if (typeof func === 'function' && func(node)) {
	              return node;
	            }
	          }
	        }
	        return null;
	      };
	      var getNext = function (node, selector) {
	        return _findSib(node, selector, 'nextSibling');
	      };
	      var getPrev = function (node, selector) {
	        return _findSib(node, selector, 'previousSibling');
	      };
	      var select = function (selector, scope) {
	        return Sizzle(selector, get(scope) || settings.root_element || doc, []);
	      };
	      var run = function (elm, func, scope) {
	        var result;
	        var node = typeof elm === 'string' ? get(elm) : elm;
	        if (!node) {
	          return false;
	        }
	        if (Tools.isArray(node) && (node.length || node.length === 0)) {
	          result = [];
	          each$f(node, function (elm, i) {
	            if (elm) {
	              result.push(func.call(scope, typeof elm === 'string' ? get(elm) : elm, i));
	            }
	          });
	          return result;
	        }
	        var context = scope ? scope : this;
	        return func.call(context, node);
	      };
	      var setAttribs = function (elm, attrs) {
	        $$(elm).each(function (i, node) {
	          each$f(attrs, function (value, name) {
	            setAttrib(node, name, value);
	          });
	        });
	      };
	      var setHTML = function (elm, html) {
	        var $elm = $$(elm);
	        if (isIE) {
	          $elm.each(function (i, target) {
	            if (target.canHaveHTML === false) {
	              return;
	            }
	            while (target.firstChild) {
	              target.removeChild(target.firstChild);
	            }
	            try {
	              target.innerHTML = '<br>' + html;
	              target.removeChild(target.firstChild);
	            } catch (ex) {
	              DomQuery('<div></div>').html('<br>' + html).contents().slice(1).appendTo(target);
	            }
	            return html;
	          });
	        } else {
	          $elm.html(html);
	        }
	      };
	      var add = function (parentElm, name, attrs, html, create) {
	        return run(parentElm, function (parentElm) {
	          var newElm = typeof name === 'string' ? doc.createElement(name) : name;
	          setAttribs(newElm, attrs);
	          if (html) {
	            if (typeof html !== 'string' && html.nodeType) {
	              newElm.appendChild(html);
	            } else if (typeof html === 'string') {
	              setHTML(newElm, html);
	            }
	          }
	          return !create ? parentElm.appendChild(newElm) : newElm;
	        });
	      };
	      var create = function (name, attrs, html) {
	        return add(doc.createElement(name), name, attrs, html, true);
	      };
	      var decode = Entities.decode;
	      var encode = Entities.encodeAllRaw;
	      var createHTML = function (name, attrs, html) {
	        var outHtml = '', key;
	        outHtml += '<' + name;
	        for (key in attrs) {
	          if (hasNonNullableKey(attrs, key)) {
	            outHtml += ' ' + key + '="' + encode(attrs[key]) + '"';
	          }
	        }
	        if (typeof html !== 'undefined') {
	          return outHtml + '>' + html + '</' + name + '>';
	        }
	        return outHtml + ' />';
	      };
	      var createFragment = function (html) {
	        var node;
	        var container = doc.createElement('div');
	        var frag = doc.createDocumentFragment();
	        frag.appendChild(container);
	        if (html) {
	          container.innerHTML = html;
	        }
	        while (node = container.firstChild) {
	          frag.appendChild(node);
	        }
	        frag.removeChild(container);
	        return frag;
	      };
	      var remove = function (node, keepChildren) {
	        var $node = $$(node);
	        if (keepChildren) {
	          $node.each(function () {
	            var child;
	            while (child = this.firstChild) {
	              if (child.nodeType === 3 && child.data.length === 0) {
	                this.removeChild(child);
	              } else {
	                this.parentNode.insertBefore(child, this);
	              }
	            }
	          }).remove();
	        } else {
	          $node.remove();
	        }
	        return $node.length > 1 ? $node.toArray() : $node[0];
	      };
	      var removeAllAttribs = function (e) {
	        return run(e, function (e) {
	          var i;
	          var attrs = e.attributes;
	          for (i = attrs.length - 1; i >= 0; i--) {
	            e.removeAttributeNode(attrs.item(i));
	          }
	        });
	      };
	      var parseStyle = function (cssText) {
	        return styles.parse(cssText);
	      };
	      var serializeStyle = function (stylesArg, name) {
	        return styles.serialize(stylesArg, name);
	      };
	      var addStyle = function (cssText) {
	        var head, styleElm;
	        if (self !== DOMUtils.DOM && doc === document) {
	          if (addedStyles[cssText]) {
	            return;
	          }
	          addedStyles[cssText] = true;
	        }
	        styleElm = doc.getElementById('mceDefaultStyles');
	        if (!styleElm) {
	          styleElm = doc.createElement('style');
	          styleElm.id = 'mceDefaultStyles';
	          styleElm.type = 'text/css';
	          head = doc.getElementsByTagName('head')[0];
	          if (head.firstChild) {
	            head.insertBefore(styleElm, head.firstChild);
	          } else {
	            head.appendChild(styleElm);
	          }
	        }
	        if (styleElm.styleSheet) {
	          styleElm.styleSheet.cssText += cssText;
	        } else {
	          styleElm.appendChild(doc.createTextNode(cssText));
	        }
	      };
	      var loadCSS = function (urls) {
	        if (!urls) {
	          urls = '';
	        }
	        each$k(urls.split(','), function (url) {
	          files[url] = true;
	          styleSheetLoader.load(url, noop);
	        });
	      };
	      var toggleClass = function (elm, cls, state) {
	        $$(elm).toggleClass(cls, state).each(function () {
	          if (this.className === '') {
	            DomQuery(this).attr('class', null);
	          }
	        });
	      };
	      var addClass = function (elm, cls) {
	        $$(elm).addClass(cls);
	      };
	      var removeClass = function (elm, cls) {
	        toggleClass(elm, cls, false);
	      };
	      var hasClass = function (elm, cls) {
	        return $$(elm).hasClass(cls);
	      };
	      var show = function (elm) {
	        $$(elm).show();
	      };
	      var hide = function (elm) {
	        $$(elm).hide();
	      };
	      var isHidden = function (elm) {
	        return $$(elm).css('display') === 'none';
	      };
	      var uniqueId = function (prefix) {
	        return (!prefix ? 'mce_' : prefix) + counter++;
	      };
	      var getOuterHTML = function (elm) {
	        var node = typeof elm === 'string' ? get(elm) : elm;
	        return isElement$5(node) ? node.outerHTML : DomQuery('<div></div>').append(DomQuery(node).clone()).html();
	      };
	      var setOuterHTML = function (elm, html) {
	        $$(elm).each(function () {
	          try {
	            if ('outerHTML' in this) {
	              this.outerHTML = html;
	              return;
	            }
	          } catch (ex) {
	          }
	          remove(DomQuery(this).html(html), true);
	        });
	      };
	      var insertAfter = function (node, reference) {
	        var referenceNode = get(reference);
	        return run(node, function (node) {
	          var parent = referenceNode.parentNode;
	          var nextSibling = referenceNode.nextSibling;
	          if (nextSibling) {
	            parent.insertBefore(node, nextSibling);
	          } else {
	            parent.appendChild(node);
	          }
	          return node;
	        });
	      };
	      var replace = function (newElm, oldElm, keepChildren) {
	        return run(oldElm, function (oldElm) {
	          if (Tools.is(oldElm, 'array')) {
	            newElm = newElm.cloneNode(true);
	          }
	          if (keepChildren) {
	            each$f(grep$1(oldElm.childNodes), function (node) {
	              newElm.appendChild(node);
	            });
	          }
	          return oldElm.parentNode.replaceChild(newElm, oldElm);
	        });
	      };
	      var rename = function (elm, name) {
	        var newElm;
	        if (elm.nodeName !== name.toUpperCase()) {
	          newElm = create(name);
	          each$f(getAttribs(elm), function (attrNode) {
	            setAttrib(newElm, attrNode.nodeName, getAttrib(elm, attrNode.nodeName));
	          });
	          replace(newElm, elm, true);
	        }
	        return newElm || elm;
	      };
	      var findCommonAncestor = function (a, b) {
	        var ps = a, pe;
	        while (ps) {
	          pe = b;
	          while (pe && ps !== pe) {
	            pe = pe.parentNode;
	          }
	          if (ps === pe) {
	            break;
	          }
	          ps = ps.parentNode;
	        }
	        if (!ps && a.ownerDocument) {
	          return a.ownerDocument.documentElement;
	        }
	        return ps;
	      };
	      var toHex = function (rgbVal) {
	        return styles.toHex(Tools.trim(rgbVal));
	      };
	      var isNonEmptyElement = function (node) {
	        if (isElement$5(node)) {
	          var isNamedAnchor = node.nodeName.toLowerCase() === 'a' && !getAttrib(node, 'href') && getAttrib(node, 'id');
	          if (getAttrib(node, 'name') || getAttrib(node, 'data-mce-bookmark') || isNamedAnchor) {
	            return true;
	          }
	        }
	        return false;
	      };
	      var isEmpty = function (node, elements) {
	        var type, name, brCount = 0;
	        if (isNonEmptyElement(node)) {
	          return false;
	        }
	        node = node.firstChild;
	        if (node) {
	          var walker = new DomTreeWalker(node, node.parentNode);
	          var whitespace = schema ? schema.getWhiteSpaceElements() : {};
	          elements = elements || (schema ? schema.getNonEmptyElements() : null);
	          do {
	            type = node.nodeType;
	            if (isElement$5(node)) {
	              var bogusVal = node.getAttribute('data-mce-bogus');
	              if (bogusVal) {
	                node = walker.next(bogusVal === 'all');
	                continue;
	              }
	              name = node.nodeName.toLowerCase();
	              if (elements && elements[name]) {
	                if (name === 'br') {
	                  brCount++;
	                  node = walker.next();
	                  continue;
	                }
	                return false;
	              }
	              if (isNonEmptyElement(node)) {
	                return false;
	              }
	            }
	            if (type === 8) {
	              return false;
	            }
	            if (type === 3 && !isWhitespaceText(node.nodeValue)) {
	              return false;
	            }
	            if (type === 3 && node.parentNode && whitespace[node.parentNode.nodeName] && isWhitespaceText(node.nodeValue)) {
	              return false;
	            }
	            node = walker.next();
	          } while (node);
	        }
	        return brCount <= 1;
	      };
	      var createRng = function () {
	        return doc.createRange();
	      };
	      var split = function (parentElm, splitElm, replacementElm) {
	        var range = createRng();
	        var beforeFragment;
	        var afterFragment;
	        var parentNode;
	        if (parentElm && splitElm) {
	          range.setStart(parentElm.parentNode, findNodeIndex(parentElm));
	          range.setEnd(splitElm.parentNode, findNodeIndex(splitElm));
	          beforeFragment = range.extractContents();
	          range = createRng();
	          range.setStart(splitElm.parentNode, findNodeIndex(splitElm) + 1);
	          range.setEnd(parentElm.parentNode, findNodeIndex(parentElm) + 1);
	          afterFragment = range.extractContents();
	          parentNode = parentElm.parentNode;
	          parentNode.insertBefore(trimNode(self, beforeFragment), parentElm);
	          if (replacementElm) {
	            parentNode.insertBefore(replacementElm, parentElm);
	          } else {
	            parentNode.insertBefore(splitElm, parentElm);
	          }
	          parentNode.insertBefore(trimNode(self, afterFragment), parentElm);
	          remove(parentElm);
	          return replacementElm || splitElm;
	        }
	      };
	      var bind = function (target, name, func, scope) {
	        if (Tools.isArray(target)) {
	          var i = target.length;
	          var rv = [];
	          while (i--) {
	            rv[i] = bind(target[i], name, func, scope);
	          }
	          return rv;
	        }
	        if (settings.collect && (target === doc || target === win)) {
	          boundEvents.push([
	            target,
	            name,
	            func,
	            scope
	          ]);
	        }
	        var output = events.bind(target, name, func, scope || self);
	        return output;
	      };
	      var unbind = function (target, name, func) {
	        if (Tools.isArray(target)) {
	          var i = target.length;
	          var rv = [];
	          while (i--) {
	            rv[i] = unbind(target[i], name, func);
	          }
	          return rv;
	        } else {
	          if (boundEvents.length > 0 && (target === doc || target === win)) {
	            var i = boundEvents.length;
	            while (i--) {
	              var item = boundEvents[i];
	              if (target === item[0] && (!name || name === item[1]) && (!func || func === item[2])) {
	                events.unbind(item[0], item[1], item[2]);
	              }
	            }
	          }
	          return events.unbind(target, name, func);
	        }
	      };
	      var fire = function (target, name, evt) {
	        return events.fire(target, name, evt);
	      };
	      var getContentEditable = function (node) {
	        if (node && isElement$5(node)) {
	          var contentEditable = node.getAttribute('data-mce-contenteditable');
	          if (contentEditable && contentEditable !== 'inherit') {
	            return contentEditable;
	          }
	          return node.contentEditable !== 'inherit' ? node.contentEditable : null;
	        } else {
	          return null;
	        }
	      };
	      var getContentEditableParent = function (node) {
	        var root = getRoot();
	        var state = null;
	        for (; node && node !== root; node = node.parentNode) {
	          state = getContentEditable(node);
	          if (state !== null) {
	            break;
	          }
	        }
	        return state;
	      };
	      var destroy = function () {
	        if (boundEvents.length > 0) {
	          var i = boundEvents.length;
	          while (i--) {
	            var item = boundEvents[i];
	            events.unbind(item[0], item[1], item[2]);
	          }
	        }
	        each$j(files, function (_, url) {
	          styleSheetLoader.unload(url);
	          delete files[url];
	        });
	        if (Sizzle.setDocument) {
	          Sizzle.setDocument();
	        }
	      };
	      var isChildOf = function (node, parent) {
	        if (!isIE) {
	          return node === parent || parent.contains(node);
	        } else {
	          while (node) {
	            if (parent === node) {
	              return true;
	            }
	            node = node.parentNode;
	          }
	          return false;
	        }
	      };
	      var dumpRng = function (r) {
	        return 'startContainer: ' + r.startContainer.nodeName + ', startOffset: ' + r.startOffset + ', endContainer: ' + r.endContainer.nodeName + ', endOffset: ' + r.endOffset;
	      };
	      var self = {
	        doc: doc,
	        settings: settings,
	        win: win,
	        files: files,
	        stdMode: stdMode,
	        boxModel: boxModel,
	        styleSheetLoader: styleSheetLoader,
	        boundEvents: boundEvents,
	        styles: styles,
	        schema: schema,
	        events: events,
	        isBlock: isBlock,
	        $: $,
	        $$: $$,
	        root: null,
	        clone: clone,
	        getRoot: getRoot,
	        getViewPort: getViewPort,
	        getRect: getRect,
	        getSize: getSize,
	        getParent: getParent,
	        getParents: getParents,
	        get: get,
	        getNext: getNext,
	        getPrev: getPrev,
	        select: select,
	        is: is,
	        add: add,
	        create: create,
	        createHTML: createHTML,
	        createFragment: createFragment,
	        remove: remove,
	        setStyle: setStyle,
	        getStyle: getStyle,
	        setStyles: setStyles,
	        removeAllAttribs: removeAllAttribs,
	        setAttrib: setAttrib,
	        setAttribs: setAttribs,
	        getAttrib: getAttrib,
	        getPos: getPos$1,
	        parseStyle: parseStyle,
	        serializeStyle: serializeStyle,
	        addStyle: addStyle,
	        loadCSS: loadCSS,
	        addClass: addClass,
	        removeClass: removeClass,
	        hasClass: hasClass,
	        toggleClass: toggleClass,
	        show: show,
	        hide: hide,
	        isHidden: isHidden,
	        uniqueId: uniqueId,
	        setHTML: setHTML,
	        getOuterHTML: getOuterHTML,
	        setOuterHTML: setOuterHTML,
	        decode: decode,
	        encode: encode,
	        insertAfter: insertAfter,
	        replace: replace,
	        rename: rename,
	        findCommonAncestor: findCommonAncestor,
	        toHex: toHex,
	        run: run,
	        getAttribs: getAttribs,
	        isEmpty: isEmpty,
	        createRng: createRng,
	        nodeIndex: findNodeIndex,
	        split: split,
	        bind: bind,
	        unbind: unbind,
	        fire: fire,
	        getContentEditable: getContentEditable,
	        getContentEditableParent: getContentEditableParent,
	        destroy: destroy,
	        isChildOf: isChildOf,
	        dumpRng: dumpRng
	      };
	      var attrHooks = setupAttrHooks(styles, settings, constant(self));
	      return self;
	    };
	    DOMUtils.DOM = DOMUtils(document);
	    DOMUtils.nodeIndex = findNodeIndex;
	
	    var DOM$a = DOMUtils.DOM;
	    var each$e = Tools.each, grep = Tools.grep;
	    var QUEUED = 0;
	    var LOADING = 1;
	    var LOADED = 2;
	    var FAILED = 3;
	    var ScriptLoader = function () {
	      function ScriptLoader(settings) {
	        if (settings === void 0) {
	          settings = {};
	        }
	        this.states = {};
	        this.queue = [];
	        this.scriptLoadedCallbacks = {};
	        this.queueLoadedCallbacks = [];
	        this.loading = 0;
	        this.settings = settings;
	      }
	      ScriptLoader.prototype._setReferrerPolicy = function (referrerPolicy) {
	        this.settings.referrerPolicy = referrerPolicy;
	      };
	      ScriptLoader.prototype.loadScript = function (url, success, failure) {
	        var dom = DOM$a;
	        var elm;
	        var cleanup = function () {
	          dom.remove(id);
	          if (elm) {
	            elm.onerror = elm.onload = elm = null;
	          }
	        };
	        var done = function () {
	          cleanup();
	          success();
	        };
	        var error = function () {
	          cleanup();
	          if (isFunction(failure)) {
	            failure();
	          } else {
	            if (typeof console !== 'undefined' && console.log) {
	              console.log('Failed to load script: ' + url);
	            }
	          }
	        };
	        var id = dom.uniqueId();
	        elm = document.createElement('script');
	        elm.id = id;
	        elm.type = 'text/javascript';
	        elm.src = Tools._addCacheSuffix(url);
	        if (this.settings.referrerPolicy) {
	          dom.setAttrib(elm, 'referrerpolicy', this.settings.referrerPolicy);
	        }
	        elm.onload = done;
	        elm.onerror = error;
	        (document.getElementsByTagName('head')[0] || document.body).appendChild(elm);
	      };
	      ScriptLoader.prototype.isDone = function (url) {
	        return this.states[url] === LOADED;
	      };
	      ScriptLoader.prototype.markDone = function (url) {
	        this.states[url] = LOADED;
	      };
	      ScriptLoader.prototype.add = function (url, success, scope, failure) {
	        var state = this.states[url];
	        this.queue.push(url);
	        if (state === undefined) {
	          this.states[url] = QUEUED;
	        }
	        if (success) {
	          if (!this.scriptLoadedCallbacks[url]) {
	            this.scriptLoadedCallbacks[url] = [];
	          }
	          this.scriptLoadedCallbacks[url].push({
	            success: success,
	            failure: failure,
	            scope: scope || this
	          });
	        }
	      };
	      ScriptLoader.prototype.load = function (url, success, scope, failure) {
	        return this.add(url, success, scope, failure);
	      };
	      ScriptLoader.prototype.remove = function (url) {
	        delete this.states[url];
	        delete this.scriptLoadedCallbacks[url];
	      };
	      ScriptLoader.prototype.loadQueue = function (success, scope, failure) {
	        this.loadScripts(this.queue, success, scope, failure);
	      };
	      ScriptLoader.prototype.loadScripts = function (scripts, success, scope, failure) {
	        var self = this;
	        var failures = [];
	        var execCallbacks = function (name, url) {
	          each$e(self.scriptLoadedCallbacks[url], function (callback) {
	            if (isFunction(callback[name])) {
	              callback[name].call(callback.scope);
	            }
	          });
	          self.scriptLoadedCallbacks[url] = undefined;
	        };
	        self.queueLoadedCallbacks.push({
	          success: success,
	          failure: failure,
	          scope: scope || this
	        });
	        var loadScripts = function () {
	          var loadingScripts = grep(scripts);
	          scripts.length = 0;
	          each$e(loadingScripts, function (url) {
	            if (self.states[url] === LOADED) {
	              execCallbacks('success', url);
	              return;
	            }
	            if (self.states[url] === FAILED) {
	              execCallbacks('failure', url);
	              return;
	            }
	            if (self.states[url] !== LOADING) {
	              self.states[url] = LOADING;
	              self.loading++;
	              self.loadScript(url, function () {
	                self.states[url] = LOADED;
	                self.loading--;
	                execCallbacks('success', url);
	                loadScripts();
	              }, function () {
	                self.states[url] = FAILED;
	                self.loading--;
	                failures.push(url);
	                execCallbacks('failure', url);
	                loadScripts();
	              });
	            }
	          });
	          if (!self.loading) {
	            var notifyCallbacks = self.queueLoadedCallbacks.slice(0);
	            self.queueLoadedCallbacks.length = 0;
	            each$e(notifyCallbacks, function (callback) {
	              if (failures.length === 0) {
	                if (isFunction(callback.success)) {
	                  callback.success.call(callback.scope);
	                }
	              } else {
	                if (isFunction(callback.failure)) {
	                  callback.failure.call(callback.scope, failures);
	                }
	              }
	            });
	          }
	        };
	        loadScripts();
	      };
	      ScriptLoader.ScriptLoader = new ScriptLoader();
	      return ScriptLoader;
	    }();
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var isRaw = function (str) {
	      return isObject(str) && has$2(str, 'raw');
	    };
	    var isTokenised = function (str) {
	      return isArray$1(str) && str.length > 1;
	    };
	    var data = {};
	    var currentCode = Cell('en');
	    var getLanguageData = function () {
	      return get$9(data, currentCode.get());
	    };
	    var getData = function () {
	      return map$2(data, function (value) {
	        return __assign({}, value);
	      });
	    };
	    var setCode = function (newCode) {
	      if (newCode) {
	        currentCode.set(newCode);
	      }
	    };
	    var getCode = function () {
	      return currentCode.get();
	    };
	    var add$4 = function (code, items) {
	      var langData = data[code];
	      if (!langData) {
	        data[code] = langData = {};
	      }
	      each$j(items, function (translation, name) {
	        langData[name.toLowerCase()] = translation;
	      });
	    };
	    var translate = function (text) {
	      var langData = getLanguageData().getOr({});
	      var toString = function (obj) {
	        if (isFunction(obj)) {
	          return Object.prototype.toString.call(obj);
	        }
	        return !isEmpty(obj) ? '' + obj : '';
	      };
	      var isEmpty = function (text) {
	        return text === '' || text === null || text === undefined;
	      };
	      var getLangData = function (text) {
	        var textstr = toString(text);
	        return get$9(langData, textstr.toLowerCase()).map(toString).getOr(textstr);
	      };
	      var removeContext = function (str) {
	        return str.replace(/{context:\w+}$/, '');
	      };
	      if (isEmpty(text)) {
	        return '';
	      }
	      if (isRaw(text)) {
	        return toString(text.raw);
	      }
	      if (isTokenised(text)) {
	        var values_1 = text.slice(1);
	        var substitued = getLangData(text[0]).replace(/\{([0-9]+)\}/g, function ($1, $2) {
	          return has$2(values_1, $2) ? toString(values_1[$2]) : $1;
	        });
	        return removeContext(substitued);
	      }
	      return removeContext(getLangData(text));
	    };
	    var isRtl$1 = function () {
	      return getLanguageData().bind(function (items) {
	        return get$9(items, '_dir');
	      }).exists(function (dir) {
	        return dir === 'rtl';
	      });
	    };
	    var hasCode = function (code) {
	      return has$2(data, code);
	    };
	    var I18n = {
	      getData: getData,
	      setCode: setCode,
	      getCode: getCode,
	      add: add$4,
	      translate: translate,
	      isRtl: isRtl$1,
	      hasCode: hasCode
	    };
	
	    var AddOnManager = function () {
	      var items = [];
	      var urls = {};
	      var lookup = {};
	      var _listeners = [];
	      var runListeners = function (name, state) {
	        var matchedListeners = filter$4(_listeners, function (listener) {
	          return listener.name === name && listener.state === state;
	        });
	        each$k(matchedListeners, function (listener) {
	          return listener.callback();
	        });
	      };
	      var get = function (name) {
	        if (lookup[name]) {
	          return lookup[name].instance;
	        }
	        return undefined;
	      };
	      var dependencies = function (name) {
	        var result;
	        if (lookup[name]) {
	          result = lookup[name].dependencies;
	        }
	        return result || [];
	      };
	      var requireLangPack = function (name, languages) {
	        if (AddOnManager.languageLoad !== false) {
	          waitFor(name, function () {
	            var language = I18n.getCode();
	            var wrappedLanguages = ',' + (languages || '') + ',';
	            if (!language || languages && wrappedLanguages.indexOf(',' + language + ',') === -1) {
	              return;
	            }
	            ScriptLoader.ScriptLoader.add(urls[name] + '/langs/' + language + '.js');
	          }, 'loaded');
	        }
	      };
	      var add = function (id, addOn, dependencies) {
	        var addOnConstructor = addOn;
	        items.push(addOnConstructor);
	        lookup[id] = {
	          instance: addOnConstructor,
	          dependencies: dependencies
	        };
	        runListeners(id, 'added');
	        return addOnConstructor;
	      };
	      var remove = function (name) {
	        delete urls[name];
	        delete lookup[name];
	      };
	      var createUrl = function (baseUrl, dep) {
	        if (typeof dep === 'object') {
	          return dep;
	        }
	        return typeof baseUrl === 'string' ? {
	          prefix: '',
	          resource: dep,
	          suffix: ''
	        } : {
	          prefix: baseUrl.prefix,
	          resource: dep,
	          suffix: baseUrl.suffix
	        };
	      };
	      var addComponents = function (pluginName, scripts) {
	        var pluginUrl = urls[pluginName];
	        each$k(scripts, function (script) {
	          ScriptLoader.ScriptLoader.add(pluginUrl + '/' + script);
	        });
	      };
	      var loadDependencies = function (name, addOnUrl, success, scope) {
	        var deps = dependencies(name);
	        each$k(deps, function (dep) {
	          var newUrl = createUrl(addOnUrl, dep);
	          load(newUrl.resource, newUrl, undefined, undefined);
	        });
	        if (success) {
	          if (scope) {
	            success.call(scope);
	          } else {
	            success.call(ScriptLoader);
	          }
	        }
	      };
	      var load = function (name, addOnUrl, success, scope, failure) {
	        if (urls[name]) {
	          return;
	        }
	        var urlString = typeof addOnUrl === 'string' ? addOnUrl : addOnUrl.prefix + addOnUrl.resource + addOnUrl.suffix;
	        if (urlString.indexOf('/') !== 0 && urlString.indexOf('://') === -1) {
	          urlString = AddOnManager.baseURL + '/' + urlString;
	        }
	        urls[name] = urlString.substring(0, urlString.lastIndexOf('/'));
	        var done = function () {
	          runListeners(name, 'loaded');
	          loadDependencies(name, addOnUrl, success, scope);
	        };
	        if (lookup[name]) {
	          done();
	        } else {
	          ScriptLoader.ScriptLoader.add(urlString, done, scope, failure);
	        }
	      };
	      var waitFor = function (name, callback, state) {
	        if (state === void 0) {
	          state = 'added';
	        }
	        if (has$2(lookup, name) && state === 'added') {
	          callback();
	        } else if (has$2(urls, name) && state === 'loaded') {
	          callback();
	        } else {
	          _listeners.push({
	            name: name,
	            state: state,
	            callback: callback
	          });
	        }
	      };
	      return {
	        items: items,
	        urls: urls,
	        lookup: lookup,
	        _listeners: _listeners,
	        get: get,
	        dependencies: dependencies,
	        requireLangPack: requireLangPack,
	        add: add,
	        remove: remove,
	        createUrl: createUrl,
	        addComponents: addComponents,
	        load: load,
	        waitFor: waitFor
	      };
	    };
	    AddOnManager.languageLoad = true;
	    AddOnManager.baseURL = '';
	    AddOnManager.PluginManager = AddOnManager();
	    AddOnManager.ThemeManager = AddOnManager();
	
	    var singleton = function (doRevoke) {
	      var subject = Cell(Optional.none());
	      var revoke = function () {
	        return subject.get().each(doRevoke);
	      };
	      var clear = function () {
	        revoke();
	        subject.set(Optional.none());
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var get = function () {
	        return subject.get();
	      };
	      var set = function (s) {
	        revoke();
	        subject.set(Optional.some(s));
	      };
	      return {
	        clear: clear,
	        isSet: isSet,
	        get: get,
	        set: set
	      };
	    };
	    var value = function () {
	      var subject = singleton(noop);
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return __assign(__assign({}, subject), { on: on });
	    };
	
	    var first = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (!isNull(timer)) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (isNull(timer)) {
	          timer = setTimeout(function () {
	            timer = null;
	            fn.apply(null, args);
	          }, rate);
	        }
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	    var last = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (!isNull(timer)) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        cancel();
	        timer = setTimeout(function () {
	          timer = null;
	          fn.apply(null, args);
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var read$4 = function (element, attr) {
	      var value = get$6(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add$3 = function (element, attr, id) {
	      var old = read$4(element, attr);
	      var nu = old.concat([id]);
	      set$1(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$5 = function (element, attr, id) {
	      var nu = filter$4(read$4(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set$1(element, attr, nu.join(' '));
	      } else {
	        remove$6(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom.classList !== undefined;
	    };
	    var get$4 = function (element) {
	      return read$4(element, 'class');
	    };
	    var add$2 = function (element, clazz) {
	      return add$3(element, 'class', clazz);
	    };
	    var remove$4 = function (element, clazz) {
	      return remove$5(element, 'class', clazz);
	    };
	
	    var add$1 = function (element, clazz) {
	      if (supports(element)) {
	        element.dom.classList.add(clazz);
	      } else {
	        add$2(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom.classList : get$4(element);
	      if (classList.length === 0) {
	        remove$6(element, 'class');
	      }
	    };
	    var remove$3 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom.classList;
	        classList.remove(clazz);
	      } else {
	        remove$4(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has = function (element, clazz) {
	      return supports(element) && element.dom.classList.contains(clazz);
	    };
	
	    var descendants$1 = function (scope, predicate) {
	      var result = [];
	      each$k(children(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([x]);
	        }
	        result = result.concat(descendants$1(x, predicate));
	      });
	      return result;
	    };
	
	    var descendants = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    var annotation = constant('mce-annotation');
	    var dataAnnotation = constant('data-mce-annotation');
	    var dataAnnotationId = constant('data-mce-annotation-uid');
	
	    var identify = function (editor, annotationName) {
	      var rng = editor.selection.getRng();
	      var start = SugarElement.fromDom(rng.startContainer);
	      var root = SugarElement.fromDom(editor.getBody());
	      var selector = annotationName.fold(function () {
	        return '.' + annotation();
	      }, function (an) {
	        return '[' + dataAnnotation() + '="' + an + '"]';
	      });
	      var newStart = child$1(start, rng.startOffset).getOr(start);
	      var closest = closest$2(newStart, selector, function (n) {
	        return eq(n, root);
	      });
	      var getAttr = function (c, property) {
	        if (has$1(c, property)) {
	          return Optional.some(get$6(c, property));
	        } else {
	          return Optional.none();
	        }
	      };
	      return closest.bind(function (c) {
	        return getAttr(c, '' + dataAnnotationId()).bind(function (uid) {
	          return getAttr(c, '' + dataAnnotation()).map(function (name) {
	            var elements = findMarkers(editor, uid);
	            return {
	              uid: uid,
	              name: name,
	              elements: elements
	            };
	          });
	        });
	      });
	    };
	    var isAnnotation = function (elem) {
	      return isElement$6(elem) && has(elem, annotation());
	    };
	    var findMarkers = function (editor, uid) {
	      var body = SugarElement.fromDom(editor.getBody());
	      return descendants(body, '[' + dataAnnotationId() + '="' + uid + '"]');
	    };
	    var findAll = function (editor, name) {
	      var body = SugarElement.fromDom(editor.getBody());
	      var markers = descendants(body, '[' + dataAnnotation() + '="' + name + '"]');
	      var directory = {};
	      each$k(markers, function (m) {
	        var uid = get$6(m, dataAnnotationId());
	        var nodesAlready = get$9(directory, uid).getOr([]);
	        directory[uid] = nodesAlready.concat([m]);
	      });
	      return directory;
	    };
	
	    var setup$n = function (editor, _registry) {
	      var changeCallbacks = Cell({});
	      var initData = function () {
	        return {
	          listeners: [],
	          previous: value()
	        };
	      };
	      var withCallbacks = function (name, f) {
	        updateCallbacks(name, function (data) {
	          f(data);
	          return data;
	        });
	      };
	      var updateCallbacks = function (name, f) {
	        var callbackMap = changeCallbacks.get();
	        var data = get$9(callbackMap, name).getOrThunk(initData);
	        var outputData = f(data);
	        callbackMap[name] = outputData;
	        changeCallbacks.set(callbackMap);
	      };
	      var fireCallbacks = function (name, uid, elements) {
	        withCallbacks(name, function (data) {
	          each$k(data.listeners, function (f) {
	            return f(true, name, {
	              uid: uid,
	              nodes: map$3(elements, function (elem) {
	                return elem.dom;
	              })
	            });
	          });
	        });
	      };
	      var fireNoAnnotation = function (name) {
	        withCallbacks(name, function (data) {
	          each$k(data.listeners, function (f) {
	            return f(false, name);
	          });
	        });
	      };
	      var onNodeChange = last(function () {
	        var callbackMap = changeCallbacks.get();
	        var annotations = sort(keys(callbackMap));
	        each$k(annotations, function (name) {
	          updateCallbacks(name, function (data) {
	            var prev = data.previous.get();
	            identify(editor, Optional.some(name)).fold(function () {
	              if (prev.isSome()) {
	                fireNoAnnotation(name);
	                data.previous.clear();
	              }
	            }, function (_a) {
	              var uid = _a.uid, name = _a.name, elements = _a.elements;
	              if (!is$1(prev, uid)) {
	                fireCallbacks(name, uid, elements);
	                data.previous.set(uid);
	              }
	            });
	            return {
	              previous: data.previous,
	              listeners: data.listeners
	            };
	          });
	        });
	      }, 30);
	      editor.on('remove', function () {
	        onNodeChange.cancel();
	      });
	      editor.on('NodeChange', function () {
	        onNodeChange.throttle();
	      });
	      var addListener = function (name, f) {
	        updateCallbacks(name, function (data) {
	          return {
	            previous: data.previous,
	            listeners: data.listeners.concat([f])
	          };
	        });
	      };
	      return { addListener: addListener };
	    };
	
	    var setup$m = function (editor, registry) {
	      var identifyParserNode = function (span) {
	        return Optional.from(span.attr(dataAnnotation())).bind(registry.lookup);
	      };
	      editor.on('init', function () {
	        editor.serializer.addNodeFilter('span', function (spans) {
	          each$k(spans, function (span) {
	            identifyParserNode(span).each(function (settings) {
	              if (settings.persistent === false) {
	                span.unwrap();
	              }
	            });
	          });
	        });
	      });
	    };
	
	    var create$7 = function () {
	      var annotations = {};
	      var register = function (name, settings) {
	        annotations[name] = {
	          name: name,
	          settings: settings
	        };
	      };
	      var lookup = function (name) {
	        return get$9(annotations, name).map(function (a) {
	          return a.settings;
	        });
	      };
	      return {
	        register: register,
	        lookup: lookup
	      };
	    };
	
	    var unique = 0;
	    var generate = function (prefix) {
	      var date = new Date();
	      var time = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	      unique++;
	      return prefix + '_' + random + unique + String(time);
	    };
	
	    var add = function (element, classes) {
	      each$k(classes, function (x) {
	        add$1(element, x);
	      });
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children(SugarElement.fromDom(div));
	    };
	    var fromDom$1 = function (nodes) {
	      return map$3(nodes, SugarElement.fromDom);
	    };
	
	    var get$3 = function (element) {
	      return element.dom.innerHTML;
	    };
	    var set = function (element, content) {
	      var owner = owner$1(element);
	      var docDom = owner.dom;
	      var fragment = SugarElement.fromDom(docDom.createDocumentFragment());
	      var contentElements = fromHtml(content, docDom);
	      append(fragment, contentElements);
	      empty(element);
	      append$1(element, fragment);
	    };
	
	    var clone$1 = function (original, isDeep) {
	      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
	    };
	    var shallow = function (original) {
	      return clone$1(original, false);
	    };
	    var deep$1 = function (original) {
	      return clone$1(original, true);
	    };
	
	    var TextWalker = function (startNode, rootNode, isBoundary) {
	      if (isBoundary === void 0) {
	        isBoundary = never;
	      }
	      var walker = new DomTreeWalker(startNode, rootNode);
	      var walk = function (direction) {
	        var next;
	        do {
	          next = walker[direction]();
	        } while (next && !isText$7(next) && !isBoundary(next));
	        return Optional.from(next).filter(isText$7);
	      };
	      return {
	        current: function () {
	          return Optional.from(walker.current()).filter(isText$7);
	        },
	        next: function () {
	          return walk('next');
	        },
	        prev: function () {
	          return walk('prev');
	        },
	        prev2: function () {
	          return walk('prev2');
	        }
	      };
	    };
	
	    var TextSeeker = function (dom, isBoundary) {
	      var isBlockBoundary = isBoundary ? isBoundary : function (node) {
	        return dom.isBlock(node) || isBr$5(node) || isContentEditableFalse$b(node);
	      };
	      var walk = function (node, offset, walker, process) {
	        if (isText$7(node)) {
	          var newOffset = process(node, offset, node.data);
	          if (newOffset !== -1) {
	            return Optional.some({
	              container: node,
	              offset: newOffset
	            });
	          }
	        }
	        return walker().bind(function (next) {
	          return walk(next.container, next.offset, walker, process);
	        });
	      };
	      var backwards = function (node, offset, process, root) {
	        var walker = TextWalker(node, root, isBlockBoundary);
	        return walk(node, offset, function () {
	          return walker.prev().map(function (prev) {
	            return {
	              container: prev,
	              offset: prev.length
	            };
	          });
	        }, process).getOrNull();
	      };
	      var forwards = function (node, offset, process, root) {
	        var walker = TextWalker(node, root, isBlockBoundary);
	        return walk(node, offset, function () {
	          return walker.next().map(function (next) {
	            return {
	              container: next,
	              offset: 0
	            };
	          });
	        }, process).getOrNull();
	      };
	      return {
	        backwards: backwards,
	        forwards: forwards
	      };
	    };
	
	    var round$2 = Math.round;
	    var clone = function (rect) {
	      if (!rect) {
	        return {
	          left: 0,
	          top: 0,
	          bottom: 0,
	          right: 0,
	          width: 0,
	          height: 0
	        };
	      }
	      return {
	        left: round$2(rect.left),
	        top: round$2(rect.top),
	        bottom: round$2(rect.bottom),
	        right: round$2(rect.right),
	        width: round$2(rect.width),
	        height: round$2(rect.height)
	      };
	    };
	    var collapse = function (rect, toStart) {
	      rect = clone(rect);
	      if (toStart) {
	        rect.right = rect.left;
	      } else {
	        rect.left = rect.left + rect.width;
	        rect.right = rect.left;
	      }
	      rect.width = 0;
	      return rect;
	    };
	    var isEqual = function (rect1, rect2) {
	      return rect1.left === rect2.left && rect1.top === rect2.top && rect1.bottom === rect2.bottom && rect1.right === rect2.right;
	    };
	    var isValidOverflow = function (overflowY, rect1, rect2) {
	      return overflowY >= 0 && overflowY <= Math.min(rect1.height, rect2.height) / 2;
	    };
	    var isAbove$1 = function (rect1, rect2) {
	      var halfHeight = Math.min(rect2.height / 2, rect1.height / 2);
	      if (rect1.bottom - halfHeight < rect2.top) {
	        return true;
	      }
	      if (rect1.top > rect2.bottom) {
	        return false;
	      }
	      return isValidOverflow(rect2.top - rect1.bottom, rect1, rect2);
	    };
	    var isBelow$1 = function (rect1, rect2) {
	      if (rect1.top > rect2.bottom) {
	        return true;
	      }
	      if (rect1.bottom < rect2.top) {
	        return false;
	      }
	      return isValidOverflow(rect2.bottom - rect1.top, rect1, rect2);
	    };
	    var containsXY = function (rect, clientX, clientY) {
	      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
	    };
	
	    var clamp$2 = function (value, min, max) {
	      return Math.min(Math.max(value, min), max);
	    };
	
	    var getSelectedNode = function (range) {
	      var startContainer = range.startContainer, startOffset = range.startOffset;
	      if (startContainer.hasChildNodes() && range.endOffset === startOffset + 1) {
	        return startContainer.childNodes[startOffset];
	      }
	      return null;
	    };
	    var getNode$1 = function (container, offset) {
	      if (isElement$5(container) && container.hasChildNodes()) {
	        var childNodes = container.childNodes;
	        var safeOffset = clamp$2(offset, 0, childNodes.length - 1);
	        return childNodes[safeOffset];
	      } else {
	        return container;
	      }
	    };
	    var getNodeUnsafe = function (container, offset) {
	      if (offset < 0 && isElement$5(container) && container.hasChildNodes()) {
	        return undefined;
	      } else {
	        return getNode$1(container, offset);
	      }
	    };
	
	    var extendingChars = new RegExp('[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a' + '\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0' + '\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e3-\u0902\u093a\u093c' + '\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3' + '\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc' + '\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57' + '\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56' + '\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44' + '\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9' + '\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97' + '\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074' + '\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5' + '\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18' + '\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1ABE\u1b00-\u1b03\u1b34' + '\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9' + '\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9' + '\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20DD-\u20E0\u20e1\u20E2-\u20E4\u20e5-\u20f0\u2cef-\u2cf1' + '\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\uA670-\uA672\ua674-\ua67d\ua69e-\ua69f\ua6f0-\ua6f1' + '\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc' + '\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1' + '\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\uff9e-\uff9f]');
	    var isExtendingChar = function (ch) {
	      return typeof ch === 'string' && ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
	    };
	
	    var or = function () {
	      var args = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	      }
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (args[i](x)) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var and = function () {
	      var args = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	      }
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (!args[i](x)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    };
	
	    var isElement$3 = isElement$5;
	    var isCaretCandidate$2 = isCaretCandidate$3;
	    var isBlock$1 = matchStyleValues('display', 'block table');
	    var isFloated = matchStyleValues('float', 'left right');
	    var isValidElementCaretCandidate = and(isElement$3, isCaretCandidate$2, not(isFloated));
	    var isNotPre = not(matchStyleValues('white-space', 'pre pre-line pre-wrap'));
	    var isText$4 = isText$7;
	    var isBr$2 = isBr$5;
	    var nodeIndex$1 = DOMUtils.nodeIndex;
	    var resolveIndex$1 = getNodeUnsafe;
	    var createRange$1 = function (doc) {
	      return 'createRange' in doc ? doc.createRange() : DOMUtils.DOM.createRng();
	    };
	    var isWhiteSpace$1 = function (chr) {
	      return chr && /[\r\n\t ]/.test(chr);
	    };
	    var isRange = function (rng) {
	      return !!rng.setStart && !!rng.setEnd;
	    };
	    var isHiddenWhiteSpaceRange = function (range) {
	      var container = range.startContainer;
	      var offset = range.startOffset;
	      if (isWhiteSpace$1(range.toString()) && isNotPre(container.parentNode) && isText$7(container)) {
	        var text = container.data;
	        if (isWhiteSpace$1(text[offset - 1]) || isWhiteSpace$1(text[offset + 1])) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var getBrClientRect = function (brNode) {
	      var doc = brNode.ownerDocument;
	      var rng = createRange$1(doc);
	      var nbsp$1 = doc.createTextNode(nbsp);
	      var parentNode = brNode.parentNode;
	      parentNode.insertBefore(nbsp$1, brNode);
	      rng.setStart(nbsp$1, 0);
	      rng.setEnd(nbsp$1, 1);
	      var clientRect = clone(rng.getBoundingClientRect());
	      parentNode.removeChild(nbsp$1);
	      return clientRect;
	    };
	    var getBoundingClientRectWebKitText = function (rng) {
	      var sc = rng.startContainer;
	      var ec = rng.endContainer;
	      var so = rng.startOffset;
	      var eo = rng.endOffset;
	      if (sc === ec && isText$7(ec) && so === 0 && eo === 1) {
	        var newRng = rng.cloneRange();
	        newRng.setEndAfter(ec);
	        return getBoundingClientRect$1(newRng);
	      } else {
	        return null;
	      }
	    };
	    var isZeroRect = function (r) {
	      return r.left === 0 && r.right === 0 && r.top === 0 && r.bottom === 0;
	    };
	    var getBoundingClientRect$1 = function (item) {
	      var clientRect;
	      var clientRects = item.getClientRects();
	      if (clientRects.length > 0) {
	        clientRect = clone(clientRects[0]);
	      } else {
	        clientRect = clone(item.getBoundingClientRect());
	      }
	      if (!isRange(item) && isBr$2(item) && isZeroRect(clientRect)) {
	        return getBrClientRect(item);
	      }
	      if (isZeroRect(clientRect) && isRange(item)) {
	        return getBoundingClientRectWebKitText(item);
	      }
	      return clientRect;
	    };
	    var collapseAndInflateWidth = function (clientRect, toStart) {
	      var newClientRect = collapse(clientRect, toStart);
	      newClientRect.width = 1;
	      newClientRect.right = newClientRect.left + 1;
	      return newClientRect;
	    };
	    var getCaretPositionClientRects = function (caretPosition) {
	      var clientRects = [];
	      var addUniqueAndValidRect = function (clientRect) {
	        if (clientRect.height === 0) {
	          return;
	        }
	        if (clientRects.length > 0) {
	          if (isEqual(clientRect, clientRects[clientRects.length - 1])) {
	            return;
	          }
	        }
	        clientRects.push(clientRect);
	      };
	      var addCharacterOffset = function (container, offset) {
	        var range = createRange$1(container.ownerDocument);
	        if (offset < container.data.length) {
	          if (isExtendingChar(container.data[offset])) {
	            return clientRects;
	          }
	          if (isExtendingChar(container.data[offset - 1])) {
	            range.setStart(container, offset);
	            range.setEnd(container, offset + 1);
	            if (!isHiddenWhiteSpaceRange(range)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(range), false));
	              return clientRects;
	            }
	          }
	        }
	        if (offset > 0) {
	          range.setStart(container, offset - 1);
	          range.setEnd(container, offset);
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(range), false));
	          }
	        }
	        if (offset < container.data.length) {
	          range.setStart(container, offset);
	          range.setEnd(container, offset + 1);
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(range), true));
	          }
	        }
	      };
	      var container = caretPosition.container();
	      var offset = caretPosition.offset();
	      if (isText$4(container)) {
	        addCharacterOffset(container, offset);
	        return clientRects;
	      }
	      if (isElement$3(container)) {
	        if (caretPosition.isAtEnd()) {
	          var node = resolveIndex$1(container, offset);
	          if (isText$4(node)) {
	            addCharacterOffset(node, node.data.length);
	          }
	          if (isValidElementCaretCandidate(node) && !isBr$2(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(node), false));
	          }
	        } else {
	          var node = resolveIndex$1(container, offset);
	          if (isText$4(node)) {
	            addCharacterOffset(node, 0);
	          }
	          if (isValidElementCaretCandidate(node) && caretPosition.isAtEnd()) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(node), false));
	            return clientRects;
	          }
	          var beforeNode = resolveIndex$1(caretPosition.container(), caretPosition.offset() - 1);
	          if (isValidElementCaretCandidate(beforeNode) && !isBr$2(beforeNode)) {
	            if (isBlock$1(beforeNode) || isBlock$1(node) || !isValidElementCaretCandidate(node)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(beforeNode), false));
	            }
	          }
	          if (isValidElementCaretCandidate(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(node), true));
	          }
	        }
	      }
	      return clientRects;
	    };
	    var CaretPosition = function (container, offset, clientRects) {
	      var isAtStart = function () {
	        if (isText$4(container)) {
	          return offset === 0;
	        }
	        return offset === 0;
	      };
	      var isAtEnd = function () {
	        if (isText$4(container)) {
	          return offset >= container.data.length;
	        }
	        return offset >= container.childNodes.length;
	      };
	      var toRange = function () {
	        var range = createRange$1(container.ownerDocument);
	        range.setStart(container, offset);
	        range.setEnd(container, offset);
	        return range;
	      };
	      var getClientRects = function () {
	        if (!clientRects) {
	          clientRects = getCaretPositionClientRects(CaretPosition(container, offset));
	        }
	        return clientRects;
	      };
	      var isVisible = function () {
	        return getClientRects().length > 0;
	      };
	      var isEqual = function (caretPosition) {
	        return caretPosition && container === caretPosition.container() && offset === caretPosition.offset();
	      };
	      var getNode = function (before) {
	        return resolveIndex$1(container, before ? offset - 1 : offset);
	      };
	      return {
	        container: constant(container),
	        offset: constant(offset),
	        toRange: toRange,
	        getClientRects: getClientRects,
	        isVisible: isVisible,
	        isAtStart: isAtStart,
	        isAtEnd: isAtEnd,
	        isEqual: isEqual,
	        getNode: getNode
	      };
	    };
	    CaretPosition.fromRangeStart = function (range) {
	      return CaretPosition(range.startContainer, range.startOffset);
	    };
	    CaretPosition.fromRangeEnd = function (range) {
	      return CaretPosition(range.endContainer, range.endOffset);
	    };
	    CaretPosition.after = function (node) {
	      return CaretPosition(node.parentNode, nodeIndex$1(node) + 1);
	    };
	    CaretPosition.before = function (node) {
	      return CaretPosition(node.parentNode, nodeIndex$1(node));
	    };
	    CaretPosition.isAbove = function (pos1, pos2) {
	      return lift2(head(pos2.getClientRects()), last$2(pos1.getClientRects()), isAbove$1).getOr(false);
	    };
	    CaretPosition.isBelow = function (pos1, pos2) {
	      return lift2(last$2(pos2.getClientRects()), head(pos1.getClientRects()), isBelow$1).getOr(false);
	    };
	    CaretPosition.isAtStart = function (pos) {
	      return pos ? pos.isAtStart() : false;
	    };
	    CaretPosition.isAtEnd = function (pos) {
	      return pos ? pos.isAtEnd() : false;
	    };
	    CaretPosition.isTextPosition = function (pos) {
	      return pos ? isText$7(pos.container()) : false;
	    };
	    CaretPosition.isElementPosition = function (pos) {
	      return CaretPosition.isTextPosition(pos) === false;
	    };
	
	    var trimEmptyTextNode$1 = function (dom, node) {
	      if (isText$7(node) && node.data.length === 0) {
	        dom.remove(node);
	      }
	    };
	    var insertNode = function (dom, rng, node) {
	      rng.insertNode(node);
	      trimEmptyTextNode$1(dom, node.previousSibling);
	      trimEmptyTextNode$1(dom, node.nextSibling);
	    };
	    var insertFragment = function (dom, rng, frag) {
	      var firstChild = Optional.from(frag.firstChild);
	      var lastChild = Optional.from(frag.lastChild);
	      rng.insertNode(frag);
	      firstChild.each(function (child) {
	        return trimEmptyTextNode$1(dom, child.previousSibling);
	      });
	      lastChild.each(function (child) {
	        return trimEmptyTextNode$1(dom, child.nextSibling);
	      });
	    };
	    var rangeInsertNode = function (dom, rng, node) {
	      if (isDocumentFragment(node)) {
	        insertFragment(dom, rng, node);
	      } else {
	        insertNode(dom, rng, node);
	      }
	    };
	
	    var isText$3 = isText$7;
	    var isBogus = isBogus$2;
	    var nodeIndex = DOMUtils.nodeIndex;
	    var normalizedParent = function (node) {
	      var parentNode = node.parentNode;
	      if (isBogus(parentNode)) {
	        return normalizedParent(parentNode);
	      }
	      return parentNode;
	    };
	    var getChildNodes = function (node) {
	      if (!node) {
	        return [];
	      }
	      return reduce(node.childNodes, function (result, node) {
	        if (isBogus(node) && node.nodeName !== 'BR') {
	          result = result.concat(getChildNodes(node));
	        } else {
	          result.push(node);
	        }
	        return result;
	      }, []);
	    };
	    var normalizedTextOffset = function (node, offset) {
	      while (node = node.previousSibling) {
	        if (!isText$3(node)) {
	          break;
	        }
	        offset += node.data.length;
	      }
	      return offset;
	    };
	    var equal = function (a) {
	      return function (b) {
	        return a === b;
	      };
	    };
	    var normalizedNodeIndex = function (node) {
	      var nodes, index;
	      nodes = getChildNodes(normalizedParent(node));
	      index = findIndex$1(nodes, equal(node), node);
	      nodes = nodes.slice(0, index + 1);
	      var numTextFragments = reduce(nodes, function (result, node, i) {
	        if (isText$3(node) && isText$3(nodes[i - 1])) {
	          result++;
	        }
	        return result;
	      }, 0);
	      nodes = filter$2(nodes, matchNodeNames([node.nodeName]));
	      index = findIndex$1(nodes, equal(node), node);
	      return index - numTextFragments;
	    };
	    var createPathItem = function (node) {
	      var name;
	      if (isText$3(node)) {
	        name = 'text()';
	      } else {
	        name = node.nodeName.toLowerCase();
	      }
	      return name + '[' + normalizedNodeIndex(node) + ']';
	    };
	    var parentsUntil$1 = function (root, node, predicate) {
	      var parents = [];
	      for (node = node.parentNode; node !== root; node = node.parentNode) {
	        if (predicate && predicate(node)) {
	          break;
	        }
	        parents.push(node);
	      }
	      return parents;
	    };
	    var create$6 = function (root, caretPosition) {
	      var container, offset, path = [], outputOffset, childNodes, parents;
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	      if (isText$3(container)) {
	        outputOffset = normalizedTextOffset(container, offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length) {
	          outputOffset = 'after';
	          offset = childNodes.length - 1;
	        } else {
	          outputOffset = 'before';
	        }
	        container = childNodes[offset];
	      }
	      path.push(createPathItem(container));
	      parents = parentsUntil$1(root, container);
	      parents = filter$2(parents, not(isBogus$2));
	      path = path.concat(map$1(parents, function (node) {
	        return createPathItem(node);
	      }));
	      return path.reverse().join('/') + ',' + outputOffset;
	    };
	    var resolvePathItem = function (node, name, index) {
	      var nodes = getChildNodes(node);
	      nodes = filter$2(nodes, function (node, index) {
	        return !isText$3(node) || !isText$3(nodes[index - 1]);
	      });
	      nodes = filter$2(nodes, matchNodeNames([name]));
	      return nodes[index];
	    };
	    var findTextPosition = function (container, offset) {
	      var node = container, targetOffset = 0, dataLen;
	      while (isText$3(node)) {
	        dataLen = node.data.length;
	        if (offset >= targetOffset && offset <= targetOffset + dataLen) {
	          container = node;
	          offset = offset - targetOffset;
	          break;
	        }
	        if (!isText$3(node.nextSibling)) {
	          container = node;
	          offset = dataLen;
	          break;
	        }
	        targetOffset += dataLen;
	        node = node.nextSibling;
	      }
	      if (isText$3(container) && offset > container.data.length) {
	        offset = container.data.length;
	      }
	      return CaretPosition(container, offset);
	    };
	    var resolve$2 = function (root, path) {
	      var offset;
	      if (!path) {
	        return null;
	      }
	      var parts = path.split(',');
	      var paths = parts[0].split('/');
	      offset = parts.length > 1 ? parts[1] : 'before';
	      var container = reduce(paths, function (result, value) {
	        var match = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);
	        if (!match) {
	          return null;
	        }
	        if (match[1] === 'text()') {
	          match[1] = '#text';
	        }
	        return resolvePathItem(result, match[1], parseInt(match[2], 10));
	      }, root);
	      if (!container) {
	        return null;
	      }
	      if (!isText$3(container)) {
	        if (offset === 'after') {
	          offset = nodeIndex(container) + 1;
	        } else {
	          offset = nodeIndex(container);
	        }
	        return CaretPosition(container.parentNode, offset);
	      }
	      return findTextPosition(container, parseInt(offset, 10));
	    };
	
	    var isContentEditableFalse$9 = isContentEditableFalse$b;
	    var getNormalizedTextOffset = function (trim, container, offset) {
	      var node, trimmedOffset;
	      trimmedOffset = trim(container.data.slice(0, offset)).length;
	      for (node = container.previousSibling; node && isText$7(node); node = node.previousSibling) {
	        trimmedOffset += trim(node.data).length;
	      }
	      return trimmedOffset;
	    };
	    var getPoint = function (dom, trim, normalized, rng, start) {
	      var container = rng[start ? 'startContainer' : 'endContainer'];
	      var offset = rng[start ? 'startOffset' : 'endOffset'];
	      var point = [];
	      var childNodes, after = 0;
	      var root = dom.getRoot();
	      if (isText$7(container)) {
	        point.push(normalized ? getNormalizedTextOffset(trim, container, offset) : offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length && childNodes.length) {
	          after = 1;
	          offset = Math.max(0, childNodes.length - 1);
	        }
	        point.push(dom.nodeIndex(childNodes[offset], normalized) + after);
	      }
	      for (; container && container !== root; container = container.parentNode) {
	        point.push(dom.nodeIndex(container, normalized));
	      }
	      return point;
	    };
	    var getLocation = function (trim, selection, normalized, rng) {
	      var dom = selection.dom, bookmark = {};
	      bookmark.start = getPoint(dom, trim, normalized, rng, true);
	      if (!selection.isCollapsed()) {
	        bookmark.end = getPoint(dom, trim, normalized, rng, false);
	      }
	      if (isRangeInCaretContainerBlock(rng)) {
	        bookmark.isFakeCaret = true;
	      }
	      return bookmark;
	    };
	    var findIndex = function (dom, name, element) {
	      var count = 0;
	      Tools.each(dom.select(name), function (node) {
	        if (node.getAttribute('data-mce-bogus') === 'all') {
	          return;
	        }
	        if (node === element) {
	          return false;
	        }
	        count++;
	      });
	      return count;
	    };
	    var moveEndPoint$1 = function (rng, start) {
	      var container, offset, childNodes;
	      var prefix = start ? 'start' : 'end';
	      container = rng[prefix + 'Container'];
	      offset = rng[prefix + 'Offset'];
	      if (isElement$5(container) && container.nodeName === 'TR') {
	        childNodes = container.childNodes;
	        container = childNodes[Math.min(start ? offset : offset - 1, childNodes.length - 1)];
	        if (container) {
	          offset = start ? 0 : container.childNodes.length;
	          rng['set' + (start ? 'Start' : 'End')](container, offset);
	        }
	      }
	    };
	    var normalizeTableCellSelection = function (rng) {
	      moveEndPoint$1(rng, true);
	      moveEndPoint$1(rng, false);
	      return rng;
	    };
	    var findSibling = function (node, offset) {
	      var sibling;
	      if (isElement$5(node)) {
	        node = getNode$1(node, offset);
	        if (isContentEditableFalse$9(node)) {
	          return node;
	        }
	      }
	      if (isCaretContainer$2(node)) {
	        if (isText$7(node) && isCaretContainerBlock$1(node)) {
	          node = node.parentNode;
	        }
	        sibling = node.previousSibling;
	        if (isContentEditableFalse$9(sibling)) {
	          return sibling;
	        }
	        sibling = node.nextSibling;
	        if (isContentEditableFalse$9(sibling)) {
	          return sibling;
	        }
	      }
	    };
	    var findAdjacentContentEditableFalseElm = function (rng) {
	      return findSibling(rng.startContainer, rng.startOffset) || findSibling(rng.endContainer, rng.endOffset);
	    };
	    var getOffsetBookmark = function (trim, normalized, selection) {
	      var element = selection.getNode();
	      var name = element ? element.nodeName : null;
	      var rng = selection.getRng();
	      if (isContentEditableFalse$9(element) || name === 'IMG') {
	        return {
	          name: name,
	          index: findIndex(selection.dom, name, element)
	        };
	      }
	      var sibling = findAdjacentContentEditableFalseElm(rng);
	      if (sibling) {
	        name = sibling.tagName;
	        return {
	          name: name,
	          index: findIndex(selection.dom, name, sibling)
	        };
	      }
	      return getLocation(trim, selection, normalized, rng);
	    };
	    var getCaretBookmark = function (selection) {
	      var rng = selection.getRng();
	      return {
	        start: create$6(selection.dom.getRoot(), CaretPosition.fromRangeStart(rng)),
	        end: create$6(selection.dom.getRoot(), CaretPosition.fromRangeEnd(rng))
	      };
	    };
	    var getRangeBookmark = function (selection) {
	      return { rng: selection.getRng() };
	    };
	    var createBookmarkSpan = function (dom, id, filled) {
	      var args = {
	        'data-mce-type': 'bookmark',
	        id: id,
	        'style': 'overflow:hidden;line-height:0px'
	      };
	      return filled ? dom.create('span', args, '&#xFEFF;') : dom.create('span', args);
	    };
	    var getPersistentBookmark = function (selection, filled) {
	      var dom = selection.dom;
	      var rng = selection.getRng();
	      var id = dom.uniqueId();
	      var collapsed = selection.isCollapsed();
	      var element = selection.getNode();
	      var name = element.nodeName;
	      if (name === 'IMG') {
	        return {
	          name: name,
	          index: findIndex(dom, name, element)
	        };
	      }
	      var rng2 = normalizeTableCellSelection(rng.cloneRange());
	      if (!collapsed) {
	        rng2.collapse(false);
	        var endBookmarkNode = createBookmarkSpan(dom, id + '_end', filled);
	        rangeInsertNode(dom, rng2, endBookmarkNode);
	      }
	      rng = normalizeTableCellSelection(rng);
	      rng.collapse(true);
	      var startBookmarkNode = createBookmarkSpan(dom, id + '_start', filled);
	      rangeInsertNode(dom, rng, startBookmarkNode);
	      selection.moveToBookmark({
	        id: id,
	        keep: true
	      });
	      return { id: id };
	    };
	    var getBookmark$2 = function (selection, type, normalized) {
	      if (type === 2) {
	        return getOffsetBookmark(trim$2, normalized, selection);
	      } else if (type === 3) {
	        return getCaretBookmark(selection);
	      } else if (type) {
	        return getRangeBookmark(selection);
	      } else {
	        return getPersistentBookmark(selection, false);
	      }
	    };
	    var getUndoBookmark = curry(getOffsetBookmark, identity, true);
	
	    var DOM$9 = DOMUtils.DOM;
	    var defaultPreviewStyles = 'font-family font-size font-weight font-style text-decoration text-transform color background-color border border-radius outline text-shadow';
	    var getBodySetting = function (editor, name, defaultValue) {
	      var value = editor.getParam(name, defaultValue);
	      if (value.indexOf('=') !== -1) {
	        var bodyObj = editor.getParam(name, '', 'hash');
	        return get$9(bodyObj, editor.id).getOr(defaultValue);
	      } else {
	        return value;
	      }
	    };
	    var getIframeAttrs = function (editor) {
	      return editor.getParam('iframe_attrs', {});
	    };
	    var getDocType = function (editor) {
	      return editor.getParam('doctype', '<!DOCTYPE html>');
	    };
	    var getDocumentBaseUrl = function (editor) {
	      return editor.getParam('document_base_url', '');
	    };
	    var getBodyId = function (editor) {
	      return getBodySetting(editor, 'body_id', 'tinymce');
	    };
	    var getBodyClass = function (editor) {
	      return getBodySetting(editor, 'body_class', '');
	    };
	    var getContentSecurityPolicy = function (editor) {
	      return editor.getParam('content_security_policy', '');
	    };
	    var shouldPutBrInPre$1 = function (editor) {
	      return editor.getParam('br_in_pre', true);
	    };
	    var getForcedRootBlock = function (editor) {
	      if (editor.getParam('force_p_newlines', false)) {
	        return 'p';
	      }
	      var block = editor.getParam('forced_root_block', 'p');
	      if (block === false) {
	        return '';
	      } else if (block === true) {
	        return 'p';
	      } else {
	        return block;
	      }
	    };
	    var getForcedRootBlockAttrs = function (editor) {
	      return editor.getParam('forced_root_block_attrs', {});
	    };
	    var getBrNewLineSelector = function (editor) {
	      return editor.getParam('br_newline_selector', '.mce-toc h2,figcaption,caption');
	    };
	    var getNoNewLineSelector = function (editor) {
	      return editor.getParam('no_newline_selector', '');
	    };
	    var shouldKeepStyles = function (editor) {
	      return editor.getParam('keep_styles', true);
	    };
	    var shouldEndContainerOnEmptyBlock = function (editor) {
	      return editor.getParam('end_container_on_empty_block', false);
	    };
	    var getFontStyleValues = function (editor) {
	      return Tools.explode(editor.getParam('font_size_style_values', 'xx-small,x-small,small,medium,large,x-large,xx-large'));
	    };
	    var getFontSizeClasses = function (editor) {
	      return Tools.explode(editor.getParam('font_size_classes', ''));
	    };
	    var getImagesDataImgFilter = function (editor) {
	      return editor.getParam('images_dataimg_filter', always, 'function');
	    };
	    var isAutomaticUploadsEnabled = function (editor) {
	      return editor.getParam('automatic_uploads', true, 'boolean');
	    };
	    var shouldReuseFileName = function (editor) {
	      return editor.getParam('images_reuse_filename', false, 'boolean');
	    };
	    var shouldReplaceBlobUris = function (editor) {
	      return editor.getParam('images_replace_blob_uris', true, 'boolean');
	    };
	    var getIconPackName = function (editor) {
	      return editor.getParam('icons', '', 'string');
	    };
	    var getIconsUrl = function (editor) {
	      return editor.getParam('icons_url', '', 'string');
	    };
	    var getImageUploadUrl = function (editor) {
	      return editor.getParam('images_upload_url', '', 'string');
	    };
	    var getImageUploadBasePath = function (editor) {
	      return editor.getParam('images_upload_base_path', '', 'string');
	    };
	    var getImagesUploadCredentials = function (editor) {
	      return editor.getParam('images_upload_credentials', false, 'boolean');
	    };
	    var getImagesUploadHandler = function (editor) {
	      return editor.getParam('images_upload_handler', null, 'function');
	    };
	    var shouldUseContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors', false, 'boolean');
	    };
	    var getReferrerPolicy = function (editor) {
	      return editor.getParam('referrer_policy', '', 'string');
	    };
	    var getLanguageCode = function (editor) {
	      return editor.getParam('language', 'en', 'string');
	    };
	    var getLanguageUrl = function (editor) {
	      return editor.getParam('language_url', '', 'string');
	    };
	    var shouldIndentUseMargin = function (editor) {
	      return editor.getParam('indent_use_margin', false);
	    };
	    var getIndentation = function (editor) {
	      return editor.getParam('indentation', '40px', 'string');
	    };
	    var getContentCss = function (editor) {
	      var contentCss = editor.getParam('content_css');
	      if (isString$1(contentCss)) {
	        return map$3(contentCss.split(','), trim$4);
	      } else if (isArray$1(contentCss)) {
	        return contentCss;
	      } else if (contentCss === false || editor.inline) {
	        return [];
	      } else {
	        return ['default'];
	      }
	    };
	    var getFontCss = function (editor) {
	      var fontCss = editor.getParam('font_css', []);
	      return isArray$1(fontCss) ? fontCss : map$3(fontCss.split(','), trim$4);
	    };
	    var getDirectionality = function (editor) {
	      return editor.getParam('directionality', I18n.isRtl() ? 'rtl' : undefined);
	    };
	    var getInlineBoundarySelector = function (editor) {
	      return editor.getParam('inline_boundaries_selector', 'a[href],code,.mce-annotation', 'string');
	    };
	    var getObjectResizing = function (editor) {
	      var selector = editor.getParam('object_resizing');
	      if (selector === false || Env.iOS) {
	        return false;
	      } else {
	        return isString$1(selector) ? selector : 'table,img,figure.image,div,video,iframe';
	      }
	    };
	    var getResizeImgProportional = function (editor) {
	      return editor.getParam('resize_img_proportional', true, 'boolean');
	    };
	    var getPlaceholder = function (editor) {
	      return editor.getParam('placeholder', DOM$9.getAttrib(editor.getElement(), 'placeholder'), 'string');
	    };
	    var getEventRoot = function (editor) {
	      return editor.getParam('event_root');
	    };
	    var getServiceMessage = function (editor) {
	      return editor.getParam('service_message');
	    };
	    var getTheme = function (editor) {
	      return editor.getParam('theme');
	    };
	    var shouldValidate = function (editor) {
	      return editor.getParam('validate');
	    };
	    var isInlineBoundariesEnabled = function (editor) {
	      return editor.getParam('inline_boundaries') !== false;
	    };
	    var getFormats = function (editor) {
	      return editor.getParam('formats');
	    };
	    var getPreviewStyles = function (editor) {
	      var style = editor.getParam('preview_styles', defaultPreviewStyles);
	      if (isString$1(style)) {
	        return style;
	      } else {
	        return '';
	      }
	    };
	    var canFormatEmptyLines = function (editor) {
	      return editor.getParam('format_empty_lines', false, 'boolean');
	    };
	    var getCustomUiSelector = function (editor) {
	      return editor.getParam('custom_ui_selector', '', 'string');
	    };
	    var getThemeUrl = function (editor) {
	      return editor.getParam('theme_url');
	    };
	    var isInline = function (editor) {
	      return editor.getParam('inline');
	    };
	    var hasHiddenInput = function (editor) {
	      return editor.getParam('hidden_input');
	    };
	    var shouldPatchSubmit = function (editor) {
	      return editor.getParam('submit_patch');
	    };
	    var isEncodingXml = function (editor) {
	      return editor.getParam('encoding') === 'xml';
	    };
	    var shouldAddFormSubmitTrigger = function (editor) {
	      return editor.getParam('add_form_submit_trigger');
	    };
	    var shouldAddUnloadTrigger = function (editor) {
	      return editor.getParam('add_unload_trigger');
	    };
	    var hasForcedRootBlock = function (editor) {
	      return getForcedRootBlock(editor) !== '';
	    };
	    var getCustomUndoRedoLevels = function (editor) {
	      return editor.getParam('custom_undo_redo_levels', 0, 'number');
	    };
	    var shouldDisableNodeChange = function (editor) {
	      return editor.getParam('disable_nodechange');
	    };
	    var isReadOnly$1 = function (editor) {
	      return editor.getParam('readonly');
	    };
	    var hasContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors');
	    };
	    var getPlugins = function (editor) {
	      return editor.getParam('plugins', '', 'string');
	    };
	    var getExternalPlugins$1 = function (editor) {
	      return editor.getParam('external_plugins');
	    };
	    var shouldBlockUnsupportedDrop = function (editor) {
	      return editor.getParam('block_unsupported_drop', true, 'boolean');
	    };
	    var isVisualAidsEnabled = function (editor) {
	      return editor.getParam('visual', true, 'boolean');
	    };
	    var getVisualAidsTableClass = function (editor) {
	      return editor.getParam('visual_table_class', 'mce-item-table', 'string');
	    };
	    var getVisualAidsAnchorClass = function (editor) {
	      return editor.getParam('visual_anchor_class', 'mce-item-anchor', 'string');
	    };
	    var getIframeAriaText = function (editor) {
	      return editor.getParam('iframe_aria_text', 'Rich Text Area. Press ALT-0 for help.', 'string');
	    };
	
	    var isElement$2 = isElement$5;
	    var isText$2 = isText$7;
	    var removeNode$1 = function (node) {
	      var parentNode = node.parentNode;
	      if (parentNode) {
	        parentNode.removeChild(node);
	      }
	    };
	    var trimCount = function (text) {
	      var trimmedText = trim$2(text);
	      return {
	        count: text.length - trimmedText.length,
	        text: trimmedText
	      };
	    };
	    var deleteZwspChars = function (caretContainer) {
	      var idx;
	      while ((idx = caretContainer.data.lastIndexOf(ZWSP$1)) !== -1) {
	        caretContainer.deleteData(idx, 1);
	      }
	    };
	    var removeUnchanged = function (caretContainer, pos) {
	      remove$2(caretContainer);
	      return pos;
	    };
	    var removeTextAndReposition = function (caretContainer, pos) {
	      var before = trimCount(caretContainer.data.substr(0, pos.offset()));
	      var after = trimCount(caretContainer.data.substr(pos.offset()));
	      var text = before.text + after.text;
	      if (text.length > 0) {
	        deleteZwspChars(caretContainer);
	        return CaretPosition(caretContainer, pos.offset() - before.count);
	      } else {
	        return pos;
	      }
	    };
	    var removeElementAndReposition = function (caretContainer, pos) {
	      var parentNode = pos.container();
	      var newPosition = indexOf$2(from(parentNode.childNodes), caretContainer).map(function (index) {
	        return index < pos.offset() ? CaretPosition(parentNode, pos.offset() - 1) : pos;
	      }).getOr(pos);
	      remove$2(caretContainer);
	      return newPosition;
	    };
	    var removeTextCaretContainer = function (caretContainer, pos) {
	      return isText$2(caretContainer) && pos.container() === caretContainer ? removeTextAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	    var removeElementCaretContainer = function (caretContainer, pos) {
	      return pos.container() === caretContainer.parentNode ? removeElementAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	    var removeAndReposition = function (container, pos) {
	      return CaretPosition.isTextPosition(pos) ? removeTextCaretContainer(container, pos) : removeElementCaretContainer(container, pos);
	    };
	    var remove$2 = function (caretContainerNode) {
	      if (isElement$2(caretContainerNode) && isCaretContainer$2(caretContainerNode)) {
	        if (hasContent(caretContainerNode)) {
	          caretContainerNode.removeAttribute('data-mce-caret');
	        } else {
	          removeNode$1(caretContainerNode);
	        }
	      }
	      if (isText$2(caretContainerNode)) {
	        deleteZwspChars(caretContainerNode);
	        if (caretContainerNode.data.length === 0) {
	          removeNode$1(caretContainerNode);
	        }
	      }
	    };
	
	    var browser$2 = detect().browser;
	    var isContentEditableFalse$8 = isContentEditableFalse$b;
	    var isMedia$1 = isMedia$2;
	    var isTableCell$3 = isTableCell$5;
	    var inlineFakeCaretSelector = '*[contentEditable=false],video,audio,embed,object';
	    var getAbsoluteClientRect = function (root, element, before) {
	      var clientRect = collapse(element.getBoundingClientRect(), before);
	      var scrollX;
	      var scrollY;
	      if (root.tagName === 'BODY') {
	        var docElm = root.ownerDocument.documentElement;
	        scrollX = root.scrollLeft || docElm.scrollLeft;
	        scrollY = root.scrollTop || docElm.scrollTop;
	      } else {
	        var rootRect = root.getBoundingClientRect();
	        scrollX = root.scrollLeft - rootRect.left;
	        scrollY = root.scrollTop - rootRect.top;
	      }
	      clientRect.left += scrollX;
	      clientRect.right += scrollX;
	      clientRect.top += scrollY;
	      clientRect.bottom += scrollY;
	      clientRect.width = 1;
	      var margin = element.offsetWidth - element.clientWidth;
	      if (margin > 0) {
	        if (before) {
	          margin *= -1;
	        }
	        clientRect.left += margin;
	        clientRect.right += margin;
	      }
	      return clientRect;
	    };
	    var trimInlineCaretContainers = function (root) {
	      var fakeCaretTargetNodes = descendants(SugarElement.fromDom(root), inlineFakeCaretSelector);
	      for (var i = 0; i < fakeCaretTargetNodes.length; i++) {
	        var node = fakeCaretTargetNodes[i].dom;
	        var sibling = node.previousSibling;
	        if (endsWithCaretContainer$1(sibling)) {
	          var data = sibling.data;
	          if (data.length === 1) {
	            sibling.parentNode.removeChild(sibling);
	          } else {
	            sibling.deleteData(data.length - 1, 1);
	          }
	        }
	        sibling = node.nextSibling;
	        if (startsWithCaretContainer$1(sibling)) {
	          var data = sibling.data;
	          if (data.length === 1) {
	            sibling.parentNode.removeChild(sibling);
	          } else {
	            sibling.deleteData(0, 1);
	          }
	        }
	      }
	    };
	    var FakeCaret = function (editor, root, isBlock, hasFocus) {
	      var lastVisualCaret = value();
	      var cursorInterval;
	      var caretContainerNode;
	      var rootBlock = getForcedRootBlock(editor);
	      var caretBlock = rootBlock.length > 0 ? rootBlock : 'p';
	      var show = function (before, element) {
	        var rng;
	        hide();
	        if (isTableCell$3(element)) {
	          return null;
	        }
	        if (isBlock(element)) {
	          caretContainerNode = insertBlock$1(caretBlock, element, before);
	          var clientRect = getAbsoluteClientRect(root, element, before);
	          DomQuery(caretContainerNode).css('top', clientRect.top);
	          var caret = DomQuery('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(__assign({}, clientRect)).appendTo(root)[0];
	          lastVisualCaret.set({
	            caret: caret,
	            element: element,
	            before: before
	          });
	          if (before) {
	            DomQuery(caret).addClass('mce-visual-caret-before');
	          }
	          startBlink();
	          rng = element.ownerDocument.createRange();
	          rng.setStart(caretContainerNode, 0);
	          rng.setEnd(caretContainerNode, 0);
	        } else {
	          caretContainerNode = insertInline$1(element, before);
	          rng = element.ownerDocument.createRange();
	          if (isInlineFakeCaretTarget(caretContainerNode.nextSibling)) {
	            rng.setStart(caretContainerNode, 0);
	            rng.setEnd(caretContainerNode, 0);
	          } else {
	            rng.setStart(caretContainerNode, 1);
	            rng.setEnd(caretContainerNode, 1);
	          }
	          return rng;
	        }
	        return rng;
	      };
	      var hide = function () {
	        trimInlineCaretContainers(root);
	        if (caretContainerNode) {
	          remove$2(caretContainerNode);
	          caretContainerNode = null;
	        }
	        lastVisualCaret.on(function (caretState) {
	          DomQuery(caretState.caret).remove();
	          lastVisualCaret.clear();
	        });
	        if (cursorInterval) {
	          Delay.clearInterval(cursorInterval);
	          cursorInterval = undefined;
	        }
	      };
	      var startBlink = function () {
	        cursorInterval = Delay.setInterval(function () {
	          if (hasFocus()) {
	            DomQuery('div.mce-visual-caret', root).toggleClass('mce-visual-caret-hidden');
	          } else {
	            DomQuery('div.mce-visual-caret', root).addClass('mce-visual-caret-hidden');
	          }
	        }, 500);
	      };
	      var reposition = function () {
	        lastVisualCaret.on(function (caretState) {
	          var clientRect = getAbsoluteClientRect(root, caretState.element, caretState.before);
	          DomQuery(caretState.caret).css(__assign({}, clientRect));
	        });
	      };
	      var destroy = function () {
	        return Delay.clearInterval(cursorInterval);
	      };
	      var getCss = function () {
	        return '.mce-visual-caret {' + 'position: absolute;' + 'background-color: black;' + 'background-color: currentcolor;' + '}' + '.mce-visual-caret-hidden {' + 'display: none;' + '}' + '*[data-mce-caret] {' + 'position: absolute;' + 'left: -1000px;' + 'right: auto;' + 'top: 0;' + 'margin: 0;' + 'padding: 0;' + '}';
	      };
	      return {
	        show: show,
	        hide: hide,
	        getCss: getCss,
	        reposition: reposition,
	        destroy: destroy
	      };
	    };
	    var isFakeCaretTableBrowser = function () {
	      return browser$2.isIE() || browser$2.isEdge() || browser$2.isFirefox();
	    };
	    var isInlineFakeCaretTarget = function (node) {
	      return isContentEditableFalse$8(node) || isMedia$1(node);
	    };
	    var isFakeCaretTarget = function (node) {
	      return isInlineFakeCaretTarget(node) || isTable$3(node) && isFakeCaretTableBrowser();
	    };
	
	    var isContentEditableFalse$7 = isContentEditableFalse$b;
	    var isMedia = isMedia$2;
	    var isBlockLike = matchStyleValues('display', 'block table table-cell table-caption list-item');
	    var isCaretContainer = isCaretContainer$2;
	    var isCaretContainerBlock = isCaretContainerBlock$1;
	    var isElement$1 = isElement$5;
	    var isCaretCandidate$1 = isCaretCandidate$3;
	    var isForwards = function (direction) {
	      return direction > 0;
	    };
	    var isBackwards = function (direction) {
	      return direction < 0;
	    };
	    var skipCaretContainers = function (walk, shallow) {
	      var node;
	      while (node = walk(shallow)) {
	        if (!isCaretContainerBlock(node)) {
	          return node;
	        }
	      }
	      return null;
	    };
	    var findNode$1 = function (node, direction, predicateFn, rootNode, shallow) {
	      var walker = new DomTreeWalker(node, rootNode);
	      var isCefOrCaretContainer = isContentEditableFalse$7(node) || isCaretContainerBlock(node);
	      if (isBackwards(direction)) {
	        if (isCefOrCaretContainer) {
	          node = skipCaretContainers(walker.prev.bind(walker), true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	        while (node = skipCaretContainers(walker.prev.bind(walker), shallow)) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	      if (isForwards(direction)) {
	        if (isCefOrCaretContainer) {
	          node = skipCaretContainers(walker.next.bind(walker), true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	        while (node = skipCaretContainers(walker.next.bind(walker), shallow)) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	      return null;
	    };
	    var getParentBlock$2 = function (node, rootNode) {
	      while (node && node !== rootNode) {
	        if (isBlockLike(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var isInSameBlock = function (caretPosition1, caretPosition2, rootNode) {
	      return getParentBlock$2(caretPosition1.container(), rootNode) === getParentBlock$2(caretPosition2.container(), rootNode);
	    };
	    var getChildNodeAtRelativeOffset = function (relativeOffset, caretPosition) {
	      if (!caretPosition) {
	        return null;
	      }
	      var container = caretPosition.container();
	      var offset = caretPosition.offset();
	      if (!isElement$1(container)) {
	        return null;
	      }
	      return container.childNodes[offset + relativeOffset];
	    };
	    var beforeAfter = function (before, node) {
	      var range = node.ownerDocument.createRange();
	      if (before) {
	        range.setStartBefore(node);
	        range.setEndBefore(node);
	      } else {
	        range.setStartAfter(node);
	        range.setEndAfter(node);
	      }
	      return range;
	    };
	    var isNodesInSameBlock = function (root, node1, node2) {
	      return getParentBlock$2(node1, root) === getParentBlock$2(node2, root);
	    };
	    var lean = function (left, root, node) {
	      var siblingName = left ? 'previousSibling' : 'nextSibling';
	      while (node && node !== root) {
	        var sibling = node[siblingName];
	        if (isCaretContainer(sibling)) {
	          sibling = sibling[siblingName];
	        }
	        if (isContentEditableFalse$7(sibling) || isMedia(sibling)) {
	          if (isNodesInSameBlock(root, sibling, node)) {
	            return sibling;
	          }
	          break;
	        }
	        if (isCaretCandidate$1(sibling)) {
	          break;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var before$2 = curry(beforeAfter, true);
	    var after$2 = curry(beforeAfter, false);
	    var normalizeRange = function (direction, root, range) {
	      var node;
	      var leanLeft = curry(lean, true, root);
	      var leanRight = curry(lean, false, root);
	      var container = range.startContainer;
	      var offset = range.startOffset;
	      if (isCaretContainerBlock$1(container)) {
	        if (!isElement$1(container)) {
	          container = container.parentNode;
	        }
	        var location_1 = container.getAttribute('data-mce-caret');
	        if (location_1 === 'before') {
	          node = container.nextSibling;
	          if (isFakeCaretTarget(node)) {
	            return before$2(node);
	          }
	        }
	        if (location_1 === 'after') {
	          node = container.previousSibling;
	          if (isFakeCaretTarget(node)) {
	            return after$2(node);
	          }
	        }
	      }
	      if (!range.collapsed) {
	        return range;
	      }
	      if (isText$7(container)) {
	        if (isCaretContainer(container)) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	            node = leanLeft(container);
	            if (node) {
	              return after$2(node);
	            }
	          }
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after$2(node);
	            }
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	          }
	          return range;
	        }
	        if (endsWithCaretContainer$1(container) && offset >= container.data.length - 1) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	          }
	          return range;
	        }
	        if (startsWithCaretContainer$1(container) && offset <= 1) {
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after$2(node);
	            }
	          }
	          return range;
	        }
	        if (offset === container.data.length) {
	          node = leanRight(container);
	          if (node) {
	            return before$2(node);
	          }
	          return range;
	        }
	        if (offset === 0) {
	          node = leanLeft(container);
	          if (node) {
	            return after$2(node);
	          }
	          return range;
	        }
	      }
	      return range;
	    };
	    var getRelativeCefElm = function (forward, caretPosition) {
	      return Optional.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, caretPosition)).filter(isContentEditableFalse$7);
	    };
	    var getNormalizedRangeEndPoint = function (direction, root, range) {
	      var normalizedRange = normalizeRange(direction, root, range);
	      if (direction === -1) {
	        return CaretPosition.fromRangeStart(normalizedRange);
	      }
	      return CaretPosition.fromRangeEnd(normalizedRange);
	    };
	    var getElementFromPosition = function (pos) {
	      return Optional.from(pos.getNode()).map(SugarElement.fromDom);
	    };
	    var getElementFromPrevPosition = function (pos) {
	      return Optional.from(pos.getNode(true)).map(SugarElement.fromDom);
	    };
	    var getVisualCaretPosition = function (walkFn, caretPosition) {
	      while (caretPosition = walkFn(caretPosition)) {
	        if (caretPosition.isVisible()) {
	          return caretPosition;
	        }
	      }
	      return caretPosition;
	    };
	    var isMoveInsideSameBlock = function (from, to) {
	      var inSameBlock = isInSameBlock(from, to);
	      if (!inSameBlock && isBr$5(from.getNode())) {
	        return true;
	      }
	      return inSameBlock;
	    };
	
	    var HDirection;
	    (function (HDirection) {
	      HDirection[HDirection['Backwards'] = -1] = 'Backwards';
	      HDirection[HDirection['Forwards'] = 1] = 'Forwards';
	    }(HDirection || (HDirection = {})));
	    var isContentEditableFalse$6 = isContentEditableFalse$b;
	    var isText$1 = isText$7;
	    var isElement = isElement$5;
	    var isBr$1 = isBr$5;
	    var isCaretCandidate = isCaretCandidate$3;
	    var isAtomic = isAtomic$1;
	    var isEditableCaretCandidate = isEditableCaretCandidate$1;
	    var getParents$3 = function (node, root) {
	      var parents = [];
	      while (node && node !== root) {
	        parents.push(node);
	        node = node.parentNode;
	      }
	      return parents;
	    };
	    var nodeAtIndex = function (container, offset) {
	      if (container.hasChildNodes() && offset < container.childNodes.length) {
	        return container.childNodes[offset];
	      }
	      return null;
	    };
	    var getCaretCandidatePosition = function (direction, node) {
	      if (isForwards(direction)) {
	        if (isCaretCandidate(node.previousSibling) && !isText$1(node.previousSibling)) {
	          return CaretPosition.before(node);
	        }
	        if (isText$1(node)) {
	          return CaretPosition(node, 0);
	        }
	      }
	      if (isBackwards(direction)) {
	        if (isCaretCandidate(node.nextSibling) && !isText$1(node.nextSibling)) {
	          return CaretPosition.after(node);
	        }
	        if (isText$1(node)) {
	          return CaretPosition(node, node.data.length);
	        }
	      }
	      if (isBackwards(direction)) {
	        if (isBr$1(node)) {
	          return CaretPosition.before(node);
	        }
	        return CaretPosition.after(node);
	      }
	      return CaretPosition.before(node);
	    };
	    var moveForwardFromBr = function (root, nextNode) {
	      var nextSibling = nextNode.nextSibling;
	      if (nextSibling && isCaretCandidate(nextSibling)) {
	        if (isText$1(nextSibling)) {
	          return CaretPosition(nextSibling, 0);
	        } else {
	          return CaretPosition.before(nextSibling);
	        }
	      } else {
	        return findCaretPosition$1(HDirection.Forwards, CaretPosition.after(nextNode), root);
	      }
	    };
	    var findCaretPosition$1 = function (direction, startPos, root) {
	      var node;
	      var nextNode;
	      var innerNode;
	      var caretPosition;
	      if (!isElement(root) || !startPos) {
	        return null;
	      }
	      if (startPos.isEqual(CaretPosition.after(root)) && root.lastChild) {
	        caretPosition = CaretPosition.after(root.lastChild);
	        if (isBackwards(direction) && isCaretCandidate(root.lastChild) && isElement(root.lastChild)) {
	          return isBr$1(root.lastChild) ? CaretPosition.before(root.lastChild) : caretPosition;
	        }
	      } else {
	        caretPosition = startPos;
	      }
	      var container = caretPosition.container();
	      var offset = caretPosition.offset();
	      if (isText$1(container)) {
	        if (isBackwards(direction) && offset > 0) {
	          return CaretPosition(container, --offset);
	        }
	        if (isForwards(direction) && offset < container.length) {
	          return CaretPosition(container, ++offset);
	        }
	        node = container;
	      } else {
	        if (isBackwards(direction) && offset > 0) {
	          nextNode = nodeAtIndex(container, offset - 1);
	          if (isCaretCandidate(nextNode)) {
	            if (!isAtomic(nextNode)) {
	              innerNode = findNode$1(nextNode, direction, isEditableCaretCandidate, nextNode);
	              if (innerNode) {
	                if (isText$1(innerNode)) {
	                  return CaretPosition(innerNode, innerNode.data.length);
	                }
	                return CaretPosition.after(innerNode);
	              }
	            }
	            if (isText$1(nextNode)) {
	              return CaretPosition(nextNode, nextNode.data.length);
	            }
	            return CaretPosition.before(nextNode);
	          }
	        }
	        if (isForwards(direction) && offset < container.childNodes.length) {
	          nextNode = nodeAtIndex(container, offset);
	          if (isCaretCandidate(nextNode)) {
	            if (isBr$1(nextNode)) {
	              return moveForwardFromBr(root, nextNode);
	            }
	            if (!isAtomic(nextNode)) {
	              innerNode = findNode$1(nextNode, direction, isEditableCaretCandidate, nextNode);
	              if (innerNode) {
	                if (isText$1(innerNode)) {
	                  return CaretPosition(innerNode, 0);
	                }
	                return CaretPosition.before(innerNode);
	              }
	            }
	            if (isText$1(nextNode)) {
	              return CaretPosition(nextNode, 0);
	            }
	            return CaretPosition.after(nextNode);
	          }
	        }
	        node = nextNode ? nextNode : caretPosition.getNode();
	      }
	      if (isForwards(direction) && caretPosition.isAtEnd() || isBackwards(direction) && caretPosition.isAtStart()) {
	        node = findNode$1(node, direction, always, root, true);
	        if (isEditableCaretCandidate(node, root)) {
	          return getCaretCandidatePosition(direction, node);
	        }
	      }
	      nextNode = findNode$1(node, direction, isEditableCaretCandidate, root);
	      var rootContentEditableFalseElm = last$1(filter$4(getParents$3(container, root), isContentEditableFalse$6));
	      if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
	        if (isForwards(direction)) {
	          caretPosition = CaretPosition.after(rootContentEditableFalseElm);
	        } else {
	          caretPosition = CaretPosition.before(rootContentEditableFalseElm);
	        }
	        return caretPosition;
	      }
	      if (nextNode) {
	        return getCaretCandidatePosition(direction, nextNode);
	      }
	      return null;
	    };
	    var CaretWalker = function (root) {
	      return {
	        next: function (caretPosition) {
	          return findCaretPosition$1(HDirection.Forwards, caretPosition, root);
	        },
	        prev: function (caretPosition) {
	          return findCaretPosition$1(HDirection.Backwards, caretPosition, root);
	        }
	      };
	    };
	
	    var walkToPositionIn = function (forward, root, start) {
	      var position = forward ? CaretPosition.before(start) : CaretPosition.after(start);
	      return fromPosition(forward, root, position);
	    };
	    var afterElement = function (node) {
	      return isBr$5(node) ? CaretPosition.before(node) : CaretPosition.after(node);
	    };
	    var isBeforeOrStart = function (position) {
	      if (CaretPosition.isTextPosition(position)) {
	        return position.offset() === 0;
	      } else {
	        return isCaretCandidate$3(position.getNode());
	      }
	    };
	    var isAfterOrEnd = function (position) {
	      if (CaretPosition.isTextPosition(position)) {
	        var container = position.container();
	        return position.offset() === container.data.length;
	      } else {
	        return isCaretCandidate$3(position.getNode(true));
	      }
	    };
	    var isBeforeAfterSameElement = function (from, to) {
	      return !CaretPosition.isTextPosition(from) && !CaretPosition.isTextPosition(to) && from.getNode() === to.getNode(true);
	    };
	    var isAtBr = function (position) {
	      return !CaretPosition.isTextPosition(position) && isBr$5(position.getNode());
	    };
	    var shouldSkipPosition = function (forward, from, to) {
	      if (forward) {
	        return !isBeforeAfterSameElement(from, to) && !isAtBr(from) && isAfterOrEnd(from) && isBeforeOrStart(to);
	      } else {
	        return !isBeforeAfterSameElement(to, from) && isBeforeOrStart(from) && isAfterOrEnd(to);
	      }
	    };
	    var fromPosition = function (forward, root, pos) {
	      var walker = CaretWalker(root);
	      return Optional.from(forward ? walker.next(pos) : walker.prev(pos));
	    };
	    var navigate = function (forward, root, from) {
	      return fromPosition(forward, root, from).bind(function (to) {
	        if (isInSameBlock(from, to, root) && shouldSkipPosition(forward, from, to)) {
	          return fromPosition(forward, root, to);
	        } else {
	          return Optional.some(to);
	        }
	      });
	    };
	    var navigateIgnore = function (forward, root, from, ignoreFilter) {
	      return navigate(forward, root, from).bind(function (pos) {
	        return ignoreFilter(pos) ? navigateIgnore(forward, root, pos, ignoreFilter) : Optional.some(pos);
	      });
	    };
	    var positionIn = function (forward, element) {
	      var startNode = forward ? element.firstChild : element.lastChild;
	      if (isText$7(startNode)) {
	        return Optional.some(CaretPosition(startNode, forward ? 0 : startNode.data.length));
	      } else if (startNode) {
	        if (isCaretCandidate$3(startNode)) {
	          return Optional.some(forward ? CaretPosition.before(startNode) : afterElement(startNode));
	        } else {
	          return walkToPositionIn(forward, element, startNode);
	        }
	      } else {
	        return Optional.none();
	      }
	    };
	    var nextPosition = curry(fromPosition, true);
	    var prevPosition = curry(fromPosition, false);
	    var firstPositionIn = curry(positionIn, true);
	    var lastPositionIn = curry(positionIn, false);
	
	    var CARET_ID$1 = '_mce_caret';
	    var isCaretNode = function (node) {
	      return isElement$5(node) && node.id === CARET_ID$1;
	    };
	    var getParentCaretContainer = function (body, node) {
	      while (node && node !== body) {
	        if (node.id === CARET_ID$1) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	
	    var isStringPathBookmark = function (bookmark) {
	      return isString$1(bookmark.start);
	    };
	    var isRangeBookmark = function (bookmark) {
	      return has$2(bookmark, 'rng');
	    };
	    var isIdBookmark = function (bookmark) {
	      return has$2(bookmark, 'id');
	    };
	    var isIndexBookmark = function (bookmark) {
	      return has$2(bookmark, 'name');
	    };
	    var isPathBookmark = function (bookmark) {
	      return Tools.isArray(bookmark.start);
	    };
	
	    var addBogus = function (dom, node) {
	      if (isElement$5(node) && dom.isBlock(node) && !node.innerHTML && !Env.ie) {
	        node.innerHTML = '<br data-mce-bogus="1" />';
	      }
	      return node;
	    };
	    var resolveCaretPositionBookmark = function (dom, bookmark) {
	      var pos;
	      var rng = dom.createRng();
	      pos = resolve$2(dom.getRoot(), bookmark.start);
	      rng.setStart(pos.container(), pos.offset());
	      pos = resolve$2(dom.getRoot(), bookmark.end);
	      rng.setEnd(pos.container(), pos.offset());
	      return rng;
	    };
	    var insertZwsp = function (node, rng) {
	      var textNode = node.ownerDocument.createTextNode(ZWSP$1);
	      node.appendChild(textNode);
	      rng.setStart(textNode, 0);
	      rng.setEnd(textNode, 0);
	    };
	    var isEmpty$1 = function (node) {
	      return node.hasChildNodes() === false;
	    };
	    var tryFindRangePosition = function (node, rng) {
	      return lastPositionIn(node).fold(never, function (pos) {
	        rng.setStart(pos.container(), pos.offset());
	        rng.setEnd(pos.container(), pos.offset());
	        return true;
	      });
	    };
	    var padEmptyCaretContainer = function (root, node, rng) {
	      if (isEmpty$1(node) && getParentCaretContainer(root, node)) {
	        insertZwsp(node, rng);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var setEndPoint = function (dom, start, bookmark, rng) {
	      var point = bookmark[start ? 'start' : 'end'];
	      var i, node, offset, children;
	      var root = dom.getRoot();
	      if (point) {
	        offset = point[0];
	        for (node = root, i = point.length - 1; i >= 1; i--) {
	          children = node.childNodes;
	          if (padEmptyCaretContainer(root, node, rng)) {
	            return true;
	          }
	          if (point[i] > children.length - 1) {
	            if (padEmptyCaretContainer(root, node, rng)) {
	              return true;
	            }
	            return tryFindRangePosition(node, rng);
	          }
	          node = children[point[i]];
	        }
	        if (node.nodeType === 3) {
	          offset = Math.min(point[0], node.nodeValue.length);
	        }
	        if (node.nodeType === 1) {
	          offset = Math.min(point[0], node.childNodes.length);
	        }
	        if (start) {
	          rng.setStart(node, offset);
	        } else {
	          rng.setEnd(node, offset);
	        }
	      }
	      return true;
	    };
	    var isValidTextNode = function (node) {
	      return isText$7(node) && node.data.length > 0;
	    };
	    var restoreEndPoint = function (dom, suffix, bookmark) {
	      var marker = dom.get(bookmark.id + '_' + suffix), node, idx, next, prev;
	      var keep = bookmark.keep;
	      var container, offset;
	      if (marker) {
	        node = marker.parentNode;
	        if (suffix === 'start') {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            if (marker.hasChildNodes()) {
	              node = marker.firstChild;
	              idx = 1;
	            } else if (isValidTextNode(marker.nextSibling)) {
	              node = marker.nextSibling;
	              idx = 0;
	            } else if (isValidTextNode(marker.previousSibling)) {
	              node = marker.previousSibling;
	              idx = marker.previousSibling.data.length;
	            } else {
	              node = marker.parentNode;
	              idx = dom.nodeIndex(marker) + 1;
	            }
	          }
	          container = node;
	          offset = idx;
	        } else {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            if (marker.hasChildNodes()) {
	              node = marker.firstChild;
	              idx = 1;
	            } else if (isValidTextNode(marker.previousSibling)) {
	              node = marker.previousSibling;
	              idx = marker.previousSibling.data.length;
	            } else {
	              node = marker.parentNode;
	              idx = dom.nodeIndex(marker);
	            }
	          }
	          container = node;
	          offset = idx;
	        }
	        if (!keep) {
	          prev = marker.previousSibling;
	          next = marker.nextSibling;
	          Tools.each(Tools.grep(marker.childNodes), function (node) {
	            if (isText$7(node)) {
	              node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
	            }
	          });
	          while (marker = dom.get(bookmark.id + '_' + suffix)) {
	            dom.remove(marker, true);
	          }
	          if (prev && next && prev.nodeType === next.nodeType && isText$7(prev) && !Env.opera) {
	            idx = prev.nodeValue.length;
	            prev.appendData(next.nodeValue);
	            dom.remove(next);
	            container = prev;
	            offset = idx;
	          }
	        }
	        return Optional.some(CaretPosition(container, offset));
	      } else {
	        return Optional.none();
	      }
	    };
	    var resolvePaths = function (dom, bookmark) {
	      var rng = dom.createRng();
	      if (setEndPoint(dom, true, bookmark, rng) && setEndPoint(dom, false, bookmark, rng)) {
	        return Optional.some(rng);
	      } else {
	        return Optional.none();
	      }
	    };
	    var resolveId = function (dom, bookmark) {
	      var startPos = restoreEndPoint(dom, 'start', bookmark);
	      var endPos = restoreEndPoint(dom, 'end', bookmark);
	      return lift2(startPos, endPos.or(startPos), function (spos, epos) {
	        var rng = dom.createRng();
	        rng.setStart(addBogus(dom, spos.container()), spos.offset());
	        rng.setEnd(addBogus(dom, epos.container()), epos.offset());
	        return rng;
	      });
	    };
	    var resolveIndex = function (dom, bookmark) {
	      return Optional.from(dom.select(bookmark.name)[bookmark.index]).map(function (elm) {
	        var rng = dom.createRng();
	        rng.selectNode(elm);
	        return rng;
	      });
	    };
	    var resolve$1 = function (selection, bookmark) {
	      var dom = selection.dom;
	      if (bookmark) {
	        if (isPathBookmark(bookmark)) {
	          return resolvePaths(dom, bookmark);
	        } else if (isStringPathBookmark(bookmark)) {
	          return Optional.some(resolveCaretPositionBookmark(dom, bookmark));
	        } else if (isIdBookmark(bookmark)) {
	          return resolveId(dom, bookmark);
	        } else if (isIndexBookmark(bookmark)) {
	          return resolveIndex(dom, bookmark);
	        } else if (isRangeBookmark(bookmark)) {
	          return Optional.some(bookmark.rng);
	        }
	      }
	      return Optional.none();
	    };
	
	    var getBookmark$1 = function (selection, type, normalized) {
	      return getBookmark$2(selection, type, normalized);
	    };
	    var moveToBookmark = function (selection, bookmark) {
	      resolve$1(selection, bookmark).each(function (rng) {
	        selection.setRng(rng);
	      });
	    };
	    var isBookmarkNode$1 = function (node) {
	      return isElement$5(node) && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	
	    var is = function (expected) {
	      return function (actual) {
	        return expected === actual;
	      };
	    };
	    var isNbsp = is(nbsp);
	    var isWhiteSpace = function (chr) {
	      return chr !== '' && ' \f\n\r\t\x0B'.indexOf(chr) !== -1;
	    };
	    var isContent = function (chr) {
	      return !isWhiteSpace(chr) && !isNbsp(chr);
	    };
	
	    var isNode = function (node) {
	      return !!node.nodeType;
	    };
	    var isInlineBlock = function (node) {
	      return node && /^(IMG)$/.test(node.nodeName);
	    };
	    var moveStart = function (dom, selection, rng) {
	      var offset = rng.startOffset;
	      var container = rng.startContainer;
	      if (container === rng.endContainer) {
	        if (isInlineBlock(container.childNodes[offset])) {
	          return;
	        }
	      }
	      if (isElement$5(container)) {
	        var nodes = container.childNodes;
	        var walker = void 0;
	        if (offset < nodes.length) {
	          container = nodes[offset];
	          walker = new DomTreeWalker(container, dom.getParent(container, dom.isBlock));
	        } else {
	          container = nodes[nodes.length - 1];
	          walker = new DomTreeWalker(container, dom.getParent(container, dom.isBlock));
	          walker.next(true);
	        }
	        for (var node = walker.current(); node; node = walker.next()) {
	          if (isText$7(node) && !isWhiteSpaceNode$1(node)) {
	            rng.setStart(node, 0);
	            selection.setRng(rng);
	            return;
	          }
	        }
	      }
	    };
	    var getNonWhiteSpaceSibling = function (node, next, inc) {
	      if (node) {
	        var nextName = next ? 'nextSibling' : 'previousSibling';
	        for (node = inc ? node : node[nextName]; node; node = node[nextName]) {
	          if (isElement$5(node) || !isWhiteSpaceNode$1(node)) {
	            return node;
	          }
	        }
	      }
	    };
	    var isTextBlock$1 = function (editor, name) {
	      if (isNode(name)) {
	        name = name.nodeName;
	      }
	      return !!editor.schema.getTextBlockElements()[name.toLowerCase()];
	    };
	    var isValid = function (ed, parent, child) {
	      return ed.schema.isValidChild(parent, child);
	    };
	    var isWhiteSpaceNode$1 = function (node, allowSpaces) {
	      if (allowSpaces === void 0) {
	        allowSpaces = false;
	      }
	      if (isNonNullable(node) && isText$7(node)) {
	        var data = allowSpaces ? node.data.replace(/ /g, '\xA0') : node.data;
	        return isWhitespaceText(data);
	      } else {
	        return false;
	      }
	    };
	    var isEmptyTextNode$1 = function (node) {
	      return isNonNullable(node) && isText$7(node) && node.length === 0;
	    };
	    var replaceVars = function (value, vars) {
	      if (isFunction(value)) {
	        value = value(vars);
	      } else if (isNonNullable(vars)) {
	        value = value.replace(/%(\w+)/g, function (str, name) {
	          return vars[name] || str;
	        });
	      }
	      return value;
	    };
	    var isEq$5 = function (str1, str2) {
	      str1 = str1 || '';
	      str2 = str2 || '';
	      str1 = '' + (str1.nodeName || str1);
	      str2 = '' + (str2.nodeName || str2);
	      return str1.toLowerCase() === str2.toLowerCase();
	    };
	    var normalizeStyleValue = function (dom, value, name) {
	      if (name === 'color' || name === 'backgroundColor') {
	        value = dom.toHex(value);
	      }
	      if (name === 'fontWeight' && value === 700) {
	        value = 'bold';
	      }
	      if (name === 'fontFamily') {
	        value = value.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
	      }
	      return '' + value;
	    };
	    var getStyle = function (dom, node, name) {
	      return normalizeStyleValue(dom, dom.getStyle(node, name), name);
	    };
	    var getTextDecoration = function (dom, node) {
	      var decoration;
	      dom.getParent(node, function (n) {
	        decoration = dom.getStyle(n, 'text-decoration');
	        return decoration && decoration !== 'none';
	      });
	      return decoration;
	    };
	    var getParents$2 = function (dom, node, selector) {
	      return dom.getParents(node, selector, dom.getRoot());
	    };
	    var isVariableFormatName = function (editor, formatName) {
	      var hasVariableValues = function (format) {
	        var isVariableValue = function (val) {
	          return val.length > 1 && val.charAt(0) === '%';
	        };
	        return exists([
	          'styles',
	          'attributes'
	        ], function (key) {
	          return get$9(format, key).exists(function (field) {
	            var fieldValues = isArray$1(field) ? field : values(field);
	            return exists(fieldValues, isVariableValue);
	          });
	        });
	      };
	      return exists(editor.formatter.get(formatName), hasVariableValues);
	    };
	    var areSimilarFormats = function (editor, formatName, otherFormatName) {
	      var validKeys = [
	        'inline',
	        'block',
	        'selector',
	        'attributes',
	        'styles',
	        'classes'
	      ];
	      var filterObj = function (format) {
	        return filter$3(format, function (_, key) {
	          return exists(validKeys, function (validKey) {
	            return validKey === key;
	          });
	        });
	      };
	      return exists(editor.formatter.get(formatName), function (fmt1) {
	        var filteredFmt1 = filterObj(fmt1);
	        return exists(editor.formatter.get(otherFormatName), function (fmt2) {
	          var filteredFmt2 = filterObj(fmt2);
	          return equal$1(filteredFmt1, filteredFmt2);
	        });
	      });
	    };
	    var isBlockFormat = function (format) {
	      return hasNonNullableKey(format, 'block');
	    };
	    var isSelectorFormat = function (format) {
	      return hasNonNullableKey(format, 'selector');
	    };
	    var isInlineFormat = function (format) {
	      return hasNonNullableKey(format, 'inline');
	    };
	    var isMixedFormat = function (format) {
	      return isSelectorFormat(format) && isInlineFormat(format) && is$1(get$9(format, 'mixed'), true);
	    };
	    var shouldExpandToSelector = function (format) {
	      return isSelectorFormat(format) && format.expand !== false && !isInlineFormat(format);
	    };
	
	    var isBookmarkNode = isBookmarkNode$1;
	    var getParents$1 = getParents$2;
	    var isWhiteSpaceNode = isWhiteSpaceNode$1;
	    var isTextBlock = isTextBlock$1;
	    var isBogusBr = function (node) {
	      return isBr$5(node) && node.getAttribute('data-mce-bogus') && !node.nextSibling;
	    };
	    var findParentContentEditable = function (dom, node) {
	      var parent = node;
	      while (parent) {
	        if (isElement$5(parent) && dom.getContentEditable(parent)) {
	          return dom.getContentEditable(parent) === 'false' ? parent : node;
	        }
	        parent = parent.parentNode;
	      }
	      return node;
	    };
	    var walkText = function (start, node, offset, predicate) {
	      var str = node.data;
	      for (var i = offset; start ? i >= 0 : i < str.length; start ? i-- : i++) {
	        if (predicate(str.charAt(i))) {
	          return start ? i + 1 : i;
	        }
	      }
	      return -1;
	    };
	    var findSpace = function (start, node, offset) {
	      return walkText(start, node, offset, function (c) {
	        return isNbsp(c) || isWhiteSpace(c);
	      });
	    };
	    var findContent = function (start, node, offset) {
	      return walkText(start, node, offset, isContent);
	    };
	    var findWordEndPoint = function (dom, body, container, offset, start, includeTrailingSpaces) {
	      var lastTextNode;
	      var rootNode = dom.getParent(container, dom.isBlock) || body;
	      var walk = function (container, offset, pred) {
	        var textSeeker = TextSeeker(dom);
	        var walker = start ? textSeeker.backwards : textSeeker.forwards;
	        return Optional.from(walker(container, offset, function (text, textOffset) {
	          if (isBookmarkNode(text.parentNode)) {
	            return -1;
	          } else {
	            lastTextNode = text;
	            return pred(start, text, textOffset);
	          }
	        }, rootNode));
	      };
	      var spaceResult = walk(container, offset, findSpace);
	      return spaceResult.bind(function (result) {
	        return includeTrailingSpaces ? walk(result.container, result.offset + (start ? -1 : 0), findContent) : Optional.some(result);
	      }).orThunk(function () {
	        return lastTextNode ? Optional.some({
	          container: lastTextNode,
	          offset: start ? 0 : lastTextNode.length
	        }) : Optional.none();
	      });
	    };
	    var findSelectorEndPoint = function (dom, formatList, rng, container, siblingName) {
	      if (isText$7(container) && isEmpty$3(container.data) && container[siblingName]) {
	        container = container[siblingName];
	      }
	      var parents = getParents$1(dom, container);
	      for (var i = 0; i < parents.length; i++) {
	        for (var y = 0; y < formatList.length; y++) {
	          var curFormat = formatList[y];
	          if (isNonNullable(curFormat.collapsed) && curFormat.collapsed !== rng.collapsed) {
	            continue;
	          }
	          if (isSelectorFormat(curFormat) && dom.is(parents[i], curFormat.selector)) {
	            return parents[i];
	          }
	        }
	      }
	      return container;
	    };
	    var findBlockEndPoint = function (editor, formatList, container, siblingName) {
	      var node = container;
	      var dom = editor.dom;
	      var root = dom.getRoot();
	      var format = formatList[0];
	      if (isBlockFormat(format)) {
	        node = format.wrapper ? null : dom.getParent(container, format.block, root);
	      }
	      if (!node) {
	        var scopeRoot = dom.getParent(container, 'LI,TD,TH');
	        node = dom.getParent(isText$7(container) ? container.parentNode : container, function (node) {
	          return node !== root && isTextBlock(editor, node);
	        }, scopeRoot);
	      }
	      if (node && isBlockFormat(format) && format.wrapper) {
	        node = getParents$1(dom, node, 'ul,ol').reverse()[0] || node;
	      }
	      if (!node) {
	        node = container;
	        while (node[siblingName] && !dom.isBlock(node[siblingName])) {
	          node = node[siblingName];
	          if (isEq$5(node, 'br')) {
	            break;
	          }
	        }
	      }
	      return node || container;
	    };
	    var isAtBlockBoundary$1 = function (dom, root, container, siblingName) {
	      var parent = container.parentNode;
	      if (isNonNullable(container[siblingName])) {
	        return false;
	      } else if (parent === root || isNullable(parent) || dom.isBlock(parent)) {
	        return true;
	      } else {
	        return isAtBlockBoundary$1(dom, root, parent, siblingName);
	      }
	    };
	    var findParentContainer = function (dom, formatList, container, offset, start) {
	      var parent = container;
	      var siblingName = start ? 'previousSibling' : 'nextSibling';
	      var root = dom.getRoot();
	      if (isText$7(container) && !isWhiteSpaceNode(container)) {
	        if (start ? offset > 0 : offset < container.data.length) {
	          return container;
	        }
	      }
	      while (true) {
	        if (!formatList[0].block_expand && dom.isBlock(parent)) {
	          return parent;
	        }
	        for (var sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
	          var allowSpaces = isText$7(sibling) && !isAtBlockBoundary$1(dom, root, sibling, siblingName);
	          if (!isBookmarkNode(sibling) && !isBogusBr(sibling) && !isWhiteSpaceNode(sibling, allowSpaces)) {
	            return parent;
	          }
	        }
	        if (parent === root || parent.parentNode === root) {
	          container = parent;
	          break;
	        }
	        parent = parent.parentNode;
	      }
	      return container;
	    };
	    var isSelfOrParentBookmark = function (container) {
	      return isBookmarkNode(container.parentNode) || isBookmarkNode(container);
	    };
	    var expandRng = function (editor, rng, formatList, includeTrailingSpace) {
	      if (includeTrailingSpace === void 0) {
	        includeTrailingSpace = false;
	      }
	      var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
	      var dom = editor.dom;
	      var format = formatList[0];
	      if (isElement$5(startContainer) && startContainer.hasChildNodes()) {
	        startContainer = getNode$1(startContainer, startOffset);
	        if (isText$7(startContainer)) {
	          startOffset = 0;
	        }
	      }
	      if (isElement$5(endContainer) && endContainer.hasChildNodes()) {
	        endContainer = getNode$1(endContainer, rng.collapsed ? endOffset : endOffset - 1);
	        if (isText$7(endContainer)) {
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	      startContainer = findParentContentEditable(dom, startContainer);
	      endContainer = findParentContentEditable(dom, endContainer);
	      if (isSelfOrParentBookmark(startContainer)) {
	        startContainer = isBookmarkNode(startContainer) ? startContainer : startContainer.parentNode;
	        if (rng.collapsed) {
	          startContainer = startContainer.previousSibling || startContainer;
	        } else {
	          startContainer = startContainer.nextSibling || startContainer;
	        }
	        if (isText$7(startContainer)) {
	          startOffset = rng.collapsed ? startContainer.length : 0;
	        }
	      }
	      if (isSelfOrParentBookmark(endContainer)) {
	        endContainer = isBookmarkNode(endContainer) ? endContainer : endContainer.parentNode;
	        if (rng.collapsed) {
	          endContainer = endContainer.nextSibling || endContainer;
	        } else {
	          endContainer = endContainer.previousSibling || endContainer;
	        }
	        if (isText$7(endContainer)) {
	          endOffset = rng.collapsed ? 0 : endContainer.length;
	        }
	      }
	      if (rng.collapsed) {
	        var startPoint = findWordEndPoint(dom, editor.getBody(), startContainer, startOffset, true, includeTrailingSpace);
	        startPoint.each(function (_a) {
	          var container = _a.container, offset = _a.offset;
	          startContainer = container;
	          startOffset = offset;
	        });
	        var endPoint = findWordEndPoint(dom, editor.getBody(), endContainer, endOffset, false, includeTrailingSpace);
	        endPoint.each(function (_a) {
	          var container = _a.container, offset = _a.offset;
	          endContainer = container;
	          endOffset = offset;
	        });
	      }
	      if (isInlineFormat(format) || format.block_expand) {
	        if (!isInlineFormat(format) || (!isText$7(startContainer) || startOffset === 0)) {
	          startContainer = findParentContainer(dom, formatList, startContainer, startOffset, true);
	        }
	        if (!isInlineFormat(format) || (!isText$7(endContainer) || endOffset === endContainer.nodeValue.length)) {
	          endContainer = findParentContainer(dom, formatList, endContainer, endOffset, false);
	        }
	      }
	      if (shouldExpandToSelector(format)) {
	        startContainer = findSelectorEndPoint(dom, formatList, rng, startContainer, 'previousSibling');
	        endContainer = findSelectorEndPoint(dom, formatList, rng, endContainer, 'nextSibling');
	      }
	      if (isBlockFormat(format) || isSelectorFormat(format)) {
	        startContainer = findBlockEndPoint(editor, formatList, startContainer, 'previousSibling');
	        endContainer = findBlockEndPoint(editor, formatList, endContainer, 'nextSibling');
	        if (isBlockFormat(format)) {
	          if (!dom.isBlock(startContainer)) {
	            startContainer = findParentContainer(dom, formatList, startContainer, startOffset, true);
	          }
	          if (!dom.isBlock(endContainer)) {
	            endContainer = findParentContainer(dom, formatList, endContainer, endOffset, false);
	          }
	        }
	      }
	      if (isElement$5(startContainer)) {
	        startOffset = dom.nodeIndex(startContainer);
	        startContainer = startContainer.parentNode;
	      }
	      if (isElement$5(endContainer)) {
	        endOffset = dom.nodeIndex(endContainer) + 1;
	        endContainer = endContainer.parentNode;
	      }
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	
	    var walk$2 = function (dom, rng, callback) {
	      var startOffset = rng.startOffset;
	      var startContainer = getNode$1(rng.startContainer, startOffset);
	      var endOffset = rng.endOffset;
	      var endContainer = getNode$1(rng.endContainer, endOffset - 1);
	      var exclude = function (nodes) {
	        var firstNode = nodes[0];
	        if (isText$7(firstNode) && firstNode === startContainer && startOffset >= firstNode.data.length) {
	          nodes.splice(0, 1);
	        }
	        var lastNode = nodes[nodes.length - 1];
	        if (endOffset === 0 && nodes.length > 0 && lastNode === endContainer && isText$7(lastNode)) {
	          nodes.splice(nodes.length - 1, 1);
	        }
	        return nodes;
	      };
	      var collectSiblings = function (node, name, endNode) {
	        var siblings = [];
	        for (; node && node !== endNode; node = node[name]) {
	          siblings.push(node);
	        }
	        return siblings;
	      };
	      var findEndPoint = function (node, root) {
	        return dom.getParent(node, function (node) {
	          return node.parentNode === root;
	        }, root);
	      };
	      var walkBoundary = function (startNode, endNode, next) {
	        var siblingName = next ? 'nextSibling' : 'previousSibling';
	        for (var node = startNode, parent_1 = node.parentNode; node && node !== endNode; node = parent_1) {
	          parent_1 = node.parentNode;
	          var siblings_1 = collectSiblings(node === startNode ? node : node[siblingName], siblingName);
	          if (siblings_1.length) {
	            if (!next) {
	              siblings_1.reverse();
	            }
	            callback(exclude(siblings_1));
	          }
	        }
	      };
	      if (startContainer === endContainer) {
	        return callback(exclude([startContainer]));
	      }
	      var ancestor = dom.findCommonAncestor(startContainer, endContainer);
	      if (dom.isChildOf(startContainer, endContainer)) {
	        return walkBoundary(startContainer, ancestor, true);
	      }
	      if (dom.isChildOf(endContainer, startContainer)) {
	        return walkBoundary(endContainer, ancestor);
	      }
	      var startPoint = findEndPoint(startContainer, ancestor) || startContainer;
	      var endPoint = findEndPoint(endContainer, ancestor) || endContainer;
	      walkBoundary(startContainer, startPoint, true);
	      var siblings = collectSiblings(startPoint === startContainer ? startPoint : startPoint.nextSibling, 'nextSibling', endPoint === endContainer ? endPoint.nextSibling : endPoint);
	      if (siblings.length) {
	        callback(exclude(siblings));
	      }
	      walkBoundary(endContainer, endPoint);
	    };
	
	    var getRanges = function (selection) {
	      var ranges = [];
	      if (selection) {
	        for (var i = 0; i < selection.rangeCount; i++) {
	          ranges.push(selection.getRangeAt(i));
	        }
	      }
	      return ranges;
	    };
	    var getSelectedNodes = function (ranges) {
	      return bind(ranges, function (range) {
	        var node = getSelectedNode(range);
	        return node ? [SugarElement.fromDom(node)] : [];
	      });
	    };
	    var hasMultipleRanges = function (selection) {
	      return getRanges(selection).length > 1;
	    };
	
	    var getCellsFromRanges = function (ranges) {
	      return filter$4(getSelectedNodes(ranges), isTableCell$4);
	    };
	    var getCellsFromElement = function (elm) {
	      return descendants(elm, 'td[data-mce-selected],th[data-mce-selected]');
	    };
	    var getCellsFromElementOrRanges = function (ranges, element) {
	      var selectedCells = getCellsFromElement(element);
	      return selectedCells.length > 0 ? selectedCells : getCellsFromRanges(ranges);
	    };
	    var getCellsFromEditor = function (editor) {
	      return getCellsFromElementOrRanges(getRanges(editor.selection.getSel()), SugarElement.fromDom(editor.getBody()));
	    };
	    var getClosestTable = function (cell, isRoot) {
	      return ancestor$2(cell, 'table', isRoot);
	    };
	
	    var getStartNode = function (rng) {
	      var sc = rng.startContainer, so = rng.startOffset;
	      if (isText$7(sc)) {
	        return so === 0 ? Optional.some(SugarElement.fromDom(sc)) : Optional.none();
	      } else {
	        return Optional.from(sc.childNodes[so]).map(SugarElement.fromDom);
	      }
	    };
	    var getEndNode = function (rng) {
	      var ec = rng.endContainer, eo = rng.endOffset;
	      if (isText$7(ec)) {
	        return eo === ec.data.length ? Optional.some(SugarElement.fromDom(ec)) : Optional.none();
	      } else {
	        return Optional.from(ec.childNodes[eo - 1]).map(SugarElement.fromDom);
	      }
	    };
	    var getFirstChildren = function (node) {
	      return firstChild(node).fold(constant([node]), function (child) {
	        return [node].concat(getFirstChildren(child));
	      });
	    };
	    var getLastChildren$1 = function (node) {
	      return lastChild(node).fold(constant([node]), function (child) {
	        if (name(child) === 'br') {
	          return prevSibling(child).map(function (sibling) {
	            return [node].concat(getLastChildren$1(sibling));
	          }).getOr([]);
	        } else {
	          return [node].concat(getLastChildren$1(child));
	        }
	      });
	    };
	    var hasAllContentsSelected = function (elm, rng) {
	      return lift2(getStartNode(rng), getEndNode(rng), function (startNode, endNode) {
	        var start = find$3(getFirstChildren(elm), curry(eq, startNode));
	        var end = find$3(getLastChildren$1(elm), curry(eq, endNode));
	        return start.isSome() && end.isSome();
	      }).getOr(false);
	    };
	    var moveEndPoint = function (dom, rng, node, start) {
	      var root = node, walker = new DomTreeWalker(node, root);
	      var moveCaretBeforeOnEnterElementsMap = filter$3(dom.schema.getMoveCaretBeforeOnEnterElements(), function (_, name) {
	        return !contains$3([
	          'td',
	          'th',
	          'table'
	        ], name.toLowerCase());
	      });
	      do {
	        if (isText$7(node) && Tools.trim(node.nodeValue).length !== 0) {
	          if (start) {
	            rng.setStart(node, 0);
	          } else {
	            rng.setEnd(node, node.nodeValue.length);
	          }
	          return;
	        }
	        if (moveCaretBeforeOnEnterElementsMap[node.nodeName]) {
	          if (start) {
	            rng.setStartBefore(node);
	          } else {
	            if (node.nodeName === 'BR') {
	              rng.setEndBefore(node);
	            } else {
	              rng.setEndAfter(node);
	            }
	          }
	          return;
	        }
	      } while (node = start ? walker.next() : walker.prev());
	      if (root.nodeName === 'BODY') {
	        if (start) {
	          rng.setStart(root, 0);
	        } else {
	          rng.setEnd(root, root.childNodes.length);
	        }
	      }
	    };
	    var hasAnyRanges = function (editor) {
	      var sel = editor.selection.getSel();
	      return sel && sel.rangeCount > 0;
	    };
	    var runOnRanges = function (editor, executor) {
	      var fakeSelectionNodes = getCellsFromEditor(editor);
	      if (fakeSelectionNodes.length > 0) {
	        each$k(fakeSelectionNodes, function (elem) {
	          var node = elem.dom;
	          var fakeNodeRng = editor.dom.createRng();
	          fakeNodeRng.setStartBefore(node);
	          fakeNodeRng.setEndAfter(node);
	          executor(fakeNodeRng, true);
	        });
	      } else {
	        executor(editor.selection.getRng(), false);
	      }
	    };
	    var preserve = function (selection, fillBookmark, executor) {
	      var bookmark = getPersistentBookmark(selection, fillBookmark);
	      executor(bookmark);
	      selection.moveToBookmark(bookmark);
	    };
	
	    var NodeValue = function (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom.nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	
	    var api$1 = NodeValue(isText$8, 'text');
	    var get$2 = function (element) {
	      return api$1.get(element);
	    };
	
	    var isZeroWidth = function (elem) {
	      return isText$8(elem) && get$2(elem) === ZWSP$1;
	    };
	    var context = function (editor, elem, wrapName, nodeName) {
	      return parent(elem).fold(function () {
	        return 'skipping';
	      }, function (parent) {
	        if (nodeName === 'br' || isZeroWidth(elem)) {
	          return 'valid';
	        } else if (isAnnotation(elem)) {
	          return 'existing';
	        } else if (isCaretNode(elem.dom)) {
	          return 'caret';
	        } else if (!isValid(editor, wrapName, nodeName) || !isValid(editor, name(parent), wrapName)) {
	          return 'invalid-child';
	        } else {
	          return 'valid';
	        }
	      });
	    };
	
	    var applyWordGrab = function (editor, rng) {
	      var r = expandRng(editor, rng, [{ inline: 'span' }]);
	      rng.setStart(r.startContainer, r.startOffset);
	      rng.setEnd(r.endContainer, r.endOffset);
	      editor.selection.setRng(rng);
	    };
	    var makeAnnotation = function (eDoc, _a, annotationName, decorate) {
	      var _b = _a.uid, uid = _b === void 0 ? generate('mce-annotation') : _b, data = __rest(_a, ['uid']);
	      var master = SugarElement.fromTag('span', eDoc);
	      add$1(master, annotation());
	      set$1(master, '' + dataAnnotationId(), uid);
	      set$1(master, '' + dataAnnotation(), annotationName);
	      var _c = decorate(uid, data), _d = _c.attributes, attributes = _d === void 0 ? {} : _d, _e = _c.classes, classes = _e === void 0 ? [] : _e;
	      setAll$1(master, attributes);
	      add(master, classes);
	      return master;
	    };
	    var annotate = function (editor, rng, annotationName, decorate, data) {
	      var newWrappers = [];
	      var master = makeAnnotation(editor.getDoc(), data, annotationName, decorate);
	      var wrapper = value();
	      var finishWrapper = function () {
	        wrapper.clear();
	      };
	      var getOrOpenWrapper = function () {
	        return wrapper.get().getOrThunk(function () {
	          var nu = shallow(master);
	          newWrappers.push(nu);
	          wrapper.set(nu);
	          return nu;
	        });
	      };
	      var processElements = function (elems) {
	        each$k(elems, processElement);
	      };
	      var processElement = function (elem) {
	        var ctx = context(editor, elem, 'span', name(elem));
	        switch (ctx) {
	        case 'invalid-child': {
	            finishWrapper();
	            var children$1 = children(elem);
	            processElements(children$1);
	            finishWrapper();
	            break;
	          }
	        case 'valid': {
	            var w = getOrOpenWrapper();
	            wrap$3(elem, w);
	            break;
	          }
	        }
	      };
	      var processNodes = function (nodes) {
	        var elems = map$3(nodes, SugarElement.fromDom);
	        processElements(elems);
	      };
	      walk$2(editor.dom, rng, function (nodes) {
	        finishWrapper();
	        processNodes(nodes);
	      });
	      return newWrappers;
	    };
	    var annotateWithBookmark = function (editor, name, settings, data) {
	      editor.undoManager.transact(function () {
	        var selection = editor.selection;
	        var initialRng = selection.getRng();
	        var hasFakeSelection = getCellsFromEditor(editor).length > 0;
	        if (initialRng.collapsed && !hasFakeSelection) {
	          applyWordGrab(editor, initialRng);
	        }
	        if (selection.getRng().collapsed && !hasFakeSelection) {
	          var wrapper = makeAnnotation(editor.getDoc(), data, name, settings.decorate);
	          set(wrapper, nbsp);
	          selection.getRng().insertNode(wrapper.dom);
	          selection.select(wrapper.dom);
	        } else {
	          preserve(selection, false, function () {
	            runOnRanges(editor, function (selectionRng) {
	              annotate(editor, selectionRng, name, settings.decorate, data);
	            });
	          });
	        }
	      });
	    };
	
	    var Annotator = function (editor) {
	      var registry = create$7();
	      setup$m(editor, registry);
	      var changes = setup$n(editor);
	      return {
	        register: function (name, settings) {
	          registry.register(name, settings);
	        },
	        annotate: function (name, data) {
	          registry.lookup(name).each(function (settings) {
	            annotateWithBookmark(editor, name, settings, data);
	          });
	        },
	        annotationChanged: function (name, callback) {
	          changes.addListener(name, callback);
	        },
	        remove: function (name) {
	          identify(editor, Optional.some(name)).each(function (_a) {
	            var elements = _a.elements;
	            each$k(elements, unwrap);
	          });
	        },
	        getAll: function (name) {
	          var directory = findAll(editor, name);
	          return map$2(directory, function (elems) {
	            return map$3(elems, function (elem) {
	              return elem.dom;
	            });
	          });
	        }
	      };
	    };
	
	    var BookmarkManager = function (selection) {
	      return {
	        getBookmark: curry(getBookmark$1, selection),
	        moveToBookmark: curry(moveToBookmark, selection)
	      };
	    };
	    BookmarkManager.isBookmarkNode = isBookmarkNode$1;
	
	    var getContentEditableRoot$1 = function (root, node) {
	      while (node && node !== root) {
	        if (isContentEditableTrue$4(node) || isContentEditableFalse$b(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	
	    var isXYWithinRange = function (clientX, clientY, range) {
	      if (range.collapsed) {
	        return false;
	      }
	      if (Env.browser.isIE() && range.startOffset === range.endOffset - 1 && range.startContainer === range.endContainer) {
	        var elm = range.startContainer.childNodes[range.startOffset];
	        if (isElement$5(elm)) {
	          return exists(elm.getClientRects(), function (rect) {
	            return containsXY(rect, clientX, clientY);
	          });
	        }
	      }
	      return exists(range.getClientRects(), function (rect) {
	        return containsXY(rect, clientX, clientY);
	      });
	    };
	
	    var firePreProcess = function (editor, args) {
	      return editor.fire('PreProcess', args);
	    };
	    var firePostProcess = function (editor, args) {
	      return editor.fire('PostProcess', args);
	    };
	    var fireRemove = function (editor) {
	      return editor.fire('remove');
	    };
	    var fireDetach = function (editor) {
	      return editor.fire('detach');
	    };
	    var fireSwitchMode = function (editor, mode) {
	      return editor.fire('SwitchMode', { mode: mode });
	    };
	    var fireObjectResizeStart = function (editor, target, width, height, origin) {
	      editor.fire('ObjectResizeStart', {
	        target: target,
	        width: width,
	        height: height,
	        origin: origin
	      });
	    };
	    var fireObjectResized = function (editor, target, width, height, origin) {
	      editor.fire('ObjectResized', {
	        target: target,
	        width: width,
	        height: height,
	        origin: origin
	      });
	    };
	    var firePreInit = function (editor) {
	      return editor.fire('PreInit');
	    };
	    var firePostRender = function (editor) {
	      return editor.fire('PostRender');
	    };
	    var fireInit = function (editor) {
	      return editor.fire('Init');
	    };
	    var firePlaceholderToggle = function (editor, state) {
	      return editor.fire('PlaceholderToggle', { state: state });
	    };
	    var fireError = function (editor, errorType, error) {
	      return editor.fire(errorType, error);
	    };
	    var fireFormatApply = function (editor, format, node, vars) {
	      return editor.fire('FormatApply', {
	        format: format,
	        node: node,
	        vars: vars
	      });
	    };
	    var fireFormatRemove = function (editor, format, node, vars) {
	      return editor.fire('FormatRemove', {
	        format: format,
	        node: node,
	        vars: vars
	      });
	    };
	
	    var VK = {
	      BACKSPACE: 8,
	      DELETE: 46,
	      DOWN: 40,
	      ENTER: 13,
	      ESC: 27,
	      LEFT: 37,
	      RIGHT: 39,
	      SPACEBAR: 32,
	      TAB: 9,
	      UP: 38,
	      PAGE_UP: 33,
	      PAGE_DOWN: 34,
	      END: 35,
	      HOME: 36,
	      modifierPressed: function (e) {
	        return e.shiftKey || e.ctrlKey || e.altKey || VK.metaKeyPressed(e);
	      },
	      metaKeyPressed: function (e) {
	        return Env.mac ? e.metaKey : e.ctrlKey && !e.altKey;
	      }
	    };
	
	    var isContentEditableFalse$5 = isContentEditableFalse$b;
	    var ControlSelection = function (selection, editor) {
	      var elementSelectionAttr = 'data-mce-selected';
	      var dom = editor.dom, each = Tools.each;
	      var selectedElm, selectedElmGhost, resizeHelper, selectedHandle, resizeBackdrop;
	      var startX, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
	      var width, height;
	      var editableDoc = editor.getDoc(), rootDocument = document;
	      var abs = Math.abs, round = Math.round, rootElement = editor.getBody();
	      var startScrollWidth, startScrollHeight;
	      var resizeHandles = {
	        nw: [
	          0,
	          0,
	          -1,
	          -1
	        ],
	        ne: [
	          1,
	          0,
	          1,
	          -1
	        ],
	        se: [
	          1,
	          1,
	          1,
	          1
	        ],
	        sw: [
	          0,
	          1,
	          -1,
	          1
	        ]
	      };
	      var isImage = function (elm) {
	        return elm && (elm.nodeName === 'IMG' || editor.dom.is(elm, 'figure.image'));
	      };
	      var isMedia = function (elm) {
	        return isMedia$2(elm) || dom.hasClass(elm, 'mce-preview-object');
	      };
	      var isEventOnImageOutsideRange = function (evt, range) {
	        if (evt.type === 'longpress' || evt.type.indexOf('touch') === 0) {
	          var touch = evt.touches[0];
	          return isImage(evt.target) && !isXYWithinRange(touch.clientX, touch.clientY, range);
	        } else {
	          return isImage(evt.target) && !isXYWithinRange(evt.clientX, evt.clientY, range);
	        }
	      };
	      var contextMenuSelectImage = function (evt) {
	        var target = evt.target;
	        if (isEventOnImageOutsideRange(evt, editor.selection.getRng()) && !evt.isDefaultPrevented()) {
	          editor.selection.select(target);
	        }
	      };
	      var getResizeTargets = function (elm) {
	        if (dom.is(elm, 'figure.image')) {
	          return [elm.querySelector('img')];
	        } else if (dom.hasClass(elm, 'mce-preview-object') && isNonNullable(elm.firstElementChild)) {
	          return [
	            elm,
	            elm.firstElementChild
	          ];
	        } else {
	          return [elm];
	        }
	      };
	      var isResizable = function (elm) {
	        var selector = getObjectResizing(editor);
	        if (!selector) {
	          return false;
	        }
	        if (elm.getAttribute('data-mce-resize') === 'false') {
	          return false;
	        }
	        if (elm === editor.getBody()) {
	          return false;
	        }
	        if (dom.hasClass(elm, 'mce-preview-object')) {
	          return is$2(SugarElement.fromDom(elm.firstElementChild), selector);
	        } else {
	          return is$2(SugarElement.fromDom(elm), selector);
	        }
	      };
	      var createGhostElement = function (elm) {
	        if (isMedia(elm)) {
	          return dom.create('img', { src: Env.transparentSrc });
	        } else {
	          return elm.cloneNode(true);
	        }
	      };
	      var setSizeProp = function (element, name, value) {
	        if (isNonNullable(value)) {
	          var targets = getResizeTargets(element);
	          each$k(targets, function (target) {
	            if (target.style[name] || !editor.schema.isValid(target.nodeName.toLowerCase(), name)) {
	              dom.setStyle(target, name, value);
	            } else {
	              dom.setAttrib(target, name, '' + value);
	            }
	          });
	        }
	      };
	      var setGhostElmSize = function (ghostElm, width, height) {
	        setSizeProp(ghostElm, 'width', width);
	        setSizeProp(ghostElm, 'height', height);
	      };
	      var resizeGhostElement = function (e) {
	        var deltaX, deltaY, proportional;
	        var resizeHelperX, resizeHelperY;
	        deltaX = e.screenX - startX;
	        deltaY = e.screenY - startY;
	        width = deltaX * selectedHandle[2] + startW;
	        height = deltaY * selectedHandle[3] + startH;
	        width = width < 5 ? 5 : width;
	        height = height < 5 ? 5 : height;
	        if ((isImage(selectedElm) || isMedia(selectedElm)) && getResizeImgProportional(editor) !== false) {
	          proportional = !VK.modifierPressed(e);
	        } else {
	          proportional = VK.modifierPressed(e);
	        }
	        if (proportional) {
	          if (abs(deltaX) > abs(deltaY)) {
	            height = round(width * ratio);
	            width = round(height / ratio);
	          } else {
	            width = round(height / ratio);
	            height = round(width * ratio);
	          }
	        }
	        setGhostElmSize(selectedElmGhost, width, height);
	        resizeHelperX = selectedHandle.startPos.x + deltaX;
	        resizeHelperY = selectedHandle.startPos.y + deltaY;
	        resizeHelperX = resizeHelperX > 0 ? resizeHelperX : 0;
	        resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
	        dom.setStyles(resizeHelper, {
	          left: resizeHelperX,
	          top: resizeHelperY,
	          display: 'block'
	        });
	        resizeHelper.innerHTML = width + ' &times; ' + height;
	        if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= width) {
	          dom.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - width));
	        }
	        if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
	          dom.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height));
	        }
	        deltaX = rootElement.scrollWidth - startScrollWidth;
	        deltaY = rootElement.scrollHeight - startScrollHeight;
	        if (deltaX + deltaY !== 0) {
	          dom.setStyles(resizeHelper, {
	            left: resizeHelperX - deltaX,
	            top: resizeHelperY - deltaY
	          });
	        }
	        if (!resizeStarted) {
	          fireObjectResizeStart(editor, selectedElm, startW, startH, 'corner-' + selectedHandle.name);
	          resizeStarted = true;
	        }
	      };
	      var endGhostResize = function () {
	        var wasResizeStarted = resizeStarted;
	        resizeStarted = false;
	        if (wasResizeStarted) {
	          setSizeProp(selectedElm, 'width', width);
	          setSizeProp(selectedElm, 'height', height);
	        }
	        dom.unbind(editableDoc, 'mousemove', resizeGhostElement);
	        dom.unbind(editableDoc, 'mouseup', endGhostResize);
	        if (rootDocument !== editableDoc) {
	          dom.unbind(rootDocument, 'mousemove', resizeGhostElement);
	          dom.unbind(rootDocument, 'mouseup', endGhostResize);
	        }
	        dom.remove(selectedElmGhost);
	        dom.remove(resizeHelper);
	        dom.remove(resizeBackdrop);
	        showResizeRect(selectedElm);
	        if (wasResizeStarted) {
	          fireObjectResized(editor, selectedElm, width, height, 'corner-' + selectedHandle.name);
	          dom.setAttrib(selectedElm, 'style', dom.getAttrib(selectedElm, 'style'));
	        }
	        editor.nodeChanged();
	      };
	      var showResizeRect = function (targetElm) {
	        unbindResizeHandleEvents();
	        var position = dom.getPos(targetElm, rootElement);
	        var selectedElmX = position.x;
	        var selectedElmY = position.y;
	        var rect = targetElm.getBoundingClientRect();
	        var targetWidth = rect.width || rect.right - rect.left;
	        var targetHeight = rect.height || rect.bottom - rect.top;
	        if (selectedElm !== targetElm) {
	          hideResizeRect();
	          selectedElm = targetElm;
	          width = height = 0;
	        }
	        var e = editor.fire('ObjectSelected', { target: targetElm });
	        var selectedValue = dom.getAttrib(selectedElm, elementSelectionAttr, '1');
	        if (isResizable(targetElm) && !e.isDefaultPrevented()) {
	          each(resizeHandles, function (handle, name) {
	            var handleElm;
	            var startDrag = function (e) {
	              var target = getResizeTargets(selectedElm)[0];
	              startX = e.screenX;
	              startY = e.screenY;
	              startW = target.clientWidth;
	              startH = target.clientHeight;
	              ratio = startH / startW;
	              selectedHandle = handle;
	              selectedHandle.name = name;
	              selectedHandle.startPos = {
	                x: targetWidth * handle[0] + selectedElmX,
	                y: targetHeight * handle[1] + selectedElmY
	              };
	              startScrollWidth = rootElement.scrollWidth;
	              startScrollHeight = rootElement.scrollHeight;
	              resizeBackdrop = dom.add(rootElement, 'div', {
	                'class': 'mce-resize-backdrop',
	                'data-mce-bogus': 'all'
	              });
	              dom.setStyles(resizeBackdrop, {
	                position: 'fixed',
	                left: '0',
	                top: '0',
	                width: '100%',
	                height: '100%'
	              });
	              selectedElmGhost = createGhostElement(selectedElm);
	              dom.addClass(selectedElmGhost, 'mce-clonedresizable');
	              dom.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
	              selectedElmGhost.contentEditable = 'false';
	              dom.setStyles(selectedElmGhost, {
	                left: selectedElmX,
	                top: selectedElmY,
	                margin: 0
	              });
	              setGhostElmSize(selectedElmGhost, targetWidth, targetHeight);
	              selectedElmGhost.removeAttribute(elementSelectionAttr);
	              rootElement.appendChild(selectedElmGhost);
	              dom.bind(editableDoc, 'mousemove', resizeGhostElement);
	              dom.bind(editableDoc, 'mouseup', endGhostResize);
	              if (rootDocument !== editableDoc) {
	                dom.bind(rootDocument, 'mousemove', resizeGhostElement);
	                dom.bind(rootDocument, 'mouseup', endGhostResize);
	              }
	              resizeHelper = dom.add(rootElement, 'div', {
	                'class': 'mce-resize-helper',
	                'data-mce-bogus': 'all'
	              }, startW + ' &times; ' + startH);
	            };
	            handleElm = dom.get('mceResizeHandle' + name);
	            if (handleElm) {
	              dom.remove(handleElm);
	            }
	            handleElm = dom.add(rootElement, 'div', {
	              'id': 'mceResizeHandle' + name,
	              'data-mce-bogus': 'all',
	              'class': 'mce-resizehandle',
	              'unselectable': true,
	              'style': 'cursor:' + name + '-resize; margin:0; padding:0'
	            });
	            if (Env.ie === 11) {
	              handleElm.contentEditable = false;
	            }
	            dom.bind(handleElm, 'mousedown', function (e) {
	              e.stopImmediatePropagation();
	              e.preventDefault();
	              startDrag(e);
	            });
	            handle.elm = handleElm;
	            dom.setStyles(handleElm, {
	              left: targetWidth * handle[0] + selectedElmX - handleElm.offsetWidth / 2,
	              top: targetHeight * handle[1] + selectedElmY - handleElm.offsetHeight / 2
	            });
	          });
	        } else {
	          hideResizeRect();
	        }
	        if (!dom.getAttrib(selectedElm, elementSelectionAttr)) {
	          selectedElm.setAttribute(elementSelectionAttr, selectedValue);
	        }
	      };
	      var hideResizeRect = function () {
	        unbindResizeHandleEvents();
	        if (selectedElm) {
	          selectedElm.removeAttribute(elementSelectionAttr);
	        }
	        each$j(resizeHandles, function (value, name) {
	          var handleElm = dom.get('mceResizeHandle' + name);
	          if (handleElm) {
	            dom.unbind(handleElm);
	            dom.remove(handleElm);
	          }
	        });
	      };
	      var updateResizeRect = function (e) {
	        var startElm, controlElm;
	        var isChildOrEqual = function (node, parent) {
	          if (node) {
	            do {
	              if (node === parent) {
	                return true;
	              }
	            } while (node = node.parentNode);
	          }
	        };
	        if (resizeStarted || editor.removed) {
	          return;
	        }
	        each(dom.select('img[data-mce-selected],hr[data-mce-selected]'), function (img) {
	          img.removeAttribute(elementSelectionAttr);
	        });
	        controlElm = e.type === 'mousedown' ? e.target : selection.getNode();
	        controlElm = dom.$(controlElm).closest('table,img,figure.image,hr,video,span.mce-preview-object')[0];
	        if (isChildOrEqual(controlElm, rootElement)) {
	          disableGeckoResize();
	          startElm = selection.getStart(true);
	          if (isChildOrEqual(startElm, controlElm) && isChildOrEqual(selection.getEnd(true), controlElm)) {
	            showResizeRect(controlElm);
	            return;
	          }
	        }
	        hideResizeRect();
	      };
	      var isWithinContentEditableFalse = function (elm) {
	        return isContentEditableFalse$5(getContentEditableRoot$1(editor.getBody(), elm));
	      };
	      var unbindResizeHandleEvents = function () {
	        each$j(resizeHandles, function (handle) {
	          if (handle.elm) {
	            dom.unbind(handle.elm);
	            delete handle.elm;
	          }
	        });
	      };
	      var disableGeckoResize = function () {
	        try {
	          editor.getDoc().execCommand('enableObjectResizing', false, 'false');
	        } catch (ex) {
	        }
	      };
	      editor.on('init', function () {
	        disableGeckoResize();
	        if (Env.browser.isIE() || Env.browser.isEdge()) {
	          editor.on('mousedown click', function (e) {
	            var target = e.target, nodeName = target.nodeName;
	            if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(target)) {
	              if (e.button !== 2) {
	                editor.selection.select(target, nodeName === 'TABLE');
	              }
	              if (e.type === 'mousedown') {
	                editor.nodeChanged();
	              }
	            }
	          });
	          var handleMSControlSelect_1 = function (e) {
	            var delayedSelect = function (node) {
	              Delay.setEditorTimeout(editor, function () {
	                return editor.selection.select(node);
	              });
	            };
	            if (isWithinContentEditableFalse(e.target) || isMedia$2(e.target)) {
	              e.preventDefault();
	              delayedSelect(e.target);
	              return;
	            }
	            if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
	              e.preventDefault();
	              if (e.target.tagName === 'IMG') {
	                delayedSelect(e.target);
	              }
	            }
	          };
	          dom.bind(rootElement, 'mscontrolselect', handleMSControlSelect_1);
	          editor.on('remove', function () {
	            return dom.unbind(rootElement, 'mscontrolselect', handleMSControlSelect_1);
	          });
	        }
	        var throttledUpdateResizeRect = Delay.throttle(function (e) {
	          if (!editor.composing) {
	            updateResizeRect(e);
	          }
	        });
	        editor.on('NodeChange ResizeEditor ResizeWindow ResizeContent drop', throttledUpdateResizeRect);
	        editor.on('keyup compositionend', function (e) {
	          if (selectedElm && selectedElm.nodeName === 'TABLE') {
	            throttledUpdateResizeRect(e);
	          }
	        });
	        editor.on('hide blur', hideResizeRect);
	        editor.on('contextmenu longpress', contextMenuSelectImage, true);
	      });
	      editor.on('remove', unbindResizeHandleEvents);
	      var destroy = function () {
	        selectedElm = selectedElmGhost = resizeBackdrop = null;
	      };
	      return {
	        isResizable: isResizable,
	        showResizeRect: showResizeRect,
	        hideResizeRect: hideResizeRect,
	        updateResizeRect: updateResizeRect,
	        destroy: destroy
	      };
	    };
	
	    var hasCeProperty = function (node) {
	      return isContentEditableTrue$4(node) || isContentEditableFalse$b(node);
	    };
	    var findParent$1 = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var findClosestIeRange = function (clientX, clientY, doc) {
	      var rects;
	      var element = doc.elementFromPoint(clientX, clientY);
	      var rng = doc.body.createTextRange();
	      if (!element || element.tagName === 'HTML') {
	        element = doc.body;
	      }
	      rng.moveToElementText(element);
	      rects = Tools.toArray(rng.getClientRects());
	      rects = rects.sort(function (a, b) {
	        a = Math.abs(Math.max(a.top - clientY, a.bottom - clientY));
	        b = Math.abs(Math.max(b.top - clientY, b.bottom - clientY));
	        return a - b;
	      });
	      if (rects.length > 0) {
	        clientY = (rects[0].bottom + rects[0].top) / 2;
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	          return rng;
	        } catch (ex) {
	        }
	      }
	      return null;
	    };
	    var moveOutOfContentEditableFalse = function (rng, rootNode) {
	      var parentElement = rng && rng.parentElement ? rng.parentElement() : null;
	      return isContentEditableFalse$b(findParent$1(parentElement, rootNode, hasCeProperty)) ? null : rng;
	    };
	    var fromPoint = function (clientX, clientY, doc) {
	      var rng, point;
	      var pointDoc = doc;
	      if (pointDoc.caretPositionFromPoint) {
	        point = pointDoc.caretPositionFromPoint(clientX, clientY);
	        if (point) {
	          rng = doc.createRange();
	          rng.setStart(point.offsetNode, point.offset);
	          rng.collapse(true);
	        }
	      } else if (pointDoc.caretRangeFromPoint) {
	        rng = pointDoc.caretRangeFromPoint(clientX, clientY);
	      } else if (pointDoc.body.createTextRange) {
	        rng = pointDoc.body.createTextRange();
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	        } catch (ex) {
	          rng = findClosestIeRange(clientX, clientY, doc);
	        }
	        return moveOutOfContentEditableFalse(rng, doc.body);
	      }
	      return rng;
	    };
	
	    var isEq$4 = function (rng1, rng2) {
	      return rng1 && rng2 && (rng1.startContainer === rng2.startContainer && rng1.startOffset === rng2.startOffset) && (rng1.endContainer === rng2.endContainer && rng1.endOffset === rng2.endOffset);
	    };
	
	    var findParent = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var hasParent$1 = function (node, rootNode, predicate) {
	      return findParent(node, rootNode, predicate) !== null;
	    };
	    var hasParentWithName = function (node, rootNode, name) {
	      return hasParent$1(node, rootNode, function (node) {
	        return node.nodeName === name;
	      });
	    };
	    var isTable = function (node) {
	      return node && node.nodeName === 'TABLE';
	    };
	    var isTableCell$2 = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	    var isCeFalseCaretContainer = function (node, rootNode) {
	      return isCaretContainer$2(node) && hasParent$1(node, rootNode, isCaretNode) === false;
	    };
	    var hasBrBeforeAfter = function (dom, node, left) {
	      var walker = new DomTreeWalker(node, dom.getParent(node.parentNode, dom.isBlock) || dom.getRoot());
	      while (node = walker[left ? 'prev' : 'next']()) {
	        if (isBr$5(node)) {
	          return true;
	        }
	      }
	    };
	    var isPrevNode = function (node, name) {
	      return node.previousSibling && node.previousSibling.nodeName === name;
	    };
	    var hasContentEditableFalseParent = function (body, node) {
	      while (node && node !== body) {
	        if (isContentEditableFalse$b(node)) {
	          return true;
	        }
	        node = node.parentNode;
	      }
	      return false;
	    };
	    var findTextNodeRelative = function (dom, isAfterNode, collapsed, left, startNode) {
	      var lastInlineElement;
	      var body = dom.getRoot();
	      var node;
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      var parentBlockContainer = dom.getParent(startNode.parentNode, dom.isBlock) || body;
	      if (left && isBr$5(startNode) && isAfterNode && dom.isEmpty(parentBlockContainer)) {
	        return Optional.some(CaretPosition(startNode.parentNode, dom.nodeIndex(startNode)));
	      }
	      var walker = new DomTreeWalker(startNode, parentBlockContainer);
	      while (node = walker[left ? 'prev' : 'next']()) {
	        if (dom.getContentEditableParent(node) === 'false' || isCeFalseCaretContainer(node, body)) {
	          return Optional.none();
	        }
	        if (isText$7(node) && node.nodeValue.length > 0) {
	          if (hasParentWithName(node, body, 'A') === false) {
	            return Optional.some(CaretPosition(node, left ? node.nodeValue.length : 0));
	          }
	          return Optional.none();
	        }
	        if (dom.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          return Optional.none();
	        }
	        lastInlineElement = node;
	      }
	      if (collapsed && lastInlineElement) {
	        return Optional.some(CaretPosition(lastInlineElement, 0));
	      }
	      return Optional.none();
	    };
	    var normalizeEndPoint = function (dom, collapsed, start, rng) {
	      var container, offset;
	      var body = dom.getRoot();
	      var node;
	      var directionLeft, normalized = false;
	      container = rng[(start ? 'start' : 'end') + 'Container'];
	      offset = rng[(start ? 'start' : 'end') + 'Offset'];
	      var isAfterNode = isElement$5(container) && offset === container.childNodes.length;
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      directionLeft = start;
	      if (isCaretContainer$2(container)) {
	        return Optional.none();
	      }
	      if (isElement$5(container) && offset > container.childNodes.length - 1) {
	        directionLeft = false;
	      }
	      if (isDocument$1(container)) {
	        container = body;
	        offset = 0;
	      }
	      if (container === body) {
	        if (directionLeft) {
	          node = container.childNodes[offset > 0 ? offset - 1 : 0];
	          if (node) {
	            if (isCaretContainer$2(node)) {
	              return Optional.none();
	            }
	            if (nonEmptyElementsMap[node.nodeName] || isTable(node)) {
	              return Optional.none();
	            }
	          }
	        }
	        if (container.hasChildNodes()) {
	          offset = Math.min(!directionLeft && offset > 0 ? offset - 1 : offset, container.childNodes.length - 1);
	          container = container.childNodes[offset];
	          offset = isText$7(container) && isAfterNode ? container.data.length : 0;
	          if (!collapsed && container === body.lastChild && isTable(container)) {
	            return Optional.none();
	          }
	          if (hasContentEditableFalseParent(body, container) || isCaretContainer$2(container)) {
	            return Optional.none();
	          }
	          if (container.hasChildNodes() && isTable(container) === false) {
	            node = container;
	            var walker = new DomTreeWalker(container, body);
	            do {
	              if (isContentEditableFalse$b(node) || isCaretContainer$2(node)) {
	                normalized = false;
	                break;
	              }
	              if (isText$7(node) && node.nodeValue.length > 0) {
	                offset = directionLeft ? 0 : node.nodeValue.length;
	                container = node;
	                normalized = true;
	                break;
	              }
	              if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell$2(node)) {
	                offset = dom.nodeIndex(node);
	                container = node.parentNode;
	                if (!directionLeft) {
	                  offset++;
	                }
	                normalized = true;
	                break;
	              }
	            } while (node = directionLeft ? walker.next() : walker.prev());
	          }
	        }
	      }
	      if (collapsed) {
	        if (isText$7(container) && offset === 0) {
	          findTextNodeRelative(dom, isAfterNode, collapsed, true, container).each(function (pos) {
	            container = pos.container();
	            offset = pos.offset();
	            normalized = true;
	          });
	        }
	        if (isElement$5(container)) {
	          node = container.childNodes[offset];
	          if (!node) {
	            node = container.childNodes[offset - 1];
	          }
	          if (node && isBr$5(node) && !isPrevNode(node, 'A') && !hasBrBeforeAfter(dom, node, false) && !hasBrBeforeAfter(dom, node, true)) {
	            findTextNodeRelative(dom, isAfterNode, collapsed, true, node).each(function (pos) {
	              container = pos.container();
	              offset = pos.offset();
	              normalized = true;
	            });
	          }
	        }
	      }
	      if (directionLeft && !collapsed && isText$7(container) && offset === container.nodeValue.length) {
	        findTextNodeRelative(dom, isAfterNode, collapsed, false, container).each(function (pos) {
	          container = pos.container();
	          offset = pos.offset();
	          normalized = true;
	        });
	      }
	      return normalized ? Optional.some(CaretPosition(container, offset)) : Optional.none();
	    };
	    var normalize$2 = function (dom, rng) {
	      var collapsed = rng.collapsed, normRng = rng.cloneRange();
	      var startPos = CaretPosition.fromRangeStart(rng);
	      normalizeEndPoint(dom, collapsed, true, normRng).each(function (pos) {
	        if (!collapsed || !CaretPosition.isAbove(startPos, pos)) {
	          normRng.setStart(pos.container(), pos.offset());
	        }
	      });
	      if (!collapsed) {
	        normalizeEndPoint(dom, collapsed, false, normRng).each(function (pos) {
	          normRng.setEnd(pos.container(), pos.offset());
	        });
	      }
	      if (collapsed) {
	        normRng.collapse(true);
	      }
	      return isEq$4(rng, normRng) ? Optional.none() : Optional.some(normRng);
	    };
	
	    var splitText = function (node, offset) {
	      return node.splitText(offset);
	    };
	    var split = function (rng) {
	      var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
	      if (startContainer === endContainer && isText$7(startContainer)) {
	        if (startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          endContainer = splitText(startContainer, startOffset);
	          startContainer = endContainer.previousSibling;
	          if (endOffset > startOffset) {
	            endOffset = endOffset - startOffset;
	            startContainer = endContainer = splitText(endContainer, endOffset).previousSibling;
	            endOffset = endContainer.nodeValue.length;
	            startOffset = 0;
	          } else {
	            endOffset = 0;
	          }
	        }
	      } else {
	        if (isText$7(startContainer) && startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          startContainer = splitText(startContainer, startOffset);
	          startOffset = 0;
	        }
	        if (isText$7(endContainer) && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
	          endContainer = splitText(endContainer, endOffset).previousSibling;
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	
	    var RangeUtils = function (dom) {
	      var walk = function (rng, callback) {
	        return walk$2(dom, rng, callback);
	      };
	      var split$1 = split;
	      var normalize = function (rng) {
	        return normalize$2(dom, rng).fold(never, function (normalizedRng) {
	          rng.setStart(normalizedRng.startContainer, normalizedRng.startOffset);
	          rng.setEnd(normalizedRng.endContainer, normalizedRng.endOffset);
	          return true;
	        });
	      };
	      return {
	        walk: walk,
	        split: split$1,
	        normalize: normalize
	      };
	    };
	    RangeUtils.compareRanges = isEq$4;
	    RangeUtils.getCaretRangeFromPoint = fromPoint;
	    RangeUtils.getSelectedNode = getSelectedNode;
	    RangeUtils.getNode = getNode$1;
	
	    var Dimension = function (name, getOffset) {
	      var set = function (element, h) {
	        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
	          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
	        }
	        var dom = element.dom;
	        if (isSupported(dom)) {
	          dom.style[name] = h + 'px';
	        }
	      };
	      var get = function (element) {
	        var r = getOffset(element);
	        if (r <= 0 || r === null) {
	          var css = get$5(element, name);
	          return parseFloat(css) || 0;
	        }
	        return r;
	      };
	      var getOuter = get;
	      var aggregate = function (element, properties) {
	        return foldl(properties, function (acc, property) {
	          var val = get$5(element, property);
	          var value = val === undefined ? 0 : parseInt(val, 10);
	          return isNaN(value) ? acc : acc + value;
	        }, 0);
	      };
	      var max = function (element, value, properties) {
	        var cumulativeInclusions = aggregate(element, properties);
	        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
	        return absoluteMax;
	      };
	      return {
	        set: set,
	        get: get,
	        getOuter: getOuter,
	        aggregate: aggregate,
	        max: max
	      };
	    };
	
	    var api = Dimension('height', function (element) {
	      var dom = element.dom;
	      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
	    });
	    var get$1 = function (element) {
	      return api.get(element);
	    };
	
	    var walkUp = function (navigation, doc) {
	      var frame = navigation.view(doc);
	      return frame.fold(constant([]), function (f) {
	        var parent = navigation.owner(f);
	        var rest = walkUp(navigation, parent);
	        return [f].concat(rest);
	      });
	    };
	    var pathTo = function (element, navigation) {
	      var d = navigation.owner(element);
	      return walkUp(navigation, d);
	    };
	
	    var view = function (doc) {
	      var _a;
	      var element = doc.dom === document ? Optional.none() : Optional.from((_a = doc.dom.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement);
	      return element.map(SugarElement.fromDom);
	    };
	    var owner = function (element) {
	      return documentOrOwner(element);
	    };
	
	    var Navigation = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        view: view,
	        owner: owner
	    });
	
	    var find$1 = function (element) {
	      var doc = SugarElement.fromDom(document);
	      var scroll = get$8(doc);
	      var frames = pathTo(element, Navigation);
	      var offset = viewport(element);
	      var r = foldr(frames, function (b, a) {
	        var loc = viewport(a);
	        return {
	          left: b.left + loc.left,
	          top: b.top + loc.top
	        };
	      }, {
	        left: 0,
	        top: 0
	      });
	      return SugarPosition(r.left + offset.left + scroll.left, r.top + offset.top + scroll.top);
	    };
	
	    var excludeFromDescend = function (element) {
	      return name(element) === 'textarea';
	    };
	    var fireScrollIntoViewEvent = function (editor, data) {
	      var scrollEvent = editor.fire('ScrollIntoView', data);
	      return scrollEvent.isDefaultPrevented();
	    };
	    var fireAfterScrollIntoViewEvent = function (editor, data) {
	      editor.fire('AfterScrollIntoView', data);
	    };
	    var descend = function (element, offset) {
	      var children$1 = children(element);
	      if (children$1.length === 0 || excludeFromDescend(element)) {
	        return {
	          element: element,
	          offset: offset
	        };
	      } else if (offset < children$1.length && !excludeFromDescend(children$1[offset])) {
	        return {
	          element: children$1[offset],
	          offset: 0
	        };
	      } else {
	        var last = children$1[children$1.length - 1];
	        if (excludeFromDescend(last)) {
	          return {
	            element: element,
	            offset: offset
	          };
	        } else {
	          if (name(last) === 'img') {
	            return {
	              element: last,
	              offset: 1
	            };
	          } else if (isText$8(last)) {
	            return {
	              element: last,
	              offset: get$2(last).length
	            };
	          } else {
	            return {
	              element: last,
	              offset: children(last).length
	            };
	          }
	        }
	      }
	    };
	    var markerInfo = function (element, cleanupFun) {
	      var pos = absolute(element);
	      var height = get$1(element);
	      return {
	        element: element,
	        bottom: pos.top + height,
	        height: height,
	        pos: pos,
	        cleanup: cleanupFun
	      };
	    };
	    var createMarker = function (element, offset) {
	      var startPoint = descend(element, offset);
	      var span = SugarElement.fromHtml('<span data-mce-bogus="all" style="display: inline-block;">' + ZWSP$1 + '</span>');
	      before$4(startPoint.element, span);
	      return markerInfo(span, function () {
	        return remove$7(span);
	      });
	    };
	    var elementMarker = function (element) {
	      return markerInfo(SugarElement.fromDom(element), noop);
	    };
	    var withMarker = function (editor, f, rng, alignToTop) {
	      preserveWith(editor, function (_s, _e) {
	        return applyWithMarker(editor, f, rng, alignToTop);
	      }, rng);
	    };
	    var withScrollEvents = function (editor, doc, f, marker, alignToTop) {
	      var data = {
	        elm: marker.element.dom,
	        alignToTop: alignToTop
	      };
	      if (fireScrollIntoViewEvent(editor, data)) {
	        return;
	      }
	      var scrollTop = get$8(doc).top;
	      f(doc, scrollTop, marker, alignToTop);
	      fireAfterScrollIntoViewEvent(editor, data);
	    };
	    var applyWithMarker = function (editor, f, rng, alignToTop) {
	      var body = SugarElement.fromDom(editor.getBody());
	      var doc = SugarElement.fromDom(editor.getDoc());
	      reflow(body);
	      var marker = createMarker(SugarElement.fromDom(rng.startContainer), rng.startOffset);
	      withScrollEvents(editor, doc, f, marker, alignToTop);
	      marker.cleanup();
	    };
	    var withElement = function (editor, element, f, alignToTop) {
	      var doc = SugarElement.fromDom(editor.getDoc());
	      withScrollEvents(editor, doc, f, elementMarker(element), alignToTop);
	    };
	    var preserveWith = function (editor, f, rng) {
	      var startElement = rng.startContainer;
	      var startOffset = rng.startOffset;
	      var endElement = rng.endContainer;
	      var endOffset = rng.endOffset;
	      f(SugarElement.fromDom(startElement), SugarElement.fromDom(endElement));
	      var newRng = editor.dom.createRng();
	      newRng.setStart(startElement, startOffset);
	      newRng.setEnd(endElement, endOffset);
	      editor.selection.setRng(rng);
	    };
	    var scrollToMarker = function (marker, viewHeight, alignToTop, doc) {
	      var pos = marker.pos;
	      if (alignToTop) {
	        to(pos.left, pos.top, doc);
	      } else {
	        var y = pos.top - viewHeight + marker.height;
	        to(pos.left, y, doc);
	      }
	    };
	    var intoWindowIfNeeded = function (doc, scrollTop, viewHeight, marker, alignToTop) {
	      var viewportBottom = viewHeight + scrollTop;
	      var markerTop = marker.pos.top;
	      var markerBottom = marker.bottom;
	      var largerThanViewport = markerBottom - markerTop >= viewHeight;
	      if (markerTop < scrollTop) {
	        scrollToMarker(marker, viewHeight, alignToTop !== false, doc);
	      } else if (markerTop > viewportBottom) {
	        var align = largerThanViewport ? alignToTop !== false : alignToTop === true;
	        scrollToMarker(marker, viewHeight, align, doc);
	      } else if (markerBottom > viewportBottom && !largerThanViewport) {
	        scrollToMarker(marker, viewHeight, alignToTop === true, doc);
	      }
	    };
	    var intoWindow = function (doc, scrollTop, marker, alignToTop) {
	      var viewHeight = doc.dom.defaultView.innerHeight;
	      intoWindowIfNeeded(doc, scrollTop, viewHeight, marker, alignToTop);
	    };
	    var intoFrame = function (doc, scrollTop, marker, alignToTop) {
	      var frameViewHeight = doc.dom.defaultView.innerHeight;
	      intoWindowIfNeeded(doc, scrollTop, frameViewHeight, marker, alignToTop);
	      var op = find$1(marker.element);
	      var viewportBounds = getBounds(window);
	      if (op.top < viewportBounds.y) {
	        intoView(marker.element, alignToTop !== false);
	      } else if (op.top > viewportBounds.bottom) {
	        intoView(marker.element, alignToTop === true);
	      }
	    };
	    var rangeIntoWindow = function (editor, rng, alignToTop) {
	      return withMarker(editor, intoWindow, rng, alignToTop);
	    };
	    var elementIntoWindow = function (editor, element, alignToTop) {
	      return withElement(editor, element, intoWindow, alignToTop);
	    };
	    var rangeIntoFrame = function (editor, rng, alignToTop) {
	      return withMarker(editor, intoFrame, rng, alignToTop);
	    };
	    var elementIntoFrame = function (editor, element, alignToTop) {
	      return withElement(editor, element, intoFrame, alignToTop);
	    };
	    var scrollElementIntoView = function (editor, element, alignToTop) {
	      var scroller = editor.inline ? elementIntoWindow : elementIntoFrame;
	      scroller(editor, element, alignToTop);
	    };
	    var scrollRangeIntoView = function (editor, rng, alignToTop) {
	      var scroller = editor.inline ? rangeIntoWindow : rangeIntoFrame;
	      scroller(editor, rng, alignToTop);
	    };
	
	    var getDocument = function () {
	      return SugarElement.fromDom(document);
	    };
	
	    var focus$1 = function (element) {
	      return element.dom.focus();
	    };
	    var hasFocus$1 = function (element) {
	      var root = getRootNode(element).dom;
	      return element.dom === root.activeElement;
	    };
	    var active = function (root) {
	      if (root === void 0) {
	        root = getDocument();
	      }
	      return Optional.from(root.dom.activeElement).map(SugarElement.fromDom);
	    };
	    var search = function (element) {
	      return active(getRootNode(element)).filter(function (e) {
	        return element.dom.contains(e.dom);
	      });
	    };
	
	    var create$5 = function (start, soffset, finish, foffset) {
	      return {
	        start: start,
	        soffset: soffset,
	        finish: finish,
	        foffset: foffset
	      };
	    };
	    var SimRange = { create: create$5 };
	
	    var adt$1 = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart$2 = function (situ) {
	      return situ.fold(identity, identity, identity);
	    };
	    var before$1 = adt$1.before;
	    var on = adt$1.on;
	    var after$1 = adt$1.after;
	    var Situ = {
	      before: before$1,
	      on: on,
	      after: after$1,
	      cata: cata,
	      getStart: getStart$2
	    };
	
	    var adt = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
	    };
	    var getStart$1 = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return SugarElement.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, _finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, _soffset, _finish, _foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt.domRange;
	    var relative = adt.relative;
	    var exact = adt.exact;
	    var getWin = function (selection) {
	      var start = getStart$1(selection);
	      return defaultView(start);
	    };
	    var range = SimRange.create;
	    var SimSelection = {
	      domRange: domRange,
	      relative: relative,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range
	    };
	
	    var browser$1 = detect().browser;
	    var clamp$1 = function (offset, element) {
	      var max = isText$8(element) ? get$2(element).length : children(element).length + 1;
	      if (offset > max) {
	        return max;
	      } else if (offset < 0) {
	        return 0;
	      }
	      return offset;
	    };
	    var normalizeRng = function (rng) {
	      return SimSelection.range(rng.start, clamp$1(rng.soffset, rng.start), rng.finish, clamp$1(rng.foffset, rng.finish));
	    };
	    var isOrContains = function (root, elm) {
	      return !isRestrictedNode(elm.dom) && (contains$1(root, elm) || eq(root, elm));
	    };
	    var isRngInRoot = function (root) {
	      return function (rng) {
	        return isOrContains(root, rng.start) && isOrContains(root, rng.finish);
	      };
	    };
	    var shouldStore = function (editor) {
	      return editor.inline === true || browser$1.isIE();
	    };
	    var nativeRangeToSelectionRange = function (r) {
	      return SimSelection.range(SugarElement.fromDom(r.startContainer), r.startOffset, SugarElement.fromDom(r.endContainer), r.endOffset);
	    };
	    var readRange = function (win) {
	      var selection = win.getSelection();
	      var rng = !selection || selection.rangeCount === 0 ? Optional.none() : Optional.from(selection.getRangeAt(0));
	      return rng.map(nativeRangeToSelectionRange);
	    };
	    var getBookmark = function (root) {
	      var win = defaultView(root);
	      return readRange(win.dom).filter(isRngInRoot(root));
	    };
	    var validate = function (root, bookmark) {
	      return Optional.from(bookmark).filter(isRngInRoot(root)).map(normalizeRng);
	    };
	    var bookmarkToNativeRng = function (bookmark) {
	      var rng = document.createRange();
	      try {
	        rng.setStart(bookmark.start.dom, bookmark.soffset);
	        rng.setEnd(bookmark.finish.dom, bookmark.foffset);
	        return Optional.some(rng);
	      } catch (_) {
	        return Optional.none();
	      }
	    };
	    var store = function (editor) {
	      var newBookmark = shouldStore(editor) ? getBookmark(SugarElement.fromDom(editor.getBody())) : Optional.none();
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	    var storeNative = function (editor, rng) {
	      var root = SugarElement.fromDom(editor.getBody());
	      var range = shouldStore(editor) ? Optional.from(rng) : Optional.none();
	      var newBookmark = range.map(nativeRangeToSelectionRange).filter(isRngInRoot(root));
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	    var getRng = function (editor) {
	      var bookmark = editor.bookmark ? editor.bookmark : Optional.none();
	      return bookmark.bind(function (x) {
	        return validate(SugarElement.fromDom(editor.getBody()), x);
	      }).bind(bookmarkToNativeRng);
	    };
	    var restore = function (editor) {
	      getRng(editor).each(function (rng) {
	        return editor.selection.setRng(rng);
	      });
	    };
	
	    var isEditorUIElement$1 = function (elm) {
	      var className = elm.className.toString();
	      return className.indexOf('tox-') !== -1 || className.indexOf('mce-') !== -1;
	    };
	    var FocusManager = { isEditorUIElement: isEditorUIElement$1 };
	
	    var isManualNodeChange = function (e) {
	      return e.type === 'nodechange' && e.selectionChange;
	    };
	    var registerPageMouseUp = function (editor, throttledStore) {
	      var mouseUpPage = function () {
	        throttledStore.throttle();
	      };
	      DOMUtils.DOM.bind(document, 'mouseup', mouseUpPage);
	      editor.on('remove', function () {
	        DOMUtils.DOM.unbind(document, 'mouseup', mouseUpPage);
	      });
	    };
	    var registerFocusOut = function (editor) {
	      editor.on('focusout', function () {
	        store(editor);
	      });
	    };
	    var registerMouseUp = function (editor, throttledStore) {
	      editor.on('mouseup touchend', function (_e) {
	        throttledStore.throttle();
	      });
	    };
	    var registerEditorEvents = function (editor, throttledStore) {
	      var browser = detect().browser;
	      if (browser.isIE()) {
	        registerFocusOut(editor);
	      } else {
	        registerMouseUp(editor, throttledStore);
	      }
	      editor.on('keyup NodeChange', function (e) {
	        if (!isManualNodeChange(e)) {
	          store(editor);
	        }
	      });
	    };
	    var register$3 = function (editor) {
	      var throttledStore = first(function () {
	        store(editor);
	      }, 0);
	      editor.on('init', function () {
	        if (editor.inline) {
	          registerPageMouseUp(editor, throttledStore);
	        }
	        registerEditorEvents(editor, throttledStore);
	      });
	      editor.on('remove', function () {
	        throttledStore.cancel();
	      });
	    };
	
	    var documentFocusInHandler;
	    var DOM$8 = DOMUtils.DOM;
	    var isEditorUIElement = function (elm) {
	      return FocusManager.isEditorUIElement(elm);
	    };
	    var isEditorContentAreaElement = function (elm) {
	      var classList = elm.classList;
	      if (classList !== undefined) {
	        return classList.contains('tox-edit-area') || classList.contains('tox-edit-area__iframe') || classList.contains('mce-content-body');
	      } else {
	        return false;
	      }
	    };
	    var isUIElement = function (editor, elm) {
	      var customSelector = getCustomUiSelector(editor);
	      var parent = DOM$8.getParent(elm, function (elm) {
	        return isEditorUIElement(elm) || (customSelector ? editor.dom.is(elm, customSelector) : false);
	      });
	      return parent !== null;
	    };
	    var getActiveElement = function (editor) {
	      try {
	        var root = getRootNode(SugarElement.fromDom(editor.getElement()));
	        return active(root).fold(function () {
	          return document.body;
	        }, function (x) {
	          return x.dom;
	        });
	      } catch (ex) {
	        return document.body;
	      }
	    };
	    var registerEvents$1 = function (editorManager, e) {
	      var editor = e.editor;
	      register$3(editor);
	      editor.on('focusin', function () {
	        var focusedEditor = editorManager.focusedEditor;
	        if (focusedEditor !== editor) {
	          if (focusedEditor) {
	            focusedEditor.fire('blur', { focusedEditor: editor });
	          }
	          editorManager.setActive(editor);
	          editorManager.focusedEditor = editor;
	          editor.fire('focus', { blurredEditor: focusedEditor });
	          editor.focus(true);
	        }
	      });
	      editor.on('focusout', function () {
	        Delay.setEditorTimeout(editor, function () {
	          var focusedEditor = editorManager.focusedEditor;
	          if (!isUIElement(editor, getActiveElement(editor)) && focusedEditor === editor) {
	            editor.fire('blur', { focusedEditor: null });
	            editorManager.focusedEditor = null;
	          }
	        });
	      });
	      if (!documentFocusInHandler) {
	        documentFocusInHandler = function (e) {
	          var activeEditor = editorManager.activeEditor;
	          if (activeEditor) {
	            getOriginalEventTarget(e).each(function (target) {
	              if (target.ownerDocument === document) {
	                if (target !== document.body && !isUIElement(activeEditor, target) && editorManager.focusedEditor === activeEditor) {
	                  activeEditor.fire('blur', { focusedEditor: null });
	                  editorManager.focusedEditor = null;
	                }
	              }
	            });
	          }
	        };
	        DOM$8.bind(document, 'focusin', documentFocusInHandler);
	      }
	    };
	    var unregisterDocumentEvents = function (editorManager, e) {
	      if (editorManager.focusedEditor === e.editor) {
	        editorManager.focusedEditor = null;
	      }
	      if (!editorManager.activeEditor) {
	        DOM$8.unbind(document, 'focusin', documentFocusInHandler);
	        documentFocusInHandler = null;
	      }
	    };
	    var setup$l = function (editorManager) {
	      editorManager.on('AddEditor', curry(registerEvents$1, editorManager));
	      editorManager.on('RemoveEditor', curry(unregisterDocumentEvents, editorManager));
	    };
	
	    var getContentEditableHost = function (editor, node) {
	      return editor.dom.getParent(node, function (node) {
	        return editor.dom.getContentEditable(node) === 'true';
	      });
	    };
	    var getCollapsedNode = function (rng) {
	      return rng.collapsed ? Optional.from(getNode$1(rng.startContainer, rng.startOffset)).map(SugarElement.fromDom) : Optional.none();
	    };
	    var getFocusInElement = function (root, rng) {
	      return getCollapsedNode(rng).bind(function (node) {
	        if (isTableSection(node)) {
	          return Optional.some(node);
	        } else if (contains$1(root, node) === false) {
	          return Optional.some(root);
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var normalizeSelection$1 = function (editor, rng) {
	      getFocusInElement(SugarElement.fromDom(editor.getBody()), rng).bind(function (elm) {
	        return firstPositionIn(elm.dom);
	      }).fold(function () {
	        editor.selection.normalize();
	        return;
	      }, function (caretPos) {
	        return editor.selection.setRng(caretPos.toRange());
	      });
	    };
	    var focusBody = function (body) {
	      if (body.setActive) {
	        try {
	          body.setActive();
	        } catch (ex) {
	          body.focus();
	        }
	      } else {
	        body.focus();
	      }
	    };
	    var hasElementFocus = function (elm) {
	      return hasFocus$1(elm) || search(elm).isSome();
	    };
	    var hasIframeFocus = function (editor) {
	      return editor.iframeElement && hasFocus$1(SugarElement.fromDom(editor.iframeElement));
	    };
	    var hasInlineFocus = function (editor) {
	      var rawBody = editor.getBody();
	      return rawBody && hasElementFocus(SugarElement.fromDom(rawBody));
	    };
	    var hasUiFocus = function (editor) {
	      var dos = getRootNode(SugarElement.fromDom(editor.getElement()));
	      return active(dos).filter(function (elem) {
	        return !isEditorContentAreaElement(elem.dom) && isUIElement(editor, elem.dom);
	      }).isSome();
	    };
	    var hasFocus = function (editor) {
	      return editor.inline ? hasInlineFocus(editor) : hasIframeFocus(editor);
	    };
	    var hasEditorOrUiFocus = function (editor) {
	      return hasFocus(editor) || hasUiFocus(editor);
	    };
	    var focusEditor = function (editor) {
	      var selection = editor.selection;
	      var body = editor.getBody();
	      var rng = selection.getRng();
	      editor.quirks.refreshContentEditable();
	      if (editor.bookmark !== undefined && hasFocus(editor) === false) {
	        getRng(editor).each(function (bookmarkRng) {
	          editor.selection.setRng(bookmarkRng);
	          rng = bookmarkRng;
	        });
	      }
	      var contentEditableHost = getContentEditableHost(editor, selection.getNode());
	      if (editor.$.contains(body, contentEditableHost)) {
	        focusBody(contentEditableHost);
	        normalizeSelection$1(editor, rng);
	        activateEditor(editor);
	        return;
	      }
	      if (!editor.inline) {
	        if (!Env.opera) {
	          focusBody(body);
	        }
	        editor.getWin().focus();
	      }
	      if (Env.gecko || editor.inline) {
	        focusBody(body);
	        normalizeSelection$1(editor, rng);
	      }
	      activateEditor(editor);
	    };
	    var activateEditor = function (editor) {
	      return editor.editorManager.setActive(editor);
	    };
	    var focus = function (editor, skipFocus) {
	      if (editor.removed) {
	        return;
	      }
	      if (skipFocus) {
	        activateEditor(editor);
	      } else {
	        focusEditor(editor);
	      }
	    };
	
	    var getEndpointElement = function (root, rng, start, real, resolve) {
	      var container = start ? rng.startContainer : rng.endContainer;
	      var offset = start ? rng.startOffset : rng.endOffset;
	      return Optional.from(container).map(SugarElement.fromDom).map(function (elm) {
	        return !real || !rng.collapsed ? child$1(elm, resolve(elm, offset)).getOr(elm) : elm;
	      }).bind(function (elm) {
	        return isElement$6(elm) ? Optional.some(elm) : parent(elm).filter(isElement$6);
	      }).map(function (elm) {
	        return elm.dom;
	      }).getOr(root);
	    };
	    var getStart = function (root, rng, real) {
	      return getEndpointElement(root, rng, true, real, function (elm, offset) {
	        return Math.min(childNodesCount(elm), offset);
	      });
	    };
	    var getEnd = function (root, rng, real) {
	      return getEndpointElement(root, rng, false, real, function (elm, offset) {
	        return offset > 0 ? offset - 1 : offset;
	      });
	    };
	    var skipEmptyTextNodes = function (node, forwards) {
	      var orig = node;
	      while (node && isText$7(node) && node.length === 0) {
	        node = forwards ? node.nextSibling : node.previousSibling;
	      }
	      return node || orig;
	    };
	    var getNode = function (root, rng) {
	      var elm, startContainer, endContainer;
	      if (!rng) {
	        return root;
	      }
	      startContainer = rng.startContainer;
	      endContainer = rng.endContainer;
	      var startOffset = rng.startOffset;
	      var endOffset = rng.endOffset;
	      elm = rng.commonAncestorContainer;
	      if (!rng.collapsed) {
	        if (startContainer === endContainer) {
	          if (endOffset - startOffset < 2) {
	            if (startContainer.hasChildNodes()) {
	              elm = startContainer.childNodes[startOffset];
	            }
	          }
	        }
	        if (startContainer.nodeType === 3 && endContainer.nodeType === 3) {
	          if (startContainer.length === startOffset) {
	            startContainer = skipEmptyTextNodes(startContainer.nextSibling, true);
	          } else {
	            startContainer = startContainer.parentNode;
	          }
	          if (endOffset === 0) {
	            endContainer = skipEmptyTextNodes(endContainer.previousSibling, false);
	          } else {
	            endContainer = endContainer.parentNode;
	          }
	          if (startContainer && startContainer === endContainer) {
	            return startContainer;
	          }
	        }
	      }
	      if (elm && elm.nodeType === 3) {
	        return elm.parentNode;
	      }
	      return elm;
	    };
	    var getSelectedBlocks = function (dom, rng, startElm, endElm) {
	      var node;
	      var selectedBlocks = [];
	      var root = dom.getRoot();
	      startElm = dom.getParent(startElm || getStart(root, rng, rng.collapsed), dom.isBlock);
	      endElm = dom.getParent(endElm || getEnd(root, rng, rng.collapsed), dom.isBlock);
	      if (startElm && startElm !== root) {
	        selectedBlocks.push(startElm);
	      }
	      if (startElm && endElm && startElm !== endElm) {
	        node = startElm;
	        var walker = new DomTreeWalker(startElm, root);
	        while ((node = walker.next()) && node !== endElm) {
	          if (dom.isBlock(node)) {
	            selectedBlocks.push(node);
	          }
	        }
	      }
	      if (endElm && startElm !== endElm && endElm !== root) {
	        selectedBlocks.push(endElm);
	      }
	      return selectedBlocks;
	    };
	    var select = function (dom, node, content) {
	      return Optional.from(node).map(function (node) {
	        var idx = dom.nodeIndex(node);
	        var rng = dom.createRng();
	        rng.setStart(node.parentNode, idx);
	        rng.setEnd(node.parentNode, idx + 1);
	        if (content) {
	          moveEndPoint(dom, rng, node, true);
	          moveEndPoint(dom, rng, node, false);
	        }
	        return rng;
	      });
	    };
	
	    var processRanges = function (editor, ranges) {
	      return map$3(ranges, function (range) {
	        var evt = editor.fire('GetSelectionRange', { range: range });
	        return evt.range !== range ? evt.range : range;
	      });
	    };
	
	    var typeLookup = {
	      '#text': 3,
	      '#comment': 8,
	      '#cdata': 4,
	      '#pi': 7,
	      '#doctype': 10,
	      '#document-fragment': 11
	    };
	    var walk$1 = function (node, root, prev) {
	      var startName = prev ? 'lastChild' : 'firstChild';
	      var siblingName = prev ? 'prev' : 'next';
	      if (node[startName]) {
	        return node[startName];
	      }
	      if (node !== root) {
	        var sibling = node[siblingName];
	        if (sibling) {
	          return sibling;
	        }
	        for (var parent_1 = node.parent; parent_1 && parent_1 !== root; parent_1 = parent_1.parent) {
	          sibling = parent_1[siblingName];
	          if (sibling) {
	            return sibling;
	          }
	        }
	      }
	    };
	    var isEmptyTextNode = function (node) {
	      if (!isWhitespaceText(node.value)) {
	        return false;
	      }
	      var parentNode = node.parent;
	      if (parentNode && (parentNode.name !== 'span' || parentNode.attr('style')) && /^[ ]+$/.test(node.value)) {
	        return false;
	      }
	      return true;
	    };
	    var isNonEmptyElement = function (node) {
	      var isNamedAnchor = node.name === 'a' && !node.attr('href') && node.attr('id');
	      return node.attr('name') || node.attr('id') && !node.firstChild || node.attr('data-mce-bookmark') || isNamedAnchor;
	    };
	    var AstNode = function () {
	      function AstNode(name, type) {
	        this.name = name;
	        this.type = type;
	        if (type === 1) {
	          this.attributes = [];
	          this.attributes.map = {};
	        }
	      }
	      AstNode.create = function (name, attrs) {
	        var node = new AstNode(name, typeLookup[name] || 1);
	        if (attrs) {
	          each$j(attrs, function (value, attrName) {
	            node.attr(attrName, value);
	          });
	        }
	        return node;
	      };
	      AstNode.prototype.replace = function (node) {
	        var self = this;
	        if (node.parent) {
	          node.remove();
	        }
	        self.insert(node, self);
	        self.remove();
	        return self;
	      };
	      AstNode.prototype.attr = function (name, value) {
	        var self = this;
	        var attrs;
	        if (typeof name !== 'string') {
	          if (name !== undefined && name !== null) {
	            each$j(name, function (value, key) {
	              self.attr(key, value);
	            });
	          }
	          return self;
	        }
	        if (attrs = self.attributes) {
	          if (value !== undefined) {
	            if (value === null) {
	              if (name in attrs.map) {
	                delete attrs.map[name];
	                var i = attrs.length;
	                while (i--) {
	                  if (attrs[i].name === name) {
	                    attrs.splice(i, 1);
	                    return self;
	                  }
	                }
	              }
	              return self;
	            }
	            if (name in attrs.map) {
	              var i = attrs.length;
	              while (i--) {
	                if (attrs[i].name === name) {
	                  attrs[i].value = value;
	                  break;
	                }
	              }
	            } else {
	              attrs.push({
	                name: name,
	                value: value
	              });
	            }
	            attrs.map[name] = value;
	            return self;
	          }
	          return attrs.map[name];
	        }
	      };
	      AstNode.prototype.clone = function () {
	        var self = this;
	        var clone = new AstNode(self.name, self.type);
	        var selfAttrs;
	        if (selfAttrs = self.attributes) {
	          var cloneAttrs = [];
	          cloneAttrs.map = {};
	          for (var i = 0, l = selfAttrs.length; i < l; i++) {
	            var selfAttr = selfAttrs[i];
	            if (selfAttr.name !== 'id') {
	              cloneAttrs[cloneAttrs.length] = {
	                name: selfAttr.name,
	                value: selfAttr.value
	              };
	              cloneAttrs.map[selfAttr.name] = selfAttr.value;
	            }
	          }
	          clone.attributes = cloneAttrs;
	        }
	        clone.value = self.value;
	        clone.shortEnded = self.shortEnded;
	        return clone;
	      };
	      AstNode.prototype.wrap = function (wrapper) {
	        var self = this;
	        self.parent.insert(wrapper, self);
	        wrapper.append(self);
	        return self;
	      };
	      AstNode.prototype.unwrap = function () {
	        var self = this;
	        for (var node = self.firstChild; node;) {
	          var next = node.next;
	          self.insert(node, self, true);
	          node = next;
	        }
	        self.remove();
	      };
	      AstNode.prototype.remove = function () {
	        var self = this, parent = self.parent, next = self.next, prev = self.prev;
	        if (parent) {
	          if (parent.firstChild === self) {
	            parent.firstChild = next;
	            if (next) {
	              next.prev = null;
	            }
	          } else {
	            prev.next = next;
	          }
	          if (parent.lastChild === self) {
	            parent.lastChild = prev;
	            if (prev) {
	              prev.next = null;
	            }
	          } else {
	            next.prev = prev;
	          }
	          self.parent = self.next = self.prev = null;
	        }
	        return self;
	      };
	      AstNode.prototype.append = function (node) {
	        var self = this;
	        if (node.parent) {
	          node.remove();
	        }
	        var last = self.lastChild;
	        if (last) {
	          last.next = node;
	          node.prev = last;
	          self.lastChild = node;
	        } else {
	          self.lastChild = self.firstChild = node;
	        }
	        node.parent = self;
	        return node;
	      };
	      AstNode.prototype.insert = function (node, refNode, before) {
	        if (node.parent) {
	          node.remove();
	        }
	        var parent = refNode.parent || this;
	        if (before) {
	          if (refNode === parent.firstChild) {
	            parent.firstChild = node;
	          } else {
	            refNode.prev.next = node;
	          }
	          node.prev = refNode.prev;
	          node.next = refNode;
	          refNode.prev = node;
	        } else {
	          if (refNode === parent.lastChild) {
	            parent.lastChild = node;
	          } else {
	            refNode.next.prev = node;
	          }
	          node.next = refNode.next;
	          node.prev = refNode;
	          refNode.next = node;
	        }
	        node.parent = parent;
	        return node;
	      };
	      AstNode.prototype.getAll = function (name) {
	        var self = this;
	        var collection = [];
	        for (var node = self.firstChild; node; node = walk$1(node, self)) {
	          if (node.name === name) {
	            collection.push(node);
	          }
	        }
	        return collection;
	      };
	      AstNode.prototype.children = function () {
	        var self = this;
	        var collection = [];
	        for (var node = self.firstChild; node; node = node.next) {
	          collection.push(node);
	        }
	        return collection;
	      };
	      AstNode.prototype.empty = function () {
	        var self = this;
	        if (self.firstChild) {
	          var nodes = [];
	          for (var node = self.firstChild; node; node = walk$1(node, self)) {
	            nodes.push(node);
	          }
	          var i = nodes.length;
	          while (i--) {
	            var node = nodes[i];
	            node.parent = node.firstChild = node.lastChild = node.next = node.prev = null;
	          }
	        }
	        self.firstChild = self.lastChild = null;
	        return self;
	      };
	      AstNode.prototype.isEmpty = function (elements, whitespace, predicate) {
	        if (whitespace === void 0) {
	          whitespace = {};
	        }
	        var self = this;
	        var node = self.firstChild;
	        if (isNonEmptyElement(self)) {
	          return false;
	        }
	        if (node) {
	          do {
	            if (node.type === 1) {
	              if (node.attr('data-mce-bogus')) {
	                continue;
	              }
	              if (elements[node.name]) {
	                return false;
	              }
	              if (isNonEmptyElement(node)) {
	                return false;
	              }
	            }
	            if (node.type === 8) {
	              return false;
	            }
	            if (node.type === 3 && !isEmptyTextNode(node)) {
	              return false;
	            }
	            if (node.type === 3 && node.parent && whitespace[node.parent.name] && isWhitespaceText(node.value)) {
	              return false;
	            }
	            if (predicate && predicate(node)) {
	              return false;
	            }
	          } while (node = walk$1(node, self));
	        }
	        return true;
	      };
	      AstNode.prototype.walk = function (prev) {
	        return walk$1(this, null, prev);
	      };
	      return AstNode;
	    }();
	
	    var extractBase64DataUris = function (html) {
	      var dataImageUri = /data:[^;<"'\s]+;base64,([a-z0-9\+\/=\s]+)/gi;
	      var chunks = [];
	      var uris = {};
	      var prefix = generate('img');
	      var matches;
	      var index = 0;
	      var count = 0;
	      while (matches = dataImageUri.exec(html)) {
	        var uri = matches[0];
	        var imageId = prefix + '_' + count++;
	        uris[imageId] = uri;
	        if (index < matches.index) {
	          chunks.push(html.substr(index, matches.index - index));
	        }
	        chunks.push(imageId);
	        index = matches.index + uri.length;
	      }
	      var re = new RegExp(prefix + '_[0-9]+', 'g');
	      if (index === 0) {
	        return {
	          prefix: prefix,
	          uris: uris,
	          html: html,
	          re: re
	        };
	      } else {
	        if (index < html.length) {
	          chunks.push(html.substr(index));
	        }
	        return {
	          prefix: prefix,
	          uris: uris,
	          html: chunks.join(''),
	          re: re
	        };
	      }
	    };
	    var restoreDataUris = function (html, result) {
	      return html.replace(result.re, function (imageId) {
	        return get$9(result.uris, imageId).getOr(imageId);
	      });
	    };
	    var parseDataUri$1 = function (uri) {
	      var matches = /data:([^;]+);base64,([a-z0-9\+\/=\s]+)/i.exec(uri);
	      if (matches) {
	        return Optional.some({
	          type: matches[1],
	          data: decodeURIComponent(matches[2])
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	
	    var each$d = Tools.each, trim = Tools.trim;
	    var queryParts = 'source protocol authority userInfo user password host port relative path directory file query anchor'.split(' ');
	    var DEFAULT_PORTS = {
	      ftp: 21,
	      http: 80,
	      https: 443,
	      mailto: 25
	    };
	    var safeSvgDataUrlElements = [
	      'img',
	      'video'
	    ];
	    var blockSvgDataUris = function (allowSvgDataUrls, tagName) {
	      if (isNonNullable(allowSvgDataUrls)) {
	        return !allowSvgDataUrls;
	      } else {
	        return isNonNullable(tagName) ? !contains$3(safeSvgDataUrlElements, tagName) : true;
	      }
	    };
	    var isInvalidUri = function (settings, uri, tagName) {
	      if (settings.allow_html_data_urls) {
	        return false;
	      } else if (/^data:image\//i.test(uri)) {
	        return blockSvgDataUris(settings.allow_svg_data_urls, tagName) && /^data:image\/svg\+xml/i.test(uri);
	      } else {
	        return /^data:/i.test(uri);
	      }
	    };
	    var URI = function () {
	      function URI(url, settings) {
	        url = trim(url);
	        this.settings = settings || {};
	        var baseUri = this.settings.base_uri;
	        var self = this;
	        if (/^([\w\-]+):([^\/]{2})/i.test(url) || /^\s*#/.test(url)) {
	          self.source = url;
	          return;
	        }
	        var isProtocolRelative = url.indexOf('//') === 0;
	        if (url.indexOf('/') === 0 && !isProtocolRelative) {
	          url = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + url;
	        }
	        if (!/^[\w\-]*:?\/\//.test(url)) {
	          var baseUrl = this.settings.base_uri ? this.settings.base_uri.path : new URI(document.location.href).directory;
	          if (this.settings.base_uri && this.settings.base_uri.protocol == '') {
	            url = '//mce_host' + self.toAbsPath(baseUrl, url);
	          } else {
	            var match = /([^#?]*)([#?]?.*)/.exec(url);
	            url = (baseUri && baseUri.protocol || 'http') + '://mce_host' + self.toAbsPath(baseUrl, match[1]) + match[2];
	          }
	        }
	        url = url.replace(/@@/g, '(mce_at)');
	        var urlMatch = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?(\[[a-zA-Z0-9:.%]+\]|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);
	        each$d(queryParts, function (v, i) {
	          var part = urlMatch[i];
	          if (part) {
	            part = part.replace(/\(mce_at\)/g, '@@');
	          }
	          self[v] = part;
	        });
	        if (baseUri) {
	          if (!self.protocol) {
	            self.protocol = baseUri.protocol;
	          }
	          if (!self.userInfo) {
	            self.userInfo = baseUri.userInfo;
	          }
	          if (!self.port && self.host === 'mce_host') {
	            self.port = baseUri.port;
	          }
	          if (!self.host || self.host === 'mce_host') {
	            self.host = baseUri.host;
	          }
	          self.source = '';
	        }
	        if (isProtocolRelative) {
	          self.protocol = '';
	        }
	      }
	      URI.parseDataUri = function (uri) {
	        var type;
	        var uriComponents = decodeURIComponent(uri).split(',');
	        var matches = /data:([^;]+)/.exec(uriComponents[0]);
	        if (matches) {
	          type = matches[1];
	        }
	        return {
	          type: type,
	          data: uriComponents[1]
	        };
	      };
	      URI.isDomSafe = function (uri, context, options) {
	        if (options === void 0) {
	          options = {};
	        }
	        if (options.allow_script_urls) {
	          return true;
	        } else {
	          var decodedUri = Entities.decode(uri).replace(/[\s\u0000-\u001F]+/g, '');
	          try {
	            decodedUri = decodeURIComponent(decodedUri);
	          } catch (ex) {
	            decodedUri = unescape(decodedUri);
	          }
	          if (/((java|vb)script|mhtml):/i.test(decodedUri)) {
	            return false;
	          }
	          return !isInvalidUri(options, decodedUri, context);
	        }
	      };
	      URI.getDocumentBaseUrl = function (loc) {
	        var baseUrl;
	        if (loc.protocol.indexOf('http') !== 0 && loc.protocol !== 'file:') {
	          baseUrl = loc.href;
	        } else {
	          baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
	        }
	        if (/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)) {
	          baseUrl = baseUrl.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	          if (!/[\/\\]$/.test(baseUrl)) {
	            baseUrl += '/';
	          }
	        }
	        return baseUrl;
	      };
	      URI.prototype.setPath = function (path) {
	        var pathMatch = /^(.*?)\/?(\w+)?$/.exec(path);
	        this.path = pathMatch[0];
	        this.directory = pathMatch[1];
	        this.file = pathMatch[2];
	        this.source = '';
	        this.getURI();
	      };
	      URI.prototype.toRelative = function (uri) {
	        var output;
	        if (uri === './') {
	          return uri;
	        }
	        var relativeUri = new URI(uri, { base_uri: this });
	        if (relativeUri.host !== 'mce_host' && this.host !== relativeUri.host && relativeUri.host || this.port !== relativeUri.port || this.protocol !== relativeUri.protocol && relativeUri.protocol !== '') {
	          return relativeUri.getURI();
	        }
	        var tu = this.getURI(), uu = relativeUri.getURI();
	        if (tu === uu || tu.charAt(tu.length - 1) === '/' && tu.substr(0, tu.length - 1) === uu) {
	          return tu;
	        }
	        output = this.toRelPath(this.path, relativeUri.path);
	        if (relativeUri.query) {
	          output += '?' + relativeUri.query;
	        }
	        if (relativeUri.anchor) {
	          output += '#' + relativeUri.anchor;
	        }
	        return output;
	      };
	      URI.prototype.toAbsolute = function (uri, noHost) {
	        var absoluteUri = new URI(uri, { base_uri: this });
	        return absoluteUri.getURI(noHost && this.isSameOrigin(absoluteUri));
	      };
	      URI.prototype.isSameOrigin = function (uri) {
	        if (this.host == uri.host && this.protocol == uri.protocol) {
	          if (this.port == uri.port) {
	            return true;
	          }
	          var defaultPort = DEFAULT_PORTS[this.protocol];
	          if (defaultPort && (this.port || defaultPort) == (uri.port || defaultPort)) {
	            return true;
	          }
	        }
	        return false;
	      };
	      URI.prototype.toRelPath = function (base, path) {
	        var breakPoint = 0, out = '', i, l;
	        var normalizedBase = base.substring(0, base.lastIndexOf('/')).split('/');
	        var items = path.split('/');
	        if (normalizedBase.length >= items.length) {
	          for (i = 0, l = normalizedBase.length; i < l; i++) {
	            if (i >= items.length || normalizedBase[i] !== items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	        if (normalizedBase.length < items.length) {
	          for (i = 0, l = items.length; i < l; i++) {
	            if (i >= normalizedBase.length || normalizedBase[i] !== items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	        if (breakPoint === 1) {
	          return path;
	        }
	        for (i = 0, l = normalizedBase.length - (breakPoint - 1); i < l; i++) {
	          out += '../';
	        }
	        for (i = breakPoint - 1, l = items.length; i < l; i++) {
	          if (i !== breakPoint - 1) {
	            out += '/' + items[i];
	          } else {
	            out += items[i];
	          }
	        }
	        return out;
	      };
	      URI.prototype.toAbsPath = function (base, path) {
	        var i, nb = 0, o = [], outPath;
	        var tr = /\/$/.test(path) ? '/' : '';
	        var normalizedBase = base.split('/');
	        var normalizedPath = path.split('/');
	        each$d(normalizedBase, function (k) {
	          if (k) {
	            o.push(k);
	          }
	        });
	        normalizedBase = o;
	        for (i = normalizedPath.length - 1, o = []; i >= 0; i--) {
	          if (normalizedPath[i].length === 0 || normalizedPath[i] === '.') {
	            continue;
	          }
	          if (normalizedPath[i] === '..') {
	            nb++;
	            continue;
	          }
	          if (nb > 0) {
	            nb--;
	            continue;
	          }
	          o.push(normalizedPath[i]);
	        }
	        i = normalizedBase.length - nb;
	        if (i <= 0) {
	          outPath = reverse(o).join('/');
	        } else {
	          outPath = normalizedBase.slice(0, i).join('/') + '/' + reverse(o).join('/');
	        }
	        if (outPath.indexOf('/') !== 0) {
	          outPath = '/' + outPath;
	        }
	        if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
	          outPath += tr;
	        }
	        return outPath;
	      };
	      URI.prototype.getURI = function (noProtoHost) {
	        if (noProtoHost === void 0) {
	          noProtoHost = false;
	        }
	        var s;
	        if (!this.source || noProtoHost) {
	          s = '';
	          if (!noProtoHost) {
	            if (this.protocol) {
	              s += this.protocol + '://';
	            } else {
	              s += '//';
	            }
	            if (this.userInfo) {
	              s += this.userInfo + '@';
	            }
	            if (this.host) {
	              s += this.host;
	            }
	            if (this.port) {
	              s += ':' + this.port;
	            }
	          }
	          if (this.path) {
	            s += this.path;
	          }
	          if (this.query) {
	            s += '?' + this.query;
	          }
	          if (this.anchor) {
	            s += '#' + this.anchor;
	          }
	          this.source = s;
	        }
	        return this.source;
	      };
	      return URI;
	    }();
	
	    var filteredClobberElements = Tools.makeMap('button,fieldset,form,iframe,img,image,input,object,output,select,textarea');
	    var isValidPrefixAttrName = function (name) {
	      return name.indexOf('data-') === 0 || name.indexOf('aria-') === 0;
	    };
	    var lazyTempDocument$1 = cached(function () {
	      return document.implementation.createHTMLDocument('parser');
	    });
	    var findMatchingEndTagIndex = function (schema, html, startIndex) {
	      var startTagRegExp = /<([!?\/])?([A-Za-z0-9\-_:.]+)/g;
	      var endTagRegExp = /(?:\s(?:[^'">]+(?:"[^"]*"|'[^']*'))*[^"'>]*(?:"[^">]*|'[^'>]*)?|\s*|\/)>/g;
	      var shortEndedElements = schema.getShortEndedElements();
	      var count = 1, index = startIndex;
	      while (count !== 0) {
	        startTagRegExp.lastIndex = index;
	        while (true) {
	          var startMatch = startTagRegExp.exec(html);
	          if (startMatch === null) {
	            return index;
	          } else if (startMatch[1] === '!') {
	            if (startsWith(startMatch[2], '--')) {
	              index = findCommentEndIndex(html, false, startMatch.index + '!--'.length);
	            } else {
	              index = findCommentEndIndex(html, true, startMatch.index + 1);
	            }
	            break;
	          } else {
	            endTagRegExp.lastIndex = startTagRegExp.lastIndex;
	            var endMatch = endTagRegExp.exec(html);
	            if (isNull(endMatch) || endMatch.index !== startTagRegExp.lastIndex) {
	              continue;
	            }
	            if (startMatch[1] === '/') {
	              count -= 1;
	            } else if (!has$2(shortEndedElements, startMatch[2])) {
	              count += 1;
	            }
	            index = startTagRegExp.lastIndex + endMatch[0].length;
	            break;
	          }
	        }
	      }
	      return index;
	    };
	    var isConditionalComment = function (html, startIndex) {
	      return /^\s*\[if [\w\W]+\]>.*<!\[endif\](--!?)?>/.test(html.substr(startIndex));
	    };
	    var findCommentEndIndex = function (html, isBogus, startIndex) {
	      if (startIndex === void 0) {
	        startIndex = 0;
	      }
	      var lcHtml = html.toLowerCase();
	      if (lcHtml.indexOf('[if ', startIndex) !== -1 && isConditionalComment(lcHtml, startIndex)) {
	        var endIfIndex = lcHtml.indexOf('[endif]', startIndex);
	        return lcHtml.indexOf('>', endIfIndex);
	      } else {
	        if (isBogus) {
	          var endIndex = lcHtml.indexOf('>', startIndex);
	          return endIndex !== -1 ? endIndex : lcHtml.length;
	        } else {
	          var endCommentRegexp = /--!?>/g;
	          endCommentRegexp.lastIndex = startIndex;
	          var match = endCommentRegexp.exec(html);
	          return match ? match.index + match[0].length : lcHtml.length;
	        }
	      }
	    };
	    var checkBogusAttribute = function (regExp, attrString) {
	      var matches = regExp.exec(attrString);
	      if (matches) {
	        var name_1 = matches[1];
	        var value = matches[2];
	        return typeof name_1 === 'string' && name_1.toLowerCase() === 'data-mce-bogus' ? value : null;
	      } else {
	        return null;
	      }
	    };
	    var SaxParser = function (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      settings = settings || {};
	      var doc = lazyTempDocument$1();
	      var form = doc.createElement('form');
	      if (settings.fix_self_closing !== false) {
	        settings.fix_self_closing = true;
	      }
	      var comment = settings.comment ? settings.comment : noop;
	      var cdata = settings.cdata ? settings.cdata : noop;
	      var text = settings.text ? settings.text : noop;
	      var start = settings.start ? settings.start : noop;
	      var end = settings.end ? settings.end : noop;
	      var pi = settings.pi ? settings.pi : noop;
	      var doctype = settings.doctype ? settings.doctype : noop;
	      var parseInternal = function (base64Extract, format) {
	        if (format === void 0) {
	          format = 'html';
	        }
	        var html = base64Extract.html;
	        var matches, index = 0, value, endRegExp;
	        var stack = [];
	        var attrList, i, textData, name;
	        var isInternalElement, isShortEnded;
	        var elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
	        var attributesRequired, attributesDefault, attributesForced;
	        var anyAttributesRequired, attrValue, idCount = 0;
	        var decode = Entities.decode;
	        var filteredUrlAttrs = Tools.makeMap('src,href,data,background,action,formaction,poster,xlink:href');
	        var parsingMode = format === 'html' ? 0 : 1;
	        var processEndTag = function (name) {
	          var pos, i;
	          pos = stack.length;
	          while (pos--) {
	            if (stack[pos].name === name) {
	              break;
	            }
	          }
	          if (pos >= 0) {
	            for (i = stack.length - 1; i >= pos; i--) {
	              name = stack[i];
	              if (name.valid) {
	                end(name.name);
	              }
	            }
	            stack.length = pos;
	          }
	        };
	        var processText = function (value, raw) {
	          return text(restoreDataUris(value, base64Extract), raw);
	        };
	        var processComment = function (value) {
	          if (value === '') {
	            return;
	          }
	          if (value.charAt(0) === '>') {
	            value = ' ' + value;
	          }
	          if (!settings.allow_conditional_comments && value.substr(0, 3).toLowerCase() === '[if') {
	            value = ' ' + value;
	          }
	          comment(restoreDataUris(value, base64Extract));
	        };
	        var processAttr = function (value) {
	          return restoreDataUris(value, base64Extract);
	        };
	        var processMalformedComment = function (value, startIndex) {
	          var startTag = value || '';
	          var isBogus = !startsWith(startTag, '--');
	          var endIndex = findCommentEndIndex(html, isBogus, startIndex);
	          value = html.substr(startIndex, endIndex - startIndex);
	          processComment(isBogus ? startTag + value : value);
	          return endIndex + 1;
	        };
	        var parseAttribute = function (tagName, name, value, val2, val3) {
	          name = name.toLowerCase();
	          value = processAttr(name in fillAttrsMap ? name : decode(value || val2 || val3 || ''));
	          if (validate && !isInternalElement && isValidPrefixAttrName(name) === false) {
	            var attrRule = validAttributesMap[name];
	            if (!attrRule && validAttributePatterns) {
	              var i_1 = validAttributePatterns.length;
	              while (i_1--) {
	                attrRule = validAttributePatterns[i_1];
	                if (attrRule.pattern.test(name)) {
	                  break;
	                }
	              }
	              if (i_1 === -1) {
	                attrRule = null;
	              }
	            }
	            if (!attrRule) {
	              return;
	            }
	            if (attrRule.validValues && !(value in attrRule.validValues)) {
	              return;
	            }
	          }
	          var isNameOrId = name === 'name' || name === 'id';
	          if (isNameOrId && tagName in filteredClobberElements && (value in doc || value in form)) {
	            return;
	          }
	          if (filteredUrlAttrs[name] && !URI.isDomSafe(value, tagName, settings)) {
	            return;
	          }
	          if (isInternalElement && (name in filteredUrlAttrs || name.indexOf('on') === 0)) {
	            return;
	          }
	          attrList.map[name] = value;
	          attrList.push({
	            name: name,
	            value: value
	          });
	        };
	        var tokenRegExp = new RegExp('<(?:' + '(?:!--([\\w\\W]*?)--!?>)|' + '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + '(?:![Dd][Oo][Cc][Tt][Yy][Pp][Ee]([\\w\\W]*?)>)|' + '(?:!(--)?)|' + '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + '(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|' + '(?:([A-Za-z][A-Za-z0-9\\-_:.]*)(\\s(?:[^\'">]+(?:"[^"]*"|\'[^\']*\'))*[^"\'>]*(?:"[^">]*|\'[^\'>]*)?|\\s*|\\/)>)' + ')', 'g');
	        var attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
	        var shortEndedElements = schema.getShortEndedElements();
	        var selfClosing = settings.self_closing_elements || schema.getSelfClosingElements();
	        var fillAttrsMap = schema.getBoolAttrs();
	        var validate = settings.validate;
	        var removeInternalElements = settings.remove_internals;
	        var fixSelfClosing = settings.fix_self_closing;
	        var specialElements = schema.getSpecialElements();
	        var processHtml = html + '>';
	        while (matches = tokenRegExp.exec(processHtml)) {
	          var matchText = matches[0];
	          if (index < matches.index) {
	            processText(decode(html.substr(index, matches.index - index)));
	          }
	          if (value = matches[7]) {
	            value = value.toLowerCase();
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	            processEndTag(value);
	          } else if (value = matches[8]) {
	            if (matches.index + matchText.length > html.length) {
	              processText(decode(html.substr(matches.index)));
	              index = matches.index + matchText.length;
	              continue;
	            }
	            value = value.toLowerCase();
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	            isShortEnded = value in shortEndedElements;
	            if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
	              processEndTag(value);
	            }
	            var bogusValue = checkBogusAttribute(attrRegExp, matches[9]);
	            if (bogusValue !== null) {
	              if (bogusValue === 'all') {
	                index = findMatchingEndTagIndex(schema, html, tokenRegExp.lastIndex);
	                tokenRegExp.lastIndex = index;
	                continue;
	              }
	              isValidElement = false;
	            }
	            if (!validate || (elementRule = schema.getElementRule(value))) {
	              isValidElement = true;
	              if (validate) {
	                validAttributesMap = elementRule.attributes;
	                validAttributePatterns = elementRule.attributePatterns;
	              }
	              if (attribsValue = matches[9]) {
	                isInternalElement = attribsValue.indexOf('data-mce-type') !== -1;
	                if (isInternalElement && removeInternalElements) {
	                  isValidElement = false;
	                }
	                attrList = [];
	                attrList.map = {};
	                attribsValue.replace(attrRegExp, function (match, name, val, val2, val3) {
	                  parseAttribute(value, name, val, val2, val3);
	                  return '';
	                });
	              } else {
	                attrList = [];
	                attrList.map = {};
	              }
	              if (validate && !isInternalElement) {
	                attributesRequired = elementRule.attributesRequired;
	                attributesDefault = elementRule.attributesDefault;
	                attributesForced = elementRule.attributesForced;
	                anyAttributesRequired = elementRule.removeEmptyAttrs;
	                if (anyAttributesRequired && !attrList.length) {
	                  isValidElement = false;
	                }
	                if (attributesForced) {
	                  i = attributesForced.length;
	                  while (i--) {
	                    attr = attributesForced[i];
	                    name = attr.name;
	                    attrValue = attr.value;
	                    if (attrValue === '{$uid}') {
	                      attrValue = 'mce_' + idCount++;
	                    }
	                    attrList.map[name] = attrValue;
	                    attrList.push({
	                      name: name,
	                      value: attrValue
	                    });
	                  }
	                }
	                if (attributesDefault) {
	                  i = attributesDefault.length;
	                  while (i--) {
	                    attr = attributesDefault[i];
	                    name = attr.name;
	                    if (!(name in attrList.map)) {
	                      attrValue = attr.value;
	                      if (attrValue === '{$uid}') {
	                        attrValue = 'mce_' + idCount++;
	                      }
	                      attrList.map[name] = attrValue;
	                      attrList.push({
	                        name: name,
	                        value: attrValue
	                      });
	                    }
	                  }
	                }
	                if (attributesRequired) {
	                  i = attributesRequired.length;
	                  while (i--) {
	                    if (attributesRequired[i] in attrList.map) {
	                      break;
	                    }
	                  }
	                  if (i === -1) {
	                    isValidElement = false;
	                  }
	                }
	                if (attr = attrList.map['data-mce-bogus']) {
	                  if (attr === 'all') {
	                    index = findMatchingEndTagIndex(schema, html, tokenRegExp.lastIndex);
	                    tokenRegExp.lastIndex = index;
	                    continue;
	                  }
	                  isValidElement = false;
	                }
	              }
	              if (isValidElement) {
	                start(value, attrList, isShortEnded);
	              }
	            } else {
	              isValidElement = false;
	            }
	            if (endRegExp = specialElements[value]) {
	              endRegExp.lastIndex = index = matches.index + matchText.length;
	              if (matches = endRegExp.exec(html)) {
	                if (isValidElement) {
	                  textData = html.substr(index, matches.index - index);
	                }
	                index = matches.index + matches[0].length;
	              } else {
	                textData = html.substr(index);
	                index = html.length;
	              }
	              if (isValidElement) {
	                if (textData.length > 0) {
	                  processText(textData, true);
	                }
	                end(value);
	              }
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	            if (!isShortEnded) {
	              if (!attribsValue || attribsValue.indexOf('/') !== attribsValue.length - 1) {
	                stack.push({
	                  name: value,
	                  valid: isValidElement
	                });
	              } else if (isValidElement) {
	                end(value);
	              }
	            }
	          } else if (value = matches[1]) {
	            processComment(value);
	          } else if (value = matches[2]) {
	            var isValidCdataSection = parsingMode === 1 || settings.preserve_cdata || stack.length > 0 && schema.isValidChild(stack[stack.length - 1].name, '#cdata');
	            if (isValidCdataSection) {
	              cdata(value);
	            } else {
	              index = processMalformedComment('', matches.index + 2);
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	          } else if (value = matches[3]) {
	            doctype(value);
	          } else if ((value = matches[4]) || matchText === '<!') {
	            index = processMalformedComment(value, matches.index + matchText.length);
	            tokenRegExp.lastIndex = index;
	            continue;
	          } else if (value = matches[5]) {
	            if (parsingMode === 1) {
	              pi(value, matches[6]);
	            } else {
	              index = processMalformedComment('?', matches.index + 2);
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	          }
	          index = matches.index + matchText.length;
	        }
	        if (index < html.length) {
	          processText(decode(html.substr(index)));
	        }
	        for (i = stack.length - 1; i >= 0; i--) {
	          value = stack[i];
	          if (value.valid) {
	            end(value.name);
	          }
	        }
	      };
	      var parse = function (html, format) {
	        if (format === void 0) {
	          format = 'html';
	        }
	        parseInternal(extractBase64DataUris(html), format);
	      };
	      return { parse: parse };
	    };
	    SaxParser.findEndTag = findMatchingEndTagIndex;
	
	    var trimHtml = function (tempAttrs, html) {
	      var trimContentRegExp = new RegExp(['\\s?(' + tempAttrs.join('|') + ')="[^"]+"'].join('|'), 'gi');
	      return html.replace(trimContentRegExp, '');
	    };
	    var trimInternal = function (serializer, html) {
	      var bogusAllRegExp = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
	      var schema = serializer.schema;
	      var content = trimHtml(serializer.getTempAttrs(), html);
	      var shortEndedElements = schema.getShortEndedElements();
	      var matches;
	      while (matches = bogusAllRegExp.exec(content)) {
	        var index = bogusAllRegExp.lastIndex;
	        var matchLength = matches[0].length;
	        var endTagIndex = void 0;
	        if (shortEndedElements[matches[1]]) {
	          endTagIndex = index;
	        } else {
	          endTagIndex = SaxParser.findEndTag(schema, content, index);
	        }
	        content = content.substring(0, index - matchLength) + content.substring(endTagIndex);
	        bogusAllRegExp.lastIndex = index - matchLength;
	      }
	      return trim$2(content);
	    };
	    var trimExternal = trimInternal;
	
	    var trimEmptyContents = function (editor, html) {
	      var blockName = getForcedRootBlock(editor);
	      var emptyRegExp = new RegExp('^(<' + blockName + '[^>]*>(&nbsp;|&#160;|\\s|\xA0|<br \\/>|)<\\/' + blockName + '>[\r\n]*|<br \\/>[\r\n]*)$');
	      return html.replace(emptyRegExp, '');
	    };
	    var setupArgs$3 = function (args, format) {
	      return __assign(__assign({}, args), {
	        format: format,
	        get: true,
	        getInner: true
	      });
	    };
	    var getContentFromBody = function (editor, args, format, body) {
	      var defaultedArgs = setupArgs$3(args, format);
	      var updatedArgs = args.no_events ? defaultedArgs : editor.fire('BeforeGetContent', defaultedArgs);
	      var content;
	      if (updatedArgs.format === 'raw') {
	        content = Tools.trim(trimExternal(editor.serializer, body.innerHTML));
	      } else if (updatedArgs.format === 'text') {
	        content = editor.dom.isEmpty(body) ? '' : trim$2(body.innerText || body.textContent);
	      } else if (updatedArgs.format === 'tree') {
	        content = editor.serializer.serialize(body, updatedArgs);
	      } else {
	        content = trimEmptyContents(editor, editor.serializer.serialize(body, updatedArgs));
	      }
	      if (!contains$3([
	          'text',
	          'tree'
	        ], updatedArgs.format) && !isWsPreserveElement(SugarElement.fromDom(body))) {
	        updatedArgs.content = Tools.trim(content);
	      } else {
	        updatedArgs.content = content;
	      }
	      if (updatedArgs.no_events) {
	        return updatedArgs.content;
	      } else {
	        return editor.fire('GetContent', updatedArgs).content;
	      }
	    };
	    var getContentInternal = function (editor, args, format) {
	      return Optional.from(editor.getBody()).fold(constant(args.format === 'tree' ? new AstNode('body', 11) : ''), function (body) {
	        return getContentFromBody(editor, args, format, body);
	      });
	    };
	
	    var each$c = Tools.each;
	    var ElementUtils = function (dom) {
	      var compare = function (node1, node2) {
	        if (node1.nodeName !== node2.nodeName) {
	          return false;
	        }
	        var getAttribs = function (node) {
	          var attribs = {};
	          each$c(dom.getAttribs(node), function (attr) {
	            var name = attr.nodeName.toLowerCase();
	            if (name.indexOf('_') !== 0 && name !== 'style' && name.indexOf('data-') !== 0) {
	              attribs[name] = dom.getAttrib(node, name);
	            }
	          });
	          return attribs;
	        };
	        var compareObjects = function (obj1, obj2) {
	          var value, name;
	          for (name in obj1) {
	            if (has$2(obj1, name)) {
	              value = obj2[name];
	              if (typeof value === 'undefined') {
	                return false;
	              }
	              if (obj1[name] !== value) {
	                return false;
	              }
	              delete obj2[name];
	            }
	          }
	          for (name in obj2) {
	            if (has$2(obj2, name)) {
	              return false;
	            }
	          }
	          return true;
	        };
	        if (!compareObjects(getAttribs(node1), getAttribs(node2))) {
	          return false;
	        }
	        if (!compareObjects(dom.parseStyle(dom.getAttrib(node1, 'style')), dom.parseStyle(dom.getAttrib(node2, 'style')))) {
	          return false;
	        }
	        return !isBookmarkNode$1(node1) && !isBookmarkNode$1(node2);
	      };
	      return { compare: compare };
	    };
	
	    var makeMap$1 = Tools.makeMap;
	    var Writer = function (settings) {
	      var html = [];
	      settings = settings || {};
	      var indent = settings.indent;
	      var indentBefore = makeMap$1(settings.indent_before || '');
	      var indentAfter = makeMap$1(settings.indent_after || '');
	      var encode = Entities.getEncodeFunc(settings.entity_encoding || 'raw', settings.entities);
	      var htmlOutput = settings.element_format === 'html';
	      return {
	        start: function (name, attrs, empty) {
	          var i, l, attr, value;
	          if (indent && indentBefore[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	          html.push('<', name);
	          if (attrs) {
	            for (i = 0, l = attrs.length; i < l; i++) {
	              attr = attrs[i];
	              html.push(' ', attr.name, '="', encode(attr.value, true), '"');
	            }
	          }
	          if (!empty || htmlOutput) {
	            html[html.length] = '>';
	          } else {
	            html[html.length] = ' />';
	          }
	          if (empty && indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	        end: function (name) {
	          var value;
	          html.push('</', name, '>');
	          if (indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	        text: function (text, raw) {
	          if (text.length > 0) {
	            html[html.length] = raw ? text : encode(text);
	          }
	        },
	        cdata: function (text) {
	          html.push('<![CDATA[', text, ']]>');
	        },
	        comment: function (text) {
	          html.push('<!--', text, '-->');
	        },
	        pi: function (name, text) {
	          if (text) {
	            html.push('<?', name, ' ', encode(text), '?>');
	          } else {
	            html.push('<?', name, '?>');
	          }
	          if (indent) {
	            html.push('\n');
	          }
	        },
	        doctype: function (text) {
	          html.push('<!DOCTYPE', text, '>', indent ? '\n' : '');
	        },
	        reset: function () {
	          html.length = 0;
	        },
	        getContent: function () {
	          return html.join('').replace(/\n$/, '');
	        }
	      };
	    };
	
	    var HtmlSerializer = function (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var writer = Writer(settings);
	      settings = settings || {};
	      settings.validate = 'validate' in settings ? settings.validate : true;
	      var serialize = function (node) {
	        var validate = settings.validate;
	        var handlers = {
	          3: function (node) {
	            writer.text(node.value, node.raw);
	          },
	          8: function (node) {
	            writer.comment(node.value);
	          },
	          7: function (node) {
	            writer.pi(node.name, node.value);
	          },
	          10: function (node) {
	            writer.doctype(node.value);
	          },
	          4: function (node) {
	            writer.cdata(node.value);
	          },
	          11: function (node) {
	            if (node = node.firstChild) {
	              do {
	                walk(node);
	              } while (node = node.next);
	            }
	          }
	        };
	        writer.reset();
	        var walk = function (node) {
	          var handler = handlers[node.type];
	          if (!handler) {
	            var name_1 = node.name;
	            var isEmpty = node.shortEnded;
	            var attrs = node.attributes;
	            if (validate && attrs && attrs.length > 1) {
	              var sortedAttrs = [];
	              sortedAttrs.map = {};
	              var elementRule = schema.getElementRule(node.name);
	              if (elementRule) {
	                for (var i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
	                  var attrName = elementRule.attributesOrder[i];
	                  if (attrName in attrs.map) {
	                    var attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({
	                      name: attrName,
	                      value: attrValue
	                    });
	                  }
	                }
	                for (var i = 0, l = attrs.length; i < l; i++) {
	                  var attrName = attrs[i].name;
	                  if (!(attrName in sortedAttrs.map)) {
	                    var attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({
	                      name: attrName,
	                      value: attrValue
	                    });
	                  }
	                }
	                attrs = sortedAttrs;
	              }
	            }
	            writer.start(node.name, attrs, isEmpty);
	            if (!isEmpty) {
	              if (node = node.firstChild) {
	                do {
	                  walk(node);
	                } while (node = node.next);
	              }
	              writer.end(name_1);
	            }
	          } else {
	            handler(node);
	          }
	        };
	        if (node.type === 1 && !settings.inner) {
	          walk(node);
	        } else {
	          handlers[11](node);
	        }
	        return writer.getContent();
	      };
	      return { serialize: serialize };
	    };
	
	    var nonInheritableStyles = new Set();
	    (function () {
	      var nonInheritableStylesArr = [
	        'margin',
	        'margin-left',
	        'margin-right',
	        'margin-top',
	        'margin-bottom',
	        'padding',
	        'padding-left',
	        'padding-right',
	        'padding-top',
	        'padding-bottom',
	        'border',
	        'border-width',
	        'border-style',
	        'border-color',
	        'background',
	        'background-attachment',
	        'background-clip',
	        'background-color',
	        'background-image',
	        'background-origin',
	        'background-position',
	        'background-repeat',
	        'background-size',
	        'float',
	        'position',
	        'left',
	        'right',
	        'top',
	        'bottom',
	        'z-index',
	        'display',
	        'transform',
	        'width',
	        'max-width',
	        'min-width',
	        'height',
	        'max-height',
	        'min-height',
	        'overflow',
	        'overflow-x',
	        'overflow-y',
	        'text-overflow',
	        'vertical-align',
	        'transition',
	        'transition-delay',
	        'transition-duration',
	        'transition-property',
	        'transition-timing-function'
	      ];
	      each$k(nonInheritableStylesArr, function (style) {
	        nonInheritableStyles.add(style);
	      });
	    }());
	    var shorthandStyleProps = [
	      'font',
	      'text-decoration',
	      'text-emphasis'
	    ];
	    var getStyleProps = function (dom, node) {
	      return keys(dom.parseStyle(dom.getAttrib(node, 'style')));
	    };
	    var isNonInheritableStyle = function (style) {
	      return nonInheritableStyles.has(style);
	    };
	    var hasInheritableStyles = function (dom, node) {
	      return forall(getStyleProps(dom, node), function (style) {
	        return !isNonInheritableStyle(style);
	      });
	    };
	    var getLonghandStyleProps = function (styles) {
	      return filter$4(styles, function (style) {
	        return exists(shorthandStyleProps, function (prop) {
	          return startsWith(style, prop);
	        });
	      });
	    };
	    var hasStyleConflict = function (dom, node, parentNode) {
	      var nodeStyleProps = getStyleProps(dom, node);
	      var parentNodeStyleProps = getStyleProps(dom, parentNode);
	      var valueMismatch = function (prop) {
	        var nodeValue = dom.getStyle(node, prop);
	        var parentValue = dom.getStyle(parentNode, prop);
	        return isNotEmpty(nodeValue) && isNotEmpty(parentValue) && nodeValue !== parentValue;
	      };
	      return exists(nodeStyleProps, function (nodeStyleProp) {
	        var propExists = function (props) {
	          return exists(props, function (prop) {
	            return prop === nodeStyleProp;
	          });
	        };
	        if (!propExists(parentNodeStyleProps) && propExists(shorthandStyleProps)) {
	          var longhandProps = getLonghandStyleProps(parentNodeStyleProps);
	          return exists(longhandProps, valueMismatch);
	        } else {
	          return valueMismatch(nodeStyleProp);
	        }
	      });
	    };
	
	    var isChar = function (forward, predicate, pos) {
	      return Optional.from(pos.container()).filter(isText$7).exists(function (text) {
	        var delta = forward ? 0 : -1;
	        return predicate(text.data.charAt(pos.offset() + delta));
	      });
	    };
	    var isBeforeSpace = curry(isChar, true, isWhiteSpace);
	    var isAfterSpace = curry(isChar, false, isWhiteSpace);
	    var isEmptyText = function (pos) {
	      var container = pos.container();
	      return isText$7(container) && (container.data.length === 0 || isZwsp(container.data) && BookmarkManager.isBookmarkNode(container.parentNode));
	    };
	    var matchesElementPosition = function (before, predicate) {
	      return function (pos) {
	        return Optional.from(getChildNodeAtRelativeOffset(before ? 0 : -1, pos)).filter(predicate).isSome();
	      };
	    };
	    var isImageBlock = function (node) {
	      return isImg(node) && get$5(SugarElement.fromDom(node), 'display') === 'block';
	    };
	    var isCefNode = function (node) {
	      return isContentEditableFalse$b(node) && !isBogusAll$1(node);
	    };
	    var isBeforeImageBlock = matchesElementPosition(true, isImageBlock);
	    var isAfterImageBlock = matchesElementPosition(false, isImageBlock);
	    var isBeforeMedia = matchesElementPosition(true, isMedia$2);
	    var isAfterMedia = matchesElementPosition(false, isMedia$2);
	    var isBeforeTable = matchesElementPosition(true, isTable$3);
	    var isAfterTable = matchesElementPosition(false, isTable$3);
	    var isBeforeContentEditableFalse = matchesElementPosition(true, isCefNode);
	    var isAfterContentEditableFalse = matchesElementPosition(false, isCefNode);
	
	    var getLastChildren = function (elm) {
	      var children = [];
	      var rawNode = elm.dom;
	      while (rawNode) {
	        children.push(SugarElement.fromDom(rawNode));
	        rawNode = rawNode.lastChild;
	      }
	      return children;
	    };
	    var removeTrailingBr = function (elm) {
	      var allBrs = descendants(elm, 'br');
	      var brs = filter$4(getLastChildren(elm).slice(-1), isBr$4);
	      if (allBrs.length === brs.length) {
	        each$k(brs, remove$7);
	      }
	    };
	    var fillWithPaddingBr = function (elm) {
	      empty(elm);
	      append$1(elm, SugarElement.fromHtml('<br data-mce-bogus="1">'));
	    };
	    var trimBlockTrailingBr = function (elm) {
	      lastChild(elm).each(function (lastChild) {
	        prevSibling(lastChild).each(function (lastChildPrevSibling) {
	          if (isBlock$2(elm) && isBr$4(lastChild) && isBlock$2(lastChildPrevSibling)) {
	            remove$7(lastChild);
	          }
	        });
	      });
	    };
	
	    var dropLast = function (xs) {
	      return xs.slice(0, -1);
	    };
	    var parentsUntil = function (start, root, predicate) {
	      if (contains$1(root, start)) {
	        return dropLast(parents$1(start, function (elm) {
	          return predicate(elm) || eq(elm, root);
	        }));
	      } else {
	        return [];
	      }
	    };
	    var parents = function (start, root) {
	      return parentsUntil(start, root, never);
	    };
	    var parentsAndSelf = function (start, root) {
	      return [start].concat(parents(start, root));
	    };
	
	    var navigateIgnoreEmptyTextNodes = function (forward, root, from) {
	      return navigateIgnore(forward, root, from, isEmptyText);
	    };
	    var getClosestBlock$1 = function (root, pos) {
	      return find$3(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock$2);
	    };
	    var isAtBeforeAfterBlockBoundary = function (forward, root, pos) {
	      return navigateIgnoreEmptyTextNodes(forward, root.dom, pos).forall(function (newPos) {
	        return getClosestBlock$1(root, pos).fold(function () {
	          return isInSameBlock(newPos, pos, root.dom) === false;
	        }, function (fromBlock) {
	          return isInSameBlock(newPos, pos, root.dom) === false && contains$1(fromBlock, SugarElement.fromDom(newPos.container()));
	        });
	      });
	    };
	    var isAtBlockBoundary = function (forward, root, pos) {
	      return getClosestBlock$1(root, pos).fold(function () {
	        return navigateIgnoreEmptyTextNodes(forward, root.dom, pos).forall(function (newPos) {
	          return isInSameBlock(newPos, pos, root.dom) === false;
	        });
	      }, function (parent) {
	        return navigateIgnoreEmptyTextNodes(forward, parent.dom, pos).isNone();
	      });
	    };
	    var isAtStartOfBlock = curry(isAtBlockBoundary, false);
	    var isAtEndOfBlock = curry(isAtBlockBoundary, true);
	    var isBeforeBlock = curry(isAtBeforeAfterBlockBoundary, false);
	    var isAfterBlock = curry(isAtBeforeAfterBlockBoundary, true);
	
	    var isBr = function (pos) {
	      return getElementFromPosition(pos).exists(isBr$4);
	    };
	    var findBr = function (forward, root, pos) {
	      var parentBlocks = filter$4(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock$2);
	      var scope = head(parentBlocks).getOr(root);
	      return fromPosition(forward, scope.dom, pos).filter(isBr);
	    };
	    var isBeforeBr$1 = function (root, pos) {
	      return getElementFromPosition(pos).exists(isBr$4) || findBr(true, root, pos).isSome();
	    };
	    var isAfterBr = function (root, pos) {
	      return getElementFromPrevPosition(pos).exists(isBr$4) || findBr(false, root, pos).isSome();
	    };
	    var findPreviousBr = curry(findBr, false);
	    var findNextBr = curry(findBr, true);
	
	    var isInMiddleOfText = function (pos) {
	      return CaretPosition.isTextPosition(pos) && !pos.isAtStart() && !pos.isAtEnd();
	    };
	    var getClosestBlock = function (root, pos) {
	      var parentBlocks = filter$4(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock$2);
	      return head(parentBlocks).getOr(root);
	    };
	    var hasSpaceBefore = function (root, pos) {
	      if (isInMiddleOfText(pos)) {
	        return isAfterSpace(pos);
	      } else {
	        return isAfterSpace(pos) || prevPosition(getClosestBlock(root, pos).dom, pos).exists(isAfterSpace);
	      }
	    };
	    var hasSpaceAfter = function (root, pos) {
	      if (isInMiddleOfText(pos)) {
	        return isBeforeSpace(pos);
	      } else {
	        return isBeforeSpace(pos) || nextPosition(getClosestBlock(root, pos).dom, pos).exists(isBeforeSpace);
	      }
	    };
	    var isPreValue = function (value) {
	      return contains$3([
	        'pre',
	        'pre-wrap'
	      ], value);
	    };
	    var isInPre = function (pos) {
	      return getElementFromPosition(pos).bind(function (elm) {
	        return closest$3(elm, isElement$6);
	      }).exists(function (elm) {
	        return isPreValue(get$5(elm, 'white-space'));
	      });
	    };
	    var isAtBeginningOfBody = function (root, pos) {
	      return prevPosition(root.dom, pos).isNone();
	    };
	    var isAtEndOfBody = function (root, pos) {
	      return nextPosition(root.dom, pos).isNone();
	    };
	    var isAtLineBoundary = function (root, pos) {
	      return isAtBeginningOfBody(root, pos) || isAtEndOfBody(root, pos) || isAtStartOfBlock(root, pos) || isAtEndOfBlock(root, pos) || isAfterBr(root, pos) || isBeforeBr$1(root, pos);
	    };
	    var needsToHaveNbsp = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtLineBoundary(root, pos) || hasSpaceBefore(root, pos) || hasSpaceAfter(root, pos);
	      }
	    };
	    var needsToBeNbspLeft = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtStartOfBlock(root, pos) || isBeforeBlock(root, pos) || isAfterBr(root, pos) || hasSpaceBefore(root, pos);
	      }
	    };
	    var leanRight = function (pos) {
	      var container = pos.container();
	      var offset = pos.offset();
	      if (isText$7(container) && offset < container.data.length) {
	        return CaretPosition(container, offset + 1);
	      } else {
	        return pos;
	      }
	    };
	    var needsToBeNbspRight = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtEndOfBlock(root, pos) || isAfterBlock(root, pos) || isBeforeBr$1(root, pos) || hasSpaceAfter(root, pos);
	      }
	    };
	    var needsToBeNbsp = function (root, pos) {
	      return needsToBeNbspLeft(root, pos) || needsToBeNbspRight(root, leanRight(pos));
	    };
	    var isNbspAt = function (text, offset) {
	      return isNbsp(text.charAt(offset));
	    };
	    var hasNbsp = function (pos) {
	      var container = pos.container();
	      return isText$7(container) && contains$2(container.data, nbsp);
	    };
	    var normalizeNbspMiddle = function (text) {
	      var chars = text.split('');
	      return map$3(chars, function (chr, i) {
	        if (isNbsp(chr) && i > 0 && i < chars.length - 1 && isContent(chars[i - 1]) && isContent(chars[i + 1])) {
	          return ' ';
	        } else {
	          return chr;
	        }
	      }).join('');
	    };
	    var normalizeNbspAtStart = function (root, node) {
	      var text = node.data;
	      var firstPos = CaretPosition(node, 0);
	      if (isNbspAt(text, 0) && !needsToBeNbsp(root, firstPos)) {
	        node.data = ' ' + text.slice(1);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbspInMiddleOfTextNode = function (node) {
	      var text = node.data;
	      var newText = normalizeNbspMiddle(text);
	      if (newText !== text) {
	        node.data = newText;
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbspAtEnd = function (root, node) {
	      var text = node.data;
	      var lastPos = CaretPosition(node, text.length - 1);
	      if (isNbspAt(text, text.length - 1) && !needsToBeNbsp(root, lastPos)) {
	        node.data = text.slice(0, -1) + ' ';
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbsps = function (root, pos) {
	      return Optional.some(pos).filter(hasNbsp).bind(function (pos) {
	        var container = pos.container();
	        var normalized = normalizeNbspAtStart(root, container) || normalizeNbspInMiddleOfTextNode(container) || normalizeNbspAtEnd(root, container);
	        return normalized ? Optional.some(pos) : Optional.none();
	      });
	    };
	    var normalizeNbspsInEditor = function (editor) {
	      var root = SugarElement.fromDom(editor.getBody());
	      if (editor.selection.isCollapsed()) {
	        normalizeNbsps(root, CaretPosition.fromRangeStart(editor.selection.getRng())).each(function (pos) {
	          editor.selection.setRng(pos.toRange());
	        });
	      }
	    };
	
	    var normalizeContent = function (content, isStartOfContent, isEndOfContent) {
	      var result = foldl(content, function (acc, c) {
	        if (isWhiteSpace(c) || isNbsp(c)) {
	          if (acc.previousCharIsSpace || acc.str === '' && isStartOfContent || acc.str.length === content.length - 1 && isEndOfContent) {
	            return {
	              previousCharIsSpace: false,
	              str: acc.str + nbsp
	            };
	          } else {
	            return {
	              previousCharIsSpace: true,
	              str: acc.str + ' '
	            };
	          }
	        } else {
	          return {
	            previousCharIsSpace: false,
	            str: acc.str + c
	          };
	        }
	      }, {
	        previousCharIsSpace: false,
	        str: ''
	      });
	      return result.str;
	    };
	    var normalize$1 = function (node, offset, count) {
	      if (count === 0) {
	        return;
	      }
	      var elm = SugarElement.fromDom(node);
	      var root = ancestor$3(elm, isBlock$2).getOr(elm);
	      var whitespace = node.data.slice(offset, offset + count);
	      var isEndOfContent = offset + count >= node.data.length && needsToBeNbspRight(root, CaretPosition(node, node.data.length));
	      var isStartOfContent = offset === 0 && needsToBeNbspLeft(root, CaretPosition(node, 0));
	      node.replaceData(offset, count, normalizeContent(whitespace, isStartOfContent, isEndOfContent));
	    };
	    var normalizeWhitespaceAfter = function (node, offset) {
	      var content = node.data.slice(offset);
	      var whitespaceCount = content.length - lTrim(content).length;
	      normalize$1(node, offset, whitespaceCount);
	    };
	    var normalizeWhitespaceBefore = function (node, offset) {
	      var content = node.data.slice(0, offset);
	      var whitespaceCount = content.length - rTrim(content).length;
	      normalize$1(node, offset - whitespaceCount, whitespaceCount);
	    };
	    var mergeTextNodes = function (prevNode, nextNode, normalizeWhitespace, mergeToPrev) {
	      if (mergeToPrev === void 0) {
	        mergeToPrev = true;
	      }
	      var whitespaceOffset = rTrim(prevNode.data).length;
	      var newNode = mergeToPrev ? prevNode : nextNode;
	      var removeNode = mergeToPrev ? nextNode : prevNode;
	      if (mergeToPrev) {
	        newNode.appendData(removeNode.data);
	      } else {
	        newNode.insertData(0, removeNode.data);
	      }
	      remove$7(SugarElement.fromDom(removeNode));
	      if (normalizeWhitespace) {
	        normalizeWhitespaceAfter(newNode, whitespaceOffset);
	      }
	      return newNode;
	    };
	
	    var needsReposition = function (pos, elm) {
	      var container = pos.container();
	      var offset = pos.offset();
	      return CaretPosition.isTextPosition(pos) === false && container === elm.parentNode && offset > CaretPosition.before(elm).offset();
	    };
	    var reposition = function (elm, pos) {
	      return needsReposition(pos, elm) ? CaretPosition(pos.container(), pos.offset() - 1) : pos;
	    };
	    var beforeOrStartOf = function (node) {
	      return isText$7(node) ? CaretPosition(node, 0) : CaretPosition.before(node);
	    };
	    var afterOrEndOf = function (node) {
	      return isText$7(node) ? CaretPosition(node, node.data.length) : CaretPosition.after(node);
	    };
	    var getPreviousSiblingCaretPosition = function (elm) {
	      if (isCaretCandidate$3(elm.previousSibling)) {
	        return Optional.some(afterOrEndOf(elm.previousSibling));
	      } else {
	        return elm.previousSibling ? lastPositionIn(elm.previousSibling) : Optional.none();
	      }
	    };
	    var getNextSiblingCaretPosition = function (elm) {
	      if (isCaretCandidate$3(elm.nextSibling)) {
	        return Optional.some(beforeOrStartOf(elm.nextSibling));
	      } else {
	        return elm.nextSibling ? firstPositionIn(elm.nextSibling) : Optional.none();
	      }
	    };
	    var findCaretPositionBackwardsFromElm = function (rootElement, elm) {
	      var startPosition = CaretPosition.before(elm.previousSibling ? elm.previousSibling : elm.parentNode);
	      return prevPosition(rootElement, startPosition).fold(function () {
	        return nextPosition(rootElement, CaretPosition.after(elm));
	      }, Optional.some);
	    };
	    var findCaretPositionForwardsFromElm = function (rootElement, elm) {
	      return nextPosition(rootElement, CaretPosition.after(elm)).fold(function () {
	        return prevPosition(rootElement, CaretPosition.before(elm));
	      }, Optional.some);
	    };
	    var findCaretPositionBackwards = function (rootElement, elm) {
	      return getPreviousSiblingCaretPosition(elm).orThunk(function () {
	        return getNextSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionBackwardsFromElm(rootElement, elm);
	      });
	    };
	    var findCaretPositionForward = function (rootElement, elm) {
	      return getNextSiblingCaretPosition(elm).orThunk(function () {
	        return getPreviousSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionForwardsFromElm(rootElement, elm);
	      });
	    };
	    var findCaretPosition = function (forward, rootElement, elm) {
	      return forward ? findCaretPositionForward(rootElement, elm) : findCaretPositionBackwards(rootElement, elm);
	    };
	    var findCaretPosOutsideElmAfterDelete = function (forward, rootElement, elm) {
	      return findCaretPosition(forward, rootElement, elm).map(curry(reposition, elm));
	    };
	    var setSelection$1 = function (editor, forward, pos) {
	      pos.fold(function () {
	        editor.focus();
	      }, function (pos) {
	        editor.selection.setRng(pos.toRange(), forward);
	      });
	    };
	    var eqRawNode = function (rawNode) {
	      return function (elm) {
	        return elm.dom === rawNode;
	      };
	    };
	    var isBlock = function (editor, elm) {
	      return elm && has$2(editor.schema.getBlockElements(), name(elm));
	    };
	    var paddEmptyBlock = function (elm) {
	      if (isEmpty$2(elm)) {
	        var br = SugarElement.fromHtml('<br data-mce-bogus="1">');
	        empty(elm);
	        append$1(elm, br);
	        return Optional.some(CaretPosition.before(br.dom));
	      } else {
	        return Optional.none();
	      }
	    };
	    var deleteNormalized = function (elm, afterDeletePosOpt, normalizeWhitespace) {
	      var prevTextOpt = prevSibling(elm).filter(isText$8);
	      var nextTextOpt = nextSibling(elm).filter(isText$8);
	      remove$7(elm);
	      return lift3(prevTextOpt, nextTextOpt, afterDeletePosOpt, function (prev, next, pos) {
	        var prevNode = prev.dom, nextNode = next.dom;
	        var offset = prevNode.data.length;
	        mergeTextNodes(prevNode, nextNode, normalizeWhitespace);
	        return pos.container() === nextNode ? CaretPosition(prevNode, offset) : pos;
	      }).orThunk(function () {
	        if (normalizeWhitespace) {
	          prevTextOpt.each(function (elm) {
	            return normalizeWhitespaceBefore(elm.dom, elm.dom.length);
	          });
	          nextTextOpt.each(function (elm) {
	            return normalizeWhitespaceAfter(elm.dom, 0);
	          });
	        }
	        return afterDeletePosOpt;
	      });
	    };
	    var isInlineElement = function (editor, element) {
	      return has$2(editor.schema.getTextInlineElements(), name(element));
	    };
	    var deleteElement$2 = function (editor, forward, elm, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var afterDeletePos = findCaretPosOutsideElmAfterDelete(forward, editor.getBody(), elm.dom);
	      var parentBlock = ancestor$3(elm, curry(isBlock, editor), eqRawNode(editor.getBody()));
	      var normalizedAfterDeletePos = deleteNormalized(elm, afterDeletePos, isInlineElement(editor, elm));
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        editor.selection.setCursorLocation();
	      } else {
	        parentBlock.bind(paddEmptyBlock).fold(function () {
	          if (moveCaret) {
	            setSelection$1(editor, forward, normalizedAfterDeletePos);
	          }
	        }, function (paddPos) {
	          if (moveCaret) {
	            setSelection$1(editor, forward, Optional.some(paddPos));
	          }
	        });
	      }
	    };
	
	    var isRootFromElement = function (root) {
	      return function (cur) {
	        return eq(root, cur);
	      };
	    };
	    var getTableCells = function (table) {
	      return descendants(table, 'td,th');
	    };
	    var getTableDetailsFromRange = function (rng, isRoot) {
	      var getTable = function (node) {
	        return getClosestTable(SugarElement.fromDom(node), isRoot);
	      };
	      var startTable = getTable(rng.startContainer);
	      var endTable = getTable(rng.endContainer);
	      var isStartInTable = startTable.isSome();
	      var isEndInTable = endTable.isSome();
	      var isSameTable = lift2(startTable, endTable, eq).getOr(false);
	      var isMultiTable = !isSameTable && isStartInTable && isEndInTable;
	      return {
	        startTable: startTable,
	        endTable: endTable,
	        isStartInTable: isStartInTable,
	        isEndInTable: isEndInTable,
	        isSameTable: isSameTable,
	        isMultiTable: isMultiTable
	      };
	    };
	
	    var tableCellRng = function (start, end) {
	      return {
	        start: start,
	        end: end
	      };
	    };
	    var tableSelection = function (rng, table, cells) {
	      return {
	        rng: rng,
	        table: table,
	        cells: cells
	      };
	    };
	    var deleteAction = Adt.generate([
	      {
	        singleCellTable: [
	          'rng',
	          'cell'
	        ]
	      },
	      { fullTable: ['table'] },
	      {
	        partialTable: [
	          'cells',
	          'outsideDetails'
	        ]
	      },
	      {
	        multiTable: [
	          'startTableCells',
	          'endTableCells',
	          'betweenRng'
	        ]
	      }
	    ]);
	    var getClosestCell$1 = function (container, isRoot) {
	      return closest$2(SugarElement.fromDom(container), 'td,th', isRoot);
	    };
	    var isExpandedCellRng = function (cellRng) {
	      return !eq(cellRng.start, cellRng.end);
	    };
	    var getTableFromCellRng = function (cellRng, isRoot) {
	      return getClosestTable(cellRng.start, isRoot).bind(function (startParentTable) {
	        return getClosestTable(cellRng.end, isRoot).bind(function (endParentTable) {
	          return someIf(eq(startParentTable, endParentTable), startParentTable);
	        });
	      });
	    };
	    var isSingleCellTable = function (cellRng, isRoot) {
	      return !isExpandedCellRng(cellRng) && getTableFromCellRng(cellRng, isRoot).exists(function (table) {
	        var rows = table.dom.rows;
	        return rows.length === 1 && rows[0].cells.length === 1;
	      });
	    };
	    var getCellRng = function (rng, isRoot) {
	      var startCell = getClosestCell$1(rng.startContainer, isRoot);
	      var endCell = getClosestCell$1(rng.endContainer, isRoot);
	      return lift2(startCell, endCell, tableCellRng);
	    };
	    var getCellRangeFromStartTable = function (isRoot) {
	      return function (startCell) {
	        return getClosestTable(startCell, isRoot).bind(function (table) {
	          return last$2(getTableCells(table)).map(function (endCell) {
	            return tableCellRng(startCell, endCell);
	          });
	        });
	      };
	    };
	    var getCellRangeFromEndTable = function (isRoot) {
	      return function (endCell) {
	        return getClosestTable(endCell, isRoot).bind(function (table) {
	          return head(getTableCells(table)).map(function (startCell) {
	            return tableCellRng(startCell, endCell);
	          });
	        });
	      };
	    };
	    var getTableSelectionFromCellRng = function (isRoot) {
	      return function (cellRng) {
	        return getTableFromCellRng(cellRng, isRoot).map(function (table) {
	          return tableSelection(cellRng, table, getTableCells(table));
	        });
	      };
	    };
	    var getTableSelections = function (cellRng, selectionDetails, rng, isRoot) {
	      if (rng.collapsed || !cellRng.forall(isExpandedCellRng)) {
	        return Optional.none();
	      } else if (selectionDetails.isSameTable) {
	        var sameTableSelection = cellRng.bind(getTableSelectionFromCellRng(isRoot));
	        return Optional.some({
	          start: sameTableSelection,
	          end: sameTableSelection
	        });
	      } else {
	        var startCell = getClosestCell$1(rng.startContainer, isRoot);
	        var endCell = getClosestCell$1(rng.endContainer, isRoot);
	        var startTableSelection = startCell.bind(getCellRangeFromStartTable(isRoot)).bind(getTableSelectionFromCellRng(isRoot));
	        var endTableSelection = endCell.bind(getCellRangeFromEndTable(isRoot)).bind(getTableSelectionFromCellRng(isRoot));
	        return Optional.some({
	          start: startTableSelection,
	          end: endTableSelection
	        });
	      }
	    };
	    var getCellIndex = function (cells, cell) {
	      return findIndex$2(cells, function (x) {
	        return eq(x, cell);
	      });
	    };
	    var getSelectedCells = function (tableSelection) {
	      return lift2(getCellIndex(tableSelection.cells, tableSelection.rng.start), getCellIndex(tableSelection.cells, tableSelection.rng.end), function (startIndex, endIndex) {
	        return tableSelection.cells.slice(startIndex, endIndex + 1);
	      });
	    };
	    var isSingleCellTableContentSelected = function (optCellRng, rng, isRoot) {
	      return optCellRng.exists(function (cellRng) {
	        return isSingleCellTable(cellRng, isRoot) && hasAllContentsSelected(cellRng.start, rng);
	      });
	    };
	    var unselectCells = function (rng, selectionDetails) {
	      var startTable = selectionDetails.startTable, endTable = selectionDetails.endTable;
	      var otherContentRng = rng.cloneRange();
	      startTable.each(function (table) {
	        return otherContentRng.setStartAfter(table.dom);
	      });
	      endTable.each(function (table) {
	        return otherContentRng.setEndBefore(table.dom);
	      });
	      return otherContentRng;
	    };
	    var handleSingleTable = function (cellRng, selectionDetails, rng, isRoot) {
	      return getTableSelections(cellRng, selectionDetails, rng, isRoot).bind(function (_a) {
	        var start = _a.start, end = _a.end;
	        return start.or(end);
	      }).bind(function (tableSelection) {
	        var isSameTable = selectionDetails.isSameTable;
	        var selectedCells = getSelectedCells(tableSelection).getOr([]);
	        if (isSameTable && tableSelection.cells.length === selectedCells.length) {
	          return Optional.some(deleteAction.fullTable(tableSelection.table));
	        } else if (selectedCells.length > 0) {
	          if (isSameTable) {
	            return Optional.some(deleteAction.partialTable(selectedCells, Optional.none()));
	          } else {
	            var otherContentRng = unselectCells(rng, selectionDetails);
	            return Optional.some(deleteAction.partialTable(selectedCells, Optional.some(__assign(__assign({}, selectionDetails), { rng: otherContentRng }))));
	          }
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var handleMultiTable = function (cellRng, selectionDetails, rng, isRoot) {
	      return getTableSelections(cellRng, selectionDetails, rng, isRoot).bind(function (_a) {
	        var start = _a.start, end = _a.end;
	        var startTableSelectedCells = start.bind(getSelectedCells).getOr([]);
	        var endTableSelectedCells = end.bind(getSelectedCells).getOr([]);
	        if (startTableSelectedCells.length > 0 && endTableSelectedCells.length > 0) {
	          var otherContentRng = unselectCells(rng, selectionDetails);
	          return Optional.some(deleteAction.multiTable(startTableSelectedCells, endTableSelectedCells, otherContentRng));
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var getActionFromRange = function (root, rng) {
	      var isRoot = isRootFromElement(root);
	      var optCellRng = getCellRng(rng, isRoot);
	      var selectionDetails = getTableDetailsFromRange(rng, isRoot);
	      if (isSingleCellTableContentSelected(optCellRng, rng, isRoot)) {
	        return optCellRng.map(function (cellRng) {
	          return deleteAction.singleCellTable(rng, cellRng.start);
	        });
	      } else if (selectionDetails.isMultiTable) {
	        return handleMultiTable(optCellRng, selectionDetails, rng, isRoot);
	      } else {
	        return handleSingleTable(optCellRng, selectionDetails, rng, isRoot);
	      }
	    };
	
	    var freefallRtl = function (root) {
	      var child = isComment$1(root) ? prevSibling(root) : lastChild(root);
	      return child.bind(freefallRtl).orThunk(function () {
	        return Optional.some(root);
	      });
	    };
	    var cleanCells = function (cells) {
	      return each$k(cells, function (cell) {
	        remove$6(cell, 'contenteditable');
	        fillWithPaddingBr(cell);
	      });
	    };
	    var getOutsideBlock = function (editor, container) {
	      return Optional.from(editor.dom.getParent(container, editor.dom.isBlock)).map(SugarElement.fromDom);
	    };
	    var handleEmptyBlock = function (editor, startInTable, emptyBlock) {
	      emptyBlock.each(function (block) {
	        if (startInTable) {
	          remove$7(block);
	        } else {
	          fillWithPaddingBr(block);
	          editor.selection.setCursorLocation(block.dom, 0);
	        }
	      });
	    };
	    var deleteContentInsideCell = function (editor, cell, rng, isFirstCellInSelection) {
	      var insideTableRng = rng.cloneRange();
	      if (isFirstCellInSelection) {
	        insideTableRng.setStart(rng.startContainer, rng.startOffset);
	        insideTableRng.setEndAfter(cell.dom.lastChild);
	      } else {
	        insideTableRng.setStartBefore(cell.dom.firstChild);
	        insideTableRng.setEnd(rng.endContainer, rng.endOffset);
	      }
	      deleteCellContents(editor, insideTableRng, cell, false);
	    };
	    var collapseAndRestoreCellSelection = function (editor) {
	      var selectedCells = getCellsFromEditor(editor);
	      var selectedNode = SugarElement.fromDom(editor.selection.getNode());
	      if (isTableCell$5(selectedNode.dom) && isEmpty$2(selectedNode)) {
	        editor.selection.setCursorLocation(selectedNode.dom, 0);
	      } else {
	        editor.selection.collapse(true);
	      }
	      if (selectedCells.length > 1 && exists(selectedCells, function (cell) {
	          return eq(cell, selectedNode);
	        })) {
	        set$1(selectedNode, 'data-mce-selected', '1');
	      }
	    };
	    var emptySingleTableCells = function (editor, cells, outsideDetails) {
	      var editorRng = editor.selection.getRng();
	      var cellsToClean = outsideDetails.bind(function (_a) {
	        var rng = _a.rng, isStartInTable = _a.isStartInTable;
	        var outsideBlock = getOutsideBlock(editor, isStartInTable ? rng.endContainer : rng.startContainer);
	        rng.deleteContents();
	        handleEmptyBlock(editor, isStartInTable, outsideBlock.filter(isEmpty$2));
	        var endPointCell = isStartInTable ? cells[0] : cells[cells.length - 1];
	        deleteContentInsideCell(editor, endPointCell, editorRng, isStartInTable);
	        if (!isEmpty$2(endPointCell)) {
	          return Optional.some(isStartInTable ? cells.slice(1) : cells.slice(0, -1));
	        } else {
	          return Optional.none();
	        }
	      }).getOr(cells);
	      cleanCells(cellsToClean);
	      collapseAndRestoreCellSelection(editor);
	      return true;
	    };
	    var emptyMultiTableCells = function (editor, startTableCells, endTableCells, betweenRng) {
	      var rng = editor.selection.getRng();
	      var startCell = startTableCells[0];
	      var endCell = endTableCells[endTableCells.length - 1];
	      deleteContentInsideCell(editor, startCell, rng, true);
	      deleteContentInsideCell(editor, endCell, rng, false);
	      var startTableCellsToClean = isEmpty$2(startCell) ? startTableCells : startTableCells.slice(1);
	      var endTableCellsToClean = isEmpty$2(endCell) ? endTableCells : endTableCells.slice(0, -1);
	      cleanCells(startTableCellsToClean.concat(endTableCellsToClean));
	      betweenRng.deleteContents();
	      collapseAndRestoreCellSelection(editor);
	      return true;
	    };
	    var deleteCellContents = function (editor, rng, cell, moveSelection) {
	      if (moveSelection === void 0) {
	        moveSelection = true;
	      }
	      rng.deleteContents();
	      var lastNode = freefallRtl(cell).getOr(cell);
	      var lastBlock = SugarElement.fromDom(editor.dom.getParent(lastNode.dom, editor.dom.isBlock));
	      if (isEmpty$2(lastBlock)) {
	        fillWithPaddingBr(lastBlock);
	        if (moveSelection) {
	          editor.selection.setCursorLocation(lastBlock.dom, 0);
	        }
	      }
	      if (!eq(cell, lastBlock)) {
	        var additionalCleanupNodes = is$1(parent(lastBlock), cell) ? [] : siblings(lastBlock);
	        each$k(additionalCleanupNodes.concat(children(cell)), function (node) {
	          if (!eq(node, lastBlock) && !contains$1(node, lastBlock) && isEmpty$2(node)) {
	            remove$7(node);
	          }
	        });
	      }
	      return true;
	    };
	    var deleteTableElement = function (editor, table) {
	      deleteElement$2(editor, false, table);
	      return true;
	    };
	    var deleteCellRange = function (editor, rootElm, rng) {
	      return getActionFromRange(rootElm, rng).map(function (action) {
	        return action.fold(curry(deleteCellContents, editor), curry(deleteTableElement, editor), curry(emptySingleTableCells, editor), curry(emptyMultiTableCells, editor));
	      });
	    };
	    var deleteCaptionRange = function (editor, caption) {
	      return emptyElement(editor, caption);
	    };
	    var deleteTableRange = function (editor, rootElm, rng, startElm) {
	      return getParentCaption(rootElm, startElm).fold(function () {
	        return deleteCellRange(editor, rootElm, rng);
	      }, function (caption) {
	        return deleteCaptionRange(editor, caption);
	      }).getOr(false);
	    };
	    var deleteRange$2 = function (editor, startElm, selectedCells) {
	      var rootNode = SugarElement.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      return selectedCells.length !== 0 ? emptySingleTableCells(editor, selectedCells, Optional.none()) : deleteTableRange(editor, rootNode, rng, startElm);
	    };
	    var getParentCell = function (rootElm, elm) {
	      return find$3(parentsAndSelf(elm, rootElm), isTableCell$4);
	    };
	    var getParentCaption = function (rootElm, elm) {
	      return find$3(parentsAndSelf(elm, rootElm), isTag('caption'));
	    };
	    var deleteBetweenCells = function (editor, rootElm, forward, fromCell, from) {
	      return navigate(forward, editor.getBody(), from).bind(function (to) {
	        return getParentCell(rootElm, SugarElement.fromDom(to.getNode())).map(function (toCell) {
	          return eq(toCell, fromCell) === false;
	        });
	      });
	    };
	    var emptyElement = function (editor, elm) {
	      fillWithPaddingBr(elm);
	      editor.selection.setCursorLocation(elm.dom, 0);
	      return Optional.some(true);
	    };
	    var isDeleteOfLastCharPos = function (fromCaption, forward, from, to) {
	      return firstPositionIn(fromCaption.dom).bind(function (first) {
	        return lastPositionIn(fromCaption.dom).map(function (last) {
	          return forward ? from.isEqual(first) && to.isEqual(last) : from.isEqual(last) && to.isEqual(first);
	        });
	      }).getOr(true);
	    };
	    var emptyCaretCaption = function (editor, elm) {
	      return emptyElement(editor, elm);
	    };
	    var validateCaretCaption = function (rootElm, fromCaption, to) {
	      return getParentCaption(rootElm, SugarElement.fromDom(to.getNode())).map(function (toCaption) {
	        return eq(toCaption, fromCaption) === false;
	      });
	    };
	    var deleteCaretInsideCaption = function (editor, rootElm, forward, fromCaption, from) {
	      return navigate(forward, editor.getBody(), from).bind(function (to) {
	        return isDeleteOfLastCharPos(fromCaption, forward, from, to) ? emptyCaretCaption(editor, fromCaption) : validateCaretCaption(rootElm, fromCaption, to);
	      }).or(Optional.some(true));
	    };
	    var deleteCaretCells = function (editor, forward, rootElm, startElm) {
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return getParentCell(rootElm, startElm).bind(function (fromCell) {
	        return isEmpty$2(fromCell) ? emptyElement(editor, fromCell) : deleteBetweenCells(editor, rootElm, forward, fromCell, from);
	      }).getOr(false);
	    };
	    var deleteCaretCaption = function (editor, forward, rootElm, fromCaption) {
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return isEmpty$2(fromCaption) ? emptyElement(editor, fromCaption) : deleteCaretInsideCaption(editor, rootElm, forward, fromCaption, from);
	    };
	    var isNearTable = function (forward, pos) {
	      return forward ? isBeforeTable(pos) : isAfterTable(pos);
	    };
	    var isBeforeOrAfterTable = function (editor, forward) {
	      var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return isNearTable(forward, fromPos) || fromPosition(forward, editor.getBody(), fromPos).exists(function (pos) {
	        return isNearTable(forward, pos);
	      });
	    };
	    var deleteCaret$3 = function (editor, forward, startElm) {
	      var rootElm = SugarElement.fromDom(editor.getBody());
	      return getParentCaption(rootElm, startElm).fold(function () {
	        return deleteCaretCells(editor, forward, rootElm, startElm) || isBeforeOrAfterTable(editor, forward);
	      }, function (fromCaption) {
	        return deleteCaretCaption(editor, forward, rootElm, fromCaption).getOr(false);
	      });
	    };
	    var backspaceDelete$9 = function (editor, forward) {
	      var startElm = SugarElement.fromDom(editor.selection.getStart(true));
	      var cells = getCellsFromEditor(editor);
	      return editor.selection.isCollapsed() && cells.length === 0 ? deleteCaret$3(editor, forward, startElm) : deleteRange$2(editor, startElm, cells);
	    };
	
	    var createRange = function (sc, so, ec, eo) {
	      var rng = document.createRange();
	      rng.setStart(sc, so);
	      rng.setEnd(ec, eo);
	      return rng;
	    };
	    var normalizeBlockSelectionRange = function (rng) {
	      var startPos = CaretPosition.fromRangeStart(rng);
	      var endPos = CaretPosition.fromRangeEnd(rng);
	      var rootNode = rng.commonAncestorContainer;
	      return fromPosition(false, rootNode, endPos).map(function (newEndPos) {
	        if (!isInSameBlock(startPos, endPos, rootNode) && isInSameBlock(startPos, newEndPos, rootNode)) {
	          return createRange(startPos.container(), startPos.offset(), newEndPos.container(), newEndPos.offset());
	        } else {
	          return rng;
	        }
	      }).getOr(rng);
	    };
	    var normalize = function (rng) {
	      return rng.collapsed ? rng : normalizeBlockSelectionRange(rng);
	    };
	
	    var hasOnlyOneChild$1 = function (node) {
	      return node.firstChild && node.firstChild === node.lastChild;
	    };
	    var isPaddingNode = function (node) {
	      return node.name === 'br' || node.value === nbsp;
	    };
	    var isPaddedEmptyBlock = function (schema, node) {
	      var blockElements = schema.getBlockElements();
	      return blockElements[node.name] && hasOnlyOneChild$1(node) && isPaddingNode(node.firstChild);
	    };
	    var isEmptyFragmentElement = function (schema, node) {
	      var nonEmptyElements = schema.getNonEmptyElements();
	      return node && (node.isEmpty(nonEmptyElements) || isPaddedEmptyBlock(schema, node));
	    };
	    var isListFragment = function (schema, fragment) {
	      var firstChild = fragment.firstChild;
	      var lastChild = fragment.lastChild;
	      if (firstChild && firstChild.name === 'meta') {
	        firstChild = firstChild.next;
	      }
	      if (lastChild && lastChild.attr('id') === 'mce_marker') {
	        lastChild = lastChild.prev;
	      }
	      if (isEmptyFragmentElement(schema, lastChild)) {
	        lastChild = lastChild.prev;
	      }
	      if (!firstChild || firstChild !== lastChild) {
	        return false;
	      }
	      return firstChild.name === 'ul' || firstChild.name === 'ol';
	    };
	    var cleanupDomFragment = function (domFragment) {
	      var firstChild = domFragment.firstChild;
	      var lastChild = domFragment.lastChild;
	      if (firstChild && firstChild.nodeName === 'META') {
	        firstChild.parentNode.removeChild(firstChild);
	      }
	      if (lastChild && lastChild.id === 'mce_marker') {
	        lastChild.parentNode.removeChild(lastChild);
	      }
	      return domFragment;
	    };
	    var toDomFragment = function (dom, serializer, fragment) {
	      var html = serializer.serialize(fragment);
	      var domFragment = dom.createFragment(html);
	      return cleanupDomFragment(domFragment);
	    };
	    var listItems = function (elm) {
	      return filter$4(elm.childNodes, function (child) {
	        return child.nodeName === 'LI';
	      });
	    };
	    var isPadding = function (node) {
	      return node.data === nbsp || isBr$5(node);
	    };
	    var isListItemPadded = function (node) {
	      return node && node.firstChild && node.firstChild === node.lastChild && isPadding(node.firstChild);
	    };
	    var isEmptyOrPadded = function (elm) {
	      return !elm.firstChild || isListItemPadded(elm);
	    };
	    var trimListItems = function (elms) {
	      return elms.length > 0 && isEmptyOrPadded(elms[elms.length - 1]) ? elms.slice(0, -1) : elms;
	    };
	    var getParentLi = function (dom, node) {
	      var parentBlock = dom.getParent(node, dom.isBlock);
	      return parentBlock && parentBlock.nodeName === 'LI' ? parentBlock : null;
	    };
	    var isParentBlockLi = function (dom, node) {
	      return !!getParentLi(dom, node);
	    };
	    var getSplit = function (parentNode, rng) {
	      var beforeRng = rng.cloneRange();
	      var afterRng = rng.cloneRange();
	      beforeRng.setStartBefore(parentNode);
	      afterRng.setEndAfter(parentNode);
	      return [
	        beforeRng.cloneContents(),
	        afterRng.cloneContents()
	      ];
	    };
	    var findFirstIn = function (node, rootNode) {
	      var caretPos = CaretPosition.before(node);
	      var caretWalker = CaretWalker(rootNode);
	      var newCaretPos = caretWalker.next(caretPos);
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	    var findLastOf = function (node, rootNode) {
	      var caretPos = CaretPosition.after(node);
	      var caretWalker = CaretWalker(rootNode);
	      var newCaretPos = caretWalker.prev(caretPos);
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	    var insertMiddle = function (target, elms, rootNode, rng) {
	      var parts = getSplit(target, rng);
	      var parentElm = target.parentNode;
	      parentElm.insertBefore(parts[0], target);
	      Tools.each(elms, function (li) {
	        parentElm.insertBefore(li, target);
	      });
	      parentElm.insertBefore(parts[1], target);
	      parentElm.removeChild(target);
	      return findLastOf(elms[elms.length - 1], rootNode);
	    };
	    var insertBefore$1 = function (target, elms, rootNode) {
	      var parentElm = target.parentNode;
	      Tools.each(elms, function (elm) {
	        parentElm.insertBefore(elm, target);
	      });
	      return findFirstIn(target, rootNode);
	    };
	    var insertAfter$1 = function (target, elms, rootNode, dom) {
	      dom.insertAfter(elms.reverse(), target);
	      return findLastOf(elms[0], rootNode);
	    };
	    var insertAtCaret$1 = function (serializer, dom, rng, fragment) {
	      var domFragment = toDomFragment(dom, serializer, fragment);
	      var liTarget = getParentLi(dom, rng.startContainer);
	      var liElms = trimListItems(listItems(domFragment.firstChild));
	      var BEGINNING = 1, END = 2;
	      var rootNode = dom.getRoot();
	      var isAt = function (location) {
	        var caretPos = CaretPosition.fromRangeStart(rng);
	        var caretWalker = CaretWalker(dom.getRoot());
	        var newPos = location === BEGINNING ? caretWalker.prev(caretPos) : caretWalker.next(caretPos);
	        return newPos ? getParentLi(dom, newPos.getNode()) !== liTarget : true;
	      };
	      if (isAt(BEGINNING)) {
	        return insertBefore$1(liTarget, liElms, rootNode);
	      } else if (isAt(END)) {
	        return insertAfter$1(liTarget, liElms, rootNode, dom);
	      }
	      return insertMiddle(liTarget, liElms, rootNode, rng);
	    };
	
	    var trimOrPadLeftRight = function (dom, rng, html) {
	      var root = SugarElement.fromDom(dom.getRoot());
	      if (needsToBeNbspLeft(root, CaretPosition.fromRangeStart(rng))) {
	        html = html.replace(/^ /, '&nbsp;');
	      } else {
	        html = html.replace(/^&nbsp;/, ' ');
	      }
	      if (needsToBeNbspRight(root, CaretPosition.fromRangeEnd(rng))) {
	        html = html.replace(/(&nbsp;| )(<br( \/)>)?$/, '&nbsp;');
	      } else {
	        html = html.replace(/&nbsp;(<br( \/)?>)?$/, ' ');
	      }
	      return html;
	    };
	
	    var isTableCell$1 = isTableCell$5;
	    var isTableCellContentSelected = function (dom, rng, cell) {
	      if (cell !== null) {
	        var endCell = dom.getParent(rng.endContainer, isTableCell$1);
	        return cell === endCell && hasAllContentsSelected(SugarElement.fromDom(cell), rng);
	      } else {
	        return false;
	      }
	    };
	    var validInsertion = function (editor, value, parentNode) {
	      if (parentNode.getAttribute('data-mce-bogus') === 'all') {
	        parentNode.parentNode.insertBefore(editor.dom.createFragment(value), parentNode);
	      } else {
	        var node = parentNode.firstChild;
	        var node2 = parentNode.lastChild;
	        if (!node || node === node2 && node.nodeName === 'BR') {
	          editor.dom.setHTML(parentNode, value);
	        } else {
	          editor.selection.setContent(value);
	        }
	      }
	    };
	    var trimBrsFromTableCell = function (dom, elm) {
	      Optional.from(dom.getParent(elm, 'td,th')).map(SugarElement.fromDom).each(trimBlockTrailingBr);
	    };
	    var reduceInlineTextElements = function (editor, merge) {
	      var textInlineElements = editor.schema.getTextInlineElements();
	      var dom = editor.dom;
	      if (merge) {
	        var root_1 = editor.getBody();
	        var elementUtils_1 = ElementUtils(dom);
	        Tools.each(dom.select('*[data-mce-fragment]'), function (node) {
	          var isInline = isNonNullable(textInlineElements[node.nodeName.toLowerCase()]);
	          if (isInline && hasInheritableStyles(dom, node)) {
	            for (var parentNode = node.parentNode; isNonNullable(parentNode) && parentNode !== root_1; parentNode = parentNode.parentNode) {
	              var styleConflict = hasStyleConflict(dom, node, parentNode);
	              if (styleConflict) {
	                break;
	              }
	              if (elementUtils_1.compare(parentNode, node)) {
	                dom.remove(node, true);
	                break;
	              }
	            }
	          }
	        });
	      }
	    };
	    var markFragmentElements = function (fragment) {
	      var node = fragment;
	      while (node = node.walk()) {
	        if (node.type === 1) {
	          node.attr('data-mce-fragment', '1');
	        }
	      }
	    };
	    var unmarkFragmentElements = function (elm) {
	      Tools.each(elm.getElementsByTagName('*'), function (elm) {
	        elm.removeAttribute('data-mce-fragment');
	      });
	    };
	    var isPartOfFragment = function (node) {
	      return !!node.getAttribute('data-mce-fragment');
	    };
	    var canHaveChildren = function (editor, node) {
	      return node && !editor.schema.getShortEndedElements()[node.nodeName];
	    };
	    var moveSelectionToMarker = function (editor, marker) {
	      var nextRng;
	      var dom = editor.dom;
	      var selection = editor.selection;
	      if (!marker) {
	        return;
	      }
	      selection.scrollIntoView(marker);
	      var parentEditableElm = getContentEditableRoot$1(editor.getBody(), marker);
	      if (dom.getContentEditable(parentEditableElm) === 'false') {
	        dom.remove(marker);
	        selection.select(parentEditableElm);
	        return;
	      }
	      var rng = dom.createRng();
	      var node = marker.previousSibling;
	      if (isText$7(node)) {
	        rng.setStart(node, node.nodeValue.length);
	        if (!Env.ie) {
	          var node2 = marker.nextSibling;
	          if (isText$7(node2)) {
	            node.appendData(node2.data);
	            node2.parentNode.removeChild(node2);
	          }
	        }
	      } else {
	        rng.setStartBefore(marker);
	        rng.setEndBefore(marker);
	      }
	      var findNextCaretRng = function (rng) {
	        var caretPos = CaretPosition.fromRangeStart(rng);
	        var caretWalker = CaretWalker(editor.getBody());
	        caretPos = caretWalker.next(caretPos);
	        if (caretPos) {
	          return caretPos.toRange();
	        }
	      };
	      var parentBlock = dom.getParent(marker, dom.isBlock);
	      dom.remove(marker);
	      if (parentBlock && dom.isEmpty(parentBlock)) {
	        editor.$(parentBlock).empty();
	        rng.setStart(parentBlock, 0);
	        rng.setEnd(parentBlock, 0);
	        if (!isTableCell$1(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
	          rng = nextRng;
	          dom.remove(parentBlock);
	        } else {
	          dom.add(parentBlock, dom.create('br', { 'data-mce-bogus': '1' }));
	        }
	      }
	      selection.setRng(rng);
	    };
	    var deleteSelectedContent = function (editor) {
	      var dom = editor.dom;
	      var rng = normalize(editor.selection.getRng());
	      editor.selection.setRng(rng);
	      var startCell = dom.getParent(rng.startContainer, isTableCell$1);
	      if (isTableCellContentSelected(dom, rng, startCell)) {
	        deleteCellContents(editor, rng, SugarElement.fromDom(startCell));
	      } else {
	        editor.getDoc().execCommand('Delete', false, null);
	      }
	    };
	    var insertHtmlAtCaret = function (editor, value, details) {
	      var parentNode;
	      var rng, node;
	      var selection = editor.selection;
	      var dom = editor.dom;
	      if (/^ | $/.test(value)) {
	        value = trimOrPadLeftRight(dom, selection.getRng(), value);
	      }
	      var parser = editor.parser;
	      var merge = details.merge;
	      var serializer = HtmlSerializer({ validate: shouldValidate(editor) }, editor.schema);
	      var bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;</span>';
	      var args = editor.fire('BeforeSetContent', {
	        content: value,
	        format: 'html',
	        selection: true,
	        paste: details.paste
	      });
	      if (args.isDefaultPrevented()) {
	        editor.fire('SetContent', {
	          content: args.content,
	          format: 'html',
	          selection: true,
	          paste: details.paste
	        });
	        return;
	      }
	      value = args.content;
	      if (value.indexOf('{$caret}') === -1) {
	        value += '{$caret}';
	      }
	      value = value.replace(/\{\$caret\}/, bookmarkHtml);
	      rng = selection.getRng();
	      var caretElement = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
	      var body = editor.getBody();
	      if (caretElement === body && selection.isCollapsed()) {
	        if (dom.isBlock(body.firstChild) && canHaveChildren(editor, body.firstChild) && dom.isEmpty(body.firstChild)) {
	          rng = dom.createRng();
	          rng.setStart(body.firstChild, 0);
	          rng.setEnd(body.firstChild, 0);
	          selection.setRng(rng);
	        }
	      }
	      if (!selection.isCollapsed()) {
	        deleteSelectedContent(editor);
	      }
	      parentNode = selection.getNode();
	      var parserArgs = {
	        context: parentNode.nodeName.toLowerCase(),
	        data: details.data,
	        insert: true
	      };
	      var fragment = parser.parse(value, parserArgs);
	      if (details.paste === true && isListFragment(editor.schema, fragment) && isParentBlockLi(dom, parentNode)) {
	        rng = insertAtCaret$1(serializer, dom, selection.getRng(), fragment);
	        selection.setRng(rng);
	        editor.fire('SetContent', args);
	        return;
	      }
	      markFragmentElements(fragment);
	      node = fragment.lastChild;
	      if (node.attr('id') === 'mce_marker') {
	        var marker = node;
	        for (node = node.prev; node; node = node.walk(true)) {
	          if (node.type === 3 || !dom.isBlock(node.name)) {
	            if (editor.schema.isValidChild(node.parent.name, 'span')) {
	              node.parent.insert(marker, node, node.name === 'br');
	            }
	            break;
	          }
	        }
	      }
	      editor._selectionOverrides.showBlockCaretContainer(parentNode);
	      if (!parserArgs.invalid) {
	        value = serializer.serialize(fragment);
	        validInsertion(editor, value, parentNode);
	      } else {
	        editor.selection.setContent(bookmarkHtml);
	        parentNode = selection.getNode();
	        var rootNode = editor.getBody();
	        if (parentNode.nodeType === 9) {
	          parentNode = node = rootNode;
	        } else {
	          node = parentNode;
	        }
	        while (node !== rootNode) {
	          parentNode = node;
	          node = node.parentNode;
	        }
	        value = parentNode === rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
	        value = serializer.serialize(parser.parse(value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function () {
	          return serializer.serialize(fragment);
	        })));
	        if (parentNode === rootNode) {
	          dom.setHTML(rootNode, value);
	        } else {
	          dom.setOuterHTML(parentNode, value);
	        }
	      }
	      reduceInlineTextElements(editor, merge);
	      moveSelectionToMarker(editor, dom.get('mce_marker'));
	      unmarkFragmentElements(editor.getBody());
	      trimBrsFromTableCell(dom, selection.getStart());
	      editor.fire('SetContent', args);
	      editor.addVisual();
	    };
	
	    var traverse = function (node, fn) {
	      fn(node);
	      if (node.firstChild) {
	        traverse(node.firstChild, fn);
	      }
	      if (node.next) {
	        traverse(node.next, fn);
	      }
	    };
	    var findMatchingNodes = function (nodeFilters, attributeFilters, node) {
	      var nodeMatches = {};
	      var attrMatches = {};
	      var matches = [];
	      if (node.firstChild) {
	        traverse(node.firstChild, function (node) {
	          each$k(nodeFilters, function (filter) {
	            if (filter.name === node.name) {
	              if (nodeMatches[filter.name]) {
	                nodeMatches[filter.name].nodes.push(node);
	              } else {
	                nodeMatches[filter.name] = {
	                  filter: filter,
	                  nodes: [node]
	                };
	              }
	            }
	          });
	          each$k(attributeFilters, function (filter) {
	            if (typeof node.attr(filter.name) === 'string') {
	              if (attrMatches[filter.name]) {
	                attrMatches[filter.name].nodes.push(node);
	              } else {
	                attrMatches[filter.name] = {
	                  filter: filter,
	                  nodes: [node]
	                };
	              }
	            }
	          });
	        });
	      }
	      for (var name_1 in nodeMatches) {
	        if (has$2(nodeMatches, name_1)) {
	          matches.push(nodeMatches[name_1]);
	        }
	      }
	      for (var name_2 in attrMatches) {
	        if (has$2(attrMatches, name_2)) {
	          matches.push(attrMatches[name_2]);
	        }
	      }
	      return matches;
	    };
	    var filter$1 = function (nodeFilters, attributeFilters, node) {
	      var matches = findMatchingNodes(nodeFilters, attributeFilters, node);
	      each$k(matches, function (match) {
	        each$k(match.filter.callbacks, function (callback) {
	          callback(match.nodes, match.filter.name, {});
	        });
	      });
	    };
	
	    var defaultFormat$1 = 'html';
	    var isTreeNode = function (content) {
	      return content instanceof AstNode;
	    };
	    var moveSelection = function (editor) {
	      if (hasFocus(editor)) {
	        firstPositionIn(editor.getBody()).each(function (pos) {
	          var node = pos.getNode();
	          var caretPos = isTable$3(node) ? firstPositionIn(node).getOr(pos) : pos;
	          editor.selection.setRng(caretPos.toRange());
	        });
	      }
	    };
	    var setEditorHtml = function (editor, html, noSelection) {
	      editor.dom.setHTML(editor.getBody(), html);
	      if (noSelection !== true) {
	        moveSelection(editor);
	      }
	    };
	    var setContentString = function (editor, body, content, args) {
	      if (content.length === 0 || /^\s+$/.test(content)) {
	        var padd = '<br data-mce-bogus="1">';
	        if (body.nodeName === 'TABLE') {
	          content = '<tr><td>' + padd + '</td></tr>';
	        } else if (/^(UL|OL)$/.test(body.nodeName)) {
	          content = '<li>' + padd + '</li>';
	        }
	        var forcedRootBlockName = getForcedRootBlock(editor);
	        if (forcedRootBlockName && editor.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
	          content = padd;
	          content = editor.dom.createHTML(forcedRootBlockName, getForcedRootBlockAttrs(editor), content);
	        } else if (!content) {
	          content = '<br data-mce-bogus="1">';
	        }
	        setEditorHtml(editor, content, args.no_selection);
	        editor.fire('SetContent', args);
	      } else {
	        if (args.format !== 'raw') {
	          content = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(editor.parser.parse(content, {
	            isRootContent: true,
	            insert: true
	          }));
	        }
	        args.content = isWsPreserveElement(SugarElement.fromDom(body)) ? content : Tools.trim(content);
	        setEditorHtml(editor, args.content, args.no_selection);
	        if (!args.no_events) {
	          editor.fire('SetContent', args);
	        }
	      }
	      return args.content;
	    };
	    var setContentTree = function (editor, body, content, args) {
	      filter$1(editor.parser.getNodeFilters(), editor.parser.getAttributeFilters(), content);
	      var html = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(content);
	      args.content = isWsPreserveElement(SugarElement.fromDom(body)) ? html : Tools.trim(html);
	      setEditorHtml(editor, args.content, args.no_selection);
	      if (!args.no_events) {
	        editor.fire('SetContent', args);
	      }
	      return content;
	    };
	    var setupArgs$2 = function (args, content) {
	      return __assign(__assign({ format: defaultFormat$1 }, args), {
	        set: true,
	        content: isTreeNode(content) ? '' : content
	      });
	    };
	    var setContentInternal = function (editor, content, args) {
	      var defaultedArgs = setupArgs$2(args, content);
	      var updatedArgs = args.no_events ? defaultedArgs : editor.fire('BeforeSetContent', defaultedArgs);
	      if (!isTreeNode(content)) {
	        content = updatedArgs.content;
	      }
	      return Optional.from(editor.getBody()).fold(constant(content), function (body) {
	        return isTreeNode(content) ? setContentTree(editor, body, content, updatedArgs) : setContentString(editor, body, content, updatedArgs);
	      });
	    };
	
	    var sibling = function (scope, predicate) {
	      return sibling$2(scope, predicate).isSome();
	    };
	
	    var ensureIsRoot = function (isRoot) {
	      return isFunction(isRoot) ? isRoot : never;
	    };
	    var ancestor = function (scope, transform, isRoot) {
	      var element = scope.dom;
	      var stop = ensureIsRoot(isRoot);
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        var transformed = transform(el);
	        if (transformed.isSome()) {
	          return transformed;
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest$1 = function (scope, transform, isRoot) {
	      var current = transform(scope);
	      var stop = ensureIsRoot(isRoot);
	      return current.orThunk(function () {
	        return stop(scope) ? Optional.none() : ancestor(scope, transform, stop);
	      });
	    };
	
	    var isEq$3 = isEq$5;
	    var matchesUnInheritedFormatSelector = function (ed, node, name) {
	      var formatList = ed.formatter.get(name);
	      if (formatList) {
	        for (var i = 0; i < formatList.length; i++) {
	          var format = formatList[i];
	          if (isSelectorFormat(format) && format.inherit === false && ed.dom.is(node, format.selector)) {
	            return true;
	          }
	        }
	      }
	      return false;
	    };
	    var matchParents = function (editor, node, name, vars, similar) {
	      var root = editor.dom.getRoot();
	      if (node === root) {
	        return false;
	      }
	      node = editor.dom.getParent(node, function (node) {
	        if (matchesUnInheritedFormatSelector(editor, node, name)) {
	          return true;
	        }
	        return node.parentNode === root || !!matchNode(editor, node, name, vars, true);
	      });
	      return !!matchNode(editor, node, name, vars, similar);
	    };
	    var matchName$1 = function (dom, node, format) {
	      if (isEq$3(node, format.inline)) {
	        return true;
	      }
	      if (isEq$3(node, format.block)) {
	        return true;
	      }
	      if (format.selector) {
	        return node.nodeType === 1 && dom.is(node, format.selector);
	      }
	    };
	    var matchItems = function (dom, node, format, itemName, similar, vars) {
	      var items = format[itemName];
	      if (isFunction(format.onmatch)) {
	        return format.onmatch(node, format, itemName);
	      }
	      if (items) {
	        if (isUndefined(items.length)) {
	          for (var key in items) {
	            if (has$2(items, key)) {
	              var value = itemName === 'attributes' ? dom.getAttrib(node, key) : getStyle(dom, node, key);
	              var expectedValue = replaceVars(items[key], vars);
	              var isEmptyValue = isNullable(value) || isEmpty$3(value);
	              if (isEmptyValue && isNullable(expectedValue)) {
	                continue;
	              }
	              if (similar && isEmptyValue && !format.exact) {
	                return false;
	              }
	              if ((!similar || format.exact) && !isEq$3(value, normalizeStyleValue(dom, expectedValue, key))) {
	                return false;
	              }
	            }
	          }
	        } else {
	          for (var i = 0; i < items.length; i++) {
	            if (itemName === 'attributes' ? dom.getAttrib(node, items[i]) : getStyle(dom, node, items[i])) {
	              return true;
	            }
	          }
	        }
	      }
	      return true;
	    };
	    var matchNode = function (ed, node, name, vars, similar) {
	      var formatList = ed.formatter.get(name);
	      var dom = ed.dom;
	      if (formatList && node) {
	        for (var i = 0; i < formatList.length; i++) {
	          var format = formatList[i];
	          if (matchName$1(ed.dom, node, format) && matchItems(dom, node, format, 'attributes', similar, vars) && matchItems(dom, node, format, 'styles', similar, vars)) {
	            var classes = format.classes;
	            if (classes) {
	              for (var x = 0; x < classes.length; x++) {
	                if (!ed.dom.hasClass(node, replaceVars(classes[x], vars))) {
	                  return;
	                }
	              }
	            }
	            return format;
	          }
	        }
	      }
	    };
	    var match$2 = function (editor, name, vars, node, similar) {
	      if (node) {
	        return matchParents(editor, node, name, vars, similar);
	      }
	      node = editor.selection.getNode();
	      if (matchParents(editor, node, name, vars, similar)) {
	        return true;
	      }
	      var startNode = editor.selection.getStart();
	      if (startNode !== node) {
	        if (matchParents(editor, startNode, name, vars, similar)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var matchAll = function (editor, names, vars) {
	      var matchedFormatNames = [];
	      var checkedMap = {};
	      var startElement = editor.selection.getStart();
	      editor.dom.getParent(startElement, function (node) {
	        for (var i = 0; i < names.length; i++) {
	          var name_1 = names[i];
	          if (!checkedMap[name_1] && matchNode(editor, node, name_1, vars)) {
	            checkedMap[name_1] = true;
	            matchedFormatNames.push(name_1);
	          }
	        }
	      }, editor.dom.getRoot());
	      return matchedFormatNames;
	    };
	    var closest = function (editor, names) {
	      var isRoot = function (elm) {
	        return eq(elm, SugarElement.fromDom(editor.getBody()));
	      };
	      var match = function (elm, name) {
	        return matchNode(editor, elm.dom, name) ? Optional.some(name) : Optional.none();
	      };
	      return Optional.from(editor.selection.getStart(true)).bind(function (rawElm) {
	        return closest$1(SugarElement.fromDom(rawElm), function (elm) {
	          return findMap(names, function (name) {
	            return match(elm, name);
	          });
	        }, isRoot);
	      }).getOrNull();
	    };
	    var canApply = function (editor, name) {
	      var formatList = editor.formatter.get(name);
	      var dom = editor.dom;
	      if (formatList) {
	        var startNode = editor.selection.getStart();
	        var parents = getParents$2(dom, startNode);
	        for (var x = formatList.length - 1; x >= 0; x--) {
	          var format = formatList[x];
	          if (!isSelectorFormat(format) || isNonNullable(format.defaultBlock)) {
	            return true;
	          }
	          for (var i = parents.length - 1; i >= 0; i--) {
	            if (dom.is(parents[i], format.selector)) {
	              return true;
	            }
	          }
	        }
	      }
	      return false;
	    };
	    var matchAllOnNode = function (editor, node, formatNames) {
	      return foldl(formatNames, function (acc, name) {
	        var matchSimilar = isVariableFormatName(editor, name);
	        if (editor.formatter.matchNode(node, name, {}, matchSimilar)) {
	          return acc.concat([name]);
	        } else {
	          return acc;
	        }
	      }, []);
	    };
	
	    var ZWSP = ZWSP$1, CARET_ID = '_mce_caret';
	    var importNode = function (ownerDocument, node) {
	      return ownerDocument.importNode(node, true);
	    };
	    var getEmptyCaretContainers = function (node) {
	      var nodes = [];
	      while (node) {
	        if (node.nodeType === 3 && node.nodeValue !== ZWSP || node.childNodes.length > 1) {
	          return [];
	        }
	        if (node.nodeType === 1) {
	          nodes.push(node);
	        }
	        node = node.firstChild;
	      }
	      return nodes;
	    };
	    var isCaretContainerEmpty = function (node) {
	      return getEmptyCaretContainers(node).length > 0;
	    };
	    var findFirstTextNode = function (node) {
	      if (node) {
	        var walker = new DomTreeWalker(node, node);
	        for (node = walker.current(); node; node = walker.next()) {
	          if (isText$7(node)) {
	            return node;
	          }
	        }
	      }
	      return null;
	    };
	    var createCaretContainer = function (fill) {
	      var caretContainer = SugarElement.fromTag('span');
	      setAll$1(caretContainer, {
	        'id': CARET_ID,
	        'data-mce-bogus': '1',
	        'data-mce-type': 'format-caret'
	      });
	      if (fill) {
	        append$1(caretContainer, SugarElement.fromText(ZWSP));
	      }
	      return caretContainer;
	    };
	    var trimZwspFromCaretContainer = function (caretContainerNode) {
	      var textNode = findFirstTextNode(caretContainerNode);
	      if (textNode && textNode.nodeValue.charAt(0) === ZWSP) {
	        textNode.deleteData(0, 1);
	      }
	      return textNode;
	    };
	    var removeCaretContainerNode = function (editor, node, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var dom = editor.dom, selection = editor.selection;
	      if (isCaretContainerEmpty(node)) {
	        deleteElement$2(editor, false, SugarElement.fromDom(node), moveCaret);
	      } else {
	        var rng = selection.getRng();
	        var block = dom.getParent(node, dom.isBlock);
	        var startContainer = rng.startContainer;
	        var startOffset = rng.startOffset;
	        var endContainer = rng.endContainer;
	        var endOffset = rng.endOffset;
	        var textNode = trimZwspFromCaretContainer(node);
	        dom.remove(node, true);
	        if (startContainer === textNode && startOffset > 0) {
	          rng.setStart(textNode, startOffset - 1);
	        }
	        if (endContainer === textNode && endOffset > 0) {
	          rng.setEnd(textNode, endOffset - 1);
	        }
	        if (block && dom.isEmpty(block)) {
	          fillWithPaddingBr(SugarElement.fromDom(block));
	        }
	        selection.setRng(rng);
	      }
	    };
	    var removeCaretContainer = function (editor, node, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var dom = editor.dom, selection = editor.selection;
	      if (!node) {
	        node = getParentCaretContainer(editor.getBody(), selection.getStart());
	        if (!node) {
	          while (node = dom.get(CARET_ID)) {
	            removeCaretContainerNode(editor, node, false);
	          }
	        }
	      } else {
	        removeCaretContainerNode(editor, node, moveCaret);
	      }
	    };
	    var insertCaretContainerNode = function (editor, caretContainer, formatNode) {
	      var dom = editor.dom, block = dom.getParent(formatNode, curry(isTextBlock$1, editor));
	      if (block && dom.isEmpty(block)) {
	        formatNode.parentNode.replaceChild(caretContainer, formatNode);
	      } else {
	        removeTrailingBr(SugarElement.fromDom(formatNode));
	        if (dom.isEmpty(formatNode)) {
	          formatNode.parentNode.replaceChild(caretContainer, formatNode);
	        } else {
	          dom.insertAfter(caretContainer, formatNode);
	        }
	      }
	    };
	    var appendNode = function (parentNode, node) {
	      parentNode.appendChild(node);
	      return node;
	    };
	    var insertFormatNodesIntoCaretContainer = function (formatNodes, caretContainer) {
	      var innerMostFormatNode = foldr(formatNodes, function (parentNode, formatNode) {
	        return appendNode(parentNode, formatNode.cloneNode(false));
	      }, caretContainer);
	      return appendNode(innerMostFormatNode, innerMostFormatNode.ownerDocument.createTextNode(ZWSP));
	    };
	    var cleanFormatNode = function (editor, caretContainer, formatNode, name, vars, similar) {
	      var formatter = editor.formatter;
	      var dom = editor.dom;
	      var validFormats = filter$4(keys(formatter.get()), function (formatName) {
	        return formatName !== name && !contains$2(formatName, 'removeformat');
	      });
	      var matchedFormats = matchAllOnNode(editor, formatNode, validFormats);
	      var uniqueFormats = filter$4(matchedFormats, function (fmtName) {
	        return !areSimilarFormats(editor, fmtName, name);
	      });
	      if (uniqueFormats.length > 0) {
	        var clonedFormatNode = formatNode.cloneNode(false);
	        dom.add(caretContainer, clonedFormatNode);
	        formatter.remove(name, vars, clonedFormatNode, similar);
	        dom.remove(clonedFormatNode);
	        return Optional.some(clonedFormatNode);
	      } else {
	        return Optional.none();
	      }
	    };
	    var applyCaretFormat = function (editor, name, vars) {
	      var caretContainer, textNode;
	      var selection = editor.selection;
	      var selectionRng = selection.getRng();
	      var offset = selectionRng.startOffset;
	      var container = selectionRng.startContainer;
	      var text = container.nodeValue;
	      caretContainer = getParentCaretContainer(editor.getBody(), selection.getStart());
	      if (caretContainer) {
	        textNode = findFirstTextNode(caretContainer);
	      }
	      var wordcharRegex = /[^\s\u00a0\u00ad\u200b\ufeff]/;
	      if (text && offset > 0 && offset < text.length && wordcharRegex.test(text.charAt(offset)) && wordcharRegex.test(text.charAt(offset - 1))) {
	        var bookmark = selection.getBookmark();
	        selectionRng.collapse(true);
	        var rng = expandRng(editor, selectionRng, editor.formatter.get(name));
	        rng = split(rng);
	        editor.formatter.apply(name, vars, rng);
	        selection.moveToBookmark(bookmark);
	      } else {
	        if (!caretContainer || textNode.nodeValue !== ZWSP) {
	          caretContainer = importNode(editor.getDoc(), createCaretContainer(true).dom);
	          textNode = caretContainer.firstChild;
	          selectionRng.insertNode(caretContainer);
	          offset = 1;
	          editor.formatter.apply(name, vars, caretContainer);
	        } else {
	          editor.formatter.apply(name, vars, caretContainer);
	        }
	        selection.setCursorLocation(textNode, offset);
	      }
	    };
	    var removeCaretFormat = function (editor, name, vars, similar) {
	      var dom = editor.dom;
	      var selection = editor.selection;
	      var hasContentAfter, node, formatNode;
	      var parents = [];
	      var rng = selection.getRng();
	      var container = rng.startContainer;
	      var offset = rng.startOffset;
	      node = container;
	      if (container.nodeType === 3) {
	        if (offset !== container.nodeValue.length) {
	          hasContentAfter = true;
	        }
	        node = node.parentNode;
	      }
	      while (node) {
	        if (matchNode(editor, node, name, vars, similar)) {
	          formatNode = node;
	          break;
	        }
	        if (node.nextSibling) {
	          hasContentAfter = true;
	        }
	        parents.push(node);
	        node = node.parentNode;
	      }
	      if (!formatNode) {
	        return;
	      }
	      if (hasContentAfter) {
	        var bookmark = selection.getBookmark();
	        rng.collapse(true);
	        var expandedRng = expandRng(editor, rng, editor.formatter.get(name), true);
	        expandedRng = split(expandedRng);
	        editor.formatter.remove(name, vars, expandedRng, similar);
	        selection.moveToBookmark(bookmark);
	      } else {
	        var caretContainer = getParentCaretContainer(editor.getBody(), formatNode);
	        var newCaretContainer = createCaretContainer(false).dom;
	        insertCaretContainerNode(editor, newCaretContainer, caretContainer !== null ? caretContainer : formatNode);
	        var cleanedFormatNode = cleanFormatNode(editor, newCaretContainer, formatNode, name, vars, similar);
	        var caretTextNode = insertFormatNodesIntoCaretContainer(parents.concat(cleanedFormatNode.toArray()), newCaretContainer);
	        removeCaretContainerNode(editor, caretContainer, false);
	        selection.setCursorLocation(caretTextNode, 1);
	        if (dom.isEmpty(formatNode)) {
	          dom.remove(formatNode);
	        }
	      }
	    };
	    var disableCaretContainer = function (editor, keyCode) {
	      var selection = editor.selection, body = editor.getBody();
	      removeCaretContainer(editor, null, false);
	      if ((keyCode === 8 || keyCode === 46) && selection.isCollapsed() && selection.getStart().innerHTML === ZWSP) {
	        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
	      }
	      if (keyCode === 37 || keyCode === 39) {
	        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
	      }
	    };
	    var setup$k = function (editor) {
	      editor.on('mouseup keydown', function (e) {
	        disableCaretContainer(editor, e.keyCode);
	      });
	    };
	    var replaceWithCaretFormat = function (targetNode, formatNodes) {
	      var caretContainer = createCaretContainer(false);
	      var innerMost = insertFormatNodesIntoCaretContainer(formatNodes, caretContainer.dom);
	      before$4(SugarElement.fromDom(targetNode), caretContainer);
	      remove$7(SugarElement.fromDom(targetNode));
	      return CaretPosition(innerMost, 0);
	    };
	    var isFormatElement = function (editor, element) {
	      var inlineElements = editor.schema.getTextInlineElements();
	      return has$2(inlineElements, name(element)) && !isCaretNode(element.dom) && !isBogus$2(element.dom);
	    };
	    var isEmptyCaretFormatElement = function (element) {
	      return isCaretNode(element.dom) && isCaretContainerEmpty(element.dom);
	    };
	
	    var postProcessHooks = {};
	    var filter = filter$2;
	    var each$b = each$i;
	    var addPostProcessHook = function (name, hook) {
	      var hooks = postProcessHooks[name];
	      if (!hooks) {
	        postProcessHooks[name] = [];
	      }
	      postProcessHooks[name].push(hook);
	    };
	    var postProcess$1 = function (name, editor) {
	      each$b(postProcessHooks[name], function (hook) {
	        hook(editor);
	      });
	    };
	    addPostProcessHook('pre', function (editor) {
	      var rng = editor.selection.getRng();
	      var blocks;
	      var hasPreSibling = function (pre) {
	        return isPre(pre.previousSibling) && indexOf$1(blocks, pre.previousSibling) !== -1;
	      };
	      var joinPre = function (pre1, pre2) {
	        DomQuery(pre2).remove();
	        DomQuery(pre1).append('<br><br>').append(pre2.childNodes);
	      };
	      var isPre = matchNodeNames(['pre']);
	      if (!rng.collapsed) {
	        blocks = editor.selection.getSelectedBlocks();
	        each$b(filter(filter(blocks, isPre), hasPreSibling), function (pre) {
	          joinPre(pre.previousSibling, pre);
	        });
	      }
	    });
	
	    var each$a = Tools.each;
	    var isElementNode$1 = function (node) {
	      return isElement$5(node) && !isBookmarkNode$1(node) && !isCaretNode(node) && !isBogus$2(node);
	    };
	    var findElementSibling = function (node, siblingName) {
	      for (var sibling = node; sibling; sibling = sibling[siblingName]) {
	        if (isText$7(sibling) && isNotEmpty(sibling.data)) {
	          return node;
	        }
	        if (isElement$5(sibling) && !isBookmarkNode$1(sibling)) {
	          return sibling;
	        }
	      }
	      return node;
	    };
	    var mergeSiblingsNodes = function (dom, prev, next) {
	      var elementUtils = ElementUtils(dom);
	      if (prev && next) {
	        prev = findElementSibling(prev, 'previousSibling');
	        next = findElementSibling(next, 'nextSibling');
	        if (elementUtils.compare(prev, next)) {
	          for (var sibling = prev.nextSibling; sibling && sibling !== next;) {
	            var tmpSibling = sibling;
	            sibling = sibling.nextSibling;
	            prev.appendChild(tmpSibling);
	          }
	          dom.remove(next);
	          Tools.each(Tools.grep(next.childNodes), function (node) {
	            prev.appendChild(node);
	          });
	          return prev;
	        }
	      }
	      return next;
	    };
	    var mergeSiblings = function (dom, format, vars, node) {
	      if (node && format.merge_siblings !== false) {
	        var newNode = mergeSiblingsNodes(dom, getNonWhiteSpaceSibling(node), node);
	        mergeSiblingsNodes(dom, newNode, getNonWhiteSpaceSibling(newNode, true));
	      }
	    };
	    var clearChildStyles = function (dom, format, node) {
	      if (format.clear_child_styles) {
	        var selector = format.links ? '*:not(a)' : '*';
	        each$a(dom.select(selector, node), function (node) {
	          if (isElementNode$1(node)) {
	            each$a(format.styles, function (value, name) {
	              dom.setStyle(node, name, '');
	            });
	          }
	        });
	      }
	    };
	    var processChildElements = function (node, filter, process) {
	      each$a(node.childNodes, function (node) {
	        if (isElementNode$1(node)) {
	          if (filter(node)) {
	            process(node);
	          }
	          if (node.hasChildNodes()) {
	            processChildElements(node, filter, process);
	          }
	        }
	      });
	    };
	    var unwrapEmptySpan = function (dom, node) {
	      if (node.nodeName === 'SPAN' && dom.getAttribs(node).length === 0) {
	        dom.remove(node, true);
	      }
	    };
	    var hasStyle = function (dom, name) {
	      return function (node) {
	        return !!(node && getStyle(dom, node, name));
	      };
	    };
	    var applyStyle = function (dom, name, value) {
	      return function (node) {
	        dom.setStyle(node, name, value);
	        if (node.getAttribute('style') === '') {
	          node.removeAttribute('style');
	        }
	        unwrapEmptySpan(dom, node);
	      };
	    };
	
	    var removeResult = Adt.generate([
	      { keep: [] },
	      { rename: ['name'] },
	      { removed: [] }
	    ]);
	    var MCE_ATTR_RE = /^(src|href|style)$/;
	    var each$9 = Tools.each;
	    var isEq$2 = isEq$5;
	    var isTableCellOrRow = function (node) {
	      return /^(TR|TH|TD)$/.test(node.nodeName);
	    };
	    var isChildOfInlineParent = function (dom, node, parent) {
	      return dom.isChildOf(node, parent) && node !== parent && !dom.isBlock(parent);
	    };
	    var getContainer = function (ed, rng, start) {
	      var container = rng[start ? 'startContainer' : 'endContainer'];
	      var offset = rng[start ? 'startOffset' : 'endOffset'];
	      if (isElement$5(container)) {
	        var lastIdx = container.childNodes.length - 1;
	        if (!start && offset) {
	          offset--;
	        }
	        container = container.childNodes[offset > lastIdx ? lastIdx : offset];
	      }
	      if (isText$7(container) && start && offset >= container.nodeValue.length) {
	        container = new DomTreeWalker(container, ed.getBody()).next() || container;
	      }
	      if (isText$7(container) && !start && offset === 0) {
	        container = new DomTreeWalker(container, ed.getBody()).prev() || container;
	      }
	      return container;
	    };
	    var normalizeTableSelection = function (node, start) {
	      var prop = start ? 'firstChild' : 'lastChild';
	      if (isTableCellOrRow(node) && node[prop]) {
	        var childNode = node[prop];
	        if (node.nodeName === 'TR') {
	          return childNode[prop] || childNode;
	        } else {
	          return childNode;
	        }
	      }
	      return node;
	    };
	    var wrap$1 = function (dom, node, name, attrs) {
	      var wrapper = dom.create(name, attrs);
	      node.parentNode.insertBefore(wrapper, node);
	      wrapper.appendChild(node);
	      return wrapper;
	    };
	    var wrapWithSiblings = function (dom, node, next, name, attrs) {
	      var start = SugarElement.fromDom(node);
	      var wrapper = SugarElement.fromDom(dom.create(name, attrs));
	      var siblings = next ? nextSiblings(start) : prevSiblings(start);
	      append(wrapper, siblings);
	      if (next) {
	        before$4(start, wrapper);
	        prepend(wrapper, start);
	      } else {
	        after$3(start, wrapper);
	        append$1(wrapper, start);
	      }
	      return wrapper.dom;
	    };
	    var matchName = function (dom, node, format) {
	      if (isInlineFormat(format) && isEq$2(node, format.inline)) {
	        return true;
	      }
	      if (isBlockFormat(format) && isEq$2(node, format.block)) {
	        return true;
	      }
	      if (isSelectorFormat(format)) {
	        return isElement$5(node) && dom.is(node, format.selector);
	      }
	    };
	    var isColorFormatAndAnchor = function (node, format) {
	      return format.links && node.nodeName === 'A';
	    };
	    var find = function (dom, node, next, inc) {
	      var sibling = getNonWhiteSpaceSibling(node, next, inc);
	      return isNullable(sibling) || sibling.nodeName === 'BR' || dom.isBlock(sibling);
	    };
	    var removeNode = function (ed, node, format) {
	      var parentNode = node.parentNode;
	      var rootBlockElm;
	      var dom = ed.dom, forcedRootBlock = getForcedRootBlock(ed);
	      if (isBlockFormat(format)) {
	        if (!forcedRootBlock) {
	          if (dom.isBlock(node) && !dom.isBlock(parentNode)) {
	            if (!find(dom, node, false) && !find(dom, node.firstChild, true, true)) {
	              node.insertBefore(dom.create('br'), node.firstChild);
	            }
	            if (!find(dom, node, true) && !find(dom, node.lastChild, false, true)) {
	              node.appendChild(dom.create('br'));
	            }
	          }
	        } else {
	          if (parentNode === dom.getRoot()) {
	            if (!format.list_block || !isEq$2(node, format.list_block)) {
	              each$k(from(node.childNodes), function (node) {
	                if (isValid(ed, forcedRootBlock, node.nodeName.toLowerCase())) {
	                  if (!rootBlockElm) {
	                    rootBlockElm = wrap$1(dom, node, forcedRootBlock);
	                    dom.setAttribs(rootBlockElm, ed.settings.forced_root_block_attrs);
	                  } else {
	                    rootBlockElm.appendChild(node);
	                  }
	                } else {
	                  rootBlockElm = null;
	                }
	              });
	            }
	          }
	        }
	      }
	      if (isMixedFormat(format) && !isEq$2(format.inline, node)) {
	        return;
	      }
	      dom.remove(node, true);
	    };
	    var removeFormatInternal = function (ed, format, vars, node, compareNode) {
	      var stylesModified;
	      var dom = ed.dom;
	      if (!matchName(dom, node, format) && !isColorFormatAndAnchor(node, format)) {
	        return removeResult.keep();
	      }
	      var elm = node;
	      if (isInlineFormat(format) && format.remove === 'all' && isArray$1(format.preserve_attributes)) {
	        var attrsToPreserve = filter$4(dom.getAttribs(elm), function (attr) {
	          return contains$3(format.preserve_attributes, attr.name.toLowerCase());
	        });
	        dom.removeAllAttribs(elm);
	        each$k(attrsToPreserve, function (attr) {
	          return dom.setAttrib(elm, attr.name, attr.value);
	        });
	        if (attrsToPreserve.length > 0) {
	          return removeResult.rename('span');
	        }
	      }
	      if (format.remove !== 'all') {
	        each$9(format.styles, function (value, name) {
	          value = normalizeStyleValue(dom, replaceVars(value, vars), name + '');
	          if (isNumber(name)) {
	            name = value;
	            compareNode = null;
	          }
	          if (format.remove_similar || (!compareNode || isEq$2(getStyle(dom, compareNode, name), value))) {
	            dom.setStyle(elm, name, '');
	          }
	          stylesModified = true;
	        });
	        if (stylesModified && dom.getAttrib(elm, 'style') === '') {
	          elm.removeAttribute('style');
	          elm.removeAttribute('data-mce-style');
	        }
	        each$9(format.attributes, function (value, name) {
	          var valueOut;
	          value = replaceVars(value, vars);
	          if (isNumber(name)) {
	            name = value;
	            compareNode = null;
	          }
	          if (format.remove_similar || (!compareNode || isEq$2(dom.getAttrib(compareNode, name), value))) {
	            if (name === 'class') {
	              value = dom.getAttrib(elm, name);
	              if (value) {
	                valueOut = '';
	                each$k(value.split(/\s+/), function (cls) {
	                  if (/mce\-\w+/.test(cls)) {
	                    valueOut += (valueOut ? ' ' : '') + cls;
	                  }
	                });
	                if (valueOut) {
	                  dom.setAttrib(elm, name, valueOut);
	                  return;
	                }
	              }
	            }
	            if (MCE_ATTR_RE.test(name)) {
	              elm.removeAttribute('data-mce-' + name);
	            }
	            if (name === 'style' && matchNodeNames(['li'])(elm) && dom.getStyle(elm, 'list-style-type') === 'none') {
	              elm.removeAttribute(name);
	              dom.setStyle(elm, 'list-style-type', 'none');
	              return;
	            }
	            if (name === 'class') {
	              elm.removeAttribute('className');
	            }
	            elm.removeAttribute(name);
	          }
	        });
	        each$9(format.classes, function (value) {
	          value = replaceVars(value, vars);
	          if (!compareNode || dom.hasClass(compareNode, value)) {
	            dom.removeClass(elm, value);
	          }
	        });
	        var attrs = dom.getAttribs(elm);
	        for (var i = 0; i < attrs.length; i++) {
	          var attrName = attrs[i].nodeName;
	          if (attrName.indexOf('_') !== 0 && attrName.indexOf('data-') !== 0) {
	            return removeResult.keep();
	          }
	        }
	      }
	      if (format.remove !== 'none') {
	        removeNode(ed, elm, format);
	        return removeResult.removed();
	      }
	      return removeResult.keep();
	    };
	    var removeFormat$1 = function (ed, format, vars, node, compareNode) {
	      return removeFormatInternal(ed, format, vars, node, compareNode).fold(never, function (newName) {
	        ed.dom.rename(node, newName);
	        return true;
	      }, always);
	    };
	    var findFormatRoot = function (editor, container, name, vars, similar) {
	      var formatRoot;
	      each$k(getParents$2(editor.dom, container.parentNode).reverse(), function (parent) {
	        if (!formatRoot && parent.id !== '_start' && parent.id !== '_end') {
	          var format = matchNode(editor, parent, name, vars, similar);
	          if (format && format.split !== false) {
	            formatRoot = parent;
	          }
	        }
	      });
	      return formatRoot;
	    };
	    var removeFormatFromClone = function (editor, format, vars, clone) {
	      return removeFormatInternal(editor, format, vars, clone, clone).fold(constant(clone), function (newName) {
	        var fragment = editor.dom.createFragment();
	        fragment.appendChild(clone);
	        return editor.dom.rename(clone, newName);
	      }, constant(null));
	    };
	    var wrapAndSplit = function (editor, formatList, formatRoot, container, target, split, format, vars) {
	      var clone, lastClone, firstClone;
	      var dom = editor.dom;
	      if (formatRoot) {
	        var formatRootParent = formatRoot.parentNode;
	        for (var parent_1 = container.parentNode; parent_1 && parent_1 !== formatRootParent; parent_1 = parent_1.parentNode) {
	          clone = dom.clone(parent_1, false);
	          for (var i = 0; i < formatList.length; i++) {
	            clone = removeFormatFromClone(editor, formatList[i], vars, clone);
	            if (clone === null) {
	              break;
	            }
	          }
	          if (clone) {
	            if (lastClone) {
	              clone.appendChild(lastClone);
	            }
	            if (!firstClone) {
	              firstClone = clone;
	            }
	            lastClone = clone;
	          }
	        }
	        if (split && (!format.mixed || !dom.isBlock(formatRoot))) {
	          container = dom.split(formatRoot, container);
	        }
	        if (lastClone) {
	          target.parentNode.insertBefore(lastClone, target);
	          firstClone.appendChild(target);
	          if (isInlineFormat(format)) {
	            mergeSiblings(dom, format, vars, lastClone);
	          }
	        }
	      }
	      return container;
	    };
	    var remove$1 = function (ed, name, vars, node, similar) {
	      var formatList = ed.formatter.get(name);
	      var format = formatList[0];
	      var contentEditable = true;
	      var dom = ed.dom;
	      var selection = ed.selection;
	      var splitToFormatRoot = function (container) {
	        var formatRoot = findFormatRoot(ed, container, name, vars, similar);
	        return wrapAndSplit(ed, formatList, formatRoot, container, container, true, format, vars);
	      };
	      var isRemoveBookmarkNode = function (node) {
	        return isBookmarkNode$1(node) && isElement$5(node) && (node.id === '_start' || node.id === '_end');
	      };
	      var removeNodeFormat = function (node) {
	        return exists(formatList, function (fmt) {
	          return removeFormat$1(ed, fmt, vars, node, node);
	        });
	      };
	      var process = function (node) {
	        var lastContentEditable = true;
	        var hasContentEditableState = false;
	        if (isElement$5(node) && dom.getContentEditable(node)) {
	          lastContentEditable = contentEditable;
	          contentEditable = dom.getContentEditable(node) === 'true';
	          hasContentEditableState = true;
	        }
	        var children = from(node.childNodes);
	        if (contentEditable && !hasContentEditableState) {
	          var removed = removeNodeFormat(node);
	          var currentNodeMatches = removed || exists(formatList, function (f) {
	            return matchName$1(dom, node, f);
	          });
	          var parentNode = node.parentNode;
	          if (!currentNodeMatches && isNonNullable(parentNode) && shouldExpandToSelector(format)) {
	            removeNodeFormat(parentNode);
	          }
	        }
	        if (format.deep) {
	          if (children.length) {
	            for (var i = 0; i < children.length; i++) {
	              process(children[i]);
	            }
	            if (hasContentEditableState) {
	              contentEditable = lastContentEditable;
	            }
	          }
	        }
	        var textDecorations = [
	          'underline',
	          'line-through',
	          'overline'
	        ];
	        each$k(textDecorations, function (decoration) {
	          if (isElement$5(node) && ed.dom.getStyle(node, 'text-decoration') === decoration && node.parentNode && getTextDecoration(dom, node.parentNode) === decoration) {
	            removeFormat$1(ed, {
	              deep: false,
	              exact: true,
	              inline: 'span',
	              styles: { textDecoration: decoration }
	            }, null, node);
	          }
	        });
	      };
	      var unwrap = function (start) {
	        var node = dom.get(start ? '_start' : '_end');
	        var out = node[start ? 'firstChild' : 'lastChild'];
	        if (isRemoveBookmarkNode(out)) {
	          out = out[start ? 'firstChild' : 'lastChild'];
	        }
	        if (isText$7(out) && out.data.length === 0) {
	          out = start ? node.previousSibling || node.nextSibling : node.nextSibling || node.previousSibling;
	        }
	        dom.remove(node, true);
	        return out;
	      };
	      var removeRngStyle = function (rng) {
	        var startContainer, endContainer;
	        var expandedRng = expandRng(ed, rng, formatList, rng.collapsed);
	        if (format.split) {
	          expandedRng = split(expandedRng);
	          startContainer = getContainer(ed, expandedRng, true);
	          endContainer = getContainer(ed, expandedRng);
	          if (startContainer !== endContainer) {
	            startContainer = normalizeTableSelection(startContainer, true);
	            endContainer = normalizeTableSelection(endContainer, false);
	            if (isChildOfInlineParent(dom, startContainer, endContainer)) {
	              var marker = Optional.from(startContainer.firstChild).getOr(startContainer);
	              splitToFormatRoot(wrapWithSiblings(dom, marker, true, 'span', {
	                'id': '_start',
	                'data-mce-type': 'bookmark'
	              }));
	              unwrap(true);
	              return;
	            }
	            if (isChildOfInlineParent(dom, endContainer, startContainer)) {
	              var marker = Optional.from(endContainer.lastChild).getOr(endContainer);
	              splitToFormatRoot(wrapWithSiblings(dom, marker, false, 'span', {
	                'id': '_end',
	                'data-mce-type': 'bookmark'
	              }));
	              unwrap(false);
	              return;
	            }
	            startContainer = wrap$1(dom, startContainer, 'span', {
	              'id': '_start',
	              'data-mce-type': 'bookmark'
	            });
	            endContainer = wrap$1(dom, endContainer, 'span', {
	              'id': '_end',
	              'data-mce-type': 'bookmark'
	            });
	            var newRng = dom.createRng();
	            newRng.setStartAfter(startContainer);
	            newRng.setEndBefore(endContainer);
	            walk$2(dom, newRng, function (nodes) {
	              each$k(nodes, function (n) {
	                if (!isBookmarkNode$1(n) && !isBookmarkNode$1(n.parentNode)) {
	                  splitToFormatRoot(n);
	                }
	              });
	            });
	            splitToFormatRoot(startContainer);
	            splitToFormatRoot(endContainer);
	            startContainer = unwrap(true);
	            endContainer = unwrap();
	          } else {
	            startContainer = endContainer = splitToFormatRoot(startContainer);
	          }
	          expandedRng.startContainer = startContainer.parentNode ? startContainer.parentNode : startContainer;
	          expandedRng.startOffset = dom.nodeIndex(startContainer);
	          expandedRng.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
	          expandedRng.endOffset = dom.nodeIndex(endContainer) + 1;
	        }
	        walk$2(dom, expandedRng, function (nodes) {
	          each$k(nodes, process);
	        });
	      };
	      if (node) {
	        if (isNode(node)) {
	          var rng = dom.createRng();
	          rng.setStartBefore(node);
	          rng.setEndAfter(node);
	          removeRngStyle(rng);
	        } else {
	          removeRngStyle(node);
	        }
	        fireFormatRemove(ed, name, node, vars);
	        return;
	      }
	      if (dom.getContentEditable(selection.getNode()) === 'false') {
	        node = selection.getNode();
	        for (var i = 0; i < formatList.length; i++) {
	          if (formatList[i].ceFalseOverride) {
	            if (removeFormat$1(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	        fireFormatRemove(ed, name, node, vars);
	        return;
	      }
	      if (!selection.isCollapsed() || !isInlineFormat(format) || getCellsFromEditor(ed).length) {
	        preserve(selection, true, function () {
	          runOnRanges(ed, removeRngStyle);
	        });
	        if (isInlineFormat(format) && match$2(ed, name, vars, selection.getStart())) {
	          moveStart(dom, selection, selection.getRng());
	        }
	        ed.nodeChanged();
	      } else {
	        removeCaretFormat(ed, name, vars, similar);
	      }
	      fireFormatRemove(ed, name, node, vars);
	    };
	
	    var each$8 = Tools.each;
	    var mergeTextDecorationsAndColor = function (dom, format, vars, node) {
	      var processTextDecorationsAndColor = function (n) {
	        if (n.nodeType === 1 && n.parentNode && n.parentNode.nodeType === 1) {
	          var textDecoration = getTextDecoration(dom, n.parentNode);
	          if (dom.getStyle(n, 'color') && textDecoration) {
	            dom.setStyle(n, 'text-decoration', textDecoration);
	          } else if (dom.getStyle(n, 'text-decoration') === textDecoration) {
	            dom.setStyle(n, 'text-decoration', null);
	          }
	        }
	      };
	      if (format.styles && (format.styles.color || format.styles.textDecoration)) {
	        Tools.walk(node, processTextDecorationsAndColor, 'childNodes');
	        processTextDecorationsAndColor(node);
	      }
	    };
	    var mergeBackgroundColorAndFontSize = function (dom, format, vars, node) {
	      if (format.styles && format.styles.backgroundColor) {
	        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'backgroundColor', replaceVars(format.styles.backgroundColor, vars)));
	      }
	    };
	    var mergeSubSup = function (dom, format, vars, node) {
	      if (isInlineFormat(format) && (format.inline === 'sub' || format.inline === 'sup')) {
	        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'fontSize', ''));
	        dom.remove(dom.select(format.inline === 'sup' ? 'sub' : 'sup', node), true);
	      }
	    };
	    var mergeWithChildren = function (editor, formatList, vars, node) {
	      each$8(formatList, function (format) {
	        if (isInlineFormat(format)) {
	          each$8(editor.dom.select(format.inline, node), function (child) {
	            if (!isElementNode$1(child)) {
	              return;
	            }
	            removeFormat$1(editor, format, vars, child, format.exact ? child : null);
	          });
	        }
	        clearChildStyles(editor.dom, format, node);
	      });
	    };
	    var mergeWithParents = function (editor, format, name, vars, node) {
	      if (matchNode(editor, node.parentNode, name, vars)) {
	        if (removeFormat$1(editor, format, vars, node)) {
	          return;
	        }
	      }
	      if (format.merge_with_parents) {
	        editor.dom.getParent(node.parentNode, function (parent) {
	          if (matchNode(editor, parent, name, vars)) {
	            removeFormat$1(editor, format, vars, node);
	            return true;
	          }
	        });
	      }
	    };
	
	    var each$7 = Tools.each;
	    var isElementNode = function (node) {
	      return isElement$5(node) && !isBookmarkNode$1(node) && !isCaretNode(node) && !isBogus$2(node);
	    };
	    var canFormatBR = function (editor, format, node, parentName) {
	      if (canFormatEmptyLines(editor) && isInlineFormat(format)) {
	        var validBRParentElements = getTextRootBlockElements(editor.schema);
	        var hasCaretNodeSibling = sibling(SugarElement.fromDom(node), function (sibling) {
	          return isCaretNode(sibling.dom);
	        });
	        return hasNonNullableKey(validBRParentElements, parentName) && isEmpty$2(SugarElement.fromDom(node.parentNode), false) && !hasCaretNodeSibling;
	      } else {
	        return false;
	      }
	    };
	    var applyFormat$1 = function (ed, name, vars, node) {
	      var formatList = ed.formatter.get(name);
	      var format = formatList[0];
	      var isCollapsed = !node && ed.selection.isCollapsed();
	      var dom = ed.dom;
	      var selection = ed.selection;
	      var setElementFormat = function (elm, fmt) {
	        if (fmt === void 0) {
	          fmt = format;
	        }
	        if (isFunction(fmt.onformat)) {
	          fmt.onformat(elm, fmt, vars, node);
	        }
	        each$7(fmt.styles, function (value, name) {
	          dom.setStyle(elm, name, replaceVars(value, vars));
	        });
	        if (fmt.styles) {
	          var styleVal = dom.getAttrib(elm, 'style');
	          if (styleVal) {
	            dom.setAttrib(elm, 'data-mce-style', styleVal);
	          }
	        }
	        each$7(fmt.attributes, function (value, name) {
	          dom.setAttrib(elm, name, replaceVars(value, vars));
	        });
	        each$7(fmt.classes, function (value) {
	          value = replaceVars(value, vars);
	          if (!dom.hasClass(elm, value)) {
	            dom.addClass(elm, value);
	          }
	        });
	      };
	      var applyNodeStyle = function (formatList, node) {
	        var found = false;
	        each$7(formatList, function (format) {
	          if (!isSelectorFormat(format)) {
	            return false;
	          }
	          if (isNonNullable(format.collapsed) && format.collapsed !== isCollapsed) {
	            return;
	          }
	          if (dom.is(node, format.selector) && !isCaretNode(node)) {
	            setElementFormat(node, format);
	            found = true;
	            return false;
	          }
	        });
	        return found;
	      };
	      var createWrapElement = function (wrapName) {
	        if (isString$1(wrapName)) {
	          var wrapElm = dom.create(wrapName);
	          setElementFormat(wrapElm);
	          return wrapElm;
	        } else {
	          return null;
	        }
	      };
	      var applyRngStyle = function (dom, rng, nodeSpecific) {
	        var newWrappers = [];
	        var contentEditable = true;
	        var wrapName = format.inline || format.block;
	        var wrapElm = createWrapElement(wrapName);
	        walk$2(dom, rng, function (nodes) {
	          var currentWrapElm;
	          var process = function (node) {
	            var hasContentEditableState = false;
	            var lastContentEditable = contentEditable;
	            var nodeName = node.nodeName.toLowerCase();
	            var parentNode = node.parentNode;
	            var parentName = parentNode.nodeName.toLowerCase();
	            if (isElement$5(node) && dom.getContentEditable(node)) {
	              lastContentEditable = contentEditable;
	              contentEditable = dom.getContentEditable(node) === 'true';
	              hasContentEditableState = true;
	            }
	            if (isBr$5(node) && !canFormatBR(ed, format, node, parentName)) {
	              currentWrapElm = null;
	              if (isBlockFormat(format)) {
	                dom.remove(node);
	              }
	              return;
	            }
	            if (isBlockFormat(format) && format.wrapper && matchNode(ed, node, name, vars)) {
	              currentWrapElm = null;
	              return;
	            }
	            if (contentEditable && !hasContentEditableState && isBlockFormat(format) && !format.wrapper && isTextBlock$1(ed, nodeName) && isValid(ed, parentName, wrapName)) {
	              var elm = dom.rename(node, wrapName);
	              setElementFormat(elm);
	              newWrappers.push(elm);
	              currentWrapElm = null;
	              return;
	            }
	            if (isSelectorFormat(format)) {
	              var found = applyNodeStyle(formatList, node);
	              if (!found && isNonNullable(parentNode) && shouldExpandToSelector(format)) {
	                found = applyNodeStyle(formatList, parentNode);
	              }
	              if (!isInlineFormat(format) || found) {
	                currentWrapElm = null;
	                return;
	              }
	            }
	            if (contentEditable && !hasContentEditableState && isValid(ed, wrapName, nodeName) && isValid(ed, parentName, wrapName) && !(!nodeSpecific && isText$7(node) && isZwsp(node.data)) && !isCaretNode(node) && (!isInlineFormat(format) || !dom.isBlock(node))) {
	              if (!currentWrapElm) {
	                currentWrapElm = dom.clone(wrapElm, false);
	                node.parentNode.insertBefore(currentWrapElm, node);
	                newWrappers.push(currentWrapElm);
	              }
	              currentWrapElm.appendChild(node);
	            } else {
	              currentWrapElm = null;
	              each$k(from(node.childNodes), process);
	              if (hasContentEditableState) {
	                contentEditable = lastContentEditable;
	              }
	              currentWrapElm = null;
	            }
	          };
	          each$k(nodes, process);
	        });
	        if (format.links === true) {
	          each$k(newWrappers, function (node) {
	            var process = function (node) {
	              if (node.nodeName === 'A') {
	                setElementFormat(node, format);
	              }
	              each$k(from(node.childNodes), process);
	            };
	            process(node);
	          });
	        }
	        each$k(newWrappers, function (node) {
	          var getChildCount = function (node) {
	            var count = 0;
	            each$k(node.childNodes, function (node) {
	              if (!isEmptyTextNode$1(node) && !isBookmarkNode$1(node)) {
	                count++;
	              }
	            });
	            return count;
	          };
	          var mergeStyles = function (node) {
	            var childElement = find$3(node.childNodes, isElementNode).filter(function (child) {
	              return matchName$1(dom, child, format);
	            });
	            return childElement.map(function (child) {
	              var clone = dom.clone(child, false);
	              setElementFormat(clone);
	              dom.replace(clone, node, true);
	              dom.remove(child, true);
	              return clone;
	            }).getOr(node);
	          };
	          var childCount = getChildCount(node);
	          if ((newWrappers.length > 1 || !dom.isBlock(node)) && childCount === 0) {
	            dom.remove(node, true);
	            return;
	          }
	          if (isInlineFormat(format) || isBlockFormat(format) && format.wrapper) {
	            if (!format.exact && childCount === 1) {
	              node = mergeStyles(node);
	            }
	            mergeWithChildren(ed, formatList, vars, node);
	            mergeWithParents(ed, format, name, vars, node);
	            mergeBackgroundColorAndFontSize(dom, format, vars, node);
	            mergeTextDecorationsAndColor(dom, format, vars, node);
	            mergeSubSup(dom, format, vars, node);
	            mergeSiblings(dom, format, vars, node);
	          }
	        });
	      };
	      if (dom.getContentEditable(selection.getNode()) === 'false') {
	        node = selection.getNode();
	        for (var i = 0, l = formatList.length; i < l; i++) {
	          var formatItem = formatList[i];
	          if (formatItem.ceFalseOverride && isSelectorFormat(formatItem) && dom.is(node, formatItem.selector)) {
	            setElementFormat(node, formatItem);
	            break;
	          }
	        }
	        fireFormatApply(ed, name, node, vars);
	        return;
	      }
	      if (format) {
	        if (node) {
	          if (isNode(node)) {
	            if (!applyNodeStyle(formatList, node)) {
	              var rng = dom.createRng();
	              rng.setStartBefore(node);
	              rng.setEndAfter(node);
	              applyRngStyle(dom, expandRng(ed, rng, formatList), true);
	            }
	          } else {
	            applyRngStyle(dom, node, true);
	          }
	        } else {
	          if (!isCollapsed || !isInlineFormat(format) || getCellsFromEditor(ed).length) {
	            var curSelNode = selection.getNode();
	            var firstFormat = formatList[0];
	            if (!ed.settings.forced_root_block && firstFormat.defaultBlock && !dom.getParent(curSelNode, dom.isBlock)) {
	              applyFormat$1(ed, firstFormat.defaultBlock);
	            }
	            selection.setRng(normalize(selection.getRng()));
	            preserve(selection, true, function () {
	              runOnRanges(ed, function (selectionRng, fake) {
	                var expandedRng = fake ? selectionRng : expandRng(ed, selectionRng, formatList);
	                applyRngStyle(dom, expandedRng, false);
	              });
	            });
	            moveStart(dom, selection, selection.getRng());
	            ed.nodeChanged();
	          } else {
	            applyCaretFormat(ed, name, vars);
	          }
	        }
	        postProcess$1(name, ed);
	      }
	      fireFormatApply(ed, name, node, vars);
	    };
	
	    var hasVars = function (value) {
	      return has$2(value, 'vars');
	    };
	    var setup$j = function (registeredFormatListeners, editor) {
	      registeredFormatListeners.set({});
	      editor.on('NodeChange', function (e) {
	        updateAndFireChangeCallbacks(editor, e.element, registeredFormatListeners.get());
	      });
	      editor.on('FormatApply FormatRemove', function (e) {
	        var element = Optional.from(e.node).map(function (nodeOrRange) {
	          return isNode(nodeOrRange) ? nodeOrRange : nodeOrRange.startContainer;
	        }).bind(function (node) {
	          return isElement$5(node) ? Optional.some(node) : Optional.from(node.parentElement);
	        }).getOrThunk(function () {
	          return fallbackElement(editor);
	        });
	        updateAndFireChangeCallbacks(editor, element, registeredFormatListeners.get());
	      });
	    };
	    var fallbackElement = function (editor) {
	      return editor.selection.getStart();
	    };
	    var matchingNode = function (editor, parents, format, similar, vars) {
	      var isMatchingNode = function (node) {
	        var matchingFormat = editor.formatter.matchNode(node, format, vars !== null && vars !== void 0 ? vars : {}, similar);
	        return !isUndefined(matchingFormat);
	      };
	      var isUnableToMatch = function (node) {
	        if (matchesUnInheritedFormatSelector(editor, node, format)) {
	          return true;
	        } else {
	          if (!similar) {
	            return isNonNullable(editor.formatter.matchNode(node, format, vars, true));
	          } else {
	            return false;
	          }
	        }
	      };
	      return findUntil$1(parents, isMatchingNode, isUnableToMatch);
	    };
	    var getParents = function (editor, elm) {
	      var element = elm !== null && elm !== void 0 ? elm : fallbackElement(editor);
	      return filter$4(getParents$2(editor.dom, element), function (node) {
	        return isElement$5(node) && !isBogus$2(node);
	      });
	    };
	    var updateAndFireChangeCallbacks = function (editor, elm, registeredCallbacks) {
	      var parents = getParents(editor, elm);
	      each$j(registeredCallbacks, function (data, format) {
	        var runIfChanged = function (spec) {
	          var match = matchingNode(editor, parents, format, spec.similar, hasVars(spec) ? spec.vars : undefined);
	          var isSet = match.isSome();
	          if (spec.state.get() !== isSet) {
	            spec.state.set(isSet);
	            var node_1 = match.getOr(elm);
	            if (hasVars(spec)) {
	              spec.callback(isSet, {
	                node: node_1,
	                format: format,
	                parents: parents
	              });
	            } else {
	              each$k(spec.callbacks, function (callback) {
	                return callback(isSet, {
	                  node: node_1,
	                  format: format,
	                  parents: parents
	                });
	              });
	            }
	          }
	        };
	        each$k([
	          data.withSimilar,
	          data.withoutSimilar
	        ], runIfChanged);
	        each$k(data.withVars, runIfChanged);
	      });
	    };
	    var addListeners = function (editor, registeredFormatListeners, formats, callback, similar, vars) {
	      var formatChangeItems = registeredFormatListeners.get();
	      each$k(formats.split(','), function (format) {
	        var group = get$9(formatChangeItems, format).getOrThunk(function () {
	          var base = {
	            withSimilar: {
	              state: Cell(false),
	              similar: true,
	              callbacks: []
	            },
	            withoutSimilar: {
	              state: Cell(false),
	              similar: false,
	              callbacks: []
	            },
	            withVars: []
	          };
	          formatChangeItems[format] = base;
	          return base;
	        });
	        var getCurrent = function () {
	          var parents = getParents(editor);
	          return matchingNode(editor, parents, format, similar, vars).isSome();
	        };
	        if (isUndefined(vars)) {
	          var toAppendTo = similar ? group.withSimilar : group.withoutSimilar;
	          toAppendTo.callbacks.push(callback);
	          if (toAppendTo.callbacks.length === 1) {
	            toAppendTo.state.set(getCurrent());
	          }
	        } else {
	          group.withVars.push({
	            state: Cell(getCurrent()),
	            similar: similar,
	            vars: vars,
	            callback: callback
	          });
	        }
	      });
	      registeredFormatListeners.set(formatChangeItems);
	    };
	    var removeListeners = function (registeredFormatListeners, formats, callback) {
	      var formatChangeItems = registeredFormatListeners.get();
	      each$k(formats.split(','), function (format) {
	        return get$9(formatChangeItems, format).each(function (group) {
	          formatChangeItems[format] = {
	            withSimilar: __assign(__assign({}, group.withSimilar), {
	              callbacks: filter$4(group.withSimilar.callbacks, function (cb) {
	                return cb !== callback;
	              })
	            }),
	            withoutSimilar: __assign(__assign({}, group.withoutSimilar), {
	              callbacks: filter$4(group.withoutSimilar.callbacks, function (cb) {
	                return cb !== callback;
	              })
	            }),
	            withVars: filter$4(group.withVars, function (item) {
	              return item.callback !== callback;
	            })
	          };
	        });
	      });
	      registeredFormatListeners.set(formatChangeItems);
	    };
	    var formatChangedInternal = function (editor, registeredFormatListeners, formats, callback, similar, vars) {
	      if (registeredFormatListeners.get() === null) {
	        setup$j(registeredFormatListeners, editor);
	      }
	      addListeners(editor, registeredFormatListeners, formats, callback, similar, vars);
	      return {
	        unbind: function () {
	          return removeListeners(registeredFormatListeners, formats, callback);
	        }
	      };
	    };
	
	    var toggle = function (editor, name, vars, node) {
	      var fmt = editor.formatter.get(name);
	      if (match$2(editor, name, vars, node) && (!('toggle' in fmt[0]) || fmt[0].toggle)) {
	        remove$1(editor, name, vars, node);
	      } else {
	        applyFormat$1(editor, name, vars, node);
	      }
	    };
	
	    var fromElements = function (elements, scope) {
	      var doc = scope || document;
	      var fragment = doc.createDocumentFragment();
	      each$k(elements, function (element) {
	        fragment.appendChild(element.dom);
	      });
	      return SugarElement.fromDom(fragment);
	    };
	
	    var tableModel = function (element, width, rows) {
	      return {
	        element: element,
	        width: width,
	        rows: rows
	      };
	    };
	    var tableRow = function (element, cells) {
	      return {
	        element: element,
	        cells: cells
	      };
	    };
	    var cellPosition = function (x, y) {
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var getSpan = function (td, key) {
	      var value = parseInt(get$6(td, key), 10);
	      return isNaN(value) ? 1 : value;
	    };
	    var fillout = function (table, x, y, tr, td) {
	      var rowspan = getSpan(td, 'rowspan');
	      var colspan = getSpan(td, 'colspan');
	      var rows = table.rows;
	      for (var y2 = y; y2 < y + rowspan; y2++) {
	        if (!rows[y2]) {
	          rows[y2] = tableRow(deep$1(tr), []);
	        }
	        for (var x2 = x; x2 < x + colspan; x2++) {
	          var cells = rows[y2].cells;
	          cells[x2] = y2 === y && x2 === x ? td : shallow(td);
	        }
	      }
	    };
	    var cellExists = function (table, x, y) {
	      var rows = table.rows;
	      var cells = rows[y] ? rows[y].cells : [];
	      return !!cells[x];
	    };
	    var skipCellsX = function (table, x, y) {
	      while (cellExists(table, x, y)) {
	        x++;
	      }
	      return x;
	    };
	    var getWidth = function (rows) {
	      return foldl(rows, function (acc, row) {
	        return row.cells.length > acc ? row.cells.length : acc;
	      }, 0);
	    };
	    var findElementPos = function (table, element) {
	      var rows = table.rows;
	      for (var y = 0; y < rows.length; y++) {
	        var cells = rows[y].cells;
	        for (var x = 0; x < cells.length; x++) {
	          if (eq(cells[x], element)) {
	            return Optional.some(cellPosition(x, y));
	          }
	        }
	      }
	      return Optional.none();
	    };
	    var extractRows = function (table, sx, sy, ex, ey) {
	      var newRows = [];
	      var rows = table.rows;
	      for (var y = sy; y <= ey; y++) {
	        var cells = rows[y].cells;
	        var slice = sx < ex ? cells.slice(sx, ex + 1) : cells.slice(ex, sx + 1);
	        newRows.push(tableRow(rows[y].element, slice));
	      }
	      return newRows;
	    };
	    var subTable = function (table, startPos, endPos) {
	      var sx = startPos.x, sy = startPos.y;
	      var ex = endPos.x, ey = endPos.y;
	      var newRows = sy < ey ? extractRows(table, sx, sy, ex, ey) : extractRows(table, sx, ey, ex, sy);
	      return tableModel(table.element, getWidth(newRows), newRows);
	    };
	    var createDomTable = function (table, rows) {
	      var tableElement = shallow(table.element);
	      var tableBody = SugarElement.fromTag('tbody');
	      append(tableBody, rows);
	      append$1(tableElement, tableBody);
	      return tableElement;
	    };
	    var modelRowsToDomRows = function (table) {
	      return map$3(table.rows, function (row) {
	        var cells = map$3(row.cells, function (cell) {
	          var td = deep$1(cell);
	          remove$6(td, 'colspan');
	          remove$6(td, 'rowspan');
	          return td;
	        });
	        var tr = shallow(row.element);
	        append(tr, cells);
	        return tr;
	      });
	    };
	    var fromDom = function (tableElm) {
	      var table = tableModel(shallow(tableElm), 0, []);
	      each$k(descendants(tableElm, 'tr'), function (tr, y) {
	        each$k(descendants(tr, 'td,th'), function (td, x) {
	          fillout(table, skipCellsX(table, x, y), y, tr, td);
	        });
	      });
	      return tableModel(table.element, getWidth(table.rows), table.rows);
	    };
	    var toDom = function (table) {
	      return createDomTable(table, modelRowsToDomRows(table));
	    };
	    var subsection = function (table, startElement, endElement) {
	      return findElementPos(table, startElement).bind(function (startPos) {
	        return findElementPos(table, endElement).map(function (endPos) {
	          return subTable(table, startPos, endPos);
	        });
	      });
	    };
	
	    var findParentListContainer = function (parents) {
	      return find$3(parents, function (elm) {
	        return name(elm) === 'ul' || name(elm) === 'ol';
	      });
	    };
	    var getFullySelectedListWrappers = function (parents, rng) {
	      return find$3(parents, function (elm) {
	        return name(elm) === 'li' && hasAllContentsSelected(elm, rng);
	      }).fold(constant([]), function (_li) {
	        return findParentListContainer(parents).map(function (listCont) {
	          var listElm = SugarElement.fromTag(name(listCont));
	          var listStyles = filter$3(getAllRaw(listCont), function (_style, name) {
	            return startsWith(name, 'list-style');
	          });
	          setAll(listElm, listStyles);
	          return [
	            SugarElement.fromTag('li'),
	            listElm
	          ];
	        }).getOr([]);
	      });
	    };
	    var wrap = function (innerElm, elms) {
	      var wrapped = foldl(elms, function (acc, elm) {
	        append$1(elm, acc);
	        return elm;
	      }, innerElm);
	      return elms.length > 0 ? fromElements([wrapped]) : wrapped;
	    };
	    var directListWrappers = function (commonAnchorContainer) {
	      if (isListItem(commonAnchorContainer)) {
	        return parent(commonAnchorContainer).filter(isList).fold(constant([]), function (listElm) {
	          return [
	            commonAnchorContainer,
	            listElm
	          ];
	        });
	      } else {
	        return isList(commonAnchorContainer) ? [commonAnchorContainer] : [];
	      }
	    };
	    var getWrapElements = function (rootNode, rng) {
	      var commonAnchorContainer = SugarElement.fromDom(rng.commonAncestorContainer);
	      var parents = parentsAndSelf(commonAnchorContainer, rootNode);
	      var wrapElements = filter$4(parents, function (elm) {
	        return isInline$1(elm) || isHeading(elm);
	      });
	      var listWrappers = getFullySelectedListWrappers(parents, rng);
	      var allWrappers = wrapElements.concat(listWrappers.length ? listWrappers : directListWrappers(commonAnchorContainer));
	      return map$3(allWrappers, shallow);
	    };
	    var emptyFragment = function () {
	      return fromElements([]);
	    };
	    var getFragmentFromRange = function (rootNode, rng) {
	      return wrap(SugarElement.fromDom(rng.cloneContents()), getWrapElements(rootNode, rng));
	    };
	    var getParentTable = function (rootElm, cell) {
	      return ancestor$2(cell, 'table', curry(eq, rootElm));
	    };
	    var getTableFragment = function (rootNode, selectedTableCells) {
	      return getParentTable(rootNode, selectedTableCells[0]).bind(function (tableElm) {
	        var firstCell = selectedTableCells[0];
	        var lastCell = selectedTableCells[selectedTableCells.length - 1];
	        var fullTableModel = fromDom(tableElm);
	        return subsection(fullTableModel, firstCell, lastCell).map(function (sectionedTableModel) {
	          return fromElements([toDom(sectionedTableModel)]);
	        });
	      }).getOrThunk(emptyFragment);
	    };
	    var getSelectionFragment = function (rootNode, ranges) {
	      return ranges.length > 0 && ranges[0].collapsed ? emptyFragment() : getFragmentFromRange(rootNode, ranges[0]);
	    };
	    var read$3 = function (rootNode, ranges) {
	      var selectedCells = getCellsFromElementOrRanges(ranges, rootNode);
	      return selectedCells.length > 0 ? getTableFragment(rootNode, selectedCells) : getSelectionFragment(rootNode, ranges);
	    };
	
	    var trimLeadingCollapsibleText = function (text) {
	      return text.replace(/^[ \f\n\r\t\v]+/, '');
	    };
	    var isCollapsibleWhitespace = function (text, index) {
	      return index >= 0 && index < text.length && isWhiteSpace(text.charAt(index));
	    };
	    var getInnerText = function (bin, shouldTrim) {
	      var text = trim$2(bin.innerText);
	      return shouldTrim ? trimLeadingCollapsibleText(text) : text;
	    };
	    var getContextNodeName = function (parentBlockOpt) {
	      return parentBlockOpt.map(function (block) {
	        return block.nodeName;
	      }).getOr('div').toLowerCase();
	    };
	    var getTextContent = function (editor) {
	      return Optional.from(editor.selection.getRng()).map(function (rng) {
	        var parentBlockOpt = Optional.from(editor.dom.getParent(rng.commonAncestorContainer, editor.dom.isBlock));
	        var body = editor.getBody();
	        var contextNodeName = getContextNodeName(parentBlockOpt);
	        var shouldTrimSpaces = Env.browser.isIE() && contextNodeName !== 'pre';
	        var bin = editor.dom.add(body, contextNodeName, {
	          'data-mce-bogus': 'all',
	          'style': 'overflow: hidden; opacity: 0;'
	        }, rng.cloneContents());
	        var text = getInnerText(bin, shouldTrimSpaces);
	        var nonRenderedText = trim$2(bin.textContent);
	        editor.dom.remove(bin);
	        if (isCollapsibleWhitespace(nonRenderedText, 0) || isCollapsibleWhitespace(nonRenderedText, nonRenderedText.length - 1)) {
	          var parentBlock = parentBlockOpt.getOr(body);
	          var parentBlockText = getInnerText(parentBlock, shouldTrimSpaces);
	          var textIndex = parentBlockText.indexOf(text);
	          if (textIndex === -1) {
	            return text;
	          } else {
	            var hasProceedingSpace = isCollapsibleWhitespace(parentBlockText, textIndex - 1);
	            var hasTrailingSpace = isCollapsibleWhitespace(parentBlockText, textIndex + text.length);
	            return (hasProceedingSpace ? ' ' : '') + text + (hasTrailingSpace ? ' ' : '');
	          }
	        } else {
	          return text;
	        }
	      }).getOr('');
	    };
	    var getSerializedContent = function (editor, args) {
	      var rng = editor.selection.getRng(), tmpElm = editor.dom.create('body');
	      var sel = editor.selection.getSel();
	      var ranges = processRanges(editor, getRanges(sel));
	      var fragment = args.contextual ? read$3(SugarElement.fromDom(editor.getBody()), ranges).dom : rng.cloneContents();
	      if (fragment) {
	        tmpElm.appendChild(fragment);
	      }
	      return editor.selection.serializer.serialize(tmpElm, args);
	    };
	    var setupArgs$1 = function (args, format) {
	      return __assign(__assign({}, args), {
	        format: format,
	        get: true,
	        selection: true
	      });
	    };
	    var getSelectedContentInternal = function (editor, format, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      var defaultedArgs = setupArgs$1(args, format);
	      var updatedArgs = editor.fire('BeforeGetContent', defaultedArgs);
	      if (updatedArgs.isDefaultPrevented()) {
	        editor.fire('GetContent', updatedArgs);
	        return updatedArgs.content;
	      }
	      if (updatedArgs.format === 'text') {
	        return getTextContent(editor);
	      } else {
	        updatedArgs.getInner = true;
	        var content = getSerializedContent(editor, updatedArgs);
	        if (updatedArgs.format === 'tree') {
	          return content;
	        } else {
	          updatedArgs.content = editor.selection.isCollapsed() ? '' : content;
	          editor.fire('GetContent', updatedArgs);
	          return updatedArgs.content;
	        }
	      }
	    };
	
	    var KEEP = 0, INSERT = 1, DELETE = 2;
	    var diff = function (left, right) {
	      var size = left.length + right.length + 2;
	      var vDown = new Array(size);
	      var vUp = new Array(size);
	      var snake = function (start, end, diag) {
	        return {
	          start: start,
	          end: end,
	          diag: diag
	        };
	      };
	      var buildScript = function (start1, end1, start2, end2, script) {
	        var middle = getMiddleSnake(start1, end1, start2, end2);
	        if (middle === null || middle.start === end1 && middle.diag === end1 - end2 || middle.end === start1 && middle.diag === start1 - start2) {
	          var i = start1;
	          var j = start2;
	          while (i < end1 || j < end2) {
	            if (i < end1 && j < end2 && left[i] === right[j]) {
	              script.push([
	                KEEP,
	                left[i]
	              ]);
	              ++i;
	              ++j;
	            } else {
	              if (end1 - start1 > end2 - start2) {
	                script.push([
	                  DELETE,
	                  left[i]
	                ]);
	                ++i;
	              } else {
	                script.push([
	                  INSERT,
	                  right[j]
	                ]);
	                ++j;
	              }
	            }
	          }
	        } else {
	          buildScript(start1, middle.start, start2, middle.start - middle.diag, script);
	          for (var i2 = middle.start; i2 < middle.end; ++i2) {
	            script.push([
	              KEEP,
	              left[i2]
	            ]);
	          }
	          buildScript(middle.end, end1, middle.end - middle.diag, end2, script);
	        }
	      };
	      var buildSnake = function (start, diag, end1, end2) {
	        var end = start;
	        while (end - diag < end2 && end < end1 && left[end] === right[end - diag]) {
	          ++end;
	        }
	        return snake(start, end, diag);
	      };
	      var getMiddleSnake = function (start1, end1, start2, end2) {
	        var m = end1 - start1;
	        var n = end2 - start2;
	        if (m === 0 || n === 0) {
	          return null;
	        }
	        var delta = m - n;
	        var sum = n + m;
	        var offset = (sum % 2 === 0 ? sum : sum + 1) / 2;
	        vDown[1 + offset] = start1;
	        vUp[1 + offset] = end1 + 1;
	        var d, k, i, x, y;
	        for (d = 0; d <= offset; ++d) {
	          for (k = -d; k <= d; k += 2) {
	            i = k + offset;
	            if (k === -d || k !== d && vDown[i - 1] < vDown[i + 1]) {
	              vDown[i] = vDown[i + 1];
	            } else {
	              vDown[i] = vDown[i - 1] + 1;
	            }
	            x = vDown[i];
	            y = x - start1 + start2 - k;
	            while (x < end1 && y < end2 && left[x] === right[y]) {
	              vDown[i] = ++x;
	              ++y;
	            }
	            if (delta % 2 !== 0 && delta - d <= k && k <= delta + d) {
	              if (vUp[i - delta] <= vDown[i]) {
	                return buildSnake(vUp[i - delta], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	          for (k = delta - d; k <= delta + d; k += 2) {
	            i = k + offset - delta;
	            if (k === delta - d || k !== delta + d && vUp[i + 1] <= vUp[i - 1]) {
	              vUp[i] = vUp[i + 1] - 1;
	            } else {
	              vUp[i] = vUp[i - 1];
	            }
	            x = vUp[i] - 1;
	            y = x - start1 + start2 - k;
	            while (x >= start1 && y >= start2 && left[x] === right[y]) {
	              vUp[i] = x--;
	              y--;
	            }
	            if (delta % 2 === 0 && -d <= k && k <= d) {
	              if (vUp[i] <= vDown[i + delta]) {
	                return buildSnake(vUp[i], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	        }
	      };
	      var script = [];
	      buildScript(0, left.length, 0, right.length, script);
	      return script;
	    };
	
	    var getOuterHtml = function (elm) {
	      if (isElement$5(elm)) {
	        return elm.outerHTML;
	      } else if (isText$7(elm)) {
	        return Entities.encodeRaw(elm.data, false);
	      } else if (isComment(elm)) {
	        return '<!--' + elm.data + '-->';
	      }
	      return '';
	    };
	    var createFragment = function (html) {
	      var node;
	      var container = document.createElement('div');
	      var frag = document.createDocumentFragment();
	      if (html) {
	        container.innerHTML = html;
	      }
	      while (node = container.firstChild) {
	        frag.appendChild(node);
	      }
	      return frag;
	    };
	    var insertAt = function (elm, html, index) {
	      var fragment = createFragment(html);
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.insertBefore(fragment, target);
	      } else {
	        elm.appendChild(fragment);
	      }
	    };
	    var removeAt = function (elm, index) {
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.removeChild(target);
	      }
	    };
	    var applyDiff = function (diff, elm) {
	      var index = 0;
	      each$k(diff, function (action) {
	        if (action[0] === KEEP) {
	          index++;
	        } else if (action[0] === INSERT) {
	          insertAt(elm, action[1], index);
	          index++;
	        } else if (action[0] === DELETE) {
	          removeAt(elm, index);
	        }
	      });
	    };
	    var read$2 = function (elm) {
	      return filter$4(map$3(from(elm.childNodes), getOuterHtml), function (item) {
	        return item.length > 0;
	      });
	    };
	    var write = function (fragments, elm) {
	      var currentFragments = map$3(from(elm.childNodes), getOuterHtml);
	      applyDiff(diff(currentFragments, fragments), elm);
	      return elm;
	    };
	
	    var lazyTempDocument = cached(function () {
	      return document.implementation.createHTMLDocument('undo');
	    });
	    var hasIframes = function (html) {
	      return html.indexOf('</iframe>') !== -1;
	    };
	    var createFragmentedLevel = function (fragments) {
	      return {
	        type: 'fragmented',
	        fragments: fragments,
	        content: '',
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	    var createCompleteLevel = function (content) {
	      return {
	        type: 'complete',
	        fragments: null,
	        content: content,
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	    var createFromEditor = function (editor) {
	      var fragments = read$2(editor.getBody());
	      var trimmedFragments = bind(fragments, function (html) {
	        var trimmed = trimInternal(editor.serializer, html);
	        return trimmed.length > 0 ? [trimmed] : [];
	      });
	      var content = trimmedFragments.join('');
	      return hasIframes(content) ? createFragmentedLevel(trimmedFragments) : createCompleteLevel(content);
	    };
	    var applyToEditor = function (editor, level, before) {
	      var bookmark = before ? level.beforeBookmark : level.bookmark;
	      if (level.type === 'fragmented') {
	        write(level.fragments, editor.getBody());
	      } else {
	        editor.setContent(level.content, {
	          format: 'raw',
	          no_selection: isNonNullable(bookmark) && isPathBookmark(bookmark) ? !bookmark.isFakeCaret : true
	        });
	      }
	      editor.selection.moveToBookmark(bookmark);
	    };
	    var getLevelContent = function (level) {
	      return level.type === 'fragmented' ? level.fragments.join('') : level.content;
	    };
	    var getCleanLevelContent = function (level) {
	      var elm = SugarElement.fromTag('body', lazyTempDocument());
	      set(elm, getLevelContent(level));
	      each$k(descendants(elm, '*[data-mce-bogus]'), unwrap);
	      return get$3(elm);
	    };
	    var hasEqualContent = function (level1, level2) {
	      return getLevelContent(level1) === getLevelContent(level2);
	    };
	    var hasEqualCleanedContent = function (level1, level2) {
	      return getCleanLevelContent(level1) === getCleanLevelContent(level2);
	    };
	    var isEq$1 = function (level1, level2) {
	      if (!level1 || !level2) {
	        return false;
	      } else if (hasEqualContent(level1, level2)) {
	        return true;
	      } else {
	        return hasEqualCleanedContent(level1, level2);
	      }
	    };
	
	    var isUnlocked = function (locks) {
	      return locks.get() === 0;
	    };
	
	    var setTyping = function (undoManager, typing, locks) {
	      if (isUnlocked(locks)) {
	        undoManager.typing = typing;
	      }
	    };
	    var endTyping = function (undoManager, locks) {
	      if (undoManager.typing) {
	        setTyping(undoManager, false, locks);
	        undoManager.add();
	      }
	    };
	    var endTypingLevelIgnoreLocks = function (undoManager) {
	      if (undoManager.typing) {
	        undoManager.typing = false;
	        undoManager.add();
	      }
	    };
	
	    var beforeChange$1 = function (editor, locks, beforeBookmark) {
	      if (isUnlocked(locks)) {
	        beforeBookmark.set(getUndoBookmark(editor.selection));
	      }
	    };
	    var addUndoLevel$1 = function (editor, undoManager, index, locks, beforeBookmark, level, event) {
	      var currentLevel = createFromEditor(editor);
	      level = level || {};
	      level = Tools.extend(level, currentLevel);
	      if (isUnlocked(locks) === false || editor.removed) {
	        return null;
	      }
	      var lastLevel = undoManager.data[index.get()];
	      if (editor.fire('BeforeAddUndo', {
	          level: level,
	          lastLevel: lastLevel,
	          originalEvent: event
	        }).isDefaultPrevented()) {
	        return null;
	      }
	      if (lastLevel && isEq$1(lastLevel, level)) {
	        return null;
	      }
	      if (undoManager.data[index.get()]) {
	        beforeBookmark.get().each(function (bm) {
	          undoManager.data[index.get()].beforeBookmark = bm;
	        });
	      }
	      var customUndoRedoLevels = getCustomUndoRedoLevels(editor);
	      if (customUndoRedoLevels) {
	        if (undoManager.data.length > customUndoRedoLevels) {
	          for (var i = 0; i < undoManager.data.length - 1; i++) {
	            undoManager.data[i] = undoManager.data[i + 1];
	          }
	          undoManager.data.length--;
	          index.set(undoManager.data.length);
	        }
	      }
	      level.bookmark = getUndoBookmark(editor.selection);
	      if (index.get() < undoManager.data.length - 1) {
	        undoManager.data.length = index.get() + 1;
	      }
	      undoManager.data.push(level);
	      index.set(undoManager.data.length - 1);
	      var args = {
	        level: level,
	        lastLevel: lastLevel,
	        originalEvent: event
	      };
	      if (index.get() > 0) {
	        editor.setDirty(true);
	        editor.fire('AddUndo', args);
	        editor.fire('change', args);
	      } else {
	        editor.fire('AddUndo', args);
	      }
	      return level;
	    };
	    var clear$1 = function (editor, undoManager, index) {
	      undoManager.data = [];
	      index.set(0);
	      undoManager.typing = false;
	      editor.fire('ClearUndos');
	    };
	    var extra$1 = function (editor, undoManager, index, callback1, callback2) {
	      if (undoManager.transact(callback1)) {
	        var bookmark = undoManager.data[index.get()].bookmark;
	        var lastLevel = undoManager.data[index.get() - 1];
	        applyToEditor(editor, lastLevel, true);
	        if (undoManager.transact(callback2)) {
	          undoManager.data[index.get() - 1].beforeBookmark = bookmark;
	        }
	      }
	    };
	    var redo$1 = function (editor, index, data) {
	      var level;
	      if (index.get() < data.length - 1) {
	        index.set(index.get() + 1);
	        level = data[index.get()];
	        applyToEditor(editor, level, false);
	        editor.setDirty(true);
	        editor.fire('Redo', { level: level });
	      }
	      return level;
	    };
	    var undo$1 = function (editor, undoManager, locks, index) {
	      var level;
	      if (undoManager.typing) {
	        undoManager.add();
	        undoManager.typing = false;
	        setTyping(undoManager, false, locks);
	      }
	      if (index.get() > 0) {
	        index.set(index.get() - 1);
	        level = undoManager.data[index.get()];
	        applyToEditor(editor, level, true);
	        editor.setDirty(true);
	        editor.fire('Undo', { level: level });
	      }
	      return level;
	    };
	    var reset$1 = function (undoManager) {
	      undoManager.clear();
	      undoManager.add();
	    };
	    var hasUndo$1 = function (editor, undoManager, index) {
	      return index.get() > 0 || undoManager.typing && undoManager.data[0] && !isEq$1(createFromEditor(editor), undoManager.data[0]);
	    };
	    var hasRedo$1 = function (undoManager, index) {
	      return index.get() < undoManager.data.length - 1 && !undoManager.typing;
	    };
	    var transact$1 = function (undoManager, locks, callback) {
	      endTyping(undoManager, locks);
	      undoManager.beforeChange();
	      undoManager.ignore(callback);
	      return undoManager.add();
	    };
	    var ignore$1 = function (locks, callback) {
	      try {
	        locks.set(locks.get() + 1);
	        callback();
	      } finally {
	        locks.set(locks.get() - 1);
	      }
	    };
	
	    var addVisualInternal = function (editor, elm) {
	      var dom = editor.dom;
	      var scope = isNonNullable(elm) ? elm : editor.getBody();
	      if (isUndefined(editor.hasVisual)) {
	        editor.hasVisual = isVisualAidsEnabled(editor);
	      }
	      each$k(dom.select('table,a', scope), function (matchedElm) {
	        switch (matchedElm.nodeName) {
	        case 'TABLE':
	          var cls = getVisualAidsTableClass(editor);
	          var value = dom.getAttrib(matchedElm, 'border');
	          if ((!value || value === '0') && editor.hasVisual) {
	            dom.addClass(matchedElm, cls);
	          } else {
	            dom.removeClass(matchedElm, cls);
	          }
	          break;
	        case 'A':
	          if (!dom.getAttrib(matchedElm, 'href')) {
	            var value_1 = dom.getAttrib(matchedElm, 'name') || matchedElm.id;
	            var cls_1 = getVisualAidsAnchorClass(editor);
	            if (value_1 && editor.hasVisual) {
	              dom.addClass(matchedElm, cls_1);
	            } else {
	              dom.removeClass(matchedElm, cls_1);
	            }
	          }
	          break;
	        }
	      });
	      editor.fire('VisualAid', {
	        element: elm,
	        hasVisual: editor.hasVisual
	      });
	    };
	
	    var makePlainAdaptor = function (editor) {
	      return {
	        undoManager: {
	          beforeChange: function (locks, beforeBookmark) {
	            return beforeChange$1(editor, locks, beforeBookmark);
	          },
	          add: function (undoManager, index, locks, beforeBookmark, level, event) {
	            return addUndoLevel$1(editor, undoManager, index, locks, beforeBookmark, level, event);
	          },
	          undo: function (undoManager, locks, index) {
	            return undo$1(editor, undoManager, locks, index);
	          },
	          redo: function (index, data) {
	            return redo$1(editor, index, data);
	          },
	          clear: function (undoManager, index) {
	            return clear$1(editor, undoManager, index);
	          },
	          reset: function (undoManager) {
	            return reset$1(undoManager);
	          },
	          hasUndo: function (undoManager, index) {
	            return hasUndo$1(editor, undoManager, index);
	          },
	          hasRedo: function (undoManager, index) {
	            return hasRedo$1(undoManager, index);
	          },
	          transact: function (undoManager, locks, callback) {
	            return transact$1(undoManager, locks, callback);
	          },
	          ignore: function (locks, callback) {
	            return ignore$1(locks, callback);
	          },
	          extra: function (undoManager, index, callback1, callback2) {
	            return extra$1(editor, undoManager, index, callback1, callback2);
	          }
	        },
	        formatter: {
	          match: function (name, vars, node, similar) {
	            return match$2(editor, name, vars, node, similar);
	          },
	          matchAll: function (names, vars) {
	            return matchAll(editor, names, vars);
	          },
	          matchNode: function (node, name, vars, similar) {
	            return matchNode(editor, node, name, vars, similar);
	          },
	          canApply: function (name) {
	            return canApply(editor, name);
	          },
	          closest: function (names) {
	            return closest(editor, names);
	          },
	          apply: function (name, vars, node) {
	            return applyFormat$1(editor, name, vars, node);
	          },
	          remove: function (name, vars, node, similar) {
	            return remove$1(editor, name, vars, node, similar);
	          },
	          toggle: function (name, vars, node) {
	            return toggle(editor, name, vars, node);
	          },
	          formatChanged: function (registeredFormatListeners, formats, callback, similar, vars) {
	            return formatChangedInternal(editor, registeredFormatListeners, formats, callback, similar, vars);
	          }
	        },
	        editor: {
	          getContent: function (args, format) {
	            return getContentInternal(editor, args, format);
	          },
	          setContent: function (content, args) {
	            return setContentInternal(editor, content, args);
	          },
	          insertContent: function (value, details) {
	            return insertHtmlAtCaret(editor, value, details);
	          },
	          addVisual: function (elm) {
	            return addVisualInternal(editor, elm);
	          }
	        },
	        selection: {
	          getContent: function (format, args) {
	            return getSelectedContentInternal(editor, format, args);
	          }
	        },
	        raw: {
	          getModel: function () {
	            return Optional.none();
	          }
	        }
	      };
	    };
	    var makeRtcAdaptor = function (rtcEditor) {
	      var defaultVars = function (vars) {
	        return isObject(vars) ? vars : {};
	      };
	      var undoManager = rtcEditor.undoManager, formatter = rtcEditor.formatter, editor = rtcEditor.editor, selection = rtcEditor.selection, raw = rtcEditor.raw;
	      return {
	        undoManager: {
	          beforeChange: undoManager.beforeChange,
	          add: undoManager.add,
	          undo: undoManager.undo,
	          redo: undoManager.redo,
	          clear: undoManager.clear,
	          reset: undoManager.reset,
	          hasUndo: undoManager.hasUndo,
	          hasRedo: undoManager.hasRedo,
	          transact: function (_undoManager, _locks, fn) {
	            return undoManager.transact(fn);
	          },
	          ignore: function (_locks, callback) {
	            return undoManager.ignore(callback);
	          },
	          extra: function (_undoManager, _index, callback1, callback2) {
	            return undoManager.extra(callback1, callback2);
	          }
	        },
	        formatter: {
	          match: function (name, vars, _node, similar) {
	            return formatter.match(name, defaultVars(vars), similar);
	          },
	          matchAll: formatter.matchAll,
	          matchNode: formatter.matchNode,
	          canApply: function (name) {
	            return formatter.canApply(name);
	          },
	          closest: function (names) {
	            return formatter.closest(names);
	          },
	          apply: function (name, vars, _node) {
	            return formatter.apply(name, defaultVars(vars));
	          },
	          remove: function (name, vars, _node, _similar) {
	            return formatter.remove(name, defaultVars(vars));
	          },
	          toggle: function (name, vars, _node) {
	            return formatter.toggle(name, defaultVars(vars));
	          },
	          formatChanged: function (_rfl, formats, callback, similar, vars) {
	            return formatter.formatChanged(formats, callback, similar, vars);
	          }
	        },
	        editor: {
	          getContent: function (args, _format) {
	            return editor.getContent(args);
	          },
	          setContent: function (content, args) {
	            return editor.setContent(content, args);
	          },
	          insertContent: function (content, _details) {
	            return editor.insertContent(content);
	          },
	          addVisual: editor.addVisual
	        },
	        selection: {
	          getContent: function (_format, args) {
	            return selection.getContent(args);
	          }
	        },
	        raw: {
	          getModel: function () {
	            return Optional.some(raw.getRawModel());
	          }
	        }
	      };
	    };
	    var makeNoopAdaptor = function () {
	      var nul = constant(null);
	      var empty = constant('');
	      return {
	        undoManager: {
	          beforeChange: noop,
	          add: nul,
	          undo: nul,
	          redo: nul,
	          clear: noop,
	          reset: noop,
	          hasUndo: never,
	          hasRedo: never,
	          transact: nul,
	          ignore: noop,
	          extra: noop
	        },
	        formatter: {
	          match: never,
	          matchAll: constant([]),
	          matchNode: constant(undefined),
	          canApply: never,
	          closest: empty,
	          apply: noop,
	          remove: noop,
	          toggle: noop,
	          formatChanged: constant({ unbind: noop })
	        },
	        editor: {
	          getContent: empty,
	          setContent: empty,
	          insertContent: noop,
	          addVisual: noop
	        },
	        selection: { getContent: empty },
	        raw: { getModel: constant(Optional.none()) }
	      };
	    };
	    var isRtc = function (editor) {
	      return has$2(editor.plugins, 'rtc');
	    };
	    var getRtcSetup = function (editor) {
	      return get$9(editor.plugins, 'rtc').bind(function (rtcPlugin) {
	        return Optional.from(rtcPlugin.setup);
	      });
	    };
	    var setup$i = function (editor) {
	      var editorCast = editor;
	      return getRtcSetup(editor).fold(function () {
	        editorCast.rtcInstance = makePlainAdaptor(editor);
	        return Optional.none();
	      }, function (setup) {
	        editorCast.rtcInstance = makeNoopAdaptor();
	        return Optional.some(function () {
	          return setup().then(function (rtcEditor) {
	            editorCast.rtcInstance = makeRtcAdaptor(rtcEditor);
	            return rtcEditor.rtc.isRemote;
	          });
	        });
	      });
	    };
	    var getRtcInstanceWithFallback = function (editor) {
	      return editor.rtcInstance ? editor.rtcInstance : makePlainAdaptor(editor);
	    };
	    var getRtcInstanceWithError = function (editor) {
	      var rtcInstance = editor.rtcInstance;
	      if (!rtcInstance) {
	        throw new Error('Failed to get RTC instance not yet initialized.');
	      } else {
	        return rtcInstance;
	      }
	    };
	    var beforeChange = function (editor, locks, beforeBookmark) {
	      getRtcInstanceWithError(editor).undoManager.beforeChange(locks, beforeBookmark);
	    };
	    var addUndoLevel = function (editor, undoManager, index, locks, beforeBookmark, level, event) {
	      return getRtcInstanceWithError(editor).undoManager.add(undoManager, index, locks, beforeBookmark, level, event);
	    };
	    var undo = function (editor, undoManager, locks, index) {
	      return getRtcInstanceWithError(editor).undoManager.undo(undoManager, locks, index);
	    };
	    var redo = function (editor, index, data) {
	      return getRtcInstanceWithError(editor).undoManager.redo(index, data);
	    };
	    var clear = function (editor, undoManager, index) {
	      getRtcInstanceWithError(editor).undoManager.clear(undoManager, index);
	    };
	    var reset = function (editor, undoManager) {
	      getRtcInstanceWithError(editor).undoManager.reset(undoManager);
	    };
	    var hasUndo = function (editor, undoManager, index) {
	      return getRtcInstanceWithError(editor).undoManager.hasUndo(undoManager, index);
	    };
	    var hasRedo = function (editor, undoManager, index) {
	      return getRtcInstanceWithError(editor).undoManager.hasRedo(undoManager, index);
	    };
	    var transact = function (editor, undoManager, locks, callback) {
	      return getRtcInstanceWithError(editor).undoManager.transact(undoManager, locks, callback);
	    };
	    var ignore = function (editor, locks, callback) {
	      getRtcInstanceWithError(editor).undoManager.ignore(locks, callback);
	    };
	    var extra = function (editor, undoManager, index, callback1, callback2) {
	      getRtcInstanceWithError(editor).undoManager.extra(undoManager, index, callback1, callback2);
	    };
	    var matchFormat = function (editor, name, vars, node, similar) {
	      return getRtcInstanceWithError(editor).formatter.match(name, vars, node, similar);
	    };
	    var matchAllFormats = function (editor, names, vars) {
	      return getRtcInstanceWithError(editor).formatter.matchAll(names, vars);
	    };
	    var matchNodeFormat = function (editor, node, name, vars, similar) {
	      return getRtcInstanceWithError(editor).formatter.matchNode(node, name, vars, similar);
	    };
	    var canApplyFormat = function (editor, name) {
	      return getRtcInstanceWithError(editor).formatter.canApply(name);
	    };
	    var closestFormat = function (editor, names) {
	      return getRtcInstanceWithError(editor).formatter.closest(names);
	    };
	    var applyFormat = function (editor, name, vars, node) {
	      getRtcInstanceWithError(editor).formatter.apply(name, vars, node);
	    };
	    var removeFormat = function (editor, name, vars, node, similar) {
	      getRtcInstanceWithError(editor).formatter.remove(name, vars, node, similar);
	    };
	    var toggleFormat = function (editor, name, vars, node) {
	      getRtcInstanceWithError(editor).formatter.toggle(name, vars, node);
	    };
	    var formatChanged = function (editor, registeredFormatListeners, formats, callback, similar, vars) {
	      return getRtcInstanceWithError(editor).formatter.formatChanged(registeredFormatListeners, formats, callback, similar, vars);
	    };
	    var getContent$2 = function (editor, args, format) {
	      return getRtcInstanceWithFallback(editor).editor.getContent(args, format);
	    };
	    var setContent$2 = function (editor, content, args) {
	      return getRtcInstanceWithFallback(editor).editor.setContent(content, args);
	    };
	    var insertContent = function (editor, value, details) {
	      return getRtcInstanceWithFallback(editor).editor.insertContent(value, details);
	    };
	    var getSelectedContent = function (editor, format, args) {
	      return getRtcInstanceWithError(editor).selection.getContent(format, args);
	    };
	    var addVisual$1 = function (editor, elm) {
	      return getRtcInstanceWithError(editor).editor.addVisual(elm);
	    };
	
	    var getContent$1 = function (editor, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      var format = args.format ? args.format : 'html';
	      return getSelectedContent(editor, format, args);
	    };
	
	    var removeEmpty = function (text) {
	      if (text.dom.length === 0) {
	        remove$7(text);
	        return Optional.none();
	      } else {
	        return Optional.some(text);
	      }
	    };
	    var walkPastBookmark = function (node, start) {
	      return node.filter(function (elm) {
	        return BookmarkManager.isBookmarkNode(elm.dom);
	      }).bind(start ? nextSibling : prevSibling);
	    };
	    var merge = function (outer, inner, rng, start) {
	      var outerElm = outer.dom;
	      var innerElm = inner.dom;
	      var oldLength = start ? outerElm.length : innerElm.length;
	      if (start) {
	        mergeTextNodes(outerElm, innerElm, false, !start);
	        rng.setStart(innerElm, oldLength);
	      } else {
	        mergeTextNodes(innerElm, outerElm, false, !start);
	        rng.setEnd(innerElm, oldLength);
	      }
	    };
	    var normalizeTextIfRequired = function (inner, start) {
	      parent(inner).each(function (root) {
	        var text = inner.dom;
	        if (start && needsToBeNbspLeft(root, CaretPosition(text, 0))) {
	          normalizeWhitespaceAfter(text, 0);
	        } else if (!start && needsToBeNbspRight(root, CaretPosition(text, text.length))) {
	          normalizeWhitespaceBefore(text, text.length);
	        }
	      });
	    };
	    var mergeAndNormalizeText = function (outerNode, innerNode, rng, start) {
	      outerNode.bind(function (outer) {
	        var normalizer = start ? normalizeWhitespaceBefore : normalizeWhitespaceAfter;
	        normalizer(outer.dom, start ? outer.dom.length : 0);
	        return innerNode.filter(isText$8).map(function (inner) {
	          return merge(outer, inner, rng, start);
	        });
	      }).orThunk(function () {
	        var innerTextNode = walkPastBookmark(innerNode, start).or(innerNode).filter(isText$8);
	        return innerTextNode.map(function (inner) {
	          return normalizeTextIfRequired(inner, start);
	        });
	      });
	    };
	    var rngSetContent = function (rng, fragment) {
	      var firstChild = Optional.from(fragment.firstChild).map(SugarElement.fromDom);
	      var lastChild = Optional.from(fragment.lastChild).map(SugarElement.fromDom);
	      rng.deleteContents();
	      rng.insertNode(fragment);
	      var prevText = firstChild.bind(prevSibling).filter(isText$8).bind(removeEmpty);
	      var nextText = lastChild.bind(nextSibling).filter(isText$8).bind(removeEmpty);
	      mergeAndNormalizeText(prevText, firstChild, rng, true);
	      mergeAndNormalizeText(nextText, lastChild, rng, false);
	      rng.collapse(false);
	    };
	    var setupArgs = function (args, content) {
	      return __assign(__assign({ format: 'html' }, args), {
	        set: true,
	        selection: true,
	        content: content
	      });
	    };
	    var cleanContent = function (editor, args) {
	      if (args.format !== 'raw') {
	        var rng = editor.selection.getRng();
	        var contextBlock = editor.dom.getParent(rng.commonAncestorContainer, editor.dom.isBlock);
	        var contextArgs = contextBlock ? { context: contextBlock.nodeName.toLowerCase() } : {};
	        var node = editor.parser.parse(args.content, __assign(__assign({
	          isRootContent: true,
	          forced_root_block: false
	        }, contextArgs), args));
	        return HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(node);
	      } else {
	        return args.content;
	      }
	    };
	    var setContent$1 = function (editor, content, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      var defaultedArgs = setupArgs(args, content);
	      var updatedArgs = defaultedArgs;
	      if (!defaultedArgs.no_events) {
	        var eventArgs = editor.fire('BeforeSetContent', defaultedArgs);
	        if (eventArgs.isDefaultPrevented()) {
	          editor.fire('SetContent', eventArgs);
	          return;
	        } else {
	          updatedArgs = eventArgs;
	        }
	      }
	      updatedArgs.content = cleanContent(editor, updatedArgs);
	      var rng = editor.selection.getRng();
	      rngSetContent(rng, rng.createContextualFragment(updatedArgs.content));
	      editor.selection.setRng(rng);
	      scrollRangeIntoView(editor, rng);
	      if (!updatedArgs.no_events) {
	        editor.fire('SetContent', updatedArgs);
	      }
	    };
	
	    var deleteFromCallbackMap = function (callbackMap, selector, callback) {
	      if (callbackMap && has$2(callbackMap, selector)) {
	        var newCallbacks = filter$4(callbackMap[selector], function (cb) {
	          return cb !== callback;
	        });
	        if (newCallbacks.length === 0) {
	          delete callbackMap[selector];
	        } else {
	          callbackMap[selector] = newCallbacks;
	        }
	      }
	    };
	    function SelectorChanged (dom, editor) {
	      var selectorChangedData;
	      var currentSelectors;
	      var findMatchingNode = function (selector, nodes) {
	        return find$3(nodes, function (node) {
	          return dom.is(node, selector);
	        });
	      };
	      var getParents = function (elem) {
	        return dom.getParents(elem, null, dom.getRoot());
	      };
	      return {
	        selectorChangedWithUnbind: function (selector, callback) {
	          if (!selectorChangedData) {
	            selectorChangedData = {};
	            currentSelectors = {};
	            editor.on('NodeChange', function (e) {
	              var node = e.element;
	              var parents = getParents(node);
	              var matchedSelectors = {};
	              Tools.each(selectorChangedData, function (callbacks, selector) {
	                findMatchingNode(selector, parents).each(function (node) {
	                  if (!currentSelectors[selector]) {
	                    each$k(callbacks, function (callback) {
	                      callback(true, {
	                        node: node,
	                        selector: selector,
	                        parents: parents
	                      });
	                    });
	                    currentSelectors[selector] = callbacks;
	                  }
	                  matchedSelectors[selector] = callbacks;
	                });
	              });
	              Tools.each(currentSelectors, function (callbacks, selector) {
	                if (!matchedSelectors[selector]) {
	                  delete currentSelectors[selector];
	                  Tools.each(callbacks, function (callback) {
	                    callback(false, {
	                      node: node,
	                      selector: selector,
	                      parents: parents
	                    });
	                  });
	                }
	              });
	            });
	          }
	          if (!selectorChangedData[selector]) {
	            selectorChangedData[selector] = [];
	          }
	          selectorChangedData[selector].push(callback);
	          findMatchingNode(selector, getParents(editor.selection.getStart())).each(function () {
	            currentSelectors[selector] = selectorChangedData[selector];
	          });
	          return {
	            unbind: function () {
	              deleteFromCallbackMap(selectorChangedData, selector, callback);
	              deleteFromCallbackMap(currentSelectors, selector, callback);
	            }
	          };
	        }
	      };
	    }
	
	    var isNativeIeSelection = function (rng) {
	      return !!rng.select;
	    };
	    var isAttachedToDom = function (node) {
	      return !!(node && node.ownerDocument) && contains$1(SugarElement.fromDom(node.ownerDocument), SugarElement.fromDom(node));
	    };
	    var isValidRange = function (rng) {
	      if (!rng) {
	        return false;
	      } else if (isNativeIeSelection(rng)) {
	        return true;
	      } else {
	        return isAttachedToDom(rng.startContainer) && isAttachedToDom(rng.endContainer);
	      }
	    };
	    var EditorSelection = function (dom, win, serializer, editor) {
	      var selectedRange;
	      var explicitRange;
	      var selectorChangedWithUnbind = SelectorChanged(dom, editor).selectorChangedWithUnbind;
	      var setCursorLocation = function (node, offset) {
	        var rng = dom.createRng();
	        if (isNonNullable(node) && isNonNullable(offset)) {
	          rng.setStart(node, offset);
	          rng.setEnd(node, offset);
	          setRng(rng);
	          collapse(false);
	        } else {
	          moveEndPoint(dom, rng, editor.getBody(), true);
	          setRng(rng);
	        }
	      };
	      var getContent = function (args) {
	        return getContent$1(editor, args);
	      };
	      var setContent = function (content, args) {
	        return setContent$1(editor, content, args);
	      };
	      var getStart$1 = function (real) {
	        return getStart(editor.getBody(), getRng$1(), real);
	      };
	      var getEnd$1 = function (real) {
	        return getEnd(editor.getBody(), getRng$1(), real);
	      };
	      var getBookmark = function (type, normalized) {
	        return bookmarkManager.getBookmark(type, normalized);
	      };
	      var moveToBookmark = function (bookmark) {
	        return bookmarkManager.moveToBookmark(bookmark);
	      };
	      var select$1 = function (node, content) {
	        select(dom, node, content).each(setRng);
	        return node;
	      };
	      var isCollapsed = function () {
	        var rng = getRng$1(), sel = getSel();
	        if (!rng || rng.item) {
	          return false;
	        }
	        if (rng.compareEndPoints) {
	          return rng.compareEndPoints('StartToEnd', rng) === 0;
	        }
	        return !sel || rng.collapsed;
	      };
	      var collapse = function (toStart) {
	        var rng = getRng$1();
	        rng.collapse(!!toStart);
	        setRng(rng);
	      };
	      var getSel = function () {
	        return win.getSelection ? win.getSelection() : win.document.selection;
	      };
	      var getRng$1 = function () {
	        var selection, rng, elm;
	        var tryCompareBoundaryPoints = function (how, sourceRange, destinationRange) {
	          try {
	            return sourceRange.compareBoundaryPoints(how, destinationRange);
	          } catch (ex) {
	            return -1;
	          }
	        };
	        var doc = win.document;
	        if (editor.bookmark !== undefined && hasFocus(editor) === false) {
	          var bookmark = getRng(editor);
	          if (bookmark.isSome()) {
	            return bookmark.map(function (r) {
	              return processRanges(editor, [r])[0];
	            }).getOr(doc.createRange());
	          }
	        }
	        try {
	          if ((selection = getSel()) && !isRestrictedNode(selection.anchorNode)) {
	            if (selection.rangeCount > 0) {
	              rng = selection.getRangeAt(0);
	            } else {
	              rng = selection.createRange ? selection.createRange() : doc.createRange();
	            }
	            rng = processRanges(editor, [rng])[0];
	          }
	        } catch (ex) {
	        }
	        if (!rng) {
	          rng = doc.createRange ? doc.createRange() : doc.body.createTextRange();
	        }
	        if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
	          elm = dom.getRoot();
	          rng.setStart(elm, 0);
	          rng.setEnd(elm, 0);
	        }
	        if (selectedRange && explicitRange) {
	          if (tryCompareBoundaryPoints(rng.START_TO_START, rng, selectedRange) === 0 && tryCompareBoundaryPoints(rng.END_TO_END, rng, selectedRange) === 0) {
	            rng = explicitRange;
	          } else {
	            selectedRange = null;
	            explicitRange = null;
	          }
	        }
	        return rng;
	      };
	      var setRng = function (rng, forward) {
	        var node;
	        if (!isValidRange(rng)) {
	          return;
	        }
	        var ieRange = isNativeIeSelection(rng) ? rng : null;
	        if (ieRange) {
	          explicitRange = null;
	          try {
	            ieRange.select();
	          } catch (ex) {
	          }
	          return;
	        }
	        var sel = getSel();
	        var evt = editor.fire('SetSelectionRange', {
	          range: rng,
	          forward: forward
	        });
	        rng = evt.range;
	        if (sel) {
	          explicitRange = rng;
	          try {
	            sel.removeAllRanges();
	            sel.addRange(rng);
	          } catch (ex) {
	          }
	          if (forward === false && sel.extend) {
	            sel.collapse(rng.endContainer, rng.endOffset);
	            sel.extend(rng.startContainer, rng.startOffset);
	          }
	          selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
	        }
	        if (!rng.collapsed && rng.startContainer === rng.endContainer && sel.setBaseAndExtent && !Env.ie) {
	          if (rng.endOffset - rng.startOffset < 2) {
	            if (rng.startContainer.hasChildNodes()) {
	              node = rng.startContainer.childNodes[rng.startOffset];
	              if (node && node.tagName === 'IMG') {
	                sel.setBaseAndExtent(rng.startContainer, rng.startOffset, rng.endContainer, rng.endOffset);
	                if (sel.anchorNode !== rng.startContainer || sel.focusNode !== rng.endContainer) {
	                  sel.setBaseAndExtent(node, 0, node, 1);
	                }
	              }
	            }
	          }
	        }
	        editor.fire('AfterSetSelectionRange', {
	          range: rng,
	          forward: forward
	        });
	      };
	      var setNode = function (elm) {
	        setContent(dom.getOuterHTML(elm));
	        return elm;
	      };
	      var getNode$1 = function () {
	        return getNode(editor.getBody(), getRng$1());
	      };
	      var getSelectedBlocks$1 = function (startElm, endElm) {
	        return getSelectedBlocks(dom, getRng$1(), startElm, endElm);
	      };
	      var isForward = function () {
	        var sel = getSel();
	        var anchorNode = sel === null || sel === void 0 ? void 0 : sel.anchorNode;
	        var focusNode = sel === null || sel === void 0 ? void 0 : sel.focusNode;
	        if (!sel || !anchorNode || !focusNode || isRestrictedNode(anchorNode) || isRestrictedNode(focusNode)) {
	          return true;
	        }
	        var anchorRange = dom.createRng();
	        anchorRange.setStart(anchorNode, sel.anchorOffset);
	        anchorRange.collapse(true);
	        var focusRange = dom.createRng();
	        focusRange.setStart(focusNode, sel.focusOffset);
	        focusRange.collapse(true);
	        return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0;
	      };
	      var normalize = function () {
	        var rng = getRng$1();
	        var sel = getSel();
	        if (!hasMultipleRanges(sel) && hasAnyRanges(editor)) {
	          var normRng = normalize$2(dom, rng);
	          normRng.each(function (normRng) {
	            setRng(normRng, isForward());
	          });
	          return normRng.getOr(rng);
	        }
	        return rng;
	      };
	      var selectorChanged = function (selector, callback) {
	        selectorChangedWithUnbind(selector, callback);
	        return exports;
	      };
	      var getScrollContainer = function () {
	        var scrollContainer;
	        var node = dom.getRoot();
	        while (node && node.nodeName !== 'BODY') {
	          if (node.scrollHeight > node.clientHeight) {
	            scrollContainer = node;
	            break;
	          }
	          node = node.parentNode;
	        }
	        return scrollContainer;
	      };
	      var scrollIntoView = function (elm, alignToTop) {
	        if (isNonNullable(elm)) {
	          scrollElementIntoView(editor, elm, alignToTop);
	        } else {
	          scrollRangeIntoView(editor, getRng$1(), alignToTop);
	        }
	      };
	      var placeCaretAt = function (clientX, clientY) {
	        return setRng(fromPoint(clientX, clientY, editor.getDoc()));
	      };
	      var getBoundingClientRect = function () {
	        var rng = getRng$1();
	        return rng.collapsed ? CaretPosition.fromRangeStart(rng).getClientRects()[0] : rng.getBoundingClientRect();
	      };
	      var destroy = function () {
	        win = selectedRange = explicitRange = null;
	        controlSelection.destroy();
	      };
	      var exports = {
	        bookmarkManager: null,
	        controlSelection: null,
	        dom: dom,
	        win: win,
	        serializer: serializer,
	        editor: editor,
	        collapse: collapse,
	        setCursorLocation: setCursorLocation,
	        getContent: getContent,
	        setContent: setContent,
	        getBookmark: getBookmark,
	        moveToBookmark: moveToBookmark,
	        select: select$1,
	        isCollapsed: isCollapsed,
	        isForward: isForward,
	        setNode: setNode,
	        getNode: getNode$1,
	        getSel: getSel,
	        setRng: setRng,
	        getRng: getRng$1,
	        getStart: getStart$1,
	        getEnd: getEnd$1,
	        getSelectedBlocks: getSelectedBlocks$1,
	        normalize: normalize,
	        selectorChanged: selectorChanged,
	        selectorChangedWithUnbind: selectorChangedWithUnbind,
	        getScrollContainer: getScrollContainer,
	        scrollIntoView: scrollIntoView,
	        placeCaretAt: placeCaretAt,
	        getBoundingClientRect: getBoundingClientRect,
	        destroy: destroy
	      };
	      var bookmarkManager = BookmarkManager(exports);
	      var controlSelection = ControlSelection(exports, editor);
	      exports.bookmarkManager = bookmarkManager;
	      exports.controlSelection = controlSelection;
	      return exports;
	    };
	
	    var removeAttrs = function (node, names) {
	      each$k(names, function (name) {
	        node.attr(name, null);
	      });
	    };
	    var addFontToSpansFilter = function (domParser, styles, fontSizes) {
	      domParser.addNodeFilter('font', function (nodes) {
	        each$k(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          var color = node.attr('color');
	          var face = node.attr('face');
	          var size = node.attr('size');
	          if (color) {
	            props.color = color;
	          }
	          if (face) {
	            props['font-family'] = face;
	          }
	          if (size) {
	            props['font-size'] = fontSizes[parseInt(node.attr('size'), 10) - 1];
	          }
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	          removeAttrs(node, [
	            'color',
	            'face',
	            'size'
	          ]);
	        });
	      });
	    };
	    var addStrikeToSpanFilter = function (domParser, styles) {
	      domParser.addNodeFilter('strike', function (nodes) {
	        each$k(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          props['text-decoration'] = 'line-through';
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	        });
	      });
	    };
	    var addFilters = function (domParser, settings) {
	      var styles = Styles();
	      if (settings.convert_fonts_to_spans) {
	        addFontToSpansFilter(domParser, styles, Tools.explode(settings.font_size_legacy_values));
	      }
	      addStrikeToSpanFilter(domParser, styles);
	    };
	    var register$2 = function (domParser, settings) {
	      if (settings.inline_styles) {
	        addFilters(domParser, settings);
	      }
	    };
	
	    var blobUriToBlob = function (url) {
	      return new promiseObj(function (resolve, reject) {
	        var rejectWithError = function () {
	          reject('Cannot convert ' + url + ' to Blob. Resource might not exist or is inaccessible.');
	        };
	        try {
	          var xhr_1 = new XMLHttpRequest();
	          xhr_1.open('GET', url, true);
	          xhr_1.responseType = 'blob';
	          xhr_1.onload = function () {
	            if (xhr_1.status === 200) {
	              resolve(xhr_1.response);
	            } else {
	              rejectWithError();
	            }
	          };
	          xhr_1.onerror = rejectWithError;
	          xhr_1.send();
	        } catch (ex) {
	          rejectWithError();
	        }
	      });
	    };
	    var parseDataUri = function (uri) {
	      var type;
	      var uriParts = decodeURIComponent(uri).split(',');
	      var matches = /data:([^;]+)/.exec(uriParts[0]);
	      if (matches) {
	        type = matches[1];
	      }
	      return {
	        type: type,
	        data: uriParts[1]
	      };
	    };
	    var buildBlob = function (type, data) {
	      var str;
	      try {
	        str = atob(data);
	      } catch (e) {
	        return Optional.none();
	      }
	      var arr = new Uint8Array(str.length);
	      for (var i = 0; i < arr.length; i++) {
	        arr[i] = str.charCodeAt(i);
	      }
	      return Optional.some(new Blob([arr], { type: type }));
	    };
	    var dataUriToBlob = function (uri) {
	      return new promiseObj(function (resolve) {
	        var _a = parseDataUri(uri), type = _a.type, data = _a.data;
	        buildBlob(type, data).fold(function () {
	          return resolve(new Blob([]));
	        }, resolve);
	      });
	    };
	    var uriToBlob = function (url) {
	      if (url.indexOf('blob:') === 0) {
	        return blobUriToBlob(url);
	      }
	      if (url.indexOf('data:') === 0) {
	        return dataUriToBlob(url);
	      }
	      return null;
	    };
	    var blobToDataUri = function (blob) {
	      return new promiseObj(function (resolve) {
	        var reader = new FileReader();
	        reader.onloadend = function () {
	          resolve(reader.result);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	
	    var count$1 = 0;
	    var uniqueId = function (prefix) {
	      return (prefix || 'blobid') + count$1++;
	    };
	    var imageToBlobInfo = function (blobCache, img, resolve, reject) {
	      var base64, blobInfo;
	      if (img.src.indexOf('blob:') === 0) {
	        blobInfo = blobCache.getByUri(img.src);
	        if (blobInfo) {
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        } else {
	          uriToBlob(img.src).then(function (blob) {
	            blobToDataUri(blob).then(function (dataUri) {
	              base64 = parseDataUri(dataUri).data;
	              blobInfo = blobCache.create(uniqueId(), blob, base64);
	              blobCache.add(blobInfo);
	              resolve({
	                image: img,
	                blobInfo: blobInfo
	              });
	            });
	          }, function (err) {
	            reject(err);
	          });
	        }
	        return;
	      }
	      var _a = parseDataUri(img.src), data = _a.data, type = _a.type;
	      base64 = data;
	      blobInfo = blobCache.getByData(base64, type);
	      if (blobInfo) {
	        resolve({
	          image: img,
	          blobInfo: blobInfo
	        });
	      } else {
	        uriToBlob(img.src).then(function (blob) {
	          blobInfo = blobCache.create(uniqueId(), blob, base64);
	          blobCache.add(blobInfo);
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        }, function (err) {
	          reject(err);
	        });
	      }
	    };
	    var getAllImages = function (elm) {
	      return elm ? from(elm.getElementsByTagName('img')) : [];
	    };
	    var ImageScanner = function (uploadStatus, blobCache) {
	      var cachedPromises = {};
	      var findAll = function (elm, predicate) {
	        if (!predicate) {
	          predicate = always;
	        }
	        var images = filter$4(getAllImages(elm), function (img) {
	          var src = img.src;
	          if (!Env.fileApi) {
	            return false;
	          }
	          if (img.hasAttribute('data-mce-bogus')) {
	            return false;
	          }
	          if (img.hasAttribute('data-mce-placeholder')) {
	            return false;
	          }
	          if (!src || src === Env.transparentSrc) {
	            return false;
	          }
	          if (src.indexOf('blob:') === 0) {
	            return !uploadStatus.isUploaded(src) && predicate(img);
	          }
	          if (src.indexOf('data:') === 0) {
	            return predicate(img);
	          }
	          return false;
	        });
	        var promises = map$3(images, function (img) {
	          if (cachedPromises[img.src] !== undefined) {
	            return new promiseObj(function (resolve) {
	              cachedPromises[img.src].then(function (imageInfo) {
	                if (typeof imageInfo === 'string') {
	                  return imageInfo;
	                }
	                resolve({
	                  image: img,
	                  blobInfo: imageInfo.blobInfo
	                });
	              });
	            });
	          }
	          var newPromise = new promiseObj(function (resolve, reject) {
	            imageToBlobInfo(blobCache, img, resolve, reject);
	          }).then(function (result) {
	            delete cachedPromises[result.image.src];
	            return result;
	          }).catch(function (error) {
	            delete cachedPromises[img.src];
	            return error;
	          });
	          cachedPromises[img.src] = newPromise;
	          return newPromise;
	        });
	        return promiseObj.all(promises);
	      };
	      return { findAll: findAll };
	    };
	
	    var paddEmptyNode = function (settings, args, blockElements, node) {
	      var brPreferred = settings.padd_empty_with_br || args.insert;
	      if (brPreferred && blockElements[node.name]) {
	        node.empty().append(new AstNode('br', 1)).shortEnded = true;
	      } else {
	        node.empty().append(new AstNode('#text', 3)).value = nbsp;
	      }
	    };
	    var isPaddedWithNbsp = function (node) {
	      return hasOnlyChild(node, '#text') && node.firstChild.value === nbsp;
	    };
	    var hasOnlyChild = function (node, name) {
	      return node && node.firstChild && node.firstChild === node.lastChild && node.firstChild.name === name;
	    };
	    var isPadded = function (schema, node) {
	      var rule = schema.getElementRule(node.name);
	      return rule && rule.paddEmpty;
	    };
	    var isEmpty = function (schema, nonEmptyElements, whitespaceElements, node) {
	      return node.isEmpty(nonEmptyElements, whitespaceElements, function (node) {
	        return isPadded(schema, node);
	      });
	    };
	    var isLineBreakNode = function (node, blockElements) {
	      return node && (has$2(blockElements, node.name) || node.name === 'br');
	    };
	
	    var isBogusImage = function (img) {
	      return isNonNullable(img.attr('data-mce-bogus'));
	    };
	    var isInternalImageSource = function (img) {
	      return img.attr('src') === Env.transparentSrc || isNonNullable(img.attr('data-mce-placeholder'));
	    };
	    var isValidDataImg = function (img, settings) {
	      if (settings.images_dataimg_filter) {
	        var imgElem_1 = new Image();
	        imgElem_1.src = img.attr('src');
	        each$j(img.attributes.map, function (value, key) {
	          imgElem_1.setAttribute(key, value);
	        });
	        return settings.images_dataimg_filter(imgElem_1);
	      } else {
	        return true;
	      }
	    };
	    var registerBase64ImageFilter = function (parser, settings) {
	      var blobCache = settings.blob_cache;
	      var processImage = function (img) {
	        var inputSrc = img.attr('src');
	        if (isInternalImageSource(img) || isBogusImage(img)) {
	          return;
	        }
	        parseDataUri$1(inputSrc).filter(function () {
	          return isValidDataImg(img, settings);
	        }).bind(function (_a) {
	          var type = _a.type, data = _a.data;
	          return Optional.from(blobCache.getByData(data, type)).orThunk(function () {
	            return buildBlob(type, data).map(function (blob) {
	              var blobInfo = blobCache.create(uniqueId(), blob, data);
	              blobCache.add(blobInfo);
	              return blobInfo;
	            });
	          });
	        }).each(function (blobInfo) {
	          img.attr('src', blobInfo.blobUri());
	        });
	      };
	      if (blobCache) {
	        parser.addAttributeFilter('src', function (nodes) {
	          return each$k(nodes, processImage);
	        });
	      }
	    };
	    var register$1 = function (parser, settings) {
	      var schema = parser.schema;
	      if (settings.remove_trailing_brs) {
	        parser.addNodeFilter('br', function (nodes, _, args) {
	          var i;
	          var l = nodes.length;
	          var node;
	          var blockElements = Tools.extend({}, schema.getBlockElements());
	          var nonEmptyElements = schema.getNonEmptyElements();
	          var parent, lastParent, prev, prevName;
	          var whiteSpaceElements = schema.getWhiteSpaceElements();
	          var elementRule, textNode;
	          blockElements.body = 1;
	          for (i = 0; i < l; i++) {
	            node = nodes[i];
	            parent = node.parent;
	            if (blockElements[node.parent.name] && node === parent.lastChild) {
	              prev = node.prev;
	              while (prev) {
	                prevName = prev.name;
	                if (prevName !== 'span' || prev.attr('data-mce-type') !== 'bookmark') {
	                  if (prevName === 'br') {
	                    node = null;
	                  }
	                  break;
	                }
	                prev = prev.prev;
	              }
	              if (node) {
	                node.remove();
	                if (isEmpty(schema, nonEmptyElements, whiteSpaceElements, parent)) {
	                  elementRule = schema.getElementRule(parent.name);
	                  if (elementRule) {
	                    if (elementRule.removeEmpty) {
	                      parent.remove();
	                    } else if (elementRule.paddEmpty) {
	                      paddEmptyNode(settings, args, blockElements, parent);
	                    }
	                  }
	                }
	              }
	            } else {
	              lastParent = node;
	              while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
	                lastParent = parent;
	                if (blockElements[parent.name]) {
	                  break;
	                }
	                parent = parent.parent;
	              }
	              if (lastParent === parent && settings.padd_empty_with_br !== true) {
	                textNode = new AstNode('#text', 3);
	                textNode.value = nbsp;
	                node.replace(textNode);
	              }
	            }
	          }
	        });
	      }
	      parser.addAttributeFilter('href', function (nodes) {
	        var i = nodes.length;
	        var appendRel = function (rel) {
	          var parts = rel.split(' ').filter(function (p) {
	            return p.length > 0;
	          });
	          return parts.concat(['noopener']).sort().join(' ');
	        };
	        var addNoOpener = function (rel) {
	          var newRel = rel ? Tools.trim(rel) : '';
	          if (!/\b(noopener)\b/g.test(newRel)) {
	            return appendRel(newRel);
	          } else {
	            return newRel;
	          }
	        };
	        if (!settings.allow_unsafe_link_target) {
	          while (i--) {
	            var node = nodes[i];
	            if (node.name === 'a' && node.attr('target') === '_blank') {
	              node.attr('rel', addNoOpener(node.attr('rel')));
	            }
	          }
	        }
	      });
	      if (!settings.allow_html_in_named_anchor) {
	        parser.addAttributeFilter('id,name', function (nodes) {
	          var i = nodes.length, sibling, prevSibling, parent, node;
	          while (i--) {
	            node = nodes[i];
	            if (node.name === 'a' && node.firstChild && !node.attr('href')) {
	              parent = node.parent;
	              sibling = node.lastChild;
	              do {
	                prevSibling = sibling.prev;
	                parent.insert(sibling, node);
	                sibling = prevSibling;
	              } while (sibling);
	            }
	          }
	        });
	      }
	      if (settings.fix_list_elements) {
	        parser.addNodeFilter('ul,ol', function (nodes) {
	          var i = nodes.length, node, parentNode;
	          while (i--) {
	            node = nodes[i];
	            parentNode = node.parent;
	            if (parentNode.name === 'ul' || parentNode.name === 'ol') {
	              if (node.prev && node.prev.name === 'li') {
	                node.prev.append(node);
	              } else {
	                var li = new AstNode('li', 1);
	                li.attr('style', 'list-style-type: none');
	                node.wrap(li);
	              }
	            }
	          }
	        });
	      }
	      if (settings.validate && schema.getValidClasses()) {
	        parser.addAttributeFilter('class', function (nodes) {
	          var validClasses = schema.getValidClasses();
	          var i = nodes.length;
	          while (i--) {
	            var node = nodes[i];
	            var classList = node.attr('class').split(' ');
	            var classValue = '';
	            for (var ci = 0; ci < classList.length; ci++) {
	              var className = classList[ci];
	              var valid = false;
	              var validClassesMap = validClasses['*'];
	              if (validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	              validClassesMap = validClasses[node.name];
	              if (!valid && validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	              if (valid) {
	                if (classValue) {
	                  classValue += ' ';
	                }
	                classValue += className;
	              }
	            }
	            if (!classValue.length) {
	              classValue = null;
	            }
	            node.attr('class', classValue);
	          }
	        });
	      }
	      registerBase64ImageFilter(parser, settings);
	    };
	
	    var makeMap = Tools.makeMap, each$6 = Tools.each, explode$2 = Tools.explode, extend$4 = Tools.extend;
	    var DomParser = function (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var nodeFilters = {};
	      var attributeFilters = [];
	      var matchedNodes = {};
	      var matchedAttributes = {};
	      settings = settings || {};
	      settings.validate = 'validate' in settings ? settings.validate : true;
	      settings.root_name = settings.root_name || 'body';
	      var fixInvalidChildren = function (nodes) {
	        var nonSplitableElements = makeMap('tr,td,th,tbody,thead,tfoot,table');
	        var nonEmptyElements = schema.getNonEmptyElements();
	        var whitespaceElements = schema.getWhiteSpaceElements();
	        var textBlockElements = schema.getTextBlockElements();
	        var specialElements = schema.getSpecialElements();
	        var removeOrUnwrapInvalidNode = function (node, originalNodeParent) {
	          if (originalNodeParent === void 0) {
	            originalNodeParent = node.parent;
	          }
	          if (specialElements[node.name]) {
	            node.empty().remove();
	          } else {
	            var children = node.children();
	            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
	              var childNode = children_1[_i];
	              if (!schema.isValidChild(originalNodeParent.name, childNode.name)) {
	                removeOrUnwrapInvalidNode(childNode, originalNodeParent);
	              }
	            }
	            node.unwrap();
	          }
	        };
	        for (var ni = 0; ni < nodes.length; ni++) {
	          var node = nodes[ni];
	          var parent_1 = void 0, newParent = void 0, tempNode = void 0;
	          if (!node.parent || node.fixed) {
	            continue;
	          }
	          if (textBlockElements[node.name] && node.parent.name === 'li') {
	            var sibling = node.next;
	            while (sibling) {
	              if (textBlockElements[sibling.name]) {
	                sibling.name = 'li';
	                sibling.fixed = true;
	                node.parent.insert(sibling, node.parent);
	              } else {
	                break;
	              }
	              sibling = sibling.next;
	            }
	            node.unwrap();
	            continue;
	          }
	          var parents = [node];
	          for (parent_1 = node.parent; parent_1 && !schema.isValidChild(parent_1.name, node.name) && !nonSplitableElements[parent_1.name]; parent_1 = parent_1.parent) {
	            parents.push(parent_1);
	          }
	          if (parent_1 && parents.length > 1) {
	            if (schema.isValidChild(parent_1.name, node.name)) {
	              parents.reverse();
	              newParent = filterNode(parents[0].clone());
	              var currentNode = newParent;
	              for (var i = 0; i < parents.length - 1; i++) {
	                if (schema.isValidChild(currentNode.name, parents[i].name)) {
	                  tempNode = filterNode(parents[i].clone());
	                  currentNode.append(tempNode);
	                } else {
	                  tempNode = currentNode;
	                }
	                for (var childNode = parents[i].firstChild; childNode && childNode !== parents[i + 1];) {
	                  var nextNode = childNode.next;
	                  tempNode.append(childNode);
	                  childNode = nextNode;
	                }
	                currentNode = tempNode;
	              }
	              if (!isEmpty(schema, nonEmptyElements, whitespaceElements, newParent)) {
	                parent_1.insert(newParent, parents[0], true);
	                parent_1.insert(node, newParent);
	              } else {
	                parent_1.insert(node, parents[0], true);
	              }
	              parent_1 = parents[0];
	              if (isEmpty(schema, nonEmptyElements, whitespaceElements, parent_1) || hasOnlyChild(parent_1, 'br')) {
	                parent_1.empty().remove();
	              }
	            } else {
	              removeOrUnwrapInvalidNode(node);
	            }
	          } else if (node.parent) {
	            if (node.name === 'li') {
	              var sibling = node.prev;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ol')) {
	                sibling.append(node);
	                continue;
	              }
	              sibling = node.next;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ol')) {
	                sibling.insert(node, sibling.firstChild, true);
	                continue;
	              }
	              node.wrap(filterNode(new AstNode('ul', 1)));
	              continue;
	            }
	            if (schema.isValidChild(node.parent.name, 'div') && schema.isValidChild('div', node.name)) {
	              node.wrap(filterNode(new AstNode('div', 1)));
	            } else {
	              removeOrUnwrapInvalidNode(node);
	            }
	          }
	        }
	      };
	      var filterNode = function (node) {
	        var name = node.name;
	        if (name in nodeFilters) {
	          var list = matchedNodes[name];
	          if (list) {
	            list.push(node);
	          } else {
	            matchedNodes[name] = [node];
	          }
	        }
	        var i = attributeFilters.length;
	        while (i--) {
	          var attrName = attributeFilters[i].name;
	          if (attrName in node.attributes.map) {
	            var list = matchedAttributes[attrName];
	            if (list) {
	              list.push(node);
	            } else {
	              matchedAttributes[attrName] = [node];
	            }
	          }
	        }
	        return node;
	      };
	      var addNodeFilter = function (name, callback) {
	        each$6(explode$2(name), function (name) {
	          var list = nodeFilters[name];
	          if (!list) {
	            nodeFilters[name] = list = [];
	          }
	          list.push(callback);
	        });
	      };
	      var getNodeFilters = function () {
	        var out = [];
	        for (var name_1 in nodeFilters) {
	          if (has$2(nodeFilters, name_1)) {
	            out.push({
	              name: name_1,
	              callbacks: nodeFilters[name_1]
	            });
	          }
	        }
	        return out;
	      };
	      var addAttributeFilter = function (name, callback) {
	        each$6(explode$2(name), function (name) {
	          var i;
	          for (i = 0; i < attributeFilters.length; i++) {
	            if (attributeFilters[i].name === name) {
	              attributeFilters[i].callbacks.push(callback);
	              return;
	            }
	          }
	          attributeFilters.push({
	            name: name,
	            callbacks: [callback]
	          });
	        });
	      };
	      var getAttributeFilters = function () {
	        return [].concat(attributeFilters);
	      };
	      var parse = function (html, args) {
	        var nodes, i, l, fi, fl, list, name;
	        var invalidChildren = [];
	        var node;
	        var getRootBlockName = function (name) {
	          if (name === false) {
	            return '';
	          } else if (name === true) {
	            return 'p';
	          } else {
	            return name;
	          }
	        };
	        args = args || {};
	        matchedNodes = {};
	        matchedAttributes = {};
	        var blockElements = extend$4(makeMap('script,style,head,html,body,title,meta,param'), schema.getBlockElements());
	        var textRootBlockElements = getTextRootBlockElements(schema);
	        var nonEmptyElements = schema.getNonEmptyElements();
	        var children = schema.children;
	        var validate = settings.validate;
	        var forcedRootBlockName = 'forced_root_block' in args ? args.forced_root_block : settings.forced_root_block;
	        var rootBlockName = getRootBlockName(forcedRootBlockName);
	        var whiteSpaceElements = schema.getWhiteSpaceElements();
	        var startWhiteSpaceRegExp = /^[ \t\r\n]+/;
	        var endWhiteSpaceRegExp = /[ \t\r\n]+$/;
	        var allWhiteSpaceRegExp = /[ \t\r\n]+/g;
	        var isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;
	        var isInWhiteSpacePreservedElement = has$2(whiteSpaceElements, args.context) || has$2(whiteSpaceElements, settings.root_name);
	        var addRootBlocks = function () {
	          var node = rootNode.firstChild, rootBlockNode = null;
	          var trim = function (rootBlock) {
	            if (rootBlock) {
	              node = rootBlock.firstChild;
	              if (node && node.type === 3) {
	                node.value = node.value.replace(startWhiteSpaceRegExp, '');
	              }
	              node = rootBlock.lastChild;
	              if (node && node.type === 3) {
	                node.value = node.value.replace(endWhiteSpaceRegExp, '');
	              }
	            }
	          };
	          if (!schema.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
	            return;
	          }
	          while (node) {
	            var next = node.next;
	            if (node.type === 3 || node.type === 1 && node.name !== 'p' && !blockElements[node.name] && !node.attr('data-mce-type')) {
	              if (!rootBlockNode) {
	                rootBlockNode = createNode(rootBlockName, 1);
	                rootBlockNode.attr(settings.forced_root_block_attrs);
	                rootNode.insert(rootBlockNode, node);
	                rootBlockNode.append(node);
	              } else {
	                rootBlockNode.append(node);
	              }
	            } else {
	              trim(rootBlockNode);
	              rootBlockNode = null;
	            }
	            node = next;
	          }
	          trim(rootBlockNode);
	        };
	        var createNode = function (name, type) {
	          var node = new AstNode(name, type);
	          var list;
	          if (name in nodeFilters) {
	            list = matchedNodes[name];
	            if (list) {
	              list.push(node);
	            } else {
	              matchedNodes[name] = [node];
	            }
	          }
	          return node;
	        };
	        var removeWhitespaceBefore = function (node) {
	          var blockElements = schema.getBlockElements();
	          for (var textNode = node.prev; textNode && textNode.type === 3;) {
	            var textVal = textNode.value.replace(endWhiteSpaceRegExp, '');
	            if (textVal.length > 0) {
	              textNode.value = textVal;
	              return;
	            }
	            var textNodeNext = textNode.next;
	            if (textNodeNext) {
	              if (textNodeNext.type === 3 && textNodeNext.value.length) {
	                textNode = textNode.prev;
	                continue;
	              }
	              if (!blockElements[textNodeNext.name] && textNodeNext.name !== 'script' && textNodeNext.name !== 'style') {
	                textNode = textNode.prev;
	                continue;
	              }
	            }
	            var sibling = textNode.prev;
	            textNode.remove();
	            textNode = sibling;
	          }
	        };
	        var cloneAndExcludeBlocks = function (input) {
	          var output = {};
	          for (var name_2 in input) {
	            if (name_2 !== 'li' && name_2 !== 'p') {
	              output[name_2] = input[name_2];
	            }
	          }
	          return output;
	        };
	        var isTextRootBlockEmpty = function (node) {
	          var tempNode = node;
	          while (isNonNullable(tempNode)) {
	            if (tempNode.name in textRootBlockElements) {
	              return isEmpty(schema, nonEmptyElements, whiteSpaceElements, tempNode);
	            } else {
	              tempNode = tempNode.parent;
	            }
	          }
	          return false;
	        };
	        var parser = SaxParser({
	          validate: validate,
	          document: settings.document,
	          allow_html_data_urls: settings.allow_html_data_urls,
	          allow_svg_data_urls: settings.allow_svg_data_urls,
	          allow_script_urls: settings.allow_script_urls,
	          allow_conditional_comments: settings.allow_conditional_comments,
	          preserve_cdata: settings.preserve_cdata,
	          self_closing_elements: cloneAndExcludeBlocks(schema.getSelfClosingElements()),
	          cdata: function (text) {
	            node.append(createNode('#cdata', 4)).value = text;
	          },
	          text: function (text, raw) {
	            var textNode;
	            if (!isInWhiteSpacePreservedElement) {
	              text = text.replace(allWhiteSpaceRegExp, ' ');
	              if (isLineBreakNode(node.lastChild, blockElements)) {
	                text = text.replace(startWhiteSpaceRegExp, '');
	              }
	            }
	            if (text.length !== 0) {
	              textNode = createNode('#text', 3);
	              textNode.raw = !!raw;
	              node.append(textNode).value = text;
	            }
	          },
	          comment: function (text) {
	            node.append(createNode('#comment', 8)).value = text;
	          },
	          pi: function (name, text) {
	            node.append(createNode(name, 7)).value = text;
	            removeWhitespaceBefore(node);
	          },
	          doctype: function (text) {
	            var newNode = node.append(createNode('#doctype', 10));
	            newNode.value = text;
	            removeWhitespaceBefore(node);
	          },
	          start: function (name, attrs, empty) {
	            var elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              var newNode = createNode(elementRule.outputName || name, 1);
	              newNode.attributes = attrs;
	              newNode.shortEnded = empty;
	              node.append(newNode);
	              var parent_2 = children[node.name];
	              if (parent_2 && children[newNode.name] && !parent_2[newNode.name]) {
	                invalidChildren.push(newNode);
	              }
	              var attrFiltersLen = attributeFilters.length;
	              while (attrFiltersLen--) {
	                var attrName = attributeFilters[attrFiltersLen].name;
	                if (attrName in attrs.map) {
	                  list = matchedAttributes[attrName];
	                  if (list) {
	                    list.push(newNode);
	                  } else {
	                    matchedAttributes[attrName] = [newNode];
	                  }
	                }
	              }
	              if (blockElements[name]) {
	                removeWhitespaceBefore(newNode);
	              }
	              if (!empty) {
	                node = newNode;
	              }
	              if (!isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = true;
	              }
	            }
	          },
	          end: function (name) {
	            var textNode, text, sibling;
	            var elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              if (blockElements[name]) {
	                if (!isInWhiteSpacePreservedElement) {
	                  textNode = node.firstChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(startWhiteSpaceRegExp, '');
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.next;
	                    } else {
	                      sibling = textNode.next;
	                      textNode.remove();
	                      textNode = sibling;
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.next;
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                  textNode = node.lastChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(endWhiteSpaceRegExp, '');
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.prev;
	                    } else {
	                      sibling = textNode.prev;
	                      textNode.remove();
	                      textNode = sibling;
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.prev;
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                }
	              }
	              if (isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = false;
	              }
	              var isNodeEmpty = isEmpty(schema, nonEmptyElements, whiteSpaceElements, node);
	              var parentNode = node.parent;
	              if (elementRule.paddInEmptyBlock && isNodeEmpty && isTextRootBlockEmpty(node)) {
	                paddEmptyNode(settings, args, blockElements, node);
	              } else if (elementRule.removeEmpty && isNodeEmpty) {
	                if (blockElements[node.name]) {
	                  node.empty().remove();
	                } else {
	                  node.unwrap();
	                }
	              } else if (elementRule.paddEmpty && (isPaddedWithNbsp(node) || isNodeEmpty)) {
	                paddEmptyNode(settings, args, blockElements, node);
	              }
	              node = parentNode;
	            }
	          }
	        }, schema);
	        var rootNode = node = new AstNode(args.context || settings.root_name, 11);
	        parser.parse(html, args.format);
	        if (validate && invalidChildren.length) {
	          if (!args.context) {
	            fixInvalidChildren(invalidChildren);
	          } else {
	            args.invalid = true;
	          }
	        }
	        if (rootBlockName && (rootNode.name === 'body' || args.isRootContent)) {
	          addRootBlocks();
	        }
	        if (!args.invalid) {
	          for (name in matchedNodes) {
	            if (!has$2(matchedNodes, name)) {
	              continue;
	            }
	            list = nodeFilters[name];
	            nodes = matchedNodes[name];
	            fi = nodes.length;
	            while (fi--) {
	              if (!nodes[fi].parent) {
	                nodes.splice(fi, 1);
	              }
	            }
	            for (i = 0, l = list.length; i < l; i++) {
	              list[i](nodes, name, args);
	            }
	          }
	          for (i = 0, l = attributeFilters.length; i < l; i++) {
	            list = attributeFilters[i];
	            if (list.name in matchedAttributes) {
	              nodes = matchedAttributes[list.name];
	              fi = nodes.length;
	              while (fi--) {
	                if (!nodes[fi].parent) {
	                  nodes.splice(fi, 1);
	                }
	              }
	              for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
	                list.callbacks[fi](nodes, list.name, args);
	              }
	            }
	          }
	        }
	        return rootNode;
	      };
	      var exports = {
	        schema: schema,
	        addAttributeFilter: addAttributeFilter,
	        getAttributeFilters: getAttributeFilters,
	        addNodeFilter: addNodeFilter,
	        getNodeFilters: getNodeFilters,
	        filterNode: filterNode,
	        parse: parse
	      };
	      register$1(exports, settings);
	      register$2(exports, settings);
	      return exports;
	    };
	
	    var register = function (htmlParser, settings, dom) {
	      htmlParser.addAttributeFilter('data-mce-tabindex', function (nodes, name) {
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          node.attr('tabindex', node.attr('data-mce-tabindex'));
	          node.attr(name, null);
	        }
	      });
	      htmlParser.addAttributeFilter('src,href,style', function (nodes, name) {
	        var internalName = 'data-mce-' + name;
	        var urlConverter = settings.url_converter;
	        var urlConverterScope = settings.url_converter_scope;
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          var value = node.attr(internalName);
	          if (value !== undefined) {
	            node.attr(name, value.length > 0 ? value : null);
	            node.attr(internalName, null);
	          } else {
	            value = node.attr(name);
	            if (name === 'style') {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	            } else if (urlConverter) {
	              value = urlConverter.call(urlConverterScope, value, name, node.name);
	            }
	            node.attr(name, value.length > 0 ? value : null);
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          var value = node.attr('class');
	          if (value) {
	            value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
	            node.attr('class', value.length > 0 ? value : null);
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes, name, args) {
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          if (node.attr('data-mce-type') === 'bookmark' && !args.cleanup) {
	            var hasChildren = Optional.from(node.firstChild).exists(function (firstChild) {
	              return !isZwsp(firstChild.value);
	            });
	            if (hasChildren) {
	              node.unwrap();
	            } else {
	              node.remove();
	            }
	          }
	        }
	      });
	      htmlParser.addNodeFilter('noscript', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i].firstChild;
	          if (node) {
	            node.value = Entities.decode(node.value);
	          }
	        }
	      });
	      htmlParser.addNodeFilter('script,style', function (nodes, name) {
	        var trim = function (value) {
	          return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n').replace(/^[\r\n]*|[\r\n]*$/g, '').replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '').replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
	        };
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          var value = node.firstChild ? node.firstChild.value : '';
	          if (name === 'script') {
	            var type = node.attr('type');
	            if (type) {
	              node.attr('type', type === 'mce-no/type' ? null : type.replace(/^mce\-/, ''));
	            }
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>';
	            }
	          } else {
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '<!--\n' + trim(value) + '\n-->';
	            }
	          }
	        }
	      });
	      htmlParser.addNodeFilter('#comment', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          if (settings.preserve_cdata && node.value.indexOf('[CDATA[') === 0) {
	            node.name = '#cdata';
	            node.type = 4;
	            node.value = dom.decode(node.value.replace(/^\[CDATA\[|\]\]$/g, ''));
	          } else if (node.value.indexOf('mce:protected ') === 0) {
	            node.name = '#text';
	            node.type = 3;
	            node.raw = true;
	            node.value = unescape(node.value).substr(14);
	          }
	        }
	      });
	      htmlParser.addNodeFilter('xml:namespace,input', function (nodes, name) {
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          if (node.type === 7) {
	            node.remove();
	          } else if (node.type === 1) {
	            if (name === 'input' && !node.attr('type')) {
	              node.attr('type', 'text');
	            }
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes) {
	        each$k(nodes, function (node) {
	          if (node.attr('data-mce-type') === 'format-caret') {
	            if (node.isEmpty(htmlParser.schema.getNonEmptyElements())) {
	              node.remove();
	            } else {
	              node.unwrap();
	            }
	          }
	        });
	      });
	      htmlParser.addAttributeFilter('data-mce-src,data-mce-href,data-mce-style,' + 'data-mce-selected,data-mce-expando,' + 'data-mce-type,data-mce-resize,data-mce-placeholder', function (nodes, name) {
	        var i = nodes.length;
	        while (i--) {
	          nodes[i].attr(name, null);
	        }
	      });
	    };
	    var trimTrailingBr = function (rootNode) {
	      var isBr = function (node) {
	        return node && node.name === 'br';
	      };
	      var brNode1 = rootNode.lastChild;
	      if (isBr(brNode1)) {
	        var brNode2 = brNode1.prev;
	        if (isBr(brNode2)) {
	          brNode1.remove();
	          brNode2.remove();
	        }
	      }
	    };
	
	    var preProcess = function (editor, node, args) {
	      var oldDoc;
	      var dom = editor.dom;
	      var clonedNode = node.cloneNode(true);
	      var impl = document.implementation;
	      if (impl.createHTMLDocument) {
	        var doc_1 = impl.createHTMLDocument('');
	        Tools.each(clonedNode.nodeName === 'BODY' ? clonedNode.childNodes : [clonedNode], function (node) {
	          doc_1.body.appendChild(doc_1.importNode(node, true));
	        });
	        if (clonedNode.nodeName !== 'BODY') {
	          clonedNode = doc_1.body.firstChild;
	        } else {
	          clonedNode = doc_1.body;
	        }
	        oldDoc = dom.doc;
	        dom.doc = doc_1;
	      }
	      firePreProcess(editor, __assign(__assign({}, args), { node: clonedNode }));
	      if (oldDoc) {
	        dom.doc = oldDoc;
	      }
	      return clonedNode;
	    };
	    var shouldFireEvent = function (editor, args) {
	      return editor && editor.hasEventListeners('PreProcess') && !args.no_events;
	    };
	    var process = function (editor, node, args) {
	      return shouldFireEvent(editor, args) ? preProcess(editor, node, args) : node;
	    };
	
	    var addTempAttr = function (htmlParser, tempAttrs, name) {
	      if (Tools.inArray(tempAttrs, name) === -1) {
	        htmlParser.addAttributeFilter(name, function (nodes, name) {
	          var i = nodes.length;
	          while (i--) {
	            nodes[i].attr(name, null);
	          }
	        });
	        tempAttrs.push(name);
	      }
	    };
	    var postProcess = function (editor, args, content) {
	      if (!args.no_events && editor) {
	        var outArgs = firePostProcess(editor, __assign(__assign({}, args), { content: content }));
	        return outArgs.content;
	      } else {
	        return content;
	      }
	    };
	    var getHtmlFromNode = function (dom, node, args) {
	      var html = trim$2(args.getInner ? node.innerHTML : dom.getOuterHTML(node));
	      return args.selection || isWsPreserveElement(SugarElement.fromDom(node)) ? html : Tools.trim(html);
	    };
	    var parseHtml = function (htmlParser, html, args) {
	      var parserArgs = args.selection ? __assign({ forced_root_block: false }, args) : args;
	      var rootNode = htmlParser.parse(html, parserArgs);
	      trimTrailingBr(rootNode);
	      return rootNode;
	    };
	    var serializeNode = function (settings, schema, node) {
	      var htmlSerializer = HtmlSerializer(settings, schema);
	      return htmlSerializer.serialize(node);
	    };
	    var toHtml = function (editor, settings, schema, rootNode, args) {
	      var content = serializeNode(settings, schema, rootNode);
	      return postProcess(editor, args, content);
	    };
	    var DomSerializerImpl = function (settings, editor) {
	      var tempAttrs = ['data-mce-selected'];
	      var dom = editor && editor.dom ? editor.dom : DOMUtils.DOM;
	      var schema = editor && editor.schema ? editor.schema : Schema(settings);
	      settings.entity_encoding = settings.entity_encoding || 'named';
	      settings.remove_trailing_brs = 'remove_trailing_brs' in settings ? settings.remove_trailing_brs : true;
	      var htmlParser = DomParser(settings, schema);
	      register(htmlParser, settings, dom);
	      var serialize = function (node, parserArgs) {
	        if (parserArgs === void 0) {
	          parserArgs = {};
	        }
	        var args = __assign({ format: 'html' }, parserArgs);
	        var targetNode = process(editor, node, args);
	        var html = getHtmlFromNode(dom, targetNode, args);
	        var rootNode = parseHtml(htmlParser, html, args);
	        return args.format === 'tree' ? rootNode : toHtml(editor, settings, schema, rootNode, args);
	      };
	      return {
	        schema: schema,
	        addNodeFilter: htmlParser.addNodeFilter,
	        addAttributeFilter: htmlParser.addAttributeFilter,
	        serialize: serialize,
	        addRules: schema.addValidElements,
	        setRules: schema.setValidElements,
	        addTempAttr: curry(addTempAttr, htmlParser, tempAttrs),
	        getTempAttrs: constant(tempAttrs),
	        getNodeFilters: htmlParser.getNodeFilters,
	        getAttributeFilters: htmlParser.getAttributeFilters
	      };
	    };
	
	    var DomSerializer = function (settings, editor) {
	      var domSerializer = DomSerializerImpl(settings, editor);
	      return {
	        schema: domSerializer.schema,
	        addNodeFilter: domSerializer.addNodeFilter,
	        addAttributeFilter: domSerializer.addAttributeFilter,
	        serialize: domSerializer.serialize,
	        addRules: domSerializer.addRules,
	        setRules: domSerializer.setRules,
	        addTempAttr: domSerializer.addTempAttr,
	        getTempAttrs: domSerializer.getTempAttrs,
	        getNodeFilters: domSerializer.getNodeFilters,
	        getAttributeFilters: domSerializer.getAttributeFilters
	      };
	    };
	
	    var defaultFormat = 'html';
	    var getContent = function (editor, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      var format = args.format ? args.format : defaultFormat;
	      return getContent$2(editor, args, format);
	    };
	
	    var setContent = function (editor, content, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      return setContent$2(editor, content, args);
	    };
	
	    var DOM$7 = DOMUtils.DOM;
	    var restoreOriginalStyles = function (editor) {
	      DOM$7.setStyle(editor.id, 'display', editor.orgDisplay);
	    };
	    var safeDestroy = function (x) {
	      return Optional.from(x).each(function (x) {
	        return x.destroy();
	      });
	    };
	    var clearDomReferences = function (editor) {
	      editor.contentAreaContainer = editor.formElement = editor.container = editor.editorContainer = null;
	      editor.bodyElement = editor.contentDocument = editor.contentWindow = null;
	      editor.iframeElement = editor.targetElm = null;
	      if (editor.selection) {
	        editor.selection = editor.selection.win = editor.selection.dom = editor.selection.dom.doc = null;
	      }
	    };
	    var restoreForm = function (editor) {
	      var form = editor.formElement;
	      if (form) {
	        if (form._mceOldSubmit) {
	          form.submit = form._mceOldSubmit;
	          form._mceOldSubmit = null;
	        }
	        DOM$7.unbind(form, 'submit reset', editor.formEventDelegate);
	      }
	    };
	    var remove = function (editor) {
	      if (!editor.removed) {
	        var _selectionOverrides = editor._selectionOverrides, editorUpload = editor.editorUpload;
	        var body = editor.getBody();
	        var element = editor.getElement();
	        if (body) {
	          editor.save({ is_removing: true });
	        }
	        editor.removed = true;
	        editor.unbindAllNativeEvents();
	        if (editor.hasHiddenInput && element) {
	          DOM$7.remove(element.nextSibling);
	        }
	        fireRemove(editor);
	        editor.editorManager.remove(editor);
	        if (!editor.inline && body) {
	          restoreOriginalStyles(editor);
	        }
	        fireDetach(editor);
	        DOM$7.remove(editor.getContainer());
	        safeDestroy(_selectionOverrides);
	        safeDestroy(editorUpload);
	        editor.destroy();
	      }
	    };
	    var destroy = function (editor, automatic) {
	      var selection = editor.selection, dom = editor.dom;
	      if (editor.destroyed) {
	        return;
	      }
	      if (!automatic && !editor.removed) {
	        editor.remove();
	        return;
	      }
	      if (!automatic) {
	        editor.editorManager.off('beforeunload', editor._beforeUnload);
	        if (editor.theme && editor.theme.destroy) {
	          editor.theme.destroy();
	        }
	        safeDestroy(selection);
	        safeDestroy(dom);
	      }
	      restoreForm(editor);
	      clearDomReferences(editor);
	      editor.destroyed = true;
	    };
	
	    var deep = function (old, nu) {
	      var bothObjects = isObject(old) && isObject(nu);
	      return bothObjects ? deepMerge(old, nu) : nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          objects[_i] = arguments[_i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (has$2(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var deepMerge = baseMerge(deep);
	
	    var deprecatedSettings = ('autoresize_on_init,content_editable_state,convert_fonts_to_spans,inline_styles,padd_empty_with_br,block_elements,' + 'boolean_attributes,editor_deselector,editor_selector,elements,file_browser_callback_types,filepicker_validator_handler,' + 'force_hex_style_colors,force_p_newlines,gecko_spellcheck,images_dataimg_filter,media_scripts,mode,move_caret_before_on_enter_elements,' + 'non_empty_elements,self_closing_elements,short_ended_elements,special,spellchecker_select_languages,spellchecker_whitelist,' + 'tab_focus,table_responsive_width,text_block_elements,text_inline_elements,toolbar_drawer,types,validate,whitespace_elements,' + 'paste_word_valid_elements,paste_retain_style_properties,paste_convert_word_fake_lists').split(',');
	    var deprecatedPlugins = 'bbcode,colorpicker,contextmenu,fullpage,legacyoutput,spellchecker,textcolor'.split(',');
	    var movedToPremiumPlugins = 'imagetools,toc'.split(',');
	    var getDeprecatedSettings = function (settings) {
	      var settingNames = filter$4(deprecatedSettings, function (setting) {
	        return has$2(settings, setting);
	      });
	      var forcedRootBlock = settings.forced_root_block;
	      if (forcedRootBlock === false || forcedRootBlock === '') {
	        settingNames.push('forced_root_block (false only)');
	      }
	      return sort(settingNames);
	    };
	    var getDeprecatedPlugins = function (settings) {
	      var plugins = Tools.makeMap(settings.plugins, ' ');
	      var hasPlugin = function (plugin) {
	        return has$2(plugins, plugin);
	      };
	      var pluginNames = __spreadArray(__spreadArray([], filter$4(deprecatedPlugins, hasPlugin), true), bind(movedToPremiumPlugins, function (plugin) {
	        return hasPlugin(plugin) ? [plugin + ' (moving to premium)'] : [];
	      }), true);
	      return sort(pluginNames);
	    };
	    var logDeprecationsWarning = function (rawSettings, finalSettings) {
	      var deprecatedSettings = getDeprecatedSettings(rawSettings);
	      var deprecatedPlugins = getDeprecatedPlugins(finalSettings);
	      var hasDeprecatedPlugins = deprecatedPlugins.length > 0;
	      var hasDeprecatedSettings = deprecatedSettings.length > 0;
	      var isLegacyMobileTheme = finalSettings.theme === 'mobile';
	      if (hasDeprecatedPlugins || hasDeprecatedSettings || isLegacyMobileTheme) {
	        var listJoiner = '\n- ';
	        var themesMessage = isLegacyMobileTheme ? '\n\nThemes:' + listJoiner + 'mobile' : '';
	        var pluginsMessage = hasDeprecatedPlugins ? '\n\nPlugins:' + listJoiner + deprecatedPlugins.join(listJoiner) : '';
	        var settingsMessage = hasDeprecatedSettings ? '\n\nSettings:' + listJoiner + deprecatedSettings.join(listJoiner) : '';
	        console.warn('The following deprecated features are currently enabled, these will be removed in TinyMCE 6.0. ' + 'See https://www.tiny.cloud/docs/release-notes/6.0-upcoming-changes/ for more information.' + themesMessage + pluginsMessage + settingsMessage);
	      }
	    };
	
	    var sectionResult = function (sections, settings) {
	      return {
	        sections: constant(sections),
	        settings: constant(settings)
	      };
	    };
	    var deviceDetection = detect().deviceType;
	    var isTouch = deviceDetection.isTouch();
	    var isPhone = deviceDetection.isPhone();
	    var isTablet = deviceDetection.isTablet();
	    var legacyMobilePlugins = [
	      'lists',
	      'autolink',
	      'autosave'
	    ];
	    var defaultTouchSettings = {
	      table_grid: false,
	      object_resizing: false,
	      resize: false
	    };
	    var normalizePlugins = function (plugins) {
	      var pluginNames = isArray$1(plugins) ? plugins.join(' ') : plugins;
	      var trimmedPlugins = map$3(isString$1(pluginNames) ? pluginNames.split(' ') : [], trim$4);
	      return filter$4(trimmedPlugins, function (item) {
	        return item.length > 0;
	      });
	    };
	    var filterLegacyMobilePlugins = function (plugins) {
	      return filter$4(plugins, curry(contains$3, legacyMobilePlugins));
	    };
	    var extractSections = function (keys, settings) {
	      var result = bifilter(settings, function (value, key) {
	        return contains$3(keys, key);
	      });
	      return sectionResult(result.t, result.f);
	    };
	    var getSection = function (sectionResult, name, defaults) {
	      if (defaults === void 0) {
	        defaults = {};
	      }
	      var sections = sectionResult.sections();
	      var sectionSettings = get$9(sections, name).getOr({});
	      return Tools.extend({}, defaults, sectionSettings);
	    };
	    var hasSection = function (sectionResult, name) {
	      return has$2(sectionResult.sections(), name);
	    };
	    var isSectionTheme = function (sectionResult, name, theme) {
	      var section = sectionResult.sections();
	      return hasSection(sectionResult, name) && section[name].theme === theme;
	    };
	    var getSectionConfig = function (sectionResult, name) {
	      return hasSection(sectionResult, name) ? sectionResult.sections()[name] : {};
	    };
	    var getToolbarMode = function (settings, defaultVal) {
	      return get$9(settings, 'toolbar_mode').orThunk(function () {
	        return get$9(settings, 'toolbar_drawer').map(function (val) {
	          return val === false ? 'wrap' : val;
	        });
	      }).getOr(defaultVal);
	    };
	    var getDefaultSettings = function (settings, id, documentBaseUrl, isTouch, editor) {
	      var baseDefaults = {
	        id: id,
	        theme: 'silver',
	        toolbar_mode: getToolbarMode(settings, 'floating'),
	        plugins: '',
	        document_base_url: documentBaseUrl,
	        add_form_submit_trigger: true,
	        submit_patch: true,
	        add_unload_trigger: true,
	        convert_urls: true,
	        relative_urls: true,
	        remove_script_host: true,
	        object_resizing: true,
	        doctype: '<!DOCTYPE html>',
	        visual: true,
	        font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
	        forced_root_block: 'p',
	        hidden_input: true,
	        inline_styles: true,
	        convert_fonts_to_spans: true,
	        indent: true,
	        indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        entity_encoding: 'named',
	        url_converter: editor.convertURL,
	        url_converter_scope: editor
	      };
	      return __assign(__assign({}, baseDefaults), isTouch ? defaultTouchSettings : {});
	    };
	    var getDefaultMobileSettings = function (mobileSettings, isPhone) {
	      var defaultMobileSettings = {
	        resize: false,
	        toolbar_mode: getToolbarMode(mobileSettings, 'scrolling'),
	        toolbar_sticky: false
	      };
	      var defaultPhoneSettings = { menubar: false };
	      return __assign(__assign(__assign({}, defaultTouchSettings), defaultMobileSettings), isPhone ? defaultPhoneSettings : {});
	    };
	    var getExternalPlugins = function (overrideSettings, settings) {
	      var userDefinedExternalPlugins = settings.external_plugins ? settings.external_plugins : {};
	      if (overrideSettings && overrideSettings.external_plugins) {
	        return Tools.extend({}, overrideSettings.external_plugins, userDefinedExternalPlugins);
	      } else {
	        return userDefinedExternalPlugins;
	      }
	    };
	    var combinePlugins = function (forcedPlugins, plugins) {
	      return [].concat(normalizePlugins(forcedPlugins)).concat(normalizePlugins(plugins));
	    };
	    var getPlatformPlugins = function (isMobileDevice, sectionResult, desktopPlugins, mobilePlugins) {
	      if (isMobileDevice && isSectionTheme(sectionResult, 'mobile', 'mobile')) {
	        return filterLegacyMobilePlugins(mobilePlugins);
	      } else if (isMobileDevice && hasSection(sectionResult, 'mobile')) {
	        return mobilePlugins;
	      } else {
	        return desktopPlugins;
	      }
	    };
	    var processPlugins = function (isMobileDevice, sectionResult, defaultOverrideSettings, settings) {
	      var forcedPlugins = normalizePlugins(defaultOverrideSettings.forced_plugins);
	      var desktopPlugins = normalizePlugins(settings.plugins);
	      var mobileConfig = getSectionConfig(sectionResult, 'mobile');
	      var mobilePlugins = mobileConfig.plugins ? normalizePlugins(mobileConfig.plugins) : desktopPlugins;
	      var platformPlugins = getPlatformPlugins(isMobileDevice, sectionResult, desktopPlugins, mobilePlugins);
	      var combinedPlugins = combinePlugins(forcedPlugins, platformPlugins);
	      if (Env.browser.isIE() && contains$3(combinedPlugins, 'rtc')) {
	        throw new Error('RTC plugin is not supported on IE 11.');
	      }
	      return Tools.extend(settings, { plugins: combinedPlugins.join(' ') });
	    };
	    var isOnMobile = function (isMobileDevice, sectionResult) {
	      return isMobileDevice && hasSection(sectionResult, 'mobile');
	    };
	    var combineSettings = function (isMobileDevice, isPhone, defaultSettings, defaultOverrideSettings, settings) {
	      var defaultDeviceSettings = isMobileDevice ? { mobile: getDefaultMobileSettings(settings.mobile || {}, isPhone) } : {};
	      var sectionResult = extractSections(['mobile'], deepMerge(defaultDeviceSettings, settings));
	      var extendedSettings = Tools.extend(defaultSettings, defaultOverrideSettings, sectionResult.settings(), isOnMobile(isMobileDevice, sectionResult) ? getSection(sectionResult, 'mobile') : {}, {
	        validate: true,
	        external_plugins: getExternalPlugins(defaultOverrideSettings, sectionResult.settings())
	      });
	      return processPlugins(isMobileDevice, sectionResult, defaultOverrideSettings, extendedSettings);
	    };
	    var getEditorSettings = function (editor, id, documentBaseUrl, defaultOverrideSettings, settings) {
	      var defaultSettings = getDefaultSettings(settings, id, documentBaseUrl, isTouch, editor);
	      var finalSettings = combineSettings(isPhone || isTablet, isPhone, defaultSettings, defaultOverrideSettings, settings);
	      if (finalSettings.deprecation_warnings !== false) {
	        logDeprecationsWarning(settings, finalSettings);
	      }
	      return finalSettings;
	    };
	    var getFiltered = function (predicate, editor, name) {
	      return Optional.from(editor.settings[name]).filter(predicate);
	    };
	    var getParamObject = function (value) {
	      var output = {};
	      if (typeof value === 'string') {
	        each$k(value.indexOf('=') > 0 ? value.split(/[;,](?![^=;,]*(?:[;,]|$))/) : value.split(','), function (val) {
	          var arr = val.split('=');
	          if (arr.length > 1) {
	            output[Tools.trim(arr[0])] = Tools.trim(arr[1]);
	          } else {
	            output[Tools.trim(arr[0])] = Tools.trim(arr[0]);
	          }
	        });
	      } else {
	        output = value;
	      }
	      return output;
	    };
	    var isArrayOf = function (p) {
	      return function (a) {
	        return isArray$1(a) && forall(a, p);
	      };
	    };
	    var getParam = function (editor, name, defaultVal, type) {
	      var value = name in editor.settings ? editor.settings[name] : defaultVal;
	      if (type === 'hash') {
	        return getParamObject(value);
	      } else if (type === 'string') {
	        return getFiltered(isString$1, editor, name).getOr(defaultVal);
	      } else if (type === 'number') {
	        return getFiltered(isNumber, editor, name).getOr(defaultVal);
	      } else if (type === 'boolean') {
	        return getFiltered(isBoolean, editor, name).getOr(defaultVal);
	      } else if (type === 'object') {
	        return getFiltered(isObject, editor, name).getOr(defaultVal);
	      } else if (type === 'array') {
	        return getFiltered(isArray$1, editor, name).getOr(defaultVal);
	      } else if (type === 'string[]') {
	        return getFiltered(isArrayOf(isString$1), editor, name).getOr(defaultVal);
	      } else if (type === 'function') {
	        return getFiltered(isFunction, editor, name).getOr(defaultVal);
	      } else {
	        return value;
	      }
	    };
	
	    var CreateIconManager = function () {
	      var lookup = {};
	      var add = function (id, iconPack) {
	        lookup[id] = iconPack;
	      };
	      var get = function (id) {
	        if (lookup[id]) {
	          return lookup[id];
	        }
	        return { icons: {} };
	      };
	      var has = function (id) {
	        return has$2(lookup, id);
	      };
	      return {
	        add: add,
	        get: get,
	        has: has
	      };
	    };
	    var IconManager = CreateIconManager();
	
	    var getProp = function (propName, elm) {
	      var rawElm = elm.dom;
	      return rawElm[propName];
	    };
	    var getComputedSizeProp = function (propName, elm) {
	      return parseInt(get$5(elm, propName), 10);
	    };
	    var getClientWidth = curry(getProp, 'clientWidth');
	    var getClientHeight = curry(getProp, 'clientHeight');
	    var getMarginTop = curry(getComputedSizeProp, 'margin-top');
	    var getMarginLeft = curry(getComputedSizeProp, 'margin-left');
	    var getBoundingClientRect = function (elm) {
	      return elm.dom.getBoundingClientRect();
	    };
	    var isInsideElementContentArea = function (bodyElm, clientX, clientY) {
	      var clientWidth = getClientWidth(bodyElm);
	      var clientHeight = getClientHeight(bodyElm);
	      return clientX >= 0 && clientY >= 0 && clientX <= clientWidth && clientY <= clientHeight;
	    };
	    var transpose = function (inline, elm, clientX, clientY) {
	      var clientRect = getBoundingClientRect(elm);
	      var deltaX = inline ? clientRect.left + elm.dom.clientLeft + getMarginLeft(elm) : 0;
	      var deltaY = inline ? clientRect.top + elm.dom.clientTop + getMarginTop(elm) : 0;
	      var x = clientX - deltaX;
	      var y = clientY - deltaY;
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var isXYInContentArea = function (editor, clientX, clientY) {
	      var bodyElm = SugarElement.fromDom(editor.getBody());
	      var targetElm = editor.inline ? bodyElm : documentElement(bodyElm);
	      var transposedPoint = transpose(editor.inline, targetElm, clientX, clientY);
	      return isInsideElementContentArea(targetElm, transposedPoint.x, transposedPoint.y);
	    };
	    var fromDomSafe = function (node) {
	      return Optional.from(node).map(SugarElement.fromDom);
	    };
	    var isEditorAttachedToDom = function (editor) {
	      var rawContainer = editor.inline ? editor.getBody() : editor.getContentAreaContainer();
	      return fromDomSafe(rawContainer).map(inBody).getOr(false);
	    };
	
	    var NotificationManagerImpl = function () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a NotificationManager implementation.');
	      };
	      return {
	        open: unimplemented,
	        close: unimplemented,
	        reposition: unimplemented,
	        getArgs: unimplemented
	      };
	    };
	
	    var NotificationManager = function (editor) {
	      var notifications = [];
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getNotificationManagerImpl ? theme.getNotificationManagerImpl() : NotificationManagerImpl();
	      };
	      var getTopNotification = function () {
	        return Optional.from(notifications[0]);
	      };
	      var isEqual = function (a, b) {
	        return a.type === b.type && a.text === b.text && !a.progressBar && !a.timeout && !b.progressBar && !b.timeout;
	      };
	      var reposition = function () {
	        if (notifications.length > 0) {
	          getImplementation().reposition(notifications);
	        }
	      };
	      var addNotification = function (notification) {
	        notifications.push(notification);
	      };
	      var closeNotification = function (notification) {
	        findIndex$2(notifications, function (otherNotification) {
	          return otherNotification === notification;
	        }).each(function (index) {
	          notifications.splice(index, 1);
	        });
	      };
	      var open = function (spec, fireEvent) {
	        if (fireEvent === void 0) {
	          fireEvent = true;
	        }
	        if (editor.removed || !isEditorAttachedToDom(editor)) {
	          return;
	        }
	        if (fireEvent) {
	          editor.fire('BeforeOpenNotification', { notification: spec });
	        }
	        return find$3(notifications, function (notification) {
	          return isEqual(getImplementation().getArgs(notification), spec);
	        }).getOrThunk(function () {
	          editor.editorManager.setActive(editor);
	          var notification = getImplementation().open(spec, function () {
	            closeNotification(notification);
	            reposition();
	            getTopNotification().fold(function () {
	              return editor.focus();
	            }, function (top) {
	              return focus$1(SugarElement.fromDom(top.getEl()));
	            });
	          });
	          addNotification(notification);
	          reposition();
	          editor.fire('OpenNotification', { notification: __assign({}, notification) });
	          return notification;
	        });
	      };
	      var close = function () {
	        getTopNotification().each(function (notification) {
	          getImplementation().close(notification);
	          closeNotification(notification);
	          reposition();
	        });
	      };
	      var getNotifications = constant(notifications);
	      var registerEvents = function (editor) {
	        editor.on('SkinLoaded', function () {
	          var serviceMessage = getServiceMessage(editor);
	          if (serviceMessage) {
	            open({
	              text: serviceMessage,
	              type: 'warning',
	              timeout: 0
	            }, false);
	          }
	          reposition();
	        });
	        editor.on('show ResizeEditor ResizeWindow NodeChange', function () {
	          Delay.requestAnimationFrame(reposition);
	        });
	        editor.on('remove', function () {
	          each$k(notifications.slice(), function (notification) {
	            getImplementation().close(notification);
	          });
	        });
	      };
	      registerEvents(editor);
	      return {
	        open: open,
	        close: close,
	        getNotifications: getNotifications
	      };
	    };
	
	    var PluginManager = AddOnManager.PluginManager;
	
	    var ThemeManager = AddOnManager.ThemeManager;
	
	    function WindowManagerImpl () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a WindowManager implementation.');
	      };
	      return {
	        open: unimplemented,
	        openUrl: unimplemented,
	        alert: unimplemented,
	        confirm: unimplemented,
	        close: unimplemented,
	        getParams: unimplemented,
	        setParams: unimplemented
	      };
	    }
	
	    var WindowManager = function (editor) {
	      var dialogs = [];
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getWindowManagerImpl ? theme.getWindowManagerImpl() : WindowManagerImpl();
	      };
	      var funcBind = function (scope, f) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          return f ? f.apply(scope, args) : undefined;
	        };
	      };
	      var fireOpenEvent = function (dialog) {
	        editor.fire('OpenWindow', { dialog: dialog });
	      };
	      var fireCloseEvent = function (dialog) {
	        editor.fire('CloseWindow', { dialog: dialog });
	      };
	      var addDialog = function (dialog) {
	        dialogs.push(dialog);
	        fireOpenEvent(dialog);
	      };
	      var closeDialog = function (dialog) {
	        fireCloseEvent(dialog);
	        dialogs = filter$4(dialogs, function (otherDialog) {
	          return otherDialog !== dialog;
	        });
	        if (dialogs.length === 0) {
	          editor.focus();
	        }
	      };
	      var getTopDialog = function () {
	        return Optional.from(dialogs[dialogs.length - 1]);
	      };
	      var storeSelectionAndOpenDialog = function (openDialog) {
	        editor.editorManager.setActive(editor);
	        store(editor);
	        var dialog = openDialog();
	        addDialog(dialog);
	        return dialog;
	      };
	      var open = function (args, params) {
	        return storeSelectionAndOpenDialog(function () {
	          return getImplementation().open(args, params, closeDialog);
	        });
	      };
	      var openUrl = function (args) {
	        return storeSelectionAndOpenDialog(function () {
	          return getImplementation().openUrl(args, closeDialog);
	        });
	      };
	      var alert = function (message, callback, scope) {
	        var windowManagerImpl = getImplementation();
	        windowManagerImpl.alert(message, funcBind(scope ? scope : windowManagerImpl, callback));
	      };
	      var confirm = function (message, callback, scope) {
	        var windowManagerImpl = getImplementation();
	        windowManagerImpl.confirm(message, funcBind(scope ? scope : windowManagerImpl, callback));
	      };
	      var close = function () {
	        getTopDialog().each(function (dialog) {
	          getImplementation().close(dialog);
	          closeDialog(dialog);
	        });
	      };
	      editor.on('remove', function () {
	        each$k(dialogs, function (dialog) {
	          getImplementation().close(dialog);
	        });
	      });
	      return {
	        open: open,
	        openUrl: openUrl,
	        alert: alert,
	        confirm: confirm,
	        close: close
	      };
	    };
	
	    var displayNotification = function (editor, message) {
	      editor.notificationManager.open({
	        type: 'error',
	        text: message
	      });
	    };
	    var displayError = function (editor, message) {
	      if (editor._skinLoaded) {
	        displayNotification(editor, message);
	      } else {
	        editor.on('SkinLoaded', function () {
	          displayNotification(editor, message);
	        });
	      }
	    };
	    var uploadError = function (editor, message) {
	      displayError(editor, I18n.translate([
	        'Failed to upload image: {0}',
	        message
	      ]));
	    };
	    var logError = function (editor, errorType, msg) {
	      fireError(editor, errorType, { message: msg });
	      console.error(msg);
	    };
	    var createLoadError = function (type, url, name) {
	      return name ? 'Failed to load ' + type + ': ' + name + ' from url ' + url : 'Failed to load ' + type + ' url: ' + url;
	    };
	    var pluginLoadError = function (editor, url, name) {
	      logError(editor, 'PluginLoadError', createLoadError('plugin', url, name));
	    };
	    var iconsLoadError = function (editor, url, name) {
	      logError(editor, 'IconsLoadError', createLoadError('icons', url, name));
	    };
	    var languageLoadError = function (editor, url, name) {
	      logError(editor, 'LanguageLoadError', createLoadError('language', url, name));
	    };
	    var pluginInitError = function (editor, name, err) {
	      var message = I18n.translate([
	        'Failed to initialize plugin: {0}',
	        name
	      ]);
	      fireError(editor, 'PluginLoadError', { message: message });
	      initError(message, err);
	      displayError(editor, message);
	    };
	    var initError = function (message) {
	      var x = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        x[_i - 1] = arguments[_i];
	      }
	      var console = window.console;
	      if (console) {
	        if (console.error) {
	          console.error.apply(console, __spreadArray([message], x, false));
	        } else {
	          console.log.apply(console, __spreadArray([message], x, false));
	        }
	      }
	    };
	
	    var isContentCssSkinName = function (url) {
	      return /^[a-z0-9\-]+$/i.test(url);
	    };
	    var getContentCssUrls = function (editor) {
	      return transformToUrls(editor, getContentCss(editor));
	    };
	    var getFontCssUrls = function (editor) {
	      return transformToUrls(editor, getFontCss(editor));
	    };
	    var transformToUrls = function (editor, cssLinks) {
	      var skinUrl = editor.editorManager.baseURL + '/skins/content';
	      var suffix = editor.editorManager.suffix;
	      var contentCssFile = 'content' + suffix + '.css';
	      var inline = editor.inline === true;
	      return map$3(cssLinks, function (url) {
	        if (isContentCssSkinName(url) && !inline) {
	          return skinUrl + '/' + url + '/' + contentCssFile;
	        } else {
	          return editor.documentBaseURI.toAbsolute(url);
	        }
	      });
	    };
	    var appendContentCssFromSettings = function (editor) {
	      editor.contentCSS = editor.contentCSS.concat(getContentCssUrls(editor), getFontCssUrls(editor));
	    };
	
	    var UploadStatus = function () {
	      var PENDING = 1, UPLOADED = 2;
	      var blobUriStatuses = {};
	      var createStatus = function (status, resultUri) {
	        return {
	          status: status,
	          resultUri: resultUri
	        };
	      };
	      var hasBlobUri = function (blobUri) {
	        return blobUri in blobUriStatuses;
	      };
	      var getResultUri = function (blobUri) {
	        var result = blobUriStatuses[blobUri];
	        return result ? result.resultUri : null;
	      };
	      var isPending = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === PENDING : false;
	      };
	      var isUploaded = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === UPLOADED : false;
	      };
	      var markPending = function (blobUri) {
	        blobUriStatuses[blobUri] = createStatus(PENDING, null);
	      };
	      var markUploaded = function (blobUri, resultUri) {
	        blobUriStatuses[blobUri] = createStatus(UPLOADED, resultUri);
	      };
	      var removeFailed = function (blobUri) {
	        delete blobUriStatuses[blobUri];
	      };
	      var destroy = function () {
	        blobUriStatuses = {};
	      };
	      return {
	        hasBlobUri: hasBlobUri,
	        getResultUri: getResultUri,
	        isPending: isPending,
	        isUploaded: isUploaded,
	        markPending: markPending,
	        markUploaded: markUploaded,
	        removeFailed: removeFailed,
	        destroy: destroy
	      };
	    };
	
	    var count = 0;
	    var seed = function () {
	      var rnd = function () {
	        return Math.round(Math.random() * 4294967295).toString(36);
	      };
	      var now = new Date().getTime();
	      return 's' + now.toString(36) + rnd() + rnd() + rnd();
	    };
	    var uuid = function (prefix) {
	      return prefix + count++ + seed();
	    };
	
	    var BlobCache = function () {
	      var cache = [];
	      var mimeToExt = function (mime) {
	        var mimes = {
	          'image/jpeg': 'jpg',
	          'image/jpg': 'jpg',
	          'image/gif': 'gif',
	          'image/png': 'png',
	          'image/apng': 'apng',
	          'image/avif': 'avif',
	          'image/svg+xml': 'svg',
	          'image/webp': 'webp',
	          'image/bmp': 'bmp',
	          'image/tiff': 'tiff'
	        };
	        return mimes[mime.toLowerCase()] || 'dat';
	      };
	      var create = function (o, blob, base64, name, filename) {
	        if (isString$1(o)) {
	          var id = o;
	          return toBlobInfo({
	            id: id,
	            name: name,
	            filename: filename,
	            blob: blob,
	            base64: base64
	          });
	        } else if (isObject(o)) {
	          return toBlobInfo(o);
	        } else {
	          throw new Error('Unknown input type');
	        }
	      };
	      var toBlobInfo = function (o) {
	        if (!o.blob || !o.base64) {
	          throw new Error('blob and base64 representations of the image are required for BlobInfo to be created');
	        }
	        var id = o.id || uuid('blobid');
	        var name = o.name || id;
	        var blob = o.blob;
	        return {
	          id: constant(id),
	          name: constant(name),
	          filename: constant(o.filename || name + '.' + mimeToExt(blob.type)),
	          blob: constant(blob),
	          base64: constant(o.base64),
	          blobUri: constant(o.blobUri || URL.createObjectURL(blob)),
	          uri: constant(o.uri)
	        };
	      };
	      var add = function (blobInfo) {
	        if (!get(blobInfo.id())) {
	          cache.push(blobInfo);
	        }
	      };
	      var findFirst = function (predicate) {
	        return find$3(cache, predicate).getOrUndefined();
	      };
	      var get = function (id) {
	        return findFirst(function (cachedBlobInfo) {
	          return cachedBlobInfo.id() === id;
	        });
	      };
	      var getByUri = function (blobUri) {
	        return findFirst(function (blobInfo) {
	          return blobInfo.blobUri() === blobUri;
	        });
	      };
	      var getByData = function (base64, type) {
	        return findFirst(function (blobInfo) {
	          return blobInfo.base64() === base64 && blobInfo.blob().type === type;
	        });
	      };
	      var removeByUri = function (blobUri) {
	        cache = filter$4(cache, function (blobInfo) {
	          if (blobInfo.blobUri() === blobUri) {
	            URL.revokeObjectURL(blobInfo.blobUri());
	            return false;
	          }
	          return true;
	        });
	      };
	      var destroy = function () {
	        each$k(cache, function (cachedBlobInfo) {
	          URL.revokeObjectURL(cachedBlobInfo.blobUri());
	        });
	        cache = [];
	      };
	      return {
	        create: create,
	        add: add,
	        get: get,
	        getByUri: getByUri,
	        getByData: getByData,
	        findFirst: findFirst,
	        removeByUri: removeByUri,
	        destroy: destroy
	      };
	    };
	
	    var Uploader = function (uploadStatus, settings) {
	      var pendingPromises = {};
	      var pathJoin = function (path1, path2) {
	        if (path1) {
	          return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
	        }
	        return path2;
	      };
	      var defaultHandler = function (blobInfo, success, failure, progress) {
	        var xhr = new XMLHttpRequest();
	        xhr.open('POST', settings.url);
	        xhr.withCredentials = settings.credentials;
	        xhr.upload.onprogress = function (e) {
	          progress(e.loaded / e.total * 100);
	        };
	        xhr.onerror = function () {
	          failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
	        };
	        xhr.onload = function () {
	          if (xhr.status < 200 || xhr.status >= 300) {
	            failure('HTTP Error: ' + xhr.status);
	            return;
	          }
	          var json = JSON.parse(xhr.responseText);
	          if (!json || typeof json.location !== 'string') {
	            failure('Invalid JSON: ' + xhr.responseText);
	            return;
	          }
	          success(pathJoin(settings.basePath, json.location));
	        };
	        var formData = new FormData();
	        formData.append('file', blobInfo.blob(), blobInfo.filename());
	        xhr.send(formData);
	      };
	      var noUpload = function () {
	        return new promiseObj(function (resolve) {
	          resolve([]);
	        });
	      };
	      var handlerSuccess = function (blobInfo, url) {
	        return {
	          url: url,
	          blobInfo: blobInfo,
	          status: true
	        };
	      };
	      var handlerFailure = function (blobInfo, message, options) {
	        return {
	          url: '',
	          blobInfo: blobInfo,
	          status: false,
	          error: {
	            message: message,
	            options: options
	          }
	        };
	      };
	      var resolvePending = function (blobUri, result) {
	        Tools.each(pendingPromises[blobUri], function (resolve) {
	          resolve(result);
	        });
	        delete pendingPromises[blobUri];
	      };
	      var uploadBlobInfo = function (blobInfo, handler, openNotification) {
	        uploadStatus.markPending(blobInfo.blobUri());
	        return new promiseObj(function (resolve) {
	          var notification, progress;
	          try {
	            var closeNotification_1 = function () {
	              if (notification) {
	                notification.close();
	                progress = noop;
	              }
	            };
	            var success = function (url) {
	              closeNotification_1();
	              uploadStatus.markUploaded(blobInfo.blobUri(), url);
	              resolvePending(blobInfo.blobUri(), handlerSuccess(blobInfo, url));
	              resolve(handlerSuccess(blobInfo, url));
	            };
	            var failure = function (error, options) {
	              var failureOptions = options ? options : {};
	              closeNotification_1();
	              uploadStatus.removeFailed(blobInfo.blobUri());
	              resolvePending(blobInfo.blobUri(), handlerFailure(blobInfo, error, failureOptions));
	              resolve(handlerFailure(blobInfo, error, failureOptions));
	            };
	            progress = function (percent) {
	              if (percent < 0 || percent > 100) {
	                return;
	              }
	              Optional.from(notification).orThunk(function () {
	                return Optional.from(openNotification).map(apply);
	              }).each(function (n) {
	                notification = n;
	                n.progressBar.value(percent);
	              });
	            };
	            handler(blobInfo, success, failure, progress);
	          } catch (ex) {
	            resolve(handlerFailure(blobInfo, ex.message, {}));
	          }
	        });
	      };
	      var isDefaultHandler = function (handler) {
	        return handler === defaultHandler;
	      };
	      var pendingUploadBlobInfo = function (blobInfo) {
	        var blobUri = blobInfo.blobUri();
	        return new promiseObj(function (resolve) {
	          pendingPromises[blobUri] = pendingPromises[blobUri] || [];
	          pendingPromises[blobUri].push(resolve);
	        });
	      };
	      var uploadBlobs = function (blobInfos, openNotification) {
	        blobInfos = Tools.grep(blobInfos, function (blobInfo) {
	          return !uploadStatus.isUploaded(blobInfo.blobUri());
	        });
	        return promiseObj.all(Tools.map(blobInfos, function (blobInfo) {
	          return uploadStatus.isPending(blobInfo.blobUri()) ? pendingUploadBlobInfo(blobInfo) : uploadBlobInfo(blobInfo, settings.handler, openNotification);
	        }));
	      };
	      var upload = function (blobInfos, openNotification) {
	        return !settings.url && isDefaultHandler(settings.handler) ? noUpload() : uploadBlobs(blobInfos, openNotification);
	      };
	      if (isFunction(settings.handler) === false) {
	        settings.handler = defaultHandler;
	      }
	      return { upload: upload };
	    };
	
	    var openNotification = function (editor) {
	      return function () {
	        return editor.notificationManager.open({
	          text: editor.translate('Image uploading...'),
	          type: 'info',
	          timeout: -1,
	          progressBar: true
	        });
	      };
	    };
	    var createUploader = function (editor, uploadStatus) {
	      return Uploader(uploadStatus, {
	        url: getImageUploadUrl(editor),
	        basePath: getImageUploadBasePath(editor),
	        credentials: getImagesUploadCredentials(editor),
	        handler: getImagesUploadHandler(editor)
	      });
	    };
	    var ImageUploader = function (editor) {
	      var uploadStatus = UploadStatus();
	      var uploader = createUploader(editor, uploadStatus);
	      return {
	        upload: function (blobInfos, showNotification) {
	          if (showNotification === void 0) {
	            showNotification = true;
	          }
	          return uploader.upload(blobInfos, showNotification ? openNotification(editor) : undefined);
	        }
	      };
	    };
	
	    var UploadChangeHandler = function (editor) {
	      var lastChangedLevel = Cell(null);
	      editor.on('change AddUndo', function (e) {
	        lastChangedLevel.set(__assign({}, e.level));
	      });
	      var fireIfChanged = function () {
	        var data = editor.undoManager.data;
	        last$2(data).filter(function (level) {
	          return !isEq$1(lastChangedLevel.get(), level);
	        }).each(function (level) {
	          editor.setDirty(true);
	          editor.fire('change', {
	            level: level,
	            lastLevel: get$a(data, data.length - 2).getOrNull()
	          });
	        });
	      };
	      return { fireIfChanged: fireIfChanged };
	    };
	    var EditorUpload = function (editor) {
	      var blobCache = BlobCache();
	      var uploader, imageScanner;
	      var uploadStatus = UploadStatus();
	      var urlFilters = [];
	      var changeHandler = UploadChangeHandler(editor);
	      var aliveGuard = function (callback) {
	        return function (result) {
	          if (editor.selection) {
	            return callback(result);
	          }
	          return [];
	        };
	      };
	      var cacheInvalidator = function (url) {
	        return url + (url.indexOf('?') === -1 ? '?' : '&') + new Date().getTime();
	      };
	      var replaceString = function (content, search, replace) {
	        var index = 0;
	        do {
	          index = content.indexOf(search, index);
	          if (index !== -1) {
	            content = content.substring(0, index) + replace + content.substr(index + search.length);
	            index += replace.length - search.length + 1;
	          }
	        } while (index !== -1);
	        return content;
	      };
	      var replaceImageUrl = function (content, targetUrl, replacementUrl) {
	        var replacementString = 'src="' + replacementUrl + '"' + (replacementUrl === Env.transparentSrc ? ' data-mce-placeholder="1"' : '');
	        content = replaceString(content, 'src="' + targetUrl + '"', replacementString);
	        content = replaceString(content, 'data-mce-src="' + targetUrl + '"', 'data-mce-src="' + replacementUrl + '"');
	        return content;
	      };
	      var replaceUrlInUndoStack = function (targetUrl, replacementUrl) {
	        each$k(editor.undoManager.data, function (level) {
	          if (level.type === 'fragmented') {
	            level.fragments = map$3(level.fragments, function (fragment) {
	              return replaceImageUrl(fragment, targetUrl, replacementUrl);
	            });
	          } else {
	            level.content = replaceImageUrl(level.content, targetUrl, replacementUrl);
	          }
	        });
	      };
	      var replaceImageUriInView = function (image, resultUri) {
	        var src = editor.convertURL(resultUri, 'src');
	        replaceUrlInUndoStack(image.src, resultUri);
	        editor.$(image).attr({
	          'src': shouldReuseFileName(editor) ? cacheInvalidator(resultUri) : resultUri,
	          'data-mce-src': src
	        });
	      };
	      var uploadImages = function (callback) {
	        if (!uploader) {
	          uploader = createUploader(editor, uploadStatus);
	        }
	        return scanForImages().then(aliveGuard(function (imageInfos) {
	          var blobInfos = map$3(imageInfos, function (imageInfo) {
	            return imageInfo.blobInfo;
	          });
	          return uploader.upload(blobInfos, openNotification(editor)).then(aliveGuard(function (result) {
	            var imagesToRemove = [];
	            var filteredResult = map$3(result, function (uploadInfo, index) {
	              var blobInfo = imageInfos[index].blobInfo;
	              var image = imageInfos[index].image;
	              if (uploadInfo.status && shouldReplaceBlobUris(editor)) {
	                blobCache.removeByUri(image.src);
	                if (isRtc(editor)) ; else {
	                  replaceImageUriInView(image, uploadInfo.url);
	                }
	              } else if (uploadInfo.error) {
	                if (uploadInfo.error.options.remove) {
	                  replaceUrlInUndoStack(image.getAttribute('src'), Env.transparentSrc);
	                  imagesToRemove.push(image);
	                }
	                uploadError(editor, uploadInfo.error.message);
	              }
	              return {
	                element: image,
	                status: uploadInfo.status,
	                uploadUri: uploadInfo.url,
	                blobInfo: blobInfo
	              };
	            });
	            if (filteredResult.length > 0) {
	              changeHandler.fireIfChanged();
	            }
	            if (imagesToRemove.length > 0) {
	              if (isRtc(editor)) {
	                console.error('Removing images on failed uploads is currently unsupported for RTC');
	              } else {
	                editor.undoManager.transact(function () {
	                  each$k(imagesToRemove, function (element) {
	                    editor.dom.remove(element);
	                    blobCache.removeByUri(element.src);
	                  });
	                });
	              }
	            }
	            if (callback) {
	              callback(filteredResult);
	            }
	            return filteredResult;
	          }));
	        }));
	      };
	      var uploadImagesAuto = function (callback) {
	        if (isAutomaticUploadsEnabled(editor)) {
	          return uploadImages(callback);
	        }
	      };
	      var isValidDataUriImage = function (imgElm) {
	        if (forall(urlFilters, function (filter) {
	            return filter(imgElm);
	          }) === false) {
	          return false;
	        }
	        if (imgElm.getAttribute('src').indexOf('data:') === 0) {
	          var dataImgFilter = getImagesDataImgFilter(editor);
	          return dataImgFilter(imgElm);
	        }
	        return true;
	      };
	      var addFilter = function (filter) {
	        urlFilters.push(filter);
	      };
	      var scanForImages = function () {
	        if (!imageScanner) {
	          imageScanner = ImageScanner(uploadStatus, blobCache);
	        }
	        return imageScanner.findAll(editor.getBody(), isValidDataUriImage).then(aliveGuard(function (result) {
	          result = filter$4(result, function (resultItem) {
	            if (typeof resultItem === 'string') {
	              displayError(editor, resultItem);
	              return false;
	            }
	            return true;
	          });
	          if (isRtc(editor)) ; else {
	            each$k(result, function (resultItem) {
	              replaceUrlInUndoStack(resultItem.image.src, resultItem.blobInfo.blobUri());
	              resultItem.image.src = resultItem.blobInfo.blobUri();
	              resultItem.image.removeAttribute('data-mce-src');
	            });
	          }
	          return result;
	        }));
	      };
	      var destroy = function () {
	        blobCache.destroy();
	        uploadStatus.destroy();
	        imageScanner = uploader = null;
	      };
	      var replaceBlobUris = function (content) {
	        return content.replace(/src="(blob:[^"]+)"/g, function (match, blobUri) {
	          var resultUri = uploadStatus.getResultUri(blobUri);
	          if (resultUri) {
	            return 'src="' + resultUri + '"';
	          }
	          var blobInfo = blobCache.getByUri(blobUri);
	          if (!blobInfo) {
	            blobInfo = foldl(editor.editorManager.get(), function (result, editor) {
	              return result || editor.editorUpload && editor.editorUpload.blobCache.getByUri(blobUri);
	            }, null);
	          }
	          if (blobInfo) {
	            var blob = blobInfo.blob();
	            return 'src="data:' + blob.type + ';base64,' + blobInfo.base64() + '"';
	          }
	          return match;
	        });
	      };
	      editor.on('SetContent', function () {
	        if (isAutomaticUploadsEnabled(editor)) {
	          uploadImagesAuto();
	        } else {
	          scanForImages();
	        }
	      });
	      editor.on('RawSaveContent', function (e) {
	        e.content = replaceBlobUris(e.content);
	      });
	      editor.on('GetContent', function (e) {
	        if (e.source_view || e.format === 'raw' || e.format === 'tree') {
	          return;
	        }
	        e.content = replaceBlobUris(e.content);
	      });
	      editor.on('PostRender', function () {
	        editor.parser.addNodeFilter('img', function (images) {
	          each$k(images, function (img) {
	            var src = img.attr('src');
	            if (blobCache.getByUri(src)) {
	              return;
	            }
	            var resultUri = uploadStatus.getResultUri(src);
	            if (resultUri) {
	              img.attr('src', resultUri);
	            }
	          });
	        });
	      });
	      return {
	        blobCache: blobCache,
	        addFilter: addFilter,
	        uploadImages: uploadImages,
	        uploadImagesAuto: uploadImagesAuto,
	        scanForImages: scanForImages,
	        destroy: destroy
	      };
	    };
	
	    var get = function (dom) {
	      var formats = {
	        valigntop: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'top' }
	          }],
	        valignmiddle: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'middle' }
	          }],
	        valignbottom: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'bottom' }
	          }],
	        alignleft: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-left',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'left' },
	            inherit: false,
	            preview: false,
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table,audio,video',
	            collapsed: false,
	            styles: { float: 'left' },
	            preview: 'font-family font-size'
	          }
	        ],
	        aligncenter: [
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'center' },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-center',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'img,audio,video',
	            collapsed: false,
	            styles: {
	              display: 'block',
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: false
	          },
	          {
	            selector: 'table',
	            collapsed: false,
	            styles: {
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: 'font-family font-size'
	          }
	        ],
	        alignright: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-right',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'right' },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table,audio,video',
	            collapsed: false,
	            styles: { float: 'right' },
	            preview: 'font-family font-size'
	          }
	        ],
	        alignjustify: [{
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'justify' },
	            inherit: false,
	            defaultBlock: 'div',
	            preview: 'font-family font-size'
	          }],
	        bold: [
	          {
	            inline: 'strong',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          },
	          {
	            inline: 'span',
	            styles: { fontWeight: 'bold' }
	          },
	          {
	            inline: 'b',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          }
	        ],
	        italic: [
	          {
	            inline: 'em',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          },
	          {
	            inline: 'span',
	            styles: { fontStyle: 'italic' }
	          },
	          {
	            inline: 'i',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          }
	        ],
	        underline: [
	          {
	            inline: 'span',
	            styles: { textDecoration: 'underline' },
	            exact: true
	          },
	          {
	            inline: 'u',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          }
	        ],
	        strikethrough: [
	          {
	            inline: 'span',
	            styles: { textDecoration: 'line-through' },
	            exact: true
	          },
	          {
	            inline: 'strike',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          },
	          {
	            inline: 's',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          }
	        ],
	        forecolor: {
	          inline: 'span',
	          styles: { color: '%value' },
	          links: true,
	          remove_similar: true,
	          clear_child_styles: true
	        },
	        hilitecolor: {
	          inline: 'span',
	          styles: { backgroundColor: '%value' },
	          links: true,
	          remove_similar: true,
	          clear_child_styles: true
	        },
	        fontname: {
	          inline: 'span',
	          toggle: false,
	          styles: { fontFamily: '%value' },
	          clear_child_styles: true
	        },
	        fontsize: {
	          inline: 'span',
	          toggle: false,
	          styles: { fontSize: '%value' },
	          clear_child_styles: true
	        },
	        lineheight: {
	          selector: 'h1,h2,h3,h4,h5,h6,p,li,td,th,div',
	          defaultBlock: 'p',
	          styles: { lineHeight: '%value' }
	        },
	        fontsize_class: {
	          inline: 'span',
	          attributes: { class: '%value' }
	        },
	        blockquote: {
	          block: 'blockquote',
	          wrapper: true,
	          remove: 'all'
	        },
	        subscript: { inline: 'sub' },
	        superscript: { inline: 'sup' },
	        code: { inline: 'code' },
	        link: {
	          inline: 'a',
	          selector: 'a',
	          remove: 'all',
	          split: true,
	          deep: true,
	          onmatch: function (node, _fmt, _itemName) {
	            return isElement$5(node) && node.hasAttribute('href');
	          },
	          onformat: function (elm, _fmt, vars) {
	            Tools.each(vars, function (value, key) {
	              dom.setAttrib(elm, key, value);
	            });
	          }
	        },
	        lang: {
	          inline: 'span',
	          clear_child_styles: true,
	          remove_similar: true,
	          attributes: {
	            'lang': '%value',
	            'data-mce-lang': function (vars) {
	              var _a;
	              return (_a = vars === null || vars === void 0 ? void 0 : vars.customValue) !== null && _a !== void 0 ? _a : null;
	            }
	          }
	        },
	        removeformat: [
	          {
	            selector: 'b,strong,em,i,font,u,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small',
	            remove: 'all',
	            split: true,
	            expand: false,
	            block_expand: true,
	            deep: true
	          },
	          {
	            selector: 'span',
	            attributes: [
	              'style',
	              'class'
	            ],
	            remove: 'empty',
	            split: true,
	            expand: false,
	            deep: true
	          },
	          {
	            selector: '*',
	            attributes: [
	              'style',
	              'class'
	            ],
	            split: false,
	            expand: false,
	            deep: true
	          }
	        ]
	      };
	      Tools.each('p h1 h2 h3 h4 h5 h6 div address pre dt dd samp'.split(/\s/), function (name) {
	        formats[name] = {
	          block: name,
	          remove: 'all'
	        };
	      });
	      return formats;
	    };
	
	    var FormatRegistry = function (editor) {
	      var formats = {};
	      var get$1 = function (name) {
	        return isNonNullable(name) ? formats[name] : formats;
	      };
	      var has = function (name) {
	        return has$2(formats, name);
	      };
	      var register = function (name, format) {
	        if (name) {
	          if (!isString$1(name)) {
	            each$j(name, function (format, name) {
	              register(name, format);
	            });
	          } else {
	            if (!isArray$1(format)) {
	              format = [format];
	            }
	            each$k(format, function (format) {
	              if (isUndefined(format.deep)) {
	                format.deep = !isSelectorFormat(format);
	              }
	              if (isUndefined(format.split)) {
	                format.split = !isSelectorFormat(format) || isInlineFormat(format);
	              }
	              if (isUndefined(format.remove) && isSelectorFormat(format) && !isInlineFormat(format)) {
	                format.remove = 'none';
	              }
	              if (isSelectorFormat(format) && isInlineFormat(format)) {
	                format.mixed = true;
	                format.block_expand = true;
	              }
	              if (isString$1(format.classes)) {
	                format.classes = format.classes.split(/\s+/);
	              }
	            });
	            formats[name] = format;
	          }
	        }
	      };
	      var unregister = function (name) {
	        if (name && formats[name]) {
	          delete formats[name];
	        }
	        return formats;
	      };
	      register(get(editor.dom));
	      register(getFormats(editor));
	      return {
	        get: get$1,
	        has: has,
	        register: register,
	        unregister: unregister
	      };
	    };
	
	    var each$5 = Tools.each;
	    var dom = DOMUtils.DOM;
	    var parsedSelectorToHtml = function (ancestry, editor) {
	      var elm, item, fragment;
	      var schema = editor && editor.schema || Schema({});
	      var decorate = function (elm, item) {
	        if (item.classes.length) {
	          dom.addClass(elm, item.classes.join(' '));
	        }
	        dom.setAttribs(elm, item.attrs);
	      };
	      var createElement = function (sItem) {
	        item = typeof sItem === 'string' ? {
	          name: sItem,
	          classes: [],
	          attrs: {}
	        } : sItem;
	        var elm = dom.create(item.name);
	        decorate(elm, item);
	        return elm;
	      };
	      var getRequiredParent = function (elm, candidate) {
	        var name = typeof elm !== 'string' ? elm.nodeName.toLowerCase() : elm;
	        var elmRule = schema.getElementRule(name);
	        var parentsRequired = elmRule && elmRule.parentsRequired;
	        if (parentsRequired && parentsRequired.length) {
	          return candidate && Tools.inArray(parentsRequired, candidate) !== -1 ? candidate : parentsRequired[0];
	        } else {
	          return false;
	        }
	      };
	      var wrapInHtml = function (elm, ancestry, siblings) {
	        var parent, parentCandidate;
	        var ancestor = ancestry.length > 0 && ancestry[0];
	        var ancestorName = ancestor && ancestor.name;
	        var parentRequired = getRequiredParent(elm, ancestorName);
	        if (parentRequired) {
	          if (ancestorName === parentRequired) {
	            parentCandidate = ancestry[0];
	            ancestry = ancestry.slice(1);
	          } else {
	            parentCandidate = parentRequired;
	          }
	        } else if (ancestor) {
	          parentCandidate = ancestry[0];
	          ancestry = ancestry.slice(1);
	        } else if (!siblings) {
	          return elm;
	        }
	        if (parentCandidate) {
	          parent = createElement(parentCandidate);
	          parent.appendChild(elm);
	        }
	        if (siblings) {
	          if (!parent) {
	            parent = dom.create('div');
	            parent.appendChild(elm);
	          }
	          Tools.each(siblings, function (sibling) {
	            var siblingElm = createElement(sibling);
	            parent.insertBefore(siblingElm, elm);
	          });
	        }
	        return wrapInHtml(parent, ancestry, parentCandidate && parentCandidate.siblings);
	      };
	      if (ancestry && ancestry.length) {
	        item = ancestry[0];
	        elm = createElement(item);
	        fragment = dom.create('div');
	        fragment.appendChild(wrapInHtml(elm, ancestry.slice(1), item.siblings));
	        return fragment;
	      } else {
	        return '';
	      }
	    };
	    var parseSelectorItem = function (item) {
	      var tagName;
	      var obj = {
	        classes: [],
	        attrs: {}
	      };
	      item = obj.selector = Tools.trim(item);
	      if (item !== '*') {
	        tagName = item.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, function ($0, $1, $2, $3, $4) {
	          switch ($1) {
	          case '#':
	            obj.attrs.id = $2;
	            break;
	          case '.':
	            obj.classes.push($2);
	            break;
	          case ':':
	            if (Tools.inArray('checked disabled enabled read-only required'.split(' '), $2) !== -1) {
	              obj.attrs[$2] = $2;
	            }
	            break;
	          }
	          if ($3 === '[') {
	            var m = $4.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
	            if (m) {
	              obj.attrs[m[1]] = m[2];
	            }
	          }
	          return '';
	        });
	      }
	      obj.name = tagName || 'div';
	      return obj;
	    };
	    var parseSelector = function (selector) {
	      if (!selector || typeof selector !== 'string') {
	        return [];
	      }
	      selector = selector.split(/\s*,\s*/)[0];
	      selector = selector.replace(/\s*(~\+|~|\+|>)\s*/g, '$1');
	      return Tools.map(selector.split(/(?:>|\s+(?![^\[\]]+\]))/), function (item) {
	        var siblings = Tools.map(item.split(/(?:~\+|~|\+)/), parseSelectorItem);
	        var obj = siblings.pop();
	        if (siblings.length) {
	          obj.siblings = siblings;
	        }
	        return obj;
	      }).reverse();
	    };
	    var getCssText = function (editor, format) {
	      var name, previewFrag;
	      var previewCss = '', parentFontSize;
	      var previewStyles = getPreviewStyles(editor);
	      if (previewStyles === '') {
	        return '';
	      }
	      var removeVars = function (val) {
	        return val.replace(/%(\w+)/g, '');
	      };
	      if (typeof format === 'string') {
	        format = editor.formatter.get(format);
	        if (!format) {
	          return;
	        }
	        format = format[0];
	      }
	      if ('preview' in format) {
	        var previewOpt = get$9(format, 'preview');
	        if (is$1(previewOpt, false)) {
	          return '';
	        } else {
	          previewStyles = previewOpt.getOr(previewStyles);
	        }
	      }
	      name = format.block || format.inline || 'span';
	      var items = parseSelector(format.selector);
	      if (items.length) {
	        if (!items[0].name) {
	          items[0].name = name;
	        }
	        name = format.selector;
	        previewFrag = parsedSelectorToHtml(items, editor);
	      } else {
	        previewFrag = parsedSelectorToHtml([name], editor);
	      }
	      var previewElm = dom.select(name, previewFrag)[0] || previewFrag.firstChild;
	      each$5(format.styles, function (value, name) {
	        var newValue = removeVars(value);
	        if (newValue) {
	          dom.setStyle(previewElm, name, newValue);
	        }
	      });
	      each$5(format.attributes, function (value, name) {
	        var newValue = removeVars(value);
	        if (newValue) {
	          dom.setAttrib(previewElm, name, newValue);
	        }
	      });
	      each$5(format.classes, function (value) {
	        var newValue = removeVars(value);
	        if (!dom.hasClass(previewElm, newValue)) {
	          dom.addClass(previewElm, newValue);
	        }
	      });
	      editor.fire('PreviewFormats');
	      dom.setStyles(previewFrag, {
	        position: 'absolute',
	        left: -65535
	      });
	      editor.getBody().appendChild(previewFrag);
	      parentFontSize = dom.getStyle(editor.getBody(), 'fontSize', true);
	      parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
	      each$5(previewStyles.split(' '), function (name) {
	        var value = dom.getStyle(previewElm, name, true);
	        if (name === 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(value)) {
	          value = dom.getStyle(editor.getBody(), name, true);
	          if (dom.toHex(value).toLowerCase() === '#ffffff') {
	            return;
	          }
	        }
	        if (name === 'color') {
	          if (dom.toHex(value).toLowerCase() === '#000000') {
	            return;
	          }
	        }
	        if (name === 'font-size') {
	          if (/em|%$/.test(value)) {
	            if (parentFontSize === 0) {
	              return;
	            }
	            var numValue = parseFloat(value) / (/%$/.test(value) ? 100 : 1);
	            value = numValue * parentFontSize + 'px';
	          }
	        }
	        if (name === 'border' && value) {
	          previewCss += 'padding:0 2px;';
	        }
	        previewCss += name + ':' + value + ';';
	      });
	      editor.fire('AfterPreviewFormats');
	      dom.remove(previewFrag);
	      return previewCss;
	    };
	
	    var setup$h = function (editor) {
	      editor.addShortcut('meta+b', '', 'Bold');
	      editor.addShortcut('meta+i', '', 'Italic');
	      editor.addShortcut('meta+u', '', 'Underline');
	      for (var i = 1; i <= 6; i++) {
	        editor.addShortcut('access+' + i, '', [
	          'FormatBlock',
	          false,
	          'h' + i
	        ]);
	      }
	      editor.addShortcut('access+7', '', [
	        'FormatBlock',
	        false,
	        'p'
	      ]);
	      editor.addShortcut('access+8', '', [
	        'FormatBlock',
	        false,
	        'div'
	      ]);
	      editor.addShortcut('access+9', '', [
	        'FormatBlock',
	        false,
	        'address'
	      ]);
	    };
	
	    var Formatter = function (editor) {
	      var formats = FormatRegistry(editor);
	      var formatChangeState = Cell(null);
	      setup$h(editor);
	      setup$k(editor);
	      return {
	        get: formats.get,
	        has: formats.has,
	        register: formats.register,
	        unregister: formats.unregister,
	        apply: function (name, vars, node) {
	          applyFormat(editor, name, vars, node);
	        },
	        remove: function (name, vars, node, similar) {
	          removeFormat(editor, name, vars, node, similar);
	        },
	        toggle: function (name, vars, node) {
	          toggleFormat(editor, name, vars, node);
	        },
	        match: function (name, vars, node, similar) {
	          return matchFormat(editor, name, vars, node, similar);
	        },
	        closest: function (names) {
	          return closestFormat(editor, names);
	        },
	        matchAll: function (names, vars) {
	          return matchAllFormats(editor, names, vars);
	        },
	        matchNode: function (node, name, vars, similar) {
	          return matchNodeFormat(editor, node, name, vars, similar);
	        },
	        canApply: function (name) {
	          return canApplyFormat(editor, name);
	        },
	        formatChanged: function (formats, callback, similar, vars) {
	          return formatChanged(editor, formatChangeState, formats, callback, similar, vars);
	        },
	        getCssText: curry(getCssText, editor)
	      };
	    };
	
	    var shouldIgnoreCommand = function (cmd) {
	      switch (cmd.toLowerCase()) {
	      case 'undo':
	      case 'redo':
	      case 'mcerepaint':
	      case 'mcefocus':
	        return true;
	      default:
	        return false;
	      }
	    };
	    var registerEvents = function (editor, undoManager, locks) {
	      var isFirstTypedCharacter = Cell(false);
	      var addNonTypingUndoLevel = function (e) {
	        setTyping(undoManager, false, locks);
	        undoManager.add({}, e);
	      };
	      editor.on('init', function () {
	        undoManager.add();
	      });
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command;
	        if (!shouldIgnoreCommand(cmd)) {
	          endTyping(undoManager, locks);
	          undoManager.beforeChange();
	        }
	      });
	      editor.on('ExecCommand', function (e) {
	        var cmd = e.command;
	        if (!shouldIgnoreCommand(cmd)) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      editor.on('ObjectResizeStart cut', function () {
	        undoManager.beforeChange();
	      });
	      editor.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
	      editor.on('dragend', addNonTypingUndoLevel);
	      editor.on('keyup', function (e) {
	        var keyCode = e.keyCode;
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45 || e.ctrlKey) {
	          addNonTypingUndoLevel();
	          editor.nodeChanged();
	        }
	        if (keyCode === 46 || keyCode === 8) {
	          editor.nodeChanged();
	        }
	        if (isFirstTypedCharacter.get() && undoManager.typing && isEq$1(createFromEditor(editor), undoManager.data[0]) === false) {
	          if (editor.isDirty() === false) {
	            editor.setDirty(true);
	            editor.fire('change', {
	              level: undoManager.data[0],
	              lastLevel: null
	            });
	          }
	          editor.fire('TypingUndo');
	          isFirstTypedCharacter.set(false);
	          editor.nodeChanged();
	        }
	      });
	      editor.on('keydown', function (e) {
	        var keyCode = e.keyCode;
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45) {
	          if (undoManager.typing) {
	            addNonTypingUndoLevel(e);
	          }
	          return;
	        }
	        var modKey = e.ctrlKey && !e.altKey || e.metaKey;
	        if ((keyCode < 16 || keyCode > 20) && keyCode !== 224 && keyCode !== 91 && !undoManager.typing && !modKey) {
	          undoManager.beforeChange();
	          setTyping(undoManager, true, locks);
	          undoManager.add({}, e);
	          isFirstTypedCharacter.set(true);
	        }
	      });
	      editor.on('mousedown', function (e) {
	        if (undoManager.typing) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      var isInsertReplacementText = function (event) {
	        return event.inputType === 'insertReplacementText';
	      };
	      var isInsertTextDataNull = function (event) {
	        return event.inputType === 'insertText' && event.data === null;
	      };
	      var isInsertFromPasteOrDrop = function (event) {
	        return event.inputType === 'insertFromPaste' || event.inputType === 'insertFromDrop';
	      };
	      editor.on('input', function (e) {
	        if (e.inputType && (isInsertReplacementText(e) || isInsertTextDataNull(e) || isInsertFromPasteOrDrop(e))) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      editor.on('AddUndo Undo Redo ClearUndos', function (e) {
	        if (!e.isDefaultPrevented()) {
	          editor.nodeChanged();
	        }
	      });
	    };
	    var addKeyboardShortcuts = function (editor) {
	      editor.addShortcut('meta+z', '', 'Undo');
	      editor.addShortcut('meta+y,meta+shift+z', '', 'Redo');
	    };
	
	    var UndoManager = function (editor) {
	      var beforeBookmark = value();
	      var locks = Cell(0);
	      var index = Cell(0);
	      var undoManager = {
	        data: [],
	        typing: false,
	        beforeChange: function () {
	          beforeChange(editor, locks, beforeBookmark);
	        },
	        add: function (level, event) {
	          return addUndoLevel(editor, undoManager, index, locks, beforeBookmark, level, event);
	        },
	        undo: function () {
	          return undo(editor, undoManager, locks, index);
	        },
	        redo: function () {
	          return redo(editor, index, undoManager.data);
	        },
	        clear: function () {
	          clear(editor, undoManager, index);
	        },
	        reset: function () {
	          reset(editor, undoManager);
	        },
	        hasUndo: function () {
	          return hasUndo(editor, undoManager, index);
	        },
	        hasRedo: function () {
	          return hasRedo(editor, undoManager, index);
	        },
	        transact: function (callback) {
	          return transact(editor, undoManager, locks, callback);
	        },
	        ignore: function (callback) {
	          ignore(editor, locks, callback);
	        },
	        extra: function (callback1, callback2) {
	          extra(editor, undoManager, index, callback1, callback2);
	        }
	      };
	      if (!isRtc(editor)) {
	        registerEvents(editor, undoManager, locks);
	      }
	      addKeyboardShortcuts(editor);
	      return undoManager;
	    };
	
	    var nonTypingKeycodes = [
	      9,
	      27,
	      VK.HOME,
	      VK.END,
	      19,
	      20,
	      44,
	      144,
	      145,
	      33,
	      34,
	      45,
	      16,
	      17,
	      18,
	      91,
	      92,
	      93,
	      VK.DOWN,
	      VK.UP,
	      VK.LEFT,
	      VK.RIGHT
	    ].concat(Env.browser.isFirefox() ? [224] : []);
	    var placeholderAttr = 'data-mce-placeholder';
	    var isKeyboardEvent = function (e) {
	      return e.type === 'keydown' || e.type === 'keyup';
	    };
	    var isDeleteEvent = function (e) {
	      var keyCode = e.keyCode;
	      return keyCode === VK.BACKSPACE || keyCode === VK.DELETE;
	    };
	    var isNonTypingKeyboardEvent = function (e) {
	      if (isKeyboardEvent(e)) {
	        var keyCode = e.keyCode;
	        return !isDeleteEvent(e) && (VK.metaKeyPressed(e) || e.altKey || keyCode >= 112 && keyCode <= 123 || contains$3(nonTypingKeycodes, keyCode));
	      } else {
	        return false;
	      }
	    };
	    var isTypingKeyboardEvent = function (e) {
	      return isKeyboardEvent(e) && !(isDeleteEvent(e) || e.type === 'keyup' && e.keyCode === 229);
	    };
	    var isVisuallyEmpty = function (dom, rootElm, forcedRootBlock) {
	      if (isEmpty$2(SugarElement.fromDom(rootElm), false)) {
	        var isForcedRootBlockFalse = forcedRootBlock === '';
	        var firstElement = rootElm.firstElementChild;
	        if (!firstElement) {
	          return true;
	        } else if (dom.getStyle(rootElm.firstElementChild, 'padding-left') || dom.getStyle(rootElm.firstElementChild, 'padding-right')) {
	          return false;
	        } else {
	          return isForcedRootBlockFalse ? !dom.isBlock(firstElement) : forcedRootBlock === firstElement.nodeName.toLowerCase();
	        }
	      } else {
	        return false;
	      }
	    };
	    var setup$g = function (editor) {
	      var dom = editor.dom;
	      var rootBlock = getForcedRootBlock(editor);
	      var placeholder = getPlaceholder(editor);
	      var updatePlaceholder = function (e, initial) {
	        if (isNonTypingKeyboardEvent(e)) {
	          return;
	        }
	        var body = editor.getBody();
	        var showPlaceholder = isTypingKeyboardEvent(e) ? false : isVisuallyEmpty(dom, body, rootBlock);
	        var isPlaceholderShown = dom.getAttrib(body, placeholderAttr) !== '';
	        if (isPlaceholderShown !== showPlaceholder || initial) {
	          dom.setAttrib(body, placeholderAttr, showPlaceholder ? placeholder : null);
	          dom.setAttrib(body, 'aria-placeholder', showPlaceholder ? placeholder : null);
	          firePlaceholderToggle(editor, showPlaceholder);
	          editor.on(showPlaceholder ? 'keydown' : 'keyup', updatePlaceholder);
	          editor.off(showPlaceholder ? 'keyup' : 'keydown', updatePlaceholder);
	        }
	      };
	      if (placeholder) {
	        editor.on('init', function (e) {
	          updatePlaceholder(e, true);
	          editor.on('change SetContent ExecCommand', updatePlaceholder);
	          editor.on('paste', function (e) {
	            return Delay.setEditorTimeout(editor, function () {
	              return updatePlaceholder(e);
	            });
	          });
	        });
	      }
	    };
	
	    var strongRtl = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
	    var hasStrongRtl = function (text) {
	      return strongRtl.test(text);
	    };
	
	    var isInlineTarget = function (editor, elm) {
	      return is$2(SugarElement.fromDom(elm), getInlineBoundarySelector(editor));
	    };
	    var isRtl = function (element) {
	      return DOMUtils.DOM.getStyle(element, 'direction', true) === 'rtl' || hasStrongRtl(element.textContent);
	    };
	    var findInlineParents = function (isInlineTarget, rootNode, pos) {
	      return filter$4(DOMUtils.DOM.getParents(pos.container(), '*', rootNode), isInlineTarget);
	    };
	    var findRootInline = function (isInlineTarget, rootNode, pos) {
	      var parents = findInlineParents(isInlineTarget, rootNode, pos);
	      return Optional.from(parents[parents.length - 1]);
	    };
	    var hasSameParentBlock = function (rootNode, node1, node2) {
	      var block1 = getParentBlock$2(node1, rootNode);
	      var block2 = getParentBlock$2(node2, rootNode);
	      return block1 && block1 === block2;
	    };
	    var isAtZwsp = function (pos) {
	      return isBeforeInline(pos) || isAfterInline(pos);
	    };
	    var normalizePosition = function (forward, pos) {
	      if (!pos) {
	        return pos;
	      }
	      var container = pos.container(), offset = pos.offset();
	      if (forward) {
	        if (isCaretContainerInline(container)) {
	          if (isText$7(container.nextSibling)) {
	            return CaretPosition(container.nextSibling, 0);
	          } else {
	            return CaretPosition.after(container);
	          }
	        } else {
	          return isBeforeInline(pos) ? CaretPosition(container, offset + 1) : pos;
	        }
	      } else {
	        if (isCaretContainerInline(container)) {
	          if (isText$7(container.previousSibling)) {
	            return CaretPosition(container.previousSibling, container.previousSibling.data.length);
	          } else {
	            return CaretPosition.before(container);
	          }
	        } else {
	          return isAfterInline(pos) ? CaretPosition(container, offset - 1) : pos;
	        }
	      }
	    };
	    var normalizeForwards = curry(normalizePosition, true);
	    var normalizeBackwards = curry(normalizePosition, false);
	
	    var isBeforeRoot = function (rootNode) {
	      return function (elm) {
	        return eq(rootNode, SugarElement.fromDom(elm.dom.parentNode));
	      };
	    };
	    var isTextBlockOrListItem = function (element) {
	      return isTextBlock$2(element) || isListItem(element);
	    };
	    var getParentBlock$1 = function (rootNode, elm) {
	      if (contains$1(rootNode, elm)) {
	        return closest$3(elm, isTextBlockOrListItem, isBeforeRoot(rootNode));
	      } else {
	        return Optional.none();
	      }
	    };
	    var placeCaretInEmptyBody = function (editor) {
	      var body = editor.getBody();
	      var node = body.firstChild && editor.dom.isBlock(body.firstChild) ? body.firstChild : body;
	      editor.selection.setCursorLocation(node, 0);
	    };
	    var paddEmptyBody = function (editor) {
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        placeCaretInEmptyBody(editor);
	      }
	    };
	    var willDeleteLastPositionInElement = function (forward, fromPos, elm) {
	      return lift2(firstPositionIn(elm), lastPositionIn(elm), function (firstPos, lastPos) {
	        var normalizedFirstPos = normalizePosition(true, firstPos);
	        var normalizedLastPos = normalizePosition(false, lastPos);
	        var normalizedFromPos = normalizePosition(false, fromPos);
	        if (forward) {
	          return nextPosition(elm, normalizedFromPos).exists(function (nextPos) {
	            return nextPos.isEqual(normalizedLastPos) && fromPos.isEqual(normalizedFirstPos);
	          });
	        } else {
	          return prevPosition(elm, normalizedFromPos).exists(function (prevPos) {
	            return prevPos.isEqual(normalizedFirstPos) && fromPos.isEqual(normalizedLastPos);
	          });
	        }
	      }).getOr(true);
	    };
	
	    var blockPosition = function (block, position) {
	      return {
	        block: block,
	        position: position
	      };
	    };
	    var blockBoundary = function (from, to) {
	      return {
	        from: from,
	        to: to
	      };
	    };
	    var getBlockPosition = function (rootNode, pos) {
	      var rootElm = SugarElement.fromDom(rootNode);
	      var containerElm = SugarElement.fromDom(pos.container());
	      return getParentBlock$1(rootElm, containerElm).map(function (block) {
	        return blockPosition(block, pos);
	      });
	    };
	    var isDifferentBlocks = function (blockBoundary) {
	      return eq(blockBoundary.from.block, blockBoundary.to.block) === false;
	    };
	    var hasSameParent = function (blockBoundary) {
	      return parent(blockBoundary.from.block).bind(function (parent1) {
	        return parent(blockBoundary.to.block).filter(function (parent2) {
	          return eq(parent1, parent2);
	        });
	      }).isSome();
	    };
	    var isEditable$1 = function (blockBoundary) {
	      return isContentEditableFalse$b(blockBoundary.from.block.dom) === false && isContentEditableFalse$b(blockBoundary.to.block.dom) === false;
	    };
	    var skipLastBr = function (rootNode, forward, blockPosition) {
	      if (isBr$5(blockPosition.position.getNode()) && isEmpty$2(blockPosition.block) === false) {
	        return positionIn(false, blockPosition.block.dom).bind(function (lastPositionInBlock) {
	          if (lastPositionInBlock.isEqual(blockPosition.position)) {
	            return fromPosition(forward, rootNode, lastPositionInBlock).bind(function (to) {
	              return getBlockPosition(rootNode, to);
	            });
	          } else {
	            return Optional.some(blockPosition);
	          }
	        }).getOr(blockPosition);
	      } else {
	        return blockPosition;
	      }
	    };
	    var readFromRange = function (rootNode, forward, rng) {
	      var fromBlockPos = getBlockPosition(rootNode, CaretPosition.fromRangeStart(rng));
	      var toBlockPos = fromBlockPos.bind(function (blockPos) {
	        return fromPosition(forward, rootNode, blockPos.position).bind(function (to) {
	          return getBlockPosition(rootNode, to).map(function (blockPos) {
	            return skipLastBr(rootNode, forward, blockPos);
	          });
	        });
	      });
	      return lift2(fromBlockPos, toBlockPos, blockBoundary).filter(function (blockBoundary) {
	        return isDifferentBlocks(blockBoundary) && hasSameParent(blockBoundary) && isEditable$1(blockBoundary);
	      });
	    };
	    var read$1 = function (rootNode, forward, rng) {
	      return rng.collapsed ? readFromRange(rootNode, forward, rng) : Optional.none();
	    };
	
	    var getChildrenUntilBlockBoundary = function (block) {
	      var children$1 = children(block);
	      return findIndex$2(children$1, isBlock$2).fold(constant(children$1), function (index) {
	        return children$1.slice(0, index);
	      });
	    };
	    var extractChildren = function (block) {
	      var children = getChildrenUntilBlockBoundary(block);
	      each$k(children, remove$7);
	      return children;
	    };
	    var removeEmptyRoot = function (rootNode, block) {
	      var parents = parentsAndSelf(block, rootNode);
	      return find$3(parents.reverse(), function (element) {
	        return isEmpty$2(element);
	      }).each(remove$7);
	    };
	    var isEmptyBefore = function (el) {
	      return filter$4(prevSiblings(el), function (el) {
	        return !isEmpty$2(el);
	      }).length === 0;
	    };
	    var nestedBlockMerge = function (rootNode, fromBlock, toBlock, insertionPoint) {
	      if (isEmpty$2(toBlock)) {
	        fillWithPaddingBr(toBlock);
	        return firstPositionIn(toBlock.dom);
	      }
	      if (isEmptyBefore(insertionPoint) && isEmpty$2(fromBlock)) {
	        before$4(insertionPoint, SugarElement.fromTag('br'));
	      }
	      var position = prevPosition(toBlock.dom, CaretPosition.before(insertionPoint.dom));
	      each$k(extractChildren(fromBlock), function (child) {
	        before$4(insertionPoint, child);
	      });
	      removeEmptyRoot(rootNode, fromBlock);
	      return position;
	    };
	    var sidelongBlockMerge = function (rootNode, fromBlock, toBlock) {
	      if (isEmpty$2(toBlock)) {
	        remove$7(toBlock);
	        if (isEmpty$2(fromBlock)) {
	          fillWithPaddingBr(fromBlock);
	        }
	        return firstPositionIn(fromBlock.dom);
	      }
	      var position = lastPositionIn(toBlock.dom);
	      each$k(extractChildren(fromBlock), function (child) {
	        append$1(toBlock, child);
	      });
	      removeEmptyRoot(rootNode, fromBlock);
	      return position;
	    };
	    var findInsertionPoint = function (toBlock, block) {
	      var parentsAndSelf$1 = parentsAndSelf(block, toBlock);
	      return Optional.from(parentsAndSelf$1[parentsAndSelf$1.length - 1]);
	    };
	    var getInsertionPoint = function (fromBlock, toBlock) {
	      return contains$1(toBlock, fromBlock) ? findInsertionPoint(toBlock, fromBlock) : Optional.none();
	    };
	    var trimBr = function (first, block) {
	      positionIn(first, block.dom).map(function (position) {
	        return position.getNode();
	      }).map(SugarElement.fromDom).filter(isBr$4).each(remove$7);
	    };
	    var mergeBlockInto = function (rootNode, fromBlock, toBlock) {
	      trimBr(true, fromBlock);
	      trimBr(false, toBlock);
	      return getInsertionPoint(fromBlock, toBlock).fold(curry(sidelongBlockMerge, rootNode, fromBlock, toBlock), curry(nestedBlockMerge, rootNode, fromBlock, toBlock));
	    };
	    var mergeBlocks = function (rootNode, forward, block1, block2) {
	      return forward ? mergeBlockInto(rootNode, block2, block1) : mergeBlockInto(rootNode, block1, block2);
	    };
	
	    var backspaceDelete$8 = function (editor, forward) {
	      var rootNode = SugarElement.fromDom(editor.getBody());
	      var position = read$1(rootNode.dom, forward, editor.selection.getRng()).bind(function (blockBoundary) {
	        return mergeBlocks(rootNode, forward, blockBoundary.from.block, blockBoundary.to.block);
	      });
	      position.each(function (pos) {
	        editor.selection.setRng(pos.toRange());
	      });
	      return position.isSome();
	    };
	
	    var deleteRangeMergeBlocks = function (rootNode, selection) {
	      var rng = selection.getRng();
	      return lift2(getParentBlock$1(rootNode, SugarElement.fromDom(rng.startContainer)), getParentBlock$1(rootNode, SugarElement.fromDom(rng.endContainer)), function (block1, block2) {
	        if (eq(block1, block2) === false) {
	          rng.deleteContents();
	          mergeBlocks(rootNode, true, block1, block2).each(function (pos) {
	            selection.setRng(pos.toRange());
	          });
	          return true;
	        } else {
	          return false;
	        }
	      }).getOr(false);
	    };
	    var isRawNodeInTable = function (root, rawNode) {
	      var node = SugarElement.fromDom(rawNode);
	      var isRoot = curry(eq, root);
	      return ancestor$3(node, isTableCell$4, isRoot).isSome();
	    };
	    var isSelectionInTable = function (root, rng) {
	      return isRawNodeInTable(root, rng.startContainer) || isRawNodeInTable(root, rng.endContainer);
	    };
	    var isEverythingSelected = function (root, rng) {
	      var noPrevious = prevPosition(root.dom, CaretPosition.fromRangeStart(rng)).isNone();
	      var noNext = nextPosition(root.dom, CaretPosition.fromRangeEnd(rng)).isNone();
	      return !isSelectionInTable(root, rng) && noPrevious && noNext;
	    };
	    var emptyEditor = function (editor) {
	      editor.setContent('');
	      editor.selection.setCursorLocation();
	      return true;
	    };
	    var deleteRange$1 = function (editor) {
	      var rootNode = SugarElement.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      return isEverythingSelected(rootNode, rng) ? emptyEditor(editor) : deleteRangeMergeBlocks(rootNode, editor.selection);
	    };
	    var backspaceDelete$7 = function (editor, _forward) {
	      return editor.selection.isCollapsed() ? false : deleteRange$1(editor);
	    };
	
	    var isContentEditableTrue$2 = isContentEditableTrue$4;
	    var isContentEditableFalse$4 = isContentEditableFalse$b;
	    var showCaret = function (direction, editor, node, before, scrollIntoView) {
	      return Optional.from(editor._selectionOverrides.showCaret(direction, node, before, scrollIntoView));
	    };
	    var getNodeRange = function (node) {
	      var rng = node.ownerDocument.createRange();
	      rng.selectNode(node);
	      return rng;
	    };
	    var selectNode = function (editor, node) {
	      var e = editor.fire('BeforeObjectSelected', { target: node });
	      if (e.isDefaultPrevented()) {
	        return Optional.none();
	      }
	      return Optional.some(getNodeRange(node));
	    };
	    var renderCaretAtRange = function (editor, range, scrollIntoView) {
	      var normalizedRange = normalizeRange(1, editor.getBody(), range);
	      var caretPosition = CaretPosition.fromRangeStart(normalizedRange);
	      var caretPositionNode = caretPosition.getNode();
	      if (isInlineFakeCaretTarget(caretPositionNode)) {
	        return showCaret(1, editor, caretPositionNode, !caretPosition.isAtEnd(), false);
	      }
	      var caretPositionBeforeNode = caretPosition.getNode(true);
	      if (isInlineFakeCaretTarget(caretPositionBeforeNode)) {
	        return showCaret(1, editor, caretPositionBeforeNode, false, false);
	      }
	      var ceRoot = editor.dom.getParent(caretPosition.getNode(), function (node) {
	        return isContentEditableFalse$4(node) || isContentEditableTrue$2(node);
	      });
	      if (isInlineFakeCaretTarget(ceRoot)) {
	        return showCaret(1, editor, ceRoot, false, scrollIntoView);
	      }
	      return Optional.none();
	    };
	    var renderRangeCaret = function (editor, range, scrollIntoView) {
	      return range.collapsed ? renderCaretAtRange(editor, range, scrollIntoView).getOr(range) : range;
	    };
	
	    var isBeforeBoundary = function (pos) {
	      return isBeforeContentEditableFalse(pos) || isBeforeMedia(pos);
	    };
	    var isAfterBoundary = function (pos) {
	      return isAfterContentEditableFalse(pos) || isAfterMedia(pos);
	    };
	    var trimEmptyTextNode = function (dom, node) {
	      if (isText$7(node) && node.data.length === 0) {
	        dom.remove(node);
	      }
	    };
	    var deleteContentAndShowCaret = function (editor, range, node, direction, forward, peekCaretPosition) {
	      showCaret(direction, editor, peekCaretPosition.getNode(!forward), forward, true).each(function (caretRange) {
	        if (range.collapsed) {
	          var deleteRange = range.cloneRange();
	          if (forward) {
	            deleteRange.setEnd(caretRange.startContainer, caretRange.startOffset);
	          } else {
	            deleteRange.setStart(caretRange.endContainer, caretRange.endOffset);
	          }
	          deleteRange.deleteContents();
	        } else {
	          range.deleteContents();
	        }
	        editor.selection.setRng(caretRange);
	      });
	      trimEmptyTextNode(editor.dom, node);
	      return true;
	    };
	    var deleteBoundaryText = function (editor, forward) {
	      var range = editor.selection.getRng();
	      if (!isText$7(range.commonAncestorContainer)) {
	        return false;
	      }
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextPosFn = curry(getVisualCaretPosition, forward ? caretWalker.next : caretWalker.prev);
	      var isBeforeFn = forward ? isBeforeBoundary : isAfterBoundary;
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      var nextCaretPosition = normalizePosition(forward, getNextPosFn(caretPosition));
	      if (!nextCaretPosition || !isMoveInsideSameBlock(caretPosition, nextCaretPosition)) {
	        return false;
	      } else if (isBeforeFn(nextCaretPosition)) {
	        return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, nextCaretPosition);
	      }
	      var peekCaretPosition = getNextPosFn(nextCaretPosition);
	      if (peekCaretPosition && isBeforeFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
	          return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, peekCaretPosition);
	        }
	      }
	      return false;
	    };
	    var backspaceDelete$6 = function (editor, forward) {
	      return deleteBoundaryText(editor, forward);
	    };
	
	    var isCompoundElement = function (node) {
	      return isTableCell$4(SugarElement.fromDom(node)) || isListItem(SugarElement.fromDom(node));
	    };
	    var DeleteAction = Adt.generate([
	      { remove: ['element'] },
	      { moveToElement: ['element'] },
	      { moveToPosition: ['position'] }
	    ]);
	    var isAtContentEditableBlockCaret = function (forward, from) {
	      var elm = from.getNode(forward === false);
	      var caretLocation = forward ? 'after' : 'before';
	      return isElement$5(elm) && elm.getAttribute('data-mce-caret') === caretLocation;
	    };
	    var isDeleteFromCefDifferentBlocks = function (root, forward, from, to) {
	      var inSameBlock = function (elm) {
	        return isInline$1(SugarElement.fromDom(elm)) && !isInSameBlock(from, to, root);
	      };
	      return getRelativeCefElm(!forward, from).fold(function () {
	        return getRelativeCefElm(forward, to).fold(never, inSameBlock);
	      }, inSameBlock);
	    };
	    var deleteEmptyBlockOrMoveToCef = function (root, forward, from, to) {
	      var toCefElm = to.getNode(forward === false);
	      return getParentBlock$1(SugarElement.fromDom(root), SugarElement.fromDom(from.getNode())).map(function (blockElm) {
	        return isEmpty$2(blockElm) ? DeleteAction.remove(blockElm.dom) : DeleteAction.moveToElement(toCefElm);
	      }).orThunk(function () {
	        return Optional.some(DeleteAction.moveToElement(toCefElm));
	      });
	    };
	    var findCefPosition = function (root, forward, from) {
	      return fromPosition(forward, root, from).bind(function (to) {
	        if (isCompoundElement(to.getNode())) {
	          return Optional.none();
	        } else if (isDeleteFromCefDifferentBlocks(root, forward, from, to)) {
	          return Optional.none();
	        } else if (forward && isContentEditableFalse$b(to.getNode())) {
	          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
	        } else if (forward === false && isContentEditableFalse$b(to.getNode(true))) {
	          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
	        } else if (forward && isAfterContentEditableFalse(from)) {
	          return Optional.some(DeleteAction.moveToPosition(to));
	        } else if (forward === false && isBeforeContentEditableFalse(from)) {
	          return Optional.some(DeleteAction.moveToPosition(to));
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var getContentEditableBlockAction = function (forward, elm) {
	      if (forward && isContentEditableFalse$b(elm.nextSibling)) {
	        return Optional.some(DeleteAction.moveToElement(elm.nextSibling));
	      } else if (forward === false && isContentEditableFalse$b(elm.previousSibling)) {
	        return Optional.some(DeleteAction.moveToElement(elm.previousSibling));
	      } else {
	        return Optional.none();
	      }
	    };
	    var skipMoveToActionFromInlineCefToContent = function (root, from, deleteAction) {
	      return deleteAction.fold(function (elm) {
	        return Optional.some(DeleteAction.remove(elm));
	      }, function (elm) {
	        return Optional.some(DeleteAction.moveToElement(elm));
	      }, function (to) {
	        if (isInSameBlock(from, to, root)) {
	          return Optional.none();
	        } else {
	          return Optional.some(DeleteAction.moveToPosition(to));
	        }
	      });
	    };
	    var getContentEditableAction = function (root, forward, from) {
	      if (isAtContentEditableBlockCaret(forward, from)) {
	        return getContentEditableBlockAction(forward, from.getNode(forward === false)).fold(function () {
	          return findCefPosition(root, forward, from);
	        }, Optional.some);
	      } else {
	        return findCefPosition(root, forward, from).bind(function (deleteAction) {
	          return skipMoveToActionFromInlineCefToContent(root, from, deleteAction);
	        });
	      }
	    };
	    var read = function (root, forward, rng) {
	      var normalizedRange = normalizeRange(forward ? 1 : -1, root, rng);
	      var from = CaretPosition.fromRangeStart(normalizedRange);
	      var rootElement = SugarElement.fromDom(root);
	      if (forward === false && isAfterContentEditableFalse(from)) {
	        return Optional.some(DeleteAction.remove(from.getNode(true)));
	      } else if (forward && isBeforeContentEditableFalse(from)) {
	        return Optional.some(DeleteAction.remove(from.getNode()));
	      } else if (forward === false && isBeforeContentEditableFalse(from) && isAfterBr(rootElement, from)) {
	        return findPreviousBr(rootElement, from).map(function (br) {
	          return DeleteAction.remove(br.getNode());
	        });
	      } else if (forward && isAfterContentEditableFalse(from) && isBeforeBr$1(rootElement, from)) {
	        return findNextBr(rootElement, from).map(function (br) {
	          return DeleteAction.remove(br.getNode());
	        });
	      } else {
	        return getContentEditableAction(root, forward, from);
	      }
	    };
	
	    var deleteElement$1 = function (editor, forward) {
	      return function (element) {
	        editor._selectionOverrides.hideFakeCaret();
	        deleteElement$2(editor, forward, SugarElement.fromDom(element));
	        return true;
	      };
	    };
	    var moveToElement = function (editor, forward) {
	      return function (element) {
	        var pos = forward ? CaretPosition.before(element) : CaretPosition.after(element);
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	    var moveToPosition = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	    var getAncestorCe = function (editor, node) {
	      return Optional.from(getContentEditableRoot$1(editor.getBody(), node));
	    };
	    var backspaceDeleteCaret = function (editor, forward) {
	      var selectedNode = editor.selection.getNode();
	      return getAncestorCe(editor, selectedNode).filter(isContentEditableFalse$b).fold(function () {
	        return read(editor.getBody(), forward, editor.selection.getRng()).exists(function (deleteAction) {
	          return deleteAction.fold(deleteElement$1(editor, forward), moveToElement(editor, forward), moveToPosition(editor));
	        });
	      }, always);
	    };
	    var deleteOffscreenSelection = function (rootElement) {
	      each$k(descendants(rootElement, '.mce-offscreen-selection'), remove$7);
	    };
	    var backspaceDeleteRange = function (editor, forward) {
	      var selectedNode = editor.selection.getNode();
	      if (isContentEditableFalse$b(selectedNode) && !isTableCell$5(selectedNode)) {
	        var hasCefAncestor = getAncestorCe(editor, selectedNode.parentNode).filter(isContentEditableFalse$b);
	        return hasCefAncestor.fold(function () {
	          deleteOffscreenSelection(SugarElement.fromDom(editor.getBody()));
	          deleteElement$2(editor, forward, SugarElement.fromDom(editor.selection.getNode()));
	          paddEmptyBody(editor);
	          return true;
	        }, always);
	      }
	      return false;
	    };
	    var paddEmptyElement = function (editor) {
	      var dom = editor.dom, selection = editor.selection;
	      var ceRoot = getContentEditableRoot$1(editor.getBody(), selection.getNode());
	      if (isContentEditableTrue$4(ceRoot) && dom.isBlock(ceRoot) && dom.isEmpty(ceRoot)) {
	        var br = dom.create('br', { 'data-mce-bogus': '1' });
	        dom.setHTML(ceRoot, '');
	        ceRoot.appendChild(br);
	        selection.setRng(CaretPosition.before(br).toRange());
	      }
	      return true;
	    };
	    var backspaceDelete$5 = function (editor, forward) {
	      if (editor.selection.isCollapsed()) {
	        return backspaceDeleteCaret(editor, forward);
	      } else {
	        return backspaceDeleteRange(editor, forward);
	      }
	    };
	
	    var deleteCaret$2 = function (editor, forward) {
	      var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return fromPosition(forward, editor.getBody(), fromPos).filter(function (pos) {
	        return forward ? isBeforeImageBlock(pos) : isAfterImageBlock(pos);
	      }).bind(function (pos) {
	        return Optional.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, pos));
	      }).exists(function (elm) {
	        editor.selection.select(elm);
	        return true;
	      });
	    };
	    var backspaceDelete$4 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret$2(editor, forward) : false;
	    };
	
	    var isText = isText$7;
	    var startsWithCaretContainer = function (node) {
	      return isText(node) && node.data[0] === ZWSP$1;
	    };
	    var endsWithCaretContainer = function (node) {
	      return isText(node) && node.data[node.data.length - 1] === ZWSP$1;
	    };
	    var createZwsp = function (node) {
	      return node.ownerDocument.createTextNode(ZWSP$1);
	    };
	    var insertBefore = function (node) {
	      if (isText(node.previousSibling)) {
	        if (endsWithCaretContainer(node.previousSibling)) {
	          return node.previousSibling;
	        } else {
	          node.previousSibling.appendData(ZWSP$1);
	          return node.previousSibling;
	        }
	      } else if (isText(node)) {
	        if (startsWithCaretContainer(node)) {
	          return node;
	        } else {
	          node.insertData(0, ZWSP$1);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        node.parentNode.insertBefore(newNode, node);
	        return newNode;
	      }
	    };
	    var insertAfter = function (node) {
	      if (isText(node.nextSibling)) {
	        if (startsWithCaretContainer(node.nextSibling)) {
	          return node.nextSibling;
	        } else {
	          node.nextSibling.insertData(0, ZWSP$1);
	          return node.nextSibling;
	        }
	      } else if (isText(node)) {
	        if (endsWithCaretContainer(node)) {
	          return node;
	        } else {
	          node.appendData(ZWSP$1);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        if (node.nextSibling) {
	          node.parentNode.insertBefore(newNode, node.nextSibling);
	        } else {
	          node.parentNode.appendChild(newNode);
	        }
	        return newNode;
	      }
	    };
	    var insertInline = function (before, node) {
	      return before ? insertBefore(node) : insertAfter(node);
	    };
	    var insertInlineBefore = curry(insertInline, true);
	    var insertInlineAfter = curry(insertInline, false);
	
	    var insertInlinePos = function (pos, before) {
	      if (isText$7(pos.container())) {
	        return insertInline(before, pos.container());
	      } else {
	        return insertInline(before, pos.getNode());
	      }
	    };
	    var isPosCaretContainer = function (pos, caret) {
	      var caretNode = caret.get();
	      return caretNode && pos.container() === caretNode && isCaretContainerInline(caretNode);
	    };
	    var renderCaret = function (caret, location) {
	      return location.fold(function (element) {
	        remove$2(caret.get());
	        var text = insertInlineBefore(element);
	        caret.set(text);
	        return Optional.some(CaretPosition(text, text.length - 1));
	      }, function (element) {
	        return firstPositionIn(element).map(function (pos) {
	          if (!isPosCaretContainer(pos, caret)) {
	            remove$2(caret.get());
	            var text = insertInlinePos(pos, true);
	            caret.set(text);
	            return CaretPosition(text, 1);
	          } else {
	            return CaretPosition(caret.get(), 1);
	          }
	        });
	      }, function (element) {
	        return lastPositionIn(element).map(function (pos) {
	          if (!isPosCaretContainer(pos, caret)) {
	            remove$2(caret.get());
	            var text = insertInlinePos(pos, false);
	            caret.set(text);
	            return CaretPosition(text, text.length - 1);
	          } else {
	            return CaretPosition(caret.get(), caret.get().length - 1);
	          }
	        });
	      }, function (element) {
	        remove$2(caret.get());
	        var text = insertInlineAfter(element);
	        caret.set(text);
	        return Optional.some(CaretPosition(text, 1));
	      });
	    };
	
	    var evaluateUntil = function (fns, args) {
	      for (var i = 0; i < fns.length; i++) {
	        var result = fns[i].apply(null, args);
	        if (result.isSome()) {
	          return result;
	        }
	      }
	      return Optional.none();
	    };
	
	    var Location = Adt.generate([
	      { before: ['element'] },
	      { start: ['element'] },
	      { end: ['element'] },
	      { after: ['element'] }
	    ]);
	    var rescope$1 = function (rootNode, node) {
	      var parentBlock = getParentBlock$2(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	    var before = function (isInlineTarget, rootNode, pos) {
	      var nPos = normalizeForwards(pos);
	      var scope = rescope$1(rootNode, nPos.container());
	      return findRootInline(isInlineTarget, scope, nPos).fold(function () {
	        return nextPosition(scope, nPos).bind(curry(findRootInline, isInlineTarget, scope)).map(function (inline) {
	          return Location.before(inline);
	        });
	      }, Optional.none);
	    };
	    var isNotInsideFormatCaretContainer = function (rootNode, elm) {
	      return getParentCaretContainer(rootNode, elm) === null;
	    };
	    var findInsideRootInline = function (isInlineTarget, rootNode, pos) {
	      return findRootInline(isInlineTarget, rootNode, pos).filter(curry(isNotInsideFormatCaretContainer, rootNode));
	    };
	    var start$1 = function (isInlineTarget, rootNode, pos) {
	      var nPos = normalizeBackwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var prevPos = prevPosition(inline, nPos);
	        return prevPos.isNone() ? Optional.some(Location.start(inline)) : Optional.none();
	      });
	    };
	    var end = function (isInlineTarget, rootNode, pos) {
	      var nPos = normalizeForwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var nextPos = nextPosition(inline, nPos);
	        return nextPos.isNone() ? Optional.some(Location.end(inline)) : Optional.none();
	      });
	    };
	    var after = function (isInlineTarget, rootNode, pos) {
	      var nPos = normalizeBackwards(pos);
	      var scope = rescope$1(rootNode, nPos.container());
	      return findRootInline(isInlineTarget, scope, nPos).fold(function () {
	        return prevPosition(scope, nPos).bind(curry(findRootInline, isInlineTarget, scope)).map(function (inline) {
	          return Location.after(inline);
	        });
	      }, Optional.none);
	    };
	    var isValidLocation = function (location) {
	      return isRtl(getElement(location)) === false;
	    };
	    var readLocation = function (isInlineTarget, rootNode, pos) {
	      var location = evaluateUntil([
	        before,
	        start$1,
	        end,
	        after
	      ], [
	        isInlineTarget,
	        rootNode,
	        pos
	      ]);
	      return location.filter(isValidLocation);
	    };
	    var getElement = function (location) {
	      return location.fold(identity, identity, identity, identity);
	    };
	    var getName = function (location) {
	      return location.fold(constant('before'), constant('start'), constant('end'), constant('after'));
	    };
	    var outside = function (location) {
	      return location.fold(Location.before, Location.before, Location.after, Location.after);
	    };
	    var inside = function (location) {
	      return location.fold(Location.start, Location.start, Location.end, Location.end);
	    };
	    var isEq = function (location1, location2) {
	      return getName(location1) === getName(location2) && getElement(location1) === getElement(location2);
	    };
	    var betweenInlines = function (forward, isInlineTarget, rootNode, from, to, location) {
	      return lift2(findRootInline(isInlineTarget, rootNode, from), findRootInline(isInlineTarget, rootNode, to), function (fromInline, toInline) {
	        if (fromInline !== toInline && hasSameParentBlock(rootNode, fromInline, toInline)) {
	          return Location.after(forward ? fromInline : toInline);
	        } else {
	          return location;
	        }
	      }).getOr(location);
	    };
	    var skipNoMovement = function (fromLocation, toLocation) {
	      return fromLocation.fold(always, function (fromLocation) {
	        return !isEq(fromLocation, toLocation);
	      });
	    };
	    var findLocationTraverse = function (forward, isInlineTarget, rootNode, fromLocation, pos) {
	      var from = normalizePosition(forward, pos);
	      var to = fromPosition(forward, rootNode, from).map(curry(normalizePosition, forward));
	      var location = to.fold(function () {
	        return fromLocation.map(outside);
	      }, function (to) {
	        return readLocation(isInlineTarget, rootNode, to).map(curry(betweenInlines, forward, isInlineTarget, rootNode, from, to)).filter(curry(skipNoMovement, fromLocation));
	      });
	      return location.filter(isValidLocation);
	    };
	    var findLocationSimple = function (forward, location) {
	      if (forward) {
	        return location.fold(compose(Optional.some, Location.start), Optional.none, compose(Optional.some, Location.after), Optional.none);
	      } else {
	        return location.fold(Optional.none, compose(Optional.some, Location.before), Optional.none, compose(Optional.some, Location.end));
	      }
	    };
	    var findLocation$1 = function (forward, isInlineTarget, rootNode, pos) {
	      var from = normalizePosition(forward, pos);
	      var fromLocation = readLocation(isInlineTarget, rootNode, from);
	      return readLocation(isInlineTarget, rootNode, from).bind(curry(findLocationSimple, forward)).orThunk(function () {
	        return findLocationTraverse(forward, isInlineTarget, rootNode, fromLocation, pos);
	      });
	    };
	    curry(findLocation$1, false);
	    curry(findLocation$1, true);
	
	    var hasSelectionModifyApi = function (editor) {
	      return isFunction(editor.selection.getSel().modify);
	    };
	    var moveRel = function (forward, selection, pos) {
	      var delta = forward ? 1 : -1;
	      selection.setRng(CaretPosition(pos.container(), pos.offset() + delta).toRange());
	      selection.getSel().modify('move', forward ? 'forward' : 'backward', 'word');
	      return true;
	    };
	    var moveByWord = function (forward, editor) {
	      var rng = editor.selection.getRng();
	      var pos = forward ? CaretPosition.fromRangeEnd(rng) : CaretPosition.fromRangeStart(rng);
	      if (!hasSelectionModifyApi(editor)) {
	        return false;
	      } else if (forward && isBeforeInline(pos)) {
	        return moveRel(true, editor.selection, pos);
	      } else if (!forward && isAfterInline(pos)) {
	        return moveRel(false, editor.selection, pos);
	      } else {
	        return false;
	      }
	    };
	
	    var BreakType;
	    (function (BreakType) {
	      BreakType[BreakType['Br'] = 0] = 'Br';
	      BreakType[BreakType['Block'] = 1] = 'Block';
	      BreakType[BreakType['Wrap'] = 2] = 'Wrap';
	      BreakType[BreakType['Eol'] = 3] = 'Eol';
	    }(BreakType || (BreakType = {})));
	    var flip = function (direction, positions) {
	      return direction === HDirection.Backwards ? reverse(positions) : positions;
	    };
	    var walk = function (direction, caretWalker, pos) {
	      return direction === HDirection.Forwards ? caretWalker.next(pos) : caretWalker.prev(pos);
	    };
	    var getBreakType = function (scope, direction, currentPos, nextPos) {
	      if (isBr$5(nextPos.getNode(direction === HDirection.Forwards))) {
	        return BreakType.Br;
	      } else if (isInSameBlock(currentPos, nextPos) === false) {
	        return BreakType.Block;
	      } else {
	        return BreakType.Wrap;
	      }
	    };
	    var getPositionsUntil = function (predicate, direction, scope, start) {
	      var caretWalker = CaretWalker(scope);
	      var currentPos = start;
	      var positions = [];
	      while (currentPos) {
	        var nextPos = walk(direction, caretWalker, currentPos);
	        if (!nextPos) {
	          break;
	        }
	        if (isBr$5(nextPos.getNode(false))) {
	          if (direction === HDirection.Forwards) {
	            return {
	              positions: flip(direction, positions).concat([nextPos]),
	              breakType: BreakType.Br,
	              breakAt: Optional.some(nextPos)
	            };
	          } else {
	            return {
	              positions: flip(direction, positions),
	              breakType: BreakType.Br,
	              breakAt: Optional.some(nextPos)
	            };
	          }
	        }
	        if (!nextPos.isVisible()) {
	          currentPos = nextPos;
	          continue;
	        }
	        if (predicate(currentPos, nextPos)) {
	          var breakType = getBreakType(scope, direction, currentPos, nextPos);
	          return {
	            positions: flip(direction, positions),
	            breakType: breakType,
	            breakAt: Optional.some(nextPos)
	          };
	        }
	        positions.push(nextPos);
	        currentPos = nextPos;
	      }
	      return {
	        positions: flip(direction, positions),
	        breakType: BreakType.Eol,
	        breakAt: Optional.none()
	      };
	    };
	    var getAdjacentLinePositions = function (direction, getPositionsUntilBreak, scope, start) {
	      return getPositionsUntilBreak(scope, start).breakAt.map(function (pos) {
	        var positions = getPositionsUntilBreak(scope, pos).positions;
	        return direction === HDirection.Backwards ? positions.concat(pos) : [pos].concat(positions);
	      }).getOr([]);
	    };
	    var findClosestHorizontalPositionFromPoint = function (positions, x) {
	      return foldl(positions, function (acc, newPos) {
	        return acc.fold(function () {
	          return Optional.some(newPos);
	        }, function (lastPos) {
	          return lift2(head(lastPos.getClientRects()), head(newPos.getClientRects()), function (lastRect, newRect) {
	            var lastDist = Math.abs(x - lastRect.left);
	            var newDist = Math.abs(x - newRect.left);
	            return newDist <= lastDist ? newPos : lastPos;
	          }).or(acc);
	        });
	      }, Optional.none());
	    };
	    var findClosestHorizontalPosition = function (positions, pos) {
	      return head(pos.getClientRects()).bind(function (targetRect) {
	        return findClosestHorizontalPositionFromPoint(positions, targetRect.left);
	      });
	    };
	    var getPositionsUntilPreviousLine = curry(getPositionsUntil, CaretPosition.isAbove, -1);
	    var getPositionsUntilNextLine = curry(getPositionsUntil, CaretPosition.isBelow, 1);
	    var getPositionsAbove = curry(getAdjacentLinePositions, -1, getPositionsUntilPreviousLine);
	    var getPositionsBelow = curry(getAdjacentLinePositions, 1, getPositionsUntilNextLine);
	    var isAtFirstLine = function (scope, pos) {
	      return getPositionsUntilPreviousLine(scope, pos).breakAt.isNone();
	    };
	    var isAtLastLine = function (scope, pos) {
	      return getPositionsUntilNextLine(scope, pos).breakAt.isNone();
	    };
	    var getFirstLinePositions = function (scope) {
	      return firstPositionIn(scope).map(function (pos) {
	        return [pos].concat(getPositionsUntilNextLine(scope, pos).positions);
	      }).getOr([]);
	    };
	    var getLastLinePositions = function (scope) {
	      return lastPositionIn(scope).map(function (pos) {
	        return getPositionsUntilPreviousLine(scope, pos).positions.concat(pos);
	      }).getOr([]);
	    };
	
	    var getNodeClientRects = function (node) {
	      var toArrayWithNode = function (clientRects) {
	        return map$3(clientRects, function (rect) {
	          var clientRect = clone(rect);
	          clientRect.node = node;
	          return clientRect;
	        });
	      };
	      if (isElement$5(node)) {
	        return toArrayWithNode(node.getClientRects());
	      }
	      if (isText$7(node)) {
	        var rng = node.ownerDocument.createRange();
	        rng.setStart(node, 0);
	        rng.setEnd(node, node.data.length);
	        return toArrayWithNode(rng.getClientRects());
	      }
	    };
	    var getClientRects = function (nodes) {
	      return bind(nodes, getNodeClientRects);
	    };
	
	    var VDirection;
	    (function (VDirection) {
	      VDirection[VDirection['Up'] = -1] = 'Up';
	      VDirection[VDirection['Down'] = 1] = 'Down';
	    }(VDirection || (VDirection = {})));
	    var findUntil = function (direction, root, predicateFn, node) {
	      while (node = findNode$1(node, direction, isEditableCaretCandidate$1, root)) {
	        if (predicateFn(node)) {
	          return;
	        }
	      }
	    };
	    var walkUntil$1 = function (direction, isAboveFn, isBeflowFn, root, predicateFn, caretPosition) {
	      var line = 0;
	      var result = [];
	      var add = function (node) {
	        var clientRects = getClientRects([node]);
	        if (direction === -1) {
	          clientRects = clientRects.reverse();
	        }
	        for (var i = 0; i < clientRects.length; i++) {
	          var clientRect = clientRects[i];
	          if (isBeflowFn(clientRect, targetClientRect)) {
	            continue;
	          }
	          if (result.length > 0 && isAboveFn(clientRect, last$1(result))) {
	            line++;
	          }
	          clientRect.line = line;
	          if (predicateFn(clientRect)) {
	            return true;
	          }
	          result.push(clientRect);
	        }
	      };
	      var targetClientRect = last$1(caretPosition.getClientRects());
	      if (!targetClientRect) {
	        return result;
	      }
	      var node = caretPosition.getNode();
	      add(node);
	      findUntil(direction, root, add, node);
	      return result;
	    };
	    var aboveLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line > lineNumber;
	    };
	    var isLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line === lineNumber;
	    };
	    var upUntil = curry(walkUntil$1, VDirection.Up, isAbove$1, isBelow$1);
	    var downUntil = curry(walkUntil$1, VDirection.Down, isBelow$1, isAbove$1);
	    var positionsUntil = function (direction, root, predicateFn, node) {
	      var caretWalker = CaretWalker(root);
	      var walkFn;
	      var isBelowFn;
	      var isAboveFn;
	      var caretPosition;
	      var result = [];
	      var line = 0;
	      var getClientRect = function (caretPosition) {
	        if (direction === 1) {
	          return last$1(caretPosition.getClientRects());
	        }
	        return last$1(caretPosition.getClientRects());
	      };
	      if (direction === 1) {
	        walkFn = caretWalker.next;
	        isBelowFn = isBelow$1;
	        isAboveFn = isAbove$1;
	        caretPosition = CaretPosition.after(node);
	      } else {
	        walkFn = caretWalker.prev;
	        isBelowFn = isAbove$1;
	        isAboveFn = isBelow$1;
	        caretPosition = CaretPosition.before(node);
	      }
	      var targetClientRect = getClientRect(caretPosition);
	      do {
	        if (!caretPosition.isVisible()) {
	          continue;
	        }
	        var rect = getClientRect(caretPosition);
	        if (isAboveFn(rect, targetClientRect)) {
	          continue;
	        }
	        if (result.length > 0 && isBelowFn(rect, last$1(result))) {
	          line++;
	        }
	        var clientRect = clone(rect);
	        clientRect.position = caretPosition;
	        clientRect.line = line;
	        if (predicateFn(clientRect)) {
	          return result;
	        }
	        result.push(clientRect);
	      } while (caretPosition = walkFn(caretPosition));
	      return result;
	    };
	    var isAboveLine = function (lineNumber) {
	      return function (clientRect) {
	        return aboveLineNumber(lineNumber, clientRect);
	      };
	    };
	    var isLine = function (lineNumber) {
	      return function (clientRect) {
	        return isLineNumber(lineNumber, clientRect);
	      };
	    };
	
	    var isContentEditableFalse$3 = isContentEditableFalse$b;
	    var findNode = findNode$1;
	    var distanceToRectLeft = function (clientRect, clientX) {
	      return Math.abs(clientRect.left - clientX);
	    };
	    var distanceToRectRight = function (clientRect, clientX) {
	      return Math.abs(clientRect.right - clientX);
	    };
	    var isInsideX = function (clientX, clientRect) {
	      return clientX >= clientRect.left && clientX <= clientRect.right;
	    };
	    var isInsideY = function (clientY, clientRect) {
	      return clientY >= clientRect.top && clientY <= clientRect.bottom;
	    };
	    var isNodeClientRect = function (rect) {
	      return hasNonNullableKey(rect, 'node');
	    };
	    var findClosestClientRect = function (clientRects, clientX, allowInside) {
	      if (allowInside === void 0) {
	        allowInside = always;
	      }
	      return reduce(clientRects, function (oldClientRect, clientRect) {
	        if (isInsideX(clientX, clientRect)) {
	          return allowInside(clientRect) ? clientRect : oldClientRect;
	        }
	        if (isInsideX(clientX, oldClientRect)) {
	          return allowInside(oldClientRect) ? oldClientRect : clientRect;
	        }
	        var oldDistance = Math.min(distanceToRectLeft(oldClientRect, clientX), distanceToRectRight(oldClientRect, clientX));
	        var newDistance = Math.min(distanceToRectLeft(clientRect, clientX), distanceToRectRight(clientRect, clientX));
	        if (newDistance === oldDistance && isNodeClientRect(clientRect) && isContentEditableFalse$3(clientRect.node)) {
	          return clientRect;
	        }
	        if (newDistance < oldDistance) {
	          return clientRect;
	        }
	        return oldClientRect;
	      });
	    };
	    var walkUntil = function (direction, root, predicateFn, startNode, includeChildren) {
	      var node = findNode(startNode, direction, isEditableCaretCandidate$1, root, !includeChildren);
	      do {
	        if (!node || predicateFn(node)) {
	          return;
	        }
	      } while (node = findNode(node, direction, isEditableCaretCandidate$1, root));
	    };
	    var findLineNodeRects = function (root, targetNodeRect, includeChildren) {
	      if (includeChildren === void 0) {
	        includeChildren = true;
	      }
	      var clientRects = [];
	      var collect = function (checkPosFn, node) {
	        var lineRects = filter$4(getClientRects([node]), function (clientRect) {
	          return !checkPosFn(clientRect, targetNodeRect);
	        });
	        clientRects = clientRects.concat(lineRects);
	        return lineRects.length === 0;
	      };
	      clientRects.push(targetNodeRect);
	      walkUntil(VDirection.Up, root, curry(collect, isAbove$1), targetNodeRect.node, includeChildren);
	      walkUntil(VDirection.Down, root, curry(collect, isBelow$1), targetNodeRect.node, includeChildren);
	      return clientRects;
	    };
	    var getFakeCaretTargets = function (root) {
	      return filter$4(from(root.getElementsByTagName('*')), isFakeCaretTarget);
	    };
	    var caretInfo = function (clientRect, clientX) {
	      return {
	        node: clientRect.node,
	        before: distanceToRectLeft(clientRect, clientX) < distanceToRectRight(clientRect, clientX)
	      };
	    };
	    var closestFakeCaret = function (root, clientX, clientY) {
	      var fakeTargetNodeRects = getClientRects(getFakeCaretTargets(root));
	      var targetNodeRects = filter$4(fakeTargetNodeRects, curry(isInsideY, clientY));
	      var checkInside = function (clientRect) {
	        return !isTable$3(clientRect.node) && !isMedia$2(clientRect.node);
	      };
	      var closestNodeRect = findClosestClientRect(targetNodeRects, clientX, checkInside);
	      if (closestNodeRect) {
	        var includeChildren = checkInside(closestNodeRect);
	        closestNodeRect = findClosestClientRect(findLineNodeRects(root, closestNodeRect, includeChildren), clientX, checkInside);
	        if (closestNodeRect && isFakeCaretTarget(closestNodeRect.node)) {
	          return caretInfo(closestNodeRect, clientX);
	        }
	      }
	      return null;
	    };
	
	    var moveToRange = function (editor, rng) {
	      editor.selection.setRng(rng);
	      scrollRangeIntoView(editor, editor.selection.getRng());
	    };
	    var renderRangeCaretOpt = function (editor, range, scrollIntoView) {
	      return Optional.some(renderRangeCaret(editor, range, scrollIntoView));
	    };
	    var moveHorizontally = function (editor, direction, range, isBefore, isAfter, isElement) {
	      var forwards = direction === HDirection.Forwards;
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextPosFn = curry(getVisualCaretPosition, forwards ? caretWalker.next : caretWalker.prev);
	      var isBeforeFn = forwards ? isBefore : isAfter;
	      if (!range.collapsed) {
	        var node = getSelectedNode(range);
	        if (isElement(node)) {
	          return showCaret(direction, editor, node, direction === HDirection.Backwards, false);
	        }
	      }
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      if (isBeforeFn(caretPosition)) {
	        return selectNode(editor, caretPosition.getNode(!forwards));
	      }
	      var nextCaretPosition = normalizePosition(forwards, getNextPosFn(caretPosition));
	      var rangeIsInContainerBlock = isRangeInCaretContainerBlock(range);
	      if (!nextCaretPosition) {
	        return rangeIsInContainerBlock ? Optional.some(range) : Optional.none();
	      }
	      if (isBeforeFn(nextCaretPosition)) {
	        return showCaret(direction, editor, nextCaretPosition.getNode(!forwards), forwards, false);
	      }
	      var peekCaretPosition = getNextPosFn(nextCaretPosition);
	      if (peekCaretPosition && isBeforeFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
	          return showCaret(direction, editor, peekCaretPosition.getNode(!forwards), forwards, false);
	        }
	      }
	      if (rangeIsInContainerBlock) {
	        return renderRangeCaretOpt(editor, nextCaretPosition.toRange(), false);
	      }
	      return Optional.none();
	    };
	    var moveVertically = function (editor, direction, range, isBefore, isAfter, isElement) {
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      var caretClientRect = last$1(caretPosition.getClientRects());
	      var forwards = direction === VDirection.Down;
	      if (!caretClientRect) {
	        return Optional.none();
	      }
	      var walkerFn = forwards ? downUntil : upUntil;
	      var linePositions = walkerFn(editor.getBody(), isAboveLine(1), caretPosition);
	      var nextLinePositions = filter$4(linePositions, isLine(1));
	      var clientX = caretClientRect.left;
	      var nextLineRect = findClosestClientRect(nextLinePositions, clientX);
	      if (nextLineRect && isElement(nextLineRect.node)) {
	        var dist1 = Math.abs(clientX - nextLineRect.left);
	        var dist2 = Math.abs(clientX - nextLineRect.right);
	        return showCaret(direction, editor, nextLineRect.node, dist1 < dist2, false);
	      }
	      var currentNode;
	      if (isBefore(caretPosition)) {
	        currentNode = caretPosition.getNode();
	      } else if (isAfter(caretPosition)) {
	        currentNode = caretPosition.getNode(true);
	      } else {
	        currentNode = getSelectedNode(range);
	      }
	      if (currentNode) {
	        var caretPositions = positionsUntil(direction, editor.getBody(), isAboveLine(1), currentNode);
	        var closestNextLineRect = findClosestClientRect(filter$4(caretPositions, isLine(1)), clientX);
	        if (closestNextLineRect) {
	          return renderRangeCaretOpt(editor, closestNextLineRect.position.toRange(), false);
	        }
	        closestNextLineRect = last$1(filter$4(caretPositions, isLine(0)));
	        if (closestNextLineRect) {
	          return renderRangeCaretOpt(editor, closestNextLineRect.position.toRange(), false);
	        }
	      }
	      if (nextLinePositions.length === 0) {
	        return getLineEndPoint(editor, forwards).filter(forwards ? isAfter : isBefore).map(function (pos) {
	          return renderRangeCaret(editor, pos.toRange(), false);
	        });
	      }
	      return Optional.none();
	    };
	    var getLineEndPoint = function (editor, forward) {
	      var rng = editor.selection.getRng();
	      var body = editor.getBody();
	      if (forward) {
	        var from = CaretPosition.fromRangeEnd(rng);
	        var result = getPositionsUntilNextLine(body, from);
	        return last$2(result.positions);
	      } else {
	        var from = CaretPosition.fromRangeStart(rng);
	        var result = getPositionsUntilPreviousLine(body, from);
	        return head(result.positions);
	      }
	    };
	    var moveToLineEndPoint$3 = function (editor, forward, isElementPosition) {
	      return getLineEndPoint(editor, forward).filter(isElementPosition).exists(function (pos) {
	        editor.selection.setRng(pos.toRange());
	        return true;
	      });
	    };
	
	    var setCaretPosition = function (editor, pos) {
	      var rng = editor.dom.createRng();
	      rng.setStart(pos.container(), pos.offset());
	      rng.setEnd(pos.container(), pos.offset());
	      editor.selection.setRng(rng);
	    };
	    var setSelected = function (state, elm) {
	      if (state) {
	        elm.setAttribute('data-mce-selected', 'inline-boundary');
	      } else {
	        elm.removeAttribute('data-mce-selected');
	      }
	    };
	    var renderCaretLocation = function (editor, caret, location) {
	      return renderCaret(caret, location).map(function (pos) {
	        setCaretPosition(editor, pos);
	        return location;
	      });
	    };
	    var findLocation = function (editor, caret, forward) {
	      var rootNode = editor.getBody();
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      var location = findLocation$1(forward, isInlineTarget$1, rootNode, from);
	      return location.bind(function (location) {
	        return renderCaretLocation(editor, caret, location);
	      });
	    };
	    var toggleInlines = function (isInlineTarget, dom, elms) {
	      var inlineBoundaries = map$3(descendants(SugarElement.fromDom(dom.getRoot()), '*[data-mce-selected="inline-boundary"]'), function (e) {
	        return e.dom;
	      });
	      var selectedInlines = filter$4(inlineBoundaries, isInlineTarget);
	      var targetInlines = filter$4(elms, isInlineTarget);
	      each$k(difference(selectedInlines, targetInlines), curry(setSelected, false));
	      each$k(difference(targetInlines, selectedInlines), curry(setSelected, true));
	    };
	    var safeRemoveCaretContainer = function (editor, caret) {
	      if (editor.selection.isCollapsed() && editor.composing !== true && caret.get()) {
	        var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	        if (CaretPosition.isTextPosition(pos) && isAtZwsp(pos) === false) {
	          setCaretPosition(editor, removeAndReposition(caret.get(), pos));
	          caret.set(null);
	        }
	      }
	    };
	    var renderInsideInlineCaret = function (isInlineTarget, editor, caret, elms) {
	      if (editor.selection.isCollapsed()) {
	        var inlines = filter$4(elms, isInlineTarget);
	        each$k(inlines, function (_inline) {
	          var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	          readLocation(isInlineTarget, editor.getBody(), pos).bind(function (location) {
	            return renderCaretLocation(editor, caret, location);
	          });
	        });
	      }
	    };
	    var move$2 = function (editor, caret, forward) {
	      return isInlineBoundariesEnabled(editor) ? findLocation(editor, caret, forward).isSome() : false;
	    };
	    var moveWord = function (forward, editor, _caret) {
	      return isInlineBoundariesEnabled(editor) ? moveByWord(forward, editor) : false;
	    };
	    var setupSelectedState = function (editor) {
	      var caret = Cell(null);
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      editor.on('NodeChange', function (e) {
	        if (isInlineBoundariesEnabled(editor) && !(Env.browser.isIE() && e.initial)) {
	          toggleInlines(isInlineTarget$1, editor.dom, e.parents);
	          safeRemoveCaretContainer(editor, caret);
	          renderInsideInlineCaret(isInlineTarget$1, editor, caret, e.parents);
	        }
	      });
	      return caret;
	    };
	    var moveNextWord = curry(moveWord, true);
	    var movePrevWord = curry(moveWord, false);
	    var moveToLineEndPoint$2 = function (editor, forward, caret) {
	      if (isInlineBoundariesEnabled(editor)) {
	        var linePoint = getLineEndPoint(editor, forward).getOrThunk(function () {
	          var rng = editor.selection.getRng();
	          return forward ? CaretPosition.fromRangeEnd(rng) : CaretPosition.fromRangeStart(rng);
	        });
	        return readLocation(curry(isInlineTarget, editor), editor.getBody(), linePoint).exists(function (loc) {
	          var outsideLoc = outside(loc);
	          return renderCaret(caret, outsideLoc).exists(function (pos) {
	            setCaretPosition(editor, pos);
	            return true;
	          });
	        });
	      } else {
	        return false;
	      }
	    };
	
	    var rangeFromPositions = function (from, to) {
	      var range = document.createRange();
	      range.setStart(from.container(), from.offset());
	      range.setEnd(to.container(), to.offset());
	      return range;
	    };
	    var hasOnlyTwoOrLessPositionsLeft = function (elm) {
	      return lift2(firstPositionIn(elm), lastPositionIn(elm), function (firstPos, lastPos) {
	        var normalizedFirstPos = normalizePosition(true, firstPos);
	        var normalizedLastPos = normalizePosition(false, lastPos);
	        return nextPosition(elm, normalizedFirstPos).forall(function (pos) {
	          return pos.isEqual(normalizedLastPos);
	        });
	      }).getOr(true);
	    };
	    var setCaretLocation = function (editor, caret) {
	      return function (location) {
	        return renderCaret(caret, location).exists(function (pos) {
	          setCaretPosition(editor, pos);
	          return true;
	        });
	      };
	    };
	    var deleteFromTo = function (editor, caret, from, to) {
	      var rootNode = editor.getBody();
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      editor.undoManager.ignore(function () {
	        editor.selection.setRng(rangeFromPositions(from, to));
	        editor.execCommand('Delete');
	        readLocation(isInlineTarget$1, rootNode, CaretPosition.fromRangeStart(editor.selection.getRng())).map(inside).map(setCaretLocation(editor, caret));
	      });
	      editor.nodeChanged();
	    };
	    var rescope = function (rootNode, node) {
	      var parentBlock = getParentBlock$2(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	    var backspaceDeleteCollapsed = function (editor, caret, forward, from) {
	      var rootNode = rescope(editor.getBody(), from.container());
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      var fromLocation = readLocation(isInlineTarget$1, rootNode, from);
	      return fromLocation.bind(function (location) {
	        if (forward) {
	          return location.fold(constant(Optional.some(inside(location))), Optional.none, constant(Optional.some(outside(location))), Optional.none);
	        } else {
	          return location.fold(Optional.none, constant(Optional.some(outside(location))), Optional.none, constant(Optional.some(inside(location))));
	        }
	      }).map(setCaretLocation(editor, caret)).getOrThunk(function () {
	        var toPosition = navigate(forward, rootNode, from);
	        var toLocation = toPosition.bind(function (pos) {
	          return readLocation(isInlineTarget$1, rootNode, pos);
	        });
	        return lift2(fromLocation, toLocation, function () {
	          return findRootInline(isInlineTarget$1, rootNode, from).exists(function (elm) {
	            if (hasOnlyTwoOrLessPositionsLeft(elm)) {
	              deleteElement$2(editor, forward, SugarElement.fromDom(elm));
	              return true;
	            } else {
	              return false;
	            }
	          });
	        }).orThunk(function () {
	          return toLocation.bind(function (_) {
	            return toPosition.map(function (to) {
	              if (forward) {
	                deleteFromTo(editor, caret, from, to);
	              } else {
	                deleteFromTo(editor, caret, to, from);
	              }
	              return true;
	            });
	          });
	        }).getOr(false);
	      });
	    };
	    var backspaceDelete$3 = function (editor, caret, forward) {
	      if (editor.selection.isCollapsed() && isInlineBoundariesEnabled(editor)) {
	        var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	        return backspaceDeleteCollapsed(editor, caret, forward, from);
	      }
	      return false;
	    };
	
	    var getParentInlines = function (rootElm, startElm) {
	      var parents = parentsAndSelf(startElm, rootElm);
	      return findIndex$2(parents, isBlock$2).fold(constant(parents), function (index) {
	        return parents.slice(0, index);
	      });
	    };
	    var hasOnlyOneChild = function (elm) {
	      return childNodesCount(elm) === 1;
	    };
	    var deleteLastPosition = function (forward, editor, target, parentInlines) {
	      var isFormatElement$1 = curry(isFormatElement, editor);
	      var formatNodes = map$3(filter$4(parentInlines, isFormatElement$1), function (elm) {
	        return elm.dom;
	      });
	      if (formatNodes.length === 0) {
	        deleteElement$2(editor, forward, target);
	      } else {
	        var pos = replaceWithCaretFormat(target.dom, formatNodes);
	        editor.selection.setRng(pos.toRange());
	      }
	    };
	    var deleteCaret$1 = function (editor, forward) {
	      var rootElm = SugarElement.fromDom(editor.getBody());
	      var startElm = SugarElement.fromDom(editor.selection.getStart());
	      var parentInlines = filter$4(getParentInlines(rootElm, startElm), hasOnlyOneChild);
	      return last$2(parentInlines).exists(function (target) {
	        var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
	        if (willDeleteLastPositionInElement(forward, fromPos, target.dom) && !isEmptyCaretFormatElement(target)) {
	          deleteLastPosition(forward, editor, target, parentInlines);
	          return true;
	        } else {
	          return false;
	        }
	      });
	    };
	    var backspaceDelete$2 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret$1(editor, forward) : false;
	    };
	
	    var deleteElement = function (editor, forward, element) {
	      editor._selectionOverrides.hideFakeCaret();
	      deleteElement$2(editor, forward, SugarElement.fromDom(element));
	      return true;
	    };
	    var deleteCaret = function (editor, forward) {
	      var isNearMedia = forward ? isBeforeMedia : isAfterMedia;
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var fromPos = getNormalizedRangeEndPoint(direction, editor.getBody(), editor.selection.getRng());
	      if (isNearMedia(fromPos)) {
	        return deleteElement(editor, forward, fromPos.getNode(!forward));
	      } else {
	        return Optional.from(normalizePosition(forward, fromPos)).filter(function (pos) {
	          return isNearMedia(pos) && isMoveInsideSameBlock(fromPos, pos);
	        }).exists(function (pos) {
	          return deleteElement(editor, forward, pos.getNode(!forward));
	        });
	      }
	    };
	    var deleteRange = function (editor, forward) {
	      var selectedNode = editor.selection.getNode();
	      return isMedia$2(selectedNode) ? deleteElement(editor, forward, selectedNode) : false;
	    };
	    var backspaceDelete$1 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret(editor, forward) : deleteRange(editor, forward);
	    };
	
	    var isEditable = function (target) {
	      return closest$3(target, function (elm) {
	        return isContentEditableTrue$4(elm.dom) || isContentEditableFalse$b(elm.dom);
	      }).exists(function (elm) {
	        return isContentEditableTrue$4(elm.dom);
	      });
	    };
	    var parseIndentValue = function (value) {
	      var number = parseInt(value, 10);
	      return isNaN(number) ? 0 : number;
	    };
	    var getIndentStyleName = function (useMargin, element) {
	      var indentStyleName = useMargin || isTable$2(element) ? 'margin' : 'padding';
	      var suffix = get$5(element, 'direction') === 'rtl' ? '-right' : '-left';
	      return indentStyleName + suffix;
	    };
	    var indentElement = function (dom, command, useMargin, value, unit, element) {
	      var indentStyleName = getIndentStyleName(useMargin, SugarElement.fromDom(element));
	      if (command === 'outdent') {
	        var styleValue = Math.max(0, parseIndentValue(element.style[indentStyleName]) - value);
	        dom.setStyle(element, indentStyleName, styleValue ? styleValue + unit : '');
	      } else {
	        var styleValue = parseIndentValue(element.style[indentStyleName]) + value + unit;
	        dom.setStyle(element, indentStyleName, styleValue);
	      }
	    };
	    var validateBlocks = function (editor, blocks) {
	      return forall(blocks, function (block) {
	        var indentStyleName = getIndentStyleName(shouldIndentUseMargin(editor), block);
	        var intentValue = getRaw(block, indentStyleName).map(parseIndentValue).getOr(0);
	        var contentEditable = editor.dom.getContentEditable(block.dom);
	        return contentEditable !== 'false' && intentValue > 0;
	      });
	    };
	    var canOutdent = function (editor) {
	      var blocks = getBlocksToIndent(editor);
	      return !editor.mode.isReadOnly() && (blocks.length > 1 || validateBlocks(editor, blocks));
	    };
	    var isListComponent = function (el) {
	      return isList(el) || isListItem(el);
	    };
	    var parentIsListComponent = function (el) {
	      return parent(el).exists(isListComponent);
	    };
	    var getBlocksToIndent = function (editor) {
	      return filter$4(fromDom$1(editor.selection.getSelectedBlocks()), function (el) {
	        return !isListComponent(el) && !parentIsListComponent(el) && isEditable(el);
	      });
	    };
	    var handle = function (editor, command) {
	      var dom = editor.dom, selection = editor.selection, formatter = editor.formatter;
	      var indentation = getIndentation(editor);
	      var indentUnit = /[a-z%]+$/i.exec(indentation)[0];
	      var indentValue = parseInt(indentation, 10);
	      var useMargin = shouldIndentUseMargin(editor);
	      var forcedRootBlock = getForcedRootBlock(editor);
	      if (!editor.queryCommandState('InsertUnorderedList') && !editor.queryCommandState('InsertOrderedList')) {
	        if (forcedRootBlock === '' && !dom.getParent(selection.getNode(), dom.isBlock)) {
	          formatter.apply('div');
	        }
	      }
	      each$k(getBlocksToIndent(editor), function (block) {
	        indentElement(dom, command, useMargin, indentValue, indentUnit, block.dom);
	      });
	    };
	
	    var backspaceDelete = function (editor, _forward) {
	      if (editor.selection.isCollapsed() && canOutdent(editor)) {
	        var dom = editor.dom;
	        var rng = editor.selection.getRng();
	        var pos = CaretPosition.fromRangeStart(rng);
	        var block = dom.getParent(rng.startContainer, dom.isBlock);
	        if (block !== null && isAtStartOfBlock(SugarElement.fromDom(block), pos)) {
	          handle(editor, 'outdent');
	          return true;
	        }
	      }
	      return false;
	    };
	
	    var nativeCommand = function (editor, command) {
	      editor.getDoc().execCommand(command, false, null);
	    };
	    var deleteCommand = function (editor, caret) {
	      if (backspaceDelete(editor)) {
	        return;
	      } else if (backspaceDelete$5(editor, false)) {
	        return;
	      } else if (backspaceDelete$6(editor, false)) {
	        return;
	      } else if (backspaceDelete$3(editor, caret, false)) {
	        return;
	      } else if (backspaceDelete$8(editor, false)) {
	        return;
	      } else if (backspaceDelete$9(editor)) {
	        return;
	      } else if (backspaceDelete$4(editor, false)) {
	        return;
	      } else if (backspaceDelete$1(editor, false)) {
	        return;
	      } else if (backspaceDelete$7(editor)) {
	        return;
	      } else if (backspaceDelete$2(editor, false)) {
	        return;
	      } else {
	        nativeCommand(editor, 'Delete');
	        paddEmptyBody(editor);
	      }
	    };
	    var forwardDeleteCommand = function (editor, caret) {
	      if (backspaceDelete$5(editor, true)) {
	        return;
	      } else if (backspaceDelete$6(editor, true)) {
	        return;
	      } else if (backspaceDelete$3(editor, caret, true)) {
	        return;
	      } else if (backspaceDelete$8(editor, true)) {
	        return;
	      } else if (backspaceDelete$9(editor)) {
	        return;
	      } else if (backspaceDelete$4(editor, true)) {
	        return;
	      } else if (backspaceDelete$1(editor, true)) {
	        return;
	      } else if (backspaceDelete$7(editor)) {
	        return;
	      } else if (backspaceDelete$2(editor, true)) {
	        return;
	      } else {
	        nativeCommand(editor, 'ForwardDelete');
	      }
	    };
	    var setup$f = function (editor, caret) {
	      editor.addCommand('delete', function () {
	        deleteCommand(editor, caret);
	      });
	      editor.addCommand('forwardDelete', function () {
	        forwardDeleteCommand(editor, caret);
	      });
	    };
	
	    var SIGNIFICANT_MOVE = 5;
	    var LONGPRESS_DELAY = 400;
	    var getTouch = function (event) {
	      if (event.touches === undefined || event.touches.length !== 1) {
	        return Optional.none();
	      }
	      return Optional.some(event.touches[0]);
	    };
	    var isFarEnough = function (touch, data) {
	      var distX = Math.abs(touch.clientX - data.x);
	      var distY = Math.abs(touch.clientY - data.y);
	      return distX > SIGNIFICANT_MOVE || distY > SIGNIFICANT_MOVE;
	    };
	    var setup$e = function (editor) {
	      var startData = value();
	      var longpressFired = Cell(false);
	      var debounceLongpress = last(function (e) {
	        editor.fire('longpress', __assign(__assign({}, e), { type: 'longpress' }));
	        longpressFired.set(true);
	      }, LONGPRESS_DELAY);
	      editor.on('touchstart', function (e) {
	        getTouch(e).each(function (touch) {
	          debounceLongpress.cancel();
	          var data = {
	            x: touch.clientX,
	            y: touch.clientY,
	            target: e.target
	          };
	          debounceLongpress.throttle(e);
	          longpressFired.set(false);
	          startData.set(data);
	        });
	      }, true);
	      editor.on('touchmove', function (e) {
	        debounceLongpress.cancel();
	        getTouch(e).each(function (touch) {
	          startData.on(function (data) {
	            if (isFarEnough(touch, data)) {
	              startData.clear();
	              longpressFired.set(false);
	              editor.fire('longpresscancel');
	            }
	          });
	        });
	      }, true);
	      editor.on('touchend touchcancel', function (e) {
	        debounceLongpress.cancel();
	        if (e.type === 'touchcancel') {
	          return;
	        }
	        startData.get().filter(function (data) {
	          return data.target.isEqualNode(e.target);
	        }).each(function () {
	          if (longpressFired.get()) {
	            e.preventDefault();
	          } else {
	            editor.fire('tap', __assign(__assign({}, e), { type: 'tap' }));
	          }
	        });
	      }, true);
	    };
	
	    var isBlockElement = function (blockElements, node) {
	      return has$2(blockElements, node.nodeName);
	    };
	    var isValidTarget = function (blockElements, node) {
	      if (isText$7(node)) {
	        return true;
	      } else if (isElement$5(node)) {
	        return !isBlockElement(blockElements, node) && !isBookmarkNode$1(node);
	      } else {
	        return false;
	      }
	    };
	    var hasBlockParent = function (blockElements, root, node) {
	      return exists(parents(SugarElement.fromDom(node), SugarElement.fromDom(root)), function (elm) {
	        return isBlockElement(blockElements, elm.dom);
	      });
	    };
	    var shouldRemoveTextNode = function (blockElements, node) {
	      if (isText$7(node)) {
	        if (node.nodeValue.length === 0) {
	          return true;
	        } else if (/^\s+$/.test(node.nodeValue) && (!node.nextSibling || isBlockElement(blockElements, node.nextSibling))) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var addRootBlocks = function (editor) {
	      var dom = editor.dom, selection = editor.selection;
	      var schema = editor.schema, blockElements = schema.getBlockElements();
	      var node = selection.getStart();
	      var rootNode = editor.getBody();
	      var rootBlockNode, tempNode, wrapped;
	      var forcedRootBlock = getForcedRootBlock(editor);
	      if (!node || !isElement$5(node) || !forcedRootBlock) {
	        return;
	      }
	      var rootNodeName = rootNode.nodeName.toLowerCase();
	      if (!schema.isValidChild(rootNodeName, forcedRootBlock.toLowerCase()) || hasBlockParent(blockElements, rootNode, node)) {
	        return;
	      }
	      var rng = selection.getRng();
	      var startContainer = rng.startContainer;
	      var startOffset = rng.startOffset;
	      var endContainer = rng.endContainer;
	      var endOffset = rng.endOffset;
	      var restoreSelection = hasFocus(editor);
	      node = rootNode.firstChild;
	      while (node) {
	        if (isValidTarget(blockElements, node)) {
	          if (shouldRemoveTextNode(blockElements, node)) {
	            tempNode = node;
	            node = node.nextSibling;
	            dom.remove(tempNode);
	            continue;
	          }
	          if (!rootBlockNode) {
	            rootBlockNode = dom.create(forcedRootBlock, getForcedRootBlockAttrs(editor));
	            node.parentNode.insertBefore(rootBlockNode, node);
	            wrapped = true;
	          }
	          tempNode = node;
	          node = node.nextSibling;
	          rootBlockNode.appendChild(tempNode);
	        } else {
	          rootBlockNode = null;
	          node = node.nextSibling;
	        }
	      }
	      if (wrapped && restoreSelection) {
	        rng.setStart(startContainer, startOffset);
	        rng.setEnd(endContainer, endOffset);
	        selection.setRng(rng);
	        editor.nodeChanged();
	      }
	    };
	    var setup$d = function (editor) {
	      if (getForcedRootBlock(editor)) {
	        editor.on('NodeChange', curry(addRootBlocks, editor));
	      }
	    };
	
	    var findBlockCaretContainer = function (editor) {
	      return descendant(SugarElement.fromDom(editor.getBody()), '*[data-mce-caret]').map(function (elm) {
	        return elm.dom;
	      }).getOrNull();
	    };
	    var removeIeControlRect = function (editor) {
	      editor.selection.setRng(editor.selection.getRng());
	    };
	    var showBlockCaretContainer = function (editor, blockCaretContainer) {
	      if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	        showCaretContainerBlock(blockCaretContainer);
	        removeIeControlRect(editor);
	        editor.selection.scrollIntoView(blockCaretContainer);
	      }
	    };
	    var handleBlockContainer = function (editor, e) {
	      var blockCaretContainer = findBlockCaretContainer(editor);
	      if (!blockCaretContainer) {
	        return;
	      }
	      if (e.type === 'compositionstart') {
	        e.preventDefault();
	        e.stopPropagation();
	        showBlockCaretContainer(editor, blockCaretContainer);
	        return;
	      }
	      if (hasContent(blockCaretContainer)) {
	        showBlockCaretContainer(editor, blockCaretContainer);
	        editor.undoManager.add();
	      }
	    };
	    var setup$c = function (editor) {
	      editor.on('keyup compositionstart', curry(handleBlockContainer, editor));
	    };
	
	    var isContentEditableFalse$2 = isContentEditableFalse$b;
	    var moveToCeFalseHorizontally = function (direction, editor, range) {
	      return moveHorizontally(editor, direction, range, isBeforeContentEditableFalse, isAfterContentEditableFalse, isContentEditableFalse$2);
	    };
	    var moveToCeFalseVertically = function (direction, editor, range) {
	      var isBefore = function (caretPosition) {
	        return isBeforeContentEditableFalse(caretPosition) || isBeforeTable(caretPosition);
	      };
	      var isAfter = function (caretPosition) {
	        return isAfterContentEditableFalse(caretPosition) || isAfterTable(caretPosition);
	      };
	      return moveVertically(editor, direction, range, isBefore, isAfter, isContentEditableFalse$2);
	    };
	    var createTextBlock = function (editor) {
	      var textBlock = editor.dom.create(getForcedRootBlock(editor));
	      if (!Env.ie || Env.ie >= 11) {
	        textBlock.innerHTML = '<br data-mce-bogus="1">';
	      }
	      return textBlock;
	    };
	    var exitPreBlock = function (editor, direction, range) {
	      var caretWalker = CaretWalker(editor.getBody());
	      var getVisualCaretPosition$1 = curry(getVisualCaretPosition, direction === 1 ? caretWalker.next : caretWalker.prev);
	      if (range.collapsed && hasForcedRootBlock(editor)) {
	        var pre = editor.dom.getParent(range.startContainer, 'PRE');
	        if (!pre) {
	          return;
	        }
	        var caretPos = getVisualCaretPosition$1(CaretPosition.fromRangeStart(range));
	        if (!caretPos) {
	          var newBlock = createTextBlock(editor);
	          if (direction === 1) {
	            editor.$(pre).after(newBlock);
	          } else {
	            editor.$(pre).before(newBlock);
	          }
	          editor.selection.select(newBlock, true);
	          editor.selection.collapse();
	        }
	      }
	    };
	    var getHorizontalRange = function (editor, forward) {
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var range = editor.selection.getRng();
	      return moveToCeFalseHorizontally(direction, editor, range).orThunk(function () {
	        exitPreBlock(editor, direction, range);
	        return Optional.none();
	      });
	    };
	    var getVerticalRange = function (editor, down) {
	      var direction = down ? 1 : -1;
	      var range = editor.selection.getRng();
	      return moveToCeFalseVertically(direction, editor, range).orThunk(function () {
	        exitPreBlock(editor, direction, range);
	        return Optional.none();
	      });
	    };
	    var moveH$2 = function (editor, forward) {
	      return getHorizontalRange(editor, forward).exists(function (newRange) {
	        moveToRange(editor, newRange);
	        return true;
	      });
	    };
	    var moveV$3 = function (editor, down) {
	      return getVerticalRange(editor, down).exists(function (newRange) {
	        moveToRange(editor, newRange);
	        return true;
	      });
	    };
	    var moveToLineEndPoint$1 = function (editor, forward) {
	      var isCefPosition = forward ? isAfterContentEditableFalse : isBeforeContentEditableFalse;
	      return moveToLineEndPoint$3(editor, forward, isCefPosition);
	    };
	
	    var isTarget = function (node) {
	      return contains$3(['figcaption'], name(node));
	    };
	    var rangeBefore = function (target) {
	      var rng = document.createRange();
	      rng.setStartBefore(target.dom);
	      rng.setEndBefore(target.dom);
	      return rng;
	    };
	    var insertElement = function (root, elm, forward) {
	      if (forward) {
	        append$1(root, elm);
	      } else {
	        prepend(root, elm);
	      }
	    };
	    var insertBr = function (root, forward) {
	      var br = SugarElement.fromTag('br');
	      insertElement(root, br, forward);
	      return rangeBefore(br);
	    };
	    var insertBlock = function (root, forward, blockName, attrs) {
	      var block = SugarElement.fromTag(blockName);
	      var br = SugarElement.fromTag('br');
	      setAll$1(block, attrs);
	      append$1(block, br);
	      insertElement(root, block, forward);
	      return rangeBefore(br);
	    };
	    var insertEmptyLine = function (root, rootBlockName, attrs, forward) {
	      if (rootBlockName === '') {
	        return insertBr(root, forward);
	      } else {
	        return insertBlock(root, forward, rootBlockName, attrs);
	      }
	    };
	    var getClosestTargetBlock = function (pos, root) {
	      var isRoot = curry(eq, root);
	      return closest$3(SugarElement.fromDom(pos.container()), isBlock$2, isRoot).filter(isTarget);
	    };
	    var isAtFirstOrLastLine = function (root, forward, pos) {
	      return forward ? isAtLastLine(root.dom, pos) : isAtFirstLine(root.dom, pos);
	    };
	    var moveCaretToNewEmptyLine = function (editor, forward) {
	      var root = SugarElement.fromDom(editor.getBody());
	      var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	      var rootBlock = getForcedRootBlock(editor);
	      var rootBlockAttrs = getForcedRootBlockAttrs(editor);
	      return getClosestTargetBlock(pos, root).exists(function () {
	        if (isAtFirstOrLastLine(root, forward, pos)) {
	          var rng = insertEmptyLine(root, rootBlock, rootBlockAttrs, forward);
	          editor.selection.setRng(rng);
	          return true;
	        } else {
	          return false;
	        }
	      });
	    };
	    var moveV$2 = function (editor, forward) {
	      if (editor.selection.isCollapsed()) {
	        return moveCaretToNewEmptyLine(editor, forward);
	      } else {
	        return false;
	      }
	    };
	
	    var defaultPatterns = function (patterns) {
	      return map$3(patterns, function (pattern) {
	        return __assign({
	          shiftKey: false,
	          altKey: false,
	          ctrlKey: false,
	          metaKey: false,
	          keyCode: 0,
	          action: noop
	        }, pattern);
	      });
	    };
	    var matchesEvent = function (pattern, evt) {
	      return evt.keyCode === pattern.keyCode && evt.shiftKey === pattern.shiftKey && evt.altKey === pattern.altKey && evt.ctrlKey === pattern.ctrlKey && evt.metaKey === pattern.metaKey;
	    };
	    var match$1 = function (patterns, evt) {
	      return bind(defaultPatterns(patterns), function (pattern) {
	        return matchesEvent(pattern, evt) ? [pattern] : [];
	      });
	    };
	    var action = function (f) {
	      var x = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        x[_i - 1] = arguments[_i];
	      }
	      return function () {
	        return f.apply(null, x);
	      };
	    };
	    var execute = function (patterns, evt) {
	      return find$3(match$1(patterns, evt), function (pattern) {
	        return pattern.action();
	      });
	    };
	
	    var moveH$1 = function (editor, forward) {
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var range = editor.selection.getRng();
	      return moveHorizontally(editor, direction, range, isBeforeMedia, isAfterMedia, isMedia$2).exists(function (newRange) {
	        moveToRange(editor, newRange);
	        return true;
	      });
	    };
	    var moveV$1 = function (editor, down) {
	      var direction = down ? 1 : -1;
	      var range = editor.selection.getRng();
	      return moveVertically(editor, direction, range, isBeforeMedia, isAfterMedia, isMedia$2).exists(function (newRange) {
	        moveToRange(editor, newRange);
	        return true;
	      });
	    };
	    var moveToLineEndPoint = function (editor, forward) {
	      var isNearMedia = forward ? isAfterMedia : isBeforeMedia;
	      return moveToLineEndPoint$3(editor, forward, isNearMedia);
	    };
	
	    var deflate = function (rect, delta) {
	      return {
	        left: rect.left - delta,
	        top: rect.top - delta,
	        right: rect.right + delta * 2,
	        bottom: rect.bottom + delta * 2,
	        width: rect.width + delta,
	        height: rect.height + delta
	      };
	    };
	    var getCorners = function (getYAxisValue, tds) {
	      return bind(tds, function (td) {
	        var rect = deflate(clone(td.getBoundingClientRect()), -1);
	        return [
	          {
	            x: rect.left,
	            y: getYAxisValue(rect),
	            cell: td
	          },
	          {
	            x: rect.right,
	            y: getYAxisValue(rect),
	            cell: td
	          }
	        ];
	      });
	    };
	    var findClosestCorner = function (corners, x, y) {
	      return foldl(corners, function (acc, newCorner) {
	        return acc.fold(function () {
	          return Optional.some(newCorner);
	        }, function (oldCorner) {
	          var oldDist = Math.sqrt(Math.abs(oldCorner.x - x) + Math.abs(oldCorner.y - y));
	          var newDist = Math.sqrt(Math.abs(newCorner.x - x) + Math.abs(newCorner.y - y));
	          return Optional.some(newDist < oldDist ? newCorner : oldCorner);
	        });
	      }, Optional.none());
	    };
	    var getClosestCell = function (getYAxisValue, isTargetCorner, table, x, y) {
	      var cells = descendants(SugarElement.fromDom(table), 'td,th,caption').map(function (e) {
	        return e.dom;
	      });
	      var corners = filter$4(getCorners(getYAxisValue, cells), function (corner) {
	        return isTargetCorner(corner, y);
	      });
	      return findClosestCorner(corners, x, y).map(function (corner) {
	        return corner.cell;
	      });
	    };
	    var getBottomValue = function (rect) {
	      return rect.bottom;
	    };
	    var getTopValue = function (rect) {
	      return rect.top;
	    };
	    var isAbove = function (corner, y) {
	      return corner.y < y;
	    };
	    var isBelow = function (corner, y) {
	      return corner.y > y;
	    };
	    var getClosestCellAbove = curry(getClosestCell, getBottomValue, isAbove);
	    var getClosestCellBelow = curry(getClosestCell, getTopValue, isBelow);
	    var findClosestPositionInAboveCell = function (table, pos) {
	      return head(pos.getClientRects()).bind(function (rect) {
	        return getClosestCellAbove(table, rect.left, rect.top);
	      }).bind(function (cell) {
	        return findClosestHorizontalPosition(getLastLinePositions(cell), pos);
	      });
	    };
	    var findClosestPositionInBelowCell = function (table, pos) {
	      return last$2(pos.getClientRects()).bind(function (rect) {
	        return getClosestCellBelow(table, rect.left, rect.top);
	      }).bind(function (cell) {
	        return findClosestHorizontalPosition(getFirstLinePositions(cell), pos);
	      });
	    };
	
	    var hasNextBreak = function (getPositionsUntil, scope, lineInfo) {
	      return lineInfo.breakAt.exists(function (breakPos) {
	        return getPositionsUntil(scope, breakPos).breakAt.isSome();
	      });
	    };
	    var startsWithWrapBreak = function (lineInfo) {
	      return lineInfo.breakType === BreakType.Wrap && lineInfo.positions.length === 0;
	    };
	    var startsWithBrBreak = function (lineInfo) {
	      return lineInfo.breakType === BreakType.Br && lineInfo.positions.length === 1;
	    };
	    var isAtTableCellLine = function (getPositionsUntil, scope, pos) {
	      var lineInfo = getPositionsUntil(scope, pos);
	      if (startsWithWrapBreak(lineInfo) || !isBr$5(pos.getNode()) && startsWithBrBreak(lineInfo)) {
	        return !hasNextBreak(getPositionsUntil, scope, lineInfo);
	      } else {
	        return lineInfo.breakAt.isNone();
	      }
	    };
	    var isAtFirstTableCellLine = curry(isAtTableCellLine, getPositionsUntilPreviousLine);
	    var isAtLastTableCellLine = curry(isAtTableCellLine, getPositionsUntilNextLine);
	    var isCaretAtStartOrEndOfTable = function (forward, rng, table) {
	      var caretPos = CaretPosition.fromRangeStart(rng);
	      return positionIn(!forward, table).exists(function (pos) {
	        return pos.isEqual(caretPos);
	      });
	    };
	    var navigateHorizontally = function (editor, forward, table, _td) {
	      var rng = editor.selection.getRng();
	      var direction = forward ? 1 : -1;
	      if (isFakeCaretTableBrowser() && isCaretAtStartOrEndOfTable(forward, rng, table)) {
	        showCaret(direction, editor, table, !forward, false).each(function (newRng) {
	          moveToRange(editor, newRng);
	        });
	        return true;
	      }
	      return false;
	    };
	    var getClosestAbovePosition = function (root, table, start) {
	      return findClosestPositionInAboveCell(table, start).orThunk(function () {
	        return head(start.getClientRects()).bind(function (rect) {
	          return findClosestHorizontalPositionFromPoint(getPositionsAbove(root, CaretPosition.before(table)), rect.left);
	        });
	      }).getOr(CaretPosition.before(table));
	    };
	    var getClosestBelowPosition = function (root, table, start) {
	      return findClosestPositionInBelowCell(table, start).orThunk(function () {
	        return head(start.getClientRects()).bind(function (rect) {
	          return findClosestHorizontalPositionFromPoint(getPositionsBelow(root, CaretPosition.after(table)), rect.left);
	        });
	      }).getOr(CaretPosition.after(table));
	    };
	    var getTable = function (previous, pos) {
	      var node = pos.getNode(previous);
	      return isElement$5(node) && node.nodeName === 'TABLE' ? Optional.some(node) : Optional.none();
	    };
	    var renderBlock = function (down, editor, table, pos) {
	      var forcedRootBlock = getForcedRootBlock(editor);
	      if (forcedRootBlock) {
	        editor.undoManager.transact(function () {
	          var element = SugarElement.fromTag(forcedRootBlock);
	          setAll$1(element, getForcedRootBlockAttrs(editor));
	          append$1(element, SugarElement.fromTag('br'));
	          if (down) {
	            after$3(SugarElement.fromDom(table), element);
	          } else {
	            before$4(SugarElement.fromDom(table), element);
	          }
	          var rng = editor.dom.createRng();
	          rng.setStart(element.dom, 0);
	          rng.setEnd(element.dom, 0);
	          moveToRange(editor, rng);
	        });
	      } else {
	        moveToRange(editor, pos.toRange());
	      }
	    };
	    var moveCaret = function (editor, down, pos) {
	      var table = down ? getTable(true, pos) : getTable(false, pos);
	      var last = down === false;
	      table.fold(function () {
	        return moveToRange(editor, pos.toRange());
	      }, function (table) {
	        return positionIn(last, editor.getBody()).filter(function (lastPos) {
	          return lastPos.isEqual(pos);
	        }).fold(function () {
	          return moveToRange(editor, pos.toRange());
	        }, function (_) {
	          return renderBlock(down, editor, table, pos);
	        });
	      });
	    };
	    var navigateVertically = function (editor, down, table, td) {
	      var rng = editor.selection.getRng();
	      var pos = CaretPosition.fromRangeStart(rng);
	      var root = editor.getBody();
	      if (!down && isAtFirstTableCellLine(td, pos)) {
	        var newPos = getClosestAbovePosition(root, table, pos);
	        moveCaret(editor, down, newPos);
	        return true;
	      } else if (down && isAtLastTableCellLine(td, pos)) {
	        var newPos = getClosestBelowPosition(root, table, pos);
	        moveCaret(editor, down, newPos);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var move$1 = function (editor, forward, mover) {
	      return Optional.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
	        return Optional.from(editor.dom.getParent(td, 'table')).map(function (table) {
	          return mover(editor, forward, table, td);
	        });
	      }).getOr(false);
	    };
	    var moveH = function (editor, forward) {
	      return move$1(editor, forward, navigateHorizontally);
	    };
	    var moveV = function (editor, forward) {
	      return move$1(editor, forward, navigateVertically);
	    };
	
	    var executeKeydownOverride$3 = function (editor, caret, evt) {
	      var os = detect().os;
	      execute([
	        {
	          keyCode: VK.RIGHT,
	          action: action(moveH$2, editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: action(moveH$2, editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: action(moveV$3, editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: action(moveV$3, editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: action(moveH, editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: action(moveH, editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: action(moveV, editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: action(moveV, editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: action(moveH$1, editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: action(moveH$1, editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: action(moveV$1, editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: action(moveV$1, editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: action(move$2, editor, caret, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: action(move$2, editor, caret, false)
	        },
	        {
	          keyCode: VK.RIGHT,
	          ctrlKey: !os.isOSX(),
	          altKey: os.isOSX(),
	          action: action(moveNextWord, editor, caret)
	        },
	        {
	          keyCode: VK.LEFT,
	          ctrlKey: !os.isOSX(),
	          altKey: os.isOSX(),
	          action: action(movePrevWord, editor, caret)
	        },
	        {
	          keyCode: VK.UP,
	          action: action(moveV$2, editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: action(moveV$2, editor, true)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$b = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$3(editor, caret, evt);
	        }
	      });
	    };
	
	    var executeKeydownOverride$2 = function (editor, caret, evt) {
	      execute([
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$5, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$5, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$6, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$6, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$3, editor, caret, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$3, editor, caret, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$9, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$9, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$4, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$4, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$1, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$1, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$7, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$7, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$8, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$8, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$2, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$2, editor, true)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var executeKeyupOverride = function (editor, evt) {
	      execute([
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(paddEmptyElement, editor)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(paddEmptyElement, editor)
	        }
	      ], evt);
	    };
	    var setup$a = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$2(editor, caret, evt);
	        }
	      });
	      editor.on('keyup', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeyupOverride(editor, evt);
	        }
	      });
	    };
	
	    var firstNonWhiteSpaceNodeSibling = function (node) {
	      while (node) {
	        if (node.nodeType === 1 || node.nodeType === 3 && node.data && /[\r\n\s]/.test(node.data)) {
	          return node;
	        }
	        node = node.nextSibling;
	      }
	    };
	    var moveToCaretPosition = function (editor, root) {
	      var node, lastNode = root;
	      var dom = editor.dom;
	      var moveCaretBeforeOnEnterElementsMap = editor.schema.getMoveCaretBeforeOnEnterElements();
	      if (!root) {
	        return;
	      }
	      if (/^(LI|DT|DD)$/.test(root.nodeName)) {
	        var firstChild = firstNonWhiteSpaceNodeSibling(root.firstChild);
	        if (firstChild && /^(UL|OL|DL)$/.test(firstChild.nodeName)) {
	          root.insertBefore(dom.doc.createTextNode(nbsp), root.firstChild);
	        }
	      }
	      var rng = dom.createRng();
	      root.normalize();
	      if (root.hasChildNodes()) {
	        var walker = new DomTreeWalker(root, root);
	        while (node = walker.current()) {
	          if (isText$7(node)) {
	            rng.setStart(node, 0);
	            rng.setEnd(node, 0);
	            break;
	          }
	          if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
	            rng.setStartBefore(node);
	            rng.setEndBefore(node);
	            break;
	          }
	          lastNode = node;
	          node = walker.next();
	        }
	        if (!node) {
	          rng.setStart(lastNode, 0);
	          rng.setEnd(lastNode, 0);
	        }
	      } else {
	        if (isBr$5(root)) {
	          if (root.nextSibling && dom.isBlock(root.nextSibling)) {
	            rng.setStartBefore(root);
	            rng.setEndBefore(root);
	          } else {
	            rng.setStartAfter(root);
	            rng.setEndAfter(root);
	          }
	        } else {
	          rng.setStart(root, 0);
	          rng.setEnd(root, 0);
	        }
	      }
	      editor.selection.setRng(rng);
	      scrollRangeIntoView(editor, rng);
	    };
	    var getEditableRoot$1 = function (dom, node) {
	      var root = dom.getRoot();
	      var parent, editableRoot;
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
	        if (dom.getContentEditable(parent) === 'true') {
	          editableRoot = parent;
	        }
	        parent = parent.parentNode;
	      }
	      return parent !== root ? editableRoot : root;
	    };
	    var getParentBlock = function (editor) {
	      return Optional.from(editor.dom.getParent(editor.selection.getStart(true), editor.dom.isBlock));
	    };
	    var getParentBlockName = function (editor) {
	      return getParentBlock(editor).fold(constant(''), function (parentBlock) {
	        return parentBlock.nodeName.toUpperCase();
	      });
	    };
	    var isListItemParentBlock = function (editor) {
	      return getParentBlock(editor).filter(function (elm) {
	        return isListItem(SugarElement.fromDom(elm));
	      }).isSome();
	    };
	
	    var hasFirstChild = function (elm, name) {
	      return elm.firstChild && elm.firstChild.nodeName === name;
	    };
	    var isFirstChild = function (elm) {
	      var _a;
	      return ((_a = elm.parentNode) === null || _a === void 0 ? void 0 : _a.firstChild) === elm;
	    };
	    var hasParent = function (elm, parentName) {
	      return elm && elm.parentNode && elm.parentNode.nodeName === parentName;
	    };
	    var isListBlock = function (elm) {
	      return elm && /^(OL|UL|LI)$/.test(elm.nodeName);
	    };
	    var isNestedList = function (elm) {
	      return isListBlock(elm) && isListBlock(elm.parentNode);
	    };
	    var getContainerBlock = function (containerBlock) {
	      var containerBlockParent = containerBlock.parentNode;
	      if (/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)) {
	        return containerBlockParent;
	      }
	      return containerBlock;
	    };
	    var isFirstOrLastLi = function (containerBlock, parentBlock, first) {
	      var node = containerBlock[first ? 'firstChild' : 'lastChild'];
	      while (node) {
	        if (isElement$5(node)) {
	          break;
	        }
	        node = node[first ? 'nextSibling' : 'previousSibling'];
	      }
	      return node === parentBlock;
	    };
	    var insert$3 = function (editor, createNewBlock, containerBlock, parentBlock, newBlockName) {
	      var dom = editor.dom;
	      var rng = editor.selection.getRng();
	      if (containerBlock === editor.getBody()) {
	        return;
	      }
	      if (isNestedList(containerBlock)) {
	        newBlockName = 'LI';
	      }
	      var newBlock = newBlockName ? createNewBlock(newBlockName) : dom.create('BR');
	      if (isFirstOrLastLi(containerBlock, parentBlock, true) && isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        if (hasParent(containerBlock, 'LI')) {
	          var containerBlockParent = getContainerBlock(containerBlock);
	          dom.insertAfter(newBlock, containerBlockParent);
	          if (isFirstChild(containerBlock)) {
	            dom.remove(containerBlockParent);
	          } else {
	            dom.remove(containerBlock);
	          }
	        } else {
	          dom.replace(newBlock, containerBlock);
	        }
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, true)) {
	        if (hasParent(containerBlock, 'LI')) {
	          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	          newBlock.appendChild(dom.doc.createTextNode(' '));
	          newBlock.appendChild(containerBlock);
	        } else {
	          containerBlock.parentNode.insertBefore(newBlock, containerBlock);
	        }
	        dom.remove(parentBlock);
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	        dom.remove(parentBlock);
	      } else {
	        containerBlock = getContainerBlock(containerBlock);
	        var tmpRng = rng.cloneRange();
	        tmpRng.setStartAfter(parentBlock);
	        tmpRng.setEndAfter(containerBlock);
	        var fragment = tmpRng.extractContents();
	        if (newBlockName === 'LI' && hasFirstChild(fragment, 'LI')) {
	          newBlock = fragment.firstChild;
	          dom.insertAfter(fragment, containerBlock);
	        } else {
	          dom.insertAfter(fragment, containerBlock);
	          dom.insertAfter(newBlock, containerBlock);
	        }
	        dom.remove(parentBlock);
	      }
	      moveToCaretPosition(editor, newBlock);
	    };
	
	    var trimZwsp = function (fragment) {
	      each$k(descendants$1(SugarElement.fromDom(fragment), isText$8), function (text) {
	        var rawNode = text.dom;
	        rawNode.nodeValue = trim$2(rawNode.nodeValue);
	      });
	    };
	    var isEmptyAnchor = function (dom, elm) {
	      return elm && elm.nodeName === 'A' && dom.isEmpty(elm);
	    };
	    var isTableCell = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	    var emptyBlock = function (elm) {
	      elm.innerHTML = '<br data-mce-bogus="1">';
	    };
	    var containerAndSiblingName = function (container, nodeName) {
	      return container.nodeName === nodeName || container.previousSibling && container.previousSibling.nodeName === nodeName;
	    };
	    var canSplitBlock = function (dom, node) {
	      return node && dom.isBlock(node) && !/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) && !/^(fixed|absolute)/i.test(node.style.position) && dom.getContentEditable(node) !== 'true';
	    };
	    var trimInlineElementsOnLeftSideOfBlock = function (dom, nonEmptyElementsMap, block) {
	      var node = block;
	      var firstChilds = [];
	      var i;
	      if (!node) {
	        return;
	      }
	      while (node = node.firstChild) {
	        if (dom.isBlock(node)) {
	          return;
	        }
	        if (isElement$5(node) && !nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          firstChilds.push(node);
	        }
	      }
	      i = firstChilds.length;
	      while (i--) {
	        node = firstChilds[i];
	        if (!node.hasChildNodes() || node.firstChild === node.lastChild && node.firstChild.nodeValue === '') {
	          dom.remove(node);
	        } else {
	          if (isEmptyAnchor(dom, node)) {
	            dom.remove(node);
	          }
	        }
	      }
	    };
	    var normalizeZwspOffset = function (start, container, offset) {
	      if (isText$7(container) === false) {
	        return offset;
	      } else if (start) {
	        return offset === 1 && container.data.charAt(offset - 1) === ZWSP$1 ? 0 : offset;
	      } else {
	        return offset === container.data.length - 1 && container.data.charAt(offset) === ZWSP$1 ? container.data.length : offset;
	      }
	    };
	    var includeZwspInRange = function (rng) {
	      var newRng = rng.cloneRange();
	      newRng.setStart(rng.startContainer, normalizeZwspOffset(true, rng.startContainer, rng.startOffset));
	      newRng.setEnd(rng.endContainer, normalizeZwspOffset(false, rng.endContainer, rng.endOffset));
	      return newRng;
	    };
	    var trimLeadingLineBreaks = function (node) {
	      do {
	        if (isText$7(node)) {
	          node.nodeValue = node.nodeValue.replace(/^[\r\n]+/, '');
	        }
	        node = node.firstChild;
	      } while (node);
	    };
	    var getEditableRoot = function (dom, node) {
	      var root = dom.getRoot();
	      var parent, editableRoot;
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
	        if (dom.getContentEditable(parent) === 'true') {
	          editableRoot = parent;
	        }
	        parent = parent.parentNode;
	      }
	      return parent !== root ? editableRoot : root;
	    };
	    var applyAttributes = function (editor, node, forcedRootBlockAttrs) {
	      var dom = editor.dom;
	      Optional.from(forcedRootBlockAttrs.style).map(dom.parseStyle).each(function (attrStyles) {
	        var currentStyles = getAllRaw(SugarElement.fromDom(node));
	        var newStyles = __assign(__assign({}, currentStyles), attrStyles);
	        dom.setStyles(node, newStyles);
	      });
	      var attrClassesOpt = Optional.from(forcedRootBlockAttrs.class).map(function (attrClasses) {
	        return attrClasses.split(/\s+/);
	      });
	      var currentClassesOpt = Optional.from(node.className).map(function (currentClasses) {
	        return filter$4(currentClasses.split(/\s+/), function (clazz) {
	          return clazz !== '';
	        });
	      });
	      lift2(attrClassesOpt, currentClassesOpt, function (attrClasses, currentClasses) {
	        var filteredClasses = filter$4(currentClasses, function (clazz) {
	          return !contains$3(attrClasses, clazz);
	        });
	        var newClasses = __spreadArray(__spreadArray([], attrClasses, true), filteredClasses, true);
	        dom.setAttrib(node, 'class', newClasses.join(' '));
	      });
	      var appliedAttrs = [
	        'style',
	        'class'
	      ];
	      var remainingAttrs = filter$3(forcedRootBlockAttrs, function (_, attrs) {
	        return !contains$3(appliedAttrs, attrs);
	      });
	      dom.setAttribs(node, remainingAttrs);
	    };
	    var setForcedBlockAttrs = function (editor, node) {
	      var forcedRootBlockName = getForcedRootBlock(editor);
	      if (forcedRootBlockName && forcedRootBlockName.toLowerCase() === node.tagName.toLowerCase()) {
	        var forcedRootBlockAttrs = getForcedRootBlockAttrs(editor);
	        applyAttributes(editor, node, forcedRootBlockAttrs);
	      }
	    };
	    var wrapSelfAndSiblingsInDefaultBlock = function (editor, newBlockName, rng, container, offset) {
	      var newBlock, parentBlock, startNode, node, next, rootBlockName;
	      var blockName = newBlockName || 'P';
	      var dom = editor.dom, editableRoot = getEditableRoot(dom, container);
	      parentBlock = dom.getParent(container, dom.isBlock);
	      if (!parentBlock || !canSplitBlock(dom, parentBlock)) {
	        parentBlock = parentBlock || editableRoot;
	        if (parentBlock === editor.getBody() || isTableCell(parentBlock)) {
	          rootBlockName = parentBlock.nodeName.toLowerCase();
	        } else {
	          rootBlockName = parentBlock.parentNode.nodeName.toLowerCase();
	        }
	        if (!parentBlock.hasChildNodes()) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          parentBlock.appendChild(newBlock);
	          rng.setStart(newBlock, 0);
	          rng.setEnd(newBlock, 0);
	          return newBlock;
	        }
	        node = container;
	        while (node.parentNode !== parentBlock) {
	          node = node.parentNode;
	        }
	        while (node && !dom.isBlock(node)) {
	          startNode = node;
	          node = node.previousSibling;
	        }
	        if (startNode && editor.schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          startNode.parentNode.insertBefore(newBlock, startNode);
	          node = startNode;
	          while (node && !dom.isBlock(node)) {
	            next = node.nextSibling;
	            newBlock.appendChild(node);
	            node = next;
	          }
	          rng.setStart(container, offset);
	          rng.setEnd(container, offset);
	        }
	      }
	      return container;
	    };
	    var addBrToBlockIfNeeded = function (dom, block) {
	      block.normalize();
	      var lastChild = block.lastChild;
	      if (!lastChild || /^(left|right)$/gi.test(dom.getStyle(lastChild, 'float', true))) {
	        dom.add(block, 'br');
	      }
	    };
	    var insert$2 = function (editor, evt) {
	      var tmpRng, container, offset, parentBlock;
	      var newBlock, fragment, containerBlock, parentBlockName, newBlockName, isAfterLastNodeInContainer;
	      var dom = editor.dom;
	      var schema = editor.schema, nonEmptyElementsMap = schema.getNonEmptyElements();
	      var rng = editor.selection.getRng();
	      var createNewBlock = function (name) {
	        var node = container, block, clonedNode, caretNode;
	        var textInlineElements = schema.getTextInlineElements();
	        if (name || parentBlockName === 'TABLE' || parentBlockName === 'HR') {
	          block = dom.create(name || newBlockName);
	        } else {
	          block = parentBlock.cloneNode(false);
	        }
	        caretNode = block;
	        if (shouldKeepStyles(editor) === false) {
	          dom.setAttrib(block, 'style', null);
	          dom.setAttrib(block, 'class', null);
	        } else {
	          do {
	            if (textInlineElements[node.nodeName]) {
	              if (isCaretNode(node) || isBookmarkNode$1(node)) {
	                continue;
	              }
	              clonedNode = node.cloneNode(false);
	              dom.setAttrib(clonedNode, 'id', '');
	              if (block.hasChildNodes()) {
	                clonedNode.appendChild(block.firstChild);
	                block.appendChild(clonedNode);
	              } else {
	                caretNode = clonedNode;
	                block.appendChild(clonedNode);
	              }
	            }
	          } while ((node = node.parentNode) && node !== editableRoot);
	        }
	        setForcedBlockAttrs(editor, block);
	        emptyBlock(caretNode);
	        return block;
	      };
	      var isCaretAtStartOrEndOfBlock = function (start) {
	        var node, name;
	        var normalizedOffset = normalizeZwspOffset(start, container, offset);
	        if (isText$7(container) && (start ? normalizedOffset > 0 : normalizedOffset < container.nodeValue.length)) {
	          return false;
	        }
	        if (container.parentNode === parentBlock && isAfterLastNodeInContainer && !start) {
	          return true;
	        }
	        if (start && isElement$5(container) && container === parentBlock.firstChild) {
	          return true;
	        }
	        if (containerAndSiblingName(container, 'TABLE') || containerAndSiblingName(container, 'HR')) {
	          return isAfterLastNodeInContainer && !start || !isAfterLastNodeInContainer && start;
	        }
	        var walker = new DomTreeWalker(container, parentBlock);
	        if (isText$7(container)) {
	          if (start && normalizedOffset === 0) {
	            walker.prev();
	          } else if (!start && normalizedOffset === container.nodeValue.length) {
	            walker.next();
	          }
	        }
	        while (node = walker.current()) {
	          if (isElement$5(node)) {
	            if (!node.getAttribute('data-mce-bogus')) {
	              name = node.nodeName.toLowerCase();
	              if (nonEmptyElementsMap[name] && name !== 'br') {
	                return false;
	              }
	            }
	          } else if (isText$7(node) && !isWhitespaceText(node.nodeValue)) {
	            return false;
	          }
	          if (start) {
	            walker.prev();
	          } else {
	            walker.next();
	          }
	        }
	        return true;
	      };
	      var insertNewBlockAfter = function () {
	        if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName !== 'HGROUP') {
	          newBlock = createNewBlock(newBlockName);
	        } else {
	          newBlock = createNewBlock();
	        }
	        if (shouldEndContainerOnEmptyBlock(editor) && canSplitBlock(dom, containerBlock) && dom.isEmpty(parentBlock)) {
	          newBlock = dom.split(containerBlock, parentBlock);
	        } else {
	          dom.insertAfter(newBlock, parentBlock);
	        }
	        moveToCaretPosition(editor, newBlock);
	      };
	      normalize$2(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      newBlockName = getForcedRootBlock(editor);
	      var shiftKey = !!(evt && evt.shiftKey);
	      var ctrlKey = !!(evt && evt.ctrlKey);
	      if (isElement$5(container) && container.hasChildNodes()) {
	        isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && isText$7(container)) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	      var editableRoot = getEditableRoot(dom, container);
	      if (!editableRoot) {
	        return;
	      }
	      if (newBlockName && !shiftKey || !newBlockName && shiftKey) {
	        container = wrapSelfAndSiblingsInDefaultBlock(editor, newBlockName, rng, container, offset);
	      }
	      parentBlock = dom.getParent(container, dom.isBlock);
	      containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : '';
	      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
	      if (containerBlockName === 'LI' && !ctrlKey) {
	        parentBlock = containerBlock;
	        containerBlock = containerBlock.parentNode;
	        parentBlockName = containerBlockName;
	      }
	      if (/^(LI|DT|DD)$/.test(parentBlockName)) {
	        if (dom.isEmpty(parentBlock)) {
	          insert$3(editor, createNewBlock, containerBlock, parentBlock, newBlockName);
	          return;
	        }
	      }
	      if (newBlockName && parentBlock === editor.getBody()) {
	        return;
	      }
	      newBlockName = newBlockName || 'P';
	      if (isCaretContainerBlock$1(parentBlock)) {
	        newBlock = showCaretContainerBlock(parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        setForcedBlockAttrs(editor, newBlock);
	        moveToCaretPosition(editor, newBlock);
	      } else if (isCaretAtStartOrEndOfBlock()) {
	        insertNewBlockAfter();
	      } else if (isCaretAtStartOrEndOfBlock(true)) {
	        newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
	        moveToCaretPosition(editor, containerAndSiblingName(parentBlock, 'HR') ? newBlock : parentBlock);
	      } else {
	        tmpRng = includeZwspInRange(rng).cloneRange();
	        tmpRng.setEndAfter(parentBlock);
	        fragment = tmpRng.extractContents();
	        trimZwsp(fragment);
	        trimLeadingLineBreaks(fragment);
	        newBlock = fragment.firstChild;
	        dom.insertAfter(fragment, parentBlock);
	        trimInlineElementsOnLeftSideOfBlock(dom, nonEmptyElementsMap, newBlock);
	        addBrToBlockIfNeeded(dom, parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        newBlock.normalize();
	        if (dom.isEmpty(newBlock)) {
	          dom.remove(newBlock);
	          insertNewBlockAfter();
	        } else {
	          setForcedBlockAttrs(editor, newBlock);
	          moveToCaretPosition(editor, newBlock);
	        }
	      }
	      dom.setAttrib(newBlock, 'id', '');
	      editor.fire('NewBlock', { newBlock: newBlock });
	    };
	
	    var hasRightSideContent = function (schema, container, parentBlock) {
	      var walker = new DomTreeWalker(container, parentBlock);
	      var node;
	      var nonEmptyElementsMap = schema.getNonEmptyElements();
	      while (node = walker.next()) {
	        if (nonEmptyElementsMap[node.nodeName.toLowerCase()] || node.length > 0) {
	          return true;
	        }
	      }
	    };
	    var moveSelectionToBr = function (editor, brElm, extraBr) {
	      var rng = editor.dom.createRng();
	      if (!extraBr) {
	        rng.setStartAfter(brElm);
	        rng.setEndAfter(brElm);
	      } else {
	        rng.setStartBefore(brElm);
	        rng.setEndBefore(brElm);
	      }
	      editor.selection.setRng(rng);
	      scrollRangeIntoView(editor, rng);
	    };
	    var insertBrAtCaret = function (editor, evt) {
	      var selection = editor.selection;
	      var dom = editor.dom;
	      var rng = selection.getRng();
	      var brElm;
	      var extraBr;
	      normalize$2(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	      var offset = rng.startOffset;
	      var container = rng.startContainer;
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        var isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && container.nodeType === 3) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	      var parentBlock = dom.getParent(container, dom.isBlock);
	      var containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
	      var isControlKey = !!(evt && evt.ctrlKey);
	      if (containerBlockName === 'LI' && !isControlKey) {
	        parentBlock = containerBlock;
	      }
	      if (container && container.nodeType === 3 && offset >= container.nodeValue.length) {
	        if (!hasRightSideContent(editor.schema, container, parentBlock)) {
	          brElm = dom.create('br');
	          rng.insertNode(brElm);
	          rng.setStartAfter(brElm);
	          rng.setEndAfter(brElm);
	          extraBr = true;
	        }
	      }
	      brElm = dom.create('br');
	      rangeInsertNode(dom, rng, brElm);
	      moveSelectionToBr(editor, brElm, extraBr);
	      editor.undoManager.add();
	    };
	    var insertBrBefore = function (editor, inline) {
	      var br = SugarElement.fromTag('br');
	      before$4(SugarElement.fromDom(inline), br);
	      editor.undoManager.add();
	    };
	    var insertBrAfter = function (editor, inline) {
	      if (!hasBrAfter(editor.getBody(), inline)) {
	        after$3(SugarElement.fromDom(inline), SugarElement.fromTag('br'));
	      }
	      var br = SugarElement.fromTag('br');
	      after$3(SugarElement.fromDom(inline), br);
	      moveSelectionToBr(editor, br.dom, false);
	      editor.undoManager.add();
	    };
	    var isBeforeBr = function (pos) {
	      return isBr$5(pos.getNode());
	    };
	    var hasBrAfter = function (rootNode, startNode) {
	      if (isBeforeBr(CaretPosition.after(startNode))) {
	        return true;
	      } else {
	        return nextPosition(rootNode, CaretPosition.after(startNode)).map(function (pos) {
	          return isBr$5(pos.getNode());
	        }).getOr(false);
	      }
	    };
	    var isAnchorLink = function (elm) {
	      return elm && elm.nodeName === 'A' && 'href' in elm;
	    };
	    var isInsideAnchor = function (location) {
	      return location.fold(never, isAnchorLink, isAnchorLink, never);
	    };
	    var readInlineAnchorLocation = function (editor) {
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      var position = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return readLocation(isInlineTarget$1, editor.getBody(), position).filter(isInsideAnchor);
	    };
	    var insertBrOutsideAnchor = function (editor, location) {
	      location.fold(noop, curry(insertBrBefore, editor), curry(insertBrAfter, editor), noop);
	    };
	    var insert$1 = function (editor, evt) {
	      var anchorLocation = readInlineAnchorLocation(editor);
	      if (anchorLocation.isSome()) {
	        anchorLocation.each(curry(insertBrOutsideAnchor, editor));
	      } else {
	        insertBrAtCaret(editor, evt);
	      }
	    };
	
	    var matchesSelector = function (editor, selector) {
	      return getParentBlock(editor).filter(function (parentBlock) {
	        return selector.length > 0 && is$2(SugarElement.fromDom(parentBlock), selector);
	      }).isSome();
	    };
	    var shouldInsertBr = function (editor) {
	      return matchesSelector(editor, getBrNewLineSelector(editor));
	    };
	    var shouldBlockNewLine$1 = function (editor) {
	      return matchesSelector(editor, getNoNewLineSelector(editor));
	    };
	
	    var newLineAction = Adt.generate([
	      { br: [] },
	      { block: [] },
	      { none: [] }
	    ]);
	    var shouldBlockNewLine = function (editor, _shiftKey) {
	      return shouldBlockNewLine$1(editor);
	    };
	    var isBrMode = function (requiredState) {
	      return function (editor, _shiftKey) {
	        var brMode = getForcedRootBlock(editor) === '';
	        return brMode === requiredState;
	      };
	    };
	    var inListBlock = function (requiredState) {
	      return function (editor, _shiftKey) {
	        return isListItemParentBlock(editor) === requiredState;
	      };
	    };
	    var inBlock = function (blockName, requiredState) {
	      return function (editor, _shiftKey) {
	        var state = getParentBlockName(editor) === blockName.toUpperCase();
	        return state === requiredState;
	      };
	    };
	    var inPreBlock = function (requiredState) {
	      return inBlock('pre', requiredState);
	    };
	    var inSummaryBlock = function () {
	      return inBlock('summary', true);
	    };
	    var shouldPutBrInPre = function (requiredState) {
	      return function (editor, _shiftKey) {
	        return shouldPutBrInPre$1(editor) === requiredState;
	      };
	    };
	    var inBrContext = function (editor, _shiftKey) {
	      return shouldInsertBr(editor);
	    };
	    var hasShiftKey = function (_editor, shiftKey) {
	      return shiftKey;
	    };
	    var canInsertIntoEditableRoot = function (editor) {
	      var forcedRootBlock = getForcedRootBlock(editor);
	      var rootEditable = getEditableRoot$1(editor.dom, editor.selection.getStart());
	      return rootEditable && editor.schema.isValidChild(rootEditable.nodeName, forcedRootBlock ? forcedRootBlock : 'P');
	    };
	    var match = function (predicates, action) {
	      return function (editor, shiftKey) {
	        var isMatch = foldl(predicates, function (res, p) {
	          return res && p(editor, shiftKey);
	        }, true);
	        return isMatch ? Optional.some(action) : Optional.none();
	      };
	    };
	    var getAction = function (editor, evt) {
	      return evaluateUntil([
	        match([shouldBlockNewLine], newLineAction.none()),
	        match([inSummaryBlock()], newLineAction.br()),
	        match([
	          inPreBlock(true),
	          shouldPutBrInPre(false),
	          hasShiftKey
	        ], newLineAction.br()),
	        match([
	          inPreBlock(true),
	          shouldPutBrInPre(false)
	        ], newLineAction.block()),
	        match([
	          inPreBlock(true),
	          shouldPutBrInPre(true),
	          hasShiftKey
	        ], newLineAction.block()),
	        match([
	          inPreBlock(true),
	          shouldPutBrInPre(true)
	        ], newLineAction.br()),
	        match([
	          inListBlock(true),
	          hasShiftKey
	        ], newLineAction.br()),
	        match([inListBlock(true)], newLineAction.block()),
	        match([
	          isBrMode(true),
	          hasShiftKey,
	          canInsertIntoEditableRoot
	        ], newLineAction.block()),
	        match([isBrMode(true)], newLineAction.br()),
	        match([inBrContext], newLineAction.br()),
	        match([
	          isBrMode(false),
	          hasShiftKey
	        ], newLineAction.br()),
	        match([canInsertIntoEditableRoot], newLineAction.block())
	      ], [
	        editor,
	        !!(evt && evt.shiftKey)
	      ]).getOr(newLineAction.none());
	    };
	
	    var insert = function (editor, evt) {
	      getAction(editor, evt).fold(function () {
	        insert$1(editor, evt);
	      }, function () {
	        insert$2(editor, evt);
	      }, noop);
	    };
	
	    var handleEnterKeyEvent = function (editor, event) {
	      if (event.isDefaultPrevented()) {
	        return;
	      }
	      event.preventDefault();
	      endTypingLevelIgnoreLocks(editor.undoManager);
	      editor.undoManager.transact(function () {
	        if (editor.selection.isCollapsed() === false) {
	          editor.execCommand('Delete');
	        }
	        insert(editor, event);
	      });
	    };
	    var setup$9 = function (editor) {
	      editor.on('keydown', function (event) {
	        if (event.keyCode === VK.ENTER) {
	          handleEnterKeyEvent(editor, event);
	        }
	      });
	    };
	
	    var executeKeydownOverride$1 = function (editor, caret, evt) {
	      execute([
	        {
	          keyCode: VK.END,
	          action: action(moveToLineEndPoint$1, editor, true)
	        },
	        {
	          keyCode: VK.HOME,
	          action: action(moveToLineEndPoint$1, editor, false)
	        },
	        {
	          keyCode: VK.END,
	          action: action(moveToLineEndPoint, editor, true)
	        },
	        {
	          keyCode: VK.HOME,
	          action: action(moveToLineEndPoint, editor, false)
	        },
	        {
	          keyCode: VK.END,
	          action: action(moveToLineEndPoint$2, editor, true, caret)
	        },
	        {
	          keyCode: VK.HOME,
	          action: action(moveToLineEndPoint$2, editor, false, caret)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$8 = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$1(editor, caret, evt);
	        }
	      });
	    };
	
	    var browser = detect().browser;
	    var setupIeInput = function (editor) {
	      var keypressThrotter = first(function () {
	        if (!editor.composing) {
	          normalizeNbspsInEditor(editor);
	        }
	      }, 0);
	      if (browser.isIE()) {
	        editor.on('keypress', function (_e) {
	          keypressThrotter.throttle();
	        });
	        editor.on('remove', function (_e) {
	          keypressThrotter.cancel();
	        });
	      }
	    };
	    var setup$7 = function (editor) {
	      setupIeInput(editor);
	      editor.on('input', function (e) {
	        if (e.isComposing === false) {
	          normalizeNbspsInEditor(editor);
	        }
	      });
	    };
	
	    var platform = detect();
	    var executeKeyupAction = function (editor, caret, evt) {
	      execute([
	        {
	          keyCode: VK.PAGE_UP,
	          action: action(moveToLineEndPoint$2, editor, false, caret)
	        },
	        {
	          keyCode: VK.PAGE_DOWN,
	          action: action(moveToLineEndPoint$2, editor, true, caret)
	        }
	      ], evt);
	    };
	    var stopImmediatePropagation = function (e) {
	      return e.stopImmediatePropagation();
	    };
	    var isPageUpDown = function (evt) {
	      return evt.keyCode === VK.PAGE_UP || evt.keyCode === VK.PAGE_DOWN;
	    };
	    var setNodeChangeBlocker = function (blocked, editor, block) {
	      if (block && !blocked.get()) {
	        editor.on('NodeChange', stopImmediatePropagation, true);
	      } else if (!block && blocked.get()) {
	        editor.off('NodeChange', stopImmediatePropagation);
	      }
	      blocked.set(block);
	    };
	    var setup$6 = function (editor, caret) {
	      if (platform.os.isOSX()) {
	        return;
	      }
	      var blocked = Cell(false);
	      editor.on('keydown', function (evt) {
	        if (isPageUpDown(evt)) {
	          setNodeChangeBlocker(blocked, editor, true);
	        }
	      });
	      editor.on('keyup', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeyupAction(editor, caret, evt);
	        }
	        if (isPageUpDown(evt) && blocked.get()) {
	          setNodeChangeBlocker(blocked, editor, false);
	          editor.nodeChanged();
	        }
	      });
	    };
	
	    var insertTextAtPosition = function (text, pos) {
	      var container = pos.container();
	      var offset = pos.offset();
	      if (isText$7(container)) {
	        container.insertData(offset, text);
	        return Optional.some(CaretPosition(container, offset + text.length));
	      } else {
	        return getElementFromPosition(pos).map(function (elm) {
	          var textNode = SugarElement.fromText(text);
	          if (pos.isAtEnd()) {
	            after$3(elm, textNode);
	          } else {
	            before$4(elm, textNode);
	          }
	          return CaretPosition(textNode.dom, text.length);
	        });
	      }
	    };
	    var insertNbspAtPosition = curry(insertTextAtPosition, nbsp);
	    var insertSpaceAtPosition = curry(insertTextAtPosition, ' ');
	
	    var locationToCaretPosition = function (root) {
	      return function (location) {
	        return location.fold(function (element) {
	          return prevPosition(root.dom, CaretPosition.before(element));
	        }, function (element) {
	          return firstPositionIn(element);
	        }, function (element) {
	          return lastPositionIn(element);
	        }, function (element) {
	          return nextPosition(root.dom, CaretPosition.after(element));
	        });
	      };
	    };
	    var insertInlineBoundarySpaceOrNbsp = function (root, pos) {
	      return function (checkPos) {
	        return needsToHaveNbsp(root, checkPos) ? insertNbspAtPosition(pos) : insertSpaceAtPosition(pos);
	      };
	    };
	    var setSelection = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        editor.nodeChanged();
	        return true;
	      };
	    };
	    var insertSpaceOrNbspAtSelection = function (editor) {
	      var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	      var root = SugarElement.fromDom(editor.getBody());
	      if (editor.selection.isCollapsed()) {
	        var isInlineTarget$1 = curry(isInlineTarget, editor);
	        var caretPosition = CaretPosition.fromRangeStart(editor.selection.getRng());
	        return readLocation(isInlineTarget$1, editor.getBody(), caretPosition).bind(locationToCaretPosition(root)).bind(insertInlineBoundarySpaceOrNbsp(root, pos)).exists(setSelection(editor));
	      } else {
	        return false;
	      }
	    };
	
	    var executeKeydownOverride = function (editor, evt) {
	      execute([{
	          keyCode: VK.SPACEBAR,
	          action: action(insertSpaceOrNbspAtSelection, editor)
	        }], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$5 = function (editor) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride(editor, evt);
	        }
	      });
	    };
	
	    var registerKeyboardOverrides = function (editor) {
	      var caret = setupSelectedState(editor);
	      setup$c(editor);
	      setup$b(editor, caret);
	      setup$a(editor, caret);
	      setup$9(editor);
	      setup$5(editor);
	      setup$7(editor);
	      setup$8(editor, caret);
	      setup$6(editor, caret);
	      return caret;
	    };
	    var setup$4 = function (editor) {
	      if (!isRtc(editor)) {
	        return registerKeyboardOverrides(editor);
	      } else {
	        return Cell(null);
	      }
	    };
	
	    var NodeChange = function () {
	      function NodeChange(editor) {
	        this.lastPath = [];
	        this.editor = editor;
	        var lastRng;
	        var self = this;
	        if (!('onselectionchange' in editor.getDoc())) {
	          editor.on('NodeChange click mouseup keyup focus', function (e) {
	            var nativeRng = editor.selection.getRng();
	            var fakeRng = {
	              startContainer: nativeRng.startContainer,
	              startOffset: nativeRng.startOffset,
	              endContainer: nativeRng.endContainer,
	              endOffset: nativeRng.endOffset
	            };
	            if (e.type === 'nodechange' || !isEq$4(fakeRng, lastRng)) {
	              editor.fire('SelectionChange');
	            }
	            lastRng = fakeRng;
	          });
	        }
	        editor.on('contextmenu', function () {
	          editor.fire('SelectionChange');
	        });
	        editor.on('SelectionChange', function () {
	          var startElm = editor.selection.getStart(true);
	          if (!startElm || !Env.range && editor.selection.isCollapsed()) {
	            return;
	          }
	          if (hasAnyRanges(editor) && !self.isSameElementPath(startElm) && editor.dom.isChildOf(startElm, editor.getBody())) {
	            editor.nodeChanged({ selectionChange: true });
	          }
	        });
	        editor.on('mouseup', function (e) {
	          if (!e.isDefaultPrevented() && hasAnyRanges(editor)) {
	            if (editor.selection.getNode().nodeName === 'IMG') {
	              Delay.setEditorTimeout(editor, function () {
	                editor.nodeChanged();
	              });
	            } else {
	              editor.nodeChanged();
	            }
	          }
	        });
	      }
	      NodeChange.prototype.nodeChanged = function (args) {
	        var selection = this.editor.selection;
	        var node, parents, root;
	        if (this.editor.initialized && selection && !shouldDisableNodeChange(this.editor) && !this.editor.mode.isReadOnly()) {
	          root = this.editor.getBody();
	          node = selection.getStart(true) || root;
	          if (node.ownerDocument !== this.editor.getDoc() || !this.editor.dom.isChildOf(node, root)) {
	            node = root;
	          }
	          parents = [];
	          this.editor.dom.getParent(node, function (node) {
	            if (node === root) {
	              return true;
	            }
	            parents.push(node);
	          });
	          args = args || {};
	          args.element = node;
	          args.parents = parents;
	          this.editor.fire('NodeChange', args);
	        }
	      };
	      NodeChange.prototype.isSameElementPath = function (startElm) {
	        var i;
	        var currentPath = this.editor.$(startElm).parentsUntil(this.editor.getBody()).add(startElm);
	        if (currentPath.length === this.lastPath.length) {
	          for (i = currentPath.length; i >= 0; i--) {
	            if (currentPath[i] !== this.lastPath[i]) {
	              break;
	            }
	          }
	          if (i === -1) {
	            this.lastPath = currentPath;
	            return true;
	          }
	        }
	        this.lastPath = currentPath;
	        return false;
	      };
	      return NodeChange;
	    }();
	
	    var preventSummaryToggle = function (editor) {
	      editor.on('click', function (e) {
	        if (editor.dom.getParent(e.target, 'details')) {
	          e.preventDefault();
	        }
	      });
	    };
	    var filterDetails = function (editor) {
	      editor.parser.addNodeFilter('details', function (elms) {
	        each$k(elms, function (details) {
	          details.attr('data-mce-open', details.attr('open'));
	          details.attr('open', 'open');
	        });
	      });
	      editor.serializer.addNodeFilter('details', function (elms) {
	        each$k(elms, function (details) {
	          var open = details.attr('data-mce-open');
	          details.attr('open', isString$1(open) ? open : null);
	          details.attr('data-mce-open', null);
	        });
	      });
	    };
	    var setup$3 = function (editor) {
	      preventSummaryToggle(editor);
	      filterDetails(editor);
	    };
	
	    var isTextBlockNode = function (node) {
	      return isElement$5(node) && isTextBlock$2(SugarElement.fromDom(node));
	    };
	    var normalizeSelection = function (editor) {
	      var rng = editor.selection.getRng();
	      var startPos = CaretPosition.fromRangeStart(rng);
	      var endPos = CaretPosition.fromRangeEnd(rng);
	      if (CaretPosition.isElementPosition(startPos)) {
	        var container = startPos.container();
	        if (isTextBlockNode(container)) {
	          firstPositionIn(container).each(function (pos) {
	            return rng.setStart(pos.container(), pos.offset());
	          });
	        }
	      }
	      if (CaretPosition.isElementPosition(endPos)) {
	        var container = startPos.container();
	        if (isTextBlockNode(container)) {
	          lastPositionIn(container).each(function (pos) {
	            return rng.setEnd(pos.container(), pos.offset());
	          });
	        }
	      }
	      editor.selection.setRng(normalize(rng));
	    };
	    var setup$2 = function (editor) {
	      editor.on('click', function (e) {
	        if (e.detail >= 3) {
	          normalizeSelection(editor);
	        }
	      });
	    };
	
	    var getAbsolutePosition = function (elm) {
	      var clientRect = elm.getBoundingClientRect();
	      var doc = elm.ownerDocument;
	      var docElem = doc.documentElement;
	      var win = doc.defaultView;
	      return {
	        top: clientRect.top + win.pageYOffset - docElem.clientTop,
	        left: clientRect.left + win.pageXOffset - docElem.clientLeft
	      };
	    };
	    var getBodyPosition = function (editor) {
	      return editor.inline ? getAbsolutePosition(editor.getBody()) : {
	        left: 0,
	        top: 0
	      };
	    };
	    var getScrollPosition = function (editor) {
	      var body = editor.getBody();
	      return editor.inline ? {
	        left: body.scrollLeft,
	        top: body.scrollTop
	      } : {
	        left: 0,
	        top: 0
	      };
	    };
	    var getBodyScroll = function (editor) {
	      var body = editor.getBody(), docElm = editor.getDoc().documentElement;
	      var inlineScroll = {
	        left: body.scrollLeft,
	        top: body.scrollTop
	      };
	      var iframeScroll = {
	        left: body.scrollLeft || docElm.scrollLeft,
	        top: body.scrollTop || docElm.scrollTop
	      };
	      return editor.inline ? inlineScroll : iframeScroll;
	    };
	    var getMousePosition = function (editor, event) {
	      if (event.target.ownerDocument !== editor.getDoc()) {
	        var iframePosition = getAbsolutePosition(editor.getContentAreaContainer());
	        var scrollPosition = getBodyScroll(editor);
	        return {
	          left: event.pageX - iframePosition.left + scrollPosition.left,
	          top: event.pageY - iframePosition.top + scrollPosition.top
	        };
	      }
	      return {
	        left: event.pageX,
	        top: event.pageY
	      };
	    };
	    var calculatePosition = function (bodyPosition, scrollPosition, mousePosition) {
	      return {
	        pageX: mousePosition.left - bodyPosition.left + scrollPosition.left,
	        pageY: mousePosition.top - bodyPosition.top + scrollPosition.top
	      };
	    };
	    var calc = function (editor, event) {
	      return calculatePosition(getBodyPosition(editor), getScrollPosition(editor), getMousePosition(editor, event));
	    };
	
	    var isContentEditableFalse$1 = isContentEditableFalse$b, isContentEditableTrue$1 = isContentEditableTrue$4;
	    var isDraggable = function (rootElm, elm) {
	      return isContentEditableFalse$1(elm) && elm !== rootElm;
	    };
	    var isValidDropTarget = function (editor, targetElement, dragElement) {
	      if (targetElement === dragElement || editor.dom.isChildOf(targetElement, dragElement)) {
	        return false;
	      }
	      return !isContentEditableFalse$1(targetElement);
	    };
	    var cloneElement = function (elm) {
	      var cloneElm = elm.cloneNode(true);
	      cloneElm.removeAttribute('data-mce-selected');
	      return cloneElm;
	    };
	    var createGhost = function (editor, elm, width, height) {
	      var dom = editor.dom;
	      var clonedElm = elm.cloneNode(true);
	      dom.setStyles(clonedElm, {
	        width: width,
	        height: height
	      });
	      dom.setAttrib(clonedElm, 'data-mce-selected', null);
	      var ghostElm = dom.create('div', {
	        'class': 'mce-drag-container',
	        'data-mce-bogus': 'all',
	        'unselectable': 'on',
	        'contenteditable': 'false'
	      });
	      dom.setStyles(ghostElm, {
	        position: 'absolute',
	        opacity: 0.5,
	        overflow: 'hidden',
	        border: 0,
	        padding: 0,
	        margin: 0,
	        width: width,
	        height: height
	      });
	      dom.setStyles(clonedElm, {
	        margin: 0,
	        boxSizing: 'border-box'
	      });
	      ghostElm.appendChild(clonedElm);
	      return ghostElm;
	    };
	    var appendGhostToBody = function (ghostElm, bodyElm) {
	      if (ghostElm.parentNode !== bodyElm) {
	        bodyElm.appendChild(ghostElm);
	      }
	    };
	    var moveGhost = function (ghostElm, position, width, height, maxX, maxY) {
	      var overflowX = 0, overflowY = 0;
	      ghostElm.style.left = position.pageX + 'px';
	      ghostElm.style.top = position.pageY + 'px';
	      if (position.pageX + width > maxX) {
	        overflowX = position.pageX + width - maxX;
	      }
	      if (position.pageY + height > maxY) {
	        overflowY = position.pageY + height - maxY;
	      }
	      ghostElm.style.width = width - overflowX + 'px';
	      ghostElm.style.height = height - overflowY + 'px';
	    };
	    var removeElement = function (elm) {
	      if (elm && elm.parentNode) {
	        elm.parentNode.removeChild(elm);
	      }
	    };
	    var isLeftMouseButtonPressed = function (e) {
	      return e.button === 0;
	    };
	    var applyRelPos = function (state, position) {
	      return {
	        pageX: position.pageX - state.relX,
	        pageY: position.pageY + 5
	      };
	    };
	    var start = function (state, editor) {
	      return function (e) {
	        if (isLeftMouseButtonPressed(e)) {
	          var ceElm = find$3(editor.dom.getParents(e.target), or(isContentEditableFalse$1, isContentEditableTrue$1)).getOr(null);
	          if (isDraggable(editor.getBody(), ceElm)) {
	            var elmPos = editor.dom.getPos(ceElm);
	            var bodyElm = editor.getBody();
	            var docElm = editor.getDoc().documentElement;
	            state.set({
	              element: ceElm,
	              dragging: false,
	              screenX: e.screenX,
	              screenY: e.screenY,
	              maxX: (editor.inline ? bodyElm.scrollWidth : docElm.offsetWidth) - 2,
	              maxY: (editor.inline ? bodyElm.scrollHeight : docElm.offsetHeight) - 2,
	              relX: e.pageX - elmPos.x,
	              relY: e.pageY - elmPos.y,
	              width: ceElm.offsetWidth,
	              height: ceElm.offsetHeight,
	              ghost: createGhost(editor, ceElm, ceElm.offsetWidth, ceElm.offsetHeight)
	            });
	          }
	        }
	      };
	    };
	    var move = function (state, editor) {
	      var throttledPlaceCaretAt = Delay.throttle(function (clientX, clientY) {
	        editor._selectionOverrides.hideFakeCaret();
	        editor.selection.placeCaretAt(clientX, clientY);
	      }, 0);
	      editor.on('remove', throttledPlaceCaretAt.stop);
	      return function (e) {
	        return state.on(function (state) {
	          var movement = Math.max(Math.abs(e.screenX - state.screenX), Math.abs(e.screenY - state.screenY));
	          if (!state.dragging && movement > 10) {
	            var args = editor.fire('dragstart', { target: state.element });
	            if (args.isDefaultPrevented()) {
	              return;
	            }
	            state.dragging = true;
	            editor.focus();
	          }
	          if (state.dragging) {
	            var targetPos = applyRelPos(state, calc(editor, e));
	            appendGhostToBody(state.ghost, editor.getBody());
	            moveGhost(state.ghost, targetPos, state.width, state.height, state.maxX, state.maxY);
	            throttledPlaceCaretAt(e.clientX, e.clientY);
	          }
	        });
	      };
	    };
	    var getRawTarget = function (selection) {
	      var rng = selection.getSel().getRangeAt(0);
	      var startContainer = rng.startContainer;
	      return startContainer.nodeType === 3 ? startContainer.parentNode : startContainer;
	    };
	    var drop = function (state, editor) {
	      return function (e) {
	        state.on(function (state) {
	          if (state.dragging) {
	            if (isValidDropTarget(editor, getRawTarget(editor.selection), state.element)) {
	              var targetClone_1 = cloneElement(state.element);
	              var args = editor.fire('drop', {
	                clientX: e.clientX,
	                clientY: e.clientY
	              });
	              if (!args.isDefaultPrevented()) {
	                editor.undoManager.transact(function () {
	                  removeElement(state.element);
	                  editor.insertContent(editor.dom.getOuterHTML(targetClone_1));
	                  editor._selectionOverrides.hideFakeCaret();
	                });
	              }
	            }
	            editor.fire('dragend');
	          }
	        });
	        removeDragState(state);
	      };
	    };
	    var stop = function (state, editor) {
	      return function () {
	        state.on(function (state) {
	          if (state.dragging) {
	            editor.fire('dragend');
	          }
	        });
	        removeDragState(state);
	      };
	    };
	    var removeDragState = function (state) {
	      state.on(function (state) {
	        removeElement(state.ghost);
	      });
	      state.clear();
	    };
	    var bindFakeDragEvents = function (editor) {
	      var state = value();
	      var pageDom = DOMUtils.DOM;
	      var rootDocument = document;
	      var dragStartHandler = start(state, editor);
	      var dragHandler = move(state, editor);
	      var dropHandler = drop(state, editor);
	      var dragEndHandler = stop(state, editor);
	      editor.on('mousedown', dragStartHandler);
	      editor.on('mousemove', dragHandler);
	      editor.on('mouseup', dropHandler);
	      pageDom.bind(rootDocument, 'mousemove', dragHandler);
	      pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
	      editor.on('remove', function () {
	        pageDom.unbind(rootDocument, 'mousemove', dragHandler);
	        pageDom.unbind(rootDocument, 'mouseup', dragEndHandler);
	      });
	      editor.on('keydown', function (e) {
	        if (e.keyCode === VK.ESC) {
	          dragEndHandler();
	        }
	      });
	    };
	    var blockIeDrop = function (editor) {
	      editor.on('drop', function (e) {
	        var realTarget = typeof e.clientX !== 'undefined' ? editor.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
	        if (isContentEditableFalse$1(realTarget) || editor.dom.getContentEditableParent(realTarget) === 'false') {
	          e.preventDefault();
	        }
	      });
	    };
	    var blockUnsupportedFileDrop = function (editor) {
	      var preventFileDrop = function (e) {
	        if (!e.isDefaultPrevented()) {
	          var dataTransfer = e.dataTransfer;
	          if (dataTransfer && (contains$3(dataTransfer.types, 'Files') || dataTransfer.files.length > 0)) {
	            e.preventDefault();
	            if (e.type === 'drop') {
	              displayError(editor, 'Dropped file type is not supported');
	            }
	          }
	        }
	      };
	      var preventFileDropIfUIElement = function (e) {
	        if (isUIElement(editor, e.target)) {
	          preventFileDrop(e);
	        }
	      };
	      var setup = function () {
	        var pageDom = DOMUtils.DOM;
	        var dom = editor.dom;
	        var doc = document;
	        var editorRoot = editor.inline ? editor.getBody() : editor.getDoc();
	        var eventNames = [
	          'drop',
	          'dragover'
	        ];
	        each$k(eventNames, function (name) {
	          pageDom.bind(doc, name, preventFileDropIfUIElement);
	          dom.bind(editorRoot, name, preventFileDrop);
	        });
	        editor.on('remove', function () {
	          each$k(eventNames, function (name) {
	            pageDom.unbind(doc, name, preventFileDropIfUIElement);
	            dom.unbind(editorRoot, name, preventFileDrop);
	          });
	        });
	      };
	      editor.on('init', function () {
	        Delay.setEditorTimeout(editor, setup, 0);
	      });
	    };
	    var init$2 = function (editor) {
	      bindFakeDragEvents(editor);
	      blockIeDrop(editor);
	      if (shouldBlockUnsupportedDrop(editor)) {
	        blockUnsupportedFileDrop(editor);
	      }
	    };
	
	    var setup$1 = function (editor) {
	      var renderFocusCaret = first(function () {
	        if (!editor.removed && editor.getBody().contains(document.activeElement)) {
	          var rng = editor.selection.getRng();
	          if (rng.collapsed) {
	            var caretRange = renderRangeCaret(editor, rng, false);
	            editor.selection.setRng(caretRange);
	          }
	        }
	      }, 0);
	      editor.on('focus', function () {
	        renderFocusCaret.throttle();
	      });
	      editor.on('blur', function () {
	        renderFocusCaret.cancel();
	      });
	    };
	
	    var setup = function (editor) {
	      editor.on('init', function () {
	        editor.on('focusin', function (e) {
	          var target = e.target;
	          if (isMedia$2(target)) {
	            var ceRoot = getContentEditableRoot$1(editor.getBody(), target);
	            var node = isContentEditableFalse$b(ceRoot) ? ceRoot : target;
	            if (editor.selection.getNode() !== node) {
	              selectNode(editor, node).each(function (rng) {
	                return editor.selection.setRng(rng);
	              });
	            }
	          }
	        });
	      });
	    };
	
	    var isContentEditableTrue = isContentEditableTrue$4;
	    var isContentEditableFalse = isContentEditableFalse$b;
	    var getContentEditableRoot = function (editor, node) {
	      return getContentEditableRoot$1(editor.getBody(), node);
	    };
	    var SelectionOverrides = function (editor) {
	      var selection = editor.selection, dom = editor.dom;
	      var isBlock = dom.isBlock;
	      var rootNode = editor.getBody();
	      var fakeCaret = FakeCaret(editor, rootNode, isBlock, function () {
	        return hasFocus(editor);
	      });
	      var realSelectionId = 'sel-' + dom.uniqueId();
	      var elementSelectionAttr = 'data-mce-selected';
	      var selectedElement;
	      var isFakeSelectionElement = function (node) {
	        return dom.hasClass(node, 'mce-offscreen-selection');
	      };
	      var isFakeSelectionTargetElement = function (node) {
	        return node !== rootNode && (isContentEditableFalse(node) || isMedia$2(node)) && dom.isChildOf(node, rootNode);
	      };
	      var isNearFakeSelectionElement = function (pos) {
	        return isBeforeContentEditableFalse(pos) || isAfterContentEditableFalse(pos) || isBeforeMedia(pos) || isAfterMedia(pos);
	      };
	      var getRealSelectionElement = function () {
	        var container = dom.get(realSelectionId);
	        return container ? container.getElementsByTagName('*')[0] : container;
	      };
	      var setRange = function (range) {
	        if (range) {
	          selection.setRng(range);
	        }
	      };
	      var getRange = selection.getRng;
	      var showCaret = function (direction, node, before, scrollIntoView) {
	        if (scrollIntoView === void 0) {
	          scrollIntoView = true;
	        }
	        var e = editor.fire('ShowCaret', {
	          target: node,
	          direction: direction,
	          before: before
	        });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	        if (scrollIntoView) {
	          selection.scrollIntoView(node, direction === -1);
	        }
	        return fakeCaret.show(before, node);
	      };
	      var showBlockCaretContainer = function (blockCaretContainer) {
	        if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	          showCaretContainerBlock(blockCaretContainer);
	          setRange(getRange());
	          selection.scrollIntoView(blockCaretContainer);
	        }
	      };
	      var registerEvents = function () {
	        editor.on('mouseup', function (e) {
	          var range = getRange();
	          if (range.collapsed && isXYInContentArea(editor, e.clientX, e.clientY)) {
	            renderCaretAtRange(editor, range, false).each(setRange);
	          }
	        });
	        editor.on('click', function (e) {
	          var contentEditableRoot = getContentEditableRoot(editor, e.target);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse(contentEditableRoot)) {
	              e.preventDefault();
	              editor.focus();
	            }
	            if (isContentEditableTrue(contentEditableRoot)) {
	              if (dom.isChildOf(contentEditableRoot, selection.getNode())) {
	                removeElementSelection();
	              }
	            }
	          }
	        });
	        editor.on('blur NewBlock', removeElementSelection);
	        editor.on('ResizeWindow FullscreenStateChanged', fakeCaret.reposition);
	        var hasNormalCaretPosition = function (elm) {
	          var start = elm.firstChild;
	          if (isNullable(start)) {
	            return false;
	          }
	          var startPos = CaretPosition.before(start);
	          if (isBr$5(startPos.getNode()) && elm.childNodes.length === 1) {
	            return !isNearFakeSelectionElement(startPos);
	          } else {
	            var caretWalker = CaretWalker(elm);
	            var newPos = caretWalker.next(startPos);
	            return newPos && !isNearFakeSelectionElement(newPos);
	          }
	        };
	        var isInSameBlock = function (node1, node2) {
	          var block1 = dom.getParent(node1, isBlock);
	          var block2 = dom.getParent(node2, isBlock);
	          return block1 === block2;
	        };
	        var hasBetterMouseTarget = function (targetNode, caretNode) {
	          var targetBlock = dom.getParent(targetNode, isBlock);
	          var caretBlock = dom.getParent(caretNode, isBlock);
	          if (isNullable(targetBlock)) {
	            return false;
	          }
	          if (targetNode !== caretBlock && dom.isChildOf(targetBlock, caretBlock) && isContentEditableFalse(getContentEditableRoot(editor, targetBlock)) === false) {
	            return true;
	          }
	          return !dom.isChildOf(caretBlock, targetBlock) && !isInSameBlock(targetBlock, caretBlock) && hasNormalCaretPosition(targetBlock);
	        };
	        editor.on('tap', function (e) {
	          var targetElm = e.target;
	          var contentEditableRoot = getContentEditableRoot(editor, targetElm);
	          if (isContentEditableFalse(contentEditableRoot)) {
	            e.preventDefault();
	            selectNode(editor, contentEditableRoot).each(setElementSelection);
	          } else if (isFakeSelectionTargetElement(targetElm)) {
	            selectNode(editor, targetElm).each(setElementSelection);
	          }
	        }, true);
	        editor.on('mousedown', function (e) {
	          var targetElm = e.target;
	          if (targetElm !== rootNode && targetElm.nodeName !== 'HTML' && !dom.isChildOf(targetElm, rootNode)) {
	            return;
	          }
	          if (isXYInContentArea(editor, e.clientX, e.clientY) === false) {
	            return;
	          }
	          var contentEditableRoot = getContentEditableRoot(editor, targetElm);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse(contentEditableRoot)) {
	              e.preventDefault();
	              selectNode(editor, contentEditableRoot).each(setElementSelection);
	            } else {
	              removeElementSelection();
	              if (!(isContentEditableTrue(contentEditableRoot) && e.shiftKey) && !isXYWithinRange(e.clientX, e.clientY, selection.getRng())) {
	                hideFakeCaret();
	                selection.placeCaretAt(e.clientX, e.clientY);
	              }
	            }
	          } else if (isFakeSelectionTargetElement(targetElm)) {
	            selectNode(editor, targetElm).each(setElementSelection);
	          } else if (isFakeCaretTarget(targetElm) === false) {
	            removeElementSelection();
	            hideFakeCaret();
	            var fakeCaretInfo = closestFakeCaret(rootNode, e.clientX, e.clientY);
	            if (fakeCaretInfo) {
	              if (!hasBetterMouseTarget(targetElm, fakeCaretInfo.node)) {
	                e.preventDefault();
	                var range = showCaret(1, fakeCaretInfo.node, fakeCaretInfo.before, false);
	                setRange(range);
	                editor.getBody().focus();
	              }
	            }
	          }
	        });
	        editor.on('keypress', function (e) {
	          if (VK.modifierPressed(e)) {
	            return;
	          }
	          if (isContentEditableFalse(selection.getNode())) {
	            e.preventDefault();
	          }
	        });
	        editor.on('GetSelectionRange', function (e) {
	          var rng = e.range;
	          if (selectedElement) {
	            if (!selectedElement.parentNode) {
	              selectedElement = null;
	              return;
	            }
	            rng = rng.cloneRange();
	            rng.selectNode(selectedElement);
	            e.range = rng;
	          }
	        });
	        editor.on('SetSelectionRange', function (e) {
	          e.range = normalizeShortEndedElementSelection(e.range);
	          var rng = setElementSelection(e.range, e.forward);
	          if (rng) {
	            e.range = rng;
	          }
	        });
	        var isPasteBin = function (node) {
	          return node.id === 'mcepastebin';
	        };
	        editor.on('AfterSetSelectionRange', function (e) {
	          var rng = e.range;
	          var parentNode = rng.startContainer.parentNode;
	          if (!isRangeInCaretContainer(rng) && !isPasteBin(parentNode)) {
	            hideFakeCaret();
	          }
	          if (!isFakeSelectionElement(parentNode)) {
	            removeElementSelection();
	          }
	        });
	        editor.on('copy', function (e) {
	          var clipboardData = e.clipboardData;
	          if (!e.isDefaultPrevented() && e.clipboardData && !Env.ie) {
	            var realSelectionElement = getRealSelectionElement();
	            if (realSelectionElement) {
	              e.preventDefault();
	              clipboardData.clearData();
	              clipboardData.setData('text/html', realSelectionElement.outerHTML);
	              clipboardData.setData('text/plain', realSelectionElement.outerText || realSelectionElement.innerText);
	            }
	          }
	        });
	        init$2(editor);
	        setup$1(editor);
	        setup(editor);
	      };
	      var isWithinCaretContainer = function (node) {
	        return isCaretContainer$2(node) || startsWithCaretContainer$1(node) || endsWithCaretContainer$1(node);
	      };
	      var isRangeInCaretContainer = function (rng) {
	        return isWithinCaretContainer(rng.startContainer) || isWithinCaretContainer(rng.endContainer);
	      };
	      var normalizeShortEndedElementSelection = function (rng) {
	        var shortEndedElements = editor.schema.getShortEndedElements();
	        var newRng = dom.createRng();
	        var startContainer = rng.startContainer;
	        var startOffset = rng.startOffset;
	        var endContainer = rng.endContainer;
	        var endOffset = rng.endOffset;
	        if (has$2(shortEndedElements, startContainer.nodeName.toLowerCase())) {
	          if (startOffset === 0) {
	            newRng.setStartBefore(startContainer);
	          } else {
	            newRng.setStartAfter(startContainer);
	          }
	        } else {
	          newRng.setStart(startContainer, startOffset);
	        }
	        if (has$2(shortEndedElements, endContainer.nodeName.toLowerCase())) {
	          if (endOffset === 0) {
	            newRng.setEndBefore(endContainer);
	          } else {
	            newRng.setEndAfter(endContainer);
	          }
	        } else {
	          newRng.setEnd(endContainer, endOffset);
	        }
	        return newRng;
	      };
	      var setupOffscreenSelection = function (node, targetClone, origTargetClone) {
	        var $ = editor.$;
	        var $realSelectionContainer = descendant(SugarElement.fromDom(editor.getBody()), '#' + realSelectionId).fold(function () {
	          return $([]);
	        }, function (elm) {
	          return $([elm.dom]);
	        });
	        if ($realSelectionContainer.length === 0) {
	          $realSelectionContainer = $('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr('id', realSelectionId);
	          $realSelectionContainer.appendTo(editor.getBody());
	        }
	        var newRange = dom.createRng();
	        if (targetClone === origTargetClone && Env.ie) {
	          $realSelectionContainer.empty().append('<p style="font-size: 0" data-mce-bogus="all">\xA0</p>').append(targetClone);
	          newRange.setStartAfter($realSelectionContainer[0].firstChild.firstChild);
	          newRange.setEndAfter(targetClone);
	        } else {
	          $realSelectionContainer.empty().append(nbsp).append(targetClone).append(nbsp);
	          newRange.setStart($realSelectionContainer[0].firstChild, 1);
	          newRange.setEnd($realSelectionContainer[0].lastChild, 0);
	        }
	        $realSelectionContainer.css({ top: dom.getPos(node, editor.getBody()).y });
	        $realSelectionContainer[0].focus();
	        var sel = selection.getSel();
	        sel.removeAllRanges();
	        sel.addRange(newRange);
	        return newRange;
	      };
	      var selectElement = function (elm) {
	        var targetClone = elm.cloneNode(true);
	        var e = editor.fire('ObjectSelected', {
	          target: elm,
	          targetClone: targetClone
	        });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	        var range = setupOffscreenSelection(elm, e.targetClone, targetClone);
	        var nodeElm = SugarElement.fromDom(elm);
	        each$k(descendants(SugarElement.fromDom(editor.getBody()), '*[data-mce-selected]'), function (elm) {
	          if (!eq(nodeElm, elm)) {
	            remove$6(elm, elementSelectionAttr);
	          }
	        });
	        if (!dom.getAttrib(elm, elementSelectionAttr)) {
	          elm.setAttribute(elementSelectionAttr, '1');
	        }
	        selectedElement = elm;
	        hideFakeCaret();
	        return range;
	      };
	      var setElementSelection = function (range, forward) {
	        if (!range) {
	          return null;
	        }
	        if (range.collapsed) {
	          if (!isRangeInCaretContainer(range)) {
	            var dir = forward ? 1 : -1;
	            var caretPosition = getNormalizedRangeEndPoint(dir, rootNode, range);
	            var beforeNode = caretPosition.getNode(!forward);
	            if (isFakeCaretTarget(beforeNode)) {
	              return showCaret(dir, beforeNode, forward ? !caretPosition.isAtEnd() : false, false);
	            }
	            var afterNode = caretPosition.getNode(forward);
	            if (isFakeCaretTarget(afterNode)) {
	              return showCaret(dir, afterNode, forward ? false : !caretPosition.isAtEnd(), false);
	            }
	          }
	          return null;
	        }
	        var startContainer = range.startContainer;
	        var startOffset = range.startOffset;
	        var endOffset = range.endOffset;
	        if (startContainer.nodeType === 3 && startOffset === 0 && isContentEditableFalse(startContainer.parentNode)) {
	          startContainer = startContainer.parentNode;
	          startOffset = dom.nodeIndex(startContainer);
	          startContainer = startContainer.parentNode;
	        }
	        if (startContainer.nodeType !== 1) {
	          return null;
	        }
	        if (endOffset === startOffset + 1 && startContainer === range.endContainer) {
	          var node = startContainer.childNodes[startOffset];
	          if (isFakeSelectionTargetElement(node)) {
	            return selectElement(node);
	          }
	        }
	        return null;
	      };
	      var removeElementSelection = function () {
	        if (selectedElement) {
	          selectedElement.removeAttribute(elementSelectionAttr);
	        }
	        descendant(SugarElement.fromDom(editor.getBody()), '#' + realSelectionId).each(remove$7);
	        selectedElement = null;
	      };
	      var destroy = function () {
	        fakeCaret.destroy();
	        selectedElement = null;
	      };
	      var hideFakeCaret = function () {
	        fakeCaret.hide();
	      };
	      if (Env.ceFalse && !isRtc(editor)) {
	        registerEvents();
	      }
	      return {
	        showCaret: showCaret,
	        showBlockCaretContainer: showBlockCaretContainer,
	        hideFakeCaret: hideFakeCaret,
	        destroy: destroy
	      };
	    };
	
	    var Quirks = function (editor) {
	      var each = Tools.each;
	      var BACKSPACE = VK.BACKSPACE, DELETE = VK.DELETE, dom = editor.dom, selection = editor.selection, parser = editor.parser;
	      var isGecko = Env.gecko, isIE = Env.ie, isWebKit = Env.webkit;
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      var mceInternalDataType = isIE ? 'Text' : 'URL';
	      var setEditorCommandState = function (cmd, state) {
	        try {
	          editor.getDoc().execCommand(cmd, false, state);
	        } catch (ex) {
	        }
	      };
	      var isDefaultPrevented = function (e) {
	        return e.isDefaultPrevented();
	      };
	      var setMceInternalContent = function (e) {
	        var selectionHtml, internalContent;
	        if (e.dataTransfer) {
	          if (editor.selection.isCollapsed() && e.target.tagName === 'IMG') {
	            selection.select(e.target);
	          }
	          selectionHtml = editor.selection.getContent();
	          if (selectionHtml.length > 0) {
	            internalContent = mceInternalUrlPrefix + escape(editor.id) + ',' + escape(selectionHtml);
	            e.dataTransfer.setData(mceInternalDataType, internalContent);
	          }
	        }
	      };
	      var getMceInternalContent = function (e) {
	        var internalContent;
	        if (e.dataTransfer) {
	          internalContent = e.dataTransfer.getData(mceInternalDataType);
	          if (internalContent && internalContent.indexOf(mceInternalUrlPrefix) >= 0) {
	            internalContent = internalContent.substr(mceInternalUrlPrefix.length).split(',');
	            return {
	              id: unescape(internalContent[0]),
	              html: unescape(internalContent[1])
	            };
	          }
	        }
	        return null;
	      };
	      var insertClipboardContents = function (content, internal) {
	        if (editor.queryCommandSupported('mceInsertClipboardContent')) {
	          editor.execCommand('mceInsertClipboardContent', false, {
	            content: content,
	            internal: internal
	          });
	        } else {
	          editor.execCommand('mceInsertContent', false, content);
	        }
	      };
	      var emptyEditorWhenDeleting = function () {
	        var serializeRng = function (rng) {
	          var body = dom.create('body');
	          var contents = rng.cloneContents();
	          body.appendChild(contents);
	          return selection.serializer.serialize(body, { format: 'html' });
	        };
	        var allContentsSelected = function (rng) {
	          var selection = serializeRng(rng);
	          var allRng = dom.createRng();
	          allRng.selectNode(editor.getBody());
	          var allSelection = serializeRng(allRng);
	          return selection === allSelection;
	        };
	        editor.on('keydown', function (e) {
	          var keyCode = e.keyCode;
	          var isCollapsed, body;
	          if (!isDefaultPrevented(e) && (keyCode === DELETE || keyCode === BACKSPACE)) {
	            isCollapsed = editor.selection.isCollapsed();
	            body = editor.getBody();
	            if (isCollapsed && !dom.isEmpty(body)) {
	              return;
	            }
	            if (!isCollapsed && !allContentsSelected(editor.selection.getRng())) {
	              return;
	            }
	            e.preventDefault();
	            editor.setContent('');
	            if (body.firstChild && dom.isBlock(body.firstChild)) {
	              editor.selection.setCursorLocation(body.firstChild, 0);
	            } else {
	              editor.selection.setCursorLocation(body, 0);
	            }
	            editor.nodeChanged();
	          }
	        });
	      };
	      var selectAll = function () {
	        editor.shortcuts.add('meta+a', null, 'SelectAll');
	      };
	      var documentElementEditingFocus = function () {
	        if (!editor.inline) {
	          dom.bind(editor.getDoc(), 'mousedown mouseup', function (e) {
	            var rng;
	            if (e.target === editor.getDoc().documentElement) {
	              rng = selection.getRng();
	              editor.getBody().focus();
	              if (e.type === 'mousedown') {
	                if (isCaretContainer$2(rng.startContainer)) {
	                  return;
	                }
	                selection.placeCaretAt(e.clientX, e.clientY);
	              } else {
	                selection.setRng(rng);
	              }
	            }
	          });
	        }
	      };
	      var removeHrOnBackspace = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (!editor.getBody().getElementsByTagName('hr').length) {
	              return;
	            }
	            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
	              var node = selection.getNode();
	              var previousSibling = node.previousSibling;
	              if (node.nodeName === 'HR') {
	                dom.remove(node);
	                e.preventDefault();
	                return;
	              }
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'hr') {
	                dom.remove(previousSibling);
	                e.preventDefault();
	              }
	            }
	          }
	        });
	      };
	      var focusBody = function () {
	        if (!Range.prototype.getClientRects) {
	          editor.on('mousedown', function (e) {
	            if (!isDefaultPrevented(e) && e.target.nodeName === 'HTML') {
	              var body_1 = editor.getBody();
	              body_1.blur();
	              Delay.setEditorTimeout(editor, function () {
	                body_1.focus();
	              });
	            }
	          });
	        }
	      };
	      var selectControlElements = function () {
	        editor.on('click', function (e) {
	          var target = e.target;
	          if (/^(IMG|HR)$/.test(target.nodeName) && dom.getContentEditableParent(target) !== 'false') {
	            e.preventDefault();
	            editor.selection.select(target);
	            editor.nodeChanged();
	          }
	          if (target.nodeName === 'A' && dom.hasClass(target, 'mce-item-anchor')) {
	            e.preventDefault();
	            selection.select(target);
	          }
	        });
	      };
	      var removeStylesWhenDeletingAcrossBlockElements = function () {
	        var getAttributeApplyFunction = function () {
	          var template = dom.getAttribs(selection.getStart().cloneNode(false));
	          return function () {
	            var target = selection.getStart();
	            if (target !== editor.getBody()) {
	              dom.setAttrib(target, 'style', null);
	              each(template, function (attr) {
	                target.setAttributeNode(attr.cloneNode(true));
	              });
	            }
	          };
	        };
	        var isSelectionAcrossElements = function () {
	          return !selection.isCollapsed() && dom.getParent(selection.getStart(), dom.isBlock) !== dom.getParent(selection.getEnd(), dom.isBlock);
	        };
	        editor.on('keypress', function (e) {
	          var applyAttributes;
	          if (!isDefaultPrevented(e) && (e.keyCode === 8 || e.keyCode === 46) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            editor.getDoc().execCommand('delete', false, null);
	            applyAttributes();
	            e.preventDefault();
	            return false;
	          }
	        });
	        dom.bind(editor.getDoc(), 'cut', function (e) {
	          var applyAttributes;
	          if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            Delay.setEditorTimeout(editor, function () {
	              applyAttributes();
	            });
	          }
	        });
	      };
	      var disableBackspaceIntoATable = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
	              var previousSibling = selection.getNode().previousSibling;
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'table') {
	                e.preventDefault();
	                return false;
	              }
	            }
	          }
	        });
	      };
	      var removeBlockQuoteOnBackSpace = function () {
	        editor.on('keydown', function (e) {
	          var rng, parent;
	          if (isDefaultPrevented(e) || e.keyCode !== VK.BACKSPACE) {
	            return;
	          }
	          rng = selection.getRng();
	          var container = rng.startContainer;
	          var offset = rng.startOffset;
	          var root = dom.getRoot();
	          parent = container;
	          if (!rng.collapsed || offset !== 0) {
	            return;
	          }
	          while (parent && parent.parentNode && parent.parentNode.firstChild === parent && parent.parentNode !== root) {
	            parent = parent.parentNode;
	          }
	          if (parent.tagName === 'BLOCKQUOTE') {
	            editor.formatter.toggle('blockquote', null, parent);
	            rng = dom.createRng();
	            rng.setStart(container, 0);
	            rng.setEnd(container, 0);
	            selection.setRng(rng);
	          }
	        });
	      };
	      var setGeckoEditingOptions = function () {
	        var setOpts = function () {
	          setEditorCommandState('StyleWithCSS', false);
	          setEditorCommandState('enableInlineTableEditing', false);
	          if (!getObjectResizing(editor)) {
	            setEditorCommandState('enableObjectResizing', false);
	          }
	        };
	        if (!isReadOnly$1(editor)) {
	          editor.on('BeforeExecCommand mousedown', setOpts);
	        }
	      };
	      var addBrAfterLastLinks = function () {
	        var fixLinks = function () {
	          each(dom.select('a'), function (node) {
	            var parentNode = node.parentNode;
	            var root = dom.getRoot();
	            if (parentNode.lastChild === node) {
	              while (parentNode && !dom.isBlock(parentNode)) {
	                if (parentNode.parentNode.lastChild !== parentNode || parentNode === root) {
	                  return;
	                }
	                parentNode = parentNode.parentNode;
	              }
	              dom.add(parentNode, 'br', { 'data-mce-bogus': 1 });
	            }
	          });
	        };
	        editor.on('SetContent ExecCommand', function (e) {
	          if (e.type === 'setcontent' || e.command === 'mceInsertLink') {
	            fixLinks();
	          }
	        });
	      };
	      var setDefaultBlockType = function () {
	        if (getForcedRootBlock(editor)) {
	          editor.on('init', function () {
	            setEditorCommandState('DefaultParagraphSeparator', getForcedRootBlock(editor));
	          });
	        }
	      };
	      var normalizeSelection = function () {
	        editor.on('keyup focusin mouseup', function (e) {
	          if (!VK.modifierPressed(e)) {
	            selection.normalize();
	          }
	        }, true);
	      };
	      var showBrokenImageIcon = function () {
	        editor.contentStyles.push('img:-moz-broken {' + '-moz-force-broken-image-icon:1;' + 'min-width:24px;' + 'min-height:24px' + '}');
	      };
	      var restoreFocusOnKeyDown = function () {
	        if (!editor.inline) {
	          editor.on('keydown', function () {
	            if (document.activeElement === document.body) {
	              editor.getWin().focus();
	            }
	          });
	        }
	      };
	      var bodyHeight = function () {
	        if (!editor.inline) {
	          editor.contentStyles.push('body {min-height: 150px}');
	          editor.on('click', function (e) {
	            var rng;
	            if (e.target.nodeName === 'HTML') {
	              if (Env.ie > 11) {
	                editor.getBody().focus();
	                return;
	              }
	              rng = editor.selection.getRng();
	              editor.getBody().focus();
	              editor.selection.setRng(rng);
	              editor.selection.normalize();
	              editor.nodeChanged();
	            }
	          });
	        }
	      };
	      var blockCmdArrowNavigation = function () {
	        if (Env.mac) {
	          editor.on('keydown', function (e) {
	            if (VK.metaKeyPressed(e) && !e.shiftKey && (e.keyCode === 37 || e.keyCode === 39)) {
	              e.preventDefault();
	              var selection_1 = editor.selection.getSel();
	              selection_1.modify('move', e.keyCode === 37 ? 'backward' : 'forward', 'lineboundary');
	            }
	          });
	        }
	      };
	      var disableAutoUrlDetect = function () {
	        setEditorCommandState('AutoUrlDetect', false);
	      };
	      var tapLinksAndImages = function () {
	        editor.on('click', function (e) {
	          var elm = e.target;
	          do {
	            if (elm.tagName === 'A') {
	              e.preventDefault();
	              return;
	            }
	          } while (elm = elm.parentNode);
	        });
	        editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');
	      };
	      var blockFormSubmitInsideEditor = function () {
	        editor.on('init', function () {
	          editor.dom.bind(editor.getBody(), 'submit', function (e) {
	            e.preventDefault();
	          });
	        });
	      };
	      var removeAppleInterchangeBrs = function () {
	        parser.addNodeFilter('br', function (nodes) {
	          var i = nodes.length;
	          while (i--) {
	            if (nodes[i].attr('class') === 'Apple-interchange-newline') {
	              nodes[i].remove();
	            }
	          }
	        });
	      };
	      var ieInternalDragAndDrop = function () {
	        editor.on('dragstart', function (e) {
	          setMceInternalContent(e);
	        });
	        editor.on('drop', function (e) {
	          if (!isDefaultPrevented(e)) {
	            var internalContent = getMceInternalContent(e);
	            if (internalContent && internalContent.id !== editor.id) {
	              e.preventDefault();
	              var rng = fromPoint(e.x, e.y, editor.getDoc());
	              selection.setRng(rng);
	              insertClipboardContents(internalContent.html, true);
	            }
	          }
	        });
	      };
	      var refreshContentEditable = noop;
	      var isHidden = function () {
	        if (!isGecko || editor.removed) {
	          return false;
	        }
	        var sel = editor.selection.getSel();
	        return !sel || !sel.rangeCount || sel.rangeCount === 0;
	      };
	      var setupRtc = function () {
	        if (isWebKit) {
	          documentElementEditingFocus();
	          selectControlElements();
	          blockFormSubmitInsideEditor();
	          selectAll();
	          if (Env.iOS) {
	            restoreFocusOnKeyDown();
	            bodyHeight();
	            tapLinksAndImages();
	          }
	        }
	        if (isGecko) {
	          focusBody();
	          setGeckoEditingOptions();
	          showBrokenImageIcon();
	          blockCmdArrowNavigation();
	        }
	      };
	      var setup = function () {
	        removeBlockQuoteOnBackSpace();
	        emptyEditorWhenDeleting();
	        if (!Env.windowsPhone) {
	          normalizeSelection();
	        }
	        if (isWebKit) {
	          documentElementEditingFocus();
	          selectControlElements();
	          setDefaultBlockType();
	          blockFormSubmitInsideEditor();
	          disableBackspaceIntoATable();
	          removeAppleInterchangeBrs();
	          if (Env.iOS) {
	            restoreFocusOnKeyDown();
	            bodyHeight();
	            tapLinksAndImages();
	          } else {
	            selectAll();
	          }
	        }
	        if (Env.ie >= 11) {
	          bodyHeight();
	          disableBackspaceIntoATable();
	        }
	        if (Env.ie) {
	          selectAll();
	          disableAutoUrlDetect();
	          ieInternalDragAndDrop();
	        }
	        if (isGecko) {
	          removeHrOnBackspace();
	          focusBody();
	          removeStylesWhenDeletingAcrossBlockElements();
	          setGeckoEditingOptions();
	          addBrAfterLastLinks();
	          showBrokenImageIcon();
	          blockCmdArrowNavigation();
	          disableBackspaceIntoATable();
	        }
	      };
	      if (isRtc(editor)) {
	        setupRtc();
	      } else {
	        setup();
	      }
	      return {
	        refreshContentEditable: refreshContentEditable,
	        isHidden: isHidden
	      };
	    };
	
	    var DOM$6 = DOMUtils.DOM;
	    var appendStyle = function (editor, text) {
	      var body = SugarElement.fromDom(editor.getBody());
	      var container = getStyleContainer(getRootNode(body));
	      var style = SugarElement.fromTag('style');
	      set$1(style, 'type', 'text/css');
	      append$1(style, SugarElement.fromText(text));
	      append$1(container, style);
	      editor.on('remove', function () {
	        remove$7(style);
	      });
	    };
	    var getRootName = function (editor) {
	      return editor.inline ? editor.getElement().nodeName.toLowerCase() : undefined;
	    };
	    var removeUndefined = function (obj) {
	      return filter$3(obj, function (v) {
	        return isUndefined(v) === false;
	      });
	    };
	    var mkSchemaSettings = function (editor) {
	      var settings = editor.settings;
	      return removeUndefined({
	        block_elements: settings.block_elements,
	        boolean_attributes: settings.boolean_attributes,
	        custom_elements: settings.custom_elements,
	        extended_valid_elements: settings.extended_valid_elements,
	        invalid_elements: settings.invalid_elements,
	        invalid_styles: settings.invalid_styles,
	        move_caret_before_on_enter_elements: settings.move_caret_before_on_enter_elements,
	        non_empty_elements: settings.non_empty_elements,
	        schema: settings.schema,
	        self_closing_elements: settings.self_closing_elements,
	        short_ended_elements: settings.short_ended_elements,
	        special: settings.special,
	        text_block_elements: settings.text_block_elements,
	        text_inline_elements: settings.text_inline_elements,
	        valid_children: settings.valid_children,
	        valid_classes: settings.valid_classes,
	        valid_elements: settings.valid_elements,
	        valid_styles: settings.valid_styles,
	        verify_html: settings.verify_html,
	        whitespace_elements: settings.whitespace_elements,
	        padd_empty_block_inline_children: settings.format_empty_lines
	      });
	    };
	    var mkParserSettings = function (editor) {
	      var settings = editor.settings;
	      var blobCache = editor.editorUpload.blobCache;
	      return removeUndefined({
	        allow_conditional_comments: settings.allow_conditional_comments,
	        allow_html_data_urls: settings.allow_html_data_urls,
	        allow_svg_data_urls: settings.allow_svg_data_urls,
	        allow_html_in_named_anchor: settings.allow_html_in_named_anchor,
	        allow_script_urls: settings.allow_script_urls,
	        allow_unsafe_link_target: settings.allow_unsafe_link_target,
	        convert_fonts_to_spans: settings.convert_fonts_to_spans,
	        fix_list_elements: settings.fix_list_elements,
	        font_size_legacy_values: settings.font_size_legacy_values,
	        forced_root_block: settings.forced_root_block,
	        forced_root_block_attrs: settings.forced_root_block_attrs,
	        padd_empty_with_br: settings.padd_empty_with_br,
	        preserve_cdata: settings.preserve_cdata,
	        remove_trailing_brs: settings.remove_trailing_brs,
	        inline_styles: settings.inline_styles,
	        root_name: getRootName(editor),
	        validate: true,
	        blob_cache: blobCache,
	        document: editor.getDoc(),
	        images_dataimg_filter: settings.images_dataimg_filter
	      });
	    };
	    var mkSerializerSettings = function (editor) {
	      var settings = editor.settings;
	      return __assign(__assign(__assign({}, mkParserSettings(editor)), mkSchemaSettings(editor)), removeUndefined({
	        url_converter: settings.url_converter,
	        url_converter_scope: settings.url_converter_scope,
	        element_format: settings.element_format,
	        entities: settings.entities,
	        entity_encoding: settings.entity_encoding,
	        indent: settings.indent,
	        indent_after: settings.indent_after,
	        indent_before: settings.indent_before
	      }));
	    };
	    var createParser = function (editor) {
	      var parser = DomParser(mkParserSettings(editor), editor.schema);
	      parser.addAttributeFilter('src,href,style,tabindex', function (nodes, name) {
	        var i = nodes.length, node, value;
	        var dom = editor.dom;
	        var internalName = 'data-mce-' + name;
	        while (i--) {
	          node = nodes[i];
	          value = node.attr(name);
	          if (value && !node.attr(internalName)) {
	            if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
	              continue;
	            }
	            if (name === 'style') {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	              if (!value.length) {
	                value = null;
	              }
	              node.attr(internalName, value);
	              node.attr(name, value);
	            } else if (name === 'tabindex') {
	              node.attr(internalName, value);
	              node.attr(name, null);
	            } else {
	              node.attr(internalName, editor.convertURL(value, name, node.name));
	            }
	          }
	        }
	      });
	      parser.addNodeFilter('script', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          var type = node.attr('type') || 'no/type';
	          if (type.indexOf('mce-') !== 0) {
	            node.attr('type', 'mce-' + type);
	          }
	        }
	      });
	      if (editor.settings.preserve_cdata) {
	        parser.addNodeFilter('#cdata', function (nodes) {
	          var i = nodes.length;
	          while (i--) {
	            var node = nodes[i];
	            node.type = 8;
	            node.name = '#comment';
	            node.value = '[CDATA[' + editor.dom.encode(node.value) + ']]';
	          }
	        });
	      }
	      parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function (nodes) {
	        var i = nodes.length;
	        var nonEmptyElements = editor.schema.getNonEmptyElements();
	        while (i--) {
	          var node = nodes[i];
	          if (node.isEmpty(nonEmptyElements) && node.getAll('br').length === 0) {
	            node.append(new AstNode('br', 1)).shortEnded = true;
	          }
	        }
	      });
	      return parser;
	    };
	    var autoFocus = function (editor) {
	      if (editor.settings.auto_focus) {
	        Delay.setEditorTimeout(editor, function () {
	          var focusEditor;
	          if (editor.settings.auto_focus === true) {
	            focusEditor = editor;
	          } else {
	            focusEditor = editor.editorManager.get(editor.settings.auto_focus);
	          }
	          if (!focusEditor.destroyed) {
	            focusEditor.focus();
	          }
	        }, 100);
	      }
	    };
	    var moveSelectionToFirstCaretPosition = function (editor) {
	      var root = editor.dom.getRoot();
	      if (!editor.inline && (!hasAnyRanges(editor) || editor.selection.getStart(true) === root)) {
	        firstPositionIn(root).each(function (pos) {
	          var node = pos.getNode();
	          var caretPos = isTable$3(node) ? firstPositionIn(node).getOr(pos) : pos;
	          if (Env.browser.isIE()) {
	            storeNative(editor, caretPos.toRange());
	          } else {
	            editor.selection.setRng(caretPos.toRange());
	          }
	        });
	      }
	    };
	    var initEditor = function (editor) {
	      editor.bindPendingEventDelegates();
	      editor.initialized = true;
	      fireInit(editor);
	      editor.focus(true);
	      moveSelectionToFirstCaretPosition(editor);
	      editor.nodeChanged({ initial: true });
	      editor.execCallback('init_instance_callback', editor);
	      autoFocus(editor);
	    };
	    var getStyleSheetLoader$1 = function (editor) {
	      return editor.inline ? editor.ui.styleSheetLoader : editor.dom.styleSheetLoader;
	    };
	    var makeStylesheetLoadingPromises = function (editor, css, framedFonts) {
	      var promises = [new promiseObj(function (resolve, reject) {
	          return getStyleSheetLoader$1(editor).loadAll(css, resolve, reject);
	        })];
	      if (editor.inline) {
	        return promises;
	      } else {
	        return promises.concat([new promiseObj(function (resolve, reject) {
	            return editor.ui.styleSheetLoader.loadAll(framedFonts, resolve, reject);
	          })]);
	      }
	    };
	    var loadContentCss = function (editor) {
	      var styleSheetLoader = getStyleSheetLoader$1(editor);
	      var fontCss = getFontCss(editor);
	      var css = editor.contentCSS;
	      var removeCss = function () {
	        styleSheetLoader.unloadAll(css);
	        if (!editor.inline) {
	          editor.ui.styleSheetLoader.unloadAll(fontCss);
	        }
	      };
	      var loaded = function () {
	        if (editor.removed) {
	          removeCss();
	        } else {
	          editor.on('remove', removeCss);
	        }
	      };
	      if (editor.contentStyles.length > 0) {
	        var contentCssText_1 = '';
	        Tools.each(editor.contentStyles, function (style) {
	          contentCssText_1 += style + '\r\n';
	        });
	        editor.dom.addStyle(contentCssText_1);
	      }
	      var allStylesheets = promiseObj.all(makeStylesheetLoadingPromises(editor, css, fontCss)).then(loaded).catch(loaded);
	      if (editor.settings.content_style) {
	        appendStyle(editor, editor.settings.content_style);
	      }
	      return allStylesheets;
	    };
	    var preInit = function (editor) {
	      var settings = editor.settings, doc = editor.getDoc(), body = editor.getBody();
	      firePreInit(editor);
	      if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
	        doc.body.spellcheck = false;
	        DOM$6.setAttrib(body, 'spellcheck', 'false');
	      }
	      editor.quirks = Quirks(editor);
	      firePostRender(editor);
	      var directionality = getDirectionality(editor);
	      if (directionality !== undefined) {
	        body.dir = directionality;
	      }
	      if (settings.protect) {
	        editor.on('BeforeSetContent', function (e) {
	          Tools.each(settings.protect, function (pattern) {
	            e.content = e.content.replace(pattern, function (str) {
	              return '<!--mce:protected ' + escape(str) + '-->';
	            });
	          });
	        });
	      }
	      editor.on('SetContent', function () {
	        editor.addVisual(editor.getBody());
	      });
	      editor.on('compositionstart compositionend', function (e) {
	        editor.composing = e.type === 'compositionstart';
	      });
	    };
	    var loadInitialContent = function (editor) {
	      if (!isRtc(editor)) {
	        editor.load({
	          initial: true,
	          format: 'html'
	        });
	      }
	      editor.startContent = editor.getContent({ format: 'raw' });
	    };
	    var initEditorWithInitialContent = function (editor) {
	      if (editor.removed !== true) {
	        loadInitialContent(editor);
	        initEditor(editor);
	      }
	    };
	    var initContentBody = function (editor, skipWrite) {
	      var settings = editor.settings;
	      var targetElm = editor.getElement();
	      var doc = editor.getDoc();
	      if (!settings.inline) {
	        editor.getElement().style.visibility = editor.orgVisibility;
	      }
	      if (!skipWrite && !editor.inline) {
	        doc.open();
	        doc.write(editor.iframeHTML);
	        doc.close();
	      }
	      if (editor.inline) {
	        DOM$6.addClass(targetElm, 'mce-content-body');
	        editor.contentDocument = doc = document;
	        editor.contentWindow = window;
	        editor.bodyElement = targetElm;
	        editor.contentAreaContainer = targetElm;
	      }
	      var body = editor.getBody();
	      body.disabled = true;
	      editor.readonly = !!settings.readonly;
	      if (!editor.readonly) {
	        if (editor.inline && DOM$6.getStyle(body, 'position', true) === 'static') {
	          body.style.position = 'relative';
	        }
	        body.contentEditable = editor.getParam('content_editable_state', true);
	      }
	      body.disabled = false;
	      editor.editorUpload = EditorUpload(editor);
	      editor.schema = Schema(mkSchemaSettings(editor));
	      editor.dom = DOMUtils(doc, {
	        keep_values: true,
	        url_converter: editor.convertURL,
	        url_converter_scope: editor,
	        hex_colors: settings.force_hex_style_colors,
	        update_styles: true,
	        root_element: editor.inline ? editor.getBody() : null,
	        collect: function () {
	          return editor.inline;
	        },
	        schema: editor.schema,
	        contentCssCors: shouldUseContentCssCors(editor),
	        referrerPolicy: getReferrerPolicy(editor),
	        onSetAttrib: function (e) {
	          editor.fire('SetAttrib', e);
	        }
	      });
	      editor.parser = createParser(editor);
	      editor.serializer = DomSerializer(mkSerializerSettings(editor), editor);
	      editor.selection = EditorSelection(editor.dom, editor.getWin(), editor.serializer, editor);
	      editor.annotator = Annotator(editor);
	      editor.formatter = Formatter(editor);
	      editor.undoManager = UndoManager(editor);
	      editor._nodeChangeDispatcher = new NodeChange(editor);
	      editor._selectionOverrides = SelectionOverrides(editor);
	      setup$e(editor);
	      setup$3(editor);
	      if (!isRtc(editor)) {
	        setup$2(editor);
	      }
	      var caret = setup$4(editor);
	      setup$f(editor, caret);
	      setup$d(editor);
	      setup$g(editor);
	      var setupRtcThunk = setup$i(editor);
	      preInit(editor);
	      setupRtcThunk.fold(function () {
	        loadContentCss(editor).then(function () {
	          return initEditorWithInitialContent(editor);
	        });
	      }, function (setupRtc) {
	        editor.setProgressState(true);
	        loadContentCss(editor).then(function () {
	          setupRtc().then(function (_rtcMode) {
	            editor.setProgressState(false);
	            initEditorWithInitialContent(editor);
	          }, function (err) {
	            editor.notificationManager.open({
	              type: 'error',
	              text: String(err)
	            });
	            initEditorWithInitialContent(editor);
	          });
	        });
	      });
	    };
	
	    var DOM$5 = DOMUtils.DOM;
	    var relaxDomain = function (editor, ifr) {
	      if (document.domain !== window.location.hostname && Env.browser.isIE()) {
	        var bodyUuid = uuid('mce');
	        editor[bodyUuid] = function () {
	          initContentBody(editor);
	        };
	        var domainRelaxUrl = 'javascript:(function(){' + 'document.open();document.domain="' + document.domain + '";' + 'var ed = window.parent.tinymce.get("' + editor.id + '");document.write(ed.iframeHTML);' + 'document.close();ed.' + bodyUuid + '(true);})()';
	        DOM$5.setAttrib(ifr, 'src', domainRelaxUrl);
	        return true;
	      }
	      return false;
	    };
	    var createIframeElement = function (id, title, height, customAttrs) {
	      var iframe = SugarElement.fromTag('iframe');
	      setAll$1(iframe, customAttrs);
	      setAll$1(iframe, {
	        id: id + '_ifr',
	        frameBorder: '0',
	        allowTransparency: 'true',
	        title: title
	      });
	      add$1(iframe, 'tox-edit-area__iframe');
	      return iframe;
	    };
	    var getIframeHtml = function (editor) {
	      var iframeHTML = getDocType(editor) + '<html><head>';
	      if (getDocumentBaseUrl(editor) !== editor.documentBaseUrl) {
	        iframeHTML += '<base href="' + editor.documentBaseURI.getURI() + '" />';
	      }
	      iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
	      var bodyId = getBodyId(editor);
	      var bodyClass = getBodyClass(editor);
	      var translatedAriaText = editor.translate(getIframeAriaText(editor));
	      if (getContentSecurityPolicy(editor)) {
	        iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + getContentSecurityPolicy(editor) + '" />';
	      }
	      iframeHTML += '</head>' + ('<body id="' + bodyId + '" class="mce-content-body ' + bodyClass + '" data-id="' + editor.id + '" aria-label="' + translatedAriaText + '">') + '<br>' + '</body></html>';
	      return iframeHTML;
	    };
	    var createIframe = function (editor, o) {
	      var iframeTitle = editor.translate('Rich Text Area');
	      var ifr = createIframeElement(editor.id, iframeTitle, o.height, getIframeAttrs(editor)).dom;
	      ifr.onload = function () {
	        ifr.onload = null;
	        editor.fire('load');
	      };
	      var isDomainRelaxed = relaxDomain(editor, ifr);
	      editor.contentAreaContainer = o.iframeContainer;
	      editor.iframeElement = ifr;
	      editor.iframeHTML = getIframeHtml(editor);
	      DOM$5.add(o.iframeContainer, ifr);
	      return isDomainRelaxed;
	    };
	    var init$1 = function (editor, boxInfo) {
	      var isDomainRelaxed = createIframe(editor, boxInfo);
	      if (boxInfo.editorContainer) {
	        DOM$5.get(boxInfo.editorContainer).style.display = editor.orgDisplay;
	        editor.hidden = DOM$5.isHidden(boxInfo.editorContainer);
	      }
	      editor.getElement().style.display = 'none';
	      DOM$5.setAttrib(editor.id, 'aria-hidden', 'true');
	      if (!isDomainRelaxed) {
	        initContentBody(editor);
	      }
	    };
	
	    var DOM$4 = DOMUtils.DOM;
	    var initPlugin = function (editor, initializedPlugins, plugin) {
	      var Plugin = PluginManager.get(plugin);
	      var pluginUrl = PluginManager.urls[plugin] || editor.documentBaseUrl.replace(/\/$/, '');
	      plugin = Tools.trim(plugin);
	      if (Plugin && Tools.inArray(initializedPlugins, plugin) === -1) {
	        Tools.each(PluginManager.dependencies(plugin), function (dep) {
	          initPlugin(editor, initializedPlugins, dep);
	        });
	        if (editor.plugins[plugin]) {
	          return;
	        }
	        try {
	          var pluginInstance = new Plugin(editor, pluginUrl, editor.$);
	          editor.plugins[plugin] = pluginInstance;
	          if (pluginInstance.init) {
	            pluginInstance.init(editor, pluginUrl);
	            initializedPlugins.push(plugin);
	          }
	        } catch (e) {
	          pluginInitError(editor, plugin, e);
	        }
	      }
	    };
	    var trimLegacyPrefix = function (name) {
	      return name.replace(/^\-/, '');
	    };
	    var initPlugins = function (editor) {
	      var initializedPlugins = [];
	      Tools.each(getPlugins(editor).split(/[ ,]/), function (name) {
	        initPlugin(editor, initializedPlugins, trimLegacyPrefix(name));
	      });
	    };
	    var initIcons = function (editor) {
	      var iconPackName = Tools.trim(getIconPackName(editor));
	      var currentIcons = editor.ui.registry.getAll().icons;
	      var loadIcons = __assign(__assign({}, IconManager.get('default').icons), IconManager.get(iconPackName).icons);
	      each$j(loadIcons, function (svgData, icon) {
	        if (!has$2(currentIcons, icon)) {
	          editor.ui.registry.addIcon(icon, svgData);
	        }
	      });
	    };
	    var initTheme = function (editor) {
	      var theme = getTheme(editor);
	      if (isString$1(theme)) {
	        editor.settings.theme = trimLegacyPrefix(theme);
	        var Theme = ThemeManager.get(theme);
	        editor.theme = new Theme(editor, ThemeManager.urls[theme]);
	        if (editor.theme.init) {
	          editor.theme.init(editor, ThemeManager.urls[theme] || editor.documentBaseUrl.replace(/\/$/, ''), editor.$);
	        }
	      } else {
	        editor.theme = {};
	      }
	    };
	    var renderFromLoadedTheme = function (editor) {
	      return editor.theme.renderUI();
	    };
	    var renderFromThemeFunc = function (editor) {
	      var elm = editor.getElement();
	      var theme = getTheme(editor);
	      var info = theme(editor, elm);
	      if (info.editorContainer.nodeType) {
	        info.editorContainer.id = info.editorContainer.id || editor.id + '_parent';
	      }
	      if (info.iframeContainer && info.iframeContainer.nodeType) {
	        info.iframeContainer.id = info.iframeContainer.id || editor.id + '_iframecontainer';
	      }
	      info.height = info.iframeHeight ? info.iframeHeight : elm.offsetHeight;
	      return info;
	    };
	    var createThemeFalseResult = function (element) {
	      return {
	        editorContainer: element,
	        iframeContainer: element,
	        api: {}
	      };
	    };
	    var renderThemeFalseIframe = function (targetElement) {
	      var iframeContainer = DOM$4.create('div');
	      DOM$4.insertAfter(iframeContainer, targetElement);
	      return createThemeFalseResult(iframeContainer);
	    };
	    var renderThemeFalse = function (editor) {
	      var targetElement = editor.getElement();
	      return editor.inline ? createThemeFalseResult(null) : renderThemeFalseIframe(targetElement);
	    };
	    var renderThemeUi = function (editor) {
	      var elm = editor.getElement();
	      editor.orgDisplay = elm.style.display;
	      if (isString$1(getTheme(editor))) {
	        return renderFromLoadedTheme(editor);
	      } else if (isFunction(getTheme(editor))) {
	        return renderFromThemeFunc(editor);
	      } else {
	        return renderThemeFalse(editor);
	      }
	    };
	    var augmentEditorUiApi = function (editor, api) {
	      var uiApiFacade = {
	        show: Optional.from(api.show).getOr(noop),
	        hide: Optional.from(api.hide).getOr(noop),
	        disable: Optional.from(api.disable).getOr(noop),
	        isDisabled: Optional.from(api.isDisabled).getOr(never),
	        enable: function () {
	          if (!editor.mode.isReadOnly()) {
	            Optional.from(api.enable).map(call);
	          }
	        }
	      };
	      editor.ui = __assign(__assign({}, editor.ui), uiApiFacade);
	    };
	    var init = function (editor) {
	      editor.fire('ScriptsLoaded');
	      initIcons(editor);
	      initTheme(editor);
	      initPlugins(editor);
	      var renderInfo = renderThemeUi(editor);
	      augmentEditorUiApi(editor, Optional.from(renderInfo.api).getOr({}));
	      var boxInfo = {
	        editorContainer: renderInfo.editorContainer,
	        iframeContainer: renderInfo.iframeContainer
	      };
	      editor.editorContainer = boxInfo.editorContainer ? boxInfo.editorContainer : null;
	      appendContentCssFromSettings(editor);
	      if (editor.inline) {
	        return initContentBody(editor);
	      } else {
	        return init$1(editor, boxInfo);
	      }
	    };
	
	    var DOM$3 = DOMUtils.DOM;
	    var hasSkipLoadPrefix = function (name) {
	      return name.charAt(0) === '-';
	    };
	    var loadLanguage = function (scriptLoader, editor) {
	      var languageCode = getLanguageCode(editor);
	      var languageUrl = getLanguageUrl(editor);
	      if (I18n.hasCode(languageCode) === false && languageCode !== 'en') {
	        var url_1 = languageUrl !== '' ? languageUrl : editor.editorManager.baseURL + '/langs/' + languageCode + '.js';
	        scriptLoader.add(url_1, noop, undefined, function () {
	          languageLoadError(editor, url_1, languageCode);
	        });
	      }
	    };
	    var loadTheme = function (scriptLoader, editor, suffix, callback) {
	      var theme = getTheme(editor);
	      if (isString$1(theme)) {
	        if (!hasSkipLoadPrefix(theme) && !has$2(ThemeManager.urls, theme)) {
	          var themeUrl = getThemeUrl(editor);
	          if (themeUrl) {
	            ThemeManager.load(theme, editor.documentBaseURI.toAbsolute(themeUrl));
	          } else {
	            ThemeManager.load(theme, 'themes/' + theme + '/theme' + suffix + '.js');
	          }
	        }
	        scriptLoader.loadQueue(function () {
	          ThemeManager.waitFor(theme, callback);
	        });
	      } else {
	        callback();
	      }
	    };
	    var getIconsUrlMetaFromUrl = function (editor) {
	      return Optional.from(getIconsUrl(editor)).filter(function (url) {
	        return url.length > 0;
	      }).map(function (url) {
	        return {
	          url: url,
	          name: Optional.none()
	        };
	      });
	    };
	    var getIconsUrlMetaFromName = function (editor, name, suffix) {
	      return Optional.from(name).filter(function (name) {
	        return name.length > 0 && !IconManager.has(name);
	      }).map(function (name) {
	        return {
	          url: editor.editorManager.baseURL + '/icons/' + name + '/icons' + suffix + '.js',
	          name: Optional.some(name)
	        };
	      });
	    };
	    var loadIcons = function (scriptLoader, editor, suffix) {
	      var defaultIconsUrl = getIconsUrlMetaFromName(editor, 'default', suffix);
	      var customIconsUrl = getIconsUrlMetaFromUrl(editor).orThunk(function () {
	        return getIconsUrlMetaFromName(editor, getIconPackName(editor), '');
	      });
	      each$k(cat([
	        defaultIconsUrl,
	        customIconsUrl
	      ]), function (urlMeta) {
	        scriptLoader.add(urlMeta.url, noop, undefined, function () {
	          iconsLoadError(editor, urlMeta.url, urlMeta.name.getOrUndefined());
	        });
	      });
	    };
	    var loadPlugins = function (editor, suffix) {
	      Tools.each(getExternalPlugins$1(editor), function (url, name) {
	        PluginManager.load(name, url, noop, undefined, function () {
	          pluginLoadError(editor, url, name);
	        });
	        editor.settings.plugins += ' ' + name;
	      });
	      Tools.each(getPlugins(editor).split(/[ ,]/), function (plugin) {
	        plugin = Tools.trim(plugin);
	        if (plugin && !PluginManager.urls[plugin]) {
	          if (hasSkipLoadPrefix(plugin)) {
	            plugin = plugin.substr(1, plugin.length);
	            var dependencies = PluginManager.dependencies(plugin);
	            Tools.each(dependencies, function (depPlugin) {
	              var defaultSettings = {
	                prefix: 'plugins/',
	                resource: depPlugin,
	                suffix: '/plugin' + suffix + '.js'
	              };
	              var dep = PluginManager.createUrl(defaultSettings, depPlugin);
	              PluginManager.load(dep.resource, dep, noop, undefined, function () {
	                pluginLoadError(editor, dep.prefix + dep.resource + dep.suffix, dep.resource);
	              });
	            });
	          } else {
	            var url_2 = {
	              prefix: 'plugins/',
	              resource: plugin,
	              suffix: '/plugin' + suffix + '.js'
	            };
	            PluginManager.load(plugin, url_2, noop, undefined, function () {
	              pluginLoadError(editor, url_2.prefix + url_2.resource + url_2.suffix, plugin);
	            });
	          }
	        }
	      });
	    };
	    var loadScripts = function (editor, suffix) {
	      var scriptLoader = ScriptLoader.ScriptLoader;
	      loadTheme(scriptLoader, editor, suffix, function () {
	        loadLanguage(scriptLoader, editor);
	        loadIcons(scriptLoader, editor, suffix);
	        loadPlugins(editor, suffix);
	        scriptLoader.loadQueue(function () {
	          if (!editor.removed) {
	            init(editor);
	          }
	        }, editor, function () {
	          if (!editor.removed) {
	            init(editor);
	          }
	        });
	      });
	    };
	    var getStyleSheetLoader = function (element, editor) {
	      return instance.forElement(element, {
	        contentCssCors: hasContentCssCors(editor),
	        referrerPolicy: getReferrerPolicy(editor)
	      });
	    };
	    var render = function (editor) {
	      var id = editor.id;
	      I18n.setCode(getLanguageCode(editor));
	      var readyHandler = function () {
	        DOM$3.unbind(window, 'ready', readyHandler);
	        editor.render();
	      };
	      if (!EventUtils.Event.domLoaded) {
	        DOM$3.bind(window, 'ready', readyHandler);
	        return;
	      }
	      if (!editor.getElement()) {
	        return;
	      }
	      if (!Env.contentEditable) {
	        return;
	      }
	      var element = SugarElement.fromDom(editor.getElement());
	      var snapshot = clone$3(element);
	      editor.on('remove', function () {
	        eachr(element.dom.attributes, function (attr) {
	          return remove$6(element, attr.name);
	        });
	        setAll$1(element, snapshot);
	      });
	      editor.ui.styleSheetLoader = getStyleSheetLoader(element, editor);
	      if (!isInline(editor)) {
	        editor.orgVisibility = editor.getElement().style.visibility;
	        editor.getElement().style.visibility = 'hidden';
	      } else {
	        editor.inline = true;
	      }
	      var form = editor.getElement().form || DOM$3.getParent(id, 'form');
	      if (form) {
	        editor.formElement = form;
	        if (hasHiddenInput(editor) && !isTextareaOrInput(editor.getElement())) {
	          DOM$3.insertAfter(DOM$3.create('input', {
	            type: 'hidden',
	            name: id
	          }), id);
	          editor.hasHiddenInput = true;
	        }
	        editor.formEventDelegate = function (e) {
	          editor.fire(e.type, e);
	        };
	        DOM$3.bind(form, 'submit reset', editor.formEventDelegate);
	        editor.on('reset', function () {
	          editor.resetContent();
	        });
	        if (shouldPatchSubmit(editor) && !form.submit.nodeType && !form.submit.length && !form._mceOldSubmit) {
	          form._mceOldSubmit = form.submit;
	          form.submit = function () {
	            editor.editorManager.triggerSave();
	            editor.setDirty(false);
	            return form._mceOldSubmit(form);
	          };
	        }
	      }
	      editor.windowManager = WindowManager(editor);
	      editor.notificationManager = NotificationManager(editor);
	      if (isEncodingXml(editor)) {
	        editor.on('GetContent', function (e) {
	          if (e.save) {
	            e.content = DOM$3.encode(e.content);
	          }
	        });
	      }
	      if (shouldAddFormSubmitTrigger(editor)) {
	        editor.on('submit', function () {
	          if (editor.initialized) {
	            editor.save();
	          }
	        });
	      }
	      if (shouldAddUnloadTrigger(editor)) {
	        editor._beforeUnload = function () {
	          if (editor.initialized && !editor.destroyed && !editor.isHidden()) {
	            editor.save({
	              format: 'raw',
	              no_events: true,
	              set_dirty: false
	            });
	          }
	        };
	        editor.editorManager.on('BeforeUnload', editor._beforeUnload);
	      }
	      editor.editorManager.add(editor);
	      loadScripts(editor, editor.suffix);
	    };
	
	    var addVisual = function (editor, elm) {
	      return addVisual$1(editor, elm);
	    };
	
	    var legacyPropNames = {
	      'font-size': 'size',
	      'font-family': 'face'
	    };
	    var getSpecifiedFontProp = function (propName, rootElm, elm) {
	      var getProperty = function (elm) {
	        return getRaw(elm, propName).orThunk(function () {
	          if (name(elm) === 'font') {
	            return get$9(legacyPropNames, propName).bind(function (legacyPropName) {
	              return getOpt(elm, legacyPropName);
	            });
	          } else {
	            return Optional.none();
	          }
	        });
	      };
	      var isRoot = function (elm) {
	        return eq(SugarElement.fromDom(rootElm), elm);
	      };
	      return closest$1(SugarElement.fromDom(elm), function (elm) {
	        return getProperty(elm);
	      }, isRoot);
	    };
	    var normalizeFontFamily = function (fontFamily) {
	      return fontFamily.replace(/[\'\"\\]/g, '').replace(/,\s+/g, ',');
	    };
	    var getComputedFontProp = function (propName, elm) {
	      return Optional.from(DOMUtils.DOM.getStyle(elm, propName, true));
	    };
	    var getFontProp = function (propName) {
	      return function (rootElm, elm) {
	        return Optional.from(elm).map(SugarElement.fromDom).filter(isElement$6).bind(function (element) {
	          return getSpecifiedFontProp(propName, rootElm, element.dom).or(getComputedFontProp(propName, element.dom));
	        }).getOr('');
	      };
	    };
	    var getFontSize = getFontProp('font-size');
	    var getFontFamily = compose(normalizeFontFamily, getFontProp('font-family'));
	
	    var findFirstCaretElement = function (editor) {
	      return firstPositionIn(editor.getBody()).map(function (caret) {
	        var container = caret.container();
	        return isText$7(container) ? container.parentNode : container;
	      });
	    };
	    var getCaretElement = function (editor) {
	      return Optional.from(editor.selection.getRng()).bind(function (rng) {
	        var root = editor.getBody();
	        var atStartOfNode = rng.startContainer === root && rng.startOffset === 0;
	        return atStartOfNode ? Optional.none() : Optional.from(editor.selection.getStart(true));
	      });
	    };
	    var bindRange = function (editor, binder) {
	      return getCaretElement(editor).orThunk(curry(findFirstCaretElement, editor)).map(SugarElement.fromDom).filter(isElement$6).bind(binder);
	    };
	    var mapRange = function (editor, mapper) {
	      return bindRange(editor, compose1(Optional.some, mapper));
	    };
	
	    var fromFontSizeNumber = function (editor, value) {
	      if (/^[0-9.]+$/.test(value)) {
	        var fontSizeNumber = parseInt(value, 10);
	        if (fontSizeNumber >= 1 && fontSizeNumber <= 7) {
	          var fontSizes = getFontStyleValues(editor);
	          var fontClasses = getFontSizeClasses(editor);
	          if (fontClasses) {
	            return fontClasses[fontSizeNumber - 1] || value;
	          } else {
	            return fontSizes[fontSizeNumber - 1] || value;
	          }
	        } else {
	          return value;
	        }
	      } else {
	        return value;
	      }
	    };
	    var normalizeFontNames = function (font) {
	      var fonts = font.split(/\s*,\s*/);
	      return map$3(fonts, function (font) {
	        if (font.indexOf(' ') !== -1 && !(startsWith(font, '"') || startsWith(font, '\''))) {
	          return '\'' + font + '\'';
	        } else {
	          return font;
	        }
	      }).join(',');
	    };
	    var fontNameAction = function (editor, value) {
	      var font = fromFontSizeNumber(editor, value);
	      editor.formatter.toggle('fontname', { value: normalizeFontNames(font) });
	      editor.nodeChanged();
	    };
	    var fontNameQuery = function (editor) {
	      return mapRange(editor, function (elm) {
	        return getFontFamily(editor.getBody(), elm.dom);
	      }).getOr('');
	    };
	    var fontSizeAction = function (editor, value) {
	      editor.formatter.toggle('fontsize', { value: fromFontSizeNumber(editor, value) });
	      editor.nodeChanged();
	    };
	    var fontSizeQuery = function (editor) {
	      return mapRange(editor, function (elm) {
	        return getFontSize(editor.getBody(), elm.dom);
	      }).getOr('');
	    };
	
	    var lineHeightQuery = function (editor) {
	      return mapRange(editor, function (elm) {
	        var root = SugarElement.fromDom(editor.getBody());
	        var specifiedStyle = closest$1(elm, function (elm) {
	          return getRaw(elm, 'line-height');
	        }, curry(eq, root));
	        var computedStyle = function () {
	          var lineHeight = parseFloat(get$5(elm, 'line-height'));
	          var fontSize = parseFloat(get$5(elm, 'font-size'));
	          return String(lineHeight / fontSize);
	        };
	        return specifiedStyle.getOrThunk(computedStyle);
	      }).getOr('');
	    };
	    var lineHeightAction = function (editor, lineHeight) {
	      editor.formatter.toggle('lineheight', { value: String(lineHeight) });
	      editor.nodeChanged();
	    };
	
	    var processValue = function (value) {
	      if (typeof value !== 'string') {
	        var details = Tools.extend({
	          paste: value.paste,
	          data: { paste: value.paste }
	        }, value);
	        return {
	          content: value.content,
	          details: details
	        };
	      }
	      return {
	        content: value,
	        details: {}
	      };
	    };
	    var insertAtCaret = function (editor, value) {
	      var result = processValue(value);
	      insertContent(editor, result.content, result.details);
	    };
	
	    var each$4 = Tools.each;
	    var map = Tools.map, inArray = Tools.inArray;
	    var EditorCommands = function () {
	      function EditorCommands(editor) {
	        this.commands = {
	          state: {},
	          exec: {},
	          value: {}
	        };
	        this.editor = editor;
	        this.setupCommands(editor);
	      }
	      EditorCommands.prototype.execCommand = function (command, ui, value, args) {
	        var func, state = false;
	        var self = this;
	        if (self.editor.removed) {
	          return;
	        }
	        if (command.toLowerCase() !== 'mcefocus') {
	          if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command) && (!args || !args.skip_focus)) {
	            self.editor.focus();
	          } else {
	            restore(self.editor);
	          }
	        }
	        args = self.editor.fire('BeforeExecCommand', {
	          command: command,
	          ui: ui,
	          value: value
	        });
	        if (args.isDefaultPrevented()) {
	          return false;
	        }
	        var customCommand = command.toLowerCase();
	        if (func = self.commands.exec[customCommand]) {
	          func(customCommand, ui, value);
	          self.editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        each$4(this.editor.plugins, function (p) {
	          if (p.execCommand && p.execCommand(command, ui, value)) {
	            self.editor.fire('ExecCommand', {
	              command: command,
	              ui: ui,
	              value: value
	            });
	            state = true;
	            return false;
	          }
	        });
	        if (state) {
	          return state;
	        }
	        if (self.editor.theme && self.editor.theme.execCommand && self.editor.theme.execCommand(command, ui, value)) {
	          self.editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        try {
	          state = self.editor.getDoc().execCommand(command, ui, value);
	        } catch (ex) {
	        }
	        if (state) {
	          self.editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        return false;
	      };
	      EditorCommands.prototype.queryCommandState = function (command) {
	        var func;
	        if (this.editor.quirks.isHidden() || this.editor.removed) {
	          return;
	        }
	        command = command.toLowerCase();
	        if (func = this.commands.state[command]) {
	          return func(command);
	        }
	        try {
	          return this.editor.getDoc().queryCommandState(command);
	        } catch (ex) {
	        }
	        return false;
	      };
	      EditorCommands.prototype.queryCommandValue = function (command) {
	        var func;
	        if (this.editor.quirks.isHidden() || this.editor.removed) {
	          return;
	        }
	        command = command.toLowerCase();
	        if (func = this.commands.value[command]) {
	          return func(command);
	        }
	        try {
	          return this.editor.getDoc().queryCommandValue(command);
	        } catch (ex) {
	        }
	      };
	      EditorCommands.prototype.addCommands = function (commandList, type) {
	        if (type === void 0) {
	          type = 'exec';
	        }
	        var self = this;
	        each$4(commandList, function (callback, command) {
	          each$4(command.toLowerCase().split(','), function (command) {
	            self.commands[type][command] = callback;
	          });
	        });
	      };
	      EditorCommands.prototype.addCommand = function (command, callback, scope) {
	        var _this = this;
	        command = command.toLowerCase();
	        this.commands.exec[command] = function (command, ui, value, args) {
	          return callback.call(scope || _this.editor, ui, value, args);
	        };
	      };
	      EditorCommands.prototype.queryCommandSupported = function (command) {
	        command = command.toLowerCase();
	        if (this.commands.exec[command]) {
	          return true;
	        }
	        try {
	          return this.editor.getDoc().queryCommandSupported(command);
	        } catch (ex) {
	        }
	        return false;
	      };
	      EditorCommands.prototype.addQueryStateHandler = function (command, callback, scope) {
	        var _this = this;
	        command = command.toLowerCase();
	        this.commands.state[command] = function () {
	          return callback.call(scope || _this.editor);
	        };
	      };
	      EditorCommands.prototype.addQueryValueHandler = function (command, callback, scope) {
	        var _this = this;
	        command = command.toLowerCase();
	        this.commands.value[command] = function () {
	          return callback.call(scope || _this.editor);
	        };
	      };
	      EditorCommands.prototype.hasCustomCommand = function (command) {
	        command = command.toLowerCase();
	        return !!this.commands.exec[command];
	      };
	      EditorCommands.prototype.execNativeCommand = function (command, ui, value) {
	        if (ui === undefined) {
	          ui = false;
	        }
	        if (value === undefined) {
	          value = null;
	        }
	        return this.editor.getDoc().execCommand(command, ui, value);
	      };
	      EditorCommands.prototype.isFormatMatch = function (name) {
	        return this.editor.formatter.match(name);
	      };
	      EditorCommands.prototype.toggleFormat = function (name, value) {
	        this.editor.formatter.toggle(name, value);
	        this.editor.nodeChanged();
	      };
	      EditorCommands.prototype.storeSelection = function (type) {
	        this.selectionBookmark = this.editor.selection.getBookmark(type);
	      };
	      EditorCommands.prototype.restoreSelection = function () {
	        this.editor.selection.moveToBookmark(this.selectionBookmark);
	      };
	      EditorCommands.prototype.setupCommands = function (editor) {
	        var self = this;
	        this.addCommands({
	          'mceResetDesignMode,mceBeginUndoLevel': noop,
	          'mceEndUndoLevel,mceAddUndoLevel': function () {
	            editor.undoManager.add();
	          },
	          'mceFocus': function (_command, _ui, value) {
	            focus(editor, value);
	          },
	          'Cut,Copy,Paste': function (command) {
	            var doc = editor.getDoc();
	            var failed;
	            try {
	              self.execNativeCommand(command);
	            } catch (ex) {
	              failed = true;
	            }
	            if (command === 'paste' && !doc.queryCommandEnabled(command)) {
	              failed = true;
	            }
	            if (failed || !doc.queryCommandSupported(command)) {
	              var msg = editor.translate('Your browser doesn\'t support direct access to the clipboard. ' + 'Please use the Ctrl+X/C/V keyboard shortcuts instead.');
	              if (Env.mac) {
	                msg = msg.replace(/Ctrl\+/g, '\u2318+');
	              }
	              editor.notificationManager.open({
	                text: msg,
	                type: 'error'
	              });
	            }
	          },
	          'unlink': function () {
	            if (editor.selection.isCollapsed()) {
	              var elm = editor.dom.getParent(editor.selection.getStart(), 'a');
	              if (elm) {
	                editor.dom.remove(elm, true);
	              }
	              return;
	            }
	            editor.formatter.remove('link');
	          },
	          'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function (command) {
	            var align = command.substring(7);
	            if (align === 'full') {
	              align = 'justify';
	            }
	            each$4('left,center,right,justify'.split(','), function (name) {
	              if (align !== name) {
	                editor.formatter.remove('align' + name);
	              }
	            });
	            if (align !== 'none') {
	              self.toggleFormat('align' + align);
	            }
	          },
	          'InsertUnorderedList,InsertOrderedList': function (command) {
	            var listParent;
	            self.execNativeCommand(command);
	            var listElm = editor.dom.getParent(editor.selection.getNode(), 'ol,ul');
	            if (listElm) {
	              listParent = listElm.parentNode;
	              if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
	                self.storeSelection();
	                editor.dom.split(listParent, listElm);
	                self.restoreSelection();
	              }
	            }
	          },
	          'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	            self.toggleFormat(command);
	          },
	          'ForeColor,HiliteColor': function (command, ui, value) {
	            self.toggleFormat(command, { value: value });
	          },
	          'FontName': function (command, ui, value) {
	            fontNameAction(editor, value);
	          },
	          'FontSize': function (command, ui, value) {
	            fontSizeAction(editor, value);
	          },
	          'LineHeight': function (command, ui, value) {
	            lineHeightAction(editor, value);
	          },
	          'Lang': function (command, ui, lang) {
	            self.toggleFormat(command, {
	              value: lang.code,
	              customValue: lang.customCode
	            });
	          },
	          'RemoveFormat': function (command) {
	            editor.formatter.remove(command);
	          },
	          'mceBlockQuote': function () {
	            self.toggleFormat('blockquote');
	          },
	          'FormatBlock': function (command, ui, value) {
	            return self.toggleFormat(value || 'p');
	          },
	          'mceCleanup': function () {
	            var bookmark = editor.selection.getBookmark();
	            editor.setContent(editor.getContent());
	            editor.selection.moveToBookmark(bookmark);
	          },
	          'mceRemoveNode': function (command, ui, value) {
	            var node = value || editor.selection.getNode();
	            if (node !== editor.getBody()) {
	              self.storeSelection();
	              editor.dom.remove(node, true);
	              self.restoreSelection();
	            }
	          },
	          'mceSelectNodeDepth': function (command, ui, value) {
	            var counter = 0;
	            editor.dom.getParent(editor.selection.getNode(), function (node) {
	              if (node.nodeType === 1 && counter++ === value) {
	                editor.selection.select(node);
	                return false;
	              }
	            }, editor.getBody());
	          },
	          'mceSelectNode': function (command, ui, value) {
	            editor.selection.select(value);
	          },
	          'mceInsertContent': function (command, ui, value) {
	            insertAtCaret(editor, value);
	          },
	          'mceInsertRawHTML': function (command, ui, value) {
	            editor.selection.setContent('tiny_mce_marker');
	            var content = editor.getContent();
	            editor.setContent(content.replace(/tiny_mce_marker/g, function () {
	              return value;
	            }));
	          },
	          'mceInsertNewLine': function (command, ui, value) {
	            insert(editor, value);
	          },
	          'mceToggleFormat': function (command, ui, value) {
	            self.toggleFormat(value);
	          },
	          'mceSetContent': function (command, ui, value) {
	            editor.setContent(value);
	          },
	          'Indent,Outdent': function (command) {
	            handle(editor, command);
	          },
	          'mceRepaint': noop,
	          'InsertHorizontalRule': function () {
	            editor.execCommand('mceInsertContent', false, '<hr />');
	          },
	          'mceToggleVisualAid': function () {
	            editor.hasVisual = !editor.hasVisual;
	            editor.addVisual();
	          },
	          'mceReplaceContent': function (command, ui, value) {
	            editor.execCommand('mceInsertContent', false, value.replace(/\{\$selection\}/g, editor.selection.getContent({ format: 'text' })));
	          },
	          'mceInsertLink': function (command, ui, value) {
	            if (typeof value === 'string') {
	              value = { href: value };
	            }
	            var anchor = editor.dom.getParent(editor.selection.getNode(), 'a');
	            value.href = value.href.replace(/ /g, '%20');
	            if (!anchor || !value.href) {
	              editor.formatter.remove('link');
	            }
	            if (value.href) {
	              editor.formatter.apply('link', value, anchor);
	            }
	          },
	          'selectAll': function () {
	            var editingHost = editor.dom.getParent(editor.selection.getStart(), isContentEditableTrue$4);
	            if (editingHost) {
	              var rng = editor.dom.createRng();
	              rng.selectNodeContents(editingHost);
	              editor.selection.setRng(rng);
	            }
	          },
	          'mceNewDocument': function () {
	            editor.setContent('');
	          },
	          'InsertLineBreak': function (command, ui, value) {
	            insert$1(editor, value);
	            return true;
	          }
	        });
	        var alignStates = function (name) {
	          return function () {
	            var selection = editor.selection;
	            var nodes = selection.isCollapsed() ? [editor.dom.getParent(selection.getNode(), editor.dom.isBlock)] : selection.getSelectedBlocks();
	            var matches = map(nodes, function (node) {
	              return !!editor.formatter.matchNode(node, name);
	            });
	            return inArray(matches, true) !== -1;
	          };
	        };
	        self.addCommands({
	          'JustifyLeft': alignStates('alignleft'),
	          'JustifyCenter': alignStates('aligncenter'),
	          'JustifyRight': alignStates('alignright'),
	          'JustifyFull': alignStates('alignjustify'),
	          'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	            return self.isFormatMatch(command);
	          },
	          'mceBlockQuote': function () {
	            return self.isFormatMatch('blockquote');
	          },
	          'Outdent': function () {
	            return canOutdent(editor);
	          },
	          'InsertUnorderedList,InsertOrderedList': function (command) {
	            var list = editor.dom.getParent(editor.selection.getNode(), 'ul,ol');
	            return list && (command === 'insertunorderedlist' && list.tagName === 'UL' || command === 'insertorderedlist' && list.tagName === 'OL');
	          }
	        }, 'state');
	        self.addCommands({
	          Undo: function () {
	            editor.undoManager.undo();
	          },
	          Redo: function () {
	            editor.undoManager.redo();
	          }
	        });
	        self.addQueryValueHandler('FontName', function () {
	          return fontNameQuery(editor);
	        }, this);
	        self.addQueryValueHandler('FontSize', function () {
	          return fontSizeQuery(editor);
	        }, this);
	        self.addQueryValueHandler('LineHeight', function () {
	          return lineHeightQuery(editor);
	        }, this);
	      };
	      return EditorCommands;
	    }();
	
	    var internalContentEditableAttr = 'data-mce-contenteditable';
	    var toggleClass = function (elm, cls, state) {
	      if (has(elm, cls) && state === false) {
	        remove$3(elm, cls);
	      } else if (state) {
	        add$1(elm, cls);
	      }
	    };
	    var setEditorCommandState = function (editor, cmd, state) {
	      try {
	        editor.getDoc().execCommand(cmd, false, String(state));
	      } catch (ex) {
	      }
	    };
	    var setContentEditable = function (elm, state) {
	      elm.dom.contentEditable = state ? 'true' : 'false';
	    };
	    var switchOffContentEditableTrue = function (elm) {
	      each$k(descendants(elm, '*[contenteditable="true"]'), function (elm) {
	        set$1(elm, internalContentEditableAttr, 'true');
	        setContentEditable(elm, false);
	      });
	    };
	    var switchOnContentEditableTrue = function (elm) {
	      each$k(descendants(elm, '*[' + internalContentEditableAttr + '="true"]'), function (elm) {
	        remove$6(elm, internalContentEditableAttr);
	        setContentEditable(elm, true);
	      });
	    };
	    var removeFakeSelection = function (editor) {
	      Optional.from(editor.selection.getNode()).each(function (elm) {
	        elm.removeAttribute('data-mce-selected');
	      });
	    };
	    var restoreFakeSelection = function (editor) {
	      editor.selection.setRng(editor.selection.getRng());
	    };
	    var toggleReadOnly = function (editor, state) {
	      var body = SugarElement.fromDom(editor.getBody());
	      toggleClass(body, 'mce-content-readonly', state);
	      if (state) {
	        editor.selection.controlSelection.hideResizeRect();
	        editor._selectionOverrides.hideFakeCaret();
	        removeFakeSelection(editor);
	        editor.readonly = true;
	        setContentEditable(body, false);
	        switchOffContentEditableTrue(body);
	      } else {
	        editor.readonly = false;
	        setContentEditable(body, true);
	        switchOnContentEditableTrue(body);
	        setEditorCommandState(editor, 'StyleWithCSS', false);
	        setEditorCommandState(editor, 'enableInlineTableEditing', false);
	        setEditorCommandState(editor, 'enableObjectResizing', false);
	        if (hasEditorOrUiFocus(editor)) {
	          editor.focus();
	        }
	        restoreFakeSelection(editor);
	        editor.nodeChanged();
	      }
	    };
	    var isReadOnly = function (editor) {
	      return editor.readonly;
	    };
	    var registerFilters = function (editor) {
	      editor.parser.addAttributeFilter('contenteditable', function (nodes) {
	        if (isReadOnly(editor)) {
	          each$k(nodes, function (node) {
	            node.attr(internalContentEditableAttr, node.attr('contenteditable'));
	            node.attr('contenteditable', 'false');
	          });
	        }
	      });
	      editor.serializer.addAttributeFilter(internalContentEditableAttr, function (nodes) {
	        if (isReadOnly(editor)) {
	          each$k(nodes, function (node) {
	            node.attr('contenteditable', node.attr(internalContentEditableAttr));
	          });
	        }
	      });
	      editor.serializer.addTempAttr(internalContentEditableAttr);
	    };
	    var registerReadOnlyContentFilters = function (editor) {
	      if (editor.serializer) {
	        registerFilters(editor);
	      } else {
	        editor.on('PreInit', function () {
	          registerFilters(editor);
	        });
	      }
	    };
	    var isClickEvent = function (e) {
	      return e.type === 'click';
	    };
	    var getAnchorHrefOpt = function (editor, elm) {
	      var isRoot = function (elm) {
	        return eq(elm, SugarElement.fromDom(editor.getBody()));
	      };
	      return closest$2(elm, 'a', isRoot).bind(function (a) {
	        return getOpt(a, 'href');
	      });
	    };
	    var processReadonlyEvents = function (editor, e) {
	      if (isClickEvent(e) && !VK.metaKeyPressed(e)) {
	        var elm = SugarElement.fromDom(e.target);
	        getAnchorHrefOpt(editor, elm).each(function (href) {
	          e.preventDefault();
	          if (/^#/.test(href)) {
	            var targetEl = editor.dom.select(href + ',[name="' + removeLeading(href, '#') + '"]');
	            if (targetEl.length) {
	              editor.selection.scrollIntoView(targetEl[0], true);
	            }
	          } else {
	            window.open(href, '_blank', 'rel=noopener noreferrer,menubar=yes,toolbar=yes,location=yes,status=yes,resizable=yes,scrollbars=yes');
	          }
	        });
	      }
	    };
	    var registerReadOnlySelectionBlockers = function (editor) {
	      editor.on('ShowCaret', function (e) {
	        if (isReadOnly(editor)) {
	          e.preventDefault();
	        }
	      });
	      editor.on('ObjectSelected', function (e) {
	        if (isReadOnly(editor)) {
	          e.preventDefault();
	        }
	      });
	    };
	
	    var nativeEvents = Tools.makeMap('focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange ' + 'mouseout mouseenter mouseleave wheel keydown keypress keyup input beforeinput contextmenu dragstart dragend dragover ' + 'draggesture dragdrop drop drag submit ' + 'compositionstart compositionend compositionupdate touchstart touchmove touchend touchcancel', ' ');
	    var EventDispatcher = function () {
	      function EventDispatcher(settings) {
	        this.bindings = {};
	        this.settings = settings || {};
	        this.scope = this.settings.scope || this;
	        this.toggleEvent = this.settings.toggleEvent || never;
	      }
	      EventDispatcher.isNative = function (name) {
	        return !!nativeEvents[name.toLowerCase()];
	      };
	      EventDispatcher.prototype.fire = function (name, args) {
	        var lcName = name.toLowerCase();
	        var event = normalize$3(lcName, args || {}, this.scope);
	        if (this.settings.beforeFire) {
	          this.settings.beforeFire(event);
	        }
	        var handlers = this.bindings[lcName];
	        if (handlers) {
	          for (var i = 0, l = handlers.length; i < l; i++) {
	            var callback = handlers[i];
	            if (callback.removed) {
	              continue;
	            }
	            if (callback.once) {
	              this.off(lcName, callback.func);
	            }
	            if (event.isImmediatePropagationStopped()) {
	              return event;
	            }
	            if (callback.func.call(this.scope, event) === false) {
	              event.preventDefault();
	              return event;
	            }
	          }
	        }
	        return event;
	      };
	      EventDispatcher.prototype.on = function (name, callback, prepend, extra) {
	        if (callback === false) {
	          callback = never;
	        }
	        if (callback) {
	          var wrappedCallback = {
	            func: callback,
	            removed: false
	          };
	          if (extra) {
	            Tools.extend(wrappedCallback, extra);
	          }
	          var names = name.toLowerCase().split(' ');
	          var i = names.length;
	          while (i--) {
	            var currentName = names[i];
	            var handlers = this.bindings[currentName];
	            if (!handlers) {
	              handlers = [];
	              this.toggleEvent(currentName, true);
	            }
	            if (prepend) {
	              handlers = __spreadArray([wrappedCallback], handlers, true);
	            } else {
	              handlers = __spreadArray(__spreadArray([], handlers, true), [wrappedCallback], false);
	            }
	            this.bindings[currentName] = handlers;
	          }
	        }
	        return this;
	      };
	      EventDispatcher.prototype.off = function (name, callback) {
	        var _this = this;
	        if (name) {
	          var names = name.toLowerCase().split(' ');
	          var i = names.length;
	          while (i--) {
	            var currentName = names[i];
	            var handlers = this.bindings[currentName];
	            if (!currentName) {
	              each$j(this.bindings, function (_value, bindingName) {
	                _this.toggleEvent(bindingName, false);
	                delete _this.bindings[bindingName];
	              });
	              return this;
	            }
	            if (handlers) {
	              if (!callback) {
	                handlers.length = 0;
	              } else {
	                var filteredHandlers = partition(handlers, function (handler) {
	                  return handler.func === callback;
	                });
	                handlers = filteredHandlers.fail;
	                this.bindings[currentName] = handlers;
	                each$k(filteredHandlers.pass, function (handler) {
	                  handler.removed = true;
	                });
	              }
	              if (!handlers.length) {
	                this.toggleEvent(name, false);
	                delete this.bindings[currentName];
	              }
	            }
	          }
	        } else {
	          each$j(this.bindings, function (_value, name) {
	            _this.toggleEvent(name, false);
	          });
	          this.bindings = {};
	        }
	        return this;
	      };
	      EventDispatcher.prototype.once = function (name, callback, prepend) {
	        return this.on(name, callback, prepend, { once: true });
	      };
	      EventDispatcher.prototype.has = function (name) {
	        name = name.toLowerCase();
	        return !(!this.bindings[name] || this.bindings[name].length === 0);
	      };
	      return EventDispatcher;
	    }();
	
	    var getEventDispatcher = function (obj) {
	      if (!obj._eventDispatcher) {
	        obj._eventDispatcher = new EventDispatcher({
	          scope: obj,
	          toggleEvent: function (name, state) {
	            if (EventDispatcher.isNative(name) && obj.toggleNativeEvent) {
	              obj.toggleNativeEvent(name, state);
	            }
	          }
	        });
	      }
	      return obj._eventDispatcher;
	    };
	    var Observable = {
	      fire: function (name, args, bubble) {
	        var self = this;
	        if (self.removed && name !== 'remove' && name !== 'detach') {
	          return args;
	        }
	        var dispatcherArgs = getEventDispatcher(self).fire(name, args);
	        if (bubble !== false && self.parent) {
	          var parent_1 = self.parent();
	          while (parent_1 && !dispatcherArgs.isPropagationStopped()) {
	            parent_1.fire(name, dispatcherArgs, false);
	            parent_1 = parent_1.parent();
	          }
	        }
	        return dispatcherArgs;
	      },
	      on: function (name, callback, prepend) {
	        return getEventDispatcher(this).on(name, callback, prepend);
	      },
	      off: function (name, callback) {
	        return getEventDispatcher(this).off(name, callback);
	      },
	      once: function (name, callback) {
	        return getEventDispatcher(this).once(name, callback);
	      },
	      hasEventListeners: function (name) {
	        return getEventDispatcher(this).has(name);
	      }
	    };
	
	    var DOM$2 = DOMUtils.DOM;
	    var customEventRootDelegates;
	    var getEventTarget = function (editor, eventName) {
	      if (eventName === 'selectionchange') {
	        return editor.getDoc();
	      }
	      if (!editor.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)) {
	        return editor.getDoc().documentElement;
	      }
	      var eventRoot = getEventRoot(editor);
	      if (eventRoot) {
	        if (!editor.eventRoot) {
	          editor.eventRoot = DOM$2.select(eventRoot)[0];
	        }
	        return editor.eventRoot;
	      }
	      return editor.getBody();
	    };
	    var isListening = function (editor) {
	      return !editor.hidden && !isReadOnly(editor);
	    };
	    var fireEvent = function (editor, eventName, e) {
	      if (isListening(editor)) {
	        editor.fire(eventName, e);
	      } else if (isReadOnly(editor)) {
	        processReadonlyEvents(editor, e);
	      }
	    };
	    var bindEventDelegate = function (editor, eventName) {
	      var delegate;
	      if (!editor.delegates) {
	        editor.delegates = {};
	      }
	      if (editor.delegates[eventName] || editor.removed) {
	        return;
	      }
	      var eventRootElm = getEventTarget(editor, eventName);
	      if (getEventRoot(editor)) {
	        if (!customEventRootDelegates) {
	          customEventRootDelegates = {};
	          editor.editorManager.on('removeEditor', function () {
	            if (!editor.editorManager.activeEditor) {
	              if (customEventRootDelegates) {
	                each$j(customEventRootDelegates, function (_value, name) {
	                  editor.dom.unbind(getEventTarget(editor, name));
	                });
	                customEventRootDelegates = null;
	              }
	            }
	          });
	        }
	        if (customEventRootDelegates[eventName]) {
	          return;
	        }
	        delegate = function (e) {
	          var target = e.target;
	          var editors = editor.editorManager.get();
	          var i = editors.length;
	          while (i--) {
	            var body = editors[i].getBody();
	            if (body === target || DOM$2.isChildOf(target, body)) {
	              fireEvent(editors[i], eventName, e);
	            }
	          }
	        };
	        customEventRootDelegates[eventName] = delegate;
	        DOM$2.bind(eventRootElm, eventName, delegate);
	      } else {
	        delegate = function (e) {
	          fireEvent(editor, eventName, e);
	        };
	        DOM$2.bind(eventRootElm, eventName, delegate);
	        editor.delegates[eventName] = delegate;
	      }
	    };
	    var EditorObservable = __assign(__assign({}, Observable), {
	      bindPendingEventDelegates: function () {
	        var self = this;
	        Tools.each(self._pendingNativeEvents, function (name) {
	          bindEventDelegate(self, name);
	        });
	      },
	      toggleNativeEvent: function (name, state) {
	        var self = this;
	        if (name === 'focus' || name === 'blur') {
	          return;
	        }
	        if (self.removed) {
	          return;
	        }
	        if (state) {
	          if (self.initialized) {
	            bindEventDelegate(self, name);
	          } else {
	            if (!self._pendingNativeEvents) {
	              self._pendingNativeEvents = [name];
	            } else {
	              self._pendingNativeEvents.push(name);
	            }
	          }
	        } else if (self.initialized) {
	          self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
	          delete self.delegates[name];
	        }
	      },
	      unbindAllNativeEvents: function () {
	        var self = this;
	        var body = self.getBody();
	        var dom = self.dom;
	        if (self.delegates) {
	          each$j(self.delegates, function (value, name) {
	            self.dom.unbind(getEventTarget(self, name), name, value);
	          });
	          delete self.delegates;
	        }
	        if (!self.inline && body && dom) {
	          body.onload = null;
	          dom.unbind(self.getWin());
	          dom.unbind(self.getDoc());
	        }
	        if (dom) {
	          dom.unbind(body);
	          dom.unbind(self.getContainer());
	        }
	      }
	    });
	
	    var defaultModes = [
	      'design',
	      'readonly'
	    ];
	    var switchToMode = function (editor, activeMode, availableModes, mode) {
	      var oldMode = availableModes[activeMode.get()];
	      var newMode = availableModes[mode];
	      try {
	        newMode.activate();
	      } catch (e) {
	        console.error('problem while activating editor mode ' + mode + ':', e);
	        return;
	      }
	      oldMode.deactivate();
	      if (oldMode.editorReadOnly !== newMode.editorReadOnly) {
	        toggleReadOnly(editor, newMode.editorReadOnly);
	      }
	      activeMode.set(mode);
	      fireSwitchMode(editor, mode);
	    };
	    var setMode = function (editor, availableModes, activeMode, mode) {
	      if (mode === activeMode.get()) {
	        return;
	      } else if (!has$2(availableModes, mode)) {
	        throw new Error('Editor mode \'' + mode + '\' is invalid');
	      }
	      if (editor.initialized) {
	        switchToMode(editor, activeMode, availableModes, mode);
	      } else {
	        editor.on('init', function () {
	          return switchToMode(editor, activeMode, availableModes, mode);
	        });
	      }
	    };
	    var registerMode = function (availableModes, mode, api) {
	      var _a;
	      if (contains$3(defaultModes, mode)) {
	        throw new Error('Cannot override default mode ' + mode);
	      }
	      return __assign(__assign({}, availableModes), (_a = {}, _a[mode] = __assign(__assign({}, api), {
	        deactivate: function () {
	          try {
	            api.deactivate();
	          } catch (e) {
	            console.error('problem while deactivating editor mode ' + mode + ':', e);
	          }
	        }
	      }), _a));
	    };
	
	    var create$4 = function (editor) {
	      var activeMode = Cell('design');
	      var availableModes = Cell({
	        design: {
	          activate: noop,
	          deactivate: noop,
	          editorReadOnly: false
	        },
	        readonly: {
	          activate: noop,
	          deactivate: noop,
	          editorReadOnly: true
	        }
	      });
	      registerReadOnlyContentFilters(editor);
	      registerReadOnlySelectionBlockers(editor);
	      return {
	        isReadOnly: function () {
	          return isReadOnly(editor);
	        },
	        set: function (mode) {
	          return setMode(editor, availableModes.get(), activeMode, mode);
	        },
	        get: function () {
	          return activeMode.get();
	        },
	        register: function (mode, api) {
	          availableModes.set(registerMode(availableModes.get(), mode, api));
	        }
	      };
	    };
	
	    var each$3 = Tools.each, explode$1 = Tools.explode;
	    var keyCodeLookup = {
	      f1: 112,
	      f2: 113,
	      f3: 114,
	      f4: 115,
	      f5: 116,
	      f6: 117,
	      f7: 118,
	      f8: 119,
	      f9: 120,
	      f10: 121,
	      f11: 122,
	      f12: 123
	    };
	    var modifierNames = Tools.makeMap('alt,ctrl,shift,meta,access');
	    var parseShortcut = function (pattern) {
	      var key;
	      var shortcut = {};
	      each$3(explode$1(pattern.toLowerCase(), '+'), function (value) {
	        if (value in modifierNames) {
	          shortcut[value] = true;
	        } else {
	          if (/^[0-9]{2,}$/.test(value)) {
	            shortcut.keyCode = parseInt(value, 10);
	          } else {
	            shortcut.charCode = value.charCodeAt(0);
	            shortcut.keyCode = keyCodeLookup[value] || value.toUpperCase().charCodeAt(0);
	          }
	        }
	      });
	      var id = [shortcut.keyCode];
	      for (key in modifierNames) {
	        if (shortcut[key]) {
	          id.push(key);
	        } else {
	          shortcut[key] = false;
	        }
	      }
	      shortcut.id = id.join(',');
	      if (shortcut.access) {
	        shortcut.alt = true;
	        if (Env.mac) {
	          shortcut.ctrl = true;
	        } else {
	          shortcut.shift = true;
	        }
	      }
	      if (shortcut.meta) {
	        if (Env.mac) {
	          shortcut.meta = true;
	        } else {
	          shortcut.ctrl = true;
	          shortcut.meta = false;
	        }
	      }
	      return shortcut;
	    };
	    var Shortcuts = function () {
	      function Shortcuts(editor) {
	        this.shortcuts = {};
	        this.pendingPatterns = [];
	        this.editor = editor;
	        var self = this;
	        editor.on('keyup keypress keydown', function (e) {
	          if ((self.hasModifier(e) || self.isFunctionKey(e)) && !e.isDefaultPrevented()) {
	            each$3(self.shortcuts, function (shortcut) {
	              if (self.matchShortcut(e, shortcut)) {
	                self.pendingPatterns = shortcut.subpatterns.slice(0);
	                if (e.type === 'keydown') {
	                  self.executeShortcutAction(shortcut);
	                }
	                return true;
	              }
	            });
	            if (self.matchShortcut(e, self.pendingPatterns[0])) {
	              if (self.pendingPatterns.length === 1) {
	                if (e.type === 'keydown') {
	                  self.executeShortcutAction(self.pendingPatterns[0]);
	                }
	              }
	              self.pendingPatterns.shift();
	            }
	          }
	        });
	      }
	      Shortcuts.prototype.add = function (pattern, desc, cmdFunc, scope) {
	        var self = this;
	        var func = self.normalizeCommandFunc(cmdFunc);
	        each$3(explode$1(Tools.trim(pattern)), function (pattern) {
	          var shortcut = self.createShortcut(pattern, desc, func, scope);
	          self.shortcuts[shortcut.id] = shortcut;
	        });
	        return true;
	      };
	      Shortcuts.prototype.remove = function (pattern) {
	        var shortcut = this.createShortcut(pattern);
	        if (this.shortcuts[shortcut.id]) {
	          delete this.shortcuts[shortcut.id];
	          return true;
	        }
	        return false;
	      };
	      Shortcuts.prototype.normalizeCommandFunc = function (cmdFunc) {
	        var self = this;
	        var cmd = cmdFunc;
	        if (typeof cmd === 'string') {
	          return function () {
	            self.editor.execCommand(cmd, false, null);
	          };
	        } else if (Tools.isArray(cmd)) {
	          return function () {
	            self.editor.execCommand(cmd[0], cmd[1], cmd[2]);
	          };
	        } else {
	          return cmd;
	        }
	      };
	      Shortcuts.prototype.createShortcut = function (pattern, desc, cmdFunc, scope) {
	        var shortcuts = Tools.map(explode$1(pattern, '>'), parseShortcut);
	        shortcuts[shortcuts.length - 1] = Tools.extend(shortcuts[shortcuts.length - 1], {
	          func: cmdFunc,
	          scope: scope || this.editor
	        });
	        return Tools.extend(shortcuts[0], {
	          desc: this.editor.translate(desc),
	          subpatterns: shortcuts.slice(1)
	        });
	      };
	      Shortcuts.prototype.hasModifier = function (e) {
	        return e.altKey || e.ctrlKey || e.metaKey;
	      };
	      Shortcuts.prototype.isFunctionKey = function (e) {
	        return e.type === 'keydown' && e.keyCode >= 112 && e.keyCode <= 123;
	      };
	      Shortcuts.prototype.matchShortcut = function (e, shortcut) {
	        if (!shortcut) {
	          return false;
	        }
	        if (shortcut.ctrl !== e.ctrlKey || shortcut.meta !== e.metaKey) {
	          return false;
	        }
	        if (shortcut.alt !== e.altKey || shortcut.shift !== e.shiftKey) {
	          return false;
	        }
	        if (e.keyCode === shortcut.keyCode || e.charCode && e.charCode === shortcut.charCode) {
	          e.preventDefault();
	          return true;
	        }
	        return false;
	      };
	      Shortcuts.prototype.executeShortcutAction = function (shortcut) {
	        return shortcut.func ? shortcut.func.call(shortcut.scope) : null;
	      };
	      return Shortcuts;
	    }();
	
	    var create$3 = function () {
	      var buttons = {};
	      var menuItems = {};
	      var popups = {};
	      var icons = {};
	      var contextMenus = {};
	      var contextToolbars = {};
	      var sidebars = {};
	      var add = function (collection, type) {
	        return function (name, spec) {
	          return collection[name.toLowerCase()] = __assign(__assign({}, spec), { type: type });
	        };
	      };
	      var addIcon = function (name, svgData) {
	        return icons[name.toLowerCase()] = svgData;
	      };
	      return {
	        addButton: add(buttons, 'button'),
	        addGroupToolbarButton: add(buttons, 'grouptoolbarbutton'),
	        addToggleButton: add(buttons, 'togglebutton'),
	        addMenuButton: add(buttons, 'menubutton'),
	        addSplitButton: add(buttons, 'splitbutton'),
	        addMenuItem: add(menuItems, 'menuitem'),
	        addNestedMenuItem: add(menuItems, 'nestedmenuitem'),
	        addToggleMenuItem: add(menuItems, 'togglemenuitem'),
	        addAutocompleter: add(popups, 'autocompleter'),
	        addContextMenu: add(contextMenus, 'contextmenu'),
	        addContextToolbar: add(contextToolbars, 'contexttoolbar'),
	        addContextForm: add(contextToolbars, 'contextform'),
	        addSidebar: add(sidebars, 'sidebar'),
	        addIcon: addIcon,
	        getAll: function () {
	          return {
	            buttons: buttons,
	            menuItems: menuItems,
	            icons: icons,
	            popups: popups,
	            contextMenus: contextMenus,
	            contextToolbars: contextToolbars,
	            sidebars: sidebars
	          };
	        }
	      };
	    };
	
	    var registry = function () {
	      var bridge = create$3();
	      return {
	        addAutocompleter: bridge.addAutocompleter,
	        addButton: bridge.addButton,
	        addContextForm: bridge.addContextForm,
	        addContextMenu: bridge.addContextMenu,
	        addContextToolbar: bridge.addContextToolbar,
	        addIcon: bridge.addIcon,
	        addMenuButton: bridge.addMenuButton,
	        addMenuItem: bridge.addMenuItem,
	        addNestedMenuItem: bridge.addNestedMenuItem,
	        addSidebar: bridge.addSidebar,
	        addSplitButton: bridge.addSplitButton,
	        addToggleButton: bridge.addToggleButton,
	        addGroupToolbarButton: bridge.addGroupToolbarButton,
	        addToggleMenuItem: bridge.addToggleMenuItem,
	        getAll: bridge.getAll
	      };
	    };
	
	    var DOM$1 = DOMUtils.DOM;
	    var extend$3 = Tools.extend, each$2 = Tools.each;
	    var resolve = Tools.resolve;
	    var ie = Env.ie;
	    var Editor = function () {
	      function Editor(id, settings, editorManager) {
	        var _this = this;
	        this.plugins = {};
	        this.contentCSS = [];
	        this.contentStyles = [];
	        this.loadedCSS = {};
	        this.isNotDirty = false;
	        this.editorManager = editorManager;
	        this.documentBaseUrl = editorManager.documentBaseURL;
	        extend$3(this, EditorObservable);
	        this.settings = getEditorSettings(this, id, this.documentBaseUrl, editorManager.defaultSettings, settings);
	        if (this.settings.suffix) {
	          editorManager.suffix = this.settings.suffix;
	        }
	        this.suffix = editorManager.suffix;
	        if (this.settings.base_url) {
	          editorManager._setBaseUrl(this.settings.base_url);
	        }
	        this.baseUri = editorManager.baseURI;
	        if (this.settings.referrer_policy) {
	          ScriptLoader.ScriptLoader._setReferrerPolicy(this.settings.referrer_policy);
	          DOMUtils.DOM.styleSheetLoader._setReferrerPolicy(this.settings.referrer_policy);
	        }
	        AddOnManager.languageLoad = this.settings.language_load;
	        AddOnManager.baseURL = editorManager.baseURL;
	        this.id = id;
	        this.setDirty(false);
	        this.documentBaseURI = new URI(this.settings.document_base_url, { base_uri: this.baseUri });
	        this.baseURI = this.baseUri;
	        this.inline = !!this.settings.inline;
	        this.shortcuts = new Shortcuts(this);
	        this.editorCommands = new EditorCommands(this);
	        if (this.settings.cache_suffix) {
	          Env.cacheSuffix = this.settings.cache_suffix.replace(/^[\?\&]+/, '');
	        }
	        this.ui = {
	          registry: registry(),
	          styleSheetLoader: undefined,
	          show: noop,
	          hide: noop,
	          enable: noop,
	          disable: noop,
	          isDisabled: never
	        };
	        var self = this;
	        var modeInstance = create$4(self);
	        this.mode = modeInstance;
	        this.setMode = modeInstance.set;
	        editorManager.fire('SetupEditor', { editor: this });
	        this.execCallback('setup', this);
	        this.$ = DomQuery.overrideDefaults(function () {
	          return {
	            context: _this.inline ? _this.getBody() : _this.getDoc(),
	            element: _this.getBody()
	          };
	        });
	      }
	      Editor.prototype.render = function () {
	        render(this);
	      };
	      Editor.prototype.focus = function (skipFocus) {
	        this.execCommand('mceFocus', false, skipFocus);
	      };
	      Editor.prototype.hasFocus = function () {
	        return hasFocus(this);
	      };
	      Editor.prototype.execCallback = function (name) {
	        var x = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	          x[_i - 1] = arguments[_i];
	        }
	        var self = this;
	        var callback = self.settings[name], scope;
	        if (!callback) {
	          return;
	        }
	        if (self.callbackLookup && (scope = self.callbackLookup[name])) {
	          callback = scope.func;
	          scope = scope.scope;
	        }
	        if (typeof callback === 'string') {
	          scope = callback.replace(/\.\w+$/, '');
	          scope = scope ? resolve(scope) : 0;
	          callback = resolve(callback);
	          self.callbackLookup = self.callbackLookup || {};
	          self.callbackLookup[name] = {
	            func: callback,
	            scope: scope
	          };
	        }
	        return callback.apply(scope || self, x);
	      };
	      Editor.prototype.translate = function (text) {
	        return I18n.translate(text);
	      };
	      Editor.prototype.getParam = function (name, defaultVal, type) {
	        return getParam(this, name, defaultVal, type);
	      };
	      Editor.prototype.hasPlugin = function (name, loaded) {
	        var hasPlugin = contains$3(getPlugins(this).split(/[ ,]/), name);
	        if (hasPlugin) {
	          return loaded ? PluginManager.get(name) !== undefined : true;
	        } else {
	          return false;
	        }
	      };
	      Editor.prototype.nodeChanged = function (args) {
	        this._nodeChangeDispatcher.nodeChanged(args);
	      };
	      Editor.prototype.addCommand = function (name, callback, scope) {
	        this.editorCommands.addCommand(name, callback, scope);
	      };
	      Editor.prototype.addQueryStateHandler = function (name, callback, scope) {
	        this.editorCommands.addQueryStateHandler(name, callback, scope);
	      };
	      Editor.prototype.addQueryValueHandler = function (name, callback, scope) {
	        this.editorCommands.addQueryValueHandler(name, callback, scope);
	      };
	      Editor.prototype.addShortcut = function (pattern, desc, cmdFunc, scope) {
	        this.shortcuts.add(pattern, desc, cmdFunc, scope);
	      };
	      Editor.prototype.execCommand = function (cmd, ui, value, args) {
	        return this.editorCommands.execCommand(cmd, ui, value, args);
	      };
	      Editor.prototype.queryCommandState = function (cmd) {
	        return this.editorCommands.queryCommandState(cmd);
	      };
	      Editor.prototype.queryCommandValue = function (cmd) {
	        return this.editorCommands.queryCommandValue(cmd);
	      };
	      Editor.prototype.queryCommandSupported = function (cmd) {
	        return this.editorCommands.queryCommandSupported(cmd);
	      };
	      Editor.prototype.show = function () {
	        var self = this;
	        if (self.hidden) {
	          self.hidden = false;
	          if (self.inline) {
	            self.getBody().contentEditable = 'true';
	          } else {
	            DOM$1.show(self.getContainer());
	            DOM$1.hide(self.id);
	          }
	          self.load();
	          self.fire('show');
	        }
	      };
	      Editor.prototype.hide = function () {
	        var self = this, doc = self.getDoc();
	        if (!self.hidden) {
	          if (ie && doc && !self.inline) {
	            doc.execCommand('SelectAll');
	          }
	          self.save();
	          if (self.inline) {
	            self.getBody().contentEditable = 'false';
	            if (self === self.editorManager.focusedEditor) {
	              self.editorManager.focusedEditor = null;
	            }
	          } else {
	            DOM$1.hide(self.getContainer());
	            DOM$1.setStyle(self.id, 'display', self.orgDisplay);
	          }
	          self.hidden = true;
	          self.fire('hide');
	        }
	      };
	      Editor.prototype.isHidden = function () {
	        return !!this.hidden;
	      };
	      Editor.prototype.setProgressState = function (state, time) {
	        this.fire('ProgressState', {
	          state: state,
	          time: time
	        });
	      };
	      Editor.prototype.load = function (args) {
	        var self = this;
	        var elm = self.getElement(), html;
	        if (self.removed) {
	          return '';
	        }
	        if (elm) {
	          args = args || {};
	          args.load = true;
	          var value = isTextareaOrInput(elm) ? elm.value : elm.innerHTML;
	          html = self.setContent(value, args);
	          args.element = elm;
	          if (!args.no_events) {
	            self.fire('LoadContent', args);
	          }
	          args.element = elm = null;
	          return html;
	        }
	      };
	      Editor.prototype.save = function (args) {
	        var self = this;
	        var elm = self.getElement(), html, form;
	        if (!elm || !self.initialized || self.removed) {
	          return;
	        }
	        args = args || {};
	        args.save = true;
	        args.element = elm;
	        html = args.content = self.getContent(args);
	        if (!args.no_events) {
	          self.fire('SaveContent', args);
	        }
	        if (args.format === 'raw') {
	          self.fire('RawSaveContent', args);
	        }
	        html = args.content;
	        if (!isTextareaOrInput(elm)) {
	          if (args.is_removing || !self.inline) {
	            elm.innerHTML = html;
	          }
	          if (form = DOM$1.getParent(self.id, 'form')) {
	            each$2(form.elements, function (elm) {
	              if (elm.name === self.id) {
	                elm.value = html;
	                return false;
	              }
	            });
	          }
	        } else {
	          elm.value = html;
	        }
	        args.element = elm = null;
	        if (args.set_dirty !== false) {
	          self.setDirty(false);
	        }
	        return html;
	      };
	      Editor.prototype.setContent = function (content, args) {
	        return setContent(this, content, args);
	      };
	      Editor.prototype.getContent = function (args) {
	        return getContent(this, args);
	      };
	      Editor.prototype.insertContent = function (content, args) {
	        if (args) {
	          content = extend$3({ content: content }, args);
	        }
	        this.execCommand('mceInsertContent', false, content);
	      };
	      Editor.prototype.resetContent = function (initialContent) {
	        if (initialContent === undefined) {
	          setContent(this, this.startContent, { format: 'raw' });
	        } else {
	          setContent(this, initialContent);
	        }
	        this.undoManager.reset();
	        this.setDirty(false);
	        this.nodeChanged();
	      };
	      Editor.prototype.isDirty = function () {
	        return !this.isNotDirty;
	      };
	      Editor.prototype.setDirty = function (state) {
	        var oldState = !this.isNotDirty;
	        this.isNotDirty = !state;
	        if (state && state !== oldState) {
	          this.fire('dirty');
	        }
	      };
	      Editor.prototype.getContainer = function () {
	        var self = this;
	        if (!self.container) {
	          self.container = DOM$1.get(self.editorContainer || self.id + '_parent');
	        }
	        return self.container;
	      };
	      Editor.prototype.getContentAreaContainer = function () {
	        return this.contentAreaContainer;
	      };
	      Editor.prototype.getElement = function () {
	        if (!this.targetElm) {
	          this.targetElm = DOM$1.get(this.id);
	        }
	        return this.targetElm;
	      };
	      Editor.prototype.getWin = function () {
	        var self = this;
	        var elm;
	        if (!self.contentWindow) {
	          elm = self.iframeElement;
	          if (elm) {
	            self.contentWindow = elm.contentWindow;
	          }
	        }
	        return self.contentWindow;
	      };
	      Editor.prototype.getDoc = function () {
	        var self = this;
	        var win;
	        if (!self.contentDocument) {
	          win = self.getWin();
	          if (win) {
	            self.contentDocument = win.document;
	          }
	        }
	        return self.contentDocument;
	      };
	      Editor.prototype.getBody = function () {
	        var doc = this.getDoc();
	        return this.bodyElement || (doc ? doc.body : null);
	      };
	      Editor.prototype.convertURL = function (url, name, elm) {
	        var self = this, settings = self.settings;
	        if (settings.urlconverter_callback) {
	          return self.execCallback('urlconverter_callback', url, elm, true, name);
	        }
	        if (!settings.convert_urls || elm && elm.nodeName === 'LINK' || url.indexOf('file:') === 0 || url.length === 0) {
	          return url;
	        }
	        if (settings.relative_urls) {
	          return self.documentBaseURI.toRelative(url);
	        }
	        url = self.documentBaseURI.toAbsolute(url, settings.remove_script_host);
	        return url;
	      };
	      Editor.prototype.addVisual = function (elm) {
	        addVisual(this, elm);
	      };
	      Editor.prototype.remove = function () {
	        remove(this);
	      };
	      Editor.prototype.destroy = function (automatic) {
	        destroy(this, automatic);
	      };
	      Editor.prototype.uploadImages = function (callback) {
	        return this.editorUpload.uploadImages(callback);
	      };
	      Editor.prototype._scanForImages = function () {
	        return this.editorUpload.scanForImages();
	      };
	      Editor.prototype.addButton = function () {
	        throw new Error('editor.addButton has been removed in tinymce 5x, use editor.ui.registry.addButton or editor.ui.registry.addToggleButton or editor.ui.registry.addSplitButton instead');
	      };
	      Editor.prototype.addSidebar = function () {
	        throw new Error('editor.addSidebar has been removed in tinymce 5x, use editor.ui.registry.addSidebar instead');
	      };
	      Editor.prototype.addMenuItem = function () {
	        throw new Error('editor.addMenuItem has been removed in tinymce 5x, use editor.ui.registry.addMenuItem instead');
	      };
	      Editor.prototype.addContextToolbar = function () {
	        throw new Error('editor.addContextToolbar has been removed in tinymce 5x, use editor.ui.registry.addContextToolbar instead');
	      };
	      return Editor;
	    }();
	
	    var DOM = DOMUtils.DOM;
	    var explode = Tools.explode, each$1 = Tools.each, extend$2 = Tools.extend;
	    var instanceCounter = 0, boundGlobalEvents = false;
	    var beforeUnloadDelegate;
	    var legacyEditors = [];
	    var editors = [];
	    var isValidLegacyKey = function (id) {
	      return id !== 'length';
	    };
	    var globalEventDelegate = function (e) {
	      var type = e.type;
	      each$1(EditorManager.get(), function (editor) {
	        switch (type) {
	        case 'scroll':
	          editor.fire('ScrollWindow', e);
	          break;
	        case 'resize':
	          editor.fire('ResizeWindow', e);
	          break;
	        }
	      });
	    };
	    var toggleGlobalEvents = function (state) {
	      if (state !== boundGlobalEvents) {
	        if (state) {
	          DomQuery(window).on('resize scroll', globalEventDelegate);
	        } else {
	          DomQuery(window).off('resize scroll', globalEventDelegate);
	        }
	        boundGlobalEvents = state;
	      }
	    };
	    var removeEditorFromList = function (targetEditor) {
	      var oldEditors = editors;
	      delete legacyEditors[targetEditor.id];
	      for (var i = 0; i < legacyEditors.length; i++) {
	        if (legacyEditors[i] === targetEditor) {
	          legacyEditors.splice(i, 1);
	          break;
	        }
	      }
	      editors = filter$4(editors, function (editor) {
	        return targetEditor !== editor;
	      });
	      if (EditorManager.activeEditor === targetEditor) {
	        EditorManager.activeEditor = editors.length > 0 ? editors[0] : null;
	      }
	      if (EditorManager.focusedEditor === targetEditor) {
	        EditorManager.focusedEditor = null;
	      }
	      return oldEditors.length !== editors.length;
	    };
	    var purgeDestroyedEditor = function (editor) {
	      if (editor && editor.initialized && !(editor.getContainer() || editor.getBody()).parentNode) {
	        removeEditorFromList(editor);
	        editor.unbindAllNativeEvents();
	        editor.destroy(true);
	        editor.removed = true;
	        editor = null;
	      }
	      return editor;
	    };
	    var isQuirksMode = document.compatMode !== 'CSS1Compat';
	    var EditorManager = __assign(__assign({}, Observable), {
	      baseURI: null,
	      baseURL: null,
	      defaultSettings: {},
	      documentBaseURL: null,
	      suffix: null,
	      $: DomQuery,
	      majorVersion: '5',
	      minorVersion: '10.7',
	      releaseDate: '2022-12-06',
	      editors: legacyEditors,
	      i18n: I18n,
	      activeEditor: null,
	      focusedEditor: null,
	      settings: {},
	      setup: function () {
	        var self = this;
	        var baseURL, documentBaseURL, suffix = '';
	        documentBaseURL = URI.getDocumentBaseUrl(document.location);
	        if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
	          documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	          if (!/[\/\\]$/.test(documentBaseURL)) {
	            documentBaseURL += '/';
	          }
	        }
	        var preInit = window.tinymce || window.tinyMCEPreInit;
	        if (preInit) {
	          baseURL = preInit.base || preInit.baseURL;
	          suffix = preInit.suffix;
	        } else {
	          var scripts = document.getElementsByTagName('script');
	          for (var i = 0; i < scripts.length; i++) {
	            var src = scripts[i].src || '';
	            if (src === '') {
	              continue;
	            }
	            var srcScript = src.substring(src.lastIndexOf('/'));
	            if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
	              if (srcScript.indexOf('.min') !== -1) {
	                suffix = '.min';
	              }
	              baseURL = src.substring(0, src.lastIndexOf('/'));
	              break;
	            }
	          }
	          if (!baseURL && document.currentScript) {
	            var src = document.currentScript.src;
	            if (src.indexOf('.min') !== -1) {
	              suffix = '.min';
	            }
	            baseURL = src.substring(0, src.lastIndexOf('/'));
	          }
	        }
	        self.baseURL = new URI(documentBaseURL).toAbsolute(baseURL);
	        self.documentBaseURL = documentBaseURL;
	        self.baseURI = new URI(self.baseURL);
	        self.suffix = suffix;
	        setup$l(self);
	      },
	      overrideDefaults: function (defaultSettings) {
	        var baseUrl = defaultSettings.base_url;
	        if (baseUrl) {
	          this._setBaseUrl(baseUrl);
	        }
	        var suffix = defaultSettings.suffix;
	        if (defaultSettings.suffix) {
	          this.suffix = suffix;
	        }
	        this.defaultSettings = defaultSettings;
	        var pluginBaseUrls = defaultSettings.plugin_base_urls;
	        if (pluginBaseUrls !== undefined) {
	          each$j(pluginBaseUrls, function (pluginBaseUrl, pluginName) {
	            AddOnManager.PluginManager.urls[pluginName] = pluginBaseUrl;
	          });
	        }
	      },
	      init: function (settings) {
	        var self = this;
	        var result;
	        var invalidInlineTargets = Tools.makeMap('area base basefont br col frame hr img input isindex link meta param embed source wbr track ' + 'colgroup option table tbody tfoot thead tr th td script noscript style textarea video audio iframe object menu', ' ');
	        var isInvalidInlineTarget = function (settings, elm) {
	          return settings.inline && elm.tagName.toLowerCase() in invalidInlineTargets;
	        };
	        var createId = function (elm) {
	          var id = elm.id;
	          if (!id) {
	            id = get$9(elm, 'name').filter(function (name) {
	              return !DOM.get(name);
	            }).getOrThunk(DOM.uniqueId);
	            elm.setAttribute('id', id);
	          }
	          return id;
	        };
	        var execCallback = function (name) {
	          var callback = settings[name];
	          if (!callback) {
	            return;
	          }
	          return callback.apply(self, []);
	        };
	        var hasClass = function (elm, className) {
	          return className.constructor === RegExp ? className.test(elm.className) : DOM.hasClass(elm, className);
	        };
	        var findTargets = function (settings) {
	          var targets = [];
	          if (Env.browser.isIE() && Env.browser.version.major < 11) {
	            initError('TinyMCE does not support the browser you are using. For a list of supported' + ' browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/');
	            return [];
	          } else if (isQuirksMode) {
	            initError('Failed to initialize the editor as the document is not in standards mode. ' + 'TinyMCE requires standards mode.');
	            return [];
	          }
	          if (settings.types) {
	            each$1(settings.types, function (type) {
	              targets = targets.concat(DOM.select(type.selector));
	            });
	            return targets;
	          } else if (settings.selector) {
	            return DOM.select(settings.selector);
	          } else if (settings.target) {
	            return [settings.target];
	          }
	          switch (settings.mode) {
	          case 'exact':
	            var l = settings.elements || '';
	            if (l.length > 0) {
	              each$1(explode(l), function (id) {
	                var elm = DOM.get(id);
	                if (elm) {
	                  targets.push(elm);
	                } else {
	                  each$1(document.forms, function (f) {
	                    each$1(f.elements, function (e) {
	                      if (e.name === id) {
	                        id = 'mce_editor_' + instanceCounter++;
	                        DOM.setAttrib(e, 'id', id);
	                        targets.push(e);
	                      }
	                    });
	                  });
	                }
	              });
	            }
	            break;
	          case 'textareas':
	          case 'specific_textareas':
	            each$1(DOM.select('textarea'), function (elm) {
	              if (settings.editor_deselector && hasClass(elm, settings.editor_deselector)) {
	                return;
	              }
	              if (!settings.editor_selector || hasClass(elm, settings.editor_selector)) {
	                targets.push(elm);
	              }
	            });
	            break;
	          }
	          return targets;
	        };
	        var provideResults = function (editors) {
	          result = editors;
	        };
	        var initEditors = function () {
	          var initCount = 0;
	          var editors = [];
	          var targets;
	          var createEditor = function (id, settings, targetElm) {
	            var editor = new Editor(id, settings, self);
	            editors.push(editor);
	            editor.on('init', function () {
	              if (++initCount === targets.length) {
	                provideResults(editors);
	              }
	            });
	            editor.targetElm = editor.targetElm || targetElm;
	            editor.render();
	          };
	          DOM.unbind(window, 'ready', initEditors);
	          execCallback('onpageload');
	          targets = DomQuery.unique(findTargets(settings));
	          if (settings.types) {
	            each$1(settings.types, function (type) {
	              Tools.each(targets, function (elm) {
	                if (DOM.is(elm, type.selector)) {
	                  createEditor(createId(elm), extend$2({}, settings, type), elm);
	                  return false;
	                }
	                return true;
	              });
	            });
	            return;
	          }
	          Tools.each(targets, function (elm) {
	            purgeDestroyedEditor(self.get(elm.id));
	          });
	          targets = Tools.grep(targets, function (elm) {
	            return !self.get(elm.id);
	          });
	          if (targets.length === 0) {
	            provideResults([]);
	          } else {
	            each$1(targets, function (elm) {
	              if (isInvalidInlineTarget(settings, elm)) {
	                initError('Could not initialize inline editor on invalid inline target element', elm);
	              } else {
	                createEditor(createId(elm), settings, elm);
	              }
	            });
	          }
	        };
	        self.settings = settings;
	        DOM.bind(window, 'ready', initEditors);
	        return new promiseObj(function (resolve) {
	          if (result) {
	            resolve(result);
	          } else {
	            provideResults = function (editors) {
	              resolve(editors);
	            };
	          }
	        });
	      },
	      get: function (id) {
	        if (arguments.length === 0) {
	          return editors.slice(0);
	        } else if (isString$1(id)) {
	          return find$3(editors, function (editor) {
	            return editor.id === id;
	          }).getOr(null);
	        } else if (isNumber(id)) {
	          return editors[id] ? editors[id] : null;
	        } else {
	          return null;
	        }
	      },
	      add: function (editor) {
	        var self = this;
	        var existingEditor = legacyEditors[editor.id];
	        if (existingEditor === editor) {
	          return editor;
	        }
	        if (self.get(editor.id) === null) {
	          if (isValidLegacyKey(editor.id)) {
	            legacyEditors[editor.id] = editor;
	          }
	          legacyEditors.push(editor);
	          editors.push(editor);
	        }
	        toggleGlobalEvents(true);
	        self.activeEditor = editor;
	        self.fire('AddEditor', { editor: editor });
	        if (!beforeUnloadDelegate) {
	          beforeUnloadDelegate = function (e) {
	            var event = self.fire('BeforeUnload');
	            if (event.returnValue) {
	              e.preventDefault();
	              e.returnValue = event.returnValue;
	              return event.returnValue;
	            }
	          };
	          window.addEventListener('beforeunload', beforeUnloadDelegate);
	        }
	        return editor;
	      },
	      createEditor: function (id, settings) {
	        return this.add(new Editor(id, settings, this));
	      },
	      remove: function (selector) {
	        var self = this;
	        var i, editor;
	        if (!selector) {
	          for (i = editors.length - 1; i >= 0; i--) {
	            self.remove(editors[i]);
	          }
	          return;
	        }
	        if (isString$1(selector)) {
	          each$1(DOM.select(selector), function (elm) {
	            editor = self.get(elm.id);
	            if (editor) {
	              self.remove(editor);
	            }
	          });
	          return;
	        }
	        editor = selector;
	        if (isNull(self.get(editor.id))) {
	          return null;
	        }
	        if (removeEditorFromList(editor)) {
	          self.fire('RemoveEditor', { editor: editor });
	        }
	        if (editors.length === 0) {
	          window.removeEventListener('beforeunload', beforeUnloadDelegate);
	        }
	        editor.remove();
	        toggleGlobalEvents(editors.length > 0);
	        return editor;
	      },
	      execCommand: function (cmd, ui, value) {
	        var self = this, editor = self.get(value);
	        switch (cmd) {
	        case 'mceAddEditor':
	          if (!self.get(value)) {
	            new Editor(value, self.settings, self).render();
	          }
	          return true;
	        case 'mceRemoveEditor':
	          if (editor) {
	            editor.remove();
	          }
	          return true;
	        case 'mceToggleEditor':
	          if (!editor) {
	            self.execCommand('mceAddEditor', false, value);
	            return true;
	          }
	          if (editor.isHidden()) {
	            editor.show();
	          } else {
	            editor.hide();
	          }
	          return true;
	        }
	        if (self.activeEditor) {
	          return self.activeEditor.execCommand(cmd, ui, value);
	        }
	        return false;
	      },
	      triggerSave: function () {
	        each$1(editors, function (editor) {
	          editor.save();
	        });
	      },
	      addI18n: function (code, items) {
	        I18n.add(code, items);
	      },
	      translate: function (text) {
	        return I18n.translate(text);
	      },
	      setActive: function (editor) {
	        var activeEditor = this.activeEditor;
	        if (this.activeEditor !== editor) {
	          if (activeEditor) {
	            activeEditor.fire('deactivate', { relatedTarget: editor });
	          }
	          editor.fire('activate', { relatedTarget: activeEditor });
	        }
	        this.activeEditor = editor;
	      },
	      _setBaseUrl: function (baseUrl) {
	        this.baseURL = new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/, ''));
	        this.baseURI = new URI(this.baseURL);
	      }
	    });
	    EditorManager.setup();
	
	    var min$1 = Math.min, max$1 = Math.max, round$1 = Math.round;
	    var relativePosition = function (rect, targetRect, rel) {
	      var x = targetRect.x;
	      var y = targetRect.y;
	      var w = rect.w;
	      var h = rect.h;
	      var targetW = targetRect.w;
	      var targetH = targetRect.h;
	      var relChars = (rel || '').split('');
	      if (relChars[0] === 'b') {
	        y += targetH;
	      }
	      if (relChars[1] === 'r') {
	        x += targetW;
	      }
	      if (relChars[0] === 'c') {
	        y += round$1(targetH / 2);
	      }
	      if (relChars[1] === 'c') {
	        x += round$1(targetW / 2);
	      }
	      if (relChars[3] === 'b') {
	        y -= h;
	      }
	      if (relChars[4] === 'r') {
	        x -= w;
	      }
	      if (relChars[3] === 'c') {
	        y -= round$1(h / 2);
	      }
	      if (relChars[4] === 'c') {
	        x -= round$1(w / 2);
	      }
	      return create$2(x, y, w, h);
	    };
	    var findBestRelativePosition = function (rect, targetRect, constrainRect, rels) {
	      var pos, i;
	      for (i = 0; i < rels.length; i++) {
	        pos = relativePosition(rect, targetRect, rels[i]);
	        if (pos.x >= constrainRect.x && pos.x + pos.w <= constrainRect.w + constrainRect.x && pos.y >= constrainRect.y && pos.y + pos.h <= constrainRect.h + constrainRect.y) {
	          return rels[i];
	        }
	      }
	      return null;
	    };
	    var inflate = function (rect, w, h) {
	      return create$2(rect.x - w, rect.y - h, rect.w + w * 2, rect.h + h * 2);
	    };
	    var intersect = function (rect, cropRect) {
	      var x1 = max$1(rect.x, cropRect.x);
	      var y1 = max$1(rect.y, cropRect.y);
	      var x2 = min$1(rect.x + rect.w, cropRect.x + cropRect.w);
	      var y2 = min$1(rect.y + rect.h, cropRect.y + cropRect.h);
	      if (x2 - x1 < 0 || y2 - y1 < 0) {
	        return null;
	      }
	      return create$2(x1, y1, x2 - x1, y2 - y1);
	    };
	    var clamp = function (rect, clampRect, fixedSize) {
	      var x1 = rect.x;
	      var y1 = rect.y;
	      var x2 = rect.x + rect.w;
	      var y2 = rect.y + rect.h;
	      var cx2 = clampRect.x + clampRect.w;
	      var cy2 = clampRect.y + clampRect.h;
	      var underflowX1 = max$1(0, clampRect.x - x1);
	      var underflowY1 = max$1(0, clampRect.y - y1);
	      var overflowX2 = max$1(0, x2 - cx2);
	      var overflowY2 = max$1(0, y2 - cy2);
	      x1 += underflowX1;
	      y1 += underflowY1;
	      if (fixedSize) {
	        x2 += underflowX1;
	        y2 += underflowY1;
	        x1 -= overflowX2;
	        y1 -= overflowY2;
	      }
	      x2 -= overflowX2;
	      y2 -= overflowY2;
	      return create$2(x1, y1, x2 - x1, y2 - y1);
	    };
	    var create$2 = function (x, y, w, h) {
	      return {
	        x: x,
	        y: y,
	        w: w,
	        h: h
	      };
	    };
	    var fromClientRect = function (clientRect) {
	      return create$2(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
	    };
	    var Rect = {
	      inflate: inflate,
	      relativePosition: relativePosition,
	      findBestRelativePosition: findBestRelativePosition,
	      intersect: intersect,
	      clamp: clamp,
	      create: create$2,
	      fromClientRect: fromClientRect
	    };
	
	    var awaiter = function (resolveCb, rejectCb, timeout) {
	      if (timeout === void 0) {
	        timeout = 1000;
	      }
	      var done = false;
	      var timer = null;
	      var complete = function (completer) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          if (!done) {
	            done = true;
	            if (timer !== null) {
	              clearTimeout(timer);
	              timer = null;
	            }
	            completer.apply(null, args);
	          }
	        };
	      };
	      var resolve = complete(resolveCb);
	      var reject = complete(rejectCb);
	      var start = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!done && timer === null) {
	          timer = setTimeout(function () {
	            return reject.apply(null, args);
	          }, timeout);
	        }
	      };
	      return {
	        start: start,
	        resolve: resolve,
	        reject: reject
	      };
	    };
	    var create$1 = function () {
	      var tasks = {};
	      var resultFns = {};
	      var load = function (id, url) {
	        var loadErrMsg = 'Script at URL "' + url + '" failed to load';
	        var runErrMsg = 'Script at URL "' + url + '" did not call `tinymce.Resource.add(\'' + id + '\', data)` within 1 second';
	        if (tasks[id] !== undefined) {
	          return tasks[id];
	        } else {
	          var task = new promiseObj(function (resolve, reject) {
	            var waiter = awaiter(resolve, reject);
	            resultFns[id] = waiter.resolve;
	            ScriptLoader.ScriptLoader.loadScript(url, function () {
	              return waiter.start(runErrMsg);
	            }, function () {
	              return waiter.reject(loadErrMsg);
	            });
	          });
	          tasks[id] = task;
	          return task;
	        }
	      };
	      var add = function (id, data) {
	        if (resultFns[id] !== undefined) {
	          resultFns[id](data);
	          delete resultFns[id];
	        }
	        tasks[id] = promiseObj.resolve(data);
	      };
	      return {
	        load: load,
	        add: add
	      };
	    };
	    var Resource = create$1();
	
	    var each = Tools.each, extend$1 = Tools.extend;
	    var extendClass, initializing;
	    var Class = function () {
	    };
	    Class.extend = extendClass = function (props) {
	      var self = this;
	      var _super = self.prototype;
	      var Class = function () {
	        var i, mixins, mixin;
	        var self = this;
	        if (!initializing) {
	          if (self.init) {
	            self.init.apply(self, arguments);
	          }
	          mixins = self.Mixins;
	          if (mixins) {
	            i = mixins.length;
	            while (i--) {
	              mixin = mixins[i];
	              if (mixin.init) {
	                mixin.init.apply(self, arguments);
	              }
	            }
	          }
	        }
	      };
	      var dummy = function () {
	        return this;
	      };
	      var createMethod = function (name, fn) {
	        return function () {
	          var self = this;
	          var tmp = self._super;
	          self._super = _super[name];
	          var ret = fn.apply(self, arguments);
	          self._super = tmp;
	          return ret;
	        };
	      };
	      initializing = true;
	      var prototype = new self();
	      initializing = false;
	      if (props.Mixins) {
	        each(props.Mixins, function (mixin) {
	          for (var name_1 in mixin) {
	            if (name_1 !== 'init') {
	              props[name_1] = mixin[name_1];
	            }
	          }
	        });
	        if (_super.Mixins) {
	          props.Mixins = _super.Mixins.concat(props.Mixins);
	        }
	      }
	      if (props.Methods) {
	        each(props.Methods.split(','), function (name) {
	          props[name] = dummy;
	        });
	      }
	      if (props.Properties) {
	        each(props.Properties.split(','), function (name) {
	          var fieldName = '_' + name;
	          props[name] = function (value) {
	            var self = this;
	            if (value !== undefined) {
	              self[fieldName] = value;
	              return self;
	            }
	            return self[fieldName];
	          };
	        });
	      }
	      if (props.Statics) {
	        each(props.Statics, function (func, name) {
	          Class[name] = func;
	        });
	      }
	      if (props.Defaults && _super.Defaults) {
	        props.Defaults = extend$1({}, _super.Defaults, props.Defaults);
	      }
	      each$j(props, function (member, name) {
	        if (typeof member === 'function' && _super[name]) {
	          prototype[name] = createMethod(name, member);
	        } else {
	          prototype[name] = member;
	        }
	      });
	      Class.prototype = prototype;
	      Class.constructor = Class;
	      Class.extend = extendClass;
	      return Class;
	    };
	
	    var min = Math.min, max = Math.max, round = Math.round;
	    var Color = function (value) {
	      var self = {};
	      var r = 0, g = 0, b = 0;
	      var rgb2hsv = function (r, g, b) {
	        var h, s, v;
	        h = 0;
	        s = 0;
	        v = 0;
	        r = r / 255;
	        g = g / 255;
	        b = b / 255;
	        var minRGB = min(r, min(g, b));
	        var maxRGB = max(r, max(g, b));
	        if (minRGB === maxRGB) {
	          v = minRGB;
	          return {
	            h: 0,
	            s: 0,
	            v: v * 100
	          };
	        }
	        var d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
	        h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
	        h = 60 * (h - d / (maxRGB - minRGB));
	        s = (maxRGB - minRGB) / maxRGB;
	        v = maxRGB;
	        return {
	          h: round(h),
	          s: round(s * 100),
	          v: round(v * 100)
	        };
	      };
	      var hsvToRgb = function (hue, saturation, brightness) {
	        hue = (parseInt(hue, 10) || 0) % 360;
	        saturation = parseInt(saturation, 10) / 100;
	        brightness = parseInt(brightness, 10) / 100;
	        saturation = max(0, min(saturation, 1));
	        brightness = max(0, min(brightness, 1));
	        if (saturation === 0) {
	          r = g = b = round(255 * brightness);
	          return;
	        }
	        var side = hue / 60;
	        var chroma = brightness * saturation;
	        var x = chroma * (1 - Math.abs(side % 2 - 1));
	        var match = brightness - chroma;
	        switch (Math.floor(side)) {
	        case 0:
	          r = chroma;
	          g = x;
	          b = 0;
	          break;
	        case 1:
	          r = x;
	          g = chroma;
	          b = 0;
	          break;
	        case 2:
	          r = 0;
	          g = chroma;
	          b = x;
	          break;
	        case 3:
	          r = 0;
	          g = x;
	          b = chroma;
	          break;
	        case 4:
	          r = x;
	          g = 0;
	          b = chroma;
	          break;
	        case 5:
	          r = chroma;
	          g = 0;
	          b = x;
	          break;
	        default:
	          r = g = b = 0;
	        }
	        r = round(255 * (r + match));
	        g = round(255 * (g + match));
	        b = round(255 * (b + match));
	      };
	      var toHex = function () {
	        var hex = function (val) {
	          val = parseInt(val, 10).toString(16);
	          return val.length > 1 ? val : '0' + val;
	        };
	        return '#' + hex(r) + hex(g) + hex(b);
	      };
	      var toRgb = function () {
	        return {
	          r: r,
	          g: g,
	          b: b
	        };
	      };
	      var toHsv = function () {
	        return rgb2hsv(r, g, b);
	      };
	      var parse = function (value) {
	        var matches;
	        if (typeof value === 'object') {
	          if ('r' in value) {
	            r = value.r;
	            g = value.g;
	            b = value.b;
	          } else if ('v' in value) {
	            hsvToRgb(value.h, value.s, value.v);
	          }
	        } else {
	          if (matches = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value)) {
	            r = parseInt(matches[1], 10);
	            g = parseInt(matches[2], 10);
	            b = parseInt(matches[3], 10);
	          } else if (matches = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value)) {
	            r = parseInt(matches[1], 16);
	            g = parseInt(matches[2], 16);
	            b = parseInt(matches[3], 16);
	          } else if (matches = /#([0-F])([0-F])([0-F])/gi.exec(value)) {
	            r = parseInt(matches[1] + matches[1], 16);
	            g = parseInt(matches[2] + matches[2], 16);
	            b = parseInt(matches[3] + matches[3], 16);
	          }
	        }
	        r = r < 0 ? 0 : r > 255 ? 255 : r;
	        g = g < 0 ? 0 : g > 255 ? 255 : g;
	        b = b < 0 ? 0 : b > 255 ? 255 : b;
	        return self;
	      };
	      if (value) {
	        parse(value);
	      }
	      self.toRgb = toRgb;
	      self.toHsv = toHsv;
	      self.toHex = toHex;
	      self.parse = parse;
	      return self;
	    };
	
	    var serialize = function (obj) {
	      var data = JSON.stringify(obj);
	      if (!isString$1(data)) {
	        return data;
	      }
	      return data.replace(/[\u0080-\uFFFF]/g, function (match) {
	        var hexCode = match.charCodeAt(0).toString(16);
	        return '\\u' + '0000'.substring(hexCode.length) + hexCode;
	      });
	    };
	    var JSONUtils = {
	      serialize: serialize,
	      parse: function (text) {
	        try {
	          return JSON.parse(text);
	        } catch (ex) {
	        }
	      }
	    };
	
	    var JSONP = {
	      callbacks: {},
	      count: 0,
	      send: function (settings) {
	        var self = this, dom = DOMUtils.DOM, count = settings.count !== undefined ? settings.count : self.count;
	        var id = 'tinymce_jsonp_' + count;
	        self.callbacks[count] = function (json) {
	          dom.remove(id);
	          delete self.callbacks[count];
	          settings.callback(json);
	        };
	        dom.add(dom.doc.body, 'script', {
	          id: id,
	          src: settings.url,
	          type: 'text/javascript'
	        });
	        self.count++;
	      }
	    };
	
	    var XHR = __assign(__assign({}, Observable), {
	      send: function (settings) {
	        var xhr, count = 0;
	        var ready = function () {
	          if (!settings.async || xhr.readyState === 4 || count++ > 10000) {
	            if (settings.success && count < 10000 && xhr.status === 200) {
	              settings.success.call(settings.success_scope, '' + xhr.responseText, xhr, settings);
	            } else if (settings.error) {
	              settings.error.call(settings.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', xhr, settings);
	            }
	            xhr = null;
	          } else {
	            Delay.setTimeout(ready, 10);
	          }
	        };
	        settings.scope = settings.scope || this;
	        settings.success_scope = settings.success_scope || settings.scope;
	        settings.error_scope = settings.error_scope || settings.scope;
	        settings.async = settings.async !== false;
	        settings.data = settings.data || '';
	        XHR.fire('beforeInitialize', { settings: settings });
	        xhr = new XMLHttpRequest();
	        if (xhr.overrideMimeType) {
	          xhr.overrideMimeType(settings.content_type);
	        }
	        xhr.open(settings.type || (settings.data ? 'POST' : 'GET'), settings.url, settings.async);
	        if (settings.crossDomain) {
	          xhr.withCredentials = true;
	        }
	        if (settings.content_type) {
	          xhr.setRequestHeader('Content-Type', settings.content_type);
	        }
	        if (settings.requestheaders) {
	          Tools.each(settings.requestheaders, function (header) {
	            xhr.setRequestHeader(header.key, header.value);
	          });
	        }
	        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        xhr = XHR.fire('beforeSend', {
	          xhr: xhr,
	          settings: settings
	        }).xhr;
	        xhr.send(settings.data);
	        if (!settings.async) {
	          return ready();
	        }
	        Delay.setTimeout(ready, 10);
	      }
	    });
	
	    var extend = Tools.extend;
	    var JSONRequest = function () {
	      function JSONRequest(settings) {
	        this.settings = extend({}, settings);
	        this.count = 0;
	      }
	      JSONRequest.sendRPC = function (o) {
	        return new JSONRequest().send(o);
	      };
	      JSONRequest.prototype.send = function (args) {
	        var ecb = args.error, scb = args.success;
	        var xhrArgs = extend(this.settings, args);
	        xhrArgs.success = function (c, x) {
	          c = JSONUtils.parse(c);
	          if (typeof c === 'undefined') {
	            c = { error: 'JSON Parse error.' };
	          }
	          if (c.error) {
	            ecb.call(xhrArgs.error_scope || xhrArgs.scope, c.error, x);
	          } else {
	            scb.call(xhrArgs.success_scope || xhrArgs.scope, c.result);
	          }
	        };
	        xhrArgs.error = function (ty, x) {
	          if (ecb) {
	            ecb.call(xhrArgs.error_scope || xhrArgs.scope, ty, x);
	          }
	        };
	        xhrArgs.data = JSONUtils.serialize({
	          id: args.id || 'c' + this.count++,
	          method: args.method,
	          params: args.params
	        });
	        xhrArgs.content_type = 'application/json';
	        XHR.send(xhrArgs);
	      };
	      return JSONRequest;
	    }();
	
	    var create = function () {
	      return function () {
	        var data = {};
	        var keys = [];
	        var storage = {
	          getItem: function (key) {
	            var item = data[key];
	            return item ? item : null;
	          },
	          setItem: function (key, value) {
	            keys.push(key);
	            data[key] = String(value);
	          },
	          key: function (index) {
	            return keys[index];
	          },
	          removeItem: function (key) {
	            keys = keys.filter(function (k) {
	              return k === key;
	            });
	            delete data[key];
	          },
	          clear: function () {
	            keys = [];
	            data = {};
	          },
	          length: 0
	        };
	        Object.defineProperty(storage, 'length', {
	          get: function () {
	            return keys.length;
	          },
	          configurable: false,
	          enumerable: false
	        });
	        return storage;
	      }();
	    };
	
	    var localStorage;
	    try {
	      var test = '__storage_test__';
	      localStorage = window.localStorage;
	      localStorage.setItem(test, test);
	      localStorage.removeItem(test);
	    } catch (e) {
	      localStorage = create();
	    }
	    var LocalStorage = localStorage;
	
	    var publicApi = {
	      geom: { Rect: Rect },
	      util: {
	        Promise: promiseObj,
	        Delay: Delay,
	        Tools: Tools,
	        VK: VK,
	        URI: URI,
	        Class: Class,
	        EventDispatcher: EventDispatcher,
	        Observable: Observable,
	        I18n: I18n,
	        XHR: XHR,
	        JSON: JSONUtils,
	        JSONRequest: JSONRequest,
	        JSONP: JSONP,
	        LocalStorage: LocalStorage,
	        Color: Color,
	        ImageUploader: ImageUploader
	      },
	      dom: {
	        EventUtils: EventUtils,
	        Sizzle: Sizzle,
	        DomQuery: DomQuery,
	        TreeWalker: DomTreeWalker,
	        TextSeeker: TextSeeker,
	        DOMUtils: DOMUtils,
	        ScriptLoader: ScriptLoader,
	        RangeUtils: RangeUtils,
	        Serializer: DomSerializer,
	        StyleSheetLoader: StyleSheetLoader,
	        ControlSelection: ControlSelection,
	        BookmarkManager: BookmarkManager,
	        Selection: EditorSelection,
	        Event: EventUtils.Event
	      },
	      html: {
	        Styles: Styles,
	        Entities: Entities,
	        Node: AstNode,
	        Schema: Schema,
	        SaxParser: SaxParser,
	        DomParser: DomParser,
	        Writer: Writer,
	        Serializer: HtmlSerializer
	      },
	      Env: Env,
	      AddOnManager: AddOnManager,
	      Annotator: Annotator,
	      Formatter: Formatter,
	      UndoManager: UndoManager,
	      EditorCommands: EditorCommands,
	      WindowManager: WindowManager,
	      NotificationManager: NotificationManager,
	      EditorObservable: EditorObservable,
	      Shortcuts: Shortcuts,
	      Editor: Editor,
	      FocusManager: FocusManager,
	      EditorManager: EditorManager,
	      DOM: DOMUtils.DOM,
	      ScriptLoader: ScriptLoader.ScriptLoader,
	      PluginManager: PluginManager,
	      ThemeManager: ThemeManager,
	      IconManager: IconManager,
	      Resource: Resource,
	      trim: Tools.trim,
	      isArray: Tools.isArray,
	      is: Tools.is,
	      toArray: Tools.toArray,
	      makeMap: Tools.makeMap,
	      each: Tools.each,
	      map: Tools.map,
	      grep: Tools.grep,
	      inArray: Tools.inArray,
	      extend: Tools.extend,
	      create: Tools.create,
	      walk: Tools.walk,
	      createNS: Tools.createNS,
	      resolve: Tools.resolve,
	      explode: Tools.explode,
	      _addCacheSuffix: Tools._addCacheSuffix,
	      isOpera: Env.opera,
	      isWebKit: Env.webkit,
	      isIE: Env.ie,
	      isGecko: Env.gecko,
	      isMac: Env.mac
	    };
	    var tinymce = Tools.extend(EditorManager, publicApi);
	
	    var exportToModuleLoaders = function (tinymce) {
	      if (true) {
	        try {
	          module.exports = tinymce;
	        } catch (_) {
	        }
	      }
	    };
	    var exportToWindowGlobal = function (tinymce) {
	      window.tinymce = tinymce;
	      window.tinyMCE = tinymce;
	    };
	    exportToWindowGlobal(tinymce);
	    exportToModuleLoaders(tinymce);
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(512).setImmediate))

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/Ryan-Taylor-Green-Tick.svg";

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAC1ElEQVR42r2XXagNURTHJ1/lmyhSihfiTSFFSL4e8IZEPHmYPefM7LX3nDnn3Lgm5SvyVR7uI/eFwwORp6vweETdF4oUeaMUyiP+/3Pcmtsdx5w5ndm12jOz11q/vdbsWXuPk7dpHc9TOlrF3ulnGxoamuoFdrMK5LIbyFsVmJ/Kl2/KN2/Y8x7yrjUusoX6PUPjOJ6mtD0E4EfXN6/QDzLaMAxnJvV4X7Z2NccxgZeY1Afa0T4XOAiilXA0ioiaZWM2dGNLfdrRnn66ApcCuwvp/AwHB3vJHO3bfuy6TAZ8t64vv2CwKT82GYjZB3+/vcDs+V+61lCxLLK+k161Wp1LPbzjx5kmINFaNzBf6D894np9AVL0SYnszpDO44RTMr8Cqeykf3ImDmpzGk5vZnWGSKrtd5m90T854x9WKovxKX1Vxix1+tjonxzyElHIICK54hTQyEEdOJVMR7Okw21FwMkhr30TRUv4LTYajckZq94MJeFeimfMim7h5JBHruNKuB1pf5K98g0sQuoeUrjacxafEdSTHbw4ChnO46QH+DC5uLA1zzdni4Qj02cQ+YCjfBsAfr3gyK952mgu/f2Qe4XCfbnrSXjA4eYPJ88LjvwZPrmtjohMR+Tf3VptfhFwHrsQ+Q9yx9JwHxM4UgRcaXsYrAfjdilOoAg4OeQlq9YULP/3LH39hNM/OeRNOPJAmv2DkyEvuMrTavYkDD5C0bnRwVixLoyJW7a3k/cc7zDRW/RPTqpCFEWzofDa1aaeCtfmgtJy9V/C8TQ7bqHMEv2ngpPHKSpiRTac3huzda51PIvjWdnO3XE8h4UARndKYbg8D5R2XiAnEPVTBtT1LxI3nNaxJ7CXtK4ty2JHPQAv0o72Pf06WWsXcuNpH/5llNFwO+R+zF8k9p5vjwF4kuPU48ZBu7zM1K+hpCsbsRbO/92PR7g42XMl8znHqZfV5x/KorO2TeGZBwAAAABJRU5ErkJggg=="

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAzMzY2Ij48cGF0aCBkPSJNNDQwLTQ0MHYtMTYwaDgwdjgwaDgwdjgwSDQ0MFptMjgwIDB2LTgwaDgwdi04MGg4MHYxNjBINzIwWk00NDAtNzIwdi0xNjBoMTYwdjgwaC04MHY4MGgtODBabTM2MCAwdi04MGgtODB2LTgwaDE2MHYxNjBoLTgwWk0xMzYtODBsLTU2LTU2IDIyNC0yMjRIMTIwdi04MGgzMjB2MzIwaC04MHYtMTg0TDEzNi04MFoiLz48L3N2Zz4="

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAADNUlEQVR42rVXa6gNURQejyRvyi8pUihCSimhKPmDkMcPRIiZOWf2Y2bOOTfUlK5H5JUoJUnEIY9CHn8Iv6TII4kS0g155Qe/ju/rus091zn3zp45d9VuzpnZe33rW3utvda2TCWKop52qTTUVcUJrqfnel4wUSk1rFwu97K6Q/JRNMj11EpH6LO20D8xvjtCvbA9ddv29HP8/sb3jqfO47mKxmUGLRaLg6HYh9JPeF51pb+BiuvNhTHrMPcyxhdb6iYpoyHp2Go9HUzfUVk+DMeYrHW0HgkPlDE+uMKfZQQMhqvJ1lZqtpVBSIBewJYtTrQA1i7Dgt8MKKsB4mo9Fjr/YBt058Bgin2rCFEYZzVQpCyNsoX66Cg1v+YEpMsIBFWLI/xpVjeILYJJ3MpcEIyu5e79SJvDVjeKI/VuBPGx/9wC4K/5pqbhWQFyQi8EkdOFQmFgx29MPXz7nPP98e1Y+9vxclcmVipYgG17RNeC3d268zy9jV6OXwj1JCfDGVlA4bnHYL0U4O87ixtHhlMw97VFYQDwMKhUKj3SgjKPud72/M2I6utdrSU4UxlKwnk8o7OA/is4fbpiHXtaX3Kkv4QRuBZ/TqYDjSUR6zizjrhSu5Yr1FYGXFpQU9YUzCuhHO+wbOnna+U3azWYvEF0vmW14unXfqRjHec7DbAYoXD7xRr7co+1mmnTcQDoJZ4bjVnHuk9hrLHyKpwJdg8MT6otMKA5DWsKjL3Jc77N8h883UzB07DmyQfWv4Ig6N9myTkE1XpT8FSshV6Bca26eRD6lgk4jN1pyprCzghYm6o6Uih7xrRKDq5PmLLOyWAOMwh4vatTSwWLkPxPk7TALA5sOoxZC/WQXXC9/TjDcpjghLrAdtkEmGt4rNarIXR/X1oHRnutBgrjg55ihHeZCpwI196JrUwnXO9IdQD7/ArE+iVaRA/ATVeYAWh/J6cBZsnkRQN6bvBCYW61UD5GC7xw3JXh1CTraCzWHGVHw1tLpjucE0UDkFoRXcemA4r3oRxKZMdydj+tfb4vYOAeFiGmEkYz73dWI4WNH8CK2I6DrZdCdZ9RjAp4iFWKN1YTfX8BRE0SdQ7f3g8AAAAASUVORK5CYII="

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/a-people_2x.png";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/autorenew.svg";

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAhCAYAAAC4JqlRAAAAAXNSR0IArs4c6QAAARdJREFUWAnFmA0OgyAMhT2GO8Zu4wF2Wb2LyS6wsFcDiRIo/REhaWC0fd9DzRY3hRBmxAfxmh4axIrMecJiRdDYEe/eHogRWZjCSgY2WsXR1QQYZzghNzKQb3YxwXLY5A33RKQvKjKYUemqigVmTHqmpoIZl46rGWa8/cd5rCLWvsJF1J/kVnhyJBWV1iVd1dwSb+VVsFpxDVLbr+m49guwL/Yo0ujyNX4xDVL+2/EcPDkBcUH8Ejmul5TvOgM27goU4M89AwX48cDV9m+9DS1IK+8yIxWX1qnMaEW19awZq5i172LGK+LqdzWfjmHSMTWdoPlSpacqzknMZ5GuqIiBtFKsPptsKSvyVQ4Sw98Nh78dD/1/4A/3xRrqk1BCQQAAAABJRU5ErkJggg=="

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/corner.svg";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-agenda.svg";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-automotive.svg";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-b2b.svg";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-claims.svg";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-clients.svg";

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDIyIDMwIiBmaWxsPSIjQkNCQ0JDIj4KICAgIDxwYXRoIGQ9Ik0xNC41IDcuNXYtN2w3IDdoLTd6bTcuMzUtLjM1bC03LTdjLS4xLS4xLS4yMi0uMTUtLjM1LS4xNUguNUMuMjIgMCAwIC4yMiAwIC41djI5YzAgLjI3LjIyLjUuNS41aDIxYy4yOCAwIC41LS4yMy41LS41di0yMmMwLS4xMy0uMDUtLjI2LS4xNS0uMzV6Ij48L3BhdGg+Cjwvc3ZnPg=="

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-credit.svg";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-dsdocuments-blue.svg";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-dsdocuments-green.svg";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-dsdocuments.svg";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-family.svg";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-faq.svg";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-fire.svg";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-generali.svg";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-health.svg";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-home.svg";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-inbox-blue.svg";

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-inbox.svg";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-info.svg";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-life.svg";

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAzMzY2IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUpIj48cGF0aCBkPSJNNDMyLjMxLTI5OC40NkgyODEuNTRxLTc1LjM0IDAtMTI4LjQ0LTUzLjFRMTAwLTQwNC42NSAxMDAtNDc5Ljk4cTAtNzUuMzMgNTMuMS0xMjguNDQgNTMuMS01My4xMiAxMjguNDQtNTMuMTJoMTUwLjc3djYwSDI4MS41NHEtNTAuMzkgMC04NS45NiAzNS41OFExNjAtNTMwLjM4IDE2MC00ODBxMCA1MC4zOCAzNS41OCA4NS45NiAzNS41NyAzNS41OCA4NS45NiAzNS41OGgxNTAuNzd2NjBaTTMzMC00NTB2LTYwaDMwMHY2MEgzMzBabTE5Ny42OSAxNTEuNTR2LTYwaDE1MC43N3E1MC4zOSAwIDg1Ljk2LTM1LjU4UTgwMC00MjkuNjIgODAwLTQ4MHEwLTUwLjM4LTM1LjU4LTg1Ljk2LTM1LjU3LTM1LjU4LTg1Ljk2LTM1LjU4SDUyNy42OXYtNjBoMTUwLjc3cTc1LjM0IDAgMTI4LjQ0IDUzLjFRODYwLTU1NS4zNSA4NjAtNDgwLjAycTAgNzUuMzMtNTMuMSAxMjguNDQtNTMuMSA1My4xMi0xMjguNDQgNTMuMTJINTI3LjY5WiIvPjwvc3ZnPg=="

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-links.svg";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-logout.svg";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-misc.svg";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-news.svg";

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-office.svg";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-outbox.svg";

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-outline-location_on-24px.svg";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-production.svg";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-tasklist.svg";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-transport.svg";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-webapps.svg";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-willdoc.svg";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/icn-workinjuries.svg";

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiPjxwYXRoIGZpbGw9IiNmNDQzMzYiIGQ9Ik00NCwyNGMwLDExLjA0NS04Ljk1NSwyMC0yMCwyMFM0LDM1LjA0NSw0LDI0UzEyLjk1NSw0LDI0LDRTNDQsMTIuOTU1LDQ0LDI0eiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0yOS42NTYsMTUuNTE2bDIuODI4LDIuODI4bC0xNC4xNCwxNC4xNGwtMi44MjgtMi44MjhMMjkuNjU2LDE1LjUxNnoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMzIuNDg0LDI5LjY1NmwtMi44MjgsMi44MjhsLTE0LjE0LTE0LjE0bDIuODI4LTIuODI4TDMyLjQ4NCwyOS42NTZ6Ii8+PC9zdmc+"

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-agenda.svg";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-b2b.svg";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-claims.svg";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-clients.svg";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-dsdocuments.svg";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-faq.svg";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-generali.svg";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-inbox-blue.svg";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-inbox.svg";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-links.svg";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-news.svg";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-office.svg";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-outbox.svg";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-production.svg";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-tasklist.svg";

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCAzLjguMyAoMjk4MDIpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmljbi13ZWJhcHBzPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Imljbi13ZWJhcHBzIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlN0cm9rZS00MzEiIHBvaW50cz0iMTAuNSAxMC41IDAuNSAxMC41IDAuNSAwLjUgMTAuNSAwLjUiPjwvcG9seWdvbj4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlN0cm9rZS00MzIiIHBvaW50cz0iMjMuNSAxMC41IDEzLjUgMTAuNSAxMy41IDAuNSAyMy41IDAuNSI+PC9wb2x5Z29uPgogICAgICAgICAgICA8cG9seWdvbiBpZD0iU3Ryb2tlLTQzMyIgcG9pbnRzPSIxMC41IDIzLjUgMC41IDIzLjUgMC41IDEzLjUgMTAuNSAxMy41Ij48L3BvbHlnb24+CiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJTdHJva2UtNDM0IiBwb2ludHM9IjIzLjUgMjMuNSAxMy41IDIzLjUgMTMuNSAxMy41IDIzLjUgMTMuNSI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-willdoc.svg";

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAbCAYAAAAH+20UAAAAAXNSR0IArs4c6QAAAG1JREFUWAntljEKgEAMBHMWVj7XL1ja6FO1sombzg8EVpjAwl1zDJPidmTmFhGrMivO8whuHwK+dFicST9s96TLqRS9+xTj4Q4JHwYwgAEMmBmor5ku0bgUukSjXJ7GAAYwgAEHA3SJ5i38r0u8aUgosU0RBjgAAAAASUVORK5CYII="

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/person_search_green.svg";

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAXCAYAAAA/ZK6/AAAAAXNSR0IArs4c6QAAAWNJREFUOBGNlEtOwzAQQMdOFl20/K7ABRAIBAKxaJu2KYuqzR24FGdIqy4g6ZcNCASCXgTxX3QRe5ip5CqlSVovYnv8nj22kwCsWRBRMDp7rHK6vdG5UtrPQWHXXgW3g8FZpPU1AOanlsrJLKHbH58iQACIecOlrtAOhicqUgHPbGCuEwX/ZnAMoEOavRCHub2UUiccHdFRhIiw8R9eEvxgeKhR9ynnzSR4Qej0xgcCMRNmYbYHPxzto4oGlPNW2swmLjv92z1AxfC2CWbVto6iKwJ2sqD4mKScLulU3uPBrLZs1J0JCMuhl+ojCzRjs3vwaqVXYdkkiU8zkFbPL65ZLb6gEBUQ4isN5vhc4I7nlp+lkBUh4Jv7SWVBYKBZKz3Rt1JNk5YElry680iL12hPP9yPl0SBgZZbfrBsy6U9/a4lMNSoFO/puBek1BXMrC3XubOlvKD03nLKmpr4ytr8Nf4Agb1tbz3ChzIAAAAASUVORK5CYII="

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	module.exports = {
	  indexOf: function (arr, item) {
	    var i, j;
	    if (Array.prototype.indexOf) {
	      return arr.indexOf(item);
	    }
	    for (i = 0, j = arr.length; i < j; i++) {
	      if (arr[i] === item) {
	        return i;
	      }
	    }
	    return -1;
	  },
	  forEach: function (arr, fn, scope) {
	    var i, j;
	    if (Array.prototype.forEach) {
	      return arr.forEach(fn, scope);
	    }
	    for (i = 0, j = arr.length; i < j; i++) {
	      fn.call(scope, arr[i], i, arr);
	    }
	  },
	  trim: function (str) {
	    if (String.prototype.trim) {
	      return str.trim();
	    }
	    return str.replace(/(^\s*)|(\s*$)/g, "");
	  },
	  spaceIndex: function (str) {
	    var reg = /\s|\n|\t/;
	    var match = reg.exec(str);
	    return match ? match.index : -1;
	  },
	};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./BE_Logo_OVB_Willemot_Blue_cmyk.svg": 171,
		"./BE_Logo_OVB_Willemot_White.svg": 354,
		"./Ryan-Taylor-Green-Tick.svg": 527,
		"./a-edit_1x_blue.svg": 355,
		"./a-jump-ovbblue.svg": 529,
		"./a-open_with-green.svg": 955,
		"./a-trash_1x_ovbBlue.svg": 79,
		"./autorenew.svg": 532,
		"./autorenew_white.svg": 959,
		"./baseline-direct-Sign24px-green.svg": 960,
		"./baseline-reply-24px-green.svg": 961,
		"./baseline-reply-to-willemot-24px-green.svg": 962,
		"./baseline-send-reminder-24px-green.svg": 963,
		"./corner.svg": 534,
		"./create-24px.svg": 974,
		"./ic_delete_forever_black_24px.svg": 977,
		"./ic_do_not_disturb_black_24px.svg": 261,
		"./ic_done_gray_32px.svg": 978,
		"./ic_done_green_32px.svg": 979,
		"./ic_done_white_32px.svg": 980,
		"./icn-agenda.svg": 535,
		"./icn-automotive.svg": 536,
		"./icn-b2b.svg": 537,
		"./icn-claimWizard-white.svg": 356,
		"./icn-claims.svg": 538,
		"./icn-clients.svg": 539,
		"./icn-contracts.svg": 540,
		"./icn-credit.svg": 541,
		"./icn-dsdocuments-blue.svg": 542,
		"./icn-dsdocuments-green.svg": 543,
		"./icn-dsdocuments-white.svg": 357,
		"./icn-dsdocuments.svg": 544,
		"./icn-family.svg": 545,
		"./icn-faq.svg": 546,
		"./icn-fire.svg": 547,
		"./icn-generali.svg": 548,
		"./icn-health.svg": 549,
		"./icn-home.svg": 550,
		"./icn-inbox-blue.svg": 551,
		"./icn-inbox-white.svg": 358,
		"./icn-inbox.svg": 552,
		"./icn-info.svg": 553,
		"./icn-life.svg": 554,
		"./icn-link_1x_blue.svg": 555,
		"./icn-links.svg": 556,
		"./icn-logout.svg": 557,
		"./icn-misc.svg": 558,
		"./icn-news.svg": 559,
		"./icn-no-result.svg": 23,
		"./icn-office.svg": 560,
		"./icn-outbox.svg": 561,
		"./icn-outline-location_on-24px.svg": 562,
		"./icn-production.svg": 563,
		"./icn-tasklist.svg": 564,
		"./icn-transport.svg": 565,
		"./icn-webapps.svg": 566,
		"./icn-willdoc.svg": 567,
		"./icn-workinjuries.svg": 568,
		"./icon-cancel.svg": 569,
		"./m-agenda.svg": 570,
		"./m-b2b.svg": 571,
		"./m-claims.svg": 572,
		"./m-clients.svg": 573,
		"./m-dsdocuments.svg": 574,
		"./m-faq.svg": 575,
		"./m-generali.svg": 576,
		"./m-inbox-blue.svg": 577,
		"./m-inbox.svg": 578,
		"./m-links.svg": 579,
		"./m-logout.svg": 359,
		"./m-news.svg": 580,
		"./m-office.svg": 581,
		"./m-outbox.svg": 582,
		"./m-production.svg": 583,
		"./m-tasklist.svg": 584,
		"./m-webapps.svg": 585,
		"./m-willdoc.svg": 586,
		"./notification-bell.svg": 1000,
		"./person_search_green.svg": 588,
		"./print-black-18dp.svg": 360,
		"./print-white-18dp.svg": 1007,
		"./recycle.svg": 1009
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 591;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./m-agenda.svg": 570,
		"./m-b2b.svg": 571,
		"./m-claims.svg": 572,
		"./m-clients.svg": 573,
		"./m-dsdocuments.svg": 574,
		"./m-faq.svg": 575,
		"./m-generali.svg": 576,
		"./m-inbox-blue.svg": 577,
		"./m-inbox.svg": 578,
		"./m-links.svg": 579,
		"./m-logout.svg": 359,
		"./m-news.svg": 580,
		"./m-office.svg": 581,
		"./m-outbox.svg": 582,
		"./m-production.svg": 583,
		"./m-tasklist.svg": 584,
		"./m-webapps.svg": 585,
		"./m-willdoc.svg": 586
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 592;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _BrokerSelectorScss = __webpack_require__(714);
	
	var _BrokerSelectorScss2 = _interopRequireDefault(_BrokerSelectorScss);
	
	var _stateActions = __webpack_require__(5);
	
	var BrokerSelector = (function (_React$Component) {
		_inherits(BrokerSelector, _React$Component);
	
		_createClass(BrokerSelector, null, [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				setBrNr: _react2['default'].PropTypes.func.isRequired,
				brokers: _react2['default'].PropTypes.object.isRequired,
				brNr: _react2['default'].PropTypes.string.isRequired,
				customClass: _react2['default'].PropTypes.string,
				disabled: _react2['default'].PropTypes.bool,
				hasInternalAccess: _react2['default'].PropTypes.bool
			},
			enumerable: true
		}]);
	
		function BrokerSelector(props) {
			var _this = this;
	
			_classCallCheck(this, _BrokerSelector);
	
			_get(Object.getPrototypeOf(_BrokerSelector.prototype), 'constructor', this).call(this, props);
	
			this.searchForBroker = function callee$2$0() {
				var brokerInputVal, dispatch, brokerInfoRes;
				return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
					while (1) switch (context$3$0.prev = context$3$0.next) {
						case 0:
							brokerInputVal = this.state.brokerInputVal;
							dispatch = this.props.dispatch;
							context$3$0.next = 4;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.getBrokerInfo)(brokerInputVal)));
	
						case 4:
							brokerInfoRes = context$3$0.sent;
	
						case 5:
						case 'end':
							return context$3$0.stop();
					}
				}, null, _this);
			};
	
			this.state = {
				brokerInputVal: props.brNr
			};
		}
	
		_createClass(BrokerSelector, [{
			key: 'updateBroker',
			value: function updateBroker(brNr) {
				var _props = this.props;
				var dispatch = _props.dispatch;
				var setBrNr = _props.setBrNr;
	
				dispatch(setBrNr(brNr));
			}
		}, {
			key: 'getIcon',
			value: function getIcon() {
				return __webpack_require__(588);
			}
		}, {
			key: 'renderSelector',
			value: function renderSelector() {
				var _this2 = this;
	
				var _props2 = this.props;
				var brNr = _props2.brNr;
				var brokers = _props2.brokers;
				var disabled = _props2.disabled;
	
				var brokerIds = Object.keys(brokers);
				var options = brokerIds.map(function (id) {
					return {
						label: id,
						value: id
					};
				});
				return brokerIds.length > 1 ? _react2['default'].createElement(_componentsSharedSelectSelectWrap.SelectWrapper, {
					value: brNr,
					options: options,
					isDisabled: disabled,
					onChange: function (item) {
						return _this2.updateBroker(item.value);
					},
					className: _BrokerSelectorScss2['default'].brokerSelector
				}) : _react2['default'].createElement(
					'span',
					null,
					brNr
				);
			}
		}, {
			key: 'renderBrokerSearch',
	
			// }
			value: function renderBrokerSearch() {
				var _this3 = this;
	
				//require oracle procedure to continue
				var brokerInputVal = this.state.brokerInputVal;
	
				return _react2['default'].createElement(
					'div',
					{ onSubmit: function (ev) {
							ev.preventDefault();
							return _this3.searchForBroker();
						}, className: _BrokerSelectorScss2['default'].brokerSearch },
					_react2['default'].createElement('input', { type: 'text', value: brokerInputVal, onChange: function (ev) {
							ev.preventDefault();
							_this3.setState({ brokerInputVal: ev.target.value });
						} }),
					_react2['default'].createElement('img', { src: this.getIcon(), onClick: this.searchForBroker })
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props3 = this.props;
				var customClass = _props3.customClass;
				var hasInternalAccess = _props3.hasInternalAccess;
	
				return _react2['default'].createElement(
					'span',
					{ className: '' + customClass },
					hasInternalAccess ? this.renderBrokerSearch() : this.renderSelector()
				);
			}
		}]);
	
		var _BrokerSelector = BrokerSelector;
		BrokerSelector = (0, _reactRedux.connect)(function (state) {
			var hasInternalAccess = state.app.userTypeId === '1' || state.app.userTypeId === '3' ? true : false;
	
			return {
				hasInternalAccess: hasInternalAccess
			};
		})(BrokerSelector) || BrokerSelector;
		return BrokerSelector;
	})(_react2['default'].Component);
	
	exports['default'] = BrokerSelector;
	module.exports = exports['default'];

	// if (brokerInputVal && brokerInputVal.length > 3) {

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var customModalStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        whiteSpace: 'pre-wrap',
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        width: '60%',
	        height: 'auto'
	    }
	};
	
	exports.customModalStyles = customModalStyles;
	var selectInFocusWithin = false;
	var customCreatableSelectStyles = {
	    control: function control(base, state) {
	        selectInFocusWithin = state.isFocused;
	        return _extends({}, base, {
	            flex: "4",
	            fontSize: "12px",
	            display: "flex",
	            justifyContent: "flex-end",
	            alignItems: "flex-end",
	            color: "#000",
	            backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
	            borderColor: "#d9d9d9 #ccc #b3b3b3",
	            borderRadius: "2px",
	            border: "1px solid #d9d9d9",
	            minHeight: "25px",
	            maxHeight: "auto",
	            //height: state.isFocused ? "auto" : "25px",
	            boxShadow: state.isFocused ? null : null,
	            "&:hover": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            "&:focus": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            padding: 0,
	            margin: 0,
	            overflow: state.isFocused ? null : "hidden"
	        });
	    },
	    menu: function menu(base) {
	        return _extends({}, base, {
	            borderRadius: 2,
	            hyphens: "auto",
	            marginTop: 0,
	            textAlign: "left",
	            wordWrap: "break-word"
	        });
	    },
	    menuList: function menuList(base) {
	        return _extends({}, base, {
	            padding: 0,
	            verticalAlign: "baseline"
	        });
	    },
	    singleValue: function singleValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            color: "black"
	        });
	    },
	    multiValue: function multiValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            maxHeight: "18px",
	            border: "0.5px solid #388957",
	            background: '#46b270',
	            color: "black",
	            div: {
	                color: "black",
	                fontSize: '1.2em',
	                lineHeight: '0.8em'
	            }
	        });
	    },
	    /* noOptionsMessage: (base, state) => ({
	        ...base,
	        padding: 0,
	        height: "20px",
	        lineHeight: "16px"
	    }), */
	    option: function option(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            fontSize: '1em',
	            maxHeight: "25px"
	        });
	    },
	    valueContainer: function valueContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            top: 0
	        });
	    },
	    multiValueRemove: function multiValueRemove(base, state) {
	        return _extends({}, base, {
	            display: state.isDisabled ? "none" : null,
	            padding: 0
	        });
	    },
	    clearIndicator: function clearIndicator(base, state) {
	        return _extends({}, base, {
	            padding: 0
	        });
	    },
	    dropdownIndicator: function dropdownIndicator(base, state) {
	        return _extends({}, base, {
	            marginTop: 0,
	            padding: 0
	        });
	    },
	    indicatorsContainer: function indicatorsContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "23px",
	            top: 0
	        });
	    },
	    indicatorSeparator: function indicatorSeparator(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "0",
	            top: 0
	        });
	    },
	    group: function group(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            top: 0
	        });
	    },
	    groupHeading: function groupHeading(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            top: 0
	        });
	    },
	    input: function input(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: "2px 0 0 0",
	            height: "20px",
	            top: 0,
	            fontSize: '1.2em',
	            lineHeight: '0.8em',
	            width: selectInFocusWithin ? '100%!important' : 'auto',
	            div: {
	                width: selectInFocusWithin ? '100%!important' : 'auto',
	                input: {
	                    width: selectInFocusWithin ? '100%!important' : 'auto'
	                }
	            }
	        });
	    },
	    noOptionsMessage: function noOptionsMessage(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            fontSize: '1em'
	        });
	    },
	    placeholder: function placeholder(base, state) {
	        return _extends({}, base, {
	            fontSize: '1.1em',
	            lineHeight: '1.1em'
	        });
	    }
	};
	exports.customCreatableSelectStyles = customCreatableSelectStyles;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _slicedToArray=(function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n = (_s = _i.next()).done);_n = true) {_arr.push(_s.value);if(i && _arr.length === i)break;}}catch(err) {_d = true;_e = err;}finally {try{if(!_n && _i['return'])_i['return']();}finally {if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else {throw new TypeError('Invalid attempt to destructure non-iterable instance');}};})();var _extends=Object.assign || function(target){for(var i=1;i < arguments.length;i++) {var source=arguments[i];for(var key in source) {if(Object.prototype.hasOwnProperty.call(source,key)){target[key] = source[key];}}}return target;};var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();var _get=function get(_x34,_x35,_x36){var _again=true;_function: while(_again) {var object=_x34,property=_x35,receiver=_x36;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x34 = parent;_x35 = property;_x36 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireWildcard(obj){if(obj && obj.__esModule){return obj;}else {var newObj={};if(obj != null){for(var key in obj) {if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key] = obj[key];}}newObj['default'] = obj;return newObj;}}function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i < arr.length;i++) arr2[i] = arr[i];return arr2;}else {return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key] = value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(4);var _documentsScss=__webpack_require__(54);var _documentsScss2=_interopRequireDefault(_documentsScss);var _reactModal=__webpack_require__(15);var _reactModal2=_interopRequireDefault(_reactModal);var _libI18n=__webpack_require__(3);var _libI18n2=_interopRequireDefault(_libI18n);var _libHelpers=__webpack_require__(24);var _nestedProperty=__webpack_require__(10);var _nestedProperty2=_interopRequireDefault(_nestedProperty);var _documentsHelpers=__webpack_require__(106);var _stateActions=__webpack_require__(5);var _stateConstants=__webpack_require__(11);var c=_interopRequireWildcard(_stateConstants);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _stateActions2=__webpack_require__(5);var _DSWizardHelper=__webpack_require__(124);var _DSWizardHelper2=_interopRequireDefault(_DSWizardHelper);var _DSWizardFormControl=__webpack_require__(596);var _uuidV4=__webpack_require__(61);var _uuidV42=_interopRequireDefault(_uuidV4);var _moment=__webpack_require__(12);var _moment2=_interopRequireDefault(_moment);var _jsonBeautify=__webpack_require__(734);var _jsonBeautify2=_interopRequireDefault(_jsonBeautify);var _emailSenderEmailServerConfigDialog=__webpack_require__(367);var _emailSenderEmailServerConfigDialog2=_interopRequireDefault(_emailSenderEmailServerConfigDialog);var _AreYouSureModal=__webpack_require__(363);var _AreYouSureModal2=_interopRequireDefault(_AreYouSureModal);var _IntervalInfoPopup=__webpack_require__(1040);var _IntervalInfoPopup2=_interopRequireDefault(_IntervalInfoPopup);var _OpenDocumentToFillModal=__webpack_require__(598);var _OpenDocumentToFillModal2=_interopRequireDefault(_OpenDocumentToFillModal);var _handleSignaturePlaceholdersPopupOfSignaturePlaceholder=__webpack_require__(1048);var _handleSignaturePlaceholdersPopupOfSignaturePlaceholder2=_interopRequireDefault(_handleSignaturePlaceholdersPopupOfSignaturePlaceholder);var _WarningModal=__webpack_require__(599);var _WarningModal2=_interopRequireDefault(_WarningModal);var _UploadLocalDocumentUploadLocalDocumentButton=__webpack_require__(1042);var _UploadLocalDocumentUploadLocalDocumentButton2=_interopRequireDefault(_UploadLocalDocumentUploadLocalDocumentButton);var _SelectOracleDocumentOracleDocumentButton=__webpack_require__(1041);var _SelectOracleDocumentOracleDocumentButton2=_interopRequireDefault(_SelectOracleDocumentOracleDocumentButton);var _emailSenderAttachmentDialog=__webpack_require__(606);var _emailSenderAttachmentDialog2=_interopRequireDefault(_emailSenderAttachmentDialog);var _emailSenderEmailButton=__webpack_require__(108);var _emailSenderEmailButton2=_interopRequireDefault(_emailSenderEmailButton); // init translations
	var _=(0,_libI18n2['default'])('dswizard');var HALF_FILLED_PDF_API_URL="/api/getHalfFilledPdfForPrint";exports.HALF_FILLED_PDF_API_URL = HALF_FILLED_PDF_API_URL; /**
	 * Connect module to store
	 */ /**
	 * DSWizard class used to create dsDocuments.
	 */var DSWizard=(function(_Component){_inherits(DSWizard,_Component);_createClass(DSWizard,null,[{key:'propTypes',value:{step:_react.PropTypes.string,packageId:_react.PropTypes.string,callBackOnClose:_react.PropTypes.func,clientId:_react.PropTypes.string,contractId:_react.PropTypes.string,claimId:_react.PropTypes.string,claimNumber:_react.PropTypes.string,tarificationId:_react.PropTypes.string,tarificationNumber:_react.PropTypes.string,team:_react.PropTypes.string,teamName:_react.PropTypes.string,forceGetClient:_react.PropTypes.bool,customModalTitle1:_react.PropTypes.string,customModalTitle2:_react.PropTypes.string,customModalTitle3:_react.PropTypes.string,customModalDescriptionStep1:_react.PropTypes.string,customModalDescriptionStep2:_react.PropTypes.string,customModalDescriptionStep3:_react.PropTypes.string,subModuleKey:_react.PropTypes.string,stakeholders:_react.PropTypes.array,moduleOptions:_react.PropTypes.object,alienUserId:_react.PropTypes.string,ticketId:_react2['default'].PropTypes.string,ticketDocuments:_react2['default'].PropTypes.array,selectedTicketDocuments:_react2['default'].PropTypes.array,emailAttachmentTicketDocuments:_react2['default'].PropTypes.array,brokerFromOffice:_react2['default'].PropTypes.object}, /**
	     * Module constructor
	     *
	     *  Prepare the properties for the module, but must be initialised with values by init-Step1()
	     *  in case when there are already loaded the necessary values in store, the constructor can
	     *  prepare few of the initial values, but idf not the init-Step1() starts a flow, what will
	     *   fetch all te missing necessary values from database
	     * @param {*} props
	     */enumerable:true}]);function DSWizard(props){var _this=this;_classCallCheck(this,_DSWizard);_get(Object.getPrototypeOf(_DSWizard.prototype),'constructor',this).call(this,props);this.initStep1 = function callee$2$0(formInputs){var _props,dispatch,brokers,clientDataExt,client,templates,forceGetClient,DSDocumentsConfig,lang,brokersTeamWhiteList,subgroups,userId,DSDocumentOriginTypes,selectedTicketDocuments,alienUserId,userPhoneNumber,claimId,claimNumber,isOffice,claimWizardDocType,_state,brokerOptions,brokerEmailOptions,firstSignerEmailAddressOptions,clientId,packageId,clientGSMPhoneNumbers,brokerGSMPhoneNumbers,forceGetClientAffected,moduleKey,subModuleKey,teamSubgroupsOptions,dynamicFieldIdCursor,teamsOptions,stakeholders,clientNumber,contractId,isValidTheForm,clientOptionsDict,isPrem,languageOptions,documentTemplateOptions,tarificationId,tarificationNumber,contractDetails,signerAvailabilityOfTemplates,haveAvailableClaimTemplate,resultOFClaimAvailable,documentTemplates,getDsDocumentsAndPackagesResult,templateIds,packageDSDocuments,attachIdResult,selectedListsList,packageInstance,brokerNumber,detailedContractInfo,teamIndex,teamName,teamSubgroupId,brokerLoader,isClaimWizard,resultOfGetTeamSubgroups,theContract,contractNumber,clientLanguageWord,clientLanguage,i,result,_packageInstance,formInitialValues,newFormInputs,isItTarificationModule,isTarificationSubmodule,requiredOnPrem,createDefaultDocResult,rawFormValuesData,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,_step$value,key,value,upsertArguments,newPremPackage,_attachIdResult,_formInitialValues,requiredOnClaimWizard,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,_step2$value,_formInitialValues2,addSignersButtonFlags,isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:_props = this.props;dispatch = _props.dispatch;brokers = _props.brokers;clientDataExt = _props.clientDataExt;client = _props.client;templates = _props.templates;forceGetClient = _props.forceGetClient;DSDocumentsConfig = _props.DSDocumentsConfig;lang = _props.lang;brokersTeamWhiteList = _props.brokersTeamWhiteList;subgroups = _props.subgroups;userId = _props.userId;DSDocumentOriginTypes = _props.DSDocumentOriginTypes;selectedTicketDocuments = _props.selectedTicketDocuments;alienUserId = _props.alienUserId;userPhoneNumber = _props.userPhoneNumber;claimId = _props.claimId;claimNumber = _props.claimNumber;isOffice = _props.isOffice;claimWizardDocType = _props.claimWizardDocType;_state = this.state;brokerOptions = _state.brokerOptions;brokerEmailOptions = _state.brokerEmailOptions;firstSignerEmailAddressOptions = _state.firstSignerEmailAddressOptions;clientId = _state.clientId;packageId = _state.packageId;clientGSMPhoneNumbers = _state.clientGSMPhoneNumbers;brokerGSMPhoneNumbers = _state.brokerGSMPhoneNumbers;forceGetClientAffected = _state.forceGetClientAffected;moduleKey = _state.moduleKey;subModuleKey = _state.subModuleKey;teamSubgroupsOptions = _state.teamSubgroupsOptions;dynamicFieldIdCursor = _state.dynamicFieldIdCursor;teamsOptions = _state.teamsOptions;stakeholders = _state.stakeholders;clientNumber = _state.clientNumber;contractId = _state.contractId;isValidTheForm = _state.isValidTheForm;clientOptionsDict = _state.clientOptionsDict;isPrem = _state.isPrem;languageOptions = _state.languageOptions;documentTemplateOptions = _state.documentTemplateOptions;tarificationId = _state.tarificationId;tarificationNumber = _state.tarificationNumber;contractDetails = _state.contractDetails;signerAvailabilityOfTemplates = _state.signerAvailabilityOfTemplates;haveAvailableClaimTemplate = _state.haveAvailableClaimTemplate;if(!(!this.props.clientOptionsDict || Object.keys(this.props.clientOptionsDict).length == 0)){context$3$0.next = 51;break;}context$3$0.next = 50;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.fetchClientOptionsDict)()));case 50:clientOptionsDict = context$3$0.sent;case 51: // make sure if it loaded to state
	if(!clientOptionsDict || Object.keys(clientOptionsDict).length == 0){clientOptionsDict = this.props.clientOptionsDict;} // -------------------------------------
	// +++++++++++++++ LOAD CONFIG if not already loaded
	if(!(!DSDocumentsConfig || Object.keys(DSDocumentsConfig).length === 0)){context$3$0.next = 55;break;}context$3$0.next = 55;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSDocumentConfig)(c.DIGITAL_SIGNATURE_SETTINGS)));case 55:if(!(moduleKey === c.DS_MODULE_CLIENT_CLAIMS)){context$3$0.next = 60;break;}context$3$0.next = 58;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSDocumentTemplateClaimsAvailability)()));case 58:resultOFClaimAvailable = context$3$0.sent; // {claimsAvailable: boolean, count: number}
	haveAvailableClaimTemplate = resultOFClaimAvailable.claimsAvailable;case 60:documentTemplates = undefined;if(!(packageId && moduleKey != 'DS_MODULE_CLIENT_CONTRACT_PREM')){context$3$0.next = 75;break;}getDsDocumentsAndPackagesResult = undefined;if(!alienUserId){context$3$0.next = 69;break;}context$3$0.next = 66;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDsDocsAndPackages)(false,false,alienUserId,packageId,true)));case 66:getDsDocumentsAndPackagesResult = context$3$0.sent;context$3$0.next = 72;break;case 69:context$3$0.next = 71;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDsDocsAndPackages)(false,false,null,null,true)));case 71:getDsDocumentsAndPackagesResult = context$3$0.sent;case 72:documentTemplates = getDsDocumentsAndPackagesResult.templates;context$3$0.next = 78;break;case 75:context$3$0.next = 77;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSDocumentTemplates)()));case 77:documentTemplates = context$3$0.sent;case 78:if(!documentTemplates){context$3$0.next = 83;break;}templateIds = documentTemplates.map(function(oneTmplt){return oneTmplt._id;});context$3$0.next = 82;return regeneratorRuntime.awrap(dispatch((0,_stateActions.getTemplatesSigners)(templateIds)));case 82:signerAvailabilityOfTemplates = context$3$0.sent;case 83:documentTemplateOptions = (0,_DSWizardHelper.getDocumentTemplateOptionList)(documentTemplates,lang,moduleKey,subModuleKey,false,claimWizardDocType); // -------------------------------------
	// +++++++++++++++ get DOCUMENTS from store by package ID
	packageDSDocuments = (0,_DSWizardHelper.filterDocumentsByPackageId)(this.props.documents,packageId);attachIdResult = (0,_DSWizardFormControl.packageDocumentsAttachIdCursor)(packageDSDocuments,dynamicFieldIdCursor,true);packageDSDocuments = attachIdResult.packageDSDocuments;dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor; // -------------------------------------
	formInputs = (0,_DSWizardFormControl.synchronizePackageDSDocumentsInputsFromForm)(formInputs,packageDSDocuments,moduleKey,subModuleKey,DSDocumentOriginTypes); // if there are documents, then try to check those come from tickets ofr attachment selector
	selectedListsList = {};if(packageDSDocuments && packageDSDocuments.length > 0){selectedListsList = (0,_DSWizardHelper.setOracleSelectedDocuments)(packageDSDocuments);} // -------------------------------------
	// +++++++++++++++ FIND PACKAGE instance using the first document from the package
	packageInstance = {};if(packageDSDocuments){packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");} // -------------------------------------
	// +++++++++++++++ FIND A BROKER NUMBER
	brokerNumber = _nestedProperty2['default'].get(formInputs,"brokerNumber.value") || _nestedProperty2['default'].get(packageInstance,"brokerNumber") || brokers && brokers[Object.keys(brokers)[0]].brokerNumber || "";if(!(!_nestedProperty2['default'].get(packageInstance,"brokerNumber") && contractId)){context$3$0.next = 101;break;}if(contractDetails){context$3$0.next = 100;break;}context$3$0.next = 98;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.fetchClientContract)(contractId)));case 98:detailedContractInfo = context$3$0.sent;contractDetails = _nestedProperty2['default'].get(detailedContractInfo,"response.contractDetails");case 100: // set the newly determined broker number by contract, this was asked: BEWB-471
	brokerNumber = contractDetails.brokerNumber; // this broker number will be put in the form-Inputs values in the following code lower
	case 101:teamIndex = _nestedProperty2['default'].get(formInputs,"team.value");teamName = _nestedProperty2['default'].get(formInputs,"teamName.value");teamSubgroupId = _nestedProperty2['default'].get(formInputs,"teamSubgroup.value"); // if this is the tarification we must filter the templates again by broker and teams etc.
	if(moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION){ // when the pacakge already exists, and the state  formInpust is not prepared yet, then we must use the packageInstance values
	// this affect the values only on first reload, when the package is already created, and the formInputs not yet prepared
	if(packageId && packageInstance){teamIndex = teamIndex || _nestedProperty2['default'].get(packageInstance,"team") || "";teamName = teamName || _nestedProperty2['default'].get(packageInstance,"teamName") || "";teamSubgroupId = teamSubgroupId || _nestedProperty2['default'].get(packageInstance,"teamSubgroup") || "";} // filter the unecessary or restricted templates
	documentTemplateOptions = (0,_DSWizardHelper.filterTemplatesForBroker)(documentTemplateOptions,brokersTeamWhiteList,brokerNumber,teamIndex,teamSubgroupId);} // -------------------------------------
	// +++++++++++++++ LOAD BROKER data
	// prepare lists for form dropdown inputs (broker emails, brokers)
	if(!((!brokerOptions || brokerOptions.length === 0) && !isOffice)){context$3$0.next = 111;break;}context$3$0.next = 108;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.fetchOfficeData)()));case 108:brokerLoader = context$3$0.sent; // must get the office data for all informations for variables
	brokerOptions = (0,_DSWizardFormControl.getBrokersInOptionList)(this.props.brokers);brokerGSMPhoneNumbers = (0,_DSWizardFormControl.getBrokerGSMPhoneNumbers)(brokers[brokerNumber].main.phoneNumbers,userPhoneNumber);case 111: // filter the new list by broker number and put it in to state
	brokerEmailOptions = (0,_DSWizardFormControl.getBrokerEmailsInOptionList)(brokerNumber,brokers,userId); // ------------------------------------------
	// +++++++++++++++ generate TEAM OPTIONS
	// determine the list of teams using the whitelist of the broker
	teamsOptions = (0,_DSWizardHelper.getTeamsOptionList)(clientOptionsDict,lang);teamsOptions = (0,_DSWizardHelper.filterTeamsForBroker)(teamsOptions,brokersTeamWhiteList,brokerNumber); // ------------------------------------------
	// +++++++++++++++  LOAD CLIENT, and CONTRACTS in the same request
	//check prop data is also a way to do a fetch: if (!clientDataExt || !nesProp.get(clientDataExt, clientId + ".main")) {
	if(!(!isOffice && (forceGetClient && !forceGetClientAffected || !firstSignerEmailAddressOptions && clientId || firstSignerEmailAddressOptions.length === 0 || !clientGSMPhoneNumbers || clientGSMPhoneNumbers.length === 0 || client && client.clientId !== clientId))){context$3$0.next = 121;break;}context$3$0.next = 117;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.fetchClient)(clientId)));case 117: // process client result
	firstSignerEmailAddressOptions = (0,_DSWizardFormControl.getClientEmailsInOptionList)(clientDataExt,clientId);clientGSMPhoneNumbers = (0,_DSWizardFormControl.getClientGSMPhoneNumbers)(clientDataExt,clientId);clientNumber = client && client.main.clientNumber || "";forceGetClientAffected = true;case 121:isClaimWizard = moduleKey === c.DS_MODULE_CLAIM_WIZARD;resultOfGetTeamSubgroups = subgroups;if(!(!isClaimWizard && (!teamSubgroupsOptions || teamSubgroupsOptions.length === 0))){context$3$0.next = 127;break;}context$3$0.next = 126;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.fetchTeamSubgroups)()));case 126:resultOfGetTeamSubgroups = context$3$0.sent;case 127:if(resultOfGetTeamSubgroups){teamSubgroupsOptions = (0,_DSWizardHelper.getTeamSubgroupsOptionList)(resultOfGetTeamSubgroups,lang);} // ------------------------------------------
	// +++++++++++++++ HANDLE CONTRACT ID
	// loaded data preprocessed, can continue the flow
	if(!contractId){context$3$0.next = 134;break;}theContract = (0,_DSWizardFormControl.findContractInClientObj)(client,contractId);contractNumber = _nestedProperty2['default'].get(theContract,"contractMain.contractNumber");context$3$0.next = 133;return regeneratorRuntime.awrap(this.handleChangeContractNumber(contractId,contractNumber,formInputs));case 133:formInputs = context$3$0.sent;case 134:clientLanguageWord = _nestedProperty2['default'].get(clientDataExt,clientId + ".detail.language");clientLanguage = undefined;if(clientOptionsDict && clientLanguageWord){clientLanguage = (0,_libHelpers.getTheLanguageCodeByAnyLanguageOnAnyLanguage)(clientLanguageWord,clientOptionsDict);}clientLanguage = _nestedProperty2['default'].get(formInputs,"clientLanguage.value") || clientLanguage; // ------------------------------------
	// +++++++++++++++ DOCUMENTS FROM TICKETS
	// add ticket documents to wizard
	if(!(selectedTicketDocuments && !packageId)){context$3$0.next = 150;break;}i = 0;case 140:if(!(i < selectedTicketDocuments.length)){context$3$0.next = 150;break;}context$3$0.next = 143;return regeneratorRuntime.awrap(this.createDSDocumentForPackage(packageDSDocuments,clientLanguage,{team:teamIndex,teamName:teamName,teamSubgroup:teamSubgroupId},dynamicFieldIdCursor,languageOptions,documentTemplateOptions,{contractId:contractId,tarificationId:tarificationId,tarificationNumber:tarificationNumber,claimId:claimId,claimNumber:claimNumber,moduleKey:moduleKey,subModuleKey:subModuleKey,isPrem:isPrem},null,selectedTicketDocuments[i]));case 143:result = context$3$0.sent; // merge on document inputs
	formInputs = _extends({},formInputs,result.documentFormInputs); // update the list of documents and the cursor
	packageDSDocuments = result.packageDSDocuments;dynamicFieldIdCursor = result.dynamicFieldIdCursor;case 147:i++;context$3$0.next = 140;break;case 150:if(!(packageId && packageDSDocuments)){context$3$0.next = 156;break;}_packageInstance = {};_packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");context$3$0.next = 155;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSStakeholders)(_packageInstance.stakeholders)));case 155:stakeholders = context$3$0.sent;case 156:formInitialValues = this.getFormInitialValues(packageDSDocuments,brokerNumber,stakeholders,clientId,packageId,clientOptionsDict,contractId);newFormInputs = (0,_DSWizardFormControl.createNewFormInputFieldsList)(formInitialValues,packageDSDocuments,DSDocumentOriginTypes,moduleKey,subModuleKey,(0,_DSWizardHelper.requireSigning)(packageDSDocuments,DSDocumentOriginTypes),stakeholders,(0,_DSWizardHelper.requireSmsOtpSigning)(packageDSDocuments,DSDocumentOriginTypes),isOffice); // the new set form input must overwrite by old ones, to keep the
	// correct values, and extend the input list with the document fields
	formInputs = _extends({},newFormInputs,formInputs); // ------------------------------------------
	// +++++++++++ POST PROCESSING packageDSDocuments and produce final FORM INPUTS
	// +++++++++++ AFTER ALL OPERATION ON "packageDSDocuments" we can add/remove the conditional fields and validation
	formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey,packageId);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,false); // -------------------------------------------------------------------------------------------
	// +++++++++++++  PREM initial handling
	// CREATE PACKAGE FOR PREM CONTRACT ON FIRST CONTACT
	// in case when we creating a new package, and it is prem, must added on document, with the PREM template
	// BEWB - 706 - update we can have generated documents in PREM module, one document flagged as requiredOnPrem
	//is mandatory by default and can't be deleted
	isItTarificationModule = moduleKey === c.DS_MODULE_CLIENT_TARIFICATION;isTarificationSubmodule = subModuleKey === c.DS_MODULE_CLIENT_TARIFICATION;if(!((isPrem || isItTarificationModule && !isTarificationSubmodule) && !packageId)){context$3$0.next = 211;break;}requiredOnPrem = (0,_DSWizardHelper.getDocumentTemplateOptionList)(documentTemplates,lang,moduleKey,subModuleKey,true,claimWizardDocType);context$3$0.next = 168;return regeneratorRuntime.awrap(this.createDSDocumentForPackage(packageDSDocuments,clientLanguage,{team:teamIndex,teamName:teamName,teamSubgroup:teamSubgroupId},dynamicFieldIdCursor,languageOptions,requiredOnPrem,{contractId:contractId,tarificationId:tarificationId,tarificationNumber:tarificationNumber,moduleKey:moduleKey,subModuleKey:subModuleKey,isPrem:isPrem,isItTarificationModule:isItTarificationModule},null,null));case 168:createDefaultDocResult = context$3$0.sent; // merge on document inputs
	formInputs = _extends({},formInputs,createDefaultDocResult.documentFormInputs); // update the list of documents and the cursor
	packageDSDocuments = createDefaultDocResult.packageDSDocuments;dynamicFieldIdCursor = createDefaultDocResult.dynamicFieldIdCursor; // ---------------------------
	// get the form values from the formInputs object,
	// because the rendering is not done
	// to get values from inputs by ref
	rawFormValuesData = {};_iteratorNormalCompletion = true;_didIteratorError = false;_iteratorError = undefined;context$3$0.prev = 176;for(_iterator = Object.entries(formInputs)[Symbol.iterator]();!(_iteratorNormalCompletion = (_step = _iterator.next()).done);_iteratorNormalCompletion = true) {_step$value = _slicedToArray(_step.value,2);key = _step$value[0];value = _step$value[1];if(value.value !== null){rawFormValuesData[key] = value.value;}} //load properties for first contact
	context$3$0.next = 184;break;case 180:context$3$0.prev = 180;context$3$0.t0 = context$3$0['catch'](176);_didIteratorError = true;_iteratorError = context$3$0.t0;case 184:context$3$0.prev = 184;context$3$0.prev = 185;if(!_iteratorNormalCompletion && _iterator['return']){_iterator['return']();}case 187:context$3$0.prev = 187;if(!_didIteratorError){context$3$0.next = 190;break;}throw _iteratorError;case 190:return context$3$0.finish(187);case 191:return context$3$0.finish(184);case 192:theContract = (0,_DSWizardFormControl.findContractInClientObj)(client,contractId);upsertArguments = _extends({},rawFormValuesData,{clientId:clientId,clientNumber:clientNumber,contractId:_nestedProperty2['default'].get(theContract,'contractMain.contractId'),contractNumber:_nestedProperty2['default'].get(theContract,"contractMain.contractNumber"),uploadedOnModule:moduleKey,subModuleKey:subModuleKey});context$3$0.next = 196;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.upsertDSPackage)(upsertArguments)));case 196:newPremPackage = context$3$0.sent;packageId = newPremPackage._id; // Notice I.
	// important to find the documents from this.props, do not use the destructured from
	// the begin of the function, because the dispatch update the store references, and
	// that object is disconnected with old values in the moment of destructuring
	// Notice II.
	// This reloaded package, will overwrite the packageDSDocuments, so must keep in
	// sync with the formInputs
	packageDSDocuments = (0,_DSWizardHelper.filterDocumentsByPackageId)(this.props.documents,packageId); // ++++ reset dynamicFieldIdCursor because new package created and the documents are reloaded
	dynamicFieldIdCursor = 1; // ----
	// add local ID to manage the document in browser
	_attachIdResult = (0,_DSWizardFormControl.packageDocumentsAttachIdCursor)(packageDSDocuments,dynamicFieldIdCursor,true);packageDSDocuments = _attachIdResult.packageDSDocuments;dynamicFieldIdCursor = _attachIdResult.dynamicFieldIdCursor; // get the increased value
	// don't need to synch because the hole form will be regenerated in next lines
	// formInputs = synchronizePackageDSDocumentsInputsFromForm(formInputs, packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes)
	context$3$0.next = 205;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSStakeholders)(newPremPackage.stakeholders)));case 205:stakeholders = context$3$0.sent;_formInitialValues = this.getFormInitialValues(packageDSDocuments,brokerNumber,stakeholders,clientId,packageId,clientOptionsDict,contractId);formInputs = (0,_DSWizardFormControl.createNewFormInputFieldsList)(_formInitialValues,packageDSDocuments,this.props.DSDocumentOriginTypes,this.props.moduleKey,this.props.subModuleKey,(0,_DSWizardHelper.requireSigning)(packageDSDocuments,this.props.DSDocumentOriginTypes),stakeholders,(0,_DSWizardHelper.requireSmsOtpSigning)(packageDSDocuments,this.props.DSDocumentOriginTypes),isOffice);formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey,packageId);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,false);case 211:if(!(isClaimWizard && !packageId)){context$3$0.next = 244;break;}requiredOnClaimWizard = (0,_DSWizardHelper.getDocumentTemplateOptionList)(documentTemplates,lang,moduleKey,subModuleKey,true,claimWizardDocType);context$3$0.next = 215;return regeneratorRuntime.awrap(this.createDSDocumentForPackage(packageDSDocuments,clientLanguage,{team:teamIndex,teamName:teamName,teamSubgroup:teamSubgroupId},dynamicFieldIdCursor,languageOptions,requiredOnClaimWizard,{claimId:claimId,claimNumber:claimNumber,moduleKey:moduleKey,subModuleKey:subModuleKey},null,null));case 215:createDefaultDocResult = context$3$0.sent; // merge on document inputs
	formInputs = _extends({},formInputs,createDefaultDocResult.documentFormInputs); // update the list of documents and the cursor
	packageDSDocuments = createDefaultDocResult.packageDSDocuments;dynamicFieldIdCursor = createDefaultDocResult.dynamicFieldIdCursor; // ---------------------------
	// get the form values from the formInputs object,
	// because the rendering is not done
	// to get values from inputs by ref
	rawFormValuesData = {};_iteratorNormalCompletion2 = true;_didIteratorError2 = false;_iteratorError2 = undefined;context$3$0.prev = 223;for(_iterator2 = Object.entries(formInputs)[Symbol.iterator]();!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);_iteratorNormalCompletion2 = true) {_step2$value = _slicedToArray(_step2.value,2);key = _step2$value[0];value = _step2$value[1];if(value.value !== null){rawFormValuesData[key] = value.value;}} // ++++++++++++ RESET THE FORM INPUTS by documents because the new package ++++++++++++++++++
	context$3$0.next = 231;break;case 227:context$3$0.prev = 227;context$3$0.t1 = context$3$0['catch'](223);_didIteratorError2 = true;_iteratorError2 = context$3$0.t1;case 231:context$3$0.prev = 231;context$3$0.prev = 232;if(!_iteratorNormalCompletion2 && _iterator2['return']){_iterator2['return']();}case 234:context$3$0.prev = 234;if(!_didIteratorError2){context$3$0.next = 237;break;}throw _iteratorError2;case 237:return context$3$0.finish(234);case 238:return context$3$0.finish(231);case 239:_formInitialValues2 = this.getFormInitialValues(packageDSDocuments,brokerNumber,stakeholders,clientId,packageId,clientOptionsDict,contractId);formInputs = (0,_DSWizardFormControl.createNewFormInputFieldsList)(_formInitialValues2,packageDSDocuments,this.props.DSDocumentOriginTypes,this.props.moduleKey,this.props.subModuleKey,(0,_DSWizardHelper.requireSigning)(packageDSDocuments,this.props.DSDocumentOriginTypes),stakeholders,(0,_DSWizardHelper.requireSmsOtpSigning)(packageDSDocuments,this.props.DSDocumentOriginTypes),isOffice);formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey,packageId);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,false);case 244:addSignersButtonFlags = (0,_DSWizardHelper.getSignerAdderButtonsFlags)(packageDSDocuments,DSDocumentOriginTypes,isPrem,signerAvailabilityOfTemplates);isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder;isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder;isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder; // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
	// those properties, so don't do that
	//---------------- end handle enabled signers list
	// at the end set the state
	this.setState(_extends({teamSubgroupsOptions:teamSubgroupsOptions,packageDSDocuments:packageDSDocuments,formInputs:formInputs,isValidTheForm:isValidTheForm,dynamicFieldIdCursor:dynamicFieldIdCursor,packageId:packageId,clientOptionsDict:clientOptionsDict,brokerOptions:brokerOptions,brokerEmailOptions:brokerEmailOptions,brokerGSMPhoneNumbers:brokerGSMPhoneNumbers,moduleKey:moduleKey,subModuleKey:subModuleKey,documentTemplateOptions:documentTemplateOptions,teamsOptions:teamsOptions,firstSignerEmailAddressOptions:firstSignerEmailAddressOptions,clientGSMPhoneNumbers:clientGSMPhoneNumbers,clientNumber:clientNumber,forceGetClientAffected:forceGetClientAffected,stakeholders:stakeholders,contractDetails:contractDetails,signerAvailabilityOfTemplates:signerAvailabilityOfTemplates,haveAvailableClaimTemplate:haveAvailableClaimTemplate,isItExistFirstSignerPlaceholder:isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder:isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder:isItExistBrokerSignerPlaceholder},selectedListsList));return context$3$0.abrupt('return',formInputs);case 250:case 'end':return context$3$0.stop();}},null,_this,[[176,180,184,192],[185,,187,191],[223,227,231,239],[232,,234,238]]);};this.initStep2 = function callee$2$0(formInputs){var skipValidationJustUpdate=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];var _props2,dispatch,templates,lang,brokersTeamWhiteList,documents,DSDocumentOriginTypes,claimWizardDocType,_state2,clientId,packageId,moduleKey,subModuleKey,clientNumber,dynamicFieldIdCursor,stakeholders,packageDSDocuments,rawFormValuesData,forceTouche,isValidTheForm,contractId,claimId,claimNumber,ticketId,_brokerNumber,isRequiredTarification,tarificationId,tarificationNumber,_teamIndex,_teamSubgroupId,_teamIndex2,tarificationResult,upsertPackageArgs,updatedPackage,_documentTemplateOptions,newPackageId,_attachIdResult2,newPackageContractId,newPackageTarificationId;return regeneratorRuntime.async(function callee$2$0$(context$3$0){var _this2=this;while(1) switch(context$3$0.prev = context$3$0.next){case 0:_props2 = this.props;dispatch = _props2.dispatch;templates = _props2.templates;lang = _props2.lang;brokersTeamWhiteList = _props2.brokersTeamWhiteList;documents = _props2.documents;DSDocumentOriginTypes = _props2.DSDocumentOriginTypes;claimWizardDocType = _props2.claimWizardDocType;_state2 = this.state;clientId = _state2.clientId;packageId = _state2.packageId;moduleKey = _state2.moduleKey;subModuleKey = _state2.subModuleKey;clientNumber = _state2.clientNumber;dynamicFieldIdCursor = _state2.dynamicFieldIdCursor;stakeholders = _state2.stakeholders;packageDSDocuments = _state2.packageDSDocuments;this.startLoading();context$3$0.prev = 18;rawFormValuesData = (0,_DSWizardFormControl.fetchFormValues)(formInputs,this.refs,packageDSDocuments,moduleKey,subModuleKey); // fill back the state holded form input objects list what control the form in the dome
	formInputs = (0,_DSWizardFormControl.setFormInputsByFormValues)(rawFormValuesData,formInputs); //-------------------   VALIDATE INPUT FIELDS ---------------------------//
	// now we do a final validation before passing forward the wizard, force touch to enforce to fill the error messages
	forceTouche = true;formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs,forceTouche); // set the general error flag of the current step of wizard
	isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,forceTouche);this.setState({isValidTheForm:isValidTheForm,formInputs:formInputs}); // put back the validated, and error filled input instances to the state to be able to render the error messages under the inputs
	// in case of ERROR abort to move forward until the form is not valid on another try
	// skipValidationJustUpdate : BEWB-676
	if(!(!isValidTheForm.isValid && !skipValidationJustUpdate)){context$3$0.next = 29;break;}console.error(isValidTheForm);this.stopLoading(); //trow error to prevent the form to move forward
	throw _("invalidForm");case 29:contractId = this.getContractIdByNumber(_nestedProperty2['default'].get(formInputs,"contractNumber.value"));claimId = _nestedProperty2['default'].get(this.props,'claimId');claimNumber = _nestedProperty2['default'].get(this.props,'claimNumber');ticketId = _nestedProperty2['default'].get(this.props,'ticketId') && (_nestedProperty2['default'].get(this.state,"selectedTicketRelatedOraDocuments") && _nestedProperty2['default'].get(this.state,"selectedTicketRelatedOraDocuments").length > 0 || _nestedProperty2['default'].get(this.state,"emailAttachmentsTicketRelatedOraDocuments") && _nestedProperty2['default'].get(this.state,"emailAttachmentsTicketRelatedOraDocuments").length > 0)?_nestedProperty2['default'].get(this.props,'ticketId'):'';_brokerNumber = _nestedProperty2['default'].get(formInputs,"brokerNumber.value");isRequiredTarification = moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION;tarificationId = _nestedProperty2['default'].get(formInputs,"tarificationId.value");tarificationNumber = _nestedProperty2['default'].get(formInputs,"tarificationNumber.value");_teamIndex = _nestedProperty2['default'].get(formInputs,"team.value");_teamSubgroupId = _nestedProperty2['default'].get(formInputs,"teamSubgroup.value") || null;if(!isRequiredTarification){context$3$0.next = 46;break;}_teamIndex2 = _nestedProperty2['default'].get(formInputs,"team.value");_brokerNumber = _nestedProperty2['default'].get(formInputs,"brokerNumber.value"); // this function will create tarification in case when there is no tarification else will return new ID and number pair
	context$3$0.next = 44;return regeneratorRuntime.awrap(this.setupTarificationForPackageAndDocs(clientId,_brokerNumber,_teamIndex2,tarificationId,tarificationNumber,packageDSDocuments,formInputs));case 44:tarificationResult = context$3$0.sent;if(tarificationResult){ // the promise does what must be done before to finish the initialisation of step 2
	// if this promise is a tarification initialiser then we have this values and patch it into args for create package
	tarificationId = tarificationResult.tarificationId;tarificationNumber = tarificationResult.tarificationNumber;formInputs = tarificationResult.formInputs;packageDSDocuments = tarificationResult.packageDSDocuments; // get the fresh input values from the form, because possible, there is a new tarification was created, and the
	// inputs are updated by the new tarification values for the dynamic document list also
	// the raw values of the form are used to create a document package by the API
	rawFormValuesData = (0,_DSWizardFormControl.fetchFormValues)(formInputs,this.refs,packageDSDocuments,moduleKey,subModuleKey);}case 46:upsertPackageArgs = _extends({},rawFormValuesData,{emailAttachmentTicketDocuments:this.state.emailAttachmentsTicketRelatedOraDocuments,contractId:contractId,claimId:claimId,claimNumber:claimNumber,tarificationId:tarificationId,tarificationNumber:tarificationNumber,clientId:clientId,ticketId:ticketId,clientNumber:clientNumber,packageId:packageId,claimWizardDocType:claimWizardDocType,uploadedOnModule:moduleKey,subModuleKey:subModuleKey,teamSubgroup:_teamSubgroupId});context$3$0.next = 49;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.upsertDSPackage)(upsertPackageArgs)));case 49:updatedPackage = context$3$0.sent;if(!(updatedPackage && updatedPackage.stakeholders && updatedPackage.stakeholders.length > 0)){context$3$0.next = 54;break;}context$3$0.next = 53;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSStakeholders)(updatedPackage.stakeholders)));case 53:stakeholders = context$3$0.sent;case 54:context$3$0.next = 56;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDsDocsAndPackages)(false,false,null,null,true)));case 56:_documentTemplateOptions = (0,_DSWizardHelper.getDocumentTemplateOptionList)(templates,lang,moduleKey,subModuleKey,false,claimWizardDocType);if(moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION){_documentTemplateOptions = (0,_DSWizardHelper.filterTemplatesForBroker)(_documentTemplateOptions,brokersTeamWhiteList,_brokerNumber,_teamIndex,_teamSubgroupId);}newPackageId = packageId || updatedPackage && updatedPackage._id; // reload package documents from store, because fo update
	// this require to reconstruct the dynamic documents part fo the form
	packageDSDocuments = (0,_DSWizardHelper.filterDocumentsByPackageId)(this.props.documents,newPackageId); // ++++ reset dynamic document index cursor for reindexing
	dynamicFieldIdCursor = 1; // attach the cursor for all document
	_attachIdResult2 = (0,_DSWizardFormControl.packageDocumentsAttachIdCursor)(packageDSDocuments,dynamicFieldIdCursor,true);packageDSDocuments = _attachIdResult2.packageDSDocuments;dynamicFieldIdCursor = _attachIdResult2.dynamicFieldIdCursor;formInputs = (0,_DSWizardFormControl.synchronizePackageDSDocumentsInputsFromForm)(formInputs,packageDSDocuments,moduleKey,subModuleKey,DSDocumentOriginTypes);moduleKey = moduleKey || (0,_DSWizardHelper.getModuleKeyOfPackage)(_nestedProperty2['default'].get(this,"state.packageDSDocuments"));subModuleKey = subModuleKey || (0,_DSWizardHelper.getSubModuleKeyOfPackage)(_nestedProperty2['default'].get(this,"state.packageDSDocuments"));newPackageContractId = contractId || updatedPackage && updatedPackage.contractId;newPackageTarificationId = tarificationId || updatedPackage && updatedPackage.tarificationId;this.setState({formInputs:formInputs,packageDSDocuments:packageDSDocuments,packageId:newPackageId,contractId:newPackageContractId,tarificationId:newPackageTarificationId,tarificationNumber:tarificationNumber,dynamicFieldIdCursor:dynamicFieldIdCursor,moduleKey:moduleKey,subModuleKey:subModuleKey,documentTemplateOptions:_documentTemplateOptions,stakeholders:stakeholders},function(){_this2.stopLoading();});return context$3$0.abrupt('return',updatedPackage);case 73:context$3$0.prev = 73;context$3$0.t0 = context$3$0['catch'](18); //this.setState({isLoaded: true})
	this.stopLoading(); // TODO - solve the error handling on another way if necessary. To give feedback for the user about the error in the modal...
	dispatch((0,_stateActions2.setNotification)(_('wizardError') + " " + JSON.stringify(context$3$0.t0),'error'));return context$3$0.abrupt('return',Promise.reject(context$3$0.t0));case 78:case 'end':return context$3$0.stop();}},null,_this,[[18,73]]);};this.state = {clientId:props.clientId};var brokers=props.brokers;var clientId=props.clientId;var firstSignerEmailAddressOptions=(0,_DSWizardFormControl.getClientEmailsInOptionList)(props.clientDataExt,clientId);var clientGSMPhoneNumbers=(0,_DSWizardFormControl.getClientGSMPhoneNumbers)(props.clientDataExt,clientId);var countryPhoneCodes=(0,_DSWizardFormControl.getCountryPhoneCodes)();var remainderIntervalOptions=(0,_DSWizardHelper.getRemainderIntervalOptionList)(props.security);var remainderRepeatsOptions=(0,_DSWizardHelper.getRemainderRepeatsOptionList)(props.security);var documentTemplateOptions=(0,_DSWizardHelper.getDocumentTemplateOptionList)(props.templates,props.lang,props.moduleKey,props.subModuleKey,false,props.claimWizardDocType);var languageOptions=(0,_DSWizardHelper.getLanguageOptionList)();var teamsOptions=(0,_DSWizardHelper.getTeamsOptionList)(props.clientOptionsDict,props.lang);var teamSubgroupsOptions=(0,_DSWizardHelper.getTeamSubgroupsOptionList)(props.subgroups,props.lang); // handle package documents
	var packageDSDocuments=(0,_DSWizardHelper.filterDocumentsByPackageId)(props.documents,props.packageId); // set cursor for all documents
	var dynamicFieldIdCursor=1;var attachIdResult=(0,_DSWizardFormControl.packageDocumentsAttachIdCursor)(packageDSDocuments,dynamicFieldIdCursor,true);packageDSDocuments = attachIdResult.packageDSDocuments;dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor;this.state = _extends({},this.state,{dynamicFieldIdCursor:dynamicFieldIdCursor});var moduleKey=props.moduleKey || (0,_DSWizardHelper.getModuleKeyOfPackage)(packageDSDocuments);var subModuleKey=props.subModuleKey || (0,_DSWizardHelper.getSubModuleKeyOfPackage)(packageDSDocuments);var stakeholders=props.stakeholders; // if package created get the instance
	var packageInstance={};if(packageDSDocuments){packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");} // get brNr from package, other ways not working here, not exists in store,
	// and async calls not possible in constructor.
	var brokerNumber=_nestedProperty2['default'].get(packageInstance,"brokerNumber"); // alternative solution but if not initialised from contracts zoom, nothing found.
	if(props.contractId && props.client){var theContract=(0,_DSWizardFormControl.findContractInClientObj)(props.client,props.contractId); // the already saved broker number is more important than what is in the contract
	brokerNumber = brokerNumber || (0,_DSWizardFormControl.getBrokerNumberByContract)(theContract,props.brokers,{});} // select first brokerNumber
	brokerNumber = brokerNumber?brokerNumber:props.brokers && props.brokers[Object.keys(props.brokers)[0]].brokerNumber;var brokerGSMPhoneNumbers=[];if(props.isOffice){brokerGSMPhoneNumbers = (0,_DSWizardFormControl.getBrokerGSMPhoneNumbers)(props.brokerFromOffice.main.phoneNumbers);}else {brokerNumber?(0,_DSWizardFormControl.getBrokerGSMPhoneNumbers)(props.brokers[brokerNumber].main.phoneNumbers,props.userPhoneNumber):"";}var teamIndex=_nestedProperty2['default'].get(packageInstance,"team");var teamSubgroupId=_nestedProperty2['default'].get(packageInstance,"teamSubgroup");teamsOptions = (0,_DSWizardHelper.filterTeamsForBroker)(teamsOptions,props.brokersTeamWhiteList,brokerNumber);var brokerEmailOptions=(0,_DSWizardFormControl.getBrokerEmailsInOptionList)(brokerNumber,props.brokers,props.userId); // if this is the tarificatino we must filter the templates
	if(moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION){documentTemplateOptions = (0,_DSWizardHelper.filterTemplatesForBroker)(documentTemplateOptions,props.brokersTeamWhiteList,brokerNumber,teamIndex,teamSubgroupId);} // case module is from office, use the broker from office reset broker number and change email option like foowing:
	// fisrst signer  -> emails from  broker
	// broker emails from logged in user
	if(props.isOffice){brokers = [props.brokerFromOffice];brokerNumber = props.brokerFromOffice.brokerNumber;firstSignerEmailAddressOptions = (0,_DSWizardFormControl.getBrokerEmailsInOptionList)(brokerNumber,props.brokers,props.userId);}var isPrem=props.moduleKey && props.moduleKey === c.DS_MODULE_CLIENT_CONTRACT_PREM?true:false;var secondSigningStakeholder=props.stakeholders && props.stakeholders.find(function(stakeholder){return stakeholder.signerNumber === '1';});var brokerOptions=(0,_DSWizardFormControl.getBrokersInOptionList)(brokers); //add stakeholder phone number to clientGSMPhoneNumbers list
	if(props.stakeholders && props.stakeholders.find(function(stakeholder){return stakeholder.signerNumber === '0';})){var firstSigningStakeholderPhoneNumber=(0,_DSWizardFormControl.spreadPhoneNumber)(props.stakeholders.find(function(stakeholder){return stakeholder.signerNumber === '0';}).phoneNumber);clientGSMPhoneNumbers.push(firstSigningStakeholderPhoneNumber && {label:firstSigningStakeholderPhoneNumber.phoneNumber,value:firstSigningStakeholderPhoneNumber.phoneNumber,countryCode:firstSigningStakeholderPhoneNumber.phoneCode});}this.isLoaded = false; // init state with all of the available data prepared from props and the store
	this.state = _extends({},this.state,{step:props.step,packageId:props.packageId,clientNumber:props.client && props.client.main && props.client.main.clientNumber,contractId:props.contractId,tarificationId:props.tarificationId,tarificationNumber:props.tarificationNumber,claimId:props.claimId,claimNumber:props.claimNumber,packageDSDocuments:packageDSDocuments || [],isValidTheForm:{isValid:false},firstSignerEmailAddressOptions:firstSignerEmailAddressOptions,clientGSMPhoneNumbers:clientGSMPhoneNumbers,brokerGSMPhoneNumbers:brokerGSMPhoneNumbers,countryPhoneCodes:countryPhoneCodes,brokerOptions:brokerOptions,brokerEmailOptions:brokerEmailOptions,remainderIntervalOptions:remainderIntervalOptions,remainderRepeatsOptions:remainderRepeatsOptions,dynamicFieldIdCursor:dynamicFieldIdCursor,documentTemplateOptions:documentTemplateOptions,languageOptions:languageOptions,teamsOptions:teamsOptions,teamSubgroupsOptions:teamSubgroupsOptions,formInputs:{}, //isLoaded: false,
	isOpenIntervalInfo:false,isOpenTicketIntervalInfo:false,moduleKey:moduleKey,subModuleKey:subModuleKey,clientOptionsDict:props.clientOptionsDict,warningModalOpen:false,isOpenAreYouSure:false,forceGetClientAffected:false,changeTemplateModalIsOpen:true,changeTemplateModalData:{},contractDetails:null,fillTemplateErrors:false,fillTemplateErrorsModalOpen:false,documentsAreNotValidModalOpen:false,areNonUsedStakeholders:false,stakeholderUsageMap:{},printNotValidModalOpen:false,isPrem:isPrem,showSecondSigner:secondSigningStakeholder?true:false,stakeholders:stakeholders,selectedTicketRelatedOraDocuments:props.selectedTicketDocuments,emailAttachmentsTicketRelatedOraDocuments:props.emailAttachmentTicketDocuments,selectedClaimRelatedOraDocuments:[],selectedContractRelatedOraDocuments:[],selectedTarificationRelatedOraDocuments:[],selectedClientRelatedOraDocuments:[],moduleOptions:props.moduleOptions,invitationEmailSent:false, // moduleKeyToSetForEmailer: nesProp.get(props, "EmailTemplateRelations.EmailTemplateModules. mifid.value") || false,
	forceCloseDatepicker:false,signerAvailabilityOfTemplates:null,haveAvailableClaimTemplate:false,isItExistFirstSignerPlaceholder:false,isItExistSecondSignerPlaceholder:false,isItExistBrokerSignerPlaceholder:false,initiatorEmailAddressesFromTemplates:[]});} /**
	     * Start loading anything.
	     * Not a state driven status flag, because not required a rerender in case of change
	     */_createClass(DSWizard,[{key:'startLoading',value:function startLoading(){this.isLoaded = false;} /**
	     * Stop loading anything.
	     * Not a state driven status flag, because not required a rerender in case of change
	     * @param {*} forceUpdate - can be enforced optionally a rerender but very rare to be necessary.
	     */},{key:'stopLoading',value:function stopLoading(){var forceUpdate=arguments.length <= 0 || arguments[0] === undefined?false:arguments[0];this.isLoaded = true;if(forceUpdate){this.forceUpdate();}}},{key:'componentWillMount',value:function componentWillMount(){var _this3=this;var _props3=this.props;var dispatch=_props3.dispatch;var clientOptionsDict=_props3.clientOptionsDict;var isOffice=_props3.isOffice;if(!isOffice && (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0)){dispatch((0,_stateActions2.fetchClientOptionsDict)()).then(function(){_this3.setState({clientOptionsDict:_this3.props.clientOptionsDict});});}} /**
	     * Component did mount hook. Check and load all the dependency values, init related values.
	     */},{key:'componentDidMount',value:function componentDidMount(){var _state3,formInputs,clientOptionsDict,_props4,dispatch,isOffice;return regeneratorRuntime.async(function componentDidMount$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_state3 = this.state;formInputs = _state3.formInputs;clientOptionsDict = _state3.clientOptionsDict;_props4 = this.props;dispatch = _props4.dispatch;isOffice = _props4.isOffice;if(!(!isOffice && (!this.props.clientOptionsDict || Object.keys(this.props.clientOptionsDict).length == 0))){context$2$0.next = 20;break;}context$2$0.prev = 7;context$2$0.next = 10;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.fetchClientOptionsDict)()));case 10:clientOptionsDict = context$2$0.sent;context$2$0.next = 18;break;case 13:context$2$0.prev = 13;context$2$0.t0 = context$2$0['catch'](7); // can not get the dictionaries from oracle, but let the initialisation to go forward
	// notify the user about error
	console.error("Error loading client options dictionary, ",context$2$0.t0);dispatch((0,_stateActions2.setNotification)(_('wizardError') + " " + JSON.stringify(context$2$0.t0),'error'));return context$2$0.abrupt('return',context$2$0.t0);case 18:clientOptionsDict = this.props.clientOptionsDict;this.setState({clientOptionsDict:clientOptionsDict});case 20: // display loader for multi step operation
	dispatch((0,_stateActions2.showLoader)());this.startLoading();context$2$0.prev = 22;context$2$0.next = 25;return regeneratorRuntime.awrap(this.initStep1(formInputs));case 25:formInputs = context$2$0.sent;this.setState({formInputs:formInputs});context$2$0.next = 32;break;case 29:context$2$0.prev = 29;context$2$0.t1 = context$2$0['catch'](22);console.error(context$2$0.t1);case 32:this.stopLoading();dispatch((0,_stateActions2.hideLoader)());return context$2$0.abrupt('return');case 35:case 'end':return context$2$0.stop();}},null,this,[[7,13],[22,29]]);} /**
	     * Component did mount hook. Check and load all the dependency values, init related values.
	     * @param {object} formInputs list of inputs of the form, what is constructed by this function and returned
	     * @returns {object}
	     */},{key:'getFormInitialValues', /**
	     * This function prepare and return a bunch of predefined data for the form inputs indexed by form input ref names
	     * When wizard is opened from office module there is no client there fore no client data to set
	     * @param {*} packageDSDocuments
	     * @param {*} brokerNumberFromForm
	     * @param {*} stakeholders
	     * @param {*} clientId
	     * @param {*} packageId
	     * @param {*} clientOptionsDict
	     * @param {*} contractId
	     * @returns
	     */value:function getFormInitialValues(packageDSDocuments,brokerNumberFromForm,stakeholders,clientId,packageId,clientOptionsDict,contractId){var _extends2;var _props5=this.props;var clientDataExt=_props5.clientDataExt;var moduleKeyFromProps=_props5.moduleKeyFromProps;var lang=_props5.lang;var templates=_props5.templates;var brokersTeamWhiteList=_props5.brokersTeamWhiteList;var subModuleKey=_props5.subModuleKey;var client=_props5.client;var brokers=_props5.brokers;var security=_props5.security;var DSDocumentsConfig=_props5.DSDocumentsConfig;var userFirstName=_props5.userFirstName;var userLastName=_props5.userLastName;var claimId=_props5.claimId;var claimNumber=_props5.claimNumber;var userPhoneNumber=_props5.userPhoneNumber;var isOffice=_props5.isOffice;var brokerFromOffice=_props5.brokerFromOffice;var userId=_props5.userId;var claimWizardDocType=_props5.claimWizardDocType;var packageInstance={};if(packageDSDocuments){packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");}clientId = clientId || this.props.clientId;packageId = packageId || this.props.packageId;clientOptionsDict = clientOptionsDict || this.props.clientOptionsDict; // +++++ determine clientlanguage and language word
	var clientLanguageWord=_nestedProperty2['default'].get(clientDataExt,clientId + ".detail.language");var clientLanguage='';if(clientOptionsDict && clientLanguageWord){clientLanguage = (0,_libHelpers.getTheLanguageCodeByAnyLanguageOnAnyLanguage)(clientLanguageWord,clientOptionsDict);} //hard coded the language for broker until we improve this module
	if(isOffice){clientLanguage = brokerFromOffice.main.language;}console.log('broker from office ::: ',brokerFromOffice);console.log('is office ::: ',isOffice);console.log('client language :::: ',clientLanguage); // ------------------------------------
	var clientTypeCode=isOffice?'':c.CLIENT_TYPE_PERSON; // CLIENT_TYPE_COMPANY
	var clientTypeWord=_nestedProperty2['default'].get(clientDataExt,clientId + ".main.clientType");if(clientOptionsDict && clientTypeWord){clientTypeCode = (0,_libHelpers.getTheClientTypeCodeByAnyLanguageOnAnyLanguage)(clientTypeWord,clientOptionsDict);}var clientFirstName=_nestedProperty2['default'].get(clientDataExt,clientId + ".main.firstName") || "";var clientLastName=_nestedProperty2['default'].get(clientDataExt,clientId + ".main.lastName") || "";var clientBirthDate=_nestedProperty2['default'].get(clientDataExt,clientId + ".main.dateOfBirth");var clientName=[clientFirstName,clientLastName].join(" ");var clientEmailAddresses=(0,_DSWizardFormControl.getClientEmailsInOptionList)(clientDataExt,clientId);var clientEmailAddress=_nestedProperty2['default'].get(clientEmailAddresses,"0.value"); // get the default email-address (ordered - first is default)
	var clientGSMPhoneNumbers=(0,_DSWizardFormControl.getClientGSMPhoneNumbers)(clientDataExt,clientId);var clientPhoneNumber=_nestedProperty2['default'].get(clientGSMPhoneNumbers,"0.value");var clientPhoneNumberCountryCode=_nestedProperty2['default'].get(clientGSMPhoneNumbers,"0.countryCode") || '+32';contractId = contractId || this.props.contractId;var theContract=(0,_DSWizardFormControl.findContractInClientObj)(client,contractId);var packageBrokerNumber=brokerNumberFromForm || _nestedProperty2['default'].get(packageInstance,"brokerNumber");var teamIndex=_nestedProperty2['default'].get(packageInstance,"team");var teamSubgroupId=_nestedProperty2['default'].get(packageInstance,"teamSubgroup");var contractDetails=this.state && this.state.contractDetails || null;var brokerNumber=packageBrokerNumber || (0,_DSWizardFormControl.getBrokerNumberByContract)(theContract,brokers,contractDetails); // broker number by contract or default
	//handle broker number if the module is fro office
	if(isOffice){brokerNumber = brokerFromOffice.brokerNumber;}var brokerInfo=(0,_DSWizardFormControl.getBrokerFullInfoByNumber)(brokerNumber,brokers); // broker number by contract or default
	var brokerEmailAddress='';if(!isOffice){brokerEmailAddress = _nestedProperty2['default'].get(brokerInfo,"main.emails.0");}var brokerName=_nestedProperty2['default'].get(brokerInfo,"main.name");var brokerSignerFirstName=userFirstName;var brokerSignerLastName=userLastName; //let brokerSignerBirthDate = moment().subtract(25, 'years').format("YYYY/MM/DD") // pick a random date
	// let brokerNameParts = String(brokerName).split(" ")
	// let brokerSignerFirstName = nesProp.get(brokerNameParts , "0")
	// let brokerSignerLastName = brokerNameParts.slice(1).join(" ")
	var brokerGSMPhoneNumbers=undefined;if(isOffice){brokerGSMPhoneNumbers = (0,_DSWizardFormControl.getBrokerGSMPhoneNumbers)(brokerFromOffice.main.phoneNumbers);clientEmailAddresses = (0,_DSWizardFormControl.getBrokerEmailsInOptionList)(brokerNumber,brokers,userId);clientPhoneNumber = _nestedProperty2['default'].get(brokerGSMPhoneNumbers,"0.value");clientEmailAddress = _nestedProperty2['default'].get(clientEmailAddresses,"0.value"); // get the default email-address (ordered - first is default)
	}else {brokerGSMPhoneNumbers = (0,_DSWizardFormControl.getBrokerGSMPhoneNumbers)(brokerInfo.main.phoneNumbers,userPhoneNumber);}var brokerPhoneNumber=_nestedProperty2['default'].get(brokerGSMPhoneNumbers,"0.value");var brokerPhoneNumberCountryCode=_nestedProperty2['default'].get(brokerGSMPhoneNumbers,"0.countryCode") || '+32';var remainderInterval=(0,_DSWizardFormControl.getDefaultRemainderInterval)(security,DSDocumentsConfig);var remainderRepeats=(0,_DSWizardFormControl.getDefaultRemainderRepeats)(security,DSDocumentsConfig);var remainderTicketInterval=(0,_DSWizardFormControl.getDefaultTarificationRemainderInterval)(security,DSDocumentsConfig);var remainderTicketRepeats=(0,_DSWizardFormControl.getDefaultTarificationRemainderRepeats)(security,DSDocumentsConfig);var expirationOn=(0,_DSWizardFormControl.getDefaultExpirationOn)(DSDocumentsConfig); // recalculate the template options by broker white lists and template white list match
	var moduleKeyFromState=_nestedProperty2['default'].get(this,"state.moduleKey");var subModuleKeyFromState=_nestedProperty2['default'].get(this,"state.subModuleKey");var moduleKey=moduleKeyFromState || moduleKeyFromProps;var subModuleKeyCalculated=subModuleKeyFromState || subModuleKey;var documentTemplateOptions=(0,_DSWizardHelper.getDocumentTemplateOptionList)(templates,lang,moduleKey,subModuleKeyCalculated,false,claimWizardDocType);if(moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKeyCalculated !== c.DS_MODULE_CLIENT_TARIFICATION){documentTemplateOptions = (0,_DSWizardHelper.filterTemplatesForBroker)(documentTemplateOptions,brokersTeamWhiteList,brokerNumber,teamIndex,teamSubgroupId);} // generate dynamic list of the fields for documents
	var flatDocumentsValueList=(0,_DSWizardFormControl.getFlatValueListOfDsDocumentsForForm)(packageDSDocuments,documentTemplateOptions);var packageIdFieldName=(0,_DSWizardFormControl.getPackageIdFieldName)();var tarificationId=_nestedProperty2['default'].get(this,"state.tarificationId") || this.props.tarificationId;var tarificationNumber=_nestedProperty2['default'].get(this,"state.tarificationNumber") || this.props.tarificationNumber;var firstSigningStakeholder=stakeholders && stakeholders.find(function(stakeholder){return stakeholder.signerNumber === '0';});var secondSigningStakeholder=stakeholders && stakeholders.find(function(stakeholder){return stakeholder.signerNumber === '1';});var brokerSigningStakeholder=stakeholders && stakeholders.find(function(stakeholder){return stakeholder.signerType === "BROKER";});var firstSigningSpreadPhoneNumberObject=_nestedProperty2['default'].get(firstSigningStakeholder,"phoneNumber")?(0,_DSWizardFormControl.spreadPhoneNumber)(_nestedProperty2['default'].get(firstSigningStakeholder,"phoneNumber")):null;var secondSigningSpreadPhoneNumberObject=_nestedProperty2['default'].get(secondSigningStakeholder,"phoneNumber")?(0,_DSWizardFormControl.spreadPhoneNumber)(_nestedProperty2['default'].get(secondSigningStakeholder,"phoneNumber")):null;var brokerSigningSpreadPhoneNumberObject=_nestedProperty2['default'].get(brokerSigningStakeholder,"phoneNumber")?(0,_DSWizardFormControl.spreadPhoneNumber)(_nestedProperty2['default'].get(brokerSigningStakeholder,"phoneNumber")):{phoneNumber:brokerPhoneNumber,phoneCode:brokerPhoneNumberCountryCode};var firstSignerLastName=firstSigningStakeholder && firstSigningStakeholder.lastName || clientLastName;var firstSignerFirstName=firstSigningStakeholder && firstSigningStakeholder.firstName || clientFirstName;if(!firstSignerFirstName && isOffice && brokerFromOffice.main.legalType === "1"){var spreadName=brokerFromOffice.main.name.split(' ');firstSignerLastName = spreadName[0];spreadName.shift();firstSignerFirstName = spreadName.join(' ');}var initialValues=_extends((_extends2 = {},_defineProperty(_extends2,packageIdFieldName,_nestedProperty2['default'].get(packageInstance,"_id") || packageId),_defineProperty(_extends2,"clientEmailAddress",_nestedProperty2['default'].get(packageInstance,"clientEmailAddress") || clientEmailAddress),_defineProperty(_extends2,"clientName",_nestedProperty2['default'].get(packageInstance,"clientName") || clientName),_defineProperty(_extends2,"clientTypeCode",_nestedProperty2['default'].get(packageInstance,"clientTypeCode") || clientTypeCode),_defineProperty(_extends2,"contractNumber",_nestedProperty2['default'].get(packageInstance,"contractNumber") || _nestedProperty2['default'].get(theContract,"contractMain.contractNumber")),_defineProperty(_extends2,"brokerNumber",_nestedProperty2['default'].get(packageInstance,"brokerNumber") || brokerNumber),_defineProperty(_extends2,"brokerEmailAddress",_nestedProperty2['default'].get(packageInstance,"brokerEmailAddress") || brokerEmailAddress),_defineProperty(_extends2,"brokerName",_nestedProperty2['default'].get(packageInstance,"brokerName") || brokerName),_defineProperty(_extends2,"team",_nestedProperty2['default'].get(packageInstance,"team") || ""),_defineProperty(_extends2,"teamName",_nestedProperty2['default'].get(packageInstance,"teamName") || ""),_defineProperty(_extends2,"teamSubgroup",_nestedProperty2['default'].get(packageInstance,"teamSubgroup") || ""),_defineProperty(_extends2,"tarificationId",_nestedProperty2['default'].get(packageInstance,"tarificationId") || tarificationId || ""),_defineProperty(_extends2,"tarificationNumber",_nestedProperty2['default'].get(packageInstance,"tarificationNumber") || tarificationNumber || ""),_defineProperty(_extends2,"remainderInterval",_nestedProperty2['default'].get(packageInstance,"remainderInterval") || remainderInterval),_defineProperty(_extends2,"remainderRepeats",_nestedProperty2['default'].get(packageInstance,"remainderRepeats") || remainderRepeats),_defineProperty(_extends2,"remainderTicketInterval",_nestedProperty2['default'].get(packageInstance,"remainderTicketInterval") || remainderTicketInterval),_defineProperty(_extends2,"remainderTicketRepeats",_nestedProperty2['default'].get(packageInstance,"remainderTicketRepeats") || remainderTicketRepeats),_defineProperty(_extends2,"expirationOn",_nestedProperty2['default'].get(packageInstance,"expirationOn") || expirationOn),_defineProperty(_extends2,"clientFirstName",_nestedProperty2['default'].get(packageInstance,"clientFirstName") || clientFirstName),_defineProperty(_extends2,"clientLastName",_nestedProperty2['default'].get(packageInstance,"clientLastName") || clientLastName),_defineProperty(_extends2,"clientBirthDate",_nestedProperty2['default'].get(packageInstance,"clientBirthDate") || clientBirthDate),_defineProperty(_extends2,"clientLanguageWord",clientLanguageWord),_defineProperty(_extends2,"clientLanguage",_nestedProperty2['default'].get(packageInstance,"clientLanguage") || clientLanguage),_defineProperty(_extends2,"status",_nestedProperty2['default'].get(packageInstance,"status") || 'initialized'),_defineProperty(_extends2,"firstSignerFirstName",firstSignerFirstName),_defineProperty(_extends2,"firstSignerLastName",firstSignerLastName),_defineProperty(_extends2,"firstSignerPhoneNumber",firstSigningSpreadPhoneNumberObject?firstSigningSpreadPhoneNumberObject.phoneNumber:clientPhoneNumber),_defineProperty(_extends2,"firstSignerCountryPhoneCode",firstSigningSpreadPhoneNumberObject?firstSigningSpreadPhoneNumberObject.phoneCode:clientPhoneNumberCountryCode),_defineProperty(_extends2,"secondSignerLanguage",secondSigningStakeholder && secondSigningStakeholder.language || ""),_defineProperty(_extends2,"secondSignerEmailAddress",secondSigningStakeholder && secondSigningStakeholder.email || ""),_defineProperty(_extends2,"secondSignerFirstName",secondSigningStakeholder && secondSigningStakeholder.firstName || ""),_defineProperty(_extends2,"secondSignerLastName",secondSigningStakeholder && secondSigningStakeholder.lastName || ""),_defineProperty(_extends2,"secondSignerPhoneNumber",secondSigningSpreadPhoneNumberObject?secondSigningSpreadPhoneNumberObject.phoneNumber:""),_defineProperty(_extends2,"secondSignerCountryPhoneCode",secondSigningSpreadPhoneNumberObject?secondSigningSpreadPhoneNumberObject.phoneCode:""),_defineProperty(_extends2,"brokerSignerFirstName",brokerSigningStakeholder && brokerSigningStakeholder.firstName || brokerSignerFirstName),_defineProperty(_extends2,"brokerSignerLastName",brokerSigningStakeholder && brokerSigningStakeholder.lastName || brokerSignerLastName),_defineProperty(_extends2,"brokerSignerPhoneNumber",brokerSigningSpreadPhoneNumberObject?brokerSigningSpreadPhoneNumberObject.phoneNumber:brokerPhoneNumber),_defineProperty(_extends2,"brokerSignerCountryPhoneCode",brokerSigningSpreadPhoneNumberObject?brokerSigningSpreadPhoneNumberObject.phoneCode:brokerPhoneNumberCountryCode),_defineProperty(_extends2,"claimId",claimId),_defineProperty(_extends2,"claimNumber",claimNumber),_extends2),flatDocumentsValueList);return initialValues;} /**
	     * Change one input value in state, validate also.
	     * @param {*} value
	     * @param {*} formFieldName
	     * @param {*} forceTouch
	     * @param {*} callback
	     */},{key:'onChangeFormInput',value:function onChangeFormInput(value,formFieldName){var forceTouch=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];var callback=arguments.length <= 3 || arguments[3] === undefined?function(){}:arguments[3];var forceFormInputs=arguments.length <= 4 || arguments[4] === undefined?null:arguments[4];var _state4=this.state;var formInputs=_state4.formInputs;var packageDSDocuments=_state4.packageDSDocuments;var DSDocumentOriginTypes=this.props.DSDocumentOriginTypes;var newFormInputs=forceFormInputs || formInputs; //get the object from state to be able to set the validity value in it.
	var formField=newFormInputs[formFieldName]; // handle touch input
	if(formField.value !== value && forceTouch === null){formField.touched = true;}if(forceTouch !== null){formField.touched = forceTouch;} // set the value
	formField.value = value; // set the validity in object, this will be set because it passed by address in JS
	formField = (0,_DSWizardFormControl.fieldValidation)(formField); // set the newly validate input to the list
	newFormInputs[formFieldName] = formField; // reset the flag of form validity
	var isValidTheForm=(0,_DSWizardFormControl.validateTheForm)(newFormInputs,packageDSDocuments,DSDocumentOriginTypes); // put back into the state
	this.setState({formInputs:newFormInputs,isValidTheForm:isValidTheForm},function(){if(callback){return callback(newFormInputs);}});return newFormInputs;} /**
	     * Get contract id by contract number from client data
	     */},{key:'getContractIdByNumber',value:function getContractIdByNumber(contractNumber){var client=this.props.client;var result='';var contracts=_nestedProperty2['default'].get(client,"contracts");if(!contracts || contracts.length === 0){return result;}var objKeys=Object.keys(contracts);objKeys && objKeys.map(function(oneKey){var oneContractNumber=_nestedProperty2['default'].get(contracts,oneKey + ".contractMain.contractNumber");if(oneContractNumber + "" === contractNumber + ""){result = _nestedProperty2['default'].get(contracts,oneKey + ".contractMain.contractId");}});return result;} /**
	     * Finish the first step of wizard and step forward.
	     */},{key:'setupTarificationForPackageAndDocs', /**
	     * This function will handle the tarification related values for the package.
	     * If there is a tarification already added then just return it in promise, else
	     * will generate one using oracle procedures, and will return with that.
	     * @param {*} clientId
	     * @param {*} brokerNumber
	     * @param {*} teamIndex
	     * @param {*} tarificationId
	     * @param {*} tarificationNumber
	     * @param {*} packageDSDocuments
	     * @param {*} formInputs
	     * @returns Promise: {packageDSDocuments, formInputs, tarificationId, tarificationNumber}
	     */value:function setupTarificationForPackageAndDocs(clientId,brokerNumber,teamIndex,tarificationId,tarificationNumber,packageDSDocuments,formInputs){var dispatch,tarificationInfo,isLinkedAllDocumentsWithTarification,listOfTarificationNumbers,firstTarificationIdNumberPair,setTarifResult,createTarificationParams,createTarifResult;return regeneratorRuntime.async(function setupTarificationForPackageAndDocs$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:dispatch = this.props.dispatch;tarificationInfo = {tarificationId:tarificationId,tarificationNumber:tarificationNumber};isLinkedAllDocumentsWithTarification = (0,_DSWizardHelper.allDocumentsHasTarificationNumber)(packageDSDocuments);if(!isLinkedAllDocumentsWithTarification){context$2$0.next = 5;break;}return context$2$0.abrupt('return',_extends({},tarificationInfo,{packageDSDocuments:packageDSDocuments,formInputs:formInputs}));case 5:listOfTarificationNumbers = (0,_DSWizardHelper.getDocumentsTarificationNumbersList)(packageDSDocuments);firstTarificationIdNumberPair = _nestedProperty2['default'].get(listOfTarificationNumbers,"0");if(!(firstTarificationIdNumberPair && firstTarificationIdNumberPair.tarificationId)){context$2$0.next = 14;break;}context$2$0.next = 10;return regeneratorRuntime.awrap(this.setTarificationInfoForAllDocuments(packageDSDocuments,formInputs,firstTarificationIdNumberPair.tarificationId,firstTarificationIdNumberPair.tarificationNumber));case 10:setTarifResult = context$2$0.sent;packageDSDocuments = setTarifResult.packageDSDocuments;formInputs = setTarifResult.formInputs;return context$2$0.abrupt('return',_extends({},tarificationInfo,{packageDSDocuments:packageDSDocuments,formInputs:formInputs}));case 14:createTarificationParams = {clientId:clientId,brokerNumber:brokerNumber,tarificationTeam:teamIndex};context$2$0.next = 17;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.createClientTarification)(createTarificationParams)));case 17:createTarifResult = context$2$0.sent;context$2$0.prev = 18; // setup tarification for package inputs
	formInputs = this.onChangeFormInput(createTarifResult.tarificationId,"tarificationId",null,null,formInputs);formInputs = this.onChangeFormInput(createTarifResult.tarificationNumber,"tarificationNumber",null,null,formInputs); // fill the form documents properties with the new tarification values and return a promise
	context$2$0.next = 23;return regeneratorRuntime.awrap(this.setTarificationInfoForAllDocuments(packageDSDocuments,formInputs,createTarifResult.tarificationId,createTarifResult.tarificationNumber));case 23:setTarifResult = context$2$0.sent;packageDSDocuments = setTarifResult.packageDSDocuments;formInputs = setTarifResult.formInputs;context$2$0.next = 32;break;case 28:context$2$0.prev = 28;context$2$0.t0 = context$2$0['catch'](18);console.error(context$2$0.t0);throw context$2$0.t0;case 32:return context$2$0.abrupt('return',_extends({},createTarifResult,{packageDSDocuments:packageDSDocuments,formInputs:formInputs}));case 33:case 'end':return context$2$0.stop();}},null,this,[[18,28]]);} /**
	     * This function helps to use an icon on a safe way
	     */},{key:'getIcon',value:function getIcon(menuName){try{return __webpack_require__(591)("./" + menuName + '.svg');}catch(err) {return __webpack_require__(23);}} /**
	     *
	     * @param {*} templateId
	     * @returns
	     */},{key:'getTeamOptionsByTemplateId',value:function getTeamOptionsByTemplateId(templateId){var _props6=this.props;var templates=_props6.templates;var lang=_props6.lang;var clientOptionsDict=_props6.clientOptionsDict;var teamsOptions=this.state.teamsOptions; // language can be selected depending on template
	var teamsList=(0,_DSWizardHelper.getTeamsOptionList)(clientOptionsDict,lang);var teamWhiteList=[]; // extend the languageWhiteList with the values what support the selected template (check html existence in record)
	if(templates && templates.length && templateId){(function(){ // find template in the list of all templates
	var templateForTheNewDoc=templates.filter(function(item){return item._id === templateId;}); // get the template instance from result
	var templateInstance=_nestedProperty2['default'].get(templateForTheNewDoc,"0"); // check the languages if exist in template, what mean check the html path have value on that language index
	teamsList.forEach(function(oneTeam){if(oneTeam.value == _nestedProperty2['default'].get(templateInstance,"teamId.teamIndex")){teamWhiteList.push(oneTeam.value);}});})();} // compose the language list for the current Select element in the render, using th whitelist created using the template.
	var filteredLanguageOptions=teamsOptions.filter(function(item){return teamWhiteList.includes(item.value);});return filteredLanguageOptions;} /**
	     * This function will create a new document for the package, can be added to the sate
	     * @param {array} packageDSDocuments - package documents
	     * @param {string} clientLanguage - form inputs list
	     * @param {object} teamInfo - teamInfo
	     * @param {number} dynamicFieldIdCursor - cursor index for docs
	     * @param {array} languageOptions - cursor index for docs
	     * @param {array} documentTemplateOptions - cursor index for docs
	     * @param {object} moduleEntityArguments - this object can contains contract, claim, tarification information
	     * Options for moduleEntityArguments: {contractId, tarificationId, tarificationNumber, moduleKey, subModuleKey, isPrem}
	     * @param {object} localDocument - provided by uploader/attachment modal (v8)
	     * @param {object} oracleDocument - provided by oracle (v8)
	     * @returns
	     */},{key:'createDSDocumentForPackage',value:function createDSDocumentForPackage(packageDSDocuments,clientLanguage,teamInfo,dynamicFieldIdCursor,languageOptions,documentTemplateOptions,moduleEntityArguments){var localDocument=arguments.length <= 7 || arguments[7] === undefined?null:arguments[7];var oracleDocument=arguments.length <= 8 || arguments[8] === undefined?null:arguments[8];var _props7,templates,security,DSDocumentOriginTypes,client,contractId,tarificationId,tarificationNumber,claimId,claimNumber,moduleKey,subModuleKey,isPrem,isItTarificationModule,blankDSDocumentInstance,isRequiredTarification,filteredLanguageOptions,yesAllowedLang,theContract,templateForTheNewDoc,sameDocumentWithSize,documentFormInputs;return regeneratorRuntime.async(function createDSDocumentForPackage$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props7 = this.props;templates = _props7.templates;security = _props7.security;DSDocumentOriginTypes = _props7.DSDocumentOriginTypes;client = _props7.client;contractId = moduleEntityArguments.contractId;tarificationId = moduleEntityArguments.tarificationId;tarificationNumber = moduleEntityArguments.tarificationNumber;claimId = moduleEntityArguments.claimId;claimNumber = moduleEntityArguments.claimNumber;moduleKey = moduleEntityArguments.moduleKey;subModuleKey = moduleEntityArguments.subModuleKey;isPrem = moduleEntityArguments.isPrem;isItTarificationModule = moduleEntityArguments.isItTarificationModule;blankDSDocumentInstance = (0,_DSWizardFormControl.getNewDSDocumentInstance)(security); // set unique cursor for the new instance to be able to handle it, that is a kind of temporal ID to assign it
	blankDSDocumentInstance.cursor = dynamicFieldIdCursor; //INCREASE by ONE and save the global cursor (temporal ID)
	dynamicFieldIdCursor += 1; // +++++++ PREM CASE
	// WHEN WE HAVE THE PREM CASE, ONLY ON TEMPLATE IS IN THE LIST, the prem template it is. !!deprecated!!
	// select the first one values from options of selection list to init the document instance in case we are in PREM dswizard flow !!deprecated!!
	//update BEWB - 706 prem module should behave like tariffication
	// update BEWB - 706 we need to add a default document with flag requiredOnPrem, this doc can't be removed, these documents are to be removed from documents list and stored in a different list
	if(isPrem){_nestedProperty2['default'].set(blankDSDocumentInstance,"documentTemplateId",_nestedProperty2['default'].get(documentTemplateOptions,"0.value"));documentTemplateOptions;} // ------- PREM CASE
	if(isItTarificationModule){} // IMPORTANT: LET IT BLANK DO NOT SELECT ANY TEMPLATE: BEWB-664
	// nesProp.set(blankDSDocumentInstance, "documentTemplateId", nesProp.get(documentTemplateOptions, "0.value"))
	// case is claimWizard there should always be only one document template add should be added by default
	if(moduleKey === c.DS_MODULE_CLAIM_WIZARD && !localDocument && !oracleDocument){_nestedProperty2['default'].set(blankDSDocumentInstance,"documentTemplateId",_nestedProperty2['default'].get(documentTemplateOptions,"0.value"));}_nestedProperty2['default'].set(blankDSDocumentInstance,"subModuleKey",subModuleKey); // init team for the doc when we are on tarification
	isRequiredTarification = moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION; // in case if the tarification is required, then we clone the team information from the package for the individual documents
	// else just leave it empty
	if(isRequiredTarification){blankDSDocumentInstance.team = _nestedProperty2['default'].get(teamInfo,"team") || null;blankDSDocumentInstance.teamName = _nestedProperty2['default'].get(teamInfo,"teamName") || null;blankDSDocumentInstance.teamSubgroup = _nestedProperty2['default'].get(teamInfo,"teamSubgroup") || null;}else {blankDSDocumentInstance.team = null;blankDSDocumentInstance.teamName = null;blankDSDocumentInstance.teamSubgroup = null;} // language can be selected depending on template
	filteredLanguageOptions = (0,_DSWizardHelper.getLanguageOptionsByTemplateId)(blankDSDocumentInstance.documentTemplateId,templates,languageOptions); // get the fist value from the possible languages
	blankDSDocumentInstance.language = _nestedProperty2['default'].get(filteredLanguageOptions,"0.value"); // BEWB-443 the LANGUAGE of the document to be the language of the user by default
	yesAllowedLang = false;filteredLanguageOptions.forEach(function(item){yesAllowedLang = yesAllowedLang || item.value === clientLanguage;});if(yesAllowedLang){blankDSDocumentInstance.language = clientLanguage;} // get the the possible CONTRACTNUMBER
	if(contractId){theContract = (0,_DSWizardFormControl.findContractInClientObj)(client,contractId); // sync call
	blankDSDocumentInstance.contractNumber = _nestedProperty2['default'].get(theContract,"contractMain.contractNumber");blankDSDocumentInstance.contractId = contractId;} // get the the possible ClaimId
	if(claimId){blankDSDocumentInstance.claimNumber = claimNumber;blankDSDocumentInstance.claimId = claimId;} // get the the possible TARIFICATIONID
	if(tarificationId){blankDSDocumentInstance.tarificationId = tarificationId;blankDSDocumentInstance.tarificationNumber = tarificationNumber;} // set the ORIGIN and the origin specific details for the new dynamic document
	// by default is generated document
	blankDSDocumentInstance.origin = DSDocumentOriginTypes.DS_ORIGIN_GENERATED; // +++++++ EXTRA FIELDS FOR UPLOADED DOCUMENTS
	// when a document is uploaded from local device, overwrite the origin and specific related data
	if(localDocument){blankDSDocumentInstance.originalFileName = localDocument.originalFileName;blankDSDocumentInstance.temporaryUploadId = localDocument._id;blankDSDocumentInstance.origin = DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD;blankDSDocumentInstance.documentUploadGroupTypeId = localDocument.documentUploadGroupTypeId;blankDSDocumentInstance.documentTypeIdx = localDocument.lowValue;blankDSDocumentInstance.language = clientLanguage;blankDSDocumentInstance.uploadComment = localDocument.uploadComment;blankDSDocumentInstance.attachmentConnectionId = localDocument.attachmentConnectionId || '';blankDSDocumentInstance.isAttachment = localDocument.isAttachment || false;blankDSDocumentInstance.positionInUploadDoc = localDocument.positionInUploadDoc || '';} // --------- END of handling UPLOADED documents
	// +++++++ EXTRA FIELDS FOR ORACLE DOCUMENTS
	// when a document is selected from oracle, overwrite the origin and specific related data
	if(oracleDocument){blankDSDocumentInstance.oracleDocumentId = oracleDocument.oracleDocumentId;blankDSDocumentInstance.oracleDocumentType = oracleDocument.oracleDocumentType;blankDSDocumentInstance.origin = DSDocumentOriginTypes.DS_ORIGIN_ORACLE;blankDSDocumentInstance.oracleDocumentName = oracleDocument.oracleDocumentName || oracleDocument.oracleDocumentId; // TODO ask if it is ok
	// no template enforce client language
	blankDSDocumentInstance.language = clientLanguage;blankDSDocumentInstance.documentSelectionTab = oracleDocument.documentSelectionTab;blankDSDocumentInstance.oracleDocumentUploadDate = oracleDocument.oracleDocumentUploadDate;} // --------- END of handling ORACLE documents
	// link the template record for the new doc instance
	if(templates && templates.length && blankDSDocumentInstance.documentTemplateId){templateForTheNewDoc = templates.filter(function(item){return item._id === blankDSDocumentInstance.documentTemplateId;});_nestedProperty2['default'].set(blankDSDocumentInstance,"documentTemplate",_nestedProperty2['default'].get(templateForTheNewDoc,"0"));} // finally extend the package documents list also, to be able to work with documents.
	packageDSDocuments.push(blankDSDocumentInstance); // +++++ process FILE SIZES for documents +++++++
	context$2$0.next = 38;return regeneratorRuntime.awrap(this.updateDocumentSizesForAllDsDocuments(packageDSDocuments));case 38:packageDSDocuments = context$2$0.sent;sameDocumentWithSize = packageDSDocuments.filter(function(oneDoc){return oneDoc.cursor === blankDSDocumentInstance.cursor;});blankDSDocumentInstance = sameDocumentWithSize[0]; // ++++ Important notice +++ This operation to produce fields for the document must be the last operation, to give corect
	// initial values for inputs by the document instances
	// push a new form field set for the new document properties in form
	documentFormInputs = (0,_DSWizardFormControl.getDynamicInputFieldByCursor)(blankDSDocumentInstance,moduleKey,subModuleKey,DSDocumentOriginTypes);return context$2$0.abrupt('return',{packageDSDocuments:packageDSDocuments,documentFormInputs:documentFormInputs,dynamicFieldIdCursor:dynamicFieldIdCursor});case 43:case 'end':return context$2$0.stop();}},null,this);} /**
	     *
	     * @param {*} packageDSDocuments
	     * @returns
	     */},{key:'updateDocumentSizesForAllDsDocuments',value:function updateDocumentSizesForAllDsDocuments(packageDSDocuments){var _props8,DSDocumentOriginTypes,dispatch,generatedDocs,oraDocsDocs,uploadedDocs,fileSizeList,i,j;return regeneratorRuntime.async(function updateDocumentSizesForAllDsDocuments$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props8 = this.props;DSDocumentOriginTypes = _props8.DSDocumentOriginTypes;dispatch = _props8.dispatch;generatedDocs = packageDSDocuments.filter(function(oneDoc){return oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED;}).map(function(oneDoc){return oneDoc.documentTemplateId;});oraDocsDocs = packageDSDocuments.filter(function(oneDoc){return oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_ORACLE;}).map(function(oneDoc){return {oracleDocumentId:oneDoc.oracleDocumentId,oracleDocumentType:oneDoc.oracleDocumentType};});uploadedDocs = packageDSDocuments.filter(function(oneDoc){return oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD;}).map(function(oneDoc){return oneDoc.temporaryUploadId;});context$2$0.next = 8;return regeneratorRuntime.awrap(dispatch((0,_stateActions.fetchDsDocumentSizeList)(generatedDocs,oraDocsDocs,uploadedDocs)));case 8:fileSizeList = context$2$0.sent; // iterate al docs and update the result sizes by origin on it
	for(i = 0;i < packageDSDocuments.length;i++) { // update ora template documents for size
	for(j = 0;j < fileSizeList.DS_ORIGIN_GENERATED.length;j++) {if(packageDSDocuments[i].documentTemplateId === fileSizeList.DS_ORIGIN_GENERATED[j].documentTemplateId){packageDSDocuments[i].fileSize = fileSizeList.DS_ORIGIN_GENERATED[j].size;packageDSDocuments[i].isEncrypted = false;}} // update ora docs for size
	for(j = 0;j < fileSizeList.DS_ORIGIN_ORACLE.length;j++) {if(packageDSDocuments[i].oracleDocumentId === fileSizeList.DS_ORIGIN_ORACLE[j].oracleDocumentId && packageDSDocuments[i].oracleDocumentType === fileSizeList.DS_ORIGIN_ORACLE[j].oracleDocumentType){packageDSDocuments[i].fileSize = fileSizeList.DS_ORIGIN_ORACLE[j].size;packageDSDocuments[i].isEncrypted = fileSizeList.DS_ORIGIN_ORACLE[j].isEncrypted;}} // update ora template documents for size
	for(j = 0;j < fileSizeList.DS_ORIGIN_LOCAL_UPLOAD.length;j++) {if(packageDSDocuments[i].temporaryUploadId === fileSizeList.DS_ORIGIN_LOCAL_UPLOAD[j].temporaryUploadId){packageDSDocuments[i].fileSize = fileSizeList.DS_ORIGIN_LOCAL_UPLOAD[j].size;packageDSDocuments[i].isEncrypted = fileSizeList.DS_ORIGIN_LOCAL_UPLOAD[j].isEncrypted;}}}return context$2$0.abrupt('return',packageDSDocuments);case 11:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This will change the template for a doc on packageDSDocuments and formInputs as well.
	     * This will fire the this.on ChangeLanguageForDoc as well with default value.
	     * @param {*} value
	     * @param {*} docTemplateFieldName
	     * @param {*} packageDSDocuments
	     * @param {*} documentCursor
	     */},{key:'onChangeTemplateForDoc',value:function onChangeTemplateForDoc(value,docTemplateFieldName,packageDSDocuments,formInputs,documentCursor){var _state5,moduleKey,subModuleKey,languageOptions,stakeholders,isPrem,signerAvailabilityOfTemplates,dynamicFieldIdCursor,initiatorEmailAddressesFromTemplates,_props9,templates,DSDocumentOriginTypes,isOffice,selectedTemplateId,clientLanguage,selectedTemplateRecord,filteredLanguageOptions,initiatorEmailAddressesFromTemplatesCopy,_loop,index,_iteratorNormalCompletion3,_didIteratorError3,_iteratorError3,_iterator3,_step3,_ret2,isValidTheForm,addSignersButtonFlags,isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder;return regeneratorRuntime.async(function onChangeTemplateForDoc$(context$2$0){var _this5=this;while(1) switch(context$2$0.prev = context$2$0.next){case 0:_state5 = this.state;moduleKey = _state5.moduleKey;subModuleKey = _state5.subModuleKey;languageOptions = _state5.languageOptions;stakeholders = _state5.stakeholders;isPrem = _state5.isPrem;signerAvailabilityOfTemplates = _state5.signerAvailabilityOfTemplates;dynamicFieldIdCursor = _state5.dynamicFieldIdCursor;initiatorEmailAddressesFromTemplates = _state5.initiatorEmailAddressesFromTemplates;_props9 = this.props;templates = _props9.templates;DSDocumentOriginTypes = _props9.DSDocumentOriginTypes;isOffice = _props9.isOffice;selectedTemplateId = _nestedProperty2['default'].get(value,"value");clientLanguage = _nestedProperty2['default'].get(formInputs,"clientLanguage.value");formInputs = this.onChangeFormInput(selectedTemplateId || "",docTemplateFieldName,null,null,formInputs); // find the affected template record
	selectedTemplateRecord = templates.filter(function(item){return item._id.toString() === selectedTemplateId?selectedTemplateId.toString():'';});selectedTemplateRecord = _nestedProperty2['default'].get(selectedTemplateRecord,"0") || null; // change the language selected in case that is the old value is restricted
	filteredLanguageOptions = (0,_DSWizardHelper.getLanguageOptionsByTemplateId)(selectedTemplateId,templates,languageOptions);initiatorEmailAddressesFromTemplatesCopy = [].concat(_toConsumableArray(initiatorEmailAddressesFromTemplates));if(!packageDSDocuments){context$2$0.next = 32;break;}_loop = function callee$2$0(index){var oneDocument,attachedDocumentsToRemove,oneDocToRemove,removeDocumentsRes,docListToCheckSize,documentSizeFieldName,currentDocLang,isEnabledTheDocLang,team,teamName,teamSubgroup,tarificationId,tarificationNumber,docTeamFieldName,docTeamNameFieldName,docTarificationIdFieldName,docTeamSubgroupFieldName,docTarificationNumberFieldName,connectionId,attachmentConnectionIdFieldName,handleDocsResult;return regeneratorRuntime.async(function callee$2$0$(context$3$0){var _this4=this;while(1) switch(context$3$0.prev = context$3$0.next){case 0:oneDocument = packageDSDocuments[index];if(!(oneDocument.cursor != documentCursor)){context$3$0.next = 3;break;}return context$3$0.abrupt('return','continue');case 3: // if this is office than the initiator is not just a broker and "broker email addresses are set from the templates
	if(isOffice && selectedTemplateRecord && selectedTemplateRecord.initiatorEmailAddress){(function(){ // remove emails from initiator list that originate from removed "documents from office"
	var emailsFromTemplateMapResult=packageDSDocuments.map(function(oneDoc){var oneTemplateArray=templates.filter(function(item){return oneDoc.cursor !== documentCursor && oneDoc.documentTemplateId && item._id.toString() === oneDoc.documentTemplateId.toString();});var oneTemplate=_nestedProperty2['default'].get(oneTemplateArray,"0") || null;return oneTemplate && oneTemplate.initiatorEmailAddress;});initiatorEmailAddressesFromTemplatesCopy = initiatorEmailAddressesFromTemplatesCopy.filter(function(email){return emailsFromTemplateMapResult.includes(email.value);}); //add new email address if it's the case 
	if(!initiatorEmailAddressesFromTemplatesCopy.some(function(oneEmailOption){return oneEmailOption.value === selectedTemplateRecord.initiatorEmailAddress;})){var emailOption={value:selectedTemplateRecord.initiatorEmailAddress,label:selectedTemplateRecord.initiatorEmailAddress};if(initiatorEmailAddressesFromTemplatesCopy.length === 0 || !initiatorEmailAddressesFromTemplatesCopy.some(function(oneEmailOption){return oneEmailOption.value === formInputs['brokerEmailAddress'];})){formInputs = _this4.onChangeFormInput(selectedTemplateRecord.initiatorEmailAddress,'brokerEmailAddress',null,null,formInputs);}initiatorEmailAddressesFromTemplatesCopy.push(emailOption);}})();} //check if there attached documents from template
	attachedDocumentsToRemove = packageDSDocuments.filter(function(oneDsDoc){return oneDocument.attachmentConnectionId && oneDsDoc.attachmentConnectionId === oneDocument.attachmentConnectionId && oneDsDoc.cursor !== oneDocument.cursor;});_iteratorNormalCompletion3 = true;_didIteratorError3 = false;_iteratorError3 = undefined;context$3$0.prev = 8;_iterator3 = attachedDocumentsToRemove[Symbol.iterator]();case 10:if(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done){context$3$0.next = 20;break;}oneDocToRemove = _step3.value;context$3$0.next = 14;return regeneratorRuntime.awrap(this.removeAttachmentDocument(oneDocToRemove.cursor,formInputs,packageDSDocuments));case 14:removeDocumentsRes = context$3$0.sent;packageDSDocuments = removeDocumentsRes.packageDSDocuments;formInputs = removeDocumentsRes.formInputs;case 17:_iteratorNormalCompletion3 = true;context$3$0.next = 10;break;case 20:context$3$0.next = 26;break;case 22:context$3$0.prev = 22;context$3$0.t0 = context$3$0['catch'](8);_didIteratorError3 = true;_iteratorError3 = context$3$0.t0;case 26:context$3$0.prev = 26;context$3$0.prev = 27;if(!_iteratorNormalCompletion3 && _iterator3['return']){_iterator3['return']();}case 29:context$3$0.prev = 29;if(!_didIteratorError3){context$3$0.next = 32;break;}throw _iteratorError3;case 32:return context$3$0.finish(29);case 33:return context$3$0.finish(26);case 34: // set the affected document template in state also
	_nestedProperty2['default'].set(packageDSDocuments,index + ".documentTemplate",selectedTemplateRecord);_nestedProperty2['default'].set(packageDSDocuments,index + ".documentTemplateId",selectedTemplateId); // -------------------- CHECK LANGUAGE WHITELIST SECTION ----
	// ++++++++ check the size by API call, only one doc to check in this case
	// the result contains only just the lonely document
	context$3$0.next = 38;return regeneratorRuntime.awrap(this.updateDocumentSizesForAllDsDocuments([packageDSDocuments[index]]));case 38:docListToCheckSize = context$3$0.sent; // put be the doc in place, the result have only one result, the first one needed
	packageDSDocuments[index] = docListToCheckSize[0]; // -------------------------
	documentSizeFieldName = (0,_DSWizardFormControl.getDynamicFieldNameForSize)(documentCursor);formInputs = this.onChangeFormInput(packageDSDocuments[index].fileSize || 0,documentSizeFieldName,null,null,formInputs); // check if the language is not in the white list of the template
	currentDocLang = _nestedProperty2['default'].get(packageDSDocuments,index + ".language");isEnabledTheDocLang = false; // check if must change
	filteredLanguageOptions.forEach(function(oneWhiteListedLang){if(oneWhiteListedLang.value === currentDocLang){isEnabledTheDocLang = true;}}); // in case the current language is not enabled, then change it
	if(!isEnabledTheDocLang){(function(){ //nesProp.set(packageDSDocuments, index+".language", nesProp.get(filteredLanguageOptions, "0.value"))
	var docLangFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocLang)(documentCursor); // BEWB-443 the language of the document to be the language of the user by default
	var yesAllowedLang=false;filteredLanguageOptions.forEach(function(oneWhiteListedLang){yesAllowedLang = yesAllowedLang || oneWhiteListedLang.value === clientLanguage;});var defaultLanguageForDoc=_nestedProperty2['default'].get(filteredLanguageOptions,"0.value");if(yesAllowedLang){defaultLanguageForDoc = clientLanguage;}formInputs = _this4.onChangeFormInput(_nestedProperty2['default'].get(defaultLanguageForDoc,"value") || "",docLangFieldName,null,null,formInputs);_nestedProperty2['default'].set(packageDSDocuments,index + ".language",_nestedProperty2['default'].get(defaultLanguageForDoc,"value"));_nestedProperty2['default'].set(packageDSDocuments,index + ".brokerFilledValues",null);_nestedProperty2['default'].set(packageDSDocuments,index + ".isPrinted",false);})();} // -----------------------------------------------------------------------
	// -----------------  Clone the tarification info --------------------------
	// templates depends on teams by priority, do not change a higher level value
	team = _nestedProperty2['default'].get(formInputs,"team.value");teamName = _nestedProperty2['default'].get(formInputs,"teamName.value");teamSubgroup = _nestedProperty2['default'].get(formInputs,"teamSubgroup.value");tarificationId = _nestedProperty2['default'].get(formInputs,"tarificationId.value");tarificationNumber = _nestedProperty2['default'].get(formInputs,"tarificationNumber.value");_nestedProperty2['default'].set(packageDSDocuments,index + ".team",team);_nestedProperty2['default'].set(packageDSDocuments,index + ".teamName",teamName);_nestedProperty2['default'].set(packageDSDocuments,index + ".teamSubgroup",teamSubgroup);_nestedProperty2['default'].set(packageDSDocuments,index + ".tarificationId",tarificationId);_nestedProperty2['default'].set(packageDSDocuments,index + ".tarificationNumber",tarificationNumber);docTeamFieldName = (0,_DSWizardFormControl.getDynamicFieldNameForDocTeam)(oneDocument.cursor);docTeamNameFieldName = (0,_DSWizardFormControl.getDynamicFieldNameForDocTeamName)(oneDocument.cursor);docTarificationIdFieldName = (0,_DSWizardFormControl.getDynamicFieldNameForDocTarificationId)(oneDocument.cursor);docTeamSubgroupFieldName = (0,_DSWizardFormControl.getDynamicFieldNameForDocTeamSubgroup)(oneDocument.cursor);docTarificationNumberFieldName = (0,_DSWizardFormControl.getDynamicFieldNameForDocTarificationNumber)(oneDocument.cursor);formInputs = this.onChangeFormInput(team,docTeamFieldName,null,null,formInputs);formInputs = this.onChangeFormInput(teamName,docTeamNameFieldName,null,null,formInputs);formInputs = this.onChangeFormInput(tarificationId,docTarificationIdFieldName,null,null,formInputs);formInputs = this.onChangeFormInput(tarificationNumber,docTarificationNumberFieldName,null,null,formInputs);formInputs = this.onChangeFormInput(teamSubgroup,docTeamSubgroupFieldName,null,null,formInputs); // -----------------------------------------------------------------------
	// reset the filled values and the printed status on template change
	_nestedProperty2['default'].set(packageDSDocuments,index + ".brokerFilledValues",null);_nestedProperty2['default'].set(packageDSDocuments,index + ".isPrinted",false); // Create a connection id for attached pdf's if there are any
	connectionId = (0,_uuidV42['default'])();_nestedProperty2['default'].set(packageDSDocuments,index + ".attachmentConnectionId",connectionId);attachmentConnectionIdFieldName = (0,_DSWizardFormControl.getDynamicFieldNameAttachmentConnectionId)(oneDocument.cursor);formInputs = this.onChangeFormInput(connectionId,attachmentConnectionIdFieldName,null,null,formInputs); // add documents attached to template if any
	context$3$0.next = 74;return regeneratorRuntime.awrap(this.handleDocsAttachedToGeneratedTemplates(packageDSDocuments,index,formInputs,selectedTemplateRecord,dynamicFieldIdCursor));case 74:handleDocsResult = context$3$0.sent;packageDSDocuments = handleDocsResult.packageDSDocuments;formInputs = handleDocsResult.formInputs;dynamicFieldIdCursor = handleDocsResult.dynamicFieldIdCursor;case 78:case 'end':return context$3$0.stop();}},null,_this5,[[8,22,26,34],[27,,29,33]]);};index = 0;case 23:if(!(index < packageDSDocuments.length)){context$2$0.next = 32;break;}context$2$0.next = 26;return regeneratorRuntime.awrap(_loop(index));case 26:_ret2 = context$2$0.sent;if(!(_ret2 === 'continue')){context$2$0.next = 29;break;}return context$2$0.abrupt('continue',29);case 29:index++;context$2$0.next = 23;break;case 32:formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,true);addSignersButtonFlags = (0,_DSWizardHelper.getSignerAdderButtonsFlags)(packageDSDocuments,DSDocumentOriginTypes,isPrem,signerAvailabilityOfTemplates);isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder;isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder;isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder; // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
	// those properties, so don't do that
	//---------------- end handle enabled signers list
	// finally update all of process result in state
	this.setState({isItExistFirstSignerPlaceholder:isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder:isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder:isItExistBrokerSignerPlaceholder,isValidTheForm:isValidTheForm,formInputs:formInputs,packageDSDocuments:packageDSDocuments,dynamicFieldIdCursor:dynamicFieldIdCursor,initiatorEmailAddressesFromTemplates:initiatorEmailAddressesFromTemplatesCopy});return context$2$0.abrupt('return',{formInputs:formInputs,packageDSDocuments:packageDSDocuments,isValidTheForm:isValidTheForm});case 41:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This method will fill or clean the form inputs for signers depends on added documents to the list.
	     * @param {object} formInputs
	     * @param {array} packageDSDocuments
	     * @param {string} clientId
	     * @param {string} packageId
	     * @param {array} stakeholders
	     * @returns
	     */},{key:'reconstructAndFillSignerFormInputs',value:function reconstructAndFillSignerFormInputs(formInputs,packageDSDocuments,clientId,packageId,stakeholders){var _props10=this.props;var DSDocumentOriginTypes=_props10.DSDocumentOriginTypes;var isOffice=_props10.isOffice; //const firstSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerNumber === '0')
	var secondSigningStakeholder=stakeholders && stakeholders.find(function(stakeholder){return stakeholder.signerNumber === '1';});var brokerSigningStakeholder=stakeholders && stakeholders.find(function(stakeholder){return stakeholder.signerType === "BROKER";});var packageHaveSignableDocument=(0,_DSWizardHelper.requireSigning)(packageDSDocuments,DSDocumentOriginTypes); //check if one document requires signing and if so, handle form inputs for signing
	if(packageHaveSignableDocument){var brokerNumberFromForm=_nestedProperty2['default'].get(formInputs,"brokerNumber.value");var formInitialValues=this.getFormInitialValues(packageDSDocuments,brokerNumberFromForm,stakeholders,clientId,packageId,this.props.clientOptionsDict,this.props.contractId); // extend form inputs for first signer
	formInputs = (0,_DSWizardFormControl.setSigningInputFields)(formInputs,formInitialValues,(0,_DSWizardHelper.requireSmsOtpSigning)(packageDSDocuments,DSDocumentOriginTypes));var resultSS=this.toggleShowSecondSigner(formInputs,packageDSDocuments,!!secondSigningStakeholder); // force toggle
	this.setState({showSecondSigner:resultSS.showSecondSigner});formInputs = resultSS.formInputs;var resultBS=this.toggleShowBrokerSigner(formInputs,packageDSDocuments,brokerSigningStakeholder,!!brokerSigningStakeholder);this.setState({showBrokerSigner:resultBS.showBrokerSigner});formInputs = resultBS.formInputs;} // if no document require signing reset fields that are are set in case previously there was select a
	// contract that require signing and now is removed
	if(!packageHaveSignableDocument){formInputs = (0,_DSWizardFormControl.removeSigningInputFieldsValues)(formInputs);var resultSS=this.toggleShowSecondSigner(formInputs,packageDSDocuments,false);this.setState({showSecondSigner:resultSS.showSecondSigner});formInputs = resultSS.formInputs;var resultBS=this.toggleShowBrokerSigner(formInputs,packageDSDocuments,brokerSigningStakeholder,false);this.setState({showBrokerSigner:resultBS.showBrokerSigner});formInputs = resultBS.formInputs;}return formInputs;} /**
	     * Onchange event handler for the language selector
	     * @param {*} value
	     * @param {*} docTemplateFieldName
	     * @param {*} packageDSDocuments
	     * @param {*} formInputs
	     * @param {*} documentCursor
	     */},{key:'onChangeLanguageForDoc',value:function onChangeLanguageForDoc(value,docLangFieldName,packageDSDocuments,formInputs,documentCursor){var _props11,templates,DSDocumentOriginTypes,_state6,dynamicFieldIdCursor,moduleKey,subModuleKey,stakeholders,_loop2,index,_iteratorNormalCompletion4,_didIteratorError4,_iteratorError4,_iterator4,_step4,isValidTheForm;return regeneratorRuntime.async(function onChangeLanguageForDoc$(context$2$0){var _this6=this;while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props11 = this.props;templates = _props11.templates;DSDocumentOriginTypes = _props11.DSDocumentOriginTypes;_state6 = this.state;dynamicFieldIdCursor = _state6.dynamicFieldIdCursor;moduleKey = _state6.moduleKey;subModuleKey = _state6.subModuleKey;stakeholders = _state6.stakeholders;formInputs = this.onChangeFormInput(_nestedProperty2['default'].get(value,"value") || "",docLangFieldName,null,null,formInputs);if(!packageDSDocuments){context$2$0.next = 18;break;}_loop2 = function callee$2$0(index){var oneDocument,selectedTemplateRecord,attachedDocumentsToRemove,oneDocToRemove,responseFromRemoveDoc,handleDocsResult;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:oneDocument = packageDSDocuments[index];if(!(oneDocument.cursor == documentCursor)){context$3$0.next = 43;break;} // put it in the document affected
	_nestedProperty2['default'].set(packageDSDocuments,index + ".language",_nestedProperty2['default'].get(value,"value"));_nestedProperty2['default'].set(packageDSDocuments,index + ".brokerFilledValues",null);_nestedProperty2['default'].set(packageDSDocuments,index + ".isPrinted",false); // find the affected template record
	selectedTemplateRecord = templates.filter(function(item){return String(item._id) === String(oneDocument.documentTemplateId);});selectedTemplateRecord = _nestedProperty2['default'].get(selectedTemplateRecord,"0") || null; //check if there attached documents from template
	attachedDocumentsToRemove = packageDSDocuments.filter(function(oneDsDoc){return oneDsDoc.attachmentConnectionId === oneDocument.attachmentConnectionId && oneDsDoc.cursor !== oneDocument.cursor;});_iteratorNormalCompletion4 = true;_didIteratorError4 = false;_iteratorError4 = undefined;context$3$0.prev = 11;_iterator4 = attachedDocumentsToRemove[Symbol.iterator]();case 13:if(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done){context$3$0.next = 23;break;}oneDocToRemove = _step4.value;context$3$0.next = 17;return regeneratorRuntime.awrap(this.removeAttachmentDocument(oneDocToRemove.cursor,formInputs,packageDSDocuments));case 17:responseFromRemoveDoc = context$3$0.sent;packageDSDocuments = responseFromRemoveDoc.packageDSDocuments;formInputs = responseFromRemoveDoc.formInputs;case 20:_iteratorNormalCompletion4 = true;context$3$0.next = 13;break;case 23:context$3$0.next = 29;break;case 25:context$3$0.prev = 25;context$3$0.t0 = context$3$0['catch'](11);_didIteratorError4 = true;_iteratorError4 = context$3$0.t0;case 29:context$3$0.prev = 29;context$3$0.prev = 30;if(!_iteratorNormalCompletion4 && _iterator4['return']){_iterator4['return']();}case 32:context$3$0.prev = 32;if(!_didIteratorError4){context$3$0.next = 35;break;}throw _iteratorError4;case 35:return context$3$0.finish(32);case 36:return context$3$0.finish(29);case 37:context$3$0.next = 39;return regeneratorRuntime.awrap(this.handleDocsAttachedToGeneratedTemplates(packageDSDocuments,index,formInputs,selectedTemplateRecord,dynamicFieldIdCursor));case 39:handleDocsResult = context$3$0.sent;packageDSDocuments = handleDocsResult.packageDSDocuments;formInputs = handleDocsResult.formInputs;dynamicFieldIdCursor = handleDocsResult.dynamicFieldIdCursor;case 43:case 'end':return context$3$0.stop();}},null,_this6,[[11,25,29,37],[30,,32,36]]);};index = 0;case 12:if(!(index < packageDSDocuments.length)){context$2$0.next = 18;break;}context$2$0.next = 15;return regeneratorRuntime.awrap(_loop2(index));case 15:index++;context$2$0.next = 12;break;case 18:formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,true);this.setState({packageDSDocuments:packageDSDocuments,formInputs:formInputs,dynamicFieldIdCursor:dynamicFieldIdCursor,isValidTheForm:isValidTheForm});return context$2$0.abrupt('return',{packageDSDocuments:packageDSDocuments,formInputs:formInputs});case 23:case 'end':return context$2$0.stop();}},null,this);} /**
	     *
	     * @param {*} value
	     * @param {*} docTeamFieldName
	     * @param {*} documentCursor
	     */},{key:'onChangeTeamForDoc',value:function onChangeTeamForDoc(value,docTeamFieldName,documentCursor){var _this7=this;var packageDSDocuments=this.state.packageDSDocuments;this.onChangeFormInput(_nestedProperty2['default'].get(value,"value") || "",docTeamFieldName,null,function(){if(packageDSDocuments){packageDSDocuments.forEach(function(oneDocument,index){if(oneDocument.cursor == documentCursor){_nestedProperty2['default'].set(packageDSDocuments,index + ".team",_nestedProperty2['default'].get(value,"value"));}});}_this7.setState({packageDSDocuments:packageDSDocuments});});} /**
	     *
	     * @param {*} value
	     * @param {*} docTeamNameFieldName
	     * @param {*} documentCursor
	     */},{key:'onChangeTeamNameForDoc',value:function onChangeTeamNameForDoc(value,docTeamNameFieldName,documentCursor){var _this8=this;var packageDSDocuments=this.state.packageDSDocuments;this.onChangeFormInput(_nestedProperty2['default'].get(value,"label") || "",docTeamNameFieldName,null,function(){if(packageDSDocuments){packageDSDocuments.forEach(function(oneDocument,index){if(oneDocument.cursor == documentCursor){_nestedProperty2['default'].set(packageDSDocuments,index + ".teamName",_nestedProperty2['default'].get(value,"value"));}});}_this8.setState({packageDSDocuments:packageDSDocuments});});} /**
	     * This function not called by direc user interaction because all documents has the same subgroup, changed by an
	     * outer dropdown on package.
	     * @param {*} value
	     * @param {*} docTeamSubgroupFieldName
	     * @param {*} documentCursor
	     */},{key:'onChangeTeamSubgroupForDoc',value:function onChangeTeamSubgroupForDoc(value,docTeamSubgroupFieldName,documentCursor){var _this9=this;var _state7=this.state;var packageDSDocuments=_state7.packageDSDocuments;var formInputs=_state7.formInputs;var selectedTeamSubgroupValue=_nestedProperty2['default'].get(value,"value");this.onChangeFormInput(selectedTeamSubgroupValue || "",docTeamSubgroupFieldName,null,function(){if(packageDSDocuments){packageDSDocuments.forEach(function(oneDocument,index){if(oneDocument.cursor == documentCursor){_nestedProperty2['default'].set(packageDSDocuments,index + ".teamSubgroup",_nestedProperty2['default'].get(value,"value"));}});}_this9.setState({packageDSDocuments:packageDSDocuments /* , documentTemplateOptions */});});} /**
	     * Remove attachment documents but do not update state
	     * @param {*} cursor 
	     * @param {*} formInputs 
	     * @param {*} packageDSDocuments 
	     * @returns 
	     */},{key:'removeAttachmentDocument',value:function removeAttachmentDocument(cursor,formInputs,packageDSDocuments){var _state8,moduleKey,subModuleKey,stakeholders,DSDocumentOriginTypes,isValidTheForm;return regeneratorRuntime.async(function removeAttachmentDocument$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_state8 = this.state;moduleKey = _state8.moduleKey;subModuleKey = _state8.subModuleKey;stakeholders = _state8.stakeholders;DSDocumentOriginTypes = this.props.DSDocumentOriginTypes; // filter document list
	packageDSDocuments = (0,_DSWizardHelper.removeDSDocumentFromThePackage)(cursor,packageDSDocuments); // filter input list
	formInputs = (0,_DSWizardFormControl.removeFormInputByCursor)(cursor,formInputs); // handle the signing filed related dynamic inputs and validations
	formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,true);return context$2$0.abrupt('return',{packageDSDocuments:packageDSDocuments,formInputs:formInputs,isValidTheForm:isValidTheForm});case 11:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This function remove documents from package document and form inputs as well
	     */},{key:'onRemoveDocument',value:function onRemoveDocument(cursor,formInputs,packageDSDocuments){var updateState=arguments.length <= 3 || arguments[3] === undefined?true:arguments[3];var _state9,selectedClaimRelatedOraDocuments,selectedContractRelatedOraDocuments,selectedTarificationRelatedOraDocuments,selectedClientRelatedOraDocuments,selectedTicketRelatedOraDocuments,moduleKey,subModuleKey,stakeholders,DSDocumentOriginTypes,oracleId,isValidTheForm;return regeneratorRuntime.async(function onRemoveDocument$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_state9 = this.state;selectedClaimRelatedOraDocuments = _state9.selectedClaimRelatedOraDocuments;selectedContractRelatedOraDocuments = _state9.selectedContractRelatedOraDocuments;selectedTarificationRelatedOraDocuments = _state9.selectedTarificationRelatedOraDocuments;selectedClientRelatedOraDocuments = _state9.selectedClientRelatedOraDocuments;selectedTicketRelatedOraDocuments = _state9.selectedTicketRelatedOraDocuments;moduleKey = _state9.moduleKey;subModuleKey = _state9.subModuleKey;stakeholders = _state9.stakeholders;DSDocumentOriginTypes = this.props.DSDocumentOriginTypes;oracleId = (0,_DSWizardHelper.getOracleIdByCursorFromPackageDSDocuments)(cursor,packageDSDocuments);selectedClaimRelatedOraDocuments = (0,_DSWizardHelper.removeSelectedDocumentFromOraDocuments)(oracleId,selectedClaimRelatedOraDocuments);selectedContractRelatedOraDocuments = (0,_DSWizardHelper.removeSelectedDocumentFromOraDocuments)(oracleId,selectedContractRelatedOraDocuments);selectedTarificationRelatedOraDocuments = (0,_DSWizardHelper.removeSelectedDocumentFromOraDocuments)(oracleId,selectedTarificationRelatedOraDocuments);selectedClientRelatedOraDocuments = (0,_DSWizardHelper.removeSelectedDocumentFromOraDocuments)(oracleId,selectedClientRelatedOraDocuments);selectedTicketRelatedOraDocuments = (0,_DSWizardHelper.removeSelectedDocumentFromOraDocuments)(oracleId,selectedTicketRelatedOraDocuments); // filter document list
	packageDSDocuments = (0,_DSWizardHelper.removeDSDocumentFromThePackage)(cursor,packageDSDocuments); // filter input list
	formInputs = (0,_DSWizardFormControl.removeFormInputByCursor)(cursor,formInputs); // handle the signing filed related dynamic inputs and validations
	formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,true);if(updateState){context$2$0.next = 23;break;}return context$2$0.abrupt('return');case 23:this.setState({formInputs:formInputs,isValidTheForm:isValidTheForm,packageDSDocuments:packageDSDocuments,selectedClaimRelatedOraDocuments:selectedClaimRelatedOraDocuments,selectedContractRelatedOraDocuments:selectedContractRelatedOraDocuments,selectedTarificationRelatedOraDocuments:selectedTarificationRelatedOraDocuments,selectedClientRelatedOraDocuments:selectedClientRelatedOraDocuments,selectedTicketRelatedOraDocuments:selectedTicketRelatedOraDocuments});case 24:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This function render a document in the dome
	     * @param {*} oneDocument
	     * @param {*} isRequiredTarification
	     */},{key:'renderPackageDocument',value:function renderPackageDocument(oneDocument,isRequiredTarification){var _this11=this;var _state10=this.state;var languageOptions=_state10.languageOptions;var documentTemplateOptions=_state10.documentTemplateOptions;var _state11=this.state;var formInputs=_state11.formInputs;var isPrem=_state11.isPrem;var packageDSDocuments=_state11.packageDSDocuments;var _props12=this.props;var lang=_props12.lang;var DSDocumentOriginTypes=_props12.DSDocumentOriginTypes;var templates=_props12.templates;var claimWizardDocType=_props12.claimWizardDocType;var cursor=oneDocument.cursor; // find the package instance from the first document of the package
	var packageInstance={};var requiredOnPrem=oneDocument.documentTemplate && oneDocument.documentTemplate.requiredOnPrem; //if module is claimWizard than there always should be only one document template that cant't be removed
	// const requiredOnClaimWizard = oneDocument.documentTemplate && oneDocument.documentTemplate.indexType.lowValue === claimWizardDocType 
	var requiredOnClaimWizard=false;if(packageDSDocuments){packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");}var docIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocId)(cursor);var docOriginFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocOrigin)(cursor);var docTemplateFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTemplate)(cursor);var docLangFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocLang)(cursor);var docTeamFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeam)(cursor);var docTeamNameFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeamName)(cursor);var docTeamSubgroupFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeamSubgroup)(cursor);var docContractFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocContractNumber)(cursor);var docContractIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocContractId)(cursor);var docTarificationIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTarificationId)(cursor);var docTarificationNumberFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTarificationNumber)(cursor);var docClaimIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocClaimId)(cursor);var docClaimNumberFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocClaimNumber)(cursor); // local upload
	var docTemporaryUploadIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForTemporaryUploadId)(cursor);var docUploadedFileOriginalNameFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocUploadedFileOriginalName)(cursor);var docDocumentTypeIdxFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocumentTypeIdx)(cursor);var docDocumentUploadGroupTypeIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocumentUploadGroupTypeId)(cursor);var docDocumentUploadCommentFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForUploadComment)(cursor); // oracle selected
	var docOracleIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocOracleId)(cursor);var docOracleName=(0,_DSWizardFormControl.getDynamicFieldNameForDocOracleName)(cursor);var oracleDocumentUploadDate=(0,_DSWizardFormControl.getDynamicFieldNameForOracleDocumentUploadDate)(cursor);var docOracleTypeFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocOracleType)(cursor);var documentSelectionTabFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocSelectionTab)(cursor);var attachmentConnectionIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameAttachmentConnectionId)(cursor);var isAttachmentFieldName=(0,_DSWizardFormControl.getDynamicFieldNameIsAttachment)(cursor);var positionInUploadDocFieldName=(0,_DSWizardFormControl.getDynamicFieldNamePositionInUploadDoc)(cursor);var documentSizeFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForSize)(cursor);var documentEncryptedFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForEncrypted)(cursor); // when no data loaded no render
	if(!formInputs[docOriginFieldName]){return;} // decide what languages to be in the list
	var filteredLanguageOptions=(0,_DSWizardHelper.getLanguageOptionsByTemplateId)(formInputs[docTemplateFieldName].value,templates,languageOptions);var isRequiredContractNumber=_nestedProperty2['default'].get(oneDocument,"documentTemplate.uploadedOnModule") == c.DS_MODULE_CLIENT_CONTRACT; // check if team leven is selected and subteam is invalid to disable the template selection
	var disableTemplateSelect=false;if(formInputs.team.value === '1' && !formInputs.teamSubgroup.value || requiredOnPrem){disableTemplateSelect = true;}return _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].packageDocumentContainer),key:oneDocument._id + Math.random()},_react2['default'].createElement('input',{ref:docIdFieldName,name:docIdFieldName,type:'hidden',value:formInputs[docIdFieldName].value || ''}),_react2['default'].createElement('input',{ref:docOriginFieldName,name:docOriginFieldName,type:'hidden',value:formInputs[docOriginFieldName].value || ''}),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].packageDocumentDetailRow)},formInputs[docOriginFieldName].value == DSDocumentOriginTypes.DS_ORIGIN_GENERATED && _react2['default'].createElement('div',null,_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].row)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formLabel,_documentsScss2['default'].short1)},_('documentTemplate'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect,_documentsScss2['default'].short3,_documentsScss2['default'].flexLast)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:requiredOnPrem?{label:oneDocument.documentTemplate.title[lang],value:formInputs[docTemplateFieldName].value}:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs[docTemplateFieldName].value,documentTemplateOptions) || "",ref:docTemplateFieldName,name:docTemplateFieldName,onChange:function callee$2$0(value){var resultOfChange;return regeneratorRuntime.async(function callee$2$0$(context$3$0){var _this10=this;while(1) switch(context$3$0.prev = context$3$0.next){case 0:if(!_nestedProperty2['default'].get(oneDocument,"brokerFilledValues")){context$3$0.next = 4;break;}return context$3$0.abrupt('return',this.setState({isOpenAreYouSure:{title:_('areYouSureModalTitle'),message:_('areYouSureToChangeDocumentTemplate'),callBackCancel:function callBackCancel(){},callBackOk:function callBackOk(){var resultOfChange;return regeneratorRuntime.async(function callBackOk$(context$4$0){while(1) switch(context$4$0.prev = context$4$0.next){case 0: // to be shown the error message on validation
	formInputs["hasObligatedTarificationTemplate"].touched = true;formInputs["hasObligatedMandateTemplate"].touched = true;context$4$0.next = 4;return regeneratorRuntime.awrap(this.onChangeTemplateForDoc(value,docTemplateFieldName,packageDSDocuments,formInputs,oneDocument.cursor));case 4:resultOfChange = context$4$0.sent;return context$4$0.abrupt('return',resultOfChange);case 6:case 'end':return context$4$0.stop();}},null,_this10);}}}));case 4: // to be shown the error message on validation
	formInputs["hasObligatedTarificationTemplate"].touched = true;formInputs["hasObligatedMandateTemplate"].touched = true;context$3$0.next = 8;return regeneratorRuntime.awrap(this.onChangeTemplateForDoc(value,docTemplateFieldName,packageDSDocuments,formInputs,oneDocument.cursor));case 8:resultOfChange = context$3$0.sent;return context$3$0.abrupt('return',resultOfChange);case 10:case 'end':return context$3$0.stop();}},null,_this11);},handleOnBlur:function(e){},options:documentTemplateOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false,isDisabled:disableTemplateSelect}))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs[docTemplateFieldName].touched && formInputs[docTemplateFieldName].error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs[docTemplateFieldName].error && formInputs[docTemplateFieldName].touched && formInputs[docTemplateFieldName].error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].row},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('documentLanguage'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs[docLangFieldName].value,languageOptions) || "",ref:docLangFieldName,name:docLangFieldName,onChange:function(value){if(_nestedProperty2['default'].get(oneDocument,"brokerFilledValues")){return _this11.setState({isOpenAreYouSure:{title:_('areYouSureModalTitle'),message:_('areYouSureToChangeDocumentLanguage'),callBackCancel:function callBackCancel(){},callBackOk:function callBackOk(){_this11.onChangeLanguageForDoc(value,docLangFieldName,packageDSDocuments,formInputs,oneDocument.cursor);}}});}else {return _this11.onChangeLanguageForDoc(value,docLangFieldName,packageDSDocuments,formInputs,oneDocument.cursor);}},handleOnBlur:function(e){},options:filteredLanguageOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false,isDisabled:false}))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs[docLangFieldName].touched && formInputs[docLangFieldName].error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs[docLangFieldName].error && formInputs[docLangFieldName].touched && formInputs[docLangFieldName].error))),formInputs[docOriginFieldName].value == DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD && _react2['default'].createElement('div',{className:_documentsScss2['default'].row},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('documentPdfName'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].short3)},_react2['default'].createElement('input',{ref:docLangFieldName,name:docLangFieldName,type:'hidden',disabled:true,value:formInputs[docLangFieldName].value || ""}),_react2['default'].createElement('input',{ref:docTemporaryUploadIdFieldName,name:docTemporaryUploadIdFieldName,type:'hidden',value:formInputs[docTemporaryUploadIdFieldName].value || ""}),_react2['default'].createElement('input',{ref:docDocumentTypeIdxFieldName,name:docDocumentTypeIdxFieldName,type:'hidden',value:formInputs[docDocumentTypeIdxFieldName].value || ""}),_react2['default'].createElement('input',{ref:docDocumentUploadGroupTypeIdFieldName,name:docDocumentUploadGroupTypeIdFieldName,type:'hidden',value:formInputs[docDocumentUploadGroupTypeIdFieldName].value || ""}),_react2['default'].createElement('input',{ref:docDocumentUploadCommentFieldName,name:docDocumentUploadCommentFieldName,type:'hidden',value:formInputs[docDocumentUploadCommentFieldName].value || ""}),_react2['default'].createElement('input',{ref:docUploadedFileOriginalNameFieldName,name:docUploadedFileOriginalNameFieldName,type:'hidden',disabled:true,value:formInputs[docUploadedFileOriginalNameFieldName].value || ""}),formInputs[docUploadedFileOriginalNameFieldName].value || "")),formInputs[docOriginFieldName].value == DSDocumentOriginTypes.DS_ORIGIN_ORACLE && _react2['default'].createElement('div',{className:_documentsScss2['default'].row},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('documentOracle'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].short3)},_react2['default'].createElement('input',{ref:docLangFieldName,name:docLangFieldName,type:'hidden',disabled:true,value:formInputs[docLangFieldName].value || ""}),_react2['default'].createElement('input',{ref:docOracleIdFieldName,name:docOracleIdFieldName,type:'hidden',disabled:true,value:formInputs[docOracleIdFieldName].value || ""}),_react2['default'].createElement('input',{ref:docOracleTypeFieldName,name:docOracleTypeFieldName,type:'hidden',disabled:true,value:formInputs[docOracleTypeFieldName].value}),_react2['default'].createElement('input',{ref:documentSelectionTabFieldName,name:documentSelectionTabFieldName,type:'hidden',disabled:true,value:formInputs[documentSelectionTabFieldName].value}),_react2['default'].createElement('input',{ref:attachmentConnectionIdFieldName,name:attachmentConnectionIdFieldName,type:'hidden',disabled:true,value:formInputs[attachmentConnectionIdFieldName].value}),_react2['default'].createElement('input',{ref:isAttachmentFieldName,name:isAttachmentFieldName,type:'hidden',disabled:true,value:formInputs[isAttachmentFieldName].value}),_react2['default'].createElement('input',{ref:positionInUploadDocFieldName,name:positionInUploadDocFieldName,type:'hidden',disabled:true,value:formInputs[positionInUploadDocFieldName].value}),_react2['default'].createElement('input',{ref:docOracleName,name:docOracleName,type:'hidden',disabled:true,value:formInputs[docOracleName].value}),_react2['default'].createElement('input',{ref:documentEncryptedFieldName,name:documentEncryptedFieldName,type:'hidden',disabled:true,value:formInputs[documentEncryptedFieldName].value}),_react2['default'].createElement('input',{ref:oracleDocumentUploadDate,name:oracleDocumentUploadDate,type:'hidden',disabled:true,value:formInputs[oracleDocumentUploadDate].value}),_react2['default'].createElement('span',null,formInputs[docOracleName].value || ""))),_react2['default'].createElement('input',{ref:docClaimIdFieldName,name:docClaimIdFieldName,type:'hidden',value:formInputs[docClaimIdFieldName].value}),_react2['default'].createElement('input',{ref:docClaimNumberFieldName,name:docClaimNumberFieldName,type:'hidden',value:formInputs[docClaimNumberFieldName].value}),_react2['default'].createElement('input',{ref:documentSizeFieldName,name:documentSizeFieldName,type:'hidden',disabled:true,value:formInputs[documentSizeFieldName].value}),_react2['default'].createElement('div',{className:_documentsScss2['default'].row},_react2['default'].createElement('span',null,_('documentSize'),' ',(Math.ceil(Number(oneDocument.fileSize / 1024 / 1024) * 100) / 100).toFixed(2),' ',_('megabytes'))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs[documentSizeFieldName].error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs[documentSizeFieldName].error && formInputs[documentSizeFieldName].error)),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs[documentEncryptedFieldName].error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs[documentEncryptedFieldName].error && formInputs[documentEncryptedFieldName].error)),(isRequiredContractNumber || isPrem) && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].row)},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},!isPrem?_('contractNumber'):_('premContractNumber'),':'),!isPrem?formInputs[docContractFieldName].value?formInputs[docContractFieldName].value:_("selectContractNumberLater"):packageInstance && packageInstance.contractNumber?packageInstance.contractNumber:_("selectContractNumberLater")),isRequiredTarification && _react2['default'].createElement('input',{ref:docTeamFieldName,name:docTeamFieldName,type:'hidden',value:formInputs[docTeamFieldName].value}),isRequiredTarification && _react2['default'].createElement('input',{ref:docTeamNameFieldName,name:docTeamNameFieldName,type:'hidden',value:formInputs[docTeamNameFieldName].value}),_react2['default'].createElement('input',{ref:docContractFieldName,name:docContractFieldName,type:'hidden',value:formInputs[docContractFieldName].value}),_react2['default'].createElement('input',{ref:docContractIdFieldName,name:docContractIdFieldName,type:'hidden',value:formInputs[docContractIdFieldName].value}),_react2['default'].createElement('input',{ref:docTarificationIdFieldName,name:docTarificationIdFieldName,type:'hidden',value:formInputs[docTarificationIdFieldName].value}),_react2['default'].createElement('input',{ref:docTarificationNumberFieldName,name:docTarificationNumberFieldName,type:'hidden',value:formInputs[docTarificationNumberFieldName].value})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].operationsRow)},!packageDSDocuments || packageDSDocuments.length === 1 || requiredOnPrem || requiredOnClaimWizard?_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].onlyInfo)},_("canNotRemoveThisDocument")):_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].cancel,_documentsScss2['default'].removeDocumentBtn),onClick:function(e){_this11.setState({isOpenAreYouSure:{title:_('areYouSureModalTitle'),message:_('areYouSureToRemoveDocument'),callBackCancel:function callBackCancel(){},callBackOk:function callBackOk(){var attachedDocumentsToRemove,_iteratorNormalCompletion5,_didIteratorError5,_iteratorError5,_iterator5,_step5,oneDocToRemove;return regeneratorRuntime.async(function callBackOk$(context$4$0){while(1) switch(context$4$0.prev = context$4$0.next){case 0:if(!(oneDocument && !oneDocument.isAttachment)){context$4$0.next = 35;break;}attachedDocumentsToRemove = packageDSDocuments.filter(function(oneDsDoc){return oneDsDoc.attachmentConnectionId === oneDocument.attachmentConnectionId && oneDsDoc.cursor !== oneDocument.cursor;});_iteratorNormalCompletion5 = true;_didIteratorError5 = false;_iteratorError5 = undefined;context$4$0.prev = 5;_iterator5 = attachedDocumentsToRemove[Symbol.iterator]();case 7:if(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done){context$4$0.next = 14;break;}oneDocToRemove = _step5.value;context$4$0.next = 11;return regeneratorRuntime.awrap(this.onRemoveDocument(oneDocToRemove.cursor,formInputs,packageDSDocuments,false));case 11:_iteratorNormalCompletion5 = true;context$4$0.next = 7;break;case 14:context$4$0.next = 20;break;case 16:context$4$0.prev = 16;context$4$0.t0 = context$4$0['catch'](5);_didIteratorError5 = true;_iteratorError5 = context$4$0.t0;case 20:context$4$0.prev = 20;context$4$0.prev = 21;if(!_iteratorNormalCompletion5 && _iterator5['return']){_iterator5['return']();}case 23:context$4$0.prev = 23;if(!_didIteratorError5){context$4$0.next = 26;break;}throw _iteratorError5;case 26:return context$4$0.finish(23);case 27:return context$4$0.finish(20);case 28:context$4$0.next = 30;return regeneratorRuntime.awrap(this.onRemoveDocument(oneDocument.cursor,formInputs,packageDSDocuments,true));case 30:if(!(packageDSDocuments.length === 0)){context$4$0.next = 33;break;}context$4$0.next = 33;return regeneratorRuntime.awrap(this.onClickAddGeneratedDocument());case 33:context$4$0.next = 36;break;case 35:this.onRemoveDocument(oneDocument.cursor,formInputs,packageDSDocuments);case 36:case 'end':return context$4$0.stop();}},null,_this11,[[5,16,20,28],[21,,23,27]]);}}});}},_("removeDocument"))));} /**
	     * This function will handle the on contract change in MIFID wizard step #1.
	     * This will update the broker information also in the state.
	     * Update form data in state also related with contractNumber.
	     * @param {*} newContractId
	     * @param {*} newContractNumber
	     * @param {*} formInputs
	     */},{key:'handleChangeContractNumber',value:function handleChangeContractNumber(newContractId,newContractNumber,formInputs){var _props13,dispatch,brokers,resultContract,brokerNumber,brokerInfo,brokerEmailAddress,brokerName;return regeneratorRuntime.async(function handleChangeContractNumber$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props13 = this.props;dispatch = _props13.dispatch;brokers = _props13.brokers;context$2$0.next = 5;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.fetchClientContract)(newContractId)));case 5:resultContract = context$2$0.sent;brokerNumber = _nestedProperty2['default'].get(resultContract,"response.contractDetails.brokerNumber");brokerInfo = (0,_DSWizardFormControl.getBrokerFullInfoByNumber)(brokerNumber,brokers);brokerEmailAddress = _nestedProperty2['default'].get(brokerInfo,"main.emails.0");brokerName = _nestedProperty2['default'].get(brokerInfo,"main.name");_nestedProperty2['default'].set(formInputs,"brokerName.value",brokerName);_nestedProperty2['default'].set(formInputs,"brokerEmailAddress.value",brokerEmailAddress);_nestedProperty2['default'].set(formInputs,"brokerNumber.value",brokerNumber);_nestedProperty2['default'].set(formInputs,"contractNumber.value",newContractNumber || "");return context$2$0.abrupt('return',formInputs);case 15:case 'end':return context$2$0.stop();}},null,this);} /**
	    * On change event handler for Remainder Interval
	    * @param {*} value
	    * @returns
	    */},{key:'onChangeRemainderInterval',value:function onChangeRemainderInterval(value){var _this12=this;var formInputs=this.state.formInputs;var rawValue=_nestedProperty2['default'].get(value,"value"); // check if the remainders interval is set to 0, need to be set to 0 the repeats and disable the repeat field
	if(parseInt(rawValue) === 0){formInputs['remainderRepeats'].value = '0';}else {if(formInputs['remainderRepeats'].value == '0'){formInputs['remainderRepeats'].value = '1';}}return this.setState({formInputs:formInputs},function(){return _this12.onChangeFormInput(rawValue || "","remainderInterval");});} /**
	    * On change event handler for Remainder Ticket Interval
	    * @param {*} value
	    * @returns
	    */},{key:'onChangeRemainderTicketInterval',value:function onChangeRemainderTicketInterval(value){var _this13=this;var formInputs=this.state.formInputs;var rawValue=_nestedProperty2['default'].get(value,"value"); // check if the remainders interval is set to 0, need to be set to 0 the repeats and disable the repeat field
	if(parseInt(rawValue) === 0){formInputs['remainderTicketRepeats'].value = '0';}else {if(formInputs['remainderTicketRepeats'].value == '0'){formInputs['remainderTicketRepeats'].value = '1';}}return this.setState({formInputs:formInputs},function(){return _this13.onChangeFormInput(rawValue || "","remainderTicketInterval");});} /**
	    * On change event handler for first signer phone number
	    * @param {*} value
	    * @param {*} forceTouch
	    * @returns
	    */},{key:'onChangeFirstSignerPhoneNumber',value:function onChangeFirstSignerPhoneNumber(value){var _this14=this;var forceTouch=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var _state12=this.state;var formInputs=_state12.formInputs;var clientGSMPhoneNumbers=_state12.clientGSMPhoneNumbers;var brokerGSMPhoneNumbers=_state12.brokerGSMPhoneNumbers;var isOffice=this.props.isOffice;var rawValue=_nestedProperty2['default'].get(value,"value"); // handle phone number change to display any country codes associated with selected phone number
	var phoneNumbers=isOffice?brokerGSMPhoneNumbers:clientGSMPhoneNumbers;var selectedGSMPhoneNumber=phoneNumbers.find(function(elem){return elem.value === rawValue;});formInputs['firstSignerCountryPhoneCode'].value = selectedGSMPhoneNumber?selectedGSMPhoneNumber.countryCode:formInputs['firstSignerCountryPhoneCode'].value;if(formInputs['firstSignerCountryPhoneCode'].value != '+32'){formInputs['firstSignerPhoneNumber'].isValid = function(){return true;};}else {formInputs['firstSignerPhoneNumber'].isValid = function(value){return value[0] == '0'?value.length === 10:value.length === 9;};}return this.setState({formInputs:formInputs},function(){return _this14.onChangeFormInput(rawValue || "","firstSignerPhoneNumber",forceTouch);});} /**
	   * On change event handler for first signer phone number country code
	   * @param {*} value
	   * @param {*} forceTouch
	   * @returns
	   */},{key:'onChangeFirstSignerCountryCode',value:function onChangeFirstSignerCountryCode(val){var _this15=this;var forceTouch=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var _state13=this.state;var formInputs=_state13.formInputs;var countryPhoneCodes=_state13.countryPhoneCodes;var value='';var countryCodeIndex=countryPhoneCodes.findIndex(function(oneCode){return oneCode.value === val;});if(countryCodeIndex > -1){value = countryPhoneCodes[countryCodeIndex].value;}if(value === '+32'){formInputs['firstSignerPhoneNumber'].isValid = function(value){return value[0] == '0'?value.length === 10:value.length === 9;};}else {formInputs['firstSignerPhoneNumber'].isValid = function(){return true;};}var firstSignerPhoneNumberValidation=(0,_DSWizardFormControl.fieldValidation)(formInputs['firstSignerPhoneNumber']);_nestedProperty2['default'].set(formInputs,'firstSignerPhoneNumber',firstSignerPhoneNumberValidation);return this.setState({formInputs:formInputs},function(){return _this15.onChangeFormInput(value || "","firstSignerCountryPhoneCode",forceTouch);});} /**
	   * On change event handler for second signer phone number
	   * @param {*} value
	   * @param {*} forceTouch
	   * @returns
	   */},{key:'onChangeSecondSignerPhoneNumber',value:function onChangeSecondSignerPhoneNumber(value){var _this16=this;var forceTouch=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];var formInputs=this.state.formInputs;if(formInputs['secondSignerCountryPhoneCode'].value != '+32'){formInputs['secondSignerPhoneNumber'].isValid = function(){return true;};}else {formInputs['secondSignerPhoneNumber'].isValid = function(value){return value[0] == '0'?value.length === 10:value.length === 9;};}return this.setState({formInputs:formInputs},function(){return _this16.onChangeFormInput(value || "","secondSignerPhoneNumber",forceTouch);});} /**
	   * On change event handler for second signer phone number country code
	   * @param {*} value
	   * @param {*} forceTouch
	   * @returns
	   */},{key:'onChangeSecondSignerCountryCode',value:function onChangeSecondSignerCountryCode(val){var _this17=this;var forceTouch=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];var _state14=this.state;var formInputs=_state14.formInputs;var countryPhoneCodes=_state14.countryPhoneCodes;var value='';var countryCodeIndex=countryPhoneCodes.findIndex(function(oneCode){return oneCode.value === val;});if(countryCodeIndex > -1){value = countryPhoneCodes[countryCodeIndex].value;}if(value === '+32'){formInputs['secondSignerPhoneNumber'].isValid = function(value){return value[0] == '0'?value.length === 10:value.length === 9;};}else {formInputs['secondSignerPhoneNumber'].isValid = function(){return true;};}var secondSignerPhoneNumberValidation=(0,_DSWizardFormControl.fieldValidation)(formInputs['secondSignerPhoneNumber']);_nestedProperty2['default'].set(formInputs,'secondSignerPhoneNumber',secondSignerPhoneNumberValidation);return this.setState({formInputs:formInputs},function(){return _this17.onChangeFormInput(value || "","secondSignerCountryPhoneCode",forceTouch);});} /**
	    * On change event handler for broker signer phone number
	    * @param {*} value
	    * @param {*} forceTouch
	    * @returns
	    */},{key:'onChangeBrokerSignerPhoneNumber',value:function onChangeBrokerSignerPhoneNumber(value){var _this18=this;var forceTouch=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var _state15=this.state;var formInputs=_state15.formInputs;var brokerGSMPhoneNumbers=_state15.brokerGSMPhoneNumbers;var rawValue=_nestedProperty2['default'].get(value,"value"); // handle phone number change to display any country codes associated with selected phone number
	var selectedGSMPhoneNumber=brokerGSMPhoneNumbers.find(function(elem){return elem.value === rawValue;});formInputs['brokerSignerCountryPhoneCode'].value = selectedGSMPhoneNumber?selectedGSMPhoneNumber.countryCode:formInputs['brokerSignerCountryPhoneCode'].value;if(formInputs['brokerSignerCountryPhoneCode'].value != '+32'){formInputs['brokerSignerPhoneNumber'].isValid = function(){return true;};}else {formInputs['brokerSignerPhoneNumber'].isValid = function(value){return value[0] == '0'?value.length === 10:value.length === 9;};}return this.setState({formInputs:formInputs},function(){return _this18.onChangeFormInput(rawValue || "","brokerSignerPhoneNumber",forceTouch);});} /**
	   * On change event handler for broker broker phone number country code
	   * @param {*} value
	   * @param {*} forceTouch
	   * @returns
	   */},{key:'onChangeBrokerSignerCountryCode',value:function onChangeBrokerSignerCountryCode(value){var _this19=this;var forceTouch=arguments.length <= 1 || arguments[1] === undefined?false:arguments[1];var formInputs=this.state.formInputs;if(value === '+32'){formInputs['brokerSignerPhoneNumber'].isValid = function(value){return value[0] == '0'?value.length === 10:value.length === 9;};}else {formInputs['brokerSignerPhoneNumber'].isValid = function(){return true;};}var brokerSignerPhoneNumberValidation=(0,_DSWizardFormControl.fieldValidation)(formInputs['brokerSignerPhoneNumber']);_nestedProperty2['default'].set(formInputs,'brokerSignerPhoneNumber',brokerSignerPhoneNumberValidation);return this.setState({formInputs:formInputs},function(){return _this19.onChangeFormInput(value || "","brokerSignerCountryPhoneCode",forceTouch);});} /**
	     * This function will reset the tarification and team values for the
	     * dsDocument list what are depending on selected broker. Reset form values also
	     * @returns
	     */},{key:'resetTeamsAndTarificationForAllDocuments',value:function resetTeamsAndTarificationForAllDocuments(packageDSDocuments,formInputs){var _this20=this; // reset package team/tarification information
	formInputs = this.onChangeFormInput("","team",null,null,formInputs);formInputs = this.onChangeFormInput("","teamName",null,null,formInputs);formInputs = this.onChangeTeamSubGroupHandler("",formInputs);formInputs = this.onChangeFormInput("","tarificationId",null,null,formInputs);formInputs = this.onChangeFormInput("","tarificationNumber",null,null,formInputs); // reset documents level team and tarification information
	if(!packageDSDocuments){return {packageDSDocuments:packageDSDocuments,formInputs:formInputs};}packageDSDocuments.forEach(function(oneDocument,index){_nestedProperty2['default'].set(packageDSDocuments,index + ".documentTemplateId","");_nestedProperty2['default'].set(packageDSDocuments,index + ".documentTemplate","");_nestedProperty2['default'].set(packageDSDocuments,index + ".team","");_nestedProperty2['default'].set(packageDSDocuments,index + ".teamName","");_nestedProperty2['default'].set(packageDSDocuments,index + ".teamSubgroup","");_nestedProperty2['default'].set(packageDSDocuments,index + ".tarificationId","");_nestedProperty2['default'].set(packageDSDocuments,index + ".tarificationNumber","");var docTemplateFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTemplate)(oneDocument.cursor);var docTeamFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeam)(oneDocument.cursor);var docTeamSubgroupFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeamSubgroup)(oneDocument.cursor);var docTeamNameFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeamName)(oneDocument.cursor);var docTarificationIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTarificationId)(oneDocument.cursor);var docTarificationNumberFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTarificationNumber)(oneDocument.cursor);formInputs = _this20.onChangeFormInput("",docTemplateFieldName,null,null,formInputs);formInputs = _this20.onChangeFormInput("",docTeamFieldName,null,null,formInputs);formInputs = _this20.onChangeFormInput("",docTeamNameFieldName,null,null,formInputs);formInputs = _this20.onChangeFormInput("",docTeamSubgroupFieldName,null,null,formInputs);formInputs = _this20.onChangeFormInput("",docTarificationIdFieldName,null,null,formInputs);formInputs = _this20.onChangeFormInput("",docTarificationNumberFieldName,null,null,formInputs);});return {packageDSDocuments:packageDSDocuments,formInputs:formInputs};} /**
	     *
	     * @param {*} packageDSDocuments
	     * @param {*} formInputs
	     * @param {*} valueLabelPair
	     * @param {*} subGroupValueLabelPair
	     * @returns
	     */},{key:'setTeamsForAllDocuments',value:function setTeamsForAllDocuments(packageDSDocuments,formInputs,valueLabelPair,subGroupValueLabelPair){var _this21=this;if(!packageDSDocuments){console.error("No documents added to the package");return Promise.reject(new Error("No documents added to the package"));}var team=_nestedProperty2['default'].get(valueLabelPair,"value");var teamName=_nestedProperty2['default'].get(valueLabelPair,"label");var teamSubgroupId=_nestedProperty2['default'].get(subGroupValueLabelPair,"value");packageDSDocuments.forEach(function(oneDocument,index){ // set values in state document
	_nestedProperty2['default'].set(packageDSDocuments,index + ".team",team);_nestedProperty2['default'].set(packageDSDocuments,index + ".teamName",teamName);_nestedProperty2['default'].set(packageDSDocuments,index + ".teamSubgroup",teamSubgroupId); // set values in form documents also
	var docTeamFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeam)(oneDocument.cursor);var docTeamNameFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeamName)(oneDocument.cursor);var docTeamSubgroupFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTeamSubgroup)(oneDocument.cursor); //let docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(oneDocument.cursor)
	//let docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(oneDocument.cursor)
	// change values for form in sync with state documents
	formInputs = _this21.onChangeFormInput(team,docTeamFieldName,null,null,formInputs);formInputs = _this21.onChangeFormInput(teamName,docTeamNameFieldName,null,null,formInputs);formInputs = _this21.onChangeFormInput(teamSubgroupId,docTeamSubgroupFieldName,null,null,formInputs);});return {packageDSDocuments:packageDSDocuments,formInputs:formInputs};} /**
	     *
	     * @param {*} packageDSDocuments
	     * @param {*} valueLabelPair
	     * @returns
	     */},{key:'clearTemplateForAllDocuments',value:function clearTemplateForAllDocuments(packageDSDocuments,formInputs){var i,oneDocument,docTemplateFieldName,updatedValuePack;return regeneratorRuntime.async(function clearTemplateForAllDocuments$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:if(packageDSDocuments){context$2$0.next = 2;break;}throw new Error("No documents added to the package");case 2:i = 0;case 3:if(!(i < packageDSDocuments.length)){context$2$0.next = 13;break;}oneDocument = packageDSDocuments[i];docTemplateFieldName = (0,_DSWizardFormControl.getDynamicFieldNameForDocTemplate)(oneDocument.cursor);context$2$0.next = 8;return regeneratorRuntime.awrap(this.onChangeTemplateForDoc(null,docTemplateFieldName,packageDSDocuments,formInputs,oneDocument.cursor));case 8:updatedValuePack = context$2$0.sent;packageDSDocuments = updatedValuePack.packageDSDocuments,formInputs = updatedValuePack.formInputs;case 10:i++;context$2$0.next = 3;break;case 13:return context$2$0.abrupt('return',{packageDSDocuments:packageDSDocuments,formInputs:formInputs});case 14:case 'end':return context$2$0.stop();}},null,this);} /**
	     * Set tarification information for all the documents in the state and in the form inputs also.
	     * Return a promise when the job is done.
	     * @param {*} packageDSDocuments
	     * @param {*} valueLabelPair
	     * @returns Promise
	     */},{key:'setTarificationInfoForAllDocuments',value:function setTarificationInfoForAllDocuments(packageDSDocuments,formInputs,tarificationId,tarificationNumber){var DSDocumentOriginTypes;return regeneratorRuntime.async(function setTarificationInfoForAllDocuments$(context$2$0){var _this22=this;while(1) switch(context$2$0.prev = context$2$0.next){case 0:DSDocumentOriginTypes = this.props.DSDocumentOriginTypes;if(packageDSDocuments){context$2$0.next = 3;break;}return context$2$0.abrupt('return',packageDSDocuments);case 3:packageDSDocuments.forEach(function(oneDocument,index){var isRequiredTarification=false;if(oneDocument.origin !== DSDocumentOriginTypes.DS_ORIGIN_GENERATED && oneDocument.subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION){ // UPLOADED ORACLE DOCUMENTS CASE
	isRequiredTarification = true;}else { // GENERATED DOCUMENTS CASE
	isRequiredTarification = _nestedProperty2['default'].get(oneDocument,"documentTemplate.uploadedOnModule") == c.DS_MODULE_CLIENT_TARIFICATION && _nestedProperty2['default'].get(oneDocument,"subModuleKey") !== c.DS_MODULE_CLIENT_TARIFICATION;} // in case when the document don't require tarification number the skip it
	if(!isRequiredTarification){return; // skip this step of loop
	} // update state documents
	_nestedProperty2['default'].set(packageDSDocuments,index + ".tarificationId",tarificationId);_nestedProperty2['default'].set(packageDSDocuments,index + ".tarificationNumber",tarificationNumber); // update form values for the documents
	var docTarificationIdFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTarificationId)(oneDocument.cursor);var docTarificationNumberFieldName=(0,_DSWizardFormControl.getDynamicFieldNameForDocTarificationNumber)(oneDocument.cursor);formInputs = _this22.onChangeFormInput(tarificationId,docTarificationIdFieldName,null,null,formInputs);formInputs = _this22.onChangeFormInput(tarificationNumber,docTarificationNumberFieldName,null,null,formInputs);}); // return a promise when everything is updated
	return context$2$0.abrupt('return',{packageDSDocuments:packageDSDocuments,formInputs:formInputs});case 5:case 'end':return context$2$0.stop();}},null,this);} /**
	     *
	     * @param {*} value - the event of the input on onchange
	     * @returns
	     */},{key:'onChangeBrokerNumberHandler',value:function onChangeBrokerNumberHandler(value){var _props14=this.props;var templates=_props14.templates;var lang=_props14.lang;var clientOptionsDict=_props14.clientOptionsDict;var brokersTeamWhiteList=_props14.brokersTeamWhiteList;var moduleKeyFromProps=_props14.moduleKeyFromProps;var subModuleKey=_props14.subModuleKey;var brokers=_props14.brokers;var userId=_props14.userId;var DSDocumentOriginTypes=_props14.DSDocumentOriginTypes;var userFirstName=_props14.userFirstName;var userLastName=_props14.userLastName;var userPhoneNumber=_props14.userPhoneNumber;var claimWizardDocType=_props14.claimWizardDocType;var _state16=this.state;var packageDSDocuments=_state16.packageDSDocuments;var formInputs=_state16.formInputs;var showBrokerSigner=_state16.showBrokerSigner;var countryPhoneCodes=_state16.countryPhoneCodes;var stakeholders=_state16.stakeholders; // fetch selected brokerNumber from input event
	var selectedValue=_nestedProperty2['default'].get(value,"value") || ""; // update broker email list in state
	var brokerEmailOptions=(0,_DSWizardFormControl.getBrokerEmailsInOptionList)(selectedValue,brokers,userId); // reset the broker fields
	// select the first available broker email address, to be selected
	var firstBrokerEmailAddress=_nestedProperty2['default'].get(brokerEmailOptions,"0.value"); // change the form input of the broker email address
	this.onChangeFormInput(firstBrokerEmailAddress,"brokerEmailAddress"); // reset team options
	var teamsOptions=(0,_DSWizardHelper.getTeamsOptionList)(clientOptionsDict,lang);teamsOptions = (0,_DSWizardHelper.filterTeamsForBroker)(teamsOptions,brokersTeamWhiteList,selectedValue); // recalculate the template options by broker white lists and template white list match
	var moduleKeyFromState=_nestedProperty2['default'].get(this,"state.moduleKey");var subModuleKeyFromState=_nestedProperty2['default'].get(this,"state.subModuleKey");var moduleKey=moduleKeyFromState || moduleKeyFromProps;var subModuleKeyCalculated=subModuleKeyFromState || subModuleKey; // reset the template list
	var documentTemplateOptions=(0,_DSWizardHelper.getDocumentTemplateOptionList)(templates,lang,moduleKey,subModuleKeyCalculated,false,claimWizardDocType);if(moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKeyCalculated == c.DS_MODULE_CLIENT_TARIFICATION){documentTemplateOptions = (0,_DSWizardHelper.filterTemplatesForBroker)(documentTemplateOptions,brokersTeamWhiteList,selectedValue,false,false);} // fetch the full info about the broker using the brokerNumber
	var brokerInfo=(0,_DSWizardFormControl.getBrokerFullInfoByNumber)(selectedValue,brokers); // fetch the broker name to set it in the form values
	var brokerName=_nestedProperty2['default'].get(brokerInfo,"main.name"); // update brokerName form input
	formInputs = this.onChangeFormInput(brokerName,"brokerName",null,null,formInputs);var requireSmsOtpSigningResult=(0,_DSWizardHelper.requireSmsOtpSigning)(packageDSDocuments,DSDocumentOriginTypes);var brokerSigningStakeholder=stakeholders && stakeholders.find(function(stakeholder){return stakeholder.signerType === "BROKER";});formInputs = (0,_DSWizardFormControl.resetBrokerSignerRelatedFields)(brokerSigningStakeholder,formInputs,brokerInfo,lang,countryPhoneCodes,showBrokerSigner,requireSmsOtpSigningResult,userFirstName,userLastName,userPhoneNumber); // reset the state stored documents tarification and team values
	var resultOfReset=this.resetTeamsAndTarificationForAllDocuments(packageDSDocuments,formInputs);packageDSDocuments = resultOfReset.packageDSDocuments;formInputs = resultOfReset.formInputs; // generate dynamic list of the fields for documents
	var freshDocumentsInputList=(0,_DSWizardFormControl.getFlatValueListOfDsDocumentsForForm)(packageDSDocuments,documentTemplateOptions);formInputs = (0,_DSWizardHelper.patchFormInputValuesByValueList)(formInputs,freshDocumentsInputList); // finally change the form input value for the broker number also
	formInputs = this.onChangeFormInput(selectedValue,"brokerNumber",null,null,formInputs); // update the state with the processed values after brokerNumber input change
	this.setState({formInputs:formInputs,brokerEmailOptions:brokerEmailOptions,teamsOptions:teamsOptions,documentTemplateOptions:documentTemplateOptions,packageDSDocuments:packageDSDocuments});return formInputs;} /**
	     * Handle OnChange event for teamSubgroups on package level
	     * @param {*} valueToSetForSubGroup
	     * @param {*} formInputs
	     * @returns
	     */},{key:'onChangeTeamSubGroupHandler',value:function onChangeTeamSubGroupHandler(valueToSetForSubGroup,formInputs){var formFieldName="teamSubgroup"; //get the object from state to be able to set the validity value in it.
	var formField=_nestedProperty2['default'].get(formInputs,formFieldName); // set the value
	formField.value = valueToSetForSubGroup; //check if team is leven and set the subTeam as required
	var teamField=_nestedProperty2['default'].get(formInputs,'team');if(teamField.value && parseInt(teamField.value) === 1){formField.isRequired = true;}else {formField.isRequired = false;}_nestedProperty2['default'].set(formInputs,formFieldName,formField);formInputs = this.onChangeFormInput(valueToSetForSubGroup,formFieldName,null,null,formInputs);return formInputs;} /**
	     * This is a handler for onChange the team of package
	     * @param {*} value
	     * @returns
	     */},{key:'onChangeTeamHandler',value:function onChangeTeamHandler(teamValue,teamSubgroupValue,packageDSDocuments,formInputs){var _state17,teamsOptions,teamSubgroupsOptions,moduleKey,subModuleKey,_props15,templates,lang,brokersTeamWhiteList,claimWizardDocType,selectedTeamValue,selectedTeamSubgroupValue,brokerNumber,teamOptionItem,teamSubgroupOptionItem,documentTemplateOptions,result,valueToSetForSubGroup,resultClear,freshDocumentsInputList;return regeneratorRuntime.async(function onChangeTeamHandler$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_state17 = this.state;teamsOptions = _state17.teamsOptions;teamSubgroupsOptions = _state17.teamSubgroupsOptions;moduleKey = _state17.moduleKey;subModuleKey = _state17.subModuleKey;_props15 = this.props;templates = _props15.templates;lang = _props15.lang;brokersTeamWhiteList = _props15.brokersTeamWhiteList;claimWizardDocType = _props15.claimWizardDocType;selectedTeamValue = _nestedProperty2['default'].get(teamValue,"value") || "";selectedTeamSubgroupValue = _nestedProperty2['default'].get(teamSubgroupValue,"value") || "";brokerNumber = _nestedProperty2['default'].get(formInputs,"brokerNumber.value");teamOptionItem = (0,_DSWizardFormControl.findItemByValueFromSelectOptions)(selectedTeamValue,teamsOptions);teamSubgroupOptionItem = (0,_DSWizardFormControl.findItemByValueFromSelectOptions)(selectedTeamSubgroupValue,teamSubgroupsOptions);documentTemplateOptions = (0,_DSWizardHelper.getDocumentTemplateOptionList)(templates,lang,moduleKey,subModuleKey,false,claimWizardDocType); // if the main tarification module (overview) is opened, then filter the templates
	if(moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION){documentTemplateOptions = (0,_DSWizardHelper.filterTemplatesForBroker)(documentTemplateOptions,brokersTeamWhiteList,brokerNumber,selectedTeamValue,selectedTeamSubgroupValue);} // first of all we must refilter the template list after the new selected team
	// reset the state stored documents tarification and team values, in the form also
	result = this.setTeamsForAllDocuments(packageDSDocuments,formInputs,teamOptionItem,teamSubgroupOptionItem);formInputs = result.formInputs;packageDSDocuments = result.packageDSDocuments;formInputs = this.onChangeFormInput(teamOptionItem.label,"teamName",null,null,formInputs);formInputs = this.onChangeFormInput(selectedTeamValue,"team",null,null,formInputs); // when the team is not LEVEN the clear the subgroups
	valueToSetForSubGroup = selectedTeamSubgroupValue;if(parseInt(selectedTeamValue) !== 1){valueToSetForSubGroup = "";}formInputs = this.onChangeTeamSubGroupHandler(valueToSetForSubGroup,formInputs);context$2$0.next = 27;return regeneratorRuntime.awrap(this.clearTemplateForAllDocuments(packageDSDocuments,formInputs));case 27:resultClear = context$2$0.sent;formInputs = resultClear.formInputs;packageDSDocuments = resultClear.packageDSDocuments; // generate dynamic list of the fields for documents
	freshDocumentsInputList = (0,_DSWizardFormControl.getFlatValueListOfDsDocumentsForForm)(packageDSDocuments,documentTemplateOptions);formInputs = (0,_DSWizardHelper.patchFormInputValuesByValueList)(formInputs,freshDocumentsInputList);this.setState({formInputs:formInputs,packageDSDocuments:packageDSDocuments,documentTemplateOptions:documentTemplateOptions});return context$2$0.abrupt('return',{formInputs:formInputs,packageDSDocuments:packageDSDocuments,documentTemplateOptions:documentTemplateOptions});case 34:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This function will toggle show the second signer fields and set or reset values
	     *
	     * @param {*} formInputs
	     * @param {*} packageDSDocuments
	     * @param {*} forceShow
	     * @returns
	     */},{key:'toggleShowSecondSigner',value:function toggleShowSecondSigner(formInputs,packageDSDocuments){var forceShow=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];var DSDocumentOriginTypes=this.props.DSDocumentOriginTypes;var showSecondSigner=this.state.showSecondSigner;var requireSmsOtpSigningResult=(0,_DSWizardHelper.requireSmsOtpSigning)(packageDSDocuments,DSDocumentOriginTypes); // toggle
	var show=!showSecondSigner;if(forceShow !== null){show = forceShow;}formInputs = (0,_DSWizardFormControl.showSecondSignerFields)(formInputs,show,requireSmsOtpSigningResult);return {showSecondSigner:show,formInputs:formInputs};} /**
	     * This function will toggle show the second signer fields and set or reset values
	     *
	     * @param {object} formInputs {name1: {input props ...}, name2: {input props ...},...}
	     * @param {array} packageDSDocuments array[ <dsdocument record>, ... ]
	     * @param {object} brokerSigningStakeholder stakeholder mongo record
	     * @param {boolean} forceShow
	     * @returns
	     */},{key:'toggleShowBrokerSigner',value:function toggleShowBrokerSigner(formInputs,packageDSDocuments,brokerSigningStakeholder){var forceShow=arguments.length <= 3 || arguments[3] === undefined?null:arguments[3];var _props16=this.props;var DSDocumentOriginTypes=_props16.DSDocumentOriginTypes;var lang=_props16.lang;var brokers=_props16.brokers;var userFirstName=_props16.userFirstName;var userLastName=_props16.userLastName;var userPhoneNumber=_props16.userPhoneNumber;var _state18=this.state;var showBrokerSigner=_state18.showBrokerSigner;var countryPhoneCodes=_state18.countryPhoneCodes;var requireSmsOtpSigningResult=(0,_DSWizardHelper.requireSmsOtpSigning)(packageDSDocuments,DSDocumentOriginTypes);var selectedBroker=formInputs["brokerNumber"].value; // fetch the full info about the broker using the brokerNumber
	var brokerInfo=(0,_DSWizardFormControl.getBrokerFullInfoByNumber)(selectedBroker,brokers);var toggledShowBrokerSigner=!showBrokerSigner;if(forceShow !== null){toggledShowBrokerSigner = forceShow;}formInputs = (0,_DSWizardFormControl.resetBrokerSignerRelatedFields)(brokerSigningStakeholder,formInputs,brokerInfo,lang,countryPhoneCodes,toggledShowBrokerSigner,requireSmsOtpSigningResult,userFirstName,userLastName,userPhoneNumber);return {showBrokerSigner:toggledShowBrokerSigner,formInputs:formInputs};} // function to handle the attached documents
	},{key:'handleDocsAttachedToGeneratedTemplates',value:function handleDocsAttachedToGeneratedTemplates(packageDSDocuments,index,formInputs,selectedTemplateRecord,dynamicFieldIdCursor){var dispatch,_state19,contractId,tarificationId,tarificationNumber,claimId,claimNumber,moduleKey,subModuleKey,isPrem,languageOptions,documentTemplateOptions,stakeholders,generatedDocument,language,documentsFromAttachment,team,teamName,teamSubgroup,_iteratorNormalCompletion6,_didIteratorError6,_iteratorError6,_iterator6,_step6,oneAttachment,documents,i,documentsFromAttachmentResult,docsWithError,docsToAdd,_iteratorNormalCompletion7,_didIteratorError7,_iteratorError7,_iterator7,_step7,oneDocumentRes,_iteratorNormalCompletion8,_didIteratorError8,_iteratorError8,_iterator8,_step8,oneDocToAdd,docRecord,createDocResult;return regeneratorRuntime.async(function handleDocsAttachedToGeneratedTemplates$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:dispatch = this.props.dispatch;_state19 = this.state;contractId = _state19.contractId;tarificationId = _state19.tarificationId;tarificationNumber = _state19.tarificationNumber;claimId = _state19.claimId;claimNumber = _state19.claimNumber;moduleKey = _state19.moduleKey;subModuleKey = _state19.subModuleKey;isPrem = _state19.isPrem;languageOptions = _state19.languageOptions;documentTemplateOptions = _state19.documentTemplateOptions;stakeholders = _state19.stakeholders;generatedDocument = packageDSDocuments[index];language = generatedDocument.language;documentsFromAttachment = [];team = _nestedProperty2['default'].get(formInputs,"team.value");teamName = _nestedProperty2['default'].get(formInputs,"teamName.value");teamSubgroup = _nestedProperty2['default'].get(formInputs,"teamSubgroup.value");if(!(selectedTemplateRecord && selectedTemplateRecord.additionalAttachments && selectedTemplateRecord.additionalAttachments.length > 0)){context$2$0.next = 39;break;}_iteratorNormalCompletion6 = true;_didIteratorError6 = false;_iteratorError6 = undefined;context$2$0.prev = 23;for(_iterator6 = selectedTemplateRecord.additionalAttachments[Symbol.iterator]();!(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done);_iteratorNormalCompletion6 = true) {oneAttachment = _step6.value;documents = oneAttachment.documents.filter(function(oneDocument){return oneDocument.language === language;});if(documents){for(i = 0;i < documents.length;i++) {documents[i].document.sourceTemplateId = generatedDocument.documentTemplateId;documents[i].document.uploadType = 'attachment';documents[i].document.positionInUploadDoc = oneAttachment.positionInUploadDoc;documentsFromAttachment.push(documents[i].document);}}}context$2$0.next = 31;break;case 27:context$2$0.prev = 27;context$2$0.t0 = context$2$0['catch'](23);_didIteratorError6 = true;_iteratorError6 = context$2$0.t0;case 31:context$2$0.prev = 31;context$2$0.prev = 32;if(!_iteratorNormalCompletion6 && _iterator6['return']){_iterator6['return']();}case 34:context$2$0.prev = 34;if(!_didIteratorError6){context$2$0.next = 37;break;}throw _iteratorError6;case 37:return context$2$0.finish(34);case 38:return context$2$0.finish(31);case 39:if(!(documentsFromAttachment && documentsFromAttachment.length > 0)){context$2$0.next = 102;break;}context$2$0.next = 42;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.createLocalUploadFilesFromAttachments)(documentsFromAttachment)));case 42:documentsFromAttachmentResult = context$2$0.sent;docsWithError = [];docsToAdd = [];if(!(documentsFromAttachmentResult && documentsFromAttachmentResult.length > 0)){context$2$0.next = 65;break;}_iteratorNormalCompletion7 = true;_didIteratorError7 = false;_iteratorError7 = undefined;context$2$0.prev = 49;for(_iterator7 = documentsFromAttachmentResult[Symbol.iterator]();!(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done);_iteratorNormalCompletion7 = true) {oneDocumentRes = _step7.value;if(oneDocumentRes.isError){docsWithError.push(oneDocumentRes);}else {docsToAdd.push(oneDocumentRes); // await this.onSelectLocalDocument(oneDocumentRes.temporaryFileRecord)
	// okayRes.push(oneDocumentRes)/
	}}context$2$0.next = 57;break;case 53:context$2$0.prev = 53;context$2$0.t1 = context$2$0['catch'](49);_didIteratorError7 = true;_iteratorError7 = context$2$0.t1;case 57:context$2$0.prev = 57;context$2$0.prev = 58;if(!_iteratorNormalCompletion7 && _iterator7['return']){_iterator7['return']();}case 60:context$2$0.prev = 60;if(!_didIteratorError7){context$2$0.next = 63;break;}throw _iteratorError7;case 63:return context$2$0.finish(60);case 64:return context$2$0.finish(57);case 65:if(!docsToAdd){context$2$0.next = 101;break;}_iteratorNormalCompletion8 = true;_didIteratorError8 = false;_iteratorError8 = undefined;context$2$0.prev = 69;_iterator8 = docsToAdd[Symbol.iterator]();case 71:if(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done){context$2$0.next = 87;break;}oneDocToAdd = _step8.value;docRecord = oneDocToAdd.temporaryFileRecord;docRecord.attachmentConnectionId = generatedDocument.attachmentConnectionId;docRecord.isAttachment = true;docRecord.positionInUploadDoc = oneDocToAdd.positionInUploadDoc;context$2$0.next = 79;return regeneratorRuntime.awrap(this.createDSDocumentForPackage(packageDSDocuments,language,{team:team,teamName:teamName,teamSubgroup:teamSubgroup},dynamicFieldIdCursor,languageOptions,documentTemplateOptions,{contractId:contractId,tarificationId:tarificationId,tarificationNumber:tarificationNumber,claimId:claimId,claimNumber:claimNumber,moduleKey:moduleKey,subModuleKey:subModuleKey,isPrem:isPrem},docRecord));case 79:createDocResult = context$2$0.sent;formInputs = _extends({},formInputs,createDocResult.documentFormInputs);packageDSDocuments = createDocResult.packageDSDocuments;formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey);dynamicFieldIdCursor = createDocResult.dynamicFieldIdCursor;case 84:_iteratorNormalCompletion8 = true;context$2$0.next = 71;break;case 87:context$2$0.next = 93;break;case 89:context$2$0.prev = 89;context$2$0.t2 = context$2$0['catch'](69);_didIteratorError8 = true;_iteratorError8 = context$2$0.t2;case 93:context$2$0.prev = 93;context$2$0.prev = 94;if(!_iteratorNormalCompletion8 && _iterator8['return']){_iterator8['return']();}case 96:context$2$0.prev = 96;if(!_didIteratorError8){context$2$0.next = 99;break;}throw _iteratorError8;case 99:return context$2$0.finish(96);case 100:return context$2$0.finish(93);case 101:if(docsWithError && docsWithError.length > 0){this.setState({templateAttachmentDocumentsError:docsWithError});}case 102:return context$2$0.abrupt('return',{packageDSDocuments:packageDSDocuments,formInputs:formInputs,dynamicFieldIdCursor:dynamicFieldIdCursor});case 103:case 'end':return context$2$0.stop();}},null,this,[[23,27,31,39],[32,,34,38],[49,53,57,65],[58,,60,64],[69,89,93,101],[94,,96,100]]);} /**
	     * Function is used when user uploads local documents from his computer or when user selects a generated template with attached pdf's that will be
	     *  treated from this pont as local uploads except automatic removal when the liked generated document is removed 
	     * @param {*} document - must contains a document that was uploaded by user or added automatically by the createLocalUploadFilesFromAttachments
	     * and exists physically on server
	     */},{key:'onSelectLocalDocument',value:function onSelectLocalDocument(document){var _props17,DSDocumentOriginTypes,claimWizardDocType,_state20,formInputs,packageDSDocuments,isValidTheForm,dynamicFieldIdCursor,moduleKey,subModuleKey,stakeholders,languageOptions,documentTemplateOptions,contractId,tarificationId,tarificationNumber,isPrem,signerAvailabilityOfTemplates,claimId,claimNumber,clientLanguage,team,teamName,teamSubgroup,result,addSignersButtonFlags,isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder;return regeneratorRuntime.async(function onSelectLocalDocument$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props17 = this.props;DSDocumentOriginTypes = _props17.DSDocumentOriginTypes;claimWizardDocType = _props17.claimWizardDocType;_state20 = this.state;formInputs = _state20.formInputs;packageDSDocuments = _state20.packageDSDocuments;isValidTheForm = _state20.isValidTheForm;dynamicFieldIdCursor = _state20.dynamicFieldIdCursor;moduleKey = _state20.moduleKey;subModuleKey = _state20.subModuleKey;stakeholders = _state20.stakeholders;languageOptions = _state20.languageOptions;documentTemplateOptions = _state20.documentTemplateOptions;contractId = _state20.contractId;tarificationId = _state20.tarificationId;tarificationNumber = _state20.tarificationNumber;isPrem = _state20.isPrem;signerAvailabilityOfTemplates = _state20.signerAvailabilityOfTemplates;claimId = _state20.claimId;claimNumber = _state20.claimNumber;if(!(!document || document.length == 0)){context$2$0.next = 23;break;}console.warn("No local documents provided for wizard by selector popup.");return context$2$0.abrupt('return');case 23: // if this claimWizard module force a document type from claimWizardDocType
	if(claimWizardDocType && moduleKey === 'DS_MODULE_CLAIM_WIZARD'){document.lowValue = claimWizardDocType;}clientLanguage = _nestedProperty2['default'].get(formInputs,"clientLanguage.value");team = _nestedProperty2['default'].get(formInputs,"team.value");teamName = _nestedProperty2['default'].get(formInputs,"teamName.value");teamSubgroup = _nestedProperty2['default'].get(formInputs,"teamSubgroup.value");context$2$0.next = 30;return regeneratorRuntime.awrap(this.createDSDocumentForPackage(packageDSDocuments,clientLanguage,{team:team,teamName:teamName,teamSubgroup:teamSubgroup},dynamicFieldIdCursor,languageOptions,documentTemplateOptions,{contractId:contractId,tarificationId:tarificationId,tarificationNumber:tarificationNumber,claimId:claimId,claimNumber:claimNumber,moduleKey:moduleKey,subModuleKey:subModuleKey,isPrem:isPrem},document));case 30:result = context$2$0.sent;formInputs = _extends({},formInputs,result.documentFormInputs);packageDSDocuments = result.packageDSDocuments;dynamicFieldIdCursor = result.dynamicFieldIdCursor; // update conditional fields, what are based on another fields vallues
	formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey); // validate individual form inputs
	formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs); // validate the form global conditions, the values what are related
	isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,true); // ++++++++++++ start handle enabled signers list ++++++++++++++
	addSignersButtonFlags = (0,_DSWizardHelper.getSignerAdderButtonsFlags)(packageDSDocuments,DSDocumentOriginTypes,isPrem,signerAvailabilityOfTemplates);isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder;isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder;isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder; // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
	// those properties, so don't do that
	//---------------- end handle enabled signers list
	this.setState({packageDSDocuments:packageDSDocuments,formInputs:formInputs,isValidTheForm:isValidTheForm,dynamicFieldIdCursor:dynamicFieldIdCursor,isItExistFirstSignerPlaceholder:isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder:isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder:isItExistBrokerSignerPlaceholder});return context$2$0.abrupt('return',{packageDSDocuments:packageDSDocuments,formInputs:formInputs,isValidTheForm:isValidTheForm});case 43:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This is an onclick handler for the add document.
	     * Create instances, process data and set state of documents and inputs.
	     */},{key:'onClickAddGeneratedDocument',value:function onClickAddGeneratedDocument(){var DSDocumentOriginTypes,_state21,formInputs,packageDSDocuments,isValidTheForm,dynamicFieldIdCursor,moduleKey,subModuleKey,stakeholders,languageOptions,documentTemplateOptions,contractId,tarificationId,tarificationNumber,isPrem,signerAvailabilityOfTemplates,claimId,claimNumber,clientLanguage,team,teamName,teamSubgroup,result,addSignersButtonFlags,isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder;return regeneratorRuntime.async(function onClickAddGeneratedDocument$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:DSDocumentOriginTypes = this.props.DSDocumentOriginTypes;_state21 = this.state;formInputs = _state21.formInputs;packageDSDocuments = _state21.packageDSDocuments;isValidTheForm = _state21.isValidTheForm;dynamicFieldIdCursor = _state21.dynamicFieldIdCursor;moduleKey = _state21.moduleKey;subModuleKey = _state21.subModuleKey;stakeholders = _state21.stakeholders;languageOptions = _state21.languageOptions;documentTemplateOptions = _state21.documentTemplateOptions;contractId = _state21.contractId;tarificationId = _state21.tarificationId;tarificationNumber = _state21.tarificationNumber;isPrem = _state21.isPrem;signerAvailabilityOfTemplates = _state21.signerAvailabilityOfTemplates;claimId = _state21.claimId;claimNumber = _state21.claimNumber;clientLanguage = _nestedProperty2['default'].get(formInputs,"clientLanguage.value");team = _nestedProperty2['default'].get(formInputs,"team.value");teamName = _nestedProperty2['default'].get(formInputs,"teamName.value");teamSubgroup = _nestedProperty2['default'].get(formInputs,"teamSubgroup.value");context$2$0.next = 24;return regeneratorRuntime.awrap(this.createDSDocumentForPackage(packageDSDocuments,clientLanguage,{team:team,teamName:teamName,teamSubgroup:teamSubgroup},dynamicFieldIdCursor,languageOptions,documentTemplateOptions,{contractId:contractId,tarificationId:tarificationId,tarificationNumber:tarificationNumber,claimId:claimId,claimNumber:claimNumber,moduleKey:moduleKey,subModuleKey:subModuleKey,isPrem:isPrem}));case 24:result = context$2$0.sent;formInputs = _extends({},formInputs,result.documentFormInputs);packageDSDocuments = result.packageDSDocuments;dynamicFieldIdCursor = result.dynamicFieldIdCursor;formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,true); // ++++++++++++ start handle enabled signers list ++++++++++++++
	addSignersButtonFlags = (0,_DSWizardHelper.getSignerAdderButtonsFlags)(packageDSDocuments,DSDocumentOriginTypes,isPrem,signerAvailabilityOfTemplates);isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder;isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder;isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder; // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
	// those properties, so don't do that
	//---------------- end handle enabled signers list
	// set state
	this.setState({packageDSDocuments:packageDSDocuments,formInputs:formInputs,isValidTheForm:isValidTheForm,dynamicFieldIdCursor:dynamicFieldIdCursor,isItExistFirstSignerPlaceholder:isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder:isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder:isItExistBrokerSignerPlaceholder});case 36:case 'end':return context$2$0.stop();}},null,this);} /**
	     * Must called after each modification of formInputs
	     */},{key:'onUpdateFormInputs',value:function onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey){var forcePackageId=arguments.length <= 5 || arguments[5] === undefined?null:arguments[5];var _state22=this.state;var packageId=_state22.packageId;var clientId=_state22.clientId;var packageIdFieldName=(0,_DSWizardFormControl.getPackageIdFieldName)();var finalPackageId=forcePackageId || packageId || this.props.packageId;formInputs[packageIdFieldName].value = finalPackageId; // Minimum one tarification template required with the mark of special template template.
	// literally it is a boolean value in list of properties of a template, can be set in back-office.
	// This is only in case when we are on tarification module
	// Set the flag, what let the form to continue on tarification module.
	// set the flag, what let the form to continue on tarification module.
	formInputs["hasObligatedTarificationTemplate"].value = (0,_DSWizardHelper.isATarificationAndHasAMarkedTemplate)(moduleKey,packageDSDocuments,subModuleKey);formInputs["hasObligatedMandateTemplate"].value = (0,_DSWizardHelper.isMandateAndHasAMarkedTemplate)(moduleKey,packageDSDocuments,subModuleKey); // add OR remove signer related form inputs, depends on what kind of documents are added to de dynamic document list
	formInputs = this.reconstructAndFillSignerFormInputs(formInputs,packageDSDocuments,clientId,finalPackageId,stakeholders); // sync call
	return formInputs;}},{key:'handleScroll',value:function handleScroll(e){var forceCloseDatepicker=this.state.forceCloseDatepicker;if(!forceCloseDatepicker){this.setState({forceCloseDatepicker:true});}} /**
	     * This will render the modal content of status explainer in case of error.
	     */},{key:'renderDSWizardPopup',value:function renderDSWizardPopup(){var _this23=this;var _props18=this.props;var lang=_props18.lang;var brokersTeamWhiteList=_props18.brokersTeamWhiteList;var clientOptionsDict=_props18.clientOptionsDict;var customModalTitle1=_props18.customModalTitle1;var customModalDescriptionStep1=_props18.customModalDescriptionStep1;var DSDocumentOriginTypes=_props18.DSDocumentOriginTypes;var isOffice=_props18.isOffice;var claimWizardDocType=_props18.claimWizardDocType;var _state23=this.state;var moduleKey=_state23.moduleKey;var subModuleKey=_state23.subModuleKey;var isPrem=_state23.isPrem;var showSecondSigner=_state23.showSecondSigner;var showBrokerSigner=_state23.showBrokerSigner;var languageOptions=_state23.languageOptions;var clientId=_state23.clientId;var contractId=_state23.contractId;var tarificationId=_state23.tarificationId;var claimId=_state23.claimId;var _state24=this.state;var isValidTheForm=_state24.isValidTheForm;var formInputs=_state24.formInputs;var firstSignerEmailAddressOptions=_state24.firstSignerEmailAddressOptions;var  /* contractNumbersOptions ,*/brokerOptions=_state24.brokerOptions;var brokerEmailOptions=_state24.brokerEmailOptions;var remainderIntervalOptions=_state24.remainderIntervalOptions;var remainderRepeatsOptions=_state24.remainderRepeatsOptions;var packageDSDocuments=_state24.packageDSDocuments;var teamsOptions=_state24.teamsOptions;var teamSubgroupsOptions=_state24.teamSubgroupsOptions;var countryPhoneCodes=_state24.countryPhoneCodes;var clientGSMPhoneNumbers=_state24.clientGSMPhoneNumbers;var brokerGSMPhoneNumbers=_state24.brokerGSMPhoneNumbers;var isItExistFirstSignerPlaceholder=_state24.isItExistFirstSignerPlaceholder;var isItExistSecondSignerPlaceholder=_state24.isItExistSecondSignerPlaceholder;var isItExistBrokerSignerPlaceholder=_state24.isItExistBrokerSignerPlaceholder;var stakeholders=_state24.stakeholders;var haveAvailableClaimTemplate=_state24.haveAvailableClaimTemplate;var initiatorEmailAddressesFromTemplates=_state24.initiatorEmailAddressesFromTemplates;if(!formInputs || Object.keys(formInputs).length === 0 || !packageDSDocuments){return _react2['default'].createElement('div',null,'...');}var isRequiredTarification=moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION;var isThereABrokerFill=(0,_DSWizardHelper.checkDocumentAfterFillIns)(packageDSDocuments);var _props19=this.props;var emailServerConfigModalIsOpen=_props19.emailServerConfigModalIsOpen;var dispatch=_props19.dispatch;var firstSignerGSMPhoneNumber=isOffice?brokerGSMPhoneNumbers:clientGSMPhoneNumbers;var requireSmsOtpSigningResult=(0,_DSWizardHelper.requireSmsOtpSigning)(packageDSDocuments,DSDocumentOriginTypes);var formErrorNoGeneratedDoc=false;if(!isValidTheForm.isValid && isValidTheForm.errors){var error=isValidTheForm.errors.filter(function(item){return item.code === _DSWizardFormControl.DS_WIZARD_ERROR_CODE_NO_GENERATED_DOC && item.touched;});if(error && error.length > 0){formErrorNoGeneratedDoc = error[0];}} // ++++++ prepare values for rendering uploader
	var moduleType=(0,_DSWizardHelper.getModuleTypeByModuleKey)(moduleKey);var entityId=(0,_DSWizardHelper.getEntityIdByModule)((0,_DSWizardHelper.getModuleTypeByModuleKey)(moduleKey),clientId,contractId,claimId,tarificationId); // BEWB-511 -> (moduleType !== "tarification")
	// in case when the user is on tarification overview, must show different upload categories than general: BEWB-511
	// In any case when we don't have entityId, lic a contract id oor tarification id, from overview we show a
	// default category list as of the client profile
	if(!entityId && moduleType !== "tarification"){entityId = clientId;moduleType = (0,_DSWizardHelper.getModuleTypeByModuleKey)(c.DS_MODULE_CLIENT_PROFILE);} // ------ Preparation for uploader END
	var brokerSigningStakeholder=stakeholders && stakeholders.find(function(stakeholder){return stakeholder.signerType === "BROKER";}); // pacakgeInstance if exist we need that
	// find the package instance from the first document of the package
	var packageInstance={};if(packageDSDocuments){packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");}var isClaimsModule=moduleKey === c.DS_MODULE_CLIENT_CLAIMS;var isClaimWizardModule=moduleKey === c.DS_MODULE_CLAIM_WIZARD;return _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalContent,key:"mifidStep1",onWheel:function(e){return _this23.handleScroll(e);}},_react2['default'].createElement('span',{className:_documentsScss2['default'].title,key:"titleSpanKey"},isPrem?_('DSWizardModalTitleMandate'):customModalTitle1?customModalTitle1:_('DSWizardModalTitle')),_react2['default'].createElement('form',{method:'post',onSubmit:function(ev){return ev.preventDefault();},className:_documentsScss2['default'].modalFormContent,key:"masterFormKey"},_react2['default'].createElement('span',{className:_documentsScss2['default'].message},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].titleLabel),key:"DSWizardModalDescriptionKey"},isPrem?_('DSWizardModalDescriptionMandate'):customModalDescriptionStep1?customModalDescriptionStep1:_('DSWizardModalDescription')),!isOffice && _react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},formInputs.clientTypeCode === c.CLIENT_TYPE_PERSON?_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('clientName'),' '):_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('clientCompanyName'),' '),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText),type:'text',value:formInputs.clientName.value,onChange:function(e){return _this23.onChangeFormInput(e.target.value,"clientName");},onBlur:function(e){var forceTouch=true;return _this23.onChangeFormInput(e.target.value,"clientName",forceTouch);},ref:'clientName',name:'clientName',disabled:true})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.clientName.touched && formInputs.clientName.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.clientName.error && formInputs.clientName.touched && formInputs.clientName.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('brokerNumber'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.brokerNumber.value,brokerOptions) || "",ref:'brokerNumber',name:'brokerNumber',isDisabled:isPrem,onChange:function(value){if(isThereABrokerFill){return _this23.setState({isOpenAreYouSure:{title:_('areYouSureModalTitle'),message:_('areYouSureToChangeBrokerNumber'),callBackCancel:function callBackCancel(){},callBackOk:function callBackOk(){return _this23.onChangeBrokerNumberHandler(value);}}});}else {return _this23.onChangeBrokerNumberHandler(value);}},handleOnBlur:function(e){},options:brokerOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false}))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.brokerNumber.touched && formInputs.brokerNumber.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.brokerNumber.error && formInputs.brokerNumber.touched && formInputs.brokerNumber.error,formInputs.brokerName.error && formInputs.brokerName.error)),isRequiredTarification && _react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('team'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.team.value,teamsOptions) || "",ref:'team',name:'team',onChange:function(value){if(isThereABrokerFill){return _this23.setState({isOpenAreYouSure:{title:_('areYouSureModalTitle'),message:_('areYouSureToChangeTeam'),callBackCancel:function callBackCancel(){},callBackOk:function callBackOk(){return _this23.onChangeTeamHandler(value,{value:formInputs.teamSubgroup.value},packageDSDocuments,formInputs);}}});}else {return _this23.onChangeTeamHandler(value,{value:formInputs.teamSubgroup.value},packageDSDocuments,formInputs);}},handleOnBlur:function(e){},options:teamsOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false}))),isRequiredTarification && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.team.touched && formInputs.team.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.team.error && formInputs.team.touched && formInputs.team.error)),isRequiredTarification && formInputs.team.value == 1 && _react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('teamSubgroup'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.teamSubgroup.value,teamSubgroupsOptions) || "",ref:'teamSubgroup',name:'teamSubgroup',onChange:function(value){if(isThereABrokerFill){return _this23.setState({isOpenAreYouSure:{title:_('areYouSureModalTitle'),message:_('areYouSureToChangeTeamSubgroup'),callBackCancel:function callBackCancel(){},callBackOk:function callBackOk(){return _this23.onChangeTeamHandler({value:formInputs.team.value},value,packageDSDocuments,formInputs);}}});}else {return _this23.onChangeTeamHandler({value:formInputs.team.value},value,packageDSDocuments,formInputs);}},handleOnBlur:function(e){},options:teamSubgroupsOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false}))),isRequiredTarification && formInputs.team.value == 1 && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.teamSubgroup.touched && formInputs.teamSubgroup.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.teamSubgroup.error && formInputs.teamSubgroup.touched && formInputs.teamSubgroup.error)),packageDSDocuments && packageDSDocuments.length > 0?packageDSDocuments.map(function(oneDocument){return _this23.renderPackageDocument(oneDocument,isRequiredTarification);}):_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].row,_documentsScss2['default'].noHeight,_documentsScss2['default'].marginBottomS)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].row)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].short1,_documentsScss2['default'].alignRight)},_("noPackageDocumentAddedYetPleaseAdd")))),packageDSDocuments && packageDSDocuments.length > 0 && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].row,_documentsScss2['default'].noHeight,_documentsScss2['default'].marginBottomS)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].row)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].short1,_documentsScss2['default'].alignRight)},_('totalSizeOfFiles'),' ',(Math.ceil(Number(packageDSDocuments.reduce(function(accumulator,currentValue){return Number(accumulator) + Number(currentValue.fileSize);},0) / 1024 / 1024) * 100) / 100).toFixed(2),' ',_('megabytes')))),isPrem && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.hasObligatedMandateTemplate.touched && formInputs.hasObligatedMandateTemplate.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessage,_documentsScss2['default'].textAlignLeft)},formInputs.hasObligatedMandateTemplate.error && formInputs.hasObligatedMandateTemplate.touched && formInputs.hasObligatedMandateTemplate.error)),isRequiredTarification && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].noHeight,_documentsScss2['default'].marginBottomS)},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('tarificationNumber'),': '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].row)},formInputs.tarificationNumber.value?formInputs.tarificationNumber.value:_("newTarificationWillBeCreated"))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.hasObligatedTarificationTemplate.touched && formInputs.hasObligatedTarificationTemplate.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessage,_documentsScss2['default'].textAlignLeft)},formInputs.hasObligatedTarificationTemplate.error && formInputs.hasObligatedTarificationTemplate.touched && formInputs.hasObligatedTarificationTemplate.error)),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formErrorNoGeneratedDoc?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessage,_documentsScss2['default'].textAlignLeft)},formErrorNoGeneratedDoc.message)))),_react2['default'].createElement('div',{className:_documentsScss2['default'].addDocumentButtonContainer},!isOffice && _react2['default'].createElement(_UploadLocalDocumentUploadLocalDocumentButton2['default'],{onSelectDocuments:this.onSelectLocalDocument.bind(this),clientId:clientId,entityId:entityId,moduleType:moduleType,classNameExtra:_documentsScss2['default'].uploadButton,claimWizardDocType:claimWizardDocType}),!isOffice && _react2['default'].createElement(_SelectOracleDocumentOracleDocumentButton2['default'],{onSelectDocuments:this.openOracleDocumentsModal.bind(this)}),isClaimsModule && haveAvailableClaimTemplate || !isClaimsModule?_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons},_react2['default'].createElement('button',{type:'button',className:_documentsScss2['default'].greenButton + " enabled",onClick:function(e){_this23.onClickAddGeneratedDocument();}},_react2['default'].createElement('div',{className:_documentsScss2['default'].iconContainer},_react2['default'].createElement('img',{src:__webpack_require__(353)})),_("addDocument"))):''),(0,_DSWizardHelper.requireSigning)(packageDSDocuments,DSDocumentOriginTypes)?_react2['default'].createElement('span',{className:_documentsScss2['default'].message},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].noHeight)},_react2['default'].createElement('label',{className:(0,_classnames2['default'])(_documentsScss2['default'].formLabel,_documentsScss2['default'].signersAreaLabel)},isPrem?_('signersAreaTitlelMandate'):_('signersAreaTitle'))),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('firstSignerLastName'),' '),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText),type:'text',value:formInputs.firstSignerLastName.value,onChange:function(e){return _this23.onChangeFormInput(e.target.value,"firstSignerLastName");},onBlur:function(e){var forceTouch=true;return _this23.onChangeFormInput(e.target.value,"firstSignerLastName",forceTouch);},ref:'firstSignerLastName',name:'firstSignerLastName'})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.firstSignerLastName.touched && formInputs.firstSignerLastName.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.firstSignerLastName.error && formInputs.firstSignerLastName.touched && formInputs.firstSignerLastName.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('firstSignerFirstName'),' '),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText),type:'text',value:formInputs.firstSignerFirstName.value,onChange:function(e){return _this23.onChangeFormInput(e.target.value,"firstSignerFirstName");},onBlur:function(e){var forceTouch=true;return _this23.onChangeFormInput(e.target.value,"firstSignerFirstName",forceTouch);},ref:'firstSignerFirstName',name:'firstSignerFirstName'})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.firstSignerFirstName.touched && formInputs.firstSignerFirstName.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.firstSignerFirstName.error && formInputs.firstSignerFirstName.touched && formInputs.firstSignerFirstName.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer,key:"formInputContainerKey1"},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('emailAddress'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.clientEmailAddress.value,firstSignerEmailAddressOptions) || firstSignerEmailAddressOptions[0] || '',ref:'clientEmailAddress',name:'clientEmailAddress',onChange:function(value){return _this23.onChangeFormInput(_nestedProperty2['default'].get(value,"value") || "","clientEmailAddress");},handleOnBlur:function(e){var forceTouch=true;var typedValue=_nestedProperty2['default'].get(e,"target.value");if(typedValue){return _this23.onChangeFormInput(_nestedProperty2['default'].get(e,"target.value") || "","clientEmailAddress",forceTouch);}},options:firstSignerEmailAddressOptions,isSearchable:true,isClearable:true,isMulti:false,formatCreateLabel:_('newClientEmail'),isCreatableSelect:true,noOptionsLabel:_('emailAddressNoOption')}))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.clientEmailAddress.touched && formInputs.clientEmailAddress.error?"":_documentsScss2['default'].none),key:"errorMessageContainerKey1"},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.clientEmailAddress.error && formInputs.clientEmailAddress.touched && formInputs.clientEmailAddress.error)),requireSmsOtpSigningResult && _react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer,key:"formInputPhoneNumberContainerKey"},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('firstSignerPhoneNumber'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].inputsForceRow)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].phoneCode)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.firstSignerCountryPhoneCode.value,countryPhoneCodes) || "",options:countryPhoneCodes,ref:'firstSignerCountryPhoneCode',name:'firstSignerCountryPhoneCode',onChange:function(value){return _this23.onChangeFirstSignerCountryCode(_nestedProperty2['default'].get(value,"value") || "");},handleOnBlur:function(e){var forceTouch=true;var typedValue=_nestedProperty2['default'].get(e,"target.value");if(typedValue){return _this23.onChangeFirstSignerCountryCode(_nestedProperty2['default'].get(e,"target.value") || "",forceTouch);}},isSearchable:true,isClearable:true,isMulti:false, // formatCreateLabel={_('newClientPhoneNumber')}
	isCreatableSelect:false})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect,_documentsScss2['default'].sizeXS)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.firstSignerPhoneNumber.value,firstSignerGSMPhoneNumber) || "",ref:'firstSignerPhoneNumber',name:'firstSignerPhoneNumber',onChange:function(value){return _this23.onChangeFirstSignerPhoneNumber(value);},handleOnBlur:function(e){var forceTouch=true;var typedValue=_nestedProperty2['default'].get(e,"target.value");var inputValueObject={value:typedValue || ""};if(!typedValue){return;}return _this23.onChangeFirstSignerPhoneNumber(inputValueObject,forceTouch);},options:firstSignerGSMPhoneNumber,isSearchable:true,isClearable:true,isMulti:false,formatCreateLabel:_('newClientPhoneNumber'),isCreatableSelect:true,noOptionsLabel:_('phoneNumberNoOptions')})))),requireSmsOtpSigningResult && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.firstSignerPhoneNumber.touched && formInputs.firstSignerPhoneNumber.error?"":_documentsScss2['default'].none),key:"errorMessageContainerKey2"},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.firstSignerPhoneNumber.error && formInputs.firstSignerPhoneNumber.touched && formInputs.firstSignerPhoneNumber.error)),(isPrem || isItExistSecondSignerPlaceholder || isOffice) && _react2['default'].createElement('div',{className:_documentsScss2['default'].secondSigner},showSecondSigner && _react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('secondSignerLastName'),' '),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText),type:'text',value:formInputs.secondSignerLastName.value, // value={formInputs.secondSignerLastName.value}
	onChange:function(e){return _this23.onChangeFormInput(e.target.value,"secondSignerLastName");},onBlur:function(e){var forceTouch=true;return _this23.onChangeFormInput(e.target.value,"secondSignerLastName",forceTouch);},ref:'secondSignerLastName',name:'secondSignerLastName'})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.secondSignerLastName.touched && formInputs.secondSignerLastName.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.secondSignerLastName.error && formInputs.secondSignerLastName.touched && formInputs.secondSignerLastName.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('secondSignerFirstName'),' '),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText),type:'text',value:formInputs.secondSignerFirstName.value,onChange:function(e){return _this23.onChangeFormInput(e.target.value,"secondSignerFirstName");},onBlur:function(e){var forceTouch=true;return _this23.onChangeFormInput(e.target.value,"secondSignerFirstName",forceTouch);},ref:'secondSignerFirstName',name:'secondSignerFirstName'})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.secondSignerFirstName.touched && formInputs.secondSignerFirstName.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.secondSignerFirstName.error && formInputs.secondSignerFirstName.touched && formInputs.secondSignerFirstName.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('secondSignerLanguage'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.secondSignerLanguage.value,languageOptions) || "",ref:'secondSignerLanguage',name:'secondSignerLanguage',onChange:function(value){return _this23.onChangeFormInput(_nestedProperty2['default'].get(value,"value") || "","secondSignerLanguage");},handleOnBlur:function(e){},options:languageOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false}))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.secondSignerLanguage.touched && formInputs.secondSignerLanguage.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.secondSignerLanguage.error && formInputs.secondSignerLanguage.touched && formInputs.secondSignerLanguage.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('secondSignerEmailAddress'),' '),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText),type:'text',value:formInputs.secondSignerEmailAddress.value,onChange:function(e){return _this23.onChangeFormInput(e.target.value,"secondSignerEmailAddress");},onBlur:function(e){var forceTouch=true;return _this23.onChangeFormInput(e.target.value,"secondSignerEmailAddress",forceTouch);},ref:'secondSignerEmailAddress',name:'secondSignerEmailAddress'})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.secondSignerEmailAddress.touched && formInputs.secondSignerEmailAddress.error?"":_documentsScss2['default'].none),key:"errorMessageContainerKey12"},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.secondSignerEmailAddress.error && formInputs.secondSignerEmailAddress.touched && formInputs.secondSignerEmailAddress.error)),requireSmsOtpSigningResult && _react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('secondSignerPhoneNumber'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].inputsForceRow)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].phoneCode)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.secondSignerCountryPhoneCode.value || '',countryPhoneCodes) || "",options:countryPhoneCodes,ref:'secondSignerCountryPhoneCode',name:'secondSignerCountryPhoneCode',onChange:function(value){return _this23.onChangeSecondSignerCountryCode(_nestedProperty2['default'].get(value,"value") || "");},handleOnBlur:function(e){var forceTouch=true;var typedValue=_nestedProperty2['default'].get(e,"target.value");if(typedValue){return _this23.onChangeSecondSignerCountryCode(_nestedProperty2['default'].get(e,"target.value") || "",forceTouch);}},isSearchable:true,isClearable:true,isMulti:false, // formatCreateLabel={_('newClientPhoneNumber')}
	isCreatableSelect:false})),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText,_documentsScss2['default'].sizeXS),type:'text',value:formInputs.secondSignerPhoneNumber.value,onChange:function(e){return _this23.onChangeSecondSignerPhoneNumber(e.target.value);},onBlur:function(e){var forceTouch=true;return _this23.onChangeSecondSignerPhoneNumber(e.target.value,forceTouch);},ref:'secondSignerPhoneNumber',name:'secondSignerPhoneNumber'}))),requireSmsOtpSigningResult && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.secondSignerPhoneNumber.touched && formInputs.secondSignerPhoneNumber.error?"":_documentsScss2['default'].none),key:"errorMessageContainerKey2"},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.secondSignerPhoneNumber.error && formInputs.secondSignerPhoneNumber.touched && formInputs.secondSignerPhoneNumber.error))),_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons + ' secondSigner'},_react2['default'].createElement('button',{type:'button',className:_documentsScss2['default'].greenButton + " enabled",onClick:function(e){var result=_this23.toggleShowSecondSigner(formInputs,packageDSDocuments);result.formInputs = (0,_DSWizardFormControl.formInputsValidation)(result.formInputs);var isValidTheForm=(0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,true);_this23.setState({showSecondSigner:result.showSecondSigner,formInputs:result.formInputs,isValidTheForm:isValidTheForm});}},showSecondSigner?_('removeSecondSigner'):_("addSecondSigner")))),_react2['default'].createElement('div',{className:_documentsScss2['default'].secondSigner},showBrokerSigner && _react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('input',{ref:'brokerSignerExists',name:'brokerSignerExists',type:'hidden',value:formInputs['brokerSignerExists'].value || false}),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('brokerSignerLastName'),' '),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText),type:'text',value:formInputs.brokerSignerLastName.value, // value={formInputs.brokerSignerLastName.value}
	onChange:function(e){return _this23.onChangeFormInput(e.target.value,"brokerSignerLastName");},onBlur:function(e){var forceTouch=true;return _this23.onChangeFormInput(e.target.value,"brokerSignerLastName",forceTouch);},ref:'brokerSignerLastName',name:'brokerSignerLastName'})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.brokerSignerLastName.touched && formInputs.brokerSignerLastName.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.brokerSignerLastName.error && formInputs.brokerSignerLastName.touched && formInputs.brokerSignerLastName.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('brokerSignerFirstName'),' '),_react2['default'].createElement('input',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputText),type:'text',value:formInputs.brokerSignerFirstName.value,onChange:function(e){return _this23.onChangeFormInput(e.target.value,"brokerSignerFirstName");},onBlur:function(e){var forceTouch=true;return _this23.onChangeFormInput(e.target.value,"brokerSignerFirstName",forceTouch);},ref:'brokerSignerFirstName',name:'brokerSignerFirstName'})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.brokerSignerFirstName.touched && formInputs.brokerSignerFirstName.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.brokerSignerFirstName.error && formInputs.brokerSignerFirstName.touched && formInputs.brokerSignerFirstName.error)),_react2['default'].createElement('input',{ref:'brokerSignerLanguage',name:'brokerSignerLanguage',type:'hidden',value:formInputs['brokerSignerLanguage'].value || ''}),requireSmsOtpSigningResult && _react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer,key:"formInputPhoneNumberContainerKey"},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_('brokerSignerPhoneNumber'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].inputsForceRow)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].phoneCode)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.brokerSignerCountryPhoneCode.value,countryPhoneCodes) || "",options:countryPhoneCodes,ref:'brokerSignerCountryPhoneCode',name:'brokerSignerCountryPhoneCode',onChange:function(value){return _this23.onChangeBrokerSignerCountryCode(_nestedProperty2['default'].get(value,"value") || "");},handleOnBlur:function(e){var forceTouch=true;var typedValue=_nestedProperty2['default'].get(e,"target.value");if(typedValue){return _this23.onChangeBrokerSignerCountryCode(_nestedProperty2['default'].get(e,"target.value") || "",forceTouch);}},isSearchable:true,isClearable:true,isMulti:false, // formatCreateLabel={_('newClientPhoneNumber')}
	isCreatableSelect:false})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect,_documentsScss2['default'].sizeXS)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.brokerSignerPhoneNumber.value,brokerGSMPhoneNumbers) || "",ref:'brokerSignerPhoneNumber',name:'brokerSignerPhoneNumber',onChange:function(value){return _this23.onChangeBrokerSignerPhoneNumber(value);},handleOnBlur:function(e){var forceTouch=true;var typedValue=_nestedProperty2['default'].get(e,"target.value");var inputValueObject={value:typedValue || ""};if(!typedValue){return;}return _this23.onChangeBrokerSignerPhoneNumber(inputValueObject,forceTouch);},options:brokerGSMPhoneNumbers,isSearchable:true,isClearable:true,isMulti:false,formatCreateLabel:_('newClientPhoneNumber'),isCreatableSelect:true})))),requireSmsOtpSigningResult && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.brokerSignerPhoneNumber.touched && formInputs.brokerSignerPhoneNumber.error?"":_documentsScss2['default'].none),key:"errorMessageContainerKey2"},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.brokerSignerPhoneNumber.error && formInputs.brokerSignerPhoneNumber.touched && formInputs.brokerSignerPhoneNumber.error))),isItExistBrokerSignerPlaceholder && _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons + ' secondSigner'},_react2['default'].createElement('button',{type:'button',className:_documentsScss2['default'].greenButton + " enabled",onClick:function(e){var result=_this23.toggleShowBrokerSigner(formInputs,packageDSDocuments,brokerSigningStakeholder);_this23.setState({showBrokerSigner:result.showBrokerSigner,formInputs:result.formInputs});}},showBrokerSigner?_('removeBrokerAsSigner'):_("addBrokerAsSigner")))),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:_documentsScss2['default'].formLabel},_(isOffice?'willemotEmailAddress':'brokerEmailAddress')),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.brokerEmailAddress.value,isOffice?initiatorEmailAddressesFromTemplates:brokerEmailOptions) || "",ref:'brokerEmailAddress',name:'brokerEmailAddress',onChange:function(value){return _this23.onChangeFormInput(_nestedProperty2['default'].get(value,"value") || "","brokerEmailAddress");},handleOnBlur:function(e){},options:isOffice?initiatorEmailAddressesFromTemplates:brokerEmailOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false}))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.brokerEmailAddress.touched && formInputs.brokerEmailAddress.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.brokerEmailAddress.error && formInputs.brokerEmailAddress.touched && formInputs.brokerEmailAddress.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:(0,_classnames2['default'])(_documentsScss2['default'].formLabel)},_(isOffice?'brokerReminderInterval':'remainderInterval'),_react2['default'].createElement('img',{onClick:function(e){_this23.setState({isOpenIntervalInfo:true});},className:(0,_classnames2['default'])(_documentsScss2['default'].infoIcon),src:this.getIcon('icn-info')})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].inputsForceRow)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect,_documentsScss2['default'].sizeXS,_documentsScss2['default'].first)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.remainderInterval.value,remainderIntervalOptions) || "",ref:'remainderInterval',name:'remainderInterval',onChange:function(value){return _this23.onChangeRemainderInterval(value.value);},handleOnBlur:function(e){},options:remainderIntervalOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formLabel,_documentsScss2['default'].marginLeftS,_documentsScss2['default'].short1)},_('remainderRepeats'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect,_documentsScss2['default'].sizeXS,_documentsScss2['default'].shortMargin,_documentsScss2['default'].last)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.remainderRepeats.value,remainderRepeatsOptions) || "",ref:'remainderRepeats',name:'remainderRepeats',onChange:function(value){return _this23.onChangeFormInput(_nestedProperty2['default'].get(value,"value") || "","remainderRepeats");},handleOnBlur:function(e){},options:remainderRepeatsOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false,isDisabled:parseInt(formInputs.remainderInterval.value) === 0})))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.remainderInterval.touched && formInputs.remainderInterval.error || formInputs.remainderRepeats.touched && formInputs.remainderRepeats.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.remainderInterval.error && formInputs.remainderInterval.touched && formInputs.remainderInterval.error),_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.remainderRepeats.error && formInputs.remainderRepeats.touched && formInputs.remainderRepeats.error)),_react2['default'].createElement('div',{className:_documentsScss2['default'].formInputContainer},_react2['default'].createElement('label',{className:(0,_classnames2['default'])(_documentsScss2['default'].formLabel)},_(isOffice?'willemotReminderTicketInterval':'remainderTicketInterval'),_react2['default'].createElement('img',{onClick:function(e){_this23.setState({isOpenTicketIntervalInfo:true});},className:(0,_classnames2['default'])(_documentsScss2['default'].infoIcon),src:this.getIcon('icn-info')})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].inputsForceRow)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect,_documentsScss2['default'].sizeXS,_documentsScss2['default'].first)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.remainderTicketInterval.value,remainderIntervalOptions) || "",ref:'remainderTicketInterval',name:'remainderTicketInterval',onChange:function(value){return _this23.onChangeRemainderTicketInterval(value.value);},handleOnBlur:function(e){},options:remainderIntervalOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formLabel,_documentsScss2['default'].marginLeftS,_documentsScss2['default'].short1)},_('remainderRepeats'),' '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].formInputCreatableSelect,_documentsScss2['default'].sizeXS,_documentsScss2['default'].shortMargin,_documentsScss2['default'].last)},_react2['default'].createElement(_DSWizardHelper2['default'],{value:(0,_DSWizardFormControl.findItemByValueFromSelectOptions)(formInputs.remainderTicketRepeats.value,remainderRepeatsOptions) || "",ref:'remainderTicketRepeats',name:'remainderTicketRepeats',onChange:function(value){return _this23.onChangeFormInput(_nestedProperty2['default'].get(value,"value") || "","remainderTicketRepeats");},handleOnBlur:function(e){},options:remainderRepeatsOptions,isSearchable:true,isClearable:true,isMulti:false,isCreatableSelect:false,isDisabled:parseInt(formInputs.remainderTicketInterval.value) === 0})))),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.remainderInterval.touched && formInputs.remainderInterval.error || formInputs.remainderRepeats.touched && formInputs.remainderRepeats.error?"":_documentsScss2['default'].none)},_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.remainderInterval.error && formInputs.remainderInterval.touched && formInputs.remainderInterval.error),_react2['default'].createElement('div',{className:_documentsScss2['default'].errorMessage},formInputs.remainderRepeats.error && formInputs.remainderRepeats.touched && formInputs.remainderRepeats.error)))):null,!isValidTheForm.isValid && isValidTheForm.errors.map(function(oneErr,errIndex){return _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessageContainer,formInputs.hasObligatedTarificationTemplate.touched && formInputs.hasObligatedTarificationTemplate.error?"":_documentsScss2['default'].none),key:oneErr.code + " " + errIndex},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].errorMessage,_documentsScss2['default'].textAlignLeft)},oneErr.message && oneErr.touched && oneErr.message));}),_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons},_react2['default'].createElement('div',{onClick:function callee$2$0(){var skipValidationJustUpdate,listOfTmpId;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:if(!(packageInstance && packageInstance._id)){context$3$0.next = 6;break;}skipValidationJustUpdate = true;context$3$0.next = 4;return regeneratorRuntime.awrap(this.initStep2(formInputs,skipValidationJustUpdate));case 4:context$3$0.next = 10;break;case 6:if(!(packageDSDocuments && packageDSDocuments.length > 0)){context$3$0.next = 10;break;}listOfTmpId = packageDSDocuments.filter(function(oneDoc){return oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD;}).map(function(oneDoc){return oneDoc.temporaryUploadId;});context$3$0.next = 10;return regeneratorRuntime.awrap(dispatch((0,_stateActions.removeTemporaryUpload)(listOfTmpId)));case 10: // just reset triggers and states and close modal
	this.closeModal();case 11:case 'end':return context$3$0.stop();}},null,_this23);},className:_documentsScss2['default'].cancel},_("cancel")),_react2['default'].createElement('button',{type:'button',className:_documentsScss2['default'].greenButton + " enabled",disabled:!isValidTheForm.isValid,onClick:function(e){e.preventDefault();var formInputs=_this23.state.formInputs;var brokerEmailAddress=formInputs.brokerEmailAddress.value;if(brokerEmailAddress){dispatch((0,_stateActions2.loadEmailServer)(brokerEmailAddress)).then(function(res){if(res && res.senderName && res.senderName.length > 0){_this23.initStep2(formInputs).then(function(){ // step forward to disable rendering of form
	_this23.setState({step:c.DSWIZARD_STEP_2_FILL_DOCUMENTS},function(){});})['catch'](function(err){console.error("init step 2: ",err); // step forward to disable rendering of form
	_this23.setState({step:c.DSWIZARD_STEP_1_COMPOSE_PACKAGE});});}else {dispatch((0,_stateActions2.showEmailServerConfigModal)(brokerEmailAddress));}})['catch'](function(err){dispatch((0,_stateActions2.showEmailServerConfigModal)(brokerEmailAddress));});}else {_this23.initStep2(formInputs).then(function(){ // step forward to disable rendering of form
	_this23.setState({step:c.DSWIZARD_STEP_2_FILL_DOCUMENTS},function(){});})['catch'](function(err){console.error("init step 2: ",err); // step forward to disable rendering of form
	_this23.setState({step:c.DSWIZARD_STEP_1_COMPOSE_PACKAGE});});}}},_("Next")))),_react2['default'].createElement(_emailSenderEmailServerConfigDialog2['default'],{modalIsOpen:emailServerConfigModalIsOpen,onCancel:function(){var dispatch=_this23.props.dispatch;dispatch((0,_stateActions2.hideEmailServerConfigModal)(false));},onConfirmation:function(config){dispatch((0,_stateActions2.saveEmailServer)(config)).then(function(res){dispatch((0,_stateActions2.hideEmailServerConfigModal)(true));if(res){_this23.initStep2(formInputs).then(function(){ // step forward to disable rendering of form
	_this23.setState({step:c.DSWIZARD_STEP_2_FILL_DOCUMENTS});});}})['catch'](function(err){ // step forward to disable rendering of form
	_this23.setState({step:c.DSWIZARD_STEP_1_COMPOSE_PACKAGE});});}}));} /**
	     * This function render a row for fill a document
	     * @param {object} oneDocument Instance fo dsdocument
	     */},{key:'renderDocumentFillAndPrintBlock',value:function renderDocumentFillAndPrintBlock(oneDocument){var _this24=this;var DSDocumentOriginTypes=this.props.DSDocumentOriginTypes;var stakeholders=this.state.stakeholders; // totalNumberOfSigners is require to validate PDF documents about the signature placeholder count.
	var totalNumberOfSigners=stakeholders.length;var packageReseted=oneDocument['package'].packageReseted;var documentRequiredOnOffers=oneDocument.documentTemplate?oneDocument.documentTemplate.requiredOnOffers:false;var isValid=(0,_DSWizardHelper.isValidDocument)(oneDocument,totalNumberOfSigners,DSDocumentOriginTypes);return _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].packageDocumentContainer),key:"formInputContainerPackageDocumentContainerKey" + oneDocument.cursor + oneDocument._id},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].packageDocumentDetailRow)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].documentsModalButtons,_documentsScss2['default'].fillButtonContainer)},_react2['default'].createElement('label',{className:(0,_classnames2['default'])(_documentsScss2['default'].formLabel,_documentsScss2['default'].short5)},oneDocument.fileName),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].short1,_documentsScss2['default'].alignRight),key:"documentsModalButtonsAlignRightKey"},oneDocument.origin == DSDocumentOriginTypes.DS_ORIGIN_GENERATED && _react2['default'].createElement('button',{key:'OpenDocumentForSignaturePlaceholdersEditDocumentButtonKey',type:'button',disabled:packageReseted && documentRequiredOnOffers,className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].short8,_documentsScss2['default'].autoWidth,_documentsScss2['default'].editDocumentButton,_documentsScss2['default'].greenButton + " enabled"),onClick:function(e){_this24.openFillADocument(oneDocument);}},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].btnText)},oneDocument.brokerFilledValues?_("editDocument"):_("fillDocument")),isValid && _react2['default'].createElement('img',{className:(0,_classnames2['default'])(_documentsScss2['default'].checkIcon),src:this.getIcon('ic_done_white_32px')})),!oneDocument.isAttachment && (oneDocument.origin == DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD || oneDocument.origin == DSDocumentOriginTypes.DS_ORIGIN_ORACLE) && _react2['default'].createElement('button',{key:'OpenDocumentForSignaturePlaceholdersButtonKey',type:'button',className:(0,_classnames2['default'])(_documentsScss2['default'].formInput,_documentsScss2['default'].short8,_documentsScss2['default'].autoWidth,_documentsScss2['default'].greenButton + " enabled",_documentsScss2['default'].editDocumentButton),onClick:function(e){_this24.openPopupToAddSignaturePlaceholders(oneDocument);}},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].btnText)},oneDocument.brokerFilledValues?_("editSignaturePlaceholders"):_("addSignaturePlaceholders")),isValid && _react2['default'].createElement('img',{className:_documentsScss2['default'].checkIcon,src:this.getIcon('ic_done_white_32px')})),!oneDocument.origin || oneDocument.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED?_react2['default'].createElement('div',{type:'button',className:(0,_classnames2['default'])(_documentsScss2['default'].short1),onClick:function(e){ // can not print the document until is not filled correctly
	if(!isValid){return _this24.setState({printNotValidModalOpen:[_("theDocumentIsNotFilledCorrectlyYet")]});} // open printing modal
	return _this24.printPDFManually(oneDocument);}},_react2['default'].createElement('img',{className:(0,_classnames2['default'])(_documentsScss2['default'].checkIcon),src:this.getIcon('print-black-18dp')}),oneDocument.isPrinted && _react2['default'].createElement('img',{className:(0,_classnames2['default'])(_documentsScss2['default'].checkIcon),src:this.getIcon('ic_done_green_32px')})):_react2['default'].createElement('div',{className:_documentsScss2['default'].emptyPrintSpace})))));} /**
	     * This function will popup a modal with fillable html by a document record.
	     * @param {*} oneDocument
	     */},{key:'openFillADocument',value:function openFillADocument(oneDocument){var dispatch,_state25,packageDSDocuments,claimId,packageInstance,brokerNumber,clientId,contractId,datasetId,datasetName,language,optionsLists,dataSetsForDoc,listsToGet,_iteratorNormalCompletion9,_didIteratorError9,_iteratorError9,_iterator9,_step9,placeholder,getListRequest;return regeneratorRuntime.async(function openFillADocument$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:dispatch = this.props.dispatch;_state25 = this.state;packageDSDocuments = _state25.packageDSDocuments;claimId = _state25.claimId;packageInstance = {};if(packageDSDocuments){packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");}brokerNumber = _nestedProperty2['default'].get(packageInstance,"brokerNumber");clientId = _nestedProperty2['default'].get(packageInstance,"clientId");contractId = _nestedProperty2['default'].get(packageInstance,"contractId");datasetId = _nestedProperty2['default'].get(oneDocument,"documentTemplate.dataSetId.datasetId");datasetName = _nestedProperty2['default'].get(oneDocument,"documentTemplate.dataSetId.datasetName");language = _nestedProperty2['default'].get(oneDocument,"language");optionsLists = undefined;context$2$0.prev = 13;context$2$0.next = 16;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSDataSets)()));case 16:context$2$0.next = 18;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSDataSet)(datasetName,datasetId === 'clientId'?clientId:null,brokerNumber,language,datasetId === 'contractId'?contractId:null,datasetId === 'claimId'?claimId:null)));case 18:dataSetsForDoc = context$2$0.sent;context$2$0.next = 21;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.disableBackgroundProcesses)(true)));case 21:if(!(dataSetsForDoc && dataSetsForDoc.placeholders)){context$2$0.next = 47;break;}listsToGet = [];_iteratorNormalCompletion9 = true;_didIteratorError9 = false;_iteratorError9 = undefined;context$2$0.prev = 26;for(_iterator9 = dataSetsForDoc.placeholders[Symbol.iterator]();!(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done);_iteratorNormalCompletion9 = true) {placeholder = _step9.value;if(placeholder.placeholderList){listsToGet.push({placeholderName:placeholder.placeholderName,placeholderList:placeholder.placeholderList});}}context$2$0.next = 34;break;case 30:context$2$0.prev = 30;context$2$0.t0 = context$2$0['catch'](26);_didIteratorError9 = true;_iteratorError9 = context$2$0.t0;case 34:context$2$0.prev = 34;context$2$0.prev = 35;if(!_iteratorNormalCompletion9 && _iterator9['return']){_iterator9['return']();}case 37:context$2$0.prev = 37;if(!_didIteratorError9){context$2$0.next = 40;break;}throw _iteratorError9;case 40:return context$2$0.finish(37);case 41:return context$2$0.finish(34);case 42:if(!(listsToGet && listsToGet.length > 0)){context$2$0.next = 47;break;}context$2$0.next = 45;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getLists)(listsToGet,language)));case 45:getListRequest = context$2$0.sent;if(getListRequest){optionsLists = getListRequest;}case 47:this.setState({isOpenDocumentToFill:{oneDocument:oneDocument,dataSet:dataSetsForDoc,optionsLists:optionsLists}});context$2$0.next = 53;break;case 50:context$2$0.prev = 50;context$2$0.t1 = context$2$0['catch'](13);dispatch((0,_stateActions2.setNotification)(_('wizardError') + " " + JSON.stringify(context$2$0.t1),'error'));case 53:case 'end':return context$2$0.stop();}},null,this,[[13,50],[26,30,34,42],[35,,37,41]]);} /**
	     * This function will popup a modal with images from PDF to add placeholders
	     * @param {*} oneDocument - Instance of a document record
	     */},{key:'openPopupToAddSignaturePlaceholders',value:function openPopupToAddSignaturePlaceholders(oneDocument){var dispatch,packageDSDocuments,packageInstance,pdfInfo;return regeneratorRuntime.async(function openPopupToAddSignaturePlaceholders$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:dispatch = this.props.dispatch;packageDSDocuments = this.state.packageDSDocuments;packageInstance = {};if(packageDSDocuments){packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");}context$2$0.next = 6;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.disableBackgroundProcesses)(true)));case 6:context$2$0.next = 8;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getImageListAboutPDF)(oneDocument._id)));case 8:pdfInfo = context$2$0.sent;this.setState({isOpenDocumentForPlaceholders:{dsDocument:oneDocument,maxPageNumber:pdfInfo.Pages * 1,pageSizeList:pdfInfo.pageSizeList}});case 10:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This will generate the PDF and forward to the ling toward it to print.
	     * @param {Object} oneDocument
	     */},{key:'printPDFManually',value:function printPDFManually(oneDocument){var _props20,dispatch,templates,lang,brokersTeamWhiteList,DSDocumentOriginTypes,claimWizardDocType,_state26,moduleKey,subModuleKey,dynamicFieldIdCursor,formInputs,brokerNumber,teamIndex,teamSubgroupId,linkForPdfDownload,w,onLoadWindowPromise,documentTemplateOptions,packageDSDocuments,attachIdResult;return regeneratorRuntime.async(function printPDFManually$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props20 = this.props;dispatch = _props20.dispatch;templates = _props20.templates;lang = _props20.lang;brokersTeamWhiteList = _props20.brokersTeamWhiteList;DSDocumentOriginTypes = _props20.DSDocumentOriginTypes;claimWizardDocType = _props20.claimWizardDocType;_state26 = this.state;moduleKey = _state26.moduleKey;subModuleKey = _state26.subModuleKey;dynamicFieldIdCursor = _state26.dynamicFieldIdCursor;formInputs = _state26.formInputs;brokerNumber = _nestedProperty2['default'].get(oneDocument,"package.brokerNumber");teamIndex = _nestedProperty2['default'].get(oneDocument,"package.team");teamSubgroupId = _nestedProperty2['default'].get(oneDocument,"teamSubgroup");linkForPdfDownload = HALF_FILLED_PDF_API_URL + "/" + oneDocument._id;w = window.open(linkForPdfDownload,'_blank','noopener,noreferrer');onLoadWindowPromise = new Promise(function(resolve){w.addEventListener('load',function(){resolve();},true);});context$2$0.next = 20;return regeneratorRuntime.awrap(onLoadWindowPromise);case 20:context$2$0.next = 22;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDsDocsAndPackages)(false,false,null,null,true)));case 22:documentTemplateOptions = (0,_DSWizardHelper.getDocumentTemplateOptionList)(this.props.templates,lang,moduleKey,subModuleKey,false,claimWizardDocType); // tarification case, needs extra filtering for template options
	if(moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION){documentTemplateOptions = (0,_DSWizardHelper.filterTemplatesForBroker)(documentTemplateOptions,this.props.brokersTeamWhiteList,brokerNumber,teamIndex,teamSubgroupId);}packageDSDocuments = (0,_DSWizardHelper.filterDocumentsByPackageId)(this.props.documents,oneDocument.packageId);attachIdResult = (0,_DSWizardFormControl.packageDocumentsAttachIdCursor)(packageDSDocuments,dynamicFieldIdCursor);packageDSDocuments = attachIdResult.packageDSDocuments;dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor;formInputs = (0,_DSWizardFormControl.synchronizePackageDSDocumentsInputsFromForm)(formInputs,packageDSDocuments,moduleKey,subModuleKey,DSDocumentOriginTypes);moduleKey = moduleKey || (0,_DSWizardHelper.getModuleKeyOfPackage)(_nestedProperty2['default'].get(this,"state.packageDSDocuments"));subModuleKey = subModuleKey || (0,_DSWizardHelper.getSubModuleKeyOfPackage)(_nestedProperty2['default'].get(this,"state.packageDSDocuments"));this.setState({packageDSDocuments:packageDSDocuments,moduleKey:moduleKey,documentTemplateOptions:documentTemplateOptions,formInputs:formInputs,dynamicFieldIdCursor:dynamicFieldIdCursor});case 32:case 'end':return context$2$0.stop();}},null,this);} /**
	     * Goto the next step. Execute an API call what start a process on the server to create the package on connective.
	     * @param {object} ev
	     */},{key:'initStep3',value:function initStep3(ev){var _props21,dispatch,UsersProcessFlag,DSDocumentOriginTypes,packageId,_state27,dynamicFieldIdCursor,formInputs,moduleKey,subModuleKey,stakeholders,signerAvailabilityOfTemplates,error,noLoader,resultOfApiCall,updatedStakeholders,stakeholderIdsToFetch,_iteratorNormalCompletion10,_didIteratorError10,_iteratorError10,_iterator10,_step10,oneStakeholder,packageDSDocuments,attachIdResult;return regeneratorRuntime.async(function initStep3$(context$2$0){var _this26=this;while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props21 = this.props;dispatch = _props21.dispatch;UsersProcessFlag = _props21.UsersProcessFlag;DSDocumentOriginTypes = _props21.DSDocumentOriginTypes;packageId = _nestedProperty2['default'].get(this,"state.packageId") || _nestedProperty2['default'].get(this,"props.packageId");_state27 = this.state;dynamicFieldIdCursor = _state27.dynamicFieldIdCursor;formInputs = _state27.formInputs;moduleKey = _state27.moduleKey;subModuleKey = _state27.subModuleKey;stakeholders = _state27.stakeholders;signerAvailabilityOfTemplates = _state27.signerAvailabilityOfTemplates;error = false;ev.preventDefault(); // args: {string}flagName, {string}referenceId, {numeric}checkpointCount
	context$2$0.next = 16;return regeneratorRuntime.awrap(dispatch((0,_stateActions.startUsersProcessFlagWatch)(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS,packageId,4)));case 16:context$2$0.next = 18;return regeneratorRuntime.awrap(dispatch((0,_stateActions.doUsersProcessFlagWatch)(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS,packageId)));case 18:this.setState({step:c.DSWIZARD_STEP_WAITING});noLoader = true;resultOfApiCall = undefined;updatedStakeholders = [].concat(_toConsumableArray(stakeholders));context$2$0.prev = 22;context$2$0.next = 25;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.executeFullDSDocumentWizardOnServer)(packageId,c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS,noLoader)));case 25:resultOfApiCall = context$2$0.sent;if(!resultOfApiCall){context$2$0.next = 50;break;}stakeholderIdsToFetch = [];_iteratorNormalCompletion10 = true;_didIteratorError10 = false;_iteratorError10 = undefined;context$2$0.prev = 31;for(_iterator10 = stakeholders[Symbol.iterator]();!(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done);_iteratorNormalCompletion10 = true) {oneStakeholder = _step10.value;stakeholderIdsToFetch.push({stakeholder:oneStakeholder._id});}context$2$0.next = 39;break;case 35:context$2$0.prev = 35;context$2$0.t0 = context$2$0['catch'](31);_didIteratorError10 = true;_iteratorError10 = context$2$0.t0;case 39:context$2$0.prev = 39;context$2$0.prev = 40;if(!_iteratorNormalCompletion10 && _iterator10['return']){_iterator10['return']();}case 42:context$2$0.prev = 42;if(!_didIteratorError10){context$2$0.next = 45;break;}throw _iteratorError10;case 45:return context$2$0.finish(42);case 46:return context$2$0.finish(39);case 47:context$2$0.next = 49;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSStakeholders)(stakeholderIdsToFetch)));case 49:updatedStakeholders = context$2$0.sent;case 50:context$2$0.next = 56;break;case 52:context$2$0.prev = 52;context$2$0.t1 = context$2$0['catch'](22);console.error(context$2$0.t1);error = context$2$0.t1;case 56: // stop watching the process
	// stop to check the progress
	dispatch((0,_stateActions.stopUsersProcessFlagWatch)(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS,packageId)); // reloaded package reset cursor
	dynamicFieldIdCursor = 1; // get documents from props to state
	packageDSDocuments = (0,_DSWizardHelper.filterDocumentsByPackageId)(this.props.documents,packageId);attachIdResult = (0,_DSWizardFormControl.packageDocumentsAttachIdCursor)(packageDSDocuments,dynamicFieldIdCursor,true);packageDSDocuments = attachIdResult.packageDSDocuments;dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor;formInputs = (0,_DSWizardFormControl.synchronizePackageDSDocumentsInputsFromForm)(formInputs,packageDSDocuments,moduleKey,subModuleKey,DSDocumentOriginTypes); // if there was a warning else just resolve the promise
	if(!(resultOfApiCall && resultOfApiCall.warnings && resultOfApiCall.warnings.length > 0 || error)){context$2$0.next = 66;break;}context$2$0.next = 66;return regeneratorRuntime.awrap((function callee$2$0(){var err;return regeneratorRuntime.async(function callee$2$0$(context$3$0){var _this25=this;while(1) switch(context$3$0.prev = context$3$0.next){case 0:err = error || resultOfApiCall.warnings;context$3$0.next = 3;return regeneratorRuntime.awrap(new Promise(function(resolvePopup){_this25.setState({isOpenAreYouSure:{title:_('thereWasAnAError'),message:_('thereWasAnErrorWhenCreatePackage'),message1:_nestedProperty2['default'].get(err,"error")?JSON.stringify(_nestedProperty2['default'].get(err,"error")) + JSON.stringify(_nestedProperty2['default'].get(err,"message")):_react2['default'].createElement('pre',null,err && err.errorCodes && _this25.renderErrorCodes(err.errorCodes),(0,_jsonBeautify2['default'])(err,null,2,80)),message2:_nestedProperty2['default'].get(err,"message") + (err.errorTranslationKey?_(err.errorTranslationKey):""),isErrorMessage:true,callBackCancel:function callBackCancel(){resolvePopup();},callBackOk:function callBackOk(){resolvePopup();}}});}));case 3:this.closeModal();throw err;case 5:case 'end':return context$3$0.stop();}},null,_this26);})());case 66: // display the waiting STEP
	this.setState({stakeholders:updatedStakeholders,dynamicFieldIdCursor:dynamicFieldIdCursor,formInputs:formInputs,packageDSDocuments:packageDSDocuments});return context$2$0.abrupt('return',resultOfApiCall);case 68:case 'end':return context$2$0.stop();}},null,this,[[22,52],[31,35,39,47],[40,,42,46]]);} /**
	     * This function will render the error codes from the server response of the API call what create the package on connective.
	     * @param {Array} codes
	     */},{key:'renderErrorCodes',value:function renderErrorCodes(codes){if(!codes || codes.length === 0){return "";}return _react2['default'].createElement('div',null,codes.map(function(oneCode,index){return _react2['default'].createElement('div',{key:index},_(oneCode));}));} /**
	     * Render second page of wizard
	     **/},{key:'renderDSWizardPopup2',value:function renderDSWizardPopup2(){var _this27=this;var _state28=this.state;var isValidTheForm=_state28.isValidTheForm;var packageDSDocuments=_state28.packageDSDocuments;var customModalTitle2=_state28.customModalTitle2;var customModalDescriptionStep2=_state28.customModalDescriptionStep2;var stakeholders=_state28.stakeholders;var formInputs=_state28.formInputs;var signerAvailabilityOfTemplates=_state28.signerAvailabilityOfTemplates;var DSDocumentOriginTypes=this.props.DSDocumentOriginTypes; // totalNumberOfSigners is require to validate PDF documents about the signature placeholder count.
	var totalNumberOfSigners=stakeholders.length;return _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalContent,key:"mifidStep2"},_react2['default'].createElement('span',{className:_documentsScss2['default'].title,key:"mifidStepTitle2"},customModalTitle2?customModalTitle2:_('DSWizardModalTitle2')),_react2['default'].createElement('form',{method:'post',onSubmit:function(ev){return ev.preventDefault();},className:_documentsScss2['default'].modalFormContent,key:"mifidStep2Form"},_react2['default'].createElement('div',{className:_documentsScss2['default'].message,key:"mifidStep2messageDescription"},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer,key:"mifidStep2messageDescriptionResendModalContainer"},_react2['default'].createElement('div',{className:_documentsScss2['default'].columnContainer,key:"DSWizardModalDescription2columnContainerKey"},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].titleLabel,_documentsScss2['default'].autoHeight),key:"DSWizardModalDescription2FormInputContainerKey"},_react2['default'].createElement('div',{className:_documentsScss2['default'].whitespacePre,key:"DSWizardModalDescription2WhitespacePreKey",dangerouslySetInnerHTML:{__html:customModalDescriptionStep2?customModalDescriptionStep2:_('DSWizardModalDescription2')}})),_react2['default'].createElement('div',{className:_documentsScss2['default'].oneRowItem,key:"DSWizardModalDescription2oneRowItemKey"},packageDSDocuments && packageDSDocuments.map(function(oneDocument){return _this27.renderDocumentFillAndPrintBlock(oneDocument);}))))),_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons,key:"mifidStep2documentsModalButtons"},_react2['default'].createElement('div',{onClick:function(){ // just reset triggers and states and close modal
	_this27.closeModal();},className:_documentsScss2['default'].cancel,key:"mifidStep2ButtonsCloseModal"},_("cancel")),_react2['default'].createElement('button',{type:'button',className:_documentsScss2['default'].greenButton + " enabled",onClick:function callee$2$0(e){var newFormInputs;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:this.startLoading();context$3$0.prev = 1;context$3$0.next = 4;return regeneratorRuntime.awrap(this.initStep1(formInputs));case 4:newFormInputs = context$3$0.sent;this.setState({step:c.DSWIZARD_STEP_1_COMPOSE_PACKAGE,formInputs:newFormInputs});context$3$0.next = 11;break;case 8:context$3$0.prev = 8;context$3$0.t0 = context$3$0['catch'](1);console.error(context$3$0.t0);case 11:this.stopLoading();case 12:case 'end':return context$3$0.stop();}},null,_this27,[[1,8]]);},key:"mifidStep2ButtonsBackToStep1"},_("back")),_react2['default'].createElement('button',{key:"mifidStep2ButtonsNextToStep2",type:'button',className:_documentsScss2['default'].greenButton + (!isValidTheForm.isValid?" disabled":" enabled"),disabled:!isValidTheForm.isValid,onClick:function(e){var documentsAreNotValidModalOpen=(0,_DSWizardHelper.getTheListOfInvalidDocuments)(packageDSDocuments,totalNumberOfSigners,DSDocumentOriginTypes);var resultOfUsage=(0,_DSWizardHelper.isUsedAllOfStakeholders)(packageDSDocuments,stakeholders,DSDocumentOriginTypes,signerAvailabilityOfTemplates);var isThisASignablePackage=(0,_DSWizardHelper.areThereSignableDocuments)(packageDSDocuments,DSDocumentOriginTypes);var stakeholderUsageMap=resultOfUsage.stakeholderUsageMap;var areNonUsedStakeholders=resultOfUsage.areNonUsedStakeholders; // check if there is an invalid document
	if(areNonUsedStakeholders && isThisASignablePackage){return _this27.setState({documentsAreNotValidModalOpen:[],areNonUsedStakeholders:areNonUsedStakeholders,stakeholderUsageMap:stakeholderUsageMap});}else {_this27.setState({documentsAreNotValidModalOpen:false,areNonUsedStakeholders:false,stakeholderUsageMap:{}});} // check if there is an invalid document
	if(documentsAreNotValidModalOpen && documentsAreNotValidModalOpen.length > 0){return _this27.setState({documentsAreNotValidModalOpen:documentsAreNotValidModalOpen});}return _this27.initStep3(e).then(function(){ // forward the wizard
	// let the user to see the fourth dot before leaving the waiting modal
	//setTimeout(() => {
	_this27.setState({step:c.DSWIZARD_STEP_3_BROKER_FILLING}); //}, 500)
	})['catch'](function(err){console.warn('error init step 3 ',err);});}},_("Next")))));} /**
	     * This function will navigate to package.
	     * @param {string} packageId
	     */},{key:'onClickDSDocInSamePackage',value:function onClickDSDocInSamePackage(packageId){var _this28=this;var dispatch=this.props.dispatch; // refresh the packages and documents before navigate to details.
	dispatch((0,_stateActions2.getDsDocsAndPackages)(false,false,null,null,true)).then(function(){_this28.closeModal();dispatch((0,_stateActions2.setAppModule)(c.DSDOCUMENTS));dispatch((0,_stateActions2.setDSDocumentsOpenedPackage)(packageId));dispatch((0,_stateActions2.setDSDocumentsSubModule)('detailedPackage'));return;});} /**
	     * The finisher dialog
	     */},{key:'renderDSWizardPopup3',value:function renderDSWizardPopup3(){var _this29=this;var _props22=this.props;var customModalTitle3=_props22.customModalTitle3;var customModalDescriptionStep3=_props22.customModalDescriptionStep3;var DSDocumentOriginTypes=_props22.DSDocumentOriginTypes;var createmail=_props22.createmail;var dispatch=_props22.dispatch;var isOffice=_props22.isOffice;var _state29=this.state;var packageDSDocuments=_state29.packageDSDocuments;var packageId=_state29.packageId;var moduleKey=_state29.moduleKey;var moduleOptions=_state29.moduleOptions;var selectedTicketRelatedOraDocuments=_state29.selectedTicketRelatedOraDocuments;var invitationEmailSent=_state29.invitationEmailSent;var  /* moduleKeyToSetForEmailer, */stakeholders=_state29.stakeholders;var formFiller=stakeholders.find(function(oneStakeholder){return oneStakeholder.roles.find(function(oneRole){return oneRole.type === 'formFiller' && oneRole.status === 'Available';});});var URLForSign=_nestedProperty2['default'].get(packageDSDocuments,"0.package.F2FSigningUrl");var URLForPreview=_nestedProperty2['default'].get(packageDSDocuments,"0.package.previewUrl");var areConnectiveDocuments=(0,_DSWizardHelper.areThereDocumentSentToConnective)(packageDSDocuments,DSDocumentOriginTypes);var packageInstance={};if(packageDSDocuments){packageInstance = _nestedProperty2['default'].get(packageDSDocuments,"0.package");}return _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalContent,key:"mifidStep3"},_react2['default'].createElement('span',{className:_documentsScss2['default'].title},customModalTitle3?customModalTitle3:_('DSWizardModalTitle3')),_react2['default'].createElement('form',{method:'post',onSubmit:function(ev){return ev.preventDefault();},className:_documentsScss2['default'].modalFormContent},_react2['default'].createElement('span',{className:_documentsScss2['default'].message},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].titleLabel),key:'step3ModalDescription2'},!areConnectiveDocuments?_react2['default'].createElement('div',{className:_documentsScss2['default'].whitespacePre},customModalDescriptionStep3?customModalDescriptionStep3:_('DSWizardModalDescription3NoDocsForSign')):_react2['default'].createElement('div',{className:_documentsScss2['default'].whitespacePre},customModalDescriptionStep3?customModalDescriptionStep3:_('DSWizardModalDescription3'))))),_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons},areConnectiveDocuments && createmail && !invitationEmailSent && _react2['default'].createElement(_emailSenderEmailButton2['default'],{onInit:function(){var attachments=_this29.state.emailAttachmentsTicketRelatedOraDocuments;if(attachments && attachments.length){var files=attachments.map(function(oneDoc){return {name:oneDoc.oracleDocumentType,date:"-",id:oneDoc.oracleDocumentId,typeDocument:oneDoc.oracleDocumentType};});dispatch((0,_stateActions.setEmailSenderExternalAttachments)(files));}return;},onSentLate:function callee$2$0(responses){var i,emailId,toEmailAddress,_loop3,j;return regeneratorRuntime.async(function callee$2$0$(context$3$0){var _this30=this;while(1) switch(context$3$0.prev = context$3$0.next){case 0:context$3$0.prev = 0;if(!(!responses || responses.length === 0)){context$3$0.next = 3;break;}return context$3$0.abrupt('return');case 3:i = 0;case 4:if(!(i < responses.length)){context$3$0.next = 23;break;}emailId = _nestedProperty2['default'].get(responses,i + ".emailRecord._id");toEmailAddress = _nestedProperty2['default'].get(responses,i + ".emailRecord.toEmailAddress");if(emailId){context$3$0.next = 9;break;}return context$3$0.abrupt('continue',20);case 9:_loop3 = function callee$3$0(j){return regeneratorRuntime.async(function callee$3$0$(context$4$0){while(1) switch(context$4$0.prev = context$4$0.next){case 0:if(!(toEmailAddress && toEmailAddress.length > 0 && toEmailAddress.some(function(email){return String(email).toLowerCase() === String(stakeholders[j].email).toLowerCase();}))){context$4$0.next = 5;break;}context$4$0.next = 3;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.upsertDSPackageEmailStatus)(packageId,emailId,{isInvitation:true,stakeholderId:stakeholders[j]._id} /* --> ?? mailOptions*/)));case 3:context$4$0.next = 5;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.updateDSStakeholder)({stakeholderId:stakeholders[j]._id,isInvited:true})));case 5:case 'end':return context$4$0.stop();}},null,_this30);};j = 0;case 11:if(!(j < stakeholders.length)){context$3$0.next = 17;break;}context$3$0.next = 14;return regeneratorRuntime.awrap(_loop3(j));case 14:j++;context$3$0.next = 11;break;case 17:context$3$0.next = 19;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getOneDsPackageById)(packageId)));case 19:packageInstance = context$3$0.sent;case 20:i++;context$3$0.next = 4;break;case 23:context$3$0.next = 29;break;case 25:context$3$0.prev = 25;context$3$0.t0 = context$3$0['catch'](0);console.error(context$3$0.t0);throw context$3$0.t0;case 29:this.setState({invitationEmailSent:true},function(){_this30.closeModal();});case 30:case 'end':return context$3$0.stop();}},null,_this29,[[0,25]]);},moduleKeyToSet:(0,_DSWizardHelper.getEmailerModuleKeyByWizardModuleKey)(moduleKey) /* moduleKeyToSetForEmailer */,moduleOptions:_extends({},moduleOptions,{dsPackage:packageInstance,brokerNumber:_nestedProperty2['default'].get(packageInstance,"brokerNumber"),brokerEmailAddress:_nestedProperty2['default'].get(packageInstance,"brokerEmailAddress"),stakeholders:stakeholders.filter(function(oneStake){return oneStake.signerType !== "BROKER";}),autoSelectTemplate:true,usePlaceholdersForClientVariables:true, // overwrite client email addresses, for signer emailaddress-es
	clientEmails:stakeholders.filter(function(oneStake){return oneStake.signerType !== "BROKER";}).map(function(oneHolder){return {referenceId:oneHolder._id,value:oneHolder.email,lang:oneHolder.language,isPermanentSelected:true,isCC:false,label:oneHolder.firstName + " " + oneHolder.lastName};})}),getDSStakeholders:function callee$2$0(stakeholderIdArray){return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:context$3$0.next = 2;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.getDSStakeholders)(stakeholderIdArray)));case 2:return context$3$0.abrupt('return',context$3$0.sent);case 3:case 'end':return context$3$0.stop();}},null,_this29);},customButtonLabel:_('customizeInvitationEmail'),customClassName:_documentsScss2['default'].greenButton + " enabled",key:"customizeInvitationRenderEmailSenderButtonKey",isWhiteIcon:true,modalId:c.EMAILER_MODAL_ID_DSWIZARD_STEP_3,hideCC:isOffice?false:true,isCreatable:isOffice?true:false,multiLanguage:true,serialSending:true,forceIsMulti:true}),areConnectiveDocuments && _react2['default'].createElement('button',{type:'button',className:_documentsScss2['default'].greenButton + " enabled",onClick:function(e){ // open direct signing and close the modal
	if(formFiller){window.open(formFiller.privateLink,'_blank','noopener,noreferrer');}else {window.open(URLForSign,'_blank','noopener,noreferrer');}_this29.closeModal();dispatch((0,_stateActions.removeUsersProcessFlagWatch)(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS,packageId)); //if the cancel command comes from PREM -- after creating a mandate contract, should remove it from state
	if(_this29.state.isPrem){dispatch((0,_stateActions2.setClientSubModule)('contracts',{contractId:_this29.state.contractId},null));}},key:"signNowButtonKey"},_('signNow')),!areConnectiveDocuments && _react2['default'].createElement('button',{type:'button',className:_documentsScss2['default'].greenButton + " enabled",onClick:function(e){_this29.closeModal();dispatch((0,_stateActions.removeUsersProcessFlagWatch)(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS,packageId)); //if the cancel command comes from PREM -- after creating a mandate contract, should remove it from state
	if(_this29.state.isPrem){dispatch((0,_stateActions2.setClientSubModule)('contracts',{contractId:_this29.state.contractId},null));}},key:"finishWizardButtonKey"},_("ok")))));} /**
	     * This step can be used in any case, when there is a waiting.
	     * @returns
	     */},{key:'renderDSWizardPopupWait',value:function renderDSWizardPopupWait(){var UsersProcessFlag=this.props.UsersProcessFlag;var packageId=this.state.packageId;var textKey=_nestedProperty2['default'].get(UsersProcessFlag,packageId + '.record.customData') || "usersProcessStatus_initialize";var status=_nestedProperty2['default'].get(UsersProcessFlag,packageId + '.record.status') * 1;var checkpointCount=_nestedProperty2['default'].get(UsersProcessFlag,packageId + '.checkpointCount') * 1;var dotClassesList=[]; // iterate steps to setup the class list for step indicator dots
	for(var _i=0;_i < checkpointCount;_i++) {dotClassesList[_i] = [_documentsScss2['default'].progressDot]; // step in progress must be gray
	if(status == _i){dotClassesList[_i].push(_documentsScss2['default'].progressDotInProgress);} // step completed must be green
	if(status > _i){dotClassesList[_i].push(_documentsScss2['default'].progressDotFilled);}} //init dots array To Render Dots And Lines also
	var dotAndLinesArray=[].concat(_toConsumableArray(Array(checkpointCount * 2 - 1).keys()));return _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalContent,key:"mifidStepWait"},_react2['default'].createElement('span',{className:_documentsScss2['default'].title},_('DSWizardModalTitleWait')),_react2['default'].createElement('form',{method:'post',onSubmit:function(ev){return ev.preventDefault();},className:_documentsScss2['default'].modalFormContent},_react2['default'].createElement('span',{className:_documentsScss2['default'].message,key:'step3ModalSpanMessage'},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer,key:'step3ModalresendModalContainer'},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].titleLabel),key:'step3ModalDescription1'},_react2['default'].createElement('div',{className:_documentsScss2['default'].progress},_react2['default'].createElement('div',{className:_documentsScss2['default'].progressDotsContainer,key:"progressDotsContainerKey"},dotAndLinesArray.map(function(elementNumber){if(!(elementNumber * 1 % 2)){return _react2['default'].createElement('div',{className:(0,_classnames2['default'])(dotClassesList[elementNumber * 1 / 2])},elementNumber * 1 / 2);}return _react2['default'].createElement('div',{className:_documentsScss2['default'].progressLine});})),_react2['default'].createElement('div',{className:_documentsScss2['default'].progressText,key:"progressDotsProgressTextKey"},_(textKey))))))));} /**
	     * Any case of modal close must call this function to reset states and call the callback function
	     */},{key:'closeModal',value:function closeModal(){var _props23=this.props;var dispatch=_props23.dispatch;var moduleKey=_props23.moduleKey;var _props24=this.props;var callBackOnClose=_props24.callBackOnClose;var callBackOnCloseFromClaimWizard=_props24.callBackOnCloseFromClaimWizard;var _state30=this.state;var clientId=_state30.clientId;var tarificationId=_state30.tarificationId;var packageId=_state30.packageId;this.setState({step:c.DSWIZARD_STEP_1_COMPOSE_PACKAGE});this.setState({isValidTheForm:{isValid:true}});dispatch((0,_stateActions.setDSWizard)(false));if(this.state.isPrem){this.setState({isPrem:false});}dispatch((0,_stateActions2.setClientCreateContractState)(''));if(moduleKey === c.DS_MODULE_CLAIM_WIZARD){callBackOnCloseFromClaimWizard(packageId);} //anyway must called to reset external trigger also for modal opening
	callBackOnClose(clientId,tarificationId);} /**
	     * Content of filling the document template error
	     * @param {*} fillTemplateErrorsModalOpen
	     * @returns
	     */},{key:'fillTemplateErrorsRender',value:function fillTemplateErrorsRender(fillTemplateErrorsModalOpen){var _this31=this;return _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalContent,key:"fillTemplateErrorsModalContentDivKey"},_react2['default'].createElement('span',{className:_documentsScss2['default'].title},_('fillTemplateErrorsModalTitle')),_react2['default'].createElement('span',{className:_documentsScss2['default'].message},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].titleLabel)},_('fillTemplateErrorsModalDescription')),fillTemplateErrorsModalOpen && _react2['default'].createElement('div',null,fillTemplateErrorsModalOpen.map(function(item,index){return _react2['default'].createElement('div',{key:"index" + index},item);})))),_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons},_react2['default'].createElement('div',{onClick:function(){_this31.setState({fillTemplateErrorsModalOpen:false});},className:_documentsScss2['default'].greenButton + " enabled"},_("ok"))));} /**
	     * Content of filling the document template error
	     * @param {*} printNotValidModalOpen
	     * @returns
	     */},{key:'printingAbortErrorsRender',value:function printingAbortErrorsRender(printNotValidModalOpen){var _this32=this;return _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalContent,key:"printingAbortErrorsModalRenderKey"},_react2['default'].createElement('span',{className:_documentsScss2['default'].title},_('printNotValidModalTitle')),_react2['default'].createElement('span',{className:_documentsScss2['default'].message},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].titleLabel)},_('printNotValidModalDescription')),printNotValidModalOpen && _react2['default'].createElement('div',null,printNotValidModalOpen.map(function(item,index){return _react2['default'].createElement('div',{key:"index" + index},item);})))),_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons},_react2['default'].createElement('div',{onClick:function(){_this32.setState({printNotValidModalOpen:false});},className:_documentsScss2['default'].greenButton + " enabled"},_("ok"))));} /**
	     * Used to display errors when copying files from template attachments to local uploads 
	     * @param {*} templateAttachmentDocumentsError 
	     * @returns 
	     */},{key:'templateAttachmentDocumentsErrorRender',value:function templateAttachmentDocumentsErrorRender(templateAttachmentDocumentsError){var _this33=this;return _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalContent,key:"printingAbortErrorsModalRenderKey"},_react2['default'].createElement('span',{className:_documentsScss2['default'].title},_('templateAttachmentDocumentsErrorModalTitle')),_react2['default'].createElement('span',{className:_documentsScss2['default'].message},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].titleLabel)},_('templateAttachmentDocumentsErrorDescription')),templateAttachmentDocumentsError && templateAttachmentDocumentsError.length > 0 && _react2['default'].createElement('div',null,templateAttachmentDocumentsError.map(function(item,index){return _react2['default'].createElement('div',{key:"index" + index},_react2['default'].createElement('div',{className:_documentsScss2['default'].message},_react2['default'].createElement('span',null,_('errorFileName'),' : ',item.originalname),_react2['default'].createElement('span',null,_('errorMessage'),' : ',item.error)));})))),_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons},_react2['default'].createElement('div',{onClick:function(){_this33.setState({templateAttachmentDocumentsError:false});},className:_documentsScss2['default'].greenButton + " enabled"},_("ok"))));} /**
	     * Content of invalid documents fills error modal
	     * @param {*} documentsAreNotValidModalOpen - list of documents with invalid fillings
	     * @returns React node
	     */},{key:'warningModalDocumentsAreNotValidRender',value:function warningModalDocumentsAreNotValidRender(documentsAreNotValidModalOpen){var _this34=this;var DSDocumentOriginTypes=this.props.DSDocumentOriginTypes;var _state31=this.state;var areNonUsedStakeholders=_state31.areNonUsedStakeholders;var stakeholderUsageMap=_state31.stakeholderUsageMap;return _react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalContent,key:"warningDocumentsAreNotValidRenderContentKey"},_react2['default'].createElement('span',{className:_documentsScss2['default'].title},_('documentsAreNotValidModalTitle')),_react2['default'].createElement('span',{className:_documentsScss2['default'].message},_react2['default'].createElement('div',{className:_documentsScss2['default'].resendModalContainer},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_documentsScss2['default'].formInputContainer,_documentsScss2['default'].titleLabel)},_('documentsAreNotValidModalDescription')),documentsAreNotValidModalOpen && documentsAreNotValidModalOpen.length > 0 && _react2['default'].createElement('div',null,documentsAreNotValidModalOpen.map(function(dsDoc,index){return _react2['default'].createElement('div',{key:"index" + index},dsDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED && dsDoc.fileName + ": " + _("documentTemplateNotFilledCorrectly"),dsDoc.origin !== DSDocumentOriginTypes.DS_ORIGIN_GENERATED && dsDoc.fileName + ": " + _("documentMustHavePlacedSignerPlaceholders"),dsDoc.errorMessages && _react2['default'].createElement('div',{className:_documentsScss2['default'].marginLeft1em},dsDoc.errorMessages.map(function(message,index){return _react2['default'].createElement('div',null,message);})));})),documentsAreNotValidModalOpen && areNonUsedStakeholders && _react2['default'].createElement('div',null,_("notAllStakeholdersAreNotUsed"),_react2['default'].createElement('div',{className:_documentsScss2['default'].marginLeft1em},Object.keys(stakeholderUsageMap).map(function(oneKey,index){var holder=stakeholderUsageMap[oneKey];return holder?_react2['default'].createElement('div',{key:"index" + index},_react2['default'].createElement('div',null,holder.firstName + " " + holder.lastName + " [" + holder.email + "] ")):null;}))))),_react2['default'].createElement('div',{className:_documentsScss2['default'].documentsModalButtons},_react2['default'].createElement('div',{onClick:function(){_this34.setState({documentsAreNotValidModalOpen:false});},className:_documentsScss2['default'].greenButton + " enabled"},_("ok"))));} /**
	     * This function will effect the attaching of document to the attachment list.
	     * @param {array} selected0 - list of claim documents
	     * @param {array} selected - list of contract documents
	     * @param {array} selected2 - list of client documents
	     * @param {array} selected3 - list of tarification documents
	     */},{key:'handleConfirmSelectedAttachments',value:function handleConfirmSelectedAttachments(){var selected0=arguments.length <= 0 || arguments[0] === undefined?[]:arguments[0];var selected1=arguments.length <= 1 || arguments[1] === undefined?[]:arguments[1];var selected2=arguments.length <= 2 || arguments[2] === undefined?[]:arguments[2];var selected3=arguments.length <= 3 || arguments[3] === undefined?[]:arguments[3];var selected4=arguments.length <= 4 || arguments[4] === undefined?[]:arguments[4];var selected5=arguments.length <= 5 || arguments[5] === undefined?[]:arguments[5];var _props25,DSDocumentOriginTypes,stakeholders,claimWizardDocType,_state32,packageDSDocuments,formInputs,isValidTheForm,dynamicFieldIdCursor,moduleKey,subModuleKey,languageOptions,documentTemplateOptions,claimId,claimNumber,contractId,tarificationId,tarificationNumber,isPrem,signerAvailabilityOfTemplates,selectedClaimRelatedOraDocuments,selectedContractRelatedOraDocuments,selectedTarificationRelatedOraDocuments,selectedClientRelatedOraDocuments,selectedTicketRelatedOraDocuments,selectedOracleDocuments,cursorsListToRemove,_iteratorNormalCompletion11,_didIteratorError11,_iteratorError11,_loop4,_iterator11,_step11,_iteratorNormalCompletion12,_didIteratorError12,_iteratorError12,_iterator12,_step12,oneCursor,clientLanguage,team,teamName,teamSubgroup,_iteratorNormalCompletion13,_didIteratorError13,_iteratorError13,_iterator13,_step13,oneOraDocument,result,addSignersButtonFlags,isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder;return regeneratorRuntime.async(function handleConfirmSelectedAttachments$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props25 = this.props;DSDocumentOriginTypes = _props25.DSDocumentOriginTypes;stakeholders = _props25.stakeholders;claimWizardDocType = _props25.claimWizardDocType;_state32 = this.state;packageDSDocuments = _state32.packageDSDocuments;formInputs = _state32.formInputs;isValidTheForm = _state32.isValidTheForm;dynamicFieldIdCursor = _state32.dynamicFieldIdCursor;moduleKey = _state32.moduleKey;subModuleKey = _state32.subModuleKey;languageOptions = _state32.languageOptions;documentTemplateOptions = _state32.documentTemplateOptions;claimId = _state32.claimId;claimNumber = _state32.claimNumber;contractId = _state32.contractId;tarificationId = _state32.tarificationId;tarificationNumber = _state32.tarificationNumber;isPrem = _state32.isPrem;signerAvailabilityOfTemplates = _state32.signerAvailabilityOfTemplates;selectedClaimRelatedOraDocuments = (0,_DSWizardHelper.prepareOracleDocumentsFromUploaderSelectionDocList)(selected0,c.CLAIM_DOCUMENTS_TAB,claimWizardDocType);selectedContractRelatedOraDocuments = (0,_DSWizardHelper.prepareOracleDocumentsFromUploaderSelectionDocList)(selected1,c.CONTRACT_DOCUMENTS_TAB,claimWizardDocType);selectedTarificationRelatedOraDocuments = (0,_DSWizardHelper.prepareOracleDocumentsFromUploaderSelectionDocList)(selected3,c.TARIFICATION_DOCUMENTS_TAB,claimWizardDocType);selectedClientRelatedOraDocuments = (0,_DSWizardHelper.prepareOracleDocumentsFromUploaderSelectionDocList)(selected2,c.PROFILE_DOCUMENTS_TAB,claimWizardDocType);selectedTicketRelatedOraDocuments = (0,_DSWizardHelper.prepareOracleDocumentsFromUploaderSelectionDocList)(selected4,c.TICKET_DOCUMENTS_TAB,claimWizardDocType);selectedOracleDocuments = selectedClaimRelatedOraDocuments.concat(selectedContractRelatedOraDocuments,selectedTarificationRelatedOraDocuments,selectedClientRelatedOraDocuments,selectedTicketRelatedOraDocuments);cursorsListToRemove = [];_iteratorNormalCompletion11 = true;_didIteratorError11 = false;_iteratorError11 = undefined;context$2$0.prev = 30;_loop4 = function(){var onePackageDocument=_step11.value; // if the origin is ORACLE
	if(onePackageDocument.oracleDocumentId){ // document is it on the list of selected documents from uploader table?
	var keepDocument=selectedOracleDocuments.some(function(selectedDocument){return selectedDocument.id === onePackageDocument.oracleDocumentId;}); // not in the selection list but have oracle id clear it
	if(!keepDocument){cursorsListToRemove.push(onePackageDocument.cursor);}}}; // remove oracle documents that have been unselected
	for(_iterator11 = packageDSDocuments[Symbol.iterator]();!(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done);_iteratorNormalCompletion11 = true) {_loop4();} // remove the collected ID-s by unselected documents
	// do like this because not healthy to modify the array what is iterated in a loop
	context$2$0.next = 39;break;case 35:context$2$0.prev = 35;context$2$0.t0 = context$2$0['catch'](30);_didIteratorError11 = true;_iteratorError11 = context$2$0.t0;case 39:context$2$0.prev = 39;context$2$0.prev = 40;if(!_iteratorNormalCompletion11 && _iterator11['return']){_iterator11['return']();}case 42:context$2$0.prev = 42;if(!_didIteratorError11){context$2$0.next = 45;break;}throw _iteratorError11;case 45:return context$2$0.finish(42);case 46:return context$2$0.finish(39);case 47:if(!(cursorsListToRemove && cursorsListToRemove.length > 0)){context$2$0.next = 67;break;}_iteratorNormalCompletion12 = true;_didIteratorError12 = false;_iteratorError12 = undefined;context$2$0.prev = 51;for(_iterator12 = cursorsListToRemove[Symbol.iterator]();!(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done);_iteratorNormalCompletion12 = true) {oneCursor = _step12.value; // filter document list
	packageDSDocuments = (0,_DSWizardHelper.removeDSDocumentFromThePackage)(oneCursor,packageDSDocuments); // filter input list
	formInputs = (0,_DSWizardFormControl.removeFormInputByCursor)(oneCursor,formInputs);}context$2$0.next = 59;break;case 55:context$2$0.prev = 55;context$2$0.t1 = context$2$0['catch'](51);_didIteratorError12 = true;_iteratorError12 = context$2$0.t1;case 59:context$2$0.prev = 59;context$2$0.prev = 60;if(!_iteratorNormalCompletion12 && _iterator12['return']){_iterator12['return']();}case 62:context$2$0.prev = 62;if(!_didIteratorError12){context$2$0.next = 65;break;}throw _iteratorError12;case 65:return context$2$0.finish(62);case 66:return context$2$0.finish(59);case 67:clientLanguage = _nestedProperty2['default'].get(formInputs,"clientLanguage.value");team = _nestedProperty2['default'].get(formInputs,"team.value");teamName = _nestedProperty2['default'].get(formInputs,"teamName.value");teamSubgroup = _nestedProperty2['default'].get(formInputs,"teamSubgroup.value");_iteratorNormalCompletion13 = true;_didIteratorError13 = false;_iteratorError13 = undefined;context$2$0.prev = 74;_iterator13 = selectedOracleDocuments[Symbol.iterator]();case 76:if(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done){context$2$0.next = 88;break;}oneOraDocument = _step13.value;if((0,_DSWizardHelper.oraDocumentAlreadyInList)(oneOraDocument,packageDSDocuments)){context$2$0.next = 85;break;}context$2$0.next = 81;return regeneratorRuntime.awrap(this.createDSDocumentForPackage(packageDSDocuments,clientLanguage,{team:team,teamName:teamName,teamSubgroup:teamSubgroup},dynamicFieldIdCursor,languageOptions,documentTemplateOptions,{contractId:contractId,tarificationId:tarificationId,tarificationNumber:tarificationNumber,claimId:claimId,claimNumber:claimNumber,moduleKey:moduleKey,subModuleKey:subModuleKey,isPrem:isPrem},null,oneOraDocument));case 81:result = context$2$0.sent;formInputs = _extends({},formInputs,result.documentFormInputs);packageDSDocuments = result.packageDSDocuments;dynamicFieldIdCursor = result.dynamicFieldIdCursor;case 85:_iteratorNormalCompletion13 = true;context$2$0.next = 76;break;case 88:context$2$0.next = 94;break;case 90:context$2$0.prev = 90;context$2$0.t2 = context$2$0['catch'](74);_didIteratorError13 = true;_iteratorError13 = context$2$0.t2;case 94:context$2$0.prev = 94;context$2$0.prev = 95;if(!_iteratorNormalCompletion13 && _iterator13['return']){_iterator13['return']();}case 97:context$2$0.prev = 97;if(!_didIteratorError13){context$2$0.next = 100;break;}throw _iteratorError13;case 100:return context$2$0.finish(97);case 101:return context$2$0.finish(94);case 102:formInputs = this.onUpdateFormInputs(formInputs,packageDSDocuments,stakeholders,moduleKey,subModuleKey);formInputs = (0,_DSWizardFormControl.formInputsValidation)(formInputs);isValidTheForm = (0,_DSWizardFormControl.validateTheForm)(formInputs,packageDSDocuments,DSDocumentOriginTypes,true); // ++++++++++++ start handle enabled signers list ++++++++++++++
	addSignersButtonFlags = (0,_DSWizardHelper.getSignerAdderButtonsFlags)(packageDSDocuments,DSDocumentOriginTypes,isPrem,signerAvailabilityOfTemplates);isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder;isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder;isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder; // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
	// those properties, so don't do that
	//---------------- end handle enabled signers list
	this.setState({packageDSDocuments:packageDSDocuments,formInputs:formInputs,isValidTheForm:isValidTheForm,dynamicFieldIdCursor:dynamicFieldIdCursor,selectedClaimRelatedOraDocuments:selectedClaimRelatedOraDocuments,selectedContractRelatedOraDocuments:selectedContractRelatedOraDocuments,selectedTarificationRelatedOraDocuments:selectedTarificationRelatedOraDocuments,selectedClientRelatedOraDocuments:selectedClientRelatedOraDocuments,selectedTicketRelatedOraDocuments:selectedTicketRelatedOraDocuments,isItExistFirstSignerPlaceholder:isItExistFirstSignerPlaceholder,isItExistSecondSignerPlaceholder:isItExistSecondSignerPlaceholder,isItExistBrokerSignerPlaceholder:isItExistBrokerSignerPlaceholder});case 110:case 'end':return context$2$0.stop();}},null,this,[[30,35,39,47],[40,,42,46],[51,55,59,67],[60,,62,66],[74,90,94,102],[95,,97,101]]);} /**
	     * Takes the selected documents from the attachment modal and decides if there are changes that might affect a previous selection
	     * @param {*} selectedClaimDocuments
	     * @param {*} selectedContractDocuments
	     * @param {*} selectedClientDocuments
	     * @param {*} selectedTarificationDocuments
	     * @returns boolean
	     */},{key:'checkForOracleDocumentsChanges',value:function checkForOracleDocumentsChanges(){var selectedClaimDocuments=arguments.length <= 0 || arguments[0] === undefined?[]:arguments[0];var selectedContractDocuments=arguments.length <= 1 || arguments[1] === undefined?[]:arguments[1];var selectedClientDocuments=arguments.length <= 2 || arguments[2] === undefined?[]:arguments[2];var selectedTarificationDocuments=arguments.length <= 3 || arguments[3] === undefined?[]:arguments[3];var selectedTicketDocuments=arguments.length <= 4 || arguments[4] === undefined?[]:arguments[4];var _state33=this.state;var selectedClaimRelatedOraDocuments=_state33.selectedClaimRelatedOraDocuments;var selectedContractRelatedOraDocuments=_state33.selectedContractRelatedOraDocuments;var selectedTarificationRelatedOraDocuments=_state33.selectedTarificationRelatedOraDocuments;var selectedClientRelatedOraDocuments=_state33.selectedClientRelatedOraDocuments;var selectedTicketRelatedOraDocuments=_state33.selectedTicketRelatedOraDocuments;var hasChanges=true;if((!selectedClaimRelatedOraDocuments || selectedClaimRelatedOraDocuments.length === 0 || selectedClaimRelatedOraDocuments.length === selectedClaimDocuments.length && selectedClaimRelatedOraDocuments.every(function(oneDoc){return selectedClaimDocuments.some(function(oneSelectedDoc){return oneSelectedDoc.id === oneDoc.id;});})) && (!selectedContractRelatedOraDocuments || selectedContractRelatedOraDocuments.length === 0 || selectedContractRelatedOraDocuments.length === selectedContractDocuments.length && selectedContractRelatedOraDocuments.every(function(oneDoc){return selectedContractDocuments.some(function(oneSelectedDoc){return oneSelectedDoc.id === oneDoc.id;});})) && (!selectedTarificationRelatedOraDocuments || selectedTarificationRelatedOraDocuments.length === 0 || selectedTarificationRelatedOraDocuments.length === selectedTarificationDocuments.length && selectedTarificationRelatedOraDocuments.every(function(oneDoc){return selectedTarificationDocuments.some(function(oneSelectedDoc){return oneSelectedDoc.id === oneDoc.id;});})) && (!selectedClientRelatedOraDocuments || selectedClientRelatedOraDocuments.length === 0 || selectedClientRelatedOraDocuments.length === selectedClientDocuments.length && selectedClientRelatedOraDocuments.every(function(oneDoc){return selectedClientDocuments.some(function(oneSelectedDoc){return oneSelectedDoc.id === oneDoc.id;});})) && (!selectedTicketRelatedOraDocuments || selectedTicketRelatedOraDocuments.length === 0 || selectedTicketRelatedOraDocuments.length === selectedTicketDocuments.length && selectedTicketRelatedOraDocuments.every(function(oneDoc){return selectedTicketDocuments.some(function(oneSelectedDoc){return oneSelectedDoc.oracleDocumentId === oneDoc.oracleDocumentId;});}))){hasChanges = false;}return hasChanges;} /**
	    * this will open the emailAttachments modal which will serve in this case to select existing documents to send to oracle for signing
	    */},{key:'openOracleDocumentsModal',value:function openOracleDocumentsModal(){var dispatch=this.props.dispatch;dispatch((0,_stateActions2.showEmailSenderAttachmentModal)("dsDocumentsSelectionModal",_("selectDocuments"),_("pleaseSelect"),"select",null));} /**
	     * Open warning modal
	     * @param {*} isThereXSSFiltered
	     * @param {*} suspectValues
	     */},{key:'openWarningModalForXssIssue',value:function openWarningModalForXssIssue(isThereXSSFiltered,suspectValues){return regeneratorRuntime.async(function openWarningModalForXssIssue$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:return context$2$0.abrupt('return',this.setState({warningModalOpen:isThereXSSFiltered?suspectValues:false}));case 1:case 'end':return context$2$0.stop();}},null,this);} /**
	     * Get Actual Documents From Store from DSDocuments.items path
	     */},{key:'getActualDocumentsFromStore',value:function getActualDocumentsFromStore(){return this.props?this.props.documents:null;} /**
	     * Set the actual package documents in state
	     * @param {*} packageDSDocuments
	     */},{key:'setPackageDocuments',value:function setPackageDocuments(packageDSDocuments){var _state34,formInputs,moduleKey,subModuleKey,DSDocumentOriginTypes;return regeneratorRuntime.async(function setPackageDocuments$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_state34 = this.state;formInputs = _state34.formInputs;moduleKey = _state34.moduleKey;subModuleKey = _state34.subModuleKey;DSDocumentOriginTypes = this.props.DSDocumentOriginTypes;formInputs = (0,_DSWizardFormControl.synchronizePackageDSDocumentsInputsFromForm)(formInputs,packageDSDocuments,moduleKey,subModuleKey,DSDocumentOriginTypes);return context$2$0.abrupt('return',this.setState({packageDSDocuments:packageDSDocuments,formInputs:formInputs}));case 7:case 'end':return context$2$0.stop();}},null,this);}},{key:'render',value:function render(){var _this35=this;var _props26=this.props;var DSWizardOpened=_props26.DSWizardOpened;var dispatch=_props26.dispatch;var DSDocumentOriginTypes=_props26.DSDocumentOriginTypes;var moduleOptions=_props26.moduleOptions;var moduleKey=_props26.moduleKey;var ticketDocuments=_props26.ticketDocuments;var subModuleKey=_props26.subModuleKey;var isOffice=_props26.isOffice;var _state35=this.state;var isOpenIntervalInfo=_state35.isOpenIntervalInfo;var isOpenTicketIntervalInfo=_state35.isOpenTicketIntervalInfo;var step=_state35.step;var isLoaded=_state35.isLoaded;var isOpenDocumentToFill=_state35.isOpenDocumentToFill;var isOpenDocumentForPlaceholders=_state35.isOpenDocumentForPlaceholders;var warningModalOpen=_state35.warningModalOpen;var isOpenAreYouSure=_state35.isOpenAreYouSure;var fillTemplateErrorsModalOpen=_state35.fillTemplateErrorsModalOpen;var documentsAreNotValidModalOpen=_state35.documentsAreNotValidModalOpen;var printNotValidModalOpen=_state35.printNotValidModalOpen;var stakeholders=_state35.stakeholders;var templateAttachmentDocumentsError=_state35.templateAttachmentDocumentsError;var dynamicFieldIdCursor=this.state.dynamicFieldIdCursor;var intervalInfoTitle='';var intervalInfoDescription='';var openIntervalInfoModal=false;if(isOpenIntervalInfo){intervalInfoTitle = _('IntervalInfoModalTitle');intervalInfoDescription = _('IntervalInfoModalDescription');openIntervalInfoModal = Boolean(isOpenIntervalInfo);}else if(isOpenTicketIntervalInfo){intervalInfoTitle = _('IntervalTicketInfoModalTitle');intervalInfoDescription = _('IntervalTicketInfoModalDescription');openIntervalInfoModal = Boolean(isOpenTicketIntervalInfo);}return _react2['default'].createElement('div',{key:'rootComponentOfDsWizardRender'},_react2['default'].createElement(_reactModal2['default'],{isOpen:Boolean(DSWizardOpened),style:_documentsHelpers.customModalStyles,contentLabel:"",key:"DSWizardModal"},(!step || step === c.DSWIZARD_STEP_1_COMPOSE_PACKAGE) && this.renderDSWizardPopup(),step === c.DSWIZARD_STEP_2_FILL_DOCUMENTS && this.renderDSWizardPopup2(),step === c.DSWIZARD_STEP_3_BROKER_FILLING && this.renderDSWizardPopup3(),step === c.DSWIZARD_STEP_WAITING && this.renderDSWizardPopupWait()),_react2['default'].createElement(_IntervalInfoPopup2['default'],{isOpen:openIntervalInfoModal,style:_documentsHelpers.customModalStyles,contentLabel:"",didClose:function(){_this35.setState({isOpenIntervalInfo:false,isOpenTicketIntervalInfo:false});},key:"IntervalInfoPopup",modalTitle:intervalInfoTitle,modalDescription:intervalInfoDescription}),_react2['default'].createElement(_OpenDocumentToFillModal2['default'],{isOpen:Boolean(isOpenDocumentToFill),style:_documentsHelpers.customModalStylesForFillForm,contentLabel:"",dataForEditDocument:isOpenDocumentToFill,stakeholders:stakeholders,packageDSDocuments:this.state.packageDSDocuments,lang:this.props.lang,packageId:_nestedProperty2['default'].get(this,"state.packageId") || _nestedProperty2['default'].get(this,"props.packageId"),showWarningXss:function(isThereXSSFiltered,suspectValues){return _this35.openWarningModalForXssIssue(isThereXSSFiltered,suspectValues);},didClose:function(){_this35.setState({isOpenDocumentToFill:false}); //this.setState({isLoaded: true})
	_this35.stopLoading();dispatch((0,_stateActions2.disableBackgroundProcesses)(false));},onCancel:function(){},onSave:function callee$2$0(oneDocumentUpdatableProps){var updatedDocument,packageId,docsFromProps,packageDSDocuments,attachIdResult,errorInstance;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:context$3$0.next = 2;return regeneratorRuntime.awrap(dispatch((0,_stateActions2.upsertDSDocumentAndFetchAllData)(oneDocumentUpdatableProps)));case 2:updatedDocument = context$3$0.sent;dynamicFieldIdCursor = 1;packageId = _nestedProperty2['default'].get(this,"state.packageId") || _nestedProperty2['default'].get(this,"props.packageId");docsFromProps = this.getActualDocumentsFromStore();packageDSDocuments = (0,_DSWizardHelper.filterDocumentsByPackageId)(docsFromProps,packageId);attachIdResult = (0,_DSWizardFormControl.packageDocumentsAttachIdCursor)(packageDSDocuments,dynamicFieldIdCursor,true);packageDSDocuments = attachIdResult.packageDSDocuments;dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor;this.setState({dynamicFieldIdCursor:dynamicFieldIdCursor}); // immediately update the document in state to show the actualised data on render
	packageDSDocuments = (0,_DSWizardFormControl.packageDocumentsListUpdateByDocument)(packageDSDocuments,updatedDocument); //sync
	context$3$0.next = 14;return regeneratorRuntime.awrap(this.setPackageDocuments(packageDSDocuments));case 14:if(!(oneDocumentUpdatableProps.errorMessages.length > 0)){context$3$0.next = 18;break;}errorInstance = new Error();errorInstance.error = oneDocumentUpdatableProps.errorMessages;throw errorInstance;case 18:case 'end':return context$3$0.stop();}},null,_this35);},key:"OpenDocumentToFillModal"}),_react2['default'].createElement(_handleSignaturePlaceholdersPopupOfSignaturePlaceholder2['default'],{isOpen:Boolean(isOpenDocumentForPlaceholders),style:_documentsHelpers.customModalStylesForFillForm,contentLabel:"",dataForEditDocument:isOpenDocumentForPlaceholders,stakeholders:stakeholders,packageDSDocuments:this.state.packageDSDocuments,lang:this.props.lang,DSDocumentOriginTypes:DSDocumentOriginTypes,dynamicFieldIdCursor:_nestedProperty2['default'].get(this,"state.dynamicFieldIdCursor"),setFieldIdCursor:function(dynamicFieldIdCursor){return _this35.setState({dynamicFieldIdCursor:dynamicFieldIdCursor});},getDocumentsFromStore:function(){return _this35.getActualDocumentsFromStore();},updatePackageDocuments:function(packageDSDocuments){return _this35.setPackageDocuments(packageDSDocuments);},didClose:function(){_this35.setState({isOpenDocumentForPlaceholders:false}); //this.setState({isLoaded: true})
	_this35.stopLoading();dispatch((0,_stateActions2.disableBackgroundProcesses)(false));},onCancel:function(){},onSave:function(updatedDocument){},key:"OpenDocumentToAddSignaturePlaceholder"}),_react2['default'].createElement(_WarningModal2['default'],{isOpen:Boolean(warningModalOpen),style:_documentsHelpers.customModalStyles,contentLabel:"",didClose:function(){_this35.setState({warningModalOpen:false});},key:"WarningModal"}),_react2['default'].createElement(_AreYouSureModal2['default'],{isOpen:Boolean(isOpenAreYouSure),style:_documentsHelpers.customModalStyles,contentLabel:"",isOpenAreYouSure:isOpenAreYouSure?isOpenAreYouSure:{},didClose:function(){_this35.setState({isOpenAreYouSure:false});},key:"AreYouSureModal"}),_react2['default'].createElement(_reactModal2['default'],{isOpen:Boolean(fillTemplateErrorsModalOpen),style:_documentsHelpers.customModalStyles,contentLabel:"",key:"fillTemplateErrorsModal"},this.fillTemplateErrorsRender(fillTemplateErrorsModalOpen)),_react2['default'].createElement(_reactModal2['default'],{isOpen:Boolean(documentsAreNotValidModalOpen),style:_documentsHelpers.customModalStyles,contentLabel:"",key:"documentsAreNotValidModal"},this.warningModalDocumentsAreNotValidRender(documentsAreNotValidModalOpen)),_react2['default'].createElement(_reactModal2['default'],{isOpen:Boolean(printNotValidModalOpen),style:_documentsHelpers.customModalStyles,contentLabel:"",key:"printNotValidModal"},this.printingAbortErrorsRender(printNotValidModalOpen)),_react2['default'].createElement(_reactModal2['default'],{isOpen:Boolean(templateAttachmentDocumentsError),style:_documentsHelpers.customModalStyles,contentLabel:"",key:"templateAttachmentDocumentsError"},this.templateAttachmentDocumentsErrorRender(templateAttachmentDocumentsError)),!isOffice && _react2['default'].createElement(_emailSenderAttachmentDialog2['default'],{key:"attachmentDialogForDsWizard",cancelLabel:_("cancel"),confirmationLabel:_("ok"),onCancel:function(){var dispatch=_this35.props.dispatch;dispatch((0,_stateActions2.hideEmailSenderAttachmentModal)(false));},onConfirmation:function callee$2$0(){var result0=arguments.length <= 0 || arguments[0] === undefined?[]:arguments[0];var result1=arguments.length <= 1 || arguments[1] === undefined?[]:arguments[1];var result2=arguments.length <= 2 || arguments[2] === undefined?[]:arguments[2];var result3=arguments.length <= 3 || arguments[3] === undefined?[]:arguments[3];var result4=arguments.length <= 4 || arguments[4] === undefined?[]:arguments[4];var dispatch;return regeneratorRuntime.async(function callee$2$0$(context$3$0){var _this36=this;while(1) switch(context$3$0.prev = context$3$0.next){case 0:dispatch = this.props.dispatch; //check oracle document changes except for documents originate from inbox
	if(this.checkForOracleDocumentsChanges(result0,result1,result2,result3,result4)){dispatch((0,_stateActions2.hideEmailSenderAttachmentModal)(true));this.setState({isOpenAreYouSure:{title:_('areYouSureModalTitle'),message:_('areYouSureToUpdateDocumentsLists'),callBackCancel:function callBackCancel(){dispatch(_this36.openOracleDocumentsModal.bind(_this36));},callBackOk:function callBackOk(){_this36.handleConfirmSelectedAttachments(result0,result1,result2,result3,result4);}}});}else {this.handleConfirmSelectedAttachments(result0,result1,result2,result3,result4);dispatch((0,_stateActions2.hideEmailSenderAttachmentModal)(true));}case 2:case 'end':return context$3$0.stop();}},null,_this35);},moduleOptions:moduleOptions,moduleKey:moduleKey,isDsWizard:true,ticketDocuments:ticketDocuments,selected0:this.state.selectedClaimRelatedOraDocuments,selected1:this.state.selectedContractRelatedOraDocuments,selected2:this.state.selectedClientRelatedOraDocuments,selected3:this.state.selectedTarificationRelatedOraDocuments,selected4:this.state.selectedTicketRelatedOraDocuments,selected5:this.state.emailAttachmentsTicketRelatedOraDocuments}));}}]);var _DSWizard=DSWizard;DSWizard = (0,_reactRedux.connect)(function(state){var brokers=_nestedProperty2['default'].get(state,"office.brokers");var clientAccess=_nestedProperty2['default'].get(state,"app.security.actions");var createmail=clientAccess && clientAccess.filter(function(item){return item.actionName == "createmail" && item.actionAllowed == "true";}).length > 0;var moduleKey=_nestedProperty2['default'].get(state,"DSDocuments.moduleKey");var isOffice=moduleKey === c.DS_MODULE_OFFICE;return {DSWizardOpened:_nestedProperty2['default'].get(state,"DSDocuments.DSWizardOpened"),documents:_nestedProperty2['default'].get(state,"DSDocuments.items"),subgroups:_nestedProperty2['default'].get(state,"DSDocuments.subgroups"),moduleKey:moduleKey,brokers:brokers,clientDataExt:_nestedProperty2['default'].get(state,"clients.clientData"),clientOptionsDict:_nestedProperty2['default'].get(state,"client.clientOptionsDict"),client:_nestedProperty2['default'].get(state,"DSDocuments.client"),templates:_nestedProperty2['default'].get(state,"DSDocuments.templates"),DSDataSets:_nestedProperty2['default'].get(state,"DSDocuments.DSDataSets"),security:_nestedProperty2['default'].get(state,"app.security"),userFirstName:_nestedProperty2['default'].get(state,"app.firstName"),userLastName:_nestedProperty2['default'].get(state,"app.lastName"),DSDocumentOriginTypes:_nestedProperty2['default'].get(state,"app.security.DigitalSignatureHardLists.DSDocumentOriginTypes"),DSDocumentsConfig:_nestedProperty2['default'].get(state,"DSDocuments.config"),allContracts:state.contracts,emailServerConfigModalIsOpen:state.emailSender.emailServerConfigModalIsOpen,serverConfigIsSaved:state.emailSender.serverConfigIsSaved, //brokersTeamWhiteList: {'90069': ['1', '2'], '91616': [3, 4]} // TODO - fetch this values from the app login security
	brokersTeamWhiteList:(0,_DSWizardHelper.processBrokerWhiteListFromBrokersList)(brokers), // TODO - fetch this values from the app login security
	userId:state.app.userId,userPhoneNumber:state.app.number,UsersProcessFlag:state.UsersProcessFlag,createmail:createmail,EmailTemplateRelations:state.app.security.EmailTemplateRelations,isOffice:isOffice};})(DSWizard) || DSWizard;return DSWizard;})(_react.Component);exports['default'] = DSWizard; // fist make sure there are loaded the dictionaries from oracle also
	// +++++++++++++++ LOAD DICTIONARIES if not already loaded
	// -------------------------------------
	// +++++++++++++++ CLAIMS PREPARATION (just in claim case)
	// -------------------------------------
	// +++++++++++++++ LOAD DOCUMENT-S and templates
	//must reload every time when init step1 to be up to date in order to improve dswizard loading from Prem should do this only when there is a package id otherwise load only templates
	// PREM CASE: (not the best solution, but find all template to get the PREM template. TODO optimise it.)
	//get only the templates options
	// Get the templates availability
	// fill up with cursor values
	// getBrokerNumberByContract(theContract, brokers, contractDetails)
	// -------------------------------------
	// +++++++++++++++ LOAD CONTRACT IF CONTRACT ID EXISTS
	// when no brokerNumber is predicted by the package we should use from the contract is exists
	// we do this only in case when not exists already saved brokerNumber by user selection, and
	// only when there exists a contract, else let the first broker from selection list what was set on form initialisation
	// if the contract details are not loaded, then must be load it, than keep it in state, to do not load again
	// +++++++++++++++ TEMPLATE OPTION LIST filtering
	// determine the list of used templates, for this module on the selected language
	// API call to get client information
	// ------------------------------------------
	// +++++++++++++++ LOAD SUBGROUPS
	//prevent unnecessary fetch when is claim wizard
	// must get the office data for all informations for variables
	// get the two necessary value about the current contract, to init the contract dropdown and the broker data related the contract
	// force the change of the contract input to use set the Broker details in other inputs
	// ---------------------------------
	// +++++++++++++++ determine CLIENTLANGUAGE for new document
	// iterate ticked documents and add them to the package
	// ---------------------------------------------------
	// ++++ package exist reload stakeholders ++++++
	// ----------------------------------------------------
	// +++++ all DOCUMENTS are LOADED/CREATED/ADDED
	// +++++ generate formInputs for the packageDSDocuments
	// +++++++++++ add a single mandate document
	// ++++++++++++ RESET THE FORM INPUTS by documents because the new package ++++++++++++++++++
	// ----------------------- END of PREM section
	// +++++++++++++++++++++ claimWizard initial handling
	// add a single designated document for claimWizard without creating a package
	// +++++++++++++++++++++ DETERMINE THE flags for showing signer buttons
	// ++++++++++++ start handle enabled signers list ++++++++++++++
	// spread oracle document lists in state
	//"brokerSignerBirthDate": brokerSigningStakeholder && brokerSigningStakeholder.birthDate || brokerSignerBirthDate,
	//add the dynamic fields also, those must be managed when form is changed
	//await new Promise(resolve => this.setState({isLoaded: false}, resolve))
	// load current form values like flat array
	// prepare few variables form
	//check if there are signing documents selected or attachment selected
	// ++++++++++++++++ WORKING WITH TARIFICATION ++++++++++
	// ------------------ UPSERTING THE PACKAGE -------------- //
	// UPDATE PACKAGE
	// REFRESH STAKEHOLDERS
	// ++++++ Refresh DOCUMENTS and packages list -------------- //
	// UPDATE TEMPLATE OPTIONS
	// prepare result
	// parse all document are there set tarification for al documents
	// +++ EXIT POINT
	// already set the tarification, or not needed to link with anything, then return and resolve
	// ------------------ CREATE AND SETUP TARIFICATION IN CASE OF NOT CREATED ----------------------------------
	// if necessary to setup tarification for a document then check if already have tarification number generated by oracle
	// get the list of used tarification numbers
	// +++ EXIT POINT
	// When we have ALREADY generated TARIFICATION, just LINK it to the DOCUMENTS,
	// normally must be the same for all docs, when it is possible avoid to use value from package
	// fill the form documents properties with the new tarification values and return a promise
	// Last case when we don't have tarification, we create one and set it for all entities, for package and document also
	// prepare params for api call
	// temporary external data holder bridge for the following promise
	// call the createTarification api call
	// ----------------------------------------------
	// get the document from the list with the same cursor to know the size from the previous operation
	// package documents are mixed with already existent and newly created documents,
	// so they are managed in browser with local cursor in place of id, to be able make difference in between
	// more newly added document
	// skip if not affected
	// ++++++++++++ start handle enabled signers list ++++++++++++++
	// add documents attached to template if any
	// filter ticket doc list
	/*<div className={cs(stylesDocCss.errorMessageContainer,
	                        (formInputs[docTemporaryUploadIdFieldName].touched && formInputs[docTemporaryUploadIdFieldName].error) ? "" : stylesDocCss.none
	                    )}>
	                        <div className={stylesDocCss.errorMessage}>
	                            {formInputs[docTemporaryUploadIdFieldName].error && formInputs[docTemporaryUploadIdFieldName].touched &&
	                                formInputs[docTemporaryUploadIdFieldName].error}
	                        </div>
	                    </div>*/ //check if the document is generated and has documents attached and remove those to, 
	//also create a empty generated doc if there are no docs left in package 
	// get detailed contract data to know to predefine the broker data
	//extract attached documents to the selected template
	//create local files from attached files on the server
	//separate the success from fails
	//add okay documents to dswizard
	// add document
	/*<div className={stylesDocCss.formInputContainer}>
	                                                <label className={stylesDocCss.formLabel}>{_('brokerSignerBirthDate')} </label>
	                                                <DatePicker
	                                                    className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
	                                                    type="text"
	                                                    value={formInputs.brokerSignerBirthDate.value}

	                                                    // value={formInputs.brokerSignerBirthDate.value}
	                                                    onChange={(value) => {
	                                                        this.onChangeFormInput(value, "brokerSignerBirthDate")
	                                                        return this.setState({forceCloseDatepicker: false})
	                                                    }}

	                                                    // onBlur={(e) => {
	                                                    //     let forceTouch = true
	                                                    //     this.onChangeFormInput(e.target.value, "brokerSignerBirthDate", forceTouch)
	                                                    //     return this.setState({forceCloseDatepicker: false})
	                                                    // }}

	                                                    ref="brokerSignerBirthDate"
	                                                    name="brokerSignerBirthDate"
	                                                    maxDate={moment().toString()}
	                                                    forceCloseDatepicker={{
	                                                        froceClose: this.state.forceCloseDatepicker,
	                                                        cb: () => this.setState({forceCloseDatepicker:false})
	                                                    }}
	                                                />
	                                            </div>
	                                            <div className={cs(stylesDocCss.errorMessageContainer,
	                                                (formInputs.brokerSignerBirthDate.touched && formInputs.brokerSignerBirthDate.error) ? "" : stylesDocCss.none
	                                            )}>
	                                                <div className={stylesDocCss.errorMessage}>
	                                                    {formInputs.brokerSignerBirthDate.error && formInputs.brokerSignerBirthDate.touched &&
	                                                        formInputs.brokerSignerBirthDate.error}
	                                                </div>
	                                            </div>*/ // find the package instance from the first document of the package
	// find the package instance from the first document of the package
	// hide spinner
	/* <button
	                            type="button"
	                            className={stylesDocCss.greenButton + " enabled"}
	                            onClick={(e)=>{
	                                let firstDocId = nesProp.get(packageDSDocuments, "0._id")
	                                this.onClickDSDocInSamePackage(packageId)
	                            }}
	                            key={"goToDocumentsButtonKey"}
	                        >
	                            {_("goToDocuments")}
	                        </button> */ // skip the step, no email sent
	// update all stakeholder as invited
	// add attachments from default document list of current module
	// add attachments from default document list of current module
	// add attachments from default document list of current module
	// add attachments from optional document list of current module
	// add attachments from optional document list of current module
	// merge all selected lists together for show
	// add the missing documents to the form
	// refresh state packageDSDocuments from props "documents" by packageId, because after
	// the API call of upsertDSDocumentAndFetchAllData the documents are reloaded in store
	// invalid fill of template

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _phoneCountryCodesSelectJson = __webpack_require__(446);
	
	var _phoneCountryCodesSelectJson2 = _interopRequireDefault(_phoneCountryCodesSelectJson);
	
	var _DSWizardHelper = __webpack_require__(124);
	
	var _libValidator = __webpack_require__(96);
	
	// init translations
	var _ = (0, _libI18n2['default'])('dswizard');
	
	/**
	 * This function will set state for the broker selector input.
	 * Insert the list of broker like an array contains plain JS objects (label, value).
	 * @param {*} brokers
	 * @returns
	 */
	var getBrokersInOptionList = function getBrokersInOptionList(brokers) {
	    var brokerObjKeys = brokers && Object.keys(brokers) || [];
	    var brokerOptions = brokerObjKeys.map(function (brokerKey) {
	        return {
	            value: brokers[brokerKey].brokerNumber,
	            label: brokers[brokerKey].brokerNumber + " - " + brokers[brokerKey].main.name
	        };
	    });
	
	    return brokerOptions;
	};
	
	exports.getBrokersInOptionList = getBrokersInOptionList;
	/**
	 * This function will set state for the broker selector input.
	 * Insert the list of broker like an array contains plain JS objects (label, value).
	 * @param {*} brokerNumber
	 * @param {*} brokers
	 * @returns
	 */
	var getBrokerEmailsInOptionList = function getBrokerEmailsInOptionList(brokerNumber, brokers, userId) {
	    var brokerObjKeys = brokers && Object.keys(brokers) || [];
	
	    var broker = {};
	    brokerObjKeys.forEach(function (brokerKey) {
	        if (brokers[brokerKey].brokerNumber + "" === brokerNumber + "") {
	            broker = brokers[brokerKey];
	        }
	    });
	
	    var brokerEmailOptions = _nestedProperty2['default'].get(broker, "main.emails") || [];
	
	    brokerEmailOptions = brokerEmailOptions.map(function (item) {
	        return {
	            value: item,
	            label: item
	        };
	    });
	
	    var staffList = _nestedProperty2['default'].get(broker, "staff");
	    if (staffList && staffList.length > 0) {
	        staffList.forEach(function (oneStaff) {
	            if (oneStaff.userId == userId) {
	                brokerEmailOptions.push({
	                    value: oneStaff.email,
	                    label: oneStaff.email
	                });
	            }
	        });
	    }
	
	    //remove duplicate entries
	    brokerEmailOptions = brokerEmailOptions.filter(function (listElement, pos, self) {
	        return pos == self.findIndex(function (email) {
	            return email.value == listElement.value;
	        });
	    });
	
	    return brokerEmailOptions;
	};
	
	exports.getBrokerEmailsInOptionList = getBrokerEmailsInOptionList;
	/**
	* This function attach a temporal ID for the dynamic documents in form to be able to
	* handle the already saved with the new ones
	* @param {*} packageDSDocuments
	* @param {*} dynamicFieldIdCursor
	* @param {*} resetAllCursor - If this is true then will reset a new incremental order for cursors for al documents
	* without any exception, else just the newly added documents will give an new cursor in the list.
	* @returns Object:  {packageDSDocuments: <array with objects>, dynamicFieldIdCursor: <number>}
	*/
	var packageDocumentsAttachIdCursor = function packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor) {
	    var resetAllCursor = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	    packageDSDocuments = packageDSDocuments.map(function (oneDoc) {
	        if (resetAllCursor || !oneDoc.cursor) {
	            oneDoc.cursor = dynamicFieldIdCursor;
	            dynamicFieldIdCursor += 1;
	        }
	        return oneDoc;
	    });
	
	    return { packageDSDocuments: packageDSDocuments, dynamicFieldIdCursor: dynamicFieldIdCursor };
	};
	
	exports.packageDocumentsAttachIdCursor = packageDocumentsAttachIdCursor;
	/**
	* This function will update the Array elements. Find document by _id and merge it in the Array by new record object.
	* @param {*} packageDSDocuments
	* @param {*} dsDocument
	* @returns Array with dsDocument record objects
	*/
	var packageDocumentsListUpdateByDocument = function packageDocumentsListUpdateByDocument(packageDSDocuments, dsDocument) {
	    if (!dsDocument) {
	        console.warn("Can not update packageDSDocuments list with empty object instead of dsDocument record. (package-DocumentsListUpdateByDocument)");
	        return packageDSDocuments;
	    }
	
	    if (!packageDSDocuments) {
	        packageDSDocuments = [];
	        packageDSDocuments.push(dsDocument);
	        return packageDSDocuments;
	    }
	
	    packageDSDocuments.forEach(function (oneDoc, index) {
	        if (String(oneDoc._id) === String(dsDocument._id)) {
	            packageDSDocuments[index] = _extends({}, packageDSDocuments[index], dsDocument);
	        }
	    });
	
	    return packageDSDocuments;
	};
	
	exports.packageDocumentsListUpdateByDocument = packageDocumentsListUpdateByDocument;
	/**
	 * Get all of the client emails in a list what is digestible for react select.
	 * @param {*} clientDataExt
	 * @param {*} clientId
	 * @returns sorted Array: emails = [{label, value, default}]
	 */
	var getClientEmailsInOptionList = function getClientEmailsInOptionList(clientDataExt, clientId) {
	    var emails = _nestedProperty2['default'].get(clientDataExt, clientId + '.detail.emails');
	
	    if (emails && emails.length) {
	        emails = emails.map(function (item) {
	            return {
	                referenceId: clientId,
	                label: item.email,
	                value: item.email,
	                'default': item['default'] == "true" || item['default'] == true ? true : false
	            };
	        });
	
	        emails = emails.sort(function (item, item2) {
	            if (item['default'] && !item2['default']) {
	                return -1;
	            }
	            if (!item['default'] && item2['default']) {
	                return 1;
	            }
	            if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                return 0;
	            }
	        }) || [];
	    }
	
	    return emails;
	};
	
	exports.getClientEmailsInOptionList = getClientEmailsInOptionList;
	/**
	 * Get all of the client gsm phone numbers in a list what is digestible for react select.
	 * @param {*} clientDataExt
	 * @param {*} clientId
	 * @returns sorted Array: phoneNumber = [{label, value, default}]
	 */
	var getClientGSMPhoneNumbers = function getClientGSMPhoneNumbers(clientDataExt, clientId) {
	    var phoneNumbers = _nestedProperty2['default'].get(clientDataExt, clientId + '.detail.phoneNumbers');
	    var mobilePhoneNumbers = [];
	
	    if (phoneNumbers) {
	        mobilePhoneNumbers = phoneNumbers.filter(function (number) {
	            return number.mobile && (number.mobile == 'true' || number.mobile == true);
	        });
	    }
	
	    if (mobilePhoneNumbers && mobilePhoneNumbers.length > 0) {
	        mobilePhoneNumbers = mobilePhoneNumbers.map(function (item) {
	            var spreadNumber = spreadPhoneNumber(item.number);
	            return {
	                label: spreadNumber.phoneNumber,
	                value: spreadNumber.phoneNumber,
	                'default': item['default'] === 'true' ? true : false,
	                countryCode: spreadNumber.phoneCode
	            };
	        });
	
	        mobilePhoneNumbers = mobilePhoneNumbers.sort(function (item1, item2) {
	            if (item1['default'] && !item2['default']) {
	                return -1;
	            }
	            if (!item1['default'] && item2['default']) {
	                return 1;
	            }
	            if (item1['default'] && item2['default'] || !item1['default'] && !item2['default']) {
	                return 0;
	            }
	        }) || [];
	    }
	
	    return mobilePhoneNumbers;
	};
	
	exports.getClientGSMPhoneNumbers = getClientGSMPhoneNumbers;
	/**
	 *
	 * @param {*} arr
	 * @returns
	 */
	var removeDuplicates = function removeDuplicates(arr) {
	    var uniqueValues = [];
	    var visited = {};
	
	    for (var i = 0; i < arr.length; i++) {
	        var value = arr[i];
	        if (!visited[value]) {
	            visited[value] = true;
	            uniqueValues.push(value);
	        }
	    }
	
	    return uniqueValues;
	};
	
	/**
	 * Get all of the client gsm phone numbers in a list what is digestible for react select.
	 * @param {*} clientDataExt
	 * @param {*} clientId
	 * @returns sorted Array: phoneNumber = [{label, value, default}]
	 */
	var getBrokerGSMPhoneNumbers = function getBrokerGSMPhoneNumbers(phoneNumbers) {
	    var userPhoneNumber = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    var mobilePhoneNumbers = [];
	
	    if (phoneNumbers) {
	        // we have no information about number is mobile or not
	        // TODO find a solution for this
	        mobilePhoneNumbers = phoneNumbers; //.filter(number => number.mobile && (number.mobile == 'true' || number.mobile == true))
	    }
	    var spreadUserNumber = null;
	
	    if (userPhoneNumber) {
	        mobilePhoneNumbers.push(userPhoneNumber);
	        mobilePhoneNumbers = removeDuplicates(mobilePhoneNumbers);
	        spreadUserNumber = spreadPhoneNumber(userPhoneNumber);
	    }
	    mobilePhoneNumbers = removeDuplicates(mobilePhoneNumbers);
	    if (mobilePhoneNumbers && mobilePhoneNumbers.length > 0) {
	        mobilePhoneNumbers = mobilePhoneNumbers.map(function (item, index) {
	            var spreadNumber = spreadPhoneNumber(item);
	            return {
	                label: spreadNumber.phoneNumber,
	                value: spreadNumber.phoneNumber,
	                'default': spreadUserNumber && spreadUserNumber.phoneNumber === spreadNumber.phoneNumber ? true : false,
	                countryCode: spreadNumber.phoneCode
	            };
	        });
	
	        // if no default exists select the first
	        if (!mobilePhoneNumbers.some(function (item) {
	            return item['default'];
	        })) {
	            mobilePhoneNumbers[0]['default'] = true;
	        }
	
	        mobilePhoneNumbers = mobilePhoneNumbers.sort(function (item1, item2) {
	            if (item1['default'] && !item2['default']) {
	                return -1;
	            }
	            if (!item1['default'] && item2['default']) {
	                return 1;
	            }
	            if (item1['default'] && item2['default'] || !item1['default'] && !item2['default']) {
	                return 0;
	            }
	        }) || [];
	    }
	
	    return mobilePhoneNumbers;
	};
	
	exports.getBrokerGSMPhoneNumbers = getBrokerGSMPhoneNumbers;
	/**
	 * This function extracts country code from phone number and returns a object wit both values
	 * @param {*} phoneNumber
	 * @returns
	 */
	var spreadPhoneNumber = function spreadPhoneNumber(phoneNumber) {
	    //check if phone number starts with "00" or "+" than normalize it if necessary
	    if (phoneNumber && phoneNumber.trim()[0] === "+") {
	        phoneNumber = "00" + phoneNumber.substring(1);
	    }
	
	    //declare a default result for invalid values
	    var result = {
	        phoneNumber: '',
	        phoneCode: '+32' //default Belgium value
	    };
	
	    // if the phone number contains other characters than numbers, return default
	    var isNumber = /^\d+$/.test(phoneNumber);
	    if (!isNumber) {
	        return result;
	    }
	
	    result.phoneNumber = phoneNumber;
	    //Find the country phone code in our list and store it in a variable
	    var maxTestPhoneCodeLength = 6;
	    var countryCode = phoneNumber.slice(0, maxTestPhoneCodeLength);
	    var foundCodeInList = false;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = _phoneCountryCodesSelectJson2['default'][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var code = _step.value;
	
	            if (countryCode.startsWith(code.phoneCode)) {
	                result.phoneCode = code.phoneCode;
	                foundCodeInList = true;
	            }
	        }
	
	        //reduce the phone number to its value without the country code to normalize all numbers
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator['return']) {
	                _iterator['return']();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    if (result.phoneCode && result.phoneCode.length > 0 && foundCodeInList) {
	        result.phoneNumber = result.phoneNumber.slice(result.phoneCode.length);
	    }
	
	    if (result.phoneNumber[0] != 0) {
	        result.phoneNumber = '0' + result.phoneNumber;
	    }
	
	    //set phone code to '+' format
	    if (result.phoneCode[0] !== '+') {
	        result.phoneCode = '+' + result.phoneCode.substring(2);
	    }
	
	    return result;
	};
	
	exports.spreadPhoneNumber = spreadPhoneNumber;
	/**
	 * Gets the list for the country phone codes
	 * @returns Options list of label and values keys objects for react select2 to handle
	 */
	var getCountryPhoneCodes = function getCountryPhoneCodes() {
	    var countryCodesOptionsList = [];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = _phoneCountryCodesSelectJson2['default'][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var code = _step2.value;
	
	            var selectOption = {
	                label: '+' + code.phoneCode.substring(2),
	                value: '+' + code.phoneCode.substring(2),
	                'default': code.phoneCode == '0032' ? true : false
	            };
	            countryCodesOptionsList.push(selectOption);
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                _iterator2['return']();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    countryCodesOptionsList.sort(function (a, b) {
	        return a.value > b.value ? 1 : a.value < b.value ? -1 : 0;
	    });
	    return countryCodesOptionsList;
	};
	
	exports.getCountryPhoneCodes = getCountryPhoneCodes;
	/**
	 * This function will provide a blank frame of the schema for the form
	 */
	var getNewDSDocumentInstance = function getNewDSDocumentInstance(security) {
	    var oneInstanceFrame = _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DSDocumentSchemaProps");
	    // copy object props
	    oneInstanceFrame = JSON.parse(JSON.stringify(oneInstanceFrame));
	
	    return oneInstanceFrame;
	};
	
	exports.getNewDSDocumentInstance = getNewDSDocumentInstance;
	/**
	 * This function wil retrieve contract and return
	 */
	var findContractInClientObj = function findContractInClientObj(client, contractId) {
	
	    var result = null;
	    var contracts = _nestedProperty2['default'].get(client, "contracts");
	
	    if (!contracts || contracts.length === 0) {
	        return result;
	    }
	
	    var objKeys = Object.keys(contracts);
	
	    // fishing our contract by ID from stack
	    objKeys && objKeys.map(function (oneKey) {
	        var oneContractId = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.contractId");
	
	        // got it and save into the result
	        if (oneContractId === contractId) {
	            result = _nestedProperty2['default'].get(contracts, oneKey);
	        }
	    });
	
	    return result;
	};
	
	exports.findContractInClientObj = findContractInClientObj;
	/**
	* This function will return broker number by contract or the first from the list
	* @param {*} contractInfo
	*/
	var getBrokerNumberByContract = function getBrokerNumberByContract(contractInfo, brokers, contractDetails) {
	    var result = undefined;
	    if (contractDetails) {
	        result = contractDetails.brokerNumber || null;
	    }
	
	    if (!result && contractDetails) {
	        result = contractInfo && contractInfo.brokerNumber || null;
	    }
	
	    // if no contract related brokerNumber then get the first one
	    if (!result) {
	        var brokerObjKeys = brokers && Object.keys(brokers) || [];
	        if (brokerObjKeys.length > 0) {
	            result = brokers[brokerObjKeys[0]].brokerNumber;
	        }
	    }
	
	    return result;
	};
	
	exports.getBrokerNumberByContract = getBrokerNumberByContract;
	/**
	* This function will return broker info by brokerNumber
	* @param {*} brokerNumber
	*/
	var getBrokerFullInfoByNumber = function getBrokerFullInfoByNumber(brokerNumber, brokers) {
	    var brokerObjKeys = brokers && Object.keys(brokers) || [];
	    var result = null;
	
	    if (brokerObjKeys.length > 0) {
	        brokerObjKeys.forEach(function (oneBrokerKey) {
	            if (brokers[oneBrokerKey].brokerNumber === brokerNumber) {
	                result = brokers[oneBrokerKey];
	            }
	        });
	    }
	
	    return result;
	};
	
	exports.getBrokerFullInfoByNumber = getBrokerFullInfoByNumber;
	/**
	* This function will return remainder interval selected default
	*/
	var getDefaultRemainderInterval = function getDefaultRemainderInterval(security, DSDocumentsConfig) {
	    // const { security, DSDocumentsConfig } = this.props
	
	    return _nestedProperty2['default'].get(DSDocumentsConfig, "remainderInterval") || _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervals.0.value");
	};
	
	exports.getDefaultRemainderInterval = getDefaultRemainderInterval;
	/**
	* This function will return remainder interval selected default
	*/
	var getDefaultRemainderRepeats = function getDefaultRemainderRepeats(security, DSDocumentsConfig) {
	    // const { security, DSDocumentsConfig } = this.props
	
	    return _nestedProperty2['default'].get(DSDocumentsConfig, "remainderRepeats") || _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervalRepeat.3.value") || _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervalRepeat.0.value");
	};
	
	exports.getDefaultRemainderRepeats = getDefaultRemainderRepeats;
	/**
	* This function will return remainder interval selected default
	*/
	var getDefaultTarificationRemainderInterval = function getDefaultTarificationRemainderInterval(security, DSDocumentsConfig) {
	    // const { security, DSDocumentsConfig } = this.props
	
	    return _nestedProperty2['default'].get(DSDocumentsConfig, "remainderTicketInterval") || _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervals.0.value");
	};
	
	exports.getDefaultTarificationRemainderInterval = getDefaultTarificationRemainderInterval;
	/**
	* This function will return remainder interval selected default
	*/
	var getDefaultTarificationRemainderRepeats = function getDefaultTarificationRemainderRepeats(security, DSDocumentsConfig) {
	    // const { security, DSDocumentsConfig } = this.props
	
	    return _nestedProperty2['default'].get(DSDocumentsConfig, "remainderTicketRepeats") || _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervalRepeat.3.value") || _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervalRepeat.0.value");
	};
	
	exports.getDefaultTarificationRemainderRepeats = getDefaultTarificationRemainderRepeats;
	/**
	* This function will return expiration on date default
	*/
	var getDefaultExpirationOn = function getDefaultExpirationOn(DSDocumentsConfig) {
	    //return new Date().setFullYear(new Date().getFullYear() + 1)
	    // Calendar time displays time relative to a given referenceDay (defaults to the start of today).
	
	    var defExpDay = _nestedProperty2['default'].get(DSDocumentsConfig, "packageExpiration.day");
	    var defExpMonth = _nestedProperty2['default'].get(DSDocumentsConfig, "packageExpiration.month");
	    var defExpYear = _nestedProperty2['default'].get(DSDocumentsConfig, "packageExpiration.year");
	
	    return (0, _moment2['default'])().add(_moment2['default'].duration(defExpDay, 'days')).add(_moment2['default'].duration(defExpMonth, 'months')).add(_moment2['default'].duration(defExpYear, 'years')).endOf('day').format("YYYY-MM-DD");
	};
	
	exports.getDefaultExpirationOn = getDefaultExpirationOn;
	/**
	 * This function will toggle show the second signer fields and set or reset values
	 * @param {*} formInputs
	 * @param {*} show
	 * @returns formInputs
	 */
	var showSecondSignerFields = function showSecondSignerFields(formInputs, show, requireSmsOtpSigning) {
	    var secondSignerFields = ["secondSignerLastName", "secondSignerFirstName", "secondSignerEmailAddress", "secondSignerLanguage"];
	
	    if (requireSmsOtpSigning) {
	        secondSignerFields.push('secondSignerPhoneNumber', 'secondSignerCountryPhoneCode');
	    } else {
	        formInputs['secondSignerPhoneNumber'].isRequired = false;
	        formInputs['secondSignerPhoneNumber'].value = null;
	        formInputs['secondSignerPhoneNumber'].touched = false;
	        formInputs['secondSignerPhoneNumber'].isValid = function () {
	            return true;
	        };
	        formInputs['secondSignerCountryPhoneCode'].isRequired = false;
	        formInputs['secondSignerCountryPhoneCode'].value = null;
	        formInputs['secondSignerCountryPhoneCode'].touched = false;
	    }
	
	    if (!show) {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = secondSignerFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var field = _step3.value;
	
	                formInputs[field].isRequired = false;
	                formInputs[field].value = null;
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	                    _iterator3['return']();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	    } else {
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = secondSignerFields[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var field = _step4.value;
	
	                formInputs[field].isRequired = true;
	                // formInputs[field].value = ''
	
	                //set default validation for belgium numbers
	                if (field === 'secondSignerPhoneNumber') {
	                    formInputs[field].isValid = function (value) {
	                        return value[0] == '0' ? value.length === 10 : value.length === 9;
	                    };
	                }
	
	                // set default country code for belgium
	                if (field === 'secondSignerCountryPhoneCode') {
	                    if (!formInputs[field].value) {
	                        formInputs[field].value = '+32';
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4['return']) {
	                    _iterator4['return']();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	    }
	
	    return formInputs;
	};
	
	exports.showSecondSignerFields = showSecondSignerFields;
	/**
	 * This function will toggle show the second signer fields and set or reset values
	 * @param {*} brokerSigningStakeholder
	 * @param {*} formInputs
	 * @param {*} brokerInfo
	 * @param {*} lang
	 * @param {*} countryPhoneCodes
	 * @param {*} show
	 * @param {*} requireSmsOtpSigning
	 * @param {*} userFirstName
	 * @param {*} userLastName
	 * @returns formInputs
	 */
	var resetBrokerSignerRelatedFields = function resetBrokerSignerRelatedFields(brokerSigningStakeholder, formInputs, brokerInfo, lang, countryPhoneCodes, show, requireSmsOtpSigning, userFirstName, userLastName, userPhoneNumber) {
	    var fieldNameList = ["brokerSignerLastName", "brokerSignerFirstName", /* "brokerSignerBirthDate", */"brokerSignerLanguage", "brokerSignerPhoneNumber", "brokerSignerCountryPhoneCode"];
	
	    // set broker as signer or not
	    formInputs["brokerSignerExists"].value = show;
	
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	        for (var _iterator5 = fieldNameList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var fieldName = _step5.value;
	
	            formInputs[fieldName].isRequired = show;
	            formInputs[fieldName].touched = false;
	        }
	
	        // set default values from brokerInfo
	    } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion5 && _iterator5['return']) {
	                _iterator5['return']();
	            }
	        } finally {
	            if (_didIteratorError5) {
	                throw _iteratorError5;
	            }
	        }
	    }
	
	    var code = countryPhoneCodes.find(function (oneCode) {
	        return oneCode['default'] ? true : false;
	    });
	    if (!code) {
	        code = countryPhoneCodes[0];
	    }
	
	    var spreadUsersPhone = spreadPhoneNumber(brokerSigningStakeholder ? brokerSigningStakeholder.phoneNumber : userPhoneNumber);
	
	    formInputs["brokerSignerFirstName"].value = userFirstName;
	    formInputs["brokerSignerLastName"].value = userLastName;
	
	    formInputs["brokerSignerLanguage"].value = lang;
	    //formInputs["brokerSignerBirthDate"].value = moment().subtract(25, 'years').format("YYYY/MM/DD") // pick a random date
	
	    formInputs["brokerSignerPhoneNumber"].value = spreadUsersPhone ? spreadUsersPhone.phoneNumber : brokerInfo.main.phoneNumbers[0];
	    formInputs["brokerSignerCountryPhoneCode"].value = spreadUsersPhone ? spreadUsersPhone.phoneCode : code.value;
	
	    if (show) {
	        formInputs["brokerSignerPhoneNumber"].isValid = function (value) {
	            return value[0] == '0' ? value.length === 10 : value.length === 9;
	        };
	    } else {
	        formInputs["brokerSignerPhoneNumber"].isValid = function () {
	            return true;
	        };
	    }
	
	    // check if sms required
	    if (requireSmsOtpSigning) {
	        formInputs['brokerSignerPhoneNumber'].isRequired = show;
	        formInputs['brokerSignerCountryPhoneCode'].isRequired = show;
	    } else {
	        formInputs['brokerSignerPhoneNumber'].isRequired = false;
	        formInputs['brokerSignerCountryPhoneCode'].isRequired = false;
	    }
	
	    return formInputs;
	};
	
	exports.resetBrokerSignerRelatedFields = resetBrokerSignerRelatedFields;
	/**
	 * One input field basic props for handle form.
	 */
	var _inputPrototype = function _inputPrototype(inputName) {
	    return {
	        label: "",
	        value: "",
	        touched: false,
	        error: false,
	        isRequired: false,
	        isValid: function isValid() {
	            return true;
	        },
	        errorMessage: _("invalidInputValue"),
	        errorMessageRequired: _("requiredInputValueFor" + inputName)
	    };
	};
	
	exports._inputPrototype = _inputPrototype;
	/**
	 * Copy one input handler object and return.
	 */
	var _initValueOfInput = function _initValueOfInput(inputName) {
	    var proto = JSON.parse(JSON.stringify(_inputPrototype(inputName)));
	    proto.isValid = function () {
	        return true;
	    }; // JSON trick is not perfect to copy an object :)
	    return proto;
	};
	
	exports._initValueOfInput = _initValueOfInput;
	/**
	 * This function will generate a name for the field of DSDocumentTemplate in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocTemplate = function getDynamicFieldNameForDocTemplate(cursor) {
	    return "packageDocumentTemplate" + cursor;
	};
	
	exports.getDynamicFieldNameForDocTemplate = getDynamicFieldNameForDocTemplate;
	/**
	 * This function will generate a name for the field of DSDocument Language in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocLang = function getDynamicFieldNameForDocLang(cursor) {
	    return "packageDocumentLang" + cursor;
	};
	
	exports.getDynamicFieldNameForDocLang = getDynamicFieldNameForDocLang;
	/**
	 * This function will generate a name for the field of DSDocument team in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocTeam = function getDynamicFieldNameForDocTeam(cursor) {
	    return "packageDocumentTeam" + cursor;
	};
	
	exports.getDynamicFieldNameForDocTeam = getDynamicFieldNameForDocTeam;
	/**
	 * This function will generate a name for the field of DSDocument team name in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocTeamName = function getDynamicFieldNameForDocTeamName(cursor) {
	    return "packageDocumentTeamName" + cursor;
	};
	
	exports.getDynamicFieldNameForDocTeamName = getDynamicFieldNameForDocTeamName;
	/**
	 * This function will generate a name for the field of DSDocument team name in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocTeamSubgroup = function getDynamicFieldNameForDocTeamSubgroup(cursor) {
	    return "packageDocumentTeamSubgroupName" + cursor;
	};
	
	exports.getDynamicFieldNameForDocTeamSubgroup = getDynamicFieldNameForDocTeamSubgroup;
	/**
	 * This function will generate a name for the field of DSDocument Contract in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocContractNumber = function getDynamicFieldNameForDocContractNumber(cursor) {
	    return "packageDocumentContractNumber" + cursor;
	};
	
	exports.getDynamicFieldNameForDocContractNumber = getDynamicFieldNameForDocContractNumber;
	/**
	 * This function will generate a name for the field of DSDocument Contract in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocContractId = function getDynamicFieldNameForDocContractId(cursor) {
	    return "packageDocumentContractId" + cursor;
	};
	
	exports.getDynamicFieldNameForDocContractId = getDynamicFieldNameForDocContractId;
	/**
	 * This function will generate a name for the field of DSDocument Tarification id in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocTarificationId = function getDynamicFieldNameForDocTarificationId(cursor) {
	    return "packageDocumentTarificationId" + cursor;
	};
	
	exports.getDynamicFieldNameForDocTarificationId = getDynamicFieldNameForDocTarificationId;
	/**
	 * This function will generate a name for the field of DSDocument Tarification name in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocTarificationNumber = function getDynamicFieldNameForDocTarificationNumber(cursor) {
	    return "packageDocumentTarificationNumber" + cursor;
	};
	
	exports.getDynamicFieldNameForDocTarificationNumber = getDynamicFieldNameForDocTarificationNumber;
	/**
	 * This function will generate a name for the field of DSDocument Claim id in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocClaimId = function getDynamicFieldNameForDocClaimId(cursor) {
	    return "packageDocumentClaimId" + cursor;
	};
	
	exports.getDynamicFieldNameForDocClaimId = getDynamicFieldNameForDocClaimId;
	/**
	 * This function will generate a name for the field of DSDocument Claim number in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocClaimNumber = function getDynamicFieldNameForDocClaimNumber(cursor) {
	    return "packageDocumentClaimNumber" + cursor;
	};
	
	exports.getDynamicFieldNameForDocClaimNumber = getDynamicFieldNameForDocClaimNumber;
	/**
	 * This function will generate a name for the field of DSDocument ID in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocId = function getDynamicFieldNameForDocId(cursor) {
	    return "packageDocumentId" + cursor;
	};
	
	exports.getDynamicFieldNameForDocId = getDynamicFieldNameForDocId;
	/**
	 * This function will generate a name for the field of Origin in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocOrigin = function getDynamicFieldNameForDocOrigin(cursor) {
	    return "packageDocumentOrigin" + cursor;
	};
	
	exports.getDynamicFieldNameForDocOrigin = getDynamicFieldNameForDocOrigin;
	/**
	 * This function will generate a name for the field of pdf name in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForTemporaryUploadId = function getDynamicFieldNameForTemporaryUploadId(cursor) {
	    return "packageDocumentTemporaryUploadId" + cursor;
	};
	
	exports.getDynamicFieldNameForTemporaryUploadId = getDynamicFieldNameForTemporaryUploadId;
	/**
	 * This function will generate a name for the field of pdf name in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocumentTypeIdx = function getDynamicFieldNameForDocumentTypeIdx(cursor) {
	    return "packageDocumentDocumentTypeIdx" + cursor;
	};
	
	exports.getDynamicFieldNameForDocumentTypeIdx = getDynamicFieldNameForDocumentTypeIdx;
	/**
	 * This function will generate upload document index name for local document in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocumentUploadGroupTypeId = function getDynamicFieldNameForDocumentUploadGroupTypeId(cursor) {
	    return "packageDocumentDocumentUploadGroupTypeId" + cursor;
	};
	
	exports.getDynamicFieldNameForDocumentUploadGroupTypeId = getDynamicFieldNameForDocumentUploadGroupTypeId;
	/**
	 * This function will generate a name for the field of pdf name in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForUploadComment = function getDynamicFieldNameForUploadComment(cursor) {
	    return "packageDocumentDocumentUploadComment" + cursor;
	};
	
	exports.getDynamicFieldNameForUploadComment = getDynamicFieldNameForUploadComment;
	/**
	 * This function will generate a name for the field of original filename in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocUploadedFileOriginalName = function getDynamicFieldNameForDocUploadedFileOriginalName(cursor) {
	    return "packageDocumentUploadedFileOriginalName" + cursor;
	};
	
	exports.getDynamicFieldNameForDocUploadedFileOriginalName = getDynamicFieldNameForDocUploadedFileOriginalName;
	/**
	 * This function will generate a name for the field of oracle ID in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocOracleId = function getDynamicFieldNameForDocOracleId(cursor) {
	    return "packageDocumentOracleDocumentId" + cursor;
	};
	
	exports.getDynamicFieldNameForDocOracleId = getDynamicFieldNameForDocOracleId;
	/**
	 * This function will generate a name for the field of oracle type in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocOracleType = function getDynamicFieldNameForDocOracleType(cursor) {
	    return "packageDocumentOracleDocumentType" + cursor;
	};
	
	exports.getDynamicFieldNameForDocOracleType = getDynamicFieldNameForDocOracleType;
	/**
	 * This function will generate a name for the field of OracleDocumentUploadDate in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForOracleDocumentUploadDate = function getDynamicFieldNameForOracleDocumentUploadDate(cursor) {
	    return "packageDocumentOracleDate" + cursor;
	};
	
	exports.getDynamicFieldNameForOracleDocumentUploadDate = getDynamicFieldNameForOracleDocumentUploadDate;
	/**
	 * This function will generate a name for the field of oracle name in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocOracleName = function getDynamicFieldNameForDocOracleName(cursor) {
	    return "packageDocumentOracleName" + cursor;
	};
	
	exports.getDynamicFieldNameForDocOracleName = getDynamicFieldNameForDocOracleName;
	/**
	 * This function will generate a name for the field of oracle type in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForDocSelectionTab = function getDynamicFieldNameForDocSelectionTab(cursor) {
	    return "packageDocumentSelectionTab" + cursor;
	};
	
	exports.getDynamicFieldNameForDocSelectionTab = getDynamicFieldNameForDocSelectionTab;
	/**
	 * This function will generate a name for the field of oracle type in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForSize = function getDynamicFieldNameForSize(cursor) {
	    return "packageDocumentSize" + cursor;
	};
	
	exports.getDynamicFieldNameForSize = getDynamicFieldNameForSize;
	/**
	 * This function will generate a name for the field of oracle type in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameForEncrypted = function getDynamicFieldNameForEncrypted(cursor) {
	    return "packageDocumentEncrypted" + cursor;
	};
	
	exports.getDynamicFieldNameForEncrypted = getDynamicFieldNameForEncrypted;
	/**
	 * This function will generate a name for the field of oracle type in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameAttachmentConnectionId = function getDynamicFieldNameAttachmentConnectionId(cursor) {
	    return "packageDocumentAttachmentConnectionId" + cursor;
	};
	
	exports.getDynamicFieldNameAttachmentConnectionId = getDynamicFieldNameAttachmentConnectionId;
	/**
	 * This function will generate a name for the is attachment flag in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNameIsAttachment = function getDynamicFieldNameIsAttachment(cursor) {
	    return "packageDocumentIsAttachment" + cursor;
	};
	
	exports.getDynamicFieldNameIsAttachment = getDynamicFieldNameIsAttachment;
	/**
	 * This function will generate a name for the position of the attachment file in the merged document in the dynamic document list.
	 * @param {number} cursor
	 */
	var getDynamicFieldNamePositionInUploadDoc = function getDynamicFieldNamePositionInUploadDoc(cursor) {
	    return "packageDocumentPositionInUploadDoc" + cursor;
	};
	
	exports.getDynamicFieldNamePositionInUploadDoc = getDynamicFieldNamePositionInUploadDoc;
	/**
	 * Returns with the name of the packageId
	 */
	var getPackageIdFieldName = function getPackageIdFieldName() {
	    return "packageId";
	};
	
	exports.getPackageIdFieldName = getPackageIdFieldName;
	/**
	 * This function provide form input fields for a single document by a document record
	 * @param {*} oneDocument
	 */
	var getDynamicInputFieldByCursor = function getDynamicInputFieldByCursor(documentRecord, moduleKey, subModuleKey, DSDocumentOriginTypes) {
	    var initialDocumentFields = {};
	    // deep clone to not lose
	    var oneDocument = JSON.parse(JSON.stringify(documentRecord));
	    var cursor = oneDocument.cursor;
	    var docIdFieldName = getDynamicFieldNameForDocId(cursor);
	    var docOriginFieldName = getDynamicFieldNameForDocOrigin(cursor);
	    var docTemplateFieldName = getDynamicFieldNameForDocTemplate(cursor);
	    var docLangFieldName = getDynamicFieldNameForDocLang(cursor);
	    var docTeamFieldName = getDynamicFieldNameForDocTeam(cursor);
	    var docTeamNameFieldName = getDynamicFieldNameForDocTeamName(cursor);
	    var docTeamSubgroupFieldName = getDynamicFieldNameForDocTeamSubgroup(cursor);
	    var docContractFieldName = getDynamicFieldNameForDocContractNumber(cursor);
	    var docContractIdFieldName = getDynamicFieldNameForDocContractId(cursor);
	    var docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(cursor);
	    var docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(cursor);
	    var docClaimIdFieldName = getDynamicFieldNameForDocClaimId(cursor);
	    var docClaimNumberFieldName = getDynamicFieldNameForDocClaimNumber(cursor);
	    // uploaded documents
	    var docTemporaryUploadIdFieldName = getDynamicFieldNameForTemporaryUploadId(cursor);
	    var docUploadedFileOriginalNameFieldName = getDynamicFieldNameForDocUploadedFileOriginalName(cursor);
	    // oracle documents
	    var docDocumentTypeIdxFieldName = getDynamicFieldNameForDocumentTypeIdx(cursor);
	    var docDocumentUploadGroupTypeIdFieldName = getDynamicFieldNameForDocumentUploadGroupTypeId(cursor);
	    var docUploadCommentFieldName = getDynamicFieldNameForUploadComment(cursor);
	    var docOracleIdFieldName = getDynamicFieldNameForDocOracleId(cursor);
	    var docOracleTypeFieldName = getDynamicFieldNameForDocOracleType(cursor);
	    var docOracleName = getDynamicFieldNameForDocOracleName(cursor);
	    var oracleDocumentUploadDate = getDynamicFieldNameForOracleDocumentUploadDate(cursor);
	    var documentSelectionTabFieldName = getDynamicFieldNameForDocSelectionTab(cursor);
	    var attachmentConnectionIdFieldName = getDynamicFieldNameAttachmentConnectionId(cursor);
	    var isAttachmentFieldName = getDynamicFieldNameIsAttachment(cursor);
	    var positionInUploadDocName = getDynamicFieldNamePositionInUploadDoc(cursor);
	    var documentSizeFieldName = getDynamicFieldNameForSize(cursor);
	    var documentEncryptedFieldName = getDynamicFieldNameForEncrypted(cursor);
	
	    initialDocumentFields[docIdFieldName] = _extends({}, _initValueOfInput(docIdFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocId"),
	        value: oneDocument._id || ""
	    });
	
	    //V8.0
	    initialDocumentFields[docOriginFieldName] = _extends({}, _initValueOfInput(docOriginFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocOriginFieldName"),
	        value: oneDocument.origin || ""
	    });
	
	    initialDocumentFields[docTemplateFieldName] = _extends({}, _initValueOfInput(docTemplateFieldName), {
	        isRequired: oneDocument.origin == DSDocumentOriginTypes.DS_ORIGIN_GENERATED ? true : false,
	        //isRequired: true,
	        errorMessage: _("invalidDocType"),
	        value: _nestedProperty2['default'].get(oneDocument, "documentTemplateId") || null
	    });
	
	    initialDocumentFields[docLangFieldName] = _extends({}, _initValueOfInput(docLangFieldName), {
	        isRequired: oneDocument.origin == DSDocumentOriginTypes.DS_ORIGIN_GENERATED ? true : false,
	        //isRequired: true,
	        errorMessage: _("invalidDocLang"),
	        value: _nestedProperty2['default'].get(oneDocument, "language") || null
	    });
	
	    initialDocumentFields[docTeamFieldName] = _extends({}, _initValueOfInput(docTeamFieldName), {
	        isRequired: moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION,
	        requiredErrorMessage: _("requiredDocTeam"),
	        errorMessage: _("invalidDocTeam"),
	        value: _nestedProperty2['default'].get(oneDocument, "team") || null
	    });
	
	    initialDocumentFields[docTeamNameFieldName] = _extends({}, _initValueOfInput(docTeamNameFieldName), {
	        isRequired: moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION,
	        errorMessage: _("invalidDocTeamName"),
	        value: _nestedProperty2['default'].get(oneDocument, "teamName") || null
	    });
	
	    initialDocumentFields[docContractFieldName] = _extends({}, _initValueOfInput(docContractFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocContract"),
	        value: _nestedProperty2['default'].get(oneDocument, "contractNumber") || ""
	    });
	
	    initialDocumentFields[docContractIdFieldName] = _extends({}, _initValueOfInput(docContractIdFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocContractId"),
	        value: _nestedProperty2['default'].get(oneDocument, "contractId") || ""
	    });
	
	    initialDocumentFields[docTarificationIdFieldName] = _extends({}, _initValueOfInput(docTarificationIdFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocTarificationId"),
	        value: _nestedProperty2['default'].get(oneDocument, "tarificationId") || ""
	    });
	
	    initialDocumentFields[docTarificationNumberFieldName] = _extends({}, _initValueOfInput(docTarificationNumberFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocTarificationNumber"),
	        value: _nestedProperty2['default'].get(oneDocument, "tarificationNumber") || ""
	    });
	
	    initialDocumentFields[docClaimIdFieldName] = _extends({}, _initValueOfInput(docClaimIdFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocClaimId"),
	        value: _nestedProperty2['default'].get(oneDocument, "claimId") || ""
	    });
	
	    initialDocumentFields[docClaimNumberFieldName] = _extends({}, _initValueOfInput(docClaimNumberFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocClaimNumber"),
	        value: _nestedProperty2['default'].get(oneDocument, "claimNumber") || ""
	    });
	
	    initialDocumentFields[docTeamSubgroupFieldName] = _extends({}, _initValueOfInput(docTeamSubgroupFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocTeamSubgroup"),
	        value: _nestedProperty2['default'].get(oneDocument, "teamSubgroup") || null
	    });
	
	    // V8.0 - local uploaded documents related fields
	    initialDocumentFields[docTemporaryUploadIdFieldName] = _extends({}, _initValueOfInput(docTemporaryUploadIdFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidTemporaryUploadId"),
	        value: _nestedProperty2['default'].get(oneDocument, "temporaryUploadId") || ""
	    });
	
	    initialDocumentFields[docDocumentTypeIdxFieldName] = _extends({}, _initValueOfInput(docDocumentTypeIdxFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocumentTypeIdxFieldName"),
	        value: _nestedProperty2['default'].get(oneDocument, "documentTypeIdx") || ""
	    });
	
	    initialDocumentFields[docDocumentUploadGroupTypeIdFieldName] = _extends({}, _initValueOfInput(docDocumentUploadGroupTypeIdFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocumentUploadGroupTypeIdName"),
	        value: _nestedProperty2['default'].get(oneDocument, "documentUploadGroupTypeId") || ""
	    });
	
	    initialDocumentFields[docUploadCommentFieldName] = _extends({}, _initValueOfInput(docUploadCommentFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidUploadComment"),
	        value: _nestedProperty2['default'].get(oneDocument, "uploadComment") || ""
	    });
	
	    initialDocumentFields[docUploadedFileOriginalNameFieldName] = _extends({}, _initValueOfInput(docUploadedFileOriginalNameFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidUploadedocOracleIdFieldNamedFileOriginalName"),
	        value: _nestedProperty2['default'].get(oneDocument, "originalFileName") || ""
	    });
	
	    // v8.0 oracle documents related fields
	    initialDocumentFields[docOracleIdFieldName] = _extends({}, _initValueOfInput(docOracleIdFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidOracleId"),
	        value: _nestedProperty2['default'].get(oneDocument, "oracleDocumentId") || ""
	    });
	
	    initialDocumentFields[docOracleTypeFieldName] = _extends({}, _initValueOfInput(docOracleTypeFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidOracleType"),
	        value: _nestedProperty2['default'].get(oneDocument, "oracleDocumentType") || ""
	    });
	
	    initialDocumentFields[docOracleName] = _extends({}, _initValueOfInput(docOracleName), {
	        isRequired: false,
	        errorMessage: _("invalidOracleDocumentName"),
	        value: _nestedProperty2['default'].get(oneDocument, "oracleDocumentName") || ""
	    });
	
	    initialDocumentFields[oracleDocumentUploadDate] = _extends({}, _initValueOfInput(oracleDocumentUploadDate), {
	        isRequired: false,
	        errorMessage: _("invalidOracleDocumentUploadDate"),
	        value: _nestedProperty2['default'].get(oneDocument, "oracleDocumentUploadDate") || ""
	    });
	
	    initialDocumentFields[documentSelectionTabFieldName] = _extends({}, _initValueOfInput(documentSelectionTabFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDoscumentSelectionTab"),
	        value: _nestedProperty2['default'].get(oneDocument, 'documentSelectionTab')
	    });
	
	    initialDocumentFields[attachmentConnectionIdFieldName] = _extends({}, _initValueOfInput(attachmentConnectionIdFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidAttachmentConnectionId"),
	        value: _nestedProperty2['default'].get(oneDocument, 'attachmentConnectionId')
	    });
	
	    initialDocumentFields[isAttachmentFieldName] = _extends({}, _initValueOfInput(isAttachmentFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocumentIsAttachment"),
	        value: _nestedProperty2['default'].get(oneDocument, 'isAttachment')
	    });
	
	    initialDocumentFields[positionInUploadDocName] = _extends({}, _initValueOfInput(positionInUploadDocName), {
	        isRequired: false,
	        errorMessage: _("invalidDocumentPositionInUploadDoc"),
	        value: _nestedProperty2['default'].get(oneDocument, 'positionInUploadDoc')
	    });
	
	    initialDocumentFields[documentSizeFieldName] = _extends({}, _initValueOfInput(documentSizeFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocumentSize"),
	        isValid: function isValid(size) {
	            return Number(size) <= 30 * Math.pow(1024, 2);
	        },
	        value: Number(_nestedProperty2['default'].get(oneDocument, 'fileSize'))
	    });
	
	    initialDocumentFields[documentEncryptedFieldName] = _extends({}, _initValueOfInput(documentEncryptedFieldName), {
	        isRequired: false,
	        errorMessage: _("invalidDocumentEncryption"),
	        isValid: function isValid(isEncrypted) {
	            isEncrypted = isEncrypted === "false" || !isEncrypted ? false : true;
	            return !isEncrypted;
	        },
	        value: _nestedProperty2['default'].get(oneDocument, 'isEncrypted') === "false" || !_nestedProperty2['default'].get(oneDocument, 'isEncrypted') ? false : true
	    });
	
	    return initialDocumentFields;
	};
	
	exports.getDynamicInputFieldByCursor = getDynamicInputFieldByCursor;
	/**
	 * This function will return a list with form field values for documents.
	 * @param {*} packageDSDocuments
	 * @returns
	 */
	var getFlatValueListOfDsDocumentsForForm = function getFlatValueListOfDsDocumentsForForm(packageDSDocuments, documentTemplateOptions) {
	    // if there is many options we let it blank, no default selection yet
	    //let contractNumbersOptions = this.getContractNumbersInOptionList()
	    var flatDocumentsValueList = {};
	
	    if (packageDSDocuments) {
	        (function () {
	            var cursor = 0;
	
	            packageDSDocuments.forEach(function (oneDocument) {
	                cursor = oneDocument.cursor;
	
	                var docIdFieldName = getDynamicFieldNameForDocId(cursor);
	                var docOriginFieldName = getDynamicFieldNameForDocOrigin(cursor);
	                var docTemplateFieldName = getDynamicFieldNameForDocTemplate(cursor);
	                var docLangFieldName = getDynamicFieldNameForDocLang(cursor);
	                var docTeamFieldName = getDynamicFieldNameForDocTeam(cursor);
	                var docTeamNameFieldName = getDynamicFieldNameForDocTeamName(cursor);
	                var docTeamSubgroupFieldName = getDynamicFieldNameForDocTeamSubgroup(cursor);
	                var docContractFieldName = getDynamicFieldNameForDocContractNumber(cursor);
	                var docContractIdFieldName = getDynamicFieldNameForDocContractId(cursor);
	                var docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(cursor);
	                var docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(cursor);
	                var docClaimIdFieldName = getDynamicFieldNameForDocClaimId(cursor);
	                var docClaimNumberFieldName = getDynamicFieldNameForDocClaimNumber(cursor);
	                // uploaded document related
	                var docTemporaryUploadIdFieldName = getDynamicFieldNameForTemporaryUploadId(cursor);
	                var docUploadedFileOriginalNameFieldName = getDynamicFieldNameForDocUploadedFileOriginalName(cursor);
	                var docDocumentTypeIdxFieldName = getDynamicFieldNameForDocumentTypeIdx(cursor);
	                var docDocumentUploadGroupTypeIdFieldName = getDynamicFieldNameForDocumentUploadGroupTypeId(cursor);
	                var docUploadCommentFieldName = getDynamicFieldNameForUploadComment(cursor);
	
	                // oracle document related
	                var docOracleIdFieldName = getDynamicFieldNameForDocOracleId(cursor);
	                var docOracleTypeFieldName = getDynamicFieldNameForDocOracleType(cursor);
	                var docOracleName = getDynamicFieldNameForDocOracleName(cursor);
	                var oracleDocumentUploadDate = getDynamicFieldNameForOracleDocumentUploadDate(cursor);
	                var documentSelectionTabFieldName = getDynamicFieldNameForDocSelectionTab(cursor);
	                var attachmentConnectionIdFieldName = getDynamicFieldNameAttachmentConnectionId(cursor);
	                var isAttachmentFieldName = getDynamicFieldNameIsAttachment(cursor);
	                var positionInUploadDocName = getDynamicFieldNamePositionInUploadDoc(cursor);
	                var documentSizeFieldName = getDynamicFieldNameForSize(cursor);
	                var documentEncryptedFieldName = getDynamicFieldNameForEncrypted(cursor);
	
	                flatDocumentsValueList[docIdFieldName] = oneDocument._id || "";
	                flatDocumentsValueList[docOriginFieldName] = oneDocument.origin || "";
	                flatDocumentsValueList[docTemplateFieldName] = documentTemplateOptions && documentTemplateOptions.length && (_nestedProperty2['default'].get(oneDocument, "documentTemplateId") || "") || "";
	                flatDocumentsValueList[docLangFieldName] = oneDocument.language;
	                flatDocumentsValueList[docTeamFieldName] = oneDocument.team || "";
	                flatDocumentsValueList[docTeamNameFieldName] = oneDocument.teamName || "";
	                flatDocumentsValueList[docContractFieldName] = oneDocument.contractNumber || "";
	                flatDocumentsValueList[docContractIdFieldName] = oneDocument.contractId || "";
	                flatDocumentsValueList[docTarificationIdFieldName] = oneDocument.tarificationId || "";
	                flatDocumentsValueList[docTarificationNumberFieldName] = oneDocument.tarificationNumber || "";
	                flatDocumentsValueList[docClaimIdFieldName] = oneDocument.claimId || "";
	                flatDocumentsValueList[docClaimNumberFieldName] = oneDocument.claimNumber || "";
	                flatDocumentsValueList[docTeamSubgroupFieldName] = oneDocument.teamSubgroup || "";
	                // uploaded documents
	                flatDocumentsValueList[docTemporaryUploadIdFieldName] = oneDocument.temporaryUploadId || "";
	                flatDocumentsValueList[docUploadedFileOriginalNameFieldName] = oneDocument.originalFileName || "";
	                flatDocumentsValueList[docDocumentTypeIdxFieldName] = oneDocument.documentTypeIdx || "";
	                flatDocumentsValueList[docDocumentUploadGroupTypeIdFieldName] = oneDocument.documentUploadGroupTypeId || "";
	                flatDocumentsValueList[docUploadCommentFieldName] = oneDocument.uploadComment || "";
	                // oracle related documents
	                flatDocumentsValueList[docOracleIdFieldName] = oneDocument.oracleDocumentId || "";
	                flatDocumentsValueList[docOracleTypeFieldName] = oneDocument.oracleDocumentType || "";
	                flatDocumentsValueList[docOracleName] = oneDocument.oracleDocumentName || "";
	                flatDocumentsValueList[oracleDocumentUploadDate] = oneDocument.oracleDocumentUploadDate || "";
	                flatDocumentsValueList[documentSelectionTabFieldName] = oneDocument.documentSelectionTab || "";
	                flatDocumentsValueList[attachmentConnectionIdFieldName] = oneDocument.attachmentConnectionId || "";
	                flatDocumentsValueList[isAttachmentFieldName] = oneDocument.isAttachment || false;
	                flatDocumentsValueList[positionInUploadDocName] = oneDocument.positionInUploadDoc || '';
	                flatDocumentsValueList[documentSizeFieldName] = Number(oneDocument.fileSize) || 0;
	                flatDocumentsValueList[documentEncryptedFieldName] = !oneDocument.isEncrypted || oneDocument.isEncrypted === "false" ? false : true;
	            });
	        })();
	    }
	
	    return flatDocumentsValueList;
	};
	
	exports.getFlatValueListOfDsDocumentsForForm = getFlatValueListOfDsDocumentsForForm;
	/**
	 * This function will remove values from signing fields in case documents that require signing are removed from docs list
	 * @param {*} formInputs
	 * @returns
	 */
	var removeSigningInputFieldsValues = function removeSigningInputFieldsValues(formInputs) {
	    var signingFields = ['clientEmailAddress', 'brokerEmailAddress', 'remainderInterval', 'remainderRepeats', 'firstSignerFirstName', 'firstSignerLastName', 'firstSignerPhoneNumber', 'firstSignerCountryPhoneCode'];
	
	    var _iteratorNormalCompletion6 = true;
	    var _didIteratorError6 = false;
	    var _iteratorError6 = undefined;
	
	    try {
	        for (var _iterator6 = signingFields[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	            var field = _step6.value;
	
	            formInputs[field].isRequired = false;
	            formInputs[field].value = '';
	            formInputs[field].touched = false;
	        }
	    } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion6 && _iterator6['return']) {
	                _iterator6['return']();
	            }
	        } finally {
	            if (_didIteratorError6) {
	                throw _iteratorError6;
	            }
	        }
	    }
	
	    return formInputs;
	};
	
	exports.removeSigningInputFieldsValues = removeSigningInputFieldsValues;
	/**
	 * This function wil set default values for first signer fields, reminder fields and broker email address
	 * @param {*} formInputs
	 * @param {*} packageDSDocuments
	 * @returns
	 */
	var setSigningInputFields = function setSigningInputFields(formInputs, formInitialValues, requireSmsOtpSigning) {
	    var signingFields = ['clientEmailAddress', 'brokerEmailAddress', 'remainderInterval', 'remainderRepeats', 'firstSignerFirstName', 'firstSignerLastName', 'remainderTicketInterval', 'remainderTicketRepeats'];
	
	    if (requireSmsOtpSigning) {
	        signingFields.push('firstSignerPhoneNumber', 'firstSignerCountryPhoneCode');
	    } else {
	        formInputs['firstSignerPhoneNumber'].isRequired = false;
	        formInputs['firstSignerPhoneNumber'].value = '';
	        formInputs['firstSignerPhoneNumber'].touched = false;
	        formInputs['firstSignerCountryPhoneCode'].isRequired = false;
	        formInputs['firstSignerCountryPhoneCode'].value = '';
	        formInputs['firstSignerCountryPhoneCode'].touched = false;
	    }
	
	    var _iteratorNormalCompletion7 = true;
	    var _didIteratorError7 = false;
	    var _iteratorError7 = undefined;
	
	    try {
	        for (var _iterator7 = signingFields[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	            var field = _step7.value;
	
	            if (!formInputs[field].touched) {
	                formInputs[field].isRequired = true;
	                formInputs[field].value = _nestedProperty2['default'].get(formInitialValues, field);
	                formInputs[field].touched = false;
	            }
	        }
	    } catch (err) {
	        _didIteratorError7 = true;
	        _iteratorError7 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion7 && _iterator7['return']) {
	                _iterator7['return']();
	            }
	        } finally {
	            if (_didIteratorError7) {
	                throw _iteratorError7;
	            }
	        }
	    }
	
	    return formInputs;
	};
	
	exports.setSigningInputFields = setSigningInputFields;
	/**
	* Fill the form values ins state
	* @param {*} data
	* @param {*} formInputs
	*
	* @returns formInputs - reference to formInputs object in state
	*/
	var setFormInputsByFormValues = function setFormInputsByFormValues(data, formInputs) {
	    if (!formInputs) {
	        return formInputs;
	    }
	
	    var formInputNames = Object.keys(formInputs);
	    formInputNames.forEach(function (formFieldName) {
	
	        var dataField = _nestedProperty2['default'].get(data, formFieldName);
	        var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	        formField.value = dataField;
	
	        // set back the value but this is already set by address, but must implement to see what happen
	        // so if you delete this row don't prevent tha value change caused by field Validation. (Only the deep cloning of values can solve.)
	        formInputs[formFieldName] = formField;
	    });
	
	    return formInputs;
	};
	
	exports.setFormInputsByFormValues = setFormInputsByFormValues;
	var DS_WIZARD_ERROR_CODE_GENERAL = 'DS_WIZARD_ERROR_CODE_GENERAL';
	exports.DS_WIZARD_ERROR_CODE_GENERAL = DS_WIZARD_ERROR_CODE_GENERAL;
	var DS_WIZARD_ERROR_CODE_NO_DOCUMENTS = 'DS_WIZARD_ERROR_CODE_NO_DOCUMENTS';
	exports.DS_WIZARD_ERROR_CODE_NO_DOCUMENTS = DS_WIZARD_ERROR_CODE_NO_DOCUMENTS;
	var DS_WIZARD_ERROR_CODE_TO_MUCH_DOCUMENTS = 'DS_WIZARD_ERROR_CODE_TO_MUCH_DOCUMENTS';
	exports.DS_WIZARD_ERROR_CODE_TO_MUCH_DOCUMENTS = DS_WIZARD_ERROR_CODE_TO_MUCH_DOCUMENTS;
	var DS_WIZARD_ERROR_CODE_NO_GENERATED_DOC = 'DS_WIZARD_ERROR_CODE_NO_GENERATED_DOC';
	
	exports.DS_WIZARD_ERROR_CODE_NO_GENERATED_DOC = DS_WIZARD_ERROR_CODE_NO_GENERATED_DOC;
	/**
	 * Return true if the form is valid else false.
	 * @param {*} formInputs
	 * @param {*} packageDSDocuments
	 * @param {*} DSDocumentOriginTypes
	 * @param {*} translations
	 * @returns Boolean or error messages
	 */
	var validateTheForm = function validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes) {
	    var forceTouche = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	    // every change must set the valid form
	    if (!formInputs) {
	        return false;
	    }
	
	    var hasError = [];
	    var keys = Object.keys(formInputs) || [];
	
	    // todo improve the form validity check contirioning if client is company to skip clientFirstName
	    keys.forEach(function (oneKey) {
	        if (formInputs[oneKey].error) {
	            // this if is made only for debug.
	            if (formInputs[oneKey].touched) {
	                console.warn("Form input '", oneKey, "' error: ", formInputs[oneKey].error);
	            }
	
	            if (!hasError.some(function (item) {
	                return item.code === DS_WIZARD_ERROR_CODE_GENERAL;
	            })) {
	                hasError.push({
	                    message: _('formInputsAreNotValid'),
	                    code: DS_WIZARD_ERROR_CODE_GENERAL,
	                    touched: forceTouche
	                });
	            }
	        }
	    });
	
	    // must has minimum one document for the package
	    if (!packageDSDocuments || packageDSDocuments.length === 0) {
	        console.warn("No package documents found.");
	
	        if (!hasError.some(function (item) {
	            return item.code === DS_WIZARD_ERROR_CODE_NO_DOCUMENTS;
	        })) {
	            hasError.push({
	                message: _('noDocumentsFoundInPackage'),
	                code: DS_WIZARD_ERROR_CODE_NO_DOCUMENTS,
	                touched: forceTouche
	            });
	        }
	    }
	
	    if (packageDSDocuments && packageDSDocuments.length > 15) {
	        console.warn("To much file added to the package. Max 15");
	
	        if (!hasError.some(function (item) {
	            return item.code === DS_WIZARD_ERROR_CODE_TO_MUCH_DOCUMENTS;
	        })) {
	            hasError.push({
	                message: _('toManyDocumentsAddedToThePackage'),
	                code: DS_WIZARD_ERROR_CODE_TO_MUCH_DOCUMENTS,
	                touched: forceTouche
	            });
	        }
	    }
	
	    var totalSize = packageDSDocuments.reduce(function (accumulator, currentValue) {
	        return Number(accumulator) + Number(currentValue.fileSize);
	    }, 0) / 1024 / 1024;
	
	    if (totalSize > 150) {
	        console.warn("Pacakge size exceeded  bigger than 150 MB");
	
	        if (!hasError.some(function (item) {
	            return item.code === DS_WIZARD_ERROR_CODE_NO_DOCUMENTS;
	        })) {
	            hasError.push({
	                message: _('theTotalSizeOfFilesIsMoreThanMax'),
	                code: DS_WIZARD_ERROR_CODE_NO_DOCUMENTS,
	                touched: forceTouche
	            });
	        }
	    }
	
	    var isValidTheForm = {
	        isValid: hasError.length === 0 ? true : false,
	        errors: hasError
	    };
	
	    return isValidTheForm;
	};
	
	exports.validateTheForm = validateTheForm;
	/**
	 * This function validate one field from the form.
	 * @param {*} formField - instance of input field object
	 * @param {*} forceTouch - touch anyway the input even if the value is not modified (useful on onBluer fired or onSubmit)
	 */
	var fieldValidation = function fieldValidation(formField) {
	    var forceTouch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    // required check
	    if (formField.isRequired && !formField.value) {
	        formField.error = formField.errorMessageRequired || _("fieldRequired");
	        formField.touched = forceTouch ? true : formField.touched;
	    } else {
	        // validate if "isValid" property is set
	        if (formField.isValid && formField.value) {
	            if (formField.isValid(formField.value)) {
	                formField.error = false;
	            } else {
	                formField.error = formField.errorMessage;
	                formField.touched = forceTouch ? true : formField.touched;
	            }
	        } else {
	            formField.error = false;
	            formField.touched = forceTouch ? true : formField.touched;
	        }
	    }
	
	    return formField;
	};
	
	exports.fieldValidation = fieldValidation;
	/**
	 * Validate the hole form.
	 * @param {*} formInputs
	 * @param {*} forceTouch - touch anyway the input even if the value is not modified (useful on onBluer fired or onSubmit)
	 * @returns formInputs - reference to formInputs object in state
	 */
	var formInputsValidation = function formInputsValidation(formInputs) {
	    var forceTouch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    if (!formInputs) {
	        return formInputs;
	    }
	
	    for (var currentFormFieldName in formInputs) {
	        var currentFormFiled = formInputs[currentFormFieldName];
	
	        // THIS IF MADE FOR EMAIL SERVER CONFIG for email address
	        // if (!(currentFormFieldName !== 'brokerEmailAddress' ||
	        //     (currentFormFieldName === 'brokerEmailAddress' && !currentFormFiled.error))) {
	        //         // following line make no sense, get out an d put back? Why?
	        //         formInputs[currentFormFieldName] = currentFormFiled
	        //     return
	        // }
	
	        currentFormFiled = fieldValidation(currentFormFiled, forceTouch);
	
	        // set back the value but this is already set by address, but must implement to see what happen
	        // so if you delete this row don't prevent tha value change caused by field Validation. (Only the deep cloning of values can solve.)
	        formInputs[currentFormFieldName] = currentFormFiled;
	    }
	
	    // reset the flag of form validity and return with the form inputs
	    return formInputs;
	};
	
	exports.formInputsValidation = formInputsValidation;
	/**
	 * IMPORTANT -> do not call this function separately, used in remove-DSDocumentFromThePackage only
	 * Update the form field inputs list also to be in synchronised with the documents list
	 * let docTemplateFieldName = this.getDynamicFieldNameForDocTemplate(cursor)
	 * @param {*} cursor
	 * @param {*} formInputs
	 * @param {*} packageDSDocuments
	 * @param {*} DSDocumentOriginTypes
	 * @returns
	 */
	var removeFormInputByCursor = function removeFormInputByCursor(cursor, formInputs) {
	    var docIdFieldName = getDynamicFieldNameForDocId(cursor);
	    var docOriginFieldName = getDynamicFieldNameForDocOrigin(cursor);
	    var docTemplateFieldName = getDynamicFieldNameForDocTemplate(cursor);
	    var docLangFieldName = getDynamicFieldNameForDocLang(cursor);
	    var docTeamFieldName = getDynamicFieldNameForDocTeam(cursor);
	    var docTeamNameFieldName = getDynamicFieldNameForDocTeamName(cursor);
	    var docTeamSubgroupFieldName = getDynamicFieldNameForDocTeamSubgroup(cursor);
	    var docContractFieldName = getDynamicFieldNameForDocContractNumber(cursor);
	    var docContractIdFieldName = getDynamicFieldNameForDocContractId(cursor);
	    var docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(cursor);
	    var docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(cursor);
	    var docClaimIdFieldName = getDynamicFieldNameForDocClaimId(cursor);
	    var docClaimNumberFieldName = getDynamicFieldNameForDocClaimNumber(cursor);
	    // uploaded documents
	    var docTemporaryUploadIdFieldName = getDynamicFieldNameForTemporaryUploadId(cursor);
	    var docUploadedFileOriginalNameFieldName = getDynamicFieldNameForDocUploadedFileOriginalName(cursor);
	    var docDocumentTypeIdxFieldName = getDynamicFieldNameForDocumentTypeIdx(cursor);
	    var docDocumentUploadGroupTypeIdFieldName = getDynamicFieldNameForDocumentUploadGroupTypeId(cursor);
	    var docUploadCommentFieldName = getDynamicFieldNameForUploadComment(cursor);
	    var attachmentConnectionIdFieldName = getDynamicFieldNameAttachmentConnectionId(cursor);
	    var isAttachmentFieldName = getDynamicFieldNameIsAttachment(cursor);
	    var positionInUploadDocName = getDynamicFieldNamePositionInUploadDoc(cursor);
	
	    // oracle selected
	    var docOracleIdFieldName = getDynamicFieldNameForDocOracleId(cursor);
	    var docOracleTypeFieldName = getDynamicFieldNameForDocOracleType(cursor);
	    var docOracleName = getDynamicFieldNameForDocOracleName(cursor);
	    var oracleDocumentUploadDate = getDynamicFieldNameForOracleDocumentUploadDate(cursor);
	    var documentSizeFieldName = getDynamicFieldNameForSize(cursor);
	    var documentEncryptedFieldName = getDynamicFieldNameForEncrypted(cursor);
	
	    delete formInputs[docIdFieldName];
	    delete formInputs[docOriginFieldName];
	    delete formInputs[docTemplateFieldName];
	    delete formInputs[docLangFieldName];
	    delete formInputs[docTeamFieldName];
	    delete formInputs[docTeamNameFieldName];
	    delete formInputs[docContractFieldName];
	    delete formInputs[docContractIdFieldName];
	    delete formInputs[docTarificationIdFieldName];
	    delete formInputs[docTarificationNumberFieldName];
	    delete formInputs[docClaimIdFieldName];
	    delete formInputs[docClaimNumberFieldName];
	    delete formInputs[docTeamSubgroupFieldName];
	    // uploaded documents
	    delete formInputs[docTemporaryUploadIdFieldName];
	    delete formInputs[docUploadedFileOriginalNameFieldName];
	    delete formInputs[docDocumentTypeIdxFieldName];
	    delete formInputs[docDocumentUploadGroupTypeIdFieldName];
	    delete formInputs[docUploadCommentFieldName];
	    delete formInputs[attachmentConnectionIdFieldName];
	    delete formInputs[isAttachmentFieldName];
	    delete formInputs[positionInUploadDocName];
	    // oracle documents
	    delete formInputs[docOracleIdFieldName];
	    delete formInputs[docOracleTypeFieldName];
	    delete formInputs[docOracleName];
	    delete formInputs[oracleDocumentUploadDate];
	    delete formInputs[documentSizeFieldName];
	    delete formInputs[documentEncryptedFieldName];
	
	    return formInputs;
	};
	
	exports.removeFormInputByCursor = removeFormInputByCursor;
	/**
	 * Fetch values from form by input refs.
	 * @param {*} formInputs
	 * @param {*} refs
	 * @param {*} packageDSDocuments
	 * @param {*} moduleKey
	 * @param {*} subModuleKey
	 * @returns
	 */
	var fetchFormValues = function fetchFormValues(formInputs, refs, packageDSDocuments, moduleKey, subModuleKey) {
	    var formData = {};
	    // first check the physical inputs for values
	    for (var formFieldName in formInputs) {
	        //get value from form state
	        var formFieldValue = _nestedProperty2['default'].get(formInputs, formFieldName + ".value");
	
	        // if there is no value in state than try to get from refs as to not brake old functionality
	        //react creatable select way to get value
	        formFieldValue = formFieldValue || _nestedProperty2['default'].get(refs, formFieldName + ".props.value.value");
	        // if not then react select way to get value
	        formFieldValue = formFieldValue || _nestedProperty2['default'].get(refs, formFieldName + ".state.value.value");
	
	        // if not then normal text input way to get value
	        formFieldValue = formFieldValue || _nestedProperty2['default'].get(refs, formFieldName + ".value");
	
	        formData[formFieldName] = formFieldValue;
	    }
	
	    // overwrite the non existent physical inputs, because there are form values what must be passed forward, but does not have real inputs
	    // this values are not shown in the form, because are not editable only must pass forward fot create package
	    formData["expirationOn"] = _nestedProperty2['default'].get(formInputs, "expirationOn.value");
	    formData["clientFirstName"] = _nestedProperty2['default'].get(formInputs, "clientFirstName.value");
	    formData["clientLastName"] = _nestedProperty2['default'].get(formInputs, "clientLastName.value");
	    formData["clientBirthDate"] = _nestedProperty2['default'].get(formInputs, "clientBirthDate.value");
	    formData["clientLanguageWord"] = _nestedProperty2['default'].get(formInputs, "clientLanguageWord.value");
	    formData["status"] = _nestedProperty2['default'].get(formInputs, "status.value");
	    formData["brokerEmailAddress"] = _nestedProperty2['default'].get(formInputs, "brokerEmailAddress.value");
	    formData["brokerName"] = _nestedProperty2['default'].get(formInputs, "brokerName.value");
	    formData["contractId"] = _nestedProperty2['default'].get(formInputs, "contractId.value");
	    formData["contractNumber"] = _nestedProperty2['default'].get(formInputs, "contractNumber.value");
	    formData["claimId"] = _nestedProperty2['default'].get(formInputs, "claimId.value");
	    formData["claimNumber"] = _nestedProperty2['default'].get(formInputs, "claimNumber.value");
	    formData["team"] = _nestedProperty2['default'].get(formInputs, "team.value");
	    formData["teamName"] = _nestedProperty2['default'].get(formInputs, "teamName.value");
	    formData["teamSubgroup"] = _nestedProperty2['default'].get(formInputs, "teamSubgroup.value");
	    formData["tarificationId"] = _nestedProperty2['default'].get(formInputs, "tarificationId.value");
	    formData["tarificationNumber"] = _nestedProperty2['default'].get(formInputs, "tarificationNumber.value");
	
	    // Language translated to code, don't know if this word must used,
	    // !!! TODO !!! check it for what was used th LanguageWord
	    // const clientOptionsDict = this.state.clientOptionsDict || this.props.clientOptionsDict
	    // let clientLanguage = ''
	    // if (clientOptionsDict) {
	    //     clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(formData["clientLanguageWord"], clientOptionsDict)
	    // }
	
	    formData["clientLanguage"] = _nestedProperty2['default'].get(formInputs, "clientLanguage.value");
	    // not a real input in form so must generate the value in a non natural way when fetching the form values.
	    formData["hasObligatedTarificationTemplate"] = (0, _DSWizardHelper.isATarificationAndHasAMarkedTemplate)(moduleKey, packageDSDocuments, subModuleKey);
	    formData["hasObligatedMandateTemplate"] = (0, _DSWizardHelper.isMandateAndHasAMarkedTemplate)(moduleKey, packageDSDocuments, subModuleKey);
	
	    return formData;
	};
	
	exports.fetchFormValues = fetchFormValues;
	/**
	 * This function will generate the list of input fields for state.
	 * This also will keep the values from the documents
	 * @param {*} packageDSDocuments
	 * @param {*} moduleKey
	 * @param {*} subModuleKey
	 * @param {*} DSDocumentOriginTypes
	 * @returns
	 */
	var getFormDynamicInputFieldsList = function getFormDynamicInputFieldsList(packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes) {
	    var initialDocumentFields = {};
	
	    if (packageDSDocuments) {
	        packageDSDocuments.forEach(function (oneDocument) {
	            var newField = getDynamicInputFieldByCursor(oneDocument, moduleKey, subModuleKey, DSDocumentOriginTypes);
	
	            // add field
	            initialDocumentFields = _extends({}, initialDocumentFields, newField);
	        });
	    }
	
	    return initialDocumentFields;
	};
	
	exports.getFormDynamicInputFieldsList = getFormDynamicInputFieldsList;
	/**
	 * Compose and setup the form inputs with validation an custom error messages
	 * For ex: tarification needs a special template anyway to continue the wizard.
	 * @param {*} formInitialValues - initial values for the form.
	 * @param {*} packageDSDocuments
	 * @param {*} DSDocumentOriginTypes
	 * @param {*} moduleKey - module key for init some rules for the form depending on modules key.
	 * @param {*} subModuleKey
	 * @param {*} isSignable
	 * @param {*} stakeholders
	 * @param {*} requireSmsOtpSigning
	 * @returns
	 */
	var createNewFormInputFieldsList = function createNewFormInputFieldsList(formInitialValues, packageDSDocuments, DSDocumentOriginTypes, moduleKey, subModuleKey, isSignable, stakeholders, requireSmsOtpSigning, isOffice) {
	    if (isSignable === undefined) isSignable = false;
	
	    var _extends2;
	
	    // the initial values are in state in "packageDSDocuments"
	    var dynamicInputFieldList = getFormDynamicInputFieldsList(packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes);
	
	    var packageIdFieldName = getPackageIdFieldName();
	    var clientTypeCode = _nestedProperty2['default'].get(formInitialValues, "clientTypeCode");
	    var firstSigningStakeholder = stakeholders && stakeholders.find(function (stakeholder) {
	        return stakeholder.signerNumber === '0';
	    });
	    var secondSigningStakeholder = stakeholders && stakeholders.find(function (stakeholder) {
	        return stakeholder.signerNumber === '1';
	    });
	    var brokerSigningStakeholder = stakeholders && stakeholders.find(function (stakeholder) {
	        return stakeholder.signerType === "BROKER";
	    });
	
	    var brokerSignerPhoneNumber = brokerSigningStakeholder ? spreadPhoneNumber(brokerSigningStakeholder.phoneNumber).phoneNumber : spreadPhoneNumber(_nestedProperty2['default'].get(formInitialValues, "brokerSignerPhoneNumber")).phoneNumber;
	
	    var brokerSignerCountryPhoneCode = brokerSigningStakeholder ? spreadPhoneNumber(brokerSigningStakeholder.phoneNumber).phoneCode : spreadPhoneNumber(_nestedProperty2['default'].get(formInitialValues, "brokerSignerCountryPhoneCode")).phoneCode;
	
	    return _extends((_extends2 = {}, _defineProperty(_extends2, packageIdFieldName, _extends({}, _initValueOfInput(packageIdFieldName), {
	        isRequired: false,
	        value: _nestedProperty2['default'].get(formInitialValues, packageIdFieldName)
	    })), _defineProperty(_extends2, "clientEmailAddress", _extends({}, _initValueOfInput("clientEmailAddress"), {
	        isRequired: isSignable && !isOffice,
	        isValid: function isValid(value) {
	            return value && (0, _libValidator.isAnEmail)(value);
	        },
	        errorMessage: _("invalidEmailAddress"),
	        value: isSignable ? firstSigningStakeholder ? firstSigningStakeholder.email : _nestedProperty2['default'].get(formInitialValues, 'clientEmailAddress') : ''
	    })), _defineProperty(_extends2, "clientName", _extends({}, _initValueOfInput("clientName"), {
	        isRequired: true && !isOffice,
	        errorMessage: clientTypeCode === c.CLIENT_TYPE_PERSON ? _("invalidName") : _("invalidCompanyName"),
	        value: _nestedProperty2['default'].get(formInitialValues, "clientName")
	    })), _defineProperty(_extends2, "contractNumber", _extends({}, _initValueOfInput("contractNumber"), {
	        isRequired: false,
	        errorMessage: _("invalidContractNumber"),
	        value: _nestedProperty2['default'].get(formInitialValues, "contractNumber")
	    })), _defineProperty(_extends2, "brokerNumber", _extends({}, _initValueOfInput("brokerNumber"), {
	        isRequired: true,
	        errorMessage: _("invalidBrokerNumber"),
	        value: _nestedProperty2['default'].get(formInitialValues, "brokerNumber")
	    })), _defineProperty(_extends2, "brokerEmailAddress", _extends({}, _initValueOfInput("brokerEmailAddress"), {
	        isRequired: isSignable,
	        errorMessage: _("invalidBrokerEmailAddress"),
	        isValid: function isValid(value) {
	            return value && (0, _libValidator.isAnEmail)(value);
	        },
	        value: isSignable ? _nestedProperty2['default'].get(formInitialValues, 'brokerEmailAddress') : ''
	    })), _defineProperty(_extends2, "brokerName", _extends({}, _initValueOfInput("brokerName"), {
	        isRequired: true,
	        errorMessage: _("invalidBrokerName"),
	        value: _nestedProperty2['default'].get(formInitialValues, "brokerName")
	    })), _defineProperty(_extends2, "team", _extends({}, _initValueOfInput("team"), {
	        isRequired: moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION,
	        errorMessage: _("invalidTeam"),
	        value: _nestedProperty2['default'].get(formInitialValues, "team")
	    })), _defineProperty(_extends2, "teamName", _extends({}, _initValueOfInput("teamName"), {
	        isRequired: false,
	        errorMessage: _("invalidTeamName"),
	        value: _nestedProperty2['default'].get(formInitialValues, "teamName")
	    })), _defineProperty(_extends2, "teamSubgroup", _extends({}, _initValueOfInput("teamSubgroup"), {
	        isRequired: false,
	        errorMessage: _("invalidTeamSubgroup"),
	        value: _nestedProperty2['default'].get(formInitialValues, "teamSubgroup")
	    })), _defineProperty(_extends2, "tarificationId", _extends({}, _initValueOfInput("tarificationId"), {
	        isRequired: false,
	        errorMessage: _("invalidTarificationId"),
	        value: _nestedProperty2['default'].get(formInitialValues, "tarificationId")
	    })), _defineProperty(_extends2, "tarificationNumber", _extends({}, _initValueOfInput("tarificationNumber"), {
	        isRequired: false,
	        errorMessage: _("invalidTarificationNumber"),
	        value: _nestedProperty2['default'].get(formInitialValues, "tarificationNumber")
	    })), _defineProperty(_extends2, "claimId", _extends({}, _initValueOfInput("claimId"), {
	        isRequired: false,
	        errorMessage: _("invalidClaimId"),
	        value: _nestedProperty2['default'].get(formInitialValues, "claimId")
	    })), _defineProperty(_extends2, "claimNumber", _extends({}, _initValueOfInput("claimNumber"), {
	        isRequired: false,
	        errorMessage: _("invalidClaimNumber"),
	        value: _nestedProperty2['default'].get(formInitialValues, "claimNumber")
	    })), _defineProperty(_extends2, "remainderInterval", _extends({}, _initValueOfInput("remainderInterval"), {
	        isRequired: isSignable,
	        errorMessage: _("invalidRemainderInterval"),
	        value: isSignable ? _nestedProperty2['default'].get(formInitialValues, 'remainderInterval') : ''
	    })), _defineProperty(_extends2, "remainderRepeats", _extends({}, _initValueOfInput("remainderRepeats"), {
	        isRequired: isSignable,
	        errorMessage: _("invalidRemainderRepeats"),
	        value: isSignable ? _nestedProperty2['default'].get(formInitialValues, 'remainderRepeats') : ''
	    })), _defineProperty(_extends2, "remainderTicketInterval", _extends({}, _initValueOfInput("remainderTicketInterval"), {
	        isRequired: isSignable,
	        errorMessage: _("invalidRemainderTicketInterval"),
	        value: isSignable ? _nestedProperty2['default'].get(formInitialValues, 'remainderTicketInterval') : ''
	    })), _defineProperty(_extends2, "remainderTicketRepeats", _extends({}, _initValueOfInput("remainderTicketRepeats"), {
	        isRequired: isSignable,
	        errorMessage: _("invalidRemainderTicketRepeats"),
	        value: isSignable ? _nestedProperty2['default'].get(formInitialValues, 'remainderTicketRepeats') : ''
	    })), _defineProperty(_extends2, "expirationOn", _extends({}, _initValueOfInput("expirationOn"), {
	        isRequired: true,
	        errorMessage: _("invalidExpirationOn"),
	        isValid: function isValid(value) {
	            return value && (0, _moment2['default'])(value).isValid();
	        },
	        value: _nestedProperty2['default'].get(formInitialValues, "expirationOn")
	    })), _defineProperty(_extends2, "clientFirstName", _extends({}, _initValueOfInput("clientFirstName"), {
	        isRequired: clientTypeCode === c.CLIENT_TYPE_PERSON && !isOffice ? true : false,
	        errorMessage: _("invalidClientFirstName"),
	        value: _nestedProperty2['default'].get(formInitialValues, "clientFirstName")
	    })), _defineProperty(_extends2, "clientLastName", _extends({}, _initValueOfInput("clientLastName"), {
	        isRequired: clientTypeCode === c.CLIENT_TYPE_PERSON && !isOffice ? true : false,
	        errorMessage: _("invalidClientLastName"),
	        value: _nestedProperty2['default'].get(formInitialValues, "clientLastName")
	    })), _defineProperty(_extends2, "clientBirthDate", _extends({}, _initValueOfInput("clientBirthDate"), {
	        isRequired: false,
	        errorMessage: _("invalidClientBirthDate"),
	        value: _nestedProperty2['default'].get(formInitialValues, "clientBirthDate")
	    })), _defineProperty(_extends2, "clientLanguageWord", _extends({}, _initValueOfInput("clientLanguageWord"), {
	        isRequired: false,
	        errorMessage: _("invalidClientLanguageWord"),
	        value: _nestedProperty2['default'].get(formInitialValues, "clientLanguageWord")
	    })), _defineProperty(_extends2, "clientLanguage", _extends({}, _initValueOfInput("clientLanguage"), {
	        isRequired: !isOffice ? true : false,
	        errorMessage: _("invalidClientLanguage"),
	        value: firstSigningStakeholder ? firstSigningStakeholder.language : _nestedProperty2['default'].get(formInitialValues, "clientLanguage")
	    })), _defineProperty(_extends2, "status", _extends({}, _initValueOfInput("status"), {
	        isRequired: true,
	        errorMessage: _("invalidStatus"),
	        value: _nestedProperty2['default'].get(formInitialValues, "status")
	    })), _defineProperty(_extends2, "hasObligatedTarificationTemplate", _extends({}, _initValueOfInput("hasObligatedTarificationTemplate"), {
	        isRequired: moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION,
	        errorMessage: _("noObligatedTarificationTemplateSelected"),
	        errorMessageRequired: _("noObligatedTarificationTemplateSelected"),
	        isValid: function isValid(value) {
	            return !(moduleKey == c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION && !value);
	        },
	        //value: nesProp.get(formInitialValues, "hasObligatedTarificationTemplate")
	        value: (0, _DSWizardHelper.isATarificationAndHasAMarkedTemplate)(moduleKey, packageDSDocuments, subModuleKey)
	    })), _defineProperty(_extends2, "hasObligatedMandateTemplate", _extends({}, _initValueOfInput("hasObligatedMandateTemplate"), {
	        isRequired: moduleKey === c.DS_MODULE_CLIENT_CONTRACT_PREM,
	        errorMessage: _("noObligatedMandateTemplateSelected"),
	        errorMessageRequired: _("noObligatedMandateTemplateSelected"),
	        isValid: function isValid(value) {
	            return !(moduleKey == c.DS_MODULE_CLIENT_CONTRACT_PREM && !value);
	        },
	        value: (0, _DSWizardHelper.isMandateAndHasAMarkedTemplate)(moduleKey, packageDSDocuments, subModuleKey)
	    })), _defineProperty(_extends2, "firstSignerFirstName", _extends({}, _initValueOfInput("firstSignerFirstName"), {
	        isRequired: isSignable,
	        errorMessage: _("invalidFirstSignerFirstName"),
	        value: isSignable ? firstSigningStakeholder ? firstSigningStakeholder.firstName : _nestedProperty2['default'].get(formInitialValues, 'firstSignerFirstName') : ''
	    })), _defineProperty(_extends2, "firstSignerLastName", _extends({}, _initValueOfInput("firstSignerLastName"), {
	        isRequired: isSignable,
	        errorMessage: _("invalidFirstSignerLastName"),
	        value: isSignable ? firstSigningStakeholder ? firstSigningStakeholder.lastName : _nestedProperty2['default'].get(formInitialValues, 'firstSignerLastName') : ''
	    })), _defineProperty(_extends2, "firstSignerPhoneNumber", _extends({}, _initValueOfInput("firstSignerPhoneNumber"), {
	        isRequired: requireSmsOtpSigning,
	        errorMessage: _("invalidPhoneNumber"),
	        isValid: function isValid(value) {
	            return value[0] == '0' ? value.length === 10 : value.length === 9;
	        },
	        value: requireSmsOtpSigning ? firstSigningStakeholder ? spreadPhoneNumber(firstSigningStakeholder.phoneNumber).phoneNumber : _nestedProperty2['default'].get(formInitialValues, 'firstSignerPhoneNumber') : ''
	    })), _defineProperty(_extends2, "firstSignerCountryPhoneCode", _extends({}, _initValueOfInput("firstSignerCountryPhoneCode"), {
	        isRequired: requireSmsOtpSigning,
	        errorMessage: _("invalidPhoneNumberCode"),
	        value: requireSmsOtpSigning ? firstSigningStakeholder ? spreadPhoneNumber(firstSigningStakeholder.phoneNumber).phoneCode : _nestedProperty2['default'].get(formInitialValues, 'firstSignerCountryPhoneCode') : ''
	    })), _defineProperty(_extends2, "secondSignerLastName", _extends({}, _initValueOfInput("secondSignerLastName"), {
	        isRequired: false,
	        errorMessage: _("invalidSecondSignerLastName"),
	        value: secondSigningStakeholder ? secondSigningStakeholder.lastName : ''
	    })), _defineProperty(_extends2, "secondSignerFirstName", _extends({}, _initValueOfInput("secondSignerFirstName"), {
	        isRequired: false,
	        errorMessage: _("invalidSecondSignerFirstName"),
	        value: secondSigningStakeholder ? secondSigningStakeholder.firstName : ''
	    })), _defineProperty(_extends2, "secondSignerEmailAddress", _extends({}, _initValueOfInput("secondSignerEmailAddress"), {
	        isRequired: false,
	        errorMessage: _("invalidSecondSignerEmailAddress"),
	        isValid: function isValid(value) {
	            return value && (0, _libValidator.isAnEmail)(value);
	        },
	        value: secondSigningStakeholder ? secondSigningStakeholder.email : ''
	    })), _defineProperty(_extends2, "secondSignerPhoneNumber", _extends({}, _initValueOfInput("secondSignerPhoneNumber"), {
	        isRequired: false,
	        errorMessage: _("invalidSecondSignerPhoneNumber"),
	        isValid: function isValid(value) {
	            return value[0] == '0' ? value.length === 10 : value.length === 9;
	        },
	        value: secondSigningStakeholder ? spreadPhoneNumber(secondSigningStakeholder.phoneNumber).phoneNumber : ''
	    })), _defineProperty(_extends2, "secondSignerCountryPhoneCode", _extends({}, _initValueOfInput("secondSignerCountryPhoneCode"), {
	        isRequired: false,
	        errorMessage: _("secondSignerCountryPhoneCode"),
	        value: secondSigningStakeholder ? spreadPhoneNumber(secondSigningStakeholder.phoneNumber).phoneCode : ''
	    })), _defineProperty(_extends2, "secondSignerLanguage", _extends({}, _initValueOfInput("secondSignerLanguage"), {
	        isRequired: false,
	        errorMessage: _("invalidSecondSignerLanguage"),
	        value: secondSigningStakeholder ? secondSigningStakeholder.language : _nestedProperty2['default'].get(formInitialValues, 'clientLanguage')
	    })), _defineProperty(_extends2, "brokerSignerExists", _extends({}, _initValueOfInput("brokerSignerExists"), {
	        isRequired: false,
	        errorMessage: _("brokerSignerExists"),
	        value: brokerSigningStakeholder ? true : false
	    })), _defineProperty(_extends2, "brokerSignerLastName", _extends({}, _initValueOfInput("brokerSignerLastName"), {
	        isRequired: false,
	        errorMessage: _("invalidBrokerSignerLastName"),
	        value: brokerSigningStakeholder ? brokerSigningStakeholder.lastName : ''
	    })), _defineProperty(_extends2, "brokerSignerFirstName", _extends({}, _initValueOfInput("brokerSignerFirstName"), {
	        isRequired: false,
	        errorMessage: _("invalidBrokerSignerFirstName"),
	        value: brokerSigningStakeholder ? brokerSigningStakeholder.firstName : ''
	    })), _defineProperty(_extends2, "brokerSignerLanguage", _extends({}, _initValueOfInput("brokerSignerLanguage"), {
	        isRequired: false,
	        errorMessage: _("invalidBrokerSignerLanguage"),
	        value: brokerSigningStakeholder ? brokerSigningStakeholder.language : _nestedProperty2['default'].get(formInitialValues, 'clientLanguage')
	    })), _defineProperty(_extends2, "brokerSignerPhoneNumber", _extends({}, _initValueOfInput("brokerSignerPhoneNumber"), {
	        isRequired: false,
	        errorMessage: _("invalidBrokerSignerPhoneNumber"),
	        isValid: function isValid(value) {
	            return value[0] == '0' ? value.length === 10 : value.length === 9;
	        },
	        value: brokerSignerPhoneNumber
	    })), _defineProperty(_extends2, "brokerSignerCountryPhoneCode", _extends({}, _initValueOfInput("brokerSignerCountryPhoneCode"), {
	        isRequired: false,
	        errorMessage: _("invalidBrokerSignerCountryPhoneCode"),
	        value: brokerSignerCountryPhoneCode
	    })), _extends2), dynamicInputFieldList);
	};
	
	exports.createNewFormInputFieldsList = createNewFormInputFieldsList;
	/**
	 * This function helps to find by a input-select-value a full element from options, so a value-label pair.
	 * This is necessary for react select 2 to display the label of the selected option after selection in dropdown list.
	 * @param {*} value
	 * @param {*} options
	 */
	var findItemByValueFromSelectOptions = function findItemByValueFromSelectOptions(value, options) {
	    var result = { label: value, value: value };
	
	    if (!options) {
	        return result;
	    }
	
	    var filteredByValue = options.filter(function (item) {
	        return item.value === value;
	    });
	
	    // if no result in list of options the result the subject value
	    if (!filteredByValue || filteredByValue.length === 0) {
	        return result;
	    }
	
	    // in case of match then the first match is the selected one. If there are no values then remains the subject value
	    return _nestedProperty2['default'].get(filteredByValue, "0") || result;
	};
	
	exports.findItemByValueFromSelectOptions = findItemByValueFromSelectOptions;
	/**
	 * This functino will remove all of the document related inputs from input list
	 * @param {*} formInputs
	 * @param {*} DSDocumentOriginTypes
	 * @returns
	 */
	var clearPackageDSDocumentsInputsFromForm = function clearPackageDSDocumentsInputsFromForm(formInputs, DSDocumentOriginTypes) {
	    // get not indexed filed list
	    var initialDocumentFields = getDynamicInputFieldByCursor({ cursor: "" }, "", "", DSDocumentOriginTypes);
	
	    // first check the physical inputs for values
	    for (var formFieldName in formInputs) {
	
	        var isItDocumentRelatedInput = false;
	
	        // check with regexp, the not indexed field names used with a regexp can
	        // detect an already generated field name
	        for (var oneName in initialDocumentFields) {
	            var regex = new RegExp(oneName + '\\d+$');
	            if (regex.test(formFieldName)) {
	
	                isItDocumentRelatedInput = true;
	            }
	        }
	
	        if (isItDocumentRelatedInput) {
	            delete formInputs[formFieldName];
	        }
	    }
	
	    return formInputs;
	};
	
	exports.clearPackageDSDocumentsInputsFromForm = clearPackageDSDocumentsInputsFromForm;
	/**
	 * This function will regenerate the form inputs for dynamic list of documents, without touching other form fields.
	 * This is useful to refresh the form inputs after updating the package in Mongodb, after that can be update the form.
	 * Make sure before call this function, the document values to be saved in the document list, because the
	 * the form inputs hold the current values from form, that will be overwrite by this method.
	 * @param {*} formInputs
	 * @param {*} packageDSDocuments
	 * @param {*} moduleKey
	 * @param {*} subModuleKey
	 * @param {*} DSDocumentOriginTypes
	 */
	var synchronizePackageDSDocumentsInputsFromForm = function synchronizePackageDSDocumentsInputsFromForm(formInputs, packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes) {
	    formInputs = clearPackageDSDocumentsInputsFromForm(formInputs, DSDocumentOriginTypes);
	
	    // generate and attach the list of documents inputs
	    var dynamicInputFieldList = getFormDynamicInputFieldsList(packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes);
	    formInputs = _extends({}, formInputs, dynamicInputFieldList);
	
	    return formInputs;
	};
	exports.synchronizePackageDSDocumentsInputsFromForm = synchronizePackageDSDocumentsInputsFromForm;

	// second signer fields

	// broker signer fields

	// "brokerSignerBirthDate": {...(_initValueOfInput("brokerSignerBirthDate")),
	//     isRequired: false,
	//     errorMessage: _("invalidBrokerSignerBirthDate"),
	//     value: brokerSigningStakeholder ? brokerSigningStakeholder.birthDate : moment().subtract(18, 'years').format("YYYY/MM/DD")
	// },

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x7, _x8, _x9) { var _again = true; _function: while (_again) { var object = _x7, property = _x8, receiver = _x9; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x7 = parent; _x8 = property; _x9 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _LinkDocumentModalScss = __webpack_require__(715);
	
	var _LinkDocumentModalScss2 = _interopRequireDefault(_LinkDocumentModalScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateActions = __webpack_require__(5);
	
	var _DSWizardHelper = __webpack_require__(124);
	
	var _DSWizardHelper2 = _interopRequireDefault(_DSWizardHelper);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        overflow: 'visible'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        //minHeight: '50%',
	        overflow: 'visible',
	        padding: '0',
	        wordWrap: "break-word"
	    }
	};
	
	var CONNECTIVE_ERROR = 'CONNECTIVE_ERROR';
	var NO_DOCUMENT_FOUND_ON_SERVER = 'NO_DOCUMENT_FOUND_ON_SERVER';
	var NO_DOCUMENTS_AVAILABLE_FOR_PROCESS = 'NO_DOCUMENTS_AVAILABLE_FOR_PROCESS';
	var UPLOAD_TO_ORACLE_TIMEOUT = 'UPLOAD_TO_ORACLE_TIMEOUT';
	var NO_DOCUMENT_MATCH_FOR_UPLOAD = 'NO_DOCUMENT_MATCH_FOR_UPLOAD';
	var MISSING_ARGUMENTS = 'MISSING_ARGUMENTS';
	
	/**
	 * Connect module to store
	 */
	
	var LinkDocumentModal = (function (_React$Component) {
	    _inherits(LinkDocumentModal, _React$Component);
	
	    _createClass(LinkDocumentModal, null, [{
	        key: 'propTypes',
	        value: {
	            modalIsOpen: _react2['default'].PropTypes.bool,
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func,
	            options: _react2['default'].PropTypes.object,
	            payload: _react2['default'].PropTypes.object
	        },
	        enumerable: true
	    }]);
	
	    function LinkDocumentModal(props) {
	        _classCallCheck(this, _LinkDocumentModal);
	
	        _get(Object.getPrototypeOf(_LinkDocumentModal.prototype), 'constructor', this).call(this, props);
	
	        var payload = _nestedProperty2['default'].get(props, "payload");
	        var dsdocument = _nestedProperty2['default'].get(payload, "dsdocument");
	        var clientId = _nestedProperty2['default'].get(payload, "dsdocument.package.clientId");
	
	        //this.handleKeyPress = this.handleKeyPress.bind(this);
	        this.state = {
	            contractNumbersOptions: [],
	            contractsNumberHashmap: {},
	            isLoaded: true,
	            clientLoaderAlreadyStarted: false,
	            isValidTheForm: false,
	            formInputs: {},
	            clientId: clientId,
	            step: 1,
	            dsdocument: dsdocument,
	            wizardError: false
	        };
	    }
	
	    /**
	     * Default hook for unmounting component
	     */
	
	    _createClass(LinkDocumentModal, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // document.body.removeEventListener('keyup', this.props.onCancel, false);
	            this.clearModule();
	        }
	
	        /*
	        handleKeyPress (evt) {
	            if (vkey[evt.keyCode] === '<escape>') {
	                this.props.onCancel();
	            }
	        }
	        */
	
	        /**
	         * Default hook for processing if something in props was changed
	         * @param {*} nextProps
	         * @returns
	         */
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // incoming values from outside module, or from the store
	            var payload = _nestedProperty2['default'].get(nextProps, "payload");
	            var client = _nestedProperty2['default'].get(nextProps, "client");
	            var newPropsDsdocument = _nestedProperty2['default'].get(payload, "dsdocument");
	            var stateDsdocument = _nestedProperty2['default'].get(this.state, "dsdocument");
	
	            // exceptional initialization for dsdocument, because will be updated in state after linking
	            // default is ok what is in the props
	            var dsdocument = newPropsDsdocument;
	
	            // if there is set the document in state, and is the same document like in the props,
	            // then use from the state, because there can be an updated version of the document
	            // anyway after a full document reload from outside of the module,
	            // the props will contain also the latest version of the dsdocument
	            if (newPropsDsdocument && stateDsdocument && newPropsDsdocument._id === stateDsdocument._id) {
	                dsdocument = stateDsdocument;
	            }
	
	            var clientId = _nestedProperty2['default'].get(dsdocument, "package.clientId");
	
	            // old values, mostly only for compare to detect if something was changed
	            var oldDsdocument = _nestedProperty2['default'].get(this, "props.payload.dsdocument");
	            var shouldToReinitialiseTheModule = false;
	            var willClientChange = clientId !== this.state.clientId;
	
	            // -----------------------------------------------------------------
	            // --------------------- processing section ------------------------
	            // detect client change
	            if (willClientChange) {
	                // enable initialisation
	                shouldToReinitialiseTheModule = true;
	
	                // if the client id is empty then abort the wizard
	                if (!clientId) {
	                    return this.clearModule();
	                }
	            }
	
	            var willDsDocumentChange = dsdocument && !!oldDsdocument || dsdocument && oldDsdocument && String(dsdocument._id) !== String(oldDsdocument._id);
	
	            // detect document change
	            if (willDsDocumentChange) {
	                // enable initialisation
	                shouldToReinitialiseTheModule = true;
	            }
	
	            // if there is something changed what affect the module settings, then must reinitialise.
	            if (shouldToReinitialiseTheModule) {
	                this.setState({ clientId: clientId, dsdocument: dsdocument });
	
	                this.initModule(clientId, client, dsdocument);
	            }
	            // -------------------- end of update props processing ----------------
	
	            // everything is up to date, nothing to do here
	            return true;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props,
	            // document.body.addEventListener('keyup', this.props.onCancel, false)
	            client, payload, _state, dsdocument, clientId;
	
	            return regeneratorRuntime.async(function componentDidMount$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props = this.props;
	                        client = _props.client;
	                        payload = _props.payload;
	                        _state = this.state;
	                        dsdocument = _state.dsdocument;
	                        clientId = _state.clientId;
	                        context$2$0.next = 8;
	                        return regeneratorRuntime.awrap(this.initModule(clientId, client, dsdocument));
	
	                    case 8:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Reset the module, for a new client and document
	         */
	    }, {
	        key: 'clearModule',
	        value: function clearModule() {
	            this.setState({
	                contractNumbersOptions: [], clientId: '', step: 1, contractsNumberHashmap: {},
	                wizardError: false
	            });
	        }
	
	        /**
	         * Component did mount hook. Check and load all the dependency values, init related values.
	         */
	    }, {
	        key: 'initModule',
	        value: function initModule(clientId, client, dsdocument) {
	            var dispatch, contractNumbersOptions, isRequiredContract, allNecessaryDataLoaderPromise, areThereContractNumberOptions, isChangedTheClientId, clientDataResponse, _client, contracts, _contractNumbersOptions, contractsNumberHashmap, _contractNumbersOptions2, formInitialValues, formInputs;
	
	            return regeneratorRuntime.async(function initModule$(context$2$0) {
	                var _this = this;
	
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        contractNumbersOptions = this.state.contractNumbersOptions;
	                        isRequiredContract = false;
	
	                        if (dsdocument && dsdocument.documentTemplate.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT) {
	                            isRequiredContract = true;
	                            this.setState({ step: 1 });
	                        }
	
	                        // if no contract required, jump the first step
	
	                        if (!(!isRequiredContract || dsdocument.contractId)) {
	                            context$2$0.next = 7;
	                            break;
	                        }
	
	                        this.setState({ isLoaded: true, wizardError: false, clientLoaderAlreadyStarted: false, step: 2 });
	                        return context$2$0.abrupt('return');
	
	                    case 7:
	                        allNecessaryDataLoaderPromise = [];
	                        context$2$0.prev = 8;
	                        areThereContractNumberOptions = contractNumbersOptions && contractNumbersOptions.length > 0;
	                        isChangedTheClientId = client && client.clientId !== clientId || !client;
	
	                        if (!((!areThereContractNumberOptions && !this.state.clientLoaderAlreadyStarted || isChangedTheClientId) && clientId)) {
	                            context$2$0.next = 24;
	                            break;
	                        }
	
	                        this.setState({ clientLoaderAlreadyStarted: true });
	                        context$2$0.next = 15;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClient)(clientId)));
	
	                    case 15:
	                        clientDataResponse = context$2$0.sent;
	
	                        this.setState({ clientLoaderAlreadyStarted: false });
	
	                        _client = clientDataResponse.client;
	                        contracts = _client.contracts;
	                        _contractNumbersOptions = this.getContractNumbersInOptionList(contracts);
	                        contractsNumberHashmap = this.getContractsHashmap(_contractNumbersOptions);
	
	                        this.setState({ contractNumbersOptions: _contractNumbersOptions, contractsNumberHashmap: contractsNumberHashmap, wizardError: false });
	
	                        context$2$0.next = 25;
	                        break;
	
	                    case 24:
	                        if (!areThereContractNumberOptions && !this.state.clientLoaderAlreadyStarted && client) {
	                            contracts = client.contracts;
	                            _contractNumbersOptions2 = this.getContractNumbersInOptionList(contracts);
	                            contractsNumberHashmap = this.getContractsHashmap(_contractNumbersOptions2);
	
	                            this.setState({ contractNumbersOptions: _contractNumbersOptions2, contractsNumberHashmap: contractsNumberHashmap });
	                        }
	
	                    case 25:
	                        formInitialValues = this.getFormInitialValues(dsdocument);
	                        formInputs = this.formInputFieldsList(formInitialValues);
	
	                        this.setState({ formInputs: formInputs }, function () {
	                            // reset the flag of form validity
	                            _this.setFormValidityFlag();
	                            _this.setState({ isLoaded: true });
	                        });
	
	                        context$2$0.next = 34;
	                        break;
	
	                    case 30:
	                        context$2$0.prev = 30;
	                        context$2$0.t0 = context$2$0['catch'](8);
	
	                        this.setState({ isLoaded: true, clientLoaderAlreadyStarted: false, wizardError: context$2$0.t0 && context$2$0.t0.message || JSON.stringify(context$2$0.t0) });
	                        console.warn(context$2$0.t0);
	
	                    case 34:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[8, 30]]);
	        }
	
	        /**
	         * This function prepare and return a bunch of predefined data for the form inputs indexed by form input ref names
	         */
	    }, {
	        key: 'getFormInitialValues',
	        value: function getFormInitialValues(dsdocument) {
	
	            var initialValues = {
	                "contractNumber": _nestedProperty2['default'].get(dsdocument, "contractNumber")
	            };
	
	            return initialValues;
	        }
	
	        /**
	         * One input field basic props for handle form.
	         */
	    }, {
	        key: '_inputPrototype',
	        value: function _inputPrototype() {
	            return { label: "", value: "", touched: false, error: false, isRequired: false, isValid: function isValid() {
	                    return true;
	                }, errorMessage: _("invalidInputValue") };
	        }
	
	        /**
	         * Copy one input handler object and return.
	         */
	    }, {
	        key: '_initValueOfInput',
	        value: function _initValueOfInput() {
	            var proto = JSON.parse(JSON.stringify(this._inputPrototype()));
	            proto.isValid = function () {
	                return true;
	            }; // JSON trick is not perfect to copy an object :)
	            return proto;
	        }
	
	        /**
	         * Compose and setup the form inputs with validation an custom error messages
	         * @param {*} formInitialValues - initial values for the form.
	         */
	    }, {
	        key: 'formInputFieldsList',
	        value: function formInputFieldsList(formInitialValues) {
	            return {
	                "contractNumber": _extends({}, this._initValueOfInput(), {
	                    isRequired: true,
	                    errorMessage: _("invalidContractNumber"),
	                    value: _nestedProperty2['default'].get(formInitialValues, "contractNumber")
	                })
	            };
	        }
	
	        /**
	         * Get all of the client contract numbers in a list what is digestible for react select.
	         */
	    }, {
	        key: 'getContractNumbersInOptionList',
	        value: function getContractNumbersInOptionList(contracts) {
	            var result = [];
	
	            if (!contracts || contracts.length === 0) {
	                return result;
	            }
	
	            var objKeys = Object.keys(contracts);
	            result = objKeys && objKeys.map(function (oneKey) {
	                var contractNumber = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.contractNumber");
	                var contractMainBranch = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.mainBranche");
	                var contractMainRisk = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.mainRisk");
	                var contractCompany = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.insuranceCompany");
	                var contractId = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.contractId");
	
	                return {
	                    label: contractNumber + " - " + contractMainBranch + " - " + contractMainRisk + " - " + contractCompany,
	                    value: contractNumber,
	                    contractId: contractId
	                };
	            });
	
	            return result;
	        }
	
	        /**
	         * Get contractNumber indexed contractId list.
	         */
	    }, {
	        key: 'getContractsHashmap',
	        value: function getContractsHashmap(contractNumbersOptions) {
	            var result = {};
	
	            if (!contractNumbersOptions || contractNumbersOptions.length === 0) {
	                return result;
	            }
	
	            contractNumbersOptions.forEach(function (oneContractOption) {
	                result[oneContractOption.value] = oneContractOption.contractId;
	            });
	
	            return result;
	        }
	
	        /**
	         * This function helps to find by a input-select-value a full element from options, so a value-label pair.
	         * This is necessary for react select 2 to display the label of the selected option after selection in dropdown list.
	         * @param {*} value
	         * @param {*} options
	         */
	    }, {
	        key: 'findItemByValueFromSelectOptions',
	        value: function findItemByValueFromSelectOptions(value, options) {
	            var result = { label: value, value: value };
	
	            if (!options) {
	                return result;
	            }
	
	            var filteredByValue = options.filter(function (item) {
	                return item.value === value;
	            });
	
	            // if no result in list of options the result the subject value
	            if (!filteredByValue || filteredByValue.length === 0) {
	                return result;
	            }
	
	            // in case of match then the first match is the selected one. If there are no values then remains the subject value
	            return _nestedProperty2['default'].get(filteredByValue, "0") || result;
	        }
	
	        /**
	         * Change one input value in state, validate also.
	         */
	    }, {
	        key: 'onChangeFormInput',
	        value: function onChangeFormInput(value, formFieldName) {
	            var forceTouch = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	            var callback = arguments.length <= 3 || arguments[3] === undefined ? function () {} : arguments[3];
	            var formInputs = this.state.formInputs;
	
	            //const data = this.fetchFormValues()
	
	            //get the object from state to be able to set the validity value in it.
	            var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	            // handle touch input
	            if (formField.value !== value && forceTouch === null) {
	                formField.touched = true;
	            }
	
	            if (forceTouch !== null) {
	                formField.touched = forceTouch;
	            }
	
	            // set the value
	            formField.value = value;
	
	            // set the validity in object, this will be set because it passed by address in JS
	            formField = this.fieldValidation(formField);
	
	            // this wil set back the value but implemented only for to be understandable, the value is set by address of object.
	            _nestedProperty2['default'].set(formInputs, formFieldName, formField);
	
	            // put back into the state
	            this.setState({ formInputs: formInputs }, function () {
	                callback();
	            });
	        }
	
	        /**
	         * This function validate one field from the form.
	         * @param {*} formField - instance of input field object
	         * @param {*} inputValue - the new value of input
	         * @param {*} forceTouch - touch anyway the input even if the value is not modified (useful on onBluer fired or onSubmit)
	         */
	    }, {
	        key: 'fieldValidation',
	        value: function fieldValidation(formField) {
	            var forceTouch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            // required check
	            if (formField.isRequired && !formField.value) {
	                formField.error = _("fieldRequired");
	                formField.touched = forceTouch ? true : formField.touched;
	            } else {
	                // validate if "isValid" property is set
	                if (formField.isValid) {
	                    if (formField.isValid(formField.value)) {
	                        formField.error = false;
	                    } else {
	                        formField.error = formField.errorMessage;
	                        formField.touched = forceTouch ? true : formField.touched;
	                    }
	                } else {
	                    formField.error = false;
	                    formField.touched = forceTouch ? true : formField.touched;
	                }
	            }
	
	            // reset the flag of form validity
	            this.setFormValidityFlag();
	
	            return formField;
	        }
	
	        /**
	         * Reset the flag of form validity in state by checking the formInputs in state.
	         */
	    }, {
	        key: 'setFormValidityFlag',
	        value: function setFormValidityFlag() {
	            var formInputs = _nestedProperty2['default'].get(this, "state.formInputs");
	
	            // every change must set the valid form
	            if (formInputs) {
	                var hasError = false;
	                var keys = Object.keys(formInputs) || [];
	
	                keys.forEach(function (oneKey) {
	                    if (formInputs[oneKey].error) {
	                        hasError = true;
	                    }
	                });
	
	                this.setState({ isValidTheForm: hasError ? false : true });
	
	                return hasError ? false : true;
	            }
	
	            return true;
	        }
	
	        /**
	         * Fetch values from form by input refs
	         */
	    }, {
	        key: 'fetchFormValues',
	        value: function fetchFormValues() {
	            var _this2 = this;
	
	            var formInputs = this.state.formInputs;
	
	            var formFieldNames = Object.keys(formInputs);
	            var formData = {};
	
	            formFieldNames.forEach(function (formFieldName) {
	                // react creatable select way to get value
	                var formFieldValue = _nestedProperty2['default'].get(_this2, "refs." + formFieldName + ".props.value.value");
	
	                // if not then react select way to get value
	                formFieldValue = formFieldValue || _nestedProperty2['default'].get(_this2, "refs." + formFieldName + ".state.value.value");
	
	                // if not then normal text input way to get value
	                formFieldValue = formFieldValue || _nestedProperty2['default'].get(_this2, "refs." + formFieldName + ".value");
	                formData[formFieldName] = formFieldValue;
	            });
	
	            //example: this values are not shown in the form, because are not editable only must pass forward fot create package
	            // formData["someFieldName"] = nesProp.get(formInputs, "someFieldName.value")
	
	            return formData;
	        }
	
	        /**
	         * Fill the form values ins state
	         * @param {*} data
	         * @param {*} formInputs
	         *
	         * @returns formInputs - reference to formInputs object in state
	         */
	    }, {
	        key: 'setFormInputsByFormValues',
	        value: function setFormInputsByFormValues(data, formInputs) {
	            if (!formInputs) {
	                return;
	            }
	
	            var formInputNames = Object.keys(formInputs);
	            formInputNames.forEach(function (formFieldName) {
	
	                var dataField = _nestedProperty2['default'].get(data, formFieldName);
	                var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	                formField.value = dataField;
	
	                // set back the value but this is already set by address, but must implement to see what happen
	                // so if you delete this row don't prevent tha value change caused by fieldValidation. (Only the deep cloning of values can solve.)
	                _nestedProperty2['default'].set(formInputs, formFieldName, formField);
	            });
	
	            return formInputs;
	        }
	
	        /**
	         * Validate the hole form.
	         * @param {*} data
	         * @param {*} formInputs
	         *
	         * @returns formInputs - reference to formInputs object in state
	         */
	    }, {
	        key: 'formInputsValidation',
	        value: function formInputsValidation(formInputs) {
	            var _this3 = this;
	
	            var forceTouch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            if (!formInputs) {
	                return;
	            }
	
	            var formInputNames = Object.keys(formInputs);
	            formInputNames.forEach(function (formFieldName) {
	
	                var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	                formField = _this3.fieldValidation(formField, forceTouch);
	
	                // set back the value but this is already set by address, but must implement to see what happen
	                // so if you delete this row don't prevent tha value change caused by fieldValidation. (Only the deep cloning of values can solve.)
	                _nestedProperty2['default'].set(formInputs, formFieldName, formField);
	            });
	
	            // reset the flag of form validity
	            this.setFormValidityFlag();
	
	            return formInputs;
	        }
	
	        /**
	         *
	         * @param {*} e
	         * @returns
	         */
	    }, {
	        key: 'goToStep2',
	        value: function goToStep2(e) {
	            var _this4 = this;
	
	            var _props2 = this.props;
	            var onConfirmation = _props2.onConfirmation;
	            var dispatch = _props2.dispatch;
	            var client = _props2.client;
	            var contracts = _props2.contracts;
	            var _state2 = this.state;
	            var formInputs = _state2.formInputs;
	            var dsdocument = _state2.dsdocument;
	            var contractsNumberHashmap = _state2.contractsNumberHashmap;
	
	            var data = this.fetchFormValues();
	            formInputs = this.setFormInputsByFormValues(data, formInputs);
	            var forceTouch = true;
	            formInputs = this.formInputsValidation(formInputs, forceTouch);
	
	            var isValidTheForm = this.setFormValidityFlag();
	
	            this.setState({ formInputs: formInputs });
	
	            // form validation can  prevent to step the wizard forward
	            if (!isValidTheForm) {
	                this.setState({ isLoaded: true });
	                return Promise.reject("Invalid form");
	            }
	
	            // TODO get contractId by contract number and pass it forward for update.
	            var contractNumber = _nestedProperty2['default'].get(formInputs, "contractNumber.value");
	            var contractId = contractsNumberHashmap[contractNumber];
	
	            // -------------- linking the document to contract and update it in the state -------
	            var updateDocument = {
	                _id: dsdocument._id,
	                contractNumber: contractNumber,
	                contractId: contractId
	            };
	
	            this.setState({ isLoaded: false });
	
	            return dispatch((0, _stateActions.upsertDSDocument)(updateDocument)).then(function (resultOfUpdate) {
	                resultOfUpdate['package'] = dsdocument['package'];
	                resultOfUpdate.documentTemplate = dsdocument.documentTemplate;
	
	                return _this4.setState({ dsdocument: resultOfUpdate }, function () {
	                    _this4.setState({ isLoaded: true, wizardError: false });
	                    return _this4.setState({ step: 2 });
	                });
	            })['catch'](function (err) {
	                return _this4.setState({
	                    isLoaded: true,
	                    wizardError: err && err.message || JSON.stringify(err),
	                    step: 2
	                });
	            });
	            // --------- end of linking document ----------
	        }
	
	        /**
	         * This function will find in the result of document upload a dsDocument instance by ID from the list by parsing it.
	         * @param {*} id
	         * @param {*} dataAndDocs
	         * @returns
	         */
	    }, {
	        key: 'findADocumentInListOfDocuments',
	        value: function findADocumentInListOfDocuments(documentId, dataAndDocs) {
	            // check params
	            if (!dataAndDocs || dataAndDocs.length == 0 || !documentId) {
	                return false;
	            }
	
	            // find the doc in list
	            var resultDoc = false;
	            dataAndDocs.forEach(function (oneData) {
	                if (oneData.dsDocument._id == documentId) {
	                    resultDoc = oneData.dsDocument;
	                }
	            });
	
	            return resultDoc;
	        }
	
	        /**
	         *
	         * @param {*} e
	         * @returns
	         */
	    }, {
	        key: 'goToStep3',
	        value: function goToStep3(e) {
	            var _this5 = this;
	
	            var dispatch = this.props.dispatch;
	            var dsdocument = this.state.dsdocument;
	
	            if (!dsdocument['package']._id || !dsdocument._id) {
	                return Promise.reject("Missing package id");
	            }
	
	            this.setState({ isLoaded: false });
	
	            return dispatch((0, _stateActions.uploadDocumentIfItIsSigned)(dsdocument['package']._id, dsdocument._id)).then(function (resultOfRequest) {
	
	                // in case of error response abort the
	                if (resultOfRequest && resultOfRequest.error || !resultOfRequest) {
	                    return Promise.reject(resultOfRequest);
	                }
	
	                // if no error then the response is a package
	                var dataAndDocs = _nestedProperty2['default'].get(resultOfRequest, "dataAndDocs");
	
	                // parse result list after the current document instance and update it
	                var dsdocumentTemplate = dsdocument.documentTemplate;
	
	                // overwrite the package
	                dsdocument = _this5.findADocumentInListOfDocuments(dsdocument._id, dataAndDocs);
	                // put back the package
	                dsdocument['package'] = _nestedProperty2['default'].get(resultOfRequest, "thePackage");
	                // put back the template
	                dsdocument.documentTemplate = dsdocumentTemplate;
	
	                return _this5.setState({ dsdocument: dsdocument }, function () {
	                    _this5.setState({ isLoaded: true, wizardError: false });
	                    return _this5.setState({ step: 3 });
	                });
	            })['catch'](function (err) {
	                var errorMessageToRender = err && err.statusText && _(err.statusText) || err && err.message || JSON.stringify(err);
	
	                var errorCode = err && err.statusText || '';
	
	                switch (errorCode) {
	                    case CONNECTIVE_ERROR:
	                        {
	                            errorMessageToRender = _('errorRetrievingDocumentFromConnective');
	                            break;
	                        }
	                    case NO_DOCUMENT_FOUND_ON_SERVER:
	                        {
	                            errorMessageToRender = _('documentNotFoundToUpload');
	                            break;
	                        }
	                    case NO_DOCUMENTS_AVAILABLE_FOR_PROCESS:
	                        {
	                            errorMessageToRender = _('documentNotReadyOrAlreadyUploaded');
	                            break;
	                        }
	                    case UPLOAD_TO_ORACLE_TIMEOUT:
	                        {
	                            errorMessageToRender = _('canNotTransferTheDocumentToWillemot');
	                            break;
	                        }
	                    case NO_DOCUMENT_MATCH_FOR_UPLOAD:
	                        {
	                            errorMessageToRender = _('documentNotReadyOrAlreadyUploaded');
	                            break;
	                        }
	                    case MISSING_ARGUMENTS:
	                        {
	                            errorMessageToRender = _('missingArgumentsError');
	                            break;
	                        }
	                }
	
	                return _this5.setState({
	                    isLoaded: true,
	                    wizardError: errorMessageToRender,
	                    step: 3
	                });
	            });
	            // --------- end of linking document ----------
	        }
	
	        /**
	         * Thi is the wizard step 1 content interface
	         * @returns
	         */
	    }, {
	        key: 'renderStep1',
	        value: function renderStep1(message) {
	            var _this6 = this;
	
	            var _state3 = this.state;
	            var formInputs = _state3.formInputs;
	            var contractNumbersOptions = _state3.contractNumbersOptions;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _LinkDocumentModalScss2['default'].content },
	                message,
	                _react2['default'].createElement(
	                    'div',
	                    { className: _LinkDocumentModalScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: _LinkDocumentModalScss2['default'].formLabel },
	                        _('contractNumber'),
	                        ':* '
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].formInput, _LinkDocumentModalScss2['default'].formInputCreatableSelect) },
	                        _react2['default'].createElement(_DSWizardHelper2['default'], {
	                            value: this.findItemByValueFromSelectOptions(_nestedProperty2['default'].get(formInputs, "contractNumber.value"), contractNumbersOptions),
	                            ref: 'contractNumber',
	                            name: 'contractNumber',
	                            onChange: function (value) {
	                                return _this6.onChangeFormInput(_nestedProperty2['default'].get(value, "value") || "", "contractNumber");
	                            },
	                            handleOnBlur: function (e) {
	                                var forceTouch = true;
	                                var typedValue = _nestedProperty2['default'].get(e, "target.value");
	
	                                if (typedValue) {
	                                    return _this6.onChangeFormInput(_nestedProperty2['default'].get(e, "target.value") || "", "contractNumber", forceTouch);
	                                }
	                            },
	                            options: contractNumbersOptions,
	                            isSearchable: true,
	                            isClearable: true,
	                            isMulti: false
	                        })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].errorMessageContainer, _nestedProperty2['default'].get(formInputs, "contractNumber.touched") && _nestedProperty2['default'].get(formInputs, "contractNumber.error") ? "" : _LinkDocumentModalScss2['default'].none) },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _LinkDocumentModalScss2['default'].errorMessage },
	                        _nestedProperty2['default'].get(formInputs, "contractNumber.error") && _nestedProperty2['default'].get(formInputs, "contractNumber.touched") && _nestedProperty2['default'].get(formInputs, "contractNumber.error")
	                    )
	                )
	            );
	        }
	
	        /**
	         * This function helps to use an icon on a safe way
	         */
	    }, {
	        key: 'getIcon',
	        value: function getIcon(icon) {
	            try {
	                return __webpack_require__(591)("./" + icon + '.svg');
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	
	        /**
	         * Thi is the wizard step 2 content interface
	         * @param {*} canNotBeUploaded
	         * @returns
	         */
	    }, {
	        key: 'renderStep2',
	        value: function renderStep2() {
	            var canNotBeUploaded = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	            var dsdocument = this.state.dsdocument;
	
	            if (!dsdocument || !dsdocument.documentTemplate) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    '...'
	                );
	            }
	
	            // determine if is needed to link a contract or anything, if not the skip the first step
	            var isRequiredContract = false;
	            if (dsdocument && dsdocument.documentTemplate.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT) {
	                isRequiredContract = true;
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _LinkDocumentModalScss2['default'].content },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _LinkDocumentModalScss2['default'].documentRow },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _LinkDocumentModalScss2['default'].documentColumn },
	                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].emailButtonIcon), src: this.getIcon("n-contracts_2x.png") })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _LinkDocumentModalScss2['default'].documentColumn },
	                        _("documentName"),
	                        ': ',
	                        dsdocument && dsdocument.fileName || '-'
	                    )
	                ),
	                isRequiredContract && _("dsDocumentIsLinkedSuccessfully"),
	                canNotBeUploaded ? _("theDocumentIsNotReadyForUploadYet") : _("goToNextStepToUpload")
	            );
	        }
	
	        /**
	         * Thi is the wizard step 3 content interface
	         * @returns
	         */
	    }, {
	        key: 'renderStep3',
	        value: function renderStep3() {
	            var dsdocument = this.state.dsdocument;
	
	            if (!dsdocument) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    '...'
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _LinkDocumentModalScss2['default'].content },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _LinkDocumentModalScss2['default'].documentRow },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _LinkDocumentModalScss2['default'].documentColumn },
	                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].emailButtonIcon), src: this.getIcon("n-contracts_2x.png") })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _LinkDocumentModalScss2['default'].documentColumn },
	                        _("documentName"),
	                        ': ',
	                        dsdocument.fileName
	                    )
	                ),
	                _("dsDocumentPackageUpdated"),
	                dsdocument.uploadedToOracle ? _("dsDocumentUploaded") : _("dsDocumentNotUploaded")
	            );
	        }
	
	        /**
	         * On click next button in the wizard
	         * @param {*} e
	         * @param {Boolean} closeModal
	         * @param {Boolean} canBeUploaded
	         */
	    }, {
	        key: 'onClickNext',
	        value: function onClickNext(e, closeModal, canBeUploaded) {
	            var _this7 = this;
	
	            var step = this.state.step;
	            var onConfirmation = this.props.onConfirmation;
	
	            if (step === 1) {
	                this.goToStep2(e)
	                // go forward and skip to push the upload button if the document is ready for upload BEWB-339
	                .then(function () {
	                    if (canBeUploaded) {
	                        _this7.goToStep3(e);
	                    }
	                });
	            } else {
	                if (step === 2) {
	
	                    // skip the upload step if the document is not ready for upload
	                    if (closeModal) {
	                        this.clearModule();
	                        onConfirmation(e);
	                    }
	
	                    this.goToStep3(e);
	                } else {
	                    if (step === 3) {
	                        this.clearModule();
	                        onConfirmation(e);
	                    }
	                }
	            }
	        }
	
	        /**
	        * This function determine if a document must be signed.
	        * @param {object} DSDocumentOriginTypes
	        * @param {string} origin
	        * @param {object} documentTemplate
	        * @returns
	        */
	    }, {
	        key: 'isDocumentMustBeSigned',
	        value: function isDocumentMustBeSigned(DSDocumentOriginTypes, origin) {
	            var documentTemplate = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	            switch (origin) {
	                case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD:
	                    {
	                        return true;
	                        break;
	                    }
	                case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:
	                    {
	                        return true;
	                        break;
	                    }
	                case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
	                default:
	                    {
	                        return !!(documentTemplate && documentTemplate.mustBeSigned);
	                    }
	            }
	        }
	
	        /** 
	        * This function checks if a document is signed.
	        * @param {*} document
	        * @returns
	        */
	    }, {
	        key: 'isSignedTheDocument',
	        value: function isSignedTheDocument(document) {
	            var isSigned = false;
	
	            if (document && document['package'] && document['package'].statusHistory) {
	                document['package'].statusHistory.forEach(function (oneStatus, index) {
	                    if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
	                        isSigned = true;
	                    }
	                });
	            }
	
	            return isSigned;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var _props3 = this.props;
	            var modalIsOpen = _props3.modalIsOpen;
	            var onCancel = _props3.onCancel;
	            var DSDocumentOriginTypes = _props3.DSDocumentOriginTypes;
	            var _state4 = this.state;
	            var step = _state4.step;
	            var wizardError = _state4.wizardError;
	            var dsdocument = _state4.dsdocument;
	
	            // determine modal title by doc template
	            var title = _('documentModal');
	            var message = _('linkAndUploadDescription');
	
	            // init variables
	            var mustBeSigned = true;
	            var isSigned = false;
	
	            // avoid total fall in fail
	            if (!dsdocument || !dsdocument.documentTemplate) {
	                return _react2['default'].createElement('div', null);
	            }
	
	            if (dsdocument) {
	                if (dsdocument.documentTemplate.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT) {
	                    title = _('linkContract');
	                    message = _('linkContractDescription');
	                } else if (dsdocument.documentTemplate.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS) {
	                    title = _('linkClaims');
	                    message = _('linkClaimsDescription');
	                }
	
	                // update variables by actial conditions
	                mustBeSigned = this.isDocumentMustBeSigned(DSDocumentOriginTypes, dsdocument.origin, dsdocument.documentTemplate);
	                isSigned = this.isSignedTheDocument(dsdocument);
	            }
	
	            var canBeUploaded = !mustBeSigned || mustBeSigned && isSigned;
	            // in case when the doc is not signed but can be linked then we just let to connect the contract
	            var skipStep2 = step === 2 && !canBeUploaded;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _LinkDocumentModalScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _LinkDocumentModalScss2['default'].title },
	                            title
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _LinkDocumentModalScss2['default'].contentWrapper },
	                            step === 1 && this.renderStep1(message),
	                            step === 2 && this.renderStep2(skipStep2),
	                            step === 3 && this.renderStep3(),
	                            wizardError && _react2['default'].createElement(
	                                'div',
	                                { className: _LinkDocumentModalScss2['default'].wizardError },
	                                _("wizardError"),
	                                wizardError
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _LinkDocumentModalScss2['default'].buttons },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: onCancel,
	                                        className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].cancel)
	                                    },
	                                    _('cancel')
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function (e) {
	                                            return _this8.onClickNext(e, skipStep2, canBeUploaded);
	                                        },
	                                        className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].next, _LinkDocumentModalScss2['default'].enabled)
	                                    },
	                                    step === 1 && _("link"),
	                                    step === 2 && (canBeUploaded && _("upload") || _("ok")),
	                                    step === 3 && _("done")
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _LinkDocumentModal = LinkDocumentModal;
	    LinkDocumentModal = (0, _reactRedux.connect)(function (state) {
	        return {
	            client: _nestedProperty2['default'].get(state, "DSDocuments.client"),
	            DSDocumentOriginTypes: _nestedProperty2['default'].get(state, "app.security.DigitalSignatureHardLists.DSDocumentOriginTypes")
	        };
	    })(LinkDocumentModal) || LinkDocumentModal;
	    return LinkDocumentModal;
	})(_react2['default'].Component);
	
	exports['default'] = LinkDocumentModal;
	module.exports = exports['default'];

	// determine if is needed to link a contract or anything, if not the skip the first step

	// load every dependency data if necessary

	// init form inputs, and values

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _DSWizardHelper = __webpack_require__(124);
	
	var _reactRedux = __webpack_require__(4);
	
	var _xss = __webpack_require__(1015);
	
	var _xss2 = _interopRequireDefault(_xss);
	
	// init translations
	var _ = (0, _libI18n2['default'])('dswizard');
	var TEMPLATE_ACCESS_URL = '/documentTemplates/';
	
	var OpenDocumentToFillModal = (function (_Component) {
	    _inherits(OpenDocumentToFillModal, _Component);
	
	    _createClass(OpenDocumentToFillModal, null, [{
	        key: 'propTypes',
	        value: {
	            dataForEditDocument: _react.PropTypes.any,
	            packageDSDocuments: _react.PropTypes.array,
	            stakeholders: _react.PropTypes.array,
	            isOpen: _react.PropTypes.bool,
	            style: _react.PropTypes.object,
	            contentLabel: _react.PropTypes.string,
	            lang: _react.PropTypes.string,
	            packageId: _react.PropTypes.string,
	            onCancel: _react.PropTypes.func,
	            onSave: _react.PropTypes.func,
	            didClose: _react.PropTypes.func,
	            showWarningXss: _react.PropTypes.func,
	            renderTemplateOnly: _react.PropTypes.bool,
	            extraClassNameForContainer: _react.PropTypes.any
	        },
	        enumerable: true
	    }]);
	
	    function OpenDocumentToFillModal(props) {
	        _classCallCheck(this, _OpenDocumentToFillModal);
	
	        _get(Object.getPrototypeOf(_OpenDocumentToFillModal.prototype), 'constructor', this).call(this, props);
	        this.state = {};
	        this.canvasImages = [];
	    }
	
	    /**
	    * This function will collect the values from the HTML inside the iframe
	    * @param {*} oneDocument
	    */
	
	    /**
	     * Find input value from haystack of saved values of broker inputs, if not found then return default value.
	     * @param {*} brokerFilledValues
	     * @param {*} inputName
	     * @param {*} defaultValue
	     */
	
	    _createClass(OpenDocumentToFillModal, [{
	        key: 'findBrokerInputValueByInputName',
	        value: function findBrokerInputValueByInputName(brokerFilledValues, inputName) {
	            var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	
	            if (!brokerFilledValues || brokerFilledValues.length === 0) {
	                return defaultValue;
	            }
	
	            var result = defaultValue;
	
	            brokerFilledValues.forEach(function (item) {
	                if (item.name + "" === inputName + "") {
	                    result = item.value;
	                }
	            });
	
	            return result;
	        }
	
	        /**
	         * This function will set the values for the HTML inside the iframe
	         * @param {*} oneDocument
	         */
	    }, {
	        key: 'setIframeFormInputValues',
	        value: function setIframeFormInputValues(oneDocument, dataSet) {
	            var _this = this;
	
	            var originOfElemnts = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document;
	            var brokerFilledValues = _nestedProperty2['default'].get(oneDocument, "brokerFilledValues");
	            var placeholders = _nestedProperty2['default'].get(dataSet, "placeholders") || [];
	
	            // in case of not saved values (maybe first visit of document), we can not fill nothing
	            /* if (!brokerFilledValues || brokerFilledValues.length === 0) {
	                return
	            } */
	
	            // the iframe is not reachable from some reason
	            if (!originOfElemnts) {
	                console.error("Can not set the input values automatically. DSDocument root is not reachable!");
	                return;
	            }
	
	            // find inputs in the dsdocument inframe to fill up with values
	            var inputs = originOfElemnts.getElementsByTagName("input");
	            var selects = originOfElemnts.getElementsByTagName("select");
	            var textareas = originOfElemnts.getElementsByTagName("textarea");
	
	            // The rest of types are ignored yet
	            // TODO iterate the rest of types of elements in case
	            //let optgroups = originOfElemnts.getElementsByTagName("optgroup")
	            //let datalists = originOfElemnts.getElementsByTagName("datalist")
	            //let outputs = originOfElemnts.getElementsByTagName("output")
	            // fetch input values and names
	            if (inputs && inputs.length > 0) {
	                var _loop = function () {
	                    var oneInput = inputs[i];
	
	                    // if must fill an input value from dataset
	                    placeholders.forEach(function (onePlaceholder) {
	                        oneInput.value = String(oneInput.value).replace('{{' + onePlaceholder.placeholderName + '}}', onePlaceholder.placeholderValue);
	                    });
	
	                    // } else {
	                    switch (oneInput.type) {
	                        case "checkbox":
	                            {
	                                // set checked the input by pre-saved value
	                                var savedInputValue = _this.findBrokerInputValueByInputName(brokerFilledValues, oneInput.name, Boolean(oneInput.checked));
	                                // console.log('from checkbox ', oneInput);
	                                // const attributeForConnective = oneInput.getAttribute('fieldforconnective')
	                                // if (attributeForConnective) {
	                                //     const rect = oneInput.getBoundingClientRect()
	                                //     console.log('rect', rect);
	                                //     console.log('elem value? ', oneInput.value);
	                                // }
	
	                                // prevent issues with stringy saved bool values
	                                // set the value for checkbox
	                                oneInput.checked = Boolean(savedInputValue === "false" ? false : savedInputValue);
	                                var _event = new Event('change', {
	                                    bubbles: true,
	                                    cancelable: true
	                                });
	                                oneInput.dispatchEvent(_event);
	                                break;
	                            }
	                        case "radio":
	                            {
	                                // set checked the input by pre-saved value
	                                var savedInputValue = _this.findBrokerInputValueByInputName(brokerFilledValues, oneInput.name, null);
	
	                                // prevent issues with stringy saved bool values
	                                // set the value for radio
	                                if (oneInput.value == savedInputValue) {
	                                    oneInput.checked = Boolean(savedInputValue === "false" ? false : true);
	                                }
	                                var _event2 = new Event('change', {
	                                    bubbles: true,
	                                    cancelable: true
	                                });
	                                oneInput.dispatchEvent(_event2);
	                                break;
	                            }
	
	                        default:
	                            // set checked the input by pre-saved value
	                            // console.log('from default', oneInput);
	                            // const attributeForConnective = oneInput.getAttribute('fieldforconnective')
	                            // if (attributeForConnective) {
	                            //     const rect = oneInput.getBoundingClientRect()
	                            //     console.log('rect', rect);
	                            //     console.log('elem value? ', oneInput.value);
	                            // }
	                            var signerExceptionList = ['firstSignerFirstNamePlaceholder', 'firstSignerLastNamePlaceholder', 'firstSignerEmailPlaceholder', 'secondSignerFirstNamePlaceholder', 'secondSignerLastNamePlaceholder', 'secondSignerEmailPlaceholder'];
	                            if (!signerExceptionList.includes(oneInput.name)) {
	
	                                var savedInputValue = _this.findBrokerInputValueByInputName(brokerFilledValues, oneInput.name, oneInput.value);
	                                oneInput.value = savedInputValue || oneInput.value;
	                            }
	                    }
	
	                    // }
	                };
	
	                for (var i = 0, max = inputs.length; i < max; i++) {
	                    _loop();
	                }
	            }
	
	            // fetch textareas values and names
	            if (textareas && textareas.length > 0) {
	                var _loop2 = function () {
	                    var oneTextarea = textareas[i];
	
	                    // if must fill an textarea value from dataset
	                    placeholders.forEach(function (onePlaceholder) {
	                        oneTextarea.value = String(oneTextarea.value).replace('{{' + onePlaceholder.placeholderName + '}}', onePlaceholder.placeholderValue);
	                    });
	
	                    // set checked the input by pre-saved value
	                    var savedInputValue = _this.findBrokerInputValueByInputName(brokerFilledValues, oneTextarea.name, String(oneTextarea.value).replace(/\n/g, '\\n'));
	
	                    oneTextarea.value = savedInputValue;
	                };
	
	                for (var i = 0, max = textareas.length; i < max; i++) {
	                    _loop2();
	                }
	            }
	
	            // fetch textareas values and names
	            if (selects && selects.length > 0) {
	                for (var i = 0, max = selects.length; i < max; i++) {
	                    var oneSelect = selects[i];
	
	                    var savedInputValue = this.findBrokerInputValueByInputName(brokerFilledValues, oneSelect.name, oneSelect.options[oneSelect.selectedIndex] ? oneSelect.options[oneSelect.selectedIndex].text : '');
	
	                    var optionsList = oneSelect.getElementsByTagName('option');
	                    if (optionsList && optionsList.length > 0) {
	                        for (var j = 0, max2 = optionsList.length; j < max2; j++) {
	                            if (optionsList[j].text && optionsList[j].text + "" === savedInputValue + "") {
	                                optionsList[j].selected = 'selected';
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        /**
	         * This function will set the dataSet values for the HTML inside the iframe
	         * @param {*} dataSet
	         * @param {*} oneDocument
	         */
	    }, {
	        key: 'setIframeFormDatasetValues',
	        value: function setIframeFormDatasetValues(dataSet, oneDocument, optionsList, stakeholders) {
	            var originOfElemnts = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document;
	
	            // in case of not saved values (maybe first visit of document), we can not fill nothing
	            if (!dataSet) {
	                return;
	            }
	
	            // the iframe is not reachable from some reason
	            if (!originOfElemnts) {
	                console.error("Can not set the dataSet values in DSDocument. DSDocument root is not reachable!");
	                return;
	            }
	
	            // find inputs in the dsdocument iframe to fill up with values
	
	            // TODO in case of
	            var bodyArray = originOfElemnts.getElementsByTagName("body");
	            var placeholders = _nestedProperty2['default'].get(dataSet, "placeholders");
	
	            this.fillTextNodeValuesWithDataSet(_nestedProperty2['default'].get(bodyArray, "0"), placeholders, optionsList, stakeholders);
	        }
	
	        /**
	         *
	         * @param {*} oneDocument
	         */
	    }, {
	        key: 'setIframeAnimationOnComplete',
	        value: function setIframeAnimationOnComplete(oneDocument) {
	            var that = this;
	
	            var canvasOnComplete = function canvasOnComplete(canvasIds) {
	                var canvasImages = [];
	
	                if (!canvasIds || canvasIds.length === 0) {
	                    console.warn("No 'canvasIds' array declared in the document template! Must be an Array with strings of canvas element ids.");
	                    return;
	                }
	
	                for (var i = 0; i < canvasIds.length; i++) {
	                    var img = {};
	                    var imageIndex = -1;
	                    for (var j = 0; j < canvasImages.length; j++) {
	                        var oneImage = canvasImages[j];
	                        if (oneImage.canvasId === canvasIds[i]) {
	                            imageIndex = j;
	                        }
	                    }
	
	                    if (imageIndex === -1) {
	                        canvasImages.push(img);
	                        imageIndex = canvasImages.length - 1;
	                    }
	
	                    var oneCanvas = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document.getElementById(canvasIds[i]);
	
	                    if (oneCanvas) {
	                        var scaleFactor = window.devicePixelRatio;
	
	                        var displayedWidth = oneCanvas.offsetWidth;
	                        var displayedHeight = oneCanvas.offsetHeight;
	
	                        canvasImages[imageIndex].canvasId = canvasIds[i];
	                        canvasImages[imageIndex].scaleFactor = scaleFactor; // not needed on server
	                        canvasImages[imageIndex].width = oneCanvas.width / scaleFactor;
	                        canvasImages[imageIndex].offsetWidth = displayedWidth; // not needed on server
	                        canvasImages[imageIndex].originalWidth = oneCanvas.width; // not needed on server
	                        canvasImages[imageIndex].nonScaledWidth = oneCanvas.width / scaleFactor; // not needed on server
	                        canvasImages[imageIndex].scaledOffsetWidth = displayedWidth / scaleFactor; // not needed on server
	                        canvasImages[imageIndex].height = oneCanvas.height / scaleFactor;
	                        canvasImages[imageIndex].offsetHeight = displayedHeight; // not needed on server
	                        canvasImages[imageIndex].originalHeight = oneCanvas.height; // not needed on server
	                        canvasImages[imageIndex].nonScaledHight = oneCanvas.height / scaleFactor; // not needed on server
	                        canvasImages[imageIndex].scaledOffsetHight = displayedHeight / scaleFactor; // not needed on server
	                        canvasImages[imageIndex].base64Data = oneCanvas.toDataURL("image/png").split(",")[1];
	                    }
	                }
	
	                that.canvasImages = canvasImages;
	
	                return canvasImages;
	            };
	
	            // set inner function to external scope
	            document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.canvasOnComplete = canvasOnComplete;
	        }
	
	        /**
	         *
	         * @param {*} node
	         */
	    }, {
	        key: 'fillTextNodeValuesWithDataSet',
	        value: function fillTextNodeValuesWithDataSet(node, placeholders, optionsLists, stakeholders) {
	            var patchText = function patchText(currentNode) {
	
	                // If the node is an element node, the nodeType property will return 1.
	                // If the node is an attribute node, the nodeType property will return 2.
	                // If the node is a text node, the nodeType property will return 3.
	                // If the node is a comment node, the nodeType property will return 8.
	
	                if (currentNode.nodeType === 3) {
	                    placeholders.forEach(function (onePlaceholder) {
	                        currentNode.nodeValue = String(currentNode.nodeValue).replace('{{' + onePlaceholder.placeholderName + '}}', onePlaceholder.placeholderValue);
	                    });
	                }
	
	                //Find Select placeholders and set the options lists than set selected values
	                if (currentNode.nodeName === 'SELECT') {
	                    (function () {
	                        var optionsList = currentNode.getElementsByTagName('option');
	                        var datasetPlaceHolderNameFromTemplate = currentNode.getAttribute('dataset-placeholder-name');
	                        //set options list
	                        if (datasetPlaceHolderNameFromTemplate && optionsLists) {
	                            var optionsListsArray = [];
	                            optionsListsArray = optionsLists[datasetPlaceHolderNameFromTemplate].listValues;
	
	                            //crete a first empty option
	                            var emptyOption = document.createElement('option');
	                            emptyOption.value = '';
	                            emptyOption.innerHTML = '';
	                            currentNode.appendChild(emptyOption);
	
	                            //create a nd add to options list a option for each list element from optionsListsArray
	                            if (optionsListsArray) {
	                                optionsListsArray.forEach(function (e) {
	                                    var option = document.createElement('option');
	                                    option.value = e.description;
	                                    option.innerHTML = e.description;
	                                    currentNode.appendChild(option);
	                                });
	                            }
	                        } else if (!optionsLists) {
	                            console.warn('No options lists in datasets');
	                        }
	
	                        //determine selected value
	                        placeholders.forEach(function (onePlaceholder) {
	                            if (datasetPlaceHolderNameFromTemplate === onePlaceholder.placeholderName) {
	                                if (optionsList && optionsList.length > 0) {
	                                    for (var j = 0, max2 = optionsList.length; j < max2; j++) {
	                                        if (optionsList[j].innerText && optionsList[j].innerText === onePlaceholder.placeholderValue) {
	                                            optionsList[j].selected = 'selected';
	                                        }
	                                    }
	                                }
	                            }
	                        });
	                    })();
	                }
	
	                // find placeholders in src attributes of all nodes in the page, and replace the attribute value to the placeholder value
	                if (currentNode && typeof currentNode.getAttributeNode == 'function' && currentNode.getAttributeNode("src")) {
	                    placeholders.forEach(function (onePlaceholder) {
	                        if (currentNode.getAttributeNode("src").value == '{{' + onePlaceholder.placeholderName + '}}') {
	                            currentNode.getAttributeNode("src").value = onePlaceholder.placeholderValue;
	                        }
	                    });
	                }
	                // Handle stakeholders form filling
	                if (stakeholders) {
	                    if (currentNode.nodeName === 'INPUT' && currentNode.getAttributeNode('type').value === 'text') {
	                        currentNode.value = currentNode.getAttribute('name') === 'firstSignerFirstNamePlaceholder' ? stakeholders[0].firstName : currentNode.getAttribute('name') === 'firstSignerLastNamePlaceholder' ? stakeholders[0].lastName : currentNode.value = currentNode.getAttribute('name') === 'firstSignerEmailPlaceholder' ? stakeholders[0].email : stakeholders.length > 1 ? currentNode.getAttribute('name') === 'secondSignerFirstNamePlaceholder' ? stakeholders[1].firstName : currentNode.getAttribute('name') === 'secondSignerLastNamePlaceholder' ? stakeholders[1].lastName : currentNode.getAttribute('name') === 'secondSignerEmailPlaceholder' ? stakeholders[1].email : currentNode.value : currentNode.value;
	                    }
	                }
	
	                if ((!stakeholders || stakeholders.length <= 1) && currentNode.classList && currentNode.classList.contains('{{hideSecondSignerClassPlaceholder}}')) {
	                    currentNode.classList.remove('{{hideSecondSignerClassPlaceholder}}');
	                    currentNode.classList.add('hideSecondSigner');
	                }
	            };
	            this.findNextDomeNode(node, patchText);
	        }
	
	        /**
	         *
	         * @param {*} node
	         * @param {*} cb
	         */
	    }, {
	        key: 'findNextDomeNode',
	        value: function findNextDomeNode(node, cb) {
	            cb(node);
	            node = node.firstChild;
	
	            while (node) {
	                this.findNextDomeNode(node, cb);
	                node = node.nextSibling;
	            }
	        }
	
	        /**
	         * This function will save the infill of a document to database and update error messages.
	         * @param {*} oneDocument
	         * @returns templateFromValues - the values from external template form values
	         */
	    }, {
	        key: 'saveDocumentFill',
	        value: function saveDocumentFill(oneDocument) {
	            var _props, dispatch, lang, packageId, showWarningXss, templateFormValues, externalValidationResult, connectiveFormFields, errorMessages, documentUpdateThisProps;
	
	            return regeneratorRuntime.async(function saveDocumentFill$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props = this.props;
	                        dispatch = _props.dispatch;
	                        lang = _props.lang;
	                        packageId = _props.packageId;
	                        showWarningXss = _props.showWarningXss;
	                        templateFormValues = getIframeFormInputValues(oneDocument);
	                        externalValidationResult = callIframeExternalValidation(oneDocument);
	                        connectiveFormFields = getConnectiveFormFields(oneDocument);
	                        errorMessages = [];
	
	                        // first XSS check only for notify the user, exact the same XSS filtering will be applied on server side.
	                        if (templateFormValues) {
	                            (function () {
	                                var isThereXSSFiltered = false;
	                                var suspectValues = {};
	
	                                Object.keys(templateFormValues).forEach(function (oneKey) {
	                                    if (typeof templateFormValues[oneKey].value === 'string') {
	                                        if (templateFormValues[oneKey].value !== (0, _xss2['default'])(templateFormValues[oneKey].value)) {
	                                            isThereXSSFiltered = true;
	                                            suspectValues[templateFormValues[oneKey].name] = templateFormValues[oneKey].value;
	                                            templateFormValues[oneKey].value = "";
	                                        }
	                                    }
	
	                                    // check if required some if the inputs
	                                    if (!templateFormValues[oneKey].value && templateFormValues[oneKey].required) {
	                                        errorMessages.push(templateFormValues[oneKey].requiredMessage || templateFormValues[oneKey].name + " " + _("templateFieldIsRequired"));
	                                    }
	                                });
	
	                                // validate here, validation exist if the result is not === false.
	                                if (externalValidationResult !== false && !externalValidationResult.isValid) {
	                                    // remove from result the validity flag because all of the other properties are fields with error reports
	                                    delete externalValidationResult.isValid;
	
	                                    var fieldsListWithError = Object.keys(externalValidationResult);
	
	                                    if (fieldsListWithError && fieldsListWithError.length > 0) {
	                                        fieldsListWithError.forEach(function (oneErrorKey) {
	                                            errorMessages.push(_nestedProperty2['default'].get(externalValidationResult, oneErrorKey + ".message." + lang) || _nestedProperty2['default'].get(externalValidationResult, oneErrorKey + ".message.nl") || oneErrorKey + " " + _("templateFieldIsRequired"));
	                                        });
	                                    } else {
	                                        errorMessages.push(_("unknownErrorInTemplateForm"));
	                                    }
	                                }
	
	                                // got some issue with XSS filtering
	                                if (isThereXSSFiltered) {
	                                    showWarningXss(isThereXSSFiltered, suspectValues);
	                                }
	                            })();
	                        }
	
	                        // prepare final result to update the already existing document only by the follwoing properties
	                        documentUpdateThisProps = {
	                            documentData: {
	                                _id: oneDocument._id,
	                                brokerFilledValues: templateFormValues,
	                                errorMessages: errorMessages
	                            },
	                            connectiveFormFields: connectiveFormFields
	                        };
	                        return context$2$0.abrupt('return', documentUpdateThisProps);
	
	                    case 12:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'renderContent',
	
	        /*
	        packageDSDocuments = attachIdResult.packageDSDocuments
	        // immediately update the document in state to show the actualised data on render
	        packageDSDocuments = packageDocumentsListUpdateByDocument(packageDSDocuments, updatedDocument) //sync
	         // invalid fill of template
	        if (errorMessages.length > 0) {
	            let errorInstance = new Error()
	            errorInstance.error = errorMessages
	            throw errorInstance
	        }
	         // return final promise: resolved if template filled correctly else reject it.
	        return templateFormValues */
	        value: function renderContent() {
	            var _this2 = this;
	
	            var _props2 = this.props;
	            var dataForEditDocument = _props2.dataForEditDocument;
	            var stakeholders = _props2.stakeholders;
	            var didClose = _props2.didClose;
	            var onCancel = _props2.onCancel;
	            var onSave = _props2.onSave;
	            var packageDSDocuments = _props2.packageDSDocuments;
	            var parentModule = _props2.parentModule;
	
	            var dataSet = _nestedProperty2['default'].get(dataForEditDocument, "dataSet");
	            var optionsLists = _nestedProperty2['default'].get(dataForEditDocument, "optionsLists");
	            var oneDocument = _nestedProperty2['default'].get(dataForEditDocument, "oneDocument");
	
	            if (!oneDocument || !dataSet) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    '...'
	                );
	            }
	
	            // update doc instance from the state
	            oneDocument = (0, _DSWizardHelper.findDocumentFromListById)(oneDocument._id, packageDSDocuments);
	
	            var docLang = _nestedProperty2['default'].get(oneDocument, "language");
	            var langIndex = docLang === 'nl' ? 0 : docLang === 'fr' ? 1 : 2;
	            var popupTitle = _nestedProperty2['default'].get(oneDocument, "documentTemplate.title." + (docLang || 'nl'));
	            var htmlContentLink = TEMPLATE_ACCESS_URL + _nestedProperty2['default'].get(oneDocument, "documentTemplate.templateContent.htmlPath." + langIndex);
	
	            // in case fo rerender the iframe will be reloaded, use this flag to know the state of load
	            // this.iframeLoaded = false
	
	            return _react2['default'].createElement(
	                'div',
	                {
	                    className: (0, _classnames2['default'])(_documentsScss2['default'].documentsModalContent, _documentsScss2['default'].maximizeModalContent), key: oneDocument._id + Math.random(),
	                    id: 'templateHolderDiv'
	                },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].title },
	                    _('fillDocumentModalTitle') + " - " + popupTitle
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].message },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_documentsScss2['default'].formInputContainer, _documentsScss2['default'].titleLabel) },
	                        _('fillDocumentModalContent')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_documentsScss2['default'].iframeContainer, this.props.extraClassNameForContainer) },
	                        _react2['default'].createElement('iframe', {
	                            ref: c.DSDOC_IFRAME_PRE_REF + oneDocument._id,
	                            src: htmlContentLink, width: '100%',
	                            id: c.DSDOC_IFRAME_PRE_REF + oneDocument._id,
	                            onLoad: function () {
	                                _this2.setIframeAnimationOnComplete(oneDocument);
	                                _this2.setIframeFormDatasetValues(dataSet, oneDocument, optionsLists, stakeholders);
	                                _this2.setIframeFormInputValues(oneDocument, dataSet);
	                                callIframeExternalOnFieldValuesLoaded(oneDocument);
	                            }
	                        })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalButtons },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            onClick: function () {
	                                onCancel();
	                                didClose();
	                            },
	                            className: _documentsScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            onClick: function callee$2$0(e) {
	                                var documentUpdateThisProps;
	                                return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                    while (1) switch (context$3$0.prev = context$3$0.next) {
	                                        case 0:
	                                            context$3$0.prev = 0;
	                                            context$3$0.next = 3;
	                                            return regeneratorRuntime.awrap(this.saveDocumentFill(oneDocument));
	
	                                        case 3:
	                                            documentUpdateThisProps = context$3$0.sent;
	
	                                            // console.log("canvasIds", document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.canvasIds)
	                                            // make initial call to get the canvas images by default minimum once, a further call will update the values
	                                            try {
	                                                document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.canvasOnComplete(document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.canvasIds);
	                                            } catch (err) {
	                                                console.warn("canvasOnComplete error", err);
	                                            }
	
	                                            context$3$0.next = 7;
	                                            return regeneratorRuntime.awrap(onSave(documentUpdateThisProps, this.canvasImages));
	
	                                        case 7:
	                                            context$3$0.next = 9;
	                                            return regeneratorRuntime.awrap(didClose(documentUpdateThisProps));
	
	                                        case 9:
	                                            context$3$0.next = 15;
	                                            break;
	
	                                        case 11:
	                                            context$3$0.prev = 11;
	                                            context$3$0.t0 = context$3$0['catch'](0);
	
	                                            console.error(context$3$0.t0);
	                                            didClose(context$3$0.t0.error);
	
	                                        case 15:
	                                            return context$3$0.abrupt('return');
	
	                                        case 16:
	                                        case 'end':
	                                            return context$3$0.stop();
	                                    }
	                                }, null, _this2, [[0, 11]]);
	                            },
	                            className: _documentsScss2['default'].greenButton + " enabled"
	                        },
	                        parentModule === c.WEBAPPS ? _("exportPdfForWebapps") : _("save")
	                    )
	                )
	            );
	        }
	
	        /**
	         * Content of are you sure modal
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props;
	            var style = _props3.style;
	            var isOpen = _props3.isOpen;
	            var contentLabel = _props3.contentLabel;
	            var renderTemplateOnly = _props3.renderTemplateOnly;
	
	            if (renderTemplateOnly) {
	                return this.renderContent();
	            }
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: isOpen,
	                    style: style,
	                    contentLabel: contentLabel,
	                    key: "OpenDocumentToFillModalKey"
	                },
	                this.renderContent()
	            );
	        }
	    }]);
	
	    var _OpenDocumentToFillModal = OpenDocumentToFillModal;
	    OpenDocumentToFillModal = (0, _reactRedux.connect)(function (state) {
	        return {};
	    })(OpenDocumentToFillModal) || OpenDocumentToFillModal;
	    return OpenDocumentToFillModal;
	})(_react.Component);
	
	exports['default'] = OpenDocumentToFillModal;
	var getIframeFormInputValues = function getIframeFormInputValues(oneDocument) {
	
	    var originOfElemnts = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document;
	
	    if (!originOfElemnts) {
	        return;
	    }
	
	    var inputs = originOfElemnts.getElementsByTagName("input");
	    var selects = originOfElemnts.getElementsByTagName("select");
	    var textareas = originOfElemnts.getElementsByTagName("textarea");
	
	    // The rest of types are ignored yet
	    // in case of future requirements iterate the rest of types of elements in case
	    //let optgroups = originOfElemnts.getElementsByTagName("optgroup")
	    //let datalists = originOfElemnts.getElementsByTagName("datalist")
	    //let outputs = originOfElemnts.getElementsByTagName("output")
	
	    var result = [];
	
	    // fetch input values and names
	    if (inputs && inputs.length > 0) {
	        for (var i = 0, max = inputs.length; i < max; i++) {
	            var oneInput = inputs[i];
	
	            switch (oneInput.type) {
	                case "checkbox":
	                    {
	                        result.push({
	                            name: oneInput.name,
	                            value: Boolean(oneInput.checked),
	                            inputType: "checkbox",
	                            required: !!oneInput.required,
	                            requiredMessage: oneInput.getAttribute("data-requiredmessage")
	                        });
	                        break;
	                    }
	                case "radio":
	                    if (Boolean(oneInput.checked)) {
	                        result.push({
	                            name: oneInput.name,
	                            value: oneInput.value,
	                            inputType: "radio",
	                            required: !!oneInput.required,
	                            requiredMessage: oneInput.getAttribute("data-requiredmessage")
	                        });
	                    }
	                    break;
	                default:
	                    //result.push({name: oneInput.name, value: escapeSpecialChars(oneInput.value), inputType: "text"})
	                    result.push({
	                        name: oneInput.name,
	                        value: oneInput.value,
	                        inputType: "text",
	                        required: !!oneInput.required,
	                        requiredMessage: oneInput.getAttribute("data-requiredmessage")
	                    });
	            }
	        }
	    }
	
	    // fetch textareas values and names
	    if (textareas && textareas.length > 0) {
	        for (var i = 0, max = textareas.length; i < max; i++) {
	            var oneTextarea = textareas[i];
	            result.push({
	                name: oneTextarea.name,
	                value: oneTextarea.value,
	                inputType: "textarea",
	                required: !!oneTextarea.required,
	                requiredMessage: oneTextarea.getAttribute("data-requiredmessage")
	            });
	        }
	    }
	
	    // fetch textareas values and names
	    if (selects && selects.length > 0) {
	        for (var i = 0, max = selects.length; i < max; i++) {
	            var oneSelect = selects[i];
	            var selectOptionText = oneSelect.options[oneSelect.selectedIndex].text;
	
	            //to be shown the text in the final document as when displayed in the wizard
	            result.push({
	                name: oneSelect.name,
	                value: selectOptionText,
	                inputType: "select",
	                required: !!oneSelect.required,
	                requiredMessage: oneSelect.getAttribute("data-requiredmessage")
	            });
	        }
	    }
	
	    return result;
	};
	
	exports.getIframeFormInputValues = getIframeFormInputValues;
	/**
	 * Extract fields marked for connective from the template
	 * 
	 * @param {*} oneDocument 
	 * @returns 
	 */
	var getConnectiveFormFields = function getConnectiveFormFields(oneDocument) {
	    var originOfElemnts = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document;
	
	    if (!originOfElemnts) return [];
	
	    var inputs = originOfElemnts.getElementsByTagName("input");
	
	    var result = [];
	
	    if (inputs && inputs.length > 0) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var oneInput = _step.value;
	
	                var attributeForConnective = oneInput.getAttribute('data-connectiveformfield');
	                if (attributeForConnective) {
	                    var tooltip = oneInput.getAttribute('data-tooltip');
	                    var label = oneInput.getAttribute('data-label');
	                    var isRequired = oneInput.getAttribute('data-required');
	                    var elementHeight = oneInput.clientHeight;
	                    var elementWidth = oneInput.clientWidth;
	                    var connectiveFormElement = {
	                        name: attributeForConnective,
	                        dsDocumentId: oneDocument._id,
	                        label: label || '',
	                        toolTipLabel: tooltip || '',
	                        isRequired: isRequired || false,
	                        height: Math.ceil(elementHeight * 0.8),
	                        width: Math.ceil(elementWidth * 0.8)
	                    };
	                    switch (oneInput.type) {
	                        case "checkbox":
	                            {
	                                connectiveFormElement.type = 'CheckBoxField';
	                                connectiveFormElement.defaultValue = oneInput.checked;
	                                result.push(connectiveFormElement);
	                            }
	
	                            break;
	                        case "radio":
	                            {
	                                connectiveFormElement.type = 'RadioGroup';
	                                connectiveFormElement.defaultValue = oneInput.checked;
	                                result.push(connectiveFormElement);
	                            }
	                            break;
	                        default:
	                            {
	                                connectiveFormElement.height = Math.ceil(elementHeight * 1);
	                                connectiveFormElement.width = Math.ceil(elementWidth * 0.65);
	                                connectiveFormElement.type = 'TextBoxField';
	                                connectiveFormElement.defaultValue = oneInput.value;
	                                result.push(connectiveFormElement);
	                            }
	                            break;
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return result;
	    }
	};
	
	/**
	 * get the validate function fom template
	 * @param {*} oneDocument
	 * @returns {Object} || {Boolean} - If return true then there is no validation function else return object, validation result
	 */
	var callIframeExternalValidation = function callIframeExternalValidation(oneDocument) {
	    var validationResult = false;
	
	    if (typeof document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.validate === "function") {
	        validationResult = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.validate();
	    }
	
	    return validationResult;
	};
	
	exports.callIframeExternalValidation = callIframeExternalValidation;
	/**
	 * Call the onFieldValuesLoaded external callback function. This function wll be called after
	 * the iframe field values are loaded, to give a chance to template makers to set controls read-only and/or
	 * do sime other value-related initialiations
	 * @param {*} oneDocument
	 */
	var callIframeExternalOnFieldValuesLoaded = function callIframeExternalOnFieldValuesLoaded(oneDocument) {
	
	    if (typeof document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.onFieldValuesLoaded === "function") {
	        document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.onFieldValuesLoaded();
	    }
	};
	
	exports.callIframeExternalOnFieldValuesLoaded = callIframeExternalOnFieldValuesLoaded;
	/**
	 * Get the canvasImages data fom template
	 * @param {*} oneDocument
	 * @returns {Object} || {Boolean} - If return whit canvasImages else return false, validation result
	    return format:
	    [
	        0: {
	            canvasId: <sting>,
	            base64Data: <string> base64 encoded,
	            width: <number>,
	            height: <number>
	        },
	            ... an so on, if there are more canvas elements in the template
	    ]
	 */

	// if return boolean === false then there is no validation function declared

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('dswizard');
	
	var WarningModal = (function (_Component) {
	    _inherits(WarningModal, _Component);
	
	    function WarningModal() {
	        _classCallCheck(this, WarningModal);
	
	        _get(Object.getPrototypeOf(WarningModal.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(WarningModal, [{
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var isOpen = _props.isOpen;
	            var style = _props.style;
	            var didClose = _props.didClose;
	            var warningModalOpen = _props.warningModalOpen;
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: Boolean(isOpen),
	                    style: style,
	                    contentLabel: "",
	
	                    key: "rootComponentOfDsWizardWarningModalKey"
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalContent, key: 'rootComponentOfDsWizardWarningModalContentRenderKey' },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _documentsScss2['default'].title },
	                        _('warningModalTitle')
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _documentsScss2['default'].message },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _documentsScss2['default'].resendModalContainer },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_documentsScss2['default'].formInputContainer, _documentsScss2['default'].titleLabel) },
	                                _('warningModalDescription')
	                            ),
	                            warningModalOpen && _react2['default'].createElement(
	                                'div',
	                                null,
	                                JSON.stringify(warningModalOpen)
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentsModalButtons },
	                        _react2['default'].createElement(
	                            'div',
	                            {
	                                onClick: function () {
	                                    _this.setState({ warningModalOpen: false });
	                                    didClose();
	                                },
	                                className: _documentsScss2['default'].greenButton + " enabled"
	                            },
	                            _("ok")
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            isOpen: _react.PropTypes.bool,
	            style: _react.PropTypes.object,
	            warningModalOpen: _react.PropTypes.object,
	            didClose: _react.PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    return WarningModal;
	})(_react.Component);
	
	exports['default'] = WarningModal;
	module.exports = exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	//import styles from './packageClientEmailChange.scss'
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _documentsHelpers = __webpack_require__(106);
	
	var _stateActions = __webpack_require__(5);
	
	var _libValidator = __webpack_require__(96);
	
	var _emailSenderHelpers = __webpack_require__(368);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stateActions2 = __webpack_require__(5);
	
	var _phoneCountryCodesSelectJson = __webpack_require__(446);
	
	var _phoneCountryCodesSelectJson2 = _interopRequireDefault(_phoneCountryCodesSelectJson);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _emailSenderEmailButton = __webpack_require__(108);
	
	var _emailSenderEmailButton2 = _interopRequireDefault(_emailSenderEmailButton);
	
	// init translations
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	/**
	 * Connect module to store
	 */
	
	// dsdocuments: state.DSDocuments.items,
	
	/**
	 * ClientContactInfoChangerModalForPackage class used to change the client email-address and resend the invitation email.
	 */
	
	var ClientContactInfoChangerModalForPackage = (function (_Component) {
	    _inherits(ClientContactInfoChangerModalForPackage, _Component);
	
	    _createClass(ClientContactInfoChangerModalForPackage, null, [{
	        key: 'propTypes',
	        value: {
	            dsPackage: _react.PropTypes.object,
	            triggerToOpen: _react.PropTypes.bool,
	            callBackOnClose: _react.PropTypes.func,
	            isEditableThePackage: _react.PropTypes.bool,
	            stakeholder: _react.PropTypes.object,
	            editClientEmail: _react.PropTypes.bool,
	            editClientPhoneNumber: _react.PropTypes.bool,
	            moduleKeyToSet: _react.PropTypes.string,
	            emailerModuleOptions: _react.PropTypes.object,
	            onSentEmailer: _react.PropTypes.func,
	            onInitEmailer: _react.PropTypes.func
	        },
	
	        /**
	         * Module constructor
	         * @param {*} props
	         */
	        enumerable: true
	    }]);
	
	    function ClientContactInfoChangerModalForPackage(props) {
	        _classCallCheck(this, _ClientContactInfoChangerModalForPackage);
	
	        _get(Object.getPrototypeOf(_ClientContactInfoChangerModalForPackage.prototype), 'constructor', this).call(this, props);
	        // initilaize from incoming props
	        var resendToAddress = _nestedProperty2['default'].get(props, "dsPackage.clientEmailAddress");
	        var originalPhoneNumber = _nestedProperty2['default'].get(props, 'stakeholder.phoneNumber');
	
	        this.state = {
	            clientEmailChangePopupIsOpen: false,
	            resendToAddress: resendToAddress,
	            resendingButtonDisabled: false,
	            resendToAddressValid: resendToAddress && (0, _libValidator.isAnEmail)(resendToAddress),
	            resendToAddressTouched: false,
	            changeSent: false,
	            newPhoneNumber: originalPhoneNumber,
	            newPhoneNumberValue: false,
	            newPhoneNumberTouched: false,
	            dsPackage: {},
	            step: 1,
	            emailerModuleOptions: JSON.parse(JSON.stringify(props.emailerModuleOptions)),
	            invitationSent: false
	        };
	    }
	
	    /**
	     * check if there is package data and the right package is opened
	     */
	
	    _createClass(ClientContactInfoChangerModalForPackage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props, dispatch, openedPackage, dsPackage, getPackageReq;
	
	            return regeneratorRuntime.async(function componentWillMount$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props = this.props;
	                        dispatch = _props.dispatch;
	                        openedPackage = _props.openedPackage;
	                        dsPackage = _props.dsPackage;
	                        context$2$0.prev = 4;
	
	                        if (!(!dsPackage || !dsPackage._id || dsPackage._id.toString() !== openedPackage)) {
	                            context$2$0.next = 12;
	                            break;
	                        }
	
	                        context$2$0.next = 8;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(openedPackage)));
	
	                    case 8:
	                        getPackageReq = context$2$0.sent;
	
	                        this.setState({ dsPackage: getPackageReq });
	                        context$2$0.next = 13;
	                        break;
	
	                    case 12:
	                        this.setState({ dsPackage: dsPackage });
	
	                    case 13:
	                        context$2$0.next = 18;
	                        break;
	
	                    case 15:
	                        context$2$0.prev = 15;
	                        context$2$0.t0 = context$2$0['catch'](4);
	
	                        console.warn(context$2$0.t0);
	
	                    case 18:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[4, 15]]);
	        }
	
	        /**
	         * This will render the modal content of status explainer in case of error for email editing.
	         */
	    }, {
	        key: 'clientEmailChangePopup',
	        value: function clientEmailChangePopup() {
	            var _this = this;
	
	            var _state = this.state;
	            var resendToAddress = _state.resendToAddress;
	            var resendingButtonDisabled = _state.resendingButtonDisabled;
	            var resendToAddressValid = _state.resendToAddressValid;
	            var resendToAddressTouched = _state.resendToAddressTouched;
	            var dsPackage = _state.dsPackage;
	            var changeSent = _state.changeSent;
	            var stakeholder = this.props.stakeholder;
	
	            var isDifferByOriginal = stakeholder && stakeholder.email ? resendToAddress !== stakeholder.email : resendToAddress !== _nestedProperty2['default'].get(dsPackage, "clientEmailAddress");
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].documentsModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].title },
	                    _('clientEmailChangeModalTitle')
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].message },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].resendModalContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            _('clientEmailChangeModalDescription')
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _documentsScss2['default'].formInputContainer },
	                            _react2['default'].createElement(
	                                'label',
	                                { className: _documentsScss2['default'].formLabel },
	                                _('typeANewEmailAddressToSend'),
	                                ':* '
	                            ),
	                            _react2['default'].createElement('input', {
	                                className: (0, _classnames2['default'])(_documentsScss2['default'].formInput, _documentsScss2['default'].long),
	                                type: 'text',
	                                value: resendToAddress,
	                                onChange: function (e) {
	                                    _this.changeResendEmailToAddress(e.target.value);
	                                },
	                                onBlur: function () {
	                                    _this.setState({ resendToAddressTouched: true });
	                                }
	                            })
	                        ),
	                        !changeSent && !resendToAddressValid && resendToAddressTouched && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _documentsScss2['default'].errorMessage },
	                                _('emailAddressIsRequired')
	                            )
	                        ),
	                        !changeSent && !isDifferByOriginal && resendToAddressTouched && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _documentsScss2['default'].errorMessage },
	                                _('emailAddressMustBeDifferent')
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalButtons },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            onClick: function () {
	                                // just reset triggers and states and close modal
	                                _this.closeModal();
	                            },
	                            className: _documentsScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this.setState({ changeSent: true });
	                            // update records, restart the hole Digi-Sign flow, send mail again
	                            _this.onClientEmailChange();
	                        },
	                        type: 'button',
	                        className: _documentsScss2['default'].greenButton + (resendingButtonDisabled || !resendToAddressValid ? " disabled" : " enabled"),
	                        value: _("clientEmailChange"),
	                        disabled: resendingButtonDisabled || !resendToAddressValid || !isDifferByOriginal
	                    })
	                )
	            );
	        }
	
	        /**
	         * This will render the modal content of status explainer in case of error for phone number editing.
	         */
	    }, {
	        key: 'clientPhoneNumberChangePopup',
	        value: function clientPhoneNumberChangePopup() {
	            var _this2 = this;
	
	            var _state2 = this.state;
	            var newPhoneNumber = _state2.newPhoneNumber;
	            var newPhoneNumberValid = _state2.newPhoneNumberValid;
	            var resendingButtonDisabled = _state2.resendingButtonDisabled;
	            var newPhoneNumberTouched = _state2.newPhoneNumberTouched;
	            var changeSent = _state2.changeSent;
	            var stakeholder = this.props.stakeholder;
	
	            var isDifferByOriginal = stakeholder && stakeholder.phoneNumber ? newPhoneNumber !== stakeholder.phoneNumber : false;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].documentsModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].title },
	                    _('clientPhoneNumberChangeModalTitle')
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].message },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].resendModalContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            _('clientPhoneNumberChangeModalDescription')
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _documentsScss2['default'].formInputContainer },
	                            _react2['default'].createElement(
	                                'label',
	                                { className: _documentsScss2['default'].formLabel },
	                                _('typeANewPhoneNumber'),
	                                ':* '
	                            ),
	                            _react2['default'].createElement('input', {
	                                className: (0, _classnames2['default'])(_documentsScss2['default'].formInput, _documentsScss2['default'].long),
	                                type: 'text',
	                                value: newPhoneNumber,
	                                onChange: function (e) {
	                                    _this2.changePhoneNumber(e.target.value);
	                                },
	                                onBlur: function () {
	                                    _this2.setState({ newPhoneNumberTouched: true });
	                                }
	                            })
	                        ),
	                        (!newPhoneNumber || newPhoneNumber.length === 0) && newPhoneNumberTouched && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _documentsScss2['default'].errorMessage },
	                                _('phoneNumberIsRequired')
	                            )
	                        ),
	                        newPhoneNumber && newPhoneNumber.length > 0 && !changeSent && !newPhoneNumberValid && newPhoneNumberTouched && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _documentsScss2['default'].errorMessage },
	                                _('phoneNumberIsInvalid')
	                            )
	                        ),
	                        !changeSent && !isDifferByOriginal && newPhoneNumberTouched && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _documentsScss2['default'].errorMessage },
	                                _('phoneNumberMustBeDifferent')
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalButtons },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            onClick: function () {
	                                // just reset triggers and states and close modal
	                                _this2.closeModal();
	                            },
	                            className: _documentsScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this2.setState({ changeSent: true });
	                            // update records, restart the hole Digi-Sign flow, send mail again
	                            _this2.onClientEmailChange();
	                        },
	                        type: 'button',
	                        className: _documentsScss2['default'].greenButton + (resendingButtonDisabled || !newPhoneNumberValid ? " disabled" : " enabled"),
	                        value: _("clientPhoneNumberChange"),
	                        disabled: resendingButtonDisabled || !newPhoneNumberValid || !isDifferByOriginal
	                    })
	                )
	            );
	        }
	
	        /**
	         * Change the email-address in state, validate also.
	         * @param {*} value
	         */
	    }, {
	        key: 'changeResendEmailToAddress',
	        value: function changeResendEmailToAddress(value) {
	            // check validity
	            var valid = true;
	
	            if (!value || !(0, _libValidator.isAnEmail)(value)) {
	                valid = false;
	            }
	
	            this.setState({
	                resendToAddress: value,
	                resendToAddressValid: valid
	            });
	        }
	
	        /**
	        * Change the phone number in state, validate also.
	        * @param {*} value
	        */
	    }, {
	        key: 'changePhoneNumber',
	        value: function changePhoneNumber(phoneNumber) {
	
	            //check if phone number starts with "00" or "+" than normalize it if necessary
	            if (phoneNumber.trim()[0] === "+") {
	                phoneNumber = "00" + phoneNumber.substring(1);
	            }
	
	            //check if is a number
	            var isNumber = /^\d+$/.test(phoneNumber);
	
	            //the max length for a country code in our codes list is 6
	            var maxPhoneCodeLength = 6;
	            var countryCode = phoneNumber.slice(0, maxPhoneCodeLength);
	            var countryCodeIsValid = false;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = _phoneCountryCodesSelectJson2['default'][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var code = _step.value;
	
	                    if (countryCode.startsWith(code.phoneCode)) {
	                        countryCodeIsValid = code.phoneCode;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator['return']) {
	                        _iterator['return']();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var slicedNumber = phoneNumber.slice(countryCodeIsValid.length);
	            phoneNumber = '+' + phoneNumber.substring(2);
	            this.setState({
	                newPhoneNumber: phoneNumber,
	                newPhoneNumberValid: isNumber && countryCodeIsValid && slicedNumber && slicedNumber.length === 9
	            });
	        }
	
	        /**
	         * Any case of modal close must call this function to reset states and call the callback function
	         */
	    }, {
	        key: 'closeModal',
	        value: function closeModal() {
	            var callBackOnClose = this.props.callBackOnClose;
	            var resendToAddress = this.state.resendToAddress;
	
	            this.setState({ resendToAddressTouched: false,
	                clientEmailChangePopupIsOpen: false,
	                resendingButtonDisabled: false,
	                resendToAddress: "",
	                changeSent: false,
	                newPhoneNumber: "",
	                newPhoneNumberTouched: false,
	                step: 1
	            });
	
	            //anyway must called to reset external trigger also for modal opening
	            callBackOnClose();
	        }
	
	        /**
	         * This function triggered by modal confirmation button (ok button)
	         */
	    }, {
	        key: 'onClientEmailChange',
	        value: function onClientEmailChange() {
	            var _state3, resendToAddress, dsPackage, newPhoneNumber, emailerModuleOptions, _props2, dispatch, stakeholder, isEditableThePackage, editClientEmail, editClientPhoneNumber, userProcess, isDifferByOriginal, noLoader, j;
	
	            return regeneratorRuntime.async(function onClientEmailChange$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _state3 = this.state;
	                        resendToAddress = _state3.resendToAddress;
	                        dsPackage = _state3.dsPackage;
	                        newPhoneNumber = _state3.newPhoneNumber;
	                        emailerModuleOptions = _state3.emailerModuleOptions;
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        stakeholder = _props2.stakeholder;
	                        isEditableThePackage = _props2.isEditableThePackage;
	                        editClientEmail = _props2.editClientEmail;
	                        editClientPhoneNumber = _props2.editClientPhoneNumber;
	                        userProcess = undefined;
	
	                        this.setState({ resendingButtonDisabled: true });
	
	                        // no modification no update (optimisation)
	                        isDifferByOriginal = undefined;
	
	                        if (editClientEmail) {
	                            isDifferByOriginal = stakeholder && stakeholder.email ? resendToAddress !== stakeholder.email : resendToAddress !== _nestedProperty2['default'].get(dsPackage, "clientEmailAddress");
	                            userProcess = c.DSDOCUMENT_EMAIL_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS;
	                        } else if (editClientPhoneNumber) {
	                            isDifferByOriginal = stakeholder && stakeholder.phoneNumber ? newPhoneNumber !== stakeholder.email : false;
	                            userProcess = c.DSDOCUMENT_PHONE_NUMBER_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS;
	                        }
	
	                        if (isDifferByOriginal) {
	                            context$2$0.next = 18;
	                            break;
	                        }
	
	                        this.closeModal();
	                        return context$2$0.abrupt('return');
	
	                    case 18:
	                        context$2$0.prev = 18;
	
	                        dispatch((0, _stateActions.showLoader)());
	                        context$2$0.next = 22;
	                        return regeneratorRuntime.awrap(this.updateSigner());
	
	                    case 22:
	                        if (isEditableThePackage) {
	                            context$2$0.next = 32;
	                            break;
	                        }
	
	                        noLoader = true;
	                        context$2$0.next = 26;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.executeFullDSDocumentWizardOnServer)(_nestedProperty2['default'].get(dsPackage, "_id"), userProcess, noLoader)));
	
	                    case 26:
	                        context$2$0.next = 28;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(_nestedProperty2['default'].get(dsPackage, "_id"))));
	
	                    case 28:
	                        dsPackage = context$2$0.sent;
	
	                        // update
	                        for (j = 0; j < dsPackage.dsStakeholders.length; j++) {
	                            if (stakeholder._id === dsPackage.dsStakeholders[j]._id) {
	                                stakeholder.email = dsPackage.dsStakeholders[j].email;
	                            }
	                        }
	
	                        for (j = 0; j < emailerModuleOptions.stakeholders.length; j++) {
	                            if (stakeholder._id === emailerModuleOptions.stakeholders[j]._id) {
	                                emailerModuleOptions.stakeholders[j].email = stakeholder.email;
	                            }
	                        }
	
	                        for (j = 0; j < emailerModuleOptions.clientEmails.length; j++) {
	                            if (stakeholder._id === emailerModuleOptions.clientEmails[j].referenceId) {
	                                emailerModuleOptions.clientEmails[j].value = stakeholder.email;
	                            }
	                        }
	
	                    case 32:
	
	                        // dispatch(setNotification(_("success"), 'info'))
	                        dispatch((0, _stateActions.hideLoader)());
	                        context$2$0.next = 41;
	                        break;
	
	                    case 35:
	                        context$2$0.prev = 35;
	                        context$2$0.t0 = context$2$0['catch'](18);
	
	                        // TODO show an advanced error for the user if the process fail somewhere
	                        dispatch((0, _stateActions.hideLoader)());
	                        console.error(context$2$0.t0);
	                        dispatch((0, _stateActions2.setNotification)(JSON.stringify(context$2$0.t0), 'error'));
	                        this.closeModal();
	
	                    case 41:
	
	                        this.setState({ dsPackage: dsPackage, step: 2, emailerModuleOptions: emailerModuleOptions });
	                        return context$2$0.abrupt('return');
	
	                    case 43:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[18, 35]]);
	        }
	    }, {
	        key: 'updateSigner',
	        value: function updateSigner() {
	            var _state4, resendToAddress, dsPackage, newPhoneNumber, _props3, dispatch, stakeholder, editClientPhoneNumber, editClientEmail;
	
	            return regeneratorRuntime.async(function updateSigner$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _state4 = this.state;
	                        resendToAddress = _state4.resendToAddress;
	                        dsPackage = _state4.dsPackage;
	                        newPhoneNumber = _state4.newPhoneNumber;
	                        _props3 = this.props;
	                        dispatch = _props3.dispatch;
	                        stakeholder = _props3.stakeholder;
	                        editClientPhoneNumber = _props3.editClientPhoneNumber;
	                        editClientEmail = _props3.editClientEmail;
	
	                        if (!editClientEmail) {
	                            context$2$0.next = 15;
	                            break;
	                        }
	
	                        if (!stakeholder) {
	                            context$2$0.next = 12;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return', dispatch((0, _stateActions.updateDSStakeholder)({
	                            stakeholderId: _nestedProperty2['default'].get(stakeholder, "_id"),
	                            email: resendToAddress
	                        })));
	
	                    case 12:
	                        return context$2$0.abrupt('return', dispatch((0, _stateActions.updateDSDocumentPackage)({
	                            _id: _nestedProperty2['default'].get(dsPackage, "_id"),
	                            clientEmailAddress: resendToAddress
	                        })));
	
	                    case 15:
	                        if (!editClientPhoneNumber) {
	                            context$2$0.next = 17;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return', dispatch((0, _stateActions.updateDSStakeholder)({
	                            stakeholderId: _nestedProperty2['default'].get(stakeholder, "_id"),
	                            phoneNumber: newPhoneNumber
	                        })));
	
	                    case 17:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props4 = this.props;
	            var triggerToOpen = _props4.triggerToOpen;
	            var opened = _props4.opened;
	            var dsPackage = this.state.dsPackage;
	
	            var stakeholder = _nestedProperty2['default'].get(nextProps, 'stakeholder');
	
	            var resendToAddress = _nestedProperty2['default'].get(nextProps, "dsPackage.clientEmailAddress");
	            var newPhoneNumber = undefined;
	            if (stakeholder) {
	                resendToAddress = stakeholder.email;
	                newPhoneNumber = stakeholder.phoneNumber;
	            }
	
	            // take action only when props set true
	            if (nextProps.triggerToOpen !== triggerToOpen) {
	                if (nextProps.triggerToOpen) {
	                    this.setState({
	                        resendToAddress: resendToAddress, newPhoneNumber: newPhoneNumber,
	                        clientEmailChangePopupIsOpen: true
	                    });
	                }
	            }
	
	            // check if document content modified
	            var newPackage = _nestedProperty2['default'].get(nextProps, "dsPackage");
	            if (newPackage) {
	
	                if (newPackage._id !== dsPackage._id) {
	                    this.setState({ dsPackage: newPackage });
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: 'renderCustomizeInvitationEmails',
	        value: function renderCustomizeInvitationEmails() {
	            var _this3 = this;
	
	            var _state5 = this.state;
	            var resendToAddress = _state5.resendToAddress;
	            var resendingButtonDisabled = _state5.resendingButtonDisabled;
	            var resendToAddressValid = _state5.resendToAddressValid;
	            var resendToAddressTouched = _state5.resendToAddressTouched;
	            var changeSent = _state5.changeSent;
	            var emailerModuleOptions = _state5.emailerModuleOptions;
	            var invitationSent = _state5.invitationSent;
	            var _props5 = this.props;
	            var stakeholder = _props5.stakeholder;
	            var moduleKeyToSet = _props5.moduleKeyToSet;
	            var dispatch = _props5.dispatch;
	
	            var isDifferByOriginal = stakeholder && stakeholder.email ? resendToAddress !== stakeholder.email : resendToAddress !== _nestedProperty2['default'].get(dsPackage, "clientEmailAddress");
	            var dsPackage = this.props.dsPackage;
	
	            var that = this;
	
	            var wasPending = false;
	            dsPackage.statusHistory.forEach(function (oneStatus) {
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_PENDING) {
	                    wasPending = true;
	                }
	            });
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].documentsModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].title },
	                    _('clientEmailChangeModalTitle')
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].message },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].resendModalContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            !invitationSent ? _('clientEmailChangeModalInvitationDescription') : _('clientEmailChangeModalDoneDescription')
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalButtons },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            onClick: function () {
	                                // just reset triggers and states and close modal
	                                _this3.closeModal();
	                            },
	                            className: _documentsScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    !invitationSent && dsPackage.dsStakeholders && wasPending && _react2['default'].createElement(_emailSenderEmailButton2['default'], {
	                        customButtonLabel: _('customizeInvitationEmail'),
	                        isWhiteIcon: true,
	                        modalId: c.EMAILER_MODAL_ID_EDIT_EMAIL_OF_PACAKGE,
	                        hideCC: true,
	                        multiLanguage: true,
	                        serialSending: true,
	                        isCreatable: false,
	                        forceIsMulti: true,
	                        key: "customizeInvitationRenderEmailSenderButtonFromEmailChangerKey",
	                        onInit: function () {
	                            _this3.props.onInitEmailer();
	                        },
	                        onSentLate: function callee$2$0(responses) {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        context$3$0.next = 2;
	                                        return regeneratorRuntime.awrap(that.props.onSentEmailer(responses, dsPackage, dsPackage.dsStakeholders));
	
	                                    case 2:
	                                        dsPackage = context$3$0.sent;
	
	                                        that.setState({ invitationSent: true });
	
	                                    case 4:
	                                    case 'end':
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this3);
	                        },
	                        moduleKeyToSet: moduleKeyToSet,
	                        moduleOptions: emailerModuleOptions,
	                        getDSStakeholders: function callee$2$0(stakeholderIdArray) {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        context$3$0.next = 2;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions2.getDSStakeholders)(stakeholderIdArray)));
	
	                                    case 2:
	                                        return context$3$0.abrupt('return', context$3$0.sent);
	
	                                    case 3:
	                                    case 'end':
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this3);
	                        },
	                        customClassName: _documentsScss2['default'].greenButton + " enabled"
	                    }) || _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this3.closeModal();
	                        },
	                        type: 'button',
	                        className: _documentsScss2['default'].greenButton + " enabled",
	                        value: _("ok")
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props6 = this.props;
	            var editClientEmail = _props6.editClientEmail;
	            var editClientPhoneNumber = _props6.editClientPhoneNumber;
	            var _state6 = this.state;
	            var clientEmailChangePopupIsOpen = _state6.clientEmailChangePopupIsOpen;
	            var step = _state6.step;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: Boolean(clientEmailChangePopupIsOpen),
	                        contentLabel: '',
	                        style: _documentsHelpers.customModalStyles
	                    },
	                    step == 1 && editClientEmail && this.clientEmailChangePopup(),
	                    step == 1 && editClientPhoneNumber && this.clientPhoneNumberChangePopup(),
	                    step == 2 && this.renderCustomizeInvitationEmails()
	                )
	            );
	        }
	    }]);
	
	    var _ClientContactInfoChangerModalForPackage = ClientContactInfoChangerModalForPackage;
	    ClientContactInfoChangerModalForPackage = (0, _reactRedux.connect)(function (state) {
	        return {
	            openedPackage: state.DSDocuments.openedPackage };
	    })(ClientContactInfoChangerModalForPackage) || ClientContactInfoChangerModalForPackage;
	    return ClientContactInfoChangerModalForPackage;
	})(_react.Component);
	
	exports['default'] = ClientContactInfoChangerModalForPackage;
	module.exports = exports['default'];

	// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
	// in case of the package is editable, that is mean not set the pending status for connective, so we don't want
	// to finish the process.
	// show/hide spiner

	// update stakeholder email if the package preceds the stakeholder functionality we will use old implementation

	// update client email in package, this automatically will refresh the list of documents also
	// this logic only apply for old packages before introduction of two signers

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _DSWizardHelperScss = __webpack_require__(196);
	
	var _DSWizardHelperScss2 = _interopRequireDefault(_DSWizardHelperScss);
	
	var _DSWizardHelper = __webpack_require__(124);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _documentsHelpers = __webpack_require__(106);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	/**
	 * This module render a button witch can be used to link or upload DSDocument
	 */
	
	var LinkAndUploadButton = (function (_React$Component) {
	    _inherits(LinkAndUploadButton, _React$Component);
	
	    _createClass(LinkAndUploadButton, null, [{
	        key: 'propTypes',
	        value: {
	            dsDocument: _react2['default'].PropTypes.object,
	            templates: _react2['default'].PropTypes.array,
	            openLinkAndUploadWizard: _react2['default'].PropTypes.func,
	            key: _react2['default'].PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    function LinkAndUploadButton(props) {
	        _classCallCheck(this, _LinkAndUploadButton);
	
	        _get(Object.getPrototypeOf(_LinkAndUploadButton.prototype), 'constructor', this).call(this, props);
	        this.state = {};
	    }
	
	    /**
	     * This function fired when the module attached
	     */
	
	    _createClass(LinkAndUploadButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	
	        /**
	         * This function handle the onclick on action button for a DSDocument
	         * @param {*} dsDocument
	         */
	    }, {
	        key: 'onDSDocumentActionClick',
	        value: function onDSDocumentActionClick(dsDocument) {
	            // no document cancel action
	            if (!dsDocument) {
	                return false;
	            }
	
	            var buttonTextForAction = '';
	
	            switch (true) {
	                case (0, _documentsHelpers.shouldToLinkWithContract)(dsDocument):
	                    {
	                        buttonTextForAction = _("linkContract");
	                        break;
	                    }
	                case (0, _documentsHelpers.shouldToLinkWithClaim)(dsDocument):
	                    {
	                        buttonTextForAction = _("linkClaim");
	                        break;
	                    }
	                case (0, _documentsHelpers.shouldToLinkWithTarification)(dsDocument):
	                    {
	                        buttonTextForAction = _("linkTarification");
	                        break;
	                    }
	            }
	
	            // open wizard to link and upload document
	            return this.openLinkAndUploadWizard(dsDocument);
	        }
	
	        /**
	         *
	         * @param {*} dsDocument
	         */
	    }, {
	        key: 'openLinkAndUploadWizard',
	        value: function openLinkAndUploadWizard(dsDocument) {
	            this.props.openLinkAndUploadWizard(dsDocument);
	        }
	
	        /**
	         * This function will return with a translated text for the action button by processing a document record.
	         * @param {Object} dsDocument
	         * @returns String - the text of the button for action.
	         */
	    }, {
	        key: 'determineActionButtonText',
	        value: function determineActionButtonText(dsDocument) {
	            var buttonTextForAction = '';
	
	            switch (true) {
	                case (0, _documentsHelpers.shouldToLinkWithContract)(dsDocument):
	                    {
	                        buttonTextForAction = _("linkContract");
	                        break;
	                    }
	                case (0, _documentsHelpers.shouldToLinkWithClaim)(dsDocument):
	                    {
	                        buttonTextForAction = _("linkClaim");
	                        break;
	                    }
	                case (0, _documentsHelpers.shouldToLinkWithTarification)(dsDocument):
	                    {
	                        buttonTextForAction = _("linkTarification");
	                        break;
	                    }
	                default:
	                    {
	                        buttonTextForAction = _("uploadDocument");
	                    }
	            }
	
	            return buttonTextForAction;
	        }
	
	        /**
	         * Main render function
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var dsDocument = _props.dsDocument;
	            var templates = _props.templates;
	            var key = _props.key;
	            var DSDocumentOriginTypes = _props.DSDocumentOriginTypes;
	
	            // avoid total fall in fail
	            if (!dsDocument) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    '...'
	                );
	            }
	
	            var documentTemplateId = _nestedProperty2['default'].get(dsDocument, "documentTemplateId");
	            var docTemplateArray = templates && templates.filter(function (oneTemplate) {
	                return String(oneTemplate._id) === String(documentTemplateId);
	            }) || false;
	
	            var documentTemplate = docTemplateArray && docTemplateArray[0] || false;
	            var mustBeSigned = (0, _DSWizardHelper.isDocumentMustBeSigned)(DSDocumentOriginTypes, dsDocument.origin, documentTemplate);
	            var isSigned = (0, _documentsHelpers.isSignedTheDocument)(dsDocument);
	            // only in case when the value is FALSE should be uneditable, else the package is an older version instance or editable else not editable so false.
	            // so FALSE mean false only, rest of the values means editable or old version of package where this value is not set, that means must checked other conditions
	            var packageIsEditable = dsDocument && dsDocument['package'] && dsDocument['package'].isEditable === false ? false : true;
	
	            return _react2['default'].createElement(
	                'div',
	                { key: key },
	                !dsDocument.uploadedToOracle && (!mustBeSigned || mustBeSigned && isSigned || (0, _documentsHelpers.shouldToLinkWithContract)(dsDocument)) && !packageIsEditable ? _react2['default'].createElement(
	                    'button',
	                    { className: (0, _classnames2['default'])(_documentsScss2['default'].greenButton, "enabled"),
	                        onClick: function (ev) {
	                            ev.stopPropagation();
	                            return _this.onDSDocumentActionClick(dsDocument);
	                        } },
	                    this.determineActionButtonText(dsDocument)
	                ) : ""
	            );
	        }
	    }]);
	
	    var _LinkAndUploadButton = LinkAndUploadButton;
	    LinkAndUploadButton = (0, _reactRedux.connect)(function (state) {
	        return {
	            DSDocumentOriginTypes: _nestedProperty2['default'].get(state, "app.security.DigitalSignatureHardLists.DSDocumentOriginTypes")
	        };
	    })(LinkAndUploadButton) || LinkAndUploadButton;
	    return LinkAndUploadButton;
	})(_react2['default'].Component);
	
	exports['default'] = LinkAndUploadButton;
	module.exports = exports['default'];

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _LinkDocumentModalScss = __webpack_require__(715);
	
	var _LinkDocumentModalScss2 = _interopRequireDefault(_LinkDocumentModalScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _stateActions = __webpack_require__(5);
	
	var _DSWizardHelper = __webpack_require__(124);
	
	var _DSWizardHelper2 = _interopRequireDefault(_DSWizardHelper);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _DSWizard = __webpack_require__(595);
	
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        overflow: 'visible'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        //minHeight: '50%',
	        overflow: 'visible',
	        padding: '0',
	        wordWrap: "break-word"
	    }
	};
	
	var CONNECTIVE_ERROR = 'CONNECTIVE_ERROR';
	var NO_DOCUMENT_FOUND_ON_SERVER = 'NO_DOCUMENT_FOUND_ON_SERVER';
	var NO_DOCUMENTS_AVAILABLE_FOR_PROCESS = 'NO_DOCUMENTS_AVAILABLE_FOR_PROCESS';
	var UPLOAD_TO_ORACLE_TIMEOUT = 'UPLOAD_TO_ORACLE_TIMEOUT';
	var NO_DOCUMENT_MATCH_FOR_UPLOAD = 'NO_DOCUMENT_MATCH_FOR_UPLOAD';
	var MISSING_ARGUMENTS = 'MISSING_ARGUMENTS';
	
	/**
	 * Connect module to store
	 */
	
	var LinkDocumentsModal = (function (_React$Component) {
	    _inherits(LinkDocumentsModal, _React$Component);
	
	    _createClass(LinkDocumentsModal, null, [{
	        key: 'propTypes',
	        value: {
	            modalIsOpen: _react2['default'].PropTypes.bool,
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func,
	            options: _react2['default'].PropTypes.object,
	            payload: _react2['default'].PropTypes.object
	        },
	        enumerable: true
	    }]);
	
	    function LinkDocumentsModal(props) {
	        _classCallCheck(this, _LinkDocumentsModal);
	
	        _get(Object.getPrototypeOf(_LinkDocumentsModal.prototype), 'constructor', this).call(this, props);
	
	        var payload = _nestedProperty2['default'].get(props, "payload");
	        var dsPackage = _nestedProperty2['default'].get(payload, "dsPackage");
	        var clientId = dsPackage ? _nestedProperty2['default'].get(payload, 'dsPackage.clientId') : '';
	
	        //this.handleKeyPress = this.handleKeyPress.bind(this);
	        this.state = {
	            contractNumbersOptions: [],
	            contractsNumberHashmap: {},
	            isLoaded: true,
	            clientLoaderAlreadyStarted: false,
	            isValidTheForm: false,
	            formInputs: {},
	            clientId: clientId,
	            step: 1,
	            dsPackage: dsPackage,
	            wizardError: false,
	            dsDocumentsThatRequireLinking: [],
	            selectedDsDocumentIds: [],
	            linkedDocuments: []
	        };
	    }
	
	    /**
	     * Default hook for unmounting component
	     */
	
	    _createClass(LinkDocumentsModal, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearModule();
	        }
	
	        /**
	         * Default hook for processing if something in props was changed
	         * @param {*} nextProps
	         * @returns
	         */
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // incoming values from outside module, or from the store
	            var payload = _nestedProperty2['default'].get(nextProps, "payload");
	            var client = _nestedProperty2['default'].get(nextProps, "client");
	            var newPropsDsPackage = _nestedProperty2['default'].get(payload, "dsPackage");
	            var dsPackage = newPropsDsPackage;
	
	            var clientId = _nestedProperty2['default'].get(dsPackage, "clientId");
	
	            // old values, mostly only for compare to detect if something was changed
	            var oldDsPackage = _nestedProperty2['default'].get(this, "props.payload.dsPackage");
	            var shouldReinitializeTheModule = false;
	            var willClientChange = clientId !== this.state.clientId;
	
	            // -----------------------------------------------------------------
	            // --------------------- processing section ------------------------
	            // detect client change
	            if (willClientChange) {
	                // enable initialization
	                shouldReinitializeTheModule = true;
	
	                // if the client id is empty then abort the wizard
	                if (!clientId) {
	                    return this.clearModule();
	                }
	            }
	            //detect package change
	            var willDsPackageChange = dsPackage && !!oldDsPackage || dsPackage && oldDsPackage && String(dsPackage._id) !== String(oldDsPackage._id);
	
	            // detect document change
	            if (willDsPackageChange) {
	                // enable initialization
	                shouldReinitializeTheModule = true;
	            }
	
	            // if there is something changed what affect the module settings, then must reinitialize.
	            if (shouldReinitializeTheModule) {
	                this.setState({ clientId: clientId, dsPackage: dsPackage });
	                this.initModule(clientId, client, dsPackage);
	            }
	            // -------------------- end of update props processing ----------------
	
	            // everything is up to date, nothing to do here
	            return true;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // document.body.addEventListener('keyup', this.props.onCancel, false)
	            var _props = this.props;
	            var client = _props.client;
	            var payload = _props.payload;
	            var _state = this.state;
	            var clientId = _state.clientId;
	            var dsPackage = _state.dsPackage;
	
	            this.initModule(clientId, client, dsPackage);
	        }
	
	        /**
	         * Reset the module, for a new client and document
	         */
	    }, {
	        key: 'clearModule',
	        value: function clearModule() {
	            this.setState({
	                contractNumbersOptions: [],
	                contractsNumberHashmap: {},
	                isLoaded: true,
	                clientLoaderAlreadyStarted: false,
	                isValidTheForm: false,
	                formInputs: {},
	                step: 1,
	                wizardError: false,
	                dsDocumentsThatRequireLinking: [],
	                selectedDsDocumentIds: [],
	                linkedDocuments: []
	            });
	        }
	
	        /**
	         * Component did mount hook. Check and load all the dependency values, init related values.
	         */
	    }, {
	        key: 'initModule',
	        value: function initModule(clientId, client, dsPackage) {
	            var dispatch, _state2, contractNumbersOptions, dsDocumentsThatRequireLinking, areThereContractNumberOptions, isChangedTheClientId, newDsDocumentsThatRequireLinking, fetchClientResult, _client, contracts, _contractNumbersOptions, contractsNumberHashmap, _contractNumbersOptions2, oneDocument, formInitialValues, formInputs;
	
	            return regeneratorRuntime.async(function initModule$(context$2$0) {
	                var _this = this;
	
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        context$2$0.prev = 0;
	                        dispatch = this.props.dispatch;
	                        _state2 = this.state;
	                        contractNumbersOptions = _state2.contractNumbersOptions;
	                        dsDocumentsThatRequireLinking = _state2.dsDocumentsThatRequireLinking;
	                        areThereContractNumberOptions = contractNumbersOptions && contractNumbersOptions.length > 0;
	                        isChangedTheClientId = client && client.clientId !== clientId || !client;
	
	                        if (dsPackage) {
	                            context$2$0.next = 9;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return');
	
	                    case 9:
	                        if (dsPackage.requireLinking) {
	                            context$2$0.next = 13;
	                            break;
	                        }
	
	                        this.setState({ isLoaded: true, wizardError: false });
	                        this.setState({ clientLoaderAlreadyStarted: false });
	
	                        return context$2$0.abrupt('return', this.setState({ step: 2 }));
	
	                    case 13:
	
	                        this.setState({ isLoaded: false });
	                        this.setState({ clientLoaderAlreadyStarted: false });
	                        // reset step to step 1 because must linked the contract number
	                        this.setState({ step: 1 });
	
	                        if (dsPackage && (!dsDocumentsThatRequireLinking || dsDocumentsThatRequireLinking.length === 0)) {
	                            newDsDocumentsThatRequireLinking = dsPackage.dsDocuments.filter(function (oneDocument) {
	                                return oneDocument.documentTemplate && oneDocument.documentTemplate.uploadedOnModule === "DS_MODULE_CLIENT_CONTRACT" && !oneDocument.contractId;
	                            });
	
	                            this.setState({ dsDocumentsThatRequireLinking: newDsDocumentsThatRequireLinking });
	                        }
	
	                        if (!((!areThereContractNumberOptions && !this.state.clientLoaderAlreadyStarted || isChangedTheClientId) && clientId)) {
	                            context$2$0.next = 30;
	                            break;
	                        }
	
	                        this.setState({ clientLoaderAlreadyStarted: true });
	                        context$2$0.next = 21;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClient)(clientId)));
	
	                    case 21:
	                        fetchClientResult = context$2$0.sent;
	                        _client = fetchClientResult.client;
	                        contracts = _client.contracts;
	                        _contractNumbersOptions = this.getContractNumbersInOptionList(contracts);
	                        contractsNumberHashmap = this.getContractsHashmap(_contractNumbersOptions);
	
	                        this.setState({ clientLoaderAlreadyStarted: false });
	                        this.setState({ contractNumbersOptions: _contractNumbersOptions, contractsNumberHashmap: contractsNumberHashmap, wizardError: false }, function () {});
	
	                        context$2$0.next = 31;
	                        break;
	
	                    case 30:
	                        if (!areThereContractNumberOptions && !this.state.clientLoaderAlreadyStarted && client) {
	                            contracts = client.contracts;
	                            _contractNumbersOptions2 = this.getContractNumbersInOptionList(contracts);
	                            contractsNumberHashmap = this.getContractsHashmap(_contractNumbersOptions2);
	
	                            this.setState({ contractNumbersOptions: _contractNumbersOptions2, contractsNumberHashmap: contractsNumberHashmap }, function () {
	                                resolve();
	                            });
	                        }
	
	                    case 31:
	                        oneDocument = dsDocumentsThatRequireLinking && dsDocumentsThatRequireLinking[0] ? dsDocumentsThatRequireLinking[0] : '';
	                        formInitialValues = this.getFormInitialValues(oneDocument);
	                        formInputs = this.formInputFieldsList(formInitialValues);
	
	                        this.setState({ formInputs: formInputs }, function () {
	                            // reset the flag of form validity
	                            _this.setFormValidityFlag();
	                            _this.setState({ isLoaded: true });
	                        });
	                        context$2$0.next = 41;
	                        break;
	
	                    case 37:
	                        context$2$0.prev = 37;
	                        context$2$0.t0 = context$2$0['catch'](0);
	
	                        console.warn("promises err", context$2$0.t0);
	                        this.setState({ clientLoaderAlreadyStarted: false, wizardError: context$2$0.t0 && context$2$0.t0.message || JSON.stringify(context$2$0.t0) });
	
	                    case 41:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[0, 37]]);
	        }
	
	        /**
	         * This function prepare and return a bunch of predefined data for the form inputs indexed by form input ref names
	         */
	    }, {
	        key: 'getFormInitialValues',
	        value: function getFormInitialValues(dsDocument) {
	
	            var initialValues = {
	                "contractNumber": _nestedProperty2['default'].get(dsDocument, "contractNumber")
	            };
	
	            return initialValues;
	        }
	
	        /**
	         * One input field basic props for handle form.
	         */
	    }, {
	        key: '_inputPrototype',
	        value: function _inputPrototype() {
	            return { label: "", value: "", touched: false, error: false, isRequired: false, isValid: function isValid() {
	                    return true;
	                }, errorMessage: _("invalidInputValue") };
	        }
	
	        /**
	         * Copy one input handler object and return.
	         */
	    }, {
	        key: '_initValueOfInput',
	        value: function _initValueOfInput() {
	            var proto = JSON.parse(JSON.stringify(this._inputPrototype()));
	            proto.isValid = function () {
	                return true;
	            }; // JSON trick is not perfect to copy an object :)
	            return proto;
	        }
	
	        /**
	         * Compose and setup the form inputs with validation an custom error messages
	         * @param {*} formInitialValues - initial values for the form.
	         */
	    }, {
	        key: 'formInputFieldsList',
	        value: function formInputFieldsList(formInitialValues) {
	            return {
	                "contractNumber": _extends({}, this._initValueOfInput(), {
	                    isRequired: true,
	                    errorMessage: _("invalidContractNumber"),
	                    value: _nestedProperty2['default'].get(formInitialValues, "contractNumber")
	                })
	            };
	        }
	
	        /**
	         * Get all of the client contract numbers in a list what is digestible for react select.
	         */
	    }, {
	        key: 'getContractNumbersInOptionList',
	        value: function getContractNumbersInOptionList(contracts) {
	            var result = [];
	
	            if (!contracts || contracts.length === 0) {
	                return result;
	            }
	
	            var objKeys = Object.keys(contracts);
	            result = objKeys && objKeys.map(function (oneKey) {
	                var contractNumber = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.contractNumber");
	                var contractMainBranch = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.mainBranche");
	                var contractMainRisk = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.mainRisk");
	                var contractCompany = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.insuranceCompany");
	                var contractId = _nestedProperty2['default'].get(contracts, oneKey + ".contractMain.contractId");
	
	                return {
	                    label: contractNumber + " - " + contractMainBranch + " - " + contractMainRisk + " - " + contractCompany,
	                    value: contractNumber,
	                    contractId: contractId
	                };
	            });
	
	            return result;
	        }
	
	        /**
	         * Get contractNumber indexed contractId list.
	         */
	    }, {
	        key: 'getContractsHashmap',
	        value: function getContractsHashmap(contractNumbersOptions) {
	            var result = {};
	
	            if (!contractNumbersOptions || contractNumbersOptions.length === 0) {
	                return result;
	            }
	
	            contractNumbersOptions.forEach(function (oneContractOption) {
	                result[oneContractOption.value] = oneContractOption.contractId;
	            });
	
	            return result;
	        }
	
	        /**
	         * This function helps to find by a input-select-value a full element from options, so a value-label pair.
	         * This is necessary for react select 2 to display the label of the selected option after selection in dropdown list.
	         * @param {*} value
	         * @param {*} options
	         */
	    }, {
	        key: 'findItemByValueFromSelectOptions',
	        value: function findItemByValueFromSelectOptions(value, options) {
	            var result = { label: value, value: value };
	
	            if (!options) {
	                return result;
	            }
	
	            var filteredByValue = options.filter(function (item) {
	                return item.value === value;
	            });
	
	            // if no result in list of options the result the subject value
	            if (!filteredByValue || filteredByValue.length === 0) {
	                return result;
	            }
	
	            // in case of match then the first match is the selected one. If there are no values then remains the subject value
	            return _nestedProperty2['default'].get(filteredByValue, "0") || result;
	        }
	
	        /**
	         * Change one input value in state, validate also.
	         */
	    }, {
	        key: 'onChangeFormInput',
	        value: function onChangeFormInput(value, formFieldName) {
	            var forceTouch = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	            var callback = arguments.length <= 3 || arguments[3] === undefined ? function () {} : arguments[3];
	            var formInputs = this.state.formInputs;
	
	            //const data = this.fetchFormValues()
	
	            //get the object from state to be able to set the validity value in it.
	            var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	            // handle touch input
	            if (formField.value !== value && forceTouch === null) {
	                formField.touched = true;
	            }
	
	            if (forceTouch !== null) {
	                formField.touched = forceTouch;
	            }
	
	            // set the value
	            formField.value = value;
	
	            // set the validity in object, this will be set because it passed by address in JS
	            formField = this.fieldValidation(formField);
	
	            // this wil set back the value but implemented only for to be understandable, the value is set by address of object.
	            _nestedProperty2['default'].set(formInputs, formFieldName, formField);
	
	            // put back into the state
	            this.setState({ formInputs: formInputs }, function () {
	                callback();
	            });
	        }
	
	        /**
	         * This function validate one field from the form.
	         * @param {*} formField - instance of input field object
	         * @param {*} inputValue - the new value of input
	         * @param {*} forceTouch - touch anyway the input even if the value is not modified (useful on onBluer fired or onSubmit)
	         */
	    }, {
	        key: 'fieldValidation',
	        value: function fieldValidation(formField) {
	            var forceTouch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            // required check
	            if (formField.isRequired && !formField.value) {
	                formField.error = _("fieldRequired");
	                formField.touched = forceTouch ? true : formField.touched;
	            } else {
	                // validate if "isValid" property is set
	                if (formField.isValid) {
	                    if (formField.isValid(formField.value)) {
	                        formField.error = false;
	                    } else {
	                        formField.error = formField.errorMessage;
	                        formField.touched = forceTouch ? true : formField.touched;
	                    }
	                } else {
	                    formField.error = false;
	                    formField.touched = forceTouch ? true : formField.touched;
	                }
	            }
	
	            // reset the flag of form validity
	            this.setFormValidityFlag();
	
	            return formField;
	        }
	
	        /**
	         * Reset the flag of form validity in state by checking the formInputs in state.
	         */
	    }, {
	        key: 'setFormValidityFlag',
	        value: function setFormValidityFlag() {
	            var formInputs = _nestedProperty2['default'].get(this, "state.formInputs");
	
	            // every change must set the valid form
	            if (formInputs) {
	                var hasError = false;
	                var keys = Object.keys(formInputs) || [];
	
	                keys.forEach(function (oneKey) {
	                    if (formInputs[oneKey].error) {
	                        hasError = true;
	                    }
	                });
	
	                this.setState({ isValidTheForm: hasError ? false : true });
	
	                return hasError ? false : true;
	            }
	
	            return true;
	        }
	
	        /**
	         * Fetch values from form by input refs
	         */
	    }, {
	        key: 'fetchFormValues',
	        value: function fetchFormValues() {
	            var _this2 = this;
	
	            var formInputs = this.state.formInputs;
	
	            var formFieldNames = Object.keys(formInputs);
	            var formData = {};
	
	            formFieldNames.forEach(function (formFieldName) {
	                // react creatable select way to get value
	                var formFieldValue = _nestedProperty2['default'].get(_this2, "refs." + formFieldName + ".props.value.value");
	
	                // if not then react select way to get value
	                formFieldValue = formFieldValue || _nestedProperty2['default'].get(_this2, "refs." + formFieldName + ".state.value.value");
	
	                // if not then normal text input way to get value
	                formFieldValue = formFieldValue || _nestedProperty2['default'].get(_this2, "refs." + formFieldName + ".value");
	                formData[formFieldName] = formFieldValue;
	            });
	
	            //example: this values are not shown in the form, because are not editable only must pass forward fot create package
	            // formData["someFieldName"] = nesProp.get(formInputs, "someFieldName.value")
	
	            return formData;
	        }
	
	        /**
	         * Fill the form values ins state
	         * @param {*} data
	         * @param {*} formInputs
	         *
	         * @returns formInputs - reference to formInputs object in state
	         */
	    }, {
	        key: 'setFormInputsByFormValues',
	        value: function setFormInputsByFormValues(data, formInputs) {
	            if (!formInputs) {
	                return;
	            }
	
	            var formInputNames = Object.keys(formInputs);
	            formInputNames.forEach(function (formFieldName) {
	
	                var dataField = _nestedProperty2['default'].get(data, formFieldName);
	                var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	                formField.value = dataField;
	
	                // set back the value but this is already set by address, but must implement to see what happen
	                // so if you delete this row don't prevent tha value change caused by fieldValidation. (Only the deep cloning of values can solve.)
	                _nestedProperty2['default'].set(formInputs, formFieldName, formField);
	            });
	
	            return formInputs;
	        }
	
	        /**
	         * Validate the hole form.
	         * @param {*} data
	         * @param {*} formInputs
	         *
	         * @returns formInputs - reference to formInputs object in state
	         */
	    }, {
	        key: 'formInputsValidation',
	        value: function formInputsValidation(formInputs) {
	            var _this3 = this;
	
	            var forceTouch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            if (!formInputs) {
	                return;
	            }
	
	            var formInputNames = Object.keys(formInputs);
	            formInputNames.forEach(function (formFieldName) {
	
	                var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	                formField = _this3.fieldValidation(formField, forceTouch);
	
	                // set back the value but this is already set by address, but must implement to see what happen
	                // so if you delete this row don't prevent tha value change caused by fieldValidation. (Only the deep cloning of values can solve.)
	                _nestedProperty2['default'].set(formInputs, formFieldName, formField);
	            });
	
	            // reset the flag of form validity
	            this.setFormValidityFlag();
	
	            return formInputs;
	        }
	
	        /**
	         *
	         * @param {*} e
	         * @returns
	         */
	    }, {
	        key: 'goToStep2',
	        value: function goToStep2(e) {
	            var _ret;
	
	            return regeneratorRuntime.async(function goToStep2$(context$2$0) {
	                var _this4 = this;
	
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        context$2$0.prev = 0;
	                        context$2$0.next = 3;
	                        return regeneratorRuntime.awrap((function callee$2$0() {
	                            var _props2, onConfirmation, dispatch, client, contracts, _state3, formInputs, contractsNumberHashmap, selectedDsDocumentIds, dsPackage, data, forceTouch, isValidTheForm, contractNumber, contractId, updates, updatedDocumentsResponse, getPackageRequestResponse, linkedDocuments;
	
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        _props2 = this.props;
	                                        onConfirmation = _props2.onConfirmation;
	                                        dispatch = _props2.dispatch;
	                                        client = _props2.client;
	                                        contracts = _props2.contracts;
	                                        _state3 = this.state;
	                                        formInputs = _state3.formInputs;
	                                        contractsNumberHashmap = _state3.contractsNumberHashmap;
	                                        selectedDsDocumentIds = _state3.selectedDsDocumentIds;
	                                        dsPackage = _state3.dsPackage;
	                                        data = this.fetchFormValues();
	
	                                        formInputs = this.setFormInputsByFormValues(data, formInputs);
	                                        forceTouch = true;
	
	                                        formInputs = this.formInputsValidation(formInputs, forceTouch);
	
	                                        isValidTheForm = this.setFormValidityFlag();
	
	                                        this.setState({ formInputs: formInputs });
	
	                                        // form validation can  prevent to step the wizard forward
	
	                                        if (isValidTheForm) {
	                                            context$3$0.next = 19;
	                                            break;
	                                        }
	
	                                        this.setState({ isLoaded: true });
	                                        return context$3$0.abrupt('return', {
	                                            v: undefined
	                                        });
	
	                                    case 19:
	                                        if (!(dsPackage && (!selectedDsDocumentIds || selectedDsDocumentIds.length === 0))) {
	                                            context$3$0.next = 22;
	                                            break;
	                                        }
	
	                                        this.setState({ isLoaded: true, wizardError: 'noDocumentSelected' });
	                                        return context$3$0.abrupt('return', {
	                                            v: undefined
	                                        });
	
	                                    case 22:
	                                        contractNumber = _nestedProperty2['default'].get(formInputs, "contractNumber.value");
	                                        contractId = contractsNumberHashmap[contractNumber];
	
	                                        if (!(dsPackage && selectedDsDocumentIds)) {
	                                            context$3$0.next = 34;
	                                            break;
	                                        }
	
	                                        updates = { contractNumber: contractNumber, contractId: contractId };
	                                        context$3$0.next = 28;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateManyDocuments)(selectedDsDocumentIds, updates)));
	
	                                    case 28:
	                                        updatedDocumentsResponse = context$3$0.sent;
	
	                                        if (!updatedDocumentsResponse) {
	                                            context$3$0.next = 34;
	                                            break;
	                                        }
	
	                                        context$3$0.next = 32;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(dsPackage._id)));
	
	                                    case 32:
	                                        getPackageRequestResponse = context$3$0.sent;
	
	                                        if (_stateActions.getOneDsPackageById) {
	                                            linkedDocuments = getPackageRequestResponse.dsDocuments.map(function (oneDoc) {
	                                                return selectedDsDocumentIds.includes(oneDoc._id.toString()) && oneDoc;
	                                            });
	
	                                            this.setState({ dsPackage: getPackageRequestResponse, isLoaded: true, wizardError: false, step: 2, linkedDocuments: linkedDocuments });
	                                        }
	
	                                    case 34:
	                                    case 'end':
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this4);
	                        })());
	
	                    case 3:
	                        _ret = context$2$0.sent;
	
	                        if (!(typeof _ret === 'object')) {
	                            context$2$0.next = 6;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return', _ret.v);
	
	                    case 6:
	                        context$2$0.next = 12;
	                        break;
	
	                    case 8:
	                        context$2$0.prev = 8;
	                        context$2$0.t0 = context$2$0['catch'](0);
	
	                        console.warn(context$2$0.t0);
	                        return context$2$0.abrupt('return', this.setState({
	                            isLoaded: true,
	                            wizardError: context$2$0.t0 && context$2$0.t0.message || JSON.stringify(context$2$0.t0),
	                            step: 2
	                        }));
	
	                    case 12:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[0, 8]]);
	        }
	
	        /**
	         * This function will find in the result of document upload a dsDocument instance by ID from the list by parsing it.
	         * @param {*} id
	         * @param {*} dataAndDocs
	         * @returns
	         */
	    }, {
	        key: 'findADocumentInListOfDocuments',
	        value: function findADocumentInListOfDocuments(documentId, dataAndDocs) {
	            // check params
	            if (!dataAndDocs || dataAndDocs.length == 0 || !documentId) {
	                return false;
	            }
	
	            // find the doc in list
	            var resultDoc = false;
	            dataAndDocs.forEach(function (oneData) {
	                if (oneData.dsDocument._id == documentId) {
	                    resultDoc = oneData.dsDocument;
	                }
	            });
	
	            return resultDoc;
	        }
	
	        /**
	         *
	         * @param {*} e
	         * @returns
	         */
	    }, {
	        key: 'goToStep3',
	        value: function goToStep3(e) {
	            var dispatch, dsPackage, uploadRequestResponse, getPackageRequestResponse, errorMessageToRender, errorCode;
	            return regeneratorRuntime.async(function goToStep3$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        dsPackage = this.state.dsPackage;
	
	                        if (dsPackage._id) {
	                            context$2$0.next = 4;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return', Promise.reject("Missing package id"));
	
	                    case 4:
	
	                        this.setState({ isLoaded: false });
	                        context$2$0.prev = 5;
	                        context$2$0.next = 8;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.uploadReadyDocuments)(dsPackage._id)));
	
	                    case 8:
	                        uploadRequestResponse = context$2$0.sent;
	
	                        if (!(uploadRequestResponse && uploadRequestResponse.error || !uploadRequestResponse)) {
	                            context$2$0.next = 11;
	                            break;
	                        }
	
	                        throw uploadRequestResponse;
	
	                    case 11:
	                        if (!_stateActions.uploadReadyDocuments) {
	                            context$2$0.next = 16;
	                            break;
	                        }
	
	                        context$2$0.next = 14;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(dsPackage._id)));
	
	                    case 14:
	                        getPackageRequestResponse = context$2$0.sent;
	
	                        if (_stateActions.getOneDsPackageById) {
	                            this.setState({ dsPackage: getPackageRequestResponse, isLoaded: true, wizardError: false, step: 3 });
	                        }
	
	                    case 16:
	                        context$2$0.next = 38;
	                        break;
	
	                    case 18:
	                        context$2$0.prev = 18;
	                        context$2$0.t0 = context$2$0['catch'](5);
	                        errorMessageToRender = context$2$0.t0 && context$2$0.t0.statusText && _(context$2$0.t0.statusText) || context$2$0.t0 && context$2$0.t0.message || JSON.stringify(context$2$0.t0);
	                        errorCode = context$2$0.t0 && context$2$0.t0.statusText || '';
	                        context$2$0.t1 = errorCode;
	                        context$2$0.next = context$2$0.t1 === CONNECTIVE_ERROR ? 25 : context$2$0.t1 === NO_DOCUMENT_FOUND_ON_SERVER ? 27 : context$2$0.t1 === NO_DOCUMENTS_AVAILABLE_FOR_PROCESS ? 29 : context$2$0.t1 === UPLOAD_TO_ORACLE_TIMEOUT ? 31 : context$2$0.t1 === NO_DOCUMENT_MATCH_FOR_UPLOAD ? 33 : context$2$0.t1 === MISSING_ARGUMENTS ? 35 : 37;
	                        break;
	
	                    case 25:
	                        errorMessageToRender = _('errorRetrievingDocumentFromConnective');
	                        return context$2$0.abrupt('break', 37);
	
	                    case 27:
	                        errorMessageToRender = _('documentNotFoundToUpload');
	                        return context$2$0.abrupt('break', 37);
	
	                    case 29:
	                        errorMessageToRender = _('documentNotReadyOrAlreadyUploaded');
	                        return context$2$0.abrupt('break', 37);
	
	                    case 31:
	                        errorMessageToRender = _('canNotTransferTheDocumentToWillemot');
	                        return context$2$0.abrupt('break', 37);
	
	                    case 33:
	                        errorMessageToRender = _('documentNotReadyOrAlreadyUploaded');
	                        return context$2$0.abrupt('break', 37);
	
	                    case 35:
	                        errorMessageToRender = _('missingArgumentsError');
	                        return context$2$0.abrupt('break', 37);
	
	                    case 37:
	                        return context$2$0.abrupt('return', this.setState({
	                            isLoaded: true,
	                            wizardError: errorMessageToRender,
	                            step: 3
	                        }));
	
	                    case 38:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[5, 18]]);
	        }
	
	        /**
	         * Handle Ui event for header checkbox
	         */
	    }, {
	        key: 'handleCheckAll',
	        value: function handleCheckAll() {
	            var _state4 = this.state;
	            var dsDocumentsThatRequireLinking = _state4.dsDocumentsThatRequireLinking;
	            var selectedDsDocumentIds = _state4.selectedDsDocumentIds;
	
	            var selection = selectedDsDocumentIds.length === dsDocumentsThatRequireLinking.length ? [] : dsDocumentsThatRequireLinking.map(function (oneDocument) {
	                return oneDocument._id;
	            });
	            this.setState({ selectedDsDocumentIds: selection });
	        }
	
	        /**
	        * Handle Ui event for individual checkbox
	        * @param {*} ev
	        * @param {*} documentId
	        */
	    }, {
	        key: 'onCheckChange',
	        value: function onCheckChange(ev, document) {
	            var selectedDsDocumentIds = this.state.selectedDsDocumentIds;
	
	            var index = selectedDsDocumentIds.findIndex(function (oneDoc) {
	                return oneDoc.toString() === document._id.toString();
	            });
	            if (index >= 0) {
	                selectedDsDocumentIds.splice(index, 1);
	            } else {
	                selectedDsDocumentIds.push(document._id);
	            }
	            this.setState({ selectedDsDocumentIds: selectedDsDocumentIds });
	        }
	    }, {
	        key: 'openPdf',
	        value: function openPdf(_id) {
	            var linkForPdfDownload, w, onLoadWindowPromise;
	            return regeneratorRuntime.async(function openPdf$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        linkForPdfDownload = _DSWizard.HALF_FILLED_PDF_API_URL + "/" + _id;
	                        w = window.open(linkForPdfDownload, '_blank', 'noopener,noreferrer');
	                        onLoadWindowPromise = new Promise(function (resolve) {
	                            w.addEventListener('load', function () {
	                                resolve();
	                            }, true);
	                        });
	                        context$2$0.next = 5;
	                        return regeneratorRuntime.awrap(onLoadWindowPromise());
	
	                    case 5:
	                        return context$2$0.abrupt('return');
	
	                    case 6:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Thi is the wizard step 1 content interface
	         * @returns
	         */
	    }, {
	        key: 'renderStep1',
	        value: function renderStep1(message) {
	            var _this5 = this;
	
	            var _state5 = this.state;
	            var formInputs = _state5.formInputs;
	            var contractNumbersOptions = _state5.contractNumbersOptions;
	            var dsDocumentsThatRequireLinking = _state5.dsDocumentsThatRequireLinking;
	            var selectedDsDocumentIds = _state5.selectedDsDocumentIds;
	            var lang = this.props.lang;
	
	            var allSelected = dsDocumentsThatRequireLinking && selectedDsDocumentIds && dsDocumentsThatRequireLinking.length === selectedDsDocumentIds.length;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _LinkDocumentModalScss2['default'].content },
	                message,
	                dsDocumentsThatRequireLinking && _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            filterable: ["documentName"],
	                            ref: function (el) {
	                                _this5.table = el;
	                            },
	                            id: 'table',
	                            className: 'table',
	                            sortable: [{ column: 'ticketDate', sortFunction: 'Date' }, 'ticketDescription', 'ticketType'],
	                            defaultSort: {
	                                column: 'ticketDate',
	                                direction: 'desc'
	                            },
	
	                            itemsPerPage: 50,
	                            pageButtonLimit: 5
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'checkbox' },
	                                _react2['default'].createElement('input', {
	                                    type: 'checkbox',
	                                    checked: allSelected,
	                                    onChange: function () {
	                                        return _this5.handleCheckAll();
	                                    }
	                                })
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'pdfIcon' },
	                                " "
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'documentName' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _("documentName")
	                                )
	                            )
	                        ),
	                        dsDocumentsThatRequireLinking && dsDocumentsThatRequireLinking.length && dsDocumentsThatRequireLinking.length > 0 ? dsDocumentsThatRequireLinking.map(function (item, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                {
	                                    className: 'clickable',
	                                    i: item,
	                                    key: key
	                                },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'checkbox' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { style: { width: 15 } },
	                                        _react2['default'].createElement('input', {
	                                            type: 'checkbox',
	                                            onClick: function (ev) {
	                                                return ev.stopPropagation();
	                                            },
	                                            onChange: function (ev) {
	                                                return _this5.onCheckChange(ev, item);
	                                            },
	                                            checked: selectedDsDocumentIds.find(function (oneDocId) {
	                                                return oneDocId.toString() === item._id.toString();
	                                            }) ? true : false
	                                        })
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'pdfIcon' },
	                                    _react2['default'].createElement('img', {
	                                        src: __webpack_require__(172),
	                                        onClick: function () {
	                                            return _this5.openPdf(item._id);
	                                        },
	                                        className: _LinkDocumentModalScss2['default'].pdfIcon
	                                    })
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'documentName', value: item.fileName },
	                                    item.fileName
	                                )
	                            );
	                        }) : ''
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _LinkDocumentModalScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: _LinkDocumentModalScss2['default'].formLabel },
	                        _('contractNumber'),
	                        ':* '
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].formInput, _LinkDocumentModalScss2['default'].formInputCreatableSelect) },
	                        _react2['default'].createElement(_DSWizardHelper2['default'], {
	                            value: this.findItemByValueFromSelectOptions(_nestedProperty2['default'].get(formInputs, "contractNumber.value"), contractNumbersOptions),
	                            ref: 'contractNumber',
	                            name: 'contractNumber',
	                            onChange: function (value) {
	                                return _this5.onChangeFormInput(_nestedProperty2['default'].get(value, "value") || "", "contractNumber");
	                            },
	                            handleOnBlur: function (e) {
	                                var forceTouch = true;
	                                var typedValue = _nestedProperty2['default'].get(e, "target.value");
	
	                                if (typedValue) {
	                                    return _this5.onChangeFormInput(_nestedProperty2['default'].get(e, "target.value") || "", "contractNumber", forceTouch);
	                                }
	                            },
	                            options: contractNumbersOptions,
	                            isSearchable: true,
	                            isClearable: true,
	                            isMulti: false
	                        })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].errorMessageContainer, _nestedProperty2['default'].get(formInputs, "contractNumber.touched") && _nestedProperty2['default'].get(formInputs, "contractNumber.error") ? "" : _LinkDocumentModalScss2['default'].none) },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _LinkDocumentModalScss2['default'].errorMessage },
	                        _nestedProperty2['default'].get(formInputs, "contractNumber.error") && _nestedProperty2['default'].get(formInputs, "contractNumber.touched") && _nestedProperty2['default'].get(formInputs, "contractNumber.error")
	                    )
	                )
	            );
	        }
	
	        /**
	         * This function helps to use an icon on a safe way
	         */
	    }, {
	        key: 'getIcon',
	        value: function getIcon(icon) {
	            try {
	                return __webpack_require__(591)("./" + icon + '.svg');
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	
	        /**
	         * Thi is the wizard step 2 content interface
	         * @param {*} canNotBeUploaded
	         * @returns
	         */
	    }, {
	        key: 'renderStep2',
	        value: function renderStep2() {
	            var _this6 = this;
	
	            var canNotBeUploaded = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	            var _state6 = this.state;
	            var dsPackage = _state6.dsPackage;
	            var linkedDocuments = _state6.linkedDocuments;
	
	            if (!dsPackage || !dsPackage.dsDocuments) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    '...'
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _LinkDocumentModalScss2['default'].content },
	                linkedDocuments.map(function (oneLinkedDoc, key) {
	                    return oneLinkedDoc && oneLinkedDoc._id && _react2['default'].createElement(
	                        'div',
	                        { key: 'linkedDocumentName' + key, className: _LinkDocumentModalScss2['default'].documentRow },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _LinkDocumentModalScss2['default'].documentColumn },
	                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].emailButtonIcon), src: _this6.getIcon("n-contracts_2x.png") })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _LinkDocumentModalScss2['default'].documentColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                null,
	                                _("documentName"),
	                                ': ',
	                                oneLinkedDoc.fileName || '-'
	                            )
	                        )
	                    );
	                }),
	                linkedDocuments && linkedDocuments.length > 0 && _("dsDocumentIsLinkedSuccessfully"),
	                canNotBeUploaded ? _("theDocumentIsNotReadyForUploadYet") : _("goToNextStepToUpload")
	            );
	        }
	
	        /**
	         * This is the wizard step 3 content interface
	         * this will list the upload status for package documents
	         * @returns
	         */
	    }, {
	        key: 'renderStep3',
	        value: function renderStep3() {
	            var _this7 = this;
	
	            var _state7 = this.state;
	            var dsPackage = _state7.dsPackage;
	            var linkedDocuments = _state7.linkedDocuments;
	
	            if (!dsPackage) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    '...'
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                dsPackage.dsDocuments.map(function (oneDoc) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: _LinkDocumentModalScss2['default'].content },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _LinkDocumentModalScss2['default'].documentRow },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _LinkDocumentModalScss2['default'].documentColumn },
	                                _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].emailButtonIcon), src: _this7.getIcon("n-contracts_2x.png") })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _LinkDocumentModalScss2['default'].documentColumn },
	                                _("documentName"),
	                                ': ',
	                                oneDoc.fileName
	                            )
	                        ),
	                        _("dsDocumentPackageUpdated"),
	                        oneDoc.uploadedToOracle ? _("dsDocumentUploaded") : _("dsDocumentNotUploaded")
	                    );
	                })
	            );
	        }
	
	        /**
	         * On click next button in the wizard
	         * @param {*} e
	         * @param {Boolean} closeModal
	         * @param {Boolean} canBeUploaded
	         */
	    }, {
	        key: 'onClickNext',
	        value: function onClickNext(e, closeModal, canBeUploaded) {
	            var step, onConfirmation;
	            return regeneratorRuntime.async(function onClickNext$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        step = this.state.step;
	                        onConfirmation = this.props.onConfirmation;
	
	                        if (!(step === 1)) {
	                            context$2$0.next = 10;
	                            break;
	                        }
	
	                        context$2$0.next = 5;
	                        return regeneratorRuntime.awrap(this.goToStep2(e));
	
	                    case 5:
	                        if (!canBeUploaded) {
	                            context$2$0.next = 8;
	                            break;
	                        }
	
	                        context$2$0.next = 8;
	                        return regeneratorRuntime.awrap(this.goToStep3(e));
	
	                    case 8:
	                        context$2$0.next = 11;
	                        break;
	
	                    case 10:
	                        if (step === 2) {
	                            // skip the upload step if the document is not ready for upload
	                            if (closeModal) {
	                                this.clearModule();
	                                onConfirmation(e);
	                            }
	
	                            this.goToStep3(e);
	                        } else {
	                            if (step === 3) {
	                                this.clearModule();
	                                onConfirmation(e);
	                            }
	                        }
	
	                    case 11:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * this method will iterate all documents from the package and return each different upload on module
	         * @returns array with each upload module present in documents list
	         */
	    }, {
	        key: 'determineModule',
	        value: function determineModule(dsPackage) {
	            // const {  } = this.props
	            if (!dsPackage) {
	                return;
	            }
	            var modules = dsPackage.dsDocuments.map(function (oneDocument) {
	                console.log('oneDocument0', oneDocument);
	                return oneDocument.documentTemplate ? oneDocument.documentTemplate.uploadedOnModule : oneDocument.uploadedOnModule;
	            });
	            //remove duplicated entries
	            modules.filter(function (oneModule, index, originalArray) {
	                return originalArray.indexOf(oneModule) === index;
	            });
	            return modules;
	        }
	
	        /**
	         * Check documents list if there are documents that not been uploaded
	         * @returns boolean
	         */
	    }, {
	        key: 'packageHasDocumentsReadyToUpload',
	        value: function packageHasDocumentsReadyToUpload(dsPackage) {
	            // const {  } = this.props
	            var hasDocsToUpload = false;
	            if (!dsPackage) {
	                return hasDocsToUpload;
	            }
	            dsPackage.dsDocuments.map(function (oneDoc) {
	                if (!oneDoc.uploadedToOracle && !oneDoc.documentTemplate && oneDoc.origin === 'DS_ORIGIN_ORACLE' && dsPackage.hasFinishStatus || oneDoc.documentTemplate && (!oneDoc.documentTemplate.mustBeSigned || oneDoc.documentTemplate.mustBeSigned && dsPackage.hasFinishStatus)) {
	                    hasDocsToUpload = true;
	                }
	            });
	            return hasDocsToUpload;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var _props3 = this.props;
	            var modalIsOpen = _props3.modalIsOpen;
	            var onCancel = _props3.onCancel;
	            var _state8 = this.state;
	            var step = _state8.step;
	            var wizardError = _state8.wizardError;
	            var dsPackage = _state8.dsPackage;
	
	            // determine modal title by doc template
	            var title = _('documentModal');
	            var message = _('linkAndUploadDescription');
	
	            // avoid total fall in fail
	            if (!dsPackage) {
	                return _react2['default'].createElement('div', null);
	            }
	
	            var modules = this.determineModule(dsPackage);
	
	            if (modules && modules.includes(c.DS_MODULE_CLIENT_CONTRACT)) {
	                title = _('linkContract');
	                message = _('linkContractDescription');
	            }
	
	            var mustDoUpload = this.packageHasDocumentsReadyToUpload(dsPackage);
	            // in case when the doc is not signed but can be linked then we just let to connect the contract
	            var skipStep2 = step === 2 && !mustDoUpload;
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _LinkDocumentModalScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _LinkDocumentModalScss2['default'].title },
	                            title
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _LinkDocumentModalScss2['default'].contentWrapper },
	                            step === 1 && this.renderStep1(message),
	                            step === 2 && this.renderStep2(skipStep2),
	                            step === 3 && this.renderStep3(),
	                            wizardError && _react2['default'].createElement(
	                                'div',
	                                { className: _LinkDocumentModalScss2['default'].wizardError },
	                                _("wizardError"),
	                                wizardError
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _LinkDocumentModalScss2['default'].buttons },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            _this8.clearModule();
	                                            onCancel();
	                                        },
	                                        className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].cancel)
	                                    },
	                                    _('cancel')
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function (e) {
	                                            return _this8.onClickNext(e, skipStep2, mustDoUpload);
	                                        },
	                                        className: (0, _classnames2['default'])(_LinkDocumentModalScss2['default'].next, _LinkDocumentModalScss2['default'].enabled)
	                                    },
	                                    step === 1 && _("link"),
	                                    step === 2 && (mustDoUpload && _("upload") || _("ok")),
	                                    step === 3 && _("done")
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _LinkDocumentsModal = LinkDocumentsModal;
	    LinkDocumentsModal = (0, _reactRedux.connect)(function (state) {
	        return {
	            client: _nestedProperty2['default'].get(state, "DSDocuments.client"),
	            lang: _nestedProperty2['default'].get(state, 'app.lang')
	        };
	    })(LinkDocumentsModal) || LinkDocumentsModal;
	    return LinkDocumentsModal;
	})(_react2['default'].Component);
	
	exports['default'] = LinkDocumentsModal;
	module.exports = exports['default'];

	// // determine if is needed to link a contract or anything, if not the skip the first step

	// if no contract required, jump the first step

	// init form inputs, and values

	// // TODO get contractId by contract number and pass it forward for update.

	// update package data with the new documents and set data for step 2

	// go forward and skip to push the upload button if one document is ready for upload is ready for upload BEWB-339

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _categoriesScss = __webpack_require__(1592);
	
	var _categoriesScss2 = _interopRequireDefault(_categoriesScss);
	
	var _libI18n = __webpack_require__(3);
	
	var CategoryDom = function CategoryDom(_ref) {
		var text = _ref.text;
	
		return _react2['default'].createElement('span', { className: _categoriesScss2['default'].category, children: text });
	};
	exports.CategoryDom = CategoryDom;
	CategoryDom.propTypes = {
		text: _react.PropTypes.string
	};
	
	var Category = (function (_Component) {
		_inherits(Category, _Component);
	
		function Category() {
			_classCallCheck(this, Category);
	
			_get(Object.getPrototypeOf(Category.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Category, [{
			key: 'render',
			value: function render() {
				var id = this.props.id;
	
				var category = (0, _libI18n.catIdToString)(id);
				return _react2['default'].createElement(CategoryDom, { text: category });
			}
		}], [{
			key: 'propTypes',
			value: {
				id: _react.PropTypes.string.isRequired
			},
			enumerable: true
		}]);
	
		return Category;
	})(_react.Component);
	
	exports['default'] = Category;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _stateActions = __webpack_require__(5);
	
	var _libHelpers = __webpack_require__(24);
	
	var _clientContractsZoomScss = __webpack_require__(1599);
	
	var _clientContractsZoomScss2 = _interopRequireDefault(_clientContractsZoomScss);
	
	var _uploader = __webpack_require__(143);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _emailSenderEmailButton = __webpack_require__(108);
	
	var _emailSenderEmailButton2 = _interopRequireDefault(_emailSenderEmailButton);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _stateConstants = __webpack_require__(11);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _ClaimsWizardClaimWizardButton = __webpack_require__(263);
	
	var _ClaimsWizardClaimWizardButton2 = _interopRequireDefault(_ClaimsWizardClaimWizardButton);
	
	var _ = (0, _libI18n2['default'])('clientContractsZoom');
	
	var Risk = function Risk(_ref) {
	    var data = _ref.data;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: _clientContractsZoomScss2['default'].clientsTableContainer },
	        _react2['default'].createElement(
	            'div',
	            { className: _clientContractsZoomScss2['default'].riskDescriptionContainer },
	            _react2['default'].createElement(
	                'div',
	                { className: _clientContractsZoomScss2['default'].riskDescLabel },
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _('description')
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: _clientContractsZoomScss2['default'].riskDesc },
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    data.riskDescription
	                )
	            )
	        ),
	        _react2['default'].createElement(
	            _componentsReactable.Table,
	            {
	                className: _clientContractsZoomScss2['default'].table,
	                topPagination: false,
	                bottomPagination: false,
	                sortable: ["product", "option"]
	            },
	            _react2['default'].createElement(
	                _componentsReactable.Thead,
	                null,
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'product' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('product')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'option' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('option')
	                    )
	                )
	            ),
	            data.products && data.products.map(function (item, key) {
	                return _react2['default'].createElement(
	                    _componentsReactable.Tr,
	                    { className: 'centered', key: key },
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'product' },
	                        item.product
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'option' },
	                        item.option
	                    )
	                );
	            })
	        )
	    );
	};
	
	/**
	 * This function render the data for the qualification column in the claims result table.
	 * @param {object} main - thi is the claims record main property, what contains the qualification values
	 */
	var formatQualification = function formatQualification(main) {
	    return _react2['default'].createElement(
	        'span',
	        null,
	        _react2['default'].createElement(
	            'span',
	            null,
	            main.qualification
	        ),
	        main.subQualification && _react2['default'].createElement(
	            'span',
	            null,
	            ',',
	            _react2['default'].createElement('br', null),
	            main.subQualification
	        )
	    );
	};
	
	var Claims = function Claims(_ref2) {
	    var data = _ref2.data;
	    var zoomTo = _ref2.zoomTo;
	
	    var formattedData = data.map(function (item) {
	        return _extends({}, item.claimMain, {
	            claimDate: (0, _moment2['default'])(item.claimMain.claimDate).format("DD-MM-YYYY"),
	            creationDate: (0, _moment2['default'])(item.claimMain.creationDate).format("DD-MM-YYYY")
	        });
	    });
	
	    return _react2['default'].createElement(
	        'div',
	        { className: _clientContractsZoomScss2['default'].clientsTableContainer },
	        _react2['default'].createElement(
	            'div',
	            { className: _clientContractsZoomScss2['default'].descriptionContainer },
	            _react2['default'].createElement(
	                'div',
	                { className: _clientContractsZoomScss2['default'].descLabel },
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _('claimsHeader')
	                )
	            )
	        ),
	        _react2['default'].createElement(
	            _componentsReactable.Table,
	            {
	                className: _clientContractsZoomScss2['default'].table,
	                topPagination: false,
	                bottomPagination: false,
	                itemsPerPage: 10,
	                sortable: [{ column: 'claimDate', sortFunction: 'Date' }, { column: 'creationDate', sortFunction: 'Date' }, 'claimNumber', 'claimsManager', 'qualification', 'state'],
	                defaultSort: {
	                    column: 'creationDate',
	                    direction: 'desc'
	                }
	            },
	            _react2['default'].createElement(
	                _componentsReactable.Thead,
	                null,
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'claimDate' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('claimDate')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'creationDate' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('creationDate')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'claimNumber' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('claimNumber')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'claimsManager' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('claimsManager')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'qualification' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('qualification')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'state' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('state')
	                    )
	                )
	            ),
	            formattedData.length > 0 && formattedData.map(function (item, key) {
	                return _react2['default'].createElement(
	                    _componentsReactable.Tr,
	                    { className: 'clickable centered', onClick: function () {
	                            return zoomTo(item.claimId);
	                        }, key: key },
	                    _react2['default'].createElement(_componentsReactable.Td, { column: 'claimDate', data: (0, _libHelpers.dateFormatter)(item.claimDate) }),
	                    _react2['default'].createElement(_componentsReactable.Td, { column: 'creationDate', data: (0, _libHelpers.dateFormatter)(item.creationDate) }),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'claimNumber' },
	                        item.claimNumber
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'claimsManager' },
	                        item.claimsManager
	                    ),
	                    _react2['default'].createElement(_componentsReactable.Td, { column: 'qualification', data: formatQualification(item), value: item.qualification + " " + item.subQualification }),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'state' },
	                        item.state
	                    )
	                );
	            })
	        )
	    );
	};
	
	var ClientContractsZoom = (function (_React$Component) {
	    _inherits(ClientContractsZoom, _React$Component);
	
	    _createClass(ClientContractsZoom, null, [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            contractId: _react2['default'].PropTypes.string.isRequired,
	            clientId: _react2['default'].PropTypes.string.isRequired,
	            clientContract: _react2['default'].PropTypes.object,
	            clientData: _react2['default'].PropTypes.object,
	            allClaims: _react2['default'].PropTypes.array,
	            clientOptionsDict: _react2['default'].PropTypes.object,
	            claimStatus: _react2['default'].PropTypes.string
	        },
	
	        /**
	         * Constructor: initialize state etc.
	         * @param {*} props
	         */
	        enumerable: true
	    }]);
	
	    function ClientContractsZoom(props) {
	        _classCallCheck(this, _ClientContractsZoom);
	
	        _get(Object.getPrototypeOf(_ClientContractsZoom.prototype), 'constructor', this).call(this, props);
	        var clientOptionsDict = props.clientOptionsDict;
	
	        this.state = {
	            clientOptionsDict: clientOptionsDict,
	            initializationCompleted: false, contractLoaded: false, claimLoaded: false,
	            characteristicTypeDict: {}
	        };
	    }
	
	    /**
	     * Fetching clientContracts and clientClaims data from server and set the current brokerNumber
	     */
	
	    _createClass(ClientContractsZoom, [{
	        key: 'fetchData',
	        value: function fetchData() {
	            var _this = this;
	
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var contract = _props.contract;
	            var clientId = _props.clientId;
	            var brNr = _props.brNr;
	
	            // if we have contract id we can get the contract details to know the related brokerNumber
	            if (contract && contract.contractId) {
	                dispatch((0, _stateActions.fetchClientContract)(contract.contractId)).then(function () {
	                    _this.setState({ contractLoaded: true });
	                });
	            } else {
	                this.setState({ contractLoaded: true });
	            }
	
	            // using the clientId trigger the fetchClientClaims to know claims managers email addresses and languages
	            if (clientId) {
	                dispatch((0, _stateActions.fetchClientClaims)(clientId)).then(function () {
	                    _this.setState({ claimLoaded: true });
	                });
	            } else {
	                this.setState({ claimLoaded: true });
	            }
	        }
	
	        /**
	         * Triggered before update the module.
	         * @param {object} nextProps
	         * @param {object} nextState
	         */
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            if (nextState.claimLoaded && nextState.contractLoaded && !nextState.initializationCompleted) {
	                this.setState({ initializationCompleted: true });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.fetchData();
	
	            var _props2 = this.props;
	            var dispatch = _props2.dispatch;
	            var clientOptionsDict = _props2.clientOptionsDict;
	            var createContractState = _props2.createContractState;
	
	            if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
	                dispatch((0, _stateActions.fetchClientOptionsDict)()).then(function (dictionary) {
	                    _this2.setClientOptionsDict(dictionary);
	                });
	            } else {
	                if (!this.state.clientOptionsDict) {
	                    this.setClientOptionsDict(clientOptionsDict);
	                }
	            }
	
	            // // set the contract creation state in module state, to keep it
	            // this.setState({createContractState: createContractState})
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var dispatch;
	            return regeneratorRuntime.async(function componentWillUnmount$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$2$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.resetClaimWizard)()));
	
	                    case 3:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        // /**
	        //  * This will be call always when receive props
	        //  * @param {*} nextProps
	        //  */
	        // componentWillReceiveProps(nextProps) {
	        //     const {dispatch, createContractState} = this.props
	
	        //     // get the create contract state in to the module state and remove it from store
	        //     if (nextProps.createContractState !== createContractState && nextProps.createContractState) {
	        //         this.setState({createContractState: createContractState})
	        //         dispatch(setClientCreateContractState(''))
	        //     }
	        // }
	
	        /**
	         * Set client options dict in to the state
	         * @param {object} dictionary - contains the dictionary
	         */
	    }, {
	        key: 'setClientOptionsDict',
	        value: function setClientOptionsDict(dictionary) {
	            var _this3 = this;
	
	            var appLanguage = this.props.appLanguage;
	
	            var characteristicTypeDict = this.processClientOptionsDictForCharacteristics(dictionary);
	
	            this.setState({ clientOptionsDict: dictionary, characteristicTypeDict: characteristicTypeDict }, function () {
	                _this3.forceUpdate();
	            });
	        }
	
	        /**
	         * This function returns the translated values for characteristicType
	         * @param {object} dictionary - getListsLibrary result to get the translations
	         */
	    }, {
	        key: 'processClientOptionsDictForCharacteristics',
	        value: function processClientOptionsDictForCharacteristics(dictionary) {
	            var translations = {};
	
	            if (!dictionary || !dictionary.KENMERKTYPE) {
	                translations = dictionary.KENMERKTYPE;
	
	                // TODO if the type values are different like the indexes then we have to process and assign the values
	                /* Object.keys(charaTypes).map((key) => {
	                    charaTypes[key]
	                }) */
	            }
	
	            return translations;
	        }
	
	        /**
	         * This function return with values for email sender, collected from this module
	         * depending on the current data structure.
	         */
	    }, {
	        key: 'collectVariableValues',
	        value: function collectVariableValues() {
	            var _props3 = this.props;
	            var contract = _props3.contract;
	            var clientData = _props3.clientData;
	            var clientId = _props3.clientId;
	            var office = _props3.office;
	            var clientOptionsDict = this.state.clientOptionsDict;
	            var documents = contract.documents;
	
	            var emails = _nestedProperty2['default'].get(clientData, "detail.emails");
	            var clientName = _nestedProperty2['default'].get(clientData, "main.name");
	
	            // process email list to be digestible for email sender
	            emails = emails.map(function (item) {
	                return {
	                    referenceId: clientId,
	                    label: clientName,
	                    value: item.email,
	                    'default': item['default'] == "true" || item['default'] == true ? true : false
	                };
	            });
	
	            emails = emails.sort(function (item, item2) {
	                if (item['default'] && !item2['default']) {
	                    return -1;
	                }
	                if (!item['default'] && item2['default']) {
	                    return 1;
	                }
	                if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                    return 0;
	                }
	            }) || [];
	
	            // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
	            var clientLanguage = _nestedProperty2['default'].get(clientData, "detail.language") || '';
	            clientLanguage = (0, _libHelpers.getTheLanguageCodeByAnyLanguageOnAnyLanguage)(clientLanguage, clientOptionsDict);
	            return {
	                contractNumber: contract.contractNumber,
	
	                clientDocuments: _nestedProperty2['default'].get(clientData, "clientDocuments"),
	                clientDocumentsType: 'client',
	                clientDocumentsId: clientId,
	
	                // new v6 mode
	                claimDocuments: [],
	                claimDocumentsType: "claim",
	                claimDocumentsId: null,
	
	                contractDocuments: documents,
	                contractDocumentsType: "contract",
	                contractDocumentsId: contract && contract.contractId,
	
	                clientId: false,
	                contractId: contract && contract.contractId,
	                claimId: false,
	                company: contract && contract.insuranceCompany,
	                clientName: _nestedProperty2['default'].get(clientData, "main.name"),
	                clientNumber: _nestedProperty2['default'].get(clientData, "main.clientNumber"),
	                clientLanguage: clientLanguage,
	                clientEmails: emails,
	                companyCancelMail: contract.companyCancelMail,
	
	                brokerNumber: _nestedProperty2['default'].get(contract, "details.brokerNumber"),
	
	                // test line the next 2 remove
	                brokersAvailableForThisUser: Object.keys(office && office.brokers || {}),
	                contract: contract,
	                clientData: _nestedProperty2['default'].get(clientData, "main"),
	                contractBranche: contract && contract.contractBranche
	            };
	        }
	
	        /**
	         * This function transcode the contract state to an uploader state.
	         * @param {string} createContractState contract state
	         * @returns {string} uploader state
	         */
	    }, {
	        key: 'getUploadStateByContractState',
	        value: function getUploadStateByContractState(createContractState) {
	            var result = '';
	
	            if (!createContractState) {
	                return result;
	            }
	
	            switch (createContractState) {
	                case _stateConstants.CONTRACT_PRE_PROPOSAL:
	                    result = _stateConstants.UPLOADER_STATE_NEW_POLICY;
	                    break;
	                //only case of prev the upload will be opened forcefully
	                // case CONTRACT_PRE_MANDATE:
	                //     result = UPLOADER_STATE_POLICY_FILE
	                // break
	            }
	
	            return result;
	        }
	
	        /**
	         * This function returns a description about contract for uploader.
	         * @param {string} createContractState contract state
	         * @returns {string} uploader documents description
	         */
	    }, {
	        key: 'getUploadDescriptionByContractState',
	        value: function getUploadDescriptionByContractState(createContractState) {
	            var result = '';
	
	            if (!createContractState) {
	                return result;
	            }
	
	            switch (createContractState) {
	                case _stateConstants.CONTRACT_PRE_PROPOSAL:
	                    result = 'PREV';
	                    break;
	            }
	
	            return result;
	        }
	
	        /**
	         * Resets ticket data from store in order to prevent multiple additions to dsWizzard
	         */
	    }, {
	        key: 'resetDataFromStoreOnCancel',
	        value: function resetDataFromStoreOnCancel() {
	            var _props4 = this.props;
	            var dispatch = _props4.dispatch;
	            var ticketId = _props4.ticketId;
	            var contractId = _props4.contractId;
	
	            //reset aditional data fro tickets
	            if (ticketId) {
	                dispatch((0, _stateActions.setOpenedSubmenu)(contractId, {}));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props5 = this.props;
	            var dispatch = _props5.dispatch;
	            var claims = _props5.claims;
	            var contract = _props5.contract;
	            var clientAccess = _props5.clientAccess;
	            var canCreateMifid = _props5.canCreateMifid;
	            var clientId = _props5.clientId;
	            var contractId = _props5.contractId;
	            var createContractState = _props5.createContractState;
	            var ticketId = _props5.ticketId;
	            var ticketDocuments = _props5.ticketDocuments;
	            var selectedTicketDocuments = _props5.selectedTicketDocuments;
	            var emailAttachmentTicketDocuments = _props5.emailAttachmentTicketDocuments;
	            var claimStatus = _props5.claimStatus;
	            var _state = this.state;
	            var clientOptionsDict = _state.clientOptionsDict;
	            var initializationCompleted = _state.initializationCompleted;
	            var characteristicTypeDict = _state.characteristicTypeDict;
	
	            var contractIdForMifid = contractId !== "undefined" && contractId || contract.contractId;
	
	            // exit point for render if no data, try next time when data loaded
	            if (!clientOptionsDict || !contract.details) {
	                return _react2['default'].createElement(
	                    'span',
	                    null,
	                    '...'
	                );
	            }
	
	            var createmail = clientAccess && clientAccess.filter(function (item) {
	                return item.actionName == "createmail" && item.actionAllowed == "true";
	            }).length > 0;
	
	            var _ref3 = contract || {};
	
	            var details = _ref3.details;
	            var documents = _ref3.documents;
	
	            var c = contract || {};
	            var columns = contract && [[{ label: _('insuranceCompany'), value: c && c.insuranceCompany }, { label: _('contractState'), value: c && c.contractState }, { label: _('startDate'), value: details && (0, _moment2['default'])(details.startDate).format('DD-MM-YYYY') }, { label: _('collectType'), value: details && details.collectType }, { label: _('bonusMalus'), value: details && details.bonusMalus }, { label: _('premium'), value: details && _(details.unpaidInvoices) }], [{ label: _('brokerNumber'), value: details && details.brokerNumber }, { label: _('dueDate'), value: details && (0, _moment2['default'])(details.dueDate, 'MM-DD').format('DD-MM') }, { label: _('endDate'), value: details && (0, _moment2['default'])(details.endDate).format('DD-MM-YYYY') }, { label: _('frequency'), value: details && details.frequency }, { label: _('termination'), value: (details && details.terminationType) + ' ' + (details && details.terminationDate) + ' ' + (details && details.terminationReason) }]];
	
	            // if have value then push
	            if (details && details.characteristicValue) {
	
	                // translator version
	                /* columns[1].push({
	                    label: characteristicTypeDict && details && details.characteristicType && characteristicTypeDict[details.characteristicType] || _('characteristicValue'),
	                    value: details && details.characteristicValue || ""
	                }) */
	
	                columns[1].push({
	                    label: details && details.characteristicType || _('characteristicValue'),
	                    value: details && details.characteristicValue || ""
	                });
	            }
	
	            var moduleKeyToSet = _nestedProperty2['default'].get(this.props, "EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value") || false;
	
	            // process the contract creation state to fetch an initial state for uploader module
	            var uploadForceState = this.getUploadStateByContractState(createContractState);
	            var uploadForceDescription = this.getUploadDescriptionByContractState(createContractState);
	            var brokerNumber = _nestedProperty2['default'].get(contract, "details.brokerNumber");
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _clientContractsZoomScss2['default'].clientContractsZoomContainer },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientContractsZoomScss2['default'].mainTitleDiv },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractsZoomScss2['default'].moduleControls },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientContractsZoomScss2['default'].buttonOrganizer },
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        dispatch((0, _stateActions.setOpenedSubmenu)());
	                                    }, className: _clientContractsZoomScss2['default'].backToList
	                                },
	                                _('backToContracts')
	                            ),
	                            createmail && initializationCompleted && _react2['default'].createElement(_emailSenderEmailButton2['default'], { moduleKeyToSet: moduleKeyToSet, moduleOptions: this.collectVariableValues() }),
	                            canCreateMifid && _react2['default'].createElement(
	                                'div',
	                                { className: _clientContractsZoomScss2['default'].wizardButtonCorrection },
	                                _react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
	                                    moduleKeyToSet: createContractState && createContractState === _stateConstants.CONTRACT_PRE_MANDATE ? _stateConstants.DS_MODULE_CLIENT_CONTRACT_PREM : _stateConstants.DS_MODULE_CLIENT_CONTRACT,
	                                    clientId: clientId,
	                                    contractId: contractIdForMifid,
	                                    callBackOnClose: function () {
	                                        return _this4.resetDataFromStoreOnCancel();
	                                    },
	                                    forceOpenPrem: createContractState && createContractState === _stateConstants.CONTRACT_PRE_MANDATE ? true : false,
	                                    moduleOptions: this.collectVariableValues(),
	                                    ticketId: ticketId,
	                                    ticketDocuments: ticketDocuments,
	                                    selectedTicketDocuments: selectedTicketDocuments,
	                                    emailAttachmentTicketDocuments: emailAttachmentTicketDocuments
	                                })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientContractsZoomScss2['default'].wizardButtonCorrection },
	                                    _react2['default'].createElement(_ClaimsWizardClaimWizardButton2['default'], {
	                                        contractNumber: contract.contractNumber,
	                                        contractId: contractIdForMifid,
	                                        clientId: clientId,
	                                        brokerNumber: brokerNumber,
	                                        isClientContract: true,
	                                        onCloseMethod: function () {
	                                            return _this4.fetchData();
	                                        }
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                contract && _react2['default'].createElement(
	                    'div',
	                    { className: _clientContractsZoomScss2['default'].clientContractZoom },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientContractsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _clientContractsZoomScss2['default'].subTitle },
	                                _('contractNumber'),
	                                ' ',
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    contract.contractNumber
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(_KeyValue2['default'], { array: columns, divider: true })
	                    ),
	                    details && details.risks && details.risks.length && _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientContractsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _clientContractsZoomScss2['default'].subTitle },
	                                _('riskHeader')
	                            )
	                        ),
	                        details.risks.map(function (item, key) {
	                            return _react2['default'].createElement(Risk, { key: key, data: item });
	                        })
	                    ),
	                    claims.length > 0 && _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(Claims, {
	                            zoomTo: function (claimId) {
	                                dispatch((0, _stateActions.setClientSubModule)('claims'));
	                                dispatch((0, _stateActions.setOpenedSubmenu)(claimId));
	                            },
	                            data: claims
	                        })
	                    ),
	                    documents && _react2['default'].createElement(_uploader2['default'], {
	                        type: 'contract',
	                        documents: documents,
	                        id: contract.contractId,
	                        clientId: clientId,
	                        forceState: uploadForceState,
	                        forceDescription: uploadForceDescription
	                    })
	                )
	            );
	        }
	    }]);
	
	    var _ClientContractsZoom = ClientContractsZoom;
	    ClientContractsZoom = (0, _reactRedux.connect)(function (state, props) {
	        var contract = props.contract;
	        var clientData = props.clientData;
	
	        var clientId = state.app.opened;
	        var clientClaims = state.clients.claims[clientId];
	        var claims = clientClaims && clientClaims.filter(function (item) {
	            return item.claimMain.contractNumber === contract.contractNumber;
	        }) || [];
	        var clientAccess = _nestedProperty2['default'].get(state, "app.security.actions");
	        var EmailTemplateRelations = state.app.security.EmailTemplateRelations;
	        var brNr = state.app.brNr;
	        var createContractState = state.clients.createContractState;
	        var canCreateMifid = false;
	        var selectedTicketDocuments = _nestedProperty2['default'].get(state, "clients.initialArguments.selectedTicketDocuments");
	        var ticketDocuments = _nestedProperty2['default'].get(state, "clients.initialArguments.ticketDocuments");
	        var ticketId = _nestedProperty2['default'].get(state, "clients.initialArguments.ticketId");
	        var emailAttachmentTicketDocuments = _nestedProperty2['default'].get(state, "clients.initialArguments.emailAttachmentTicketDocuments");
	        var claimStatus = state.claimWizard.claimData ? state.claimWizard.claimData.claimStatus : null;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createmifid') {
	                canCreateMifid = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        return {
	            clientId: clientId,
	            claims: claims,
	            EmailTemplateRelations: EmailTemplateRelations,
	            clientAccess: clientAccess, clientData: clientData, brNr: brNr,
	            clientOptionsDict: state.client.clientOptionsDict,
	            appLanguage: state.app.lang,
	            office: state.office,
	            canCreateMifid: canCreateMifid,
	            createContractState: createContractState,
	            ticketDocuments: ticketDocuments,
	            selectedTicketDocuments: selectedTicketDocuments,
	            ticketId: ticketId,
	            emailAttachmentTicketDocuments: emailAttachmentTicketDocuments,
	            claimStatus: claimStatus
	        };
	    })(ClientContractsZoom) || ClientContractsZoom;
	    return ClientContractsZoom;
	})(_react2['default'].Component);
	
	exports['default'] = ClientContractsZoom;
	module.exports = exports['default'];

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(57);
	
	var _clientsScss = __webpack_require__(244);
	
	var _clientsScss2 = _interopRequireDefault(_clientsScss);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _input = __webpack_require__(109);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _libHelpers = __webpack_require__(24);
	
	var _clientProfileForm = __webpack_require__(265);
	
	var _clientProfileForm2 = _interopRequireDefault(_clientProfileForm);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var fieldType = {
	    name: 'multiple',
	    dateOfBirth: 'multiple',
	    street: 'multiple',
	    postalCode: 'multiple',
	    email: 'multiple',
	    phoneNumber: 'multiple',
	    contractNumber: 'unique',
	    clientNumber: 'unique',
	    tarificationNumber: 'unique',
	    claimNumber: 'unique',
	    claimRefBroker: 'unique',
	    licencePlate: "unique",
	    companyRegistrationNumber: "multiple",
	    myEasinsure: "multiple",
	    needsAnalysis: "multiple",
	    clientFile: "multiple"
	};
	
	var validate = function validate(values) {
	    var errors = {};
	    var formattedData = (0, _libHelpers.trimObject)(values);
	    var isEmpty = !(0, _libHelpers.hasContent)(formattedData);
	    if (isEmpty) {
	        errors._error = 'emptyFields';
	    }
	    return errors;
	};
	
	var ClientsForm = (function (_React$Component) {
	    _inherits(ClientsForm, _React$Component);
	
	    function ClientsForm(props) {
	        _classCallCheck(this, _ClientsForm);
	
	        _get(Object.getPrototypeOf(_ClientsForm.prototype), 'constructor', this).call(this, props);
	        this.state = { characteristicOptions: [], characteristicValueTouched: false };
	    }
	
	    _createClass(ClientsForm, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextPorps) {
	            var clientOptionsDict = nextPorps.clientOptionsDict;
	            var lang = nextPorps.lang;
	
	            // process raw option dict data for select
	            this.handleClientOptionsDictPropChange(clientOptionsDict, lang);
	        }
	
	        /**
	         * This function process the client option dic (oracle provided translations) for
	         * the react select of user characteristics
	         * @param {object} clientOptionsDict - oracle provided translations
	         * @param {string} lang - the current language of page
	         */
	    }, {
	        key: 'handleClientOptionsDictPropChange',
	        value: function handleClientOptionsDictPropChange(clientOptionsDict, lang) {
	            var _this = this;
	
	            var characteristicOptions = [];
	
	            if (clientOptionsDict && clientOptionsDict.KENMERKTYPE) {
	                (function () {
	                    var charTypes = clientOptionsDict.KENMERKTYPE;
	                    Object.keys(charTypes).map(function (oneCharacteristicKey) {
	                        characteristicOptions.push({
	                            value: oneCharacteristicKey,
	                            label: charTypes[oneCharacteristicKey][lang]
	                        });
	                    });
	
	                    _this.setState({ characteristicOptions: characteristicOptions });
	                })();
	            }
	        }
	
	        /**
	         * This will set the form value content in store
	         */
	    }, {
	        key: 'updateFormValue',
	        value: function updateFormValue(value, field) {
	            var dispatch = this.props.dispatch;
	
	            dispatch({
	                type: "redux-form/CHANGE",
	                field: field.name,
	                value: value && value.value || '',
	                touch: value && (value.touched === false ? false : typeof value.touched == undefined ? field.touched : false),
	                form: "clients"
	            });
	
	            // to enforce of update of disabled buttons and validations refresh
	            this.forceUpdate();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var canCreateOnlyLegalClient = this.props.canCreateOnlyLegalClient;
	
	            var columns = [['name', 'dateOfBirth', 'street', 'postalCode', 'email', 'phoneNumber'], ['contractNumber', 'clientNumber', 'tarificationNumber', 'claimNumber', 'claimRefBroker', 'licencePlate', 'companyRegistrationNumber', 'myEasinsure', 'needsAnalysis', 'clientFile']];
	
	            var isTernary = {
	                myEasinsure: true,
	                needsAnalysis: true,
	                clientFile: true
	            };
	
	            var _props = this.props;
	            var fields = _props.fields;
	            var _props$fields = _props.fields;
	            var state = _props$fields.state;
	            var characteristicType = _props$fields.characteristicType;
	            var characteristicValue = _props$fields.characteristicValue;
	            var contractNumber = _props$fields.contractNumber;
	            var claimRefBroker = _props$fields.claimRefBroker;
	            var claimNumber = _props$fields.claimNumber;
	            var handleSubmit = _props.handleSubmit;
	            var error = _props.error;
	            var createClientAccess = _props.createClientAccess;
	            var openModal = _props.openModal;
	            var modalState = _props.modalState;
	            var characteristicOptions = this.state.characteristicOptions;
	
	            var usedField = (0, _lodashCollection.find)(fields, function (field) {
	                return field.value;
	            });
	            var usedType = usedField && fieldType[usedField.name];
	            var invalid = error === 'emptyFields';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _clientsScss2['default'].formContainerOuter },
	                _react2['default'].createElement(
	                    'form',
	                    { onSubmit: handleSubmit, name: 'clients', className: 'clients' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientsScss2['default'].formContainer },
	                        columns.map(function (col, i) {
	                            return _react2['default'].createElement(
	                                'div',
	                                { key: i, className: _clientsScss2['default'].column },
	                                col.map(function (name) {
	                                    return _react2['default'].createElement(
	                                        'div',
	                                        { key: name, className: _clientsScss2['default'].searchContainer },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientsScss2['default'].label },
	                                            _(name)
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _clientsScss2['default'].clientSearchInput },
	                                            _react2['default'].createElement(_input2['default'], _extends({
	                                                autoFocus: name === 'name',
	                                                disabled: (usedType ? usedField.name !== name && (usedType === 'unique' ? true : usedType !== fieldType[name]) : false) || characteristicType.value,
	                                                type: isTernary[name] ? "ternary" : "text"
	                                            }, fields[name]))
	                                        )
	                                    );
	                                })
	                            );
	                        }),
	                        _react2['default'].createElement(
	                            'div',
	                            { key: 'extraSearchPossibilitiesCol1Key', className: _clientsScss2['default'].column },
	                            _react2['default'].createElement(
	                                'div',
	                                { key: 'extraSearchPossibilitiesRow1Key', className: _clientsScss2['default'].searchContainerSeparated },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientsScss2['default'].label },
	                                    _('selectCharacteristicsLabel')
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientsScss2['default'].clientSearchInput },
	                                    _react2['default'].createElement(_componentsSharedSelectSelectWrap.SelectWrapper, _extends({
	                                        className: (0, _classnames2['default'])(_clientsScss2['default'].inputCharacteristics, contractNumber.value ? _clientsScss2['default'].disabled : ''),
	                                        autoFocus: false,
	                                        isDisabled: contractNumber.value,
	                                        isClearable: true,
	                                        options: characteristicOptions
	                                    }, characteristicType, {
	                                        onChange: function (value) {
	                                            if (!value || !value.value) {
	                                                _this2.setState({ characteristicValueTouched: false });
	                                                characteristicValue.onChange('');
	                                            }
	                                            characteristicType.onChange(value);
	                                        }
	                                    }))
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { key: 'extraSearchPossibilitiesCol2Key', className: _clientsScss2['default'].column },
	                            _react2['default'].createElement(
	                                'div',
	                                { key: 'extraSearchPossibilitiesRow2Key', className: _clientsScss2['default'].searchContainerSeparated },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientsScss2['default'].clientSearchInputLong },
	                                    _react2['default'].createElement(_input2['default'], {
	                                        type: "text",
	                                        disabled: !characteristicType.value,
	                                        value: characteristicValue.value,
	                                        onChange: function (value) {
	                                            _this2.setState({ characteristicValueTouched: true });
	                                            characteristicValue.onChange(value);
	                                        }
	                                    })
	                                )
	                            )
	                        ),
	                        !(characteristicValue.value && characteristicType.value || !characteristicValue.value && !characteristicType.value) && this.state.characteristicValueTouched && _react2['default'].createElement(
	                            'div',
	                            { key: 'extraSearchPossibilitiesCol3Key', className: (0, _classnames2['default'])(_clientsScss2['default'].column, _clientsScss2['default'].fullColumn) },
	                            _react2['default'].createElement(
	                                'div',
	                                { key: 'extraSearchPossibilitiesRow3Key', className: _clientsScss2['default'].searchContainerSeparated },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_clientsScss2['default'].label, _clientsScss2['default'].error) },
	                                    _('mustFillEachCharacteristicField')
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { style: { display: 'flex', gap: '2px', widdth: '100%' } },
	                        _react2['default'].createElement(
	                            'button',
	                            {
	                                className: _clientsScss2['default'].greyButton,
	                                disabled: invalid || characteristicValue.value && !characteristicType.value || !characteristicValue.value && characteristicType.value,
	                                onClick: handleSubmit,
	                                type: 'submit'
	                            },
	                            _('submitbutton')
	                        ),
	                        createClientAccess && _react2['default'].createElement(
	                            'button',
	                            {
	                                className: _clientsScss2['default'].greyButton + ' btn',
	                                onClick: function (e) {
	                                    openModal(e);
	                                }
	                            },
	                            _('create-profile')
	                        )
	                    )
	                ),
	                modalState && _react2['default'].createElement('div', { className: _clientsScss2['default'].overlayMap }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_clientsScss2['default'].customCreateModal, modalState === true && _clientsScss2['default'].isOpened) },
	                    modalState && _react2['default'].createElement(_clientProfileForm2['default'], { canCreateOnlyLegalClient: canCreateOnlyLegalClient, openModal: openModal })
	                )
	            );
	        }
	    }]);
	
	    var _ClientsForm = ClientsForm;
	    ClientsForm = (0, _reactRedux.connect)(function (state) {
	        var clientAccess = state.app.security.actions;
	
	        var canCreateOnlyLegalClient = clientAccess && clientAccess.filter(function (item) {
	            return item.actionName == "createonlylegalclient" && item.actionAllowed == "true";
	        }).length > 0;
	
	        return {
	            canCreateOnlyLegalClient: canCreateOnlyLegalClient
	        };
	    })(ClientsForm) || ClientsForm;
	    ClientsForm = (0, _reduxForm.reduxForm)({
	        form: "clients",
	        fields: Object.keys(fieldType).concat(['characteristicValue', 'characteristicType']),
	        error: _react2['default'].PropTypes.string,
	        validate: validate
	    })(ClientsForm) || ClientsForm;
	    return ClientsForm;
	})(_react2['default'].Component);
	
	exports['default'] = ClientsForm;
	module.exports = exports['default'];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _attachmentDialogScss = __webpack_require__(1606);
	
	var _attachmentDialogScss2 = _interopRequireDefault(_attachmentDialogScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _uploader = __webpack_require__(143);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _ = (0, _libI18n2['default'])('attachmentDialog');
	var _uploaderTranslations = (0, _libI18n2['default'])('uploader');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex', justifyContent: 'center', alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%', overflow: 'auto', padding: '0'
	    }
	};
	
	/**
	 * This module will handle oracle documents selection for both email attachments and dsWizard oracle documents selection
	 */
	
	var AttachmentDialog = (function (_React$Component) {
	    _inherits(AttachmentDialog, _React$Component);
	
	    _createClass(AttachmentDialog, null, [{
	        key: 'propTypes',
	        value: {
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func,
	            cancelLabel: _react2['default'].PropTypes.string,
	            confirmationLabel: _react2['default'].PropTypes.string,
	            moduleOptions: _react2['default'].PropTypes.any.isRequired,
	            moduleKey: _react2['default'].PropTypes.string,
	            selected0: _react2['default'].PropTypes.array,
	            selected1: _react2['default'].PropTypes.array,
	            selected2: _react2['default'].PropTypes.array,
	            selected3: _react2['default'].PropTypes.array,
	            selected4: _react2['default'].PropTypes.array,
	            ticketDocuments: _react2['default'].PropTypes.array
	        },
	
	        /**
	         * Constructor.
	         * Here initialize the state values
	         * @param {*} props
	         */
	        enumerable: true
	    }]);
	
	    function AttachmentDialog(props) {
	        _classCallCheck(this, _AttachmentDialog);
	
	        _get(Object.getPrototypeOf(_AttachmentDialog.prototype), 'constructor', this).call(this, props);
	
	        var moduleOptions = props.moduleOptions;
	        var isDsWizard = props.isDsWizard;
	        var ticketDocuments = props.ticketDocuments;
	
	        var tabIndex = 0;
	
	        // decide the initial tabIndex after module key
	        if (isDsWizard) {
	            tabIndex = moduleOptions && moduleOptions.clientDocuments && moduleOptions.clientDocuments.length > 0 ? 2 : moduleOptions.claimDocuments && moduleOptions.claimDocuments.length > 0 ? 0 : moduleOptions.contractDocuments && moduleOptions.contractDocuments.length > 0 ? 1 : moduleOptions.tarificationDocuments && moduleOptions.tarificationDocuments.length > 0 ? 3 : ticketDocuments && ticketDocuments.length > 0 ? 4 : 0;
	
	            // On modules mut selected the tab what have the specified documents
	            // BEWB-723
	            switch (props.moduleKey) {
	                // universal module detection, (the module keys are uset to identify the react modules,
	                // but the EmailTemplateModules have mroe values and differ. On initialistaion this module got,
	                // the react module contans, but must work with other one, because the attachment
	                // modal originally was made for emails attachment composition not for DSWizard!
	                // So not was planed to be universal file selector over the hole project)
	                case _stateConstants2['default'].DS_MODULE_CLIENT_TARIFICATION:
	                case props.EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value:
	                    {
	                        if (moduleOptions.tarificationId) {
	                            tabIndex = 3;
	                        }
	                        break;
	                    }
	                case _stateConstants2['default'].DS_MODULE_CLIENT_PROFILE:
	                case props.EmailTemplateRelations.EmailTemplateModules.clientsProfile.value:
	                    {
	                        if (moduleOptions && moduleOptions.clientId) {
	                            tabIndex = 2;
	                        }
	                        break;
	                    }
	                case _stateConstants2['default'].DS_MODULE_CLIENT_CONTRACT:
	                case props.EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value:
	                    {
	                        if (moduleOptions.contractId) {
	                            tabIndex = 1;
	                        }
	                        break;
	                    }
	                case _stateConstants2['default'].DS_MODULE_CLIENT_CLAIMS:
	                case props.EmailTemplateRelations.EmailTemplateModules.claims.value:
	                case props.EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value:
	                    {
	                        if (moduleOptions.claimId) {
	                            tabIndex = 0;
	                        }
	                        break;
	                    }
	                case props.EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value:
	                    {
	                        if (ticketDocuments && ticketDocuments.length > 0) {
	                            tabIndex = 4;
	                        }
	                    }
	            }
	        } else {
	            switch (props.moduleKey) {
	                case props.EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value:
	                    {
	                        tabIndex = 3;
	                        break;
	                    }
	                case props.EmailTemplateRelations.EmailTemplateModules.clientsProfile.value:
	                    {
	                        tabIndex = 2;
	                        break;
	                    }
	                case props.EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value:
	                    {
	                        tabIndex = 1;
	                        break;
	                    }
	                case props.EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value:
	                    {
	                        tabIndex = 0;
	                        break;
	                    }
	                case props.EmailTemplateRelations.EmailTemplateModules.claims.value:
	                    {
	                        tabIndex = 0;
	                        break;
	                    }
	                case props.EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value:
	                    {
	                        tabIndex = 4;
	                        break;
	                    }
	            }
	        }
	
	        this.state = { selected0: [], selected1: [], selected2: [], selected3: [], selected4: [], tabIndex: tabIndex };
	    }
	
	    /**
	     * This function triggered when the component receive props
	     * @param {*} nextProps
	     * @param {*} props
	     */
	
	    _createClass(AttachmentDialog, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps, props) {
	            // update "selected0" in state when receive new props
	            if (JSON.stringify(nextProps.selected0) != JSON.stringify(this.state.selected0)) {
	                this.setState({ selected0: nextProps.selected0 });
	            }
	
	            // update "selected1" in state when receive new props
	            if (JSON.stringify(nextProps.selected1) != JSON.stringify(this.state.selected1)) {
	                this.setState({ selected1: nextProps.selected1 });
	            }
	
	            // update "selected2" in state when receive new props
	            if (JSON.stringify(nextProps.selected2) != JSON.stringify(this.state.selected2)) {
	                this.setState({ selected2: nextProps.selected2 });
	            }
	
	            // update "selected3" in state when receive new props
	            if (JSON.stringify(nextProps.selected3) != JSON.stringify(this.state.selected3)) {
	                this.setState({ selected3: nextProps.selected3 });
	            }
	
	            // update "selected4" in state when receive new props
	            if (JSON.stringify(nextProps.selected4) != JSON.stringify(this.state.selected4)) {
	
	                // check if the value can be destructured, so that is an array no undefined
	                var selected4 = [];
	                if (nextProps.selected4 && nextProps.selected4.length > 0) {
	                    selected4 = [].concat(_toConsumableArray(nextProps.selected4));
	                }
	
	                this.setState({ selected4: selected4 });
	            }
	
	            // update "selected4" in state when receive new props
	            // if (JSON.stringify(nextProps.moduleOptions) !== JSON.stringify(this.props.moduleOptions)) {
	            //     console.log("ATT DIALOG nextProps.moduleOptions", nextProps.moduleOptions )
	            // }
	        }
	
	        /**
	         * This function render the default document selector (uploader) for email sender
	         */
	    }, {
	        key: 'renderClaimsUploader',
	        value: function renderClaimsUploader() {
	            var _this = this;
	
	            var _props = this.props;
	            var selected0 = _props.selected0;
	            var moduleOptions = _props.moduleOptions;
	
	            return _react2['default'].createElement(_uploader2['default'], {
	                type: moduleOptions.claimDocumentsType,
	                documents: moduleOptions.claimDocuments,
	                id: moduleOptions.claimDocumentsId,
	                selectable: true,
	                selected: selected0,
	                selectedUpdaterCallback: function (result) {
	                    _this.setState({ selected0: result });
	                }
	            });
	        }
	
	        /**
	         * This function render the default document selector (uploader) for email sender
	         */
	    }, {
	        key: 'renderContractUploader',
	        value: function renderContractUploader() {
	            var _this2 = this;
	
	            var _props2 = this.props;
	            var selected1 = _props2.selected1;
	            var moduleOptions = _props2.moduleOptions;
	
	            return _react2['default'].createElement(_uploader2['default'], {
	                type: moduleOptions.contractDocumentsType,
	                documents: moduleOptions.contractDocuments,
	                id: moduleOptions.contractDocumentsId,
	                selectable: true,
	                selected: selected1,
	                selectedUpdaterCallback: function (result) {
	                    _this2.setState({ selected1: result });
	                }
	            });
	        }
	
	        /**
	         * This function render the secondary document selector (client document) for email sender
	         */
	    }, {
	        key: 'renderClientUploader',
	        value: function renderClientUploader() {
	            var _this3 = this;
	
	            var _props3 = this.props;
	            var selected2 = _props3.selected2;
	            var moduleOptions = _props3.moduleOptions;
	
	            return _react2['default'].createElement(_uploader2['default'], {
	                type: moduleOptions.clientDocumentsType,
	                documents: moduleOptions.clientDocuments,
	                id: moduleOptions.clientDocumentsId,
	                selectable: true,
	                selected: selected2,
	                selectedUpdaterCallback: function (result) {
	                    _this3.setState({ selected2: result });
	                }
	            });
	        }
	
	        /**
	         * This function render the default document selector (uploader) for email sender
	         */
	    }, {
	        key: 'renderTarificationUploader',
	        value: function renderTarificationUploader() {
	            var _this4 = this;
	
	            var _props4 = this.props;
	            var selected3 = _props4.selected3;
	            var moduleOptions = _props4.moduleOptions;
	
	            return _react2['default'].createElement(_uploader2['default'], {
	                type: moduleOptions.tarificationDocumentsType,
	                documents: moduleOptions.tarificationDocuments,
	                id: moduleOptions.tarificationDocumentsId,
	                selectable: true,
	                selected: selected3,
	                selectedUpdaterCallback: function (result) {
	                    _this4.setState({ selected3: result });
	                }
	            });
	        }
	
	        /**
	        * This function render the default document selector (uploader) for dsWizard when opened from inbox
	        */
	    }, {
	        key: 'renderTicketUploader',
	        value: function renderTicketUploader() {
	            var _this5 = this;
	
	            var ticketDocuments = this.props.ticketDocuments;
	            var selected4 = this.state.selected4;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _attachmentDialogScss2['default'].content },
	                _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        filterable: ["documentName"],
	                        ref: function (el) {
	                            _this5.table = el;
	                        },
	                        id: 'table',
	                        className: 'table',
	                        sortable: ['documentName'],
	                        defaultSort: {
	                            column: 'documentName',
	                            direction: 'desc'
	                        },
	
	                        itemsPerPage: 40,
	                        pageButtonLimit: 5
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(_componentsReactable.Th, { column: 'documentMetaCol', label: '' }),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'signCheckbox' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("addToSignLabel")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'documentName' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("documentName")
	                            )
	                        )
	                    ),
	                    ticketDocuments && ticketDocuments.length && ticketDocuments.length > 0 ? ticketDocuments.map(function (item, key) {
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            {
	                                className: 'clickable',
	                                i: item,
	                                key: key
	                            },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'documentMetaCol', className: _attachmentDialogScss2['default'].rowIcon },
	                                _react2['default'].createElement(
	                                    'div',
	                                    null,
	                                    _react2['default'].createElement(
	                                        'div',
	                                        null,
	                                        _react2['default'].createElement('img', { src: __webpack_require__(172) })
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'signCheckbox' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { style: { width: 15 } },
	                                    _react2['default'].createElement('input', {
	                                        type: 'checkbox',
	                                        onClick: function (ev) {
	                                            return ev.stopPropagation();
	                                        },
	                                        onChange: function (ev) {
	                                            return _this5.onSelectedForSigningCheckChange(ev, item);
	                                        },
	                                        checked: _this5.state.selected4 && _this5.state.selected4.findIndex(function (oneSelectedDoc) {
	                                            return oneSelectedDoc.oracleDocumentId === item.oracleDocumentId;
	                                        }) > -1 ? true : false
	                                    })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'documentName', value: item },
	                                JSON.stringify(_this5.state.selected4),
	                                item.oracleDocumentId
	                            )
	                        );
	                    }) : ''
	                )
	            );
	        }
	
	        /**
	        * Handle Ui event for individual checkbox for signing documents
	        * @param {*} ev
	        * @param {*} document
	        */
	    }, {
	        key: 'onSelectedForSigningCheckChange',
	        value: function onSelectedForSigningCheckChange(ev, document) {
	            var selected4 = this.state.selected4;
	
	            var index = selected4.findIndex(function (oneDoc) {
	                return oneDoc.oracleDocumentId === document.oracleDocumentId;
	            });
	            if (index >= 0) {
	                selected4.splice(index, 1);
	            } else {
	                selected4.push(document);
	            }
	            this.setState({ selected4: selected4 });
	        }
	
	        /**
	         * This is a container for primary document selector to show additional message
	         */
	    }, {
	        key: 'renderClientUploaderContainer',
	        value: function renderClientUploaderContainer() {
	            var attachmentModal = this.props.attachmentModal;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _attachmentDialogScss2['default'].content, key: "clientDocumentsContainer" },
	                attachmentModal && attachmentModal.message,
	                this.renderClientUploader()
	            );
	        }
	
	        /**
	         * This will return with the correct title for the tab what describe the type of documents.
	         */
	    }, {
	        key: 'renderTitleForPrimaryTab',
	        value: function renderTitleForPrimaryTab(type) {
	            return type == 'client' && _uploaderTranslations('clientDocuments') || type == 'claim' && _uploaderTranslations('claimDocuments') || type == 'contract' && _uploaderTranslations('contractDocuments') || type == 'tarification' && _uploaderTranslations('tarificationDocumentsTabTitle') || type == 'ticketDocuments' && _uploaderTranslations('ticketDocuments') || _('documents');
	        }
	
	        /**
	         * This function render the tabbed container for more list of documents.
	         */
	    }, {
	        key: 'renderTabbedUploaderContainer',
	        value: function renderTabbedUploaderContainer() {
	            var _this6 = this;
	
	            var _props5 = this.props;
	            var attachmentModal = _props5.attachmentModal;
	            var moduleOptions = _props5.moduleOptions;
	            var EmailTemplateRelations = _props5.EmailTemplateRelations;
	            var moduleKey = _props5.moduleKey;
	            var isDsWizard = _props5.isDsWizard;
	            var ticketDocuments = _props5.ticketDocuments;
	            var tabIndex = this.state.tabIndex;
	
	            var isInboxReplyToWillemot = moduleKey == EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value;
	
	            var isClient = moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value || (isInboxReplyToWillemot || isDsWizard) && moduleOptions && moduleOptions.clientDocuments && moduleOptions.clientDocuments.length > 0 ? true : false;
	            var isClientClaim = moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value || (isInboxReplyToWillemot || isDsWizard) && moduleOptions && moduleOptions.claimId ? true : false;
	            var isClientContract = moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value || (isInboxReplyToWillemot || isDsWizard) && moduleOptions && moduleOptions.contractId ? true : false;
	            var isClaims = moduleKey == EmailTemplateRelations.EmailTemplateModules.claims.value;
	            var isTarification = moduleKey == EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value || isInboxReplyToWillemot || (isInboxReplyToWillemot || isDsWizard) && moduleOptions && moduleOptions.tarificationId ? true : false;
	            var hasTicketDocuments = (isDsWizard || isInboxReplyToWillemot) && ticketDocuments && ticketDocuments.length > 0;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _attachmentDialogScss2['default'].content, key: "documentsContainer" },
	                _react2['default'].createElement('br', null),
	                attachmentModal && attachmentModal.message,
	                _react2['default'].createElement(
	                    'div',
	                    { className: _attachmentDialogScss2['default'].TabContainer },
	                    isClientClaim || isClaims ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].Tab, tabIndex == 0 ? _attachmentDialogScss2['default'].active : ""),
	                            key: 'tab1',
	                            onClick: function () {
	                                _this6.onTabSelect(0);
	                            } },
	                        this.renderTitleForPrimaryTab('claim')
	                    ) : null,
	                    isClientClaim || isClientContract || isClaims ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].Tab, tabIndex == 1 ? _attachmentDialogScss2['default'].active : ""),
	                            key: 'tab2',
	                            onClick: function () {
	                                _this6.onTabSelect(1);
	                            } },
	                        this.renderTitleForPrimaryTab('contract')
	                    ) : null,
	                    isClientClaim || isClientContract || isClient || isClaims || isTarification ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].Tab, tabIndex == 2 ? _attachmentDialogScss2['default'].active : ""),
	                            key: 'tab3',
	                            onClick: function () {
	                                _this6.onTabSelect(2);
	                            } },
	                        this.renderTitleForPrimaryTab('client')
	                    ) : null,
	                    isDsWizard && isTarification || !isDsWizard && (isTarification || isClient) ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].Tab, tabIndex == 3 ? _attachmentDialogScss2['default'].active : ""),
	                            key: 'tab4',
	                            onClick: function () {
	                                _this6.onTabSelect(3);
	                            } },
	                        this.renderTitleForPrimaryTab('tarification')
	                    ) : null,
	                    hasTicketDocuments ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].Tab, tabIndex == 4 ? _attachmentDialogScss2['default'].active : ""),
	                            key: 'tab5',
	                            onClick: function () {
	                                _this6.onTabSelect(4);
	                            } },
	                        this.renderTitleForPrimaryTab('ticketDocuments')
	                    ) : null
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _attachmentDialogScss2['default'].TabContentContainer },
	                    isClientClaim || isClaims ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].tabContent, tabIndex == 0 ? "" : _attachmentDialogScss2['default'].hidden), key: 'tabContent1' },
	                        this.renderClaimsUploader()
	                    ) : null,
	                    isClientClaim || isClientContract || isClaims ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].tabContent, tabIndex == 1 ? "" : _attachmentDialogScss2['default'].hidden), key: 'tabContent2' },
	                        this.renderContractUploader()
	                    ) : null,
	                    isClientClaim || isClientContract || isClient || isClaims || isTarification ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].tabContent, tabIndex == 2 ? "" : _attachmentDialogScss2['default'].hidden), key: 'tabContent3' },
	                        this.renderClientUploader()
	                    ) : null,
	                    isDsWizard && isTarification || !isDsWizard && (isTarification || isClient) ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].tabContent, tabIndex == 3 ? "" : _attachmentDialogScss2['default'].hidden), key: 'tabContent4' },
	                        this.renderTarificationUploader()
	                    ) : null,
	                    hasTicketDocuments ? _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].tabContent, tabIndex == 4 ? "" : _attachmentDialogScss2['default'].hidden), key: 'tabContent5' },
	                        this.renderTicketUploader()
	                    ) : null
	                )
	            );
	        }
	
	        /**
	         * Event for selecting tab
	         * @param {integer} index
	         */
	    }, {
	        key: 'onTabSelect',
	        value: function onTabSelect(index) {
	            this.setState({ tabIndex: index });
	        }
	
	        /**
	         * Render attachment selector.
	         * Render 2 tab for separated attachments possibilities
	         */
	    }, {
	        key: 'renderAttachmentSelector',
	        value: function renderAttachmentSelector() {
	            var _props6 = this.props;
	            var moduleOptions = _props6.moduleOptions;
	            var moduleKey = _props6.moduleKey;
	            var EmailTemplateRelations = _props6.EmailTemplateRelations;
	            var isDsWizard = _props6.isDsWizard;
	
	            // Always show each tab, but not on client module!
	            var isThisTheClientModule = moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value;
	
	            return isThisTheClientModule ? this.renderClientUploaderContainer() : this.renderTabbedUploaderContainer();
	        }
	
	        /**
	         * Main render function of this module
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var _props7 = this.props;
	            var modalIsOpen = _props7.modalIsOpen;
	            var attachmentModal = _props7.attachmentModal;
	            var onCancel = _props7.onCancel;
	            var onConfirmation = _props7.onConfirmation;
	            var cancelLabel = _props7.cancelLabel;
	            var confirmationLabel = _props7.confirmationLabel;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _attachmentDialogScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _attachmentDialogScss2['default'].title },
	                            attachmentModal && attachmentModal.title
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _attachmentDialogScss2['default'].contentWrapper },
	                            this.renderAttachmentSelector(),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _attachmentDialogScss2['default'].buttons },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: onCancel,
	                                        className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].next, _attachmentDialogScss2['default'].enabled, _attachmentDialogScss2['default'].gray)
	                                    },
	                                    cancelLabel
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function (e) {
	                                            onConfirmation(_this7.state.selected0, _this7.state.selected1, _this7.state.selected2, _this7.state.selected3, _this7.state.selected4);
	                                        },
	                                        className: (0, _classnames2['default'])(_attachmentDialogScss2['default'].next, _attachmentDialogScss2['default'].enabled)
	                                    },
	                                    confirmationLabel
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _AttachmentDialog = AttachmentDialog;
	    AttachmentDialog = (0, _reactRedux.connect)(function (state) {
	        return {
	            modalIsOpen: state.emailSender.emailAttModalIsOpen,
	            attachmentModal: state.emailSender.attachmentModal,
	            EmailTemplateRelations: state.app.security.EmailTemplateRelations
	
	        };
	    })(AttachmentDialog) || AttachmentDialog;
	    return AttachmentDialog;
	})(_react2['default'].Component);
	
	exports['default'] = AttachmentDialog;
	module.exports = exports['default'];
	/* <Th column="attachmentCheckbox">
	   <strong>{_("addToEmailAttachment")}</strong>
	</Th> */

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _modalDialogScss = __webpack_require__(722);
	
	var _modalDialogScss2 = _interopRequireDefault(_modalDialogScss);
	
	var _emailSetupScss = __webpack_require__(438);
	
	var _emailSetupScss2 = _interopRequireDefault(_emailSetupScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        wordwrap: "break-word"
	    }
	};
	
	/**
	 * Simple are you sure modal, for general use in office module.
	 */
	
	var AreYouSureDialog = (function (_React$Component) {
	    _inherits(AreYouSureDialog, _React$Component);
	
	    _createClass(AreYouSureDialog, null, [{
	        key: 'propTypes',
	        value: {
	            modalIsOpen: _react2['default'].PropTypes.bool,
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func,
	            title: _react2['default'].PropTypes.string,
	            message: _react2['default'].PropTypes.string,
	            cancelLabel: _react2['default'].PropTypes.string,
	            confirmationLabel: _react2['default'].PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    function AreYouSureDialog(props) {
	        _classCallCheck(this, AreYouSureDialog);
	
	        _get(Object.getPrototypeOf(AreYouSureDialog.prototype), 'constructor', this).call(this, props);
	        this.state = {};
	    }
	
	    _createClass(AreYouSureDialog, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var modalIsOpen = _props.modalIsOpen;
	            var onCancel = _props.onCancel;
	            var onConfirmation = _props.onConfirmation;
	            var cancelLabel = _props.cancelLabel;
	            var confirmationLabel = _props.confirmationLabel;
	            var title = _props.title;
	            var message = _props.message;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _modalDialogScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _modalDialogScss2['default'].title },
	                            title
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _modalDialogScss2['default'].contentWrapper },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_emailSetupScss2['default'].formContent, _modalDialogScss2['default'].content) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _emailSetupScss2['default'].formInputContainer },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: (0, _classnames2['default'])(_emailSetupScss2['default'].formLabel, _emailSetupScss2['default'].sizeS) },
	                                        message
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _modalDialogScss2['default'].buttons },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            // close modal
	                                            return onCancel();
	                                        },
	                                        className: _modalDialogScss2['default'].cancel
	                                    },
	                                    cancelLabel
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            return onConfirmation();
	                                        },
	                                        className: (0, _classnames2['default'])(_modalDialogScss2['default'].next, _modalDialogScss2['default'].enabled)
	                                    },
	                                    confirmationLabel
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AreYouSureDialog;
	})(_react2['default'].Component);
	
	exports['default'] = AreYouSureDialog;
	module.exports = exports['default'];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _this = this;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _libValidator = __webpack_require__(96);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _signatureTemplateCoffee = __webpack_require__(1220);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _md5 = __webpack_require__(1886);
	
	var _md52 = _interopRequireDefault(_md5);
	
	var _ = (0, _libI18n2['default'])('office');
	
	// TODO Here is defined the service url for getting broker logo, but we have to provide it from a common place.
	//const URL_BROKER_LOGO = window.location.protocol+'//'+window.location.hostname+'/brokerLogo?brokerNumber='
	var URL_BROKER_LOGO = window.location.protocol + '//' + window.location.href.split("/")[2] + '/brokerLogo?brokerNumber=';
	var LOGO_PLACEHOLDER_URL = window.location.protocol + '//' + window.location.href.split("/")[2] + '/uploads/brokerLogos/';
	var LOGO_PLACEHOLDER_TRANSPARENT = 'logoPlaceholder.png';
	var LOGO_PLACEHOLDER_EN = 'placeOfLogoEn.png';
	var LOGO_PLACEHOLDER_FR = 'placeOfLogoFr.png';
	var LOGO_PLACEHOLDER_NL = 'placeOfLogoNl.png';
	var logoPlaceHolderNl = LOGO_PLACEHOLDER_URL + LOGO_PLACEHOLDER_NL;
	var logoPlaceHolderFr = LOGO_PLACEHOLDER_URL + LOGO_PLACEHOLDER_FR;
	var logoPlaceHolderEn = LOGO_PLACEHOLDER_URL + LOGO_PLACEHOLDER_EN;
	var logoPlaceHolderTransparent = LOGO_PLACEHOLDER_URL + LOGO_PLACEHOLDER_TRANSPARENT;
	
	/**
	 * This will update signature for brokers who don't has right to update the signature
	 *
	 * @param {*} theBroker
	 * @param {*} userId
	 * @param {*} userFullName
	 * @param {*} lang
	 */
	var signatureGenerator = function signatureGenerator(theBroker, userId, userFullName, lang) {
	
	    if (!theBroker || !theBroker.main) {
	        return '';
	    }
	
	    // wait with html processing until the logo is cached
	    var workOnLogoAndReplacementsPromise = new Promise(function callee$1$0(resolve, reject) {
	        var noCache, promiseForLogoLink, replacements;
	        return regeneratorRuntime.async(function callee$1$0$(context$2$0) {
	            while (1) switch (context$2$0.prev = context$2$0.next) {
	                case 0:
	                    noCache = true;
	                    context$2$0.next = 3;
	                    return regeneratorRuntime.awrap(getLogoLinkPromise(theBroker.brokerNumber, lang, noCache));
	
	                case 3:
	                    promiseForLogoLink = context$2$0.sent;
	                    replacements = generateSignatureReplaceData(theBroker, userId, userFullName, lang);
	
	                    replacements.URL_BROKER_LOGO = promiseForLogoLink;
	
	                    return context$2$0.abrupt('return', resolve(parseAndReplaceVariables(_signatureTemplateCoffee.signatureTemplate, replacements)));
	
	                case 7:
	                case 'end':
	                    return context$2$0.stop();
	            }
	        }, null, _this);
	    });
	
	    return workOnLogoAndReplacementsPromise;
	};
	
	/**
	 * Generates the replacement data for the signature
	 * @param {*} theBroker
	 * @param {*} userId
	 * @param {*} userFullName
	 * @param {*} lang
	 * @return {object|null} null if the required data was not found
	 */
	var generateSignatureReplaceData = function generateSignatureReplaceData(theBroker, userId, userFullName, lang) {
	    if (!theBroker || !theBroker.main) {
	        return null;
	    }
	    var brNr = theBroker.brokerNumber;
	    var main = theBroker.main;
	    var employees = theBroker && theBroker.staff;
	    var userName = findUserNameInBrokersStuffByUserId(userId, employees) || userFullName || "--";
	
	    // select the correspondanceAddress if exists else mainAddress.
	    // (the "correspondance" is misspelled because must be "correspondence" not affect functionality
	    // if nobody does not change it)
	    var address = _nestedProperty2['default'].get(main, "correspondanceAddress");
	    if (!address || Object.keys(address).length === 0 || Object.keys(address).filter(function (oneProp) {
	        return address[oneProp];
	    }).length === 0) {
	        address = _nestedProperty2['default'].get(main, "mainAddress");
	    }
	
	    var addressExtension = address.extension ? '/' + address.extension : '';
	    //const addressBus = address.bus ? `/${address.bus}` : ''
	    var fullAddress = '';
	    if (address.street || address.number || addressExtension || address.postalCode || address.locality) {
	        fullAddress = address.street + ' ' + address.number + addressExtension + ', ' + address.postalCode + ' ' + address.locality;
	    }
	
	    var website = (0, _libValidator.isAnURL)(main.website) ? '<a href="' + main.website + '" target="_blank" rel="noopener noreferrer">' + main.website + '</a>' : main.website;
	    var emails = (0, _lodashCollection.map)(main.emails, function (email, i) {
	        return email ? '<a href="mailto:' + email + '">' + email + '</a>' : '';
	    });
	    var phoneNumbers = (0, _lodashCollection.map)(main.phoneNumbers, function (phoneNumber, i) {
	        return phoneNumber ? '<a href="tel:' + phoneNumber + '">' + phoneNumber + '</a>' : '';
	    });
	    var firstPhone = _nestedProperty2['default'].get(phoneNumbers, '0');
	    var fax = main.faxNumber ? '<a href="tel:' + main.faxNumber + '">' + main.faxNumber + '</a>' : '';
	    // const promiseForLogoLink = getLogoLinkPromise(brNr, lang)
	
	    // this is a list of variable what you can use in the template to replace it
	    var replacements = {
	        URL_BROKER_LOGO: URL_BROKER_LOGO + brNr,
	        name: userName, //main.name,
	        commercialName: main.commercialName || main.name, // commercialName if not empty, else office name //+'('+brNr+')'
	        fullAddress: fullAddress,
	        emails: _nestedProperty2['default'].get(emails, '0') ? _('email') + ': ' + _nestedProperty2['default'].get(emails, '0') : '', //emails.join('; '),
	        website: website && website !== 'http://' ? _('website') + ': ' + website : '',
	        // the default phone number, now the first one is the default
	        // phoneNumbers: _('telephone') + ': ' + phoneNumbers.filter((number,index)=>(index==0)).join(', '),
	        phoneNumbers: firstPhone ? _('telephone') + ': ' + firstPhone : '',
	        fax: fax ? _('fax') + ': ' + fax : '',
	        fsma: _('fsma') + ': ' + main.fsmaNumber,
	        companyRegistrationNumber: " - " + _('companyRegistrationNumber') + ': ' + main.companyRegistrationNumber,
	        signatureText: String(main.signatureText).trim() ? " - " + main.signatureText : "",
	
	        // template lookout parameters
	        faxAndPhoneAdditionalCss: fax || firstPhone ? 'height: auto;' : 'height: 0; display: none;',
	        faxAndPhoneSeparator: fax || firstPhone ? '<br/>' : ''
	        //aedesNumber: _('aedesNumber') + ': ' + main.aedesNumber //<span style="font-size: 11px;">{{aedesNumber}}</span>
	    };
	
	    return replacements;
	};
	
	exports.generateSignatureReplaceData = generateSignatureReplaceData;
	/**
	 * Generates an md5 hash from the signature replacement data
	 * @param {Object} signatureData
	 */
	var generateUniqueHashFromSignatureData = function generateUniqueHashFromSignatureData(signatureData) {
	    if (signatureData === null) {
	        return null;
	    }
	
	    var jsonString = (0, _md52['default'])(JSON.stringify(signatureData));
	    return jsonString;
	};
	
	exports.generateUniqueHashFromSignatureData = generateUniqueHashFromSignatureData;
	/**
	 *
	 * @param {*} userId
	 * @param {*} employees
	 */
	var findUserNameInBrokersStuffByUserId = function findUserNameInBrokersStuffByUserId(userId, employees) {
	    var userName = '';
	
	    if (employees && Array.isArray(employees) && employees.length > 0) {
	        var oneEmploye = employees.filter(function (oneEmplItem) {
	            return oneEmplItem.userId == userId;
	        });
	
	        if (oneEmploye && oneEmploye.length > 0) {
	            var eFirstName = oneEmploye[0].firstName || "";
	            var eLastName = oneEmploye[0].lastName || "";
	            userName = eFirstName + " " + eLastName;
	            userName = String(userName).trim();
	        }
	    }
	
	    return userName;
	};
	
	/**
	 *
	 * @param {*} signatureTemplate
	 * @param {*} keyValues
	 */
	var parseAndReplaceVariables = function parseAndReplaceVariables(signatureTemplate, keyValues) {
	    var varKeys = Object.keys(keyValues);
	    var result = '';
	    if (!_underscore2['default'].isEmpty(varKeys) && varKeys.length > 0 && signatureTemplate) {
	        (function () {
	            var searchExp = '',
	                replaceExp = '';
	            result = String(signatureTemplate);
	            varKeys.forEach(function (varKeyValue) {
	                searchExp = varKeyValue || "unknownvar";
	                replaceExp = _nestedProperty2['default'].get(keyValues, varKeyValue) || "";
	                result = result.replace(new RegExp("\{\{" + searchExp + "\}\}", 'g'), replaceExp);
	            });
	        })();
	    }
	    return result;
	};
	
	/**
	 *
	 * @param {*} brNr
	 */
	var getLogoLinkPromise = function getLogoLinkPromise(brNr, lang) {
	    var noCache = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	    return new Promise(function (resolve) {
	        var logoPlaceholderUrl = undefined;
	
	        switch (lang) {
	            case 'nl':
	                logoPlaceholderUrl = logoPlaceHolderNl;
	                break;
	            case 'fr':
	                logoPlaceholderUrl = logoPlaceHolderFr;
	                break;
	            case 'en':
	                logoPlaceholderUrl = logoPlaceHolderEn;
	                break;
	            default:
	                logoPlaceholderUrl = logoPlaceHolderNl;
	        }
	
	        var request = new XMLHttpRequest();
	        var logoUrl = URL_BROKER_LOGO + brNr;
	        var logoUrlNoCache = logoUrl;
	
	        if (noCache) {
	            logoUrlNoCache = logoUrl + '&noCache=true&rnd=' + Math.floor(Math.random() * 10000000);
	        }
	
	        // to enforce the browser for download image
	        logoUrl = logoUrl + '&rnd=' + Math.floor(Math.random() * 10000000);
	
	        request.open('GET', logoUrlNoCache, true);
	        request.timeout = 10000;
	        request.onreadystatechange = function () {
	            if (request.readyState === 4) {
	                if (request.status === 404) {
	                    resolve(logoPlaceholderUrl);
	                } else if (request.status === 200) {
	                    resolve(logoUrl);
	                }
	            }
	        };
	        request.ontimeout = function () {
	            resolve(logoPlaceholderUrl);
	        };
	        request.send();
	    });
	};
	
	/**
	 * This function do replace for the language depended placeholder logo URL to a transparent placeholder.
	 * @param {string} content - the signature content where we want to replace the logo placeholders to be invisible
	 * @returns {string} the input string modified version, what contains the invisible placeholder link
	 */
	var replacePlaceholderToTransparentLogo = function replacePlaceholderToTransparentLogo(content) {
	    if (content) {
	        content = content.replace(logoPlaceHolderEn, logoPlaceHolderTransparent);
	
	        content = content.replace(logoPlaceHolderFr, logoPlaceHolderTransparent);
	
	        content = content.replace(logoPlaceHolderNl, logoPlaceHolderTransparent);
	    }
	
	    return content;
	};
	
	exports.replacePlaceholderToTransparentLogo = replacePlaceholderToTransparentLogo;
	/**
	 * This function do replace for the language depended placeholder logo URL to a nothing.
	 * @param {string} content - the signature content where we want to replace the logo placeholders to be invisible
	 * @returns {string} the input string modified version, what contains the invisible placeholder link
	 */
	var replacePlaceholderToNothing = function replacePlaceholderToNothing(content) {
	    if (content) {
	        var pattern = new RegExp('<img(.*)src="' + logoPlaceHolderEn + '"(.*)\/>', "g");
	        content = content.replace(pattern, '');
	
	        pattern = new RegExp('<img(.*)src="' + logoPlaceHolderFr + '"(.*)\/>', "g");
	        content = content.replace(pattern, '');
	
	        pattern = new RegExp('<img(.*)src="' + logoPlaceHolderNl + '"(.*)\/>', "g");
	        content = content.replace(pattern, '');
	    }
	
	    return content;
	};
	
	exports.replacePlaceholderToNothing = replacePlaceholderToNothing;
	/**
	 * This function do replace for the general transparent logo URL to a placeholder to be
	 * visible for the broker when edit.
	 * @param {string} content - the signature content where we want to replace the invisible logo placeholders
	 * @returns {string} the input string modified version, what contains the visible placeholder links
	 */
	var replaceTransparentLogoToPlaceholder = function replaceTransparentLogoToPlaceholder(content, lang) {
	    var logoPlaceholderUrl = undefined;
	
	    switch (lang) {
	        case 'nl':
	            logoPlaceholderUrl = logoPlaceHolderNl;
	            break;
	        case 'fr':
	            logoPlaceholderUrl = logoPlaceHolderFr;
	            break;
	        case 'en':
	            logoPlaceholderUrl = logoPlaceHolderEn;
	            break;
	        default:
	            logoPlaceholderUrl = logoPlaceHolderNl;
	    }
	
	    if (content) {
	        content = String(content).replace(logoPlaceHolderTransparent, logoPlaceholderUrl);
	    }
	
	    return content;
	};
	
	exports.replaceTransparentLogoToPlaceholder = replaceTransparentLogoToPlaceholder;
	exports['default'] = signatureGenerator;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
					value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var RenderEmails = function RenderEmails(_ref) {
					var emails = _ref.emails;
	
					var result = _react2['default'].createElement(
									'div',
									null,
									emails && emails.map(function (emailAddress, key) {
													return _react2['default'].createElement(
																	'p',
																	{ key: key },
																	_react2['default'].createElement(
																					'a',
																					{ key: key, href: 'mailto:' + emailAddress },
																					emailAddress
																	)
													);
									})
					);
					return result;
	};
	
	exports.RenderEmails = RenderEmails;
	var customModalStyles = {
					overlay: {
									position: 'fixed',
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									backgroundColor: 'rgba(255, 255, 255, 0.75)'
					},
					content: {
									position: 'relative',
									top: 'initial',
									bottom: 'initial',
									left: 'initial',
									right: 'initial',
									maxHeight: '90%',
									overflow: 'auto',
									padding: '0',
									width: '55%'
					}
	};
	exports.customModalStyles = customModalStyles;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ColorSelectWrapperScss = __webpack_require__(1625);
	
	var _ColorSelectWrapperScss2 = _interopRequireDefault(_ColorSelectWrapperScss);
	
	var _lodashGet = __webpack_require__(327);
	
	var _lodashGet2 = _interopRequireDefault(_lodashGet);
	
	var _lodashLast = __webpack_require__(466);
	
	var _lodashLast2 = _interopRequireDefault(_lodashLast);
	
	var _reactSelect = __webpack_require__(105);
	
	var _SelectWrap = __webpack_require__(37);
	
	var i18claimsZoom = (0, _libI18n2['default'])('claimsZoom');
	
	function noOptionsMessage(_ref) {
		var inputValue = _ref.inputValue;
		// eslint-disable-line no-unused-vars
		return i18claimsZoom('noResultsText');
	}
	
	var ColorValue = function ColorValue(_ref2) {
		var innerProps = _ref2.innerProps;
		var data = _ref2.data;
		var selectProps = _ref2.selectProps;
		var isDisabled = _ref2.isDisabled;
		var clearValue = _ref2.clearValue;
	
		var showLabel = selectProps.className.includes('todo-color-select');
	
		function handleMouseDown(event) {
			if (!isDisabled) {
				clearValue();
			}
			event.stopPropagation(); // for sanity's sake
		}
	
		return _react2['default'].createElement(
			'div',
			_extends({}, innerProps, { className: showLabel ? _ColorSelectWrapperScss2['default'].colorValueTodo : _ColorSelectWrapperScss2['default'].colorValue, title: data.label }),
			data.colorCode && _react2['default'].createElement('div', { className: 'color-sqr-value', style: { background: data.colorCode }, onMouseDown: handleMouseDown }),
			showLabel && _react2['default'].createElement(
				'span',
				null,
				data.label
			)
		);
	};
	ColorValue.propTypes = {
		isDisabled: _react.PropTypes.bool,
		data: _react.PropTypes.object, // Option
		clearValue: _react.PropTypes.func,
		innerProps: _react.PropTypes.object,
		selectProps: _react.PropTypes.object
	};
	
	var ColorOption = function ColorOption(_ref3) {
		var innerRef = _ref3.innerRef;
		var innerProps = _ref3.innerProps;
		var data = _ref3.data;
		var selectOption = _ref3.selectOption;
		var children = _ref3.children;
	
		function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			selectOption(data);
		}
	
		return _react2['default'].createElement(
			'div',
			_extends({
				ref: innerRef
			}, innerProps, {
				onMouseDown: handleMouseDown,
				className: _ColorSelectWrapperScss2['default'].colorOption
			}),
			data.colorCode != null && _react2['default'].createElement('div', { style: { background: data.colorCode, width: '15px', height: '15px', marginRight: '5px' } }),
			_react2['default'].createElement(
				'span',
				{ style: { verticalAlign: 'middle', display: 'inline' } },
				children
			)
		);
	};
	ColorOption.propTypes = {
		data: _react.PropTypes.object, // Option
		selectOption: _react.PropTypes.func,
		children: _react.PropTypes.node,
		innerRef: _react.PropTypes.oneOfType([
		// Either a function
		_react.PropTypes.func,
		// Or the instance of a DOM native element (see the note about SSR)
		_react.PropTypes.shape({ current: _react.PropTypes.instanceOf(Element) })]),
		innerProps: _react.PropTypes.object
	};
	
	var ColorValueContainer = function ColorValueContainer(_ref4) {
		var children = _ref4.children;
		var hasValue = _ref4.hasValue;
		var selectProps = _ref4.selectProps;
	
		var props = _objectWithoutProperties(_ref4, ['children', 'hasValue', 'selectProps']);
	
		var lastSelection = (0, _lodashLast2['default'])(selectProps.value);
		var isOpenMenu = selectProps.menuIsOpen;
		var colorValue = (0, _lodashGet2['default'])(lastSelection, 'label', '');
		var showSuggestion = hasValue && isOpenMenu;
	
		return _reactSelect.components.ValueContainer && _react2['default'].createElement(
			_reactSelect.components.ValueContainer,
			_extends({}, props, { className: _ColorSelectWrapperScss2['default'].colorValueContainer }),
			showSuggestion && _react2['default'].createElement(
				'span',
				{ className: 'remove-one' },
				'Press Backspace to remove ' + colorValue
			),
			_react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])({ 'selected-values': hasValue }, { 'selected-values--with-suggestion': showSuggestion }) },
				children
			)
		);
	};
	
	var ColorSelectWrapper = function ColorSelectWrapper(props) {
		return _react2['default'].createElement(_SelectWrap.ReactSelect, _extends({
			isClearable: false,
			isSearchable: false,
			placeholder: '',
			noOptionsMessage: noOptionsMessage,
			components: { Option: ColorOption, MultiValue: ColorValue, ValueContainer: ColorValueContainer },
			isMulti: true,
			joinValues: true,
			hideSelectedOptions: true,
			classNamePrefix: 'select',
			className: _ColorSelectWrapperScss2['default'].colorSelect
		}, props));
	};
	
	exports.ColorSelectWrapper = ColorSelectWrapper;
	var SelectTodoColorWrapper = function SelectTodoColorWrapper(_ref5) {
		var value = _ref5.value;
		var options = _ref5.options;
	
		var props = _objectWithoutProperties(_ref5, ['value', 'options']);
	
		var selectedValue = value;
		if (typeof selectedValue === 'string') {
			// This code enables the select to work with the new react-select
			selectedValue = options.find(function (option) {
				return option.value === selectedValue;
			});
		}
	
		return _react2['default'].createElement(_SelectWrap.ReactSelect, _extends({
			value: selectedValue,
			options: options,
			isClearable: false,
			isSearchable: false,
			placeholder: '',
			noOptionsMessage: noOptionsMessage,
			components: { Option: ColorOption, SingleValue: ColorValue },
			classNamePrefix: 'select',
			className: (0, _classnames2['default'])(_ColorSelectWrapperScss2['default'].colorSelect, 'todo-color-select')
		}, props));
	};
	exports.SelectTodoColorWrapper = SelectTodoColorWrapper;
	SelectTodoColorWrapper.propTypes = {
		value: _react.PropTypes.string,
		options: _react.PropTypes.array
	};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _stateActionsApi = __webpack_require__(125);
	
	var GOT_WILLDOC_URL = 'app/willdoc/GOT_WILLDOC_URL';
	
	exports['default'] = function (state, action) {
		if (state === undefined) state = false;
	
		if (action.type === GOT_WILLDOC_URL) {
			return action.location;
		}
		return state;
	};
	
	var getWillDocUrl = function getWillDocUrl() {
		return function (dispatch, getState) {
			if (!getState().app.willDocUrl) {
				return dispatch((0, _stateActionsApi.apiCall)('/data/wildoc')).then(function (_ref) {
					var location = _ref.location;
					return dispatch({
						type: GOT_WILLDOC_URL,
						location: location
					});
				});
			}
		};
	};
	exports.getWillDocUrl = getWillDocUrl;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementsPillList = __webpack_require__(614);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementsBannerScss = __webpack_require__(1632);
	
	var _elementsBannerScss2 = _interopRequireDefault(_elementsBannerScss);
	
	var Banner = function Banner(_ref) {
		var bold = _ref.bold;
		var beforeLink = _ref.beforeLink;
		var button = _ref.button;
		var afterLink = _ref.afterLink;
		var link = _ref.link;
		var destination = _ref.destination;
		var onClick = _ref.onClick;
		var className = _ref.className;
	
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])(_elementsBannerScss2['default'].mainCon, className) },
			_react2['default'].createElement('div', { className: _elementsBannerScss2['default'].xButton }),
			_react2['default'].createElement(
				'div',
				{ className: _elementsBannerScss2['default'].textCon },
				bold && _react2['default'].createElement(
					'strong',
					null,
					bold,
					': '
				),
				beforeLink && _react2['default'].createElement(
					'span',
					null,
					beforeLink,
					' '
				),
				destination && link && _react2['default'].createElement(
					'a',
					{ target: '_new', href: destination },
					link
				),
				afterLink && _react2['default'].createElement(
					'span',
					null,
					' ',
					afterLink
				)
			),
			button && _react2['default'].createElement(
				_elementsPillList.Pill,
				null,
				_react2['default'].createElement(
					'div',
					{
						className: _elementsBannerScss2['default'].xButton,
						onClick: onClick
					},
					button
				)
			)
		);
	};
	exports['default'] = Banner;
	module.exports = exports['default'];

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FilterInputScss = __webpack_require__(1635);
	
	var _FilterInputScss2 = _interopRequireDefault(_FilterInputScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2["default"])();
	
	var FilterInput = function FilterInput(_ref) {
		var filter = _ref.filter;
		var setFilter = _ref.setFilter;
		var placeholder = _ref.placeholder;
		return _react2["default"].createElement(
			"div",
			{ className: _FilterInputScss2["default"].searchContainer },
			_react2["default"].createElement(
				"div",
				{ className: _FilterInputScss2["default"].searchContent },
				_react2["default"].createElement("div", { className: _FilterInputScss2["default"].searchLogo + " " + _FilterInputScss2["default"].search }),
				_react2["default"].createElement("input", {
					placeholder: placeholder || _('filter'),
					value: filter,
					onChange: function (ev) {
						return setFilter(ev.target.value);
					}
				}),
				filter && _react2["default"].createElement(
					"div",
					{ onClick: function () {
							return setFilter();
						}, className: _FilterInputScss2["default"].removeFilter },
					_react2["default"].createElement(
						"span",
						{ className: _FilterInputScss2["default"].cross },
						"×"
					)
				)
			)
		);
	};
	FilterInput.propTypes = {
		filter: _react.PropTypes.string,
		setFilter: _react.PropTypes.func.isRequired,
		placeholder: _react.PropTypes.string
	};
	
	exports["default"] = FilterInput;
	module.exports = exports["default"];

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PillListScss = __webpack_require__(1636);
	
	var _PillListScss2 = _interopRequireDefault(_PillListScss);
	
	var Pill = function Pill(_ref) {
		var children = _ref.children;
	
		return _react2['default'].createElement(
			'span',
			{ className: _PillListScss2['default'].pill },
			children
		);
	};
	exports.Pill = Pill;
	Pill.propTypes = {
		children: _react.PropTypes.node
	};
	
	var PillList = function PillList(_ref2) {
		var children = _ref2.children;
		var title = _ref2.title;
		var _ref2$noPills = _ref2.noPills;
		var noPills = _ref2$noPills === undefined ? '' : _ref2$noPills;
	
		return _react2['default'].createElement(
			'span',
			{ className: _PillListScss2['default'].wrapper },
			_react2['default'].createElement(
				'span',
				{ className: _PillListScss2['default'].title },
				title,
				': '
			),
			children.length ? children.map(function (pill, i) {
				return _react2['default'].createElement(
					Pill,
					{ key: i },
					pill
				);
			}) : _react2['default'].createElement(
				'span',
				{ className: _PillListScss2['default'].noPills },
				noPills
			)
		);
	};
	exports.PillList = PillList;
	PillList.propTypes = {
		children: _react.PropTypes.arrayOf(_react.PropTypes.node).isRequired,
		title: _react.PropTypes.string.isRequired,
		noPills: _react.PropTypes.node
	};
	
	exports['default'] = PillList;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _actionsApi = __webpack_require__(125);
	
	var _stateActions = __webpack_require__(5);
	
	var LOADED = 'app/categories/LOADED';
	
	exports['default'] = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? { _gen: 0 } : arguments[0];
		var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		switch (action.type) {
			case LOADED:
				{
					var categories = action.categories;
	
					categories._gen = state._gen + 1;
					return categories;
				}
			default:
				return state;
		}
	};
	
	var getCategories = function getCategories() {
		return function (dispatch) {
			return dispatch((0, _actionsApi.apiCall)("/api/getCategories")).then(function (response) {
				return dispatch({ type: LOADED, categories: response });
			})['catch'](function () {
				return dispatch((0, _stateActions.setNotification)('Categories could not be fetched.', 'error'));
			});
		};
	};exports.getCategories = getCategories;
	// eslint-disable-line no-alert

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _actionsApi = __webpack_require__(125);
	
	var _stateActions = __webpack_require__(5);
	
	var LOADED = 'app/sources/LOADED';
	
	exports['default'] = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? { _gen: 0 } : arguments[0];
		var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		switch (action.type) {
			case LOADED:
				{
					var sources = action.sources;
	
					sources._gen = state._gen + 1;
					return sources;
				}
			default:
				return state;
		}
	};
	
	var getSources = function getSources() {
		return function (dispatch) {
			return dispatch((0, _actionsApi.apiCall)("/api/getSources")).then(function (response) {
				return dispatch({ type: LOADED, sources: response });
			})['catch'](function () {
				return dispatch((0, _stateActions.setNotification)('Sources could not be fetched.', 'error'));
			});
		};
	};exports.getSources = getSources;
	// eslint-disable-line no-alert

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _actionsApi = __webpack_require__(125);
	
	var _stateActions = __webpack_require__(5);
	
	var LOADED = 'app/texts/LOADED';
	
	exports['default'] = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		switch (action.type) {
			case LOADED:
				{
					var id = action.id;
					var text = action.text;
	
					return _extends({}, state, _defineProperty({}, id, text));
				}
			default:
				return state;
		}
	};
	
	var getText = function getText(id) {
		return function (dispatch) {
			return dispatch((0, _actionsApi.apiCall)('/api/getText/' + id)).then(function (text) {
				dispatch({ type: LOADED, id: id, text: text });
			})['catch'](function () {
				return dispatch((0, _stateActions.setNotification)('Text ' + id + ' could not be fetched.', 'error'));
			});
		};
	};
	exports.getText = getText;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reduxAddressbar = __webpack_require__(2170);
	
	var _reduxAddressbar2 = _interopRequireDefault(_reduxAddressbar);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _stateActions = __webpack_require__(5);
	
	var _jsurl = __webpack_require__(1676);
	
	var _jsurl2 = _interopRequireDefault(_jsurl);
	
	var locs = {
		news: _stateConstants2['default'].NEWS,
		inbox: _stateConstants2['default'].INBOX,
		tasklist: _stateConstants2['default'].TASKLIST,
		outbox: _stateConstants2['default'].OUTBOX,
		agenda: _stateConstants2['default'].AGENDA,
		links: _stateConstants2['default'].LINKS,
		clients: _stateConstants2['default'].CLIENTS,
		production: _stateConstants2['default'].PRODUCTION,
		b2b: _stateConstants2['default'].B2B,
		insuranceCompany: _stateConstants2['default'].INSURANCE_COMPANY,
		insuranceCompany2320: _stateConstants2['default'].PVVERZEKERINGENCVBA,
		insuranceCompany2321: _stateConstants2['default'].GENERALIBELGIUM,
		claims: _stateConstants2['default'].CLAIMS,
		contracts: _stateConstants2['default'].CONTRACTS,
		profile: _stateConstants2['default'].PROFILE,
		willdoc: _stateConstants2['default'].WILLDOC,
		office: _stateConstants2['default'].OFFICE,
		login: _stateConstants2['default'].LOGIN,
		faq: _stateConstants2['default'].FAQ,
		webapps: _stateConstants2['default'].WEBAPPS,
		emaildocument: _stateConstants2['default'].EMAILDOCUMENT,
		accountConfirmation: _stateConstants2['default'].ACCOUNT_CONFIRMATION,
		dsdocuments: _stateConstants2['default'].DSDOCUMENTS,
		privacy: _stateConstants2['default'].PRIVACY,
		404: _stateConstants2['default'].NOT_FOUND
	};
	
	exports.locs = locs;
	var reverseLocs = {};
	Object.keys(locs).forEach(function (k) {
		reverseLocs[locs[k]] = k;
	});
	
	var loc2action = function loc2action(loc) {
		var store = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
		return function (dispatch) {
			var _loc$pathname$slice$split$map = loc.pathname.slice(1).split('/').map(decodeURIComponent);
	
			var _loc$pathname$slice$split$map2 = _slicedToArray(_loc$pathname$slice$split$map, 4);
	
			var module = _loc$pathname$slice$split$map2[0];
			var param = _loc$pathname$slice$split$map2[1];
			var subParam = _loc$pathname$slice$split$map2[2];
			var subParam2 = _loc$pathname$slice$split$map2[3];
	
			var search = loc.search ? _jsurl2['default'].parse(decodeURIComponent(loc.search.slice(1))) : '';
			var component = locs[module];
			var hash = undefined;
			if (module === 'accountConfirmation' && param && param.length > 0) {
				hash = param;
			}
	
			switch (component) {
				case _stateConstants2['default'].NEWS:
				case _stateConstants2['default'].CLAIMS:
				case _stateConstants2['default'].OFFICE:
					dispatch((0, _stateActions.setBrNr)(search.brNr));
					break;
				case _stateConstants2['default'].CLIENTS:
					dispatch((0, _stateActions.setOpenedSubmenu)(subParam2));
					dispatch((0, _stateActions.setClientSubModule)(subParam));
					break;
				// this for loading data for insurance company when opened module by link... in the future we have to use this
				/* case c.GENERALIBELGIUM:
	       dispatch(setB2BInsuranceCompany({companyId:submenuItem.dataCargo, insuranceCompany: submenuItem.menuLabel}))
	   case c.PVVERZEKERINGENCVBA:
	       dispatch(setB2BInsuranceCompany({companyId:submenuItem.dataCargo, insuranceCompany: submenuItem.menuLabel}))*/
				case _stateConstants2['default'].INSURANCE_COMPANY:
				case _stateConstants2['default'].GENERALIBELGIUM:
				case _stateConstants2['default'].PVVERZEKERINGENCVBA:
					dispatch((0, _stateActions.setB2bCompanyBrNr)(search.brNr));
					dispatch((0, _stateActions.setB2bCompanySubModule)(subParam));
					break;
				case _stateConstants2['default'].EMAILDOCUMENT:
					dispatch((0, _stateActions.setEmailDocumentId)(param));
					break;
				case _stateConstants2['default'].DSDOCUMENTS:
					dispatch((0, _stateActions.setDSDocumentsOpenedPackage)(subParam2));
					dispatch((0, _stateActions.setDSDocumentsSubModule)(subParam));
					break;
				case _stateConstants2['default'].ACCOUNT_CONFIRMATION:
					if (hash) {
						dispatch((0, _stateActions.changeAuthState)('accountConfirmation'));
						dispatch((0, _stateActions.setAccountConfirmationHash)(hash));
					}
					break;
				case _stateConstants2['default'].PRIVACY:
					dispatch((0, _stateActions.setAppModule)(component));
					break;
				case undefined:
					component = _stateConstants2['default'].NOT_FOUND;
					break;
				default:
			}
	
			// Metro UI
			if (module === '') {
				component = undefined;
			}
	
			if (component === _stateConstants2['default'].ACCOUNT_CONFIRMATION) {
				dispatch((0, _stateActions.setAppModule)(component));
			} else {
				dispatch((0, _stateActions.setAppModule)(component, param));
			}
		};
	};
	
	var state2location = function state2location(state) {
		var _state$app = state.app;
		var module = _state$app.module;
		var opened = _state$app.opened;
		var submenuOpened = _state$app.submenuOpened;
		var brNr = _state$app.brNr;
		var openedPackage = _state$app.openedPackage;
		var _state$clients = state.clients;
		var subModule = _state$clients.subModule;
		var subModuleZoom = _state$clients.subModuleZoom;
	
		var b2bCompanySubModule = state.b2bCompany.subModule;
		var b2bCompanySubModuleZoom = state.b2bCompany.subModuleZoom;
		var b2bCompanyOpened = state.b2bCompany.opened;
		var component = reverseLocs[state.app.module] || '';
		var search = {};
		var param = undefined;
		var subParam = undefined;
		var subParam2 = undefined;
		if (module === _stateConstants2['default'].NEWS) {
			param = opened;
		}
		if (module === _stateConstants2['default'].OFFICE) {
			param = opened || 'general';
			if (brNr) {
				search.brNr = '' + brNr;
			}
		}
		if (module === _stateConstants2['default'].CLAIMS) {
			param = opened;
		}
		if (module === _stateConstants2['default'].CONTRACTS) {
			param = opened;
		}
		if (module === _stateConstants2['default'].PROFILE) {
			param = opened;
		}
		if (module === _stateConstants2['default'].CLIENTS) {
			param = opened;
			if (subModule) {
				subParam = subModule;
			}
			if (submenuOpened) {
				subParam2 = submenuOpened;
			}
	
			// This logic is also in clientContractsZoom, keep in sync.
			// TODO if we implement a derivation layer after the store, put this there
			if (!subParam2 && subModuleZoom && subModule === 'contracts') {
				var contracts = state.contracts;
	
				var key = Object.keys(subModuleZoom)[0];
				if (key) {
					var value = subModuleZoom[key];
					var contract = undefined;
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = Object.keys(contracts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var cId = _step.value;
	
							if (contracts[cId][key] === value) {
								contract = contracts[cId];
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator['return']) {
								_iterator['return']();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					subParam2 = contract && contract.contractId;
				}
			}
		}
		if (module === _stateConstants2['default'].DSDOCUMENTS) {
			if (state.DSDocuments.subModule) {
				subParam = state.DSDocuments.subModule;
			}
			if (state.DSDocuments.opened) {
				subParam2 = state.DSDocuments.opened;
			}
			if (state.DSDocuments.openedPackage) {
				subParam2 = state.DSDocuments.openedPackage;
			}
			param = opened || openedPackage;
		}
		// This is affected all of the insurance companies, all of them use a single general module
		var insCompaniesList = [_stateConstants2['default'].INSURANCE_COMPANY, _stateConstants2['default'].PVVERZEKERINGENCVBA, _stateConstants2['default'].GENERALIBELGIUM];
		if (insCompaniesList.includes(module)) {
			param = b2bCompanyOpened;
			if (b2bCompanySubModule) {
				subParam = b2bCompanySubModule;
			}
			if (submenuOpened) {
				subParam2 = submenuOpened;
			}
			if (!subParam2 && b2bCompanySubModuleZoom && b2bCompanySubModule === 'contracts') {
				var contracts = state.contracts;
	
				var key = Object.keys(b2bCompanySubModuleZoom)[0];
				if (key) {
					var value = b2bCompanySubModuleZoom[key];
					var contract = undefined;
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;
	
					try {
						for (var _iterator2 = Object.keys(contracts)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var cId = _step2.value;
	
							if (contracts[cId][key] === value) {
								contract = contracts[cId];
							}
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2['return']) {
								_iterator2['return']();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
	
					subParam2 = contract && contract.contractId;
				}
			}
		}
		if (component && param) {
			param = '/' + encodeURIComponent(param);
		} else {
			param = '';
		}
		if (subParam) {
			subParam = '/' + encodeURIComponent(subParam);
		} else {
			subParam = '';
		}
		if (subParam2) {
			subParam2 = '/' + encodeURIComponent(subParam2);
		} else {
			subParam2 = '';
		}
		return {
			pathname: '/' + component + param + subParam + subParam2
		};
	};
	
	// Don't use search until redux-addressbar fixes push/pop behavior
	// search: `?${JSURL.stringify(search)}`,
	
	exports['default'] = function (store) {
		return (0, _reduxAddressbar2['default'])({
			store: store,
			fromLoc: loc2action,
			toLoc: state2location
		});
	};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1186), __esModule: true };

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(1190);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(178);
	var document = __webpack_require__(128).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(127) && !__webpack_require__(223)(function () {
	  return Object.defineProperty(__webpack_require__(623)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(621);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(266);
	var $export = __webpack_require__(176);
	var redefine = __webpack_require__(630);
	var hide = __webpack_require__(177);
	var Iterators = __webpack_require__(379);
	var $iterCreate = __webpack_require__(1196);
	var setToStringTag = __webpack_require__(382);
	var getPrototypeOf = __webpack_require__(1202);
	var ITERATOR = __webpack_require__(180)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(268);
	var createDesc = __webpack_require__(269);
	var toIObject = __webpack_require__(179);
	var toPrimitive = __webpack_require__(387);
	var has = __webpack_require__(144);
	var IE8_DOM_DEFINE = __webpack_require__(624);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(127) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(629);
	var hiddenKeys = __webpack_require__(378).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(144);
	var toIObject = __webpack_require__(179);
	var arrayIndexOf = __webpack_require__(1192)(false);
	var IE_PROTO = __webpack_require__(383)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(177);


/***/ }),
/* 631 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(631)
	var ieee754 = __webpack_require__(730)
	var customInspectSymbol =
	  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
	    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
	    : null
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	var K_MAX_LENGTH = 0x7fffffff
	exports.kMaxLength = K_MAX_LENGTH
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()
	
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
	    typeof console.error === 'function') {
	  console.error(
	    'This browser lacks typed array (Uint8Array) support which is required by ' +
	    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
	  )
	}
	
	function typedArraySupport () {
	  // Can typed array instances can be augmented?
	  try {
	    var arr = new Uint8Array(1)
	    var proto = { foo: function () { return 42 } }
	    Object.setPrototypeOf(proto, Uint8Array.prototype)
	    Object.setPrototypeOf(arr, proto)
	    return arr.foo() === 42
	  } catch (e) {
	    return false
	  }
	}
	
	Object.defineProperty(Buffer.prototype, 'parent', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.buffer
	  }
	})
	
	Object.defineProperty(Buffer.prototype, 'offset', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.byteOffset
	  }
	})
	
	function createBuffer (length) {
	  if (length > K_MAX_LENGTH) {
	    throw new RangeError('The value "' + length + '" is invalid for option "size"')
	  }
	  // Return an augmented `Uint8Array` instance
	  var buf = new Uint8Array(length)
	  Object.setPrototypeOf(buf, Buffer.prototype)
	  return buf
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new TypeError(
	        'The "string" argument must be of type string. Received type number'
	      )
	    }
	    return allocUnsafe(arg)
	  }
	  return from(arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	function from (value, encodingOrOffset, length) {
	  if (typeof value === 'string') {
	    return fromString(value, encodingOrOffset)
	  }
	
	  if (ArrayBuffer.isView(value)) {
	    return fromArrayView(value)
	  }
	
	  if (value == null) {
	    throw new TypeError(
	      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	      'or Array-like Object. Received type ' + (typeof value)
	    )
	  }
	
	  if (isInstance(value, ArrayBuffer) ||
	      (value && isInstance(value.buffer, ArrayBuffer))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof SharedArrayBuffer !== 'undefined' &&
	      (isInstance(value, SharedArrayBuffer) ||
	      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'number') {
	    throw new TypeError(
	      'The "value" argument must not be of type number. Received type number'
	    )
	  }
	
	  var valueOf = value.valueOf && value.valueOf()
	  if (valueOf != null && valueOf !== value) {
	    return Buffer.from(valueOf, encodingOrOffset, length)
	  }
	
	  var b = fromObject(value)
	  if (b) return b
	
	  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
	      typeof value[Symbol.toPrimitive] === 'function') {
	    return Buffer.from(
	      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
	    )
	  }
	
	  throw new TypeError(
	    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	    'or Array-like Object. Received type ' + (typeof value)
	  )
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(value, encodingOrOffset, length)
	}
	
	// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
	Object.setPrototypeOf(Buffer, Uint8Array)
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be of type number')
	  } else if (size < 0) {
	    throw new RangeError('The value "' + size + '" is invalid for option "size"')
	  }
	}
	
	function alloc (size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpreted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(size).fill(fill, encoding)
	      : createBuffer(size).fill(fill)
	  }
	  return createBuffer(size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(size, fill, encoding)
	}
	
	function allocUnsafe (size) {
	  assertSize(size)
	  return createBuffer(size < 0 ? 0 : checked(size) | 0)
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(size)
	}
	
	function fromString (string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('Unknown encoding: ' + encoding)
	  }
	
	  var length = byteLength(string, encoding) | 0
	  var buf = createBuffer(length)
	
	  var actual = buf.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    buf = buf.slice(0, actual)
	  }
	
	  return buf
	}
	
	function fromArrayLike (array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  var buf = createBuffer(length)
	  for (var i = 0; i < length; i += 1) {
	    buf[i] = array[i] & 255
	  }
	  return buf
	}
	
	function fromArrayView (arrayView) {
	  if (isInstance(arrayView, Uint8Array)) {
	    var copy = new Uint8Array(arrayView)
	    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
	  }
	  return fromArrayLike(arrayView)
	}
	
	function fromArrayBuffer (array, byteOffset, length) {
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('"offset" is outside of buffer bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('"length" is outside of buffer bounds')
	  }
	
	  var buf
	  if (byteOffset === undefined && length === undefined) {
	    buf = new Uint8Array(array)
	  } else if (length === undefined) {
	    buf = new Uint8Array(array, byteOffset)
	  } else {
	    buf = new Uint8Array(array, byteOffset, length)
	  }
	
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(buf, Buffer.prototype)
	
	  return buf
	}
	
	function fromObject (obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    var buf = createBuffer(len)
	
	    if (buf.length === 0) {
	      return buf
	    }
	
	    obj.copy(buf, 0, 0, len)
	    return buf
	  }
	
	  if (obj.length !== undefined) {
	    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
	      return createBuffer(0)
	    }
	    return fromArrayLike(obj)
	  }
	
	  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
	    return fromArrayLike(obj.data)
	  }
	}
	
	function checked (length) {
	  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= K_MAX_LENGTH) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return b != null && b._isBuffer === true &&
	    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
	}
	
	Buffer.compare = function compare (a, b) {
	  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
	  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError(
	      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
	    )
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!Array.isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (isInstance(buf, Uint8Array)) {
	      if (pos + buf.length > buffer.length) {
	        Buffer.from(buf).copy(buffer, pos)
	      } else {
	        Uint8Array.prototype.set.call(
	          buffer,
	          buf,
	          pos
	        )
	      }
	    } else if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    } else {
	      buf.copy(buffer, pos)
	    }
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    throw new TypeError(
	      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
	      'Received type ' + typeof string
	    )
	  }
	
	  var len = string.length
	  var mustMatch = (arguments.length > 2 && arguments[2] === true)
	  if (!mustMatch && len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) {
	          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
	        }
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.toLocaleString = Buffer.prototype.toString
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
	  if (this.length > max) str += ' ... '
	  return '<Buffer ' + str + '>'
	}
	if (customInspectSymbol) {
	  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (isInstance(target, Uint8Array)) {
	    target = Buffer.from(target, target.offset, target.byteLength)
	  }
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError(
	      'The "target" argument must be one of type Buffer or Uint8Array. ' +
	      'Received type ' + (typeof target)
	    )
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset // Coerce to Number.
	  if (numberIsNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  var strLen = string.length
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (numberIsNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset >>> 0
	    if (isFinite(length)) {
	      length = length >>> 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return asciiWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF)
	      ? 4
	      : (firstByte > 0xDF)
	          ? 3
	          : (firstByte > 0xBF)
	              ? 2
	              : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += hexSliceLookupTable[buf[i]]
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
	  for (var i = 0; i < bytes.length - 1; i += 2) {
	    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf = this.subarray(start, end)
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(newBuf, Buffer.prototype)
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUintLE =
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUintBE =
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUint8 =
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUint16LE =
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUint16BE =
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUint32LE =
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUint32BE =
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUintLE =
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUintBE =
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUint8 =
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeUint16LE =
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint16BE =
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint32LE =
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset + 3] = (value >>> 24)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 1] = (value >>> 8)
	  this[offset] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeUint32BE =
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 3] = (value >>> 24)
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	
	  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
	    // Use built-in when available, missing from IE11
	    this.copyWithin(targetStart, start, end)
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, end),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if ((encoding === 'utf8' && code < 128) ||
	          encoding === 'latin1') {
	        // Fast path: If `val` fits into a single byte, use that numeric value.
	        val = code
	      }
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  } else if (typeof val === 'boolean') {
	    val = Number(val)
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : Buffer.from(val, encoding)
	    var len = bytes.length
	    if (len === 0) {
	      throw new TypeError('The value "' + val +
	        '" is invalid for argument "value"')
	    }
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node takes equal signs as end of the Base64 encoding
	  str = str.split('=')[0]
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = str.trim().replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
	// the `instanceof` check but they should be treated as of that type.
	// See: https://github.com/feross/buffer/issues/166
	function isInstance (obj, type) {
	  return obj instanceof type ||
	    (obj != null && obj.constructor != null && obj.constructor.name != null &&
	      obj.constructor.name === type.name)
	}
	function numberIsNaN (obj) {
	  // For IE11 support
	  return obj !== obj // eslint-disable-line no-self-compare
	}
	
	// Create lookup table for `toString('hex')`
	// See: https://github.com/feross/buffer/issues/219
	var hexSliceLookupTable = (function () {
	  var alphabet = '0123456789abcdef'
	  var table = new Array(256)
	  for (var i = 0; i < 16; ++i) {
	    var i16 = i * 16
	    for (var j = 0; j < 16; ++j) {
	      table[i16 + j] = alphabet[i] + alphabet[j]
	    }
	  }
	  return table
	})()
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1888).Buffer))

/***/ }),
/* 633 */
[2335, 246, 390],
/* 634 */
/***/ (function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var E, N, React, Version, __, merge, translations,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	React = __webpack_require__(1);
	
	E = React.createElement;
	
	N = {};
	
	merge = __webpack_require__(330).merge;
	
	translations = __ = function(t) {
	  return translations[t] || t;
	};
	
	Version = (function(superClass) {
	  extend(Version, superClass);
	
	  function Version() {
	    return Version.__super__.constructor.apply(this, arguments);
	  }
	
	  Version.prototype.render = function() {
	    return E('div', this.props, (("10.0-159-ge9cd7ea95") || "dev") + " - © " + ((new Date()).getFullYear()) + " WILLEMOT NV");
	  };
	
	  return Version;
	
	})(React.Component);
	
	module.exports = Version;


/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isPossiblePrototype = __webpack_require__(669);
	
	var $String = String;
	var $TypeError = TypeError;
	
	module.exports = function (argument) {
	  if (isPossiblePrototype(argument)) return argument;
	  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
	};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var uncurryThisAccessor = __webpack_require__(283);
	var classof = __webpack_require__(53);
	
	var ArrayBuffer = globalThis.ArrayBuffer;
	var TypeError = globalThis.TypeError;
	
	// Includes
	// - Perform ? RequireInternalSlot(O, [[ArrayBufferData]]).
	// - If IsSharedArrayBuffer(O) is true, throw a TypeError exception.
	module.exports = ArrayBuffer && uncurryThisAccessor(ArrayBuffer.prototype, 'byteLength', 'get') || function (O) {
	  if (classof(O) !== 'ArrayBuffer') throw new TypeError('ArrayBuffer expected');
	  return O.byteLength;
	};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(130);
	var arrayBufferByteLength = __webpack_require__(638);
	
	var ArrayBuffer = globalThis.ArrayBuffer;
	var ArrayBufferPrototype = ArrayBuffer && ArrayBuffer.prototype;
	var slice = ArrayBufferPrototype && uncurryThis(ArrayBufferPrototype.slice);
	
	module.exports = function (O) {
	  if (arrayBufferByteLength(O) !== 0) return false;
	  if (!slice) return false;
	  try {
	    slice(O, 0, 0);
	    return false;
	  } catch (error) {
	    return true;
	  }
	};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(8);
	var uncurryThisAccessor = __webpack_require__(283);
	var toIndex = __webpack_require__(428);
	var notDetached = __webpack_require__(1222);
	var arrayBufferByteLength = __webpack_require__(638);
	var detachTransferable = __webpack_require__(650);
	var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(426);
	
	var structuredClone = globalThis.structuredClone;
	var ArrayBuffer = globalThis.ArrayBuffer;
	var DataView = globalThis.DataView;
	var min = Math.min;
	var ArrayBufferPrototype = ArrayBuffer.prototype;
	var DataViewPrototype = DataView.prototype;
	var slice = uncurryThis(ArrayBufferPrototype.slice);
	var isResizable = uncurryThisAccessor(ArrayBufferPrototype, 'resizable', 'get');
	var maxByteLength = uncurryThisAccessor(ArrayBufferPrototype, 'maxByteLength', 'get');
	var getInt8 = uncurryThis(DataViewPrototype.getInt8);
	var setInt8 = uncurryThis(DataViewPrototype.setInt8);
	
	module.exports = (PROPER_STRUCTURED_CLONE_TRANSFER || detachTransferable) && function (arrayBuffer, newLength, preserveResizability) {
	  var byteLength = arrayBufferByteLength(arrayBuffer);
	  var newByteLength = newLength === undefined ? byteLength : toIndex(newLength);
	  var fixedLength = !isResizable || !isResizable(arrayBuffer);
	  var newBuffer;
	  notDetached(arrayBuffer);
	  if (PROPER_STRUCTURED_CLONE_TRANSFER) {
	    arrayBuffer = structuredClone(arrayBuffer, { transfer: [arrayBuffer] });
	    if (byteLength === newByteLength && (preserveResizability || fixedLength)) return arrayBuffer;
	  }
	  if (byteLength >= newByteLength && (!preserveResizability || fixedLength)) {
	    newBuffer = slice(arrayBuffer, 0, newByteLength);
	  } else {
	    var options = preserveResizability && !fixedLength && maxByteLength ? { maxByteLength: maxByteLength(arrayBuffer) } : undefined;
	    newBuffer = new ArrayBuffer(newByteLength, options);
	    var a = new DataView(arrayBuffer);
	    var b = new DataView(newBuffer);
	    var copyLength = min(newByteLength, byteLength);
	    for (var i = 0; i < copyLength; i++) setInt8(b, i, getInt8(a, i));
	  }
	  if (!PROPER_STRUCTURED_CLONE_TRANSFER) detachTransferable(arrayBuffer);
	  return newBuffer;
	};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toObject = __webpack_require__(31);
	var toAbsoluteIndex = __webpack_require__(117);
	var lengthOfArrayLike = __webpack_require__(34);
	var deletePropertyOrThrow = __webpack_require__(279);
	
	var min = Math.min;
	
	// `Array.prototype.copyWithin` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.copywithin
	// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = lengthOfArrayLike(O);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else deletePropertyOrThrow(O, to);
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $forEach = __webpack_require__(52).forEach;
	var arrayMethodIsStrict = __webpack_require__(114);
	
	var STRICT_METHOD = arrayMethodIsStrict('forEach');
	
	// `Array.prototype.forEach` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
	  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe
	} : [].forEach;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(91);
	var call = __webpack_require__(19);
	var toObject = __webpack_require__(31);
	var callWithSafeIterationClosing = __webpack_require__(1224);
	var isArrayIteratorMethod = __webpack_require__(406);
	var isConstructor = __webpack_require__(186);
	var lengthOfArrayLike = __webpack_require__(34);
	var createProperty = __webpack_require__(129);
	var getIterator = __webpack_require__(284);
	var getIteratorMethod = __webpack_require__(231);
	
	var $Array = Array;
	
	// `Array.from` method implementation
	// https://tc39.es/ecma262/#sec-array.from
	module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	  var O = toObject(arrayLike);
	  var IS_CONSTRUCTOR = isConstructor(this);
	  var argumentsLength = arguments.length;
	  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
	  var mapping = mapfn !== undefined;
	  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
	  var iteratorMethod = getIteratorMethod(O);
	  var index = 0;
	  var length, result, step, iterator, next, value;
	  // if the target is not iterable or it's an array with the default iterator - use a simple case
	  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
	    result = IS_CONSTRUCTOR ? new this() : [];
	    iterator = getIterator(O, iteratorMethod);
	    next = iterator.next;
	    for (;!(step = call(next, iterator)).done; index++) {
	      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
	      createProperty(result, index, value);
	    }
	  } else {
	    length = lengthOfArrayLike(O);
	    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
	    for (;length > index; index++) {
	      value = mapping ? mapfn(O[index], index) : O[index];
	      createProperty(result, index, value);
	    }
	  }
	  result.length = index;
	  return result;
	};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-array-prototype-lastindexof -- safe */
	var apply = __webpack_require__(90);
	var toIndexedObject = __webpack_require__(51);
	var toIntegerOrInfinity = __webpack_require__(44);
	var lengthOfArrayLike = __webpack_require__(34);
	var arrayMethodIsStrict = __webpack_require__(114);
	
	var min = Math.min;
	var $lastIndexOf = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
	var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
	var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;
	
	// `Array.prototype.lastIndexOf` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
	module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	  // convert -0 to +0
	  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
	  var O = toIndexedObject(this);
	  var length = lengthOfArrayLike(O);
	  if (length === 0) return -1;
	  var index = length - 1;
	  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
	  if (index < 0) index = length + index;
	  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
	  return -1;
	} : $lastIndexOf;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var lengthOfArrayLike = __webpack_require__(34);
	
	// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
	// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
	module.exports = function (O, C) {
	  var len = lengthOfArrayLike(O);
	  var A = new C(len);
	  var k = 0;
	  for (; k < len; k++) A[k] = O[len - k - 1];
	  return A;
	};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var lengthOfArrayLike = __webpack_require__(34);
	var toIntegerOrInfinity = __webpack_require__(44);
	
	var $RangeError = RangeError;
	
	// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
	// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
	module.exports = function (O, C, index, value) {
	  var len = lengthOfArrayLike(O);
	  var relativeIndex = toIntegerOrInfinity(index);
	  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
	  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
	  var A = new C(len);
	  var k = 0;
	  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
	  return A;
	};


/***/ }),
/* 647 */
/***/ (function(module, exports) {

	'use strict';
	var commonAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	var base64Alphabet = commonAlphabet + '+/';
	var base64UrlAlphabet = commonAlphabet + '-_';
	
	var inverse = function (characters) {
	  // TODO: use `Object.create(null)` in `core-js@4`
	  var result = {};
	  var index = 0;
	  for (; index < 64; index++) result[characters.charAt(index)] = index;
	  return result;
	};
	
	module.exports = {
	  i2c: base64Alphabet,
	  c2i: inverse(base64Alphabet),
	  i2cUrl: base64UrlAlphabet,
	  c2iUrl: inverse(base64UrlAlphabet)
	};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(73);
	var defineBuiltInAccessor = __webpack_require__(50);
	var defineBuiltIns = __webpack_require__(229);
	var bind = __webpack_require__(91);
	var anInstance = __webpack_require__(97);
	var isNullOrUndefined = __webpack_require__(64);
	var iterate = __webpack_require__(83);
	var defineIterator = __webpack_require__(409);
	var createIterResultObject = __webpack_require__(228);
	var setSpecies = __webpack_require__(189);
	var DESCRIPTORS = __webpack_require__(14);
	var fastKey = __webpack_require__(149).fastKey;
	var InternalStateModule = __webpack_require__(49);
	
	var setInternalState = InternalStateModule.set;
	var internalStateGetterFor = InternalStateModule.getterFor;
	
	module.exports = {
	  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
	    var Constructor = wrapper(function (that, iterable) {
	      anInstance(that, Prototype);
	      setInternalState(that, {
	        type: CONSTRUCTOR_NAME,
	        index: create(null),
	        first: null,
	        last: null,
	        size: 0
	      });
	      if (!DESCRIPTORS) that.size = 0;
	      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	    });
	
	    var Prototype = Constructor.prototype;
	
	    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
	
	    var define = function (that, key, value) {
	      var state = getInternalState(that);
	      var entry = getEntry(that, key);
	      var previous, index;
	      // change existing entry
	      if (entry) {
	        entry.value = value;
	      // create new entry
	      } else {
	        state.last = entry = {
	          index: index = fastKey(key, true),
	          key: key,
	          value: value,
	          previous: previous = state.last,
	          next: null,
	          removed: false
	        };
	        if (!state.first) state.first = entry;
	        if (previous) previous.next = entry;
	        if (DESCRIPTORS) state.size++;
	        else that.size++;
	        // add to index
	        if (index !== 'F') state.index[index] = entry;
	      } return that;
	    };
	
	    var getEntry = function (that, key) {
	      var state = getInternalState(that);
	      // fast case
	      var index = fastKey(key);
	      var entry;
	      if (index !== 'F') return state.index[index];
	      // frozen object case
	      for (entry = state.first; entry; entry = entry.next) {
	        if (entry.key === key) return entry;
	      }
	    };
	
	    defineBuiltIns(Prototype, {
	      // `{ Map, Set }.prototype.clear()` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.clear
	      // https://tc39.es/ecma262/#sec-set.prototype.clear
	      clear: function clear() {
	        var that = this;
	        var state = getInternalState(that);
	        var entry = state.first;
	        while (entry) {
	          entry.removed = true;
	          if (entry.previous) entry.previous = entry.previous.next = null;
	          entry = entry.next;
	        }
	        state.first = state.last = null;
	        state.index = create(null);
	        if (DESCRIPTORS) state.size = 0;
	        else that.size = 0;
	      },
	      // `{ Map, Set }.prototype.delete(key)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.delete
	      // https://tc39.es/ecma262/#sec-set.prototype.delete
	      'delete': function (key) {
	        var that = this;
	        var state = getInternalState(that);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.next;
	          var prev = entry.previous;
	          delete state.index[entry.index];
	          entry.removed = true;
	          if (prev) prev.next = next;
	          if (next) next.previous = prev;
	          if (state.first === entry) state.first = next;
	          if (state.last === entry) state.last = prev;
	          if (DESCRIPTORS) state.size--;
	          else that.size--;
	        } return !!entry;
	      },
	      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.foreach
	      // https://tc39.es/ecma262/#sec-set.prototype.foreach
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        var state = getInternalState(this);
	        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	        var entry;
	        while (entry = entry ? entry.next : state.first) {
	          boundFunction(entry.value, entry.key, this);
	          // revert to the last existing entry
	          while (entry && entry.removed) entry = entry.previous;
	        }
	      },
	      // `{ Map, Set}.prototype.has(key)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.has
	      // https://tc39.es/ecma262/#sec-set.prototype.has
	      has: function has(key) {
	        return !!getEntry(this, key);
	      }
	    });
	
	    defineBuiltIns(Prototype, IS_MAP ? {
	      // `Map.prototype.get(key)` method
	      // https://tc39.es/ecma262/#sec-map.prototype.get
	      get: function get(key) {
	        var entry = getEntry(this, key);
	        return entry && entry.value;
	      },
	      // `Map.prototype.set(key, value)` method
	      // https://tc39.es/ecma262/#sec-map.prototype.set
	      set: function set(key, value) {
	        return define(this, key === 0 ? 0 : key, value);
	      }
	    } : {
	      // `Set.prototype.add(value)` method
	      // https://tc39.es/ecma262/#sec-set.prototype.add
	      add: function add(value) {
	        return define(this, value = value === 0 ? 0 : value, value);
	      }
	    });
	    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
	      configurable: true,
	      get: function () {
	        return getInternalState(this).size;
	      }
	    });
	    return Constructor;
	  },
	  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
	    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
	    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
	    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
	    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
	    // https://tc39.es/ecma262/#sec-map.prototype.entries
	    // https://tc39.es/ecma262/#sec-map.prototype.keys
	    // https://tc39.es/ecma262/#sec-map.prototype.values
	    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
	    // https://tc39.es/ecma262/#sec-set.prototype.entries
	    // https://tc39.es/ecma262/#sec-set.prototype.keys
	    // https://tc39.es/ecma262/#sec-set.prototype.values
	    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
	    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
	      setInternalState(this, {
	        type: ITERATOR_NAME,
	        target: iterated,
	        state: getInternalCollectionState(iterated),
	        kind: kind,
	        last: null
	      });
	    }, function () {
	      var state = getInternalIteratorState(this);
	      var kind = state.kind;
	      var entry = state.last;
	      // revert to the last existing entry
	      while (entry && entry.removed) entry = entry.previous;
	      // get next entry
	      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
	        // or finish the iteration
	        state.target = null;
	        return createIterResultObject(undefined, true);
	      }
	      // return step by kind
	      if (kind === 'keys') return createIterResultObject(entry.key, false);
	      if (kind === 'values') return createIterResultObject(entry.value, false);
	      return createIterResultObject([entry.key, entry.value], false);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // `{ Map, Set }.prototype[@@species]` accessors
	    // https://tc39.es/ecma262/#sec-get-map-@@species
	    // https://tc39.es/ecma262/#sec-get-set-@@species
	    setSpecies(CONSTRUCTOR_NAME);
	  }
	};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var defineBuiltIns = __webpack_require__(229);
	var getWeakData = __webpack_require__(149).getWeakData;
	var anInstance = __webpack_require__(97);
	var anObject = __webpack_require__(20);
	var isNullOrUndefined = __webpack_require__(64);
	var isObject = __webpack_require__(25);
	var iterate = __webpack_require__(83);
	var ArrayIterationModule = __webpack_require__(52);
	var hasOwn = __webpack_require__(29);
	var InternalStateModule = __webpack_require__(49);
	
	var setInternalState = InternalStateModule.set;
	var internalStateGetterFor = InternalStateModule.getterFor;
	var find = ArrayIterationModule.find;
	var findIndex = ArrayIterationModule.findIndex;
	var splice = uncurryThis([].splice);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (state) {
	  return state.frozen || (state.frozen = new UncaughtFrozenStore());
	};
	
	var UncaughtFrozenStore = function () {
	  this.entries = [];
	};
	
	var findUncaughtFrozen = function (store, key) {
	  return find(store.entries, function (it) {
	    return it[0] === key;
	  });
	};
	
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.entries.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = findIndex(this.entries, function (it) {
	      return it[0] === key;
	    });
	    if (~index) splice(this.entries, index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
	    var Constructor = wrapper(function (that, iterable) {
	      anInstance(that, Prototype);
	      setInternalState(that, {
	        type: CONSTRUCTOR_NAME,
	        id: id++,
	        frozen: null
	      });
	      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	    });
	
	    var Prototype = Constructor.prototype;
	
	    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
	
	    var define = function (that, key, value) {
	      var state = getInternalState(that);
	      var data = getWeakData(anObject(key), true);
	      if (data === true) uncaughtFrozenStore(state).set(key, value);
	      else data[state.id] = value;
	      return that;
	    };
	
	    defineBuiltIns(Prototype, {
	      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
	      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
	      'delete': function (key) {
	        var state = getInternalState(this);
	        if (!isObject(key)) return false;
	        var data = getWeakData(key);
	        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
	        return data && hasOwn(data, state.id) && delete data[state.id];
	      },
	      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
	      // https://tc39.es/ecma262/#sec-weakset.prototype.has
	      has: function has(key) {
	        var state = getInternalState(this);
	        if (!isObject(key)) return false;
	        var data = getWeakData(key);
	        if (data === true) return uncaughtFrozenStore(state).has(key);
	        return data && hasOwn(data, state.id);
	      }
	    });
	
	    defineBuiltIns(Prototype, IS_MAP ? {
	      // `WeakMap.prototype.get(key)` method
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
	      get: function get(key) {
	        var state = getInternalState(this);
	        if (isObject(key)) {
	          var data = getWeakData(key);
	          if (data === true) return uncaughtFrozenStore(state).get(key);
	          if (data) return data[state.id];
	        }
	      },
	      // `WeakMap.prototype.set(key, value)` method
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
	      set: function set(key, value) {
	        return define(this, key, value);
	      }
	    } : {
	      // `WeakSet.prototype.add(value)` method
	      // https://tc39.es/ecma262/#sec-weakset.prototype.add
	      add: function add(value) {
	        return define(this, value, true);
	      }
	    });
	
	    return Constructor;
	  }
	};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var getBuiltInNodeModule = __webpack_require__(662);
	var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(426);
	
	var structuredClone = globalThis.structuredClone;
	var $ArrayBuffer = globalThis.ArrayBuffer;
	var $MessageChannel = globalThis.MessageChannel;
	var detach = false;
	var WorkerThreads, channel, buffer, $detach;
	
	if (PROPER_STRUCTURED_CLONE_TRANSFER) {
	  detach = function (transferable) {
	    structuredClone(transferable, { transfer: [transferable] });
	  };
	} else if ($ArrayBuffer) try {
	  if (!$MessageChannel) {
	    WorkerThreads = getBuiltInNodeModule('worker_threads');
	    if (WorkerThreads) $MessageChannel = WorkerThreads.MessageChannel;
	  }
	
	  if ($MessageChannel) {
	    channel = new $MessageChannel();
	    buffer = new $ArrayBuffer(2);
	
	    $detach = function (transferable) {
	      channel.port1.postMessage(null, [transferable]);
	    };
	
	    if (buffer.byteLength === 2) {
	      $detach(buffer);
	      if (buffer.byteLength === 0) detach = $detach;
	    }
	  }
	} catch (error) { /* empty */ }
	
	module.exports = detach;


/***/ }),
/* 651 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = {
	  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
	  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
	  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
	  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
	  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
	  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
	  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
	  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
	  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
	  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
	  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
	  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
	  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
	  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
	  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
	  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
	  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
	  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
	  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
	  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
	  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
	  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
	  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
	  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
	  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
	};


/***/ }),
/* 652 */
/***/ (function(module, exports) {

	'use strict';
	// iterable DOM collections
	// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
	module.exports = {
	  CSSRuleList: 0,
	  CSSStyleDeclaration: 0,
	  CSSValueList: 0,
	  ClientRectList: 0,
	  DOMRectList: 0,
	  DOMStringList: 0,
	  DOMTokenList: 1,
	  DataTransferItemList: 0,
	  FileList: 0,
	  HTMLAllCollection: 0,
	  HTMLCollection: 0,
	  HTMLFormElement: 0,
	  HTMLSelectElement: 0,
	  MediaList: 0,
	  MimeTypeArray: 0,
	  NamedNodeMap: 0,
	  NodeList: 1,
	  PaintRequestList: 0,
	  Plugin: 0,
	  PluginArray: 0,
	  SVGLengthList: 0,
	  SVGNumberList: 0,
	  SVGPathSegList: 0,
	  SVGPointList: 0,
	  SVGStringList: 0,
	  SVGTransformList: 0,
	  SourceBufferList: 0,
	  StyleSheetList: 0,
	  TextTrackCueList: 0,
	  TextTrackList: 0,
	  TouchList: 0
	};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
	var documentCreateElement = __webpack_require__(280);
	
	var classList = documentCreateElement('span').classList;
	var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
	
	module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(99);
	
	var firefox = userAgent.match(/firefox\/(\d+)/i);
	
	module.exports = !!firefox && +firefox[1];


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var UA = __webpack_require__(99);
	
	module.exports = /MSIE|Trident/.test(UA);


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(99);
	
	// eslint-disable-next-line redos/no-vulnerable -- safe
	module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createNonEnumerableProperty = __webpack_require__(58);
	var clearErrorStack = __webpack_require__(404);
	var ERROR_STACK_INSTALLABLE = __webpack_require__(658);
	
	// non-standard V8
	var captureStackTrace = Error.captureStackTrace;
	
	module.exports = function (error, C, stack, dropEntries) {
	  if (ERROR_STACK_INSTALLABLE) {
	    if (captureStackTrace) captureStackTrace(error, C);
	    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
	  }
	};


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var createPropertyDescriptor = __webpack_require__(82);
	
	module.exports = !fails(function () {
	  var error = new Error('a');
	  if (!('stack' in error)) return true;
	  // eslint-disable-next-line es/no-object-defineproperty -- safe
	  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
	  return error.stack !== 7;
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var fails = __webpack_require__(6);
	var anObject = __webpack_require__(20);
	var normalizeStringArgument = __webpack_require__(235);
	
	var nativeErrorToString = Error.prototype.toString;
	
	var INCORRECT_TO_STRING = fails(function () {
	  if (DESCRIPTORS) {
	    // Chrome 32- incorrectly call accessor
	    // eslint-disable-next-line es/no-object-create, es/no-object-defineproperty -- safe
	    var object = Object.create(Object.defineProperty({}, 'name', { get: function () {
	      return this === object;
	    } }));
	    if (nativeErrorToString.call(object) !== 'true') return true;
	  }
	  // FF10- does not properly handle non-strings
	  return nativeErrorToString.call({ message: 1, name: 2 }) !== '2: 1'
	    // IE8 does not properly handle defaults
	    || nativeErrorToString.call({}) !== 'Error';
	});
	
	module.exports = INCORRECT_TO_STRING ? function toString() {
	  var O = anObject(this);
	  var name = normalizeStringArgument(O.name, 'Error');
	  var message = normalizeStringArgument(O.message);
	  return !name ? message : !message ? name : name + ': ' + message;
	} : nativeErrorToString;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isArray = __webpack_require__(131);
	var lengthOfArrayLike = __webpack_require__(34);
	var doesNotExceedSafeInteger = __webpack_require__(181);
	var bind = __webpack_require__(91);
	
	// `FlattenIntoArray` abstract operation
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? bind(mapper, thisArg) : false;
	  var element, elementLen;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      if (depth > 0 && isArray(element)) {
	        elementLen = lengthOfArrayLike(element);
	        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
	      } else {
	        doesNotExceedSafeInteger(targetIndex + 1);
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	};
	
	module.exports = flattenIntoArray;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(39);
	var isObject = __webpack_require__(25);
	var hasOwn = __webpack_require__(29);
	var arraySlice = __webpack_require__(89);
	var NATIVE_BIND = __webpack_require__(230);
	
	var $Function = Function;
	var concat = uncurryThis([].concat);
	var join = uncurryThis([].join);
	var factories = {};
	
	var construct = function (C, argsLength, args) {
	  if (!hasOwn(factories, argsLength)) {
	    var list = [];
	    var i = 0;
	    for (; i < argsLength; i++) list[i] = 'a[' + i + ']';
	    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
	  } return factories[argsLength](C, args);
	};
	
	// `Function.prototype.bind` method implementation
	// https://tc39.es/ecma262/#sec-function.prototype.bind
	// eslint-disable-next-line es/no-function-prototype-bind -- detection
	module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
	  var F = aCallable(this);
	  var Prototype = F.prototype;
	  var partArgs = arraySlice(arguments, 1);
	  var boundFunction = function bound(/* args... */) {
	    var args = concat(partArgs, arraySlice(arguments));
	    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
	  };
	  if (isObject(Prototype)) boundFunction.prototype = Prototype;
	  return boundFunction;
	};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var IS_NODE = __webpack_require__(182);
	
	module.exports = function (name) {
	  if (IS_NODE) {
	    try {
	      return globalThis.process.getBuiltinModule(name);
	    } catch (error) { /* empty */ }
	    try {
	      // eslint-disable-next-line no-new-func -- safe
	      return Function('return require("' + name + '")')();
	    } catch (error) { /* empty */ }
	  }
	};


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var toObject = __webpack_require__(31);
	
	var floor = Math.floor;
	var charAt = uncurryThis(''.charAt);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	// eslint-disable-next-line redos/no-vulnerable -- safe
	var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
	
	// `GetSubstitution` abstract operation
	// https://tc39.es/ecma262/#sec-getsubstitution
	module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
	  var tailPos = position + matched.length;
	  var m = captures.length;
	  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	  if (namedCaptures !== undefined) {
	    namedCaptures = toObject(namedCaptures);
	    symbols = SUBSTITUTION_SYMBOLS;
	  }
	  return replace(replacement, symbols, function (match, ch) {
	    var capture;
	    switch (charAt(ch, 0)) {
	      case '$': return '$';
	      case '&': return matched;
	      case '`': return stringSlice(str, 0, position);
	      case "'": return stringSlice(str, tailPos);
	      case '<':
	        capture = namedCaptures[stringSlice(ch, 1, -1)];
	        break;
	      default: // \d\d?
	        var n = +ch;
	        if (n === 0) return match;
	        if (n > m) {
	          var f = floor(n / 10);
	          if (f === 0) return match;
	          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
	          return match;
	        }
	        capture = captures[n - 1];
	    }
	    return capture === undefined ? '' : capture;
	  });
	};


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(33);
	
	module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var fails = __webpack_require__(6);
	var createElement = __webpack_require__(280);
	
	// Thanks to IE8 for its funny defineProperty
	module.exports = !DESCRIPTORS && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a !== 7;
	});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(25);
	var createNonEnumerableProperty = __webpack_require__(58);
	
	// `InstallErrorCause` abstract operation
	// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
	module.exports = function (O, options) {
	  if (isObject(options) && 'cause' in options) {
	    createNonEnumerableProperty(O, 'cause', options.cause);
	  }
	};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(98);
	
	module.exports = function (it) {
	  var klass = classof(it);
	  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
	};


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(29);
	
	module.exports = function (descriptor) {
	  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
	};


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(25);
	
	module.exports = function (argument) {
	  return isObject(argument) || argument === null;
	};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var isCallable = __webpack_require__(28);
	var isObject = __webpack_require__(25);
	var create = __webpack_require__(73);
	var getPrototypeOf = __webpack_require__(84);
	var defineBuiltIn = __webpack_require__(40);
	var wellKnownSymbol = __webpack_require__(27);
	var IS_PURE = __webpack_require__(43);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false;
	
	// `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
	
	/* eslint-disable es/no-array-prototype-keys -- safe */
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
	  else {
	    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
	  }
	}
	
	var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
	  var test = {};
	  // FF44- legacy iterators case
	  return IteratorPrototype[ITERATOR].call(test) !== test;
	});
	
	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
	else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
	
	// `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
	if (!isCallable(IteratorPrototype[ITERATOR])) {
	  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
	    return this;
	  });
	}
	
	module.exports = {
	  IteratorPrototype: IteratorPrototype,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	// eslint-disable-next-line es/no-map -- safe
	var MapPrototype = Map.prototype;
	
	module.exports = {
	  // eslint-disable-next-line es/no-map -- safe
	  Map: Map,
	  set: uncurryThis(MapPrototype.set),
	  get: uncurryThis(MapPrototype.get),
	  has: uncurryThis(MapPrototype.has),
	  remove: uncurryThis(MapPrototype['delete']),
	  proto: MapPrototype
	};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var floatRound = __webpack_require__(1234);
	
	var FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
	var FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
	var FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
	
	// `Math.fround` method implementation
	// https://tc39.es/ecma262/#sec-math.fround
	// eslint-disable-next-line es/no-math-fround -- safe
	module.exports = Math.fround || function fround(x) {
	  return floatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
	};


/***/ }),
/* 673 */
/***/ (function(module, exports) {

	'use strict';
	var log = Math.log;
	var LOG10E = Math.LOG10E;
	
	// eslint-disable-next-line es/no-math-log10 -- safe
	module.exports = Math.log10 || function log10(x) {
	  return log(x) * LOG10E;
	};


/***/ }),
/* 674 */
/***/ (function(module, exports) {

	'use strict';
	var log = Math.log;
	
	// `Math.log1p` method implementation
	// https://tc39.es/ecma262/#sec-math.log1p
	// eslint-disable-next-line es/no-math-log1p -- safe
	module.exports = Math.log1p || function log1p(x) {
	  var n = +x;
	  return n > -1e-8 && n < 1e-8 ? n - n * n / 2 : log(1 + n);
	};


/***/ }),
/* 675 */
/***/ (function(module, exports) {

	'use strict';
	var ceil = Math.ceil;
	var floor = Math.floor;
	
	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	module.exports = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var safeGetBuiltIn = __webpack_require__(687);
	var bind = __webpack_require__(91);
	var macrotask = __webpack_require__(296).set;
	var Queue = __webpack_require__(685);
	var IS_IOS = __webpack_require__(656);
	var IS_IOS_PEBBLE = __webpack_require__(1227);
	var IS_WEBOS_WEBKIT = __webpack_require__(1228);
	var IS_NODE = __webpack_require__(182);
	
	var MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver;
	var document = globalThis.document;
	var process = globalThis.process;
	var Promise = globalThis.Promise;
	var microtask = safeGetBuiltIn('queueMicrotask');
	var notify, toggle, node, promise, then;
	
	// modern engines have queueMicrotask method
	if (!microtask) {
	  var queue = new Queue();
	
	  var flush = function () {
	    var parent, fn;
	    if (IS_NODE && (parent = process.domain)) parent.exit();
	    while (fn = queue.get()) try {
	      fn();
	    } catch (error) {
	      if (queue.head) notify();
	      throw error;
	    }
	    if (parent) parent.enter();
	  };
	
	  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
	  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
	  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
	    toggle = true;
	    node = document.createTextNode('');
	    new MutationObserver(flush).observe(node, { characterData: true });
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    promise = Promise.resolve(undefined);
	    // workaround of WebKit ~ iOS Safari 10.1 bug
	    promise.constructor = Promise;
	    then = bind(promise.then, promise);
	    notify = function () {
	      then(flush);
	    };
	  // Node.js without promises
	  } else if (IS_NODE) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessage
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    // `webpack` dev server bug on IE global methods - use bind(fn, global)
	    macrotask = bind(macrotask, globalThis);
	    notify = function () {
	      macrotask(flush);
	    };
	  }
	
	  microtask = function (fn) {
	    if (!queue.head) notify();
	    queue.add(fn);
	  };
	}
	
	module.exports = microtask;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var fails = __webpack_require__(6);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(18);
	var trim = __webpack_require__(192).trim;
	var whitespaces = __webpack_require__(301);
	
	var charAt = uncurryThis(''.charAt);
	var $parseFloat = globalThis.parseFloat;
	var Symbol = globalThis.Symbol;
	var ITERATOR = Symbol && Symbol.iterator;
	var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity
	  // MS Edge 18- broken with boxed symbols
	  || (ITERATOR && !fails(function () { $parseFloat(Object(ITERATOR)); }));
	
	// `parseFloat` method
	// https://tc39.es/ecma262/#sec-parsefloat-string
	module.exports = FORCED ? function parseFloat(string) {
	  var trimmedString = trim(toString(string));
	  var result = $parseFloat(trimmedString);
	  return result === 0 && charAt(trimmedString, 0) === '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var fails = __webpack_require__(6);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(18);
	var trim = __webpack_require__(192).trim;
	var whitespaces = __webpack_require__(301);
	
	var $parseInt = globalThis.parseInt;
	var Symbol = globalThis.Symbol;
	var ITERATOR = Symbol && Symbol.iterator;
	var hex = /^[+-]?0x/i;
	var exec = uncurryThis(hex.exec);
	var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
	  // MS Edge 18- broken with boxed symbols
	  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));
	
	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	module.exports = FORCED ? function parseInt(string, radix) {
	  var S = trim(toString(string));
	  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var uncurryThis = __webpack_require__(8);
	var call = __webpack_require__(19);
	var fails = __webpack_require__(6);
	var objectKeys = __webpack_require__(236);
	var getOwnPropertySymbolsModule = __webpack_require__(288);
	var propertyIsEnumerableModule = __webpack_require__(289);
	var toObject = __webpack_require__(31);
	var IndexedObject = __webpack_require__(185);
	
	// eslint-disable-next-line es/no-object-assign -- safe
	var $assign = Object.assign;
	// eslint-disable-next-line es/no-object-defineproperty -- required for testing
	var defineProperty = Object.defineProperty;
	var concat = uncurryThis([].concat);
	
	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	module.exports = !$assign || fails(function () {
	  // should have correct order of operations (Edge bug)
	  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
	    enumerable: true,
	    get: function () {
	      defineProperty(this, 'b', {
	        value: 3,
	        enumerable: false
	      });
	    }
	  }), { b: 2 })).b !== 1) return true;
	  // should work with symbols and should have deterministic property order (V8 bug)
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line es/no-symbol -- safe
	  var symbol = Symbol('assign detection');
	  var alphabet = 'abcdefghijklmnopqrst';
	  A[symbol] = 7;
	  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
	  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
	  var T = toObject(target);
	  var argumentsLength = arguments.length;
	  var index = 1;
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  var propertyIsEnumerable = propertyIsEnumerableModule.f;
	  while (argumentsLength > index) {
	    var S = IndexedObject(arguments[index++]);
	    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var hasOwn = __webpack_require__(29);
	var toIndexedObject = __webpack_require__(51);
	var indexOf = __webpack_require__(224).indexOf;
	var hiddenKeys = __webpack_require__(232);
	
	var push = uncurryThis([].push);
	
	module.exports = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn(O, key = names[i++])) {
	    ~indexOf(result, key) || push(result, key);
	  }
	  return result;
	};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var fails = __webpack_require__(6);
	var uncurryThis = __webpack_require__(8);
	var objectGetPrototypeOf = __webpack_require__(84);
	var objectKeys = __webpack_require__(236);
	var toIndexedObject = __webpack_require__(51);
	var $propertyIsEnumerable = __webpack_require__(289).f;
	
	var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
	var push = uncurryThis([].push);
	
	// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
	// of `null` prototype objects
	var IE_BUG = DESCRIPTORS && fails(function () {
	  // eslint-disable-next-line es/no-object-create -- safe
	  var O = Object.create(null);
	  O[2] = 2;
	  return !propertyIsEnumerable(O, 2);
	});
	
	// `Object.{ entries, values }` methods implementation
	var createMethod = function (TO_ENTRIES) {
	  return function (it) {
	    var O = toIndexedObject(it);
	    var keys = objectKeys(O);
	    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
	        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};
	
	module.exports = {
	  // `Object.entries` method
	  // https://tc39.es/ecma262/#sec-object.entries
	  entries: createMethod(true),
	  // `Object.values` method
	  // https://tc39.es/ecma262/#sec-object.values
	  values: createMethod(false)
	};


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var isCallable = __webpack_require__(28);
	var isObject = __webpack_require__(25);
	
	var $TypeError = TypeError;
	
	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	module.exports = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  throw new $TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(25);
	var newPromiseCapability = __webpack_require__(132);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineProperty = __webpack_require__(42).f;
	
	module.exports = function (Target, Source, key) {
	  key in Target || defineProperty(Target, key, {
	    configurable: true,
	    get: function () { return Source[key]; },
	    set: function (it) { Source[key] = it; }
	  });
	};


/***/ }),
/* 685 */
/***/ (function(module, exports) {

	'use strict';
	var Queue = function () {
	  this.head = null;
	  this.tail = null;
	};
	
	Queue.prototype = {
	  add: function (item) {
	    var entry = { item: item, next: null };
	    var tail = this.tail;
	    if (tail) tail.next = entry;
	    else this.head = entry;
	    this.tail = entry;
	  },
	  get: function () {
	    var entry = this.head;
	    if (entry) {
	      var next = this.head = entry.next;
	      if (next === null) this.tail = null;
	      return entry.item;
	    }
	  }
	};
	
	module.exports = Queue;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	var globalThis = __webpack_require__(9);
	
	// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
	var $RegExp = globalThis.RegExp;
	
	module.exports = fails(function () {
	  var re = $RegExp('(?<a>b)', 'g');
	  return re.exec('b').groups.a !== 'b' ||
	    'b'.replace(re, '$<a>c') !== 'bc';
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var DESCRIPTORS = __webpack_require__(14);
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Avoid NodeJS experimental warning
	module.exports = function (name) {
	  if (!DESCRIPTORS) return globalThis[name];
	  var descriptor = getOwnPropertyDescriptor(globalThis, name);
	  return descriptor && descriptor.value;
	};


/***/ }),
/* 688 */
/***/ (function(module, exports) {

	'use strict';
	// `SameValue` abstract operation
	// https://tc39.es/ecma262/#sec-samevalue
	// eslint-disable-next-line es/no-object-is -- safe
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
	};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zloirock/core-js/issues/280
	var userAgent = __webpack_require__(99);
	
	module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $trimEnd = __webpack_require__(192).end;
	var forcedStringTrimMethod = __webpack_require__(425);
	
	// `String.prototype.{ trimEnd, trimRight }` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimend
	// https://tc39.es/ecma262/#String.prototype.trimright
	module.exports = forcedStringTrimMethod('trimEnd') ? function trimEnd() {
	  return $trimEnd(this);
	// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
	} : ''.trimEnd;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $trimStart = __webpack_require__(192).start;
	var forcedStringTrimMethod = __webpack_require__(425);
	
	// `String.prototype.{ trimStart, trimLeft }` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimstart
	// https://tc39.es/ecma262/#String.prototype.trimleft
	module.exports = forcedStringTrimMethod('trimStart') ? function trimStart() {
	  return $trimStart(this);
	// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
	} : ''.trimStart;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var getBuiltIn = __webpack_require__(33);
	var wellKnownSymbol = __webpack_require__(27);
	var defineBuiltIn = __webpack_require__(40);
	
	module.exports = function () {
	  var Symbol = getBuiltIn('Symbol');
	  var SymbolPrototype = Symbol && Symbol.prototype;
	  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
	  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	
	  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
	    // `Symbol.prototype[@@toPrimitive]` method
	    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	    // eslint-disable-next-line no-unused-vars -- required for .length
	    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
	      return call(valueOf, this);
	    }, { arity: 1 });
	  }
	};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_SYMBOL = __webpack_require__(193);
	
	/* eslint-disable es/no-symbol -- safe */
	module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toPositiveInteger = __webpack_require__(1245);
	
	var $RangeError = RangeError;
	
	module.exports = function (it, BYTES) {
	  var offset = toPositiveInteger(it);
	  if (offset % BYTES) throw new $RangeError('Wrong offset');
	  return offset;
	};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(91);
	var call = __webpack_require__(19);
	var aConstructor = __webpack_require__(393);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var getIterator = __webpack_require__(284);
	var getIteratorMethod = __webpack_require__(231);
	var isArrayIteratorMethod = __webpack_require__(406);
	var isBigIntArray = __webpack_require__(667);
	var aTypedArrayConstructor = __webpack_require__(26).aTypedArrayConstructor;
	var toBigInt = __webpack_require__(427);
	
	module.exports = function from(source /* , mapfn, thisArg */) {
	  var C = aConstructor(this);
	  var O = toObject(source);
	  var argumentsLength = arguments.length;
	  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
	  var mapping = mapfn !== undefined;
	  var iteratorMethod = getIteratorMethod(O);
	  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
	  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
	    iterator = getIterator(O, iteratorMethod);
	    next = iterator.next;
	    O = [];
	    while (!(step = call(next, iterator)).done) {
	      O.push(step.value);
	    }
	  }
	  if (mapping && argumentsLength > 2) {
	    mapfn = bind(mapfn, arguments[2]);
	  }
	  length = lengthOfArrayLike(O);
	  result = new (aTypedArrayConstructor(C))(length);
	  thisIsBigIntArray = isBigIntArray(result);
	  for (i = 0; length > i; i++) {
	    value = mapping ? mapfn(O[i], i) : O[i];
	    // FF30- typed arrays doesn't properly convert objects to typed array values
	    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
	  }
	  return result;
	};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-symbol -- required for testing */
	var NATIVE_SYMBOL = __webpack_require__(193);
	
	module.exports = NATIVE_SYMBOL
	  && !Symbol.sham
	  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var fails = __webpack_require__(6);
	
	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	module.exports = DESCRIPTORS && fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype !== 42;
	});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var isCallable = __webpack_require__(28);
	
	var WeakMap = globalThis.WeakMap;
	
	module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(27);
	
	exports.f = wellKnownSymbol;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(33);
	var hasOwn = __webpack_require__(29);
	var createNonEnumerableProperty = __webpack_require__(58);
	var isPrototypeOf = __webpack_require__(74);
	var setPrototypeOf = __webpack_require__(100);
	var copyConstructorProperties = __webpack_require__(227);
	var proxyAccessor = __webpack_require__(684);
	var inheritIfRequired = __webpack_require__(148);
	var normalizeStringArgument = __webpack_require__(235);
	var installErrorCause = __webpack_require__(666);
	var installErrorStack = __webpack_require__(657);
	var DESCRIPTORS = __webpack_require__(14);
	var IS_PURE = __webpack_require__(43);
	
	module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
	  var STACK_TRACE_LIMIT = 'stackTraceLimit';
	  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
	  var path = FULL_NAME.split('.');
	  var ERROR_NAME = path[path.length - 1];
	  var OriginalError = getBuiltIn.apply(null, path);
	
	  if (!OriginalError) return;
	
	  var OriginalErrorPrototype = OriginalError.prototype;
	
	  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
	  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;
	
	  if (!FORCED) return OriginalError;
	
	  var BaseError = getBuiltIn('Error');
	
	  var WrappedError = wrapper(function (a, b) {
	    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
	    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
	    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
	    installErrorStack(result, WrappedError, result.stack, 2);
	    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
	    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
	    return result;
	  });
	
	  WrappedError.prototype = OriginalErrorPrototype;
	
	  if (ERROR_NAME !== 'Error') {
	    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
	    else copyConstructorProperties(WrappedError, BaseError, { name: true });
	  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
	    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
	    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
	  }
	
	  copyConstructorProperties(WrappedError, OriginalError);
	
	  if (!IS_PURE) try {
	    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
	    if (OriginalErrorPrototype.name !== ERROR_NAME) {
	      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
	    }
	    OriginalErrorPrototype.constructor = WrappedError;
	  } catch (error) { /* empty */ }
	
	  return WrappedError;
	};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var apply = __webpack_require__(90);
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	var isCallable = __webpack_require__(28);
	var isSymbol = __webpack_require__(150);
	var arraySlice = __webpack_require__(89);
	var getReplacerFunction = __webpack_require__(1231);
	var NATIVE_SYMBOL = __webpack_require__(193);
	
	var $String = String;
	var $stringify = getBuiltIn('JSON', 'stringify');
	var exec = uncurryThis(/./.exec);
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var replace = uncurryThis(''.replace);
	var numberToString = uncurryThis(1.0.toString);
	
	var tester = /[\uD800-\uDFFF]/g;
	var low = /^[\uD800-\uDBFF]$/;
	var hi = /^[\uDC00-\uDFFF]$/;
	
	var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
	  var symbol = getBuiltIn('Symbol')('stringify detection');
	  // MS Edge converts symbol values to JSON as {}
	  return $stringify([symbol]) !== '[null]'
	    // WebKit converts symbol values to JSON as null
	    || $stringify({ a: symbol }) !== '{}'
	    // V8 throws on boxed symbols
	    || $stringify(Object(symbol)) !== '{}';
	});
	
	// https://github.com/tc39/proposal-well-formed-stringify
	var ILL_FORMED_UNICODE = fails(function () {
	  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
	    || $stringify('\uDEAD') !== '"\\udead"';
	});
	
	var stringifyWithSymbolsFix = function (it, replacer) {
	  var args = arraySlice(arguments);
	  var $replacer = getReplacerFunction(replacer);
	  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
	  args[1] = function (key, value) {
	    // some old implementations (like WebKit) could pass numbers as keys
	    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
	    if (!isSymbol(value)) return value;
	  };
	  return apply($stringify, null, args);
	};
	
	var fixIllFormed = function (match, offset, string) {
	  var prev = charAt(string, offset - 1);
	  var next = charAt(string, offset + 1);
	  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
	    return '\\u' + numberToString(charCodeAt(match, 0), 16);
	  } return match;
	};
	
	if ($stringify) {
	  // `JSON.stringify` method
	  // https://tc39.es/ecma262/#sec-json.stringify
	  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
	    // eslint-disable-next-line no-unused-vars -- required for `.length`
	    stringify: function stringify(it, replacer, space) {
	      var args = arraySlice(arguments);
	      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
	      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
	    }
	  });
	}


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(117);
	
	var $RangeError = RangeError;
	var fromCharCode = String.fromCharCode;
	// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
	var $fromCodePoint = String.fromCodePoint;
	var join = uncurryThis([].join);
	
	// length should be 1, old FF problem
	var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;
	
	// `String.fromCodePoint` method
	// https://tc39.es/ecma262/#sec-string.fromcodepoint
	$({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  fromCodePoint: function fromCodePoint(x) {
	    var elements = [];
	    var length = arguments.length;
	    var i = 0;
	    var code;
	    while (length > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
	      elements[i] = code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
	    } return join(elements, '');
	  }
	});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var charAt = __webpack_require__(294).charAt;
	var toString = __webpack_require__(18);
	var InternalStateModule = __webpack_require__(49);
	var defineIterator = __webpack_require__(409);
	var createIterResultObject = __webpack_require__(228);
	
	var STRING_ITERATOR = 'String Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
	
	// `String.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
	defineIterator(String, 'String', function (iterated) {
	  setInternalState(this, {
	    type: STRING_ITERATOR,
	    string: toString(iterated),
	    index: 0
	  });
	// `%StringIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
	}, function next() {
	  var state = getInternalState(this);
	  var string = state.string;
	  var index = state.index;
	  var point;
	  if (index >= string.length) return createIterResultObject(undefined, true);
	  point = charAt(string, index);
	  state.index += point.length;
	  return createIterResultObject(point, false);
	});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
	__webpack_require__(302);
	__webpack_require__(702);
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var safeGetBuiltIn = __webpack_require__(687);
	var getBuiltIn = __webpack_require__(33);
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(14);
	var USE_NATIVE_URL = __webpack_require__(300);
	var defineBuiltIn = __webpack_require__(40);
	var defineBuiltInAccessor = __webpack_require__(50);
	var defineBuiltIns = __webpack_require__(229);
	var setToStringTag = __webpack_require__(65);
	var createIteratorConstructor = __webpack_require__(408);
	var InternalStateModule = __webpack_require__(49);
	var anInstance = __webpack_require__(97);
	var isCallable = __webpack_require__(28);
	var hasOwn = __webpack_require__(29);
	var bind = __webpack_require__(91);
	var classof = __webpack_require__(98);
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(25);
	var $toString = __webpack_require__(18);
	var create = __webpack_require__(73);
	var createPropertyDescriptor = __webpack_require__(82);
	var getIterator = __webpack_require__(284);
	var getIteratorMethod = __webpack_require__(231);
	var createIterResultObject = __webpack_require__(228);
	var validateArgumentsLength = __webpack_require__(85);
	var wellKnownSymbol = __webpack_require__(27);
	var arraySort = __webpack_require__(398);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var URL_SEARCH_PARAMS = 'URLSearchParams';
	var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
	var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
	
	var nativeFetch = safeGetBuiltIn('fetch');
	var NativeRequest = safeGetBuiltIn('Request');
	var Headers = safeGetBuiltIn('Headers');
	var RequestPrototype = NativeRequest && NativeRequest.prototype;
	var HeadersPrototype = Headers && Headers.prototype;
	var TypeError = globalThis.TypeError;
	var encodeURIComponent = globalThis.encodeURIComponent;
	var fromCharCode = String.fromCharCode;
	var fromCodePoint = getBuiltIn('String', 'fromCodePoint');
	var $parseInt = parseInt;
	var charAt = uncurryThis(''.charAt);
	var join = uncurryThis([].join);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var shift = uncurryThis([].shift);
	var splice = uncurryThis([].splice);
	var split = uncurryThis(''.split);
	var stringSlice = uncurryThis(''.slice);
	var exec = uncurryThis(/./.exec);
	
	var plus = /\+/g;
	var FALLBACK_REPLACER = '\uFFFD';
	var VALID_HEX = /^[0-9a-f]+$/i;
	
	var parseHexOctet = function (string, start) {
	  var substr = stringSlice(string, start, start + 2);
	  if (!exec(VALID_HEX, substr)) return NaN;
	
	  return $parseInt(substr, 16);
	};
	
	var getLeadingOnes = function (octet) {
	  var count = 0;
	  for (var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1) {
	    count++;
	  }
	  return count;
	};
	
	var utf8Decode = function (octets) {
	  var codePoint = null;
	
	  switch (octets.length) {
	    case 1:
	      codePoint = octets[0];
	      break;
	    case 2:
	      codePoint = (octets[0] & 0x1F) << 6 | (octets[1] & 0x3F);
	      break;
	    case 3:
	      codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | (octets[2] & 0x3F);
	      break;
	    case 4:
	      codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | (octets[3] & 0x3F);
	      break;
	  }
	
	  return codePoint > 0x10FFFF ? null : codePoint;
	};
	
	var decode = function (input) {
	  input = replace(input, plus, ' ');
	  var length = input.length;
	  var result = '';
	  var i = 0;
	
	  while (i < length) {
	    var decodedChar = charAt(input, i);
	
	    if (decodedChar === '%') {
	      if (charAt(input, i + 1) === '%' || i + 3 > length) {
	        result += '%';
	        i++;
	        continue;
	      }
	
	      var octet = parseHexOctet(input, i + 1);
	
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (octet !== octet) {
	        result += decodedChar;
	        i++;
	        continue;
	      }
	
	      i += 2;
	      var byteSequenceLength = getLeadingOnes(octet);
	
	      if (byteSequenceLength === 0) {
	        decodedChar = fromCharCode(octet);
	      } else {
	        if (byteSequenceLength === 1 || byteSequenceLength > 4) {
	          result += FALLBACK_REPLACER;
	          i++;
	          continue;
	        }
	
	        var octets = [octet];
	        var sequenceIndex = 1;
	
	        while (sequenceIndex < byteSequenceLength) {
	          i++;
	          if (i + 3 > length || charAt(input, i) !== '%') break;
	
	          var nextByte = parseHexOctet(input, i + 1);
	
	          // eslint-disable-next-line no-self-compare -- NaN check
	          if (nextByte !== nextByte) {
	            i += 3;
	            break;
	          }
	          if (nextByte > 191 || nextByte < 128) break;
	
	          push(octets, nextByte);
	          i += 2;
	          sequenceIndex++;
	        }
	
	        if (octets.length !== byteSequenceLength) {
	          result += FALLBACK_REPLACER;
	          continue;
	        }
	
	        var codePoint = utf8Decode(octets);
	        if (codePoint === null) {
	          result += FALLBACK_REPLACER;
	        } else {
	          decodedChar = fromCodePoint(codePoint);
	        }
	      }
	    }
	
	    result += decodedChar;
	    i++;
	  }
	
	  return result;
	};
	
	var find = /[!'()~]|%20/g;
	
	var replacements = {
	  '!': '%21',
	  "'": '%27',
	  '(': '%28',
	  ')': '%29',
	  '~': '%7E',
	  '%20': '+'
	};
	
	var replacer = function (match) {
	  return replacements[match];
	};
	
	var serialize = function (it) {
	  return replace(encodeURIComponent(it), find, replacer);
	};
	
	var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
	  setInternalState(this, {
	    type: URL_SEARCH_PARAMS_ITERATOR,
	    target: getInternalParamsState(params).entries,
	    index: 0,
	    kind: kind
	  });
	}, URL_SEARCH_PARAMS, function next() {
	  var state = getInternalIteratorState(this);
	  var target = state.target;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = null;
	    return createIterResultObject(undefined, true);
	  }
	  var entry = target[index];
	  switch (state.kind) {
	    case 'keys': return createIterResultObject(entry.key, false);
	    case 'values': return createIterResultObject(entry.value, false);
	  } return createIterResultObject([entry.key, entry.value], false);
	}, true);
	
	var URLSearchParamsState = function (init) {
	  this.entries = [];
	  this.url = null;
	
	  if (init !== undefined) {
	    if (isObject(init)) this.parseObject(init);
	    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
	  }
	};
	
	URLSearchParamsState.prototype = {
	  type: URL_SEARCH_PARAMS,
	  bindURL: function (url) {
	    this.url = url;
	    this.update();
	  },
	  parseObject: function (object) {
	    var entries = this.entries;
	    var iteratorMethod = getIteratorMethod(object);
	    var iterator, next, step, entryIterator, entryNext, first, second;
	
	    if (iteratorMethod) {
	      iterator = getIterator(object, iteratorMethod);
	      next = iterator.next;
	      while (!(step = call(next, iterator)).done) {
	        entryIterator = getIterator(anObject(step.value));
	        entryNext = entryIterator.next;
	        if (
	          (first = call(entryNext, entryIterator)).done ||
	          (second = call(entryNext, entryIterator)).done ||
	          !call(entryNext, entryIterator).done
	        ) throw new TypeError('Expected sequence with length 2');
	        push(entries, { key: $toString(first.value), value: $toString(second.value) });
	      }
	    } else for (var key in object) if (hasOwn(object, key)) {
	      push(entries, { key: key, value: $toString(object[key]) });
	    }
	  },
	  parseQuery: function (query) {
	    if (query) {
	      var entries = this.entries;
	      var attributes = split(query, '&');
	      var index = 0;
	      var attribute, entry;
	      while (index < attributes.length) {
	        attribute = attributes[index++];
	        if (attribute.length) {
	          entry = split(attribute, '=');
	          push(entries, {
	            key: decode(shift(entry)),
	            value: decode(join(entry, '='))
	          });
	        }
	      }
	    }
	  },
	  serialize: function () {
	    var entries = this.entries;
	    var result = [];
	    var index = 0;
	    var entry;
	    while (index < entries.length) {
	      entry = entries[index++];
	      push(result, serialize(entry.key) + '=' + serialize(entry.value));
	    } return join(result, '&');
	  },
	  update: function () {
	    this.entries.length = 0;
	    this.parseQuery(this.url.query);
	  },
	  updateURL: function () {
	    if (this.url) this.url.update();
	  }
	};
	
	// `URLSearchParams` constructor
	// https://url.spec.whatwg.org/#interface-urlsearchparams
	var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
	  anInstance(this, URLSearchParamsPrototype);
	  var init = arguments.length > 0 ? arguments[0] : undefined;
	  var state = setInternalState(this, new URLSearchParamsState(init));
	  if (!DESCRIPTORS) this.size = state.entries.length;
	};
	
	var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
	
	defineBuiltIns(URLSearchParamsPrototype, {
	  // `URLSearchParams.prototype.append` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
	  append: function append(name, value) {
	    var state = getInternalParamsState(this);
	    validateArgumentsLength(arguments.length, 2);
	    push(state.entries, { key: $toString(name), value: $toString(value) });
	    if (!DESCRIPTORS) this.length++;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.delete` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
	  'delete': function (name /* , value */) {
	    var state = getInternalParamsState(this);
	    var length = validateArgumentsLength(arguments.length, 1);
	    var entries = state.entries;
	    var key = $toString(name);
	    var $value = length < 2 ? undefined : arguments[1];
	    var value = $value === undefined ? $value : $toString($value);
	    var index = 0;
	    while (index < entries.length) {
	      var entry = entries[index];
	      if (entry.key === key && (value === undefined || entry.value === value)) {
	        splice(entries, index, 1);
	        if (value !== undefined) break;
	      } else index++;
	    }
	    if (!DESCRIPTORS) this.size = entries.length;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.get` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
	  get: function get(name) {
	    var entries = getInternalParamsState(this).entries;
	    validateArgumentsLength(arguments.length, 1);
	    var key = $toString(name);
	    var index = 0;
	    for (; index < entries.length; index++) {
	      if (entries[index].key === key) return entries[index].value;
	    }
	    return null;
	  },
	  // `URLSearchParams.prototype.getAll` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
	  getAll: function getAll(name) {
	    var entries = getInternalParamsState(this).entries;
	    validateArgumentsLength(arguments.length, 1);
	    var key = $toString(name);
	    var result = [];
	    var index = 0;
	    for (; index < entries.length; index++) {
	      if (entries[index].key === key) push(result, entries[index].value);
	    }
	    return result;
	  },
	  // `URLSearchParams.prototype.has` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
	  has: function has(name /* , value */) {
	    var entries = getInternalParamsState(this).entries;
	    var length = validateArgumentsLength(arguments.length, 1);
	    var key = $toString(name);
	    var $value = length < 2 ? undefined : arguments[1];
	    var value = $value === undefined ? $value : $toString($value);
	    var index = 0;
	    while (index < entries.length) {
	      var entry = entries[index++];
	      if (entry.key === key && (value === undefined || entry.value === value)) return true;
	    }
	    return false;
	  },
	  // `URLSearchParams.prototype.set` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
	  set: function set(name, value) {
	    var state = getInternalParamsState(this);
	    validateArgumentsLength(arguments.length, 1);
	    var entries = state.entries;
	    var found = false;
	    var key = $toString(name);
	    var val = $toString(value);
	    var index = 0;
	    var entry;
	    for (; index < entries.length; index++) {
	      entry = entries[index];
	      if (entry.key === key) {
	        if (found) splice(entries, index--, 1);
	        else {
	          found = true;
	          entry.value = val;
	        }
	      }
	    }
	    if (!found) push(entries, { key: key, value: val });
	    if (!DESCRIPTORS) this.size = entries.length;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.sort` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
	  sort: function sort() {
	    var state = getInternalParamsState(this);
	    arraySort(state.entries, function (a, b) {
	      return a.key > b.key ? 1 : -1;
	    });
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.forEach` method
	  forEach: function forEach(callback /* , thisArg */) {
	    var entries = getInternalParamsState(this).entries;
	    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
	    var index = 0;
	    var entry;
	    while (index < entries.length) {
	      entry = entries[index++];
	      boundFunction(entry.value, entry.key, this);
	    }
	  },
	  // `URLSearchParams.prototype.keys` method
	  keys: function keys() {
	    return new URLSearchParamsIterator(this, 'keys');
	  },
	  // `URLSearchParams.prototype.values` method
	  values: function values() {
	    return new URLSearchParamsIterator(this, 'values');
	  },
	  // `URLSearchParams.prototype.entries` method
	  entries: function entries() {
	    return new URLSearchParamsIterator(this, 'entries');
	  }
	}, { enumerable: true });
	
	// `URLSearchParams.prototype[@@iterator]` method
	defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });
	
	// `URLSearchParams.prototype.toString` method
	// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
	defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
	  return getInternalParamsState(this).serialize();
	}, { enumerable: true });
	
	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	  get: function size() {
	    return getInternalParamsState(this).entries.length;
	  },
	  configurable: true,
	  enumerable: true
	});
	
	setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
	
	$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
	  URLSearchParams: URLSearchParamsConstructor
	});
	
	// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
	if (!USE_NATIVE_URL && isCallable(Headers)) {
	  var headersHas = uncurryThis(HeadersPrototype.has);
	  var headersSet = uncurryThis(HeadersPrototype.set);
	
	  var wrapRequestOptions = function (init) {
	    if (isObject(init)) {
	      var body = init.body;
	      var headers;
	      if (classof(body) === URL_SEARCH_PARAMS) {
	        headers = init.headers ? new Headers(init.headers) : new Headers();
	        if (!headersHas(headers, 'content-type')) {
	          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	        return create(init, {
	          body: createPropertyDescriptor(0, $toString(body)),
	          headers: createPropertyDescriptor(0, headers)
	        });
	      }
	    } return init;
	  };
	
	  if (isCallable(nativeFetch)) {
	    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
	      fetch: function fetch(input /* , init */) {
	        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
	      }
	    });
	  }
	
	  if (isCallable(NativeRequest)) {
	    var RequestConstructor = function Request(input /* , init */) {
	      anInstance(this, RequestPrototype);
	      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
	    };
	
	    RequestPrototype.constructor = RequestConstructor;
	    RequestConstructor.prototype = RequestPrototype;
	
	    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
	      Request: RequestConstructor
	    });
	  }
	}
	
	module.exports = {
	  URLSearchParams: URLSearchParamsConstructor,
	  getState: getInternalParamsState
	};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 706 */
/***/ (function(module, exports) {

	/**
	 * cssfilter
	 *
	 * @author 老雷<leizongmin@gmail.com>
	 */
	
	function getDefaultWhiteList () {
	  // 白名单值说明：
	  // true: 允许该属性
	  // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
	  // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
	  // 除上面列出的值外均表示不允许
	  var whiteList = {};
	
	  whiteList['align-content'] = false; // default: auto
	  whiteList['align-items'] = false; // default: auto
	  whiteList['align-self'] = false; // default: auto
	  whiteList['alignment-adjust'] = false; // default: auto
	  whiteList['alignment-baseline'] = false; // default: baseline
	  whiteList['all'] = false; // default: depending on individual properties
	  whiteList['anchor-point'] = false; // default: none
	  whiteList['animation'] = false; // default: depending on individual properties
	  whiteList['animation-delay'] = false; // default: 0
	  whiteList['animation-direction'] = false; // default: normal
	  whiteList['animation-duration'] = false; // default: 0
	  whiteList['animation-fill-mode'] = false; // default: none
	  whiteList['animation-iteration-count'] = false; // default: 1
	  whiteList['animation-name'] = false; // default: none
	  whiteList['animation-play-state'] = false; // default: running
	  whiteList['animation-timing-function'] = false; // default: ease
	  whiteList['azimuth'] = false; // default: center
	  whiteList['backface-visibility'] = false; // default: visible
	  whiteList['background'] = true; // default: depending on individual properties
	  whiteList['background-attachment'] = true; // default: scroll
	  whiteList['background-clip'] = true; // default: border-box
	  whiteList['background-color'] = true; // default: transparent
	  whiteList['background-image'] = true; // default: none
	  whiteList['background-origin'] = true; // default: padding-box
	  whiteList['background-position'] = true; // default: 0% 0%
	  whiteList['background-repeat'] = true; // default: repeat
	  whiteList['background-size'] = true; // default: auto
	  whiteList['baseline-shift'] = false; // default: baseline
	  whiteList['binding'] = false; // default: none
	  whiteList['bleed'] = false; // default: 6pt
	  whiteList['bookmark-label'] = false; // default: content()
	  whiteList['bookmark-level'] = false; // default: none
	  whiteList['bookmark-state'] = false; // default: open
	  whiteList['border'] = true; // default: depending on individual properties
	  whiteList['border-bottom'] = true; // default: depending on individual properties
	  whiteList['border-bottom-color'] = true; // default: current color
	  whiteList['border-bottom-left-radius'] = true; // default: 0
	  whiteList['border-bottom-right-radius'] = true; // default: 0
	  whiteList['border-bottom-style'] = true; // default: none
	  whiteList['border-bottom-width'] = true; // default: medium
	  whiteList['border-collapse'] = true; // default: separate
	  whiteList['border-color'] = true; // default: depending on individual properties
	  whiteList['border-image'] = true; // default: none
	  whiteList['border-image-outset'] = true; // default: 0
	  whiteList['border-image-repeat'] = true; // default: stretch
	  whiteList['border-image-slice'] = true; // default: 100%
	  whiteList['border-image-source'] = true; // default: none
	  whiteList['border-image-width'] = true; // default: 1
	  whiteList['border-left'] = true; // default: depending on individual properties
	  whiteList['border-left-color'] = true; // default: current color
	  whiteList['border-left-style'] = true; // default: none
	  whiteList['border-left-width'] = true; // default: medium
	  whiteList['border-radius'] = true; // default: 0
	  whiteList['border-right'] = true; // default: depending on individual properties
	  whiteList['border-right-color'] = true; // default: current color
	  whiteList['border-right-style'] = true; // default: none
	  whiteList['border-right-width'] = true; // default: medium
	  whiteList['border-spacing'] = true; // default: 0
	  whiteList['border-style'] = true; // default: depending on individual properties
	  whiteList['border-top'] = true; // default: depending on individual properties
	  whiteList['border-top-color'] = true; // default: current color
	  whiteList['border-top-left-radius'] = true; // default: 0
	  whiteList['border-top-right-radius'] = true; // default: 0
	  whiteList['border-top-style'] = true; // default: none
	  whiteList['border-top-width'] = true; // default: medium
	  whiteList['border-width'] = true; // default: depending on individual properties
	  whiteList['bottom'] = false; // default: auto
	  whiteList['box-decoration-break'] = true; // default: slice
	  whiteList['box-shadow'] = true; // default: none
	  whiteList['box-sizing'] = true; // default: content-box
	  whiteList['box-snap'] = true; // default: none
	  whiteList['box-suppress'] = true; // default: show
	  whiteList['break-after'] = true; // default: auto
	  whiteList['break-before'] = true; // default: auto
	  whiteList['break-inside'] = true; // default: auto
	  whiteList['caption-side'] = false; // default: top
	  whiteList['chains'] = false; // default: none
	  whiteList['clear'] = true; // default: none
	  whiteList['clip'] = false; // default: auto
	  whiteList['clip-path'] = false; // default: none
	  whiteList['clip-rule'] = false; // default: nonzero
	  whiteList['color'] = true; // default: implementation dependent
	  whiteList['color-interpolation-filters'] = true; // default: auto
	  whiteList['column-count'] = false; // default: auto
	  whiteList['column-fill'] = false; // default: balance
	  whiteList['column-gap'] = false; // default: normal
	  whiteList['column-rule'] = false; // default: depending on individual properties
	  whiteList['column-rule-color'] = false; // default: current color
	  whiteList['column-rule-style'] = false; // default: medium
	  whiteList['column-rule-width'] = false; // default: medium
	  whiteList['column-span'] = false; // default: none
	  whiteList['column-width'] = false; // default: auto
	  whiteList['columns'] = false; // default: depending on individual properties
	  whiteList['contain'] = false; // default: none
	  whiteList['content'] = false; // default: normal
	  whiteList['counter-increment'] = false; // default: none
	  whiteList['counter-reset'] = false; // default: none
	  whiteList['counter-set'] = false; // default: none
	  whiteList['crop'] = false; // default: auto
	  whiteList['cue'] = false; // default: depending on individual properties
	  whiteList['cue-after'] = false; // default: none
	  whiteList['cue-before'] = false; // default: none
	  whiteList['cursor'] = false; // default: auto
	  whiteList['direction'] = false; // default: ltr
	  whiteList['display'] = true; // default: depending on individual properties
	  whiteList['display-inside'] = true; // default: auto
	  whiteList['display-list'] = true; // default: none
	  whiteList['display-outside'] = true; // default: inline-level
	  whiteList['dominant-baseline'] = false; // default: auto
	  whiteList['elevation'] = false; // default: level
	  whiteList['empty-cells'] = false; // default: show
	  whiteList['filter'] = false; // default: none
	  whiteList['flex'] = false; // default: depending on individual properties
	  whiteList['flex-basis'] = false; // default: auto
	  whiteList['flex-direction'] = false; // default: row
	  whiteList['flex-flow'] = false; // default: depending on individual properties
	  whiteList['flex-grow'] = false; // default: 0
	  whiteList['flex-shrink'] = false; // default: 1
	  whiteList['flex-wrap'] = false; // default: nowrap
	  whiteList['float'] = false; // default: none
	  whiteList['float-offset'] = false; // default: 0 0
	  whiteList['flood-color'] = false; // default: black
	  whiteList['flood-opacity'] = false; // default: 1
	  whiteList['flow-from'] = false; // default: none
	  whiteList['flow-into'] = false; // default: none
	  whiteList['font'] = true; // default: depending on individual properties
	  whiteList['font-family'] = true; // default: implementation dependent
	  whiteList['font-feature-settings'] = true; // default: normal
	  whiteList['font-kerning'] = true; // default: auto
	  whiteList['font-language-override'] = true; // default: normal
	  whiteList['font-size'] = true; // default: medium
	  whiteList['font-size-adjust'] = true; // default: none
	  whiteList['font-stretch'] = true; // default: normal
	  whiteList['font-style'] = true; // default: normal
	  whiteList['font-synthesis'] = true; // default: weight style
	  whiteList['font-variant'] = true; // default: normal
	  whiteList['font-variant-alternates'] = true; // default: normal
	  whiteList['font-variant-caps'] = true; // default: normal
	  whiteList['font-variant-east-asian'] = true; // default: normal
	  whiteList['font-variant-ligatures'] = true; // default: normal
	  whiteList['font-variant-numeric'] = true; // default: normal
	  whiteList['font-variant-position'] = true; // default: normal
	  whiteList['font-weight'] = true; // default: normal
	  whiteList['grid'] = false; // default: depending on individual properties
	  whiteList['grid-area'] = false; // default: depending on individual properties
	  whiteList['grid-auto-columns'] = false; // default: auto
	  whiteList['grid-auto-flow'] = false; // default: none
	  whiteList['grid-auto-rows'] = false; // default: auto
	  whiteList['grid-column'] = false; // default: depending on individual properties
	  whiteList['grid-column-end'] = false; // default: auto
	  whiteList['grid-column-start'] = false; // default: auto
	  whiteList['grid-row'] = false; // default: depending on individual properties
	  whiteList['grid-row-end'] = false; // default: auto
	  whiteList['grid-row-start'] = false; // default: auto
	  whiteList['grid-template'] = false; // default: depending on individual properties
	  whiteList['grid-template-areas'] = false; // default: none
	  whiteList['grid-template-columns'] = false; // default: none
	  whiteList['grid-template-rows'] = false; // default: none
	  whiteList['hanging-punctuation'] = false; // default: none
	  whiteList['height'] = true; // default: auto
	  whiteList['hyphens'] = false; // default: manual
	  whiteList['icon'] = false; // default: auto
	  whiteList['image-orientation'] = false; // default: auto
	  whiteList['image-resolution'] = false; // default: normal
	  whiteList['ime-mode'] = false; // default: auto
	  whiteList['initial-letters'] = false; // default: normal
	  whiteList['inline-box-align'] = false; // default: last
	  whiteList['justify-content'] = false; // default: auto
	  whiteList['justify-items'] = false; // default: auto
	  whiteList['justify-self'] = false; // default: auto
	  whiteList['left'] = false; // default: auto
	  whiteList['letter-spacing'] = true; // default: normal
	  whiteList['lighting-color'] = true; // default: white
	  whiteList['line-box-contain'] = false; // default: block inline replaced
	  whiteList['line-break'] = false; // default: auto
	  whiteList['line-grid'] = false; // default: match-parent
	  whiteList['line-height'] = false; // default: normal
	  whiteList['line-snap'] = false; // default: none
	  whiteList['line-stacking'] = false; // default: depending on individual properties
	  whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
	  whiteList['line-stacking-shift'] = false; // default: consider-shifts
	  whiteList['line-stacking-strategy'] = false; // default: inline-line-height
	  whiteList['list-style'] = true; // default: depending on individual properties
	  whiteList['list-style-image'] = true; // default: none
	  whiteList['list-style-position'] = true; // default: outside
	  whiteList['list-style-type'] = true; // default: disc
	  whiteList['margin'] = true; // default: depending on individual properties
	  whiteList['margin-bottom'] = true; // default: 0
	  whiteList['margin-left'] = true; // default: 0
	  whiteList['margin-right'] = true; // default: 0
	  whiteList['margin-top'] = true; // default: 0
	  whiteList['marker-offset'] = false; // default: auto
	  whiteList['marker-side'] = false; // default: list-item
	  whiteList['marks'] = false; // default: none
	  whiteList['mask'] = false; // default: border-box
	  whiteList['mask-box'] = false; // default: see individual properties
	  whiteList['mask-box-outset'] = false; // default: 0
	  whiteList['mask-box-repeat'] = false; // default: stretch
	  whiteList['mask-box-slice'] = false; // default: 0 fill
	  whiteList['mask-box-source'] = false; // default: none
	  whiteList['mask-box-width'] = false; // default: auto
	  whiteList['mask-clip'] = false; // default: border-box
	  whiteList['mask-image'] = false; // default: none
	  whiteList['mask-origin'] = false; // default: border-box
	  whiteList['mask-position'] = false; // default: center
	  whiteList['mask-repeat'] = false; // default: no-repeat
	  whiteList['mask-size'] = false; // default: border-box
	  whiteList['mask-source-type'] = false; // default: auto
	  whiteList['mask-type'] = false; // default: luminance
	  whiteList['max-height'] = true; // default: none
	  whiteList['max-lines'] = false; // default: none
	  whiteList['max-width'] = true; // default: none
	  whiteList['min-height'] = true; // default: 0
	  whiteList['min-width'] = true; // default: 0
	  whiteList['move-to'] = false; // default: normal
	  whiteList['nav-down'] = false; // default: auto
	  whiteList['nav-index'] = false; // default: auto
	  whiteList['nav-left'] = false; // default: auto
	  whiteList['nav-right'] = false; // default: auto
	  whiteList['nav-up'] = false; // default: auto
	  whiteList['object-fit'] = false; // default: fill
	  whiteList['object-position'] = false; // default: 50% 50%
	  whiteList['opacity'] = false; // default: 1
	  whiteList['order'] = false; // default: 0
	  whiteList['orphans'] = false; // default: 2
	  whiteList['outline'] = false; // default: depending on individual properties
	  whiteList['outline-color'] = false; // default: invert
	  whiteList['outline-offset'] = false; // default: 0
	  whiteList['outline-style'] = false; // default: none
	  whiteList['outline-width'] = false; // default: medium
	  whiteList['overflow'] = false; // default: depending on individual properties
	  whiteList['overflow-wrap'] = false; // default: normal
	  whiteList['overflow-x'] = false; // default: visible
	  whiteList['overflow-y'] = false; // default: visible
	  whiteList['padding'] = true; // default: depending on individual properties
	  whiteList['padding-bottom'] = true; // default: 0
	  whiteList['padding-left'] = true; // default: 0
	  whiteList['padding-right'] = true; // default: 0
	  whiteList['padding-top'] = true; // default: 0
	  whiteList['page'] = false; // default: auto
	  whiteList['page-break-after'] = false; // default: auto
	  whiteList['page-break-before'] = false; // default: auto
	  whiteList['page-break-inside'] = false; // default: auto
	  whiteList['page-policy'] = false; // default: start
	  whiteList['pause'] = false; // default: implementation dependent
	  whiteList['pause-after'] = false; // default: implementation dependent
	  whiteList['pause-before'] = false; // default: implementation dependent
	  whiteList['perspective'] = false; // default: none
	  whiteList['perspective-origin'] = false; // default: 50% 50%
	  whiteList['pitch'] = false; // default: medium
	  whiteList['pitch-range'] = false; // default: 50
	  whiteList['play-during'] = false; // default: auto
	  whiteList['position'] = false; // default: static
	  whiteList['presentation-level'] = false; // default: 0
	  whiteList['quotes'] = false; // default: text
	  whiteList['region-fragment'] = false; // default: auto
	  whiteList['resize'] = false; // default: none
	  whiteList['rest'] = false; // default: depending on individual properties
	  whiteList['rest-after'] = false; // default: none
	  whiteList['rest-before'] = false; // default: none
	  whiteList['richness'] = false; // default: 50
	  whiteList['right'] = false; // default: auto
	  whiteList['rotation'] = false; // default: 0
	  whiteList['rotation-point'] = false; // default: 50% 50%
	  whiteList['ruby-align'] = false; // default: auto
	  whiteList['ruby-merge'] = false; // default: separate
	  whiteList['ruby-position'] = false; // default: before
	  whiteList['shape-image-threshold'] = false; // default: 0.0
	  whiteList['shape-outside'] = false; // default: none
	  whiteList['shape-margin'] = false; // default: 0
	  whiteList['size'] = false; // default: auto
	  whiteList['speak'] = false; // default: auto
	  whiteList['speak-as'] = false; // default: normal
	  whiteList['speak-header'] = false; // default: once
	  whiteList['speak-numeral'] = false; // default: continuous
	  whiteList['speak-punctuation'] = false; // default: none
	  whiteList['speech-rate'] = false; // default: medium
	  whiteList['stress'] = false; // default: 50
	  whiteList['string-set'] = false; // default: none
	  whiteList['tab-size'] = false; // default: 8
	  whiteList['table-layout'] = false; // default: auto
	  whiteList['text-align'] = true; // default: start
	  whiteList['text-align-last'] = true; // default: auto
	  whiteList['text-combine-upright'] = true; // default: none
	  whiteList['text-decoration'] = true; // default: none
	  whiteList['text-decoration-color'] = true; // default: currentColor
	  whiteList['text-decoration-line'] = true; // default: none
	  whiteList['text-decoration-skip'] = true; // default: objects
	  whiteList['text-decoration-style'] = true; // default: solid
	  whiteList['text-emphasis'] = true; // default: depending on individual properties
	  whiteList['text-emphasis-color'] = true; // default: currentColor
	  whiteList['text-emphasis-position'] = true; // default: over right
	  whiteList['text-emphasis-style'] = true; // default: none
	  whiteList['text-height'] = true; // default: auto
	  whiteList['text-indent'] = true; // default: 0
	  whiteList['text-justify'] = true; // default: auto
	  whiteList['text-orientation'] = true; // default: mixed
	  whiteList['text-overflow'] = true; // default: clip
	  whiteList['text-shadow'] = true; // default: none
	  whiteList['text-space-collapse'] = true; // default: collapse
	  whiteList['text-transform'] = true; // default: none
	  whiteList['text-underline-position'] = true; // default: auto
	  whiteList['text-wrap'] = true; // default: normal
	  whiteList['top'] = false; // default: auto
	  whiteList['transform'] = false; // default: none
	  whiteList['transform-origin'] = false; // default: 50% 50% 0
	  whiteList['transform-style'] = false; // default: flat
	  whiteList['transition'] = false; // default: depending on individual properties
	  whiteList['transition-delay'] = false; // default: 0s
	  whiteList['transition-duration'] = false; // default: 0s
	  whiteList['transition-property'] = false; // default: all
	  whiteList['transition-timing-function'] = false; // default: ease
	  whiteList['unicode-bidi'] = false; // default: normal
	  whiteList['vertical-align'] = false; // default: baseline
	  whiteList['visibility'] = false; // default: visible
	  whiteList['voice-balance'] = false; // default: center
	  whiteList['voice-duration'] = false; // default: auto
	  whiteList['voice-family'] = false; // default: implementation dependent
	  whiteList['voice-pitch'] = false; // default: medium
	  whiteList['voice-range'] = false; // default: medium
	  whiteList['voice-rate'] = false; // default: normal
	  whiteList['voice-stress'] = false; // default: normal
	  whiteList['voice-volume'] = false; // default: medium
	  whiteList['volume'] = false; // default: medium
	  whiteList['white-space'] = false; // default: normal
	  whiteList['widows'] = false; // default: 2
	  whiteList['width'] = true; // default: auto
	  whiteList['will-change'] = false; // default: auto
	  whiteList['word-break'] = true; // default: normal
	  whiteList['word-spacing'] = true; // default: normal
	  whiteList['word-wrap'] = true; // default: normal
	  whiteList['wrap-flow'] = false; // default: auto
	  whiteList['wrap-through'] = false; // default: wrap
	  whiteList['writing-mode'] = false; // default: horizontal-tb
	  whiteList['z-index'] = false; // default: auto
	
	  return whiteList;
	}
	
	
	/**
	 * 匹配到白名单上的一个属性时
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @return {String}
	 */
	function onAttr (name, value, options) {
	  // do nothing
	}
	
	/**
	 * 匹配到不在白名单上的一个属性时
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @return {String}
	 */
	function onIgnoreAttr (name, value, options) {
	  // do nothing
	}
	
	var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;
	
	/**
	 * 过滤属性值
	 *
	 * @param {String} name
	 * @param {String} value
	 * @return {String}
	 */
	function safeAttrValue(name, value) {
	  if (REGEXP_URL_JAVASCRIPT.test(value)) return '';
	  return value;
	}
	
	
	exports.whiteList = getDefaultWhiteList();
	exports.getDefaultWhiteList = getDefaultWhiteList;
	exports.onAttr = onAttr;
	exports.onIgnoreAttr = onIgnoreAttr;
	exports.safeAttrValue = safeAttrValue;


/***/ }),
/* 707 */
/***/ (function(module, exports) {

	module.exports = {
	  indexOf: function (arr, item) {
	    var i, j;
	    if (Array.prototype.indexOf) {
	      return arr.indexOf(item);
	    }
	    for (i = 0, j = arr.length; i < j; i++) {
	      if (arr[i] === item) {
	        return i;
	      }
	    }
	    return -1;
	  },
	  forEach: function (arr, fn, scope) {
	    var i, j;
	    if (Array.prototype.forEach) {
	      return arr.forEach(fn, scope);
	    }
	    for (i = 0, j = arr.length; i < j; i++) {
	      fn.call(scope, arr[i], i, arr);
	    }
	  },
	  trim: function (str) {
	    if (String.prototype.trim) {
	      return str.trim();
	    }
	    return str.replace(/(^\s*)|(\s*$)/g, '');
	  },
	  trimRight: function (str) {
	    if (String.prototype.trimRight) {
	      return str.trimRight();
	    }
	    return str.replace(/(\s*$)/g, '');
	  }
	};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1549);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","VERSION":"10.0-159-ge9cd7ea95","CLIENT":"","COOKIE_VERSION":"bd446f0a-08ae-41f0-8823-15e1acb0e459"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 709 */
[2337, 825, 1671, 1889, 1674, 2236, 1673],
/* 710 */
/***/ (function(module, exports) {

	"use strict";
	
	var detector = module.exports = {};
	
	detector.isIE = function(version) {
	    function isAnyIeVersion() {
	        var agent = navigator.userAgent.toLowerCase();
	        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
	    }
	
	    if(!isAnyIeVersion()) {
	        return false;
	    }
	
	    if(!version) {
	        return true;
	    }
	
	    //Shamelessly stolen from https://gist.github.com/padolsey/527683
	    var ieVersion = (function(){
	        var undef,
	            v = 3,
	            div = document.createElement("div"),
	            all = div.getElementsByTagName("i");
	
	        do {
	            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
	        }
	        while (all[0]);
	
	        return v > 4 ? v : undef;
	    }());
	
	    return version === ieVersion;
	};
	
	detector.isLegacyOpera = function() {
	    return !!window.opera;
	};


/***/ }),
/* 711 */
/***/ (function(module, exports) {

	"use strict";
	
	var utils = module.exports = {};
	
	/**
	 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
	 * @public
	 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
	 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
	 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
	 */
	utils.forEach = function(collection, callback) {
	    for(var i = 0; i < collection.length; i++) {
	        var result = callback(collection[i]);
	        if(result) {
	            return result;
	        }
	    }
	};


/***/ }),
/* 712 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ }),
/* 713 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"officeNumber":"a4RN73UnVQTzOD2L6QQgb","brokerSelector":"_3K9eWVJQIYMzTnxxYvbNPU","brokerSearch":"_36WFoswdFPAItyMy_Naf9U"};

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"templateBasicStyleAuto":"_21wKyRxbBORB5FUew3zvi","withPointer":"_3x9szgP7Fa1O-Y9nVjWfTS","modal":"_2bkO8GwpNNKANfXQtGfG53","title":"_2fiuc9LxT8LXDpvNqC11YT","contentWrapper":"krgdedDyMYYb5T6gbhBxS","content":"_1dnCCYCdUPC-rY4Wz_LWyF","formGroup":"Ned03XJph97nwmgiZfD1V","signature":"_3V3oCYuWv9g4FZ8HzuxxXU","table":"_2RVBi16w4erFh2ikMoxDiz","errorMessage":"_3ltZ-bzlltrbrCGE3T5LUh","inARow":"_3yQeyhqDMxMNqv22FyAzS","formLabel":"KAOlxmGt5RK0EDXFe0zE3","formInput":"_2DKi_Vrq9O8VzSx_PahBiO","negativeMarginOne":"_2U7mJDSz7zYAYOih9JMSd8","marginPlusOne":"_12j7silCzx_W-tOM_MuOeR","sizeL":"_2l2jr7TpXfHZEfQx5pS8p0","sizeM":"_1Eh9KcP4torG41MKjEWDlu","sizeS":"_1BNilHDR5pVUwlbeeWppDc","sizeMS":"_2dUu_874qZRuXspUeqxUrW","sizeXS":"_1uJkSxNbNTRREgnlUtwOY9","visibleNone":"xB339qe_3GiN2eIJ75-cU","marginBottomS":"_3p7P0Fl7jUWDjsiLQNA9VR","formInputText":"_3cJgoNghEVFcXskggthl3N","select":"_187BXWiArfuDfetZWEwbco","buttons":"_3SA7ul-_NeNyQyesGixCJ1","enabled":"_245VgM2DOz3AFSEYs3Muse","next":"_1j29Uw9LYwEv4mxkTJLXYr","cancelButton":"_98wpPyX-3OBhdxfVK9DwU","disabled":"SIyylNzT6IfyR8YJmzHC0","leftRightAlign":"_18woPHlfT4Wuh0KG5jJDC","grayButton":"A8uiq6GoZhLl-YDAcsmps","emailButton":"_242bJ5TYnhGB4FqYS5yLj1","emailButtonIcon":"_3_A2wwwvjXR7hIA1keWYH5","documentRow":"_2WVVPxBMcBVlNPqnmeutaD","documentColumn":"PmU0ZATNvFqUjBz7eQ03X","downArrowHolder":"_2e-P-pwyqmBpl_ihxlBW4b","downArrow":"xy6fnl_2cwWoCJd3Z7MCC","creatableSelectInput":"FL3xMv3UmDJdEOgKw6LdC","creatableOptionContainer":"_1_WmNGtu03PFQ0CkDxXhms","creatableOptionItem":"Y0mwy35WxYikb1sqeUsSD","elementsInRow":"_3t6b5BBs0mXypPIX9Y8aFw","pdfIcon":"_2RSi_g5D3HYCMFMKOI7vIc"};

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dsdocumentContainer":"F4CMT4-IZ7a9XG1nK3vjZ","mainTitle":"_3oiCsAAmB1x89s8AIFtO8-","dsdocumentHeaderContainer":"_1ad2lNZNOaCDBUzK9IRPSK","columnWrapper":"_1h9vbjShY5tPz09JiJzVW","columnLeft":"_27JSZGoDBB85vuB4vpb-Ju","columnRight":"jr1SAoadE9wDTTLoumVj","signersLabelsColumn":"_3wV8iqW-9xHY5j11gFXhO1","firstSignerColumn":"_1Oh6dPdRC607MF2sWm0wDm","secondSignerColumn":"dxAuags43VYZgAd3ldMZm","columnWrapperForSigners":"_3fxlbzaz05JMqiTqJbCivu","row":"_2vduWHykyB3OBU28ZyD-Ry","labelColumn":"_1l8hQolGwR-a16Pm7akK8p","firstValueColumn":"_3EpvhbJVMDeP3hVad1uzS4","secondValueColumn":"_3LhuuR-t3MntvdyhctAjHG","remainderButtonCorrection":"_1o0Skd0rAx8yJHtoYjh82s","icon":"_2IGD8TBREXyv_G_4a8SA7W","column":"_1CfD-N64MTPEi2AbEJWODi","signersLabel":"_3iSZOREUcPUvG5d8e6sbQw","signer":"_3o2c-nghdx8EyrYnF3RFqH","email":"Iervf2ti7HvFpTL5xCUUx","columnTitle":"_2MuhEXPC99JhdShHliByX8","goToLink":"_1-rxxwVmqzDN08eFLdYnld","dsdocumentStatus":"_2Tqa10CZ5Aoe6xWCFXMaQv","mifidContainer":"Vntd_KpMni8JDnRPuvyTk","mifidButtonContainer":"_1lsca8V24NjkKZy-kUhp-C","dsDocumentDescriptionContainer":"zLcKvb_I_JAMX95kOg2Oc","contentTitle":"_3IX7FdV0Y0eR2lioNRoxDr","content":"SvvrkciFqS3XKlFwKoYCb","statusHistoryContainer":"_3rCARIyrd6rAH_GHWIJgJO","statusHistoryTable":"_gJ-aJlRa_gFajUQUV0bg","title":"_2EAYc7NGaVcGi72ABIx6ci","documentsListContainer":"_19KiUXlx-l5Hk33Qu7hgd4","goToLinkTable":"_2drl6Em6YO4RJKGgM5jjg1","remainderInfoContainer":"_3vU45k8ZyT7biE-1YEgKr0","remainderInfo":"_1UzDbLNCXXWJrO9MFQh3hk","buttonContainer":"pLGKxrm9r8RrvgxtQ_8u5","iconPaddingRight":"_3AM4P6TKVJEMEtXl6nIoHL","bottomButtonsContainer":"_3QRKZt_8tHrjArHT7_Au8Z","buttonCustomizationRenew":"mDrhOU8wzGgVE4fvGsuE_","iconHeight":"_1SUrp5r9rRWfet_3Hkh2yy"};

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"clientFinances":"_1T3AXjpUdQeFLtFsbr41g-","submitContainer":"_1FNwoAPJ1iU-aPxPShyyTW","inputContainer":"ucmCrnEYAiHANUdQiliOD","label":"_3kOWcMPak3OE-NfPgPvYa1","input":"xE5Z_KtFs-DxZoHiG3DvE","submit":"_2PQUHzymP8sEfPZ2nSBxOH","results":"_3ovOEw_8hKiNHq8zzIyjSj","hidden":"_1ZSBa5JQwhfBhrGI2Uq6yK","tType":"_23kZuJyJF_e-4AnDIvOEg1","bhkDatum":"VuWJnwr39ajShssDHikOk"};

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"error":"_1gF-T0jbXINF-ZzgKEuZdO","greyButton":"_2HSS8uNiARA3RTIEigYprp","informationTitle":"_1OOTX-I56zHg-bv8-EE6dg","informationTitleBorder":"_39NKbJgkMW_Vn0RTueftDk","moduleSection":"lp8whZ78rG728zE8j_Sv9","moduleSectionHeading":"_1J57v6giS-uUgFlB6TSroa","KeyValue":"_1IPSjZSA95RirV9tzt-ad9"};

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"results":"_3hwVt1u6cpUwNhtirdWPLR","buttonContainer":"PsP3a6oIO1NSQ_ab6jGt_","unread":"_1AKuwkttrn5H0-47_KBGGE","iconWrapper":"_3j0JFTHxOppPsmAW21110S","content":"_2JDPpaxZ5dHr2xHyPvK7lC","documents":"DIZ8LB-DoRi-E0fGZLyZO","unlinkedDocument":"_1AKFE65Q_liqRq54kXHhLL","linkButton":"_3k24MaoegVvdaSr0V1HpQf","archiveSelect":"l1PuccE8UXJy9_gTD4CLt","inboxUserNames":"_3_9YH9jXJMJu_y0GVgxWYg","error":"_1r2uCZkGKepw79pAQKG6AS","archiveModalContent":"_1XE1w3W7lW0sViks9Yqc4W","ticketList":"_1tjjN6sLlcq0lPzhbZS0YY","ticketItem":"_24PgV2Hf5vKzaup41C7mIk","ticketField":"_3f9bSDRNm1KGzz3VUIU0kR","dateInput":"xaY1aCpHcdWI-nednQ9Dn","archiveSubtitle":"_1IAkueoPbKXVIFTkzeKe3f","archiveSubtitleLast":"_12rkpNWyPtOq18lDAT4Mun","usersList":"_3ADBsuBOp293wQmFpdOV6J","archiveModalButtons":"_2VoVzF-mhRjuxNhAKdZT_W","cancel":"_1xxYh0N46v42YznV7WXlxg","title":"_28ea2jJgdqRlJqhKQvKW40","message":"gNg7weTuNg0fBkCveYoCv","greyButton":"PAhuIobtz0h2PjehVZHCt","enabled":"_3-bpMp3SmlNDFzXodN10sl","inboxToolIcon":"BLts6JUxibbd4mTf6gghu","tooltip":"_1-JveUs3IFUrfMjllZDXJ6","goToPackageWrapper":"LU7Vd_-co34k8p81O-mMG","sendReminderWrapper":"_2uTPzv8NXfV_Jbebir8R4i","directSignWrapper":"_2Sruk83h13qpCfAOxlLmwJ","quickReplyWrapper":"_231ym19NR4NMq_98VettL7","blockRetourWrapper":"_3kRrS4MUWX9o8sG3IRX-Zz","signDocumentsWrapper":"_1uV-CMUWYB7c-LuFK_mCKx","createEmailWrapper":"_3jfrWT9jSEP0VeFGQrGto4","goToContractWrapper":"_2dUGsj5eR8X9DRJYb8l1SE","goToPackageTooltip":"_25B_3g5iXqBuEg5yPUzwMK","sendReminderTooltip":"_1lO1h0VBzl59vLVclWC3tm","directSignTooltip":"_3otG8tKNTlvH9poFm9yja7","quickReplyTooltip":"_3Bk_31W4U8JumoscjE7SCV","blockRetourTooltip":"LJ17nTj_2HjPII4NMvC9H","signDocumentsTooltip":"_3wL-93_lICvK8UFSTUmlPf","createEmailTooltip":"_1w4NUk8YfKi0SnpsstADDp","goToContractTooltip":"rcGuk7GNmK26NYHe2Oe3H","linkClientIcon":"_1DS5_JaSfoOze93VKshQae","modal":"_2OFEDQ-_qmTSE6jFsxzaOe","contentWrapper":"dXo7llImSghiRbPxEZatZ","formGroup":"_49-SNr4fU3S327pfgbZUh","signature":"_2M2Qu1eE1P1MMxuWiTF4lm","errorMessage":"_1N8NdO1F0BFVsByNXIYLPZ","inARow":"_3XqfkHHvNAeruma-oFoHzM","formLabel":"_3yF1batO4T8WzjYlWlpD5O","formInput":"_3_DV4_jAFHrapHiqUAvzKf","negativeMarginOne":"_29W4AfY_PC4KCH-kqdqY1I","marginPlusOne":"tmDF1n64aKZ_qikmOsrb7","sizeL":"_3GRlM2O-iitX3-6ZR5QrI4","sizeM":"x1WG_JhmRJ2p_WFb-5lNQ","sizeS":"_2kw7O9SPss_Lgiwh9Kt21K","sizeMS":"yG4gx3UtXX1u2lqgf11QK","sizeXS":"_2OvNYxvwCsEDyoZV4ipYgS","visibleNone":"_1TXUzVVNGk195j5-4v4jTY","marginBottomS":"_3d8zmn6QAA6Xg374HmSXcY","formInputText":"_3KbmbCeVEtnomFyawAxi1S","select":"_2ZortnRLGEETThA4NcQQFZ","buttons":"_3bSfBA01PBtdKADBdqDODf","next":"fC0SAcqSZ9BSCCXv4-F3q","cancelButton":"_1nNEdv4oUHZ-tOOo-BF0oL","disabled":"_3Vs7qB7xYe_RsDxpJO6M2N","leftRightAlign":"_1fzrQvczPKbHitAozDShWg"};

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"documentsModalContent":"_3QFmL4O2ZsSuqVYD4tqva7","columnContainer":"_1o8AVxTEbpkGyUsYzqT1Gi","oneRowItem":"_2RU8NMvRQGDorzj6DPfEgO","autoHeight":"p2lK7CAD0rhVaef0cJzmA","title":"BO9lZ2PVUvn4BQY1j5bbL","contentWrapper":"_3VjX2oX0S14_ivQiOs_lhg","clientsSearchContainer":"_1JpRRyedaqQ9gpW5ltOAzN","content":"_1wDPihs3m_h5peNbWsuI4h","whitespacePre":"ndVRxMEwGTn8cgvKJ73De","modalFormContent":"_32CFVTziZTd39QOjGlNLTy","documentsModalButtons":"_3Y7A6IiZRchOJy8u-f59Ks","cancel":"_1NZy1hm--GKlmaXiVwfyTI","greyButton":"_2tpe4rS5ojPUvZi-oCdIAC","enabled":"_3OU8Il7Cokqr1muwxJ0I9g","greenButton":"_1E0vrLE3ZYPUNxGryMcTyk"};

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"green-link":"_2UVBVtx_nPnHINN56PxMFA","custom-select":"_3xO6Flp4ZJOQc3jMuQUdgj","greyButton":"_1AMC1UwXzOor9xYqM0PkbA","grayButtonFlex":"_2Et7eeynMam5hSHM8LEDMr","refreshButton":"_11zpDcY0YY9PZ7PlhY9xTW","iconContainer":"_1DK76OUPXEkYG8b4FED-3W","btn":"_2a82D_bJb5A6FERMMeg6HS","green":"_26YZBGRL7z3AdGr0ebCzSd","inline-button":"AE2WVqA0EWaTW8PPMnU8P","link-button":"_2TKl6F-qqDolANoyV4neNS","dropdown-group":"dSnxqRB3iqivzh13r5ao5","dropdown-indicator":"_2GSrBqqD5lDFy28PZ40Fc-","dropdown-arrow":"ItqjEYN6ANVFfVUJkGuaB","buttonGreen":"_1X67_g1cI6kJoVL456shK-","officeModule":"_1d-Q5qL175cPiiB7SEmwdl","office":"_1eOA8ket9XQ1xHNosDHG8b","mainTitleDiv":"kX6_0mRLUhvL8B_8f0cBV","mainTitleContainer":"_3Q0ReZfZsoSG9AWTXRp0az","mainTitle":"_3w041ONBoZePQYrlkHFx6j","officeNumber":"BwSs70-yDVDzXPqzvP8yF","officeNavigation":"_3Km9zfitEuuYcGnCJOsOtp","headingDiv":"_2fhnr3y3l8h1wl3zkIK_pC","headingCell":"_3_lj6x-heIuyNlc_qKTiYU","active":"_34D7c-bqKwM0nsMGOFR9iP","brokerLogo":"_3EjwJnuLFu6gma_XosanwV","brokerLogoContainer":"_-Wlxh2I304P2GdmmJbUgN","officeFinances":"_2Pw2DXgePhCgIwN2SgNqyj","submitContainer":"_19nbm2HfGYEbtaeynwO1Ni","inputContainer":"U-O9dMscJoHhX64_NrZwl","label":"TxGD3VrGEnWCyZ2I3ShdT","inputSubmit":"pi1VbohzC_dbKPbSc204L","inputForm":"_3g7m6Fg0RbJ2IBtLIVxGYT","results":"_1frk9yEVJ3yG7GXuswQMZo","subNavigationCont":"KPvFnP0riba_rZlZt3O_o","subNav":"_1EPhPMcd8TFxXrB8AP_81V","catCont":"_2aVTBHiqsPdQajx-DOaCA3","inactive":"_3k34d0X9lN-0TyyY5K0FD0","transContainer":"_1C0Dy002q2LOPEU_F2n-LM","summaryContainer":"_1WtV4DNLyXyGcmHdnsiHe8","summary":"soBv7c5qPpqrp7Q_SjiUE","field":"_1etPERlSerJRtj9GcHzboT","input":"_1ACXnc4HQ15aiv7RQrkqpF","logoAndButtonContainer":"WCBAdw5Brs-Z1CH-9Sa9i","containerForLogo":"d-bQxmdXPEBi8BkPBL-Ur","containerForButton":"AYK1u9UY6U2cx3ZcWHkTs","DSWizardButtonWrapper":"_1BrD8Uto7yy8ZO45UAgMKn","refreshLogoDescription":"KAbSJKZegXaw-e9C4m1tJ","enabled":"_18kbH1xnm7qmEu2TAVxDHt"};

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_2jX3eH6Gtcq7V_h0H2c_hL","modal":"SKU96WzY164-0vDI68sas","title":"_2BRTCwfgo3PvQTabO8Hkpf","contentWrapper":"_1r4QbnxCwxDmKdnAKjlOtw","content":"_1KDYnQ2AxNzab98CH5OioO","scrollContent":"_3KK3iD_IQMTlQ2JqHY3GKb","TabContainer":"dMm2RXO42Y8C1TGfPWXvX","Tab":"_33IXVY7GbFM2OFKNZQkBgh","active":"_3r05F3i28QiyFaD4USjWIT","TabContentContainer":"_3i-EY7GtpSnm3oBRqAHVaj","tabContent":"_238mH0R5RZGd6PdRAhAD_N","hidden":"_-bRHCHH6TX7Gl5rUYx1LT","buttons":"_2WIMtfSIjpK1-DtAyF1M7H","next":"_4PMOaPX1ucjMcRlDeF3HD"};

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"_360MLHqCtE95xt4v-Ve9vs"};

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"searchBox":"jZrDb17sYQ20Ecrcl_FQB","searchContainer":"_3F9VaeZjxhvk1b9DwgLMvx","searchLogo":"_2Ny2jgM7A1O77nWnoEypwD","mainSearch":"_186lOrd9ZkVyMEBulsUd8Y","leftLogo":"k0NbmrhI1y_47L5LITLwb","removeFilter":"_20BgXLwIytr8N3EOnQay_p","cross":"mrUXVIV_GIUovc5f8decI","noResults":"_34iNfaHgp83l9mzWNdxXkz"};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(93);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 728 */
[2343, 246],
/* 729 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 730 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 731 */
349,
/* 732 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 734 */
/***/ (function(module, exports) {

	
	var rx_escapable = /[\\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
	
	var gap,
	    indent,
	    meta = { // table of character substitutions
	      '\b': '\\b',
	      '\t': '\\t',
	      '\n': '\\n',
	      '\f': '\\f',
	      '\r': '\\r',
	      '"': '\\"',
	      '\\': '\\\\'
	    },
	    rep;
	
	function quote(string) {
	
	// If the string contains no control characters, no quote characters, and no
	// backslash characters, then we can safely slap some quotes around it.
	// Otherwise we must also replace the offending characters with safe escape
	// sequences.
	
	    rx_escapable.lastIndex = 0;
	    return rx_escapable.test(string)
	        ? '"' + string.replace(rx_escapable, function (a) {
	            var c = meta[a];
	            return typeof c === 'string'
	                ? c
	                : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
	        }) + '"'
	        : '"' + string + '"';
	}
	
	
	function str(key, holder, limit) {
	
	// Produce a string from holder[key].
	
	    var i,          // The loop counter.
	        k,          // The member key.
	        v,          // The member value.
	        length,
	        mind = gap,
	        partial,
	        value = holder[key];
	
	// If the value has a toJSON method, call it to obtain a replacement value.
	
	    if (value && typeof value === 'object' &&
	            typeof value.toJSON === 'function') {
	        value = value.toJSON(key);
	    }
	
	// If we were called with a replacer function, then call the replacer to
	// obtain a replacement value.
	
	    if (typeof rep === 'function') {
	        value = rep.call(holder, key, value);
	    }
	
	// What happens next depends on the value's type.
	
	    switch (typeof value) {
	    case 'string':
	        return quote(value);
	
	    case 'number':
	
	// JSON numbers must be finite. Encode non-finite numbers as null.
	
	        return isFinite(value)
	            ? String(value)
	            : 'null';
	
	    case 'boolean':
	    case 'null':
	
	// If the value is a boolean or null, convert it to a string. Note:
	// typeof null does not produce 'null'. The case is included here in
	// the remote chance that this gets fixed someday.
	
	        return String(value);
	
	// If the type is 'object', we might be dealing with an object or an array or
	// null.
	
	    case 'object':
	
	// Due to a specification blunder in ECMAScript, typeof null is 'object',
	// so watch out for that case.
	
	        if (!value) {
	            return 'null';
	        }
	
	// Make an array to hold the partial results of stringifying this object value.
	
	        gap += indent;
	        partial = [];
	
	// Is the value an array?
	
	        if (Object.prototype.toString.apply(value) === '[object Array]') {
	
	// The value is an array. Stringify every element. Use null as a placeholder
	// for non-JSON values.
	
	            length = value.length;
	            for (i = 0; i < length; i += 1) {
	                partial[i] = str(i, value, limit) || 'null';
	            }
	
	// Join all of the elements together, separated with commas, and wrap them in
	// brackets.
	
	            v = partial.length === 0
	                ? '[]'
	                : gap
	                    ? (
	                      gap.length + partial.join(', ').length + 4 > limit ?
	                      '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' :
	                      '[ ' + partial.join(', ') + ' ]'
	                    )
	                    : '[' + partial.join(',') + ']';
	            gap = mind;
	            return v;
	        }
	
	// If the replacer is an array, use it to select the members to be stringified.
	
	        if (rep && typeof rep === 'object') {
	            length = rep.length;
	            for (i = 0; i < length; i += 1) {
	                if (typeof rep[i] === 'string') {
	                    k = rep[i];
	                    v = str(k, value, limit);
	                    if (v) {
	                        partial.push(quote(k) + (
	                            gap
	                                ? ': '
	                                : ':'
	                        ) + v);
	                    }
	                }
	            }
	        } else {
	
	// Otherwise, iterate through all of the keys in the object.
	
	            for (k in value) {
	                if (Object.prototype.hasOwnProperty.call(value, k)) {
	                    v = str(k, value, limit);
	                    if (v) {
	                        partial.push(quote(k) + (
	                            gap
	                                ? ': '
	                                : ':'
	                        ) + v);
	                    }
	                }
	            }
	        }
	
	// Join all of the member texts together, separated with commas,
	// and wrap them in braces.
	
	        v = partial.length === 0
	            ? '{}'
	            : gap
	                ? (
	                  gap.length + partial.join(', ').length + 4 > limit ?
	                  '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}' :
	                  '{ ' + partial.join(', ') + ' }'
	                )
	                : '{' + partial.join(',') + '}';
	        gap = mind;
	        return v;
	    }
	}
	
	
	function beautify (value, replacer, space, limit) {
	
	// The stringify method takes a value and an optional replacer, and an optional
	// space parameter, and returns a JSON text. The replacer can be a function
	// that can replace values, or an array of strings that will select the keys.
	// A default replacer method can be provided. Use of the space parameter can
	// produce text that is more easily readable.
	
	  var i;
	  gap = '';
	  indent = '';
	
	  if (!limit) limit = 0;
	
	  if (typeof limit !== "number")
	    throw new Error("beaufifier: limit must be a number");
	
	// If the space parameter is a number, make an indent string containing that
	// many spaces.
	
	  if (typeof space === 'number') {
	      for (i = 0; i < space; i += 1) {
	          indent += ' ';
	      }
	
	// If the space parameter is a string, it will be used as the indent string.
	
	  } else if (typeof space === 'string') {
	      indent = space;
	  }
	
	// If there is a replacer, it must be a function or an array.
	// Otherwise, throw an error.
	
	  rep = replacer;
	  if (replacer && typeof replacer !== 'function' &&
	          (typeof replacer !== 'object' ||
	          typeof replacer.length !== 'number')) {
	      throw new Error('beautifier: wrong replacer parameter');
	  }
	
	// Make a fake root object containing our value under the key of ''.
	// Return the result of stringifying the value.
	
	  return str('', {'': value}, limit);
	}
	
	module.exports = beautify;


/***/ }),
/* 735 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1730),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(30),
	    isBuffer = __webpack_require__(162),
	    isIndex = __webpack_require__(323),
	    isTypedArray = __webpack_require__(207);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(754);
	
	/**
	 * A specialized version of `_.sample` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to sample.
	 * @returns {*} Returns the random element.
	 */
	function arraySample(array) {
	  var length = array.length;
	  return length ? array[baseRandom(0, length - 1)] : undefined;
	}
	
	module.exports = arraySample;


/***/ }),
/* 739 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(136),
	    eq = __webpack_require__(161);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(102),
	    keys = __webpack_require__(70);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwnRight = __webpack_require__(454),
	    createBaseEach = __webpack_require__(762);
	
	/**
	 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	module.exports = baseEachRight;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(137);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 744 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	 * without support for iteratee shorthands, which iterates over `collection`
	 * using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFindKey(collection, predicate, eachFunc) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = key;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFindKey;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(763);
	
	/**
	 * This function is like `baseFor` except that it iterates over properties
	 * in the opposite order.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseForRight = createBaseFor(true);
	
	module.exports = baseForRight;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(313),
	    isFunction = __webpack_require__(141);
	
	/**
	 * The base implementation of `_.functions` which creates an array of
	 * `object` function property names filtered from `props`.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} props The property names to filter.
	 * @returns {Array} Returns the function names.
	 */
	function baseFunctions(object, props) {
	  return arrayFilter(props, function(key) {
	    return isFunction(object[key]);
	  });
	}
	
	module.exports = baseFunctions;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(450),
	    isArray = __webpack_require__(30);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(312),
	    castPath = __webpack_require__(139),
	    last = __webpack_require__(466),
	    parent = __webpack_require__(779),
	    toKey = __webpack_require__(140);
	
	/**
	 * The base implementation of `_.invoke` without support for individual
	 * method arguments.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {Array} args The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 */
	function baseInvoke(object, path, args) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  var func = object == null ? object : object[toKey(last(path))];
	  return func == null ? undefined : apply(func, object, args);
	}
	
	module.exports = baseInvoke;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(141),
	    isMasked = __webpack_require__(1758),
	    isObject = __webpack_require__(56),
	    toSource = __webpack_require__(783);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(137),
	    isArrayLike = __webpack_require__(69);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(157),
	    baseGet = __webpack_require__(199),
	    baseIteratee = __webpack_require__(47),
	    baseMap = __webpack_require__(750),
	    baseSortBy = __webpack_require__(1729),
	    baseUnary = __webpack_require__(159),
	    compareMultiple = __webpack_require__(1739),
	    identity = __webpack_require__(204),
	    isArray = __webpack_require__(30);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199),
	    baseSet = __webpack_require__(318),
	    castPath = __webpack_require__(139);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 753 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	module.exports = baseRandom;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(139),
	    last = __webpack_require__(466),
	    parent = __webpack_require__(779),
	    toKey = __webpack_require__(140);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199),
	    baseSet = __webpack_require__(318);
	
	/**
	 * The base implementation of `_.update`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to update.
	 * @param {Function} updater The function to produce the updated value.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseUpdate(object, path, updater, customizer) {
	  return baseSet(object, path, updater(baseGet(object, path)), customizer);
	}
	
	module.exports = baseUpdate;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(157);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(86);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)(module)))

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(458);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(69);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 763 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(47),
	    isArrayLike = __webpack_require__(69),
	    keys = __webpack_require__(70);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(1706);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(1731),
	    getTag = __webpack_require__(119),
	    mapToArray = __webpack_require__(464),
	    setToPairs = __webpack_require__(1776);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	module.exports = createToPairs;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(160);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1686),
	    arraySome = __webpack_require__(739),
	    cacheHas = __webpack_require__(1734);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(747),
	    getSymbols = __webpack_require__(462),
	    keys = __webpack_require__(70);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(450),
	    getPrototype = __webpack_require__(322),
	    getSymbols = __webpack_require__(462),
	    stubArray = __webpack_require__(801);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(139),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(30),
	    isIndex = __webpack_require__(323),
	    isLength = __webpack_require__(328),
	    toKey = __webpack_require__(140);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 773 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(451),
	    getPrototype = __webpack_require__(322),
	    isPrototype = __webpack_require__(250);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 776 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(312);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199),
	    baseSlice = __webpack_require__(1727);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 780 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1725),
	    shortOut = __webpack_require__(1777);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 783 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(102),
	    createAssigner = __webpack_require__(201),
	    keysIn = __webpack_require__(71);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(102),
	    createAssigner = __webpack_require__(201),
	    keysIn = __webpack_require__(71);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(247);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 787 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56),
	    now = __webpack_require__(1858),
	    toNumber = __webpack_require__(331);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(790);


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(449),
	    baseEach = __webpack_require__(137),
	    castFunction = __webpack_require__(138),
	    isArray = __webpack_require__(30);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEachRight = __webpack_require__(1689),
	    baseEachRight = __webpack_require__(742),
	    castFunction = __webpack_require__(138),
	    isArray = __webpack_require__(30);
	
	/**
	 * This method is like `_.forEach` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @alias eachRight
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEach
	 * @example
	 *
	 * _.forEachRight([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `2` then `1`.
	 */
	function forEachRight(collection, iteratee) {
	  var func = isArray(collection) ? arrayEachRight : baseEachRight;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEachRight;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(69),
	    isObjectLike = __webpack_require__(48);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(121);
	
	/**
	 * Checks if `value` is an integer.
	 *
	 * **Note:** This method is based on
	 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	 * @example
	 *
	 * _.isInteger(3);
	 * // => true
	 *
	 * _.isInteger(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isInteger(Infinity);
	 * // => false
	 *
	 * _.isInteger('3');
	 * // => false
	 */
	function isInteger(value) {
	  return typeof value == 'number' && value == toInteger(value);
	}
	
	module.exports = isInteger;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1711),
	    baseUnary = __webpack_require__(159),
	    nodeUtil = __webpack_require__(203);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1714),
	    baseUnary = __webpack_require__(159),
	    nodeUtil = __webpack_require__(203);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 797 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(457),
	    createAssigner = __webpack_require__(201);
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with six arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = { 'a': [1], 'b': [2] };
	 * var other = { 'a': [3], 'b': [4] };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'a': [1, 3], 'b': [2, 4] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	module.exports = mergeWith;


/***/ }),
/* 799 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(157),
	    baseIteratee = __webpack_require__(47),
	    basePickBy = __webpack_require__(752),
	    getAllKeysIn = __webpack_require__(460);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ }),
/* 801 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 802 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(331);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(766),
	    keys = __webpack_require__(70);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(766),
	    keysIn = __webpack_require__(71);
	
	/**
	 * Creates an array of own and inherited enumerable string keyed-value pairs
	 * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	 * or set, its entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entriesIn
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairsIn(new Foo);
	 * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	 */
	var toPairsIn = createToPairs(keysIn);
	
	module.exports = toPairsIn;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(102),
	    keysIn = __webpack_require__(71);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1732);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
	});


/***/ }),
/* 809 */
/***/ (function(module, exports) {

	'use strict';
	
	var safeIsNaN = Number.isNaN ||
	    function ponyfill(value) {
	        return typeof value === 'number' && value !== value;
	    };
	function isEqual(first, second) {
	    if (first === second) {
	        return true;
	    }
	    if (safeIsNaN(first) && safeIsNaN(second)) {
	        return true;
	    }
	    return false;
	}
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (!isEqual(newInputs[i], lastInputs[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(12)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 823 */
/***/ (function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ }),
/* 824 */
[2352, 823],
/* 825 */
[2355, 826, 1891],
/* 826 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1896);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 828 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 829 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(620);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  };
	
	  LazyRenderBox.prototype.render = function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2['default'].createElement('div', props);
	    }
	
	    return _react2['default'].Children.only(props.children);
	  };
	
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(221);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getAlignPopupClassName = getAlignPopupClassName;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addEventListenerWrap;
	
	var _addDomEventListener = _interopRequireDefault(__webpack_require__(1032));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(45));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
	    _reactDom.default.unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener.default)(target, eventType, callback, option);
	}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	function contains(root, n) {
	  var node = n;
	
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	
	    node = node.parentNode;
	  }
	
	  return false;
	}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(788);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_ref) {
	    _inherits(ColorPicker, _ref);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
	
	      _this.handleChange = function (data, event) {
	        var isValidColor = color.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = color.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
	          _this.props.onChange && _this.props.onChange(colors, event);
	        }
	      };
	
	      _this.handleSwatchHover = function (data, event) {
	        var isValidColor = color.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = color.toState(data, data.h || _this.state.oldHue);
	          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
	        }
	      };
	
	      _this.state = _extends({}, color.toState(props.color, 0));
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
	        fn(data, event);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'render',
	      value: function render() {
	        var optionalEvents = {};
	        if (this.props.onSwatchHover) {
	          optionalEvents.onSwatchHover = this.handleSwatchHover;
	        }
	
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
	          onChange: this.handleChange
	        }, optionalEvents));
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(nextProps, state) {
	        return _extends({}, color.toState(nextProps.color, state.oldHue));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react.PureComponent || _react.Component);
	
	  ColorPicker.propTypes = _extends({}, Picker.propTypes);
	
	  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
	    color: {
	      h: 250,
	      s: 0.50,
	      l: 0.20,
	      a: 1
	    }
	  });
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(1));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ }),
/* 836 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(164);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(210);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(95);
	
	var quoteAttributeValueForBrowser = __webpack_require__(2028);
	var warning = __webpack_require__(35);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var LinkedValueUtils = __webpack_require__(474);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(104);
	
	var warning = __webpack_require__(35);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(21);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1988);
	
	var containsNode = __webpack_require__(1643);
	var focusNode = __webpack_require__(726);
	var getActiveElement = __webpack_require__(727);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var DOMLazyTree = __webpack_require__(209);
	var DOMProperty = __webpack_require__(210);
	var React = __webpack_require__(166);
	var ReactBrowserEventEmitter = __webpack_require__(333);
	var ReactCurrentOwner = __webpack_require__(123);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDOMContainerInfo = __webpack_require__(1982);
	var ReactDOMFeatureFlags = __webpack_require__(1984);
	var ReactFeatureFlags = __webpack_require__(842);
	var ReactInstanceMap = __webpack_require__(254);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactMarkupChecksum = __webpack_require__(1998);
	var ReactReconciler = __webpack_require__(211);
	var ReactUpdateQueue = __webpack_require__(477);
	var ReactUpdates = __webpack_require__(104);
	
	var emptyObject = __webpack_require__(307);
	var instantiateReactComponent = __webpack_require__(853);
	var invariant = __webpack_require__(21);
	var setInnerHTML = __webpack_require__(337);
	var shouldUpdateReactComponent = __webpack_require__(483);
	var warning = __webpack_require__(35);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var React = __webpack_require__(166);
	
	var invariant = __webpack_require__(21);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(846);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(46);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(36);
	
	var ReactCompositeComponent = __webpack_require__(1979);
	var ReactEmptyComponent = __webpack_require__(841);
	var ReactHostComponent = __webpack_require__(843);
	
	var getNextDebugID = __webpack_require__(2145);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(35);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	var escapeTextContentForBrowser = __webpack_require__(336);
	var setInnerHTML = __webpack_require__(337);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(123);
	var REACT_ELEMENT_TYPE = __webpack_require__(1994);
	
	var getIteratorFn = __webpack_require__(2025);
	var invariant = __webpack_require__(21);
	var KeyEscapeUtils = __webpack_require__(473);
	var warning = __webpack_require__(35);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	var styles = {
		string: {
			color: '#0e4889',
			cursor: 'default'
		},
		bool: {
			color: '#06624b',
			cursor: 'default',
			fontStyle: 'italic'
		},
		number: {
			color: '#ca000a',
			cursor: 'default'
		},
		date: {
			color: '#009f7b',
			cursor: 'default'
		},
		empty: {
			color: '#999999',
			cursor: 'default'
		},
		array: {
			color: '#666666',
			cursor: 'default'
		},
		object: {
			color: '#0b89b6',
			cursor: 'default'
		},
		comma: {
			color: '#999999',
			cursor: 'default'
		}
	};
	
	function transform(obj, fromRecur, comma) {
	
		var tag = fromRecur ? 'span' : 'div';
		var nextLevel = (fromRecur || 0) + 1;
		var children = [];
		comma = comma ? React.createElement(
			'span',
			{ style: styles.comma },
			','
		) : null;
	
		// strings
		if (typeof obj === 'string') {
			return React.createElement(tag, { style: styles.string }, '"' + obj + '"', comma);
		}
		// booleans, null and undefined
		else if (typeof obj === 'boolean' || obj === null || obj === undefined) {
				return React.createElement(tag, { style: styles.bool }, String(obj), comma);
			}
			// numbers
			else if (typeof obj === 'number') {
					return React.createElement(tag, { style: styles.number }, String(obj), comma);
				}
				// dates
				else if (Object.prototype.toString.call(obj) === '[object Date]') {
						return React.createElement(tag, { style: styles.date }, String(obj), comma);
					}
					// arrays
					else if (Array.isArray(obj)) {
	
							if (!obj.length) {
								return React.createElement(tag, { style: styles.empty }, 'Array: []');
							}
	
							children.push(React.createElement(tag, { key: '__array:open__', style: styles.array }, 'Array: ['));
	
							for (var i = 0; i < obj.length; i++) {
								children.push(React.createElement(
									'div',
									{ key: 'i' + i, style: { paddingLeft: '20px' } },
									transform(obj[i], nextLevel, i < obj.length - 1)
								));
							}
	
							children.push(React.createElement(tag, { key: '__array:close__', style: styles.array }, ']'));
						}
						// objects
						else if (obj && typeof obj === 'object') {
	
								var len = Object.keys(obj).length;
	
								if (fromRecur && !len) {
									return React.createElement(tag, { style: styles.empty }, 'Object: {}');
								}
	
								if (fromRecur) {
									children.push(React.createElement(tag, { key: '__object:open__', style: styles.object }, 'Object: {'));
								}
	
								for (var key in obj) {
									if (typeof obj[key] !== 'function') {
										children.push(React.createElement(
											'div',
											{ key: key, style: { paddingLeft: fromRecur ? '20px' : '0px' } },
											React.createElement(
												'span',
												{ style: { paddingRight: '5px', cursor: 'default' } },
												key,
												':'
											),
											transform(obj[key], nextLevel)
										));
									}
								}
	
								if (fromRecur) {
									children.push(React.createElement(tag, { key: '__object:close__', style: styles.object }, '}'));
								}
							}
	
		return React.createElement(
			'div',
			null,
			children,
			comma
		);
	}
	
	var DOMify = React.createClass({
		displayName: 'DOMify',
	
		render: function render() {
			return React.createElement(
				'div',
				{ className: this.props.className, style: this.props.style },
				transform(this.props.value)
			);
		}
	});
	
	module.exports = DOMify;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(13)):"function"==typeof define&&define.amd?define(["react","prop-types"],t):e.Dropzone=t(e.React,e.PropTypes)}(this,function(e,t){"use strict";e=e&&e.hasOwnProperty("default")?e.default:e,t=t&&t.hasOwnProperty("default")?t.default:t;var n,r,o=(function(e){e.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=13)}([function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){var n=e.exports={version:"2.5.0"};"number"==typeof __e&&(__e=n)},function(e,t,n){e.exports=!n(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(32)("wks"),o=n(9),i=n(0).Symbol,a="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=a&&i[e]||(a?i:o)("Symbol."+e))}).store=r},function(e,t,n){var r=n(0),o=n(2),i=n(8),a=n(22),s=n(10),c=function(e,t,n){var u,l,p,f,d=e&c.F,h=e&c.G,v=e&c.S,g=e&c.P,y=e&c.B,m=h?r:v?r[t]||(r[t]={}):(r[t]||{}).prototype,b=h?o:o[t]||(o[t]={}),D=b.prototype||(b.prototype={});for(u in h&&(n=t),n)p=((l=!d&&m&&void 0!==m[u])?m:n)[u],f=y&&l?s(p,r):g&&"function"==typeof p?s(Function.call,p):p,m&&a(m,u,p,e&c.U),b[u]!=p&&i(b,u,f),g&&D[u]!=p&&(D[u]=p)};r.core=o,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,e.exports=c},function(e,t,n){var r=n(16),o=n(21);e.exports=n(3)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){var r=n(24);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,o){return e.call(t,n,r,o)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(28),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},function(e,t,n){t.__esModule=!0,t.default=function(e,t){if(e&&t){var n=Array.isArray(t)?t:t.split(","),r=e.name||"",o=e.type||"",i=o.replace(/\/.*$/,"");return n.some(function(e){var t=e.trim();return"."===t.charAt(0)?r.toLowerCase().endsWith(t.toLowerCase()):t.endsWith("/*")?i===t.replace(/\/.*$/,""):o===t})}return!0},n(14),n(34)},function(e,t,n){n(15),e.exports=n(2).Array.some},function(e,t,n){var r=n(7),o=n(25)(3);r(r.P+r.F*!n(33)([].some,!0),"Array",{some:function(e){return o(this,e,arguments[1])}})},function(e,t,n){var r=n(17),o=n(18),i=n(20),a=Object.defineProperty;t.f=n(3)?Object.defineProperty:function(e,t,n){if(r(e),t=i(t,!0),r(n),o)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){var r=n(1);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n){e.exports=!n(3)&&!n(4)(function(){return 7!=Object.defineProperty(n(19)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(1),o=n(0).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}}},function(e,t,n){var r=n(1);e.exports=function(e,t){if(!r(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!r(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;throw TypeError("Can't convert object to primitive value")}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){var r=n(0),o=n(8),i=n(23),a=n(9)("src"),s=Function.toString,c=(""+s).split("toString");n(2).inspectSource=function(e){return s.call(e)},(e.exports=function(e,t,n,s){var u="function"==typeof n;u&&(i(n,"name")||o(n,"name",t)),e[t]!==n&&(u&&(i(n,a)||o(n,a,e[t]?""+e[t]:c.join(String(t)))),e===r?e[t]=n:s?e[t]?e[t]=n:o(e,t,n):(delete e[t],o(e,t,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[a]||s.call(this)})},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){var r=n(10),o=n(26),i=n(27),a=n(12),s=n(29);e.exports=function(e,t){var n=1==e,c=2==e,u=3==e,l=4==e,p=6==e,f=5==e||p,d=t||s;return function(t,s,h){for(var v,g,y=i(t),m=o(y),b=r(s,h,3),D=a(m.length),x=0,S=n?d(t,D):c?d(t,0):void 0;D>x;x++)if((f||x in m)&&(g=b(v=m[x],x,y),e))if(n)S[x]=g;else if(g)switch(e){case 3:return!0;case 5:return v;case 6:return x;case 2:S.push(v)}else if(l)return!1;return p?-1:u||l?l:S}}},function(e,t,n){var r=n(5);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(11);e.exports=function(e){return Object(r(e))}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t,n){var r=n(30);e.exports=function(e,t){return new(r(e))(t)}},function(e,t,n){var r=n(1),o=n(31),i=n(6)("species");e.exports=function(e){var t;return o(e)&&("function"!=typeof(t=e.constructor)||t!==Array&&!o(t.prototype)||(t=void 0),r(t)&&null===(t=t[i])&&(t=void 0)),void 0===t?Array:t}},function(e,t,n){var r=n(5);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});e.exports=function(e){return o[e]||(o[e]={})}},function(e,t,n){var r=n(4);e.exports=function(e,t){return!!e&&r(function(){t?e.call(null,function(){},1):e.call(null)})}},function(e,t,n){n(35),e.exports=n(2).String.endsWith},function(e,t,n){var r=n(7),o=n(12),i=n(36),a="".endsWith;r(r.P+r.F*n(38)("endsWith"),"String",{endsWith:function(e){var t=i(this,e,"endsWith"),n=arguments.length>1?arguments[1]:void 0,r=o(t.length),s=void 0===n?r:Math.min(o(n),r),c=String(e);return a?a.call(t,c,s):t.slice(s-c.length,s)===c}})},function(e,t,n){var r=n(37),o=n(11);e.exports=function(e,t,n){if(r(t))throw TypeError("String#"+n+" doesn't accept regex!");return String(o(e))}},function(e,t,n){var r=n(1),o=n(5),i=n(6)("match");e.exports=function(e){var t;return r(e)&&(void 0!==(t=e[i])?!!t:"RegExp"==o(e))}},function(e,t,n){var r=n(6)("match");e.exports=function(e){var t=/./;try{"/./"[e](t)}catch(n){try{return t[r]=!1,!"/./"[e](t)}catch(e){}}return!0}}])}(n={exports:{}},n.exports),n.exports),i=(r=o)&&r.__esModule&&Object.prototype.hasOwnProperty.call(r,"default")?r.default:r,a=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n},l=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},p="undefined"==typeof document||!document||!document.createElement||"multiple"in document.createElement("input");function f(e,t){return"application/x-moz-file"===e.type||i(e,t)}function d(e){return!e.dataTransfer||Array.prototype.every.call(e.dataTransfer.types,function(e){return"Files"===e||"application/x-moz-file"===e})}function h(e){e.preventDefault()}var v={borderStyle:"solid",backgroundColor:"#eee"},g={borderStyle:"solid",borderColor:"#6c6",backgroundColor:"#eee"},y={borderStyle:"solid",borderColor:"#c66",backgroundColor:"#eee"},m={width:200,height:200,borderWidth:2,borderColor:"#666",borderStyle:"dashed",borderRadius:5},b={opacity:.5},D=function(t){function n(e,t){a(this,n);var r=l(this,(n.__proto__||Object.getPrototypeOf(n)).call(this,e,t));return r.renderChildren=function(e,t,n,o){return"function"==typeof e?e(c({},r.state,{isDragActive:t,isDragAccept:n,isDragReject:o,open:r.open})):e},r.composeHandlers=r.composeHandlers.bind(r),r.onClick=r.onClick.bind(r),r.onDocumentDrop=r.onDocumentDrop.bind(r),r.onDragEnter=r.onDragEnter.bind(r),r.onDragLeave=r.onDragLeave.bind(r),r.onDragOver=r.onDragOver.bind(r),r.onDragStart=r.onDragStart.bind(r),r.onDrop=r.onDrop.bind(r),r.onFileDialogCancel=r.onFileDialogCancel.bind(r),r.onInputElementClick=r.onInputElementClick.bind(r),r.open=r.open.bind(r),r.setRef=r.setRef.bind(r),r.setRefs=r.setRefs.bind(r),r.isFileDialogActive=!1,r.state={draggedFiles:[],acceptedFiles:[],rejectedFiles:[]},r}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(n,e.Component),s(n,[{key:"componentDidMount",value:function(){var e=this.props.preventDropOnDocument;this.dragTargets=[],e&&(document.addEventListener("dragover",h,!1),document.addEventListener("drop",this.onDocumentDrop,!1)),null!=this.fileInputEl&&this.fileInputEl.addEventListener("click",this.onInputElementClick,!1),window.addEventListener("focus",this.onFileDialogCancel,!1)}},{key:"componentWillUnmount",value:function(){this.props.preventDropOnDocument&&(document.removeEventListener("dragover",h),document.removeEventListener("drop",this.onDocumentDrop)),null!=this.fileInputEl&&this.fileInputEl.removeEventListener("click",this.onInputElementClick,!1),window.removeEventListener("focus",this.onFileDialogCancel,!1)}},{key:"composeHandlers",value:function(e){return this.props.disabled?null:e}},{key:"onDocumentDrop",value:function(e){this.node&&this.node.contains(e.target)||(e.preventDefault(),this.dragTargets=[])}},{key:"onDragStart",value:function(e){e.persist(),this.props.onDragStart&&d(e)&&this.props.onDragStart.call(this,e)}},{key:"onDragEnter",value:function(e){var t=this;e.preventDefault(),-1===this.dragTargets.indexOf(e.target)&&this.dragTargets.push(e.target),e.persist(),d(e)&&(Promise.resolve(this.props.getDataTransferItems(e)).then(function(n){e.isPropagationStopped()||t.setState({draggedFiles:n,isDragActive:!0})}),this.props.onDragEnter&&this.props.onDragEnter.call(this,e))}},{key:"onDragOver",value:function(e){e.preventDefault(),e.persist();try{e.dataTransfer.dropEffect=this.isFileDialogActive?"none":"copy"}catch(e){}return this.props.onDragOver&&d(e)&&this.props.onDragOver.call(this,e),!1}},{key:"onDragLeave",value:function(e){var t=this;e.preventDefault(),e.persist(),this.dragTargets=this.dragTargets.filter(function(n){return n!==e.target&&t.node.contains(n)}),this.dragTargets.length>0||(this.setState({isDragActive:!1,draggedFiles:[]}),this.props.onDragLeave&&d(e)&&this.props.onDragLeave.call(this,e))}},{key:"onDrop",value:function(e){var t=this,n=this.props,r=n.onDrop,o=n.onDropAccepted,i=n.onDropRejected,a=n.multiple,s=n.accept,c=n.getDataTransferItems;e.preventDefault(),e.persist(),this.dragTargets=[],this.isFileDialogActive=!1,this.draggedFiles=null,this.setState({isDragActive:!1,draggedFiles:[]}),d(e)&&Promise.resolve(c(e)).then(function(n){var c=[],u=[];e.isPropagationStopped()||(n.forEach(function(e){f(e,s)&&function(e,t,n){return e.size<=t&&e.size>=n}(e,t.props.maxSize,t.props.minSize)?c.push(e):u.push(e)}),!a&&c.length>1&&u.push.apply(u,function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}(c.splice(0))),t.setState({acceptedFiles:c,rejectedFiles:u},function(){r&&r.call(t,c,u,e),u.length>0&&i&&i.call(t,u,e),c.length>0&&o&&o.call(t,c,e)}))})}},{key:"onClick",value:function(e){var t=this.props,n=t.onClick,r=t.disableClick;n&&n.call(this,e),r||e.isDefaultPrevented()||(e.stopPropagation(),!function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.navigator.userAgent;return function(e){return-1!==e.indexOf("MSIE")||-1!==e.indexOf("Trident/")}(e)||function(e){return-1!==e.indexOf("Edge/")}(e)}()?this.open():setTimeout(this.open,0))}},{key:"onInputElementClick",value:function(e){e.stopPropagation(),this.props.inputProps&&this.props.inputProps.onClick&&this.props.inputProps.onClick(e)}},{key:"onFileDialogCancel",value:function(){var e=this,t=this.props.onFileDialogCancel;this.isFileDialogActive&&setTimeout(function(){null!=e.fileInputEl&&(e.fileInputEl.files.length||(e.isFileDialogActive=!1,"function"==typeof t&&t()))},300)}},{key:"setRef",value:function(e){this.node=e}},{key:"setRefs",value:function(e){this.fileInputEl=e}},{key:"open",value:function(){this.isFileDialogActive=!0,this.fileInputEl.value=null,this.fileInputEl.click()}},{key:"render",value:function(){var t=this.props,n=t.accept,r=t.acceptClassName,o=t.activeClassName,i=t.children,a=t.disabled,s=t.disabledClassName,l=t.inputProps,d=t.multiple,h=t.name,D=t.rejectClassName,x=u(t,["accept","acceptClassName","activeClassName","children","disabled","disabledClassName","inputProps","multiple","name","rejectClassName"]),S=x.acceptStyle,C=x.activeStyle,E=x.className,O=void 0===E?"":E,j=x.disabledStyle,k=x.rejectStyle,w=x.style,P=u(x,["acceptStyle","activeStyle","className","disabledStyle","rejectStyle","style"]),F=this.state,A=F.isDragActive,T=F.draggedFiles,_=T.length,I=d||_<=1,L=_>0&&function(e,t){return e.every(function(e){return f(e,t)})}(T,this.props.accept),N=_>0&&(!L||!I),R=!(O||w||C||S||k||j);A&&o&&(O+=" "+o),L&&r&&(O+=" "+r),N&&D&&(O+=" "+D),a&&s&&(O+=" "+s),R&&(w=m,C=v,S=g,k=y,j=b);var z=c({position:"relative"},w);C&&A&&(z=c({},z,C)),S&&L&&(z=c({},z,S)),k&&N&&(z=c({},z,k)),j&&a&&(z=c({},z,j));var M={accept:n,disabled:a,type:"file",style:c({position:"absolute",top:0,right:0,bottom:0,left:0,opacity:1e-5,pointerEvents:"none"},l.style),multiple:p&&d,ref:this.setRefs,onChange:this.onDrop,autoComplete:"off"};h&&h.length&&(M.name=h);var W=u(P,["acceptedFiles","preventDropOnDocument","disableClick","onDropAccepted","onDropRejected","onFileDialogCancel","maxSize","minSize","getDataTransferItems"]);return e.createElement("div",c({className:O,style:z},W,{onClick:this.composeHandlers(this.onClick),onDragStart:this.composeHandlers(this.onDragStart),onDragEnter:this.composeHandlers(this.onDragEnter),onDragOver:this.composeHandlers(this.onDragOver),onDragLeave:this.composeHandlers(this.onDragLeave),onDrop:this.composeHandlers(this.onDrop),ref:this.setRef,"aria-disabled":a}),this.renderChildren(i,A,L,N),e.createElement("input",c({},l,M)))}}]),n}();return D.propTypes={accept:t.oneOfType([t.string,t.arrayOf(t.string)]),children:t.oneOfType([t.node,t.func]),disableClick:t.bool,disabled:t.bool,preventDropOnDocument:t.bool,inputProps:t.object,multiple:t.bool,name:t.string,maxSize:t.number,minSize:t.number,className:t.string,activeClassName:t.string,acceptClassName:t.string,rejectClassName:t.string,disabledClassName:t.string,style:t.object,activeStyle:t.object,acceptStyle:t.object,rejectStyle:t.object,disabledStyle:t.object,getDataTransferItems:t.func,onClick:t.func,onDrop:t.func,onDropAccepted:t.func,onDropRejected:t.func,onDragStart:t.func,onDragEnter:t.func,onDragOver:t.func,onDragLeave:t.func,onFileDialogCancel:t.func},D.defaultProps={preventDropOnDocument:!0,disabled:!1,disableClick:!1,inputProps:{},multiple:!0,maxSize:1/0,minSize:0,getDataTransferItems:function(e){var t=[];if(e.dataTransfer){var n=e.dataTransfer;n.files&&n.files.length?t=n.files:n.items&&n.items.length&&(t=n.items)}else e.target&&e.target.files&&(t=e.target.files);return Array.prototype.slice.call(t)}},D});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export
	
	var ReactHeight = __webpack_require__(2030).default;
	
	module.exports = ReactHeight;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2042);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onUnmount = exports.onMount = undefined;
	exports._onClick = _onClick;
	exports._onKeyDown = _onKeyDown;
	exports._shouldConsider = _shouldConsider;
	
	var _dom_helpers = __webpack_require__(2049);
	
	var _dom_helpers2 = _interopRequireDefault(_dom_helpers);
	
	var _listeners = __webpack_require__(2050);
	
	var _listeners2 = _interopRequireDefault(_listeners);
	
	var _store = __webpack_require__(339);
	
	var store = _interopRequireWildcard(_store);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	/**
	 * @module eventHandlers
	 *
	 */
	
	
	/**
	 * private
	 *
	 */
	
	/**
	 * _onClick
	 *
	 * @access private
	 * @param {object} event The click event object
	 * @param {object} event.target The DOM node from the click event
	 */
	function _onClick(_ref) {
	  var target = _ref.target;
	
	  store.activate([].concat(_toConsumableArray(store.getInstances())).reduce(_dom_helpers2.default.findContainerNodes(target), []).sort(_dom_helpers2.default.sortByDOMPosition).map(function (item) {
	    return item.instance;
	  }));
	}
	
	/**
	 * _onKeyDown: The keydown event callback
	 *
	 * @access private
	 * @param {object} event The keydown event object
	 * @param {number} event.which The key code (which) received from the keydown event
	 */
	function _onKeyDown(event) {
	  var forceConsider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (forceConsider || _shouldConsider(event)) {
	    var _ref2 = store.findBindingForEvent(event) || {},
	        fn = _ref2.fn,
	        instance = _ref2.instance;
	
	    if (fn) {
	      fn.call(instance, event);
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * _shouldConsider: Conditions for proceeding with key event handling
	 *
	 * @access private
	 * @param {object} event The keydown event object
	 * @param {object} event.target The node origin of the event
	 * @return {boolean} Whether to continue procesing the keydown event
	 */
	function _shouldConsider(_ref3) {
	  var ctrlKey = _ref3.ctrlKey,
	      target = _ref3.target;
	
	  return ctrlKey || !~['INPUT', 'SELECT', 'TEXTAREA'].indexOf(target.tagName) && (!target.getAttribute || target.getAttribute('role') !== 'textbox');
	}
	
	/**
	 * public
	 *
	 */
	
	/**
	 * onMount
	 *
	 * @access public
	 */
	function onMount(instance) {
	  store.activate(instance);
	  _listeners2.default.bindKeys(_onKeyDown);
	  _listeners2.default.bindClicks(_onClick);
	  _dom_helpers2.default.bindFocusables(instance, store.activate);
	}
	
	/**
	 * onUnmount
	 *
	 * @access public
	 */
	function onUnmount(instance) {
	  store.deleteInstance(instance);
	  if (store.isEmpty()) {
	    _listeners2.default.unbindClicks(_onClick);
	    _listeners2.default.unbindKeys(_onKeyDown);
	  }
	}
	
	exports.onMount = onMount;
	exports.onUnmount = onUnmount;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(338);
	
	var PRINTABLE_CHARACTERS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ~!@#$%^&*()-_+=[]\\{}|;\':",./<>?£';
	
	var modKeys = Object.keys(_keys.modifiers);
	
	function matchKeys(_ref) {
	  var keySet = _ref.keySet,
	      event = _ref.event;
	  var key = keySet.key,
	      _keySet$modifiers = keySet.modifiers,
	      modifiers = _keySet$modifiers === undefined ? [] : _keySet$modifiers;
	
	  var keysMatch = void 0;
	
	  keysMatch = key === _keys.ALL_KEYS;
	
	  if (key === _keys.ALL_PRINTABLE_KEYS) {
	    if (event.key) {
	      // Modern browsers implement `key`, so if `key` is length 1, we have a match. e.g. 'a' for the
	      // a key, or '2' for the 2 key. All other non-printable characters have names, e.g. 'Enter' or 'Backspace'.
	      keysMatch = event.key.length === 1;
	    } else {
	      // For browsers that do no support `event.key`, we test against a list of characters
	      var pressedChar = String.fromCharCode(event.charCode);
	      keysMatch = PRINTABLE_CHARACTERS.indexOf(pressedChar) >= 0;
	    }
	  }
	
	  if (key === event.which) {
	    var evtModKeys = modKeys.filter(function (modKey) {
	      return event[modKey + 'Key'];
	    }).sort();
	    keysMatch = modifiers.length === evtModKeys.length && modifiers.every(function (modKey, index) {
	      return evtModKeys[index] === modKey;
	    });
	  }
	
	  return keysMatch;
	}
	
	exports.default = matchKeys;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(338);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseKeys(keysArray) {
	  return keysArray.map(function (key) {
	    var keySet = { key: key };
	    if (typeof key === 'string') {
	      var keyString = key.toLowerCase().trim();
	      var matches = keyString.split(/\s?\+\s?/);
	      keySet = matches.length === 1 ? { key: _keys2.default[keyString] } : {
	        key: _keys2.default[matches.pop()],
	        modifiers: matches.map(function (modKey) {
	          return _keys.modifiers[modKey];
	        }).sort()
	      };
	    }
	    return keySet;
	  });
	}
	
	exports.default = parseKeys;

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ }),
/* 865 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeAsyncSelect = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Select = _interopRequireDefault(__webpack_require__(342));
	
	var _utils = __webpack_require__(344);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(343));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  cacheOptions: false,
	  defaultOptions: false,
	  filterOption: null
	};
	exports.defaultProps = defaultProps;
	
	var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Async, _Component);
	
	    function Async(props) {
	      var _this;
	
	      _classCallCheck(this, Async);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Async).call(this));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastRequest", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsCache", {});
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (newValue, actionMeta) {
	        var _this$props = _this.props,
	            cacheOptions = _this$props.cacheOptions,
	            onInputChange = _this$props.onInputChange; // TODO
	
	        var inputValue = (0, _utils.handleInputChange)(newValue, actionMeta, onInputChange);
	
	        if (!inputValue) {
	          delete _this.lastRequest;
	
	          _this.setState({
	            inputValue: '',
	            loadedInputValue: '',
	            loadedOptions: [],
	            isLoading: false,
	            passEmptyOptions: false
	          });
	
	          return;
	        }
	
	        if (cacheOptions && _this.optionsCache[inputValue]) {
	          _this.setState({
	            inputValue: inputValue,
	            loadedInputValue: inputValue,
	            loadedOptions: _this.optionsCache[inputValue],
	            isLoading: false,
	            passEmptyOptions: false
	          });
	        } else {
	          var request = _this.lastRequest = {};
	
	          _this.setState({
	            inputValue: inputValue,
	            isLoading: true,
	            passEmptyOptions: !_this.state.loadedInputValue
	          }, function () {
	            _this.loadOptions(inputValue, function (options) {
	              if (!_this.mounted) return;
	
	              if (options) {
	                _this.optionsCache[inputValue] = options;
	              }
	
	              if (request !== _this.lastRequest) return;
	              delete _this.lastRequest;
	
	              _this.setState({
	                isLoading: false,
	                loadedInputValue: inputValue,
	                loadedOptions: options || [],
	                passEmptyOptions: false
	              });
	            });
	          });
	        }
	
	        return inputValue;
	      });
	
	      _this.state = {
	        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
	        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
	        isLoading: props.defaultOptions === true ? true : false,
	        loadedOptions: [],
	        passEmptyOptions: false
	      };
	      return _this;
	    }
	
	    _createClass(Async, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this.mounted = true;
	        var defaultOptions = this.props.defaultOptions;
	        var inputValue = this.state.inputValue;
	
	        if (defaultOptions === true) {
	          this.loadOptions(inputValue, function (options) {
	            if (!_this2.mounted) return;
	            var isLoading = !!_this2.lastRequest;
	
	            _this2.setState({
	              defaultOptions: options || [],
	              isLoading: isLoading
	            });
	          });
	        }
	      }
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        // if the cacheOptions prop changes, clear the cache
	        if (nextProps.cacheOptions !== this.props.cacheOptions) {
	          this.optionsCache = {};
	        }
	
	        if (nextProps.defaultOptions !== this.props.defaultOptions) {
	          this.setState({
	            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
	          });
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.mounted = false;
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      }
	    }, {
	      key: "loadOptions",
	      value: function loadOptions(inputValue, callback) {
	        var loadOptions = this.props.loadOptions;
	        if (!loadOptions) return callback();
	        var loader = loadOptions(inputValue, callback);
	
	        if (loader && typeof loader.then === 'function') {
	          loader.then(callback, function () {
	            return callback();
	          });
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this3 = this;
	
	        var _this$props2 = this.props,
	            loadOptions = _this$props2.loadOptions,
	            props = _objectWithoutProperties(_this$props2, ["loadOptions"]);
	
	        var _this$state = this.state,
	            defaultOptions = _this$state.defaultOptions,
	            inputValue = _this$state.inputValue,
	            isLoading = _this$state.isLoading,
	            loadedInputValue = _this$state.loadedInputValue,
	            loadedOptions = _this$state.loadedOptions,
	            passEmptyOptions = _this$state.passEmptyOptions;
	        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this3.select = _ref;
	          },
	          options: options,
	          isLoading: isLoading,
	          onInputChange: this.handleInputChange
	        }));
	      }
	    }]);
	
	    return Async;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	exports.makeAsyncSelect = makeAsyncSelect;
	var SelectState = (0, _stateManager.default)(_Select.default);
	
	var _default = makeAsyncSelect(SelectState);
	
	exports.default = _default;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.css = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      _ref$theme = _ref.theme,
	      colors = _ref$theme.colors,
	      borderRadius = _ref$theme.borderRadius,
	      spacing = _ref$theme.spacing;
	  return {
	    label: 'control',
	    alignItems: 'center',
	    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
	    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
	    borderRadius: borderRadius,
	    borderStyle: 'solid',
	    borderWidth: 1,
	    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
	    cursor: 'default',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'space-between',
	    minHeight: spacing.controlHeight,
	    outline: '0 !important',
	    position: 'relative',
	    transition: 'all 100ms',
	    '&:hover': {
	      borderColor: isFocused ? colors.primary : colors.neutral30
	    }
	  };
	};
	
	exports.css = css;
	
	var Control = function Control(props) {
	  var children = props.children,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      className = props.className,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps,
	      menuIsOpen = props.menuIsOpen;
	  return _react.default.createElement("div", _extends({
	    ref: innerRef,
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('control', props)), {
	      'control': true,
	      'control--is-disabled': isDisabled,
	      'control--is-focused': isFocused,
	      'control--menu-is-open': menuIsOpen
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Control;
	exports.default = _default;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GroupHeading = exports.groupHeadingCSS = exports.groupCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var groupCSS = function groupCSS(_ref) {
	  var spacing = _ref.theme.spacing;
	  return {
	    paddingBottom: spacing.baseUnit * 2,
	    paddingTop: spacing.baseUnit * 2
	  };
	};
	
	exports.groupCSS = groupCSS;
	
	var Group = function Group(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      Heading = props.Heading,
	      headingProps = props.headingProps,
	      label = props.label,
	      theme = props.theme,
	      selectProps = props.selectProps;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('group', props)), {
	      'group': true
	    }, className)
	  }, _react.default.createElement(Heading, _extends({}, headingProps, {
	    selectProps: selectProps,
	    theme: theme,
	    getStyles: getStyles,
	    cx: cx
	  }), label), _react.default.createElement("div", null, children));
	};
	
	var groupHeadingCSS = function groupHeadingCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    label: 'group',
	    color: '#999',
	    cursor: 'default',
	    display: 'block',
	    fontSize: '75%',
	    fontWeight: '500',
	    marginBottom: '0.25em',
	    paddingLeft: spacing.baseUnit * 3,
	    paddingRight: spacing.baseUnit * 3,
	    textTransform: 'uppercase'
	  };
	};
	
	exports.groupHeadingCSS = groupHeadingCSS;
	
	var GroupHeading = function GroupHeading(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      theme = props.theme,
	      selectProps = props.selectProps,
	      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
	
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('groupHeading', _objectSpread({
	      theme: theme
	    }, cleanProps))), {
	      'group-heading': true
	    }, className)
	  }, cleanProps));
	};
	
	exports.GroupHeading = GroupHeading;
	var _default = Group;
	exports.default = _default;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.inputCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	var _reactInputAutosize = _interopRequireDefault(__webpack_require__(2041));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var inputCSS = function inputCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    margin: spacing.baseUnit / 2,
	    paddingBottom: spacing.baseUnit / 2,
	    paddingTop: spacing.baseUnit / 2,
	    visibility: isDisabled ? 'hidden' : 'visible',
	    color: colors.neutral80
	  };
	};
	
	exports.inputCSS = inputCSS;
	
	var inputStyle = function inputStyle(isHidden) {
	  return {
	    label: 'input',
	    background: 0,
	    border: 0,
	    fontSize: 'inherit',
	    opacity: isHidden ? 0 : 1,
	    outline: 0,
	    padding: 0,
	    color: 'inherit'
	  };
	};
	
	var Input = function Input(_ref2) {
	  var className = _ref2.className,
	      cx = _ref2.cx,
	      getStyles = _ref2.getStyles,
	      innerRef = _ref2.innerRef,
	      isHidden = _ref2.isHidden,
	      isDisabled = _ref2.isDisabled,
	      theme = _ref2.theme,
	      selectProps = _ref2.selectProps,
	      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
	
	  return _react.default.createElement("div", {
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('input', _objectSpread({
	      theme: theme
	    }, props)))
	  }, _react.default.createElement(_reactInputAutosize.default, _extends({
	    className: cx(null, {
	      'input': true
	    }, className),
	    inputRef: innerRef,
	    inputStyle: inputStyle(isHidden),
	    disabled: isDisabled
	  }, props)));
	};
	
	var _default = Input;
	exports.default = _default;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MultiValueRemove = exports.MultiValueLabel = exports.MultiValueContainer = exports.MultiValueGeneric = exports.multiValueRemoveCSS = exports.multiValueLabelCSS = exports.multiValueCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	var _indicators = __webpack_require__(494);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var multiValueCSS = function multiValueCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      borderRadius = _ref$theme.borderRadius,
	      colors = _ref$theme.colors;
	  return {
	    label: 'multiValue',
	    backgroundColor: colors.neutral10,
	    borderRadius: borderRadius / 2,
	    display: 'flex',
	    margin: spacing.baseUnit / 2,
	    minWidth: 0 // resolves flex/text-overflow bug
	
	  };
	};
	
	exports.multiValueCSS = multiValueCSS;
	
	var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
	  var _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      colors = _ref2$theme.colors,
	      cropWithEllipsis = _ref2.cropWithEllipsis;
	  return {
	    borderRadius: borderRadius / 2,
	    color: colors.neutral80,
	    fontSize: '85%',
	    overflow: 'hidden',
	    padding: 3,
	    paddingLeft: 6,
	    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
	    whiteSpace: 'nowrap'
	  };
	};
	
	exports.multiValueLabelCSS = multiValueLabelCSS;
	
	var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
	  var _ref3$theme = _ref3.theme,
	      spacing = _ref3$theme.spacing,
	      borderRadius = _ref3$theme.borderRadius,
	      colors = _ref3$theme.colors,
	      isFocused = _ref3.isFocused;
	  return {
	    alignItems: 'center',
	    borderRadius: borderRadius / 2,
	    backgroundColor: isFocused && colors.dangerLight,
	    display: 'flex',
	    paddingLeft: spacing.baseUnit,
	    paddingRight: spacing.baseUnit,
	    ':hover': {
	      backgroundColor: colors.dangerLight,
	      color: colors.danger
	    }
	  };
	};
	
	exports.multiValueRemoveCSS = multiValueRemoveCSS;
	
	var MultiValueGeneric = function MultiValueGeneric(_ref4) {
	  var children = _ref4.children,
	      innerProps = _ref4.innerProps;
	  return _react.default.createElement("div", innerProps, children);
	};
	
	exports.MultiValueGeneric = MultiValueGeneric;
	var MultiValueContainer = MultiValueGeneric;
	exports.MultiValueContainer = MultiValueContainer;
	var MultiValueLabel = MultiValueGeneric;
	exports.MultiValueLabel = MultiValueLabel;
	
	var MultiValueRemove =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MultiValueRemove, _Component);
	
	  function MultiValueRemove() {
	    _classCallCheck(this, MultiValueRemove);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
	  }
	
	  _createClass(MultiValueRemove, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          innerProps = _this$props.innerProps;
	      return _react.default.createElement("div", innerProps, children || _react.default.createElement(_indicators.CrossIcon, {
	        size: 14
	      }));
	    }
	  }]);
	
	  return MultiValueRemove;
	}(_react.Component);
	
	exports.MultiValueRemove = MultiValueRemove;
	
	var MultiValue =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MultiValue, _Component2);
	
	  function MultiValue() {
	    _classCallCheck(this, MultiValue);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
	  }
	
	  _createClass(MultiValue, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          components = _this$props2.components,
	          cx = _this$props2.cx,
	          data = _this$props2.data,
	          getStyles = _this$props2.getStyles,
	          innerProps = _this$props2.innerProps,
	          isDisabled = _this$props2.isDisabled,
	          removeProps = _this$props2.removeProps,
	          selectProps = _this$props2.selectProps;
	      var Container = components.Container,
	          Label = components.Label,
	          Remove = components.Remove;
	
	      var containerInnerProps = _objectSpread({
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValue', this.props)), {
	          'multi-value': true,
	          'multi-value--is-disabled': isDisabled
	        }, className)
	      }, innerProps);
	
	      var labelInnerProps = {
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValueLabel', this.props)), {
	          'multi-value__label': true
	        }, className)
	      };
	
	      var removeInnerProps = _objectSpread({
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValueRemove', this.props)), {
	          'multi-value__remove': true
	        }, className)
	      }, removeProps);
	
	      return _react.default.createElement(Container, {
	        data: data,
	        innerProps: containerInnerProps,
	        selectProps: selectProps
	      }, _react.default.createElement(Label, {
	        data: data,
	        innerProps: labelInnerProps,
	        selectProps: selectProps
	      }, children), _react.default.createElement(Remove, {
	        data: data,
	        innerProps: removeInnerProps,
	        selectProps: selectProps
	      }));
	    }
	  }]);
	
	  return MultiValue;
	}(_react.Component);
	
	_defineProperty(MultiValue, "defaultProps", {
	  cropWithEllipsis: true
	});
	
	var _default = MultiValue;
	exports.default = _default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.optionCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var optionCSS = function optionCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      isSelected = _ref.isSelected,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'option',
	    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
	    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
	    cursor: 'default',
	    display: 'block',
	    fontSize: 'inherit',
	    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
	    width: '100%',
	    userSelect: 'none',
	    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	    // provide some affordance on touch devices
	    ':active': {
	      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
	    }
	  };
	};
	
	exports.optionCSS = optionCSS;
	
	var Option = function Option(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      isSelected = props.isSelected,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    ref: innerRef,
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('option', props)), {
	      'option': true,
	      'option--is-disabled': isDisabled,
	      'option--is-focused': isFocused,
	      'option--is-selected': isSelected
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Option;
	exports.default = _default;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.placeholderCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var placeholderCSS = function placeholderCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'placeholder',
	    color: colors.neutral50,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    position: 'absolute',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	exports.placeholderCSS = placeholderCSS;
	
	var Placeholder = function Placeholder(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('placeholder', props)), {
	      'placeholder': true
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Placeholder;
	exports.default = _default;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.css = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'singleValue',
	    color: isDisabled ? colors.neutral40 : colors.neutral80,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
	    overflow: 'hidden',
	    position: 'absolute',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	exports.css = css;
	
	var SingleValue = function SingleValue(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('singleValue', props)), {
	      'single-value': true,
	      'single-value--is-disabled': isDisabled
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = SingleValue;
	exports.default = _default;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndicatorsContainer = exports.indicatorsContainerCSS = exports.ValueContainer = exports.valueContainerCSS = exports.SelectContainer = exports.containerCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var containerCSS = function containerCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isRtl = _ref.isRtl;
	  return {
	    label: 'container',
	    direction: isRtl ? 'rtl' : null,
	    pointerEvents: isDisabled ? 'none' : null,
	    // cancel mouse events when disabled
	    position: 'relative'
	  };
	};
	
	exports.containerCSS = containerCSS;
	
	var SelectContainer = function SelectContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      isRtl = props.isRtl;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('container', props)), {
	      '--is-disabled': isDisabled,
	      '--is-rtl': isRtl
	    }, className)
	  }, innerProps), children);
	}; // ==============================
	// Value Container
	// ==============================
	
	
	exports.SelectContainer = SelectContainer;
	
	var valueContainerCSS = function valueContainerCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    alignItems: 'center',
	    display: 'flex',
	    flex: 1,
	    flexWrap: 'wrap',
	    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
	    WebkitOverflowScrolling: 'touch',
	    position: 'relative',
	    overflow: 'hidden'
	  };
	};
	
	exports.valueContainerCSS = valueContainerCSS;
	
	var ValueContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ValueContainer, _Component);
	
	  function ValueContainer() {
	    _classCallCheck(this, ValueContainer);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
	  }
	
	  _createClass(ValueContainer, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          cx = _this$props.cx,
	          isMulti = _this$props.isMulti,
	          getStyles = _this$props.getStyles,
	          hasValue = _this$props.hasValue;
	      return _react.default.createElement("div", {
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('valueContainer', this.props)), {
	          'value-container': true,
	          'value-container--is-multi': isMulti,
	          'value-container--has-value': hasValue
	        }, className)
	      }, children);
	    }
	  }]);
	
	  return ValueContainer;
	}(_react.Component); // ==============================
	// Indicator Container
	// ==============================
	
	
	exports.ValueContainer = ValueContainer;
	
	var indicatorsContainerCSS = function indicatorsContainerCSS() {
	  return {
	    alignItems: 'center',
	    alignSelf: 'stretch',
	    display: 'flex',
	    flexShrink: 0
	  };
	};
	
	exports.indicatorsContainerCSS = indicatorsContainerCSS;
	
	var IndicatorsContainer = function IndicatorsContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('indicatorsContainer', props)), {
	      'indicators': true
	    }, className)
	  }, children);
	};
	
	exports.IndicatorsContainer = IndicatorsContainer;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFilter = void 0;
	
	var _diacritics = __webpack_require__(2088);
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var trimString = function trimString(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	var defaultStringify = function defaultStringify(option) {
	  return "".concat(option.label, " ").concat(option.value);
	};
	
	var createFilter = function createFilter(config) {
	  return function (option, rawInput) {
	    var _ignoreCase$ignoreAcc = _objectSpread({
	      ignoreCase: true,
	      ignoreAccents: true,
	      stringify: defaultStringify,
	      trim: true,
	      matchFrom: 'any'
	    }, config),
	        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
	        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
	        stringify = _ignoreCase$ignoreAcc.stringify,
	        trim = _ignoreCase$ignoreAcc.trim,
	        matchFrom = _ignoreCase$ignoreAcc.matchFrom;
	
	    var input = trim ? trimString(rawInput) : rawInput;
	    var candidate = trim ? trimString(stringify(option)) : stringify(option);
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	      candidate = candidate.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = (0, _diacritics.stripDiacritics)(input);
	      candidate = (0, _diacritics.stripDiacritics)(candidate);
	    }
	
	    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
	  };
	};
	
	exports.createFilter = createFilter;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exportedEqual;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
	    var arrA = isArray(a),
	        arrB = isArray(b),
	        i,
	        length,
	        key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	
	      for (i = length; i-- !== 0;) {
	        if (!equal(a[i], b[i])) return false;
	      }
	
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	    var dateA = a instanceof Date,
	        dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	    var regexpA = a instanceof RegExp,
	        regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length) {
	      return false;
	    }
	
	    for (i = length; i-- !== 0;) {
	      if (!hasProp.call(b, keys[i])) return false;
	    } // end fast-deep-equal
	    // Custom handling for React
	
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    } // fast-deep-equal index.js 2.0.1
	
	
	    return true;
	  }
	
	  return a !== a && b !== b;
	} // end fast-deep-equal
	
	
	function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (error.message && error.message.match(/stack|recursion/i)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    } // some other error. we should definitely know about these
	
	
	    throw error;
	  }
	}
	
	;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeStyles = mergeStyles;
	exports.defaultStyles = void 0;
	
	var _containers = __webpack_require__(876);
	
	var _Control = __webpack_require__(869);
	
	var _Group = __webpack_require__(870);
	
	var _indicators = __webpack_require__(494);
	
	var _Input = __webpack_require__(871);
	
	var _Placeholder = __webpack_require__(874);
	
	var _Option = __webpack_require__(873);
	
	var _Menu = __webpack_require__(492);
	
	var _SingleValue = __webpack_require__(875);
	
	var _MultiValue = __webpack_require__(872);
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultStyles = {
	  clearIndicator: _indicators.clearIndicatorCSS,
	  container: _containers.containerCSS,
	  control: _Control.css,
	  dropdownIndicator: _indicators.dropdownIndicatorCSS,
	  group: _Group.groupCSS,
	  groupHeading: _Group.groupHeadingCSS,
	  indicatorsContainer: _containers.indicatorsContainerCSS,
	  indicatorSeparator: _indicators.indicatorSeparatorCSS,
	  input: _Input.inputCSS,
	  loadingIndicator: _indicators.loadingIndicatorCSS,
	  loadingMessage: _Menu.loadingMessageCSS,
	  menu: _Menu.menuCSS,
	  menuList: _Menu.menuListCSS,
	  menuPortal: _Menu.menuPortalCSS,
	  multiValue: _MultiValue.multiValueCSS,
	  multiValueLabel: _MultiValue.multiValueLabelCSS,
	  multiValueRemove: _MultiValue.multiValueRemoveCSS,
	  noOptionsMessage: _Menu.noOptionsMessageCSS,
	  option: _Option.optionCSS,
	  placeholder: _Placeholder.placeholderCSS,
	  singleValue: _SingleValue.css,
	  valueContainer: _containers.valueContainerCSS
	}; // Merge Utility
	// Allows consumers to extend a base Select with additional styles
	
	exports.defaultStyles = defaultStyles;
	
	function mergeStyles(source) {
	  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  // initialize with source styles
	  var styles = _objectSpread({}, source); // massage in target styles
	
	
	  Object.keys(target).forEach(function (key) {
	    if (source[key]) {
	      styles[key] = function (rsCss, props) {
	        return target[key](source[key](rsCss, props), props);
	      };
	    } else {
	      styles[key] = target[key];
	    }
	  });
	  return styles;
	}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultTheme = exports.spacing = exports.colors = void 0;
	var colors = {
	  primary: '#2684FF',
	  primary75: '#4C9AFF',
	  primary50: '#B2D4FF',
	  primary25: '#DEEBFF',
	  danger: '#DE350B',
	  dangerLight: '#FFBDAD',
	  neutral0: 'hsl(0, 0%, 100%)',
	  neutral5: 'hsl(0, 0%, 95%)',
	  neutral10: 'hsl(0, 0%, 90%)',
	  neutral20: 'hsl(0, 0%, 80%)',
	  neutral30: 'hsl(0, 0%, 70%)',
	  neutral40: 'hsl(0, 0%, 60%)',
	  neutral50: 'hsl(0, 0%, 50%)',
	  neutral60: 'hsl(0, 0%, 40%)',
	  neutral70: 'hsl(0, 0%, 30%)',
	  neutral80: 'hsl(0, 0%, 20%)',
	  neutral90: 'hsl(0, 0%, 10%)'
	};
	exports.colors = colors;
	var borderRadius = 4;
	var baseUnit = 4;
	/* Used to calculate consistent margin/padding on elements */
	
	var controlHeight = 38;
	/* The minimum height of the control */
	
	var menuGutter = baseUnit * 2;
	/* The amount of space between the control and menu */
	
	var spacing = {
	  baseUnit: baseUnit,
	  controlHeight: controlHeight,
	  menuGutter: menuGutter
	};
	exports.spacing = spacing;
	var defaultTheme = {
	  borderRadius: borderRadius,
	  colors: colors,
	  spacing: spacing
	};
	exports.defaultTheme = defaultTheme;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(45));
	
	var _reactLifecyclesCompat = __webpack_require__(485);
	
	var _PropTypes = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(485);
	
	var _ChildMapping = __webpack_require__(2101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(2099));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(2100));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(882));
	
	var _Transition = _interopRequireDefault(__webpack_require__(881));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Default CellMeasurer `cellSizeCache` implementation.
	 * Permanently caches all cell sizes (identified by column and row index) unless explicitly cleared.
	 * Can be configured to handle uniform cell widths and/or heights as a way of optimizing certain use cases.
	 */
	var CellSizeCache = function () {
	  function CellSizeCache() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var _ref$uniformRowHeight = _ref.uniformRowHeight;
	    var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;
	    var _ref$uniformColumnWid = _ref.uniformColumnWidth;
	    var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;
	
	    _classCallCheck(this, CellSizeCache);
	
	    this._uniformRowHeight = uniformRowHeight;
	    this._uniformColumnWidth = uniformColumnWidth;
	
	    this._cachedColumnWidths = {};
	    this._cachedRowHeights = {};
	  }
	
	  _createClass(CellSizeCache, [{
	    key: "clearAllColumnWidths",
	    value: function clearAllColumnWidths() {
	      this._cachedColumnWidth = undefined;
	      this._cachedColumnWidths = {};
	    }
	  }, {
	    key: "clearAllRowHeights",
	    value: function clearAllRowHeights() {
	      this._cachedRowHeight = undefined;
	      this._cachedRowHeights = {};
	    }
	  }, {
	    key: "clearColumnWidth",
	    value: function clearColumnWidth(index) {
	      this._cachedColumnWidth = undefined;
	
	      delete this._cachedColumnWidths[index];
	    }
	  }, {
	    key: "clearRowHeight",
	    value: function clearRowHeight(index) {
	      this._cachedRowHeight = undefined;
	
	      delete this._cachedRowHeights[index];
	    }
	  }, {
	    key: "getColumnWidth",
	    value: function getColumnWidth(index) {
	      return this._uniformColumnWidth ? this._cachedColumnWidth : this._cachedColumnWidths[index];
	    }
	  }, {
	    key: "getRowHeight",
	    value: function getRowHeight(index) {
	      return this._uniformRowHeight ? this._cachedRowHeight : this._cachedRowHeights[index];
	    }
	  }, {
	    key: "hasColumnWidth",
	    value: function hasColumnWidth(index) {
	      return this._uniformColumnWidth ? !!this._cachedColumnWidth : !!this._cachedColumnWidths[index];
	    }
	  }, {
	    key: "hasRowHeight",
	    value: function hasRowHeight(index) {
	      return this._uniformRowHeight ? !!this._cachedRowHeight : !!this._cachedRowHeights[index];
	    }
	  }, {
	    key: "setColumnWidth",
	    value: function setColumnWidth(index, width) {
	      this._cachedColumnWidth = width;
	      this._cachedColumnWidths[index] = width;
	    }
	  }, {
	    key: "setRowHeight",
	    value: function setRowHeight(index, height) {
	      this._cachedRowHeight = height;
	      this._cachedRowHeights[index] = height;
	    }
	  }]);
	
	  return CellSizeCache;
	}();
	
	exports.default = CellSizeCache;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _defaultHeaderRenderer = __webpack_require__(890);
	
	var _defaultHeaderRenderer2 = _interopRequireDefault(_defaultHeaderRenderer);
	
	var _defaultCellRenderer = __webpack_require__(889);
	
	var _defaultCellRenderer2 = _interopRequireDefault(_defaultCellRenderer);
	
	var _defaultCellDataGetter = __webpack_require__(888);
	
	var _defaultCellDataGetter2 = _interopRequireDefault(_defaultCellDataGetter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Describes the header and cell contents of a table column.
	 */
	var Column = function (_Component) {
	  _inherits(Column, _Component);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
	  }
	
	  return Column;
	}(_react.Component);
	
	Column.defaultProps = {
	  cellDataGetter: _defaultCellDataGetter2.default,
	  cellRenderer: _defaultCellRenderer2.default,
	  flexGrow: 0,
	  flexShrink: 1,
	  headerRenderer: _defaultHeaderRenderer2.default,
	  style: {}
	};
	Column.propTypes = {
	  /** Optional aria-label value to set on the column header */
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Callback responsible for returning a cell's data, given its :dataKey
	   * ({ columnData: any, dataKey: string, rowData: any }): any
	   */
	  cellDataGetter: _react.PropTypes.func,
	
	  /**
	   * Callback responsible for rendering a cell's contents.
	   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
	   */
	  cellRenderer: _react.PropTypes.func,
	
	  /** Optional CSS class to apply to cell */
	  className: _react.PropTypes.string,
	
	  /** Optional additional data passed to this column's :cellDataGetter */
	  columnData: _react.PropTypes.object,
	
	  /** Uniquely identifies the row-data attribute correspnding to this cell */
	  dataKey: _react.PropTypes.any.isRequired,
	
	  /** If sort is enabled for the table at large, disable it for this column */
	  disableSort: _react.PropTypes.bool,
	
	  /** Flex grow style; defaults to 0 */
	  flexGrow: _react.PropTypes.number,
	
	  /** Flex shrink style; defaults to 1 */
	  flexShrink: _react.PropTypes.number,
	
	  /** Optional CSS class to apply to this column's header */
	  headerClassName: _react.PropTypes.string,
	
	  /**
	   * Optional callback responsible for rendering a column header contents.
	   * ({ columnData: object, dataKey: string, disableSort: boolean, label: string, sortBy: string, sortDirection: string }): PropTypes.node
	   */
	  headerRenderer: _react.PropTypes.func.isRequired,
	
	  /** Header label for this column */
	  label: _react.PropTypes.string,
	
	  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
	  maxWidth: _react.PropTypes.number,
	
	  /** Minimum width of column. */
	  minWidth: _react.PropTypes.number,
	
	  /** Optional inline style to apply to cell */
	  style: _react.PropTypes.object,
	
	  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
	  width: _react.PropTypes.number.isRequired
	};
	exports.default = Column;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SortIndicator;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SortDirection = __webpack_require__(497);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Displayed beside a header to indicate that a FlexTable is currently sorted by this column.
	 */
	function SortIndicator(_ref) {
	  var sortDirection = _ref.sortDirection;
	
	  var classNames = (0, _classnames2.default)('FlexTable__sortableHeaderIcon', {
	    'FlexTable__sortableHeaderIcon--ASC': sortDirection === _SortDirection2.default.ASC,
	    'FlexTable__sortableHeaderIcon--DESC': sortDirection === _SortDirection2.default.DESC
	  });
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: classNames,
	      width: 18,
	      height: 18,
	      viewBox: '0 0 24 24'
	    },
	    sortDirection === _SortDirection2.default.ASC ? _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' }) : _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  );
	}
	SortIndicator.propTypes = {
	  sortDirection: _react.PropTypes.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC])
	};

/***/ }),
/* 888 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellDataGetter;
	
	
	/**
	 * Default accessor for returning a cell value for a given attribute.
	 * This function expects to operate on either a vanilla Object or an Immutable Map.
	 * You should override the column's cellDataGetter if your data is some other type of object.
	 */
	function defaultCellDataGetter(_ref) {
	  var columnData = _ref.columnData;
	  var dataKey = _ref.dataKey;
	  var rowData = _ref.rowData;
	
	  if (rowData.get instanceof Function) {
	    return rowData.get(dataKey);
	  } else {
	    return rowData[dataKey];
	  }
	}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRenderer;
	
	
	/**
	 * Default cell renderer that displays an attribute as a simple string
	 * You should override the column's cellRenderer if your data is some other type of object.
	 */
	function defaultCellRenderer(_ref) {
	  var cellData = _ref.cellData;
	  var cellDataKey = _ref.cellDataKey;
	  var columnData = _ref.columnData;
	  var rowData = _ref.rowData;
	  var rowIndex = _ref.rowIndex;
	
	  if (cellData == null) {
	    return '';
	  } else {
	    return String(cellData);
	  }
	}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SortIndicator = __webpack_require__(887);
	
	var _SortIndicator2 = _interopRequireDefault(_SortIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default table header renderer.
	 */
	function defaultHeaderRenderer(_ref) {
	  var columnData = _ref.columnData;
	  var dataKey = _ref.dataKey;
	  var disableSort = _ref.disableSort;
	  var label = _ref.label;
	  var sortBy = _ref.sortBy;
	  var sortDirection = _ref.sortDirection;
	
	  var showSortIndicator = sortBy === dataKey;
	  var children = [_react2.default.createElement(
	    'span',
	    {
	      className: 'FlexTable__headerTruncatedText',
	      key: 'label',
	      title: label
	    },
	    label
	  )];
	
	  if (showSortIndicator) {
	    children.push(_react2.default.createElement(_SortIndicator2.default, {
	      key: 'SortIndicator',
	      sortDirection: sortDirection
	    }));
	  }
	
	  return children;
	}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = defaultRowRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default row renderer for FlexTable.
	 */
	function defaultRowRenderer(_ref) {
	  var className = _ref.className;
	  var columns = _ref.columns;
	  var index = _ref.index;
	  var isScrolling = _ref.isScrolling;
	  var onRowClick = _ref.onRowClick;
	  var onRowDoubleClick = _ref.onRowDoubleClick;
	  var onRowMouseOver = _ref.onRowMouseOver;
	  var onRowMouseOut = _ref.onRowMouseOut;
	  var rowData = _ref.rowData;
	  var style = _ref.style;
	
	  var a11yProps = {};
	
	  if (onRowClick || onRowDoubleClick || onRowMouseOver || onRowMouseOut) {
	    a11yProps['aria-label'] = 'row';
	    a11yProps.role = 'row';
	    a11yProps.tabIndex = 0;
	
	    if (onRowClick) {
	      a11yProps.onClick = function () {
	        return onRowClick({ index: index });
	      };
	    }
	    if (onRowDoubleClick) {
	      a11yProps.onDoubleClick = function () {
	        return onRowDoubleClick({ index: index });
	      };
	    }
	    if (onRowMouseOut) {
	      a11yProps.onMouseOut = function () {
	        return onRowMouseOut({ index: index });
	      };
	    }
	    if (onRowMouseOver) {
	      a11yProps.onMouseOver = function () {
	        return onRowMouseOver({ index: index });
	      };
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, a11yProps, {
	      className: className,
	      style: style
	    }),
	    columns
	  );
	}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = defaultCellRangeRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default implementation of cellRangeRenderer used by Grid.
	 * This renderer supports cell-caching while the user is scrolling.
	 */
	function defaultCellRangeRenderer(_ref) {
	  var cellCache = _ref.cellCache;
	  var cellClassName = _ref.cellClassName;
	  var cellRenderer = _ref.cellRenderer;
	  var cellStyle = _ref.cellStyle;
	  var columnSizeAndPositionManager = _ref.columnSizeAndPositionManager;
	  var columnStartIndex = _ref.columnStartIndex;
	  var columnStopIndex = _ref.columnStopIndex;
	  var horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment;
	  var isScrolling = _ref.isScrolling;
	  var rowSizeAndPositionManager = _ref.rowSizeAndPositionManager;
	  var rowStartIndex = _ref.rowStartIndex;
	  var rowStopIndex = _ref.rowStopIndex;
	  var scrollLeft = _ref.scrollLeft;
	  var scrollTop = _ref.scrollTop;
	  var verticalOffsetAdjustment = _ref.verticalOffsetAdjustment;
	
	  var renderedCells = [];
	
	  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
	
	    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
	      var key = rowIndex + '-' + columnIndex;
	      var cellStyleObject = cellStyle({ rowIndex: rowIndex, columnIndex: columnIndex });
	      var renderedCell = void 0;
	
	      // Avoid re-creating cells while scrolling.
	      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	      // If a scroll is in progress- cache and reuse cells.
	      // This cache will be thrown away once scrolling complets.
	      if (isScrolling) {
	        if (!cellCache[key]) {
	          cellCache[key] = cellRenderer({
	            columnIndex: columnIndex,
	            isScrolling: isScrolling,
	            rowIndex: rowIndex
	          });
	        }
	        renderedCell = cellCache[key];
	        // If the user is no longer scrolling, don't cache cells.
	        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
	      } else {
	        renderedCell = cellRenderer({
	          columnIndex: columnIndex,
	          isScrolling: isScrolling,
	          rowIndex: rowIndex
	        });
	      }
	
	      if (renderedCell == null || renderedCell === false) {
	        continue;
	      }
	
	      var className = cellClassName({ columnIndex: columnIndex, rowIndex: rowIndex });
	
	      var child = _react2.default.createElement(
	        'div',
	        {
	          key: key,
	          className: (0, _classnames2.default)('Grid__cell', className),
	          style: _extends({
	            height: rowDatum.size,
	            left: columnDatum.offset + horizontalOffsetAdjustment,
	            top: rowDatum.offset + verticalOffsetAdjustment,
	            width: columnDatum.size
	          }, cellStyleObject)
	        },
	        renderedCell
	      );
	
	      renderedCells.push(child);
	    }
	  }
	
	  return renderedCells;
	}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerScrollListener = registerScrollListener;
	exports.unregisterScrollListener = unregisterScrollListener;
	var mountedInstances = [];
	var originalBodyPointerEvents = null;
	var disablePointerEventsTimeoutId = null;
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = exports.IS_SCROLLING_TIMEOUT = 150;
	
	function enablePointerEventsIfDisabled() {
	  if (disablePointerEventsTimeoutId) {
	    disablePointerEventsTimeoutId = null;
	
	    document.body.style.pointerEvents = originalBodyPointerEvents;
	
	    originalBodyPointerEvents = null;
	  }
	}
	
	function enablePointerEventsAfterDelayCallback() {
	  enablePointerEventsIfDisabled();
	  mountedInstances.forEach(function (component) {
	    return component._enablePointerEventsAfterDelayCallback();
	  });
	}
	
	function enablePointerEventsAfterDelay() {
	  if (disablePointerEventsTimeoutId) {
	    clearTimeout(disablePointerEventsTimeoutId);
	  }
	
	  disablePointerEventsTimeoutId = setTimeout(enablePointerEventsAfterDelayCallback, IS_SCROLLING_TIMEOUT);
	}
	
	function onScrollWindow(event) {
	  if (originalBodyPointerEvents == null) {
	    originalBodyPointerEvents = document.body.style.pointerEvents;
	
	    document.body.style.pointerEvents = 'none';
	
	    enablePointerEventsAfterDelay();
	  }
	  mountedInstances.forEach(function (component) {
	    return component._onScrollWindow(event);
	  });
	}
	
	function registerScrollListener(component) {
	  if (!mountedInstances.length) {
	    window.addEventListener('scroll', onScrollWindow);
	  }
	  mountedInstances.push(component);
	}
	
	function unregisterScrollListener(component) {
	  mountedInstances = mountedInstances.filter(function (c) {
	    return c !== component;
	  });
	  if (!mountedInstances.length) {
	    window.removeEventListener('scroll', onScrollWindow);
	    if (disablePointerEventsTimeoutId) {
	      clearTimeout(disablePointerEventsTimeoutId);
	      enablePointerEventsIfDisabled();
	    }
	  }
	}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(2135);
	
	var size;
	
	module.exports = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(256),
	    _assign = __webpack_require__(36);
	
	var ReactNoopUpdateQueue = __webpack_require__(898);
	
	var canDefineProperty = __webpack_require__(899);
	var emptyObject = __webpack_require__(307);
	var invariant = __webpack_require__(21);
	var lowPriorityWarning = __webpack_require__(2146);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(256);
	
	var ReactCurrentOwner = __webpack_require__(123);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(35);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(35);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function pageHref(num) {
	    return "#page-" + (num + 1);
	}
	
	var tr = {
	    of: {
	        nl: "van",
	        fr: "de",
	        de: "von",
	        en: "of"
	    }
	};
	
	var BtnPaginator = (function (_React$Component) {
	    _inherits(BtnPaginator, _React$Component);
	
	    function BtnPaginator(props) {
	        _classCallCheck(this, BtnPaginator);
	
	        _get(Object.getPrototypeOf(BtnPaginator.prototype), "constructor", this).call(this, props);
	        this.handlePrevious = this.handlePrevious.bind(this);
	        this.handleNext = this.handleNext.bind(this);
	    }
	
	    _createClass(BtnPaginator, [{
	        key: "handlePrevious",
	        value: function handlePrevious(e) {
	            e.preventDefault();
	            this.props.onPageChange(this.props.currentPage - 1);
	        }
	    }, {
	        key: "handleNext",
	        value: function handleNext(e) {
	            e.preventDefault();
	            this.props.onPageChange(this.props.currentPage + 1);
	        }
	    }, {
	        key: "renderPrevious",
	        value: function renderPrevious() {
	            var currentPage = this.props.currentPage;
	
	            var canPage = currentPage > 0;
	            return _react2["default"].createElement("button", { className: "reactable-previous-page " + (canPage ? "" : "disabled"),
	                href: pageHref(this.props.currentPage - 1),
	                onClick: canPage && this.handlePrevious });
	        }
	    }, {
	        key: "renderNext",
	        value: function renderNext() {
	            var _props = this.props;
	            var currentPage = _props.currentPage;
	            var numPages = _props.numPages;
	
	            var canPage = currentPage + 1 !== numPages;
	            return _react2["default"].createElement("button", { className: "reactable-next-page " + (canPage ? "" : "disabled"),
	                href: pageHref(this.props.currentPage + 1),
	                onClick: canPage && this.handleNext });
	        }
	    }, {
	        key: "calcRange",
	        value: function calcRange() {
	            var _props2 = this.props;
	            var currentPage = _props2.currentPage;
	            var itemsNumber = _props2.itemsNumber;
	            var itemsPerPage = _props2.itemsPerPage;
	
	            var fromVal = currentPage === -1 ? 0 : currentPage * itemsPerPage + 1;
	            var toValTmp = (currentPage + 1) * itemsPerPage;
	            var toVal = toValTmp < itemsNumber ? toValTmp : itemsNumber;
	            return fromVal + " - " + toVal;
	        }
	    }, {
	        key: "renderCounter",
	        value: function renderCounter() {
	            var _props3 = this.props;
	            var itemsNumber = _props3.itemsNumber;
	            var locale = _props3.locale;
	
	            return _react2["default"].createElement(
	                "div",
	                { className: "counter" },
	                _react2["default"].createElement(
	                    "span",
	                    null,
	                    this.calcRange(),
	                    " ",
	                    tr.of[locale],
	                    " ",
	                    itemsNumber
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	
	            if (typeof this.props.currentPage === 'undefined') {
	                throw new TypeError('Must pass a currentPage argument to Paginator');
	            }
	            return _react2["default"].createElement(
	                "div",
	                { className: "reactable-pagesSwitcher" },
	                this.renderCounter(),
	                _react2["default"].createElement(
	                    "div",
	                    { className: "reactable-pageBtns" },
	                    this.renderPrevious(),
	                    this.renderNext()
	                )
	            );
	        }
	    }]);
	
	    return BtnPaginator;
	})(_react2["default"].Component);
	
	exports.BtnPaginator = BtnPaginator;
	;


/***/ }),
/* 901 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.stringable = stringable;
	
	function stringable(thing) {
	    return thing !== null && typeof thing !== 'undefined' && typeof (thing.toString === 'function');
	}


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _libIs_react_component = __webpack_require__(2153);
	
	var _libStringable = __webpack_require__(901);
	
	var _unsafe = __webpack_require__(347);
	
	var Td = (function (_React$Component) {
	    _inherits(Td, _React$Component);
	
	    function Td() {
	        _classCallCheck(this, Td);
	
	        _get(Object.getPrototypeOf(Td.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Td, [{
	        key: 'handleClick',
	        value: function handleClick(e) {
	            if (typeof this.props.handleClick === 'function') {
	                return this.props.handleClick(e, this);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var tdProps = {
	                className: this.props.className,
	                onClick: this.handleClick.bind(this)
	            };
	
	            if (typeof this.props.style !== 'undefined') {
	                tdProps.style = this.props.style;
	            }
	
	            // Attach any properties on the column to this Td object to allow things like custom event handlers
	            if (typeof this.props.column === 'object') {
	                for (var key in this.props.column.props) {
	                    tdProps[key] = this.props.column[key];
	                }
	            }
	
	            var data = this.props.data;
	
	            if (typeof this.props.children !== 'undefined') {
	                if ((0, _libIs_react_component.isReactComponent)(this.props.children)) {
	                    data = this.props.children;
	                } else if (typeof this.props.data === 'undefined' && (0, _libStringable.stringable)(this.props.children)) {
	                    data = this.props.children.toString();
	                }
	
	                if ((0, _unsafe.isUnsafe)(this.props.children)) {
	                    tdProps.dangerouslySetInnerHTML = { __html: this.props.children.toString() };
	                } else {
	                    tdProps.children = data;
	                }
	            }
	
	            return _react2['default'].createElement('td', tdProps);
	        }
	    }]);
	
	    return Td;
	})(_react2['default'].Component);
	
	exports.Td = Td;
	;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Tfoot = (function (_React$Component) {
	    _inherits(Tfoot, _React$Component);
	
	    function Tfoot() {
	        _classCallCheck(this, Tfoot);
	
	        _get(Object.getPrototypeOf(Tfoot.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Tfoot, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement('tfoot', this.props);
	        }
	    }]);
	
	    return Tfoot;
	})(_react2['default'].Component);
	
	exports.Tfoot = Tfoot;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _th = __webpack_require__(499);
	
	var _filterer = __webpack_require__(2151);
	
	var _libFilter_props_from = __webpack_require__(346);
	
	var _btnPaginator = __webpack_require__(900);
	
	var Thead = (function (_React$Component) {
	    _inherits(Thead, _React$Component);
	
	    function Thead() {
	        _classCallCheck(this, Thead);
	
	        _get(Object.getPrototypeOf(Thead.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Thead, [{
	        key: 'handleClickTh',
	        value: function handleClickTh(column) {
	            this.props.onSort(column.key);
	        }
	    }, {
	        key: 'handleKeyDownTh',
	        value: function handleKeyDownTh(column, event) {
	            if (event.keyCode === 13) {
	                this.props.onSort(column.key);
	            }
	        }
	    }, {
	        key: 'scrollIntoView',
	        value: function scrollIntoView() {
	            if (this.domEl && this.domEl.offsetParent === null) {
	                this.domEl.scrollIntoView();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var sort = _props.sort;
	            var sortableColumns = _props.sortableColumns;
	            var filtering = _props.filtering;
	            var columns = _props.columns;
	            var onFilter = _props.onFilter;
	            var onClean = _props.onClean;
	            var filterPlaceholder = _props.filterPlaceholder;
	            var currentFilter = _props.currentFilter;
	            var topPagination = _props.topPagination;
	            var middlePagination = _props.middlePagination;
	            var filterCleanBtn = _props.filterCleanBtn;
	            var locale = _props.locale;
	            var itemsPerPage = _props.itemsPerPage;
	            var itemsNumber = _props.itemsNumber;
	            var numPages = _props.numPages;
	            var currentPage = _props.currentPage;
	            var onPageChange = _props.onPageChange;
	            var topPaginationElem = _props.topPaginationElem;
	            var middlePaginationElem = _props.middlePaginationElem;
	
	            // Declare the list of Ths
	            var Ths = [];
	            for (var index = 0; index < columns.length; index++) {
	                var column = columns[index];
	                var thClass = 'reactable-th-' + column.key.replace(/\s+/g, '-').toLowerCase();
	                var sortClass = '';
	
	                if (sortableColumns[column.key]) {
	                    sortClass += 'reactable-header-sortable ';
	                }
	
	                if (sort.column === column.key) {
	                    sortClass += 'reactable-header-sort';
	                    if (sort.direction === 1) {
	                        sortClass += '-asc';
	                    } else {
	                        sortClass += '-desc';
	                    }
	                }
	
	                if (sortClass.length > 0) {
	                    thClass += ' ' + sortClass;
	                }
	
	                if (typeof column.props === 'object' && typeof column.props.className === 'string') {
	                    thClass += ' ' + column.props.className;
	                }
	
	                Ths.push(_react2['default'].createElement(
	                    _th.Th,
	                    _extends({}, column.props, {
	                        className: thClass,
	                        key: index,
	                        onClick: this.handleClickTh.bind(this, column),
	                        onKeyDown: this.handleKeyDownTh.bind(this, column),
	                        role: 'button',
	                        tabIndex: '0' }),
	                    column.label
	                ));
	            }
	
	            // Manually transfer props
	            var props = (0, _libFilter_props_from.filterPropsFrom)(this.props);
	            return _react2['default'].createElement(
	                'thead',
	                _extends({}, props, { ref: function ref(el) {
	                        return _this.domEl = el;
	                    } }),
	                !topPagination && filtering && _react2['default'].createElement(_filterer.Filterer, {
	                    colSpan: columns.length,
	                    onFilter: onFilter,
	                    placeholder: filterPlaceholder,
	                    value: currentFilter
	                }),
	                topPagination ? _react2['default'].createElement(
	                    'tr',
	                    { className: 'reactable-btnPagination' },
	                    _react2['default'].createElement(
	                        'td',
	                        { colSpan: columns.length },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'reactable-topDesign' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'reactable-leftElem' },
	                                topPaginationElem.left
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: filtering ? 'reactable-mainElem' : 'reactable-mainElem no-filter' },
	                                filtering && _react2['default'].createElement(_filterer.FiltererInput, {
	                                    filterCleanBtn: filterCleanBtn,
	                                    onClean: onClean,
	                                    onFilter: onFilter,
	                                    placeholder: filterPlaceholder,
	                                    value: currentFilter
	                                }),
	                                _react2['default'].createElement(_btnPaginator.BtnPaginator, {
	                                    locale: locale,
	                                    itemsPerPage: itemsPerPage,
	                                    itemsNumber: itemsNumber,
	                                    numPages: numPages,
	                                    currentPage: currentPage,
	                                    onPageChange: onPageChange,
	                                    key: 'paginator'
	                                })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'reactable-rightElem' },
	                                topPaginationElem.right
	                            )
	                        )
	                    )
	                ) : null,
	                middlePagination ? _react2['default'].createElement(
	                    'tr',
	                    { className: 'reactable-btnPagination' },
	                    _react2['default'].createElement(
	                        'td',
	                        { colSpan: columns.length },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'reactable-topDesign' },
	                            middlePaginationElem
	                        )
	                    )
	                ) : null,
	                _react2['default'].createElement(
	                    'tr',
	                    { className: 'reactable-column-header' },
	                    Ths
	                )
	            );
	        }
	    }], [{
	        key: 'getColumns',
	        value: function getColumns(component) {
	            // Can't use React.Children.map since that doesn't return a proper array
	            var columns = [];
	            _react2['default'].Children.forEach(component.props.children, function (th) {
	                var column = {};
	                if (typeof th.props !== 'undefined') {
	                    column.props = (0, _libFilter_props_from.filterPropsFrom)(th.props);
	
	                    //set the label depending on the props
	                    if (typeof th.props.label !== 'undefined') {
	                        column.label = th.props.label;
	                    } else if (typeof th.props.children !== 'undefined') {
	                        column.label = th.props.children;
	                    } else if (typeof th.props.column === 'string') {
	                        column.label = th.props.column;
	                    }
	
	                    // the key in the column attribute supersedes the one defined previously
	                    if (typeof th.props.column === 'string') {
	                        column.key = th.props.column;
	                    } else {
	                        // use the content as the key
	                        column.key = th.props.children;
	                    }
	                }
	
	                if (typeof column.key === 'undefined') {
	                    throw new TypeError('<th> must have either a "column" property or a string ' + 'child');
	                } else {
	                    columns.push(column);
	                }
	            });
	
	            return columns;
	        }
	    }]);
	
	    return Thead;
	})(_react2['default'].Component);
	
	exports.Thead = Thead;
	;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _td = __webpack_require__(902);
	
	var _libTo_array = __webpack_require__(2154);
	
	var _libFilter_props_from = __webpack_require__(346);
	
	var Tr = (function (_React$Component) {
	    _inherits(Tr, _React$Component);
	
	    function Tr() {
	        _classCallCheck(this, Tr);
	
	        _get(Object.getPrototypeOf(Tr.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Tr, [{
	        key: 'render',
	        value: function render() {
	            var children = (0, _libTo_array.toArray)(_react2['default'].Children.children(this.props.children));
	
	            if (this.props.data && this.props.columns && typeof this.props.columns.map === 'function') {
	                if (typeof children.concat === 'undefined') {
	                    console.log(children);
	                }
	
	                children = children.concat(this.props.columns.map((function (column, i) {
	                    if (this.props.data.hasOwnProperty(column.key)) {
	                        var value = this.props.data[column.key];
	                        var props = {};
	
	                        if (typeof value !== 'undefined' && value !== null && value.__reactableMeta === true) {
	                            props = value.props;
	                            value = value.value;
	                        }
	
	                        return _react2['default'].createElement(
	                            _td.Td,
	                            _extends({ column: column, key: column.key }, props),
	                            value
	                        );
	                    } else {
	                        return _react2['default'].createElement(_td.Td, { column: column, key: column.key });
	                    }
	                }).bind(this)));
	            }
	
	            // Manually transfer props
	            var props = (0, _libFilter_props_from.filterPropsFrom)(this.props);
	
	            return _react2['default'].DOM.tr(props, children);
	        }
	    }]);
	
	    return Tr;
	})(_react2['default'].Component);
	
	exports.Tr = Tr;
	;
	
	Tr.childNode = _td.Td;
	Tr.dataType = 'object';


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(332);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(732);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(435).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(909);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(352).Buffer;
	var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(242));
	util.inherits = __webpack_require__(198);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(2333);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(2166);
	var destroyImpl = __webpack_require__(908);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(167);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(948).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(167);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(948).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', state.awaitDrain);
	        state.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, { hasUnpiped: false });
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(103)))

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(167);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(242));
	util.inherits = __webpack_require__(198);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(332);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err) {
	      if (!this._writableState) {
	        pna.nextTick(emitErrorNT, this, err);
	      } else if (!this._writableState.errorEmitted) {
	        this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, this, err);
	      }
	    }
	
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      if (!_this._writableState) {
	        pna.nextTick(emitErrorNT, _this, err);
	      } else if (!_this._writableState.errorEmitted) {
	        _this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, _this, err);
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finalCalled = false;
	    this._writableState.prefinished = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(435).EventEmitter;


/***/ }),
/* 910 */
[2335, 258, 502],
/* 911 */
712,
/* 912 */
[2343, 258],
/* 913 */
729,
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(170);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededError = 'QuotaExceededError';
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (error.name === QuotaExceededError && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(349);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(259);
	
	var _DOMUtils = __webpack_require__(348);
	
	var _createHistory = __webpack_require__(916);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	//import warning from 'warning'
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deepEqual = __webpack_require__(2171);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _AsyncUtils = __webpack_require__(2182);
	
	var _Actions = __webpack_require__(215);
	
	var _createLocation2 = __webpack_require__(917);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(508);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _parsePath = __webpack_require__(169);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(168);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var keyLength = options.keyLength;
	  var getUserConfirmation = options.getUserConfirmation;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	      //warning(
	      //  false,
	      //  'The state (2nd) argument to history.createLocation is deprecated; use a ' +
	      //  'location descriptor instead'
	      //)
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _parsePath2['default'](path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _parsePath2['default'](path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	//import warning from 'warning'
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Actions = __webpack_require__(215);
	
	var _parsePath = __webpack_require__(169);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _parsePath2['default'](location);
	
	  if (typeof action === 'object') {
	    //warning(
	    //  false,
	    //  'The state (2nd) argument to createLocation is deprecated; use a ' +
	    //  'location descriptor instead'
	    //)
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 918 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	exports["default"] = extractPath;
	module.exports = exports["default"];

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(170);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(259);
	
	var _DOMUtils = __webpack_require__(348);
	
	var _deprecate = __webpack_require__(168);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
	  function listener(event) {
	    var message = getBeforeUnloadPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	  }
	
	  _DOMUtils.addEventListener(window, 'beforeunload', listener);
	
	  return function () {
	    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
	  };
	}
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	function useBeforeUnload(createHistory) {
	  return function (options) {
	    var history = createHistory(options);
	
	    var stopBeforeUnloadListener = undefined;
	    var beforeUnloadHooks = [];
	
	    function getBeforeUnloadPromptMessage() {
	      var message = undefined;
	
	      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
	        message = beforeUnloadHooks[i].call();
	      }return message;
	    }
	
	    function listenBeforeUnload(hook) {
	      beforeUnloadHooks.push(hook);
	
	      if (beforeUnloadHooks.length === 1) {
	        if (_ExecutionEnvironment.canUseDOM) {
	          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	        } else {
	           false ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
	        }
	      }
	
	      return function () {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
	          stopBeforeUnloadListener();
	          stopBeforeUnloadListener = null;
	        }
	      };
	    }
	
	    // deprecated
	    function registerBeforeUnloadHook(hook) {
	      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
	        beforeUnloadHooks.push(hook);
	
	        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	      }
	    }
	
	    // deprecated
	    function unregisterBeforeUnloadHook(hook) {
	      if (beforeUnloadHooks.length > 0) {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
	      }
	    }
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload,
	
	      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
	      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
	    });
	  };
	}
	
	exports['default'] = useBeforeUnload;
	module.exports = exports['default'];

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _warning = __webpack_require__(170);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(2196);
	
	var _runTransitionHook = __webpack_require__(508);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _parsePath = __webpack_require__(169);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(168);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    var historyOptions = _objectWithoutProperties(options, ['stringifyQuery', 'parseQueryString']);
	
	    var history = createHistory(historyOptions);
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var queryString = undefined;
	      if (!query || (queryString = stringifyQuery(query)) === '') return location;
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase + (searchBase ? '&' : '?') + queryString;
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	      //warning(
	      //  !query,
	      //  'the query argument to createPath is deprecated; use a location descriptor instead'
	      //)
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	      //warning(
	      //  !query,
	      //  'the query argument to createHref is deprecated; use a location descriptor instead'
	      //)
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation() {
	      return addQuery(history.createLocation.apply(history, arguments));
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 921 */
823,
/* 922 */
[2352, 921],
/* 923 */
[2355, 924, 2195],
/* 924 */
826,
/* 925 */
[2357, 2200, 214],
/* 926 */
[2359, 925, 257],
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;
	
	var _actionTypes = __webpack_require__(509);
	
	var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
	  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
	};
	
	var autofill = exports.autofill = function autofill(field, value) {
	  return { type: _actionTypes.AUTOFILL, field: field, value: value };
	};
	
	var blur = exports.blur = function blur(field, value) {
	  return { type: _actionTypes.BLUR, field: field, value: value };
	};
	
	var change = exports.change = function change(field, value) {
	  return { type: _actionTypes.CHANGE, field: field, value: value };
	};
	
	var destroy = exports.destroy = function destroy() {
	  return { type: _actionTypes.DESTROY };
	};
	
	var focus = exports.focus = function focus(field) {
	  return { type: _actionTypes.FOCUS, field: field };
	};
	
	var initialize = exports.initialize = function initialize(data, fields) {
	  var overwriteValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!Array.isArray(fields)) {
	    throw new Error('must provide fields array to initialize() action creator');
	  }
	  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
	};
	
	var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, index) {
	  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index };
	};
	
	var reset = exports.reset = function reset() {
	  return { type: _actionTypes.RESET };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit() {
	  return { type: _actionTypes.START_SUBMIT };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
	  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
	  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
	};
	
	var submitFailed = exports.submitFailed = function submitFailed() {
	  return { type: _actionTypes.SUBMIT_FAILED };
	};
	
	var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
	  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
	};
	
	var touch = exports.touch = function touch() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.TOUCH, fields: fields };
	};
	
	var untouch = exports.untouch = function untouch() {
	  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    fields[_key2] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.UNTOUCH, fields: fields };
	};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = bindActionData;
	
	var _mapValues = __webpack_require__(510);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds additional properties to the results of the function or map of functions passed
	 */
	function bindActionData(action, data) {
	  if (typeof action === 'function') {
	    return function () {
	      return _extends({}, action.apply(undefined, arguments), data);
	    };
	  }
	  if (typeof action === 'object') {
	    return (0, _mapValues2.default)(action, function (value) {
	      return bindActionData(value, data);
	    });
	  }
	  return action;
	}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(511);
	
	var _initializeState = __webpack_require__(937);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createInitialState = function createInitialState(data, fields, state) {
	  var _extends2;
	
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var markInitialized = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
	    _asyncValidating: false,
	    _active: undefined
	  }, _extends2[_reducer.globalErrorKey] = undefined, _extends2._initialized = markInitialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	};
	
	exports.default = createInitialState;

/***/ }),
/* 930 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var dataKey = exports.dataKey = 'value';
	var createOnDragStart = function createOnDragStart(name, getValue) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, getValue());
	  };
	};
	
	exports.default = createOnDragStart;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(932);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'radio') {
	      return checked ? value : '';
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    if (value !== '' && (type === 'number' || type === 'range')) {
	      return parseFloat(value);
	    }
	    return value;
	  }
	  // not an event, so must be either our value or an object containing our value in the 'value' key
	  return event && typeof event === 'object' && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
	  event;
	};
	
	exports.default = getValue;

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(932);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ }),
/* 934 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDisplayName;
	function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Given a state[field], get the value.
	 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
	 *  See {@link https://github.com/erikras/redux-form/issues/621}.
	 */
	var itemToValue = function itemToValue(_ref) {
	  var value = _ref.value,
	      initialValue = _ref.initialValue;
	  return typeof value !== 'undefined' ? value : initialValue;
	};
	
	var getValue = function getValue(field, state, dest) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = field.substring(0, openIndex);
	    var rest = field.substring(closeIndex + 1);
	    if (rest[0] === '.') {
	      rest = rest.substring(1);
	    }
	    var array = state && state[key] || [];
	    if (rest) {
	      if (!dest[key]) {
	        dest[key] = [];
	      }
	      array.forEach(function (item, index) {
	        if (!dest[key][index]) {
	          dest[key][index] = {};
	        }
	        getValue(rest, item, dest[key][index]);
	      });
	    } else {
	      dest[key] = array.map(itemToValue);
	    }
	  } else if (dotIndex > 0) {
	    // subobject field
	    var _key = field.substring(0, dotIndex);
	    var _rest = field.substring(dotIndex + 1);
	    if (!dest[_key]) {
	      dest[_key] = {};
	    }
	    getValue(_rest, state && state[_key] || {}, dest[_key]);
	  } else {
	    dest[field] = state[field] && itemToValue(state[field]);
	  }
	};
	
	var getValues = function getValues(fields, state) {
	  return fields.reduce(function (accumulator, field) {
	    getValue(field, state, accumulator);
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValues;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(216);
	
	/**
	 * A different version of getValues() that does not need the fields array
	 */
	var getValuesFromState = function getValuesFromState(state) {
	  if (!state) {
	    return state;
	  }
	  var keys = Object.keys(state);
	  if (!keys.length) {
	    return undefined;
	  }
	  return keys.reduce(function (accumulator, key) {
	    var field = state[key];
	    if (field) {
	      if ((0, _fieldValue.isFieldValue)(field)) {
	        if (field.value !== undefined) {
	          accumulator[key] = field.value;
	        }
	      } else if (Array.isArray(field)) {
	        accumulator[key] = field.map(function (arrayField) {
	          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
	        });
	      } else if (typeof field === 'object') {
	        var result = getValuesFromState(field);
	
	        if (result && Object.keys(result).length > 0) {
	          accumulator[key] = result;
	        }
	      }
	    }
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValuesFromState;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(216);
	
	var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
	  if (value === undefined && previousValue === undefined) return (0, _fieldValue.makeFieldValue)({});
	  return (0, _fieldValue.makeFieldValue)({
	    initial: value,
	    value: overwriteValues ? value : previousValue
	  });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var initializeState = function initializeState(values, fields) {
	  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  if (!fields) {
	    throw new Error('fields must be passed when initializing state');
	  }
	  if (!values || !fields.length) {
	    return state;
	  }
	  var initializeField = function initializeField(path, src, dest) {
	    var dotIndex = path.indexOf('.');
	    if (dotIndex === 0) {
	      return initializeField(path.substring(1), src, dest);
	    }
	    var openIndex = path.indexOf('[');
	    var closeIndex = path.indexOf(']');
	    var result = _extends({}, dest) || {};
	    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	      // is dot notation
	      var key = path.substring(0, dotIndex);
	      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
	    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	      // is array notation
	      if (closeIndex < 0) {
	        throw new Error('found \'[\' but no \']\': \'' + path + '\'');
	      }
	      var _key = path.substring(0, openIndex);
	      var srcArray = src[_key];
	      var destArray = result[_key];
	      var rest = path.substring(closeIndex + 1);
	      if (Array.isArray(srcArray)) {
	        if (rest.length) {
	          // need to keep recursing
	          result[_key] = srcArray.map(function (srcValue, srcIndex) {
	            return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
	          });
	        } else {
	          result[_key] = srcArray.map(function (srcValue, srcIndex) {
	            return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
	          });
	        }
	      } else {
	        result[_key] = [];
	      }
	    } else {
	      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
	    }
	    return result;
	  };
	  return fields.reduce(function (accumulator, field) {
	    return initializeField(field, values, accumulator);
	  }, _extends({}, state));
	};
	
	exports.default = initializeState;

/***/ }),
/* 938 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isChecked = function isChecked(value) {
	  if (typeof value === 'boolean') {
	    return value;
	  }
	  if (typeof value === 'string') {
	    var lower = value.toLowerCase();
	    if (lower === 'true') {
	      return true;
	    }
	    if (lower === 'false') {
	      return false;
	    }
	  }
	  return undefined;
	};
	
	exports.default = isChecked;

/***/ }),
/* 939 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Reads any potentially deep value from an object using dot and array syntax
	 */
	var read = function read(path, object) {
	  if (!path || !object) {
	    return object;
	  }
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return read(path.substring(1), object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    // iterate down object tree
	    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    if (!index.length) {
	      return object[key];
	    }
	    if (openIndex === 0) {
	      return read(path.substring(closeIndex + 1), object[index]);
	    }
	    if (!object[key]) {
	      return undefined;
	    }
	    return read(path.substring(closeIndex + 1), object[key][index]);
	  }
	  return object[path];
	};
	
	exports.default = read;

/***/ }),
/* 940 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Writes any potentially deep value from an object using dot and array syntax,
	 * and returns a new copy of the object.
	 */
	var write = function write(path, value, object) {
	  var _extends7;
	
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return write(path.substring(1), value, object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    var _extends2;
	
	    // is dot notation
	    var key = path.substring(0, dotIndex);
	    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _extends6;
	
	    // is array notation
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var _key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    var array = object[_key] || [];
	    var rest = path.substring(closeIndex + 1);
	    if (index) {
	      var _extends4;
	
	      // indexed array
	      if (rest.length) {
	        var _extends3;
	
	        // need to keep recursing
	        var dest = array[index] || {};
	        var arrayCopy = [].concat(array);
	        arrayCopy[index] = write(rest, value, dest);
	        return _extends({}, object || {}, (_extends3 = {}, _extends3[_key] = arrayCopy, _extends3));
	      }
	      var copy = [].concat(array);
	      copy[index] = typeof value === 'function' ? value(copy[index]) : value;
	      return _extends({}, object || {}, (_extends4 = {}, _extends4[_key] = copy, _extends4));
	    }
	    // indexless array
	    if (rest.length) {
	      var _extends5;
	
	      // need to keep recursing
	      if ((!array || !array.length) && typeof value === 'function') {
	        return object; // don't even set a value under [key]
	      }
	      var _arrayCopy = array.map(function (dest) {
	        return write(rest, value, dest);
	      });
	      return _extends({}, object || {}, (_extends5 = {}, _extends5[_key] = _arrayCopy, _extends5));
	    }
	    var result = void 0;
	    if (Array.isArray(value)) {
	      result = value;
	    } else if (object[_key]) {
	      result = array.map(function (dest) {
	        return typeof value === 'function' ? value(dest) : value;
	      });
	    } else if (typeof value === 'function') {
	      return object; // don't even set a value under [key]
	    } else {
	      result = value;
	    }
	    return _extends({}, object || {}, (_extends6 = {}, _extends6[_key] = result, _extends6));
	  }
	  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
	};
	
	exports.default = write;

/***/ }),
/* 941 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),
/* 942 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(120);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2234);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var runtime = (function (exports) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }
	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function(obj, key, value) {
	      return obj[key] = value;
	    };
	  }
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });
	
	    return generator;
	  }
	  exports.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = GeneratorFunctionPrototype;
	  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
	  defineProperty(
	    GeneratorFunctionPrototype,
	    "constructor",
	    { value: GeneratorFunction, configurable: true }
	  );
	  GeneratorFunction.displayName = define(
	    GeneratorFunctionPrototype,
	    toStringTagSymbol,
	    "GeneratorFunction"
	  );
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      define(prototype, method, function(arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }
	
	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    defineProperty(this, "_invoke", { value: enqueue });
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  });
	  exports.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );
	
	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per GeneratorResume behavior specified since ES2015:
	        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
	        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var methodName = context.method;
	    var method = delegate.iterator[methodName];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method, or a missing .next method, always terminate the
	      // yield* loop.
	      context.delegate = null;
	
	      // Note: ["return"] must be used for ES3 parsing compatibility.
	      if (methodName === "throw" && delegate.iterator["return"]) {
	        // If the delegate iterator has a return method, give it a
	        // chance to clean up.
	        context.method = "return";
	        context.arg = undefined;
	        maybeInvokeDelegate(delegate, context);
	
	        if (context.method === "throw") {
	          // If maybeInvokeDelegate(context) changed context.method from
	          // "return" to "throw", let that override the TypeError below.
	          return ContinueSentinel;
	        }
	      }
	      if (methodName !== "return") {
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a '" + methodName + "' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  define(Gp, toStringTagSymbol, "Generator");
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  define(Gp, iteratorSymbol, function() {
	    return this;
	  });
	
	  define(Gp, "toString", function() {
	    return "[object Generator]";
	  });
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  exports.keys = function(val) {
	    var object = Object(val);
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable != null) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    throw new TypeError(typeof iterable + " is not iterable");
	  }
	  exports.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	
	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;
	
	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	   true ? module.exports : {}
	));
	
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, in modern engines
	  // we can explicitly access globalThis. In older engines we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}


/***/ }),
/* 946 */
[2357, 2239, 195],
/* 947 */
[2359, 946, 243],
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(352).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGZpbGw9IiNBRUIyQjQiIGQ9Ik0yMi4yNDUsNC4wMTVjMC4zMTMsMC4zMTMsMC4zMTMsMC44MjYsMCwxLjEzOWwtNi4yNzYsNi4yN2MtMC4zMTMsMC4zMTItMC4zMTMsMC44MjYsMCwxLjE0bDYuMjczLDYuMjcyICBjMC4zMTMsMC4zMTMsMC4zMTMsMC44MjYsMCwxLjE0bC0yLjI4NSwyLjI3N2MtMC4zMTQsMC4zMTItMC44MjgsMC4zMTItMS4xNDIsMGwtNi4yNzEtNi4yNzFjLTAuMzEzLTAuMzEzLTAuODI4LTAuMzEzLTEuMTQxLDAgIGwtNi4yNzYsNi4yNjdjLTAuMzEzLDAuMzEzLTAuODI4LDAuMzEzLTEuMTQxLDBsLTIuMjgyLTIuMjhjLTAuMzEzLTAuMzEzLTAuMzEzLTAuODI2LDAtMS4xNGw2LjI3OC02LjI2OSAgYzAuMzEzLTAuMzEyLDAuMzEzLTAuODI2LDAtMS4xNEwxLjcwOSw1LjE0N2MtMC4zMTQtMC4zMTMtMC4zMTQtMC44MjcsMC0xLjE0bDIuMjg0LTIuMjc4QzQuMzA4LDEuNDE3LDQuODIxLDEuNDE3LDUuMTM1LDEuNzMgIEwxMS40MDUsOGMwLjMxNCwwLjMxNCwwLjgyOCwwLjMxNCwxLjE0MSwwLjAwMWw2LjI3Ni02LjI2N2MwLjMxMi0wLjMxMiwwLjgyNi0wLjMxMiwxLjE0MSwwTDIyLjI0NSw0LjAxNXoiLz48L3N2Zz4K"

/***/ }),
/* 950 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMC8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvVFIvMjAwMS9SRUMtU1ZHLTIwMDEwOTA0L0RURC9zdmcxMC5kdGQnPjxzdmcgaGVpZ2h0PSIzMiIgc3R5bGU9Im92ZXJmbG93OnZpc2libGU7ZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMiAzMiIgdmlld0JveD0iMCAwIDMyIDMyIiB3aWR0aD0iMzIiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxnIGlkPSJFcnJvcl8xXyI+PGcgaWQ9IkVycm9yIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiBpZD0iQkciIHI9IjE2IiBzdHlsZT0iZmlsbDojRDcyODI4OyIvPjxwYXRoIGQ9Ik0xNC41LDI1aDN2LTNoLTNWMjV6IE0xNC41LDZ2MTNoM1Y2SDE0LjV6IiBpZD0iRXhjbGFtYXRvcnlfeDVGX1NpZ24iIHN0eWxlPSJmaWxsOiNFNkU2RTY7Ii8+PC9nPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/icn-checkmark.svg";

/***/ }),
/* 952 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAAAXNSR0IArs4c6QAAAVJJREFUOBFj3Lx3r/TvX3+PMDAyNgW6uyxgZGT8z0AhYPr78z////8MCv///Z+3fseeoxu37Tak0EwGJmQD/v//b/mH4f+Zddt3Tdly+LAgshwpbBRDoRqZgC7P/vnl+811O3YnAi1iJMVAkFpshkLM+M8gSm6Q4DYU6jxygoSgoVCzSQoSYg0lKUhIMxQtSNZv3z0VWyohy1BYkPz7/z8LWyqhxFD0IDkGyziMG7bt0frL8O8q1HZKqX/AVNpPuUuxOIMFixhZQsCC6ATzf4Ysfy+X85QbysjwmvE/Y0Wgh8t8WAlHiaH/mBgZZ7DycNT42Nq+R/YeWYbCverpeh7ZMBibNEOxeBVmEDJNrKE4vYpsGIxN0FCgV48DYzXbH4dXYQYh07gNJdKryIbB2NgMJcmrMIOQaRRDyfEqsmEwNgszO+PHvz8ZnzIyMdRSq4oGAAQTsUOnaQW5AAAAAElFTkSuQmCC"

/***/ }),
/* 953 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABSUlEQVR42u3WvUoEMRAHcBsLGxux8gOEa8/OxjfKZDeTmSx3bndgo4IIYrMIWomNle8h2GilpzYigh9voBNhbrG65pJqB4Yl2eKX/zIsmctRgGHLeK4BqWiaZj4P6gIapBfwvG8c3xpHP+VotJgUNch74Hhs63qp3QuXgHyeNCk4ereOD//tM28D0k1ClMdA1BPkHjyPJokdnxrki5mj1rM3SE/AvBbXZV0vC3YXccBAgn7ogM0UjUnLwWB1stnir/FAiMP15KiW8aE0XiabdnpZUU3aoR3aoVNRi+zk3XN2VH+RHdqh09Cj7GhRVRvxMmaRdnOhejm7so6PjeMHQApZ0IKoL9gbES1IryguXSRDNa3xzLoWvC/gl/SjoknT/t2PMBxI4k95numQJUsrPVRQ+iR+7mSgpo2TLPB3FrBNW22Co2sFc9UvvCtI+87sL/IAAAAASUVORK5CYII="

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAjEAAAIxAHydkeTAAAAB3RJTUUH5wYdDicBTfpUgQAAAgJJREFUSMe1lr9rFEEUxz8zh6Kk0GgRG0vBRkE4rDymMP4IWBjxD7C0MmCjsDubOR4HsbCwy19hQBARosQ5bEQFey0jWEi8RgJhZ21mZd1sztvzfDAwzJv3/TLv+97MQAuz1jpr7VqbmE4bcGAVuGSMOeq935wZQQW8tIlJOi3AfwA5sAf8BBaNMcp7vzUuXo9zZll2L4LvhBCuACNgFOc7wGrcMx2B1vop8AG4PhgM3pfrcX4Z+BhCeMa/mHNOVdK1ba3dbvJNfIIsy+6naXqmAlKMIf/tS5LkdFO6dF3QoigeK6U2nHO6zSm11htFUTyJRbGfoFotIYQ7zrnQgLUUx76ThBDulsJXSVQNfARcFZF30+hlrb0AbAIngEci8lDVmmgEfG+IvSUin2pgZ4HnDXtPAsfivK/5z1am6AGwNuMUORHpdwC892+NMQq4Btzu9XqvhsPh1waA88aYBe/9t7ovSZKuUqoE74tI/48qEhEH9IF5rfX6AU30Io6mMl0H5iO4a+wDEXFKqZUQwvK4BjugTJeVUitV8EmD58ZcFXOtr4qqpWm6lOf5F2vtxSZB8zz/bK29OTUB0AUWgJdJknSrggKvgVNFUZz7a5m2eHAOxeU94Hhd0KleNO/9ljFmF7gBHI7jSFnnM3mTY5/sAoulvpOAt/pVVJrxzaTgAL8AUL/2a/x5misAAAAASUVORK5CYII="

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/a-open_with-green.svg";

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhDAwJNxVs4U9uAAABUUlEQVRIx72VMUvDQBzFf5oQS9LFQUrr6OAXcBARMjsXnJwVFztIJwdB8EN0d3XUuUIHRYfiEsQx9huYdrASl/NySS76L63mhjze3T3ee/9AwPa4nBOT6vXKKTM9x0Rs0dBrlzf2ZxF44KTAXHBrP7qk3j02DXaHZ95z51bZ4CnHvHBkCmxzQMil0OEZd1xxnyfbDMQRB7S/4bImx/hiAZ9xWSAhEAsEJDYHmUBTozp1CxvYHWQRIloKdekq1CIyImgHrjVCDU+hFc151H6L4OGIGnDw7BEQ1hio0wWBCalQwCdlUhaQfwnGDIoC0ggVAonQgTHEooDUQYWANII/b4S5HfxdiQtwIC2xcoz/VOJix+gaG5mDDiOFrvXuiI6tRFMgK7GnuUeNPjRbWWLMuihCk9juoM8ah9zw+cNlhz0a9Ku2Q4ZMjd96eU0ZEppXvgDwrGp/ohU1pwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0xMi0xMlQwOTo1NToyMSswMTowMEJwtFoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMTItMTJUMDk6NTU6MjErMDE6MDAzLQzmAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAyklEQVR42pWSMQvCMBCFI67+rkRBx+LuD9BeRnVwU2d1FHQQ0TFXZ0cXf5HQxj5L7Vkw4sGDcO99l4RERddZyzg6QZE/N9WPQsYwHTTTEazSjm7axf4lpp33vvENhmc43ov8XXWYeprjR9k0bNffBuiENm8YzMV2C4Nt3zhKSzNfL+qwYbsUfgqmNt0O8qkZAoXspPTaTFOxc4bsB1wF7RCh6jo0gmQPGRUqk9BY7iZheEFYHHkOQAo99U/hNcRVVoFo8M23UOhvPAHBW7F8PnLwWgAAAABJRU5ErkJggg=="

/***/ }),
/* 958 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAKCAYAAACqnE5VAAAAZElEQVQ4jWNkQAOemwrt/zL8X8vMwBi83a//ILo8uYCRHpagWERLS+AW0doSBgYGBkaPzUV5//7/a2dkZFz5n+H/Q2pbwPyf8cB2v/6DTNQ2GBegX9DBGHRJDPSwjBFdgFaWAQCCrkUMUoWmLgAAAABJRU5ErkJggg=="

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/autorenew_white.svg";

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/baseline-direct-Sign24px-green.svg";

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/baseline-reply-24px-green.svg";

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/baseline-reply-to-willemot-24px-green.svg";

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/baseline-send-reminder-24px-green.svg";

/***/ }),
/* 964 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAARCAYAAAAlpHdJAAACTElEQVR42r1VOYgUURBtD8RF0MQDN/BABQMxVzPRFQQRAzESAw/4ffy7Z5wRsRcRvBLDVRAMFJnAAyNvEBXEzEy8FlEQUUyMNBjfm+0Zmh2Z6dldtqDo3/2r6tXdQT+SMt0QK7erDEfK7QxmiqT0m4Q0zVDZB6E09/txLntpRsAJGml3pJdMs9mcE5p0JPZ+baPRmAedN0LZ/dMDtnZrKO14lmXze8nhfi4AH7WiNmZ9rNNtAP/ivV80/ahLUqSths6tXPdaqO25gQAj7bewaSJp9vWNujsDC0NlvgnlNyPq5eiBH5Hxe2mvzcL4HcT4T6TmNTz+jPQ9BPBHpeorggFJ6/rK2LmNPMeVyjBsvqS9NjObLI9Q5jl7ZQJYOsWPwSwQQZkhOHI0j9pdFNraYJYI/XBCKHc6IOFwHtFXigIcnVatnFs9VRBjzBB3BZk90QGX9hRsj3aBc3QwKvfy2jzG+SczMygwNyNtAOhtzuMcxZ7gADwjpH3V7nQ8F3BxoCy1ssDOuaWo66/Q+D2dSVImpTPVanVJBzxJ03WI7mYk3ViCUYDAd6Wqq4rGOD4isV9j7beXYRi/APnbXbWW5g7nHxjPWuBCumMQfsH2Bz+FwF9GW1RKarVlUPjDMpRiaT4Ipe9OBkeQZ5HV98jkOwbYtSq5HHB5oPgdXtbh4JPSy0ra3Uxxscl4hmOf+B/osSiOr8kb5SQ3Ehy5zPdBu56rFvwbK/ogSnqINhDE1b6KBEJ6rrAMUBpLsmxxMAViSZHq63DiBhrw8OT7f7YoiTgS6Ps2AAAAAElFTkSuQmCC"

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAYAAADU8sWcAAADH0lEQVR42r1XW4hNURgedyKXFA/K/Z5LygsP7sktEiJSlNLe+5y91r/WPnPOTDKbEl6UeTsJiYkOhfBAJMQDeTBIYry4k/uTkuP7Zs5oZpvBnM4+q/7W2mfvtb7/+v3rVJR6uGHYx/eDSUljpqbT6X4V5RoJbRc7yrx1ffMY833Hl7zny8rYgV1dOaERTAczPGuHJVOpUb6fGoPffriSWhgvuG9uutqublwrm3GV7ObaU3YWvZDNZrvFBg6Az1qH/aPgYRh2x7uvItIrNnCAPUCSTYuCa50ZDq+8jDnmZq+rTD3XSLJ1nrZbmsIhJxH3bKzgjCldD/kARTYh/htg/Xko9ASu71yWcnO0MVCgzlH2OJKtGsBdSw4SBEFvllfS2okklrKRiSuyCC594/jmKZLpEevb0cHS+FnM2vEEc42ZqVR6aCIIRtB6/PYzoYN58Vqt5FZCmVVcM6aOkl1cExjv7jHGMTKZfEmGYd8oOEB74t03zvGBM8YqmBIFdyQzEuDP43b7PshdrlnLJJMCvebKRSbfYfErAG8EiazF8zk8N3SYTJixcOUzbL7aQhrYFtvbk8/nOwEwDeATtNhTso1KFRPDGrjrOkpnbrPQtU5EIQCdhuyntU4mM6BUCVSDxNnRuj3KdgAdaamQJ8EKTxvdpIR8gsV7aG084NrsbG+PV1U1EEochhJ3MF/G91coWN/GeQej37OngwfmeMoso9eKAo8OHkav8GCKIzIb573mXS5ZW9sDZLQcCh1lt8N8A3IB5fgOYd78b/AiRlN+SAMBC2tXqerBv+lZKqeTnklUHQZPKFlPF7clDAEPBqBF1xvUch+v0cRBIn+EYqfIhB0G57XI8838tsSRYAGtjLZeXqt4yQDwAZbwP2OOjx9C1hTL1Yy5o22SrRcYx1yR0X98xODTVXRZs/AZcgjJcbFQVnWwbMn/dCwqizO2Ys8L7D+TEJn81w10V1Ral5W4OPAaDnzPUuLFIUo0njFjyXrMZsxnmVgl5XURGVIgmktsn5jr2cP594gdjY1FqcpxFXGPXC7Xha2Vfwh5kynmjF8xiBLqEoZ/NAAAAABJRU5ErkJggg=="

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAZCAYAAADJ9/UkAAAC2ElEQVR42u1WSajUQBD9riDuKAoibriACm54EndcjnrUi+DJdCbpru4s8xUx6kFcQEVcBsEVREcUL55EL3rTf1EEQdDDF1EPnhXBWC/DQH5+JsnA/JsNDTNVL3ldVa+q01e2wjCcKoh2C0nCUsaxXdprjJnZN9LLdvV2y6VYuPoFk18VUl/k/dRy9U+hzL4RIZXy8Gwm/QvimjS7hh1K66Xw2RSu6Dk5orQkfbCNmd8JYym6ZSt9sPfkrgk4vZeKMfSENbAna3eMWc7PXmuVSr8U0lyGZrpIezgPaY2iaHyeH4KDPwiCyW1bzfMWMuEn2IXSniB/py3NJg5EwgbBVotc6dMc2YNO5EQ0wZL6N+OOtG3A834oomhSFl9T3hYu49dmszmmQs31H1uSX4J5jNSnNcAHCgvKeK9S5A75G5EqpL/I77r+ktRhbvP+mMVy9sYCm+ij6uJefs/p2pbvowaizthiR+s1+XhzCP7q5JJeQbF5PhbSDaQyQw5RncovkTmHslQmx1jFC5WqLxja37of9loQzMlEt45r/r1T2p0gmNvlsME4NfX2fyiZbfc58uNZrFLRtORQyt8wROmS9kPpqc6pWne6kybHQmqF0lGREC2qL0qwyl/dEqa3souIzXq0Rp7iBdFi2Nl/kwW2anhb6bO8j7bI9QkuxZVqt5jy1ya3lqTPfADCBMvNSL0+HRlhxQ8KSY/SFww00r4TMPsZ88si2hzH8ahcUs/zZjHpXT7lF37ArjKJsFBHJje8v3FrXrf7+2dkMRhW7B+AGDHzWS87Go3GuMQJ1SKN7DyPsVnKmH/4iULRBY7yhxNFU/Iw0AGyyYd80ypnsCy5PjEqe3QVD/C73pbPEN1k7Gv+Yc5gYPSAG+86iQyWX9n6GNq15+RQ+n/yMnL0ouI6vbMkPS/cLj2rgIlt1xwAAfq6CIcZgF4djU/kso3rtQwjtN6ajrAIC/8/x4fyKom/3eQAAAAASUVORK5CYII="

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAC6klEQVR42q1WS6hMcRwe16MR8lpYEAs2YkNeCzYWCnltlEKU5Jwzc/6P85gZjzoLjwWRrEbdBeXRECWRR1GkbOSdyC3KlKKLHanxfTNz6/S/M3POzDV1Ouf/+v6/7/u9JtPu57r+wkqlMjrzP35RFI2zXFWzXfXNkd4ejLMjBrVVsMYS+rst9F1LqPeO8JePHFSomwDdbkl/Pd5fHakdWNvXM6Alvc2w8BG/hdg/w3b1bQBXKEmvWvYB4IdVLE4dGuOCa9D2Tq1WG9UjbX3fcfW6oTE9D00f47nVEyDAjtrCKxqWZ0F/wJK61L2FUvsAPGHOK6WmwcpqXusV3TnGVbthTX9L66W3w3L1s64SwBEqAODxTqHlCO2mBgTYYdA+0G49r9QyUP8EXce03hCGswzAh8yapEhgAmRaCD2zkcP6EMflcnksKA3SAZ0jQW0hqOHNcD5u+Y30svB+1XCIt4+BnCIBsjjzyymVptcnfN+fgIMf6DWmFYsCqcODb3LSW5tGa5y5AK13xTyprsQWT5E6nvNdFBIPRp1uAqiPCN6l8aDF4s4E7QxvB6vqhSQfBHOZRkkHWCBw8REhCrNbOsbz5jB8Mjnpr2ZoJAHmVLiEMvCh+OZ6oVCYDNl+0pN7samcSEnrRaD0EtIovC+b60w/4Pyp5yM2XEwh+iApN6lVWyUEmH4BYLAYm18kpF8/qdIKFlZ8/+W3yQBh9jwjZTSF3JkV8Q1hGE7CRSdZTbB+w46iiZxnznI/x2YRAdMz9QE14cQwrzINpbctXu5t5W/ARa/NYsAK7ih/awNdFRawqyHuxhu62dSOMUYmbFq8BI5ZGd/HGIZRn5ll8WZ0FZNnzTbJKkJtSBPvp4xbs5GxabGyD/u30Gzq1bS9l47BmessIJSlTdtU70DzLTtdR88rNY/0mbaJfRribiIoNj+Asw7SMcwoVhN2Oqw9IROUOtlVk88JvRGHj1nCuwRr7oHaObZVWt+u5P8D9tmo+pskGfEAAAAASUVORK5CYII="

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAaCAYAAABPY4eKAAACHUlEQVR42u2WuYsUURCHnyB4BYKYGIhgsMIi/gWeKwqmLgYripHCe2+mqquqx1kvHM/1WJNNDAQRFBTEwMhAVLwwMFUEUVTMzYzHKpknjtOz9OzMbCBb8OPRXVV876rqdr1YvV5fGVF2FSlQbXee5yvcMKzRaCz3QM2A9FbHx53iT+bPsuNrBg73KFcMPGtMRrcCyvTA4RHpZAA+P1uMgic98qW5bOtSgHxjJcvHIvDOTtHNUOU7Rb4kD3zDg9zt6sd8ExEta98umlxv5+WRPtv56fikQK9Ur9Nzt5gA3DUmIL0LQN+rIqPOjIhWeeAfIZO9bh7MgxyxhYrIahdBDgXke24eTXm3Y8bRRZQzAfhUL8l6L7arxv5Ws9lcVB4uFIGvOQWftgmULzk+YNumeU+TPPB7XYnvoXJqmne1Z3jI+IRHutBe33wsIE39f3A748C8w2RJEfhiAfy6+ZPsDvQNj5kcbPWAZ78F/Mb6QttuMK9V38cUY/F2m/uGWyV4lHMdjhJtdgHeFzwgP/dE25KK4qpU25L8Bh4IPIqs80hfbAImu0w6Hm4vP5mw9ynG4hGPblhoMgOF29ZqztYkfXd5TnCPXLf/s7KJdgc08asHevFHSN8i84grabZgnfBZbZ2yxy5LdWZmiRu+2e/aYoV/qCCPp8/kQw/0s4K0P6BstrIZhpSzr/U5fvRPD2cfgO63yuXlcEQPAggm5i9OMz2Zp4QekQAAAABJRU5ErkJggg=="

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAYAAAC9pNwMAAABaElEQVR42u3WwUrEMBAA0Coe/AFF1INePPgNigh+hCCIJzGz2yQzyVYXYV0EEfV/POlhwW/Qix5E/6NOBKWblEJl1tMODLTTDI8hJW3211CGTrP/DjDoQNOLMjgYqxPtKvR71RwOh7NiqNL0Cr3eEl8/V3G+vgdDDz+pNJbKulwMRcSVcO+9X4zwZDvA0o0oGiLF62FRNMF5zzkvJOAUbYi8318Ikwc8geXRZjwvilVrz9YE0PZ4O9SSVwbfIlQcT1GetFsUy5WyAC6AyuHNqDzejMrjLVBZPJzdv5O3QMUm5y/WXFZFwdAhWDqSxDoa95V2x1Wc4fnoUMcBw5eSMGhXKONu43orOMfetkLcqcuyLGcmAoN1B98vh6FRnKGutDuZEEzn/Pyqts9SHwxeT+EpPIXHYM5HMG4rztDcDNOoto97QNNdI9z1fl0Z+uTFT0lyvUO0UdcXfuh4zXtdH2j8yJ3bjHu+AHkxpMHcHutnAAAAAElFTkSuQmCC"

/***/ }),
/* 970 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAYAAADQBxWhAAAC00lEQVR42r1XOagTURQd930pVARxxQUVQdRGLRREwRULQQtFbIR5M5m3zWR+sHAKW1E+iAS1ED8KHxRcCtHCDVHBDUFECwX3pdRKkHhOIHHQhEzyM14Ik3l595177vriNJJKpTJIqWSi0NEGV/fMKSTJeCeDCGOm+7q4wpVmt1DFhf39/UOcLOJJs8WV+oYI9Hc30Nfx/Y2Q5gcOuii0nttIx1o7CXtOY883NzCPRWD6qIf3964yJZJobqnUAps/eoHZlCTJyNo6LcYBMQ7+JVS0NK3jar0GxlUI9DczPwxnY/0uzr2C84b/CxhYSWWt9bRmRtF13OOraHUNEAd+5rOZDsCGutKeg8HPnLTEcTwB7vxasHZRS/cHehdc+LTQ2zsCz+eusttbxjpJxtJYN7DLUyzNIXxOORkF7B55gd2L5/3sOmYnMG7WMxUvr4Mgmpf1AFi9j5YzS7PqsAKYnNXYMoYA/eS0IVIWFxCUidKOHnBeeMbMdzwVLWOat6NM7xRKpcn1UsjuodvVJER5rIO/rzn/QZiALLkU0/wFMX3HruV41s4E07d5A0oZz2BN/6EtzRdakCeop+wekLtQX+AL6y5PULB8wgGSavJ2PYOcG6Axq9DTX9WyPd0gXjKd82FpzrK3N2z4+PFM92MZrmTWNpzJxWJxHOefr8K13QIsl8vDOBSEsjuabvKV3cg+jP44uituVeYAiFzO0h/70KUODxTQ13oJxyWvO61Bo2gqY+CqcHOngGEYTuEZvjTbMiuxP/K+w7rqJI5IyDvw2MG2reUFjeOLo6jNpn4CLC8hLwZ3lgg63AqLP2Sdm0LaY2B5S2s9aoDjyO4nsFI9s1o0gJNg+ZCl53RD2Jd5NWWhN3HpA4TiZyuGHcWYyZUudMYNazFA77G28xlPOl7M5iGUPkpWADyCz1WUyBgnT6n+x5H6PDMbz+OpW33+wrtyp7q/AaD6dhmS8N04AAAAAElFTkSuQmCC"

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAYAAADNAiUZAAAC6UlEQVR42rWVz6tNURTHL5KfiaQwEMpEyEDeiGKkTJQoxTNROmffe/aPs+9794o6BhiYvVBXisxcMTEwkZQQwkDy418wV0yu9bm987ruPu+1333Zddp3rfVd3+/+sda+tZhRtxP76tbungtDHFxtoSNtNjem2t1NMvcm1fZDot0t1W6vH8Rg4ycODjx58xZrTE0tE6LJNHPfVZaf7fV6i7rd7hIhPJ9o+0Npl1lrVzBj4ycODjx55MMTJZiY/Jis+IvK3NW0KFYPx40p1orIS/l+MWMPY8gjHx74ZhXLMr9LSJ7J97ju/bZqTHOH7OCJ7ORpau0RZmz8lRuwre3wwQv/v3eSuRvyfawbf7jyuItijQhcF4HPifFHB2PY+ImDq8qHF3500KvJKsYl6acyTnEvg+CiKBYrk5/r35FxrtPpLK0ixU8cHHjyBuPwwo8OejO7TXV+kwpMnTuEr2GbB8R+L6DbjXZ7Q0w9gANPHvn44GOX8KNT2WuS9E6SPvUXYJp7R2k18siHB77ZepyjXKl0flmO6KusqtWvPG2vlBUcO8CTRz488MEL/9DK8lMC/CaASxJcPtOrxrWn7+kMPTiXGHFw4MkrexQ+eOFHpw9W2l6UC/5d3mXYlxc2Jcbe47VR2o9VYfATBwc+RJR3a/+gF132DWv3S/yVJN6vT0xsxseMjZ94TLtFlH14hJJ8mqPijWXGDo4+ot2CspejekuZU/ZBhWt3HDHZYY8ZexhDHvnwRLUbgyOTndyRVb5IM/tA68ktifZ7xH4ubfCokec7EWWW+EP8xMGBJ498eOCLFlXGGX4r60+yI3quLDb+YRBlxpaWOMiDMH3cJ/BJu9iRRcuyL5/IQHTgDss2WaBoOELR6kH+vER5lIPKjBENK3w8WrSqByNEw14edfDaSJG8Ll+bKlH8xMGBjyaPeVc5Mt7VpNVahygzNv6I93m04b1fxT8IrwyizNj4a/97GNPaKkd5jXmU/L8vW0gg/b6+7gAAAABJRU5ErkJggg=="

/***/ }),
/* 972 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAACrUlEQVR42t1VS2sUQRBexNdJPYjg+33Q/+Dbf6CIggclPtIzme6u7pnZGFHHID7Bwx4iixofIOLJgwfBF4guGPAgxCT4xAgheNNfoF/NOjLb7mxkwRUcKKa7vqr6qnpqqkvtPFr3rhAUbm9XPKI1bRF72u4RygwLSaOQh1OLHvYkjWV7T5mDDQF7wnClL802VwT1rnLJfWX7gJ1O/XS4tai6JEmmedLGQtnzhZWgir2QER+CrB5BXgtFo542+4qIUx9J39neFdYLbQOHuIicjiPoSV570hwDaT+vC4m1OeIpOlNQSBn+5/5L4ktNe0OZs0zYkjhIkjmeMVvwba5BbnDD+NIOCk03ee0KkrrAlQZxvATrMST82BXo30gZrS0kttbO50aA8XMY1UBcg9OT/LqJ1IIoWv1Hvx8TSzOUJc2dXge0OYpjuVf6S092KpwwF4hEVAqgqrsYCjtLHXh8RRF/pnSDYxgJrF3feWJF4761yztOjMVkGIYLOk+szDtu+39B/CygaEPegIgW838NWdosQE8cL8KvsbkVzv5KlZe1OGq6A/LDv0BJu4UyX6F7yu3vayManCncBZ9vjGcXQQOpMjscf92MGIZhl5B6QhBtgmE3G2fNxhXVnSMfY3KjkPYQ73l4ZJWluDLyJ36A99llr3XfwhQPjGYcdgNMXAcUvcXmE2eI90dP2YuNk8ecEqxnXNEHzOGKg/dn/qj0PSocyOPdUp8A+XgdpxdeHK8rMSnfIpkRV4Qg9/OOIH2VHSeIuxDggYO/zKYRCPbznHbwIaGN+e3qyu8xR2dD94VvHG4eoextPqpqtTqD8aBSmYXEJqCr1nFzK4/DfyYS+wyyyymu6TrjrJ+y5TkIvscgdzsH4JvLSW46yK8yzu9yuTzXxYFdyXCtk3kuxw/Wqj4Jcv7nhwAAAABJRU5ErkJggg=="

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAaCAYAAABPY4eKAAACkUlEQVR42r1WXahMURQeP9dPKSkpbyIvfiJPConiDcmTSx7n2vuc2Xuvvc9xDsk9RKGoe0sZHhBPU1LkzU/kL0lJ95Zb4kWiKF1PPIxvHROTO41z5p6ZXas9c87e61vrW2d9e5fyjMrw8ExfU7/U9rzUdF1qFwuijdVqta/UzWFMvAiAr6Syj4Vy+31td+H/WaHsUzz7KDQdCYJgQeHAvgnXIdtPsCHPWOFpCj0KdigVrCCi2RXnljEbgtcYt6der0+ZNCg7htMBZPcT8zfYjZRyY08B6BYyH8X8RWh3WqlwqU+0Ev9fc0mSJJneMXDF2rWgcgxgd7QO+mu12rTW5Ti00FP2jFT0GUEd4/pzYBxoRwwwpakzCrdm3SOTZA4yfgaWXpTL5T7ML2EX82VM4QahqI7MV+UNmrNGxrfB2H0Rx/PYj6RgW6bNXDeRflhufaflQq2nckfwR8kfKgJ5m6n+2HQNNlia5HDOzQcDVythuIRZwO99/6lztBzAHxDljCLb1NNuCzPRdhHojkD3uaI1AsnMkorGoyia2wacHklrN3VDHQF+01O0sx34O0Hx4q6Aa3sBNjDhBYsH6Cb05FeIxEMsepDVeG8mcGMT1v4WL9xuAI/4JtjMJ1Qey6pgUrkDLMGt6D6BnjxcALv5wUFJwP3de/DGwZDKoLbPpaYnLApF2m+fZgylfdP8nC8mfyVR2yts3G6FmraXhKHL/z5nzGZpHYQaHS2Ubpx0zKqv7fY2yyaCcxt52iqmCO/u5TXsu9so5xD7ywXeuKONsjZzG3ZifEqyr0zgsONNWn9SGHuw1IvRuKuN/AFX9AMB7O0JOKsVH31MNeb3COZ7Kp+9GnwN8ky4RppwddoKXR6/AGaMAAaVlSixAAAAAElFTkSuQmCC"

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/create-24px.svg";

/***/ }),
/* 975 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAfCAYAAAAMeVbNAAAA0ElEQVRIx2NgAILs/GJXsnBxsTwDPpCZV5gIxP+BeDdJOL/oMpB+hdeCrLyieqArGhlIBEA9VUC924H4AU4LKDE8O6+oLbugKBunBZQaDmbjsoAahuO0gFqGwyzIzC98CLeAogjNLzyWU1DihIyzCgonZOUXvfj//z8j2YZnFRXJAvXeBOJ9WPD73KKSPLINx2txfnFFVkFRJ80MB2ayjlHDRw0fNXzU8FHDRw0fBIaDauycglJramFgq6AdbHhmYYUS0ILnQHyUivhpVkGZJgDeqYLxCwpPAgAAAABJRU5ErkJggg=="

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/dropdown-arrow_2x.png";

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNDA0NTQ4IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMFYweiIgZmlsbD0ibm9uZSIvPgogICAgPHBhdGggZD0iTTYgMTljMCAxLjEuOSAyIDIgMmg4YzEuMSAwIDItLjkgMi0yVjdINnYxMnptMi40Ni03LjEybDEuNDEtMS40MUwxMiAxMi41OWwyLjEyLTIuMTIgMS40MSAxLjQxTDEzLjQxIDE0bDIuMTIgMi4xMi0xLjQxIDEuNDFMMTIgMTUuNDFsLTIuMTIgMi4xMi0xLjQxLTEuNDFMMTAuNTkgMTRsLTIuMTMtMi4xMnpNMTUuNSA0bC0xLTFoLTVsLTEgMUg1djJoMTRWNHoiLz4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 978 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRDdEN0Q3IiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik05IDE2LjJMNC44IDEybC0xLjQgMS40TDkgMTkgMjEgN2wtMS40LTEuNEw5IDE2LjJ6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 979 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDAzMzY2IiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik05IDE2LjJMNC44IDEybC0xLjQgMS40TDkgMTkgMjEgN2wtMS40LTEuNEw5IDE2LjJ6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/ic_done_white_32px.svg";

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAWCAYAAAChWZ5EAAACo0lEQVR42r1VO6wNURR9/oIEeYSQ0FCoNESFOXPv+ewzH/cVk/hEXIncKGi8QiLELUREFBI0GoKIGoVE41MgoRAFQik+EYVEg2LsNcl5d7w3c3PnDu8kOzOzz95r7c85e0aGWUrtXSjDcL0g2u4ruw3v0I38z5WRSTojlHnD8kMoeu8p88iT9Bjv0GEPNrD9d8TKbsmIFL3yFZ2S1m4qs8UebGALH/gOTdxut+dzZjeEpA++tvuLbKDvtwdfoc1FYFUiJ6J5TP6S5apzbrVaS4S2O/J2nOVJSF4HmyAIlrokPG2ucGueNcbGRgcij6JoGTt8416en7zH/X4iTBCXBcDljzjop1PbaE570qSMvaAveafTmcMAD9nhbME2stvN/b0zQShtG9ILiG6z7Cn0Ba6kB+Ao40eGF4S0RyacpLnmAIdZDR1sxTOHd9PTdLTQ2Ld2LUrfiOMVTmetXcklfi00HatKDh9uyeG8DtjgANfU7JW97ivbLQJLkmRuVXLMBPZbNHkPHOD6S9lMksVC0XccEky0ZhBsyO8PQ47q5fXABDY4wAXOXmmU2cn9uYv3zEDSZxwYIlpelxwYwAKmuwU4yL6xu/In9Bb3ep/77na7s31pEqHDjXUzBwawgOl04AJnPoDnDWM2Vx3RXLV7DPbO0+HBIvJ+I5vtX+Qn2kc/DFcPSt6MojUYLL62B3DS8Y6/4qD+Mo5XcRs+uXLPZIBfeGKEah2vc1IGwGTHuQKXegOJzglJJ8rsMYbxywam4xSKfvItmZVNPw7gdwak6RBK6qTs+rFzh0v4JU3TGRBUALrSAadpHHgc5FunQ9LA7wVQYYEU/wUQ8/Mrg9+v4F4/gPwJdzelfgC1Vv0A0oaycjoFnAgg66dQdBl9nE4BJ7j/AIRRe+ac8ho4AAAAAElFTkSuQmCC"

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABeUlEQVR42pWTMS8EQRTHt5HwCRRCFD6BQoeZ2ZuZN7N76xQXBZKL4iIh0dBQ8REUtIREp6EkEUIhd0LoKY5EgUKikvB/LitHJHZf8t+Z7Hvv996b2Q1SK5fLHdK4NWHcriQKg1+mjFPw7XAMx/5ItDbpC008LjR9KBPNS0M3nNAqqem2QH5BGLoMdTTBOV8gUPc4UWrXENrC6WeEdi+odNgqxD0r62YBvwLsHqAHrPsA0LEyfihMkk44HwF7RfDS7xGkdYvs4xiODW00iEInAeh1of0ct5lHnANdBKA0QK1zmzlV49zvEYKclo7wJ0DZYr/SNFqpVNpRaVUYv4V1O7SeMgEQ/I6DvFZx3IWgdWX9JN5tQJvZABQluNYj3je/Ea/5aq0tDWQCFCgWKQDVp7kbaeiJ3+cGsGF/AMhYpkPEnFPDhk6RUGOfMSPdWM+q1WpbJkChWOxhZ6p/rxGPc6WdISr15hEfrESnPN9y88dwd3mEwm/SupVPLxj/UKmEsTEAAAAASUVORK5CYII="

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAACaUlEQVR42r2Wu4vVQBTGI/gCdRV84QsUOy0UBBGrZLJzkpO9yeaKKZVbyBVd8IGKhYpXEQsFGyv/Ai20shX8D0R8gsr6qGy0Ed3y7ndkQ65Oojsx8UCaDDO/Oeebb844TQbRoWVKRz2PwusqiI4w85jTZgTBgQ2APXWJH+K74OnwgUvh6zBMt7YGdDW/AfT46H8v4MOe5o8CbgXoBny+bFwRHyvArQNNcJIkK1oEmgHoFVeHw9rALMuW2wDzEKgXdHZZA5l5yc/JxPds5yLbRz5F2hoKG1xGlk/KtZvYXwkM4p2w0leRxRqqiK/BCleNzQTRSYydLZvjJ8l6qY5YqJaeognK9Jmou24UiApMj2fZylIgLgl4+LTzL6GTZKNHE3uGw+GCHEg0uaUKqCi6aGcL4ruiIb7bOLWLR8cbB0o2uS0kK4+iWwIpA/6+GSm9NVB1Opsw6S1A537ZiI52l2UI+/SZefOcpcag3wsroEzGIu+Q4Rlj0AAWdgDoi3QYT/MH6TLzBspCsmDVSVMBn8L4+xxotLYgmpRq2GmIBVHSE38ATudl9IlTVOROv99f5NQJuf3FvBU6ANjZWwCLAPS+dBBroHgNwMco6Y3qizqaKoBFiAzQ76Y1VDFvl15X5z0kJ1zpsGsNHWfeB+hLy06zFh5+hXmXaumZpukq0dNn3uHMI+I4XiOblG5jRzI7hwL4G1G87W/AOeMP7AjVh+Uodv+pCux3u6td4udGW2sKLBkZQM3PpJc2hDLBcpXJARsMBgvlhoEfv8ur3WkzfOKD0iWQ3Q9oPSOaO/8jpF31er2l8hBreu1ZFS0MNpeD2yMAAAAASUVORK5CYII="

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAYAAACGVs+MAAABtklEQVR42u2XO0sDQRSFb3yA2ImF4APtLSwFQdnZMLMzu9lohKBlqhTaaGEffFT+ABtRC7XVQrGwtVAsrBR8VKIWWmsb7zEEQoiaxN2kcD8YGGbvnnPmXlhYshOJPiH1vqXMlVD6ohELXvCENwFL6RWhzIOtvDGh3NEwFzwKXmaVSrGk2eAgp9lstp1CAtrwgBeVk8vlWrg9h5xuN5/PxyhgoMnae9z+A3hRJTKZTAcXnXHROgUMNKEND/oJz/O6hDTX3I1FCgjbMQvc9htoUzUYY/o5xBOnnqE/Eld6luf+qNTkANWCcPxhDvBqK2PXbe54gm/+Bq16BcYLAokRqhG8U7iAO0F/QWhvWkj9rPXUUNUzd91BbvsL3qUgEErPcSfu4qlUN/0CaoQ0t5Z05ylIWHRNKHPu+34nfQOeoQa1FAYsvsPjOEqn061UBs7Y+Nhy9DaFBL6WbTzbE6HczQod2kIA1FCYoM2WNJfCMcvFM+xxVj6ecDshzUc8mezB4tG844waiSV1vnTPxKIAUYAoQBTgfwaQyWRvcd/wAF/mSt/jb6cpAWAulLtEoBkBmmYOgmr7J9YxHStnDv6nAAAAAElFTkSuQmCC"

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/l-logo_2x.png";

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/logo-glyph-white-m_2x.png";

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/logo-glyph-white_2x.png";

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/logo_2x.png";

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAA6CAQAAAC5DtcGAAACn0lEQVR4Ae3YXWiNcRzA8d/Oxqa8LJpmJsdLHHPFETfUMJJcKDdqESKteVnCsEQhLHQkzYW2vMS01VJrd5qSLKVEaDUvs11MsdVO28GZfd1QezrneZ7f/9meE3U+/+vfv+/N//+8iA5ZrOcKj+lmkGFivKWBkxQhY70E95VBKV0k18bWVAdNpBVnd8lOXVA2j3B3JzVBKzjFQ3TW+R90EBO3/A4aRz8mXvgdFMTMe7+DpmLmNeKw8tlMGVUcZjuryfESJHzExAObXSZwiHasBmlhg3nQNUwcSLrHcnqw08h0s6Bl6A0zM2E+jxJ6XQ7CeLN7qBOt5wlntI5h3O0xCbqIiZ2W2R3o3NMHTeMHJj5ZpuvQeaoPKsZU7ojpG+g06oM2YapgxPRedI7ogxZhJkrA+J6PU6gPEl5hotb6Sqe6VhvM7qGN/EKrj3mW2Qo0oswwu4eqwOPb0Et0ysyCSkxOmGXF0ImYBRWi05cw2YPOGbMg4QMazQlzreiUmgZdR6Pc82NngWnQfIZw08+UhLkCvuDutpfPoHO42Z90bhtuYuR4CcrkJk5qbObm4KbN65drGCdh27nPOIukOmg3Tn4yN9VBmTzB3gUk1UHCZNukWjK8BuVSjZNqch2mA1wi0VGvPxuCRIjiJkqEoO0eWxSPYlVQmHqG0BqinrB/QWGa8aKZsOofyi6ToBBNjEYToRG3dQfJtXOahe5BedQQZ7Ti1JCPIEziPk7ecJaldkEB9tHHWBmgggCCcAw3nVxlFQFrUJA2xtqzP2evEo1uzjP7b9BaevHDV9YgCC3oxLlMllDMd/wSYyXCEvROCB346R1CgAG0GgS/CcI3tBr//6B0UDooHZQOSgelg7r+qaByoYhKjvu4BCHEYtWahfwG5oVDIHqYjogAAAAASUVORK5CYII="

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAzCAQAAACeAYbOAAADbUlEQVR4Ae3XzWuU5xrH8WtIfNkoiAf0gESktkSlTaEolmIXTS2IiwSycmEFkVCLtNCFC60UdJGFli6Kmyii0ApmERHfUAvajQdyRDxw7CLBl9ESbYzU2hhNTPLpLnlmfDIzeSYBF35+f8D9Xd5XZCOnwRZtOt1wR78hQ/rdcUOnNls0yIksC1PdQq06PFLOIx1aLZzJoFpNOg2bimGdmtROf9As29yS1S3bzJrOoM3yqpW3eXqC6l02XS6rry4oZ6chldhuu0oM2SmXNWiB0ypzUwg3Vea0BVmCVrorzc+OKnZNCNcUO+onae5aOdWgNfqleSCESxUF/SKEXmn6rZlKUKMB6YYtEloqCmoRFhmWbkBjpUGrDZjcbqFWb9mgXrXCbpMbsLqSoOX6lJJXI+wrG7RPqJFXSp/l5YLm61FOk1Bn1IRuIXSbMKpOaFJOj/mlg04odMNzxS4I4ZykNm2SzgnhgvJOlApqVei48LZehcasEA4r5bCwwphKtE4WtNSgQpeEUO+hQj0OGlHKiIN6VOaZpelBJ73qeyGs0qda96y1zog0J9OCNkjXJoT3PFaN370l1OqTbkNxUM5Nk9krhA9l1+sdIfxoMv+XKwxqVsq3wmxPZfNQvRB+UEpzYVCX0s74VTZ9Vglhv9K6kkHrzJR+7wqhTXnrJoIOmRmPvS+EvSpxSIgQ5npiwikNduhWvT99IITvpOm2Q4NTJjwxV4TQImmTEHI2uqgaf1kthF1eddFGOSFsktQiQmiXlNesZvzX2CGbp9YKYadiHeO/xRrN8pLaRQg9it23x2Ih5NwzdX/7SAjfKJaXE8Jie9xXrEeEJdIN69DoM4Om6pmPhfCVVw1a71MdhqVbElpMr0GfCOFLWbSEXar1h4O+8LV2Tz23XgitxmSxKxxTneOJK+tf1ghhqzHZHAtXVWO/KJ7PjcrqauiW3W/mpAT9T3bd4YHsNomUbZHdgzAgu3+LlC2X3UAYM2HEdf8dX145s0XK5ignn3jlulETxkLSepFYzlml1YmU1SntrJxIbKOEkFR8bZ9R2laRsq1KOy0K1jh50Etd/jO+28rJmyeKNk9eObcTr3R5KSFU54icSCzniKqEal2xbDxnmSuqFKr3wnkHHHDeC1ULM+1N0JugN0GjXiejof01ShrV/g/2EwyUzSLbTAAAAABJRU5ErkJggg=="

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-link_2x.png";

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-logo_2x.png";

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAQAAAD/5HvMAAABuElEQVR4Ae3YIU9bUQBA4VNCGkKCIEEgMBgMCoXC1eFwq2RmwXYOi61F4qjE4XDMkJFgUIguAcESBAkJIUB4Z3Zrtr229777nrjnF3z64LGFTanwGG9tUrfY8c2m9GYHsWthEyrsCiL2bEI9EUTEvnXXl99BLQfW2cDWnyBse2ZdndmWURAueGUdXbkgfwPhsj9M3dBl+RcI13wwZQ+uyf9AuOmzqXp2U8pAuO27KXp3W8YB4a4p2pVxQbhv1e3LJCA8tMoOZVLQjCdW1Ykzk4NwznOr6Nw5mQaEi14bu2sXZVoQrnhnzO5ckRAQrvtorB5dl1AQbvlijF7ckhgg3PHD0D7ckVgg3DO0PYkJwgNDOpDYIDxy2o6kCtCsp07TqbPVgHDeCyftwnmpCoRL3jhJNy5JlSBc9d5xu3dVqgbhhk+O05MbkgKEHV8t69WOpAJh16J8HKQDlQ+KnqQDlQ+KvqQElQ2Kga16QNh26GhD21IXCC8d7VIaDMqgDMqgDMqgDMqgDMqgDMqgDMqgDPrWLFDhpyaBCr9I/aBwTnxQECc+KIATHxSXEw76HpcTDvrqTz/H48gvq9dd3Pqy9EsAAAAASUVORK5CYII="

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAAIElEQVQIW2PIyi/aCsR/qYTXM2TlFa7MzC/6RA0MMhAAPh1ZL7lzX9cAAAAASUVORK5CYII="

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/n-avatar_2x.png";

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAeCAYAAAAo5+5WAAAAAXNSR0IArs4c6QAAAn9JREFUSA2llM9rU0EQx2deomjaixat3gRbf4AniT/Q/0CMub0kh7YKVSmCohcPKgj+AT14UPBXmpbm9VECHnvK3YJWFFQQxIOIl2JRE9skO85G9rkv3b59r+5lZmdnPgzf3VmAhKtcnbtdrlbv2cocW4J+XqnOnwCguwTOFz1u8mODKwsLfQLaM0SUSiO9MMH0WFrfRPm0vDxJBEMI8Pvw0NCbqFx5FqvjctU/JwgudmGIS9lstvXf4EqttptAPP4Hsssgc60di9W1J0C0KwAjWvW1gqc87zJf1tkAys6WdDoWmO/CvBh6gHV9xd1mVAYCfh8rFXYiIqnYRtYoRb1eT5OgaR0qAYS0GAcqc43gz1+/3eGWjssEfSHF01fWrAM/87yTgHBLBwY+OrH0lfkhjX3f7290xBJf2P4AltBhqZqZlLM3NHmNtpgk2Dz0bw/00HXdlUAKfgV5ho4nbDCcjrh4ZHj4pgx2wbOzzwf5aT0KZyXcIa6kUk5BjXsXvArNp6HpSsiU6Q4446Ou+0mVOmXPm+AXekYFNmP5wh6Mldx5vdbhQbiuBxL7iK9pz+CN3rrQc+s9VPtp3z/Ybnfeq72y3OlP1jU74rofVEzZ4FWogMmKDp02xXkSJ0xQmRt6x6ZiGRMg1oG52zJ/SDMb1cTqmP+yUzqAoe8G+vuu6LFe3wqeqtUG+EM6pAoZ2nQQ3Fwu11Axk7VKga1WqFsCvDZaLLw1wfSYFdwREOjLH713vlSINaFWMA9Pt2OW4OOOzPZLeldRfqTG/I1uRaJjDF1LIRTy+fyPKJh+FtnxLyGOcvI2ILg6Uiq+1AttfiSYi/cB4tyFUvG+DdR7/gd+rMPRK73VqgAAAABJRU5ErkJggg=="

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAfCAYAAADjuz3zAAAAAXNSR0IArs4c6QAAAKlJREFUSA1jnL9sRS4D439hBlLBf8YPumoqU01MTH5j08o4f9ny/9gkCIoxMixkZGB4p6OqWo7NcCaCBuBW8ADooklXbt/uPHPmDCu6MkoMZkiMjMRpOEUGg1yJy3CKDcZlOFUMxmY41QxGNvzqrTut5Cc3kEl4AFVdjGzPqMHw0BgNitGggIcAnDGaKkaDAh4CcMZoqhjCQcHCwMCYR1ZrE+5pLIz/jG8B6/pIGdxdzlwAAAAASUVORK5CYII="

/***/ }),
/* 998 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAaCAYAAABGiCfwAAACpElEQVR42rVWSYsTQRSOzqijF3HDXRAEcUVPHsSDB8WTChLwLka6O93Vr3pJMoMQj95kRCUiLoiKcUVRcUP0IHr0IjIKooiD4MVfEL8vTqQtMpN00hYUJP263rfUq9eVy2rYfrzOUdrjVCpem/tfw/G1Yyn5bit90lL6NOYPW8mhzIFsFQiAPvv+8NK/z7ReCeCvmEeyU6Qksjz9yY3jFWasGIarQeKL5QduBnukR5BsLKnIHEqVVtme/ATg/j4UBcewJ++VGl5sxtoq9KRRjONlPeyRPszFbqWyqPs18gYEd6UDEtlDINO6RqMxzalUFrRbU6vVZqA6v/FopAKzfK3B8kzyWbVanQ7W51sEjNggCugt3DiX2kJLhZt5hoIgWMj/9Xp9AIkuo1BeUF0bRffhxNOei4Nl7qhwW6FQQLLgGsCeQMHQP++Mjs4iEGJ3qK5jUtpj+3Liz+GU167WWw3WN6HoIRMb64ZsTz9Cyd/oFmiQrLHgbrMbSLQbya9MxGbyOeY9/haR+cl1IPcM8yot7ghE1lByi6yTC0ql0lyqQKIHmLdbrJm4qPReW2QNFB3F/0t0ZUoQ02uCJmNQMJv7A0XXkyQ8L9yI5y9B7gO6yvFEoZjD9FoeMxlZG7E5SPaclZfP5wdciXawM/RUYZRN67ipptdkivJ9BaALLXuscnkeLBtn0fRwfnSde8TE7Ynos2YMBGogGKQCKops4vdoMq/Zhtp1c7at9P1O651g+K7b99npm0C+9lNbyNbDxbYfbelILIqWTFTdSK7XUfSj7SiOX24QrJ/sHX6PsHcfbRWU+//Ee3KQTZbN1oyJyHICQVGYy2qgExwgoCOlDYZ1Y/y8ZH8tk3BfU6EvF2HZKV7RMrm0THVR4b2P90FjH/savwFlW3X5fvkF5wAAAABJRU5ErkJggg=="

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABL0lEQVR42u3TMUpEMRAAUAsVZVnQQo9gY7Fgs7V6De1skrjJzPz43S0Wo1bWLsi/hYVnUEQEL+A5BC004/5CwmKKiYWwA8NPmJAHfyYL0gghLMZcbppmaVZyTYxohzfK4iendvQxK7lmLO2LkJj3dV13fz0HFDjLInlIjmhH18rSW6w9GTzdTqEyiKXxdy+ItgxUR7z23m8mkAxpa8/G+f6P/Z1ydMBr46pzbemsSE+Uw1dt8bYd9xVl8f0Y/F4CyRsPENamY04P7XfSllJIPl2IuKqJdg2c7PA+hQRIPrz3nWm/qss/Q9RwuK4svWigqznyTxAD1SHPPj+04kga8dBjzIkYyQX/sgQTIAJMgOQxESLH8ogcyyNyLIOUwzTQRQaRx2A02uAHPSDqSe75Am4wQ9Yd/2IQAAAAAElFTkSuQmCC"

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/notification-bell.svg";

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/office-logo_2x.png";

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/p-avatar_2x.png";

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAoElEQVR42pXPsRECIRCFYWY01kLUxF60AwM4D1gGh3RL0DZoxdTQArSAy4Vg031Ctsx8P4txMWXv896MneboXmtdmYnKzgX69MgIbuYpc4vks0T+xaWUbZ9BBGMQARhGMMYRBeOI9bTYQK8xLGuH9LA+vl2k75XoMIxlbRvSqX+nR4bwzLyROyWCMYgADCMY48gUb0cFqxF5/aJgNcLM6x91O5mxCOB8FwAAAABJRU5ErkJggg=="

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABN0lEQVR42r3XsUrDUBSH8aPoEwhC30OdBF9Ggjc1ubm3Qah0COLQJ3DXUZ9JOoqTgpMIxhMJHFEXz4cd/mP6/WjDgco0pkWIedl13ZZO1rDNsskXZZ0vdSIhpvtQp14Rt4b4x3jM10NP4w99329IGWf7Gn92IEA8vWj3UCcDACBY3AAjoozpyYFwxg0AECRuAIAgcQMABIkbACBI3AAAQeIGAAgSNwBAkLgBAILEDeBGFEWxDeIGAIiVI44BclKlA42/jvG3UKUjnXj25we+/uahat7pxUTnNdSzY3q24XnlZ5vGhSJgnCNgnCNgnCNgnCNgnCN+xPWBG0fcjXDE/Qj93LvvCBjnCEfct9N0tvcbQkLMV444/yb0RdcNgLRyxDki5sfPP6dt2+6Ok3VtOp/vNM35RCcfA8ElJeD1CosAAAAASUVORK5CYII="

/***/ }),
/* 1005 */
172,
/* 1006 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAS0lEQVQ4y2NgIAJk5Rdtzcov3MJADdDQ0MCUmVf4H2jo31EDRw2klYGgRAvSQA0MMovKBhKRm0ZjedTAwWAgODflFW3PyivcRIxaAJjWwwVN9GkSAAAAAElFTkSuQmCC"

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/print-white-18dp.svg";

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAYBJREFUOBGV0zFLAzEUAOD3cm0Vlw7ddFFQHGxP8dqKLnYUBKFu4iIOguCs4B/o4Ky4uaogTs52LMo59K7iD1C3roL2Ls9LbI5em17PLMm95D6Slxd0rPw5AGZzkDmYtO0v+EdrFc0tDvyEgXHECHGdgHbb+P3waVkTSR2ntLjtA90RwRpn/jRLGUY12NFHEKgkxQRCnF8DUQqB1QpP7j2KHbyuLM15nv8IQFOIUM/R2OawY4YIUFoidvNUGBJKig1DItAoLA4ZgIZhbeZtyJz0HUesVy08mgqIvrW6POv/dOp/OUM3uIj5YBzJSe96MdZCYkJgvNNpEFFOfBsEZwsv7rEY6xrTBUWMe75JAFk1zxmU4upMC8nEEr/p1sllkjobgPqQWsFuHhqZdGUUFsmRBpHFJo4XvYDBog2hOETlKQ6TUBJkFIZOOV8ljrfhA+y+HfWjrtftDJtW4V0WnnjFCRAF92LAcB/dornDkcbNZ+dKLUrav5XNGc+nPUrRxS/kSiNvAES2TQAAAABJRU5ErkJggg=="

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/recycle.svg";

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABb0lEQVR42rVVO07EMBBdemj401FwABqQkKDiNDGK7bGTiGyx7DmQKOEGtNBQ8/8E7gAN1Bv8wNMREyNsyYplv5k3b2bsDH4ae9LsCmUOM0WNkPSOiTX2cDb46xBEa87ReSapDU1ggI1zrux2pswrHPiIR0KX62I8nsb8WktzgDNggIVNROTs3Jxpvb/ahcUZMEzSSwkks/O2bad+wwPDJLANglE0TktH5J1KOF3BwqMzfCSj2KZATWALH6H0NAChiLEEsPHBNZ0glolOiSWADac3CUFVVTM+RR+pU/SStsjSHKVs04lQdiPVRUP+T/o9FdK8RT8VuGS62OolOadyByR9Hzuebu9Z6+HKfz7Xk0yZ4+8OMpd80URZLgdch3846HO0IrolJ9pkHBHNCkVXXslTDEn/YOp6zim5ZhKlhktJSJySG5C472MSEmvtPJM4RQ9FUSwmIjG3Xsl9EpK8rhcyZe58d11gLwkJnDs1p59Edn6jBXQ7qQAAAABJRU5ErkJggg=="

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/pdfIcon.svg";

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * default settings
	 *
	 * @author Zongmin Lei<leizongmin@gmail.com>
	 */
	
	var FilterCSS = __webpack_require__(432).FilterCSS;
	var getDefaultCSSWhiteList = __webpack_require__(432).getDefaultWhiteList;
	var _ = __webpack_require__(590);
	
	function getDefaultWhiteList() {
	  return {
	    a: ["target", "href", "title"],
	    abbr: ["title"],
	    address: [],
	    area: ["shape", "coords", "href", "alt"],
	    article: [],
	    aside: [],
	    audio: [
	      "autoplay",
	      "controls",
	      "crossorigin",
	      "loop",
	      "muted",
	      "preload",
	      "src",
	    ],
	    b: [],
	    bdi: ["dir"],
	    bdo: ["dir"],
	    big: [],
	    blockquote: ["cite"],
	    br: [],
	    caption: [],
	    center: [],
	    cite: [],
	    code: [],
	    col: ["align", "valign", "span", "width"],
	    colgroup: ["align", "valign", "span", "width"],
	    dd: [],
	    del: ["datetime"],
	    details: ["open"],
	    div: [],
	    dl: [],
	    dt: [],
	    em: [],
	    figcaption: [],
	    figure: [],
	    font: ["color", "size", "face"],
	    footer: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    header: [],
	    hr: [],
	    i: [],
	    img: ["src", "alt", "title", "width", "height"],
	    ins: ["datetime"],
	    li: [],
	    mark: [],
	    nav: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    section: [],
	    small: [],
	    span: [],
	    sub: [],
	    summary: [],
	    sup: [],
	    strong: [],
	    strike: [],
	    table: ["width", "border", "align", "valign"],
	    tbody: ["align", "valign"],
	    td: ["width", "rowspan", "colspan", "align", "valign"],
	    tfoot: ["align", "valign"],
	    th: ["width", "rowspan", "colspan", "align", "valign"],
	    thead: ["align", "valign"],
	    tr: ["rowspan", "align", "valign"],
	    tt: [],
	    u: [],
	    ul: [],
	    video: [
	      "autoplay",
	      "controls",
	      "crossorigin",
	      "loop",
	      "muted",
	      "playsinline",
	      "poster",
	      "preload",
	      "src",
	      "height",
	      "width",
	    ],
	  };
	}
	
	var defaultCSSFilter = new FilterCSS();
	
	/**
	 * default onTag function
	 *
	 * @param {String} tag
	 * @param {String} html
	 * @param {Object} options
	 * @return {String}
	 */
	function onTag(tag, html, options) {
	  // do nothing
	}
	
	/**
	 * default onIgnoreTag function
	 *
	 * @param {String} tag
	 * @param {String} html
	 * @param {Object} options
	 * @return {String}
	 */
	function onIgnoreTag(tag, html, options) {
	  // do nothing
	}
	
	/**
	 * default onTagAttr function
	 *
	 * @param {String} tag
	 * @param {String} name
	 * @param {String} value
	 * @return {String}
	 */
	function onTagAttr(tag, name, value) {
	  // do nothing
	}
	
	/**
	 * default onIgnoreTagAttr function
	 *
	 * @param {String} tag
	 * @param {String} name
	 * @param {String} value
	 * @return {String}
	 */
	function onIgnoreTagAttr(tag, name, value) {
	  // do nothing
	}
	
	/**
	 * default escapeHtml function
	 *
	 * @param {String} html
	 */
	function escapeHtml(html) {
	  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
	}
	
	/**
	 * default safeAttrValue function
	 *
	 * @param {String} tag
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} cssFilter
	 * @return {String}
	 */
	function safeAttrValue(tag, name, value, cssFilter) {
	  // unescape attribute value firstly
	  value = friendlyAttrValue(value);
	
	  if (name === "href" || name === "src") {
	    // filter `href` and `src` attribute
	    // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
	    value = _.trim(value);
	    if (value === "#") return "#";
	    if (
	      !(
	        value.substr(0, 7) === "http://" ||
	        value.substr(0, 8) === "https://" ||
	        value.substr(0, 7) === "mailto:" ||
	        value.substr(0, 4) === "tel:" ||
	        value.substr(0, 11) === "data:image/" ||
	        value.substr(0, 6) === "ftp://" ||
	        value.substr(0, 2) === "./" ||
	        value.substr(0, 3) === "../" ||
	        value[0] === "#" ||
	        value[0] === "/"
	      )
	    ) {
	      return "";
	    }
	  } else if (name === "background") {
	    // filter `background` attribute (maybe no use)
	    // `javascript:`
	    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
	    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
	      return "";
	    }
	  } else if (name === "style") {
	    // `expression()`
	    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
	    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
	      return "";
	    }
	    // `url()`
	    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
	    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
	      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
	      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
	        return "";
	      }
	    }
	    if (cssFilter !== false) {
	      cssFilter = cssFilter || defaultCSSFilter;
	      value = cssFilter.process(value);
	    }
	  }
	
	  // escape `<>"` before returns
	  value = escapeAttrValue(value);
	  return value;
	}
	
	// RegExp list
	var REGEXP_LT = /</g;
	var REGEXP_GT = />/g;
	var REGEXP_QUOTE = /"/g;
	var REGEXP_QUOTE_2 = /&quot;/g;
	var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
	var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
	var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
	// var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
	var REGEXP_DEFAULT_ON_TAG_ATTR_4 =
	  /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
	// var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
	// var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
	var REGEXP_DEFAULT_ON_TAG_ATTR_7 =
	  /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
	var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;
	
	/**
	 * escape double quote
	 *
	 * @param {String} str
	 * @return {String} str
	 */
	function escapeQuote(str) {
	  return str.replace(REGEXP_QUOTE, "&quot;");
	}
	
	/**
	 * unescape double quote
	 *
	 * @param {String} str
	 * @return {String} str
	 */
	function unescapeQuote(str) {
	  return str.replace(REGEXP_QUOTE_2, '"');
	}
	
	/**
	 * escape html entities
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function escapeHtmlEntities(str) {
	  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
	    return code[0] === "x" || code[0] === "X"
	      ? String.fromCharCode(parseInt(code.substr(1), 16))
	      : String.fromCharCode(parseInt(code, 10));
	  });
	}
	
	/**
	 * escape html5 new danger entities
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function escapeDangerHtml5Entities(str) {
	  return str
	    .replace(REGEXP_ATTR_VALUE_COLON, ":")
	    .replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
	}
	
	/**
	 * clear nonprintable characters
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function clearNonPrintableCharacter(str) {
	  var str2 = "";
	  for (var i = 0, len = str.length; i < len; i++) {
	    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
	  }
	  return _.trim(str2);
	}
	
	/**
	 * get friendly attribute value
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function friendlyAttrValue(str) {
	  str = unescapeQuote(str);
	  str = escapeHtmlEntities(str);
	  str = escapeDangerHtml5Entities(str);
	  str = clearNonPrintableCharacter(str);
	  return str;
	}
	
	/**
	 * unescape attribute value
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function escapeAttrValue(str) {
	  str = escapeQuote(str);
	  str = escapeHtml(str);
	  return str;
	}
	
	/**
	 * `onIgnoreTag` function for removing all the tags that are not in whitelist
	 */
	function onIgnoreTagStripAll() {
	  return "";
	}
	
	/**
	 * remove tag body
	 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
	 *
	 * @param {array} tags
	 * @param {function} next
	 */
	function StripTagBody(tags, next) {
	  if (typeof next !== "function") {
	    next = function () {};
	  }
	
	  var isRemoveAllTag = !Array.isArray(tags);
	  function isRemoveTag(tag) {
	    if (isRemoveAllTag) return true;
	    return _.indexOf(tags, tag) !== -1;
	  }
	
	  var removeList = [];
	  var posStart = false;
	
	  return {
	    onIgnoreTag: function (tag, html, options) {
	      if (isRemoveTag(tag)) {
	        if (options.isClosing) {
	          var ret = "[/removed]";
	          var end = options.position + ret.length;
	          removeList.push([
	            posStart !== false ? posStart : options.position,
	            end,
	          ]);
	          posStart = false;
	          return ret;
	        } else {
	          if (!posStart) {
	            posStart = options.position;
	          }
	          return "[removed]";
	        }
	      } else {
	        return next(tag, html, options);
	      }
	    },
	    remove: function (html) {
	      var rethtml = "";
	      var lastPos = 0;
	      _.forEach(removeList, function (pos) {
	        rethtml += html.slice(lastPos, pos[0]);
	        lastPos = pos[1];
	      });
	      rethtml += html.slice(lastPos);
	      return rethtml;
	    },
	  };
	}
	
	/**
	 * remove html comments
	 *
	 * @param {String} html
	 * @return {String}
	 */
	function stripCommentTag(html) {
	  var retHtml = "";
	  var lastPos = 0;
	  while (lastPos < html.length) {
	    var i = html.indexOf("<!--", lastPos);
	    if (i === -1) {
	      retHtml += html.slice(lastPos);
	      break;
	    }
	    retHtml += html.slice(lastPos, i);
	    var j = html.indexOf("-->", i);
	    if (j === -1) {
	      break;
	    }
	    lastPos = j + 3;
	  }
	  return retHtml;
	}
	
	/**
	 * remove invisible characters
	 *
	 * @param {String} html
	 * @return {String}
	 */
	function stripBlankChar(html) {
	  var chars = html.split("");
	  chars = chars.filter(function (char) {
	    var c = char.charCodeAt(0);
	    if (c === 127) return false;
	    if (c <= 31) {
	      if (c === 10 || c === 13) return true;
	      return false;
	    }
	    return true;
	  });
	  return chars.join("");
	}
	
	exports.whiteList = getDefaultWhiteList();
	exports.getDefaultWhiteList = getDefaultWhiteList;
	exports.onTag = onTag;
	exports.onIgnoreTag = onIgnoreTag;
	exports.onTagAttr = onTagAttr;
	exports.onIgnoreTagAttr = onIgnoreTagAttr;
	exports.safeAttrValue = safeAttrValue;
	exports.escapeHtml = escapeHtml;
	exports.escapeQuote = escapeQuote;
	exports.unescapeQuote = unescapeQuote;
	exports.escapeHtmlEntities = escapeHtmlEntities;
	exports.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
	exports.clearNonPrintableCharacter = clearNonPrintableCharacter;
	exports.friendlyAttrValue = friendlyAttrValue;
	exports.escapeAttrValue = escapeAttrValue;
	exports.onIgnoreTagStripAll = onIgnoreTagStripAll;
	exports.StripTagBody = StripTagBody;
	exports.stripCommentTag = stripCommentTag;
	exports.stripBlankChar = stripBlankChar;
	exports.cssFilter = defaultCSSFilter;
	exports.getDefaultCSSWhiteList = getDefaultCSSWhiteList;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * xss
	 *
	 * @author Zongmin Lei<leizongmin@gmail.com>
	 */
	
	var DEFAULT = __webpack_require__(1014);
	var parser = __webpack_require__(1016);
	var FilterXSS = __webpack_require__(2331);
	
	/**
	 * filter xss function
	 *
	 * @param {String} html
	 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
	 * @return {String}
	 */
	function filterXSS(html, options) {
	  var xss = new FilterXSS(options);
	  return xss.process(html);
	}
	
	exports = module.exports = filterXSS;
	exports.filterXSS = filterXSS;
	exports.FilterXSS = FilterXSS;
	
	(function () {
	  for (var i in DEFAULT) {
	    exports[i] = DEFAULT[i];
	  }
	  for (var j in parser) {
	    exports[j] = parser[j];
	  }
	})();
	
	// using `xss` on the browser, output `filterXSS` to the globals
	if (typeof window !== "undefined") {
	  window.filterXSS = module.exports;
	}
	
	// using `xss` on the WebWorker, output `filterXSS` to the globals
	function isWorkerEnv() {
	  return (
	    typeof self !== "undefined" &&
	    typeof DedicatedWorkerGlobalScope !== "undefined" &&
	    self instanceof DedicatedWorkerGlobalScope
	  );
	}
	if (isWorkerEnv()) {
	  self.filterXSS = module.exports;
	}


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Simple HTML Parser
	 *
	 * @author Zongmin Lei<leizongmin@gmail.com>
	 */
	
	var _ = __webpack_require__(590);
	
	/**
	 * get tag name
	 *
	 * @param {String} html e.g. '<a hef="#">'
	 * @return {String}
	 */
	function getTagName(html) {
	  var i = _.spaceIndex(html);
	  var tagName;
	  if (i === -1) {
	    tagName = html.slice(1, -1);
	  } else {
	    tagName = html.slice(1, i + 1);
	  }
	  tagName = _.trim(tagName).toLowerCase();
	  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
	  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
	  return tagName;
	}
	
	/**
	 * is close tag?
	 *
	 * @param {String} html 如：'<a hef="#">'
	 * @return {Boolean}
	 */
	function isClosing(html) {
	  return html.slice(0, 2) === "</";
	}
	
	/**
	 * parse input html and returns processed html
	 *
	 * @param {String} html
	 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
	 * @param {Function} escapeHtml
	 * @return {String}
	 */
	function parseTag(html, onTag, escapeHtml) {
	  "use strict";
	
	  var rethtml = "";
	  var lastPos = 0;
	  var tagStart = false;
	  var quoteStart = false;
	  var currentPos = 0;
	  var len = html.length;
	  var currentTagName = "";
	  var currentHtml = "";
	
	  chariterator: for (currentPos = 0; currentPos < len; currentPos++) {
	    var c = html.charAt(currentPos);
	    if (tagStart === false) {
	      if (c === "<") {
	        tagStart = currentPos;
	        continue;
	      }
	    } else {
	      if (quoteStart === false) {
	        if (c === "<") {
	          rethtml += escapeHtml(html.slice(lastPos, currentPos));
	          tagStart = currentPos;
	          lastPos = currentPos;
	          continue;
	        }
	        if (c === ">" || currentPos === len - 1) {
	          rethtml += escapeHtml(html.slice(lastPos, tagStart));
	          currentHtml = html.slice(tagStart, currentPos + 1);
	          currentTagName = getTagName(currentHtml);
	          rethtml += onTag(
	            tagStart,
	            rethtml.length,
	            currentTagName,
	            currentHtml,
	            isClosing(currentHtml)
	          );
	          lastPos = currentPos + 1;
	          tagStart = false;
	          continue;
	        }
	        if (c === '"' || c === "'") {
	          var i = 1;
	          var ic = html.charAt(currentPos - i);
	
	          while (ic.trim() === "" || ic === "=") {
	            if (ic === "=") {
	              quoteStart = c;
	              continue chariterator;
	            }
	            ic = html.charAt(currentPos - ++i);
	          }
	        }
	      } else {
	        if (c === quoteStart) {
	          quoteStart = false;
	          continue;
	        }
	      }
	    }
	  }
	  if (lastPos < len) {
	    rethtml += escapeHtml(html.substr(lastPos));
	  }
	
	  return rethtml;
	}
	
	var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;
	
	/**
	 * parse input attributes and returns processed attributes
	 *
	 * @param {String} html e.g. `href="#" target="_blank"`
	 * @param {Function} onAttr e.g. `function (name, value)`
	 * @return {String}
	 */
	function parseAttr(html, onAttr) {
	  "use strict";
	
	  var lastPos = 0;
	  var lastMarkPos = 0;
	  var retAttrs = [];
	  var tmpName = false;
	  var len = html.length;
	
	  function addAttr(name, value) {
	    name = _.trim(name);
	    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
	    if (name.length < 1) return;
	    var ret = onAttr(name, value || "");
	    if (ret) retAttrs.push(ret);
	  }
	
	  // 逐个分析字符
	  for (var i = 0; i < len; i++) {
	    var c = html.charAt(i);
	    var v, j;
	    if (tmpName === false && c === "=") {
	      tmpName = html.slice(lastPos, i);
	      lastPos = i + 1;
	      lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : findNextQuotationMark(html, i + 1);
	      continue;
	    }
	    if (tmpName !== false) {
	      if (
	        i === lastMarkPos
	      ) {
	        j = html.indexOf(c, i + 1);
	        if (j === -1) {
	          break;
	        } else {
	          v = _.trim(html.slice(lastMarkPos + 1, j));
	          addAttr(tmpName, v);
	          tmpName = false;
	          i = j;
	          lastPos = i + 1;
	          continue;
	        }
	      }
	    }
	    if (/\s|\n|\t/.test(c)) {
	      html = html.replace(/\s|\n|\t/g, " ");
	      if (tmpName === false) {
	        j = findNextEqual(html, i);
	        if (j === -1) {
	          v = _.trim(html.slice(lastPos, i));
	          addAttr(v);
	          tmpName = false;
	          lastPos = i + 1;
	          continue;
	        } else {
	          i = j - 1;
	          continue;
	        }
	      } else {
	        j = findBeforeEqual(html, i - 1);
	        if (j === -1) {
	          v = _.trim(html.slice(lastPos, i));
	          v = stripQuoteWrap(v);
	          addAttr(tmpName, v);
	          tmpName = false;
	          lastPos = i + 1;
	          continue;
	        } else {
	          continue;
	        }
	      }
	    }
	  }
	
	  if (lastPos < html.length) {
	    if (tmpName === false) {
	      addAttr(html.slice(lastPos));
	    } else {
	      addAttr(tmpName, stripQuoteWrap(_.trim(html.slice(lastPos))));
	    }
	  }
	
	  return _.trim(retAttrs.join(" "));
	}
	
	function findNextEqual(str, i) {
	  for (; i < str.length; i++) {
	    var c = str[i];
	    if (c === " ") continue;
	    if (c === "=") return i;
	    return -1;
	  }
	}
	
	function findNextQuotationMark(str, i) {
	  for (; i < str.length; i++) {
	    var c = str[i];
	    if (c === " ") continue;
	    if (c === "'" || c === '"') return i;
	    return -1;
	  }
	}
	
	function findBeforeEqual(str, i) {
	  for (; i > 0; i--) {
	    var c = str[i];
	    if (c === " ") continue;
	    if (c === "=") return i;
	    return -1;
	  }
	}
	
	function isQuoteWrapString(text) {
	  if (
	    (text[0] === '"' && text[text.length - 1] === '"') ||
	    (text[0] === "'" && text[text.length - 1] === "'")
	  ) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function stripQuoteWrap(text) {
	  if (isQuoteWrapString(text)) {
	    return text.substr(1, text.length - 2);
	  } else {
	    return text;
	  }
	}
	
	exports.parseTag = parseTag;
	exports.parseAttr = parseAttr;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./a-arrow_2x.png": 952,
		"./a-edit_2x.png": 953,
		"./a-info_2x.png": 528,
		"./a-location_2x.png": 530,
		"./a-people_2x.png": 531,
		"./a-trash_2x.png": 956,
		"./arrow-down_2x.png": 957,
		"./arrow_back_2x.png": 958,
		"./c-automotive_2x.png": 964,
		"./c-credit_2x.png": 965,
		"./c-family_2x.png": 966,
		"./c-fire_2x.png": 967,
		"./c-health_2x.png": 968,
		"./c-home_2x.png": 969,
		"./c-life_2x.png": 970,
		"./c-misc_2x.png": 971,
		"./c-transport_2x.png": 972,
		"./c-workinjuries_2x.png": 973,
		"./close_2x.png": 533,
		"./document_2x.png": 975,
		"./dropdown-arrow_2x.png": 976,
		"./icn-dashboard_2x.png": 981,
		"./icn-events_2x.png": 982,
		"./icn-link_2x.png": 983,
		"./icn-marketing_2x.png": 984,
		"./l-logo_2x.png": 985,
		"./logo-glyph-white-m_2x.png": 986,
		"./logo-glyph-white_2x.png": 987,
		"./logo_2x.png": 988,
		"./m-client_2x.png": 989,
		"./m-dashboard_2x.png": 990,
		"./m-link_2x.png": 991,
		"./m-logo_2x.png": 992,
		"./m-marketing_2x.png": 993,
		"./menu_2x.png": 587,
		"./minus_2x.png": 994,
		"./n-avatar_2x.png": 995,
		"./n-claims_2x.png": 996,
		"./n-contracts_2x.png": 997,
		"./n-source_2x.png": 998,
		"./n-tag_2x.png": 999,
		"./office-logo_2x.png": 1001,
		"./p-avatar_2x.png": 1002,
		"./p-close_2x.png": 1004,
		"./pdf-icon_2x.png": 1005,
		"./plus_2x.png": 1006,
		"./pro-arrow_2x.png": 589,
		"./r-close_2x.png": 1008,
		"./search_2x.png": 1010
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1017;


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	function _extends() {
	  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(1023);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (e.includes(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	module.exports = murmurhash2_32_gc;


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	'use strict';
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	module.exports = memoize;


/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	'use strict';
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e, m).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        switch (d.constructor) {
	          case Array:
	            for (var c = 0, e = d.length; c < e; ++c) {
	              T(d[c]);
	            }
	
	            break;
	
	          case Function:
	            S[A++] = d;
	            break;
	
	          case Boolean:
	            Y = !!d | 0;
	        }
	
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	module.exports = stylis_min;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	'use strict';
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	module.exports = unitlessKeys;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEFAULT_SIZE = 24;
	
	exports.default = function (_ref) {
	  var _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
	      style: _extends({ fill: fill, width: width, height: height }, style)
	    }, props),
	    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	  );
	};

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEFAULT_SIZE = 24;
	
	exports.default = function (_ref) {
	  var _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
	      style: _extends({ fill: fill, width: width, height: height }, style)
	    }, props),
	    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
	  );
	};

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(1030);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(36);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(1031);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback, option) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    var _ret = (function () {
	      var useCapture = false;
	      if (typeof option === 'object') {
	        useCapture = option.capture || false;
	      } else if (typeof option === 'boolean') {
	        useCapture = option;
	      }
	
	      target.addEventListener(eventType, wrapCallback, option || false);
	
	      return {
	        v: {
	          remove: function remove() {
	            target.removeEventListener(eventType, wrapCallback, useCapture);
	          }
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sharedWizardModalContent = __webpack_require__(218);
	
	var _sharedWizardModalContent2 = _interopRequireDefault(_sharedWizardModalContent);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ClaimWizardScss = __webpack_require__(155);
	
	var _ClaimWizardScss2 = _interopRequireDefault(_ClaimWizardScss);
	
	// variables out of module
	var _ = (0, _libI18n2["default"])('claimWizard');
	
	function ClaimWarningModal(props) {
	    var modalTitle = props.modalTitle;
	    var message = props.message;
	
	    return _react2["default"].createElement(
	        _sharedWizardModalContent2["default"],
	        { modalTitle: modalTitle },
	        _react2["default"].createElement(
	            "div",
	            { className: _ClaimWizardScss2["default"].modalFormContent },
	            _react2["default"].createElement(
	                "div",
	                { className: _ClaimWizardScss2["default"].sectionWrapper },
	                _react2["default"].createElement(
	                    "span",
	                    { className: _ClaimWizardScss2["default"].message },
	                    message
	                )
	            ),
	            props.children
	        )
	    );
	}
	
	exports["default"] = ClaimWarningModal;
	module.exports = exports["default"];

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sharedWizardModalContent = __webpack_require__(218);
	
	var _sharedWizardModalContent2 = _interopRequireDefault(_sharedWizardModalContent);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClaimWizardScss = __webpack_require__(155);
	
	var _ClaimWizardScss2 = _interopRequireDefault(_ClaimWizardScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _claimsWizardService = __webpack_require__(217);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('claimWizard');
	
	var ClaimWizardStepFour = function ClaimWizardStepFour(props) {
	    var claimDocumentsOptions = props.claimDocumentsOptions;
	    var missingInfo = props.missingInfo;
	    var involvedPartiesData = props.involvedPartiesData;
	    var involvedParties = props.involvedParties;
	    var formData = props.formData;
	    var clientOptionsDict = props.clientOptionsDict;
	    var documentFiles = props.documentFiles;
	    var oraDocuments = props.oraDocuments;
	    var docsFromDocumentation = props.docsFromDocumentation;
	
	    var getDocumentLabel = function getDocumentLabel(docType) {
	        var index = claimDocumentsOptions.findIndex(function (oneOption) {
	            return oneOption.value === docType;
	        });
	        if (index === -1) {
	            return docType;
	        }
	        return claimDocumentsOptions[index].label;
	    };
	
	    /**
	     * Get a list of unfinished DS package files that are required for the wizard and have not been uploaded
	     */
	    var unfinishedDsPackageFiles = documentFiles.filter(function (file) {
	        return file.dsPackageStatus && file.dsPackageStatus !== 'packageStatusFinished' && !file.uploaded && oraDocuments.find(function (doc) {
	            return doc.required === 'Wizard' && (doc.docType === file.docType || doc.alternativeDocTypes.some(function (altDoc) {
	                return altDoc.altDocType === file.docType;
	            }));
	        });
	    });
	
	    var missingInvolvedPartiesInfo = function missingInvolvedPartiesInfo() {
	        var missingInfoMessages = [];
	
	        if (involvedParties && involvedParties.length > 0) {
	            involvedParties.forEach(function (party) {
	                var partyIndex = involvedPartiesData.findIndex(function (p) {
	                    return p.partyNumber === party.partyNumber;
	                });
	                var errorData = {
	                    partyNumber: '',
	                    label: '',
	                    errorMessages: []
	                };
	
	                if (partyIndex > -1) {
	                    (function () {
	                        var partyData = involvedPartiesData[partyIndex];
	                        if (party.requiredFields && party.requiredFields.length > 0) {
	                            party.requiredFields.forEach(function (field) {
	                                switch (field) {
	                                    case 'Name':
	                                        if (!partyData.fields.lastName.value || partyData.fields.lastName.value === '') {
	                                            errorData.errorMessages.push(_('missingInfoMessage') + ' ' + _('lastName'));
	                                        }
	                                        break;
	                                    case 'Mail':
	                                        if (!partyData.fields.email.value || partyData.fields.email.value === '') {
	                                            errorData.errorMessages.push(_('missingInfoMessage') + ' ' + _('email'));
	                                        }
	                                        break;
	                                    case 'Phone':
	                                        if (!partyData.fields.phoneNumber.value || partyData.fields.phoneNumber.value === '') {
	                                            errorData.errorMessages.push(_('missingInfoMessage') + ' ' + _('phone'));
	                                        }
	                                        break;
	                                    case 'Address':
	                                        var addressFields = ['street', 'number', 'postalCode', 'town', 'country'];
	                                        var _iteratorNormalCompletion = true;
	                                        var _didIteratorError = false;
	                                        var _iteratorError = undefined;
	
	                                        try {
	                                            for (var _iterator = addressFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                                var addressField = _step.value;
	
	                                                if (!partyData.fields[addressField].value || partyData.fields[addressField].value === '') {
	                                                    errorData.errorMessages.push(_('missingInfoMessage') + ' ' + _(addressField));
	                                                }
	                                            }
	                                        } catch (err) {
	                                            _didIteratorError = true;
	                                            _iteratorError = err;
	                                        } finally {
	                                            try {
	                                                if (!_iteratorNormalCompletion && _iterator['return']) {
	                                                    _iterator['return']();
	                                                }
	                                            } finally {
	                                                if (_didIteratorError) {
	                                                    throw _iteratorError;
	                                                }
	                                            }
	                                        }
	
	                                        break;
	                                    default:
	                                        break;
	                                }
	                            });
	                        }
	                    })();
	                }
	                if (errorData.errorMessages.length > 0) {
	                    errorData.partyNumber = party.partyNumber;
	                    missingInfoMessages.push(errorData);
	                }
	            });
	        }
	        return missingInfoMessages;
	    };
	
	    return _react2['default'].createElement(
	        _sharedWizardModalContent2['default'],
	        { modalTitle: _('stepFourTitle') },
	        _react2['default'].createElement(
	            'form',
	            { method: 'post', onSubmit: function (ev) {
	                    return ev.preventDefault();
	                }, className: _ClaimWizardScss2['default'].modalFormContent, key: "claimWizardStepFourForm" },
	            _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _ClaimWizardScss2['default'].titleLabel },
	                        _('stepFourSubTitle')
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].stepFourComment },
	                    _react2['default'].createElement('textarea', _extends({
	                        name: 'claimComment'
	                    }, formData.claimComment))
	                )
	            ),
	            missingInfo && missingInfo.involvedParties && missingInfo.involvedParties.length > 0 && _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].missingInfoWrapper },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _ClaimWizardScss2['default'].missingInfoTitle },
	                        _('missingInvolvedPartiesData')
	                    )
	                ),
	                missingInvolvedPartiesInfo().map(function (party, index) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { key: index, className: _ClaimWizardScss2['default'].missingInfoWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _ClaimWizardScss2['default'].missingInfoSubtitle },
	                            '' + clientOptionsDict.involvedParties.find(function (i) {
	                                return i.value === party.partyNumber;
	                            }).label
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            party.errorMessages.map(function (message, index) {
	                                return _react2['default'].createElement(
	                                    'div',
	                                    { key: index, className: _ClaimWizardScss2['default'].missingInfo },
	                                    message
	                                );
	                            })
	                        )
	                    );
	                })
	            ),
	            (0, _claimsWizardService.missingWizardDocuments)(missingInfo, oraDocuments, docsFromDocumentation, documentFiles) && (0, _claimsWizardService.missingWizardDocuments)(missingInfo, oraDocuments, docsFromDocumentation, documentFiles).length > 0 && _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].missingInfoWrapper },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _ClaimWizardScss2['default'].missingInfoTitle },
	                        _('missingDocuments')
	                    )
	                ),
	                (0, _claimsWizardService.missingWizardDocuments)(missingInfo, oraDocuments, docsFromDocumentation, documentFiles).map(function (doc, index) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { key: index, className: _ClaimWizardScss2['default'].missingInfoWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _ClaimWizardScss2['default'].missingInfo },
	                            '' + getDocumentLabel(doc)
	                        )
	                    );
	                })
	            ),
	            unfinishedDsPackageFiles && unfinishedDsPackageFiles.length > 0 && _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].missingInfoWrapper },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _ClaimWizardScss2['default'].missingInfoTitle },
	                        _('unfinishedDsDocuments')
	                    )
	                ),
	                unfinishedDsPackageFiles.map(function (doc, index) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { key: index, className: _ClaimWizardScss2['default'].missingInfoWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _ClaimWizardScss2['default'].missingInfo },
	                            '' + doc.name
	                        )
	                    );
	                })
	            ),
	            props.children
	        )
	    );
	};
	
	exports['default'] = ClaimWizardStepFour;
	module.exports = exports['default'];
	/* <div className={styles.formInput}> */ /* <div className={styles.commentWrapper}>*/ /* <div className={styles.missingInfo}>{`${getDocumentLabel(doc.docType)}`}</div> */

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _sharedWizardModalContent = __webpack_require__(218);
	
	var _sharedWizardModalContent2 = _interopRequireDefault(_sharedWizardModalContent);
	
	var _ClaimWizardScss = __webpack_require__(155);
	
	var _ClaimWizardScss2 = _interopRequireDefault(_ClaimWizardScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _claimsWizardService = __webpack_require__(217);
	
	var _sharedWizardSelectsWizardReactSelect = __webpack_require__(362);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	// variables out of module
	var _ = (0, _libI18n2["default"])('claimWizard');
	
	var ClaimWizardStepOne = (function (_Component) {
	    _inherits(ClaimWizardStepOne, _Component);
	
	    function ClaimWizardStepOne(props) {
	        _classCallCheck(this, ClaimWizardStepOne);
	
	        _get(Object.getPrototypeOf(ClaimWizardStepOne.prototype), "constructor", this).call(this, props);
	    }
	
	    _createClass(ClaimWizardStepOne, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props;
	            var formData = _props.formData;
	            var phoneNumberOptions = _props.phoneNumberOptions;
	            var mobilePhoneOptions = _props.mobilePhoneOptions;
	            var emailOptions = _props.emailOptions;
	            var productListOptions = _props.productListOptions;
	            var selfManaging = _props.selfManaging;
	            var onClaimDateHandler = _props.onClaimDateHandler;
	            var handleProductChange = _props.handleProductChange;
	            var handleQualificationChange = _props.handleQualificationChange;
	            var riskOptionsList = _props.riskOptionsList;
	            var qualificationOptionsList = _props.qualificationOptionsList;
	            var accountNumberOptions = _props.accountNumberOptions;
	            var subQualificationOptionsList = _props.subQualificationOptionsList;
	            var isLegalAid = _props.isLegalAid;
	            var isExistingClaim = _props.isExistingClaim;
	            var errors = _props.errors;
	            var handleSelfManagingChange = _props.handleSelfManagingChange;
	            var dispatch = _props.dispatch;
	
	            var selfManagingOptions = [{ value: 'true', label: _('Yes') }, { value: 'false', label: _('No') }];
	
	            var hasInitialValue = formData.email.value.length === 0 && formData.mobileNumber.value.length === 0 && formData.phoneNumber.value.length === 0;
	
	            return _react2["default"].createElement(
	                _sharedWizardModalContent2["default"],
	                { modalTitle: _('stepOneTitle') },
	                _react2["default"].createElement(
	                    "form",
	                    { method: "post", onSubmit: function (ev) {
	                            return ev.preventDefault();
	                        }, className: _ClaimWizardScss2["default"].modalFormContent,
	                        key: "claimWizardStepOneForm" },
	                    _react2["default"].createElement(
	                        "div",
	                        { className: _ClaimWizardScss2["default"].sectionWrapper, key: "brokerSection" },
	                        !isLegalAid && selfManaging && _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "selfManagingContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('selfManaging'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.selfManaging, {
	                                    options: selfManagingOptions,
	                                    onChange: function (value) {
	                                        handleSelfManagingChange(value.vale);
	                                        (0, _claimsWizardService.updatedFormValue)(value, formData.selfManaging, dispatch);
	                                    },
	                                    name: "selfManaging",
	                                    isCreatableSelect: false,
	                                    isDisabled: isExistingClaim
	                                }))
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "brokerNameContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('brokerName'),
	                                " "
	                            ),
	                            _react2["default"].createElement("input", _extends({
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                ref: "claimNumber",
	                                name: "claimNumber",
	                                disabled: true
	                            }, formData.brokerName))
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "claimNumberContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('claimNumber'),
	                                " "
	                            ),
	                            _react2["default"].createElement("input", _extends({
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                ref: "claimNumber",
	                                name: "claimNumber",
	                                disabled: true
	                            }, formData.claimNumber))
	                        ),
	                        _react2["default"].createElement("div", { className: _ClaimWizardScss2["default"].formSeparator })
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: _ClaimWizardScss2["default"].sectionWrapper, key: "clientSection" },
	                        _react2["default"].createElement(
	                            "span",
	                            { className: _ClaimWizardScss2["default"].fillMostFieldsLabel },
	                            _('contactDetailFillInfosLabel')
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "clientNameContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('clientName'),
	                                " "
	                            ),
	                            _react2["default"].createElement("input", _extends({
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                ref: "clientName",
	                                name: "clientName",
	                                disabled: true
	                            }, formData.clientName))
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "phoneNumberContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('phoneNumber'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.phoneNumber, {
	                                    options: phoneNumberOptions,
	                                    onChange: function (value) {
	                                        return (0, _claimsWizardService.updatedFormValue)(value, formData.phoneNumber, dispatch);
	                                    },
	                                    name: "phoneNumber",
	                                    noOptionsLabel: _('phoneNumberNoOptions'),
	                                    formatCreateLabel: _('newClaimPhoneNumber'),
	                                    isClearable: true,
	                                    isCreatableSelect: true
	                                }))
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, (formData.phoneNumber.touched || formData.mobileNumber.touched || formData.email.touched) && errors.stepOne && errors.stepOne.phoneNumber ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                errors.stepOne && errors.stepOne.phoneNumber
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "mobileNumberContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('mobileNumber'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.mobileNumber, {
	                                    options: mobilePhoneOptions,
	                                    onChange: function (value) {
	                                        return (0, _claimsWizardService.updatedFormValue)(value, formData.mobileNumber, dispatch);
	                                    },
	                                    name: "mobileNumber",
	                                    formatCreateLabel: _('newClaimPhoneNumber'),
	                                    isClearable: true,
	                                    isCreatableSelect: true
	
	                                }))
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, (formData.mobileNumber.touched || formData.phoneNumber.touched || formData.email.touched) && errors.stepOne && errors.stepOne.mobileNumber ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                errors.stepOne && errors.stepOne.mobileNumber
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "emailContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('email'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.email, {
	                                    options: emailOptions,
	                                    onChange: function (value) {
	                                        return (0, _claimsWizardService.updatedFormValue)(value, formData.email, dispatch);
	                                    },
	                                    formatCreateLabel: _('newClaimEmail'),
	                                    name: "email",
	                                    isClearable: true,
	                                    isCreatableSelect: true
	                                }))
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, (formData.email.touched || formData.mobileNumber.touched || formData.phoneNumber.touched) && errors.stepOne && errors.stepOne.email || hasInitialValue ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                errors.stepOne && (errors.stepOne.email || errors.stepOne.phoneNumber || errors.stepOne.mobileNumber)
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "accountNumberContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('accountNumber'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.accountNumber, {
	                                    options: accountNumberOptions,
	                                    onChange: function (value) {
	                                        return (0, _claimsWizardService.updatedFormValue)(value, formData.accountNumber, dispatch);
	                                    },
	                                    formatCreateLabel: _('newClaimAccountNumber'),
	                                    name: "accountNumber",
	                                    isClearable: true,
	                                    isCreatableSelect: false
	                                }))
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, formData.accountNumber.touched && errors.stepOne && errors.stepOne.accountNumber ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                formData.accountNumber.touched && errors.stepOne && errors.stepOne.accountNumber
	                            )
	                        ),
	                        formData.accountNumber.value && _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "bakConfirmation" },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].sizeExtraSmall) },
	                                _react2["default"].createElement("input", _extends({
	                                    className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInputCheckboxLeft),
	                                    type: "checkBox",
	                                    ref: "claimNumber",
	                                    name: "claimNumber"
	                                }, formData.accountConfirmation))
	                            ),
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('accountConfirmationLabel'),
	                                " "
	                            )
	                        ),
	                        formData.accountNumber.value && _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, formData.accountConfirmation.touched && errors.stepOne && errors.stepOne.accountConfirmation ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                formData.accountConfirmation.touched && errors.stepOne && errors.stepOne.accountConfirmation
	                            )
	                        ),
	                        _react2["default"].createElement("div", { className: _ClaimWizardScss2["default"].formSeparator })
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: _ClaimWizardScss2["default"].sectionWrapper, key: "claimSection" },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "claimDateContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('claimDate'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].inputsForceRow) },
	                                _react2["default"].createElement(
	                                    "div",
	                                    { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first) },
	                                    _react2["default"].createElement(_componentsSharedDatePicker.DatePicker, _extends({}, formData.claimDate, {
	                                        onChange: function (ev) {
	                                            onClaimDateHandler(ev);
	                                            formData.claimDate.onChange(ev);
	                                        },
	                                        disabled: isExistingClaim
	                                    }))
	                                ),
	                                _react2["default"].createElement(
	                                    "div",
	                                    { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].marginLeftS, _ClaimWizardScss2["default"].short1) },
	                                    _('claimRefBrokerLabel')
	                                ),
	                                _react2["default"].createElement(
	                                    "div",
	                                    { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].shortMargin, _ClaimWizardScss2["default"].last) },
	                                    _react2["default"].createElement("input", _extends({
	                                        className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                        type: "text",
	                                        ref: "claimRefBroker",
	                                        name: "claimRefBroker"
	                                    }, formData.claimRefBroker))
	                                )
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, formData.claimDate.touched && errors.stepOne && errors.stepOne.claimDate ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                formData.claimDate.touched && errors.stepOne && errors.stepOne.claimDate
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "productContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('product'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.productId, {
	                                    options: productListOptions,
	                                    onChange: function (value) {
	                                        handleProductChange(value);
	                                        return (0, _claimsWizardService.updatedFormValue)(value, formData.productId, dispatch);
	                                    },
	                                    name: "product",
	                                    isCreatableSelect: false,
	                                    isDisabled: isExistingClaim || !formData.claimDate.value
	                                }))
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, formData.productId.touched && errors.stepOne && errors.stepOne.productId ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                formData.productId.touched && errors.stepOne && errors.stepOne.productId
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "riskContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('risk'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.riskId, {
	                                    options: riskOptionsList,
	                                    onChange: function (value) {
	                                        (0, _claimsWizardService.updatedFormValue)(value, formData.riskId, dispatch);
	                                        (0, _claimsWizardService.updatedFormValue)({ value: value.label }, formData.riskDescription, dispatch);
	                                    },
	                                    isDisabled: isExistingClaim || (0, _claimsWizardService.disableRiskAndQualificationFields)(formData.productId),
	                                    name: "risk",
	                                    isCreatableSelect: false
	                                }))
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, formData.riskId.touched && errors.stepOne && errors.stepOne.riskId ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                formData.riskId.touched && errors.stepOne && errors.stepOne.riskId
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "qualificationContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('qualification'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.qualificationNumber, {
	                                    options: qualificationOptionsList,
	                                    onChange: function (value) {
	                                        handleQualificationChange(value);
	                                        (0, _claimsWizardService.updatedFormValue)(value, formData.qualificationNumber, dispatch);
	                                        (0, _claimsWizardService.updatedFormValue)({ value: value.label }, formData.qualificationLabel, dispatch);
	                                    },
	                                    isDisabled: isExistingClaim || (0, _claimsWizardService.disableRiskAndQualificationFields)(formData.productId),
	                                    name: "qualification",
	                                    isCreatableSelect: false
	                                }))
	                            )
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, formData.qualificationNumber.touched && errors.stepOne && errors.stepOne.qualificationNumber ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                formData.qualificationNumber.touched && errors.stepOne && errors.stepOne.qualificationNumber
	                            )
	                        ),
	                        subQualificationOptionsList && subQualificationOptionsList.length > 0 && _react2["default"].createElement(
	                            "div",
	                            { className: _ClaimWizardScss2["default"].formInputContainer, key: "subQualificationContainer" },
	                            _react2["default"].createElement(
	                                "label",
	                                { className: _ClaimWizardScss2["default"].formLabel },
	                                _('subQualification'),
	                                " "
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect) },
	                                _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, _extends({
	                                    type: "text"
	                                }, formData.subQualificationNumber, {
	                                    options: subQualificationOptionsList,
	                                    onChange: function (value) {
	                                        return (0, _claimsWizardService.updatedFormValue)(value, formData.subQualificationNumber, dispatch);
	                                    },
	                                    isDisabled: isExistingClaim || (0, _claimsWizardService.disableRiskAndQualificationFields)(formData.productId),
	                                    name: "subQualification",
	                                    isCreatableSelect: false
	                                }))
	                            )
	                        ),
	                        subQualificationOptionsList && subQualificationOptionsList.length > 0 && _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessageContainer, formData.subQualificationNumber.touched && errors.stepOne && errors.stepOne.subQualificationNumber ? "" : _ClaimWizardScss2["default"].none) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].errorMessage, _ClaimWizardScss2["default"].textAlignLeft) },
	                                formData.subQualificationNumber.touched && errors.stepOne && errors.stepOne.subQualificationNumber
	                            )
	                        )
	                    ),
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return ClaimWizardStepOne;
	})(_react.Component);
	
	exports["default"] = ClaimWizardStepOne;
	module.exports = exports["default"];

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _this = this;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(858);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClaimWizardScss = __webpack_require__(155);
	
	var _ClaimWizardScss2 = _interopRequireDefault(_ClaimWizardScss);
	
	var _sharedWizardModalContent = __webpack_require__(218);
	
	var _sharedWizardModalContent2 = _interopRequireDefault(_sharedWizardModalContent);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _sharedWizardSelectsWizardReactSelect = __webpack_require__(362);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _sharedWizardButtonsWizardButtons = __webpack_require__(361);
	
	var _sharedWizardButtonsWizardButtons2 = _interopRequireDefault(_sharedWizardButtonsWizardButtons);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _DSDocumentsDsListButtonsWrapper = __webpack_require__(364);
	
	var _DSDocumentsDsListButtonsWrapper2 = _interopRequireDefault(_DSDocumentsDsListButtonsWrapper);
	
	var _emailSenderEmailButton = __webpack_require__(108);
	
	var _emailSenderEmailButton2 = _interopRequireDefault(_emailSenderEmailButton);
	
	var _DSDocumentsDocumentsHelpers = __webpack_require__(106);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('claimWizard');
	var ClaimWizardStepThree = function ClaimWizardStepThree(props) {
	    var claimWizardDocumentsData = props.claimWizardDocumentsData;
	    var claimDocumentsOptions = props.claimDocumentsOptions;
	    var setAlternativeMethod = props.setAlternativeMethod;
	    var onAddOptionalDocument = props.onAddOptionalDocument;
	    var onRemoveOptionalDocument = props.onRemoveOptionalDocument;
	    var onChangeOptionalDoctypeId = props.onChangeOptionalDoctypeId;
	    var claimData = props.claimData;
	    var clientData = props.clientData;
	    var contractDetails = props.contractDetails;
	    var docsFromDocumentation = props.docsFromDocumentation;
	    var isDragging = props.isDragging;
	    var setFileDrag = props.setFileDrag;
	    var addFilesToClaimWizardState = props.addFilesToClaimWizardState;
	    var documentFiles = props.documentFiles;
	    var removeDocumentFile = props.removeDocumentFile;
	    var updateDsPackageList = props.updateDsPackageList;
	    var dsPackages = props.dsPackages;
	    var canCreateMifid = props.canCreateMifid;
	    var directSignMethod = props.directSignMethod;
	    var recreatePackageMethod = props.recreatePackageMethod;
	    var sendRemindersMethod = props.sendRemindersMethod;
	    var getDsStakeholdersForInvitation = props.getDsStakeholdersForInvitation;
	    var afterInvUpdates = props.afterInvUpdates;
	
	    var temporaryFiles = {};
	    var getDocumentLabel = function getDocumentLabel(docType) {
	        var index = claimDocumentsOptions.findIndex(function (oneOption) {
	            return oneOption.value === docType;
	        });
	        if (index === -1) {
	            return docType;
	        }
	        return claimDocumentsOptions[index].label;
	    };
	
	    var getAlternativeOptions = function getAlternativeOptions(doc) {
	        var alternativeDocOptions = [{
	            label: _('mainDocOption'),
	            value: doc.docType
	        }];
	        if (doc.alternativeDocTypes) {
	            doc.alternativeDocTypes.forEach(function (option) {
	                alternativeDocOptions.push({
	                    label: _('alternativeDocOption') + ' ' + option.alternativeLabel,
	                    value: option.alternativeId
	                });
	            });
	        }
	        return alternativeDocOptions;
	    };
	
	    var getOptionalDocumentOptions = function getOptionalDocumentOptions(documents, currentDocType) {
	
	        var result = [];
	        docsFromDocumentation.forEach(function (oneDocument) {
	            if (oneDocument.required === "Optional") {
	                if (oneDocument.docType === currentDocType || !documents.some(function (doc) {
	                    return doc.docType === oneDocument.docType;
	                })) {
	                    result.push({
	                        label: getDocumentLabel(oneDocument.docType),
	                        value: oneDocument.docType
	                    });
	                }
	            }
	        });
	        result.sort(function (a, b) {
	            return a.label.localeCompare(b.label);
	        });
	
	        return result;
	    };
	
	    var collectModuleOptions = function collectModuleOptions() {
	        var clientId = claimData.clientId;
	
	        var contractId = _nestedProperty2['default'].get(claimData, "contractId");
	
	        var contractDocuments = _nestedProperty2['default'].get(contractDetails, "documents");
	        var contractDocumentsId = contractId;
	
	        var emails = _nestedProperty2['default'].get(clientData, clientId + '.detail.emails');
	        var clientName = _nestedProperty2['default'].get(claimData, "clientName");
	
	        if (emails && emails.length) {
	            emails = emails.map(function (item) {
	                return {
	                    referenceId: clientId,
	                    label: clientName,
	                    value: item.email,
	                    'default': item['default'] == "true" || item['default'] == true ? true : false
	                };
	            });
	
	            emails = emails.sort(function (item, item2) {
	                if (item['default'] && !item2['default']) {
	                    return -1;
	                }
	                if (!item['default'] && item2['default']) {
	                    return 1;
	                }
	                if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                    return 0;
	                }
	            }) || [];
	        }
	        return {
	            contractNumber: contractDetails ? contractDetails.contractNumber : claimData.contractNumber,
	            claimsNumber: claimData.claimNumber,
	            clientName: clientName,
	            clientEmails: emails,
	
	            clientDocuments: _nestedProperty2['default'].get(clientData, clientId + ".clientDocuments"),
	            clientDocumentsType: 'client',
	            clientDocumentsId: clientId,
	
	            // new v6 mode
	            claimDocuments: claimData.documents || [],
	            claimDocumentsType: "claim",
	            claimDocumentsId: claimData.claimId,
	            companyCancelMail: _nestedProperty2['default'].get(contractDetails, 'companyCancelMail'),
	
	            contractDocuments: contractDocuments || [],
	            contractDocumentsType: "contract",
	            contractDocumentsId: contractDocumentsId,
	
	            clientId: false,
	            contractId: false,
	            claimId: claimData.claimId,
	            company: _nestedProperty2['default'].get(contractDetails, 'insuranceCompany'),
	
	            brokerNumber: _nestedProperty2['default'].get(clientData, "brokerNumber"),
	            claim: claimData,
	            // claimDetail,
	            clientNumber: _nestedProperty2['default'].get(clientData, ".main.clientNumber"),
	            clientData: clientData
	        };
	    };
	
	    /**
	     * Will create a new file object and add it to the temporaryFiles object
	     * Will set a list of files to store in the state
	     * Will end drag event
	     * @param {*} docType
	     * @param {*} ev 
	     */
	    var addFiles = function addFiles(ev, docType, alternativeId, mainDocType) {
	        var files = ev;
	        var tempStoreFiles = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var file = _step.value;
	
	                var fileId = (0, _uuidV42['default'])();
	                var oneTemp = {
	                    name: file.name,
	                    lastModified: (0, _moment2['default'])(),
	                    size: file.size,
	                    type: file.type.split('/').splice(-1)[0],
	                    progress: 0,
	                    fileId: fileId,
	                    docType: docType,
	                    uploaded: false,
	                    error: '',
	                    alternativeId: alternativeId,
	                    mainDocType: mainDocType,
	                    file: file
	                };
	                if (oneTemp.size > 10 * 1024 * 1024) {
	                    oneTemp.error = _('too_large_file');
	                }
	                if (oneTemp.size === 0) {
	                    oneTemp.error = _('file_is_empty_maybe_compressed');
	                }
	                //error is wrong file type
	                if (/^(jpe?g|gif|png|pdf|tiff?)$/.test(oneTemp.type) || /^(|(x-)?download)$/.test(oneTemp.type) && /\.(jpe?g|gif|png|pdf|tiff?)$/.test(oneTemp.name)) {
	                    tempStoreFiles.push(oneTemp);
	                    temporaryFiles[fileId] = file;
	                } else {
	                    oneTemp.error = _('wrong_file_type');
	                    tempStoreFiles.push(oneTemp);
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        addFilesToClaimWizardState(tempStoreFiles);
	        setFileDrag(false);
	    };
	
	    var removeOptionalDocumentAndFiles = function removeOptionalDocumentAndFiles(doc) {
	        var filesToRemove = documentFiles.filter(function (file) {
	            return file.docType === doc.docType;
	        });
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = filesToRemove[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var file = _step2.value;
	
	                removeDocumentFile(file.fileId);
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                    _iterator2['return']();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        onRemoveOptionalDocument(doc.id);
	    };
	
	    /**
	    * This function helps to use an icon on a safe way
	    */
	    var getIcon = function getIcon(iconName) {
	        try {
	            return __webpack_require__(173)("./" + iconName);
	        } catch (err) {
	            return __webpack_require__(23);
	        }
	    };
	
	    /**
	    * Checks if package has stakeholders that haven't signed yet
	    * @param {*} dsPackage
	    * @returns Boolean
	    */
	    var checkForUnfinishedStakeholder = function checkForUnfinishedStakeholder(dsPackage) {
	        var hasUnfinishedStakeholder = false;
	        dsPackage.dsStakeholders.map(function (oneStakeholder) {
	            if (!oneStakeholder.finished && oneStakeholder.signerType !== "BROKER") {
	                hasUnfinishedStakeholder = true;
	            }
	        });
	        return hasUnfinishedStakeholder;
	    };
	
	    // ================================
	    // #region Render
	    // ================================
	
	    var renderListOfDocuments = function renderListOfDocuments(document) {
	        return _react2['default'].createElement(
	            'div',
	            { className: _ClaimWizardScss2['default'].documentListContainer },
	            documentFiles.filter(function (file) {
	                return file.docType === document.docType;
	            }).sort(function (a, b) {
	                return a.name.localeCompare(b.name);
	            }).map(function (file, key) {
	                return _react2['default'].createElement(
	                    'div',
	                    { key: key, className: _ClaimWizardScss2['default'].documentListItem },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _ClaimWizardScss2['default'].documentName },
	                        file.name
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _ClaimWizardScss2['default'].documentStatus },
	                        _react2['default'].createElement(
	                            'label',
	                            { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].formLabel, _ClaimWizardScss2['default'].statusLabel) },
	                            _('documentStatus'),
	                            ':'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].documentStatusValue, file.error ? _ClaimWizardScss2['default'].error : '') },
	                            file.dsPackageStatus ? file.dsPackageStatus !== 'finished' ? _(file.dsPackageStatus) : file.uploaded ? _('uploaded') : _('dsDocumentNotUploaded') : file.uploaded ? _('uploaded') : file.error ? file.error : _('readyToUpload')
	                        )
	                    ),
	                    renderDSButtons(file, key)
	                );
	            })
	        );
	    };
	
	    var renderDSButtons = function renderDSButtons(file, key) {
	        var dsPackage = dsPackages[file.dsPackageId];
	        var isEditableThePackage = (0, _DSDocumentsDocumentsHelpers.shouldEditThePackage)(_nestedProperty2['default'].get(dsPackage, "statusHistory"), _nestedProperty2['default'].get(dsPackage, "isEditable"));
	
	        var blocked = false;
	        var statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed', 'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError', 'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError', 'printed'];
	        if (dsPackage && dsPackage.statusHistory) {
	            dsPackage.statusHistory.forEach(function (oneStatus) {
	                if (statusBlackList.includes(oneStatus.status)) {
	                    blocked = true;
	                }
	            });
	        }
	
	        var packageStatusError = dsPackage && dsPackage.status === _stateConstants2['default'].DS_DOCUMENTS_GENERAL_ERROR || blocked;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: _ClaimWizardScss2['default'].documentActionButtons },
	            _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].removeDocumentBtnWrapper },
	                _react2['default'].createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].removeDocumentBtn, file.uploaded || file.dsPackageStatus ? _ClaimWizardScss2['default'].invisible : ''),
	                        onClick: function (e) {
	                            e.preventDefault();
	                            removeDocumentFile(file.fileId);
	                        }
	                    },
	                    'X'
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: (0, _classnames2['default'])([_ClaimWizardScss2['default'].tooltip, _ClaimWizardScss2['default'].removeDocumentBtnTooltip]) },
	                    _('removeDocumentBtnTooltip')
	                )
	            ),
	            canCreateMifid && dsPackage && _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].mifidWrapper) },
	                _react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
	                    step: _stateConstants2['default'].DSWIZARD_STEP_1_COMPOSE_PACKAGE,
	                    packageId: _nestedProperty2['default'].get(dsPackage, "_id"),
	                    lang: lang,
	                    callBackOnClose: function () {},
	                    callBackOnCloseClaimWizard: function (packageId) {
	                        if (packageId) {
	                            updateDsPackageList(packageId);
	                        }
	                    },
	                    moduleKeyToSet: _nestedProperty2['default'].get(dsPackage, "uploadedOnModule"),
	                    mifidKey: key + _nestedProperty2['default'].get(dsPackage, "_id"),
	                    clientId: _nestedProperty2['default'].get(dsPackage, "clientId"),
	                    claimId: _nestedProperty2['default'].get(dsPackage, "claimId"),
	                    claimNumber: _nestedProperty2['default'].get(dsPackage, "claimNumber"),
	                    contractId: _nestedProperty2['default'].get(dsPackage, "contractId"),
	                    contractNumber: _nestedProperty2['default'].get(dsPackage, "contractNumber"),
	                    tarificationId: _nestedProperty2['default'].get(dsPackage, "tarificationId"),
	                    tarificationNumber: _nestedProperty2['default'].get(dsPackage, "tarificationNumber"),
	                    stakeholders: _nestedProperty2['default'].get(dsPackage, "dsStakeholders"),
	                    claimWizardDocType: _nestedProperty2['default'].get(dsPackage, "claimWizardDocType"),
	                    alienUserId: dsPackage.userId,
	                    hideButton: !isEditableThePackage,
	                    isResume: true,
	                    moduleOptions: collectModuleOptions(),
	                    onlyIcon: true
	                }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: (0, _classnames2['default'])([_ClaimWizardScss2['default'].tooltip, _ClaimWizardScss2['default'].mifidTooltip]) },
	                    _('mifidTooltip')
	                )
	            ),
	            dsPackage && !packageStatusError && dsPackage.mustBeSigned && !dsPackage.hasFinishStatus && checkForUnfinishedStakeholder(dsPackage) && !(0, _DSDocumentsDocumentsHelpers.shouldEditThePackage)(dsPackage.statusHistory, dsPackage.isEditable) && !(0, _DSDocumentsDocumentsHelpers.stakeholdersNeedInvitation)(dsPackage) && _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].marginBot, _ClaimWizardScss2['default'].grow, _ClaimWizardScss2['default'].reminderButtonWrapper) },
	                _react2['default'].createElement(
	                    'button',
	                    { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].greenButton, _ClaimWizardScss2['default'].greenButtonDsList, "enabled", _ClaimWizardScss2['default'].grow),
	                        onClick: function (ev) {
	                            ev.stopPropagation();
	                            return sendRemindersMethod(dsPackage.id);
	                        } },
	                    _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].icon), src: getIcon('icn-inbox-blue.svg', true) })
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: (0, _classnames2['default'])([_ClaimWizardScss2['default'].tooltip, _ClaimWizardScss2['default'].reminderTooltip]) },
	                    _('reminderTooltip')
	                )
	            ),
	            dsPackage && !packageStatusError && dsPackage.mustBeSigned && !dsPackage.hasFinishStatus && (0, _DSDocumentsDocumentsHelpers.stakeholdersNeedInvitation)(dsPackage) && !(0, _DSDocumentsDocumentsHelpers.shouldEditThePackage)(dsPackage.statusHistory, dsPackage.isEditable) && _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].inviteToSignWrapper },
	                _react2['default'].createElement(_emailSenderEmailButton2['default'], {
	                    noLabel: true,
	                    isWhiteIcon: true,
	                    modalId: "emailSenderModal" + dsPackage.id,
	                    hideCC: true,
	                    multiLanguage: true,
	                    serialSending: true,
	                    isCreatable: false,
	                    forceIsMulti: true,
	                    key: "customizeInvitationRenderEmailSenderButtonFromEmailChangerKey",
	                    onInit: function () {},
	                    onSentLate: function callee$2$0(response) {
	                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                case 0:
	                                    context$3$0.next = 2;
	                                    return regeneratorRuntime.awrap(afterInvUpdates(response, dsPackage, dsPackage.dsStakeholders));
	
	                                case 2:
	                                case 'end':
	                                    return context$3$0.stop();
	                            }
	                        }, null, _this);
	                    },
	                    moduleKeyToSet: "clientsClaimsDetail",
	                    moduleOptions: _extends({}, collectModuleOptions(), {
	                        dsPackage: dsPackage,
	                        brokerNumber: _nestedProperty2['default'].get(dsPackage, "brokerNumber"),
	                        brokerEmailAddress: _nestedProperty2['default'].get(dsPackage, "brokerEmailAddress"),
	                        autoSelectTemplate: true,
	                        usePlaceholdersForClientVariables: true,
	                        stakeholders: dsPackage.dsStakeholders.filter(function (oneStake) {
	                            return oneStake.signerType !== "BROKER";
	                        }),
	                        clientEmails: dsPackage.dsStakeholders.filter(function (oneStake) {
	                            return oneStake.signerType !== "BROKER";
	                        }).map(function (oneHolder) {
	                            return {
	                                referenceId: oneHolder._id,
	                                value: oneHolder.email,
	                                lang: oneHolder.language,
	                                isPermanentSelected: true,
	                                isCC: false,
	                                label: oneHolder.firstName + " " + oneHolder.lastName
	                            };
	                        })
	                    }),
	                    getDSStakeholders: function callee$2$0(stakeholderIdArray) {
	                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                case 0:
	                                    context$3$0.next = 2;
	                                    return regeneratorRuntime.awrap(getDsStakeholdersForInvitation(stakeholderIdArray));
	
	                                case 2:
	                                    return context$3$0.abrupt('return', context$3$0.sent);
	
	                                case 3:
	                                case 'end':
	                                    return context$3$0.stop();
	                            }
	                        }, null, _this);
	                    },
	                    customClassName: (0, _classnames2['default'])(_ClaimWizardScss2['default'].greenButton, _ClaimWizardScss2['default'].enabled)
	                }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: (0, _classnames2['default'])([_ClaimWizardScss2['default'].tooltip, _ClaimWizardScss2['default'].inviteToSignTooltip]) },
	                    _('inviteToSignTooltip')
	                )
	            ),
	            dsPackage && !packageStatusError && !isEditableThePackage && dsPackage.mustBeSigned && (0, _DSDocumentsDocumentsHelpers.stakeholdersCanSign)(dsPackage) && _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].marginBot, _ClaimWizardScss2['default'].grow, _ClaimWizardScss2['default'].directSignButtonWrapper) },
	                _react2['default'].createElement(
	                    'button',
	                    { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].greenButton, _ClaimWizardScss2['default'].noPadding, _ClaimWizardScss2['default'].directSignButton),
	                        onClick: function (ev) {
	                            ev.stopPropagation();
	                            return directSignMethod(dsPackage.id);
	                        } },
	                    _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].icon), src: getIcon('a-edit_1x_blue.svg', true) }),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: (0, _classnames2['default'])([_ClaimWizardScss2['default'].tooltip, _ClaimWizardScss2['default'].directSignTooltip]) },
	                        _('directSignTooltip')
	                    )
	                )
	            ),
	            dsPackage && !isEditableThePackage && !dsPackage.hasFinishStatus && dsPackage.mustBeSigned &&
	            // {dsPackage &&
	            _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].recreatePackageWrapper) },
	                _react2['default'].createElement(
	                    'button',
	                    { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].greenButton, _ClaimWizardScss2['default'].noPadding,
	                        // styles.greenButtonDsList,
	                        "enabled", _ClaimWizardScss2['default'].buttonCustomizationRenew),
	                        onClick: function callee$2$0(ev) {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        ev.stopPropagation();
	                                        context$3$0.next = 3;
	                                        return regeneratorRuntime.awrap(recreatePackageMethod(dsPackage));
	
	                                    case 3:
	                                    case 'end':
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this);
	                        }
	                    },
	                    _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].icon), src: getIcon('autorenew.svg') }),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: (0, _classnames2['default'])([_ClaimWizardScss2['default'].tooltip, _ClaimWizardScss2['default'].recreateTooltip]) },
	                        _('recreateTooltip')
	                    )
	                )
	            )
	        );
	    };
	
	    var renderDocumentButtons = function renderDocumentButtons(document, key) {
	        var alternativeId = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	        var mainDocType = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];
	
	        return _react2['default'].createElement(
	            'div',
	            { className: _ClaimWizardScss2['default'].buttonsWrapper },
	            document.docType && _react2['default'].createElement(
	                _reactDropzone2['default'],
	                {
	                    style: { minHeight: 50 },
	                    className: _ClaimWizardScss2['default'].dropzone + " " + (isDragging && isDragging === document.docType && _ClaimWizardScss2['default'].drag),
	                    onDragEnter: function () {
	                        return setFileDrag(document.docType);
	                    },
	                    onDragLeave: function () {
	                        return setFileDrag('');
	                    },
	                    onDrop: function (ev) {
	                        return addFiles(ev, document.docType, alternativeId, mainDocType);
	                    }
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].dropzonePlaceholder },
	                    _('filePlaceholder')
	                )
	            ),
	            document && document.hasDsDocumentTemplate && canCreateMifid && _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].mifidButton) },
	                _react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
	                    moduleKeyToSet: _stateConstants2['default'].DS_MODULE_CLAIM_WIZARD,
	                    subModuleKeyToSet: _stateConstants2['default'].DS_MODULE_CLAIM_WIZARD,
	                    clientId: claimData.clientId,
	                    claimId: claimData.claimId,
	                    claimNumber: claimData.claimNumber,
	                    callBackOnClose: function () {},
	                    callBackOnCloseClaimWizard: function (packageId) {
	                        if (packageId) {
	                            updateDsPackageList(packageId);
	                        }
	                    },
	                    moduleOptions: collectModuleOptions(),
	                    claimWizardDocType: document.docType,
	                    mifidKey: key + document.docType
	                })
	            )
	        );
	    };
	
	    var renderAlternativesList = function renderAlternativesList(document) {
	        var index = document.alternativeDocTypes.findIndex(function (oneAlternative) {
	            return oneAlternative.alternativeId === document.alternativeSelectionId;
	        });
	        return document.alternativeDocTypes[index].alternatives.map(function (oneAlternative, key) {
	            return _react2['default'].createElement(
	                'div',
	                { key: key, className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: _ClaimWizardScss2['default'].formLabel },
	                        getDocumentLabel(oneAlternative.docType)
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].documentHandlerSection },
	                    _react2['default'].createElement('div', { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].formLabel, _ClaimWizardScss2['default'].marginLeftS, _ClaimWizardScss2['default'].short1) }),
	                    renderDocumentButtons(oneAlternative, key, document.alternativeDocTypes[index].alternativeId, document.docType),
	                    renderListOfDocuments(oneAlternative)
	                )
	            );
	        });
	    };
	
	    var renderDocuments = function renderDocuments(documents) {
	        var isOptional = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	        return documents.map(function (document, key) {
	            return _react2['default'].createElement(
	                'div',
	                { key: key, className: _ClaimWizardScss2['default'].sectionWrapper },
	                isOptional && _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].documentHandlerSection, _ClaimWizardScss2['default'].noPadding) },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _ClaimWizardScss2['default'].docTypeControlWrapper },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].docTypeSelector) },
	                                _react2['default'].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, {
	                                    type: 'text',
	                                    value: document.docType,
	                                    options: getOptionalDocumentOptions(documents, document.docType),
	                                    onChange: function (value) {
	                                        return onChangeOptionalDoctypeId(value ? value.value : '', document.id);
	                                    },
	                                    formatCreateLabel: _('optionalDocType'),
	                                    name: 'optionalDocType',
	                                    isClearable: true,
	                                    isDisabled: documentFiles.some(function (docFile) {
	                                        return docFile.docType === document.docType;
	                                    }), //disable when there are documents attached
	                                    isCreatableSelect: false
	                                })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].docRemoveWrapper) },
	                                _react2['default'].createElement(
	                                    'button',
	                                    {
	                                        type: 'button', //disable when there documents attached
	                                        className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].removeDocumentBtn),
	                                        onClick: function (e) {
	                                            e.preventDefault();
	                                            removeOptionalDocumentAndFiles(document);
	                                        },
	                                        disabled: documentFiles.some(function (docFile) {
	                                            return docFile.docType === document.docType && docFile.uploaded || docFile.docType === document.docType && docFile.dsPackageStatus;
	                                        }) //disable when there are documents attached
	                                    },
	                                    _('removeOptionalDocument')
	                                )
	                            )
	                        )
	                    )
	                ),
	                !isOptional && _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: _ClaimWizardScss2['default'].formLabel },
	                        getDocumentLabel(document.docType)
	                    ),
	                    _react2['default'].createElement('div', { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].formLabel, _ClaimWizardScss2['default'].marginLeftS, _ClaimWizardScss2['default'].short1) }),
	                    document.alternativeDocTypes && document.alternativeDocTypes.length > 0 && _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].formInput, _ClaimWizardScss2['default'].formInputCreatableSelect, _ClaimWizardScss2['default'].sizeM, _ClaimWizardScss2['default'].last, _ClaimWizardScss2['default'].fixeMaxWidth, _ClaimWizardScss2['default'].marginRightS) },
	                        _react2['default'].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, {
	                            type: 'text',
	                            value: document.alternativeSelectionId || document.docType,
	                            options: getAlternativeOptions(document),
	                            onChange: function (value) {
	                                return setAlternativeMethod(value.value, document.docType);
	                            },
	                            formatCreateLabel: _('alternativeDocs'),
	                            name: 'alternativeDocs',
	                            isDisabled: documentFiles.some(function (oneDocFile) {
	                                return oneDocFile.docType === document.docType || oneDocFile.alternativeId && document.alternativeDocTypes && document.alternativeDocTypes.some(function (alternative) {
	                                    return alternative.alternativeId === oneDocFile.alternativeId;
	                                });
	                            }),
	                            isClearable: true,
	                            isCreatableSelect: false
	                        })
	                    )
	                ),
	                document.alternativeDocTypes && document.alternativeDocTypes.length > 0 && document.alternativeSelectionId && document.alternativeSelectionId !== document.docType ? renderAlternativesList(document) : _react2['default'].createElement(
	                    'div',
	                    { key: key, className: _ClaimWizardScss2['default'].sectionWrapper },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _ClaimWizardScss2['default'].documentHandlerSection },
	                        _react2['default'].createElement('div', { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].formLabel, _ClaimWizardScss2['default'].marginLeftS, _ClaimWizardScss2['default'].short1) }),
	                        renderDocumentButtons(document, key),
	                        renderListOfDocuments(document)
	                    )
	                )
	            );
	        });
	    };
	
	    return _react2['default'].createElement(
	        _sharedWizardModalContent2['default'],
	        { modalTitle: _('stepThreeTitle') },
	        _react2['default'].createElement(
	            'form',
	            { method: 'post', onSubmit: function (ev) {
	                    return ev.preventDefault();
	                }, className: _ClaimWizardScss2['default'].modalFormContent, key: "claimWizardStepThreeForm" },
	            _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].formInputContainer },
	                _react2['default'].createElement('div', { className: _ClaimWizardScss2['default'].titleLabel, dangerouslySetInnerHTML: { __html: _('stepThreeSubTitle') } })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].titleLabel, _ClaimWizardScss2['default'].docSectionTitle) },
	                        _('wizardMandatory')
	                    )
	                )
	            ),
	            claimWizardDocumentsData.wizardMandatory && claimWizardDocumentsData.wizardMandatory.length > 0 && renderDocuments(claimWizardDocumentsData.wizardMandatory),
	            claimWizardDocumentsData.claimMandatory && claimWizardDocumentsData.claimMandatory.length > 0 && _react2['default'].createElement('div', { className: _ClaimWizardScss2['default'].formSeparator }),
	            claimWizardDocumentsData.claimMandatory && claimWizardDocumentsData.claimMandatory.length > 0 && _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].titleLabel, _ClaimWizardScss2['default'].docSectionTitle) },
	                        _('claimMandatory')
	                    )
	                )
	            ),
	            claimWizardDocumentsData.claimMandatory && renderDocuments(claimWizardDocumentsData.claimMandatory),
	            _react2['default'].createElement('div', { className: _ClaimWizardScss2['default'].formSeparator }),
	            _react2['default'].createElement(
	                'div',
	                { className: _ClaimWizardScss2['default'].sectionWrapper },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _ClaimWizardScss2['default'].formInputContainer },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: (0, _classnames2['default'])(_ClaimWizardScss2['default'].titleLabel, _ClaimWizardScss2['default'].docSectionTitle) },
	                        _('wizardOptional')
	                    )
	                )
	            ),
	            claimWizardDocumentsData.wizardOptional && renderDocuments(claimWizardDocumentsData.wizardOptional, true),
	            _react2['default'].createElement(_sharedWizardButtonsWizardButtons2['default'], {
	                nextBtn: {
	                    method: function method() {
	                        onAddOptionalDocument();
	                    },
	                    disabled: getOptionalDocumentOptions(claimWizardDocumentsData.wizardOptional, true).length === 0 || claimWizardDocumentsData.wizardOptional.some(function (document) {
	                        return !document.docType;
	                    }),
	                    label: '+'
	                }
	            }),
	            props.children
	        )
	    );
	
	    // #endregion
	};
	
	exports['default'] = ClaimWizardStepThree;
	module.exports = exports['default'];
	/* reminder btn */ /* //invitation button */ /* //direct sign button */ /* <div className={styles.documentListContainer} > */ /* </div> */ /* <div className={styles.documentListContainer} > */ /* </div> */

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(57);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _sharedWizardModalContent = __webpack_require__(218);
	
	var _sharedWizardModalContent2 = _interopRequireDefault(_sharedWizardModalContent);
	
	var _ClaimWizardScss = __webpack_require__(155);
	
	var _ClaimWizardScss2 = _interopRequireDefault(_ClaimWizardScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _claimsWizardService = __webpack_require__(217);
	
	var _sharedWizardSelectsWizardReactSelect = __webpack_require__(362);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _sharedWizardButtonsWizardButtons = __webpack_require__(361);
	
	var _sharedWizardButtonsWizardButtons2 = _interopRequireDefault(_sharedWizardButtonsWizardButtons);
	
	// variables out of module
	var _ = (0, _libI18n2["default"])('claimWizard');
	
	var ClaimWizardStepTwo = (function (_Component) {
	    _inherits(ClaimWizardStepTwo, _Component);
	
	    function ClaimWizardStepTwo() {
	        _classCallCheck(this, ClaimWizardStepTwo);
	
	        _get(Object.getPrototypeOf(ClaimWizardStepTwo.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(ClaimWizardStepTwo, [{
	        key: "renderParty",
	        value: function renderParty(party, key) {
	            var _props = this.props;
	            var onRemoveOptionalParty = _props.onRemoveOptionalParty;
	            var updatePartyField = _props.updatePartyField;
	            var optionalInvPartyOptions = _props.optionalInvPartyOptions;
	            var countryOptionsList = _props.countryOptionsList;
	            var zipCodeOptions = _props.zipCodeOptions;
	            var mandatoryInvPartyOptions = _props.mandatoryInvPartyOptions;
	
	            return _react2["default"].createElement(
	                "div",
	                { className: _ClaimWizardScss2["default"].sectionWrapper, key: key + party.id },
	                _react2["default"].createElement(
	                    "div",
	                    { className: _ClaimWizardScss2["default"].formInputContainer },
	                    _react2["default"].createElement(
	                        "label",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].maxWidthStepTwoLeft) },
	                        _('partyNumber'),
	                        " "
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].inputsForceRow) },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first, _ClaimWizardScss2["default"].dropdownWidth) },
	                            _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, {
	                                type: "text",
	                                value: party.partyNumber,
	                                options: party.isMandatory ? mandatoryInvPartyOptions : optionalInvPartyOptions,
	                                onChange: function (value) {
	                                    return updatePartyField(value ? value.value : '', party.id, 'partyNumber');
	                                },
	                                formatCreateLabel: _('optionalPartyNumber'),
	                                name: "optionalPartyNumber",
	                                isClearable: true,
	                                isDisabled: party.isMandatory,
	                                isCreatableSelect: false
	                            })
	                        ),
	                        _react2["default"].createElement("div", { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].marginLeftS, _ClaimWizardScss2["default"].short1) }),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].shortMargin, _ClaimWizardScss2["default"].last, _ClaimWizardScss2["default"].removePartyWrapper) },
	                            !party.isMandatory && _react2["default"].createElement(
	                                "button",
	                                {
	                                    type: "button",
	                                    className: _ClaimWizardScss2["default"].removePartyBtn,
	                                    onClick: function (e) {
	                                        e.preventDefault();
	                                        onRemoveOptionalParty(party.id);
	                                    }
	                                },
	                                _('removeParty')
	                            )
	                        )
	                    )
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: _ClaimWizardScss2["default"].formInputContainer },
	                    _react2["default"].createElement(
	                        "label",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].maxWidthStepTwoLeft) },
	                        _('firstName') + " " + (party.fields.firstName.required ? '*' : '')
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].inputsForceRow) },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first) },
	                            _react2["default"].createElement("input", {
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                name: "invPartyFirstName",
	                                value: party.fields.firstName.value,
	                                onChange: function (e) {
	                                    updatePartyField(e.target.value, party.id, 'firstName');
	                                }
	                            })
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].marginLeftS, _ClaimWizardScss2["default"].short1, _ClaimWizardScss2["default"].maxWidthStepTwoRight) },
	                            _('lastName') + " " + (party.fields.lastName.required ? '*' : '')
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].shortMargin, _ClaimWizardScss2["default"].last) },
	                            _react2["default"].createElement("input", {
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                name: "invPartyLastName",
	                                value: party.fields.lastName.value,
	                                onChange: function (e) {
	                                    return updatePartyField(e.target.value, party.id, 'lastName');
	                                }
	                            })
	                        )
	                    )
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: _ClaimWizardScss2["default"].formInputContainer },
	                    _react2["default"].createElement(
	                        "label",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].maxWidthStepTwoLeft) },
	                        _('street') + " " + (party.fields.street.required ? '*' : ''),
	                        " "
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].inputsForceRow) },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first) },
	                            _react2["default"].createElement("input", {
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                ref: "",
	                                name: "invPartyStreet",
	                                value: party.fields.street.value,
	                                onChange: function (e) {
	                                    return updatePartyField(e.target.value, party.id, 'street');
	                                }
	                            })
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].marginLeftS, _ClaimWizardScss2["default"].short1, _ClaimWizardScss2["default"].maxWidthStepTwoRight) },
	                            _('number') + " " + (party.fields.number.required ? '*' : '')
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].shortMargin, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].last) },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first) },
	                                _react2["default"].createElement("input", {
	                                    className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                    type: "text",
	                                    ref: "invPartyHouseNumber",
	                                    name: "invPartyHouseNumber",
	                                    value: party.fields.number.value,
	                                    onChange: function (e) {
	                                        return updatePartyField(e.target.value, party.id, 'number');
	                                    }
	                                })
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].marginLeftS, _ClaimWizardScss2["default"].short1, _ClaimWizardScss2["default"].maxWidthStepTwoRight) },
	                                _('box')
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeExtraSmall, _ClaimWizardScss2["default"].last, _ClaimWizardScss2["default"].boxMinWidth) },
	                                _react2["default"].createElement("input", {
	                                    className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                    type: "text",
	                                    ref: "invPartyBox",
	                                    name: "invPartyBox",
	                                    value: party.fields.box.value,
	                                    onChange: function (e) {
	                                        return updatePartyField(e.target.value, party.id, 'box');
	                                    }
	                                })
	                            )
	                        )
	                    )
	                ),
	                party.fields.country.value === '1' ? _react2["default"].createElement(
	                    "div",
	                    { className: _ClaimWizardScss2["default"].formInputContainer },
	                    _react2["default"].createElement(
	                        "label",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].maxWidthStepTwoLeft) },
	                        _('locality') + " " + (party.fields.postalCode.required ? '*' : ''),
	                        " "
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].inputsForceRow) },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first) },
	                            _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, {
	                                type: "text",
	                                value: party.fields.postalCode.value && party.fields.town.value ? party.fields.postalCode.value + '_' + party.fields.town.value : '',
	                                options: zipCodeOptions,
	                                onChange: function (value) {
	                                    var splitValue = value.value.split('_');
	
	                                    var zipCode = splitValue[0];
	                                    var town = splitValue[1];
	                                    updatePartyField(zipCode ? zipCode : '', party.id, 'postalCode');
	                                    updatePartyField(town ? town : '', party.id, 'town');
	                                },
	                                formatCreateLabel: _('invPartyPostalCodeAndTown'),
	                                name: "invPartyPostalCodeAndTown",
	                                isClearable: true,
	                                isCreatableSelect: false
	                            })
	                        )
	                    )
	                ) : _react2["default"].createElement(
	                    "div",
	                    { className: _ClaimWizardScss2["default"].formInputContainer },
	                    _react2["default"].createElement(
	                        "label",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].maxWidthStepTwoLeft) },
	                        _('postalCode') + " " + (party.fields.postalCode.required ? '*' : ''),
	                        " "
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].inputsForceRow) },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first) },
	                            _react2["default"].createElement("input", {
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                ref: "invPartyPostalCode",
	                                name: "invPartyPostalCode",
	                                value: party.fields.postalCode.value,
	                                onChange: function (e) {
	                                    return updatePartyField(e.target.value, party.id, 'postalCode');
	                                }
	
	                            })
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].marginLeftS, _ClaimWizardScss2["default"].short1, _ClaimWizardScss2["default"].maxWidthStepTwoRight) },
	                            _('town') + " " + (party.fields.town.required ? '*' : '')
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].shortMargin, _ClaimWizardScss2["default"].last) },
	                            _react2["default"].createElement("input", {
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                ref: "invPartyTown",
	                                name: "invPartyTown",
	                                value: party.fields.town.value,
	                                onChange: function (e) {
	                                    return updatePartyField(e.target.value, party.id, 'town');
	                                }
	                            })
	                        )
	                    )
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: _ClaimWizardScss2["default"].formInputContainer },
	                    _react2["default"].createElement(
	                        "label",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].maxWidthStepTwoLeft) },
	                        _('country') + " " + (party.fields.country.required ? '*' : ''),
	                        " "
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].inputsForceRow) },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first, _ClaimWizardScss2["default"].dropdownWidth) },
	                            _react2["default"].createElement(_sharedWizardSelectsWizardReactSelect.CreatableSelectWrapper, {
	                                type: "text",
	                                value: party.fields.country.value,
	                                options: countryOptionsList,
	                                onChange: function (value) {
	                                    return updatePartyField(value ? value.value : '', party.id, 'country');
	                                },
	                                formatCreateLabel: _('invPartyCountry'),
	                                name: "invPartyCountry",
	                                isClearable: true,
	                                isCreatableSelect: false
	                            })
	                        ),
	                        _react2["default"].createElement("div", { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].marginLeftS, _ClaimWizardScss2["default"].short1) }),
	                        _react2["default"].createElement("div", { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].shortMargin, _ClaimWizardScss2["default"].last) })
	                    )
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: _ClaimWizardScss2["default"].formInputContainer },
	                    _react2["default"].createElement(
	                        "label",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].maxWidthStepTwoLeft) },
	                        _('phoneNumber') + " " + (party.fields.phoneNumber.required ? '*' : ''),
	                        " "
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].inputsForceRow) },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].first) },
	                            _react2["default"].createElement("input", {
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                ref: "",
	                                name: "invPartyPhoneNumber",
	                                value: party.fields.phoneNumber.value,
	                                onChange: function (e) {
	                                    return updatePartyField(e.target.value, party.id, 'phoneNumber');
	                                }
	                            })
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formLabel, _ClaimWizardScss2["default"].marginLeftS, _ClaimWizardScss2["default"].short1, _ClaimWizardScss2["default"].maxWidthStepTwoRight) },
	                            _('email') + " " + (party.fields.email.required ? '*' : '')
	                        ),
	                        _react2["default"].createElement(
	                            "div",
	                            { className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputCreatableSelect, _ClaimWizardScss2["default"].sizeXS, _ClaimWizardScss2["default"].shortMargin, _ClaimWizardScss2["default"].last) },
	                            _react2["default"].createElement("input", {
	                                className: (0, _classnames2["default"])(_ClaimWizardScss2["default"].formInput, _ClaimWizardScss2["default"].formInputText),
	                                type: "text",
	                                ref: "",
	                                name: "invPartyEmail",
	                                value: party.fields.email.value,
	                                onChange: function (e) {
	                                    return updatePartyField(e.target.value, party.id, 'email');
	                                }
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this = this;
	
	            var _props2 = this.props;
	            var involvedPartiesData = _props2.involvedPartiesData;
	            var onAddOptionalParty = _props2.onAddOptionalParty;
	
	            var renderMandatoryParties = involvedPartiesData ? involvedPartiesData.filter(function (oneParty) {
	                return oneParty.isMandatory;
	            }).map(function (oneParty, key) {
	                return _this.renderParty(oneParty, key);
	            }) : [];
	
	            var isPartyNumberSelected = involvedPartiesData.every(function (party) {
	                return party.isMandatory || party.partyNumber && party.partyNumber.trim() !== "";
	            });
	
	            return _react2["default"].createElement(
	                _sharedWizardModalContent2["default"],
	                { modalTitle: _('stepTwoTitle') },
	                _react2["default"].createElement(
	                    "form",
	                    { method: "post", onSubmit: function (ev) {
	                            return ev.preventDefault();
	                        }, className: _ClaimWizardScss2["default"].modalFormContent, key: "claimWizardStepTwoForm" },
	                    renderMandatoryParties.length > 0 ? renderMandatoryParties : _react2["default"].createElement(
	                        "div",
	                        { className: _ClaimWizardScss2["default"].formInputContainer },
	                        _react2["default"].createElement(
	                            "label",
	                            { className: _ClaimWizardScss2["default"].formLabel },
	                            _('missingMandatoryParties'),
	                            " "
	                        )
	                    ),
	                    _react2["default"].createElement("div", { className: _ClaimWizardScss2["default"].formSeparator }),
	                    involvedPartiesData && involvedPartiesData.map(function (oneParty, key) {
	                        if (!oneParty.isMandatory) {
	                            return _this.renderParty(oneParty, key);
	                        }
	                    }),
	                    _react2["default"].createElement(_sharedWizardButtonsWizardButtons2["default"], {
	                        nextBtn: {
	                            method: function method() {
	                                onAddOptionalParty();
	                            },
	                            disabled: !isPartyNumberSelected,
	                            label: '+'
	                        }
	                    }),
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return ClaimWizardStepTwo;
	})(_react.Component);
	
	exports["default"] = ClaimWizardStepTwo;
	module.exports = exports["default"];
	/* if is mandatory party, number is fixed => input disable, if is optional party dropdown with list of parties */ /* render mandatory parties */

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reduxForm = __webpack_require__(57);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _sharedCustomStyles = __webpack_require__(594);
	
	var _ClaimWizardStepOne = __webpack_require__(1035);
	
	var _ClaimWizardStepOne2 = _interopRequireDefault(_ClaimWizardStepOne);
	
	var _stateActions = __webpack_require__(5);
	
	var _claimsWizardService = __webpack_require__(217);
	
	var _sharedWizardButtonsWizardButtons = __webpack_require__(361);
	
	var _sharedWizardButtonsWizardButtons2 = _interopRequireDefault(_sharedWizardButtonsWizardButtons);
	
	var _ClaimWarningModal = __webpack_require__(1033);
	
	var _ClaimWarningModal2 = _interopRequireDefault(_ClaimWarningModal);
	
	var _ClaimWizardStepTwo = __webpack_require__(1037);
	
	var _ClaimWizardStepTwo2 = _interopRequireDefault(_ClaimWizardStepTwo);
	
	var _libHelpers = __webpack_require__(24);
	
	var _bpostSelectJson = __webpack_require__(309);
	
	var _bpostSelectJson2 = _interopRequireDefault(_bpostSelectJson);
	
	var _ClaimWizardStepThree = __webpack_require__(1036);
	
	var _ClaimWizardStepThree2 = _interopRequireDefault(_ClaimWizardStepThree);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _ClaimWizardStepFour = __webpack_require__(1034);
	
	var _ClaimWizardStepFour2 = _interopRequireDefault(_ClaimWizardStepFour);
	
	var _DSDocumentsAreYouSureModal = __webpack_require__(363);
	
	var _DSDocumentsAreYouSureModal2 = _interopRequireDefault(_DSDocumentsAreYouSureModal);
	
	var _DSDocumentsReminderEmailStatusDialog = __webpack_require__(264);
	
	var _DSDocumentsReminderEmailStatusDialog2 = _interopRequireDefault(_DSDocumentsReminderEmailStatusDialog);
	
	var _ = (0, _libI18n2["default"])('claimWizard');
	
	var ClaimsWizard = (function (_Component) {
	    _inherits(ClaimsWizard, _Component);
	
	    _createClass(ClaimsWizard, null, [{
	        key: "propTypes",
	        value: {
	            contractNumber: _react2["default"].PropTypes.string,
	            claimNumber: _react2["default"].PropTypes.string,
	            brokerNumber: _react2["default"].PropTypes.string,
	            onGoing: _react2["default"].PropTypes.bool,
	            isClientContract: _react2["default"].PropTypes.bool
	        },
	        enumerable: true
	    }]);
	
	    function ClaimsWizard(props) {
	        var _this4 = this;
	
	        _classCallCheck(this, _ClaimsWizard);
	
	        _get(Object.getPrototypeOf(_ClaimsWizard.prototype), "constructor", this).call(this, props);
	
	        // Check if Contract has a ongoing claim and fetch all data if there is a ongoing claim
	
	        this.onClickRecreatePackage = function callee$2$0(dsPackage) {
	            var _props, dispatch, claimData, onErrorPopup, onSuccessPopup, onConfirmResetCallback, initAreYouSureData;
	
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                var _this2 = this;
	
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        _props = this.props;
	                        dispatch = _props.dispatch;
	                        claimData = _props.claimData;
	
	                        onErrorPopup = function onErrorPopup(error) {
	                            return regeneratorRuntime.async(function onErrorPopup$(context$4$0) {
	                                var _this = this;
	
	                                while (1) switch (context$4$0.prev = context$4$0.next) {
	                                    case 0:
	                                        return context$4$0.abrupt("return", this.setState({
	                                            isOpenAreYouSure: {
	                                                title: _('areYouSureModalTitle'),
	                                                message: _('recreatePackageError') + " " + _(error.name) + " code:" + _(error.callIDForDebug),
	                                                noCancelButton: true,
	                                                callBackCancel: function callBackCancel() {
	                                                    _this.setState({ isOpenAreYouSure: false });
	                                                },
	                                                callBackOk: function callBackOk() {
	                                                    return regeneratorRuntime.async(function callBackOk$(context$5$0) {
	                                                        while (1) switch (context$5$0.prev = context$5$0.next) {
	                                                            case 0:
	                                                                this.setState({ isOpenAreYouSure: false });
	
	                                                            case 1:
	                                                            case "end":
	                                                                return context$5$0.stop();
	                                                        }
	                                                    }, null, _this);
	                                                }
	                                            }
	                                        }));
	
	                                    case 1:
	                                    case "end":
	                                        return context$4$0.stop();
	                                }
	                            }, null, _this2);
	                        };
	
	                        onSuccessPopup = function onSuccessPopup() {
	                            return regeneratorRuntime.async(function onSuccessPopup$(context$4$0) {
	                                var _this3 = this;
	
	                                while (1) switch (context$4$0.prev = context$4$0.next) {
	                                    case 0:
	                                        return context$4$0.abrupt("return", this.setState({
	                                            isOpenAreYouSure: {
	                                                title: _('areYouSureModalTitle'),
	                                                message: _('recreatePackageSuccess'),
	                                                noCancelButton: false,
	                                                callBackCancel: function callBackCancel() {
	                                                    _this3.setState({ isOpenAreYouSure: false });
	                                                },
	                                                callBackOk: function callBackOk() {
	                                                    return regeneratorRuntime.async(function callBackOk$(context$5$0) {
	                                                        while (1) switch (context$5$0.prev = context$5$0.next) {
	                                                            case 0:
	                                                                this.setState({ isOpenAreYouSure: false, autoOpenMifid: true });
	
	                                                            case 1:
	                                                            case "end":
	                                                                return context$5$0.stop();
	                                                        }
	                                                    }, null, _this3);
	                                                }
	                                            }
	                                        }));
	
	                                    case 1:
	                                    case "end":
	                                        return context$4$0.stop();
	                                }
	                            }, null, _this2);
	                        };
	
	                        onConfirmResetCallback = function onConfirmResetCallback() {
	                            return regeneratorRuntime.async(function onConfirmResetCallback$(context$4$0) {
	                                while (1) switch (context$4$0.prev = context$4$0.next) {
	                                    case 0:
	                                        context$4$0.prev = 0;
	                                        context$4$0.next = 3;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.recreateDsPackage)(dsPackage.id)));
	
	                                    case 3:
	                                        context$4$0.next = 5;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimData.contractId })));
	
	                                    case 5:
	                                        context$4$0.next = 7;
	                                        return regeneratorRuntime.awrap(this.initializeStepThree());
	
	                                    case 7:
	                                        return context$4$0.abrupt("return", onSuccessPopup());
	
	                                    case 10:
	                                        context$4$0.prev = 10;
	                                        context$4$0.t0 = context$4$0["catch"](0);
	
	                                        console.error(context$4$0.t0);
	                                        return context$4$0.abrupt("return", onErrorPopup(context$4$0.t0));
	
	                                    case 14:
	                                    case "end":
	                                        return context$4$0.stop();
	                                }
	                            }, null, _this2, [[0, 10]]);
	                        };
	
	                        initAreYouSureData = {
	                            title: _('areYouSureModalTitle'),
	                            message: _('areYouSureToRecreteThePackage'),
	                            callBackCancel: function callBackCancel() {
	                                _this2.setState({ isOpenAreYouSure: false });
	                            },
	                            callBackOk: onConfirmResetCallback
	                        };
	                        return context$3$0.abrupt("return", this.setState({ isOpenAreYouSure: initAreYouSureData }));
	
	                    case 8:
	                    case "end":
	                        return context$3$0.stop();
	                }
	            }, null, _this4);
	        };
	
	        this.onResendRemindersClick = function callee$2$0(packageId) {
	            var dispatch, reminderResponse, reminderSentSuccessFlag;
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$3$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.resendClientRemainder)(packageId)));
	
	                    case 3:
	                        reminderResponse = context$3$0.sent;
	                        reminderSentSuccessFlag = false;
	
	                        if (reminderResponse && reminderResponse.success) {
	                            reminderSentSuccessFlag = true;
	                        }
	                        this.setState({ reminderConfirmationModal: true, reminderSentSuccessFlag: reminderSentSuccessFlag });
	
	                    case 7:
	                    case "end":
	                        return context$3$0.stop();
	                }
	            }, null, _this4);
	        };
	
	        this.getDsStakeholdersForInvitation = function callee$2$0(stakeholderIdArray) {
	            var dispatch;
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$3$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getDSStakeholders)(stakeholderIdArray)));
	
	                    case 3:
	                        return context$3$0.abrupt("return", context$3$0.sent);
	
	                    case 4:
	                    case "end":
	                        return context$3$0.stop();
	                }
	            }, null, _this4);
	        };
	
	        this.handleUpdatesAfterSigningInvitation = function callee$2$0(responses, dsPackage, stakeholders) {
	            var _props2, dispatch, claimData, i, emailId, toEmailAddress, _loop, j;
	
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                var _this5 = this;
	
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        claimData = _props2.claimData;
	                        context$3$0.prev = 3;
	
	                        if (!(!responses || responses.length === 0)) {
	                            context$3$0.next = 6;
	                            break;
	                        }
	
	                        return context$3$0.abrupt("return");
	
	                    case 6:
	                        i = 0;
	
	                    case 7:
	                        if (!(i < responses.length)) {
	                            context$3$0.next = 23;
	                            break;
	                        }
	
	                        emailId = _nestedProperty2["default"].get(responses, i + ".emailRecord._id");
	                        toEmailAddress = _nestedProperty2["default"].get(responses, i + ".emailRecord.toEmailAddress");
	
	                        if (emailId) {
	                            context$3$0.next = 12;
	                            break;
	                        }
	
	                        return context$3$0.abrupt("continue", 20);
	
	                    case 12:
	                        _loop = function callee$3$0(j) {
	                            return regeneratorRuntime.async(function callee$3$0$(context$4$0) {
	                                while (1) switch (context$4$0.prev = context$4$0.next) {
	                                    case 0:
	                                        if (!(toEmailAddress && toEmailAddress.length > 0 && toEmailAddress.some(function (email) {
	                                            return String(email).toLowerCase() === String(stakeholders[j].email).toLowerCase();
	                                        }))) {
	                                            context$4$0.next = 5;
	                                            break;
	                                        }
	
	                                        context$4$0.next = 3;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.upsertDSPackageEmailStatus)(dsPackage._id, emailId, { isInvitation: true, stakeholderId: stakeholders[j]._id } /* --> ?? mailOptions*/
	                                        )));
	
	                                    case 3:
	                                        context$4$0.next = 5;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateDSStakeholder)({ stakeholderId: stakeholders[j]._id, isInvited: true })));
	
	                                    case 5:
	                                    case "end":
	                                        return context$4$0.stop();
	                                }
	                            }, null, _this5);
	                        };
	
	                        j = 0;
	
	                    case 14:
	                        if (!(j < stakeholders.length)) {
	                            context$3$0.next = 20;
	                            break;
	                        }
	
	                        context$3$0.next = 17;
	                        return regeneratorRuntime.awrap(_loop(j));
	
	                    case 17:
	                        j++;
	                        context$3$0.next = 14;
	                        break;
	
	                    case 20:
	                        i++;
	                        context$3$0.next = 7;
	                        break;
	
	                    case 23:
	                        context$3$0.next = 25;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimData.contractId })));
	
	                    case 25:
	                        context$3$0.next = 27;
	                        return regeneratorRuntime.awrap(this.initializeStepThree());
	
	                    case 27:
	                        context$3$0.next = 33;
	                        break;
	
	                    case 29:
	                        context$3$0.prev = 29;
	                        context$3$0.t0 = context$3$0["catch"](3);
	
	                        console.error(context$3$0.t0);
	                        throw context$3$0.t0;
	
	                    case 33:
	                    case "end":
	                        return context$3$0.stop();
	                }
	            }, null, _this4, [[3, 29]]);
	        };
	
	        var isExistingClaim = props.claimData && props.claimData.claimStatus === '8' || props.onGoing || false;
	
	        var claimWarningModalStep = '';
	        if (isExistingClaim && !props.onGoing) {
	            claimWarningModalStep = '1';
	        }
	        var zipCodeOptions = _bpostSelectJson2["default"].map(function (_ref) {
	            var zip = _ref.zip;
	            var city = _ref.city;
	
	            return {
	                value: zip + "_" + city,
	                label: zip + " " + city
	            };
	        });
	
	        var contractDetails = props.contracts[props.contractId];
	
	        this.state = {
	            isExistingClaim: isExistingClaim,
	            returnToClaimWizard: false,
	            claimWarningModalStep: claimWarningModalStep,
	            brokersOptions: [],
	            mobilePhoneOptions: [],
	            phoneNumberOptions: [],
	            emailOptions: [],
	            productList: [],
	            productListOptions: [],
	            riskOptionsList: [],
	            qualificationOptionsList: [],
	            accountNumberOptions: [],
	            qualificationList: [],
	            subQualificationOptionsList: [],
	            claimData: props.claimData,
	            zipCodeOptions: zipCodeOptions,
	            mandatoryInvPartyOptions: [],
	            optionalInvPartyOptions: [],
	            contractDetails: contractDetails,
	            isDragging: ''
	        };
	    }
	
	    // ================================
	    // #region Init
	    // ================================
	
	    _createClass(ClaimsWizard, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props3, dispatch, brokersList, fields, clientId, clientData, contractId, brokerNumber, _state, claimData, isExistingClaim, brokerData, brokerName, selfManaging, selectedClientData, getClientResponse, claimDataResolved, mobilePhoneOptions, phoneNumberOptions, emailOptions, accountNumberOptions, claimDate, productsListAndOptions, riskOptionsList, qualificationList, qualificationOptionsList, subQualificationOptionsList, riskAndQualificationOptions, qualification;
	
	            return regeneratorRuntime.async(function componentDidMount$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props3 = this.props;
	                        dispatch = _props3.dispatch;
	                        brokersList = _props3.brokersList;
	                        fields = _props3.fields;
	                        clientId = _props3.clientId;
	                        clientData = _props3.clientData;
	                        contractId = _props3.contractId;
	                        brokerNumber = _props3.brokerNumber;
	                        _state = this.state;
	                        claimData = _state.claimData;
	                        isExistingClaim = _state.isExistingClaim;
	                        brokerData = brokersList[brokerNumber];
	                        brokerName = brokerData && brokerData.main.name + " [" + brokerNumber + "]";
	                        selfManaging = true;
	
	                        if (brokerData && brokerData.main) {
	                            selfManaging = brokerData.main.selfManagingVisible;
	                        }
	                        //handle client data
	                        selectedClientData = undefined;
	
	                        if (!(clientData && clientData[clientId])) {
	                            context$2$0.next = 20;
	                            break;
	                        }
	
	                        selectedClientData = clientData[clientId];
	                        context$2$0.next = 25;
	                        break;
	
	                    case 20:
	                        context$2$0.next = 22;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClient)(claimData.clientId)));
	
	                    case 22:
	                        getClientResponse = context$2$0.sent;
	
	                        dispatch((0, _stateActions.fetchClientOptionsDict)());
	                        selectedClientData = getClientResponse.client;
	
	                    case 25:
	                        claimDataResolved = claimData;
	
	                        if (!(!claimData || Object.keys(claimData).length === 0)) {
	                            context$2$0.next = 31;
	                            break;
	                        }
	
	                        context$2$0.next = 29;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.getClaimMongoRecord)(dispatch, { contractId: contractId }));
	
	                    case 29:
	                        claimDataResolved = context$2$0.sent;
	
	                        this.setState({ claimData: claimDataResolved });
	
	                    case 31:
	                        mobilePhoneOptions = (0, _claimsWizardService.setMobilePhoneOptions)(selectedClientData.detail.phoneNumbers);
	                        phoneNumberOptions = (0, _claimsWizardService.setPhoneNumbersOptions)(selectedClientData.detail.phoneNumbers);
	                        emailOptions = (0, _claimsWizardService.setEmailOptions)(selectedClientData.detail.emails);
	                        accountNumberOptions = (0, _claimsWizardService.setAccountOptions)(selectedClientData.detail.accountNumbers);
	                        claimDate = isExistingClaim && claimData && claimData.claimDate ? (0, _moment2["default"])(claimData.claimDate).format('YYYY-MM-DD') : claimDataResolved && claimDataResolved.claimDate ? (0, _moment2["default"])(claimDataResolved.claimDate).format('YYYY-MM-DD') : '';
	                        context$2$0.next = 38;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.getAndSetProductsAndRisks)(dispatch, contractId, claimDate, fields));
	
	                    case 38:
	                        productsListAndOptions = context$2$0.sent;
	                        riskOptionsList = [], qualificationList = [], qualificationOptionsList = [], subQualificationOptionsList = [];
	
	                        if (!(isExistingClaim && (claimData.productId || claimDataResolved.productId))) {
	                            context$2$0.next = 48;
	                            break;
	                        }
	
	                        context$2$0.next = 43;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.setRiskAndQualificationsOptions)(dispatch, claimData.productId || claimDataResolved.productId, productsListAndOptions.productsList, claimData.selfManaging, claimData.contractId, claimData.contractIdHist));
	
	                    case 43:
	                        riskAndQualificationOptions = context$2$0.sent;
	
	                        riskOptionsList = riskAndQualificationOptions.riskOptionsList;
	                        qualificationList = riskAndQualificationOptions.qualificationList;
	                        qualificationOptionsList = riskAndQualificationOptions.qualificationOptionsList;
	                        // handle subqualifications for existing claim
	                        if (claimDataResolved && claimDataResolved.subQualificationNumber) {
	                            qualification = qualificationList.find(function (oneQualification) {
	                                return oneQualification.qualificationNumber === claimDataResolved.qualificationNumber;
	                            });
	
	                            if (qualification.subQualifications && qualification.subQualifications.length > 0) {
	                                qualification.subQualifications.forEach(function (oneSubQualification) {
	                                    subQualificationOptionsList.push({
	                                        value: oneSubQualification.subQualificationNumber,
	                                        label: oneSubQualification.subQualificationName
	                                    });
	                                });
	                            }
	                        }
	
	                    case 48:
	
	                        if (subQualificationOptionsList.length > 0) {
	                            dispatch((0, _stateActions.setHasSubQualifications)(true));
	                        }
	
	                        this.setState({
	                            accountNumberOptions: accountNumberOptions, selfManaging: selfManaging,
	                            mobilePhoneOptions: mobilePhoneOptions, phoneNumberOptions: phoneNumberOptions, emailOptions: emailOptions,
	                            productList: productsListAndOptions.productsList,
	                            productListOptions: productsListAndOptions.productListOptions,
	                            riskOptionsList: riskOptionsList, qualificationList: qualificationList, qualificationOptionsList: qualificationOptionsList,
	                            subQualificationOptionsList: subQualificationOptionsList
	                        }, function () {
	                            (0, _claimsWizardService.setInitialValues)(dispatch, claimData && Object.keys(claimData).length > 0 ? claimData : claimDataResolved, fields, {
	                                brokerName: brokerName, clientData: selectedClientData, claimComment: claimData.claimComment || isExistingClaim ? claimDataResolved.claimComment : '',
	                                mobilePhoneOptions: mobilePhoneOptions, phoneNumberOptions: phoneNumberOptions, emailOptions: emailOptions
	                            });
	                        });
	
	                    case 50:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            var _props4 = this.props;
	            var claimData = _props4.claimData;
	            var fields = _props4.fields;
	            var dispatch = _props4.dispatch;
	            var clientOptionsDict = _props4.clientOptionsDict;
	            var involvedParties = _props4.involvedParties;
	            var optionalParties = _props4.optionalParties;
	
	            if (claimData !== prevProps.claimData) {
	                var isExistingClaim = claimData && claimData.claimStatus === '8' || false;
	                if (claimData.claimNumber) {
	                    (0, _claimsWizardService.updateFormFieldsAfterClaimUpdate)(dispatch, fields, claimData);
	                }
	                this.setState({ isExistingClaim: isExistingClaim });
	            }
	            if (involvedParties !== prevProps.involvedParties) {
	
	                var mandatoryInvPartyOptions = involvedParties.map(function (oneParty) {
	                    var onePartyOption = clientOptionsDict.involvedParties.find(function (i) {
	                        return i.value === oneParty.partyNumber;
	                    });
	                    return onePartyOption;
	                });
	                this.setState({ mandatoryInvPartyOptions: mandatoryInvPartyOptions });
	            }
	            if (optionalParties !== prevProps.optionalParties) {
	                var optionalInvPartyOptions = optionalParties.map(function (oneParty) {
	                    var onePartyOption = clientOptionsDict.involvedParties.find(function (i) {
	                        return i.value === oneParty;
	                    });
	                    return onePartyOption;
	                });
	                optionalInvPartyOptions.sort(function (a, b) {
	                    return a.label.localeCompare(b.label);
	                });
	                this.setState({ optionalInvPartyOptions: optionalInvPartyOptions });
	            }
	        }
	
	        /**
	         * This will initialize step three of the claim wizard
	         * First will get documents records stored in mongo
	         * Than using documents records from mongo and documents from the getDocumentation procedure will create a list of documents
	         * These processes will be done in redux actions
	         * At the moment getClaimWizardDocuments is not implemented will only create the initial list
	         */
	    }, {
	        key: "initializeStepThree",
	        value: function initializeStepThree() {
	            var _props5, dispatch, claimData, documents;
	
	            return regeneratorRuntime.async(function initializeStepThree$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props5 = this.props;
	                        dispatch = _props5.dispatch;
	                        claimData = _props5.claimData;
	                        documents = _props5.documents;
	                        context$2$0.next = 6;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.setDocumentsForStepThree)(claimData._id, claimData)));
	
	                    case 6:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        // #endregion
	
	        // ================================
	        // #region Handlers
	        // ================================
	
	    }, {
	        key: "handleCloseWizardMethod",
	        value: function handleCloseWizardMethod() {
	            var forceClose = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	            var _props6 = this.props;
	            var dispatch = _props6.dispatch;
	            var closeWizard = _props6.closeWizard;
	            var _state2 = this.state;
	            var returnToClaimWizard = _state2.returnToClaimWizard;
	            var claimWarningModalStep = _state2.claimWarningModalStep;
	
	            // if cancelClaim modal is opened from claimWizard step one we need to return to claim wizard on cancel
	            if (returnToClaimWizard && claimWarningModalStep && !forceClose) {
	                this.setState({ returnToClaimWizard: false, claimWarningModalStep: '' });
	            } else {
	                dispatch((0, _stateActions.resetClaimWizard)());
	
	                closeWizard();
	            }
	        }
	    }, {
	        key: "handleOnCreateClaim",
	        value: function handleOnCreateClaim() {
	            var _props7, dispatch, fields, errors, clientId, contractId, brokerNumber, lang, contractNumber, claimData;
	
	            return regeneratorRuntime.async(function handleOnCreateClaim$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props7 = this.props;
	                        dispatch = _props7.dispatch;
	                        fields = _props7.fields;
	                        errors = _props7.errors;
	                        clientId = _props7.clientId;
	                        contractId = _props7.contractId;
	                        brokerNumber = _props7.brokerNumber;
	                        lang = _props7.lang;
	                        contractNumber = _props7.contractNumber;
	                        claimData = (0, _claimsWizardService.prepareDataForClaim)(fields.stepOne);
	
	                        claimData['clientId'] = clientId;
	                        claimData['contractId'] = contractId;
	                        claimData['brokerNumber'] = brokerNumber;
	                        claimData['contractNumber'] = contractNumber;
	                        //language used for claimOverview
	                        claimData['language'] = lang;
	
	                        // call api
	                        dispatch((0, _stateActions.showLoader)());
	                        context$2$0.next = 18;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.saveNewClaim)(dispatch, claimData));
	
	                    case 18:
	                        dispatch((0, _stateActions.hideLoader)());
	
	                    case 19:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: "handleOnUpdateClaimContact",
	        value: function handleOnUpdateClaimContact() {
	            var _props8, dispatch, claimData, fields;
	
	            return regeneratorRuntime.async(function handleOnUpdateClaimContact$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props8 = this.props;
	                        dispatch = _props8.dispatch;
	                        claimData = _props8.claimData;
	                        fields = _props8.fields;
	
	                        dispatch((0, _stateActions.showLoader)());
	                        context$2$0.next = 7;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.updateClaimContactAndSetStep2)(dispatch, claimData, fields));
	
	                    case 7:
	                        dispatch((0, _stateActions.hideLoader)());
	
	                    case 8:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: "handleOnClaimCancel",
	        value: function handleOnClaimCancel() {
	            var _props9, dispatch, claimData, clientData, clientId, fields, brokersList, brokerNumber, isClientContract, closeWizard, _state3, mobilePhoneOptions, phoneNumberOptions, emailOptions, claimId, digitalClaimPackageId, claimStatus, selectedClientData, brokerData, brokerName;
	
	            return regeneratorRuntime.async(function handleOnClaimCancel$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props9 = this.props;
	                        dispatch = _props9.dispatch;
	                        claimData = _props9.claimData;
	                        clientData = _props9.clientData;
	                        clientId = _props9.clientId;
	                        fields = _props9.fields;
	                        brokersList = _props9.brokersList;
	                        brokerNumber = _props9.brokerNumber;
	                        isClientContract = _props9.isClientContract;
	                        closeWizard = _props9.closeWizard;
	                        _state3 = this.state;
	                        mobilePhoneOptions = _state3.mobilePhoneOptions;
	                        phoneNumberOptions = _state3.phoneNumberOptions;
	                        emailOptions = _state3.emailOptions;
	                        claimId = claimData.claimId;
	                        digitalClaimPackageId = claimData._id;
	                        claimStatus = '6';
	                        context$2$0.next = 19;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateClaimStatus)({ claimId: claimId, claimStatus: claimStatus, digitalClaimPackageId: digitalClaimPackageId })));
	
	                    case 19:
	                        context$2$0.next = 21;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.resetClaimWizard)()));
	
	                    case 21:
	                        dispatch((0, _reduxForm.reset)('claimWizardForm'));
	                        if (!isClientContract) {
	                            closeWizard();
	                        } else {
	                            selectedClientData = undefined;
	                            brokerData = brokersList[brokerNumber];
	                            brokerName = brokerData && brokerData.main.name + " [" + brokerNumber + "]";
	
	                            if (clientData && clientData[clientId]) {
	                                selectedClientData = clientData[clientId];
	                            }
	
	                            this.setState({
	                                returnToClaimWizard: false, claimWarningModalStep: '',
	                                qualificationOptionsList: [],
	                                subQualificationOptionsList: []
	                            }, (0, _claimsWizardService.setInitialValues)(dispatch, null, fields, {
	                                brokerName: brokerName,
	                                clientData: selectedClientData,
	                                mobilePhoneOptions: mobilePhoneOptions,
	                                phoneNumberOptions: phoneNumberOptions,
	                                emailOptions: emailOptions
	                            }));
	                        }
	
	                    case 23:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /***
	         * Handle self managing change in step one
	         * If self managing is set to true filter qualification options list and remove legal aid true options
	         * If there is already a legal aid qualification selected set reset the qualificationNumber and qualificationLabel to default ''
	         */
	    }, {
	        key: "onHandleSelfManagingChange",
	        value: function onHandleSelfManagingChange(value) {
	            var _props10, fields, dispatch, riskOptionsList, qualificationList, qualificationOptionsList, riskAndQualificationOptions;
	
	            return regeneratorRuntime.async(function onHandleSelfManagingChange$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props10 = this.props;
	                        fields = _props10.fields;
	                        dispatch = _props10.dispatch;
	
	                        if (!fields.stepOne.productId.value) {
	                            context$2$0.next = 12;
	                            break;
	                        }
	
	                        riskOptionsList = [], qualificationList = [], qualificationOptionsList = [];
	                        context$2$0.next = 7;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.setRiskAndQualificationsOptions)(dispatch, fields.stepOne.productId.value, this.state.productList, value, contractId, fields.stepOne.contractIdHist));
	
	                    case 7:
	                        riskAndQualificationOptions = context$2$0.sent;
	
	                        riskOptionsList = riskAndQualificationOptions.riskOptionsList;
	                        qualificationList = riskAndQualificationOptions.qualificationList;
	                        qualificationOptionsList = riskAndQualificationOptions.qualificationOptionsList;
	                        this.setState({ riskOptionsList: riskOptionsList, qualificationList: qualificationList, qualificationOptionsList: qualificationOptionsList });
	
	                    case 12:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: "handleUpdateInvolvedParties",
	        value: function handleUpdateInvolvedParties() {
	            var _props11, dispatch, involvedPartiesData, claimData, involvedParties, args;
	
	            return regeneratorRuntime.async(function handleUpdateInvolvedParties$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props11 = this.props;
	                        dispatch = _props11.dispatch;
	                        involvedPartiesData = _props11.involvedPartiesData;
	                        claimData = _props11.claimData;
	                        involvedParties = (0, _claimsWizardService.generateInvolvedPartiesData)(involvedPartiesData);
	                        args = {
	                            claimId: claimData.claimId,
	                            involvedParties: involvedParties
	                        };
	                        context$2$0.next = 8;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateInvolvedParties)(args)));
	
	                    case 8:
	                        context$2$0.next = 10;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimData.contractId })));
	
	                    case 10:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: "handleDateChange",
	        value: function handleDateChange(newDate) {
	            var _props12, contractId, dispatch, fields, productsListAndOptions;
	
	            return regeneratorRuntime.async(function handleDateChange$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props12 = this.props;
	                        contractId = _props12.contractId;
	                        dispatch = _props12.dispatch;
	                        fields = _props12.fields;
	
	                        (0, _claimsWizardService.resetProductAndRisk)(fields, dispatch);
	                        dispatch((0, _stateActions.toggleLegalAid)(false));
	
	                        if (newDate) {
	                            context$2$0.next = 10;
	                            break;
	                        }
	
	                        // no date reset all lists
	                        this.setState({
	                            productList: [],
	                            productListOptions: [],
	                            riskOptionsList: [],
	                            qualificationOptionsList: [],
	                            subQualificationOptionsList: []
	                        });
	                        context$2$0.next = 14;
	                        break;
	
	                    case 10:
	                        context$2$0.next = 12;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.getAndSetProductsAndRisks)(dispatch, contractId, newDate, fields));
	
	                    case 12:
	                        productsListAndOptions = context$2$0.sent;
	
	                        this.setState({
	                            productList: productsListAndOptions.productsList,
	                            productListOptions: productsListAndOptions.productListOptions,
	                            riskOptionsList: []
	                        });
	
	                    case 14:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: "handleProductChange",
	        value: function handleProductChange(newProductId) {
	            var productList, _props13, dispatch, fields, contractId, _ref2, riskOptionsList, qualificationList, qualificationOptionsList;
	
	            return regeneratorRuntime.async(function handleProductChange$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        productList = this.state.productList;
	                        _props13 = this.props;
	                        dispatch = _props13.dispatch;
	                        fields = _props13.fields;
	                        contractId = _props13.contractId;
	                        context$2$0.next = 7;
	                        return regeneratorRuntime.awrap((0, _claimsWizardService.setRiskAndQualificationsOptions)(dispatch, newProductId.value, productList, fields.stepOne.selfManaging.value, contractId, fields.stepOne.contractIdHist.value));
	
	                    case 7:
	                        _ref2 = context$2$0.sent;
	                        riskOptionsList = _ref2.riskOptionsList;
	                        qualificationList = _ref2.qualificationList;
	                        qualificationOptionsList = _ref2.qualificationOptionsList;
	
	                        dispatch((0, _stateActions.toggleLegalAid)(false));
	                        this.setState({ riskOptionsList: riskOptionsList, qualificationOptionsList: qualificationOptionsList, qualificationList: qualificationList });
	
	                    case 13:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: "handleQualificationChange",
	        value: function handleQualificationChange(newQualificationNumber) {
	            var qualificationList = this.state.qualificationList;
	            var _props14 = this.props;
	            var dispatch = _props14.dispatch;
	            var fields = _props14.fields;
	
	            var subQualificationOptionsList = [];
	            var qualification = qualificationList.find(function (oneQualification) {
	                return oneQualification.qualificationNumber === newQualificationNumber.value;
	            });
	            var isLegalAid = false;
	
	            //if is legal aid add subQualification and set selfManaging to default 'false'
	            if (qualification.subQualifications && qualification.subQualifications.length > 0) {
	                qualification.subQualifications.forEach(function (oneSubQualification) {
	                    subQualificationOptionsList.push({
	                        value: oneSubQualification.subQualificationNumber,
	                        label: oneSubQualification.subQualificationName
	                    });
	                });
	            }
	
	            if (qualification.legalAid === 'true') {
	                isLegalAid = true;
	                (0, _claimsWizardService.updatedFormValue)({ value: 'false', touched: true }, fields.stepOne.selfManaging, dispatch);
	            }
	            (0, _claimsWizardService.updatedFormValue)({ value: '', touched: true }, fields.stepOne.subQualificationNumber, dispatch);
	
	            dispatch((0, _stateActions.toggleLegalAid)(isLegalAid));
	            subQualificationOptionsList.sort(function (a, b) {
	                return a.label.localeCompare(b.label);
	            });
	            if (subQualificationOptionsList.length > 0) {
	                dispatch((0, _stateActions.setHasSubQualifications)(true));
	            } else {
	                dispatch((0, _stateActions.setHasSubQualifications)(false));
	            }
	            this.setState({ subQualificationOptionsList: subQualificationOptionsList });
	        }
	
	        /**
	         * On click the continue existing on-going claim will close cancelation modal and go to claim wizard step 1
	         */
	    }, {
	        key: "handleContinueExistingClaim",
	        value: function handleContinueExistingClaim() {
	            var dispatch = this.props.dispatch;
	
	            this.setState({ claimWarningModalStep: '' }, function () {
	                dispatch((0, _stateActions.setClaimWizardStep)('1'));
	            });
	        }
	
	        /**
	         * This will will move to step in the warning modal when is opened before step one
	         */
	    }, {
	        key: "handleSetStepTwoWarningModal",
	        value: function handleSetStepTwoWarningModal() {
	            this.setState({ claimWarningModalStep: '2' });
	        }
	
	        /**
	         * Open cancel claim modal from claim wizard, on cancel button we need to keep claim wizard modal open 
	         * This will open the warning modal on step two and three
	         */
	    }, {
	        key: "handleOpenWarningClaimModal",
	        value: function handleOpenWarningClaimModal() {
	            this.setState({ claimWarningModalStep: '2', returnToClaimWizard: true });
	        }
	
	        /**
	         * Add optional party to the list of optional parties on step two
	         */
	    }, {
	        key: "handleOnAddOptionalParty",
	        value: function handleOnAddOptionalParty() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.addOptionalParty)());
	        }
	
	        /**
	         * Remove optional party from the list of optional parties on step two
	         * @param {*} partyId 
	         */
	    }, {
	        key: "handleOnRemoveOptionalParty",
	        value: function handleOnRemoveOptionalParty(partyId) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.removeOptionalParty)(partyId));
	        }
	
	        /**
	         * Update party field on step two
	         * @param {*} value 
	         * @param {*} partyId 
	         * @param {*} field 
	         */
	    }, {
	        key: "handleUpdatePartyField",
	        value: function handleUpdatePartyField(value, partyId, field) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.updatePartyField)(value, partyId, field));
	        }
	
	        /**
	         * Handle selected alternative document on step three
	         * @param {*} value 
	         * @param {*} docType 
	         */
	    }, {
	        key: "handleSelectedAlternativeDocument",
	        value: function handleSelectedAlternativeDocument(value, docType) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.setAlternativeDocType)(value, docType));
	        }
	    }, {
	        key: "handleAddClaimWizardOptionalDocument",
	        value: function handleAddClaimWizardOptionalDocument() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.addClaimWizardOptionalDocument)());
	        }
	    }, {
	        key: "handleRemoveClaimWizardOptionalDocument",
	        value: function handleRemoveClaimWizardOptionalDocument(tempId) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.removeClaimWizardOptionalDocument)(tempId));
	        }
	    }, {
	        key: "handleUpdateClaimWizardOptionalDocument",
	        value: function handleUpdateClaimWizardOptionalDocument(value, tempId) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.updateClaimWizardOptionalDocument)(value, tempId));
	        }
	    }, {
	        key: "handleAddFilesToClaimWizardState",
	        value: function handleAddFilesToClaimWizardState(files) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.addFilesToClaimWizardState)(files));
	        }
	    }, {
	        key: "handleRemoveDocumentFile",
	        value: function handleRemoveDocumentFile(fileId) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.removeDocumentFileFromClaimWizard)(fileId));
	        }
	    }, {
	        key: "handleSetFileDrag",
	        value: function handleSetFileDrag(isDragging) {
	            this.setState({ isDragging: isDragging });
	        }
	    }, {
	        key: "handleAddDSPackageToClaimPackage",
	        value: function handleAddDSPackageToClaimPackage(dsPackageId) {
	            var _props15, dispatch, claimData, claimWizardId, existingDSPackages;
	
	            return regeneratorRuntime.async(function handleAddDSPackageToClaimPackage$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props15 = this.props;
	                        dispatch = _props15.dispatch;
	                        claimData = _props15.claimData;
	                        claimWizardId = claimData._id;
	                        existingDSPackages = claimData.dsPackages ? claimData.dsPackages.map(function (onePackage) {
	                            return onePackage.dsPackage;
	                        }) : [];
	
	                        if (existingDSPackages.includes(dsPackageId)) {
	                            context$2$0.next = 9;
	                            break;
	                        }
	
	                        existingDSPackages.push(dsPackageId);
	                        context$2$0.next = 16;
	                        break;
	
	                    case 9:
	                        dispatch((0, _stateActions.showLoader)());
	                        context$2$0.next = 12;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimData.contractId })));
	
	                    case 12:
	                        context$2$0.next = 14;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.setDocumentsForStepThree)(claimData._id, claimData)));
	
	                    case 14:
	                        dispatch((0, _stateActions.hideLoader)());
	                        return context$2$0.abrupt("return");
	
	                    case 16:
	                        dispatch((0, _stateActions.showLoader)());
	                        context$2$0.next = 19;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateClaimWizardPackage)(claimWizardId, { dsPackages: existingDSPackages })));
	
	                    case 19:
	                        context$2$0.next = 21;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimData.contractId })));
	
	                    case 21:
	                        dispatch((0, _stateActions.hideLoader)());
	
	                    case 22:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: "handleFilesUpload",
	        value: function handleFilesUpload(files) {
	            var _props16, dispatch, claimData;
	
	            return regeneratorRuntime.async(function handleFilesUpload$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props16 = this.props;
	                        dispatch = _props16.dispatch;
	                        claimData = _props16.claimData;
	
	                        dispatch((0, _stateActions.showLoader)());
	                        context$2$0.next = 6;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.uploadClaimWizardDocuments)(files, claimData.claimId, claimData._id)));
	
	                    case 6:
	                        context$2$0.next = 8;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimData.contractId })));
	
	                    case 8:
	                        dispatch((0, _stateActions.hideLoader)());
	
	                    case 9:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * This method will update package from connective reactivating the main sining link and opens the signing page from connective
	         * @param {*} packageId
	         */
	    }, {
	        key: "onDirectSignButtonClick",
	        value: function onDirectSignButtonClick(packageId) {
	            var dispatch, responseFromConnective, dsPackage, URLForSign;
	            return regeneratorRuntime.async(function onDirectSignButtonClick$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$2$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updatePackagesFromConnective)([packageId])));
	
	                    case 3:
	                        responseFromConnective = context$2$0.sent;
	
	                        if (!responseFromConnective.success) {
	                            context$2$0.next = 10;
	                            break;
	                        }
	
	                        context$2$0.next = 7;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(packageId)));
	
	                    case 7:
	                        dsPackage = context$2$0.sent;
	                        URLForSign = _nestedProperty2["default"].get(dsPackage, "F2FSigningUrl");
	
	                        // this.setState({ dsPackage })
	                        window.open(URLForSign, '_blank', 'noopener,noreferrer');
	
	                    case 10:
	                    case "end":
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Handle the reset process, when the user click on the reset button
	         * @param {object} dsPackage
	         * @returns nothing
	         */
	    }, {
	        key: "renderWizardButtons",
	
	        // #endregion
	
	        // ================================
	        // #region Render
	        // ================================
	
	        value: function renderWizardButtons() {
	            var _this6 = this;
	
	            var _state4 = this.state;
	            var claimWarningModalStep = _state4.claimWarningModalStep;
	            var isExistingClaim = _state4.isExistingClaim;
	            var _props17 = this.props;
	            var errors = _props17.errors;
	            var fields = _props17.fields;
	            var wizardStep = _props17.wizardStep;
	            var documentFiles = _props17.documentFiles;
	            var brokerNumber = _props17.brokerNumber;
	            var lang = _props17.lang;
	            var claimData = _props17.claimData;
	            var documents = _props17.documents;
	            var dispatch = _props17.dispatch;
	
	            var unfinishedDsPackageFiles = documentFiles.filter(function (file) {
	                return file.dsPackageStatus && file.dsPackageStatus !== 'packageStatusFinished' && !file.uploaded && claimData.oraDocuments.find(function (doc) {
	                    return doc.required === 'Wizard' && (doc.docType === file.docType || doc.alternativeDocTypes.some(function (altDoc) {
	                        return altDoc.altDocType === file.docType;
	                    }));
	                });
	            });
	
	            var leftBtn = {
	                disabled: false,
	                label: _('cancelClaimButton'),
	                isHidden: true
	            };
	
	            var cancelBtn = {
	                disabled: false,
	                method: function method() {
	                    return _this6.handleCloseWizardMethod();
	                },
	                label: _('cancel')
	            };
	            var previousBtn = {
	                isHidden: true
	            };
	            var nextBtn = {
	                disabled: false,
	                label: _('next')
	            };
	            var middleActionBtn = {
	                isHidden: true
	            };
	
	            var missingDocs = (0, _claimsWizardService.missingWizardDocuments)(claimData.missingInfo, claimData.oraDocuments, documents, documentFiles);
	
	            if (!claimWarningModalStep && wizardStep) {
	                switch (wizardStep) {
	                    case '1':
	                        leftBtn.method = this.handleOpenWarningClaimModal.bind(this);
	                        leftBtn.isHidden = !isExistingClaim;
	
	                        nextBtn.disabled = errors && errors.stepOne ? true : false;
	                        nextBtn.method = isExistingClaim ? this.handleOnUpdateClaimContact.bind(this) : this.handleOnCreateClaim.bind(this);
	                        nextBtn.label = isExistingClaim ? _('next') : _('saveClaimButton');
	                        break;
	
	                    case '2':
	                        //on cancel set the confirmation modal to confirm cancel or save data
	                        cancelBtn.method = this.handleOpenWarningClaimModal.bind(this);
	
	                        previousBtn.isHidden = false;
	                        previousBtn.label = _('previous');
	                        previousBtn.method = function callee$2$0() {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        context$3$0.next = 2;
	                                        return regeneratorRuntime.awrap(this.handleUpdateInvolvedParties());
	
	                                    case 2:
	                                        return context$3$0.abrupt("return", dispatch((0, _stateActions.setClaimWizardStep)('1')));
	
	                                    case 3:
	                                    case "end":
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this6);
	                        };
	                        nextBtn.method = function callee$2$0() {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        dispatch((0, _stateActions.showLoader)());
	                                        context$3$0.next = 3;
	                                        return regeneratorRuntime.awrap(this.handleUpdateInvolvedParties());
	
	                                    case 3:
	                                        context$3$0.next = 5;
	                                        return regeneratorRuntime.awrap(this.initializeStepThree());
	
	                                    case 5:
	                                        dispatch((0, _stateActions.hideLoader)());
	                                        return context$3$0.abrupt("return", dispatch((0, _stateActions.setClaimWizardStep)('3')));
	
	                                    case 7:
	                                    case "end":
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this6);
	                        };
	                        break;
	                    case '3':
	                        // HANDLE CANCEL CLAIM MODAL IN STEP 3
	                        cancelBtn.method = function () {
	                            if (documentFiles.length > 0 && documentFiles.some(function (file) {
	                                return !file.uploaded && !file.dsPackageStatus;
	                            })) {
	                                _this6.handleOpenWarningClaimModal();
	                            } else {
	                                _this6.handleCloseWizardMethod();
	                            }
	                        };
	                        previousBtn.isHidden = false;
	                        previousBtn.label = _('previous');
	                        previousBtn.method = function callee$2$0() {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        if (!(documentFiles.length > 0 && documentFiles.some(function (file) {
	                                            return !file.uploaded && !file.dsPackageStatus;
	                                        }))) {
	                                            context$3$0.next = 3;
	                                            break;
	                                        }
	
	                                        context$3$0.next = 3;
	                                        return regeneratorRuntime.awrap(this.handleFilesUpload(documentFiles));
	
	                                    case 3:
	                                        if (!documentFiles.some(function (file) {
	                                            return file.error;
	                                        })) {
	                                            dispatch((0, _stateActions.setClaimWizardStep)('2'));
	                                        }
	
	                                    case 4:
	                                    case "end":
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this6);
	                        };
	                        nextBtn.method = function callee$2$0() {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        if (!(documentFiles.length > 0 && documentFiles.some(function (file) {
	                                            return !file.uploaded && !file.dsPackageStatus;
	                                        }))) {
	                                            context$3$0.next = 3;
	                                            break;
	                                        }
	
	                                        context$3$0.next = 3;
	                                        return regeneratorRuntime.awrap(this.handleFilesUpload(documentFiles));
	
	                                    case 3:
	                                        if (!documentFiles.some(function (file) {
	                                            return file.error;
	                                        })) {
	                                            dispatch((0, _stateActions.setClaimWizardStep)('4'));
	                                        }
	
	                                    case 4:
	                                    case "end":
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this6);
	                        };
	                        nextBtn.label = _('next');
	                        break;
	                    case '4':
	                        cancelBtn.method = function () {
	                            if (fields.stepFour.claimComment.value) {
	                                _this6.handleOpenWarningClaimModal();
	                            } else {
	                                _this6.handleCloseWizardMethod();
	                            }
	                        };
	
	                        previousBtn.isHidden = false;
	                        previousBtn.label = _('previous');
	                        previousBtn.method = function callee$2$0() {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        dispatch((0, _stateActions.showLoader)());
	                                        context$3$0.next = 3;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateClaimComment)(claimData.claimId, fields.stepFour.claimComment.value)));
	
	                                    case 3:
	                                        context$3$0.next = 5;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimWizardPackage)({ contractId: claimData.contractId })));
	
	                                    case 5:
	                                        context$3$0.next = 7;
	                                        return regeneratorRuntime.awrap(this.initializeStepThree());
	
	                                    case 7:
	                                        dispatch((0, _stateActions.hideLoader)());
	                                        return context$3$0.abrupt("return", dispatch((0, _stateActions.setClaimWizardStep)('3')));
	
	                                    case 9:
	                                    case "end":
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this6);
	                        };
	                        middleActionBtn.isHidden = false;
	                        middleActionBtn.label = _('claimOverview');
	                        middleActionBtn.method = function callee$2$0() {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        context$3$0.next = 2;
	                                        return regeneratorRuntime.awrap((0, _claimsWizardService.openOverviewPdf)(claimData._id));
	
	                                    case 2:
	                                    case "end":
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this6);
	                        };
	                        nextBtn.method = function callee$2$0() {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        dispatch((0, _stateActions.showLoader)());
	                                        context$3$0.next = 3;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateClaimComment)(claimData.claimId, fields.stepFour.claimComment.value)));
	
	                                    case 3:
	                                        context$3$0.next = 5;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.claimConfirmation)(claimData.claimId)));
	
	                                    case 5:
	                                        dispatch((0, _stateActions.hideLoader)());
	                                        this.handleCloseWizardMethod();
	
	                                    case 7:
	                                    case "end":
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this6);
	                        };
	                        nextBtn.label = _('finalizeClaim');
	                        //disable the finalize claim button in case mandatory data is not filled in or if there are dsDocuments unfinished
	                        nextBtn.disabled = claimData.missingInfo && (claimData.missingInfo.involvedParties && claimData.missingInfo.involvedParties.length > 0 || missingDocs && missingDocs.length > 0 || unfinishedDsPackageFiles && unfinishedDsPackageFiles.length > 0);
	                        break;
	                    default:
	                        break;
	                }
	            } else if (claimWarningModalStep) {
	                leftBtn.method = this.handleContinueExistingClaim.bind(this);
	                leftBtn.label = _('continueExistingClaimBtn');
	                leftBtn.isHidden = claimWarningModalStep === '1' ? false : true;
	
	                cancelBtn.disabled = false;
	                cancelBtn.method = function () {
	                    return _this6.handleCloseWizardMethod();
	                };
	                cancelBtn.label = _('cancel');
	
	                if (wizardStep === '1') {
	                    nextBtn.method = claimWarningModalStep === '1' ? this.handleSetStepTwoWarningModal.bind(this) : this.handleOnClaimCancel.bind(this);
	                    nextBtn.label = claimWarningModalStep === '1' ? _('cancelClaimButton') : _('cancelClaimButton2');
	                } else if (wizardStep === '2') {
	                    //save and exit method
	                    nextBtn.method = function callee$2$0() {
	                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                case 0:
	                                    context$3$0.next = 2;
	                                    return regeneratorRuntime.awrap(this.handleUpdateInvolvedParties());
	
	                                case 2:
	                                    this.handleCloseWizardMethod(true);
	
	                                case 3:
	                                case "end":
	                                    return context$3$0.stop();
	                            }
	                        }, null, _this6);
	                    };
	                    nextBtn.label = _('saveAnddExitButton');
	
	                    //exit without saving
	                    previousBtn.isHidden = false;
	                    previousBtn.method = function () {
	                        return _this6.handleCloseWizardMethod(true);
	                    };
	                    previousBtn.label = _('exitWithoutSaveButton');
	                } else if (wizardStep === '3') {
	                    nextBtn.method = function callee$2$0() {
	                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                case 0:
	                                    context$3$0.next = 2;
	                                    return regeneratorRuntime.awrap(this.handleFilesUpload(documentFiles));
	
	                                case 2:
	                                    if (!documentFiles.some(function (file) {
	                                        return file.error;
	                                    })) {
	                                        this.handleCloseWizardMethod(true);
	                                    } else {
	                                        this.setState({ returnToClaimWizard: false, claimWarningModalStep: '' });
	                                    }
	
	                                case 3:
	                                case "end":
	                                    return context$3$0.stop();
	                            }
	                        }, null, _this6);
	                    };
	                    nextBtn.label = _('saveAnddExitButton');
	                    previousBtn.isHidden = false;
	                    previousBtn.method = function () {
	                        return _this6.handleCloseWizardMethod(true);
	                    };
	                    previousBtn.label = _('exitWithoutSaveButton');
	                } else if (wizardStep === '4') {
	                    nextBtn.method = function callee$2$0() {
	                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                case 0:
	                                    context$3$0.next = 2;
	                                    return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateClaimComment)(claimData.claimId, fields.stepFour.claimComment.value)));
	
	                                case 2:
	                                    this.handleCloseWizardMethod(true);
	
	                                case 3:
	                                case "end":
	                                    return context$3$0.stop();
	                            }
	                        }, null, _this6);
	                    };
	                    nextBtn.label = _('saveAnddExitButton');
	                    previousBtn.isHidden = false;
	                    previousBtn.method = function () {
	                        return _this6.handleCloseWizardMethod();
	                    };
	                    previousBtn.label = _('exitWithoutSaveButton');
	                }
	            }
	
	            return _react2["default"].createElement(_sharedWizardButtonsWizardButtons2["default"], {
	                leftBtn: leftBtn,
	                cancelBtn: cancelBtn,
	                nextBtn: nextBtn,
	                middleActionBtn: middleActionBtn,
	                previousBtn: previousBtn
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this7 = this;
	
	            var _state5 = this.state;
	            var isExistingClaim = _state5.isExistingClaim;
	            var mobilePhoneOptions = _state5.mobilePhoneOptions;
	            var phoneNumberOptions = _state5.phoneNumberOptions;
	            var productListOptions = _state5.productListOptions;
	            var emailOptions = _state5.emailOptions;
	            var riskOptionsList = _state5.riskOptionsList;
	            var qualificationOptionsList = _state5.qualificationOptionsList;
	            var accountNumberOptions = _state5.accountNumberOptions;
	            var subQualificationOptionsList = _state5.subQualificationOptionsList;
	            var claimWarningModalStep = _state5.claimWarningModalStep;
	            var selfManaging = _state5.selfManaging;
	            var zipCodeOptions = _state5.zipCodeOptions;
	            var optionalInvPartyOptions = _state5.optionalInvPartyOptions;
	            var mandatoryInvPartyOptions = _state5.mandatoryInvPartyOptions;
	            var contractDetails = _state5.contractDetails;
	            var isOpenAreYouSure = _state5.isOpenAreYouSure;
	            var reminderConfirmationModal = _state5.reminderConfirmationModal;
	            var reminderSentSuccessFlag = _state5.reminderSentSuccessFlag;
	            var _props18 = this.props;
	            var claimWizardIsOpened = _props18.claimWizardIsOpened;
	            var fields = _props18.fields;
	            var errors = _props18.errors;
	            var isLegalAid = _props18.isLegalAid;
	            var wizardStep = _props18.wizardStep;
	            var involvedPartiesData = _props18.involvedPartiesData;
	            var module = _props18.module;
	            var clientSubModule = _props18.clientSubModule;
	            var clientOptionsDict = _props18.clientOptionsDict;
	            var claimWizardDocumentsData = _props18.claimWizardDocumentsData;
	            var dsPackages = _props18.dsPackages;
	            var clientData = _props18.clientData;
	            var documents = _props18.documents;
	            var claimData = _props18.claimData;
	            var dispatch = _props18.dispatch;
	
	            return _react2["default"].createElement(
	                "div",
	                null,
	                _react2["default"].createElement(
	                    _reactModal2["default"],
	                    {
	                        isOpen: Boolean(claimWizardIsOpened),
	                        style: _sharedCustomStyles.customModalStyles,
	                        contentLabel: "",
	                        key: "DigitalClaimWizardModal"
	                    },
	                    !claimWarningModalStep && wizardStep && wizardStep === '1' && _react2["default"].createElement(
	                        _ClaimWizardStepOne2["default"],
	                        {
	                            mobilePhoneOptions: mobilePhoneOptions,
	                            phoneNumberOptions: phoneNumberOptions,
	                            emailOptions: emailOptions,
	                            productListOptions: productListOptions,
	                            riskOptionsList: riskOptionsList,
	                            qualificationOptionsList: qualificationOptionsList,
	                            accountNumberOptions: accountNumberOptions,
	                            subQualificationOptionsList: subQualificationOptionsList,
	                            onClaimDateHandler: this.handleDateChange.bind(this),
	                            handleProductChange: this.handleProductChange.bind(this),
	                            handleQualificationChange: this.handleQualificationChange.bind(this),
	                            dispatch: dispatch,
	                            formData: fields.stepOne,
	                            errors: errors,
	                            selfManaging: selfManaging,
	                            isExistingClaim: isExistingClaim,
	                            isLegalAid: isLegalAid,
	                            handleSelfManagingChange: this.onHandleSelfManagingChange.bind(this)
	                        },
	                        this.renderWizardButtons()
	                    ),
	                    !claimWarningModalStep && wizardStep && wizardStep === '2' && _react2["default"].createElement(
	                        _ClaimWizardStepTwo2["default"],
	                        {
	                            involvedPartiesData: involvedPartiesData,
	                            onAddOptionalParty: this.handleOnAddOptionalParty.bind(this),
	                            onRemoveOptionalParty: this.handleOnRemoveOptionalParty.bind(this),
	                            updatePartyField: this.handleUpdatePartyField.bind(this),
	                            mandatoryInvPartyOptions: mandatoryInvPartyOptions,
	                            optionalInvPartyOptions: optionalInvPartyOptions,
	                            countryOptionsList: clientOptionsDict.country,
	                            zipCodeOptions: zipCodeOptions
	                        },
	                        this.renderWizardButtons()
	                    ),
	                    !claimWarningModalStep && wizardStep && wizardStep === '3' && _react2["default"].createElement(
	                        _ClaimWizardStepThree2["default"],
	                        {
	                            claimWizardDocumentsData: claimWizardDocumentsData,
	                            dsPackages: dsPackages,
	                            canCreateMifid: this.props.canCreateMifid,
	                            documentFiles: this.props.documentFiles,
	                            claimDocumentsOptions: clientOptionsDict.documentTypeOptions,
	                            setAlternativeMethod: this.handleSelectedAlternativeDocument.bind(this),
	                            onAddOptionalDocument: this.handleAddClaimWizardOptionalDocument.bind(this),
	                            onRemoveOptionalDocument: this.handleRemoveClaimWizardOptionalDocument.bind(this),
	                            onChangeOptionalDoctypeId: this.handleUpdateClaimWizardOptionalDocument.bind(this),
	                            directSignMethod: this.onDirectSignButtonClick.bind(this),
	                            recreatePackageMethod: this.onClickRecreatePackage.bind(this),
	                            sendRemindersMethod: this.onResendRemindersClick.bind(this),
	                            getDsStakeholdersForInvitation: this.getDsStakeholdersForInvitation.bind(this),
	                            afterInvUpdates: this.handleUpdatesAfterSigningInvitation.bind(this),
	                            addFilesToClaimWizardState: this.handleAddFilesToClaimWizardState.bind(this),
	                            removeDocumentFile: this.handleRemoveDocumentFile.bind(this),
	                            updateDsPackageList: this.handleAddDSPackageToClaimPackage.bind(this),
	                            setFileDrag: this.handleSetFileDrag.bind(this),
	                            isDragging: this.state.isDragging,
	                            claimData: this.props.claimData,
	                            clientData: clientData,
	                            contractDetails: contractDetails,
	                            docsFromDocumentation: documents,
	                            lang: this.props.lang
	                        },
	                        this.renderWizardButtons()
	                    ),
	                    !claimWarningModalStep && wizardStep && wizardStep === '4' && _react2["default"].createElement(
	                        _ClaimWizardStepFour2["default"],
	                        {
	                            documentFiles: this.props.documentFiles,
	                            documents: documents,
	                            involvedPartiesData: involvedPartiesData,
	                            involvedParties: this.props.involvedParties,
	                            mandatoryInvPartyOptions: mandatoryInvPartyOptions,
	                            formData: fields.stepFour,
	                            clientOptionsDict: clientOptionsDict,
	                            missingInfo: claimData.missingInfo,
	                            claimDocumentsOptions: clientOptionsDict.documentTypeOptions,
	                            oraDocuments: claimData.oraDocuments,
	                            docsFromDocumentation: documents
	                        },
	                        this.renderWizardButtons()
	                    ),
	                    claimWarningModalStep && _react2["default"].createElement(
	                        _ClaimWarningModal2["default"],
	                        {
	                            modalTitle: wizardStep === '1' ? _('cancelClaimModal') : wizardStep === '2' ? _('cancelInvolvedParties') : wizardStep === '3' ? _('cancelDocuments') : wizardStep === '4' ? _('cancelClaimComment') : '',
	                            message: wizardStep === '1' && (claimWarningModalStep === '1' ? _('existingClaimMessage') : claimWarningModalStep === '2' ? _('claimCancelMessage') : '') || wizardStep === '2' && _('cancelInvolvedPartiesMessage') || wizardStep === '3' && _('cancelDocumentsMessage') || wizardStep === '4' && _('cancelClaimCommentMessage') },
	                        this.renderWizardButtons()
	                    )
	                ),
	                _react2["default"].createElement(_DSDocumentsAreYouSureModal2["default"], {
	                    isOpen: Boolean(isOpenAreYouSure),
	                    style: _sharedCustomStyles.customModalStyles,
	                    contentLabel: "",
	                    isOpenAreYouSure: isOpenAreYouSure ? isOpenAreYouSure : {},
	                    didClose: function () {
	                        _this7.setState({ isOpenAreYouSure: false });
	                    },
	                    key: "AreYouSureModal"
	                }),
	                _react2["default"].createElement(_DSDocumentsReminderEmailStatusDialog2["default"], {
	                    isOpen: reminderConfirmationModal,
	                    success: reminderSentSuccessFlag,
	                    invitationBlocked: false,
	                    closeModal: function () {
	                        return _this7.setState({ reminderConfirmationModal: false });
	                    }
	                })
	            );
	        }
	
	        // #endregion
	
	    }]);
	
	    var _ClaimsWizard = ClaimsWizard;
	    ClaimsWizard = (0, _reduxForm.reduxForm)({
	        form: 'claimWizardForm',
	        fields: [].concat(_toConsumableArray(_claimsWizardService.stepOneFormFields)),
	        validate: _claimsWizardService.validate
	    })(ClaimsWizard) || ClaimsWizard;
	    ClaimsWizard = (0, _reactRedux.connect)(function (state) {
	        //this will be a property with in authenticate to determine if user has self managing permission in step one
	        var brokersList = state.office.brokers;
	        var clientData = state.clients.clientData;
	        var isLegalAid = state.claimWizard.isLegalAid;
	        var hasSubQualifications = state.claimWizard.hasSubQualifications;
	        var claimData = state.claimWizard.claimData;
	        var wizardStep = state.claimWizard.wizardStep;
	        var involvedPartiesData = state.claimWizard.involvedPartiesData;
	        var claimWizardDocumentsData = state.claimWizard.claimWizardDocumentsData;
	        var dsPackages = state.claimWizard.dsPackages;
	        var involvedParties = state.claimWizard.involvedParties;
	        var optionalParties = state.claimWizard.optionalParties;
	        var documents = state.claimWizard.documents;
	        var appLanguage = state.app.lang;
	        var clientOptionsDict = (0, _libHelpers.generateClientDicts)(state.client.clientOptionsDict, appLanguage);
	        var contracts = state.contracts;
	        var documentFiles = state.claimWizard.documentFiles;
	        var module = state.app.module;
	        var clientSubModule = state.clients.subModule;
	        var clientAccess = state.app.security.actions;
	        var canCreateMifid = false;
	        clientAccess.map(function (oneAccess) {
	            if (oneAccess.actionName == 'createmifid') {
	                canCreateMifid = oneAccess.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        return {
	            brokersList: brokersList, clientData: clientData, claimData: claimData, isLegalAid: isLegalAid, wizardStep: wizardStep, involvedPartiesData: involvedPartiesData, documents: documents, involvedParties: involvedParties,
	            clientOptionsDict: clientOptionsDict, optionalParties: optionalParties, claimWizardDocumentsData: claimWizardDocumentsData, contracts: contracts, lang: appLanguage, documentFiles: documentFiles, module: module,
	            clientSubModule: clientSubModule, dsPackages: dsPackages, canCreateMifid: canCreateMifid, hasSubQualifications: hasSubQualifications
	            // initializeForm: initialValues => dispatch(initialize('claimWizardForm', initialValues))
	        };
	    })(ClaimsWizard) || ClaimsWizard;
	    return ClaimsWizard;
	})(_react.Component);
	
	exports["default"] = ClaimsWizard;
	module.exports = exports["default"];

	// map phone numbers, emails and account numbers from client

	// get product, risk and qualifications, and create options lists

	//check validation first
	// ...
	// prepare data

	//reset form and set initial values

	// this function will be called when the operation is failed
	// it will show a popup with the error message

	// this function will be called when the operation is success
	// it will show a popup with the success message

	// this function will be called when the user click on the confirm button
	// it will call the backend to recreate the package

	// this is an init data for the popup on the first time to ask the user if he is sure to recreate the package

	// show the popup to ask the user if he is sure to recreate the package

	// update all stakeholder as invited

	// dsPackage = await dispatch(getOneDsPackageById(dsPackage._id))

	// await dispatch(setDocumentsForStepThree(claimData._id, claimData))

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementsBanner = __webpack_require__(612);
	
	var _elementsBanner2 = _interopRequireDefault(_elementsBanner);
	
	var _elementsCookieBanner = __webpack_require__(1161);
	
	var _elementsCookieBanner2 = _interopRequireDefault(_elementsCookieBanner);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _CookieBarScss = __webpack_require__(1580);
	
	var _CookieBarScss2 = _interopRequireDefault(_CookieBarScss);
	
	var _ = (0, _libI18n2['default'])('cookieBar');
	
	var CookieBar = function CookieBar(_ref) {
		var className = _ref.className;
		var handleAcceptCookies = _ref.handleAcceptCookies;
	
		return _react2['default'].createElement(
			'div',
			null,
			 false ? _react2['default'].createElement(
				_elementsCookieBanner2['default'],
				{
					className: (0, _classnames2['default'])(_CookieBarScss2['default'].cookies, className),
					buttonText: _('cookieConsent'),
					handleAcceptCookies: handleAcceptCookies
				},
				_react2['default'].createElement(
					'p',
					null,
					_('clientText1')
				),
				_react2['default'].createElement(
					'p',
					null,
					_('clientText2')
				),
				_react2['default'].createElement(
					'p',
					null,
					_('clientText3'),
					_react2['default'].createElement(
						'a',
						{ href: _('clientLink') },
						_('clientLinkText')
					)
				)
			) : _react2['default'].createElement(
				_elementsCookieBanner2['default'],
				{
					className: (0, _classnames2['default'])(_CookieBarScss2['default'].cookies, className),
					buttonText: _('cookieConsent'),
					handleAcceptCookies: handleAcceptCookies
				},
				_react2['default'].createElement(
					'p',
					null,
					_('brokerText1')
				),
				_react2['default'].createElement(
					'p',
					null,
					_('brokerText2')
				),
				_react2['default'].createElement(
					'p',
					null,
					_('brokerText3'),
					_react2['default'].createElement(
						'a',
						{ href: _('brokerLink') },
						_('brokerLinkText')
					)
				)
			)
		);
	};
	
	exports.CookieBar = CookieBar;
	exports['default'] = CookieBar;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	//import cs from 'classnames'
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	// import * as c from 'state/constants'
	
	// init translations
	var _ = (0, _libI18n2['default'])('dswizard');
	
	var IntervalInfoPopup = (function (_Component) {
	    _inherits(IntervalInfoPopup, _Component);
	
	    function IntervalInfoPopup() {
	        _classCallCheck(this, IntervalInfoPopup);
	
	        _get(Object.getPrototypeOf(IntervalInfoPopup.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(IntervalInfoPopup, [{
	        key: 'render',
	
	        /**
	         * Content of are you sure modal
	         */
	        value: function render() {
	            var _props = this.props;
	            var style = _props.style;
	            var isOpen = _props.isOpen;
	            var contentLabel = _props.contentLabel;
	            var didClose = _props.didClose;
	            var modalTitle = _props.modalTitle;
	            var modalDescription = _props.modalDescription;
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: isOpen,
	                    style: style,
	                    contentLabel: contentLabel
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalContent, key: 'rootComponentOfDsWizardIntervalInfoPopup' },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _documentsScss2['default'].title },
	                        modalTitle ? modalTitle : _('IntervalInfoModalTitle')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].message },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _documentsScss2['default'].resendModalContainer },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _documentsScss2['default'].whitespacePre },
	                                modalDescription ? modalDescription : _('IntervalInfoModalDescription')
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentsModalButtons },
	                        _react2['default'].createElement(
	                            'div',
	                            {
	                                onClick: function () {
	                                    didClose();
	                                },
	                                className: _documentsScss2['default'].greenButton + " enabled"
	                            },
	                            _("ok")
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            isOpen: _react.PropTypes.bool,
	            style: _react.PropTypes.object,
	            contentLabel: _react.PropTypes.string,
	            didClose: _react.PropTypes.func,
	            modalTitle: _react.PropTypes.string,
	            modalDescription: _react.PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    return IntervalInfoPopup;
	})(_react.Component);
	
	exports['default'] = IntervalInfoPopup;
	module.exports = exports['default'];

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	//import {UPLOADER_STATE_NEW_POLICY, UPLOADER_STATE_POLICY_FILE, DS_MODULE_CLIENT_CONTRACT} from 'state/constants'
	
	// init translations
	var _ = (0, _libI18n2['default'])('dswizard');
	
	// TODO hardcoded values to be provided by file selector
	
	var OracleDocumentButton = (function (_Component) {
	    _inherits(OracleDocumentButton, _Component);
	
	    function OracleDocumentButton() {
	        _classCallCheck(this, _OracleDocumentButton);
	
	        _get(Object.getPrototypeOf(_OracleDocumentButton.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(OracleDocumentButton, [{
	        key: 'render',
	        value: function render() {
	            var onSelectDocuments = this.props.onSelectDocuments;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].documentsModalButtons },
	                _react2['default'].createElement(
	                    'button',
	                    { type: 'button',
	                        className: _documentsScss2['default'].greenButton,
	                        onClick: function () {
	                            return onSelectDocuments({
	                                id: "",
	                                type: ""
	                            });
	                        } },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].iconContainer },
	                        _react2['default'].createElement('img', { src: __webpack_require__(353) })
	                    ),
	                    _("selectDocument")
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            onSelectDocuments: _react2['default'].PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    var _OracleDocumentButton = OracleDocumentButton;
	    OracleDocumentButton = (0, _reactRedux.connect)(function (state) {
	        return {};
	    })(OracleDocumentButton) || OracleDocumentButton;
	    return OracleDocumentButton;
	})(_react.Component);
	
	exports['default'] = OracleDocumentButton;
	module.exports = exports['default'];

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _uploader = __webpack_require__(143);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	//import {UPLOADER_STATE_NEW_POLICY, UPLOADER_STATE_POLICY_FILE, DS_MODULE_CLIENT_CONTRACT} from 'state/constants'
	
	// init translations
	var _ = (0, _libI18n2['default'])('dswizard');
	
	var UploadLocalDocumentButton = (function (_Component) {
	    _inherits(UploadLocalDocumentButton, _Component);
	
	    function UploadLocalDocumentButton() {
	        _classCallCheck(this, _UploadLocalDocumentButton);
	
	        _get(Object.getPrototypeOf(_UploadLocalDocumentButton.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(UploadLocalDocumentButton, [{
	        key: 'render',
	        value: function render() {
	            var _props = /*addCommentToPackage*/this.props;
	            var moduleType = _props.moduleType;
	            var clientId = _props.clientId;
	            var entityId = _props.entityId;
	            var onSelectDocuments = _props.onSelectDocuments;
	            var classNameExtra = _props.classNameExtra;
	            var claimWizardDocType = _props.claimWizardDocType;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].documentsModalButtons },
	                _react2['default'].createElement(_uploader2['default'], {
	                    type: moduleType,
	                    documents: null,
	                    id: entityId,
	                    clientId: clientId,
	                    forceState: null,
	                    forceDescription: null,
	                    onlyUploadButton: true,
	                    onSelectDocuments: onSelectDocuments,
	                    disableUploadToOracle: true,
	                    classNameExtra: classNameExtra,
	                    claimWizardDocType: claimWizardDocType
	                })
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            onSelectDocuments: _react2['default'].PropTypes.func.isRequired,
	            moduleType: _react2['default'].PropTypes.string.isRequired,
	            clientId: _react2['default'].PropTypes.string.isRequired,
	            entityId: _react2['default'].PropTypes.string,
	            classNameExtra: _react2['default'].PropTypes.any,
	            claimWizardDocType: _react2['default'].PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    var _UploadLocalDocumentButton = UploadLocalDocumentButton;
	    UploadLocalDocumentButton = (0, _reactRedux.connect)(function (state) {
	        return {};
	    })(UploadLocalDocumentButton) || UploadLocalDocumentButton;
	    return UploadLocalDocumentButton;
	})(_react.Component);
	
	exports['default'] = UploadLocalDocumentButton;
	module.exports = exports['default'];

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x4, _x5, _x6) { var _again = true; _function: while (_again) { var object = _x4, property = _x5, receiver = _x6; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x4 = parent; _x5 = property; _x6 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _detailedDocumentScss = __webpack_require__(716);
	
	var _detailedDocumentScss2 = _interopRequireDefault(_detailedDocumentScss);
	
	var _DSWizardHelperScss = __webpack_require__(196);
	
	var _DSWizardHelperScss2 = _interopRequireDefault(_DSWizardHelperScss);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _documentsHelpers = __webpack_require__(106);
	
	var _stateActions = __webpack_require__(5);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _clientContactInfoChangerModalForPackage = __webpack_require__(600);
	
	var _clientContactInfoChangerModalForPackage2 = _interopRequireDefault(_clientContactInfoChangerModalForPackage);
	
	var _mifidButton = __webpack_require__(80);
	
	var _mifidButton2 = _interopRequireDefault(_mifidButton);
	
	var _LinkDocumentModal = __webpack_require__(597);
	
	var _LinkDocumentModal2 = _interopRequireDefault(_LinkDocumentModal);
	
	var _linkAndUploadButton = __webpack_require__(601);
	
	var _linkAndUploadButton2 = _interopRequireDefault(_linkAndUploadButton);
	
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	var DetailedDocument = (function (_Component) {
	    _inherits(DetailedDocument, _Component);
	
	    _createClass(DetailedDocument, null, [{
	        key: 'propTypes',
	        value: {
	            DigitalSignatureSettings: _react.PropTypes.object,
	            clientAccess: _react.PropTypes.array,
	            onItemActionClick: _react.PropTypes.func,
	            determineActionButtonText: _react.PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function DetailedDocument(props) {
	        var _this = this;
	
	        _classCallCheck(this, _DetailedDocument);
	
	        _get(Object.getPrototypeOf(_DetailedDocument.prototype), 'constructor', this).call(this, props);
	
	        this.getIcon = function (iconName) {
	            try {
	                return __webpack_require__(173)("./" + iconName);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        };
	
	        this.onAfterUpdateClientEmail = function () {
	            var dispatch = _this.props.dispatch;
	
	            var stakeholders = _nestedProperty2['default'].get(_this, "state.dsdocument.package.stakeholders");
	
	            //update stakeholders if the case
	            if (stakeholders) {
	                return dispatch((0, _stateActions.getDSStakeholders)(stakeholders, true)).then(function (response) {
	                    _this.setState({ editClientEmail: false, editClientPhoneNumber: false, stakeholderToEdit: null, stakeholders: response });
	                });
	            }
	            // release the email changer modal
	            _this.setState({ editClientEmail: false, stakeholderToEdit: null, editClientPhoneNumber: false });
	        };
	
	        this.renderStatusHistory = function (statusHistory) {
	            return _react2['default'].createElement(
	                'div',
	                { className: _detailedDocumentScss2['default'].statusHistoryContainer },
	                _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        ref: function (el) {
	                            _this.tableStatusHist = el;
	                        },
	                        id: 'table',
	                        className: _detailedDocumentScss2['default'].statusHistoryTable,
	                        itemsPerPage: 50,
	                        pageButtonLimit: 5
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'setOn' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("setOn")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'status' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("status")
	                            )
	                        )
	                    ),
	                    statusHistory.map(function (item, key) {
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            { i: key, key: key },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'setOn' },
	                                item.setOn && (0, _moment2['default'])(item.setOn).format('DD/MM/YYYY HH:mm:ss') || "-"
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'status' },
	                                _react2['default'].createElement(
	                                    'a',
	                                    {
	                                        className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].status, _detailedDocumentScss2['default'].goToLink),
	                                        onClick: function (ev) {
	                                            ev.stopPropagation();
	                                            if (item.status) {
	                                                _this.onItemStatusClick(item.status);
	                                            }
	                                        } },
	                                    item.status ? _((0, _documentsHelpers.getStatusTranslationKey)(item.status)) : '-'
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2['default'].createElement('br', null)
	            );
	        };
	
	        this.onResendClientRemainder = function callee$2$0(packageId) {
	            var stakeholderId = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	            var dispatch, stakeholders, resendReminderRes, updatedStakeholders;
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        stakeholders = _nestedProperty2['default'].get(this, "state.dsdocument.package.stakeholders");
	                        context$3$0.next = 4;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.resendClientRemainder)(packageId, stakeholderId)));
	
	                    case 4:
	                        resendReminderRes = context$3$0.sent;
	
	                        if (!resendReminderRes) {
	                            context$3$0.next = 10;
	                            break;
	                        }
	
	                        context$3$0.next = 8;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getDSStakeholders)(stakeholders)));
	
	                    case 8:
	                        updatedStakeholders = context$3$0.sent;
	
	                        this.setState({ stakeholders: updatedStakeholders });
	
	                    case 10:
	                    case 'end':
	                        return context$3$0.stop();
	                }
	            }, null, _this);
	        };
	
	        this.state = {
	            statusExplainerIsOpen: false,
	            editClientEmail: false,
	            canCreateMifid: false,
	            dsdocument: {},
	            curentPackage: false,
	            isOpenLinkDocumentModal: false,
	            stakeholders: null,
	            stakeholderToEdit: null
	        };
	    }
	
	    _createClass(DetailedDocument, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var clientAccess = _props.clientAccess;
	            var opened = _props.opened;
	
	            this.prepareDSDocumentToDisplay(opened);
	
	            // find and set security flag
	            clientAccess.map(function (item, key) {
	                if (item.actionName == 'createmifid') {
	                    _this2.setState({ canCreateMifid: item.actionAllowed === "true" ? true : false });
	                }
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props2 = this.props;
	            var opened = _props2.opened;
	            var packages = _props2.packages;
	            var dsdocuments = _props2.dsdocuments;
	            var dsdocument = this.state.dsdocument;
	
	            // handle change document id to display
	            if (nextProps.opened !== opened) {
	                this.prepareDSDocumentToDisplay(nextProps.opened);
	            }
	
	            // check if document content modified
	            var newDocs = _nestedProperty2['default'].get(nextProps, "dsdocuments");
	            if (newDocs) {
	
	                // find the document Object by Id
	                var newDoc = _nestedProperty2['default'].get(newDocs.filter(function (item) {
	                    return String(item._id) === String(nextProps.opened);
	                }), "0");
	
	                // if there is a change of document opened, then refresh  in  state
	                if (JSON.stringify(newDocs) !== JSON.stringify(dsdocument)) {
	
	                    // change package only if there is an opened document what have package.
	                    if (_nestedProperty2['default'].get(newDoc, "package")) {
	                        this.setState({ curentPackage: _nestedProperty2['default'].get(newDoc, "package") }, function () {
	                            // debug place
	                        });
	                    }
	
	                    this.setState({ dsdocument: newDoc }, function () {
	                        // debug place
	                    });
	                }
	            }
	
	            /* let oldPack = packages.filter((item=>{return (item._id === dsdocument.package._id)}))
	            let newPack = nextProps.packages.filter((item=>{return (item._id === dsdocument.package._id)})) */
	        }
	
	        //remove this and instead get the package object from server via new method
	        /**
	         * This function will change the document what is used to render.
	         */
	    }, {
	        key: 'prepareDSDocumentToDisplay',
	        value: function prepareDSDocumentToDisplay(dsdocumentId) {
	            var _this3 = this;
	
	            var forceFetch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	            var _props3 = this.props;
	            var dispatch = _props3.dispatch;
	            var dsdocuments = _props3.dsdocuments;
	
	            var force = true;
	
	            new Promise(function (resolve) {
	                if (!dsdocuments || dsdocuments.length === 0 || forceFetch) {
	                    dispatch((0, _stateActions.getDsDocsAndPackages)(force)).then(function () {
	                        _this3.setState({ dsdocument: _nestedProperty2['default'].get(dsdocuments.filter(function (item) {
	                                return item._id === dsdocumentId;
	                            }), "0") }, function () {
	                            return resolve();
	                        });
	                    });
	                } else {
	                    _this3.setState({ dsdocument: _nestedProperty2['default'].get(dsdocuments.filter(function (item) {
	                            return item._id === dsdocumentId;
	                        }), "0") }, function () {
	                        return resolve();
	                    });
	                }
	            })
	            //in this step we will get the stakeholders data and put it to state
	            .then(function () {
	                var currentPackage = _nestedProperty2['default'].get(_this3, "state.dsdocument.package");
	                if (currentPackage && currentPackage.stakeholders && currentPackage.stakeholders.length > 0) {
	                    return dispatch((0, _stateActions.getDSStakeholders)(currentPackage.stakeholders));
	                }
	                return [];
	            }).then(function (stakeholders) {
	                _this3.setState({ curentPackage: _nestedProperty2['default'].get(_this3, "state.dsdocument.package"), stakeholders: stakeholders });
	            });
	        }
	
	        /**
	         * This function handle the status modal opening
	         * @param {string} status
	         */
	    }, {
	        key: 'onItemStatusClick',
	        value: function onItemStatusClick(status) {
	            this.setState({ statusExplainerIsOpen: status });
	        }
	
	        /**
	         * This function helps to use an icon on a safe way
	         */
	    }, {
	        key: 'navigateTo',
	
	        /**
	         * This function will navigate to the target module by entity id (contracts, claims)
	         * @param {object} dsdocument - dsdocument record
	         */
	        value: function navigateTo(dsdocument) {
	            // navigateToModuleName, dynamicId, clientId, options)
	            var dispatch = this.props.dispatch;
	
	            var clientId = _nestedProperty2['default'].get(dsdocument, "package.clientId");
	            var contractId = _nestedProperty2['default'].get(dsdocument, "contractId");
	            var claimId = _nestedProperty2['default'].get(dsdocument, "claimId");
	            var tarificationId = _nestedProperty2['default'].get(dsdocument, "tarificationId");
	
	            var dynamicId = clientId;
	            var navigateToModuleName = '';
	
	            // navigate by uploaded on module value, not after contract or claim existence (BEWB-231)
	            if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS) {
	                dynamicId = claimId;
	                navigateToModuleName = 'claims';
	            }
	
	            if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT || c.DS_MODULE_CLIENT_CONTRACT_PREM) {
	                dynamicId = contractId;
	                navigateToModuleName = 'contracts';
	            }
	
	            if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION) {
	                dynamicId = tarificationId;
	                navigateToModuleName = 'tarification';
	            }
	
	            // this next line of code (commented) can get clientId from oracle by contract or claim
	            // getClientId(contractId, claimId).then((clientId)=>{  })
	
	            dispatch((0, _stateActions.setAppModule)(c.CLIENTS, clientId));
	            dispatch((0, _stateActions.setOpenedSubmenu)(dynamicId, {})); // submenuOpened: claimId, subModuleZoom: {}
	            dispatch((0, _stateActions.setClientSubModule)(navigateToModuleName)); // subModule: 'claims' subModuleZoom: ''
	        }
	
	        /**
	         * This function extract the signing date from status history.
	         * @param {*} dsdocument
	         */
	    }, {
	        key: 'getSigningDate',
	        value: function getSigningDate(dsdocument) {
	            var statusHistory = _nestedProperty2['default'].get(dsdocument, "package.statusHistory");
	
	            if (!statusHistory || statusHistory.length === 0) {
	                return false;
	            }
	
	            var signDate = false;
	            statusHistory.forEach(function (oneStatus) {
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
	                    signDate = oneStatus.setOn;
	                }
	            });
	
	            return signDate && (0, _moment2['default'])(signDate).format('DD/MM/YYYY HH:mm:ss');
	        }
	
	        /**
	         * This function could fetch if the package is in a fail state
	         * @param {*} statusHistory
	         * @returns {object} - {notice: {string}, isAFail: {Bool}}
	         */
	    }, {
	        key: 'getLatestError',
	        value: function getLatestError(status, statusHistory) {
	            var result = {
	                isAFail: false,
	                notice: ''
	            };
	
	            if (!statusHistory || statusHistory.length === 0) {
	                return result;
	            }
	
	            // check if the package status is a failed status
	            result.isAFail = (0, _documentsHelpers.isAFailStatus)(status);
	
	            var lastStatus = _nestedProperty2['default'].get(statusHistory, statusHistory.length - 1);
	            result.notice = lastStatus.notice;
	
	            return result;
	        }
	
	        /**
	         * This function will
	         * @param {*} dsDocInstance
	         * @param {*} includeHimSelf -Boolean
	         */
	    }, {
	        key: 'findDSDocumentsFromSamePackage',
	        value: function findDSDocumentsFromSamePackage(dsDocInstance) {
	            var includeHimSelf = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	            var dsdocuments = this.props.dsdocuments;
	
	            var result = [];
	
	            if (!dsdocuments || dsdocuments.length === 0) {
	                return result;
	            }
	
	            result = dsdocuments.filter(function (item) {
	                var _id = _nestedProperty2['default'].get(item, "package._id");
	                var _id2 = _nestedProperty2['default'].get(dsDocInstance, "package._id");
	
	                return _id === _id2 && (!includeHimSelf && dsDocInstance._id !== item._id || includeHimSelf);
	            });
	
	            return result;
	        }
	
	        /**
	         * This function will
	         * @param {*} dsDocInstance
	         */
	    }, {
	        key: 'findDSDocumentsFromPackage',
	        value: function findDSDocumentsFromPackage(packageId) {
	            var dsdocuments = this.props.dsdocuments;
	
	            var result = [];
	
	            if (!dsdocuments || dsdocuments.length === 0) {
	                return result;
	            }
	
	            result = dsdocuments.filter(function (item) {
	                var _id = _nestedProperty2['default'].get(item, "package._id");
	                var _id2 = packageId;
	                return _id === _id2;
	            });
	
	            return result;
	        }
	
	        /**
	         * This function will navigate to an another document.
	         * @param {string} DsDocId
	         */
	    }, {
	        key: 'onClickDSDocInSamePackage',
	        value: function onClickDSDocInSamePackage(DsDocId) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.setAppModule)(c.DSDOCUMENTS));
	            dispatch((0, _stateActions.setDSDocumentsOpened)(''));
	            dispatch((0, _stateActions.setDSDocumentsOpened)(DsDocId));
	            dispatch((0, _stateActions.setDSDocumentsSubModule)('detailedDSDocument'));
	        }
	
	        /**
	         * This function will render the table of document from the same package
	         * @param {array} docuemntsList - list of documents from same package
	         */
	    }, {
	        key: 'renderDSDocumentsInSamePackage',
	        value: function renderDSDocumentsInSamePackage(docuemntsList) {
	            var _this4 = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _detailedDocumentScss2['default'].statusHistoryContainer },
	                _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        ref: function (el) {
	                            _this4.tableSamePackage = el;
	                        },
	                        id: 'table',
	                        className: _detailedDocumentScss2['default'].statusHistoryTable,
	                        itemsPerPage: 50,
	                        pageButtonLimit: 5
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'createdAt' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("createdAt")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'fileName' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("fileName")
	                            )
	                        )
	                    ),
	                    docuemntsList.map(function (item, key) {
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            { i: key, key: key },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'createdAt' },
	                                item.createdAt && (0, _moment2['default'])(item.createdAt).format('DD/MM/YYYY HH:mm:ss') || "-"
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'fileName' },
	                                _react2['default'].createElement(
	                                    'a',
	                                    {
	                                        className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].status, _detailedDocumentScss2['default'].goToLink),
	                                        onClick: function (ev) {
	                                            ev.stopPropagation();
	                                            _this4.onClickDSDocInSamePackage(item._id);
	                                        } },
	                                    item.fileName
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }
	
	        /**
	         * After Close wizard refresh the documents list and open the first one if this one is deleted.
	         * @param {*} packageId
	         */
	    }, {
	        key: 'onCloseDSWizard',
	        value: function onCloseDSWizard(packageId) {
	            var _props4 = this.props;
	            var opened = _props4.opened;
	            var dsdocument = _props4.dsdocument;
	            var dispatch = _props4.dispatch;
	
	            // if this document is deleted then navigate to other one
	            if (!dsdocument) {
	                var brotherDocuments = this.findDSDocumentsFromPackage(packageId);
	                dispatch((0, _stateActions.setAppModule)(c.DSDOCUMENTS, ''));
	            } else {
	                this.prepareDSDocumentToDisplay(opened, true);
	            }
	        }
	
	        /**
	         * This function provide false if can be sent a remainder.
	         * this is adapted for version 8
	         * @param {*} dsPackage
	         */
	    }, {
	        key: 'shouldSendRemainder',
	        value: function shouldSendRemainder(dsPackage) {
	            var should = false;
	            var templates = dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.map(function (oneDoc) {
	                return oneDoc.documentTemplate;
	            });
	            // can be enabled the remainder when there are minimum one document what should be signed
	            if (dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.length > 0 && templates && templates.length > 0) {
	                dsPackage.dsDocuments.forEach(function (oneDoc) {
	                    templates.forEach(function (oneTemplate) {
	                        if (String(oneDoc.documentTemplateId) === String(oneTemplate._id) && oneTemplate.mustBeSigned) {
	                            should = true;
	                        }
	                    });
	                });
	            }
	
	            // no status history, normally never happen this
	            if (!dsPackage || !dsPackage.statusHistory) {
	                return should;
	            }
	
	            // check if not closed the package
	            dsPackage.statusHistory.forEach(function (oneStatus) {
	                // the best case, when signed, no more remainder necessary
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
	                    should = false;
	                }
	
	                // any cases when the package life is over, no more remainder necessary
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_REJECTED || oneStatus.status === c.DS_PACKAGE_STATUS_REVOKED || oneStatus.status === c.DS_PACKAGE_STATUS_EXPIRED || oneStatus.status === c.DS_PACKAGE_STATUS_FAILED || oneStatus.status === c.DS_PACKAGE_STATUS_DELETED) {
	                    should = false;
	                }
	            });
	
	            return should;
	        }
	
	        /**
	         * This function provide false if the package is not signed.
	         * @param {*} status
	         * @param {*} statusHistory
	         */
	    }, {
	        key: 'isSignedPackage',
	        value: function isSignedPackage(status, statusHistory) {
	            var isSigned = status === c.DS_PACKAGE_STATUS_FINISHED;
	
	            if (!statusHistory) {
	                return isSigned;
	            }
	
	            statusHistory.forEach(function (oneStatus) {
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
	                    isSigned = true;
	                }
	            });
	
	            return isSigned;
	        }
	
	        /**
	         * This function provide true if the package is expired and not signed.
	         * @param {*} status
	         * @param {*} statusHistory
	         */
	    }, {
	        key: 'isExpiredPackage',
	        value: function isExpiredPackage(status, statusHistory) {
	            var isExpired = status === 'packageStatusExpired';
	
	            if (!statusHistory) {
	                return isExpired;
	            }
	
	            statusHistory.forEach(function (oneStatus) {
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
	                    isExpired = false;
	                }
	            });
	
	            return isExpired;
	        }
	
	        /***
	         * Event handler for on resent the email.
	         */
	    }, {
	        key: 'openLinkAndUploadWizard',
	
	        /**
	         * Open the model for linking or uploading document
	         * @param {*} dsDocument
	         */
	        value: function openLinkAndUploadWizard(dsDocument) {
	            this.setState({ isOpenLinkDocumentModal: dsDocument });
	        }
	
	        /**
	         * Refresh the document tho show the latest updated details
	         * @param {function} onSubmit
	         * @returns
	         */
	    }, {
	        key: 'simpleRefresh',
	        value: function simpleRefresh() {
	            var _this5 = this;
	
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _stateActions.getDsDocsAndPackages)(true)).then(function (result) {
	                return _this5.forceUpdate();
	            })['catch'](function (err) {
	                return _this5.forceUpdate();
	            });
	        }
	    }, {
	        key: 'renderStakeholdersArea',
	        value: function renderStakeholdersArea(stakeholders, dsdocument, isEditableThePackage, shouldSendRemainder) {
	            var _this6 = this;
	
	            var curentPackage = this.state.curentPackage;
	
	            var canSendNextReminder = +dsdocument['package'].remainderRepeats > 0 ? true : false;
	            var signatureType = dsdocument.documentTemplate.digitalSignatureType;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                    _('signersArea')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].columnWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].signersLabelsColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel, _detailedDocumentScss2['default'].columnTitle) },
	                                    ' '
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerName')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerEmail')
	                                )
	                            ),
	                            signatureType === "SmsOtp" && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerPhoneNumber')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerLanguage')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('lastRemainderSentOn')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('nextRemainderSendOn')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('remainderCount')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('manuallRemainderCount')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signingStatusLabel')
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].firstSignerColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer, _detailedDocumentScss2['default'].columnTitle) },
	                                    _('firstSignerColumnTitle')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    stakeholders[0].lastName + ' ' + stakeholders[0].firstName
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + stakeholders[0].email },
	                                            stakeholders[0].email
	                                        ),
	                                        !stakeholders[0].finished && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this6.setState({ editClientEmail: true, stakeholderToEdit: stakeholders[0] });
	                                            } })
	                                    )
	                                )
	                            ),
	                            signatureType === "SmsOtp" && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + stakeholders[0].phoneNumber },
	                                            stakeholders[0].phoneNumber
	                                        ),
	                                        !stakeholders[0].finished && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this6.setState({ editClientPhoneNumber: true, stakeholderToEdit: stakeholders[0] });
	                                            } })
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    stakeholders[0].language
	                                )
	                            ),
	                            isEditableThePackage ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _('reminderSentOnNotReady')
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(stakeholders[0], "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ),
	                            !isEditableThePackage ? canSendNextReminder ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(stakeholders[0], "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    '-'
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _('nextReminderNotReady')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(stakeholders[0], "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(stakeholders[0], "remainderSentCount")) + " / " + _nestedProperty2['default'].get(curentPackage, "remainderRepeats")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(stakeholders[0], "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(stakeholders[0], "remainderSentCountManually") || 0) + " / " + _("infinite")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                stakeholders[0].finished && _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('signerHasSignedStatus')
	                                ) || _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('signerHasNotSignedStatus')
	                                )
	                            ),
	                            !stakeholders[0].finished && !isEditableThePackage && shouldSendRemainder && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].mifidButtonContainer) },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "resentButton",
	                                            className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].grayButtonFlex, _DSWizardHelperScss2['default'].mifidButton),
	                                            onClick: function (e) {
	                                                return _this6.onResendClientRemainder(_nestedProperty2['default'].get(dsdocument, "package._id"), stakeholders[0]._id);
	                                            }
	                                        },
	                                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].icon, _detailedDocumentScss2['default'].iconPaddingRight), src: this.getIcon('icn-inbox-white.svg') }),
	                                        _('resendRemainderEmail')
	                                    )
	                                )
	                            )
	                        ),
	                        stakeholders.length > 1 && _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].firstSignerColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer, _detailedDocumentScss2['default'].columnTitle) },
	                                    _('secondSignerColumnTitle')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    stakeholders[1].lastName + ' ' + stakeholders[1].firstName
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + stakeholders[1].email },
	                                            stakeholders[1].email
	                                        ),
	                                        !stakeholders[1].finished && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this6.setState({ editClientEmail: true, stakeholderToEdit: stakeholders[1] });
	                                            } })
	                                    )
	                                )
	                            ),
	                            signatureType === "SmsOtp" && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + stakeholders[1].phoneNumber },
	                                            stakeholders[1].phoneNumber
	                                        ),
	                                        !stakeholders[0].finished && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this6.setState({ editClientPhoneNumber: true, stakeholderToEdit: stakeholders[1] });
	                                            } })
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    stakeholders[1].language
	                                )
	                            ),
	                            isEditableThePackage ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _('reminderSentOnNotReady')
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(stakeholders[1], "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ),
	                            !isEditableThePackage ? canSendNextReminder ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(stakeholders[1], "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    '-'
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _('nextReminderNotReady')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(stakeholders[1], "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(stakeholders[1], "remainderSentCount")) + " / " + _nestedProperty2['default'].get(curentPackage, "remainderRepeats")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(stakeholders[1], "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(stakeholders[1], "remainderSentCountManually") || 0) + " / " + _("infinite")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                stakeholders[1].finished && _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('signerHasSignedStatus')
	                                ) || _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('signerHasNotSignedStatus')
	                                )
	                            ),
	                            !stakeholders[1].finished && !isEditableThePackage && shouldSendRemainder && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].mifidButtonContainer) },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "resentButton",
	                                            className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].grayButtonFlex, _DSWizardHelperScss2['default'].mifidButton),
	                                            onClick: function (e) {
	                                                return _this6.onResendClientRemainder(_nestedProperty2['default'].get(dsdocument, "package._id"), stakeholders[1]._id);
	                                            }
	                                        },
	                                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].icon, _detailedDocumentScss2['default'].iconPaddingRight), src: this.getIcon('icn-inbox-white.svg') }),
	                                        _('resendRemainderEmail')
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderSignerArea',
	        value: function renderSignerArea(clientEmailAddress, dsdocument, isEditableThePackage, shouldSendRemainder) {
	            var _this7 = this;
	
	            var curentPackage = this.state.curentPackage;
	
	            var isSignedThePackage = this.isSignedPackage(_nestedProperty2['default'].get(curentPackage, "status"), _nestedProperty2['default'].get(curentPackage, "statusHistory"));
	            var canSendNextReminder = +dsdocument['package'].remainderRepeats > 0 ? true : false;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                    _('signersArea')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].columnWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].signersLabelsColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel, _detailedDocumentScss2['default'].columnTitle) },
	                                    ' '
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerName')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerEmail')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerLanguage')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('lastRemainderSentOn')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('nextRemainderSendOn')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('lastRemainderSentOn')
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].firstSignerColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer, _detailedDocumentScss2['default'].columnTitle) },
	                                    _('firstSignerColumnTitle')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _nestedProperty2['default'].get(dsdocument, "package.clientName")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + clientEmailAddress },
	                                            clientEmailAddress
	                                        ),
	                                        !isSignedThePackage && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this7.setState({ editClientEmail: true });
	                                            } })
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    dsdocument.language
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(curentPackage, "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ),
	                            canSendNextReminder ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(curentPackage, "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    '-'
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(curentPackage, "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(curentPackage, "remainderSentCount")) + " / " + _nestedProperty2['default'].get(curentPackage, "remainderRepeats")
	                                )
	                            ),
	                            !isEditableThePackage && shouldSendRemainder && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].mifidButtonContainer) },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "resentButton",
	                                            className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].grayButtonFlex, _DSWizardHelperScss2['default'].mifidButton),
	                                            onClick: function (e) {
	                                                return _this7.onResendClientRemainder(_nestedProperty2['default'].get(dsdocument, "package._id"), null);
	                                            }
	                                        },
	                                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].icon, _detailedDocumentScss2['default'].iconPaddingRight), src: this.getIcon('icn-inbox-white.svg') }),
	                                        _('resendRemainderEmail')
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	
	        /**
	         * Render hook of react
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var _props5 = this.props;
	            var lang = _props5.lang;
	            var templates = _props5.templates;
	            var _state = this.state;
	            var statusExplainerIsOpen = _state.statusExplainerIsOpen;
	            var editClientEmail = _state.editClientEmail;
	            var canCreateMifid = _state.canCreateMifid;
	            var dsdocument = _state.dsdocument;
	            var curentPackage = _state.curentPackage;
	            var isOpenLinkDocumentModal = _state.isOpenLinkDocumentModal;
	            var stakeholders = _state.stakeholders;
	            var stakeholderToEdit = _state.stakeholderToEdit;
	            var editClientPhoneNumber = _state.editClientPhoneNumber;
	
	            // few flags for render conditions
	            var isEditableThePackage = (0, _documentsHelpers.shouldEditThePackage)(_nestedProperty2['default'].get(curentPackage, "statusHistory"), _nestedProperty2['default'].get(curentPackage, "isEditable"));
	
	            // if there are no package let the mifid button to render by setting this
	            if (!curentPackage) {
	                isEditableThePackage = true;
	            }
	
	            // filter the document in two way, including himself and without
	            var docsInPackage = this.findDSDocumentsFromSamePackage(dsdocument, true);
	            var dsdocumentsInSamePackageList = this.findDSDocumentsFromSamePackage(dsdocument, false);
	
	            // calculate and collect flags for logical operations
	            var shouldSendRemainder = this.shouldSendRemainder(_nestedProperty2['default'].get(curentPackage, "statusHistory"), docsInPackage, templates);
	
	            var isSignedThePackage = this.isSignedPackage(_nestedProperty2['default'].get(curentPackage, "status"), _nestedProperty2['default'].get(curentPackage, "statusHistory"));
	
	            var mustBeSigned = dsdocument.documentTemplate && dsdocument.documentTemplate.mustBeSigned;
	            var isUploaded = dsdocument.uploadedToOracle;
	
	            // collect ID-s and numbers for table
	            var contractId = _nestedProperty2['default'].get(curentPackage, "contractId");
	            var claimId = _nestedProperty2['default'].get(curentPackage, "claimId");
	            var claimNumber = _nestedProperty2['default'].get(curentPackage, "claimNumber");
	            var contractNumber = _nestedProperty2['default'].get(curentPackage, "contractNumber");
	
	            var isExpiredThePackage = this.isExpiredPackage(_nestedProperty2['default'].get(curentPackage, "status"), _nestedProperty2['default'].get(curentPackage, "statusHistory"));
	
	            // fetch error state is has
	            var statusErrorState = this.getLatestError(_nestedProperty2['default'].get(curentPackage, "status"), _nestedProperty2['default'].get(curentPackage, "statusHistory"));
	
	            var statusHistory = _nestedProperty2['default'].get(curentPackage, "statusHistory");
	            var clientEmailAddress = _nestedProperty2['default'].get(curentPackage, "clientEmailAddress");
	
	            // don't show the last status, must shown the signed status in case when the document is signed: BEWB-445
	            var statusToShow = _nestedProperty2['default'].get(curentPackage, "status") || "";
	            if (mustBeSigned) {
	                if (isSignedThePackage) {
	                    statusToShow = c.DS_PACKAGE_STATUS_FINISHED;
	                }
	            } else {
	                if (isUploaded) {
	                    statusToShow = c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE;
	                }
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _detailedDocumentScss2['default'].dsdocumentContainer },
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                    _('dsdocumentName') + (dsdocument && ' - "' + _nestedProperty2['default'].get(dsdocument, "fileName") + '"' || '')
	                ),
	                dsdocument && _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].columnWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].columnLeft) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('documentTemplate'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "documentTemplate.title." + lang)
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('clientName'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "package.clientName")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('brokerNumber'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "package.brokerNumber")
	                                )
	                            ),
	                            contractNumber && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('contractNumber'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    contractNumber
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('documentLocation'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'a',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].column, _detailedDocumentScss2['default'].goToLink),
	                                        onClick: function (e) {
	                                            e.stopPropagation();
	                                            _this8.navigateTo(dsdocument, false);
	                                        }
	                                    },
	                                    dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS && _('goToClaims'),
	                                    dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT && _('goToContracts'),
	                                    dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM && _('goToContracts'),
	                                    dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_PROFILE && _('goToProfile'),
	                                    dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION && _('goToTarification')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('packageName'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "package.connectivePackageName")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('documentLanguage'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    dsdocument.language
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].columnRight) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('createdAt'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    dsdocument && dsdocument.createdAt && (0, _moment2['default'])(dsdocument.createdAt).format('DD/MM/YYYY HH:mm:ss') || "-"
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('updatedAt'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    dsdocument.updatedAt != undefined && (0, _moment2['default'])(dsdocument.updatedAt).format('DD/MM/YYYY HH:mm:ss') || "-"
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('signedAt'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    this.getSigningDate(dsdocument) || "-"
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('packageStatus'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'a',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].column, _detailedDocumentScss2['default'].goToLink),
	                                        onClick: function (ev) {
	                                            ev.stopPropagation();
	                                            if (statusToShow) {
	                                                _this8.onItemStatusClick(statusToShow);
	                                            }
	                                        }
	                                    },
	                                    statusToShow ? _((0, _documentsHelpers.getStatusTranslationKey)(statusToShow)) : ''
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('packageExpiration'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "package.expirationOn")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row, _detailedDocumentScss2['default'].mifidContainer) },
	                                    canCreateMifid && _react2['default'].createElement(_mifidButton2['default'], {
	                                        step: c.DSWIZARD_STEP_1_COMPOSE_PACKAGE,
	                                        packageId: _nestedProperty2['default'].get(dsdocument, "package._id"),
	                                        lang: lang,
	                                        callBackOnClose: function () {
	                                            _this8.onCloseDSWizard();
	                                        },
	                                        moduleKeyToSet: _nestedProperty2['default'].get(dsdocument, "package.uploadedOnModule"),
	
	                                        clientId: _nestedProperty2['default'].get(dsdocument, "package.clientId"),
	                                        claimId: _nestedProperty2['default'].get(dsdocument, "package.claimId"),
	                                        claimNumber: _nestedProperty2['default'].get(dsdocument, "package.claimNumber"),
	                                        contractId: _nestedProperty2['default'].get(dsdocument, "package.contractId"),
	                                        contractNumber: _nestedProperty2['default'].get(dsdocument, "package.contractNumber"),
	                                        tarificationId: _nestedProperty2['default'].get(dsdocument, "package.tarificationId"),
	                                        tarificationNumber: _nestedProperty2['default'].get(dsdocument, "package.tarificationNumber"),
	                                        stakeholders: stakeholders,
	
	                                        hideButton: !isEditableThePackage,
	                                        isResume: true
	                                    }),
	                                    _react2['default'].createElement(_linkAndUploadButton2['default'], { dsDocument: dsdocument, templates: templates,
	                                        openLinkAndUploadWizard: function (dsDocument) {
	                                            return _this8.openLinkAndUploadWizard(dsDocument);
	                                        }
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                dsdocument.documentTemplate && dsdocument.documentTemplate.mustBeSigned ? stakeholders && stakeholders.length > 0 ? this.renderStakeholdersArea(stakeholders, dsdocument, isEditableThePackage, shouldSendRemainder) : clientEmailAddress ? this.renderSignerArea(clientEmailAddress, dsdocument, isEditableThePackage, shouldSendRemainder) : null : dsdocument.documentTemplate && !dsdocument.documentTemplate.mustBeSigned ? _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                        _('signersArea')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].signersLabelsColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('documentNotRequireSignig')
	                                )
	                            )
	                        )
	                    )
	                ) : null,
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                    _('packageStatusHistory')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].column },
	                            statusHistory && statusHistory.length > 0 && this.renderStatusHistory(statusHistory)
	                        )
	                    )
	                ),
	                dsdocumentsInSamePackageList && dsdocumentsInSamePackageList.length > 0 && _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                        _('dsdocumentsInSamePackages')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _detailedDocumentScss2['default'].column },
	                                this.renderDSDocumentsInSamePackage(dsdocumentsInSamePackageList)
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                    _('technicalInfo')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].columnWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].columnLeft) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('isContractSpecific'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "package.contractId") ? _("yes") : _("no")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('connectiveDocumentId'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "connectiveDocumentId")
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].columnRight) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('digitalSignatureType'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "documentTemplate.digitalSignatureType")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('datasetName'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsdocument, "documentTemplate.dataSetId.datasetName")
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    claimNumber && _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedDocumentScss2['default'].column },
	                            _('claimNumber'),
	                            ': '
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedDocumentScss2['default'].column },
	                            claimNumber
	                        )
	                    ),
	                    statusErrorState.isAFail && _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedDocumentScss2['default'].column },
	                            _('failedMessage'),
	                            ': '
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedDocumentScss2['default'].column },
	                            statusErrorState.notice || "-"
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: Boolean(statusExplainerIsOpen),
	                        style: _documentsHelpers.customModalStyles
	                    },
	                    (0, _documentsHelpers.statusExplainerPopup)(_((0, _documentsHelpers.getStatusTranslationKey)(statusExplainerIsOpen)), _((0, _documentsHelpers.getStatusDescriptionTranslationKey)(statusExplainerIsOpen)), function () {
	                        _this8.setState({ statusExplainerIsOpen: false });
	                    }, _("ok"))
	                ),
	                _react2['default'].createElement(_clientContactInfoChangerModalForPackage2['default'], {
	                    dsdocument: dsdocument,
	                    triggerToOpen: editClientEmail || editClientPhoneNumber,
	                    editClientEmail: editClientEmail,
	                    editClientPhoneNumber: editClientPhoneNumber,
	                    stakeholder: stakeholderToEdit,
	                    isEditableThePackage: isEditableThePackage,
	                    callBackOnClose: function () {
	                        _this8.onAfterUpdateClientEmail();
	                    }
	                }),
	                _react2['default'].createElement(_LinkDocumentModal2['default'], {
	                    modalIsOpen: !!isOpenLinkDocumentModal,
	                    onCancel: function () {
	                        _this8.setState({ isOpenLinkDocumentModal: false });
	                        _this8.simpleRefresh();
	                    },
	                    onConfirmation: function () {
	                        _this8.simpleRefresh();
	                        _this8.setState({ isOpenLinkDocumentModal: false });
	                    },
	                    flag: 'LinkDocumentModal',
	                    payload: isOpenLinkDocumentModal ? {
	                        dsdocument: isOpenLinkDocumentModal
	                    } : {}
	                })
	            );
	        }
	    }]);
	
	    var _DetailedDocument = DetailedDocument;
	    DetailedDocument = (0, _reactRedux.connect)(function (state) {
	        return {
	            // the lits for drop-downs for digi sign in the future use are:
	            // DigitalSignatureHardLists: state.app.security.DigitalSignatureHardLists
	            paginatedPackages: state.DSDocuments.items,
	            packages: state.DSDocuments.packages,
	            templates: state.DSDocuments.templates,
	
	            // must fetch the setting
	            DigitalSignatureSettings: state.DSDocuments.DigitalSignatureSettings,
	            opened: state.DSDocuments.opened,
	            clientAccess: state.app.security.actions,
	            lang: state.app.lang
	        };
	    })(DetailedDocument) || DetailedDocument;
	    return DetailedDocument;
	})(_react.Component);
	
	exports['default'] = DetailedDocument;
	module.exports = exports['default'];

	/**
	 * This is the call-back function of the email changer popup.
	 * @param {string} newEmail - this is the mail address provided by the address changer module
	 */

	/**
	 * This function render the status history data-table
	 */
	/* <div className={cs(styles.row)}>
	   <p className={styles.column}>{_('uploadedOnModule')}: </p>
	   <p className={styles.column}>{dsdocument.uploadedOnModule}</p>
	</div> */ /* <div className={cs(styles.row)}>
	             <p className={styles.column}>{_('accessLink')}: </p>
	             <p className={styles.column}>{nesProp.get(dsdocument,"package.accessLink")}</p>
	          </div> */

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _detailedDocumentScss = __webpack_require__(716);
	
	var _detailedDocumentScss2 = _interopRequireDefault(_detailedDocumentScss);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _DSWizardHelperScss = __webpack_require__(196);
	
	var _DSWizardHelperScss2 = _interopRequireDefault(_DSWizardHelperScss);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _documentsHelpers = __webpack_require__(106);
	
	var _stateActions = __webpack_require__(5);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _clientContactInfoChangerModalForPackage = __webpack_require__(600);
	
	var _clientContactInfoChangerModalForPackage2 = _interopRequireDefault(_clientContactInfoChangerModalForPackage);
	
	var _mifidButton = __webpack_require__(80);
	
	var _mifidButton2 = _interopRequireDefault(_mifidButton);
	
	var _DSWizardHelper = __webpack_require__(124);
	
	var _dsListButtonsWrapper = __webpack_require__(364);
	
	var _dsListButtonsWrapper2 = _interopRequireDefault(_dsListButtonsWrapper);
	
	var _linkToContractAndUploadDocumentsLinkDocumentsModal = __webpack_require__(602);
	
	var _linkToContractAndUploadDocumentsLinkDocumentsModal2 = _interopRequireDefault(_linkToContractAndUploadDocumentsLinkDocumentsModal);
	
	var _emailSenderEmailButton = __webpack_require__(108);
	
	var _emailSenderEmailButton2 = _interopRequireDefault(_emailSenderEmailButton);
	
	var _stateActions2 = __webpack_require__(5);
	
	var _AreYouSureModal = __webpack_require__(363);
	
	var _AreYouSureModal2 = _interopRequireDefault(_AreYouSureModal);
	
	var _reminderEmailStatusDialog = __webpack_require__(264);
	
	var _reminderEmailStatusDialog2 = _interopRequireDefault(_reminderEmailStatusDialog);
	
	var _libHelpers = __webpack_require__(24);
	
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	var HALF_FILLED_PDF_API_URL = "/api/getHalfFilledPdfForPrint";
	
	var DetailedPackage = (function (_Component) {
	    _inherits(DetailedPackage, _Component);
	
	    _createClass(DetailedPackage, null, [{
	        key: 'propTypes',
	        value: {
	            DigitalSignatureSettings: _react.PropTypes.object,
	            clientAccess: _react.PropTypes.array,
	            openedPackage: _react.PropTypes.string,
	            lang: _react.PropTypes.string,
	            forceOpenWizard: _react.PropTypes.bool,
	            forceOpenInvitationEditor: _react.PropTypes.bool,
	            zoomOut: _react.PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function DetailedPackage(props) {
	        var _this = this;
	
	        _classCallCheck(this, _DetailedPackage);
	
	        _get(Object.getPrototypeOf(_DetailedPackage.prototype), 'constructor', this).call(this, props);
	
	        this.getIcon = function (iconName) {
	            try {
	                return __webpack_require__(173)("./" + iconName);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        };
	
	        this.onResendClientRemainder = function callee$2$0(packageId) {
	            var stakeholderId = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	            var dispatch, resendReminderRes, reminderSentSuccessFlag;
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$3$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.resendClientRemainder)(packageId, stakeholderId)));
	
	                    case 3:
	                        resendReminderRes = context$3$0.sent;
	                        reminderSentSuccessFlag = false;
	
	                        if (resendReminderRes && resendReminderRes.success) {
	                            reminderSentSuccessFlag = true;
	                        }
	                        this.setState({ reminderConfirmationModal: true, reminderSentSuccessFlag: reminderSentSuccessFlag });
	
	                        if (!resendReminderRes) {
	                            context$3$0.next = 10;
	                            break;
	                        }
	
	                        context$3$0.next = 10;
	                        return regeneratorRuntime.awrap(this.fetchDsPackageToDisplay(packageId));
	
	                    case 10:
	                    case 'end':
	                        return context$3$0.stop();
	                }
	            }, null, _this);
	        };
	
	        this.onAfterUpdateClientEmail = function callee$2$0() {
	            var dsPackage;
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        dsPackage = this.state.dsPackage;
	
	                        if (!dsPackage) {
	                            context$3$0.next = 5;
	                            break;
	                        }
	
	                        context$3$0.next = 4;
	                        return regeneratorRuntime.awrap(this.fetchDsPackageToDisplay(dsPackage._id));
	
	                    case 4:
	                        this.setState({ editClientEmail: false, editClientPhoneNumber: false, stakeholderToEdit: null });
	
	                    case 5:
	                        // release the email changer modal
	                        this.setState({ editClientEmail: false, stakeholderToEdit: null, editClientPhoneNumber: false });
	
	                    case 6:
	                    case 'end':
	                        return context$3$0.stop();
	                }
	            }, null, _this);
	        };
	
	        this.renderStatusHistory = function (statusHistory) {
	            return _react2['default'].createElement(
	                'div',
	                { className: _detailedDocumentScss2['default'].statusHistoryContainer },
	                _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        ref: function (el) {
	                            _this.tableStatusHist = el;
	                        },
	                        id: 'table',
	                        className: _detailedDocumentScss2['default'].statusHistoryTable,
	                        itemsPerPage: 50,
	                        pageButtonLimit: 5
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'setOn' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("setOn")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'status' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("status")
	                            )
	                        )
	                    ),
	                    statusHistory.map(function (item, key) {
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            { i: key, key: key },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'setOn' },
	                                item.setOn && (0, _moment2['default'])(item.setOn).format('DD/MM/YYYY HH:mm:ss') || "-"
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'status' },
	                                _react2['default'].createElement(
	                                    'a',
	                                    {
	                                        className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].status, _detailedDocumentScss2['default'].goToLink),
	                                        onClick: function (ev) {
	                                            ev.stopPropagation();
	                                            if (item.status) {
	                                                _this.onItemStatusClick(item.status);
	                                            }
	                                        } },
	                                    item.status ? _((0, _documentsHelpers.getStatusTranslationKey)(item.status)) : '-'
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2['default'].createElement('br', null)
	            );
	        };
	
	        this.renderDocumentsList = function (dsDocuments, statusToShow) {
	            var _props = _this.props;
	            var lang = _props.lang;
	            var DSDocumentOriginTypes = _props.DSDocumentOriginTypes;
	            var dsPackage = _this.state.dsPackage;
	
	            var totalNumberOfSigners = dsPackage.stakeholders.length;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _detailedDocumentScss2['default'].documentsListContainer },
	                _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        ref: function (el) {
	                            _this.tableStatusHist = el;
	                        },
	                        id: 'table',
	                        className: _detailedDocumentScss2['default'].documentsListTable,
	                        itemsPerPage: 50,
	                        pageButtonLimit: 5
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'documentName' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("documentName")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'documentLanguage' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("documentLanguage")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'status' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("status")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'documentLocation' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("documentLocation")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'printSection' },
	                            _react2['default'].createElement('div', null)
	                        )
	                    ),
	                    dsDocuments.map(function (oneDoc, key) {
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            { i: key, key: key },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'documentName' },
	                                oneDoc.fileName || "-"
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'documentLanguage' },
	                                _(oneDoc.language)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'status' },
	                                statusToShow ? _((0, _documentsHelpers.getStatusTranslationKey)(statusToShow)) : ''
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'documentLocation' },
	                                _react2['default'].createElement(
	                                    'a',
	                                    { className: _detailedDocumentScss2['default'].goToLinkTable,
	                                        onClick: function (e) {
	                                            e.stopPropagation();
	                                            _this.navigateTo(oneDoc, false);
	                                        }
	                                    },
	                                    oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS && oneDoc.claimNumber,
	                                    oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT && oneDoc.contractNumber,
	                                    oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM && oneDoc.contractNumber,
	                                    oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_PROFILE && dsPackage.clientNumber,
	                                    oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION && oneDoc.tarificationNumber
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'printSection' },
	                                !oneDoc.origin || oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED ? _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        type: 'button',
	                                        className: (0, _classnames2['default'])(_documentsScss2['default'].short1),
	                                        onClick: function (e) {
	
	                                            return _this.printPDFManually(oneDoc, dsPackage._id);
	                                        }
	                                    },
	                                    _react2['default'].createElement('img', {
	                                        className: (0, _classnames2['default'])(_documentsScss2['default'].checkIcon),
	                                        src: _this.getIcon('print-black-18dp.svg')
	                                    }),
	                                    oneDoc.isPrinted && _react2['default'].createElement('img', {
	                                        className: (0, _classnames2['default'])(_documentsScss2['default'].checkIcon),
	                                        src: _this.getIcon('ic_done_green_32px.svg')
	                                    })
	                                ) : _react2['default'].createElement('div', { className: _documentsScss2['default'].emptyPrintSpace })
	                            )
	                        );
	                    })
	                ),
	                _react2['default'].createElement('br', null)
	            );
	        };
	
	        this.onClickRecreatePackage = function callee$2$0(dsPackage) {
	            var _props2, dispatch, zoomOut, onErrorPopup, onSuccesPopup, onConfirmResetCallback, initAreYouSureData;
	
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                var _this3 = this;
	
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        zoomOut = _props2.zoomOut;
	
	                        onErrorPopup = function onErrorPopup(error) {
	                            return regeneratorRuntime.async(function onErrorPopup$(context$4$0) {
	                                var _this2 = this;
	
	                                while (1) switch (context$4$0.prev = context$4$0.next) {
	                                    case 0:
	                                        return context$4$0.abrupt('return', this.setState({
	                                            isOpenAreYouSure: {
	                                                title: _('areYouSureModalTitle'),
	                                                message: _('recreatePackageError') + " " + _(error.name) + " code:" + _(error.callIDForDebug),
	                                                noCancelButton: true,
	                                                callBackCancel: function callBackCancel() {
	                                                    _this2.setState({ isOpenAreYouSure: false });
	                                                },
	                                                callBackOk: function callBackOk() {
	                                                    return regeneratorRuntime.async(function callBackOk$(context$5$0) {
	                                                        while (1) switch (context$5$0.prev = context$5$0.next) {
	                                                            case 0:
	                                                                this.setState({ isOpenAreYouSure: false });
	
	                                                            case 1:
	                                                            case 'end':
	                                                                return context$5$0.stop();
	                                                        }
	                                                    }, null, _this2);
	                                                }
	                                            }
	                                        }));
	
	                                    case 1:
	                                    case 'end':
	                                        return context$4$0.stop();
	                                }
	                            }, null, _this3);
	                        };
	
	                        onSuccesPopup = function onSuccesPopup(dsPackage) {
	                            return regeneratorRuntime.async(function onSuccesPopup$(context$4$0) {
	                                var _this4 = this;
	
	                                while (1) switch (context$4$0.prev = context$4$0.next) {
	                                    case 0:
	                                        return context$4$0.abrupt('return', this.setState({
	                                            isOpenAreYouSure: {
	                                                title: _('areYouSureModalTitle'),
	                                                message: _('recreatePackageSuccess'),
	                                                noCancelButton: false,
	                                                callBackCancel: function callBackCancel() {
	                                                    _this4.setState({ isOpenAreYouSure: false, dsPackage: dsPackage });
	                                                },
	                                                callBackOk: function callBackOk() {
	                                                    return regeneratorRuntime.async(function callBackOk$(context$5$0) {
	                                                        while (1) switch (context$5$0.prev = context$5$0.next) {
	                                                            case 0:
	                                                                this.setState({ isOpenAreYouSure: false, dsPackage: dsPackage, autoOpenMifid: true });
	                                                                //await dispatch(zoomOut())
	
	                                                            case 1:
	                                                            case 'end':
	                                                                return context$5$0.stop();
	                                                        }
	                                                    }, null, _this4);
	                                                }
	                                            }
	                                        }));
	
	                                    case 1:
	                                    case 'end':
	                                        return context$4$0.stop();
	                                }
	                            }, null, _this3);
	                        };
	
	                        onConfirmResetCallback = function onConfirmResetCallback() {
	                            var resultrecreateDsPackage;
	                            return regeneratorRuntime.async(function onConfirmResetCallback$(context$4$0) {
	                                while (1) switch (context$4$0.prev = context$4$0.next) {
	                                    case 0:
	                                        resultrecreateDsPackage = undefined;
	                                        context$4$0.prev = 1;
	                                        context$4$0.next = 4;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.recreateDsPackage)(dsPackage.id)));
	
	                                    case 4:
	                                        resultrecreateDsPackage = context$4$0.sent;
	                                        context$4$0.next = 11;
	                                        break;
	
	                                    case 7:
	                                        context$4$0.prev = 7;
	                                        context$4$0.t0 = context$4$0['catch'](1);
	
	                                        console.error(context$4$0.t0);
	                                        return context$4$0.abrupt('return', onErrorPopup(context$4$0.t0));
	
	                                    case 11:
	                                        context$4$0.next = 13;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(dsPackage.id)));
	
	                                    case 13:
	                                        dsPackage = context$4$0.sent;
	                                        return context$4$0.abrupt('return', onSuccesPopup(dsPackage));
	
	                                    case 15:
	                                    case 'end':
	                                        return context$4$0.stop();
	                                }
	                            }, null, _this3, [[1, 7]]);
	                        };
	
	                        initAreYouSureData = {
	                            title: _('areYouSureModalTitle'),
	                            message: _('areYouSureToRecreteThePackage'),
	                            callBackCancel: function callBackCancel() {
	                                _this3.setState({ isOpenAreYouSure: false });
	                            },
	                            callBackOk: onConfirmResetCallback
	                        };
	                        return context$3$0.abrupt('return', this.setState({ isOpenAreYouSure: initAreYouSureData }));
	
	                    case 8:
	                    case 'end':
	                        return context$3$0.stop();
	                }
	            }, null, _this);
	        };
	
	        this.state = {
	            statusExplainerIsOpen: false,
	            editClientEmail: false,
	            canCreateMifid: false,
	            dsPackage: {},
	            isOpenLinkDocumentModal: false,
	            stakeholders: null,
	            stakeholderToEdit: null,
	            isLoaded: true,
	            moduleOptions: {},
	            ticketData: {},
	            isOpenAreYouSure: false,
	            autoOpenMifid: false,
	            reminderConfirmationModal: false,
	            reminderSentSuccessFlag: false,
	            invitationBlocked: false
	        };
	    }
	
	    /**
	     * get the package object to display and set security flag
	     */
	
	    _createClass(DetailedPackage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this5 = this;
	
	            var _props3 = this.props;
	            var clientAccess = _props3.clientAccess;
	            var openedPackage = _props3.openedPackage;
	            var dispatch = _props3.dispatch;
	
	            this.fetchDsPackageToDisplay(openedPackage).then(function (dsPackage) {
	                var moduleKeyToSet = (0, _DSWizardHelper.getEmailerModuleKeyByWizardModuleKey)(_nestedProperty2['default'].get(dsPackage, "uploadedOnModule"));
	                dispatch((0, _stateActions.setEmailSenderModule)(moduleKeyToSet, c.EMAILER_MODAL_HIDDEN_IN_PACKAGE_DETAILS));
	            });
	
	            // find and set security flag
	            clientAccess.map(function (item, key) {
	                if (item.actionName == 'createmifid') {
	                    _this5.setState({ canCreateMifid: item.actionAllowed === "true" ? true : false });
	                }
	            });
	        }
	
	        /**
	         * Check if the opened package has changed  and update if it did
	         * @param {*} nextProps
	         */
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var openedPackage = this.props.openedPackage;
	
	            if (nextProps.openedPackage !== openedPackage) {
	                this.fetchDsPackageToDisplay(nextProps.openedPackage);
	            }
	        }
	
	        /**
	         * This functionality will call the API used to get the data related to opened package
	         * @param {*} openedPackageId
	         */
	    }, {
	        key: 'fetchDsPackageToDisplay',
	        value: function fetchDsPackageToDisplay(openedPackageId) {
	            var dispatch, dsPackage, moduleOptions, ticketData;
	            return regeneratorRuntime.async(function fetchDsPackageToDisplay$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        dsPackage = undefined;
	                        context$2$0.prev = 2;
	                        context$2$0.next = 5;
	                        return regeneratorRuntime.awrap(this.setState({ isLoaded: false }));
	
	                    case 5:
	                        context$2$0.next = 7;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(openedPackageId)));
	
	                    case 7:
	                        dsPackage = context$2$0.sent;
	
	                        if (!dsPackage) {
	                            context$2$0.next = 20;
	                            break;
	                        }
	
	                        moduleOptions = {};
	                        ticketData = {};
	
	                        if (dsPackage.hasFinishStatus) {
	                            context$2$0.next = 19;
	                            break;
	                        }
	
	                        context$2$0.next = 14;
	                        return regeneratorRuntime.awrap(this.collectModuleOptionsValues(dsPackage));
	
	                    case 14:
	                        moduleOptions = context$2$0.sent;
	
	                        if (!dsPackage.ticketId) {
	                            context$2$0.next = 19;
	                            break;
	                        }
	
	                        context$2$0.next = 18;
	                        return regeneratorRuntime.awrap(this.collectTicketData(dsPackage.ticketId));
	
	                    case 18:
	                        ticketData = context$2$0.sent;
	
	                    case 19:
	
	                        this.setState({ dsPackage: dsPackage, isLoaded: true, moduleOptions: moduleOptions, ticketData: ticketData });
	
	                    case 20:
	                        context$2$0.next = 25;
	                        break;
	
	                    case 22:
	                        context$2$0.prev = 22;
	                        context$2$0.t0 = context$2$0['catch'](2);
	
	                        console.warn(context$2$0.t0);
	
	                    case 25:
	                        return context$2$0.abrupt('return', dsPackage);
	
	                    case 26:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[2, 22]]);
	        }
	
	        /**
	         * This function extract the signing date from status history.
	         * @param {*} dsPackage
	         */
	    }, {
	        key: 'getSigningDate',
	        value: function getSigningDate(dsPackage) {
	            var statusHistory = _nestedProperty2['default'].get(dsPackage, "statusHistory");
	
	            if (!statusHistory || statusHistory.length === 0) {
	                return false;
	            }
	
	            var signDate = false;
	            statusHistory.forEach(function (oneStatus) {
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
	                    signDate = oneStatus.setOn;
	                }
	            });
	
	            return signDate && (0, _moment2['default'])(signDate).format('DD/MM/YYYY HH:mm:ss');
	        }
	
	        /**
	        * This function handle the status modal opening
	        * @param {string} status
	        */
	    }, {
	        key: 'onItemStatusClick',
	        value: function onItemStatusClick(status) {
	            this.setState({ statusExplainerIsOpen: status });
	        }
	
	        /**
	         * This function provide false if the package has no status of transferred to oracle.
	         * @param {*} status
	         * @param {*} statusHistory
	         */
	    }, {
	        key: 'documentsAreUploaded',
	        value: function documentsAreUploaded(status, statusHistory) {
	            var isUploaded = status === c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE;
	
	            if (!statusHistory) {
	                return isUploaded;
	            }
	
	            statusHistory.forEach(function (oneStatus) {
	                if (oneStatus.status === c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE) {
	                    isUploaded = true;
	                }
	            });
	
	            return isUploaded;
	        }
	
	        /**
	         * Refresh package data after the DSWizard close
	         */
	    }, {
	        key: 'onCloseDSWizard',
	        value: function onCloseDSWizard() {
	            var _props4 = this.props;
	            var openedPackage = _props4.openedPackage;
	            var zoomOut = _props4.zoomOut;
	            var forceOpenWizard = _props4.forceOpenWizard;
	
	            if (forceOpenWizard) {
	                zoomOut();
	            } else {
	                this.fetchDsPackageToDisplay(openedPackage);
	            }
	
	            this.setState({ autoOpenMifid: false });
	        }
	
	        /**
	         * Open the model for linking or uploading document
	         * @param {*} dsDocument
	         */
	    }, {
	        key: 'openLinkAndUploadWizard',
	        value: function openLinkAndUploadWizard(dsDocument) {
	            this.setState({ isOpenLinkDocumentModal: dsDocument });
	        }
	
	        /**
	        * This function helps to use an icon on a safe way
	        */
	    }, {
	        key: 'onDirectSignButtonClick',
	
	        /**
	        * This method will update package from connective reactivating the main sining link and opens the signing page from connective
	        * @param {*} packageId
	        */
	        value: function onDirectSignButtonClick(packageId) {
	            var dispatch, responseFromConnective, dsPackage, URLForSign;
	            return regeneratorRuntime.async(function onDirectSignButtonClick$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$2$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updatePackagesFromConnective)([packageId])));
	
	                    case 3:
	                        responseFromConnective = context$2$0.sent;
	
	                        if (!responseFromConnective.success) {
	                            context$2$0.next = 11;
	                            break;
	                        }
	
	                        context$2$0.next = 7;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(packageId)));
	
	                    case 7:
	                        dsPackage = context$2$0.sent;
	                        URLForSign = _nestedProperty2['default'].get(dsPackage, "F2FSigningUrl");
	
	                        this.setState({ dsPackage: dsPackage });
	                        window.open(URLForSign, '_blank', 'noopener,noreferrer');
	
	                    case 11:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * This function will handle the signers area legacy prior to version 7 when packages have no stakeholders
	         * @param {*} isEditableThePackage
	         * @param {*} shouldSendRemainder
	         * @returns
	         */
	    }, {
	        key: 'renderSignerArea',
	        value: function renderSignerArea(isEditableThePackage, shouldSendRemainder) {
	            var _this6 = this;
	
	            var dsPackage = this.state.dsPackage;
	
	            var isSignedThePackage = _nestedProperty2['default'].get(dsPackage, "hasFinishStatus");
	            var canSendNextReminder = +_nestedProperty2['default'].get(dsPackage, "remainderRepeats") > 0 ? true : false;
	
	            var blocked = false;
	            var statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed', 'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError', 'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError'];
	
	            if (dsPackage && dsPackage.statusHistory) {
	                dsPackage.statusHistory.forEach(function (oneStatus) {
	                    if (statusBlackList.includes(oneStatus.status)) {
	                        blocked = true;
	                    }
	                });
	            }
	
	            var packageStatusError = dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked;
	
	            // case fo failed package does not send remainder
	            if (packageStatusError) {
	                canSendNextReminder = false;
	            }
	
	            var clientEmailAddress = _nestedProperty2['default'].get(dsPackage, "clientEmailAddress");
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                    _('signersArea')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].columnWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].signersLabelsColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel, _detailedDocumentScss2['default'].columnTitle) },
	                                    ' '
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerName')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerEmail')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerLanguage')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('lastRemainderSentOn')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('nextRemainderSendOn')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('lastRemainderSentOn')
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].firstSignerColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer, _detailedDocumentScss2['default'].columnTitle) },
	                                    _('firstSignerColumnTitle')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _nestedProperty2['default'].get(dsPackage, "clientName")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + clientEmailAddress },
	                                            clientEmailAddress
	                                        ),
	                                        !isSignedThePackage && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this6.setState({ editClientEmail: true });
	                                            } })
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _nestedProperty2['default'].get(dsPackage, "clientLanguage")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(dsPackage, "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ),
	                            !packageStatusError && canSendNextReminder ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(dsPackage, "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    '-'
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(dsPackage, "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(dsPackage, "remainderSentCount")) + " / " + _nestedProperty2['default'].get(dsPackage, "remainderRepeats")
	                                )
	                            ),
	                            !packageStatusError && !isEditableThePackage && shouldSendRemainder && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].mifidButtonContainer) },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "resentButton",
	                                            className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].grayButtonFlex, _DSWizardHelperScss2['default'].mifidButton),
	                                            onClick: function (e) {
	                                                return _this6.onResendClientRemainder(_nestedProperty2['default'].get(dsPackage, "_id"), null);
	                                            }
	                                        },
	                                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].icon, _detailedDocumentScss2['default'].iconPaddingRight), src: this.getIcon('icn-inbox-white.svg') }),
	                                        _('resendRemainderEmail')
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	
	        /**
	         *
	         * @param {*} selectedTicketRelatedOraDocuments
	         * @returns
	         */
	    }, {
	        key: 'onInitEmailer',
	        value: function onInitEmailer(selectedTicketRelatedOraDocuments) {
	            var dispatch = this.props.dispatch;
	
	            if (selectedTicketRelatedOraDocuments && selectedTicketRelatedOraDocuments.length) {
	                var files = selectedTicketRelatedOraDocuments.map(function (oneDoc) {
	                    return {
	                        name: oneDoc.oracleDocumentType,
	                        date: "-",
	                        id: oneDoc.oracleDocumentId,
	                        typeDocument: oneDoc.oracleDocumentType
	                    };
	                });
	                dispatch((0, _stateActions.setEmailSenderExternalAttachments)(files));
	            }
	
	            return;
	        }
	
	        /**
	         * Update package ans stakeholder about the invitation.
	         * @param {*} responses
	         * @param {*} dsPackage
	         * @param {*} stakeholder
	         * @returns
	         */
	    }, {
	        key: 'onSentEmailer',
	        value: function onSentEmailer(responses, dsPackage, stakeholders) {
	            var dispatch, i, emailId, toEmailAddress, _loop, j;
	
	            return regeneratorRuntime.async(function onSentEmailer$(context$2$0) {
	                var _this7 = this;
	
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$2$0.prev = 1;
	
	                        if (!(!responses || responses.length === 0)) {
	                            context$2$0.next = 4;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return');
	
	                    case 4:
	                        i = 0;
	
	                    case 5:
	                        if (!(i < responses.length)) {
	                            context$2$0.next = 24;
	                            break;
	                        }
	
	                        emailId = _nestedProperty2['default'].get(responses, i + ".emailRecord._id");
	                        toEmailAddress = _nestedProperty2['default'].get(responses, i + ".emailRecord.toEmailAddress");
	
	                        if (emailId) {
	                            context$2$0.next = 10;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('continue', 21);
	
	                    case 10:
	                        _loop = function callee$2$0(j) {
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        if (!(toEmailAddress && toEmailAddress.length > 0 && toEmailAddress.some(function (email) {
	                                            return String(email).toLowerCase() === String(stakeholders[j].email).toLowerCase();
	                                        }))) {
	                                            context$3$0.next = 5;
	                                            break;
	                                        }
	
	                                        context$3$0.next = 3;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions2.upsertDSPackageEmailStatus)(dsPackage._id, emailId, { isInvitation: true, stakeholderId: stakeholders[j]._id } /* --> ?? mailOptions*/
	                                        )));
	
	                                    case 3:
	                                        context$3$0.next = 5;
	                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions2.updateDSStakeholder)({ stakeholderId: stakeholders[j]._id, isInvited: true })));
	
	                                    case 5:
	                                    case 'end':
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this7);
	                        };
	
	                        j = 0;
	
	                    case 12:
	                        if (!(j < stakeholders.length)) {
	                            context$2$0.next = 18;
	                            break;
	                        }
	
	                        context$2$0.next = 15;
	                        return regeneratorRuntime.awrap(_loop(j));
	
	                    case 15:
	                        j++;
	                        context$2$0.next = 12;
	                        break;
	
	                    case 18:
	                        context$2$0.next = 20;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(dsPackage._id)));
	
	                    case 20:
	                        dsPackage = context$2$0.sent;
	
	                    case 21:
	                        i++;
	                        context$2$0.next = 5;
	                        break;
	
	                    case 24:
	                        context$2$0.next = 30;
	                        break;
	
	                    case 26:
	                        context$2$0.prev = 26;
	                        context$2$0.t0 = context$2$0['catch'](1);
	
	                        console.error(context$2$0.t0);
	                        throw context$2$0.t0;
	
	                    case 30:
	                        return context$2$0.abrupt('return', dsPackage);
	
	                    case 31:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[1, 26]]);
	        }
	
	        /**
	         * This function will render the stakeholders data
	         * @param {*} isEditableThePackage
	         * @param {*} shouldSendRemainder
	         * @returns stakeholders jsx
	         */
	    }, {
	        key: 'renderStakeholdersArea',
	        value: function renderStakeholdersArea(isEditableThePackage, shouldSendRemainder) {
	            var _this8 = this;
	
	            var _state = this.state;
	            var dsPackage = _state.dsPackage;
	            var ticketData = _state.ticketData;
	            var moduleOptions = _state.moduleOptions;
	            var _props5 = this.props;
	            var createmail = _props5.createmail;
	            var dispatch = _props5.dispatch;
	            var DSDocumentOriginTypes = _props5.DSDocumentOriginTypes;
	
	            var stakeholders = _nestedProperty2['default'].get(dsPackage, "dsStakeholders");
	            var canSendNextReminder = +_nestedProperty2['default'].get(dsPackage, "remainderRepeats") > 0 ? true : false;
	
	            var blocked = false;
	            var statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed', 'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError', 'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError'];
	            if (dsPackage && dsPackage.statusHistory) {
	                dsPackage.statusHistory.forEach(function (oneStatus) {
	                    if (statusBlackList.includes(oneStatus.status)) {
	                        blocked = true;
	                    }
	                });
	            }
	
	            var packageStatusError = dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked;
	            // case fo failed package does not send remainder
	            if (packageStatusError) {
	                canSendNextReminder = false;
	            }
	
	            var hasSmsOtpSigning = dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.find(function (oneDocument) {
	                //check if there is at least one document generated that require signing type sms otp signing
	                if (!oneDocument.documentTemplate && (oneDocument.origin === DSDocumentOriginTypes.DS_ORIGIN_ORACLE || oneDocument.origin === DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD)) {
	                    return true;
	                }
	
	                return oneDocument.documentTemplate && oneDocument.documentTemplate.digitalSignatureType === "SmsOtp";
	            }) ? true : false;
	
	            // TODO
	            // MIRCEA must resolve to get this data from ticket
	            var selectedTicketRelatedOraDocuments = ticketData.emailAttachmentTicketDocuments || [];
	
	            // prepare module options for emailer of the client
	            var emailerModuleOptions1 = _extends({}, moduleOptions, {
	                dsPackage: dsPackage,
	                brokerNumber: _nestedProperty2['default'].get(dsPackage, "brokerNumber"),
	                brokerEmailAddress: _nestedProperty2['default'].get(dsPackage, "brokerEmailAddress"),
	                stakeholders: [dsPackage.dsStakeholders[0]],
	                autoSelectTemplate: true,
	                usePlaceholdersForClientVariables: true,
	                // overwrite client email addresses, for signer emailaddress-es
	                clientEmails: [{
	                    referenceId: dsPackage.dsStakeholders[0]._id,
	                    value: dsPackage.dsStakeholders[0].email,
	                    lang: dsPackage.dsStakeholders[0].language,
	                    isPermanentSelected: true,
	                    isCC: false,
	                    label: dsPackage.dsStakeholders[0].firstName + " " + dsPackage.dsStakeholders[0].lastName
	                }]
	            });
	
	            var stakeholderOtherPerson = dsPackage.dsStakeholders && dsPackage.dsStakeholders.filter(function (item) {
	                return item.signerType === "OTHER_PERSON";
	            });
	            stakeholderOtherPerson = stakeholderOtherPerson && stakeholderOtherPerson.length > 0 && stakeholderOtherPerson[0];
	
	            var emailerModuleOptions2 = stakeholderOtherPerson && _extends({}, moduleOptions, {
	                dsPackage: dsPackage,
	                brokerNumber: _nestedProperty2['default'].get(dsPackage, "brokerNumber"),
	                brokerEmailAddress: _nestedProperty2['default'].get(dsPackage, "brokerEmailAddress"),
	                autoSelectTemplate: true,
	                usePlaceholdersForClientVariables: true,
	                stakeholders: [stakeholderOtherPerson],
	                clientEmails: [{
	                    referenceId: stakeholderOtherPerson._id,
	                    value: stakeholderOtherPerson.email,
	                    lang: stakeholderOtherPerson.language,
	                    isPermanentSelected: true,
	                    isCC: false,
	                    label: stakeholderOtherPerson.firstName + " " + stakeholderOtherPerson.lastName
	                }]
	            });
	
	            var stakeholderBroker = dsPackage.dsStakeholders && dsPackage.dsStakeholders.filter(function (item) {
	                return item.signerType === "BROKER";
	            });
	            stakeholderBroker = stakeholderBroker && stakeholderBroker.length > 0 && stakeholderBroker[0];
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                    _('signersArea')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].columnWrapperForSigners },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement('p', { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel, _detailedDocumentScss2['default'].columnTitle) })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer, _detailedDocumentScss2['default'].columnTitle) },
	                                    _('firstSignerColumnTitle')
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer, _detailedDocumentScss2['default'].columnTitle) },
	                                    _('secondSignerColumnTitle')
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerName')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    stakeholders[0].lastName + ' ' + stakeholders[0].firstName
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    stakeholderOtherPerson.lastName + ' ' + stakeholderOtherPerson.firstName
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerEmail')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + stakeholders[0].email },
	                                            stakeholders[0].email
	                                        ),
	                                        !stakeholders[0].finished && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this8.setState({ editClientEmail: true, stakeholderToEdit: stakeholders[0] });
	                                            }
	                                        })
	                                    )
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + stakeholderOtherPerson.email },
	                                            stakeholderOtherPerson.email
	                                        ),
	                                        !stakeholderOtherPerson.finished && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this8.setState({ editClientEmail: true, stakeholderToEdit: stakeholderOtherPerson });
	                                            } })
	                                    )
	                                )
	                            )
	                        ),
	                        hasSmsOtpSigning && _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerPhoneNumber')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + stakeholders[0].phoneNumber },
	                                            stakeholders[0].phoneNumber
	                                        ),
	                                        !stakeholders[0].finished && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this8.setState({ editClientPhoneNumber: true, stakeholderToEdit: stakeholders[0] });
	                                            }
	                                        })
	                                    )
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _detailedDocumentScss2['default'].email },
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'mailto:' + stakeholderOtherPerson.phoneNumber },
	                                            stakeholderOtherPerson.phoneNumber
	                                        ),
	                                        !stakeholders[0].finished && _react2['default'].createElement('img', { className: _detailedDocumentScss2['default'].icon, src: this.getIcon('create-24px.svg'),
	                                            onClick: function (e) {
	                                                e.preventDefault();
	                                                _this8.setState({ editClientPhoneNumber: true, stakeholderToEdit: stakeholderOtherPerson });
	                                            } })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signerLanguage')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    stakeholders[0].language
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    stakeholderOtherPerson.language
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('lastRemainderSentOn')
	                                )
	                            ),
	                            isEditableThePackage ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _('reminderSentOnNotReady')
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	
	                                    /*
	                                        Until the stakeholder not invited, don't show the date of first invitation.
	                                        The property have value always because the calculation of remainder.
	                                    */
	                                    _nestedProperty2['default'].get(stakeholders[0], "isInvited") ? (0, _moment2['default'])(_nestedProperty2['default'].get(stakeholders[0], "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss") : "-"
	                                )
	                            ),
	                            stakeholderOtherPerson && isEditableThePackage ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _('reminderSentOnNotReady')
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    /*
	                                       Until the stakeholder not invited, don't show the date of first invitation.
	                                       The property have value always because the calculation of remainder.
	                                    */
	                                    _nestedProperty2['default'].get(stakeholderOtherPerson, "isInvited") ? (0, _moment2['default'])(_nestedProperty2['default'].get(stakeholderOtherPerson, "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss") : "-"
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('nextRemainderSendOn')
	                                )
	                            ),
	                            !isEditableThePackage && !packageStatusError ? canSendNextReminder && !packageStatusError ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(stakeholders[0], "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    '-'
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _('nextReminderNotReady')
	                                )
	                            ),
	                            stakeholderOtherPerson && !packageStatusError && (!isEditableThePackage ? canSendNextReminder && !packageStatusError ? _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (0, _moment2['default'])(_nestedProperty2['default'].get(stakeholderOtherPerson, "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    '-'
	                                )
	                            ) : _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    _('nextReminderNotReady')
	                                )
	                            ))
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('remainderCount')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(stakeholders[0], "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(stakeholders[0], "remainderSentCount")) + " / " + _nestedProperty2['default'].get(dsPackage, "remainderRepeats")
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(stakeholderOtherPerson, "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(stakeholderOtherPerson, "remainderSentCount")) + " / " + _nestedProperty2['default'].get(dsPackage, "remainderRepeats")
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('manuallRemainderCount')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(stakeholders[0], "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(stakeholders[0], "remainderSentCountManually") || 0) + " / " + _("infinite")
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].signer },
	                                    (_nestedProperty2['default'].get(stakeholderOtherPerson, "remainderRepeats") + "" === "-1" ? _("infinite") : _nestedProperty2['default'].get(stakeholderOtherPerson, "remainderSentCountManually") || 0) + " / " + _("infinite")
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('signingStatusLabel')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                stakeholders[0].finished && _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('signerHasSignedStatus')
	                                ) || _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('signerHasNotSignedStatus')
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                stakeholderOtherPerson.finished && _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('signerHasSignedStatus')
	                                ) || _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('signerHasNotSignedStatus')
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('brokerSignerAffection')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                !stakeholderBroker && _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('brokerSignerDoesNOtNeedToSign')
	                                ),
	                                stakeholderBroker && !stakeholderBroker.finished && _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('brokerSignerNotFinishedStatus')
	                                ),
	                                stakeholderBroker && stakeholderBroker.finished && _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    _('brokerSignerFinishedStatus')
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signer) },
	                                    ' '
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    ' '
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                !packageStatusError && (0, _documentsHelpers.stakeholderMustAct)(stakeholders[0]) && !isEditableThePackage && shouldSendRemainder && stakeholders[0].isInvited && _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].mifidButtonContainer, _detailedDocumentScss2['default'].remainderButtonCorrection) },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "resentButton",
	                                            className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].grayButtonFlex, _DSWizardHelperScss2['default'].mifidButton),
	                                            onClick: function (e) {
	                                                return _this8.onResendClientRemainder(_nestedProperty2['default'].get(dsPackage, "_id"), stakeholders[0]._id);
	                                            }
	                                        },
	                                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].icon, _detailedDocumentScss2['default'].iconPaddingRight), src: this.getIcon('icn-inbox-white.svg') }),
	                                        _('resendRemainderEmail')
	                                    )
	                                )
	                            ),
	                            stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                !packageStatusError && (0, _documentsHelpers.stakeholderMustAct)(stakeholderOtherPerson) && !isEditableThePackage && shouldSendRemainder && stakeholderOtherPerson.isInvited && stakeholderOtherPerson.signerType !== "BROKER" && _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].mifidButtonContainer, _detailedDocumentScss2['default'].remainderButtonCorrection) },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "resentButton",
	                                            className: (0, _classnames2['default'])(_DSWizardHelperScss2['default'].grayButtonFlex, _DSWizardHelperScss2['default'].mifidButton),
	                                            onClick: function (e) {
	                                                return _this8.onResendClientRemainder(_nestedProperty2['default'].get(dsPackage, "_id"), stakeholderOtherPerson._id);
	                                            }
	                                        },
	                                        _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].icon, _detailedDocumentScss2['default'].iconPaddingRight), src: this.getIcon('icn-inbox-white.svg') }),
	                                        _('resendRemainderEmail')
	                                    )
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].labelColumn) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    ' '
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].firstValueColumn) },
	                                !packageStatusError && !isEditableThePackage && stakeholders[0] && (0, _documentsHelpers.stakeholderMustAct)(stakeholders[0]) && !stakeholders[0].isInvited && createmail && _react2['default'].createElement(_emailSenderEmailButton2['default'], {
	                                    onInit: function () {
	                                        _this8.onInitEmailer(selectedTicketRelatedOraDocuments);
	                                    },
	                                    onSentLate: function callee$2$0(responses) {
	                                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                case 0:
	                                                    context$3$0.next = 2;
	                                                    return regeneratorRuntime.awrap(this.onSentEmailer(responses, dsPackage, [stakeholders[0]]));
	
	                                                case 2:
	                                                    dsPackage = context$3$0.sent;
	
	                                                    this.setState({ dsPackage: dsPackage });
	
	                                                case 4:
	                                                case 'end':
	                                                    return context$3$0.stop();
	                                            }
	                                        }, null, _this8);
	                                    },
	                                    moduleKeyToSet: (0, _DSWizardHelper.getEmailerModuleKeyByWizardModuleKey)(_nestedProperty2['default'].get(dsPackage, "uploadedOnModule")),
	                                    moduleOptions: emailerModuleOptions1,
	                                    getDSStakeholders: function callee$2$0(stakeholderIdArray) {
	                                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                case 0:
	                                                    context$3$0.next = 2;
	                                                    return regeneratorRuntime.awrap(dispatch((0, _stateActions.getDSStakeholders)(stakeholderIdArray)));
	
	                                                case 2:
	                                                    return context$3$0.abrupt('return', context$3$0.sent);
	
	                                                case 3:
	                                                case 'end':
	                                                    return context$3$0.stop();
	                                            }
	                                        }, null, _this8);
	                                    },
	                                    customButtonLabel: _('customizeInvitationEmail'),
	                                    customClassName: _documentsScss2['default'].greenButton + " enabled",
	                                    key: "customizeInvitationRenderEmailSenderButtonFromDetailedPackageKey",
	                                    isWhiteIcon: true,
	                                    modalId: c.EMAILER_MODAL_ID_PACKAGE_DETAILS,
	                                    hideCC: dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? false : true,
	                                    multiLanguage: true,
	                                    serialSending: true,
	                                    isCreatable: dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? true : false,
	                                    forceIsMulti: false,
	                                    isInvitation: true,
	                                    packageStatusCheck: function callee$2$0() {
	                                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                case 0:
	                                                    context$3$0.next = 2;
	                                                    return regeneratorRuntime.awrap(this.onSendInvitationClick(dsPackage.id));
	
	                                                case 2:
	                                                    return context$3$0.abrupt('return', context$3$0.sent);
	
	                                                case 3:
	                                                case 'end':
	                                                    return context$3$0.stop();
	                                            }
	                                        }, null, _this8);
	                                    }
	                                })
	                            ),
	                            !packageStatusError && stakeholderOtherPerson && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].secondValueColumn) },
	                                !isEditableThePackage && stakeholderOtherPerson && (0, _documentsHelpers.stakeholderMustAct)(stakeholderOtherPerson) && !stakeholderOtherPerson.isInvited && createmail && stakeholderOtherPerson.signerType !== "BROKER" && _react2['default'].createElement(_emailSenderEmailButton2['default'], {
	                                    onInit: function () {
	                                        _this8.onInitEmailer(selectedTicketRelatedOraDocuments);
	                                    },
	                                    onSentLate: function callee$2$0(responses) {
	                                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                case 0:
	                                                    context$3$0.next = 2;
	                                                    return regeneratorRuntime.awrap(this.onSentEmailer(responses, dsPackage, [stakeholderOtherPerson]));
	
	                                                case 2:
	                                                    dsPackage = context$3$0.sent;
	
	                                                    this.setState({ dsPackage: dsPackage });
	
	                                                case 4:
	                                                case 'end':
	                                                    return context$3$0.stop();
	                                            }
	                                        }, null, _this8);
	                                    },
	                                    moduleKeyToSet: (0, _DSWizardHelper.getEmailerModuleKeyByWizardModuleKey)(_nestedProperty2['default'].get(dsPackage, "uploadedOnModule")),
	                                    moduleOptions: emailerModuleOptions2,
	                                    getDSStakeholders: function callee$2$0(stakeholderIdArray) {
	                                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                case 0:
	                                                    context$3$0.next = 2;
	                                                    return regeneratorRuntime.awrap(dispatch((0, _stateActions.getDSStakeholders)(stakeholderIdArray)));
	
	                                                case 2:
	                                                    return context$3$0.abrupt('return', context$3$0.sent);
	
	                                                case 3:
	                                                case 'end':
	                                                    return context$3$0.stop();
	                                            }
	                                        }, null, _this8);
	                                    },
	                                    customButtonLabel: _('customizeInvitationEmail'),
	                                    customClassName: _documentsScss2['default'].greenButton + " enabled",
	                                    key: "customizeInvitationRenderEmailSenderButtonFromDetailedPackageKey2",
	                                    isWhiteIcon: true,
	                                    modalId: c.EMAILER_MODAL_ID_PACKAGE_DETAILS_2,
	                                    hideCC: dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? false : true,
	                                    multiLanguage: true,
	                                    serialSending: true,
	                                    isCreatable: dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? true : false,
	                                    forceIsMulti: false,
	                                    isInvitation: true,
	                                    packageStatusCheck: function callee$2$0() {
	                                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                case 0:
	                                                    context$3$0.next = 2;
	                                                    return regeneratorRuntime.awrap(this.onSendInvitationClick(dsPackage.id));
	
	                                                case 2:
	                                                    return context$3$0.abrupt('return', context$3$0.sent);
	
	                                                case 3:
	                                                case 'end':
	                                                    return context$3$0.stop();
	                                            }
	                                        }, null, _this8);
	                                    }
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	
	        /**
	         * This function provide false if can't be sent a remainder.
	         * @param {*} dsPackage
	         */
	    }, {
	        key: 'shouldSendRemainder',
	        value: function shouldSendRemainder(dsPackage) {
	            var DSDocumentOriginTypes = this.props.DSDocumentOriginTypes;
	
	            var should = false;
	            // can be enabled the remainder when there are minimum one document what should be signed
	            if (dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.length > 0) {
	                dsPackage.dsDocuments.forEach(function (oneDoc) {
	                    if (oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned || oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_ORACLE || oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD) {
	
	                        should = true;
	                    }
	                });
	            }
	
	            // CHECK if the invitation was sent
	
	            // no status history, normally never happen this
	            if (!dsPackage || !dsPackage.statusHistory) {
	                return should;
	            }
	
	            // check if not closed the package
	            dsPackage.statusHistory.forEach(function (oneStatus) {
	                // the best case, when signed, no more remainder necessary
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
	                    should = false;
	                }
	
	                // any cases when the package life is over, no more remainder necessary
	                if (oneStatus.status === c.DS_PACKAGE_STATUS_REJECTED || oneStatus.status === c.DS_PACKAGE_STATUS_REVOKED || oneStatus.status === c.DS_PACKAGE_STATUS_EXPIRED || oneStatus.status === c.DS_PACKAGE_STATUS_FAILED || oneStatus.status === c.DS_PACKAGE_STATUS_DELETED) {
	                    should = false;
	                }
	            });
	
	            return should;
	        }
	
	        /**
	        * This is the call-back function of the email changer popup.
	        * It will get the updated dsPackage after editing stakeholders data
	        */
	    }, {
	        key: 'printPDFManually',
	
	        /**
	         * This will generate the PDF and forward to the ling toward it to print.
	         * @param {Object} oneDocument
	         */
	        value: function printPDFManually(oneDocument, packageId) {
	            var dispatch, linkForPdfDownload, w, onLoadWindowPromise;
	            return regeneratorRuntime.async(function printPDFManually$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        linkForPdfDownload = HALF_FILLED_PDF_API_URL + "/" + oneDocument._id;
	                        w = window.open(linkForPdfDownload, '_blank', 'noopener,noreferrer');
	                        onLoadWindowPromise = new Promise(function (resolve) {
	                            w.addEventListener('load', function () {
	                                resolve();
	                            }, true);
	                        });
	                        context$2$0.next = 6;
	                        return regeneratorRuntime.awrap(onLoadWindowPromise);
	
	                    case 6:
	                        context$2$0.next = 8;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.handlePackageAfterPrint)(packageId)));
	
	                    case 8:
	                        context$2$0.next = 10;
	                        return regeneratorRuntime.awrap(this.fetchDsPackageToDisplay(packageId));
	
	                    case 10:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	        * This function render the status history data-table
	        */
	    }, {
	        key: 'navigateTo',
	
	        /**
	         * This function will navigate to the target module by entity id (contracts, claims)
	         * @param {object} dsdocument - dsdocument record
	         */
	        value: function navigateTo(dsdocument) {
	            // navigateToModuleName, dynamicId, clientId, options)
	            var dispatch = this.props.dispatch;
	            var dsPackage = this.state.dsPackage;
	
	            var clientId = _nestedProperty2['default'].get(dsPackage, "clientId");
	            var contractId = _nestedProperty2['default'].get(dsdocument, "contractId");
	            var claimId = _nestedProperty2['default'].get(dsdocument, "claimId");
	            var tarificationId = _nestedProperty2['default'].get(dsdocument, "tarificationId");
	            var dynamicId = clientId;
	            var navigateToModuleName = '';
	
	            // navigate by uploaded on module value, not after contract or claim existence (BEWB-231)
	            if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS) {
	                dynamicId = claimId;
	                navigateToModuleName = 'claims';
	            }
	
	            if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT || dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM) {
	                dynamicId = contractId;
	                navigateToModuleName = 'contracts';
	            }
	
	            if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION) {
	                dynamicId = tarificationId;
	                navigateToModuleName = 'tarification';
	            }
	
	            // this next line of code (commented) can get clientId from oracle by contract or claim
	            // getClientId(contractId, claimId).then((clientId)=>{  })
	
	            dispatch((0, _stateActions.setAppModule)(c.CLIENTS, clientId));
	            dispatch((0, _stateActions.setOpenedSubmenu)(dynamicId, {})); // submenuOpened: claimId, subModuleZoom: {}
	            dispatch((0, _stateActions.setClientSubModule)(navigateToModuleName)); // subModule: 'claims' subModuleZoom: ''
	        }
	
	        /**
	         * Used to determine the status for each document
	         * @param {*} oneDoc
	         * @returns upload, signed status or package status
	         */
	    }, {
	        key: 'determineStatusForDocument',
	        value: function determineStatusForDocument(oneDoc) {
	            var dsPackage = this.state.dsPackage;
	
	            var statusToDisplay = '---';
	            if (oneDoc.uploadedToOracle) {
	                statusToDisplay = _('uploadedToOracle');
	            }
	
	            if (!oneDoc.uploadedToOracle && (oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned || oneDoc.origin === "DS_ORIGIN_ORACLE") && !dsPackage.isEditable && dsPackage.dsStakeholders.find(function (oneStakeholder) {
	                return !oneStakeholder.finished;
	            })) {
	                statusToDisplay = _('notSigned');
	            }
	
	            if (!oneDoc.uploadedToOracle && (oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned || oneDoc.origin === "DS_ORIGIN_ORACLE") && !dsPackage.isEditable && dsPackage.dsStakeholders.find(function (oneStakeholder) {
	                return !oneStakeholder.finished;
	            })) {
	                statusToDisplay = _('signed');
	            }
	            if (dsPackage.isEditable) {
	                statusToDisplay = dsPackage.status ? _((0, _documentsHelpers.getStatusTranslationKey)(dsPackage.status)) : '-';
	            }
	            return statusToDisplay;
	        }
	    }, {
	        key: 'simpleRefresh',
	        value: function simpleRefresh() {
	            var openedPackage = this.props.openedPackage;
	
	            this.fetchDsPackageToDisplay(openedPackage);
	        }
	    }, {
	        key: 'collectTicketData',
	        value: function collectTicketData(ticketId) {
	            var _props6, dispatch, DSDocumentOriginTypes, ticket, ticketDocuments, selectedTicketDocuments, emailAttachmentTicketDocuments, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, oneDocId, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, oneSelectedDoc, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3;
	
	            return regeneratorRuntime.async(function collectTicketData$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props6 = this.props;
	                        dispatch = _props6.dispatch;
	                        DSDocumentOriginTypes = _props6.DSDocumentOriginTypes;
	                        ticket = undefined;
	                        ticketDocuments = [];
	                        selectedTicketDocuments = [];
	                        emailAttachmentTicketDocuments = [];
	
	                        if (!ticketId) {
	                            context$2$0.next = 69;
	                            break;
	                        }
	
	                        context$2$0.next = 10;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchOneTicketById)(ticketId)));
	
	                    case 10:
	                        ticket = context$2$0.sent;
	
	                        if (!ticket) {
	                            context$2$0.next = 69;
	                            break;
	                        }
	
	                        _iteratorNormalCompletion = true;
	                        _didIteratorError = false;
	                        _iteratorError = undefined;
	                        context$2$0.prev = 15;
	
	                        for (_iterator = ticket.documents[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            oneDocId = _step.value;
	
	                            ticketDocuments.push({ oracleDocumentId: oneDocId, oracleDocumentType: _nestedProperty2['default'].get(ticket, 'typeDocument'), origin: DSDocumentOriginTypes.DS_ORIGIN_ORACLE });
	                        }
	
	                        context$2$0.next = 23;
	                        break;
	
	                    case 19:
	                        context$2$0.prev = 19;
	                        context$2$0.t0 = context$2$0['catch'](15);
	                        _didIteratorError = true;
	                        _iteratorError = context$2$0.t0;
	
	                    case 23:
	                        context$2$0.prev = 23;
	                        context$2$0.prev = 24;
	
	                        if (!_iteratorNormalCompletion && _iterator['return']) {
	                            _iterator['return']();
	                        }
	
	                    case 26:
	                        context$2$0.prev = 26;
	
	                        if (!_didIteratorError) {
	                            context$2$0.next = 29;
	                            break;
	                        }
	
	                        throw _iteratorError;
	
	                    case 29:
	                        return context$2$0.finish(26);
	
	                    case 30:
	                        return context$2$0.finish(23);
	
	                    case 31:
	                        _iteratorNormalCompletion2 = true;
	                        _didIteratorError2 = false;
	                        _iteratorError2 = undefined;
	                        context$2$0.prev = 34;
	                        for (_iterator2 = ticket.signatureDocuments[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                            oneSelectedDoc = _step2.value;
	
	                            selectedTicketDocuments.push({
	                                oracleDocumentId: oneSelectedDoc,
	                                oracleDocumentType: _nestedProperty2['default'].get(ticket, 'typeDocument'),
	                                origin: DSDocumentOriginTypes.DS_ORIGIN_ORACLE
	                            });
	                        }
	
	                        context$2$0.next = 42;
	                        break;
	
	                    case 38:
	                        context$2$0.prev = 38;
	                        context$2$0.t1 = context$2$0['catch'](34);
	                        _didIteratorError2 = true;
	                        _iteratorError2 = context$2$0.t1;
	
	                    case 42:
	                        context$2$0.prev = 42;
	                        context$2$0.prev = 43;
	
	                        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                            _iterator2['return']();
	                        }
	
	                    case 45:
	                        context$2$0.prev = 45;
	
	                        if (!_didIteratorError2) {
	                            context$2$0.next = 48;
	                            break;
	                        }
	
	                        throw _iteratorError2;
	
	                    case 48:
	                        return context$2$0.finish(45);
	
	                    case 49:
	                        return context$2$0.finish(42);
	
	                    case 50:
	                        _iteratorNormalCompletion3 = true;
	                        _didIteratorError3 = false;
	                        _iteratorError3 = undefined;
	                        context$2$0.prev = 53;
	                        for (_iterator3 = ticket.emailAttachmentTicketDocuments[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                            oneSelectedDoc = _step3.value;
	
	                            emailAttachmentTicketDocuments.push({
	                                oracleDocumentId: oneSelectedDoc,
	                                oracleDocumentType: _nestedProperty2['default'].get(ticket, 'typeDocument'),
	                                origin: DSDocumentOriginTypes.DS_ORIGIN_ORACLE
	                            });
	                        }
	                        context$2$0.next = 61;
	                        break;
	
	                    case 57:
	                        context$2$0.prev = 57;
	                        context$2$0.t2 = context$2$0['catch'](53);
	                        _didIteratorError3 = true;
	                        _iteratorError3 = context$2$0.t2;
	
	                    case 61:
	                        context$2$0.prev = 61;
	                        context$2$0.prev = 62;
	
	                        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	                            _iterator3['return']();
	                        }
	
	                    case 64:
	                        context$2$0.prev = 64;
	
	                        if (!_didIteratorError3) {
	                            context$2$0.next = 67;
	                            break;
	                        }
	
	                        throw _iteratorError3;
	
	                    case 67:
	                        return context$2$0.finish(64);
	
	                    case 68:
	                        return context$2$0.finish(61);
	
	                    case 69:
	                        return context$2$0.abrupt('return', { ticketId: ticketId, ticketDocuments: ticketDocuments, selectedTicketDocuments: selectedTicketDocuments, emailAttachmentTicketDocuments: emailAttachmentTicketDocuments });
	
	                    case 70:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[15, 19, 23, 31], [24,, 26, 30], [34, 38, 42, 50], [43,, 45, 49], [53, 57, 61, 69], [62,, 64, 68]]);
	        }
	    }, {
	        key: 'collectModuleOptionsValues',
	        value: function collectModuleOptionsValues(dsPackage) {
	            var _props7, dispatch, lang, clientId, contractId, tarificationId, claimId, clientData, emails, fetchClientResponse, tarificationData, fetchTarificationResponse, claimData, fetchClaimResponse, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, oneContract, contractData, fetchContractResponse;
	
	            return regeneratorRuntime.async(function collectModuleOptionsValues$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props7 = this.props;
	                        dispatch = _props7.dispatch;
	                        lang = _props7.lang;
	                        clientId = dsPackage.clientId;
	                        contractId = dsPackage.contractId;
	                        tarificationId = dsPackage.tarificationId;
	                        claimId = dsPackage.claimId;
	                        clientData = null;
	                        emails = [];
	
	                        if (!clientId) {
	                            context$2$0.next = 16;
	                            break;
	                        }
	
	                        context$2$0.next = 12;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClient)(clientId)));
	
	                    case 12:
	                        fetchClientResponse = context$2$0.sent;
	
	                        if (fetchClientResponse && fetchClientResponse.client) {
	                            clientData = fetchClientResponse.client;
	                        }
	
	                        emails = _nestedProperty2['default'].get(clientData, 'detail.emails');
	                        if (emails && emails.length) {
	                            emails = emails.map(function (item) {
	                                return {
	                                    referenceId: clientId,
	                                    label: _nestedProperty2['default'].get(clientData, "main.name"),
	                                    value: item.email,
	                                    'default': item['default'] == "true" || item['default'] == true ? true : false
	                                };
	                            });
	
	                            emails = emails.sort(function (item, item2) {
	                                if (item['default'] && !item2['default']) {
	                                    return -1;
	                                }
	                                if (!item['default'] && item2['default']) {
	                                    return 1;
	                                }
	                                if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                                    return 0;
	                                }
	                            }) || [];
	                        }
	
	                    case 16:
	                        tarificationData = null;
	
	                        if (!tarificationId) {
	                            context$2$0.next = 22;
	                            break;
	                        }
	
	                        context$2$0.next = 20;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClientTarification)(tarificationId)));
	
	                    case 20:
	                        fetchTarificationResponse = context$2$0.sent;
	
	                        if (fetchTarificationResponse && fetchTarificationResponse.response) {
	                            tarificationData = _stateActions.fetchClientTarification.response;
	                        }
	
	                    case 22:
	                        claimData = undefined;
	
	                        if (!(claimId && clientId)) {
	                            context$2$0.next = 49;
	                            break;
	                        }
	
	                        context$2$0.next = 26;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClientOneClaim)(clientId, claimId, dsPackage.userId)));
	
	                    case 26:
	                        fetchClaimResponse = context$2$0.sent;
	
	                        if (!fetchClaimResponse) {
	                            context$2$0.next = 49;
	                            break;
	                        }
	
	                        claimData = fetchClaimResponse;
	
	                        if (!(claimData && claimData.claimMain && claimData.claimMain.contractNumber && clientData)) {
	                            context$2$0.next = 49;
	                            break;
	                        }
	
	                        _iteratorNormalCompletion4 = true;
	                        _didIteratorError4 = false;
	                        _iteratorError4 = undefined;
	                        context$2$0.prev = 33;
	
	                        for (_iterator4 = clientData.contracts[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                            oneContract = _step4.value;
	
	                            if (oneContract.contractMain.contractNumber === claimData.claimMain.contractNumber) {
	                                contractId = oneContract.contractMain.contractId;
	                            }
	                        }
	                        context$2$0.next = 41;
	                        break;
	
	                    case 37:
	                        context$2$0.prev = 37;
	                        context$2$0.t0 = context$2$0['catch'](33);
	                        _didIteratorError4 = true;
	                        _iteratorError4 = context$2$0.t0;
	
	                    case 41:
	                        context$2$0.prev = 41;
	                        context$2$0.prev = 42;
	
	                        if (!_iteratorNormalCompletion4 && _iterator4['return']) {
	                            _iterator4['return']();
	                        }
	
	                    case 44:
	                        context$2$0.prev = 44;
	
	                        if (!_didIteratorError4) {
	                            context$2$0.next = 47;
	                            break;
	                        }
	
	                        throw _iteratorError4;
	
	                    case 47:
	                        return context$2$0.finish(44);
	
	                    case 48:
	                        return context$2$0.finish(41);
	
	                    case 49:
	                        contractData = null;
	
	                        if (!contractId) {
	                            context$2$0.next = 55;
	                            break;
	                        }
	
	                        context$2$0.next = 53;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClientContract)(contractId)));
	
	                    case 53:
	                        fetchContractResponse = context$2$0.sent;
	
	                        if (fetchContractResponse && fetchContractResponse.response) {
	                            contractData = fetchContractResponse.response;
	                        }
	
	                    case 55:
	                        return context$2$0.abrupt('return', {
	                            clientDocuments: _nestedProperty2['default'].get(clientData, "clientDocuments"),
	                            clientDocumentsType: 'client',
	                            clientDocumentsId: clientId,
	                            clientId: clientId,
	                            clientName: _nestedProperty2['default'].get(clientData, "main.name"),
	                            clientNumber: _nestedProperty2['default'].get(clientData, "main.clientNumber"),
	                            clientLanguage: lang,
	                            clientEmails: emails,
	
	                            // new v6 mode
	                            claimNumber: _nestedProperty2['default'].get(claimData, "claimMain.claimNumber"),
	                            claimDocuments: _nestedProperty2['default'].get(claimData, "claimDocuments"),
	                            claimDocumentsType: "claim",
	                            claimDocumentsId: claimId,
	                            // claimId: false,
	
	                            contractNumber: _nestedProperty2['default'].get(contractData, 'contractMain.contractNumber'),
	                            contractDocuments: _nestedProperty2['default'].get(contractData, 'contractDocuments'),
	                            contractDocumentsType: "contract",
	                            contractDocumentsId: contractId,
	                            contractId: contractId,
	
	                            tarificationNumber: _nestedProperty2['default'].get(tarificationData, 'tarificationNumber'),
	                            tarificationDocuments: _nestedProperty2['default'].get(tarificationData, "tarificationDocuments"),
	                            tarificationDocumentsType: "tarification",
	                            tarificationDocumentsId: tarificationId,
	
	                            company: _nestedProperty2['default'].get(contractData, 'contractMain.insuranceCompany'),
	                            companyCancelMail: _nestedProperty2['default'].get(contractData, 'contractMain.companyCancelMail'),
	                            brokerNumber: _nestedProperty2['default'].get(dsPackage, "brokerNumber"),
	
	                            clientData: _nestedProperty2['default'].get(clientData, "main")
	                        });
	
	                    case 56:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[33, 37, 41, 49], [42,, 44, 48]]);
	        }
	
	        /**
	         * Handle the reset process, when the user click on the reset button
	         * @param {object} dsPackage
	         * @returns nothing
	         */
	    }, {
	        key: 'onSendInvitationClick',
	        value: function onSendInvitationClick(packageId) {
	            var dispatch, dsPackage;
	            return regeneratorRuntime.async(function onSendInvitationClick$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$2$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getActualizedPackageForInvitation)(packageId)));
	
	                    case 3:
	                        dsPackage = context$2$0.sent;
	
	                        if (!(!dsPackage.error && (0, _libHelpers.canSendInvitation)(dsPackage))) {
	                            context$2$0.next = 8;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return', true);
	
	                    case 8:
	                        this.setState({ reminderConfirmationModal: true, invitationBlocked: true });
	                        this.fetchDsPackageToDisplay(packageId);
	                        return context$2$0.abrupt('return', false);
	
	                    case 11:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this9 = this;
	
	            var _state2 = this.state;
	            var statusExplainerIsOpen = _state2.statusExplainerIsOpen;
	            var canCreateMifid = _state2.canCreateMifid;
	            var editClientEmail = _state2.editClientEmail;
	            var editClientPhoneNumber = _state2.editClientPhoneNumber;
	            var stakeholderToEdit = _state2.stakeholderToEdit;
	            var isOpenLinkDocumentModal = _state2.isOpenLinkDocumentModal;
	            var isLoaded = _state2.isLoaded;
	            var moduleOptions = _state2.moduleOptions;
	            var ticketData = _state2.ticketData;
	            var reminderConfirmationModal = _state2.reminderConfirmationModal;
	            var reminderSentSuccessFlag = _state2.reminderSentSuccessFlag;
	            var invitationBlocked = _state2.invitationBlocked;
	            var _props8 = this.props;
	            var createmail = _props8.createmail;
	            var dispatch = _props8.dispatch;
	            var forceOpenInvitationEditor = _props8.forceOpenInvitationEditor;
	            var forceOpenInvitationFromTicket = _props8.forceOpenInvitationFromTicket;
	            var zoomOut = _props8.zoomOut;
	            var _state3 = this.state;
	            var dsPackage = _state3.dsPackage;
	            var isOpenAreYouSure = _state3.isOpenAreYouSure;
	
	            var contractNumber = _nestedProperty2['default'].get(dsPackage, 'contractNumber');
	            var statusHistory = _nestedProperty2['default'].get(dsPackage, "statusHistory");
	
	            // calculate and collect flags for logical operations
	            var shouldSendRemainder = this.shouldSendRemainder(dsPackage);
	            var isEditableThePackage = (0, _documentsHelpers.shouldEditThePackage)(_nestedProperty2['default'].get(dsPackage, "statusHistory"), _nestedProperty2['default'].get(dsPackage, "isEditable"));
	            // don't show the last status, must shown the signed status in case when the document is signed: BEWB-445
	            var isUploaded = this.documentsAreUploaded(_nestedProperty2['default'].get(dsPackage, "status"), _nestedProperty2['default'].get(dsPackage, "statusHistory"));
	            var statusToShow = _nestedProperty2['default'].get(dsPackage, "status") || "";
	            if (dsPackage.mustBeSigned) {
	                if (dsPackage.hasFinishStatus) {
	                    statusToShow = c.DS_PACKAGE_STATUS_FINISHED;
	                }
	            } else {
	                if (isUploaded) {
	                    statusToShow = c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE;
	                }
	            }
	
	            if (!isLoaded) {
	                return _react2['default'].createElement('div', null);
	            }
	
	            // for overview emailer
	            var emailModuleOptionsInviteOnlyNotInvited = dsPackage.dsStakeholders && dsPackage.dsStakeholders.length > 0 && _extends({}, moduleOptions, {
	                dsPackage: dsPackage,
	                brokerNumber: _nestedProperty2['default'].get(dsPackage, "brokerNumber"),
	                brokerEmailAddress: _nestedProperty2['default'].get(dsPackage, "brokerEmailAddress"),
	                autoSelectTemplate: true,
	                usePlaceholdersForClientVariables: true,
	                stakeholders: dsPackage.dsStakeholders.filter(function (oneStake) {
	                    return oneStake.signerType !== "BROKER" && !oneStake.isInvited;
	                }),
	                clientEmails: dsPackage.dsStakeholders.filter(function (oneStake) {
	                    return oneStake.signerType !== "BROKER" && !oneStake.isInvited;
	                }).map(function (oneHolder) {
	                    return {
	                        referenceId: oneHolder._id,
	                        value: oneHolder.email,
	                        lang: oneHolder.language,
	                        isPermanentSelected: true,
	                        isCC: false,
	                        label: oneHolder.firstName + " " + oneHolder.lastName
	                    };
	                })
	            });
	
	            // for emailaddress correction modal, resend for all
	            var emailModuleOptionsInviteAll = _extends({}, moduleOptions, {
	                dsPackage: dsPackage,
	                brokerNumber: _nestedProperty2['default'].get(dsPackage, "brokerNumber"),
	                brokerEmailAddress: _nestedProperty2['default'].get(dsPackage, "brokerEmailAddress"),
	                autoSelectTemplate: true,
	                usePlaceholdersForClientVariables: true,
	                stakeholders: dsPackage.dsStakeholders.filter(function (oneStake) {
	                    return oneStake.signerType !== "BROKER";
	                }),
	                clientEmails: dsPackage.dsStakeholders.filter(function (oneStake) {
	                    return oneStake.signerType !== "BROKER";
	                }).map(function (oneHolder) {
	                    return {
	                        referenceId: oneHolder._id,
	                        value: oneHolder.email,
	                        lang: oneHolder.language,
	                        isPermanentSelected: true,
	                        isCC: false,
	                        label: oneHolder.firstName + " " + oneHolder.lastName
	                    };
	                })
	            });
	
	            var selectedTicketRelatedOraDocuments = ticketData.emailAttachmentTicketDocuments || [];
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _detailedDocumentScss2['default'].dsdocumentContainer },
	                _react2['default'].createElement(
	                    'h2',
	                    { className: _detailedDocumentScss2['default'].mainTitle },
	                    _('packageName') + (dsPackage && ' - "' + _nestedProperty2['default'].get(dsPackage, "connectivePackageName") + '"' || '')
	                ),
	                dsPackage && _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].columnWrapper },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].columnLeft) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('clientName'),
	                                    ':'
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsPackage, "clientName")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('clientEmail'),
	                                    ':'
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsPackage, "clientEmailAddress")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('brokerNumber'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsPackage, "brokerNumber")
	                                )
	                            ),
	                            contractNumber && _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('contractNumber'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    contractNumber
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('createdByFullName'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    dsPackage.userFullName
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].columnRight) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('createdAt'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    dsPackage && dsPackage.createdAt && (0, _moment2['default'])(dsPackage.createdAt).format('DD/MM/YYYY HH:mm:ss') || "-"
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('updatedAt'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    dsPackage.updatedAt != undefined && (0, _moment2['default'])(dsPackage.updatedAt).format('DD/MM/YYYY HH:mm:ss') || "-"
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('signedAt'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    this.getSigningDate(dsPackage) || "-"
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('packageStatus'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'a',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].column, _detailedDocumentScss2['default'].goToLink),
	                                        onClick: function (ev) {
	                                            ev.stopPropagation();
	                                            if (statusToShow) {
	                                                _this9.onItemStatusClick(statusToShow);
	                                            }
	                                        }
	                                    },
	                                    statusToShow ? _((0, _documentsHelpers.getStatusTranslationKey)(statusToShow)) : ''
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _('packageExpiration'),
	                                    ': '
	                                ),
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: _detailedDocumentScss2['default'].column },
	                                    _nestedProperty2['default'].get(dsPackage, "expirationOn")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row, _detailedDocumentScss2['default'].mifidContainer) },
	                                    canCreateMifid && _react2['default'].createElement(_mifidButton2['default'], {
	                                        step: c.DSWIZARD_STEP_1_COMPOSE_PACKAGE,
	                                        packageId: _nestedProperty2['default'].get(dsPackage, "_id"),
	                                        lang: lang,
	                                        callBackOnClose: function () {
	                                            _this9.onCloseDSWizard();
	                                        },
	                                        moduleKeyToSet: _nestedProperty2['default'].get(dsPackage, "uploadedOnModule"),
	
	                                        clientId: _nestedProperty2['default'].get(dsPackage, "clientId"),
	                                        claimId: _nestedProperty2['default'].get(dsPackage, "claimId"),
	                                        claimNumber: _nestedProperty2['default'].get(dsPackage, "claimNumber"),
	                                        contractId: _nestedProperty2['default'].get(dsPackage, "contractId"),
	                                        contractNumber: _nestedProperty2['default'].get(dsPackage, "contractNumber"),
	                                        tarificationId: _nestedProperty2['default'].get(dsPackage, "tarificationId"),
	                                        tarificationNumber: _nestedProperty2['default'].get(dsPackage, "tarificationNumber"),
	                                        stakeholders: _nestedProperty2['default'].get(dsPackage, "dsStakeholders"),
	                                        claimWizardDocType: _nestedProperty2['default'].get(dsPackage, "claimWizardDocType"),
	                                        alienUserId: dsPackage.userId,
	                                        hideButton: !isEditableThePackage,
	                                        isResume: true,
	                                        moduleOptions: moduleOptions,
	                                        ticketId: ticketData.ticketId,
	                                        ticketDocuments: ticketData.ticketDocuments,
	                                        selectedTicketDocuments: ticketData.selectedTicketDocuments,
	                                        emailAttachmentTicketDocuments: ticketData.emailAttachmentTicketDocuments || [],
	                                        openTrigger: this.state.autoOpenMifid
	                                    }),
	                                    _react2['default'].createElement(_dsListButtonsWrapper2['default'], {
	                                        dsPackage: dsPackage || {},
	                                        isList: false,
	                                        method: function (dsDocument) {
	                                            return _this9.openLinkAndUploadWizard(dsDocument);
	                                        },
	                                        directSignMethod: function (id) {
	                                            return _this9.onDirectSignButtonClick(id);
	                                        },
	                                        showInvitation: false
	                                    }),
	                                    (forceOpenInvitationEditor || forceOpenInvitationFromTicket) && createmail && _react2['default'].createElement(_emailSenderEmailButton2['default'], {
	                                        customButtonLabel: _('customizeInvitationEmail'),
	                                        isWhiteIcon: true,
	                                        modalId: c.EMAILER_MODAL_HIDDEN_IN_PACKAGE_DETAILS,
	                                        hideCC: dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? false : true,
	                                        multiLanguage: true,
	                                        serialSending: true,
	                                        isCreatable: dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? true : false,
	                                        forceIsMulti: true,
	                                        key: "customizeInvitationRenderEmailSenderButtonFromEmailChangerKeyTemp",
	                                        onInit: function () {
	                                            _this9.onInitEmailer(selectedTicketRelatedOraDocuments);
	                                        },
	                                        onSentLate: function callee$2$0(responses) {
	                                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                    case 0:
	                                                        context$3$0.next = 2;
	                                                        return regeneratorRuntime.awrap(this.onSentEmailer(responses, dsPackage, dsPackage.dsStakeholders));
	
	                                                    case 2:
	                                                        dsPackage = context$3$0.sent;
	
	                                                        if (!forceOpenInvitationFromTicket) {
	                                                            context$3$0.next = 7;
	                                                            break;
	                                                        }
	
	                                                        dispatch((0, _stateActions.setOpenInvitationEditorFromTicket)(false));
	                                                        dispatch((0, _stateActions.setAppModule)(c.INBOX, null));
	                                                        return context$3$0.abrupt('return');
	
	                                                    case 7:
	                                                        context$3$0.next = 9;
	                                                        return regeneratorRuntime.awrap(zoomOut());
	
	                                                    case 9:
	                                                        context$3$0.next = 11;
	                                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.setOpenInvitationEditor)(false)));
	
	                                                    case 11:
	                                                    case 'end':
	                                                        return context$3$0.stop();
	                                                }
	                                            }, null, _this9);
	                                        },
	                                        moduleKeyToSet: (0, _DSWizardHelper.getEmailerModuleKeyByWizardModuleKey)(_nestedProperty2['default'].get(dsPackage, "uploadedOnModule")),
	                                        moduleOptions: emailModuleOptionsInviteOnlyNotInvited,
	                                        getDSStakeholders: function callee$2$0(stakeholderIdArray) {
	                                            var listOfHolders;
	                                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                    case 0:
	                                                        context$3$0.next = 2;
	                                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getDSStakeholders)(stakeholderIdArray)));
	
	                                                    case 2:
	                                                        listOfHolders = context$3$0.sent;
	
	                                                        listOfHolders = listOfHolders.filter(function (oneStake) {
	                                                            return oneStake.signerType !== "BROKER" && !oneStake.isInvited;
	                                                        });
	                                                        return context$3$0.abrupt('return', listOfHolders);
	
	                                                    case 5:
	                                                    case 'end':
	                                                        return context$3$0.stop();
	                                                }
	                                            }, null, _this9);
	                                        },
	                                        customClassName: _documentsScss2['default'].greenButton + " enabled",
	                                        onCancel: function callee$2$0() {
	                                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                    case 0:
	                                                        if (!forceOpenInvitationFromTicket) {
	                                                            context$3$0.next = 4;
	                                                            break;
	                                                        }
	
	                                                        dispatch((0, _stateActions.setOpenInvitationEditorFromTicket)(false));
	                                                        dispatch((0, _stateActions.setAppModule)(c.INBOX, null));
	                                                        return context$3$0.abrupt('return');
	
	                                                    case 4:
	                                                        context$3$0.next = 6;
	                                                        return regeneratorRuntime.awrap(zoomOut());
	
	                                                    case 6:
	                                                        context$3$0.next = 8;
	                                                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.setOpenInvitationEditor)(false)));
	
	                                                    case 8:
	                                                    case 'end':
	                                                        return context$3$0.stop();
	                                                }
	                                            }, null, _this9);
	                                        }
	                                    }),
	                                    dsPackage && !isEditableThePackage && !dsPackage.hasFinishStatus && dsPackage.mustBeSigned && _react2['default'].createElement(
	                                        'div',
	                                        { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].bottomButtonsContainer) },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: (0, _classnames2['default'])(_documentsScss2['default'].marginBot) },
	                                            _react2['default'].createElement(
	                                                'button',
	                                                { className: (0, _classnames2['default'])(_documentsScss2['default'].greenButton, _documentsScss2['default'].greenButtonDsList, "enabled", _detailedDocumentScss2['default'].buttonCustomizationRenew),
	                                                    onClick: function callee$2$0(ev) {
	                                                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                                case 0:
	                                                                    ev.stopPropagation();
	
	                                                                    context$3$0.next = 3;
	                                                                    return regeneratorRuntime.awrap(this.onClickRecreatePackage(dsPackage));
	
	                                                                case 3:
	                                                                case 'end':
	                                                                    return context$3$0.stop();
	                                                            }
	                                                        }, null, _this9);
	                                                    }
	                                                },
	                                                _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].icon, _detailedDocumentScss2['default'].iconHeight), src: this.getIcon('autorenew_white.svg') }),
	                                                _('extendExpirationText')
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                dsPackage && dsPackage.mustBeSigned ? dsPackage.dsStakeholders && dsPackage.dsStakeholders.length > 0 ? this.renderStakeholdersArea(isEditableThePackage, shouldSendRemainder) : dsPackage.clientEmailAddress ? this.renderSignerArea(isEditableThePackage, shouldSendRemainder) : null : dsPackage && !dsPackage.mustBeSigned ? _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                        _('signersArea')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].signersLabelsColumn },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].signersLabel) },
	                                    _('documentNotRequireSignig')
	                                )
	                            )
	                        )
	                    )
	                ) : null,
	                dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.length > 0 && _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                        _('dsDocuments')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _detailedDocumentScss2['default'].column },
	                                this.renderDocumentsList(dsPackage.dsDocuments, statusToShow)
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedDocumentScss2['default'].mainTitle },
	                    _('packageStatusHistory')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedDocumentScss2['default'].dsdocumentHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedDocumentScss2['default'].row) },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedDocumentScss2['default'].column },
	                            statusHistory && statusHistory.length > 0 && this.renderStatusHistory(statusHistory)
	                        )
	                    )
	                ),
	                _react2['default'].createElement(_AreYouSureModal2['default'], {
	                    isOpen: Boolean(isOpenAreYouSure),
	                    style: _documentsHelpers.customModalStyles,
	                    contentLabel: "",
	                    isOpenAreYouSure: isOpenAreYouSure ? isOpenAreYouSure : {},
	                    didClose: function () {
	                        _this9.setState({ isOpenAreYouSure: false });
	                    },
	                    key: "AreYouSureModal"
	                }),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        contentLabel: "",
	                        isOpen: Boolean(statusExplainerIsOpen),
	                        style: _documentsHelpers.customModalStyles
	                    },
	                    (0, _documentsHelpers.statusExplainerPopup)(_((0, _documentsHelpers.getStatusTranslationKey)(statusExplainerIsOpen)), _((0, _documentsHelpers.getStatusDescriptionTranslationKey)(statusExplainerIsOpen)), function () {
	                        _this9.setState({ statusExplainerIsOpen: false });
	                    }, _("ok"))
	                ),
	                _react2['default'].createElement(_reminderEmailStatusDialog2['default'], {
	                    isOpen: reminderConfirmationModal,
	                    success: reminderSentSuccessFlag,
	                    invitationBlocked: invitationBlocked,
	                    closeModal: function () {
	                        return _this9.setState({ reminderConfirmationModal: false, invitationBlocked: false, reminderSentSuccessFlag: false });
	                    }
	                }),
	                _react2['default'].createElement(_clientContactInfoChangerModalForPackage2['default'], {
	                    dsPackage: dsPackage,
	                    triggerToOpen: editClientEmail || editClientPhoneNumber,
	                    editClientEmail: editClientEmail,
	                    editClientPhoneNumber: editClientPhoneNumber,
	                    stakeholder: stakeholderToEdit,
	                    isEditableThePackage: isEditableThePackage,
	                    callBackOnClose: function () {
	                        _this9.onAfterUpdateClientEmail();
	                    },
	                    moduleKeyToSet: (0, _DSWizardHelper.getEmailerModuleKeyByWizardModuleKey)(_nestedProperty2['default'].get(dsPackage, "uploadedOnModule")),
	                    emailerModuleOptions: emailModuleOptionsInviteAll,
	                    onSentEmailer: function callee$2$0(responses, dsPackageNew, stakeholdersNew) {
	                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                case 0:
	                                    context$3$0.next = 2;
	                                    return regeneratorRuntime.awrap(this.onSentEmailer(responses, dsPackageNew, stakeholdersNew));
	
	                                case 2:
	                                    dsPackage = context$3$0.sent;
	
	                                    this.setState({ dsPackage: dsPackage });
	                                    return context$3$0.abrupt('return', dsPackage);
	
	                                case 5:
	                                case 'end':
	                                    return context$3$0.stop();
	                            }
	                        }, null, _this9);
	                    },
	                    onInitEmailer: function () {
	                        _this9.onInitEmailer(selectedTicketRelatedOraDocuments);
	                    }
	                }),
	                _react2['default'].createElement(_linkToContractAndUploadDocumentsLinkDocumentsModal2['default'], {
	                    modalIsOpen: !!isOpenLinkDocumentModal,
	                    onCancel: function () {
	                        _this9.setState({ isOpenLinkDocumentModal: false });
	                        _this9.simpleRefresh();
	                    },
	                    onConfirmation: function () {
	                        _this9.setState({ isOpenLinkDocumentModal: false });
	                        _this9.simpleRefresh();
	                    },
	                    flag: 'LinkDocumentModal',
	                    payload: isOpenLinkDocumentModal ? {
	                        dsPackage: isOpenLinkDocumentModal
	                    } : {}
	                })
	            );
	        }
	    }]);
	
	    var _DetailedPackage = DetailedPackage;
	    DetailedPackage = (0, _reactRedux.connect)(function (state) {
	        return {
	            // must fetch the setting
	            DigitalSignatureSettings: state.DSDocuments.DigitalSignatureSettings,
	            openedPackage: state.DSDocuments.openedPackage,
	            clientAccess: state.app.security.actions,
	            lang: state.app.lang,
	            DSDocumentOriginTypes: _nestedProperty2['default'].get(state, "app.security.DigitalSignatureHardLists.DSDocumentOriginTypes"),
	            createmail: state.app.security.actions.filter(function (item) {
	                return item.actionName == "createmail" && item.actionAllowed == "true";
	            }).length > 0,
	            EmailTemplateRelations: state.app.security.EmailTemplateRelations,
	            forceOpenInvitationFromTicket: state.DSDocuments.forceOpenInvitationFromTicket
	        };
	    })(DetailedPackage) || DetailedPackage;
	    return DetailedPackage;
	})(_react.Component);
	
	exports['default'] = DetailedPackage;
	module.exports = exports['default'];

	/***
	* Event handler for on resent the email.
	* Update dsPackage data after reminder was sent
	*/

	// update all stakeholder as invited
	/* BUTTONS */ /* BUTTONS 2 */

	//update stakeholders if the case

	/**
	* This function render the status history data-table
	*/

	//get client related data

	//get tarification data

	//get claim and related package data

	//get contract data

	// this function will be called when the operation is failed
	// it will show a popup with the error message

	// this function will be called when the operation is success
	// it will show a popup with the success message

	// this function will be called when the user click on the confirm button
	// it will call the backend to recreate the package

	// this is an init data for the popup on the first time to ask the user if he is sure to recreate the package

	// show the popup to ask the user if he is sure to recreate the package

	//if originate from tickets navigate back

	//navigate back to ds list

	//if originate from tickets navigate back

	//navigate back to ds list

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(57);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _stateActions = __webpack_require__(5);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _componentsSharedSelectSelectWrap2 = _interopRequireDefault(_componentsSharedSelectSelectWrap);
	
	var _refreshBtn = __webpack_require__(174);
	
	var _refreshBtn2 = _interopRequireDefault(_refreshBtn);
	
	var _documentsHelpers = __webpack_require__(106);
	
	var _libHelpers = __webpack_require__(24);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _libValidator = __webpack_require__(96);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _linkToContractAndUploadDocumentsLinkDocumentsModal = __webpack_require__(602);
	
	var _linkToContractAndUploadDocumentsLinkDocumentsModal2 = _interopRequireDefault(_linkToContractAndUploadDocumentsLinkDocumentsModal);
	
	var _dsListButtonsWrapper = __webpack_require__(364);
	
	var _dsListButtonsWrapper2 = _interopRequireDefault(_dsListButtonsWrapper);
	
	var _reminderEmailStatusDialog = __webpack_require__(264);
	
	var _reminderEmailStatusDialog2 = _interopRequireDefault(_reminderEmailStatusDialog);
	
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	var DSDocumentList = (function (_React$Component) {
	    _inherits(DSDocumentList, _React$Component);
	
	    _createClass(DSDocumentList, null, [{
	        key: 'propTypes',
	        value: {
	            filter: _react.PropTypes.string.isRequired,
	            selectValue: _react.PropTypes.string.isRequired,
	            paginatedPackages: _react2['default'].PropTypes.array.isRequired,
	            zoomTo: _react2['default'].PropTypes.func.isRequired,
	            startDate: _react2['default'].PropTypes.any,
	            endDate: _react2['default'].PropTypes.any,
	            handleSubmit: _react2['default'].PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    function DSDocumentList(props) {
	        var _this = this;
	
	        _classCallCheck(this, _DSDocumentList);
	
	        _get(Object.getPrototypeOf(_DSDocumentList.prototype), 'constructor', this).call(this, props);
	
	        this.handleCheckAll = function () {
	            var dispatch = _this.props.dispatch;
	            var allSelected = _this.allSelected;
	            var visibleIds = _this.visibleIds;
	
	            if (!allSelected) {
	                var msg = _('all') + ' ' + visibleIds.length + ' ' + _('numOfSelectedMsg');
	                dispatch((0, _stateActions.setNotification)(msg, 'info'));
	            }
	
	            dispatch((0, _stateActions.selectVisibleItems)(visibleIds));
	        };
	
	        this.handleVisibleList = function (visibleIds) {
	            var visibilityOf = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = visibleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var id = _step.value;
	
	                    visibilityOf[id] = true;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator['return']) {
	                        _iterator['return']();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            _this.visibleIds = visibleIds;
	            _this.setState({ visibilityOf: visibilityOf });
	        };
	
	        this.saveForm = function (data) {
	            // const { selectValue, dispatch } = this.props
	            return _this.onDateFilterClick(data);
	            // dispatch(filterDSDocuments(selectValue, data.startDate, data.endDate))
	        };
	
	        this.alignTableComponents = function () {
	            var documentTypeElements = Array.from(document.querySelectorAll('[class*="docTypeParagraph"]'));
	            var docStatusElements = Array.from(document.querySelectorAll('[class*="statusParagraph"]'));
	            var docTypeMap = {};
	            var docStatusMap = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = documentTypeElements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var oneElem = _step2.value;
	
	                    var attribute = oneElem.getAttribute('data-documentIdAttr');
	                    _nestedProperty2['default'].set(docTypeMap, attribute, oneElem);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                        _iterator2['return']();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = docStatusElements[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var oneStatusElem = _step3.value;
	
	                    var attribute = oneStatusElem.getAttribute('data-documentIdAttr');
	                    _nestedProperty2['default'].set(docStatusMap, attribute, oneStatusElem);
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	                        _iterator3['return']();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	
	            for (var key in docTypeMap) {
	                var docTypeHeight = docTypeMap[key].offsetHeight;
	                var docStatusHeight = docStatusMap[key] ? docStatusMap[key].offsetHeight : 0;
	                if (docTypeHeight > 0 && docStatusHeight > 0) {
	                    if (docStatusHeight > docTypeHeight) {
	                        docTypeMap[key].style.height = docStatusHeight + 'px';
	                    } else if (docStatusHeight < docTypeHeight) {
	                        docStatusMap[key].style.height = docTypeHeight + 'px';
	                    }
	                }
	            }
	        };
	
	        this.resetAlignedComponents = function () {
	            var documentTypeElements = Array.from(document.querySelectorAll('[class*="docTypeParagraph"]'));
	            var docStatusElements = Array.from(document.querySelectorAll('[class*="statusParagraph"]'));
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = documentTypeElements[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var oneElem = _step4.value;
	
	                    oneElem.style.height = 'auto';
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4['return']) {
	                        _iterator4['return']();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion5 = true;
	            var _didIteratorError5 = false;
	            var _iteratorError5 = undefined;
	
	            try {
	                for (var _iterator5 = docStatusElements[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                    var oneStatusElem = _step5.value;
	
	                    oneStatusElem.style.height = 'auto';
	                }
	            } catch (err) {
	                _didIteratorError5 = true;
	                _iteratorError5 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion5 && _iterator5['return']) {
	                        _iterator5['return']();
	                    }
	                } finally {
	                    if (_didIteratorError5) {
	                        throw _iteratorError5;
	                    }
	                }
	            }
	        };
	
	        this.onResendRemindersClick = function callee$2$0(packageId) {
	            var dispatch, reminderResponse, reminderSentSuccessFlag;
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$3$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.resendClientRemainder)(packageId)));
	
	                    case 3:
	                        reminderResponse = context$3$0.sent;
	                        reminderSentSuccessFlag = false;
	
	                        if (reminderResponse && reminderResponse.success) {
	                            reminderSentSuccessFlag = true;
	                        }
	                        this.setState({ reminderConfirmationModal: true, reminderSentSuccessFlag: reminderSentSuccessFlag });
	
	                    case 7:
	                    case 'end':
	                        return context$3$0.stop();
	                }
	            }, null, _this);
	        };
	
	        this.clientNameAndBrokerNumber = function (_ref) {
	            var subModuleKey = _ref.subModuleKey;
	            var clientName = _ref.clientName;
	            var brokerNumber = _ref.brokerNumber;
	
	            if (subModuleKey === c.DS_MODULE_OFFICE) {
	                return brokerNumber;
	            }
	            return clientName;
	        };
	
	        var brokers = _nestedProperty2['default'].get(props, 'brokers') || [];
	        var staffList = [];
	        var brokerNumbersList = [];
	        var canCreateMifid = false;
	        var clientAccess = _nestedProperty2['default'].get(props, 'actions');
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createmifid') {
	                canCreateMifid = item.actionAllowed === "true" ? true : false;
	            }
	        });
	        if (brokers) {
	            for (var key in brokers) {
	                if (brokers[key].brokerNumber) {
	                    brokerNumbersList.push(brokers[key].brokerNumber);
	                }
	                if (brokers[key].staff) {
	                    var _iteratorNormalCompletion6 = true;
	                    var _didIteratorError6 = false;
	                    var _iteratorError6 = undefined;
	
	                    try {
	                        for (var _iterator6 = brokers[key].staff[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                            var oneStaffMember = _step6.value;
	
	                            if (!staffList.includes(oneStaffMember.userId)) {
	                                staffList.push(oneStaffMember.userId);
	                            }
	                        }
	                    } catch (err) {
	                        _didIteratorError6 = true;
	                        _iteratorError6 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion6 && _iterator6['return']) {
	                                _iterator6['return']();
	                            }
	                        } finally {
	                            if (_didIteratorError6) {
	                                throw _iteratorError6;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        this.state = {
	            visibilityOf: {}, archiveIsOpen: false, statusExplainerIsOpen: false,
	            updatePackagesTotal: 0,
	            updatePackagesCurrentChunk: 0,
	            showUpdateWaitingModal: false,
	            isOpenLinkDocumentModal: false,
	            itemsPerPage: 50,
	            filterableFields: ["createdAt", "documentType", "clientName", "uploadedOnModule", "status", "userFullName", "brokerNumber"],
	            staffList: staffList,
	            brokerNumbersList: brokerNumbersList,
	            inputTimeoutId: '',
	            filterParam: '',
	            canCreateMifid: canCreateMifid,
	            reminderConfirmationModal: false,
	            reminderSentSuccessFlag: false,
	            invitationBlocked: false
	        };
	    }
	
	    /**
	    * Used to reset the selected documents in case new ticket is being processed
	    * @param {*} nextProps
	    */
	
	    _createClass(DSDocumentList, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _state = this.state;
	            var isLoaded = _state.isLoaded;
	            var stateStaffList = _state.staffList;
	            var stateBrokerNumbersList = _state.brokerNumbersList;
	
	            if (!isLoaded && (!stateStaffList || stateStaffList.length === 0 || !stateBrokerNumbersList || stateBrokerNumbersList.length === 0) && nextProps.brokers) {
	                var brokerNumbersList = [];
	                var staffList = [];
	                for (var key in nextProps.brokers) {
	                    if (nextProps.brokers[key].brokerNumber) {
	                        brokerNumbersList.push(nextProps.brokers[key].brokerNumber);
	                    }
	                    if (nextProps.brokers[key].staff) {
	                        var _iteratorNormalCompletion7 = true;
	                        var _didIteratorError7 = false;
	                        var _iteratorError7 = undefined;
	
	                        try {
	                            for (var _iterator7 = nextProps.brokers[key].staff[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                                var oneStaffMember = _step7.value;
	
	                                if (!staffList.includes(oneStaffMember.userId)) {
	                                    staffList.push(oneStaffMember.userId);
	                                }
	                            }
	                        } catch (err) {
	                            _didIteratorError7 = true;
	                            _iteratorError7 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion7 && _iterator7['return']) {
	                                    _iterator7['return']();
	                                }
	                            } finally {
	                                if (_didIteratorError7) {
	                                    throw _iteratorError7;
	                                }
	                            }
	                        }
	                    }
	                }
	                this.initModule(staffList, brokerNumbersList);
	            } else if (!isLoaded) {
	                this.initModule();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.resetAlignedComponents();
	            this.alignTableComponents();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.resetDSPackagesPaginationData)());
	        }
	
	        /**
	         * Component did mount hook. Check and load all the dependency values, init related values.
	         */
	    }, {
	        key: 'initModule',
	        value: function initModule() {
	            var updateStaffList = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	            var updatedBrokerNumbersList = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	            var _props, dispatch, selectValue, startDate, endDate, sortParams, pageNumber, filter, preSortDocumentsFromClient, _state2, itemsPerPage, filterableFields, staffList, brokerNumbersList, paginationData;
	
	            return regeneratorRuntime.async(function initModule$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props = this.props;
	                        dispatch = _props.dispatch;
	                        selectValue = _props.selectValue;
	                        startDate = _props.startDate;
	                        endDate = _props.endDate;
	                        sortParams = _props.sortParams;
	                        pageNumber = _props.pageNumber;
	                        filter = _props.filter;
	                        preSortDocumentsFromClient = _props.preSortDocumentsFromClient;
	                        _state2 = this.state;
	                        itemsPerPage = _state2.itemsPerPage;
	                        filterableFields = _state2.filterableFields;
	                        staffList = _state2.staffList;
	                        brokerNumbersList = _state2.brokerNumbersList;
	                        paginationData = {
	                            sortParams: sortParams, pageNumber: pageNumber, itemsPerPage: itemsPerPage, filterableFields: filterableFields, filter: filter, filterFunction: selectValue, startDate: startDate,
	                            endDate: endDate, staffList: staffList, brokerNumbersList: brokerNumbersList, clientId: preSortDocumentsFromClient
	                        };
	
	                        this.setState({ isLoaded: false });
	
	                        //if we receive clientI it means we the user has navigated from client profile and we need to show all documents that require linking from client
	                        if (preSortDocumentsFromClient) {
	                            paginationData.filterFunction = 'showNotLinked';
	                        }
	
	                        context$2$0.prev = 17;
	
	                        if ((!staffList || staffList.length === 0) && updateStaffList) {
	                            paginationData.staffList = updateStaffList;
	                        }
	                        if ((!brokerNumbersList || brokerNumbersList.length === 0) && updatedBrokerNumbersList) {
	                            paginationData.brokerNumbersList = updatedBrokerNumbersList;
	                        }
	                        context$2$0.next = 22;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getPaginatedPackagesList)(paginationData)));
	
	                    case 22:
	                        this.setState({ staffList: paginationData.staffList, brokerNumbersList: paginationData.brokerNumbersList, isLoaded: true });
	
	                        context$2$0.next = 28;
	                        break;
	
	                    case 25:
	                        context$2$0.prev = 25;
	                        context$2$0.t0 = context$2$0['catch'](17);
	
	                        this.setState({ isLoaded: true });
	
	                    case 28:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[17, 25]]);
	        }
	    }, {
	        key: 'check',
	        value: function check(ev, id) {
	            ev.stopPropagation();
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.setCheckBox)(id));
	        }
	    }, {
	        key: 'archiveBtn',
	        value: function archiveBtn(checkedItemCount, items) {
	            var _this2 = this;
	
	            var dispatch = this.props.dispatch;
	            var _state3 = this.state;
	            var staffList = _state3.staffList;
	            var brokerNumbersList = _state3.brokerNumbersList;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].buttonContainer },
	                _react2['default'].createElement('input', {
	                    onClick: function callee$2$0(ev) {
	                        return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                            while (1) switch (context$3$0.prev = context$3$0.next) {
	                                case 0:
	                                    context$3$0.next = 2;
	                                    return regeneratorRuntime.awrap(dispatch((0, _stateActions.archiveDSDocumentPackages)(items, staffList, brokerNumbersList)));
	
	                                case 2:
	                                    this.initModule();
	
	                                case 3:
	                                case 'end':
	                                    return context$3$0.stop();
	                            }
	                        }, null, _this2);
	                    },
	                    disabled: !checkedItemCount,
	                    type: 'button',
	                    className: _documentsScss2['default'].greyButton,
	                    value: _("delete")
	                }),
	                _react2['default'].createElement('input', {
	                    onClick: function () {
	                        return _this2.archiveAllPopupToggle();
	                    },
	                    disabled: !(items && items.length || false),
	                    type: 'button',
	                    className: _documentsScss2['default'].greyButton,
	                    value: _("deleteAll")
	                })
	            );
	        }
	    }, {
	        key: 'archiveAllPopupToggle',
	        value: function archiveAllPopupToggle() {
	            this.setState({ archiveIsOpen: !this.state.archiveIsOpen });
	        }
	    }, {
	        key: 'archiveAllConfirmHandle',
	        value: function archiveAllConfirmHandle() {
	            var _props2, dispatch, selectValue, startDate, endDate, sortParams, filter, _state4, filterableFields, staffList, brokerNumbersList, paginationData, itemsLength, msg;
	
	            return regeneratorRuntime.async(function archiveAllConfirmHandle$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        selectValue = _props2.selectValue;
	                        startDate = _props2.startDate;
	                        endDate = _props2.endDate;
	                        sortParams = _props2.sortParams;
	                        filter = _props2.filter;
	                        _state4 = this.state;
	                        filterableFields = _state4.filterableFields;
	                        staffList = _state4.staffList;
	                        brokerNumbersList = _state4.brokerNumbersList;
	                        paginationData = { sortParams: sortParams, filterableFields: filterableFields, filter: filter, filterFunction: selectValue, startDate: startDate, endDate: endDate, staffList: staffList, brokerNumbersList: brokerNumbersList };
	                        context$2$0.next = 14;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.archiveAllDSDocumentPackages)(paginationData)));
	
	                    case 14:
	                        itemsLength = context$2$0.sent;
	
	                        this.archiveAllPopupToggle();
	                        this.initModule();
	
	                        msg = _('all') + ' ' + itemsLength + ' ' + _('documentsDeleted');
	
	                        dispatch((0, _stateActions.setNotification)(msg, 'info'));
	
	                    case 19:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'archiveAllPopup',
	        value: function archiveAllPopup() {
	            var _this3 = this;
	
	            var paginatedPackages = this.props.paginatedPackages;
	
	            var filteredDocuments = paginatedPackages.filter(function (item) {
	                return !item.hidden;
	            });
	            var itemsLength = filteredDocuments && filteredDocuments.length || 0;
	            var titleMsg = _('all') + ' ' + itemsLength + ' ' + _('numOfSelectedMsg');
	            var msg = '' + _('doYouWantToArchiveAll');
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].documentsModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].title },
	                    titleMsg
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].message },
	                    msg
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalButtons },
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                return _this3.archiveAllPopupToggle();
	                            },
	                            className: _documentsScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            return _this3.archiveAllConfirmHandle();
	                        },
	                        type: 'button',
	                        className: _documentsScss2['default'].greyButton + " enabled",
	                        value: _("deleteAll")
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'onItemStatusClick',
	
	        /**
	         * This function handle the status modal opening
	         * @param {string} status - one doc status
	         */
	        value: function onItemStatusClick(status) {
	            this.setState({ statusExplainerIsOpen: status });
	        }
	
	        /**
	         *
	         * @param {*} value
	         */
	    }, {
	        key: 'changeResendToAddress',
	        value: function changeResendToAddress(value) {
	            // check validity
	            var valid = true;
	
	            if (!value || !(0, _libValidator.isAnEmail)(value)) {
	                valid = false;
	            }
	
	            this.setState({
	                resendToAddress: value,
	                resendToAddressValid: valid
	            });
	        }
	
	        /**
	         * This function will automatically refresh from connective the necessary packages.
	         */
	    }, {
	        key: 'getRemoteUpdateByChunks',
	        value: function getRemoteUpdateByChunks(onSubmit) {
	            var _this6 = this;
	
	            var dispatch = this.props.dispatch;
	
	            this.setState({ showUpdateWaitingModal: true });
	
	            new Promise(function (resolveGetUpdatableCount, rejectGetUpdatableCount) {
	                return dispatch((0, _stateActions.getUpdatablePackagesList)()).then(function (result) {
	                    return resolveGetUpdatableCount(result);
	                })['catch'](function (err) {
	                    return rejectGetUpdatableCount(err);
	                });
	            }).then(function callee$2$0(listOfUpdatableIds) {
	                var totalLength;
	                return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                    var _this5 = this;
	
	                    while (1) switch (context$3$0.prev = context$3$0.next) {
	                        case 0:
	                            totalLength = listOfUpdatableIds && listOfUpdatableIds.length;
	
	                            // must be numeric
	                            totalLength = totalLength ? totalLength * 1 : 0;
	
	                            this.setState({ updatePackagesTotal: totalLength });
	
	                            if (!(totalLength > 0)) {
	                                context$3$0.next = 6;
	                                break;
	                            }
	
	                            context$3$0.next = 6;
	                            return regeneratorRuntime.awrap((function callee$3$0() {
	                                var chunkSize, maxIndex, fromIndex, toIndex, chunkOfIds;
	                                return regeneratorRuntime.async(function callee$3$0$(context$4$0) {
	                                    var _this4 = this;
	
	                                    while (1) switch (context$4$0.prev = context$4$0.next) {
	                                        case 0:
	                                            chunkSize = 5;
	                                            maxIndex = totalLength - 1;
	                                            fromIndex = 0;
	                                            toIndex = fromIndex + chunkSize;
	
	                                            toIndex = toIndex > maxIndex ? maxIndex : toIndex;
	
	                                            // end of loop in case when someone push the cancel on modal or all is done
	
	                                        case 5:
	                                            if (!(fromIndex <= maxIndex && this.state.showUpdateWaitingModal)) {
	                                                context$4$0.next = 14;
	                                                break;
	                                            }
	
	                                            chunkOfIds = listOfUpdatableIds.slice(fromIndex, toIndex + 1);
	                                            context$4$0.next = 9;
	                                            return regeneratorRuntime.awrap(dispatch((0, _stateActions.updatePackagesFromConnective)(chunkOfIds)).then(function (statisticsOfSuccess) {
	                                                _this4.setState({ updatePackagesCurrentChunk: toIndex + 1 });
	                                            }));
	
	                                        case 9:
	
	                                            fromIndex = fromIndex + chunkSize;
	                                            toIndex = fromIndex + chunkSize;
	                                            toIndex = toIndex > maxIndex ? maxIndex : toIndex;
	                                            context$4$0.next = 5;
	                                            break;
	
	                                        case 14:
	                                        case 'end':
	                                            return context$4$0.stop();
	                                    }
	                                }, null, _this5);
	                            })());
	
	                        case 6:
	                        case 'end':
	                            return context$3$0.stop();
	                    }
	                }, null, _this6);
	            }).then(function () {
	                return _this6.simpleRefresh();
	            })['catch'](function (err) {
	                return onSubmit();
	            });
	        }
	
	        /**
	         * Will handle the situation when data from status column is not level arranged with the data from documentType
	         */
	    }, {
	        key: 'onDirectSignButtonClick',
	
	        /**
	        * This method will update package from connective reactivating the main sining link and opens the signing page from connective
	        * @param {*} packageId
	        */
	        value: function onDirectSignButtonClick(packageId) {
	            var dispatch, responseFromConnective, dsPackage, URLForSign;
	            return regeneratorRuntime.async(function onDirectSignButtonClick$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	                        context$2$0.next = 3;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updatePackagesFromConnective)([packageId])));
	
	                    case 3:
	                        responseFromConnective = context$2$0.sent;
	
	                        if (!responseFromConnective.success) {
	                            context$2$0.next = 11;
	                            break;
	                        }
	
	                        context$2$0.next = 7;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getOneDsPackageById)(packageId)));
	
	                    case 7:
	                        dsPackage = context$2$0.sent;
	                        URLForSign = _nestedProperty2['default'].get(dsPackage, "F2FSigningUrl");
	
	                        this.setState({ dsPackage: dsPackage });
	                        window.open(URLForSign, '_blank', 'noopener,noreferrer');
	
	                    case 11:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'onSendInvitationClick',
	        value: function onSendInvitationClick(packageId) {
	            var _props3, zoomTo, dispatch, dsPackage;
	
	            return regeneratorRuntime.async(function onSendInvitationClick$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props3 = this.props;
	                        zoomTo = _props3.zoomTo;
	                        dispatch = _props3.dispatch;
	                        context$2$0.next = 5;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getActualizedPackageForInvitation)(packageId)));
	
	                    case 5:
	                        dsPackage = context$2$0.sent;
	
	                        if (!dsPackage.error && (0, _libHelpers.canSendInvitation)(dsPackage)) {
	                            zoomTo(dsPackage, null, true);
	                        } else {
	                            this.setState({ reminderConfirmationModal: true, invitationBlocked: true });
	                            this.initModule();
	                        }
	
	                    case 7:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         *
	         * @param {function} onSubmit
	         * @returns
	         */
	    }, {
	        key: 'simpleRefresh',
	        value: function simpleRefresh() {
	            return regeneratorRuntime.async(function simpleRefresh$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        this.initModule();
	
	                    case 1:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Render waiting modal for update packages
	         */
	    }, {
	        key: 'updatePackagesModalContent',
	        value: function updatePackagesModalContent() {
	            var _this7 = this;
	
	            var _state5 = this.state;
	            var updatePackagesTotal = _state5.updatePackagesTotal;
	            var updatePackagesCurrentChunk = _state5.updatePackagesCurrentChunk;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].documentsModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].title },
	                    _("waitForRefreshPackages")
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _documentsScss2['default'].message },
	                    _("refreshPackagesProgress") + " " + updatePackagesCurrentChunk + "/" + updatePackagesTotal
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].documentsModalButtons },
	                    updatePackagesTotal !== updatePackagesCurrentChunk && _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                _this7.setState({ showUpdateWaitingModal: false, updatePackagesTotal: 0, updatePackagesCurrentChunk: 0 });
	                            },
	                            className: _documentsScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    updatePackagesTotal == updatePackagesCurrentChunk && _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this7.setState({ showUpdateWaitingModal: false, updatePackagesTotal: 0, updatePackagesCurrentChunk: 0 });
	                        },
	                        type: 'button',
	                        className: _documentsScss2['default'].greenButton,
	                        value: _("ok")
	                    })
	                )
	            );
	        }
	
	        /**
	         *
	         * @param {*} dsDocument
	         */
	    }, {
	        key: 'openLinkAndUploadWizard',
	        value: function openLinkAndUploadWizard(dsDocument) {
	            this.setState({ isOpenLinkDocumentModal: dsDocument });
	        }
	
	        /**
	         * Handles the sorting form packages
	         * @param {*} currentSort
	         * @returns
	         */
	    }, {
	        key: 'onSortChange',
	        value: function onSortChange(currentSort) {
	            if (currentSort) {
	                var sortParams = {
	                    column: currentSort.column,
	                    sortOrder: currentSort.direction
	                    // === 1? 'asc' : 'des'
	                };
	                var pageNumber = 0;
	                var _props4 = this.props;
	                var dispatch = _props4.dispatch;
	                var selectValue = _props4.selectValue;
	                var startDate = _props4.startDate;
	                var endDate = _props4.endDate;
	                var filter = _props4.filter;
	                var _state6 = this.state;
	                var itemsPerPage = _state6.itemsPerPage;
	                var filterableFields = _state6.filterableFields;
	
	                var paginationData = { sortParams: sortParams, pageNumber: pageNumber, itemsPerPage: itemsPerPage, filterableFields: filterableFields, filter: filter, filterFunction: selectValue, startDate: startDate, endDate: endDate };
	                return dispatch((0, _stateActions.getPaginatedPackagesList)(paginationData));
	            }
	        }
	    }, {
	        key: 'onPageChange',
	        value: function onPageChange(pageNumber) {
	            if ((pageNumber || pageNumber === 0) && pageNumber > -1) {
	                var _props5 = this.props;
	                var dispatch = _props5.dispatch;
	                var selectValue = _props5.selectValue;
	                var startDate = _props5.startDate;
	                var endDate = _props5.endDate;
	                var sortParams = _props5.sortParams;
	                var filter = _props5.filter;
	                var _state7 = this.state;
	                var itemsPerPage = _state7.itemsPerPage;
	                var filterableFields = _state7.filterableFields;
	                var staffList = _state7.staffList;
	                var brokerNumbersList = _state7.brokerNumbersList;
	
	                var paginationData = { sortParams: sortParams, pageNumber: pageNumber, itemsPerPage: itemsPerPage, filterableFields: filterableFields, filter: filter, filterFunction: selectValue, startDate: startDate, endDate: endDate, staffList: staffList, brokerNumbersList: brokerNumbersList };
	                return dispatch((0, _stateActions.getPaginatedPackagesList)(paginationData));
	            }
	        }
	    }, {
	        key: 'onFilterSelectorChange',
	        value: function onFilterSelectorChange(filterFunction) {
	            var _props6 = this.props;
	            var dispatch = _props6.dispatch;
	            var startDate = _props6.startDate;
	            var endDate = _props6.endDate;
	            var sortParams = _props6.sortParams;
	            var filter = _props6.filter;
	
	            var pageNumber = 0;
	            var _state8 = this.state;
	            var itemsPerPage = _state8.itemsPerPage;
	            var filterableFields = _state8.filterableFields;
	            var staffList = _state8.staffList;
	            var brokerNumbersList = _state8.brokerNumbersList;
	
	            var paginationData = { sortParams: sortParams, pageNumber: pageNumber, itemsPerPage: itemsPerPage, filterableFields: filterableFields, filter: filter, filterFunction: filterFunction, startDate: startDate, endDate: endDate, staffList: staffList, brokerNumbersList: brokerNumbersList };
	            return dispatch((0, _stateActions.getPaginatedPackagesList)(paginationData));
	        }
	    }, {
	        key: 'onDateFilterClick',
	        value: function onDateFilterClick(data) {
	            var _props7 = this.props;
	            var dispatch = _props7.dispatch;
	            var selectValue = _props7.selectValue;
	            var sortParams = _props7.sortParams;
	            var pageNumber = _props7.pageNumber;
	            var filter = _props7.filter;
	            var _state9 = this.state;
	            var itemsPerPage = _state9.itemsPerPage;
	            var filterableFields = _state9.filterableFields;
	            var staffList = _state9.staffList;
	            var brokerNumbersList = _state9.brokerNumbersList;
	
	            var startDate = data.startDate;
	            var endDate = data.endDate;
	            var paginationData = { sortParams: sortParams, pageNumber: pageNumber, itemsPerPage: itemsPerPage, filterableFields: filterableFields, filter: filter, filterFunction: selectValue, startDate: startDate, endDate: endDate, staffList: staffList, brokerNumbersList: brokerNumbersList };
	            return dispatch((0, _stateActions.getPaginatedPackagesList)(paginationData));
	        }
	    }, {
	        key: 'getPaginatedDataFromServer',
	        value: function getPaginatedDataFromServer() {
	            var _props8 = this.props;
	            var dispatch = _props8.dispatch;
	            var selectValue = _props8.selectValue;
	            var startDate = _props8.startDate;
	            var endDate = _props8.endDate;
	            var sortParams = _props8.sortParams;
	            var pageNumber = _props8.pageNumber;
	            var filter = _props8.filter;
	            var _state10 = this.state;
	            var itemsPerPage = _state10.itemsPerPage;
	            var filterableFields = _state10.filterableFields;
	            var staffList = _state10.staffList;
	            var brokerNumbersList = _state10.brokerNumbersList;
	
	            var paginationData = { sortParams: sortParams, pageNumber: pageNumber, itemsPerPage: itemsPerPage, filterableFields: filterableFields, filter: filter, filterFunction: selectValue, startDate: startDate, endDate: endDate, staffList: staffList, brokerNumbersList: brokerNumbersList };
	            return dispatch((0, _stateActions.getPaginatedPackagesList)(paginationData));
	        }
	    }, {
	        key: 'onFilterInputChange',
	        value: function onFilterInputChange(filterParam) {
	            var _props9, dispatch, selectValue, startDate, endDate, sortParams, pageNumber, _state11, itemsPerPage, filterableFields, staffList, brokerNumbersList, paginationData;
	
	            return regeneratorRuntime.async(function onFilterInputChange$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props9 = this.props;
	                        dispatch = _props9.dispatch;
	                        selectValue = _props9.selectValue;
	                        startDate = _props9.startDate;
	                        endDate = _props9.endDate;
	                        sortParams = _props9.sortParams;
	                        pageNumber = _props9.pageNumber;
	                        _state11 = this.state;
	                        itemsPerPage = _state11.itemsPerPage;
	                        filterableFields = _state11.filterableFields;
	                        staffList = _state11.staffList;
	                        brokerNumbersList = _state11.brokerNumbersList;
	                        paginationData = { sortParams: sortParams, pageNumber: pageNumber, itemsPerPage: itemsPerPage, filterableFields: filterableFields, filter: filterParam, filterFunction: selectValue, startDate: startDate, endDate: endDate, staffList: staffList, brokerNumbersList: brokerNumbersList };
	                        context$2$0.next = 15;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getPaginatedPackagesList)(paginationData)));
	
	                    case 15:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'renderDocumentDescription',
	        value: function renderDocumentDescription(onePackage) {
	
	            if (onePackage && onePackage.tarificationInfo) {
	
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentDescriptionSpan, title: onePackage.tarificationInfo.mainGroupDescription, key: 'mainGroupDescription' },
	                        '- ',
	                        onePackage.tarificationInfo.mainGroupDescription
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentDescriptionSpan, title: onePackage.tarificationInfo.riskDescription, key: 'riskDescription' },
	                        '- ',
	                        onePackage.tarificationInfo.riskDescription
	                    )
	                );
	            }
	
	            if (onePackage && onePackage.contractInfo) {
	
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentDescriptionSpan, title: onePackage.contractInfo.mainBranche, key: 'mainBranche' },
	                        '- ',
	                        onePackage.contractInfo.mainBranche
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentDescriptionSpan, title: onePackage.contractInfo.mainRisk, key: 'mainRisk' },
	                        '- ',
	                        onePackage.contractInfo.mainRisk
	                    )
	                );
	            }
	
	            if (onePackage && onePackage.claimInfo) {
	
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentDescriptionSpan, title: onePackage.claimInfo.insuranceCompany, key: 'insuranceCompany' },
	                        '- ',
	                        onePackage.claimInfo.insuranceCompany
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].documentDescriptionSpan, title: onePackage.claimInfo.qualification, key: 'qualification' },
	                        '- ',
	                        onePackage.claimInfo.qualification
	                    )
	                );
	            }
	        }
	
	        /**
	        * This function will navigate to the target module by entity id (contracts, claims)
	        * @param {object} dsdocument - dsdocument record
	        */
	    }, {
	        key: 'navigateTo',
	        value: function navigateTo(dsPackage) {
	            // navigateToModuleName, dynamicId, clientId, options)
	            var dispatch = this.props.dispatch;
	
	            // const { dsPackage } = this.state
	
	            var clientId = _nestedProperty2['default'].get(dsPackage, "clientId");
	            var contractId = _nestedProperty2['default'].get(dsPackage, "contractId");
	            var claimId = _nestedProperty2['default'].get(dsPackage, "claimId");
	            var tarificationId = _nestedProperty2['default'].get(dsPackage, "tarificationId");
	            var dynamicId = clientId;
	            var navigateToModuleName = '';
	
	            // navigate by uploaded on module value, not after contract or claim existence (BEWB-231)
	            if (dsPackage.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS) {
	                dynamicId = claimId;
	                navigateToModuleName = 'claims';
	            }
	
	            if (dsPackage.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT || dsPackage.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM) {
	                dynamicId = contractId;
	                navigateToModuleName = 'contracts';
	            }
	
	            if (dsPackage.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION) {
	                dynamicId = tarificationId;
	                navigateToModuleName = 'tarification';
	            }
	
	            // this next line of code (commented) can get clientId from oracle by contract or claim
	            // getClientId(contractId, claimId).then((clientId)=>{  })
	
	            dispatch((0, _stateActions.setAppModule)(c.CLIENTS, clientId));
	            dispatch((0, _stateActions.setOpenedSubmenu)(dynamicId, {})); // submenuOpened: claimId, subModuleZoom: {}
	            dispatch((0, _stateActions.setClientSubModule)(navigateToModuleName)); // subModule: 'claims' subModuleZoom: ''
	        }
	    }, {
	        key: 'render',
	
	        /**
	         * Render hook of react.
	         */
	        value: function render() {
	            var _this8 = this;
	
	            var _props10 = this.props;
	            var dispatch = _props10.dispatch;
	            var paginatedPackages = _props10.paginatedPackages;
	            var zoomTo = _props10.zoomTo;
	            var selectValue = _props10.selectValue;
	            var opened = _props10.opened;
	            var totalRecords = _props10.totalRecords;
	            var pageNumber = _props10.pageNumber;
	            var _props10$fields = _props10.fields;
	            var startDate = _props10$fields.startDate;
	            var endDate = _props10$fields.endDate;
	            var handleSubmit = _props10.handleSubmit;
	            var lang = _props10.lang;
	            var preSortDocumentsFromClient = _props10.preSortDocumentsFromClient;
	            var filter = _props10.filter;
	            var _state12 = this.state;
	            var visibilityOf = _state12.visibilityOf;
	            var archiveIsOpen = _state12.archiveIsOpen;
	            var statusExplainerIsOpen = _state12.statusExplainerIsOpen;
	            var showUpdateWaitingModal = _state12.showUpdateWaitingModal;
	            var isOpenLinkDocumentModal = _state12.isOpenLinkDocumentModal;
	            var isLoaded = _state12.isLoaded;
	            var itemsPerPage = _state12.itemsPerPage;
	            var canCreateMifid = _state12.canCreateMifid;
	            var reminderConfirmationModal = _state12.reminderConfirmationModal;
	            var reminderSentSuccessFlag = _state12.reminderSentSuccessFlag;
	            var invitationBlocked = _state12.invitationBlocked;
	
	            var checkedItemCount = paginatedPackages && paginatedPackages.reduce(function (sum, item) {
	                return sum + (item.checked ? 1 : 0);
	            }, 0);
	
	            var allSelected = paginatedPackages && paginatedPackages.length > 0 && paginatedPackages.every(function (item) {
	                return visibilityOf[item.id] ? item.checked : true;
	            });
	
	            // const allSelected = false
	            this.allSelected = allSelected;
	
	            var filteredDocuments = paginatedPackages && paginatedPackages.filter(function (item) {
	                return !item.hidden;
	            }).map(function (item) {
	                item.priority = (0, _moment2['default'])(item.createdAt).format("YYYYMMDDHHmmss");
	                return item;
	            });
	
	            // Needs to be defined here so translations are updated
	            var filterOptions = [{ value: 'showAll', label: _('showAll') }, { value: 'showDraft', label: _('showDraft') }, { value: 'showNotSigned', label: _('showNotSigned') }, { value: 'showSigned', label: _('showSigned') }, { value: 'showNotLinked', label: _('showNotLinked') }, { value: 'toSign', label: _('toSign') }];
	            if (!paginatedPackages) {
	                return false;
	            }
	
	            var onSubmit = handleSubmit(this.saveForm);
	
	            if (!isLoaded) {
	                return _react2['default'].createElement('div', null);
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _documentsScss2['default'].results + ' ' + (opened ? _documentsScss2['default'].hidden : 'visible') },
	                _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        onVisibleChange: this.handleVisibleList,
	                        topPaginationElemL: [_react2['default'].createElement(
	                            'div',
	                            { key: 'x1z', className: 'filterSelectContainer' },
	                            _react2['default'].createElement(_componentsSharedSelectSelectWrap2['default'], {
	                                key: 's',
	                                value: selectValue,
	                                options: filterOptions,
	                                onChange: function (v) {
	                                    // dispatch(filterDSDocuments(v.value, startDate.value, endDate.value))
	                                    _this8.onFilterSelectorChange(v.value);
	                                },
	                                className: _documentsScss2['default'].selectStyle
	                            })
	                        ), _react2['default'].createElement(_refreshBtn2['default'], {
	                            key: 'r',
	                            onClick: function () {
	                                _this8.getRemoteUpdateByChunks(onSubmit);
	                            }
	                        })],
	                        topPaginationElemR: this.archiveBtn(checkedItemCount, filteredDocuments),
	                        middlePagination: true,
	                        middlePaginationElem: [_react2['default'].createElement(
	                            'div',
	                            { className: _documentsScss2['default'].datePickerContainer, key: "pickerContainer" },
	                            _react2['default'].createElement(
	                                'form',
	                                { onSubmit: onSubmit },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: '' + _documentsScss2['default'].submitContainer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: '' + _documentsScss2['default'].inputContainer },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: '' + _documentsScss2['default'].label },
	                                            _react2['default'].createElement(
	                                                'p',
	                                                null,
	                                                _('fromDate')
	                                            )
	                                        ),
	                                        _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, _extends({ className: _documentsScss2['default'].inputForm
	                                        }, startDate, {
	                                            startDate: startDate.value,
	                                            endDate: endDate.value,
	                                            maxDate: endDate.value
	                                        }))
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: '' + _documentsScss2['default'].inputContainer },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: '' + _documentsScss2['default'].label },
	                                            _react2['default'].createElement(
	                                                'p',
	                                                null,
	                                                _('toDate')
	                                            )
	                                        ),
	                                        _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, _extends({
	                                            className: _documentsScss2['default'].inputForm
	                                        }, endDate, {
	                                            startDate: startDate.value,
	                                            endDate: endDate.value,
	                                            minDate: startDate.value
	                                        }))
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: '' + _documentsScss2['default'].inputContainer },
	                                        _react2['default'].createElement('input', { className: '' + _documentsScss2['default'].inputSubmit, type: 'button', onClick: onSubmit, value: _('filterDateBtn') })
	                                    )
	                                )
	                            )
	                        )],
	                        filterable: ["createdAt", "documentType", "clientName", "documentLocation", "status", "userFullName"],
	                        ref: function (el) {
	                            _this8.table = el;
	                        },
	                        id: 'table',
	                        className: 'table',
	                        sortable: [{ column: 'createdAt', sortFunction: 'Date' }, 'documentType', 'clientName', 'userFullName', { column: 'priority', sortFunction: 'Date' }, 'status'],
	                        defaultSort: {
	                            // column: 'createdAt',
	                            column: 'priority',
	                            direction: 'desc'
	                        },
	                        itemsPerPage: itemsPerPage,
	                        pageButtonLimit: 5,
	                        externalPagination: {
	                            totalRecords: totalRecords,
	                            currentPage: pageNumber,
	                            onPageChange: function onPageChange(pageNumber) {
	                                _this8.onPageChange(pageNumber);
	                            },
	                            onFilter: function onFilter(filterParam) {
	                                var timeoutId = _this8.state.inputTimeoutId;
	                                clearTimeout(timeoutId);
	                                var newTimeoutId = setTimeout(function callee$3$0() {
	                                    return regeneratorRuntime.async(function callee$3$0$(context$4$0) {
	                                        while (1) switch (context$4$0.prev = context$4$0.next) {
	                                            case 0:
	                                                this.onFilterInputChange(filterParam);
	
	                                            case 1:
	                                            case 'end':
	                                                return context$4$0.stop();
	                                        }
	                                    }, null, _this8);
	                                }, 1500);
	                                _this8.setState({ inputTimeoutId: newTimeoutId });
	                            },
	                            filter: filter
	                        },
	                        onSort: function (currentSort) {
	                            _this8.onSortChange(currentSort);
	                        }
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'priority',
	                                className: _documentsScss2['default'].hidden
	                            },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("priority")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'checkbox' },
	                            _react2['default'].createElement('input', { type: 'checkbox', checked: allSelected, onChange: function (e) {
	                                    _this8.handleCheckAll();
	                                }
	                            })
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'createdAt' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("createdAt")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'clientName' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("clientName")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'userFullName' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("userFullName")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'documentLocation' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("documentLocation")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'documentDescription' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("documentDescription")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'documentType' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("documentType")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'status' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("status")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'actions' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("actions")
	                            )
	                        )
	                    ),
	                    filteredDocuments.map(function (item, key) {
	                        var trStyleArchived = item.archived ? _documentsScss2['default'].archived + ' clickable' : 'clickable';
	                        var documentsNames = [];
	                        var documentsStatuses = [];
	                        var status = item && item.status || "";
	                        var itemStatusTranslated = _((0, _documentsHelpers.getStatusTranslationKey)(status));
	                        var itemStatusTranslatedSigned = _((0, _documentsHelpers.getStatusTranslationKey)(c.DS_PACKAGE_STATUS_FINISHED));
	                        var itemStatusTranslatedUploaded = _((0, _documentsHelpers.getStatusTranslationKey)(c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE));
	                        var _iteratorNormalCompletion8 = true;
	                        var _didIteratorError8 = false;
	                        var _iteratorError8 = undefined;
	
	                        try {
	                            for (var _iterator8 = item.dsDocuments[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                                var oneDoc = _step8.value;
	
	                                documentsNames.push({ name: oneDoc.documentTemplate ? oneDoc.documentTemplate.title[lang] : oneDoc.fileName, id: oneDoc._id });
	                                var statusToShow = status;
	                                var finalTranslatedValueForStatus = itemStatusTranslated;
	                                if (oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned || oneDoc.origin === "DS_ORIGIN_ORACLE" || oneDoc.origin === "DS_ORIGIN_LOCAL_UPLOAD") {
	                                    if (item.hasFinishStatus) {
	                                        finalTranslatedValueForStatus = itemStatusTranslatedSigned;
	                                        statusToShow = c.DS_PACKAGE_STATUS_FINISHED;
	                                    }
	                                } else {
	                                    if (oneDoc.uploadedToOracle) {
	                                        finalTranslatedValueForStatus = itemStatusTranslatedUploaded;
	                                        statusToShow = c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE;
	                                    }
	                                }
	                                documentsStatuses.push({ statusToShow: statusToShow, finalTranslatedValueForStatus: finalTranslatedValueForStatus, id: oneDoc._id });
	                            }
	                        } catch (err) {
	                            _didIteratorError8 = true;
	                            _iteratorError8 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion8 && _iterator8['return']) {
	                                    _iterator8['return']();
	                                }
	                            } finally {
	                                if (_didIteratorError8) {
	                                    throw _iteratorError8;
	                                }
	                            }
	                        }
	
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            {
	                                className: (0, _classnames2['default'])(trStyleArchived, _documentsScss2['default'].trFirstColumnHidden),
	                                i: item.id,
	                                key: key,
	                                onClick: function () {
	                                    zoomTo(item);
	                                }
	                            },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                {
	                                    column: 'priority',
	                                    value: item.priority
	                                },
	                                item.priority
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'checkbox', value: item._id },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { style: { width: 15 } },
	                                    _react2['default'].createElement('input', {
	                                        type: 'checkbox',
	                                        onClick: function (ev) {
	                                            return ev.stopPropagation();
	                                        },
	                                        onChange: function (ev) {
	                                            return _this8.check(ev, item._id);
	                                        },
	                                        checked: item.checked
	                                    })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'createdAt' },
	                                item.createdAt && (0, _moment2['default'])(item.createdAt).format("DD/MM/YYYY HH:mm:ss") || ""
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'clientName' },
	                                _this8.clientNameAndBrokerNumber(item)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'userFullName', value: item.userFullName },
	                                item.userFullName
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'documentLocation', value: item.uploadedOnModule },
	                                _react2['default'].createElement(
	                                    'a',
	                                    { className: _documentsScss2['default'].goToLinkTable,
	                                        onClick: function (e) {
	                                            e.stopPropagation();
	                                            _this8.navigateTo(item, false);
	                                        }
	                                    },
	                                    item.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS && item.claimNumber,
	                                    item.uploadedOnModule === c.DS_MODULE_CLAIM_WIZARD && item.claimNumber,
	                                    item.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT && item.contractNumber,
	                                    item.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM && item.contractNumber,
	                                    item.uploadedOnModule === c.DS_MODULE_CLIENT_PROFILE && item.clientNumber,
	                                    item.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION && item.tarificationNumber
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'documentDescription' },
	                                _this8.renderDocumentDescription(item)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'documentType', value: documentsNames },
	                                _react2['default'].createElement(
	                                    'div',
	                                    null,
	                                    documentsNames.map(function (oneElem, key) {
	                                        return _react2['default'].createElement(
	                                            'div',
	                                            { className: (0, _classnames2['default'])([_documentsScss2['default'].documentTypeSpan, 'docTypeParagraph']), 'data-documentIdAttr': oneElem.id, title: oneElem.name, key: key + 'docType' },
	                                            '- ',
	                                            oneElem.name
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'status', value: documentsStatuses },
	                                _react2['default'].createElement(
	                                    'div',
	                                    null,
	                                    documentsStatuses.map(function (oneStatus, key) {
	                                        return _react2['default'].createElement(
	                                            'p',
	                                            { className: (0, _classnames2['default'])([_documentsScss2['default'].marginBot, 'statusParagraph']), 'data-documentIdAttr': oneStatus.id, key: key + 'docStatus' },
	                                            _react2['default'].createElement(
	                                                'a',
	                                                { className: (0, _classnames2['default'])(_documentsScss2['default'].status),
	                                                    onClick: function (ev) {
	                                                        ev.stopPropagation();
	                                                        _this8.onItemStatusClick(oneStatus.statusToShow);
	                                                    } },
	                                                oneStatus.finalTranslatedValueForStatus
	                                            )
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'actions' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    null,
	                                    _react2['default'].createElement(_dsListButtonsWrapper2['default'], {
	                                        canCreateMifid: canCreateMifid,
	                                        zoomTo: zoomTo,
	                                        // zoomOut={zoomOut}
	                                        dsPackage: item || {},
	                                        isDsList: true,
	                                        method: function (dsDocument) {
	                                            return _this8.openLinkAndUploadWizard(dsDocument);
	                                        },
	                                        sendRemindersMethod: function (packageId) {
	                                            return _this8.onResendRemindersClick(packageId);
	                                        },
	                                        directSignMethod: function (id) {
	                                            return _this8.onDirectSignButtonClick(id);
	                                        },
	                                        showInvitation: true,
	                                        sendInvitationMethod: function (packageId) {
	                                            return _this8.onSendInvitationClick(packageId);
	                                        }
	                                    })
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: archiveIsOpen,
	                        style: _documentsHelpers.customModalStyles,
	                        contentLabel: ""
	                    },
	                    this.archiveAllPopup()
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: Boolean(statusExplainerIsOpen),
	                        style: _documentsHelpers.customModalStyles,
	                        contentLabel: ""
	                    },
	                    (0, _documentsHelpers.statusExplainerPopup)(_((0, _documentsHelpers.getStatusTranslationKey)(statusExplainerIsOpen)), _((0, _documentsHelpers.getStatusDescriptionTranslationKey)(statusExplainerIsOpen)), function () {
	                        _this8.setState({ statusExplainerIsOpen: false });
	                    }, _("ok"))
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        contentLabel: "",
	                        isOpen: Boolean(showUpdateWaitingModal),
	                        style: _documentsHelpers.customModalStyles
	                    },
	                    this.updatePackagesModalContent()
	                ),
	                _react2['default'].createElement(_linkToContractAndUploadDocumentsLinkDocumentsModal2['default'], {
	                    modalIsOpen: !!isOpenLinkDocumentModal,
	                    onCancel: function () {
	                        _this8.setState({ isOpenLinkDocumentModal: false });
	                        _this8.simpleRefresh();
	                    },
	                    onConfirmation: function () {
	                        _this8.setState({ isOpenLinkDocumentModal: false });
	                        _this8.simpleRefresh();
	                    },
	                    flag: 'LinkDocumentModal',
	                    payload: isOpenLinkDocumentModal ? {
	                        dsPackage: isOpenLinkDocumentModal
	                    } : {}
	                }),
	                _react2['default'].createElement(_reminderEmailStatusDialog2['default'], {
	                    isOpen: reminderConfirmationModal,
	                    success: reminderSentSuccessFlag,
	                    invitationBlocked: invitationBlocked,
	                    closeModal: function () {
	                        return _this8.setState({ reminderConfirmationModal: false });
	                    }
	                })
	            );
	        }
	    }]);
	
	    var _DSDocumentList = DSDocumentList;
	    DSDocumentList = (0, _reactRedux.connect)(function (_ref2) {
	        var _ref2$DSDocuments = _ref2.DSDocuments;
	        var filter = _ref2$DSDocuments.filter;
	        var selectValue = _ref2$DSDocuments.selectValue;
	        var modalIsOpen = _ref2$DSDocuments.modalIsOpen;
	        var opened = _ref2$DSDocuments.opened;
	        var subModule = _ref2$DSDocuments.subModule;
	        var startDate = _ref2$DSDocuments.startDate;
	        var endDate = _ref2$DSDocuments.endDate;
	        var preSortDocumentsFromClient = _ref2$DSDocuments.preSortDocumentsFromClient;
	        var templates = _ref2$DSDocuments.templates;
	        var packages = _ref2$DSDocuments.packages;
	        var sortParams = _ref2$DSDocuments.sortParams;
	        var pageNumber = _ref2$DSDocuments.pageNumber;
	        var _ref2$app = _ref2.app;
	        var lang = _ref2$app.lang;
	        var actions = _ref2$app.security.actions;
	        var brokers = _ref2.office.brokers;
	        return { filter: filter, sortParams: sortParams, pageNumber: pageNumber, selectValue: selectValue, modalIsOpen: modalIsOpen, opened: opened, subModule: subModule, startDate: startDate, endDate: endDate, preSortDocumentsFromClient: preSortDocumentsFromClient, lang: lang, templates: templates, packages: packages, brokers: brokers, actions: actions };
	    })(DSDocumentList) || DSDocumentList;
	    DSDocumentList = (0, _reduxForm.reduxForm)({
	        form: "DSDocumentList",
	        fields: ["startDate", "endDate"],
	        initialValues: {}
	    })(DSDocumentList) || DSDocumentList;
	    return DSDocumentList;
	})(_react2['default'].Component);
	
	exports['default'] = DSDocumentList;
	module.exports = exports['default'];

	/**
	 * This function wills handle the filter values of the form
	 */

	/**
	 * Resets any modification to style made by alignTableComponents method
	 */

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var DynamicImageComponent = (function (_Component) {
	    _inherits(DynamicImageComponent, _Component);
	
	    _createClass(DynamicImageComponent, null, [{
	        key: 'propTypes',
	        value: {
	            documentId: _react.PropTypes.string,
	            pageNumber: _react.PropTypes.number,
	            marginBottom: _react.PropTypes.number
	        },
	        enumerable: true
	    }]);
	
	    function DynamicImageComponent(props) {
	        _classCallCheck(this, DynamicImageComponent);
	
	        _get(Object.getPrototypeOf(DynamicImageComponent.prototype), 'constructor', this).call(this, props);
	        this.disableDragging = this.disableDragging.bind(this);
	        this.state = {};
	    }
	
	    _createClass(DynamicImageComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.disableDragging();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.disableDragging();
	        }
	    }, {
	        key: 'disableDragging',
	        value: function disableDragging() {
	            if (!this.imageElem) {
	                return;
	            }
	            this.imageElem.setAttribute('draggable', false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var documentId = _props.documentId;
	            var pageNumber = _props.pageNumber;
	            var marginBottom = _props.marginBottom;
	
	            return _react2['default'].createElement('img', {
	                width: "1000",
	                src: "api/documentToImages/" + documentId + "/" + pageNumber,
	                style: { marginBottom: marginBottom * 1 + "px" },
	                ref: function (input) {
	                    _this.imageElem = input;
	                },
	                'data-pdf-page': true,
	                'data-page-number': pageNumber
	            });
	        }
	    }]);
	
	    return DynamicImageComponent;
	})(_react.Component);
	
	exports['default'] = DynamicImageComponent;
	module.exports = exports['default'];

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dynamicImageComponent = __webpack_require__(1046);
	
	var _dynamicImageComponent2 = _interopRequireDefault(_dynamicImageComponent);
	
	var DynamicImageListComponent = (function (_Component) {
	    _inherits(DynamicImageListComponent, _Component);
	
	    _createClass(DynamicImageListComponent, null, [{
	        key: 'propTypes',
	        value: {
	            documentId: _react.PropTypes.string,
	            maxPageNumber: _react.PropTypes.number,
	            pageDistances: _react.PropTypes.number
	        },
	        enumerable: true
	    }]);
	
	    function DynamicImageListComponent(props) {
	        _classCallCheck(this, DynamicImageListComponent);
	
	        _get(Object.getPrototypeOf(DynamicImageListComponent.prototype), 'constructor', this).call(this, props);
	        this.state = {};
	    }
	
	    _createClass(DynamicImageListComponent, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var documentId = _props.documentId;
	            var maxPageNumber = _props.maxPageNumber;
	            var pageDistances = _props.pageDistances;
	
	            var rows = [];
	            for (var pageNumber = 1; pageNumber <= maxPageNumber; pageNumber++) {
	                rows.push(_react2['default'].createElement(_dynamicImageComponent2['default'], {
	                    key: "documentImages_" + documentId + "_" + pageNumber,
	                    documentId: documentId,
	                    pageNumber: pageNumber,
	                    marginBottom: pageDistances
	                }));
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                rows
	            );
	        }
	    }]);
	
	    return DynamicImageListComponent;
	})(_react.Component);
	
	exports['default'] = DynamicImageListComponent;
	module.exports = exports['default'];

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _popupOfSignaturePlaceholderScss = __webpack_require__(1581);
	
	var _popupOfSignaturePlaceholderScss2 = _interopRequireDefault(_popupOfSignaturePlaceholderScss);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _DSWizardHelper = __webpack_require__(124);
	
	var _DSWizardFormControl = __webpack_require__(596);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _xss = __webpack_require__(1015);
	
	var _xss2 = _interopRequireDefault(_xss);
	
	var _signaturePlaceholderSelector = __webpack_require__(1049);
	
	var _signaturePlaceholderSelector2 = _interopRequireDefault(_signaturePlaceholderSelector);
	
	var _dynamicImageListComponent = __webpack_require__(1047);
	
	var _dynamicImageListComponent2 = _interopRequireDefault(_dynamicImageListComponent);
	
	var _elementsReactSelect2Wrapper = __webpack_require__(374);
	
	var _elementsReactSelect2Wrapper2 = _interopRequireDefault(_elementsReactSelect2Wrapper);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	// init translations
	var _ = (0, _libI18n2['default'])('dswizard');
	var PAGE_DISTANCES = 50; // in pixel
	
	var PopupOfSignaturePlaceholder = (function (_Component) {
	    _inherits(PopupOfSignaturePlaceholder, _Component);
	
	    _createClass(PopupOfSignaturePlaceholder, null, [{
	        key: 'propTypes',
	        value: {
	            dataForEditDocument: _react.PropTypes.any,
	            packageDSDocuments: _react.PropTypes.array,
	            stakeholders: _react.PropTypes.array,
	            isOpen: _react.PropTypes.bool,
	            style: _react.PropTypes.object,
	            contentLabel: _react.PropTypes.string,
	            lang: _react.PropTypes.string,
	            dynamicFieldIdCursor: _react.PropTypes.number,
	            onCancel: _react.PropTypes.func,
	            onSave: _react.PropTypes.func,
	            didClose: _react.PropTypes.func,
	            setFieldIdCursor: _react.PropTypes.func,
	            getDocumentsFromStore: _react.PropTypes.func,
	            updatePackageDocuments: _react.PropTypes.func,
	            DSDocumentOriginTypes: _react.PropTypes.object
	        },
	        enumerable: true
	    }]);
	
	    function PopupOfSignaturePlaceholder(props) {
	        var _this = this;
	
	        _classCallCheck(this, _PopupOfSignaturePlaceholder);
	
	        _get(Object.getPrototypeOf(_PopupOfSignaturePlaceholder.prototype), 'constructor', this).call(this, props);
	
	        this.handleScroll = function (e) {
	            _this.scrollPositionY = e.currentTarget.scrollTop;
	            _this.scrollPositionX = e.currentTarget.scrollLeft;
	            return e;
	        };
	
	        this.setScrollContainerRef = function (ref) {
	            _this.scrollContainer = ref;
	        };
	
	        this.scrollContainerRef = null;
	        this.scrollPositionX = 0;
	        this.scrollPositionY = 0;
	        this.scrollId = 0;
	
	        this.state = { placeholders: [], jumpersState: {} };
	    }
	
	    _createClass(PopupOfSignaturePlaceholder, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var _this2 = this;
	
	            // placeholder handler
	            var _props = this.props;
	            var dataForEditDocument = _props.dataForEditDocument;
	            var stakeholders = _props.stakeholders;
	
	            var dataForEditDocumentOld = prevProps.dataForEditDocument;
	
	            if (dataForEditDocument) {
	                var dsDocument = dataForEditDocument.dsDocument;
	                var maxPageNumber = dataForEditDocument.maxPageNumber;
	                var pageSizeList = dataForEditDocument.pageSizeList;
	
	                // try to get old document from previous props
	                var dsDocumentOld = undefined;
	                if (dataForEditDocumentOld && dataForEditDocumentOld.dsDocument) {
	                    dsDocumentOld = dataForEditDocumentOld.dsDocument;
	                }
	
	                // init placeholder selector
	                // detect if a new document is opened. The component is mounted, so we have to check the
	                // opened document._id to know if another one is opened.
	                if (dsDocument && dsDocument._id && (!dsDocumentOld || dsDocument._id !== dsDocumentOld._id)) {
	                    var idForDOMElement = c.DSDOC_PLACEHOLDER_ELEMENT_REF + dsDocument._id;
	
	                    // new instance of tool, require reset the scroll
	                    this.scrollPositionX = 0;
	                    this.scrollPositionY = 0;
	
	                    this.signaturePlaceholderSelector = new _signaturePlaceholderSelector2['default'](stakeholders, idForDOMElement, maxPageNumber, PAGE_DISTANCES, pageSizeList,
	
	                    // flushUpdates function provided for the coordinate selector tool
	                    function (placeholders) {
	                        return _this2.receivePlaceholder(placeholders);
	                    });
	                }
	
	                if (!prevProps.isOpen && this.props.isOpen) {
	                    // modal reopened, require reset the scroll
	                    this.scrollPositionX = 0;
	                    this.scrollPositionY = 0;
	
	                    // clear unwanted placeholders leaved in the tool instance
	                    this.signaturePlaceholderSelector.deleteAllPlaceholders();
	
	                    // reload placeholders
	                    var placeholders = dsDocument.signatureManualPlaceholders;
	
	                    // reload already saved placeholders
	                    if (placeholders) {
	                        (function () {
	                            var that = _this2;
	                            var deppCloneOfPlaceholders = JSON.parse(JSON.stringify(placeholders));
	
	                            // set timeout to wait until render page.
	                            var timeoutId = setTimeout(function () {
	                                for (var i = 0; i < deppCloneOfPlaceholders.length; i++) {
	                                    that.signaturePlaceholderSelector.createSignaturePlaceholder(deppCloneOfPlaceholders[i], false, function (placeholder) {
	                                        //console.log("PLACEHOLDERS: ",this.signaturePlaceholderSelector.getPlaceholders())
	                                    }, true);
	                                }
	
	                                clearTimeout(timeoutId);
	                            }, 0);
	                        })();
	                    }
	                }
	            }
	        }
	
	        /**
	         * This function will be fired in react component when the coordinate selector flush the changes.
	         * @param {*} placeholders
	         */
	    }, {
	        key: 'receivePlaceholder',
	        value: function receivePlaceholder(placeholders) {
	            var _this3 = this;
	
	            this.setState({ placeholders: placeholders }, function () {
	                // scroll handler
	                if (_this3.scrollContainer) {
	                    _this3.scrollContainer.scrollTop = _this3.scrollPositionY;
	                    _this3.scrollContainer.scrollLeft = _this3.scrollPositionX;
	                }
	            });
	        }
	
	        /**
	         * This function will find the package Id in a ds document record, even if the packageId is a populated prop or mongoose model.
	         * @param {*} dsDocument
	         * @returns
	         */
	    }, {
	        key: 'getPackageIdFromDsDocument',
	        value: function getPackageIdFromDsDocument(dsDocument) {
	            var packageId = undefined;
	            if (typeof dsDocument.packageId === "string") {
	                packageId = dsDocument.packageId;
	            } else {
	                if (typeof dsDocument.packageId === "object" && dsDocument.packageId._id) {
	                    packageId = dsDocument.packageId._id;
	                } else {
	                    // nothing to do
	                    packageId = dsDocument.packageId;
	                    console.warn("No valid packageId is set for DsDocument in save-DocumentPlaceholders function.");
	                }
	            }
	
	            return packageId;
	        }
	
	        /**
	         * This function will update a document in database when the placeholder are saved.
	         * @param {*} dsDocument
	         * @param {*} dsDocument
	         * @param {*} totalNumberOfSigners
	         * @returns
	         */
	    }, {
	        key: 'saveDocumentPlaceholders',
	        value: function saveDocumentPlaceholders(dsDocument, totalNumberOfSigners) {
	            var _props2, dispatch, lang, dynamicFieldIdCursor, setFieldIdCursor, getDocumentsFromStore, updatePackageDocuments, DSDocumentOriginTypes, errorMessages, isValid, packageId, updateThisValue, updatedDocument, docsFromProps, packageDSDocuments, attachIdResult;
	
	            return regeneratorRuntime.async(function saveDocumentPlaceholders$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        lang = _props2.lang;
	                        dynamicFieldIdCursor = _props2.dynamicFieldIdCursor;
	                        setFieldIdCursor = _props2.setFieldIdCursor;
	                        getDocumentsFromStore = _props2.getDocumentsFromStore;
	                        updatePackageDocuments = _props2.updatePackageDocuments;
	                        DSDocumentOriginTypes = _props2.DSDocumentOriginTypes;
	                        errorMessages = [];
	                        isValid = (0, _DSWizardHelper.isValidDocument)(dsDocument, totalNumberOfSigners, DSDocumentOriginTypes);
	
	                        if (!isValid) {
	                            errorMessages.push(_("signaturePlaceholdersAreNotSetCorrectly"));
	                        }
	
	                        packageId = this.getPackageIdFromDsDocument(dsDocument);
	                        updateThisValue = {
	                            _id: dsDocument._id,
	                            signatureManualPlaceholders: this.signaturePlaceholderSelector.getPlaceholders(),
	                            errorMessages: errorMessages
	                        };
	                        context$2$0.next = 15;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.upsertDSDocumentAndFetchAllData)({ documentData: updateThisValue })));
	
	                    case 15:
	                        updatedDocument = context$2$0.sent;
	
	                        dynamicFieldIdCursor = 1;
	
	                        // refresh state packageDSDocuments from props "documents" by packageId, because after
	                        // the API call of upsertDSDocumentAndFetchAllData the documents are reloaded in store
	                        docsFromProps = getDocumentsFromStore();
	                        packageDSDocuments = (0, _DSWizardHelper.filterDocumentsByPackageId)(docsFromProps, packageId);
	                        attachIdResult = (0, _DSWizardFormControl.packageDocumentsAttachIdCursor)(packageDSDocuments, dynamicFieldIdCursor, true);
	
	                        packageDSDocuments = attachIdResult.packageDSDocuments;
	                        setFieldIdCursor(attachIdResult.dynamicFieldIdCursor);
	
	                        // add or overwrite the affected document in list of documents
	                        packageDSDocuments = (0, _DSWizardFormControl.packageDocumentsListUpdateByDocument)(packageDSDocuments, updatedDocument); //sync
	
	                        context$2$0.next = 25;
	                        return regeneratorRuntime.awrap(updatePackageDocuments(packageDSDocuments));
	
	                    case 25:
	                        return context$2$0.abrupt('return', updatedDocument);
	
	                    case 26:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Add new signature placeholder on iframe
	         * @returns
	         */
	    }, {
	        key: 'startSelectCoordinate',
	        value: function startSelectCoordinate() {
	            if (!this.signaturePlaceholderSelector) {
	                return;
	            }
	
	            // initial values, optional
	            var placeholderRecord = {
	                width: this.signaturePlaceholderSelector.MINIMUM_PLACEHOLDER_WIDTH_PTS, // 112, // -min width
	                height: this.signaturePlaceholderSelector.MINIMUM_PLACEHOLDER_HEIGHT_PTS };
	
	            // 70 // -min height
	            this.signaturePlaceholderSelector.createSignaturePlaceholder(placeholderRecord, true, function (placeholder) {
	                //     console.log("Placeholder released!", placeholder)
	                //     console.log(this.signaturePlaceholderSelector.getPlaceholders())
	            });
	        }
	    }, {
	        key: 'getBinIcon',
	        value: function getBinIcon() {
	            try {
	                return __webpack_require__(569);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'getMoveIcon',
	        value: function getMoveIcon() {
	            try {
	                return __webpack_require__(954);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'getResizeIcon',
	        value: function getResizeIcon() {
	            try {
	                return __webpack_require__(534);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'getJumpIcon',
	        value: function getJumpIcon() {
	            try {
	                return __webpack_require__(529);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'renderPlaceholder',
	        value: function renderPlaceholder(placeholder, placeholders, stakeholders) {
	            var _this4 = this;
	
	            var stakeOptionsList = [];
	            var selectedSigner = undefined;
	
	            // add select options, must be recalculated in each render, because the option list is dynamic
	            // depends on the already selected signers by other placeholders
	            for (var i = 0; i < stakeholders.length; i++) {
	                var oneStake = stakeholders[i];
	                var signerTypeSelectOpt = {};
	
	                signerTypeSelectOpt.label = oneStake.firstName + " " + oneStake.lastName + " [" + oneStake.email + "]";
	                signerTypeSelectOpt.value = oneStake._id;
	
	                // set selected the loaded value if exists
	                if (placeholder.stakeholderId && String(placeholder.stakeholderId) === String(oneStake._id)) {
	                    signerTypeSelectOpt.selected = true;
	                    selectedSigner = signerTypeSelectOpt;
	                }
	
	                // checking if the current selectOption is selected by this placeholder, what is rendering by this function now
	                var currentIdIsUsedByThisActualSelectInput = String(signerTypeSelectOpt.value) === String(placeholder.stakeholderId);
	
	                // check the rest of the placeholders to filter the used options
	                var canAddTheOptionToTheList = true;
	
	                // Do not check if someone is used because of BEWB-743 (vwrsion 8.2 recuirement)!!!
	                // for (let j=0; j < placeholders.length; j++) {
	                //     let onePlaceholder = placeholders[j]
	
	                //     // checking the current selectOption, if already selected by some of the placeholders
	                //     let currentIdIsAlreadyUsed = String(onePlaceholder.stakeholderId) === String(signerTypeSelectOpt.value)
	
	                //     // the exclude condition for a selectOption of the actual dropdown
	                //     if ( currentIdIsAlreadyUsed && !currentIdIsUsedByThisActualSelectInput ) {
	                //         canAddTheOptionToTheList = false
	                //     }
	                // }
	
	                // add option to the list if not already taken by other placeholder than this, or not selected by this select input
	                if (canAddTheOptionToTheList) {
	                    stakeOptionsList.push(signerTypeSelectOpt);
	                }
	            }
	
	            // prepare helper values to calculate coordinates and sizes
	            var pageTop = this.signaturePlaceholderSelector.getPageTop(placeholder.placedOnPage);
	            var xMultiplier = this.signaturePlaceholderSelector.getXMultiplier(placeholder);
	            var yMultiplier = this.signaturePlaceholderSelector.getYMultiplier(placeholder);
	
	            return _react2['default'].createElement(
	                'div',
	                {
	                    key: placeholder.id,
	                    id: placeholder.id,
	                    className: _popupOfSignaturePlaceholderScss2['default'].pHolderBody,
	                    style: {
	                        width: placeholder.width / xMultiplier + "px",
	                        height: placeholder.height / yMultiplier + "px",
	                        left: placeholder.x / xMultiplier + "px",
	                        top: placeholder.y / yMultiplier + pageTop + "px"
	                    },
	                    draggable: false
	                },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        key: placeholder.id + "remove_button",
	                        id: placeholder.id + "remove_button",
	                        className: (0, _classnames2['default'])(_popupOfSignaturePlaceholderScss2['default'].pHolderDotButton, _popupOfSignaturePlaceholderScss2['default'].buttonRemove),
	                        draggable: false,
	                        onMouseDown: function (e) {
	                            console.log("onMouseDownclicked");
	                        },
	                        onClick: function (e) {
	                            if (_this4.signaturePlaceholderSelector) {
	                                _this4.signaturePlaceholderSelector.removeSignaturePlaceholder(placeholder.id);
	                            }
	                        }
	                    },
	                    _react2['default'].createElement('img', {
	                        src: this.getBinIcon(),
	                        className: _popupOfSignaturePlaceholderScss2['default'].buttonRemoveIcon,
	                        draggable: false,
	                        onDragStart: function (e) {
	                            e.preventDefault();
	                            return false;
	                        }
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        key: placeholder.id + "move_button",
	                        id: placeholder.id + "move_button",
	                        className: (0, _classnames2['default'])(_popupOfSignaturePlaceholderScss2['default'].pHolderDotButton, _popupOfSignaturePlaceholderScss2['default'].buttonMove),
	                        draggable: false,
	                        onMouseDown: function () {
	                            _this4.signaturePlaceholderSelector.moveStart(placeholder.id);
	                        },
	                        onMouseUp: function () {
	                            _this4.signaturePlaceholderSelector.moveStop();
	                        }
	                    },
	                    _react2['default'].createElement('img', {
	                        src: this.getMoveIcon(),
	                        className: _popupOfSignaturePlaceholderScss2['default'].buttonMoveIcon,
	                        draggable: false,
	                        onDragStart: function (e) {
	                            e.preventDefault();
	                            return false;
	                        }
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        key: placeholder.id + "resize_button",
	                        id: placeholder.id + "resize_button",
	                        className: (0, _classnames2['default'])(_popupOfSignaturePlaceholderScss2['default'].pHolderDotButton, _popupOfSignaturePlaceholderScss2['default'].buttonResize),
	                        draggable: false,
	                        onMouseDown: function () {
	                            _this4.signaturePlaceholderSelector.resizeStart(placeholder.id);
	                        },
	                        onMouseUp: function () {
	                            _this4.signaturePlaceholderSelector.resizeStop();
	                        }
	                    },
	                    _react2['default'].createElement('img', {
	                        src: this.getResizeIcon(),
	                        className: _popupOfSignaturePlaceholderScss2['default'].buttonResizeIcon,
	                        draggable: false,
	                        onDragStart: function (e) {
	                            e.preventDefault();
	                            return false;
	                        }
	                    })
	                ),
	                _react2['default'].createElement(_elementsReactSelect2Wrapper2['default'], {
	                    key: placeholder.id + "selectedSignerSelectInput",
	                    value: selectedSigner,
	                    className: _popupOfSignaturePlaceholderScss2['default'].pHolderSelect,
	                    openMenuOnFocus: true,
	                    customStyles: {
	                        menu: function menu(base) {
	                            return _extends({}, base, {
	                                borderRadius: 2,
	                                hyphens: "auto",
	                                marginTop: 0,
	                                textAlign: "left",
	                                wordWrap: "break-word",
	                                fontSize: "16px",
	                                lineHeight: "16px",
	                                height: "auto",
	                                padding: "2px",
	                                margin: "2px"
	                            });
	                        },
	                        menuList: function menuList(base) {
	                            return _extends({}, base, {
	                                padding: 0,
	                                verticalAlign: "baseline",
	                                backgroundColor: "rgba(255,255,255,1)",
	                                height: "max-content"
	                            });
	                        },
	                        option: function option(base, state) {
	                            return _extends({}, base, {
	                                padding: 0,
	                                fontSize: '0.80em',
	                                maxHeight: "max-content"
	                            });
	                        }
	                    },
	                    draggable: false,
	                    onDragStart: function (e) {
	                        e.preventDefault();
	                        return false;
	                    },
	                    onBlur: function (e) {
	                        var /* value, */onChange = _this4.props.onChange;
	
	                        if (onChange && typeof onChange === "function") {
	                            onChange({ label: e.target.value, value: e.target.value });
	                        }
	
	                        return e.target.value;
	                    },
	                    onChange: function (value) {
	                        var thisPlaceholder = _this4.signaturePlaceholderSelector.getPlaceholderByIdFromList(placeholder.id);
	
	                        var alreadyUsedSigners = _this4.signaturePlaceholderSelector._placeholders.map(function (item) {
	                            return item.stakeholderId;
	                        });
	
	                        // prevent to select a value what is selected by others
	                        //if (alreadyUsedSigners.indexOf(newSelectedValue) == -1) {
	                        thisPlaceholder.stakeholderId = value.value;
	
	                        // notify the tool about change
	                        _this4.signaturePlaceholderSelector.updateSignaturePlaceholder(placeholder);
	
	                        //} else {
	
	                        // avoid to change
	                        //    e.preventDefault();
	                        //}
	                    },
	                    options: stakeOptionsList,
	                    placeholder: _("pleaseSelectASigner"),
	                    onBlurResetsInput: false
	                }),
	                _react2['default'].createElement(
	                    'span',
	                    {
	                        key: placeholder.id + "page_number_text_holder",
	                        id: placeholder.id + "page_number_text_holder",
	                        className: _popupOfSignaturePlaceholderScss2['default'].pageNumberHolderTextContainer,
	                        draggable: false
	                    },
	                    _("pageNumberOfPlaceholder"),
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            key: placeholder.id + this.signaturePlaceholderSelector.ELEMENT_ID_POSTFIX_FOR_PAGE_NUMBER_VALUE,
	                            id: placeholder.id + this.signaturePlaceholderSelector.ELEMENT_ID_POSTFIX_FOR_PAGE_NUMBER_VALUE,
	                            className: _popupOfSignaturePlaceholderScss2['default'].pageNumberHolderText,
	                            draggable: false
	                        },
	                        placeholder.placedOnPage + "/" + this.signaturePlaceholderSelector._totalPageNumber
	                    )
	                )
	            );
	        }
	
	        /**
	         * Render a jumper button to jump to the placeholder
	         * @param {*} placeholder
	         * @param {*} placeholdersMap
	         * @returns
	         */
	    }, {
	        key: 'renderPlaceholderJumpers',
	        value: function renderPlaceholderJumpers(placeholder, placeholdersMap) {
	            var _this5 = this;
	
	            var stakeholders = this.props.stakeholders;
	            var jumpersState = this.state.jumpersState;
	
	            var usedXTimes = jumpersState && jumpersState[placeholder.stakeholderId] ? jumpersState[placeholder.stakeholderId] : 0;
	            var samePholders = placeholdersMap[placeholder.stakeholderId];
	            var indexOfThisPlaceholder = 0;
	
	            for (var i = 0; i < samePholders.length; i++) {
	                if (samePholders[i].id === placeholder.id) {
	                    indexOfThisPlaceholder = i;
	                    break;
	                }
	            }
	
	            var renderOnlyOnIndex = usedXTimes % samePholders.length;
	
	            // skip if not the right index by incremental counter
	            if (indexOfThisPlaceholder !== renderOnlyOnIndex) {
	                return _react2['default'].createElement('div', { key: "nothing_to_render" + placeholder.id });
	            }
	
	            var signerName = "";
	            var signerAddress = "";
	
	            // add select options
	            for (var i = 0; i < stakeholders.length; i++) {
	                var oneStake = stakeholders[i];
	
	                if (String(placeholder.stakeholderId) === String(oneStake._id)) {
	                    signerName = oneStake.firstName + " " + oneStake.lastName;
	                    signerAddress = oneStake.email;
	                }
	            }
	
	            if (!signerAddress) {
	                return _react2['default'].createElement('div', { key: "nothing_to_render" + placeholder.id });
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                {
	                    key: placeholder.id + "_jumper_button_key",
	                    id: placeholder.id + "_jumper_button",
	                    className: _popupOfSignaturePlaceholderScss2['default'].jumpButton,
	                    draggable: false,
	                    onClick: function (e) {
	                        _this5.scrollId = (0, _uuidV42['default'])();
	
	                        _this5.increaseJumperIndex(placeholder);
	
	                        _this5.scrollTo(placeholder, _this5.scrollId);
	                    }
	                },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        className: _popupOfSignaturePlaceholderScss2['default'].jumpButtonText,
	                        key: placeholder.id + "JumperButtonNameKey" },
	                    signerName
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        className: _popupOfSignaturePlaceholderScss2['default'].jumpButtonIconHolder,
	                        key: placeholder.id + "JumperIconNameKey"
	                    },
	                    _react2['default'].createElement('img', {
	                        src: this.getJumpIcon(),
	                        className: _popupOfSignaturePlaceholderScss2['default'].jumpButtonIcon,
	                        style: {
	                            display: "block",
	                            pointerEvents: "none",
	                            userSelect: "none"
	                        },
	                        draggable: false,
	                        onDragStart: function (e) {
	                            e.preventDefault();
	                            return false;
	                        }
	                    })
	                )
	            );
	        }
	
	        /**
	         * Lerp scroll to signature placeholder
	         * @param {*} placeholder
	         * @param {*} scrollId - In case of new scroll started, the old scroll lerp thread must be killed. This id let to check himself in recursion to kill it or not.
	         */
	    }, {
	        key: 'scrollTo',
	        value: function scrollTo(placeholder, scrollId) {
	            var lastX = arguments.length <= 2 || arguments[2] === undefined ? -1 : arguments[2];
	            var lastY = arguments.length <= 3 || arguments[3] === undefined ? -1 : arguments[3];
	
	            var that = this;
	            var timeoutId = setTimeout(function () {
	                if (!that.scrollContainer) {
	                    return;
	                }
	
	                // calc the target
	                var limitY = Math.max(that.scrollContainer.scrollHeight, that.scrollContainer.offsetHeight);
	                var limitX = Math.max(that.scrollContainer.scrollWidth, that.scrollContainer.offsetWidth);
	                var targetY = limitY <= placeholder.scrollYToBeVisible ? limitY : placeholder.scrollYToBeVisible;
	                var targetX = limitX <= placeholder.scrollXToBeVisible ? limitX : placeholder.scrollXToBeVisible;
	
	                // do the partial scroll
	                that.scrollContainer.scrollTop += (targetY - that.scrollContainer.scrollTop) / 10;
	                that.scrollContainer.scrollLeft += (targetX - that.scrollContainer.scrollLeft) / 10;
	
	                // cut off the veri small end steps
	                if (Math.abs(targetY - that.scrollContainer.scrollTop) < 5) {
	                    that.scrollContainer.scrollTop = targetY;
	                }
	                if (Math.abs(targetX - that.scrollContainer.scrollLeft) < 5) {
	                    that.scrollContainer.scrollLeft = targetX;
	                }
	
	                // conditions to continue the recursion
	                // check if reached the target positions
	                if ((that.scrollContainer.scrollTop !== targetY || that.scrollContainer.scrollLeft !== targetX) &&
	                // check if other scroll not started parallel
	                that.scrollId === scrollId && (
	                // check if te scroll is stuck because shorter available scroll space like what was saved
	                lastX !== that.scrollContainer.scrollLeft || that.scrollContainer.scrollTop !== lastY)) {
	                    // recursive call
	                    that.scrollTo(placeholder, scrollId, that.scrollContainer.scrollLeft, that.scrollContainer.scrollTop);
	                }
	
	                clearTimeout(timeoutId);
	            }, 5);
	        }
	    }, {
	        key: 'increaseJumperIndex',
	        value: function increaseJumperIndex(placeholder) {
	            var jumpersState = this.state.jumpersState;
	
	            jumpersState[placeholder.stakeholderId] = jumpersState[placeholder.stakeholderId] ? jumpersState[placeholder.stakeholderId] + 1 : 1;
	
	            this.setState({ jumpersState: jumpersState });
	        }
	
	        /**
	         * Content of are you sure modal
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props3 = this.props;
	            var dataForEditDocument = _props3.dataForEditDocument;
	            var stakeholders = _props3.stakeholders;
	            var style = _props3.style;
	            var isOpen = _props3.isOpen;
	            var contentLabel = _props3.contentLabel;
	            var didClose = _props3.didClose;
	            var onCancel = _props3.onCancel;
	            var onSave = _props3.onSave;
	            var packageDSDocuments = _props3.packageDSDocuments;
	            var placeholders = this.state.placeholders;
	
	            if (!dataForEditDocument || !dataForEditDocument.dsDocument) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    '...'
	                );
	            }
	
	            // for placeholder creator tool
	            var dsDocument = dataForEditDocument.dsDocument;
	            var idForDOMElement = c.DSDOC_PLACEHOLDER_ELEMENT_REF + dsDocument._id;
	            var pageSizeList = dataForEditDocument.pageSizeList;
	            var maxPageNumber = dataForEditDocument.maxPageNumber;
	            var totalNumberOfSigners = stakeholders.length;
	
	            // update doc instance from the state
	            dsDocument = (0, _DSWizardHelper.findDocumentFromListById)(dsDocument._id, packageDSDocuments);
	
	            var docLang = _nestedProperty2['default'].get(dsDocument, "language");
	            var langIndex = docLang === 'nl' ? 0 : docLang === 'fr' ? 1 : 2;
	            var popupTitle = _nestedProperty2['default'].get(dsDocument, "documentTemplate.title." + (docLang || 'nl'));
	            // Do not check max number of signer placeholder because of BEWB-743 (vwrsion 8.2 recuirement)!!!
	            var placeholderCountIsFull = false; //!!(stakeholders.length <= placeholders.length)
	
	            var placeholdersMap = {};
	            placeholders.forEach(function (placeholder) {
	                // init
	                placeholdersMap[placeholder.stakeholderId] = placeholdersMap[placeholder.stakeholderId] ? placeholdersMap[placeholder.stakeholderId] : [];
	
	                placeholdersMap[placeholder.stakeholderId].push(placeholder);
	            });
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: isOpen,
	                    style: style,
	                    contentLabel: contentLabel,
	                    key: "PlaceholderComposerModalKey"
	                },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2['default'])(_documentsScss2['default'].documentsModalContent, _documentsScss2['default'].maximizeModalContent),
	                        key: dsDocument._id + Math.random(),
	                        id: 'templateHolderDiv'
	                    },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _documentsScss2['default'].title },
	                        _('fillDocumentModalTitle') + " - " + popupTitle
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_documentsScss2['default'].formInputContainer, _documentsScss2['default'].titleLabel),
	                            key: 'selectSignaturePlaceholderDocumentModalContentTitleKey' },
	                        _('selectSignaturePlaceholderModalContent')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            key: 'documentImagesMainContainerKey',
	                            className: _documentsScss2['default'].documentImagesMainContainer
	                        },
	                        _react2['default'].createElement(
	                            'div',
	                            {
	                                key: 'selectSignaturePlaceholderOnImageList_MainContainerKey',
	                                className: _documentsScss2['default'].imageListContainer,
	                                width: '100%',
	                                id: c.DSDOC_PLACEHOLDER_ELEMENT_REF + dsDocument._id,
	
	                                ref: function (ref) {
	                                    return _this6.setScrollContainerRef(ref);
	                                },
	                                onScroll: function (e) {
	                                    return _this6.handleScroll(e);
	                                },
	
	                                onMouseMove: function (e) {
	                                    if (_this6.signaturePlaceholderSelector) {
	                                        _this6.signaturePlaceholderSelector.containerOnMouseMove(e);
	                                    }
	                                },
	                                onMouseUp: function (e) {
	                                    // event must persist until the call stack will be empty and the callback queue will run
	                                    e.persist();
	
	                                    // wait to flush the react vDOM to the browsers DOM
	                                    var timeoutId = setTimeout(function () {
	                                        if (_this6.signaturePlaceholderSelector) {
	                                            _this6.signaturePlaceholderSelector.containerOnMouseUp(e);
	                                        }
	
	                                        clearTimeout(timeoutId);
	                                    }, 0);
	                                },
	                                onClick: function (e) {
	                                    // event must persist until the call stack will be empty and the callback queue will run
	                                    e.persist();
	
	                                    // wait to flush the react vDOM to the browsers DOM
	                                    var timeoutId = setTimeout(function () {
	                                        if (_this6.signaturePlaceholderSelector) {
	                                            _this6.signaturePlaceholderSelector.containerOnClick(e);
	                                        }
	
	                                        clearTimeout(timeoutId);
	                                    }, 0);
	                                }
	                            },
	                            _react2['default'].createElement(_dynamicImageListComponent2['default'], {
	                                documentId: dsDocument._id,
	                                maxPageNumber: maxPageNumber,
	                                pageDistances: PAGE_DISTANCES,
	                                handleScroll: function (detail, view) {
	                                    return _this6.handleScroll(detail, view);
	                                }
	                            }),
	                            placeholders && placeholders.map(function (placeholder) {
	                                return _this6.renderPlaceholder(placeholder, placeholders, stakeholders);
	                            })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _popupOfSignaturePlaceholderScss2['default'].placeholdersModalButtons },
	                        _react2['default'].createElement(
	                            'div',
	                            { key: 'jumpHolders', className: _popupOfSignaturePlaceholderScss2['default'].jumpButtonsHolder },
	                            _react2['default'].createElement(
	                                'div',
	                                { key: "jumpToText", className: _popupOfSignaturePlaceholderScss2['default'].jumpButtonsLabel },
	                                placeholders && placeholders.length ? _('jumpToPlaceholder') : ""
	                            ),
	                            placeholders && placeholders.map(function (placeholder) {
	                                return _this6.renderPlaceholderJumpers(placeholder, placeholdersMap);
	                            })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            {
	                                className: _popupOfSignaturePlaceholderScss2['default'].greenButton + (placeholderCountIsFull ? " disabled" : ""),
	                                disabled: placeholderCountIsFull,
	                                onClick: function () {
	                                    // abort if all of the placeholders are added
	                                    if (placeholderCountIsFull) {
	                                        return;
	                                    }
	
	                                    // add new placeholder
	                                    _this6.startSelectCoordinate();
	                                }
	                            },
	                            "+" + _("addSignaturePlaceholder")
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            {
	                                onClick: function () {
	                                    _this6.scrollPositionX = 0;
	                                    _this6.scrollPositionY = 0;
	                                    _this6.signaturePlaceholderSelector && _this6.signaturePlaceholderSelector.deleteAllPlaceholders();
	
	                                    onCancel();
	                                    didClose();
	                                },
	                                className: _popupOfSignaturePlaceholderScss2['default'].cancel
	                            },
	                            _("cancel")
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            {
	                                onClick: function (e) {
	                                    var that = _this6;
	                                    _this6.saveDocumentPlaceholders(dsDocument, totalNumberOfSigners).then(function (updatedDocument) {
	                                        that.scrollPositionX = 0;
	                                        that.scrollPositionY = 0;
	                                        that.signaturePlaceholderSelector.deleteAllPlaceholders();
	                                        didClose(updatedDocument);
	                                    })['catch'](function (err) {
	                                        that.scrollPositionX = 0;
	                                        that.scrollPositionY = 0;
	                                        that.signaturePlaceholderSelector.deleteAllPlaceholders();
	                                        console.error(err);
	                                        didClose(err.error);
	                                    });
	                                },
	                                className: _documentsScss2['default'].greenButton + " enabled"
	                            },
	                            _("save")
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _PopupOfSignaturePlaceholder = PopupOfSignaturePlaceholder;
	    PopupOfSignaturePlaceholder = (0, _reactRedux.connect)(function (state) {
	        return {};
	    })(PopupOfSignaturePlaceholder) || PopupOfSignaturePlaceholder;
	    return PopupOfSignaturePlaceholder;
	})(_react.Component);
	
	exports['default'] = PopupOfSignaturePlaceholder;
	module.exports = exports['default'];

	// return final promise: resolved if template filled correctly else reject it.
	/*<div className={stylesPHolder.jumpButtonText}>{signerAddress}</div>*/

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	/**
	 * This class can work together with a react component, what provide react elements and their synthetic events
	 * to work together to place signature placeholders on documents.
	 *
	 * A document means a base DOM element with image elements, what represents the pages of the document.
	 * Each page IMG tag must contains the following data attributes:
	 * data-pdf-page = <boolean> - must be set to "true", else the page  is not taken in consideration as a document page.
	 * data-page-number = <number> - page number, counted from 1 (this value currently out of order)
	 *
	 * The events of the container elements must be connected with the specific functions of the class:
	 * moveStart(), moveStop(), resizeStart(), resizeStop(), containerOnClick(), containerOnMouseMove(), containerOnMouseUp().
	 *
	 * Most of this event handlers require the event (synthetic event of react) as argument to identify the "currentTarget" elements.
	 * Few of the event-handles can work only if the react rendering is done. Current solution is the event handlers are fired using
	 * setTimeout() function with 0 millisecond, what cause, the function will arrive in the callback queue of the Javascript Event loop,
	 * and will be fired only when the CallStack is empty, what means the render is over. If there is a better solution, like a react hook
	 * (componentDidRender - not exists) that is welcome.
	 *
	 * Can be fetched the created placeholders in an array by ->getPlaceholders().
	 * A placeholder have a data-model declared in the class body named: _placeholderTemplate (object).
	 * (Take care if you want to extend or modify ot, the database maybe contains already saved data in the original structure.)
	 *
	 * The functions and class attributes what starts with "_" (underscore) are considered as private, and the rest is public.
	 */
	
	var SignaturePlaceholderSelector = (function () {
	
	    /**
	     * This is the constructor of a placeholder selector system.
	     *
	     * @param {*} stakeholders
	     * @param {String} elementId The id of a dome element what parenting the signature placeholder selector
	     * @param {*} pageNumber
	     * @param {*} pageDistances
	     * @param {*} pageSizeList
	     * @param {function} flushUpdate
	     */
	
	    function SignaturePlaceholderSelector(stakeholders, elementId, pageNumber, pageDistances, pageSizeList, flushUpdate) {
	        _classCallCheck(this, SignaturePlaceholderSelector);
	
	        this._stakeholders = [];
	        this._placeholders = [];
	        this._totalPageNumber = 1;
	        this._pageDistances = 0;
	        this._pageSizeList = [];
	        this._pageImageSizeList = [];
	        this.ELEMENT_ID_POSTFIX_FOR_PAGE_NUMBER_VALUE = "_page_number_value";
	        this.MINIMUM_PLACEHOLDER_WIDTH_PTS = 112;
	        this.MINIMUM_PLACEHOLDER_HEIGHT_PTS = 70;
	        this.OPERATION_RESIZE = "RESIZE";
	        this.OPERATION_MOVE = "MOVE";
	        this.OPERATION_NONE = "NONE";
	        this.MOUSE_SHIFT_X = 19;
	        this.MOUSE_SHIFT_Y = 19;
	        this._placeholderTemplate = {
	            id: "",
	            x: 0,
	            y: 0,
	            width: this.MINIMUM_PLACEHOLDER_WIDTH_PTS,
	            height: this.MINIMUM_PLACEHOLDER_HEIGHT_PTS,
	            signerType: null,
	            stakeholderId: null,
	            callBackOnDrop: null,
	            element: null,
	            totalPages: null,
	            placedOnPage: null,
	            pageSizeOfOriginalPDF: null,
	            pageImageInfo: {
	                naturalWidth: 0,
	                naturalHeight: 0,
	                src: '',
	                width: 0,
	                height: 0
	            },
	            // extra
	            scrollXToBeVisible: 0,
	            scrollYToBeVisible: 0
	        };
	        this._activePlaceholderId = null;
	        this._activeOperation = this.OPERATION_NONE;
	        this._containerElement = null;
	        this._wasPlaceholderModified = false;
	
	        this._flushUpdateCallback = function () {
	            console.warn("No onUpdate function set by external React component");
	        };
	
	        this._targetDOMElementId = elementId;
	        this._totalPageNumber = pageNumber;
	        this._pageDistances = pageDistances;
	        this._stakeholders = stakeholders;
	        this._pageSizeList = pageSizeList;
	        this._flushUpdateCallback = flushUpdate;
	    }
	
	    /**
	     * Create a new signature placeholder instance.
	     * @param {*} placeholderRecord - preset values for placeholder (like the final )
	     * @param {Function} callBackOnDrop - optional
	     * @returns The new placeholder instance created for a signature.
	     */
	
	    _createClass(SignaturePlaceholderSelector, [{
	        key: "createSignaturePlaceholder",
	        value: function createSignaturePlaceholder() {
	            var placeholderRecord = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	            var isItActive = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	            var callBackOnDrop = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	            var forceAdd = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	            if (this._activePlaceholderId && !forceAdd) {
	                // console.log("Can not add new element until you don't put on place the active one.")
	                return;
	            }
	
	            // init new placeholder
	            var placeholder = this._generatePlaceholder(placeholderRecord);
	            // add to the collection list of placeholders
	            this._addPlaceholderToTheList(placeholder);
	
	            placeholder.callBackOnDrop = callBackOnDrop;
	
	            // set active the new placeholder
	            if (isItActive) {
	                this._activePlaceholderId = placeholder.id;
	                this._activeOperation = this.OPERATION_MOVE;
	            }
	
	            // notify parent component
	            this._flushUpdateCallback(this._placeholders);
	
	            return placeholder;
	        }
	
	        /**
	         * This function will update the placeholder in the list of placeholders by iterating the properties.
	         * @param {*} placeholderData
	         * @returns
	         */
	    }, {
	        key: "updateSignaturePlaceholder",
	        value: function updateSignaturePlaceholder(placeholderData) {
	            if (!placeholderData.id) {
	                console.warn("Can not update placeholder without id. -> updateSignaturePlaceholder()");
	                return;
	            }
	
	            var placeholder = this.getPlaceholderByIdFromList(placeholderData.id);
	
	            // iterate over the properties of the placeholderData object
	            for (var property in placeholderData) {
	                if (property === "id") {
	                    continue;
	                }
	
	                if (placeholderData.hasOwnProperty(property)) {
	                    // update the property in the target object if it exists
	                    if (placeholder.hasOwnProperty(property)) {
	                        placeholder[property] = placeholderData[property];
	                    }
	                }
	            }
	
	            this._setPlaceholderByIdInList(placeholderData.id, placeholder);
	            this._flushUpdateCallback(this._placeholders);
	
	            return placeholder;
	        }
	
	        /**
	         * Remove an placeholder element by id.
	         * @param {String} id The unique id of a placeholder to remove
	         * @returns Bool - true if success, else false (id not found).
	         */
	    }, {
	        key: "removeSignaturePlaceholder",
	        value: function removeSignaturePlaceholder(id) {
	            var arrayIndexToRemove = -1;
	
	            // find the element to remove
	            for (var i = 0; i < this._placeholders.length; i++) {
	                if (this._placeholders[i].id === id) {
	                    arrayIndexToRemove = i;
	                    break;
	                }
	            }
	
	            // check if not found the id in the list
	            if (arrayIndexToRemove === -1) {
	                return false;
	            }
	
	            // remove the actual element
	            this._placeholders.splice(arrayIndexToRemove, 1);
	
	            // if the removed element is the active one, stop to update it
	            if (this._activePlaceholderId == id) {
	                this._activePlaceholderId = null;
	            }
	
	            // notify external tool
	            this._flushUpdateCallback(this._placeholders);
	
	            return false;
	        }
	
	        /**
	         * This function will clear all the placeholders from class instance and from the DOM as well.
	         * Reset all of the operations. Clear flags if there is any.
	         */
	    }, {
	        key: "deleteAllPlaceholders",
	        value: function deleteAllPlaceholders() {
	            this._placeholders = [];
	
	            this._activePlaceholderId = null;
	            this._wasPlaceholderModified = false;
	
	            this._stopAnyOperation();
	
	            // notify external tool
	            this._flushUpdateCallback(this._placeholders);
	        }
	
	        /**
	         * Blank click on container, can release an active placeholder
	         * @param {*} event
	         * @returns
	         */
	    }, {
	        key: "containerOnClick",
	        value: function containerOnClick(event) {
	            // let containerElement = event.currentTarget
	
	            if (!this._activePlaceholderId) {
	                return;
	            }
	
	            var placeholder = this.getPlaceholderByIdFromList(this._activePlaceholderId);
	
	            if (!placeholder) {
	                return;
	            }
	
	            // fire callback
	            if (typeof placeholder.callBackOnDrop === 'function') {
	                placeholder.callBackOnDrop(placeholder);
	            }
	
	            // stop updating the placeholder by set it inactive
	            this._activePlaceholderId = null;
	        }
	
	        /**
	         * This function is for handling the mouse move, and fetching information fro event.
	         * This is a wrapper for the main update function of this class.
	         * @param {*} event React synthetic event
	         * @returns
	         */
	    }, {
	        key: "containerOnMouseMove",
	        value: function containerOnMouseMove(event) {
	            return this._update(event);
	        }
	
	        /**
	         * This event is good to do an update on react virtual dome.
	         * The _flushUpdateCallback is an external callback function, what must
	         * contain a render update (setState, dispatch, forceRefresh) to proceed a permanent
	         * update on DOM elements
	         * @param {*} event Not used yet - react synthetic event
	         * @returns
	         */
	    }, {
	        key: "containerOnMouseUp",
	        value: function containerOnMouseUp(event) {
	            if (this._wasPlaceholderModified) {
	                this._wasPlaceholderModified = false;
	                return this._flushUpdateCallback(this._placeholders);
	            }
	        }
	
	        /**
	         * This is the start event of the element of the resize button.
	         * @param {*} id - placeholder element id (not mongo id, this is the unique id provided by this tool on create)
	         */
	    }, {
	        key: "resizeStart",
	        value: function resizeStart(id) {
	            if (!this._activePlaceholderId) {
	                this._activePlaceholderId = id;
	                this._activeOperation = this.OPERATION_RESIZE;
	            }
	        }
	
	        /**
	         * This is the stop event of the element of the resize button.
	         */
	    }, {
	        key: "resizeStop",
	        value: function resizeStop() {
	            this._stopAnyOperation();
	        }
	
	        /**
	         * This is the start event of the element of the move button.
	         * @param {*} id - placeholder element id (not mongo id, this is the unique id provided by this tool on create)
	         */
	    }, {
	        key: "moveStart",
	        value: function moveStart(id) {
	            if (!this._activePlaceholderId) {
	                this._activePlaceholderId = id;
	                this._activeOperation = this.OPERATION_MOVE;
	            }
	        }
	
	        /**
	         * This is the stop event of the element of the move button.
	         */
	    }, {
	        key: "moveStop",
	        value: function moveStop() {
	            this._stopAnyOperation();
	        }
	
	        /**
	         * General function what stop any active operation
	         */
	    }, {
	        key: "_stopAnyOperation",
	        value: function _stopAnyOperation() {
	            this._activePlaceholderId = null;
	            this._activeOperation = this.OPERATION_NONE;
	        }
	
	        /**
	         * This is an update method onMouseMove event, this update the placeholder, respecting the
	         * operation type
	         * @param {*} event
	         * @returns
	         */
	    }, {
	        key: "_update",
	        value: function _update(event) {
	            var containerElement = event.currentTarget;
	
	            this._pageImageSizeList = this.getAllImageInfo();
	
	            // no active placeholder tha do nothing
	            if (!this._activePlaceholderId) {
	                return;
	            }
	
	            var placeholder = this.getPlaceholderByIdFromList(this._activePlaceholderId);
	
	            if (!placeholder) {
	                console.error("Placeholder not found in the list by ID: this._activePlaceholderId = ", this._activePlaceholderId);
	                console.table(this._placeholders);
	                return;
	            }
	
	            if (!this._pageSizeList || this._pageSizeList.length === 0) {
	                console.error("Page size limit is ", this._pageSizeList);
	                return;
	            }
	
	            // This comment is a Quote from StackOverflow what can help when we want to test
	            // in different browsers:
	            // "Document sizes are a browser compatibility nightmare because,
	            // although all browsers expose clientHeight and scrollHeight properties,
	            // they don't all agree how the values are calculated.
	            // There used to be a complex best-practice formula around for
	            // how you tested for correct height/width. This involved using document.documentElement
	            // properties if available or falling back on document properties and so on.
	            // The simplest way to get correct height is to get all height values
	            // found on document, or documentElement, and use the highest one. This is basically what jQuery does:"
	
	            // get scrolling state
	            var scrollX = containerElement.scrollLeft; // containerElement.scrollY ||
	            var scrollY = containerElement.scrollTop; //containerElement.scrollX ||
	
	            // prepare debug text for signature
	            // let debugCoords = "Signature here! </br>"
	            // debugCoords += "Mouse X: " + (x) + ", Y: " + (y) + "</br>"
	            // debugCoords += "Iframe H: " + Math.round(height) + ", W: " + Math.round(width) + "</br>"
	            // debugCoords += "Iframe scrollX: " + (scrollX) + ", scrollY: " + (scrollY) + "</br>"
	
	            var containerElementViewportOffset = containerElement && containerElement.getBoundingClientRect();
	            var containerY = containerElementViewportOffset.top; // same as x, but with negative width will be x + width
	            var containerX = containerElementViewportOffset.left; // same as y, but with negative height will be y + height
	
	            // let containerFullHeight = Math.max(containerElementViewportOffset.height, containerElement.clientHeight, containerElement.scrollHeight, containerElement.offsetHeight);
	            // the containerFullHeight does not contain the page margin, so we add one
	            // TODO check in all browsers
	            // containerFullHeight += this._pageDistances
	
	            var mouseX = event.clientX * 1 || event.pageX * 1;
	            var mouseY = event.clientY * 1 || event.pageY * 1;
	
	            // get mouse coordinates
	            var mouseOriginX = mouseX - containerX;
	            var mouseOriginY = mouseY - containerY;
	
	            var mouseDocumentPosX = mouseOriginX + scrollX;
	            var mouseDocumentPosY = mouseOriginY + scrollY;
	
	            var mouseIsOnPageNumber = this._getPageNumberByCoordinates(mouseDocumentPosY);
	
	            // placed on page
	            placeholder.pageSizeOfOriginalPDF = this._pageSizeList && this._pageSizeList[mouseIsOnPageNumber - 1] || {};
	
	            var xMultiplier = this.getXMultiplier(placeholder);
	            var yMultiplier = this.getYMultiplier(placeholder);
	
	            // console.log("xMultiplier", xMultiplier)
	            // console.log("yMultiplier", yMultiplier)
	
	            // syncing coordinates for active placeholder
	            switch (this._activeOperation) {
	
	                // when the placeholder moving
	                case this.OPERATION_MOVE:
	                    {
	                        // placed on page
	                        placeholder.placedOnPage = mouseIsOnPageNumber;
	
	                        placeholder.x = this.snapXToPageWidth(mouseDocumentPosX - this.MOUSE_SHIFT_X, // displayed scale
	                        placeholder.width / xMultiplier, // displayed scale (ptsW to display scale)
	                        mouseIsOnPageNumber) * xMultiplier; // scale to pts (save the final usable value for PDF, no further calculations for connective)
	
	                        var currentPageTop = this.getPageTop(mouseIsOnPageNumber);
	                        placeholder.y = this.snapYToPageHeight(mouseDocumentPosY - this.MOUSE_SHIFT_Y - currentPageTop, placeholder.height / yMultiplier, mouseIsOnPageNumber) * yMultiplier; // scale to pts (save the final usable value for PDF, no further calculations for connective)
	
	                        // this checking is permited only in case of move
	                        placeholder.pageImageInfo = this.getImageInfoUnderCoordinates(mouseX, mouseY);
	
	                        // to be able to scroll on the same place in the document to find it.
	                        placeholder.scrollXToBeVisible = scrollX;
	                        placeholder.scrollYToBeVisible = scrollY;
	
	                        // set the flag to true to know, must be flushed the modifications
	                        // this is important, to avoid unnecessary rerenders, what make impossible to use dropdowns inside
	                        this._wasPlaceholderModified = true;
	
	                        break;
	                    }
	
	                // when the placeholder is resizing
	                case this.OPERATION_RESIZE:
	                    {
	                        var currentPageTop = this.getPageTop(placeholder.placedOnPage);
	
	                        var notScaledWidth = mouseDocumentPosX - placeholder.x / xMultiplier; // displayed pixels scale
	                        var notScaledHeight = mouseDocumentPosY - (placeholder.y / yMultiplier + currentPageTop); // displayed pixels scale
	                        var notScaledX = placeholder.x / xMultiplier; // displayed pixels scale
	                        var notScaledY = placeholder.y / yMultiplier + currentPageTop; // displayed pixels scale
	
	                        placeholder.width = this.snapWidthToPageBorder(notScaledX, // displayed pixels scale
	                        notScaledWidth, // displayed pixels scale
	                        placeholder.placedOnPage, xMultiplier // for scale to pts
	                        ) * xMultiplier;
	
	                        placeholder.height = this.snapHeightToPageBorder(notScaledY, // displayed pixels scale
	                        notScaledHeight, // displayed pixels scale
	                        placeholder.placedOnPage, yMultiplier // for scale to pts
	                        ) * yMultiplier;
	
	                        // set the flag to true to know, must be flushed the modifications
	                        // this is important, to avoid unnecessary rerenders, what make impossible to use dropdowns inside
	                        this._wasPlaceholderModified = true;
	
	                        break;
	                    }
	            }
	
	            placeholder.totalPages = this._totalPageNumber;
	
	            // modify directly the DOM elements, to avoid rerender in react, to make persist the changes
	            // must call the _flushUpdateCallback.
	            this._updateDOMHtml(placeholder, xMultiplier, yMultiplier);
	        }
	
	        /**
	         * This function put a newly wished X coordinates between the borders of a page.
	         * @param {*} x // on displayed scale
	         * @param {*} rectangleWidth  // on displayed scale
	         * @param {*} pageNumber
	         * @returns corrected x in displayed image scale (not natural pixels, not pts)
	         */
	    }, {
	        key: "snapXToPageWidth",
	        value: function snapXToPageWidth(x, rectangleWidth, pageNumber) {
	            var pageWidth = this._getPageWidth(pageNumber); // displayed scale
	            var result = x > pageWidth - rectangleWidth ? pageWidth - rectangleWidth : x;
	            return Math.round(result < 0 ? 0 : result);
	        }
	
	        /**
	         * This function put a newly wished Y coordinates between the borders of a page.
	         * @param {*} y
	         * @param {*} rectangleHeight
	         * @param {*} pageNumber
	         * @returns Corrected Y coordinate in pixels on displayed image scale (not natural pixels, not pts)
	         * This is relative Y coordinate to the page top.
	         */
	    }, {
	        key: "snapYToPageHeight",
	        value: function snapYToPageHeight(y, rectangleHeight, pageNumber) {
	            // get the top of the page
	            // let pageBeforeCurrent = (pageNumber-1 > 0) ? pageNumber-1 : 0
	            // let upperPageBottom = pageBeforeCurrent !== 0 ? this.getPageBottom(pageBeforeCurrent) : 0 // on displayed scale
	            var currentPageTop = this.getPageTop(pageNumber); // on displayed scale
	            var currentPageBottom = this.getPageBottom(pageNumber); // on displayed scale
	
	            // calculate absolute height
	            y = y + currentPageTop;
	
	            // calculate result snapped to the page bottom if that does not fit under the Y coord
	            var result = y > currentPageBottom - rectangleHeight ? currentPageBottom - rectangleHeight : y;
	
	            // calculate relative Y on current page
	            result = result - currentPageTop;
	
	            return Math.round(result < 0 ? 0 : result);
	        }
	
	        /**
	         * This function put a newly wished WIDTH size between the borders of a page.
	         * @param {*} x
	         * @param {*} rectangleWidth
	         * @param {*} pageNumber
	         * @param {*} xMultiplier
	         * @returns
	         */
	    }, {
	        key: "snapWidthToPageBorder",
	        value: function snapWidthToPageBorder(x, rectangleWidth, pageNumber, xMultiplier) {
	            var pageWidth = this._getPageWidth(pageNumber); // displayed pixels scale
	
	            var resultRectangleWidth = x + rectangleWidth > pageWidth ? pageWidth - x : rectangleWidth;
	
	            var ptsRectangleWidth = resultRectangleWidth * xMultiplier;
	            var displaySizeScaledMinWidth = this.MINIMUM_PLACEHOLDER_WIDTH_PTS / xMultiplier;
	            // put the result in between the minimal limits
	            if (ptsRectangleWidth < this.MINIMUM_PLACEHOLDER_WIDTH_PTS) {
	                resultRectangleWidth = displaySizeScaledMinWidth;
	            }
	
	            // rounding result, no half pixels
	            return Math.round(resultRectangleWidth);
	        }
	
	        /**
	         * This function put a newly wished HEIGHT size between the borders of a page.
	         * @param {*} y // display scale Y coordinate (absolute) from the (y=)0 coord from the first page
	         * @param {*} rectangleHeight // display scale (px)
	         * @param {*} currentPageNumber // pae number where is placed the placeholder
	         * @param {*} yMultiplier // for scale to PDF pts
	         * @returns
	         */
	    }, {
	        key: "snapHeightToPageBorder",
	        value: function snapHeightToPageBorder(y, rectangleHeight, currentPageNumber, yMultiplier) {
	            var currentPageBottom = this.getPageBottom(currentPageNumber);
	
	            var resultRectangleHeight = y + rectangleHeight > currentPageBottom ? currentPageBottom - y : rectangleHeight;
	
	            var ptsRectangleHeight = resultRectangleHeight * yMultiplier; // convert to PDF pts scale
	            var displaySizeScaledMinHeight = this.MINIMUM_PLACEHOLDER_HEIGHT_PTS / yMultiplier; // convert to display scale
	
	            // put the result in between minimal limits
	            if (ptsRectangleHeight < this.MINIMUM_PLACEHOLDER_HEIGHT_PTS) {
	                resultRectangleHeight = displaySizeScaledMinHeight;
	            }
	
	            // rounding result, no half pixels
	            return Math.round(resultRectangleHeight);
	        }
	
	        /**
	         * This function will calculate the ratio between the original image width and the displayed image width.
	         * This is a normalized value, so the 1 means the two images have the same width, 2 means the original image
	         * is twice wider than the displayed.
	         * @param {*} placeholder
	         * @returns
	         */
	    }, {
	        key: "getXMultiplier",
	        value: function getXMultiplier(placeholder) {
	            var naturalScale = placeholder.pageImageInfo.naturalWidth / placeholder.pageImageInfo.width;
	            var pdfScale = placeholder.pageSizeOfOriginalPDF.pointx / placeholder.pageImageInfo.naturalWidth * naturalScale;
	            return pdfScale;
	        }
	
	        /**
	         * This function will calculate the ratio between the original image height and the displayed image height.
	         * This is a normalized value, so the 1 means the two images have the same height, 2 means the original image
	         * is twice longer than the displayed.
	         */
	    }, {
	        key: "getYMultiplier",
	        value: function getYMultiplier(placeholder) {
	            var naturalScale = placeholder.pageImageInfo.naturalHeight / placeholder.pageImageInfo.height;
	            var pdfScale = placeholder.pageSizeOfOriginalPDF.pointy / placeholder.pageImageInfo.naturalHeight * naturalScale;
	            return pdfScale;
	        }
	
	        /**
	         * This function determine the information about an IMG element, what is under the given coordinates.
	         * If there are more images under the coordinates, then first match returned.
	         * Only marked images detected with specific attributes: "data-pdf-page" = true.
	         * No reason yet to check other images that the first matched result.
	         * @param {*} x
	         * @param {*} y
	         * @returns
	         */
	    }, {
	        key: "getImageInfoUnderCoordinates",
	        value: function getImageInfoUnderCoordinates(x, y) {
	            var containerElement = this._getContainer();
	            var images = containerElement.getElementsByTagName("img");
	
	            // console.log("getImageInfoUnderCoordinates: containerElement ", containerElement)
	            // console.log("getImageInfoUnderCoordinates: images ", images)
	
	            var theCastedImage = {};
	
	            for (var i = 0; i < images.length; i++) {
	                var oneImage = images[i];
	
	                // filtering out the "none page images", what maybe are used as accessories or tools icons.
	                if (!oneImage.getAttribute("data-pdf-page")) {
	                    continue;
	                }
	
	                // check if the image is under the coordinates and break from the loop
	                // first match returned
	                var rectObject = oneImage.getBoundingClientRect();
	                if (y >= rectObject.top && y <= rectObject.bottom + this._pageDistances && x >= rectObject.left && x <= rectObject.right) {
	                    theCastedImage = oneImage;
	                    break;
	                }
	            }
	
	            // console.log("getImageInfoUnderCoordinates: page nr:", theCastedImage.getAttribute("data-page-number"))
	
	            return theCastedImage && {
	                naturalWidth: theCastedImage.naturalWidth,
	                naturalHeight: theCastedImage.naturalHeight,
	                src: theCastedImage.src,
	                width: theCastedImage.width,
	                height: theCastedImage.height
	            };
	        }
	
	        /**
	         * Find all marked IMG html tags inside the inner part of the container element.
	         * Only marked images detected with specific attributes: "data-pdf-page" = true.
	         * All image information about the Bounding Client Rect are pushed in the result array.
	         * @returns Array [<DOMRect>, <DOMRect>, ...] in order of elements of DOM.
	         */
	    }, {
	        key: "getAllImageInfo",
	        value: function getAllImageInfo() {
	            var containerElement = this._getContainer();
	            var images = containerElement.getElementsByTagName("img");
	            var imageInfoList = [];
	
	            for (var i = 0; i < images.length; i++) {
	                var oneImage = images[i];
	                if (!oneImage.getAttribute("data-pdf-page")) {
	                    continue;
	                }
	
	                var rectObject = oneImage.getBoundingClientRect();
	                imageInfoList.push(rectObject);
	            }
	
	            return imageInfoList;
	        }
	
	        /**
	         * Calculate page number using page heights, page distances and Y coordinate of signature.
	         * The result never be lower than 1 ( the y = 0 coordinate still the first page).
	         * The result never be higher than the total count of pages.
	         * @param {*} y pos of the mouse
	         * @returns
	         */
	    }, {
	        key: "_getPageNumberByCoordinates",
	        value: function _getPageNumberByCoordinates(y) {
	            var pageNumber = 1;
	
	            // --- original solution ---
	            // use this: this._pageSizeList
	            // let pagNumber = Math.ceil(y / (onePageHeight + this._pageDistances))
	
	            // --- calculation solution --- not finished
	            var accumulativeHeight = 0;
	            var lastAccumulativeHeight = 0;
	
	            for (var i = 0; i < this._pageSizeList.length; i++) {
	                var aPageSize = this._pageSizeList[i]; // "{\"pointx\":%w,\"pointy\":%h,\"dpix\":%x,\"dpiy\":%y},"
	                var anImageSize = this._pageImageSizeList[i]; // rectObj
	
	                // save the page bottom on a step before
	                lastAccumulativeHeight = accumulativeHeight;
	
	                // calculate current page bottom
	                accumulativeHeight += anImageSize.height + this._pageDistances;
	
	                // check if the Y coord is in between
	                if (y > lastAccumulativeHeight && y < accumulativeHeight) {
	                    pageNumber = i + 1;
	                    break;
	                }
	            }
	
	            // --- img tag attribute value kind solutions --- not working of the mouse is outward the page
	
	            // let containerElement = this._ getContainer()
	            // let images = containerElement.getElementsByTagName("img")
	            // let theCastedImage = null
	            // for (let i=0; i < images.length; i++) {
	            //     let oneImage = images[i]
	            //     if (!oneImage.getAttribute("data-pdf-page")) {
	            //         continue;
	            //     }
	
	            //     let rectObject = oneImage.getBoundingClientRect();
	
	            //     if(
	            //         y >= rectObject.top && y <= (rectObject.bottom + this._pageDistances) &&
	            //         x >= rectObject.left && x <= rectObject.right
	            //     ) {
	            //         theCastedImage = oneImage
	            //         break
	            //     }
	            // }
	
	            // pageNumber = theCastedImage && theCastedImage.getAttribute("data-page-number") || 0
	
	            pageNumber = pageNumber < 1 ? 1 : pageNumber;
	            pageNumber = pageNumber > this._totalPageNumber ? this._totalPageNumber : pageNumber;
	
	            return pageNumber;
	        }
	
	        // can help when cross browser testing got fails
	        // getScrollXY(baseElement) {
	        //     let scrOfX = 0, scrOfY = 0;
	        //     if( typeof( baseElement.pageYOffset ) == 'number' ) {
	        //       //Netscape compliant
	        //       scrOfY = baseElement.pageYOffset;
	        //       scrOfX = baseElement.pageXOffset;
	        //     } else if( baseElement && ( baseElement.scrollLeft || baseElement.scrollTop ) ) {
	        //       //DOM compliant
	        //       scrOfY = baseElement.scrollTop;
	        //       scrOfX = baseElement.scrollLeft;
	        //     } else if( baseElement && ( baseElement.scrollLeft || baseElement.scrollTop ) ) {
	        //       //IE6 standards compliant mode
	        //       scrOfY = baseElement.scrollTop;
	        //       scrOfX = baseElement.scrollLeft;
	        //     }
	        //     return [ scrOfX, scrOfY ];
	        //   }
	
	        /**
	         * Get the relative Y coordinate (measured from the container) of the current page bottom.
	         * Page distances included.
	         * @param {*} pageNumber
	         * @returns
	         */
	    }, {
	        key: "getPageBottom",
	        value: function getPageBottom(pageNumber) {
	            // --- calculate by img tag marker ---
	            // let bottom = null
	            // let containerElement = this._ getContainer()
	            // let images = containerElement.getElementsByTagName("img")
	
	            // for (let i=0; i < images.length; i++) {
	            //     let oneImage = images[i]
	            //     if (!oneImage.getAttribute("data-pdf-page")) {
	            //         continue;
	            //     }
	
	            //     if( pageNumber === oneImage.getAttribute("data-page-number") ) {
	            //         let rectObject = oneImage.getBoundingClientRect();
	            //         bottom = rectObject.bottom
	            //         break
	            //     }
	            // }
	
	            // --- calculation solution --- not finished
	            var accumulativeHeight = 0;
	            for (var i = 0; i < this._pageSizeList.length; i++) {
	                var aPageSize = this._pageSizeList[i]; // "{\"pointx\":%w,\"pointy\":%h,\"dpix\":%x,\"dpiy\":%y},"
	                var anImageSize = this._pageImageSizeList[i]; // rectObj
	                //accumulativeHeight += aPageSize.pointy
	                accumulativeHeight += anImageSize.height + this._pageDistances;
	
	                if (pageNumber === i + 1) {
	                    break;
	                }
	            }
	
	            // last _pageDistances removed for the correct bottom coordinate.
	            return accumulativeHeight - this._pageDistances;
	        }
	
	        /**
	         * Get the relative Y coordinate (measured from the container) of the current page top.
	         * Page distances included.
	         * @param {*} pageNumber
	         * @returns
	         */
	    }, {
	        key: "getPageTop",
	        value: function getPageTop(pageNumber) {
	            var accumulativeHeight = 0;
	            var lastPageHeight = 0;
	            for (var i = 0; i < this._pageSizeList.length; i++) {
	                var aPageSize = this._pageSizeList[i]; // "{\"pointx\":%w,\"pointy\":%h,\"dpix\":%x,\"dpiy\":%y},"
	                var anImageSize = this._pageImageSizeList[i]; // rectObj
	                //accumulativeHeight += aPageSize.pointy
	                accumulativeHeight += anImageSize.height + this._pageDistances;
	                lastPageHeight = anImageSize.height;
	                if (pageNumber === i + 1) {
	                    break;
	                }
	            }
	
	            // last _pageDistances removed for the correct bottom coordinate.
	            return accumulativeHeight - this._pageDistances - lastPageHeight;
	        }
	
	        /**
	         * This function will give the specified page width in pixels.
	         * @param {*} pageNumber
	         * @returns width in pixels on display scale
	         */
	    }, {
	        key: "_getPageWidth",
	        value: function _getPageWidth(pageNumber) {
	            var width = 0;
	
	            for (var i = 0; i < this._pageSizeList.length; i++) {
	                var aPageSize = this._pageSizeList[i]; // "{\"pointx\":%w,\"pointy\":%h,\"dpix\":%x,\"dpiy\":%y},"
	                var anImageSize = this._pageImageSizeList[i]; // rectObj
	
	                if (pageNumber === i + 1) {
	                    width = anImageSize.width;
	                    break;
	                }
	            }
	
	            return width;
	        }
	
	        /**
	         * Return the instance of placeholder by id.     *
	         * @param {String} id An unique id generated on placeholder creation of this tool. Not a mongo _id.
	         * @returns
	         */
	    }, {
	        key: "getPlaceholderByIdFromList",
	        value: function getPlaceholderByIdFromList(id) {
	            var index = -1;
	
	            // find the element to remove
	            for (var i = 0; i < this._placeholders.length; i++) {
	                if (this._placeholders[i].id === id) {
	                    index = i;
	                    break;
	                }
	            }
	
	            // check if not found the id in the list
	            if (index === -1) {
	                return null;
	            }
	
	            return this._placeholders[index];
	        }
	
	        /**
	         * This function will replace an instance of placeholder in the list of placeholder by ID.
	         * No safety checks, just replace if found.
	         * @param {String} id An unique id generated on placeholder creation of this tool. Not a mongo _id.
	         * @param {object} newPlaceholder the new instance of the placeholder object
	         * @returns Return the instance of placeholder updated
	         */
	    }, {
	        key: "_setPlaceholderByIdInList",
	        value: function _setPlaceholderByIdInList(id, newPlaceholder) {
	            var index = -1;
	
	            // find the element to remove
	            for (var i = 0; i < this._placeholders.length; i++) {
	                if (this._placeholders[i].id === id) {
	                    index = i;
	                    break;
	                }
	            }
	
	            // check if not found the id in the list
	            if (index === -1) {
	                return null;
	            }
	
	            return this._placeholders[index] = newPlaceholder;
	        }
	
	        /**
	         * Return all placeholders.
	         * @returns Array contains instances of placeholders.
	         */
	    }, {
	        key: "getPlaceholders",
	        value: function getPlaceholders() {
	            return this._placeholders;
	        }
	
	        /**
	         * Add new placeholder to th
	         * @returns
	         */
	    }, {
	        key: "_generatePlaceholder",
	        value: function _generatePlaceholder() {
	            var placeholderRecord = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	            // update actual IMG data
	            this._pageImageSizeList = this.getAllImageInfo();
	
	            // clone the template
	            var placeholder = JSON.parse(JSON.stringify(this._placeholderTemplate));
	
	            // setup the new instance
	            // this will be overwrite when the placeholderRecord is an already existing reloaded record
	            placeholder.id = this._getNewPlaceholderIndex();
	
	            // must set if exists else will added an unused
	            if (placeholderRecord) {
	                placeholder.stakeholderId = placeholderRecord.stakeholderId;
	                placeholder.signerType = placeholderRecord.signerType;
	            }
	
	            placeholder.placedOnPage = 1;
	            placeholder.pageSizeOfOriginalPDF = this._pageSizeList && this._pageSizeList[placeholder.placedOnPage - 1] || {};
	            // current page info
	            placeholder.pageImageInfo = this._pageImageSizeList[placeholder.placedOnPage - 1];
	
	            var xMultiplier = this.getXMultiplier(placeholder);
	            var yMultiplier = this.getYMultiplier(placeholder);
	
	            placeholder.width = this.MINIMUM_PLACEHOLDER_WIDTH_PTS;
	            placeholder.height = this.MINIMUM_PLACEHOLDER_HEIGHT_PTS;
	
	            if (!placeholder.stakeholderId && this._stakeholders.length > 0) {
	                // set a new id
	                var unusedSHolder = this._getUnusedStakeholder();
	                placeholder.stakeholderId = unusedSHolder && unusedSHolder._id || "";
	                placeholder.signerType = unusedSHolder && unusedSHolder.signerType || "";
	            }
	
	            // update with initial values or exiting data
	            if (placeholderRecord) {
	                placeholder = _extends({}, placeholder, placeholderRecord);
	            }
	
	            return placeholder;
	        }
	
	        /**
	         * this function returns with a stakeholder what is not used yet by any of the placeholders.
	         * @returns StakeholderRecord or null
	         */
	    }, {
	        key: "_getUnusedStakeholder",
	        value: function _getUnusedStakeholder() {
	            var freeStakeholder = null;
	
	            for (var i = 0; i < this._stakeholders.length; i++) {
	                var oneStake = null;
	
	                var isItAlreadyInUse = false;
	                for (var j = 0; j < this._placeholders; j++) {
	                    var onePlace = this._placeholders[j];
	                    if (oneStake._id === onePlace.stakeholderId) {
	                        isItAlreadyInUse = true;
	                    }
	                }
	
	                if (!isItAlreadyInUse) {
	                    freeStakeholder = oneStake;
	                    break;
	                }
	            }
	
	            // set a new id
	            return freeStakeholder;
	        }
	
	        /**
	         * Modify coordinates and texts in the signature placeholder rectangle what are changing.
	         * @param {*} placeholder
	         */
	    }, {
	        key: "_updateDOMHtml",
	        value: function _updateDOMHtml(placeholder, xMultiplier, yMultiplier) {
	            var labelElementForPageNumberValue = window.document.getElementById(placeholder.id + this.ELEMENT_ID_POSTFIX_FOR_PAGE_NUMBER_VALUE);
	            labelElementForPageNumberValue.innerHTML = placeholder.placedOnPage + "/" + this._totalPageNumber;
	
	            var currentPageTop = this.getPageTop(placeholder.placedOnPage);
	
	            var signPlaceholderElement = null;
	            if (this._activePlaceholderId) {
	                signPlaceholderElement = window.document.getElementById(this._activePlaceholderId);
	                signPlaceholderElement.style.left = placeholder.x / xMultiplier + "px";
	                signPlaceholderElement.style.top = placeholder.y / yMultiplier + currentPageTop + "px";
	                signPlaceholderElement.style.width = placeholder.width / xMultiplier + "px";
	                signPlaceholderElement.style.height = placeholder.height / yMultiplier + "px";
	            }
	
	            // can be extended with more values to show in the rectangle
	        }
	
	        /**
	         * This function provide a new unique placeholder id.
	         * @returns
	         */
	    }, {
	        key: "_getNewPlaceholderIndex",
	        value: function _getNewPlaceholderIndex() {
	            return "signaturePlaceholder_" + (0, _uuidV42["default"])();
	        }
	
	        /**
	         * Add placeholder to the list of the class instance
	         * @param {*} placeholder
	         */
	    }, {
	        key: "_addPlaceholderToTheList",
	        value: function _addPlaceholderToTheList(placeholder) {
	            this._placeholders.push(placeholder);
	        }
	
	        /**
	         *
	         * @returns
	         */
	    }, {
	        key: "_getContainer",
	        value: function _getContainer() {
	            var result = window.document.getElementById(this._targetDOMElementId);
	            //console.log("_ getContainer window.document.getElementById(this._targetDOMElementId) = ", result)
	            return result;
	        }
	    }]);
	
	    return SignaturePlaceholderSelector;
	})();
	
	exports["default"] = SignaturePlaceholderSelector;
	module.exports = exports["default"];

	// must populated in constructor

	// private list of placeholders

	// DOM element id if the container element

	// the visible distance in pixels between he document page IMG tags.

	// the array of information about the original PDF page sizes. In order [{pointx, pointy, dpix, dpiy},... ] (this is determined by server API response.)

	// contains information about document page IMG tags in form [<DOMRect>, ...]. In order of the pages in DOM.
	// in pixels
	// in pixels

	// Operation types (actions), what can be made on a placeholder.
	// in pixels
	// in pixels
	// in pixels

	// Quoted information from other documentations:
	// Page* The page of the document on which the element is placed.
	// The paging works as follows: '1' is the first page of the PDF, '2' the second, and so on. '0' must not be used as page value. To count backwards from the last page, use negative integers: '-1' for the last page, '-2' for the second to last, and so on. Integer
	// Top* How far from the top edge of the document the element is placed.

	// Minimum value is 0. Number (float)
	// Left* How far from the left edge of the document the element is placed.
	// Minimum value is 0. Number (float)

	// Width of the element in pixels.
	// Minimum value is 112.
	// Maximum value is 999999.

	// Height of the element in pixels.
	// Minimum value is 70.
	// Maximum value is 999999

	// currently active placeholder, what receive effect of an active operation

	// currently active operation on the selected/active placeholder

	// container DOM element reachable on class instance level

	// a flag to determine fi the react component must notified about the result of an operation to do rerender.
	// This helps to prevent unnecessary rerenders, to keep an inner dropdown opened, or prevent loosing any temporary information,
	// what is not stored in components state
	// what true, the _flushUpdateCallback() function take effect, when it is false, the operation result will not take flush on react virtual DOM.

	// The _flushUpdateCallback is a callback function what must be overwrite by an external callback function.
	// That must contain a render update (setState, dispatch, forceRefresh, ...) to proceed a permanent
	// update on DOM elements. Else the temporary DOM modifications will disappear on the next rendering.

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _detailedDocument = __webpack_require__(1043);
	
	var _detailedDocument2 = _interopRequireDefault(_detailedDocument);
	
	var _documentsList = __webpack_require__(1045);
	
	var _documentsList2 = _interopRequireDefault(_documentsList);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	//import DSWizard from './DSWizard'
	
	var _mifidButton = __webpack_require__(80);
	
	var _mifidButton2 = _interopRequireDefault(_mifidButton);
	
	var _detailedPackage = __webpack_require__(1044);
	
	var _detailedPackage2 = _interopRequireDefault(_detailedPackage);
	
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	var DSDocuments = (function (_Component) {
	    _inherits(DSDocuments, _Component);
	
	    _createClass(DSDocuments, null, [{
	        key: 'propTypes',
	        value: {
	            items: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            modalIsOpen: _react.PropTypes.bool,
	            opened: _react.PropTypes.string,
	            security: _react.PropTypes.object,
	            subModule: _react.PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    function DSDocuments(props) {
	        var _this = this;
	
	        _classCallCheck(this, _DSDocuments);
	
	        _get(Object.getPrototypeOf(_DSDocuments.prototype), 'constructor', this).call(this, props);
	
	        this.zoomTo = function (dsPackage) {
	            var forceOpenWizard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	            var forceOpenInvitationEditor = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	            var dispatch = _this.props.dispatch;
	
	            _this.setState({ forceOpenWizard: forceOpenWizard, forceOpenInvitationEditor: forceOpenInvitationEditor });
	            dispatch((0, _stateActions.setDSDocumentsOpenedPackage)(dsPackage._id));
	            dispatch((0, _stateActions.setDSDocumentsSubModule)('detailedPackage'));
	            if (forceOpenWizard) {
	                dispatch((0, _stateActions.setDSWizard)(true));
	            }
	            if (forceOpenInvitationEditor) {
	                dispatch((0, _stateActions.setOpenInvitationEditor)(true));
	            }
	        };
	
	        this.zoomOut = function () {
	            var dispatch = _this.props.dispatch;
	
	            dispatch((0, _stateActions.setDSDocumentsOpenedPackage)());
	            dispatch((0, _stateActions.setDSDocumentsSubModule)());
	        };
	
	        this.navigateBackToInbox = function () {
	            var _props = _this.props;
	            var dispatch = _props.dispatch;
	            var previousModule = _props.previousModule;
	
	            dispatch((0, _stateActions.setAppModule)(previousModule));
	        };
	
	        this.state = { canCreateMifid: false, forceOpenWizard: false };
	    }
	
	    _createClass(DSDocuments, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var _props2 = this.props;
	            var dispatch = _props2.dispatch;
	            var config = _props2.config;
	            var security = _props2.security;
	
	            if (!config || Object.keys(config).length === 0) {
	                dispatch((0, _stateActions.getDSDocumentConfig)(c.DIGITAL_SIGNATURE_SETTINGS));
	            }
	
	            security.actions.map(function (item, key) {
	                if (item.actionName == 'createmifid') {
	                    _this2.setState({ canCreateMifid: item.actionAllowed === "true" ? true : false });
	                }
	            });
	        }
	
	        /**
	         * This function navigate to the detailed overview of a sent email and set seen that email.
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props;
	            var opened = _props3.opened;
	            var previousModule = _props3.previousModule;
	            var paginatedPackages = _props3.paginatedPackages;
	            var totalPackageRecords = _props3.totalPackageRecords;
	            var openedPackage = _props3.openedPackage;
	            var _state = this.state;
	            var forceOpenWizard = _state.forceOpenWizard;
	            var forceOpenInvitationEditor = _state.forceOpenInvitationEditor;
	
	            return _react2['default'].createElement(
	                'div',
	                { id: '' + _documentsScss2['default'].outboxModule },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _documentsScss2['default'].mainTitleDiv },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: '' + _documentsScss2['default'].mainTitleContainer },
	                        _react2['default'].createElement(
	                            'h2',
	                            { className: '' + _documentsScss2['default'].mainTitle },
	                            _('title')
	                        ),
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            _('subtitle')
	                        )
	                    ),
	                    previousModule && previousModule === "INBOX" ? _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].moduleControls },
	                        _react2['default'].createElement(
	                            'button',
	                            { onClick: this.navigateBackToInbox,
	                                className: _documentsScss2['default'].backToList + ' ' + _documentsScss2['default'].greyButton + ' ' + (opened ? 'visible' : _documentsScss2['default'].hidden) },
	                            _('backToInbox')
	                        )
	                    ) : _react2['default'].createElement(
	                        'div',
	                        { className: _documentsScss2['default'].moduleControls },
	                        _react2['default'].createElement(
	                            'button',
	                            { onClick: this.zoomOut,
	                                className: _documentsScss2['default'].backToList + ' ' + _documentsScss2['default'].greyButton + ' ' + (opened ? 'visible' : _documentsScss2['default'].hidden) },
	                            _('backToList')
	                        )
	                    )
	                ),
	                !openedPackage && _react2['default'].createElement(_documentsList2['default'], { paginatedPackages: paginatedPackages, totalRecords: totalPackageRecords, zoomTo: this.zoomTo }),
	                openedPackage && _react2['default'].createElement(_detailedPackage2['default'], {
	                    zoomOut: this.zoomOut,
	                    forceOpenWizard: forceOpenWizard,
	                    forceOpenInvitationEditor: forceOpenInvitationEditor
	                })
	            );
	        }
	    }]);
	
	    var _DSDocuments = DSDocuments;
	    DSDocuments = (0, _reactRedux.connect)(function (_ref) {
	        var _ref$DSDocuments = _ref.DSDocuments;
	        var items = _ref$DSDocuments.items;
	        var modalIsOpen = _ref$DSDocuments.modalIsOpen;
	        var opened = _ref$DSDocuments.opened;
	        var subModule = _ref$DSDocuments.subModule;
	        var config = _ref$DSDocuments.config;
	        var paginatedPackages = _ref$DSDocuments.paginatedPackages;
	        var totalPackageRecords = _ref$DSDocuments.totalPackageRecords;
	        var openedPackage = _ref$DSDocuments.openedPackage;
	        var _ref$app = _ref.app;
	        var security = _ref$app.security;
	        var lang = _ref$app.lang;
	        var previousModule = _ref$app.previousModule;
	        return {
	            items: items,
	            modalIsOpen: modalIsOpen,
	            opened: opened,
	            subModule: subModule,
	            security: security,
	            lang: lang,
	            previousModule: previousModule,
	            paginatedPackages: paginatedPackages,
	            totalPackageRecords: totalPackageRecords,
	            openedPackage: openedPackage
	        };
	    })(DSDocuments) || DSDocuments;
	    return DSDocuments;
	})(_react.Component);
	
	exports['default'] = DSDocuments;
	module.exports = exports['default'];

	/**
	 * This function will close the detailed page of an email.
	 */

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _documentsScss = __webpack_require__(54);
	
	var _documentsScss2 = _interopRequireDefault(_documentsScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('dsdocuments');
	
	/**
	 * This module render a button witch can be used to link one or more dsDocuments from a package to a contract or upload these documents dsDocuments
	 */
	
	var DsPackageLinkAndUploadButton = (function (_React$Component) {
	    _inherits(DsPackageLinkAndUploadButton, _React$Component);
	
	    _createClass(DsPackageLinkAndUploadButton, null, [{
	        key: 'propTypes',
	        value: {
	            dsPackage: _react2['default'].PropTypes.object,
	            openLinkAndUploadWizard: _react2['default'].PropTypes.func,
	            key: _react2['default'].PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    function DsPackageLinkAndUploadButton(props) {
	        _classCallCheck(this, DsPackageLinkAndUploadButton);
	
	        _get(Object.getPrototypeOf(DsPackageLinkAndUploadButton.prototype), 'constructor', this).call(this, props);
	        this.state = {};
	    }
	
	    /**
	     * This function handle the onclick on action button for a DSDocument
	     * @param {*} dsPackage
	     */
	
	    _createClass(DsPackageLinkAndUploadButton, [{
	        key: 'onDSDocumentActionClick',
	        value: function onDSDocumentActionClick(dsPackage) {
	            // no document cancel action
	            if (!dsPackage) {
	                return false;
	            }
	
	            return this.openLinkAndUploadWizard(dsPackage);
	        }
	
	        /**
	         *
	         * @param {*} dsPackage
	         */
	    }, {
	        key: 'openLinkAndUploadWizard',
	        value: function openLinkAndUploadWizard(dsPackage) {
	            this.props.openLinkAndUploadWizard(dsPackage);
	        }
	
	        /**
	         * Main render function
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var key = _props.key;
	            var dsPackage = _props.dsPackage;
	
	            var hasUnUploadedDocuments = dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.some(function (oneDocument) {
	                return !oneDocument.uploadedToOracle && !oneDocument.isAttachment;
	            });
	            return _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_documentsScss2['default'].grow), key: key },
	                hasUnUploadedDocuments && (!dsPackage.mustBeSigned || dsPackage.mustBeSigned && dsPackage.hasFinishStatus || dsPackage.requireLinking) && !dsPackage.isEditable && _react2['default'].createElement(
	                    'button',
	                    { className: (0, _classnames2['default'])(_documentsScss2['default'].greenButton, _documentsScss2['default'].greenButtonDsList, "enabled", _documentsScss2['default'].grow),
	                        onClick: function (ev) {
	                            ev.stopPropagation();
	                            return _this.onDSDocumentActionClick(dsPackage);
	                        }
	                    },
	                    dsPackage.requireLinking ? _("linkContract") : _("uploadDocument")
	                )
	            );
	        }
	    }]);
	
	    return DsPackageLinkAndUploadButton;
	})(_react2['default'].Component);
	
	exports['default'] = DsPackageLinkAndUploadButton;
	module.exports = exports['default'];

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementsHtmlContent = __webpack_require__(110);
	
	var _elementsHtmlContent2 = _interopRequireDefault(_elementsHtmlContent);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateDucksText = __webpack_require__(617);
	
	var StaticHtml = (function (_Component) {
		_inherits(StaticHtml, _Component);
	
		function StaticHtml() {
			_classCallCheck(this, _StaticHtml);
	
			_get(Object.getPrototypeOf(_StaticHtml.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(StaticHtml, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _props = this.props;
				var content = _props.content;
				var id = _props.id;
				var getText = _props.getText;
	
				if (!content) {
					getText(id);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props;
				var content = _props2.content;
				var className = _props2.className;
	
				if (!content) {
					return _react2['default'].createElement(
						'p',
						null,
						'…'
					);
				}
				return _react2['default'].createElement(_elementsHtmlContent2['default'], { className: className, content: content });
			}
		}], [{
			key: 'propTypes',
			value: {
				id: _react.PropTypes.string.isRequired,
				content: _react.PropTypes.string,
				className: _react.PropTypes.string,
				getText: _react.PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		var _StaticHtml = StaticHtml;
		StaticHtml = (0, _reactRedux.connect)(function (initState, _ref) {
			var id = _ref.id;
			return function (state) {
				var text = state.text[id];
				return {
					content: text && text[state.app.lang]
				};
			};
		}, { getText: _stateDucksText.getText })(StaticHtml) || StaticHtml;
		return StaticHtml;
	})(_react.Component);
	
	exports['default'] = StaticHtml;
	module.exports = exports['default'];

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _agendaScss = __webpack_require__(1584);
	
	var _agendaScss2 = _interopRequireDefault(_agendaScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libHelpers = __webpack_require__(24);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _subscribe = __webpack_require__(1054);
	
	var _subscribe2 = _interopRequireDefault(_subscribe);
	
	var _officeContacts = __webpack_require__(370);
	
	var _elementsComponentPageDom = __webpack_require__(219);
	
	var _elementsComponentPageDom2 = _interopRequireDefault(_elementsComponentPageDom);
	
	var _elementsHtmlContent = __webpack_require__(110);
	
	var _elementsHtmlContent2 = _interopRequireDefault(_elementsHtmlContent);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ = (0, _libI18n2['default'])('agenda');
	
	var AvailablePlaces = function AvailablePlaces(_ref) {
		var capacity = _ref.capacity;
		var available = _ref.available;
		return _react2['default'].createElement(
			'span',
			null,
			available + '/' + capacity
		);
	};
	AvailablePlaces.propTypes = {
		capacity: _react.PropTypes.number,
		available: _react.PropTypes.number
	};
	
	var DateValue = function DateValue(_ref2) {
		var date = _ref2.date;
		return _react2['default'].createElement(
			'span',
			null,
			(0, _libHelpers.formatDate)(date)
		);
	};
	DateValue.propTypes = { date: _react.PropTypes.any };
	
	var DateRangeValue = function DateRangeValue(_ref3) {
		var startDate = _ref3.startDate;
		var endDate = _ref3.endDate;
		var startTime = _ref3.startTime;
		var endTime = _ref3.endTime;
	
		var start = (0, _libHelpers.formatDate)(startDate);
		var end = (0, _libHelpers.formatDate)(endDate);
		var same = start === end;
		var startString = start + ' ' + startTime;
		var endString = '' + (same ? '' : end + ' ') + endTime;
	
		return _react2['default'].createElement(
			'span',
			null,
			startString,
			' - ',
			endString
		);
	};
	DateRangeValue.propTypes = {
		startDate: _react.PropTypes.string,
		endDate: _react.PropTypes.string,
		startTime: _react.PropTypes.string,
		endTime: _react.PropTypes.string
	};
	
	var LocationValue = function LocationValue(_ref4) {
		var _ref4$location = _ref4.location;
		var _ref4$location$street = _ref4$location.street;
		var street = _ref4$location$street === undefined ? '?' : _ref4$location$street;
		var _ref4$location$houseNum = _ref4$location.houseNum;
		var houseNum = _ref4$location$houseNum === undefined ? '' : _ref4$location$houseNum;
		var houseNumExt = _ref4$location.houseNumExt;
		var _ref4$location$zip = _ref4$location.zip;
		var zip = _ref4$location$zip === undefined ? '?' : _ref4$location$zip;
		var _ref4$location$city = _ref4$location.city;
		var city = _ref4$location$city === undefined ? '?' : _ref4$location$city;
		var _ref4$location$country = _ref4$location.country;
		var country = _ref4$location$country === undefined ? '' : _ref4$location$country;
		return _react2['default'].createElement(
			'div',
			{ className: _agendaScss2['default'].address },
			street,
			' ',
			houseNum,
			houseNumExt ? '/' + houseNumExt : '',
			' – ',
			zip,
			' ',
			city,
			' ',
			country
		);
	};
	LocationValue.propTypes = { location: _react.PropTypes.object };
	
	var EventContactsDom = function EventContactsDom(_ref5) {
		var contacts = _ref5.contacts;
		var date = _ref5.date;
		return _react2['default'].createElement(
			'div',
			{ className: _agendaScss2['default'].subscribers },
			contacts && date.subscriberIds.map(function (cId, key) {
				return _react2['default'].createElement(_officeContacts.ContactNameValue, { key: key, contact: contacts.find(function (u) {
						return u._id === cId;
					}) });
			})
		);
	};
	EventContactsDom.propTypes = {
		date: _react.PropTypes.object,
		contacts: _react.PropTypes.array
	};
	
	var Button = function Button(_ref6) {
		var event = _ref6.event;
		var label = _ref6.label;
		return _react2['default'].createElement(
			'div',
			null,
			_react2['default'].createElement('input', {
				onClick: event,
				type: 'button',
				className: _agendaScss2['default'].greyButton,
				value: label
			})
		);
	};
	Button.propTypes = {
		label: _react.PropTypes.string,
		event: _react.PropTypes.func
	};
	
	var EventPeriod = function EventPeriod(_ref7) {
		var _ref7$date = _ref7.date;
		var _id = _ref7$date._id;
		var startDate = _ref7$date.startDate;
		var endDate = _ref7$date.endDate;
		var startTime = _ref7$date.startTime;
		var endTime = _ref7$date.endTime;
		var capacity = _ref7$date.capacity;
		var available = _ref7$date.available;
		var subscribeOpen = _ref7$date.subscribeOpen;
		var startSubscribe = _ref7$date.startSubscribe;
		var endSubscribe = _ref7$date.endSubscribe;
		var date = _ref7.date;
		var contacts = _ref7.contacts;
		var openPopup = _ref7.openPopup;
		var subscribersList = _ref7.subscribersList;
		var userId = _ref7.userId;
		return _react2['default'].createElement(
			'tr',
			{ className: _agendaScss2['default'].eventContainer },
			_react2['default'].createElement(
				'td',
				{ className: _agendaScss2['default'].dateRange },
				_react2['default'].createElement(DateRangeValue, {
					startDate: startDate,
					endDate: endDate,
					startTime: startTime,
					endTime: endTime
				})
			),
			_react2['default'].createElement(
				'td',
				{ className: _agendaScss2['default'].places },
				_react2['default'].createElement(AvailablePlaces, { capacity: capacity, available: available })
			),
			_react2['default'].createElement(
				'td',
				{ className: _agendaScss2['default'].subsCont },
				_react2['default'].createElement(
					'div',
					{ className: _agendaScss2['default'].subs },
					_react2['default'].createElement(EventContactsDom, { contacts: contacts, date: date }),
					openPopup && (subscribeOpen ? _react2['default'].createElement(
						'div',
						{ className: _agendaScss2['default'].subscribeButtonContainer },
						_react2['default'].createElement(Button, { event: function () {
								return openPopup(date);
							}, label: _("subscribeButton") }),
						_react2['default'].createElement(
							'small',
							null,
							_('subscribeEnds'),
							' ',
							_react2['default'].createElement(DateValue, { date: endSubscribe })
						)
					) : new Date(startSubscribe) < new Date() ? _react2['default'].createElement(
						'em',
						null,
						_('subscribeEnded')
					) : _react2['default'].createElement(
						'em',
						null,
						_('subscribeStartsOn'),
						' ',
						_react2['default'].createElement(DateValue, { date: startSubscribe })
					))
				)
			)
		);
	};
	EventPeriod.propTypes = {
		date: _react.PropTypes.shape({
			_id: _react.PropTypes.string.isRequired,
			startDate: _react.PropTypes.string.isRequired,
			endDate: _react.PropTypes.string.isRequired,
			startTime: _react.PropTypes.string.isRequired,
			endTime: _react.PropTypes.string.isRequired,
			capacity: _react.PropTypes.number.isRequired,
			available: _react.PropTypes.number.isRequired,
			subscribeOpen: _react.PropTypes.bool.isRequired,
			startSubscribe: _react.PropTypes.string,
			endSubscribe: _react.PropTypes.string
		}),
		contacts: _react.PropTypes.array,
		openPopup: _react.PropTypes.func,
		subscribersList: _react.PropTypes.func,
		userId: _react.PropTypes.string.isRequired
	};
	
	var EventDatesDom = function EventDatesDom(_ref8) {
		var dates = _ref8.dates;
		var contacts = _ref8.contacts;
		var openPopup = _ref8.openPopup;
		var userId = _ref8.userId;
		var subscribersList = _ref8.subscribersList;
		return _react2['default'].createElement(
			'table',
			{ className: _agendaScss2['default'].eventMainContainer },
			_react2['default'].createElement(
				'tbody',
				null,
				_react2['default'].createElement(
					'tr',
					{ className: _agendaScss2['default'].headerContainer },
					_react2['default'].createElement(
						'th',
						{ className: _agendaScss2['default'].dateHeader },
						_('date')
					),
					_react2['default'].createElement(
						'th',
						{ className: _agendaScss2['default'].attendeesHeader },
						_('freeSeatsNum')
					),
					_react2['default'].createElement(
						'th',
						{ className: _agendaScss2['default'].subscribeHeader },
						_('subscribe')
					)
				),
				dates.map(function (date, key) {
					return _react2['default'].createElement(EventPeriod, _extends({
						key: key
					}, {
						date: date,
						contacts: contacts,
						openPopup: openPopup,
						subscribersList: subscribersList,
						userId: userId
					}));
				})
			)
		);
	};
	
	EventDatesDom.propTypes = {
		dates: _react.PropTypes.arrayOf(_react.PropTypes.object),
		contacts: _react.PropTypes.arrayOf(_react.PropTypes.object),
		openPopup: _react.PropTypes.func,
		subscribersList: _react.PropTypes.func,
		userId: _react.PropTypes.string.isRequired
	};
	
	var EventDescriptionDom = function EventDescriptionDom(_ref9) {
		var event = _ref9.event;
		return _react2['default'].createElement(
			'div',
			{ className: _agendaScss2['default'].description },
			_react2['default'].createElement(
				'div',
				{ className: _agendaScss2['default'].icon },
				_react2['default'].createElement('img', { src: __webpack_require__(528) }),
				_('eventTitle')
			),
			event.desc && _react2['default'].createElement(_elementsHtmlContent2['default'], { className: _agendaScss2['default'].descriptionContent, content: event.desc[global.lang] }),
			event.location && _react2['default'].createElement(
				'div',
				null,
				_react2['default'].createElement(
					'div',
					{ className: _agendaScss2['default'].icon },
					_react2['default'].createElement('img', { src: __webpack_require__(530) }),
					_('location')
				),
				_react2['default'].createElement(LocationValue, { location: event.location })
			)
		);
	};
	EventDescriptionDom.propTypes = {
		isPhone: _react.PropTypes.bool.isRequired,
		isTablet: _react.PropTypes.bool.isRequired,
		event: _react.PropTypes.object
	};
	
	var apiKey = "AIzaSyBXJ3lsUMlS2I4tCr3ppQ_ZgijeI7d_n-s";
	
	var GmapEmbed = function GmapEmbed(_ref10) {
		var isPhone = _ref10.isPhone;
		var isTablet = _ref10.isTablet;
		var googlePlaceId = _ref10.googlePlaceId;
		var lat = _ref10.lat;
		var lng = _ref10.lng;
		var q = _ref10.q;
	
		var search = undefined;
		if (googlePlaceId) {
			search = 'place_id:' + googlePlaceId;
		} else if (lat && lng) {
			search = lat + ',' + lng;
		} else {
			search = q;
		}
		if (!search) {
			return _react2['default'].createElement('div', null);
		}
		search = encodeURIComponent(search);
	
		return _react2['default'].createElement(
			'div',
			{ className: _agendaScss2['default'].gmapEmbedWrapper },
			isPhone || isTablet ? lat && lng && _react2['default'].createElement(
				'a',
				{ href: 'https://www.google.com/maps/place?q=' + search + '&zoom=17' },
				_react2['default'].createElement('img', { src: 'https://maps.googleapis.com/maps/api/staticmap?center=' + lat + ',' + lng + '&zoom=15&size=600x300&key=' + apiKey + '&markers=size:large%7Ccolor:0xff0000%7Clabel:%7C' + lat + ',+' + lng })
			) : _react2['default'].createElement('iframe', {
				className: _agendaScss2['default'].map,
				src: 'https://www.google.com/maps/embed/v1/place?q=' + search + '&zoom=17&key=' + apiKey,
				width: '100%',
				height: '400px'
			})
		);
	};
	GmapEmbed.propTypes = {
		isPhone: _react.PropTypes.bool.isRequired,
		isTablet: _react.PropTypes.bool.isRequired,
		googlePlaceId: _react.PropTypes.string,
		lat: _react.PropTypes.number,
		lng: _react.PropTypes.number,
		q: _react.PropTypes.string
	};
	
	var Event = function Event(_ref11) {
		var event = _ref11.event;
		var contacts = _ref11.contacts;
		var openPopup = _ref11.openPopup;
		var subscribersList = _ref11.subscribersList;
		var userId = _ref11.userId;
		var isPhone = _ref11.isPhone;
		var isTablet = _ref11.isTablet;
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])(_agendaScss2['default'].content, _agendaScss2['default'].noPointer) },
			_react2['default'].createElement(EventDatesDom, {
				dates: event.dates,
				contacts: contacts,
				openPopup: event.allowSubscribe ? openPopup : undefined,
				subscribersList: subscribersList,
				userId: userId
			}),
			_react2['default'].createElement(EventDescriptionDom, { event: event, isPhone: isPhone, isTablet: isTablet }),
			event.location && _react2['default'].createElement(EventMap, { event: event, isPhone: isPhone, isTablet: isTablet })
		);
	};
	Event.propTypes = {
		event: _react.PropTypes.object,
		isPhone: _react.PropTypes.bool.isRequired,
		contacts: _react.PropTypes.arrayOf(_react.PropTypes.object),
		openPopup: _react.PropTypes.func.isRequired,
		subscribersList: _react.PropTypes.func,
		userId: _react.PropTypes.string.isRequired
	};
	
	var EventMap = function EventMap(_ref12) {
		var event = _ref12.event;
		var isPhone = _ref12.isPhone;
		var isTablet = _ref12.isTablet;
		var _event$location = event.location;
		var googlePlaceId = _event$location.googlePlaceId;
		var lat = _event$location.lat;
		var lng = _event$location.lng;
	
		return _react2['default'].createElement(
			'div',
			{ className: _agendaScss2['default'].map },
			(lat && lng || googlePlaceId) && _react2['default'].createElement(GmapEmbed, {
				isPhone: isPhone,
				isTablet: isTablet,
				googlePlaceId: googlePlaceId,
				lat: lat, lng: lng
			})
		);
	};
	EventMap.propTypes = {
		event: _react.PropTypes.object,
		isPhone: _react.PropTypes.bool.isRequired,
		isTablet: _react.PropTypes.bool.isRequired
	};
	
	var AgendaTableDom = function AgendaTableDom(_ref13) {
		var events = _ref13.events;
		var contacts = _ref13.contacts;
		var isOpened = _ref13.isOpened;
		var toggleSub = _ref13.toggleSub;
		var openPopup = _ref13.openPopup;
		var subscribersList = _ref13.subscribersList;
		var userId = _ref13.userId;
		var isPhone = _ref13.isPhone;
		var isTablet = _ref13.isTablet;
		return _react2['default'].createElement(
			_componentsReactable.Table,
			{
				sortable: [{ column: 'ticketDate', sortFunction: 'Date' }],
				defaultSort: {
					column: 'ticketDate',
					direction: 'asc'
				},
	
				itemsPerPage: 10,
				pageButtonLimit: 5
			},
			_react2['default'].createElement(
				_componentsReactable.Thead,
				null,
				_react2['default'].createElement(_componentsReactable.Th, { column: 'collapse', label: '' }),
				_react2['default'].createElement(_componentsReactable.Th, { column: 'checkmark', label: '' }),
				_react2['default'].createElement(
					_componentsReactable.Th,
					{ column: 'description' },
					_react2['default'].createElement(
						'strong',
						null,
						_("eventTitle")
					)
				),
				_react2['default'].createElement(
					_componentsReactable.Th,
					{ column: 'ticketDate' },
					_react2['default'].createElement(
						'strong',
						null,
						_("date")
					)
				)
			),
			events && events.map(function (event) {
				return _react2['default'].createElement(
					_componentsReactable.Tr,
					{
						key: event._id,
						className: _agendaScss2['default'].row,
						onClick: function () {
							return toggleSub(event._id);
						}
					},
					(0, _componentsReactable.collapseTdWithClass)({
						column: 'collapse',
						className: _agendaScss2['default'].checkmarkColumn,
						isOpened: isOpened[event._id],
						children: _react2['default'].createElement(Event, { event: event, contacts: contacts, openPopup: openPopup, subscribersList: subscribersList, userId: userId, isPhone: isPhone, isTablet: isTablet })
					}),
					_react2['default'].createElement(
						_componentsReactable.Td,
						{ column: 'checkmark', className: _agendaScss2['default'].checkmarkColumn },
						event.highlighted ? _react2['default'].createElement('img', { className: _agendaScss2['default'].checkmark, src: __webpack_require__(951) }) : ''
					),
					_react2['default'].createElement(
						_componentsReactable.Td,
						{ column: 'description', className: _agendaScss2['default'].descriptionColumn },
						event.title[global.lang]
					),
					_react2['default'].createElement(
						_componentsReactable.Td,
						{ column: 'ticketDate', className: _agendaScss2['default'].dateColumn, value: event.dates[0].startDate },
						event.dates.length > 0 ? _react2['default'].createElement(DateRangeValue, {
							startDate: event.dates[0].startDate,
							startTime: event.dates[0].startTime,
							endDate: event.dates[0].endDate,
							endTime: event.dates[0].endTime
						}) : ''
					)
				);
			})
		);
	};
	AgendaTableDom.propTypes = {
		events: _react.PropTypes.arrayOf(_react.PropTypes.object),
		contacts: _react.PropTypes.arrayOf(_react.PropTypes.object),
		isOpened: _react.PropTypes.object,
		toggleSub: _react.PropTypes.func.isRequired,
		openPopup: _react.PropTypes.func,
		isPhone: _react.PropTypes.bool.isRequired,
		isTablet: _react.PropTypes.bool.isRequired,
		userId: _react.PropTypes.string.isRequired,
		subscribersList: _react.PropTypes.func
	};
	
	var SubscriberPopupDom = function SubscriberPopupDom(_ref14) {
		var children = _ref14.children;
		return _react2['default'].createElement(
			'div',
			{ className: _agendaScss2['default'].overlay },
			children
		);
	};
	
	SubscriberPopupDom.propTypes = {
		children: _react2['default'].PropTypes.node
	};
	
	var Agenda = (function (_Component) {
		_inherits(Agenda, _Component);
	
		_createClass(Agenda, null, [{
			key: 'propTypes',
			value: {
				events: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
				contacts: _react.PropTypes.arrayOf(_react.PropTypes.object),
				isPhone: _react.PropTypes.bool.isRequired,
				userId: _react.PropTypes.string.isRequired,
				lang: _react.PropTypes.string.isRequired,
				fetchAgendaData: _react.PropTypes.func,
				fetchUserData: _react.PropTypes.func,
				fetchSubscribersList: _react.PropTypes.func
			},
			enumerable: true
		}]);
	
		function Agenda(props) {
			_classCallCheck(this, _Agenda);
	
			_get(Object.getPrototypeOf(_Agenda.prototype), 'constructor', this).call(this, props);
			this.state = { isOpened: {}, subscriberPopup: false };
		}
	
		_createClass(Agenda, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.update();
			}
		}, {
			key: 'update',
			value: function update() {
				this.props.fetchAgendaData();
				this.props.fetchUserData();
			}
		}, {
			key: 'toggle',
			value: function toggle(id) {
				this.setState({ isOpened: _extends({}, this.state.isOpened, _defineProperty({}, id, !this.state.isOpened[id])) });
			}
		}, {
			key: 'openPopup',
			value: function openPopup(date) {
				var capacity = date.capacity;
				var subscriberIds = date.subscriberIds;
				var available = date.available;
	
				this.setState({ subscriberPopup: true, dateId: date._id, activeSubscribers: subscriberIds, capacity: capacity, available: available });
			}
		}, {
			key: 'closePopup',
			value: function closePopup() {
				this.update();
				this.setState({ subscriberPopup: false });
			}
		}, {
			key: 'sortByDate',
			value: function sortByDate(events) {
				return events.map(function (event) {
					return _extends({}, event, { dates: (0, _lodashCollection.sortBy)(event.dates, function (date) {
							return date.startDate;
						}) });
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var events = _props.events;
				var contacts = _props.contacts;
				var isPhone = _props.isPhone;
				var fetchSubscribersList = _props.fetchSubscribersList;
				var userId = _props.userId;
				var lang = _props.lang;
	
				var langEvents = events.filter(function (e) {
					return e.language === lang;
				});
				var sortedEvents = this.sortByDate(langEvents);
				var _state = this.state;
				var subscriberPopup = _state.subscriberPopup;
				var dateId = _state.dateId;
				var activeSubscribers = _state.activeSubscribers;
				var isOpened = _state.isOpened;
				var capacity = _state.capacity;
				var available = _state.available;
	
				var contactOptions = contacts && contacts.map(function (contact) {
					return { label: _react2['default'].createElement(_officeContacts.ContactNameValue, { contact: contact }), value: contact._id };
				});
				return _react2['default'].createElement(
					_elementsComponentPageDom2['default'],
					{
						title: _('title'),
						subtitle: _('subtitle')
					},
					_react2['default'].createElement(AgendaTableDom, {
						events: sortedEvents,
						contacts: contacts,
						isOpened: isOpened,
						openPopup: function (date) {
							return _this.openPopup(date);
						},
						subscribersList: fetchSubscribersList,
						toggleSub: function (id) {
							return _this.toggle(id);
						},
						isPhone: isPhone,
						userId: userId
					}),
					subscriberPopup && _react2['default'].createElement(
						SubscriberPopupDom,
						null,
						_react2['default'].createElement(_subscribe2['default'], {
							capacity: capacity,
							dateId: dateId,
							activeSubscribers: activeSubscribers,
							subscriberOptions: contactOptions,
							onClose: function () {
								return _this.closePopup();
							},
							placesLeft: available
						})
					)
				);
			}
		}]);
	
		var _Agenda = Agenda;
		Agenda = (0, _reactRedux.connect)(function (state) {
			return {
				events: state.agenda.events,
				contacts: state.agenda.users,
				userId: state.app.userId,
				isPhone: state.responsive.isPhone,
				lang: state.app.lang
			};
		}, { fetchUserData: _stateActions.fetchUserData, fetchAgendaData: _stateActions.fetchAgendaData, fetchSubscribersList: _stateActions.fetchSubscribersList })(Agenda) || Agenda;
		return Agenda;
	})(_react.Component);
	
	exports['default'] = Agenda;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectSelectWrap2 = _interopRequireDefault(_sharedSelectSelectWrap);
	
	var _stateActions = __webpack_require__(5);
	
	var _subscribeScss = __webpack_require__(1585);
	
	var _subscribeScss2 = _interopRequireDefault(_subscribeScss);
	
	var _lodashLang = __webpack_require__(78);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('agendaPopup');
	
	var Subscribe = (function (_React$Component) {
		_inherits(Subscribe, _React$Component);
	
		_createClass(Subscribe, null, [{
			key: 'propTypes',
			value: {
				dateId: _react.PropTypes.string.isRequired,
				updateSubscribers: _react.PropTypes.func.isRequired,
				onClose: _react.PropTypes.func.isRequired,
				subscriberOptions: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
				capacity: _react.PropTypes.number.isRequired,
				activeSubscribers: _react.PropTypes.array.isRequired,
				placesLeft: _react.PropTypes.number.isRequired,
				setAppModule: _react.PropTypes.func,
				showContactModal: _react.PropTypes.func
			},
			enumerable: true
		}]);
	
		function Subscribe(props) {
			_classCallCheck(this, _Subscribe);
	
			_get(Object.getPrototypeOf(_Subscribe.prototype), 'constructor', this).call(this, props);
			var activeSubscribers = props.activeSubscribers;
			var subscriberOptions = props.subscriberOptions;
	
			var initialState = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = subscriberOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var subscriber = _step.value;
	
					if (activeSubscribers.includes(subscriber.value)) {
						initialState.push(subscriber);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator['return']) {
						_iterator['return']();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
	
			this.state = { list: initialState };
		}
	
		_createClass(Subscribe, [{
			key: 'handleSelectChange',
			value: function handleSelectChange(list) {
				this.setState({ list: [].concat(_toConsumableArray(list)) });
			}
		}, {
			key: 'updateSubscribers',
			value: function updateSubscribers() {
				var dateId = this.props.dateId;
				var list = this.state.list;
	
				var subscriberIds = list.map(function (subscriber) {
					return subscriber.value;
				});
	
				this.props.updateSubscribers(subscriberIds, dateId);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var onClose = _props.onClose;
				var subscriberOptions = _props.subscriberOptions;
				var capacity = _props.capacity;
				var activeSubscribers = _props.activeSubscribers;
				var placesLeft = _props.placesLeft;
				var setAppModule = _props.setAppModule;
				var showContactModal = _props.showContactModal;
				var list = this.state.list;
	
				var chosenUsers = Array.isArray(list) ? list.length : list.length && list.split(",").length;
				var placesOccupied = capacity - (activeSubscribers.length + placesLeft);
				var freePlaces = capacity - (placesOccupied + chosenUsers);
				var isFull = placesOccupied + chosenUsers > capacity;
				return _react2['default'].createElement(
					'div',
					{ className: _subscribeScss2['default'].registerDialogContainer },
					_react2['default'].createElement(
						'div',
						{ className: _subscribeScss2['default'].registerDialog },
						_react2['default'].createElement(
							'div',
							{ className: _subscribeScss2['default'].description },
							_('description')
						),
						_react2['default'].createElement(
							'div',
							{ className: _subscribeScss2['default'].subscriberContainer },
							_react2['default'].createElement(
								'div',
								{ className: _subscribeScss2['default'].dropdownContainer },
								_react2['default'].createElement(
									'div',
									{ className: _subscribeScss2['default'].iconConatiner },
									_react2['default'].createElement('img', { src: __webpack_require__(531) })
								),
								_react2['default'].createElement(
									'div',
									{ className: _subscribeScss2['default'].subscriberDropdown },
									_react2['default'].createElement(_sharedSelectSelectWrap2['default'], {
										options: subscriberOptions,
										onChange: function (e) {
											return _this.handleSelectChange(e);
										},
										value: list,
										placeholder: _('selectUsers'),
										backspaceRemovesValue: false,
										blurInputOnSelect: true,
										isMulti: true
									})
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: _subscribeScss2['default'].bottomContainer },
								_react2['default'].createElement(
									'div',
									{ className: _subscribeScss2['default'].freePlacesContainer },
									_react2['default'].createElement(
										'div',
										{ className: _subscribeScss2['default'].freePlaces },
										_('freePlaces') + ': ' + (freePlaces < 0 ? 0 : freePlaces)
									)
								),
								_react2['default'].createElement(
									'div',
									{ className: _subscribeScss2['default'].buttonContainer },
									_react2['default'].createElement(
										'div',
										{ className: _subscribeScss2['default'].buttonContainerLeft },
										_react2['default'].createElement(
											'button',
											{
												onClick: function () {
													setAppModule(_stateConstants2['default'].OFFICE, 'contacts');
													showContactModal(null);
												},
												className: _subscribeScss2['default'].greyButton
											},
											_('addNewContact')
										)
									),
									_react2['default'].createElement(
										'div',
										{ className: _subscribeScss2['default'].buttonContainerRight },
										_react2['default'].createElement(
											'button',
											{
												onClick: onClose,
												className: _subscribeScss2['default'].closeBtn + ' ' + _subscribeScss2['default'].greyButton
											},
											_('close')
										),
										_react2['default'].createElement(
											'button',
											{
												disabled: isFull,
												onClick: function () {
													if (!(0, _lodashLang.isEqual)(list, activeSubscribers)) {
														_this.updateSubscribers();
													}
													onClose();
												},
												className: 'btn green'
											},
											_('confirm')
										)
									)
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: _subscribeScss2['default'].closeCross },
							_react2['default'].createElement(
								'span',
								{ onClick: onClose, className: _subscribeScss2['default'].cross },
								'×'
							)
						)
					)
				);
			}
		}]);
	
		var _Subscribe = Subscribe;
		Subscribe = (0, _reactRedux.connect)(null, { updateSubscribers: _stateActions.updateSubscribers, setAppModule: _stateActions.setAppModule, showContactModal: _stateActions.showContactModal })(Subscribe) || Subscribe;
		return Subscribe;
	})(_react2['default'].Component);
	
	exports['default'] = Subscribe;
	module.exports = exports['default'];

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _authScss = __webpack_require__(135);
	
	var _authScss2 = _interopRequireDefault(_authScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _stateActionsApi = __webpack_require__(125);
	
	var _stateActions2 = __webpack_require__(5);
	
	var _ = (0, _libI18n2['default'])('accountConfirmation');
	
	var AccountConfirmation = (function (_Component) {
	    _inherits(AccountConfirmation, _Component);
	
	    function AccountConfirmation(props) {
	        var _this = this;
	
	        _classCallCheck(this, _AccountConfirmation);
	
	        _get(Object.getPrototypeOf(_AccountConfirmation.prototype), 'constructor', this).call(this, props);
	
	        this.checkIfClientExists = function () {
	            var _props = _this.props;
	            var dispatch = _props.dispatch;
	            var hash = _props.hash;
	
	            dispatch((0, _stateActions.checkIfClientExistApi)(hash)).then(function (res) {
	                if (res == false) {
	                    dispatch((0, _stateActions.setAppModule)('NEWS'));
	                    dispatch((0, _stateActions.changeAuthState)(''));
	                    dispatch((0, _stateActions.cleanAccountConfirmation)());
	                }
	                if (res === 'hash_expired') {
	                    _this.setState({ saveError: 'client_registration_link_expired' });
	                    dispatch((0, _stateActions.setAccountConfirmationStep)(5));
	                }
	            });
	        };
	
	        this.sendConfirmAccount = function (ev) {
	            ev.preventDefault();
	            var _props2 = _this.props;
	            var step = _props2.step;
	            var dispatch = _props2.dispatch;
	            var hash = _props2.hash;
	            var smsToken = _this.state.smsToken;
	
	            if (step === 1) {
	                dispatch((0, _stateActions.validateConfirmationToken)(hash, smsToken)).then(function (response) {
	                    if (response === true) {
	                        dispatch((0, _stateActions.setAccountConfirmationStep)(2));
	                    } else {
	                        _this.setState({ error: { smsError: true } });
	                    }
	                });
	            }
	
	            if (step === 2) {
	                var _state = _this.state;
	                var password = _state.password;
	                var confirmPassword = _state.confirmPassword;
	
	                var regex = /^(?=[^0-9])(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])(?=.*[_\-$%.!:<>*#%])[a-zA-Z0-9_\-$.!:<>*#%]{8,}$/;
	                if (hash) {
	                    if (!regex.test(password)) {
	                        dispatch((0, _stateActionsApi.hasErrors)('passwordRulesError'));
	                        return;
	                    }
	
	                    if (password !== confirmPassword) {
	                        dispatch((0, _stateActionsApi.hasErrors)('checkConfirmPassword'));
	                        return;
	                    }
	
	                    dispatch((0, _stateActions.createNewClient)(password, hash)).then(function (res) {
	                        switch (res[0].error) {
	                            case 0:
	                                dispatch((0, _stateActions.setAccountConfirmationStep)(3));
	                                break;
	                            case 1:
	                                _this.setState({ saveError: 'client_registration_error_email_exists' });
	                                dispatch((0, _stateActions.setAccountConfirmationStep)(4));
	                                break;
	                            case 2:
	                                _this.setState({ saveError: 'client_registration_error_user_not_created' });
	                                dispatch((0, _stateActions.setAccountConfirmationStep)(4));
	                                break;
	                            case 3:
	                                _this.setState({ saveError: 'client_registration_error_opt_out_not_registered' });
	                                dispatch((0, _stateActions.setAccountConfirmationStep)(4));
	                                break;
	                        }
	                    });
	                }
	            }
	
	            if (step === 3 || step === 4 || step === 5) {
	                dispatch((0, _stateActions.setAppModule)('NEWS'));
	                dispatch((0, _stateActions.changeAuthState)(''));
	                dispatch((0, _stateActions.cleanAccountConfirmation)());
	            }
	        };
	
	        this.handleSmsTokenChange = function (event) {
	            _this.setState({ smsToken: event.target.value });
	        };
	
	        this.handlePasswordChange = function (event) {
	            _this.setState({ password: event.target.value });
	        };
	
	        this.handleConfirmPasswordChange = function (event) {
	            _this.setState({ confirmPassword: event.target.value });
	        };
	
	        this.state = {
	            smsToken: '',
	            smsError: false,
	            password: '',
	            confirmPassword: '',
	            loadingToken: false,
	            saveError: '',
	            error: {
	                smsError: false,
	                password: false,
	                confirmPassword: false,
	                passwordMismatch: false
	            }
	        };
	    }
	
	    _createClass(AccountConfirmation, [{
	        key: 'createToken',
	        value: function createToken() {
	            var _props3 = this.props;
	            var dispatch = _props3.dispatch;
	            var hash = _props3.hash;
	
	            if (!hash || hash === '' || hash === null) {
	                dispatch((0, _stateActions.changeAuthState)(null));
	            }
	
	            dispatch((0, _stateActions.createConfirmationToken)(hash));
	        }
	    }, {
	        key: 'refreshHashAndToken',
	        value: function refreshHashAndToken() {
	            var _this2 = this;
	
	            var _props4 = this.props;
	            var dispatch = _props4.dispatch;
	            var hash = _props4.hash;
	
	            dispatch((0, _stateActions.refreshHashAndTokenApi)(hash)).then(function (response) {
	                if (response.success) {
	                    _this2.setState({ saveError: 'client_registration_link_renewed' });
	                }
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount(prevProps, prevState) {
	            this.checkIfClientExists();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props5 = this.props;
	            var errors = _props5.errors;
	            var step = _props5.step;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _authScss2['default'].authFormsContainer },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _authScss2['default'].loginForm },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _authScss2['default'].formImage },
	                        _react2['default'].createElement('img', { src: __webpack_require__(260) })
	                    ),
	                    step === 1 && _react2['default'].createElement(
	                        'div',
	                        { className: _authScss2['default'].info },
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            _('smsTokenMessage')
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'form',
	                        { onSubmit: function (ev) {
	                                return _this3.sendConfirmAccount(ev);
	                            }, method: 'post', className: _authScss2['default'].form },
	                        step === 1 && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].formGroup },
	                                _react2['default'].createElement(
	                                    'label',
	                                    null,
	                                    _('smsToken'),
	                                    _react2['default'].createElement('input', { type: 'text', name: 'confirmSmsToken', value: this.state.smsToken, onChange: function (ev) {
	                                            return _this3.handleSmsTokenChange(ev);
	                                        } })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].errorMessage },
	                                this.state.error.smsError && _('smsTokenNotValid')
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].formGroup },
	                                _react2['default'].createElement(
	                                    'button',
	                                    { className: _authScss2['default'].submitButton },
	                                    _('next')
	                                )
	                            )
	                        ),
	                        step === 2 && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].info },
	                                _('passwordRules')
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].formGroup },
	                                _react2['default'].createElement(
	                                    'label',
	                                    null,
	                                    _('password'),
	                                    _react2['default'].createElement('input', {
	                                        ref: 'password', type: 'password', name: 'password',
	                                        value: this.state.password,
	                                        onChange: function (ev) {
	                                            return _this3.handlePasswordChange(ev);
	                                        }
	                                    })
	                                ),
	                                _react2['default'].createElement(
	                                    'label',
	                                    null,
	                                    _('confirmPassword'),
	                                    _react2['default'].createElement('input', {
	                                        ref: 'confirmPassword', type: 'password', name: 'confirmPassword',
	                                        value: this.state.confirmPassword,
	                                        onChange: function (ev) {
	                                            return _this3.handleConfirmPasswordChange(ev);
	                                        }
	                                    })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].errorMessage },
	                                errors && _(errors.id)
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].formGroup },
	                                _react2['default'].createElement(
	                                    'button',
	                                    { className: _authScss2['default'].accountConfirmationSubmitButton },
	                                    _('confirmPassword')
	                                )
	                            )
	                        ),
	                        step === 3 && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                _('passwordSetMessage')
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].formGroup },
	                                _react2['default'].createElement(
	                                    'button',
	                                    { className: _authScss2['default'].accountConfirmationSubmitButton },
	                                    _('goToLoginBtn')
	                                )
	                            )
	                        ),
	                        step === 4 && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].info },
	                                _react2['default'].createElement(
	                                    'p',
	                                    null,
	                                    _(this.state.saveError)
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].formGroup },
	                                _react2['default'].createElement(
	                                    'button',
	                                    { className: _authScss2['default'].accountConfirmationSubmitButton },
	                                    _('goToLoginBtn')
	                                )
	                            )
	                        ),
	                        step === 5 && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].info },
	                                _react2['default'].createElement(
	                                    'p',
	                                    null,
	                                    _(this.state.saveError)
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authScss2['default'].formGroup },
	                                _react2['default'].createElement(
	                                    'button',
	                                    { className: _authScss2['default'].accountConfirmationSubmitButton },
	                                    _('goToLoginBtn')
	                                )
	                            )
	                        )
	                    )
	                ),
	                step === 1 && _react2['default'].createElement(
	                    'div',
	                    { id: 'casper_smsForgot', className: _authScss2['default'].additionalOption },
	                    _react2['default'].createElement(
	                        'a',
	                        { onClick: function (e) {
	                                return _this3.createToken(e);
	                            } },
	                        _('sendCodeMSG')
	                    )
	                ),
	                step === 5 && _react2['default'].createElement(
	                    'div',
	                    { id: 'casper_smsForgot', className: _authScss2['default'].additionalOption },
	                    _react2['default'].createElement(
	                        'a',
	                        { onClick: function (e) {
	                                return _this3.refreshHashAndToken(e);
	                            } },
	                        _('refresh_link')
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _AccountConfirmation = AccountConfirmation;
	    AccountConfirmation = (0, _reactRedux.connect)(function (state) {
	        return {
	            hash: state.auth.confirmation.hash,
	            step: state.auth.confirmation.step,
	            isSending: state.auth.confirmation.isSending,
	            isToken: state.auth.confirmation.isToken,
	            errors: state.auth.errors
	        };
	    })(AccountConfirmation) || AccountConfirmation;
	    return AccountConfirmation;
	})(_react.Component);
	
	exports['default'] = AccountConfirmation;
	module.exports = exports['default'];
	/* </a> */ /* <a href={link}> */ /* </a> */

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	/* globals isClient */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _elementsGrail = __webpack_require__(220);
	
	var _elementsGrail2 = _interopRequireDefault(_elementsGrail);
	
	var _disclaimer = __webpack_require__(391);
	
	var _disclaimer2 = _interopRequireDefault(_disclaimer);
	
	var _version = __webpack_require__(635);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _loginBroker = __webpack_require__(1057);
	
	var _loginBroker2 = _interopRequireDefault(_loginBroker);
	
	var _loginClient = __webpack_require__(1058);
	
	var _loginClient2 = _interopRequireDefault(_loginClient);
	
	var _registration = __webpack_require__(1061);
	
	var _registration2 = _interopRequireDefault(_registration);
	
	var _passwordChange = __webpack_require__(1059);
	
	var _passwordChange2 = _interopRequireDefault(_passwordChange);
	
	var _passwordReset = __webpack_require__(1060);
	
	var _passwordReset2 = _interopRequireDefault(_passwordReset);
	
	var _accountConfirmation = __webpack_require__(1055);
	
	var _accountConfirmation2 = _interopRequireDefault(_accountConfirmation);
	
	var _sms = __webpack_require__(1062);
	
	var _sms2 = _interopRequireDefault(_sms);
	
	var _reactGa = __webpack_require__(212);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _authScss = __webpack_require__(135);
	
	var _authScss2 = _interopRequireDefault(_authScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateActions = __webpack_require__(5);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _ = (0, _libI18n2['default'])('auth');
	
	var Auth = (function (_React$Component) {
		_inherits(Auth, _React$Component);
	
		_createClass(Auth, null, [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				authState: _react2['default'].PropTypes.string.isRequired,
				isPhone: _react2['default'].PropTypes.bool,
				isLoggedIn: _react2['default'].PropTypes.bool.isRequired,
				options: _react2['default'].PropTypes.any
			},
			enumerable: true
		}]);
	
		function Auth(props) {
			_classCallCheck(this, _Auth);
	
			_get(Object.getPrototypeOf(_Auth.prototype), 'constructor', this).call(this, props);
	
			this.state = { prevAuthState: 'start' };
		}
	
		_createClass(Auth, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.sendAnalyticsData();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.sendAnalyticsData();
			}
		}, {
			key: 'sendAnalyticsData',
			value: function sendAnalyticsData() {
				var authState = this.props.authState;
	
				var gaMsg = undefined;
	
				if (authState) {
					gaMsg = authState;
				} else {
					gaMsg =  false ? "clientLogin" : "brokerLogin";
				}
	
				if (this.state.prevAuthState !== authState) {
					_reactGa2['default'].pageview(gaMsg);
					this.setState({ prevAuthState: authState });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props;
				var authState = _props.authState;
				var options = _props.options;
				var isPhone = _props.isPhone;
				var dispatch = _props.dispatch;
	
				var component = undefined;
	
				switch (authState) {
					case 'registration':
						component = _react2['default'].createElement(_registration2['default'], null);
						break;
					case 'sms':
						component = _react2['default'].createElement(_sms2['default'], { options: options });
						break;
					case 'passwordReset':
						component = _react2['default'].createElement(_passwordReset2['default'], { options: options });
						break;
					case 'passwordChange':
						component = _react2['default'].createElement(_passwordChange2['default'], null);
						break;
					case 'accountConfirmation':
						component = _react2['default'].createElement(_accountConfirmation2['default'], null);
						break;
					default:
						if (false) {
							component = _react2['default'].createElement(_loginClient2['default'], null);
						} else {
							component = _react2['default'].createElement(_loginBroker2['default'], null);
						}
						break;
				}
	
				return _react2['default'].createElement(_elementsGrail2['default'], {
					noScroll: true,
					content: _react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].authFormsOverlay + ' ' + (isPhone ? _authScss2['default'].mobile : '') },
						component
					),
					footer: _react2['default'].createElement(
						'div',
						null,
						_react2['default'].createElement(
							'div',
							{ className: _authScss2['default'].privacy },
							_react2['default'].createElement(
								'a',
								{ href: _('privacyStatementLink'), onClick: function (e) {
										e.preventDefault();
										// dispatch(changeAuthState(""))
										// todo check if no language exist in local storage
	
										var localLang = localStorage.getItem('clientLanguage');
										if (localLang) {
											window.open("/privacy/" + localLang, '_blank', 'noopener,noreferrer');
										} else {
											dispatch((0, _stateActions.setAppModule)(_stateConstants2['default'].PRIVACY));
										}
	
										return false;
									} },
								_('privacyStatement')
							),
							_react2['default'].createElement(
								'a',
								{ href:  false ? _('clientLink') : _('brokerLink'), className: _authScss2['default'].secondLink },
								_('cookiesLinkText')
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: _authScss2['default'].disclaimer },
							_react2['default'].createElement(_disclaimer2['default'], null),
							'- ',
							_react2['default'].createElement(
								'span',
								{ className: _authScss2['default'].version },
								_react2['default'].createElement(_version2['default'], null)
							)
						)
					)
				});
			}
		}]);
	
		var _Auth = Auth;
		Auth = (0, _reactRedux.connect)(function (state) {
			return {
				isLoggedIn: state.auth.isLoggedIn,
				authState: state.auth.authState,
				options: state.auth.options,
				isPhone: state.responsive.isPhone
			};
		})(Auth) || Auth;
		return Auth;
	})(_react2['default'].Component);
	
	exports['default'] = Auth;
	module.exports = exports['default'];

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _authScss = __webpack_require__(135);
	
	var _authScss2 = _interopRequireDefault(_authScss);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('login');
	
	var LoginBroker = (function (_React$Component) {
		_inherits(LoginBroker, _React$Component);
	
		_createClass(LoginBroker, null, [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				errors: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		function LoginBroker(props) {
			_classCallCheck(this, _LoginBroker);
	
			_get(Object.getPrototypeOf(_LoginBroker.prototype), 'constructor', this).call(this, props);
			var localLang = localStorage.getItem('clientLanguage');
			this.state = { lang: localLang || 'nl' };
		}
	
		_createClass(LoginBroker, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.appGetNofitications)('broker'));
			}
		}, {
			key: 'loginClicked',
			value: function loginClicked(ev) {
				ev.preventDefault();
	
				var dispatch = this.props.dispatch;
				var lang = this.state.lang;
	
				var login = this.refs.login.value;
				var password = this.refs.password.value;
	
				dispatch((0, _stateActions.logIn)(login, password, lang));
			}
	
			/**
	   * Get the notification message based on current app language
	   *
	   * @param {object} notification item data
	   */
		}, {
			key: 'getNotificationMessage',
			value: function getNotificationMessage(notification) {
				var language = this.props.language;
	
				var languageKey = 'message' + this.capitalizeFirstLetter(language);
	
				return notification[languageKey];
			}
	
			/**
	   * Validates if the notification is not expired
	   *
	   * @param {object} notification item data
	   */
		}, {
			key: 'isValidNotification',
			value: function isValidNotification(notification) {
				if (notification.length < 1) {
					return false;
				}
	
				var item = notification[0];
				var currentDate = (0, _moment2['default'])();
				var notificationExpires = (0, _moment2['default'])(item.expires);
	
				if (currentDate.isBefore(notificationExpires)) {
					return true;
				}
	
				return false;
			}
		}, {
			key: 'onLanguageChange',
			value: function onLanguageChange(lang) {
				var dispatch = this.props.dispatch;
	
				if (lang) {
					this.setState({ lang: lang });
					dispatch((0, _stateActions.setLang)(lang));
				}
			}
		}, {
			key: 'capitalizeFirstLetter',
			value: function capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var errors = _props.errors;
				var notifications = _props.notifications;
				var lang = this.state.lang;
	
				var langOptions = [{
					value: 'nl',
					label: _('nl')
				}, {
					value: 'fr',
					label: _('fr')
				}];
	
				return _react2['default'].createElement(
					'div',
					{ className: _authScss2['default'].authWrappNew },
					_react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].authFormsContainer },
						_react2['default'].createElement(
							'div',
							{ className: _authScss2['default'].loginForm },
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].langChanger },
								langOptions.map(function (langOption, key) {
									return _react2['default'].createElement(
										'span',
										{ key: 'langChange' + key, onClick: function () {
												return _this.onLanguageChange(langOption.value);
											}, className: lang === langOption.value ? _authScss2['default'].selectedLanguage : '' },
										(key !== 0 ? ' - ' : '') + langOption.label
									);
								})
							),
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].formImage },
								_react2['default'].createElement('img', { src: __webpack_require__(171) })
							),
							_react2['default'].createElement(
								'form',
								{ id: 'casper_Wout', onSubmit: function (ev) {
										return _this.loginClicked(ev);
									}, method: 'post', className: _authScss2['default'].form, autoComplete: 'off' },
								_react2['default'].createElement('input', { autoComplete: 'off', name: 'hidden', type: 'text', style: { display: "none" } }),
								_react2['default'].createElement(
									'div',
									{ className: _authScss2['default'].formGroup },
									_react2['default'].createElement(
										'label',
										null,
										_('login'),
										_react2['default'].createElement('input', { id: 'casper_user', autoFocus: true, ref: 'login' })
									)
								),
								_react2['default'].createElement(
									'div',
									{ className: _authScss2['default'].formGroup },
									_react2['default'].createElement(
										'label',
										null,
										_('password'),
										_react2['default'].createElement('input', { id: 'casper_pass', ref: 'password', type: 'password', autoComplete: 'new-password' })
									)
								),
								_react2['default'].createElement(
									'div',
									{ className: _authScss2['default'].errorMessage },
									errors && _(errors.id)
								),
								_react2['default'].createElement(
									'div',
									{ className: _authScss2['default'].formGroup },
									_react2['default'].createElement(
										'button',
										{ id: 'casper_butt', className: _authScss2['default'].submitButton },
										_('loginBttn')
									)
								)
							)
						)
					),
					notifications && notifications.length > 0 && this.isValidNotification(notifications) && _react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].notificationWrapper },
						_react2['default'].createElement(
							'span',
							null,
							notifications.map(function (notification, key) {
								return _this.getNotificationMessage(notification);
							})
						)
					)
				);
			}
		}]);
	
		var _LoginBroker = LoginBroker;
		LoginBroker = (0, _reactRedux.connect)(function (state) {
			return {
				errors: state.auth.errors,
				dict: state.dict,
				notifications: state.notifications.items,
				language: state.app.lang
			};
		})(LoginBroker) || LoginBroker;
		return LoginBroker;
	})(_react2['default'].Component);
	
	exports['default'] = LoginBroker;
	module.exports = exports['default'];

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _authScss = __webpack_require__(135);
	
	var _authScss2 = _interopRequireDefault(_authScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('login');
	
	var LoginClient = (function (_React$Component) {
		_inherits(LoginClient, _React$Component);
	
		function LoginClient() {
			_classCallCheck(this, _LoginClient);
	
			_get(Object.getPrototypeOf(_LoginClient.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(LoginClient, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.appGetNofitications)('client'));
			}
		}, {
			key: 'loginClicked',
			value: function loginClicked(ev) {
				ev.preventDefault();
	
				var dispatch = this.props.dispatch;
	
				var login = this.refs.login.value;
				var password = this.refs.password.value;
	
				dispatch((0, _stateActions.logIn)(login, password));
			}
		}, {
			key: 'registrationClicked',
			value: function registrationClicked() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.changeAuthState)('registration'));
			}
		}, {
			key: 'resetPassword',
			value: function resetPassword() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.changeAuthState)('passwordReset', { ok: false }));
			}
	
			/**
	   * Get the notification message based on current app language
	   *
	   * @param {object} notification item data
	   */
		}, {
			key: 'getNotificationMessage',
			value: function getNotificationMessage(notification) {
				var language = this.props.language;
	
				var languageKey = 'message' + this.capitalizeFirstLetter(language);
	
				return notification[languageKey];
			}
	
			/**
	   * Validates if the notification is not expired
	   *
	   * @param {object} notification item data
	   */
		}, {
			key: 'isValidNotification',
			value: function isValidNotification(notification) {
				if (notification.length < 1) {
					return false;
				}
	
				var item = notification[0];
				var currentDate = (0, _moment2['default'])();
				var notificationExpires = (0, _moment2['default'])(item.expires);
	
				if (currentDate.isBefore(notificationExpires)) {
					return true;
				}
	
				return false;
			}
		}, {
			key: 'capitalizeFirstLetter',
			value: function capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var errors = _props.errors;
				var isPhone = _props.isPhone;
				var notifications = _props.notifications;
	
				return _react2['default'].createElement(
					'div',
					{ className: _authScss2['default'].authWrappNew },
					_react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].authFormsContainer },
						_react2['default'].createElement(
							'div',
							{ className: _authScss2['default'].loginForm },
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].formImage },
								_react2['default'].createElement('img', { src: __webpack_require__(260) })
							),
							_react2['default'].createElement(
								'form',
								{ onSubmit: function (ev) {
										return _this.loginClicked(ev);
									}, method: 'post', className: _authScss2['default'].form, autoComplete: 'off' },
								_react2['default'].createElement('input', { autoComplete: 'off', name: 'hidden', type: 'text', style: { display: "none" } }),
								_react2['default'].createElement(
									'div',
									{ className: _authScss2['default'].formGroup },
									_react2['default'].createElement(
										'label',
										{ htmlFor: 'name' },
										_('email')
									),
									_react2['default'].createElement('input', { ref: 'login', type: 'text', name: 'login' })
								),
								_react2['default'].createElement(
									'div',
									{ className: _authScss2['default'].formGroup },
									_react2['default'].createElement(
										'label',
										{ htmlFor: 'password' },
										_('password')
									),
									_react2['default'].createElement('input', { ref: 'password', type: 'password', name: 'password', autoComplete: 'new-password' })
								),
								_react2['default'].createElement(
									'div',
									{ className: _authScss2['default'].errorMessage },
									errors && _(errors.id)
								),
								_react2['default'].createElement(
									'div',
									{ className: _authScss2['default'].formGroup },
									_react2['default'].createElement(
										'button',
										{ type: 'submit', className: (0, _classnames2['default'])(_authScss2['default'].submitButton, 'client') },
										_('loginBttn')
									)
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].formGroup },
								_react2['default'].createElement(
									'button',
									{ onClick: function () {
											return _this.registrationClicked();
										}, className: _authScss2['default'].registerButton },
									_('registerBttn')
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ id: 'casper_passForgotten', className: _authScss2['default'].additionalOption },
							_react2['default'].createElement(
								'a',
								{ onClick: function () {
										return _this.resetPassword();
									} },
								_('passwordForgotten')
							)
						)
					),
					notifications && notifications.length > 0 && this.isValidNotification(notifications) && _react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].notificationWrapper },
						_react2['default'].createElement(
							'span',
							null,
							notifications.map(function (notification, key) {
								return _this.getNotificationMessage(notification);
							})
						)
					)
				);
			}
		}]);
	
		var _LoginClient = LoginClient;
		LoginClient = (0, _reactRedux.connect)(function (state) {
			return {
				errors: state.auth.errors,
				isPhone: state.responsive.isPhone,
				// hack to reload on translation load
				dict: state.dict,
				notifications: state.notifications.items,
				language: state.app.lang
			};
		})(LoginClient) || LoginClient;
		return LoginClient;
	})(_react2['default'].Component);
	
	exports['default'] = LoginClient;
	module.exports = exports['default'];

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _authScss = __webpack_require__(135);
	
	var _authScss2 = _interopRequireDefault(_authScss);
	
	var _reactStringReplace = __webpack_require__(496);
	
	var _reactStringReplace2 = _interopRequireDefault(_reactStringReplace);
	
	var _stateActions = __webpack_require__(5);
	
	var _stateActionsApi = __webpack_require__(125);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('passwordChange');
	
	var PasswordReset = (function (_React$Component) {
		_inherits(PasswordReset, _React$Component);
	
		function PasswordReset() {
			_classCallCheck(this, _PasswordReset);
	
			_get(Object.getPrototypeOf(_PasswordReset.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(PasswordReset, [{
			key: 'changePassword',
			value: function changePassword(ev) {
				ev.preventDefault();
				var _props = this.props;
				var dispatch = _props.dispatch;
				var password = _props.password;
	
				var oldPassword = password || this.refs.oldPassword.value;
				var newPassword = this.refs.newPassword.value;
				var confirmNewPassword = this.refs.confirmNewPassword.value;
				var confirmPrivacyPolicy = this.refs.confirmPrivacyPolicy.checked;
				var regex = /^(?=[^0-9])(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])(?=.*[_\-$%.!:<>*#%])[a-zA-Z0-9_\-$.!:<>*#%]{10,}$/;
	
				if (!oldPassword) {
					// Note: next time, just use redux-form validation
					dispatch((0, _stateActionsApi.hasErrors)('oldPasswordWrong'));
					return;
				}
	
				if (oldPassword === newPassword) {
					dispatch((0, _stateActionsApi.hasErrors)('cantUseTheSamePassword'));
					return;
				}
	
				if (newPassword !== confirmNewPassword) {
					dispatch((0, _stateActionsApi.hasErrors)('checkConfirmPassword'));
					return;
				}
	
				if (!regex.test(newPassword)) {
					dispatch((0, _stateActionsApi.hasErrors)('passwordRules'));
					return;
				}
	
				if (!confirmPrivacyPolicy) {
					dispatch((0, _stateActionsApi.hasErrors)('checkConfirmPrivacyPolicy'));
					return;
				}
	
				dispatch((0, _stateActions.changePassword)(oldPassword, newPassword));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props2 = this.props;
				var errors = _props2.errors;
				var password = _props2.password;
	
				var regEx = /(https?:\/\/\S+)/g;
				var replacementFunction = function replacementFunction(match, i, ofset) {
					return _react2['default'].createElement(
						'a',
						{ href: match, key: match + i },
						match
					);
				};
				var checkboxDescription = (0, _reactStringReplace2['default'])(_('privacyStatementCheckbox'), regEx, replacementFunction);
				return _react2['default'].createElement(
					'div',
					{ className: _authScss2['default'].changePaswordFormsContainer },
					_react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].loginForm },
						_react2['default'].createElement(
							'div',
							{ className: (0, _classnames2['default'])(_authScss2['default'].formImage, _authScss2['default'].passwordChangeImage) },
							_react2['default'].createElement('img', { src: __webpack_require__(171) })
						),
						_react2['default'].createElement(
							'form',
							{ onSubmit: function (ev) {
									return _this.changePassword(ev);
								}, method: 'post', className: _authScss2['default'].form },
							_react2['default'].createElement(
								'div',
								{ className: (0, _classnames2['default'])(_authScss2['default'].formGroup, _authScss2['default'].formPaswordChangeGroup) },
								!password && _react2['default'].createElement(
									'label',
									null,
									_('oldPassword'),
									_react2['default'].createElement('input', { ref: 'oldPassword', type: 'password', name: 'oldPassword' })
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: (0, _classnames2['default'])(_authScss2['default'].info, _authScss2['default'].formPaswordChangeGroup) },
								_('passwordRules')
							),
							_react2['default'].createElement(
								'div',
								{ className: (0, _classnames2['default'])(_authScss2['default'].formGroup, _authScss2['default'].formPaswordChangeGroup) },
								_react2['default'].createElement(
									'label',
									null,
									_('newPassword'),
									_react2['default'].createElement('input', { ref: 'newPassword', type: 'password', name: 'newPassword' })
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: (0, _classnames2['default'])(_authScss2['default'].formGroup, _authScss2['default'].formPaswordChangeGroup) },
								_react2['default'].createElement(
									'label',
									null,
									_('confirmNewPassword'),
									_react2['default'].createElement('input', { ref: 'confirmNewPassword', type: 'password', name: 'confirmNewPassword' })
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: (0, _classnames2['default'])(_authScss2['default'].info, _authScss2['default'].paswordChangeInfo) },
								_react2['default'].createElement(
									'span',
									{ className: (0, _classnames2['default'])(_authScss2['default'].privacyCheckboxLabel) },
									_react2['default'].createElement('input', { ref: 'confirmPrivacyPolicy', type: 'checkbox', name: 'confirmPrivacyPolicy' }),
									_react2['default'].createElement(
										'span',
										null,
										checkboxDescription
									)
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: (0, _classnames2['default'])(_authScss2['default'].errorMessage, _authScss2['default'].formPaswordChangeGroup) },
								errors && _(errors.id)
							),
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].formGroup },
								_react2['default'].createElement(
									'button',
									{ className: (0, _classnames2['default'])(_authScss2['default'].submitButton, _authScss2['default'].formPaswordChangeGroup) },
									_('changePassword')
								)
							)
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				errors: _react2['default'].PropTypes.object,
				password: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		var _PasswordReset = PasswordReset;
		PasswordReset = (0, _reactRedux.connect)(function (state) {
			return {
				password: state.auth.password,
				errors: state.auth.errors
			};
		})(PasswordReset) || PasswordReset;
		return PasswordReset;
	})(_react2['default'].Component);
	
	exports['default'] = PasswordReset;
	module.exports = exports['default'];

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(57);
	
	var _reactRedux = __webpack_require__(4);
	
	var _authScss = __webpack_require__(135);
	
	var _authScss2 = _interopRequireDefault(_authScss);
	
	var _libValidator = __webpack_require__(96);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('passwordReset');
	
	var validate = function validate(values) {
		var errors = {};
		if (!(0, _libValidator.isAnEmail)(values.email)) {
			errors.email = _('wrongEmail');
		}
		return errors;
	};
	
	var ResetForm = (function (_React$Component) {
		_inherits(ResetForm, _React$Component);
	
		function ResetForm() {
			_classCallCheck(this, _ResetForm);
	
			_get(Object.getPrototypeOf(_ResetForm.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ResetForm, [{
			key: 'touch',
			value: function touch(field) {
				field.onBlur();
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props;
				var email = _props.fields.email;
				var handleSubmit = _props.handleSubmit;
				var options = _props.options;
				var isPhone = _props.isPhone;
				var goBack = _props.goBack;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].loginForm },
						_react2['default'].createElement(
							'div',
							{ className: _authScss2['default'].formImage },
							_react2['default'].createElement('img', { src: __webpack_require__(260) })
						),
						_react2['default'].createElement(
							'div',
							{ className: _authScss2['default'].info },
							options.ok ? _('retrieve') : _('retrieveMSG')
						),
						!options.ok && _react2['default'].createElement(
							'form',
							{ onSubmit: handleSubmit, method: 'post', className: _authScss2['default'].form },
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].formGroup },
								_react2['default'].createElement(
									'label',
									{ htmlFor: 'email' },
									_('email')
								),
								_react2['default'].createElement('input', _extends({ placeholder: 'email' }, email))
							),
							email.touched && email.error && _react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].errorMessage },
								email.error
							),
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].formGroup },
								_react2['default'].createElement(
									'button',
									{ onClick: handleSubmit, className: (0, _classnames2['default'])(_authScss2['default'].submitButton, 'client') },
									_('retrieveBth')
								)
							)
						)
					),
					options.ok ? _react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].formGroup },
						_react2['default'].createElement(
							'button',
							{ onClick: goBack, className: (0, _classnames2['default'])(_authScss2['default'].submitButton, 'client') },
							_('passwordResetButton')
						)
					) : _react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].additionalOption },
						_react2['default'].createElement(
							'a',
							{ onClick: goBack },
							_('passwordForgotten')
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				fields: _react2['default'].PropTypes.object.isRequired,
				handleSubmit: _react2['default'].PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		var _ResetForm = ResetForm;
		ResetForm = (0, _reduxForm.reduxForm)({
			form: "mail",
			fields: ["email"],
			validate: validate,
			destroyOnUnmount: true,
			touchOnBlur: true
		})(ResetForm) || ResetForm;
		return ResetForm;
	})(_react2['default'].Component);
	
	var PasswordReset = (function (_React$Component2) {
		_inherits(PasswordReset, _React$Component2);
	
		function PasswordReset() {
			_classCallCheck(this, _PasswordReset);
	
			_get(Object.getPrototypeOf(_PasswordReset.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(PasswordReset, [{
			key: 'retrievePassword',
			value: function retrievePassword(email) {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.retrievePassword)(email));
			}
		}, {
			key: 'goBack',
			value: function goBack() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.changeAuthState)(null));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props2 = this.props;
				var options = _props2.options;
				var isPhone = _props2.isPhone;
	
				return _react2['default'].createElement(
					'div',
					{ className: _authScss2['default'].authFormsContainer },
					_react2['default'].createElement(ResetForm, {
						goBack: function () {
							return _this.goBack();
						},
						options: options,
						onSubmit: function (_ref) {
							var email = _ref.email;
							return _this.retrievePassword(email);
						}
					})
				);
			}
		}]);
	
		var _PasswordReset = PasswordReset;
		PasswordReset = (0, _reactRedux.connect)(function (state) {
			return {
				options: state.auth.options,
				isPhone: state.responsive.isPhone
			};
		})(PasswordReset) || PasswordReset;
		return PasswordReset;
	})(_react2['default'].Component);
	
	exports['default'] = PasswordReset;
	module.exports = exports['default'];

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(57);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _bpostSelect = __webpack_require__(365);
	
	var _bpostSelect2 = _interopRequireDefault(_bpostSelect);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _registrationScss = __webpack_require__(1586);
	
	var _registrationScss2 = _interopRequireDefault(_registrationScss);
	
	var _phoneCountryCodesSelect = __webpack_require__(1138);
	
	var _phoneCountryCodesSelect2 = _interopRequireDefault(_phoneCountryCodesSelect);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectSelectWrap2 = _interopRequireDefault(_sharedSelectSelectWrap);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var cE = _react2['default'].createElement;
	var N = {};
	
	var wanted = ['clientNumber', 'firstName', 'name', 'street', 'isBelgium', 'number', 'dateOfBirth', 'placeOfBirth', 'email', 'emailAgain', 'phone_code', 'phoneNumber', 'policy'];
	var wantedBelgium = ['zipCity'];
	var wantedNotBelgium = ['country', 'city', 'zip'];
	var ifCompany = ['companyName', 'companyRegistrationNumber'];
	var allFields = ['isCompany', 'optOut', 'lang', 'bus'].concat(wanted, ifCompany, wantedBelgium, wantedNotBelgium);
	
	var _ = (0, _libI18n2['default'])('register');
	
	var placeholder = { dateOfBirth: "DD-MM-JJJJ" };
	
	__webpack_require__(260);
	// this is required for low level IE
	__webpack_require__(2260);
	
	var Field = function Field(_ref) {
	    var field = _ref.field;
	    var name = _ref.field.name;
	    var type = _ref.type;
	    var options = _ref.options;
	    var surroundOptions = _ref.surroundOptions;
	
	    var extraClassName = surroundOptions && (surroundOptions.className && "field-" + name + "-" + surroundOptions.className || "field-" + name) || "field-" + name;
	    return _react2['default'].createElement(
	        'label',
	        { className: _registrationScss2['default'][extraClassName] },
	        surroundOptions && surroundOptions.label || _(name),
	        (function () {
	            switch (type) {
	                case 'date':
	                    return _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, _extends({}, field, { placeholder: '', className: _registrationScss2['default'].dateOfBirth }));
	                case 'select':
	                    return _react2['default'].createElement(_sharedSelectSelectWrap2['default'], _extends({}, field, { options: options }));
	                case 'BpostSelect':
	                    return _react2['default'].createElement(_bpostSelect2['default'], field);
	                case 'PhoneCountryCodesSelect':
	                    return _react2['default'].createElement(_phoneCountryCodesSelect2['default'], field);
	                default:
	                    return _react2['default'].createElement('input', _extends({ type: 'text', placeholder: placeholder[field] }, field));
	            }
	        })(),
	        ' ',
	        field.error && field.touched && _react2['default'].createElement(
	            'div',
	            { className: _registrationScss2['default'].error },
	            ' ',
	            field.error,
	            ' '
	        )
	    );
	};
	
	var langOpt = [{ value: 'nl', label: 'NL' }, { value: 'fr', label: 'FR' }];
	
	var Registration = function Registration(_ref2) {
	    var fields = _ref2.fields;
	    var handleSubmit = _ref2.handleSubmit;
	    var setLang = _ref2.setLang;
	    var onChangeIsBelgiumHandler = _ref2.onChangeIsBelgiumHandler;
	
	    var makeField = function makeField(fieldName, type, options, surroundOptions) {
	        return cE(Field, {
	            key: fieldName,
	            field: fields[fieldName],
	            type: type,
	            options: options,
	            surroundOptions: surroundOptions
	        });
	    };
	    var isNotBelgiumSelected = Number(fields.isBelgium.value) > 0 ? false : true;
	
	    var isBelgOpt = [{ value: "0", label: _('yes') }, { value: "1", label: _('no') }];
	
	    return cE('div', { className: _registrationScss2['default'].form }, cE('div', { className: _registrationScss2['default'].top }, cE('img', {
	        id: _registrationScss2['default'].logo,
	        src: __webpack_require__(260)
	    }), cE('div', { className: _registrationScss2['default'].langInput }, _react2['default'].createElement(
	        'label',
	        null,
	        _react2['default'].createElement(_sharedSelectSelectWrap2['default'], _extends({
	            className: _registrationScss2['default'].language,
	            options: langOpt
	        }, fields.lang, {
	            onChange: function (ev) {
	                setLang(ev.value);
	            },
	            value: global.lang
	        }))
	    ))), cE('div', {
	        className: _registrationScss2['default'].inputDiv
	    }, makeField('isCompany', 'select', [{
	        value: "",
	        label: _('personOpt')
	    }, {
	        value: "1",
	        label: _('companyOpt')
	    }]), makeField('clientNumber'), Number(fields.isCompany.value) ? [makeField('companyName'), makeField('companyRegistrationNumber')] : [], [makeField('firstName'), makeField('name'), cE('div', { key: 'isBelgium' }, _react2['default'].createElement(
	        'label',
	        { className: _registrationScss2['default']["field-isBelgium"] },
	        _("isBelgium"),
	        _react2['default'].createElement(_sharedSelectSelectWrap2['default'], _extends({
	            options: isBelgOpt
	        }, fields.isBelgium, {
	            onChange: function (e) {
	                return onChangeIsBelgiumHandler(e);
	            },
	            value: fields.isBelgium.value
	        }))
	    )), !isNotBelgiumSelected ? [makeField('country', 'text', {}, { label: _('countryName') })] : [], makeField('street'), makeField('number'), makeField('bus', 'text', {}, { label: _("registration_bus") }), isNotBelgiumSelected ? [makeField('zipCity', 'BpostSelect')] : [makeField('zip', 'text', {}, { label: _('zip'), className: !isNotBelgiumSelected ? "noBelgian" : "" }), makeField('city', 'text', {}, { label: _('city'), className: !isNotBelgiumSelected ? "noBelgian" : "" })], cE('br', { key: 'br0' }), makeField('dateOfBirth', 'date'), makeField('placeOfBirth'), makeField('email'), makeField('emailAgain', 'text', {}, {
	        label: _("repeat_email")
	    }), makeField('phone_code', 'PhoneCountryCodesSelect'), makeField('phoneNumber', 'text', {}, { label: _('phoneNumber') })]), _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	            'span',
	            { key: 0 },
	            ' ',
	            _('privacyPart1'),
	            ' '
	        ),
	        ' ',
	        _react2['default'].createElement(
	            'a',
	            { target: '_new', href: _('privacyLinks') },
	            _react2['default'].createElement(
	                'span',
	                { key: 0 },
	                _('privacyPart2')
	            ),
	            ' '
	        ),
	        '.'
	    ), _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	            'span',
	            { key: 0 },
	            ' ',
	            _('privacyPart5'),
	            ' '
	        ),
	        _react2['default'].createElement(
	            'a',
	            { target: '_new', href: _('privacyLinks2') },
	            _react2['default'].createElement(
	                'span',
	                { key: 0 },
	                _('privacyPart2')
	            )
	        ),
	        '  ',
	        _react2['default'].createElement('input', _extends({ type: 'checkbox' }, fields.policy)),
	        fields.policy.error && fields.policy.touched && _react2['default'].createElement(
	            'div',
	            { className: _registrationScss2['default'].error },
	            ' ',
	            fields.policy.error,
	            ' '
	        )
	    ), _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	            'span',
	            { key: 0 },
	            ' ',
	            _('privacyPart3'),
	            ' '
	        )
	    ), _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	            'span',
	            { key: 0 },
	            ' ',
	            _('privacyPart4'),
	            ' '
	        ),
	        '   ',
	        _react2['default'].createElement('input', _extends({ type: 'checkbox' }, fields.optOut))
	    ), cE('button', {
	        type: 'button',
	        className: _registrationScss2['default'].button,
	        style: {
	            marginTop: "2em"
	        },
	        onClick: handleSubmit
	    }, _('register')), cE('button', {
	        type: 'button',
	        className: _registrationScss2['default'].backButton,
	        style: {
	            marginTop: "10px"
	        },
	        onClick: function onClick() {
	            return window.location.reload();
	        }
	    }, _('back')));
	};
	
	var ConnReg = (0, _reduxForm.reduxForm)({
	    form: 'registration',
	    destroyOnUnmount: false,
	    fields: allFields,
	    validate: function validate(data) {
	        var errors = undefined;
	        errors = {};
	        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
	            errors.email = _('invalidEmail');
	        }
	        if (data.email !== data.emailAgain) {
	            errors.emailAgain = _('email_not_match');
	        }
	        if (!(0, _moment2['default'])(data.dateOfBirth).isValid()) {
	            errors.dateOfBirth = _('invalidDate');
	        }
	
	        if (wanted.includes("isBelgium")) {
	            data.isBelgium = data.isBelgium === undefined ? "0" : data.isBelgium;
	        }
	
	        var extraRequireArray = wantedBelgium;
	        if (Number(data.isBelgium) === 1) {
	            extraRequireArray = wantedNotBelgium;
	        }
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = extraRequireArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var fieldName = _step.value;
	
	                if (!data[fieldName]) {
	                    errors[fieldName] = _('required');
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = wanted[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var fieldName = _step2.value;
	
	                if (!data[fieldName]) {
	                    errors[fieldName] = _('required');
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                    _iterator2['return']();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        if (data.isCompany) {
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = ifCompany[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var fieldName = _step3.value;
	
	                    if (!data[fieldName]) {
	                        errors[fieldName] = _('required');
	                    }
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	                        _iterator3['return']();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	        }
	        return errors;
	    }
	})(Registration);
	
	var Stuff = (function (_React$Component) {
	    _inherits(Stuff, _React$Component);
	
	    function Stuff() {
	        _classCallCheck(this, _Stuff);
	
	        _get(Object.getPrototypeOf(_Stuff.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Stuff, [{
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var reg = _props.reg;
	            var lang = _props.lang;
	            var dispatch = _props.dispatch;
	
	            return cE('div', {}, reg.isSending ? _('to_send') : reg.sent ? cE('div', { className: _registrationScss2['default'].registrationConfirmationContainer }, cE('p', N, _('request_has_been_sent')), cE('p', N, _('you_will_receive_your_login'))) : reg.problem ? cE('div', N, _('a_problem_has_occured') + reg.problem, cE('button', {
	                onClick: function onClick() {
	                    return _this.props.dispatch((0, _stateActions.backToForm)());
	                }
	            }, _('try_again'))) : cE(ConnReg, {
	                initialValues: {
	                    lang: lang,
	                    isBelgium: "0",
	                    phone_code: "0032"
	                },
	                setLang: function setLang(lang) {
	                    _this.props.dispatch((0, _stateActions.setLang)(lang));
	                },
	                onChangeIsBelgiumHandler: function onChangeIsBelgiumHandler(e) {
	                    if (e.value == 0) {
	                        _this.props.dispatch((0, _reduxForm.change)("registration", "phone_code", "0032"));
	                    } else {
	                        _this.props.dispatch((0, _reduxForm.change)("registration", "phone_code", ""));
	                    }
	                    _this.props.dispatch((0, _reduxForm.change)("registration", "isBelgium", e.value));
	                },
	                onSubmit: function onSubmit(data) {
	                    var _ref3 = Number(data.isBelgium) !== 1 ? data.zipCity.split('_') : [data.zip, data.city];
	
	                    var _ref32 = _slicedToArray(_ref3, 2);
	
	                    var postalCode = _ref32[0];
	                    var locality = _ref32[1];
	
	                    data.lang = global.lang;
	                    var splitPhoneNumber = data.phoneNumber.split('');
	                    if (splitPhoneNumber[0] === '0') {
	                        splitPhoneNumber[0] = data.phone_code;
	                        data.phoneNumber = splitPhoneNumber.join('');
	                    } else {
	                        data.phoneNumber = '' + data.phone_code + data.phoneNumber;
	                    }
	                    delete data.phone_code;
	                    var allData = _extends({}, data, {
	                        zipCity: undefined,
	                        postalCode: postalCode,
	                        locality: locality
	                    });
	                    _this.props.dispatch((0, _stateActions.sendForm)(allData));
	                }
	            }));
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            reg: _react2['default'].PropTypes.object,
	            dispatch: _react2['default'].PropTypes.func,
	            lang: _react2['default'].PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    var _Stuff = Stuff;
	    Stuff = (0, _reactRedux.connect)(function (state) {
	        return {
	            reg: state.registration,
	            lang: state.app.lang
	        };
	    })(Stuff) || Stuff;
	    return Stuff;
	})(_react2['default'].Component);
	
	exports['default'] = Stuff;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _authScss = __webpack_require__(135);
	
	var _authScss2 = _interopRequireDefault(_authScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('sms');
	
	var Sms = (function (_React$Component) {
		_inherits(Sms, _React$Component);
	
		function Sms() {
			_classCallCheck(this, _Sms);
	
			_get(Object.getPrototypeOf(_Sms.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Sms, [{
			key: 'verifyClicked',
			value: function verifyClicked(ev) {
				ev.preventDefault();
	
				var dispatch = this.props.dispatch;
	
				var token = this.refs.token.value;
				dispatch((0, _stateActions.checkSMStoken)(token, false, false));
			}
		}, {
			key: 'resendToken',
			value: function resendToken() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.resendSMStoken)());
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var errors = _props.errors;
				var options = _props.options;
	
				return _react2['default'].createElement(
					'div',
					{ className: _authScss2['default'].authFormsContainer },
					_react2['default'].createElement(
						'div',
						{ className: _authScss2['default'].loginForm },
						_react2['default'].createElement(
							'div',
							{ className: _authScss2['default'].formImage },
							_react2['default'].createElement('img', { src: __webpack_require__(171) })
						),
						_react2['default'].createElement(
							'div',
							{ className: _authScss2['default'].info },
							options.smsSent ? options.smsResent ? _('newSmsMSG') + " " + options.number : _('firstSmsMSG') + " " + options.number : _('secondSmsMSG') + options.number + ")"
						),
						_react2['default'].createElement(
							'form',
							{ id: 'casper_sms', onSubmit: function (ev) {
									return _this.verifyClicked(ev);
								}, method: 'post', className: _authScss2['default'].form },
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].formGroup },
								_react2['default'].createElement(
									'label',
									{ htmlFor: 'token' },
									_('codeLabel')
								),
								_react2['default'].createElement('input', { id: 'casper_sms', ref: 'token', name: 'token', autoFocus: true })
							),
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].errorMessage },
								errors && _(errors.id)
							),
							_react2['default'].createElement(
								'div',
								{ className: _authScss2['default'].formGroup },
								_react2['default'].createElement(
									'button',
									{ id: 'casper_sms', className: _authScss2['default'].submitButton },
									_('verification')
								)
							)
						)
					),
					!options.smsResent && _react2['default'].createElement(
						'div',
						{ id: 'casper_smsForgot', className: _authScss2['default'].additionalOption },
						_react2['default'].createElement(
							'a',
							{ onClick: function () {
									return _this.resendToken();
								} },
							_('sendCodeMSG')
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				errors: _react2['default'].PropTypes.object,
				options: _react2['default'].PropTypes.object,
				isPhone: _react2['default'].PropTypes.bool
			},
			enumerable: true
		}]);
	
		var _Sms = Sms;
		Sms = (0, _reactRedux.connect)(function (state) {
			return {
				errors: state.auth.errors,
				isPhone: state.responsive.isPhone
			};
		})(Sms) || Sms;
		return Sms;
	})(_react2['default'].Component);
	
	exports['default'] = Sms;
	module.exports = exports['default'];

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementsComponentPageDom = __webpack_require__(219);
	
	var _elementsComponentPageDom2 = _interopRequireDefault(_elementsComponentPageDom);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('b2b');
	
	var B2b = (function (_React$Component) {
		_inherits(B2b, _React$Component);
	
		function B2b() {
			_classCallCheck(this, B2b);
	
			_get(Object.getPrototypeOf(B2b.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(B2b, [{
			key: 'render',
			value: function render() {
				var noHeader = this.props.noHeader;
	
				return _react2['default'].createElement(
					_elementsComponentPageDom2['default'],
					{
						noHeader: noHeader,
						title: _('title'),
						subtitle: _('subtitle')
					},
					_('selectInsuranceCompany')
				);
			}
		}]);
	
		return B2b;
	})(_react2['default'].Component);
	
	exports['default'] = B2b;
	module.exports = exports['default'];

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _stateActions = __webpack_require__(5);
	
	var B2bCompanyClientActionSelector = (function (_React$Component) {
		_inherits(B2bCompanyClientActionSelector, _React$Component);
	
		function B2bCompanyClientActionSelector() {
			_classCallCheck(this, _B2bCompanyClientActionSelector);
	
			_get(Object.getPrototypeOf(_B2bCompanyClientActionSelector.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(B2bCompanyClientActionSelector, [{
			key: 'updateClientAction',
			value: function updateClientAction(currentClientAction) {
				var _props = this.props;
				var dispatch = _props.dispatch;
				var policyActions = _props.policyActions;
	
				var oenCategoryGroup = policyActions && policyActions[currentClientAction] && policyActions[currentClientAction].actionCategories || [];
				var policySubActions = {};
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = (oenCategoryGroup || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var cSubAction = _step.value;
	
						policySubActions[cSubAction.category] = cSubAction;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator['return']) {
							_iterator['return']();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				dispatch((0, _stateActions.setB2bCompanyClientSubAction)(""));
				dispatch((0, _stateActions.b2bCompanySwitchSubActions)(policySubActions));
				dispatch((0, _stateActions.setB2bCompanyClientAction)(currentClientAction));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props2 = this.props;
				var currentClientAction = _props2.currentClientAction;
				var actionNames = _props2.actionNames;
	
				var options = [];
				if (!_underscore2['default'].isEmpty(actionNames)) {
					var keys = Object.keys(actionNames);
					keys && keys.forEach(function (key) {
						options.push({
							label: actionNames[key],
							value: key
						});
					});
				}
				return _react2['default'].createElement(
					'span',
					{ className: (0, _classnames2['default'])('B2bCompanyClientActionSelector', this.props.styleName) },
					options.length >= 1 ? _react2['default'].createElement(_sharedSelectSelectWrap.SelectWrapper, {
						value: currentClientAction,
						options: options,
						isClearable: false,
						onChange: function (item) {
							return _this.updateClientAction(item.value);
						}
					}) : _react2['default'].createElement(
						'span',
						null,
						currentClientAction
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				policyActions: _react2['default'].PropTypes.object.isRequired,
				currentClientAction: _react2['default'].PropTypes.string,
				actionNames: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		var _B2bCompanyClientActionSelector = B2bCompanyClientActionSelector;
		B2bCompanyClientActionSelector = (0, _reactRedux.connect)(function (state) {
			return {
				policyActions: state.b2bCompany.policyActions
			};
		})(B2bCompanyClientActionSelector) || B2bCompanyClientActionSelector;
		return B2bCompanyClientActionSelector;
	})(_react2['default'].Component);
	
	exports['default'] = B2bCompanyClientActionSelector;
	module.exports = exports['default'];

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _b2bCompanyClientContractsScss = __webpack_require__(1587);
	
	var _b2bCompanyClientContractsScss2 = _interopRequireDefault(_b2bCompanyClientContractsScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _clientsClientContractsZoom = __webpack_require__(604);
	
	var _clientsClientContractsZoom2 = _interopRequireDefault(_clientsClientContractsZoom);
	
	var _refreshBtn = __webpack_require__(174);
	
	var _refreshBtn2 = _interopRequireDefault(_refreshBtn);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clientContracts');
	
	var Results = function Results(_ref) {
		var data = _ref.data;
		var selectedContract = _ref.selectedContract;
		var checkIt = _ref.checkIt;
		var onRefresh = _ref.onRefresh;
	
		var icons = {
			0: 'c-credit',
			1: 'c-life',
			2: 'c-health',
			3: 'c-home',
			4: 'c-family',
			5: 'c-automotive',
			6: 'c-workinjuries',
			7: 'c-fire',
			8: 'c-transport',
			9: 'c-misc'
		};
		return _react2['default'].createElement(
			'div',
			{ className: _b2bCompanyClientContractsScss2['default'].clientsTableContainer },
			_react2['default'].createElement(
				_componentsReactable.Table,
				{
					className: _b2bCompanyClientContractsScss2['default'].table,
					itemsPerPage: 10,
					filterable: ["contractNumber", "mainBranche", "mainRisk", "insuranceCompany", "contractState"],
					sortable: ["contractNumber", "mainBranche", "mainRisk", "insuranceCompany", "contractState"],
					defaultSort: {
						column: 'contractState',
						direction: 'asc'
					},
					topPaginationElemL: [_react2['default'].createElement(_refreshBtn2['default'], {
						key: 'r',
						onClick: function () {
							onRefresh(true);
						}
					})]
				},
				_react2['default'].createElement(
					_componentsReactable.Thead,
					null,
					_react2['default'].createElement(_componentsReactable.Th, { column: 'contractCheck', label: '' }),
					_react2['default'].createElement(_componentsReactable.Th, { column: 'claimIcon', label: '' }),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'contractNumber' },
						_react2['default'].createElement(
							'strong',
							null,
							_('contractNumber')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'mainBranche' },
						_react2['default'].createElement(
							'strong',
							null,
							_('mainBranche')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'mainRisk' },
						_react2['default'].createElement(
							'strong',
							null,
							_('mainRisk')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'insuranceCompany' },
						_react2['default'].createElement(
							'strong',
							null,
							_('insuranceCompany')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'contractState' },
						_react2['default'].createElement(
							'strong',
							null,
							_('contractState')
						)
					)
				),
				data && data.map(function (item, key) {
					return _react2['default'].createElement(
						_componentsReactable.Tr,
						{
							className: 'centered clickable',
							key: key, onClick: function () {
								return checkIt(item);
							}
						},
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'contractCheck' },
							_react2['default'].createElement('input', { type: 'radio',
								checked: selectedContract && selectedContract.contractNumber === item.contractNumber || false
							})
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'claimIcon' },
							_react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientContractsScss2['default'].iconContainer },
								_react2['default'].createElement('img', { src: __webpack_require__(1017)("./" + icons[item.brancheCode] + '_2x.png') })
							)
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'contractNumber' },
							item.contractNumber
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'mainBranche' },
							item.mainBranche
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'mainRisk' },
							item.mainRisk
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'insuranceCompany' },
							item.insuranceCompany
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'contractState' },
							item.contractState
						)
					);
				})
			)
		);
	};
	
	var B2bCompanyClientContracts = (function (_React$Component) {
		_inherits(B2bCompanyClientContracts, _React$Component);
	
		function B2bCompanyClientContracts() {
			_classCallCheck(this, _B2bCompanyClientContracts);
	
			_get(Object.getPrototypeOf(_B2bCompanyClientContracts.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(B2bCompanyClientContracts, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var allContracts = _props.allContracts;
				var contracts = _props.contracts;
				var selectedPolicy = _props.selectedPolicy;
				var dispatch = _props.dispatch;
				var subModuleZoom = _props.subModuleZoom;
				var onSelectEdit = _props.onSelectEdit;
				var onRefresh = _props.onRefresh;
	
				var contract = selectedPolicy && allContracts[selectedPolicy.contractId];
				if (!contract && subModuleZoom) {
					(function () {
						var key = Object.keys(subModuleZoom)[0];
						if (key) {
							(function () {
								var value = subModuleZoom[key];
								contract = contracts.find(function (c) {
									return c[key] === value;
								});
							})();
						}
					})();
				}
				return _react2['default'].createElement(
					'div',
					{ className: _b2bCompanyClientContractsScss2['default'].moduleSection },
					contracts.length > 0 ? _react2['default'].createElement(Results, {
						data: contracts,
						selectedContract: contract,
						checkIt: function (contract) {
							return onSelectEdit(contract);
						},
						onRefresh: onRefresh
					}) : null
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				onSelectEdit: _react2['default'].PropTypes.func.isRequired,
				onRefresh: _react2['default'].PropTypes.func.isRequired,
				dispatch: _react2['default'].PropTypes.func.isRequired,
				data: _react2['default'].PropTypes.array,
				selectedPolicy: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		var _B2bCompanyClientContracts = B2bCompanyClientContracts;
		B2bCompanyClientContracts = (0, _reactRedux.connect)(function (state) {
			var clientId = state.b2bCompany.opened;
			var clientData = state.clients.clientData[clientId];
			var contracts = clientData.contractIds.map(function (id) {
				return state.contracts[id];
			});
			return {
				allContracts: state.contracts,
				contracts: contracts,
				selectedPolicy: state.b2bCompany.selectedPolicy,
				subModuleZoom: state.clients.subModuleZoom
			};
		})(B2bCompanyClientContracts) || B2bCompanyClientContracts;
		return B2bCompanyClientContracts;
	})(_react2['default'].Component);
	
	exports['default'] = B2bCompanyClientContracts;
	module.exports = exports['default'];

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _b2bCompanyClientProfileScss = __webpack_require__(1588);
	
	var _b2bCompanyClientProfileScss2 = _interopRequireDefault(_b2bCompanyClientProfileScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _libHelpers = __webpack_require__(24);
	
	var _ = (0, _libI18n2['default'])('clientProfile');
	
	var DateValue = function DateValue(_ref) {
	  var date = _ref.date;
	
	  var rest = _objectWithoutProperties(_ref, ['date']);
	
	  return _react2['default'].createElement(
	    'span',
	    rest,
	    (0, _libHelpers.formatDate)(date)
	  );
	};
	
	var printSelect = function printSelect(item, options) {
	  var itemValue = "";
	
	  options.map(function (key, i) {
	    if (Number(item) == Number(key.value)) {
	      itemValue = key.label;
	    }
	  });
	
	  return itemValue;
	};
	
	var clientLanguagePrintSelect = function clientLanguagePrintSelect(item, options, language, languageOptions) {
	  var convertedLanguage = undefined;
	
	  // Generate langauge code from
	  if (isNaN(language)) {
	    languageOptions.map(function (index, key) {
	      if (index.label == language) {
	        language = index.value;
	      }
	    });
	  }
	
	  if (language == 1) {
	    language = 'nl';
	  } else if (language == 2) {
	    language = 'fr';
	  } else if (language == 3) {
	    language = 'en';
	  } else {
	    language = 'nl';
	  }
	
	  options.map(function (index, key) {
	    if (index.value == item) {
	      convertedLanguage = index.label[language];
	    }
	  });
	
	  return convertedLanguage;
	};
	
	/**
	 * Generates the client dictionaries to have a same place for each dictionary
	 *
	 * @param Object clientOptionsDictionary 	The translate list from state.client.clientOptionsDict
	 * @param string language 								The language of the application - state.app.lang
	 */
	var generateClientDicts = function generateClientDicts(clientOptionsDict, language) {
	  var clientDictionaries = [];
	
	  clientDictionaries['personType'] = generateOptionsObject(clientOptionsDict.PERSOONSTYPE, language);
	  clientDictionaries['gender'] = generateOptionsObject(clientOptionsDict.GESLACHT, language);
	  clientDictionaries['nationality'] = generateOptionsObject(clientOptionsDict.NATIONALITEIT, language);
	  clientDictionaries['language'] = generateOptionsObject(clientOptionsDict.TAAL, language);
	  clientDictionaries['title'] = generateOptionsObject(clientOptionsDict.AANSPREKING, language);
	  clientDictionaries['licenceCategory'] = generateOptionsObject(clientOptionsDict.RB_CATEGORIE, language);
	  clientDictionaries['relationType'] = generateOptionsObject(clientOptionsDict.HOEDANIGHEID, language);
	  clientDictionaries['country'] = generateOptionsObject(clientOptionsDict.LAND, language);
	  clientDictionaries['legalForm'] = generateOptionsObject(clientOptionsDict.RECHTSVORM, language);
	  clientDictionaries['globalCountry'] = generateGlobalOptionsObject(clientOptionsDict.LAND);
	
	  return clientDictionaries;
	};
	
	var generateGlobalOptionsObject = function generateGlobalOptionsObject(optionsData) {
	  var optionsArray = [];
	
	  Object.keys(optionsData).map(function (key, index) {
	    optionsArray.push({ value: key, label: optionsData[key] });
	  });
	
	  return optionsArray;
	};
	
	/**
	 * Generate option array based on requested object data
	 * @param Object optionsData
	 * @param String language
	 *
	 * @return array
	 */
	var generateOptionsObject = function generateOptionsObject(optionsData, language) {
	  var optionsArray = [];
	
	  Object.keys(optionsData).map(function (key, index) {
	    optionsArray.push({ value: key, label: optionsData[key][language] });
	  });
	
	  return optionsArray;
	};
	
	var AddressValue = function AddressValue(_ref2) {
	  var addressData = _ref2.addressData;
	  var clientOptionsDict = _ref2.clientOptionsDict;
	  var clientLanguage = _ref2.clientLanguage;
	  var country = addressData.country;
	  var street = addressData.street;
	  var number = addressData.number;
	  var extension = addressData.extension;
	  var postalCode = addressData.postalCode;
	  var locality = addressData.locality;
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    street,
	    ' ',
	    number,
	    extension ? '/' + extension : '',
	    ' ',
	    _react2['default'].createElement('br', null),
	    postalCode,
	    ' ',
	    locality,
	    ' ',
	    !isNaN(country) ? clientLanguagePrintSelect(country, clientOptionsDict.globalCountry, clientLanguage, clientOptionsDict.language) : country
	  );
	};
	var PhoneValue = function PhoneValue(_ref3) {
	  var number = _ref3.number;
	  return _react2['default'].createElement(
	    'p',
	    { className: number['default'] === "true" && _b2bCompanyClientProfileScss2['default'].defaultNumber },
	    _react2['default'].createElement(
	      'a',
	      { href: 'callto:' + number.number },
	      number.number
	    ),
	    _react2['default'].createElement(
	      'a',
	      { href: 'callto:' + number.phone },
	      number.phone
	    )
	  );
	};
	
	var BankAcctValue = function BankAcctValue(_ref4) {
	  var BIC = _ref4.BIC;
	  var IBAN = _ref4.IBAN;
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'span',
	      { style: { fontWeight: 'bold' } },
	      IBAN
	    ),
	    _react2['default'].createElement('br', null),
	    _react2['default'].createElement(
	      'span',
	      { style: { fontStyle: 'italic' } },
	      BIC
	    )
	  );
	};
	var DriversLicenseValue = function DriversLicenseValue(_ref5) {
	  var licenceCategory = _ref5.licenceCategory;
	  var licenceDate = _ref5.licenceDate;
	  return _react2['default'].createElement(
	    'div',
	    null,
	    licenceCategory,
	    licenceDate && _react2['default'].createElement(
	      'span',
	      null,
	      ' (',
	      _react2['default'].createElement(DateValue, { date: licenceDate }),
	      ')'
	    )
	  );
	};
	var EasinsureValue = function EasinsureValue(_ref6) {
	  var eDate = _ref6.eDate;
	  return _react2['default'].createElement(
	    'div',
	    null,
	    eDate && _react2['default'].createElement(DateValue, { date: eDate })
	  );
	};
	var multiLineEmail = function multiLineEmail(data) {
	  return data && data.map(function (line, i) {
	    return _react2['default'].createElement(
	      'p',
	      { key: i },
	      _react2['default'].createElement(
	        'a',
	        { className: line['default'] == 'true' ? _b2bCompanyClientProfileScss2['default'].emailDefault : _b2bCompanyClientProfileScss2['default'].email, href: 'mailto:' + line.email },
	        line.email
	      )
	    );
	  });
	};
	var multiLinePhones = function multiLinePhones(data) {
	  return data && data.map(function (line, i) {
	    return _react2['default'].createElement(
	      'p',
	      { key: i },
	      _react2['default'].createElement(
	        'a',
	        { className: line['default'] == 'true' ? _b2bCompanyClientProfileScss2['default'].phoneDefault : _b2bCompanyClientProfileScss2['default'].phone, href: 'callto:' + line.number },
	        line.number
	      )
	    );
	  });
	};
	var EmailValue = function EmailValue(_ref7) {
	  var email = _ref7.email;
	  return _react2['default'].createElement(
	    'a',
	    { className: _b2bCompanyClientProfileScss2['default'].mail, href: 'mailto:' + email },
	    email
	  );
	};
	var ContactValue = function ContactValue(_ref8) {
	  var contactData = _ref8.contactData;
	  var clientOptionsDict = _ref8.clientOptionsDict;
	  var contactNumber = contactData.contactNumber;
	  var contactType = contactData.contactType;
	  var contactName = contactData.contactName;
	  var contactFirstName = contactData.contactFirstName;
	  var contactgender = contactData.contactgender;
	  var contactdateOfBirth = contactData.contactdateOfBirth;
	
	  if (contactgender == 'M') {
	    contactgender = 1;
	  }
	
	  if (contactgender == 'V') {
	    contactgender = 2;
	  }
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'p',
	      null,
	      _react2['default'].createElement(
	        'span',
	        { style: { fontWeight: 'bold' } },
	        !isNaN(contactType) ? printSelect(contactType, clientOptionsDict.relationType) : contactType
	      ),
	      ' ',
	      contactName,
	      ' ',
	      contactFirstName,
	      ' ( ',
	      contactNumber,
	      ' )'
	    ),
	    _('dateOfBirth'),
	    ' ',
	    (0, _libHelpers.formatDate)(contactdateOfBirth, 'eu'),
	    _react2['default'].createElement('br', null),
	    _('gender'),
	    ' ',
	    !isNaN(contactgender) ? printSelect(contactgender, clientOptionsDict.gender) : contactgender,
	    _react2['default'].createElement('br', null)
	  );
	};
	var UList = function UList(_ref9) {
	  var children = _ref9.children;
	  return _react2['default'].createElement(
	    'ul',
	    null,
	    children.map(function (c, i) {
	      return _react2['default'].createElement(
	        'li',
	        { key: i },
	        c
	      );
	    })
	  );
	};
	
	var ClientProfileDom = function ClientProfileDom(_ref10) {
	  var clientId = _ref10.clientId;
	  var clientDocuments = _ref10.clientDocuments;
	  var clientNumber = _ref10.clientNumber;
	  var dateOfBirth = _ref10.dateOfBirth;
	  var companyRegistrationNumber = _ref10.companyRegistrationNumber;
	  var gender = _ref10.gender;
	  var language = _ref10.language;
	  var emails = _ref10.emails;
	  var licences = _ref10.licences;
	  var phoneNumbers = _ref10.phoneNumbers;
	  var accountNumbers = _ref10.accountNumbers;
	  var contacts = _ref10.contacts;
	  var myEasinsure = _ref10.myEasinsure;
	  var address = _ref10.address;
	  var corrAddr = _ref10.corrAddr;
	  var name = _ref10.name;
	  var createClientAccess = _ref10.createClientAccess;
	  var updateClientAccess = _ref10.updateClientAccess;
	  var setSubModule = _ref10.setSubModule;
	  var clientOptionsDict = _ref10.clientOptionsDict;
	
	  var columns = clientNumber && [[{ label: _('clientNumber') + ':', value: clientNumber }, { label: _('gender') + ':', value: gender }, { label: _('language') + ':', value: language }, {
	    label: _('email') + ':',
	    value: multiLineEmail(emails)
	  }, {
	    label: _('licenceDate') + ':',
	    value: _react2['default'].createElement(
	      UList,
	      null,
	      licences.map(function (license, i) {
	        return _react2['default'].createElement(DriversLicenseValue, _extends({ key: i }, license));
	      })
	    )
	  }, { label: _('address') + ':', value: _react2['default'].createElement(AddressValue, { addressData: address, clientOptionsDict: clientOptionsDict, clientLanguage: language }) }, {
	    label: _('easinsureDate') + ":",
	    value: _react2['default'].createElement(EasinsureValue, { eDate: myEasinsure })
	  }], [{ label: _('dateOfBirth') + ':', value: _react2['default'].createElement(DateValue, { date: dateOfBirth }) }, { label: _('companyRegistrationNumber') + ':', value: companyRegistrationNumber }, {
	    label: _('phoneNumbers') + ':',
	    value: multiLinePhones(phoneNumbers)
	  }, {
	    label: _('IBAN') + ':',
	    value: _react2['default'].createElement(
	      UList,
	      null,
	      accountNumbers.map(function (account, key) {
	        return _react2['default'].createElement(BankAcctValue, _extends({}, account, { key: key }));
	      })
	    )
	  }, {
	    label: _('familyRelations') + ':',
	    value: _react2['default'].createElement(
	      UList,
	      null,
	      contacts.map(function (c, i) {
	        return _react2['default'].createElement(ContactValue, { key: i, contactData: c, clientOptionsDict: clientOptionsDict });
	      })
	    )
	  }, { label: _('correspondence') + ':', value: _react2['default'].createElement(AddressValue, { addressData: corrAddr, clientOptionsDict: clientOptionsDict, clientLanguage: language }) }]];
	
	  return _react2['default'].createElement(
	    'div',
	    { className: _b2bCompanyClientProfileScss2['default'].profileClient },
	    _react2['default'].createElement(
	      'div',
	      { className: _b2bCompanyClientProfileScss2['default'].moduleSection },
	      _react2['default'].createElement(
	        'div',
	        { className: _b2bCompanyClientProfileScss2['default'].moduleSectionHeading },
	        name,
	        _react2['default'].createElement(
	          'div',
	          { className: _b2bCompanyClientProfileScss2['default'].editClientProfile },
	          updateClientAccess && _react2['default'].createElement(
	            'button',
	            { className: 'btn green', onClick: function () {
	                return setSubModule('edit-profile');
	              } },
	            _('edit-profile')
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: _b2bCompanyClientProfileScss2['default'].moduleSectionContent },
	        columns ? _react2['default'].createElement(_KeyValue2['default'], { array: columns, divider: true }) : '…'
	      )
	    )
	  );
	};
	
	exports.ClientProfileDom = ClientProfileDom;
	
	var ClientProfile = (function (_Component) {
	  _inherits(ClientProfile, _Component);
	
	  function ClientProfile() {
	    _classCallCheck(this, _ClientProfile);
	
	    _get(Object.getPrototypeOf(_ClientProfile.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ClientProfile, [{
	    key: 'setSubModule',
	    value: function setSubModule(subModuleName) {
	      var _props = this.props;
	      var dispatch = _props.dispatch;
	      var clientId = _props.clientId;
	
	      dispatch((0, _stateActions.setB2bCompanyOpened)(clientId));
	      dispatch((0, _stateActions.setB2bCompanySubModule)(subModuleName));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props2 = this.props;
	      var clientId = _props2.clientId;
	      var data = _props2.data;
	      var createClientAccess = _props2.createClientAccess;
	      var updateClientAccess = _props2.updateClientAccess;
	      var clientOptionsDict = _props2.clientOptionsDict;
	
	      var detail = data && data.detail || {};
	      var main = data && data.main || {};
	      var clientDocuments = data && data.clientDocuments || [];
	
	      var clientNumber = main.clientNumber;
	      var dateOfBirth = main.dateOfBirth;
	      var companyRegistrationNumber = main.companyRegistrationNumber;
	      var name = main.name;
	      var gender = detail.gender;
	      var language = detail.language;
	      var emails = detail.emails;
	      var licences = detail.licences;
	      var phoneNumbers = detail.phoneNumbers;
	      var accountNumbers = detail.accountNumbers;
	      var contacts = detail.contacts;
	      var myEasinsure = detail.myEasinsure;
	
	      var address = data && main.mainAddress;
	      var corrAddr = data && detail.correspondanceAddress;
	
	      var setSubModule = function setSubModule(item) {
	        _this.setSubModule(item);
	      };
	
	      return _react2['default'].createElement(ClientProfileDom, _extends({
	        clientId: clientId,
	        clientDocuments: clientDocuments,
	        clientNumber: clientNumber, dateOfBirth: dateOfBirth, companyRegistrationNumber: companyRegistrationNumber,
	        gender: gender, language: language, emails: emails, licences: licences, phoneNumbers: phoneNumbers, accountNumbers: accountNumbers, contacts: contacts,
	        address: address, corrAddr: corrAddr, myEasinsure: myEasinsure, name: name,
	        createClientAccess: createClientAccess, updateClientAccess: updateClientAccess, clientOptionsDict: clientOptionsDict
	      }, {
	        setSubModule: setSubModule
	      }));
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      clientId: _react.PropTypes.string.isRequired,
	      data: _react2['default'].PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  var _ClientProfile = ClientProfile;
	  ClientProfile = (0, _reactRedux.connect)(function (state) {
	    var clientId = state.b2bCompany.opened;
	    var clientAccess = state.app.security.actions;
	    var appLanguage = state.app.lang;
	
	    var canCreateClient = undefined,
	        canUpdateClient = undefined;
	
	    // Generate options for client select lists
	    var clientOptionsDict = generateClientDicts(state.client.clientOptionsDict, appLanguage);
	
	    clientAccess.map(function (item, key) {
	      if (item.actionName == 'createclient') {
	        canCreateClient = item.actionAllowed === "true" ? true : false;
	      }
	
	      if (item.actionName == 'modifyclient') {
	        canUpdateClient = item.actionAllowed === "true" ? true : false;
	      }
	    });
	
	    return {
	      subModule: state.clients.subModule,
	      createClientAccess: canCreateClient,
	      updateClientAccess: canUpdateClient,
	      clientId: clientId,
	      clientOptionsDict: clientOptionsDict
	    };
	  })(ClientProfile) || ClientProfile;
	  return ClientProfile;
	})(_react.Component);
	
	exports['default'] = ClientProfile;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _clientsClientProfileEditScss = __webpack_require__(718);
	
	var _clientsClientProfileEditScss2 = _interopRequireDefault(_clientsClientProfileEditScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _libHelpers = __webpack_require__(24);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _clientsClientProfileForm = __webpack_require__(265);
	
	var _clientsClientProfileForm2 = _interopRequireDefault(_clientsClientProfileForm);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	/**
	 * Create connect to get requested states and actions
	 */
	
	/**
	 * Creates the edit profile page
	 */
	
	var B2bCompanyClientProfileEdit = (function (_Component) {
		_inherits(B2bCompanyClientProfileEdit, _Component);
	
		function B2bCompanyClientProfileEdit(props) {
			_classCallCheck(this, _B2bCompanyClientProfileEdit);
	
			_get(Object.getPrototypeOf(_B2bCompanyClientProfileEdit.prototype), 'constructor', this).call(this, props);
		}
	
		_createClass(B2bCompanyClientProfileEdit, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _props = this.props;
				var clientId = _props.clientId;
				var appLanguage = _props.appLanguage;
				var clientData = _props.clientData;
				var dispatch = _props.dispatch;
				var initializeProfileForm = _props.initializeProfileForm;
	
				dispatch(initializeProfileForm(clientData, clientId, 'edit'));
			}
	
			/**
	   * Implements the render function for the component
	   * Renders the component form data
	   */
		}, {
			key: 'render',
			value: function render() {
				var setSubModule = this.props.setSubModule;
	
				return _react2['default'].createElement(
					'div',
					{ className: _clientsClientProfileEditScss2['default'].profileClient },
					_react2['default'].createElement(
						'div',
						{ className: _clientsClientProfileEditScss2['default'].moduleSection },
						_react2['default'].createElement(
							'div',
							{ className: _clientsClientProfileEditScss2['default'].moduleSectionHeading },
							_('edit-profile')
						),
						_react2['default'].createElement(_clientsClientProfileForm2['default'], {
							setSubModule: setSubModule
						})
					)
				);
			}
		}]);
	
		var _B2bCompanyClientProfileEdit = B2bCompanyClientProfileEdit;
		B2bCompanyClientProfileEdit = (0, _reactRedux.connect)(function (state) {
			var clientId = state.b2bCompany.opened;
			var clientData = state.clients.clientData[clientId];
			var appLanguage = state.app.lang;
	
			return {
				clientId: clientId,
				appLanguage: appLanguage,
				clientData: clientData,
				initializeProfileForm: _stateActions.initializeProfileForm
			};
		})(B2bCompanyClientProfileEdit) || B2bCompanyClientProfileEdit;
		return B2bCompanyClientProfileEdit;
	})(_react.Component);
	
	exports['default'] = B2bCompanyClientProfileEdit;
	module.exports = exports['default'];

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _lodashLang = __webpack_require__(78);
	
	var _b2bCompanyScss = __webpack_require__(436);
	
	var _b2bCompanyScss2 = _interopRequireDefault(_b2bCompanyScss);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _tooManyResults = __webpack_require__(175);
	
	var _tooManyResults2 = _interopRequireDefault(_tooManyResults);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var B2bCompanyClientResults = (function (_React$Component) {
		_inherits(B2bCompanyClientResults, _React$Component);
	
		function B2bCompanyClientResults() {
			_classCallCheck(this, B2bCompanyClientResults);
	
			_get(Object.getPrototypeOf(B2bCompanyClientResults.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(B2bCompanyClientResults, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodashLang.eq)(this.props.data, nextProps.data);
			}
	
			// handleSelectChangeState(stateList) {
			// 	this.setState({stateList})
			// }
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props;
				var data = _props.data;
				var zoomTo = _props.zoomTo;
	
				// const {stateOptions} = this.props
				// const {stateList} = this.state
				return _react2['default'].createElement(
					'div',
					{ className: _b2bCompanyScss2['default'].clientsTableContainer },
					data && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
						_componentsReactable.Table,
						{
							className: _b2bCompanyScss2['default'].table,
							itemsPerPage: 10,
							filterable: [
							/*"policy",
	      "society",
	      "security",
	      "risk",
	      "state",
	      "end",
	      "policyholder",*/
							"name", "address", "email", "phoneNumber", "clientNumber"],
							sortable: [
							/*"policy",
	      "society",
	      "security",
	      "risk",
	      "state",
	      "end",
	      "policyholder",*/
							"name", "address", "email", "phoneNumber", "clientNumber"],
							defaultSort: {
								column: 'policy',
								direction: 'desc'
							}
						},
						_react2['default'].createElement(
							_componentsReactable.Thead,
							null,
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'name' },
								_react2['default'].createElement(
									'strong',
									null,
									_('name')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'clientNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'address' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientAddress')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'phoneNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('phoneNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'email' },
								_react2['default'].createElement(
									'strong',
									null,
									_('email')
								)
							)
						),
						data.map(function (item, key) {
							return _react2['default'].createElement(
								_componentsReactable.Tr,
								{
									className: 'clickable centered',
									onClick: function () {
										return zoomTo(item.clientId);
									}, key: key
								},
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'name' },
									item.name
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'clientNumber' },
									item.clientNumber
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'address' },
									item.mainAddress
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'email' },
									item.email
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'phoneNumber' },
									item.phoneNumber
								)
							);
						})
					),
					data && _underscore2['default'].isArray(data) && data.length === 0 && _react2['default'].createElement(_noResults2['default'], { type: 'clients' }),
					data && _underscore2['default'].isArray(data) && data[0] === 'Too many rows' && _react2['default'].createElement(_tooManyResults2['default'], { type: 'clients' })
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				data: _react.PropTypes.array
			},
			enumerable: true
		}]);
	
		return B2bCompanyClientResults;
	})(_react2['default'].Component);
	
	exports['default'] = B2bCompanyClientResults;
	module.exports = exports['default'];
	/*<Th column="policy">
	<strong>{_('policy')}</strong>
	</Th>
	<Th column="society">
	<strong>{_('society')}</strong>
	</Th>
	<Th column="security">
	<strong>{_('security')}</strong>
	</Th>
	<Th column="risk">
	<strong>{_('risk')}</strong>
	</Th>
	<Th column="state">
	<strong>{_('state')}</strong>
	</Th>
	<Th column="end">
	<strong>{_('end')}</strong>
	</Th>
	<Th column="policyholder">
	<strong>{_('policyholder')}</strong>
	</Th>*/ /*<Td column="policy">{item.policy}</Td>
	        <Td column="society">{item.society}</Td>
	        <Td column="security">{item.security}</Td>
	        <Td column="risk">{item.security}</Td>
	        <Td column="state">									
	        <SelectWrap
	        	options={stateOptions}
	        	onChange={(e) => this.handleSelectChangeState(e)}
	        	value={this.state.stateList}
	        	placeholder={_('selectState')}
	        	backspaceRemoves={false}
	        	autoBlur
	        	multi
	        	simpleValue
	        />
	        {item.security}
	        </Td>
	        <Td column="end">{item.security}</Td>
	        <Td column="policyholder">{item.security}</Td>*/

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _stateActions = __webpack_require__(5);
	
	var _BrokerSelectorScss = __webpack_require__(714);
	
	var _BrokerSelectorScss2 = _interopRequireDefault(_BrokerSelectorScss);
	
	var B2bCompanyClientSubActionSelector = (function (_React$Component) {
		_inherits(B2bCompanyClientSubActionSelector, _React$Component);
	
		function B2bCompanyClientSubActionSelector() {
			_classCallCheck(this, _B2bCompanyClientSubActionSelector);
	
			_get(Object.getPrototypeOf(_B2bCompanyClientSubActionSelector.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(B2bCompanyClientSubActionSelector, [{
			key: 'updateClientSubAction',
			value: function updateClientSubAction(currentClientSubAction) {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.setB2bCompanyClientSubAction)(currentClientSubAction));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var currentClientSubAction = _props.currentClientSubAction;
				var categoryNames = _props.categoryNames;
	
				var options = [];
				if (!_underscore2['default'].isEmpty(categoryNames)) {
					var keys = Object.keys(categoryNames);
					keys && keys.forEach(function (key) {
						options.push({
							label: categoryNames[key],
							value: key
						});
					});
				}
				return _react2['default'].createElement(
					'span',
					{ className: (0, _classnames2['default'])('B2bCompanyClientSubActionSelector', this.props.styleName) },
					options.length >= 1 ? _react2['default'].createElement(_sharedSelectSelectWrap.SelectWrapper, {
						value: currentClientSubAction,
						options: options,
						isClearable: false,
						onChange: function (item) {
							return _this.updateClientSubAction(item.value);
						}
					}) : _react2['default'].createElement(
						'span',
						null,
						currentClientSubAction
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				policySubActions: _react2['default'].PropTypes.object.isRequired,
				currentClientSubAction: _react2['default'].PropTypes.string,
				categoryNames: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		var _B2bCompanyClientSubActionSelector = B2bCompanyClientSubActionSelector;
		B2bCompanyClientSubActionSelector = (0, _reactRedux.connect)(function (state) {
			return {
				policySubActions: state.b2bCompany.policySubActions
			};
		})(B2bCompanyClientSubActionSelector) || B2bCompanyClientSubActionSelector;
		return B2bCompanyClientSubActionSelector;
	})(_react2['default'].Component);
	
	exports['default'] = B2bCompanyClientSubActionSelector;
	module.exports = exports['default'];

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x4, _x5, _x6) { var _again = true; _function: while (_again) { var object = _x4, property = _x5, receiver = _x6; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x4 = parent; _x5 = property; _x6 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _xml2map = __webpack_require__(2328);
	
	var _xml2map2 = _interopRequireDefault(_xml2map);
	
	//import iconv from 'iconv-lite'
	//import {Buffer as buffer} from 'buffer'
	
	var _lodash = __webpack_require__(329);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _stateActions = __webpack_require__(5);
	
	var _b2bCompanyClientZoomScss = __webpack_require__(1589);
	
	var _b2bCompanyClientZoomScss2 = _interopRequireDefault(_b2bCompanyClientZoomScss);
	
	var _b2bCompanyClientProfile = __webpack_require__(1066);
	
	var _b2bCompanyClientProfile2 = _interopRequireDefault(_b2bCompanyClientProfile);
	
	var _b2bCompanyClientContracts = __webpack_require__(1065);
	
	var _b2bCompanyClientContracts2 = _interopRequireDefault(_b2bCompanyClientContracts);
	
	var _b2bCompanyClientActionSelector = __webpack_require__(1064);
	
	var _b2bCompanyClientActionSelector2 = _interopRequireDefault(_b2bCompanyClientActionSelector);
	
	var _b2bCompanyClientSubActionSelector = __webpack_require__(1069);
	
	var _b2bCompanyClientSubActionSelector2 = _interopRequireDefault(_b2bCompanyClientSubActionSelector);
	
	var _b2bCompanyPolicyHistory = __webpack_require__(1071);
	
	var _b2bCompanyPolicyHistory2 = _interopRequireDefault(_b2bCompanyPolicyHistory);
	
	var _b2bCompanyClientProfileEdit = __webpack_require__(1067);
	
	var _b2bCompanyClientProfileEdit2 = _interopRequireDefault(_b2bCompanyClientProfileEdit);
	
	var _environments = __webpack_require__(392);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clientZoom');
	
	var customStyles = {
		overlay: {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: 'rgba(255, 255, 255, 0.75)',
			zIndex: 2
		},
		content: {
			position: 'relative',
			top: 'initial',
			bottom: 'initial',
			left: 'initial',
			right: 'initial',
			maxHeight: '90%',
			overflow: 'auto',
			padding: '1em'
		}
	};
	
	var SubNav = function SubNav(_ref) {
		var currentId = _ref.currentId;
		var items = _ref.items;
		var onChange = _ref.onChange;
		return _react2['default'].createElement(
			'div',
			{ className: '' + _b2bCompanyClientZoomScss2['default'].headingDiv },
			Object.keys(items).map(function (moduleId) {
				return _react2['default'].createElement(
					'div',
					{
						key: moduleId,
						className: _b2bCompanyClientZoomScss2['default'].headingCell + ' info ' + (currentId === moduleId ? '' + _b2bCompanyClientZoomScss2['default'].active : ''),
						onClick: function () {
							return onChange(moduleId);
						}
					},
					items[moduleId]
				);
			})
		);
	};
	
	var B2bCompanyClientZoom = (function (_React$Component) {
		_inherits(B2bCompanyClientZoom, _React$Component);
	
		_createClass(B2bCompanyClientZoom, null, [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				subModule: _react2['default'].PropTypes.string,
				subModuleZoom: _react2['default'].PropTypes.object,
				handleNewPolicy: _react2['default'].PropTypes.func,
				clientId: _react2['default'].PropTypes.string.isRequired,
				data: _react2['default'].PropTypes.object,
				isPhone: _react2['default'].PropTypes.bool,
				userId: _react2['default'].PropTypes.string.isRequired,
				user: _react2['default'].PropTypes.string.isRequired,
				username: _react2['default'].PropTypes.string.isRequired,
				firstName: _react2['default'].PropTypes.string.isRequired,
				lastName: _react2['default'].PropTypes.string.isRequired
			},
			enumerable: true
		}]);
	
		function B2bCompanyClientZoom(props) {
			var _this = this;
	
			_classCallCheck(this, _B2bCompanyClientZoom);
	
			_get(Object.getPrototypeOf(_B2bCompanyClientZoom.prototype), 'constructor', this).call(this, props);
	
			this.handleClose = function () {
				var clientProfileStatus = _this.props.clientProfileForm.formStatus.sent;
				var isSetOpenedMode = _this.state.isSetOpenedMode;
	
				if (clientProfileStatus == false && _this.props.subModule == 'edit-profile') {
					_this.setState({ isSetOpenedMode: true });
					_this.openModal();
				} else {
					_this.props.dispatch((0, _stateActions.setB2bCompanyOpened)());
				}
			};
	
			this.composeUriForB2bCompany = function (b2bInfo, actionCategory, b2bCompanyCompany) {
				var policy = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
				var recupCode = arguments.length <= 4 || arguments[4] === undefined ? "" : arguments[4];
	
				// b2bInfo: xml, transactionId, brokerAccount
				var _props = _this.props;
				var policySubActions = _props.policySubActions;
				var userId = _props.userId;
				var user = _props.user;
				var username = _props.username;
				var firstName = _props.firstName;
				var lastName = _props.lastName;
	
				var args = {};
				// usig xml tag as uri params if company Require
				if (_this.isNeedToUseXmlInUrlByCompanyId(b2bCompanyCompany.companyId)) {
					var pureTags = b2bInfo.xml && b2bInfo.xml.substr(b2bInfo.xml.indexOf(">") + 1) || false;
					var valuesFromXml = pureTags && _xml2map2['default'].tojson(b2bInfo.xml) || false;
					if (actionCategory && policySubActions[actionCategory] && policySubActions[actionCategory].sendClientInfo === "true" && pureTags) {
						_underscore2['default'].each(valuesFromXml, function (value, key) {
							args[key] = value;
						});
					}
				}
				args.oa = actionCategory && policySubActions[actionCategory].actionCode || "";
				args.d = actionCategory && policySubActions[actionCategory].actionDomain || "";
				args.rff = policy && policy.contractNumber || 0; // policyNumber ????
				args.txid = b2bInfo && b2bInfo.transactionId || "";
				args.Scenario = b2bCompanyCompany && b2bCompanyCompany.brokerCode || "";
				// used when recuperation for transaction
				args.RefTar = recupCode || "";
				args.LanguageScreen = lang && _this.getLanguageIdByCode(lang) || "2"; // nl=2 fr=1 en=0
				args.Broker = b2bInfo && b2bInfo.brokerAccount || "";
				// userId arg what is not specified in documentation, but is necessary in practice
				args.brokerUserId = userId;
				args.brokerUser = user;
				args.brokerUsername = username;
				args.brokerFirstName = firstName;
				args.brokerLastName = lastName;
				args.category = actionCategory || "";
				// compose uri params
				var params = [];
				Object.keys(args).forEach(function (index) {
					// please do not use lodash or underscore because the comparison of empty values do async shifting
					if (args[index] !== "" && !(args[index] instanceof Array && args[index].length === 0) && !(typeof args[index] === "object" && Object.keys(args[index]).length === 0) || args[index] === 0) {
						params.push(index + "=" + _this.getEncodedURIByCompanyId(args[index], b2bCompanyCompany.companyId) || "");
					}
				});
				var uriParams = params.join('&');
				var urlDomain = _this.getInsuranceCompanyUrlById(b2bCompanyCompany.companyId);
				var uri = urlDomain + (urlDomain.indexOf("?") === -1 ? "?" : urlDomain.indexOf("?") + 1 === urlDomain.length ? "" : "&") + uriParams;
	
				window.open(uri, '_blank', 'noopener,noreferrer');
			};
	
			this.handleCheckPolicy = function (policy) {
				var dispatch = _this.props.dispatch;
	
				dispatch((0, _stateActions.setB2bCompanySelectedPolicy)(policy));
			};
	
			this.setB2bCompanyClientSubAction = function () {
				// nothing to do here, because the subaction selection does not require nothing action
			};
	
			this.handlePerformActions = function () {
				var recupCode = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
				/**
	    * Tamas update
	    * Added policySubActions since we need to get the same action code as the url
	    */
				var _props2 = _this.props;
				var dispatch = _props2.dispatch;
				var currentClientAction = _props2.currentClientAction;
				var currentClientSubAction = _props2.currentClientSubAction;
				var selectedPolicy = _props2.selectedPolicy;
				var currentBrNr = _props2.currentBrNr;
				var b2bCompanyCompany = _props2.b2bCompanyCompany;
				var clientId = _props2.clientId;
				var B2BTransactions = _props2.B2BTransactions;
				var policySubActions = _props2.policySubActions;
	
				var args = {
					clientId: clientId || "",
					brokerNumber: currentBrNr || "",
					companyId: b2bCompanyCompany && b2bCompanyCompany.companyId || "",
					action: currentClientAction || "",
					category: currentClientSubAction || "",
					contractNumber: selectedPolicy && selectedPolicy.contractNumber || "",
					contractId: selectedPolicy && selectedPolicy.contractId || "",
					actionCode: policySubActions[currentClientSubAction].actionCode,
					b2bScenario: b2bCompanyCompany && b2bCompanyCompany.brokerCode || "",
					domain: currentClientSubAction && policySubActions[currentClientSubAction].actionDomain || "domainhere"
				};
	
				dispatch((0, _stateActions.B2bCompanyStartB2BAction)(args)).then(function (b2bInfo) {
					_this.composeUriForB2bCompany(b2bInfo, currentClientSubAction, b2bCompanyCompany, selectedPolicy, recupCode);
					dispatch((0, _stateActions.setB2bCompanyClientSubAction)(""));
					dispatch((0, _stateActions.setB2bCompanyClientAction)(""));
					dispatch((0, _stateActions.setB2bCompanySelectedPolicy)({}));
				})['catch'](function (err) {
					dispatch((0, _stateActions.setNotification)(_('errorPerformActionOnPolicy'), 'error'));
				});
			};
	
			this.handlePerformRecuperation = function (item) {
				var _props3 = _this.props;
				var dispatch = _props3.dispatch;
				var b2bCompanyCompany = _props3.b2bCompanyCompany;
				var clientId = _props3.clientId;
				var currentBrNr = _props3.currentBrNr;
				var currentClientAction = _props3.currentClientAction;
				var currentClientSubAction = _props3.currentClientSubAction;
				var policySubActions = _props3.policySubActions;
	
				var recupCode = item && item.recupCode || '';
				var b2bInfo = {
					brokerAccount: item.brokerAccount || "", // Or for a recuperation: From the JSON-item "brokerAccount" which will be returned in the getB2bTransactions Procedure.
					transactionId: item.transactionId || "",
					xml: false
				};
				var fakePolicy = {
					contractNumber: item.contractNumber
				};
	
				// not necessary to reset the actions, but here is the code to do that
				// dispatch(setB2bCompanyClientSubAction(""))
				// dispatch(setB2bCompanyClientAction(""))
				// dispatch(setB2bCompanySelectedPolicy({}))
	
				// this args are for save them in the authorization collection in mongodb
				var args = {
					recupCode: recupCode || "",
					transactionId: item.transactionId || "",
					clientId: clientId || "",
					brokerNumber: currentBrNr || "",
					companyId: b2bCompanyCompany && b2bCompanyCompany.companyId || "",
					action: "",
					category: "",
					contractNumber: item && item.contractNumber || "",
					contractId: item && item.contractId || "",
					actionCode: "",
					b2bScenario: b2bCompanyCompany && b2bCompanyCompany.brokerCode || "",
					domain: ""
				};
	
				dispatch((0, _stateActions.B2bCompanyStartB2BAction)(args)).then(function (resp) {
	
					var additionalStep = _this.additionalActionsForRecuperation(args);
	
					// if we dont have to do additional step for generating url then we get a TRUE value.
					// else we get a promis where we have to wait to complete the service call.
					if (additionalStep === true) {
						_this.composeUriForB2bCompany(b2bInfo, item.category, b2bCompanyCompany, fakePolicy, item.recupCode);
					} else if (typeof additionalStep.then == 'function') {
						// verify if it is a promise
						additionalStep.then(function (resp) {
							_this.composeUriForB2bCompany(b2bInfo, item.category, b2bCompanyCompany, fakePolicy, item.recupCode);
						})['catch'](function (err) {
							return dispatch((0, _stateActions.setNotification)(_('errorPerformRecuperationOnPolicy'), 'error'));
						});
					}
				})['catch'](function (err) {
					dispatch((0, _stateActions.setNotification)(_('errorPerformActionOnPolicy'), 'error'));
				});
			};
	
			this.additionalActionsForRecuperation = function (args) {
				var dispatch = _this.props.dispatch;
	
				switch (args.companyId) {
					case '2320':
						{
							return dispatch((0, _stateActions.B2bCompanyB2bActionRecup)(args));
						}
					case '2321':
						{
							return new Promise(function (res, rej) {
								res(true);
							});
						}
						return new Promise(function (res, rej) {
							res(true);
						});
				}
			};
	
			this.fetchActionNames = function () {
				var _props4 = _this.props;
				var policyActions = _props4.policyActions;
				var policySubActions = _props4.policySubActions;
				var b2bCompanyActionsDict = _props4.b2bCompanyActionsDict;
				var lang = _props4.lang;
	
				var policyActionsIds = Object.keys(policyActions || []);
				var labelValue = policyActionsIds && policyActionsIds.map(function (index) {
					var name = b2bCompanyActionsDict && b2bCompanyActionsDict['b2bCompanyActionTypes'] && b2bCompanyActionsDict['b2bCompanyActionTypes'][policyActions[index].action] || false;
					name = name && name[lang] || policyActions[index].action;
					return {
						label: name,
						value: policyActions[index].action
					};
				});
				var result = {};
				labelValue.forEach(function (item) {
					result[item.value] = item.label;
				});
				return result;
			};
	
			this.fetchCategoryNames = function () {
				var _props5 = _this.props;
				var policySubActions = _props5.policySubActions;
				var b2bCompanyActionsDict = _props5.b2bCompanyActionsDict;
				var lang = _props5.lang;
	
				var policySubActionsIds = Object.keys(policySubActions || []);
				var labelValue = policySubActionsIds && policySubActionsIds.map(function (index) {
					var name = b2bCompanyActionsDict && b2bCompanyActionsDict['b2bCompanyActionsSubTypes'] && b2bCompanyActionsDict['b2bCompanyActionsSubTypes'][policySubActions[index].category] || false;
					name = name && name[lang] || policySubActions[index].category;
					return {
						label: name,
						value: policySubActions[index].category
					};
				});
				var result = {};
				labelValue.forEach(function (item) {
					result[item.value] = item.label;
				});
				return result;
			};
	
			this.fetchStatusCodes = function () {
				var _props6 = _this.props;
				var b2bCompanyActionsDict = _props6.b2bCompanyActionsDict;
				var lang = _props6.lang;
	
				var labelValue = [];
				if (!_underscore2['default'].isEmpty(b2bCompanyActionsDict) && !_underscore2['default'].isEmpty(b2bCompanyActionsDict['b2bCompanyTransactionStatus'])) {
					var keys = Object.keys(b2bCompanyActionsDict['b2bCompanyTransactionStatus']);
					keys && keys.forEach(function (key) {
						labelValue.push({
							label: b2bCompanyActionsDict['b2bCompanyTransactionStatus'][key][lang] || key,
							value: key
						});
					});
				}
				var result = {};
				labelValue.forEach(function (item) {
					result[item.value] = item.label;
				});
				return result;
			};
	
			this.canPerformAction = function () {
				var _props7 = _this.props;
				var currentClientAction = _props7.currentClientAction;
				var currentClientSubAction = _props7.currentClientSubAction;
				var selectedPolicy = _props7.selectedPolicy;
				var transactionDetails = _props7.transactionDetails;
				var policySubActions = _props7.policySubActions;
	
				// option existence check and needsContract check
				var isNeededContract = !_underscore2['default'].isEmpty(policySubActions) && !_underscore2['default'].isEmpty(policySubActions[currentClientSubAction]) && policySubActions[currentClientSubAction].needsContract === "true";
				// final button enabler logic
				var canPerform = !_underscore2['default'].isEmpty(currentClientAction) && !_underscore2['default'].isEmpty(currentClientSubAction) && (isNeededContract && !_underscore2['default'].isEmpty(selectedPolicy) || !isNeededContract);
				// when contract required or not
				return canPerform;
			};
	
			this.refreshContractsList = function () {
				var _props8 = _this.props;
				var dispatch = _props8.dispatch;
				var b2bCompanyCompany = _props8.b2bCompanyCompany;
				var clientId = _props8.clientId;
	
				dispatch((0, _stateActions.fetchExistingClient)(clientId, b2bCompanyCompany.companyId));
			};
	
			this.getHistory = function () {
				var _props9 = _this.props;
				var dispatch = _props9.dispatch;
				var b2bCompanyCompany = _props9.b2bCompanyCompany;
				var clientId = _props9.clientId;
	
				return dispatch((0, _stateActions.getB2bCompanyB2BTransactions)({ companyId: b2bCompanyCompany.companyId, clientId: clientId }));
			};
	
			this.state = { modalIsOpen: false, modalSubmoduleName: "" };
		}
	
		_createClass(B2bCompanyClientZoom, [{
			key: 'openModal',
			value: function openModal() {
				this.setState({ modalIsOpen: !this.state.modalIsOpen });
			}
		}, {
			key: 'leaveModal',
			value: function leaveModal(subModuleName) {
				var dispatch = this.props.dispatch;
				var isSetOpenedMode = this.state.isSetOpenedMode;
	
				if (isSetOpenedMode == true) {
					this.props.dispatch((0, _stateActions.setB2bCompanyOpened)());
					this.setState({ isSetOpenedMode: false });
				} else {
					dispatch((0, _stateActions.setB2bCompanySubModule)(subModuleName));
				}
	
				this.openModal();
			}
		}, {
			key: 'setSubModuleName',
			value: function setSubModuleName(submoduleName) {
				this.setState({ modalSubmoduleName: submoduleName });
			}
		}, {
			key: 'setSubModule',
			value: function setSubModule(subModuleName) {
				var clientProfileStatus = this.props.clientProfileForm.formStatus.sent;
				var dispatch = this.props.dispatch;
	
				if (clientProfileStatus == false && this.props.subModule == 'edit-profile') {
					this.setSubModuleName(subModuleName);
					this.openModal();
				} else {
					dispatch((0, _stateActions.setB2bCompanySubModule)(subModuleName));
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _props10 = this.props;
				var dispatch = _props10.dispatch;
				var subModule = _props10.subModule;
				var clientId = _props10.clientId;
				var data = _props10.data;
				var b2bInsuranceCompany = _props10.b2bInsuranceCompany;
				var b2bCompanyActionsDict = _props10.b2bCompanyActionsDict;
	
				dispatch((0, _stateActions.setB2bCompanySelectedPolicy)({}));
				dispatch((0, _stateActions.fetchB2bCompanyPolicyActionsDict)());
				dispatch((0, _stateActions.fetchB2bCompanyPolicyActions)(clientId, b2bInsuranceCompany.companyId || false)).then(function (resp) {
					if (!data.main) {
						dispatch((0, _stateActions.fetchClient)(clientId, resp.b2bCompanyCompany && resp.b2bCompanyCompany.companyId || null));
					}
				});
				if (!subModule) {
					this.setSubModule('profile');
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.setSubModule('');
			}
		}, {
			key: 'isNeedToUseXmlInUrlByCompanyId',
			value: function isNeedToUseXmlInUrlByCompanyId(companyId) {
				switch (companyId) {
					case '2320':
						{
							//vivium
							return false;
						}
					case '2321':
						{
							// generali
							return true;
						}
						return false;
				}
			}
		}, {
			key: 'getLanguageIdByCode',
			value: function getLanguageIdByCode(langCode) {
				switch (langCode) {
					case 'nl':
						{
							//vivium
							return 2;
						}
					case 'fr':
						{
							// generali
							return 1;
						}
						return 0;
				}
			}
		}, {
			key: 'getInsuranceCompanyUrlById',
			value: function getInsuranceCompanyUrlById(companyId) {
				switch (companyId) {
					case '2320':
						{
							return _environments.B2bCompanyVerzekeringenUri;
						}
					case '2321':
						{
							return _environments.B2bCompanyGeneraliUri;
						}
						return '';
				}
			}
	
			/**
	   * This function will provide a correct encoded value for URIs,
	   * when you do a remote request for an insurance company.
	   * @param {*} value
	   * @param {Number} companyId
	   */
		}, {
			key: 'getEncodedURIByCompanyId',
			value: function getEncodedURIByCompanyId(value, companyId) {
				switch (companyId) {
					case '2320':
						{
							// vivium
							return encodeURIComponent(value);
						}
					case '2321':
						{
							// generali
							return encodeURIComponent(value);
						}
						// This below is the code what do the character encode switch for generali
						/* case '2321': { // generali
	         let buff = null
	         try {
	             buff = new buffer(value+"", 'utf-8')
	         } catch( errr ) {
	             console.log( "Error when create buffer", errr )
	         }
	          let iso88591Value = null
	         try {
	             iso88591Value = iconv.decode(buff, 'ISO-8859-1')
	         } catch( errr ) {
	             console.log( "Error when iconv decode", errr )
	         }
	          return encodeURIComponent(iso88591Value)
	     } */
						return encodeURIComponent(value);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props11 = this.props;
				var subModule = _props11.subModule;
				var subModuleZoom = _props11.subModuleZoom;
				var data = _props11.data;
				var isPhone = _props11.isPhone;
				var clientId = _props11.clientId;
				var subscriberPopup = _props11.subscriberPopup;
				var currentClientAction = _props11.currentClientAction;
				var currentClientSubAction = _props11.currentClientSubAction;
				var B2BTransactions = _props11.B2BTransactions;
				var b2bCompanyActionsDict = _props11.b2bCompanyActionsDict;
				var b2bCompanyCompany = _props11.b2bCompanyCompany;
				var isByContractNumber = _props11.isByContractNumber;
	
				// second perform action button is always shown but is enabled when everything is selected, or the action is new policy
				var output = undefined,
				    canPerformAction = this.canPerformAction();
				var actionNames = this.fetchActionNames();
				var categoryNames = this.fetchCategoryNames();
				var statusNames = this.fetchStatusCodes();
				var setSubModule = function setSubModule(subModuleName) {
					_this2.setSubModule(subModuleName);
				};
				var modalIsOpen = this.state.modalIsOpen;
				var modalSubmoduleName = this.state.modalSubmoduleName;
	
				if (!data.main) {
					return false;
				}
				switch (subModule) {
					case 'profile':
						output = _react2['default'].createElement(
							'div',
							null,
							_react2['default'].createElement(_b2bCompanyClientProfile2['default'], {
								clientId: clientId,
								data: data
							}),
							_react2['default'].createElement(
								'h3',
								null,
								_('policies')
							),
							_react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientZoomScss2['default'].actionSelectorsWrap },
								_react2['default'].createElement(
									'span',
									{ className: _b2bCompanyClientZoomScss2['default'].inputGroup },
									_react2['default'].createElement(
										'label',
										{ className: _b2bCompanyClientZoomScss2['default'].label },
										_('clientAction')
									),
									_react2['default'].createElement(_b2bCompanyClientActionSelector2['default'], {
										styleName: _b2bCompanyClientZoomScss2['default'].actionSelector,
										actionNames: actionNames,
										currentClientAction: currentClientAction
									})
								),
								_react2['default'].createElement(
									'span',
									{ className: _b2bCompanyClientZoomScss2['default'].inputGroup },
									_react2['default'].createElement(
										'label',
										{ className: _b2bCompanyClientZoomScss2['default'].label },
										_('clientSubAction')
									),
									_react2['default'].createElement(_b2bCompanyClientSubActionSelector2['default'], {
										styleName: _b2bCompanyClientZoomScss2['default'].actionSelector,
										categoryNames: categoryNames,
										currentClientSubAction: currentClientSubAction
									})
								),
								currentClientAction * 1 == 1 && _react2['default'].createElement(
									'span',
									{ className: _b2bCompanyClientZoomScss2['default'].inputGroup },
									_react2['default'].createElement(
										'button',
										{
											disabled: !canPerformAction,
											className: _b2bCompanyClientZoomScss2['default'].greyButton,
											onClick: function (e) {
												return _this2.handlePerformActions("");
											},
											type: 'button'
										},
										_('performActions')
									)
								)
							),
							_react2['default'].createElement(_b2bCompanyClientContracts2['default'], {
								onSelectEdit: this.handleCheckPolicy,
								onRefresh: this.refreshContractsList
							}),
							_underscore2['default'].isEmpty(data.contractIds) && isByContractNumber && _react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientZoomScss2['default'].actionSelectorsWrap },
								_react2['default'].createElement(
									'div',
									null,
									_("noContractForThisB2bCompany")
								)
							) || null,
							_underscore2['default'].isEmpty(data.contractIds) && currentClientAction && currentClientSubAction && !canPerformAction && _react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientZoomScss2['default'].actionSelectorsWrap },
								_react2['default'].createElement(
									'div',
									null,
									_("noActionWithoutContract")
								)
							),
							currentClientAction && currentClientAction * 1 !== 1 && !_underscore2['default'].isEmpty(data.contractIds) && _react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientZoomScss2['default'].actionSelectorsWrapRight },
								_react2['default'].createElement(
									'span',
									{ className: _b2bCompanyClientZoomScss2['default'].inputGroup },
									_react2['default'].createElement(
										'button',
										{
											disabled: !canPerformAction,
											className: _b2bCompanyClientZoomScss2['default'].greyButton,
											onClick: function (e) {
												return _this2.handlePerformActions("");
											},
											type: 'button'
										},
										_('performActions')
									)
								)
							),
							!_underscore2['default'].isEmpty(b2bCompanyActionsDict) && _react2['default'].createElement(_b2bCompanyPolicyHistory2['default'], {
								data: B2BTransactions,
								actionNames: actionNames,
								categoryNames: categoryNames,
								statusNames: statusNames,
								handlePerformRecuperation: this.handlePerformRecuperation,
								getHistory: this.getHistory,
								getContracts: this.refreshContractsList
							})
						);
						break;
					case 'edit-profile':
						output = _react2['default'].createElement(_b2bCompanyClientProfileEdit2['default'], _extends({
							clientId: clientId,
							data: data
						}, {
							setSubModule: setSubModule
						}));
						break;
					default:
						output = _react2['default'].createElement(
							'div',
							null,
							'Unknown submodule!'
						);
						break;
				}
				return _react2['default'].createElement(
					'div',
					{ className: _b2bCompanyClientZoomScss2['default'].b2bCompanyClientZoomContainer },
					_react2['default'].createElement(
						'div',
						{ className: _b2bCompanyClientZoomScss2['default'].content },
						_react2['default'].createElement(
							'div',
							{ className: _b2bCompanyClientZoomScss2['default'].mainTitleDiv },
							_react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientZoomScss2['default'].mainTitleContainer },
								_react2['default'].createElement(
									'h2',
									{ className: _b2bCompanyClientZoomScss2['default'].mainTitle },
									b2bCompanyCompany && b2bCompanyCompany.insuranceCompany || _('InsuranceCompany')
								),
								_react2['default'].createElement(
									'h3',
									null,
									_('b2bCompanySubtitle')
								)
							),
							!isPhone && _react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientZoomScss2['default'].moduleControls },
								_react2['default'].createElement(
									'div',
									{ onClick: this.handleClose, className: _b2bCompanyClientZoomScss2['default'].greyButton },
									_('backToList')
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: _b2bCompanyClientZoomScss2['default'].clientZoom },
							_react2['default'].createElement('div', { className: _b2bCompanyClientZoomScss2['default'].subNav }),
							_react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientZoomScss2['default'].moduleWrap },
								output
							)
						)
					),
					_react2['default'].createElement(
						_reactModal2['default'],
						{
							isOpen: modalIsOpen,
							style: customStyles,
							contentLabel: 'Modal'
						},
						_react2['default'].createElement(
							'div',
							{ className: _b2bCompanyClientZoomScss2['default'].verifyModalContent },
							_react2['default'].createElement(
								'span',
								{ className: _b2bCompanyClientZoomScss2['default'].title },
								_('clientProfileLeavePopup')
							),
							_react2['default'].createElement(
								'span',
								{ className: _b2bCompanyClientZoomScss2['default'].message },
								_('clientProfileLeavePopupMessage')
							),
							_react2['default'].createElement(
								'div',
								{ className: _b2bCompanyClientZoomScss2['default'].verifyModalButtons },
								_react2['default'].createElement(
									'span',
									{
										onClick: function () {
											return _this2.openModal();
										},
										className: _b2bCompanyClientZoomScss2['default'].cancel
									},
									_("cancel")
								),
								_react2['default'].createElement('input', {
									onClick: function () {
										return _this2.leaveModal(modalSubmoduleName);
									},
									type: 'button',
									className: _b2bCompanyClientZoomScss2['default'].greyButton + " enabled",
									value: _("clientProfileLeaveOkButton")
								})
							)
						)
					)
				);
			}
		}]);
	
		var _B2bCompanyClientZoom = B2bCompanyClientZoom;
		B2bCompanyClientZoom = (0, _reactRedux.connect)(function (state) {
			var clientId = state.b2bCompany.opened;
			return {
				subModule: state.b2bCompany.subModule,
				subModuleZoom: state.b2bCompany.subModuleZoom,
				clientId: clientId,
				data: state.b2bCompany.clientData[clientId] || {},
				isPhone: state.responsive.isPhone,
				currentClientAction: state.b2bCompany.currentClientAction,
				currentClientSubAction: state.b2bCompany.currentClientSubAction,
				selectedPolicy: state.b2bCompany.selectedPolicy,
				currentBrNr: state.b2bCompany.brNr,
				b2bCompanyCompany: state.b2bCompany.b2bCompanyCompany,
				b2bInsuranceCompany: state.b2b.b2bInsuranceCompany,
				isByContractNumber: state.b2b.isByContractNumber,
				policyActions: state.b2bCompany.policyActions,
				policySubActions: state.b2bCompany.policySubActions,
				b2bCompanyActionsDict: state.b2bCompany.b2bCompanyActionsDict,
				B2BTransactions: state.b2bCompany.B2BTransactions,
				transactionDetails: state.b2bCompany.transactionDetails,
				lang: state.app.lang,
				userId: state.app.userId,
				user: state.app.user,
				username: state.app.username,
				firstName: state.app.firstName,
				lastName: state.app.lastName,
				clientProfileForm: state.clientProfileForm
			};
		})(B2bCompanyClientZoom) || B2bCompanyClientZoom;
		return B2bCompanyClientZoom;
	})(_react2['default'].Component);
	
	exports['default'] = B2bCompanyClientZoom;
	module.exports = exports['default'];

	/**
	 * This function handle the recuperation button action, working like the real policy action but use data
	 * from another sources, and does not start a new transaction, but create a record on server in authorization
	 * collection with related data.
	 */

	/**
	 * This function make an extra step before redirecting to recuperation URI
	 * Only some of the insurance companies are affected.
	 */
	/*<SubNav
	currentId={subModule}
	items={{
		profile: _('profile'),
	}}
	onChange={id => this.setSubModule(id)}
	/>*/

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _lodashLang = __webpack_require__(78);
	
	var _b2bCompanyPolicyHistoryScss = __webpack_require__(1590);
	
	var _b2bCompanyPolicyHistoryScss2 = _interopRequireDefault(_b2bCompanyPolicyHistoryScss);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _tooManyResults = __webpack_require__(175);
	
	var _tooManyResults2 = _interopRequireDefault(_tooManyResults);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _refreshBtn = __webpack_require__(174);
	
	var _refreshBtn2 = _interopRequireDefault(_refreshBtn);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('b2bCompany');
	
	var B2bCompanyPolicyHistory = (function (_React$Component) {
		_inherits(B2bCompanyPolicyHistory, _React$Component);
	
		_createClass(B2bCompanyPolicyHistory, null, [{
			key: 'propTypes',
			value: {
				data: _react.PropTypes.array,
				actionNames: _react.PropTypes.object,
				categoryNames: _react.PropTypes.object,
				statusNames: _react.PropTypes.object,
				handlePerformRecuperation: _react.PropTypes.func.isRequired,
				getHistory: _react.PropTypes.func.isRequired,
				getContracts: _react.PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		function B2bCompanyPolicyHistory(props) {
			_classCallCheck(this, B2bCompanyPolicyHistory);
	
			_get(Object.getPrototypeOf(B2bCompanyPolicyHistory.prototype), 'constructor', this).call(this, props);
			this.refreshRecuperationColumnVisibility();
		}
	
		/**
	  * We should display recuperation column only if a recuperation code exists and will be button for it
	  */
	
		_createClass(B2bCompanyPolicyHistory, [{
			key: 'refreshRecuperationColumnVisibility',
			value: function refreshRecuperationColumnVisibility() {
				var _this = this;
	
				this.showRecuperation = false;
				this.props.data && this.props.data.forEach(function (historyline) {
					_this.showRecuperation = (historyline.recuperation === "true" || historyline.recuperation === true) && true || _this.showRecuperation;
				});
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodashLang.eq)(this.props.data, nextProps.data);
			}
		}, {
			key: 'parseClientNumber',
			value: function parseClientNumber(clientString) {
				var clientData = !_underscore2['default'].isEmpty(clientString) && clientString.split(":") || [];
				var clientNumber = !_underscore2['default'].isEmpty(clientData) && !_underscore2['default'].isEmpty(clientData[0]) && clientData[0] || "-";
				return clientNumber.trim();
			}
		}, {
			key: 'parseClientName',
			value: function parseClientName(clientString) {
				var clientData = !_underscore2['default'].isEmpty(clientString) && clientString.split(":") || [];
				var clientName = !_underscore2['default'].isEmpty(clientData) && !_underscore2['default'].isEmpty(clientData[1]) && clientData[1] || "-";
				return clientName.trim();
			}
		}, {
			key: 'refresh',
			value: function refresh(force) {
				var _this2 = this;
	
				var _props = this.props;
				var getHistory = _props.getHistory;
				var getContracts = _props.getContracts;
	
				getHistory(force).then(function (res) {
					return _this2.refreshRecuperationColumnVisibility();
				}).then(function () {
					_this2.forceUpdate();
					getContracts();
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props2 = this.props;
				var data = _props2.data;
				var actionNames = _props2.actionNames;
				var categoryNames = _props2.categoryNames;
				var statusNames = _props2.statusNames;
				var handlePerformRecuperation = _props2.handlePerformRecuperation;
				var getHistory = _props2.getHistory;
	
				{/*const recuperationNames = {
	    "true": _('recupered'),
	    "false": _('notRecupered'),
	    }*/}
	
				var tableColumns = ["transactionDate", "action", "category", "status", "clientNumber", "clientName", "brokerNumber", "transactionId", "contractNumber"];
	
				var tableColumnsSort = [{
					column: "transactionDate",
					sortFunction: function sortFunction(aDate, bDate) {
						var mDateA = (0, _moment2['default'])(aDate, "DD-MM-YYYY HH:mm");
						var mDateB = (0, _moment2['default'])(bDate, "DD-MM-YYYY HH:mm");
						return mDateA < mDateB ? -1 : mDateA > mDateB ? 1 : 0;
					}
				}, "action", "category", "status", "clientNumber", "clientName", "brokerNumber", "transactionId", "contractNumber"];
	
				this.showRecuperation && tableColumns.push("recuperation");
	
				var tableHeader = _react2['default'].createElement(
					_componentsReactable.Thead,
					null,
					tableColumns.filter(function (elem) {
						return elem !== "recuperation" || _this3.showRecuperation;
					}).map(function (elem, key) {
						return _react2['default'].createElement(
							_componentsReactable.Th,
							{ key: key, column: elem },
							_react2['default'].createElement(
								'strong',
								null,
								_(elem)
							)
						);
					})
				);
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'h3',
						null,
						_('b2bCompanyPolicyActionsHistory')
					),
					_react2['default'].createElement(
						'div',
						{ className: _b2bCompanyPolicyHistoryScss2['default'].moduleSection },
						_react2['default'].createElement(
							'div',
							{ className: _b2bCompanyPolicyHistoryScss2['default'].clientsTableContainer },
							data && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
								_componentsReactable.Table,
								{
									className: _b2bCompanyPolicyHistoryScss2['default'].table,
									itemsPerPage: 10,
									filterable: tableColumns,
									sortable: tableColumnsSort,
									defaultSort: {
										column: 'transactionDate',
										direction: 'desc'
									},
									topPaginationElemL: [_react2['default'].createElement(_refreshBtn2['default'], {
										key: 'r',
										onClick: function () {
											_this3.refresh(true);
										}
									})]
								},
								tableHeader,
								data.map(function (item, key) {
									return _react2['default'].createElement(
										_componentsReactable.Tr,
										{ className: 'centered', key: key },
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'transactionDate' },
											item.transactionDate
										),
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'action' },
											actionNames[item.action] || item.action
										),
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'category' },
											categoryNames[item.category] || item.category
										),
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'status' },
											statusNames[item.status] || item.status
										),
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'clientNumber' },
											_this3.parseClientNumber(item.client)
										),
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'clientName' },
											_this3.parseClientName(item.client)
										),
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'brokerNumber' },
											item.brokerNumber
										),
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'transactionId' },
											item.transactionId
										),
										_react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'contractNumber' },
											item.contractNumber
										),
										_this3.showRecuperation && _react2['default'].createElement(
											_componentsReactable.Td,
											{ column: 'recuperation' },
											item.recuperation === "true" && _react2['default'].createElement(
												'button',
												{
													disabled: !item.recupCode,
													className: _b2bCompanyPolicyHistoryScss2['default'].greyButton,
													onClick: function (e) {
														return handlePerformRecuperation(item);
													},
													type: 'button'
												},
												_('performRecuperation')
											) || null
										)
									);
								})
							),
							data && _underscore2['default'].isArray(data) && data.length === 0 && _react2['default'].createElement(_noResults2['default'], { type: 'b2bCompanyPolicyActionsHistory' }),
							data && _underscore2['default'].isArray(data) && data[0] === 'Too many rows' && _react2['default'].createElement(_tooManyResults2['default'], { type: 'b2bCompanyPolicyActionsHistory' })
						)
					)
				);
			}
		}]);
	
		return B2bCompanyPolicyHistory;
	})(_react2['default'].Component);
	
	exports['default'] = B2bCompanyPolicyHistory;
	module.exports = exports['default'];
	/*<Td column="company">{item.company}</Td>*/ /*<Td column="recupCode">{item.recupCode}</Td>*/

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(57);
	
	var _b2bCompanyScss = __webpack_require__(436);
	
	var _b2bCompanyScss2 = _interopRequireDefault(_b2bCompanyScss);
	
	var _input = __webpack_require__(109);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _libHelpers = __webpack_require__(24);
	
	var _clientsClientProfileForm = __webpack_require__(265);
	
	var _clientsClientProfileForm2 = _interopRequireDefault(_clientsClientProfileForm);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('b2bCompany');
	
	var fieldType = {
		name: 'multiple',
		dateOfBirth: 'multiple',
		street: 'multiple',
		postalCode: 'multiple',
		email: 'multiple',
		phoneNumber: 'multiple',
		contractNumber: 'unique',
		clientNumber: 'unique',
		claimNumber: 'unique',
		licencePlate: "unique",
		companyRegistrationNumber: "multiple",
		myEasinsure: "multiple",
		needsAnalysis: "multiple",
		clientFile: "multiple"
	};
	
	var validate = function validate(values) {
		var errors = {};
		var formattedData = (0, _libHelpers.trimObject)(values);
		var isEmpty = !(0, _libHelpers.hasContent)(formattedData);
		if (isEmpty) {
			errors._error = 'emptyFields';
		}
		return errors;
	};
	
	var SearchClientsForm = (function (_React$Component) {
		_inherits(SearchClientsForm, _React$Component);
	
		function SearchClientsForm() {
			_classCallCheck(this, _SearchClientsForm);
	
			_get(Object.getPrototypeOf(_SearchClientsForm.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(SearchClientsForm, [{
			key: 'render',
			value: function render() {
				var columns = [['name', 'dateOfBirth', 'street', 'postalCode', 'email', 'phoneNumber'], ['contractNumber', 'clientNumber', 'claimNumber', 'licencePlate', 'companyRegistrationNumber', 'myEasinsure', 'needsAnalysis', 'clientFile']];
				var isTernary = {
					myEasinsure: true,
					needsAnalysis: true,
					clientFile: true
				};
	
				var _props = this.props;
				var fields = _props.fields;
				var state = _props.fields.state;
				var handleSubmit = _props.handleSubmit;
				var error = _props.error;
				var createClientAccess = _props.createClientAccess;
				var openModal = _props.openModal;
				var modalState = _props.modalState;
	
				var usedField = (0, _lodashCollection.find)(fields, function (field) {
					return field.value;
				});
				var usedType = usedField && fieldType[usedField.name];
				var invalid = error === 'emptyFields';
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'form',
						{ onSubmit: handleSubmit, name: 'clientSearchForm', className: 'clientSearchForm' },
						_react2['default'].createElement(
							'div',
							{ className: _b2bCompanyScss2['default'].formContainer },
							columns.map(function (col, i) {
								return _react2['default'].createElement(
									'div',
									{ key: i, className: _b2bCompanyScss2['default'].column },
									col.map(function (name) {
										return _react2['default'].createElement(
											'div',
											{ key: name, className: _b2bCompanyScss2['default'].searchContainer },
											_react2['default'].createElement(
												'div',
												{ className: _b2bCompanyScss2['default'].label },
												_(name)
											),
											_react2['default'].createElement(
												'div',
												{ className: _b2bCompanyScss2['default'].clientSearchInput },
												_react2['default'].createElement(_input2['default'], _extends({
													autoFocus: name === 'name',
													disabled: usedType ? usedField.name !== name && (usedType === 'unique' ? true : usedType !== fieldType[name]) : false,
													type: isTernary[name] ? "ternary" : "text"
												}, fields[name]))
											)
										);
									})
								);
							})
						),
						_react2['default'].createElement(
							'div',
							{ className: _b2bCompanyScss2['default'].formContainer },
							_react2['default'].createElement(
								'span',
								{ className: _b2bCompanyScss2['default'].column },
								_react2['default'].createElement(
									'span',
									{ className: _b2bCompanyScss2['default'].searchContainer },
									_react2['default'].createElement(
										'span',
										{ className: (0, _classnames2['default'])(_b2bCompanyScss2['default'].clientSearchButtonContainer, _b2bCompanyScss2['default'].left) },
										_react2['default'].createElement(
											'button',
											{
												className: _b2bCompanyScss2['default'].greyButton,
												disabled: invalid,
												onClick: handleSubmit,
												type: 'submit'
											},
											_('submitbutton')
										),
										createClientAccess && _react2['default'].createElement(
											'button',
											{ className: _b2bCompanyScss2['default'].greyButton + ' btn', onClick: function (e) {
													return openModal(e);
												} },
											_('create-profile')
										)
									)
								)
							),
							_react2['default'].createElement('span', { className: _b2bCompanyScss2['default'].column })
						)
					),
					modalState && _react2['default'].createElement('div', { className: _b2bCompanyScss2['default'].overlayMap }),
					_react2['default'].createElement(
						'div',
						{ className: (0, _classnames2['default'])(_b2bCompanyScss2['default'].customCreateModal, modalState === true && _b2bCompanyScss2['default'].isOpened) },
						modalState && _react2['default'].createElement(_clientsClientProfileForm2['default'], { openModal: openModal })
					)
				);
			}
		}]);
	
		var _SearchClientsForm = SearchClientsForm;
		SearchClientsForm = (0, _reduxForm.reduxForm)({
			form: "clients",
			fields: Object.keys(fieldType),
			error: _react2['default'].PropTypes.string,
			validate: validate
		})(SearchClientsForm) || SearchClientsForm;
		return SearchClientsForm;
	})(_react2['default'].Component);
	
	exports['default'] = SearchClientsForm;
	module.exports = exports['default'];

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _b2bCompanyScss = __webpack_require__(436);
	
	var _b2bCompanyScss2 = _interopRequireDefault(_b2bCompanyScss);
	
	var _BrokerSelector = __webpack_require__(593);
	
	var _BrokerSelector2 = _interopRequireDefault(_BrokerSelector);
	
	var _stateActions = __webpack_require__(5);
	
	var _b2bCompanySearchClientsForm = __webpack_require__(1072);
	
	var _b2bCompanySearchClientsForm2 = _interopRequireDefault(_b2bCompanySearchClientsForm);
	
	var _b2bCompanyClientResults = __webpack_require__(1068);
	
	var _b2bCompanyClientResults2 = _interopRequireDefault(_b2bCompanyClientResults);
	
	var _b2bCompanyClientZoom = __webpack_require__(1070);
	
	var _b2bCompanyClientZoom2 = _interopRequireDefault(_b2bCompanyClientZoom);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _ = (0, _libI18n2['default'])('b2bCompany');
	
	var B2bCompany = (function (_React$Component) {
		_inherits(B2bCompany, _React$Component);
	
		_createClass(B2bCompany, null, [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				brokers: _react2['default'].PropTypes.object.isRequired,
				currentBrNr: _react2['default'].PropTypes.string,
				data: _react2['default'].PropTypes.array,
				opened: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		function B2bCompany(props) {
			var _this = this;
	
			_classCallCheck(this, _B2bCompany);
	
			_get(Object.getPrototypeOf(_B2bCompany.prototype), 'constructor', this).call(this, props);
	
			this.handleSearch = function (data) {
				return _this.props.dispatch((0, _stateActions.fetchB2bCompanyClients)(data));
			};
	
			this.goHomeIfRefresh = function (nextProps) {
				var dispatch = _this.props.dispatch;
	
				if (_underscore2['default'].isEmpty(nextProps) || _underscore2['default'].isEmpty(nextProps.b2bInsuranceCompany) || _underscore2['default'].isEmpty(nextProps.b2bInsuranceCompany.companyId)) {
					dispatch((0, _stateActions.setAppModule)(''));
				}
			};
	
			this.zoomClient = function (id) {
				var dispatch = _this.props.dispatch;
	
				dispatch((0, _stateActions.setB2bCompanyOpened)(id));
				dispatch((0, _stateActions.setB2bCompanySubModule)());
			};
	
			this.state = { modalIsOpen: false };
		}
	
		_createClass(B2bCompany, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.fetchB2bCompanyBrokers)());
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _props = this.props;
				var dispatch = _props.dispatch;
				var initializeProfileForm = _props.initializeProfileForm;
	
				dispatch((0, _stateActions.fetchClientOptionsDict)());
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				// missing require values from store then redirect to home
				this.goHomeIfRefresh(nextProps);
				return true;
			}
	
			/**
	   * This gonna redirect to the home screen when you do a refresh and loos all of the store.
	   * This function will deprecated when we solve the store save when refresh.
	   */
		}, {
			key: 'openModal',
			value: function openModal(e) {
				e.preventDefault();
				var _props2 = this.props;
				var dispatch = _props2.dispatch;
				var initializeProfileForm = _props2.initializeProfileForm;
				var toggleModalClientProfileForm = _props2.toggleModalClientProfileForm;
				var modalState = _props2.modalState;
	
				dispatch(toggleModalClientProfileForm(!modalState));
				dispatch(initializeProfileForm({}, null, 'create'));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props3 = this.props;
				var data = _props3.data;
				var currentBrNr = _props3.currentBrNr;
				var brokers = _props3.brokers;
				var opened = _props3.opened;
				var clientId = _props3.clientId;
				var createClientAccess = _props3.createClientAccess;
				var updateClientAccess = _props3.updateClientAccess;
				var modalState = _props3.modalState;
				var b2bInsuranceCompany = _props3.b2bInsuranceCompany;
	
				var openModal = function openModal(e) {
					_this2.openModal(e);
				};
	
				return _react2['default'].createElement(
					'div',
					{ id: '' + _b2bCompanyScss2['default'].b2bCompanyModule },
					_react2['default'].createElement(
						'div',
						{ className: '' + _b2bCompanyScss2['default'].b2bCompany },
						_react2['default'].createElement(
							'div',
							{ className: '' + _b2bCompanyScss2['default'].mainTitleDiv },
							_react2['default'].createElement(
								'div',
								{ className: '' + _b2bCompanyScss2['default'].mainTitleContainer },
								_react2['default'].createElement(
									'h2',
									{ className: '' + _b2bCompanyScss2['default'].mainTitle },
									b2bInsuranceCompany && b2bInsuranceCompany.insuranceCompany || _('insuranceCompany')
								),
								_react2['default'].createElement(
									'h3',
									null,
									_('b2bCompanySubtitle')
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ id: '' + _b2bCompanyScss2['default'].Navigation, className: _b2bCompanyScss2['default'].clientsSearchContainer + ' ' + (opened ? _b2bCompanyScss2['default'].hidden : 'visible') },
							_react2['default'].createElement(
								'div',
								{ className: _b2bCompanyScss2['default'].brokerSelectorContainer },
								_react2['default'].createElement(
									'div',
									{ className: _b2bCompanyScss2['default'].column },
									_react2['default'].createElement(
										'div',
										{ className: _b2bCompanyScss2['default'].brokerSelectorContent },
										_react2['default'].createElement(
											'div',
											{ className: _b2bCompanyScss2['default'].label },
											_('selectBroker')
										),
										_react2['default'].createElement(
											'div',
											{ className: _b2bCompanyScss2['default'].brokerSelectorContainer },
											_react2['default'].createElement(_BrokerSelector2['default'], {
												brokers: brokers,
												setBrNr: _stateActions.setB2bCompanyBrNr,
												brNr: currentBrNr,
												customClass: _b2bCompanyScss2['default'].brokerSelector
											})
										)
									),
									_react2['default'].createElement(
										'div',
										{ className: _b2bCompanyScss2['default'].searchSubSubTitle },
										_('subSubTitle')
									)
								),
								_react2['default'].createElement('div', { className: _b2bCompanyScss2['default'].column })
							),
							_react2['default'].createElement(_b2bCompanySearchClientsForm2['default'], _extends({
								createClientAccess: createClientAccess,
								updateClientAccess: updateClientAccess,
								openModal: openModal,
								modalState: modalState
							}, {
								onSubmit: this.handleSearch,
								initialValues: { state: '' } })),
							data && _react2['default'].createElement(_b2bCompanyClientResults2['default'], {
								data: data,
								zoomTo: this.zoomClient
							})
						),
						opened && _react2['default'].createElement(_b2bCompanyClientZoom2['default'], null)
					)
				);
			}
		}]);
	
		var _B2bCompany = B2bCompany;
		B2bCompany = (0, _reactRedux.connect)(function (state) {
			var currentBrNr = state.b2bCompany.brNr;
			var clientAccess = state.app.security.actions;
			var canCreateClient = undefined,
			    canUpdateClient = undefined;
	
			clientAccess.map(function (item, key) {
				if (item.actionName == 'createclient') {
					canCreateClient = item.actionAllowed === "true" ? true : false;
				}
	
				if (item.actionName == 'modifyclient') {
					canUpdateClient = item.actionAllowed === "true" ? true : false;
				}
			});
	
			return {
				data: state.b2bCompany.data,
				opened: state.b2bCompany.opened,
				brokers: state.b2bCompany.brokers,
				currentBrNr: currentBrNr,
				createClientAccess: canCreateClient,
				updateClientAccess: canUpdateClient,
				initializeProfileForm: _stateActions.initializeProfileForm,
				toggleModalClientProfileForm: _stateActions.toggleModalClientProfileForm,
				modalState: state.clientProfileForm.clientModal,
				b2bInsuranceCompany: state.b2b.b2bInsuranceCompany
			};
		})(B2bCompany) || B2bCompany;
		return B2bCompany;
	})(_react2['default'].Component);
	
	exports['default'] = B2bCompany;
	module.exports = exports['default'];

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _libHelpers = __webpack_require__(24);
	
	var _lodashLang = __webpack_require__(78);
	
	var _claimsScss = __webpack_require__(437);
	
	var _claimsScss2 = _interopRequireDefault(_claimsScss);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _tooManyResults = __webpack_require__(175);
	
	var _tooManyResults2 = _interopRequireDefault(_tooManyResults);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('claims');
	
	var ClaimResults = (function (_React$Component) {
		_inherits(ClaimResults, _React$Component);
	
		function ClaimResults() {
			_classCallCheck(this, ClaimResults);
	
			_get(Object.getPrototypeOf(ClaimResults.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ClaimResults, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodashLang.eq)(this.props.data, nextProps.data);
			}
	
			/**
	   * This function render the data for the qualification column in the claims result table.
	   * @param {object} main - thi is the claims record main property, what contains the qualification values
	   */
		}, {
			key: 'formatQualification',
			value: function formatQualification(main) {
				return _react2['default'].createElement(
					'span',
					null,
					_react2['default'].createElement(
						'span',
						null,
						main.qualification
					),
					main.subQualification && _react2['default'].createElement(
						'span',
						null,
						',',
						_react2['default'].createElement('br', null),
						main.subQualification
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var data = _props.data;
				var zoomTo = _props.zoomTo;
	
				return _react2['default'].createElement(
					'div',
					{ className: _claimsScss2['default'].claimsTableContainer },
					data && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
						_componentsReactable.Table,
						{
							className: _claimsScss2['default'].table,
							itemsPerPage: 20,
							filterable: ["clientName", "claimDate", "creationDate", "claimNumber", "contractNumber", "insuranceCompany", "claimsManager", "qualification", "state"],
							sortable: [{ column: 'claimDate', sortFunction: 'Date' }, { column: 'creationDate', sortFunction: 'Date' }, "clientName", "claimNumber", "contractNumber", "insuranceCompany", "claimsManager", 'qualification', "state"],
							defaultSort: {
								column: 'creationDate',
								direction: 'desc'
							}
						},
						_react2['default'].createElement(
							_componentsReactable.Thead,
							null,
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'clientName' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientName')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'claimDate' },
								_react2['default'].createElement(
									'strong',
									null,
									_('date')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'creationDate' },
								_react2['default'].createElement(
									'strong',
									null,
									_('creationDate')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'claimNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('claimNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'contractNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('contractNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'insuranceCompany' },
								_react2['default'].createElement(
									'strong',
									null,
									_('insuranceCompany')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'claimsManager' },
								_react2['default'].createElement(
									'strong',
									null,
									_('claimsManager')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'qualification' },
								_react2['default'].createElement(
									'strong',
									null,
									_('qualification')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'state' },
								_react2['default'].createElement(
									'strong',
									null,
									_('status')
								)
							)
						),
						data.map(function (_ref, key) {
							var main = _ref.main;
							var details = _ref.details;
							return _react2['default'].createElement(
								_componentsReactable.Tr,
								{
									key: key,
									className: 'clickable centered',
									onClick: function () {
										return zoomTo(main);
									}
								},
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'clientName' },
									main.clientName
								),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'claimDate', data: (0, _libHelpers.dateFormatter)(main.claimDate) }),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'creationDate', data: (0, _libHelpers.dateFormatter)(main.creationDate) }),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'claimNumber' },
									main.claimNumber
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'contractNumber' },
									main.contractNumber
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'insuranceCompany' },
									details.insuranceCompany
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'claimsManager' },
									main.claimsManager
								),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'qualification', data: _this.formatQualification(main), value: main.qualification + " " + main.subQualification }),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'state' },
									main.state
								)
							);
						})
					),
					data && _underscore2['default'].isArray(data) && data.length === 0 && _react2['default'].createElement(_noResults2['default'], { type: 'claims' }),
					data && _underscore2['default'].isArray(data) && data[0] === 'Too many rows' && _react2['default'].createElement(_tooManyResults2['default'], { type: 'claims' })
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				data: _react2['default'].PropTypes.array,
				zoomTo: _react2['default'].PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		return ClaimResults;
	})(_react2['default'].Component);
	
	exports['default'] = ClaimResults;
	module.exports = exports['default'];

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _claimsZoomScss = __webpack_require__(1593);
	
	var _claimsZoomScss2 = _interopRequireDefault(_claimsZoomScss);
	
	var _uploader = __webpack_require__(143);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _libHelpers = __webpack_require__(24);
	
	var _emailSenderEmailButton = __webpack_require__(108);
	
	var _emailSenderEmailButton2 = _interopRequireDefault(_emailSenderEmailButton);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _ClaimsWizardClaimWizardButton = __webpack_require__(263);
	
	var _ClaimsWizardClaimWizardButton2 = _interopRequireDefault(_ClaimsWizardClaimWizardButton);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('claimsZoom');
	
	var ClaimsZoom = (function (_React$Component) {
	    _inherits(ClaimsZoom, _React$Component);
	
	    _createClass(ClaimsZoom, null, [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            errors: _react2['default'].PropTypes.string,
	            data: _react2['default'].PropTypes.object.isRequired,
	            clientOptionsDict: _react2['default'].PropTypes.object,
	            isPhone: _react2['default'].PropTypes.bool
	        },
	
	        /**
	         * Constructor: initialize state etc.
	         * @param {*} props
	         */
	        enumerable: true
	    }]);
	
	    function ClaimsZoom(props) {
	        _classCallCheck(this, _ClaimsZoom);
	
	        _get(Object.getPrototypeOf(_ClaimsZoom.prototype), 'constructor', this).call(this, props);
	        var clientOptionsDict = props.clientOptionsDict;
	        var appLanguage = props.appLanguage;
	
	        this.state = {
	            clientOptionsDict: clientOptionsDict,
	            initializationCompleted: false,
	            claimDetailLoaded: false,
	            clientLoaded: false,
	            contractDetailsLoaded: false,
	            brokerNumber: null,
	            extendedClientOptionsDict: (0, _libHelpers.generateClientDicts)(clientOptionsDict, appLanguage)
	        };
	    }
	
	    /**
	     * Triggered before update the module.
	     * @param {object} nextProps
	     * @param {object} nextState
	     */
	
	    _createClass(ClaimsZoom, [{
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            if (nextState.claimDetailLoaded && nextState.clientLoaded && !nextState.initializationCompleted) {
	                this.setState({ initializationCompleted: true });
	            }
	            var claimContractNumber = _nestedProperty2['default'].get(nextProps, "claim.claimMain.contractNumber");
	            var contracts = _nestedProperty2['default'].get(nextProps, "contracts");
	            var contractId = (0, _libHelpers.findContractIdByContractNumber)(contracts, claimContractNumber);
	
	            // when we have the step when related api calls are finished and got the results
	            if (nextProps.contracts && nextProps.data && nextProps.contracts[contractId] && !nextProps.contracts[contractId].companyCancelMail) {
	                if (contractId) {
	                    // get client contract, and the reducer insert the contractManagerMail in to the store
	                    dispatch((0, _stateActions.fetchClientContract)(contractId));
	                }
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this = this;
	
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var clientOptionsDict = _props.clientOptionsDict;
	
	            try {
	                this.fetchData();
	
	                if (!clientOptionsDict || Object.keys(clientOptionsDict).length === 0) {
	                    dispatch((0, _stateActions.fetchClientOptionsDict)()).then(function (dictionary) {
	                        _this.setClientOptionsDict(dictionary);
	                    })['catch'](function (err) {
	                        return console.error("Error fetching client options dictionary:", err);
	                    });
	                } else {
	                    if (!this.state.clientOptionsDict) {
	                        this.setClientOptionsDict(clientOptionsDict);
	                    }
	                }
	            } catch (err) {
	                console.error("CDMount fetchData Err ", err);
	            }
	        }
	
	        /**
	         * Fetching clientContracts and clientClaims data from server and set the current brokerNumber
	         */
	    }, {
	        key: 'fetchData',
	        value: function fetchData() {
	            var _props2, dispatch, data, _state, claimDetailLoaded, clientLoaded, contractDetailsLoaded, claimId, clientNumber, brokerNumber, clientId, justReturn, fetchClientsResult, claimContractNumber, contractId, contracts;
	
	            return regeneratorRuntime.async(function fetchData$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        data = _props2.data;
	                        _state = this.state;
	                        claimDetailLoaded = _state.claimDetailLoaded;
	                        clientLoaded = _state.clientLoaded;
	                        contractDetailsLoaded = _state.contractDetailsLoaded;
	                        claimId = _nestedProperty2['default'].get(data, "main.claimId");
	                        clientNumber = _nestedProperty2['default'].get(data, "main.clientNumber");
	                        brokerNumber = _nestedProperty2['default'].get(data, "main.brokerNumber");
	
	                        if (!(claimId && !claimDetailLoaded)) {
	                            context$2$0.next = 19;
	                            break;
	                        }
	
	                        context$2$0.prev = 11;
	                        context$2$0.next = 14;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimDetail)(claimId)));
	
	                    case 14:
	                        context$2$0.next = 19;
	                        break;
	
	                    case 16:
	                        context$2$0.prev = 16;
	                        context$2$0.t0 = context$2$0['catch'](11);
	
	                        console.error("getClaimDetail ERR ", context$2$0.t0);
	
	                    case 19:
	
	                        // set to true anyway, because, based on it depends the rendering, and must happen even if not
	                        // necessary to laod it
	                        claimDetailLoaded = true;
	                        // --- END of loading calim details
	
	                        // +++ LOAD CLIENT DATA +++
	                        clientId = undefined;
	
	                        if (!(clientNumber && !clientLoaded)) {
	                            context$2$0.next = 35;
	                            break;
	                        }
	
	                        justReturn = true;
	                        fetchClientsResult = undefined;
	                        context$2$0.prev = 24;
	                        context$2$0.next = 27;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClients)({ clientNumber: clientNumber }, justReturn)));
	
	                    case 27:
	                        fetchClientsResult = context$2$0.sent;
	                        context$2$0.next = 33;
	                        break;
	
	                    case 30:
	                        context$2$0.prev = 30;
	                        context$2$0.t1 = context$2$0['catch'](24);
	
	                        console.error("fetchClients err", context$2$0.t1);
	
	                    case 33:
	
	                        clientLoaded = fetchClientsResult ? true : false;
	                        clientId = _nestedProperty2['default'].get(fetchClientsResult, "0.clientId");
	
	                    case 35:
	                        claimContractNumber = undefined;
	                        contractId = undefined;
	
	                        if (!clientId) {
	                            context$2$0.next = 49;
	                            break;
	                        }
	
	                        context$2$0.prev = 38;
	                        context$2$0.next = 41;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClient)(clientId)));
	
	                    case 41:
	                        context$2$0.next = 46;
	                        break;
	
	                    case 43:
	                        context$2$0.prev = 43;
	                        context$2$0.t2 = context$2$0['catch'](38);
	
	                        console.error("fetchClient err", context$2$0.t2);
	
	                    case 46:
	
	                        // take values direct from this props, not destructure it elsewhere, because the store renew references inbetween
	                        claimContractNumber = _nestedProperty2['default'].get(this.props, "data.main.contractNumber");
	                        contracts = _nestedProperty2['default'].get(this.props, "contracts");
	
	                        contractId = (0, _libHelpers.findContractIdByContractNumber)(contracts, claimContractNumber); // sync func call
	
	                    case 49:
	                        if (!(contractId && !contractDetailsLoaded)) {
	                            context$2$0.next = 59;
	                            break;
	                        }
	
	                        context$2$0.prev = 50;
	                        context$2$0.next = 53;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClientContract)(contractId)));
	
	                    case 53:
	                        context$2$0.next = 58;
	                        break;
	
	                    case 55:
	                        context$2$0.prev = 55;
	                        context$2$0.t3 = context$2$0['catch'](50);
	
	                        console.error("fetchClientContract err", context$2$0.t3);
	
	                    case 58:
	
	                        contractDetailsLoaded = true;
	
	                    case 59:
	
	                        if (brokerNumber) {
	                            this.setState({ brokerNumber: brokerNumber });
	                        } else {
	                            console.warn("Broker number is undefined");
	                        }
	                        // END of load contract details
	
	                        // single set state at the endto avoid uneccesarry rerenders
	                        this.setState({
	                            claimDetailLoaded: claimDetailLoaded,
	                            clientLoaded: clientLoaded,
	                            contractDetailsLoaded: contractDetailsLoaded,
	                            brokerNumber: brokerNumber
	                        });
	
	                    case 61:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[11, 16], [24, 30], [38, 43], [50, 55]]);
	        }
	
	        /**
	         * This function return with values for email sender, collected from this module
	         * depending on the current data structure.
	         */
	    }, {
	        key: 'collectVariableValues',
	        value: function collectVariableValues() {
	            var _props3 = this.props;
	            var dispatch = _props3.dispatch;
	            var claimNumber = _props3.claimNumber;
	            var data = _props3.data;
	            var claimDetail = _props3.claimDetail;
	            var clientData = _props3.clientData;
	            var clientDataExt = _props3.clientDataExt;
	            var contracts = _props3.contracts;
	
	            var clientId = _nestedProperty2['default'].get(clientData, "0.clientId");
	            var clientDataById = _nestedProperty2['default'].get(clientDataExt, clientId + ".main");
	
	            // digging out the contract related documents
	            var claim = data;
	            var claimContractNumber = _nestedProperty2['default'].get(claim, "main.contractNumber");
	            var contractId = (0, _libHelpers.findContractIdByContractNumber)(contracts, claimContractNumber);
	            var mainContract = contracts[contractId];
	
	            var contract = _nestedProperty2['default'].get(contracts, contractId);
	            var contractDocuments = _nestedProperty2['default'].get(contract, "documents");
	            var contractDocumentsId = contractId;
	
	            var emails = _nestedProperty2['default'].get(clientDataExt, clientId + '.detail.emails');
	            var clientName = _nestedProperty2['default'].get(data, "main.clientName");
	
	            if (emails && emails.length) {
	                emails = emails.map(function (item) {
	                    return {
	                        referenceId: clientId,
	                        label: clientName,
	                        value: item.email,
	                        'default': item['default'] == "true" || item['default'] == true ? true : false
	                    };
	                });
	
	                emails = emails.sort(function (item, item2) {
	                    if (item['default'] && !item2['default']) {
	                        return -1;
	                    }
	                    if (!item['default'] && item2['default']) {
	                        return 1;
	                    }
	                    if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                        return 0;
	                    }
	                }) || [];
	            }
	            return {
	                contractNumber: data.main.contractNumber,
	                claimsNumber: claimNumber,
	                clientName: clientName,
	                clientEmails: emails,
	
	                clientDocuments: _nestedProperty2['default'].get(clientDataExt, clientId + ".clientDocuments"),
	                clientDocumentsType: 'client',
	                clientDocumentsId: clientId,
	
	                // new v6 mode
	                claimDocuments: data.documents,
	                claimDocumentsType: "claim",
	                claimDocumentsId: data.main.claimId,
	                companyCancelMail: _nestedProperty2['default'].get(mainContract, 'companyCancelMail'),
	
	                contractDocuments: contractDocuments,
	                contractDocumentsType: "contract",
	                contractDocumentsId: contractDocumentsId,
	
	                clientId: false,
	                contractId: false,
	                claimId: data.main.claimId,
	                company: data.details.insuranceCompany,
	
	                brokerNumber: _nestedProperty2['default'].get(data, "main.brokerNumber"),
	                claim: data,
	                claimDetail: claimDetail,
	                clientNumber: _nestedProperty2['default'].get(clientDataById, "clientNumber"),
	                clientData: clientDataById
	
	            };
	        }
	
	        /**
	         * This function render the data for the qualification column in the claims result table.
	         * @param {object} main - thi is the claims record main property, what contains the qualification values
	         */
	    }, {
	        key: 'formatQualification',
	        value: function formatQualification(qualification, subQualification) {
	            return _react2['default'].createElement(
	                'span',
	                null,
	                _react2['default'].createElement(
	                    'span',
	                    null,
	                    qualification
	                ),
	                subQualification && _react2['default'].createElement(
	                    'span',
	                    null,
	                    ',',
	                    _react2['default'].createElement('br', null),
	                    subQualification
	                )
	            );
	        }
	
	        /**
	         * Get client id if we have clientData
	         * @param {*} clientNumber
	         * @returns clientId
	         */
	    }, {
	        key: 'getClientId',
	        value: function getClientId(clientNumber) {
	            var clientData = this.props.clientData;
	
	            var clientId = undefined;
	            if (clientData && Array.isArray(clientData)) {
	                clientData.map(function (oneClient) {
	                    clientId = oneClient.clientNumber === clientNumber ? oneClient.clientId : clientId;
	                });
	            } else {
	                console.warn("clientData is not an array as expected, maybe is not loaded yet: ", clientData);
	            }
	            return clientId;
	        }
	    }, {
	        key: 'zoomTo',
	        value: function zoomTo(claimNumber) {
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _stateActions.navigateToConnexClaim)(_stateConstants2['default'].CLAIMS, claimNumber));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props;
	            var claimNumber = _props4.claimNumber;
	            var data = _props4.data;
	            var dispatch = _props4.dispatch;
	            var isPhone = _props4.isPhone;
	            var clientAccess = _props4.clientAccess;
	            var claimDetail = _props4.claimDetail;
	
	            if (!data) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    '...'
	                );
	            }
	
	            var connex = data.connex || [];
	            var _state2 = this.state;
	            var initializationCompleted = _state2.initializationCompleted;
	            var brokerNumber = _state2.brokerNumber;
	            var extendedClientOptionsDict = _state2.extendedClientOptionsDict;
	
	            var createmail = clientAccess && clientAccess.filter(function (item) {
	                return item.actionName == "createmail" && item.actionAllowed == "true";
	            }).length > 0;
	            var moduleKeyToSet = _nestedProperty2['default'].get(this.props, "EmailTemplateRelations.EmailTemplateModules.claims.value") || false;
	            var canCreateMifid = clientAccess && clientAccess.filter(function (item) {
	                return item.actionName == "createmifid" && item.actionAllowed == "true";
	            }).length > 0;
	            var claimId = _nestedProperty2['default'].get(data, 'main.claimId');
	            var clientId = this.getClientId(_nestedProperty2['default'].get(data, 'main.clientNumber'));
	            var contractId = this.collectVariableValues().contractDocumentsId;
	
	            var columns = [[{ label: _('clientName'), value: data.main.clientName }, { label: _('insuranceCompany'), value: data.details.insuranceCompany }, { label: _('claimDate'), value: (0, _libHelpers.formatDate)(data.main.claimDate) }, { label: _('state'), value: data.main.state }, { label: _('contractNumber'), value: data.main.contractNumber }, { label: _('riskDescription'), value: data.details.riskDescription }, { label: _('claimRefBroker'), value: data.main.claimRefBroker }], [{ label: _('brokerNumber'), value: data.main.brokerNumber }, { label: _('claimsManager'), value: data.main.claimsManagerName }, { label: _('creationDate'), value: (0, _libHelpers.formatDate)(data.main.creationDate) }, { label: _('qualification'), value: this.formatQualification(data.main.qualification, data.main.subQualification) }, { label: _('branche'), value: data.details.branche }]];
	
	            var involvedPartiesLabels = [];
	            var missingDocumentsLabels = [];
	            var claimStatusAndQualification = {};
	
	            if (claimDetail) {
	                claimStatusAndQualification.claimStatus = claimDetail.claimStatus;
	                claimStatusAndQualification.qualificationNumber = claimDetail.qualificationNumber;
	                claimStatusAndQualification.subQualificationNumber = claimDetail.subQualificationNumber;
	
	                involvedPartiesLabels = claimDetail.missingInfo.involvedParties.map(function (value) {
	                    var involvedTexts = extendedClientOptionsDict.involvedParties.find(function (option) {
	                        return option.value === value;
	                    });
	                    return involvedTexts ? involvedTexts.label : '';
	                });
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    var _loop = function () {
	                        var oneDoc = _step.value;
	
	                        if (claimDetail.Documents && claimDetail.Documents.length > 0) {
	                            var missingDocType = claimDetail.Documents.find(function (doc) {
	                                return doc.docType === oneDoc.docType;
	                            });
	                            if (missingDocType) {
	                                if (missingDocType.alternativeDocTypes && missingDocType.alternativeDocTypes.length > 0) {
	                                    (function () {
	                                        var selectedAlternative = missingDocType.alternativeDocTypes.find(function (altDoc) {
	                                            return +altDoc.altDocCount > 0;
	                                        });
	                                        if (selectedAlternative) {
	                                            missingDocType.alternativeDocTypes.filter(function (altDoc) {
	                                                return +altDoc.altDocCount === 0 && altDoc.alternativeNr === selectedAlternative.alternativeNr;
	                                            }).forEach(function (altDoc) {
	                                                var newLabel = extendedClientOptionsDict.documentTypeOptions.find(function (option) {
	                                                    return option.value === altDoc.altDocType;
	                                                });
	                                                if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
	                                                    missingDocumentsLabels.push(newLabel);
	                                                }
	                                            });
	                                        } else {
	                                            var newLabel = extendedClientOptionsDict.documentTypeOptions.find(function (option) {
	                                                return option.value === oneDoc.docType;
	                                            });
	                                            if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
	                                                missingDocumentsLabels.push(newLabel);
	                                            }
	                                        }
	                                    })();
	                                } else if (missingDocType.docCount && +missingDocType.docCount <= 0) {
	                                    var newLabel = extendedClientOptionsDict.documentTypeOptions.find(function (option) {
	                                        return option.value === oneDoc.docType;
	                                    });
	                                    if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
	                                        missingDocumentsLabels.push(newLabel);
	                                    }
	                                }
	                            }
	                        }
	                    };
	
	                    for (var _iterator = claimDetail.missingInfo.documents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        _loop();
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator['return']) {
	                            _iterator['return']();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _claimsZoomScss2['default'].claimsZoom },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _claimsZoomScss2['default'].mainTitleDiv },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _claimsZoomScss2['default'].mainTitleContainer },
	                        _react2['default'].createElement(
	                            'h2',
	                            { className: _claimsZoomScss2['default'].mainTitle },
	                            _('claims')
	                        )
	                    ),
	                    !isPhone && _react2['default'].createElement(
	                        'div',
	                        { className: _claimsZoomScss2['default'].moduleControls },
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    return dispatch((0, _stateActions.setOpened)());
	                                }, id: 'backToList', className: _claimsZoomScss2['default'].greyButton },
	                            _('backToList')
	                        ),
	                        createmail && initializationCompleted && _react2['default'].createElement(_emailSenderEmailButton2['default'], {
	                            moduleKeyToSet: moduleKeyToSet,
	                            moduleOptions: this.collectVariableValues()
	                        }),
	                        canCreateMifid && clientId && _react2['default'].createElement(
	                            'div',
	                            { className: _claimsZoomScss2['default'].DSWizardButtonWrapper },
	                            _react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
	                                moduleKeyToSet: _stateConstants2['default'].DS_MODULE_CLIENT_CLAIMS,
	                                subModuleKeyToSet: _stateConstants2['default'].DS_MODULE_CLIENT_CLAIMS,
	                                clientId: clientId,
	                                claimId: claimId,
	                                claimNumber: claimNumber,
	                                callBackOnClose: function () {},
	                                moduleOptions: this.collectVariableValues()
	                            })
	                        ),
	                        claimDetail && claimDetail.claimStatus === '8' && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _claimsZoomScss2['default'].wizardButtonCorrection },
	                                _react2['default'].createElement(_ClaimsWizardClaimWizardButton2['default'], {
	                                    claimNumber: claimNumber,
	                                    contractId: contractId,
	                                    clientId: clientId,
	                                    brokerNumber: brokerNumber,
	                                    onCloseMethod: function () {
	                                        return _this2.props.dispatch((0, _stateActions.getClaimDetail)(claimId));
	                                    },
	                                    onGoing: true
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _claimsZoomScss2['default'].agentClaimsZoom },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _claimsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _claimsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _claimsZoomScss2['default'].subTitle },
	                                _('claimNumber'),
	                                ' ',
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    claimNumber
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(_KeyValue2['default'], { array: columns, divider: true })
	                    ),
	                    (claimDetail && involvedPartiesLabels.length > 0 || missingDocumentsLabels.length > 0) && _react2['default'].createElement(
	                        'div',
	                        { className: _claimsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _claimsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _claimsZoomScss2['default'].subTitle },
	                                _('missingInfo')
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _claimsZoomScss2['default'].missingInfo },
	                            involvedPartiesLabels.length > 0 && _react2['default'].createElement(
	                                'div',
	                                { className: _claimsZoomScss2['default'].missingInfoColumn },
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: _claimsZoomScss2['default'].missingInfoTitle },
	                                    _('missingInvolvedParties'),
	                                    ':'
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _claimsZoomScss2['default'].missingInfoEnum },
	                                    involvedPartiesLabels.map(function (label, index) {
	                                        return _react2['default'].createElement(
	                                            'span',
	                                            { key: index, className: _claimsZoomScss2['default'].missingInfoRow },
	                                            label
	                                        );
	                                    })
	                                )
	                            ),
	                            missingDocumentsLabels.length > 0 && _react2['default'].createElement(
	                                'div',
	                                { className: _claimsZoomScss2['default'].missingInfoColumn },
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: _claimsZoomScss2['default'].missingInfoTitle },
	                                    _('missingDocuments'),
	                                    ':'
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _claimsZoomScss2['default'].missingInfoEnum },
	                                    missingDocumentsLabels.map(function (label, index) {
	                                        return _react2['default'].createElement(
	                                            'span',
	                                            { key: index, className: _claimsZoomScss2['default'].missingInfoRow },
	                                            label.label
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _claimsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _claimsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _claimsZoomScss2['default'].conexTitle },
	                                _('connex')
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Table,
	                            {
	                                className: _claimsZoomScss2['default'].table,
	                                itemsPerPage: 20
	                            },
	                            _react2['default'].createElement(
	                                _componentsReactable.Thead,
	                                null,
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'claimNumber' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('claimNumber')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'nameClient' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('nameClient')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'contractNumber' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('contractNumber')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'companyName' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('companyName')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'qualification' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('qualification')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'state' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('state')
	                                    )
	                                )
	                            ),
	                            connex.map(function (item, key) {
	                                return _react2['default'].createElement(
	                                    _componentsReactable.Tr,
	                                    {
	                                        className: 'clickable centered',
	                                        onClick: function () {
	                                            return _this2.zoomTo(item.claimNumber);
	                                        }, key: key
	                                    },
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'claimNumber' },
	                                        item.claimNumber
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'nameClient' },
	                                        item.clientName
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'contractNumber' },
	                                        item.contractNumber
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'companyName' },
	                                        item.companyName
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'qualification' },
	                                        item.qualification
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'state' },
	                                        item.state
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    _react2['default'].createElement(_uploader2['default'], { type: 'claim', documents: data.documents, id: data.main.claimId, claimStatusAndQualification: claimStatusAndQualification })
	                )
	            );
	        }
	    }]);
	
	    var _ClaimsZoom = ClaimsZoom;
	    ClaimsZoom = (0, _reactRedux.connect)(function (state) {
	        return {
	            claimNumber: state.app.opened,
	            isPhone: state.responsive.isPhone,
	            EmailTemplateRelations: state.app.security.EmailTemplateRelations,
	            clientAccess: state.app.security.actions,
	            claimDetail: _nestedProperty2['default'].get(state, "client.claimDetail"),
	            clientData: _nestedProperty2['default'].get(state, "clients.data"),
	            clientDataExt: _nestedProperty2['default'].get(state, "clients.clientData"),
	            appLanguage: state.app.lang,
	            clientOptionsDict: state.client.clientOptionsDict,
	            contracts: state.contracts
	        };
	    })(ClaimsZoom) || ClaimsZoom;
	    return ClaimsZoom;
	})(_react2['default'].Component);
	
	exports['default'] = ClaimsZoom;
	module.exports = exports['default'];

	// +++ CLAIM LOADING IF EXISTS +++

	// just return the result no forward to the client profile.

	// +++ LOAD MORE CLIENT DATA +++

	// --- END of load more client data ---

	// +++ LOAD contract details +++

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _ClaimsWizardClaimWizardButton = __webpack_require__(263);
	
	var _ClaimsWizardClaimWizardButton2 = _interopRequireDefault(_ClaimsWizardClaimWizardButton);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('claimWizardTable');
	
	var formatDateTime = function formatDateTime(isoString) {
	    var date = new Date(isoString);
	    var day = String(date.getDate()).padStart(2, '0');
	    var month = String(date.getMonth() + 1).padStart(2, '0');
	    var year = date.getFullYear();
	
	    return day + '/' + month + '/' + year;
	};
	
	var DigitalClaimTable = (function (_React$Component) {
	    _inherits(DigitalClaimTable, _React$Component);
	
	    function DigitalClaimTable() {
	        _classCallCheck(this, DigitalClaimTable);
	
	        _get(Object.getPrototypeOf(DigitalClaimTable.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(DigitalClaimTable, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchClientOptionsDict();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var claims = _props.claims;
	            var onCloseMethod = _props.onCloseMethod;
	            var clientOptionsDict = _props.clientOptionsDict;
	            var appLanguage = _props.appLanguage;
	            var navigateToClientClaims = _props.navigateToClientClaims;
	            var navigateToClientContracts = _props.navigateToClientContracts;
	
	            var findStatusIndex = function findStatusIndex(status, appLanguage) {
	                return (Object.entries(clientOptionsDict.SCHADE_STATUS).find(function (_ref) {
	                    var _ref2 = _slicedToArray(_ref, 2);
	
	                    var key = _ref2[0];
	                    var value = _ref2[1];
	                    return value[appLanguage] === status;
	                }) || [null])[0];
	            };
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _reactableScss2['default'].tableContainer },
	                _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        filterable: ['claimDate', 'date', 'formattedDate', 'claimNumber', 'clientName', 'userName', 'contractNumber', 'risk', 'desciption', 'status', 'action'],
	                        filterPlaceholder: 'Filter',
	                        className: 'noPadding',
	                        itemsPerPage: 20,
	                        sortable: ['claimDate', 'date', 'claimNumber', 'clientName', 'userName', 'contractNumber', 'risk', 'desciption', 'status', 'action'],
	                        defaultSort: {
	                            column: 'date',
	                            direction: 'desc'
	                        }
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'claimDate' },
	                            _('claimDate')
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'date' },
	                            _('creationTime')
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'claimNumber' },
	                            _('claimNumber')
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'clientName' },
	                            _('clientName')
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'contractNumber' },
	                            _('contractNumber')
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'risk' },
	                            _('risk')
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'desciption' },
	                            _('description')
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'status' },
	                            _('status')
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'action' },
	                            _('action')
	                        )
	                    ),
	                    claims.map(function (row, index) {
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            { className: 'centered', key: index },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'claimDate', value: row.main.claimDate },
	                                formatDateTime(row.main.claimDate)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'formattedClaimDate', style: { display: 'none' }, value: formatDateTime(row.main.claimDate) },
	                                formatDateTime(row.main.claimDate)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'date', value: row.main.creationDate },
	                                formatDateTime(row.main.creationDate)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'formattedDate', style: { display: 'none' }, value: formatDateTime(row.main.creationDate) },
	                                formatDateTime(row.main.creationDate)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'claimNumber', value: row.main.claimNumber },
	                                _react2['default'].createElement(
	                                    'a',
	                                    {
	                                        style: { cursor: 'pointer' },
	                                        onClick: function () {
	                                            return navigateToClientClaims(row.main.clientId, row.main.claimId, row.main.claimNumber);
	                                        }
	                                    },
	                                    row.main.claimNumber
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'clientName', value: row.main.clientName },
	                                row.main.clientName
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'contractNumber', value: row.main.contractNumber },
	                                _react2['default'].createElement(
	                                    'a',
	                                    {
	                                        style: { cursor: 'pointer' },
	                                        onClick: function () {
	                                            return navigateToClientContracts(row.main.clientId, row.main.contractId);
	                                        }
	                                    },
	                                    row.main.contractNumber
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'risk', value: row.details.riskDescription },
	                                row.details.riskDescription
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'desciption', value: row.main.qualification },
	                                row.main.qualification
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'status', value: row.main.state },
	                                row.main.state
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'action', style: { display: 'flex', justifyContent: 'flex-start' } },
	                                Number(findStatusIndex(row.main.state, appLanguage)) === 8 ? _react2['default'].createElement(_ClaimsWizardClaimWizardButton2['default'], {
	                                    contractId: row.main.contractId,
	                                    brokerNumber: row.main.brokerNumber,
	                                    clientId: row.main.clientId,
	                                    claimNumber: row.main.claimNumber,
	                                    onCloseMethod: onCloseMethod,
	                                    onGoing: true,
	                                    isDigitalTable: true
	                                }) : null
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return DigitalClaimTable;
	})(_react2['default'].Component);
	
	DigitalClaimTable.propTypes = {
	    fetchClientOptionsDict: _propTypes2['default'].func.isRequired,
	    clientOptionsDict: _propTypes2['default'].object,
	    appLanguage: _propTypes2['default'].string,
	    onCloseMethod: _propTypes2['default'].func.isRequired
	};
	
	DigitalClaimTable.defaultProps = {
	    clientOptionsDict: { SCHADE_STATUS: {} }
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        clientOptionsDict: state.client.clientOptionsDict,
	        appLanguage: state.app.lang
	    };
	};
	
	var mapDispatchToProps = {
	    fetchClientOptionsDict: _stateActions.fetchClientOptionsDict,
	    navigateToClientClaims: _stateActions.navigateToClientClaims,
	    navigateToClientContracts: _stateActions.navigateToClientContracts
	};
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DigitalClaimTable);
	module.exports = exports['default'];

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(57);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectSelectWrap2 = _interopRequireDefault(_sharedSelectSelectWrap);
	
	var _claimsScss = __webpack_require__(437);
	
	var _claimsScss2 = _interopRequireDefault(_claimsScss);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _input = __webpack_require__(109);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _libHelpers = __webpack_require__(24);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('claims');
	
	var fieldType = {
		clientName: 'multiple',
		brokerNumber: 'multiple',
		claimDate: 'multiple',
		creationDate: 'multiple',
		contractNumber: 'unique',
		clientNumber: 'unique',
		claimNumber: 'unique',
		claimRefBroker: 'unique',
		licencePlate: 'multiple',
		state: 'always'
	};
	
	var validate = function validate(values) {
		var errors = {};
		var formattedData = (0, _libHelpers.trimObject)(values);
		var isEmpty = !(0, _libHelpers.hasContent)(formattedData);
		if (isEmpty) {
			errors._error = 'emptyFields';
		}
		return errors;
	};
	
	var ClaimsForm = (function (_React$Component) {
		_inherits(ClaimsForm, _React$Component);
	
		function ClaimsForm() {
			_classCallCheck(this, _ClaimsForm);
	
			_get(Object.getPrototypeOf(_ClaimsForm.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ClaimsForm, [{
			key: 'render',
			value: function render() {
				var columns = [['clientName', 'brokerNumber', 'claimDate', 'creationDate'], ['contractNumber', 'clientNumber', 'claimNumber', 'claimRefBroker', 'licencePlate']];
	
				var options = [{ value: '', label: '' + _('all') }, { value: 'open', label: '' + _('active') }, { value: 'closed', label: '' + _('inactive') }];
	
				var _props = this.props;
				var fields = _props.fields;
				var state = _props.fields.state;
				var handleSubmit = _props.handleSubmit;
				var error = _props.error;
	
				var invalid = error === 'emptyFields';
				var usedField = (0, _lodashCollection.find)(fields, function (field) {
					return field.value;
				});
				var usedType = usedField && fieldType[usedField.name] !== 'always' && fieldType[usedField.name];
				return _react2['default'].createElement(
					'form',
					{ id: 'casper_claims', onSubmit: handleSubmit, name: 'claimsSearchForm', className: 'claimsSearchForm' },
					_react2['default'].createElement(
						'div',
						{ className: _claimsScss2['default'].formContainer },
						columns.map(function (col, i) {
							return _react2['default'].createElement(
								'div',
								{ key: i, className: _claimsScss2['default'].column },
								col.map(function (name) {
									var isDisabled = false;
									if (usedType && usedField.name !== name) {
										if (usedType === 'unique') {
											isDisabled = true;
										} else {
											isDisabled = usedType !== fieldType[name];
										}
									}
									return _react2['default'].createElement(
										'div',
										{ key: name, className: _claimsScss2['default'].searchContainer },
										_react2['default'].createElement(
											'div',
											{ className: _claimsScss2['default'].label },
											_(name)
										),
										_react2['default'].createElement(
											'div',
											{ className: _claimsScss2['default'].claimsSearchInput },
											_react2['default'].createElement(_input2['default'], _extends({
												type: 'text',
												autoFocus: name === 'clientName',
												disabled: isDisabled
											}, fields[name]))
										)
									);
								})
							);
						}),
						_react2['default'].createElement(
							'div',
							{ className: _claimsScss2['default'].dropContainer },
							_react2['default'].createElement(
								'div',
								{ className: _claimsScss2['default'].dropdown },
								_react2['default'].createElement(
									'div',
									{ className: _claimsScss2['default'].label },
									_('state')
								),
								_react2['default'].createElement(
									'div',
									{ className: _claimsScss2['default'].claimsSearchDropdown },
									_react2['default'].createElement(_sharedSelectSelectWrap2['default'], _extends({
										options: options
									}, state, {
										onBlur: function (e) {
											e.preventDefault();
										}
									}))
								)
							)
						)
					),
					_react2['default'].createElement(
						'button',
						{ id: 'casper_claimsButton', type: 'submit', disabled: invalid, onClick: handleSubmit, className: _claimsScss2['default'].greyButton },
						_('submitbutton')
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				fields: _react2['default'].PropTypes.object,
				handleSubmit: _react2['default'].PropTypes.func,
				error: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		var _ClaimsForm = ClaimsForm;
		ClaimsForm = (0, _reduxForm.reduxForm)({
			form: "claims",
			fields: Object.keys(fieldType),
			validate: validate
		})(ClaimsForm) || ClaimsForm;
		return ClaimsForm;
	})(_react2['default'].Component);
	
	exports['default'] = ClaimsForm;
	module.exports = exports['default'];

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _claimsZoom = __webpack_require__(1075);
	
	var _claimsZoom2 = _interopRequireDefault(_claimsZoom);
	
	var _form = __webpack_require__(1077);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _claimResults = __webpack_require__(1074);
	
	var _claimResults2 = _interopRequireDefault(_claimResults);
	
	var _digitalClaimTable = __webpack_require__(1076);
	
	var _digitalClaimTable2 = _interopRequireDefault(_digitalClaimTable);
	
	var _claimsScss = __webpack_require__(437);
	
	var _claimsScss2 = _interopRequireDefault(_claimsScss);
	
	var _ = (0, _libI18n2['default'])('claims');
	
	var SubNav = function SubNav(_ref) {
		var currentId = _ref.currentId;
		var items = _ref.items;
		var onChange = _ref.onChange;
		return _react2['default'].createElement(
			'div',
			{ className: _claimsScss2['default'].subNavContainer },
			Object.keys(items).map(function (moduleId) {
				return _react2['default'].createElement(
					'div',
					{
						key: moduleId,
						className: _claimsScss2['default'].tab + ' ' + (currentId === moduleId ? _claimsScss2['default'].active : ''),
						onClick: function () {
							if (currentId !== moduleId) {
								onChange(moduleId);
							}
						}
					},
					items[moduleId]
				);
			})
		);
	};
	
	var Claims = (function (_React$Component) {
		_inherits(Claims, _React$Component);
	
		function Claims(props) {
			var _this = this;
	
			_classCallCheck(this, _Claims);
	
			_get(Object.getPrototypeOf(_Claims.prototype), 'constructor', this).call(this, props);
	
			this.handleSearch = function (data) {
				var dispatch = _this.props.dispatch;
	
				return dispatch((0, _stateActions.fetchClaims)(data)).then(function (data) {
					_this.setState({ showTable: true }, function () {
						_this.forceUpdate();
					});
					return data;
				});
			};
	
			this.zoomClaim = function (item) {
				var dispatch = _this.props.dispatch;
	
				dispatch((0, _stateActions.setOpened)(item.claimNumber));
			};
	
			this.setActiveSubtitle = function (subtitle) {
				_this.setState(function (prevState) {
					return {
						activeSubtitle: prevState.activeSubtitle === subtitle ? 'schade' : subtitle
					};
				}, function () {
					if (_this.state.activeSubtitle === 'digital') {
						_this.props.dispatch((0, _stateActions.fetchAllClaimWizardPackages)({ createdByBroker: "true" }));
					} else if (_this.state.activeSubtitle === 'schade') {
						_this.props.dispatch((0, _stateActions.clearClaimWizardPackages)());
					}
				});
			};
	
			this.state = {
				showTable: false,
				activeSubtitle: 'schade'
			};
		}
	
		_createClass(Claims, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _props = this.props;
				var expandedItem = _props.expandedItem;
				var claimNumber = _props.claimNumber;
				var dispatch = _props.dispatch;
	
				this.setState({ showTable: false });
	
				if (claimNumber && !expandedItem) {
					dispatch((0, _stateActions.fetchClaims)({ claimNumber: claimNumber }));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var dispatch;
				return regeneratorRuntime.async(function componentWillUnmount$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							dispatch = this.props.dispatch;
	
							dispatch((0, _stateActions.clearClaimWizardPackages)());
							context$2$0.next = 4;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.resetClaimWizard)()));
	
						case 4:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props2 = this.props;
				var claims = _props2.claims;
				var expandedItem = _props2.expandedItem;
				var opened = _props2.opened;
				var claimWizardPackages = _props2.claimWizardPackages;
				var _state = this.state;
				var showTable = _state.showTable;
				var activeSubtitle = _state.activeSubtitle;
	
				var output = undefined;
				switch (activeSubtitle) {
					case 'schade':
						output = _react2['default'].createElement(
							'div',
							null,
							_react2['default'].createElement(_form2['default'], { onSubmit: this.handleSearch, initialValues: { state: '' } }),
							showTable && claims && _react2['default'].createElement(_claimResults2['default'], { data: claims, zoomTo: this.zoomClaim })
						);
						break;
					case 'digital':
						output = _react2['default'].createElement(_digitalClaimTable2['default'], { claims: claimWizardPackages, onCloseMethod: function () {
								return _this2.props.dispatch((0, _stateActions.fetchAllClaimWizardPackages)({ createdByBroker: "true" }));
							} });
						break;
					default:
						output = _react2['default'].createElement(
							'div',
							null,
							_('Unknown subtitle')
						);
						break;
				}
	
				return _react2['default'].createElement(
					'div',
					{ className: _claimsScss2['default'].claimsMain },
					_react2['default'].createElement(
						'div',
						{ className: _claimsScss2['default'].claimsSearchContainer + ' ' + (opened ? _claimsScss2['default'].hidden : 'visible') },
						_react2['default'].createElement(
							'div',
							{ className: 'main-title-div' },
							_react2['default'].createElement(
								'h2',
								{ className: 'main-title' },
								_('title')
							),
							_react2['default'].createElement(
								'div',
								{ className: _claimsScss2['default'].subtitles },
								_react2['default'].createElement(SubNav, {
									currentId: activeSubtitle,
									items: {
										schade: _('subtitle'),
										digital: _('digitalTable')
									},
									onChange: this.setActiveSubtitle
								})
							)
						),
						output
					),
					expandedItem && _react2['default'].createElement(
						'div',
						{ className: _claimsScss2['default'].claimsZoomContainer },
						_react2['default'].createElement(_claimsZoom2['default'], { data: expandedItem })
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				claims: _react2['default'].PropTypes.array,
				claimNumber: _react2['default'].PropTypes.any,
				dispatch: _react2['default'].PropTypes.func,
				expandedItem: _react2['default'].PropTypes.object,
				opened: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		var _Claims = Claims;
		Claims = (0, _reactRedux.connect)(function (state) {
			var claims = state.claims;
			var opened = state.app.opened;
			var claimWizardPackages = state.claimWizard.claimWizardPackages;
	
			return {
				claims: claims,
				claimNumber: opened,
				expandedItem: opened ? claims.find(function (i) {
					return i.main.claimNumber === opened;
				}) : null,
				claimWizardPackages: claimWizardPackages,
				opened: opened
			};
		})(Claims) || Claims;
		return Claims;
	})(_react2['default'].Component);
	
	exports['default'] = Claims;
	module.exports = exports['default'];

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clientAddressScss = __webpack_require__(1594);
	
	var _clientAddressScss2 = _interopRequireDefault(_clientAddressScss);
	
	var _input = __webpack_require__(109);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _bpostSelect = __webpack_require__(365);
	
	var _bpostSelect2 = _interopRequireDefault(_bpostSelect);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libHelpers = __webpack_require__(24);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var ClientAddressList = (function (_React$Component) {
	  _inherits(ClientAddressList, _React$Component);
	
	  function ClientAddressList(props) {
	    _classCallCheck(this, ClientAddressList);
	
	    _get(Object.getPrototypeOf(ClientAddressList.prototype), 'constructor', this).call(this, props);
	  }
	
	  _createClass(ClientAddressList, [{
	    key: 'onBlurSetCountry',
	    value: function onBlurSetCountry(field) {
	      var _props = this.props;
	      var data = _props.data;
	      var addType = _props.addType;
	      var dispatch = _props.dispatch;
	
	      if (addType == 'corressadd' && field.name != 'detail.correspondanceAddress.country') {
	        if (this.emptyCheckAddressValues(data) == false) {
	          if (data.country.value == undefined || data.country.value == "" || typeof data.country.value == 'object') {
	            dispatch({
	              type: "redux-form/CHANGE",
	              field: data.country.name,
	              value: "1",
	              touch: true,
	              form: "clientProfileEdit"
	            });
	
	            dispatch({
	              type: "redux-form/CHANGE",
	              field: data.postalCode.name,
	              value: "",
	              touch: true,
	              form: "clientProfileEdit"
	            });
	
	            dispatch({
	              type: "redux-form/CHANGE",
	              field: data.locality.name,
	              value: "",
	              touch: true,
	              form: "clientProfileEdit"
	            });
	          }
	        }
	      }
	
	      dispatch({
	        type: "redux-form/BLUR",
	        field: field.name,
	        value: field.value,
	        touch: true,
	        form: "clientProfileEdit"
	      });
	
	      // Clean zipCity or postalCode and locality based on country data
	      if (field.name == 'detail.correspondanceAddress.country') {
	        if (Number(field.value) == 1) {
	          dispatch({
	            type: "redux-form/CHANGE",
	            field: data.postalCode.name,
	            value: "",
	            touch: true,
	            form: "clientProfileEdit"
	          });
	
	          dispatch({
	            type: "redux-form/CHANGE",
	            field: data.locality.name,
	            value: "",
	            touch: true,
	            form: "clientProfileEdit"
	          });
	        } else if (typeof field.value == 'object' || field.value == undefined || field.value == '') {
	          dispatch({
	            type: "redux-form/CHANGE",
	            field: data.postalCode.name,
	            value: "",
	            touch: true,
	            form: "clientProfileEdit"
	          });
	
	          dispatch({
	            type: "redux-form/CHANGE",
	            field: data.locality.name,
	            value: "",
	            touch: true,
	            form: "clientProfileEdit"
	          });
	          dispatch({
	            type: "redux-form/CHANGE",
	            field: data.zipCity.name,
	            value: "_",
	            touch: true,
	            form: "clientProfileEdit"
	          });
	        } else {
	          dispatch({
	            type: "redux-form/CHANGE",
	            field: data.zipCity.name,
	            value: "_",
	            touch: true,
	            form: "clientProfileEdit"
	          });
	        }
	      }
	    }
	
	    /**
	     * Checks if the correspondance address has already values
	     * If there is any value then will return false
	     */
	  }, {
	    key: 'emptyCheckAddressValues',
	    value: function emptyCheckAddressValues(data) {
	      var response = true;
	
	      Object.keys(data).map(function (key) {
	        if (key != 'zipCity') {
	          if (data[key].value != undefined && data[key].value != "" && data[key].value != "_") {
	            response = false;
	          }
	        } else {
	          if (data[key].value != undefined && data[key].value != "") {
	            response = false;
	          }
	        }
	      });
	
	      return response;
	    }
	
	    // Reset fields in case of corressadd requested by Silke BEWB-278
	  }, {
	    key: 'resetDataClick',
	    value: function resetDataClick(ev) {
	      var _props2 = this.props;
	      var data = _props2.data;
	      var dispatch = _props2.dispatch;
	
	      Object.keys(data).forEach(function (key) {
	        dispatch({
	          type: "redux-form/CHANGE",
	          field: data[key].name,
	          value: "",
	          form: "clientProfileEdit"
	        });
	      });
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      try {
	        return __webpack_require__(79);
	      } catch (err) {
	        return __webpack_require__(23);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props3 = this.props;
	      var data = _props3.data;
	      var countryOptions = _props3.countryOptions;
	      var title = _props3.title;
	      var addType = _props3.addType;
	
	      var isNotBelgiumSelected = data.country.value == 1 ? true : false;
	      var cityZip = null;
	
	      if (isNotBelgiumSelected == true) {
	        cityZip = _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'label',
	            null,
	            _('city'),
	            addType == 'mainaddress' ? " *" : ""
	          ),
	          _react2['default'].createElement(_bpostSelect2['default'], _extends({}, data.zipCity, { onBlur: function () {
	              _this.onBlurSetCountry(data.zipCity);
	            } })),
	          data != undefined && data.zipCity.error && data.zipCity.touched && _react2['default'].createElement(
	            'div',
	            { className: _clientAddressScss2['default'].error },
	            ' ',
	            data.zipCity.error,
	            ' '
	          )
	        );
	      } else {
	        cityZip = _react2['default'].createElement(
	          'div',
	          { className: _clientAddressScss2['default'].multiFields2 },
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              _('zip'),
	              addType == 'mainaddress' ? " *" : ""
	            ),
	            _react2['default'].createElement('input', _extends({ type: 'text' }, data.postalCode, { onBlur: function () {
	                _this.onBlurSetCountry(data.postalCode);
	              } })),
	            data != undefined && data.postalCode.error && data.postalCode.touched && _react2['default'].createElement(
	              'div',
	              { className: _clientAddressScss2['default'].error },
	              ' ',
	              data.postalCode.error,
	              ' '
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              _('city'),
	              addType == 'mainaddress' ? " *" : ""
	            ),
	            _react2['default'].createElement('input', _extends({ type: 'text' }, data.locality, { onBlur: function () {
	                _this.onBlurSetCountry(data.locality);
	              } })),
	            data != undefined && data.locality.error && data.locality.touched && _react2['default'].createElement(
	              'div',
	              { className: _clientAddressScss2['default'].error },
	              ' ',
	              data.locality.error,
	              ' '
	            )
	          )
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: _clientAddressScss2['default'].moduleSection },
	        _react2['default'].createElement(
	          'div',
	          { className: _clientAddressScss2['default'].clientsTableContainer },
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'h3',
	              null,
	              title,
	              ' ',
	              addType === 'corressadd' && _react2['default'].createElement(
	                'button',
	                { type: 'button', className: _clientAddressScss2['default'].removeFieldsButton, onClick: function (event) {
	                    event.preventDefault();
	                    _this.resetDataClick(event);
	                  } },
	                _react2['default'].createElement('img', { src: this.getIcon() })
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              _('country'),
	              addType == 'mainaddress' ? " *" : ""
	            ),
	            _react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, _extends({}, data.country, { options: countryOptions, isSearchable: true, isClearable: true, onBlur: function () {
	                _this.onBlurSetCountry(data.country);
	              } })),
	            data != undefined && data.country.error && data.country.touched && _react2['default'].createElement(
	              'div',
	              { className: _clientAddressScss2['default'].error },
	              ' ',
	              data.country.error,
	              ' '
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: _clientAddressScss2['default'].multiFields },
	            _react2['default'].createElement(
	              'div',
	              { className: _clientAddressScss2['default'].streetDiv },
	              _react2['default'].createElement(
	                'label',
	                null,
	                _('street'),
	                addType == 'mainaddress' ? " *" : ""
	              ),
	              _react2['default'].createElement('input', _extends({ type: 'text' }, data.street, { onBlur: function () {
	                  _this.onBlurSetCountry(data.street);
	                } })),
	              data != undefined && data.street.error && data.street.touched && _react2['default'].createElement(
	                'div',
	                { className: _clientAddressScss2['default'].error },
	                ' ',
	                data.street.error,
	                ' '
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: _clientAddressScss2['default'].smallDivsInput },
	              _react2['default'].createElement(
	                'label',
	                null,
	                _('number'),
	                addType == 'mainaddress' ? " *" : ""
	              ),
	              _react2['default'].createElement('input', _extends({ type: 'text' }, data.number, { onBlur: function () {
	                  _this.onBlurSetCountry(data.number);
	                } })),
	              data != undefined && data.number.error && data.number.touched && _react2['default'].createElement(
	                'div',
	                { className: _clientAddressScss2['default'].error },
	                ' ',
	                data.number.error,
	                ' '
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: _clientAddressScss2['default'].smallDivsInput },
	              _react2['default'].createElement(
	                'label',
	                null,
	                _('bus')
	              ),
	              _react2['default'].createElement('input', _extends({ type: 'text' }, data.extension, { onBlur: function () {
	                  _this.onBlurSetCountry(data.bus);
	                } })),
	              data != undefined && data.extension.error && data.extension.touched && _react2['default'].createElement(
	                'div',
	                { className: _clientAddressScss2['default'].error },
	                ' ',
	                data.extension.error,
	                ' '
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            cityZip
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClientAddressList;
	})(_react2['default'].Component);
	
	exports['default'] = ClientAddressList;
	module.exports = exports['default'];

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _clientClaimsScss = __webpack_require__(1595);
	
	var _clientClaimsScss2 = _interopRequireDefault(_clientClaimsScss);
	
	var _clientClaimsZoom = __webpack_require__(1081);
	
	var _clientClaimsZoom2 = _interopRequireDefault(_clientClaimsZoom);
	
	var _stateActions = __webpack_require__(5);
	
	var _libHelpers = __webpack_require__(24);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clientClaims');
	
	var formatQualification = function formatQualification(main) {
	  return _react2['default'].createElement(
	    'span',
	    null,
	    _react2['default'].createElement(
	      'span',
	      null,
	      main.qualification
	    ),
	    main.subQualification && _react2['default'].createElement(
	      'span',
	      null,
	      ',',
	      _react2['default'].createElement('br', null),
	      main.subQualification
	    )
	  );
	};
	
	var Results = function Results(_ref) {
	  var claims = _ref.claims;
	  var zoomTo = _ref.zoomTo;
	
	  var moment = __webpack_require__(12);
	  var formattedData = claims.map(function (_ref2) {
	    var claimMain = _ref2.claimMain;
	    var claimDetails = _ref2.claimDetails;
	    return _extends({}, claimMain, {
	      claimDate: moment(claimMain.claimDate).format('DD-MM-YYYY'),
	      creationDate: moment(claimMain.creationDate).format('DD-MM-YYYY'),
	      insuranceCompany: claimDetails.insuranceCompany || ''
	    });
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: _clientClaimsScss2['default'].clientsTableContainer },
	    _react2['default'].createElement(
	      _componentsReactable.Table,
	      {
	        className: _clientClaimsScss2['default'].table,
	        itemsPerPage: 10,
	        filterable: ['claimDate', 'creationDate', 'claimNumber', 'contractNumber', 'insuranceCompany', 'claimsManager', 'qualification', 'state'],
	        sortable: [{ column: 'claimDate', sortFunction: 'Date' }, { column: 'creationDate', sortFunction: 'Date' }, 'claimNumber', 'contractNumber', 'insuranceCompany', 'claimsManager', 'qualification', 'state'],
	        defaultSort: {
	          column: 'creationDate',
	          direction: 'desc'
	        }
	      },
	      _react2['default'].createElement(
	        _componentsReactable.Thead,
	        null,
	        _react2['default'].createElement(
	          _componentsReactable.Th,
	          { column: 'claimDate' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            _('claimDate')
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsReactable.Th,
	          { column: 'creationDate' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            _('creationDate')
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsReactable.Th,
	          { column: 'claimNumber' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            _('claimNumber')
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsReactable.Th,
	          { column: 'contractNumber' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            _('contractNumber')
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsReactable.Th,
	          { column: 'insuranceCompany' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            _('insuranceCompany')
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsReactable.Th,
	          { column: 'claimsManager' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            _('claimsManager')
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsReactable.Th,
	          { column: 'qualification' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            _('qualification')
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsReactable.Th,
	          { column: 'state' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            _('status')
	          )
	        )
	      ),
	      formattedData.map(function (item, key) {
	        return _react2['default'].createElement(
	          _componentsReactable.Tr,
	          { className: 'centered clickable', onClick: function () {
	              return zoomTo(item.claimId);
	            }, key: key },
	          _react2['default'].createElement(_componentsReactable.Td, { column: 'claimDate', data: (0, _libHelpers.dateFormatter)(item.claimDate) }),
	          _react2['default'].createElement(_componentsReactable.Td, { column: 'creationDate', data: (0, _libHelpers.dateFormatter)(item.creationDate) }),
	          _react2['default'].createElement(
	            _componentsReactable.Td,
	            { column: 'claimNumber' },
	            item.claimNumber
	          ),
	          _react2['default'].createElement(
	            _componentsReactable.Td,
	            { column: 'contractNumber' },
	            item.contractNumber
	          ),
	          _react2['default'].createElement(
	            _componentsReactable.Td,
	            { column: 'insuranceCompany' },
	            item.insuranceCompany
	          ),
	          _react2['default'].createElement(
	            _componentsReactable.Td,
	            { column: 'claimsManager' },
	            item.claimsManager
	          ),
	          _react2['default'].createElement(_componentsReactable.Td, { column: 'qualification', data: formatQualification(item), value: item.qualification + ' ' + item.subQualification }),
	          _react2['default'].createElement(
	            _componentsReactable.Td,
	            { column: 'state' },
	            item.state
	          )
	        );
	      })
	    )
	  );
	};
	
	var ClientClaims = (function (_Component) {
	  _inherits(ClientClaims, _Component);
	
	  _createClass(ClientClaims, null, [{
	    key: 'propTypes',
	    value: {
	      claims: _propTypes2['default'].array,
	      clientId: _propTypes2['default'].string.isRequired,
	      claimId: _propTypes2['default'].string,
	      clientData: _propTypes2['default'].object
	    },
	    enumerable: true
	  }]);
	
	  function ClientClaims(props) {
	    var _this = this;
	
	    _classCallCheck(this, _ClientClaims);
	
	    _get(Object.getPrototypeOf(_ClientClaims.prototype), 'constructor', this).call(this, props);
	
	    this.zoomTo = function callee$2$0(subMenu) {
	      var dispatch;
	      return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	        while (1) switch (context$3$0.prev = context$3$0.next) {
	          case 0:
	            dispatch = this.props.dispatch;
	            context$3$0.next = 3;
	            return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimDetail)(subMenu)));
	
	          case 3:
	            this.setState({ claimSearchResult: {} }, function () {
	              dispatch((0, _stateActions.setOpenedSubmenu)(subMenu));
	            });
	
	          case 4:
	          case 'end':
	            return context$3$0.stop();
	        }
	      }, null, _this);
	    };
	
	    this.updateClaimSearchResult = function callee$2$0() {
	      var claimSearchResult;
	      return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	        while (1) switch (context$3$0.prev = context$3$0.next) {
	          case 0:
	            context$3$0.next = 2;
	            return regeneratorRuntime.awrap(this.getTheSelectedClaimFromSearchResult());
	
	          case 2:
	            claimSearchResult = context$3$0.sent;
	
	            this.setState({ claimSearchResult: claimSearchResult });
	
	          case 4:
	          case 'end':
	            return context$3$0.stop();
	        }
	      }, null, _this);
	    };
	
	    this.getTheSelectedClaimFromSearchResult = function callee$2$0() {
	      var _props, claimId, claimsExtraDetails, subModuleZoom, dispatch, result;
	
	      return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	        while (1) switch (context$3$0.prev = context$3$0.next) {
	          case 0:
	            _props = this.props;
	            claimId = _props.claimId;
	            claimsExtraDetails = _props.claimsExtraDetails;
	            subModuleZoom = _props.subModuleZoom;
	            dispatch = _props.dispatch;
	
	            if (!(!Array.isArray(claimsExtraDetails) || claimsExtraDetails.length === 0)) {
	              context$3$0.next = 7;
	              break;
	            }
	
	            return context$3$0.abrupt('return', {});
	
	          case 7:
	            result = [];
	
	            if (claimId) {
	              result = claimsExtraDetails.filter(function (currentClaim) {
	                return String(currentClaim.main.claimId) === String(claimId);
	              });
	            }
	
	            if (result.length === 0 && subModuleZoom) {
	              result = claimsExtraDetails.filter(function (currentClaim) {
	                return Object.keys(subModuleZoom).some(function (key) {
	                  return key === 'claimNumber' && String(currentClaim.main.claimNumber) === String(subModuleZoom[key]) || key === 'claimRefBroker' && String(currentClaim.main.claimRefBroker) === String(subModuleZoom[key]);
	                });
	              });
	            }
	
	            if (!(result.length > 0)) {
	              context$3$0.next = 17;
	              break;
	            }
	
	            context$3$0.next = 13;
	            return regeneratorRuntime.awrap(dispatch((0, _stateActions.getClaimDetail)(result[0].main.claimId)));
	
	          case 13:
	            this.zoomTo(result[0].main.claimId);
	            return context$3$0.abrupt('return', result[0]);
	
	          case 17:
	            return context$3$0.abrupt('return', {});
	
	          case 18:
	          case 'end':
	            return context$3$0.stop();
	        }
	      }, null, _this);
	    };
	
	    this.state = {
	      initializationCompleted: false,
	      claimSearchResult: {}
	    };
	  }
	
	  _createClass(ClientClaims, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2, clientData, dispatch, claimId, clientId, claims, subModuleZoom, clientNumber, fetches;
	
	      return regeneratorRuntime.async(function componentDidMount$(context$2$0) {
	        while (1) switch (context$2$0.prev = context$2$0.next) {
	          case 0:
	            _props2 = this.props;
	            clientData = _props2.clientData;
	            dispatch = _props2.dispatch;
	            claimId = _props2.claimId;
	            clientId = _props2.clientId;
	            claims = _props2.claims;
	            subModuleZoom = _props2.subModuleZoom;
	            clientNumber = _nestedProperty2['default'].get(clientData, 'main.clientNumber');
	            context$2$0.prev = 8;
	            fetches = [];
	
	            if (!claims || claims.length === 0) {
	              fetches.push(dispatch((0, _stateActions.fetchClientClaims)(clientId)));
	              if (clientNumber) {
	                fetches.push(dispatch((0, _stateActions.fetchClaimsExtraDetails)({ clientNumber: clientNumber })));
	              }
	            }
	
	            if (claimId) {
	              fetches.push(dispatch((0, _stateActions.getClaimDetail)(claimId)));
	            }
	
	            context$2$0.next = 14;
	            return regeneratorRuntime.awrap(Promise.all(fetches));
	
	          case 14:
	            context$2$0.next = 19;
	            break;
	
	          case 16:
	            context$2$0.prev = 16;
	            context$2$0.t0 = context$2$0['catch'](8);
	
	            console.warn('Error fetching claims:', context$2$0.t0);
	
	          case 19:
	            context$2$0.prev = 19;
	
	            this.setState({ initializationCompleted: true });
	            return context$2$0.finish(19);
	
	          case 22:
	          case 'end':
	            return context$2$0.stop();
	        }
	      }, null, this, [[8, 16, 19, 22]]);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props3, clientId, claimId, claimsExtraDetails, subModuleZoom, dispatch;
	
	      return regeneratorRuntime.async(function componentDidUpdate$(context$2$0) {
	        while (1) switch (context$2$0.prev = context$2$0.next) {
	          case 0:
	            _props3 = this.props;
	            clientId = _props3.clientId;
	            claimId = _props3.claimId;
	            claimsExtraDetails = _props3.claimsExtraDetails;
	            subModuleZoom = _props3.subModuleZoom;
	            dispatch = _props3.dispatch;
	
	            if (!(clientId !== prevProps.clientId || !claimId && prevProps.claimId)) {
	              context$2$0.next = 9;
	              break;
	            }
	
	            context$2$0.next = 9;
	            return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchClientClaims)(clientId)));
	
	          case 9:
	
	            if (claimsExtraDetails !== prevProps.claimsExtraDetails && subModuleZoom && Object.keys(subModuleZoom).length > 0) {
	              this.updateClaimSearchResult();
	            }
	
	          case 10:
	          case 'end':
	            return context$2$0.stop();
	        }
	      }, null, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props;
	      var claims = _props4.claims;
	      var claimId = _props4.claimId;
	      var clientData = _props4.clientData;
	      var clientId = _props4.clientId;
	      var subModuleZoom = _props4.subModuleZoom;
	      var _state = this.state;
	      var initializationCompleted = _state.initializationCompleted;
	      var claimSearchResult = _state.claimSearchResult;
	
	      if (!initializationCompleted) {
	        return _react2['default'].createElement('span', null);
	      }
	
	      var claim = claimId && claims && claims.find(function (i) {
	        return i.claimMain.claimId === claimId;
	      });
	
	      if (!claim && subModuleZoom) {
	        (function () {
	          var key = Object.keys(subModuleZoom)[0];
	          if (key) {
	            (function () {
	              var value = subModuleZoom[key];
	              claim = claims && claims.find(function (c) {
	                return c.claimMain[key] === value;
	              });
	            })();
	          }
	        })();
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: _clientClaimsScss2['default'].claimsClient },
	        _react2['default'].createElement(
	          'div',
	          { className: _clientClaimsScss2['default'].moduleSection },
	          claims && !claimId && Object.keys(claimSearchResult).length === 0 && _react2['default'].createElement(Results, { claims: claims, zoomTo: this.zoomTo }),
	          (claimId || Object.keys(claimSearchResult).length > 0) && _react2['default'].createElement(
	            'div',
	            { className: _clientClaimsScss2['default'].clientClaimZoomContainer },
	            _react2['default'].createElement(_clientClaimsZoom2['default'], {
	              claim: claim || {
	                claimDetails: claimSearchResult.details,
	                claimDocuments: claimSearchResult.documents,
	                claimMain: claimSearchResult.main,
	                connex: claimSearchResult.connex
	              },
	              clientData: clientData,
	              clientId: clientId,
	              claimMoreDetails: claimSearchResult,
	              initializationCompleted: initializationCompleted,
	              zoomTo: function (id) {
	                return _this2.zoomTo(id);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ClientClaims = ClientClaims;
	  ClientClaims = (0, _reactRedux.connect)(function (_ref3, props) {
	    var app = _ref3.app;
	    var clients = _ref3.clients;
	    var claimsExtraDetails = _ref3.claimsExtraDetails;
	
	    var clientId = app.opened;
	    var claimId = app.submenuOpened;
	    var claims = clients.claims[clientId];
	    var clientData = props.clientData && props.clientData || {};
	    return {
	      clientId: clientId,
	      claims: claims,
	      claimId: claimId,
	      clientData: clientData,
	      claimsExtraDetails: clients.claimsExtraDetails,
	      subModuleZoom: clients.subModuleZoom
	    };
	  })(ClientClaims) || ClientClaims;
	  return ClientClaims;
	})(_react.Component);
	
	exports['default'] = ClientClaims;
	module.exports = exports['default'];

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	// TODO merge this with ClaimsZoom
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _stateActions = __webpack_require__(5);
	
	var _clientClaimsZoomScss = __webpack_require__(1596);
	
	var _clientClaimsZoomScss2 = _interopRequireDefault(_clientClaimsZoomScss);
	
	var _uploader = __webpack_require__(143);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _libHelpers = __webpack_require__(24);
	
	var _emailSenderEmailButton = __webpack_require__(108);
	
	var _emailSenderEmailButton2 = _interopRequireDefault(_emailSenderEmailButton);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _ClaimsWizardClaimWizardButton = __webpack_require__(263);
	
	var _ClaimsWizardClaimWizardButton2 = _interopRequireDefault(_ClaimsWizardClaimWizardButton);
	
	var _ = (0, _libI18n2['default'])('claimsZoom');
	
	var ClientClaimsZoom = (function (_React$Component) {
	    _inherits(ClientClaimsZoom, _React$Component);
	
	    _createClass(ClientClaimsZoom, [{
	        key: 'fetchData',
	
	        /**
	         * Fetching clientContracts and clientClaims data from server and set it for usage.
	         */
	        value: function fetchData() {
	            var dispatch = this.props.dispatch;
	
	            // using the current claim broker number
	            if ( /* !brNr && */contractBrokerNumber) {
	                dispatch((0, _stateActions.setBrNr)(contractBrokerNumber));
	            }
	        }
	
	        /**
	         * Constructor: initialize state etc.
	         * @param {*} props
	         */
	    }], [{
	        key: 'propTypes',
	        value: {
	            clientData: _react2['default'].PropTypes.object,
	            clientId: _react2['default'].PropTypes.string,
	            claim: _react2['default'].PropTypes.object.isRequired,
	            claimMoreDetails: _react2['default'].PropTypes.object,
	            initializationCompleted: _react2['default'].PropTypes.bool,
	            clientOptionsDict: _react2['default'].PropTypes.object,
	            zoomTo: _react2['default'].PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function ClientClaimsZoom(props) {
	        var _this = this;
	
	        _classCallCheck(this, _ClientClaimsZoom);
	
	        _get(Object.getPrototypeOf(_ClientClaimsZoom.prototype), 'constructor', this).call(this, props);
	
	        this.handleClose = function () {
	            var dispatch = _this.props.dispatch;
	
	            dispatch((0, _stateActions.setOpenedSubmenu)(''));
	        };
	
	        var clientOptionsDict = props.clientOptionsDict;
	        var appLanguage = props.appLanguage;
	
	        this.state = { clientOptionsDict: clientOptionsDict, claimDetailLoaded: false, extendedClientOptionsDict: (0, _libHelpers.generateClientDicts)(clientOptionsDict, appLanguage) };
	    }
	
	    /**
	     * This function will trigger when component did mounted
	     */
	
	    _createClass(ClientClaimsZoom, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var clientOptionsDict = _props.clientOptionsDict;
	            var claim = _props.claim;
	            var contracts = _props.contracts;
	
	            if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
	                dispatch((0, _stateActions.fetchClientOptionsDict)()).then(function (dictionary) {
	                    _this2.setClientOptionsDict(dictionary);
	                });
	            } else {
	                if (!this.state.clientOptionsDict) {
	                    this.setClientOptionsDict(clientOptionsDict);
	                }
	            }
	            var claimContractNumber = claim.claimMain.contractNumber;
	
	            var contractId = (0, _libHelpers.findContractIdByContractNumber)(contracts, claimContractNumber);
	            if (contractId) {
	                this.setState({ contractId: contractId });
	                // get client contract, and the reducer insert the contractManagerMail in to the store
	                dispatch((0, _stateActions.fetchClientContract)(contractId));
	            }
	        }
	
	        /**
	         * Set client options dict in to the state
	         * @param {object} dictionary - contains the dictionary
	         */
	    }, {
	        key: 'setClientOptionsDict',
	        value: function setClientOptionsDict(dictionary) {
	            var _this3 = this;
	
	            this.setState({ clientOptionsDict: dictionary }, function () {
	                _this3.forceUpdate();
	            });
	        }
	
	        /**
	         * Event for close claim. Back to list.
	         */
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.handleClose();
	        }
	
	        /**
	         * The update function of module, fired when props or state updated
	         * @param {*} nextProp
	         * @param {*} nextState
	         */
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProp, nextState) {
	            var dispatch = this.props.dispatch;
	
	            var claimContractNumber = _nestedProperty2['default'].get(nextProp, "claim.claimMain.contractNumber");
	            var contracts = _nestedProperty2['default'].get(nextProp, "contracts");
	            var contractId = (0, _libHelpers.findContractIdByContractNumber)(contracts, claimContractNumber);
	
	            // when we have the step when related api calls are finished and got the results
	            if (!nextProp.contractManagerMail && nextProp.contracts && nextProp.claim) {
	                if (contractId) {
	                    // get client contract, and the reducer insert the contractManagerMail in to the store
	                    dispatch((0, _stateActions.fetchClientContract)(contractId));
	                }
	            }
	        }
	
	        /**
	         * This function return with values for email sender, collected from this module
	         * depending on the current data structure.
	         */
	    }, {
	        key: 'collectVariableValues',
	        value: function collectVariableValues() {
	            var _props2 = this.props;
	            var clientData = _props2.clientData;
	            var clientId = _props2.clientId;
	            var claimMoreDetails = _props2.claimMoreDetails;
	            var claimDetail = _props2.claimDetail;
	            var claim = _props2.claim;
	            var contracts = _props2.contracts;
	            var clientOptionsDict = this.state.clientOptionsDict;
	
	            // digging out the contract related documents
	            var claimContractNumber = _nestedProperty2['default'].get(claim, "claimMain.contractNumber");
	            var contractId = (0, _libHelpers.findContractIdByContractNumber)(contracts, claimContractNumber);
	            var contract = _nestedProperty2['default'].get(contracts, contractId);
	            var contractDocuments = _nestedProperty2['default'].get(contract, "documents");
	            var contractDocumentsId = contractId;
	
	            var contractBrokerNumber = _nestedProperty2['default'].get(claim, "claimMain.brokerNumber") || _nestedProperty2['default'].get(claimMoreDetails, "main.brokerNumber");
	            var emails = _nestedProperty2['default'].get(clientData, "detail.emails");
	            var clientName = _nestedProperty2['default'].get(clientData, "main.name");
	
	            // process email list to be digestible for email sender
	            emails = emails.map(function (item) {
	                return {
	                    referenceId: clientId,
	                    label: clientName,
	                    value: item.email,
	                    'default': item['default'] == "true" || item['default'] == true ? true : false
	                };
	            });
	
	            emails = emails.sort(function (item, item2) {
	                if (item['default'] && !item2['default']) {
	                    return -1;
	                }
	                if (!item['default'] && item2['default']) {
	                    return 1;
	                }
	                if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                    return 0;
	                }
	            }) || [];
	
	            // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
	            var clientLanguage = _nestedProperty2['default'].get(clientData, "detail.language") || '';
	            clientLanguage = (0, _libHelpers.getTheLanguageCodeByAnyLanguageOnAnyLanguage)(clientLanguage, clientOptionsDict);
	
	            return {
	                contractNumber: _nestedProperty2['default'].get(this.props, "claim.claimMain.contractNumber"),
	                claimsNumber: _nestedProperty2['default'].get(this.props, "claim.claimMain.claimNumber"),
	
	                clientDocuments: _nestedProperty2['default'].get(clientData, "clientDocuments"),
	                clientDocumentsType: 'client',
	                clientDocumentsId: clientId,
	
	                // new v6 mode
	                claimDocuments: _nestedProperty2['default'].get(this.props, "claim.claimDocuments"),
	                claimDocumentsType: "claim",
	                claimDocumentsId: _nestedProperty2['default'].get(this.props, "claim.claimMain.claimId"),
	
	                contractDocuments: contractDocuments,
	                contractDocumentsType: "contract",
	                contractDocumentsId: contractDocumentsId,
	                companyCancelMail: contract.companyCancelMail,
	
	                clientId: false,
	                contractId: false,
	                claimId: _nestedProperty2['default'].get(this.props, "claim.claimMain.claimId"),
	                company: _nestedProperty2['default'].get(this.props, "claim.claimDetails.insuranceCompany"),
	                clientName: clientName,
	                clientNumber: _nestedProperty2['default'].get(clientData, "main.clientNumber"),
	                clientLanguage: clientLanguage,
	                clientEmails: emails,
	
	                brokerNumber: contractBrokerNumber,
	
	                claim: _nestedProperty2['default'].get(this.props, "claim"),
	                claimDetail: claimDetail,
	                clientData: _nestedProperty2['default'].get(clientData, "main")
	            };
	        }
	
	        /**
	         * This function render the data for the qualification column in the claims result table.
	         * @param {object} main - thi is the claims record main property, what contains the qualification values
	         */
	    }, {
	        key: 'formatQualification',
	        value: function formatQualification(qualification, subQualification) {
	            return _react2['default'].createElement(
	                'span',
	                null,
	                _react2['default'].createElement(
	                    'span',
	                    null,
	                    qualification
	                ),
	                subQualification && _react2['default'].createElement(
	                    'span',
	                    null,
	                    ',',
	                    _react2['default'].createElement('br', null),
	                    subQualification
	                )
	            );
	        }
	    }, {
	        key: 'zoomTo',
	        value: function zoomTo(claimNumber) {
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _stateActions.navigateToConnexClaim)(_stateConstants2['default'].CLAIMS, claimNumber));
	        }
	
	        /**
	        * Resets ticket data from store in order to prevent multiple additions to dsWizzard
	        */
	    }, {
	        key: 'resetDataFromStoreOnCancel',
	        value: function resetDataFromStoreOnCancel() {
	            var _props3 = this.props;
	            var dispatch = _props3.dispatch;
	            var ticketId = _props3.ticketId;
	            var claimId = _props3.claimId;
	
	            //reset aditional data fro tickets
	            if (ticketId) {
	                dispatch((0, _stateActions.setOpenedSubmenu)(claimId, {}));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props4 = this.props;
	            var claim = _props4.claim;
	            var clientAccess = _props4.clientAccess;
	            var initializationCompleted = _props4.initializationCompleted;
	            var clientId = _props4.clientId;
	            var ticketId = _props4.ticketId;
	            var ticketDocuments = _props4.ticketDocuments;
	            var selectedTicketDocuments = _props4.selectedTicketDocuments;
	            var emailAttachmentTicketDocuments = _props4.emailAttachmentTicketDocuments;
	            var dispatch = _props4.dispatch;
	
	            var createMail = clientAccess && clientAccess.filter(function (item) {
	                return item.actionName == "createmail" && item.actionAllowed == "true";
	            }).length > 0;
	
	            var canCreateMifid = clientAccess && clientAccess.filter(function (item) {
	                return item.actionName == "createmifid" && item.actionAllowed == "true";
	            }).length > 0;
	
	            var _state = this.state;
	            var clientOptionsDict = _state.clientOptionsDict;
	            var contractId = _state.contractId;
	            var extendedClientOptionsDict = _state.extendedClientOptionsDict;
	
	            if (!claim || !clientOptionsDict) {
	                return _react2['default'].createElement(
	                    'span',
	                    null,
	                    '...'
	                );
	            }
	
	            var _claim$claimMain = claim.claimMain;
	            var claimId = _claim$claimMain.claimId;
	            var claimDate = _claim$claimMain.claimDate;
	            var claimNumber = _claim$claimMain.claimNumber;
	            var state = _claim$claimMain.state;
	            var contractNumber = _claim$claimMain.contractNumber;
	            var claimsManagerName = _claim$claimMain.claimsManagerName;
	            var creationDate = _claim$claimMain.creationDate;
	            var qualification = _claim$claimMain.qualification;
	            var subQualification = _claim$claimMain.subQualification;
	            var brokerNumber = _claim$claimMain.brokerNumber;
	            var _claim$claimDetails = claim.claimDetails;
	            var insuranceCompany = _claim$claimDetails.insuranceCompany;
	            var riskDescription = _claim$claimDetails.riskDescription;
	            var branche = _claim$claimDetails.branche;
	            var claimDocuments = claim.claimDocuments;
	            var claimDetailsFromProps = this.props.claimDetail;
	            var claimRefBroker = claimDetailsFromProps.claimRefBroker;
	
	            var columns = [[{ label: _('insuranceCompany'), value: insuranceCompany || '' }, { label: _('claimDate'), value: (0, _libHelpers.formatDate)(claimDate) || '' }, { label: _('state'), value: state || '' }, { label: _('contractNumber'), value: contractNumber || '' }, { label: _('riskDescription'), value: riskDescription || '' }, { label: _('claimRefBroker'), value: claimRefBroker || '' }], [{ label: _('claimsManager'), value: claimsManagerName || '' }, { label: _('creationDate'), value: (0, _libHelpers.formatDate)(creationDate) || '' }, { label: _('qualification'), value: this.formatQualification(qualification, subQualification) || '' }, { label: _('branche'), value: branche || '' }]];
	            var moduleKeyToSet = _nestedProperty2['default'].get(this.props, "EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value") || false;
	
	            var involvedPartiesLabels = claimDetailsFromProps.missingInfo.involvedParties.map(function (value) {
	                var involvedTexts = extendedClientOptionsDict.involvedParties.find(function (option) {
	                    return option.value === value;
	                });
	                return involvedTexts ? involvedTexts.label : '';
	            });
	
	            var missingDocumentsLabels = [];
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                var _loop = function () {
	                    var oneDoc = _step.value;
	
	                    if (claimDetailsFromProps.Documents && claimDetailsFromProps.Documents.length > 0) {
	                        var missingDocType = claimDetailsFromProps.Documents.find(function (doc) {
	                            return doc.docType === oneDoc.docType;
	                        });
	                        if (missingDocType) {
	                            if (missingDocType.alternativeDocTypes && missingDocType.alternativeDocTypes.length > 0) {
	                                (function () {
	                                    var selectedAlternative = missingDocType.alternativeDocTypes.find(function (altDoc) {
	                                        return +altDoc.altDocCount > 0;
	                                    });
	                                    if (selectedAlternative) {
	                                        missingDocType.alternativeDocTypes.filter(function (altDoc) {
	                                            return +altDoc.altDocCount === 0 && altDoc.alternativeNr === selectedAlternative.alternativeNr;
	                                        }).forEach(function (altDoc) {
	                                            var newLabel = extendedClientOptionsDict.documentTypeOptions.find(function (option) {
	                                                return option.value === altDoc.altDocType;
	                                            });
	                                            if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
	                                                missingDocumentsLabels.push(newLabel);
	                                            }
	                                        });
	                                    } else {
	                                        var newLabel = extendedClientOptionsDict.documentTypeOptions.find(function (option) {
	                                            return option.value === oneDoc.docType;
	                                        });
	                                        if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
	                                            missingDocumentsLabels.push(newLabel);
	                                        }
	                                    }
	                                })();
	                            } else if (missingDocType.docCount && +missingDocType.docCount <= 0) {
	                                var newLabel = extendedClientOptionsDict.documentTypeOptions.find(function (option) {
	                                    return option.value === oneDoc.docType;
	                                });
	                                if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
	                                    missingDocumentsLabels.push(newLabel);
	                                }
	                            }
	                        }
	                    }
	                };
	
	                for (var _iterator = claimDetailsFromProps.missingInfo.documents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    _loop();
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator['return']) {
	                        _iterator['return']();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var claimStatusAndQualification = {};
	            if (claimDetailsFromProps) {
	                claimStatusAndQualification.claimStatus = claimDetailsFromProps.claimStatus;
	                claimStatusAndQualification.qualificationNumber = claimDetailsFromProps.qualificationNumber;
	                claimStatusAndQualification.subQualificationNumber = claimDetailsFromProps.subQualificationNumber;
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _clientClaimsZoomScss2['default'].clientClaimsZoomContainer },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientClaimsZoomScss2['default'].mainTitleDiv },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientClaimsZoomScss2['default'].moduleControls },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientClaimsZoomScss2['default'].buttonOrganizer },
	                            _react2['default'].createElement(
	                                'div',
	                                { onClick: this.handleClose, className: '' + _clientClaimsZoomScss2['default'].backToList },
	                                _('backToList')
	                            ),
	                            createMail && initializationCompleted && _react2['default'].createElement(_emailSenderEmailButton2['default'], { moduleKeyToSet: moduleKeyToSet, moduleOptions: this.collectVariableValues() }),
	                            canCreateMifid && _react2['default'].createElement(
	                                'div',
	                                { className: _clientClaimsZoomScss2['default'].DSWizardButtonWrapper },
	                                _react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
	                                    moduleKeyToSet: _stateConstants2['default'].DS_MODULE_CLIENT_CLAIMS,
	                                    subModuleKeyToSet: _stateConstants2['default'].DS_MODULE_CLIENT_CLAIMS,
	                                    clientId: clientId,
	                                    claimId: claimId,
	                                    claimNumber: claimNumber,
	                                    callBackOnClose: function () {
	                                        return _this4.resetDataFromStoreOnCancel();
	                                    },
	                                    moduleOptions: this.collectVariableValues(),
	                                    ticketId: ticketId,
	                                    ticketDocuments: ticketDocuments,
	                                    selectedTicketDocuments: selectedTicketDocuments,
	                                    emailAttachmentTicketDocuments: emailAttachmentTicketDocuments
	                                })
	                            ),
	                            claimDetailsFromProps.claimStatus === '8' && _react2['default'].createElement(
	                                'div',
	                                null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientClaimsZoomScss2['default'].wizardButtonCorrection },
	                                    _react2['default'].createElement(_ClaimsWizardClaimWizardButton2['default'], {
	                                        contractId: contractId,
	                                        claimNumber: claimNumber,
	                                        claimData: claimDetailsFromProps,
	                                        clientId: claimDetailsFromProps.client.clientId,
	                                        brokerNumber: brokerNumber,
	                                        onCloseMethod: function () {
	                                            return _this4.props.dispatch((0, _stateActions.getClaimDetail)(claimId));
	                                        },
	                                        onGoing: true
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientClaimsZoomScss2['default'].clientClaimsZoom },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientClaimsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientClaimsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _clientClaimsZoomScss2['default'].subTitle },
	                                _('claimNumber'),
	                                ' ',
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    claimNumber
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(_KeyValue2['default'], { array: columns, divider: true })
	                    ),
	                    (involvedPartiesLabels.length > 0 || missingDocumentsLabels.length > 0) && _react2['default'].createElement(
	                        'div',
	                        { className: _clientClaimsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientClaimsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _clientClaimsZoomScss2['default'].subTitle },
	                                _('missingInfo')
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientClaimsZoomScss2['default'].missingInfo },
	                            involvedPartiesLabels.length > 0 && _react2['default'].createElement(
	                                'div',
	                                { className: _clientClaimsZoomScss2['default'].missingInfoColumn },
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: _clientClaimsZoomScss2['default'].missingInfoTitle },
	                                    _('missingInvolvedParties'),
	                                    ':'
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientClaimsZoomScss2['default'].missingInfoEnum },
	                                    involvedPartiesLabels.map(function (label, index) {
	                                        return _react2['default'].createElement(
	                                            'span',
	                                            { key: index, className: _clientClaimsZoomScss2['default'].missingInfoRow },
	                                            label
	                                        );
	                                    })
	                                )
	                            ),
	                            missingDocumentsLabels.length > 0 && _react2['default'].createElement(
	                                'div',
	                                { className: _clientClaimsZoomScss2['default'].missingInfoColumn },
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: _clientClaimsZoomScss2['default'].missingInfoTitle },
	                                    _('missingDocuments'),
	                                    ':'
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientClaimsZoomScss2['default'].missingInfoEnum },
	                                    missingDocumentsLabels.map(function (label, index) {
	                                        return _react2['default'].createElement(
	                                            'span',
	                                            { key: index, className: _clientClaimsZoomScss2['default'].missingInfoRow },
	                                            label.label
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientClaimsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientClaimsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _clientClaimsZoomScss2['default'].subTitle },
	                                _('connex')
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Table,
	                            {
	                                className: _clientClaimsZoomScss2['default'].table,
	                                itemsPerPage: 20
	                            },
	                            _react2['default'].createElement(
	                                _componentsReactable.Thead,
	                                null,
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'claimNumber' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('claimNumber')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'nameClient' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('nameClient')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'contractNumber' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('contractNumber')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'companyName' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('companyName')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'qualification' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('qualification')
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'state' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _('state')
	                                    )
	                                )
	                            ),
	                            claim.connex.map(function (item, key) {
	                                return _react2['default'].createElement(
	                                    _componentsReactable.Tr,
	                                    {
	                                        className: 'clickable centered',
	                                        onClick: function () {
	                                            return _this4.zoomTo(item.claimNumber);
	                                        }, key: key
	                                    },
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'claimNumber' },
	                                        item.claimNumber
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'nameClient' },
	                                        item.clientName
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'contractNumber' },
	                                        item.contractNumber
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'companyName' },
	                                        item.companyName
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'qualification' },
	                                        item.qualification
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'state' },
	                                        item.state
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    _react2['default'].createElement(_uploader2['default'], {
	                        type: 'claim',
	                        documents: claimDocuments,
	                        id: claimId,
	                        claimStatusAndQualification: claimStatusAndQualification
	                    })
	                )
	            );
	        }
	    }]);
	
	    var _ClientClaimsZoom = ClientClaimsZoom;
	    ClientClaimsZoom = (0, _reactRedux.connect)(function (state, props) {
	        return {
	            EmailTemplateRelations: state.app.security.EmailTemplateRelations,
	            clientAccess: state.app.security.actions,
	            brNr: state.app.brNr,
	            clientData: props && props.clientData || {},
	            clientId: props && props.clientId || '',
	            clientOptionsDict: state.client.clientOptionsDict,
	            contractManagerMail: state.contracts.contractManagerMail,
	            appLanguage: state.app.lang,
	            contracts: state.contracts,
	            claimDetail: _nestedProperty2['default'].get(state, "client.claimDetail"),
	            selectedTicketDocuments: _nestedProperty2['default'].get(state, "clients.initialArguments.selectedTicketDocuments"),
	            ticketDocuments: _nestedProperty2['default'].get(state, "clients.initialArguments.ticketDocuments"),
	            ticketId: _nestedProperty2['default'].get(state, "clients.initialArguments.ticketId"),
	            emailAttachmentTicketDocuments: _nestedProperty2['default'].get(state, "clients.initialArguments.emailAttachmentTicketDocuments")
	
	        };
	    })(ClientClaimsZoom) || ClientClaimsZoom;
	    return ClientClaimsZoom;
	})(_react2['default'].Component);
	
	exports['default'] = ClientClaimsZoom;
	module.exports = exports['default'];

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _clientContractsScss = __webpack_require__(1598);
	
	var _clientContractsScss2 = _interopRequireDefault(_clientContractsScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _clientContractsZoom = __webpack_require__(604);
	
	var _clientContractsZoom2 = _interopRequireDefault(_clientContractsZoom);
	
	var _clientContractCreate = __webpack_require__(366);
	
	var _clientContractCreate2 = _interopRequireDefault(_clientContractCreate);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ = (0, _libI18n2['default'])('clientContracts');
	
	var Results = function Results(_ref) {
	    var data = _ref.data;
	    var zoomTo = _ref.zoomTo;
	    var setState = _ref.setState;
	    var createPrev = _ref.createPrev;
	    var createPrem = _ref.createPrem;
	
	    var icons = {
	        0: 'c-credit',
	        1: 'c-life',
	        2: 'c-health',
	        3: 'c-home',
	        4: 'c-family',
	        5: 'c-automotive',
	        6: 'c-workinjuries',
	        7: 'c-fire',
	        8: 'c-transport',
	        9: 'c-misc'
	    };
	
	    var topPaginationElemR = [];
	
	    if (createPrem) {
	        topPaginationElemR.push(_react2['default'].createElement('input', {
	            key: "createPremContractModalOpenerButtonKey",
	            onClick: function () {
	                setState({ createPremContractModalIsOpen: true });
	            },
	            type: 'button',
	            className: _clientContractsScss2['default'].buttonGreen,
	            value: _('mandate')
	        }));
	    }
	
	    if (createPrev) {
	        topPaginationElemR.push(_react2['default'].createElement('input', {
	            key: "createContractModalOpenerButtonKey",
	            onClick: function () {
	                setState({ createContractModalIsOpen: true });
	            },
	            type: 'button',
	            className: _clientContractsScss2['default'].buttonGreen,
	            value: _('request')
	        }));
	    }
	
	    var tableData = data || [];
	
	    return _react2['default'].createElement(
	        'div',
	        { className: _clientContractsScss2['default'].clientsTableContainer },
	        _react2['default'].createElement(
	            _componentsReactable.Table,
	            {
	                className: _clientContractsScss2['default'].table,
	                itemsPerPage: 10,
	                filterable: ["contractNumber", "mainBranche", "mainRisk", "insuranceCompany", "contractState"],
	                sortable: ["contractNumber", "mainBranche", "mainRisk", "insuranceCompany", "contractState"],
	                defaultSort: {
	                    column: 'contractState',
	                    direction: 'asc'
	                },
	                topPaginationElemR: topPaginationElemR
	            },
	            _react2['default'].createElement(
	                _componentsReactable.Thead,
	                null,
	                _react2['default'].createElement(_componentsReactable.Th, { column: 'claimIcon', label: '' }),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'contractNumber' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('contractNumber')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'mainBranche' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('mainBranche')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'mainRisk' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('mainRisk')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'insuranceCompany' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('insuranceCompany')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'contractState' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('contractState')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'ends' },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('ends')
	                    )
	                )
	            ),
	            tableData && tableData.map(function (item, key) {
	                return _react2['default'].createElement(
	                    _componentsReactable.Tr,
	                    {
	                        className: 'centered clickable',
	                        key: key, onClick: function () {
	                            return zoomTo(item.contractId);
	                        }
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'claimIcon' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientContractsScss2['default'].iconContainer },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1017)("./" + icons[item.brancheCode] + '_2x.png') })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'contractNumber' },
	                        item.contractNumber
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'mainBranche' },
	                        item.mainBranche
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'mainRisk' },
	                        item.mainRisk
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'insuranceCompany' },
	                        item.insuranceCompany
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'contractState' },
	                        item.contractState
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'ends' },
	                        (item.contractEnd || '') + ' ' + (item.contractEndDate ? (0, _moment2['default'])(item.contractEndDate).format('DD-MM-YYYY') : '')
	                    )
	                );
	            })
	        ),
	        (!tableData || tableData.length === 0) && _react2['default'].createElement(_noResults2['default'], { type: 'clientContracts' })
	    );
	};
	
	var ClientContracts = (function (_React$Component) {
	    _inherits(ClientContracts, _React$Component);
	
	    _createClass(ClientContracts, null, [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            data: _react2['default'].PropTypes.array,
	            contractId: _react2['default'].PropTypes.string,
	            clientId: _react2['default'].PropTypes.string,
	            createPrev: _react2['default'].PropTypes.bool
	        },
	        enumerable: true
	    }]);
	
	    function ClientContracts(props) {
	        _classCallCheck(this, _ClientContracts);
	
	        _get(Object.getPrototypeOf(_ClientContracts.prototype), 'constructor', this).call(this, props);
	        this.state = { createContractModalIsOpen: false, createPremContractModalIsOpen: false };
	    }
	
	    _createClass(ClientContracts, [{
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var allContracts = _props.allContracts;
	            var contracts = _props.contracts;
	            var contractId = _props.contractId;
	            var dispatch = _props.dispatch;
	            var subModuleZoom = _props.subModuleZoom;
	            var clientData = _props.clientData;
	            var clientId = _props.clientId;
	            var createContractState = _props.createContractState;
	            var _state = this.state;
	            var createContractModalIsOpen = _state.createContractModalIsOpen;
	            var createPremContractModalIsOpen = _state.createPremContractModalIsOpen;
	
	            var contract = contractId && allContracts[contractId];
	            var _props2 = this.props;
	            var createPrev = _props2.createPrev;
	            var createPrem = _props2.createPrem;
	
	            if (!contract && subModuleZoom) {
	                (function () {
	                    // TODO - rewrite this solution for pass the contract number
	                    // this is a horrible solution, not sure the first key is the contract number
	                    var key = Object.keys(subModuleZoom)[0];
	
	                    if (key) {
	                        (function () {
	                            var value = subModuleZoom[key];
	                            contract = contracts.find(function (c) {
	                                return c[key] === value;
	                            });
	                        })();
	                    }
	                })();
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientContractsScss2['default'].moduleSection },
	                    !contract ? _react2['default'].createElement(Results, _extends({}, this.props, {
	                        createPrev: createPrev,
	                        createPrem: createPrem,
	                        data: contracts || [],
	                        zoomTo: function (contractId) {
	                            return dispatch((0, _stateActions.setOpenedSubmenu)(contractId));
	                        },
	                        setState: function (paramForSetState) {
	                            return _this.setState(paramForSetState);
	                        }
	                    })) : _react2['default'].createElement(
	                        'div',
	                        { className: _clientContractsScss2['default'].clientContractZoomContainer },
	                        _react2['default'].createElement(_clientContractsZoom2['default'], {
	                            contract: contract,
	                            clientData: clientData,
	                            contractId: String(contractId)
	                        })
	                    )
	                ),
	                _react2['default'].createElement(_clientContractCreate2['default'], {
	                    modalIsOpen: createContractModalIsOpen,
	                    contract: {
	                        contractId: '',
	                        contractNumber: '',
	                        error: '0', //  0 = No error / 1 = Error creating contract
	                        errorString: 'This is the error string'
	                    },
	                    isPrem: false,
	                    closeModal: function () {
	                        return _this.setState({ createContractModalIsOpen: false });
	                    },
	                    clientId: clientId,
	                    policyHolder: _nestedProperty2['default'].get(clientData, "main.name") || ""
	                }),
	                _react2['default'].createElement(_clientContractCreate2['default'], {
	                    modalIsOpen: createPremContractModalIsOpen,
	                    contract: {
	                        contractId: '',
	                        contractNumber: '',
	                        error: '0', //  0 = No error / 1 = Error creating contract
	                        errorString: 'This is the error string'
	                    },
	                    isPrem: true,
	                    closeModal: function () {
	                        return _this.setState({ createPremContractModalIsOpen: false });
	                    },
	                    clientId: clientId,
	                    policyHolder: _nestedProperty2['default'].get(clientData, "main.name") || ""
	                })
	            );
	        }
	    }]);
	
	    var _ClientContracts = ClientContracts;
	    ClientContracts = (0, _reactRedux.connect)(function (state) {
	        var clientId = state.app.opened;
	        var clientData = state.clients.clientData[clientId];
	        var contracts = clientData.contractIds.map(function (id) {
	            return state.contracts[id];
	        });
	        var actions = _nestedProperty2['default'].get(state, "app.security.actions");
	        var createPrev = actions.filter(function (item) {
	            return item.actionName === "createPrev" && item.actionAllowed === "true";
	        }).length > 0;
	        var createPrem = actions.filter(function (item) {
	            return item.actionName === "createPrem" && item.actionAllowed === "true";
	        }).length > 0;
	
	        return {
	            allContracts: state.contracts,
	            contracts: contracts,
	            contractId: state.app.submenuOpened,
	            subModuleZoom: state.clients.subModuleZoom,
	            createContractState: state.clients.createContractState,
	            clientData: clientData,
	            clientId: clientId,
	            createPrev: createPrev,
	            createPrem: createPrem
	        };
	    })(ClientContracts) || ClientContracts;
	    return ClientContracts;
	})(_react2['default'].Component);
	
	exports['default'] = ClientContracts;
	module.exports = exports['default'];

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(57);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _clientTransactions = __webpack_require__(1091);
	
	var _clientTransactions2 = _interopRequireDefault(_clientTransactions);
	
	var _clientFinancesScss = __webpack_require__(717);
	
	var _clientFinancesScss2 = _interopRequireDefault(_clientFinancesScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clientFinances');
	
	var FinForm = (0, _reduxForm.reduxForm)({
		form: "finances",
		fields: ["startDate", "endDate"]
	})(function (props) {
		var _props$fields = props.fields;
		var startDate = _props$fields.startDate;
		var endDate = _props$fields.endDate;
		var handleSubmit = props.handleSubmit;
		var items = props.items;
	
		return _react2['default'].createElement(
			'div',
			{ className: _clientFinancesScss2['default'].clientFinances },
			_react2['default'].createElement(
				'form',
				{ onSubmit: handleSubmit },
				_react2['default'].createElement(
					'div',
					{ className: _clientFinancesScss2['default'].submitContainer },
					_react2['default'].createElement(
						'div',
						{ className: _clientFinancesScss2['default'].inputContainer },
						_react2['default'].createElement(
							'div',
							{ className: _clientFinancesScss2['default'].label },
							_react2['default'].createElement(
								'p',
								null,
								_('from')
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: _clientFinancesScss2['default'].input },
							_react2['default'].createElement(_componentsSharedDatePicker.DatePicker, startDate)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: _clientFinancesScss2['default'].inputContainer },
						_react2['default'].createElement(
							'div',
							{ className: _clientFinancesScss2['default'].label },
							_react2['default'].createElement(
								'p',
								null,
								_('till')
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: _clientFinancesScss2['default'].input },
							_react2['default'].createElement(_componentsSharedDatePicker.DatePicker, endDate)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: _clientFinancesScss2['default'].inputContainer },
						_react2['default'].createElement(
							'div',
							{ className: _clientFinancesScss2['default'].input + ' ' + _clientFinancesScss2['default'].submit },
							_react2['default'].createElement('input', { type: 'button', onClick: handleSubmit, value: _('search') })
						)
					)
				)
			),
			items && _react2['default'].createElement(
				'div',
				{ className: _clientFinancesScss2['default'].results },
				_react2['default'].createElement(_clientTransactions2['default'], { items: items })
			)
		);
	});
	
	var Finances = (function (_Component) {
		_inherits(Finances, _Component);
	
		function Finances() {
			_classCallCheck(this, _Finances);
	
			_get(Object.getPrototypeOf(_Finances.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Finances, [{
			key: 'fetchData',
			value: function fetchData() {
				var _props = this.props;
				var fetchClientFinances = _props.fetchClientFinances;
				var clientId = _props.clientId;
				var items = _props.items;
	
				if (!items) {
					fetchClientFinances(clientId);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.fetchData();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.fetchData();
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props;
				var items = _props2.items;
				var _props2$filter = _props2.filter;
				var startDate = _props2$filter.startDate;
				var endDate = _props2$filter.endDate;
				var filterClientFinances = _props2.filterClientFinances;
	
				var filteredItems = items;
				if (filteredItems && (startDate || endDate)) {
					filteredItems = filteredItems.filter(function (_ref) {
						var lineType = _ref.lineType;
						var transactionDate = _ref.transactionDate;
	
						if (lineType !== 'D' || !transactionDate) {
							return false;
						}
						var m = (0, _moment2['default'])(transactionDate);
						return (!startDate || m.isSameOrAfter(startDate)) && (!endDate || m.isSameOrBefore(endDate));
					});
				}
	
				return _react2['default'].createElement(FinForm, {
					items: filteredItems,
					onSubmit: filterClientFinances
				});
			}
		}], [{
			key: 'propTypes',
			value: {
				fetchClientFinances: _react.PropTypes.func.isRequired,
				filterClientFinances: _react.PropTypes.func.isRequired,
				clientId: _react.PropTypes.string.isRequired,
				items: _react.PropTypes.array,
				filter: _react.PropTypes.object
			},
			enumerable: true
		}]);
	
		var _Finances = Finances;
		Finances = (0, _reactRedux.connect)(function (_ref2) {
			var app = _ref2.app;
			var clients = _ref2.clients;
	
			var clientId = app.opened;
			var items = clients.finances[clientId];
			return {
				clientId: clientId,
				items: items,
				filter: clients.filter
			};
		}, { fetchClientFinances: _stateActions.fetchClientFinances, filterClientFinances: _stateActions.filterClientFinances })(Finances) || Finances;
		return Finances;
	})(_react.Component);
	
	exports['default'] = Finances;
	module.exports = exports['default'];

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _clientProfileScss = __webpack_require__(1600);
	
	var _clientProfileScss2 = _interopRequireDefault(_clientProfileScss);
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _uploader = __webpack_require__(143);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _emailSenderEmailButton = __webpack_require__(108);
	
	var _emailSenderEmailButton2 = _interopRequireDefault(_emailSenderEmailButton);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libHelpers = __webpack_require__(24);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stateConstants = __webpack_require__(11);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _ = (0, _libI18n2['default'])('clientProfile');
	
	var DateValue = function DateValue(_ref) {
	    var date = _ref.date;
	
	    var rest = _objectWithoutProperties(_ref, ['date']);
	
	    return _react2['default'].createElement(
	        'span',
	        rest,
	        (0, _libHelpers.formatDate)(date)
	    );
	};
	
	var noteConfirmationModalStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        whiteSpace: 'pre-wrap',
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        width: '70%',
	        height: 'auto'
	    }
	};
	
	var printSelect = function printSelect(item, options) {
	    var itemValue = "";
	
	    // TODO solve to not call this function before the translation values are not loaded by the client dic api.
	    if (!options) {
	        console.warn('(printSelect) No dictionary loaded and the value not translated for: ', item, " options: ", options);
	        return item;
	    }
	
	    options.map(function (key, i) {
	        if (Number(item) == Number(key.value)) {
	            itemValue = key.label;
	        }
	    });
	
	    return itemValue;
	};
	
	/**
	 * Helper function to select the language from dictionary.
	 * @param {*} item
	 * @param {*} options
	 * @param {*} language
	 * @param {*} languageOptions
	 */
	var clientLanguagePrintSelect = function clientLanguagePrintSelect(item, options, language, languageOptions) {
	    var convertedLanguage = undefined;
	
	    if (!options) {
	        console.warn('(clientLanguagePrintSelect) No dictionary loaded and the value not translated for: ', item, " options: ", options);
	        return item;
	    }
	
	    // Generate language code from
	    if (!language && languageOptions && languageOptions.length > 0) {
	        languageOptions.map(function (index, key) {
	            if (index.label == language) {
	                language = index.value;
	            }
	        });
	    }
	
	    if (language == 1) {
	        language = 'nl';
	    } else if (language == 2) {
	        language = 'fr';
	    } else if (language == 3) {
	        language = 'en';
	    } else {
	        language = 'nl';
	    }
	
	    if (options && options.length > 0) {
	        options.map(function (index, key) {
	            if (index.value == item) {
	                convertedLanguage = index.label[language];
	            }
	        });
	    }
	
	    return convertedLanguage;
	};
	
	/**
	 * Generates the client dictionaries to have a same place for each dictionary
	 *
	 * @param Object clientOptionsDictionary 	The translate list from state.client.clientOptionsDict
	 * @param string language 								The language of the application - state.app.lang
	 */
	var generateClientDicts = function generateClientDicts(clientOptionsDict, language) {
	    var clientDictionaries = [];
	
	    if (!clientOptionsDict) {
	        console.warn("Manual error: \"clientOptionsDict\" is not defined for clientProfile module");
	        return null;
	    }
	
	    clientDictionaries['personType'] = generateOptionsObject(clientOptionsDict.PERSOONSTYPE, language);
	    clientDictionaries['gender'] = generateOptionsObject(clientOptionsDict.GESLACHT, language);
	    clientDictionaries['nationality'] = generateOptionsObject(clientOptionsDict.NATIONALITEIT, language);
	    clientDictionaries['language'] = generateOptionsObject(clientOptionsDict.TAAL, language);
	    clientDictionaries['title'] = generateOptionsObject(clientOptionsDict.AANSPREKING, language);
	    clientDictionaries['licenceCategory'] = generateOptionsObject(clientOptionsDict.RB_CATEGORIE, language);
	    clientDictionaries['relationType'] = generateOptionsObject(clientOptionsDict.HOEDANIGHEID, language);
	    clientDictionaries['country'] = generateOptionsObject(clientOptionsDict.LAND, language);
	    clientDictionaries['legalForm'] = generateOptionsObject(clientOptionsDict.RECHTSVORM, language);
	    clientDictionaries['profession'] = generateOptionsObject(clientOptionsDict.profession, language);
	    clientDictionaries['activSector'] = generateOptionsObject(clientOptionsDict.activSector, language);
	    clientDictionaries['socialStatus'] = generateOptionsObject(clientOptionsDict.socialStatus, language);
	    clientDictionaries['taxStatus'] = generateOptionsObject(clientOptionsDict.taxStatus, language);
	    clientDictionaries['ppp'] = generateOptionsObject(clientOptionsDict.ppp, language);
	    clientDictionaries['birthCountry'] = generateOptionsObject(clientOptionsDict.LAND, language);
	    clientDictionaries['maritalStatus'] = generateOptionsObject(clientOptionsDict.maritalStatus, language);
	    clientDictionaries['globalCountry'] = generateGlobalOptionsObject(clientOptionsDict.LAND);
	
	    clientDictionaries = _extends({}, clientOptionsDict, clientDictionaries);
	
	    return clientDictionaries;
	};
	
	/**
	 *
	 * @param {*} optionsData
	 */
	var generateGlobalOptionsObject = function generateGlobalOptionsObject(optionsData) {
	    var optionsArray = [];
	
	    Object.keys(optionsData).map(function (key, index) {
	        optionsArray.push({ value: key, label: optionsData[key] });
	    });
	
	    return optionsArray;
	};
	
	/**
	 * Generate option array based on requested object data
	 * @param Object optionsData
	 * @param String language
	 *
	 * @return array
	 */
	var generateOptionsObject = function generateOptionsObject(optionsData, language) {
	    var optionsArray = [];
	
	    Object.keys(optionsData).map(function (key, index) {
	        optionsArray.push({ value: key, label: optionsData[key][language] });
	    });
	
	    return optionsArray;
	};
	
	/**
	 * Helper function for Address rendering.
	 * @param {*} param0
	 */
	var AddressValue = function AddressValue(_ref2) {
	    var addressData = _ref2.addressData;
	    var clientOptionsDict = _ref2.clientOptionsDict;
	    var clientLanguage = _ref2.clientLanguage;
	    var country = addressData.country;
	    var street = addressData.street;
	    var number = addressData.number;
	    var extension = addressData.extension;
	    var postalCode = addressData.postalCode;
	    var locality = addressData.locality;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: _clientProfileScss2['default'].addressContainer },
	        _react2['default'].createElement(
	            'div',
	            { className: _clientProfileScss2['default'].addressColumn },
	            street,
	            ' ',
	            number,
	            extension ? '/' + extension : '',
	            ' ',
	            _react2['default'].createElement('br', null),
	            postalCode,
	            ' ',
	            locality,
	            ' ',
	            country ? clientLanguagePrintSelect(country, clientOptionsDict.globalCountry, clientLanguage, clientOptionsDict.language) : country
	        ),
	        (postalCode || locality) && _react2['default'].createElement(
	            'div',
	            { className: _clientProfileScss2['default'].addressColumn },
	            _react2['default'].createElement(
	                'a',
	                { href: getGoogleMapsLink(addressData), target: '_blank', className: _clientProfileScss2['default'].mapsLink, rel: 'noopener noreferrer' },
	                _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_clientProfileScss2['default'].emailButtonIcon), src: getIcon("outline-location_on-24px") })
	            )
	        )
	    );
	};
	
	/**
	 * @param {object} addressData - contains address info
	 */
	var getGoogleMapsLink = function getGoogleMapsLink(addressData) {
	    var country = addressData.country;
	    var street = addressData.street;
	    var number = addressData.number;
	    var extension = addressData.extension;
	    var postalCode = addressData.postalCode;
	    var locality = addressData.locality;
	
	    var address = [country, street, number, postalCode, locality];
	    // https://developers.google.com/maps/documentation/urls/guide
	    return "https://www.google.com/maps/search/?api=1&query=" + encodeURI(address.join(", "));
	};
	
	/**
	 * This function helps to use an icon on a safe way
	 */
	var getIcon = function getIcon(icon) {
	    try {
	        return __webpack_require__(262)("./icn-" + icon + '.svg');
	    } catch (err) {
	        return __webpack_require__(23);
	    }
	};
	
	/**
	 * Phone value render helper
	 * @param {object} param0
	 */
	var PhoneValue = function PhoneValue(_ref3) {
	    var number = _ref3.number;
	    return _react2['default'].createElement(
	        'a',
	        { href: 'callto:' + number },
	        number
	    );
	};
	
	/**
	 * Help to render bank account.
	 * @param {*} param0
	 */
	var BankAcctValue = function BankAcctValue(_ref4) {
	    var BIC = _ref4.BIC;
	    var IBAN = _ref4.IBAN;
	    return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	            'span',
	            { style: { fontWeight: 'bold' } },
	            IBAN
	        ),
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement(
	            'span',
	            { style: { fontStyle: 'italic' } },
	            BIC
	        )
	    );
	};
	
	/**
	 * Thins function render the drivers license using category and date.
	 * @param {*} param0
	 */
	var DriversLicenseValue = function DriversLicenseValue(_ref5) {
	    var licenceCategory = _ref5.licenceCategory;
	    var licenceDate = _ref5.licenceDate;
	    return _react2['default'].createElement(
	        'div',
	        null,
	        licenceCategory,
	        licenceDate && _react2['default'].createElement(
	            'span',
	            null,
	            ' (',
	            _react2['default'].createElement(DateValue, { date: licenceDate }),
	            ')'
	        )
	    );
	};
	
	var EasinsureValue = function EasinsureValue(_ref6) {
	    var eDate = _ref6.eDate;
	    return _react2['default'].createElement(
	        'div',
	        null,
	        eDate && _react2['default'].createElement(DateValue, { date: eDate })
	    );
	};
	
	var multiLineEmail = function multiLineEmail(data) {
	    return data && data.map(function (line, i) {
	        return _react2['default'].createElement(
	            'p',
	            { key: i },
	            _react2['default'].createElement(
	                'a',
	                { className: line['default'] == 'true' ? _clientProfileScss2['default'].emailDefault : _clientProfileScss2['default'].email, href: 'mailto:' + line.email },
	                line.email
	            )
	        );
	    });
	};
	
	var multiLinePhones = function multiLinePhones(data) {
	    return data && data.map(function (line, i) {
	        return _react2['default'].createElement(
	            'p',
	            { key: i },
	            _react2['default'].createElement(
	                'a',
	                { className: line['default'] == 'true' ? _clientProfileScss2['default'].phoneDefault : _clientProfileScss2['default'].phone, href: 'callto:' + line.number },
	                line.number
	            )
	        );
	    });
	};
	
	var EmailValue = function EmailValue(_ref7) {
	    var email = _ref7.email;
	    return _react2['default'].createElement(
	        'a',
	        { className: _clientProfileScss2['default'].mail, href: 'mailto:' + email },
	        email
	    );
	};
	
	var ContactValue = function ContactValue(_ref8) {
	    var contactData = _ref8.contactData;
	    var clientOptionsDict = _ref8.clientOptionsDict;
	    var appLanguage = _ref8.appLanguage;
	    var navigateToRelatedClient = _ref8.navigateToRelatedClient;
	    var contactNumber = contactData.contactNumber;
	    var contactType = contactData.contactType;
	    var contactName = contactData.contactName;
	    var contactFirstName = contactData.contactFirstName;
	    var contactgender = contactData.contactgender;
	    var contactdateOfBirth = contactData.contactdateOfBirth;
	
	    var clientGenderOnAppLang = (0, _libHelpers.getTheGenderOnAppLangByAnyCode)(contactgender, clientOptionsDict, appLanguage);
	    // contactgender = genderCodeToTranslateIndex(contactgender)
	
	    return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	            'p',
	            null,
	            _react2['default'].createElement(
	                'span',
	                { style: { fontWeight: 'bold' } },
	                contactType
	            ),
	            _react2['default'].createElement(
	                'span',
	                null,
	                ' ',
	                contactName,
	                ' ',
	                contactFirstName,
	                ' (',
	                _react2['default'].createElement(
	                    'a',
	                    { onClick: function () {
	                            return navigateToRelatedClient(contactData.contactNumber);
	                        }, style: { cursor: 'pointer', display: 'inline' } },
	                    contactNumber
	                ),
	                ')'
	            )
	        ),
	        _('dateOfBirth'),
	        ' ',
	        (0, _libHelpers.formatDate)(contactdateOfBirth, 'eu'),
	        _react2['default'].createElement('br', null),
	        _('gender'),
	        ' ',
	        clientGenderOnAppLang,
	        _react2['default'].createElement('br', null)
	    );
	};
	
	var UList = function UList(_ref9) {
	    var children = _ref9.children;
	    return _react2['default'].createElement(
	        'ul',
	        null,
	        children.map(function (c, i) {
	            return _react2['default'].createElement(
	                'li',
	                { key: i },
	                c
	            );
	        })
	    );
	};
	
	var childMultiLine = function childMultiLine(data) {
	    var field = Object.keys(data)[0];
	    return data[field];
	};
	
	/**
	 * This function convert the gender code to an index from translations (from clientOptionsDict)
	 * Return with the index value if exist the code in the white list (M and V). (1 or 2)
	 * @param {string} gender
	 */
	var genderCodeToTranslateIndex = function genderCodeToTranslateIndex(gender) {
	    if (gender == 'M') {
	        gender = 1;
	    }
	
	    if (gender == 'V' || gender == 'F') {
	        gender = 2;
	    }
	
	    return gender;
	};
	
	/**
	 * This function will render the client profile dome using the process function on the raw data.
	 * Use translation on translatable values.
	 * @param {object} param0
	 */
	var ClientProfileDom = function ClientProfileDom(_ref10) {
	    var clientId = _ref10.clientId;
	    var clientDocuments = _ref10.clientDocuments;
	    var clientNumber = _ref10.clientNumber;
	    var dateOfBirth = _ref10.dateOfBirth;
	    var companyRegistrationNumber = _ref10.companyRegistrationNumber;
	    var gender = _ref10.gender;
	    var language = _ref10.language;
	    var emails = _ref10.emails;
	    var licences = _ref10.licences;
	    var phoneNumbers = _ref10.phoneNumbers;
	    var accountNumbers = _ref10.accountNumbers;
	    var contacts = _ref10.contacts;
	    var myEasinsure = _ref10.myEasinsure;
	    var address = _ref10.address;
	    var corrAddr = _ref10.corrAddr;
	    var setSubModule = _ref10.setSubModule;
	    var createClientAccess = _ref10.createClientAccess;
	    var updateClientAccess = _ref10.updateClientAccess;
	    var clientOptionsDict = _ref10.clientOptionsDict;
	    var appLanguage = _ref10.appLanguage;
	    var createmail = _ref10.createmail;
	    var moduleKeyToSet = _ref10.moduleKeyToSet;
	    var name = _ref10.name;
	    var moduleOptions = _ref10.moduleOptions;
	    var clientLanguageOnAppLang = _ref10.clientLanguageOnAppLang;
	    var clientGenderOnAppLang = _ref10.clientGenderOnAppLang;
	    var nationalIdNumber = _ref10.nationalIdNumber;
	    var birthPostalCode = _ref10.birthPostalCode;
	    var birthLocality = _ref10.birthLocality;
	    var birthCountry = _ref10.birthCountry;
	    var amlScore = _ref10.amlScore;
	    var amlProfile = _ref10.amlProfile;
	    var pppLabel = _ref10.pppLabel;
	    var nationalityLabel = _ref10.nationalityLabel;
	    var maritalStatusLabel = _ref10.maritalStatusLabel;
	    var professionLabel = _ref10.professionLabel;
	    var activSectorLabel = _ref10.activSectorLabel;
	    var socialStatusLabel = _ref10.socialStatusLabel;
	    var taxStatusLabel = _ref10.taxStatusLabel;
	    var canCreateMifid = _ref10.canCreateMifid;
	    var clientNoteObj = _ref10.clientNoteObj;
	    var navigateToRelatedClient = _ref10.navigateToRelatedClient;
	    var modifyOnlyLegalClient = _ref10.modifyOnlyLegalClient;
	    var clientTypeValue = _ref10.clientTypeValue;
	
	    var columns = createInfoColumns(clientNumber, dateOfBirth, companyRegistrationNumber, emails, licences, phoneNumbers, accountNumbers, contacts, myEasinsure, address, corrAddr, clientOptionsDict, appLanguage, clientLanguageOnAppLang, clientGenderOnAppLang, nationalIdNumber, birthPostalCode, birthLocality, birthCountry, amlScore, amlProfile, pppLabel, nationalityLabel, maritalStatusLabel, professionLabel, activSectorLabel, socialStatusLabel, taxStatusLabel, navigateToRelatedClient, clientTypeValue);
	
	    return _react2['default'].createElement(
	        'div',
	        { className: _clientProfileScss2['default'].profileClient },
	        _react2['default'].createElement(
	            'div',
	            { className: _clientProfileScss2['default'].moduleSection },
	            _react2['default'].createElement(
	                'div',
	                { className: _clientProfileScss2['default'].moduleSectionHeading },
	                _('general'),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientProfileScss2['default'].editClientProfile },
	                    updateClientAccess && !modifyOnlyLegalClient || updateClientAccess && modifyOnlyLegalClient && +clientTypeValue === 2 ? _react2['default'].createElement(
	                        'button',
	                        { key: "btnEditProfile",
	                            className: "btn green " + (0, _classnames2['default'])(_clientProfileScss2['default'].fullWidth),
	                            onClick: function () {
	                                return setSubModule('edit-profile');
	                            } },
	                        _('edit-profile')
	                    ) : '',
	                    createmail && _react2['default'].createElement(_emailSenderEmailButton2['default'], { moduleKeyToSet: moduleKeyToSet, moduleOptions: moduleOptions }),
	                    canCreateMifid && _react2['default'].createElement(
	                        'div',
	                        { className: _clientProfileScss2['default'].mifidButtonCorrection },
	                        _react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
	                            moduleKeyToSet: c.DS_MODULE_CLIENT_PROFILE,
	                            clientId: clientId,
	                            callBackOnClose: function () {},
	                            moduleOptions: moduleOptions
	                        })
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: _clientProfileScss2['default'].moduleSectionContent },
	                columns ? _react2['default'].createElement(_KeyValue2['default'], { array: columns, divider: true }) : '…'
	            ),
	            ClientNoteDom(clientNoteObj)
	        ),
	        _react2['default'].createElement(_uploader2['default'], { type: 'client', documents: clientDocuments, id: clientId })
	    );
	};
	
	exports.ClientProfileDom = ClientProfileDom;
	var createInfoColumns = function createInfoColumns(clientNumber, dateOfBirth, companyRegistrationNumber, emails, licences, phoneNumbers, accountNumbers, contacts, myEasinsure, address, corrAddr, clientOptionsDict, appLanguage, clientLanguageOnAppLang, clientGenderOnAppLang, nationalIdNumber, birthPostalCode, birthLocality, birthCountry, amlScore, amlProfile, pppLabel, nationalityLabel, maritalStatusLabel, professionLabel, activSectorLabel, socialStatusLabel, taxStatusLabel, navigateToRelatedClient, clientTypeValue) {
	
	    if (clientTypeValue == '2') {
	        return [[{ label: _('clientNumber') + ':', value: clientNumber }, { label: _('language') + ':', value: clientLanguageOnAppLang }, { label: _('nationality') + ':', value: nationalityLabel }, {
	            label: _('email') + ':',
	            value: multiLineEmail(emails)
	
	        }, {
	            label: _('phoneNumbers') + ':',
	            value: multiLinePhones(phoneNumbers)
	        }, { label: _('address') + ':', value: _react2['default'].createElement(AddressValue, { addressData: address, clientOptionsDict: clientOptionsDict, clientLanguage: appLanguage }) }, { label: _('correspondence') + ':', value: _react2['default'].createElement(AddressValue, { addressData: corrAddr, clientOptionsDict: clientOptionsDict }) }, {
	            label: _('easinsureDate') + ":",
	            value: _react2['default'].createElement(EasinsureValue, { eDate: myEasinsure })
	        }, { label: _('amlScore') + ':', value: amlScore }, { label: _('amlProfile') + ':', value: amlProfile }], [{ label: _('companyRegistrationNumber') + ':', value: companyRegistrationNumber }, { label: _('activSector') + ':', value: activSectorLabel }, { label: _('taxStatus') + ':', value: taxStatusLabel }, {
	            label: _('IBAN') + ':',
	            value: _react2['default'].createElement(
	                UList,
	                null,
	                accountNumbers.map(function (account, key) {
	                    return _react2['default'].createElement(BankAcctValue, _extends({}, account, { key: key }));
	                })
	            )
	        }, {
	            label: _('licenceDate') + ':',
	            value: _react2['default'].createElement(
	                UList,
	                null,
	                licences.map(function (license, i) {
	                    return _react2['default'].createElement(DriversLicenseValue, _extends({ key: i }, license));
	                })
	            )
	        }, {
	            label: _('familyRelations') + ':',
	            value: _react2['default'].createElement(
	                UList,
	                null,
	                contacts.map(function (c, i) {
	                    return _react2['default'].createElement(ContactValue, { key: i, contactData: c, clientOptionsDict: clientOptionsDict, navigateToRelatedClient: navigateToRelatedClient, appLanguage: appLanguage });
	                })
	            )
	        }]];
	    } else {
	        return [[{ label: _('clientNumber') + ':', value: clientNumber }, { label: _('gender') + ':', value: clientGenderOnAppLang }, { label: _('nationalIdNumber') + ':', value: nationalIdNumber }, { label: _('nationality') + ':', value: nationalityLabel }, { label: _('language') + ':', value: clientLanguageOnAppLang }, {
	            label: _('email') + ':',
	            value: multiLineEmail(emails)
	
	        }, {
	            label: _('phoneNumbers') + ':',
	            value: multiLinePhones(phoneNumbers)
	        }, { label: _('address') + ':', value: _react2['default'].createElement(AddressValue, { addressData: address, clientOptionsDict: clientOptionsDict, clientLanguage: appLanguage }) }, { label: _('correspondence') + ':', value: _react2['default'].createElement(AddressValue, { addressData: corrAddr, clientOptionsDict: clientOptionsDict }) }, {
	            label: _('easinsureDate') + ":",
	            value: _react2['default'].createElement(EasinsureValue, { eDate: myEasinsure })
	        }, { label: _('amlScore') + ':', value: amlScore }, { label: _('amlProfile') + ':', value: amlProfile }], [{ label: _('dateOfBirth') + ':', value: _react2['default'].createElement(DateValue, { date: dateOfBirth }) }, { label: _('birthCountry') + ':', value: birthPostalCode + ' ' + birthLocality + ' ' + birthCountry }, { label: _('maritalStatus') + ':', value: maritalStatusLabel }, { label: _('companyRegistrationNumber') + ':', value: companyRegistrationNumber }, { label: _('profession') + ':', value: professionLabel }, { label: _('activSector') + ':', value: activSectorLabel }, { label: _('socialStatus') + ':', value: socialStatusLabel }, { label: _('taxStatus') + ':', value: taxStatusLabel }, { label: _('ppp') + ':', value: pppLabel }, {
	            label: _('IBAN') + ':',
	            value: _react2['default'].createElement(
	                UList,
	                null,
	                accountNumbers.map(function (account, key) {
	                    return _react2['default'].createElement(BankAcctValue, _extends({}, account, { key: key }));
	                })
	            )
	        }, {
	            label: _('licenceDate') + ':',
	            value: _react2['default'].createElement(
	                UList,
	                null,
	                licences.map(function (license, i) {
	                    return _react2['default'].createElement(DriversLicenseValue, _extends({ key: i }, license));
	                })
	            )
	        }, {
	            label: _('familyRelations') + ':',
	            value: _react2['default'].createElement(
	                UList,
	                null,
	                contacts.map(function (c, i) {
	                    return _react2['default'].createElement(ContactValue, { key: i, contactData: c, clientOptionsDict: clientOptionsDict, navigateToRelatedClient: navigateToRelatedClient, appLanguage: appLanguage });
	                })
	            )
	        }]];
	    }
	};
	
	var ClientNoteDom = function ClientNoteDom(clientNoteObj) {
	    var clientNote = clientNoteObj.clientNote;
	    var saveNote = clientNoteObj.saveNote;
	    var handleNoteChange = clientNoteObj.handleNoteChange;
	    var toggleNoteEditMode = clientNoteObj.toggleNoteEditMode;
	    var handleDeleteClientNote = clientNoteObj.handleDeleteClientNote;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: _clientProfileScss2['default'].moduleSection },
	        _react2['default'].createElement(
	            'div',
	            { className: _clientProfileScss2['default'].moduleSectionHeading },
	            _('notes'),
	            clientNoteObj.noteEditMode ? _react2['default'].createElement(
	                'div',
	                { className: _clientProfileScss2['default'].noteButtons },
	                _react2['default'].createElement(
	                    'button',
	                    { className: "btn green " + (0, _classnames2['default'])(_clientProfileScss2['default'].fullWidth), onClick: function () {
	                            return saveNote(clientNote);
	                        } },
	                    ' ',
	                    _('save-note'),
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { className: _clientProfileScss2['default'].gray, onClick: function () {
	                            return toggleNoteEditMode();
	                        } },
	                    ' ',
	                    _('cancel'),
	                    ' '
	                )
	            ) : _react2['default'].createElement(
	                'div',
	                { className: _clientProfileScss2['default'].noteButtons },
	                _react2['default'].createElement(
	                    'button',
	                    { className: "btn green " + (0, _classnames2['default'])(_clientProfileScss2['default'].fullWidth), onClick: function () {
	                            return toggleNoteEditMode();
	                        } },
	                    ' ',
	                    clientNote && clientNote._id ? _('edit-note') : _('create-note'),
	                    ' '
	                ),
	                clientNote && clientNote._id && _react2['default'].createElement(
	                    'button',
	                    { className: _clientProfileScss2['default'].gray, onClick: function () {
	                            return handleDeleteClientNote(clientNote._id);
	                        } },
	                    ' ',
	                    _('delete'),
	                    ' '
	                )
	            )
	        ),
	        clientNoteObj.noteEditMode ? _react2['default'].createElement(
	            'div',
	            { className: _clientProfileScss2['default'].noteWrappper },
	            _react2['default'].createElement('textarea', { className: _clientProfileScss2['default'].noteArea, placeholder: _('notes-placeholder'), rows: '4', value: clientNote.note, onChange: function (e) {
	                    return handleNoteChange(e.target.value);
	                } }),
	            clientNoteObj.noteFieldError && _react2['default'].createElement(
	                'span',
	                { className: _clientProfileScss2['default'].noteFieldError },
	                _('noteFieldError')
	            )
	        ) : _react2['default'].createElement(
	            'div',
	            { className: _clientProfileScss2['default'].noteWrappper },
	            _react2['default'].createElement(
	                'div',
	                { className: _clientProfileScss2['default'].noteView },
	                clientNote && clientNote.note || _('notes-placeholder'),
	                ' '
	            )
	        )
	    );
	};
	
	exports.ClientNoteDom = ClientNoteDom;
	/**
	 * Client profile module
	 * It is make possible to view edit and create client profile, based on rights from "security.actions".
	 */
	
	var ClientProfile = (function (_Component) {
	    _inherits(ClientProfile, _Component);
	
	    _createClass(ClientProfile, null, [{
	        key: 'propTypes',
	        value: {
	            clientId: _react.PropTypes.string.isRequired,
	            data: _react2['default'].PropTypes.object,
	            clientOptionsDict: _react2['default'].PropTypes.object
	        },
	
	        /**
	         * Initialise the module state in constructor.
	         * The "clientOptionsDict" state value used for translate few value to the selected app language.
	         *   The translation dictionary loaded asynchronously and set up in state, what trigger automatically
	         *   the rendering again.
	         * @param {object} props
	         */
	        enumerable: true
	    }]);
	
	    function ClientProfile(props) {
	        _classCallCheck(this, _ClientProfile);
	
	        _get(Object.getPrototypeOf(_ClientProfile.prototype), 'constructor', this).call(this, props);
	
	        var clientOptionsDict = props.clientOptionsDict;
	
	        this.state = { clientOptionsDict: clientOptionsDict, firstBrokerNumberFromOfficeBrokers: '', clientNote: null, noteEditMode: false, originalNote: null, noteFieldError: false, deleteNoteId: '' };
	    }
	
	    /**
	     * Before mounting the module we have to verify if we have already loaded the client option dictionary.
	     */
	
	    _createClass(ClientProfile, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this = this;
	
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var appLanguage = _props.appLanguage;
	            var clientOptionsDict = _props.clientOptionsDict;
	            var clientId = _props.clientId;
	            var clientNote = this.state.clientNote;
	
	            if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
	                dispatch((0, _stateActions.fetchClientOptionsDict)()).then(function (dictionary) {
	                    _this.setClientOptionsDict(dictionary);
	                });
	            } else {
	                if (!this.state.clientOptionsDict) {
	                    this.setClientOptionsDict(clientOptionsDict);
	                }
	            }
	
	            // get clinet note from backoffice if there is none it creates a temp one
	            if (!clientNote && clientId) {
	                dispatch((0, _stateActions.getClientNote)({ clientId: clientId })).then(function (res) {
	                    if (res && res._id) {
	                        _this.setState({ clientNote: res });
	                    } else {
	                        var newClientNote = {};
	                        newClientNote.note = '';
	                        newClientNote.clientId = clientId;
	                        _this.setState({ clientNote: newClientNote });
	                    }
	                });
	            }
	
	            // get office data to get the broker list. Use the first one brokerNumber for the email sender
	            dispatch((0, _stateActions.fetchOfficeData)()).then(function (result) {
	                var brNr = _nestedProperty2['default'].get(result, "officeInfo.brokers.0.brokerNumber");
	                _this.setState({ firstBrokerNumberFromOfficeBrokers: brNr });
	            });
	        }
	
	        /**
	         * Set client options dict in to the state
	         */
	    }, {
	        key: 'setClientOptionsDict',
	        value: function setClientOptionsDict(dictionary) {
	            var _this2 = this;
	
	            var appLanguage = this.props.appLanguage;
	
	            var clientOptionsDict = generateClientDicts(dictionary, appLanguage);
	
	            this.setState({ clientOptionsDict: clientOptionsDict }, function () {
	                _this2.forceUpdate();
	            });
	        }
	    }, {
	        key: 'setSubModule',
	        value: function setSubModule(subModuleName) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.setOpenedSubmenu)());
	            dispatch((0, _stateActions.setClientSubModule)(subModuleName));
	        }
	    }, {
	        key: 'saveNote',
	        value: function saveNote(clientNote) {
	            var _this3 = this;
	
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.saveClinetNote)(clientNote)).then(function (res) {
	                if (res && res._id) {
	                    dispatch((0, _stateActions.setNotification)(_('clientNoteSave'), 'success'));
	                    _this3.setState({ clientNote: _extends({}, clientNote, { _id: res._id }), noteEditMode: false, originalNote: null, noteFieldError: false });
	                }
	            });
	        }
	    }, {
	        key: 'handleNoteChange',
	        value: function handleNoteChange(val) {
	            var clientNote = this.state.clientNote;
	
	            clientNote.note = val;
	            this.setState({ clientNote: clientNote });
	        }
	    }, {
	        key: 'toggleNoteEditMode',
	        value: function toggleNoteEditMode() {
	            var _state = this.state;
	            var clientNote = _state.clientNote;
	            var noteEditMode = _state.noteEditMode;
	            var originalNote = _state.originalNote;
	
	            if (!noteEditMode) {
	                this.setState({ noteEditMode: !noteEditMode, originalNote: _extends({}, clientNote) });
	            } else {
	                this.setState({ noteEditMode: !noteEditMode, clientNote: _extends({}, originalNote), originalNote: null });
	            }
	        }
	    }, {
	        key: 'handleDeleteClientNote',
	        value: function handleDeleteClientNote(id) {
	            var _this4 = this;
	
	            var _props2 = this.props;
	            var dispatch = _props2.dispatch;
	            var clientId = _props2.clientId;
	
	            var data = { clientNoteId: id };
	            dispatch((0, _stateActions.deleteClientNote)(data)).then(function (res) {
	                if (res && res.ok) dispatch((0, _stateActions.setNotification)(_('clientNoteDelete'), 'success'));
	                _this4.setState({ clientNote: { note: '', clientId: clientId }, isOpenAreYouSure: false, deleteNoteId: '' });
	            });
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal(e) {
	            e.preventDefault();
	            var _props3 = this.props;
	            var dispatch = _props3.dispatch;
	            var initializeProfileForm = _props3.initializeProfileForm;
	            var toggleModalClientProfileForm = _props3.toggleModalClientProfileForm;
	            var modalState = _props3.modalState;
	
	            dispatch(toggleModalClientProfileForm(!modalState));
	            dispatch(initializeProfileForm({}, null, 'create'));
	        }
	
	        /**
	         * This function return with values for email sender, collected from this module
	         * depending on the current data structure.
	         */
	    }, {
	        key: 'collectVariableValues',
	        value: function collectVariableValues() {
	            var _this5 = this;
	
	            var emails = _nestedProperty2['default'].get(this.props, "data.detail.emails");
	            var clientName = _nestedProperty2['default'].get(this.props, "data.main.name");
	            // process email list to be digestible for email sender
	            emails = emails.map(function (item) {
	                return {
	                    referenceId: _nestedProperty2['default'].get(_this5.props, "clientId"),
	                    label: clientName,
	                    value: item.email,
	                    'default': item['default'] == "true" || item['default'] == true ? true : false
	                };
	            });
	
	            emails = emails.sort(function (item, item2) {
	                if (item['default'] && !item2['default']) {
	                    return -1;
	                }
	                if (!item['default'] && item2['default']) {
	                    return 1;
	                }
	                if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                    return 0;
	                }
	            }) || [];
	
	            // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
	            var clientLanguage = _nestedProperty2['default'].get(this.props, "data.detail.language") || '';
	            clientLanguage = (0, _libHelpers.getTheLanguageCodeByAnyLanguageOnAnyLanguage)(clientLanguage, this.state.clientOptionsDict);
	
	            return {
	                clientNumber: _nestedProperty2['default'].get(this.props, "data.main.clientNumber"),
	                clientName: clientName,
	                clientLanguage: clientLanguage,
	                clientEmails: emails,
	
	                // v6 style
	                clientDocuments: _nestedProperty2['default'].get(this.props, "data.clientDocuments"),
	                clientDocumentsType: 'client',
	                clientDocumentsId: _nestedProperty2['default'].get(this.props, "clientId"),
	
	                clientId: _nestedProperty2['default'].get(this.props, "clientId"),
	                contractId: false,
	                claimId: false,
	
	                brokerNumber: '', //nesProp.get(this.state, "firstBrokerNumberFromOfficeBrokers"),
	                clientData: _nestedProperty2['default'].get(this.props, "data.main")
	            };
	        }
	    }, {
	        key: 'resolveMissingLabels',
	        value: function resolveMissingLabels(appLanguage, clientOptionsDict2, clientData) {
	            var labels = {};
	            var clientOptionsDict = this.props.clientOptionsDict;
	            Object.keys(clientData).forEach(function (key) {
	                var value = clientData[key];
	                if (clientOptionsDict && clientOptionsDict[key] && clientOptionsDict[key][value] && clientOptionsDict[key][value][appLanguage]) {
	                    labels[key + 'Label'] = clientOptionsDict[key][value][appLanguage];
	                } else if (key === 'nationality' && clientOptionsDict['NATIONALITEIT'] && clientOptionsDict['NATIONALITEIT'][value] && clientOptionsDict['NATIONALITEIT'][value][appLanguage]) {
	                    labels[key + 'Label'] = clientOptionsDict['NATIONALITEIT'][value][appLanguage];
	                } else if (key === 'language' && clientOptionsDict['TAAL'] && clientOptionsDict['TAAL'][value] && clientOptionsDict['TAAL'][value][appLanguage]) {
	                    labels[key + 'Label'] = clientOptionsDict['TAAL'][value][appLanguage];
	                } else {
	                    labels[key + 'Label'] = value;
	                }
	            });
	            return labels;
	        }
	    }, {
	        key: 'getTypeValueFromLabel',
	        value: function getTypeValueFromLabel(clientTypeLabel) {
	            var clientOptionsDict = this.state.clientOptionsDict;
	
	            var language = this.props.appLanguage;
	            var generatedClientDicts = generateClientDicts(clientOptionsDict, language);
	            var typeValue = undefined;
	            if (clientTypeLabel != undefined) {
	                generatedClientDicts.personType.map(function (item) {
	                    if (clientTypeLabel == item.label) {
	                        typeValue = item.value;
	                    }
	                });
	            }
	
	            if (!typeValue && +clientTypeLabel === NaN) {
	                console.error('Failed to get value from label: ', clientTypeLabel);
	            }
	            return typeValue ? typeValue : clientTypeLabel;
	        }
	    }, {
	        key: 'navigateToRelatedClient',
	        value: function navigateToRelatedClient(clientNumber) {
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _stateActions.fetchRelationClient)({ clientNumber: clientNumber })).then(function (res) {
	                dispatch((0, _stateActions.setOpened)(res[0].clientId));
	                dispatch((0, _stateActions.setClientSubModule)('profile'));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _state2 = this.state;
	            var clientOptionsDict = _state2.clientOptionsDict;
	            var clientNote = _state2.clientNote;
	            var noteEditMode = _state2.noteEditMode;
	            var noteFieldError = _state2.noteFieldError;
	            var isOpenAreYouSure = _state2.isOpenAreYouSure;
	            var deleteNoteId = _state2.deleteNoteId;
	
	            if (!clientOptionsDict) {
	                return _react2['default'].createElement(
	                    'span',
	                    null,
	                    '...'
	                );
	            }
	
	            var setSubModule = function setSubModule(item) {
	                _this6.setSubModule(item);
	            };
	
	            var openModal = function openModal(e) {
	                _this6.openModal(e);
	            };
	
	            var clientNoteObj = {};
	            clientNoteObj.saveNote = function (e) {
	                if (e.note) {
	                    _this6.saveNote(e);
	                } else {
	                    _this6.setState({ noteFieldError: true });
	                }
	            };
	            clientNoteObj.handleNoteChange = function (val) {
	                _this6.handleNoteChange(val);
	            };
	            clientNoteObj.toggleNoteEditMode = function () {
	                _this6.toggleNoteEditMode();
	            };
	            clientNoteObj.handleDeleteClientNote = function (id) {
	                _this6.setState({ deleteNoteId: id, isOpenAreYouSure: true });
	            };
	            clientNoteObj.noteEditMode = noteEditMode;
	            clientNoteObj.clientNote = clientNote;
	            clientNoteObj.noteFieldError = noteFieldError;
	
	            var _props4 = this.props;
	            var clientId = _props4.clientId;
	            var data = _props4.data;
	            var createClientAccess = _props4.createClientAccess;
	            var updateClientAccess = _props4.updateClientAccess;
	            var appLanguage = _props4.appLanguage;
	            var createmail = _props4.createmail;
	            var moduleKey = _props4.moduleKey;
	            var canCreateMifid = _props4.canCreateMifid;
	            var modifyOnlyLegalClient = _props4.modifyOnlyLegalClient;
	
	            var detail = data && data.detail || {};
	            var main = data && data.main || {};
	            var clientDocuments = data && data.clientDocuments || [];
	
	            var clientNumber = main.clientNumber;
	            var dateOfBirth = main.dateOfBirth;
	            var companyRegistrationNumber = main.companyRegistrationNumber;
	            var name = main.name;
	            var gender = detail.gender;
	            var language = detail.language;
	            var emails = detail.emails;
	            var licences = detail.licences;
	            var phoneNumbers = detail.phoneNumbers;
	            var accountNumbers = detail.accountNumbers;
	            var contacts = detail.contacts;
	            var myEasinsure = detail.myEasinsure;
	            var nationality = detail.nationality;
	            var birthPostalCode = detail.birthPostalCode;
	            var nationalIdNumber = detail.nationalIdNumber;
	            var birthLocality = detail.birthLocality;
	            var birthCountry = detail.birthCountry;
	            var maritalStatus = detail.maritalStatus;
	            var amlScore = detail.amlScore;
	            var amlProfile = detail.amlProfile;
	            var profession = detail.profession;
	            var activSector = detail.activSector;
	            var socialStatus = detail.socialStatus;
	            var taxStatus = detail.taxStatus;
	            var ppp = detail.ppp;
	
	            var labels = this.resolveMissingLabels(appLanguage, clientOptionsDict, { ppp: ppp, nationality: nationality, maritalStatus: maritalStatus, profession: profession, activSector: activSector, socialStatus: socialStatus, taxStatus: taxStatus, language: language });
	            var pppLabel = labels.pppLabel;
	            var nationalityLabel = labels.nationalityLabel;
	            var maritalStatusLabel = labels.maritalStatusLabel;
	            var professionLabel = labels.professionLabel;
	            var activSectorLabel = labels.activSectorLabel;
	            var socialStatusLabel = labels.socialStatusLabel;
	            var taxStatusLabel = labels.taxStatusLabel;
	            var languageLabel = labels.languageLabel;
	
	            contacts.map(function (contact) {
	                if (clientOptionsDict && clientOptionsDict['HOEDANIGHEID'] && clientOptionsDict['HOEDANIGHEID'][contact.contactType] && clientOptionsDict['HOEDANIGHEID'][contact.contactType][appLanguage]) {
	                    contact.contactType = clientOptionsDict['HOEDANIGHEID'][contact.contactType][appLanguage];
	                }
	            });
	
	            var address = data && main.mainAddress;
	            var corrAddr = data && detail.correspondanceAddress;
	            var moduleKeyToSet = _nestedProperty2['default'].get(this.props, "EmailTemplateRelations.EmailTemplateModules.clientsProfile.value") || false;
	            var moduleOptions = this.collectVariableValues();
	
	            // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
	            var clientLanguageOnAppLang = (0, _libHelpers.getTheLanguageOnAppLangByAnyLanguage)(languageLabel, this.state.clientOptionsDict, this.props.appLanguage);
	            var clientGenderOnAppLang = (0, _libHelpers.getTheGenderOnAppLangByAnyCode)(gender, this.state.clientOptionsDict, this.props.appLanguage);
	
	            var clientTypeValue = this.getTypeValueFromLabel(data.main.clientType);
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(ClientProfileDom, _extends({
	                    clientId: clientId,
	                    clientDocuments: clientDocuments,
	                    clientNumber: clientNumber, dateOfBirth: dateOfBirth, companyRegistrationNumber: companyRegistrationNumber,
	                    gender: gender, languageLabel: languageLabel, emails: emails, licences: licences, phoneNumbers: phoneNumbers, accountNumbers: accountNumbers, contacts: contacts,
	                    address: address, corrAddr: corrAddr, myEasinsure: myEasinsure,
	                    createClientAccess: createClientAccess, updateClientAccess: updateClientAccess, openModal: openModal, clientOptionsDict: clientOptionsDict, appLanguage: appLanguage,
	                    createmail: createmail, moduleKeyToSet: moduleKeyToSet, name: name, moduleOptions: moduleOptions, clientLanguageOnAppLang: clientLanguageOnAppLang,
	                    clientGenderOnAppLang: clientGenderOnAppLang, nationalIdNumber: nationalIdNumber, birthPostalCode: birthPostalCode, birthLocality: birthLocality,
	                    birthCountry: birthCountry, maritalStatus: maritalStatus, amlScore: amlScore, amlProfile: amlProfile,
	                    pppLabel: pppLabel, nationalityLabel: nationalityLabel, maritalStatusLabel: maritalStatusLabel, professionLabel: professionLabel, activSectorLabel: activSectorLabel, socialStatusLabel: socialStatusLabel, taxStatusLabel: taxStatusLabel, canCreateMifid: canCreateMifid, clientNote: clientNote,
	                    modifyOnlyLegalClient: modifyOnlyLegalClient,
	                    clientTypeValue: clientTypeValue
	                }, {
	                    setSubModule: setSubModule,
	                    clientNoteObj: clientNoteObj,
	                    navigateToRelatedClient: function (clientNumber) {
	                        return _this6.navigateToRelatedClient(clientNumber);
	                    }
	                })),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: isOpenAreYouSure,
	                        style: noteConfirmationModalStyles,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientProfileScss2['default'].confirmationModalContent },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: _clientProfileScss2['default'].title },
	                            _('deleteNoteConfirmationTitle')
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: _clientProfileScss2['default'].message },
	                            _('deleteNoteConfirmationMessage')
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientProfileScss2['default'].documentsModalButtons },
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        _this6.setState({ isOpenAreYouSure: false });
	                                    },
	                                    className: _clientProfileScss2['default'].cancel
	                                },
	                                _("cancel")
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        _this6.handleDeleteClientNote(deleteNoteId);
	                                    },
	                                    className: _clientProfileScss2['default'].greenButton + " enabled"
	                                },
	                                _("ok")
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _ClientProfile = ClientProfile;
	    ClientProfile = (0, _reactRedux.connect)(function (state) {
	        var clientId = state.app.opened;
	        var clientAccess = state.app.security.actions;
	        var appLanguage = state.app.lang;
	        var EmailTemplateRelations = state.app.security.EmailTemplateRelations;
	        var canCreateClient = undefined,
	            canUpdateClient = undefined,
	            canCreateMifid = undefined,
	            canCreateOnlyLegalClient = undefined,
	            canModifyOnlyLegalClient = undefined;
	        // Generate options for client select lists
	        var clientOptionsDict = state.client.clientOptionsDict;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createclient') {
	                canCreateClient = item.actionAllowed === "true" ? true : false;
	            }
	            if (item.actionName == 'modifyclient') {
	                canUpdateClient = item.actionAllowed === "true" ? true : false;
	            }
	            if (item.actionName == 'createmifid') {
	                canCreateMifid = item.actionAllowed === "true" ? true : false;
	            }
	            if (item.actionName == 'createonlylegalclient') {
	                canCreateOnlyLegalClient = item.actionAllowed === "true" ? true : false;
	            }
	            if (item.actionName == 'modifyonlylegalclient') {
	                canModifyOnlyLegalClient = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        var createmail = clientAccess && clientAccess.filter(function (item) {
	            return item.actionName == "createmail" && item.actionAllowed == "true";
	        }).length > 0;
	
	        return {
	            subModule: state.clients.subModule,
	            createClientAccess: canCreateClient,
	            updateClientAccess: canUpdateClient,
	            createOnlyLegalClient: canCreateOnlyLegalClient,
	            modifyOnlyLegalClient: canModifyOnlyLegalClient,
	            clientOptionsDict: clientOptionsDict,
	            createmail: createmail,
	            appLanguage: appLanguage,
	            EmailTemplateRelations: EmailTemplateRelations,
	            canCreateMifid: canCreateMifid
	        };
	    })(ClientProfile) || ClientProfile;
	    return ClientProfile;
	})(_react.Component);
	
	exports['default'] = ClientProfile;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _clientProfileEditScss = __webpack_require__(718);
	
	var _clientProfileEditScss2 = _interopRequireDefault(_clientProfileEditScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _libHelpers = __webpack_require__(24);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _clientProfileForm = __webpack_require__(265);
	
	var _clientProfileForm2 = _interopRequireDefault(_clientProfileForm);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	/**
	 * Create connect to get requested states and actions
	 */
	
	/**
	 * Creates the edit profile page
	 */
	
	var ClientProfileEdit = (function (_Component) {
		_inherits(ClientProfileEdit, _Component);
	
		function ClientProfileEdit(props) {
			_classCallCheck(this, _ClientProfileEdit);
	
			_get(Object.getPrototypeOf(_ClientProfileEdit.prototype), 'constructor', this).call(this, props);
		}
	
		_createClass(ClientProfileEdit, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _props = this.props;
				var clientId = _props.clientId;
				var appLanguage = _props.appLanguage;
				var clientData = _props.clientData;
				var dispatch = _props.dispatch;
				var initializeProfileForm = _props.initializeProfileForm;
	
				dispatch(initializeProfileForm(clientData, clientId, 'edit'));
			}
	
			/**
	   * Implements the render function for the component
	   * Renders the component form data
	   */
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props;
				var setSubModule = _props2.setSubModule;
				var canCreateOnlyLegalClient = _props2.canCreateOnlyLegalClient;
				var canModifyOnlyLegalClient = _props2.canModifyOnlyLegalClient;
	
				return _react2['default'].createElement(
					'div',
					{ className: _clientProfileEditScss2['default'].profileClient },
					_react2['default'].createElement(
						'div',
						{ className: _clientProfileEditScss2['default'].moduleSection },
						_react2['default'].createElement(
							'div',
							{ className: _clientProfileEditScss2['default'].moduleSectionHeading },
							_('edit-profile')
						),
						_react2['default'].createElement(_clientProfileForm2['default'], {
							setSubModule: setSubModule,
							canModifyOnlyLegalClient: canModifyOnlyLegalClient
						})
					)
				);
			}
		}]);
	
		var _ClientProfileEdit = ClientProfileEdit;
		ClientProfileEdit = (0, _reactRedux.connect)(function (state) {
			var clientId = state.app.opened;
			var clientData = state.clients.clientData[clientId];
			var appLanguage = state.app.lang;
			var clientAccess = state.app.security.actions;
	
			var canModifyOnlyLegalClient = clientAccess && clientAccess.filter(function (item) {
				return item.actionName == "modifyonlylegalclient" && item.actionAllowed == "true";
			}).length > 0;
	
			return {
				clientId: clientId,
				appLanguage: appLanguage,
				clientData: clientData,
				initializeProfileForm: _stateActions.initializeProfileForm,
				canModifyOnlyLegalClient: canModifyOnlyLegalClient
			};
		})(ClientProfileEdit) || ClientProfileEdit;
		return ClientProfileEdit;
	})(_react.Component);
	
	exports['default'] = ClientProfileEdit;
	module.exports = exports['default'];

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _lodashLang = __webpack_require__(78);
	
	var _clientsScss = __webpack_require__(244);
	
	var _clientsScss2 = _interopRequireDefault(_clientsScss);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _tooManyResults = __webpack_require__(175);
	
	var _tooManyResults2 = _interopRequireDefault(_tooManyResults);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var ClientProfileFormResults = (function (_React$Component) {
		_inherits(ClientProfileFormResults, _React$Component);
	
		function ClientProfileFormResults() {
			_classCallCheck(this, ClientProfileFormResults);
	
			_get(Object.getPrototypeOf(ClientProfileFormResults.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ClientProfileFormResults, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodashLang.eq)(this.props.data, nextProps.data);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props;
				var data = _props.data;
				var zoomTo = _props.zoomTo;
				var loadClientData = _props.loadClientData;
	
				return _react2['default'].createElement(
					'div',
					{ className: _clientsScss2['default'].clientsTableContainer },
					_('existingClients'),
					data && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
						_componentsReactable.Table,
						{
							className: _clientsScss2['default'].table,
							itemsPerPage: 10,
							filterable: false,
							sortable: ["name", "address", "email", "phoneNumber", "clientNumber"],
							defaultSort: {
								column: 'name',
								direction: 'desc'
							}
						},
						_react2['default'].createElement(
							_componentsReactable.Thead,
							null,
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'clientNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'name' },
								_react2['default'].createElement(
									'strong',
									null,
									_('name')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'address' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientAddress')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'phoneNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('phoneNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'email' },
								_react2['default'].createElement(
									'strong',
									null,
									_('email')
								)
							)
						),
						data.map(function (item, key) {
							return _react2['default'].createElement(
								_componentsReactable.Tr,
								{
									className: 'clickable centered',
									onClick: function () {
										return loadClientData(item.clientId);
									}, key: key,
									onDoubleClick: function () {
										return zoomTo(item.clientNumber);
									}
								},
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'clientNumber' },
									item.clientNumber
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'name' },
									item.name
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'address' },
									item.mainAddress
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'email' },
									item.email
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'phoneNumber' },
									item.phoneNumber
								)
							);
						})
					),
					data && _underscore2['default'].isArray(data) && data.length === 0 && _react2['default'].createElement(_noResults2['default'], { type: 'clients' }),
					data && _underscore2['default'].isArray(data) && data[0] === 'Too many rows' && _react2['default'].createElement(_tooManyResults2['default'], { type: 'clients' })
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				data: _react2['default'].PropTypes.array
			},
			enumerable: true
		}]);
	
		return ClientProfileFormResults;
	})(_react2['default'].Component);
	
	exports['default'] = ClientProfileFormResults;
	module.exports = exports['default'];

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _lodashLang = __webpack_require__(78);
	
	var _clientsScss = __webpack_require__(244);
	
	var _clientsScss2 = _interopRequireDefault(_clientsScss);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _tooManyResults = __webpack_require__(175);
	
	var _tooManyResults2 = _interopRequireDefault(_tooManyResults);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var ClientResults = (function (_React$Component) {
		_inherits(ClientResults, _React$Component);
	
		function ClientResults() {
			_classCallCheck(this, ClientResults);
	
			_get(Object.getPrototypeOf(ClientResults.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ClientResults, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodashLang.eq)(this.props.data, nextProps.data);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props;
				var data = _props.data;
				var zoomTo = _props.zoomTo;
	
				return _react2['default'].createElement(
					'div',
					{ className: _clientsScss2['default'].clientsTableContainer },
					data && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
						_componentsReactable.Table,
						{
							className: _clientsScss2['default'].table,
							itemsPerPage: 20,
							filterable: ["name", "address", "email", "phoneNumber", "clientNumber"],
							sortable: ["name", "address", "email", "phoneNumber", "clientNumber"],
							defaultSort: {
								column: 'name',
								direction: 'desc'
							}
						},
						_react2['default'].createElement(
							_componentsReactable.Thead,
							null,
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'clientNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'name' },
								_react2['default'].createElement(
									'strong',
									null,
									_('name')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'address' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientAddress')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'phoneNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('phoneNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'email' },
								_react2['default'].createElement(
									'strong',
									null,
									_('email')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'activeContracts' },
								_react2['default'].createElement(
									'strong',
									null,
									_('activeContracts')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'klantenfiche' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientFile')
								)
							)
						),
						data.map(function (item, key) {
							return _react2['default'].createElement(
								_componentsReactable.Tr,
								{
									className: 'clickable centered',
									onClick: function () {
										return zoomTo(item.clientId);
									}, key: key
								},
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'clientNumber' },
									item.clientNumber
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'name' },
									item.name
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'address' },
									item.mainAddress
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'email' },
									item.email
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'phoneNumber' },
									item.phoneNumber
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'activeContracts' },
									item.activeContracts
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'klantenfiche' },
									item.clientFile === "TRUE" ? _('Yes') : _('No')
								)
							);
						})
					),
					data && _underscore2['default'].isArray(data) && data.length === 0 && _react2['default'].createElement(_noResults2['default'], { type: 'clients' }),
					data && _underscore2['default'].isArray(data) && data[0] === 'Too many rows' && _react2['default'].createElement(_tooManyResults2['default'], { type: 'clients' })
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				data: _react2['default'].PropTypes.array
			},
			enumerable: true
		}]);
	
		return ClientResults;
	})(_react2['default'].Component);
	
	exports['default'] = ClientResults;
	module.exports = exports['default'];

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x9, _x10, _x11) { var _again = true; _function: while (_again) { var object = _x9, property = _x10, receiver = _x11; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x9 = parent; _x10 = property; _x11 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _elementsReactSelect2Wrapper = __webpack_require__(374);
	
	var _elementsReactSelect2Wrapper2 = _interopRequireDefault(_elementsReactSelect2Wrapper);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateActions = __webpack_require__(5);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _clientTarificationCreateScss = __webpack_require__(1602);
	
	var _clientTarificationCreateScss2 = _interopRequireDefault(_clientTarificationCreateScss);
	
	var _ = (0, _libI18n2['default'])('clientTarificationCreate');
	
	var customStylesForModal = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var fieldsForFill = {
	    selectedBroker: '',
	    tarificationTeam: ''
	};
	
	/**
	 * Resetable state hierarchy and values for this module.
	 */
	var resetableState = _extends({
	    allFieldDisabled: true,
	    tarificationId: '',
	    tarification: false,
	    waitingModal: false,
	    validationErrors: {},
	    hasError: false
	}, fieldsForFill);
	
	/**
	 * Default state hierarchy and values for this module.
	 */
	var permanentState = {
	    brokerOptions: []
	};
	
	var ClientTarificationCreate = (function (_React$Component) {
	    _inherits(ClientTarificationCreate, _React$Component);
	
	    function ClientTarificationCreate(props) {
	        var _this = this;
	
	        _classCallCheck(this, _ClientTarificationCreate);
	
	        _get(Object.getPrototypeOf(_ClientTarificationCreate.prototype), 'constructor', this).call(this, props);
	
	        this.handleBrokerChange = function (selectedBroker) {
	            var selectedBrokerNumber = selectedBroker && selectedBroker.value || '';
	            var oldBroker = _nestedProperty2['default'].get(_this.state, 'selectedBroker');
	
	            _this.setFieldTouched('selectedBroker');
	
	            //if there are no changes do nothing
	            if (selectedBrokerNumber === oldBroker) {
	                return;
	            }
	
	            new Promise(function (resolve, reject) {
	                // change from nothing to a value, no popup required
	                if (selectedBrokerNumber && !oldBroker) {
	                    return resolve();
	                }
	
	                // modal shown to ask user about if really want to clear the form
	                _this.switchWaitingModal(true, _("areYouSureToClearForm"), _("clearForm"), function () {
	                    var shouldContinue = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	                    if (shouldContinue) {
	                        resolve();
	                    } else {
	                        _this.switchWaitingModal(false);
	                        reject();
	                    }
	                });
	            }).then(function () {
	                //clear form
	                _this.resetForm().then(function () {
	                    // effect the broker change in the sate, after reseting form
	                    _this.setState({ selectedBroker: selectedBroker });
	                });
	            })['catch'](function () {
	                // nothing to do because the confirmation modal canceled the operation by user
	            });
	        };
	
	        this.handleTeamChange = function (tarificationTeam) {
	            _this.setState({ tarificationTeam: tarificationTeam });
	        };
	
	        this.state = _extends({}, permanentState, resetableState, {
	            tarification: props.tarification
	        });
	    }
	
	    _createClass(ClientTarificationCreate, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            //here i need to do a check if the clientOptionsDicts are loaded if not to load them
	            this.initializeBrokerOptions().then(function (brokerOptions) {
	                if (brokerOptions && brokerOptions.length === 1) {
	                    _this2.handleBrokerChange(brokerOptions[0]);
	                }
	            });
	            this.initializeTeams();
	        }
	
	        /**
	         * This function will set state for the broker selector input.
	         * Insert the list of broker like an array contains plain JS objects (label, value).
	         */
	    }, {
	        key: 'initializeBrokerOptions',
	        value: function initializeBrokerOptions() {
	            var _this3 = this;
	
	            var brokers = this.props.brokers;
	
	            var brokerOptions = brokers && Object.keys(brokers).map(function (brokerKey) {
	                return {
	                    value: brokers[brokerKey].brokerNumber,
	                    label: brokers[brokerKey].brokerNumber + " - " + brokers[brokerKey].main.name
	                };
	            });
	
	            return new Promise(function (resolve, reject) {
	                _this3.setState({ brokerOptions: brokerOptions }, function () {
	                    resolve(brokerOptions);
	                });
	            });
	        }
	    }, {
	        key: 'initializeTeams',
	        value: function initializeTeams() {
	            var _this4 = this;
	
	            var _props = this.props;
	            var clientOptionsDict = _props.clientOptionsDict;
	            var appLanguage = _props.appLanguage;
	
	            var rawWillemotTeams = clientOptionsDict ? clientOptionsDict['TEAM_WILLEMOT'] : null;
	            var teams = [];
	            if (rawWillemotTeams) {
	                Object.keys(rawWillemotTeams).forEach(function (key) {
	                    teams.push({
	                        value: key,
	                        label: rawWillemotTeams[key][appLanguage]
	                    });
	                });
	                return new Promise(function (resolve, reject) {
	                    _this4.setState({ willemotTeams: teams }, function () {
	                        resolve(teams);
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'setFieldTouched',
	        value: function setFieldTouched(fieldName) {
	            var validationErrors = this.state.validationErrors;
	
	            if (typeof fieldName == 'string') {
	                _nestedProperty2['default'].set(validationErrors, fieldName + '.touched', true);
	            } else {
	                Object.keys(fieldName).forEach(function (oneFieldName) {
	                    _nestedProperty2['default'].set(validationErrors, oneFieldName + '.touched', true);
	                });
	            }
	
	            this.setState({ validationErrors: validationErrors }, function () {
	                // debug place
	            });
	        }
	    }, {
	        key: 'switchWaitingModal',
	
	        /**
	         * This function handle the waiting modal
	         * @param {bool} show - modal show or hide
	         * @param {string} text - modal content
	         * @param {string} title - modal title
	         * @param {function} waitingModalOkButtonCallback is empty the no button shown, else ok button call
	         */
	
	        value: function switchWaitingModal() {
	            var show = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	            var text = arguments.length <= 1 || arguments[1] === undefined ? "" : arguments[1];
	            var title = arguments.length <= 2 || arguments[2] === undefined ? "" : arguments[2];
	            var waitingModalOkButtonCallback = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	            var waitingModalOkButtonLink = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
	            this.setState({
	                waitingModal: show,
	                waitingModalText: text,
	                waitingModalTitle: title,
	                waitingModalOkButtonCallback: waitingModalOkButtonCallback,
	                waitingModalOkButtonLink: waitingModalOkButtonLink
	            });
	        }
	
	        /**
	         * This function will reset the variable values in the form fields
	        */
	    }, {
	        key: 'resetForm',
	        value: function resetForm() {
	            var _this5 = this;
	
	            return new Promise(function (resolve) {
	                _this5.setState(_extends({}, resetableState), resolve);
	            });
	        }
	
	        /**
	         * This function
	         * @param {*} isConfirmed
	         */
	    }, {
	        key: 'handleCloseModel',
	        value: function handleCloseModel(isConfirmed) {
	            var _this6 = this;
	
	            var _props2 = this.props;
	            var closeModal = _props2.closeModal;
	            var dispatch = _props2.dispatch;
	            var clientId = _props2.clientId;
	
	            if (!isConfirmed) {
	                this.setState(resetableState);
	                return closeModal();
	            }
	
	            // prepare params for api call
	            var createTarificationParams = {};
	            createTarificationParams.clientId = clientId;
	            createTarificationParams.brokerNumber = _nestedProperty2['default'].get(this.state, "selectedBroker.value");
	            createTarificationParams.tarificationTeam = _nestedProperty2['default'].get(this.state, "tarificationTeam.value");
	
	            // call the createCTarification api call
	            dispatch((0, _stateActions.createClientTarification)(createTarificationParams)).then(function (result) {
	                var error = _nestedProperty2['default'].get(result[0], "error");
	                if (error && String(error) !== '0' && String(error) !== '') {
	                    throw error;
	                }
	
	                // show notification modal about error
	                _this6.switchWaitingModal(true, _("createPremSuccessMessage"), _("createPremSuccessTitle"), function () {
	                    var shouldContinue = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	                    _this6.switchWaitingModal(false);
	                    var tarificationNumber = _nestedProperty2['default'].get(result, "tarificationNumber");
	                    var tarificationId = _nestedProperty2['default'].get(result, "tarificationId");
	
	                    _this6.setState({ tarificationId: tarificationId });
	                    _this6.setState({ tarificationNumber: tarificationNumber });
	
	                    dispatch((0, _stateActions.fetchClientTarifications)(clientId)).then(function () {
	                        dispatch((0, _stateActions.fetchClientTarification)(tarificationId)).then(function () {
	                            return _this6.setState({ tarificationDetailLoaded: true }, function () {
	                                dispatch((0, _stateActions.setOpenedSubmenu)(tarificationId));
	                            });
	                        });
	                    });
	
	                    _this6.handleCloseModel(false);
	                });
	            })['catch'](function (err) {
	                var error = _nestedProperty2['default'].get(err, "error");
	                var errorCode = Number(error);
	
	                // if error code not in the list then that is not recognized by the system and set
	                // to the unknown error
	                if ([1, 2, 3, 4].indexOf(errorCode) == -1) {
	                    errorCode = 3;
	                }
	
	                // show notification modal about error
	                _this6.switchWaitingModal(true, _("createPrevErrorMessage" + errorCode), _("createPrevErrorTitle"), function () {
	                    var shouldContinue = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	                    _this6.switchWaitingModal(false);
	                });
	            });
	        }
	    }, {
	        key: 'waitingPopup',
	        value: function waitingPopup() {
	            var _state = this.state;
	            var waitingModalText = _state.waitingModalText;
	            var waitingModalTitle = _state.waitingModalTitle;
	            var waitingModalOkButtonCallback = _state.waitingModalOkButtonCallback;
	            var waitingModal = _state.waitingModal;
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: waitingModal,
	                    style: customStylesForModal,
	                    className: _clientTarificationCreateScss2['default'].modal,
	                    key: "archiveConfirmPopupKey",
	                    contentLabel: ""
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientTarificationCreateScss2['default'].title },
	                    waitingModalTitle
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientTarificationCreateScss2['default'].contentWrapper },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientTarificationCreateScss2['default'].content, key: "formContainerKey" },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientTarificationCreateScss2['default'].whitespacePre },
	                            waitingModalText
	                        ),
	                        waitingModalOkButtonCallback && typeof waitingModalOkButtonCallback == 'function' && _react2['default'].createElement(
	                            'div',
	                            { className: _clientTarificationCreateScss2['default'].buttons, key: "closeModalKey" },
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        return waitingModalOkButtonCallback(false);
	                                    },
	                                    className: _clientTarificationCreateScss2['default'].cancel
	                                },
	                                _("cancel")
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    className: (0, _classnames2['default'])(_clientTarificationCreateScss2['default'].next, _clientTarificationCreateScss2['default'].enabled),
	                                    onClick: function () {
	                                        return waitingModalOkButtonCallback(true);
	                                    }
	                                },
	                                _('ok')
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var _props3 = this.props;
	            var modalIsOpen = _props3.modalIsOpen;
	            var closeModal = _props3.closeModal;
	            var canCreateMifid = _props3.canCreateMifid;
	            var tarificationId = _props3.tarificationId;
	            var _state2 = this.state;
	            var brokerOptions = _state2.brokerOptions;
	            var selectedBroker = _state2.selectedBroker;
	            var hasError = _state2.hasError;
	            var willemotTeams = _state2.willemotTeams;
	            var tarificationTeam = _state2.tarificationTeam;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: closeModal,
	                        style: customStylesForModal,
	                        className: _clientTarificationCreateScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientTarificationCreateScss2['default'].title },
	                        _('createTarificationModalTitle')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientTarificationCreateScss2['default'].contentWrapper, key: 'contentWrapperKey' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientTarificationCreateScss2['default'].content, key: 'formContainerKey' },
	                            _react2['default'].createElement(
	                                'form',
	                                { className: _clientTarificationCreateScss2['default'].form },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientTarificationCreateScss2['default'].inputRow, key: 'brokerNumberKey' },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientTarificationCreateScss2['default'].inputLabel },
	                                        _('brokerNumber')
	                                    ),
	                                    _react2['default'].createElement(_elementsReactSelect2Wrapper2['default'], {
	                                        value: selectedBroker,
	                                        onChange: function (value) {
	                                            return _this7.handleBrokerChange(value);
	                                        },
	                                        options: brokerOptions,
	                                        openMenuOnFocus: true,
	                                        placeholder: '',
	                                        onBlurResetsInput: false,
	                                        isSearchable: true,
	                                        isClearable: true
	                                    })
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientTarificationCreateScss2['default'].inputRow, key: 'willemotTeams' },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: _clientTarificationCreateScss2['default'].inputLabel },
	                                        _('willemotTeams')
	                                    ),
	                                    _react2['default'].createElement(_elementsReactSelect2Wrapper2['default'], {
	                                        value: tarificationTeam,
	                                        onChange: function (value) {
	                                            return _this7.handleTeamChange(value);
	                                        },
	                                        options: willemotTeams,
	                                        openMenuOnFocus: true,
	                                        placeholder: '',
	                                        onBlurResetsInput: false,
	                                        isSearchable: true,
	                                        isClearable: true
	                                    })
	                                ),
	                                _react2['default'].createElement('div', null),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _clientTarificationCreateScss2['default'].buttons, key: "closeModalKey" },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "closeModalCanceKey",
	                                            onClick: function () {
	                                                _this7.handleCloseModel(false);
	                                            },
	                                            className: (0, _classnames2['default'])(_clientTarificationCreateScss2['default'].cancel)
	                                        },
	                                        _("cancel")
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            key: "closeModalConfirmKey",
	                                            onClick: function () {
	                                                if (!hasError) {
	                                                    _this7.handleCloseModel(true);
	                                                } else {
	                                                    _this7.setFieldTouched(fieldsForFill);
	                                                }
	                                            },
	                                            className: (0, _classnames2['default'])(_clientTarificationCreateScss2['default'].next, _clientTarificationCreateScss2['default'].enabled)
	                                        },
	                                        _("confirm")
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                this.waitingPopup()
	            );
	        }
	    }]);
	
	    var _ClientTarificationCreate = ClientTarificationCreate;
	    ClientTarificationCreate = (0, _reactRedux.connect)(function (state) {
	        var clientAccess = state.app.security.actions;
	        var canCreateMifid = false;
	        var clientOptionsDict = state.client.clientOptionsDict;
	        var appLanguage = state.app.lang;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createmifid') {
	                canCreateMifid = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        return {
	            security: state.app.security,
	            brokers: state.office.brokers,
	            canCreateMifid: canCreateMifid,
	            clientOptionsDict: clientOptionsDict,
	            appLanguage: appLanguage
	        };
	    })(ClientTarificationCreate) || ClientTarificationCreate;
	    return ClientTarificationCreate;
	})(_react2['default'].Component);
	
	exports['default'] = ClientTarificationCreate;
	module.exports = exports['default'];

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactRedux = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _clientTarificationsScss = __webpack_require__(1603);
	
	var _clientTarificationsScss2 = _interopRequireDefault(_clientTarificationsScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _libHelpers = __webpack_require__(24);
	
	var _clientTarificationsZoom = __webpack_require__(1090);
	
	var _clientTarificationsZoom2 = _interopRequireDefault(_clientTarificationsZoom);
	
	var _clientTarificationCreate = __webpack_require__(1088);
	
	var _clientTarificationCreate2 = _interopRequireDefault(_clientTarificationCreate);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _stateConstants = __webpack_require__(11);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var c = _interopRequireWildcard(_stateConstants);
	
	var _ = (0, _libI18n2['default'])('clientTarification');
	
	/**
	 * This method can render the table for tarification overview
	 * @param {*} props
	 * @returns
	 */
	var Results = function Results(props) {
	    var data = props.data;
	    var zoomTo = props.zoomTo;
	    var /* setState, */canCreateTarification = props.canCreateTarification;
	    var canCreateMifid = props.canCreateMifid;
	    var clientId = props.clientId;
	    var dispatch = props.dispatch;
	    var refreshTarifications = props.refreshTarifications;
	    var moduleOptions = props.moduleOptions;
	
	    var topPaginationElem = [];
	
	    /* if(canCreateTarification) {
	        topPaginationElem.push(
	            <input type='button'
	                key={'createTarificationModalOpenerButtonKey'}
	                onClick={() => {
	                    setState({createTarificationModalIsOpen: true})
	                }}
	                className={styles.buttonGreen}
	                value={_('request')}
	            />
	        )
	    } */
	
	    if (canCreateTarification) {
	        topPaginationElem.push(_react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
	            moduleKeyToSet: _stateConstants.DS_MODULE_CLIENT_TARIFICATION,
	            clientId: clientId,
	            callBackOnClose: function (clientId, tarificationId) {
	                refreshTarifications(clientId).then(function () {
	                    dispatch((0, _stateActions.setAppModule)(c.CLIENTS, clientId));
	                    dispatch((0, _stateActions.setOpenedSubmenu)(tarificationId, {}));
	                    dispatch((0, _stateActions.setClientSubModule)('tarification'));
	                });
	            },
	            buttonText: _('request'),
	            customModalTitle1: _('tarificationWizardStep1Title'),
	            customModalTitle2: _('tarificationWizardStep2Title'),
	            customModalTitle3: _('tarificationWizardStep3Title'),
	            customModalDescriptionStep1: _('tarificationWizardStep1Description'),
	            customModalDescriptionStep2: _('tarificationWizardStep2Description'),
	            customModalDescriptionStep3: _('tarificationWizardStep3Description'),
	            moduleOptions: moduleOptions
	        }));
	    }
	
	    var tableData = data || [];
	
	    return _react2['default'].createElement(
	        'div',
	        { key: "tarificationTableContainerDiv" },
	        _react2['default'].createElement(
	            _componentsReactable.Table,
	            {
	                itemsPerPage: 10,
	                filterable: ['tarificationNumber', 'group', 'descriptionRisico', 'tarificationState', 'requestDate'],
	                sortable: [{ column: 'requestDate', sortFunction: 'Date' }, 'tarificationNumber', 'mainGroup', 'descriptionRisico', 'tarificationState'],
	                topPaginationElemR: topPaginationElem,
	                defaultSort: {
	                    //column: 'sentDate',
	                    column: 'requestDate',
	                    sortFunction: 'Date',
	                    direction: 'desc'
	                }
	            },
	            _react2['default'].createElement(
	                _componentsReactable.Thead,
	                { key: "tHeadOfTarifListKey" },
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'tarificationNumber', key: "tarificationNumberKey" },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('tarificationNumber')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'mainGroup', key: "mainGroupKey" },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('mainGroup')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'descriptionRisico', key: "descriptionRisicoKey" },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('descriptionRisico')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'requestDate', key: "requestDateKey" },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('requestDate')
	                    )
	                ),
	                _react2['default'].createElement(
	                    _componentsReactable.Th,
	                    { column: 'tarificationState', key: "tarificationStateKey" },
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        _('tarificationState')
	                    )
	                )
	            ),
	            tableData && tableData.map(function (item, key) {
	                var tarificationMain = item.tarificationMain;
	                return _react2['default'].createElement(
	                    _componentsReactable.Tr,
	                    { className: 'centered clickable',
	                        key: key, onClick: function () {
	                            return zoomTo(tarificationMain.tarificationId);
	                        }
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'tarificationNumber' },
	                        tarificationMain.tarificationNumber
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'mainGroup' },
	                        tarificationMain.mainGroup
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'descriptionRisico' },
	                        tarificationMain.descriptionRisico
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'requestDate', value: (0, _moment2['default'])(tarificationMain.requestDate) },
	                        (0, _moment2['default'])(tarificationMain.requestDate).format('DD-MM-YYYY')
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Td,
	                        { column: 'tarificationState' },
	                        tarificationMain.tarificationState
	                    )
	                );
	            })
	        ),
	        (!tableData || tableData.length === 0) && _react2['default'].createElement(_noResults2['default'], { type: 'clientTarification' })
	    );
	};
	
	/**
	 * Tarification overview module
	 */
	
	var ClientTarifications = (function (_React$Component) {
	    _inherits(ClientTarifications, _React$Component);
	
	    function ClientTarifications(props) {
	        _classCallCheck(this, _ClientTarifications);
	
	        _get(Object.getPrototypeOf(_ClientTarifications.prototype), 'constructor', this).call(this, props);
	        this.state = { initializationCompleted: false, tarificationsLoaded: false, createTarificationModalIsOpen: false, tarificationDetailLoaded: false };
	    }
	
	    _createClass(ClientTarifications, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var clientId = this.props.clientId;
	
	            this.refreshTarifications(clientId);
	        }
	
	        /**
	         * This function will refresh the list of tarifications in store and return with a promise
	         * @param {*} clientId
	         * @returns Promise
	         */
	    }, {
	        key: 'refreshTarifications',
	        value: function refreshTarifications(clientId) {
	            var _this = this;
	
	            var dispatch = this.props.dispatch;
	
	            return new Promise(function (resolve, reject) {
	                // load tarifications
	                _this.setState({ tarificationsLoaded: false }, function () {
	                    dispatch((0, _stateActions.fetchClientTarifications)(clientId)).then(function () {
	                        _this.setState({ tarificationsLoaded: true }, function () {
	                            resolve();
	                        });
	                    })['catch'](function () {
	                        _this.setState({ tarificationsLoaded: true }, function () {
	                            resolve();
	                        });
	                    });
	                });
	            });
	        }
	
	        /**
	         * Triggered before update the module.
	         * @param {object} nextProps
	         * @param {object} nextState
	         */
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            var _this2 = this;
	
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var clientId = _props.clientId;
	            var tarificationId = _props.tarificationId;
	            var tarificationDetailLoaded = this.state.tarificationDetailLoaded;
	
	            // on clear opened tarification we must reload tarification list
	            if (!nextProps.tarificationId && tarificationId) {
	                this.setState({ tarificationsLoaded: false }, function () {
	                    dispatch((0, _stateActions.fetchClientTarifications)(clientId)).then(function () {
	                        _this2.setState({ tarificationsLoaded: true });
	                    })['catch'](function () {
	                        _this2.setState({ tarificationsLoaded: true });
	                    });
	                });
	            }
	
	            if (!tarificationDetailLoaded && tarificationId || nextProps.tarificationId && nextProps.tarificationId !== tarificationId) {
	                return dispatch((0, _stateActions.fetchClientTarification)(nextProps.tarificationId)).then(function () {
	                    return _this2.setState({ tarificationDetailLoaded: true });
	                });
	            }
	
	            this.navigateToTarificationFromSearch();
	        }
	
	        /**
	         * This function vill zoom to tarifican if client search is made by tarification number
	         */
	    }, {
	        key: 'navigateToTarificationFromSearch',
	        value: function navigateToTarificationFromSearch() {
	            var _props2 = this.props;
	            var subModuleZoom = _props2.subModuleZoom;
	            var tarifications = _props2.tarifications;
	            var tarificationDetailLoaded = this.state.tarificationDetailLoaded;
	
	            if (!tarificationDetailLoaded && subModuleZoom && tarifications) {
	                var openedTarificationFromSearc = tarifications.find(function (tarification) {
	                    return tarification.tarificationMain.tarificationNumber.includes(subModuleZoom);
	                });
	                if (openedTarificationFromSearc) {
	                    this.zoomTo(openedTarificationFromSearc.tarificationMain.tarificationId);
	                }
	            }
	        }
	
	        /**
	         * Used to get and open tarification details
	         * @param {string} tarificationId
	         * @returns
	         */
	    }, {
	        key: 'zoomTo',
	        value: function zoomTo(tarificationId) {
	            this.getTarification(tarificationId);
	        }
	    }, {
	        key: 'getTarification',
	        value: function getTarification(tarificationId) {
	            var _this3 = this;
	
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _stateActions.fetchClientTarification)(tarificationId)).then(function () {
	                return _this3.setState({ tarificationDetailLoaded: true }, function () {
	                    dispatch((0, _stateActions.setOpenedSubmenu)(tarificationId));
	                });
	            });
	        }
	
	        /**
	        * This function return with values for email sender, collected from this module
	        * depending on the current data structure.
	        */
	    }, {
	        key: 'collectVariableValues',
	        value: function collectVariableValues() {
	            var _props3 = this.props;
	            var clientData = _props3.clientData;
	            var clientId = _props3.clientId;
	            var tarification = _props3.tarification;
	            var tarificationId = _props3.tarificationId;
	            var clientOptionsDict = this.state.clientOptionsDict;
	
	            var tarificationBrokerNumber = _nestedProperty2['default'].get(tarification, "brokerNumber");
	            var emails = _nestedProperty2['default'].get(clientData, "detail.emails");
	            var clientName = _nestedProperty2['default'].get(clientData, "main.name");
	
	            // process email list to be digestible for email sender
	            emails = emails.map(function (item) {
	                return {
	                    referenceId: clientId,
	                    label: clientName,
	                    value: item.email,
	                    'default': item['default'] == "true" || item['default'] == true ? true : false
	                };
	            });
	
	            emails = emails.sort(function (item, item2) {
	                if (item['default'] && !item2['default']) {
	                    return -1;
	                }
	                if (!item['default'] && item2['default']) {
	                    return 1;
	                }
	                if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                    return 0;
	                }
	            }) || [];
	
	            // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
	            var clientLanguage = _nestedProperty2['default'].get(clientData, "detail.language") || '';
	            clientLanguage = (0, _libHelpers.getTheLanguageCodeByAnyLanguageOnAnyLanguage)(clientLanguage, clientOptionsDict);
	
	            return {
	                tarificationNumber: _nestedProperty2['default'].get(this.props, 'tarification.tarificationNumber'),
	
	                clientDocuments: _nestedProperty2['default'].get(clientData, "clientDocuments"),
	                clientDocumentsType: 'client',
	                clientDocumentsId: clientId,
	
	                tarificationDocuments: _nestedProperty2['default'].get(this.props, "tarification.tarificationDocuments"),
	                tarificationDocumentsType: "tarification",
	                tarificationDocumentsId: tarificationId,
	
	                clientId: false,
	                contractId: false,
	                claimId: false,
	                tarificationId: tarificationId,
	                clientName: clientName,
	                clientNumber: _nestedProperty2['default'].get(clientData, "main.clientNumber"),
	                clientLanguage: clientLanguage,
	                clientEmails: emails,
	
	                brokerNumber: tarificationBrokerNumber,
	
	                tarificationDetail: tarification,
	                clientData: _nestedProperty2['default'].get(clientData, "main")
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props4 = this.props;
	            var tarifications = _props4.tarifications;
	            var tarification = _props4.tarification;
	            var tarificationId = _props4.tarificationId;
	            var canCreateTarification = _props4.canCreateTarification;
	            var clientData = _props4.clientData;
	            var clientId = _props4.clientId;
	            var canCreateMifid = _props4.canCreateMifid;
	            var dispatch = _props4.dispatch;
	            var _state = this.state;
	            var createTarificationModalIsOpen = _state.createTarificationModalIsOpen;
	            var createContractState = _state.createContractState;
	
	            var selectedTarificationDetails = null;
	
	            if (tarifications && tarificationId) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = tarifications[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var t = _step.value;
	
	                        if (t.tarificationMain.tarificationId === tarificationId) {
	                            selectedTarificationDetails = tarification;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator['return']) {
	                            _iterator['return']();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientTarificationsScss2['default'].moduleSection },
	                    !selectedTarificationDetails ? _react2['default'].createElement(Results, _extends({}, this.props, {
	                        canCreateTarification: canCreateTarification,
	                        data: tarifications || [],
	                        zoomTo: function (tarification) {
	                            _this4.zoomTo(tarification);
	                        },
	                        setState: function (paramForSetState) {
	                            return _this4.setState(paramForSetState);
	                        },
	                        canCreateMifid: canCreateMifid,
	                        clientId: clientId,
	                        refreshTarifications: function (clientId) {
	                            return _this4.refreshTarifications(clientId);
	                        },
	                        moduleOptions: this.collectVariableValues()
	                    })) : _react2['default'].createElement(
	                        'div',
	                        { className: _clientTarificationsScss2['default'].clientTarificationsZoomContainer },
	                        _react2['default'].createElement(_clientTarificationsZoom2['default'], {
	                            tarification: selectedTarificationDetails,
	                            clientData: clientData,
	                            clientId: clientId,
	                            tarificationId: String(tarificationId),
	                            createContractState: createContractState,
	                            dispatch: dispatch,
	                            _translationFromOverview: _,
	                            canCreateTarification: canCreateTarification
	                        })
	                    )
	                ),
	                _react2['default'].createElement(_clientTarificationCreate2['default'], {
	                    modalIsOpen: createTarificationModalIsOpen,
	                    tarification: {
	                        tarificationId: '',
	                        tarificationNumber: '',
	                        error: '0',
	                        errorString: 'This is the error string'
	                    },
	                    clientId: clientId,
	                    closeModal: function () {
	                        return _this4.setState({ createTarificationModalIsOpen: false });
	                    },
	                    tarificationId: tarificationId,
	                    policyHolder: _nestedProperty2['default'].get(clientData, "main.name") || ""
	                })
	            );
	        }
	    }]);
	
	    var _ClientTarifications = ClientTarifications;
	    ClientTarifications = (0, _reactRedux.connect)(function (state) {
	        var clientId = state.app.opened;
	        var clientData = state.clients.clientData ? state.clients.clientData[clientId] : null;
	        var tarifications = state.clients.tarifications[clientId] ? state.clients.tarifications[clientId] : null;
	        var tarificationId = state.app.submenuOpened;
	        var tarification = state.client.tarificationDetail;
	        var subModuleZoom = _nestedProperty2['default'].get(state, 'clients.subModuleZoom.tarificationNumber');
	        var clientAccess = _nestedProperty2['default'].get(state, "app.security.actions");
	        var canCreateMifid = false;
	        var canCreateTarification = false;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createmifid') {
	                canCreateMifid = item.actionAllowed === "true" || item.actionAllowed === true ? true : false;
	            }
	
	            if (item.actionName == 'createTarification') {
	                canCreateTarification = item.actionAllowed === "true" || item.actionAllowed === true ? true : false;
	            }
	        });
	
	        return {
	            tarification: tarification,
	            tarifications: tarifications,
	            canCreateTarification: canCreateTarification,
	            tarificationId: tarificationId,
	            clientId: clientId,
	            clientData: clientData,
	            canCreateMifid: canCreateMifid,
	            subModuleZoom: subModuleZoom,
	            clientOptionsDict: state.client.clientOptionsDict
	        };
	    })(ClientTarifications) || ClientTarifications;
	    return ClientTarifications;
	})(_react2['default'].Component);
	
	exports['default'] = ClientTarifications;
	module.exports = exports['default'];

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactRedux = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _emailSenderEmailButton = __webpack_require__(108);
	
	var _emailSenderEmailButton2 = _interopRequireDefault(_emailSenderEmailButton);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _clientTarificationsZoomScss = __webpack_require__(1604);
	
	var _clientTarificationsZoomScss2 = _interopRequireDefault(_clientTarificationsZoomScss);
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _uploader = __webpack_require__(143);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _stateActions = __webpack_require__(5);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libHelpers = __webpack_require__(24);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _clientContractCreate = __webpack_require__(366);
	
	var _clientContractCreate2 = _interopRequireDefault(_clientContractCreate);
	
	var _stateConstants = __webpack_require__(11);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ = (0, _libI18n2['default'])('clientTarificationsZoom');
	
	var ClientTarificationsZoom = (function (_React$Component) {
	    _inherits(ClientTarificationsZoom, _React$Component);
	
	    _createClass(ClientTarificationsZoom, null, [{
	        key: 'propTypes',
	        value: {
	            _translationFromOverview: _react2['default'].PropTypes.object,
	            canCreateTarification: _react2['default'].PropTypes.bool
	        },
	        enumerable: true
	    }]);
	
	    function ClientTarificationsZoom(props) {
	        var _this = this;
	
	        _classCallCheck(this, _ClientTarificationsZoom);
	
	        _get(Object.getPrototypeOf(_ClientTarificationsZoom.prototype), 'constructor', this).call(this, props);
	
	        this.handleClose = function () {
	            var dispatch = _this.props.dispatch;
	
	            dispatch((0, _stateActions.setOpenedSubmenu)(''));
	        };
	
	        this.state = {
	            createContractModalIsOpen: false
	        };
	    }
	
	    /**
	     * Event for close claim. Back to list.
	     */
	
	    _createClass(ClientTarificationsZoom, [{
	        key: 'collectVariableValues',
	
	        /**
	        * This function return with values for email sender, collected from this module
	        * depending on the current data structure.
	        */
	        value: function collectVariableValues() {
	            var _props = this.props;
	            var clientData = _props.clientData;
	            var clientId = _props.clientId;
	            var tarification = _props.tarification;
	            var tarificationId = _props.tarificationId;
	            var clientOptionsDict = _props.clientOptionsDict;
	
	            var tarificationBrokerNumber = _nestedProperty2['default'].get(tarification, "brokerNumber");
	            var emails = _nestedProperty2['default'].get(clientData, "detail.emails");
	            var clientName = _nestedProperty2['default'].get(clientData, "main.name");
	
	            // process email list to be digestible for email sender
	            emails = emails.map(function (item) {
	                return {
	                    referenceId: clientId,
	                    label: clientName,
	                    value: item.email,
	                    'default': item['default'] == "true" || item['default'] == true ? true : false
	                };
	            });
	
	            emails = emails.sort(function (item, item2) {
	                if (item['default'] && !item2['default']) {
	                    return -1;
	                }
	                if (!item['default'] && item2['default']) {
	                    return 1;
	                }
	                if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                    return 0;
	                }
	            }) || [];
	
	            // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
	            var clientLanguage = _nestedProperty2['default'].get(clientData, "detail.language") || '';
	            clientLanguage = (0, _libHelpers.getTheLanguageCodeByAnyLanguageOnAnyLanguage)(clientLanguage, clientOptionsDict);
	
	            return {
	                tarificationNumber: _nestedProperty2['default'].get(this.props, 'tarification.tarificationNumber'),
	
	                clientDocuments: _nestedProperty2['default'].get(clientData, "clientDocuments"),
	                clientDocumentsType: 'client',
	                clientDocumentsId: clientId,
	
	                tarificationDocuments: _nestedProperty2['default'].get(this.props, "tarification.tarificationDocuments"),
	                tarificationDocumentsType: "tarification",
	                tarificationDocumentsId: tarificationId,
	
	                clientId: false,
	                contractId: false,
	                claimId: false,
	                tarificationId: tarificationId,
	                clientName: clientName,
	                clientNumber: _nestedProperty2['default'].get(clientData, "main.clientNumber"),
	                clientLanguage: clientLanguage,
	                clientEmails: emails,
	
	                brokerNumber: tarificationBrokerNumber,
	
	                tarificationDetail: tarification,
	                clientData: _nestedProperty2['default'].get(clientData, "main")
	            };
	        }
	
	        /**
	        * Resets ticket data from store in order to prevent multiple additions to dsWizzard
	        */
	    }, {
	        key: 'resetDataFromStoreOnCancel',
	        value: function resetDataFromStoreOnCancel() {
	            var _props2 = this.props;
	            var dispatch = _props2.dispatch;
	            var ticketId = _props2.ticketId;
	            var tarificationId = _props2.tarificationId;
	
	            //reset aditional data fro tickets
	            if (ticketId) {
	                dispatch((0, _stateActions.setOpenedSubmenu)(tarificationId, {}));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props;
	            var clientAccess = _props3.clientAccess;
	            var clientId = _props3.clientId;
	            var tarificationId = _props3.tarificationId;
	            var tarification = _props3.tarification;
	            var dispatch = _props3.dispatch;
	            var initializationCompleted = _props3.initializationCompleted;
	            var canCreateMifid = _props3.canCreateMifid;
	            var _translationFromOverview = _props3._translationFromOverview;
	            var canCreateTarification = _props3.canCreateTarification;
	            var selectedTicketDocuments = _props3.selectedTicketDocuments;
	            var ticketDocuments = _props3.ticketDocuments;
	            var ticketId = _props3.ticketId;
	            var emailAttachmentTicketDocuments = _props3.emailAttachmentTicketDocuments;
	            var canCreatePrev = _props3.canCreatePrev;
	            var clientData = _props3.clientData;
	            var createContractModalIsOpen = this.state.createContractModalIsOpen;
	
	            var tarificationNumber = tarification.tarificationNumber;
	            var team = tarification.team || '';
	            var teamName = tarification.teamName || '';
	
	            if (!tarification || !tarificationNumber) {
	                return _react2['default'].createElement(
	                    'span',
	                    null,
	                    '...'
	                );
	            }
	
	            var dateOfRequest = tarification.requestDate;
	            if (dateOfRequest && (0, _moment2['default'])(dateOfRequest).isValid()) {
	                dateOfRequest = (0, _moment2['default'])(dateOfRequest).format("DD-MM-YYYY");
	            }
	
	            var createmail = clientAccess && clientAccess.filter(function (item) {
	                return item.actionName == "createmail" && item.actionAllowed == "true";
	            }).length > 0;
	
	            /* const columns = tarification && [
	                [
	                    {label: _('tarificationNumber'), value: tarification.tarificationNumber || '-'},
	                    {label: _('tarificationState'), value: tarification.tarificationState || '-'},
	                    {label: _('tarificationType'), value: tarification.tarificationType || '-'},
	                    {label: _('maingroupCode'), value: tarification.maingroupCode || '-'},
	                    {label: _('subgroupCode'), value: tarification.subgroupCode || '-'},
	                    {label: _('subgroupDescription'), value: tarification.subgroupDescription || '-'},
	                ],
	                [
	                    {label: _('descriptionRisico'), value: tarification.descriptionRisico || '-'},
	                    {label: _('companies'), value: tarification.companies || '-'},
	                    {label: _('requestDate'), value: tarification.requestDate || '-'},
	                    {label: _('brokerNumber'), value: tarification.brokerNumber || '-'},
	                    {label: _('brokerName'), value: tarification.brokerName || '-'},
	                ],
	            ] */
	
	            var columns = tarification && [[{ label: _('groupDescriptions'), value: tarification.maingroupDescription + " - " + tarification.subgroupDescription }, { label: _('companies'), value: tarification.companies || '-' }, { label: _('descriptionRisico'), value: tarification.descriptionRisico || '-' }], [{ label: _('requestDate'), value: dateOfRequest || '-' }, { label: _('tarificationState'), value: tarification.tarificationState || '-' }, { label: _('broker'), value: [tarification.brokerNumber, tarification.brokerName].join(" ") || '-' }]];
	
	            var moduleKeyToSet = _nestedProperty2['default'].get(this.props, "EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value") || false;
	            var documents = tarification.tarificationDocuments;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _clientTarificationsZoomScss2['default'].clientTarificationsZoomContainer },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientTarificationsZoomScss2['default'].mainTitleDiv },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientTarificationsZoomScss2['default'].moduleControls },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientTarificationsZoomScss2['default'].buttonOrganizer },
	                            _react2['default'].createElement(
	                                'div',
	                                { onClick: function () {
	                                        return dispatch((0, _stateActions.setOpenedSubmenu)(''));
	                                    }, className: _clientTarificationsZoomScss2['default'].backToList },
	                                _('backToTarifications')
	                            ),
	                            createmail && _react2['default'].createElement(_emailSenderEmailButton2['default'], { moduleKeyToSet: moduleKeyToSet, moduleOptions: this.collectVariableValues() }),
	                            canCreateTarification && _react2['default'].createElement(
	                                'div',
	                                { className: _clientTarificationsZoomScss2['default'].DSWizardButtonWrapper },
	                                _react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
	                                    moduleKeyToSet: _stateConstants.DS_MODULE_CLIENT_TARIFICATION,
	                                    subModuleKeyToSet: _stateConstants.DS_MODULE_CLIENT_TARIFICATION,
	                                    clientId: clientId,
	                                    callBackOnClose: function () {
	                                        return _this2.resetDataFromStoreOnCancel();
	                                    },
	                                    moduleOptions: this.collectVariableValues(),
	                                    selectedTicketDocuments: selectedTicketDocuments,
	                                    ticketDocuments: ticketDocuments,
	                                    ticketId: ticketId,
	                                    emailAttachmentTicketDocuments: emailAttachmentTicketDocuments,
	                                    tarificationId: tarificationId,
	                                    tarificationNumber: tarificationNumber
	                                })
	                            ),
	                            canCreatePrev && _react2['default'].createElement(
	                                'div',
	                                { className: _clientTarificationsZoomScss2['default'].createPrevButtonContainer },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        key: "createContractModalOpenerButtonKey",
	                                        onClick: function () {
	                                            _this2.setState({ createContractModalIsOpen: true });
	                                        },
	                                        type: 'button',
	                                        className: _clientTarificationsZoomScss2['default'].prevButton
	                                    },
	                                    _('requestForOffer')
	                                )
	                            )
	                        )
	                    )
	                ),
	                tarification && _react2['default'].createElement(
	                    'div',
	                    { className: _clientTarificationsZoomScss2['default'].clientOfferZoom },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _clientTarificationsZoomScss2['default'].moduleSection },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _clientTarificationsZoomScss2['default'].moduleSectionHeading },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: _clientTarificationsZoomScss2['default'].subTitle },
	                                _('tarificationNumber'),
	                                ' ',
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    (0, _libHelpers.trimCharacterFromLeft)(tarificationNumber, "0")
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(_KeyValue2['default'], { array: columns, divider: true, customClass: _clientTarificationsZoomScss2['default'].keyValuePairCorrection })
	                    )
	                ),
	                documents && _react2['default'].createElement(_uploader2['default'], {
	                    type: 'tarification',
	                    documents: documents,
	                    id: tarificationId,
	                    clientId: clientId
	                }),
	                _react2['default'].createElement(_clientContractCreate2['default'], {
	                    modalIsOpen: createContractModalIsOpen,
	                    contract: {
	                        contractId: '',
	                        contractNumber: '',
	                        error: '0', //  0 = No error / 1 = Error creating contract
	                        errorString: 'This is the error string'
	                    },
	                    isPrem: false,
	                    closeModal: function () {
	                        return _this2.setState({ createContractModalIsOpen: false });
	                    },
	                    clientId: clientId,
	                    policyHolder: _nestedProperty2['default'].get(clientData, "main.name") || "",
	                    tarificationNumber: tarificationNumber
	                })
	            );
	        }
	    }]);
	
	    var _ClientTarificationsZoom = ClientTarificationsZoom;
	    ClientTarificationsZoom = (0, _reactRedux.connect)(function (state, props) {
	        var clientAccess = _nestedProperty2['default'].get(state, "app.security.actions");
	        var canCreateMifid = false;
	        var selectedTicketDocuments = _nestedProperty2['default'].get(state, "clients.initialArguments.selectedTicketDocuments");
	        var ticketDocuments = _nestedProperty2['default'].get(state, "clients.initialArguments.ticketDocuments");
	        var ticketId = _nestedProperty2['default'].get(state, "clients.initialArguments.ticketId");
	        var emailAttachmentTicketDocuments = _nestedProperty2['default'].get(state, "clients.initialArguments.emailAttachmentTicketDocuments");
	
	        var canCreatePrev = clientAccess.filter(function (item) {
	            return item.actionName === "createPrev" && item.actionAllowed === "true";
	        }).length > 0;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createmifid') {
	                canCreateMifid = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        return {
	            EmailTemplateRelations: state.app.security.EmailTemplateRelations,
	            clientAccess: clientAccess,
	            brNr: state.app.brNr,
	            clientData: props && props.clientData || {},
	            clientId: props && props.clientId || '',
	            clientOptionsDict: state.client.clientOptionsDict,
	            contractManagerMail: state.contracts.contractManagerMail,
	            appLanguage: state.app.lang,
	            canCreateMifid: canCreateMifid,
	            selectedTicketDocuments: selectedTicketDocuments,
	            ticketDocuments: ticketDocuments,
	            ticketId: ticketId,
	            emailAttachmentTicketDocuments: emailAttachmentTicketDocuments,
	            canCreatePrev: canCreatePrev
	        };
	    })(ClientTarificationsZoom) || ClientTarificationsZoom;
	    return ClientTarificationsZoom;
	})(_react2['default'].Component);
	
	exports['default'] = ClientTarificationsZoom;
	module.exports = exports['default'];

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _libHelpers = __webpack_require__(24);
	
	var _lodashLang = __webpack_require__(78);
	
	var _clientFinancesScss = __webpack_require__(717);
	
	var _clientFinancesScss2 = _interopRequireDefault(_clientFinancesScss);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clientFinances');
	
	var ClientTransactionsDom = function ClientTransactionsDom(_ref) {
		var items = _ref.items;
		return _react2['default'].createElement(
			'div',
			{ className: 'transContainer' },
			_react2['default'].createElement(
				_componentsReactable.Table,
				{
					itemsPerPage: 30,
					filterable: ['paymentReference', 'invoiceNumber', 'transactionDate', 'transactionType', 'returnReason', 'collectType', 'companyNumber', 'productionNumber', 'transactionContract', 'transactionRisk', 'transactionDateFrom', 'transactionDateUntil', 'amount', 'reminder']
				},
				_react2['default'].createElement(
					_componentsReactable.Thead,
					null,
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'paymentReference' },
						_react2['default'].createElement(
							'span',
							null,
							_('paymentReference')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'invoiceNumber' },
						_react2['default'].createElement(
							'span',
							null,
							_('invoiceNumber')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'transactionDate' },
						_react2['default'].createElement(
							'span',
							null,
							_('transactionDate')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'transactionType' },
						_react2['default'].createElement(
							'span',
							null,
							_('transactionType')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'returnReason' },
						_react2['default'].createElement(
							'span',
							null,
							_('returnReason')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'collectType' },
						_react2['default'].createElement(
							'span',
							null,
							_('collectType')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'companyNumber' },
						_react2['default'].createElement(
							'span',
							null,
							_('companyNumber')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'productionNumber' },
						_react2['default'].createElement(
							'span',
							null,
							_('productionNumber')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'transactionContract' },
						_react2['default'].createElement(
							'span',
							null,
							_('transactionContract')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'transactionRisk' },
						_react2['default'].createElement(
							'span',
							null,
							_('transactionRisk')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'transactionDateFrom' },
						_react2['default'].createElement(
							'span',
							null,
							_('transactionDateFrom')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'transactionDateUntil' },
						_react2['default'].createElement(
							'span',
							null,
							_('transactionDateUntil')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'amount' },
						_react2['default'].createElement(
							'span',
							null,
							_('amount')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'reminder' },
						_react2['default'].createElement(
							'span',
							null,
							_('reminder')
						)
					)
				),
				items && items.map(function (r, key) {
					return _react2['default'].createElement(
						_componentsReactable.Tr,
						{ key: key, className: (0, _classnames2['default'])(r.lineType === 'T' && _clientFinancesScss2['default'].tType, 'centered') },
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'paymentReference' },
							r.paymentReference
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'invoiceNumber' },
							r.invoiceNumber
						),
						_react2['default'].createElement(_componentsReactable.Td, { column: 'transactionDate', data: (0, _libHelpers.dateFormatter)(r.transactionDate) }),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'transactionType' },
							r.transactionType
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'returnReason' },
							r.returnReason
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'collectType' },
							r.collectType
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'companyNumber' },
							r.companyNumber
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'productionNumber' },
							r.productionNumber
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'transactionContract' },
							r.transactionContract
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'transactionRisk' },
							r.transactionRisk
						),
						_react2['default'].createElement(_componentsReactable.Td, { column: 'transactionDateFrom', data: (0, _libHelpers.dateFormatter)(r.transactionDateFrom) }),
						_react2['default'].createElement(_componentsReactable.Td, { column: 'transactionDateUntil', data: (0, _libHelpers.dateFormatter)(r.transactionDateUntil) }),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'amount' },
							r.amount
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'reminder' },
							r.reminder && _(r.reminder)
						)
					);
				})
			),
			items && items.length === 0 && _react2['default'].createElement(_noResults2['default'], { type: 'transactions' })
		);
	};
	ClientTransactionsDom.propTypes = {
		items: _react2['default'].PropTypes.array
	};
	
	exports['default'] = ClientTransactionsDom;
	module.exports = exports['default'];

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _clientZoomScss = __webpack_require__(1605);
	
	var _clientZoomScss2 = _interopRequireDefault(_clientZoomScss);
	
	var _clientProfile = __webpack_require__(1084);
	
	var _clientProfile2 = _interopRequireDefault(_clientProfile);
	
	var _clientProfileEdit = __webpack_require__(1085);
	
	var _clientProfileEdit2 = _interopRequireDefault(_clientProfileEdit);
	
	var _clientContracts = __webpack_require__(1082);
	
	var _clientContracts2 = _interopRequireDefault(_clientContracts);
	
	var _clientContractCreate = __webpack_require__(366);
	
	var _clientContractCreate2 = _interopRequireDefault(_clientContractCreate);
	
	var _clientFinances = __webpack_require__(1083);
	
	var _clientFinances2 = _interopRequireDefault(_clientFinances);
	
	var _clientClaims = __webpack_require__(1080);
	
	var _clientClaims2 = _interopRequireDefault(_clientClaims);
	
	var _clientTarifications = __webpack_require__(1089);
	
	var _clientTarifications2 = _interopRequireDefault(_clientTarifications);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clientZoom');
	
	var customStyles = {
		overlay: {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: 'rgba(255, 255, 255, 0.75)',
			zIndex: 2
		},
		content: {
			position: 'relative',
			top: 'initial',
			bottom: 'initial',
			left: 'initial',
			right: 'initial',
			maxHeight: '90%',
			overflow: 'auto',
			padding: '1em'
		}
	};
	
	// This relies on object iteration being specified-order, which it normally is
	var SubNav = function SubNav(_ref) {
		var currentId = _ref.currentId;
		var items = _ref.items;
		var onChange = _ref.onChange;
		return _react2['default'].createElement(
			'div',
			{ className: '' + _clientZoomScss2['default'].headingDiv },
			Object.keys(items).map(function (moduleId) {
				return _react2['default'].createElement(
					'div',
					{
						key: moduleId,
						className: _clientZoomScss2['default'].headingCell + ' info ' + (currentId === moduleId ? '' + _clientZoomScss2['default'].active : ''),
						onClick: function () {
							return onChange(moduleId);
						}
					},
					items[moduleId]
				);
			})
		);
	};
	
	var ClientZoom = (function (_React$Component) {
		_inherits(ClientZoom, _React$Component);
	
		_createClass(ClientZoom, null, [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				subModule: _react2['default'].PropTypes.string,
				subModuleZoom: _react2['default'].PropTypes.object,
				clientId: _react2['default'].PropTypes.string.isRequired,
				data: _react2['default'].PropTypes.object,
				clientContracts: _react2['default'].PropTypes.array,
				isPhone: _react2['default'].PropTypes.bool,
				clientOptionsDict: _react2['default'].PropTypes.object,
				lang: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		function ClientZoom(props) {
			var _this = this;
	
			_classCallCheck(this, _ClientZoom);
	
			_get(Object.getPrototypeOf(_ClientZoom.prototype), 'constructor', this).call(this, props);
	
			this.handleClose = function () {
				var clientProfileStatus = _this.props.clientProfileForm.formStatus.sent;
				var isSetOpenedMode = _this.state.isSetOpenedMode;
	
				if (clientProfileStatus == false && _this.props.subModule == 'edit-profile') {
					_this.setState({ isSetOpenedMode: true });
					_this.openModal();
				} else {
					_this.props.dispatch((0, _stateActions.setOpened)());
				}
			};
	
			this.state = { modalIsOpen: false, modalSubmoduleName: "", isSetOpenedMode: false, didDocumentsCheck: false, clientHasDocumentsToLink: [] };
		}
	
		_createClass(ClientZoom, [{
			key: 'setSubModule',
			value: function setSubModule(subModuleName) {
				var clientProfileStatus = this.props.clientProfileForm.formStatus.sent;
				if (clientProfileStatus == false && this.props.subModule == 'edit-profile') {
					this.setSubModuleName(subModuleName);
					this.openModal();
				} else {
					var dispatch = this.props.dispatch;
	
					dispatch((0, _stateActions.setOpenedSubmenu)());
					dispatch((0, _stateActions.setClientSubModule)(subModuleName));
				}
			}
		}, {
			key: 'openModal',
			value: function openModal() {
				this.setState({ modalIsOpen: !this.state.modalIsOpen });
			}
		}, {
			key: 'setSubModuleName',
			value: function setSubModuleName(submoduleName) {
				this.setState({ modalSubmoduleName: submoduleName });
			}
		}, {
			key: 'leaveModal',
			value: function leaveModal(subModuleName) {
				var dispatch = this.props.dispatch;
				var isSetOpenedMode = this.state.isSetOpenedMode;
	
				if (isSetOpenedMode == true) {
					this.props.dispatch((0, _stateActions.setOpened)());
					dispatch((0, _stateActions.setClientSubModule)(""));
					this.setState({ isSetOpenedMode: false });
				} else {
					dispatch((0, _stateActions.setOpenedSubmenu)());
					dispatch((0, _stateActions.setClientSubModule)(subModuleName));
	
					this.setSubModuleName("");
				}
	
				this.openModal();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				var _props = this.props;
				var dispatch = _props.dispatch;
				var subModule = _props.subModule;
				var clientId = _props.clientId;
				var data = _props.data;
				var staffList = _props.staffList;
				var brokerNumbersList = _props.brokerNumbersList;
				var didDocumentsCheck = this.state.didDocumentsCheck;
	
				if (!subModule) {
					this.setSubModule('profile');
				}
	
				if (!data.main) {
					dispatch((0, _stateActions.fetchClient)(clientId)).then(function (result) {
						// try to define a contract for instant open in case of match
						var contractId = _this2.processAutoZoomArguments();
	
						if (contractId) {
							dispatch((0, _stateActions.setOpenedSubmenu)(contractId));
						}
					});
				}
	
				if (!didDocumentsCheck) {
					dispatch((0, _stateActions.getDsDocsToLinkWithContract)({ clientId: clientId, staffList: staffList, brokerNumbersList: brokerNumbersList })).then(function (res) {
						_this2.setState({ didDocumentsCheck: true, clientHasDocumentsToLink: res });
					});
				}
			}
	
			/**
	   * This is used to load corect data for navigation to related client BEWB-368
	   * @param {*} prevProps
	   */
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				var _this3 = this;
	
				var _props2 = this.props;
				var dispatch = _props2.dispatch;
				var data = _props2.data;
				var clientId = _props2.clientId;
	
				if (clientId !== prevProps.clientId) {
					if (!data.main) {
						dispatch((0, _stateActions.fetchClient)(clientId)).then(function (result) {
							// try to define a contract for instant open in case of match
							var contractId = _this3.processAutoZoomArguments();
	
							if (contractId) {
								dispatch((0, _stateActions.setOpenedSubmenu)(contractId));
							}
						});
					}
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.setSubModule('');
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _props3 = this.props;
				var dispatch = _props3.dispatch;
				var clientOptionsDict = _props3.clientOptionsDict;
	
				if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
					dispatch((0, _stateActions.fetchClientOptionsDict)());
				}
			}
	
			/**
	   * This function process the client option dic (oracle provided translations) for
	   * the react select of user characteristics
	   * @param {object} clientOptionsDict - oracle provided translations
	   * @param {string} lang - the current language of page
	   */
		}, {
			key: 'handleClientOptionsDictPropChange',
			value: function handleClientOptionsDictPropChange() {
				var _props4 = this.props;
				var clientOptionsDict = _props4.clientOptionsDict;
				var lang = _props4.lang;
	
				var characteristicOptions = [];
	
				if (clientOptionsDict && clientOptionsDict.KENMERKTYPE) {
					(function () {
						var charTypes = clientOptionsDict.KENMERKTYPE;
						Object.keys(charTypes).map(function (oneCharacteristicKey) {
							characteristicOptions.push({
								value: oneCharacteristicKey,
								label: charTypes[oneCharacteristicKey][lang]
							});
						});
					})();
				}
	
				return characteristicOptions;
			}
	
			/**
	   * This function will process the result of search client and if there are match for contract number or
	   * characteristics then return with an argument for ClientContracts to instant open that contract
	   * @returns {string} contractId - the id of matched contract
	   */
		}, {
			key: 'processAutoZoomArguments',
			value: function processAutoZoomArguments() {
				var _this4 = this;
	
				var _props5 = this.props;
				var subModuleZoom = _props5.subModuleZoom;
				var clientContracts = _props5.clientContracts;
	
				var contractId = '';
	
				// That case when have to open the only one contract what have tha same characteristic.
				if (subModuleZoom && subModuleZoom.characteristicType && subModuleZoom.characteristicValue && clientContracts) {
					(function () {
						var dict = _this4.handleClientOptionsDictPropChange() || [];
						var contractsMatched = clientContracts.filter(function (oneContract) {
							var subModuleZoomTypeWords = [];
							dict.forEach(function (oneWord) {
								if (String(oneWord.value).trim().toLowerCase() == String(subModuleZoom.characteristicType).trim().toLowerCase()) {
									subModuleZoomTypeWords.push(String(oneWord.label).trim().toLowerCase());
								}
							});
	
							// if some of the comparative property is missing then skip comparison
							if (!oneContract || !oneContract.characteristicType || !oneContract.characteristicValue) {
								return false;
							}
	
							// check characteristics type and value are matching
							var valueCompareResult = String(oneContract.characteristicValue).trim().toLowerCase() == String(subModuleZoom.characteristicValue).trim().toLowerCase();
	
							// trim and lowercase the characteristicType to be able compare more efficiently with the list elements
							var caseInsesitiveCharacteristicType = String(oneContract.characteristicType).trim().toLowerCase();
							// find the type in list of the types and get a boolean result
							var typeCompareResult = subModuleZoomTypeWords.indexOf(caseInsesitiveCharacteristicType) !== -1;
	
							// if is set contractNumber for this module, then that value let only just one result
							var contractNumberCompareResult = false;
							if (subModuleZoom.contractNumber) {
								contractNumberCompareResult = String(subModuleZoom.contractNumber).trim() == String(oneContract.contractNumber).trim();
							}
	
							// Check if the searching by characteristics let the record in the filter
							// if no search value set, that already is ok from point of view of filter
							var isCharacteristicsOK = subModuleZoom.characteristicValue && oneContract.characteristicType && Boolean(valueCompareResult) && Boolean(typeCompareResult) || !subModuleZoom.characteristicValue && !oneContract.characteristicType;
	
							// Check if the searching by contractNumber let the record in the filter
							// if no search value set, that already is ok from point of view of filter
							var isContractNumberOk = Boolean(contractNumberCompareResult) && subModuleZoom.contractNumber || !subModuleZoom.contractNumber;
	
							//merge the filtering results together
							// if set value compared and matter, if no value set for a filter does not matter the existence of that
							var resultOfAllMatch = isCharacteristicsOK && isContractNumberOk;
	
							return resultOfAllMatch;
						});
	
						// IMPORTANT, when there are more contracts matched not open anything.
	
						// if only one contract has match the open it
						if (contractsMatched && contractsMatched.length == 1) {
							contractId = contractsMatched[0].contractId;
						}
					})();
				} else {
					// When only one contract found then no compare, open it anyway
					if (subModuleZoom && subModuleZoom.characteristicType && subModuleZoom.characteristicValue && clientContracts && clientContracts.length == 1) {
						contractId = _nestedProperty2['default'].get(clientContracts, "0.contractId");
					}
				}
	
				return contractId;
			}
		}, {
			key: 'getIcon',
			value: function getIcon() {
				try {
					return __webpack_require__(950);
				} catch (err) {
					return __webpack_require__(23);
				}
			}
		}, {
			key: 'navigateToDocumentsList',
			value: function navigateToDocumentsList() {
				var _props6 = this.props;
				var dispatch = _props6.dispatch;
				var clientId = _props6.clientId;
				var clientHasDocumentsToLink = this.state.clientHasDocumentsToLink;
	
				dispatch((0, _stateActions.setCustomDsDocumentsModule)(_stateConstants2['default'].DSDOCUMENTS, clientId));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var _props7 = this.props;
				var subModule = _props7.subModule;
				var subModuleZoom = _props7.subModuleZoom;
				var data = _props7.data;
				var isPhone = _props7.isPhone;
				var clientId = _props7.clientId;
				var clientContracts = _props7.clientContracts;
				var clientHasDocumentsToLink = this.state.clientHasDocumentsToLink;
	
				var output = undefined;
	
				var modalIsOpen = this.state.modalIsOpen;
				var modalSubmoduleName = this.state.modalSubmoduleName;
	
				var setSubModule = function setSubModule(subModuleName) {
					_this5.setSubModule(subModuleName);
				};
	
				if (!data.main) {
					return false;
				}
				switch (subModule) {
					case 'profile':
						output = _react2['default'].createElement(_clientProfile2['default'], {
							clientId: clientId,
							data: data
						});
						break;
					case 'edit-profile':
						output = _react2['default'].createElement(_clientProfileEdit2['default'], _extends({
							clientId: clientId,
							data: data
						}, {
							setSubModule: setSubModule
						}));
						break;
					case 'contracts':
						output = _react2['default'].createElement(_clientContracts2['default'], null);
						break;
					case 'financial':
						output = _react2['default'].createElement(_clientFinances2['default'], null);
						break;
					case 'claims':
						output = _react2['default'].createElement(_clientClaims2['default'], { clientData: data });
						break;
					case 'finances':
						output = _react2['default'].createElement(_clientFinances2['default'], null);
						break;
					case 'tarification':
						output = _react2['default'].createElement(_clientTarifications2['default'], null);
						break;
					default:
						output = _react2['default'].createElement(
							'div',
							null,
							'Unknown submodule!'
						);
						break;
				}
				return _react2['default'].createElement(
					'div',
					{ className: _clientZoomScss2['default'].clientZoomContainer },
					_react2['default'].createElement(
						'div',
						{ className: _clientZoomScss2['default'].content },
						_react2['default'].createElement(
							'div',
							{ className: _clientZoomScss2['default'].mainTitleDiv },
							_react2['default'].createElement(
								'div',
								{ className: _clientZoomScss2['default'].mainTitleContainer },
								_react2['default'].createElement(
									'h2',
									{ className: _clientZoomScss2['default'].mainTitle },
									data.main.name
								),
								clientHasDocumentsToLink && clientHasDocumentsToLink.length > 0 && _react2['default'].createElement(
									'button',
									{ type: 'button', className: _clientZoomScss2['default'].exclamationIcon, onClick: function (event) {
											event.preventDefault();
											_this5.navigateToDocumentsList();
										} },
									_react2['default'].createElement('img', { className: _clientZoomScss2['default'].icon, src: this.getIcon() }),
									_react2['default'].createElement(
										'span',
										{ className: _clientZoomScss2['default'].tooltip },
										_('toolTipForUnlinkedDocumentsWarning')
									)
								)
							),
							!isPhone && _react2['default'].createElement(
								'div',
								{ className: _clientZoomScss2['default'].moduleControls },
								_react2['default'].createElement(
									'div',
									{ onClick: this.handleClose, className: _clientZoomScss2['default'].greyButton },
									_('backToList')
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: _clientZoomScss2['default'].clientZoom },
							_react2['default'].createElement(
								'div',
								{ className: _clientZoomScss2['default'].subNav },
								_react2['default'].createElement(SubNav, {
									currentId: subModule,
									items: {
										profile: _('profile'),
										tarification: _('tarification'),
										contracts: _('contracts'),
										financial: _('financial'),
										claims: _('claims')
									},
									onChange: function (id) {
										return _this5.setSubModule(id);
									}
								})
							),
							_react2['default'].createElement(
								'div',
								{ className: _clientZoomScss2['default'].moduleWrap },
								output
							)
						)
					),
					_react2['default'].createElement(
						_reactModal2['default'],
						{
							isOpen: modalIsOpen,
							style: customStyles,
							contentLabel: 'Modal'
						},
						_react2['default'].createElement(
							'div',
							{ className: _clientZoomScss2['default'].verifyModalContent },
							_react2['default'].createElement(
								'span',
								{ className: _clientZoomScss2['default'].title },
								_('clientProfileLeavePopup')
							),
							_react2['default'].createElement(
								'span',
								{ className: _clientZoomScss2['default'].message },
								_('clientProfileLeavePopupMessage')
							),
							_react2['default'].createElement(
								'div',
								{ className: _clientZoomScss2['default'].verifyModalButtons },
								_react2['default'].createElement(
									'span',
									{
										onClick: function () {
											return _this5.openModal();
										},
										className: _clientZoomScss2['default'].cancel
									},
									_("cancel")
								),
								_react2['default'].createElement('input', {
									onClick: function () {
										return _this5.leaveModal(modalSubmoduleName);
									},
									type: 'button',
									className: _clientZoomScss2['default'].greyButton + " enabled",
									value: _("clientProfileLeaveOkButton")
								})
							)
						)
					)
				);
			}
		}]);
	
		var _ClientZoom = ClientZoom;
		ClientZoom = (0, _reactRedux.connect)(function (state) {
			var clientId = state.app.opened;
			var clientProfileForm = state.clientProfileForm;
			var clientData = state.clients.clientData[clientId];
			var clientContracts = [];
			var brokers = _nestedProperty2['default'].get(state, 'office.brokers');
	
			if (clientData && clientData.contractIds) {
				clientContracts = clientData.contractIds.map(function (id) {
					return state.contracts[id];
				});
			}
			var staffList = [];
			var brokerNumbersList = [];
			if (brokers) {
				for (var key in brokers) {
					if (brokers[key].brokerNumber) {
						brokerNumbersList.push(brokers[key].brokerNumber);
					}
					if (brokers[key].staff) {
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;
	
						try {
							for (var _iterator = brokers[key].staff[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var oneStaffMember = _step.value;
	
								if (!staffList.includes(oneStaffMember.userId)) {
									staffList.push(oneStaffMember.userId);
								}
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator['return']) {
									_iterator['return']();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}
					}
				}
			}
	
			return {
				subModule: state.clients.subModule,
				subModuleZoom: state.clients.subModuleZoom,
				clientId: clientId,
				clientContracts: clientContracts,
				data: clientData || {},
				isPhone: state.responsive.isPhone,
				clientOptionsDict: state.client.clientOptionsDict,
				clientProfileForm: clientProfileForm,
				lang: state.app.lang,
				staffList: staffList,
				brokerNumbersList: brokerNumbersList
			};
		})(ClientZoom) || ClientZoom;
		return ClientZoom;
	})(_react2['default'].Component);
	
	exports['default'] = ClientZoom;
	module.exports = exports['default'];

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _clientZoom = __webpack_require__(1092);
	
	var _clientZoom2 = _interopRequireDefault(_clientZoom);
	
	var _form = __webpack_require__(605);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _clientResults = __webpack_require__(1087);
	
	var _clientResults2 = _interopRequireDefault(_clientResults);
	
	var _clientsScss = __webpack_require__(244);
	
	var _clientsScss2 = _interopRequireDefault(_clientsScss);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var Clients = (function (_React$Component) {
	    _inherits(Clients, _React$Component);
	
	    _createClass(Clients, null, [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            opened: _react2['default'].PropTypes.string,
	            lang: _react2['default'].PropTypes.string,
	            data: _react2['default'].PropTypes.array,
	            clientOptionsDict: _react2['default'].PropTypes.object
	        },
	        enumerable: true
	    }]);
	
	    function Clients(props) {
	        var _this = this;
	
	        _classCallCheck(this, _Clients);
	
	        _get(Object.getPrototypeOf(_Clients.prototype), 'constructor', this).call(this, props);
	
	        this.handleSearch = function (data) {
	            return _this.props.dispatch((0, _stateActions.fetchClients)(data));
	        };
	
	        this.zoomClient = function (id) {
	            var dispatch = _this.props.dispatch;
	
	            dispatch((0, _stateActions.setOpened)(id));
	            dispatch((0, _stateActions.setClientSubModule)());
	        };
	    }
	
	    _createClass(Clients, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var initializeProfileForm = _props.initializeProfileForm;
	            var clientOptionsDict = _props.clientOptionsDict;
	
	            if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
	                dispatch((0, _stateActions.fetchClientOptionsDict)());
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal(e) {
	            e.preventDefault();
	            var _props2 = this.props;
	            var dispatch = _props2.dispatch;
	            var initializeProfileForm = _props2.initializeProfileForm;
	            var toggleModalClientProfileForm = _props2.toggleModalClientProfileForm;
	            var modalState = _props2.modalState;
	
	            dispatch(toggleModalClientProfileForm(!modalState));
	            dispatch(initializeProfileForm({}, null, 'create'));
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.setClientData)({}));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props;
	            var data = _props3.data;
	            var opened = _props3.opened;
	            var createClientAccess = _props3.createClientAccess;
	            var updateClientAccess = _props3.updateClientAccess;
	            var modalState = _props3.modalState;
	            var clientOptionsDict = _props3.clientOptionsDict;
	
	            var openModal = function openModal(e) {
	                _this2.openModal(e);
	            };
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _clientsScss2['default'].clientsMain },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _clientsScss2['default'].clientsSearchContainer + ' ' + (opened ? _clientsScss2['default'].hidden : 'visible') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'main-title-div' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'main-title-container' },
	                            _react2['default'].createElement(
	                                'h2',
	                                { className: 'main-title' },
	                                _('title')
	                            ),
	                            _react2['default'].createElement(
	                                'h3',
	                                null,
	                                _('subtitle')
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(_form2['default'], _extends({
	                        createClientAccess: createClientAccess,
	                        updateClientAccess: updateClientAccess,
	                        openModal: openModal,
	                        modalState: modalState
	                    }, {
	                        onSubmit: this.handleSearch,
	                        initialValues: { state: '' },
	                        clientOptionsDict: clientOptionsDict,
	                        lang: lang
	                    })),
	                    data && _react2['default'].createElement(_clientResults2['default'], { data: data, zoomTo: this.zoomClient })
	                ),
	                opened && _react2['default'].createElement(_clientZoom2['default'], null)
	            );
	        }
	    }]);
	
	    var _Clients = Clients;
	    Clients = (0, _reactRedux.connect)(function (state) {
	        var clientAccess = state.app.security.actions;
	
	        var canCreateClient = undefined,
	            canUpdateClient = undefined;
	
	        clientAccess.map(function (item, key) {
	            if (item.actionName == 'createclient') {
	                canCreateClient = item.actionAllowed === "true" ? true : false;
	            }
	
	            if (item.actionName == 'modifyclient') {
	                canUpdateClient = item.actionAllowed === "true" ? true : false;
	            }
	        });
	
	        return {
	            data: state.clients.data,
	            lang: state.app.lang,
	            clientOptionsDict: state.client.clientOptionsDict,
	            opened: state.app.opened,
	            createClientAccess: canCreateClient,
	            updateClientAccess: canUpdateClient,
	            initializeProfileForm: _stateActions.initializeProfileForm,
	            toggleModalClientProfileForm: _stateActions.toggleModalClientProfileForm,
	            modalState: state.clientProfileForm.clientModal
	        };
	    })(Clients) || Clients;
	    return Clients;
	})(_react2['default'].Component);
	
	exports['default'] = Clients;
	module.exports = exports['default'];

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _inbox = __webpack_require__(1103);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	var _outbox = __webpack_require__(1135);
	
	var _outbox2 = _interopRequireDefault(_outbox);
	
	var _news = __webpack_require__(1115);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _agenda = __webpack_require__(1053);
	
	var _agenda2 = _interopRequireDefault(_agenda);
	
	var _taskList = __webpack_require__(1151);
	
	var _taskList2 = _interopRequireDefault(_taskList);
	
	var _links = __webpack_require__(1108);
	
	var _links2 = _interopRequireDefault(_links);
	
	var _claims = __webpack_require__(1078);
	
	var _claims2 = _interopRequireDefault(_claims);
	
	var _faq = __webpack_require__(1101);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _office = __webpack_require__(1127);
	
	var _office2 = _interopRequireDefault(_office);
	
	var _clients = __webpack_require__(1093);
	
	var _clients2 = _interopRequireDefault(_clients);
	
	var _b2b = __webpack_require__(1063);
	
	var _b2b2 = _interopRequireDefault(_b2b);
	
	var _b2bCompany = __webpack_require__(1073);
	
	var _b2bCompany2 = _interopRequireDefault(_b2bCompany);
	
	var _webapps = __webpack_require__(1158);
	
	var _webapps2 = _interopRequireDefault(_webapps);
	
	var _emailDocument = __webpack_require__(1095);
	
	var _emailDocument2 = _interopRequireDefault(_emailDocument);
	
	var _willdoc = __webpack_require__(1159);
	
	var _willdoc2 = _interopRequireDefault(_willdoc);
	
	var _DSDocuments = __webpack_require__(1050);
	
	var _DSDocuments2 = _interopRequireDefault(_DSDocuments);
	
	var Production = function Production() {
		window.open('https://ts.ovb-willemot.be/37b8677ecc305f783ac786b56d34b93250f3b2dd4b66b1bac78472bb36087d03ca3313fbf3735e8', '_blank', 'noopener,noreferrer');
		return _react2['default'].createElement('div', null);
	};
	
	var Content = (function (_Component) {
		_inherits(Content, _Component);
	
		function Content() {
			_classCallCheck(this, _Content);
	
			_get(Object.getPrototypeOf(_Content.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Content, [{
			key: 'render',
			value: function render() {
				var module = this.props.module;
	
				var output = undefined;
				switch (module) {
					case _stateConstants2['default'].INBOX:
						output = _react2['default'].createElement(_inbox2['default'], null);
						break;
					case _stateConstants2['default'].OUTBOX:
						output = _react2['default'].createElement(_outbox2['default'], null);
						break;
					case _stateConstants2['default'].TASKLIST:
						output = _react2['default'].createElement(_taskList2['default'], null);
						break;
					case _stateConstants2['default'].NEWS:
						output = _react2['default'].createElement(_news2['default'], null);
						break;
					case _stateConstants2['default'].LINKS:
						output = _react2['default'].createElement(_links2['default'], null);
						break;
					case _stateConstants2['default'].FAQ:
						output = _react2['default'].createElement(_faq2['default'], null);
						break;
					case _stateConstants2['default'].OFFICE:
						output = _react2['default'].createElement(_office2['default'], null);
						break;
					case _stateConstants2['default'].PRODUCTION:
						output = _react2['default'].createElement(Production, null);
						break;
					case _stateConstants2['default'].B2B:
						output = _react2['default'].createElement(_b2b2['default'], null);
						break;
					case _stateConstants2['default'].INSURANCE_COMPANY:
					case _stateConstants2['default'].PVVERZEKERINGENCVBA:
					case _stateConstants2['default'].GENERALIBELGIUM:
						output = _react2['default'].createElement(_b2bCompany2['default'], null);
						break;
					case _stateConstants2['default'].AGENDA:
						output = _react2['default'].createElement(_agenda2['default'], null);
						break;
					case _stateConstants2['default'].CLIENTS:
						output = _react2['default'].createElement(_clients2['default'], null);
						break;
					case _stateConstants2['default'].CLAIMS:
						output = _react2['default'].createElement(_claims2['default'], null);
						break;
					case _stateConstants2['default'].WILLDOC:
						output = _react2['default'].createElement(_willdoc2['default'], null);
						break;
					case _stateConstants2['default'].WEBAPPS:
						output = _react2['default'].createElement(_webapps2['default'], null);
						break;
					case _stateConstants2['default'].EMAILDOCUMENT:
						output = _react2['default'].createElement(_emailDocument2['default'], null);
						break;
					case _stateConstants2['default'].DSDOCUMENTS:
						output = _react2['default'].createElement(_DSDocuments2['default'], null);
						break;
					default:
						output = _react2['default'].createElement(
							'div',
							null,
							'Unknown module ',
							module
						);
						break;
				}
				return output;
			}
		}], [{
			key: 'propTypes',
			value: {
				className: _react.PropTypes.string,
				module: _react.PropTypes.string.isRequired
			},
			enumerable: true
		}]);
	
		var _Content = Content;
		Content = (0, _reactRedux.connect)(function (state) {
			return {
				module: state.app.module
			};
		})(Content) || Content;
		return Content;
	})(_react.Component);
	
	exports['default'] = Content;
	module.exports = exports['default'];

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
					value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var EmailDocument = (function (_React$Component) {
					_inherits(EmailDocument, _React$Component);
	
					function EmailDocument(props) {
									_classCallCheck(this, _EmailDocument);
	
									_get(Object.getPrototypeOf(_EmailDocument.prototype), 'constructor', this).call(this, props);
									var emailDocument = props.emailDocument;
	
									if (emailDocument.id) {
													window.open('/localdocument?localId=' + emailDocument.id, '_self');
									}
					}
	
					var _EmailDocument = EmailDocument;
					EmailDocument = (0, _reactRedux.connect)(function (_ref) {
									var emailDocument = _ref.emailDocument;
									return { emailDocument: emailDocument };
					})(EmailDocument) || EmailDocument;
					return EmailDocument;
	})(_react2['default'].Component);
	
	exports['default'] = EmailDocument;
	module.exports = exports['default'];

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _listSelectScss = __webpack_require__(245);
	
	var _listSelectScss2 = _interopRequireDefault(_listSelectScss);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _generalComponentsInfoModal = __webpack_require__(369);
	
	var _generalComponentsInfoModal2 = _interopRequireDefault(_generalComponentsInfoModal);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        zIndex: 2
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var EmailListSelect = (function (_React$Component) {
	    _inherits(EmailListSelect, _React$Component);
	
	    _createClass(EmailListSelect, null, [{
	        key: 'propTypes',
	        value: {
	            data: _react2['default'].PropTypes.array,
	            formStatus: _react2['default'].PropTypes.object
	        },
	        enumerable: true
	    }]);
	
	    function EmailListSelect(props) {
	        var _this = this;
	
	        _classCallCheck(this, EmailListSelect);
	
	        _get(Object.getPrototypeOf(EmailListSelect.prototype), 'constructor', this).call(this, props);
	
	        this.handleAddFieldButton = function () {
	            var data = _this.props.data;
	
	            if (data.length > 0) {
	                var isSetDefaultValue = false;
	                data.map(function (key, index) {
	                    if (key['default'].checked == true) {
	                        isSetDefaultValue = true;
	                    }
	                });
	
	                if (!isSetDefaultValue) {
	                    data.addField({ email: "", 'default': true, uniqueId: (0, _uuidV42['default'])() });
	                } else {
	                    data.addField({ email: "", 'default': false, uniqueId: (0, _uuidV42['default'])() });
	                }
	            } else {
	                data.addField({ email: "", 'default': true, uniqueId: (0, _uuidV42['default'])() });
	            }
	            _this.openModal();
	        };
	
	        this.state = { modalIsOpen: false, informModalOpen: false };
	    }
	
	    _createClass(EmailListSelect, [{
	        key: 'getIcon',
	        value: function getIcon() {
	            try {
	                return __webpack_require__(79);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this.setState({ modalIsOpen: !this.state.modalIsOpen });
	        }
	    }, {
	        key: 'addElementData',
	        value: function addElementData() {
	            this.openModal();
	        }
	    }, {
	        key: 'removeItemFromList',
	        value: function removeItemFromList(itemUniqueId) {
	            var data = this.props.data;
	
	            Object.keys(data).map(function (dataKey) {
	                if (data[dataKey] && data[dataKey] !== undefined && data[dataKey].uniqueId.value === itemUniqueId) {
	                    data.removeField(dataKey);
	                }
	            });
	        }
	    }, {
	        key: 'removeItem',
	        value: function removeItem() {
	            var data = this.props.data;
	            data.removeField();
	        }
	    }, {
	        key: 'modalContentPopup',
	        value: function modalContentPopup() {
	            var _this2 = this;
	
	            var data = this.props.data;
	
	            var lastEmail = data.slice(-1)[0];
	            var errorData = true;
	
	            if (lastEmail != undefined) {
	                if (lastEmail.email.error != undefined) {
	                    errorData = true;
	                } else {
	                    errorData = false;
	                }
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].clientModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _listSelectScss2['default'].title },
	                    _("addEmailAddress")
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('email')
	                ),
	                lastEmail != undefined && _react2['default'].createElement('input', _extends({ type: 'text' }, lastEmail.email)),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    ' ',
	                    lastEmail != undefined && lastEmail.email.error && lastEmail.email.touched && lastEmail.email.error,
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientModalButtons },
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this2.openModal();
	                            _this2.removeItem();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].cancel,
	                        value: _("cancel")
	                    }),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            return _this2.openModal();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].next + " " + (!errorData && _listSelectScss2['default'].enabled),
	                        value: _("clientAdd"),
	                        disabled: errorData
	                    })
	                )
	            );
	        }
	
	        /**
	         * This will set the form value content in store
	         */
	    }, {
	        key: 'updateFormValue',
	        value: function updateFormValue(value, field) {
	            var dispatch = this.props.dispatch;
	
	            return dispatch({
	                type: "redux-form/CHANGE",
	                field: field.name,
	                value: value && value.value,
	                touch: value && value.touched || field.touched,
	                form: "clientProfileEdit"
	            });
	        }
	
	        /**
	         *
	         * @param {*} uniqueId
	         * @param {any}
	         * @returns
	         */
	    }, {
	        key: 'setCheckedAndClearOthers',
	        value: function setCheckedAndClearOthers(uniqueId, emailAddresses) {
	            var returnValue, i, oneEmailAddress, isThisTheSelectedField, formChangeResult;
	            return regeneratorRuntime.async(function setCheckedAndClearOthers$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        returnValue = undefined;
	                        i = 0;
	
	                    case 2:
	                        if (!(i < emailAddresses.length)) {
	                            context$2$0.next = 15;
	                            break;
	                        }
	
	                        oneEmailAddress = emailAddresses[i];
	
	                        // reset all values
	                        oneEmailAddress['default'].value = false;
	                        oneEmailAddress['default'].checked = false;
	
	                        // check if this is the selected radio button
	                        isThisTheSelectedField = oneEmailAddress.uniqueId.value === uniqueId.value;
	
	                        // overwrite the selected value to checked
	                        if (isThisTheSelectedField) {
	                            oneEmailAddress['default'].value = true;
	                            oneEmailAddress['default'].checked = true;
	                        }
	
	                        // update redux form
	                        context$2$0.next = 10;
	                        return regeneratorRuntime.awrap(this.updateFormValue(oneEmailAddress['default'], oneEmailAddress['default']));
	
	                    case 10:
	                        formChangeResult = context$2$0.sent;
	
	                        // keep the actual filed changing return value for the input
	                        if (isThisTheSelectedField) {
	                            returnValue = formChangeResult;
	                        }
	
	                    case 12:
	                        i++;
	                        context$2$0.next = 2;
	                        break;
	
	                    case 15:
	                        return context$2$0.abrupt('return', returnValue);
	
	                    case 16:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props;
	            var data = _props.data;
	            var formStatus = _props.formStatus;
	            var _state = this.state;
	            var informModalOpen = _state.informModalOpen;
	            var modalIsOpen = _state.modalIsOpen;
	
	            var isSetDefaultValue = false;
	
	            var newData = data.map(function (item, key) {
	                delete item['default'].value;
	                if (item['default'].checked == true) {
	                    isSetDefaultValue = true;
	                }
	
	                return item;
	            });
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].moduleSection },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientsTableContainer },
	                    !_underscore2['default'].isEmpty(newData) && _underscore2['default'].isArray(newData) && newData[0] !== 'Too many rows' && _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            className: _listSelectScss2['default'].table,
	                            itemsPerPage: 50,
	                            topPagination: '',
	                            filterable: [],
	                            sortable: ["email.value"],
	                            defaultSort: {
	                                column: 'email.value',
	                                direction: 'asc'
	                            }
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'email.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('email')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'default.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('default')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'checkEmail' },
	                                _react2['default'].createElement('strong', null)
	                            )
	                        ),
	                        newData.map(function (oneEmailAddress, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { className: 'centered', key: oneEmailAddress.uniqueId.value, id: oneEmailAddress.uniqueId.value },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'email.value' },
	                                    oneEmailAddress.email.value
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'default.value' },
	                                    _react2['default'].createElement('input', {
	                                        type: 'radio',
	                                        value: oneEmailAddress['default'].value,
	                                        checked: oneEmailAddress['default'].checked,
	                                        name: "emailAddresses",
	                                        onBlur: function (e) {
	                                            return false;
	                                        },
	                                        onChange: function (value) {
	                                            return _this3.setCheckedAndClearOthers(oneEmailAddress.uniqueId, newData);
	                                        }
	                                    })
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'checkEmail' },
	                                    _react2['default'].createElement(
	                                        'button',
	                                        {
	                                            type: 'button',
	                                            className: _listSelectScss2['default'].removeFieldsButton,
	                                            onClick: function (event) {
	                                                event.preventDefault();
	
	                                                // prevent to delete the default phone number
	                                                if (isSetDefaultValue && oneEmailAddress['default'].checked || !isSetDefaultValue) {
	                                                    return _this3.setState({ informModalOpen: true });
	                                                }
	
	                                                _this3.removeItemFromList(oneEmailAddress.uniqueId.value);
	                                            } },
	                                        _react2['default'].createElement('img', { src: _this3.getIcon() })
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    formStatus != undefined && formStatus.emailDefault == true && _react2['default'].createElement(
	                        'div',
	                        { className: _listSelectScss2['default'].error },
	                        ' ',
	                        _('requiredDefaultEmail'),
	                        ' '
	                    ),
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'button',
	                            className: _listSelectScss2['default'].addFieldButton,
	                            onClick: function () {
	                                var data = _this3.props.data;
	
	                                _this3.handleAddFieldButton();
	                            } },
	                        '+'
	                    )
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        style: customStyles,
	                        contentLabel: 'Modal'
	                    },
	                    this.modalContentPopup()
	                ),
	                _react2['default'].createElement(_generalComponentsInfoModal2['default'], {
	                    isOpen: Boolean(informModalOpen),
	                    title: _("infoModalEmailAddressCanNotDeleteTitle"),
	                    content: _("infoModalEmailAddressCanNotDeleteDescription"),
	                    onCancel: function () {},
	                    onConfirmation: function () {
	                        return _this3.setState({ informModalOpen: false });
	                    },
	                    cancelLabel: _("cancel"),
	                    confirmationLabel: _("ok"),
	                    options: { noCancelButton: true }
	                })
	            );
	        }
	    }]);
	
	    return EmailListSelect;
	})(_react2['default'].Component);
	
	exports['default'] = EmailListSelect;
	module.exports = exports['default'];

	// walk trough all of the phoneNumber fields

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _confirmationDialogScss = __webpack_require__(1607);
	
	var _confirmationDialogScss2 = _interopRequireDefault(_confirmationDialogScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('confirmationDialog');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        wordWrap: "break-word"
	    }
	};
	
	var ConfirmationDialog = (function (_React$Component) {
	    _inherits(ConfirmationDialog, _React$Component);
	
	    _createClass(ConfirmationDialog, null, [{
	        key: 'propTypes',
	        value: {
	            modalIsOpen: _react2['default'].PropTypes.bool,
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func,
	            cancelLabel: _react2['default'].PropTypes.string,
	            confirmationLabel: _react2['default'].PropTypes.string,
	            options: _react2['default'].PropTypes.object,
	            contentData: _react2['default'].PropTypes.any
	        },
	        enumerable: true
	    }]);
	
	    function ConfirmationDialog(props) {
	        _classCallCheck(this, _ConfirmationDialog);
	
	        _get(Object.getPrototypeOf(_ConfirmationDialog.prototype), 'constructor', this).call(this, props);
	        //this.handleKeyPress = this.handleKeyPress.bind(this);
	        this.state = { templates: null, confirmationModal: props.contentData || props.confirmationModal };
	    }
	
	    /* componentWillUnmount () {
	    	document.body.removeEventListener('keyup', this.props.onCancel, false);
	    }
	    handleKeyPress (evt) {
	    	if (vkey[evt.keyCode] === '<escape>') {
	    		this.props.onCancel();
	    	}
	    }
	    componentDidMount() {
	           document.body.addEventListener('keyup', this.props.onCancel, false);
	       } */
	
	    _createClass(ConfirmationDialog, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.confirmationModal && JSON.parse(JSON.stringify(nextProps.confirmationModal)) !== (this.props.confirmationModal && JSON.parse(JSON.stringify(this.props.confirmationModal))) && !nextProps.contentData) {
	                this.setState({ confirmationModal: nextProps.confirmationModal });
	            }
	
	            if (nextProps.contentData && JSON.parse(JSON.stringify(nextProps.contentData)) !== (this.props.contentData && JSON.parse(JSON.stringify(this.props.contentData)))) {
	                this.setState({ confirmationModal: nextProps.contentData });
	            }
	        }
	
	        /**
	         * This function opens a print window with the modal content
	         */
	    }, {
	        key: 'onPrint',
	        value: function onPrint() {
	            var options = this.props.options;
	            var confirmationModal = this.state.confirmationModal;
	
	            var theWindow = window.open('', 'PRINT', 'height=600,width=800');
	
	            theWindow.document.write('<html><head><title>' + confirmationModal.title + '</title>');
	            theWindow.document.write('</head><body >');
	            theWindow.document.write(confirmationModal.message);
	            theWindow.document.write('</body></html>');
	            theWindow.document.close(); // IE >= 10
	            theWindow.focus(); // IE >= 10
	            theWindow.print();
	            // theWindow.close()
	
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var modalIsOpen = _props.modalIsOpen;
	            var onCancel = _props.onCancel;
	            var onConfirmation = _props.onConfirmation;
	            var cancelLabel = _props.cancelLabel;
	            var confirmationLabel = _props.confirmationLabel;
	            var options = _props.options;
	            var confirmationModal = this.state.confirmationModal;
	
	            var hasCancelButtonStyle = _nestedProperty2['default'].get(options, 'hasCancelButtonStyle');
	            var noButtons = _nestedProperty2['default'].get(options, 'noButtons');
	            var showPrintButton = _nestedProperty2['default'].get(options, 'showPrintButton');
	            var printButtonLabel = _nestedProperty2['default'].get(options, 'printButtonLabel') || "";
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _confirmationDialogScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _confirmationDialogScss2['default'].title },
	                            confirmationModal && confirmationModal.title
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _confirmationDialogScss2['default'].contentWrapper },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _confirmationDialogScss2['default'].content },
	                                confirmationModal && _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: confirmationModal.message } })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _confirmationDialogScss2['default'].buttons },
	                                !noButtons && _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            return onCancel();
	                                        },
	                                        className: (0, _classnames2['default'])(hasCancelButtonStyle ? _confirmationDialogScss2['default'].cancel : "")
	                                    },
	                                    cancelLabel
	                                ),
	                                !noButtons && showPrintButton && _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            _this.onPrint(confirmationModal);
	                                        },
	                                        className: (0, _classnames2['default'])(_confirmationDialogScss2['default'].next, _confirmationDialogScss2['default'].enabled)
	                                    },
	                                    printButtonLabel
	                                ),
	                                !noButtons && _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: onConfirmation,
	                                        className: (0, _classnames2['default'])(_confirmationDialogScss2['default'].next, _confirmationDialogScss2['default'].enabled)
	                                    },
	                                    confirmationLabel
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _ConfirmationDialog = ConfirmationDialog;
	    ConfirmationDialog = (0, _reactRedux.connect)(function (state) {
	        return {
	            confirmationModal: state.emailSender.confirmationModal
	        };
	    })(ConfirmationDialog) || ConfirmationDialog;
	    return ConfirmationDialog;
	})(_react2['default'].Component);
	
	exports['default'] = ConfirmationDialog;
	module.exports = exports['default'];

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emailSenderModalScss = __webpack_require__(303);
	
	var _emailSenderModalScss2 = _interopRequireDefault(_emailSenderModalScss);
	
	var _reactSelectLibCreatable = __webpack_require__(165);
	
	var _reactSelectLibCreatable2 = _interopRequireDefault(_reactSelectLibCreatable);
	
	var _reactSelect = __webpack_require__(105);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _lodash = __webpack_require__(329);
	
	var _ = (0, _libI18n2['default'])('emailSender');
	
	var selectInFocusWithin = false;
	/**
	 * Customization object for the react-select using the same style like other components on tha site.
	 */
	var customCreatableSelectStyles = {
	    control: function control(base, state) {
	        selectInFocusWithin = state.isFocused;
	        return _extends({}, base, {
	            flex: "4",
	            fontSize: "12px",
	            display: "flex",
	            justifyContent: "flex-end",
	            alignItems: "flex-end",
	            color: "#000",
	            backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
	            borderColor: "#d9d9d9 #ccc #b3b3b3",
	            borderRadius: "2px",
	            border: "1px solid #d9d9d9",
	            minHeight: "25px",
	            maxHeight: "auto",
	            //height: state.isFocused ? "auto" : "25px",
	            boxShadow: state.isFocused ? null : null,
	            "&:hover": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            "&:focus": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            padding: 0,
	            margin: 0,
	            overflow: state.isFocused ? null : "hidden"
	        });
	    },
	    menu: function menu(base) {
	        return _extends({}, base, {
	            borderRadius: 2,
	            hyphens: "auto",
	            marginTop: 0,
	            textAlign: "left",
	            wordWrap: "break-word"
	        });
	    },
	    menuList: function menuList(base) {
	        return _extends({}, base, {
	            padding: 0,
	            verticalAlign: "baseline"
	        });
	    },
	    singleValue: function singleValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            color: "white"
	        });
	    },
	    multiValue: function multiValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            maxHeight: "18px",
	            border: "0.5px solid #003366",
	            background: '#003366',
	            color: "white",
	            div: {
	                color: "white",
	                fontSize: '1.2em',
	                lineHeight: '0.8em'
	            }
	        });
	    },
	    /* noOptionsMessage: (base, state) => ({
	      ...base,
	      padding: 0,
	      height: "20px",
	      lineHeight: "16px"
	    }), */
	    option: function option(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            fontSize: '1em',
	            maxHeight: "25px"
	        });
	    },
	    valueContainer: function valueContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            top: 0
	        });
	    },
	    multiValueRemove: function multiValueRemove(base, state) {
	        return state.data.isPermanentSelected ? _extends({}, base, {
	            display: "none",
	            padding: 0
	        }) : base;
	    },
	    clearIndicator: function clearIndicator(base, state) {
	        return _extends({}, base, {
	            padding: 0
	        });
	    },
	    dropdownIndicator: function dropdownIndicator(base, state) {
	        return _extends({}, base, {
	            marginTop: 0,
	            padding: 0
	        });
	    },
	    indicatorsContainer: function indicatorsContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "23px",
	            top: 0
	        });
	    },
	    indicatorSeparator: function indicatorSeparator(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "0",
	            top: 0
	        });
	    },
	    group: function group(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            top: 0
	        });
	    },
	    groupHeading: function groupHeading(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            top: 0
	        });
	    },
	    input: function input(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: "2px 0 0 0",
	            height: "20px",
	            top: 0,
	            fontSize: '1.2em',
	            lineHeight: '0.8em',
	            width: selectInFocusWithin ? '100%!important' : 'auto',
	            div: {
	                width: selectInFocusWithin ? '100%!important' : 'auto',
	                input: {
	                    width: selectInFocusWithin ? '100%!important' : 'auto'
	                }
	            }
	        });
	    },
	    noOptionsMessage: function noOptionsMessage(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            fontSize: '1em'
	        });
	    },
	    placeholder: function placeholder(base, state) {
	        return _extends({}, base, {
	            fontSize: '1.1em',
	            lineHeight: '1.1em'
	        });
	    }
	};
	
	exports.customCreatableSelectStyles = customCreatableSelectStyles;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var DropdownIndicator = function DropdownIndicator(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.DropdownIndicator,
	        props,
	        _react2['default'].createElement(
	            'span',
	            { className: _emailSenderModalScss2['default'].downArrowHolder },
	            _react2['default'].createElement('span', { className: _emailSenderModalScss2['default'].downArrow })
	        )
	    );
	};
	
	exports.DropdownIndicator = DropdownIndicator;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var NoOptionsMessage = function NoOptionsMessage(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.NoOptionsMessage,
	        props,
	        _('noOptions')
	    );
	};
	
	exports.NoOptionsMessage = NoOptionsMessage;
	var getDeleteIcon = function getDeleteIcon() {
	    try {
	        return __webpack_require__(79);
	    } catch (err) {
	        return __webpack_require__(23);
	    }
	};
	
	/**
	 *
	 * @param {*} props
	 */
	var SelectRemovableOption = function SelectRemovableOption(props) {
	    return _react2['default'].createElement(
	        'div',
	        { className: _emailSenderModalScss2['default'].creatableOptionContainer, key: props.value + "_key" },
	        _react2['default'].createElement(_reactSelect.components.Option, _extends({}, props, { className: _emailSenderModalScss2['default'].creatableOptionItem })),
	        props.data.isRecent && _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(
	                'button',
	                { type: 'button', className: _emailSenderModalScss2['default'].creatableOptionItem, onClick: function (event) {
	                        event.preventDefault();
	                        props['delete'](props.value);
	                    } },
	                _react2['default'].createElement('img', { src: getDeleteIcon() })
	            )
	        )
	    );
	};
	
	/**
	 * This is a custom MultiValueRemove for react select to be able set a separate unremovable value in dropdown
	 * but the rest is still dynamic
	 * @param {object} props
	 */
	var MultiValueRemove = function MultiValueRemove(props) {
	    return _react2['default'].createElement(
	        _reactSelect.components.MultiValueRemove,
	        props,
	        !props.data.isPermanentSelected ? props.children : null
	    );
	};
	
	var MultiValueContainer = function MultiValueContainer(props) {
	    return _react2['default'].createElement(
	        'span',
	        { className: _emailSenderModalScss2['default'].elementsInRow },
	        props.data.firstCC ? _react2['default'].createElement(
	            'span',
	            { className: _emailSenderModalScss2['default'].elementsInRow },
	            _react2['default'].createElement(
	                'span',
	                { className: _emailSenderModalScss2['default'].ccSpan },
	                'CC: '
	            ),
	            ' ',
	            _react2['default'].createElement(_reactSelect.components.MultiValueContainer, props)
	        ) : _react2['default'].createElement(_reactSelect.components.MultiValueContainer, props)
	    );
	};
	
	var ValueContainer = function ValueContainer(_ref) {
	    var children = _ref.children;
	
	    var props = _objectWithoutProperties(_ref, ['children']);
	
	    // sort the recipients and mark the first CC to render a separator between recipients
	    /* if (children && children[0] && children[0].length) {
	        children[0].sort((a,b) => {
	            return a.props.data.isCC > b.props.data.isCC ? 1 : -1
	        })
	        let firstCCIndex = -1
	        children[0].forEach((item, index)=>{
	            firstCCIndex === -1 && item.props.data.isCC ? (firstCCIndex = index) : null
	        })
	        if (firstCCIndex !== -1) {
	            children[0][firstCCIndex].props.data.firstCC = true
	        }
	    } */
	    var classNamesList = [_emailSenderModalScss2['default'].selectValueContainer];
	    if (!props.selectProps.isMulti) {
	        classNamesList.push(_emailSenderModalScss2['default'].selectValueContainerSingle);
	    }
	
	    return _react2['default'].createElement(
	        _reactSelect.components.ValueContainer,
	        _extends({}, props, { className: (0, _classnames2['default'])(classNamesList) }),
	        _react2['default'].createElement(
	            'div',
	            { className: _emailSenderModalScss2['default'].composeRecipients },
	            children
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: _emailSenderModalScss2['default'].ccButtonHolder },
	            props.selectProps.showCCButton ? _react2['default'].createElement(
	                'div',
	                { className: _emailSenderModalScss2['default'].ccButtonInSelect, onClick: function (e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        props.selectProps.onClickCCButton(e);
	                    } },
	                'CC'
	            ) : null
	        )
	    );
	};
	
	/**
	 * This component will render an email address composer element and provide a list of email addresses.
	 * This input have a default email address list and the user can type new email addresses in to the list.
	 * Te email addresses are separately removable.
	 *
	 * To validate the inserting value you can use this property for CreatableSelect
	 * "isValidNewOption={(value)=>{
	 *      return isAnEmail(value.trim())
	 * }}"
	 *
	 */
	
	var EmailAddressComposer = (function (_React$Component) {
	    _inherits(EmailAddressComposer, _React$Component);
	
	    _createClass(EmailAddressComposer, null, [{
	        key: 'propTypes',
	        value: {
	            emailToSelectField: _react2['default'].PropTypes.object.isRequired,
	            onChangeRecipientEmail: _react2['default'].PropTypes.func.isRequired,
	            templateContent: _react2['default'].PropTypes.object.isRequired,
	            emailToOptions: _react2['default'].PropTypes.array.isRequired,
	            allFieldDisabled: _react2['default'].PropTypes.bool,
	            isAnEmail: _react2['default'].PropTypes.func.isRequired,
	            isMulti: _react2['default'].PropTypes.bool,
	            isCreatable: _react2['default'].PropTypes.bool,
	            formatCreateLabel: _react2['default'].PropTypes.string,
	            customClassName: _react2['default'].PropTypes.string,
	            handleOnBlur: _react2['default'].PropTypes.func,
	            setDeleteItemByOption: _react2['default'].PropTypes.func,
	            showCCButton: _react2['default'].PropTypes.bool,
	            onClickCCButton: _react2['default'].PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function EmailAddressComposer(props) {
	        _classCallCheck(this, EmailAddressComposer);
	
	        _get(Object.getPrototypeOf(EmailAddressComposer.prototype), 'constructor', this).call(this, props);
	    }
	
	    _createClass(EmailAddressComposer, [{
	        key: 'handleBlur',
	        value: function handleBlur(value) {}
	    }, {
	        key: 'handleOnBlur',
	        value: function handleOnBlur(event) {
	            var _props = this.props;
	            var emailToSelectField = _props.emailToSelectField;
	            var onChangeRecipientEmail = _props.onChangeRecipientEmail;
	            var templateContent = _props.templateContent;
	
	            var newValue = [];
	
	            if (emailToSelectField && emailToSelectField.value) {
	                newValue = newValue.concat(emailToSelectField.value);
	            }
	
	            if (event && event.target && event.target.value) {
	                newValue.push({ label: event.target.value, value: event.target.value });
	            }
	
	            // add values to the list when blur, otherwise that will be lost
	            onChangeRecipientEmail(newValue, templateContent);
	            emailToSelectField.onChange(newValue);
	
	            return emailToSelectField.onBlur(newValue);
	        }
	
	        /**
	         * This function simplify to provide the correct Select component by args.
	         * @param {*} isCreatable If true then Return a creatable select component else return a none creatable component.
	         * @param {*} props the props to setup the component, like onclick, value, onBlur etc...
	         * @returns The initialised component
	         */
	    }, {
	        key: 'getProperSelectModuleByCreatableArg',
	        value: function getProperSelectModuleByCreatableArg(isCreatable, props) {
	            if (isCreatable) {
	                return _react2['default'].createElement(_reactSelectLibCreatable2['default'], props);
	            }
	
	            return _react2['default'].createElement(_reactSelect2['default'], props);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props2 = this.props;
	            var emailToSelectField = _props2.emailToSelectField;
	            var onChangeRecipientEmail = _props2.onChangeRecipientEmail;
	            var templateContent = _props2.templateContent;
	            var emailToOptions = _props2.emailToOptions;
	            var allFieldDisabled = _props2.allFieldDisabled;
	            var isAnEmail = _props2.isAnEmail;
	            var isMulti = _props2.isMulti;
	            var _formatCreateLabel = _props2.formatCreateLabel;
	            var customClassName = _props2.customClassName;
	            var handleOnBlur = _props2.handleOnBlur;
	            var showCCButton = _props2.showCCButton;
	            var onClickCCButton = _props2.onClickCCButton;
	            var setDeleteItemByOption = _props2.setDeleteItemByOption;
	            var isCreatable = _props2.isCreatable;
	
	            // placeholder={_('searchPromptText')}
	
	            // prepare props for any kind of react select, must be do on this way, because there are more type of components,
	            // what need the same setup to work
	            var props = {
	                openMenuOnFocus: true,
	                placeholder: '',
	                value: (function () {
	                    if (!isMulti) {
	                        return emailToSelectField.value && emailToSelectField.value[0] || null;
	                    }
	
	                    return emailToSelectField.value;
	                })(),
	                onChange: function onChange(value, _ref2) {
	                    var action = _ref2.action;
	                    var removedValue = _ref2.removedValue;
	
	                    if (value && !Array.isArray(value)) {
	                        value = [value];
	                    }
	
	                    if ((action === 'remove-value' || action === 'pop-value') && removedValue.isPermanentSelected) {
	                        return;
	                    }
	
	                    if (action === 'clear') {
	                        value = emailToSelectField.value.filter(function (v) {
	                            return v.isPermanentSelected;
	                        });
	                    }
	
	                    onChangeRecipientEmail(value, templateContent);
	                    return emailToSelectField.onChange(value);
	                },
	                onBlur: function onBlur(e) {
	                    if (handleOnBlur) {
	                        handleOnBlur(e);
	                    } else {
	                        _this.handleOnBlur(e);
	                    }
	                },
	                onBlurResetsInput: false,
	                options: emailToOptions,
	                isDisabled: allFieldDisabled,
	                isMulti: isMulti,
	                isSearchable: true,
	                formatCreateLabel: function formatCreateLabel(value) {
	                    return _formatCreateLabel + ' ' + value;
	                },
	                styles: customCreatableSelectStyles,
	                components: { DropdownIndicator: DropdownIndicator, NoOptionsMessage: NoOptionsMessage, Option: function Option(p) {
	                        return SelectRemovableOption(_extends({}, p, { 'delete': setDeleteItemByOption }));
	                    },
	                    MultiValueRemove: MultiValueRemove, /* MultiValueContainer,*/ValueContainer: ValueContainer },
	                className: customClassName,
	                showCCButton: showCCButton && !allFieldDisabled,
	                onClickCCButton: onClickCCButton
	            };
	
	            return this.getProperSelectModuleByCreatableArg(isCreatable, props);
	        }
	    }]);
	
	    return EmailAddressComposer;
	})(_react2['default'].Component);
	
	exports['default'] = EmailAddressComposer;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _extends=Object.assign || function(target){for(var i=1;i < arguments.length;i++) {var source=arguments[i];for(var key in source) {if(Object.prototype.hasOwnProperty.call(source,key)){target[key] = source[key];}}}return target;};var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();var _get=function get(_x34,_x35,_x36){var _again=true;_function: while(_again) {var object=_x34,property=_x35,receiver=_x36;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x34 = parent;_x35 = property;_x36 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _emailSenderModalScss=__webpack_require__(303);var _emailSenderModalScss2=_interopRequireDefault(_emailSenderModalScss);var _libI18n=__webpack_require__(3);var _libI18n2=_interopRequireDefault(_libI18n);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _stateActions=__webpack_require__(5);var _libValidator=__webpack_require__(96);var _reduxForm=__webpack_require__(57);var _reactStringReplace=__webpack_require__(496);var _reactStringReplace2=_interopRequireDefault(_reactStringReplace); // import tinyMCE. The 5.3 or above also requires importing a theme and a set of icons
	var _tinymceTinymce=__webpack_require__(526);var _tinymceTinymce2=_interopRequireDefault(_tinymceTinymce);__webpack_require__(513);__webpack_require__(525); // For tinyMCE 5.3 or above, the plugins are now imported here instead of being specified
	// as external scripts
	__webpack_require__(523);__webpack_require__(518);__webpack_require__(517);__webpack_require__(515);__webpack_require__(521);__webpack_require__(519);__webpack_require__(524);__webpack_require__(514);__webpack_require__(522);__webpack_require__(516);__webpack_require__(520);var _reactRedux=__webpack_require__(4);var _underscore=__webpack_require__(22);var _underscore2=_interopRequireDefault(_underscore);var _nestedProperty=__webpack_require__(10);var _nestedProperty2=_interopRequireDefault(_nestedProperty);var _sharedSelectSelectWrap=__webpack_require__(37);var _sharedSelectSelectWrap2=_interopRequireDefault(_sharedSelectSelectWrap);var _emailAddressComposer=__webpack_require__(1098);var _emailAddressComposer2=_interopRequireDefault(_emailAddressComposer);var _confirmationDialog=__webpack_require__(1097);var _confirmationDialog2=_interopRequireDefault(_confirmationDialog);var _attachmentDialog=__webpack_require__(606);var _attachmentDialog2=_interopRequireDefault(_attachmentDialog);var _stateConstants=__webpack_require__(11);var _stateConstants2=_interopRequireDefault(_stateConstants);var _moment=__webpack_require__(12);var _moment2=_interopRequireDefault(_moment);var _helpersJsx=__webpack_require__(368); //import {WillemotEmails} from '../environments.coffee'
	var _reactSelect=__webpack_require__(105);var _reactSelect2=_interopRequireDefault(_reactSelect);var _emailServerConfigDialog=__webpack_require__(367);var _emailServerConfigDialog2=_interopRequireDefault(_emailServerConfigDialog);var _=(0,_libI18n2['default'])('emailSender');var listOfFields=["recipientField","emailTemplateField","emailLanguageField","emailFromField","emailToSelectField","emailToSelectFieldCC","subjectField","emailBodyField","signatureField","attachmentsForValidateOnly","brokerField"]; /* const listOfRequiredFields = ["recipientField", "emailFromField", "emailToSelectField",
	    "subjectField", "emailBodyField"] */var brokerFieldIsRequired=false;var DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY="linkPlaceholder";var DSWIZARD_RECIPIENT_NAME_PLACEHOLDER_TRANS_KEY="fullNamePlaceholder"; // let DISCLAIMER_PLACEHOLDER_TRANS_KEY = "disclaimerPlaceholder"
	var DSWIZARD_DISCLAIMER_RESTRICTED_TEMPLATE_SET="coupure 212";var EMAIL_TYPE_QUICK_REPLY="EMAIL_TYPE_QUICK_REPLY";var EMAIL_TYPE_DEFAULT="EMAIL_TYPE_DEFAULT"; /**
	 * Custom dropdown indicator for react-select to be the similar style lik emailFromField: _('emailFromFieldServerConfigMissing')
	 */var NoOptionsMessageForTemplateSelector=function NoOptionsMessageForTemplateSelector(props){return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(_reactSelect.components.NoOptionsMessage,props,_('noTemplateOptions'));};exports.NoOptionsMessageForTemplateSelector = NoOptionsMessageForTemplateSelector; /**
	 * Validation function for react form when checking email components.
	 * @param {array} values
	 * @param {object} extraConditions - structure: {<fieldName as  property name>: { error: <string> }}
	 */var validate=function validate(values){var extraConditions=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var errors={}; // recipientField not be empty
	if(brokerFieldIsRequired && _underscore2['default'].isEmpty(values.brokerField)){errors.brokerField = _('brokerFieldIsRequired');} // recipientField not be empty
	if(_underscore2['default'].isEmpty(values.recipientField)){errors.recipientField = _('recipientFieldIsRequired');} // emailFromField not to be empty
	if(_underscore2['default'].isEmpty(values.emailFromField)){errors.emailFromField = _('emailFromFieldIsRequired');} // minimum one to address is required for emailToSelectField
	if(_underscore2['default'].isEmpty(values.emailToSelectField)){errors.emailToSelectField = _('youHaveToGiveMinimumOneEmail');} // If not empty have to validate
	if(!_underscore2['default'].isEmpty(values.emailToSelectField) && values.emailToSelectField.length === 0){errors.emailToSelectField = _('youHaveToGiveMinimumOneEmail');} // emailToSelectField if not empty have to validate
	if(!_underscore2['default'].isEmpty(values.emailToSelectField)){(function(){var hasErrorAnError=false;values.emailToSelectField.forEach(function(item){if(item && item.value && typeof item.value === 'string' && item.value.trim())return;hasErrorAnError = hasErrorAnError || item && item.value && item.value.length == 0;});if(hasErrorAnError){errors.emailToSelectField = _("youHaveToGiveMinimumOneEmail");}else {values.emailToSelectField.forEach(function(item){hasErrorAnError = hasErrorAnError || item && item.value && typeof item.value === 'string' && !(0,_libValidator.isAnEmail)(item.value.trim());});if(hasErrorAnError){errors.emailToSelectField = _("invalidInputEmailTo");}}})();} // emailToSelectFieldCC if not empty have to validate
	if(!_underscore2['default'].isEmpty(values.emailToSelectFieldCC)){(function(){var hasErrorAnError=false;values.emailToSelectFieldCC.forEach(function(item){hasErrorAnError = hasErrorAnError || item && item.value && typeof item.value === 'string' && !(0,_libValidator.isAnEmail)(item.value.trim());});if(hasErrorAnError){errors.emailToSelectFieldCC = _("invalidInputEmailToCC");}})();} // subjectField cant be not empty
	if(_underscore2['default'].isEmpty(values.subjectField)){errors.subjectField = _('emailBodyFieldIsRequired');} // emailBodyField cant be not empty
	if(_underscore2['default'].isEmpty(values.emailBodyField)){errors.emailBodyField = _('emailBodyFieldIsRequired');} // ++++++ check MULTI LANGUAGE and link obligation
	// this validation is differ by the dedicated validation of the redux-form because
	// depends on external values of the form, what can't be passed for
	if(extraConditions){var extraEmailBodyError="";if(extraConditions.multiLanguage && extraConditions.stakeholders){var langMap=extraConditions.stakeholders.map(function(one){return one.language;}); // Make sure if the link placeholder exists
	if(langMap.some(function(one){return String(one).toLocaleLowerCase() === 'nl';})){var translatedPHolder=_(DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY,"nl");if(!String(extraConditions.nlBody).includes(translatedPHolder)){ // make sure the field exists
	extraEmailBodyError = _("privateLinkPlaceholderMissingOnNl");}} // Make sure if the link placeholder exists
	if(langMap.some(function(one){return String(one).toLocaleLowerCase() === 'fr';})){var translatedPHolder=_(DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY,"fr");if(!String(extraConditions.frBody).includes(translatedPHolder)){ // make sure the field exists
	extraEmailBodyError = _("privateLinkPlaceholderMissingOnFr");}}} // set the error for the field
	if(extraEmailBodyError){errors.emailBodyField = extraEmailBodyError;}} // ----------------------------------------------------------
	// all attachments alias names must be valid
	if(!_underscore2['default'].isEmpty(values.attachmentsForValidateOnly)){values.attachmentsForValidateOnly.forEach(function(item){if(item.aliasFileName && item.aliasFileName.trim()){if(item.aliasFileName.length > 250){errors.attachmentsForValidateOnly = _('attachmentAliasNameTooLong') + " " + item.aliasFileName;}else {var regexExceptions=/[\/\\\%\|\<\>\"\:\?]+/g;var foundNotAllowed=item.aliasFileName.match(regexExceptions);if(foundNotAllowed && foundNotAllowed.length > 0){errors.attachmentsForValidateOnly = _('attachmentAliasNameContainsNotAllowed') + " " + item.aliasFileName;}}}else {errors.attachmentsForValidateOnly = _('attachmentAliasCanNotEmpty');}});}return errors;}; // this is out of order, if editor is working correctly should remove the
	// "actualCaretPositionBookmark" variable
	// Variables outside the module
	// let actualCaretPositionBookmark = 0
	/**
	 * Email sender form component for composing emails.
	 */ // validateOnBlur: true,
	//  asyncValidating: true
	var SenderForm=(function(_React$Component){_inherits(SenderForm,_React$Component);_createClass(SenderForm,null,[{key:'propTypes',value:{fields:_react2['default'].PropTypes.object.isRequired,options:_react2['default'].PropTypes.object.isRequired,dataCallback:_react2['default'].PropTypes.func,dataCallbackDisableSend:_react2['default'].PropTypes.func,setDisclaimerForPreview:_react2['default'].PropTypes.func,onSentLate:_react2['default'].PropTypes.func,isCreatable:_react2['default'].PropTypes.bool,forceIsMulti:_react2['default'].PropTypes.bool,haveDisclaimer:_react2['default'].PropTypes.bool},enumerable:true}]);function SenderForm(props){_classCallCheck(this,_SenderForm);_get(Object.getPrototypeOf(_SenderForm.prototype),'constructor',this).call(this,props);this.getIcon = function(iconName){try{return __webpack_require__(173)("./" + iconName);}catch(err) {return __webpack_require__(261);}};this.state = {theBodyEditor:null,templateContent:'',brokerOptions:[],templatesOptions:[],templateRecipients:[],emailToOptions:[],emailFromOptions:[],selectedEmailFromName:'',langOptions:[],signatureOptions:[],variables:[],attachments:[],finalEmail:{},moduleOptions:{},moduleSpecificClaimAttachemnts:[],moduleSpecificContractAttachemnts:[],moduleSpecificClientAttachemnts:[],moduleSpecificTarificationAttachemnts:[],moduleSpecificTicketAttachemnts:[],hardAttachments:[], // this documents will attached like real attachments not only links
	lastError:false,precacheInProgress:false,isCCShown:false,emailServerConfigError:'', // the followings are used only when the language is selectable:
	activeLanguageTabValue:'',nlLanguageTabBodyValue:null,nlLanguageTabSubjectValue:null,frLanguageTabBodyValue:null,frLanguageTabSubjectValue:null};} /**
	 * This is the master Email sender component. Used for compose and send emails.
	 */ /**
	     * This function triggered when the module was mounted.
	     */_createClass(SenderForm,[{key:'componentDidMount',value:function componentDidMount(){var _props,dispatch,moduleOptions,initResult,hardAttachments,baseModuleOptions,mergeResult,emailRecentRecipientsResult,brokerOptions,templatesOptions,preapredAttachments;return regeneratorRuntime.async(function componentDidMount$(context$2$0){var _this=this;while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props = this.props;dispatch = _props.dispatch;moduleOptions = _props.options.moduleOptions;context$2$0.next = 5;return regeneratorRuntime.awrap(this.processArgumentInitialValue());case 5:initResult = context$2$0.sent;hardAttachments = initResult.hardAttachments;baseModuleOptions = this.getUpdatedModuleOptionsByBrokerFromOffice(moduleOptions,moduleOptions.brokerNumber);mergeResult = this.initAndMixPropsToModuleOptionsState(moduleOptions,baseModuleOptions);moduleOptions = mergeResult.moduleOptions; // get the recently used email addresses to extend the recipient list
	if(!moduleOptions.brokerNumber){context$2$0.next = 18;break;}context$2$0.next = 13;return regeneratorRuntime.awrap(dispatch((0,_stateActions.loadEmailRecentRecipients)(moduleOptions.brokerNumber)));case 13:emailRecentRecipientsResult = context$2$0.sent;baseModuleOptions = this.getUpdatedModuleOptionsByBrokerFromOffice(moduleOptions);baseModuleOptions.emailRecentRecipients = emailRecentRecipientsResult;mergeResult = this.initAndMixPropsToModuleOptionsState(moduleOptions,baseModuleOptions);moduleOptions = mergeResult.moduleOptions;case 18:this.setupTinyMCE();mergeResult = this.initAndMixPropsToModuleOptionsState(moduleOptions,baseModuleOptions);moduleOptions = mergeResult.moduleOptions;this.initializeLanguage(moduleOptions.clientLanguage);brokerOptions = this.initializeBrokerOptions(moduleOptions.brokerNumber);templatesOptions = this.initializeTemplateOptions(); // preselect brokerEmail
	if(moduleOptions.brokerEmailAddress){ // this.onChangeEmailFromAddress({value: moduleOptions.brokerEmailAddress})
	// moduleOptions = this.do TheBrokerChange(moduleOptions, {value: moduleOptions.brokerNumber})
	this.updateFormValue({value:moduleOptions.brokerEmailAddress},this.props.fields.emailFromField);} // preselect template
	if(moduleOptions.autoSelectTemplate){ //this.updateFormValue({value: "0"}, this.props.fields.emailTemplateField)
	this.doTheTemplateSwitch(moduleOptions.brokerNumber,moduleOptions.clientLanguage,{value:"0"},moduleOptions.brokerEmailAddress);}this.initializeSignatures(moduleOptions.brokerNumber);preapredAttachments = moduleOptions.ticketDocuments && moduleOptions.ticketDocuments.map(function(oneAttachment){return _extends({},oneAttachment,{aliasFileName:_this.getDefaultAliasForFileNameInAttachments(oneAttachment.name,oneAttachment.date,oneAttachment.id)});}) || []; // once to do the set state at the end of hook (if it possible)
	this.setState({hardAttachments:hardAttachments,moduleOptions:moduleOptions,brokerOptions:brokerOptions,templatesOptions:templatesOptions,activeLanguageTabValue:this.state.activeLanguageTabValue || moduleOptions.clientLanguage,moduleSpecificTicketAttachemnts:preapredAttachments,attachments:preapredAttachments});case 29:case 'end':return context$2$0.stop();}},null,this);} /**
	     * Handle props changes to map values in state
	     * @param {*} nextProps
	     */},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){ // +++ TICKED DOCUMENTS set all selected by default if the moduleKey is inboxReplyToWillemot +++
	var moduleKey=_nestedProperty2['default'].get(nextProps,"options.moduleKey");var EmailTemplateRelations=_nestedProperty2['default'].get(nextProps,"options.EmailTemplateRelations");if(moduleKey == EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value){var nextTicketDocuments=_nestedProperty2['default'].get(nextProps,"options.moduleOptions.ticketDocuments") || [];var currentTicketDocuments=_nestedProperty2['default'].get(this.props,"options.moduleOptions.ticketDocuments") || [];if(JSON.stringify(nextTicketDocuments) !== JSON.stringify(currentTicketDocuments)){var currentStateTicketDocuments=_nestedProperty2['default'].get(this.state,"moduleSpecificTicketAttachemnts") || [];if(JSON.stringify(nextTicketDocuments) !== JSON.stringify(currentStateTicketDocuments)){this.setState({moduleSpecificTicketAttachemnts:nextTicketDocuments});}}} // --- END handle the change of the moduleOptions.ticketDocuments ---
	} /**
	     * Using the values for initialization what are coming from other modules like inbox
	     */},{key:'processArgumentInitialValue',value:function processArgumentInitialValue(){var _props2,dispatch,externalAttachments,hardAttachments,extendedAttachments;return regeneratorRuntime.async(function processArgumentInitialValue$(context$2$0){var _this2=this;while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props2 = this.props;dispatch = _props2.dispatch;externalAttachments = _props2.options.externalAttachments;hardAttachments = []; // must generate aliases and extend the document list to be able the user to edit the name before send
	if(externalAttachments && externalAttachments.length > 0){externalAttachments.forEach(function(item,index){hardAttachments.push(_extends({},item,{aliasFileName:_this2.getDefaultAliasForFileNameInAttachments(item.name,item.date,item.id)}));});} // set hard attachments. This time this is the only way to add real attachments for mails
	// sync call
	hardAttachments = hardAttachments || []; // hard attachment precache
	if(_underscore2['default'].isEmpty(hardAttachments)){context$2$0.next = 11;break;}context$2$0.next = 9;return regeneratorRuntime.awrap(this.doThePrecache(hardAttachments));case 9:extendedAttachments = context$2$0.sent;hardAttachments = extendedAttachments.filter(function(oneAttachment){return Boolean(oneAttachment.localId);});case 11:context$2$0.next = 13;return regeneratorRuntime.awrap(dispatch((0,_stateActions.setEmailSenderExternalAttachments)(null)));case 13:return context$2$0.abrupt('return',{hardAttachments:hardAttachments});case 14:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This function will update the moduleOptions state property by store if there are changes.
	     * The moduleOption is a set of
	     * @param {object} moduleOptionByProps
	     * @param {object} moduleOptionsNewState
	     * @returns {bool} true if the set state was called, false if not because nothing changed
	     */},{key:'initAndMixPropsToModuleOptionsState',value:function initAndMixPropsToModuleOptionsState(moduleOptionByProps,moduleOptionsNewState){ // must use this to do not overwrite the original value fo parameter
	moduleOptionByProps = moduleOptionByProps || {}; // clone and clean to be able compare the differences what requires to update state of "module options"
	// because the async api calls pass values after modal was initialized, and here must handle the changes
	var incomingPropsWithoutBrokerRelated=JSON.parse(JSON.stringify(moduleOptionByProps));delete incomingPropsWithoutBrokerRelated.officeContract;delete incomingPropsWithoutBrokerRelated.commercialOfficeName;delete incomingPropsWithoutBrokerRelated.brokerNumber;delete incomingPropsWithoutBrokerRelated.emailRecentRecipients;var nextStateWithoutBrokerRelated=JSON.parse(JSON.stringify(moduleOptionsNewState));delete nextStateWithoutBrokerRelated.officeContract;delete nextStateWithoutBrokerRelated.commercialOfficeName;delete nextStateWithoutBrokerRelated.brokerNumber;delete nextStateWithoutBrokerRelated.emailRecentRecipients; // the broker number used from props if in the state is empty
	var mustBeTheBrokerNumber=moduleOptionsNewState && moduleOptionsNewState.brokerNumber;if(moduleOptionByProps.brokerNumber && !mustBeTheBrokerNumber){mustBeTheBrokerNumber = moduleOptionByProps.brokerNumber;} // update state if there are changes or the brokerNumber update, else does not change values to
	// prevent triggering of component update
	var wasAChange=false;if(JSON.stringify(incomingPropsWithoutBrokerRelated) !== JSON.stringify(nextStateWithoutBrokerRelated) || moduleOptionsNewState.brokerNumber !== mustBeTheBrokerNumber || this.state.moduleOptions.officeContract !== moduleOptionsNewState.officeContract || this.state.moduleOptions.commercialOfficeName !== moduleOptionsNewState.commercialOfficeName || JSON.stringify(this.state.moduleOptions.emailRecentRecipients) !== JSON.stringify(moduleOptionsNewState.emailRecentRecipients)){ // was changed to avoid to do the next stuffs in the componentWillUpdate hook
	wasAChange = true;} // init the result with original state values
	var newModuleOptions=JSON.parse(JSON.stringify(moduleOptionsNewState)); // if was changes put it to the result
	if(wasAChange){newModuleOptions = _extends({},incomingPropsWithoutBrokerRelated,{officeContract:moduleOptionsNewState && moduleOptionsNewState.officeContract,commercialOfficeName:moduleOptionsNewState && moduleOptionsNewState.commercialOfficeName,emailRecentRecipients:moduleOptionsNewState && moduleOptionsNewState.emailRecentRecipients,brokerNumber:mustBeTheBrokerNumber});}return {moduleOptions:newModuleOptions,wasAChange:wasAChange};} /**
	     * This function will initialize the language field in form.
	     */},{key:'initializeLanguage',value:function initializeLanguage(clientLanguage){ // we have to initialize the language of the curent template to the broker prefered language
	var initialEmailLang=this.fetchRecipientLanguage(clientLanguage);var fields=this.props.fields;this.updateFormValue({value:initialEmailLang},fields.emailLanguageField);} /**
	     * This function will initialize the signature field. Selecting the default signature,
	     * or the first one if there are no default signature.
	     */},{key:'initializeSignatures',value:function initializeSignatures(brokerNumber){var signatures=this.props.options.signatures;var fields=this.props.fields;var moduleOptions=this.state.moduleOptions;var isOffice=moduleOptions && moduleOptions.dsPackage && moduleOptions.dsPackage.uploadedOnModule === _stateConstants2['default'].DS_MODULE_OFFICE; // compose value for hold "id" and "html" for preview and keep Id also
	// try to get the default signature by filtering broker number and isDefault
	var initialSignature=signatures && signatures.filter(function(val){return val.isDefault && (val.brokerNumber == brokerNumber || !brokerNumber);}) || false; // after filtering only one element remains, fetch from array because that is the first one
	// as per BEWB 781 if package from office don't show signature
	initialSignature = initialSignature && initialSignature.length > 0 && initialSignature[0] || false;var signatureId=initialSignature && !isOffice?initialSignature._id:'';this.updateFormValue({value:signatureId},fields.signatureField);} /**
	     * This function will set state for the template selector input.
	     * Insert the list of templates like an array contains plain JS objects (label, value).
	     */},{key:'initializeTemplateOptions',value:function initializeTemplateOptions(){var _props$options=this.props.options;var templates=_props$options.templates;var lang=_props$options.lang;var templatesOptions=templates && templates.map(function(templateValue,templateIndex){return {value:String(templateIndex),label:templateValue.title[lang]};}).sort(function(templateA,templateB){if(templateA.label < templateB.label){return -1;}if(!templateA.label > templateB.label){return 1;}if(templateA.label === templateB.label){return 0;}});return templatesOptions;} /**
	     * This function will set state for the broker selector input.
	     * Insert the list of broker like an array contains plain JS objects (label, value).
	     * @param {*} forceBrokerNumber On contracts module we have preselected broker number depending on contract
	     */},{key:'initializeBrokerOptions',value:function initializeBrokerOptions(forceBrokerNumber){var _props3=this.props;var brokers=_props3.options.brokers;var brokerField=_props3.fields.brokerField;var usedBrokerIndex=0;var brokerOptions=brokers && Object.keys(brokers).map(function(brokerKey,index){ // find the index of the used broker from options
	if(brokers[brokerKey].brokerNumber === forceBrokerNumber){usedBrokerIndex = index;} // transform raw broker info into selectable option for dropdowns
	return {value:brokerKey,label:brokers[brokerKey].brokerNumber + " - " + brokers[brokerKey].main.name};}); //implemented a default broker value
	if(brokerField && !brokerField.value){this.onChangeBroker({value:brokerOptions[usedBrokerIndex].value});}return brokerOptions;} /**
		 * We have to reset the references because the editors will reinitialize on mount.
		 */},{key:'componentWillUnmount',value:function componentWillUnmount(){this.unmountTinyMCE();} /**
	     * This function handle the touch event, to trigger blur.
	     * @param {*} field
	     */},{key:'touch',value:function touch(field){} //field.onBlur()
	/**
	     * Only place where we use the module options from props.options because that contains only
	     * the incoming data, but the in the this.state.moduleOptions we extend by a few other common value
	     * what are the same role.
	     */},{key:'getUpdatedModuleOptionsByBrokerFromOffice',value:function getUpdatedModuleOptionsByBrokerFromOffice(moduleOptions){var forcedBrokerNumber=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var office=this.props.options.office; // override forced the broker number if that is set in arguments list
	var determinedBrokerNumber=forcedBrokerNumber || moduleOptions && moduleOptions.brokerNumber; // when the parameter is an empty string we have to set empty value for the selected brokerNumber
	if(typeof forcedBrokerNumber == 'string' && forcedBrokerNumber === ''){determinedBrokerNumber = forcedBrokerNumber;} // clone the moduleOptions
	var newModuleOptions=JSON.parse(JSON.stringify(moduleOptions)); // get the brokers office info and put it in the moduleOption
	newModuleOptions.officeContract = determinedBrokerNumber?_nestedProperty2['default'].get(office,"brokers." + determinedBrokerNumber + ".main.contractType"):'';newModuleOptions.commercialOfficeName = determinedBrokerNumber?_nestedProperty2['default'].get(office,"brokers." + determinedBrokerNumber + ".main.commercialName"):'';newModuleOptions.company = moduleOptions.company || '';newModuleOptions.brokerNumber = determinedBrokerNumber;return newModuleOptions;} /**
	     * Generate valid fresh value for using the selected template
	     * @param {*} emailTemplateFieldValue
	     */},{key:'getNewSelectedTemplate',value:function getNewSelectedTemplate(emailTemplateFieldValue){var templates=this.props.options.templates;var selectedTemplate=!_underscore2['default'].isEmpty(templates) && (!_underscore2['default'].isEmpty(emailTemplateFieldValue) || emailTemplateFieldValue === "0") && templates.filter(function(template,templateIndex){return String(templateIndex) === emailTemplateFieldValue;}) || false; //if ((!selectedTemplate || selectedTemplate.length === 0) && )
	selectedTemplate = !_underscore2['default'].isEmpty(selectedTemplate) && selectedTemplate[0] || false;return selectedTemplate;} /**
	     * Generate value for template content
	     * @param {*} selectedTemplate
	     */},{key:'getNewTemplateContent',value:function getNewTemplateContent(selectedTemplate){var templateContent=false;try{templateContent = selectedTemplate && selectedTemplate.templateContent && JSON.parse(selectedTemplate.templateContent) || false;}catch(exeption) {console.error(exeption); // TODO dispatch error message notification : Error loading template try again later.
	}return templateContent;} /**
	     * This function will provide the recipient list by the object created the template editor
	     * @param {*} templateContent
	     * @param {*} moduleOptions
	     */},{key:'getNewTemplateRecipients',value:function getNewTemplateRecipients(templateContent,moduleOptions){var _props$options2=this.props.options;var EmailTemplateRelations=_props$options2.EmailTemplateRelations;var moduleKey=_props$options2.moduleKey;var templateRecipients=!_underscore2['default'].isEmpty(templateContent) && templateContent.recipients || false;templateRecipients = !_underscore2['default'].isEmpty(templateRecipients) && templateRecipients.filter(function(oneRec,indexRec){var isFoundInTheWhiteList=EmailTemplateRelations.recipientsWithModules.filter(function(whiteRec,whiteRecIndex){return !_underscore2['default'].isEmpty(whiteRec.moduleWhiteList) && whiteRec.moduleWhiteList.indexOf(moduleKey) > -1 && whiteRec.value === oneRec.value;}); // BEWB-730
	// special scenario to filtering the recipient, because in quickReply mode from inbox can let one recipient depending
	// on what entity ID is provided by the ticket. The template must contain all willemot kind recipients, but we have to
	// filter out after the existing enitity ID
	if(moduleOptions.quickReply && moduleOptions.startedFromModule === _stateConstants2['default'].EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT){if(moduleOptions.claimId){return oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value;}else if(moduleOptions.contractId){return oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value;}else if(moduleOptions.tarificationId){return oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotTarification.value;}else { // just client ID what we have, we can let the simple willemot recipient, hut this must be asked
	return oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemot.value || oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value;}}return !_underscore2['default'].isEmpty(isFoundInTheWhiteList) && isFoundInTheWhiteList.length > 0 || false;}) || false;return templateRecipients;} /**
	     * This fuction make selected the default recipient
	     * @param {array} templateRecipients
	     * @param {array} moduleOptions
	     */},{key:'makeSelectedDefaultRecipient',value:function makeSelectedDefaultRecipient(templateRecipients,moduleOptions){var _this3=this;var _props4=this.props;var fields=_props4.fields;var EmailTemplateRelations=_props4.options.EmailTemplateRelations;var defaultRec=false; // default to select
	if(templateRecipients){templateRecipients.forEach(function(oneRec){ // BEWB-730
	// special scenario to marking the recipient as default, because in quickReply mode from inbox can let one recipient depending
	// on what entity ID is provided by the ticket and that must be dafault selected.
	if(moduleOptions.quickReply && moduleOptions.startedFromModule === _stateConstants2['default'].EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT){if(moduleOptions.claimId && oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value){oneRec['default'] = true;}else if(moduleOptions.contractId){oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value;oneRec['default'] = true;}else if(moduleOptions.tarificationId){oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotTarification.value;oneRec['default'] = true;}else { // just client ID what we have, we can let the simple willemot recipient as default
	oneRec['default'] = true;}}if(oneRec['default']){ // if default we have to return to use for filling in the form with related values
	defaultRec = JSON.parse(JSON.stringify(oneRec)); // if the same what was before we dont do the change, preventing unnecessary component update
	if(fields.recipientField.value !== oneRec.value){_this3.updateFormValue({value:oneRec.value},fields.recipientField);}}});}return defaultRec;} /**
	     * This function will provide all email addresses available for "TO" recipient of email.
	     * @param {*} recipientValue
	     * @param {*} templateRecipients
	     */},{key:'getNewEmailToOptions',value:function getNewEmailToOptions(recipientValue,templateRecipients,templateContent){var willemotInCc=arguments.length <= 3 || arguments[3] === undefined?false:arguments[3];var fechedEmailAddresses=this.fetchRecipientEmails(recipientValue,templateRecipients,templateContent,willemotInCc);var emailToOptions=[]; // underscore can check the empty array/object also as empty,
	if(!_underscore2['default'].isEmpty(fechedEmailAddresses)){emailToOptions = fechedEmailAddresses.map(function(recEmail){return {value:recEmail.value,label:(recEmail.label || "") + " <" + recEmail.value + ">",name:recEmail.label,isPermanentSelected:!!recEmail.isPermanentSelected,isRecent:!!recEmail.isRecent,isCC:!!recEmail.isCC};});}return emailToOptions;} /**
	     * This function will return with all of the email addresses for "FROM" list of email.
	     */},{key:'getNewEmailFromOptions',value:function getNewEmailFromOptions(){var userId=_nestedProperty2['default'].get(this.props,"options.userId");var moduleOptions=_nestedProperty2['default'].get(this.state,"moduleOptions");var brNr=moduleOptions.brokerNumber;var brokers=_nestedProperty2['default'].get(this.props,"options.office.brokers");var emailFromOptions=[]; // check if module is office this case from email address comes from a template selected in dswizard step one snd stored under broker email address 
	var uploadedOnModuleOffice=moduleOptions && moduleOptions.dsPackage && moduleOptions.dsPackage.uploadedOnModule === _stateConstants2['default'].DS_MODULE_OFFICE;if(uploadedOnModuleOffice){emailFromOptions.push({value:moduleOptions.dsPackage.brokerEmailAddress,label:moduleOptions.dsPackage.brokerEmailAddress});}else if(!_underscore2['default'].isEmpty(brokers)){Object.keys(brokers).forEach(function(brokerKey){ // filter only the current broker related emails
	var brokerNumber=_nestedProperty2['default'].get(brokers,brokerKey + ".brokerNumber");if(brNr && brokerNumber && brNr.localeCompare(brokerNumber) !== 0){return;} // collecting email addresses
	var emails=_nestedProperty2['default'].get(brokers,brokerKey + ".main.emails");var name=_nestedProperty2['default'].get(brokers,brokerKey + ".main.name") || _("unknownName");emailFromOptions = !_underscore2['default'].isEmpty(emails) && emailFromOptions.concat(emails.map(function(oneEmail){return {value:oneEmail,label:oneEmail //name + " <" + oneEmail + ">"
	};})) || emailFromOptions; // find the email address of the logged user by ID
	var staffList=_nestedProperty2['default'].get(brokers,brokerKey + ".staff");if(staffList && staffList.length > 0){staffList.forEach(function(oneStaff){if(oneStaff.userId == userId){emailFromOptions.push({value:oneStaff.email,label:oneStaff.email //oneStaff.firstName+" "+oneStaff.lastName+" <" +  oneStaff.email + ">"
	});}});}});} // BEWB-322 this part is removed as asked in task by silke and brecht
	// This part of the mail address finding is not sure it's needed.
	// const accountManagers = nesProp.get(this.props, "options.office.accountManagers")
	// if ( !underscore.isEmpty(accountManagers) && accountManagers.length > 0) {
	//     emailFromOptions = emailFromOptions.concat( accountManagers.filter((oneManager)=>{
	//         return !underscore.isEmpty( oneManager.email )
	//     }).map((oneManager)=>({
	//         value: oneManager.email,
	//         label: oneManager.email
	//         //(oneManager.name || oneManager.Name || _("unknownName")) + " <" + oneManager.email + ">"
	//     })))
	// }
	// filtering duplicated email addresses
	var result=[],helperAlreadyInserteds=[];if(emailFromOptions && emailFromOptions.length > 0){emailFromOptions.forEach(function(val,index){if(helperAlreadyInserteds.indexOf(val.value) === -1){result.push({value:val.value,label:val.label});helperAlreadyInserteds.push(val.value);}});}return result;} /**
	     * This function will return the "name" attached to an email address.
	     * @param {string} value
	     * @param {array} emailFromOptions
	     */},{key:'getNewEmailFromName',value:function getNewEmailFromName(value,emailFromOptions){var selectedEmailFromName=emailFromOptions.filter(function(elem){return elem.value === value;});selectedEmailFromName = selectedEmailFromName.length > 0?selectedEmailFromName[0].label:"";return selectedEmailFromName;} /**
	     * Return the language list for language select input.
	     */},{key:'getNewLangOptions',value:function getNewLangOptions(){return [{value:"nl",label:_('nl')},{value:"fr",label:_('fr')}];} /**
	     * This function returns a set of signature for signature select input.
	     */},{key:'getNewSignatureOptions',value:function getNewSignatureOptions(){var signatures=this.props.options.signatures;return signatures && signatures.map(function(val){return {value:val._id,label:val.name};}) || [];} /**
	     * This function will provide the variable list from template content by selected module and recipient
	     */},{key:'getNewVariables',value:function getNewVariables(templateContent,recipient){var _props$options3=this.props.options;var moduleKey=_props$options3.moduleKey;var EmailTemplateRelations=_props$options3.EmailTemplateRelations;return _nestedProperty2['default'].get(templateContent,"content." + recipient + ".independents.variables") || [];} /**
	     * This function will provide the indexType of template after the given recipient from the
	     * Given templateContent object
	     * @param {object} templateContent
	     * @param {string} recipient
	     */},{key:'getNewTemplateIndexType',value:function getNewTemplateIndexType(templateContent,recipient){var _props$options4=this.props.options;var moduleKey=_props$options4.moduleKey;var EmailTemplateRelations=_props$options4.EmailTemplateRelations;return _nestedProperty2['default'].get(templateContent,"content." + recipient + ".independents.indextype") || {};} /**
	     * This will generate email html content
	     */},{key:'getNewEmailContentHtml',value:function getNewEmailContentHtml(){var emailBodyField=this.props.fields.emailBodyField; //compose and return result html
	return emailBodyField && this.parseAndReplaceVariables(emailBodyField.value,this.state.activeLanguageTabValue) || "";} /**
	     * This will generate email html content
	     */},{key:'getNewEmailSignatureHtml',value:function getNewEmailSignatureHtml(){var signatureField=this.props.fields.signatureField;var signatures=this.props.options.signatures; // fetch signature data
	var signatureId=signatureField && signatureField.value;var slectedSignatureDoc=signatures && signatures.filter(function(item){return item._id == signatureId;});var signatureHtml=_nestedProperty2['default'].get(slectedSignatureDoc,"0.content") || ''; //compose and return result html
	return signatureHtml;} /**
	     * This function will give you an array, contains all of the drv property values of all img tags
	     * from of the selected signature html
	     */},{key:'getSelectedSignatureUsedImagesUrlList',value:function getSelectedSignatureUsedImagesUrlList(){var signatureField=this.props.fields.signatureField;var signatures=this.props.options.signatures; // fetch signature data
	var signatureId=signatureField && signatureField.value;var slectedSignatureDoc=signatures && signatures.filter(function(item){return item._id == signatureId;});var signatureHtml=_nestedProperty2['default'].get(slectedSignatureDoc,"0.content") || '';var listOfImageUrls=(0,_helpersJsx.fetchSrcValuesFromHtml)(signatureHtml);return listOfImageUrls;} /**
	     * This function make a quick validation, and return with result.
	     */},{key:'forceValidate',value:function forceValidate(){var _this4=this;var fieldsForValidate={}; // const {emailServerConfigError} = this.state
	Object.keys(this.props.fields).forEach(function(key){fieldsForValidate[key] = _this4.props.fields[key].value;}); // let errors = null
	// errors = validate(fieldsForValidate)
	// if(emailServerConfigError && emailServerConfigError.length > 0){
	//     errors.emailFromField = emailServerConfigError
	// }
	// return errors
	// v8
	// attach more complex, extra validation conditions for the form validation
	// the version 4.2.0 of redux-form, not sure if have an official way to validate
	// the form by extra corelation of values but the field values, maybe if you are using
	// <Field ... tags instead of third party type of fields like tinyMCE, can be added some
	// validate = {something} argument
	var extraConditions={multiLanguage:this.props.options.multiLanguage,stakeholders:this.state.moduleOptions.stakeholders,nlBody:this.state.nlLanguageTabBodyValue,frBody:this.state.frLanguageTabBodyValue};return validate(fieldsForValidate,extraConditions);} /**
	     * This function return with a boolean value when the redux-form fields contains error
	     */},{key:'hasErrors',value:function hasErrors(){var errors=this.forceValidate();return errors && Object.keys(errors).length > 0?errors:false;} /**
	     * Triggered before update the module.
	     * @param {object} nextProps
	     * @param {object} nextState
	     */},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){var _props5=this.props;var _props5$fields=_props5.fields;var emailTemplateField=_props5$fields.emailTemplateField;var recipientField=_props5$fields.recipientField;var emailLanguageField=_props5$fields.emailLanguageField;var emailFromField=_props5$fields.emailFromField;var emailToSelectField=_props5$fields.emailToSelectField;var emailToSelectFieldCC=_props5$fields.emailToSelectFieldCC;var subjectField=_props5$fields.subjectField;var emailBodyField=_props5$fields.emailBodyField;var signatureField=_props5$fields.signatureField;var _props5$options=_props5.options;var templates=_props5$options.templates;var lang=_props5$options.lang;var EmailTemplateRelations=_props5$options.EmailTemplateRelations;var moduleKey=_props5$options.moduleKey;var isPhone=_props5.isPhone;var goBack=_props5.goBack;var office=_props5.office; // don't let to continue update because of the new state values needed, what will be in the state in
	// te next update
	var mergeResult=this.initAndMixPropsToModuleOptionsState(nextProps.options.moduleOptions,nextState.moduleOptions);if(mergeResult.wasAChange){this.initializeSignatures(mergeResult.moduleOptions.brokerNumber);this.setState({moduleOptions:mergeResult.moduleOptions});return;} // check if we have to set state by watching the props
	var langOptions=this.getNewLangOptions(); // sync, independent
	if(JSON.stringify(langOptions) !== JSON.stringify(nextState.langOptions)){return this.setState({langOptions:langOptions});} // we have to initialize the content of message body here separately because it is not a regular form field
	// REMOVED BECAUSE IT RESET THE CURSOR IN EDITOR WHEN WE DO A COMPLETE CONTENT SWITCH
	/* if( nextProps.fields.emailBodyField.value !== this.props.fields.emailBodyField.value ) {
	            this.initializeBodyEditor(
	                nextProps.fields.emailBodyField.value,
	                nextProps.fields.recipientField.value,
	                nextProps.fields.emailLanguageField.value
	            )
	        } */ // check if we have to set state by watching the props
	var signatureOptions=this.getNewSignatureOptions();if(JSON.stringify(signatureOptions) !== JSON.stringify(nextState.signatureOptions)){return this.setState({signatureOptions:signatureOptions});} // process email details for providing
	var rec=_nestedProperty2['default'].get(nextProps.fields,"recipientField.value") || '';var selectedLangVal=_nestedProperty2['default'].get(nextProps.fields,"emailLanguageField.value") || '';var selectedTemplateVal=_nestedProperty2['default'].get(nextProps.fields,"emailTemplateField.value") || '';var selectedTemplate=this.getNewSelectedTemplate(selectedTemplateVal);var templateContent=this.getNewTemplateContent(selectedTemplate);var templateRecipients=this.getNewTemplateRecipients(templateContent,nextState.moduleOptions);var recName=templateRecipients && templateRecipients.filter(function(item){return item.value == rec;});recName = recName && recName[0] && recName[0].value;var selectedTemplateIndexType=this.getNewTemplateIndexType(templateContent,rec);var abbreviation=_nestedProperty2['default'].get(selectedTemplate,"abbreviation." + selectedLangVal) || '';var templateTitle=_nestedProperty2['default'].get(selectedTemplate,"title." + selectedLangVal) || '';var toSelect=_nestedProperty2['default'].get(nextProps.fields,"emailToSelectField.value") || '';var toSelectCC=_nestedProperty2['default'].get(nextProps.fields,"emailToSelectFieldCC.value") || '';var toSelectEmailsChained=toSelect && Array.isArray(toSelect) && toSelect.length > 0?toSelect /* .filter((oneSelectedAddress)=>{return !oneSelectedAddress.isCC}) */.map(function(item){return item.value;}).join(';'):'';var ccSelectEmailsChained=toSelectCC && Array.isArray(toSelectCC) && toSelectCC.length > 0?toSelectCC /* .filter((oneSelectedAddress)=>{return !!oneSelectedAddress.isCC}) */.map(function(item){return item.value;}).join(';'):'';var signatureId=_nestedProperty2['default'].get(nextProps.fields,"signatureField.value");var fromName=this.state.selectedEmailFromName && this.state.selectedEmailFromName.split('<');fromName = fromName && Array.isArray(fromName) && fromName.slice(0,fromName.length - 1);fromName = fromName && Array.isArray(fromName) && fromName.join('');fromName = fromName && fromName.trim(); // we have implemented to attach file like a link but finally we only use the hardly attached files
	var allAttachmentTogether=[].concat(nextState.attachments || []).concat(nextState.hardAttachments || []);var moduleOptions=_nestedProperty2['default'].get(this.state,"moduleOptions"); // decide the module where was sent the email to able reassign the module in the future PDF uploads
	// EmailTemplateModules.clientsProfile
	var uploadedOnModule=_stateConstants2['default'].DS_MODULE_CLIENT_PROFILE;if(moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value){uploadedOnModule = _stateConstants2['default'].DS_MODULE_CLIENT_CONTRACT;}if(moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value || moduleKey == EmailTemplateRelations.EmailTemplateModules.claims.value){uploadedOnModule = _stateConstants2['default'].DS_MODULE_CLIENT_CLAIMS;}if(moduleKey == EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value){uploadedOnModule = _stateConstants2['default'].DS_MODULE_CLIENT_TARIFICATION;} //+++ TODO set value for uploadedOnModule for inboxReplyToWillemot +++
	// WHERE TO UPLOAD THE COPY OF THE EMAIL ON ORACELE - HERE TO MODIFY IF THE CLIENT PROFILE MODULE IS NOT GOOD
	if(moduleKey == EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value){ // TODO - here to give a different option, where to upload the copy of the email,
	// by default we use the client profile module
	uploadedOnModule = _stateConstants2['default'].DS_MODULE_CLIENT_PROFILE;}if(moduleKey === 'mifid' && moduleOptions && moduleOptions.dsPackage){uploadedOnModule = moduleOptions.dsPackage.uploadedOnModule;} //--- END OF TODO ---
	// the rest of options never should be arrived here like:
	// EmailTemplateModules.clientAccountApproval, EmailTemplateModules.mifid
	// Because this are used on server-side email sending.
	// compose the result object for the callback, this means the final hole data for email to send
	var finalEmail={brokerNumber:_nestedProperty2['default'].get(moduleOptions,"brokerNumber"),fromName:fromName || "",senderEmail:emailFromField.value || "",cleanSenderEmail:emailFromField.value || "",to:toSelectEmailsChained,cc:ccSelectEmailsChained,subject:subjectField.value,message:this.getNewEmailContentHtml(), // +++ the followings are used for serial multi language sending
	nlSubject:nextState.nlLanguageTabSubjectValue,nlMessage:nextState.nlLanguageTabBodyValue,frSubject:nextState.frLanguageTabSubjectValue,frMessage:nextState.frLanguageTabBodyValue, // --- end of multi language part ---
	signatureHtml:this.getNewEmailSignatureHtml(),disclaimerHtml:this.props.haveDisclaimer?_("disclaimerText",nextState.activeLanguageTabValue || "nl"):"",signatureImageUrls:this.getSelectedSignatureUsedImagesUrlList(), // attachments: nextState.attachments || [],
	attachments:[], // hardAttachments: nextState.hardAttachments || [],
	hardAttachments:allAttachmentTogether || [],recipient:recName,templateId:selectedTemplate._id,templateIndexType:_nestedProperty2['default'].get(selectedTemplateIndexType,"type") || '',templateLowValue:_nestedProperty2['default'].get(selectedTemplateIndexType,"lowValue") || '',templateTitle:templateTitle,templateAbbr:abbreviation,clientId:this.state.moduleOptions.clientId,contractId:this.state.moduleOptions.contractId,tarificationId:this.state.moduleOptions.tarificationId,claimId:this.state.moduleOptions.claimId,signatureId:signatureId, // test line the next 4 remove
	moduleKey:moduleKey,variables:EmailTemplateRelations.EmailTemplateVariables,moduleOptions:this.state.moduleOptions,moduleOptionsNotUpdated:this.props.options.moduleOptions,uploadedOnModule:uploadedOnModule,emailType:this.state.moduleOptions.quickReply?EMAIL_TYPE_QUICK_REPLY:EMAIL_TYPE_DEFAULT,ticketId:this.state.moduleOptions.ticketId || ''}; // if there are invalid field or precache in progress
	var hasErrorsValue=this.hasErrors() || this.state.precacheInProgress;this.props.dataCallbackDisableSend(hasErrorsValue); // calling the data provider for outher module if we have changes to prevent the refresh if obsolote
	if(JSON.stringify(finalEmail) !== JSON.stringify(nextState.finalEmail)){this.props.dataCallback(finalEmail);return this.setState({finalEmail:finalEmail});} // control multi language subject
	if(nextProps.fields.subjectField.value !== this.props.fields.subjectField.value){ // update multi language fields as well
	if(this.props.options.multiLanguage){if(nextState.activeLanguageTabValue === 'fr'){this.setState({frLanguageTabSubjectValue:nextProps.fields.subjectField.value});}else {this.setState({nlLanguageTabSubjectValue:nextProps.fields.subjectField.value});}}} // control multi language body
	if(nextProps.fields.emailBodyField.value !== this.props.fields.emailBodyField.value){ // update multi language fields as well
	if(this.props.options.multiLanguage){if(nextState.activeLanguageTabValue === 'fr'){this.setState({frLanguageTabBodyValue:nextProps.fields.emailBodyField.value});}else {this.setState({nlLanguageTabBodyValue:nextProps.fields.emailBodyField.value});}}}} /**
	     * This function will collect the available variable values for the body and subject
	    */},{key:'fetchEmailModuleVariableRealValues',value:function fetchEmailModuleVariableRealValues(selectedTemplate,language){var _props$options5=this.props.options;var moduleKey=_props$options5.moduleKey;var EmailTemplateRelations=_props$options5.EmailTemplateRelations;var moduleOptions=this.state.moduleOptions;_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.contractNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"contractNumber")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"clientNumber")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientName.fetchValue",_nestedProperty2['default'].get(moduleOptions,"clientName")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientName.doTranslate",false);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.signerName.doTranslate",false);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.privateLinkPlaceholder.doTranslate",false);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.privateSigningUrl.doTranslate",false);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.F2FSigningUrl.doTranslate",false);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.claimsNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimsNumber")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.templateTitleAbbr.fetchValue",_nestedProperty2['default'].get(selectedTemplate,"abbreviation." + language)) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.officeContract.fetchValue",_nestedProperty2['default'].get(moduleOptions,"officeContract")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.brokerNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"brokerNumber")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.commercialOfficeName.fetchValue",_nestedProperty2['default'].get(moduleOptions,"commercialOfficeName")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.company.fetchValue",_nestedProperty2['default'].get(moduleOptions,"company")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.contractBranch.fetchValue",_nestedProperty2['default'].get(moduleOptions,"contractBranche")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.carBrand.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.carBrand")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.chassisNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.chassisNumber")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.licensePlate.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.licensePlate")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.insuredValue.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.insuredValue")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.repairmanName.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.repName")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.repairmanFirstName.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.repFirstName")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.repairmanStreet.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.repStreet")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.repairmanStreetNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.repNumber")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.repairmanBox.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.repBox")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.repairmanPostalCode.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.repPostalCode")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.repairmanTown.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.repTown")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.repairmanPhoneNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.repPhone")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertName.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expName")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertFirstName.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expFirstName")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertStreet.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expStreet")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertStreetNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expNumber")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertBox.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expBox")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertPostalCode.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expPostalCode")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertTown.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expTown")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertPhoneNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expPhone")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.expertMail.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.expEmail")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.qualification.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claim.main.qualification") || _nestedProperty2['default'].get(moduleOptions,"claim.claimMain.qualification")) || '';var claimDate=_nestedProperty2['default'].get(moduleOptions,"claim.main.claimDate") || _nestedProperty2['default'].get(moduleOptions,"claim.claimMain.claimDate") || '';var claimDateMoment=(0,_moment2['default'])(claimDate,'YYYY-MM-DD',true);var claimDateIsValid=claimDateMoment.isValid();if(claimDateIsValid){claimDate = claimDateMoment.format("DD-MM-YYYY");}_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.claimDate.fetchValue",claimDate);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientStreet.fetchValue",_nestedProperty2['default'].get(moduleOptions,"clientData.mainAddress.street")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientStreetNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"clientData.mainAddress.number")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientBusNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"clientData.mainAddress.extension")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientPostalCode.fetchValue",_nestedProperty2['default'].get(moduleOptions,"clientData.mainAddress.postalCode")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientTown.fetchValue",_nestedProperty2['default'].get(moduleOptions,"clientData.mainAddress.locality")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.companyReference.fetchValue",_nestedProperty2['default'].get(moduleOptions,"claimDetail.companyReference")) || ''; // tarification variables
	_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.tarificationNumber.fetchValue",_nestedProperty2['default'].get(moduleOptions,"tarificationDetail.tarificationNumber")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.maingroupDescription.fetchValue",_nestedProperty2['default'].get(moduleOptions,"tarificationDetail.maingroupDescription")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.subgroupDescription.fetchValue",_nestedProperty2['default'].get(moduleOptions,"tarificationDetail.subgroupDescription")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.descriptionRisico.fetchValue",_nestedProperty2['default'].get(moduleOptions,"tarificationDetail.descriptionRisico")) || '';_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.brokerName.fetchValue",_nestedProperty2['default'].get(moduleOptions,"tarificationDetail.brokerName") || _nestedProperty2['default'].get(moduleOptions,"dsPackage.brokerName")); // v8
	// mifid wizard variables
	_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.F2FSigningUrl.fetchValue",_nestedProperty2['default'].get(moduleOptions,"dsPackage.F2FSigningUrl")) || '...'; // if the flag "usePlaceholdersForClientVariables" is true, must use placeholders, not real values, because of serial sending of the same email
	// for the clients, but before the sending must be replaced individually by the private custom values of the signer
	if(moduleOptions.usePlaceholdersForClientVariables){_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.F2FSigningUrl.fetchValue",DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.F2FSigningUrl.doTranslate",true);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.privateSigningUrl.fetchValue",DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.privateSigningUrl.doTranslate",true);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.privateLinkPlaceholder.fetchValue",DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.privateLinkPlaceholder.doTranslate",true);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientName.fetchValue",DSWIZARD_RECIPIENT_NAME_PLACEHOLDER_TRANS_KEY);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.clientName.doTranslate",true);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.signerName.fetchValue",DSWIZARD_RECIPIENT_NAME_PLACEHOLDER_TRANS_KEY);_nestedProperty2['default'].set(EmailTemplateRelations,"EmailTemplateVariables.signerName.doTranslate",true);} // nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.disclaimerPlaceholder.fetchValue", DISCLAIMER_PLACEHOLDER_TRANS_KEY)
	// nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.disclaimerPlaceholder.doTranslate", true)
	} /**
	     * This function will return with the default language code for initialize the modal language
	     * @param {*} clientLanguage
	     * @param {*} forceSelectedToEmail
	     * @returns
	     */},{key:'fetchRecipientLanguage',value:function fetchRecipientLanguage(){var clientLanguage=arguments.length <= 0 || arguments[0] === undefined?'':arguments[0];var forceSelectedToEmail=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var _props$options6=this.props.options;var moduleKey=_props$options6.moduleKey;var EmailTemplateRelations=_props$options6.EmailTemplateRelations;var contractManagerLanguage=_props$options6.contractManagerLanguage;var claimsManagersDetails=_props$options6.claimsManagersDetails;var lang=_props$options6.lang;var _props$fields=this.props.fields;var emailToSelectField=_props$fields.emailToSelectField;var recipientField=_props$fields.recipientField;var claimsManagerLanguage=false; // language of the client or the user
	var resultLang=clientLanguage || lang; // find selected recipient language if exists, the first recipient matter.
	var selectedToAddress=forceSelectedToEmail || _nestedProperty2['default'].get(emailToSelectField,'value.0.value');var haveClaimsManagerEmail=claimsManagersDetails && Array.isArray(claimsManagersDetails) && claimsManagersDetails.length > 0;if(haveClaimsManagerEmail && selectedToAddress){claimsManagersDetails.forEach(function(claimsManagerElem){if(claimsManagerElem.email && claimsManagerElem.email.localeCompare(selectedToAddress) === 0){claimsManagerLanguage = claimsManagerElem.lang;}});} // if there are no moduleKey passed to the email sender modal the we just use the current user language
	if(!moduleKey){return resultLang;} // decide the initial language after module
	switch(moduleKey){case EmailTemplateRelations.EmailTemplateModules.clientsProfile.value:{resultLang = clientLanguage || lang;break;}case EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value:{resultLang = clientLanguage || contractManagerLanguage || lang;break;}case EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value:{resultLang = clientLanguage || claimsManagerLanguage || lang;break;}case EmailTemplateRelations.EmailTemplateModules.claims.value:{ // there are no client in this case
	resultLang = claimsManagerLanguage || lang;break;}} // second level check: decide the initial language after recipient if selected
	var selectedRecipient=recipientField && recipientField.value;switch(selectedRecipient){case EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value:{resultLang = !_underscore2['default'].isEmpty(contractManagerLanguage) && contractManagerLanguage || lang;break;}case EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value:{resultLang = !_underscore2['default'].isEmpty(claimsManagerLanguage) && claimsManagerLanguage || lang;break;}case EmailTemplateRelations.EmailTemplateRecipients.client.value:{resultLang = clientLanguage || lang;break;}default:{ // if the email from the willemot recipient
	var forceEmailLang=this.getRecipientWillemotEmailsLangByEmail(forceSelectedToEmail);resultLang = forceEmailLang || resultLang || lang;}}return resultLang;} /**
	     * This function will parse and replace the variable values if exists. Return with the new string.
	     * @param {String} body - string for parse an replace by existing variables
	     * @param {String} language - when the placeholder is a translation key to translate
	     */},{key:'parseAndReplaceVariables',value:function parseAndReplaceVariables(body){var language=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var EmailTemplateRelations=this.props.options.EmailTemplateRelations;var varKeys=Object.keys(EmailTemplateRelations.EmailTemplateVariables);if(!_underscore2['default'].isEmpty(varKeys) && varKeys.length > 0 && body){(function(){var searchExp='',replaceExp='';body = String(body);varKeys.forEach(function(varKeyValue){searchExp = _nestedProperty2['default'].get(EmailTemplateRelations,"EmailTemplateVariables." + varKeyValue + ".value") || "unknownvar";replaceExp = _nestedProperty2['default'].get(EmailTemplateRelations,"EmailTemplateVariables." + varKeyValue + ".fetchValue") || ""; // only for multi-language variable placeholders
	if(_nestedProperty2['default'].get(EmailTemplateRelations,"EmailTemplateVariables." + varKeyValue + ".doTranslate")){replaceExp = _(replaceExp,language?language:null);}body = body.replace(new RegExp("\{\{" + searchExp + "\}\}",'g'),replaceExp);});})();}return body;} /**
	     * This function provide the apicall result and callback call for the tiny mce editor,
	     * trough a redux action
	     * @param {*} blobInfo
	     * @param {*} success
	     * @param {*} failure
	     */},{key:'imagesUploadHandler',value:function imagesUploadHandler(blobInfo,success,failure){var dispatch=this.props.dispatch;return dispatch((0,_stateActions.localUploadHandler)(blobInfo,success,failure));} /**
	     * This function will initialize the text editor for email composer
	     */},{key:'setupTinyMCE',value:function setupTinyMCE(){var _this5=this;var returnEditorContext=null; // window.tinymce.execCommand('mceAddEditor',true, "tinymce")
	window.tinymce.init({ /*
	            selector: '#tinymce', height: 500, skin_url: `skins/lightgray`, menubar: false,
	            statusbar: false, toolbar: 'bold italic underline undo redo', plugins: ['paste', 'link', 'autoresize'],
	            */file_browser_callback_types:'image', // when we need tu uploade images into email only todo uncomment the next line
	//images_upload_handler: (blobInfo, success, failure) => (this.imagesUploadHandler(blobInfo, success, failure)),
	//images_upload_url: 'uploads/localUploads/',
	selector:'#tinymce',min_height:365,menubar:false,mode:"readonly",draggable_modal:true, // [Jancsi] - these are not required anymore for version 5.3+ of tinyMCE, it is enough to specify the teme
	// theme_url: window.location.protocol+'//'+(window.location.href.split("/")[2] + '/themes/silver/theme.js').replace("\/\/", "\/"),
	// skin_url:  window.location.protocol+'//'+(window.location.href.split("/")[2] + '/skins/lightgray/').replace("\/\/", "\/"),
	//theme : "modern",
	theme:"silver",statusbar:false, //toolbar: 'bold italic underline | undo redo | link | code', plugins: ['paste', 'link', 'autoresize'],
	toolbar1:"bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | formatselect fontselect fontsizeselect",toolbar2:"paste pastetext searchreplace | bullist numlist | outdent indent | undo redo | link unlink anchor image code",toolbar3:"forecolor backcolor | table | hr removeformat visualchars | subscript superscript | charmap preview | fullscreen", // [Jancsi] these are not required anymore for version 5.3+ of tinyMCE, as plugins are imported at the beginning of the file
	// external_plugins: {
	//     'textcolor': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/textcolor/plugin.js').replace("\/\/", "\/"),
	//     'link': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/link/plugin.js').replace("\/\/", "\/"),
	//     'image': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/image/plugin.js').replace("\/\/", "\/"),
	//     'code': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/code/plugin.js').replace("\/\/", "\/"),
	//     'searchreplace': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/searchreplace/plugin.js').replace("\/\/", "\/"),
	//     'paste': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/paste/plugin.js').replace("\/\/", "\/"),
	//     'visualchars': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/visualchars/plugin.js').replace("\/\/", "\/"),
	//     'charmap': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/charmap/plugin.js').replace("\/\/", "\/"),
	//     'table': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/table/plugin.js').replace("\/\/", "\/"),
	//     'fullscreen': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/fullscreen/plugin.js').replace("\/\/", "\/"),
	//     'preview': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/preview/plugin.js').replace("\/\/", "\/"),
	// },
	plugins:["textcolor link image code searchreplace paste visualchars charmap table fullscreen preview"],force_br_newlines:false,force_p_newlines:false,forced_root_block:'',relative_urls:false,remove_script_host:false,allow_script_urls:true,convert_urls:true,setup:function setup(editor){returnEditorContext = editor;editor.on('init',function(){this.execCommand("fontName",false,"Arial");this.execCommand("fontSize",false,"11pt");this.execCommand("foreColor",false,'rgba(0,0,0,1)');});_this5.setState({theBodyEditor:editor});}, // protect: [
	//     /\{\{Link\}\}/g,
	// ]
	noneditable_class:'mceNonEditable',noneditable_regexp:/\{\{Link\}\}/g});return returnEditorContext;} /**
	     * This function will force a font style for the first html tag
	     * @param {string} html
	     */},{key:'forceFontStyleForContainerHtmlTag',value:function forceFontStyleForContainerHtmlTag(html){var tagHead='<div class="userBasicStyle" style="min-height:12px; color: black;font-size: 12pt; font-weight: 400; font-family: Arial,-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,\'Helvetica Neue\',\'times new roman\',sans-serif;">';var tagEnd=' </div>';if(!html){return tagHead + html + tagEnd;}if(html.indexOf("userBasicStyleAuto") == -1 && html.indexOf("templateBasicStyleAuto") == -1){return tagHead + html + tagEnd;}return html;} /**
	     * This function will initialize the body editor when you call it and replace the body value instantly
	     * @param {*} newValue - new body html value for email
	     * @param {*} recipient - the current recipient value, if empty then reset the editor
	     * @param {*} language - the current language value, if empty then reset the editor
	     */},{key:'initializeBodyEditor',value:function initializeBodyEditor(newValue,recipient,language){var _this6=this;var _state=this.state;var theBodyEditor=_state.theBodyEditor;var moduleOptions=_state.moduleOptions;var bodyField=_nestedProperty2['default'].get(this.props,"fields.emailBodyField"); // if the middlewear is loaded. Preventing errors
	if(window.tinymce && theBodyEditor){ // we can fill the editor if we have options to decide witch message template we needed.
	if(recipient && language){var body=!_underscore2['default'].isEmpty(newValue) && String(newValue) || '';body = this.parseAndReplaceVariables(body,language) || '';var bodyFontStyled=this.forceFontStyleForContainerHtmlTag(body);try{ // theBodyEditor && theBodyEditor.execCommand('mceSetContent', body, {format: 'raw', set: true, content: body})
	theBodyEditor.setContent(bodyFontStyled,{format:'raw'});}catch(exc) { // TODO error handling. But not fo user.
	}}else {try{var bodyFontStyled=this.forceFontStyleForContainerHtmlTag(''); // theBodyEditor && theBodyEditor.execCommand('mceSetContent', '', {format: 'raw', set: true, content: ''})
	theBodyEditor.setContent(bodyFontStyled,{format:'raw'});}catch(exc) { // error handling
	}} // we have to update the form value on blur
	theBodyEditor.on('blur',function(e){var content=theBodyEditor.getContent();_this6.updateFormValue({value:content},bodyField);});theBodyEditor.on('change',function(e){var content=theBodyEditor.getContent();_this6.updateFormValue({value:content},bodyField);}); // this for the correct timed validation, because this is not a regular reduxForm field.
	theBodyEditor.on('click',function(e){var content=theBodyEditor.getContent();_this6.updateFormValue({value:content,touched:true},bodyField);}); /* theBodyEditor.on('focus', (e)=>{
	                this.updateFormValue({value: theBodyEditor.getContent(), touched: true}, bodyField)
	            }) */ // theBodyEditor.on('change', (e)=>{
	//     if (moduleOptions.private LinkPlaceholder) {
	//         let content = theBodyEditor.getContent()
	//         if (!content.includes(c.DSWIZARD_ PRIVATE_LINK_PLACEHOLDER)) {
	//             console.log("Cannot to remove link from content!")
	//         } else {
	//             theBodyEditor.setContent(content , {format: 'raw'})
	//         }
	//     }
	//     //actualCaretPositionBookmark = theBodyEditor.selection.getBookmark(2, true)
	// })
	// var iframe = theBodyEditor.getDoc().getElementById(theBodyEditor.id);
	// iframe.addEventListener('keypress', function(event) {
	//     console.log('Key pressed!', event);
	//     console.log("onKeyPress fired")
	//     if (moduleOptions.private LinkPlaceholder) {
	//         let content = theBodyEditor.getContent()
	//         if (!content.includes(c.DSWIZARD_ PRIVATE_LINK_PLACEHOLDER)) {
	//             console.log("Cannot to remove link from content!")
	//             theBodyEditor.setContent(this.lastValue , {format: 'raw'})
	//         } else {
	//             this.lastValue = content
	//         }
	//     }
	// })
	}} //lastValue = "";
	/**
	     * Destruct settings for tinyMCE
	     */},{key:'unmountTinyMCE',value:function unmountTinyMCE(){window.tinymce.execCommand('mceFocus',true,"tinymce");window.tinymce.execCommand('mceRemoveEditor',true,"tinymce"); //mceAddEditor
	window.tinymce.execCommand('mceRemoveControl',false,"tinymce");} /**
	     * Insert a variable in to the editor
	     * @param {object} e
	     * @param {string} variable
	     */},{key:'onClickVariableOfEditor',value:function onClickVariableOfEditor(e,variable){var language=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];var theBodyEditor=this.state.theBodyEditor;var textToFill='{{' + variable.value + '}}';var valueToInsert=this.parseAndReplaceVariables(textToFill,language); //actualCaretPositionBookmark = theBodyEditor.selection.getBookmark();
	//theBodyEditor && theBodyEditor.insertContent(valueToInsert)
	//theBodyEditor && theBodyEditor.selection.moveToBookmark(actualCaretPositionBookmark)
	//theBodyEditor && theBodyEditor.focus()
	theBodyEditor && theBodyEditor.execCommand('mceInsertContent',false,valueToInsert); //theBodyEditor && theBodyEditor.selection.moveToBookmark(actualCaretPositionBookmark)
	//theBodyEditor && theBodyEditor.focus()
	//theBodyEditor && theBodyEditor.selection.select(theBodyEditor && theBodyEditor.getBody(), true);
	//theBodyEditor && theBodyEditor.selection.collapse(false)
	//theBodyEditor && theBodyEditor.execCommand('mceInsertContent', false, "some text")
	//theBodyEditor.selection.setCursorLocation( theBodyEditor.selection.getNode(), 2)
	//theBodyEditor.readonly = true
	}},{key:'onClickLanguageChangeOfEditor',value:function onClickLanguageChangeOfEditor(e,newActiveLanguageTabValue){var fields=this.props.fields;var _state2=this.state;var theBodyEditor=_state2.theBodyEditor;var activeLanguageTabValue=_state2.activeLanguageTabValue;var nlLanguageTabBodyValue=_state2.nlLanguageTabBodyValue;var frLanguageTabBodyValue=_state2.frLanguageTabBodyValue;var nlLanguageTabSubjectValue=_state2.nlLanguageTabSubjectValue;var frLanguageTabSubjectValue=_state2.frLanguageTabSubjectValue; // old content
	if(activeLanguageTabValue == 'nl'){nlLanguageTabSubjectValue = fields.subjectField.value;nlLanguageTabBodyValue = theBodyEditor.getContent();}if(activeLanguageTabValue == 'fr'){frLanguageTabSubjectValue = fields.subjectField.value;frLanguageTabBodyValue = theBodyEditor.getContent();} // newActiveLanguageTabValue
	if(newActiveLanguageTabValue == 'nl'){this.updateFormValue({value:nlLanguageTabSubjectValue,touched:true},fields.subjectField);this.updateFormValue({value:nlLanguageTabBodyValue,touched:true || fields.emailBodyField.touched},fields.emailBodyField);theBodyEditor.setContent(nlLanguageTabBodyValue,{format:'raw'});}if(newActiveLanguageTabValue == 'fr'){this.updateFormValue({value:frLanguageTabSubjectValue,touched:true},fields.subjectField);this.updateFormValue({value:frLanguageTabBodyValue,touched:true || fields.emailBodyField.touched},fields.emailBodyField);theBodyEditor.setContent(frLanguageTabBodyValue,{format:'raw'});} // put back all the stuffs
	this.setState({activeLanguageTabValue:newActiveLanguageTabValue,nlLanguageTabSubjectValue:nlLanguageTabSubjectValue,nlLanguageTabBodyValue:nlLanguageTabBodyValue,frLanguageTabSubjectValue:frLanguageTabSubjectValue,frLanguageTabBodyValue:frLanguageTabBodyValue});} /**
	     * This function will initialize the editor and insert the correct content in it
	     * @param {*} options
	     * @param {*} emailBodyField
	     */},{key:'renderBodyEditor',value:function renderBodyEditor(options,emailBodyField){var _this7=this;var _state3=this.state;var theBodyEditor=_state3.theBodyEditor;var textEditorAlreadySet=_state3.textEditorAlreadySet;var variables=this.state.variables;if(window.tinymce && theBodyEditor){if(options && options.disabled){if(textEditorAlreadySet){this.setState({textEditorAlreadySet:false});}theBodyEditor.setMode("readonly");}else {theBodyEditor.setMode("design");if(!textEditorAlreadySet){theBodyEditor.setMode("design");this.setState({textEditorAlreadySet:true});theBodyEditor.focus();theBodyEditor.selection.select(theBodyEditor && theBodyEditor.getBody(),true);theBodyEditor.getBody().focus();}}}return _react2['default'].createElement('div',{key:'variableEditorMainContainerKey'},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup)},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel,htmlFor:'emailBodyField'},_("messageContent"),'*'),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formInput},_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].variablesContainer},variables && variables.map(function(oneVar,oneVarIndex){return _react2['default'].createElement('div',{key:"variableindex" + oneVarIndex,onClick:function(e){return _this7.onClickVariableOfEditor(e,oneVar,_this7.state.activeLanguageTabValue);},className:_emailSenderModalScss2['default'].variableTab},_("variable_" + oneVar.value));})),_react2['default'].createElement('textarea',{id:'tinymce'}))));} /**
	     * This universal email address collector function give a list of emails filtered by
	     * current moduleKey and recipient list
	     * @param {*} templateRecipients
	     */},{key:'fetchRecipientEmails',value:function fetchRecipientEmails(selectedRecipient,templateRecipients,templateContent){var _this8=this;var willemotInCc=arguments.length <= 3 || arguments[3] === undefined?false:arguments[3];var _props$options7=this.props.options;var moduleKey=_props$options7.moduleKey;var EmailTemplateRelations=_props$options7.EmailTemplateRelations;var contractManagerMail=_props$options7.contractManagerMail;var contractManagerLanguage=_props$options7.contractManagerLanguage;var claimsManagersDetails=_props$options7.claimsManagersDetails;var claimsManagers=_props$options7.claimsManagers;var moduleOptions=this.state.moduleOptions;var quickReply=_nestedProperty2['default'].get(moduleOptions,"quickReply") || [];var clientEmails=_nestedProperty2['default'].get(moduleOptions,"clientEmails") || [];var brNr=_nestedProperty2['default'].get(moduleOptions,"brokerNumber") || '';var emailRecentRecipients=_nestedProperty2['default'].get(moduleOptions,"emailRecentRecipients") || [];var companyCancelMail=_nestedProperty2['default'].get(moduleOptions,"companyCancelMail") || [];var tarificationManagerMail=_nestedProperty2['default'].get(moduleOptions.tarificationDetail,"tarificationManagerMail");var tarificationManagerLanguage=_nestedProperty2['default'].get(moduleOptions.tarificationDetail,"tarificationManagerLanguage");var willemotProductionTranslationKey='recipient' + EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value.charAt(0).toUpperCase() + EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value.slice(1);var emailCompany=_nestedProperty2['default'].get(moduleOptions,"claimDetail.emailCompany") || "";var expertEmail=_nestedProperty2['default'].get(moduleOptions,"claimDetail.expEmail") || "";var emailCounterParty=_nestedProperty2['default'].get(moduleOptions,"claimDetail.emailCounterParty") || ""; // in case when we are on client profile, only the client email addresses are available
	var isClientProfileModule=moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value; //const isMifidModule = (moduleKey == EmailTemplateRelations.EmailTemplateModules. mifid.value)
	var resultEmailList=[]; // this array will be the final result of this function
	var recentEmailAddresses=[]; // this addresses must be at the end of the list
	// add to the end of the recipient email addresses list the broker recently used email addresses if exists
	var brokerRecents=emailRecentRecipients && emailRecentRecipients.filter(function(oneRecent){return oneRecent.brokerNumber === brNr;}) || []; // generating  translation key for the current recipient - requirement by Willemot
	var recipientTranslationKey='';if(selectedRecipient){recipientTranslationKey = 'recipient' + selectedRecipient.charAt(0).toUpperCase() + selectedRecipient.slice(1);} // format data-structure of fetched recent recipients to be digestible for the input
	brokerRecents.forEach(function(oneEmail){recentEmailAddresses.push({value:oneEmail.email,lang:oneEmail.lang,label:'',isRecent:true});});recentEmailAddresses.sort(function(a,b){return a.count > b.count?-1:1;}); // if there are no recipients for the template then remains just the frequently used email addresses.
	var isThisTheContractModule=moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value;if(_underscore2['default'].isEmpty(templateRecipients)){return resultEmailList.concat(recentEmailAddresses);}if(!_underscore2['default'].isEmpty(selectedRecipient)){switch(selectedRecipient){case EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value:{ // if we have contractManagerEmail but we are on contracts only
	// claims module not available contract
	if(isThisTheContractModule && contractManagerMail){resultEmailList.push({value:contractManagerMail,lang:contractManagerLanguage, // must use the translated recipient label (requirement)
	label:_(recipientTranslationKey)});}break;}case EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value:{var _ret4=(function(){ // we use the claim addresses if we are on that module where are fetched this addresses.
	var isThisTheClientClaimModule=moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value;var isThisTheClaimModule=moduleKey == EmailTemplateRelations.EmailTemplateModules.claims.value;var actualClaimId=_nestedProperty2['default'].get(_this8.state,"moduleOptions.claimId");var managerDetails=[]; // client claims module
	if(isThisTheClientClaimModule && claimsManagersDetails && Array.isArray(claimsManagersDetails) && claimsManagersDetails.length > 0){ // only the current claim manager
	managerDetails = claimsManagersDetails.filter(function(oneManager){return oneManager.claimId == actualClaimId || !actualClaimId;});} // claims module
	if(isThisTheClaimModule && claimsManagers && Array.isArray(claimsManagers) && claimsManagers.length > 0){managerDetails = claimsManagers.filter(function(oneManager){return oneManager.claimId == actualClaimId || !actualClaimId;});} // each module use if exists
	if(contractManagerMail){managerDetails.push({email:contractManagerMail,lang:contractManagerLanguage, // must use the translated recipient label (requirement)
	name:_(recipientTranslationKey)});} // quick filter the duplicated values
	var filteredManagerDetails=[];managerDetails.forEach(function(oneManager){ // if we have the same email address we don't need to add again
	var alreadyAdded=filteredManagerDetails.length > 0 && filteredManagerDetails.filter(function(secondManager){var email=_nestedProperty2['default'].get(secondManager,"email");var email2=_nestedProperty2['default'].get(oneManager,"email");return String(email).localeCompare(email2) === 0;});if(!alreadyAdded || Array.isArray(alreadyAdded) && alreadyAdded.length == 0){filteredManagerDetails.push(_extends({},oneManager));}});managerDetails = filteredManagerDetails;var isOkClaimManagerDetail=managerDetails && Array.isArray(managerDetails) && managerDetails.length > 0;if(isOkClaimManagerDetail){managerDetails.forEach(function(claimsManagerElem){resultEmailList.push({value:claimsManagerElem.email, //label: EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.label,
	//label: claimsManagerElem.name,
	// must use the translated recipient label (requirement)
	label:_(recipientTranslationKey),lang:claimsManagerElem.lang});});}return 'break';})();if(_ret4 === 'break')break;}case EmailTemplateRelations.EmailTemplateRecipients.thirdParties.value:{ // resultEmailList = []
	break;}case EmailTemplateRelations.EmailTemplateRecipients.client.value:{resultEmailList = resultEmailList.concat(clientEmails); // EXIT POINT (EXCEPTION IN FUNCTIONALITY):
	// On client profile, when the recipient is client we just let only the client email addresses to select
	// BEWB-354
	if(isClientProfileModule){ // reset the result if any of other addresses added from template or anywhere, jut use the client own addresses
	resultEmailList = clientEmails; // end function avoid any other concat or manipulation
	return resultEmailList;}break;} // v8
	case EmailTemplateRelations.EmailTemplateRecipients.digitalSignatureClient.value:{ // resultEmailList = resultEmailList.concat(clientEmails)
	//if (isMifidModule) {
	// reset the result to the stakeholder email adresses what is in the clientEmails when comming from mifid
	resultEmailList = clientEmails; // end function avoid any other concat or manipulation
	return resultEmailList; //}
	break;}case EmailTemplateRelations.EmailTemplateRecipients.willemot.value:{if(templateContent){var recipientWillemotEmailsUsedIds=_nestedProperty2['default'].get(templateContent,"recipientWillemotEmails");resultEmailList = resultEmailList.concat(this.getRecipientWillemotEmailsByIds(recipientWillemotEmailsUsedIds));}break;} // new v5
	case EmailTemplateRelations.EmailTemplateRecipients.company.value:{var listCompanyEmails=emailCompany?[{value:emailCompany,label:_(recipientTranslationKey)}]:[];resultEmailList = resultEmailList.concat(listCompanyEmails); // requirement V6 extra issues,
	// when company recipient selected on client contract, willemot production must added in CC
	if(isThisTheContractModule){resultEmailList.push({value:contractManagerMail,lang:contractManagerLanguage, // must use the translated recipient label (requirement)
	isPermanentSelected:isThisTheContractModule?true:false,isCC:true,label:_(willemotProductionTranslationKey)});}break;}case EmailTemplateRelations.EmailTemplateRecipients.expert.value:{var listExpertEmail=expertEmail?[{value:expertEmail,label:_(recipientTranslationKey)}]:[];resultEmailList = resultEmailList.concat(listExpertEmail);break;}case EmailTemplateRelations.EmailTemplateRecipients.counterParty.value:{var listEmailCounterParty=emailCounterParty?[{value:emailCounterParty,label:_(recipientTranslationKey)}]:[];resultEmailList = resultEmailList.concat(listEmailCounterParty);break;}case EmailTemplateRelations.EmailTemplateRecipients.companyCancellations.value:{resultEmailList = companyCancelMail && companyCancelMail.length > 0?[{value:companyCancelMail,label:_(recipientTranslationKey)}]:[];break;}case EmailTemplateRelations.EmailTemplateRecipients.willemotTarification.value:{resultEmailList = tarificationManagerMail && tarificationManagerMail.length > 0?[{value:tarificationManagerMail,lang:tarificationManagerLanguage,label:_(recipientTranslationKey)}]:[];}default:{ //resultEmailList = []
	}}}if(willemotInCc && !resultEmailList.find(function(recipient){return recipient.value === contractManagerMail && recipient.isCC;})){resultEmailList.push({value:contractManagerMail,lang:contractManagerLanguage, // must use the translated recipient label (requirement)
	isPermanentSelected:true,isCC:true,label:_(willemotProductionTranslationKey)});} // inject the recently used to the end, filtered the duplicates
	recentEmailAddresses.forEach(function(oneEmail){ // check if email address already in list
	var matchedEmails=resultEmailList.filter(function(elem){return elem.value === oneEmail.value;}); // if not exists in the already composed list, then we can push it into the list
	if(!matchedEmails.length){resultEmailList.push({value:oneEmail.value,lang:oneEmail.lang,label:'',isRecent:true});}});return resultEmailList;} /**
	     * This will set the form value content in store
	     */},{key:'updateFormValue',value:function updateFormValue(value,field){var dispatch;return regeneratorRuntime.async(function updateFormValue$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:dispatch = this.props.dispatch;context$2$0.next = 3;return regeneratorRuntime.awrap(dispatch({type:"redux-form/CHANGE",field:field.name,value:value && value.value || '',touch:value && value.touched || field.touched,form:"emailSender"}));case 3:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This function wil set selected a broker from the list and initialize the "from" email list values.
	     * @param {string} selectedBrokerNumber
	     */},{key:'onChangeBroker', // set the initial sate of validation for buttons
	// const hasErrorsValue = this.hasErrors() || this.state.precacheInProgress
	// console.log("hasErrorsValue" , hasErrorsValue)
	// this.props.dataCallbackDisableSend(hasErrorsValue)
	value:function onChangeBroker(value){var config=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var moduleOptions=this.state.moduleOptions; // change self value of the template dropdown
	// this.updateFormValue(value, fields.brokerField)
	var _props6=this.props;var dispatch=_props6.dispatch;var _props6$fields=_props6.fields;var brokerField=_props6$fields.brokerField;var emailTemplateField=_props6$fields.emailTemplateField; // initial/overwrite configuration for the modal
	var modalConfiguration={modalTitle:config && config.modalTitle || _("areYouSure"),modalMessage:config && config.modalMessage || _("areYouSureToChangeBroker")};var brokerFakeField={value:value}; // no reset on no change
	if(brokerField && value && brokerField.value === value.value){return;} // if (!brokerField || underscore.isEmpty(brokerField.value)) {
	// don't want to use the confirmation dialog, when no template selected
	if(!emailTemplateField || _underscore2['default'].isEmpty(emailTemplateField.value)){moduleOptions = this.doTheBrokerChange(moduleOptions,brokerFakeField);}else {dispatch((0,_stateActions.showEmailSenderConfirmationModal)("emailConfModal",modalConfiguration.modalTitle,modalConfiguration.modalMessage,"changeBroker",brokerFakeField));}this.setState({moduleOptions:moduleOptions});} /**
	     * This function handle the change of the mail broker. Trigger all of the events what
	     * do things what are affected by this change.
	     * @param {object} brokerFakeField
	     * @param {object} moduleOptions
	     */},{key:'doTheBrokerChange',value:function doTheBrokerChange(moduleOptions){var brokerFakeField=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var _props7,dispatch,fields,confirmationModal,modalPayload,value,setAsBrokerNumberValue,emailRecentRecipientsResult,selectedTemplateVal;return regeneratorRuntime.async(function doTheBrokerChange$(context$2$0){while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props7 = this.props;dispatch = _props7.dispatch;fields = _props7.fields;confirmationModal = _props7.options.confirmationModal;modalPayload = brokerFakeField || confirmationModal && confirmationModal.payload;value = modalPayload.value; // select broker and reset the form
	this.updateFormValue(value,fields.brokerField); // update the module options for the template usage (variables, etc.) and to save the new brokerNumber
	setAsBrokerNumberValue = !(value && value.value)?'':value.value; // if there are no broker selected (only client profile own this methods) clear the selected from address
	if(!setAsBrokerNumberValue){this.updateFormValue({value:''},fields.emailFromField);} // get the recently used email addresses to extend the recipient list
	// the IE not support the finally, so we must do almost the same thing in catch also.
	context$2$0.next = 11;return regeneratorRuntime.awrap(dispatch((0,_stateActions.loadEmailRecentRecipients)(setAsBrokerNumberValue)));case 11:emailRecentRecipientsResult = context$2$0.sent;moduleOptions = this.getUpdatedModuleOptionsByBrokerFromOffice(moduleOptions,setAsBrokerNumberValue); //sync call
	// overwrite the recent addresses by the result
	moduleOptions.emailRecentRecipients = emailRecentRecipientsResult;this.initializeSignatures(moduleOptions.brokerNumber); // v8: in case when the broker is changed but the auto selection is on,
	// must be selected the template, dont leave as blank like before
	selectedTemplateVal = fields.emailTemplateField && fields.emailTemplateField.value || moduleOptions.autoSelectTemplate && {value:"0"} || null;this.doTheTemplateSwitch(moduleOptions.brokerNumber,moduleOptions.clientLanguage,selectedTemplateVal,moduleOptions.brokerEmailAddress);return context$2$0.abrupt('return',moduleOptions);case 18:case 'end':return context$2$0.stop();}},null,this);} /**
	     * This function will reset your form elements, and insert the default values
	     * @param {Object} templateObj
	     */},{key:'onChangeEmailTemplate',value:function onChangeEmailTemplate(templateObj){var _props8=this.props;var dispatch=_props8.dispatch;var emailTemplateField=_props8.fields.emailTemplateField;var moduleOptions=this.state.moduleOptions; // no reset on no change
	if(emailTemplateField && templateObj && emailTemplateField.value === templateObj.value){return;} // when we do the first change or we just change from nothing to something we
	// don't want to use the confirmation dialog, no sens to ask the user to prevent reset of fields
	if(!emailTemplateField || _underscore2['default'].isEmpty(emailTemplateField.value)){this.doTheTemplateSwitch(moduleOptions.brokerNumber,moduleOptions.clientLanguage,templateObj); //, moduleOptions.brokerEmailAddress
	}else {dispatch((0,_stateActions.showEmailSenderConfirmationModal)("emailConfModal",_("areYouSure"),_("areYouSureToChangeTemplate"),"changeTemplate",templateObj));}} /**
	     * This function will return a list of email of Willemot recipient by a list of id-s from template.
	     * @param {Array} emailIds
	     */},{key:'getRecipientWillemotEmailsByIds',value:function getRecipientWillemotEmailsByIds(emailIds){var recipientWillemotEmails=this.props.options.recipientWillemotEmails;if(!recipientWillemotEmails || !Array.isArray(recipientWillemotEmails) || recipientWillemotEmails.length == 0){return [];}if(!emailIds || !Array.isArray(emailIds) || emailIds.length == 0){return [];}var result=[];var obsoleteEmailsIds=[];emailIds.forEach(function(item,itemIndex){var emailFound=false;recipientWillemotEmails.forEach(function(oneFromAllItem){if(oneFromAllItem._id == item.value){emailFound = true;result.push({value:oneFromAllItem.email,label:oneFromAllItem.name.first + " " + oneFromAllItem.name.last,lang:oneFromAllItem.language,id:item.value});}});if(!emailFound){obsoleteEmailsIds.push(item.value);}}); // eliminate from result the obsolete emails
	if(obsoleteEmailsIds.length > 0 && result.length > 0){result = result.filter(function(item){return obsoleteEmailsIds.indexOf(item.id) === -1;});}return result;} /**
	     * This function will return language of Willemot recipient by a email address
	     * @param {string} email
	     */},{key:'getRecipientWillemotEmailsLangByEmail',value:function getRecipientWillemotEmailsLangByEmail(email){var recipientWillemotEmails=this.props.options.recipientWillemotEmails;if(!recipientWillemotEmails || !Array.isArray(recipientWillemotEmails) || recipientWillemotEmails.length == 0){return '';}if(!email){return '';}var result='';recipientWillemotEmails.forEach(function(oneFromAllItem){if(oneFromAllItem.email == email){result = oneFromAllItem.language;}});return result;} /**
	     * This function effecting the change of template of the email.
	     * Reset values and filling with the new ones.
	     * @param {*} brokerNumber
	     * @param {*} clientLanguage
	     * @param {*} templateObjPredictive
	     * @param {*} brokerEmailAddress optional, use just as initial value on did mount, or on broker change.
	     */},{key:'doTheTemplateSwitch',value:function doTheTemplateSwitch(brokerNumber,clientLanguage){var templateObjPredictive=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];var brokerEmailAddress=arguments.length <= 3 || arguments[3] === undefined?null:arguments[3];var _props9=this.props;var fields=_props9.fields;var _props9$options=_props9.options;var confirmationModal=_props9$options.confirmationModal;var moduleKey=_props9$options.moduleKey;var EmailTemplateRelations=_props9$options.EmailTemplateRelations;var moduleOptions=_props9$options.moduleOptions;var preselectedTemplateObject=templateObjPredictive || confirmationModal && confirmationModal.payload;var isClientProfileModule=moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value; // no language selected by user, we will set the best available choice
	var language=_nestedProperty2['default'].get(fields,'emailLanguageField.value') || this.fetchRecipientLanguage(clientLanguage); // change self value of the template dropdown
	this.updateFormValue(preselectedTemplateObject,fields.emailTemplateField); // reset form fields on by one, because this verion of redux for not support the global reset
	this.updateFormValue('',fields.recipientField);this.updateFormValue({value:language},fields.emailLanguageField); //this.updateFormValue('', fields.signatureField)
	var selectedTemplate=this.getNewSelectedTemplate(preselectedTemplateObject && preselectedTemplateObject.value || '');var templateContent=this.getNewTemplateContent(selectedTemplate);var templateRecipients=this.getNewTemplateRecipients(templateContent,moduleOptions);var defaultRec=this.makeSelectedDefaultRecipient(templateRecipients,moduleOptions);var emailToOptions=this.getNewEmailToOptions('',templateRecipients,templateContent,selectedTemplate.willemotInCC);var emailFromOptions=this.getNewEmailFromOptions();this.setState({emailFromOptions:emailFromOptions,emailToOptions:emailToOptions,templateRecipients:templateRecipients,templateContent:templateContent}); // on profile module without selected brokerNumber we can not preselect email addresses
	if(brokerNumber || !isClientProfileModule){ // when no "brokerEmailAddress" is set in module option we will select the first email address form the list
	var firstEmailAddress=emailFromOptions && emailFromOptions.length > 0?emailFromOptions[0].value:'';this.updateFormValue({value:brokerEmailAddress || firstEmailAddress},fields.emailFromField); // reset the from address and name
	var selectedEmailFromName=this.getNewEmailFromName(firstEmailAddress,emailFromOptions);this.setState({selectedEmailFromName:selectedEmailFromName});}this.setState({variables:[]});this.fetchEmailModuleVariableRealValues(selectedTemplate,language); // reset the tinymce editor content
	var recipientToUseByDefault='';if(defaultRec && defaultRec.value){recipientToUseByDefault = defaultRec.value;}var fillResult=this.fillEditorValueOnChanges(recipientToUseByDefault,fields.emailLanguageField.value,templateContent);this.updateFormValue({value:fillResult.processedSubject},fields.subjectField);this.updateFormValue({value:fillResult.body,touched:Boolean(fillResult.body) || fields.emailBodyField.touched},fields.emailBodyField); // v8
	// working with multilanguage optionally
	var nlResult=this.fillEditorValueOnChanges(fields.recipientField.value,'nl',templateContent);var frResult=this.fillEditorValueOnChanges(fields.recipientField.value,'fr',templateContent);if(defaultRec){ // by the recipient switch we also do the body editor reset, then we dont have to do again
	var isThisAutomaticFirstStepSelection=true;this.doTheRecipientSwitch(defaultRec.value,templateRecipients,templateContent,isThisAutomaticFirstStepSelection,selectedTemplate.willemotInCC,selectedTemplate);}else { // preselect a content
	var body=nlResult.body;if(fields.emailLanguageField && fields.emailLanguageField.value && fields.emailLanguageField.value == 'fr' || language){body = frResult.body;}this.initializeBodyEditor(body,false,fields.emailLanguageField.value);} // put back all the stuffs
	this.setState({activeLanguageTabValue:fields.emailLanguageField.value,nlLanguageTabBodyValue:this.parseAndReplaceVariables(nlResult.body,"nl"),nlLanguageTabSubjectValue:this.parseAndReplaceVariables(nlResult.processedSubject,"nl"),frLanguageTabBodyValue:this.parseAndReplaceVariables(frResult.body,"fr"),frLanguageTabSubjectValue:this.parseAndReplaceVariables(frResult.processedSubject,"fr")});} /**
	     * This function will use to handle the recipient switch.
	     * @param {object} value
	     * @param {Object} templateRecipients
	     * @param {String} templateContent
	     */},{key:'onChangeRecipient',value:function onChangeRecipient(event,templateRecipients,templateContent){var _props10=this.props;var dispatch=_props10.dispatch;var _props10$fields=_props10.fields;var recipientField=_props10$fields.recipientField;var emailTemplateField=_props10$fields.emailTemplateField;var recipientInputValue=event.target.value;var selectedTemplate=this.getNewSelectedTemplate(emailTemplateField.value || ''); // no reset on no change
	if(recipientField && recipientField.value === recipientInputValue){return false;} // when we do the first change or we just change from nothing to something we
	// don't want to use the confirmation dialog, no sens to ask the user to prevent reset of fields
	if(!recipientField || _underscore2['default'].isEmpty(recipientField.value)){ // reset the almost everything always when recipient changed, so here we start a flag "isThisAutomaticFirstStepSelection"
	var isThisAutomaticFirstStepSelection=true;this.doTheRecipientSwitch(recipientInputValue,templateRecipients,templateContent,isThisAutomaticFirstStepSelection,selectedTemplate.willemotInCC,selectedTemplate);return true;}else {var payload={value:recipientInputValue,templateRecipients:templateRecipients,templateContent:templateContent,willemotInCC:selectedTemplate.willemotInCC};dispatch((0,_stateActions.showEmailSenderConfirmationModal)("emailConfModal",_("areYouSure"),_("areYouSureToChangeRecipient"),"changeRecipient",payload));return false;}} /**
	     * This function switch the recipient of mail.
	     * This function will reset the email address dropdown, subject and body.
	     * @param {string} value - the selected recipient value like 'willemotProduction' or 'claims' etc.
	     * @param {object} templateRecipients - contains the list of possible recipients for the template
	     * @param {object} templateContent - the template content object
	     * @param {bool} isThisAutomaticFirstStepSelection - this is true by default, means the change flow started,
	     * @param {bool} willemotInCC forced willemot email in cc,
	     * @param {object} selectedTemplate - this is slected template,
	     *  and forget about the custom changes, reset everything
	     */},{key:'doTheRecipientSwitch',value:function doTheRecipientSwitch(){var value=arguments.length <= 0 || arguments[0] === undefined?null:arguments[0];var templateRecipients=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var templateContent=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];var isThisAutomaticFirstStepSelection=arguments.length <= 3 || arguments[3] === undefined?true:arguments[3];var willemotInCC=arguments.length <= 4 || arguments[4] === undefined?false:arguments[4];var selectedTemplate=arguments.length <= 5 || arguments[5] === undefined?null:arguments[5];var _props11=this.props;var fields=_props11.fields;var _props11$options=_props11.options;var EmailTemplateRelations=_props11$options.EmailTemplateRelations;var confirmationModal=_props11$options.confirmationModal;var emailTemplateField=_props11.emailTemplateField;var selectedRecipient=value || _nestedProperty2['default'].get(confirmationModal,"payload.value");var templateRecipientsFinal=templateRecipients || _nestedProperty2['default'].get(confirmationModal,"payload.templateRecipients");var templateContentFinal=templateContent || _nestedProperty2['default'].get(confirmationModal,"payload.templateContent");if(!willemotInCC){willemotInCC = _nestedProperty2['default'].get(this.props,"options.confirmationModal.payload.willemotInCC") || false;}this.updateFormValue({value:selectedRecipient},fields.recipientField);var emailToOptions=this.getNewEmailToOptions(selectedRecipient,templateRecipientsFinal,templateContentFinal,willemotInCC);var firstToAddress=_nestedProperty2['default'].get(emailToOptions,'0'); // all exept first
	var allWhatMustBeSelectedForTo=emailToOptions.slice(1).filter(function(oneToOption){return !oneToOption.isRecent && oneToOption.isPermanentSelected;});var addressesToSelect=firstToAddress && !firstToAddress.isRecent?[firstToAddress]:[];addressesToSelect = addressesToSelect.concat(allWhatMustBeSelectedForTo); // when willemot is the recipient select all the fields fo to field, because this
	if(selectedRecipient == EmailTemplateRelations.EmailTemplateRecipients.willemot.value){addressesToSelect = emailToOptions.filter(function(oneToOption){return !oneToOption.isRecent;});} // when company is the recipient or willemotInCC select the willemot in CC
	if(willemotInCC || selectedRecipient == EmailTemplateRelations.EmailTemplateRecipients.company.value){addressesToSelect = addressesToSelect.concat(emailToOptions.filter(function(oneToOption){return oneToOption.isPermanentSelected && addressesToSelect.find(function(address){return address.value !== oneToOption.value;});}));}var filteredTos=addressesToSelect.filter(function(oneSelectedAddress){return !oneSelectedAddress.isCC;});var filteredCCs=addressesToSelect.filter(function(oneSelectedAddress){return !!oneSelectedAddress.isCC;});this.onChangeRecipientEmail(selectedRecipient,filteredTos,templateContentFinal,isThisAutomaticFirstStepSelection,selectedTemplate);this.onChangeRecipientEmailCC(filteredCCs);var variables=this.getNewVariables(templateContentFinal,selectedRecipient); // v8
	// restricting tu use the global link: F2FSigningUrl- can not be sent for all the same link
	variables = variables.filter(function(oneVar){return oneVar.value !== "F2FSigningUrl";});this.setState({variables:variables,emailToOptions:emailToOptions,isCCShown:false});} /**
	     * This function handle the event of the sender email address changing.
	     * @param {*} value
	     */},{key:'onChangeEmailFromAddress',value:function onChangeEmailFromAddress(value){var _this9=this;var fields=this.props.fields;var selectedEmailFromName=this.getNewEmailFromName(value.value,this.state.emailFromOptions);this.setState({selectedEmailFromName:selectedEmailFromName},function(){_this9.forceUpdate();});this.updateFormValue(value,fields.emailFromField);} /**
	     * This is an event what give you a confirmation dialog to decide if you want to change the  language or not.
	     * Handle the user choice, and fire the language changing if necessary.
	     * @param {*} recipient
	     * @param {*} requiredLanguage
	     * @param {*} templateContent
	     * @param {*} config
	     */},{key:'openAskingModalForLanguageChange',value:function openAskingModalForLanguageChange(recipient,requiredLanguageObj,templateContent){var config=arguments.length <= 3 || arguments[3] === undefined?null:arguments[3];var _props12=this.props;var dispatch=_props12.dispatch;var emailLanguageField=_props12.fields.emailLanguageField; // initial/overwrite configuration for the modal
	var modalConfiguration={modalTitle:config && config.modalTitle || _("areYouSure"),modalMessage:config && config.modalMessage || _("areYouSureToChangeLanguage")};var payload={value:requiredLanguageObj.value,templateContent:templateContent}; // no reset on no change
	if(emailLanguageField && emailLanguageField.value === requiredLanguageObj.value){return;} // when we do the first change or we just change from nothing to something we
	// don't want to use the confirmation dialog, no sens to ask the user to prevent reset of fields
	if(!emailLanguageField || _underscore2['default'].isEmpty(emailLanguageField.value)){this.doTheLanguageChange(recipient,payload);}else {dispatch((0,_stateActions.showEmailSenderConfirmationModal)("emailConfModal",modalConfiguration.modalTitle,modalConfiguration.modalMessage,"changeLanguage",payload));}} /**
	     * This function handle the change of the mail language. Trigger all of the events what
	     * do things what are affected by this change.
	     * @param {*} recipient
	     * @param {*} forcePayload This function is called by a confirmation momdal what have payload to use from props.
	     * But this argument let to override the payload, whent it is used by hande somwhere else.
	     * @param {*} selectedTemplate
	     */},{key:'doTheLanguageChange',value:function doTheLanguageChange(recipient){var forcePayload=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var selectedTemplate=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];var _props13=this.props;var fields=_props13.fields;var confirmationModal=_props13.options.confirmationModal; // determine the source fo data
	var languageAndTemplateFromModal=confirmationModal && confirmationModal.payload;var languageAndTemplate=forcePayload || languageAndTemplateFromModal; // fetch used values from data
	var templateContent=languageAndTemplate.templateContent;var language=languageAndTemplate.value;var selectedTemplateVal=undefined; // refresh template variables on language switch
	if(!selectedTemplate){selectedTemplateVal = _nestedProperty2['default'].get(fields,"emailTemplateField.value") || '';selectedTemplate = this.getNewSelectedTemplate(selectedTemplateVal);}this.fetchEmailModuleVariableRealValues(selectedTemplate,language); // update the form field by the new language seted
	this.updateFormValue({value:language},fields.emailLanguageField);var fillResult=this.fillEditorValueOnChanges(recipient,language,templateContent);this.updateFormValue({value:fillResult.processedSubject},fields.subjectField); // touched if once got a value what was not empty
	this.updateFormValue({value:fillResult.body,touched:Boolean(fillResult.body) || fields.emailBodyField.touched},fields.emailBodyField);this.initializeBodyEditor(fillResult.body,recipient,language);} /**
	     * Event when change recipient email address. Also handle the recipient language change.
	     * @param {string} selectedRecipient actual recipient value
	     * @param {*} emailValuesArray the allowed email addresses list filtered by the user selected conditions.
	     * @param {*} templateContent The template
	     * @param {*} isThisAutomaticFirstStepSelection a falg when the modal is loaded and the values are
	     * automatically selected to decide if the asking modal is required.
	     * @param {*} selectedTemplate
	     */},{key:'onChangeRecipientEmail',value:function onChangeRecipientEmail(selectedRecipient,emailValuesArray,templateContent){var isThisAutomaticFirstStepSelection=arguments.length <= 3 || arguments[3] === undefined?false:arguments[3];var selectedTemplate=arguments.length <= 4 || arguments[4] === undefined?null:arguments[4];var _props14=this.props;var dispatch=_props14.dispatch;var fields=_props14.fields;var _props14$fields=_props14.fields;var emailToSelectField=_props14$fields.emailToSelectField;var emailLanguageField=_props14$fields.emailLanguageField;var emailToOptions=this.state.emailToOptions; // let recipient =  fields.recipientField.value
	var moduleOptions=_nestedProperty2['default'].get(this.state,"moduleOptions") || {};var brNr=moduleOptions.brokerNumber; // if we have selected recipient we try to use the language of the first recipient
	var firstRecipient=_nestedProperty2['default'].get(emailValuesArray,'0.value');var determinedRecLanguage=this.fetchRecipientLanguage(moduleOptions.clientLanguage,firstRecipient); // no question change or ask the user by a confirmation modal
	if(isThisAutomaticFirstStepSelection){this.doTheLanguageChange(selectedRecipient,{value:determinedRecLanguage,templateContent:templateContent},selectedTemplate);}else {this.openAskingModalForLanguageChange(selectedRecipient,{value:determinedRecLanguage},templateContent,{modalMessage:_('areYouSureToChangeLanguageByRecipient')});} // add currently selected email address to the recently used email-addresses list (if exists then increase the usage count, for sort)
	var selectedOldValues=_nestedProperty2['default'].get(emailToSelectField,"value") || [];var selectedNewValues=emailValuesArray || [];var oldEmailCount=Array.isArray(selectedOldValues) && selectedOldValues.length || 0;var lastOldEmail=_nestedProperty2['default'].get(selectedOldValues,oldEmailCount - 1 + ".value") || '';var newEmailCount=Array.isArray(selectedNewValues) && selectedNewValues.length || 0;var lastNewEmail=_nestedProperty2['default'].get(selectedNewValues,newEmailCount - 1 + ".value") || '';var mustSend=true;if(oldEmailCount >= newEmailCount || isThisAutomaticFirstStepSelection){mustSend = false;}if(brNr && lastNewEmail && mustSend){dispatch((0,_stateActions.addEmailRecentRecipients)(brNr,lastNewEmail,determinedRecLanguage)); // add to the option list if not exists
	var found=emailToOptions && emailToOptions.filter(function(oneItem){return oneItem.value === lastNewEmail;});if(!found || found.length == 0){emailToOptions.push({name:'',label:"<" + lastNewEmail + ">",value:lastNewEmail,isRecent:true});this.setState({emailToOptions:emailToOptions});}}this.initializeSignatures(moduleOptions.brokerNumber);this.setState({moduleOptions:moduleOptions});this.updateFormValue({value:emailValuesArray},emailToSelectField);} /**
	     * This function will remove an option from email to list
	     * @param {String} email
	     */},{key:'removeRecent',value:function removeRecent(email){var _this10=this;var dispatch=this.props.dispatch;var moduleOptions=_nestedProperty2['default'].get(this.state,"moduleOptions");var emailToOptions=this.state.emailToOptions;var brNr=moduleOptions.brokerNumber;dispatch((0,_stateActions.removeEmailRecentRecipients)(brNr,email)).then(function(){ // remove from the option list if exists
	var found=emailToOptions && emailToOptions.filter(function(oneItem){return oneItem.value !== email;});if(found.length !== emailToOptions.length){_this10.setState({emailToOptions:found});}});} /*
	     * Event when change recipient email address. Also handle the recipient language change.
	     */},{key:'onChangeRecipientEmailCC',value:function onChangeRecipientEmailCC(emailValuesArray){var _props15=this.props;var dispatch=_props15.dispatch;var emailToSelectFieldCC=_props15.fields.emailToSelectFieldCC;var emailToOptions=this.state.emailToOptions;var moduleOptions=_nestedProperty2['default'].get(this.state,"moduleOptions") || {};var brNr=moduleOptions.brokerNumber; // if we have selected recipient we try to use the language of the first recipient
	var firstRecipient=_nestedProperty2['default'].get(emailValuesArray,'0.value');var determinedRecLanguage=this.fetchRecipientLanguage(moduleOptions.clientLanguage,firstRecipient); // add currently selected email address to the recently used email-addresses list (if exists then increase the usage count, for sort)
	var selectedOldValues=_nestedProperty2['default'].get(emailToSelectFieldCC,"value") || [];var selectedNewValues=emailValuesArray || [];var oldEmailCount=Array.isArray(selectedOldValues) && selectedOldValues.length || 0;var lastOldEmail=_nestedProperty2['default'].get(selectedOldValues,oldEmailCount - 1 + ".value") || '';var newEmailCount=Array.isArray(selectedNewValues) && selectedNewValues.length || 0;var lastNewEmail=_nestedProperty2['default'].get(selectedNewValues,newEmailCount - 1 + ".value") || '';var mustSend=true;if(oldEmailCount >= newEmailCount){mustSend = false;}if(brNr && lastNewEmail && mustSend){dispatch((0,_stateActions.addEmailRecentRecipients)(brNr,lastNewEmail,determinedRecLanguage)); // add to the option list if not exists
	var found=emailToOptions && emailToOptions.filter(function(oneItem){return oneItem.value === lastNewEmail;});if(!found || found.length == 0){emailToOptions.push({name:'',label:"<" + lastNewEmail + ">",value:lastNewEmail,isRecent:true});this.setState({emailToOptions:emailToOptions});}}this.initializeSignatures(moduleOptions.brokerNumber);this.setState({moduleOptions:moduleOptions});this.updateFormValue({value:emailValuesArray},emailToSelectFieldCC);} /**
	     * Update the the content of the editors by replace variable values on the specific language.
	     */},{key:'fillEditorValueOnChanges',value:function fillEditorValueOnChanges(selectedRecipient,language,templateContent){var _props16=this.props;var fields=_props16.fields;var EmailTemplateRelations=_props16.options.EmailTemplateRelations;var subject=!_underscore2['default'].isEmpty(templateContent) && !_underscore2['default'].isEmpty(templateContent.content[selectedRecipient]) && !_underscore2['default'].isEmpty(templateContent.content[selectedRecipient][language]) && !_underscore2['default'].isEmpty(templateContent.content[selectedRecipient][language].subject) && templateContent.content[selectedRecipient][language].subject || '';var body=!_underscore2['default'].isEmpty(templateContent) && !_underscore2['default'].isEmpty(templateContent.content[selectedRecipient]) && !_underscore2['default'].isEmpty(templateContent.content[selectedRecipient][language]) && !_underscore2['default'].isEmpty(templateContent.content[selectedRecipient][language].body) && templateContent.content[selectedRecipient][language].body || ''; // for subject here we replace the variables because this is not dynamic like the body
	var processedSubject=this.parseAndReplaceVariables(subject,language);return {body:body,processedSubject:processedSubject};} /**
	     * This function provide a reference to an icon on a safe way. If icon not found
	     * return with a placeholder icon reference
	     */},{key:'removeAttachment', /**
	     * This function will remove an attachment from selected list
	     * @param {object} file
	     */value:function removeAttachment(file){var _state4=this.state;var attachments=_state4.attachments;var moduleSpecificClaimAttachemnts=_state4.moduleSpecificClaimAttachemnts;var moduleSpecificContractAttachemnts=_state4.moduleSpecificContractAttachemnts;var moduleSpecificClientAttachemnts=_state4.moduleSpecificClientAttachemnts;var moduleSpecificTarificationAttachemnts=_state4.moduleSpecificTarificationAttachemnts;var moduleSpecificTicketAttachemnts=_state4.moduleSpecificTicketAttachemnts;moduleSpecificClaimAttachemnts = moduleSpecificClaimAttachemnts.filter(function(oneAtt){return oneAtt.id !== file.id;});moduleSpecificContractAttachemnts = moduleSpecificContractAttachemnts.filter(function(oneAtt){return oneAtt.id !== file.id;});moduleSpecificClientAttachemnts = moduleSpecificClientAttachemnts.filter(function(oneAtt){return oneAtt.id !== file.id;});moduleSpecificTarificationAttachemnts = moduleSpecificTarificationAttachemnts.filter(function(oneAtt){return oneAtt.id !== file.id;});moduleSpecificTicketAttachemnts = moduleSpecificTicketAttachemnts.filter(function(oneAtt){return oneAtt.id !== file.id;});attachments = attachments.filter(function(oneAtt){return oneAtt.id !== file.id;});this.setState({moduleSpecificClaimAttachemnts:moduleSpecificClaimAttachemnts,moduleSpecificContractAttachemnts:moduleSpecificContractAttachemnts,moduleSpecificClientAttachemnts:moduleSpecificClientAttachemnts,moduleSpecificTarificationAttachemnts:moduleSpecificTarificationAttachemnts,moduleSpecificTicketAttachemnts:moduleSpecificTicketAttachemnts,attachments:attachments});} /**
	     * This function will remove a hard attachment from selected list
	     * @param {Number} fileIndex
	     */},{key:'removeHardAttachment',value:function removeHardAttachment(fileIndex){var hardAttachments=this.state.hardAttachments;hardAttachments = hardAttachments.filter(function(oneAtt,index){return index !== fileIndex;});this.setState({hardAttachments:hardAttachments});} /**
	     * This function will open an attached document in new window.
	     * @param {*} file
	     */},{key:'openAttachment',value:function openAttachment(file){window.open('/data/document?localId=' + file.localId,'_blank','noopener,noreferrer');} /**
	     * This function will do a precache for a list of documents and fire a callback function
	     * with the extended values
	     * @param {array} attachments - list of documents -> id, date, docType
	     * @param {*} callBack
	     */},{key:'doThePrecache',value:function doThePrecache(attachments){var callBack=arguments.length <= 1 || arguments[1] === undefined?null:arguments[1];var dispatch=this.props.dispatch;var precachers=[],noLoader=true; // prepare lot of promises parallell
	attachments.forEach(function(att){precachers.push(dispatch((0,_stateActions.preCacheDocuments)(att,noLoader))['catch'](function(err){ // do not show individual toaster message, and catch error to keep the then branch for promise
	//dispatch(setNotification(_('attachmentNotFound') +' '+ att.name, 'error'))
	console.error(err);return err;}));}); // pop up the modal
	dispatch((0,_stateActions.showEmailSenderConfirmationModal)("waitingModal",_("pleaseWaitModalTitle"),_("pleaseWaitModalMessage"),"",null));return Promise.all(precachers).then(function(results){var errorPrecacheList=[];dispatch((0,_stateActions.hideEmailSenderConfirmationModal)("waitingModal",true)); // let attachemntsWhatCached = []
	// find the related attachment to give back the local id
	if(attachments && attachments.length > 0 && results && results.length > 0 && results.length == attachments.length){attachments.forEach(function(attVal,attindex){results.forEach(function(resVal,resIndex){if(attVal.id == _nestedProperty2['default'].get(resVal,"data.id")){attVal.localId = _nestedProperty2['default'].get(resVal,"data.localId");}});if(!attVal.localId){errorPrecacheList.push(attVal.aliasFileName);}});} // Display a modal for bad attachments
	if(errorPrecacheList.length > 0){dispatch((0,_stateActions.showEmailSenderConfirmationModal)("emailNotSentModal",_("attachmentsNotCachedTitle"),_("attachmentsNotCachedMessage") + " " + errorPrecacheList.join(", "),"emailSent",null));} // call the callback passing the extended document list with then localId
	if(typeof callBack === 'function'){callBack(attachments);}return attachments;})['catch'](function(err){console.error(err);throw err;});} /**
	     * Get a general filename for attached files to rename in email attachment.
	     * @param {string} originalName
	     * @param {string} date
	     * @param {string} id
	     */},{key:'getDefaultAliasForFileNameInAttachments',value:function getDefaultAliasForFileNameInAttachments(originalName,date,id){return originalName + "-" + date + "-" + id;} /**
	     * Save the old alias names from the old attachment list into the new assigned by ID-s
	     * @param {array} oldAttachments
	     * @param {array} newAttachments
	     */},{key:'getAttachmentsWithRecycledAliasFilenames',value:function getAttachmentsWithRecycledAliasFilenames(oldAttachments,newAttachments){var resultAtt=[];if(newAttachments && newAttachments.length > 0){newAttachments.forEach(function(newDoc){if(oldAttachments && oldAttachments.length > 0){oldAttachments.forEach(function(doc){if(doc.id == newDoc.id && newDoc.aliasFileName !== doc.aliasFileName){newDoc.aliasFileName = doc.aliasFileName;}});} // insert in to the result the attachment anyway, does not matter if alias is updated or not
	resultAtt.push(_extends({},newDoc));});}return resultAtt;} /**
	     * This function will transform the uploader provided document result to a structure for attachments
	     * @param {array} selectedUploaderDocs
	     */},{key:'fetchAttachmentsFromUploaderSelectionDocList',value:function fetchAttachmentsFromUploaderSelectionDocList(selectedUploaderDocs){var _this11=this;var resultAtt=[];if(!_underscore2['default'].isEmpty(selectedUploaderDocs)){selectedUploaderDocs.forEach(function(doc){var formatedDate=doc.date;if(formatedDate){formatedDate = (0,_moment2['default'])(doc.date);if(formatedDate.isValid()){formatedDate = (0,_moment2['default'])(doc.date).format('DD-MM-YYYY');}else {formatedDate = doc.date;}}resultAtt.push({name:doc.name,date:formatedDate,aliasFileName:_this11.getDefaultAliasForFileNameInAttachments(doc.name,formatedDate,doc.id),id:doc.id,oracleDocumentId:doc.id, // added because the ticket document selector
	localId:''});});}return resultAtt;} /**
	     * This function will effect the attaching of document to the attachment list.
	     * @param {array} selected0 - 1th list of documents related by opened module
	     * @param {array} selected - 2th list of documents related by opened module
	     * @param {array} selected2 - list of documents of client module if current module not equal with client module
	     * @param {array} selected3 - list of documents of tarification module if current module not equal with tarification module
	     */},{key:'handleConfirmSelectedAttachments',value:function handleConfirmSelectedAttachments(selected0,selected1){var selected2=arguments.length <= 2 || arguments[2] === undefined?[]:arguments[2];var _this12=this;var selected3=arguments.length <= 3 || arguments[3] === undefined?[]:arguments[3];var selected4=arguments.length <= 4 || arguments[4] === undefined?[]:arguments[4];var attachments=[]; // add attachments from default document list of current module
	var moduleSpecificClaimAttachemnts=this.fetchAttachmentsFromUploaderSelectionDocList(selected0);this.setState({moduleSpecificClaimAttachemnts:moduleSpecificClaimAttachemnts}); // add attachments from default document list of current module
	var moduleSpecificContractAttachemnts=this.fetchAttachmentsFromUploaderSelectionDocList(selected1);this.setState({moduleSpecificContractAttachemnts:moduleSpecificContractAttachemnts}); // add attachments from default document list of current module
	var moduleSpecificTarificationAttachemnts=this.fetchAttachmentsFromUploaderSelectionDocList(selected3);this.setState({moduleSpecificTarificationAttachemnts:moduleSpecificTarificationAttachemnts}); // add attachments from default document list of current module
	var moduleSpecificTicketAttachemnts=this.fetchAttachmentsFromUploaderSelectionDocList(selected4);this.setState({moduleSpecificTicketAttachemnts:moduleSpecificTicketAttachemnts}); // add attachments from optional document list of current module
	var moduleSpecificClientAttachemnts=this.fetchAttachmentsFromUploaderSelectionDocList(selected2);this.setState({moduleSpecificClientAttachemnts:moduleSpecificClientAttachemnts}); // merge all selected lists together for show
	attachments = moduleSpecificClaimAttachemnts.concat(moduleSpecificClientAttachemnts);attachments = moduleSpecificContractAttachemnts.concat(attachments);attachments = moduleSpecificTarificationAttachemnts.concat(attachments);attachments = moduleSpecificTicketAttachemnts.concat(attachments); // remove duplicated attachments by ID to avoid to keep the same file twice in the email
	attachments = attachments.reduce(function(uniqueAttachments,currentAttachment){var id=currentAttachment.id;if(!uniqueAttachments.some(function(attachment){return attachment.id === id;})){uniqueAttachments.push(currentAttachment);}return uniqueAttachments;},[]); // find already edited filenames and associate by ID
	attachments = this.getAttachmentsWithRecycledAliasFilenames(this.state.attachments,attachments); // attachments precache -> update in state -> update in fields for validate
	this.setState({attachments:attachments},function(){if(!_underscore2['default'].isEmpty(_this12.state.attachments)){ // set flag for visual elements (waiting modal etc.)
	_this12.setState({precacheInProgress:true},function(){_this12.forceUpdate();}); // start the caching
	_this12.doThePrecache(_this12.state.attachments,function(extendedAttachemntsWithLocalId){ // remove files from old state, what are can not be cached from any reason
	if(extendedAttachemntsWithLocalId){extendedAttachemntsWithLocalId.forEach(function(oneFile){if(!oneFile.localId){_this12.removeAttachment(oneFile);}});} // update attachments list again by only the successfully cached values
	_this12.setState({attachments:extendedAttachemntsWithLocalId.filter(function(oneAttachment){return Boolean(oneAttachment.localId);})},function(){_this12.updateValidationFieldForAttachments();});}) // the same action in "catch" and "then" because the "finally" not supported in IE
	.then(function(result){_this12.setState({precacheInProgress:false},function(){_this12.forceUpdate();});return result;})['catch'](function(err){_this12.setState({precacheInProgress:false},function(){_this12.forceUpdate();});return err;});}});} /**
	     * Open the attachment modal to attach the documents
	     */},{key:'modalEmailAttach',value:function modalEmailAttach(){var dispatch=this.props.dispatch;dispatch((0,_stateActions.showEmailSenderAttachmentModal)("emailConfModal",_("attaching"),_("pleaseAttach"),"attach",null));} /**
	     * This function just update the field value of the field "attachmentsForValidateOnly"
	     * using all of the attachments
	     */},{key:'updateValidationFieldForAttachments',value:function updateValidationFieldForAttachments(){var allAttachmentTogether=[].concat(this.state.attachments || []).concat(this.state.hardAttachments || []);this.updateFormValue({value:allAttachmentTogether,touched:true},this.props.fields.attachmentsForValidateOnly);} /**
	     * This function will reinsert a new file name alias in attachments list used a file id reference
	     * @param {*} value
	     * @param {*} file
	     */},{key:'onChangeAliasFileName',value:function onChangeAliasFileName(value,file){var attachments=this.state.attachments;attachments.forEach(function(attVal,attIndex){if(attVal.id == file.id){attachments[attIndex].aliasFileName = value;}});this.setState({attachments:attachments},this.updateValidationFieldForAttachments);} /**
	     * This function will reinsert a new file name alias in attachments list used a file id reference
	     * @param {*} value
	     * @param {Number} fileIndex
	     */},{key:'onChangeAliasHardFileName',value:function onChangeAliasHardFileName(value,fileIndex){var hardAttachments=this.state.hardAttachments;hardAttachments.forEach(function(attVal,attIndex){if(attIndex == fileIndex){hardAttachments[attIndex].aliasFileName = value;}});this.setState({hardAttachments:hardAttachments},this.updateValidationFieldForAttachments);} /**
	     * This function handle the keydown event on input of file name.
	     * @param {object} event
	     */},{key:'onKeyDownAliasFileName',value:function onKeyDownAliasFileName(event){ // event.target.focus()
	if(event.key == 'Enter' || event.key == 'Escape'){event.target.blur();}return true;} /**
	     * Render the attachment list table
	     */},{key:'renderAttachments',value:function renderAttachments(){var _this13=this;var attachmentsForValidateOnly=this.props.fields.attachmentsForValidateOnly;var _state5=this.state;var attachments=_state5.attachments;var hardAttachments=_state5.hardAttachments;return _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].attachmentsContainer)},_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].attachRowsContainer},!_underscore2['default'].isEmpty(attachments) && attachments.map(function(file,fileIndex){return _react2['default'].createElement('div',{key:"attachmentFileRow" + fileIndex,className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].attachRow,_this13.state.precacheInProgress || file.localId?"":_emailSenderModalScss2['default'].attachRowError),onClick:function(e){_this13.openAttachment(file);}},_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].icon},_react2['default'].createElement('img',{src:_this13.getIcon('icn-links.svg')})),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].fileName,onClick:function(e){e.stopPropagation();}},_react2['default'].createElement('input',{className:_emailSenderModalScss2['default'].fileNameInput,value:file.aliasFileName,onChange:function(event){return _this13.onChangeAliasFileName(event.target.value,file);},onKeyDown:_this13.onKeyDownAliasFileName})),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].date},file.date),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].operation,onClick:function(e){e.stopPropagation();_this13.removeAttachment(file);}},_react2['default'].createElement('img',{src:_this13.getIcon('a-trash_1x_ovbBlue.svg')})));}),hardAttachments && hardAttachments.length > 0 && hardAttachments.map(function(file,fileIndex){return _react2['default'].createElement('div',{key:"attachmentFileRow" + fileIndex,className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].attachRow,_emailSenderModalScss2['default'].hardAttachments,_this13.state.precacheInProgress || file.localId?"":_emailSenderModalScss2['default'].attachRowError),onClick:function(e){_this13.openAttachment(file);}},_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].icon},_react2['default'].createElement('img',{src:_this13.getIcon('icn-links.svg')})),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].fileName,onClick:function(e){e.stopPropagation();}},_react2['default'].createElement('input',{className:_emailSenderModalScss2['default'].fileNameInput,value:file.aliasFileName,onChange:function(event){return _this13.onChangeAliasHardFileName(event.target.value,fileIndex);},onKeyDown:_this13.onKeyDownAliasFileName})),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].date},file.date),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].operation,onClick:function(e){var hardOnly=true;e.stopPropagation();_this13.removeHardAttachment(fileIndex);}},_react2['default'].createElement('img',{src:_this13.getIcon('a-trash_1x_ovbBlue.svg')})));})));} /**
	     * This function will render a label with button icon for attachments
	     */},{key:'renderAttachmentsLabel',value:function renderAttachmentsLabel(){var _this14=this;return _react2['default'].createElement('label',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formLabel,_emailSenderModalScss2['default'].leftRightAlign),htmlFor:'attachmentsField'},_react2['default'].createElement('span',null,_("attachments")),_react2['default'].createElement('span',null,_react2['default'].createElement('img',{src:this.getIcon('icn-link_1x_blue.svg'),onClick:function(){return _this14.modalEmailAttach();}})));} /**
	     * This function will change the opened module (forward browser) to the signature module
	     */},{key:'navigateToSignature',value:function navigateToSignature(){var dispatch=this.props.dispatch;dispatch((0,_stateActions.setAppModule)(_stateConstants2['default'].OFFICE,'signature'));} /**
	     * This function will change the opened module (forward browser) to the outbox module
	     */},{key:'navigateToOutbox',value:function navigateToOutbox(){var dispatch=this.props.dispatch;dispatch((0,_stateActions.setAppModule)(_stateConstants2['default'].OUTBOX));} /**
	     * This function will render the recipient selector for email sender modal.
	     * @param {object} templateContent
	     * @param {array} templateRecipients
	     * @param {bool} allFieldDisabled
	     */},{key:'renderRecipientSelector',value:function renderRecipientSelector(allFieldDisabled){var _this15=this;var _props$fields2=this.props.fields;var emailTemplateField=_props$fields2.emailTemplateField;var recipientField=_props$fields2.recipientField;var _state6=this.state;var templateContent=_state6.templateContent;var templateRecipients=_state6.templateRecipients;var classNameForContainer=!emailTemplateField || !emailTemplateField.value?_emailSenderModalScss2['default'].visibleNone:"";return _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,classNameForContainer)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].inARow,_emailSenderModalScss2['default'].recipientContainer)},!_underscore2['default'].isEmpty(templateRecipients) && _react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel,htmlFor:'recipientField'},_("selectRecipient"),'*') || null,_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].recipientButtonsContainer},templateRecipients && templateRecipients.map(function(rec,recIndex){var recipientTranslationKey='recipient' + rec.value.charAt(0).toUpperCase() + rec.value.slice(1);return _react2['default'].createElement('div',{key:"recKey" + recIndex,className:_emailSenderModalScss2['default'].recipientButton},_react2['default'].createElement('input',_extends({type:"radio",disabled:allFieldDisabled},recipientField,{value:rec.value,checked:recipientField.value === rec.value,onBlur:function(e){return false;},onChange:function(value){_this15.onChangeRecipient(value,templateRecipients,templateContent);return true;}})),_react2['default'].createElement('label',{onClick:function(e){_this15.onChangeRecipient({target:{value:rec.value}},templateRecipients,templateContent);}},_(recipientTranslationKey)));}) || emailTemplateField && emailTemplateField.value && _react2['default'].createElement('span',{className:_emailSenderModalScss2['default']},_('noRecipientsFound')) || '')));} /**
	     * This function will return a boolean value what to enable all fields of form.
	     * @param {object} emailTemplateField - redux form field object for selecting template
	     * @param {object} recipientField - redux form field object for selecting recipient
	     */},{key:'isDisabledAllOfTheFields',value:function isDisabledAllOfTheFields(emailTemplateField,recipientField){return (emailTemplateField.value || emailTemplateField.value == "0") && recipientField.value?false:true;} /**
	     * This function will change te CC field visibility
	     */},{key:'toggleCCFieldShow',value:function toggleCCFieldShow(){var forceValue=arguments.length <= 0 || arguments[0] === undefined?null:arguments[0];this.setState({isCCShown:forceValue !== null?forceValue:!this.state.isCCShown});} /**
	     * Main renderer. Rendering full component. All together.
	     */},{key:'render',value:function render(){var _this16=this;var _props17=this.props;var fields=_props17.fields;var _props17$fields=_props17.fields;var emailTemplateField=_props17$fields.emailTemplateField;var recipientField=_props17$fields.recipientField;var emailLanguageField=_props17$fields.emailLanguageField;var emailFromField=_props17$fields.emailFromField;var emailToSelectField=_props17$fields.emailToSelectField;var emailToSelectFieldCC=_props17$fields.emailToSelectFieldCC;var subjectField=_props17$fields.subjectField;var emailBodyField=_props17$fields.emailBodyField;var signatureField=_props17$fields.signatureField;var attachmentsForValidateOnly=_props17$fields.attachmentsForValidateOnly;var brokerField=_props17$fields.brokerField;var _props17$options=_props17.options;var EmailTemplateRelations=_props17$options.EmailTemplateRelations;var emailConfModalIsOpen=_props17$options.emailConfModalIsOpen;var moduleKey=_props17$options.moduleKey;var emailNotSentModalIsOpen=_props17$options.emailNotSentModalIsOpen;var waitingModalIsOpen=_props17$options.waitingModalIsOpen;var showPreviewModal=_props17$options.showPreviewModal;var hideCC=_props17$options.hideCC;var emailSentModalIsOpen=_props17$options.emailSentModalIsOpen;var emailSentModal=_props17$options.emailSentModal; // WORKAROUND because of depricated react version
	// we have to clean the defaultChecked prop from the radio button fields because this version of react give a warning
	if(!_underscore2['default'].isEmpty(recipientField) && _underscore2['default'].has(recipientField,"defaultChecked")){delete recipientField.defaultChecked;}var emailServerConfigError=this.state.emailServerConfigError; // fetch the initial values of the form from state
	// const {initialEmailLang} = this.state
	var _state7=this.state;var templateContent=_state7.templateContent;var templatesOptions=_state7.templatesOptions;var templateRecipients=_state7.templateRecipients;var emailToOptions=_state7.emailToOptions;var emailFromOptions=_state7.emailFromOptions;var selectedEmailFromName=_state7.selectedEmailFromName;var langOptions=_state7.langOptions;var signatureOptions=_state7.signatureOptions;var attachments=_state7.attachments;var hardAttachments=_state7.hardAttachments;var brokerOptions=_state7.brokerOptions;var signatures=this.props.options.signatures;var allFieldDisabled=this.isDisabledAllOfTheFields(emailTemplateField,recipientField);var isClientProfileModule=moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value;brokerFieldIsRequired = isClientProfileModule; // when we using the broker selector in client profile all field is disabled until a broker is selected
	if(isClientProfileModule){allFieldDisabled = allFieldDisabled || !Boolean(brokerField) || !Boolean(brokerField.value);}var moduleOptions=this.state && this.state.moduleOptions || {};var signatureId=signatureField && signatureField.value;var slectedSignatureDoc=signatures && signatures.filter(function(item){return item._id == signatureId;});var signatureHtml=_nestedProperty2['default'].get(slectedSignatureDoc,"0.content") || ''; // force get validation result to skip reactForm reaction delay
	var errors=this.forceValidate();attachmentsForValidateOnly.error = errors && errors.attachmentsForValidateOnly;emailBodyField.error = errors && errors.emailBodyField;var toSelectCC=_nestedProperty2['default'].get(emailToSelectFieldCC,"value") || ''; // let isCCShown = toSelectCC && Array.isArray(toSelectCC) && toSelectCC.length > 0 ?
	// toSelectCC/* .filter((oneSelectedAddress)=>{return !!oneSelectedAddress.isCC}) */.length > 0 : false
	// isCCShown = isCCShown || this.state.isCCShown
	var isCCShown=!hideCC;var regExForClientRecipientPrivacy=/(https?:\/\/\S+)/g;var replacementFunction=function replacementFunction(match,i,ofset){return _react2['default'].createElement('a',{href:match,key:match + i},match);};var checkboxDescription=(0,_reactStringReplace2['default'])(_("clientRecipientPrivacyStatement"),regExForClientRecipientPrivacy,replacementFunction);var stakeholders=_nestedProperty2['default'].get(this.state,"moduleOptions.stakeholders") || [];var selectedTemplate=this.getNewSelectedTemplate(emailTemplateField.value);var oneSetClear=DSWIZARD_DISCLAIMER_RESTRICTED_TEMPLATE_SET.replace(/[^0-9A-Za-z-_ ]*/g,'');var regexpForSet=new RegExp('^([;\\s]*' + oneSetClear + '[\\s;]*)$|^([\\s;]*' + oneSetClear + '\\s*;)|(;\\s*' + oneSetClear + '\\s*;)|(;\\s*' + oneSetClear + '\\s*)$|(;\\s*' + oneSetClear + '\\s*)$','i');var haveDisclaimer=selectedTemplate.mailTemplateSet?!regexpForSet.test(selectedTemplate.mailTemplateSet):true;this.props.setDisclaimerForPreview(haveDisclaimer);var ticketDocuments=_nestedProperty2['default'].get(this.state,"moduleOptions.ticketDocuments") || [];var quickReply=_nestedProperty2['default'].get(this.state,"moduleOptions.quickReply") || false;var isOffice=moduleOptions && moduleOptions.dsPackage && moduleOptions.dsPackage.uploadedOnModule === _stateConstants2['default'].DS_MODULE_OFFICE;return _react2['default'].createElement('div',null,_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].loginForm},_react2['default'].createElement('form',{method:'post',className:_emailSenderModalScss2['default'].form},isClientProfileModule && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,_emailSenderModalScss2['default'].marginBottomS)},_react2['default'].createElement('label',{htmlFor:'brokerField',className:_emailSenderModalScss2['default'].formLabel},_("selectBroker"),'*'),_react2['default'].createElement(_sharedSelectSelectWrap2['default'],_extends({className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].sizeL,brokerField && brokerField.value?_emailSenderModalScss2['default'].negativeMarginOne:"")},brokerField,{isClearable:true,options:brokerOptions,onChange:function(value){return _this16.onChangeBroker(value);},onBlur:function(e){e.preventDefault();}}))),isClientProfileModule && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,!brokerField.touched || !brokerField.error?_emailSenderModalScss2['default'].visibleNone:"")},brokerField.touched && brokerField.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},brokerField.error)),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,_emailSenderModalScss2['default'].marginBottomS)},_react2['default'].createElement('label',{htmlFor:'emailTemplateField',className:_emailSenderModalScss2['default'].formLabel},_("selectTemplate"),'*'),_react2['default'].createElement(_reactSelect2['default'],{className:(0,_classnames2['default'])("identificationForTemplateSelector",_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].sizeL,recipientField && recipientField.value?_emailSenderModalScss2['default'].negativeMarginOne:""),styles:_extends({},_emailAddressComposer.customCreatableSelectStyles,{singleValue:function singleValue(base,state){return _extends({},base,{minHeight:"16px",lineHeight:"14px",fontSize:"1.2em",color:"#404548"});},menuList:function menuList(base){return _extends({},base,{padding:"0.1em",fontSize:"1.2em",verticalAlign:"baseline"});},option:function option(base,state){return _extends({},base,{padding:0,fontSize:'1em',maxHeight:"25px",display:state.isSelected?'none':'block',color:state.isSelected?'lightGray':'#404548',backgroundColor:'white'});}}),closeMenuOnScroll:false,components:{DropdownIndicator:_emailAddressComposer.DropdownIndicator,NoOptionsMessageForTemplateSelector:NoOptionsMessageForTemplateSelector},clearable:true,openMenuOnFocus:false,placeholder:'',autofocus:false,options:templatesOptions,onBlurResetsInput:false,isMulti:false,onChange:function(value){_this16.onChangeEmailTemplate(value);},inputId:'templateSelectorSelect1',onBlur:function(e){ // this is a fix for an issue of IE11, to disable dropdown autoclose
	// when scroll by clicking with cursor on scrollbar
	var focusedElement=document.activeElement;var parentClassName=_nestedProperty2['default'].get(focusedElement,"parentElement.parentElement.parentElement.className");var isItSelf=String(parentClassName).includes("identificationForTemplateSelector");if(isItSelf){e.cancelBubbling = true;e.stopPropagation(); //e.stopImmediatePropagation()
	e.preventDefault();e.nativeEvent.cancelBubbling = true;e.nativeEvent.stopPropagation();e.nativeEvent.stopImmediatePropagation();e.nativeEvent.preventDefault();throw null;return false;}},value:{value:String(emailTemplateField.value) || '',label:templatesOptions && templatesOptions.length > 0 && templatesOptions.filter(function(oneTempalte){return String(oneTempalte.value).localeCompare(emailTemplateField.value) === 0;}).length > 0 && templatesOptions.filter(function(oneTempalte){return String(oneTempalte.value).localeCompare(emailTemplateField.value) === 0;})[0].label || ''},filterOption:(0,_reactSelect.createFilter)({ignoreCase:true,ignoreAccents:true,trim:true}), // matchFrom: 'start',
	isSearchable:true,isDisabled:isClientProfileModule && brokerField && !brokerField.value,inputProps:{autoComplete:'off',autoCorrect:'off',spellCheck:'off'}})),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,!emailTemplateField.touched || !emailTemplateField.error?_emailSenderModalScss2['default'].visibleNone:"")},emailTemplateField.touched && emailTemplateField.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},emailTemplateField.error)),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,!emailTemplateField || !emailTemplateField.value?_emailSenderModalScss2['default'].visibleNone:"")},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].inARow,_emailSenderModalScss2['default'].recipientContainer)},!_underscore2['default'].isEmpty(templateRecipients) && _react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel,htmlFor:'recipientField'},_("selectRecipient"),'*') || null,_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].recipientButtonsContainer},templateRecipients && templateRecipients.map(function(rec,recIndex){var recipientTranslationKey='recipient' + rec.value.charAt(0).toUpperCase() + rec.value.slice(1);return _react2['default'].createElement('div',{key:"recKey" + recIndex,className:_emailSenderModalScss2['default'].recipientButton},_react2['default'].createElement('input',_extends({type:"radio"},recipientField,{value:rec.value,checked:recipientField.value === rec.value,onBlur:function(e){return false;},onChange:function(value){_this16.onChangeRecipient(value,templateRecipients,templateContent);return true;}})),_react2['default'].createElement('label',{onClick:function(e){_this16.onChangeRecipient({target:{value:rec.value}},templateRecipients,templateContent);}},_(recipientTranslationKey)));}) || emailTemplateField && emailTemplateField.value && _react2['default'].createElement('span',{className:_emailSenderModalScss2['default']},_('noRecipientsFound')) || ''))),recipientField.value === EmailTemplateRelations.EmailTemplateRecipients.client.value && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup)},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel},'    '),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].clientRecipientPrivacyStatementText)},checkboxDescription)),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,!recipientField.touched || !recipientField.error?_emailSenderModalScss2['default'].visibleNone:"")},recipientField.touched && recipientField.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},recipientField.error)),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel,htmlFor:'emailFromField'},_("selectFromAddress"),'*'),_react2['default'].createElement(_sharedSelectSelectWrap2['default'],_extends({className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].sizeL)},emailFromField,{options:emailFromOptions,isDisabled:allFieldDisabled && !quickReply, // onBlur={(val) => val}
	onChange:function(value){return _this16.onChangeEmailFromAddress(value);},onBlur:function(e){e.preventDefault();}}))),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel}),emailFromField.touched && emailFromField.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},emailFromField.error)),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel,htmlFor:'emailToSelectField'},_("selectToAddress"),'*'),_react2['default'].createElement(_emailAddressComposer2['default'],{emailToSelectField:emailToSelectField,onChangeRecipientEmail:function(inputValue,tContent){var selectedRecipient=fields.recipientField.value;return _this16.onChangeRecipientEmail(selectedRecipient,inputValue,tContent);},templateContent:templateContent?templateContent:{},emailToOptions:emailToOptions?emailToOptions.filter(function(oneSelectedAddress){return !oneSelectedAddress.isCC;}):{},allFieldDisabled:allFieldDisabled || this.props.isCreatable === false,isAnEmail:function(email){return (0,_libValidator.isAnEmail)(email);},isMulti:this.props.forceIsMulti === true?true:this.props.forceIsMulti === false?false:isClientProfileModule?false:true,isCreatable:this.props.isCreatable?isClientProfileModule?false:true:false,formatCreateLabel:_("insertEmailAddresses"),customClassName:(0,_classnames2['default'])(_emailSenderModalScss2['default'].creatableSelectInput),setDeleteItemByOption:function(email){return _this16.removeRecent(email);},showCCButton:false,onClickCCButton:function(){_this16.toggleCCFieldShow();}}),_react2['default'].createElement(_sharedSelectSelectWrap2['default'],_extends({className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].sizeXS)},emailLanguageField,{options:langOptions,isDisabled:allFieldDisabled,onChange:function(value){var selectedRecipient=fields.recipientField.value;return _this16.openAskingModalForLanguageChange(selectedRecipient,value,templateContent);},onBlur:function(e){e.preventDefault();}}))),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formLabel,!emailToSelectField.touched || !emailToSelectField.error?_emailSenderModalScss2['default'].visibleNone:"")}),emailToSelectField.touched && emailToSelectField.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},emailToSelectField.error)),isCCShown?_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel,htmlFor:'emailToSelectFieldCC'},_("selectToAddressCC")),_react2['default'].createElement(_emailAddressComposer2['default'],{emailToSelectField:emailToSelectFieldCC,onChangeRecipientEmail:function(inputValue,tContent){return _this16.onChangeRecipientEmailCC(inputValue,tContent);},templateContent:templateContent?templateContent:{},emailToOptions:emailToOptions?emailToOptions:{},allFieldDisabled:allFieldDisabled,isAnEmail:function(email){return (0,_libValidator.isAnEmail)(email);},isMulti:true,formatCreateLabel:_("insertEmailAddresses"),customClassName:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].sizeL),setDeleteItemByOption:function(email){return _this16.removeRecent(email);}})):null,_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formLabel,!emailToSelectFieldCC.touched || !emailToSelectFieldCC.error?_emailSenderModalScss2['default'].visibleNone:"")}),emailToSelectFieldCC.touched && emailToSelectFieldCC.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},emailToSelectFieldCC.error)),this.props.options.multiLanguage && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,_emailSenderModalScss2['default'].noMarginBottom),key:'languageSelectorFromGroupKey'},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].noMarginRight)},_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].variablesContainer,_emailSenderModalScss2['default'].noMarginRight)},langOptions.filter(function(oneLang){return stakeholders.some(function(oneStake){return oneStake.language === oneLang.value;});}).map(function(oneVar,oneVarIndex){var active=oneVar.value == _this16.state.activeLanguageTabValue;return _react2['default'].createElement('div',{key:"languageIndexOnEmailSender_" + oneVarIndex,onClick:function(e){return _this16.onClickLanguageChangeOfEditor(e,oneVar.value);},className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].variableTab,_emailSenderModalScss2['default'].languageRow,active?_emailSenderModalScss2['default'].languageRowActive:"")},_(oneVar.value));}),_react2['default'].createElement('div',{key:"languageIndexOnEmailSender_lastline",className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].variableTab,_emailSenderModalScss2['default'].languageRow,_emailSenderModalScss2['default'].languageRowTopLine)})))),_react2['default'].createElement('div',{className:this.props.options.multiLanguage?_emailSenderModalScss2['default'].multiLanguageTabContent:null},_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel,htmlFor:'recipient'},_("subject"),'*'),_react2['default'].createElement('input',_extends({type:"text",className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].formInputText)},subjectField,{disabled:allFieldDisabled || recipientField.value == EmailTemplateRelations.EmailTemplateRecipients.willemot.value || recipientField.value == EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value || recipientField.value == EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value || recipientField.value == EmailTemplateRelations.EmailTemplateRecipients.willemotTarification.value}))),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel}),subjectField.touched && subjectField.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},subjectField.error)),window.tinymce && this.renderBodyEditor({disabled:allFieldDisabled,templateContent:templateContent},emailBodyField),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formLabel,!emailBodyField.touched || !emailBodyField.error?_emailSenderModalScss2['default'].visibleNone:"")}),emailBodyField.touched && emailBodyField.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},emailBodyField.error))),!isOffice && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formLabel,_emailSenderModalScss2['default'].leftRightAlign),htmlFor:'signatureField'},_react2['default'].createElement('span',null,_("signature")),_react2['default'].createElement('span',null,_react2['default'].createElement('a',{href:"/office/signature",onClick:function(e){e.preventDefault();if(confirm(_("areYouSureToLeaveThisPage"))){_this16.navigateToSignature();}},target:'_self'},_react2['default'].createElement('img',{src:this.getIcon('a-edit_1x_blue.svg'),alt:_('goToManageSignatures')})))),_react2['default'].createElement(_sharedSelectSelectWrap2['default'],_extends({className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput)},signatureField,{isClearable:true,options:signatureOptions,isDisabled:allFieldDisabled,onBlur:function(e){e.preventDefault();}}))),!isOffice && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].formGroup},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel}),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].signature),dangerouslySetInnerHTML:{__html:signatureHtml}})),(!_underscore2['default'].isEmpty(attachments) || !_underscore2['default'].isEmpty(hardAttachments)) && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,_emailSenderModalScss2['default'].attachmentsFormGroup)},this.renderAttachmentsLabel(),this.renderAttachments()),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup,!attachmentsForValidateOnly.error?_emailSenderModalScss2['default'].visibleNone:"")},_react2['default'].createElement('label',{className:_emailSenderModalScss2['default'].formLabel}),attachmentsForValidateOnly.error && _react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].errorMessage},attachmentsForValidateOnly.error)),_underscore2['default'].isEmpty(attachments) && _underscore2['default'].isEmpty(hardAttachments) && _react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formGroup)},this.renderAttachmentsLabel(),_react2['default'].createElement('div',{className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].formInput,_emailSenderModalScss2['default'].noAttachmentText)},_("noAttachemntsSelected"))))),_react2['default'].createElement(_confirmationDialog2['default'],{modalIsOpen:emailConfModalIsOpen,cancelLabel:_("cancel"),confirmationLabel:_("ok"),onCancel:function(){var dispatch=_this16.props.dispatch;dispatch((0,_stateActions.hideEmailSenderConfirmationModal)("emailConfModal",false));},onConfirmation:function callee$2$0(){var _props18,dispatch,confirmationModal,flag,recipient;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:_props18 = this.props;dispatch = _props18.dispatch;confirmationModal = _props18.options.confirmationModal;flag = confirmationModal && confirmationModal.flag || '';recipient = fields.recipientField.value;context$3$0.t0 = flag;context$3$0.next = context$3$0.t0 === "changeTemplate"?8:context$3$0.t0 === "changeRecipient"?10:context$3$0.t0 === "changeLanguage"?12:context$3$0.t0 === "changeBroker"?14:18;break;case 8:this.doTheTemplateSwitch(moduleOptions.brokerNumber,moduleOptions.clientLanguage);return context$3$0.abrupt('break',18);case 10:this.doTheRecipientSwitch();return context$3$0.abrupt('break',18);case 12:this.doTheLanguageChange(recipient);return context$3$0.abrupt('break',18);case 14:context$3$0.next = 16;return regeneratorRuntime.awrap(this.doTheBrokerChange(moduleOptions));case 16:this.setState({moduleOptions:moduleOptions});return context$3$0.abrupt('break',18);case 18:context$3$0.next = 20;return regeneratorRuntime.awrap(dispatch((0,_stateActions.hideEmailSenderConfirmationModal)("emailConfModal",true)));case 20:case 'end':return context$3$0.stop();}},null,_this16);}}),_react2['default'].createElement(_confirmationDialog2['default'],{modalIsOpen:emailSentModalIsOpen,cancelLabel:_("goToOutbox"),confirmationLabel:_("ok"),onCancel:function(){var dispatch=_this16.props.dispatch;dispatch((0,_stateActions.setEmailSenderModule)(''));dispatch((0,_stateActions.hideEmailSenderModal)());_this16.navigateToOutbox(); // fire callback of the emailer button parent component
	if(typeof _this16.props.onSentLate === 'function'){_this16.props.onSentLate(_nestedProperty2['default'].get(emailSentModal,"payload"));}},onConfirmation:function(){var _props19=_this16.props;var dispatch=_props19.dispatch;var confirmationModal=_props19.options.confirmationModal;var flag=confirmationModal && confirmationModal.flag || '';dispatch((0,_stateActions.setEmailSenderModule)(''));dispatch((0,_stateActions.hideEmailSenderModal)()); // fire callback of the emailer button parent component
	if(typeof _this16.props.onSentLate === 'function'){_this16.props.onSentLate(_nestedProperty2['default'].get(emailSentModal,"payload"));}},contentData:emailSentModal}),_react2['default'].createElement(_confirmationDialog2['default'],{modalIsOpen:emailNotSentModalIsOpen,confirmationLabel:_("ok"),onConfirmation:function(){var _props20=_this16.props;var dispatch=_props20.dispatch;var confirmationModal=_props20.options.confirmationModal;var flag=confirmationModal && confirmationModal.flag || '';dispatch((0,_stateActions.hideEmailSenderConfirmationModal)("emailNotSentModal",true));}}),_react2['default'].createElement(_confirmationDialog2['default'],{modalIsOpen:waitingModalIsOpen,options:{noButtons:true}}),_react2['default'].createElement(_attachmentDialog2['default'],{cancelLabel:_("cancel"),confirmationLabel:_("ok"),onCancel:function(){var dispatch=_this16.props.dispatch;dispatch((0,_stateActions.hideEmailSenderAttachmentModal)(false));},onConfirmation:function(){var result0=arguments.length <= 0 || arguments[0] === undefined?[]:arguments[0];var result1=arguments.length <= 1 || arguments[1] === undefined?[]:arguments[1];var result2=arguments.length <= 2 || arguments[2] === undefined?[]:arguments[2];var result3=arguments.length <= 3 || arguments[3] === undefined?[]:arguments[3];var result4=arguments.length <= 4 || arguments[4] === undefined?[]:arguments[4];var _props21=_this16.props;var dispatch=_props21.dispatch;var attachmentModal=_props21.options.attachmentModal;var flag=attachmentModal && attachmentModal.flag || '';switch(flag){case "attach":{_this16.handleConfirmSelectedAttachments(result0,result1,result2,result3,result4);break;}}dispatch((0,_stateActions.hideEmailSenderAttachmentModal)(true));},moduleOptions:moduleOptions,moduleKey:moduleKey,selected0:this.state.moduleSpecificClaimAttachemnts,selected1:this.state.moduleSpecificContractAttachemnts,selected2:this.state.moduleSpecificClientAttachemnts,selected3:this.state.moduleSpecificTarificationAttachemnts,selected4:this.state.moduleSpecificTicketAttachemnts,ticketDocuments:ticketDocuments}),_react2['default'].createElement(_confirmationDialog2['default'],{modalIsOpen:showPreviewModal,confirmationLabel:_("ok"),onConfirmation:function(){var dispatch=_this16.props.dispatch;dispatch((0,_stateActions.hideEmailSenderConfirmationModal)("previewModal",true));},options:{email:this.state.finalEmail,showPrintButton:true,printButtonLabel:_("print")}}));}}]);var _SenderForm=SenderForm;SenderForm = (0,_reduxForm.reduxForm)({form:"emailSender",fields:listOfFields,validate:validate, // asyncValidate,
	// asyncBlurFields: ['emailFromField'],
	destroyOnUnmount:true,touchOnBlur:true})(SenderForm) || SenderForm;return SenderForm;})(_react2['default'].Component);var EmailSenderModal=(function(_React$Component2){_inherits(EmailSenderModal,_React$Component2);_createClass(EmailSenderModal,null,[{key:'propTypes',value:{dispatch:_react2['default'].PropTypes.any,templates:_react2['default'].PropTypes.array.isRequired,signatures:_react2['default'].PropTypes.array,recipientWillemotEmails:_react2['default'].PropTypes.array,lang:_react2['default'].PropTypes.string,moduleKey:_react2['default'].PropTypes.string.isRequired,moduleOptions:_react2['default'].PropTypes.object,EmailTemplateRelations:_react2['default'].PropTypes.any,contractManagerLanguage:_react2['default'].PropTypes.string,contractManagerMail:_react2['default'].PropTypes.string,claimsManagersDetails:_react2['default'].PropTypes.array,office:_react2['default'].PropTypes.any,files:_react2['default'].PropTypes.any,externalAttachments:_react2['default'].PropTypes.any,onSent:_react2['default'].PropTypes.func,onSentLate:_react2['default'].PropTypes.func,modalId:_react2['default'].PropTypes.string,hideCC:_react2['default'].PropTypes.bool,multiLanguage:_react2['default'].PropTypes.bool,serialSending:_react2['default'].PropTypes.bool,getDSStakeholders:_react2['default'].PropTypes.func,isCreatable:_react2['default'].PropTypes.bool,forceIsMulti:_react2['default'].PropTypes.bool,onCancel:_react2['default'].PropTypes.func},enumerable:true}]);function EmailSenderModal(props){_classCallCheck(this,_EmailSenderModal);_get(Object.getPrototypeOf(_EmailSenderModal.prototype),'constructor',this).call(this,props);this.haveDisclaimer = false;this.state = {email:{senderEmail:'',cleanSenderEmail:'',to:'',subject:'',message:'',attachments:[],recipient:'',templateIndexType:'',templateLowValue:'',templateTitle:'',templateAbbr:'',clientId:'',contractId:'',claimId:'',signatureId:false,sendingButtonDisabled:false},hasErrors:false,emailSentModalIsOpen:false};} /**
	     * This function handle the touch event, to trigger blur.
	     * @param {*} field
	     */_createClass(EmailSenderModal,[{key:'touch',value:function touch(field){field.onBlur();} /**
	     * this function has been modified, now it checks if email server settings has senderName parameter
	     * If it dosent a configuration modal will be opened where it can be configured, afterward the sending process will continue normaly
	     */},{key:'modalEmailSend',value:function modalEmailSend(){var _this17=this;var dispatch=this.props.dispatch;var senderEmailFieldValue=this.state.email.senderEmail;dispatch((0,_stateActions.loadEmailServer)(senderEmailFieldValue)).then(function callee$2$0(res){return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:if(!(res && res.senderName && res.senderName.length > 0)){context$3$0.next = 5;break;}context$3$0.next = 3;return regeneratorRuntime.awrap(this.sendEmail());case 3:context$3$0.next = 6;break;case 5:dispatch((0,_stateActions.showEmailServerConfigModal)(senderEmailFieldValue));case 6:case 'end':return context$3$0.stop();}},null,_this17);})['catch'](function(err){dispatch((0,_stateActions.showEmailServerConfigModal)(senderEmailFieldValue));});} /**
	     * This function will open the notification modal after email sending.
	     * From here you can navigate to outbox.
	     */},{key:'sendEmail',value:function sendEmail(){var _props22,dispatch,onSent,serialSending,multiLanguage,lang,response,stakeholderMap,stakeholders,originalConfig,tos,_loop,i,language,oneResult,messageForErrorModal;return regeneratorRuntime.async(function sendEmail$(context$2$0){var _this18=this;while(1) switch(context$2$0.prev = context$2$0.next){case 0:_props22 = this.props;dispatch = _props22.dispatch;onSent = _props22.onSent;serialSending = _props22.serialSending;multiLanguage = _props22.multiLanguage;lang = _props22.lang; // async, just disable the buton on next render
	this.setState({sendingButtonDisabled:true});context$2$0.prev = 7;response = [];if(!serialSending){context$2$0.next = 26;break;}stakeholderMap = this.state.email.moduleOptions.stakeholders.map(function(item){return {stakeholder:item._id};});context$2$0.next = 13;return regeneratorRuntime.awrap(this.props.getDSStakeholders(stakeholderMap));case 13:stakeholders = context$2$0.sent;originalConfig = JSON.parse(JSON.stringify(this.state.email));tos = originalConfig.to.split(";");_loop = function callee$2$0(i){var oneTo,cloneConfig,stakeholder,oneStakeLang,instantVariables,link,oneEmailResult;return regeneratorRuntime.async(function callee$2$0$(context$3$0){while(1) switch(context$3$0.prev = context$3$0.next){case 0:oneTo = tos[i];cloneConfig = JSON.parse(JSON.stringify(originalConfig)); // overwrite the recipient temporary
	cloneConfig.to = oneTo; //the email addresses in the to is muts be raw email addresses all the time, no decorations like name<...> so on.
	stakeholder = stakeholders.find(function(oneStake){return String(oneStake.email).trim() === String(oneTo).trim();});if(!stakeholder){console.error("No stakeholder found to detect the language for recipient. Fall back to nl. all stakholder: ",stakeholders,"one to address ",oneTo);} // determine the language
	oneStakeLang = stakeholder?String(stakeholder.language).toLowerCase():'nl';instantVariables = []; // overwrite the content and subject of the email
	// when the multilanguage switch is on, working only when serial sending is on
	if(multiLanguage){cloneConfig.message = oneStakeLang === 'nl'?cloneConfig.nlMessage:cloneConfig.frMessage;cloneConfig.subject = oneStakeLang === 'nl'?cloneConfig.nlSubject:cloneConfig.frSubject;link = stakeholder.privateLink; // preaprea personalised variable values for stakeholders
	instantVariables.push({value:_(DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY,oneStakeLang),fetchValue:link});instantVariables.push({value:_(DSWIZARD_RECIPIENT_NAME_PLACEHOLDER_TRANS_KEY,oneStakeLang),fetchValue:stakeholder.firstName + " " + stakeholder.lastName});} // preplace instant variabels only in body
	instantVariables.forEach(function(onVar){cloneConfig.message = String(cloneConfig.message).replaceAll(onVar.value,onVar.fetchValue);}); // add disclaimer
	cloneConfig.message = cloneConfig.message;cloneConfig.disclaimerHtml = this.haveDisclaimer?_("disclaimerText",oneStakeLang):""; // send one email from one recipient
	context$3$0.next = 13;return regeneratorRuntime.awrap(dispatch((0,_stateActions.sendEmailBySender)(cloneConfig)));case 13:oneEmailResult = context$3$0.sent;response.push(oneEmailResult);case 15:case 'end':return context$3$0.stop();}},null,_this18);};i = 0;case 18:if(!(i < tos.length)){context$2$0.next = 24;break;}context$2$0.next = 21;return regeneratorRuntime.awrap(_loop(i));case 21:i++;context$2$0.next = 18;break;case 24:context$2$0.next = 34;break;case 26:language = this.state.email.moduleOptions.clientLanguage || lang;originalConfig = JSON.parse(JSON.stringify(this.state.email));originalConfig.message = originalConfig.message;originalConfig.disclaimerHtml = this.haveDisclaimer?_("disclaimerText",language):"";context$2$0.next = 32;return regeneratorRuntime.awrap(dispatch((0,_stateActions.sendEmailBySender)(originalConfig)));case 32:oneResult = context$2$0.sent;response.push(oneResult);case 34:this.setState({emailSentModal:{modalId:"emailSentModal",title:_("emailSent"),message:_("emailSentMessage"),flag:"emailSent",payload:response},emailSentModalIsOpen:true}); // refreshing the outbox
	context$2$0.next = 37;return regeneratorRuntime.awrap(dispatch((0,_stateActions.getOutbox)(true)));case 37: // fire callback of the emailer button parent component
	if(typeof onSent === 'function'){onSent(response);}context$2$0.next = 46;break;case 40:context$2$0.prev = 40;context$2$0.t0 = context$2$0['catch'](7);console.error(context$2$0.t0);messageForErrorModal = _("emailNotSentMessage") + ' "' + (_nestedProperty2['default'].get(context$2$0.t0,"error.errorMessage") || JSON.stringify(context$2$0.t0)) + '"'; //added a check in case error from server is "{}", maybe we should change the emailNotSentMessage to its own translation case error is from server
	if(_nestedProperty2['default'].get(context$2$0.t0,"error.data.code") * 1 == 2 && _nestedProperty2['default'].get(context$2$0.t0,"error.data.error") !== "{}"){messageForErrorModal = _("emailNotSentMessage") + ' "' + JSON.stringify(_nestedProperty2['default'].get(context$2$0.t0,"error.data.error")) + '"';}dispatch((0,_stateActions.showEmailSenderConfirmationModal)("emailNotSentModal",_("emailNotSentTitle"),messageForErrorModal,"emailSent",null));case 46:this.setState({sendingButtonDisabled:false});case 47:case 'end':return context$2$0.stop();}},null,this,[[7,40]]);} /**
	     * Callback function given for email composer, to actualize the current email content in this module
	     * @param {Object} email - Full email content object
	     */},{key:'actualizeEmailContent',value:function actualizeEmailContent(email){this.setState({email:_extends({},email)});} /**
	     * Event to leave the email sender modal.
	     */},{key:'goBack',value:function goBack(){var _props23=this.props;var dispatch=_props23.dispatch;var onCancel=_props23.onCancel;dispatch((0,_stateActions.hideEmailSenderModal)());dispatch((0,_stateActions.setEmailSenderModule)(''));if(onCancel){onCancel();}}},{key:'modalPreviewEmail',value:function modalPreviewEmail(){var dispatch=this.props.dispatch;var email=this.state.email;var html='<div style="display: felx; flex-direction: column;">' + '<div style="flex-flow: row nowrap; align-items: flex-start;">' + '<span style="display: inline-block; width: 20%;">' + _("subject") + ': </span> <span style="flex: 5; word-break: break-all;">' + email.subject + "</span>" + '</div>' + '<div style="flex-flow: row nowrap; align-items: flex-start;">' + '<span style="display: inline-block; width: 20%;">' + _("selectFromAddress") + ': </span> <span style="flex: 5; word-break: break-all;">' + email.senderEmail + "</span>" + '</div>' + '<div style="flex-flow: row nowrap; align-items: flex-start;">' + '<span style="display: inline-block; width: 20%;">' + _("selectToAddress") + ': </span> <span style="flex: 5; word-break: break-all;">' + email.to + "</spans>" + '</div>' + '</div>' + '<hr/>' + email.message + email.signatureHtml + email.disclaimerHtml;dispatch((0,_stateActions.showEmailSenderConfirmationModal)("previewModal",email.subject, // modal title
	html,"",null));}},{key:'render',value:function render(){var _this19=this;var _props24=this.props;var dispatch=_props24.dispatch;var emailServerConfigModalIsOpen=_props24.emailServerConfigModalIsOpen;var _state8=this.state;var sendingButtonDisabled=_state8.sendingButtonDisabled;var showPreviewModal=_state8.showPreviewModal;return _react2['default'].createElement('div',{key:"emailSenderModalMainContainerKey"},_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].title,key:"emailSenderModalMainContainerTitleKey"},_('emailSenderTitle')),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].contentWrapper,key:"emailSenderModalMainContainerWrapperKey"},_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].content,key:"emailSenderModalContentKey"},_react2['default'].createElement(SenderForm,{goBack:function(){return _this19.goBack();},options:_extends({},this.props,{moduleOptions:this.props.moduleOptions,hasErrors:this.state.hasErrors,emailSentModal:this.state.emailSentModal,emailSentModalIsOpen:this.state.emailSentModalIsOpen}),dataCallback:function(email){_this19.actualizeEmailContent(email);},dataCallbackDisableSend:function(error){if(!!error !== !!_this19.state.hasErrors){_this19.setState({hasErrors:Boolean(error)});}},setDisclaimerForPreview:function(newHaveDisclaimer){_this19.haveDisclaimer = newHaveDisclaimer;},onSentLate:function(){_this19.setState({emailSentModal:false,emailSentModalIsOpen:false});if(typeof _this19.props.onSentLate === 'function'){_this19.props.onSentLate(_this19.state.emailSentModal.payload);}},isCreatable:this.props.isCreatable,forceIsMulti:this.props.forceIsMulti,haveDisclaimer:this.haveDisclaimer})),_react2['default'].createElement('div',{className:_emailSenderModalScss2['default'].buttons,key:"emailSenderModalButtonsListsKey"},_react2['default'].createElement('div',{key:"emailSenderModalButtonsCancelKey",onClick:function(){return _this19.goBack();},className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].cancelButton)},_('cancel')),_react2['default'].createElement('div',{key:"emailSenderModalButtonsSendKey",onClick:function(e){e.preventDefault();if(_this19.state.hasErrors || sendingButtonDisabled){return;}_this19.modalEmailSend();},className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].next,this.state.hasErrors?_emailSenderModalScss2['default'].disabled:_emailSenderModalScss2['default'].enabled)},_('sendEmail')),_react2['default'].createElement('div',{key:"emailSenderModalButtonsPreviewKey",onClick:function(e){e.preventDefault();if(_this19.state.hasErrors || sendingButtonDisabled){return;}_this19.modalPreviewEmail();},className:(0,_classnames2['default'])(_emailSenderModalScss2['default'].next,this.state.hasErrors?_emailSenderModalScss2['default'].disabled:_emailSenderModalScss2['default'].enabled)},_('previewEmail')))),_react2['default'].createElement(_emailServerConfigDialog2['default'],{modalIsOpen:emailServerConfigModalIsOpen,onCancel:function(){var dispatch=_this19.props.dispatch;dispatch((0,_stateActions.hideEmailServerConfigModal)(false));},onConfirmation:function(config){dispatch((0,_stateActions.saveEmailServer)(config)).then(function(res){dispatch((0,_stateActions.hideEmailServerConfigModal)(true));if(res){_this19.sendEmail();}});}}));}}]);var _EmailSenderModal=EmailSenderModal;EmailSenderModal = (0,_reactRedux.connect)(function(state){return {lang:state.app.lang,userId:state.app.userId,EmailTemplateRelations:state.app.security.EmailTemplateRelations,office:state.office,brokers:state.office.brokers,files:state.files,confirmationModal:state.emailSender.confirmationModal,attachmentModal:state.emailSender.attachmentModal,emailConfModalIsOpen:state.emailSender.emailConfModalIsOpen, // emailSentModalIsOpen: state.emailSender.emailSentModalIsOpen,
	emailNotSentModalIsOpen:state.emailSender.emailNotSentModalIsOpen,waitingModalIsOpen:state.emailSender.waitingModalIsOpen,showPreviewModal:state.emailSender.showPreviewModal,externalAttachments:state.emailSender.externalAttachments,emailServerConfigModalIsOpen:state.emailSender.emailServerConfigModalIsOpen,serverConfigIsSaved:state.emailSender.serverConfigIsSaved};})(EmailSenderModal) || EmailSenderModal;return EmailSenderModal;})(_react2['default'].Component);exports['default'] = EmailSenderModal; // when the email editor must initialized with values provided by another module like inbox.
	// must get the office data for all informations for variables
	// removed this functionality as it never worked and now causes the module to crash
	//await dispatch(fetchOfficeData())
	/*#region [RenderInput]*/ /*#endregion*/ /*#region [RenderError]*/ /*#endregion*/ /*#region [RenderInput]*/ /*#endregion*/ /*#region [RenderError]*/ /*#endregion*/ /*#region [RenderInput]*/ /*#endregion*/ /*#region [RenderError]*/ /*#endregion*/ /*#region [RenderInput]*/ /* <label className={cs(styles.formInput,styles.sizeS)}>{selectedEmailFromName}</label> */ /*#endregion*/ /*#region [RenderError]*/ /* {
	                                emailServerConfigError && errors.emailFromField &&
	                                <div className={styles.errorMessage}>
	                                    {errors.emailFromField}
	                                </div>
	                            } */ /*#endregion*/ /*#region [RenderInput]*/ /*<SelectWrapper
	                                className={cs(styles.formInput,styles.sizeMS,styles.marginPlusOne)}
	                                {...emailToSelectField}
	                                options={emailToOptions}
	                                disabled={allFieldDisabled}
	                                clearable={true}
	                                onChange={(value) => (this.onChangeRecipient Email(value, templateContent))}

	                            />*/ /*#region [RenderError]*/ /*#endregion*/ /*#endregion*/ /*#region [RenderError]*/ /*#endregion*/ /*#region [RenderInput]*/ /*#endregion*/ /*#region [RenderError]*/ /*#endregion*/ /*#region [RenderInput]*/ /*#region [RenderError]*/ /*#endregion*/ /* haveDisclaimer &&
	                            <div className={styles.formGroup}>
	                                <label className={cs(styles.formLabel)}>{_("disclaimerLabel")}</label>
	                                <div className={cs(styles.formInput)}
	                                    dangerouslySetInnerHTML={{__html: _("disclaimerText")}}>
	                                </div>
	                                </div> */ /*#endregion*/ /*#region [RenderInput]*/ /*#endregion*/ /*#region [RenderError]*/ /*#endregion*/ /*#region [Helpers]*/ /*#endregion*/ // result of the responses
	// handle multi email sending
	// NOTICE cc-s not supported while serial sending email (skipped), normally CC is disabled in this case.
	// iterating the recipients to send email one by one on serial mode
	// clone the settings to modify it for indepentdent dsendings.
	// single email sending for all recipients

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _emailSenderModalScss = __webpack_require__(303);
	
	var _emailSenderModalScss2 = _interopRequireDefault(_emailSenderModalScss);
	
	var _emailSenderModal = __webpack_require__(1099);
	
	var _emailSenderModal2 = _interopRequireDefault(_emailSenderModal);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var EmailSender = (function (_React$Component) {
	    _inherits(EmailSender, _React$Component);
	
	    _createClass(EmailSender, null, [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            modalIdOpened: _react2['default'].PropTypes.any,
	            moduleKey: _react2['default'].PropTypes.string.isRequired,
	            moduleOptions: _react2['default'].PropTypes.object,
	            contractManagerLanguage: _react2['default'].PropTypes.string,
	            contractManagerMail: _react2['default'].PropTypes.string,
	            claimsManagersDetails: _react2['default'].PropTypes.array,
	            claimsManagers: _react2['default'].PropTypes.array,
	            modalId: _react2['default'].PropTypes.string,
	            onSent: _react2['default'].PropTypes.func,
	            onSentLate: _react2['default'].PropTypes.func,
	            hideCC: _react2['default'].PropTypes.bool,
	            multiLanguage: _react2['default'].PropTypes.bool,
	            serialSending: _react2['default'].PropTypes.bool,
	            getDSStakeholders: _react2['default'].PropTypes.func,
	            isCreatable: _react2['default'].PropTypes.bool,
	            forceIsMulti: _react2['default'].PropTypes.bool,
	            onCancel: _react2['default'].PropTypes.func,
	            forceOpen: _react2['default'].PropTypes.bool
	        },
	        enumerable: true
	    }]);
	
	    function EmailSender(props) {
	        _classCallCheck(this, _EmailSender);
	
	        _get(Object.getPrototypeOf(_EmailSender.prototype), 'constructor', this).call(this, props);
	
	        this.state = {
	            templates: null,
	            signatures: null,
	            recipientWillemotEmails: null
	        };
	    }
	
	    _createClass(EmailSender, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props, moduleKey, dispatch, moduleOptions, moduleRelated, signaturesResponse;
	
	            return regeneratorRuntime.async(function componentDidMount$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props = this.props;
	                        moduleKey = _props.moduleKey;
	                        dispatch = _props.dispatch;
	                        moduleOptions = _props.moduleOptions;
	                        context$2$0.next = 6;
	                        return regeneratorRuntime.awrap(this.processModuleKey(moduleKey, _nestedProperty2['default'].get(moduleOptions, "dsPackage._id"), _nestedProperty2['default'].get(moduleOptions, "stakeholders")));
	
	                    case 6:
	                        moduleRelated = context$2$0.sent;
	                        context$2$0.next = 9;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.loadSignatures)()));
	
	                    case 9:
	                        signaturesResponse = context$2$0.sent;
	
	                        this.setState({
	                            templates: moduleRelated.templates,
	                            recipientWillemotEmails: moduleRelated.recipientWillemotEmails,
	                            signatures: signaturesResponse.signatures
	                        }, function () {
	                            dispatch((0, _stateActions.showEmailSenderModal)());
	                        });
	
	                        /*  let whiteListRecipients = [];
	                         const clientProfileKey = nesProp.get(EmailTemplateRelations, "recipientsWithModules") || false
	                           // TODO compose enabled recipient list after module
	                         switch( moduleKey ) {
	                             case 'balh': {
	                                 whiteListRecipients = []
	                                 break
	                             }
	                             default:
	                           }  */
	                        // const EmailTemplateRelations
	
	                    case 11:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         *
	         * @param {*} nextProps
	         */
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props2, dispatch, moduleOptions, moduleRelated;
	
	            return regeneratorRuntime.async(function componentWillReceiveProps$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        moduleOptions = _props2.moduleOptions;
	
	                        if (!(this.props.moduleKey !== nextProps.moduleKey)) {
	                            context$2$0.next = 8;
	                            break;
	                        }
	
	                        context$2$0.next = 6;
	                        return regeneratorRuntime.awrap(this.processModuleKey(nextProps.moduleKey, _nestedProperty2['default'].get(moduleOptions, "dsPackage._id"), _nestedProperty2['default'].get(moduleOptions, "stakeholders")));
	
	                    case 6:
	                        moduleRelated = context$2$0.sent;
	
	                        this.setState({
	                            templates: moduleRelated.templates,
	                            recipientWillemotEmails: moduleRelated.recipientWillemotEmails
	                        }, function () {
	                            dispatch((0, _stateActions.showEmailSenderModal)());
	                        });
	
	                    case 8:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * This function determine the list of templates available and the recipients list for emailer.
	         * @param {*} moduleKey
	         * @param {*} packageId
	         * @param {*} stakeholders
	         * @returns
	         */
	    }, {
	        key: 'processModuleKey',
	        value: function processModuleKey(moduleKey) {
	            var packageId = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	            var stakeholders = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	            var _props3, dispatch, moduleOptions, EmailTemplateRelations, templates, recipientWillemotEmails, templateResponse, formFiller, moduleKeyForTempalteFetch;
	
	            return regeneratorRuntime.async(function processModuleKey$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props3 = this.props;
	                        dispatch = _props3.dispatch;
	                        moduleOptions = _props3.moduleOptions;
	                        EmailTemplateRelations = _props3.EmailTemplateRelations;
	
	                        if (moduleKey) {
	                            context$2$0.next = 6;
	                            break;
	                        }
	
	                        return context$2$0.abrupt('return', {
	                            templates: [],
	                            recipientWillemotEmails: []
	                        });
	
	                    case 6:
	                        templates = [];
	                        recipientWillemotEmails = [];
	
	                        if (!(packageId && stakeholders)) {
	                            context$2$0.next = 17;
	                            break;
	                        }
	
	                        context$2$0.next = 11;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getInvitationTemplates)(moduleKey, packageId)));
	
	                    case 11:
	                        templateResponse = context$2$0.sent;
	
	                        templates = templateResponse && templateResponse.templates || [];
	
	                        //determine if there is a form filler and status for form filling is Available and for signing is Waiting
	                        formFiller = stakeholders.find(function (oneStakeholder) {
	                            return oneStakeholder.roles.find(function (oneRole) {
	                                return oneRole.type === 'formFiller' && oneRole.status === 'Available';
	                            });
	                        });
	
	                        if (formFiller) {
	                            recipientWillemotEmails = [{
	                                email: formFiller.email,
	                                name: {
	                                    first: formFiller.firstName,
	                                    last: formFiller.lastName
	                                },
	                                language: formFiller.language
	                            }];
	                        } else {
	                            recipientWillemotEmails = stakeholders.map(function (oneStake) {
	                                return {
	                                    email: oneStake.email,
	                                    name: {
	                                        first: oneStake.firstName,
	                                        last: oneStake.lastName
	                                    },
	                                    language: oneStake.language
	                                };
	                            });
	                        }
	
	                        context$2$0.next = 24;
	                        break;
	
	                    case 17:
	                        moduleKeyForTempalteFetch = moduleKey;
	
	                        if (moduleOptions && moduleOptions.startedFromModule == _stateConstants2['default'].EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT && moduleOptions.quickReply) {
	                            moduleKeyForTempalteFetch = EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value;
	                        }
	
	                        context$2$0.next = 21;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.getEmailTemplate)(moduleKeyForTempalteFetch)));
	
	                    case 21:
	                        templateResponse = context$2$0.sent;
	
	                        templates = templateResponse && templateResponse.templates || [];
	                        recipientWillemotEmails = templateResponse && templateResponse.recipientWillemotEmails || [];
	
	                    case 24:
	                        return context$2$0.abrupt('return', {
	                            templates: templates,
	                            recipientWillemotEmails: recipientWillemotEmails
	                        });
	
	                    case 25:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props4 = this.props;
	            var onSent = _props4.onSent;
	            var onSentLate = _props4.onSentLate;
	            var modalId = _props4.modalId;
	            var modalIsOpen = _props4.modalIsOpen;
	            var hideCC = _props4.hideCC;
	            var forceOpen = _props4.forceOpen;
	            var _state = this.state;
	            var templates = _state.templates;
	            var signatures = _state.signatures;
	            var recipientWillemotEmails = _state.recipientWillemotEmails;
	
	            return _react2['default'].createElement(
	                'div',
	                { key: "EmailSenderModal" + modalId + "key" },
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: !!modalIsOpen || !!forceOpen,
	                        style: customStyles,
	                        className: _emailSenderModalScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    templates && _react2['default'].createElement(_emailSenderModal2['default'], _extends({}, this.props, {
	                        modalId: modalId,
	                        moduleOptions: this.props.moduleOptions,
	                        templates: templates,
	                        recipientWillemotEmails: recipientWillemotEmails,
	                        signatures: signatures,
	                        onSent: onSent,
	                        onSentLate: onSentLate,
	                        hideCC: hideCC,
	                        multiLanguage: this.props.multiLanguage,
	                        serialSending: this.props.serialSending,
	                        getDSStakeholders: this.props.getDSStakeholders,
	                        isCreatable: this.props.isCreatable,
	                        forceIsMulti: this.props.forceIsMulti,
	                        onCancel: this.props.onCancel
	                    }))
	                )
	            );
	        }
	    }]);
	
	    var _EmailSender = EmailSender;
	    EmailSender = (0, _reactRedux.connect)(function (state) {
	        return {
	            modalIsOpen: state.emailSender.emailModalIsOpen,
	            moduleKey: state.emailSender.moduleKey,
	            EmailTemplateRelations: state.app.security.EmailTemplateRelations,
	            contractManagerLanguage: state.contracts.contractManagerLanguage,
	            contractManagerMail: state.contracts.contractManagerMail,
	            claimsManagersDetails: state.clients.claimsManagersDetails,
	            claimsManagers: state.app.claimsManagersDetails
	        };
	    })(EmailSender) || EmailSender;
	    return EmailSender;
	})(_react2['default'].Component);
	
	exports['default'] = EmailSender;
	module.exports = exports['default'];

	// check required args

	//let moduleKeyOfMifid = nesProp.get(this.props, "EmailTemplateRelations.EmailTemplateModules.mifid.value")

	// if the email is opened from emailer, can be determined by this parameters

	// Any other normal case get templates by moduleKey

	// by default is the module where was opened the emailsender mdoal !!!BUT!!!,
	// there are special cases when the emailer is opened on contract/tarif/claim but started from inbox-quick-reply
	// that require separate special template BEWB-730 as quick reply template

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(4);
	
	var _faqScss = __webpack_require__(1609);
	
	var _faqScss2 = _interopRequireDefault(_faqScss);
	
	var _cssExtraButtonsScss = __webpack_require__(713);
	
	var _cssExtraButtonsScss2 = _interopRequireDefault(_cssExtraButtonsScss);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _stateActions = __webpack_require__(5);
	
	var _categories = __webpack_require__(603);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _elementsHtmlContent = __webpack_require__(110);
	
	var _elementsHtmlContent2 = _interopRequireDefault(_elementsHtmlContent);
	
	var _elementsFilterInput = __webpack_require__(613);
	
	var _elementsFilterInput2 = _interopRequireDefault(_elementsFilterInput);
	
	var _reactCollapse = __webpack_require__(467);
	
	var _reactCollapse2 = _interopRequireDefault(_reactCollapse);
	
	var _reactMotion = __webpack_require__(340);
	
	var _libHelpers = __webpack_require__(24);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('faq');
	
	// TODO move this to own component, use thumbnails, add size, download original name…
	var KsFileValue = function KsFileValue(_ref) {
		var itemId = _ref.itemId;
		var file = _ref.file;
	
		var _getFileNameAndUrl = (0, _libHelpers.getFileNameAndUrl)('faq', itemId, file);
	
		var url = _getFileNameAndUrl.url;
		var name = _getFileNameAndUrl.name;
	
		return _react2['default'].createElement(
			'a',
			{ href: url, target: '_blank', rel: 'noopener noreferrer' },
			name
		);
	};
	var ListSectionDom = function ListSectionDom(_ref2) {
		var title = _ref2.title;
		var children = _ref2.children;
		return _react2['default'].createElement(
			'div',
			{ className: _faqScss2['default'].cat },
			_react2['default'].createElement(
				'div',
				{ className: _faqScss2['default'].listSectionTitle },
				title
			),
			children
		);
	};
	ListSectionDom.propTypes = {
		title: _react.PropTypes.node,
		children: _react.PropTypes.node
	};
	
	// TODO factor out the rotating arrow from here and collapseTd
	var OpenCloseArrow = function OpenCloseArrow(_ref3) {
		var open = _ref3.open;
		var className = _ref3.className;
		return _react2['default'].createElement(
			_reactMotion.Motion,
			{ style: { d: (0, _reactMotion.spring)(open ? 0 : -90) } },
			function (_ref4) {
				var d = _ref4.d;
				return _react2['default'].createElement(
					'div',
					{ className: (0, _classnames2['default'])(_faqScss2['default'].arrow, className), style: { transform: 'rotate(' + d + 'deg)' } },
					' '
				);
			}
		);
	};
	
	var getIcon = function getIcon() {
		try {
			return __webpack_require__(360);
		} catch (err) {
			return __webpack_require__(23);
		}
	};
	
	var FaqDom = function FaqDom(_ref5) {
		var q = _ref5.q;
		var a = _ref5.a;
		var open = _ref5.open;
		var onClick = _ref5.onClick;
		return _react2['default'].createElement(
			'div',
			{ className: _faqScss2['default'].faq },
			_react2['default'].createElement(
				'div',
				{ onClick: onClick, className: _faqScss2['default'].questionCont },
				_react2['default'].createElement(OpenCloseArrow, { open: open }),
				_react2['default'].createElement(
					'div',
					{ className: _faqScss2['default'].question },
					q
				),
				_react2['default'].createElement('img', { className: _faqScss2['default'].printIcon, src: getIcon(),
					onClick: function (e) {
						e.preventDefault();
						var theWindow = window.open('', 'PRINT', 'height=600,width=800');
						theWindow.document.write('<html style="overflow: scroll"><head><title>' + q + '</title>');
						theWindow.document.write('</head><body style="height: 100%; overflow: scroll;">');
						theWindow.document.write('<h2>' + q + '</h2>');
						theWindow.document.write(a);
						theWindow.document.write('</body></html>');
						theWindow.document.close(); // IE >= 10
						theWindow.focus(); // IE >= 10
						theWindow.print();
					} })
			),
			_react2['default'].createElement(
				_reactCollapse2['default'],
				{ isOpened: Boolean(open) },
				_react2['default'].createElement(
					'div',
					{ className: _faqScss2['default'].content },
					_react2['default'].createElement(_elementsHtmlContent2['default'], { className: _faqScss2['default'].answer, content: a })
				)
			)
		);
	};
	FaqDom.propTypes = {
		q: _react.PropTypes.string.isRequired,
		a: _react.PropTypes.string.isRequired,
		open: _react.PropTypes.bool,
		onClick: _react.PropTypes.func
	};
	
	var FaqSection = function FaqSection(_ref6) {
		var catId = _ref6.catId;
		var items = _ref6.items;
		var isOpened = _ref6.isOpened;
		var switchIt = _ref6.switchIt;
	
		return _react2['default'].createElement(
			ListSectionDom,
			{
				title: _react2['default'].createElement(_categories2['default'], { plain: true, id: catId })
			},
			items.map(function (_ref7) {
				var _id = _ref7._id;
				var Q = _ref7.Q;
				var A = _ref7.A;
				return _react2['default'].createElement(FaqDom, { key: _id, q: Q, a: A, open: isOpened[_id], onClick: function () {
						return switchIt(_id);
					} });
			})
		);
	};
	FaqSection.propTypes = {
		items: _react.PropTypes.array,
		catId: _react.PropTypes.string,
		isOpened: _react.PropTypes.object,
		switchIt: _react.PropTypes.func
	};
	
	var FaqPageDom = function FaqPageDom(_ref8) {
		var title = _ref8.title;
		var subtitle = _ref8.subtitle;
		var filter = _ref8.filter;
		var onFilter = _ref8.onFilter;
		var children = _ref8.children;
		return _react2['default'].createElement(
			'div',
			{ id: _faqScss2['default'].faqModule },
			_react2['default'].createElement(
				'div',
				{ className: _faqScss2['default'].mainSubDiv },
				_react2['default'].createElement(
					'div',
					{ className: _faqScss2['default'].mainTitleDiv + ' bottom-border' },
					_react2['default'].createElement(
						'div',
						{ className: _faqScss2['default'].mainTitleContainer },
						_react2['default'].createElement(
							'h2',
							null,
							title
						),
						_react2['default'].createElement(
							'h3',
							null,
							subtitle
						)
					),
					_react2['default'].createElement(_elementsFilterInput2['default'], { filter: filter, setFilter: onFilter })
				),
				_react2['default'].createElement(
					'div',
					{ className: _faqScss2['default'].catsContainer },
					children
				)
			)
		);
	};
	FaqPageDom.propTypes = {
		title: _react.PropTypes.string,
		subtitle: _react.PropTypes.string,
		filter: _react.PropTypes.string,
		onFilter: _react.PropTypes.func.isRequired,
		children: _react.PropTypes.node
	};
	
	var Faq = (function (_Component) {
		_inherits(Faq, _Component);
	
		_createClass(Faq, null, [{
			key: 'propTypes',
			value: {
				getFaq: _react.PropTypes.func.isRequired,
				setFaqFilter: _react.PropTypes.func.isRequired,
				items: _react.PropTypes.array,
				filter: _react.PropTypes.string
			},
			enumerable: true
		}]);
	
		function Faq(props) {
			_classCallCheck(this, _Faq);
	
			_get(Object.getPrototypeOf(_Faq.prototype), 'constructor', this).call(this, props);
			this.state = {
				isOpened: {}
			};
		}
	
		_createClass(Faq, [{
			key: 'switch',
			value: function _switch(id) {
				var isOpened = this.state;
				isOpened[id] = !isOpened[id];
				this.setState({ isOpened: isOpened });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.update();
			}
		}, {
			key: 'update',
			value: function update() {
				this.props.getFaq();
			}
		}, {
			key: 'orderItems',
			value: function orderItems(items) {
				var cats = {};
				items.forEach(function (item) {
					var _id = item._id;
					var categoryId = item.categoryId;
					var A = item.A;
					var Q = item.Q;
					var attachments = item.attachments;
	
					if (!cats[categoryId]) {
						cats[categoryId] = [];
					}
					cats[categoryId].push({ _id: _id, A: A, Q: Q, attachments: attachments });
				});
				return Object.keys(cats).map(function (categoryId) {
					var sortCats = (0, _lodashCollection.sortBy)(cats[categoryId], function (cat) {
						return cat.Q.toLowerCase().replace(/\s+/g, '');
					});
					return { categoryId: categoryId, content: sortCats };
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var isOpened = this.state.isOpened;
				var _props = this.props;
				var items = _props.items;
				var filter = _props.filter;
				var setFaqFilter = _props.setFaqFilter;
	
				var itemsId = items.map(function (m, i) {
					return _extends({}, m, { id: i });
				});
				var lowerFilter = filter.toLowerCase();
				var filteredItems = filter ? itemsId.filter(function (item) {
					return item.Q.toLowerCase().includes(lowerFilter) || item.A.toLowerCase().includes(lowerFilter);
				}) : itemsId;
				var orderedItems = this.orderItems(filteredItems);
	
				return _react2['default'].createElement(
					FaqPageDom,
					{
						title: _('title'),
						subtitle: _('subtitle'),
						filter: filter,
						onFilter: setFaqFilter
					},
					orderedItems.map(function (row) {
						return _react2['default'].createElement(FaqSection, {
							key: row.catId,
							catId: row.categoryId,
							items: row.content,
							isOpened: isOpened,
							switchIt: function (id) {
								return _this['switch'](id);
							}
						});
					})
				);
			}
		}]);
	
		var _Faq = Faq;
		Faq = (0, _reactRedux.connect)(function (_ref9) {
			var faq = _ref9.faq;
			return faq;
		}, { getFaq: _stateActions.getFaq, setFaqFilter: _stateActions.setFaqFilter })(Faq) || Faq;
		return Faq;
	})(_react.Component);
	
	exports['default'] = Faq;
	module.exports = exports['default'];

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _lodashLang = __webpack_require__(78);
	
	var _listSelectScss = __webpack_require__(245);
	
	var _listSelectScss2 = _interopRequireDefault(_listSelectScss);
	
	var _input = __webpack_require__(109);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _libHelpers = __webpack_require__(24);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        zIndex: 2
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var IbansListSelect = (function (_React$Component) {
	    _inherits(IbansListSelect, _React$Component);
	
	    _createClass(IbansListSelect, null, [{
	        key: 'propTypes',
	        value: {
	            data: _react2['default'].PropTypes.array
	        },
	        enumerable: true
	    }]);
	
	    function IbansListSelect(props) {
	        _classCallCheck(this, IbansListSelect);
	
	        _get(Object.getPrototypeOf(IbansListSelect.prototype), 'constructor', this).call(this, props);
	        this.state = { modalIsOpen: false };
	    }
	
	    _createClass(IbansListSelect, [{
	        key: 'getIcon',
	        value: function getIcon() {
	            try {
	                return __webpack_require__(79);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this.setState({ modalIsOpen: !this.state.modalIsOpen });
	        }
	    }, {
	        key: 'handleAddFieldButton',
	        value: function handleAddFieldButton() {
	            var data = this.props.data;
	
	            this.openModal();
	            data.addField({ IBAN: "", BIC: "", uniqueId: (0, _uuidV42['default'])() });
	        }
	    }, {
	        key: 'removeItemFromList',
	        value: function removeItemFromList(itemUniqueId) {
	            var data = this.props.data;
	
	            Object.keys(data).map(function (dataKey) {
	                if (data[dataKey] && data[dataKey] !== undefined && data[dataKey].uniqueId.value === itemUniqueId) {
	                    data.removeField(dataKey);
	                }
	            });
	        }
	    }, {
	        key: 'removeItem',
	        value: function removeItem() {
	            var data = this.props.data;
	            data.removeField();
	        }
	    }, {
	        key: 'modalContentPopup',
	        value: function modalContentPopup() {
	            var _this = this;
	
	            var data = this.props.data;
	
	            var lastData = data.slice(-1)[0];
	            var errorData = false;
	
	            if (lastData != undefined) {
	                if (lastData.IBAN.error != undefined) {
	                    errorData = true;
	                } else {
	                    errorData = false;
	                }
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].clientModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _listSelectScss2['default'].title },
	                    _("addAccount")
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('iban')
	                ),
	                lastData != undefined && _react2['default'].createElement('input', _extends({ type: 'text' }, lastData.IBAN)),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    ' ',
	                    lastData != undefined && lastData.IBAN.error && lastData.IBAN.touched && lastData.IBAN.error,
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('bic')
	                ),
	                lastData != undefined && _react2['default'].createElement('input', _extends({ type: 'text' }, lastData.BIC)),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    ' ',
	                    lastData != undefined && lastData.BIC.error && lastData.BIC.touched && lastData.BIC.error,
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientModalButtons },
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this.openModal();
	                            _this.removeItem();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].cancel,
	                        value: _("cancel")
	                    }),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            return _this.openModal();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].next + " " + (!errorData && _listSelectScss2['default'].enabled),
	                        value: _("clientAdd"),
	                        disabled: errorData
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var data = this.props.data;
	            var modalIsOpen = this.state.modalIsOpen;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].moduleSection },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientsTableContainer },
	                    !_underscore2['default'].isEmpty(data) && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            className: _listSelectScss2['default'].table,
	                            itemsPerPage: 50,
	                            topPagination: '',
	                            filterable: [],
	                            sortable: ["BIC.value", "IBAN.value"],
	                            defaultSort: {
	                                column: 'BIC.value',
	                                direction: 'asc'
	                            }
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'BIC.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('bic')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'IBAN.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('iban')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'checkEmail' },
	                                _react2['default'].createElement('strong', null)
	                            )
	                        ),
	                        data.map(function (item, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { className: 'centered', key: item.uniqueId.value },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'BIC.value' },
	                                    item.BIC.value
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'IBAN.value' },
	                                    item.IBAN.value
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'checkEmail' },
	                                    _react2['default'].createElement(
	                                        'button',
	                                        { type: 'button', className: _listSelectScss2['default'].removeFieldsButton, onClick: function (event) {
	                                                event.preventDefault();
	                                                _this2.removeItemFromList(item.uniqueId.value);
	                                            } },
	                                        _react2['default'].createElement('img', { src: _this2.getIcon() })
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'button',
	                            className: _listSelectScss2['default'].addFieldButton,
	                            onClick: function () {
	                                _this2.handleAddFieldButton();
	                            } },
	                        '+'
	                    )
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        style: customStyles,
	                        contentLabel: 'Modal'
	                    },
	                    this.modalContentPopup()
	                )
	            );
	        }
	    }]);
	
	    return IbansListSelect;
	})(_react2['default'].Component);
	
	exports['default'] = IbansListSelect;
	module.exports = exports['default'];

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x11, _x12, _x13) { var _again = true; _function: while (_again) { var object = _x11, property = _x12, receiver = _x13; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x11 = parent; _x12 = property; _x13 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(351);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactDomify = __webpack_require__(857);
	
	var _reactDomify2 = _interopRequireDefault(_reactDomify);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _elementsComponentPageDom = __webpack_require__(219);
	
	var _elementsComponentPageDom2 = _interopRequireDefault(_elementsComponentPageDom);
	
	var _refreshBtn = __webpack_require__(174);
	
	var _refreshBtn2 = _interopRequireDefault(_refreshBtn);
	
	var _libHelpers = __webpack_require__(24);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectSelectWrap2 = _interopRequireDefault(_sharedSelectSelectWrap);
	
	var _inboxScss = __webpack_require__(719);
	
	var _inboxScss2 = _interopRequireDefault(_inboxScss);
	
	var _cssExtraButtonsScss = __webpack_require__(713);
	
	var _cssExtraButtonsScss2 = _interopRequireDefault(_cssExtraButtonsScss);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _taskCreatorIndex = __webpack_require__(372);
	
	var _taskCreatorIndex2 = _interopRequireDefault(_taskCreatorIndex);
	
	var _DSDocumentsLinkDocumentModal = __webpack_require__(597);
	
	var _DSDocumentsLinkDocumentModal2 = _interopRequireDefault(_DSDocumentsLinkDocumentModal);
	
	var _DSDocumentsLinkAndUploadButton = __webpack_require__(601);
	
	var _DSDocumentsLinkAndUploadButton2 = _interopRequireDefault(_DSDocumentsLinkAndUploadButton);
	
	var _inboxDocumentsSigningModal = __webpack_require__(1106);
	
	var _inboxDocumentsSigningModal2 = _interopRequireDefault(_inboxDocumentsSigningModal);
	
	var _inboxClientLinkingModal = __webpack_require__(1104);
	
	var _inboxClientLinkingModal2 = _interopRequireDefault(_inboxClientLinkingModal);
	
	// import EmailButton from './emailSender/emailButton'
	
	// ignore all loaders defined on the webpack conf
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _DSDocumentsReminderEmailStatusDialog = __webpack_require__(264);
	
	var _DSDocumentsReminderEmailStatusDialog2 = _interopRequireDefault(_DSDocumentsReminderEmailStatusDialog);
	
	var TICKET_CATEGPRIES_WHITE_LIST_FOR_QUICK_REPLY = ["15", "8", "9", "12", "2", "6"];
	
	var _ = (0, _libI18n2['default'])('inbox');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return (0, _redux.bindActionCreators)({
	        dispatch: dispatch, setNotification: _stateActions.setNotification, setCheckBox: _stateActions.setCheckBox, selectVisibleItems: _stateActions.selectVisibleItems, filterTicket: _stateActions.filterTicket, archive: _stateActions.archive,
	        getInbox: _stateActions.getInbox, setTicketUnread: _stateActions.setTicketUnread, selectItems: _stateActions.selectItems, deselectItems: _stateActions.deselectItems, resetStaffList: _stateActions.resetStaffList, archiveToggleModal: _stateActions.archiveToggleModal,
	        generateTaskFromTicket: _stateActions.generateTaskFromTicket, archiveRelational: _stateActions.archiveRelational, forceUncheckSelectedTickets: _stateActions.forceUncheckSelectedTickets, setAppModule: _stateActions.setAppModule,
	        setOpenedSubmenu: _stateActions.setOpenedSubmenu, setClientSubModule: _stateActions.setClientSubModule, setEmailSenderExternalAttachments: _stateActions.setEmailSenderExternalAttachments, getClientId: _stateActions.getClientId,
	        taskCreatorModalToggle: _stateActions.taskCreatorModalToggle, preCacheDocumentsBulk: _stateActions.preCacheDocumentsBulk, downloadDocumentsZip: _stateActions.downloadDocumentsZip, getDsDocsAndPackages: _stateActions.getDsDocsAndPackages, fetchExistingClient: _stateActions.fetchExistingClient,
	        setEmailSenderModule: _stateActions.setEmailSenderModule, fetchClientContract: _stateActions.fetchClientContract, getStakeholdersByPackageId: _stateActions.getStakeholdersByPackageId, resendClientRemainder: _stateActions.resendClientRemainder,
	        updatePackagesFromConnective: _stateActions.updatePackagesFromConnective, getOneDsPackageById: _stateActions.getOneDsPackageById, fetchClientOptionsDict: _stateActions.fetchClientOptionsDict, getActualizedPackageForInvitation: _stateActions.getActualizedPackageForInvitation
	    }, dispatch);
	};
	
	var DOCUMENT_FILE_SOURCE_DSDOCUMENT = 'DOCUMENT_FILE_SOURCE_DSDOCUMENT';
	var DOCUMENT_FILE_SOURCE_TICKET_DOCUMENT = 'DOCUMENT_FILE_SOURCE_TICKET_DOCUMENT';
	
	var Inbox = (function (_Component) {
	    _inherits(Inbox, _Component);
	
	    _createClass(Inbox, null, [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react.PropTypes.func.isRequired,
	            items: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            filter: _react.PropTypes.string.isRequired,
	            selectValue: _react.PropTypes.string.isRequired,
	            modalIsOpen: _react.PropTypes.bool,
	            setNotification: _react.PropTypes.func.isRequired,
	            setCheckBox: _react.PropTypes.func.isRequired,
	            selectVisibleItems: _react.PropTypes.func.isRequired,
	            getStakeholdersByPackageId: _react.PropTypes.func.isRequired,
	            resendClientRemainder: _react.PropTypes.func.isRequired,
	            getOneDsPackageById: _react.PropTypes.func.isRequired,
	            updatePackagesFromConnective: _react.PropTypes.func.isRequired,
	            selectItems: _react.PropTypes.func.isRequired,
	            deselectItems: _react.PropTypes.func,
	            filterTicket: _react.PropTypes.func.isRequired,
	            archive: _react.PropTypes.func.isRequired,
	            resetStaffList: _react.PropTypes.func.isRequired,
	            archiveToggleModal: _react.PropTypes.func.isRequired,
	            generateTaskFromTicket: _react.PropTypes.func.isRequired,
	            getInbox: _react.PropTypes.func.isRequired,
	            setTicketUnread: _react.PropTypes.func.isRequired,
	            forceUncheckSelectedTickets: _react.PropTypes.func.isRequired,
	            setAppModule: _react.PropTypes.func.isRequired,
	            setOpenedSubmenu: _react.PropTypes.func.isRequired,
	            setClientSubModule: _react.PropTypes.func.isRequired,
	            setEmailSenderExternalAttachments: _react.PropTypes.func.isRequired,
	            setEmailSenderModule: _react.PropTypes.func.isRequired,
	            fetchClientContract: _react.PropTypes.func.isRequired,
	            getClientId: _react.PropTypes.func.isRequired,
	            preCacheDocumentsBulk: _react.PropTypes.func.isRequired,
	            fetchExistingClient: _react.PropTypes.func.isRequired,
	            getActualizedPackageForInvitation: _react.PropTypes.func.isRequired,
	            dsDocuments: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            dsDocTemplates: _react.PropTypes.arrayOf(_react.PropTypes.object)
	        },
	        enumerable: true
	    }]);
	
	    function Inbox(props) {
	        var _this = this;
	
	        _classCallCheck(this, _Inbox);
	
	        _get(Object.getPrototypeOf(_Inbox.prototype), 'constructor', this).call(this, props);
	
	        this.handleCheckAll = function () {
	            var _props = _this.props;
	            var selectVisibleItems = _props.selectVisibleItems;
	            var setNotification = _props.setNotification;
	            var allSelected = _this.allSelected;
	            var visibleIds = _this.visibleIds;
	
	            if (!allSelected) {
	                var msg = _('all') + ' ' + visibleIds.length + ' ' + _('numOfSelectedMsg');
	                setNotification(msg, 'info');
	            }
	            selectVisibleItems(visibleIds);
	        };
	
	        this.handleVisibleList = function (visibleIds) {
	            var visibilityOf = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = visibleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var id = _step.value;
	
	                    visibilityOf[id] = true;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator['return']) {
	                        _iterator['return']();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            _this.visibleIds = visibleIds;
	            _this.setState({ visibilityOf: visibilityOf });
	        };
	
	        this.getIcon = function (iconName) {
	            try {
	                return __webpack_require__(173)("./" + iconName);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        };
	
	        this.gotToContractOrClaimOfClient = function (ticketObj) {
	            var sendMail = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	            var autoSelectTemplate = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	            var quickReply = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	            var _props2 = _this.props;
	            var setEmailSenderExternalAttachments = _props2.setEmailSenderExternalAttachments;
	            var getClientId = _props2.getClientId;
	            var setNotification = _props2.setNotification;
	
	            var contractId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.contractId;
	            var claimId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.claimId;
	            var tarificationId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.tarificationId;
	            getClientId(contractId, claimId, tarificationId).then(function (clientId) {
	                // no clientId we can not change the module
	                if (!clientId) {
	                    setNotification(_('ticketNoClientAffected'), 'error');
	                    return;
	                }
	
	                // set attachments for the email sender from default if want to send email
	                if (sendMail) {
	                    var files = _this.fetchDocumentsToAttachment(ticketObj.documents, ticketObj.typeDocument);
	                    setEmailSenderExternalAttachments(files);
	                }
	
	                // if we have contractId we have to navigate to client contracts
	                if (contractId) {
	                    _this.navigateToClientContracts(clientId, contractId, {
	                        autoEmailModalOpen: sendMail,
	                        autoSelectTemplate: autoSelectTemplate,
	                        startedFromModule: _stateConstants2['default'].EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT,
	                        quickReply: quickReply,
	                        ticketId: ticketObj.id
	                    });
	                    // stop here this function
	                    return;
	                }
	
	                if (tarificationId) {
	                    _this.navigateToClientTarifications(clientId, tarificationId, {
	                        autoEmailModalOpen: sendMail,
	                        autoSelectTemplate: autoSelectTemplate,
	                        startedFromModule: _stateConstants2['default'].EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT,
	                        quickReply: quickReply,
	                        ticketId: ticketObj._id
	                    });
	                    // stop here this function
	                    return;
	                }
	
	                // if we have ClaimId we have to navigate to client claims
	                if (claimId) {
	                    _this.navigateToClientClaims(clientId, claimId, {
	                        autoEmailModalOpen: sendMail,
	                        autoSelectTemplate: autoSelectTemplate,
	                        startedFromModule: _stateConstants2['default'].EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT,
	                        quickReply: quickReply,
	                        ticketId: ticketObj._id
	                    });
	                }
	            });
	        };
	
	        this.onSendReminderClick = function callee$2$0(packageId) {
	            var _props3, dispatch, getStakeholdersByPackageId, resendClientRemainder, getActualizedPackageForInvitation, notInvited, dsStakeholders, dsPackage, reminderResponse, reminderSentSuccessFlag;
	
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        _props3 = this.props;
	                        dispatch = _props3.dispatch;
	                        getStakeholdersByPackageId = _props3.getStakeholdersByPackageId;
	                        resendClientRemainder = _props3.resendClientRemainder;
	                        getActualizedPackageForInvitation = _props3.getActualizedPackageForInvitation;
	                        notInvited = false;
	                        context$3$0.prev = 6;
	                        context$3$0.next = 9;
	                        return regeneratorRuntime.awrap(getStakeholdersByPackageId(packageId));
	
	                    case 9:
	                        dsStakeholders = context$3$0.sent;
	
	                        dsStakeholders.forEach(function (stakeholder) {
	                            if (!stakeholder.isInvited && stakeholder.signerType !== "BROKER") {
	                                notInvited = true;
	                            }
	                        });
	
	                        // if is not invited we need to navigate to dsPackage and open email sender but first actualize package and check status
	
	                        if (!notInvited) {
	                            context$3$0.next = 18;
	                            break;
	                        }
	
	                        context$3$0.next = 14;
	                        return regeneratorRuntime.awrap(getActualizedPackageForInvitation(packageId));
	
	                    case 14:
	                        dsPackage = context$3$0.sent;
	
	                        if ((0, _libHelpers.canSendInvitation)(dsPackage)) {
	                            dispatch((0, _stateActions.setOpenInvitationEditorFromTicket)(true));
	                            dispatch((0, _stateActions.setCustomDsDocumentsModule)(_stateConstants2['default'].DSDOCUMENTS, null));
	                            dispatch((0, _stateActions.setDSDocumentsOpenedPackage)(packageId));
	                            dispatch((0, _stateActions.setDSDocumentsSubModule)('detailedPackage'));
	                        } else {
	                            this.setState({ reminderConfirmationModal: true, invitationBlocked: true });
	                        }
	                        context$3$0.next = 24;
	                        break;
	
	                    case 18:
	                        context$3$0.next = 20;
	                        return regeneratorRuntime.awrap(resendClientRemainder(packageId));
	
	                    case 20:
	                        reminderResponse = context$3$0.sent;
	                        reminderSentSuccessFlag = undefined;
	
	                        if (reminderResponse && reminderResponse.success) {
	                            reminderSentSuccessFlag = true;
	                        }
	                        this.setState({ reminderConfirmationModal: true, reminderSentSuccessFlag: reminderSentSuccessFlag });
	
	                    case 24:
	                        context$3$0.next = 29;
	                        break;
	
	                    case 26:
	                        context$3$0.prev = 26;
	                        context$3$0.t0 = context$3$0['catch'](6);
	
	                        console.warn(context$3$0.t0);
	
	                    case 29:
	                    case 'end':
	                        return context$3$0.stop();
	                }
	            }, null, _this, [[6, 26]]);
	        };
	
	        this.handleTaskCreatorModalToggling = function () {
	            var taskCreatorModalToggle = _this.props.taskCreatorModalToggle;
	
	            taskCreatorModalToggle();
	        };
	
	        this.generateTaskCreatorItems = function (items) {
	            var convertedItems = [];
	            var selectedItems = items.filter(function (item) {
	                return item.checked;
	            });
	
	            if (selectedItems.length > 0) {
	                selectedItems.map(function (value, key) {
	                    var ticketDetail = '';
	                    var ticketDocuments = null;
	                    var ticketDoctype = null;
	                    var ticketReferral = null;
	
	                    // Parse the data of the object as a string with newlines
	                    if (value.ticketDetails && value.ticketDetails instanceof Object) {
	                        Object.keys(value.ticketDetails).map(function (objectKey, index) {
	                            var detailValue = value.ticketDetails[objectKey];
	
	                            // skip few values to show : BEWB-730
	                            if (["portal_cat_ticket", "beheerder"].indexOf(objectKey) > -1) {
	                                return;
	                            }
	
	                            ticketDetail = ticketDetail + " " + objectKey + ': "' + detailValue + '"</br>';
	                        });
	                    } else {
	                        if (value.ticketDetails !== undefined) {
	                            ticketDetail = value.ticketDetails;
	                        }
	                    }
	
	                    if (value.documents !== undefined) {
	                        ticketDocuments = value.documents;
	                    }
	
	                    if (value.typeDocument !== undefined) {
	                        ticketDoctype = value.typeDocument;
	                    }
	
	                    if (value.ticketUniqueId !== undefined) {
	                        ticketReferral = value.ticketUniqueId;
	                    }
	
	                    convertedItems.push({
	                        title: value.ticketDescription,
	                        description: ticketDetail,
	                        endDate: value.ticketDate,
	                        ticketReferral: value.id,
	                        taskRelation: null,
	                        ticketDocuments: ticketDocuments,
	                        ticketDoctype: ticketDoctype,
	                        ticketMsgLink: ticketReferral
	                    });
	                });
	            }
	
	            return convertedItems;
	        };
	
	        var moduleKeyToSet = _nestedProperty2['default'].get(props, "EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value");
	
	        this.state = {
	            isOpened: {}, visibilityOf: {}, archiveIsOpen: false,
	            inboxUsers: [],
	            inboxItems: [],
	            archiveConfirm: false,
	            confirmationModal: false,
	            archiveType: null,
	            documentCheckList: {},
	            precacheInProgress: false,
	            waitingModal: false,
	            isOpenLinkDocumentModal: false,
	            signDocumentsModalIsOpen: null,
	            clientLinkingIsOpen: false,
	            //emailerIsOpen: false,
	            //moduleOptionsForEmail: null,
	            moduleKeyToSet: moduleKeyToSet,
	            reminderConfirmationModal: false,
	            reminderSentSuccessFlag: false,
	            invitationBlocked: false
	        };
	    }
	
	    _createClass(Inbox, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refresh(true);
	            var clientOptionsDict = this.props.clientOptionsDict;
	
	            if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
	                (0, _stateActions.fetchClientOptionsDict)();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var forceUncheckSelectedTickets = this.props.forceUncheckSelectedTickets;
	
	            forceUncheckSelectedTickets();
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh(force) {
	            var getInbox = this.props.getInbox;
	
	            getInbox(force);
	        }
	    }, {
	        key: 'switch',
	        value: function _switch(id) {
	            var isOpened = this.state.isOpened;
	
	            var isElemOpened = !isOpened[id];
	            this.adjustCollapseSectionStyle(id, isElemOpened);
	            this.setState({ isOpened: _extends({}, this.state.isOpened, _defineProperty({}, id, isElemOpened)) });
	        }
	    }, {
	        key: 'adjustCollapseSectionStyle',
	        value: function adjustCollapseSectionStyle(id, isOpened) {
	
	            var collapseWrapperElements = Array.from(document.querySelectorAll('[class*="collapseWrapper"'));
	            var ticketDescriptionElements = Array.from(document.querySelectorAll('[class*="ticket-description"'));
	            var collapseWrapperMap = {};
	            var ticketDescriptionMap = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = collapseWrapperElements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var oneCollapseElem = _step2.value;
	
	                    var attribute = oneCollapseElem.getAttribute('data-ticketIdAttr');
	                    _nestedProperty2['default'].set(collapseWrapperMap, attribute, oneCollapseElem);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                        _iterator2['return']();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = ticketDescriptionElements[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var oneTicketDescriptionElem = _step3.value;
	
	                    var attribute = oneTicketDescriptionElem.getAttribute('data-ticketIdAttr');
	                    _nestedProperty2['default'].set(ticketDescriptionMap, attribute, oneTicketDescriptionElem);
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	                        _iterator3['return']();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	
	            if (isOpened) {
	                var ticketDescriptionHeight = ticketDescriptionMap[id].offsetHeight;
	                collapseWrapperMap[id].style.marginTop = ticketDescriptionHeight - 14 + 'px';
	            } else {
	                collapseWrapperMap[id].style.marginTop = '0';
	            }
	        }
	    }, {
	        key: 'check',
	        value: function check(ev, id) {
	            ev.stopPropagation();
	            var setCheckBox = this.props.setCheckBox;
	
	            setCheckBox(id);
	        }
	
	        /**
	         * Get the staff name based on user id
	         *
	         * @param {string} userId the staff user unique id
	         */
	    }, {
	        key: 'getStaffName',
	        value: function getStaffName(userId) {
	            var staff = this.props.staff;
	
	            var name = '-';
	
	            staff.forEach(function (element) {
	                if (element.userId == userId) {
	                    name = element.firstName + ' ' + element.lastName;
	                }
	            });
	
	            return name;
	        }
	
	        /**
	         * Return the status string based on task isCompleted value
	         *
	         * @param {boolean} status
	         */
	    }, {
	        key: 'getTaskStatus',
	        value: function getTaskStatus(status) {
	            if (status == true) {
	                return _('completed');
	            } else {
	                return _('uncompleted');
	            }
	        }
	
	        /**
	         * Get if the user has access to send ticket to task
	         */
	    }, {
	        key: 'getInboxSecurity',
	        value: function getInboxSecurity() {
	            var security = this.props.security;
	
	            var inboxSecurity = false;
	
	            if (security.actions && security.actions.length) {
	                security.actions.map(function (value, key) {
	                    if (value.actionName === 'Inboxtask') {
	                        if (typeof value.actionAllowed === 'string') {
	                            if (value.actionAllowed === 'true') {
	                                inboxSecurity = true;
	                            }
	                        }
	                    }
	                });
	            }
	
	            return inboxSecurity;
	        }
	
	        /**
	         * Get if the user has access to download doc
	         */
	    }, {
	        key: 'getDownloadDocSecurity',
	        value: function getDownloadDocSecurity() {
	            var security = this.props.security;
	
	            var downloadDocSecurity = false;
	
	            if (security.actions && security.actions.length) {
	                security.actions.map(function (value, key) {
	                    if (value.actionName === 'downloaddoc') {
	                        if (typeof value.actionAllowed === 'string') {
	                            if (value.actionAllowed === 'true') {
	                                downloadDocSecurity = true;
	                            }
	                        }
	                    }
	                });
	            }
	
	            return downloadDocSecurity;
	        }
	    }, {
	        key: 'getEmailSecurity',
	        value: function getEmailSecurity() {
	            var security = this.props.security;
	
	            var emailSecurity = false;
	
	            if (security.actions && security.actions.length) {
	                security.actions.map(function (value, key) {
	                    if (value.actionName === 'createmail') {
	                        if (typeof value.actionAllowed === 'string') {
	                            if (value.actionAllowed === 'true') {
	                                emailSecurity = true;
	                            }
	                        }
	                    }
	                });
	            }
	
	            return emailSecurity;
	        }
	
	        /**
	         * Handles the archiver confirmation toggle modal visibility toggle
	         *
	         * @param {string}
	         */
	    }, {
	        key: 'toggleArchiveConfirmationModal',
	        value: function toggleArchiveConfirmationModal() {
	            this.setState({
	                confirmationModal: !this.state.confirmationModal
	            });
	        }
	
	        /**
	         * Handles the archiver select input change event
	         *
	         * @param {object} value the value of the arhiver select input
	         * @param {array} items the list of items from table
	         */
	    }, {
	        key: 'handlerArchiverSelectChange',
	        value: function handlerArchiverSelectChange(value, items) {
	            var _this2 = this;
	
	            var _props4 = this.props;
	            var archiveRelational = _props4.archiveRelational;
	            var archive = _props4.archive;
	
	            // Archive for all users if value is archive
	            if (value.value == 'archive' || value.value == 'archive_self' || value.value == 'archive_others') {
	                (function () {
	                    var items = _this2.props.items;
	
	                    var stateItems = [];
	
	                    items.map(function (value, key) {
	                        stateItems[key] = _extends({}, value);
	                    });
	
	                    stateItems = stateItems.filter(function (item) {
	                        return item.checked;
	                    });
	
	                    _this2.setState({
	                        inboxItems: stateItems,
	                        archiveType: value.value
	                    });
	
	                    _this2.toggleArchiveConfirmationModal();
	                })();
	            }
	        }
	    }, {
	        key: 'archiveBtn',
	        value: function archiveBtn(checkedItemCount, items, downloaddoc) {
	            var _this3 = this;
	
	            var archive = this.props.archive;
	            var documentCheckList = this.state.documentCheckList;
	
	            var areThereSelectedDoc = false;
	
	            // check if are there a checked element in sub checklist
	            if (documentCheckList && Object.keys(documentCheckList).length > 0) {
	                Object.keys(documentCheckList).forEach(function (oneObjKey) {
	                    areThereSelectedDoc = areThereSelectedDoc || documentCheckList[oneObjKey].length > 0;
	                });
	            }
	
	            // Define the arhive list
	            var archiveOptions = [{ value: '', label: _('selectArchiveOption') }, { value: 'archive', label: _('archiveForAll') }, { value: 'archive_self', label: _('archiveCurrent') }, { value: 'archive_others', label: _('archiveOthers') }];
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _inboxScss2['default'].buttonContainer },
	                downloaddoc && _react2['default'].createElement('input', {
	                    key: 'downloaddocmultiple',
	                    onClick: function () {
	                        return _this3.handlerDownloadGlobalSelectChange(items);
	                    },
	                    disabled: !checkedItemCount && !areThereSelectedDoc,
	                    type: 'button',
	                    className: _inboxScss2['default'].greyButton,
	                    value: _('generalDownloadButton')
	                }),
	                _react2['default'].createElement(_sharedSelectSelectWrap2['default'], {
	                    key: 's',
	                    value: "",
	                    options: archiveOptions,
	                    onChange: function (v) {
	                        _this3.handlerArchiverSelectChange(v, items);
	                    },
	                    className: _inboxScss2['default'].archiveSelect,
	                    isDisabled: !checkedItemCount
	                }),
	                this.getInboxSecurity() && _react2['default'].createElement('input', {
	                    type: 'button',
	                    className: _inboxScss2['default'].greyButton,
	                    value: _("sendAsTask"),
	                    disabled: !checkedItemCount,
	                    onClick: function () {
	                        _this3.handleTaskCreatorModalToggling();
	                    }
	
	                })
	            );
	        }
	
	        /**
	         * Archive items by type on confirmation
	         */
	    }, {
	        key: 'archiveByType',
	        value: function archiveByType() {
	            var _props5 = this.props;
	            var archiveRelational = _props5.archiveRelational;
	            var archive = _props5.archive;
	            var archiveType = this.state.archiveType;
	
	            var items = this.state.inboxItems;
	
	            // Archive for all users if value is archive
	            if (archiveType == 'archive') {
	                archiveRelational(items, 'all');
	            }
	
	            // Archive for just the current user if value is archive_self
	            if (archiveType == 'archive_self') {
	                archive(items);
	            }
	
	            // Archive for other users if value is archive_others
	            if (archiveType == 'archive_others') {
	                archiveRelational(items, 'others');
	            }
	
	            this.setState({ archiveType: null });
	            this.toggleArchiveConfirmationModal(null);
	        }
	    }, {
	        key: 'archiveConfirmPopup',
	        value: function archiveConfirmPopup() {
	            var _this4 = this;
	
	            var items = this.state.inboxItems;
	            var itemsLength = items && items.length || 0;
	
	            var titleMsg = _('confirmYourArchiveAction');
	            var msg = '' + _('archiveSelfConfirmMessage');
	
	            var archiveType = this.state.archiveType;
	
	            // Archive for just the current user if value is archive_self
	            if (archiveType == 'archive_self') {
	                msg = _('archiveSelfConfirmMessage');
	            }
	
	            // Archive for other users if value is archive_others
	            if (archiveType == 'archive_others') {
	                msg = _('archiveOthersConfirmMessage');
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _inboxScss2['default'].archiveModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _inboxScss2['default'].title },
	                    titleMsg
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _inboxScss2['default'].message },
	                    msg
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _inboxScss2['default'].archiveModalButtons },
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                return _this4.toggleArchiveConfirmationModal();
	                            },
	                            className: _inboxScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            return _this4.archiveByType();
	                        },
	                        type: 'button',
	                        className: _inboxScss2['default'].greyButton + " enabled",
	                        value: _("confirm")
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'fetchDocumentsToAttachment',
	        value: function fetchDocumentsToAttachment(documents, typeDocument) {
	            var files = [];
	            if (documents) {
	                documents.forEach(function (oneDocument) {
	                    files.push({
	                        name: typeDocument,
	                        date: "-",
	                        id: oneDocument,
	                        typeDocument: typeDocument
	                    });
	                });
	            }
	
	            return files;
	        }
	    }, {
	        key: 'navigateToClientContracts',
	        value: function navigateToClientContracts(clientId, contractId, initialArguments) {
	            var _props6 = this.props;
	            var setAppModule = _props6.setAppModule;
	            var setOpenedSubmenu = _props6.setOpenedSubmenu;
	            var setClientSubModule = _props6.setClientSubModule;
	
	            setAppModule(_stateConstants2['default'].CLIENTS, clientId);
	            setOpenedSubmenu(contractId, initialArguments);
	            setClientSubModule('contracts');
	        }
	    }, {
	        key: 'navigateToClientClaims',
	        value: function navigateToClientClaims(clientId, claimId, initialArguments) {
	            var _props7 = this.props;
	            var setAppModule = _props7.setAppModule;
	            var setOpenedSubmenu = _props7.setOpenedSubmenu;
	            var setClientSubModule = _props7.setClientSubModule;
	
	            setAppModule(_stateConstants2['default'].CLIENTS, clientId);
	            setOpenedSubmenu(claimId, initialArguments); // submenuOpened: claimId, subModuleZoom: {}
	            setClientSubModule('claims'); // subModule: 'claims' subModuleZoom: ''
	        }
	    }, {
	        key: 'navigateToClientTarifications',
	        value: function navigateToClientTarifications(clientId, tarificationId, initialArguments) {
	            var _props8 = this.props;
	            var setAppModule = _props8.setAppModule;
	            var setOpenedSubmenu = _props8.setOpenedSubmenu;
	            var setClientSubModule = _props8.setClientSubModule;
	
	            setAppModule(_stateConstants2['default'].CLIENTS, clientId);
	            setClientSubModule('tarification');
	            setOpenedSubmenu(tarificationId, initialArguments);
	        }
	
	        /**
	         * This function will change the opened module (forward browser) to the client contract/claims module
	         * @param {*} ticketObj
	         * @param {*} sendMail
	         * @param {*} autoSelectTemplate
	         */
	    }, {
	        key: 'onNavigateToPackageClick',
	
	        /**
	         * This function will change the opened module (forward browser) to the client contract/claims module
	         */
	        // openEmailer = async (ticketObj) => {
	        //     const { setNotification, getClientId, fetchExistingClient, setEmailSenderModule, fetchClientContract } = this.props
	        //     let { moduleOptionsForEmail, moduleKeyToSet } = this.state
	
	        //     // collect information from ticket object for further initialization
	        //     let contractId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.contractId
	        //     let claimId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.claimId
	        //     let tarificationId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.tarificationId
	
	        //     //++++ LAOD client data +++++
	        //     let clientId = await getClientId(contractId, claimId, tarificationId)
	
	        //     // guard function if no client id
	        //     if (!clientId) {
	        //         setNotification(_('ticketNoClientAffected'), 'error')
	        //         return
	        //     }
	
	        //     let singleClientData = await fetchExistingClient(clientId)
	        //     //--- EOF load client data -----
	
	        //     //++++ LAOD contract data +++++
	        //     let contract
	        //     // get detailed contract data to know to predefine the broker data
	        //     if (contractId) {
	        //         let resultContract = await fetchClientContract(contractId)
	        //         contract = nesProp.get(resultContract, "response")
	
	        //         // let brokerNumber = nesProp.get(resultContract, "response.contractDetails.brokerNumber")
	        //         // let brokerInfo = getBrokerFullInfoByNumber(brokerNumber, brokers)
	        //         // let brokerEmailAddress = nesProp.get(brokerInfo, "main.emails.0")
	        //         // let brokerName = nesProp.get(brokerInfo, "main.name")
	        //     }
	        //     //--- EOF load contract data -----
	
	        //     //++++ ADD attachments to email sender +++++
	        //     // set attachments for the email sender from default if want to send email
	
	        //     // let files = this.fetchDocumentsToAttachment(ticketObj.documents, ticketObj.typeDocument)
	        //     // await setEmailSenderExternalAttachments(files)
	
	        //     //--- EOF add attachments to email sender -----
	
	        //     // compose the argument collection for email sender
	        //     moduleOptionsForEmail = await this.collectVariableValues(ticketObj, singleClientData, contractId, contract)
	
	        //     // open the email sender modal by setting the moduleKey flags in the store
	        //     // set the moduleKey to trigger the email sender modal with the correct templates
	        //     await setEmailSenderModule(moduleKeyToSet, c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT)
	
	        //     // enable the emailer modal locally in the state to render it
	        //     this.setState({ emailerIsOpen: true, moduleOptionsForEmail })
	        // }
	
	        /**
	         * Navigate to package details from a reminder ticket
	         * @param {*} packageId
	         */
	        value: function onNavigateToPackageClick(packageId) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.setCustomDsDocumentsModule)(_stateConstants2['default'].DSDOCUMENTS, null));
	            dispatch((0, _stateActions.setDSDocumentsOpenedPackage)(packageId));
	            dispatch((0, _stateActions.setDSDocumentsSubModule)('detailedPackage'));
	        }
	
	        /**
	         * Open reminder sending from package list for unfinished packages
	         * @param {*} packageId
	         */
	    }, {
	        key: 'onDirectSigningClick',
	
	        /**
	         * Open direct sign functionality from package list
	         * @param {*} packageId
	         */
	        value: function onDirectSigningClick(packageId) {
	            var _props9, updatePackagesFromConnective, getOneDsPackageById, responseFromConnective, dsPackage, URLForSign;
	
	            return regeneratorRuntime.async(function onDirectSigningClick$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props9 = this.props;
	                        updatePackagesFromConnective = _props9.updatePackagesFromConnective;
	                        getOneDsPackageById = _props9.getOneDsPackageById;
	                        context$2$0.next = 5;
	                        return regeneratorRuntime.awrap(updatePackagesFromConnective([packageId]));
	
	                    case 5:
	                        responseFromConnective = context$2$0.sent;
	
	                        if (!responseFromConnective.success) {
	                            context$2$0.next = 12;
	                            break;
	                        }
	
	                        context$2$0.next = 9;
	                        return regeneratorRuntime.awrap(getOneDsPackageById(packageId));
	
	                    case 9:
	                        dsPackage = context$2$0.sent;
	                        URLForSign = _nestedProperty2['default'].get(dsPackage, "F2FSigningUrl");
	
	                        // this.setState({ dsPackage })
	                        window.open(URLForSign, '_blank', 'noopener,noreferrer');
	
	                    case 12:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * This function return with values for email sender, collected from this module
	         * depending on the current data structure.
	         */
	    }, {
	        key: 'collectVariableValues',
	        value: function collectVariableValues(ticketObj, singleClientData, contractId, contract) {
	            var clientId, clientOptionsDict, _ref, documents, emails, clientName, clientLanguage;
	
	            return regeneratorRuntime.async(function collectVariableValues$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        clientId = this.props.clientId;
	                        clientOptionsDict = this.props.clientOptionsDict;
	                        _ref = contract || {};
	                        documents = _ref.documents;
	                        emails = _nestedProperty2['default'].get(singleClientData, "detail.emails");
	                        clientName = _nestedProperty2['default'].get(singleClientData, "main.name");
	
	                        // process email list to be digestible for email sender
	                        emails = emails && emails.map(function (item) {
	                            return {
	                                referenceId: clientId,
	                                label: clientName,
	                                value: item.email,
	                                'default': item['default'] == "true" || item['default'] == true ? true : false
	                            };
	                        }) || [];
	
	                        emails = emails.sort(function (item, item2) {
	                            if (item['default'] && !item2['default']) {
	                                return -1;
	                            }
	                            if (!item['default'] && item2['default']) {
	                                return 1;
	                            }
	                            if (item['default'] && item2['default'] || !item['default'] && !item2['default']) {
	                                return 0;
	                            }
	                        }) || [];
	
	                        // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
	                        clientLanguage = _nestedProperty2['default'].get(singleClientData, "detail.language") || '';
	
	                        clientLanguage = (0, _libHelpers.getTheLanguageCodeByAnyLanguageOnAnyLanguage)(clientLanguage, clientOptionsDict);
	
	                        return context$2$0.abrupt('return', {
	                            contractNumber: contract && contract.contractMain.contractNumber,
	
	                            clientDocuments: _nestedProperty2['default'].get(singleClientData, "clientDocuments"),
	                            clientDocumentsType: 'client',
	                            clientDocumentsId: clientId,
	
	                            // new v6 mode
	                            claimDocuments: [],
	                            claimDocumentsType: "claim",
	                            claimDocumentsId: null,
	
	                            contractDocuments: documents,
	                            contractDocumentsType: "contract",
	                            contractDocumentsId: contractId,
	
	                            clientId: false,
	                            contractId: contractId,
	                            claimId: false,
	                            company: contract && contract.contractMain.insuranceCompany,
	                            clientName: _nestedProperty2['default'].get(singleClientData, "main.name"),
	                            clientNumber: _nestedProperty2['default'].get(singleClientData, "main.clientNumber"),
	                            clientLanguage: clientLanguage,
	                            clientEmails: emails,
	                            companyCancelMail: contract && contract.contractMain.companyCancelMail,
	
	                            brokerNumber: contract && contract.contractDetails.brokerNumber,
	
	                            clientData: _nestedProperty2['default'].get(singleClientData, "main"),
	                            contractBranche: contract && contract.contractMain.contractBranche,
	                            ticketDocuments: this.convertTickerDocumentsToEmailAttachmentsForEmailer(ticketObj),
	                            autoSelectTemplate: true,
	                            startedFromModule: _stateConstants2['default'].EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT
	                        });
	
	                    case 11:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * This function converts the ticket documents to email attachments
	         * @param {*} ticketObject
	         * @param {*} security
	         * @returns
	         */
	    }, {
	        key: 'convertTickerDocumentsToEmailAttachmentsForEmailer',
	        value: function convertTickerDocumentsToEmailAttachmentsForEmailer(ticketObject) {
	            return _nestedProperty2['default'].get(ticketObject, "documents").map(function (oneDocId) {
	                return {
	                    id: oneDocId,
	                    type: _nestedProperty2['default'].get(ticketObject, 'typeDocument'),
	
	                    // give a redundant value in prop list on different name to be able to use the
	                    // attachment tool for tickets
	                    oracleDocumentId: oneDocId,
	                    oracleDocumentType: _nestedProperty2['default'].get(ticketObject, 'typeDocument'),
	
	                    date: "",
	                    name: ""
	                };
	            });
	        }
	
	        /**
	         * This function converts the ticket documents to email attachments
	         * @param {*} ticketObject
	         * @param {*} security
	         * @returns
	         */
	    }, {
	        key: 'convertTickerDocumentsToEmailAttachmentsForWizard',
	        value: function convertTickerDocumentsToEmailAttachmentsForWizard(ticketObject, security) {
	            var dSDocumentOriginTypes = _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DSDocumentOriginTypes");
	            return _nestedProperty2['default'].get(ticketObject, "documents").map(function (oneDocId) {
	                return { oracleDocumentId: oneDocId, oracleDocumentType: _nestedProperty2['default'].get(ticketObject, 'typeDocument'), origin: dSDocumentOriginTypes.DS_ORIGIN_ORACLE };
	            });
	        }
	
	        /**
	         * This method will navigate to relevant module (client profile, contract, tarification, claim) and open the dsWizard with selected ticket documents
	         * Get client id
	         * Prep the documents to attach
	         * Navigate to module
	         *
	         * @param {*} selectedDocumentsList
	         */
	    }, {
	        key: 'openDsWizardWithDocuments',
	        value: function openDsWizardWithDocuments(selectedDocumentsList, attachmentDocumentsList, ticketObject) {
	            var _props10, getClientId, setNotification, security, contractId, claimId, tarificationId, dSDocumentOriginTypes, clientId, ticketDocuments, ticketId, selectedTicketDocuments, emailAttachmentTicketDocuments;
	
	            return regeneratorRuntime.async(function openDsWizardWithDocuments$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props10 = this.props;
	                        getClientId = _props10.getClientId;
	                        setNotification = _props10.setNotification;
	                        security = _props10.security;
	                        contractId = ticketObject && ticketObject.ticketDetails && ticketObject.ticketDetails.contractId;
	                        claimId = ticketObject && ticketObject.ticketDetails && ticketObject.ticketDetails.claimId;
	                        tarificationId = ticketObject && ticketObject.ticketDetails && ticketObject.ticketDetails.tarificationId;
	                        dSDocumentOriginTypes = _nestedProperty2['default'].get(security, "DigitalSignatureHardLists.DSDocumentOriginTypes");
	                        context$2$0.next = 10;
	                        return regeneratorRuntime.awrap(getClientId(contractId, claimId, tarificationId));
	
	                    case 10:
	                        clientId = context$2$0.sent;
	
	                        if (clientId) {
	                            context$2$0.next = 14;
	                            break;
	                        }
	
	                        setNotification(_('ticketNoClientAffected'), 'error');
	                        return context$2$0.abrupt('return');
	
	                    case 14:
	                        ticketDocuments = this.convertTickerDocumentsToEmailAttachmentsForWizard(ticketObject, security);
	                        ticketId = _nestedProperty2['default'].get(ticketObject, "id");
	                        selectedTicketDocuments = [];
	
	                        selectedDocumentsList.map(function (oneDocName) {
	                            var oneDocObj = {
	                                oracleDocumentId: oneDocName,
	                                oracleDocumentType: _nestedProperty2['default'].get(ticketObject, 'typeDocument'),
	                                origin: dSDocumentOriginTypes.DS_ORIGIN_ORACLE,
	                                //use to identify the tickets tab in attachments modal
	                                documentSelectionTab: _stateConstants2['default'].TICKET_DOCUMENTS_TAB
	                            };
	                            selectedTicketDocuments.push(oneDocObj);
	                        });
	
	                        emailAttachmentTicketDocuments = [];
	
	                        attachmentDocumentsList.map(function (oneDocName) {
	                            var oneDocObj = {
	                                oracleDocumentId: oneDocName,
	                                oracleDocumentType: _nestedProperty2['default'].get(ticketObject, 'typeDocument'),
	                                origin: dSDocumentOriginTypes.DS_ORIGIN_ORACLE
	                            };
	                            emailAttachmentTicketDocuments.push(oneDocObj);
	                        });
	
	                        // if we have contractId we have to navigate to client contracts
	
	                        if (!contractId) {
	                            context$2$0.next = 23;
	                            break;
	                        }
	
	                        this.navigateToClientContracts(clientId, contractId, {
	                            selectedTicketDocuments: selectedTicketDocuments,
	                            ticketDocuments: ticketDocuments,
	                            ticketId: ticketId,
	                            emailAttachmentTicketDocuments: emailAttachmentTicketDocuments
	                        });
	                        // stop here this function
	                        return context$2$0.abrupt('return');
	
	                    case 23:
	                        if (!tarificationId) {
	                            context$2$0.next = 26;
	                            break;
	                        }
	
	                        this.navigateToClientTarifications(clientId, tarificationId, {
	                            selectedTicketDocuments: selectedTicketDocuments,
	                            ticketDocuments: ticketDocuments,
	                            ticketId: ticketId,
	                            emailAttachmentTicketDocuments: emailAttachmentTicketDocuments
	                        });
	                        // stop here this function
	                        return context$2$0.abrupt('return');
	
	                    case 26:
	
	                        // if we have ClaimId we have to navigate to client claims
	                        if (claimId) {
	                            this.navigateToClientClaims(clientId, claimId, {
	                                selectedTicketDocuments: selectedTicketDocuments,
	                                ticketDocuments: ticketDocuments,
	                                ticketId: ticketId,
	                                emailAttachmentTicketDocuments: emailAttachmentTicketDocuments
	                            });
	                        }
	
	                    case 27:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Handles the the taskCreator modal visibility toggeling
	         */
	    }, {
	        key: 'navigateToUnlinkedDocument',
	
	        /**
	         * Handles navigation to a singed document that has not been linked to a contract but it requires a contract
	         * @param {*} documentId
	         * @returns
	         */
	        value: function navigateToUnlinkedDocument(documentId) {
	            var _props11 = this.props;
	            var dispatch = _props11.dispatch;
	            var currentModule = _props11.module;
	
	            return dispatch((0, _stateActions.navigateToDsDocumentFromTicket)(documentId, _stateConstants2['default'].DSDOCUMENTS, currentModule));
	        }
	
	        /**
	         * Converts the inbox items to task `shape` objects to be readable by the taskCreator component
	         * @param {array} items the list of data to be converted
	         * @return {array} the task `shape` objects generated data
	         */
	    }, {
	        key: 'setCheckedDoc',
	
	        /**
	         *
	         * @param {*} event
	         * @param {*} doc
	         * @param {*} itemId
	         * @param {*} typeDocument
	         * @param {string} sourceOfDocument - there are few source of files like ticket or dsdocument, values from contants
	         */
	        value: function setCheckedDoc(event, doc, itemId, typeDocument, sourceOfDocument) {
	            var documentCheckList = this.state.documentCheckList;
	
	            if (!documentCheckList[itemId]) {
	                documentCheckList[itemId] = [];
	            }
	
	            // not used
	            var checked = event.target.checked;
	
	            var docString = String(doc);
	            var docIndex = documentCheckList[itemId].findIndex(function (item) {
	                return item.id === docString && item.typeDocument === typeDocument;
	            });
	
	            if (docIndex == -1) {
	                documentCheckList[itemId].push({ id: docString, typeDocument: typeDocument, sourceOfDocument: sourceOfDocument });
	            } else {
	                documentCheckList[itemId].splice(docIndex, 1);
	            }
	
	            this.setState({ documentCheckList: documentCheckList });
	        }
	
	        /**
	         * Verify is an item checked and return a boolean value.
	         * @param {*} doc
	         * @param {*} itemId
	         * @param {*} typeDocument
	         * @returns {bool} item is checked value
	         */
	    }, {
	        key: 'thisCheckBoxIsChecked',
	        value: function thisCheckBoxIsChecked(doc, itemId, typeDocument) {
	            var documentCheckList = this.state.documentCheckList;
	
	            if (!documentCheckList || !documentCheckList[itemId]) {
	                return false;
	            }
	
	            var docString = String(doc);
	            var docIndex = documentCheckList[itemId].findIndex(function (item) {
	                return item.id === docString && item.typeDocument === typeDocument;
	            });
	
	            if (docIndex == -1) {
	                return false;
	            }
	
	            return true;
	        }
	
	        /**
	         * This function will clear the selection of documents.
	         */
	    }, {
	        key: 'clearSelectionOfDocument',
	        value: function clearSelectionOfDocument() {
	            // this clear the ticket selection checkboxes
	            this.clearSelectionOfTickets();
	
	            // this line clear subslection of documents inside the tickets globally
	            this.setState({ documentCheckList: {} });
	        }
	
	        /**
	         * This function will clear the selection of tickets.
	         */
	    }, {
	        key: 'clearSelectionOfTickets',
	        value: function clearSelectionOfTickets() {
	            var _props12 = this.props;
	            var items = _props12.items;
	            var deselectItems = _props12.deselectItems;
	
	            var filteredItems = items.filter(function (item) {
	                return item.checked;
	            }) || [];
	
	            if (filteredItems && filteredItems.length > 0) {
	                deselectItems();
	            }
	        }
	
	        /**
	         * Handle the download when clicked on download button after document in a ticket.
	         * @param {string} itemId
	         */
	    }, {
	        key: 'downloadSelected',
	        value: function downloadSelected(itemId) {
	            var documentCheckList = this.state.documentCheckList;
	
	            if (!documentCheckList[itemId]) {
	                return false;
	            }
	
	            var docsToDownload = documentCheckList[itemId];
	
	            this.startDownloadProgressByListOfDocuments(docsToDownload, itemId);
	        }
	
	        /**
	         *  This function popup the waiting dialog and start the download progress using a list of document.
	         * @param {array} docsToDownload list of documents
	         * @param {string} itemId ticketID but any string is ok, used for filename.
	         */
	    }, {
	        key: 'startDownloadProgressByListOfDocuments',
	        value: function startDownloadProgressByListOfDocuments(docsToDownload) {
	            var _this5 = this;
	
	            var itemId = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	            if (!_underscore2['default'].isEmpty(docsToDownload)) {
	                // set flag for visual elements (waiting modal etc.)
	                this.switchWaitingModal(true, _("collectingDocumentPleaseWait"), _("pleaseWaitTitle"));
	                this.setState({ precacheInProgress: true });
	
	                // start the progress
	                this.doThePrecache(docsToDownload)
	                // the same action in "catch" and "then" because the "finally" not supported in IE
	                .then(function (result) {
	                    _this5.handleCacheProgressResult(result.docsCached, result.failedToCache, itemId);
	                })['catch'](function (err) {
	                    _this5.handleCacheProgressResult();
	                }).then(function (result) {
	                    // anyway come here
	                    _this5.clearSelectionOfDocument();
	                });
	            }
	        }
	
	        /**
	         * This function start a global download method over the ticket documents
	         */
	    }, {
	        key: 'handlerDownloadGlobalSelectChange',
	        value: function handlerDownloadGlobalSelectChange(ticketItemsSelected) {
	            var documentCheckList = this.state.documentCheckList;
	
	            var listOfAllGlobalSelectedDocuments = [];
	
	            // collect ticket selection documents
	            if (ticketItemsSelected.length > 0) {
	                ticketItemsSelected.forEach(function (item) {
	                    var currentListOfDocIDs = [];
	                    if (item.checked && item.documents && item.documents.length) {
	                        item.documents.forEach(function (oneDoc) {
	
	                            currentListOfDocIDs.push({
	                                id: String(oneDoc),
	                                typeDocument: item.typeDocument
	                            });
	                        });
	                    }
	                    listOfAllGlobalSelectedDocuments = listOfAllGlobalSelectedDocuments.concat(currentListOfDocIDs);
	                });
	            }
	
	            // collect ticket documents selected
	            if (documentCheckList && Object.keys(documentCheckList).length > 0) {
	                Object.keys(documentCheckList).forEach(function (oneObjKey) {
	                    listOfAllGlobalSelectedDocuments = listOfAllGlobalSelectedDocuments.concat(documentCheckList[oneObjKey]);
	                });
	            }
	
	            this.startDownloadProgressByListOfDocuments(listOfAllGlobalSelectedDocuments, '');
	        }
	
	        /**
	         * Show result if there are missing or inaccessible files for the user.
	         * @param {*} docsCached
	         * @param {*} failedToCache
	         */
	    }, {
	        key: 'handleCacheProgressResult',
	        value: function handleCacheProgressResult(docsCached, failedToCache, itemId) {
	            var _this6 = this;
	
	            this.setState({ precacheInProgress: false });
	
	            if (failedToCache && failedToCache.length > 0 || !docsCached || docsCached.length <= 0) {
	                this.switchWaitingModal(true, _("docsNotFound") + " " + (failedToCache && failedToCache.join(", ") || ""), _("docsNotFoundTitle"), function () {
	                    var shouldContinue = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	                    if (shouldContinue && docsCached && docsCached.length > 0) {
	                        _this6.handlePrepareDownloadZip(docsCached, itemId);
	                    } else {
	                        _this6.switchWaitingModal(false);
	                    }
	                });
	            } else {
	                this.handlePrepareDownloadZip(docsCached, itemId);
	            }
	        }
	
	        /**
	         * Open the modal what contains the link to the zip file
	         * @param {*} docsCached
	         */
	    }, {
	        key: 'handlePrepareDownloadZip',
	        value: function handlePrepareDownloadZip(docsCached, itemId) {
	            var _this7 = this;
	
	            var ticket = this.state.ticket;
	
	            this.switchWaitingModal(true, _("clickLinkBelowToDownloadZip"), _("download"), !docsCached || docsCached.length === 0 ? function () {
	                _this7.switchWaitingModal(false);
	            } : null, docsCached && docsCached.length > 0 ? {
	                link: this.getZipLink(docsCached, itemId),
	                callBack: function callBack() {
	                    _this7.switchWaitingModal(false);
	                }
	            } : null);
	        }
	
	        /**
	         * This function will generate the link toward the zip file
	         * @param {*} docsCached
	         * @param {*} itemId
	         */
	    }, {
	        key: 'getZipLink',
	        value: function getZipLink(docsCached, itemId) {
	            var onlyIds = [];
	            docsCached && docsCached.forEach(function (item) {
	                onlyIds.push(item.localId);
	            });
	
	            return '/zipDocuments?ticketId=' + itemId + '&documentList=' + onlyIds.join(',');
	        }
	
	        /**
	         * This function calls the api to zip the cached documents.
	         * @param {object} docsCached
	         */
	    }, {
	        key: 'callZipping',
	        value: function callZipping(docsCached) {
	            var downloadDocumentsZip = this.props.downloadDocumentsZip;
	
	            return downloadDocumentsZip(docsCached);
	        }
	
	        /**
	         * This function will do a precache for a list of documents and fire a callback function
	         * with the extended values
	         * @param {array} docsToDownload - list of documents -> id, date, docType
	         */
	    }, {
	        key: 'doThePrecache',
	        value: function doThePrecache(docsToDownload) {
	            var preCacheDocumentsBulk = this.props.preCacheDocumentsBulk;
	
	            var cachingResult = {
	                docsCached: [],
	                failedToCache: [],
	                error: {}
	            };
	
	            return preCacheDocumentsBulk(docsToDownload).then(function (results) {
	                var errorPrecacheList = [];
	
	                // let attachemntsWhatCached = []
	                // find the related attachment to give back the local id
	                if (docsToDownload && docsToDownload.length > 0 && results && results.length > 0 && results.length == docsToDownload.length) {
	
	                    // extend document list with "localId" property if cache don successfully
	                    docsToDownload.forEach(function (docValue) {
	                        results.forEach(function (resVal) {
	                            if (docValue.id == _nestedProperty2['default'].get(resVal, "data.id")) {
	                                docValue.localId = _nestedProperty2['default'].get(resVal, "data.localId");
	                            }
	                        });
	
	                        if (!docValue.localId) {
	                            errorPrecacheList.push(docValue.id);
	                        }
	                    });
	                }
	
	                cachingResult.docsCached = docsToDownload.filter(function (item) {
	                    return item.localId;
	                });
	
	                cachingResult.failedToCache = errorPrecacheList;
	
	                return cachingResult;
	            })['catch'](function (err) {
	                return cachingResult.error = err;
	            });
	        }
	
	        /**
	         * This function handle the waiting modal for download documents.
	         * @param {bool} show - modal show or hide
	         * @param {string} text - modal content
	         * @param {string} title - modal title
	         * @param {function} waitingModalOkButtonCallback is empty the no button shown, else ok button call
	         * @param {object} waitingModalOkButtonLink optional, link for a file
	         * the function given as value.
	         */
	    }, {
	        key: 'switchWaitingModal',
	        value: function switchWaitingModal() {
	            var show = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	            var text = arguments.length <= 1 || arguments[1] === undefined ? "" : arguments[1];
	            var title = arguments.length <= 2 || arguments[2] === undefined ? "" : arguments[2];
	            var waitingModalOkButtonCallback = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	            var waitingModalOkButtonLink = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
	            this.setState({
	                waitingModal: show,
	                waitingModalText: text,
	                waitingModalTitle: title,
	                waitingModalOkButtonCallback: waitingModalOkButtonCallback,
	                waitingModalOkButtonLink: waitingModalOkButtonLink
	            });
	        }
	
	        /**
	         *  This function render the waiting modal content until the zipped documents prepare.
	         */
	    }, {
	        key: 'waitingPopup',
	        value: function waitingPopup() {
	            var _this8 = this;
	
	            var _state = this.state;
	            var waitingModalText = _state.waitingModalText;
	            var waitingModalTitle = _state.waitingModalTitle;
	            var waitingModalOkButtonCallback = _state.waitingModalOkButtonCallback;
	            var waitingModalOkButtonLink = _state.waitingModalOkButtonLink;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _inboxScss2['default'].archiveModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _inboxScss2['default'].title },
	                    waitingModalTitle
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _inboxScss2['default'].message },
	                    waitingModalText
	                ),
	                waitingModalOkButtonCallback && typeof waitingModalOkButtonCallback == 'function' && _react2['default'].createElement(
	                    'div',
	                    { className: _inboxScss2['default'].archiveModalButtons },
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                return waitingModalOkButtonCallback(false);
	                            },
	                            className: _inboxScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _inboxScss2['default'].greyButton + " enabled",
	                            onClick: function () {
	                                return waitingModalOkButtonCallback(true);
	                            }
	                        },
	                        _('ok')
	                    )
	                ),
	                waitingModalOkButtonLink && waitingModalOkButtonLink.link && _react2['default'].createElement(
	                    'div',
	                    { className: _inboxScss2['default'].archiveModalButtons },
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                return _this8.switchWaitingModal(false);
	                            },
	                            className: _inboxScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement(
	                        'a',
	                        { download: 'true', target: '_blank', href: waitingModalOkButtonLink.link,
	                            onClick: waitingModalOkButtonLink.callBack,
	                            className: _inboxScss2['default'].greyButton + " enabled",
	                            rel: 'noopener noreferrer'
	                        },
	                        _("download")
	                    )
	                ) || null
	            );
	        }
	
	        /**
	         * This function check a ticket document list and return true if there are checked elements.
	         *
	         * @param {*} itemId
	         */
	    }, {
	        key: 'buttonIsEnabledForDownload',
	        value: function buttonIsEnabledForDownload(itemId) {
	            var documentCheckList = this.state.documentCheckList;
	
	            if (!documentCheckList[itemId]) {
	                return false;
	            }
	
	            if (documentCheckList[itemId].length <= 0) {
	                return false;
	            }
	
	            return true;
	        }
	
	        /**
	         * renders the link button once the dsDocuments are loaded
	         * @param {*} dsDocuments
	         * @param {*} dsDocTemplates
	         * @param {*} documentId
	         * @param {*} key
	         * @returns
	         */
	    }, {
	        key: 'linkButton',
	        value: function linkButton(dsDocuments, dsDocTemplates, documentId, key) {
	            var _this9 = this;
	
	            if (dsDocuments.length === 0 || dsDocTemplates.length === 0) {
	                return _react2['default'].createElement('div', null);
	            }
	
	            var dsDocument = dsDocuments.find(function (doc) {
	                return doc.id === documentId;
	            });
	            return _react2['default'].createElement(_DSDocumentsLinkAndUploadButton2['default'], {
	                dsDocument: dsDocument,
	                templates: dsDocTemplates || [],
	                openLinkAndUploadWizard: function (dsDocument) {
	                    return _this9.openLinkAndUploadWizard(dsDocument);
	                },
	                key: key + "LinkAndUploadButtonkey"
	            });
	        }
	
	        /**
	         * This function clean up the details object.
	         * No cleanDetail kept
	         * @param {*} details
	         * @returns
	         */
	    }, {
	        key: 'getDetailsWithoutClientLabel',
	        value: function getDetailsWithoutClientLabel(details) {
	
	            if (typeof details !== 'object') {
	                return details;
	            }
	
	            var cleanDetail = JSON.parse(JSON.stringify(details));
	            if (cleanDetail.clientLabel) {
	                delete cleanDetail.clientLabel;
	            }
	
	            // skip few values to show, they are used only for backround hadnling processes, not for users to show : BEWB-730
	            if (cleanDetail.portal_cat_ticket) {
	                delete cleanDetail.portal_cat_ticket;
	            }
	
	            if (cleanDetail.beheerder) {
	                delete cleanDetail.beheerder;
	            }
	
	            return cleanDetail;
	        }
	
	        /**
	          * Open the model for linking or uploading document
	          * @param {*} dsDocument
	          */
	    }, {
	        key: 'openLinkAndUploadWizard',
	        value: function openLinkAndUploadWizard(dsDocument) {
	            this.setState({ isOpenLinkDocumentModal: dsDocument });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this10 = this;
	
	            var _state2 = this.state;
	            var isOpened = _state2.isOpened;
	            var archiveIsOpen = _state2.archiveIsOpen;
	            var confirmationModal = _state2.confirmationModal;
	            var waitingModal = _state2.waitingModal;
	            var isOpenLinkDocumentModal = _state2.isOpenLinkDocumentModal;
	            var signDocumentsModalIsOpen = _state2.signDocumentsModalIsOpen;
	            var clientLinkingIsOpen = _state2.clientLinkingIsOpen;
	            var /*emailerIsOpen,*/moduleOptionsForEmail = _state2.moduleOptionsForEmail;
	            var moduleKeyToSet = _state2.moduleKeyToSet;
	            var reminderConfirmationModal = _state2.reminderConfirmationModal;
	            var reminderSentSuccessFlag = _state2.reminderSentSuccessFlag;
	            var invitationBlocked = _state2.invitationBlocked;
	            var _props13 = this.props;
	            var items = _props13.items;
	            var filterTicket = _props13.filterTicket;
	            var selectValue = _props13.selectValue;
	            var getInbox = _props13.getInbox;
	            var setTicketUnread = _props13.setTicketUnread;
	            var staff = _props13.staff;
	            var dsDocTemplates = _props13.dsDocTemplates;
	            var dsDocuments = _props13.dsDocuments;
	
	            var checkedItemCount = items.reduce(function (a, b) {
	                return a + (b.checked ? 1 : 0);
	            }, 0);
	            var visibilityOf = this.state.visibilityOf;
	            var modalIsOpen = this.props.archiveData.modalIsOpen;
	
	            var downloaddoc = this.getDownloadDocSecurity();
	            var createEmail = this.getEmailSecurity();
	            var allSelected = items && items.length > 0 && items.every(function (item) {
	                return visibilityOf[item.id] ? item.checked : true;
	            });
	            this.allSelected = allSelected;
	            var filteredItems = items.filter(function (item) {
	                return !item.hidden;
	            });
	
	            // Needs to be defined here so translations are updated
	            var filterOptions = [{ value: 'showAll', label: _('showAll') }, { value: 'showUnread', label: _('showUnread') }, { value: 'showRead', label: _('showRead') }, { value: 'hasTaskCompleted', label: _('hasTaskCompleted') }, { value: 'hasTaskUncompleted', label: _('hasTaskUncompleted') }];
	
	            return _react2['default'].createElement(
	                _elementsComponentPageDom2['default'],
	                {
	                    title: _('title'),
	                    subtitle: _('subtitle')
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _inboxScss2['default'].results },
	                    _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            onVisibleChange: this.handleVisibleList,
	                            topPaginationElemL: [_react2['default'].createElement(
	                                'div',
	                                { key: 'x1z' },
	                                _react2['default'].createElement(_sharedSelectSelectWrap2['default'], {
	                                    key: 's',
	                                    value: selectValue,
	                                    options: filterOptions,
	                                    onChange: function (v) {
	                                        filterTicket(v.value);
	                                    }
	                                })
	                            ), _react2['default'].createElement(_refreshBtn2['default'], {
	                                key: 'r',
	                                onClick: function () {
	                                    getInbox(true);
	                                }
	                            })],
	                            topPaginationElemR: this.archiveBtn(checkedItemCount, filteredItems, downloaddoc),
	                            filterable: ["ticketDate", "ticketDescription", "ticketType", "ticketDocumentNames"],
	                            ref: function (el) {
	                                _this10.table = el;
	                            },
	                            id: 'table',
	                            className: 'table',
	                            sortable: [{ column: 'ticketDate', sortFunction: 'Date' }, 'ticketDescription', 'ticketType'],
	                            defaultSort: {
	                                column: 'ticketDate',
	                                direction: 'desc'
	                            },
	
	                            itemsPerPage: 50,
	                            pageButtonLimit: 5
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(_componentsReactable.Th, { column: 'collapse', label: '' }),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'checkbox' },
	                                _react2['default'].createElement('input', {
	                                    type: 'checkbox',
	                                    checked: allSelected,
	                                    onChange: this.handleCheckAll
	                                })
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'ticketDate' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _("ticketDate")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'ticketDescription' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _("ticketDescription")
	                                )
	                            ),
	                            _react2['default'].createElement(_componentsReactable.Th, { column: 'ticketOperations', label: '' }),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'ticketType' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _("ticketType")
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'status' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _("ticketStatus")
	                                )
	                            )
	                        ),
	                        filteredItems.map(function (item, key) {
	                            var ticketCategoryId = _nestedProperty2['default'].get(item, "ticketDetails.portal_cat_ticket");
	                            var isExpanded = isOpened[item.id];
	                            var quickReplyEnabled = ticketCategoryId && TICKET_CATEGPRIES_WHITE_LIST_FOR_QUICK_REPLY.includes(ticketCategoryId + "");
	
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                {
	                                    className: item.unread ? _inboxScss2['default'].unread + ' clickable' : 'clickable',
	                                    i: item.id,
	                                    key: key,
	                                    onClick: function () {
	                                        _this10['switch'](item.id);
	                                        if (item.unread) {
	                                            setTicketUnread(item.id, false);
	                                        }
	                                    }
	                                },
	                                (0, _componentsReactable.collapseTd)({
	                                    column: 'collapse',
	                                    isOpened: isOpened[item.id],
	                                    children: _react2['default'].createElement(
	                                        'div',
	                                        { className: (0, _classnames2['default'])(_inboxScss2['default'].content, 'collapseWrapper'), 'data-ticketIdAttr': item.id },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { key: "TdDetailsKey" },
	                                            _react2['default'].createElement(
	                                                'h2',
	                                                null,
	                                                _('details')
	                                            ),
	                                            item.ticketDetails && item.ticketDetails.clientLabel && _react2['default'].createElement(
	                                                'div',
	                                                null,
	                                                _("clientLabel") + " " + item.ticketDetails.clientLabel
	                                            ),
	                                            _react2['default'].createElement(_reactDomify2['default'], { value: _this10.getDetailsWithoutClientLabel(item.ticketDetails) })
	                                        ),
	                                        item.unlinkedDocumentId && _react2['default'].createElement(
	                                            'div',
	                                            { key: "UnlinkedDocumentKey" },
	                                            _react2['default'].createElement(
	                                                'h2',
	                                                null,
	                                                _("unlinkedDocument")
	                                            ),
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _inboxScss2['default'].documents },
	                                                _react2['default'].createElement(
	                                                    'div',
	                                                    { className: _inboxScss2['default'].unlinkedDocument },
	                                                    _react2['default'].createElement(
	                                                        'a',
	                                                        {
	                                                            key: key + "download_link",
	                                                            href: '/data/document?id=' + item.unlinkedDocumentId + '&type=' + item.typeDocument + '&source=' + DOCUMENT_FILE_SOURCE_DSDOCUMENT,
	                                                            target: '_blank',
	                                                            rel: 'noopener noreferrer'
	                                                        },
	                                                        item.unlinkedDocumentFileName
	                                                    ),
	                                                    _react2['default'].createElement(
	                                                        'div',
	                                                        { className: _inboxScss2['default'].linkButton },
	                                                        _this10.linkButton(dsDocuments, dsDocTemplates, item.unlinkedDocumentId, key)
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        item.documents && item.documents.length > 0 && _react2['default'].createElement(
	                                            'div',
	                                            { key: "TdDocumentsKey" },
	                                            _react2['default'].createElement(
	                                                'h2',
	                                                null,
	                                                _('documents')
	                                            ),
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _inboxScss2['default'].documents },
	                                                item.documents.map(function (doc, key) {
	                                                    return _react2['default'].createElement(
	                                                        'div',
	                                                        null,
	                                                        downloaddoc && _react2['default'].createElement('input', {
	                                                            key: "check_" + key,
	                                                            type: 'checkbox',
	                                                            onChange: function (event) {
	                                                                _this10.setCheckedDoc(event, doc, item.id, item.typeDocument, DOCUMENT_FILE_SOURCE_TICKET_DOCUMENT);
	                                                            },
	                                                            checked: _this10.thisCheckBoxIsChecked(doc, item.id, item.typeDocument)
	                                                        }),
	                                                        _react2['default'].createElement(
	                                                            'a',
	                                                            {
	                                                                key: key,
	                                                                href: '/data/document?id=' + doc + '&type=' + item.typeDocument,
	                                                                target: '_blank',
	                                                                rel: 'noopener noreferrer'
	                                                            },
	                                                            doc
	                                                        )
	                                                    );
	                                                })
	                                            ),
	                                            downloaddoc && _react2['default'].createElement(
	                                                'div',
	                                                { className: _inboxScss2['default'].archiveModalButtons, key: item.id + "DownloadButtonKey" },
	                                                _react2['default'].createElement('input', {
	                                                    onClick: function () {
	                                                        return _this10.downloadSelected(item.id);
	                                                    },
	                                                    disabled: Boolean(!_this10.buttonIsEnabledForDownload(item.id)),
	                                                    type: 'button',
	                                                    className: _inboxScss2['default'].greyButton,
	                                                    value: _("downloadSelectedDocuments")
	                                                })
	                                            )
	                                        ),
	                                        item.relatedTasks.map(function (itemData, key) {
	                                            return _react2['default'].createElement(
	                                                'div',
	                                                { className: _inboxScss2['default'].inboxUserNames,
	                                                    key: "TdinboxUserNamesKey" + key
	                                                },
	                                                _this10.getStaffName(itemData.userId),
	                                                ' - ',
	                                                _this10.getTaskStatus(itemData.isCompleted),
	                                                ' - ',
	                                                itemData.title
	                                            );
	                                        })
	                                    )
	                                }),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'checkbox', value: (0, _lodashCollection.map)(item.ticketDetails, function (i) {
	                                            return i;
	                                        }).join(' ') },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { style: { width: 15 } },
	                                        _react2['default'].createElement('input', {
	                                            type: 'checkbox',
	                                            onClick: function (ev) {
	                                                return ev.stopPropagation();
	                                            },
	                                            onChange: function (ev) {
	                                                return _this10.check(ev, item.id);
	                                            },
	                                            checked: item.checked
	                                        })
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    {
	                                        column: 'ticketDate',
	                                        value:
	                                        // a little hack with MongoDB id as timestamp for sorting
	                                        item.ticketDate.toString() + item.id
	                                    },
	                                    (0, _libHelpers.dateFormatter)(item.ticketDate)
	                                ),
	                                _react2['default'].createElement(_componentsReactable.Td, { column: 'ticketOperations', children: item.ticketDetails && (item.ticketDetails.contractId || item.ticketDetails.claimId || item.ticketDetails.tarificationId) ? _react2['default'].createElement(
	                                        'div',
	                                        { className: _inboxScss2['default'].iconWrapper },
	                                        _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].goToContractWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_inboxScss2['default'].inboxToolIcon), src: _this10.getIcon('baseline-reply-24px-green.svg'),
	                                                onClick: function (e) {
	                                                    e.stopPropagation();
	                                                    _this10.gotToContractOrClaimOfClient(item, false);
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].goToContractTooltip]) },
	                                                _('goToContractTooltip')
	                                            )
	                                        ),
	                                        createEmail && _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].createEmailWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_inboxScss2['default'].inboxToolIcon), src: _this10.getIcon('icn-inbox-blue.svg'),
	                                                onClick: function (e) {
	                                                    e.stopPropagation();
	                                                    _this10.gotToContractOrClaimOfClient(item, true);
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].createEmailTooltip]) },
	                                                _('createEmailTooltip')
	                                            )
	                                        ),
	                                        createEmail && quickReplyEnabled && _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].quickReplyWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_inboxScss2['default'].inboxToolIcon), src: _this10.getIcon('baseline-reply-to-willemot-24px-green.svg'),
	                                                onClick: function (e) {
	                                                    e.stopPropagation();
	                                                    //this.openEmailer(item, true)
	                                                    _this10.gotToContractOrClaimOfClient(item, true, true, true);
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].quickReplyTooltip]) },
	                                                _('quickReplyTooltip')
	                                            )
	                                        ),
	                                        item.documents && item.documents.length > 0 && _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].signDocumentsWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_inboxScss2['default'].inboxToolIcon), src: _this10.getIcon('a-edit_1x_blue.svg'),
	                                                onClick: function (e) {
	                                                    _this10.setState({ signDocumentsModalIsOpen: item });
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].signDocumentsTooltip]) },
	                                                _('signDocumentsTooltip')
	                                            )
	                                        )
	                                    ) : _react2['default'].createElement(
	                                        'div',
	                                        { className: _inboxScss2['default'].iconWrapper },
	                                        item.ticketType === 'Bloc Retour' && !item.linkedClient ? _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].blockRetourWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_inboxScss2['default'].inboxToolIcon, _inboxScss2['default'].linkClientIcon), src: _this10.getIcon('person_search_green.svg'),
	                                                onClick: function (e) {
	                                                    e.stopPropagation();
	                                                    _this10.setState({ clientLinkingIsOpen: item });
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].blockRetourTooltip]) },
	                                                _('blockRetourTooltip')
	                                            )
	                                        ) : '',
	                                        createEmail && quickReplyEnabled && _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].quickReplyWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_inboxScss2['default'].inboxToolIcon), src: _this10.getIcon('baseline-reply-to-willemot-24px-green.svg'),
	                                                onClick: function (e) {
	                                                    e.stopPropagation();
	                                                    // this.openEmailer(item, true)
	                                                    _this10.gotToContractOrClaimOfClient(item, true, true, true);
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].quickReplyTooltip]) },
	                                                _('quickReplyTooltip')
	                                            )
	                                        ),
	                                        item.ticketDetails.packageId ? _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].goToPackageWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])([_inboxScss2['default'].inboxToolIcon, _inboxScss2['default'].goToPackageIcon]), src: _this10.getIcon('baseline-reply-24px-green.svg'),
	                                                onClick: function (e) {
	                                                    e.stopPropagation();
	                                                    _this10.onNavigateToPackageClick(item.ticketDetails.packageId);
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].goToPackageTooltip]) },
	                                                _('goToPackageTooltip')
	                                            )
	                                        ) : '',
	                                        item.ticketDetails.packageId && item.statusFromPackage && (item.statusFromPackage == 'packageStatusPending' || item.statusFromPackage == 'emailSentWithLink') && _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].sendReminderWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_inboxScss2['default'].inboxToolIcon), src: _this10.getIcon('notification-bell.svg'),
	                                                onClick: function (e) {
	                                                    e.stopPropagation();
	                                                    _this10.onSendReminderClick(item.ticketDetails.packageId);
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].sendReminderTooltip]) },
	                                                _('sendReminderTooltip')
	                                            )
	                                        ),
	                                        item.ticketDetails.packageId && item.statusFromPackage && (item.statusFromPackage == 'packageStatusPending' || item.statusFromPackage == 'emailSentWithLink') && _react2['default'].createElement(
	                                            'span',
	                                            { className: _inboxScss2['default'].directSignWrapper },
	                                            _react2['default'].createElement('img', { className: (0, _classnames2['default'])(_inboxScss2['default'].inboxToolIcon), src: _this10.getIcon('a-edit_1x_blue.svg'),
	                                                onClick: function (e) {
	                                                    e.stopPropagation();
	                                                    _this10.onDirectSigningClick(item.ticketDetails.packageId);
	                                                }
	                                            }),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: (0, _classnames2['default'])([_inboxScss2['default'].tooltip, _inboxScss2['default'].directSignTooltip]) },
	                                                _('directSignTooltip')
	                                            )
	                                        )
	                                    ) }),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'ticketDescription', value: item.ticketDescription },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'ticket-description',
	                                            'data-ticketIdAttr': item.id,
	                                            style: {
	                                                whiteSpace: 'pre-line',
	                                                overflow: 'hidden',
	                                                textOverflow: 'ellipsis',
	                                                display: '-webkit-box',
	                                                WebkitLineClamp: isExpanded ? 1000 : 1,
	                                                WebkitBoxOrient: 'vertical',
	                                                wordBreak: 'break-word',
	                                                overflowWrap: 'break-word'
	                                            }
	                                        },
	                                        item.ticketDescription
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'status' },
	                                    item.statusFromPackage ? _(item.statusFromPackage) : ''
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { className: _reactableScss2['default'].typeCol, column: 'ticketType' },
	                                    item.ticketType
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'ticketDocumentNames' },
	                                    item.ticketDocumentNames
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2['default'].createElement(_taskCreatorIndex2['default'], {
	                    modalTitle: 'inboxTaskCreatorModalTitle',
	                    taskItems: this.generateTaskCreatorItems(items),
	                    staffItems: staff,
	                    convertionType: 'inbox'
	                }),
	                _react2['default'].createElement(_inboxDocumentsSigningModal2['default'], {
	                    modalIsOpen: signDocumentsModalIsOpen ? true : false,
	                    onCancel: function () {
	                        _this10.setState({ signDocumentsModalIsOpen: null });
	                    },
	                    method: function (documentsList, attachmentDocumentsList, ticketObject) {
	                        _this10.setState({ signDocumentsModalIsOpen: null });
	                        return _this10.openDsWizardWithDocuments(documentsList, attachmentDocumentsList, ticketObject);
	                    },
	                    payload: signDocumentsModalIsOpen ? { ticket: signDocumentsModalIsOpen } : {}
	                }),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: confirmationModal,
	                        style: customStyles,
	                        key: "archiveConfirmPopupKey",
	                        contentLabel: ""
	                        /*className={styles.modal}*/
	                    },
	                    this.archiveConfirmPopup()
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: waitingModal,
	                        style: customStyles,
	                        key: "waitingPopupKey",
	                        contentLabel: ""
	                    },
	                    this.waitingPopup()
	                ),
	                _react2['default'].createElement(_DSDocumentsReminderEmailStatusDialog2['default'], {
	                    isOpen: reminderConfirmationModal,
	                    success: reminderSentSuccessFlag,
	                    invitationBlocked: invitationBlocked,
	                    closeModal: function () {
	                        return _this10.setState({ reminderConfirmationModal: false, invitationBlocked: false, reminderSentSuccessFlag: false });
	                    }
	                }),
	                _react2['default'].createElement(_DSDocumentsLinkDocumentModal2['default'], {
	                    modalIsOpen: !!isOpenLinkDocumentModal,
	                    onCancel: function () {
	                        _this10.setState({ isOpenLinkDocumentModal: false });
	                        _this10.refresh(true);
	                    },
	                    onConfirmation: function () {
	                        _this10.refresh(true);
	                        _this10.setState({ isOpenLinkDocumentModal: false });
	                    },
	                    flag: 'LinkDocumentModal',
	                    payload: isOpenLinkDocumentModal ? {
	                        dsdocument: isOpenLinkDocumentModal
	                    } : {}
	                }),
	                _react2['default'].createElement(_inboxClientLinkingModal2['default'], {
	                    isOpen: !!clientLinkingIsOpen,
	                    customStyles: customStyles,
	                    key: "ClientLinkingModal",
	                    ticket: clientLinkingIsOpen,
	                    onClose: function () {
	                        return _this10.setState({ clientLinkingIsOpen: '' });
	                    },
	                    setNotification: _stateActions.setNotification
	                })
	            );
	        }
	    }]);
	
	    var _Inbox = Inbox;
	    Inbox = (0, _reactRedux.connect)(function (_ref2) {
	        var _ref2$inbox = _ref2.inbox;
	        var items = _ref2$inbox.items;
	        var filter = _ref2$inbox.filter;
	        var selectValue = _ref2$inbox.selectValue;
	        var staff = _ref2$inbox.staff;
	        var archiveData = _ref2$inbox.archiveData;
	        var _ref2$DSDocuments = _ref2.DSDocuments;
	        var dsDocuments = _ref2$DSDocuments.items;
	        var dsDocTemplates = _ref2$DSDocuments.templates;
	        var _ref2$app = _ref2.app;
	        var security = _ref2$app.security;
	        var module = _ref2$app.module;
	        var EmailTemplateRelations = _ref2$app.security.EmailTemplateRelations;
	        var clientData = _ref2.clients.clientData;
	        var clientOptionsDict = _ref2.client.clientOptionsDict;
	        return {
	            items: items, filter: filter, selectValue: selectValue, staff: staff, archiveData: archiveData, security: security, module: module, dsDocuments: dsDocuments, dsDocTemplates: dsDocTemplates, clientData: clientData,
	            EmailTemplateRelations: EmailTemplateRelations, clientOptionsDict: clientOptionsDict
	        };
	    }, mapDispatchToProps)(Inbox) || Inbox;
	    return Inbox;
	})(_react.Component);
	
	exports['default'] = Inbox;
	module.exports = exports['default'];

	/**
	 * This function helps to use an icon on a safe way
	 */

	//check if must send  reminder or send invitation

	//send manual reminder

	//create documents objects
	/*emailerIsOpen &&
	   <EmailButton
	       moduleKeyToSet={moduleKeyToSet}
	       moduleOptions={moduleOptionsForEmail}
	       modalId={c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT}
	       hideButton={true}
	       forceOpen={true}
	       onSentLate={() => {
	           this.setState({ emailerIsOpen: fasle })
	       }}
	   />
	*/

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(4);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _ClientLinkingModalScss = __webpack_require__(720);
	
	var _ClientLinkingModalScss2 = _interopRequireDefault(_ClientLinkingModalScss);
	
	var _clientsClientsScss = __webpack_require__(244);
	
	var _clientsClientsScss2 = _interopRequireDefault(_clientsClientsScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _clientsForm = __webpack_require__(605);
	
	var _clientsForm2 = _interopRequireDefault(_clientsForm);
	
	var _ClientLinkingSearchResult = __webpack_require__(1105);
	
	var _ClientLinkingSearchResult2 = _interopRequireDefault(_ClientLinkingSearchResult);
	
	var _stateActions = __webpack_require__(5);
	
	// variables out of module
	var _ = (0, _libI18n2['default'])('inbox');
	
	/**
	 * This module render a button witch can be used to link or upload DSDocument
	 */
	
	var ClientLinkingModal = (function (_React$Component) {
	    _inherits(ClientLinkingModal, _React$Component);
	
	    _createClass(ClientLinkingModal, null, [{
	        key: 'propTypes',
	        value: {
	            isOpen: _react2['default'].PropTypes.bool,
	            customStyles: _react2['default'].PropTypes.object,
	            key: _react2['default'].PropTypes.string,
	            ticket: _react2['default'].PropTypes.any,
	            onClose: _react2['default'].PropTypes.func,
	            setNotification: _react2['default'].PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function ClientLinkingModal(props) {
	        var _this = this;
	
	        _classCallCheck(this, _ClientLinkingModal);
	
	        _get(Object.getPrototypeOf(_ClientLinkingModal.prototype), 'constructor', this).call(this, props);
	
	        this.handleSearch = function (data) {
	            _this.setState({ selectedClientId: '' });
	            _this.props.dispatch((0, _stateActions.fetchClients)(data, true));
	        };
	
	        this.selectClientMethod = function (clientId) {
	            var selectedClientId = _this.state.selectedClientId;
	
	            if (!selectedClientId || selectedClientId !== clientId) {
	                _this.setState({ selectedClientId: clientId });
	            } else if (selectedClientId === clientId) {
	                _this.setState({ selectedClientId: '' });
	            }
	        };
	
	        this.state = {
	            selectedClientId: '',
	            updateErrorBlocRetourSuccess: false
	        };
	    }
	
	    /**
	     * This function fired when the module attached
	     */
	
	    _createClass(ClientLinkingModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var clientOptionsDict = _props.clientOptionsDict;
	
	            if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
	                dispatch((0, _stateActions.fetchClientOptionsDict)());
	            }
	        }
	    }, {
	        key: 'clearModalData',
	        value: function clearModalData() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.setClientData)({}));
	            this.setState({ selectedClientId: '', updateErrorBlocRetourSuccess: false });
	        }
	    }, {
	        key: 'onUpdateErrorBlockRetour',
	        value: function onUpdateErrorBlockRetour() {
	            var _props2, dispatch, setNotification, ticket, selectedClientId, blockretId, result;
	
	            return regeneratorRuntime.async(function onUpdateErrorBlockRetour$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        _props2 = this.props;
	                        dispatch = _props2.dispatch;
	                        setNotification = _props2.setNotification;
	                        ticket = _props2.ticket;
	                        selectedClientId = this.state.selectedClientId;
	                        context$2$0.prev = 5;
	                        blockretId = ticket.ticketDetails.msg_link_id.split('_')[1];
	                        context$2$0.next = 9;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.updateErrorBlocRetour)(ticket.id, selectedClientId, blockretId)));
	
	                    case 9:
	                        result = context$2$0.sent;
	
	                        if (result && result[0] && result[0].error == '0') {
	                            // success
	                            this.setState({ updateErrorBlocRetourSuccess: true });
	                            dispatch(setNotification('' + _('updateErrorBlockRetourSuccess'), 'success'));
	                        } else {
	                            dispatch(setNotification('' + _('updateErrorBlockRetourFail' + result[0].error), 'error'));
	                        }
	
	                        context$2$0.next = 17;
	                        break;
	
	                    case 13:
	                        context$2$0.prev = 13;
	                        context$2$0.t0 = context$2$0['catch'](5);
	
	                        dispatch(setNotification('' + (_('updateErrorBlockRetourFail') + ' ' + context$2$0.t0), 'error'));
	                        console.warn(context$2$0.t0);
	
	                    case 17:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[5, 13]]);
	        }
	
	        /**
	         * Main render function
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props;
	            var isOpen = _props3.isOpen;
	            var customStyles = _props3.customStyles;
	            var key = _props3.key;
	            var clientOptionsDict = _props3.clientOptionsDict;
	            var lang = _props3.lang;
	            var data = _props3.data;
	            var onClose = _props3.onClose;
	            var ticket = _props3.ticket;
	            var _state = this.state;
	            var selectedClientId = _state.selectedClientId;
	            var updateErrorBlocRetourSuccess = _state.updateErrorBlocRetourSuccess;
	
	            return _react2['default'].createElement(
	                _reactModal2['default'],
	                {
	                    isOpen: isOpen,
	                    style: customStyles,
	                    key: key + "innerModal",
	                    contentLabel: ""
	                },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2['default'])(_ClientLinkingModalScss2['default'].documentsModalContent),
	                        key: key + "innerModal" + Math.random()
	                    },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _ClientLinkingModalScss2['default'].title },
	                        _('linkClientFromTicketTitle')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _ClientLinkingModalScss2['default'].contentWrapper },
	                        !updateErrorBlocRetourSuccess ? _react2['default'].createElement(
	                            'div',
	                            { className: _ClientLinkingModalScss2['default'].content },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_ClientLinkingModalScss2['default'].formInputContainer, _ClientLinkingModalScss2['default'].titleLabel),
	                                    key: 'selectSignaturePlaceholderDocumentModalContentTitleKey' },
	                                _('selectClientForUpdateErrorBlocRetour')
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _clientsClientsScss2['default'].clientsMain },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: (0, _classnames2['default'])(_clientsClientsScss2['default'].clientsSearchContainer, _ClientLinkingModalScss2['default'].clientsSearchContainer) },
	                                    _react2['default'].createElement(_clientsForm2['default'], _extends({
	                                        createClientAccess: false,
	                                        updateClientAccess: false,
	                                        openModal: function openModal() {},
	                                        modalState: false
	                                    }, {
	                                        onSubmit: this.handleSearch,
	                                        initialValues: { state: '' },
	                                        clientOptionsDict: clientOptionsDict,
	                                        lang: lang
	                                    })),
	                                    data && _react2['default'].createElement(_ClientLinkingSearchResult2['default'], {
	                                        data: data,
	                                        selectClientMethod: this.selectClientMethod,
	                                        selectedClientId: selectedClientId
	                                    })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _ClientLinkingModalScss2['default'].documentsModalButtons },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            _this2.clearModalData();
	                                            onClose();
	                                        },
	                                        className: _ClientLinkingModalScss2['default'].cancel
	                                    },
	                                    _("cancel")
	                                ),
	                                _react2['default'].createElement(
	                                    'button',
	                                    {
	                                        onClick: function callee$2$0(e) {
	                                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                    case 0:
	                                                        if (selectedClientId) {
	                                                            context$3$0.next = 2;
	                                                            break;
	                                                        }
	
	                                                        return context$3$0.abrupt('return');
	
	                                                    case 2:
	                                                        context$3$0.next = 4;
	                                                        return regeneratorRuntime.awrap(this.onUpdateErrorBlockRetour());
	
	                                                    case 4:
	                                                    case 'end':
	                                                        return context$3$0.stop();
	                                                }
	                                            }, null, _this2);
	                                        },
	
	                                        // onClose()
	                                        className: _ClientLinkingModalScss2['default'].greenButton + ' "enabled"',
	                                        disabled: !selectedClientId
	                                    },
	                                    _("updateErrorBlock")
	                                )
	                            )
	                        ) : _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_ClientLinkingModalScss2['default'].formInputContainer, _ClientLinkingModalScss2['default'].titleLabel),
	                                    key: 'selectClientUpdateErrorBlocRetourSuccessTitleKey' },
	                                _('selectClientUpdateErrorBlocRetourSuccess')
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _ClientLinkingModalScss2['default'].documentsModalButtons },
	                                _react2['default'].createElement(
	                                    'button',
	                                    {
	                                        onClick: function callee$2$0(e) {
	                                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                                    case 0:
	                                                        this.clearModalData();
	                                                        onClose();
	
	                                                    case 2:
	                                                    case 'end':
	                                                        return context$3$0.stop();
	                                                }
	                                            }, null, _this2);
	                                        },
	                                        className: _ClientLinkingModalScss2['default'].greenButton + ' "enabled"',
	                                        disabled: !selectedClientId
	                                    },
	                                    _("ok")
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _ClientLinkingModal = ClientLinkingModal;
	    ClientLinkingModal = (0, _reactRedux.connect)(function (state) {
	        return {
	            data: state.clients.data,
	            clientOptionsDict: state.client.clientOptionsDict,
	            lang: state.app.lang,
	            security: _nestedProperty2['default'].get(state, "app.security")
	        };
	    })(ClientLinkingModal) || ClientLinkingModal;
	    return ClientLinkingModal;
	})(_react2['default'].Component);
	
	exports['default'] = ClientLinkingModal;
	module.exports = exports['default'];

	//extract the blockretId from string that arrives like "BLOCRET_14950"

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _lodashLang = __webpack_require__(78);
	
	var _ClientLinkingModalScss = __webpack_require__(720);
	
	var _ClientLinkingModalScss2 = _interopRequireDefault(_ClientLinkingModalScss);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	var _tooManyResults = __webpack_require__(175);
	
	var _tooManyResults2 = _interopRequireDefault(_tooManyResults);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var ClientLinkingSearchResults = (function (_React$Component) {
		_inherits(ClientLinkingSearchResults, _React$Component);
	
		_createClass(ClientLinkingSearchResults, null, [{
			key: 'propTypes',
			value: {
				data: _react2['default'].PropTypes.array,
				selectClientMethod: _react2['default'].PropTypes.func,
				selectedClientId: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		function ClientLinkingSearchResults(props) {
			_classCallCheck(this, ClientLinkingSearchResults);
	
			_get(Object.getPrototypeOf(ClientLinkingSearchResults.prototype), 'constructor', this).call(this, props);
		}
	
		_createClass(ClientLinkingSearchResults, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodashLang.eq)(this.props.data, nextProps.data);
			}
		}, {
			key: 'onClientSelectClick',
			value: function onClientSelectClick(clientId) {
				var selectClientMethod = this.props.selectClientMethod;
	
				selectClientMethod(clientId);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var data = _props.data;
				var selectedClientId = _props.selectedClientId;
	
				return _react2['default'].createElement(
					'div',
					{ className: _ClientLinkingModalScss2['default'].clientsTableContainer },
					data && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
						_componentsReactable.Table,
						{
							className: _ClientLinkingModalScss2['default'].table,
							itemsPerPage: 20,
							filterable: ["name", "email", "clientNumber"],
							sortable: ["name", "email", "clientNumber"],
							defaultSort: {
								column: 'name',
								direction: 'desc'
							}
						},
						_react2['default'].createElement(
							_componentsReactable.Thead,
							null,
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'checkBox' },
								' '
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'clientNumber' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientNumber')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'name' },
								_react2['default'].createElement(
									'strong',
									null,
									_('name')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'email' },
								_react2['default'].createElement(
									'strong',
									null,
									_('email')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'address' },
								_react2['default'].createElement(
									'strong',
									null,
									_('clientAddress')
								)
							)
						),
						data.map(function (item, key) {
							return _react2['default'].createElement(
								_componentsReactable.Tr,
								{
									className: 'clickable centered',
									onClick: function () {
										if (!selectedClientId || selectedClientId === item.clientId) {
											_this.onClientSelectClick(item.clientId);
										}
									},
									key: key
								},
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'checkBox' },
									_react2['default'].createElement(
										'div',
										{ style: { width: 15 } },
										_react2['default'].createElement('input', {
											type: 'checkbox',
											onClick: function (ev) {
												return ev.stopPropagation();
											},
											onChange: function (ev) {
												return _this.onClientSelectClick(item.clientId);
											},
											checked: selectedClientId && selectedClientId === item.clientId ? true : false,
											disabled: selectedClientId && selectedClientId !== item.clientId
										})
									)
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'clientNumber' },
									item.clientNumber
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'name' },
									item.name
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'email' },
									item.email
								),
								_react2['default'].createElement(
									_componentsReactable.Td,
									{ column: 'address' },
									item.mainAddress
								)
							);
						})
					),
					data && _underscore2['default'].isArray(data) && data.length === 0 && _react2['default'].createElement(_noResults2['default'], { type: 'clients' }),
					data && _underscore2['default'].isArray(data) && data[0] === 'Too many rows' && _react2['default'].createElement(_tooManyResults2['default'], { type: 'clients' })
				);
			}
		}]);
	
		return ClientLinkingSearchResults;
	})(_react2['default'].Component);
	
	exports['default'] = ClientLinkingSearchResults;
	module.exports = exports['default'];

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _inboxScss = __webpack_require__(719);
	
	var _inboxScss2 = _interopRequireDefault(_inboxScss);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('inbox');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        overflow: 'visible'
	    },
	    content: {
	        width: 'auto',
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        //minHeight: '50%',
	        overflow: 'visible',
	        padding: '0',
	        wordWrap: "break-word"
	    }
	};
	
	/**
	 * This component will handle documents selection from ticket before opening the dsWizard
	 * If there is only one ticket, this modal will be skipped
	 */
	
	var InboxDocumentsSigningModal = (function (_React$Component) {
	    _inherits(InboxDocumentsSigningModal, _React$Component);
	
	    function InboxDocumentsSigningModal(props) {
	        _classCallCheck(this, InboxDocumentsSigningModal);
	
	        _get(Object.getPrototypeOf(InboxDocumentsSigningModal.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            selectedDocuments: [],
	            attachmentSelectedDocuments: []
	        };
	    }
	
	    /**
	     * Used to reset the selected documents in case new ticket is being processed 
	     * @param {*} nextProps 
	     */
	
	    _createClass(InboxDocumentsSigningModal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var ticket = _nestedProperty2['default'].get(nextProps, "payload.ticket");
	            var method = _nestedProperty2['default'].get(nextProps, "method");
	            var selectedDocuments = this.state.selectedDocuments;
	
	            if (selectedDocuments && selectedDocuments.length > 0 && ticket) {
	                if (!selectedDocuments.some(function (selectedDoc) {
	                    return ticket.documents.includes(selectedDoc);
	                })) {
	                    this.setState({ selectedDocuments: [] });
	                }
	            }
	
	            //fast forward if there is only one document
	            if (ticket && ticket.documents && ticket.documents.length === 1) {
	                method(ticket.documents, [], ticket);
	            }
	        }
	
	        /**
	         * Handle Ui event for individual checkbox
	         * @param {*} ev 
	         * @param {*} document 
	         */
	    }, {
	        key: 'onAddToSignChange',
	        value: function onAddToSignChange(ev, document) {
	            var _state = this.state;
	            var selectedDocuments = _state.selectedDocuments;
	            var attachmentSelectedDocuments = _state.attachmentSelectedDocuments;
	
	            var index = selectedDocuments.findIndex(function (oneDoc) {
	                return oneDoc === document;
	            });
	            if (index >= 0) {
	                selectedDocuments.splice(index);
	            } else {
	                selectedDocuments.push(document);
	                var attachmentIndex = attachmentSelectedDocuments.findIndex(function (oneDoc) {
	                    return oneDoc === document;
	                });
	                if (attachmentIndex >= 0) {
	                    attachmentSelectedDocuments.splice(attachmentIndex, 1);
	                }
	            }
	            this.setState({ selectedDocuments: selectedDocuments, attachmentSelectedDocuments: attachmentSelectedDocuments });
	        }
	
	        /**
	        * Handle Ui event for individual checkbox for email attachments
	        * @param {*} ev 
	        * @param {*} document 
	        */
	    }, {
	        key: 'onAddToAttachmentChange',
	        value: function onAddToAttachmentChange(ev, document) {
	            var _state2 = this.state;
	            var attachmentSelectedDocuments = _state2.attachmentSelectedDocuments;
	            var selectedDocuments = _state2.selectedDocuments;
	
	            var index = attachmentSelectedDocuments.findIndex(function (oneDoc) {
	                return oneDoc === document;
	            });
	            if (index >= 0) {
	                attachmentSelectedDocuments.splice(index);
	            } else {
	                attachmentSelectedDocuments.push(document);
	                var signingDocIndex = selectedDocuments.findIndex(function (oneDoc) {
	                    return oneDoc === document;
	                });
	                if (signingDocIndex >= 0) {
	                    selectedDocuments.splice(signingDocIndex, 1);
	                }
	            }
	            this.setState({ selectedDocuments: selectedDocuments, attachmentSelectedDocuments: attachmentSelectedDocuments });
	        }
	
	        /**
	         * Handles form validation and next step click
	         * @returns call to the method passed from parent component
	         */
	    }, {
	        key: 'handleOnNextClick',
	        value: function handleOnNextClick() {
	            var _state3 = this.state;
	            var selectedDocuments = _state3.selectedDocuments;
	            var attachmentSelectedDocuments = _state3.attachmentSelectedDocuments;
	            var _props = this.props;
	            var method = _props.method;
	            var payload = _props.payload;
	
	            var ticket = _nestedProperty2['default'].get(payload, 'ticket');
	            if (!selectedDocuments || selectedDocuments.length === 0) {
	                return;
	            }
	
	            return method(selectedDocuments, attachmentSelectedDocuments, ticket);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _state4 = this.state;
	            var selectedDocuments = _state4.selectedDocuments;
	            var attachmentSelectedDocuments = _state4.attachmentSelectedDocuments;
	            var _props2 = this.props;
	            var modalIsOpen = _props2.modalIsOpen;
	            var onCancel = _props2.onCancel;
	            var payload = _props2.payload;
	            var method = _props2.method;
	
	            var ticket = _nestedProperty2['default'].get(payload, 'ticket');
	            var ticketDocuments = _nestedProperty2['default'].get(ticket, "documents");
	            var allSelected = ticketDocuments && selectedDocuments.length === ticketDocuments.length;
	            var isValid = selectedDocuments && selectedDocuments.length > 0 ? true : false;
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _inboxScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _inboxScss2['default'].title },
	                        _('docSigningModal')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _inboxScss2['default'].contentWrapper },
	                        _react2['default'].createElement(
	                            _componentsReactable.Table,
	                            {
	                                onVisibleChange: this.handleVisibleList,
	                                filterable: ["documentName"],
	                                ref: function (el) {
	                                    _this.table = el;
	                                },
	                                id: 'table',
	                                className: 'table',
	                                sortable: ['documentName'],
	                                defaultSort: {
	                                    column: 'documentName',
	                                    direction: 'desc'
	                                },
	
	                                itemsPerPage: 50,
	                                pageButtonLimit: 5
	                            },
	                            _react2['default'].createElement(
	                                _componentsReactable.Thead,
	                                null,
	                                _react2['default'].createElement(_componentsReactable.Th, { column: 'collapse', label: '' }),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'signCheckbox' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _("addToSignLabel")
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'attachmentCheckbox' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _("addToEmailAttachment")
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'documentName' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _("documentName")
	                                    )
	                                )
	                            ),
	                            ticketDocuments && ticketDocuments.length && ticketDocuments.length > 0 ? ticketDocuments.map(function (item, key) {
	                                return _react2['default'].createElement(
	                                    _componentsReactable.Tr,
	                                    {
	                                        className: 'clickable',
	                                        i: item,
	                                        key: key
	                                    },
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'signCheckbox' },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { style: { width: 15 } },
	                                            _react2['default'].createElement('input', {
	                                                type: 'checkbox',
	                                                onClick: function (ev) {
	                                                    return ev.stopPropagation();
	                                                },
	                                                onChange: function (ev) {
	                                                    return _this.onAddToSignChange(ev, item);
	                                                },
	                                                checked: selectedDocuments.includes(item) ? true : false
	                                            })
	                                        )
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'attachmentCheckbox' },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { style: { width: 15 } },
	                                            _react2['default'].createElement('input', {
	                                                type: 'checkbox',
	                                                onClick: function (ev) {
	                                                    return ev.stopPropagation();
	                                                },
	                                                onChange: function (ev) {
	                                                    return _this.onAddToAttachmentChange(ev, item);
	                                                },
	                                                checked: attachmentSelectedDocuments.includes(item) ? true : false
	                                            })
	                                        )
	                                    ),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'documentName', value: item },
	                                        item
	                                    )
	                                );
	                            }) : ''
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _inboxScss2['default'].buttons },
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: onCancel,
	                                    className: (0, _classnames2['default'])(_inboxScss2['default'].cancel)
	                                },
	                                _('cancel')
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        return _this.handleOnNextClick();
	                                    },
	                                    className: (0, _classnames2['default'])(_inboxScss2['default'].next, isValid ? _inboxScss2['default'].enabled : _inboxScss2['default'].disabled)
	                                },
	                                _("ok")
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InboxDocumentsSigningModal;
	})(_react2['default'].Component);
	
	exports['default'] = InboxDocumentsSigningModal;
	module.exports = exports['default'];

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _lodashLang = __webpack_require__(78);
	
	var _listSelectScss = __webpack_require__(245);
	
	var _listSelectScss2 = _interopRequireDefault(_listSelectScss);
	
	var _input = __webpack_require__(109);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectSelectWrap2 = _interopRequireDefault(_sharedSelectSelectWrap);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libHelpers = __webpack_require__(24);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        zIndex: 2
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'visible',
	        padding: '0em'
	    }
	};
	
	var LicensesListSelect = (function (_React$Component) {
	    _inherits(LicensesListSelect, _React$Component);
	
	    _createClass(LicensesListSelect, null, [{
	        key: 'propTypes',
	        value: {
	            data: _react2['default'].PropTypes.array,
	            selectCategoryOptions: _react2['default'].PropTypes.array
	        },
	        enumerable: true
	    }]);
	
	    function LicensesListSelect(props) {
	        _classCallCheck(this, LicensesListSelect);
	
	        _get(Object.getPrototypeOf(LicensesListSelect.prototype), 'constructor', this).call(this, props);
	        this.state = { modalIsOpen: false };
	    }
	
	    _createClass(LicensesListSelect, [{
	        key: 'getIcon',
	        value: function getIcon() {
	            try {
	                return __webpack_require__(79);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this.setState({ modalIsOpen: !this.state.modalIsOpen });
	        }
	    }, {
	        key: 'handleAddFieldButton',
	        value: function handleAddFieldButton() {
	            var data = this.props.data;
	
	            this.openModal();
	            data.addField({ licenceCategory: "B", licenceDate: "", uniqueId: (0, _uuidV42['default'])() });
	        }
	    }, {
	        key: 'removeItemFromList',
	        value: function removeItemFromList(itemUniqueId) {
	            var data = this.props.data;
	
	            Object.keys(data).map(function (dataKey) {
	                if (data[dataKey] && data[dataKey] !== undefined && data[dataKey].uniqueId.value === itemUniqueId) {
	                    data.removeField(dataKey);
	                }
	            });
	        }
	    }, {
	        key: 'removeItem',
	        value: function removeItem() {
	            var data = this.props.data;
	            data.removeField();
	        }
	    }, {
	        key: 'modalContentPopup',
	        value: function modalContentPopup() {
	            var _this = this;
	
	            var data = this.props.data;
	
	            var lastLicence = data.slice(-1)[0];
	            var errorData = true;
	
	            if (lastLicence != undefined) {
	                if (lastLicence.licenceCategory.error != undefined) {
	                    errorData = true;
	                } else {
	                    errorData = false;
	                }
	
	                if (lastLicence.licenceDate.error != undefined) {
	                    errorData = true;
	                } else {
	                    errorData = false;
	                }
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].clientModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _listSelectScss2['default'].title },
	                    _("addLicense")
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('category')
	                ),
	                lastLicence != undefined && _react2['default'].createElement(_sharedSelectSelectWrap2['default'], _extends({}, lastLicence.licenceCategory, {
	                    value: lastLicence.licenceCategory.value,
	                    onChange: lastLicence.licenceCategory.onChange, // eslint-disable-line react/jsx-handler-names
	                    options: this.props.selectCategoryOptions
	                })),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    ' ',
	                    lastLicence != undefined && lastLicence.licenceCategory.error && lastLicence.licenceCategory.touched && lastLicence.licenceCategory.error,
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].datepickerLabelField },
	                    _react2['default'].createElement(
	                        'label',
	                        null,
	                        _('dateObtained')
	                    ),
	                    lastLicence != undefined && _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, lastLicence.licenceDate),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _listSelectScss2['default'].error },
	                        ' ',
	                        lastLicence != undefined && lastLicence.licenceDate.error && lastLicence.licenceDate.touched && lastLicence.licenceDate.error,
	                        ' '
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientModalButtons },
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this.openModal();
	                            _this.removeItem();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].cancel,
	                        value: _("cancel")
	                    }),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            return _this.openModal();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].next + " " + (!errorData && _listSelectScss2['default'].enabled),
	                        value: _("clientAdd"),
	                        disabled: errorData
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var data = this.props.data;
	            var modalIsOpen = this.state.modalIsOpen;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].moduleSection },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientsTableContainer },
	                    !_underscore2['default'].isEmpty(data) && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            className: _listSelectScss2['default'].table,
	                            itemsPerPage: 50,
	                            topPagination: '',
	                            filterable: [],
	                            sortable: ["licenceCategory.value", "licenceDate.value"],
	                            defaultSort: {
	                                column: 'licenceDate.value',
	                                direction: 'asc'
	                            }
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'licenceCategory.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('category')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'licenceDate.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('dateObtained')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'checkEmail' },
	                                _react2['default'].createElement('strong', null)
	                            )
	                        ),
	                        data.map(function (item, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { className: 'centered', key: item.uniqueId.value },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'licenceCategory.value' },
	                                    item.licenceCategory.value
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'licenceDate.value' },
	                                    (0, _libHelpers.dateFormatter)(item.licenceDate.value)
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'checkEmail' },
	                                    _react2['default'].createElement(
	                                        'button',
	                                        { type: 'button', className: _listSelectScss2['default'].removeFieldsButton, onClick: function (event) {
	                                                event.preventDefault();
	                                                _this2.removeItemFromList(item.uniqueId.value);
	                                            } },
	                                        _react2['default'].createElement('img', { src: _this2.getIcon() })
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'button',
	                            className: _listSelectScss2['default'].addFieldButton,
	                            onClick: function () {
	                                _this2.handleAddFieldButton();
	                            } },
	                        '+'
	                    )
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        style: customStyles,
	                        contentLabel: 'Modal'
	                    },
	                    this.modalContentPopup()
	                )
	            );
	        }
	    }]);
	
	    return LicensesListSelect;
	})(_react2['default'].Component);
	
	exports['default'] = LicensesListSelect;
	module.exports = exports['default'];

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactGa = __webpack_require__(212);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _linksScss = __webpack_require__(1612);
	
	var _linksScss2 = _interopRequireDefault(_linksScss);
	
	var _categories = __webpack_require__(603);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _elementsFilterInput = __webpack_require__(613);
	
	var _elementsFilterInput2 = _interopRequireDefault(_elementsFilterInput);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('links');
	
	var Links = (function (_React$Component) {
		_inherits(Links, _React$Component);
	
		function Links() {
			_classCallCheck(this, _Links);
	
			_get(Object.getPrototypeOf(_Links.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Links, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.update();
			}
		}, {
			key: 'update',
			value: function update() {
				this.props.getLinks();
			}
		}, {
			key: 'orderItems',
			value: function orderItems(items) {
				var cats = {};
				items.forEach(function (item) {
					var categoryId = item.categoryId;
					var text = item.text;
					var href = item.href;
	
					if (!cats[categoryId]) {
						cats[categoryId] = [];
					}
					cats[categoryId].push({ text: text, href: href });
				});
				return Object.keys(cats).map(function (categoryId) {
					var sortCats = (0, _lodashCollection.sortBy)(cats[categoryId], function (cat) {
						return cat.text.toLowerCase().replace(/\s+/g, '');
					});
					return { categoryId: categoryId, content: sortCats };
				});
			}
		}, {
			key: 'linkClicked',
			value: function linkClicked(link) {
				_reactGa2['default'].event({
					category: "External link",
					action: 'Redirected to ' + link
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var items = _props.items;
				var filter = _props.filter;
				var setLinksFilter = _props.setLinksFilter;
	
				var itemsId = items.map(function (m, i) {
					return _extends({}, m, { id: i });
				});
				var lowerFilter = filter.toLowerCase();
				var filteredItems = filter ? itemsId.filter(function (item) {
					return item.text.toLowerCase().includes(lowerFilter);
				}) : itemsId;
				var theItems = this.orderItems(filteredItems);
				return _react2['default'].createElement(
					'div',
					{ id: '' + _linksScss2['default'].linksModule },
					_react2['default'].createElement(
						'div',
						{ className: '' + _linksScss2['default'].mainSubDiv },
						_react2['default'].createElement(
							'div',
							{ className: _linksScss2['default'].mainTitleDiv + ' ' + _linksScss2['default'].bottomBorder },
							_react2['default'].createElement(
								'div',
								{ className: '' + _linksScss2['default'].mainTitleContainer },
								_react2['default'].createElement(
									'h2',
									{ className: '' + _linksScss2['default'].mainTitle },
									_('title')
								),
								_react2['default'].createElement(
									'h3',
									null,
									_('subtitle')
								)
							),
							_react2['default'].createElement(_elementsFilterInput2['default'], { filter: filter, setFilter: setLinksFilter })
						),
						_react2['default'].createElement(
							'div',
							null,
							theItems.map(function (item, i) {
								return _react2['default'].createElement(
									'div',
									{ key: 'cat' + i, className: '' + _linksScss2['default'].link },
									_react2['default'].createElement(
										'div',
										{ className: '' + _linksScss2['default'].text },
										_react2['default'].createElement(_categories2['default'], { plain: true, id: item.categoryId })
									),
									_react2['default'].createElement(
										'div',
										{ className: '' + _linksScss2['default'].content },
										item.content.map(function (link, i) {
											return _react2['default'].createElement(
												'div',
												{ key: i, className: '' + _linksScss2['default'].ref },
												_react2['default'].createElement(
													'a',
													{ href: link.href, target: '_blank', onClick: function () {
															return _this.linkClicked(link.href);
														}, rel: 'noopener noreferrer' },
													link.text,
													_react2['default'].createElement(
														'span',
														{ className: '' + _linksScss2['default'].textLink },
														link.href
													)
												)
											);
										})
									)
								);
							})
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				items: _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.object).isRequired,
				filter: _react2['default'].PropTypes.string.isRequired
			},
			enumerable: true
		}]);
	
		var _Links = Links;
		Links = (0, _reactRedux.connect)(function (state) {
			return {
				items: state.links.items,
				filter: state.links.filter
			};
		}, { getLinks: _stateActions.getLinks, setLinksFilter: _stateActions.setLinksFilter })(Links) || Links;
		return Links;
	})(_react2['default'].Component);
	
	exports['default'] = Links;
	module.exports = exports['default'];

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loaderScss = __webpack_require__(1613);
	
	var _loaderScss2 = _interopRequireDefault(_loaderScss);
	
	var Loader = (function (_React$Component) {
		_inherits(Loader, _React$Component);
	
		function Loader(props) {
			_classCallCheck(this, Loader);
	
			_get(Object.getPrototypeOf(Loader.prototype), 'constructor', this).call(this, props);
			this.state = {
				display: 'none'
			};
		}
	
		_createClass(Loader, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this = this;
	
				this.timer = setTimeout(function () {
					return _this.setState({ display: 'block' });
				}, 250);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearTimeout(this.timer);
			}
		}, {
			key: 'render',
			value: function render() {
				var display = this.state.display;
	
				return _react2['default'].createElement(
					'div',
					{ style: { display: display }, className: _loaderScss2['default'].loaderWrapper },
					_react2['default'].createElement(
						'div',
						{ className: _loaderScss2['default'].spinner },
						_react2['default'].createElement('div', { className: _loaderScss2['default'].dot1 }),
						_react2['default'].createElement('div', { className: _loaderScss2['default'].dot2 })
					)
				);
			}
		}]);
	
		return Loader;
	})(_react2['default'].Component);
	
	exports['default'] = Loader;
	module.exports = exports['default'];

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	/* globals isClient DEBUG */
	// rc-tooltip
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createDecoratedClass = (function () { function defineProperties(target, descriptors, initializers) { for (var i = 0; i < descriptors.length; i++) { var descriptor = descriptors[i]; var decorators = descriptor.decorators; var key = descriptor.key; delete descriptor.key; delete descriptor.decorators; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor || descriptor.initializer) descriptor.writable = true; if (decorators) { for (var f = 0; f < decorators.length; f++) { var decorator = decorators[f]; if (typeof decorator === 'function') { descriptor = decorator(target, key, descriptor) || descriptor; } else { throw new TypeError('The decorator for method ' + descriptor.key + ' is of the invalid type ' + typeof decorator); } } if (descriptor.initializer !== undefined) { initializers[key] = descriptor; continue; } } Object.defineProperty(target, key, descriptor); } } return function (Constructor, protoProps, staticProps, protoInitializers, staticInitializers) { if (protoProps) defineProperties(Constructor.prototype, protoProps, protoInitializers); if (staticProps) defineProperties(Constructor, staticProps, staticInitializers); return Constructor; }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1575);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mainScss = __webpack_require__(1614);
	
	var _mainScss2 = _interopRequireDefault(_mainScss);
	
	var _stateLocation = __webpack_require__(618);
	
	var _stateConstants = __webpack_require__(11);
	
	var _reactHelmet = __webpack_require__(2035);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _loader = __webpack_require__(1109);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CookieBar = __webpack_require__(1039);
	
	var _CookieBar2 = _interopRequireDefault(_CookieBar);
	
	var _authAuth = __webpack_require__(1056);
	
	var _authAuth2 = _interopRequireDefault(_authAuth);
	
	var _reactGa = __webpack_require__(212);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _reactKeydown = __webpack_require__(2047);
	
	var _reactKeydown2 = _interopRequireDefault(_reactKeydown);
	
	var _elementsGrail = __webpack_require__(220);
	
	var _elementsGrail2 = _interopRequireDefault(_elementsGrail);
	
	var _reactNotificationSystem = __webpack_require__(2071);
	
	var _reactNotificationSystem2 = _interopRequireDefault(_reactNotificationSystem);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _privacyPrivacy = __webpack_require__(1140);
	
	var _privacyPrivacy2 = _interopRequireDefault(_privacyPrivacy);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _generalComponentsInfoModal = __webpack_require__(369);
	
	var _generalComponentsInfoModal2 = _interopRequireDefault(_generalComponentsInfoModal);
	
	var _mainComponentsHeader = __webpack_require__(1111);
	
	var _mainComponentsHeader2 = _interopRequireDefault(_mainComponentsHeader);
	
	var _stateActions = __webpack_require__(5);
	
	var _ = (0, _libI18n2['default'])('clientZoom');
	
	var Sidebar =  false ? require('./mainComponents/sidebarMyeasinsure') : __webpack_require__(1113);
	var MetroUI =  false ? null : __webpack_require__(1114);
	var Content =  false ? null : __webpack_require__(1094);
	var ClientMain =  false ? require('./Easinsure') : null;
	
	// Remove false to get accessability warnings
	if (false) {
		// eslint-disable-line no-constant-condition
		var a11y = require('react-a11y');
		a11y(_react2['default']);
	}
	
	var customStyles = {
		overlay: {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: 'rgba(255, 255, 255, 0.75)',
			zIndex: 2
		},
		content: {
			position: 'relative',
			top: 'initial',
			bottom: 'initial',
			left: 'initial',
			right: 'initial',
			maxHeight: '90%',
			overflow: 'auto',
			padding: '1em'
		}
	};
	
	var Main = (function (_React$Component) {
		_inherits(Main, _React$Component);
	
		_createClass(Main, null, [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				module: _react2['default'].PropTypes.string,
				isPhone: _react2['default'].PropTypes.bool,
				isTablet: _react2['default'].PropTypes.bool,
				isLoggedIn: _react2['default'].PropTypes.bool.isRequired,
				authState: _react2['default'].PropTypes.string,
				resetPassword: _react2['default'].PropTypes.bool,
				loading: _react2['default'].PropTypes.number.isRequired,
				menuCollapsed: _react2['default'].PropTypes.bool,
				subMenuCollapsed: _react2['default'].PropTypes.bool,
				backButton: _react2['default'].PropTypes.bool.isRequired,
				emailSenderIsOpen: _react2['default'].PropTypes.bool.isRequired,
				onClick: _react2['default'].PropTypes.func,
				okCookies: _react2['default'].PropTypes.bool
			},
			enumerable: true
		}]);
	
		function Main(props) {
			var _this = this;
	
			_classCallCheck(this, _Main);
	
			_get(Object.getPrototypeOf(_Main.prototype), 'constructor', this).call(this, props);
	
			this.handleItemClicked = function (name, fromMetroUI, isSubmenuItem) {
				var submenuItem = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
				var _props = _this.props;
				var dispatch = _props.dispatch;
				var isPhone = _props.isPhone;
				var isTablet = _props.isTablet;
				var menuCollapsed = _props.menuCollapsed;
				var clientProfileFormStatus = _props.clientProfileFormStatus;
	
				var module = _stateLocation.locs[name];
				var modalIsOpen = _this.state.modalIsOpen;
	
				if (clientProfileFormStatus != undefined && _this.props.module != undefined && _this.props.module == _stateConstants.CLIENTS && clientProfileFormStatus == false && _this.props.subModule == 'edit-profile') {
					var currentItemOptions = {
						name: name,
						fromMetroUI: fromMetroUI,
						isSubmenuItem: isSubmenuItem,
						submenuItem: submenuItem,
						insideModulePage: 'client'
					};
	
					_this.setState({ navigationData: currentItemOptions });
					_this.openModal();
				} else if (clientProfileFormStatus != undefined && _this.props.module != undefined && clientProfileFormStatus == false && _this.props.subModuleB2B == 'edit-profile' && (_this.props.module == 'B2B' || _this.props.module == 'insuranceCompany2321' || _this.props.module == 'insuranceCompany2320')) {
					var currentItemOptions = {
						name: name,
						fromMetroUI: fromMetroUI,
						isSubmenuItem: isSubmenuItem,
						submenuItem: submenuItem,
						insideModulePage: 'b2b'
					};
	
					_this.setState({ navigationData: currentItemOptions });
					_this.openModal();
				} else {
					if ((isPhone || isTablet) && !menuCollapsed) {
						dispatch((0, _stateActions.toggleMenu)());
					}
	
					if (isSubmenuItem) {
						dispatch((0, _stateActions.setB2BInsuranceCompany)({ companyId: submenuItem.dataCargo, insuranceCompany: submenuItem.menuLabel } || false));
					}
	
					// If you come from metroUi and instantly need to open the b2b submenu
					dispatch((0, _stateActions.toggleSubMenu)(Boolean(fromMetroUI) && name === 'b2b' || isSubmenuItem || false));
					dispatch((0, _stateActions.setAppModule)(module));
				}
			};
	
			this.handleToggleSubmenu = function (name) {
				var _props2 = _this.props;
				var dispatch = _props2.dispatch;
				var subMenuCollapsed = _props2.subMenuCollapsed;
	
				var module = _stateLocation.locs[name];
				dispatch((0, _stateActions.toggleSubMenu)());
				dispatch((0, _stateActions.setAppModule)(module));
			};
	
			this.handleMetroItemClicked = function (name) {
				_this.handleItemClicked(name, true);
			};
	
			this.goToMetro = function () {
				_this.handleItemClicked(null);
			};
	
			this.handleBackClicked = function () {
				_this.props.dispatch((0, _stateActions.setOpened)());
				_this.props.dispatch((0, _stateActions.setB2bCompanyOpened)());
			};
	
			this.handleFlashClicked = function (id) {
				_this.props.dispatch((0, _stateActions.setAppModule)(_stateConstants.NEWS, id));
			};
	
			this.handleLogout = function () {
				_this.props.dispatch((0, _stateActions.logout)());
			};
	
			this.toggleMenu = function () {
				_this.props.dispatch((0, _stateActions.toggleMenu)());
			};
	
			this.handleAcceptCookies = function () {
				_this.props.dispatch((0, _stateActions.acceptCookies)());
			};
	
			this.prevModule = "start";
			this.state = { modalIsOpen: false, navigationData: { name: '', fromMetroUI: '', isSubmenuItem: '', submenuItem: false, module: '' } };
		}
	
		_createDecoratedClass(Main, [{
			key: 'openModal',
			value: function openModal() {
				this.setState({ modalIsOpen: !this.state.modalIsOpen });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mountOrUpdateStuff();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.mountOrUpdateStuff();
			}
		}, {
			key: 'mountOrUpdateStuff',
			value: function mountOrUpdateStuff() {
				var _props3 = this.props;
				var module = _props3.module;
				var notification = _props3.notification;
				var resetPassword = _props3.resetPassword;
				var okCookies = _props3.okCookies;
				var dispatch = _props3.dispatch;
	
				if (resetPassword === true) {
					dispatch((0, _stateActions.changeAuthState)('passwordChange'));
				}
	
				var gaModule = module || 'metroUI';
				if (this.prevModule !== gaModule) {
					_reactGa2['default'].pageview(gaModule);
					this.prevModule = gaModule;
				}
	
				if (notification) {
					this.addNotification(notification);
					dispatch((0, _stateActions.clearNotification)());
				}
	
				if (okCookies) {
					dispatch((0, _stateActions.validateCookie)());
				}
			}
	
			/**
	   * This function handle a click on menu items, switch module in general.
	   */
		}, {
			key: 'leaveModal',
			value: function leaveModal() {
				var _props4 = this.props;
				var dispatch = _props4.dispatch;
				var isPhone = _props4.isPhone;
				var isTablet = _props4.isTablet;
				var menuCollapsed = _props4.menuCollapsed;
				var clientProfileFormStatus = _props4.clientProfileFormStatus;
				var _state$navigationData = this.state.navigationData;
				var name = _state$navigationData.name;
				var fromMetroUI = _state$navigationData.fromMetroUI;
				var isSubmenuItem = _state$navigationData.isSubmenuItem;
				var submenuItem = _state$navigationData.submenuItem;
				var insideModulePage = _state$navigationData.insideModulePage;
	
				var module = _stateLocation.locs[name];
	
				if (insideModulePage == 'client') {
					dispatch((0, _stateActions.setClientSubModule)(''));
				}
	
				if (insideModulePage == 'b2b') {
					dispatch((0, _stateActions.setB2bCompanySubModule)(''));
				}
	
				if ((isPhone || isTablet) && !menuCollapsed) {
					dispatch((0, _stateActions.toggleMenu)());
				}
	
				if (isSubmenuItem) {
					dispatch((0, _stateActions.setB2BInsuranceCompany)({ companyId: submenuItem.dataCargo, insuranceCompany: submenuItem.menuLabel } || false));
				}
	
				// If you come from metroUi and instantly need to open the b2b submenu
				dispatch((0, _stateActions.toggleSubMenu)(Boolean(fromMetroUI) && name === 'b2b' || isSubmenuItem || false));
				dispatch((0, _stateActions.setAppModule)(module));
	
				this.setState({ navigationData: { name: '', fromMetroUI: '', isSubmenuItem: '', submenuItem: false } });
	
				this.openModal();
			}
	
			// for opening submenu in sidebar
		}, {
			key: 'submit',
			decorators: [(0, _reactKeydown2['default'])(27)],
			value: function submit(event) {
				// prevent back in special cases
				if (!this.props.backButton || this.props.emailSenderIsOpen || this.props.module === _stateConstants.OFFICE) {
					return;
				}
	
				event.preventDefault();
				this.props.dispatch((0, _stateActions.setOpened)());
				this.props.dispatch((0, _stateActions.setB2bCompanyOpened)());
			}
		}, {
			key: 'addNotification',
			value: function addNotification(_ref) {
				var msg = _ref.msg;
				var nType = _ref.nType;
	
				this.notificationSystem.addNotification({
					message: msg,
					level: nType
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props5 = this.props;
				var onClick = _props5.onClick;
				var module = _props5.module;
				var loading = _props5.loading;
				var isLoggedIn = _props5.isLoggedIn;
				var authState = _props5.authState;
				var menuCollapsed = _props5.menuCollapsed;
				var subMenuCollapsed = _props5.subMenuCollapsed;
				var isPhone = _props5.isPhone;
				var isTablet = _props5.isTablet;
				var backButton = _props5.backButton;
				var redrawMe = _props5.redrawMe;
				var okCookies = _props5.okCookies;
				var versionCheckNotification = _props5.versionCheckNotification;
	
				var menuActive = !menuCollapsed;
				var modalIsOpen = this.state.modalIsOpen;
	
				var showSidebar = Boolean( /**(isClient && (isPhone || isTablet)) ||**/!(false) && isLoggedIn && module && (!isPhone || !isTablet || menuActive));
	
				var content = undefined;
	
				if (module == _stateConstants.PRIVACY) {
					content = _react2['default'].createElement(_privacyPrivacy2['default'], null);
				} else {
					if (!isLoggedIn || authState === "passwordChange") {
						content = _react2['default'].createElement(_authAuth2['default'], null);
					} else {
						if (false) {
							content = _react2['default'].createElement(ClientMain, null);
						} else {
							if (module) {
								content = _react2['default'].createElement(Content, {
									onLinkClicked: this.handleItemClicked,
									onBackClicked: this.handleBackClicked
								});
							} else {
								content = _react2['default'].createElement(MetroUI, {
									onFlashClicked: this.handleFlashClicked,
									onLinkClicked: this.handleMetroItemClicked,
									onLogout: this.handleLogout
								});
							}
						}
					}
				}
	
				var nav = showSidebar && _react2['default'].createElement(Sidebar, {
					onLinkClicked: this.handleItemClicked,
					onLogout: this.handleLogout,
					onSubmenuClick: this.handleToggleSubmenu,
					subMenuCollapsed: subMenuCollapsed
				});
	
				/**
	                let header = isLoggedIn ? (
	               !isClient && isPhone && isLoggedIn && module && (
	                   <PhoneHeaderDom
	                       {...{
	                           backButton,
	                           menuActive,
	                           onHome: this.goToMetro,
	                           onBack: this.handleBackClicked,
	                           onMenu: this.toggleMenu,
	                       }}
	                   />
	               )
	           ) : (
	               <UpdateBar/>
	           )
	     */
	
				// !!! IMPORTANT NOTE !!! the reason why is destructured a newly created object to give the values as props is
				// that if you give a prop like isPhone, that means a true inside the component, but if you give a prop like
				// isPhone={isPhone} that forward the value of the isPhone variabel inside the component
				// alernative way to do that: isPhone={isPhone} isClient={isClient} isLoggedIn={isLoggedIn} module={module} etc...
				var header = _react2['default'].createElement(_mainComponentsHeader2['default'], {
					isLoggedIn: isLoggedIn,
					isClient: (false),
					isPhone: isPhone,
					isTablet: isTablet,
					module: module,
					backButton: backButton,
					menuActive: menuActive,
					onHome: function onHome() {
						return _this2.goToMetro();
					},
					onBack: function onBack() {
						return _this2.handleBackClicked();
					},
					onMenu: function onMenu() {
						return _this2.toggleMenu();
					}
				});
	
				var footer = !okCookies && _react2['default'].createElement(_CookieBar2['default'], { handleAcceptCookies: this.handleAcceptCookies });
	
				//----------------------------
				//test data
				var informModalOpen = true;
	
				return _react2['default'].createElement(
					_elementsGrail2['default'],
					_extends({
						stretch: true,
						key: redrawMe,
						onClick: onClick
					}, { header: header, nav: nav, footer: footer }),
					_react2['default'].createElement(
						'div',
						{ className: _mainScss2['default'].wrapApp },
						_react2['default'].createElement(_reactHelmet2['default'], { title:  false ? "My Easinsure" : "Willemot" }),
						loading > 0 && _react2['default'].createElement(_loader2['default'], null),
						_react2['default'].createElement(_reactNotificationSystem2['default'], { ref: function (el) {
								_this2.notificationSystem = el;
							} }),
						content,
						_react2['default'].createElement(
							_reactModal2['default'],
							{
								isOpen: modalIsOpen,
								style: customStyles,
								contentLabel: 'Modal'
							},
							_react2['default'].createElement(
								'div',
								{ className: _mainScss2['default'].verifyModalContent },
								_react2['default'].createElement(
									'span',
									{ className: _mainScss2['default'].title },
									_('clientProfileLeavePopup')
								),
								_react2['default'].createElement(
									'span',
									{ className: _mainScss2['default'].message },
									_('clientProfileLeavePopupMessage')
								),
								_react2['default'].createElement(
									'div',
									{ className: _mainScss2['default'].verifyModalButtons },
									_react2['default'].createElement(
										'span',
										{
											onClick: function () {
												return _this2.openModal();
											},
											className: _mainScss2['default'].cancel
										},
										_("cancel")
									),
									_react2['default'].createElement('input', {
										onClick: function () {
											return _this2.leaveModal();
										},
										type: 'button',
										className: _mainScss2['default'].greyButton + " enabled",
										value: _("clientProfileLeaveOkButton")
									})
								)
							)
						),
						_react2['default'].createElement(_generalComponentsInfoModal2['default'], {
							isOpen: Boolean(versionCheckNotification.isOpened),
							style: customStyles,
							title: versionCheckNotification.title,
							content: versionCheckNotification.msg,
							onCancel: function () {},
							onConfirmation: function () {
								_this2.props.dispatch((0, _stateActions.setVersionCheckNotification)(false));
								_this2.props.dispatch((0, _stateActions.setAppModule)());
								_this2.props.dispatch((0, _stateActions.logout)());
							},
							cancelLabel: _("cancel"),
							confirmationLabel: _("ok"),
							options: { noCancelButton: true }
						})
					)
				);
			}
		}]);
	
		var _Main = Main;
		Main = (0, _reactRedux.connect)(function (_ref2) {
			var app = _ref2.app;
			var responsive = _ref2.responsive;
			var auth = _ref2.auth;
			var dict = _ref2.dict;
			var categories = _ref2.categories;
			var sources = _ref2.sources;
			var clientProfileForm = _ref2.clientProfileForm;
			var clients = _ref2.clients;
			var b2bCompany = _ref2.b2bCompany;
			var emailSender = _ref2.emailSender;
			return {
				module: app.module,
				redrawMe: app.lang + dict._gen + categories._gen + sources._gen,
				loading: app.loading,
				isLoggedIn: auth.isLoggedIn,
				resetPassword: app.resetPassword,
				authState: auth.authState,
				menuCollapsed: app.menuCollapsed,
				subMenuCollapsed: app.subMenuCollapsed,
				isPhone: responsive.isPhone,
				isTablet: responsive.isTablet,
				backButton: Boolean(app.opened),
				emailSenderIsOpen: Boolean(emailSender.emailModalIsOpen),
				okCookies: Boolean(auth.cookiesAccepted),
				notification: app.notification,
				clientProfileFormStatus: clientProfileForm.formStatus.sent,
				subModule: clients.subModule,
				subModuleB2B: b2bCompany.subModule,
				versionCheckNotification: app.versionCheckNotification
			};
		})(Main) || Main;
		return Main;
	})(_react2['default'].Component);
	
	exports['default'] = Main;
	module.exports = exports['default'];

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable import/no-extraneous-dependencies */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _resourcesBackSvg = __webpack_require__(2259);
	
	var _resourcesBackSvg2 = _interopRequireDefault(_resourcesBackSvg);
	
	var _resourcesImagesClose_2xPng = __webpack_require__(533);
	
	var _resourcesImagesClose_2xPng2 = _interopRequireDefault(_resourcesImagesClose_2xPng);
	
	var _resourcesImagesMenu_2xPng = __webpack_require__(587);
	
	var _resourcesImagesMenu_2xPng2 = _interopRequireDefault(_resourcesImagesMenu_2xPng);
	
	var _resourcesImagesBE_Logo_OVB_Willemot_WhiteSvg = __webpack_require__(354);
	
	var _resourcesImagesBE_Logo_OVB_Willemot_WhiteSvg2 = _interopRequireDefault(_resourcesImagesBE_Logo_OVB_Willemot_WhiteSvg);
	
	var _resourcesEasinsureEasinsureLogotypeSvg = __webpack_require__(2261);
	
	var _resourcesEasinsureEasinsureLogotypeSvg2 = _interopRequireDefault(_resourcesEasinsureEasinsureLogotypeSvg);
	
	var _UpdateBar = __webpack_require__(1112);
	
	var _UpdateBar2 = _interopRequireDefault(_UpdateBar);
	
	var _HeaderScss = __webpack_require__(1615);
	
	var _HeaderScss2 = _interopRequireDefault(_HeaderScss);
	
	var Header = function Header(_ref) {
	    var isLoggedIn = _ref.isLoggedIn;
	    var isPhone = _ref.isPhone;
	    var isTablet = _ref.isTablet;
	    var isClient = _ref.isClient;
	    var backButton = _ref.backButton;
	
	    var props = _objectWithoutProperties(_ref, ['isLoggedIn', 'isPhone', 'isTablet', 'isClient', 'backButton']);
	
	    if (!isLoggedIn) {
	        return _react2['default'].createElement(_UpdateBar2['default'], null);
	    }
	
	    if (!isPhone && !isTablet) {
	        return null; // no header on desktop
	    }
	
	    return _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(_HeaderScss2['default'].mobileHeader, isClient ? _HeaderScss2['default'].myEasinsure : _HeaderScss2['default'].willBroker, props.className) },
	        backButton && _react2['default'].createElement(
	            'div',
	            { className: _HeaderScss2['default'].backBtn, onClick: props.onBack },
	            _react2['default'].createElement('img', { src: _resourcesBackSvg2['default'] }),
	            'Back'
	        ),
	        isClient ? _react2['default'].createElement(
	            'div',
	            { className: _HeaderScss2['default'].brandEasinsure },
	            _react2['default'].createElement('img', { className: _HeaderScss2['default'].logo, src: _resourcesEasinsureEasinsureLogotypeSvg2['default'] })
	        ) : _react2['default'].createElement(
	            'div',
	            { className: _HeaderScss2['default'].brandWillemot },
	            _react2['default'].createElement(
	                'div',
	                { className: _HeaderScss2['default'].menu, onClick: props.onMenu },
	                _react2['default'].createElement('img', { src: props.menuActive ? _resourcesImagesClose_2xPng2['default'] : _resourcesImagesMenu_2xPng2['default'] }),
	                ' ',
	                'Menu'
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: _HeaderScss2['default'].logo },
	                _react2['default'].createElement('img', { onClick: props.onHome, src: _resourcesImagesBE_Logo_OVB_Willemot_WhiteSvg2['default'] })
	            )
	        )
	    );
	};
	Header.propTypes = {
	    menuActive: _react.PropTypes.bool,
	    isLoggedIn: _react.PropTypes.bool,
	    isPhone: _react.PropTypes.bool,
	    isTablet: _react.PropTypes.bool,
	    isClient: _react.PropTypes.bool, // props comes from environment ??
	    backButton: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    onBack: _react.PropTypes.func,
	    onMenu: _react.PropTypes.func,
	    onHome: _react.PropTypes.func
	};
	
	exports['default'] = Header;
	module.exports = exports['default'];

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _detectBrowser = __webpack_require__(1551);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	var _elementsBanner = __webpack_require__(612);
	
	var _elementsBanner2 = _interopRequireDefault(_elementsBanner);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('updateBar');
	
	// Force updating after translations loaded
	
	var UpdateBar = (function (_React$Component) {
		_inherits(UpdateBar, _React$Component);
	
		function UpdateBar() {
			_classCallCheck(this, _UpdateBar);
	
			_get(Object.getPrototypeOf(_UpdateBar.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(UpdateBar, [{
			key: 'render',
			value: function render() {
				var browser = _detectBrowser2['default'].name;
				var version = _detectBrowser2['default'].version.split('.')[0];
				var links = [{
					label: "chrome",
					minVersion: 45,
					value: "https://www.google.com/chrome/browser/desktop/"
				}, {
					label: "firefox",
					minVersion: 43,
					value: "https://www.mozilla.org/en-US/firefox/new/"
				}, {
					label: "ie",
					minVersion: 11,
					value: "http://windows.microsoft.com/en-us/internet-explorer/download-ie"
				}, {
					label: "safari",
					minVersion: 5,
					value: "https://support.apple.com/downloads/#safari"
				}, {
					label: "opera",
					minVersion: 34,
					value: "http://www.opera.com/download"
				}];
				var shouldUpdate = links.find(function (o) {
					return o.label === browser && o.minVersion > version;
				});
				if (!shouldUpdate) {
					return false;
				}
				var destination = shouldUpdate && shouldUpdate.value;
	
				return _react2['default'].createElement(_elementsBanner2['default'], {
					handleclick: null,
					destination: destination,
					bold: _('bold'),
					beforeLink: _('beforeLink'),
					afterLink: _('afterLink'),
					link: _('link')
				});
			}
		}]);
	
		var _UpdateBar = UpdateBar;
		UpdateBar = (0, _reactRedux.connect)(function (_ref) {
			var dict = _ref.dict;
			return { dict: dict };
		})(UpdateBar) || UpdateBar;
		return UpdateBar;
	})(_react2['default'].Component);
	
	exports['default'] = UpdateBar;
	module.exports = exports['default'];

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _sidebarScss = __webpack_require__(1616);
	
	var _sidebarScss2 = _interopRequireDefault(_sidebarScss);
	
	var _disclaimer = __webpack_require__(391);
	
	var _disclaimer2 = _interopRequireDefault(_disclaimer);
	
	var _stateActions = __webpack_require__(5);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('sidebar');
	
	var Sidebar = (function (_Component) {
		_inherits(Sidebar, _Component);
	
		function Sidebar() {
			var _this = this;
	
			_classCallCheck(this, _Sidebar);
	
			_get(Object.getPrototypeOf(_Sidebar.prototype), 'constructor', this).apply(this, arguments);
	
			this.MenuItemDom = function (_ref) {
				var item = _ref.item;
				var onClick = _ref.onClick;
				var _onSubmenuClick = _ref.onSubmenuClick;
				var _ref$hasParent = _ref.hasParent;
				var hasParent = _ref$hasParent === undefined ? false : _ref$hasParent;
				var _ref$key = _ref.key;
				var key = _ref$key === undefined ? 0 : _ref$key;
				var _props = _this.props;
				var isPhone = _props.isPhone;
				var isTablet = _props.isTablet;
				var unreadCount = _props.unreadCount;
				var taskCount = _props.taskCount;
				var outboxFailedCount = _props.outboxFailedCount;
				var subMenuCollapsed = _props.subMenuCollapsed;
				var onLinkClicked = _props.onLinkClicked;
	
				var isActive = _this.isActiveItem(item);
				var name = _this.getMenuName(item);
				var count = _this.getCountIndicatorValue(item);
				var isCollapsed = Boolean(subMenuCollapsed) ? false : true;
				var childrens = _underscore2['default'].isEmpty(item.childrens) ? [] : item.childrens;
				var icon = _this.getIcon(item.menuName);
	
				return _react2['default'].createElement("li", {
					key: key,
					onClick: !_underscore2['default'].isEmpty(childrens) ? _onSubmenuClick : function (e) {
						return onClick(e, hasParent);
					},
					className: (0, _classnames2['default'])(_sidebarScss2['default'].linkWrapper, _sidebarScss2['default'][item.menuName], isActive && _sidebarScss2['default'].active)
				}, _react2['default'].createElement(
					'div',
					{ className: (0, _classnames2['default'])(_sidebarScss2['default'].link) },
					_react2['default'].createElement('img', { src: icon }),
					_react2['default'].createElement(
						'span',
						{ className: (0, _classnames2['default'])(_sidebarScss2['default'].menuTitle, (isPhone || isTablet) && _sidebarScss2['default'].extraStyle) },
						name
					),
					count > 0 && _react2['default'].createElement(
						'div',
						{ className: _sidebarScss2['default'].inboxCounter },
						count
					)
				), !isCollapsed && !_underscore2['default'].isEmpty(childrens) && _underscore2['default'].isArray(childrens) ? _react2['default'].createElement(
					'ul',
					{ className: (0, _classnames2['default'])(_sidebarScss2['default'].linkWrapper, _sidebarScss2['default'].isParentMenuContent) },
					childrens.map(function (subItem, i) {
						return _this.MenuItemDom({
							item: subItem,
							key: key + "_" + i,
							onClick: function onClick(e, hasParent) {
								e.stopPropagation();onLinkClicked(subItem.menuName, false, hasParent, subItem || null);
							},
							onSubmenuClick: function onSubmenuClick() {
								_onSubmenuClick(subItem.menuName);
							},
							hasParent: true
						});
					})
				) : null);
			};
	
			this.handleToggle = function () {
				return _this.props.toggleMenu();
			};
	
			this.getIcon = function (menuName) {
				try {
					return __webpack_require__(262)("./icn-" + menuName + '.svg');
				} catch (err) {
					return __webpack_require__(23);
				}
			};
	
			this.getContainerClassNames = function () {
				return (0, _classnames2['default'])(_sidebarScss2['default'].sidebarContainer, (_this.props.isPhone || _this.props.isTablet) && _sidebarScss2['default'].mobile, _this.props.menuCollapsed ? _sidebarScss2['default'].collapsed : _sidebarScss2['default'].opened, _this.props.className);
			};
	
			this.getLogoImg = function () {
				return _this.props.menuCollapsed ? _react2['default'].createElement('img', { src: __webpack_require__(354) }) : _react2['default'].createElement('img', { src: __webpack_require__(171) });
			};
	
			this.getLogoElement = function () {
				return _react2['default'].createElement(
					'div',
					{ onClick: function () {
							return _this.props.onLinkClicked(null);
						}, className: _sidebarScss2['default'].navLogo },
					_this.getLogoImg()
				);
			};
	
			this.getCountIndicatorValue = function (item) {
				return item.menuName === 'inbox' && _this.props.unreadCount || item.menuName === 'tasklist' && _this.props.taskCount || item.menuName === 'outbox' && _this.props.outboxFailedCount || item.menuName === 'news' && _this.props.newNewsCount;
			};
	
			this.isActiveItem = function (item) {
				return item && item.menuName.toLowerCase() === _this.props.module.toLowerCase();
			};
	
			this.getMenuName = function (item) {
				return item && (item.menuLabel || _(item.menuName));
			};
		}
	
		_createClass(Sidebar, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props2 = this.props;
				var module = _props2.module;
				var security = _props2.security;
				var _onSubmenuClick2 = _props2.onSubmenuClick;
				var isPhone = _props2.isPhone;
				var isTablet = _props2.isTablet;
				var onLinkClicked = _props2.onLinkClicked;
				var onLogout = _props2.onLogout;
				var isIE = _props2.isIE;
	
				var links = (0, _lodashCollection.filter)(security.menuItems, function (item) {
					return item.menuVisible === "true";
				});
	
				var isIEclass = _sidebarScss2['default'].isIE;
	
				if (isIE == false) {
					isIEclass = null;
				}
	
				return _react2['default'].createElement(
					'div',
					{ className: this.getContainerClassNames() + " " + isIEclass },
					_react2['default'].createElement(
						'div',
						{ className: _sidebarScss2['default'].sidebarWrapper },
						(!isPhone || !isTablet) && this.getLogoElement(),
						_react2['default'].createElement(
							'ul',
							null,
							links.map(function (item, i) {
								return _this2.MenuItemDom({
									item: item,
									key: i,
									onClick: function onClick() {
										onLinkClicked(item.menuName);
									},
									onSubmenuClick: function onSubmenuClick() {
										_onSubmenuClick2(item.menuName);
									}
								});
							}),
							this.MenuItemDom({
								item: { menuName: 'logout' },
								key: 99999, // last one menu
								onClick: onLogout
							})
						),
						_react2['default'].createElement(
							'div',
							{ className: _sidebarScss2['default'].sidebarFooter },
							_react2['default'].createElement(
								'div',
								{ className: _sidebarScss2['default'].disclaimer },
								_react2['default'].createElement(_disclaimer2['default'], null),
								' ',
								_react2['default'].createElement('br', null),
								'© ' + new Date().getFullYear() + ' WILLEMOT NV'
							),
							!isPhone && !isTablet && _react2['default'].createElement(
								'div',
								{ onClick: this.handleToggle, className: _sidebarScss2['default'].collapseArrow },
								_react2['default'].createElement('img', { src: __webpack_require__(589) })
							)
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				isPhone: _react.PropTypes.bool,
				isTablet: _react.PropTypes.bool,
				className: _react.PropTypes.string,
				module: _react.PropTypes.string.isRequired,
				security: _react.PropTypes.object,
				menuCollapsed: _react.PropTypes.bool,
				subMenuCollapsed: _react.PropTypes.bool,
				inbox: _react.PropTypes.array,
				unreadCount: _react.PropTypes.number,
				taskCount: _react.PropTypes.number,
				outboxFailedCount: _react.PropTypes.number,
				onLinkClicked: _react.PropTypes.func.isRequired,
				onLogout: _react.PropTypes.func.isRequired,
				onSubmenuClick: _react.PropTypes.func.isRequired,
				toggleMenu: _react.PropTypes.func.isRequired,
				newNewsCount: _react.PropTypes.number
			},
	
			/**
	   * This is a recursive sidebar menu generator. There are used submenus but use it carrefully,
	   * because all of the submenus try to find a module. The menu generator is dynamic but the
	   * paths must exists in the module tree.
	   */
			enumerable: true
		}]);
	
		var _Sidebar = Sidebar;
		Sidebar = (0, _reactRedux.connect)(function (state) {
			return {
				module: state.app.module,
				security: state.app.security,
				menuCollapsed: state.app.menuCollapsed,
				subMenuCollapsed: state.app.subMenuCollapsed,
				isPhone: state.responsive.isPhone,
				isTablet: state.responsive.isTablet,
				unreadCount: state.inbox.unreadCount,
				taskCount: state.taskList.uncompleted,
				outboxFailedCount: state.outbox.outboxFailedCount,
				newNewsCount: state.news.newNewsCount,
				isIe: state.app.isIE
			};
		}, { toggleMenu: _stateActions.toggleMenu })(Sidebar) || Sidebar;
		return Sidebar;
	})(_react.Component);
	
	exports['default'] = Sidebar;
	module.exports = exports['default'];

	/*
	 * This helps to provide number indicator value for the sidebar menu elements.
	 */

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _elementsGrail = __webpack_require__(220);
	
	var _elementsGrail2 = _interopRequireDefault(_elementsGrail);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _version = __webpack_require__(635);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _disclaimer = __webpack_require__(391);
	
	var _disclaimer2 = _interopRequireDefault(_disclaimer);
	
	var _elementsHtmlContent = __webpack_require__(110);
	
	var _elementsHtmlContent2 = _interopRequireDefault(_elementsHtmlContent);
	
	var _metroUIScss = __webpack_require__(1617);
	
	var _metroUIScss2 = _interopRequireDefault(_metroUIScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('sidebar');
	
	var MetroUI = (function (_React$Component) {
		_inherits(MetroUI, _React$Component);
	
		function MetroUI() {
			_classCallCheck(this, _MetroUI);
	
			_get(Object.getPrototypeOf(_MetroUI.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(MetroUI, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.update(true);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.update();
			}
		}, {
			key: 'update',
			value: function update(force) {
				this.props.dispatch((0, _stateActions.getFlash)(force));
			}
		}, {
			key: 'getCountIndicatorValue',
			value: function getCountIndicatorValue(item) {
				return item.menuName === 'inbox' && this.props.unreadCount || item.menuName === 'tasklist' && this.props.taskCount || item.menuName === 'outbox' && this.props.outboxFailedCount || item.menuName === 'news' && this.props.newNewsCount;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var flash = _props.flash;
				var menuItems = _props.menuItems;
				var isPhone = _props.isPhone;
				var isTablet = _props.isTablet;
	
				var links = menuItems.filter(function (item) {
					return item.menuVisible === "true";
				});
	
				var icons = links.map(function (item, i) {
					try {
						return __webpack_require__(592)("./m-" + item.menuName + '.svg');
					} catch (err) {
						return __webpack_require__(23);
					}
				});
				return _react2['default'].createElement(
					_elementsGrail2['default'],
					{
						noScroll: true,
						footer: _react2['default'].createElement(
							'div',
							{ className: _metroUIScss2['default'].disclaimer },
							_react2['default'].createElement(_disclaimer2['default'], null),
							'- ',
							_react2['default'].createElement(
								'span',
								{ className: _metroUIScss2['default'].version },
								_react2['default'].createElement(_version2['default'], null)
							)
						)
					},
					_react2['default'].createElement(
						'div',
						{ className: _metroUIScss2['default'].metroUI + ' ' + ((isPhone || isTablet) && _metroUIScss2['default'].mobile) },
						_react2['default'].createElement(
							'div',
							{ className: _metroUIScss2['default'].metroUIContainer },
							_react2['default'].createElement(
								'div',
								{ className: _metroUIScss2['default'].metroUICenterContainer },
								_react2['default'].createElement(
									'div',
									{ className: _metroUIScss2['default'].metroUILogo },
									_react2['default'].createElement('img', { src: __webpack_require__(171) })
								),
								links.map(function (item, i) {
									var actFlash = undefined;
									if (i === (isPhone || isTablet ? 2 : 0)) {
										actFlash = flash[0];
										if (actFlash) {
											actFlash.className = 'flashOne';
										}
									} else if (i === (isPhone || isTablet ? 8 : 5)) {
										actFlash = flash[1];
										if (actFlash) {
											actFlash.className = 'flashTwo';
										}
									}
									var src = undefined;
									var count = _this.getCountIndicatorValue(item);
									if (actFlash) {
										var html = actFlash.teaser;
										src;
										var htmlSrcMatches = html.match(new RegExp(/src\s*=\s*"(.+?)"/));
										if (!_underscore2['default'].isEmpty(htmlSrcMatches) && _underscore2['default'].isArray(htmlSrcMatches) && htmlSrcMatches.length > 1) {
											src = htmlSrcMatches[1];
										}
									}
									return _react2['default'].createElement(
										'div',
										{ key: i, className: _metroUIScss2['default'].tileWrapper },
										_react2['default'].createElement(
											'div',
											{
												id: i,
												onMouseUp: function () {
													return _this.props.onLinkClicked(item.menuName);
												},
												className: _metroUIScss2['default'].tile + ' ' + _metroUIScss2['default'][item.menuName]
											},
											_react2['default'].createElement(
												'div',
												{ className: _metroUIScss2['default'].tileHeading },
												_react2['default'].createElement(
													'div',
													{ className: _metroUIScss2['default'].iconContainer },
													_react2['default'].createElement('img', { src: icons[i] || "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: _metroUIScss2['default'].tileTitle },
													item.menuLabel || _(item.menuName)
												),
												count > 0 && _react2['default'].createElement(
													'div',
													{ className: _metroUIScss2['default'].counter },
													count
												)
											)
										),
										actFlash && _react2['default'].createElement(
											'div',
											{
												onClick: function () {
													return _this.props.onFlashClicked(actFlash._id);
												},
												className: _metroUIScss2['default'].tile + ' ' + _metroUIScss2['default'][actFlash.className] + ' ' + _metroUIScss2['default'].markdown
											},
											_react2['default'].createElement(
												'div',
												{ style: { 'backgroundImage': 'url(' + src + ')', 'backgroundSize': 'cover', 'backgroundPosition': 'center' }, className: _metroUIScss2['default'].tileHeading },
												_react2['default'].createElement(
													'div',
													{ className: _metroUIScss2['default'].tileTitle },
													actFlash.title
												),
												_react2['default'].createElement(
													'div',
													{ className: src ? _metroUIScss2['default'].tileTeaser + ' ' + _metroUIScss2['default'].noImg : _metroUIScss2['default'].tileTeaser },
													_react2['default'].createElement(_elementsHtmlContent2['default'], {
														className: '',
														content: actFlash.teaser
													})
												)
											)
										)
									);
								}),
								_react2['default'].createElement(
									'div',
									{
										id: 'casper_logout',
										onClick: function () {
											return _this.props.onLogout();
										},
										className: _metroUIScss2['default'].tile + ' ' + _metroUIScss2['default'].logout
									},
									_react2['default'].createElement(
										'div',
										{ className: _metroUIScss2['default'].tileHeading },
										_react2['default'].createElement(
											'div',
											{ className: _metroUIScss2['default'].iconContainer },
											_react2['default'].createElement('img', { src: __webpack_require__(359) })
										),
										_react2['default'].createElement(
											'div',
											{ className: _metroUIScss2['default'].tileTitle },
											_("logout")
										)
									)
								)
							)
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				flash: _react2['default'].PropTypes.array.isRequired,
				menuItems: _react2['default'].PropTypes.array.isRequired,
				isPhone: _react2['default'].PropTypes.bool.isRequired,
				isTablet: _react2['default'].PropTypes.bool.isRequired,
				onLinkClicked: _react2['default'].PropTypes.func.isRequired,
				onFlashClicked: _react2['default'].PropTypes.func.isRequired,
				onLogout: _react2['default'].PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		var _MetroUI = MetroUI;
		MetroUI = (0, _reactRedux.connect)(function (state) {
			return {
				flash: state.flash.items,
				menuItems: state.app.security && state.app.security.menuItems || [],
				isPhone: state.responsive.isPhone,
				isTablet: state.responsive.isTablet,
				unreadCount: state.inbox.unreadCount,
				taskCount: state.taskList.uncompleted,
				outboxFailedCount: state.outbox.outboxFailedCount,
				newNewsCount: state.news.newNewsCount
			};
		})(MetroUI) || MetroUI;
		return MetroUI;
	})(_react2['default'].Component);
	
	exports['default'] = MetroUI;
	module.exports = exports['default'];
	/* This is a real comment */ /* onMouseup required because of Edge - it's not handling the onClick */

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _elementsNewsPageDom = __webpack_require__(1166);
	
	var _elementsNewsPageDom2 = _interopRequireDefault(_elementsNewsPageDom);
	
	var _elementsPrintModalJsx = __webpack_require__(1168);
	
	var _elementsPrintModalJsx2 = _interopRequireDefault(_elementsPrintModalJsx);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('news');
	
	var News = (function (_React$Component) {
	    _inherits(News, _React$Component);
	
	    function News() {
	        _classCallCheck(this, _News);
	
	        _get(Object.getPrototypeOf(_News.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(News, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dispatch = this.props.dispatch;
	
	            this.update();
	            var promisesForLoading = [];
	
	            var categoryPromise = new Promise(function (resolve, reject) {
	                (0, _libI18n.catIdToString)('', function () {
	                    resolve();
	                });
	            });
	
	            var sourcePromise = new Promise(function (resolve, reject) {
	                (0, _libI18n.sourceIdToObj)('', function () {
	                    resolve();
	                });
	            });
	
	            promisesForLoading.push(categoryPromise);
	            promisesForLoading.push(sourcePromise);
	
	            Promise.all(promisesForLoading).then(function () {
	                dispatch((0, _stateActions.setNewLoaded)());
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.update();
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.getNews)());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var items = _props.items;
	            var filter = _props.filter;
	            var newsId = _props.newsId;
	            var loaded = _props.loaded;
	            var dispatch = _props.dispatch;
	            var isPhone = _props.isPhone;
	            var opened = _props.opened;
	            var isTablet = _props.isTablet;
	
	            var newsIndex = newsId && items.findIndex(function (item) {
	                return item._id === newsId;
	            });
	            if (!newsIndex && !isPhone && !isTablet) {
	                newsIndex = 0;
	            }
	            var newsItem = items[newsIndex];
	            var filteredItems = items;
	
	            if (!loaded) {
	                return _react2['default'].createElement('div', null);
	            }
	            var lowerFilters = filter && filter.trim().toLowerCase().split(/\s/) || [];
	
	            if (lowerFilters) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    var _loop = function () {
	                        var lowerFilter = _step.value;
	
	                        filteredItems = filteredItems.filter(function (item) {
	                            return item && item.title && (item.title.toLowerCase().includes(lowerFilter) || item.teaser && item.teaser.toLowerCase().includes(lowerFilter) || item.categoryIds && item.categoryIds.map(function (catId) {
	                                var result = (0, _libI18n.catIdToString)(catId);
	                                result = String(result);
	                                return result && result.toLowerCase() || '';
	                            }).some(function (s) {
	                                var result = String(s);
	                                return result && result.includes(lowerFilter);
	                            }) || item.sourceIds && item.sourceIds.map(function (sourceId) {
	                                var sourceObj = (0, _libI18n.sourceIdToObj)(sourceId);
	                                return sourceObj && sourceObj.name && typeof sourceObj.name == 'string' && sourceObj.name.toLowerCase();
	                            }).some(function (s) {
	                                var result = String(s);
	                                return result && result.includes(lowerFilter);
	                            }));
	                        });
	                    };
	
	                    for (var _iterator = lowerFilters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        _loop();
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator['return']) {
	                            _iterator['return']();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	            newsIndex = filteredItems && filteredItems.indexOf(newsItem);
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_elementsNewsPageDom2['default'], {
	                    filter: filter,
	                    list: filteredItems,
	                    newsPosition: newsIndex,
	                    newsToOpen: newsItem,
	                    setFilter: function (filter) {
	                        return dispatch((0, _stateActions.setNewsFilter)(filter));
	                    },
	                    onOpen: function (itemId) {
	                        return dispatch((0, _stateActions.setOpened)(itemId));
	                    },
	                    isPhone: isPhone,
	                    isTablet: isTablet,
	                    opened: opened
	                }),
	                _react2['default'].createElement(_elementsPrintModalJsx2['default'], {
	                    confirmationLabel: _("ok"),
	                    onConfirmation: function () {
	                        dispatch((0, _stateActions.hidePrintModal)("newsPrintModal", true));
	                    },
	                    options: { showPrintButton: true, printButtonLabel: _("print") }
	                })
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            items: _react2['default'].PropTypes.array.isRequired
	        },
	        enumerable: true
	    }]);
	
	    var _News = News;
	    News = (0, _reactRedux.connect)(function (state) {
	        return _extends({}, state.news, {
	            newsId: state.app.opened,
	            isPhone: state.responsive.isPhone,
	            isTablet: state.responsive.isTablet,
	            opened: Boolean(app.opened)
	        });
	    })(News) || News;
	    return News;
	})(_react2['default'].Component);
	
	exports['default'] = News;
	module.exports = exports['default'];

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _elementsOfficeAdminDom = __webpack_require__(1167);
	
	var _elementsOfficeAdminDom2 = _interopRequireDefault(_elementsOfficeAdminDom);
	
	var AdminDocs = (function (_React$Component) {
		_inherits(AdminDocs, _React$Component);
	
		function AdminDocs() {
			_classCallCheck(this, _AdminDocs);
	
			_get(Object.getPrototypeOf(_AdminDocs.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(AdminDocs, [{
			key: 'update',
			value: function update() {
				var _props = this.props;
				var documents = _props.documents;
				var brokerNumber = _props.brokerNumber;
				var fetchAdminDocs = _props.fetchAdminDocs;
	
				if (!documents) {
					fetchAdminDocs(brokerNumber);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.update();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.update();
			}
		}, {
			key: 'render',
			value: function render() {
				var documents = this.props.documents;
	
				return _react2['default'].createElement(
					_elementsOfficeAdminDom2['default'],
					null,
					documents
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				documents: _react2['default'].PropTypes.array,
				brokerNumber: _react2['default'].PropTypes.string.isRequired,
				fetchAdminDocs: _react2['default'].PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		var _AdminDocs = AdminDocs;
		AdminDocs = (0, _reactRedux.connect)(function (state) {
			return {
				documents: state.adminDocs[state.app.brNr],
				brokerNumber: state.app.brNr
			};
		}, { fetchAdminDocs: _stateActions.fetchAdminDocs })(AdminDocs) || AdminDocs;
		return AdminDocs;
	})(_react2['default'].Component);
	
	exports['default'] = AdminDocs;
	module.exports = exports['default'];

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _libValidator = __webpack_require__(96);
	
	var _indexScss = __webpack_require__(721);
	
	var _indexScss2 = _interopRequireDefault(_indexScss);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateActions = __webpack_require__(5);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var General = (function (_React$Component) {
		_inherits(General, _React$Component);
	
		_createClass(General, null, [{
			key: 'propTypes',
			value: {
				broker: _react2['default'].PropTypes.object,
				brokerNumber: _react2['default'].PropTypes.string
			},
			enumerable: true
		}]);
	
		function General(props) {
			_classCallCheck(this, _General);
	
			_get(Object.getPrototypeOf(_General.prototype), 'constructor', this).call(this, props);
			this.state = { logoRefreshed: true, randomNumber: this.getRandom() };
		}
	
		_createClass(General, [{
			key: 'getRandom',
			value: function getRandom() {
				return Math.floor(Math.random() * 100000000 + 1);
			}
		}, {
			key: 'refreshLogo',
			value: function refreshLogo(logoUrl) {
				var dispatch;
				return regeneratorRuntime.async(function refreshLogo$(context$2$0) {
					var _this2 = this;
	
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							dispatch = this.props.dispatch;
							context$2$0.next = 3;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.showLoader)()));
	
						case 3:
							this.setState({ logoRefreshed: false }, function callee$2$0() {
								return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
									var _this = this;
	
									while (1) switch (context$3$0.prev = context$3$0.next) {
										case 0:
											context$3$0.prev = 0;
											context$3$0.next = 3;
											return regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
												var request = new XMLHttpRequest();
	
												request.open('GET', logoUrl, true);
												request.timeout = 10000;
												request.onreadystatechange = function () {
													if (request.readyState === 4) {
														if (request.status === 404) {
															resolve(logoUrl);
														} else if (request.status === 200) {
															resolve(logoUrl);
														} else {
															// anyway do a refresh in dome
															resolve(logoUrl);
														}
													}
												};
												request.ontimeout = function () {
													resolve(logoPlaceholderUrl);
												};
												request.send();
											}));
	
										case 3:
											context$3$0.next = 8;
											break;
	
										case 5:
											context$3$0.prev = 5;
											context$3$0.t0 = context$3$0['catch'](0);
	
											console.error("Refreshing logo error: ", context$3$0.t0);
	
										case 8:
	
											// end of refresh procedure
											this.setState({ logoRefreshed: true, randomNumber: this.getRandom() }, function callee$3$0() {
												return regeneratorRuntime.async(function callee$3$0$(context$4$0) {
													while (1) switch (context$4$0.prev = context$4$0.next) {
														case 0:
															context$4$0.next = 2;
															return regeneratorRuntime.awrap(dispatch((0, _stateActions.hideLoader)()));
	
														case 2:
														case 'end':
															return context$4$0.stop();
													}
												}, null, _this);
											});
	
										case 9:
										case 'end':
											return context$3$0.stop();
									}
								}, null, _this2, [[0, 5]]);
							});
	
						case 4:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props = this.props;
				var broker = _props.broker;
				var brokerNumber = _props.brokerNumber;
				var hasInternalAccess = _props.hasInternalAccess;
				var _state = this.state;
				var logoRefreshed = _state.logoRefreshed;
				var randomNumber = _state.randomNumber;
	
				if (!broker || !broker.main) {
					return false;
				}
				var main = broker.main;
				var address = main.mainAddress;
				var correspondence = main.correspondanceAddress;
	
				var fullAddress = function fullAddress(address) {
					return address.street + ' ' + address.number + ' ' + address.extension + ' ' + address.postalCode + ' ' + address.locality;
				};
	
				var website = function website(url) {
					return (0, _libValidator.isAnURL)(url) ? _react2['default'].createElement(
						'a',
						{ href: url, target: '_blank', rel: 'noopener noreferrer' },
						url,
						' '
					) : url;
				};
	
				var ibans = (0, _lodashCollection.map)(main.accountNumbers, function (accountNumber, i) {
					return _react2['default'].createElement(
						'span',
						{ key: i },
						accountNumber.IBAN
					);
				});
	
				var emails = (0, _lodashCollection.map)(main.emails, function (email, i) {
					return _react2['default'].createElement(
						'a',
						{ key: i, href: 'mailto:' + email },
						email
					);
				});
	
				var phoneNumbers = (0, _lodashCollection.map)(main.phoneNumbers, function (phoneNumber, i) {
					return _react2['default'].createElement(
						'a',
						{ key: i, href: 'tel:' + phoneNumber },
						phoneNumber
					);
				});
	
				var fax = _react2['default'].createElement(
					'a',
					{ href: 'tel:' + main.faxNumber },
					main.faxNumber
				);
	
				var columns = [[{ label: _('name'), value: main.name }, { label: _('commercialName'), value: main.commercialName }, { label: _('email'), value: emails }, { label: _('adres'), value: fullAddress(address) }, { label: _('iban'), value: ibans }, { label: _('companyRegistrationNumber'), value: main.companyRegistrationNumber }, { label: _('contract'), value: main.contract }, { label: _('aedesNumber'), value: main.aedesNumber }], [{ label: _('website'), value: website(main.website) }, { label: _('telephone'), value: phoneNumbers }, { label: _('fax'), value: fax }, { label: _('brokerType'), value: main.brokerType }, { label: _('correspondance'), value: fullAddress(correspondence) }, { label: _('fsma'), value: main.fsmaNumber }]];
	
				var logoUrl = "/brokerLogo?brokerNumber=" + brokerNumber + "&randomNumber=" + this.state.randomNumber;
				var logoUrlNoCache = "/brokerLogo?brokerNumber=" + brokerNumber + "&noCache=1";
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'div',
						{ className: _indexScss2['default'].logoAndButtonContainer },
						_react2['default'].createElement(
							'span',
							{ className: _indexScss2['default'].containerForLogo },
							_react2['default'].createElement(
								'a',
								{ className: _indexScss2['default'].brokerLogoContainer, href: logoUrl, target: '_blank', rel: 'noopener noreferrer' },
								_react2['default'].createElement('img', { className: _indexScss2['default'].brokerLogo, src: logoUrl })
							)
						),
						_react2['default'].createElement(
							'span',
							{ className: _indexScss2['default'].containerForButton },
							_react2['default'].createElement(
								'button',
								{ className: _indexScss2['default'].greyButton, onClick: (function () {
										return _this3.refreshLogo(logoUrlNoCache);
									}).bind(this) },
								_("refreshLogo")
							),
							hasInternalAccess && brokerNumber && _react2['default'].createElement(
								'div',
								{ className: _indexScss2['default'].DSWizardButtonWrapper },
								_react2['default'].createElement(_DSDocumentsMifidButton2['default'], {
									moduleKeyToSet: _stateConstants2['default'].DS_MODULE_OFFICE,
									subModuleKeyToSet: _stateConstants2['default'].DS_MODULE_OFFICE,
									brokerFromOffice: broker,
									// brokerId={clientId}
									// claimId={claimId}
									// claimNumber={claimNumber}
									callBackOnClose: function () {}
									// moduleOptions={this.collectVariableValues()}
								})
							)
						)
					),
					_react2['default'].createElement(_KeyValue2['default'], { array: columns })
				);
			}
		}]);
	
		var _General = General;
		General = (0, _reactRedux.connect)(function (state) {
			var hasInternalAccess = state.app.userTypeId === '1' || state.app.userTypeId === '3' ? true : false;
	
			return {
				broker: state.office.brokers[state.app.brNr],
				brokerNumber: state.app.brNr,
				hasInternalAccess: hasInternalAccess
			};
		})(General) || General;
		return General;
	})(_react2['default'].Component);
	
	exports['default'] = General;
	module.exports = exports['default'];
	/* <label className={style.refreshLogoDescription}>{_("refreshBrokerLogoDescription")}</label> */

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _bpostSelect = __webpack_require__(365);
	
	var _bpostSelect2 = _interopRequireDefault(_bpostSelect);
	
	var _reduxForm = __webpack_require__(57);
	
	var _contactsScss = __webpack_require__(304);
	
	var _contactsScss2 = _interopRequireDefault(_contactsScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectSelectWrap2 = _interopRequireDefault(_sharedSelectSelectWrap);
	
	var _ = (0, _libI18n2['default'])('officeContactPopup');
	
	var requiredFields = ["firstName", "lastName", "birthday", "email", "street", "houseNum", "zipCity"];
	var belgiumWordsForValidate = [];
	
	var validate = function validate(values) {
	    var errors = {};
	
	    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
	        errors.email = 'invalid';
	    }
	    if (!/^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/i.test(values.birthday)) {
	        errors.birthday = 'invalid';
	    }
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = requiredFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            if (!values[item]) {
	                errors[item] = 'required';
	            }
	        }
	
	        // this will be an id
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator['return']) {
	                _iterator['return']();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    var isBelgium = values.country && values.country == 1 || false;
	    var isEmptySelectedZipCity = Boolean(values["zipCitySelected"]);
	    var isEmptyZipTyped = !String(_nestedProperty2['default'].get(values, "zipTyped")).trim();
	    var isEmptyCityTyped = !String(_nestedProperty2['default'].get(values, "cityTyped")).trim();
	
	    if (isBelgium && !isEmptySelectedZipCity) {
	        errors['zipCitySelected'] = 'required';
	    } else {
	        if (isEmptyCityTyped) {
	            errors['cityTyped'] = 'required';
	        }
	
	        /* if(isEmptyZipTyped){
	            errors['zipTyped'] = 'required'
	        } */
	    }
	
	    return errors;
	};
	
	var ContactModal = (function (_React$Component) {
	    _inherits(ContactModal, _React$Component);
	
	    function ContactModal() {
	        _classCallCheck(this, _ContactModal);
	
	        _get(Object.getPrototypeOf(_ContactModal.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ContactModal, [{
	        key: 'updateFormValue',
	
	        /**
	         * This function update field values in redux form.
	         * @param {*} value
	         * @param {*} field
	         */
	        value: function updateFormValue(value, field) {
	            var dispatch = this.props.dispatch;
	
	            dispatch({
	                type: "redux-form/CHANGE",
	                field: field.name,
	                value: value && value.value || '',
	                touch: value && value.touched || field.touched,
	                form: "contact"
	            });
	
	            this.forceUpdate();
	        }
	
	        /**
	         * This function fired when the component receive a new property
	         * @param {object} nextProps - the next state of properties
	         */
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // change values for zip city input and selector, assign select, replace if possible
	            this.handleZipCityUpdateProps(nextProps);
	        }
	
	        /**
	         * This function handle the property changes process for zip city inputs values
	         * @param {string} nextProps - the props of nex state of the module
	         */
	    }, {
	        key: 'handleZipCityUpdateProps',
	        value: function handleZipCityUpdateProps(nextProps) {
	            var _props = this.props;
	            var _props$fields = _props.fields;
	            var zipCitySelected = _props$fields.zipCitySelected;
	            var country = _props$fields.country;
	            var zipCity = _props$fields.zipCity;
	            var zipTyped = _props$fields.zipTyped;
	            var cityTyped = _props$fields.cityTyped;
	            var zipCodeOptions = _props.zipCodeOptions;
	            var countries = _props.countries;
	
	            // synchronization the selected zip city to the free input, that one will sent forward
	            var selectedCountryId = _nestedProperty2['default'].get(nextProps, "fields.country.value") || '';
	            var isBelgium = selectedCountryId && selectedCountryId == 1 || false;
	            var wasSomethingChanged = false;
	
	            // get new selected value
	            var zipCitySelectedValue = _nestedProperty2['default'].get(nextProps, "fields.zipCitySelected.value") || '';
	            var zipCitySelectedValueDigested = zipCitySelectedValue.replace("_", ", ");
	            var oldZipCitySelectedValue = _nestedProperty2['default'].get(this.props, "fields.zipCitySelected.value") || '';
	
	            // prepare values
	            var zipTypedValue = _nestedProperty2['default'].get(nextProps, "fields.zipTyped.value") || '';
	            var cityTypedValue = _nestedProperty2['default'].get(nextProps, "fields.cityTyped.value") || '';
	            var oldZipTypedValue = _nestedProperty2['default'].get(this.props, "fields.zipTyped.value") || '';
	            var oldCityTypedValue = _nestedProperty2['default'].get(this.props, "fields.cityTyped.value") || '';
	            var typedZipCityCombo = zipTypedValue + ", " + cityTypedValue;
	            var oldTypedZipCityCombo = oldZipTypedValue + (oldCityTypedValue && oldZipTypedValue ? ", " : "") + oldCityTypedValue;
	
	            var finalZipCity = isBelgium ? zipCitySelectedValueDigested : oldTypedZipCityCombo;
	
	            // --- if belgium selected ---
	            if (isBelgium) {
	                // is required update
	                if (oldZipCitySelectedValue != zipCitySelectedValue) {
	                    this.updateFormValue(_extends({}, nextProps.fields.zipCitySelected, {
	                        value: zipCitySelectedValue
	                    }), zipCitySelected);
	
	                    // this will be the final value to set for zipCity field
	                    finalZipCity = zipCitySelectedValueDigested;
	                    wasSomethingChanged = true;
	                }
	            } else {
	                // --- if not belgium selected ---
	
	                // if zip changed by typing
	                if (oldZipTypedValue != zipTypedValue) {
	                    this.updateFormValue(_extends({}, nextProps.fields.zipTyped, {
	                        value: zipTypedValue
	                    }), zipTyped);
	
	                    // this will be the final value to set for zipCity field
	                    finalZipCity = typedZipCityCombo;
	                    wasSomethingChanged = true;
	                }
	
	                // if city changed by typing
	                if (oldCityTypedValue != cityTypedValue) {
	                    this.updateFormValue(_extends({}, nextProps.fields.cityTyped, {
	                        value: cityTypedValue
	                    }), cityTyped);
	
	                    // this will be the final value to set for zipCity field
	                    finalZipCity = typedZipCityCombo;
	                    wasSomethingChanged = true;
	                }
	            }
	
	            // check if zipCity must be updated changed
	            var oldZipCityValue = _nestedProperty2['default'].get(zipCity, "value") || '';
	
	            // finally set the zipCity value for the form
	            if (oldZipCityValue != finalZipCity) {
	                this.updateFormValue(_extends({}, nextProps.fields.zipCity, {
	                    value: finalZipCity
	                }), zipCity);
	                // console.log("finalZipCity CAHNGED to ", finalZipCity)
	            } else {
	                    // console.log("finalZipCity NOT changed from", oldZipCityValue, "to", finalZipCity)
	                }
	        }
	    }, {
	        key: 'touch',
	        value: function touch(field) {
	            field.onBlur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props2 = this.props;
	            var _props2$fields = _props2.fields;
	            var firstName = _props2$fields.firstName;
	            var lastName = _props2$fields.lastName;
	            var birthday = _props2$fields.birthday;
	            var email = _props2$fields.email;
	            var street = _props2$fields.street;
	            var houseNum = _props2$fields.houseNum;
	            var houseNumExt = _props2$fields.houseNumExt;
	            var zipCity = _props2$fields.zipCity;
	            var zipCitySelected = _props2$fields.zipCitySelected;
	            var zipTyped = _props2$fields.zipTyped;
	            var cityTyped = _props2$fields.cityTyped;
	            var mobile = _props2$fields.mobile;
	            var phone = _props2$fields.phone;
	            var country = _props2$fields.country;
	            var language = _props2$fields.language;
	            var handleSubmit = _props2.handleSubmit;
	            var onCloseModal = _props2.onCloseModal;
	            var onSaveContact = _props2.onSaveContact;
	            var countries = _props2.countries;
	
	            var selectedCountryId = _nestedProperty2['default'].get(country, "value") || '';
	            var isBelgium = selectedCountryId && selectedCountryId == 1 || false;
	
	            var onSubmit = handleSubmit(function (formData) {
	                formData.country = countries && _nestedProperty2['default'].get(countries.filter(function (oneCountry) {
	                    return oneCountry.value == formData.country;
	                }), "0.label") || "";
	                return onSaveContact(formData);
	            });
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _contactsScss2['default'].contactForm },
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('firstName'),
	                        ' *'
	                    ),
	                    _react2['default'].createElement('input', _extends({ className: _contactsScss2['default'].contactInput }, firstName)),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _contactsScss2['default'].error },
	                        firstName.error && firstName.touched && firstName.error === 'required' && _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('required')
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('lastName'),
	                        ' *'
	                    ),
	                    _react2['default'].createElement('input', _extends({ className: _contactsScss2['default'].contactInput }, lastName)),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _contactsScss2['default'].error },
	                        lastName.error && lastName.touched && lastName.error === 'required' && _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('required')
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('birthday'),
	                        ' *'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _contactsScss2['default'].contactInput },
	                        _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, birthday)
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _contactsScss2['default'].error },
	                        birthday.error && birthday.touched && (birthday.error === 'required' ? _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('required')
	                        ) : _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('invalidDate')
	                        ))
	                    )
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('email'),
	                        ' *'
	                    ),
	                    _react2['default'].createElement('input', _extends({ className: _contactsScss2['default'].contactInput }, email)),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _contactsScss2['default'].error },
	                        email.error && email.touched && (email.error === 'required' ? _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('required')
	                        ) : _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('invalidEmail')
	                        ))
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _contactsScss2['default'].addressWrapper },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: _contactsScss2['default'].full },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('country'),
	                            ' *'
	                        ),
	                        _react2['default'].createElement(_sharedSelectSelectWrap2['default'], _extends({
	                            className: _contactsScss2['default'].contactInput
	                        }, country, {
	                            options: countries
	                        })),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: _contactsScss2['default'].error },
	                            country.error && country.touched && country.error === 'required' && _react2['default'].createElement(
	                                'span',
	                                null,
	                                _('required')
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _contactsScss2['default'].inputRow },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('street'),
	                                    ' *'
	                                ),
	                                _react2['default'].createElement('input', _extends({ className: _contactsScss2['default'].contactInput }, street)),
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: _contactsScss2['default'].error },
	                                    street.error && street.touched && street.error === 'required' && _react2['default'].createElement(
	                                        'span',
	                                        null,
	                                        _('required')
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'label',
	                                { className: _contactsScss2['default'].half },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('houseNum'),
	                                    ' *'
	                                ),
	                                _react2['default'].createElement('input', _extends({ className: _contactsScss2['default'].contactInput }, houseNum)),
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: _contactsScss2['default'].error },
	                                    houseNum.error && houseNum.touched && houseNum.error === 'required' && _react2['default'].createElement(
	                                        'span',
	                                        null,
	                                        _('required')
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'label',
	                                { className: _contactsScss2['default'].half },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('houseNumExt')
	                                ),
	                                _react2['default'].createElement('input', _extends({ className: _contactsScss2['default'].contactInput }, houseNumExt))
	                            )
	                        ),
	                        isBelgium ? _react2['default'].createElement(
	                            'label',
	                            { className: _contactsScss2['default'].full },
	                            _react2['default'].createElement(
	                                'span',
	                                null,
	                                _('city'),
	                                '   &   ',
	                                _('zip'),
	                                ' *'
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _contactsScss2['default'].gemPostcode },
	                                _react2['default'].createElement(_bpostSelect2['default'], _extends({}, zipCitySelected, {
	                                    optionsListCallback: function (options) {
	                                        _this.setState({ zipCitySelectedOptions: options });
	                                    }
	                                }))
	                            ),
	                            _react2['default'].createElement(
	                                'span',
	                                { className: _contactsScss2['default'].error },
	                                zipCitySelected.touched && zipCitySelected.error && zipCitySelected.error === 'required' && _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('required')
	                                )
	                            )
	                        ) : _react2['default'].createElement(
	                            'span',
	                            null,
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('zip')
	                                ),
	                                _react2['default'].createElement(_bpostSelect.BpostInput, _extends({}, zipTyped, {
	                                    className: _contactsScss2['default'].contactInput,
	                                    onChange: function (value) {
	                                        return zipTyped.onChange(value);
	                                    }
	                                })),
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: _contactsScss2['default'].error },
	                                    zipTyped.touched && zipTyped.error && zipTyped.error === 'required' && _react2['default'].createElement(
	                                        'span',
	                                        null,
	                                        _('required')
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('city'),
	                                    ' *'
	                                ),
	                                _react2['default'].createElement(_bpostSelect.BpostInput, _extends({}, cityTyped, {
	                                    className: _contactsScss2['default'].contactInput,
	                                    onChange: function (value) {
	                                        return cityTyped.onChange(value);
	                                    }
	                                })),
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: _contactsScss2['default'].error },
	                                    cityTyped.touched && cityTyped.error && cityTyped.error === 'required' && _react2['default'].createElement(
	                                        'span',
	                                        null,
	                                        _('required')
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _contactsScss2['default'].addressInfo },
	                        _('privateAddress')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('mobile'),
	                        ' '
	                    ),
	                    _react2['default'].createElement('input', _extends({ className: _contactsScss2['default'].contactInput }, mobile))
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('phone'),
	                        ' '
	                    ),
	                    _react2['default'].createElement('input', _extends({ className: _contactsScss2['default'].contactInput }, phone))
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('language'),
	                        ' '
	                    ),
	                    _react2['default'].createElement(
	                        'select',
	                        _extends({ className: _contactsScss2['default'].contactInput }, language),
	                        _react2['default'].createElement('option', null),
	                        _react2['default'].createElement(
	                            'option',
	                            { value: 'nl' },
	                            'NL'
	                        ),
	                        _react2['default'].createElement(
	                            'option',
	                            { value: 'fr' },
	                            'FR'
	                        ),
	                        _react2['default'].createElement(
	                            'option',
	                            { value: 'en' },
	                            'EN'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _contactsScss2['default'].buttons },
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: function () {
	                                return onCloseModal();
	                            }, className: _contactsScss2['default'].cancel },
	                        _('cancel')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: function () {
	                                return onSubmit();
	                            }, className: _contactsScss2['default'].next + " " + _contactsScss2['default'].enabled },
	                        _('confirm')
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            fields: _react2['default'].PropTypes.object.isRequired,
	            handleSubmit: _react2['default'].PropTypes.func.isRequired,
	            onCloseModal: _react2['default'].PropTypes.func.isRequired,
	            onSaveContact: _react2['default'].PropTypes.func.isRequired,
	            countries: _react2['default'].PropTypes.array,
	            zipCodeOptions: _react2['default'].PropTypes.array
	        },
	        enumerable: true
	    }]);
	
	    var _ContactModal = ContactModal;
	    ContactModal = (0, _reduxForm.reduxForm)({
	        form: "contact",
	        fields: ["firstName", "lastName", "birthday", "email", "street", "houseNum", "houseNumExt", "zipCity", "zipCitySelected", "zipTyped", "cityTyped", "mobile", "phone", "country", "language"],
	        validate: validate,
	        destroyOnUnmount: true,
	        touchOnBlur: true
	    })(ContactModal) || ContactModal;
	    return ContactModal;
	})(_react2['default'].Component);
	
	exports['default'] = ContactModal;
	module.exports = exports['default'];

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contactsScss = __webpack_require__(304);
	
	var _contactsScss2 = _interopRequireDefault(_contactsScss);
	
	var _KeyValue = __webpack_require__(107);
	
	var _KeyValue2 = _interopRequireDefault(_KeyValue);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('officeContactZoom');
	
	var phoneNumber = function phoneNumber(number) {
		return _react2['default'].createElement(
			'a',
			{ href: 'tel:' + number },
			number
		);
	};
	
	var ContactZoom = (function (_React$Component) {
		_inherits(ContactZoom, _React$Component);
	
		function ContactZoom() {
			_classCallCheck(this, ContactZoom);
	
			_get(Object.getPrototypeOf(ContactZoom.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ContactZoom, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var contact = _props.contact;
				var onShowContactModal = _props.onShowContactModal;
				var onRemoveContact = _props.onRemoveContact;
				var onCloseContact = _props.onCloseContact;
	
				var fullAddress = _react2['default'].createElement(
					'div',
					null,
					contact.street,
					' ',
					contact.houseNum,
					' ',
					contact.houseNumExt,
					' ',
					_react2['default'].createElement('br', null),
					contact.zip,
					' ',
					contact.city,
					' ',
					_react2['default'].createElement('br', null),
					contact.country
				);
				var email = _react2['default'].createElement(
					'a',
					{ href: 'mailto:' + contact.email },
					contact.email
				);
				var name = contact.name || {};
	
				var columns = [[{ label: _('firstName'), value: name.first }, { label: _('lastName'), value: name.last }, { label: _('address'), value: fullAddress }, { label: _('phone'), value: phoneNumber(contact.phone) }], [{ label: _('birthday'), value: contact.birthday }, { label: _('email'), value: email }, { label: _('language'), value: contact.language }, { label: _('mobile'), value: phoneNumber(contact.mobile) }]];
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'div',
						{ className: _contactsScss2['default'].buttonsContainer },
						_react2['default'].createElement('input', {
							onClick: function () {
								return onCloseContact();
							},
							type: 'button',
							className: 'greyButton',
							value: _('backToList')
						}),
						_react2['default'].createElement('input', {
							onClick: function () {
								return onRemoveContact(contact);
							},
							type: 'button',
							className: 'greyButton',
							value: _('removeContact')
						}),
						_react2['default'].createElement('input', {
							onClick: function () {
								return onShowContactModal(contact._id);
							},
							type: 'button',
							className: 'greyButton',
							value: _('editContact')
						})
					),
					_react2['default'].createElement(_KeyValue2['default'], { array: columns })
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				contact: _react2['default'].PropTypes.object.isRequired,
				onShowContactModal: _react2['default'].PropTypes.func.isRequired,
				onRemoveContact: _react2['default'].PropTypes.func.isRequired,
				onCloseContact: _react2['default'].PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		return ContactZoom;
	})(_react2['default'].Component);
	
	exports['default'] = ContactZoom;
	module.exports = exports['default'];

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contactsScss = __webpack_require__(304);
	
	var _contactsScss2 = _interopRequireDefault(_contactsScss);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _contacts = __webpack_require__(370);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var Contacts = (function (_React$Component) {
		_inherits(Contacts, _React$Component);
	
		function Contacts() {
			_classCallCheck(this, Contacts);
	
			_get(Object.getPrototypeOf(Contacts.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Contacts, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var contacts = _props.contacts;
				var onShowContactModal = _props.onShowContactModal;
				var onContactClicked = _props.onContactClicked;
	
				if (!contacts) {
					return false;
				}
				var contactsList = contacts.filter(function (item) {
					return !item._deleted;
				});
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'div',
						{ className: _reactableScss2['default'].tableContainer },
						_react2['default'].createElement(
							_componentsReactable.Table,
							{
								className: 'noPadding',
								itemsPerPage: 7,
								filterable: ['contName', 'contAddress', 'contBirthday', 'contPhone', 'contGSM', 'contEmail'],
								sortable: ['contName', 'contAddress', 'contBirthday', 'contPhone', 'contGSM', 'contEmail'],
								defaultSort: {
									column: 'contName',
									direction: 'desc'
								},
								topPaginationElemR: _react2['default'].createElement('input', {
									onClick: function () {
										return onShowContactModal(null);
									},
									type: 'button',
									className: 'btn green',
									value: _('newContact')
								})
							},
							_react2['default'].createElement(
								_componentsReactable.Thead,
								null,
								_react2['default'].createElement(
									_componentsReactable.Th,
									{ column: 'contName' },
									_react2['default'].createElement(
										'span',
										null,
										_('name')
									)
								),
								_react2['default'].createElement(
									_componentsReactable.Th,
									{ column: 'contAddress' },
									_react2['default'].createElement(
										'span',
										null,
										_('address')
									)
								),
								_react2['default'].createElement(
									_componentsReactable.Th,
									{ column: 'contBirthday' },
									_react2['default'].createElement(
										'span',
										null,
										_('birthday')
									)
								),
								_react2['default'].createElement(
									_componentsReactable.Th,
									{ column: 'contPhone' },
									_react2['default'].createElement(
										'span',
										null,
										_('phone')
									)
								),
								_react2['default'].createElement(
									_componentsReactable.Th,
									{ column: 'contGSM' },
									_react2['default'].createElement(
										'span',
										null,
										_('gsm')
									)
								),
								_react2['default'].createElement(
									_componentsReactable.Th,
									{ column: 'contEmail' },
									_react2['default'].createElement(
										'span',
										null,
										_('email')
									)
								)
							),
							contactsList.map(function (item, key) {
								return _react2['default'].createElement(
									_componentsReactable.Tr,
									{ key: key, data: item, className: 'clickable centered', onClick: function () {
											return onContactClicked(item._id);
										} },
									_react2['default'].createElement(_componentsReactable.Td, { column: 'contName', data: _react2['default'].createElement(_contacts.ContactNameValue, { contact: item }) }),
									_react2['default'].createElement(_componentsReactable.Td, { column: 'contAddress', data: item.address }),
									_react2['default'].createElement(_componentsReactable.Td, { column: 'contBirthday', data: item.birthday }),
									_react2['default'].createElement(_componentsReactable.Td, { column: 'contPhone', data: item.phone }),
									_react2['default'].createElement(_componentsReactable.Td, { column: 'contGSM', data: item.mobile }),
									_react2['default'].createElement(_componentsReactable.Td, { column: 'contEmail', data: item.email })
								);
							})
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				contacts: _react2['default'].PropTypes.array.isRequired,
				onShowContactModal: _react2['default'].PropTypes.func.isRequired,
				onContactClicked: _react2['default'].PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		return Contacts;
	})(_react2['default'].Component);
	
	exports['default'] = Contacts;
	module.exports = exports['default'];

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x4, _x5, _x6) { var _again = true; _function: while (_again) { var object = _x4, property = _x5, receiver = _x6; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x4 = parent; _x5 = property; _x6 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _emailSetupScss = __webpack_require__(438);
	
	var _emailSetupScss2 = _interopRequireDefault(_emailSetupScss);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _officeHelper = __webpack_require__(1129);
	
	var _officeHelper2 = _interopRequireDefault(_officeHelper);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateActions = __webpack_require__(5);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _testEmailDialog = __webpack_require__(1133);
	
	var _testEmailDialog2 = _interopRequireDefault(_testEmailDialog);
	
	var _areYouSureModal = __webpack_require__(607);
	
	var _areYouSureModal2 = _interopRequireDefault(_areYouSureModal);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var EmailSetup = (function (_React$Component) {
	    _inherits(EmailSetup, _React$Component);
	
	    _createClass(EmailSetup, null, [{
	        key: 'propTypes',
	        value: {},
	        enumerable: true
	    }]);
	
	    function EmailSetup(props) {
	        _classCallCheck(this, _EmailSetup);
	
	        _get(Object.getPrototypeOf(_EmailSetup.prototype), 'constructor', this).call(this, props);
	
	        this.getIcon = function (iconName) {
	            try {
	                return __webpack_require__(173)("./" + iconName);
	            } catch (err) {
	                return __webpack_require__(261);
	            }
	        };
	
	        var brokerOptions = this.getEmailsInOptionList();
	
	        var formInitialValues = this.getFormInitialValues();
	        var fields = this.formInputFieldsList(formInitialValues);
	
	        this.state = {
	            configsLoaded: null,
	            isLoaded: true,
	            brokerOptions: brokerOptions,
	            fields: fields,
	            saved: false,
	            isOpenTestMailModal: false,
	            isOpenAreYouSureModal: false,
	            onSendError: null
	        };
	    }
	
	    /**
	     * Component did mount hook. Check and load all the dependency values, init related values.
	     */
	
	    _createClass(EmailSetup, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initPage();
	        }
	
	        /**
	         * Load values and process it
	         */
	    }, {
	        key: 'initPage',
	        value: function initPage() {
	            var _this = this;
	
	            var dispatch = this.props.dispatch;
	            var _state = this.state;
	            var brokerOptions = _state.brokerOptions;
	            var fields = _state.fields;
	            var configsLoaded = _state.configsLoaded;
	
	            var emailAddress = _nestedProperty2['default'].get(fields, "emailAddress.value");
	
	            this.setState({ isLoaded: false });
	
	            // load every dependency data if necessary
	            var allNecessaryDataLoaderPromise = [];
	
	            // LOAD BROKERS
	            var brokerLoader = new Promise(function (resolve, reject) {
	                if (!brokerOptions || brokerOptions.length === 0) {
	                    // must get the office data for all informations for variables
	                    dispatch((0, _stateActions.fetchOfficeData)()).then(function () {
	                        var brokerOptions = _this.getEmailsInOptionList();
	                        _this.setState({ brokerOptions: brokerOptions }, function () {
	                            resolve();
	                        });
	                    })['catch'](function (err) {
	                        console.log("ERRRRROR brokerLoader ", err);
	                        reject(err);
	                    });
	                } else {
	                    resolve();
	                }
	            });
	
	            allNecessaryDataLoaderPromise.push(brokerLoader);
	
	            // LOAD CONFIG
	            var configLoader = new Promise(function (resolve, reject) {
	
	                if (!emailAddress) {
	                    return resolve({});
	                }
	
	                if (!configsLoaded || configsLoaded.emailAddress !== emailAddress) {
	                    dispatch((0, _stateActions.loadEmailServer)(emailAddress)).then(function (configsResult) {
	                        _this.setState({ configsLoaded: configsResult }, function () {
	                            resolve();
	                        });
	                    })['catch'](function (err) {
	                        console.log("ERRRRROR load configs fro broker ", err);
	                        reject(err);
	                    });
	                } else {
	                    if (!_this.state.clientOptionsDict) {
	                        _this.setState({ clientOptionsDict: dictionary }, function () {
	                            resolve();
	                        });
	                    } else {
	                        resolve();
	                    }
	                }
	            });
	
	            allNecessaryDataLoaderPromise.push(configLoader);
	
	            // promiseAll and set a flag to enable rendering of the module
	            return Promise.all(allNecessaryDataLoaderPromise).then(function () {
	                // re-init the "Step 1" form inputs, and values
	                var formInitialValues = _this.getFormInitialValues();
	                var fields = _this.formInputFieldsList(formInitialValues);
	
	                _this.setState({ fields: fields }, function () {
	
	                    _this.setState({ isLoaded: true });
	                    // reset the flag of form validity
	                    _this.setFormValidityFlag();
	                });
	            })['catch'](function (err) {
	                _this.setState({ isLoaded: true });
	                console.log("Something goes wrong on init: ", err);
	            });
	        }
	
	        /**
	         * This function will set state for the broker selector input.
	         * Insert the list of broker like an array contains plain JS objects (label, value).
	         */
	    }, {
	        key: 'getEmailsInOptionList',
	        value: function getEmailsInOptionList() {
	            var _props = this.props;
	            var brokers = _props.brokers;
	            var userId = _props.userId;
	
	            var brokerObjKeys = brokers && Object.keys(brokers) || [];
	
	            var emailList = [];
	
	            // broker own email adddresses fetch from deep
	            brokerObjKeys.forEach(function (brokerKey) {
	                if (brokers[brokerKey].main.emails) {
	                    brokers[brokerKey].main.emails.forEach(function (oneEmail) {
	                        emailList.push({
	                            value: oneEmail,
	                            label: oneEmail
	                        });
	                    });
	                }
	            });
	
	            var firstBrokerStaffList = brokers[brokerObjKeys[0]].staff;
	            if (firstBrokerStaffList && firstBrokerStaffList.length > 0) {
	                firstBrokerStaffList.forEach(function (oneStaff) {
	                    if (oneStaff.userId == userId) {
	                        emailList.push({
	                            value: oneStaff.email,
	                            label: oneStaff.email
	                        });
	                    }
	                });
	            }
	
	            // filtering duplicated email addresses
	            var result = [],
	                helperAlreadyInserteds = [];
	            if (emailList && emailList.length > 0) {
	                emailList.forEach(function (val, index) {
	                    if (helperAlreadyInserteds.indexOf(val.value) === -1) {
	                        result.push({ value: val.value, label: val.label });
	                        helperAlreadyInserteds.push(val.value);
	                    }
	                });
	            }
	
	            // add from auth the account managers emails
	            /* const accManagerObjKeys = accountManagers && Object.keys(accountManagers) || []
	            accManagerObjKeys.forEach((managerKey) => {
	                emailList.push({
	                    value: accountManagers[managerKey].email,
	                    label: accountManagers[managerKey].email + " - " + accountManagers[managerKey].Name
	                })
	            }) */
	
	            return result;
	        }
	    }, {
	        key: 'findItemByValueFromSelectOptions',
	        value: function findItemByValueFromSelectOptions(value, options) {
	            var result = { label: value, value: value };
	
	            if (!options) {
	                return result;
	            }
	
	            var filteredByValue = options.filter(function (item) {
	                return item.value === value;
	            });
	
	            // if no result in list of options the result the subject value
	            if (!filteredByValue || filteredByValue.length === 0) {
	                return result;
	            }
	
	            // in case of match then the first match is the selected one. If there are no values then remains the subject value
	            return _nestedProperty2['default'].get(filteredByValue, "0") || result;
	        }
	
	        /**
	         * One input field basic props for handle form.
	         */
	    }, {
	        key: '_inputPrototype',
	        value: function _inputPrototype() {
	            return { type: "text", label: "", value: "", touched: false, error: false, isRequired: false, isValid: function isValid() {
	                    return true;
	                }, errorMessage: _("invalidInputValue") };
	        }
	
	        /**
	         * Copy one input handler object and return.
	         */
	    }, {
	        key: '_initValueOfInput',
	        value: function _initValueOfInput() {
	            var proto = JSON.parse(JSON.stringify(this._inputPrototype()));
	            proto.isValid = function () {
	                return true;
	            }; // JSON trick is not perfect to copy an object :)
	            return proto;
	        }
	
	        /**
	         * This function prepare and return a bunch of predefined data for the form inputs indexed by form input ref names
	         */
	    }, {
	        key: 'getFormInitialValues',
	        value: function getFormInitialValues() {
	            var brokerOptions = this.getEmailsInOptionList();
	            var configsInState = _nestedProperty2['default'].get(this, "state.configsLoaded");
	            // const fields = nesProp.get(this, "state.fields")
	
	            var emailAddress = _nestedProperty2['default'].get(configsInState, "emailAddress") || "";
	            var senderName = _nestedProperty2['default'].get(configsInState, "senderName") || "";
	            // let host = nesProp.get(configsInState, "host") || ""
	            // let port = nesProp.get(configsInState, "port") || ""
	            // let secureConnection  = nesProp.get(configsInState, "secureConnection") || ""
	            // let secure = nesProp.get(configsInState, "secure") || ""
	            // let autotls = nesProp.get(configsInState, "autotls") || false
	            // let tls_rejectUnauthorized  = nesProp.get(configsInState, "tls_rejectUnauthorized") || ""
	            // let auth_user =  nesProp.get(configsInState, "auth_user") || ""
	            // let auth_password = nesProp.get(configsInState, "auth_password") || ""
	            // let service =  nesProp.get(configsInState, "service") || ""
	            // let useBounce = nesProp.get(configsInState, "useBounce") || ""
	            var active = true;
	
	            var initialValues = {
	                emailAddress: emailAddress,
	                senderName: senderName
	            };
	            // host,
	            // port,
	            // secureConnection,
	            // secure,
	            // autotls,
	            // tls_rejectUnauthorized,
	            // auth_user,
	            // auth_password,
	            // service,
	            // useBounce,
	            // active,
	            /* let initialValues = {
	                emailAddress: nesProp.get(fields, "emailAddress.value") || emailAddress,
	                host: nesProp.get(fields, "host.value") || host,
	                port: nesProp.get(fields, "port.value") || port,
	                secureConnection : nesProp.get(fields, "secureConnection.value") || secureConnection,
	                secure: nesProp.get(fields, "secure.value") || secure,
	                tls_rejectUnauthorized : nesProp.get(fields, "tls_rejectUnauthorized.value") || tls_rejectUnauthorized,
	                auth_user:  nesProp.get(fields, "auth_user.value") || auth_user,
	                auth_password: nesProp.get(fields, "auth_password.value") || auth_password,
	                service:  nesProp.get(fields, "service.value") || service,
	                active: nesProp.get(fields, "active.value") || active,
	            } */
	
	            return initialValues;
	        }
	
	        /**
	        * Compose and setup the form inputs with validation an custom error messages
	        * @param {*} formInitialValues - initial values for the form.
	        */
	    }, {
	        key: 'formInputFieldsList',
	        value: function formInputFieldsList(formInitialValues) {
	            return {
	                "emailAddress": _extends({}, this._initValueOfInput(), {
	                    isRequired: true,
	                    errorMessage: _("invalidEmailAddress"),
	                    value: _nestedProperty2['default'].get(formInitialValues, "emailAddress"),
	                    type: "select"
	                }),
	
	                "senderName": _extends({}, this._initValueOfInput(), {
	                    isRequired: true,
	                    errorMessage: _("invalidSenderName"),
	                    value: _nestedProperty2['default'].get(formInitialValues, "senderName"),
	                    type: "text"
	                })
	            };
	        }
	
	        /**
	         *
	         */
	    }, {
	        key: 'resetForm',
	        // "host": {...(this._initValueOfInput()),
	        //     isRequired: true,
	        //     errorMessage: _("invalidHost"),
	        //     value: nesProp.get(formInitialValues, "host"),
	        //     type: "text"
	        // },
	        // "port": {...(this._initValueOfInput()),
	        //     isRequired: true,
	        //     errorMessage: _("invalidPort"),
	        //     isValid: (value) => { return (((value*1)+"") === (value+""))},
	        //     value: nesProp.get(formInitialValues, "port"),
	        //     type: "text"
	        // },
	        // "secureConnection": {...(this._initValueOfInput()),
	        //     isRequired: false,
	        //     errorMessage: _("invalidSecureConnection"),
	        //     value: nesProp.get(formInitialValues, "secureConnection"),
	        //     type: "checkbox"
	        // },
	        // "secure": {...(this._initValueOfInput()),
	        //     isRequired: false,
	        //     errorMessage: _("invalidSecure"),
	        //     value: nesProp.get(formInitialValues, "secure"),
	        //     type: "checkbox"
	        // },
	        // "autotls": {...(this._initValueOfInput()),
	        //     isRequired: false,
	        //     errorMessage: _("invalidAutotls"),
	        //     value: nesProp.get(formInitialValues, "autotls"),
	        //     type: "checkbox"
	        // },
	        // "tls_rejectUnauthorized": {...(this._initValueOfInput()),
	        //     isRequired: false,
	        //     errorMessage: _("invalidTls_rejectUnauthorized"),
	        //     value: nesProp.get(formInitialValues, "tls_rejectUnauthorized"),
	        //     type: "checkbox"
	        // },
	        // "auth_user": {...(this._initValueOfInput()),
	        //     isRequired: true,
	        //     errorMessage: _("invalidAuth_user"),
	        //     value: nesProp.get(formInitialValues, "auth_user"),
	        //     type: "text"
	        // },
	        // "auth_password": {...(this._initValueOfInput()),
	        //     isRequired: true,
	        //     errorMessage: _("invalidAuth_password"),
	        //     value: nesProp.get(formInitialValues, "auth_password"),
	        //     type: "text"
	        // },
	        // "service": {...(this._initValueOfInput()),
	        //     isRequired: false,
	        //     errorMessage: _("invalidService"),
	        //     value: nesProp.get(formInitialValues, "service"),
	        //     type: "text"
	        // },
	        // "useBounce": {...(this._initValueOfInput()),
	        //     isRequired: false,
	        //     errorMessage: _("invalidUseBounce"),
	        //     value: nesProp.get(formInitialValues, "useBounce"),
	        //     type: "checkbox"
	        // },
	        // "active": {...(this._initValueOfInput()),
	        //     isRequired: false,
	        //     errorMessage: _("invalidActive"),
	        //     value: nesProp.get(formInitialValues, "active"),
	        //     type: "checkbox"
	        // },
	        value: function resetForm() {
	            var _this2 = this;
	
	            var fields = this.state.fields;
	
	            var formInitialValues = this.getFormInitialValues();
	
	            formInitialValues.emailAddress = fields.emailAddress.value;
	
	            var fieldsToSet = this.formInputFieldsList(formInitialValues);
	
	            return new Promise(function (resolve) {
	                _this2.setState({ fields: fieldsToSet }, resolve);
	            });
	        }
	
	        /**
	         * This function validate one field from the form.
	         * @param {*} formField - instance of input field object
	         * @param {*} inputValue - the new value of input
	         * @param {*} forceTouch - touch anyway the input even if the value is not modified (useful on onBluer fired or onSubmit)
	         */
	    }, {
	        key: 'fieldValidation',
	        value: function fieldValidation(formField) {
	            var forceTouch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            // required check
	            if (formField.isRequired && !formField.value) {
	                formField.error = _("fieldRequired");
	                formField.touched = forceTouch ? true : formField.touched;
	            } else {
	                // validate if "isValid" property is set
	                if (formField.isValid) {
	                    if (formField.isValid(formField.value)) {
	                        formField.error = false;
	                    } else {
	                        formField.error = formField.errorMessage;
	                        formField.touched = forceTouch ? true : formField.touched;
	                    }
	                } else {
	                    formField.error = false;
	                    formField.touched = forceTouch ? true : formField.touched;
	                }
	            }
	
	            // reset the flag of form validity
	            this.setFormValidityFlag();
	
	            return formField;
	        }
	
	        /**
	         * Set all form input untouched
	         */
	    }, {
	        key: 'unTouchFields',
	        value: function unTouchFields() {
	            var fields = _nestedProperty2['default'].get(this, "state.fields");
	            var formInputNames = Object.keys(fields);
	            formInputNames.forEach(function (formFieldName) {
	                var formField = _nestedProperty2['default'].get(fields, formFieldName);
	                formField.touched = false;
	                _nestedProperty2['default'].set(fields, formFieldName, formField);
	            });
	            this.setState({ fields: fields });
	        }
	
	        /**
	         * Reset the flag of form validity in state by checking the formInputs in state.
	         */
	    }, {
	        key: 'setFormValidityFlag',
	        value: function setFormValidityFlag() {
	            var fields = _nestedProperty2['default'].get(this, "state.fields");
	
	            // every change must set the valid form
	            if (fields) {
	                var hasError = false;
	                var keys = Object.keys(fields) || [];
	
	                keys.forEach(function (oneKey) {
	                    if (fields[oneKey].error) {
	                        hasError = true;
	                    }
	                });
	
	                this.setState({ isValidTheForm: hasError ? false : true });
	
	                return hasError ? false : true;
	            }
	
	            return true;
	        }
	
	        /**
	         * Validate the hole form.
	         * @param {*} data
	         * @param {*} formInputs
	         *
	         * @returns formInputs - reference to formInputs object in state
	         */
	    }, {
	        key: 'formInputsValidation',
	        value: function formInputsValidation(formInputs) {
	            var _this3 = this;
	
	            var forceTouch = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            if (!formInputs) {
	                return;
	            }
	
	            var formInputNames = Object.keys(formInputs);
	            formInputNames.forEach(function (formFieldName) {
	
	                var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	                formField = _this3.fieldValidation(formField, forceTouch);
	
	                //senderName should not include @
	                if (formField.isValid && formFieldName === 'senderName') {
	                    if (formField.isValid(formField.value)) {
	                        formField = _this3.validateSenderNameField(formField);
	                    }
	                }
	
	                // set back the value but this is already set by address, but must implement to see what happen
	                // so if you delete this row don't prevent tha value change caused by fieldValidation. (Only the deep cloning of values can solve.)
	                _nestedProperty2['default'].set(formInputs, formFieldName, formField);
	            });
	
	            // reset the flag of form validity
	            this.setFormValidityFlag();
	
	            return formInputs;
	        }
	
	        /**
	         * Fetch values from form by input refs
	         */
	    }, {
	        key: 'fetchFormValues',
	        value: function fetchFormValues() {
	            var _this4 = this;
	
	            var fields = this.state.fields;
	
	            var formFieldNames = Object.keys(fields);
	            var formData = {};
	
	            formFieldNames.forEach(function (formFieldName) {
	                var formFieldValue = undefined;
	
	                switch (fields[formFieldName].type) {
	                    case 'select':
	                        {
	                            // react creatable select way to get value
	                            formFieldValue = _nestedProperty2['default'].get(_this4, "refs." + formFieldName + ".props.value.value");
	
	                            // if not then react select way to get value
	                            formFieldValue = formFieldValue || _nestedProperty2['default'].get(_this4, "refs." + formFieldName + ".state.value.value");
	                            break;
	                        }
	                    case 'text':
	                        {
	                            // if not then normal text input way to get value
	                            formFieldValue = formFieldValue || _nestedProperty2['default'].get(_this4, "refs." + formFieldName + ".value");
	                            break;
	                        }
	                    case 'checkbox':
	                        {
	                            // if not then normal text input way to get value
	                            formFieldValue = formFieldValue || _nestedProperty2['default'].get(_this4, "refs." + formFieldName + ".checked");
	                            break;
	                        }
	                    default:
	                        {
	                            formFieldValue = formFieldValue || _nestedProperty2['default'].get(_this4, "refs." + formFieldName + ".value");
	                        }
	                }
	
	                formData[formFieldName] = typeof formFieldValue === "string" ? String(formFieldValue).trim() : formFieldValue;
	            });
	
	            return formData;
	        }
	
	        /**
	         * Change one input value in state, validate also.
	         */
	    }, {
	        key: 'onChangeFormInput',
	        value: function onChangeFormInput(value, formFieldName) {
	            var forceTouch = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	            var fields = this.state.fields;
	
	            //const data = this.fetchFormValues()
	
	            //get the object from state to be able to set the validity value in it.
	            var formField = _nestedProperty2['default'].get(fields, formFieldName);
	
	            // handle touch input
	            if (formField.value !== value && forceTouch === null) {
	                formField.touched = true;
	            }
	
	            if (forceTouch !== null) {
	                formField.touched = forceTouch;
	            }
	
	            // set the value
	            formField.value = value;
	
	            // set the validity in object, this will be set because it passed by address in JS
	            formField = this.fieldValidation(formField);
	
	            //senderName should not include @
	            if (formField.isValid && formFieldName === 'senderName') {
	                if (formField.isValid(formField.value)) {
	                    formField = this.validateSenderNameField(formField);
	                }
	            }
	
	            // this wil set back the value but implemented only for to be understandable, the value is set by address of object.
	            _nestedProperty2['default'].set(fields, formFieldName, formField);
	
	            // put back into the state
	            this.setState({ fields: fields });
	        }
	
	        /**
	         * senderName should not include @
	         * @param {*} formField
	         * @returns
	         */
	    }, {
	        key: 'validateSenderNameField',
	        value: function validateSenderNameField(formField) {
	            if (formField.value && formField.value.includes('@')) {
	                formField.error = _("invalidCharacter");
	            }
	
	            // reset the flag of form validity
	            this.setFormValidityFlag();
	
	            return formField;
	        }
	
	        /**
	         * Fill the form values in state
	         * @param {*} data
	         * @param {*} formInputs
	         *
	         * @returns formInputs - reference to formInputs object in state
	         */
	    }, {
	        key: 'setFormInputsByFormValues',
	        value: function setFormInputsByFormValues(data, formInputs) {
	            if (!formInputs) {
	                return;
	            }
	
	            var formInputNames = Object.keys(formInputs);
	            formInputNames.forEach(function (formFieldName) {
	
	                var dataField = _nestedProperty2['default'].get(data, formFieldName);
	                var formField = _nestedProperty2['default'].get(formInputs, formFieldName);
	
	                formField.value = dataField;
	                _nestedProperty2['default'].set(formInputs, formFieldName, formField);
	            });
	
	            return formInputs;
	        }
	
	        /**
	         * Save the form values by sending it to the server using the saveEmailServer API
	         */
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this5 = this;
	
	            var dispatch = this.props.dispatch;
	            var fields = this.state.fields;
	
	            var data = this.fetchFormValues();
	            fields = this.setFormInputsByFormValues(data, fields);
	            var forceTouche = true;
	            fields = this.formInputsValidation(fields, forceTouche);
	            var isValidTheForm = this.setFormValidityFlag();
	
	            this.setState({ fields: fields });
	
	            // form validation can  prevent to step the wizard forward
	            if (!isValidTheForm) {
	                this.setState({ isLoaded: true });
	                return;
	            }
	
	            console.log("saveEmailServer ", data);
	
	            return dispatch((0, _stateActions.saveEmailServer)(data)).then(function (newRecord) {
	                _this5.setState({ configsLoaded: newRecord });
	                _this5.setState({ saved: true });
	            });
	        }
	
	        /**
	         * Delete a config set by _id fetched from state: "configsLoaded" and Reset the form
	         */
	    }, {
	        key: 'delete',
	        value: function _delete() {
	            var _this6 = this;
	
	            var dispatch = this.props.dispatch;
	            var _state2 = this.state;
	            var fields = _state2.fields;
	            var configsLoaded = _state2.configsLoaded;
	
	            var _id = _nestedProperty2['default'].get(configsLoaded, "_id");
	
	            if (!_id) {
	                return;
	            }
	
	            var keepEmailSelected = fields.emailAddress.value;
	
	            return dispatch((0, _stateActions.deleteEmailServer)(_id)).then(function (newRecord) {
	                _this6.setState({ configsLoaded: {} }, function () {
	                    _this6.resetForm().then(function () {
	                        fields = _this6.setFormInputsByFormValues({ "emailAddress": keepEmailSelected }, fields);
	                        var forceTouche = false;
	                        fields = _this6.formInputsValidation(fields, forceTouche);
	                        _this6.setState({ fields: fields });
	                        _this6.setState({ isValidTheForm: true });
	                        _this6.setState({ isLoaded: true });
	                        _this6.setState({ saved: false });
	                        _this6.unTouchFields();
	                    });
	                });
	            });
	        }
	
	        /**
	         * Open test email modal
	         *
	         * @param {*} e
	         */
	    }, {
	        key: 'openTestMailModal',
	        value: function openTestMailModal(e) {
	            this.setState({ isOpenTestMailModal: true });
	        }
	
	        /**
	         * Close test email modal
	         */
	    }, {
	        key: 'closeTestMailModal',
	        value: function closeTestMailModal() {
	            this.setState({ isOpenTestMailModal: false });
	        }
	
	        /**
	         * Open ask delete modal
	         *
	         * @param {*} e
	         */
	    }, {
	        key: 'openAreYouSureModal',
	        value: function openAreYouSureModal(e) {
	            this.setState({ isOpenAreYouSureModal: true });
	        }
	
	        /**
	         * Close ask delete modal
	         */
	    }, {
	        key: 'closeAreYouSureModal',
	        value: function closeAreYouSureModal() {
	            this.setState({ isOpenAreYouSureModal: false });
	        }
	
	        /**
	         * This function will sent a test email to the given email address
	         * @param {*} toEmailAddress
	         * @returns {Promise} resolve when success, reject when error happen while sending the email.
	         */
	    }, {
	        key: 'sendTestEmail',
	        value: function sendTestEmail(toEmailAddress) {
	            var _this7 = this;
	
	            var dispatch = this.props.dispatch;
	            var fields = this.state.fields;
	
	            var data = this.fetchFormValues();
	            fields = this.setFormInputsByFormValues(data, fields);
	            var forceTouche = true;
	            fields = this.formInputsValidation(fields, forceTouche);
	            var isValidTheForm = this.setFormValidityFlag();
	
	            this.setState({ fields: fields });
	
	            // form validation can  prevent to step the wizard forward
	            if (!isValidTheForm) {
	                this.setState({ isLoaded: true });
	                return Promise.reject(_("noConfigurationToTest"));
	            }
	
	            // set the test recipient
	            data["toEmailAddress"] = toEmailAddress;
	
	            return new Promise(function (resolve, reject) {
	                return _this7.setState({ testEmailSent: false }, function () {
	                    dispatch((0, _stateActions.sendTestEmailWithConfig)(data)).then(function (result) {
	                        _this7.setState({ testEmailSent: result }, function () {
	                            return resolve(result);
	                        });
	                        return result;
	                    })['catch'](function (error) {
	                        _this7.setState({ onSendError: error }, function () {
	                            reject(error);
	                        });
	                        return error;
	                    });
	                });
	            });
	        }
	
	        /**
	         * This function provide a reference to an icon on a safe way. If icon not found
	         * return with a placeholder icon reference
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var _state3 = this.state;
	            var isLoaded = _state3.isLoaded;
	            var fields = _state3.fields;
	            var brokerOptions = _state3.brokerOptions;
	            var isValidTheForm = _state3.isValidTheForm;
	            var saved = _state3.saved;
	            var isOpenTestMailModal = _state3.isOpenTestMailModal;
	            var _state4 = this.state;
	            var configsLoaded = _state4.configsLoaded;
	            var onSendError = _state4.onSendError;
	            var isOpenAreYouSureModal = _state4.isOpenAreYouSureModal;
	
	            if (!isLoaded) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    'Loading...'
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'form',
	                    {
	                        onSubmit: function (e) {
	                            e.preventDefault();
	                        },
	                        className: _emailSetupScss2['default'].formContent
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _emailSetupScss2['default'].formInputContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _emailSetupScss2['default'].titleLabel },
	                            _("descriptionForEmailServerConfig")
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _emailSetupScss2['default'].formInputContainer },
	                        _react2['default'].createElement(
	                            'label',
	                            { className: _emailSetupScss2['default'].formLabel },
	                            _('emailAddress'),
	                            ':*',
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_emailSetupScss2['default'].icon, _emailSetupScss2['default'].iconMargined, _emailSetupScss2['default'].tooltip) },
	                                _react2['default'].createElement('img', { src: this.getIcon('a-info_1x.png') }),
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: (0, _classnames2['default'])(_emailSetupScss2['default'].tooltiptext, _emailSetupScss2['default'].w600) },
	                                    _("toolTipForEmailAddress")
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_emailSetupScss2['default'].formInput, _emailSetupScss2['default'].formInputCreatableSelect) },
	                            _react2['default'].createElement(_officeHelper2['default'], {
	                                value: this.findItemByValueFromSelectOptions(fields.emailAddress.value, brokerOptions),
	                                ref: 'emailAddress',
	                                name: 'emailAddress',
	                                onChange: function (value) {
	                                    var newEmailAddress = _nestedProperty2['default'].get(value, "value");
	
	                                    _this8.props.dispatch((0, _stateActions.loadEmailServer)(newEmailAddress)).then(function (configsResult) {
	                                        _this8.setState({ configsLoaded: configsResult }, function () {
	                                            _this8.resetForm();
	                                        });
	                                    })['catch'](function () {
	                                        _this8.setState({ configsLoaded: {} }, function () {
	                                            _this8.resetForm();
	                                        });
	                                    });
	
	                                    return _this8.onChangeFormInput(_nestedProperty2['default'].get(value, "value") || "", "emailAddress");
	                                },
	                                handleOnBlur: function (e) {},
	                                options: brokerOptions,
	                                isSearchable: true,
	                                isClearable: true,
	                                isMulti: false,
	                                isCreatableSelect: false
	                            })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _emailSetupScss2['default'].errorMessage },
	                                fields.emailAddress.error && fields.emailAddress.touched && fields.emailAddress.error
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _emailSetupScss2['default'].formInputContainer },
	                        _react2['default'].createElement(
	                            'label',
	                            { className: _emailSetupScss2['default'].formLabel },
	                            _('senderName'),
	                            ':*',
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_emailSetupScss2['default'].icon, _emailSetupScss2['default'].iconMargined, _emailSetupScss2['default'].tooltip) },
	                                _react2['default'].createElement('img', { src: this.getIcon('a-info_1x.png') }),
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: (0, _classnames2['default'])(_emailSetupScss2['default'].tooltiptext, _emailSetupScss2['default'].w600) },
	                                    _("toolTipForSenderName")
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement('input', {
	                            className: (0, _classnames2['default'])(_emailSetupScss2['default'].formInput, _emailSetupScss2['default'].formInputText, _emailSetupScss2['default'].fixIEHorizontals),
	                            type: 'text',
	                            value: fields.senderName.value,
	                            onChange: function (e) {
	                                return _this8.onChangeFormInput(e.target.value, "senderName");
	                            },
	                            onBlur: function (e) {
	                                var forceTouch = true;
	                                return _this8.onChangeFormInput(e.target.value, "senderName", forceTouch);
	                            },
	                            ref: 'senderName',
	                            name: 'senderName'
	                        }),
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _emailSetupScss2['default'].errorMessage },
	                                fields.senderName.error && fields.senderName.touched && fields.senderName.error
	                            )
	                        )
	                    ),
	                    saved && _react2['default'].createElement(
	                        'div',
	                        { className: _emailSetupScss2['default'].saveNotification },
	                        _('brokerEmailConfigurationsUpdatedFor') + " " + fields.emailAddress.value + " - " + (0, _moment2['default'])(_nestedProperty2['default'].get(configsLoaded, "updatedAt")).format("YYY/MM/DD HH:mm:ss."),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: _emailSetupScss2['default'].saveNotificationSmall },
	                            (0, _moment2['default'])(_nestedProperty2['default'].get(configsLoaded, "updatedAt")).format("SS")
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _emailSetupScss2['default'].buttonContainer },
	                        _react2['default'].createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: (0, _classnames2['default'])(_emailSetupScss2['default'].greyButton, !_nestedProperty2['default'].get(configsLoaded, "_id") ? "disabled" : "enabled", _emailSetupScss2['default'].buttonSizeM),
	                                onClick: function (e) {
	                                    _this8.openAreYouSureModal(e);
	                                },
	                                disabled: !_nestedProperty2['default'].get(configsLoaded, "_id")
	                            },
	                            _("deleteConfigs")
	                        ),
	                        _react2['default'].createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: _emailSetupScss2['default'].greyButton + (!isValidTheForm ? " disabled" : " enabled"),
	                                onClick: function (e) {
	                                    _this8.save(e);
	                                },
	                                disabled: !fields.emailAddress.value
	                            },
	                            _("save")
	                        )
	                    )
	                ),
	                _react2['default'].createElement(_testEmailDialog2['default'], {
	                    modalIsOpen: isOpenTestMailModal,
	                    cancelLabel: _("cancel"),
	                    confirmationLabel: _("send"),
	                    finishLabel: _("finish"),
	                    onCancel: function () {
	                        _this8.setState({ onSendError: null });
	                        _this8.closeTestMailModal();
	                    },
	                    onConfirmation: function (toEmailAddress) {
	                        return _this8.sendTestEmail(toEmailAddress).then(function (result) {
	                            _this8.setState({ onSendError: true });
	                        })['catch'](function (onSendErrorResult) {
	                            console.log("Target place onSendErrorResult: ", onSendErrorResult);
	                            _this8.setState({ onSendError: onSendErrorResult });
	                        });
	                    },
	                    onFinish: function () {
	                        _this8.setState({ onSendError: null });
	                        _this8.closeTestMailModal();
	                    },
	                    onSendResultMessage: onSendError
	                }),
	                _react2['default'].createElement(_areYouSureModal2['default'], {
	                    modalIsOpen: isOpenAreYouSureModal,
	                    title: _("emailSettingsAreYouSureModalTitle"),
	                    message: _("emailSettingsAreYouSureModalMessage"),
	                    cancelLabel: _("cancel"),
	                    confirmationLabel: _("delete"),
	                    onCancel: function () {
	                        _this8.closeAreYouSureModal();
	                    },
	                    onConfirmation: function (toEmailAddress) {
	                        return _this8['delete']().then(function () {
	                            _this8.closeAreYouSureModal();
	                        });
	                    }
	                })
	            );
	        }
	    }]);
	
	    var _EmailSetup = EmailSetup;
	    EmailSetup = (0, _reactRedux.connect)(function (state) {
	        return {
	            brokers: _nestedProperty2['default'].get(state, "office.brokers"),
	            accountManagers: _nestedProperty2['default'].get(state, "office.accountManagers"),
	            userId: _nestedProperty2['default'].get(state, "app.userId")
	        };
	    })(EmailSetup) || EmailSetup;
	    return EmailSetup;
	})(_react2['default'].Component);
	
	exports['default'] = EmailSetup;
	module.exports = exports['default'];
	/* <div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('host')}:*
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForHost")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
	       type="text"
	       value={fields.host.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.value, "host")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.value, "host", forceTouch)
	       }}
	       ref="host"
	       name="host"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.host.error && fields.host.touched &&
	               fields.host.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('port')}:*
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForPort")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
	       type="number"
	       value={fields.port.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.value, "port")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.value, "port", forceTouch)
	       }}
	       ref="port"
	       name="port"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.port.error && fields.port.touched &&
	               fields.port.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('secureConnection')}:
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForSecureConnection")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
	       type="checkbox"
	       checked={fields.secureConnection.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.checked, "secureConnection")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.checked, "secureConnection", forceTouch)
	       }}
	       ref="secureConnection"
	       name="secureConnection"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.secureConnection.error && fields.secureConnection.touched &&
	               fields.secureConnection.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('secure')}:
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForSecure")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
	       type="checkbox"
	       checked={fields.secure.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.checked, "secure")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.checked, "secure", forceTouch)
	       }}
	       ref="secure"
	       name="secure"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.secure.error && fields.secure.touched &&
	               fields.secure.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('autotls')}:
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForAutotls")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
	       type="checkbox"
	       checked={(!!(fields.autotls.value))}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.checked, "autotls")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.checked, "autotls", forceTouch)
	       }}
	       ref="autotls"
	       name="autotls"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.autotls.error && fields.autotls.touched &&
	               fields.autotls.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('tls_rejectUnauthorized')}:
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForTlsRejectUnauthorized")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
	       type="checkbox"
	       checked={fields.tls_rejectUnauthorized.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.checked, "tls_rejectUnauthorized")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.checked, "tls_rejectUnauthorized", forceTouch)
	       }}
	       ref="tls_rejectUnauthorized"
	       name="tls_rejectUnauthorized"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.tls_rejectUnauthorized.error && fields.tls_rejectUnauthorized.touched &&
	               fields.tls_rejectUnauthorized.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('auth_user')}:*
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForAuthUser")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
	       type="text"
	       value={fields.auth_user.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.value, "auth_user")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.value, "auth_user", forceTouch)
	       }}
	       ref="auth_user"
	       name="auth_user"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.auth_user.error && fields.auth_user.touched &&
	               fields.auth_user.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('auth_password')}:*
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForAuthPassword")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
	       type="password"
	       value={fields.auth_password.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.value, "auth_password")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.value, "auth_password", forceTouch)
	       }}
	       ref="auth_password"
	       name="auth_password"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.auth_password.error && fields.auth_password.touched &&
	               fields.auth_password.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('service')}:
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForService")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formInput, styles.formInputText, styles.fixIEHorizontals)}
	       type="text"
	       value={fields.service.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.value, "service")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.value, "service", forceTouch)
	       }}
	       ref="service"
	       name="service"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.service.error && fields.service.touched &&
	               fields.service.error}
	       </div>
	   </div>
	</div>
	{/* <div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('useBounce')}:
	           <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	               <img src={this.getIcon('a-info_1x.png')}/>
	               <span className={cs(styles.tooltiptext, styles.w600)}>
	                   {_("toolTipForUseBounce")}
	               </span>
	           </div>
	   </label>
	   <input
	       className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
	       type="checkbox"
	       checked={fields.useBounce.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.checked, "useBounce")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.checked, "useBounce", forceTouch)
	       }}
	       ref="useBounce"
	       name="useBounce"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.useBounce.error && fields.useBounce.touched &&
	               fields.useBounce.error}
	       </div>
	   </div>
	</div>
	<div className={styles.formInputContainer}>
	   <label className={styles.formLabel}>{_('active')}:
	       <div className={cs(styles.icon, styles.iconMargined, styles.tooltip)}>
	           <img src={this.getIcon('a-info_1x.png')}/>
	           <span className={cs(styles.tooltiptext, styles.w600)}>
	               {_("toolTipForActive")}
	           </span>
	       </div>
	   </label>
	   <input
	       className={cs(styles.formCheckbox, styles.formInputText, styles.fixIEHorizontals)}
	       type="checkbox"
	       checked={fields.active.value}
	       onChange={(e) => {
	           return this.onChangeFormInput(e.target.checked, "active")
	       }}
	       onBlur={(e) => {
	           let forceTouch = true
	           return this.onChangeFormInput(e.target.checked, "active", forceTouch)
	       }}
	       ref="active"
	       name="active"
	   />
	   <div>
	       <div className={styles.errorMessage}>
	           {fields.active.error && fields.active.touched &&
	               fields.active.error}
	       </div>
	   </div>
	</div> */ /* <button
	             type="button"
	             className={cs(styles.greyButton, ((!isValidTheForm) ? "disabled" : "enabled"), styles.buttonSizeM)}
	             onClick={(e)=>{ this.openTestMailModal(e) }}
	             disabled={!fields.emailAddress.value}
	          >
	             {_("sendTestEmail")}
	          </button> */

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var Employees = (function (_React$Component) {
		_inherits(Employees, _React$Component);
	
		function Employees() {
			_classCallCheck(this, _Employees);
	
			_get(Object.getPrototypeOf(_Employees.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Employees, [{
			key: 'render',
			value: function render() {
				var employees = this.props.employees;
	
				if (!employees) {
					return false;
				}
	
				return _react2['default'].createElement(
					'div',
					{ className: _reactableScss2['default'].tableContainer },
					_react2['default'].createElement(
						_componentsReactable.Table,
						{
							hideFilterInput: true,
							className: 'noPadding',
							itemsPerPage: 7,
							sortable: ['empFirstName', 'empLastName', 'empEmail', 'empMobileNumber', 'empPhoneNumber'],
							defaultSort: {
								column: 'empLastName',
								direction: 'desc'
							}
						},
						_react2['default'].createElement(
							_componentsReactable.Thead,
							null,
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empFirstName' },
								_react2['default'].createElement(
									'span',
									null,
									_('name_employees')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empLastName' },
								_react2['default'].createElement(
									'span',
									null,
									_('surname')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empEmail' },
								_react2['default'].createElement(
									'span',
									null,
									_('email')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empMobileNumber' },
								_react2['default'].createElement(
									'span',
									null,
									_('gsm')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empPhoneNumber' },
								_react2['default'].createElement(
									'span',
									null,
									_('telephone')
								)
							)
						),
						employees.map(function (item, key) {
							return _react2['default'].createElement(
								_componentsReactable.Tr,
								{ className: 'centered', key: key, data: item },
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empFirstName', data: item.firstName }),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empLastName', data: item.lastName }),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empEmail', data: item.email }),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empMobileNumber', data: item.mobileNumber }),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empPhoneNumber', data: item.phoneNumber })
							);
						})
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				employees: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		var _Employees = Employees;
		Employees = (0, _reactRedux.connect)(function (state) {
			var broker = state.office.brokers[state.app.brNr];
			var employees = broker && broker.staff;
			return { employees: employees };
		})(Employees) || Employees;
		return Employees;
	})(_react2['default'].Component);
	
	exports['default'] = Employees;
	module.exports = exports['default'];

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable import/no-extraneous-dependencies */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodashLang = __webpack_require__(78);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(57);
	
	var _stateActions = __webpack_require__(5);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _componentsSharedFormField = __webpack_require__(1144);
	
	var _componentsInput = __webpack_require__(109);
	
	var _componentsInput2 = _interopRequireDefault(_componentsInput);
	
	var _FinancesDocuments = __webpack_require__(1124);
	
	var _FinancesDocuments2 = _interopRequireDefault(_FinancesDocuments);
	
	var _FinancesTransactions = __webpack_require__(1125);
	
	var _FinancesTransactions2 = _interopRequireDefault(_FinancesTransactions);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _componentsSharedSelectSelectWrap2 = _interopRequireDefault(_componentsSharedSelectSelectWrap);
	
	var _translation = __webpack_require__(371);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var _FinancesScss = __webpack_require__(1619);
	
	var _FinancesScss2 = _interopRequireDefault(_FinancesScss);
	
	var Finances = (function (_Component) {
		_inherits(Finances, _Component);
	
		function Finances(props) {
			_classCallCheck(this, _Finances);
	
			_get(Object.getPrototypeOf(_Finances.prototype), 'constructor', this).call(this, props);
			var options = [{ value: 't', label: (0, _translation2['default'])('transacties') }, { value: 'd', label: (0, _translation2['default'])('documenten') }, { value: 'b', label: (0, _translation2['default'])('all') }];
			this.state = {
				msgHidden: true,
				activeTab: (0, _lodashLang.isEmpty)(props.documents) ? 't' : 'd',
				options: options
			};
		}
	
		_createClass(Finances, [{
			key: 'handleTabChange',
			value: function handleTabChange(activeTab) {
				this.setState({ activeTab: activeTab });
			}
		}, {
			key: 'saveForm',
			value: function saveForm(data) {
				var _this = this;
	
				var _props = this.props;
				var dispatch = _props.dispatch;
				var brNr = _props.brNr;
				var msgHidden = this.state.msgHidden;
	
				data.brokerNumber = brNr;
	
				if (!msgHidden) {
					this.setState({ msgHidden: true });
				}
	
				dispatch((0, _stateActions.fetchFinances)(data)).then(function (res) {
					var activeTab = data.type === 'b' ? 't' : data.type; // if type is 'b' (all) then show transactions, else show the type (e.g. 't' for transactions, 'd' for documents)
					_this.setState({ msgHidden: false, activeTab: activeTab });
	
					return res;
				})['catch'](function (err) {
					_this.setState({ msgHidden: false, activeTab: 't' });
	
					return err;
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var msgHidden = _state.msgHidden;
				var activeTab = _state.activeTab;
				var options = _state.options;
				var _props2 = this.props;
				var fields = _props2.fields;
				var handleSubmit = _props2.handleSubmit;
				var documents = _props2.documents;
				var items = _props2.items;
				var summary = _props2.summary;
				var startDateField = fields.startDate;
				var endDateField = fields.endDate;
				var contractNumberField = fields.contractNumber;
				var typeField = fields.type;
	
				return _react2['default'].createElement(
					'div',
					{ className: _FinancesScss2['default'].officeFinances },
					_react2['default'].createElement(
						'form',
						{ onSubmit: handleSubmit(this.saveForm.bind(this)) },
						_react2['default'].createElement(
							'div',
							{ className: _FinancesScss2['default'].submitContainer },
							_react2['default'].createElement(
								_componentsSharedFormField.FormField,
								{ label: (0, _translation2['default'])('from'), field: startDateField, className: _FinancesScss2['default'].inputContainer },
								_react2['default'].createElement(_componentsSharedDatePicker.DatePicker, _extends({
									id: (0, _translation2['default'])('from'),
									name: (0, _translation2['default'])('from'),
									className: _FinancesScss2['default'].inputForm
								}, startDateField, {
									startDate: startDateField.value,
									endDate: endDateField.value
								}))
							),
							_react2['default'].createElement(
								_componentsSharedFormField.FormField,
								{ label: (0, _translation2['default'])('to'), field: endDateField, className: _FinancesScss2['default'].inputContainer },
								_react2['default'].createElement(_componentsSharedDatePicker.DatePicker, _extends({
									id: (0, _translation2['default'])('to'),
									name: (0, _translation2['default'])('to'),
									className: _FinancesScss2['default'].inputForm
								}, endDateField, {
									startDate: startDateField.value,
									endDate: endDateField.value
								}))
							),
							_react2['default'].createElement(
								_componentsSharedFormField.FormField,
								{ label: (0, _translation2['default'])('policy'), field: contractNumberField, className: _FinancesScss2['default'].inputContainer },
								_react2['default'].createElement(_componentsInput2['default'], {
									type: 'text',
									id: (0, _translation2['default'])('policy'),
									name: (0, _translation2['default'])('policy'),
									className: _FinancesScss2['default'].inputForm,
									value: contractNumberField.value,
									onChange: contractNumberField.onChange // eslint-disable-line react/jsx-handler-names
								})
							),
							_react2['default'].createElement(
								_componentsSharedFormField.FormField,
								{ label: (0, _translation2['default'])('type'), field: typeField, className: _FinancesScss2['default'].inputContainer },
								_react2['default'].createElement(_componentsSharedSelectSelectWrap2['default'], {
									isClearable: false,
									id: (0, _translation2['default'])('type'),
									name: (0, _translation2['default'])('type'),
									options: options,
									value: typeField.value,
									onChange: typeField.onChange, // eslint-disable-line react/jsx-handler-names
									className: _FinancesScss2['default'].inputForm
								})
							),
							_react2['default'].createElement(
								'button',
								{ type: 'submit', className: _FinancesScss2['default'].submitButton },
								(0, _translation2['default'])('search')
							)
						)
					),
					!(0, _lodashLang.isEmpty)(items) || !(0, _lodashLang.isEmpty)(documents) ? _react2['default'].createElement(
						'div',
						{ className: _FinancesScss2['default'].results },
						_react2['default'].createElement(
							'div',
							{ className: _FinancesScss2['default'].subNavigationCont },
							_react2['default'].createElement(
								'div',
								{ className: _FinancesScss2['default'].subNav },
								!(0, _lodashLang.isEmpty)(items) && _react2['default'].createElement(
									'div',
									{ className: _FinancesScss2['default'].catCont },
									_react2['default'].createElement(
										'a',
										{
											onClick: this.handleTabChange.bind(this, 't'),
											className: activeTab === "t" ? '' + _FinancesScss2['default'].active : '' + _FinancesScss2['default'].inactive
										},
										(0, _translation2['default'])('transacties')
									)
								),
								!(0, _lodashLang.isEmpty)(documents) && _react2['default'].createElement(
									'div',
									{ className: _FinancesScss2['default'].catCont },
									_react2['default'].createElement(
										'a',
										{
											onClick: this.handleTabChange.bind(this, 'd'),
											className: activeTab === "d" ? '' + _FinancesScss2['default'].active : '' + _FinancesScss2['default'].inactive
										},
										(0, _translation2['default'])('documenten')
									)
								)
							)
						),
						activeTab === "t" ? _react2['default'].createElement(_FinancesTransactions2['default'], { items: items, summary: summary }) : _react2['default'].createElement(_FinancesDocuments2['default'], { docs: documents })
					) : Boolean(msgHidden) || _react2['default'].createElement(
						'p',
						null,
						(0, _translation2['default'])('polisError')
					)
				);
			}
		}]);
	
		var _Finances = Finances;
		Finances = (0, _reactRedux.connect)(function (_ref) {
			var app = _ref.app;
			var finances = _ref.finances;
			return {
				items: finances.items,
				documents: finances.documents,
				summary: finances.summary,
				brNr: app.brNr
			};
		})(Finances) || Finances;
		Finances = (0, _reduxForm.reduxForm)({
			form: 'finances',
			fields: ['startDate', 'endDate', 'contractNumber', 'type'],
			initialValues: {
				startDate: '',
				endDate: '',
				contractNumber: '',
				type: 'b' }
		})(Finances) || Finances;
		return Finances;
	})(_react.Component);
	
	exports.Finances = Finances;
	
	Finances.propTypes = {
		dispatch: _react.PropTypes.func,
		brNr: _react.PropTypes.string,
		fields: _react.PropTypes.object,
		handleSubmit: _react.PropTypes.func,
		documents: _react.PropTypes.arrayOf(_react.PropTypes.object),
		items: _react.PropTypes.arrayOf(_react.PropTypes.object),
		summary: _react.PropTypes.object
	};
	// default value for type is 'b' (all)

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable import/no-extraneous-dependencies */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libHelpers = __webpack_require__(24);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _translation = __webpack_require__(371);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var Documents = function Documents(_ref) {
		var docs = _ref.docs;
	
		var formatedDates = docs ? docs.map(function (item) {
			return _extends({}, item, { documentDate: (0, _moment2['default'])(item.documentDate).format("DD-MM-YYYY") });
		}) : [];
	
		return _react2['default'].createElement(
			'div',
			{ className: 'docContainer' },
			_react2['default'].createElement(
				_componentsReactable.Table,
				{
					className: 'table',
					itemsPerPage: 10,
					filterable: ['documentType', 'documentDate'],
					sortable: [{ column: 'documentDate', sortFunction: 'Date' }, 'documentType'],
					defaultSort: {
						column: 'documentDate',
						direction: 'desc'
					}
				},
				_react2['default'].createElement(
					_componentsReactable.Thead,
					null,
					_react2['default'].createElement(_componentsReactable.Th, { column: 'documentIcon', label: '' }),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'documentType' },
						_react2['default'].createElement(
							'span',
							null,
							(0, _translation2['default'])('fileType')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'documentDate' },
						_react2['default'].createElement(
							'span',
							null,
							(0, _translation2['default'])('fileDate')
						)
					)
				),
				formatedDates.map(function (item, key) {
					return _react2['default'].createElement(
						_componentsReactable.Tr,
						{
							className: 'docRow',
							onClick: function () {
								return window.open('/data/document?id=' + item.documentId, '_blank', 'noopener,noreferrer');
							}, key: key,
							data: item
						},
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'documentIcon' },
							_react2['default'].createElement(
								'div',
								{ className: 'rowIcon' },
								_react2['default'].createElement('img', { src: __webpack_require__(172) })
							)
						),
						_react2['default'].createElement(_componentsReactable.Td, { className: 'documentType', column: 'documentType' }),
						_react2['default'].createElement(_componentsReactable.Td, { column: 'documentDate', data: (0, _libHelpers.dateFormatter)(item.documentDate) })
					);
				})
			)
		);
	};
	Documents.propTypes = {
		docs: _react.PropTypes.arrayOf(_react.PropTypes.object)
	};
	
	exports['default'] = Documents;
	module.exports = exports['default'];

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable import/no-extraneous-dependencies */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libHelpers = __webpack_require__(24);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _rcTooltip = __webpack_require__(1906);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _FinancesTransactionsScss = __webpack_require__(1620);
	
	var _FinancesTransactionsScss2 = _interopRequireDefault(_FinancesTransactionsScss);
	
	var _translation = __webpack_require__(371);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var FinancesTooltip = function FinancesTooltip(_ref) {
		var id = _ref.id;
		var children = _ref.children;
		return _react2['default'].createElement(
			_rcTooltip2['default'],
			{
				placement: 'top',
				trigger: ['hover'],
				overlay: _react2['default'].createElement(
					'div',
					{ style: { maxWidth: '10em' } },
					(0, _translation2['default'])(id)
				),
				transitionName: 'rc-tooltip-zoom',
				mouseEnterDelay: 0.1
			},
			children
		);
	};
	FinancesTooltip.propTypes = {
		id: _react.PropTypes.string.isRequired,
		children: _react.PropTypes.node.isRequired
	};
	
	var Transactions = function Transactions(_ref2) {
		var items = _ref2.items;
		var summary = _ref2.summary;
	
		var formatedDates = items ? items.map(function (item) {
			return _extends({}, item, { date: (0, _moment2['default'])(item.date).format("DD-MM-YYYY") });
		}) : [];
		return _react2['default'].createElement(
			'div',
			{ className: '' + _FinancesTransactionsScss2['default'].transContainer },
			_react2['default'].createElement(
				'div',
				{ className: '' + _FinancesTransactionsScss2['default'].summaryContainer },
				_react2['default'].createElement(
					'div',
					{ className: '' + _FinancesTransactionsScss2['default'].summary },
					(0, _lodashCollection.map)(summary, function (item, key) {
						return _react2['default'].createElement(
							'div',
							{ key: key, className: '' + _FinancesTransactionsScss2['default'].field },
							_react2['default'].createElement(
								'div',
								{ className: '' + _FinancesTransactionsScss2['default'].label },
								_react2['default'].createElement(
									'p',
									null,
									(0, _translation2['default'])(key)
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: '' + _FinancesTransactionsScss2['default'].input },
								_react2['default'].createElement('input', { disabled: 'true', type: 'text', value: item })
							)
						);
					})
				)
			),
			_react2['default'].createElement(
				_componentsReactable.Table,
				{
					itemsPerPage: 15,
					filterable: ['date', 'reference', 'invoiceNumber', 'contractNumber', 'client', 'insuranceCompany', 'dueDate', 'transactionType', 'description', 'debitCode', 'debitAmount', 'creditCode', 'creditAmount'],
					sortable: [{ column: 'date', sortFunction: 'Date' }, 'reference', 'invoiceNumber', 'contractNumber', 'client', 'insuranceCompany', 'dueDate', 'transactionType', 'description', 'debitCode', 'debitAmount', 'creditCode', 'creditAmount'],
					defaultSort: {
						column: 'date',
						direction: 'desc'
					}
				},
				_react2['default'].createElement(
					_componentsReactable.Thead,
					null,
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'date' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'dateTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('date')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'reference' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'referenceTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('reference')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'invoiceNumber' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'invoiceNumberTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('invoiceNumber')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'contractNumber' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'contractNumberTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('contractNumber')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'client' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'clientTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('client')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'insuranceCompany' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'insuranceCompanyTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('insuranceCompany')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'dueDate' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'dueDateTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('dueDate')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'transactionType' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'transactionTypeTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('transactionType')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'description' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'descriptionTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('description')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'debitCode' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'commTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('debitCode')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'debitAmount' },
						_react2['default'].createElement(
							'span',
							null,
							(0, _translation2['default'])('debitAmount')
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'creditCode' },
						_react2['default'].createElement(
							FinancesTooltip,
							{ id: 'commTT' },
							_react2['default'].createElement(
								'span',
								null,
								(0, _translation2['default'])('creditCode')
							)
						)
					),
					_react2['default'].createElement(
						_componentsReactable.Th,
						{ column: 'creditAmount' },
						_react2['default'].createElement(
							'span',
							null,
							(0, _translation2['default'])('creditAmount')
						)
					)
				),
				formatedDates.map(function (item, key) {
					return _react2['default'].createElement(
						_componentsReactable.Tr,
						{ className: 'centered', key: key, data: item },
						_react2['default'].createElement(_componentsReactable.Td, { className: 'bhkDatum', column: 'date', data: (0, _libHelpers.dateFormatter)(item.date) }),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'reference' },
							item.reference
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'invoiceNumber' },
							item.invoiceNumber
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'contractNumber' },
							item.contractNumber
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'client' },
							item.client
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'insuranceCompany' },
							item.insuranceCompany
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'dueDate' },
							item.dueDate.slice(2, 4) + '/' + item.dueDate.slice(0, 2)
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'transactionType' },
							item.transactionType
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'description' },
							item.description
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'debitCode' },
							item.debitCode
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'debitAmount', value: Number(item.debitAmount) },
							item.debitAmount
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'creditCode' },
							item.creditCode
						),
						_react2['default'].createElement(
							_componentsReactable.Td,
							{ column: 'creditAmount', value: Number(item.creditAmount) },
							item.creditAmount
						)
					);
				})
			)
		);
	};
	Transactions.propTypes = {
		items: _react.PropTypes.array,
		summary: _react.PropTypes.object.isRequired
	};
	
	exports['default'] = Transactions;
	module.exports = exports['default'];

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Finances = __webpack_require__(1123);
	
	Object.defineProperty(exports, "Finances", {
	  enumerable: true,
	  get: function get() {
	    return _Finances.Finances;
	  }
	});

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _indexScss = __webpack_require__(721);
	
	var _indexScss2 = _interopRequireDefault(_indexScss);
	
	var _General = __webpack_require__(1117);
	
	var _General2 = _interopRequireDefault(_General);
	
	var _finances = __webpack_require__(1126);
	
	var _employees = __webpack_require__(1122);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _contacts = __webpack_require__(370);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _management = __webpack_require__(1128);
	
	var _management2 = _interopRequireDefault(_management);
	
	var _AdminDocs = __webpack_require__(1116);
	
	var _AdminDocs2 = _interopRequireDefault(_AdminDocs);
	
	var _signature = __webpack_require__(1130);
	
	var _signature2 = _interopRequireDefault(_signature);
	
	var _emailSetup = __webpack_require__(1121);
	
	var _emailSetup2 = _interopRequireDefault(_emailSetup);
	
	var _BrokerSelector = __webpack_require__(593);
	
	var _BrokerSelector2 = _interopRequireDefault(_BrokerSelector);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('office');
	
	// This relies on object iteration being specified-order, which it normally is
	var SubNav = function SubNav(_ref) {
		var currentId = _ref.currentId;
		var items = _ref.items;
		var onChange = _ref.onChange;
		return _react2['default'].createElement(
			'div',
			{ className: '' + _indexScss2['default'].headingDiv },
			Object.keys(items).map(function (moduleId) {
				return _react2['default'].createElement(
					'div',
					{
						key: moduleId,
						className: _indexScss2['default'].headingCell + ' info ' + (currentId === moduleId ? '' + _indexScss2['default'].active : ''),
						onClick: function () {
							return onChange(moduleId);
						}
					},
					items[moduleId]
				);
			})
		);
	};
	
	var Index = (function (_React$Component) {
		_inherits(Index, _React$Component);
	
		function Index() {
			_classCallCheck(this, _Index);
	
			_get(Object.getPrototypeOf(_Index.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Index, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _props = this.props;
				var dispatch = _props.dispatch;
				var hasInternalAccess = _props.hasInternalAccess;
	
				dispatch((0, _stateActions.fetchOfficeData)(hasInternalAccess));
			}
		}, {
			key: 'setSubModule',
			value: function setSubModule(subModuleName) {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.setOpened)(subModuleName));
				dispatch((0, _stateActions.closeSignature)());
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props2 = this.props;
				var subModule = _props2.subModule;
				var officeData = _props2.officeData;
				var brNr = _props2.brNr;
				var brokers = _props2.brokers;
				var currentBrNr = _props2.currentBrNr;
				var security = _props2.security;
				var createmail = _props2.createmail;
				var dispatch = _props2.dispatch;
				var signatureZoom = _props2.signatureZoom;
				var hasInternalAccess = _props2.hasInternalAccess;
	
				var output = undefined,
				    tabItems = {
					general: _('info'),
					employees: _('workers'),
					contacts: _('contacts'),
					management: _('management')
				};
				// compose the tab items by security attributes in order
				var extraTabs = { finances: _('accounting') };
				var lastTabs = { adminDocs: _('adminDocs') };
				if (createmail) {
					lastTabs['signature'] = _('signature');
				}
	
				lastTabs['emailSetup'] = _('emailSetup');
	
				var extraIsVisible = security && security.brokerAccountingVisible && security.brokerAccountingVisible === "true" && true || false;
				tabItems = extraIsVisible && _extends({}, tabItems, extraTabs) || tabItems;
				tabItems = _extends({}, tabItems, lastTabs);
	
				switch (subModule) {
					case 'general':
						output = _react2['default'].createElement(_General2['default'], null);
						break;
					case 'employees':
						output = _react2['default'].createElement(_employees2['default'], null);
						break;
					case 'contacts':
						output = _react2['default'].createElement(_contacts2['default'], null);
						break;
					case 'management':
						output = _react2['default'].createElement(_management2['default'], null);
						break;
					case 'finances':
						output = _react2['default'].createElement(_finances.Finances, null);
						break;
					case 'adminDocs':
						output = _react2['default'].createElement(_AdminDocs2['default'], null);
						break;
					case 'signature':
						output = _react2['default'].createElement(_signature2['default'], { dispatch: dispatch });
						break;
					case 'emailSetup':
						output = _react2['default'].createElement(_emailSetup2['default'], { dispatch: dispatch });
						break;
					default:
						output = _react2['default'].createElement(
							'div',
							null,
							'Unknown submodule!'
						);
						break;
				}
	
				// if (!officeData) {
				// 	return false
				// }
	
				// you can not change broker when editing a signature.
				var brokerSelectorIsDisabled = Boolean(subModule == 'signature' && signatureZoom && signatureZoom.visible);
				// introduce internal security check
				return _react2['default'].createElement(
					'div',
					{ id: '' + _indexScss2['default'].officeModule },
					_react2['default'].createElement(
						'div',
						{ className: '' + _indexScss2['default'].office },
						_react2['default'].createElement(
							'div',
							{ className: '' + _indexScss2['default'].mainTitleDiv },
							_react2['default'].createElement(
								'div',
								{ className: '' + _indexScss2['default'].mainTitleContainer },
								_react2['default'].createElement(
									'h2',
									{ className: '' + _indexScss2['default'].mainTitle },
									_('title'),
									_react2['default'].createElement(_BrokerSelector2['default'], {
										brokers: brokers,
										setBrNr: _stateActions.setBrNr,
										brNr: currentBrNr,
										disabled: brokerSelectorIsDisabled,
										customClass: _indexScss2['default'].officeNumber
									})
								),
								_react2['default'].createElement(
									'h3',
									null,
									_('subtitle')
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ id: '' + _indexScss2['default'].officeNavigation },
							_react2['default'].createElement(SubNav, {
								currentId: subModule,
								items: tabItems,
								onChange: function (id) {
									return _this.setSubModule(id);
								}
							})
						),
						_react2['default'].createElement(
							'div',
							{ id: 'officeMain', className: 'module-wrap' },
							output
						)
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				dispatch: _react2['default'].PropTypes.func.isRequired,
				officeData: _react2['default'].PropTypes.object,
				brokers: _react2['default'].PropTypes.object,
				currentBrNr: _react2['default'].PropTypes.string,
				subModule: _react2['default'].PropTypes.string,
				security: _react2['default'].PropTypes.object,
				signatureZoom: _react2['default'].PropTypes.object,
				createmail: _react2['default'].PropTypes.bool
			},
			enumerable: true
		}]);
	
		var _Index = Index;
		Index = (0, _reactRedux.connect)(function (state) {
			var currentBrNr = state.app.brNr;
			var brokers = state.office.brokers;
			var subModule = state.app.opened || 'general';
			var officeData = state.office.brokers[currentBrNr];
			var security = state.app.security;
			var clientAccess = state.app.security.actions;
			var createmail = clientAccess && clientAccess.filter(function (item) {
				return item.actionName == "createmail" && item.actionAllowed == "true";
			}).length > 0;
			var hasInternalAccess = state.app.userTypeId === '1' || state.app.userTypeId === '3' ? true : false;
	
			// console.log('from connect currentBrNr: ', currentBrNr);
			// const hasInternalAccess = security.actions.filter((item) => (item.actionName == "internal" && item.actionAllowed == "true")).length > 0
			return {
				brokers: brokers,
				officeData: officeData,
				currentBrNr: currentBrNr,
				subModule: subModule,
				security: security,
				createmail: createmail,
				signatureZoom: state.office.signatureZoom,
				hasInternalAccess: hasInternalAccess
			};
		})(Index) || Index;
		return Index;
	})(_react2['default'].Component);
	
	exports['default'] = Index;
	module.exports = exports['default'];

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var Management = (function (_React$Component) {
		_inherits(Management, _React$Component);
	
		function Management() {
			_classCallCheck(this, _Management);
	
			_get(Object.getPrototypeOf(_Management.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Management, [{
			key: 'render',
			value: function render() {
				var accountManagers = this.props.accountManagers;
	
				if (!accountManagers) {
					return false;
				}
	
				return _react2['default'].createElement(
					'div',
					{ className: _reactableScss2['default'].tableContainer },
					_react2['default'].createElement(
						_componentsReactable.Table,
						{
							hideFilterInput: true,
							className: 'noPadding',
							itemsPerPage: 7,
							sortable: ['empFirstName', 'empLastName', 'empEmail', 'empMobileNumber'],
							defaultSort: {
								column: 'empFirstName',
								direction: 'desc'
							}
						},
						_react2['default'].createElement(
							_componentsReactable.Thead,
							null,
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empFirstName' },
								_react2['default'].createElement(
									'span',
									null,
									_('name')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empLastName' },
								_react2['default'].createElement(
									'span',
									null,
									_('category')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empEmail' },
								_react2['default'].createElement(
									'span',
									null,
									_('email')
								)
							),
							_react2['default'].createElement(
								_componentsReactable.Th,
								{ column: 'empMobileNumber' },
								_react2['default'].createElement(
									'span',
									null,
									_('gsm')
								)
							)
						),
						accountManagers && typeof Array.isArray(accountManagers) && accountManagers.length > 0 && accountManagers.map(function (item, key) {
							return _react2['default'].createElement(
								_componentsReactable.Tr,
								{ className: 'centered', key: key, data: item },
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empFirstName', data: item.Name }),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empLastName', data: item.category }),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empEmail', data: item.email }),
								_react2['default'].createElement(_componentsReactable.Td, { column: 'empMobileNumber', data: item.mobileNumber })
							);
						})
					)
				);
			}
		}], [{
			key: 'propTypes',
			value: {
				accountManagers: _react2['default'].PropTypes.array
			},
			enumerable: true
		}]);
	
		var _Management = Management;
		Management = (0, _reactRedux.connect)(function (state) {
			return {
				accountManagers: state.office.accountManagers
			};
		})(Management) || Management;
		return Management;
	})(_react2['default'].Component);
	
	exports['default'] = Management;
	module.exports = exports['default'];

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _officeHelperScss = __webpack_require__(1621);
	
	var _officeHelperScss2 = _interopRequireDefault(_officeHelperScss);
	
	var _reactSelectLibCreatable = __webpack_require__(165);
	
	var _reactSelectLibCreatable2 = _interopRequireDefault(_reactSelectLibCreatable);
	
	var _reactSelect = __webpack_require__(105);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('dswizard');
	
	var selectInFocusWithin = false;
	/**
	 * Customization object for the react-select using the same style like other components on tha site.
	 */
	var customCreatableSelectStyles = {
	    control: function control(base, state) {
	        selectInFocusWithin = state.isFocused;
	        return _extends({}, base, {
	            flex: "4",
	            fontSize: "12px",
	            display: "flex",
	            justifyContent: "flex-end",
	            alignItems: "flex-end",
	            color: "black",
	            backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
	            borderColor: "#d9d9d9 #ccc #b3b3b3",
	            borderRadius: "2px",
	            border: "1px solid #d9d9d9",
	            minHeight: "25px",
	            maxHeight: "auto",
	            //height: state.isFocused ? "auto" : "25px",
	            boxShadow: state.isFocused ? null : null,
	            "&:hover": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            "&:focus": {
	                borderColor: "#d9d9d9 #ccc #b3b3b3"
	            },
	            padding: 0,
	            margin: 0,
	            overflow: state.isFocused ? null : "hidden"
	        });
	    },
	    menu: function menu(base) {
	        return _extends({}, base, {
	            borderRadius: 2,
	            hyphens: "auto",
	            marginTop: 0,
	            textAlign: "left",
	            wordWrap: "break-word",
	            color: "black"
	        });
	    },
	    menuList: function menuList(base) {
	        return _extends({}, base, {
	            padding: 0,
	            verticalAlign: "baseline",
	            color: "black"
	        });
	    },
	    singleValue: function singleValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            color: "black"
	        });
	    },
	    multiValue: function multiValue(base, state) {
	        return _extends({}, base, {
	            minHeight: "16px",
	            lineHeight: "14px",
	            maxHeight: "18px",
	            border: "0.5px solid #003366",
	            background: '#003366',
	            color: "black",
	            div: {
	                color: "black",
	                fontSize: '1.2em',
	                lineHeight: '0.8em'
	            }
	        });
	    },
	    /* noOptionsMessage: (base, state) => ({
	      ...base,
	      padding: 0,
	      height: "20px",
	      lineHeight: "16px"
	    }), */
	    option: function option(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            fontSize: '1em',
	            maxHeight: "25px"
	        });
	    },
	    //color: "black"
	    valueContainer: function valueContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            top: 0
	        });
	    },
	    multiValueRemove: function multiValueRemove(base, state) {
	        return _extends({}, base, {
	            display: state.isDisabled ? "none" : null,
	            padding: 0
	        });
	    },
	    clearIndicator: function clearIndicator(base, state) {
	        return _extends({}, base, {
	            padding: 0
	        });
	    },
	    dropdownIndicator: function dropdownIndicator(base, state) {
	        return _extends({}, base, {
	            marginTop: 0,
	            padding: 0
	        });
	    },
	    indicatorsContainer: function indicatorsContainer(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "23px",
	            top: 0
	        });
	    },
	    indicatorSeparator: function indicatorSeparator(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "0",
	            top: 0
	        });
	    },
	    group: function group(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            top: 0
	        });
	    },
	    groupHeading: function groupHeading(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            top: 0
	        });
	    },
	    input: function input(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: "2px 0 0 0",
	            height: "20px",
	            top: 0,
	            fontSize: '1.2em',
	            lineHeight: '0.8em',
	            width: selectInFocusWithin ? '100%!important' : 'auto',
	            div: {
	                width: selectInFocusWithin ? '100%!important' : 'auto',
	                input: {
	                    width: selectInFocusWithin ? '100%!important' : 'auto'
	                }
	            }
	        });
	    },
	    noOptionsMessage: function noOptionsMessage(base, state) {
	        return _extends({}, base, {
	            padding: 0,
	            margin: 0,
	            height: "20px",
	            fontSize: '1em'
	        });
	    },
	    placeholder: function placeholder(base, state) {
	        return _extends({}, base, {
	            fontSize: '1.1em',
	            lineHeight: '1.1em'
	        });
	    }
	};
	
	exports.customCreatableSelectStyles = customCreatableSelectStyles;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var DropdownIndicator = function DropdownIndicator(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.DropdownIndicator,
	        props,
	        _react2['default'].createElement(
	            'span',
	            { className: _officeHelperScss2['default'].downArrowHolder },
	            _react2['default'].createElement('span', { className: _officeHelperScss2['default'].downArrow })
	        )
	    );
	};
	
	exports.DropdownIndicator = DropdownIndicator;
	/**
	 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
	 * @param {object} props
	 */
	var NoOptionsMessage = function NoOptionsMessage(props) {
	    return _reactSelect.components.DropdownIndicator && _react2['default'].createElement(
	        _reactSelect.components.NoOptionsMessage,
	        props,
	        _('noOptions')
	    );
	};
	
	exports.NoOptionsMessage = NoOptionsMessage;
	var getDeleteIcon = function getDeleteIcon() {
	    try {
	        return __webpack_require__(79);
	    } catch (err) {
	        return __webpack_require__(23);
	    }
	};
	
	/**
	 *
	 * @param {*} props
	 */
	var SelectRemovableOption = function SelectRemovableOption(props) {
	    return _react2['default'].createElement(
	        'div',
	        { className: _officeHelperScss2['default'].creatableOptionContainer },
	        _react2['default'].createElement(_reactSelect.components.Option, _extends({}, props, { className: _officeHelperScss2['default'].creatableOptionItem })),
	        props.data.isRecent ? _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(
	                'button',
	                { type: 'button', className: _officeHelperScss2['default'].creatableOptionItem, onClick: function (event) {
	                        event.preventDefault();
	                        props['delete'](props.value);
	                    } },
	                _react2['default'].createElement('img', { src: getDeleteIcon() })
	            )
	        ) : null
	    );
	};
	
	/**
	 * This is a custom MultiValueRemove for react select to be able set a separate unremovable value in dropdown
	 * but the rest is still dynamic
	 * @param {object} props
	 */
	var MultiValueRemove = function MultiValueRemove(props) {
	    return _react2['default'].createElement(
	        _reactSelect.components.MultiValueRemove,
	        props,
	        !props.data.isPermanentSelected ? props.children : null
	    );
	};
	
	var ValueContainer = function ValueContainer(_ref) {
	    var children = _ref.children;
	
	    var props = _objectWithoutProperties(_ref, ['children']);
	
	    return _react2['default'].createElement(
	        _reactSelect.components.ValueContainer,
	        _extends({}, props, { className: _officeHelperScss2['default'].selectValueContainer }),
	        _react2['default'].createElement(
	            'div',
	            { className: _officeHelperScss2['default'].composeRecipients },
	            children
	        )
	    );
	};
	
	/**
	 * To validate the inserting value you can use this property for CreatableSelect
	 */
	
	var CustomSelect = (function (_React$Component) {
	    _inherits(CustomSelect, _React$Component);
	
	    _createClass(CustomSelect, null, [{
	        key: 'propTypes',
	        value: {
	            formatCreateLabel: _react2['default'].PropTypes.string,
	            customClassName: _react2['default'].PropTypes.string,
	            handleOnBlur: _react2['default'].PropTypes.func,
	            setDeleteItemByOption: _react2['default'].PropTypes.func,
	            showExtraButton: _react2['default'].PropTypes.bool,
	            onClickExtraButton: _react2['default'].PropTypes.func
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            isCreatableSelect: false
	        },
	        enumerable: true
	    }]);
	
	    function CustomSelect(props) {
	        _classCallCheck(this, CustomSelect);
	
	        _get(Object.getPrototypeOf(CustomSelect.prototype), 'constructor', this).call(this, props);
	    }
	
	    /**
	     * Must handle on blur because else loose values. ()
	     * @param {*} event
	     */
	
	    _createClass(CustomSelect, [{
	        key: 'handleOnBlur',
	        value: function handleOnBlur(event) {
	            var onChange = this.props.onChange;
	
	            onChange({ label: event.target.value, value: event.target.value });
	            return newValue;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var handleOnBlur = _props.handleOnBlur;
	            var customClassName = _props.customClassName;
	            var showExtraButton = _props.showExtraButton;
	            var onClickExtraButton = _props.onClickExtraButton;
	            var setDeleteItemByOption = _props.setDeleteItemByOption;
	
	            // placeholder={_('searchPromptText')}
	            return _react2['default'].createElement(_reactSelect2['default'], _extends({}, this.props, {
	                onBlur: function (e) {
	                    if (handleOnBlur) {
	                        handleOnBlur(e);
	                    } else {
	                        _this.handleOnBlur(e);
	                    }
	                },
	                openMenuOnFocus: true,
	                placeholder: '',
	                onBlurResetsInput: false,
	                isSearchable: true,
	                styles: customCreatableSelectStyles,
	                components: {
	                    DropdownIndicator: DropdownIndicator,
	                    NoOptionsMessage: NoOptionsMessage,
	                    Option: function Option(p) {
	                        return SelectRemovableOption(_extends({}, p, { 'delete': setDeleteItemByOption }));
	                    },
	                    MultiValueRemove: MultiValueRemove,
	                    ValueContainer: ValueContainer
	                },
	                className: customClassName,
	                showExtraButton: showExtraButton && !isDisabled,
	                onClickExtraButton: onClickExtraButton
	            }));
	        }
	    }]);
	
	    return CustomSelect;
	})(_react2['default'].Component);
	
	exports['default'] = CustomSelect;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _signatureZoom = __webpack_require__(1132);
	
	var _signatureZoom2 = _interopRequireDefault(_signatureZoom);
	
	var _signatureList = __webpack_require__(1131);
	
	var _signatureList2 = _interopRequireDefault(_signatureList);
	
	var _signatureGenerator = __webpack_require__(608);
	
	var _signatureGenerator2 = _interopRequireDefault(_signatureGenerator);
	
	var _signaturesScss = __webpack_require__(439);
	
	var _signaturesScss2 = _interopRequireDefault(_signaturesScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _ = (0, _libI18n2['default'])('office');
	
	/* export const SignatureNameValue = ({signature}) => {
		const {name} = signature
		if (!name) {return <span>? ?</span>}
		const fullName = name.first + ' ' + name.last
		return (
			<div>{fullName}</div>
		)
	}
	
	SignatureNameValue.propTypes = {
		signature: PropTypes.object,
	} */
	
	var Signature = (function (_React$Component) {
	    _inherits(Signature, _React$Component);
	
	    _createClass(Signature, null, [{
	        key: 'propTypes',
	        value: {
	            signatures: _react2['default'].PropTypes.array,
	            signatureZoom: _react2['default'].PropTypes.object,
	            signatureModal: _react2['default'].PropTypes.object,
	            dispatch: _react2['default'].PropTypes.func.isRequired,
	            lang: _react.PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    function Signature(props) {
	        _classCallCheck(this, _Signature);
	
	        _get(Object.getPrototypeOf(_Signature.prototype), 'constructor', this).call(this, props);
	        this.onSignatureClicked = this.onSignatureClicked.bind(this);
	        this.onRemoveSignature = this.onRemoveSignature.bind(this);
	        this.onCloseSignature = this.onCloseSignature.bind(this);
	        this.onSaveSignature = this.onSaveSignature.bind(this);
	
	        this.state = { canGenerateSignatureAgain: true };
	    }
	
	    _createClass(Signature, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this = this;
	
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var currentBrNr = _props.currentBrNr;
	            var signatures = _props.signatures;
	
	            dispatch((0, _stateActions.closeSignature)());
	
	            this.refresh().then(function (response) {
	                if (currentBrNr) {
	                    _this.setState({ canGenerateSignatureAgain: false }, function () {
	                        _this.createOrUpdateSignatureAutomaticForBroker(currentBrNr);
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            var _this2 = this;
	
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _stateActions.loadSignatures)()).then(function () {
	                _this2.forceUpdate();
	            });
	        }
	
	        /**
	         * This dedicated function is called on every property received.
	         * One of the scope of usage is to generate a new signature for brokers woh don't have any.
	         * @param {object} nextProps
	         */
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this3 = this;
	
	            var _props2 = this.props;
	            var currentBrNr = _props2.currentBrNr;
	            var signatureZoom = _props2.signatureZoom;
	
	            // create signature automatically if not exist minimum 1 piece.
	            // TODO thinking about to prevent the double start of this creation, but I think this never happen :),
	            // asynchronous creation of signatures can cause that.
	            var brokerNumberChanged = nextProps.currentBrNr !== currentBrNr;
	            var noSignatureOpenForEdit = !signatureZoom || !signatureZoom.visible;
	            if (brokerNumberChanged && noSignatureOpenForEdit && this.state.canGenerateSignatureAgain) {
	                this.setState({ canGenerateSignatureAgain: false }, function () {
	                    _this3.createOrUpdateSignatureAutomaticForBroker(nextProps.currentBrNr);
	                });
	            }
	        }
	
	        /**
	         * This function will create an automatic signature for a broker if not exist.
	         * Should return a promise
	         */
	    }, {
	        key: 'createOrUpdateSignatureAutomaticForBroker',
	        value: function createOrUpdateSignatureAutomaticForBroker(brNr, signature, customUpdate) {
	            var _this4 = this;
	
	            var _props3 = this.props;
	            var signatures = _props3.signatures;
	            var dispatch = _props3.dispatch;
	            var brokers = _props3.brokers;
	            var lang = _props3.lang;
	            var app = _props3.app;
	
	            // quick check of params
	            if (!brNr) {
	                return false;
	            }
	
	            // search an existing signature if to be sure is not created before
	            var signatureOfBrokerExists = false;
	            var isUpdateSignature = false;
	
	            // signature parameter is not empty we check that one first
	            if (signature) {
	                isUpdateSignature = true;
	            }
	
	            if (signatures && Array.isArray(signatures) && signatures.length > 0) {
	                var matches = signatures.filter(function (item) {
	                    return item.brokerNumber == brNr;
	                });
	                if (matches.length > 0) {
	                    signatureOfBrokerExists = true;
	                }
	            }
	
	            var theBroker = brokers && brokers[brNr] || false;
	
	            if (!theBroker || !theBroker.main) {
	                return '';
	            }
	
	            var theBrokerName = theBroker.main && theBroker.main.name || "";
	
	            var userFullName = (app.firstName || "") + " " + (app.lastName || "");
	            userFullName = String(userFullName).trim();
	
	            // if we don't have minimum 1 signature for this broker we have to generate one automatically.
	            if (!signatureOfBrokerExists || isUpdateSignature) {
	                //this.getNewSignatureTable(brNr)
	
	                dispatch({ type: _stateConstants2['default'].SHOW_LOADER });
	
	                (0, _signatureGenerator2['default'])(theBroker, app.userId, userFullName, lang).then(function (content) {
	                    var defaultValuesForASignature = _this4.getDefaultValuesForANewSignature();
	                    var replacementData = (0, _signatureGenerator.generateSignatureReplaceData)(theBroker, app.userId, userFullName, lang);
	                    defaultValuesForASignature.name = theBrokerName + " - " + brNr + " (" + (0, _moment2['default'])().format("DD-MM-YYYY HH:mm:ss") + ")";
	                    defaultValuesForASignature.content = content;
	                    defaultValuesForASignature.isDefault = true;
	                    defaultValuesForASignature.brokerNumber = brNr;
	                    defaultValuesForASignature.generatedHash = (0, _signatureGenerator.generateUniqueHashFromSignatureData)(replacementData);
	
	                    if (isUpdateSignature) {
	                        defaultValuesForASignature.isDefault = signature.isDefault;
	                        defaultValuesForASignature._id = signature._id;
	
	                        if (customUpdate === true) {
	                            defaultValuesForASignature.name = signature.name;
	                            defaultValuesForASignature.content = signature.content;
	                        }
	                    }
	
	                    return defaultValuesForASignature;
	                }).then(function (signaturePlainObj) {
	                    _this4.saveSignature(signaturePlainObj).then(function (signatureRecord) {
	
	                        // refresh the list, if this request is not started by the save action automatically
	                        _this4.refresh().then(function () {
	                            _this4.setState({ canGenerateSignatureAgain: true });
	                        });
	
	                        dispatch((0, _stateActions.setNotification)(_('signatureCreatedFor') + " " + brNr, 'success'));
	                    });
	                })
	                // the same action in "catch" and "then" because the "finally" not supported in IE
	                .then(function (result) {
	                    dispatch({ type: _stateConstants2['default'].HIDE_LOADER });
	                    return result;
	                })['catch'](function (err) {
	                    dispatch({ type: _stateConstants2['default'].HIDE_LOADER });
	                    return err;
	                });
	            } else {
	                this.setState({ canGenerateSignatureAgain: true });
	            }
	        }
	
	        /**
	         * This function give a set of default value for rendering a signature in the renderer initialization
	         * on creating a new signature.
	         */
	    }, {
	        key: 'getDefaultValuesForANewSignature',
	        value: function getDefaultValuesForANewSignature() {
	            return {
	                name: "",
	                content: "",
	                isDefault: false,
	                createdAt: "",
	                updatedAt: "",
	                generatedHash: ""
	            };
	        }
	
	        /**
	         * Event when you select a signature from list. This will set the Id for the detailed page to
	         * identify the affected record to show.
	         * @param {string} id
	         */
	    }, {
	        key: 'onSignatureClicked',
	        value: function onSignatureClicked(id) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.zoomSignature)(id));
	        }
	
	        /**
	         * This action will handle the deletion of a signature.
	         * @param {object} signature
	         */
	    }, {
	        key: 'onRemoveSignature',
	        value: function onRemoveSignature(signature) {
	            var dispatch = this.props.dispatch;
	
	            var r = confirm(_('removeConfirmation'));
	            if (r === true) {
	                dispatch((0, _stateActions.removeSignatureById)(signature._id));
	                dispatch((0, _stateActions.closeSignature)());
	            }
	        }
	
	        /**
	         * This action will handle the update of a signature.
	         * @param {object} signature
	         * @param {bool} customUpdate set this true if the content of the signature is custom, and you don't want auto generation
	         */
	    }, {
	        key: 'onUpdateSignature',
	        value: function onUpdateSignature(signature, customUpdate) {
	            var _this5 = this;
	
	            var dispatch = this.props.dispatch;
	
	            if (!customUpdate) {
	                customUpdate = false;
	            }
	
	            var result = this.createOrUpdateSignatureAutomaticForBroker(signature.brokerNumber, signature, customUpdate);
	
	            if (result) {
	                result.then(function () {
	                    _this5.refresh();
	                });
	            }
	        }
	
	        /**
	         * This action will handle the deletion of a signature.
	         */
	    }, {
	        key: 'onRemoveSignature',
	        value: function onRemoveSignature(signature) {
	            var dispatch = this.props.dispatch;
	
	            var r = confirm(_('removeConfirmation'));
	            if (r === true) {
	                dispatch((0, _stateActions.removeSignatureById)(signature._id));
	                dispatch((0, _stateActions.closeSignature)());
	            }
	        }
	
	        /**
	         * Exiting event from detailed view of a signature.
	         */
	    }, {
	        key: 'onCloseSignature',
	        value: function onCloseSignature() {
	            var _props4 = this.props;
	            var dispatch = _props4.dispatch;
	            var signatureZoom = _props4.signatureZoom;
	
	            // clean up the visible placeholder
	            /* if (signatureZoom && signatureZoom.content) {
	                signatureZoom.content = replacePlaceholderToTransparentLogo(signatureZoom.content)
	            } */
	
	            dispatch((0, _stateActions.closeSignature)());
	        }
	
	        /**
	         * Event for set a signature to be default.
	         */
	    }, {
	        key: 'onSetDefaultSignature',
	        value: function onSetDefaultSignature(signature) {
	            var dispatch = this.props.dispatch;
	
	            if (!signature) {
	                return;
	            }
	
	            var newSignature = {
	                _id: signature._id,
	                isDefault: !signature.isDefault,
	                brokerNumber: signature.brokerNumber
	            };
	
	            dispatch((0, _stateActions.setSignature)(newSignature)).then(function (signatureRecord) {
	                dispatch((0, _stateActions.setNotification)(signatureRecord.name + ' - ' + (!signature.isDefault ? _('markedAsDefault') : _('markedAsNotDefault')), 'success'));
	            });
	        }
	
	        /**
	         * Save signature action dispatch
	         * @param {*} signature
	         */
	    }, {
	        key: 'saveSignature',
	        value: function saveSignature(signature) {
	            var _props5 = this.props;
	            var dispatch = _props5.dispatch;
	            var brokers = _props5.brokers;
	
	            if (!signature || !signature.brokerNumber) {
	                return;
	            }
	
	            var canEdit = brokers && _nestedProperty2['default'].get(brokers, signature.brokerNumber + ".main.modifySignature");
	            canEdit = canEdit === "false" ? false : canEdit === "true" ? true : !!canEdit;
	
	            if (signature.content) {
	                if (canEdit) {
	                    signature.content = (0, _signatureGenerator.replacePlaceholderToTransparentLogo)(signature.content);
	                } else {
	                    signature.content = (0, _signatureGenerator.replacePlaceholderToNothing)(signature.content);
	                }
	            }
	
	            var newSignature = {
	                _id: signature._id,
	                name: signature.name,
	                content: signature.content,
	                isDefault: signature.isDefault,
	                brokerNumber: signature.brokerNumber,
	                generatedHash: signature.generatedHash
	            };
	
	            console.log("setSignature newSignature", newSignature);
	
	            return dispatch((0, _stateActions.setSignature)(newSignature));
	        }
	
	        /**
	         * Event for save a signature record. Update create.
	         * @param {object} signature
	         */
	    }, {
	        key: 'onSaveSignature',
	        value: function onSaveSignature(signature) {
	            var dispatch = this.props.dispatch;
	
	            if (!signature) {
	                return;
	            }
	
	            var newSignaturePromise = this.saveSignature(signature);
	
	            if (newSignaturePromise) {
	                newSignaturePromise.then(function (signatureRecord) {
	                    // dispatch(zoomSignature(signatureRecord._id))
	                    // dispatch(setNotification(_('signatureSaved'), 'success'))
	                });
	            }
	        }
	
	        /**
	         * Dedicated main rendering method.
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props6 = this.props;
	            var signatures = _props6.signatures;
	            var signatureZoom = _props6.signatureZoom;
	            var lang = _props6.lang;
	            var app = _props6.app;
	            var brokers = _props6.brokers;
	            var dispatch = _props6.dispatch;
	
	            var signature = {};
	            var initialValues = {};
	
	            if (signatureZoom && signatureZoom.visible) {
	                signature = signatures && signatures.filter(function (item) {
	                    return item._id === signatureZoom.signatureId;
	                })[0] || {};
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _signaturesScss2['default'].signaturesTable },
	                !signatureZoom || !signatureZoom.visible ? _react2['default'].createElement(_signatureList2['default'], {
	                    signatures: signatures || [],
	                    onSignatureClicked: this.onSignatureClicked,
	                    onSetDefaultSignature: function (resultSign) {
	                        _this6.onSetDefaultSignature(resultSign);
	                    },
	                    onUpdateSignature: function (resultSign, customUpdate) {
	                        _this6.onUpdateSignature(resultSign, customUpdate);
	                    }
	                }) : _react2['default'].createElement(_signatureZoom2['default'], {
	                    signature: signature,
	                    onRemoveSignature: function (resultSign) {
	                        _this6.onRemoveSignature(resultSign);
	                    },
	                    onUpdateSignature: function (resultSign, customUpdate) {
	                        _this6.onUpdateSignature(resultSign, customUpdate);
	                    },
	                    onCloseSignature: this.onCloseSignature,
	                    onSetDefaultSignature: function (resultSign) {
	                        _this6.onSetDefaultSignature(resultSign);
	                    },
	                    onSaveSignature: function (resultSign) {
	                        _this6.onSaveSignature(resultSign);
	                    },
	                    getNewSignatureTable: function (paramBrNr) {
	                        var theBroker = brokers && brokers[paramBrNr] || false;
	
	                        if (!theBroker || !theBroker.main) {
	                            return '';
	                        }
	
	                        var userFullName = (app.firstName || "") + " " + (app.lastName || "");
	                        userFullName = String(userFullName).trim();
	
	                        dispatch({ type: _stateConstants2['default'].SHOW_LOADER });
	                        return (0, _signatureGenerator2['default'])(theBroker, app.userId, userFullName, lang)
	                        // the same action in "catch" and "then" because the "finally" not supported in IE
	                        .then(function (result) {
	                            dispatch({ type: _stateConstants2['default'].HIDE_LOADER });
	                            return result;
	                        })['catch'](function (err) {
	                            dispatch({ type: _stateConstants2['default'].HIDE_LOADER });
	                            return err;
	                        });
	                    },
	                    signatureDefaultValues: function () {
	                        return _this6.getDefaultValuesForANewSignature();
	                    },
	                    replaceTransparentLogoToPlaceholder: function (content) {
	                        return (0, _signatureGenerator.replaceTransparentLogoToPlaceholder)(content, lang);
	                    }
	                })
	            );
	        }
	    }]);
	
	    var _Signature = Signature;
	    Signature = (0, _reactRedux.connect)(function (state) {
	        return {
	            currentBrNr: state.app.brNr,
	            broker: state.office.brokers[state.app.brNr],
	            brokers: state.office.brokers,
	            app: state.app,
	            signatures: state.office.signatures,
	            signatureZoom: state.office.signatureZoom,
	            signatureModal: state.office.signatureModal,
	            lang: state.app.lang
	        };
	    })(Signature) || Signature;
	    return Signature;
	})(_react2['default'].Component);
	
	exports['default'] = Signature;
	module.exports = exports['default'];

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _signaturesScss = __webpack_require__(439);
	
	var _signaturesScss2 = _interopRequireDefault(_signaturesScss);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _libHelpers = __webpack_require__(24);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var SignatureList = (function (_React$Component) {
	    _inherits(SignatureList, _React$Component);
	
	    function SignatureList() {
	        _classCallCheck(this, _SignatureList);
	
	        _get(Object.getPrototypeOf(_SignatureList.prototype), 'constructor', this).apply(this, arguments);
	
	        this.getIcon = function (iconName) {
	            try {
	                return __webpack_require__(173)("./" + iconName);
	            } catch (err) {
	                return __webpack_require__(261);
	            }
	        };
	    }
	
	    _createClass(SignatureList, [{
	        key: 'canCreateSignature',
	
	        /**
	         * This function decide the right to create a signature for broker.
	         */
	        value: function canCreateSignature() {
	            var _props = this.props;
	            var broker = _props.broker;
	            var currentBrNr = _props.currentBrNr;
	
	            // REMOVE REMOVE REMOVE REMOVE REMOVE REMOVE +++
	            // TODO remove this if Only for testing
	            /* if (currentBrNr == "90069") {
	                return true
	            } */
	            // REMOVE REMOVE REMOVE REMOVE REMOVE REMOVE ---
	
	            var can = broker && _nestedProperty2['default'].get(broker, "main.modifySignature");
	            return can === "false" ? false : can === "true" ? true : !!can;
	        }
	    }, {
	        key: 'updateButtonRenderer',
	        value: function updateButtonRenderer() {
	            var _this = this;
	
	            var canBrokerCreateOrUpdate = this.canCreateSignature();
	
	            if (!canBrokerCreateOrUpdate) {
	                return _react2['default'].createElement('input', {
	                    onClick: function () {
	                        return _this.updateAutomaticSignature();
	                    },
	                    type: 'button',
	                    className: _signaturesScss2['default'].buttonGreen,
	                    value: _('updateSignature')
	                });
	            }
	
	            return null;
	        }
	    }, {
	        key: 'updateAutomaticSignature',
	        value: function updateAutomaticSignature() {
	            var _props2 = this.props;
	            var signatures = _props2.signatures;
	            var currentBrNr = _props2.currentBrNr;
	            var onUpdateSignature = _props2.onUpdateSignature;
	
	            var brokerSignatures = null;
	
	            if (!currentBrNr) {
	                return;
	            }
	
	            if (signatures && Array.isArray(signatures) && signatures.length > 0) {
	                var matches = signatures.filter(function (item) {
	                    return item.brokerNumber == currentBrNr;
	                });
	                if (matches.length > 0) {
	                    brokerSignatures = matches;
	                }
	            }
	
	            if (brokerSignatures != null && brokerSignatures.length > 0) {
	                brokerSignatures.map(function (signature, key) {
	                    onUpdateSignature(signature);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props;
	            var signatures = _props3.signatures;
	            var onSignatureClicked = _props3.onSignatureClicked;
	            var onSetDefaultSignature = _props3.onSetDefaultSignature;
	
	            var isNotDefaultIcon = this.getIcon('ic_done_gray_32px.svg');
	            var isDefaultIcon = this.getIcon('ic_done_green_32px.svg');
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(_reactableScss2['default'].tableContainer, _signaturesScss2['default'].clearTableBorder) },
	                    _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            className: 'noPadding',
	                            itemsPerPage: 7,
	                            filterable: ['signName', 'signContent', 'signCreatedAt', 'signIsDefault'],
	                            sortable: [{ column: 'signName', sortFunction: function sortFunction(a, b) {
	                                    var aStr = _nestedProperty2['default'].get(a, "props.children");
	                                    var bStr = _nestedProperty2['default'].get(b, "props.children");
	                                    if (!aStr) {
	                                        aStr = a;
	                                    }
	                                    if (!bStr) {
	                                        bStr = b;
	                                    }
	                                    return String(aStr).toLowerCase() < String(bStr).toLowerCase() ? 1 : -1;
	                                } }, { column: 'signCreatedAt', sortFunction: 'Date' }, 'signContent', 'signIsDefault', 'signCreatedAt'],
	                            defaultSort: {
	                                column: 'signName',
	                                direction: 'desc'
	                            },
	                            topPaginationElemR: [_react2['default'].createElement('input', {
	                                onClick: function () {
	                                    return onSignatureClicked();
	                                },
	                                type: 'button',
	                                className: _signaturesScss2['default'].buttonGreen,
	                                value: _('newSignature'),
	                                disabled: !this.canCreateSignature()
	                            }), this.updateButtonRenderer()]
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'signName' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('name')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'signContent' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('content')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'signCreatedAt' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('createdAt')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'signIsDefault' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _('isDefault')
	                                )
	                            )
	                        ),
	                        signatures && signatures.map(function (item, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { key: key, className: 'clickable centered', onClick: function () {
	                                        return onSignatureClicked(item._id);
	                                    } },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'signName', value: item.name },
	                                    item.name
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'signContent', value: item.content, className: _signaturesScss2['default'].tableSignatureField },
	                                    _react2['default'].createElement('div', {
	                                        className: _signaturesScss2['default'].htmlTableHolder,
	                                        dangerouslySetInnerHTML: { __html: item.content }
	                                    })
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'signCreatedAt', className: _signaturesScss2['default'].tableDateField, value: item.createdAt ? (0, _libHelpers.formatDate)(item.createdAt, 'eu') : '-' },
	                                    _react2['default'].createElement(
	                                        'span',
	                                        null,
	                                        item.createdAt ? (0, _libHelpers.formatDate)(item.createdAt, 'eu') : '-'
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'signIsDefault', value: item.isDefault ? _('isDefault') : '' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        null,
	                                        item.isDefault ? _react2['default'].createElement('img', { className: _signaturesScss2['default'].borderedImage, src: isDefaultIcon,
	                                            onClick: function (e) {
	                                                e.stopPropagation();
	                                                onSetDefaultSignature(item);
	                                            }
	                                        }) : _react2['default'].createElement('img', { className: _signaturesScss2['default'].borderedImage, src: isNotDefaultIcon,
	                                            onClick: function (e) {
	                                                e.stopPropagation();
	                                                onSetDefaultSignature(item);
	                                            }
	                                        })
	                                    )
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            signatures: _react2['default'].PropTypes.array.isRequired,
	            onSignatureClicked: _react2['default'].PropTypes.func.isRequired,
	            onSetDefaultSignature: _react2['default'].PropTypes.func.isRequired
	        },
	
	        /**
	         * This function help to use icons without errors an put a placeholder icon if missing the necessary one.
	         */
	        enumerable: true
	    }]);
	
	    var _SignatureList = SignatureList;
	    SignatureList = (0, _reactRedux.connect)(function (state) {
	        return {
	            currentBrNr: state.app.brNr,
	            broker: state.office.brokers[state.app.brNr]
	        };
	    })(SignatureList) || SignatureList;
	    return SignatureList;
	})(_react2['default'].Component);
	
	exports['default'] = SignatureList;
	module.exports = exports['default'];

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _signaturesScss = __webpack_require__(439);
	
	var _signaturesScss2 = _interopRequireDefault(_signaturesScss);
	
	var _reduxForm = __webpack_require__(57);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libHelpers = __webpack_require__(24);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stateActions = __webpack_require__(5);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var validate = function validate(values) {
	    var errors = {};
	    if (_underscore2['default'].isEmpty(values.nameField)) {
	        errors.nameField = _('nameFieldIsRequired');
	    }
	    if (_underscore2['default'].isEmpty(values.contentField)) {
	        errors.contentField = _('contentFieldIsRequired');
	    }
	    return errors;
	};
	
	var SignatureZoom = (function (_React$Component) {
	    _inherits(SignatureZoom, _React$Component);
	
	    _createClass(SignatureZoom, null, [{
	        key: 'propTypes',
	        value: {
	            fields: _react2['default'].PropTypes.object.isRequired,
	            signature: _react2['default'].PropTypes.object,
	            onRemoveSignature: _react2['default'].PropTypes.func.isRequired,
	            onUpdateSignature: _react2['default'].PropTypes.func.isRequired,
	            onCloseSignature: _react2['default'].PropTypes.func.isRequired,
	            onSetDefaultSignature: _react2['default'].PropTypes.func.isRequired,
	            onSaveSignature: _react2['default'].PropTypes.func.isRequired,
	            getNewSignatureTable: _react2['default'].PropTypes.func.isRequired,
	            signatureDefaultValues: _react2['default'].PropTypes.func.isRequired,
	            currentBrNr: _react2['default'].PropTypes.string,
	            replaceTransparentLogoToPlaceholder: _react2['default'].PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    function SignatureZoom(props) {
	        _classCallCheck(this, _SignatureZoom);
	
	        _get(Object.getPrototypeOf(_SignatureZoom.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            theContentEditor: null
	        };
	    }
	
	    /**
	     * This will set the form value content in store
	     */
	
	    _createClass(SignatureZoom, [{
	        key: 'updateFormValue',
	        value: function updateFormValue(value, field) {
	            var dispatch = this.props.dispatch;
	
	            return dispatch({
	                type: "redux-form/CHANGE",
	                field: field.name,
	                value: value && value.value || '',
	                touch: value && value.touched || field.touched,
	                form: "signature"
	            });
	        }
	
	        /**
	         * This function will give an init value for body editor
	         */
	    }, {
	        key: 'setInitialSignatureContent',
	        value: function setInitialSignatureContent() {
	            var _this = this;
	
	            var _props = this.props;
	            var signature = _props.signature;
	            var fields = _props.fields;
	            var replaceTransparentLogoToPlaceholder = _props.replaceTransparentLogoToPlaceholder;
	            var getNewSignatureTable = _props.getNewSignatureTable;
	            var currentBrNr = _props.currentBrNr;
	
	            if (!signature || !signature._id) {
	                getNewSignatureTable(currentBrNr).then(function (result) {
	                    result = replaceTransparentLogoToPlaceholder(result);
	                    _this.updateFormValue({ value: result }, fields.contentField);
	                });
	            } else {
	                var content = signature && signature.content || '';
	
	                if (content) {
	                    content = replaceTransparentLogoToPlaceholder(content);
	                }
	
	                this.updateFormValue({ value: content }, fields.contentField);
	            }
	        }
	
	        /**
	         * Handle mobile touch
	         * @param {*} field
	         */
	    }, {
	        key: 'touch',
	        value: function touch(field) {
	            field.onBlur();
	        }
	
	        /**
	         * This will initialize the module after mounting.
	         */
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props2 = this.props;
	            var signature = _props2.signature;
	            var fields = _props2.fields;
	
	            this.setInitialSignatureContent();
	            this.setupTinyMce();
	            this.updateFormValue({ value: _nestedProperty2['default'].get(signature, "name") || "" }, fields.nameField);
	            this.updateFormValue({ value: Boolean(_nestedProperty2['default'].get(signature, "isDefault")) }, fields.isDefaultField);
	        }
	
	        /**
	         * Triggered before update the module
	         */
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            // we have to initialize the content of signature content here separately because it is not a regular form field
	            if (nextProps.fields.contentField.value !== this.props.fields.contentField.value) {
	                this.updateContentEditor(nextProps.fields.contentField.value);
	            }
	
	            if (nextProps.signature.name !== this.props.signature.name) {
	                this.updateFormValue({ value: nextProps.signature.name }, this.props.fields.nameField);
	            }
	        }
	
	        /**
	        * We have to reset the references because the editors will reinitialize on mount.
	        */
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.tinymce.execCommand('mceFocus', true, "tinymce");
	            window.tinymce.execCommand('mceRemoveEditor', true, "tinymce");
	            window.tinymce.execCommand('mceRemoveControl', false, "tinymce");
	        }
	
	        /**
	         * This function provide the apicall result and callback call for the tiny mce editor,
	         * trough a redux action
	         * @param {*} blobInfo
	         * @param {function} success
	         * @param {function} failure
	         */
	    }, {
	        key: 'imagesUploadHandler',
	        value: function imagesUploadHandler(blobInfo, success, failure) {
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _stateActions.localUploadHandler)(blobInfo, success, failure));
	        }
	
	        /**
	         * The editor initialization.
	         */
	    }, {
	        key: 'setupTinyMce',
	        value: function setupTinyMce() {
	            var _this2 = this;
	
	            var _props3 = this.props;
	            var signature = _props3.signature;
	            var fields = _props3.fields;
	            var replaceTransparentLogoToPlaceholder = _props3.replaceTransparentLogoToPlaceholder;
	
	            // window.tinymce.execCommand('mceAddEditor',true, "tinymce")
	            window.tinymce.init({
	                selector: '#tinymce',
	                min_height: 365,
	                menubar: false,
	                mode: "readonly",
	                //theme_url: window.location.protocol+'//'+(window.location.href.split("/")[2] + '/themes/modern/theme.js').replace("\/\/", "\/"),
	                //skin_url:  window.location.protocol+'//'+(window.location.href.split("/")[2] + '/skins/lightgray/').replace("\/\/", "\/"),
	                theme: "silver",
	                statusbar: false,
	                // toolbar: 'bold italic underline | undo redo | link | code', plugins: ['paste', 'link', 'autoresize'],
	                toolbar1: "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | formatselect fontselect fontsizeselect",
	                toolbar2: "paste pastetext searchreplace | bullist numlist | outdent indent | undo redo | link unlink anchor image code",
	                toolbar3: "forecolor backcolor | table | hr removeformat visualchars | subscript superscript | charmap preview | fullscreen",
	                // external_plugins: {
	                //     'textcolor': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/textcolor/plugin.js').replace("\/\/", "\/"),
	                //     'link': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/link/plugin.js').replace("\/\/", "\/"),
	                //     'image': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/image/plugin.js').replace("\/\/", "\/"),
	                //     'code': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/code/plugin.js').replace("\/\/", "\/"),
	                //     'searchreplace': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/searchreplace/plugin.js').replace("\/\/", "\/"),
	                //     'paste': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/paste/plugin.js').replace("\/\/", "\/"),
	                //     'visualchars': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/visualchars/plugin.js').replace("\/\/", "\/"),
	                //     'charmap': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/charmap/plugin.js').replace("\/\/", "\/"),
	                //     'table': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/table/plugin.js').replace("\/\/", "\/"),
	                //     'fullscreen': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/fullscreen/plugin.js').replace("\/\/", "\/"),
	                //     'preview': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/preview/plugin.js').replace("\/\/", "\/"),
	                // },
	                plugins: ["textcolor link image code searchreplace paste visualchars charmap table fullscreen preview"],
	                force_br_newlines: false,
	                force_p_newlines: false,
	                forced_root_block: '',
	                relative_urls: false,
	                convert_urls: true,
	                remove_script_host: false,
	                allow_script_urls: true,
	
	                valid_elements: "*[*]",
	                extended_valid_elements: "tr[style]",
	                inline_styles: true,
	                verify_html: false,
	                visual: false, // for table borders off
	                //remove_script_host: false,
	                images_upload_url: 'uploads/localUploads/',
	                images_upload_handler: function images_upload_handler(blobInfo, success, failure) {
	                    return _this2.imagesUploadHandler(blobInfo, success, failure);
	                },
	                setup: function setup(editor) {
	                    _this2.setState({ theContentEditor: editor });
	                    /* editor.on('NodeChange', function(e) {
	                        actualCaretPositionBookmark = editor.selection.getBookmark(2, true)
	                    })
	                    editor.on('SetContent', function(e) {
	                        editor.selection.moveToBookmark(actualCaretPositionBookmark)
	                    })
	                    editor.on('KeyPress', function(e) {
	                        actualCaretPositionBookmark = editor.selection.getBookmark(2, true)
	                    }) */
	                    /* editor.on('change', (e)=>{
	                        this.updateFormValue({value: editor.getContent(), touch: true}, {...fields.contentField, touch: true})
	                    }) */
	                    editor.on('blur', function (e) {
	                        _this2.updateFormValue({ value: editor.getContent(), touch: true }, _extends({}, fields.contentField, { touch: true }));
	                    });
	                    editor.on('click', function (e) {
	                        _this2.updateFormValue({ value: editor.getContent(), touch: true }, _extends({}, fields.contentField, { touch: true }));
	                    });
	                    editor.on('init', function (e) {
	                        _this2.updateContentEditor();
	                    });
	                    /* editor.on('change', (e)=>{
	                        this.updateFormValue({value: editor.getContent(), touch: true}, {...fields.contentField, touch: true})
	                    }) */
	                }
	            });
	        }
	
	        /**
	         * This function will initialize the body editor when you call it and replace the body value instantly
	         * @param {String} newValue - new body html value for email
	         */
	    }, {
	        key: 'updateContentEditor',
	        value: function updateContentEditor() {
	            var forceValue = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	            var _props4 = this.props;
	            var signature = _props4.signature;
	            var replaceTransparentLogoToPlaceholder = _props4.replaceTransparentLogoToPlaceholder;
	            var theContentEditor = this.state.theContentEditor;
	
	            var contentField = _nestedProperty2['default'].get(this.props, "fields.contentField");
	
	            var newValue = undefined;
	
	            if (forceValue === null) {
	                newValue = contentField && contentField.value || '';
	            } else {
	                newValue = forceValue;
	            }
	
	            if (newValue) {
	                newValue = replaceTransparentLogoToPlaceholder(newValue);
	            }
	
	            if (window.tinymce && theContentEditor) {
	                if (newValue) {
	                    var body = String(newValue) || '';
	                    try {
	                        theContentEditor.setContent(body, { format: 'raw' });
	                    } catch (exc) {
	                        // error handling
	                    }
	                } else {
	                        try {
	                            theContentEditor.setContent('', { format: 'raw' });
	                        } catch (exc) {
	                            // error handling
	                        }
	                    }
	            }
	        }
	
	        /**
	         * This function will return TRUE if minimum one of the form fields contains errors, about the values.
	         */
	    }, {
	        key: 'hasErrors',
	        value: function hasErrors() {
	            var fields = _nestedProperty2['default'].get(this.props, "fields");
	            var errors = false;
	            Object.keys(fields).forEach(function (indexVal) {
	                errors = errors || !_underscore2['default'].isEmpty(fields[indexVal].error);
	            });
	            return Boolean(errors);
	        }
	
	        /**
	         * This function can enable the saving of a new signature or update an old one,
	         * verify the validity of values.
	         */
	    }, {
	        key: 'isDisabledTheSubmit',
	        value: function isDisabledTheSubmit() {
	            var _props$fields = this.props.fields;
	            var nameField = _props$fields.nameField;
	            var contentField = _props$fields.contentField;
	            var isDefaultField = _props$fields.isDefaultField;
	
	            return !_underscore2['default'].isEmpty(validate({
	                nameField: nameField && nameField.value || '',
	                contentField: contentField && contentField.value || '',
	                isDefaultField: isDefaultField && isDefaultField.value || false
	            }));
	        }
	
	        /**
	         * This function enable the "make as default" button if the signature already saved. (Has _id)
	         * @param {object} signature
	         */
	    }, {
	        key: 'isDisabledTheMakeDefault',
	        value: function isDisabledTheMakeDefault(signature) {
	            return !signature._id;
	        }
	
	        /**
	         * This function return with a React element for render, what contains the signature body editor
	         * filled with the signature content.
	         */
	    }, {
	        key: 'renderBodyEditor',
	        value: function renderBodyEditor() {
	            var theContentEditor = this.state.theContentEditor;
	
	            var contentField = _nestedProperty2['default'].get(this.props, "fields.contentField");
	
	            if (window.tinymce && theContentEditor) {
	                if (this.canEditOrCreateSignature()) {
	                    // theContentEditor.execCommand("mceToggleVisualAid")
	                    theContentEditor.setMode("design");
	                } else {
	                    theContentEditor.setMode("readonly");
	                }
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _signaturesScss2['default'].formGroup },
	                _react2['default'].createElement(
	                    'label',
	                    { className: _signaturesScss2['default'].formLabel, htmlFor: 'contentField' },
	                    _("signatureContent")
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _signaturesScss2['default'].inputHolder },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _signaturesScss2['default'].formInput },
	                        _react2['default'].createElement('textarea', { id: 'tinymce' })
	                    ),
	                    contentField.touched && contentField.error && _react2['default'].createElement(
	                        'div',
	                        { className: _signaturesScss2['default'].errorMessage },
	                        contentField.error
	                    )
	                )
	            );
	        }
	
	        /**
	         * This function decide the right to create or edit a signature for broker.
	         */
	    }, {
	        key: 'canEditOrCreateSignature',
	        value: function canEditOrCreateSignature() {
	            var _props5 = this.props;
	            var brokers = _props5.brokers;
	            var currentBrNr = _props5.currentBrNr;
	            var signature = _props5.signature;
	
	            //let hisOwnSignature = signature && signature.brokerNumber && (signature.brokerNumber === currentBrNr) ? true : false
	            // default the user can edit the signature if there are no brokernumber attached,
	            // because we don't want to block forever a signature
	            var can = true;
	            // werify if signature has brokernumber attached
	            if (signature && signature.brokerNumber) {
	                // get the signature owner broker right for editing his signature
	                can = brokers && _nestedProperty2['default'].get(brokers, signature.brokerNumber + ".main.modifySignature");
	            }
	
	            // REMOVE REMOVE REMOVE REMOVE REMOVE REMOVE +++
	            // TODO remove this if. Only for testing
	            /* if (currentBrNr == "90069") {
	                can = true
	            } */
	            // REMOVE REMOVE REMOVE REMOVE REMOVE REMOVE ---
	
	            // handle if a string is the boolean value
	            can = can === "false" ? false : can === "true" ? true : !!can;
	            return can;
	        }
	
	        /**
	         * This is the main rendering function of the react.
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            // loading values for render
	            var _props6 = this.props;
	            var onRemoveSignature = _props6.onRemoveSignature;
	            var onUpdateSignature = _props6.onUpdateSignature;
	            var onCloseSignature = _props6.onCloseSignature;
	            var onSetDefaultSignature = _props6.onSetDefaultSignature;
	            var onSaveSignature = _props6.onSaveSignature;
	            var _props6$fields = _props6.fields;
	            var nameField = _props6$fields.nameField;
	            var contentField = _props6$fields.contentField;
	            var isDefaultField = _props6$fields.isDefaultField;
	            var dispatch = _props6.dispatch;
	            var signatureDefaultValues = _props6.signatureDefaultValues;
	            var _props7 = this.props;
	            var signature = _props7.signature;
	            var currentBrNr = _props7.currentBrNr;
	
	            // basic initialization in the form for a new signature if this is not an edit mode.
	            if (_underscore2['default'].isEmpty(signature)) {
	                signature = signatureDefaultValues();
	            }
	
	            // decide the creat/update right of current broker for this signature.
	            var canBrokerCreateOrUpdate = this.canEditOrCreateSignature();
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: _signaturesScss2['default'].buttonsContainer },
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	
	                            onCloseSignature();
	                        },
	                        type: 'button',
	                        className: 'greyButton',
	                        value: _('backToList')
	                    }),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            return onRemoveSignature(signature);
	                        },
	                        type: 'button',
	                        className: 'greyButton',
	                        disabled: this.isDisabledTheMakeDefault(signature) || !canBrokerCreateOrUpdate,
	                        value: _('removeSignature')
	                    })
	                ),
	                _react2['default'].createElement(
	                    'form',
	                    { method: 'post', className: _signaturesScss2['default'].signatureForm },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_signaturesScss2['default'].formGroup, _signaturesScss2['default'].inARow, _signaturesScss2['default'].note) },
	                        _("note"),
	                        ': ',
	                        isDefaultField.value ? _react2['default'].createElement(
	                            'b',
	                            null,
	                            _("thisIsDefaultSignature")
	                        ) : _("thisIsNotDefaultSignature")
	                    ),
	                    _react2['default'].createElement('input', _extends({ type: 'hidden' }, isDefaultField)),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_signaturesScss2['default'].formGroup, _signaturesScss2['default'].subline) },
	                        _react2['default'].createElement(
	                            'label',
	                            { htmlFor: 'name', className: _signaturesScss2['default'].formLabel },
	                            _("signatureName")
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_signaturesScss2['default'].inputHolder) },
	                            _react2['default'].createElement('input', _extends({ type: 'text', className: (0, _classnames2['default'])(_signaturesScss2['default'].formInput, _signaturesScss2['default'].textInput)
	                            }, nameField, {
	                                disabled: !canBrokerCreateOrUpdate
	                            })),
	                            nameField.touched && nameField.error && _react2['default'].createElement(
	                                'div',
	                                { className: _signaturesScss2['default'].errorMessage },
	                                nameField.error
	                            )
	                        )
	                    ),
	                    window.tinymce && this.renderBodyEditor(),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_signaturesScss2['default'].formGroup, _signaturesScss2['default'].subline) },
	                        _react2['default'].createElement(
	                            'label',
	                            { htmlFor: 'createdAt', className: _signaturesScss2['default'].formLabel },
	                            _("createdAt"),
	                            ':'
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: (0, _classnames2['default'])(_signaturesScss2['default'].formInput, _signaturesScss2['default'].onlyValue) },
	                            signature.createdAt ? (0, _libHelpers.formatDate)(signature.createdAt, 'eu') : '-'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_signaturesScss2['default'].formGroup, _signaturesScss2['default'].subline) },
	                        _react2['default'].createElement(
	                            'label',
	                            { htmlFor: 'createdAt', className: _signaturesScss2['default'].formLabel },
	                            _("updatedAt"),
	                            ':'
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: (0, _classnames2['default'])(_signaturesScss2['default'].formInput, _signaturesScss2['default'].onlyValue) },
	                            signature.updatedAt ? (0, _libHelpers.formatDate)(signature.updatedAt, 'eu') : '-'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _signaturesScss2['default'].buttonsContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _signaturesScss2['default'].cancelButton,
	                                onClick: function (e) {
	                                    e.preventDefault();
	                                    onCloseSignature();
	                                } },
	                            _("cancel")
	                        ),
	                        _react2['default'].createElement(
	                            'button',
	                            { className: _signaturesScss2['default'].buttonGreen,
	                                disabled: this.isDisabledTheMakeDefault(signature) || !canBrokerCreateOrUpdate,
	                                onClick: function (e) {
	                                    e.preventDefault();
	                                    if (_this3.hasErrors()) {
	                                        return;
	                                    }
	                                    onSetDefaultSignature(signature);
	                                    _this3.updateFormValue({ value: !isDefaultField.value }, isDefaultField);
	                                } },
	                            isDefaultField.value ? _("markAsNotDefault") : _("markAsDefault")
	                        ),
	                        _react2['default'].createElement(
	                            'button',
	                            { className: _signaturesScss2['default'].buttonGreen,
	                                disabled: !canBrokerCreateOrUpdate,
	                                onClick: function (e) {
	                                    e.preventDefault();
	                                    if (_this3.hasErrors()) {
	                                        _this3.updateFormValue({ value: nameField.value, touched: true }, nameField);
	                                        _this3.updateFormValue({ value: contentField.value, touched: true }, contentField);
	                                        return;
	                                    }
	                                    onUpdateSignature(_extends({}, signature, {
	                                        name: nameField.value,
	                                        content: contentField.value,
	                                        isDefault: isDefaultField.value,
	                                        brokerNumber: signature.brokerNumber || currentBrNr }), // never update the owner broker!
	                                    true);
	                                    onCloseSignature();
	                                } },
	                            _("save")
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _SignatureZoom = SignatureZoom;
	    SignatureZoom = (0, _reduxForm.reduxForm)({
	        form: "signature",
	        fields: ["nameField", "contentField", "isDefaultField"],
	        validate: validate,
	        destroyOnUnmount: true,
	        touchOnBlur: true,
	        touchOnChange: true
	    })(SignatureZoom) || SignatureZoom;
	    SignatureZoom = (0, _reactRedux.connect)(function (state) {
	        return {
	            currentBrNr: state.app.brNr,
	            broker: state.office.brokers[state.app.brNr],
	            brokers: state.office.brokers
	        };
	    })(SignatureZoom) || SignatureZoom;
	    return SignatureZoom;
	})(_react2['default'].Component);
	
	exports['default'] = SignatureZoom;
	module.exports = exports['default'];
	/** Removed and transfered to signatureList !canBrokerCreateOrUpdate &&
	   <input
	       onClick={() => onUpdateSignature(signature)}
	       type="button"
	       className={`greyButton`}
	       value={_('updateSignature')}
	   />
	**/

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _modalDialogScss = __webpack_require__(722);
	
	var _modalDialogScss2 = _interopRequireDefault(_modalDialogScss);
	
	var _emailSetupScss = __webpack_require__(438);
	
	var _emailSetupScss2 = _interopRequireDefault(_emailSetupScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _reactRedux = __webpack_require__(4);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _libValidator = __webpack_require__(96);
	
	var _jsonBeautify = __webpack_require__(734);
	
	var _jsonBeautify2 = _interopRequireDefault(_jsonBeautify);
	
	var _ = (0, _libI18n2['default'])('office');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0',
	        wordwrap: "break-word"
	    }
	};
	
	var TestEmailDialog = (function (_React$Component) {
	    _inherits(TestEmailDialog, _React$Component);
	
	    _createClass(TestEmailDialog, null, [{
	        key: 'propTypes',
	        value: {
	            modalIsOpen: _react2['default'].PropTypes.bool,
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func,
	            cancelLabel: _react2['default'].PropTypes.string,
	            confirmationLabel: _react2['default'].PropTypes.string,
	            finishLabel: _react2['default'].PropTypes.string,
	            options: _react2['default'].PropTypes.object,
	            onSendResultMessage: _react2['default'].PropTypes.object,
	            onFinish: _react2['default'].PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function TestEmailDialog(props) {
	        _classCallCheck(this, TestEmailDialog);
	
	        _get(Object.getPrototypeOf(TestEmailDialog.prototype), 'constructor', this).call(this, props);
	        this.state = { step: 0, toAddress: '', toAddressTouched: false, toAddressError: '' };
	    }
	
	    _createClass(TestEmailDialog, [{
	        key: 'validateForm',
	        value: function validateForm() {
	            var forceTouche = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	            var toAddress = this.state.toAddress;
	
	            if (forceTouche === false) {
	                this.setState({ toAddressTouched: false });
	            }
	
	            if (forceTouche === true) {
	                this.setState({ toAddressTouched: true });
	            }
	
	            if (!(0, _libValidator.isAnEmail)(toAddress)) {
	                this.setState({ toAddressError: _('wrongEmailFormat') });
	                return false;
	            }
	
	            this.setState({ toAddressError: '' });
	
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var modalIsOpen = _props.modalIsOpen;
	            var onCancel = _props.onCancel;
	            var onConfirmation = _props.onConfirmation;
	            var onFinish = _props.onFinish;
	            var cancelLabel = _props.cancelLabel;
	            var confirmationLabel = _props.confirmationLabel;
	            var finishLabel = _props.finishLabel;
	            var options = _props.options;
	            var onSendResultMessage = _props.onSendResultMessage;
	            var _state = this.state;
	            var toAddress = _state.toAddress;
	            var toAddressTouched = _state.toAddressTouched;
	            var toAddressError = _state.toAddressError;
	            var step = _state.step;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _modalDialogScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _modalDialogScss2['default'].title },
	                            _("testTheEmailSettingsModalTitle")
	                        ),
	                        step == 0 && _react2['default'].createElement(
	                            'div',
	                            { className: _modalDialogScss2['default'].contentWrapper },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: (0, _classnames2['default'])(_emailSetupScss2['default'].formContent, _modalDialogScss2['default'].content) },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _emailSetupScss2['default'].formInputContainer },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: (0, _classnames2['default'])(_emailSetupScss2['default'].formLabel, _emailSetupScss2['default'].sizeS) },
	                                        _("testTheEmailSettingsModalMessage")
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _emailSetupScss2['default'].formInputContainer },
	                                    _react2['default'].createElement(
	                                        'label',
	                                        { className: (0, _classnames2['default'])(_emailSetupScss2['default'].formLabel, _emailSetupScss2['default'].sizeS) },
	                                        _('toAddress'),
	                                        ': '
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _emailSetupScss2['default'].formInputWithError },
	                                        _react2['default'].createElement('input', {
	                                            className: (0, _classnames2['default'])(_emailSetupScss2['default'].formInput, _emailSetupScss2['default'].formInputText, _emailSetupScss2['default'].sizeL),
	                                            type: 'text',
	                                            value: toAddress,
	                                            onChange: function (e) {
	                                                return _this.setState({ toAddress: e.target.value }, function () {
	                                                    _this.validateForm();
	                                                });
	                                            },
	                                            onBlur: function (e) {
	                                                return _this.setState({ toAddress: e.target.value }, function () {
	                                                    _this.validateForm(true);
	                                                });
	                                            },
	                                            ref: 'toAddress',
	                                            name: 'toAddress'
	                                        }),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: _emailSetupScss2['default'].errorMessageContainer },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: _emailSetupScss2['default'].errorMessage },
	                                                toAddressTouched && toAddressError
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _modalDialogScss2['default'].buttons },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            // reset modal values
	                                            _this.setState({
	                                                toAddress: '', toAddressTouched: false, toAddressError: '', step: 0
	                                            });
	
	                                            // close modal
	                                            return onCancel();
	                                        },
	                                        className: _modalDialogScss2['default'].cancel
	                                    },
	                                    cancelLabel
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            // validate modal, an let it go when success
	                                            if (_this.validateForm(true)) {
	                                                return onConfirmation(_this.state.toAddress).then(function () {
	                                                    // move forward modal to step 2
	                                                    _this.setState({ step: 1 });
	                                                })['catch'](function () {
	                                                    // move forward modal to step 2
	                                                    _this.setState({ step: 1 });
	                                                });
	                                            }
	
	                                            // on error let it open
	                                            return false;
	                                        },
	                                        className: (0, _classnames2['default'])(_modalDialogScss2['default'].next, _modalDialogScss2['default'].enabled)
	                                    },
	                                    confirmationLabel
	                                )
	                            )
	                        ),
	                        step == 1 && _react2['default'].createElement(
	                            'div',
	                            { className: _modalDialogScss2['default'].contentWrapper },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _modalDialogScss2['default'].content },
	                                _("testTheEmailSettingsModalMessageFinish"),
	                                _react2['default'].createElement('br', null),
	                                _('resultOfTestEmailConfigs'),
	                                _react2['default'].createElement('br', null),
	                                onSendResultMessage === true ? _('emailSentSuccessfully') : _react2['default'].createElement(
	                                    'div',
	                                    { className: _modalDialogScss2['default'].scrollContent },
	                                    _react2['default'].createElement(
	                                        'pre',
	                                        null,
	                                        (0, _jsonBeautify2['default'])(onSendResultMessage, null, 2, 80)
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _modalDialogScss2['default'].buttons },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	
	                                            // reset modal functionality
	                                            _this.setState({
	                                                toAddress: '', toAddressTouched: false, toAddressError: '', step: 0
	                                            });
	
	                                            // exit modal permanently and cal callback of parent
	                                            return onFinish();
	                                        },
	                                        className: (0, _classnames2['default'])(_modalDialogScss2['default'].next, _modalDialogScss2['default'].enabled)
	                                    },
	                                    finishLabel
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TestEmailDialog;
	})(_react2['default'].Component);
	
	exports['default'] = TestEmailDialog;
	module.exports = exports['default'];

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _detailedEmailScss = __webpack_require__(1622);
	
	var _detailedEmailScss2 = _interopRequireDefault(_detailedEmailScss);
	
	var _outboxScss = __webpack_require__(440);
	
	var _outboxScss2 = _interopRequireDefault(_outboxScss);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _elementsHtmlContent = __webpack_require__(110);
	
	var _elementsHtmlContent2 = _interopRequireDefault(_elementsHtmlContent);
	
	var _outboxHelpers = __webpack_require__(609);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _ = (0, _libI18n2['default'])('email');
	var _emailSenderTranslates = (0, _libI18n2['default'])('emailSender');
	var __ = (0, _libI18n2['default'])('outbox'); /* We need other translations */
	var EMAIL_STATUS_FAILED = 'failed';
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var DetailedEmail = (function (_React$Component) {
	    _inherits(DetailedEmail, _React$Component);
	
	    _createClass(DetailedEmail, null, [{
	        key: 'propTypes',
	        value: {
	            email: _react2['default'].PropTypes.object.isRequired
	        },
	        enumerable: true
	    }]);
	
	    function DetailedEmail(props) {
	        _classCallCheck(this, DetailedEmail);
	
	        _get(Object.getPrototypeOf(DetailedEmail.prototype), 'constructor', this).call(this, props);
	        this.state = { statusExplainerIsOpen: false };
	    }
	
	    /**
	     * This function handle the email status modal opening
	     * @param {object} item - one email record
	     */
	
	    _createClass(DetailedEmail, [{
	        key: 'onItemStatusClick',
	        value: function onItemStatusClick(email) {
	            var dispatch = this.props.dispatch;
	
	            // status check
	            if (!email || email.status != EMAIL_STATUS_FAILED) {
	                return;
	            }
	
	            this.setState({ statusExplainerIsOpen: email });
	        }
	
	        /**
	         * This will render the modal content of status explainer in case of error.
	         */
	    }, {
	        key: 'statusExplainerPopup',
	        value: function statusExplainerPopup() {
	            var _this = this;
	
	            var statusExplainerIsOpen = this.state.statusExplainerIsOpen;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _outboxScss2['default'].archiveModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _outboxScss2['default'].title },
	                    __('emailStatusMessageModalTitle')
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _outboxScss2['default'].message },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _outboxScss2['default'].emailBodyContainer },
	                        _react2['default'].createElement(_elementsHtmlContent2['default'], { content: statusExplainerIsOpen.statusMessage, className: _outboxScss2['default'].content })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _outboxScss2['default'].archiveModalButtons },
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this.setState({ statusExplainerIsOpen: false });
	                        },
	                        type: 'button',
	                        className: _outboxScss2['default'].greyButton + " enabled",
	                        value: __("ok")
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var email = _props.email;
	            var _props$email = _props.email;
	            var attachments = _props$email.attachments;
	            var hardAttachments = _props$email.hardAttachments;
	            var externalAttachments = _props$email.externalAttachments;
	            var statusExplainerIsOpen = this.state.statusExplainerIsOpen;
	
	            var attachmentsParsed = undefined;
	            try {
	                attachmentsParsed = attachments && attachments.filter(function (a) {
	                    return !!a;
	                }).map(function (item) {
	                    return JSON.parse(item);
	                }) || [];
	            } catch (error) {
	                attachmentsParsed = [];
	                console.warn("Json parse for attachements error", error);
	            }
	            // concat the hard attachments also to the list
	            attachmentsParsed = attachmentsParsed.concat(hardAttachments || []);
	            var recipient = email.recipient || '';
	            var recipientTranslationKey = 'recipient' + recipient.charAt(0).toUpperCase() + recipient.slice(1);
	
	            if (!email) {
	                return false;
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: _detailedEmailScss2['default'].emailContainer },
	                _react2['default'].createElement(
	                    'h2',
	                    { className: '' + _detailedEmailScss2['default'].mainTitle },
	                    _('email_title') + (email && ' - "' + email.subject + '"' || '')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedEmailScss2['default'].emailHeaderContainer },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedEmailScss2['default'].row, _detailedEmailScss2['default'].templateTitle) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            _('templateTitle'),
	                            ': '
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            email.templateTitle
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedEmailScss2['default'].row) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            __('sentDate'),
	                            ': '
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            email.sentDate != undefined && (0, _moment2['default'])(email.sentDate).format('DD/MM/YYYY HH:mm:ss') || "-"
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedEmailScss2['default'].row, _detailedEmailScss2['default'].emailStatus) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            _('status'),
	                            ': '
	                        ),
	                        email.status != EMAIL_STATUS_FAILED ? _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            email.status != undefined && (email.wasResent ? __('resent') : __(email.status)) || ""
	                        ) : _react2['default'].createElement(
	                            'a',
	                            { className: _detailedEmailScss2['default'].column,
	                                onClick: function (ev) {
	                                    ev.stopPropagation();
	                                    _this2.onItemStatusClick(email);
	                                }
	                            },
	                            email.status != undefined && (email.wasResent ? __('resent') : __(email.status)) || ""
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedEmailScss2['default'].row, _detailedEmailScss2['default'].subject) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            _('subject'),
	                            ': '
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            email.subject
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedEmailScss2['default'].row, _detailedEmailScss2['default'].from) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            _('fromUser'),
	                            ': '
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            email.userName,
	                            ' <',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'mailto:' + email.senderEmail },
	                                email.senderEmail
	                            ),
	                            '>'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedEmailScss2['default'].row, _detailedEmailScss2['default'].toEmailAddress) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            _('recipient'),
	                            ': '
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            _emailSenderTranslates(recipientTranslationKey)
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])(_detailedEmailScss2['default'].row, _detailedEmailScss2['default'].toEmailAddress) },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: _detailedEmailScss2['default'].column },
	                            _('toEmailAddress'),
	                            ': '
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _detailedEmailScss2['default'].column },
	                            _react2['default'].createElement(_outboxHelpers.RenderEmails, { emails: email.toEmailAddress })
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _detailedEmailScss2['default'].emailBodyContainer },
	                    _react2['default'].createElement(_elementsHtmlContent2['default'], { content: email.content, className: _detailedEmailScss2['default'].content })
	                ),
	                attachmentsParsed && attachmentsParsed.length > 0 && _react2['default'].createElement(
	                    'div',
	                    { className: _detailedEmailScss2['default'].attachmentContainer },
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: '' + _detailedEmailScss2['default'].title },
	                        _('attachments'),
	                        ' '
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            ref: function (el) {
	                                _this2.table = el;
	                            },
	                            id: 'table',
	                            className: _detailedEmailScss2['default'].attachmentTable,
	                            sortable: [{ column: 'name', sortFunction: function sortFunction(a, b) {
	                                    var aStr = _nestedProperty2['default'].get(a, "props.children");
	                                    var bStr = _nestedProperty2['default'].get(b, "props.children");
	                                    if (!aStr) {
	                                        aStr = a;
	                                    }
	                                    if (!bStr) {
	                                        bStr = b;
	                                    }
	                                    return aStr > bStr ? 1 : -1;
	                                } }],
	                            defaultSort: {
	                                column: 'name',
	                                direction: 'desc'
	                            },
	                            itemsPerPage: 10,
	                            pageButtonLimit: 5
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'name' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    __("name")
	                                )
	                            )
	                        ),
	                        attachmentsParsed.map(function (item, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { i: key, key: key },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'name' },
	                                    _react2['default'].createElement(
	                                        'a',
	                                        { key: key,
	                                            href: '/localdocument?localId=' + item.localId + '&type=' + (item.typeDocument || ""),
	                                            target: '_blank',
	                                            rel: 'noopener noreferrer' },
	                                        item.aliasFileName || item.name
	                                    )
	                                )
	                            );
	                        })
	                    )
	                ),
	                externalAttachments && externalAttachments.length > 0 && _react2['default'].createElement(
	                    'div',
	                    { className: _detailedEmailScss2['default'].attachmentContainer },
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: '' + _detailedEmailScss2['default'].title },
	                        _('externalAttachments'),
	                        ' '
	                    ),
	                    _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            ref: function (el) {
	                                _this2.table = el;
	                            },
	                            id: 'tableExternal',
	                            className: _detailedEmailScss2['default'].attachmentTable,
	                            sortable: [{ column: 'name', sortFunction: function sortFunction(a, b) {
	                                    var aStr = _nestedProperty2['default'].get(a, "props.children");
	                                    var bStr = _nestedProperty2['default'].get(b, "props.children");
	                                    if (!aStr) {
	                                        aStr = a;
	                                    }
	                                    if (!bStr) {
	                                        bStr = b;
	                                    }
	                                    return aStr > bStr ? 1 : -1;
	                                } }],
	                            defaultSort: {
	                                column: 'name',
	                                direction: 'desc'
	                            },
	                            itemsPerPage: 10,
	                            pageButtonLimit: 5
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'name' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    __("name")
	                                )
	                            )
	                        ),
	                        externalAttachments.map(function (item, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { i: key, key: key },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'name' },
	                                    _react2['default'].createElement(
	                                        'p',
	                                        { key: key },
	                                        item.filename || item.name || ''
	                                    )
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: Boolean(statusExplainerIsOpen),
	                        style: customStyles
	                    },
	                    this.statusExplainerPopup()
	                )
	            );
	        }
	    }]);
	
	    return DetailedEmail;
	})(_react2['default'].Component);
	
	exports['default'] = DetailedEmail;
	module.exports = exports['default'];

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _detailedEmail = __webpack_require__(1134);
	
	var _detailedEmail2 = _interopRequireDefault(_detailedEmail);
	
	var _outboxEmailList = __webpack_require__(1136);
	
	var _outboxEmailList2 = _interopRequireDefault(_outboxEmailList);
	
	var _taskCreator = __webpack_require__(372);
	
	var _taskCreator2 = _interopRequireDefault(_taskCreator);
	
	var _outboxScss = __webpack_require__(440);
	
	var _outboxScss2 = _interopRequireDefault(_outboxScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _outboxPdfSync = __webpack_require__(1137);
	
	var _outboxPdfSync2 = _interopRequireDefault(_outboxPdfSync);
	
	var _ = (0, _libI18n2['default'])('outbox');
	
	var Outbox = (function (_Component) {
	    _inherits(Outbox, _Component);
	
	    _createClass(Outbox, null, [{
	        key: 'propTypes',
	        value: {
	            items: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            modalIsOpen: _react.PropTypes.bool,
	            opened: _react.PropTypes.string,
	            setOutboxEmailOpened: _react.PropTypes.func.isRequired,
	            setOutboxSubModule: _react.PropTypes.func.isRequired,
	            setSeenOutboxEmail: _react.PropTypes.func.isRequired,
	            subModule: _react.PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    function Outbox(props) {
	        var _this = this;
	
	        _classCallCheck(this, _Outbox);
	
	        _get(Object.getPrototypeOf(_Outbox.prototype), 'constructor', this).call(this, props);
	
	        this.zoomTo = function (email) {
	            var _props = _this.props;
	            var setOutboxEmailOpened = _props.setOutboxEmailOpened;
	            var setOutboxSubModule = _props.setOutboxSubModule;
	            var setSeenOutboxEmail = _props.setSeenOutboxEmail;
	
	            if (!email.seenInOutbox) {
	                setSeenOutboxEmail(email.id);
	            }
	            setOutboxEmailOpened(email.id);
	            setOutboxSubModule('detailedEmail');
	        };
	
	        this.zoomOut = function () {
	            var _props2 = _this.props;
	            var setOutboxEmailOpened = _props2.setOutboxEmailOpened;
	            var setOutboxSubModule = _props2.setOutboxSubModule;
	
	            setOutboxEmailOpened();
	            setOutboxSubModule();
	        };
	
	        this.getTaskCreatorSecurity = function () {
	            var security = _this.props.security;
	
	            var securityValue = false;
	
	            if (security.actions && security.actions.length) {
	                security.actions.map(function (value, key) {
	                    if (value.actionName === 'Inboxtask') {
	                        if (typeof value.actionAllowed === 'string') {
	                            if (value.actionAllowed === 'true') {
	                                securityValue = true;
	                            }
	                        } else {
	                            securityValue = value.actionAllowed;
	                        }
	                    }
	                });
	            }
	
	            return securityValue;
	        };
	
	        this.handleTaskCreatorModalToggling = function () {
	            var taskCreatorModalToggle = _this.props.taskCreatorModalToggle;
	
	            taskCreatorModalToggle();
	        };
	
	        this.generateTaskCreatorItems = function (items) {
	            var convertedItems = [];
	            var selectedItems = items.filter(function (item) {
	                return item.checked;
	            });
	
	            if (selectedItems.length > 0) {
	                selectedItems.map(function (value, key) {
	                    var ticketContent = value.content;
	                    ticketContent += '<div style="border-bottom: 1px solid rgba(0,0,0,0.1); margin: 10px 0px;"></div>';
	
	                    ticketContent += '<p>' + _('sentDate') + ': ' + value.sentDate + '</p>';
	                    ticketContent += '<p>' + _('fromEmailAddress') + ': ' + value.senderEmail + '</p>';
	
	                    if (value.toEmailAddress && value.toEmailAddress.length > 0) {
	
	                        var emailList = "";
	
	                        value.toEmailAddress.map(function (emailAddress, key) {
	                            key === 0 ? emailList += emailAddress : emailList += ',' + emailAddress;
	                        });
	
	                        ticketContent += '<p>' + _('toEmailAddress') + ': ' + emailList + '</p>';
	                    }
	
	                    convertedItems.push({
	                        title: value.subject,
	                        description: ticketContent,
	                        endDate: value.sentDate,
	                        taskRelation: value._id
	                    });
	                });
	            }
	
	            return convertedItems;
	        };
	
	        this.getIcon = function () {
	            try {
	                return __webpack_require__(532);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        };
	
	        this.state = { outboxSyncIsOpen: false };
	    }
	
	    /**
	     * This function naviget to the detailed overview of a sent email and set seen that email.
	     */
	
	    _createClass(Outbox, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props;
	            var items = _props3.items;
	            var opened = _props3.opened;
	            var staff = _props3.staff;
	            var outboxSyncIsOpen = this.state.outboxSyncIsOpen;
	
	            var openedEmailInstance = opened && items && items.length > 0 && items.filter(function (item, key) {
	                return item.id == opened;
	            })[0] || {};
	            return _react2['default'].createElement(
	                'div',
	                { id: '' + _outboxScss2['default'].outboxModule },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _outboxScss2['default'].mainTitleDiv },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: '' + _outboxScss2['default'].mainTitleContainer },
	                        _react2['default'].createElement(
	                            'h2',
	                            { className: '' + _outboxScss2['default'].mainTitle },
	                            _('title')
	                        ),
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            _('subtitle')
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _outboxScss2['default'].moduleControls },
	                        _react2['default'].createElement(
	                            'button',
	                            { onClick: this.zoomOut,
	                                className: _outboxScss2['default'].backToList + ' ' + _outboxScss2['default'].greyButton + ' ' + (opened ? 'visible' : _outboxScss2['default'].hidden) },
	                            _('backToList')
	                        )
	                    ),
	                    (openedEmailInstance.status == 'failed' || openedEmailInstance.status == 'bounced') && _react2['default'].createElement(
	                        'div',
	                        { className: _outboxScss2['default'].moduleControls },
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    _this2.setState({ outboxSyncIsOpen: true });
	                                },
	                                className: (0, _classnames2['default'])(_outboxScss2['default'].backToList + ' ' + _outboxScss2['default'].greyButton + ' ' + (opened ? 'visible' : _outboxScss2['default'].hidden), _outboxScss2['default'].regenerateButton) },
	                            _react2['default'].createElement('img', { className: _outboxScss2['default'].regenerateButtonIcon, src: this.getIcon() }),
	                            _react2['default'].createElement(
	                                'div',
	                                null,
	                                _('syncPDF')
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(_outboxEmailList2['default'], {
	                    emails: items,
	                    zoomTo: this.zoomTo,
	                    taskConvertionSecurity: this.getTaskCreatorSecurity(),
	                    handleMakeAsTodo: this.handleTaskCreatorModalToggling
	                }),
	                opened && _react2['default'].createElement(_detailedEmail2['default'], { email: openedEmailInstance }),
	                _react2['default'].createElement(_taskCreator2['default'], {
	                    modalTitle: 'outboxTaskCreatorModalTitle',
	                    taskItems: this.generateTaskCreatorItems(items),
	                    staffItems: staff,
	                    convertionType: 'outbox'
	                }),
	                outboxSyncIsOpen && _react2['default'].createElement(_outboxPdfSync2['default'], {
	                    email: openedEmailInstance,
	                    callBack: function () {
	                        _this2.setState({ outboxSyncIsOpen: false });
	                    }
	                })
	            );
	        }
	    }]);
	
	    var _Outbox = Outbox;
	    Outbox = (0, _reactRedux.connect)(function (_ref) {
	        var _ref$outbox = _ref.outbox;
	        var items = _ref$outbox.items;
	        var modalIsOpen = _ref$outbox.modalIsOpen;
	        var opened = _ref$outbox.opened;
	        var subModule = _ref$outbox.subModule;
	        var security = _ref.app.security;
	        var staff = _ref.inbox.staff;
	        return { items: items, modalIsOpen: modalIsOpen, opened: opened, subModule: subModule, security: security, staff: staff };
	    }, { setOutboxEmailOpened: _stateActions.setOutboxEmailOpened, setOutboxSubModule: _stateActions.setOutboxSubModule, setSeenOutboxEmail: _stateActions.setSeenOutboxEmail, taskCreatorModalToggle: _stateActions.taskCreatorModalToggle })(Outbox) || Outbox;
	    return Outbox;
	})(_react.Component);
	
	exports['default'] = Outbox;
	module.exports = exports['default'];

	/**
	 * This function will close the detailed page of an email.
	 */

	/**
	 * Retrieves the 'Inboxtask' permission value from security
	 * if the permission was not found in the security state value, the value will be false
	 * @return {bool} the 'Inboxtask' permission value
	 */

	/**
	 * Handles the the taskCreator modal visibility toggeling
	 */

	/**
	 * Converts the outbox items to task `shape` objects to be readable by the taskCreator component
	 * @param {array} items the list of data to be converted
	 * @return {array} the task `shape` objects generated data
	 */

	/**
	 * This function helps to use an icon on a safe way
	 */

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(57);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _outboxScss = __webpack_require__(440);
	
	var _outboxScss2 = _interopRequireDefault(_outboxScss);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _stateActions = __webpack_require__(5);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _componentsSharedSelectSelectWrap2 = _interopRequireDefault(_componentsSharedSelectSelectWrap);
	
	var _refreshBtn = __webpack_require__(174);
	
	var _refreshBtn2 = _interopRequireDefault(_refreshBtn);
	
	var _outboxHelpers = __webpack_require__(609);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _libValidator = __webpack_require__(96);
	
	var _elementsHtmlContent = __webpack_require__(110);
	
	var _elementsHtmlContent2 = _interopRequireDefault(_elementsHtmlContent);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _emailSenderHelpersJsx = __webpack_require__(368);
	
	var _emailSenderEmailServerConfigDialog = __webpack_require__(367);
	
	var _emailSenderEmailServerConfigDialog2 = _interopRequireDefault(_emailSenderEmailServerConfigDialog);
	
	var _ = (0, _libI18n2['default'])('outbox');
	var _emailSenderTranslates = (0, _libI18n2['default'])('emailSender');
	var EMAIL_STATUS_FAILED = 'failed';
	var EMAIL_STATUS_BOUNCED = 'bounced';
	var EMAIL_STATUS_RESENT = 'resent';
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var OutboxEmailList = (function (_React$Component) {
	    _inherits(OutboxEmailList, _React$Component);
	
	    _createClass(OutboxEmailList, null, [{
	        key: 'propTypes',
	        value: {
	            filter: _react.PropTypes.string.isRequired,
	            selectValue: _react.PropTypes.string.isRequired,
	            setCheckBox: _react.PropTypes.func.isRequired,
	            selectVisibleItems: _react.PropTypes.func.isRequired,
	            selectItems: _react.PropTypes.func.isRequired,
	            filterOutbox: _react.PropTypes.func.isRequired,
	            archiveEmail: _react.PropTypes.func.isRequired,
	            archiveAllEmail: _react.PropTypes.func.isRequired,
	            getOutbox: _react.PropTypes.func.isRequired,
	            setNotification: _react.PropTypes.func.isRequired,
	            emails: _react2['default'].PropTypes.array.isRequired,
	            zoomTo: _react2['default'].PropTypes.func.isRequired,
	            startDate: _react2['default'].PropTypes.any,
	            endDate: _react2['default'].PropTypes.any,
	            handleSubmit: _react2['default'].PropTypes.func.isRequired,
	            setSeenOutboxEmail: _react2['default'].PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    function OutboxEmailList(props) {
	        var _this = this;
	
	        _classCallCheck(this, _OutboxEmailList);
	
	        _get(Object.getPrototypeOf(_OutboxEmailList.prototype), 'constructor', this).call(this, props);
	
	        this.handleCheckAll = function () {
	            var _props = _this.props;
	            var selectVisibleItems = _props.selectVisibleItems;
	            var setNotification = _props.setNotification;
	            var allSelected = _this.allSelected;
	            var visibleIds = _this.visibleIds;
	
	            if (!allSelected) {
	                var msg = _('all') + ' ' + visibleIds.length + ' ' + _('numOfSelectedMsg');
	                setNotification(msg, 'info');
	            }
	            selectVisibleItems(visibleIds);
	        };
	
	        this.handleVisibleList = function (visibleIds) {
	            var visibilityOf = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = visibleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var id = _step.value;
	
	                    visibilityOf[id] = true;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator['return']) {
	                        _iterator['return']();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            _this.visibleIds = visibleIds;
	            _this.setState({ visibilityOf: visibilityOf });
	        };
	
	        this.saveForm = function (data) {
	            var selectValue = _this.props.selectValue;
	
	            _this.props.filterOutbox(selectValue, data.startDate, data.endDate);
	        };
	
	        this.state = { visibilityOf: {}, archiveIsOpen: false, statusExplainerIsOpen: false,
	            resendEmailPopupIsOpen: false, resendToAddress: '', resendingButtonDisabled: false,
	            resendEmailInstance: {}, resendToAddressValid: false, resendToAddressTouched: false,
	            selectedItem: null };
	    }
	
	    _createClass(OutboxEmailList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refresh();
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh(force) {
	            var getOutbox = this.props.getOutbox;
	
	            getOutbox(force);
	        }
	    }, {
	        key: 'check',
	        value: function check(ev, id) {
	            ev.stopPropagation();
	            var setCheckBox = this.props.setCheckBox;
	
	            setCheckBox(id);
	        }
	    }, {
	        key: 'archiveBtn',
	        value: function archiveBtn(checkedItemCount, items) {
	            var _this2 = this;
	
	            var _props2 = this.props;
	            var archiveEmail = _props2.archiveEmail;
	            var taskConvertionSecurity = _props2.taskConvertionSecurity;
	            var handleMakeAsTodo = _props2.handleMakeAsTodo;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _outboxScss2['default'].buttonContainer },
	                _react2['default'].createElement('input', {
	                    onClick: function (ev) {
	                        return archiveEmail(items);
	                    },
	                    disabled: !checkedItemCount,
	                    type: 'button',
	                    className: _outboxScss2['default'].greyButton,
	                    value: _("delete")
	                }),
	                _react2['default'].createElement('input', {
	                    onClick: function () {
	                        return _this2.archiveAllPopupToggle();
	                    },
	                    disabled: !(items && items.length || false),
	                    type: 'button',
	                    className: _outboxScss2['default'].greyButton,
	                    value: _("deleteAll")
	                }),
	                taskConvertionSecurity && _react2['default'].createElement(
	                    'button',
	                    { onClick: handleMakeAsTodo,
	                        disabled: !checkedItemCount,
	                        className: _outboxScss2['default'].backToList + ' ' + _outboxScss2['default'].greyButton },
	                    _('makeAsTodo')
	                )
	            );
	        }
	    }, {
	        key: 'archiveAllPopupToggle',
	        value: function archiveAllPopupToggle() {
	            this.setState({ archiveIsOpen: !this.state.archiveIsOpen });
	        }
	    }, {
	        key: 'archiveAllConfirmHandle',
	        value: function archiveAllConfirmHandle() {
	            var _props3 = this.props;
	            var archiveAllEmail = _props3.archiveAllEmail;
	            var selectItems = _props3.selectItems;
	            var emails = _props3.emails;
	            var setNotification = _props3.setNotification;
	
	            var filteredEmails = emails.filter(function (item) {
	                return !item.hidden;
	            });
	            selectItems(filteredEmails);
	            archiveAllEmail(filteredEmails);
	            this.archiveAllPopupToggle();
	
	            var itemsLength = filteredEmails && filteredEmails.length || 0;
	            var msg = _('all') + ' ' + itemsLength + ' ' + _('emailsDeleted');
	            setNotification(msg, 'info');
	        }
	    }, {
	        key: 'archiveAllPopup',
	        value: function archiveAllPopup() {
	            var _this3 = this;
	
	            var emails = this.props.emails;
	
	            var filteredEmails = emails.filter(function (item) {
	                return !item.hidden;
	            });
	            var itemsLength = filteredEmails && filteredEmails.length || 0;
	            var titleMsg = _('all') + ' ' + itemsLength + ' ' + _('numOfSelectedMsg');
	            var msg = '' + _('doYouWantToArchiveAll');
	            return _react2['default'].createElement(
	                'div',
	                { className: _outboxScss2['default'].archiveModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _outboxScss2['default'].title },
	                    titleMsg
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _outboxScss2['default'].message },
	                    msg
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _outboxScss2['default'].archiveModalButtons },
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                return _this3.archiveAllPopupToggle();
	                            },
	                            className: _outboxScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            return _this3.archiveAllConfirmHandle();
	                        },
	                        type: 'button',
	                        className: _outboxScss2['default'].greyButton + " enabled",
	                        value: _("deleteAll")
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'onItemStatusClick',
	
	        /**
	         * This function handle the email status modal opening
	         * @param {object} item - one email record
	         */
	        value: function onItemStatusClick(item) {
	            var _props4 = this.props;
	            var dispatch = _props4.dispatch;
	            var setSeenOutboxEmail = _props4.setSeenOutboxEmail;
	
	            setSeenOutboxEmail(item.id);
	
	            // status check
	            if (!item || item.status != EMAIL_STATUS_FAILED && item.status != EMAIL_STATUS_BOUNCED) {
	                return;
	            }
	
	            this.setState({ statusExplainerIsOpen: item });
	        }
	
	        /**
	         * This will render the modal content of status explainer in case of error.
	         */
	    }, {
	        key: 'statusExplainerPopup',
	        value: function statusExplainerPopup() {
	            var _this4 = this;
	
	            var statusExplainerIsOpen = this.state.statusExplainerIsOpen;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _outboxScss2['default'].archiveModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _outboxScss2['default'].title },
	                    _('emailStatusMessageModalTitle')
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _outboxScss2['default'].message },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _outboxScss2['default'].emailBodyContainer },
	                        !statusExplainerIsOpen.statusMessage || statusExplainerIsOpen.statusMessage.length == 0 ? _("noMessageAboutFail") : _react2['default'].createElement(_elementsHtmlContent2['default'], { content: statusExplainerIsOpen.statusMessage, className: _outboxScss2['default'].content })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _outboxScss2['default'].archiveModalButtons },
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this4.setState({ statusExplainerIsOpen: false });
	                        },
	                        type: 'button',
	                        className: _outboxScss2['default'].greyButton + " enabled",
	                        value: _("ok")
	                    })
	                )
	            );
	        }
	
	        /**
	         * Get the translation of the current item status for the overview
	         * @param {*} item
	         */
	    }, {
	        key: 'getStatusTextForList',
	        value: function getStatusTextForList(item) {
	            var status = item.status;
	
	            // in case of resent flag is set, the show resent in place of bounced or failed
	            if (item.wasResent) {
	                status = 'resent';
	            }
	
	            return status && _(status) || "";
	        }
	
	        /**
	         * This will render the modal content of status explainer in case of error.
	         */
	    }, {
	        key: 'resendEmailPopup',
	        value: function resendEmailPopup() {
	            var _this5 = this;
	
	            var _state = this.state;
	            var resendToAddress = _state.resendToAddress;
	            var resendingButtonDisabled = _state.resendingButtonDisabled;
	            var resendEmailInstance = _state.resendEmailInstance;
	            var resendToAddressValid = _state.resendToAddressValid;
	            var resendToAddressTouched = _state.resendToAddressTouched;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _outboxScss2['default'].archiveModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _outboxScss2['default'].title },
	                    _('resendEmailModalTitle')
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: _outboxScss2['default'].message },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _outboxScss2['default'].resendModalContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _outboxScss2['default'].formInputContainer },
	                            _react2['default'].createElement(
	                                'div',
	                                null,
	                                _('resendEmailModalDescription')
	                            ),
	                            _react2['default'].createElement(
	                                'label',
	                                { className: (0, _classnames2['default'])(_outboxScss2['default'].formLabel, _outboxScss2['default'].width3) },
	                                _('typeANewEmailAddressToSend'),
	                                ':* '
	                            ),
	                            _react2['default'].createElement('input', {
	                                className: (0, _classnames2['default'])(_outboxScss2['default'].formInput, _outboxScss2['default'].width7, _outboxScss2['default'].ieFixHeight),
	                                type: 'text',
	                                value: resendToAddress,
	                                onChange: function (e) {
	                                    _this5.changeResendToAddress(e.target.value);
	                                },
	                                onBlur: function () {
	                                    _this5.onBlurResendToAddress();
	                                }
	                            })
	                        ),
	                        !resendToAddressValid && resendToAddressTouched && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _outboxScss2['default'].errorMessage },
	                                _('emailAddressIsRequired')
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _outboxScss2['default'].archiveModalButtons },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            onClick: function () {
	                                _this5.setState({ resendEmailPopupIsOpen: false });
	                            },
	                            className: _outboxScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this5.resendEmail(resendEmailInstance);
	                        },
	                        type: 'button',
	                        className: _outboxScss2['default'].greyButton + (resendingButtonDisabled || !resendToAddressValid ? " disabled" : " enabled"),
	                        value: _("resendEmail"),
	                        disabled: resendingButtonDisabled || !resendToAddressValid
	                    })
	                )
	            );
	        }
	
	        /**
	         *
	         * @param {*} value
	         */
	    }, {
	        key: 'changeResendToAddress',
	        value: function changeResendToAddress(value) {
	            this.setState({
	                resendToAddress: value
	            });
	        }
	    }, {
	        key: 'onBlurResendToAddress',
	        value: function onBlurResendToAddress() {
	            // check validity
	            var resendToAddress = this.state.resendToAddress;
	
	            var valid = true;
	
	            if (!resendToAddress || !(0, _libValidator.isAnEmail)(resendToAddress)) {
	                valid = false;
	            }
	
	            this.setState({
	                resendToAddressValid: valid,
	                resendToAddressTouched: true
	            });
	        }
	    }, {
	        key: 'onResendEmailClick',
	        value: function onResendEmailClick(item) {
	            var _this6 = this;
	
	            var dispatch = this.props.dispatch;
	
	            var senderEmailFieldValue = item.senderEmail;
	            if (!item.senderName) {
	                //this case sender email has no emailserver configured ore is lacking senderName param
	
	                //double check if there is a email server and it has sender name
	                dispatch((0, _stateActions.loadEmailServer)(senderEmailFieldValue)).then(function (res) {
	                    if (res && res.senderName && res.senderName.length > 0) {
	                        _this6.doOpenResendModal(item);
	                    } else {
	                        dispatch((0, _stateActions.showEmailServerConfigModal)(senderEmailFieldValue));
	                    }
	                })['catch'](function (err) {
	                    _this6.setState({ selectedItem: item });
	                    dispatch((0, _stateActions.showEmailServerConfigModal)(senderEmailFieldValue));
	                });
	            } else {
	                //continue to resend modal
	                this.doOpenResendModal(item);
	            }
	        }
	    }, {
	        key: 'doOpenResendModal',
	        value: function doOpenResendModal(item) {
	            this.setState({
	                resendEmailInstance: JSON.parse(JSON.stringify(item)),
	                resendEmailPopupIsOpen: true
	            });
	        }
	
	        /**
	         *
	         * @param {*} resendEmailInstance
	         */
	    }, {
	        key: 'resendEmail',
	        value: function resendEmail(resendEmailInstance) {
	            var _this7 = this;
	
	            var resendToAddress = this.state.resendToAddress;
	            var dispatch = this.props.dispatch;
	
	            this.setState({ resendingButtonDisabled: true });
	
	            var finalEmail = {
	                fromName: resendEmailInstance.senderName || "",
	                senderEmail: resendEmailInstance.senderEmail || "",
	                cleanSenderEmail: resendEmailInstance.cleanSenderEmail || resendEmailInstance.senderEmail,
	                to: resendToAddress,
	                subject: resendEmailInstance.subject,
	                message: resendEmailInstance.content, // signature is included
	                signatureHtml: "", // content also contains because this is a resend
	                disclaimerHtml: "", // content also contains because this is a resend
	                signatureImageUrls: (0, _emailSenderHelpersJsx.fetchSrcValuesFromHtml)(resendEmailInstance.content),
	                attachments: resendEmailInstance.attachments,
	                hardAttachments: resendEmailInstance.hardAttachments,
	                recipient: resendEmailInstance.recipient,
	                templateId: resendEmailInstance.templateId,
	                templateIndexType: resendEmailInstance.templateIndexType,
	                templateLowValue: resendEmailInstance.templateLowValue,
	                templateTitle: resendEmailInstance.templateTitle,
	                templateAbbr: resendEmailInstance.templateAbbr,
	                clientId: resendEmailInstance.clientId,
	                contractId: resendEmailInstance.contractId,
	                claimId: resendEmailInstance.claimId,
	                signatureId: resendEmailInstance.signatureId,
	                resentOf: resendEmailInstance._id,
	                uploadedOnModule: resendEmailInstance.uploadedOnModule
	            };
	
	            dispatch((0, _stateActions.sendEmailBySender)(finalEmail)).then(function () {
	                _this7.setState({ resendEmailPopupIsOpen: false });
	                _this7.setState({ resendingButtonDisabled: false });
	                _this7.setState({ resendToAddress: "" });
	                _this7.refresh(true);
	            })['catch'](function () {
	                _this7.setState({ resendEmailPopupIsOpen: false });
	                _this7.setState({ resendingButtonDisabled: false });
	                _this7.setState({ resendToAddress: "" });
	                _this7.refresh(true);
	            });
	        }
	
	        /**
	         * Render hook of react.
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var _props5 = this.props;
	            var emails = _props5.emails;
	            var zoomTo = _props5.zoomTo;
	            var filterOutbox = _props5.filterOutbox;
	            var selectValue = _props5.selectValue;
	            var getOutbox = _props5.getOutbox;
	            var opened = _props5.opened;
	            var _props5$fields = _props5.fields;
	            var startDate = _props5$fields.startDate;
	            var endDate = _props5$fields.endDate;
	            var handleSubmit = _props5.handleSubmit;
	            var emailServerConfigModalIsOpen = _props5.emailServerConfigModalIsOpen;
	            var dispatch = _props5.dispatch;
	            var _state2 = this.state;
	            var visibilityOf = _state2.visibilityOf;
	            var archiveIsOpen = _state2.archiveIsOpen;
	            var statusExplainerIsOpen = _state2.statusExplainerIsOpen;
	            var resendEmailPopupIsOpen = _state2.resendEmailPopupIsOpen;
	            var selectedItem = _state2.selectedItem;
	
	            var checkedItemCount = emails.reduce(function (sum, item) {
	                return sum + (item.checked ? 1 : 0);
	            }, 0);
	            var allSelected = emails && emails.length > 0 && emails.every(function (item) {
	                return visibilityOf[item.id] ? item.checked : true;
	            });
	            this.allSelected = allSelected;
	
	            // filter the hidden email from the list, sort in order by sorting rules
	            var filteredEmails = emails.filter(function (oneEmail) {
	                return !oneEmail.hidden;
	            }).map(function (oneEmail) {
	                var priority = (0, _moment2['default'])(oneEmail.sentDate).format("YYYYMMDDHHmmss");
	                var listOfPriorityStatuses = [EMAIL_STATUS_BOUNCED, EMAIL_STATUS_FAILED];
	                var hasStatusWithPriority = listOfPriorityStatuses.includes(oneEmail.status);
	
	                // give a higher priority in case of error or bounce and not seen, exception if the email was already resent
	                // rule description in: BEWB-156
	                if (oneEmail.status == hasStatusWithPriority && !oneEmail.seenInOutbox && !oneEmail.wasResent) {
	                    priority = "9" + (0, _moment2['default'])().format("YYYYMMDDHHmmss") + oneEmail.seenInOutbox;
	                }
	
	                oneEmail.priority = priority;
	
	                return oneEmail;
	            });
	
	            // Needs to be defined here so translations are updated
	            var filterOptions = [{ value: 'showAll', label: _('showAll') }, { value: 'showSent', label: _('showSent') }, { value: 'showUnSent', label: _('showUnSent') }];
	            if (!emails) {
	                return false;
	            }
	
	            var onSubmit = handleSubmit(this.saveForm);
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _outboxScss2['default'].results + ' ' + (opened ? _outboxScss2['default'].hidden : 'visible') },
	                _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        onVisibleChange: this.handleVisibleList,
	                        topPaginationElemL: [_react2['default'].createElement(
	                            'div',
	                            { key: 'x1z', className: 'filterSelectContainer' },
	                            _react2['default'].createElement(_componentsSharedSelectSelectWrap2['default'], {
	                                key: 's',
	                                value: selectValue,
	                                options: filterOptions,
	                                onChange: function (v) {
	                                    filterOutbox(v.value, startDate.value, endDate.value);
	                                },
	                                className: _outboxScss2['default'].selectStyle
	                            })
	                        ), _react2['default'].createElement(_refreshBtn2['default'], {
	                            key: 'r',
	                            onClick: function () {
	                                getOutbox(true);
	                                onSubmit();
	                            }
	                        })],
	                        topPaginationElemR: this.archiveBtn(checkedItemCount, filteredEmails),
	                        middlePagination: true,
	                        middlePaginationElem: [_react2['default'].createElement(
	                            'div',
	                            { className: _outboxScss2['default'].datePickerContainer, key: "pickerContainer" },
	                            _react2['default'].createElement(
	                                'form',
	                                { onSubmit: onSubmit },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: '' + _outboxScss2['default'].submitContainer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: '' + _outboxScss2['default'].inputContainer },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: '' + _outboxScss2['default'].label },
	                                            _react2['default'].createElement(
	                                                'p',
	                                                null,
	                                                _('fromDate')
	                                            )
	                                        ),
	                                        _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, _extends({ className: _outboxScss2['default'].inputForm
	                                        }, startDate, {
	                                            startDate: startDate.value,
	                                            endDate: endDate.value,
	                                            maxDate: endDate.value
	                                        }))
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: '' + _outboxScss2['default'].inputContainer },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: '' + _outboxScss2['default'].label },
	                                            _react2['default'].createElement(
	                                                'p',
	                                                null,
	                                                _('toDate')
	                                            )
	                                        ),
	                                        _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, _extends({
	                                            className: _outboxScss2['default'].inputForm
	                                        }, endDate, {
	                                            startDate: startDate.value,
	                                            endDate: endDate.value,
	                                            minDate: startDate.value
	                                        }))
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: '' + _outboxScss2['default'].inputContainer },
	                                        _react2['default'].createElement('input', { className: '' + _outboxScss2['default'].inputSubmit, type: 'button', onClick: onSubmit, value: _('filterDateBtn') })
	                                    )
	                                )
	                            )
	                        )],
	                        filterable: ["sentDate", "recipient", "toEmailAddress", "subject", "status"],
	                        ref: function (el) {
	                            _this8.table = el;
	                        },
	                        id: 'table',
	                        className: 'table',
	                        sortable: [{ column: 'sentDate', sortFunction: 'Date' }, 'recipient', 'toEmailAddress', 'subject', 'status', { column: 'priority', sortFunction: 'Date' }],
	                        defaultSort: {
	                            //column: 'sentDate',
	                            column: 'priority',
	                            direction: 'desc'
	                        },
	
	                        itemsPerPage: 50,
	                        pageButtonLimit: 5
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'priority',
	                                className: _outboxScss2['default'].hidden
	                            },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("priority")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'checkbox' },
	                            _react2['default'].createElement('input', { type: 'checkbox', checked: allSelected, onChange: this.handleCheckAll })
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'sentDate' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("sentDate")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'recipient' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("recipient")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'toEmailAddress' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("toEmailAddress")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'subject' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("subject")
	                            )
	                        ),
	                        _react2['default'].createElement(_componentsReactable.Th, { column: 'resend', label: '' }),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'status' },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("status")
	                            )
	                        )
	                    ),
	                    filteredEmails.map(function (item, key) {
	                        var recipient = item.recipient || '';
	                        var recipientTranslationKey = 'recipient' + recipient.charAt(0).toUpperCase() + recipient.slice(1);
	                        var itemStatusTranslated = _this8.getStatusTextForList(item);
	                        var trStyleArchived = item.archived ? _outboxScss2['default'].archived + ' clickable' : 'clickable';
	                        var trStyleFailedUnseen = (item.status == EMAIL_STATUS_FAILED || item.status == EMAIL_STATUS_BOUNCED) && !item.seenInOutbox ? _outboxScss2['default'].failedUnSeen : '';
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            {
	                                className: (0, _classnames2['default'])(trStyleArchived, trStyleFailedUnseen, _outboxScss2['default'].trFirstColumnHidden),
	                                i: item.id,
	                                key: key,
	                                onClick: function () {
	                                    zoomTo(item);
	                                }
	                            },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                {
	                                    column: 'priority',
	                                    value: item.priority
	                                },
	                                item.priority
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'checkbox', value: (0, _lodashCollection.map)(item.content, function (i) {
	                                        return i;
	                                    }).join(' ') },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { style: { width: 15 } },
	                                    _react2['default'].createElement('input', {
	                                        type: 'checkbox',
	                                        onClick: function (ev) {
	                                            return ev.stopPropagation();
	                                        },
	                                        onChange: function (ev) {
	                                            return _this8.check(ev, item.id);
	                                        },
	                                        checked: item.checked
	                                    })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                {
	                                    column: 'sentDate',
	                                    value: // timestamp and id for correct sort
	                                    (item.sentDate && (0, _moment2['default'])(item.sentDate).format("X") || "") + item.id
	                                },
	                                item.sentDate && (0, _moment2['default'])(item.sentDate).format("DD/MM/YYYY HH:mm:ss") || ""
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'recipient', value: item.recipient },
	                                _emailSenderTranslates(recipientTranslationKey)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'toEmailAddress', value: item.toEmailAddress },
	                                _react2['default'].createElement(_outboxHelpers.RenderEmails, { emails: item.toEmailAddress })
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'subject', value: item.subject },
	                                item.subject
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'resend' },
	                                item && (item.status == EMAIL_STATUS_FAILED || item.status == EMAIL_STATUS_BOUNCED) && !item.wasResent ? _react2['default'].createElement(
	                                    'button',
	                                    { onClick: function (ev) {
	                                            ev.stopPropagation();
	                                            _this8.onResendEmailClick(item);
	                                        },
	                                        className: (0, _classnames2['default'])('greyButton visible', _outboxScss2['default'].resendButton) },
	                                    _('resendEmail')
	                                ) : null
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'status', value: item.status },
	                                item.status == EMAIL_STATUS_FAILED || item.status == EMAIL_STATUS_BOUNCED ? _react2['default'].createElement(
	                                    'a',
	                                    { className: (0, _classnames2['default'])(_outboxScss2['default'].statusFailed, /* item.wasResent ? styles.statusResent : */""),
	                                        onClick: function (ev) {
	                                            ev.stopPropagation();
	                                            _this8.onItemStatusClick(item);
	                                        } },
	                                    itemStatusTranslated
	                                ) : itemStatusTranslated
	                            )
	                        );
	                    })
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: archiveIsOpen,
	                        style: customStyles
	                    },
	                    this.archiveAllPopup()
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: Boolean(statusExplainerIsOpen),
	                        style: customStyles
	                    },
	                    this.statusExplainerPopup()
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: Boolean(resendEmailPopupIsOpen),
	                        style: _outboxHelpers.customModalStyles
	                    },
	                    this.resendEmailPopup()
	                ),
	                _react2['default'].createElement(_emailSenderEmailServerConfigDialog2['default'], {
	                    modalIsOpen: emailServerConfigModalIsOpen,
	                    onCancel: function () {
	                        var dispatch = _this8.props.dispatch;
	
	                        dispatch((0, _stateActions.hideEmailServerConfigModal)(false));
	                    },
	                    onConfirmation: function (config) {
	                        dispatch((0, _stateActions.saveEmailServer)(config)).then(function (res) {
	                            dispatch((0, _stateActions.hideEmailServerConfigModal)(true));
	                            if (res) {
	                                _this8.doOpenResendModal(selectedItem);
	                                _this8.setState({ selectedItem: null });
	                            }
	                        });
	                    }
	                })
	            );
	        }
	    }]);
	
	    var _OutboxEmailList = OutboxEmailList;
	    OutboxEmailList = (0, _reactRedux.connect)(function (state) {
	        var _state$outbox = state.outbox;
	        var filter = _state$outbox.filter;
	        var selectValue = _state$outbox.selectValue;
	        var modalIsOpen = _state$outbox.modalIsOpen;
	        var opened = _state$outbox.opened;
	        var subModule = _state$outbox.subModule;
	        var startDate = _state$outbox.startDate;
	        var endDate = _state$outbox.endDate;
	        var lang = state.app.lang;
	
	        return {
	            filter: filter,
	            selectValue: selectValue,
	            modalIsOpen: modalIsOpen,
	            opened: opened,
	            subModule: subModule,
	            startDate: startDate,
	            endDate: endDate,
	            lang: lang,
	            emailServerConfigModalIsOpen: state.emailSender.emailServerConfigModalIsOpen,
	            serverConfigIsSaved: state.emailSender.serverConfigIsSaved
	        };
	    }, { setNotification: _stateActions.setNotification, setCheckBox: _stateActions.setCheckBox, selectVisibleItems: _stateActions.selectVisibleItems, filterOutbox: _stateActions.filterOutbox, archiveEmail: _stateActions.archiveEmail, archiveAllEmail: _stateActions.archiveAllEmail, getOutbox: _stateActions.getOutbox, selectItems: _stateActions.selectItems, setSeenOutboxEmail: _stateActions.setSeenOutboxEmail })(OutboxEmailList) || OutboxEmailList;
	    OutboxEmailList = (0, _reduxForm.reduxForm)({
	        form: "OutboxEmailList",
	        fields: ["startDate", "endDate"],
	        initialValues: {}
	    })(OutboxEmailList) || OutboxEmailList;
	    return OutboxEmailList;
	})(_react2['default'].Component);
	
	exports['default'] = OutboxEmailList;
	module.exports = exports['default'];

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stateActions = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _outboxPdfSyncScss = __webpack_require__(1623);
	
	var _outboxPdfSyncScss2 = _interopRequireDefault(_outboxPdfSyncScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ = (0, _libI18n2['default'])('outbox');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	/**
	 * Connect the the component to the redux store.
	 */
	
	/**
	 * This component handle the email PDF regenerate and synchronization for oracle
	 */
	
	var OutboxPdfSync = (function (_Component) {
	    _inherits(OutboxPdfSync, _Component);
	
	    _createClass(OutboxPdfSync, null, [{
	        key: 'propTypes',
	        value: {
	            email: _react.PropTypes.object,
	            callBack: _react.PropTypes.func
	        },
	
	        /**
	         * Constructor initialize component and the state.
	         * @param {*} props
	         */
	        enumerable: true
	    }]);
	
	    function OutboxPdfSync(props) {
	        _classCallCheck(this, _OutboxPdfSync);
	
	        _get(Object.getPrototypeOf(_OutboxPdfSync.prototype), 'constructor', this).call(this, props);
	        this.state = { progress: 0 };
	    }
	
	    /**
	     * This handle to push the confirmation button of regenerate PDF modal.
	     */
	
	    _createClass(OutboxPdfSync, [{
	        key: 'regeneratePDF',
	        value: function regeneratePDF() {
	            var _this = this;
	
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var email = _props.email;
	
	            this.setState({ progress: 1 }, function () {
	                dispatch((0, _stateActions.syncEmailPdf)(email._id)).then(function () {
	                    _this.setState({ progress: 2 });
	                })['catch'](function () {
	                    _this.setState({ progress: 3 });
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var callBack = this.props.callBack;
	            var progress = this.state.progress;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: true,
	                        style: customStyles,
	                        key: "OutboxPdfSyncModalKey",
	                        className: _outboxPdfSyncScss2['default'].modal
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _outboxPdfSyncScss2['default'].title },
	                            _("pleaseWait")
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _outboxPdfSyncScss2['default'].contentWrapper },
	                            progress == 0 ? _('pleaseWaitUntilThePDFWillSync') : "",
	                            progress == 1 ? _('inProgressPleaseWait') : "",
	                            progress == 2 ? _('synchronisationCompleted') : "",
	                            progress == 3 ? _('synchronisationNotCompleted') : "",
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _outboxPdfSyncScss2['default'].buttons },
	                                progress == 0 && _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            return callBack();
	                                        },
	                                        className: (0, _classnames2['default'])(_outboxPdfSyncScss2['default'].next, _outboxPdfSyncScss2['default'].enabled, _outboxPdfSyncScss2['default'].gray)
	                                    },
	                                    _("cancel")
	                                ),
	                                progress != 1 && _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            if (progress == 0) {
	                                                _this2.regeneratePDF();
	                                            } else if (progress >= 2) {
	                                                callBack();
	                                            }
	                                        },
	                                        className: (0, _classnames2['default'])(_outboxPdfSyncScss2['default'].next, _outboxPdfSyncScss2['default'].enabled)
	                                    },
	                                    _("ok")
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _OutboxPdfSync = OutboxPdfSync;
	    OutboxPdfSync = (0, _reactRedux.connect)(function (state) {
	        return {};
	    })(OutboxPdfSync) || OutboxPdfSync;
	    return OutboxPdfSync;
	})(_react.Component);
	
	exports['default'] = OutboxPdfSync;
	module.exports = exports['default'];

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _phoneCountryCodesSelectJson = __webpack_require__(446);
	
	var _phoneCountryCodesSelectJson2 = _interopRequireDefault(_phoneCountryCodesSelectJson);
	
	var _reactSelect = __webpack_require__(105);
	
	var options = _phoneCountryCodesSelectJson2['default'].map(function (_ref) {
	    var countryName = _ref.countryName;
	    var phoneCode = _ref.phoneCode;
	
	    var search = countryName.toLowerCase().split(/[^a-z]+/).join('|');
	    return {
	        value: '' + phoneCode,
	        label: ' ' + phoneCode,
	        search: '|' + phoneCode + '|' + search
	    };
	});
	
	var matcher = function matcher(filter) {
	    return function (option) {
	        var l = '|' + filter.toLowerCase().replace(/[^a-z0-9]/, '|');
	        return option.search.includes(l);
	    };
	};
	
	var filterConfig = {
	    ignoreCase: true,
	    ignoreAccents: true,
	    trim: true
	};
	
	// matchFrom: 'start',
	var filterOptions = function filterOptions(options, filter) {
	    return filter ? options.filter(matcher(filter)) : [];
	};
	
	var PhoneCountryCodesSelect = function PhoneCountryCodesSelect(props) {
	
	    return _react2['default'].createElement(_componentsSharedSelectSelectWrap.SelectWrapper, _extends({}, props, {
	        isSearchable: true,
	        isClearable: true,
	        onBlur: function () {
	            return props.onBlur();
	        },
	        options: options,
	        filterOption: filterOptions
	    }));
	};
	exports.PhoneCountryCodesSelect = PhoneCountryCodesSelect;
	PhoneCountryCodesSelect.propTypes = {
	    onBlur: _react.PropTypes.func
	};
	
	var CoutryPhoneCodesSelectCreatable = function CoutryPhoneCodesSelectCreatable(props) {
	    return _react2['default'].createElement(_componentsSharedSelectSelectWrap.SelectWrapper, _extends({}, props, {
	        placeholder: '',
	        options: options,
	        isCreatable: true,
	        isClearable: true,
	        isSearchable: true,
	        isMulti: false,
	        onBlur: function () {
	            return props.onBlur();
	        },
	        onBlurResetsInput: false,
	        formatCreateLabel: function (value) {
	            return props.createLabel + ' ' + value;
	        },
	        filterOption: (0, _reactSelect.createFilter)(filterConfig),
	        value: props.value && props.value.value,
	        onChange: function (value) {
	            return props.onChangeOther(value);
	        }
	    }));
	};
	exports.CoutryPhoneCodesSelectCreatable = CoutryPhoneCodesSelectCreatable;
	CoutryPhoneCodesSelectCreatable.propTypes = {
	    onBlur: _react.PropTypes.func,
	    createLabel: _react.PropTypes.string,
	    value: _react.PropTypes.object,
	    onChangeOther: _react.PropTypes.func
	};
	
	var CoutryPhoneCodesInput = function CoutryPhoneCodesInput(props) {
	
	    return _react2['default'].createElement('input', _extends({}, props, {
	        type: 'text',
	        className: props.className,
	        onChange: props.onChange
	    }));
	};
	exports.CoutryPhoneCodesInput = CoutryPhoneCodesInput;
	CoutryPhoneCodesInput.propTypes = {
	    className: _react.PropTypes.string,
	    onChange: _react.PropTypes.func
	};
	
	exports['default'] = PhoneCountryCodesSelect;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _listSelectScss = __webpack_require__(245);
	
	var _listSelectScss2 = _interopRequireDefault(_listSelectScss);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _generalComponentsInfoModal = __webpack_require__(369);
	
	var _generalComponentsInfoModal2 = _interopRequireDefault(_generalComponentsInfoModal);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        zIndex: 2
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var PhoneListSelect = (function (_React$Component) {
	    _inherits(PhoneListSelect, _React$Component);
	
	    _createClass(PhoneListSelect, null, [{
	        key: 'propTypes',
	        value: {
	            data: _react2['default'].PropTypes.array,
	            formStatus: _react2['default'].PropTypes.object,
	            dispatch: _react2['default'].PropTypes.func
	        },
	        enumerable: true
	    }]);
	
	    function PhoneListSelect(props) {
	        _classCallCheck(this, PhoneListSelect);
	
	        _get(Object.getPrototypeOf(PhoneListSelect.prototype), 'constructor', this).call(this, props);
	        this.state = { modalIsOpen: false, informModalOpen: false };
	    }
	
	    _createClass(PhoneListSelect, [{
	        key: 'getIcon',
	        value: function getIcon() {
	            try {
	                return __webpack_require__(79);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this.setState({ modalIsOpen: !this.state.modalIsOpen });
	        }
	    }, {
	        key: 'handleAddFieldButton',
	        value: function handleAddFieldButton() {
	            var data = this.props.data;
	
	            this.openModal();
	
	            data.addField({
	                number: "",
	                mobile: false,
	                'default': this.canIBeADefaultNumber(),
	                uniqueId: (0, _uuidV42['default'])()
	            });
	        }
	    }, {
	        key: 'canIBeADefaultNumber',
	        value: function canIBeADefaultNumber() {
	            var data = this.props.data;
	            var yesICanBeDefault = true;
	
	            if (data.length > 0) {
	                data.map(function (key, index) {
	                    yesICanBeDefault = key['default'].checked !== true && yesICanBeDefault;
	                });
	            }
	
	            return yesICanBeDefault;
	        }
	    }, {
	        key: 'removeItemFromList',
	        value: function removeItemFromList(itemUniqueId) {
	            var data = this.props.data;
	
	            Object.keys(data).map(function (dataKey) {
	                if (data[dataKey] && data[dataKey] !== undefined && data[dataKey].uniqueId.value === itemUniqueId) {
	                    data.removeField(dataKey);
	                }
	            });
	        }
	    }, {
	        key: 'removeItem',
	        value: function removeItem() {
	            var data = this.props.data;
	            data.removeField();
	        }
	    }, {
	        key: 'modalContentPopup',
	        value: function modalContentPopup() {
	            var _this = this;
	
	            var data = this.props.data;
	
	            var lastData = data.slice(-1)[0];
	            var errorData = true;
	
	            if (lastData != undefined) {
	                if (lastData.number.error != undefined) {
	                    errorData = true;
	                } else {
	                    errorData = false;
	                }
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].clientModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _listSelectScss2['default'].title },
	                    _("addPhoneNumber")
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('phoneNumber')
	                ),
	                lastData != undefined && _react2['default'].createElement('input', _extends({ type: 'text' }, lastData.number)),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    lastData != undefined && lastData.number.error && lastData.number.touched && lastData.number.error
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientModalButtons },
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this.openModal();
	                            _this.removeItem();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].cancel,
	                        value: _("cancel")
	                    }),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            return _this.openModal();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].next + " " + (!errorData && _listSelectScss2['default'].enabled),
	                        value: _("clientAdd"),
	                        disabled: errorData
	                    })
	                )
	            );
	        }
	
	        /**
	         * This will set the form value content in store
	         * @param {*} value
	         * @param {*} field
	         * @returns
	         */
	    }, {
	        key: 'updateFormValue',
	        value: function updateFormValue(value, field) {
	            var dispatch = this.props.dispatch;
	
	            return dispatch({
	                type: "redux-form/CHANGE",
	                field: field.name,
	                value: value && value.value,
	                touch: value && value.touched || field.touched,
	                form: "clientProfileEdit"
	            });
	        }
	
	        /**
	         *
	         * @param {*} uniqueId
	         * @param {any}
	         * @returns
	         */
	    }, {
	        key: 'setCheckedAndClearOthers',
	        value: function setCheckedAndClearOthers(uniqueId, phoneNumbers) {
	            var returnValue, i, onePhoneNumber, isThisTheSelectedField, formChangeResult;
	            return regeneratorRuntime.async(function setCheckedAndClearOthers$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        returnValue = undefined;
	                        i = 0;
	
	                    case 2:
	                        if (!(i < phoneNumbers.length)) {
	                            context$2$0.next = 15;
	                            break;
	                        }
	
	                        onePhoneNumber = phoneNumbers[i];
	
	                        // reset all values
	                        onePhoneNumber['default'].value = false;
	                        onePhoneNumber['default'].checked = false;
	
	                        // check if this is the selected radio button
	                        isThisTheSelectedField = onePhoneNumber.uniqueId.value === uniqueId.value;
	
	                        // overwrite the selected value to checked
	                        if (isThisTheSelectedField) {
	                            onePhoneNumber['default'].value = true;
	                            onePhoneNumber['default'].checked = true;
	                        }
	
	                        // update redux form
	                        context$2$0.next = 10;
	                        return regeneratorRuntime.awrap(this.updateFormValue(onePhoneNumber['default'], onePhoneNumber['default']));
	
	                    case 10:
	                        formChangeResult = context$2$0.sent;
	
	                        // keep the actual filed changing return value for the input
	                        if (isThisTheSelectedField) {
	                            returnValue = formChangeResult;
	                        }
	
	                    case 12:
	                        i++;
	                        context$2$0.next = 2;
	                        break;
	
	                    case 15:
	                        return context$2$0.abrupt('return', returnValue);
	
	                    case 16:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Rendering content of information modal
	         */
	    }, {
	        key: 'informModalRender',
	        value: function informModalRender(warningModalOpen) {
	            var _this2 = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: stylesDocCss.documentsModalContent, key: 'phoneListSelectInformModalRender' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: stylesDocCss.title },
	                    _('phoneListSelectPreventDeleteModalTitle')
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: stylesDocCss.message },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: stylesDocCss.resendModalContainer },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel) },
	                            _('phoneListSelectPreventDeleteModalDescription')
	                        ),
	                        warningModalOpen && _react2['default'].createElement(
	                            'div',
	                            null,
	                            JSON.stringify(warningModalOpen)
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: stylesDocCss.documentsModalButtons },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            onClick: function () {
	                                _this2.setState({ warningModalOpen: false });
	                            },
	                            className: stylesDocCss.greenButton + " enabled"
	                        },
	                        _("ok")
	                    )
	                )
	            );
	        }
	
	        /**
	         * This function parse the initial values of phone numbers to check if there is an already set default
	         * phone number
	         * @param {Array} phoneNumbers - list of redux-form fields for phone numbers
	         * @returns
	         */
	    }, {
	        key: 'areDefaultValueSetForPhoneNumbers',
	        value: function areDefaultValueSetForPhoneNumbers(phoneNumbers) {
	            var isSetDefaultValue = false;
	
	            phoneNumbers.map(function (onePhoneNumber, key) {
	                delete onePhoneNumber['default'].value;
	                delete onePhoneNumber.mobile.value;
	
	                if (onePhoneNumber['default'].checked == true) {
	                    isSetDefaultValue = true;
	                }
	
	                return onePhoneNumber;
	            });
	
	            return isSetDefaultValue;
	        }
	
	        /**
	         * This function remove the "value" properties from the list of the redux-form phoneNumbers -fields list,
	         * to use only the checked property on radio-buttons.
	         * @param {Array} phoneNumbers - list of redux-form fields for phone numbers
	         * @returns
	         */
	    }, {
	        key: 'preparePhoneNumbersForForm',
	        value: function preparePhoneNumbersForForm(phoneNumbers) {
	            var phoneNumbersPrepared = phoneNumbers.map(function (onePhoneNumber, key) {
	                delete onePhoneNumber['default'].value;
	                delete onePhoneNumber.mobile.value;
	                return onePhoneNumber;
	            });
	
	            return phoneNumbersPrepared;
	        }
	
	        /**
	         * This function enable to render the list of phone numbers
	         * @param {*} phoneNumbers
	         * @returns
	         */
	    }, {
	        key: 'shouldRenderTheListOfPhoneNumbers',
	        value: function shouldRenderTheListOfPhoneNumbers(phoneNumbers) {
	            var isNotEmptyTheList = !_underscore2['default'].isEmpty(phoneNumbers);
	            var isArrayTheList = _underscore2['default'].isArray(phoneNumbers);
	            var noOracleErrorForTheList = phoneNumbers[0] !== 'Too many rows';
	
	            return isNotEmptyTheList && isArrayTheList && noOracleErrorForTheList;
	        }
	
	        /**
	         * Main render of the component.
	         * @returns
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props;
	            var data = _props.data;
	            var formStatus = _props.formStatus;
	            var _state = this.state;
	            var informModalOpen = _state.informModalOpen;
	            var modalIsOpen = _state.modalIsOpen;
	
	            var isSetDefaultValue = this.areDefaultValueSetForPhoneNumbers(data);
	            var phoneNumbers = this.preparePhoneNumbersForForm(data);
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].moduleSection },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientsTableContainer },
	                    this.shouldRenderTheListOfPhoneNumbers(phoneNumbers) && _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            className: _listSelectScss2['default'].table,
	                            itemsPerPage: 50,
	                            topPagination: '',
	                            filterable: [],
	                            sortable: ["number.value", "mobile.value"],
	                            defaultSort: {
	                                column: 'number.value',
	                                direction: 'asc'
	                            }
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'number.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('phone')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'mobile.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('mobile')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'default.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('default')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'checkEmail' },
	                                _react2['default'].createElement('strong', null)
	                            )
	                        ),
	                        phoneNumbers.map(function (onePhoneNumber, index) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { className: 'centered', key: onePhoneNumber.uniqueId.value },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'number.value' },
	                                    onePhoneNumber.number.value
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'mobile.value' },
	                                    _react2['default'].createElement('input', _extends({
	                                        type: 'checkbox'
	                                    }, onePhoneNumber.mobile))
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'default.value' },
	                                    _react2['default'].createElement('input', {
	                                        type: 'radio',
	                                        value: onePhoneNumber['default'].value,
	                                        checked: onePhoneNumber['default'].checked,
	                                        name: "phoneNumbers",
	                                        onBlur: function (e) {
	                                            return false;
	                                        },
	                                        onChange: function (value) {
	                                            return _this3.setCheckedAndClearOthers(onePhoneNumber.uniqueId, phoneNumbers);
	                                        }
	                                    })
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'checkEmail' },
	                                    _react2['default'].createElement(
	                                        'button',
	                                        {
	                                            type: 'button',
	                                            className: _listSelectScss2['default'].removeFieldsButton,
	                                            onClick: function (event) {
	                                                event.preventDefault();
	
	                                                // prevent to delete the default phone number
	                                                if (isSetDefaultValue && onePhoneNumber['default'].checked || !isSetDefaultValue) {
	                                                    return _this3.setState({ informModalOpen: true });
	                                                }
	
	                                                _this3.removeItemFromList(onePhoneNumber.uniqueId.value);
	                                            }
	                                        },
	                                        _react2['default'].createElement('img', { src: _this3.getIcon() })
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    formStatus != undefined && formStatus.phoneDefault == true && _react2['default'].createElement(
	                        'div',
	                        { className: _listSelectScss2['default'].error },
	                        ' ',
	                        _('requiredDefaultPhone'),
	                        ' '
	                    ),
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'button',
	                            className: _listSelectScss2['default'].addFieldButton,
	                            onClick: function () {
	                                _this3.handleAddFieldButton();
	                            } },
	                        '+'
	                    )
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        style: customStyles,
	                        contentLabel: 'Modal'
	                    },
	                    this.modalContentPopup()
	                ),
	                _react2['default'].createElement(_generalComponentsInfoModal2['default'], {
	                    isOpen: Boolean(informModalOpen),
	                    title: _("infoModalPhoneNumberCanNotDeleteTitle"),
	                    content: _("infoModalPhoneNumberCanNotDeleteDescription"),
	                    onCancel: function () {},
	                    onConfirmation: function () {
	                        return _this3.setState({ informModalOpen: false });
	                    },
	                    cancelLabel: _("cancel"),
	                    confirmationLabel: _("ok"),
	                    options: { noCancelButton: true }
	                })
	            );
	        }
	    }]);
	
	    return PhoneListSelect;
	})(_react2['default'].Component);
	
	exports['default'] = PhoneListSelect;
	module.exports = exports['default'];

	// walk trough all of the phoneNumber fields

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _authAuthScss = __webpack_require__(135);
	
	var _authAuthScss2 = _interopRequireDefault(_authAuthScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _reactStringReplace = __webpack_require__(496);
	
	var _reactStringReplace2 = _interopRequireDefault(_reactStringReplace);
	
	var _elementsGrail = __webpack_require__(220);
	
	var _elementsGrail2 = _interopRequireDefault(_elementsGrail);
	
	var _ = (0, _libI18n2['default'])('privacy');
	
	var Privacy = (function (_React$Component) {
	    _inherits(Privacy, _React$Component);
	
	    function Privacy() {
	        _classCallCheck(this, _Privacy);
	
	        _get(Object.getPrototypeOf(_Privacy.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Privacy, [{
	        key: 'onClickBack',
	        value: function onClickBack(e) {
	            var dispatch = this.props.dispatch;
	
	            // dispatch(changeAuthState(""))
	            // to be sure be dropped to the start page
	            dispatch((0, _stateActions.setAppModule)(_stateConstants2['default'].LOGIN));
	            return;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var isPhone = this.props.isPhone;
	
	            var regExForClientRecipientPrivacy = /(https?:\/\/\S+)/g;
	            var replacementFunction = function replacementFunction(match, i, offset) {
	                return _react2['default'].createElement(
	                    'a',
	                    { href: match, key: match + i },
	                    match
	                );
	            };
	            var descriptionNL = (0, _reactStringReplace2['default'])(_("privacyLinksInNl"), regExForClientRecipientPrivacy, replacementFunction);
	            var descriptionFR = (0, _reactStringReplace2['default'])(_("privacyLinksInFr"), regExForClientRecipientPrivacy, replacementFunction);
	
	            return _react2['default'].createElement(_elementsGrail2['default'], {
	                noScroll: true,
	                content: _react2['default'].createElement(
	                    'div',
	                    { className: _authAuthScss2['default'].authFormsOverlay + ' ' + (isPhone ? _authAuthScss2['default'].mobile : '') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _authAuthScss2['default'].authWrappNew },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _authAuthScss2['default'].authFormsContainerBig },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _authAuthScss2['default'].form },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _authAuthScss2['default'].formGroup },
	                                    _react2['default'].createElement(
	                                        'h2',
	                                        null,
	                                        _("titleOfPrivacy")
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _authAuthScss2['default'].privacyContainer },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: _authAuthScss2['default'].info },
	                                        descriptionNL,
	                                        _react2['default'].createElement('br', null),
	                                        descriptionFR
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: _authAuthScss2['default'].formGroup },
	                                    _react2['default'].createElement(
	                                        'a',
	                                        { className: _authAuthScss2['default'].backLink, onClick: function (e) {
	                                                return _this.onClickBack(e);
	                                            } },
	                                        _('back')
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            });
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react2['default'].PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    var _Privacy = Privacy;
	    Privacy = (0, _reactRedux.connect)(function (state) {
	        return {
	            authState: state.auth.authState,
	            isPhone: state.responsive.isPhone
	        };
	    })(Privacy) || Privacy;
	    return Privacy;
	})(_react2['default'].Component);
	
	exports['default'] = Privacy;
	module.exports = exports['default'];

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(4);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _stateActions = __webpack_require__(5);
	
	var _listSelectScss = __webpack_require__(245);
	
	var _listSelectScss2 = _interopRequireDefault(_listSelectScss);
	
	var _input = __webpack_require__(109);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libHelpers = __webpack_require__(24);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _uuidV1 = __webpack_require__(2323);
	
	var _uuidV12 = _interopRequireDefault(_uuidV1);
	
	var _ = (0, _libI18n2['default'])('clients');
	
	var genderHashMap = {
	    "M": "1",
	    "F": "2",
	    "V": "2"
	};
	
	var defaultRelationData = {
	    clientNumber: "",
	    clientFirstName: "",
	    clientLastName: "",
	    clientGender: "",
	    clientBirthDate: "",
	    clientRelationType: ""
	};
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        zIndex: 2
	    },
	    content: {
	        position: 'relative',
	        top: 'initial',
	        bottom: 'initial',
	        left: 'initial',
	        right: 'initial',
	        minHeight: '550px',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '1em'
	    }
	};
	
	var RelationListSelect = (function (_React$Component) {
	    _inherits(RelationListSelect, _React$Component);
	
	    _createClass(RelationListSelect, null, [{
	        key: 'propTypes',
	        value: {
	            data: _react2['default'].PropTypes.array,
	            genderOptions: _react2['default'].PropTypes.array,
	            relationOptions: _react2['default'].PropTypes.array
	        },
	        enumerable: true
	    }]);
	
	    function RelationListSelect(props) {
	        var _this = this;
	
	        _classCallCheck(this, RelationListSelect);
	
	        _get(Object.getPrototypeOf(RelationListSelect.prototype), 'constructor', this).call(this, props);
	
	        this.changeClientNumberValue = function (ev) {
	            var dispatch = _this.props.dispatch;
	            var relationData = _this.state.relationData;
	
	            relationData['clientNumber'] = ev.target.value;
	
	            _this.setState({ relationData: relationData });
	        };
	
	        this.changeLastNameValue = function (ev) {
	            var relationData = _this.state.relationData;
	
	            relationData['clientLastName'] = ev.target.value;
	
	            _this.setState({ relationData: relationData });
	        };
	
	        this.changeFirstNameValue = function (ev) {
	            var relationData = _this.state.relationData;
	
	            relationData['clientFirstName'] = ev.target.value;
	
	            _this.setState({ relationData: relationData });
	        };
	
	        this.changeRelationTypeValue = function (ev) {
	            var relationData = _this.state.relationData;
	
	            relationData['clientRelationType'] = ev.value;
	
	            _this.setState({ relationData: relationData });
	        };
	
	        this.changeGenderValue = function (ev) {
	            var relationData = _this.state.relationData;
	
	            relationData['clientGender'] = ev.value;
	
	            _this.setState({ relationData: relationData });
	        };
	
	        this.changeBirthDateValue = function (ev) {
	            var relationData = _this.state.relationData;
	
	            relationData['clientBirthDate'] = ev;
	
	            _this.setState({ relationData: relationData });
	        };
	
	        this.checkFormMethod = function (relationKey, formType) {
	            var data = _this.props.data;
	
	            // Get the requested data based on form type
	            if (formType == 'update') {
	                data = data[relationKey];
	
	                _this.setState({ relationData: {
	                        clientNumber: data.contactNumber.value,
	                        clientFirstName: data.contactFirstName.value,
	                        clientLastName: data.contactLastName.value,
	                        clientGender: data.contactgender.value,
	                        clientBirthDate: data.contactdateOfBirth.value,
	                        clientRelationType: data.contactType.value
	                    } });
	            }
	        };
	
	        this.validateForm = function () {
	            var _props = _this.props;
	            var data = _props.data;
	            var dispatch = _props.dispatch;
	            var _state = _this.state;
	            var relationKey = _state.relationKey;
	            var formType = _state.formType;
	
	            var formStatus = true;
	
	            var relationErrors = _this.state.relationErrors;
	            var _state$relationData = _this.state.relationData;
	            var clientNumber = _state$relationData.clientNumber;
	            var clientFirstName = _state$relationData.clientFirstName;
	            var clientLastName = _state$relationData.clientLastName;
	            var clientGender = _state$relationData.clientGender;
	            var clientBirthDate = _state$relationData.clientBirthDate;
	            var clientRelationType = _state$relationData.clientRelationType;
	
	            relationErrors = _extends({}, defaultRelationData);
	
	            if (clientLastName == "") {
	                relationErrors["clientLastName"] = _('requiredField');
	
	                formStatus = false;
	            } else if (clientLastName.length > 50) {
	                relationErrors["clientLastName"] = _('maxLength50');
	
	                formStatus = false;
	            }
	
	            if (clientFirstName.length > 50) {
	                relationErrors["clientFirstName"] = _('maxLength50');
	
	                formStatus = false;
	            }
	
	            if (clientRelationType == "") {
	                relationErrors["clientRelationType"] = _('requiredField');
	
	                formStatus = false;
	            }
	
	            _this.setState({ relationErrors: _extends({}, relationErrors), formStatus: formStatus });
	
	            if (formStatus == true) {
	                _this.saveRelationData();
	            }
	        };
	
	        this.saveRelationData = function () {
	            var _props2 = _this.props;
	            var data = _props2.data;
	            var dispatch = _props2.dispatch;
	            var _state2 = _this.state;
	            var relationKey = _state2.relationKey;
	            var formType = _state2.formType;
	            var relationErrors = _this.state.relationErrors;
	            var _state$relationData2 = _this.state.relationData;
	            var clientNumber = _state$relationData2.clientNumber;
	            var clientFirstName = _state$relationData2.clientFirstName;
	            var clientLastName = _state$relationData2.clientLastName;
	            var clientGender = _state$relationData2.clientGender;
	            var clientBirthDate = _state$relationData2.clientBirthDate;
	            var clientRelationType = _state$relationData2.clientRelationType;
	
	            if (formType == 'update') {
	                data = data[relationKey];
	
	                dispatch({
	                    type: "redux-form/CHANGE",
	                    field: data.contactNumber.name,
	                    value: clientNumber,
	                    touch: true,
	                    form: "clientProfileEdit"
	                });
	
	                dispatch({
	                    type: "redux-form/CHANGE",
	                    field: data.contactFirstName.name,
	                    value: clientFirstName,
	                    touch: true,
	                    form: "clientProfileEdit"
	                });
	
	                dispatch({
	                    type: "redux-form/CHANGE",
	                    field: data.contactLastName.name,
	                    value: clientLastName,
	                    touch: true,
	                    form: "clientProfileEdit"
	                });
	
	                dispatch({
	                    type: "redux-form/CHANGE",
	                    field: data.contactType.name,
	                    value: clientRelationType,
	                    touch: true,
	                    form: "clientProfileEdit"
	                });
	
	                dispatch({
	                    type: "redux-form/CHANGE",
	                    field: data.contactgender.name,
	                    value: clientGender,
	                    touch: true,
	                    form: "clientProfileEdit"
	                });
	
	                dispatch({
	                    type: "redux-form/CHANGE",
	                    field: data.contactdateOfBirth.name,
	                    value: clientBirthDate,
	                    touch: true,
	                    form: "clientProfileEdit"
	                });
	            } else {
	                data.addField({
	                    contactNumber: clientNumber,
	                    contactName: clientFirstName + " " + clientLastName,
	                    contactFirstName: clientFirstName,
	                    contactLastName: clientLastName,
	                    contactType: clientRelationType,
	                    contactdateOfBirth: clientBirthDate,
	                    contactgender: clientGender,
	                    uniqueId: (0, _uuidV42['default'])()
	                });
	            }
	
	            _this.setState({
	                relationData: _extends({}, defaultRelationData),
	                formType: "create",
	                relationErrors: _extends({}, defaultRelationData),
	                relationKey: ""
	            });
	            _this.openModal();
	        };
	
	        this.autocompleteRelationData = function () {
	            var _props3 = _this.props;
	            var officeClients = _props3.officeClients;
	            var dispatch = _props3.dispatch;
	            var _state$relationData3 = _this.state.relationData;
	            var clientNumber = _state$relationData3.clientNumber;
	            var clientFirstName = _state$relationData3.clientFirstName;
	            var clientLastName = _state$relationData3.clientLastName;
	            var clientGender = _state$relationData3.clientGender;
	            var clientBirthDate = _state$relationData3.clientBirthDate;
	            var clientRelationType = _state$relationData3.clientRelationType;
	
	            if (clientNumber.length > 3) {
	                _this.setState({ disabledInputs: true });
	                dispatch((0, _stateActions.clientProfileFormGetRelations)({ clientNumber: clientNumber })).then(function (response) {
	                    Object.keys(response).map(function (relationIndex) {
	                        if (response[relationIndex].clientNumber == clientNumber) {
	                            var gender = null;
	
	                            gender = _underscore2['default'].has(genderHashMap, response[relationIndex].gender) ? genderHashMap[response[relationIndex].gender] : "";
	
	                            _this.setState({ relationData: {
	                                    clientNumber: response[relationIndex].clientNumber,
	                                    clientFirstName: response[relationIndex].firstName,
	                                    clientLastName: response[relationIndex].lastName,
	                                    clientRelationType: "",
	                                    clientBirthDate: response[relationIndex].dateOfBirth,
	                                    clientGender: gender
	                                } });
	                        }
	                    });
	
	                    _this.setState({ disabledInputs: false });
	                });
	            }
	        };
	
	        this.state = {
	            modalIsOpen: false,
	            relationData: {
	                clientNumber: "",
	                clientFirstName: "",
	                clientLastName: "",
	                clientGender: "",
	                clientBirthDate: "",
	                clientRelationType: ""
	            },
	            relationKey: "",
	            formType: "create",
	            relationErrors: defaultRelationData,
	            disabledInputs: false
	        };
	    }
	
	    _createClass(RelationListSelect, [{
	        key: 'getIcon',
	        value: function getIcon() {
	            try {
	                return __webpack_require__(79);
	            } catch (err) {
	                return __webpack_require__(23);
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this.setState({ modalIsOpen: !this.state.modalIsOpen });
	        }
	    }, {
	        key: 'removeItemFromList',
	        value: function removeItemFromList(itemUniqueId) {
	            var data = this.props.data;
	
	            Object.keys(data).map(function (dataKey) {
	                if (data[dataKey] && data[dataKey] !== undefined && data[dataKey].uniqueId.value === itemUniqueId) {
	                    data.removeField(dataKey);
	                }
	            });
	        }
	    }, {
	        key: 'modalContentPopup',
	        value: function modalContentPopup() {
	            var _this2 = this;
	
	            // Get the requested data from props and state
	            var data = this.props.data;
	            var _state3 = this.state;
	            var relationKey = _state3.relationKey;
	            var formType = _state3.formType;
	            var relationErrors = _state3.relationErrors;
	            var disabledInputs = _state3.disabledInputs;
	            var _state$relationData4 = this.state.relationData;
	            var clientNumber = _state$relationData4.clientNumber;
	            var clientFirstName = _state$relationData4.clientFirstName;
	            var clientLastName = _state$relationData4.clientLastName;
	            var clientGender = _state$relationData4.clientGender;
	            var clientBirthDate = _state$relationData4.clientBirthDate;
	            var clientRelationType = _state$relationData4.clientRelationType;
	
	            var errorData = false;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].clientModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _listSelectScss2['default'].title },
	                    _("addRelation")
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('clientNumber')
	                ),
	                _react2['default'].createElement('input', {
	                    type: 'text',
	                    onChange: function (ev) {
	                        return _this2.changeClientNumberValue(ev);
	                    },
	                    onBlur: function (ev) {
	                        return _this2.autocompleteRelationData(ev);
	                    },
	                    value: clientNumber,
	                    disabled: disabledInputs
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    ' ',
	                    relationErrors && relationErrors["clientNumber"] != "" && relationErrors['clientNumber'],
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('lastName'),
	                    ' *'
	                ),
	                _react2['default'].createElement('input', {
	                    type: 'text',
	                    onChange: function (ev) {
	                        return _this2.changeLastNameValue(ev);
	                    },
	                    value: clientLastName,
	                    disabled: disabledInputs
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    ' ',
	                    relationErrors && relationErrors["clientLastName"] != "" && relationErrors['clientLastName'],
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('firstName'),
	                    ' '
	                ),
	                _react2['default'].createElement('input', {
	                    type: 'text',
	                    onChange: function (ev) {
	                        return _this2.changeFirstNameValue(ev);
	                    },
	                    value: clientFirstName,
	                    disabled: disabledInputs
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    ' ',
	                    relationErrors && relationErrors["clientFirstName"] != "" && relationErrors['clientFirstName'],
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('type'),
	                    ' *'
	                ),
	                _react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, {
	                    options: this.props.relationOptions,
	                    isSearchable: true,
	                    value: clientRelationType,
	                    onChange: function (ev) {
	                        return _this2.changeRelationTypeValue(ev);
	                    },
	                    isDisabled: disabledInputs
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].error },
	                    ' ',
	                    relationErrors && relationErrors["clientRelationType"] != "" && relationErrors['clientRelationType'],
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    _('gender'),
	                    ' '
	                ),
	                _react2['default'].createElement(_componentsSharedSelectSelectWrap.SearchableSelectWrapper, {
	                    options: this.props.genderOptions,
	                    isSearchable: true,
	                    value: clientGender,
	                    onChange: function (ev) {
	                        return _this2.changeGenderValue(ev);
	                    },
	                    isDisabled: disabledInputs
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].datepickerLabelField },
	                    _react2['default'].createElement(
	                        'label',
	                        null,
	                        _('dateOfBirth'),
	                        ' '
	                    ),
	                    _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, {
	                        value: clientBirthDate,
	                        onChange: function (ev) {
	                            return _this2.changeBirthDateValue(ev);
	                        },
	                        disabled: disabledInputs
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientModalButtons },
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this2.setState({
	                                relationData: _extends({}, defaultRelationData),
	                                formType: "create",
	                                relationErrors: _extends({}, defaultRelationData),
	                                relationKey: ""
	                            });
	                            _this2.openModal();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].cancel,
	                        value: _("cancel")
	                    }),
	                    _react2['default'].createElement('input', {
	                        onClick: function () {
	                            _this2.validateForm();
	                        },
	                        type: 'button',
	                        className: _listSelectScss2['default'].next + " " + (!errorData && _listSelectScss2['default'].enabled),
	                        value: _("clientAdd"),
	                        disabled: errorData
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'printSelect',
	        value: function printSelect(item, options) {
	            var itemValue = "";
	
	            if (item.value == undefined) {
	                return "";
	            }
	
	            options.map(function (key, i) {
	                if (Number(item.value) == Number(key.value)) {
	                    itemValue = key.label;
	                }
	            });
	
	            return itemValue;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props4 = this.props;
	            var data = _props4.data;
	            var genderOptions = _props4.genderOptions;
	            var relationOptions = _props4.relationOptions;
	            var modalIsOpen = this.state.modalIsOpen;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _listSelectScss2['default'].moduleSection },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _listSelectScss2['default'].clientsTableContainer },
	                    !_underscore2['default'].isEmpty(data) && _underscore2['default'].isArray(data) && data[0] !== 'Too many rows' && _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            className: _listSelectScss2['default'].table,
	                            itemsPerPage: 50,
	                            topPagination: '',
	                            filterable: [],
	                            sortable: ["contactType.value", "contactLastName.value", "contactFirstName.value", "contactdateOfBirth.value", "contactgender.value", "contactNumber.value"],
	                            defaultSort: {
	                                column: 'contactName.value',
	                                direction: 'asc'
	                            }
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'contactType.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('type')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'contactLastName.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('lastName')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'contactFirstName.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('firstName')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'contactgender.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('gender')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'contactdateOfBirth.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('birthday')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'contactNumber.value' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('clientNumber')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: '' },
	                                _react2['default'].createElement('strong', null)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'checkEmail' },
	                                _react2['default'].createElement('strong', null)
	                            )
	                        ),
	                        data.map(function (item, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { className: 'centered', key: item.uniqueId.value, id: item.uniqueId.value },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'contactType.value' },
	                                    _this3.printSelect(item.contactType, relationOptions)
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'contactLastName.value' },
	                                    item.contactLastName.value
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'contactFirstName.value' },
	                                    item.contactFirstName.value
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'contactgender.value' },
	                                    _this3.printSelect(item.contactgender, genderOptions)
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'contactdateOfBirth.value' },
	                                    (0, _libHelpers.dateFormatter)(item.contactdateOfBirth.value)
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'contactNumber.value' },
	                                    item.contactNumber.value
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: '' },
	                                    _react2['default'].createElement(
	                                        'button',
	                                        { type: 'button',
	                                            className: _listSelectScss2['default'].editFieldButton,
	                                            onClick: function () {
	                                                _this3.setState({ relationKey: key, formType: "update" });
	                                                _this3.checkFormMethod(key, "update");
	                                                _this3.openModal();
	                                            } },
	                                        _react2['default'].createElement('img', { src: __webpack_require__(355) })
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'checkEmail' },
	                                    _react2['default'].createElement(
	                                        'button',
	                                        { type: 'button', className: _listSelectScss2['default'].removeFieldsButton, onClick: function (event) {
	                                                event.preventDefault();
	                                                _this3.removeItemFromList(item.uniqueId.value);
	                                            } },
	                                        _react2['default'].createElement('img', { src: _this3.getIcon() })
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'button',
	                            className: _listSelectScss2['default'].addFieldButton,
	                            onClick: function () {
	                                _this3.openModal();
	                            } },
	                        '+'
	                    )
	                ),
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen,
	                        style: customStyles,
	                        contentLabel: 'Modal'
	                    },
	                    this.modalContentPopup()
	                )
	            );
	        }
	    }]);
	
	    return RelationListSelect;
	})(_react2['default'].Component);
	
	exports['default'] = RelationListSelect;
	module.exports = exports['default'];

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable import/no-extraneous-dependencies */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodashLang = __webpack_require__(78);
	
	var _reactDatepicker = __webpack_require__(1966);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	__webpack_require__(1576);
	
	var _ = (0, _libI18n2['default'])();
	var date = function date(d) {
		return d ? (0, _moment2['default'])(d) : undefined;
	};
	var isValidString = function isValidString(s) {
		return (0, _lodashLang.isString)(s) && s.trim().length > 0;
	};
	
	var DatePicker = (function (_Component) {
		_inherits(DatePicker, _Component);
	
		function DatePicker() {
			_classCallCheck(this, _DatePicker);
	
			_get(Object.getPrototypeOf(_DatePicker.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(DatePicker, [{
			key: 'onChange',
			value: function onChange(date) {
				var onChange = this.props.onChange;
	
				if (this.child && typeof this.child.hideCalendar === 'function') {
					this.child.hideCalendar(); // hide the calendar after selecting a date
				}
				onChange(date ? date.format('YYYY-MM-DD') : '');
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var value = _props.value;
				var locale = _props.locale;
				var onBlur = _props.onBlur;
				var onChange = _props.onChange;
				var onFocus = _props.onFocus;
				var startDate = _props.startDate;
				var endDate = _props.endDate;
				var minDate = _props.minDate;
				var maxDate = _props.maxDate;
				var setNotification = _props.setNotification;
				var disabled = _props.disabled;
	
				var restProps = _objectWithoutProperties(_props, ['value', 'locale', 'onBlur', 'onChange', 'onFocus', 'startDate', 'endDate', 'minDate', 'maxDate', 'setNotification', 'disabled']);
	
				// eslint-disable-line no-unused-vars
	
				return _react2['default'].createElement(_reactDatepicker2['default'], _extends({ moment: _moment2['default'], locale: locale }, {
					dateError: function () {
						var errorMessage = "dateFormatError";
						if (_this.child.state.dateErrorMessage && _this.child.state.dateErrorMessage.length > 0) {
							errorMessage = _this.child.state.dateErrorMessage;
						}
						setNotification(_(errorMessage), 'error');
					},
					startDate: date(startDate),
					endDate: date(endDate),
					minDate: isValidString(minDate) ? (0, _moment2['default'])(minDate) : (0, _moment2['default'])().subtract(100, 'years'),
					maxDate: isValidString(maxDate) ? (0, _moment2['default'])(maxDate) : (0, _moment2['default'])().add(100, 'years'),
					isTypeable: true,
					isClearable: !disabled,
					disabled: disabled,
					dateFormat: 'DD-MM-YYYY',
					placeholderText: _('datePicker'),
					selected: date(value),
					showYearDropdown: true,
					dateFormatCalendar: 'MMMM',
					onChange: this.onChange.bind(this)
				}, restProps, {
					ref: function (instance) {
						_this.child = instance;
					}
				}));
			}
		}]);
	
		var _DatePicker = DatePicker;
		DatePicker = (0, _reactRedux.connect)(function (state) {
			return { locale: state.app.lang };
		}, { setNotification: _stateActions.setNotification })(DatePicker) || DatePicker;
		return DatePicker;
	})(_react.Component);
	
	exports.DatePicker = DatePicker;
	
	DatePicker.propTypes = {
		value: _react.PropTypes.any,
		onBlur: _react.PropTypes.func,
		onChange: _react.PropTypes.func,
		disabled: _react.PropTypes.bool,
		locale: _react.PropTypes.string,
		onFocus: _react.PropTypes.func,
		startDate: _react.PropTypes.string,
		endDate: _react.PropTypes.string,
		minDate: _react.PropTypes.string,
		maxDate: _react.PropTypes.string,
		setNotification: _react.PropTypes.func
	};

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FormFieldScss = __webpack_require__(1624);
	
	var _FormFieldScss2 = _interopRequireDefault(_FormFieldScss);
	
	var FormField = function FormField(_ref) {
	    var label = _ref.label;
	    var field = _ref.field;
	    var children = _ref.children;
	    var className = _ref.className;
	
	    var showErrorMessage = field && field.touched && field.error;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(_FormFieldScss2['default']['form-field'], className) },
	        label && _react2['default'].createElement(
	            'label',
	            { className: 'label', htmlFor: label },
	            label
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'field' },
	            children,
	            showErrorMessage && _react2['default'].createElement(
	                'p',
	                { className: (0, _classnames2['default'])("error", _FormFieldScss2['default'].errorMessage) },
	                field.error
	            )
	        )
	    );
	};
	exports.FormField = FormField;
	FormField.propTypes = {
	    label: _react.PropTypes.string,
	    field: _react.PropTypes.object,
	    children: _react.PropTypes.node.isRequired,
	    className: _react.PropTypes.string
	};

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _FormField = __webpack_require__(1143);
	
	Object.defineProperty(exports, 'FormField', {
	  enumerable: true,
	  get: function get() {
	    return _FormField.FormField;
	  }
	});

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _taskCreatorFormScss = __webpack_require__(1627);
	
	var _taskCreatorFormScss2 = _interopRequireDefault(_taskCreatorFormScss);
	
	// import tinyMCE. The 5.3 or above also requires importing a theme and a set of icons
	
	var _tinymceTinymce = __webpack_require__(526);
	
	var _tinymceTinymce2 = _interopRequireDefault(_tinymceTinymce);
	
	__webpack_require__(513);
	
	__webpack_require__(525);
	
	// For tinyMCE 5.3 or above, the plugins are now imported here instead of being specified
	// as external scripts
	
	__webpack_require__(523);
	
	__webpack_require__(518);
	
	__webpack_require__(517);
	
	__webpack_require__(515);
	
	__webpack_require__(521);
	
	__webpack_require__(519);
	
	__webpack_require__(524);
	
	__webpack_require__(514);
	
	__webpack_require__(522);
	
	__webpack_require__(516);
	
	__webpack_require__(520);
	
	var _ = (0, _libI18n2["default"])("taskCreator");
	
	/**
	 * TaskCreatorForm component
	 *
	 * implements the form to convert entities to task items
	 ****************************************************************************************/
	
	var TaskCreatorForm = (function (_Component) {
	    _inherits(TaskCreatorForm, _Component);
	
	    _createClass(TaskCreatorForm, null, [{
	        key: "propTypes",
	        value: {
	            modalTitle: _react.PropTypes.string.isRequired,
	            taskItems: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            staffItems: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            convertionType: _react.PropTypes.string.isRequired,
	            taskCreatorModalToggle: _react.PropTypes.func.isRequired,
	            taskCreatorGenerateWithRelations: _react.PropTypes.func.isRequired
	        },
	
	        /**
	         * Setup the default state of the component
	         */
	        enumerable: true
	    }]);
	
	    function TaskCreatorForm(props) {
	        var _this = this;
	
	        _classCallCheck(this, TaskCreatorForm);
	
	        _get(Object.getPrototypeOf(TaskCreatorForm.prototype), "constructor", this).call(this, props);
	
	        this.generateDataWithoutReference = function (items) {
	            var newArray = [];
	
	            items.map(function (itemValue, itemKey) {
	                newArray[itemKey] = JSON.parse(JSON.stringify(itemValue));
	            });
	
	            return newArray;
	        };
	
	        this.bindTinyMceEditor = function (taskItemKey) {
	            var editors = _this.state.editors;
	            var elementSelector = "#tinymce-editor-" + taskItemKey;
	
	            window.tinymce.init({
	                selector: elementSelector,
	                min_height: 365,
	                menubar: false,
	                mode: "design",
	                statusbar: false,
	
	                // [Jancsi] - these are not required anymore for version 5.3+ of tinyMCE, it is enough to specify the teme
	                //theme_url: window.location.protocol+'//'+(window.location.href.split("/")[2] + '/themes/modern/theme.js').replace("\/\/", "\/"),
	                //skin_url:  window.location.protocol+'//'+(window.location.href.split("/")[2] + '/skins/lightgray/').replace("\/\/", "\/"),
	                theme: "silver",
	
	                toolbar1: "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | formatselect fontselect fontsizeselect",
	                toolbar2: "paste pastetext searchreplace | bullist numlist | outdent indent | undo redo | link unlink anchor image code",
	                toolbar3: "forecolor backcolor | table | hr removeformat visualchars | subscript superscript | charmap preview | fullscreen",
	                // [Jancsi] these are not required anymore for version 5.3+ of tinyMCE, as plugins are imported at the beginning of the file
	                // external_plugins: {
	                //     'textcolor': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/textcolor/plugin.js').replace("\/\/", "\/"),
	                //     'link': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/link/plugin.js').replace("\/\/", "\/"),
	                //     //'image': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/image/plugin.js').replace("\/\/", "\/"),
	                //     'code': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/code/plugin.js').replace("\/\/", "\/"),
	                //     'searchreplace': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/searchreplace/plugin.js').replace("\/\/", "\/"),
	                //     'paste': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/paste/plugin.js').replace("\/\/", "\/"),
	                //     'visualchars': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/visualchars/plugin.js').replace("\/\/", "\/"),
	                //     'charmap': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/charmap/plugin.js').replace("\/\/", "\/"),
	                //     'table': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/table/plugin.js').replace("\/\/", "\/"),
	                //     'fullscreen': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/fullscreen/plugin.js').replace("\/\/", "\/"),
	                //     'preview': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/preview/plugin.js').replace("\/\/", "\/"),
	                // },
	                plugins: ["textcolor link code searchreplace paste visualchars charmap table fullscreen preview"],
	                force_br_newlines: false,
	                force_p_newlines: false,
	                forced_root_block: "",
	                relative_urls: false,
	                remove_script_host: false,
	                convert_urls: true,
	                setup: function setup(editorInstance) {
	                    editors[elementSelector] = editorInstance;
	                    editorInstance.on('init', function (e) {
	                        _this.initializeBodyEditor(editorInstance, taskItemKey);
	                    });
	
	                    _this.setState({ editors: editors });
	                }
	            });
	        };
	
	        this.unbindTinyMceEditors = function () {
	            var editors = _this.state.editors;
	
	            if (editors && Object.keys(editors).length === 0) {
	                return;
	            }
	
	            Object.keys(editors).map(function (editorId) {
	                editorId = editorId.substr(1);
	
	                window.tinymce.execCommand("mceFocus", true, editorId);
	                window.tinymce.execCommand("mceRemoveEditor", true, editorId);
	                window.tinymce.execCommand("mceRemoveControl", false, editorId);
	            });
	        };
	
	        this.initializeBodyEditor = function (editorInstance, taskItemKey) {
	            var taskItems = _this.state.taskItems;
	
	            var taskItem = taskItems[taskItemKey];
	
	            if (window.tinymce && editorInstance) {
	
	                try {
	                    editorInstance.setContent(taskItem.description, { format: 'raw' });
	                } catch (exc) {
	                    console.log(exc);
	                }
	
	                editorInstance.on('blur', function (e) {
	                    _this.taskItemDescriptionChangeHandler(taskItemKey, editorInstance.getContent());
	                });
	
	                editorInstance.on('click', function (e) {
	                    _this.taskItemDescriptionChangeHandler(taskItemKey, editorInstance.getContent());
	                });
	            }
	        };
	
	        this.taskItemTitleChangeHandler = function (itemKey, event) {
	            var taskItems = _this.state.taskItems;
	
	            if (taskItems[itemKey]) {
	                taskItems[itemKey].title = event.target.value;
	            }
	
	            _this.setState({ taskItems: taskItems });
	        };
	
	        this.taskItemDescriptionChangeHandler = function (itemKey, value) {
	            var taskItems = _this.state.taskItems;
	
	            if (taskItems[itemKey]) {
	                taskItems[itemKey].description = value;
	            }
	
	            _this.setState({ taskItems: taskItems });
	        };
	
	        this.taskItemDateChangeHandler = function (itemKey, event) {
	            var taskItems = _this.state.taskItems;
	
	            if (taskItems[itemKey]) {
	                taskItems[itemKey].endDate = event;
	            }
	
	            _this.setState({ taskItems: taskItems });
	        };
	
	        this.staffItemSelectionHandler = function (staffId) {
	            var staffItems = _this.state.staffItems;
	            var selection = [];
	
	            staffItems.map(function (value, key) {
	                selection[key] = _extends({}, value);
	
	                if (value.userId == staffId) {
	                    selection[key].selected = !value.selected;
	                }
	            });
	
	            _this.setState({ staffItems: selection });
	        };
	
	        this.handleModalSubmitEvent = function () {
	            var taskCreatorGenerateWithRelations = _this.props.taskCreatorGenerateWithRelations;
	            var _state = _this.state;
	            var taskItems = _state.taskItems;
	            var staffItems = _state.staffItems;
	            var isArchiveConfirmation = _state.isArchiveConfirmation;
	            var convertionType = _state.convertionType;
	
	            taskCreatorGenerateWithRelations({
	                items: taskItems,
	                users: staffItems,
	                isArchiveConfirmation: isArchiveConfirmation,
	                convertionType: convertionType
	            });
	        };
	
	        this.state = {
	            isArchiveConfirmation: false,
	            editors: {},
	
	            taskItems: [],
	            staffItems: [],
	            convertionType: null
	        };
	    }
	
	    /**
	     * Generate a new array of data object without reference to the array of objects
	     * @param {array} items the array of objects
	     * @return {array} the new array object without reference
	     */
	
	    _createClass(TaskCreatorForm, [{
	        key: "componentWillMount",
	
	        /**
	         * On `componentWillMount` event updates the default state with the props received
	         */
	        value: function componentWillMount() {
	            var _props = this.props;
	            var taskItems = _props.taskItems;
	            var staffItems = _props.staffItems;
	            var convertionType = _props.convertionType;
	
	            this.setState({
	                taskItems: this.generateDataWithoutReference(taskItems),
	                staffItems: this.generateDataWithoutReference(staffItems),
	                convertionType: convertionType
	            });
	        }
	
	        /**
	         * On `componentDidMount` event binds the tinyMCE editor to each `textarea` element in the form
	         * @see bindTinyMceEditor() the method that bind's the editor to textarea element
	         */
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var taskItems = this.state.taskItems;
	
	            if (taskItems && taskItems.length > 0) {
	                taskItems.map(function (taskItem, taskItemKey) {
	                    _this2.bindTinyMceEditor(taskItemKey);
	                });
	            }
	        }
	
	        /**
	         * On `componentWillUnmount` event destorys each tinyMCE editor instance binded to `textarea` element
	         * @see unbindTinyMceEditors() the method that destroys the editor instances foreach textarea element
	         */
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            this.unbindTinyMceEditors();
	        }
	
	        /**
	         * Binds a tinyMCE editor instance to the textarea element of the task item
	         * @param {int} taskItemKey the key of the taskItem from taskItems state data
	         */
	    }, {
	        key: "handleArchiveConfirmationInput",
	
	        /**
	        * Handles the archive confirmation input change event
	        * this is used to check if the user wants to archive the entities that will be converted to tasks
	        */
	        value: function handleArchiveConfirmationInput() {
	            var isArchiveConfirmation = this.state.isArchiveConfirmation;
	
	            this.setState({ isArchiveConfirmation: !isArchiveConfirmation });
	        }
	
	        /**
	         * Handles the modal submition event
	         */
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props2 = this.props;
	            var modalTitle = _props2.modalTitle;
	            var error = _props2.error;
	            var statusText = _props2.statusText;
	            var taskCreatorModalToggle = _props2.taskCreatorModalToggle;
	            var _state2 = this.state;
	            var taskItems = _state2.taskItems;
	            var staffItems = _state2.staffItems;
	            var isArchiveConfirmation = _state2.isArchiveConfirmation;
	            var convertionType = _state2.convertionType;
	
	            var canSubmitForm = staffItems.reduce(function (a, b) {
	                return a + (b.selected ? 1 : 0);
	            }, 0);
	
	            return _react2["default"].createElement(
	                "div",
	                { className: _taskCreatorFormScss2["default"].modalContent },
	                _react2["default"].createElement(
	                    "span",
	                    { className: _taskCreatorFormScss2["default"].modalTitle },
	                    _(modalTitle)
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: _taskCreatorFormScss2["default"].taskItemsList },
	                    taskItems.length > 0 && taskItems.map(function (taskItem, key) {
	                        return _react2["default"].createElement(
	                            "div",
	                            { className: _taskCreatorFormScss2["default"].taskItem, key: key },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: _taskCreatorFormScss2["default"].taskField },
	                                _react2["default"].createElement(
	                                    "label",
	                                    null,
	                                    _("modalTaskTitle")
	                                ),
	                                _react2["default"].createElement("input", {
	                                    type: "text",
	                                    value: taskItem.title,
	                                    onChange: function (event) {
	                                        return _this3.taskItemTitleChangeHandler(key, event);
	                                    }
	                                })
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: _taskCreatorFormScss2["default"].taskField },
	                                _react2["default"].createElement(
	                                    "label",
	                                    null,
	                                    _("modalTaskDescription")
	                                ),
	                                _react2["default"].createElement("textarea", { id: "tinymce-editor-" + key })
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                {
	                                    className: _taskCreatorFormScss2["default"].taskField + " " + _taskCreatorFormScss2["default"].dateInput
	                                },
	                                _react2["default"].createElement(
	                                    "label",
	                                    null,
	                                    _("modalTaskEndate")
	                                ),
	                                _react2["default"].createElement(_componentsSharedDatePicker.DatePicker, {
	                                    value: taskItem.endDate,
	                                    onChange: function (ev) {
	                                        return _this3.taskItemDateChangeHandler(key, ev);
	                                    }
	                                })
	                            )
	                        );
	                    })
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: _taskCreatorFormScss2["default"].modalSubtitle },
	                    _("selectUsers")
	                ),
	                _react2["default"].createElement(
	                    "ul",
	                    { className: _taskCreatorFormScss2["default"].staffItemsList },
	                    staffItems.map(function (staffItem, key) {
	                        return _react2["default"].createElement(
	                            "li",
	                            {
	                                key: staffItem.userId,
	                                "data-selected": staffItem.selected,
	                                onClick: function () {
	                                    return _this3.staffItemSelectionHandler(staffItem.userId);
	                                }
	                            },
	                            _react2["default"].createElement(
	                                "span",
	                                null,
	                                staffItem.firstName + " " + staffItem.lastName
	                            ),
	                            _react2["default"].createElement(
	                                "span",
	                                null,
	                                staffItem.email
	                            )
	                        );
	                    })
	                ),
	                convertionType !== 'task' && _react2["default"].createElement(
	                    "div",
	                    { className: _taskCreatorFormScss2["default"].archiveSubtitleLast },
	                    _react2["default"].createElement(
	                        "label",
	                        { htmlFor: "confirm-archive-item" },
	                        _('archiveConfirmation')
	                    ),
	                    _react2["default"].createElement("input", {
	                        type: "checkbox",
	                        id: "confirm-archive-item",
	                        onChange: function (ev) {
	                            return _this3.handleArchiveConfirmationInput(ev);
	                        },
	                        value: isArchiveConfirmation
	                    })
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: _taskCreatorFormScss2["default"].error },
	                    statusText == "ValidationError" ? _("validationError") : error
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: _taskCreatorFormScss2["default"].modalActions },
	                    _react2["default"].createElement(
	                        "span",
	                        {
	                            onClick: function () {
	                                return taskCreatorModalToggle();
	                            },
	                            className: _taskCreatorFormScss2["default"].closeButton
	                        },
	                        _("cancel")
	                    ),
	                    _react2["default"].createElement("input", {
	                        onClick: function () {
	                            return _this3.handleModalSubmitEvent();
	                        },
	                        type: "button",
	                        className: _taskCreatorFormScss2["default"].greyButton,
	                        value: _("sendAsTask"),
	                        disabled: !canSubmitForm
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TaskCreatorForm;
	})(_react.Component);
	
	exports["default"] = TaskCreatorForm;
	module.exports = exports["default"];

	/**
	 * Unbinds the tinyMCE editor for each element in the state.editors
	 */

	/**
	 * Initialize an editor instance body
	 * @param {object} editorInstance the tinyMCE editor instance
	 * @param {int} taskItemKey the taskItem key
	 */

	/**
	 * Changes the title in the state for the requested taskItem based on `itemKey`
	 * @param {int} itemKey the key of the changed item
	 * @param {object} event the event data
	 */

	/**
	 * Changes the description in the state for the requested taskItem based on `itemKey`
	 * @param {int} itemKey the key of the changed item
	 * @param {mixed} value the new value
	 */

	/**
	 * Changes the date in the state for the requested taskItem based on `itemKey`
	 * @param {int} itemKey the key of the changed item
	 * @param {string} event the changed date value
	 */

	/**
	 * Toggles a staff item selected property based on `staffId`
	 * @param {int} staffId the id of the staff item `userId` property in the staff shape
	 */
	/*#list [taskItems]*/ /*#endlist*/ /*#list [staffItems]*/ /*endlist*/ /*#region [archiveConfirmation]*/ /*#endregion*/ /*#region [modalControlls]*/ /*#endregion*/

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	// Import base react components
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	// Import components
	
	var _reactColor = __webpack_require__(1965);
	
	// Import libraries
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	// Import styles and object styles for modals
	
	var _taskListScss = __webpack_require__(197);
	
	var _taskListScss2 = _interopRequireDefault(_taskListScss);
	
	// Setup translation group to agenda2
	var _ = (0, _libI18n2['default'])('agenda2');
	
	/**
	 * Manage color picker form
	 *
	 * Handles create and edit form for custom colors
	 */
	
	var ManageColorPickerForm = (function (_Component) {
		_inherits(ManageColorPickerForm, _Component);
	
		_createClass(ManageColorPickerForm, null, [{
			key: 'propTypes',
	
			/**
	  * Set the required property types for the component
	  */
			value: {
				formState: _react2['default'].PropTypes.object.isRequired,
				createAction: _react2['default'].PropTypes.func.isRequired,
				updateAction: _react2['default'].PropTypes.func.isRequired,
				toggleModal: _react2['default'].PropTypes.func.isRequired,
				formCleanAction: _react2['default'].PropTypes.func.isRequired,
				userColors: _react2['default'].PropTypes.array.isRequired
			},
	
			/**
	      * Setup constructor with the base state of the component
	      * Here we add the default state form task form fields and validation
	      */
			enumerable: true
		}]);
	
		function ManageColorPickerForm(props) {
			_classCallCheck(this, ManageColorPickerForm);
	
			_get(Object.getPrototypeOf(ManageColorPickerForm.prototype), 'constructor', this).call(this, props);
	
			this.state = {
				form: {
					title: '',
					colorCode: '#000000'
				},
				validation: {
					title: null,
					colorCode: null
				}
			};
		}
	
		/**
	  * Setup component state if the form is in edit state
	  */
	
		_createClass(ManageColorPickerForm, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this = this;
	
				var _props$formState = this.props.formState;
				var colorId = _props$formState.colorId;
				var isEdit = _props$formState.isEdit;
				var userColors = this.props.userColors;
	
				if (isEdit == true) {
					userColors.map(function (value, index) {
						if (value.value == colorId) {
							_this.setState({ form: {
									title: value.label,
									colorCode: value.colorCode
								} });
						}
					});
				}
			}
	
			/**
	      * Handles title change
	      */
		}, {
			key: 'handleTitleChange',
			value: function handleTitleChange(event) {
				var form = this.state.form;
	
				form.title = event.target.value;
	
				this.setState({ form: form });
			}
	
			/**
	   * Handles color change for sketch picker
	   */
		}, {
			key: 'handleColorChange',
			value: function handleColorChange(color) {
				var form = this.state.form;
	
				form.colorCode = color.hex;
	
				this.setState({ form: form });
			}
	
			/**
	      * Handles submit if the validation was ok
	      */
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				var form = this.state.form;
				var _props = this.props;
				var formState = _props.formState;
				var createAction = _props.createAction;
				var updateAction = _props.updateAction;
	
				// Clean the validation on every submit
				this.setState({
					validation: {
						title: null,
						description: null,
						date: null,
						color: null
					}
				});
	
				// If validation was true then create task
				if (this.validate()) {
					if (formState.isEdit == false) {
						createAction(form);
					} else {
						form.id = formState.colorId;
						updateAction(form);
					}
				}
			}
	
			/**
	   * Validate form after submit to check if required fields are ok
	   */
		}, {
			key: 'validate',
			value: function validate() {
				var _state = this.state;
				var form = _state.form;
				var validation = _state.validation;
	
				var invalidFields = false;
	
				if (form.title == '' || form.title == null) {
					validation.title = _('requiredField');
					invalidFields = true;
				}
	
				if (invalidFields == true) {
					this.setState({ validation: validation });
					return false;
				} else {
					return true;
				}
			}
	
			/**
	   * Render
	   * Handles the render part for the component
	   */
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _state$form = this.state.form;
				var title = _state$form.title;
				var colorCode = _state$form.colorCode;
				var validation = this.state.validation;
				var _props2 = this.props;
				var toggleModal = _props2.toggleModal;
				var formCleanAction = _props2.formCleanAction;
				var formState = _props2.formState;
	
				var submitButtonText = formState.isEdit == true ? 'edit' : 'create';
	
				return _react2['default'].createElement(
					'div',
					{ className: _taskListScss2['default'].todoModalContent + " " + _taskListScss2['default'].colSm },
					formState.isEdit == false && _react2['default'].createElement(
						'span',
						{ className: _taskListScss2['default'].title },
						_("addTodoColor")
					),
					formState.isEdit == true && _react2['default'].createElement(
						'span',
						{ className: _taskListScss2['default'].title },
						_("editTodoColor")
					),
					_react2['default'].createElement(
						'label',
						null,
						_('title')
					),
					_react2['default'].createElement('input', {
						type: 'text',
						onChange: function (ev) {
							return _this2.handleTitleChange(ev);
						},
						value: title
					}),
					_react2['default'].createElement(
						'div',
						{ className: _taskListScss2['default'].error },
						' ',
						validation.title != null && validation.title,
						' '
					),
					_react2['default'].createElement(
						'label',
						null,
						_('selectColor')
					),
					_react2['default'].createElement(
						'div',
						{ className: _taskListScss2['default'].colorPickerWrapper },
						_react2['default'].createElement(_reactColor.SketchPicker, {
							disableAlpha: true,
							presetColors: [],
							className: _taskListScss2['default'].customSketchPicker,
							color: colorCode,
							onChange: this.handleColorChange.bind(this)
						}),
						_react2['default'].createElement('div', { style: {
								background: colorCode,
								width: '60px',
								height: '40px',
								display: 'block',
								margin: '0px 0px 0px 5px'
							} })
					),
					_react2['default'].createElement(
						'div',
						{ className: _taskListScss2['default'].todoModalButtons },
						_react2['default'].createElement(
							'span',
							{
								onClick: function () {
									toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER);
									formCleanAction('manageColorPicker');
								},
								className: _taskListScss2['default'].cancel
							},
							_("cancel")
						),
						_react2['default'].createElement('input', {
							onClick: function (event) {
								return _this2.handleSubmit(event);
							},
							type: 'button',
							className: _taskListScss2['default'].greyButton,
							value: _(submitButtonText)
						})
					)
				);
			}
		}]);
	
		return ManageColorPickerForm;
	})(_react.Component);
	
	exports['default'] = ManageColorPickerForm;
	module.exports = exports['default'];

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	// Import base react components
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	// Import libraries
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	// Import styles and object styles for modals
	
	var _taskListScss = __webpack_require__(197);
	
	var _taskListScss2 = _interopRequireDefault(_taskListScss);
	
	// Setup translation group to agenda2
	var _ = (0, _libI18n2['default'])('agenda2');
	
	/**
	 * Task form
	 *
	 * Handles task create and edit form
	 */
	
	var ManageColorsForm = (function (_Component) {
	    _inherits(ManageColorsForm, _Component);
	
	    function ManageColorsForm() {
	        _classCallCheck(this, ManageColorsForm);
	
	        _get(Object.getPrototypeOf(ManageColorsForm.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ManageColorsForm, [{
	        key: 'handleEditAction',
	
	        /**
	         * Handle edit action of a color
	         */
	        value: function handleEditAction(itemId) {
	            var _props = this.props;
	            var toggleModal = _props.toggleModal;
	            var setEditAction = _props.setEditAction;
	
	            setEditAction('manageColorPicker', itemId);
	            toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER);
	        }
	
	        /**
	         * Handle delete action of a color
	         */
	    }, {
	        key: 'handleDeleteAction',
	        value: function handleDeleteAction(itemId) {
	            var setNotificationTypeAction = this.props.setNotificationTypeAction;
	
	            setNotificationTypeAction('deleteColor', itemId);
	            return;
	        }
	
	        /**
	         * Render
	         * Handles the render part for the component
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props2 = this.props;
	            var userColors = _props2.userColors;
	            var toggleModal = _props2.toggleModal;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _taskListScss2['default'].todoModalContent },
	                _react2['default'].createElement(
	                    'span',
	                    { className: _taskListScss2['default'].title },
	                    _("manageTodoColors")
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].tableContainer },
	                    !_underscore2['default'].isEmpty(userColors) && _underscore2['default'].isArray(userColors) && userColors[0] !== 'Too many rows' && _react2['default'].createElement(
	                        _componentsReactable.Table,
	                        {
	                            className: _taskListScss2['default'].table,
	                            itemsPerPage: 5,
	                            topPagination: '',
	                            filterable: []
	                        },
	                        _react2['default'].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'colorCode' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('label_color')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'label' },
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    _('title')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Th,
	                                { column: 'actions' },
	                                _react2['default'].createElement('strong', null)
	                            )
	                        ),
	                        userColors.map(function (item, key) {
	                            return _react2['default'].createElement(
	                                _componentsReactable.Tr,
	                                { className: 'centered', key: item.value },
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'colorCode' },
	                                    _react2['default'].createElement('div', { style: {
	                                            background: item.colorCode,
	                                            width: '20px',
	                                            height: '20px',
	                                            display: 'inline-block',
	                                            margin: '0px 0px 0px 5px',
	                                            boxShadow: '0px 0px 5px 1px rgba(0,0,0,0.2)'
	                                        } })
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'label' },
	                                    item.label
	                                ),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Td,
	                                    { column: 'actions' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        null,
	                                        _react2['default'].createElement(
	                                            'button',
	                                            { type: 'button',
	                                                className: _taskListScss2['default'].editFieldButton,
	                                                onClick: function () {
	                                                    _this.handleEditAction(item.value);
	                                                } },
	                                            _react2['default'].createElement('img', { src: __webpack_require__(355) })
	                                        ),
	                                        _react2['default'].createElement(
	                                            'button',
	                                            { type: 'button',
	                                                className: _taskListScss2['default'].editFieldButton,
	                                                onClick: function () {
	                                                    _this.handleDeleteAction(item.value);
	                                                } },
	                                            _react2['default'].createElement('img', { src: __webpack_require__(79) })
	                                        )
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    userColors.length == 0 && _react2['default'].createElement(
	                        'div',
	                        { className: _taskListScss2['default'].noresults },
	                        _('noTodoColors')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].todoModalButtons },
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_COLORS);
	                            },
	                            className: _taskListScss2['default'].cancel
	                        },
	                        _("close")
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	
	        /**
	        * Set the required property types for the component
	        */
	        value: {
	            userColors: _react2['default'].PropTypes.array.isRequired,
	            toggleModal: _react2['default'].PropTypes.func.isRequired,
	            setEditAction: _react2['default'].PropTypes.func.isRequired,
	            setNotificationTypeAction: _react2['default'].PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    return ManageColorsForm;
	})(_react.Component);
	
	exports['default'] = ManageColorsForm;
	module.exports = exports['default'];

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	// Import libraries
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	// Import styles and object styles for modals
	
	var _taskListScss = __webpack_require__(197);
	
	var _taskListScss2 = _interopRequireDefault(_taskListScss);
	
	// Setup translation group to agenda2
	var _ = (0, _libI18n2['default'])('agenda2');
	
	var NotificationContent = (function (_Component) {
	    _inherits(NotificationContent, _Component);
	
	    function NotificationContent() {
	        _classCallCheck(this, NotificationContent);
	
	        _get(Object.getPrototypeOf(NotificationContent.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(NotificationContent, [{
	        key: 'handleSubmit',
	
	        /**
	         * Handle submit based on notification type
	         */
	        value: function handleSubmit() {
	            var _props = this.props;
	            var notificationType = _props.notificationType;
	            var notificationItemId = _props.notificationItemId;
	            var resetTaskColorsAction = _props.resetTaskColorsAction;
	            var items = _props.items;
	            var deleteTaskAction = _props.deleteTaskAction;
	            var deleteColorAction = _props.deleteColorAction;
	
	            if (notificationType == 'deleteColor') {
	                deleteColorAction(notificationItemId);
	            }
	
	            if (notificationType == 'resetColors') {
	                resetTaskColorsAction();
	            }
	
	            if (notificationType == 'deleteTasks') {
	                deleteTaskAction(items);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props2 = this.props;
	            var notificationType = _props2.notificationType;
	            var toggleModal = _props2.toggleModal;
	            var items = _props2.items;
	
	            var filteredItems = items.filter(function (item) {
	                return !item.isDeleted;
	            }).filter(function (item) {
	                return !item.hidden;
	            });
	            var checkedItems = items.filter(function (item) {
	                return !item.isDeleted;
	            }).filter(function (i) {
	                return i.checked === true;
	            }).map(function (i) {
	                return i;
	            });
	            checkedItems = checkedItems.filter(function (item) {
	                return !item.hidden;
	            }).map(function (i) {
	                return i.id;
	            });
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _taskListScss2['default'].todoModalContent + " " + _taskListScss2['default'].colXs },
	                notificationType == 'resetColors' && _react2['default'].createElement(
	                    'span',
	                    { className: _taskListScss2['default'].title },
	                    _("confirmReset")
	                ),
	                notificationType == 'deleteTasks' && _react2['default'].createElement(
	                    'span',
	                    { className: _taskListScss2['default'].title },
	                    _("confirmDeleteTasks")
	                ),
	                notificationType == 'deleteColor' && _react2['default'].createElement(
	                    'span',
	                    { className: _taskListScss2['default'].title },
	                    _('confirmDeleteColor')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].confirmationMessage },
	                    notificationType == 'resetColors' && _react2['default'].createElement(
	                        'span',
	                        null,
	                        _("confirmResetMessage")
	                    ),
	                    notificationType == 'deleteTasks' && _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('confirmDeleteTasksSubj'),
	                        ' ',
	                        checkedItems.length,
	                        ' ',
	                        _("confirmDeleteTasksMessage")
	                    ),
	                    notificationType == 'deleteColor' && _react2['default'].createElement(
	                        'span',
	                        null,
	                        _('confirmDeleteColorMessage')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].todoModalButtons },
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_NOTIFICATION);
	                            },
	                            className: _taskListScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement('input', {
	                        onClick: function (event) {
	                            return _this.handleSubmit(event);
	                        },
	                        type: 'button',
	                        className: _taskListScss2['default'].greyButton,
	                        value: _('confirm')
	                    })
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	
	        /**
	        * Set the required property types for the component
	        */
	        value: {
	            items: _react2['default'].PropTypes.array,
	            deleteTaskAction: _react2['default'].PropTypes.func.isRequired,
	            notificationType: _react2['default'].PropTypes.string,
	            notificationItemId: _react2['default'].PropTypes.string,
	            toggleModal: _react2['default'].PropTypes.func.isRequired,
	            resetTaskColorsAction: _react2['default'].PropTypes.func.isRequired,
	            deleteColorAction: _react2['default'].PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    return NotificationContent;
	})(_react.Component);
	
	exports['default'] = NotificationContent;
	module.exports = exports['default'];

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	// Import react component and proptyes
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	// Import elements for table list
	
	var _componentsReactable = __webpack_require__(17);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectColorSelectWrapper = __webpack_require__(610);
	
	// Import helper functions
	
	var _lodashCollection = __webpack_require__(55);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libHelpers = __webpack_require__(24);
	
	var _noResults = __webpack_require__(81);
	
	var _noResults2 = _interopRequireDefault(_noResults);
	
	// Import styles for component
	
	var _taskListScss = __webpack_require__(197);
	
	var _taskListScss2 = _interopRequireDefault(_taskListScss);
	
	// Import libraries
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	// Setup translation group to agenda2
	var _ = (0, _libI18n2['default'])('agenda2');
	
	/**
	 * Table list component
	 *
	 * Handles task list table events and listing
	 */
	
	var TableList = (function (_Component) {
	    _inherits(TableList, _Component);
	
	    _createClass(TableList, null, [{
	        key: 'propTypes',
	
	        /**
	        * Set the required property types for the component
	        */
	        value: {
	            items: _react2['default'].PropTypes.array.isRequired,
	            filterStatusValue: _react2['default'].PropTypes.string,
	            filterColorValue: _react2['default'].PropTypes.array,
	            toggleModal: _react2['default'].PropTypes.func.isRequired,
	            setEditAction: _react2['default'].PropTypes.func.isRequired,
	            filterAction: _react2['default'].PropTypes.func.isRequired,
	            colorOptions: _react2['default'].PropTypes.object.isRequired,
	            checkTableItemAction: _react2['default'].PropTypes.func.isRequired,
	            checkTableAllItemsAction: _react2['default'].PropTypes.func.isRequired,
	            setNotificationTypeAction: _react2['default'].PropTypes.func.isRequired,
	            setSendTaskModalState: _react2['default'].PropTypes.func.isRequired,
	            setTaskReaded: _react2['default'].PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    function TableList(props) {
	        var _this = this;
	
	        _classCallCheck(this, TableList);
	
	        _get(Object.getPrototypeOf(TableList.prototype), 'constructor', this).call(this, props);
	
	        this.handleVisibleList = function (visibleIds) {
	            var visibilityOf = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = visibleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var id = _step.value;
	
	                    visibilityOf[id] = true;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator['return']) {
	                        _iterator['return']();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            _this.visibleIds = visibleIds;
	            _this.setState({ visibilityOf: visibilityOf });
	        };
	
	        this.handleCheckAll = function () {
	            var checkTableAllItemsAction = _this.props.checkTableAllItemsAction;
	
	            var visibleIds = _this.visibleIds;
	
	            checkTableAllItemsAction(visibleIds);
	        };
	
	        this.handleOverdueToggle = function () {
	            var showOverdue = _this.state.showOverdue;
	
	            _this.setState({ showOverdue: !showOverdue });
	        };
	
	        this.state = { visibilityOf: {}, showOverdue: false };
	    }
	
	    /**
	     * Component will unmount eve
	     */
	
	    _createClass(TableList, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.state = { visibilityOf: [] };
	        }
	
	        /**
	         * Generates buttons for delete, deleteAll and create
	         *
	         * return Html
	         */
	    }, {
	        key: 'actionButtons',
	        value: function actionButtons(checkedItemCount, items) {
	            var _props = this.props;
	            var toggleModal = _props.toggleModal;
	            var setNotificationTypeAction = _props.setNotificationTypeAction;
	            var setSendTaskModalState = _props.setSendTaskModalState;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _taskListScss2['default'].buttonContainer },
	                _react2['default'].createElement('input', {
	                    onClick: function () {
	                        return setNotificationTypeAction('deleteTasks');
	                    },
	                    disabled: !checkedItemCount,
	                    type: 'button',
	                    className: _taskListScss2['default'].greyButton,
	                    value: _("delete")
	                }),
	                _react2['default'].createElement('input', {
	                    type: 'button',
	                    className: _taskListScss2['default'].greyButton,
	                    value: _("sendTask"),
	                    disabled: !checkedItemCount,
	                    onClick: function () {
	                        setSendTaskModalState();
	                    }
	                }),
	                _react2['default'].createElement('input', {
	                    type: 'button',
	                    className: _taskListScss2['default'].greyButton + " enabled",
	                    value: _("create"),
	                    onClick: function () {
	                        return toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_TASK);
	                    }
	                })
	            );
	        }
	
	        /**
	        * Convert status to string for user experience
	         *
	         * @param boolean status The status of the task item
	         *
	         * @return String
	        */
	    }, {
	        key: 'statusToString',
	        value: function statusToString(status) {
	            return status === true ? _('completed') : _('uncompleted');
	        }
	
	        /**
	         * Handles visible items ids list
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            // Get the required properties for the component
	            var _props2 = this.props;
	            var items = _props2.items;
	            var filterStatusValue = _props2.filterStatusValue;
	            var filterColorValue = _props2.filterColorValue;
	            var setEditAction = _props2.setEditAction;
	            var toggleModal = _props2.toggleModal;
	            var filterAction = _props2.filterAction;
	            var colorOptions = _props2.colorOptions;
	            var checkTableItemAction = _props2.checkTableItemAction;
	            var setTaskReaded = _props2.setTaskReaded;
	            var _state = this.state;
	            var visibilityOf = _state.visibilityOf;
	            var showOverdue = _state.showOverdue;
	
	            var filteredItems = items;
	
	            // Generate filtered items from items property
	            filteredItems = items.filter(function (item) {
	                return !item.hidden;
	            });
	            filteredItems = filteredItems.filter(function (item) {
	                return !item.isDeleted;
	            });
	
	            // Show just overdue filter if overdue is checked
	            if (showOverdue == true) {
	                filteredItems = items.filter(function (item) {
	                    return !item.isDeleted;
	                }).filter(function (value, index) {
	                    var currentState = value.hidden;
	
	                    if (currentState == false) {
	                        if (value.isCompleted == false) {
	                            var currentDate = (0, _moment2['default'])().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
	                            var itemEndDate = (0, _moment2['default'])(value.endDate);
	
	                            if (itemEndDate.isBefore(currentDate) || itemEndDate.isSame(currentDate)) {
	                                return true;
	                            }
	                        }
	
	                        return false;
	                    }
	                });
	            }
	
	            var filterColorOptions = [].concat(_toConsumableArray(colorOptions.defaultColors), _toConsumableArray(colorOptions.userColors));
	
	            if (filterColorValue && filterColorValue.length > 0) {
	                filterColorOptions.push({
	                    colorCode: null,
	                    value: 'reset_filter',
	                    label: _('showAll')
	                });
	            }
	
	            var checkedItemCount = filteredItems.reduce(function (a, b) {
	                return a + (b.checked ? 1 : 0);
	            }, 0);
	            var allSelected = filteredItems && filteredItems.length > 0 && filteredItems.every(function (item) {
	                return visibilityOf[item.id] ? item.checked : true;
	            });
	
	            // Set default filter status options
	            var filterStatusOptions = [{ value: 'showAll', label: _('showAll') }, { value: 'showCompleted', label: _('showCompleted') }, { value: 'showUncompleted', label: _('showUncompleted') }];
	            return _react2['default'].createElement(
	                'div',
	                null,
	                filteredItems && _underscore2['default'].isArray(filteredItems) && filteredItems[0] !== 'Too many rows' && _react2['default'].createElement(
	                    _componentsReactable.Table,
	                    {
	                        onVisibleChange: this.handleVisibleList,
	                        topPaginationElemL: [_react2['default'].createElement(
	                            'div',
	                            { key: 'x1z' },
	                            _react2['default'].createElement(_sharedSelectSelectWrap.SelectWrapper, {
	                                key: 's',
	                                value: filterStatusValue,
	                                options: filterStatusOptions,
	                                onChange: function (v) {
	                                    filterAction(v.value, filterColorValue);
	                                }
	                            })
	                        ), _react2['default'].createElement(
	                            'div',
	                            { key: 'x2z' },
	                            _react2['default'].createElement(_sharedSelectColorSelectWrapper.ColorSelectWrapper, {
	                                key: 's',
	                                value: filterColorValue,
	                                options: filterColorOptions,
	                                onChange: function (v) {
	                                    filterAction(filterStatusValue, v);
	                                },
	                                placeholder: _('show_all_colors')
	                            })
	                        ), _react2['default'].createElement(
	                            'div',
	                            { key: 'x3z', className: _taskListScss2['default'].overdueWrapper },
	                            _react2['default'].createElement('input', {
	                                type: 'checkbox',
	                                checked: showOverdue,
	                                onChange: function (v) {
	                                    _this2.handleOverdueToggle();
	                                }
	                            }),
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _('showOverdue')
	                            )
	                        )],
	                        topPaginationElemR: this.actionButtons(checkedItemCount, filteredItems),
	                        filterable: ["title", "description"],
	                        ref: function (el) {
	                            _this2.table = el;
	                        },
	                        id: 'table',
	                        className: 'table',
	                        sortable: [{ column: 'endDate', sortFunction: function sortFunction(a, b) {
	                                var current = (0, _moment2['default'])(a, 'YYYY-MM-DDTHH:mm:ss.SSS').unix();
	                                var next = (0, _moment2['default'])(b, 'YYYY-MM-DDTHH:mm:ss.SSS').unix();
	
	                                return current > next ? 1 : -1;
	                            } }, { column: 'title', sortFunction: function sortFunction(a, b) {
	                                return a.toLowerCase().localeCompare(b.toLowerCase(), 'sv', { sensitivity: 'accent' });
	                            } }, 'status', {
	                            column: 'globalSort',
	                            sortFunction: function sortFunction(a, b) {
	                                var dataA = a.split('|');
	                                var dataB = b.split('|');
	
	                                dataA[0] = (0, _moment2['default'])(dataA[0], 'YYYY-MM-DDTHH:mm:ss.SSS').unix();
	                                dataA[1] = dataA[1] == 'true' ? 1 : 0;
	
	                                dataB[0] = (0, _moment2['default'])(dataB[0], 'YYYY-MM-DDTHH:mm:ss.SSS').unix();
	                                dataB[1] = dataB[1] == 'true' ? 1 : 0;
	
	                                if (dataA[1] == dataB[1]) {
	                                    return dataA[0] > dataB[0] ? 1 : -1;
	                                } else {
	                                    return dataA[1] > dataB[1] ? 1 : -1;
	                                }
	                            }
	                        }],
	                        defaultSort: {
	                            column: 'globalSort',
	                            direction: 'asc'
	                        },
	
	                        itemsPerPage: 40,
	                        pageButtonLimit: 5
	                    },
	                    _react2['default'].createElement(
	                        _componentsReactable.Thead,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'checkbox', style: { width: '5%', textAlign: 'left' } },
	                            _react2['default'].createElement('input', {
	                                type: 'checkbox',
	                                checked: allSelected,
	                                onChange: this.handleCheckAll
	                            })
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'status', style: { width: '10%', textAlign: 'left' } },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("status")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'title', style: { width: '70%', textAlign: 'left' } },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("title")
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsReactable.Th,
	                            { column: 'endDate', style: { width: '15%', textAlign: 'left' } },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                _("endDate")
	                            )
	                        )
	                    ),
	                    filteredItems.map(function (item, key) {
	                        return _react2['default'].createElement(
	                            _componentsReactable.Tr,
	                            {
	                                i: item.id,
	                                key: key,
	                                className: item.isUnreaded ? '' + _taskListScss2['default'].unread : '',
	                                onClick: function (ev) {
	                                    setEditAction('manageTask', item.id);
	                                    toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_TASK);
	                                    setTaskReaded(item);
	                                }
	                            },
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'checkbox', value: (0, _lodashCollection.map)(item, function (i) {
	                                        return i;
	                                    }).join(' '), style: { width: '5%', textAlign: 'left' } },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { style: { width: 15 } },
	                                    _react2['default'].createElement('input', {
	                                        type: 'checkbox',
	                                        onClick: function (ev) {
	                                            return ev.stopPropagation();
	                                        },
	                                        onChange: function (ev) {
	                                            return checkTableItemAction(ev, item.id);
	                                        },
	                                        checked: item.checked
	                                    })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'status', style: { width: '10%', textAlign: 'left' } },
	                                _this2.statusToString(item.isCompleted)
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                { column: 'title', value: item.title, style: { width: '70%' } },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { style: { paddingRight: '25px' } },
	                                    item.title,
	                                    item.hexColor != null && _react2['default'].createElement('div', { style: {
	                                            background: item.hexColor,
	                                            width: '18px',
	                                            height: '18px',
	                                            display: 'inline-block',
	                                            margin: '-3px -25px 0px 0px',
	                                            float: 'right'
	                                        } })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                {
	                                    style: { width: '15%', textAlign: 'left' },
	                                    column: 'endDate',
	                                    value:
	                                    // a little hack with MongoDB id as timestamp for sorting
	                                    item.endDate && item.endDate.toString() + item.id || ""
	                                },
	                                item.endDate && (0, _libHelpers.dateFormatter)(item.endDate) || ""
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                {
	                                    column: 'description',
	                                    value: item.description
	                                },
	                                item.endDate && (0, _libHelpers.dateFormatter)(item.endDate) || ""
	                            ),
	                            _react2['default'].createElement(
	                                _componentsReactable.Td,
	                                {
	                                    column: 'globalSort',
	                                    value: item.globalSort
	                                },
	                                item.globalSort
	                            )
	                        );
	                    })
	                ),
	                filteredItems && _underscore2['default'].isArray(filteredItems) && filteredItems.length === 0 && _react2['default'].createElement(_noResults2['default'], { type: 'tasks' })
	            );
	        }
	    }]);
	
	    return TableList;
	})(_react.Component);
	
	exports['default'] = TableList;
	module.exports = exports['default'];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	// Import base react components
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsSharedDatePicker = __webpack_require__(62);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectColorSelectWrapper = __webpack_require__(610);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _taskListScss = __webpack_require__(197);
	
	var _taskListScss2 = _interopRequireDefault(_taskListScss);
	
	// import tinyMCE. The 5.3 or above also requires importing a theme and a set of icons
	
	var _tinymceTinymce = __webpack_require__(526);
	
	var _tinymceTinymce2 = _interopRequireDefault(_tinymceTinymce);
	
	__webpack_require__(513);
	
	__webpack_require__(525);
	
	// For tinyMCE 5.3 or above, the plugins are now imported here instead of being specified
	// as external scripts
	
	__webpack_require__(523);
	
	__webpack_require__(518);
	
	__webpack_require__(517);
	
	__webpack_require__(515);
	
	__webpack_require__(521);
	
	__webpack_require__(519);
	
	__webpack_require__(524);
	
	__webpack_require__(514);
	
	__webpack_require__(522);
	
	__webpack_require__(516);
	
	__webpack_require__(520);
	
	// Setup translation group to agenda2
	var _ = (0, _libI18n2['default'])('agenda2');
	
	/**
	 * Task form
	 *
	 * Handles task create and edit form
	 */
	
	var TaskForm = (function (_Component) {
	    _inherits(TaskForm, _Component);
	
	    _createClass(TaskForm, null, [{
	        key: 'propTypes',
	
	        /**
	        * Set the required property types for the component
	        */
	        value: {
	            formState: _react2['default'].PropTypes.object.isRequired,
	            taskList: _react2['default'].PropTypes.array,
	            selectColorOptions: _react2['default'].PropTypes.object.isRequired,
	            toggleModal: _react2['default'].PropTypes.func.isRequired,
	            createTaskAction: _react2['default'].PropTypes.func.isRequired,
	            editTaskAction: _react2['default'].PropTypes.func.isRequired,
	            formCleanAction: _react2['default'].PropTypes.func.isRequired,
	            setNotificationTypeAction: _react2['default'].PropTypes.func.isRequired
	        },
	
	        /**
	         * Setup constructor with the base state of the component
	         * Here we add the default state form task form fields and validation
	         */
	        enumerable: true
	    }]);
	
	    function TaskForm(props) {
	        var _this = this;
	
	        _classCallCheck(this, TaskForm);
	
	        _get(Object.getPrototypeOf(TaskForm.prototype), 'constructor', this).call(this, props);
	
	        this.bindTinyMceEditor = function () {
	            var editor = _this.state.editor;
	            var elementSelector = '#tinymce-editor';
	
	            window.tinymce.init({
	                selector: elementSelector,
	                min_height: 365,
	                menubar: false,
	                mode: "design",
	                statusbar: false,
	
	                // [Jancsi] - these are not required anymore for version 5.3+ of tinyMCE, it is enough to specify the teme
	                // theme_url: window.location.protocol+'//'+(window.location.href.split("/")[2] + '/themes/modern/theme.js').replace("\/\/", "\/"),
	                // skin_url:  window.location.protocol+'//'+(window.location.href.split("/")[2] + '/skins/lightgray/').replace("\/\/", "\/"),
	                theme: 'silver',
	
	                toolbar1: "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | formatselect fontselect fontsizeselect",
	                toolbar2: "paste pastetext searchreplace | bullist numlist | outdent indent | undo redo | link unlink anchor image code",
	                toolbar3: "forecolor backcolor | table | hr removeformat visualchars | subscript superscript | charmap preview | fullscreen",
	                // [Jancsi] these are not required anymore for version 5.3+ of tinyMCE, as plugins are imported at the beginning of the file
	                // external_plugins: {
	                //     'textcolor': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/textcolor/plugin.js').replace("\/\/", "\/"),
	                //     'link': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/link/plugin.js').replace("\/\/", "\/"),
	                //     //'image': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/image/plugin.js').replace("\/\/", "\/"),
	                //     'code': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/code/plugin.js').replace("\/\/", "\/"),
	                //     'searchreplace': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/searchreplace/plugin.js').replace("\/\/", "\/"),
	                //     'paste': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/paste/plugin.js').replace("\/\/", "\/"),
	                //     'visualchars': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/visualchars/plugin.js').replace("\/\/", "\/"),
	                //     'charmap': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/charmap/plugin.js').replace("\/\/", "\/"),
	                //     'table': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/table/plugin.js').replace("\/\/", "\/"),
	                //     'fullscreen': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/fullscreen/plugin.js').replace("\/\/", "\/"),
	                //     'preview': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/preview/plugin.js').replace("\/\/", "\/"),
	                // },
	                plugins: ["textcolor link code searchreplace paste visualchars charmap table fullscreen preview"],
	                force_br_newlines: false,
	                force_p_newlines: false,
	                forced_root_block: "",
	                relative_urls: false,
	                remove_script_host: false,
	                convert_urls: true,
	                setup: function setup(editorInstance) {
	                    editor = editorInstance;
	                    editorInstance.on('init', function (e) {
	                        _this.initializeBodyEditor(editorInstance);
	                    });
	
	                    _this.setState({ editor: editor });
	                }
	            });
	        };
	
	        this.initializeBodyEditor = function (editorInstance) {
	            var form = _this.state.form;
	
	            if (window.tinymce && editorInstance) {
	
	                try {
	                    editorInstance.setContent(form.description, { format: 'raw' });
	                } catch (exc) {
	                    console.log(exc);
	                }
	
	                editorInstance.on('blur', function (e) {
	                    _this.handleDescriptionChange(editorInstance.getContent());
	                });
	
	                editorInstance.on('click', function (e) {
	                    _this.handleDescriptionChange(editorInstance.getContent());
	                });
	            }
	        };
	
	        this.unbindTinyMceEditors = function () {
	            window.tinymce.execCommand("mceFocus", true, 'tinymce-editor');
	            window.tinymce.execCommand("mceRemoveEditor", true, 'tinymce-editor');
	            window.tinymce.execCommand("mceRemoveControl", false, 'tinymce-editor');
	        };
	
	        this.generateDataWithoutReference = function (items) {
	            var userId = _this.props.userId;
	
	            var newArray = [];
	
	            items.map(function (itemValue, itemKey) {
	                var newItem = JSON.parse(JSON.stringify(itemValue));
	
	                /**if(newItem.userId === userId) {
	                    newItem.selected = true;
	                }**/
	
	                newArray[itemKey] = newItem;
	            });
	
	            return newArray;
	        };
	
	        this.staffItemSelectionHandler = function (staffId) {
	            var staffItems = _this.state.staffItems;
	            var selection = [];
	
	            staffItems.map(function (value, key) {
	                selection[key] = _extends({}, value);
	
	                if (value.userId == staffId) {
	                    selection[key].selected = !value.selected;
	                }
	            });
	
	            _this.setState({ staffItems: selection });
	        };
	
	        this.state = {
	            form: {
	                title: '',
	                description: '',
	                date: (0, _moment2['default'])(),
	                color: '',
	                status: false
	            },
	            validation: {
	                title: null,
	                description: null,
	                date: null,
	                color: null
	            },
	            editor: null,
	            staffItems: []
	        };
	    }
	
	    /**
	     * Setup component state if the form is in edit state
	     */
	
	    _createClass(TaskForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var _props$formState = this.props.formState;
	            var taskId = _props$formState.taskId;
	            var isEdit = _props$formState.isEdit;
	            var _props = this.props;
	            var taskList = _props.taskList;
	            var staff = _props.staff;
	
	            if (isEdit == true) {
	                taskList.map(function (value, index) {
	                    if (value.id == taskId) {
	                        _this2.setState({ form: {
	                                title: value.title,
	                                description: value.description,
	                                color: value.colorCode,
	                                date: value.endDate,
	                                status: value.isCompleted + ""
	                            } });
	                    }
	                });
	            } else {
	                this.setState({
	                    staffItems: this.generateDataWithoutReference(staff)
	                });
	            }
	        }
	
	        /**
	         * On `componentDidMount` event binds the tinyMCE editor to the `textarea` element in the form
	         * @see bindTinyMceEditor() the method that bind's the editor to textarea element
	         */
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.bindTinyMceEditor();
	        }
	
	        /**
	         * On `componentWillUnmount` event destorys the tinyMCE editor instance binded to `textarea` element
	         * @see unbindTinyMceEditors() the method that destroys the editor instances for textarea element
	         */
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.unbindTinyMceEditors();
	        }
	
	        /**
	         * Binds a tinyMCE editor instance to the textarea element of the task item
	         */
	    }, {
	        key: 'getTaskRelationsList',
	        value: function getTaskRelationsList() {
	            var _props$formState2 = this.props.formState;
	            var taskId = _props$formState2.taskId;
	            var isEdit = _props$formState2.isEdit;
	            var taskList = this.props.taskList;
	
	            var taskRelations = [];
	
	            if (isEdit == true) {
	                taskList.map(function (value, index) {
	                    if (value.id == taskId) {
	                        taskRelations = value.relations;
	                    }
	                });
	            }
	
	            return taskRelations;
	        }
	
	        /**
	         * This function give back the selected tsk from the list by id from state.
	         */
	    }, {
	        key: 'getOpenedTask',
	        value: function getOpenedTask() {
	            var _props$formState3 = this.props.formState;
	            var taskId = _props$formState3.taskId;
	            var isEdit = _props$formState3.isEdit;
	            var taskList = this.props.taskList;
	
	            var task = false;
	
	            // the id exists only in case when editing is true. Tha same react module is used for handling tasks.
	            if (isEdit == true) {
	                taskList.map(function (value, index) {
	                    if (value.id == taskId) {
	                        task = value;
	                    }
	                });
	            }
	            return task;
	        }
	    }, {
	        key: 'getTaskReceivedList',
	        value: function getTaskReceivedList() {
	            var _this3 = this;
	
	            var _props$formState4 = this.props.formState;
	            var taskId = _props$formState4.taskId;
	            var isEdit = _props$formState4.isEdit;
	            var taskList = this.props.taskList;
	
	            var taskRelations = [];
	
	            if (isEdit === false) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    _('receivedTasks'),
	                    ' /'
	                );
	            }
	
	            /*         if (isEdit !== true) {
	                        return
	                    } */
	
	            var taskReceivedData = undefined;
	            var taskUserRelational = null;
	            var taskTitle = null;
	            var isEmpty = "";
	            var theTask = {};
	
	            taskList.map(function (value, index) {
	                if (value.id === taskId) {
	                    taskReceivedData = value.receivedFrom;
	                    theTask = value;
	                    //taskUserRelational = value.userRelation
	                    //taskTitle = value.title
	                }
	            });
	
	            if (taskReceivedData.ticket.length < 1 && taskReceivedData.task.length < 1 /*  && !theTask.ticketReferral */) {
	                    isEmpty = '/';
	                }
	
	            return _react2['default'].createElement(
	                'div',
	                { key: "getTaskReceivedList_container_" + taskId },
	                _('receivedTasks'),
	                ' ',
	                isEmpty,
	                _react2['default'].createElement(
	                    'div',
	                    { className: "results", key: "taskReceivedData_" + taskId },
	                    taskReceivedData && taskReceivedData.ticket && taskReceivedData.ticket.length ? taskReceivedData.ticket.map(function (ticketItem, key) {
	                        return _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('ticket'),
	                            ' - ',
	                            _this3.getStaffName(ticketItem.userId),
	                            ' - ',
	                            ticketItem.ticketDescription
	                        );
	                    }) : null,
	                    theTask && theTask.ticketReferral && (!taskReceivedData.ticket || taskReceivedData.ticket.length == 0) ? _react2['default'].createElement(
	                        'div',
	                        null,
	                        _("missingTicketRelation")
	                    ) : null
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: "results",
	                        key: "taskReceivedData_task_" + taskId },
	                    taskReceivedData && taskReceivedData.task && taskReceivedData.task.length > 0 ? taskReceivedData.task.map(function (taskItem, key) {
	                        return _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('task'),
	                            ' - ',
	                            _this3.getStaffName(taskItem.userId),
	                            ' - ',
	                            _this3.getTaskStatus(taskItem.isCompleted),
	                            ' - ',
	                            taskItem.title
	                        );
	                    }) : null,
	                    theTask && theTask.taskRelation && (!taskReceivedData.task || taskReceivedData.task.length == 0) ? _react2['default'].createElement(
	                        'div',
	                        null,
	                        _("missingTaskRelation")
	                    ) : null
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: taskReceivedData.email.length ? "results" : "noresults", key: "taskReceivedData_email_" + taskId },
	                    taskReceivedData && taskReceivedData.email && taskReceivedData.email.length && taskReceivedData.email.map(function (emailItem, key) {
	                        return _react2['default'].createElement(
	                            'span',
	                            null,
	                            _('email'),
	                            ' - ',
	                            _this3.getStaffName(emailItem.userId),
	                            ' - ',
	                            emailItem.subject
	                        );
	                    })
	                )
	            );
	        }
	
	        /**
	         * Returns the current task documents list in html format
	         */
	    }, {
	        key: 'getTaskDocumentsList',
	        value: function getTaskDocumentsList() {
	            var _props$formState5 = this.props.formState;
	            var taskId = _props$formState5.taskId;
	            var isEdit = _props$formState5.isEdit;
	            var taskList = this.props.taskList;
	
	            var itemData = null;
	
	            if (isEdit == true) {
	                taskList.map(function (value, index) {
	                    if (value.id == taskId) {
	                        itemData = value;
	                    }
	                });
	            }
	
	            if (itemData === null) {
	                return;
	            }
	
	            if (itemData.ticketDocuments === undefined || itemData.ticketDocuments === null) {
	                return;
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _taskListScss2['default'].documentsWrapper },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    _('documents')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].documents },
	                    itemData.ticketDocuments && itemData.ticketDocuments.map(function (doc, key) {
	                        return _react2['default'].createElement(
	                            'a',
	                            {
	                                key: key,
	                                href: '/data/document?id=' + doc + '&type=' + itemData.ticketDoctype,
	                                target: '_blank',
	                                rel: 'noopener noreferrer'
	                            },
	                            doc
	                        );
	                    })
	                )
	            );
	        }
	
	        /**
	         * Get the staff name based on user id
	         *
	         * @param {string} userId the staff user unique id
	         */
	    }, {
	        key: 'getStaffName',
	        value: function getStaffName(userId) {
	            var staff = this.props.staff;
	
	            var name = '-';
	
	            staff.forEach(function (element) {
	                if (element.userId == userId) {
	                    name = element.firstName + ' ' + element.lastName;
	                }
	            });
	
	            return name;
	        }
	
	        /**
	         * Return the status string based on task isCompleted value
	         *
	         * @param {boolean} status
	         */
	    }, {
	        key: 'getTaskStatus',
	        value: function getTaskStatus(status) {
	            if (status == true) {
	                return _('completed');
	            } else {
	                return _('uncompleted');
	            }
	        }
	
	        /**
	        * Handle color change
	        */
	    }, {
	        key: 'handleColorChange',
	        value: function handleColorChange(event) {
	            var form = this.state.form;
	            var _props2 = this.props;
	            var toggleModal = _props2.toggleModal;
	            var setNotificationTypeAction = _props2.setNotificationTypeAction;
	
	            if (event.value == 'manage') {
	                toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_COLORS);
	                return;
	            }
	
	            if (event.value == 'create') {
	                toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER);
	                return;
	            }
	
	            if (event.value == 'reset') {
	                setNotificationTypeAction('resetColors');
	                return;
	            }
	
	            form.color = event.value;
	            this.setState({ form: form });
	        }
	
	        /**
	         * Handle title change
	         */
	    }, {
	        key: 'handleTitleChange',
	        value: function handleTitleChange(event) {
	            var form = this.state.form;
	
	            form.title = event.target.value;
	
	            this.setState({ form: form });
	        }
	
	        /**
	         * Handle date change
	         */
	    }, {
	        key: 'handleDateChange',
	        value: function handleDateChange(event) {
	            var form = this.state.form;
	
	            form.date = event;
	
	            var newDate = (0, _moment2['default'])(event).set({ hour: 1 }).format('YYYY-MM-DD h:mm:ss');
	            this.setState({ form: form });
	        }
	
	        /**
	         * Handle description change
	         */
	    }, {
	        key: 'handleDescriptionChange',
	        value: function handleDescriptionChange(value) {
	            var form = this.state.form;
	
	            form.description = value;
	
	            this.setState({ form: form });
	        }
	
	        /**
	         * Handle status change
	         */
	    }, {
	        key: 'handleStatusChange',
	        value: function handleStatusChange(event) {
	            var form = this.state.form;
	
	            form.status = event.value;
	
	            this.setState({ form: form });
	        }
	
	        /**
	         * Handles submit if the validation was ok
	         */
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(event) {
	            var _state = this.state;
	            var form = _state.form;
	            var staffItems = _state.staffItems;
	            var _props3 = this.props;
	            var formState = _props3.formState;
	            var createTaskAction = _props3.createTaskAction;
	            var editTaskAction = _props3.editTaskAction;
	            var taskCreatorGenerateWithRelations = _props3.taskCreatorGenerateWithRelations;
	
	            // Clean the validation on every submit
	            this.setState({
	                validation: {
	                    title: null,
	                    description: null,
	                    date: null,
	                    color: null
	                }
	            });
	
	            // If validation was true then create task
	            if (this.validate()) {
	                if (formState.isEdit == false) {
	                    taskCreatorGenerateWithRelations({
	                        items: [{
	                            title: form.title,
	                            description: form.description,
	                            endDate: form.date,
	                            isCompleted: form.status,
	                            colorCode: form.color
	                        }],
	                        users: staffItems,
	                        isArchiveConfirmation: false,
	                        convertionType: 'taskCreate'
	                    });
	                } else {
	                    form.id = formState.taskId;
	                    editTaskAction(form);
	                }
	            }
	        }
	
	        /**
	         * Generate a new array of data object without reference to the array of objects
	         * @param {array} items the array of objects
	         * @return {array} the new array object without reference
	         */
	    }, {
	        key: 'validate',
	
	        /**
	         * Validate form after submit to check if required fields are ok
	         */
	        value: function validate() {
	            var _state2 = this.state;
	            var form = _state2.form;
	            var validation = _state2.validation;
	
	            var invalidFields = false;
	
	            if (form.title == '' || form.title == null) {
	                validation.title = _('requiredField');
	                invalidFields = true;
	            }
	
	            if (form.description == '' || form.description == null) {
	                validation.description = _('requiredField');
	                invalidFields = true;
	            }
	
	            if (invalidFields == true) {
	                this.setState({ validation: validation });
	                return false;
	            } else {
	                return true;
	            }
	        }
	
	        /**
	         * Render
	         * Handles the render part for the component
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state$form = this.state.form;
	            var title = _state$form.title;
	            var description = _state$form.description;
	            var date = _state$form.date;
	            var color = _state$form.color;
	            var status = _state$form.status;
	            var validation = this.state.validation;
	
	            var staffItems = this.state.staffItems;
	            var _props4 = this.props;
	            var formState = _props4.formState;
	            var selectColorOptions = _props4.selectColorOptions;
	            var toggleModal = _props4.toggleModal;
	            var formCleanAction = _props4.formCleanAction;
	            var staff = _props4.staff;
	
	            var canSubmitForm = true;
	
	            if (formState.isEdit == false) {
	                canSubmitForm = staffItems.reduce(function (a, b) {
	                    return a + (b.selected ? 1 : 0);
	                }, 0);
	            }
	
	            // Select color actions
	            var selectColorActions = [{
	                value: 'manage',
	                label: _("manageColors"),
	                colorCode: null
	            }];
	
	            if (selectColorOptions.userColors.length < 15) {
	                selectColorActions.push({
	                    value: 'create',
	                    label: _("newColor"),
	                    colorCode: null
	                });
	            }
	
	            if (selectColorOptions.userColors.length > 0) {
	                selectColorActions.push({
	                    value: 'reset',
	                    label: _("resetColors"),
	                    colorCode: null
	                });
	            }
	
	            // Define select options for select todo color
	            var selectTodoColor = [{
	                value: '',
	                label: _('noTodoColor'),
	                colorCode: null
	            }].concat(_toConsumableArray(selectColorOptions.defaultColors), _toConsumableArray(selectColorOptions.userColors), selectColorActions);
	
	            var startDate = (0, _moment2['default'])().subtract(1, 'day').format('YYYY-MM-DD h:mm:ss');
	            var endDate = (0, _moment2['default'])().add(10, 'years').format('YYYY-MM-DD');
	
	            var statusOptions = [{
	                value: "true",
	                label: _('statusCompleted')
	            }, {
	                value: "false",
	                label: _('statusUncompleted')
	            }];
	
	            var submitButtonText = formState.isEdit == true ? 'edit' : 'createTodo';
	            var taskRelationsList = this.getTaskRelationsList();
	            // get task in case when editing is active, else will be false
	            var theTask = this.getOpenedTask();
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _taskListScss2['default'].todoModalContent, key: "TaskFormModalContent" },
	                formState.isEdit == true && _react2['default'].createElement(
	                    'span',
	                    { className: _taskListScss2['default'].title, key: "isEditSpanKey1" },
	                    _("editTodo")
	                ),
	                formState.isEdit == false && _react2['default'].createElement(
	                    'span',
	                    { className: _taskListScss2['default'].title, key: "isEditSpanKey2" },
	                    _("addTodo")
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].subContentWrapper, key: "TaskFormSubContentWrapper" },
	                    _react2['default'].createElement(
	                        'label',
	                        null,
	                        _('title'),
	                        ' *'
	                    ),
	                    _react2['default'].createElement('input', {
	                        type: 'text',
	                        onChange: function (ev) {
	                            return _this4.handleTitleChange(ev);
	                        },
	                        value: title
	                    }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _taskListScss2['default'].error },
	                        ' ',
	                        validation.title != null && validation.title,
	                        ' '
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _taskListScss2['default'].datepickerFlexRow, key: "datePickerFlexRow" },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _taskListScss2['default'].datepickerLabelField },
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _('todoDate'),
	                                ' *'
	                            ),
	                            _react2['default'].createElement(_componentsSharedDatePicker.DatePicker, {
	                                onChange: function (ev) {
	                                    return _this4.handleDateChange(ev);
	                                },
	                                value: date,
	                                maxDate: endDate
	                            })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _taskListScss2['default'].datepickerLabelField },
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _('color')
	                            ),
	                            _react2['default'].createElement(_sharedSelectColorSelectWrapper.SelectTodoColorWrapper, {
	                                options: selectTodoColor, value: color,
	                                onChange: this.handleColorChange.bind(this)
	                            })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'label',
	                        null,
	                        _('description'),
	                        ' *'
	                    ),
	                    _react2['default'].createElement('textarea', { id: 'tinymce-editor' }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _taskListScss2['default'].error },
	                        ' ',
	                        validation.description != null && validation.description,
	                        ' '
	                    ),
	                    formState.isEdit == true && _react2['default'].createElement(
	                        'label',
	                        null,
	                        _('status')
	                    ),
	                    formState.isEdit == true && _react2['default'].createElement(_sharedSelectSelectWrap.SelectWrapper, {
	                        value: status,
	                        options: statusOptions,
	                        onChange: function (ev) {
	                            return _this4.handleStatusChange(ev);
	                        }
	                    })
	                ),
	                formState.isEdit != true && _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].modalSubtitle },
	                    _("selectUsers")
	                ),
	                formState.isEdit != true && _react2['default'].createElement(
	                    'ul',
	                    { className: _taskListScss2['default'].staffItemsList },
	                    staffItems.map(function (staffItem, key) {
	                        return _react2['default'].createElement(
	                            'li',
	                            {
	                                key: staffItem.userId,
	                                'data-selected': staffItem.selected,
	                                onClick: function () {
	                                    return _this4.staffItemSelectionHandler(staffItem.userId);
	                                }
	                            },
	                            _react2['default'].createElement(
	                                'span',
	                                { key: "staffItemKeyFirstName" },
	                                staffItem.firstName + " " + staffItem.lastName
	                            ),
	                            _react2['default'].createElement(
	                                'span',
	                                { key: "staffItemKeyEmail" },
	                                staffItem.email
	                            )
	                        );
	                    })
	                ),
	                formState.isEdit == true && _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].subContentWrapper, key: "subContentWrapperIsEditKey" },
	                    this.getTaskDocumentsList(),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _taskListScss2['default'].relatedTasks },
	                        _('sentTasks'),
	                        ' ',
	                        taskRelationsList.length < 1 && '/',
	                        taskRelationsList.map(function (itemData, key) {
	                            return _react2['default'].createElement(
	                                'span',
	                                { key: "getTaskRelationsListItemData" + key },
	                                _this4.getStaffName(itemData.userId),
	                                ' - ',
	                                _this4.getTaskStatus(itemData.isCompleted),
	                                ' - ',
	                                itemData.title
	                            );
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _taskListScss2['default'].relatedTasks },
	                        this.getTaskReceivedList()
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _taskListScss2['default'].formError },
	                        formState.status == false && formState.message
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _taskListScss2['default'].todoModalButtons, key: "todoModalButtonsTaskKeyLast" },
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            onClick: function () {
	                                toggleModal(_stateConstants2['default'].TASK_MODULE_MODAL_NAME_MANAGE_TASK);
	                                formCleanAction('manageTask');
	                            },
	                            className: _taskListScss2['default'].cancel
	                        },
	                        _("cancel")
	                    ),
	                    _react2['default'].createElement('input', {
	                        onClick: function (event) {
	                            return _this4.handleSubmit(event);
	                        },
	                        type: 'button',
	                        className: _taskListScss2['default'].greyButton,
	                        value: _(submitButtonText),
	                        disabled: !canSubmitForm
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TaskForm;
	})(_react.Component);
	
	exports['default'] = TaskForm;
	module.exports = exports['default'];

	/**
	 * Initialize an editor instance body
	 * @param {object} editorInstance the tinyMCE editor instance
	 * @param {int} taskItemKey the taskItem key
	 */

	/**
	 * Unbinds the tinyMCE editor for the element in the state.editor
	 */
	/*
	{taskUserRelational !== undefined && taskUserRelational !== null &&
	   <span>{_('task')} - {this.getStaffName(taskUserRelational) } - { taskTitle}</span>
	}*/

	/**
	 * Toggles a staff item selected property based on `staffId`
	 * @param {int} staffId the id of the staff item `userId` property in the staff shape
	 */
	/*#list [staffItems]*/ /*endlist*/

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	// Import base react and redux components
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactDomify = __webpack_require__(857);
	
	var _reactDomify2 = _interopRequireDefault(_reactDomify);
	
	// Import page components
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _elementsComponentPageDom = __webpack_require__(219);
	
	var _elementsComponentPageDom2 = _interopRequireDefault(_elementsComponentPageDom);
	
	var _componentsTableList = __webpack_require__(1149);
	
	var _componentsTableList2 = _interopRequireDefault(_componentsTableList);
	
	var _componentsTaskForm = __webpack_require__(1150);
	
	var _componentsTaskForm2 = _interopRequireDefault(_componentsTaskForm);
	
	var _componentsManageColorsForm = __webpack_require__(1147);
	
	var _componentsManageColorsForm2 = _interopRequireDefault(_componentsManageColorsForm);
	
	var _componentsManageColorPickerForm = __webpack_require__(1146);
	
	var _componentsManageColorPickerForm2 = _interopRequireDefault(_componentsManageColorPickerForm);
	
	var _componentsNotificationContent = __webpack_require__(1148);
	
	var _componentsNotificationContent2 = _interopRequireDefault(_componentsNotificationContent);
	
	var _taskCreator = __webpack_require__(372);
	
	var _taskCreator2 = _interopRequireDefault(_taskCreator);
	
	// Import page element components
	
	var _componentsReactable = __webpack_require__(17);
	
	// Import libraries
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	// Import helper functions
	
	var _libHelpers = __webpack_require__(24);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	// Import styles and object styles for modals
	
	var _taskListScss = __webpack_require__(197);
	
	var _taskListScss2 = _interopRequireDefault(_taskListScss);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	// Import actions to handle store changes
	
	var _stateActions = __webpack_require__(5);
	
	/**
	 * Here you can define default constants for the component
	 */
	var _ = (0, _libI18n2['default'])('agenda2'); // Setup translation group to agenda2
	
	var manageModalStyles = {
		overlay: {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: 'rgba(255, 255, 255, 0.75)',
			zIndex: 2
		},
		content: {
			position: 'relative',
			top: 'initial',
			bottom: 'initial',
			left: 'initial',
			right: 'initial',
			maxHeight: '90%',
			overflow: 'auto',
			padding: '0px',
			paddingBottom: '0.5em'
		}
	};
	
	/**
	 * Redux connect
	 *
	 * Here we get all the required data from store and populate component properties
	 */
	
	var TaskList = (function (_Component) {
		_inherits(TaskList, _Component);
	
		_createClass(TaskList, null, [{
			key: 'propTypes',
	
			/**
	   * Set the required property types for the component
	   */
			value: {
				taskModuleListGet: _react2['default'].PropTypes.func.isRequired,
				taskModuleListGetDefaultColors: _react2['default'].PropTypes.func.isRequired,
				taskModuleListGetUserColors: _react2['default'].PropTypes.func.isRequired,
				taskModuleFilter: _react2['default'].PropTypes.func.isRequired,
				taskModuleModalToggle: _react2['default'].PropTypes.func.isRequired,
				taskModuleFormCleanAction: _react2['default'].PropTypes.func.isRequired,
				taskModuleFormEditSetAction: _react2['default'].PropTypes.func.isRequired,
				taskModuleModalNotificationSet: _react2['default'].PropTypes.func.isRequired,
				taskModuleFormCreateTask: _react2['default'].PropTypes.func.isRequired,
				taskModuleFormUpdateTask: _react2['default'].PropTypes.func.isRequired,
				taskModuleTaskDelete: _react2['default'].PropTypes.func.isRequired,
				taskModuleFormCreateTaskColor: _react2['default'].PropTypes.func.isRequired,
				taskModuleFormUpdateTaskColor: _react2['default'].PropTypes.func.isRequired,
				taskModuleTaskColorDelete: _react2['default'].PropTypes.func.isRequired,
				taskModuleTaskColorReset: _react2['default'].PropTypes.func.isRequired,
				taskModuleItemCheck: _react2['default'].PropTypes.func.isRequired,
				taskModuleItemCheckAllVisible: _react2['default'].PropTypes.func.isRequired,
				taskCreatorModalToggle: _react2['default'].PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		function TaskList(props) {
			_classCallCheck(this, _TaskList);
	
			_get(Object.getPrototypeOf(_TaskList.prototype), 'constructor', this).call(this, props);
	
			this.generateTaskCreatorItems = function (items) {
				var convertedItems = [];
				var selectedItems = items.filter(function (item) {
					return item.checked;
				});
	
				if (selectedItems.length > 0) {
					selectedItems.map(function (value, key) {
						var ticketDocuments = null;
						var ticketDoctype = null;
						var ticketReferral = null;
						var colorCode = null;
	
						if (value.ticketDocuments && value.ticketDocuments !== undefined) {
							ticketDocuments = value.ticketDocuments;
						}
	
						if (value.ticketDoctype && value.ticketDoctype !== undefined) {
							ticketDoctype = value.ticketDoctype;
						}
	
						if (value.ticketReferral && value.ticketReferral !== undefined) {
							ticketReferral = value.ticketReferral;
						}
	
						if (value.colorCode && value.colorCode !== undefined) {
							colorCode = value.colorCode;
						}
	
						convertedItems.push({
							title: value.title,
							description: value.description,
							endDate: value.endDate,
							taskRelation: value.id,
							ticketDocuments: ticketDocuments,
							ticketDoctype: ticketDoctype,
							ticketReferral: ticketReferral,
							colorCode: colorCode
						});
					});
				}
	
				return convertedItems;
			};
	
			this.state = {
				staffList: [],
				itemsList: []
			};
		}
	
		/**
	  * Component will mount
	  */
	
		_createClass(TaskList, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _props = this.props;
				var taskModuleListGet = _props.taskModuleListGet;
				var taskModuleListGetDefaultColors = _props.taskModuleListGetDefaultColors;
				var taskModuleListGetUserColors = _props.taskModuleListGetUserColors;
	
				taskModuleListGetDefaultColors();
				taskModuleListGetUserColors();
				taskModuleListGet();
			}
	
			/**
	   * Handle todo modal toggle
	   *
	   * @param string $modalType
	   */
		}, {
			key: 'handleModalToggle',
			value: function handleModalToggle(modalType) {
				var taskModuleModalToggle = this.props.taskModuleModalToggle;
	
				taskModuleModalToggle(modalType);
			}
	
			/**
	   * Handle notification type set action dispatcher
	   */
		}, {
			key: 'handleModalNotificationTypeSet',
			value: function handleModalNotificationTypeSet(notificationType) {
				var itemId = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
				var taskModuleModalNotificationSet = this.props.taskModuleModalNotificationSet;
	
				taskModuleModalNotificationSet(notificationType, itemId);
			}
	
			/**
	   * Handle create task action dispatcher
	   */
		}, {
			key: 'handleCreateTask',
			value: function handleCreateTask(task) {
				var taskModuleFormCreateTask = this.props.taskModuleFormCreateTask;
	
				taskModuleFormCreateTask(task);
			}
	
			/**
	   * Handle update task action dispatcher
	   */
		}, {
			key: 'handleUpdateTask',
			value: function handleUpdateTask(task) {
				var taskModuleFormUpdateTask = this.props.taskModuleFormUpdateTask;
	
				taskModuleFormUpdateTask(task);
			}
	
			/**
	   * Handle delete tasks that are selected
	   */
		}, {
			key: 'handleDeleteTask',
			value: function handleDeleteTask(tasks) {
				var taskModuleTaskDelete = this.props.taskModuleTaskDelete;
	
				taskModuleTaskDelete(tasks);
			}
	
			/**
	  * Handle create task color action dispatcher
	  */
		}, {
			key: 'handleCreateTaskColor',
			value: function handleCreateTaskColor(taskColor) {
				var taskModuleFormCreateTaskColor = this.props.taskModuleFormCreateTaskColor;
	
				taskModuleFormCreateTaskColor(taskColor);
			}
	
			/**
	   * Handle create task color action dispatcher
	   */
		}, {
			key: 'handleUpdateTaskColor',
			value: function handleUpdateTaskColor(taskColor) {
				var taskModuleFormUpdateTaskColor = this.props.taskModuleFormUpdateTaskColor;
	
				taskModuleFormUpdateTaskColor(taskColor);
			}
	
			/**
	   * Handles delete task color action dispatcher
	   */
		}, {
			key: 'handleDeleteTaskColor',
			value: function handleDeleteTaskColor(taskColorId) {
				var taskModuleTaskColorDelete = this.props.taskModuleTaskColorDelete;
	
				taskModuleTaskColorDelete(taskColorId);
			}
	
			/**
	   * Handles reset task color action dispatcher
	   */
		}, {
			key: 'handleResetTaskcolor',
			value: function handleResetTaskcolor() {
				var taskModuleTaskColorReset = this.props.taskModuleTaskColorReset;
	
				taskModuleTaskColorReset();
			}
	
			/**
	   * Handle form cleaning
	   * This sets the requested form state to default value
	   */
		}, {
			key: 'handleFormClean',
			value: function handleFormClean(formType) {
				var taskModuleFormCleanAction = this.props.taskModuleFormCleanAction;
	
				taskModuleFormCleanAction(formType);
			}
	
			/**
	   * Handle set edit form
	   * This sets the form state to edit mode based on requested parameters
	   */
		}, {
			key: 'handleSetEditForm',
			value: function handleSetEditForm(formType, entityId) {
				var taskModuleFormEditSetAction = this.props.taskModuleFormEditSetAction;
	
				taskModuleFormEditSetAction(formType, entityId);
			}
	
			/**
	   * Handle filter action
	   */
		}, {
			key: 'handleFilter',
			value: function handleFilter(filterStatusValue, filterColorValue) {
				var taskModuleFilter = this.props.taskModuleFilter;
	
				taskModuleFilter(filterStatusValue, filterColorValue);
			}
	
			/**
	   * Handles checkbox check for table item
	   */
		}, {
			key: 'handleCheckTableItem',
			value: function handleCheckTableItem(event, itemId) {
				var taskModuleItemCheck = this.props.taskModuleItemCheck;
	
				event.stopPropagation();
				taskModuleItemCheck(itemId);
			}
	
			/**
	   * Handles check all action for table items checkboxes
	   */
		}, {
			key: 'handleCheckAllVisible',
			value: function handleCheckAllVisible(visibleItems) {
				var taskModuleItemCheckAllVisible = this.props.taskModuleItemCheckAllVisible;
	
				taskModuleItemCheckAllVisible(visibleItems);
			}
	
			/**
	   * Set the modal state when opening modal
	   */
		}, {
			key: 'setSendTaskModalState',
			value: function setSendTaskModalState() {
				var _props2 = this.props;
				var staff = _props2.staff;
				var items = _props2.items;
	
				var stateItems = [];
	
				items.map(function (value, key) {
					stateItems[key] = _extends({}, value);
				});
	
				stateItems = stateItems.filter(function (item) {
					return item.checked;
				});
	
				this.setState({ staffList: staff, itemsList: stateItems });
			}
	
			/**
	   * Clean send task component state
	   */
		}, {
			key: 'cleanSendTaskModalState',
			value: function cleanSendTaskModalState() {
				var resetStaffList = this.props.resetStaffList;
	
				this.setState({
					staffList: [],
					itemsList: []
				});
	
				resetStaffList();
			}
	
			/**
	   * Toggle the user selection based on user id
	   * this function is used on send task modal user list click event
	   *
	   * @param {int} userId the selection user id
	   */
		}, {
			key: 'toggleUserSelection',
			value: function toggleUserSelection(userId) {
				var staffList = this.state.staffList;
	
				staffList.map(function (value, key) {
					if (value.userId == userId) {
						value.selected = !value.selected;
					}
	
					staffList[key] = value;
				});
	
				this.setState({ staffList: staffList });
			}
		}, {
			key: 'handleSendTask',
			value: function handleSendTask() {
				var sendTaskToUser = this.props.sendTaskToUser;
				var _state = this.state;
				var staffList = _state.staffList;
				var itemsList = _state.itemsList;
	
				sendTaskToUser({
					items: itemsList,
					users: staffList
				});
			}
	
			/**
	  * Handles ticket title changes based on input value
	  *
	  * @param {object} ev the input field object data
	  * @param {int} itemKey the array key of the current edited item
	  */
		}, {
			key: 'handleTaskTitleChange',
			value: function handleTaskTitleChange(itemKey, ev) {
				var itemsList = this.state.itemsList;
				var items = [];
	
				itemsList.map(function (value, key) {
					items[key] = value;
	
					if (items[itemKey]) {
						items[itemKey].title = ev.target.value;
					}
				});
	
				this.setState({ itemsList: items });
			}
	
			/**
	  * Handles ticket details changes based on input value
	  *
	  * @param {object} ev the input field object data
	  * @param {int} itemKey the array key of the current edited item
	  */
		}, {
			key: 'handleTaskDetailChange',
			value: function handleTaskDetailChange(itemKey, ev) {
				var itemsList = this.state.itemsList;
				var items = [];
	
				itemsList.map(function (value, key) {
					items[key] = value;
	
					if (items[itemKey]) {
						items[itemKey].description = ev.target.value;
					}
				});
	
				this.setState({ itemsList: items });
			}
	
			/**
	   * Handles task date changes based on datepicker value
	   *
	   * @param {string} ev the value of the datepicker
	   * @param {int} itemKey the array key of the current edited item
	   */
		}, {
			key: 'handleTaskDateChange',
			value: function handleTaskDateChange(ev, itemKey) {
				var itemsList = this.state.itemsList;
				var items = [];
	
				itemsList.map(function (value, key) {
					items[key] = value;
	
					if (items[itemKey]) {
						items[itemKey].endDate = ev;
					}
				});
	
				this.setState({ itemsList: items });
			}
		}, {
			key: 'handleSetStatusReaded',
			value: function handleSetStatusReaded(task) {
				var setTaskReaded = this.props.setTaskReaded;
	
				setTaskReaded(task);
			}
	
			/**
	   * Converts the task items to task `shape` objects to be readable by the taskCreator component
	   * @param {array} items the list of data to be converted
	   * @return {array} the task `shape` objects generated data
	   */
		}, {
			key: 'render',
	
			/**
	   * Render the component Html
	   */
			value: function render() {
				var _props3 = this.props;
				var items = _props3.items;
				var filterStatusValue = _props3.filterStatusValue;
				var filterColorValue = _props3.filterColorValue;
				var modals = _props3.modals;
				var notification = _props3.notification;
				var colorsList = _props3.colorsList;
				var manageTask = _props3.manageTask;
				var manageColors = _props3.manageColors;
				var manageColorPicker = _props3.manageColorPicker;
				var staff = _props3.staff;
				var taskCreatorModalToggle = _props3.taskCreatorModalToggle;
				var userId = _props3.userId;
	
				return _react2['default'].createElement(
					_elementsComponentPageDom2['default'],
					{
						title: _('pageTitle'),
						subtitle: _('subtitle')
					},
					_react2['default'].createElement(
						'div',
						{ className: _taskListScss2['default'].results },
						_react2['default'].createElement(_componentsTableList2['default'], {
							items: items,
							filterStatusValue: filterStatusValue,
							filterColorValue: filterColorValue,
							toggleModal: this.handleModalToggle.bind(this),
							setEditAction: this.handleSetEditForm.bind(this),
							filterAction: this.handleFilter.bind(this),
							colorOptions: colorsList,
							checkTableItemAction: this.handleCheckTableItem.bind(this),
							checkTableAllItemsAction: this.handleCheckAllVisible.bind(this),
							setNotificationTypeAction: this.handleModalNotificationTypeSet.bind(this),
							setSendTaskModalState: taskCreatorModalToggle,
							setTaskReaded: this.handleSetStatusReaded.bind(this)
						})
					),
					_react2['default'].createElement(
						_reactModal2['default'],
						{
							isOpen: modals.manageTask,
							style: manageModalStyles,
							contentLabel: ""
						},
						_react2['default'].createElement(_componentsTaskForm2['default'], {
							taskList: items,
							formState: manageTask,
							selectColorOptions: colorsList,
							toggleModal: this.handleModalToggle.bind(this),
							createTaskAction: this.handleCreateTask.bind(this),
							editTaskAction: this.handleUpdateTask.bind(this),
							formCleanAction: this.handleFormClean.bind(this),
							setNotificationTypeAction: this.handleModalNotificationTypeSet.bind(this),
							staff: staff,
							taskCreatorGenerateWithRelations: this.props.taskCreatorGenerateWithRelations,
							userId: userId
						})
					),
					_react2['default'].createElement(
						_reactModal2['default'],
						{
							isOpen: modals.manageColors,
							style: manageModalStyles,
							contentLabel: ""
						},
						_react2['default'].createElement(_componentsManageColorsForm2['default'], {
							userColors: colorsList.userColors,
							toggleModal: this.handleModalToggle.bind(this),
							setEditAction: this.handleSetEditForm.bind(this),
							setNotificationTypeAction: this.handleModalNotificationTypeSet.bind(this)
						})
					),
					_react2['default'].createElement(
						_reactModal2['default'],
						{
							isOpen: modals.manageColorPicker,
							style: manageModalStyles,
							contentLabel: ""
						},
						_react2['default'].createElement(_componentsManageColorPickerForm2['default'], {
							formState: manageColorPicker,
							createAction: this.handleCreateTaskColor.bind(this),
							updateAction: this.handleUpdateTaskColor.bind(this),
							toggleModal: this.handleModalToggle.bind(this),
							formCleanAction: this.handleFormClean.bind(this),
							userColors: colorsList.userColors
						})
					),
					_react2['default'].createElement(
						_reactModal2['default'],
						{
							isOpen: modals.notification,
							style: manageModalStyles,
							contentLabel: ""
						},
						_react2['default'].createElement(_componentsNotificationContent2['default'], {
							items: items,
							deleteTaskAction: this.handleDeleteTask.bind(this),
							notificationType: notification.type,
							notificationItemId: notification.itemId,
							toggleModal: this.handleModalToggle.bind(this),
							resetTaskColorsAction: this.handleResetTaskcolor.bind(this),
							deleteColorAction: this.handleDeleteTaskColor.bind(this)
						})
					),
					_react2['default'].createElement(_taskCreator2['default'], {
						modalTitle: 'taskTaskCreatorModalTitle',
						taskItems: this.generateTaskCreatorItems(items),
						staffItems: staff,
						convertionType: 'task'
					})
				);
			}
		}]);
	
		var _TaskList = TaskList;
		TaskList = (0, _reactRedux.connect)(function (_ref) {
			var _ref$taskList = _ref.taskList;
			var items = _ref$taskList.items;
			var filterStatusValue = _ref$taskList.filterStatusValue;
			var filterColorValue = _ref$taskList.filterColorValue;
			var modals = _ref$taskList.modals;
			var notification = _ref$taskList.notification;
			var colorsList = _ref$taskList.colorsList;
			var manageTask = _ref$taskList.manageTask;
			var manageColors = _ref$taskList.manageColors;
			var manageColorPicker = _ref$taskList.manageColorPicker;
			var staff = _ref.inbox.staff;
			var userId = _ref.app.userId;
			return {
				items: items, filterStatusValue: filterStatusValue, filterColorValue: filterColorValue,
				modals: modals, notification: notification,
				colorsList: colorsList,
				manageTask: manageTask, manageColors: manageColors, manageColorPicker: manageColorPicker,
				staff: staff, userId: userId
			};
		}, {
			taskModuleListGet: _stateActions.taskModuleListGet, taskModuleListGetDefaultColors: _stateActions.taskModuleListGetDefaultColors, taskModuleListGetUserColors: _stateActions.taskModuleListGetUserColors, taskModuleFilter: _stateActions.taskModuleFilter,
			taskModuleModalToggle: _stateActions.taskModuleModalToggle, taskModuleFormCleanAction: _stateActions.taskModuleFormCleanAction, taskModuleFormEditSetAction: _stateActions.taskModuleFormEditSetAction, taskModuleModalNotificationSet: _stateActions.taskModuleModalNotificationSet,
			taskModuleFormCreateTask: _stateActions.taskModuleFormCreateTask, taskModuleFormUpdateTask: _stateActions.taskModuleFormUpdateTask, taskModuleTaskDelete: _stateActions.taskModuleTaskDelete,
			taskModuleFormCreateTaskColor: _stateActions.taskModuleFormCreateTaskColor, taskModuleFormUpdateTaskColor: _stateActions.taskModuleFormUpdateTaskColor, taskModuleTaskColorDelete: _stateActions.taskModuleTaskColorDelete, taskModuleTaskColorReset: _stateActions.taskModuleTaskColorReset,
			taskModuleItemCheck: _stateActions.taskModuleItemCheck, taskModuleItemCheckAllVisible: _stateActions.taskModuleItemCheckAllVisible,
			resetStaffList: _stateActions.resetStaffList, sendTaskToUser: _stateActions.sendTaskToUser, setTaskReaded: _stateActions.setTaskReaded, taskCreatorModalToggle: _stateActions.taskCreatorModalToggle,
			taskCreatorGenerateWithRelations: _stateActions.taskCreatorGenerateWithRelations
		})(TaskList) || TaskList;
		return TaskList;
	})(_react.Component);
	
	exports['default'] = TaskList;
	module.exports = exports['default'];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactTextareaAutosize = __webpack_require__(2098);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _stateActions = __webpack_require__(5);
	
	var _UploaderTableCommentScss = __webpack_require__(1629);
	
	var _UploaderTableCommentScss2 = _interopRequireDefault(_UploaderTableCommentScss);
	
	var UploaderTableComment = (function (_Component) {
	    _inherits(UploaderTableComment, _Component);
	
	    function UploaderTableComment(props) {
	        var _this = this;
	
	        _classCallCheck(this, _UploaderTableComment);
	
	        _get(Object.getPrototypeOf(_UploaderTableComment.prototype), 'constructor', this).call(this, props);
	
	        this.resolveDocumentComment = function (file) {
	            var commentValue = '';
	            var commentKey = null;
	            var commentKeys = ['clientDocumentBemComment', 'contractDocumentBemComment', 'tarificationDocBemComment', 'documentBemComment'];
	            commentKeys.forEach(function (key) {
	                if (Object.prototype.hasOwnProperty.call(file, key)) {
	                    commentKey = key;
	                    commentValue = file[key];
	                    return;
	                }
	            });
	            return { commentKey: commentKey, commentValue: commentValue };
	        };
	
	        this.handleChangeComment = function (event) {
	            if (event) {
	                _this.setState({ commentValue: event.target.value });
	            } else {
	                _this.setState({ commentValue: '' });
	            }
	        };
	
	        this.handleFocusComment = function () {
	            _this.setState({ hideCancel: false });
	        };
	
	        this.handleBlurComment = function () {
	            var document = _this.props.document;
	            var _state = _this.state;
	            var commentKey = _state.commentKey;
	            var commentValue = _state.commentValue;
	
	            if (document[commentKey] !== commentValue) {
	                _this.dispatchUpdateComment(commentValue);
	            }
	
	            var timeoutId = setTimeout(function () {
	                // delay to allow click on cancel button
	                _this.setState({ hideCancel: true });
	            }, 100);
	
	            _this.setState({ timeoutId: timeoutId }); // save timeoutId to clear it on component unmount
	        };
	
	        this.handleClearComment = function (event) {
	            event.stopPropagation();
	            _this.setState({ commentValue: '', hideCancel: true });
	            _this.dispatchUpdateComment('');
	        };
	
	        this.dispatchUpdateComment = function (commentValue) {
	            var _props = _this.props;
	            var dispatch = _props.dispatch;
	            var document = _props.document;
	            var typeId = _props.typeId;
	            var uploadId = _props.uploadId;
	            var uploadType = _props.uploadType;
	            var commentKey = _this.state.commentKey;
	
	            dispatch((0, _stateActions.updateCommentBemDoc)({
	                documentId: document.documentId, // might be `undefined` if adding comment to the document (not file document)
	                bemComment: { commentValue: commentValue, commentKey: commentKey },
	                uploadId: uploadId,
	                typeId: typeId,
	                uploadType: uploadType
	            }));
	        };
	
	        this.state = _extends({}, this.resolveDocumentComment(props.document), {
	            hideCancel: true,
	            timeoutId: null
	        });
	    }
	
	    _createClass(UploaderTableComment, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var timeoutId = this.state.timeoutId;
	
	            if (timeoutId) {
	                clearTimeout(timeoutId);
	            }
	        }
	
	        /**
	         * Resolve the document comment field based on the document structurture.
	         * @param {object} file claim | client | contract | tarification
	         * @returns {object} { commentKey: string | null, commentValue: string}
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state2 = this.state;
	            var commentKey = _state2.commentKey;
	            var commentValue = _state2.commentValue;
	            var hideCancel = _state2.hideCancel;
	
	            if (!commentKey) {
	                return _react2['default'].createElement('div', { style: { height: 33 } }); // empty div to keep the same height as the other rows
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _UploaderTableCommentScss2['default'].userCommentContainer },
	                _react2['default'].createElement(_reactTextareaAutosize2['default'], {
	                    maxRows: 4,
	                    placeholder: '',
	                    maxLength: '2000',
	                    value: commentValue,
	                    name: 'user_comment_textarea',
	                    onChange: this.handleChangeComment,
	                    onFocus: this.handleFocusComment,
	                    onBlur: this.handleBlurComment,
	                    className: _UploaderTableCommentScss2['default'].userCommnetField
	                }),
	                commentValue && _react2['default'].createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        onClick: this.handleClearComment,
	                        style: {
	                            opacity: hideCancel ? 0 : 1,
	                            pointerEvents: hideCancel ? 'none' : 'auto'
	                        },
	                        className: _UploaderTableCommentScss2['default'].removeInput
	                    },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: _UploaderTableCommentScss2['default'].cross },
	                        '×'
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _UploaderTableComment = UploaderTableComment;
	    UploaderTableComment = (0, _reactRedux.connect)(null)(UploaderTableComment) || UploaderTableComment;
	    return UploaderTableComment;
	})(_react.Component);
	
	exports.UploaderTableComment = UploaderTableComment;
	
	UploaderTableComment.propTypes = {
	    dispatch: _react.PropTypes.func,
	    typeId: _react.PropTypes.string,
	    uploadId: _react.PropTypes.string,
	    uploadType: _react.PropTypes.string, // 'claim' | 'client' | 'contract' | 'tarification'
	    document: _react.PropTypes.object
	};

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _uploaderScss = __webpack_require__(305);
	
	var _uploaderScss2 = _interopRequireDefault(_uploaderScss);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _stateActions = __webpack_require__(5);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('uploader');
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)',
	        overflow: 'visible'
	    },
	    content: {
	        width: '600px',
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        //minHeight: '50%',
	        overflow: 'auto',
	        padding: '0',
	        wordWrap: "break-word"
	    }
	};
	
	/**
	 * This component will handle tarification documents selection for linking with a contract and upload at the contract level
	 */
	
	var TarificationSelectionModal = (function (_React$Component) {
	    _inherits(TarificationSelectionModal, _React$Component);
	
	    function TarificationSelectionModal(props) {
	        _classCallCheck(this, TarificationSelectionModal);
	
	        _get(Object.getPrototypeOf(TarificationSelectionModal.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            clientTarificationsList: [],
	            tarificationDetailsList: {},
	            isOpened: {},
	            selectedDocuments: []
	        };
	    }
	
	    /**
	     * Used to open/close one tarification details
	     * @param {*} tarificationNumber 
	     */
	
	    _createClass(TarificationSelectionModal, [{
	        key: 'onTarificationDetailsClick',
	        value: function onTarificationDetailsClick(tarificationId) {
	            var tarificationDetailsList, _props, dispatch, modalIsOpen, openedTarificationDetailsListClone, indexTypes, getTarificationData;
	
	            return regeneratorRuntime.async(function onTarificationDetailsClick$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        tarificationDetailsList = this.state.tarificationDetailsList;
	                        _props = this.props;
	                        dispatch = _props.dispatch;
	                        modalIsOpen = _props.modalIsOpen;
	                        openedTarificationDetailsListClone = structuredClone(tarificationDetailsList);
	                        indexTypes = modalIsOpen;
	
	                        if (!(!tarificationDetailsList || !tarificationDetailsList[tarificationId])) {
	                            context$2$0.next = 11;
	                            break;
	                        }
	
	                        context$2$0.next = 9;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchOneTarificationDataForIndexMap)(tarificationId, indexTypes)));
	
	                    case 9:
	                        getTarificationData = context$2$0.sent;
	
	                        openedTarificationDetailsListClone[tarificationId] = getTarificationData;
	
	                    case 11:
	
	                        this.setState({
	                            isOpened: _extends({}, this.state.isOpened, _defineProperty({}, tarificationId, !this.state.isOpened[tarificationId])),
	                            tarificationDetailsList: openedTarificationDetailsListClone
	                        });
	
	                    case 12:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Handle document selection
	         * @param {*} ev 
	         * @param {*} document 
	         */
	    }, {
	        key: 'onselectDocument',
	        value: function onselectDocument(ev, document) {
	            var selectedDocuments = this.state.selectedDocuments;
	
	            var clonedDocuments = structuredClone(selectedDocuments);
	            var index = clonedDocuments.findIndex(function (oneDoc) {
	                return oneDoc.tarificationDocId === document.tarificationDocId;
	            });
	            if (index > -1) {
	                clonedDocuments.splice(index, 1);
	            } else {
	                clonedDocuments.push(document);
	            }
	
	            this.setState({ selectedDocuments: clonedDocuments });
	        }
	
	        /**
	         * Sends selected documents to parent component
	         * @returns 
	         */
	    }, {
	        key: 'handleOnNextClick',
	        value: function handleOnNextClick() {
	            var _props2 = this.props;
	            var modalIsOpen = _props2.modalIsOpen;
	            var method = _props2.method;
	            var selectedDocuments = this.state.selectedDocuments;
	
	            var documentsForNextStep = structuredClone(selectedDocuments);
	            if (documentsForNextStep && modalIsOpen && documentsForNextStep.length) {
	                this.setState({
	                    clientTarificationsList: [],
	                    selectedDocuments: [],
	                    tarificationDetailsList: {},
	                    isOpened: {}
	                });
	                method(documentsForNextStep);
	            }
	            return;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _state = this.state;
	            var isOpened = _state.isOpened;
	            var tarificationDetailsList = _state.tarificationDetailsList;
	            var selectedDocuments = _state.selectedDocuments;
	            var _props3 = this.props;
	            var modalIsOpen = _props3.modalIsOpen;
	            var onCancel = _props3.onCancel;
	            var clientTarificationsList = _props3.clientTarificationsList;
	            var payload = _props3.payload;
	            var method = _props3.method;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: modalIsOpen && modalIsOpen.length > 0,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _uploaderScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _uploaderScss2['default'].title },
	                        _('tarificationSelectionModalTitle')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _uploaderScss2['default'].contentWrapper },
	                        _react2['default'].createElement(
	                            _componentsReactable.Table,
	                            {
	                                onVisibleChange: this.handleVisibleList,
	                                filterable: ["tarificationNumber"],
	                                ref: function (el) {
	                                    _this.table = el;
	                                },
	                                id: 'table',
	                                className: 'table',
	                                sortable: ['tarificationNumber'],
	                                defaultSort: {
	                                    column: 'tarificationNumber',
	                                    direction: 'desc'
	                                },
	
	                                itemsPerPage: 50,
	                                pageButtonLimit: 5
	                            },
	                            _react2['default'].createElement(
	                                _componentsReactable.Thead,
	                                null,
	                                _react2['default'].createElement(_componentsReactable.Th, { column: 'collapse', label: '' }),
	                                _react2['default'].createElement(
	                                    _componentsReactable.Th,
	                                    { column: 'tarificationNumber' },
	                                    _react2['default'].createElement(
	                                        'strong',
	                                        null,
	                                        _("tarificationNumber")
	                                    )
	                                )
	                            ),
	                            clientTarificationsList && clientTarificationsList.length && clientTarificationsList.length > 0 ? clientTarificationsList.map(function (item, key) {
	                                return _react2['default'].createElement(
	                                    _componentsReactable.Tr,
	                                    {
	                                        className: 'clickable',
	                                        i: item,
	                                        key: key,
	                                        onClick: function () {
	                                            _this.onTarificationDetailsClick(item.tarificationMain.tarificationId);
	                                        }
	                                    },
	                                    (0, _componentsReactable.collapseTd)({
	                                        column: 'collapse',
	                                        isOpened: isOpened[item.tarificationMain.tarificationId],
	                                        children: _react2['default'].createElement(
	                                            'div',
	                                            { className: _uploaderScss2['default'].content },
	                                            _react2['default'].createElement(
	                                                'h2',
	                                                { className: _uploaderScss2['default'].tarificationDocumentsTitle },
	                                                _('tarificationDocuments')
	                                            ),
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { key: "TdDetailsKey" },
	                                                tarificationDetailsList && tarificationDetailsList[item.tarificationMain.tarificationId] && tarificationDetailsList[item.tarificationMain.tarificationId].tarificationDocuments && tarificationDetailsList[item.tarificationMain.tarificationId].tarificationDocuments.length > 0 ? _react2['default'].createElement(
	                                                    'ul',
	                                                    null,
	                                                    tarificationDetailsList[item.tarificationMain.tarificationId].tarificationDocuments.map(function (oneDoc, key) {
	                                                        return _react2['default'].createElement(
	                                                            'li',
	                                                            { key: key + 'tarifiactionDocList', className: _uploaderScss2['default'].tarificationDocumentListElem },
	                                                            _react2['default'].createElement(
	                                                                'div',
	                                                                { className: _uploaderScss2['default'].tarificationDocumentListElemInput },
	                                                                _react2['default'].createElement('input', {
	                                                                    type: 'checkbox',
	                                                                    onClick: function (ev) {
	                                                                        return ev.stopPropagation();
	                                                                    },
	                                                                    onChange: function (ev) {
	                                                                        return _this.onselectDocument(ev, oneDoc);
	                                                                    },
	                                                                    checked: selectedDocuments.findIndex(function (e) {
	                                                                        return e.tarificationDocId === oneDoc.tarificationDocId;
	                                                                    }) > -1 ? true : false,
	                                                                    disabled: selectedDocuments && selectedDocuments.length && selectedDocuments.findIndex(function (e) {
	                                                                        return e.tarificationDocId === oneDoc.tarificationDocId;
	                                                                    }) < 0
	                                                                })
	                                                            ),
	                                                            _react2['default'].createElement(
	                                                                'div',
	                                                                { className: _uploaderScss2['default'].tariffInputLabelWrapper },
	                                                                _react2['default'].createElement('img', { src: __webpack_require__(172),
	                                                                    onClick: function (ev) {
	                                                                        ev.stopPropagation();
	                                                                        window.open('/data/document?id=' + oneDoc.tarificationDocId + '&docType=' + encodeURI(oneDoc.tarificationDocType) + '&uploadDate=' + encodeURI(oneDoc.tarificationDocDate), '_blank', 'noopener,noreferrer');
	                                                                    }
	                                                                }),
	                                                                _react2['default'].createElement(
	                                                                    'p',
	                                                                    null,
	                                                                    oneDoc.tarificationDocType,
	                                                                    ' ',
	                                                                    (0, _moment2['default'])(oneDoc.tarificationDocDate).format('DD-MM-YYYY')
	                                                                )
	                                                            )
	                                                        );
	                                                    })
	                                                ) : _('tarificationNoDocumentsMessage')
	                                            )
	                                        )
	                                    }),
	                                    _react2['default'].createElement(
	                                        _componentsReactable.Td,
	                                        { column: 'tarificationNumber', value: item.tarificationMain.tarificationNumber },
	                                        item.tarificationMain.tarificationNumber
	                                    )
	                                );
	                            }) : ''
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _uploaderScss2['default'].buttons },
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        _this.setState({
	                                            clientTarificationsList: [],
	                                            tarificationDetailsList: {},
	                                            isOpened: {}
	                                        });
	                                        onCancel();
	                                    },
	                                    className: (0, _classnames2['default'])(_uploaderScss2['default'].cancel)
	                                },
	                                _('cancel')
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                {
	                                    onClick: function () {
	                                        return _this.handleOnNextClick();
	                                    },
	                                    className: (0, _classnames2['default'])(_uploaderScss2['default'].next, selectedDocuments && modalIsOpen && selectedDocuments.length ? _uploaderScss2['default'].enabled : _uploaderScss2['default'].disabled)
	                                },
	                                _("ok")
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TarificationSelectionModal;
	})(_react2['default'].Component);
	
	exports['default'] = TarificationSelectionModal;
	module.exports = exports['default'];

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x4, _x5, _x6) { var _again = true; _function: while (_again) { var object = _x4, property = _x5, receiver = _x6; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x4 = parent; _x5 = property; _x6 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(858);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploaderScss = __webpack_require__(305);
	
	var _uploaderScss2 = _interopRequireDefault(_uploaderScss);
	
	var _barScss = __webpack_require__(1630);
	
	var _barScss2 = _interopRequireDefault(_barScss);
	
	var _stateConstants = __webpack_require__(11);
	
	var _DSDocumentsMifidButton = __webpack_require__(80);
	
	var _DSDocumentsMifidButton2 = _interopRequireDefault(_DSDocumentsMifidButton);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _officeAreYouSureModal = __webpack_require__(607);
	
	var _officeAreYouSureModal2 = _interopRequireDefault(_officeAreYouSureModal);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _uuidV4 = __webpack_require__(61);
	
	var _uuidV42 = _interopRequireDefault(_uuidV4);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _tarificationSelectionModal = __webpack_require__(1153);
	
	var _tarificationSelectionModal2 = _interopRequireDefault(_tarificationSelectionModal);
	
	var _sharedSelectSelectWrap = __webpack_require__(37);
	
	var _sharedSelectSelectWrap2 = _interopRequireDefault(_sharedSelectSelectWrap);
	
	var _ = (0, _libI18n2['default'])('uploader');
	
	// let fileId = 1
	var currentFiles = {};
	
	var FileIcon = function FileIcon(_ref) {
		var file = _ref.file;
	
		if (file.name) {
			var type = file.type;
	
			if (type === 'pdf' || type === 'x-download' || type === 'download' || file.origin && file.origin === 'DS_ORIGIN_ORACLE') {
				return _react2['default'].createElement('img', { src: __webpack_require__(1011) });
			}
	
			return _react2['default'].createElement('img', { src: __webpack_require__(2320) });
			// the preview solution by URL.createObjectURL(file) is insecure, an rejected by Chrome in year 2023.
			// return <img src={file.preview}/>
		}
		return _react2['default'].createElement(
			'a',
			{ href: '/data/document?id=' + file.documentId, target: '_blank', rel: 'noopener noreferrer' },
			_react2['default'].createElement('img', { src: __webpack_require__(1011) })
		);
	};
	FileIcon.propTypes = {
		file: _react2['default'].PropTypes.object.isRequired
	};
	
	var FileProgress = function FileProgress(_ref2) {
		var file = _ref2.file;
	
		if (file.done) {
			return _react2['default'].createElement('img', { src: __webpack_require__(951) });
		}
		if (file.error) {
			return _react2['default'].createElement(
				'div',
				{ className: _uploaderScss2['default'].errorContainer },
				_react2['default'].createElement('img', { src: __webpack_require__(950) }),
				_react2['default'].createElement(
					'span',
					null,
					file.error
				)
			);
		}
		if (file.progress === 1) {
			return _react2['default'].createElement(
				'div',
				{ className: _barScss2['default'].barBg },
				_react2['default'].createElement(
					'div',
					{ className: _barScss2['default'].bar + ' ' + _barScss2['default'].gradient },
					_react2['default'].createElement('div', { className: _barScss2['default'].barFill })
				)
			);
		}
		return _react2['default'].createElement(
			'div',
			{ className: _uploaderScss2['default'].progressBar },
			_react2['default'].createElement('span', { style: { width: file.progress * 100 + "%" } })
		);
	};
	FileProgress.propTypes = {
		file: _react2['default'].PropTypes.object.isRequired
	};
	
	var UploaderModal = (function (_React$Component) {
		_inherits(UploaderModal, _React$Component);
	
		_createClass(UploaderModal, null, [{
			key: 'propTypes',
			value: {
				id: _react2['default'].PropTypes.string,
				type: _react2['default'].PropTypes.string.isRequired,
				step: _react2['default'].PropTypes.number.isRequired,
				uploadInfo: _react2['default'].PropTypes.array,
				uploadId: _react2['default'].PropTypes.string,
				groupId: _react2['default'].PropTypes.string,
				comment: _react2['default'].PropTypes.string,
				error: _react2['default'].PropTypes.bool,
				done: _react2['default'].PropTypes.bool,
				dispatch: _react2['default'].PropTypes.any,
				onSelectDocuments: _react2['default'].PropTypes.func,
				disableUploadToOracle: _react2['default'].PropTypes.bool,
				unallocatedFiles: _react2['default'].PropTypes.array,
				claimWizardDocType: _react2['default'].PropTypes.string,
				isUnfinishedClaim: _react2['default'].PropTypes.bool
			},
			enumerable: true
		}]);
	
		function UploaderModal(props) {
			var _this = this;
	
			_classCallCheck(this, UploaderModal);
	
			_get(Object.getPrototypeOf(UploaderModal.prototype), 'constructor', this).call(this, props);
			//handle groupTypeOptions when refreshing the page
	
			this.onSelectedTarificationDocuments = function (tarificationDocuments) {
				_this.setState({ isTarificationModalOpen: false, clientTarificationsList: [] });
				_this.addFiles(tarificationDocuments);
			};
	
			var groupTypeOptions = [];
			var actGroup = [];
			var groupType = "";
			if (props && props.groupId && props.uploadInfo) {
				if (props.groupId) {
					actGroup = props.uploadInfo.filter(function (item) {
						return item.id === props.groupId;
					})[0];
				}
	
				if (actGroup) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = actGroup.fileTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var oneFileType = _step.value;
	
							if (oneFileType.max && oneFileType.max > 0 && (!oneFileType.files || oneFileType.files.length < oneFileType.max)) {
								groupTypeOptions.push({
									label: oneFileType.title[global.lang],
									value: oneFileType.id
								});
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator['return']) {
								_iterator['return']();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				}
			}
	
			if (props.type === 'claim' && props.claimWizardDocType) {
				groupType = '1';
			}
	
			this.state = {
				drag: false, error: null, isUploading: false, groupType: groupType,
				isOpenAreYouSureModal: false, forceCloseDatepicker: false, dateOpen: false,
				clientTarificationsList: [], groupTypeOptions: groupTypeOptions
			};
		}
	
		_createClass(UploaderModal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _props = this.props;
				var type = _props.type;
				var claimWizardDocType = _props.claimWizardDocType;
	
				if (type === 'claim' && claimWizardDocType) {
					this.modalNext();
				}
			}
	
			// not used should delete
		}, {
			key: 'addFilesToUpload',
			value: function addFilesToUpload(item) {
				var _props2 = this.props;
				var type = _props2.type;
				var id = _props2.id;
				var dispatch = _props2.dispatch;
	
				dispatch((0, _stateActions.initAdditionalUpload)(type, id, item));
			}
	
			/**
	   * Close modal an reset the flags
	   */
		}, {
			key: 'closeModal',
			value: function closeModal() {
				var dispatch = this.props.dispatch;
	
				this.setState({ isUploading: false });
	
				// reset the file list to avoid a false enable of upload button
				currentFiles = {};
	
				dispatch((0, _stateActions.hideUploadModal)());
	
				this.onSelectDocuments();
			}
		}, {
			key: 'onDragEnter',
			value: function onDragEnter() {
				this.setState({ drag: true });
			}
		}, {
			key: 'onDragLeave',
			value: function onDragLeave() {
				this.setState({ drag: false });
			}
	
			/**
	   * This function add a file to the upload list.
	   *
	   * There was an insecure solution for generating preview. What is eliminated.
	   * If you put it back to use URL.createObjectURL(file) to generate preview please
	   * use the following code as an event hook in react-dropzone to prevent memory leaks.
	   *        cleanup = {() => {
	   *             // Revoke data uris when done using the previews
	   *             URL.revokeObjectURL(file.preview);
	   *         }}
	   * @param {*} fileType
	   * @param {*} files
	   * @returns
	   */
		}, {
			key: 'addFiles',
			value: function addFiles(files) {
				var dispatch, outFiles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, file, fileId, tmp, today;
	
				return regeneratorRuntime.async(function addFiles$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							dispatch = this.props.dispatch;
							outFiles = [];
							_iteratorNormalCompletion2 = true;
							_didIteratorError2 = false;
							_iteratorError2 = undefined;
							context$2$0.prev = 5;
							_iterator2 = files[Symbol.iterator]();
	
						case 7:
							if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
								context$2$0.next = 27;
								break;
							}
	
							file = _step2.value;
							fileId = (0, _uuidV42['default'])();
							tmp = undefined;
							today = (0, _moment2['default'])();
	
							if (!(file.tarificationDocId && file.origin === 'DS_ORIGIN_ORACLE')) {
								context$2$0.next = 16;
								break;
							}
	
							tmp = {
								name: file.tarificationDocType,
								lastModified: today,
								size: '',
								origin: file.origin,
								progress: 0,
								fileId: file.tarificationDocId,
								documentTypeIdx: file.documentTypeIdx,
								documentToLowValue: file.documentToLowValue,
								typeDocument: file.typeDocument
							};
							context$2$0.next = 23;
							break;
	
						case 16:
							tmp = {
								name: file.name,
								lastModified: today,
								size: file.size,
								//preview: file.preview,
								type: file.type.split("/").splice(-1)[0],
								progress: 0,
								fileId: fileId
							};
	
							if (!(tmp.size > 10 * 1024 * 1024)) {
								context$2$0.next = 20;
								break;
							}
	
							tmp.error = _('too_large_file');
	
							return context$2$0.abrupt('return', false);
	
						case 20:
							if (!(tmp.size == 0)) {
								context$2$0.next = 23;
								break;
							}
	
							tmp.error = _('file_is_empty_maybe_compressed');
	
							return context$2$0.abrupt('return', false);
	
						case 23:
	
							//error is wrong file type
							if (/^(jpe?g|gif|png|pdf|tiff?)$/.test(tmp.type) || /^(|(x-)?download)$/.test(tmp.type) && /\.(jpe?g|gif|png|pdf|tiff?)$/.test(tmp.name) || file.origin === 'DS_ORIGIN_ORACLE') {
								outFiles = [].concat(_toConsumableArray(outFiles), [tmp]);
								currentFiles[fileId] = file;
							} else {
								tmp.error = _('wrong_file_type');
								outFiles = [].concat(_toConsumableArray(outFiles), [tmp]);
							}
	
						case 24:
							_iteratorNormalCompletion2 = true;
							context$2$0.next = 7;
							break;
	
						case 27:
							context$2$0.next = 33;
							break;
	
						case 29:
							context$2$0.prev = 29;
							context$2$0.t0 = context$2$0['catch'](5);
							_didIteratorError2 = true;
							_iteratorError2 = context$2$0.t0;
	
						case 33:
							context$2$0.prev = 33;
							context$2$0.prev = 34;
	
							if (!_iteratorNormalCompletion2 && _iterator2['return']) {
								_iterator2['return']();
							}
	
						case 36:
							context$2$0.prev = 36;
	
							if (!_didIteratorError2) {
								context$2$0.next = 39;
								break;
							}
	
							throw _iteratorError2;
	
						case 39:
							return context$2$0.finish(36);
	
						case 40:
							return context$2$0.finish(33);
	
						case 41:
							context$2$0.next = 43;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.addFiles)(outFiles)));
	
						case 43:
							//actualize the options list avery time a doc is added
							this.createGroupTypeOptionsList();
							this.setState({ drag: false });
	
						case 45:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this, [[5, 29, 33, 41], [34,, 36, 40]]);
			}
		}, {
			key: 'modalNext',
			value: function modalNext() {
				var groupId, dispatch;
				return regeneratorRuntime.async(function modalNext$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							groupId = this.state.groupType;
	
							if (!groupId) {
								context$2$0.next = 6;
								break;
							}
	
							dispatch = this.props.dispatch;
							context$2$0.next = 5;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.goToFileForm)(groupId)));
	
						case 5:
							this.createGroupTypeOptionsList();
	
						case 6:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this);
			}
	
			/**
	   * This kick back the modal
	   */
		}, {
			key: 'modalBack',
			value: function modalBack() {
				var dispatch = this.props.dispatch;
	
				return dispatch((0, _stateActions.goBackToUploadType)());
			}
		}, {
			key: 'modalSave',
			value: function modalSave() {
				var _props3, dispatch, disableUploadToOracle, uploadComment, comment, result;
	
				return regeneratorRuntime.async(function modalSave$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							_props3 = this.props;
							dispatch = _props3.dispatch;
							disableUploadToOracle = _props3.disableUploadToOracle;
							uploadComment = this.refs.uploadComment;
							comment = uploadComment && uploadComment.value;
							context$2$0.next = 7;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.uploadFiles)(comment, currentFiles, disableUploadToOracle)));
	
						case 7:
							result = context$2$0.sent;
							context$2$0.next = 10;
							return regeneratorRuntime.awrap(this.pushFilesForParentModuleByCallback(result));
	
						case 10:
	
							this.setState({ isUploading: true, error: null });
	
						case 11:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this);
			}
	
			/**
	   * This function is made to handle callback function if exists by uploaded files when the uploader finished his job.
	   * @param {*} uploadResult
	   */
		}, {
			key: 'pushFilesForParentModuleByCallback',
			value: function pushFilesForParentModuleByCallback(uploadResult) {
				var _props4, step, done, onSelectDocuments, comment, groupId, uploadInfo, i, oneResult, resultRecord;
	
				return regeneratorRuntime.async(function pushFilesForParentModuleByCallback$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							_props4 = this.props;
							step = _props4.step;
							done = _props4.done;
							onSelectDocuments = _props4.onSelectDocuments;
							comment = _props4.comment;
							groupId = _props4.groupId;
							uploadInfo = _props4.uploadInfo;
	
							if (!(step === 2 && done && onSelectDocuments && typeof onSelectDocuments === "function")) {
								context$2$0.next = 20;
								break;
							}
	
							i = 0;
	
						case 9:
							if (!(i < uploadResult.length)) {
								context$2$0.next = 20;
								break;
							}
	
							oneResult = uploadResult[i];
	
							if (!(oneResult.status === "fulfilled")) {
								context$2$0.next = 17;
								break;
							}
	
							resultRecord = _nestedProperty2['default'].get(oneResult, "value.response.temporaryFileRecord");
	
							resultRecord['uploadComment'] = comment;
							resultRecord['documentUploadGroupTypeId'] = groupId;
							// call the callback to provide the uploaded file information for external components
							context$2$0.next = 17;
							return regeneratorRuntime.awrap(onSelectDocuments(resultRecord));
	
						case 17:
							i++;
							context$2$0.next = 9;
							break;
	
						case 20:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this);
			}
	
			/**
	   * This function will close the upload popup.
	   */
		}, {
			key: 'cancelUpload',
			value: function cancelUpload() {
				var dispatch = this.props.dispatch;
	
				// reset the file list to avoid a false enable of upload button
				currentFiles = {};
	
				this.setState({ isUploading: false });
	
				dispatch((0, _stateActions.cancelUpload)());
			}
		}, {
			key: 'clickDate',
			value: function clickDate(ev) {
				// ev.stopPropagation()
				// ev.nativeEvent.stopImmediatePropagation()
				// this.setState({ forceCloseDatepicker: false })
			}
		}, {
			key: 'changeDate',
			value: function changeDate(value, file) {
				var filetype = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.changeFileDate)(value, file, filetype));
			}
		}, {
			key: 'removeFile',
			value: function removeFile(ev, file) {
				var fileType = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
				var dispatch;
				return regeneratorRuntime.async(function removeFile$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							ev.stopPropagation();
							ev.nativeEvent.stopImmediatePropagation();
							dispatch = this.props.dispatch;
	
							delete currentFiles[file.fileId];
							context$2$0.next = 6;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.removeFile)(file, fileType)));
	
						case 6:
							this.createGroupTypeOptionsList();
	
						case 7:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this);
			}
		}, {
			key: 'remFileAllocation',
			value: function remFileAllocation(file, filetype) {
				var dispatch;
				return regeneratorRuntime.async(function remFileAllocation$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							dispatch = this.props.dispatch;
	
							this.setState({ error: _defineProperty({}, filetype, null) });
							context$2$0.next = 4;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.unAllocateFile)(file, filetype)));
	
						case 4:
							this.createGroupTypeOptionsList();
	
						case 5:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this);
			}
		}, {
			key: 'updateFormValue',
			value: function updateFormValue(value, field) {
				var dispatch = this.props.dispatch;
	
				dispatch({
					type: "redux-form/CHANGE",
					field: field.name,
					value: value && value.value || '',
					touch: value && value.touched || field.touched,
					form: "emailSender"
				});
	
				this.forceUpdate();
			}
	
			/**
	   * This function set the field value content in store
	   *
	   * @param {*} value
	   */
		}, {
			key: 'onChangeCommentValue',
			value: function onChangeCommentValue(value) {
				var dispatch = this.props.dispatch;
	
				dispatch((0, _stateActions.updateCommentOnFileUpload)(value.target.value));
			}
		}, {
			key: 'onNavigateBack',
			value: function onNavigateBack(fileTypes, comment) {
				if (fileTypes.find(function (i) {
					return i.files && i.files.length > 0;
				}) || comment) {
					return this.openAreYouSureModal();
				}
				return this.modalBack();
			}
	
			/**
	   * Open ask modal
	   *
	   * @param {*} e
	   */
		}, {
			key: 'openAreYouSureModal',
			value: function openAreYouSureModal(e) {
				this.setState({ isOpenAreYouSureModal: true });
			}
	
			/**
	   * Close ask modal
	   */
		}, {
			key: 'closeAreYouSureModal',
			value: function closeAreYouSureModal() {
				this.setState({ isOpenAreYouSureModal: false });
			}
		}, {
			key: 'handleScroll',
			value: function handleScroll(e) {
				var forceCloseDatepicker = this.state.forceCloseDatepicker;
	
				if (!forceCloseDatepicker) {
					this.setState({ forceCloseDatepicker: true });
				}
			}
	
			/**
	   * Method used in the tarification documents selection modal
	   * @param {*} item
	   * @param {*} tarificationDocuments
	   */
		}, {
			key: 'onOpenTarificationModalClick',
			value: function onOpenTarificationModalClick(indexTypes) {
				var _props5, dispatch, clientId, indexTypesIds, fetchTarificationsRequest;
	
				return regeneratorRuntime.async(function onOpenTarificationModalClick$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							_props5 = this.props;
							dispatch = _props5.dispatch;
							clientId = _props5.clientId;
							indexTypesIds = indexTypes.map(function (oneType) {
								return oneType.id;
							});
							context$2$0.prev = 4;
							context$2$0.next = 7;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.fetchUploadTarifications)(clientId)));
	
						case 7:
							fetchTarificationsRequest = context$2$0.sent;
	
							this.setState({
								clientTarificationsList: fetchTarificationsRequest.tarifications,
								isTarificationModalOpen: indexTypesIds
							});
	
							context$2$0.next = 14;
							break;
	
						case 11:
							context$2$0.prev = 11;
							context$2$0.t0 = context$2$0['catch'](4);
	
							console.warn(context$2$0.t0);
	
						case 14:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this, [[4, 11]]);
			}
		}, {
			key: 'onAllocateFileToType',
			value: function onAllocateFileToType(file, value) {
				var currentFileType = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
				var dispatch;
				return regeneratorRuntime.async(function onAllocateFileToType$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							dispatch = this.props.dispatch;
							context$2$0.next = 3;
							return regeneratorRuntime.awrap(dispatch((0, _stateActions.allocateFiles)(value, file)));
	
						case 3:
							if (!currentFileType) {
								context$2$0.next = 6;
								break;
							}
	
							context$2$0.next = 6;
							return regeneratorRuntime.awrap(this.remFileAllocation(file, currentFileType));
	
						case 6:
							this.createGroupTypeOptionsList();
	
						case 7:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this);
			}
		}, {
			key: 'createGroupTypeOptionsList',
			value: function createGroupTypeOptionsList() {
				var _props6 = this.props;
				var groupId = _props6.groupId;
				var uploadInfo = _props6.uploadInfo;
				var isUnfinishedClaim = _props6.isUnfinishedClaim;
				var claimWizardDocType = _props6.claimWizardDocType;
	
				var actGroup = null;
				var groupTypeOptions = [];
	
				if (groupId) {
					actGroup = uploadInfo.filter(function (item) {
						return item.id === groupId;
					})[0];
				}
	
				if (actGroup) {
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;
	
					try {
						for (var _iterator3 = actGroup.fileTypes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var oneFileType = _step3.value;
	
							if ((oneFileType.max && oneFileType.max > 0 || (isUnfinishedClaim || claimWizardDocType) && groupId == '1') && (!oneFileType.files || oneFileType.files.length < oneFileType.max || (isUnfinishedClaim || claimWizardDocType) && groupId == '1')) {
								groupTypeOptions.push({
									label: oneFileType.title[global.lang],
									value: oneFileType.id
								});
							}
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3['return']) {
								_iterator3['return']();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}
				}
				groupTypeOptions.sort(function (a, b) {
					var nameA = a.label.toUpperCase(); // Ignore case
					var nameB = b.label.toUpperCase(); // Ignore case
	
					if (nameA < nameB) {
						return -1;
					}
	
					if (nameA > nameB) {
						return 1;
					}
	
					// Names are equal
					return 0;
				});
	
				this.setState({ groupTypeOptions: groupTypeOptions });
			}
		}, {
			key: 'renderUnallocatedFiles',
			value: function renderUnallocatedFiles(files) {
				var _this2 = this;
	
				var step = this.props.step;
				var _state = this.state;
				var forceCloseDatepicker = _state.forceCloseDatepicker;
				var groupTypeOptions = _state.groupTypeOptions;
	
				var ul = files.map(function (file, i) {
					return _react2['default'].createElement(
						'div',
						{ key: '' + (file.fileId || file.documentId) + i, className: _uploaderScss2['default'].dropzoneFile },
						step === 1 && _react2['default'].createElement(
							'div',
							{
								onClick: function (ev) {
									return _this2.removeFile(ev, file);
								},
								className: _uploaderScss2['default'].remove
							},
							file.name && _react2['default'].createElement('img', { src: __webpack_require__(949) })
						),
						_react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].preview },
							_react2['default'].createElement(
								'div',
								null,
								_react2['default'].createElement(FileIcon, { file: file })
							)
						),
						file.name ? _react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].name },
							file.name
						) : _react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].name },
							file.documentDate
						),
						step === 1 && file.name && !file.error && _react2['default'].createElement(_sharedSelectSelectWrap2['default'], {
							className: (0, _classnames2['default'])(_uploaderScss2['default'].formInput, _uploaderScss2['default'].sizeL),
							value: file.typeId || '',
							isClearable: true,
							options: groupTypeOptions,
							placeholder: _('typePlaceholder'),
							onChange: function (value) {
								_this2.onAllocateFileToType(file, value.value);
							}
						}),
						step === 1 && file.error && _react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].progressBarContainer },
							_react2['default'].createElement(FileProgress, { file: file })
						)
					);
				});
				return ul;
			}
	
			/**
	  * Used to render the drop zones dynamically in juncture with the new tarification selection modal
	  * @param {*} item
	  * @param {*} groupId
	  * @returns
	  */
		}, {
			key: 'renderDropZone',
			value: function renderDropZone(groupId, actGroup) {
				var _this3 = this;
	
				//the upload group that handles tarification index mapping is 27 (BEWB - 593)
				if (groupId === '27') {
					return _react2['default'].createElement(
						'div',
						{ className: _uploaderScss2['default'].mandateDropZoneWrapper },
						_react2['default'].createElement(
							'div',
							{
								style: { minHeight: 60 },
								className: _uploaderScss2['default'].dropzone + " " + (this.state.drag && _uploaderScss2['default'].drag),
								onDragEnter: function () {
									return _this3.onDragEnter(null);
								},
								onDragLeave: function () {
									return _this3.onDragLeave();
								},
								onDrop: function (ev) {
									return _this3.addFiles(ev);
								},
								onClick: function () {
									return _this3.onOpenTarificationModalClick(actGroup.fileTypes);
								}
								// disableClick={this.state.isUploading || (item.files && item.files.length >= item.max)}
							},
							_react2['default'].createElement(
								'div',
								{ className: _uploaderScss2['default'].dropzonePlaceholder },
								_('tarificationSelectorPlaceholder')
							)
						),
						_react2['default'].createElement(
							_reactDropzone2['default'],
							{
								style: { minHeight: 60 },
								className: _uploaderScss2['default'].dropzone + " " + (this.state.drag && _uploaderScss2['default'].drag),
								onDragEnter: function () {
									return _this3.onDragEnter();
								},
								onDragLeave: function () {
									return _this3.onDragLeave();
								},
								onDrop: function (ev) {
									return _this3.addFiles(ev);
								}
								// disableClick={this.state.isUploading || (item.files && item.files.length >= item.max)}
							},
							_react2['default'].createElement(
								'div',
								{ className: _uploaderScss2['default'].dropzonePlaceholder },
								_('filePlaceholder')
							)
						)
					);
				} else {
					return _react2['default'].createElement(
						_reactDropzone2['default'],
						{
							style: { minHeight: 60 },
							className: _uploaderScss2['default'].dropzone + " " + (this.state.drag && _uploaderScss2['default'].drag),
							onDragEnter: function () {
								return _this3.onDragEnter();
							},
							onDragLeave: function () {
								return _this3.onDragLeave();
							},
							onDrop: function (ev) {
								return _this3.addFiles(ev);
							}
							// disableClick={this.state.isUploading || (item.files && item.files.length >= item.max)}
						},
						_react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].dropzonePlaceholder },
							_('filePlaceholder')
						)
					);
				}
			}
		}, {
			key: 'renderListOfAllocatedDocuments',
			value: function renderListOfAllocatedDocuments(actGroup) {
				var _this4 = this;
	
				var _props7 = this.props;
				var step = _props7.step;
				var error = _props7.error;
				var _state2 = this.state;
				var forceCloseDatepicker = _state2.forceCloseDatepicker;
				var groupTypeOptions = _state2.groupTypeOptions;
	
				var ul = actGroup.fileTypes.map(function (oneType, i) {
					if (oneType && oneType.files && oneType.files.length > 0) {
						return _react2['default'].createElement(
							'div',
							{ key: oneType.id + i },
							_react2['default'].createElement(
								'div',
								{ className: _uploaderScss2['default'].dropTypeTitle },
								oneType.title[global.lang] + ' ',
								_react2['default'].createElement(
									'span',
									{ className: _uploaderScss2['default'].filesCount },
									_this4.state.error && _this4.state.error[oneType.id] && _react2['default'].createElement(
										'span',
										{ className: _uploaderScss2['default'].uploadError },
										_this4.state.error[oneType.id]
									),
									oneType.max > 0 && _react2['default'].createElement(
										'span',
										null,
										oneType.files ? oneType.files.length : 0,
										'/',
										oneType.max
									)
								)
							),
							oneType.files && oneType.files.length > 0 && _react2['default'].createElement(
								'div',
								{ className: _uploaderScss2['default'].dropzoneFiles },
								oneType.files.map(function (file) {
									return _react2['default'].createElement(
										'div',
										{ key: file.fileId || file.documentId, className: _uploaderScss2['default'].dropzoneFile },
										step === 1 && _react2['default'].createElement(
											'div',
											{
												onClick: function (ev) {
													return _this4.removeFile(ev, file, oneType.id);
												},
												className: _uploaderScss2['default'].remove
											},
											file.name && _react2['default'].createElement('img', { src: __webpack_require__(949) })
										),
										_react2['default'].createElement(
											'div',
											{ className: _uploaderScss2['default'].preview },
											_react2['default'].createElement(
												'div',
												null,
												_react2['default'].createElement(FileIcon, { file: file })
											)
										),
										file.name ? _react2['default'].createElement(
											'div',
											{ className: _uploaderScss2['default'].name },
											file.name
										) : _react2['default'].createElement(
											'div',
											{ className: _uploaderScss2['default'].name },
											file.documentDate
										),
										step === 1 && file.name && !file.error && _react2['default'].createElement(_sharedSelectSelectWrap2['default'], {
											className: (0, _classnames2['default'])(_uploaderScss2['default'].formInput, _uploaderScss2['default'].sizeL),
											value: file.typeId || '',
											isClearable: true,
											options: groupTypeOptions,
											placeholder: _('typePlaceholder'),
											onChange: function (value) {
												if (value.value === oneType.id) {
													return;
												}
	
												_this4.onAllocateFileToType(file, value.value, oneType.id);
											}
										}),
										step === 1 && file.error && _react2['default'].createElement(
											'div',
											{ className: _uploaderScss2['default'].progressBarContainer },
											_react2['default'].createElement(FileProgress, { file: file })
										),
										step === 2 && file.name && _react2['default'].createElement(
											'div',
											{ className: _uploaderScss2['default'].progressBarContainer },
											_react2['default'].createElement(FileProgress, { file: file })
										)
									);
								})
							)
						);
					}
				});
				return ul;
			}
		}, {
			key: 'getIcon',
			value: function getIcon() {
				try {
					return __webpack_require__(527);
				} catch (err) {
					return __webpack_require__(23);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var _props8 = this.props;
				var type = _props8.type;
				var step = _props8.step;
				var groupId = _props8.groupId;
				var uploadId = _props8.uploadId;
				var uploadInfo = _props8.uploadInfo;
				var comment = _props8.comment;
				var error = _props8.error;
				var done = _props8.done;
				var id = _props8.id;
				var clientId = _props8.clientId;
				var dispatch = _props8.dispatch;
				var unallocatedFiles = _props8.unallocatedFiles;
				var claimWizardDocType = _props8.claimWizardDocType;
				var _state3 = this.state;
				var groupType = _state3.groupType;
				var isOpenAreYouSureModal = _state3.isOpenAreYouSureModal;
				var isTarificationModalOpen = _state3.isTarificationModalOpen;
				var clientTarificationsList = _state3.clientTarificationsList;
	
				var actGroup = null;
	
				var initialOptions = [{ value: '', label: _('selectGroupType') }].concat(uploadInfo.map(function (_ref3) {
					var id = _ref3.id;
					var title = _ref3.title;
					return { value: id, label: title[global.lang] };
				}));
	
				if (groupId) {
					actGroup = uploadInfo.filter(function (item) {
						return item.id === groupId;
					})[0];
				}
	
				var canUpload = true;
	
				if (Object.keys(currentFiles).length === 0) {
					canUpload = false;
				}
	
				if (unallocatedFiles && unallocatedFiles.length > 0) {
					canUpload = false;
				}
	
				if (actGroup) {
					var _iteratorNormalCompletion4 = true;
					var _didIteratorError4 = false;
					var _iteratorError4 = undefined;
	
					try {
						for (var _iterator4 = actGroup.fileTypes[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
							var item = _step4.value;
	
							if (item.min !== 0) {
								if (!item.files || item.files && item.min > item.files.length) {
									canUpload = false;
								}
							}
						}
					} catch (err) {
						_didIteratorError4 = true;
						_iteratorError4 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion4 && _iterator4['return']) {
								_iterator4['return']();
							}
						} finally {
							if (_didIteratorError4) {
								throw _iteratorError4;
							}
						}
					}
				} else {
					canUpload = false;
				}
	
				var canExit = true;
				if (actGroup) {
					var _iteratorNormalCompletion5 = true;
					var _didIteratorError5 = false;
					var _iteratorError5 = undefined;
	
					try {
						for (var _iterator5 = actGroup.fileTypes[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
							var item = _step5.value;
	
							if (item.files) {
								var _iteratorNormalCompletion6 = true;
								var _didIteratorError6 = false;
								var _iteratorError6 = undefined;
	
								try {
									for (var _iterator6 = item.files[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
										var file = _step6.value;
	
										if (file.progress < 1) {
											canExit = false;
											break;
										}
									}
								} catch (err) {
									_didIteratorError6 = true;
									_iteratorError6 = err;
								} finally {
									try {
										if (!_iteratorNormalCompletion6 && _iterator6['return']) {
											_iterator6['return']();
										}
									} finally {
										if (_didIteratorError6) {
											throw _iteratorError6;
										}
									}
								}
							} else if (item.min > 0) {
								canExit = false;
							}
						}
					} catch (err) {
						_didIteratorError5 = true;
						_iteratorError5 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion5 && _iterator5['return']) {
								_iterator5['return']();
							}
						} finally {
							if (_didIteratorError5) {
								throw _iteratorError5;
							}
						}
					}
				} else {
					canExit = false;
				}
				return _react2['default'].createElement(
					'div',
					{ onWheel: function (e) {
							return _this5.handleScroll(e);
						} },
					step === 0 && _react2['default'].createElement(
						'div',
						{ className: _uploaderScss2['default'].modalHeader },
						_react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].title },
							_('addDocuments')
						)
					),
					step >= 1 && _react2['default'].createElement(
						'div',
						{ className: _uploaderScss2['default'].title },
						actGroup.title[global.lang]
					),
					_react2['default'].createElement(
						'div',
						{ className: _uploaderScss2['default'].commentWrapper },
						step > 0 && (type === 'claim' || type === 'contract' || type === 'tarification') && (!uploadId || uploadId && !(comment === '')) && _react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].uploadComment },
							_react2['default'].createElement(
								'div',
								{ className: _uploaderScss2['default'].uploadCommentTitle },
								_react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: _('comment') } })
							),
							_react2['default'].createElement('textarea', {
								ref: 'uploadComment',
								disabled: uploadId,
								className: uploadId ? _uploaderScss2['default'].disabled : '',
								value: String(comment || ''),
								onChange: function (value) {
									_this5.onChangeCommentValue(value);
								}
							})
						),
						step > 0 && type === 'client' && _react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].uploadComment },
							_react2['default'].createElement(
								'div',
								{ className: _uploaderScss2['default'].uploadCommentTitle },
								_react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: _('clientComment') } })
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: _uploaderScss2['default'].contentWrapper },
						_react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].content },
							step === 0 && _react2['default'].createElement(_sharedSelectSelectWrap2['default'], {
								value: groupType,
								options: initialOptions,
								onChange: function (value) {
									_this5.setState({ groupType: value.value });
								},
								className: _uploaderScss2['default'].step0Select
							}),
							step > 0 && _react2['default'].createElement(
								'div',
								{ className: _uploaderScss2['default'].fileForm },
								_react2['default'].createElement(
									'div',
									{ className: _uploaderScss2['default'].dropZoneContainer },
									_react2['default'].createElement(
										'div',
										{
											style: { minHeight: 60 },
											className: _uploaderScss2['default'].dropzone
											// onDragEnter={() => this.onDragEnter()}
											// onDragLeave={() => this.onDragLeave()}
											// onDrop={(ev) => this.addFiles(ev)}
											// // disableClick={this.state.isUploading || (item.files && item.files.length >= item.max)}
											// disableClick={true}
										},
										_react2['default'].createElement(
											'div',
											{ className: _uploaderScss2['default'].documentsContainer },
											_react2['default'].createElement(
												'div',
												{ className: _uploaderScss2['default'].unprocessedDocumentsWrapper },
												_react2['default'].createElement(
													'div',
													{ className: _uploaderScss2['default'].dropzoneFiles },
													_react2['default'].createElement(
														'div',
														{ className: _uploaderScss2['default'].dropType },
														this.renderDropZone(groupId, actGroup)
													),
													this.renderUnallocatedFiles(unallocatedFiles)
												)
											),
											_react2['default'].createElement(
												'div',
												null,
												this.renderListOfAllocatedDocuments(actGroup)
											)
										),
										_react2['default'].createElement(
											'div',
											{ className: _uploaderScss2['default'].docTypesContainer },
											actGroup.fileTypes.map(function (oneType, i) {
												return _react2['default'].createElement(
													'div',
													{ key: '' + oneType.id + i, className: _uploaderScss2['default'].dropType },
													_react2['default'].createElement(
														'div',
														{ className: _uploaderScss2['default'].dropTypeTitle },
														_react2['default'].createElement(
															'span',
															{ className: _uploaderScss2['default'].filesCount },
															_this5.state.error && _this5.state.error[oneType.id] && _react2['default'].createElement(
																'span',
																{ className: _uploaderScss2['default'].uploadError },
																_this5.state.error[oneType.id]
															),
															oneType.max > 0 && _react2['default'].createElement(
																'span',
																{
																	className: oneType.min && (!oneType.files || oneType.files.length < oneType.min) ? _uploaderScss2['default'].uploadError : ''
																},
																oneType.min ? _react2['default'].createElement(
																	'div',
																	null,
																	!oneType.files || oneType.files.length < oneType.min ? _react2['default'].createElement(
																		'span',
																		null,
																		oneType.files ? oneType.files.length : 0,
																		'/',
																		oneType.max
																	) : _react2['default'].createElement('img', { src: _this5.getIcon() })
																) : _react2['default'].createElement(
																	'span',
																	null,
																	oneType.files ? oneType.files.length : 0,
																	'/',
																	oneType.max
																)
															)
														),
														_react2['default'].createElement(
															'p',
															{
																className: oneType.min && (!oneType.files || oneType.files.length < oneType.min) ? _uploaderScss2['default'].uploadError : ''
															},
															oneType.title[global.lang]
														)
													)
												);
											})
										)
									)
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: _uploaderScss2['default'].buttons },
							(step !== 2 || step === 2 && error) && _react2['default'].createElement(
								'div',
								{ onClick: function () {
										return _this5.cancelUpload();
									}, className: _uploaderScss2['default'].cancel },
								_('cancel')
							),
							step === 0 && _react2['default'].createElement(
								'div',
								{ onClick: function () {
										return _this5.modalNext();
									}, className: _uploaderScss2['default'].next + " " + _uploaderScss2['default'].enabled },
								_('next')
							),
							step === 1 && !(type === 'claim' && claimWizardDocType) && _react2['default'].createElement(
								'div',
								{ onClick: function () {
										_this5.onNavigateBack(actGroup.fileTypes, comment);
									}, className: (0, _classnames2['default'])(_uploaderScss2['default'].next, _uploaderScss2['default'].enabled) },
								_('back')
							),
							(step === 1 || step === 2 && !done) && !error && _react2['default'].createElement(
								'div',
								{
									onClick: function callee$2$0() {
										return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
											while (1) switch (context$3$0.prev = context$3$0.next) {
												case 0:
													if (canUpload) {
														this.modalSave();
													}
	
													return context$3$0.abrupt('return');
	
												case 2:
												case 'end':
													return context$3$0.stop();
											}
										}, null, _this5);
									},
									className: _uploaderScss2['default'].next + " " + (canUpload && _uploaderScss2['default'].enabled)
								},
								error ? _('retry') : _('save')
							),
							step === 2 && done && !error && _react2['default'].createElement(
								'div',
								{
									onClick: function () {
										return done && _this5.cancelUpload();
									},
									className: _uploaderScss2['default'].next + " " + (done && _uploaderScss2['default'].enabled)
								},
								_('exit')
							)
						)
					),
					_react2['default'].createElement(_officeAreYouSureModal2['default'], {
						modalIsOpen: isOpenAreYouSureModal,
						title: _("areYouSureToGoBackTitle"),
						message: _("areYouSureToGoBackMessage"),
						cancelLabel: _("cancel"),
						confirmationLabel: _("goBack"),
						onCancel: function () {
							_this5.closeAreYouSureModal();
						},
						onConfirmation: function (toEmailAddress) {
							return _this5.modalBack().then(function () {
								_this5.closeAreYouSureModal();
							});
						}
					}),
					_react2['default'].createElement(_tarificationSelectionModal2['default'], {
						modalIsOpen: isTarificationModalOpen,
						onCancel: function () {
							return _this5.setState({ isTarificationModalOpen: false });
						},
						dispatch: dispatch,
						clientId: clientId,
						method: this.onSelectedTarificationDocuments,
						clientTarificationsList: clientTarificationsList
					})
				);
			}
		}]);
	
		return UploaderModal;
	})(_react2['default'].Component);
	
	exports['default'] = UploaderModal;
	module.exports = exports['default'];

	//create a unique identifier

	// push the uploaded file list for the parent module what is using the uploader

	// check if there is a callback to provide the list of uploaded files

	// oneResult: {status: ..., value: ...}
	// possible statuses: 'fulfilled', 'rejected'
	/* {step === 1 && file.name && !file.error &&
	<div className={styles.date} onClick={(ev) => this.clickDate(ev)} >
		<DatePicker
			forceCloseDatepicker={{
				forceClose: forceCloseDatepicker,
				cb: () => this.setState({ forceCloseDatepicker: false })
			}}
			onChange={(value) => this.changeDate(value, file)}
			value={file.lastModified}
			maxDate={moment().toString()}
		/>
	</div>
	} */ /* list of unprocessed documents */ /* list of processed documents */ /*  BEWB - 247  Removed mifid button  from upload modal */ /* {type === 'contract' && canCreateMifid && false &&
	                                                                                                                                                           <MifidButton
	                                                                                                                                                               moduleKeyToSet={DS_MODULE_CLIENT_CONTRACT}
	                                                                                                                                                               clientId={clientId}
	                                                                                                                                                               contractId={id}
	                                                                                                                                                               callBackOnClose={()=>{}}
	                                                                                                                                                               disabled={!id}
	                                                                                                                                                               forceGetClient={true}
	                                                                                                                                                           />
	                                                                                                                                                       } */
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable react/jsx-handler-names */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stateActions = __webpack_require__(5);
	
	var _lodashCollection = __webpack_require__(55);
	
	var _reactCollapse = __webpack_require__(467);
	
	var _reactCollapse2 = _interopRequireDefault(_reactCollapse);
	
	var _refreshBtn = __webpack_require__(174);
	
	var _refreshBtn2 = _interopRequireDefault(_refreshBtn);
	
	var _libHelpers = __webpack_require__(24);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _componentsUploaderUploaderTableComment = __webpack_require__(1152);
	
	var _resourcesImagesPdfIcon_1xPng = __webpack_require__(172);
	
	var _resourcesImagesPdfIcon_1xPng2 = _interopRequireDefault(_resourcesImagesPdfIcon_1xPng);
	
	var _resourcesImagesPClose_1xPng = __webpack_require__(1003);
	
	var _resourcesImagesPClose_1xPng2 = _interopRequireDefault(_resourcesImagesPClose_1xPng);
	
	var _resourcesIcnFolderSvg = __webpack_require__(2262);
	
	var _resourcesIcnFolderSvg2 = _interopRequireDefault(_resourcesIcnFolderSvg);
	
	var _resourcesUploadSvg = __webpack_require__(2321);
	
	var _resourcesUploadSvg2 = _interopRequireDefault(_resourcesUploadSvg);
	
	var _resourcesIcnUploadLockSvg = __webpack_require__(2264);
	
	var _resourcesIcnUploadLockSvg2 = _interopRequireDefault(_resourcesIcnUploadLockSvg);
	
	var _resourcesIcnPlusSvg = __webpack_require__(353);
	
	var _resourcesIcnPlusSvg2 = _interopRequireDefault(_resourcesIcnPlusSvg);
	
	var _reactMeasure = __webpack_require__(2055);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _reactableScss = __webpack_require__(101);
	
	var _reactableScss2 = _interopRequireDefault(_reactableScss);
	
	var _uploaderScss = __webpack_require__(305);
	
	var _uploaderScss2 = _interopRequireDefault(_uploaderScss);
	
	var _ = (0, _libI18n2["default"])("uploader");
	
	var CommentIcon = function CommentIcon() {
	    return _react2["default"].createElement(
	        "svg",
	        {
	            xmlns: "http://www.w3.org/2000/svg",
	            height: "24",
	            viewBox: "0 -960 960 960",
	            width: "24",
	            fill: "#898E91"
	        },
	        _react2["default"].createElement("path", {
	            d: "M260-420h280v-40H260v40Zm0-120h440v-40H260v40Zm0-120h440v-40H260v40ZM120-156.923v-618.462Q120-803 138.5-821.5 157-840 184.615-840h590.77Q803-840 821.5-821.5 840-803 840-775.385v430.77Q840-317 821.5-298.5 803-280 775.385-280H243.077L120-156.923ZM226-320h549.385q9.23 0 16.923-7.692Q800-335.385 800-344.615v-430.77q0-9.23-7.692-16.923Q784.615-800 775.385-800h-590.77q-9.23 0-16.923 7.692Q160-784.615 160-775.385v521.154L226-320Zm-66 0v-480 480Z"
	        })
	    );
	};
	
	var UploaderTable = (function (_Component) {
	    _inherits(UploaderTable, _Component);
	
	    function UploaderTable(props) {
	        _classCallCheck(this, UploaderTable);
	
	        _get(Object.getPrototypeOf(UploaderTable.prototype), "constructor", this).call(this, props);
	
	        this.isUserCommentCellClick = function (event) {
	            var preventNavigation = false;
	            var target = event.target;
	
	            var textareaEl = target.querySelector("textarea") || target;
	            if ((textareaEl && textareaEl.name) === "user_comment_textarea") {
	                preventNavigation = true;
	            }
	            return preventNavigation;
	        };
	
	        this.resolveDocumentComment = function (file) {
	            var commentValue = '';
	            var commentKey = null;
	            var commentKeys = ['clientDocumentBemComment', 'contractDocumentBemComment', 'tarificationDocBemComment', 'documentBemComment'];
	            commentKeys.forEach(function (key) {
	                if (Object.prototype.hasOwnProperty.call(file, key)) {
	                    commentKey = key;
	                    commentValue = file[key];
	                    return;
	                }
	            });
	            return { commentKey: commentKey, commentValue: commentValue };
	        };
	
	        this.state = {
	            isClosed: {},
	            selected: props.selected || [],
	            documentMetaCol: 0, // width of the document meta cell
	            documentCheckBox: 0, // width of the document checkbox cell
	            documentTypeCol: 0, // width of the document type cell
	            documentDateCol: 0, // width of the document date cell
	            userComment: 0 };
	    }
	
	    /**
	     * This function is unused maybe should delete it.
	     * @param {*} item 
	     */
	
	    _createClass(UploaderTable, [{
	        key: "addFilesToUpload",
	        // width of the user comment cell
	        value: function addFilesToUpload(item) {
	            var _props = this.props;
	            var type = _props.type;
	            var id = _props.id;
	            var dispatch = _props.dispatch;
	
	            dispatch((0, _stateActions.initAdditionalUpload)(type, id, item));
	        }
	    }, {
	        key: "switch",
	        value: function _switch(id) {
	            this.setState({
	                isClosed: _extends({}, this.state.isClosed, _defineProperty({}, id, !this.state.isClosed[id]))
	            });
	        }
	    }, {
	        key: "displayDate",
	        value: function displayDate(date) {
	            var d = new Date(date);
	            return ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + d.getFullYear();
	        }
	
	        /**
	         * Thanks to legacy code, we have to log the width of the cell to avoid the overflow of the text.
	         * @param {object} dimensions { width: number, height: number}
	         * @param {string} cellName  "documentMetaCol" | "documentCheckBox" | "documentTypeCol" | "documentDateCol" | "userComment"
	         */
	    }, {
	        key: "logCellWidth",
	        value: function logCellWidth(_ref, cellName) {
	            var width = _ref.width;
	
	            var cellWidth = this.state[cellName];
	            if (cellWidth !== width) {
	                this.setState(_defineProperty({}, cellName, width));
	            }
	        }
	    }, {
	        key: "onSelectDoc",
	        value: function onSelectDoc(requiredValues) {
	            var _this = this;
	
	            var selectedUpdaterCallback = this.props.selectedUpdaterCallback;
	            var selected = this.state.selected;
	
	            var index = -1;
	            var newSelectedList = [];
	
	            selected.forEach(function (val, i) {
	                newSelectedList.push(val);
	                if (val.id === String(requiredValues.id)) {
	                    index = i;
	                }
	            });
	
	            if (index === -1) {
	                newSelectedList.push(requiredValues);
	            } else {
	                newSelectedList.splice(index, 1);
	            }
	
	            this.setState({ selected: newSelectedList }, function () {
	                if (selectedUpdaterCallback && typeof selectedUpdaterCallback === "function") {
	                    selectedUpdaterCallback(_this.state.selected);
	                }
	            });
	        }
	    }, {
	        key: "opendDocumentInNewWindow",
	        value: function opendDocumentInNewWindow(item) {
	            if (item.document) {
	                window.open("/data/document?id=" + item.uploadId + "&docType=" + encodeURI(item.type) + "&uploadDate=" + encodeURI(item.uploadDate), "_blank", 'noopener,noreferrer');
	            } else if (item.amount >= 1) {
	                this["switch"](item.uploadId);
	            }
	        }
	
	        /**
	         * This function handle the refresh functionality, update the selection list also for the parent module.
	         */
	    }, {
	        key: "handleRefreshTable",
	        value: function handleRefreshTable() {
	            var _this2 = this;
	
	            var _props2 = this.props;
	            var selectedUpdaterCallback = _props2.selectedUpdaterCallback;
	            var type = _props2.type;
	            var id = _props2.id;
	            var dispatch = _props2.dispatch;
	
	            return dispatch((0, _stateActions.getUploads)(type, id, true)).then(function () {
	                // after refreshing attachments we must tell the changes again for parent module
	                if (selectedUpdaterCallback && typeof selectedUpdaterCallback === "function") {
	                    selectedUpdaterCallback(_this2.state.selected);
	                }
	            });
	        }
	
	        /**
	         * This function is used to prevent the navigation when the user is typing in the comment field.
	         */
	    }, {
	        key: "renderTitleForTable",
	
	        /**
	         * This will return with the correct title for the table what describe the type of documents.
	         */
	        value: function renderTitleForTable(type) {
	            return _react2["default"].createElement(
	                "div",
	                { className: _reactableScss2["default"].tableTitle },
	                type === "client" && _("clientDocuments") || type === "claim" && _("claimDocuments") || type === "contract" && _("contractDocuments") || type === "tarification" && _("tarificationDocuments") || _("documents")
	            );
	        }
	
	        /**
	         * Resolve the document comment field based on the document structurture.
	         * @param {object} file claim | client | contract | tarification
	         * @returns {object} { commentKey: string | null, commentValue: string}
	         */
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props3 = this.props;
	            var id = _props3.id;
	            var type = _props3.type;
	            var files = _props3.files;
	            var documents = _props3.documents;
	            var dict = _props3.dict;
	            var openModal = _props3.openModal;
	            var selectable = _props3.selectable;
	            var canUpload = _props3.canUpload;
	            var onlyUploadButton = _props3.onlyUploadButton;
	            var classNameExtra = _props3.classNameExtra;
	            var selected = this.state.selected;
	
	            var actFiles = [];
	            var selectedCheckboxes = selected && selected.map(function (val) {
	                return val.id;
	            }) || [];
	            var uploads = null;
	            var customTableHeads = [];
	            var serviceUploadComments = ["DS_ORIGIN_LOCAL_UPLOAD", "DS_ORIGIN_ORACLE", "", undefined]; // These comments are not displayed in the table
	
	            if (files && type && id) {
	                uploads = files[type][id];
	            }
	            if (type && type === "tarification") {
	                customTableHeads.push("insuranceCompany");
	            }
	
	            if (uploads) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = uploads.files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var file = _step.value;
	
	                        var tmp = _extends({}, file, {
	                            document: false,
	                            amount: file.documents ? file.documents.length : 0
	                        });
	                        actFiles = [].concat(_toConsumableArray(actFiles), [tmp]);
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator["return"]) {
	                            _iterator["return"]();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	
	            if (documents) {
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = documents[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var file = _step2.value;
	
	                        var tmp = {};
	
	                        var _resolveDocumentComment = this.resolveDocumentComment(file);
	
	                        var commentKey = _resolveDocumentComment.commentKey;
	                        var commentValue = _resolveDocumentComment.commentValue;
	
	                        tmp.amount = 1;
	                        tmp.locked = true;
	                        tmp.document = true;
	                        tmp[commentKey] = commentValue;
	                        tmp.uploadDate = file.contractDocumentDate || file.clientDocumentDate || file.documentDate || file.tarificationDocDate;
	                        tmp.type = file.contractDocumentType || file.clientDocumentType || file.documentType || file.tarificationDocType;
	                        tmp.uploadId = file.contractDocumentId || file.clientDocumentId || file.documentId || file.tarificationDocId;
	                        tmp.insuranceCompany = file.insuranceCompany || null;
	                        actFiles = [].concat(_toConsumableArray(actFiles), [tmp]);
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
	                            _iterator2["return"]();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	            }
	
	            // (v8.0) EXIT POINT (avoid to show the uploader table, hut the upload button in special cases)
	            if (onlyUploadButton) {
	                return _react2["default"].createElement(
	                    "div",
	                    { className: (0, _classnames2["default"])(_uploaderScss2["default"].uploadsContainer, classNameExtra) },
	                    dict && canUpload && _react2["default"].createElement(
	                        "div",
	                        {
	                            onClick: openModal,
	                            className: (0, _classnames2["default"])(_uploaderScss2["default"].uploadButton, 'btn', 'green')
	                        },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: _uploaderScss2["default"].iconContainer },
	                            _react2["default"].createElement("img", { src: _resourcesIcnPlusSvg2["default"] })
	                        ),
	                        _("upload")
	                    )
	                );
	            }
	
	            return _react2["default"].createElement(
	                "div",
	                { className: _uploaderScss2["default"].uploadsContainer },
	                _react2["default"].createElement(
	                    "div",
	                    { className: _reactableScss2["default"].tableContainer },
	                    this.renderTitleForTable(type),
	                    _react2["default"].createElement(
	                        _componentsReactable.Table,
	                        {
	                            filterPlaceholder: _("placeholder"),
	                            topPaginationElemL: _react2["default"].createElement(_refreshBtn2["default"], { onClick: function () {
	                                    _this3.handleRefreshTable();
	                                } }),
	                            topPaginationElemR: dict && canUpload && _react2["default"].createElement(
	                                "div",
	                                { onClick: openModal, className: (0, _classnames2["default"])(_uploaderScss2["default"].uploadButton, "btn green") },
	                                _react2["default"].createElement(
	                                    "div",
	                                    { className: _uploaderScss2["default"].iconContainer },
	                                    _react2["default"].createElement("img", { src: __webpack_require__(353) })
	                                ),
	                                _("upload")
	                            ),
	                            className: _uploaderScss2["default"].uploadTable,
	                            itemsPerPage: 40,
	                            filterable: ["documentHiddenCol", "documentTypeCol", "documentDateCol"],
	                            sortable: [{ column: "documentDateCol", sortFunction: "Date" }, "documentTypeCol", "documentAmount"],
	                            defaultSort: { column: "documentDateCol", direction: "desc" }
	                        },
	                        _react2["default"].createElement(
	                            _componentsReactable.Thead,
	                            null,
	                            _react2["default"].createElement(
	                                _componentsReactable.Th,
	                                { column: "documentMetaCol" },
	                                _react2["default"].createElement(
	                                    _reactMeasure2["default"],
	                                    { accurate: true, onMeasure: function (dim) {
	                                            return _this3.logCellWidth(dim, 'documentMetaCol');
	                                        } },
	                                    _react2["default"].createElement(
	                                        "div",
	                                        null,
	                                        ""
	                                    )
	                                )
	                            ),
	                            _react2["default"].createElement(_componentsReactable.Th, { className: _reactableScss2["default"].documentHidden, column: "documentHiddenCol" }),
	                            _react2["default"].createElement(
	                                _componentsReactable.Th,
	                                { column: "documentCheckBox" },
	                                _react2["default"].createElement(
	                                    _reactMeasure2["default"],
	                                    { accurate: true, onMeasure: function (dim) {
	                                            return _this3.logCellWidth(dim, 'documentCheckBox');
	                                        } },
	                                    _react2["default"].createElement(
	                                        "div",
	                                        null,
	                                        ""
	                                    )
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                _componentsReactable.Th,
	                                { column: "documentTypeCol" },
	                                _react2["default"].createElement(
	                                    _reactMeasure2["default"],
	                                    { accurate: true, onMeasure: function (dim) {
	                                            return _this3.logCellWidth(dim, 'documentTypeCol');
	                                        } },
	                                    _react2["default"].createElement(
	                                        "div",
	                                        null,
	                                        _react2["default"].createElement(
	                                            "strong",
	                                            null,
	                                            _("documentType")
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                _componentsReactable.Th,
	                                { column: "documentDateCol" },
	                                _react2["default"].createElement(
	                                    _reactMeasure2["default"],
	                                    { accurate: true, onMeasure: function (dim) {
	                                            return _this3.logCellWidth(dim, 'documentDateCol');
	                                        } },
	                                    _react2["default"].createElement(
	                                        "div",
	                                        null,
	                                        _react2["default"].createElement(
	                                            "strong",
	                                            null,
	                                            _("documentDate")
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                _componentsReactable.Th,
	                                { column: "userComment" },
	                                _react2["default"].createElement(
	                                    _reactMeasure2["default"],
	                                    { accurate: true, onMeasure: function (dim) {
	                                            return _this3.logCellWidth(dim, 'userComment');
	                                        } },
	                                    _react2["default"].createElement(
	                                        "div",
	                                        null,
	                                        _react2["default"].createElement(
	                                            "strong",
	                                            null,
	                                            _("userComment")
	                                        )
	                                    )
	                                )
	                            ),
	                            customTableHeads.map(function (header, index) {
	                                return _react2["default"].createElement(
	                                    _componentsReactable.Th,
	                                    { key: header + "-" + index, column: header },
	                                    _react2["default"].createElement(
	                                        "strong",
	                                        null,
	                                        _(header)
	                                    )
	                                );
	                            })
	                        ),
	                        actFiles.map(function (item, index) {
	                            return _react2["default"].createElement(
	                                _componentsReactable.Tr,
	                                {
	                                    key: item.uploadId + "-" + index,
	                                    className: _reactableScss2["default"].docRow,
	                                    onClick: function (event) {
	                                        if (_this3.isUserCommentCellClick(event)) {
	                                            return; // Here we prevent the navigation
	                                        }
	                                        _this3.opendDocumentInNewWindow(item);
	                                    }
	                                },
	                                item.document || item.amount === 0 ? _react2["default"].createElement(
	                                    _componentsReactable.Td,
	                                    {
	                                        column: "documentMetaCol",
	                                        data: item.id,
	                                        className: _uploaderScss2["default"].rowIcon
	                                    },
	                                    _react2["default"].createElement(
	                                        "div",
	                                        null,
	                                        _react2["default"].createElement("img", { src: item.amount === 1 ? _resourcesImagesPdfIcon_1xPng2["default"] : _resourcesImagesPClose_1xPng2["default"] })
	                                    )
	                                ) : _react2["default"].createElement(
	                                    _componentsReactable.Td,
	                                    {
	                                        column: "documentMetaCol",
	                                        data: item.id,
	                                        className: _uploaderScss2["default"].rowIcon
	                                    },
	                                    _react2["default"].createElement(
	                                        "div",
	                                        { style: { width: 10 } },
	                                        _react2["default"].createElement(
	                                            "div",
	                                            null,
	                                            _react2["default"].createElement("img", { src: _resourcesIcnFolderSvg2["default"] })
	                                        ),
	                                        _react2["default"].createElement(
	                                            _reactCollapse2["default"],
	                                            {
	                                                className: _uploaderScss2["default"].collapseFiles,
	                                                isOpened: Boolean(!_this3.state.isClosed[item.uploadId]),
	                                                onClick: function (ev) {
	                                                    return ev.stopPropagation();
	                                                },
	                                                style: { paddingLeft: _this3.state.documentMetaCol + 10 }
	                                            },
	                                            _react2["default"].createElement(
	                                                "div",
	                                                { className: _uploaderScss2["default"].collapseContent },
	                                                !serviceUploadComments.includes(item.comment) && _react2["default"].createElement(
	                                                    "div",
	                                                    { className: _uploaderScss2["default"].uploadCommentContainer },
	                                                    _react2["default"].createElement(
	                                                        "div",
	                                                        {
	                                                            style: { width: _this3.state.documentCheckBox + 20, padding: '10px' },
	                                                            className: _uploaderScss2["default"].icon
	                                                        },
	                                                        _react2["default"].createElement(CommentIcon, null)
	                                                    ),
	                                                    _react2["default"].createElement(
	                                                        "p",
	                                                        { style: { width: _this3.state.documentTypeCol } },
	                                                        item.comment
	                                                    )
	                                                ),
	                                                _react2["default"].createElement(
	                                                    "div",
	                                                    { className: _uploaderScss2["default"].documents },
	                                                    item.amount >= 1 && (0, _lodashCollection.sortBy)(item.documents, function (sdoc) {
	                                                        return sdoc.documentType;
	                                                    }).map(function (doc, j) {
	                                                        return _react2["default"].createElement(
	                                                            "div",
	                                                            { key: j, className: _uploaderScss2["default"].documentRowHolder },
	                                                            selectable && _react2["default"].createElement("input", {
	                                                                type: "checkbox",
	                                                                checked: selectedCheckboxes.indexOf(String(doc.documentId)) !== -1,
	                                                                onChange: function () {
	                                                                    _this3.onSelectDoc({
	                                                                        id: String(doc.documentId),
	                                                                        name: doc.documentType,
	                                                                        date: doc.documentDate
	                                                                    });
	                                                                },
	                                                                value: doc.documentId
	                                                            }),
	                                                            _react2["default"].createElement(
	                                                                "a",
	                                                                {
	                                                                    key: "anchor" + j,
	                                                                    className: _uploaderScss2["default"].file,
	                                                                    onClick: function (event) {
	                                                                        if (_this3.isUserCommentCellClick(event)) {
	                                                                            return; // Here we prevent the navigation
	                                                                        }
	                                                                        window.open("/data/document?id=" + doc.documentId + "&docType=" + encodeURI(doc.documentType) + "&uploadDate=" + encodeURI(doc.documentDate), "_blank", 'noopener,noreferrer');
	                                                                    }
	                                                                },
	                                                                _react2["default"].createElement(
	                                                                    "div",
	                                                                    { style: { width: _this3.state.documentCheckBox + 20, padding: '10px' }, className: _uploaderScss2["default"].rowIcon },
	                                                                    _react2["default"].createElement("img", { src: _resourcesImagesPdfIcon_1xPng2["default"] })
	                                                                ),
	                                                                _react2["default"].createElement(
	                                                                    "div",
	                                                                    { style: { width: _this3.state.documentTypeCol + 20, padding: '10px' }, className: _uploaderScss2["default"].documentType },
	                                                                    doc.documentType
	                                                                ),
	                                                                _react2["default"].createElement(
	                                                                    "div",
	                                                                    { style: { width: _this3.state.documentDateCol + 20, padding: "10px" } },
	                                                                    _this3.displayDate(doc.documentDate)
	                                                                ),
	                                                                _react2["default"].createElement(
	                                                                    "div",
	                                                                    { className: _uploaderScss2["default"].userComment, style: { padding: '10px', width: '52em' } },
	                                                                    _react2["default"].createElement(_componentsUploaderUploaderTableComment.UploaderTableComment, {
	                                                                        document: doc,
	                                                                        typeId: id,
	                                                                        uploadId: item.uploadId,
	                                                                        uploadType: type
	                                                                    })
	                                                                )
	                                                            )
	                                                        );
	                                                    })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2["default"].createElement(_componentsReactable.Td, {
	                                    style: { display: "none" },
	                                    column: "documentHiddenCol",
	                                    data: !item.document && item.amount >= 1 ? item.documents.map(function (doc) {
	                                        return doc.documentType + " " + doc.documentDate + " " + doc.documentId;
	                                    }).join(" ") : ""
	                                }),
	                                _react2["default"].createElement(
	                                    _componentsReactable.Td,
	                                    { column: "documentCheckBox" },
	                                    _react2["default"].createElement(
	                                        "div",
	                                        { onClick: function (ev) {
	                                                ev.stopPropagation();
	                                            } },
	                                        selectable && !item.document && item.amount === 0 && item.documents.map(function (doc, index) {
	                                            return _react2["default"].createElement("input", {
	                                                key: doc.documentId + "-" + index,
	                                                type: "checkbox",
	                                                checked: selectedCheckboxes.indexOf(String(doc.documentId)) !== -1,
	                                                onChange: function () {
	                                                    _this3.onSelectDoc({
	                                                        id: item.documentId,
	                                                        name: item.documentType,
	                                                        date: item.documentDate
	                                                    });
	                                                },
	                                                value: doc.documentId
	                                            });
	                                        }) || selectable && item.document && _react2["default"].createElement("input", {
	                                            type: "checkbox",
	                                            checked: selectedCheckboxes.indexOf(String(item.uploadId)) !== -1,
	                                            onChange: function () {
	                                                _this3.onSelectDoc({
	                                                    id: item.uploadId,
	                                                    name: item.type,
	                                                    date: item.uploadDate
	                                                });
	                                            },
	                                            value: item.uploadId
	                                        }) || item.document
	                                    )
	                                ),
	                                _react2["default"].createElement(_componentsReactable.Td, { className: _uploaderScss2["default"].documentTypeCol, column: "documentTypeCol", data: item.type }),
	                                _react2["default"].createElement(_componentsReactable.Td, { column: "documentDateCol", data: (0, _libHelpers.dateFormatter)(item.uploadDate) }),
	                                _react2["default"].createElement(
	                                    _componentsReactable.Td,
	                                    { column: "userComment", className: _uploaderScss2["default"].userComment, style: { padding: '10px', width: '52em' } },
	                                    _react2["default"].createElement(_componentsUploaderUploaderTableComment.UploaderTableComment, {
	                                        document: item,
	                                        typeId: id,
	                                        uploadId: item.uploadId,
	                                        uploadType: type
	                                    })
	                                ),
	                                type && type === "tarification" && _react2["default"].createElement(_componentsReactable.Td, { column: "insuranceCompany", data: item.insuranceCompany })
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UploaderTable;
	})(_react.Component);
	
	exports["default"] = UploaderTable;
	
	UploaderTable.propTypes = {
	    id: _react.PropTypes.string.isRequired,
	    type: _react.PropTypes.string.isRequired,
	    files: _react.PropTypes.object,
	    documents: _react.PropTypes.array,
	    dict: _react.PropTypes.object,
	    openModal: _react.PropTypes.func.isRequired,
	    dispatch: _react.PropTypes.func.isRequired,
	    selectable: _react.PropTypes.bool,
	    selected: _react.PropTypes.array,
	    selectedUpdaterCallback: _react.PropTypes.func,
	    onlyUploadButton: _react.PropTypes.bool,
	    classNameExtra: _react.PropTypes.any,
	    canUpload: _react.PropTypes.bool
	};
	module.exports = exports["default"];
	/* <Th column="documentUpload"><strong>{_("upload")}</strong></Th> */ /* {item.document === false && (
	                                                                         <Td
	                                                                             className={rt.uploadCol}
	                                                                             column="documentUpload"
	                                                                             data={item.id}
	                                                                         >
	                                                                             {item.locked === "false" ? (
	                                                                                 <img
	                                                                                     className={styles.withPointer}
	                                                                                     onClick={(ev) => {
	                                                                                         ev.stopPropagation()
	                                                                                         return this.addFilesToUpload(item)
	                                                                                     }}
	                                                                                     src={uploadIcon}
	                                                                                 />
	                                                                             ) : (
	                                                                                 <img onClick={(ev) => {ev.stopPropagation()}} src={uploadLockIcon}/>
	                                                                             )}
	                                                                         </Td>
	                                                                      )} */

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _webappsScss = __webpack_require__(441);
	
	var _webappsScss2 = _interopRequireDefault(_webappsScss);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('webapps');
	
	var WebAppClickableThumbBlock = (function (_React$Component) {
	    _inherits(WebAppClickableThumbBlock, _React$Component);
	
	    function WebAppClickableThumbBlock() {
	        _classCallCheck(this, _WebAppClickableThumbBlock);
	
	        _get(Object.getPrototypeOf(_WebAppClickableThumbBlock.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(WebAppClickableThumbBlock, [{
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var webApp = _props.webApp;
	            var img = _props.img;
	            var desc = _props.desc;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: _webappsScss2['default'].item,
	                    onClick: function () {
	                        return _this.props.onSelect(webApp);
	                    },
	                    key: "WebAppClickableThumbBlock" + webApp._id
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _webappsScss2['default'].imageContainer, key: "WebAppClickableThumbBlockImg" + webApp._id },
	                    _react2['default'].createElement('img', { src: img })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _webappsScss2['default'].descContainer, key: "WebAppClickableThumbBlockDesc" + webApp._id },
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        desc
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            webApp: _react.PropTypes.object,
	            img: _react.PropTypes.string.isRequired,
	            desc: _react.PropTypes.string.isRequired,
	            onSelect: _react.PropTypes.func.isRequired
	        },
	        enumerable: true
	    }]);
	
	    var _WebAppClickableThumbBlock = WebAppClickableThumbBlock;
	    WebAppClickableThumbBlock = (0, _reactRedux.connect)(function (_ref) {
	        var _ref$app = _ref.app;
	        var lang = _ref$app.lang;
	        var WebAppTypes = _ref$app.security.WebAppTypes;
	        return {
	            lang: lang,
	            WebAppTypes: WebAppTypes
	        };
	    })(WebAppClickableThumbBlock) || WebAppClickableThumbBlock;
	    return WebAppClickableThumbBlock;
	})(_react2['default'].Component);
	
	exports['default'] = WebAppClickableThumbBlock;
	module.exports = exports['default'];

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _webappsScss = __webpack_require__(441);
	
	var _webappsScss2 = _interopRequireDefault(_webappsScss);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _stateActionsIndex = __webpack_require__(5);
	
	var _DSDocumentsDocumentsHelpers = __webpack_require__(106);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _DSDocumentsWarningModal = __webpack_require__(599);
	
	var _DSDocumentsWarningModal2 = _interopRequireDefault(_DSDocumentsWarningModal);
	
	var _DSDocumentsOpenDocumentToFillModal = __webpack_require__(598);
	
	var _DSDocumentsOpenDocumentToFillModal2 = _interopRequireDefault(_DSDocumentsOpenDocumentToFillModal);
	
	var _componentsSharedSelectSelectWrap = __webpack_require__(37);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var PDF_API_URL = "/api/getFilledPrintablePdfDocument";
	
	var _ = (0, _libI18n2['default'])('webapps');
	
	var WebAppFillDocDom = (function (_React$Component) {
	    _inherits(WebAppFillDocDom, _React$Component);
	
	    _createClass(WebAppFillDocDom, null, [{
	        key: 'propTypes',
	        value: {
	            webApp: _react.PropTypes.object,
	            img: _react.PropTypes.string.isRequired,
	            desc: _react.PropTypes.string.isRequired,
	            onSave: _react.PropTypes.string.func,
	            onCancel: _react.PropTypes.string.func
	        },
	        enumerable: true
	    }]);
	
	    function WebAppFillDocDom(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, _WebAppFillDocDom);
	
	        _get(Object.getPrototypeOf(_WebAppFillDocDom.prototype), 'constructor', this).call(this, props);
	
	        //+++++++++++++++++++++++
	        // First time init
	
	        // init broker stuff
	        var brokerOptions = [];
	        if (props.brokers) {
	            for (var key in props.brokers) {
	                if (props.brokers[key].brokerNumber) {
	                    brokerOptions.push({
	                        label: props.brokers[key].main.name + "  " + props.brokers[key].brokerNumber,
	                        value: props.brokers[key].brokerNumber
	                    });
	                }
	            }
	        }
	
	        this.state = {
	            documentTemplate: null,
	            brokerOptions: brokerOptions,
	            brokerNumber: brokerOptions && brokerOptions[0].value || "",
	            language: props.lang,
	            documentTemplateId: props.webApp.documentTemplate && props.webApp.documentTemplate._id,
	
	            warningModalOpen: false,
	
	            dataSet: null,
	            optionsLists: null
	        };
	
	        this.startLoading();
	
	        // +++++++++++++++++++++++++++++++++++++++
	        // async inits, late set state
	        new Promise(function callee$2$0() {
	            var initResult, documentTemplate, dataSet, optionsLists;
	            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                var _this = this;
	
	                while (1) switch (context$3$0.prev = context$3$0.next) {
	                    case 0:
	                        context$3$0.next = 2;
	                        return regeneratorRuntime.awrap(this.initTemplate(this.state.brokerNumber, this.state.language, this.state.documentTemplate, this.state.documentTemplateId, ""));
	
	                    case 2:
	                        initResult = context$3$0.sent;
	                        documentTemplate = initResult.documentTemplate;
	                        dataSet = initResult.dataSet;
	                        optionsLists = initResult.optionsLists;
	
	                        // -------------------------
	
	                        this.setState({
	                            documentTemplate: documentTemplate,
	                            dataSet: dataSet,
	                            optionsLists: optionsLists
	                        }, function () {
	                            _this.stopLoading();
	                        });
	
	                    case 7:
	                    case 'end':
	                        return context$3$0.stop();
	                }
	            }, null, _this2);
	        });
	        //---------------------------------------
	    }
	
	    /**
	     *
	     * @param {*} nextProps
	     * @param {*} nextState
	     */
	
	    _createClass(WebAppFillDocDom, [{
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            var _this4 = this;
	
	            var _state = this.state;
	            var brokerNumber = _state.brokerNumber;
	            var language = _state.language;
	            var documentTemplate = _state.documentTemplate;
	            var documentTemplateId = _state.documentTemplateId;
	
	            var oldStateAffected = {
	                documentTemplate: nextState.documentTemplate,
	                dataSet: nextState.dataSet,
	                optionsLists: nextState.optionsLists
	            };
	
	            var newStateToSet = _extends({}, oldStateAffected);
	
	            // NO CODE OUTSIDE...!
	
	            // ALL YOUR CODE INSIDE PROMISE
	            new Promise(function callee$2$0(resolve) {
	                var initResult;
	                return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                    var _this3 = this;
	
	                    while (1) switch (context$3$0.prev = context$3$0.next) {
	                        case 0:
	                            if (!(documentTemplateId !== nextState.documentTemplateId || !documentTemplate && documentTemplateId || documentTemplate && documentTemplate._id !== documentTemplateId || language !== nextState.language || brokerNumber !== nextState.brokerNumber)) {
	                                context$3$0.next = 7;
	                                break;
	                            }
	
	                            context$3$0.next = 3;
	                            return regeneratorRuntime.awrap(this.initTemplate(nextState.brokerNumber, nextState.language, nextState.documentTemplate, nextState.documentTemplateId, ""));
	
	                        case 3:
	                            initResult = context$3$0.sent;
	
	                            // altering new state, affected values by incoming new values
	                            newStateToSet.documentTemplate = initResult.documentTemplate;
	                            newStateToSet.dataSet = initResult.dataSet;
	                            newStateToSet.optionsLists = initResult.optionsLists;
	
	                        case 7:
	                            if (!(JSON.stringify(newStateToSet) !== JSON.stringify(oldStateAffected))) {
	                                context$3$0.next = 9;
	                                break;
	                            }
	
	                            return context$3$0.abrupt('return', this.setState(newStateToSet, function () {
	                                //this.stopLoading()
	
	                                console.log("STATE CAHNGED ", _this3.state.brokerNumber);
	
	                                resolve();
	                            }));
	
	                        case 9:
	                            return context$3$0.abrupt('return', resolve());
	
	                        case 10:
	                        case 'end':
	                            return context$3$0.stop();
	                    }
	                }, null, _this4);
	            });
	        }
	
	        /**
	         * Setup all conditions for this module
	         */
	    }, {
	        key: 'initTemplate',
	        value: function initTemplate(brokerNumber, language, documentTemplate, documentTemplateId) {
	            var dispatch, dataSetId, datasetName, dataSet, optionsLists, listsToGet, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, placeholder, getListRequest;
	
	            return regeneratorRuntime.async(function initTemplate$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	
	                        if (!(!documentTemplate || String(documentTemplate._id) !== String(documentTemplateId))) {
	                            context$2$0.next = 5;
	                            break;
	                        }
	
	                        context$2$0.next = 4;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActionsIndex.getDSDocumentTemplate)(documentTemplateId)));
	
	                    case 4:
	                        documentTemplate = context$2$0.sent;
	
	                    case 5:
	                        if (documentTemplate) {
	                            context$2$0.next = 8;
	                            break;
	                        }
	
	                        console.error("No template found by id: " + documentTemplateId);
	                        return context$2$0.abrupt('return');
	
	                    case 8:
	                        dataSetId = documentTemplate.dataSetId && documentTemplate.dataSetId.datasetId;
	                        datasetName = documentTemplate.dataSetId && documentTemplate.dataSetId.datasetName;
	                        dataSet = undefined;
	                        optionsLists = undefined;
	                        context$2$0.prev = 12;
	                        context$2$0.next = 15;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActionsIndex.getDSDataSets)()));
	
	                    case 15:
	                        context$2$0.next = 17;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActionsIndex.getDSDataSet)(datasetName, dataSetId === 'clientId' ? "" : null, brokerNumber, language, null, null)));
	
	                    case 17:
	                        dataSet = context$2$0.sent;
	                        context$2$0.next = 20;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActionsIndex.disableBackgroundProcesses)(true)));
	
	                    case 20:
	                        if (!(dataSet && dataSet.placeholders)) {
	                            context$2$0.next = 46;
	                            break;
	                        }
	
	                        listsToGet = [];
	                        _iteratorNormalCompletion = true;
	                        _didIteratorError = false;
	                        _iteratorError = undefined;
	                        context$2$0.prev = 25;
	
	                        for (_iterator = dataSet.placeholders[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            placeholder = _step.value;
	
	                            if (placeholder.placeholderList) {
	                                listsToGet.push({ placeholderName: placeholder.placeholderName, placeholderList: placeholder.placeholderList });
	                            }
	                        }
	
	                        context$2$0.next = 33;
	                        break;
	
	                    case 29:
	                        context$2$0.prev = 29;
	                        context$2$0.t0 = context$2$0['catch'](25);
	                        _didIteratorError = true;
	                        _iteratorError = context$2$0.t0;
	
	                    case 33:
	                        context$2$0.prev = 33;
	                        context$2$0.prev = 34;
	
	                        if (!_iteratorNormalCompletion && _iterator['return']) {
	                            _iterator['return']();
	                        }
	
	                    case 36:
	                        context$2$0.prev = 36;
	
	                        if (!_didIteratorError) {
	                            context$2$0.next = 39;
	                            break;
	                        }
	
	                        throw _iteratorError;
	
	                    case 39:
	                        return context$2$0.finish(36);
	
	                    case 40:
	                        return context$2$0.finish(33);
	
	                    case 41:
	                        if (!(listsToGet && listsToGet.length > 0)) {
	                            context$2$0.next = 46;
	                            break;
	                        }
	
	                        context$2$0.next = 44;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActionsIndex.getLists)(listsToGet, language)));
	
	                    case 44:
	                        getListRequest = context$2$0.sent;
	
	                        if (getListRequest) {
	                            optionsLists = getListRequest;
	                        }
	
	                    case 46:
	                        context$2$0.next = 52;
	                        break;
	
	                    case 48:
	                        context$2$0.prev = 48;
	                        context$2$0.t1 = context$2$0['catch'](12);
	
	                        console.error(context$2$0.t1);
	                        dispatch((0, _stateActionsIndex.setNotification)(_('error') + " " + JSON.stringify(context$2$0.t1), 'error'));
	
	                    case 52:
	                        return context$2$0.abrupt('return', {
	                            documentTemplate: documentTemplate,
	                            dataSet: dataSet,
	                            optionsLists: optionsLists
	                        });
	
	                    case 53:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this, [[12, 48], [25, 29, 33, 41], [34,, 36, 40]]);
	        }
	
	        /**
	         * Start loading anything.
	         * Not a state driven status flag, because not required a rerender in case of change
	         */
	    }, {
	        key: 'startLoading',
	        value: function startLoading() {
	            this.isLoaded = false;
	        }
	
	        /**
	         * Stop loading anything.
	         * Not a state driven status flag, because not required a rerender in case of change
	         * @param {*} forceUpdate - can be enforced optionally a rerender but very rare to be necessary.
	         */
	    }, {
	        key: 'stopLoading',
	        value: function stopLoading() {
	            this.isLoaded = true;
	            this.forceUpdate();
	        }
	
	        /**
	         * Open warning modal
	         * @param {*} isThereXSSFiltered
	         * @param {*} suspectValues
	         */
	    }, {
	        key: 'openWarningModalForXssIssue',
	        value: function openWarningModalForXssIssue(isThereXSSFiltered, suspectValues) {
	            return regeneratorRuntime.async(function openWarningModalForXssIssue$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        return context$2$0.abrupt('return', this.setState({ warningModalOpen: isThereXSSFiltered ? suspectValues : false }));
	
	                    case 1:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         *
	         * @param {*} newBrokerNumber
	         */
	    }, {
	        key: 'onChangeBroker',
	        value: function onChangeBroker(newBrokerNumber) {
	            var brokerNumber = this.state.brokerNumber;
	
	            if (newBrokerNumber !== brokerNumber) {
	                this.setState({ brokerNumber: newBrokerNumber });
	            }
	        }
	
	        /**
	         * This will generate the PDF and forward to the ling toward it to print.
	         * @param {Object} oneDocument
	         */
	    }, {
	        key: 'openNewTabByDocumentId',
	        value: function openNewTabByDocumentId(printableDocumentId) {
	            var linkForPdfDownload, w;
	            return regeneratorRuntime.async(function openNewTabByDocumentId$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        linkForPdfDownload = PDF_API_URL + "/" + printableDocumentId;
	                        w = window.open(linkForPdfDownload, '_blank', 'noopener,noreferrer');
	
	                        new Promise(function (resolve) {
	                            w.addEventListener('load', function () {
	                                resolve();
	                            }, true);
	                        });
	
	                    case 3:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Provides initial arguments for creating a new printable document record
	         * @param {*} packageId - this is a fake data, can be anything. (The existence can't be avoided,
	         * without an agrerssive modifications of the reused, components of the Digital Signature system.)
	         * @returns
	         */
	    }, {
	        key: 'generatePrintableDocumentProps',
	        value: function generatePrintableDocumentProps(packageId) {
	            var _state2 = this.state;
	            var documentTemplate = _state2.documentTemplate;
	            var language = _state2.language;
	            var brokerNumber = _state2.brokerNumber;
	
	            return {
	                _id: "no_id_but_required",
	                cursor: 0,
	                language: language,
	                documentTemplate: documentTemplate,
	                brokerFilledValues: [],
	                packageId: packageId,
	                clientId: "",
	                brokerNumber: brokerNumber
	            };
	        }
	
	        /**
	         * This information is necessary to exists for printable document as well, because the code is reused of
	         * Digital signature system, what was build for signable document originaly, an are based on signers and stuffs.
	         * The cost is to try to follow the schemas, to be able to use the code, without modify the original functionalities.
	         * @returns
	         */
	    }, {
	        key: 'generatePrintableDocumentStakeholder',
	        value: function generatePrintableDocumentStakeholder() {
	            return {
	                _id: "noid",
	                firstName: "",
	                lastName: "",
	                email: ""
	            };
	        }
	
	        /**
	         * The component local onsave functionality.
	         * Resolve local jobs and call the parents on save.
	         * @param {*} printableDocArgumentsForCreate
	         * @param {*} oneDocumentUpdatableProps
	         */
	    }, {
	        key: 'onSave',
	        value: function onSave(printableDocArgumentsForCreate, oneDocumentUpdatableProps, canvasImages) {
	            var dispatch, printableDocumentRecord;
	            return regeneratorRuntime.async(function onSave$(context$2$0) {
	                while (1) switch (context$2$0.prev = context$2$0.next) {
	                    case 0:
	                        dispatch = this.props.dispatch;
	
	                        // extend the document object by the broker filled values and stuffs by the template filler module
	                        printableDocArgumentsForCreate = _extends({}, printableDocArgumentsForCreate, oneDocumentUpdatableProps, {
	                            documentTemplateId: printableDocArgumentsForCreate.documentTemplate,
	                            _id: null
	                        });
	
	                        // save the document in mongo to have reference id for generating printing link
	                        context$2$0.next = 4;
	                        return regeneratorRuntime.awrap(dispatch((0, _stateActionsIndex.createPrintableDocument)(printableDocArgumentsForCreate, canvasImages)));
	
	                    case 4:
	                        printableDocumentRecord = context$2$0.sent;
	                        context$2$0.next = 7;
	                        return regeneratorRuntime.awrap(this.openNewTabByDocumentId(printableDocumentRecord._id));
	
	                    case 7:
	                        return context$2$0.abrupt('return', printableDocumentRecord);
	
	                    case 8:
	                    case 'end':
	                        return context$2$0.stop();
	                }
	            }, null, this);
	        }
	
	        /**
	         * Render hook of class based component
	         * @returns
	         */
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            if (!this.isLoaded) {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    _("loading")
	                );
	            }
	
	            var _props = this.props;
	            var img = _props.img;
	            var desc = _props.desc;
	            var dispatch = _props.dispatch;
	            var _state3 = this.state;
	            var documentTemplate = _state3.documentTemplate;
	            var dataSet = _state3.dataSet;
	            var optionsLists = _state3.optionsLists;
	            var language = _state3.language;
	            var warningModalOpen = _state3.warningModalOpen;
	            var brokerNumber = _state3.brokerNumber;
	            var brokerOptions = _state3.brokerOptions;
	
	            var fakePackageId = "noid";
	            var printableDocArgumentsForCreate = this.generatePrintableDocumentProps(fakePackageId);
	            var fakeStakeHolder = this.generatePrintableDocumentStakeholder();
	
	            return _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(_webappsScss2['default'].item, _webappsScss2['default'].itemFlex), key: "WebAppFillDocDomMainKey" },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _webappsScss2['default'].descContainer, key: "WebAppFillDocDomDescriptionKey" },
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        desc
	                    )
	                ),
	                _react2['default'].createElement(
	                    'form',
	                    { key: "WebAppFillDocDomFormKey", className: _webappsScss2['default'].webAppForm },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: _webappsScss2['default'].formInputContainer, key: "WebAppFillDocDomFormBrokerNrKey" },
	                        _react2['default'].createElement(
	                            'label',
	                            { className: _webappsScss2['default'].formLabel },
	                            _('brokerNumber'),
	                            ' '
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(_webappsScss2['default'].formInput, _webappsScss2['default'].formInputCreatableSelect) },
	                            _react2['default'].createElement(_componentsSharedSelectSelectWrap.SelectWrapper, {
	                                value: brokerNumber,
	                                options: brokerOptions,
	                                isClearable: false,
	                                isDisabled: false,
	                                onChange: function (item) {
	                                    return _this5.onChangeBroker(item.value);
	                                },
	                                key: "WebAppFillDocDomFormBrokerSelectorKey"
	                            })
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: _webappsScss2['default'].docFillerContainer },
	                    _react2['default'].createElement(_DSDocumentsOpenDocumentToFillModal2['default'], {
	                        parentModule: _stateConstants2['default'].WEBAPPS,
	                        extraClassNameForContainer: _webappsScss2['default'].iframeContainer,
	                        renderTemplateOnly: true,
	                        contentLabel: "",
	                        dataForEditDocument: {
	                            oneDocument: printableDocArgumentsForCreate,
	                            dataSet: dataSet,
	                            optionsLists: optionsLists
	                        },
	                        stakeholders: [fakeStakeHolder],
	                        packageDSDocuments: [printableDocArgumentsForCreate],
	                        lang: language,
	                        packageId: fakePackageId,
	                        showWarningXss: function (isThereXSSFiltered, suspectValues) {
	                            return _this5.openWarningModalForXssIssue(isThereXSSFiltered, suspectValues);
	                        },
	                        didClose: function (templateFormValues) {
	                            _this5.setState({
	                                dataSet: null,
	                                optionsLists: null
	                            });
	                            _this5.stopLoading();
	                            dispatch((0, _stateActionsIndex.disableBackgroundProcesses)(false));
	                        },
	                        onCancel: function (argu) {
	                            _this5.props.onCancel(argu);
	                        },
	                        onSave: function callee$2$0(oneDocumentUpdatableProps, canvasImages) {
	                            var printableDocumentRecord;
	                            return regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	                                while (1) switch (context$3$0.prev = context$3$0.next) {
	                                    case 0:
	                                        context$3$0.next = 2;
	                                        return regeneratorRuntime.awrap(this.onSave(printableDocArgumentsForCreate, oneDocumentUpdatableProps, canvasImages));
	
	                                    case 2:
	                                        printableDocumentRecord = context$3$0.sent;
	                                        context$3$0.next = 5;
	                                        return regeneratorRuntime.awrap(this.props.onSave(printableDocumentRecord));
	
	                                    case 5:
	                                    case 'end':
	                                        return context$3$0.stop();
	                                }
	                            }, null, _this5);
	                        },
	                        key: "WebAppOpenDocumentToFillModal"
	                    })
	                ),
	                _react2['default'].createElement(_DSDocumentsWarningModal2['default'], {
	                    isOpen: Boolean(warningModalOpen),
	                    style: _DSDocumentsDocumentsHelpers.customModalStyles,
	                    contentLabel: "",
	                    didClose: function () {
	                        _this5.setState({ warningModalOpen: false });
	                    },
	                    key: "WebAppWarningModal"
	                })
	            );
	        }
	    }]);
	
	    var _WebAppFillDocDom = WebAppFillDocDom;
	    WebAppFillDocDom = (0, _reactRedux.connect)(function (_ref) {
	        var _ref$app = _ref.app;
	        var lang = _ref$app.lang;
	        var WebAppTypes = _ref$app.security.WebAppTypes;
	        var brokers = _ref.office.brokers;
	        return {
	            lang: lang,
	            WebAppTypes: WebAppTypes,
	            brokers: brokers
	        };
	    })(WebAppFillDocDom) || WebAppFillDocDom;
	    return WebAppFillDocDom;
	})(_react2['default'].Component);
	
	exports['default'] = WebAppFillDocDom;
	module.exports = exports['default'];

	// ++++++++++++++++++++++++++++
	// init template stuff

	//++++++++++++++++++++++++++
	// fetch template affected

	// args should be strictly from the nextState values

	//-----------------------------

	//+++++++++++++++++++++++++++++
	// checking the altered state values, if differ from originally expected nextState values
	// EXIT point

	//this.startLoading()

	// Arrived here means nothing to alter/update by newly set state or props values
	// EXIT point

	// update the list of datasets in database

	// get calues

	// open new tab by the saved dpocuent id

	// call the parent onSave methode, to do further action when all the jobs are done

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _stateActions = __webpack_require__(5);
	
	var _webappsScss = __webpack_require__(441);
	
	var _webappsScss2 = _interopRequireDefault(_webappsScss);
	
	var _WebAppClickableThumbBlock = __webpack_require__(1156);
	
	var _WebAppClickableThumbBlock2 = _interopRequireDefault(_WebAppClickableThumbBlock);
	
	var _WebAppFillDocDom = __webpack_require__(1157);
	
	var _WebAppFillDocDom2 = _interopRequireDefault(_WebAppFillDocDom);
	
	var _elementsComponentPageDom = __webpack_require__(219);
	
	var _elementsComponentPageDom2 = _interopRequireDefault(_elementsComponentPageDom);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('webapps');
	
	var WebAppsCtDom = function WebAppsCtDom(_ref) {
	    var children = _ref.children;
	    return _react2['default'].createElement(
	        'div',
	        { className: _webappsScss2['default'].itemsContainer },
	        children
	    );
	};
	WebAppsCtDom.propTypes = {
	    children: _react2['default'].PropTypes.node
	};
	
	var WebAppItemDom = function WebAppItemDom(_ref2) {
	    var href = _ref2.href;
	    var img = _ref2.img;
	    var desc = _ref2.desc;
	    return _react2['default'].createElement(
	        'a',
	        { href: href, target: '_blank', className: _webappsScss2['default'].item, rel: 'noopener noreferrer' },
	        _react2['default'].createElement(
	            'div',
	            { className: _webappsScss2['default'].imageContainer },
	            _react2['default'].createElement('img', { src: img })
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: _webappsScss2['default'].descContainer },
	            _react2['default'].createElement(
	                'span',
	                null,
	                desc
	            )
	        )
	    );
	};
	WebAppItemDom.propTypes = {
	    href: _react.PropTypes.string.isRequired,
	    img: _react.PropTypes.string.isRequired,
	    desc: _react.PropTypes.string.isRequired
	};
	
	var Webapp = (function (_React$Component) {
	    _inherits(Webapp, _React$Component);
	
	    _createClass(Webapp, null, [{
	        key: 'propTypes',
	        value: {
	            dispatch: _react.PropTypes.func.isRequired,
	            webapps: _react.PropTypes.arrayOf(_react.PropTypes.object),
	            lang: _react.PropTypes.string.isRequired
	        },
	        enumerable: true
	    }]);
	
	    function Webapp(props) {
	        _classCallCheck(this, _Webapp);
	
	        _get(Object.getPrototypeOf(_Webapp.prototype), 'constructor', this).call(this, props);
	
	        this.state = {
	            selectedApp: false
	        };
	    }
	
	    _createClass(Webapp, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props;
	            var dispatch = _props.dispatch;
	            var webapps = _props.webapps;
	
	            if (!webapps.length) {
	                dispatch((0, _stateActions.getWebapps)());
	            }
	        }
	    }, {
	        key: 'getLangSpecificImageName',
	        value: function getLangSpecificImageName(item) {
	            var lang = this.props.lang;
	
	            if (!item) {
	                return '';
	            }
	
	            if (item.imageLang && item.imageLang[lang] && item.imageLang[lang].filename) {
	                return item.imageLang && item.imageLang[lang] && item.imageLang[lang].filename;
	            }
	
	            // finally if no language dependent image found try to send general image.
	            return item.image && item.image.filename || '';
	        }
	
	        /**
	         * This
	         * @param {*} webappRecord
	        */
	    }, {
	        key: 'getLanguageSpecificLink',
	        value: function getLanguageSpecificLink(webappRecord) {
	            var basicLink = webappRecord && webappRecord.link;
	            var langSpecificLink = webappRecord && webappRecord.linkFor || {};
	
	            langSpecificLink["nl"] = langSpecificLink.nl || '';
	            langSpecificLink["fr"] = langSpecificLink.fr || '';
	            langSpecificLink["en"] = langSpecificLink.en || '';
	
	            return langSpecificLink[global.lang] || basicLink || '';
	        }
	
	        /**
	         * This function will return the description in of webapp on the user language.
	         * @param {*} item
	         */
	    }, {
	        key: 'getLangSpecificDescription',
	        value: function getLangSpecificDescription(item) {
	            var lang = this.props.lang;
	
	            return _nestedProperty2['default'].get(item, 'desc.' + lang) || '';
	        }
	    }, {
	        key: 'onSelectWebAppDocumentFill',
	        value: function onSelectWebAppDocumentFill(webApp) {
	            this.setState({ selectedApp: webApp ? webApp : false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props2 = this.props;
	            var webapps = _props2.webapps;
	            var lang = _props2.lang;
	            var noHeader = _props2.noHeader;
	            var WebAppTypes = _props2.WebAppTypes;
	            var selectedApp = this.state.selectedApp;
	
	            // prepare back button for Componenet page dom if webapp is selected
	            // when the object is empty no backbutton diplayed else backbutton displayed
	            var backButtonPropsForHeader = {};
	            if (selectedApp) {
	                backButtonPropsForHeader = {
	                    usesBackButton: true,
	                    backButtonOnClick: function backButtonOnClick() {
	                        _this.setState({ selectedApp: false });
	                    },
	                    backButtonLabel: _("backToWebapps")
	                };
	            }
	
	            return _react2['default'].createElement(
	                _elementsComponentPageDom2['default'],
	                _extends({}, _extends({
	                    noHeader: noHeader,
	                    title: _('title'),
	                    subtitle: _('subtitle')
	                }, backButtonPropsForHeader), {
	                    extraClassName: _webappsScss2['default'].maxHeight,
	                    extraClassNameMainSubDiv: _webappsScss2['default'].mainSubDiv
	                }),
	                selectedApp ? _react2['default'].createElement(_WebAppFillDocDom2['default'], _extends({
	                    webApp: selectedApp
	                }, {
	                    img: 'uploads/webapps/' + this.getLangSpecificImageName(selectedApp),
	                    desc: this.getLangSpecificDescription(selectedApp)
	                }, {
	                    onSave: function () {
	                        _this.setState({ selectedApp: false });
	                    },
	                    onCancel: function () {
	                        _this.setState({ selectedApp: false });
	                    }
	                })) : _react2['default'].createElement(
	                    WebAppsCtDom,
	                    null,
	                    webapps.length > 0 ? webapps.map(function (item, i) {
	                        var link = _this.getLanguageSpecificLink(item);
	
	                        // when there are no language specific or general link then the web
	                        // app is not visible.
	                        // WEBAPP_DOCUMENT_FILLER, WEBAPP_GENERAL
	                        if (!link && (!item.webAppType || item.webAppType === WebAppTypes.WEBAPP_GENERAL)) {
	                            return null;
	                        }
	
	                        var image = 'uploads/webapps/' + _this.getLangSpecificImageName(item);
	                        var description = _this.getLangSpecificDescription(item);
	                        var renderedApp = undefined;
	
	                        switch (item.webAppType) {
	                            case WebAppTypes.WEBAPP_DOCUMENT_FILLER:
	                                {
	                                    renderedApp = _react2['default'].createElement(_WebAppClickableThumbBlock2['default'], _extends({
	                                        webApp: item
	                                    }, {
	                                        img: image,
	                                        desc: description
	                                    }, {
	                                        onSelect: function (selectedApp) {
	                                            _this.onSelectWebAppDocumentFill(selectedApp);
	                                        },
	                                        key: "WebAppClickableThumbBlock" + i
	                                    }));
	                                    break;
	                                }
	                            default:
	                                {
	                                    renderedApp = _react2['default'].createElement(WebAppItemDom, _extends({
	                                        key: i
	                                    }, {
	                                        href: link,
	                                        img: image,
	                                        desc: description
	                                    }));
	                                    break;
	                                }
	                        }
	
	                        return renderedApp;
	                    }) : _('comingSoon')
	                )
	            );
	        }
	    }]);
	
	    var _Webapp = Webapp;
	    Webapp = (0, _reactRedux.connect)(function (_ref3) {
	        var webapps = _ref3.webapps;
	        var _ref3$app = _ref3.app;
	        var lang = _ref3$app.lang;
	        var WebAppTypes = _ref3$app.security.WebAppTypes;
	        return {
	            webapps: webapps,
	            lang: lang,
	            WebAppTypes: WebAppTypes
	        };
	    })(Webapp) || Webapp;
	    return Webapp;
	})(_react2['default'].Component);
	
	exports['default'] = Webapp;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _wilDuck = __webpack_require__(611);
	
	var _willdocScss = __webpack_require__(1631);
	
	var _willdocScss2 = _interopRequireDefault(_willdocScss);
	
	var _fileLoaderSpinnerHtml = __webpack_require__(1653);
	
	var _fileLoaderSpinnerHtml2 = _interopRequireDefault(_fileLoaderSpinnerHtml);
	
	var WillDoc = (function (_Component) {
		_inherits(WillDoc, _Component);
	
		_createClass(WillDoc, null, [{
			key: 'propTypes',
			value: {
				getWillDocUrl: _react.PropTypes.func.isRequired,
				url: _react.PropTypes.string
			},
			enumerable: true
		}]);
	
		function WillDoc(props) {
			_classCallCheck(this, _WillDoc);
	
			_get(Object.getPrototypeOf(_WillDoc.prototype), 'constructor', this).call(this, props);
			this.state = { loading: true };
		}
	
		_createClass(WillDoc, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this = this;
	
				this.props.getWillDocUrl();
				// Give the browser a chance to show the loading html
				this.t = setTimeout(function () {
					_this.setState({ loading: false });
				}, 300);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearTimeout(this.t);
			}
		}, {
			key: 'render',
			value: function render() {
				var url = this.props.url;
				var loading = this.state.loading;
	
				return _react2['default'].createElement(
					'div',
					{ className: _willdocScss2['default'].wdFrame },
					_react2['default'].createElement('iframe', { src: loading ? _fileLoaderSpinnerHtml2['default'] : url })
				);
			}
		}]);
	
		var _WillDoc = WillDoc;
		WillDoc = (0, _reactRedux.connect)(function (_ref) {
			var willdoc = _ref.willdoc;
			return {
				url: willdoc || _fileLoaderSpinnerHtml2['default']
			};
		}, { getWillDocUrl: _wilDuck.getWillDocUrl })(WillDoc) || WillDoc;
		return WillDoc;
	})(_react.Component);
	
	exports['default'] = WillDoc;
	module.exports = exports['default'];

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementsPillList = __webpack_require__(614);
	
	var _elementsPillList2 = _interopRequireDefault(_elementsPillList);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])();
	
	var CategoriesList = function CategoriesList(_ref) {
		var categoryIds = _ref.categoryIds;
		var customStyle = _ref.customStyle;
	
		return _react2['default'].createElement(
			_elementsPillList2['default'],
			{
				customStyle: customStyle,
				noPills: _('emptyCategories'),
				title: _('keywords')
			},
			categoryIds.map(_libI18n.catIdToString)
		);
	};
	
	exports['default'] = CategoriesList;
	module.exports = exports['default'];

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementsCookieBannerScss = __webpack_require__(1634);
	
	var _elementsCookieBannerScss2 = _interopRequireDefault(_elementsCookieBannerScss);
	
	var CookieBanner = function CookieBanner(_ref) {
		var children = _ref.children;
		var className = _ref.className;
		var buttonText = _ref.buttonText;
		var handleAcceptCookies = _ref.handleAcceptCookies;
	
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])(_elementsCookieBannerScss2['default'].mainCon, className) },
			_react2['default'].createElement(
				'div',
				{ className: _elementsCookieBannerScss2['default'].textCon },
				children
			),
			_react2['default'].createElement(
				'div',
				{ className: _elementsCookieBannerScss2['default'].buttonWrapper },
				_react2['default'].createElement(
					'button',
					{ onClick: function () {
							handleAcceptCookies();
						} },
					buttonText
				)
			)
		);
	};
	exports['default'] = CookieBanner;
	module.exports = exports['default'];

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SearchBoxScss = __webpack_require__(724);
	
	var _SearchBoxScss2 = _interopRequireDefault(_SearchBoxScss);
	
	var EmptySearch = function EmptySearch(_ref) {
		var children = _ref.children;
	
		return _react2['default'].createElement(
			'div',
			{ className: _SearchBoxScss2['default'].noResults },
			_react2['default'].createElement('img', { src: __webpack_require__(23) }),
			_react2['default'].createElement(
				'p',
				null,
				children
			)
		);
	};
	exports['default'] = EmptySearch;
	module.exports = exports['default'];

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HtmlContent = __webpack_require__(110);
	
	var _HtmlContent2 = _interopRequireDefault(_HtmlContent);
	
	var _DateValue = __webpack_require__(373);
	
	var _DateValue2 = _interopRequireDefault(_DateValue);
	
	var _newsScss = __webpack_require__(306);
	
	var _newsScss2 = _interopRequireDefault(_newsScss);
	
	var _stateActions = __webpack_require__(5);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])();
	
	var getIcon = function getIcon() {
	    try {
	        return __webpack_require__(360);
	    } catch (err) {
	        return __webpack_require__(23);
	    }
	};
	
	var NewsList = (function (_Component) {
	    _inherits(NewsList, _Component);
	
	    function NewsList() {
	        _classCallCheck(this, _NewsList);
	
	        _get(Object.getPrototypeOf(_NewsList.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(NewsList, [{
	        key: 'modalPrintNews',
	        value: function modalPrintNews(news) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _stateActions.showPrintModal)("newsPrintModal", news.title, news.content, "", null, { hasCancelButtonStyle: false }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var id = _props.id;
	            var date = _props.date;
	            var onOpen = _props.onOpen;
	            var isFirst = _props.isFirst;
	            var isActive = _props.isActive;
	            var isLast = _props.isLast;
	            var teaser = _props.teaser;
	            var title = _props.title;
	            var content = _props.content;
	            var sourceIds = _props.sourceIds;
	
	            return _react2['default'].createElement(
	                'div',
	                {
	                    onClick: function () {
	                        return onOpen(id);
	                    },
	                    className: (0, _classnames2['default'])(_newsScss2['default'].newsItem, isActive && _newsScss2['default'].active, isFirst && _newsScss2['default'].first, isLast && _newsScss2['default'].last)
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: _newsScss2['default'].newsInfoDiv },
	                    _react2['default'].createElement(
	                        'p',
	                        { className: _newsScss2['default'].newsTitle },
	                        title,
	                        _react2['default'].createElement('img', { className: _newsScss2['default'].printIcon,
	                            src: getIcon(),
	                            onClick: function (e) {
	                                e.preventDefault();
	                                var theWindow = window.open('', 'PRINT', 'height=600,width=800');
	                                theWindow.document.write('<html  style="overflow-y: hidden"><head><title>' + title + '</title>');
	                                theWindow.document.write('<style>');
	                                // this line of css made from HtmlContent.scss -> replace variables -> convert to css -> minify
	                                theWindow.document.write(".content{height:95%;overflow-y:scroll}.content ol,.content p,.content ul{margin:0 0 10px;color:#404548}.content em{font-style:italic}.content strong{font-weight:700}.content p.highlight{font-weight:700}.content p.bullet{padding-left:1em;text-indent:-1em}.content p.bullet::before{content:'•';padding-right:.5em}.content ol,.content ul{padding-left:20px}.content ol li,.content ul li{margin-left:1em}.content ol{list-style-type:decimal}.content ul{list-style-type:circle}.content h1{font-size:1.4em}.content h2{font-size:1.2em}.content h1,.content h2,.content h3,.content h4,.content h5,.content h6{font-weight:lighter;margin-top:1em;margin-bottom:.5em}.content hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.content blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}.content pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}.content pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.elements-news-title h2{color: #404548;font-size: 34px;font-weight: 600;}");
	                                theWindow.document.write('</style>');
	                                theWindow.document.write('</head><body class="content">');
	                                theWindow.document.write('<div class="elements-news-title"><h2>' + title + '</h2></div>');
	                                theWindow.document.write(content);
	                                theWindow.document.write('</body><footer><div class="linkList">');
	                                theWindow.document.write(_('news_sources') + ': ');
	                                sourceIds.map(function (sourceId, i) {
	                                    var source = (0, _libI18n.sourceIdToObj)(sourceId);
	                                    theWindow.document.write('<a href="' + source.url + '" target="_blank" rel="noopener noreferrer">' + source.name + '</a>');
	                                });
	                                theWindow.document.write('</div></footer></html>');
	                                theWindow.document.close(); // IE >= 10
	                                theWindow.focus(); // IE >= 10
	                                theWindow.print();
	                                // with preview modal
	                                /* this.modalPrintNews({title, content}) */
	                            } })
	                    ),
	                    date && _react2['default'].createElement(_DateValue2['default'], { className: _newsScss2['default'].date, date: date }),
	                    teaser && _react2['default'].createElement(
	                        'div',
	                        { className: _newsScss2['default'].teaser },
	                        _react2['default'].createElement(_HtmlContent2['default'], { className: '', content: teaser })
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            id: _react2['default'].PropTypes.string.isRequired,
	            date: _react2['default'].PropTypes.string.isRequired,
	            onOpen: _react2['default'].PropTypes.func.isRequired,
	            isFirst: _react2['default'].PropTypes.bool.isRequired,
	            isActive: _react2['default'].PropTypes.bool.isRequired,
	            isLast: _react2['default'].PropTypes.bool.isRequired,
	            teaser: _react2['default'].PropTypes.string.isRequired,
	            title: _react2['default'].PropTypes.string.isRequired
	        },
	        enumerable: true
	    }]);
	
	    var _NewsList = NewsList;
	    NewsList = (0, _reactRedux.connect)(function (state) {
	        return _extends({}, state.news, {
	            newsId: state.app.opened
	        });
	    })(NewsList) || NewsList;
	    return NewsList;
	})(_react.Component);
	
	exports['default'] = NewsList;
	module.exports = exports['default'];

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HtmlContent = __webpack_require__(110);
	
	var _HtmlContent2 = _interopRequireDefault(_HtmlContent);
	
	var _SourcesList = __webpack_require__(1171);
	
	var _SourcesList2 = _interopRequireDefault(_SourcesList);
	
	var _ScrollTop = __webpack_require__(1169);
	
	var _ScrollTop2 = _interopRequireDefault(_ScrollTop);
	
	var _CategoriesList = __webpack_require__(1160);
	
	var _CategoriesList2 = _interopRequireDefault(_CategoriesList);
	
	var _DateValue = __webpack_require__(373);
	
	var _DateValue2 = _interopRequireDefault(_DateValue);
	
	var _componentsStaticHtml = __webpack_require__(1052);
	
	var _componentsStaticHtml2 = _interopRequireDefault(_componentsStaticHtml);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _newsScss = __webpack_require__(306);
	
	var _newsScss2 = _interopRequireDefault(_newsScss);
	
	var Footer = function Footer(_ref) {
		var sourceIds = _ref.sourceIds;
		var categoryIds = _ref.categoryIds;
	
		return _react2['default'].createElement(
			'div',
			{ className: _newsScss2['default'].footer },
			sourceIds.length > 0 && _react2['default'].createElement(_SourcesList2['default'], { sourceIds: sourceIds }),
			_react2['default'].createElement('div', { className: _newsScss2['default'].divide }),
			_react2['default'].createElement(_CategoriesList2['default'], { categoryIds: categoryIds })
		);
	};
	
	exports.Footer = Footer;
	var Overlay = function Overlay(_ref2) {
		var children = _ref2.children;
		return _react2['default'].createElement(
			'div',
			{ className: _newsScss2['default'].overlayCont },
			_react2['default'].createElement('div', { className: _newsScss2['default'].overlay }),
			children
		);
	};
	
	exports.Overlay = Overlay;
	var NewsContentDom = function NewsContentDom(_ref3) {
		var title = _ref3.title;
		var content = _ref3.content;
		var teaser = _ref3.teaser;
		var date = _ref3.date;
		var sourceIds = _ref3.sourceIds;
		var categoryIds = _ref3.categoryIds;
		var className = _ref3.className;
	
		return _react2['default'].createElement(
			_ScrollTop2['default'],
			{ className: (0, _classnames2['default'])(className, _newsScss2['default'].newsContainer) },
			_react2['default'].createElement(
				'div',
				{ className: _newsScss2['default'].newsCenter },
				_react2['default'].createElement(
					'h2',
					{ className: _newsScss2['default'].title },
					title
				),
				date && _react2['default'].createElement(_DateValue2['default'], { className: _newsScss2['default'].pubDate, date: date }),
				content !== "PREVIEW" && _react2['default'].createElement(_HtmlContent2['default'], { className: _newsScss2['default'].content, content: content }),
				teaser && _react2['default'].createElement(
					Overlay,
					null,
					_react2['default'].createElement(_HtmlContent2['default'], { className: _newsScss2['default'].teaser, content: teaser })
				),
				teaser && _react2['default'].createElement(_componentsStaticHtml2['default'], { className: _newsScss2['default'].cta, id: 'callToAction' }),
				content && categoryIds && sourceIds && _react2['default'].createElement(Footer, {
					categoryIds: categoryIds,
					sourceIds: sourceIds
				})
			)
		);
	};
	
	exports.NewsContentDom = NewsContentDom;
	var NewsContent = function NewsContent(_ref4) {
		var item = _ref4.item;
		var className = _ref4.className;
		var title = item.title;
		var content = item.content;
		var date = item.pubStart;
		var sourceIds = item.sourceIds;
		var categoryIds = item.categoryIds;
	
		var teaser = content === "PREVIEW" && item.teaser;
		return _react2['default'].createElement(NewsContentDom, {
			categoryIds: categoryIds,
			content: content,
			date: date,
			sourceIds: sourceIds,
			title: title,
			className: className,
			teaser: teaser
		});
	};
	exports['default'] = NewsContent;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VirtualList = __webpack_require__(1172);
	
	var _VirtualList2 = _interopRequireDefault(_VirtualList);
	
	var _elementsNewsCell = __webpack_require__(1163);
	
	var _elementsNewsCell2 = _interopRequireDefault(_elementsNewsCell);
	
	var _elementsEmptySearch = __webpack_require__(1162);
	
	var _elementsEmptySearch2 = _interopRequireDefault(_elementsEmptySearch);
	
	var _reactHeight = __webpack_require__(859);
	
	var _reactHeight2 = _interopRequireDefault(_reactHeight);
	
	var _stateStore = __webpack_require__(271);
	
	var _stateStore2 = _interopRequireDefault(_stateStore);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	// here we store the cell heights measured by react-height, we use them for the dynamic row heights
	var heights = {};
	
	var NewsList = (function (_Component) {
		_inherits(NewsList, _Component);
	
		function NewsList() {
			_classCallCheck(this, NewsList);
	
			_get(Object.getPrototypeOf(NewsList.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(NewsList, [{
			key: 'componentDidMount',
	
			// here we give some more time for the recomputeRowHeights before component updates
			value: function componentDidMount() {
				var _this = this;
	
				this.t = setTimeout(function () {
					return _this.forceUpdate();
				}, 1000);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearTimeout(this.t);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props;
				var onOpen = _props.onOpen;
				var newsPosition = _props.newsPosition;
				var list = _props.list;
				var noResults = _props.noResults;
				var filter = _props.filter;
				var isPhone = _props.isPhone;
				var isTablet = _props.isTablet;
	
				var self = this;
	
				// A hacky way to prevent flickering of news list
				var catGen = _stateStore2['default'].getState().categories._gen;
				var srcGen = _stateStore2['default'].getState().sources._gen;
				var b1 = catGen;
				var b2 = srcGen;
	
				// TODO: check why store.getState().categories._gen and store.getState().sources._gen
				// have issues on deployed code, while work perfectly on development
				// for now this fixes the news listing, as side efect the no results also appear
				// while page is loading.
				var contentFooterFetched = Boolean(b1 && b2); // Boolean(catGen && srcGen)
				var listVisible = list.length > 0 || list.length == 0 && !_underscore2['default'].isEmpty(filter); // contentFooterFetched
	
				return _react2['default'].createElement(_VirtualList2['default'], {
					visible: listVisible,
					ref: function (el) {
						self.listEl = el;
						self.listEl && self.listEl.recomputeRowHeights();
					},
					count: list.length,
					rowWidth: 320,
					scrollPosition: newsPosition,
					row: function (_ref) {
						var index = _ref.index;
	
						var item = list[index];
						var id = item._id;
						var date = item.pubStart;
						var teaser = item.teaser;
						var title = item.title;
						var content = item.content;
						var sourceIds = item.sourceIds;
						return _react2['default'].createElement(
							_reactHeight2['default'],
							{
								onHeightReady: function (height) {
									if (heights[id] === height) {
										return;
									}
									heights[id] = height;
									self.listEl && self.listEl.recomputeRowHeights(index);
								}
							},
							_react2['default'].createElement(_elementsNewsCell2['default'], {
								date: date,
								id: id,
								isActive: index === newsPosition,
								isFirst: index === 0,
								isLast: index === list.length - 1,
								newsPosition: newsPosition,
								onOpen: onOpen,
								teaser: teaser,
								content: content,
								title: title,
								sourceIds: sourceIds
							})
						);
					},
					rowHeight: function (i) {
						return heights[list[i.index]._id] || 150;
					},
					noRows: function () {
						return _react2['default'].createElement(
							_elementsEmptySearch2['default'],
							null,
							noResults
						);
					},
					isPhone: isPhone,
					isTablet: isTablet
				});
			}
		}]);
	
		return NewsList;
	})(_react.Component);
	
	exports['default'] = NewsList;
	module.exports = exports['default'];

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementsGrail = __webpack_require__(220);
	
	var _elementsGrail2 = _interopRequireDefault(_elementsGrail);
	
	var _SearchBox = __webpack_require__(1170);
	
	var _SearchBox2 = _interopRequireDefault(_SearchBox);
	
	var _NewsList = __webpack_require__(1165);
	
	var _NewsList2 = _interopRequireDefault(_NewsList);
	
	var _NewsContent = __webpack_require__(1164);
	
	var _NewsContent2 = _interopRequireDefault(_NewsContent);
	
	var _newsScss = __webpack_require__(306);
	
	var _newsScss2 = _interopRequireDefault(_newsScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ = (0, _libI18n2['default'])('news');
	
	var NewsPageDom = function NewsPageDom(_ref) {
		var setFilter = _ref.setFilter;
		var filter = _ref.filter;
		var onOpen = _ref.onOpen;
		var newsToOpen = _ref.newsToOpen;
		var newsPosition = _ref.newsPosition;
		var list = _ref.list;
		var lang = _ref.lang;
		var isPhone = _ref.isPhone;
		var opened = _ref.opened;
		var isTablet = _ref.isTablet;
	
		return _react2['default'].createElement(_elementsGrail2['default'], {
			nav: (!isPhone && !isTablet || !newsToOpen) && _react2['default'].createElement(_elementsGrail2['default'], {
				className: _newsScss2['default'].leftColumn,
				header: _react2['default'].createElement(_SearchBox2['default'], {
					filter: filter,
					filterTitle: _('filter'),
					moduleName: 'news',
					setFilter: setFilter,
					title: _('title')
				}),
				content: _react2['default'].createElement(_NewsList2['default'], {
					lang: lang,
					list: list,
					newsPosition: newsPosition,
					noResults: _('emptySearch'),
					onOpen: onOpen,
					filter: filter,
					isPhone: isPhone,
					isTablet: isTablet
				}),
				extraContentClassName: _newsScss2['default'].extraClass,
				wrapperClass: _newsScss2['default'].contentWrapper
			}),
			content: newsToOpen && _react2['default'].createElement(_NewsContent2['default'], {
				item: newsToOpen,
				lang: lang
			}),
			extraClassName: (0, _classnames2['default'])(_newsScss2['default'].fixHeight, _newsScss2['default'].fixMobileContent, _newsScss2['default'].fixMobilePadding)
		});
	};
	exports['default'] = NewsPageDom;
	module.exports = exports['default'];

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsReactable = __webpack_require__(17);
	
	var _componentsNoResults = __webpack_require__(81);
	
	var _componentsNoResults2 = _interopRequireDefault(_componentsNoResults);
	
	var _elementsDateValue = __webpack_require__(373);
	
	var _elementsDateValue2 = _interopRequireDefault(_elementsDateValue);
	
	var _componentsReactableScss = __webpack_require__(101);
	
	var _componentsReactableScss2 = _interopRequireDefault(_componentsReactableScss);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _ = (0, _libI18n2['default'])('adminDocs');
	
	var OfficeAdminDom = function OfficeAdminDom(_ref) {
		var children = _ref.children;
	
		return _react2['default'].createElement(
			'div',
			null,
			children && children.length > 0 ? _react2['default'].createElement(
				'div',
				{ className: _componentsReactableScss2['default'].tableContainer },
				_react2['default'].createElement(
					_componentsReactable.Table,
					{
						className: 'table',
						itemsPerPage: 7,
						filterPlaceholder: _('placeholder'),
						filterable: ['documentType', 'documentDate'],
						noDataText: _react2['default'].createElement(_componentsNoResults2['default'], { type: 'adminDocs' }),
						sortable: ['documentId', {
							column: 'documentDate',
							sortFunction: 'Date'
						}, 'documentType'],
						defaultSort: {
							column: 'documentDate',
							direction: 'desc'
						}
					},
					_react2['default'].createElement(
						_componentsReactable.Thead,
						null,
						_react2['default'].createElement(_componentsReactable.Th, { column: 'documentIcon', label: '' }),
						_react2['default'].createElement(
							_componentsReactable.Th,
							{ column: 'documentType' },
							_react2['default'].createElement(
								'strong',
								null,
								_('type')
							)
						),
						_react2['default'].createElement(
							_componentsReactable.Th,
							{
								column: 'documentDate',
								className: _componentsReactableScss2['default'].date
							},
							_react2['default'].createElement(
								'strong',
								null,
								_('date')
							)
						)
					),
					children.map(function (item) {
						return _react2['default'].createElement(
							_componentsReactable.Tr,
							{
								onClick: function () {
									return window.open('/data/document?id=' + item.documentId, '_blank', 'noopener,noreferrer');
								},
								className: 'clickable centered docRow',
								key: item.documentId
							},
							_react2['default'].createElement(
								_componentsReactable.Td,
								{ column: 'documentIcon' },
								_react2['default'].createElement(
									'div',
									{ className: 'rowIcon' },
									_react2['default'].createElement('img', { src: __webpack_require__(172) })
								)
							),
							_react2['default'].createElement(_componentsReactable.Td, {
								column: 'documentType',
								data: _('ora:adminDocs_' + item.documentType)
							}),
							_react2['default'].createElement(
								_componentsReactable.Td,
								{
									column: 'documentDate',
									value: item.documentDate
								},
								_react2['default'].createElement(_elementsDateValue2['default'], { date: item.documentDate })
							)
						);
					})
				)
			) : _react2['default'].createElement(_componentsNoResults2['default'], { type: 'adminDocs' })
		);
	};
	
	exports['default'] = OfficeAdminDom;
	module.exports = exports['default'];

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(15);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _PrintModalScss = __webpack_require__(1637);
	
	var _PrintModalScss2 = _interopRequireDefault(_PrintModalScss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HtmlContent = __webpack_require__(110);
	
	var _HtmlContent2 = _interopRequireDefault(_HtmlContent);
	
	var _HtmlContentScss = __webpack_require__(723);
	
	var _HtmlContentScss2 = _interopRequireDefault(_HtmlContentScss);
	
	var _nestedProperty = __webpack_require__(10);
	
	var _nestedProperty2 = _interopRequireDefault(_nestedProperty);
	
	var _reactRedux = __webpack_require__(4);
	
	var customStyles = {
	    overlay: {
	        position: 'fixed',
	        top: 0, left: 0, right: 0, bottom: 0,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        backgroundColor: 'rgba(255, 255, 255, 0.75)'
	    },
	    content: {
	        position: 'relative',
	        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
	        maxHeight: '90%',
	        overflow: 'auto',
	        padding: '0'
	    }
	};
	
	var PrintModal = (function (_React$Component) {
	    _inherits(PrintModal, _React$Component);
	
	    _createClass(PrintModal, null, [{
	        key: 'propTypes',
	        value: {
	            onCancel: _react2['default'].PropTypes.func,
	            onConfirmation: _react2['default'].PropTypes.func,
	            cancelLabel: _react2['default'].PropTypes.string,
	            confirmationLabel: _react2['default'].PropTypes.string,
	            options: _react2['default'].PropTypes.object
	        },
	        enumerable: true
	    }]);
	
	    function PrintModal(props) {
	        _classCallCheck(this, _PrintModal);
	
	        _get(Object.getPrototypeOf(_PrintModal.prototype), 'constructor', this).call(this, props);
	        this.state = { templates: null };
	    }
	
	    /**
	     * This function opens a print window with the modal content
	     */
	
	    _createClass(PrintModal, [{
	        key: 'onPrint',
	        value: function onPrint() {
	            var printModal = this.props.printModal;
	
	            var theWindow = window.open('', 'PRINT', 'height=600,width=800');
	            theWindow.document.write('<html><head><title>' + printModal.title + '</title>');
	            theWindow.document.write('<style>');
	            // this line of css made from HtmlContent.scss -> replace variables -> convert to css -> minify
	            theWindow.document.write(".content ol,.content p,.content ul{margin:0 0 10px;color:#404548}.content em{font-style:italic}.content strong{font-weight:700}.content p.highlight{font-weight:700}.content p.bullet{padding-left:1em;text-indent:-1em}.content p.bullet::before{content:'•';padding-right:.5em}.content ol,.content ul{padding-left:20px}.content ol li,.content ul li{margin-left:1em}.content ol{list-style-type:decimal}.content ul{list-style-type:circle}.content h1{font-size:1.4em}.content h2{font-size:1.2em}.content h1,.content h2,.content h3,.content h4,.content h5,.content h6{font-weight:lighter;margin-top:1em;margin-bottom:.5em}.content hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.content blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}.content pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}.content pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}");
	            theWindow.document.write('</style>');
	            theWindow.document.write('</head><body class="content">');
	            theWindow.document.write(printModal.message);
	            theWindow.document.write('</body></html>');
	            theWindow.document.close(); // IE >= 10
	            theWindow.focus(); // IE >= 10
	            theWindow.print();
	            // theWindow.close()
	
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var _props = this.props;
	            var printModal = _props.printModal;
	            var onCancel = _props.onCancel;
	            var onConfirmation = _props.onConfirmation;
	            var cancelLabel = _props.cancelLabel;
	            var confirmationLabel = _props.confirmationLabel;
	            var options = _props.options;
	
	            var hasCancelButtonStyle = _nestedProperty2['default'].get(options, 'hasCancelButtonStyle');
	            var noButtons = _nestedProperty2['default'].get(options, 'noButtons');
	            var showPrintButton = _nestedProperty2['default'].get(options, 'showPrintButton');
	            var printButtonLabel = _nestedProperty2['default'].get(options, 'printButtonLabel') || "";
	
	            var modalId = _nestedProperty2['default'].get(printModal, "modalId");
	            var isOpen = _nestedProperty2['default'].get(printModal, modalId + "IsOpen");
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    _reactModal2['default'],
	                    {
	                        isOpen: isOpen,
	                        onCancel: onCancel,
	                        style: customStyles,
	                        className: _PrintModalScss2['default'].modal,
	                        contentLabel: ""
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { id: "printerId" },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _PrintModalScss2['default'].title },
	                            printModal && printModal.title
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: _PrintModalScss2['default'].contentWrapper },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _PrintModalScss2['default'].content },
	                                printModal && _react2['default'].createElement(_HtmlContent2['default'], { className: '', content: printModal.message })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: _PrintModalScss2['default'].buttons },
	                                !noButtons && _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: onCancel,
	                                        className: (0, _classnames2['default'])(hasCancelButtonStyle ? _PrintModalScss2['default'].cancel : "")
	                                    },
	                                    cancelLabel
	                                ),
	                                !noButtons && showPrintButton && _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: function () {
	                                            _this.onPrint(printModal);
	                                        },
	                                        className: (0, _classnames2['default'])(_PrintModalScss2['default'].next, _PrintModalScss2['default'].enabled)
	                                    },
	                                    printButtonLabel
	                                ),
	                                !noButtons && _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        onClick: onConfirmation,
	                                        className: (0, _classnames2['default'])(_PrintModalScss2['default'].next, _PrintModalScss2['default'].enabled)
	                                    },
	                                    confirmationLabel
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    var _PrintModal = PrintModal;
	    PrintModal = (0, _reactRedux.connect)(function (state) {
	        return {
	            printModal: state.app.printModal
	        };
	    })(PrintModal) || PrintModal;
	    return PrintModal;
	})(_react2['default'].Component);
	
	exports['default'] = PrintModal;
	module.exports = exports['default'];

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ScrollTopScss = __webpack_require__(1639);
	
	var _ScrollTopScss2 = _interopRequireDefault(_ScrollTopScss);
	
	var ScrollTop = (function (_Component) {
		_inherits(ScrollTop, _Component);
	
		function ScrollTop() {
			_classCallCheck(this, ScrollTop);
	
			_get(Object.getPrototypeOf(ScrollTop.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ScrollTop, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.me.scrollTop = 0;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				return _react2['default'].createElement('div', _extends({}, this.props, {
					className: (0, _classnames2['default'])(_ScrollTopScss2['default'].cont, this.props.className),
					ref: function (el) {
						return _this.me = el;
					}
				}));
			}
		}]);
	
		return ScrollTop;
	})(_react.Component);
	
	ScrollTop.propTypes = {
		children: _react.PropTypes.node
	};
	
	exports['default'] = ScrollTop;
	module.exports = exports['default'];

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SearchBoxScss = __webpack_require__(724);
	
	var _SearchBoxScss2 = _interopRequireDefault(_SearchBoxScss);
	
	var SearchBox = function SearchBox(_ref) {
	  var title = _ref.title;
	  var filter = _ref.filter;
	  var setFilter = _ref.setFilter;
	  var filterTitle = _ref.filterTitle;
	  return _react2["default"].createElement(
	    "div",
	    { className: _SearchBoxScss2["default"].searchBox },
	    _react2["default"].createElement(
	      "h2",
	      null,
	      title
	    ),
	    _react2["default"].createElement(
	      "div",
	      { className: _SearchBoxScss2["default"].searchContainer },
	      _react2["default"].createElement("div", { className: "" + _SearchBoxScss2["default"].searchLogo }),
	      _react2["default"].createElement("input", {
	        autoFocus: true,
	        placeholder: filterTitle,
	        className: _SearchBoxScss2["default"].mainSearch + " " + _SearchBoxScss2["default"].leftLogo,
	        value: filter,
	        onChange: function (ev) {
	          return setFilter(ev.target.value);
	        },
	        onFocus: function (e) {
	          // the following to move caret at the end
	          var temp_value = e.target.value;
	          e.target.value = '';
	          e.target.value = temp_value;
	        }
	      }),
	      filter && _react2["default"].createElement(
	        "div",
	        { onClick: function () {
	            return setFilter();
	          }, className: _SearchBoxScss2["default"].removeFilter },
	        _react2["default"].createElement(
	          "span",
	          { className: _SearchBoxScss2["default"].cross },
	          "×"
	        )
	      )
	    )
	  );
	};
	SearchBox.propTypes = {
	  content: _react2["default"].PropTypes.string
	};
	
	exports["default"] = SearchBox;
	module.exports = exports["default"];

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _libI18n = __webpack_require__(3);
	
	var _libI18n2 = _interopRequireDefault(_libI18n);
	
	var _newsScss = __webpack_require__(306);
	
	var _newsScss2 = _interopRequireDefault(_newsScss);
	
	var _ = (0, _libI18n2['default'])();
	
	var SourcesList = function SourcesList(_ref) {
		var sourceIds = _ref.sourceIds;
		var customStyle = _ref.customStyle;
		return _react2['default'].createElement(
			'div',
			{ className: _newsScss2['default'].linkList },
			_('news_sources'),
			':',
			sourceIds && sourceIds.length && sourceIds.map(function (sourceId, i) {
				var source = (0, _libI18n.sourceIdToObj)(sourceId);
				return _react2['default'].createElement(
					'a',
					{
						key: i,
						href: source.url,
						target: '_blank',
						rel: 'noopener noreferrer'
					},
					source.name
				);
			})
		);
	};
	SourcesList.propTypes = {
		sourceIds: _react.PropTypes.arrayOf(_react.PropTypes.string),
		customStyle: _react.PropTypes.object
	};
	
	exports['default'] = SourcesList;
	module.exports = exports['default'];

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(2132);
	
	__webpack_require__(1577);
	
	var VirtualList = (function (_Component) {
		_inherits(VirtualList, _Component);
	
		function VirtualList() {
			_classCallCheck(this, VirtualList);
	
			_get(Object.getPrototypeOf(VirtualList.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(VirtualList, [{
			key: 'recomputeRowHeights',
			value: function recomputeRowHeights(i) {
				var vsEl = this.vsEl;
	
				if (!vsEl) {
					return;
				}
				vsEl.recomputeRowHeights(i);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var gen = _props.gen;
				var count = _props.count;
				var scrollPosition = _props.scrollPosition;
				var row = _props.row;
				var noRows = _props.noRows;
				var rowHeight = _props.rowHeight;
				var rowWidth = _props.rowWidth;
				var visible = _props.visible;
				var isPhone = _props.isPhone;
				var isTablet = _props.isTablet;
	
				return _react2['default'].createElement(
					_reactVirtualized.AutoSizer,
					null,
					function (_ref) {
						var height = _ref.height;
						var width = _ref.width;
						return _react2['default'].createElement(_reactVirtualized.VirtualScroll, {
							style: { 'display': visible ? 'block' : 'none' },
							gen: gen,
							ref: function (el) {
								_this.vsEl = el;
							},
							height: height,
							noRowsRenderer: noRows,
							rowHeight: rowHeight,
							rowRenderer: row,
							rowCount: count,
							scrollToIndex: scrollPosition,
							width: isPhone || isTablet ? Math.max(rowWidth, width) : Math.min(rowWidth, width)
						});
					}
				);
			}
		}]);
	
		return VirtualList;
	})(_react.Component);
	
	VirtualList.propTypes = {
		count: _react.PropTypes.number
	};
	exports['default'] = VirtualList;
	module.exports = exports['default'];

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _debug = __webpack_require__(708);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _stateLocation = __webpack_require__(618);
	
	var _stateLocation2 = _interopRequireDefault(_stateLocation);
	
	var _stateStore = __webpack_require__(271);
	
	var _stateStore2 = _interopRequireDefault(_stateStore);
	
	__webpack_require__(1574);
	
	var _stateActionsApi = __webpack_require__(125);
	
	// ease debugging
	
	var _stateActions = __webpack_require__(5);
	
	//import {initializeGa} from 'lib/helpers'
	
	//initializeGa(window.location.hostname)
	var dispatch = _stateStore2['default'].dispatch;
	
	var PROD = ("production") === "production";
	
	window.myDebug = _debug2['default'];
	window.store = _stateStore2['default'];
	window.actions = __webpack_require__(5);
	console.warn('Run `myDebug.enable("*,-sockjs-client:*")` to see debug messages');
	
	if (PROD) {
		window.onerror = function (message, source, lineno, colno, error) {
			(0, _stateActionsApi.apiCallReal)('/browserError', function () {}, {
				error: error.stack,
				version: ("10.0-159-ge9cd7ea95")
			});
			console.log('sending error info to server');
			return false;
		};
	}
	
	var lang = localStorage.getItem('clientLanguage');
	switch (lang) {
		case 'nl':
		case 'en':
		case 'fr':
			break;
	
		default:
			lang = 'nl';
	}
	
	window.lang = lang;
	
	dispatch((0, _stateActions.checkLoggedIn)());
	dispatch((0, _stateActions.checkIfIE)());
	
	var rab = (0, _stateLocation2['default'])(window.store);
	
	var isIE = _stateStore2['default'].getState().app.isIE;
	
	var self = document.getElementById('app');
	
	if (isIE) {
		self.setAttribute("class", "ieStyles");
	}
	
	var _require = __webpack_require__(24);
	
	var mountReact = _require.mountReact;
	var makeApp = _require.makeApp;
	
	var Main = __webpack_require__(1110);
	var App = makeApp(Main, { onClick: function onClick(e) {
			return rab.interceptClicks(e);
		} });
	
	mountReact(self, App, {}, true);

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports.mediaChange = mediaChange;
	exports.mediaQueryTracker = mediaQueryTracker;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _stateConstants = __webpack_require__(11);
	
	function mediaChange(data) {
		return {
			type: _stateConstants.MEDIA_CHANGED,
			data: data
		};
	}
	
	// TODO untrack when hot reloading
	
	var initData = undefined;
	
	var trackInnerWidth = false;
	var trackInnerHeight = false;
	var onResize = undefined;
	var getSizes = function getSizes(data) {
		if (trackInnerWidth) {
			data.innerWidth = global.innerWidth;
		}
		if (trackInnerHeight) {
			data.innerHeight = global.innerHeight;
		}
	};
	var makeOnResize = function makeOnResize(dispatch) {
		return function () {
			var data = {};
			getSizes(data);
			dispatch(mediaChange(data));
		};
	};
	function trackMediaQuery(label, query, dispatch) {
		if (label === 'innerWidth' || label === 'innerHeight') {
			if (label === 'innerWidth') {
				trackInnerWidth = true;
			}
			if (label === 'innerHeight') {
				trackInnerHeight = true;
			}
			if (!onResize) {
				onResize = makeOnResize(dispatch);
				if (global.addEventListener) {
					global.addEventListener('resize', onResize, true);
				}
			}
			getSizes(initData);
			return;
		}
	
		var mq = global.matchMedia(query);
	
		var listener = function listener() {
			return dispatch(mediaChange(_defineProperty({}, label, mq.matches)));
		};
	
		mq.addListener(listener);
	
		initData[label] = mq.matches;
	}
	
	function mediaQueryTracker(queries) {
		return function (dispatch) {
			if (global.matchMedia) {
				initData = {};
				for (var label in queries) {
					trackMediaQuery(label, queries[label], dispatch);
				}
				dispatch(mediaChange(initData));
			}
		};
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactGa = __webpack_require__(212);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _stateConstants = __webpack_require__(11);
	
	var _stateConstants2 = _interopRequireDefault(_stateConstants);
	
	var filter = [_stateConstants2['default'].LOG_IN, _stateConstants2['default'].LOGGED_OUT, _stateConstants2['default'].ITEM_ZOOMED, _stateConstants2['default'].TOGGLE_MENU, _stateConstants2['default'].MEDIA_CHANGED];
	
	exports['default'] = function (store) {
		return function (next) {
			return function (action) {
				if (filter.indexOf(action.type) >= 0) {
					_reactGa2['default'].event({ category: 'Actions',
						action: JSON.stringify(action)
					});
				}
	
				var result = next(action);
				return result;
			};
		};
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* globals DEBUG */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = storeFactory;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(351);
	
	var _reduxThunk = __webpack_require__(2230);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(2229);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _gaMiddleware = __webpack_require__(1175);
	
	var _gaMiddleware2 = _interopRequireDefault(_gaMiddleware);
	
	var _stateActionsMediaQueryTracker = __webpack_require__(1174);
	
	var _stateReducers = __webpack_require__(1177);
	
	var reducers = _interopRequireWildcard(_stateReducers);
	
	function storeFactory(initialState) {
		var reducer = (0, _redux.combineReducers)(reducers);
		var devtoolsExt = global.devToolsExtension && global.devToolsExtension();
	
		var middleWares = [_reduxThunk2['default']];
		if (false) {
			if (!devtoolsExt) {
				// We don't have the Redux extension in the browser, show the Redux log
				var logger = (0, _reduxLogger2['default'])();
				middleWares.push(logger);
			}
		} else {
			// Only enable Google Analytics in production build
			middleWares.push(_gaMiddleware2['default']);
		}
	
		var storeWrapper = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleWares), devtoolsExt || function (f) {
			return f;
		});
		var store = (0, _redux.createStore)(reducer, initialState, storeWrapper);
	
		store.dispatch((0, _stateActionsMediaQueryTracker.mediaQueryTracker)({
			isPhone: "screen and (max-width: 768px)",
			isTablet: "screen and (max-width: 1024px) and (orientation: portrait)",
			innerWidth: true
		}));
	
		return store;
	}
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* globals isClient */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _extends=Object.assign || function(target){for(var i=1;i < arguments.length;i++) {var source=arguments[i];for(var key in source) {if(Object.prototype.hasOwnProperty.call(source,key)){target[key] = source[key];}}}return target;};exports.responsive = responsive;function _interopRequire(obj){return obj && obj.__esModule?obj['default']:obj;}function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _interopRequireWildcard(obj){if(obj && obj.__esModule){return obj;}else {var newObj={};if(obj != null){for(var key in obj) {if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key] = obj[key];}}newObj['default'] = obj;return newObj;}}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i < arr.length;i++) arr2[i] = arr[i];return arr2;}else {return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key] = value;}return obj;}var _stateConstants=__webpack_require__(11);var c=_interopRequireWildcard(_stateConstants);var _lodashLang=__webpack_require__(78);var _lodashObject=__webpack_require__(330);var _lodashCollection=__webpack_require__(55);var _underscore=__webpack_require__(22);var _underscore2=_interopRequireDefault(_underscore);var _moment=__webpack_require__(12);var _moment2=_interopRequireDefault(_moment);var _nestedProperty=__webpack_require__(10);var _nestedProperty2=_interopRequireDefault(_nestedProperty);var _jsCookie=__webpack_require__(733);var _jsCookie2=_interopRequireDefault(_jsCookie); // import {isDocumentMustBeSigned} from "./../components/DSDocuments/DSWizardHelper"
	var _uuidV4=__webpack_require__(61);var _uuidV42=_interopRequireDefault(_uuidV4);var _reduxForm=__webpack_require__(57);Object.defineProperty(exports,'form',{enumerable:true,get:function get(){return _reduxForm.reducer;}});var _ducksCategories=__webpack_require__(615);exports.categories = _interopRequire(_ducksCategories);var _ducksSources=__webpack_require__(616);exports.sources = _interopRequire(_ducksSources);var _ducksText=__webpack_require__(617);exports.text = _interopRequire(_ducksText);var _componentsWilldocWilDuck=__webpack_require__(611);exports.willdoc = _interopRequire(_componentsWilldocWilDuck);var registration=function registration(state,action){if(state === undefined)state = {};switch(action.type){case c.FORM_SUBMITTED:return {isSending:true};case c.REG_RESULT:if(action.ok){return {sent:true};}return {problem:action.err};case c.RESET_REG:return {};default:return state;}};exports.registration = registration;var flashDefaults={items:[]};var flash=function flash(state,action){if(state === undefined)state = flashDefaults;switch(action.type){case c.GOT_FLASH:return {items:action.items,ts:action.ts}; // Comented out as it messes up the flases, flash method is colled evcery time metro ui is accesed
	// case c.GOT_NEWS:
	// 	return {
	// 		items: action.items.filter(item => item.newsflash || item.isFlash ),
	// 		ts: action.ts,
	// 	}
	case c.LANG_SET:case c.LOGGED_OUT:return flashDefaults;default:return state;}};exports.flash = flash;var newsDefaults={items:[],flash:[],filter:'',loaded:false,lastLogin:null,newNewsCount:0};var news=function news(state,action){if(state === undefined)state = newsDefaults;switch(action.type){case c.GOT_NEWS:return _extends({},state,{ // JSON dates sort lexographically
	items:action.items.sort(function(a,b){return b.pubStart.localeCompare(a.pubStart);}), // flash: action.items.filter(item => item.newsflash),
	ts:action.ts,lastLogin:action.lastLogin,newNewsCount:countNewNews(action.items,action.lastLogin)});case c.NEWS_FILTERED:return _extends({},state,{filter:action.filter || ''});case c.NEWS_LOADED:return _extends({},state,{loaded:true});case c.LOGGED_OUT:return newsDefaults;case c.NEWS_SELECT:return _extends({},state,{opened:action.itemId});default:return state;}};exports.news = news;var countNewNews=function countNewNews(news,lastLogin){var newNewsCount=0;if(!lastLogin){newNewsCount = news.length;return newNewsCount;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=news[Symbol.iterator](),_step;!(_iteratorNormalCompletion = (_step = _iterator.next()).done);_iteratorNormalCompletion = true) {var n=_step.value;if((0,_moment2['default'])(lastLogin).isBefore(n.pubStart)){++newNewsCount;}}}catch(err) {_didIteratorError = true;_iteratorError = err;}finally {try{if(!_iteratorNormalCompletion && _iterator['return']){_iterator['return']();}}finally {if(_didIteratorError){throw _iteratorError;}}}return newNewsCount;};var faqDefaults={items:[],filter:''};var faq=function faq(state,action){if(state === undefined)state = faqDefaults;switch(action.type){case c.GOT_FAQ:{var items=action.items;return _extends({},state,{items:items});}case c.FAQ_FILTERED:return _extends({},state,{filter:action.filter || ''});case c.LANG_SET:case c.LOGGED_OUT:return faqDefaults;default:return state;}};exports.faq = faq;var linksDefaults={items:[],filter:''};var links=function links(state,action){if(state === undefined)state = linksDefaults;switch(action.type){case c.GOT_LINKS:return _extends({},state,{items:action.items});case c.LINKS_FILTERED:return _extends({},state,{filter:action.filter || ''});case c.LANG_SET:case c.LOGGED_OUT:return linksDefaults;default:return state;}};exports.links = links;var filterTicketsByTaskStatus=function filterTicketsByTaskStatus(item,status){var booleanStatus=status === 'completed'?true:false;var showItem=false;if(item && item.relatedTasks && item.relatedTasks.length){item.relatedTasks.map(function(relatedTask,key){if(relatedTask.isCompleted === booleanStatus){showItem = true;}});}return showItem;};exports.filterTicketsByTaskStatus = filterTicketsByTaskStatus;var inboxFilters={showUnread:function showUnread(item){return item.unread;},showRead:function showRead(item){return !item.unread;},showAll:function showAll(){return true;},hasTaskCompleted:function hasTaskCompleted(item){return filterTicketsByTaskStatus(item,'completed');},hasTaskUncompleted:function hasTaskUncompleted(item){return filterTicketsByTaskStatus(item,'uncompleted');}};var calcUnread=function calcUnread(items){return items.reduce(function(a,i){return a + (i.unread?1:0);},0);};var inboxDefaults={items:[],staff:[],filter:'',unreadCount:0,selectValue:'showAll',archiveData:{modalIsOpen:false,message:''}};var inbox=function inbox(state,action){if(state === undefined)state = inboxDefaults;switch(action.type){case c.GOT_INBOX:{var _ret=(function(){var shouldShow=inboxFilters[state.selectValue];var items=action.data.map(function(item){var documentNames='';if(item.ticket.documents && item.ticket.documents.length > 0){item.ticket.documents.map(function(documentItem){documentNames = documentNames + documentItem + ' ';});}return {id:item.ticket._id,ticketDate:item.ticket.ticketDate,ticketDescription:item.ticket.ticketDescription,ticketType:item.ticket.ticketType,ticketDetails:item.ticket.ticketDetails,typeDocument:item.ticket.typeDocument,ticketDocumentNames:documentNames,ticketUniqueId:item.ticket.ticketRelation,documents:item.ticket.documents,unread:item.ticket.unread,archived:item.ticket.archived,hidden:!shouldShow(item.ticket),relatedTasks:item.tasks,unlinkedDocumentId:item.ticket.unlinkedDocumentId,unlinkedDocumentFileName:item.ticket.unlinkedDocumentFileName,signatureDocuments:item.ticket.signatureDocuments,statusFromPackage:item.ticket.statusFromPackage,linkedClient:item.ticket.linkedClient};});return {v:_extends({},state,{items:items,unreadCount:calcUnread(items),ts:action.ts})};})();if(typeof _ret === 'object')return _ret.v;}case c.TICKETS_FILTERED:return _extends({},state,{filter:action.filter || ''});case c.SET_FILTERED:{var _ret2=(function(){var selectValue=action.selectValue;var shouldShow=inboxFilters[selectValue];return {v:_extends({},state,{items:state.items.map(function(item){return _extends({},item,{hidden:!shouldShow(item)});}),selectValue:selectValue})};})();if(typeof _ret2 === 'object')return _ret2.v;}case c.INBOX_ARCHIVE_CLEAN_SELECTED_ITEMS:{var items=state.items;if(items.length){items.map(function(value,key){value.checked = false;});}return _extends({},state);}case c.SET_ALL_VISIBLE_CHECKED:{var _ret3=(function(){var items=action.visibleItems;var vI=items.length;var cI=state.items.reduce(function(acc,item){return acc + (item.checked && items.includes(item.id)?1:0);},0);var toCheck=vI !== cI;return {v:_extends({},state,{items:state.items.map(function(item){return _extends({},item,{checked:items.includes(item.id)?toCheck:item.checked});})})};})();if(typeof _ret3 === 'object')return _ret3.v;}case c.SET_ALL_CHECKED:{return _extends({},state,{items:state.items.map(function(item){return _extends({},item,{checked:true});})});}case c.SET_ALL_UNCHECKED:{return _extends({},state,{items:state.items.map(function(item){return _extends({},item,{checked:false});})});}case c.SET_CHECKBOX:return _extends({},state,{items:state.items.map(function(item){return _extends({},item,{checked:item.id === action.id?!item.checked:item.checked});})});case c.LOGGED_OUT:return inboxDefaults;case c.INBOX_ITEMS_STATUS:{var _ret4=(function(){var ticketIds=action.ticketIds;var _action$status=action.status;var unread=_action$status.unread;var archived=_action$status.archived;var newItems=state.items.map(function(i){if(ticketIds.includes(i.id)){return _extends({},i,{unread:unread == null?i.unread:unread,archived:archived == null?i.archived:archived});}return i;});return {v:_extends({},state,{items:newItems,unreadCount:calcUnread(newItems)})};})();if(typeof _ret4 === 'object')return _ret4.v;}case c.SET_UNREAD_NUM:return _extends({},state,{unreadCount:action.number}); /**
			 *  UPDATE INBOX REDUCERS WITH THE NEW CONVERT AND ARCHIVER TOOLS
			 ******************************************************************/case c.INBOX_ARCHIVE_SET_STAFF_LIST:{var _ret5=(function(){var staffList=[];if(action.response.length){action.response.map(function(value,key){var userData=value;userData['selected'] = false;staffList[key] = userData;});}return {v:_extends({},state,{staff:staffList})};})();if(typeof _ret5 === 'object')return _ret5.v;}case c.INBOX_ARCHIVE_RESET_STAFF_LIST:{state.staff.map(function(value,key){if(value.selected == true){value.selected = false;}});state.archiveData.message = '';return _extends({},state);}case c.INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS:{state.archiveData = {modalIsOpen:false,message:''};return _extends({},state);}case c.INBOX_ARCHIVE_CONVERT_TICKET_ERROR:{var archiveData=state.archiveData;if(action.err && action.err.message){archiveData.message = action.err.message;}else {archiveData.message = 'Something went wrong please try again later';}return _extends({},state,{archiveData:_extends({},archiveData)});}case c.INBOX_ARCHIVE_MODAL_TOGGLE:{var newArchiveData=state.archiveData;newArchiveData.modalIsOpen = !state.archiveData.modalIsOpen;return _extends({},state,{archiveData:newArchiveData});}case c.GET_CLIENT_ID:{return _extends({},state,{clientId:action.clientId});}default:return state;}};exports.inbox = inbox; /**
	 * TASK MODULE REDUCERS
	 *
	 * Contains all reducers for task module
	 **********************************************************************************************************************/var shouldShowByStatus={showCompleted:function showCompleted(item){return item.isCompleted;},showUncompleted:function showUncompleted(item){return !item.isCompleted;},showAll:function showAll(){return true;}};var taskModuleDefaults={ // Task list data and filters
	items:[],uncompleted:0,filter:'',filterStatusValue:'showAll',filterColorValue:[], // Colors list data
	colorsList:{userColors:[],defaultColors:[]}, // Task form data
	manageTask:{message:null,status:null,taskId:null,isEdit:false}, // Manage colors form data
	manageColors:{message:null,status:null}, // Color picker form data
	manageColorPicker:{message:null,status:null,colorId:null,isEdit:false},notification:{type:'',itemId:null}, // Todo module modals states
	modals:{manageTask:false,manageColors:false,manageColorPicker:false,notification:false,sendTask:false}}; // Function to calculate how many uncompleted task we have
	var calcUncompleted=function calcUncompleted(items){return items.filter(function(item){return !item.isDeleted;}).reduce(function(accumulator,currentValue,currentIndex,array){if(currentValue.isCompleted == false){var currentDate=(0,_moment2['default'])().set({hour:0,minute:0,second:0,millisecond:0});var itemEndDate=(0,_moment2['default'])(currentValue.endDate);if(itemEndDate.isBefore(currentDate) || itemEndDate.isSame(currentDate)){accumulator++;}}return accumulator;},0);}; // Checks if item can be showable or not based on filters
	var shouldShowTask=function shouldShowTask(item,filterStatusValue,filterColorValue){var response=null; // Filter items based on filter status value
	var shouldShowBS=shouldShowByStatus[filterStatusValue];response = shouldShowBS(item); // Filter items based on filterColorValue
	// Note that this variable is an array with multiple objects if any color is selected
	if(_underscore2['default'].isArray(filterColorValue) && filterColorValue.length > 0){if(response == false){return response;}var showable=false;filterColorValue.map(function(value,index){if(value.value == item.colorCode){showable = true;}});return showable;}return response;};var setColorHex=function setColorHex(colorId,colorsList){var colorsArray=[].concat(_toConsumableArray(colorsList.defaultColors),_toConsumableArray(colorsList.userColors));if(colorId == null){return null;}var response=null;colorsArray.map(function(value){if(value.value == colorId){response = value.colorCode;}});return response;}; /**
	 * Task list reducer group where we listen to every action dispached
	 */var taskList=function taskList(state,action){if(state === undefined)state = taskModuleDefaults;switch(action.type){ /**
			 * TASK LIST MANAGER
			 *
			 * Contains all action listeners that manage the lists like task,taskDefaultColors, taskUserColors
			 */case c.TASK_MODULE_LIST_SET:{var items=action.tasks.map(function(item){if(item.task.endDate && !(0,_moment2['default'])(item.task.endDate).isValid()){console.error("Invalid end date for task id:",item.task._id," -> ",item.task.endDate);}return {id:item.task._id,ticketReferral:item.task.ticketReferral,taskRelation:item.task.taskRelation,title:item.task.title,description:item.task.description,colorCode:item.task.colorCode,endDate:item.task.endDate || "",isCompleted:item.task.isCompleted,isDeleted:item.task.isDeleted,isUnreaded:item.task.isUnreaded,ticketDocuments:item.task.ticketDocuments,ticketDoctype:item.task.ticketDoctype,createdAt:item.task.createdAt,hexColor:setColorHex(item.task.colorCode,state.colorsList),hidden:!shouldShowTask(item.task,state.filterStatusValue,state.filterColorValue),checked:false,globalSort:(item.task.endDate || "") + '|' + item.task.isCompleted,relations:item.relations,receivedFrom:item.receivedFrom};}); //userRelation: item.task.userRelation
	return _extends({},state,{items:items,uncompleted:calcUncompleted(items)});}case c.TASK_MODULE_LIST_DEFAULT_COLORS_SET:{var colorsList={userColors:state.colorsList.userColors,defaultColors:state.colorsList.defaultColors};var defaultColors=action.taskColors.map(function(item){return {value:item._id,label:item.title,colorCode:item.colorCode};});colorsList.defaultColors = defaultColors;return _extends({},state,{colorsList:colorsList});}case c.TASK_MODULE_LIST_USER_COLORS_SET:{var colorsList={userColors:state.colorsList.userColors,defaultColors:state.colorsList.defaultColors};var userColors=action.taskColors.map(function(item){return {value:item._id,label:item.title,colorCode:item.colorCode};});colorsList.userColors = userColors;return _extends({},state,{colorsList:colorsList});}case c.TASK_MODULE_FILTER:{var _ret6=(function(){var _action$filterOptions=action.filterOptions;var filterStatusValue=_action$filterOptions.filterStatusValue;var filterColorValue=_action$filterOptions.filterColorValue;filterColorValue.map(function(value,index){if(value.value == 'reset_filter'){filterColorValue = [];}});return {v:_extends({},state,{items:state.items.map(function(item){return _extends({},item,{hidden:!shouldShowTask(item,filterStatusValue,filterColorValue)});}),filterStatusValue:filterStatusValue,filterColorValue:filterColorValue})};})();if(typeof _ret6 === 'object')return _ret6.v;}case c.TASK_MODULE_FILTER_CLEAN:{var _ret7=(function(){var _state$colorsList=state.colorsList;var userColors=_state$colorsList.userColors;var defaultColors=_state$colorsList.defaultColors;var filterColorValue=state.filterColorValue;var colorsData=[].concat(_toConsumableArray(userColors),_toConsumableArray(defaultColors));var newFilterData=[];filterColorValue.map(function(value,key){var isColor=false;colorsData.map(function(colorValue,colorKey){if(value.value == colorValue.value){isColor = true;}});if(isColor == true){newFilterData.push(value);}});filterColorValue = newFilterData;return {v:_extends({},state,{filterColorValue:filterColorValue})};})();if(typeof _ret7 === 'object')return _ret7.v;} /**
			 * MODALS MANAGER
			 *
			 * Contains all action listeners that manage modal
			 */case c.TASK_MODULE_MODAL_TOGGLE:{var modals={manageTask:state.modals.manageTask,manageColors:state.modals.manageColors,manageColorPicker:state.modals.manageColorPicker,notification:state.modals.notification,sendTask:state.modals.sendTask};if(action.modalType == c.TASK_MODULE_MODAL_NAME_MANAGE_TASK){modals.manageTask = !state.modals.manageTask;}if(action.modalType == c.TASK_MODULE_MODAL_NAME_MANAGE_COLORS){modals.manageColors = !state.modals.manageColors;}if(action.modalType == c.TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER){modals.manageColorPicker = !state.modals.manageColorPicker;}if(action.modalType == c.TASK_MODULE_MODAL_NAME_NOTIFICATION){modals.notification = !state.modals.notification;}if(action.modalType == c.TASK_MODULE_MODAL_NAME_SEND_TASK){modals.sendTask = !state.modals.sendTask;}return _extends({},state,{modals:modals});}case c.TASK_MODULE_MODAL_NOTIFICATION_SET:{var notification={type:action.notificationData.notificationType,itemId:action.notificationData.itemId};return _extends({},state,{notification:notification});}case c.TASK_MODULE_MODAL_NOTIFICATION_RESET:{var notification={type:'',itemId:null};return _extends({},state,{notification:notification});} /**
			 * TASK FORM MANAGER
			 *
			 * Contains all action listeners that manage task forms
			 */case c.TASK_MODULE_FORM_ERROR:{if(action.response.formType == 'manageTask'){var manageTask={message:state.manageTask.message,status:state.manageTask.status,taskId:state.manageTask.taskId,isEdit:state.manageTask.isEdit};if(action.response.error){manageTask.status = false;manageTask.message = action.response.error.error.message;}return _extends({},state,{manageTask:manageTask});}if(action.response.formType == 'manageColorPicker'){}}case c.TASK_MODULE_FORM_CLEAN:{if(action.formType == 'manageTask'){var manageTask={message:null,status:null,taskId:null,isEdit:false};return _extends({},state,{manageTask:manageTask});}if(action.formType == 'manageColors'){var manageColors={message:null,status:null};return _extends({},state,{manageColors:manageColors});}if(action.formType == 'manageColorPicker'){var manageColorPicker={message:null,status:null,colorId:null,isEdit:false};return _extends({},state,{manageColorPicker:manageColorPicker});}}case c.TASK_MODULE_FORM_CLEAN_MESSAGE:{if(action.formType == 'manageTask'){var manageTask={message:null,status:null,taskId:state.manageTask.taskId,isEdit:state.manageTask.isEdit};return _extends({},state,{manageTask:manageTask});}if(action.formType == 'manageColors'){var manageColors={message:null,status:null};return _extends({},state,{manageColors:manageColors});}if(action.formType == 'manageColorPicker'){var manageColorPicker={message:null,status:null,colorId:null,isEdit:false};return _extends({},state,{manageColorPicker:manageColorPicker});}return _extends({},state);}case c.TASK_MODULE_FORM_EDIT_SET:{var _action$response=action.response;var formType=_action$response.formType;var entityId=_action$response.entityId;if(formType == 'manageTask'){var manageTask={message:state.manageTask.message,status:state.manageTask.status,taskId:entityId,isEdit:true};return _extends({},state,{manageTask:manageTask});}if(formType == 'manageColorPicker'){var manageColorPicker={message:state.manageColorPicker.message,status:state.manageColorPicker.status,colorId:entityId,isEdit:true};return _extends({},state,{manageColorPicker:manageColorPicker});}} /**
			 * TASK TABLE LIST CHECKBOX MANAGER
			 *
			 * Contains all action listeners that manage task table list checkbox items
			 */case c.TASK_MODULE_ITEM_SET_CHECK:{return _extends({},state,{items:state.items.map(function(item){return _extends({},item,{checked:item.id === action.itemId?!item.checked:item.checked});})});}case c.TASK_MODULE_ITEM_SET_CHECK_ALL_VISIBLE:{var _ret8=(function(){var items=action.visibleItems;var vI=items.length;var cI=state.items.reduce(function(acc,item){return acc + (item.checked && items.includes(item.id)?1:0);},0);var toCheck=vI !== cI;return {v:_extends({},state,{items:state.items.map(function(item){return _extends({},item,{checked:items.includes(item.id)?toCheck:item.checked});})})};})();if(typeof _ret8 === 'object')return _ret8.v;}case c.TASK_MODULE_ITEM_READED:{state.items.map(function(value,key){if(value.id === action.response._id){value.isUnreaded = false;}});return _extends({},state);} /**
			 * Returns the default state for default switch case
			 */default:return state;}};exports.taskList = taskList; /******************************************************
	 * OUTBOX SECTION
	 ******************************************************/var outboxFilters={showSent:function showSent(item){return item.status == 'sent';},showUnSent:function showUnSent(item){return item.status !== 'sent';},showAll:function showAll(){return true;}};var shouldShowByDates=function shouldShowByDates(item,startDate,endDate){var should=!item.hidden; // try to prevent the deprecated ISO format warning but not yet we need new modules :)
	/* var dateString = startDate &&
	        startDate.getUTCFullYear() + "/" +
	        ("0" + (startDate.getUTCMonth()+1)).slice(-2) + "/" +
	        ("0" + startDate.getUTCDate()).slice(-2) + " " +
	        ("0" + startDate.getUTCHours()).slice(-2) + ":" +
	        ("0" + startDate.getUTCMinutes()).slice(-2) + ":" +
	        ("0" + startDate.getUTCSeconds()).slice(-2) || undefined */ // skipping the time comparation
	var mStartDate=(0,_moment2['default'])((0,_moment2['default'])(startDate).format("DD-MM-YYYY"),"DD-MM-YYYY");var mEndDate=(0,_moment2['default'])((0,_moment2['default'])(endDate).format("DD-MM-YYYY"),"DD-MM-YYYY");var sentDate=(0,_moment2['default'])((0,_moment2['default'])(item.sentDate).format("DD-MM-YYYY"),"DD-MM-YYYY");if(startDate && mStartDate.isValid()){should = should && (!mStartDate.isAfter(sentDate) || mStartDate.isSame(sentDate));}if(endDate && mEndDate.isValid()){should = should && (mEndDate.isAfter(sentDate) || mEndDate.isSame(sentDate));}return should;};var calcOutboxFailed=function calcOutboxFailed(items){return items.reduce(function(a,i){return a + ((i.status == 'failed' || i.status == 'bounced') && !i.wasResent?1:0);},0);};var outboxDefaults={items:[],filter:'',outboxFailedCount:0,selectValue:'showAll',subModule:'',opened:'' /* , startDate: {value:''}, endDate: {value:''} */};var outbox=function outbox(state,action){if(state === undefined)state = outboxDefaults;switch(action.type){case c.SET_APP_MODULE: // reset some values
	return _extends({},state,{subModule:outboxDefaults.subModule,opened:outboxDefaults.opened});case c.GOT_OUTBOX:{var _ret9=(function(){var shouldShow=outboxFilters[state.selectValue];var items=action.data.map(function(item){return _extends({},item,{id:item._id,hidden:!shouldShow(item)});}).map(function(item){return _extends({},item,{hidden:!shouldShowByDates(item,state.startDate,state.endDate)});});return {v:_extends({},state,{items:items,outboxFailedCount:calcOutboxFailed(items),ts:action.ts})};})();if(typeof _ret9 === 'object')return _ret9.v;}case c.SET_OUTBOX_SUB_MODULE:{var _name=action.name;var subModuleZoom=action.subModuleZoom;return _extends({},state,{subModule:_name,subModuleZoom:subModuleZoom});}case c.OUTBOX_ITEM_ZOOMED:return _extends({},state,{opened:action.itemId});case c.TICKETS_FILTERED:return _extends({},state,{filter:action.filter || ''});case c.OUTBOX_SET_FILTERED:{var _ret10=(function(){var selectValue=action.selectValue;var startDate=action.startDate;var endDate=action.endDate;var shouldShow=outboxFilters[selectValue] || function(){return true;};return {v:_extends({},state,{items:state.items.map(function(item){return _extends({},item,{hidden:!shouldShow(item)});}).map(function(item){return _extends({},item,{hidden:!shouldShowByDates(item,startDate,endDate)});}),selectValue:selectValue || state.selectValue,startDate:startDate === false?null:startDate?startDate:state.startDate, // if undefined -> reset
	endDate:endDate === false?null:endDate?endDate:state.endDate})};})();if(typeof _ret10 === 'object')return _ret10.v;}case c.SET_ALL_VISIBLE_CHECKED:{var _ret11=(function(){var items=action.visibleItems;var vI=items.length;var cI=state.items.reduce(function(acc,item){return acc + (item.checked && items.includes(item.id)?1:0);},0);var toCheck=vI !== cI;return {v:_extends({},state,{items:state.items.map(function(item){return _extends({},item,{checked:items.includes(item.id)?toCheck:item.checked});})})};})();if(typeof _ret11 === 'object')return _ret11.v;}case c.SET_ALL_CHECKED:{return _extends({},state,{items:state.items && state.items.map(function(item){return _extends({},item,{checked:true});}) || []});}case c.SET_CHECKBOX:return _extends({},state,{items:state.items.map(function(item){return _extends({},item,{checked:item.id === action.id?!item.checked:item.checked});})});case c.LOGGED_OUT:return outboxDefaults;case c.OUTBOX_ITEMS_STATUS:{var _ret12=(function(){var emailIds=action.emailIds;var archived=action.status.archived;var newItems=state.items.map(function(i){if(emailIds.includes(i.id)){return _extends({},i,{archived:archived == null?i.archived:archived});}return i;});return {v:_extends({},state,{items:newItems})};})();if(typeof _ret12 === 'object')return _ret12.v;}default:return state;}};exports.outbox = outbox; /******************************************************
	 * END OF OUTBOX SECTION
	 ******************************************************/var agendaDefaults={subscribers:[],events:[]};var agenda=function agenda(state,action){if(state === undefined)state = agendaDefaults;switch(action.type){case c.SET_AGENDA_DATA:{var items=action.response;return _extends({},state,{events:items});}case c.GOT_USERS:{return _extends({},state,{users:action.response});}case c.SET_SUBSCRIBERS:return _extends({},state,{subscribers:action.subscriberIds});default:return state;}};exports.agenda = agenda;var officeDefaults={brokers:{},accountManagers:[],contacts:null,contactModal:{visible:false,contactId:null},contactZoom:{visible:false,contactId:null},signatures:null,signatureZoom:{visible:false,signatureId:null}};var office=function office(state,action){if(state === undefined)state = officeDefaults;switch(action.type){case c.FETCHED_CONTACTS:return _extends({},state,{contacts:action.contacts});case c.SET_OFFICE_DATA:return _extends({},state,{brokers:action.brokers,accountManagers:action.accountManagers});case c.SHOW_CONTACT_MODAL:return _extends({},state,{contactModal:{visible:true,contactId:action.id}});case c.HIDE_CONTACT_MODAL:return _extends({},state,{contactModal:{visible:false,contactId:null}});case c.ZOOM_CONTACT:return _extends({},state,{contactZoom:{visible:true,contactId:action.id}});case c.CLOSE_CONTACT:return _extends({},state,{contactZoom:{visible:false,contactId:null}});case c.FETCHED_SIGNATURES:return _extends({},state,{signatures:action.signatures});case c.ZOOM_SIGNATURE:return _extends({},state,{signatureZoom:{visible:true,signatureId:action.id}});case c.CLOSE_SIGNATURE:return _extends({},state,{signatureZoom:{visible:false,signatureId:null}});case c.LOGGED_OUT:return officeDefaults;default:return state;}};exports.office = office;var finances=function finances(state,action){if(state === undefined)state = {items:[]};switch(action.type){case c.FETCHED_OFFICE_FINANCES:{var summary=(0,_lodashObject.pick)(action.data,['annualCommission','commission','newCredit','newDebit','oldCredit','oldDebit']);return _extends({},state,{items:action.data.transactions,documents:action.data.documents,summary:summary});}default:return state;}};exports.finances = finances;var adminDocs=function adminDocs(state,action){if(state === undefined)state = {};switch(action.type){case c.FETCHED_ADMIN_DOCS:{return _extends({},state,_defineProperty({},action.brNr,action.data));}case c.SET_ADMIN_DICT:return _extends({},state,{dict:action.dict});default:return state;}};exports.adminDocs = adminDocs;var uploadsDefaults={dict:null,uploadInfo:null,modalIsOpen:false,step:0,groupId:null,uploadType:'',uploadTypeId:'',uploadId:'',claimWizardDocType:'',dsDocumentTemplates:[],comment:'',error:false,done:false,unallocatedFiles:[]};var uploads=function uploads(state,action){if(state === undefined)state = uploadsDefaults;switch(action.type){case c.SET_UPLOAD_DICT:return _extends({},state,{dict:action.dict});case c.SHOW_UPLOAD_MODAL:{var uploadInfo=(0,_lodashCollection.map)(action.uploadInfo,function(uType,uId){var result={};result.id = uId;result.title = state.dict.uploadType[uId];var increment=0;result.fileTypes = (0,_lodashCollection.map)(uType,function(fType,fId){ // TO DO I have no translations for tarification.... need dicts for this to wrok in case of tarification
	/* if(action.uploadType === 'tarification'){
							return {id: fId, title: `test ${++increment}`, max: 1, min: 0}
						} */return {id:fId,title:state.dict[action.uploadType][fId],max:fType.max,min:fType.min};});result.fileTypes.sort(function(a,b){return a.title[defaultLang].localeCompare(b.title[defaultLang]);});return result;});var step=0;var groupId=null;if(action.claimWizardDocType){step = 1;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=uploadInfo[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);_iteratorNormalCompletion2 = true) {var item=_step2.value;if(item.fileTypes && item.fileTypes.length > 0 && item.fileTypes.some(function(fileType){return fileType.id === action.claimWizardDocType;})){groupId = item.id;break;}}}catch(err) {_didIteratorError2 = true;_iteratorError2 = err;}finally {try{if(!_iteratorNormalCompletion2 && _iterator2['return']){_iterator2['return']();}}finally {if(_didIteratorError2){throw _iteratorError2;}}}}return _extends({},state,{step:step,groupId:groupId,modalIsOpen:true,uploadInfo:uploadInfo,uploadType:action.uploadType,uploadTypeId:action.uploadTypeId,claimWizardDocType:action.claimWizardDocType});}case c.HIDE_UPLOAD_MODAL:return _extends({},state,{modalIsOpen:false});case c.GO_TO_FILE_FORM:return _extends({},state,{step:1,groupId:action.groupId,uploadId:action.uploadId,comment:action.comment});case c.GO_BACK_TO_UPLOAD_TYPE:{ //cleanup the already added files
	var _files=state.uploadInfo.map(function(info){return _extends({},info,{fileTypes:info.fileTypes.map(function(filetype){return _extends({},filetype,{files:[]});})});});return _extends({},state,{modalIsOpen:true,step:0,uploadInfo:_files,comment:'',error:false,done:false,unallocatedFiles:[]});}case c.SET_UPLOAD_ID:return _extends({},state,{uploadId:action.uploadId});case c.CHANGE_FILE_DATE:{if(action.filetype){var _files2=state.uploadInfo.map(function(info){if(info.id !== state.groupId){return info;}return _extends({},info,{fileTypes:info.fileTypes.map(function(filetype){if(filetype.id !== action.filetype){return filetype;}return _extends({},filetype,{files:filetype.files.map(function(file){if(action.file !== file){return file;}return _extends({},file,{lastModified:action.date});})});})});});return _extends({},state,{uploadInfo:_files2});}else {var filesFromState=[].concat(_toConsumableArray(state.unallocatedFiles));var newFiles=filesFromState.map(function(oneFile){if(action.file !== oneFile){return oneFile;}return _extends({},oneFile,{lastModified:action.date});});return _extends({},state,{unallocatedFiles:newFiles});}}case c.REMOVE_FILE:{var unallocatedFiles=[].concat(_toConsumableArray(state.unallocatedFiles));var remIndex=unallocatedFiles.indexOf(action.file);var _files3=state.uploadInfo.map(function(info){if(info.id !== state.groupId){return info;}return _extends({},info,{fileTypes:info.fileTypes.map(function(fileType){if(fileType.id !== action.fileType){return fileType;}return _extends({},fileType,{files:fileType.files.filter(function(file){return action.file !== file;})});})});});if(remIndex > -1){unallocatedFiles.splice(remIndex,1);}return _extends({},state,{unallocatedFiles:unallocatedFiles,uploadInfo:_files3});}case c.ADD_FILES:{var _iteratorNormalCompletion3;var _didIteratorError3;var _iteratorError3;var _iterator3,_step3;var _ret13=(function(){var filesFromState=state.unallocatedFiles;var uploadInfo=state.uploadInfo;var newFilesToState=[].concat(_toConsumableArray(filesFromState));var filesToAllocate=[];_iteratorNormalCompletion3 = true;_didIteratorError3 = false;_iteratorError3 = undefined;try{for(_iterator3 = action.files[Symbol.iterator]();!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done);_iteratorNormalCompletion3 = true) {var oneFile=_step3.value;if(oneFile.origin && oneFile.origin === 'DS_ORIGIN_ORACLE' && oneFile.documentToLowValue){filesToAllocate.push(oneFile);}else {newFilesToState.push(oneFile);}}}catch(err) {_didIteratorError3 = true;_iteratorError3 = err;}finally {try{if(!_iteratorNormalCompletion3 && _iterator3['return']){_iterator3['return']();}}finally {if(_didIteratorError3){throw _iteratorError3;}}}var newUi=uploadInfo.map(function(item){if(item.id === state.groupId){var newTypes=item.fileTypes.map(function(fT){var fileIndex=filesToAllocate.findIndex(function(oneFile){return oneFile.documentToLowValue === fT.id;});if(fileIndex > -1){var newFiles=[].concat(_toConsumableArray(fT.files || []),[filesToAllocate[fileIndex]]);return _extends({},fT,{files:newFiles});}return fT;});return _extends({},item,{fileTypes:newTypes});}return item;});return {v:_extends({},state,{unallocatedFiles:newFilesToState,uploadInfo:newUi})};})();if(typeof _ret13 === 'object')return _ret13.v;}case c.UN_ALLOCATE_FILE:{var _files4=state.uploadInfo.map(function(info){if(info.id !== state.groupId){return info;}return _extends({},info,{fileTypes:info.fileTypes.map(function(fileType){if(fileType.id !== action.fileType){return fileType;}return _extends({},fileType,{files:fileType.files.filter(function(file){return action.file !== file;})});})});});return _extends({},state,{uploadInfo:_files4});}case c.ALLOCATE_FILE:{var uI=state.uploadInfo;var filesFromState=state.unallocatedFiles;var newFilesToState=[].concat(_toConsumableArray(filesFromState));var newUi=uI.map(function(item){if(item.id === state.groupId){var newTypes=item.fileTypes.map(function(fT){if(fT.id === action.typeId){var newFiles=[].concat(_toConsumableArray(fT.files || []),[action.file]);return _extends({},fT,{files:newFiles});}return fT;});return _extends({},item,{fileTypes:newTypes});}return item;});var indexOfAllocatedFile=newFilesToState.indexOf(action.file);if(indexOfAllocatedFile > -1){newFilesToState.splice(indexOfAllocatedFile,1);}return _extends({},state,{uploadInfo:newUi,unallocatedFiles:newFilesToState});}case c.UPLOAD_PROGRESS:{var _files5=state.uploadInfo.map(function(info){if(info.id !== state.groupId){return info;}return _extends({},info,{fileTypes:info.fileTypes.map(function(filetype){if(filetype.id !== action.filetype){return filetype;}return _extends({},filetype,{files:filetype.files.map(function(file){if(action.fileId !== file.fileId){return file;}return _extends({},file,{progress:action.progress});})});})});});return _extends({},state,{uploadInfo:_files5});}case c.UPLOAD_DONE:{if(!state.uploadInfo){return state;} // merge new info into the list of files
	var uploadInfo=state.uploadInfo.map(function(info){ // When the upload group is different then nothing to do, iterate forward the loop until match
	if(info.id !== state.groupId){return info;} // the groupId is the same, then merge the new info to the store
	return _extends({},info,{ // kepp the original info and add the followings below
	fileTypes:info.fileTypes.map(function(filetype){ // if the file id is differ, nothing to merge, continue iteration
	if(filetype.id !== action.filetype){return filetype;}return _extends({},filetype,{ // keep the original fileType info, overwrite the followings below.
	// iterate the files it self...
	files:filetype.files.map(function(file){if(action.fileId !== file.fileId){return file;} // other file, skip this iteration
	// this is the final branch of the big tree of upload madness, here you kan put custom information near your file.
	return _extends({},file,{apiResponse:action.response,done:true});})});})});});var done=uploadInfo.every(function(u){return u.fileTypes?u.fileTypes.every(function(ft){return ft.files?ft.files.filter(function(f){return f.fileId;}).every(function(f){return f.done;}):true;}):true;});return _extends({},state,{uploadInfo:uploadInfo,done:done});}case c.UPLOAD_ERROR:{if(!state.uploadInfo){return state;}var _files6=state.uploadInfo.map(function(info){if(info.id !== state.groupId){return info;}return _extends({},info,{fileTypes:info.fileTypes.map(function(filetype){if(filetype.id !== action.filetype){return filetype;}return _extends({},filetype,{files:filetype.files.map(function(file){if(action.fileId !== file.fileId){return file;}return _extends({},file,{error:action.error || true});})});})});});return _extends({},state,{uploadInfo:_files6,error:true});}case c.UPLOAD_CLEAR_ERROR:{if(!state.uploadInfo){return state;}var _files7=state.uploadInfo.map(function(info){if(info.id !== state.groupId){return info;}return _extends({},info,{fileTypes:info.fileTypes.map(function(filetype){if(filetype.id !== action.filetype){return filetype;}return _extends({},filetype,{files:filetype.files.map(function(file){if(action.fileId !== file.fileId){return file;}return _extends({},file,{error:false});})});})});});return _extends({},state,{uploadInfo:_files7,error:false});}case c.START_UPLOAD:return _extends({},state,{step:2});case c.CANCEL_UPLOAD:return _extends({},uploadsDefaults,{dict:state.dict});case c.UPDATE_UPLOAD_COMMENT:return _extends({},state,{comment:action.comment});default:return state;}};exports.uploads = uploads;var filesDefaults={client:{},claim:{},contract:{},tarification:{}};var files=function files(state,action){if(state === undefined)state = filesDefaults;switch(action.type){case c.GET_UPLOADS:return _extends({},state,_defineProperty({},action.uploadType,_extends({},state[action.uploadType],_defineProperty({},action.typeId,{ts:Date.now(),files:action.files}))));case c.CLIENT_FILE_DOC_UPDATE_BEM_COMMENT:{var _ret14=(function(){var uploadType=action.uploadType;var typeId=action.typeId;var uploadId=action.uploadId;var documentId=action.documentId;var bemComment=action.bemComment;var files=(0,_lodashLang.cloneDeep)(state[uploadType][typeId].files); // clone files to avoid mutation
	var fileIndex=files.findIndex(function(f){return f.uploadId === uploadId;});if(fileIndex !== -1){var commentKey=bemComment.commentKey;var commentValue=bemComment.commentValue;var documents=(0,_lodashLang.cloneDeep)(files[fileIndex].documents); // clone documents to avoid mutation
	var documentIndex=documents.findIndex(function(d){return d.documentId === documentId;});if(documentIndex !== -1){documents[documentIndex][commentKey] = commentValue;files[fileIndex].documents = documents;}}return {v:_extends({},state,_defineProperty({},uploadType,_extends({},state[uploadType],_defineProperty({},typeId,{ts:Date.now(),files:files}))))};})();if(typeof _ret14 === 'object')return _ret14.v;}case c.CONTRACT_FILE_DOC_UPDATE_BEM_COMMENT:{var _ret15=(function(){var contractId=action.typeId;var uploadId=action.uploadId;var uploadType=action.uploadType;var documentId=action.documentId;var bemComment=action.bemComment;var files=(0,_lodashLang.cloneDeep)(state[uploadType][contractId].files); // clone files to avoid mutation
	var fileIndex=files.findIndex(function(f){return f.uploadId === uploadId;});if(fileIndex !== -1){var commentKey=bemComment.commentKey;var commentValue=bemComment.commentValue;var documents=(0,_lodashLang.cloneDeep)(files[fileIndex].documents); // clone documents to avoid mutation
	var documentIndex=documents.findIndex(function(d){return d.documentId === documentId;});if(documentIndex !== -1){documents[documentIndex][commentKey] = commentValue;files[fileIndex].documents = documents;}}return {v:_extends({},state,_defineProperty({},uploadType,_extends({},state[uploadType],_defineProperty({},contractId,{ts:Date.now(),files:files}))))};})();if(typeof _ret15 === 'object')return _ret15.v;}case c.CLAIM_FILE_DOC_UPDATE_BEM_COMMENT:{var _ret16=(function(){var claimId=action.typeId;var uploadId=action.uploadId;var uploadType=action.uploadType;var documentId=action.documentId;var bemComment=action.bemComment;var files=(0,_lodashLang.cloneDeep)(state[uploadType][claimId].files); // clone files to avoid mutation
	var fileIndex=files.findIndex(function(f){return f.uploadId === uploadId;});if(fileIndex !== -1){var commentKey=bemComment.commentKey;var commentValue=bemComment.commentValue;var documents=(0,_lodashLang.cloneDeep)(files[fileIndex].documents); // clone documents to avoid mutation
	var documentIndex=documents.findIndex(function(d){return d.documentId === documentId;});if(documentIndex !== -1){documents[documentIndex][commentKey] = commentValue;files[fileIndex].documents = documents;}}return {v:_extends({},state,_defineProperty({},uploadType,_extends({},state[uploadType],_defineProperty({},claimId,{ts:Date.now(),files:files}))))};})();if(typeof _ret16 === 'object')return _ret16.v;}case c.LOGGED_OUT:return filesDefaults;default:return state;}};exports.files = files;var claims=function claims(state,action){if(state === undefined)state = [];switch(action.type){case c.SET_CLAIMS_DATA: // if we have too many rows error, don't run map, as there are no items returned
	// for sure.
	if(_underscore2['default'].isArray(action.response) && action.response[0] === 'Too many rows'){return action.response;}var newState=action.response.map(function(item){return item.main.claimId?item:{main:_extends({},item.main,{claimId:item.main.claimNumber}),details:item.details,documents:item.documents};});return newState;default:return state;}};exports.claims = claims;var contractsDefaults={};var contracts=function contracts(state,action){if(state === undefined)state = contractsDefaults;switch(action.type){case c.SET_CLIENTS_DATA:return contractsDefaults;case c.SET_CLIENT_DATA:{var newContracts=_extends({},state);var changed=false;if(action.response.contracts){var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=action.response.contracts[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done);_iteratorNormalCompletion4 = true) {var _c=_step4.value;var contract=_c.contractMain;if(!newContracts[contract.contractId]){newContracts[contract.contractId] = contract;changed = true;}}}catch(err) {_didIteratorError4 = true;_iteratorError4 = err;}finally {try{if(!_iteratorNormalCompletion4 && _iterator4['return']){_iterator4['return']();}}finally {if(_didIteratorError4){throw _iteratorError4;}}}}if(changed){return newContracts;}return _extends({},state);}case c.FETCHED_CLIENT_CONTRACT:{var _extends11;var originalContract=state[action.contractId];var contract=_extends({},originalContract,action.response.contractMain,{contractId:action.contractId,details:action.response.contractDetails,documents:action.response.contractDocuments}); // the language flags from oracle are d = dutch, f = french, e = english.
	var langFlag=_nestedProperty2['default'].get(action,"response.contractDetails.contractManagerLanguage");langFlag = langFlag == 'd'?'nl':langFlag == 'f'?'fr':'en';return _extends({},state,(_extends11 = {},_defineProperty(_extends11,action.contractId,contract),_defineProperty(_extends11,'contractManagerLanguage',langFlag),_defineProperty(_extends11,'contractManagerMail',_nestedProperty2['default'].get(action,"response.contractDetails.contractManagerMail")),_extends11));}case c.CONTRACT_DOCUMENT_DOC_UPDATE_BEM_COMMENT:{var _ret17=(function(){var contractId=action.typeId;var uploadId=action.uploadId;var bemComment=action.bemComment;var contract=(0,_lodashLang.cloneDeep)(state[contractId]); // clone contract to avoid mutation
	var documentIndex=contract.documents.findIndex(function(d){return d.contractDocumentId === uploadId;});if(documentIndex !== -1){var commentKey=bemComment.commentKey;var commentValue=bemComment.commentValue;contract.documents[documentIndex][commentKey] = commentValue;}return {v:_extends({},state,_defineProperty({},contractId,contract))};})();if(typeof _ret17 === 'object')return _ret17.v;}case c.LOGGED_OUT:return contractsDefaults;default:return state;}};exports.contracts = contracts; /**
	 * Fetch the claim manager details to an array
	 * @param {*} claims
	 */var fetchClaimManagerDetails=function fetchClaimManagerDetails(claims){var claimsManagersDetails=[];if(!(claims && Array.isArray(claims) && claims.length > 0)){return [];} // iterate claims to collect email addresses for email sender.
	claims.forEach(function(claimElem){var claimId=_nestedProperty2['default'].get(claimElem,"claimMain.claimId");var claimNumber=_nestedProperty2['default'].get(claimElem,"claimMain.claimNumber");var claimsManagerMail=_nestedProperty2['default'].get(claimElem,"claimMain.claimsManagerMail");var claimsManager=_nestedProperty2['default'].get(claimElem,"claimMain.claimsManager");var claimsManagerLanguage=_nestedProperty2['default'].get(claimElem,"claimMain.claimsManagerLanguage");claimId = claimId || _nestedProperty2['default'].get(claimElem,"main.claimId");claimNumber = claimNumber || _nestedProperty2['default'].get(claimElem,"main.claimNumber");claimsManagerMail = claimsManagerMail || _nestedProperty2['default'].get(claimElem,"main.claimsManagerMail");claimsManager = claimsManager || _nestedProperty2['default'].get(claimElem,"main.claimsManager");claimsManagerLanguage = claimsManagerLanguage || _nestedProperty2['default'].get(claimElem,"main.claimsManagerLanguage");claimsManagersDetails.push({email:claimsManagerMail,name:claimsManager,lang:claimsManagerLanguage === 'd'?'nl':'fr',claimId:claimId,claimNumber:claimNumber}); // the following code used for filter doubles but must filter at the last step.
	/*
	        // if we have the same email address we don't need to add again
	        let alreadyAdded = claimsManagersDetails.length > 0
	            && claimsManagersDetails.filter((alreadyFilterValue)=>{
	                let email  = nesProp.get(alreadyFilterValue, "email")
	                return (String(email).localeCompare(claimsManagerMail) === 0)
	                // && (alreadyFilterValue.name.localeCompare( claimElem.claimMain.claimsManager) === 0)
	        })
	
	        // TODO get a list of language codes of oracle languages: 'd', ... ??? insert in common preference
	        // add the claim manager email to the list if unique the email address
	        if(!alreadyAdded || (Array.isArray(alreadyAdded) && alreadyAdded.length == 0)) {
	            claimsManagersDetails.push({
	                email: claimsManagerMail,
	                name: claimsManager,
	                lang: claimsManagerLanguage === 'd' ? 'nl' : 'fr',
	                claimId,
	                claimNumber
	            })
	        } */});return claimsManagersDetails;};var clientsDefaults={data:null,clientData:{},subModule:"",finances:{},claims:{},subModuleZoom:{},initialArguments:{},tarifications:{},filter:{},selectedCheckboxes:{},formStatus:{isSending:false,sent:false,problem:null}};var clients=function clients(state,action){if(state === undefined)state = clientsDefaults;switch(action.type){case c.SET_CLIENTS_DATA:return _extends({},clientsDefaults,{data:action.response,createContractState:state.createContractState});case c.SET_CLIENT_DATA:{var data=_extends({},action.response,{contracts:undefined,contractIds:action.response.contracts && action.response.contracts.map(function(c){return c.contractMain.contractId;}) || []});return _extends({},state,{clientData:_extends({},state.clientData,_defineProperty({},action.clientId,data))});}case c.SET_CLIENT_SUB_MODULE:{var _name2=action.name;var subModuleZoom=action.subModuleZoom;var createContractState=action.createContractState;return _extends({},state,{subModule:_name2,subModuleZoom:subModuleZoom,createContractState:createContractState});}case c.SET_CLIENT_CREATE_CONTRACT_STATE:{return _extends({},state,{createContractState:action.createContractState});}case c.SUBMENU_ITEM_ZOOMED:return _extends({},state,{submenuOpened:action.itemId,subModuleZoom:{},initialArguments:action.initialArguments});case c.HIDE_EMAIL_SENDER_MODAL:{return _extends({},state,{initialArguments:_extends({},state.initialArguments,{ // reset special initialisation values on close, to avoid
	// to init the modal with the wrong values
	startedFromModule:'',autoSelectTemplate:false,quickReply:false,ticketId:''})});}case c.FILTER_ITEMS:return _extends({},state,{filter:action.data});case c.FETCHED_CLIENT_FINANCES:{var _finances=action.transactions.transactionDetails.map(function(t){return t.lineType === 'T'?{amount:t.amount,lineType:t.lineType}:t;});return _extends({},state,{finances:_extends({},state.finances,_defineProperty({},action.clientId,_finances))});}case c.FETCHED_CLIENT_CLAIMS:{var _extends15; // collecting the claim related emails
	var _claims=_nestedProperty2['default'].get(action,"response.claims");var claimsManagersDetails=fetchClaimManagerDetails(_claims);return _extends({},state,{claims:_extends({},state.claims,(_extends15 = {},_defineProperty(_extends15,action.clientId,_nestedProperty2['default'].get(action,"response.claims")),_defineProperty(_extends15,'claimsManagersDetails',claimsManagersDetails),_extends15))});}case c.CLIENT_DOC_UPDATE_BEM_COMMENT:{var _ret18=(function(){var clientId=action.typeId;var uploadId=action.uploadId;var bemComment=action.bemComment;var clientDocuments=(0,_lodashLang.cloneDeep)(state.clientData[clientId].clientDocuments); // clone documents to avoid mutation
	var clientDocumentIndex=clientDocuments.findIndex(function(d){return d.clientDocumentId === uploadId;});if(clientDocumentIndex !== -1){var commentKey=bemComment.commentKey;var commentValue=bemComment.commentValue;clientDocuments[clientDocumentIndex][commentKey] = commentValue;}return {v:_extends({},state,{clientData:_extends({},state.clientData,_defineProperty({},clientId,_extends({},state.clientData[clientId],{clientDocuments:clientDocuments})))})};})();if(typeof _ret18 === 'object')return _ret18.v;}case c.CLAIM_DOCUMENT_DOC_UPDATE_BEM_COMMENT:{var _ret19=(function(){var claimId=action.typeId;var uploadId=action.uploadId;var bemComment=action.bemComment;var clientNumber=action.clientNumber;var claims=(0,_lodashLang.cloneDeep)(state.claims[clientNumber]); // clone claims to avoid mutation
	var claimIndex=claims.findIndex(function(c){return c.claimMain.claimId === claimId;});if(claimIndex !== -1){var claimDocuments=(0,_lodashLang.cloneDeep)(claims[claimIndex].claimDocuments); // clone documents to avoid mutation
	var claimDocumentIndex=claimDocuments.findIndex(function(d){return d.documentId === uploadId;});if(claimDocumentIndex !== -1){var commentKey=bemComment.commentKey;var commentValue=bemComment.commentValue;claimDocuments[claimDocumentIndex][commentKey] = commentValue;claims[claimIndex].claimDocuments = claimDocuments;}}return {v:_extends({},state,{claims:_extends({},state.claims,_defineProperty({},clientNumber,claims))})};})();if(typeof _ret19 === 'object')return _ret19.v;}case c.CLIENT_LOAD_CLAIMS_EXTRA:{var claimsExtraDetails=action.response; // collecting the claim related emails
	var _claims2=_nestedProperty2['default'].get(action,"response");var claimsManagersDetails=fetchClaimManagerDetails(_claims2); // if we have too many rows error we set only an empty array
	if(_underscore2['default'].isArray(action.response) && action.response[0] === 'Too many rows'){claimsExtraDetails = [];}return _extends({},state,{claimsExtraDetails:claimsExtraDetails,claimsManagersDetails:claimsManagersDetails});}case c.FETCHED_CLIENT_TARIFICATIONS:{try{var tarifications=action.tarifications;return _extends({},state,{tarifications:_extends({},state.tarifications,_defineProperty({},action.clientId,tarifications))});}catch(error) {console.warn(error);}}case c.LOGGED_OUT:return clientsDefaults;default:return state;}};exports.clients = clients;var clientDefaults={main:{},detail:{},clientDocuments:[],contracts:{},claims:[],tarificationDetail:{},filter:null};var client=function client(state,action){if(state === undefined)state = clientDefaults;switch(action.type){case c.APP_CHANGED:return _extends({},state,{clientOptionsDict:action.clientOptionsDict || state.clientOptionsDict});case c.SET_APP_MODULE:return _extends({},state,{clientOptionsDict:action.clientOptionsDict || state.clientOptionsDict,tarificationDetail:{}});case c.SET_CLIENT:{var data=action.response;var _contracts={};var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=data.contracts[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done);_iteratorNormalCompletion5 = true) {var contract=_step5.value;var brancheCode=contract.contractMain.brancheCode;if(!(brancheCode in _contracts)){_contracts[brancheCode] = [];}_contracts[brancheCode].push(contract.contractMain);}}catch(err) {_didIteratorError5 = true;_iteratorError5 = err;}finally {try{if(!_iteratorNormalCompletion5 && _iterator5['return']){_iterator5['return']();}}finally {if(_didIteratorError5){throw _iteratorError5;}}}return _extends({},state,action.response,{contracts:_contracts});}case c.SET_FILTER:return _extends({},state,{filter:state.filter === action.filter?null:action.filter});case c.SET_CONTRACT_DETAILS:{var result={};var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=Object.keys(state.contracts)[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done);_iteratorNormalCompletion6 = true) {var k=_step6.value;result[k] = state.contracts[k].map(function(c){if(c.contractId === action.id){return _extends({},c,{contractDetails:action.response.contractDetails,contractDocuments:action.response.contractDocuments,claims:action.response.claims});}return c;});}}catch(err) {_didIteratorError6 = true;_iteratorError6 = err;}finally {try{if(!_iteratorNormalCompletion6 && _iterator6['return']){_iterator6['return']();}}finally {if(_didIteratorError6){throw _iteratorError6;}}}return _extends({},state,{contracts:result});}case c.SET_CLIENT_CLAIMS:return _extends({},state,action.response);case c.SET_CLIENT_OPTIONS_DICT:{return _extends({},state,{clientOptionsDict:action.clientOptionsDict});}case c.SET_CLAIM_DETAIL:{return _extends({},state,{claimDetail:_extends({},action.response)});}case c.FETCHED_CLIENT_TARIFICATION_DATA:{return _extends({},state,{tarificationDetail:_extends({},action.response)});}case c.TARIFICATION_DOC_UPDATE_BEM_COMMENT:{var _ret20=(function(){var tarificationDocId=action.uploadId;var bemComment=action.bemComment;var tarificationDocuments=(0,_lodashLang.cloneDeep)(state.tarificationDetail.tarificationDocuments); // clone documents to avoid mutation
	var tarificationDocIndex=tarificationDocuments.findIndex(function(d){return d.tarificationDocId === tarificationDocId;});if(tarificationDocIndex !== -1){var commentKey=bemComment.commentKey;var commentValue=bemComment.commentValue;tarificationDocuments[tarificationDocIndex][commentKey] = commentValue;}return {v:_extends({},state,{tarificationDetail:_extends({},state.tarificationDetail,{tarificationDocuments:tarificationDocuments})})};})();if(typeof _ret20 === 'object')return _ret20.v;}case c.LOGGED_OUT:return clientDefaults;default:return state;}};exports.client = client;var clientsFormDefaults={type:null,clientData:{},clientId:null,selectedCheckboxes:{},existingClients:[],clientModal:false,formStatus:{isSending:false,sent:false,problem:null,emailDefault:false,phoneDefault:false}};var clientProfileForm=function clientProfileForm(state,action){if(state === undefined)state = clientsFormDefaults;switch(action.type){case c.INITIALIZE_CLIENT_PROFILE_FORM:{state.type = action.formType;if(action.formType == 'edit'){state.clientId = action.clientId;state.clientData = action.clientData;}return _extends({},state);}case c.CLEAN_CLIENT_PROFILE_FORM:{state = {type:null,clientData:{},clientId:null,selectedCheckboxes:{},existingClients:[],clientModal:false,formStatus:{isSending:false,sent:false,problem:null,emailDefault:false,phoneDefault:false}};return state;}case c.FETCH_CLIENT_CLIENT_PROFILE_FORM:{state.clientData = action.response;state.clientId = action.clientId;state.type = 'edit';return state;}case c.TOGGLE_LIST_DEFAULT_CLIENT_PROFILE_FORM:{if(action.listType == 'email'){state.formStatus.emailDefault = action.listValue;}if(action.listType == 'phone'){state.formStatus.phoneDefault = action.listValue;}}case c.FETCH_CLIENTS_CLIENT_PROFILE_FORM:{state.existingClients = action.response;return _extends({},state);}case c.FETCH_RELATION_CLIENT_PROFILE_FORM:{state.existingClients = action.response;return _extends({},state);}case c.TOGGLE_MODAL_CLIENT_PROFILE_FORM:{state.clientModal = action.modalStatus;return state;}case c.SET_PROFILE_FORM_CHECKBOX:{if(!state.selectedCheckboxes){state.selectedCheckboxes = [];}var index=action.id;if(state.selectedCheckboxes[index]){delete state.selectedCheckboxes[index];}else {state.selectedCheckboxes[index] = action.id;}return _extends({},state);}case c.CLEAN_PROFILE_FORM_CHECKBOX:{if(state.selectedCheckboxes){state.selectedCheckboxes = [];}return _extends({},state);}case c.FORM_SUBMITTED:{state.formStatus.isSending = true;return _extends({},state);}case c.UPDATE_CLIENT_PROFILE_RESULT:{state.formStatus.isSending = false;if(action.ok == true){state.formStatus.sent = true;}else {state.formStatus.sent = true;state.formStatus.problem = action.ok;}return _extends({},state);}case c.SENT_TO_FALSE_CLIENT_PROFILE_FORM:{var newState=_extends({},state);newState.formStatus.sent = false;return _extends({},newState);}default:return state;}};exports.clientProfileForm = clientProfileForm;var webapps=function webapps(state,action){if(state === undefined)state = [];switch(action.type){case c.GOT_WEBAPPS:return action.response;default:return state;}};exports.webapps = webapps;var defaultLang=global.localStorage && global.localStorage.getItem('clientLanguage') || 'nl';var appDefaults={module: false?c.NEWS:null,menuCollapsed:false,subMenuCollapsed:true,loading:0,backButton:null,lang:defaultLang,opened:null,claimsManagersDetails:null,backgroundProcessesDisabled:false,previousModule:null,versionCheckNotification:{msg:'',isOpened:false}};var app=function app(state,action){if(state === undefined)state = appDefaults;switch(action.type){case c.SET_IS_IE:{var isIE=action.isIE;return _extends({},state,{isIE:isIE});}case c.APP_CHANGED:return _extends({},state,action.data);case c.APP_PASSWORD_CHANGED:return _extends({},state,{"resetPassword":action.resetPassword || false});case c.SET_APP_MODULE:{var _module2= false?action.module || c.NEWS:action.module;return _extends({},state,{module:_module2,opened:action.id,previousModule:null});}case c.NAVIGATE_TO_DSDOCUMENT:{var _module3=action.module;return _extends({},state,{module:_module3,opened:action.id,previousModule:action.currentModule});}case c.TOGGLE_MENU:{var menuCollapsed=action.state == null?!state.menuCollapsed:Boolean(action.state);return _extends({},state,{menuCollapsed:menuCollapsed});}case c.TOGGLE_SUB_MENU:{var subMenuCollapsed=action.state == null?!state.subMenuCollapsed:Boolean(action.state);return _extends({},state,{subMenuCollapsed:subMenuCollapsed,brokers:action.brokers});}case c.MEDIA_CHANGED:{var isPhone=action.data.isPhone;if(isPhone != null){return _extends({},state,{menuCollapsed:isPhone});}return state;}case c.LOGGED_OUT:return appDefaults;case c.SHOW_LOADER:return _extends({},state,{loading:state.loading + 1});case c.HIDE_LOADER:return _extends({},state,{loading:state.loading - 1});case c.FORCE_SET_LOADER:return _extends({},state,{loading:action.loaderValue * 1});case c.ITEM_ZOOMED:return _extends({},state,{opened:action.itemId});case c.SUBMENU_ITEM_ZOOMED:return _extends({},state,{submenuOpened:action.itemId});case c.BRNR_USED:return _extends({},state,{brNr:action.brNr});case c.LANG_SET:return _extends({},state,{lang:action.lang});case c.NOTIFICATION_SET:{var msg=action.msg;var nType=action.nType;return _extends({},state,{notification:{msg:msg,nType:nType}});}case c.VERSION_CHECK_NOTIFICATION_SET:{var isOpened=action.isOpened;var msg=action.msg;var title=action.title;return _extends({},state,{versionCheckNotification:{msg:msg,isOpened:isOpened,title:title}});}case c.NOTIFICATION_CLEAR:{return _extends({},state,{notification:null});} // TODO claims extra data extracted here because the claims store hierarchy is an array.
	// Can not add other properties to the module reducer. Todo is to encapsulate the claims
	// array in to a property of an object to be able store other data related the claims module
	// in the own section.
	// Here the app subscribed to the SET_CLAIMS_DATA action. When you solve this todo you have to
	// remove this.
	case c.SET_CLAIMS_DATA:{var claimsManagersDetails=fetchClaimManagerDetails(action.response);return _extends({},state,{claimsManagersDetails:claimsManagersDetails});}case c.SHOW_PRINT_MODAL:{var additionalObject={};var modalId=action && action.modalId || "";_nestedProperty2['default'].set(additionalObject,modalId + "IsOpen",true);_nestedProperty2['default'].set(additionalObject,"modalId",modalId);return _extends({},state,{printModal:_extends({},action.printModal,additionalObject)});}case c.HIDE_PRINT_MODAL:{var additionalObject={};var modalId=action && action.modalId || "";_nestedProperty2['default'].set(additionalObject,modalId + "IsOpen",false);return _extends({},state,{printModal:_extends({message:'-',title:'-',flag:_nestedProperty2['default'].get(state,"printModal.flag") || "",result:action.result},additionalObject)});}case c.DISABLE_BACKGROUND_PROCESSES:return _extends({},state,{backgroundProcessesDisabled:action.backgroundProcessesDisabled});default:return state;}};exports.app = app; /*********************************************
	 * Email sender module
	 ********************************************/var emailSenderDefaults={emailModalIsOpen:false,emailSentModalIsOpen:false,emailNotSentModalIsOpen:false,emailConfModalIsOpen:false,waitingModalIsOpen:false,showPreviewModal:false,emailServerConfigModalIsOpen:false,serverConfigIsSaved:false,senderEmailAddress:'',moduleKey:'',modalIdOpened:''};var emailSender=function emailSender(state,action){if(state === undefined)state = emailSenderDefaults;switch(action.type){case c.SET_APP_MODULE:{return _extends({},emailSenderDefaults,{externalAttachments:state && state.externalAttachments || []});} // preset the module where will be opened
	case c.SET_EMAIL_SENDER_MODULE:{return _extends({},state,{moduleKey:action.moduleKey,modalIdOpened:action.modalId});} // pop up the modal (optionally with ID)
	case c.SHOW_EMAIL_SENDER_MODAL:{return _extends({},state,{emailModalIsOpen:true});} // moduleKey: state.moduleKey
	case c.HIDE_EMAIL_SENDER_MODAL:{return _extends({},state,{emailModalIsOpen:false,modalIdOpened:'',moduleKey:''});}case c.SHOW_EMAIL_SENDER_CONF_MODAL:{var additionalObject={}; // decide witch modal can be handled
	var modalId=action && action.modalId || "";switch(modalId){case "emailSentModal":{additionalObject.emailSentModalIsOpen = true;break;}case "emailNotSentModal":{additionalObject.emailNotSentModalIsOpen = true;break;}case "emailConfModal":{additionalObject.emailConfModalIsOpen = true;break;}case "waitingModal":{additionalObject.waitingModalIsOpen = true;break;}case "previewModal":{additionalObject.showPreviewModal = true;break;}}return _extends({},state,additionalObject,{serverConfigIsSaved:false,confirmationModal:action.confirmationModal});}case c.SHOW_EMAIL_SERVER_CONFIG_MODAL:return _extends({},state,{emailServerConfigModalIsOpen:true,senderEmailAddress:action.senderEmailAddress});case c.HIDE_EMAIL_SERVER_CONFIG_MODAL:return _extends({},state,{emailServerConfigModalIsOpen:false,serverConfigIsSaved:action.serverConfigIsSaved,senderEmailAddress:''});case c.HIDE_EMAIL_SENDER_CONF_MODAL:{var additionalObject={}; // decide witch modal can be handled
	var modalId=action && action.modalId || "";switch(modalId){case "emailSentModal":{additionalObject.emailSentModalIsOpen = false;break;}case "emailNotSentModal":{additionalObject.emailNotSentModalIsOpen = false;break;}case "emailConfModal":{additionalObject.emailConfModalIsOpen = false;break;}case "waitingModal":{additionalObject.waitingModalIsOpen = false;break;}case "previewModal":{additionalObject.showPreviewModal = false;break;}}return _extends({},state,additionalObject,{confirmationModal:{message:'-',title:'-',flag:_nestedProperty2['default'].get(state,"confirmationModal.flag") || "",result:action.result}});}case c.SHOW_EMAIL_SENDER_ATT_MODAL:{return _extends({},state,{emailAttModalIsOpen:true,attachmentModal:action.attachmentModal});}case c.HIDE_EMAIL_SENDER_ATT_MODAL:{return _extends({},state,{emailAttModalIsOpen:false,attachmentModal:{message:'-',title:'-',flag:_nestedProperty2['default'].get(state,"attachmentModal.flag") || "",result:action.result}});}case c.SET_EMAIL_EXTERNAL_ATTACHMENTS:{return _extends({},state,{externalAttachments:action.externalAttachments});} /* case c.EMAIL_SENDER_UPDATE_MODULE_OPTIONS: {
	            return {...state, moduleOptions: {...state.moduleOptions, ...action.moduleOptions}}
	        } */ /* case c.INIT_EMAIL_SENDER_FORM: {
	            state = {
	                emailLangField: 'nl',
	                formStatus: { isSending: false, sent: false, problem: null}
	            }
	
	            return state
	        } */case c.SET_CLAIMS_DATA:{var claimsManagersDetails=fetchClaimManagerDetails(action.response);return _extends({},state,{claimsManagersDetails:claimsManagersDetails});}default:return state;}};exports.emailSender = emailSender;var emailDocument=function emailDocument(state,action){if(state === undefined)state = {_gen:0};switch(action.type){case c.SET_EMAIL_DOCUMENT_ID:{return _extends({},state,{id:action.id});}default:return state;}};exports.emailDocument = emailDocument; /*********************************************
	 * END Email sender module
	 ********************************************/var dict=function dict(state,action){if(state === undefined)state = {_gen:0};switch(action.type){case c.GOT_TRANSLATIONS:{var _dict={};var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=action.dict[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done);_iteratorNormalCompletion7 = true) {var item=_step7.value;_dict[item.key] = item.t;}}catch(err) {_didIteratorError7 = true;_iteratorError7 = err;}finally {try{if(!_iteratorNormalCompletion7 && _iterator7['return']){_iterator7['return']();}}finally {if(_didIteratorError7){throw _iteratorError7;}}}_dict._gen = state._gen + 1;return _dict;}default:return state;}};exports.dict = dict;var areCookies=global.localStorage && global.localStorage.getItem('cookiesAccepted');var authDefaults={isLoggedIn:false,authState:"",options:{},errors:null,cookiesAccepted:areCookies,password:null,confirmation:{hash:null,step:1,isSending:false}};var auth=function auth(state,action){if(state === undefined)state = authDefaults;switch(action.type){case c.LOG_IN:return _extends({},state,{isLoggedIn:true});case c.BAD_CREDENTIALS:if(state.authState !== 'accountConfirmation'){return _extends({},state,{authState:"",isLoggedIn:false});}break;case c.AUTH_STATE_CHANGED:return _extends({},state,{authState:action.authState,options:action.options,errors:null});case c.HAS_ERRORS:return _extends({},state,{errors:{id:action.id}});case c.LOGGED_OUT:var cookieData=_jsCookie2['default'] && _jsCookie2['default'].get('cookiesAccepted') !== undefined?_jsCookie2['default'].get('cookiesAccepted'):null;return _extends({},authDefaults,{cookiesAccepted:cookieData});case c.COOKIES_ACCEPTED:return _extends({},state,{cookiesAccepted:true});case c.COOKIES_CLEAN:_jsCookie2['default'].remove('cookiesAccepted');return _extends({},state,{cookiesAccepted:false});case c.SET_PASSWORD:return _extends({},state,{password:action.password});case c.SET_ACCOUNT_CONFIRMATION_HASH:{return _extends({},state,{confirmation:_extends({},state.confirmation,{hash:action.payload})});}case c.SET_ACCOUNT_CONFIRMATION_STEP:{return _extends({},state,{confirmation:_extends({},state.confirmation,{step:action.payload})});}case c.CLEAN_ACCOUNT_CONFIRMATION:{return _extends({},state,{confirmation:authDefaults.confirmation});}default:return state;}};exports.auth = auth;function responsive(state,action){if(state === undefined)state = {};switch(action.type){case c.MEDIA_CHANGED:return _extends({},state,action.data);default:return state;}}var b2bDefaults={b2bInsuranceCompany:{companyId:false,insuranceCompany:''}};var b2b=function b2b(state,action){if(state === undefined)state = b2bDefaults;switch(action.type){case c.SET_APP_MODULE: // reset
	return _extends({},b2bDefaults,{b2bInsuranceCompany:state.b2bInsuranceCompany});case c.SET_B2B_INSURANCE_COMPANY:return _extends({},state,{b2bInsuranceCompany:action.b2bInsuranceCompany});case c.B2BCOMPANY_SEARCH_BY_CONTRACT_NUMBER:return _extends({},state,{isByContractNumber:action.isByContractNumber});case c.LOGGED_OUT:return b2bDefaults;default:return state;}};exports.b2b = b2b;var b2bCompanyDefaults={brNr:"",menuCollapsed:false,subMenuCollapsed:true,loading:0,backButton:null,lang:defaultLang,opened:null,policyActions:{},policySubActions:{},currentClientAction:"",currentClientSubAction:"",brokers:{},b2bCompanyCompany:{},B2BTransactions:[],data:null,clientData:{},subModule:"",finances:{},subModuleZoom:{},filter:{},policy:null,policyModal:{visible:false,policyId:null}};var b2bCompany=function b2bCompany(state,action){if(state === undefined)state = b2bCompanyDefaults;switch(action.type){case c.SET_APP_MODULE: // reset
	return _extends({},b2bCompanyDefaults,{data:b2bCompanyDefaults.data,brokers:state.brokers || {},brNr:state.brNr || ""});case c.SET_B2BCOMPANY_CLIENTS_DATA:return _extends({},state,{data:action.response,brNr:state.brNr});case c.SET_B2BCOMPANY_SUB_MODULE:{var _name3=action.name;var subModuleZoom=action.subModuleZoom;return _extends({},state,{subModule:_name3,subModuleZoom:subModuleZoom});}case c.B2BCOMPANY_ITEM_ZOOMED:return _extends({},state,{opened:action.itemId});case c.B2BCOMPANY_BRNR_USED:return _extends({},state,{brNr:action.brNr});case c.SET_B2BCOMPANY_SELECTED_POLICY:return _extends({},state,{selectedPolicy:action.selectedPolicy});case c.B2BCOMPANY_CLIENT_ACTION_USED:return _extends({},state,{currentClientAction:action.currentClientAction});case c.B2BCOMPANY_CLIENT_SUB_ACTION_USED:return _extends({},state,{currentClientSubAction:action.currentClientSubAction});case c.SET_B2BCOMPANY_BROKERS_DATA:return _extends({},state,{brokers:action.brokers,accountManagers:action.accountManagers});case c.B2BCOMPANY_SET_ACTIONS_DICT:return _extends({},state,{b2bCompanyActionsDict:action.b2bCompanyActionsDict});case c.B2BCOMPANY_GET_ACTIONS:return _extends({},state,{policyActions:action.policyActions,policySubActions:action.policySubActions});case c.B2BCOMPANY_SWITCH_ACTION:return _extends({},state,{policySubActions:action.policySubActions});case c.B2BCOMPANY_SET_TRANSACTION_DETAILS:return _extends({},state,{transactionDetails:action.transactionDetails});case c.B2BCOMPANY_SET_COMPANY:return _extends({},state,{b2bCompanyCompany:action.b2bCompanyCompany});case c.B2BCOMPANY_SET_TRANSACTIONS:return _extends({},state,{B2BTransactions:action.B2BTransactions});case c.SET_CLIENT_DATA:{var data=_extends({},action.response,{contracts:undefined,contractIds:action.response.contracts && action.response.contracts.map(function(c){return c.contractMain.contractId;}) || []});return _extends({},state,{clientData:_extends({},state.clientData,_defineProperty({},action.clientId,data))});}case c.B2BCOMPANY_FETCHED_POLICIES:return _extends({},state,{policies:action.policies});case c.SHOW_B2BCOMPANY_POLICY_MODAL:return _extends({},state,{policyModal:{visible:true,policyId:action.id}});case c.HIDE_B2BCOMPANY_POLICY_MODAL:return _extends({},state,{policyModal:{visible:false,policyId:null}});case c.LOGGED_OUT:return b2bCompanyDefaults;default:return state;}};exports.b2bCompany = b2bCompany;var notificationsDefault={items:[]};var notifications=function notifications(state,action){if(state === undefined)state = notificationsDefault;switch(action.type){case c.SET_APP_NOTIFICATIONS:if(action.response && action.response.length){(function(){var items=[];action.response.map(function(value,key){var item={title:value.title,messageNl:value.message,messageEn:value.messageEn,messageFr:value.messageFr,showBroker:value.showBroker,showClient:value.showClient,expires:value.expires};items[key] = item;});state.items = items;})();}return _extends({},state);default:return state;}};exports.notifications = notifications;var taskCreatorDefault={modalIsOpen:false,error:null,statusText:null}; /** Task creator
	 ****************************************************************************************/var taskCreator=function taskCreator(state,action){if(state === undefined)state = taskCreatorDefault;switch(action.type){case c.TASK_CREATOR_MODAL_TOGGLE:return _extends({},state,{modalIsOpen:!state.modalIsOpen,error:null,statusText:null});case c.TASK_CREATOR_CONVERTION_SUCCESS:return _extends({},state,{modalIsOpen:false,error:null,statusText:null});case c.TASK_CREATOR_CONVERTION_FAIL:var message='Something went wrong please try again later';var statusText='Something went wrong please try again later';if(action.err && action.err.message){message = action.err.message;}if(action.err && action.err.statusText){statusText = action.err.statusText;}return _extends({},state,{error:message,statusText:statusText});default:return state;}};exports.taskCreator = taskCreator; /**************************************************
	 * ****  Digitally Signed Documents ***************
	 **************************************************/ /**
	 * This function filter items by status, important the statuses must be organised in time order correctly on server
	 * What provide the status list here, to be able to decide, we are after or before.
	 * @param {*} fn
	 * @param {*} DSDocumentOriginTypes
	 */var DSDocFilters=function DSDocFilters(fn,DSDocumentOriginTypes){switch(fn){case "showDraft":return function(item){return item['package'].status === c.DS_FILLED_BY_BROKER;};break;case "showSigned":return function(item){var dsDocument=item.dsDocument;var templates=item.templates;var documentTemplateId=_nestedProperty2['default'].get(dsDocument,"documentTemplateId");var docTemplateArray=templates && templates.filter(function(oneTemplate){return String(oneTemplate._id) === String(documentTemplateId);}) || false;var documentTemplate=docTemplateArray && docTemplateArray[0] || false;var mustBeSigned=isDocumentMustBeSigned(DSDocumentOriginTypes,dsDocument.origin,documentTemplate);var signedIndex=-1;if(dsDocument['package'].statusHistory){dsDocument['package'].statusHistory.forEach(function(oneStatus,index){if(oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED && mustBeSigned){signedIndex = index;}});}return signedIndex !== -1;};break;case "showNotSigned":return function(item){var dsDocument=item.dsDocument;var templates=item.templates;var documentTemplateId=_nestedProperty2['default'].get(dsDocument,"documentTemplateId");var docTemplateArray=templates && templates.filter(function(oneTemplate){return String(oneTemplate._id) === String(documentTemplateId);}) || false;var documentTemplate=docTemplateArray && docTemplateArray[0] || false;var mustBeSigned=isDocumentMustBeSigned(DSDocumentOriginTypes,dsDocument.origin,documentTemplate);var signedIndex=-1;if(dsDocument['package'].statusHistory){dsDocument['package'].statusHistory.forEach(function(oneStatus,index){if(oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED){signedIndex = index;}});} // if package is signed but this is a document what does not require signature than to be listed
	// ASKED TO HIDE THIS EVEN IN THIS CASE: BEWB-408
	if(!mustBeSigned){signedIndex = 1;}return signedIndex == -1;};break;case "showAll":return function(item){return true;};case "showNotLinked":return function(item){try{var _ret22=(function(){var dsDocument=item.dsDocument;var templates=item.templates; // collecting the logical values for determination of result
	var documentTemplateId=_nestedProperty2['default'].get(dsDocument,"documentTemplateId");var docTemplateArray=templates && templates.filter(function(oneTemplate){return String(oneTemplate._id) === String(documentTemplateId);}) || false;var documentTemplate=docTemplateArray && docTemplateArray[0] || false;var mustBeSigned=isDocumentMustBeSigned(DSDocumentOriginTypes,dsDocument.origin,documentTemplate);var isSigned=documentIsSigned(dsDocument);var packageIsEditable=dsDocument['package'].isEditable === false?false:true; // determine the result
	return {v:!dsDocument.uploadedToOracle && checkIfShouldLinkWithContract(dsDocument) && !packageIsEditable?true:false};})();if(typeof _ret22 === 'object')return _ret22.v;}catch(error) {console.warn(error);}};break;}};var checkIfShouldLinkWithContract=function checkIfShouldLinkWithContract(dsDocument){ // if document is uploaded to oracle or doc is falsy return false
	if(!dsDocument || dsDocument.uploadedToOracle){return false;}var contractIdIsRequired=_nestedProperty2['default'].get(dsDocument,'documentTemplate.uploadedOnModule') === c.DS_MODULE_CLIENT_CONTRACT;if(!contractIdIsRequired){return false;}var hasContractId=_nestedProperty2['default'].get(dsDocument,"contractId"); //determine the result
	return contractIdIsRequired && !hasContractId;};var documentIsSigned=function documentIsSigned(dsDocument){var isSigned=false;if(dsDocument && dsDocument['package'].statusHistory){dsDocument['package'].statusHistory.forEach(function(oneStatus){if(oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED){isSigned = true;}});}return isSigned;}; /**
	 * This function returns true if the item could be shown by date filters, else return the original visibility value.
	 * @param {*} item
	 * @param {*} startDate
	 * @param {*} endDate
	 */var DSShouldShowByDates=function DSShouldShowByDates(item,startDate,endDate){var should=!item.hidden;var mStartDate=(0,_moment2['default'])((0,_moment2['default'])(startDate).format("DD-MM-YYYY"),"DD-MM-YYYY");var mEndDate=(0,_moment2['default'])((0,_moment2['default'])(endDate).format("DD-MM-YYYY"),"DD-MM-YYYY");var createdAt=(0,_moment2['default'])((0,_moment2['default'])(item.createdAt).format("DD-MM-YYYY"),"DD-MM-YYYY");if(startDate && mStartDate.isValid()){should = should && (!mStartDate.isAfter(createdAt) || mStartDate.isSame(createdAt));}if(endDate && mEndDate.isValid()){should = should && (mEndDate.isAfter(createdAt) || mEndDate.isSame(createdAt));}return should;}; /**
	 * This function provide the number of draft documents in the list.
	 * @param {array} items
	 */var calcDocDraft=function calcDocDraft(items){return items && items.reduce(function(a,i){return a + (i.status == 'draft'?1:1);}, // TODO implement it correctly
	0) || [];}; /**
	 * This function will set the visibility information for elements in the doc list, and format-extend the values for data table
	 * @param {*} items
	 * @param {*} state
	 */var DSDocumentItemsFormatter=function DSDocumentItemsFormatter(items,filterFunctionName,DSDocumentOriginTypes,startDate,endDate){var shouldShow=DSDocFilters(filterFunctionName,DSDocumentOriginTypes);var result=[]; //check if the sort condition is "showNotLinked" this procedure requires also the template list
	if(filterFunctionName && (filterFunctionName === 'showNotLinked' || filterFunctionName === 'showSigned' || filterFunctionName === 'showNotSigned')){result = items.dsDocuments.map(function(item){return _extends({},item,{id:item._id,hidden:!shouldShow({dsDocument:item,templates:items.templates})});}).map(function(item){return _extends({},item,{hidden:!DSShouldShowByDates(item,startDate,endDate)});});}else {result = items.map(function(item){return _extends({},item,{id:item._id,hidden:!shouldShow(item)});}).map(function(item){return _extends({},item,{hidden:!DSShouldShowByDates(item,startDate,endDate)});});}return result;}; /**
	 * This function extend the documents with package records
	 * @param {*} packages
	 * @param {*} documents
	 * @param {*} templates
	 */var DSPackageMergeToDoc=function DSPackageMergeToDoc(packages,documents,templates){if(!documents || documents.length === 0){return documents;}var packageMap={};packages && packages.forEach(function(onePackage){_nestedProperty2['default'].set(packageMap,onePackage._id,onePackage);});var templateMap={};templates && templates.forEach(function(oneTemplate){_nestedProperty2['default'].set(templateMap,oneTemplate._id,oneTemplate);}); // extend the documents with the package records
	documents = documents && documents.map(function(oneDoc){ // find the index of package
	return _extends({},oneDoc,{documentTemplate:_nestedProperty2['default'].get(templateMap,oneDoc.documentTemplateId) || {_id:oneDoc.documentTemplateId},'package':_nestedProperty2['default'].get(packageMap,oneDoc.packageId) || {_id:oneDoc.packageId}});});return documents;}; // initial values for module
	var DSDocumentsDefaults={items:[],paginatedPackages:[],totalPackageRecords:0,sortParams:{column:'createdAt',sortOrder:-1},pageNumber:0,filter:'',DSDocumentsFailedCount:0,selectValue:'showAll',subModule:'',opened:'',startDate:null,endDate:null,config:{},DSWizardOpened:false,forceOpenInvitationEditor:false,moduleKey:'',client:null,packages:[],templates:[],preSortDocumentsFromClient:null,subgroups:[],openedPackage:'',DSDocumentOriginTypes:{},forceOpenInvitationFromTicket:false,openedMifidKey:null}; /**
	 * Reducer for DSDocuments module
	 * @param {*} state
	 * @param {*} action
	 */var DSDocuments=function DSDocuments(state,action){if(state === undefined)state = DSDocumentsDefaults;switch(action.type){case c.APP_CHANGED:return _extends({},state,{DSDocumentOriginTypes:action.data.security.DigitalSignatureHardLists.DSDocumentOriginTypes});case c.SET_APP_MODULE: // reset some values
	return _extends({},state,{subModule:action.subModule || DSDocumentsDefaults.subModule,opened:action.opened || DSDocumentsDefaults.opened,openedPackage:action.openedPackage || DSDocumentsDefaults.openedPackage,selectValue:action.selectValue || DSDocumentsDefaults.selectValue,preSortDocumentsFromClient:action.preSortDocumentsFromClient || null});case c.NAVIGATE_TO_DSDOCUMENT:return _extends({},state,{subModule:action.subModule || DSDocumentsDefaults.subModule,opened:action.itemId || DSDocumentsDefaults.opened,selectValue:action.selectValue || DSDocumentsDefaults.selectValue});case c.GOT_DS_CONFIG:{return _extends({},state,{config:action.config});}case c.GOT_DSDOCUMENTS:{ // fill up documents with packages
	var items=DSPackageMergeToDoc(state.packages,items,state.templates);items = DSDocumentItemsFormatter(action.data,state.selectValue || DSDocumentsDefaults.selectValue,state.DSDocumentOriginTypes,state.startDate,state.endDate) || [];return _extends({},state,{items:items,DSDocumentsFailedCount:calcDocDraft(items),ts:action.ts});}case c.GOT_DSPACKAGES:{ // fill up documents with packages
	var items=DSPackageMergeToDoc(action.data,state.items,state.templates);return _extends({},state,{packages:action.data,items:items,DSDocumentsFailedCount:calcDocDraft(items)});}case c.GOT_DSDOCS_AND_PACKAGES:{var docs=_nestedProperty2['default'].get(action,"data.dsdocuments");var packages=_nestedProperty2['default'].get(action,"data.packages");var templates=_nestedProperty2['default'].get(action,"data.templates");var items=DSPackageMergeToDoc(packages,docs,templates);items = DSDocumentItemsFormatter(items,state.selectValue,state.DSDocumentOriginTypes,state.startDate,state.endDate) || [];return _extends({},state,{packages:packages,templates:templates,items:items,DSDocumentsFailedCount:calcDocDraft(items)});}case c.GOT_PAGINATED_PACKAGES:var _action$data=action.data,paginatedPackages=_action$data.paginatedPackages,totalPackageRecords=_action$data.totalPackageRecords,paginationData=_action$data.paginationData;return _extends({},state,{paginatedPackages:paginatedPackages,totalPackageRecords:totalPackageRecords,sortParams:paginationData.sortParams,pageNumber:paginationData.pageNumber,filter:paginationData.filter,selectValue:paginationData.filterFunction,startDate:paginationData.startDate,endDate:paginationData.endDate});case c.RESET_PAGINATED_DATA:return _extends({},state,{paginatedPackages:[],totalPackageRecords:0,sortParams:{column:'createdAt',sortOrder:-1},pageNumber:0,filter:'',selectValue:'showAll'});case c.GOT_DSDOCUMENT:{ // PATCH the new dsdocument record to the big list ot avoid the full fetch from the server
	var items=state.items.map(function(item){if(item._id == action.dsdocument._id){item = _extends({},item,action.dsdocument);}return item;}); // overview filtering again because updated values
	items = DSDocumentItemsFormatter(items,state.selectValue || DSDocumentsDefaults.selectValue,state.DSDocumentOriginTypes,state.startDate,state.endDate) || function(){return true;}; // push values back to the store, recalc draft items also
	return _extends({},state,{items:items,DSDocumentsFailedCount:calcDocDraft(items)});}case c.SET_DSDOCUMENT_SUB_MODULE:{var _name4=action.name;var subModuleZoom=action.subModuleZoom;return _extends({},state,{subModule:_name4,subModuleZoom:subModuleZoom});}case c.DSDOCUMENT_ITEM_ZOOMED:return _extends({},state,{opened:action.itemId});case c.DSDOCUMENT_PACKAGE_ZOOMED:return _extends({},state,{openedPackage:action.packageId});case c.TICKETS_FILTERED:return _extends({},state,{filter:action.filter || ''});case c.DSDOCUMENT_SET_FILTERED:{var selectValue=action.selectValue;var startDate=action.startDate;var endDate=action.endDate;var finalSelectValue=selectValue || state.selectValue;var finalStartDate=startDate?startDate:null;var finalEndDate=endDate?endDate:null;var itemsToSort={dsDocuments:state.items}; //check if the sort condition is "showNotLinked" this procedure requires also the template list
	if(finalSelectValue && (finalSelectValue === 'showNotLinked' || finalSelectValue === 'showSigned' || finalSelectValue === 'showNotSigned')){itemsToSort = {dsDocuments:state.items,templates:state.templates};}var items=DSDocumentItemsFormatter(itemsToSort,finalSelectValue,state.DSDocumentOriginTypes,finalStartDate,finalEndDate) || function(){return true;};return _extends({},state,{items:items,selectValue:finalSelectValue,startDate:finalStartDate,endDate:finalEndDate,preSortDocumentsFromClient:null});}case c.SET_ALL_VISIBLE_CHECKED:{return _extends({},state,{paginatedPackages:state.paginatedPackages.map(function(onePackage){onePackage.checked = onePackage.checked?false:true;return onePackage;})}); // const items = action.visibleItems
	// const vI = items.length
	// const cI = state.items.reduce(
	//     (acc, item) => acc + (item.checked && items.includes(item.id) ? 1 : 0),
	//     0
	// )
	// const toCheck = vI !== cI
	// return {...state, items: state.items.map(item => ({...item, checked: items.includes(item.id) ? toCheck : item.checked}))}
	}case c.SET_ALL_CHECKED:{return _extends({},state,{paginatedPackages:state.paginatedPackages && state.paginatedPackages.map(function(onePackage){return _extends({},onePackage,{checked:true});}) || []});}case c.SET_CHECKBOX:return _extends({},state,{paginatedPackages:state.paginatedPackages.map(function(onePackage){return _extends({},onePackage,{checked:onePackage.id === action.id?!onePackage.checked:onePackage.checked});})});case c.LOGGED_OUT:return DSDocumentsDefaults;case c.DSDOCUMENT_ITEMS_STATUS:{var _ret23=(function(){var emailIds=action.emailIds;var archived=action.status.archived;var newItems=state.items.map(function(i){if(emailIds.includes(i.id)){return _extends({},i,{archived:archived == null?i.archived:archived});}return i;});return {v:_extends({},state,{items:newItems})};})();if(typeof _ret23 === 'object')return _ret23.v;}case c.SET_DS_WIZARD:{return _extends({},state,{DSWizardOpened:action.DSWizardOpened,moduleKey:action.moduleKey,openedMifidKey:action.mifidKey});}case c.SET_DS_INVITATION_EDITOR:{return _extends({},state,{forceOpenInvitationEditor:action.forceOpenInvitationEditor,moduleKey:action.moduleKey});}case c.SET_DS_INVITATION_EDITOR_FROM_TICKET:{return _extends({},state,{forceOpenInvitationFromTicket:action.forceOpenInvitationFromTicket,moduleKey:action.moduleKey});}case c.SET_CLIENT_DATA:{return _extends({},state,{client:_extends({},action.response,{clientId:action.clientId,clientNumber:action.clientNumber})});}case c.GOT_DSDOCUMENT_TEMPLATE:{return _extends({},state,{templates:action.data});}case c.GOT_DSDATASET:{return _extends({},state,{DSDataSets:action.data});}case c.GOT_TEAM_SUBGROUPS:{return _extends({},state,{subgroups:action.data});}default:return state;}};exports.DSDocuments = DSDocuments; /**************************************************
	 * **** END OF  Digitally Signed Documents ********
	 **************************************************/ // initial values for module
	var usersProcessFlagDefaults={}; /**
	 * Reducer for DSDocuments module
	 * @param {*} state
	 * @param {*} action
	 */var UsersProcessFlag=function UsersProcessFlag(state,action){if(state === undefined)state = usersProcessFlagDefaults;switch(action.type){ // update the users process record in store
	case c.USERS_PROCESS_FLAG_ARRIVED:{if(!action.referenceId){throw new Error("Missing referenceId for watching users process flag.");}var referenceId=action.referenceId || "unknownReference"; // if there is no reference that is an error
	var record=action.record;var isActive=_nestedProperty2['default'].get(state,referenceId + ".isActive") || false;var checkpointCount=_nestedProperty2['default'].get(state,referenceId + ".checkpointCount") || 1;return _extends({},state,_defineProperty({},referenceId,{record:record, // update the users process flag record arrived from server
	isActive:isActive, // this must be unchanged here
	checkpointCount:checkpointCount // this must be unchanged here
	}));} // stop watching the users process record from server
	case c.USERS_PROCESS_FLAG_STOP_WATCH:{if(!action.referenceId){throw new Error("Missing referenceId for watching users process flag.");}var referenceId=action.referenceId || "unknownReference"; // if there is no reference that is an error
	var record=_nestedProperty2['default'].get(state,referenceId + ".record");var checkpointCount=_nestedProperty2['default'].get(state,referenceId + ".checkpointCount") || 1;return _extends({},state,_defineProperty({},referenceId,{record:record, // this must be unchanged here
	checkpointCount:checkpointCount, // this must be unchanged here
	isActive:false // deactivate the watching of the server
	}));} // start watching the users process record from server
	case c.USERS_PROCESS_FLAG_START_WATCH:{if(!action.referenceId){throw new Error("Missing referenceId for watching users process flag.");}var referenceId=action.referenceId || "unknownReference"; // if there is no reference that is an error
	var checkpointCount=action.checkpointCount || 1; // if there is no reference that is an error
	var record=_nestedProperty2['default'].get(state,referenceId + ".record");return _extends({},state,_defineProperty({},referenceId,{record:record, // this must be unchanged here
	isActive:true, // deactivate the watching of the server
	checkpointCount:checkpointCount // count of elements to show the dots in the progress line
	}));} // remove a users process flag reference from store.
	case c.USERS_PROCESS_FLAG_REMOVE:{if(!action.referenceId){return console.error("Missing referenceId for clear users process flag.");}var referenceId=action.referenceId || "unknownReference"; // if there is no reference that is an error
	var newState=state; // remove the specified reference from store
	if(newState && newState[referenceId]){delete newState[referenceId];} // apply new state for store
	return newState;}default:return state;}};exports.UsersProcessFlag = UsersProcessFlag; /**
	 * This function determine if a document must be signed.
	 * This function will be obsolete here, when the client side dsdocument filtering will be removed.
	 * @param {object} DSDocumentOriginTypes
	 * @param {string} origin
	 * @param {object} documentTemplate
	 * @returns
	 */var isDocumentMustBeSigned=function isDocumentMustBeSigned(DSDocumentOriginTypes,origin){var documentTemplate=arguments.length <= 2 || arguments[2] === undefined?null:arguments[2];if(!DSDocumentOriginTypes){return null;}switch(origin){case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD:{return true;break;}case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:{return true;break;}case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:default:{return !!documentTemplate.mustBeSigned;}}}; // Version 10
	var claimWizardDefaults={wizardStep:'1',claimData:{},isLegalAid:false,documents:[],involvedParties:[],optionalParties:[],involvedPartiesData:[],dsDocumentTemplates:[],documentFiles:[],claimWizardPackages:[],dsPackages:{},hasSubQualifications:false};var claimWizard=function claimWizard(state,action){if(state === undefined)state = claimWizardDefaults; // define involved parties fields
	var formFields=['lastName','firstName','email','street','number','box','postalCode','town','country','phoneNumber'];var requiredFieldsMapping={'Name':['lastName'],'Mail':['email'],'Phone':['phoneNumber'],'Address':['street','number','postalCode','town','country']};var generateStep3DocumentData=function generateStep3DocumentData(doc,dsDocumentTemplates){var docData={docType:doc.docType,digitalClaimDocuments:[],alternativeDocTypes:doc.alternativeDocTypes?doc.alternativeDocTypes.map(function(option){return {alternativeId:option.alternativeNr,alternativeLabel:option.alternativeId,alternatives:option.alternatives.map(function(alternative){return {docType:alternative,hasDsDocumentTemplate:dsDocumentTemplates.some(function(template){return template.active && template.indexType.lowValue === alternative;})};})};}):[],alternativeSelectionId:'', //check if a document has a dsDocumentTemplate
	hasDsDocumentTemplate:dsDocumentTemplates.some(function(template){return template.active && template.indexType.lowValue === doc.docType;})};return docData;};switch(action.type){case c.SET_CLAIM_WIZARD_STEP:{ //if we are on step 3 we need to keep the document files otherwise we need to reset them
	var documentFiles=[];if(action.wizardStep === '3' || action.wizardStep === '4'){documentFiles = state.documentFiles;}return _extends({},state,{documentFiles:documentFiles,wizardStep:action.wizardStep});}case c.SET_CLAIM_WIZARD_DATA:{return _extends({},state,{claimData:_extends({},action.claimData)});}case c.TOGGLE_LEGAL_AID:{return _extends({},state,{isLegalAid:action.isLegalAid});}case c.SET_CLAIM_WIZARD_DOCUMENTATION:{var _ret24=(function(){var claimData=state.claimData;var involvedPartiesData=[]; //generate mandatory fields for involved party
	action.involvedParties.forEach(function(oneInvParty){var partyDataFields={id:(0,_uuidV42['default'])(),partyNumber:oneInvParty.partyNumber,isMandatory:true,fields:{}};formFields.forEach(function(oneField){partyDataFields.fields[oneField] = {value:oneField === 'country'?'1':'',required:Object.keys(requiredFieldsMapping).some(function(key){return requiredFieldsMapping[key].includes(oneField) && oneInvParty.requiredFields.includes(key);})};});involvedPartiesData.push(partyDataFields);}); // set already existing party data 
	if(claimData.involvedParties){claimData.involvedParties.forEach(function(oneClaimPartyData){var index=involvedPartiesData.findIndex(function(oneParty){return oneParty.partyNumber === oneClaimPartyData.partyNumber;}); //if fields are already created it means this party is mandatory and we only need to fill data out
	//if index <0 it means this party is optional and we need to add a new optional party 
	if(index > -1){Object.keys(involvedPartiesData[index].fields).forEach(function(key){involvedPartiesData[index].fields[key].value = oneClaimPartyData[key];});}else {(function(){var partyDataFields={id:(0,_uuidV42['default'])(),partyNumber:oneClaimPartyData.partyNumber,isMandatory:false,fields:{}};formFields.forEach(function(oneField){partyDataFields.fields[oneField] = {value:oneClaimPartyData[oneField],required:false};});involvedPartiesData.push(partyDataFields);})();}});}return {v:_extends({},state,{documents:action.documents,involvedParties:action.involvedParties,optionalParties:action.optionalParties, // optionalPartyOptionsList,
	involvedPartiesData:involvedPartiesData})};})();if(typeof _ret24 === 'object')return _ret24.v;}case c.ADD_OPTIONAL_PARTY:{var _ret26=(function(){var existingPartiesData=[].concat(_toConsumableArray(state.involvedPartiesData));var optionalParty={id:(0,_uuidV42['default'])(),partyNumber:'',isMandatory:false,fields:{}};formFields.forEach(function(oneField){optionalParty.fields[oneField] = {value:oneField === 'country'?'1':'',required:false};});existingPartiesData.push(optionalParty);return {v:_extends({},state,{involvedPartiesData:[].concat(_toConsumableArray(existingPartiesData))})};})();if(typeof _ret26 === 'object')return _ret26.v;}case c.UPDATE_PARTY_FIELD:{var existingParties=[].concat(_toConsumableArray(state.involvedPartiesData));var index=existingParties.findIndex(function(oneParty){return oneParty.id === action.partyId;});if(index || index > -1){if(action.field === 'partyNumber'){existingParties[index].partyNumber = action.value;}else {existingParties[index].fields[action.field].value = action.value;}}return _extends({},state,{involvedPartiesData:existingParties});}case c.REMOVE_OPTIONAL_PARTY:{var existingParties=[].concat(_toConsumableArray(state.involvedPartiesData));var index=existingParties.findIndex(function(oneParty){return oneParty.id === action.partyId;});if(index && index > -1){existingParties.splice(index,1);}return _extends({},state,{involvedPartiesData:existingParties});}case c.SET_DOCUMENTS_FOR_STEP_THREE:{var _iteratorNormalCompletion8;var _didIteratorError8;var _iteratorError8;var _iterator8,_step8;var _iteratorNormalCompletion9;var _didIteratorError9;var _iteratorError9;var _iterator9,_step9;var _iteratorNormalCompletion10;var _didIteratorError10;var _iteratorError10;var _iterator10,_step10;var _iteratorNormalCompletion11;var _didIteratorError11;var _iteratorError11;var _iterator11,_step11;var _ret27=(function(){var claimData=state.claimData;var documents=state.documents;var documentFiles=[];var dsDocumentTemplates=action.dsDocumentTemplates;var claimWizardDocumentsData={wizardMandatory:[],claimMandatory:[],wizardOptional:[]}; //generate required documents for step 3 
	_iteratorNormalCompletion8 = true;_didIteratorError8 = false;_iteratorError8 = undefined;try{for(_iterator8 = documents[Symbol.iterator]();!(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done);_iteratorNormalCompletion8 = true) {var doc=_step8.value;switch(doc.required.toUpperCase()){case 'WIZARD':claimWizardDocumentsData.wizardMandatory.push(generateStep3DocumentData(doc,dsDocumentTemplates));break;case 'CLOSE':claimWizardDocumentsData.claimMandatory.push(generateStep3DocumentData(doc,dsDocumentTemplates));break;default:break;}} //handle existing documents
	}catch(err) {_didIteratorError8 = true;_iteratorError8 = err;}finally {try{if(!_iteratorNormalCompletion8 && _iterator8['return']){_iterator8['return']();}}finally {if(_didIteratorError8){throw _iteratorError8;}}}if(action.claimWizardDocuments){_iteratorNormalCompletion9 = true;_didIteratorError9 = false;_iteratorError9 = undefined;try{var _loop=function(){var doc=_step9.value; //add optional Documents to wizardOptional if we have any files for optional documents
	var documentIndex=documents.findIndex(function(oneDoc){return oneDoc.docType === doc.docType;});if(documentIndex > -1){var _document=documents[documentIndex];if(_document.required.toUpperCase() === 'OPTIONAL' && !claimWizardDocumentsData.wizardOptional.some(function(oneDoc){return oneDoc.docType === doc.docType;})){claimWizardDocumentsData.wizardOptional.push(generateStep3DocumentData(doc,dsDocumentTemplates));}} //handle alternative documents
	if(doc.mainDocType && doc.alternativeId){var mainDocumentIndex=documents.findIndex(function(oneDoc){return oneDoc.docType === doc.mainDocType;});if(mainDocumentIndex > -1){var mainDocument=documents[mainDocumentIndex];switch(mainDocument.required.toUpperCase()){case 'WIZARD':var wizardMandatoryIndex=claimWizardDocumentsData.wizardMandatory.findIndex(function(oneDoc){return oneDoc.docType === doc.mainDocType;});if(wizardMandatoryIndex > -1){claimWizardDocumentsData.wizardMandatory[wizardMandatoryIndex].alternativeSelectionId = doc.alternativeId;}break;case 'CLOSE':var claimMandatoryIndex=claimWizardDocumentsData.claimMandatory.findIndex(function(oneDoc){return oneDoc.docType === doc.mainDocType;});if(claimMandatoryIndex > -1){claimWizardDocumentsData.claimMandatory[claimMandatoryIndex].alternativeSelectionId = doc.alternativeId;}break;case 'OPTIONAL':var claimOptionalIndex=claimWizardDocumentsData.wizardOptional.findIndex(function(oneDoc){return oneDoc.docType === doc.mainDocType;});claimWizardDocumentsData.wizardOptional[claimOptionalIndex].alternativeSelectionId = doc.alternativeId;break;default:break;}}}documentFiles.push(doc);};for(_iterator9 = action.claimWizardDocuments[Symbol.iterator]();!(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done);_iteratorNormalCompletion9 = true) {_loop();}}catch(err) {_didIteratorError9 = true;_iteratorError9 = err;}finally {try{if(!_iteratorNormalCompletion9 && _iterator9['return']){_iterator9['return']();}}finally {if(_didIteratorError9){throw _iteratorError9;}}}}var dsPackages={}; // handle dsWizard Documents for step 3
	if(action.dsDocumentPackages){_iteratorNormalCompletion10 = true;_didIteratorError10 = false;_iteratorError10 = undefined;try{for(_iterator10 = action.dsDocumentPackages[Symbol.iterator]();!(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done);_iteratorNormalCompletion10 = true) {var oneDsPackage=_step10.value;_iteratorNormalCompletion11 = true;_didIteratorError11 = false;_iteratorError11 = undefined;try{var _loop2=function(){var oneDocument=_step11.value;var docFile={name:oneDocument.fileName,docType:oneDocument.origin === "DS_ORIGIN_LOCAL_UPLOAD" && oneDocument.documentTypeIdx || oneDocument.origin === "DS_ORIGIN_ORACLE" && oneDocument.documentTypeIdx || oneDocument.documentTemplate && oneDocument.documentTemplate.indexType && oneDocument.documentTemplate.indexType.lowValue || '',uploaded:oneDocument.uploadedToOracle,dsPackageStatus:oneDsPackage.status,dsPackageId:oneDsPackage._id}; //check if document types are alternative types
	var alternativeId=null;var mainDocType=null;documents.forEach(function(oneDoc){ //in case there are dsDocuments for a optional document we need to add claimOptional to claimWizardDocumentsData
	if(claimWizardDocumentsData.wizardOptional.findIndex(function(doc){return doc.docType === oneDoc.docType;}) === -1 && oneDoc.docType === docFile.docType && oneDoc.required.toUpperCase() === 'OPTIONAL'){claimWizardDocumentsData.wizardOptional.push(generateStep3DocumentData(oneDoc,dsDocumentTemplates));} // check if the document is an alternative document
	if(oneDoc.docType === docFile.docType){alternativeId = null;mainDocType = null;}else if(oneDoc.alternativeDocTypes && oneDoc.alternativeDocTypes.length > 0){var alternativeDoc=oneDoc.alternativeDocTypes.find(function(oneAlternative){return oneAlternative.alternatives.some(function(oneAlternative){return oneAlternative === docFile.docType;});});if(alternativeDoc){ //data from oracle the actal id is in alternativeNr 
	alternativeId = alternativeDoc.alternativeNr;mainDocType = oneDoc.docType;switch(oneDoc.required.toUpperCase()){case 'WIZARD':var wizardMandatoryIndex=claimWizardDocumentsData.wizardMandatory.findIndex(function(doc){return doc.docType === oneDoc.docType;});if(wizardMandatoryIndex > -1){claimWizardDocumentsData.wizardMandatory[wizardMandatoryIndex].alternativeSelectionId = alternativeId;}break;case 'CLOSE':var claimMandatoryIndex=claimWizardDocumentsData.claimMandatory.findIndex(function(doc){return doc.docType === oneDoc.docType;});if(claimMandatoryIndex > -1){claimWizardDocumentsData.claimMandatory[claimMandatoryIndex].alternativeSelectionId = alternativeId;}break;case 'OPTIONAL':var claimOptionalIndex=claimWizardDocumentsData.wizardOptional.findIndex(function(doc){return doc.docType === oneDoc.docType;});claimWizardDocumentsData.wizardOptional[claimOptionalIndex].alternativeSelectionId = alternativeId;break;default:break;}}}});docFile.alternativeId = alternativeId;docFile.mainDocType = mainDocType;documentFiles.push(docFile);};for(_iterator11 = oneDsPackage.dsDocuments[Symbol.iterator]();!(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done);_iteratorNormalCompletion11 = true) {_loop2();}}catch(err) {_didIteratorError11 = true;_iteratorError11 = err;}finally {try{if(!_iteratorNormalCompletion11 && _iterator11['return']){_iterator11['return']();}}finally {if(_didIteratorError11){throw _iteratorError11;}}}dsPackages[oneDsPackage._id] = oneDsPackage;}}catch(err) {_didIteratorError10 = true;_iteratorError10 = err;}finally {try{if(!_iteratorNormalCompletion10 && _iterator10['return']){_iterator10['return']();}}finally {if(_didIteratorError10){throw _iteratorError10;}}}}return {v:_extends({},state,{claimWizardDocumentsData:claimWizardDocumentsData,dsDocumentTemplates:dsDocumentTemplates,documentFiles:documentFiles,dsPackages:dsPackages})};})();if(typeof _ret27 === 'object')return _ret27.v;}case c.ADD_OPTIONAL_CLAIM_DOCUMENT:{var claimWizardDocumentsData=_extends({},state.claimWizardDocumentsData);var newDocument={id:(0,_uuidV42['default'])(),docType:'',digitalClaimDocuments:[],alternativeDocTypes:[],alternativeSelectionId:'',hasDsDocumentTemplate:false};claimWizardDocumentsData.wizardOptional.push(newDocument);return _extends({},state,{claimWizardDocumentsData:claimWizardDocumentsData});}case c.UPDATE_CLAIM_WIZARD_OPTIONAL_DOCUMENT:{var wizardOptionalDocs=[].concat(_toConsumableArray(state.claimWizardDocumentsData.wizardOptional));var documents=state.documents;var dsDocumentTemplates=state.dsDocumentTemplates;var index=wizardOptionalDocs.findIndex(function(oneDoc){return oneDoc.id === action.tempId;});if(index > -1){(function(){var docType=action.docType;var document=documents.find(function(oneDoc){return oneDoc.docType === docType;});var docData=generateStep3DocumentData(document,dsDocumentTemplates);wizardOptionalDocs[index] = _extends({},wizardOptionalDocs[index],docData);})();}return _extends({},state,{claimWizardDocumentsData:_extends({},state.claimWizardDocumentsData,{wizardOptional:wizardOptionalDocs})});}case c.REMOVE_CLAIM_WIZARD_OPTIONAL_DOCUMENT:{var claimWizardDocumentsData=state.claimWizardDocumentsData;var wizardOptionalDocs=claimWizardDocumentsData.wizardOptional;var index=wizardOptionalDocs.findIndex(function(oneDoc){return oneDoc.id === action.tempId;});if(index > -1){wizardOptionalDocs.splice(index,1);}return _extends({},state,{claimWizardDocumentsData:_extends({},claimWizardDocumentsData,{wizardOptional:wizardOptionalDocs})});}case c.SET_ALTERNATIVE_DOC_TYPE:{var claimWizardDocumentsData=state.claimWizardDocumentsData;var docType=action.docType;var alternativeSelectionId=action.alternativeSelectionId;var documents=claimWizardDocumentsData.wizardMandatory.concat(claimWizardDocumentsData.claimMandatory,claimWizardDocumentsData.wizardOptional);var _iteratorNormalCompletion12=true;var _didIteratorError12=false;var _iteratorError12=undefined;try{for(var _iterator12=documents[Symbol.iterator](),_step12;!(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done);_iteratorNormalCompletion12 = true) {var doc=_step12.value;if(doc.docType === docType){doc.alternativeSelectionId = alternativeSelectionId;}}}catch(err) {_didIteratorError12 = true;_iteratorError12 = err;}finally {try{if(!_iteratorNormalCompletion12 && _iterator12['return']){_iterator12['return']();}}finally {if(_didIteratorError12){throw _iteratorError12;}}}return _extends({},state,{claimWizardDocumentsData:claimWizardDocumentsData});}case c.ADD_FILES_TO_CLAIM_WIZARD:{var documentFiles=[].concat(_toConsumableArray(state.documentFiles));var _files8=action.files;documentFiles.push.apply(documentFiles,_toConsumableArray(_files8));return _extends({},state,{documentFiles:documentFiles});}case c.REMOVE_DOCUMENT_FILE_FROM_CLAIM_WIZARD:{var documentFiles=[].concat(_toConsumableArray(state.documentFiles));var index=documentFiles.findIndex(function(oneFile){return oneFile.fileId === action.fileId;});if(index > -1){documentFiles.splice(index,1);}return _extends({},state,{documentFiles:documentFiles});}case c.UPDATE_FILE_UPLOAD_STATUS:{var documentFiles=[].concat(_toConsumableArray(state.documentFiles));var index=documentFiles.findIndex(function(oneFile){return oneFile.fileId === action.fileId;});if(index > -1){switch(action.status){case 'success':documentFiles[index].uploaded = true;break;case 'failed':documentFiles[index].uploaded = false;documentFiles[index].error = action.message;break;default:break;}}return _extends({},state,{documentFiles:documentFiles});}case c.RESET_CLAIM_WIZARD:{return _extends({},state,claimWizardDefaults,{claimWizardPackages:state.claimWizardPackages});}case c.SET_ALL_CLAIMWIZARD_PACKAGES:{if(action.claimWizardPackages){return _extends({},state,{claimWizardPackages:action.claimWizardPackages});}}case c.SET_CLAIM_WIZARD_SUBQUALIFICATION:{return _extends({},state,{hasSubQualifications:action.hasSubQualifications});}case c.CLEAR_CLAIM_WIZARD_PACKAGES:{return _extends({},state,{claimWizardPackages:[]});}default:{return state;}}};exports.claimWizard = claimWizard;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1184), __esModule: true };

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1185), __esModule: true };

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1187), __esModule: true };

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1188), __esModule: true };

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1189), __esModule: true };

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(619);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1208);
	module.exports = __webpack_require__(126).Object.assign;


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1209);
	var $Object = __webpack_require__(126).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1210);
	var $Object = __webpack_require__(126).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1211);
	module.exports = __webpack_require__(126).Object.setPrototypeOf;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1214);
	__webpack_require__(1212);
	__webpack_require__(1215);
	__webpack_require__(1216);
	module.exports = __webpack_require__(126).Symbol;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1213);
	__webpack_require__(1217);
	module.exports = __webpack_require__(389).f('iterator');


/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(179);
	var toLength = __webpack_require__(1206);
	var toAbsoluteIndex = __webpack_require__(1205);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(267);
	var gOPS = __webpack_require__(381);
	var pIE = __webpack_require__(268);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(128).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(621);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(380);
	var descriptor = __webpack_require__(269);
	var setToStringTag = __webpack_require__(382);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(177)(IteratorPrototype, __webpack_require__(180)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(270)('meta');
	var isObject = __webpack_require__(178);
	var has = __webpack_require__(144);
	var setDesc = __webpack_require__(145).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(223)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(127);
	var getKeys = __webpack_require__(267);
	var gOPS = __webpack_require__(381);
	var pIE = __webpack_require__(268);
	var toObject = __webpack_require__(386);
	var IObject = __webpack_require__(625);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(223)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(145);
	var anObject = __webpack_require__(222);
	var getKeys = __webpack_require__(267);
	
	module.exports = __webpack_require__(127) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(179);
	var gOPN = __webpack_require__(628).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(144);
	var toObject = __webpack_require__(386);
	var IE_PROTO = __webpack_require__(383)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(178);
	var anObject = __webpack_require__(222);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(622)(Function.call, __webpack_require__(627).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(385);
	var defined = __webpack_require__(377);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(385);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(385);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1191);
	var step = __webpack_require__(1197);
	var Iterators = __webpack_require__(379);
	var toIObject = __webpack_require__(179);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(626)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(176);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1199) });


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(176);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(380) });


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(176);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(127), 'Object', { defineProperty: __webpack_require__(145).f });


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(176);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1203).set });


/***/ }),
/* 1212 */
/***/ (function(module, exports) {



/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1204)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(626)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(128);
	var has = __webpack_require__(144);
	var DESCRIPTORS = __webpack_require__(127);
	var $export = __webpack_require__(176);
	var redefine = __webpack_require__(630);
	var META = __webpack_require__(1198).KEY;
	var $fails = __webpack_require__(223);
	var shared = __webpack_require__(384);
	var setToStringTag = __webpack_require__(382);
	var uid = __webpack_require__(270);
	var wks = __webpack_require__(180);
	var wksExt = __webpack_require__(389);
	var wksDefine = __webpack_require__(388);
	var enumKeys = __webpack_require__(1193);
	var isArray = __webpack_require__(1195);
	var anObject = __webpack_require__(222);
	var isObject = __webpack_require__(178);
	var toObject = __webpack_require__(386);
	var toIObject = __webpack_require__(179);
	var toPrimitive = __webpack_require__(387);
	var createDesc = __webpack_require__(269);
	var _create = __webpack_require__(380);
	var gOPNExt = __webpack_require__(1201);
	var $GOPD = __webpack_require__(627);
	var $GOPS = __webpack_require__(381);
	var $DP = __webpack_require__(145);
	var $keys = __webpack_require__(267);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(628).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(268).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(266)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(177)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(388)('asyncIterator');


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(388)('observable');


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1207);
	var global = __webpack_require__(128);
	var hide = __webpack_require__(177);
	var Iterators = __webpack_require__(379);
	var TO_STRING_TAG = __webpack_require__(180)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(1219);
	
	module.exports = function batchProcessorMaker(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var asyncProcess    = utils.getOption(options, "async", true);
	    var autoProcess     = utils.getOption(options, "auto", true);
	
	    if(autoProcess && !asyncProcess) {
	        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
	        asyncProcess = true;
	    }
	
	    var batch = Batch();
	    var asyncFrameHandler;
	    var isProcessing = false;
	
	    function addFunction(level, fn) {
	        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
	            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
	            // This needs to be done before, since we're checking the size of the batch to be 0.
	            processBatchAsync();
	        }
	
	        batch.add(level, fn);
	    }
	
	    function processBatch() {
	        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
	        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
	        isProcessing = true;
	        while (batch.size()) {
	            var processingBatch = batch;
	            batch = Batch();
	            processingBatch.process();
	        }
	        isProcessing = false;
	    }
	
	    function forceProcessBatch(localAsyncProcess) {
	        if (isProcessing) {
	            return;
	        }
	
	        if(localAsyncProcess === undefined) {
	            localAsyncProcess = asyncProcess;
	        }
	
	        if(asyncFrameHandler) {
	            cancelFrame(asyncFrameHandler);
	            asyncFrameHandler = null;
	        }
	
	        if(localAsyncProcess) {
	            processBatchAsync();
	        } else {
	            processBatch();
	        }
	    }
	
	    function processBatchAsync() {
	        asyncFrameHandler = requestFrame(processBatch);
	    }
	
	    function clearBatch() {
	        batch           = {};
	        batchSize       = 0;
	        topLevel        = 0;
	        bottomLevel     = 0;
	    }
	
	    function cancelFrame(listener) {
	        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
	        var cancel = clearTimeout;
	        return cancel(listener);
	    }
	
	    function requestFrame(callback) {
	        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
	        var raf = function(fn) { return setTimeout(fn, 0); };
	        return raf(callback);
	    }
	
	    return {
	        add: addFunction,
	        force: forceProcessBatch
	    };
	};
	
	function Batch() {
	    var batch       = {};
	    var size        = 0;
	    var topLevel    = 0;
	    var bottomLevel = 0;
	
	    function add(level, fn) {
	        if(!fn) {
	            fn = level;
	            level = 0;
	        }
	
	        if(level > topLevel) {
	            topLevel = level;
	        } else if(level < bottomLevel) {
	            bottomLevel = level;
	        }
	
	        if(!batch[level]) {
	            batch[level] = [];
	        }
	
	        batch[level].push(fn);
	        size++;
	    }
	
	    function process() {
	        for(var level = bottomLevel; level <= topLevel; level++) {
	            var fns = batch[level];
	
	            for(var i = 0; i < fns.length; i++) {
	                var fn = fns[i];
	                fn();
	            }
	        }
	    }
	
	    function getSize() {
	        return size;
	    }
	
	    return {
	        add: add,
	        process: process,
	        size: getSize
	    };
	}


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	"use strict";
	
	var utils = module.exports = {};
	
	utils.getOption = getOption;
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}


/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	module.exports = {
	  signatureTemplate: "<table style=\"border-spacing: 0px; font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; page-break-inside: avoid !important;\">\n  <tr style=\"padding: 0; margin: 0;\">\n    <td rowspan=\"5\" style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;\">\n      <img src=\"{{URL_BROKER_LOGO}}\" width=\"180\" />\n    </td>\n    <td colspan=\"2\" style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;\">\n      <span  style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; font-weight: bold;\">{{name}}</span>\n    </td>\n  </tr>\n\n  <tr style=\"padding: 0; margin: 0;\">\n    <td colspan=\"2\" style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;\">\n      <span  style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; font-weight: bold;\">{{commercialName}}</span>\n    </td>\n  </tr>\n\n  <tr style=\"padding: 0; margin: 0;\">\n    <td colspan=\"2\" style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;\">\n      <span  style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;\">{{fullAddress}}</span>\n    </td>\n  </tr>\n\n  <tr style=\"padding: 0; margin: 0;\">\n    <td style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;\">\n      <span  style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;\">{{emails}}</span>\n    </td>\n    <td style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;\">\n      <span  style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;\">{{website}}</span>\n    </td>\n  </tr>\n\n  <tr style=\"padding: 0; margin: 0;\">\n    <td colspan=\"2\" style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;\">\n      <span style=\"{{faxAndPhoneAdditionalCss}} font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;\">{{phoneNumbers}}</span>\n      <span style=\"{{faxAndPhoneAdditionalCss}} font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;\">{{fax}}</span>\n      {{faxAndPhoneSeparator}}\n      <span style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;\">{{fsma}}</span>\n      <span style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;\">{{companyRegistrationNumber}}</span>\n      <span style=\"font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;\">{{signatureText}}</span>\n    </td>\n  </tr>\n\n  </table>"
	};


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(636);
	} catch (err) {
	  var index = __webpack_require__(636);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isDetached = __webpack_require__(639);
	
	var $TypeError = TypeError;
	
	module.exports = function (it) {
	  if (isDetached(it)) throw new $TypeError('ArrayBuffer is detached');
	  return it;
	};


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isArray = __webpack_require__(131);
	var isConstructor = __webpack_require__(186);
	var isObject = __webpack_require__(25);
	var wellKnownSymbol = __webpack_require__(27);
	
	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;
	
	// a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray) {
	  var C;
	  if (isArray(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
	    else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? $Array : C;
	};


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(20);
	var iteratorClose = __webpack_require__(286);
	
	// call something on iterator step with safe closing on error
	module.exports = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (error) {
	    iteratorClose(iterator, 'throw', error);
	  }
	};


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	var padStart = __webpack_require__(424).start;
	
	var $RangeError = RangeError;
	var $isFinite = isFinite;
	var abs = Math.abs;
	var DatePrototype = Date.prototype;
	var nativeDateToISOString = DatePrototype.toISOString;
	var thisTimeValue = uncurryThis(DatePrototype.getTime);
	var getUTCDate = uncurryThis(DatePrototype.getUTCDate);
	var getUTCFullYear = uncurryThis(DatePrototype.getUTCFullYear);
	var getUTCHours = uncurryThis(DatePrototype.getUTCHours);
	var getUTCMilliseconds = uncurryThis(DatePrototype.getUTCMilliseconds);
	var getUTCMinutes = uncurryThis(DatePrototype.getUTCMinutes);
	var getUTCMonth = uncurryThis(DatePrototype.getUTCMonth);
	var getUTCSeconds = uncurryThis(DatePrototype.getUTCSeconds);
	
	// `Date.prototype.toISOString` method implementation
	// https://tc39.es/ecma262/#sec-date.prototype.toisostring
	// PhantomJS / old WebKit fails here:
	module.exports = (fails(function () {
	  return nativeDateToISOString.call(new Date(-5e13 - 1)) !== '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  nativeDateToISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!$isFinite(thisTimeValue(this))) throw new $RangeError('Invalid time value');
	  var date = this;
	  var year = getUTCFullYear(date);
	  var milliseconds = getUTCMilliseconds(date);
	  var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
	  return sign + padStart(abs(year), sign ? 6 : 4, 0) +
	    '-' + padStart(getUTCMonth(date) + 1, 2, 0) +
	    '-' + padStart(getUTCDate(date), 2, 0) +
	    'T' + padStart(getUTCHours(date), 2, 0) +
	    ':' + padStart(getUTCMinutes(date), 2, 0) +
	    ':' + padStart(getUTCSeconds(date), 2, 0) +
	    '.' + padStart(milliseconds, 3, 0) +
	    'Z';
	} : nativeDateToISOString;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(20);
	var ordinaryToPrimitive = __webpack_require__(682);
	
	var $TypeError = TypeError;
	
	// `Date.prototype[@@toPrimitive](hint)` method implementation
	// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
	module.exports = function (hint) {
	  anObject(this);
	  if (hint === 'string' || hint === 'default') hint = 'string';
	  else if (hint !== 'number') throw new $TypeError('Incorrect hint');
	  return ordinaryToPrimitive(this, hint);
	};


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(99);
	
	module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(99);
	
	module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	
	module.exports = function (CONSTRUCTOR, METHOD) {
	  var Constructor = globalThis[CONSTRUCTOR];
	  var Prototype = Constructor && Constructor.prototype;
	  return Prototype && Prototype[METHOD];
	};


/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	'use strict';
	// `GetIteratorDirect(obj)` abstract operation
	// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
	module.exports = function (obj) {
	  return {
	    iterator: obj,
	    next: obj.next,
	    done: false
	  };
	};


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var isArray = __webpack_require__(131);
	var isCallable = __webpack_require__(28);
	var classof = __webpack_require__(53);
	var toString = __webpack_require__(18);
	
	var push = uncurryThis([].push);
	
	module.exports = function (replacer) {
	  if (isCallable(replacer)) return replacer;
	  if (!isArray(replacer)) return;
	  var rawLength = replacer.length;
	  var keys = [];
	  for (var i = 0; i < rawLength; i++) {
	    var element = replacer[i];
	    if (typeof element == 'string') push(keys, element);
	    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
	  }
	  var keysLength = keys.length;
	  var root = true;
	  return function (key, value) {
	    if (root) {
	      root = false;
	      return value;
	    }
	    if (isArray(this)) return value;
	    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
	  };
	};


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (a, b) {
	  try {
	    // eslint-disable-next-line no-console -- safe
	    arguments.length === 1 ? console.error(a) : console.error(a, b);
	  } catch (error) { /* empty */ }
	};


/***/ }),
/* 1233 */
/***/ (function(module, exports) {

	'use strict';
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var $Array = Array;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	
	var pack = function (number, mantissaLength, bytes) {
	  var buffer = $Array(bytes);
	  var exponentLength = bytes * 8 - mantissaLength - 1;
	  var eMax = (1 << exponentLength) - 1;
	  var eBias = eMax >> 1;
	  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
	  var index = 0;
	  var exponent, mantissa, c;
	  number = abs(number);
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (number !== number || number === Infinity) {
	    // eslint-disable-next-line no-self-compare -- NaN check
	    mantissa = number !== number ? 1 : 0;
	    exponent = eMax;
	  } else {
	    exponent = floor(log(number) / LN2);
	    c = pow(2, -exponent);
	    if (number * c < 1) {
	      exponent--;
	      c *= 2;
	    }
	    if (exponent + eBias >= 1) {
	      number += rt / c;
	    } else {
	      number += rt * pow(2, 1 - eBias);
	    }
	    if (number * c >= 2) {
	      exponent++;
	      c /= 2;
	    }
	    if (exponent + eBias >= eMax) {
	      mantissa = 0;
	      exponent = eMax;
	    } else if (exponent + eBias >= 1) {
	      mantissa = (number * c - 1) * pow(2, mantissaLength);
	      exponent += eBias;
	    } else {
	      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
	      exponent = 0;
	    }
	  }
	  while (mantissaLength >= 8) {
	    buffer[index++] = mantissa & 255;
	    mantissa /= 256;
	    mantissaLength -= 8;
	  }
	  exponent = exponent << mantissaLength | mantissa;
	  exponentLength += mantissaLength;
	  while (exponentLength > 0) {
	    buffer[index++] = exponent & 255;
	    exponent /= 256;
	    exponentLength -= 8;
	  }
	  buffer[index - 1] |= sign * 128;
	  return buffer;
	};
	
	var unpack = function (buffer, mantissaLength) {
	  var bytes = buffer.length;
	  var exponentLength = bytes * 8 - mantissaLength - 1;
	  var eMax = (1 << exponentLength) - 1;
	  var eBias = eMax >> 1;
	  var nBits = exponentLength - 7;
	  var index = bytes - 1;
	  var sign = buffer[index--];
	  var exponent = sign & 127;
	  var mantissa;
	  sign >>= 7;
	  while (nBits > 0) {
	    exponent = exponent * 256 + buffer[index--];
	    nBits -= 8;
	  }
	  mantissa = exponent & (1 << -nBits) - 1;
	  exponent >>= -nBits;
	  nBits += mantissaLength;
	  while (nBits > 0) {
	    mantissa = mantissa * 256 + buffer[index--];
	    nBits -= 8;
	  }
	  if (exponent === 0) {
	    exponent = 1 - eBias;
	  } else if (exponent === eMax) {
	    return mantissa ? NaN : sign ? -Infinity : Infinity;
	  } else {
	    mantissa += pow(2, mantissaLength);
	    exponent -= eBias;
	  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
	};
	
	module.exports = {
	  pack: pack,
	  unpack: unpack
	};


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var sign = __webpack_require__(411);
	
	var abs = Math.abs;
	
	var EPSILON = 2.220446049250313e-16; // Number.EPSILON
	var INVERSE_EPSILON = 1 / EPSILON;
	
	var roundTiesToEven = function (n) {
	  return n + INVERSE_EPSILON - INVERSE_EPSILON;
	};
	
	module.exports = function (x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
	  var n = +x;
	  var absolute = abs(n);
	  var s = sign(n);
	  if (absolute < FLOAT_MIN_VALUE) return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
	  var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
	  var result = a - (a - absolute);
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
	  return s * result;
	};


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	
	var globalIsFinite = globalThis.isFinite;
	
	// `Number.isFinite` method
	// https://tc39.es/ecma262/#sec-number.isfinite
	// eslint-disable-next-line es/no-number-isfinite -- safe
	module.exports = Number.isFinite || function isFinite(it) {
	  return typeof it == 'number' && globalIsFinite(it);
	};


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(429);
	var classof = __webpack_require__(98);
	
	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(146);
	var SetHelpers = __webpack_require__(92);
	var clone = __webpack_require__(422);
	var size = __webpack_require__(241);
	var getSetRecord = __webpack_require__(147);
	var iterateSet = __webpack_require__(188);
	var iterateSimple = __webpack_require__(151);
	
	var has = SetHelpers.has;
	var remove = SetHelpers.remove;
	
	// `Set.prototype.difference` method
	// https://github.com/tc39/proposal-set-methods
	module.exports = function difference(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  var result = clone(O);
	  if (size(O) <= otherRec.size) iterateSet(O, function (e) {
	    if (otherRec.includes(e)) remove(result, e);
	  });
	  else iterateSimple(otherRec.getIterator(), function (e) {
	    if (has(O, e)) remove(result, e);
	  });
	  return result;
	};


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(146);
	var SetHelpers = __webpack_require__(92);
	var size = __webpack_require__(241);
	var getSetRecord = __webpack_require__(147);
	var iterateSet = __webpack_require__(188);
	var iterateSimple = __webpack_require__(151);
	
	var Set = SetHelpers.Set;
	var add = SetHelpers.add;
	var has = SetHelpers.has;
	
	// `Set.prototype.intersection` method
	// https://github.com/tc39/proposal-set-methods
	module.exports = function intersection(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  var result = new Set();
	
	  if (size(O) > otherRec.size) {
	    iterateSimple(otherRec.getIterator(), function (e) {
	      if (has(O, e)) add(result, e);
	    });
	  } else {
	    iterateSet(O, function (e) {
	      if (otherRec.includes(e)) add(result, e);
	    });
	  }
	
	  return result;
	};


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(146);
	var has = __webpack_require__(92).has;
	var size = __webpack_require__(241);
	var getSetRecord = __webpack_require__(147);
	var iterateSet = __webpack_require__(188);
	var iterateSimple = __webpack_require__(151);
	var iteratorClose = __webpack_require__(286);
	
	// `Set.prototype.isDisjointFrom` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
	module.exports = function isDisjointFrom(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (size(O) <= otherRec.size) return iterateSet(O, function (e) {
	    if (otherRec.includes(e)) return false;
	  }, true) !== false;
	  var iterator = otherRec.getIterator();
	  return iterateSimple(iterator, function (e) {
	    if (has(O, e)) return iteratorClose(iterator, 'normal', false);
	  }) !== false;
	};


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(146);
	var size = __webpack_require__(241);
	var iterate = __webpack_require__(188);
	var getSetRecord = __webpack_require__(147);
	
	// `Set.prototype.isSubsetOf` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
	module.exports = function isSubsetOf(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (size(O) > otherRec.size) return false;
	  return iterate(O, function (e) {
	    if (!otherRec.includes(e)) return false;
	  }, true) !== false;
	};


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(146);
	var has = __webpack_require__(92).has;
	var size = __webpack_require__(241);
	var getSetRecord = __webpack_require__(147);
	var iterateSimple = __webpack_require__(151);
	var iteratorClose = __webpack_require__(286);
	
	// `Set.prototype.isSupersetOf` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
	module.exports = function isSupersetOf(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (size(O) < otherRec.size) return false;
	  var iterator = otherRec.getIterator();
	  return iterateSimple(iterator, function (e) {
	    if (!has(O, e)) return iteratorClose(iterator, 'normal', false);
	  }) !== false;
	};


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(146);
	var SetHelpers = __webpack_require__(92);
	var clone = __webpack_require__(422);
	var getSetRecord = __webpack_require__(147);
	var iterateSimple = __webpack_require__(151);
	
	var add = SetHelpers.add;
	var has = SetHelpers.has;
	var remove = SetHelpers.remove;
	
	// `Set.prototype.symmetricDifference` method
	// https://github.com/tc39/proposal-set-methods
	module.exports = function symmetricDifference(other) {
	  var O = aSet(this);
	  var keysIter = getSetRecord(other).getIterator();
	  var result = clone(O);
	  iterateSimple(keysIter, function (e) {
	    if (has(O, e)) remove(result, e);
	    else add(result, e);
	  });
	  return result;
	};


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(146);
	var add = __webpack_require__(92).add;
	var clone = __webpack_require__(422);
	var getSetRecord = __webpack_require__(147);
	var iterateSimple = __webpack_require__(151);
	
	// `Set.prototype.union` method
	// https://github.com/tc39/proposal-set-methods
	module.exports = function union(other) {
	  var O = aSet(this);
	  var keysIter = getSetRecord(other).getIterator();
	  var result = clone(O);
	  iterateSimple(keysIter, function (it) {
	    add(result, it);
	  });
	  return result;
	};


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
	var uncurryThis = __webpack_require__(8);
	
	var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
	var base = 36;
	var tMin = 1;
	var tMax = 26;
	var skew = 38;
	var damp = 700;
	var initialBias = 72;
	var initialN = 128; // 0x80
	var delimiter = '-'; // '\x2D'
	var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
	var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
	var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
	var baseMinusTMin = base - tMin;
	
	var $RangeError = RangeError;
	var exec = uncurryThis(regexSeparators.exec);
	var floor = Math.floor;
	var fromCharCode = String.fromCharCode;
	var charCodeAt = uncurryThis(''.charCodeAt);
	var join = uncurryThis([].join);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var split = uncurryThis(''.split);
	var toLowerCase = uncurryThis(''.toLowerCase);
	
	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 */
	var ucs2decode = function (string) {
	  var output = [];
	  var counter = 0;
	  var length = string.length;
	  while (counter < length) {
	    var value = charCodeAt(string, counter++);
	    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
	      // It's a high surrogate, and there is a next character.
	      var extra = charCodeAt(string, counter++);
	      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
	        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	      } else {
	        // It's an unmatched surrogate; only append this code unit, in case the
	        // next code unit is the high surrogate of a surrogate pair.
	        push(output, value);
	        counter--;
	      }
	    } else {
	      push(output, value);
	    }
	  }
	  return output;
	};
	
	/**
	 * Converts a digit/integer into a basic code point.
	 */
	var digitToBasic = function (digit) {
	  //  0..25 map to ASCII a..z or A..Z
	  // 26..35 map to ASCII 0..9
	  return digit + 22 + 75 * (digit < 26);
	};
	
	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 */
	var adapt = function (delta, numPoints, firstTime) {
	  var k = 0;
	  delta = firstTime ? floor(delta / damp) : delta >> 1;
	  delta += floor(delta / numPoints);
	  while (delta > baseMinusTMin * tMax >> 1) {
	    delta = floor(delta / baseMinusTMin);
	    k += base;
	  }
	  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	};
	
	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 */
	var encode = function (input) {
	  var output = [];
	
	  // Convert the input in UCS-2 to an array of Unicode code points.
	  input = ucs2decode(input);
	
	  // Cache the length.
	  var inputLength = input.length;
	
	  // Initialize the state.
	  var n = initialN;
	  var delta = 0;
	  var bias = initialBias;
	  var i, currentValue;
	
	  // Handle the basic code points.
	  for (i = 0; i < input.length; i++) {
	    currentValue = input[i];
	    if (currentValue < 0x80) {
	      push(output, fromCharCode(currentValue));
	    }
	  }
	
	  var basicLength = output.length; // number of basic code points.
	  var handledCPCount = basicLength; // number of code points that have been handled;
	
	  // Finish the basic string with a delimiter unless it's empty.
	  if (basicLength) {
	    push(output, delimiter);
	  }
	
	  // Main encoding loop:
	  while (handledCPCount < inputLength) {
	    // All non-basic code points < n have been handled already. Find the next larger one:
	    var m = maxInt;
	    for (i = 0; i < input.length; i++) {
	      currentValue = input[i];
	      if (currentValue >= n && currentValue < m) {
	        m = currentValue;
	      }
	    }
	
	    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
	    var handledCPCountPlusOne = handledCPCount + 1;
	    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
	      throw new $RangeError(OVERFLOW_ERROR);
	    }
	
	    delta += (m - n) * handledCPCountPlusOne;
	    n = m;
	
	    for (i = 0; i < input.length; i++) {
	      currentValue = input[i];
	      if (currentValue < n && ++delta > maxInt) {
	        throw new $RangeError(OVERFLOW_ERROR);
	      }
	      if (currentValue === n) {
	        // Represent delta as a generalized variable-length integer.
	        var q = delta;
	        var k = base;
	        while (true) {
	          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
	          if (q < t) break;
	          var qMinusT = q - t;
	          var baseMinusT = base - t;
	          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
	          q = floor(qMinusT / baseMinusT);
	          k += base;
	        }
	
	        push(output, fromCharCode(digitToBasic(q)));
	        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
	        delta = 0;
	        handledCPCount++;
	      }
	    }
	
	    delta++;
	    n++;
	  }
	  return join(output, '');
	};
	
	module.exports = function (input) {
	  var encoded = [];
	  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
	  var i, label;
	  for (i = 0; i < labels.length; i++) {
	    label = labels[i];
	    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
	  }
	  return join(encoded, '.');
	};


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(44);
	
	var $RangeError = RangeError;
	
	module.exports = function (it) {
	  var result = toIntegerOrInfinity(it);
	  if (result < 0) throw new $RangeError("The argument can't be less than 0");
	  return result;
	};


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	'use strict';
	var round = Math.round;
	
	module.exports = function (it) {
	  var value = round(it);
	  return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
	};


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var arrayFromConstructorAndList = __webpack_require__(274);
	var typedArraySpeciesConstructor = __webpack_require__(299);
	
	module.exports = function (instance, list) {
	  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
	};


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var apply = __webpack_require__(90);
	var fails = __webpack_require__(6);
	var wrapErrorConstructorWithCause = __webpack_require__(700);
	
	var AGGREGATE_ERROR = 'AggregateError';
	var $AggregateError = getBuiltIn(AGGREGATE_ERROR);
	
	var FORCED = !fails(function () {
	  return $AggregateError([1]).errors[0] !== 1;
	}) && fails(function () {
	  return $AggregateError([1], AGGREGATE_ERROR, { cause: 7 }).cause !== 7;
	});
	
	// https://tc39.es/ecma262/#sec-aggregate-error
	$({ global: true, constructor: true, arity: 2, forced: FORCED }, {
	  AggregateError: wrapErrorConstructorWithCause(AGGREGATE_ERROR, function (init) {
	    // eslint-disable-next-line no-unused-vars -- required for functions `.length`
	    return function AggregateError(errors, message) { return apply(init, this, arguments); };
	  }, FORCED, true)
	});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isPrototypeOf = __webpack_require__(74);
	var getPrototypeOf = __webpack_require__(84);
	var setPrototypeOf = __webpack_require__(100);
	var copyConstructorProperties = __webpack_require__(227);
	var create = __webpack_require__(73);
	var createNonEnumerableProperty = __webpack_require__(58);
	var createPropertyDescriptor = __webpack_require__(82);
	var installErrorCause = __webpack_require__(666);
	var installErrorStack = __webpack_require__(657);
	var iterate = __webpack_require__(83);
	var normalizeStringArgument = __webpack_require__(235);
	var wellKnownSymbol = __webpack_require__(27);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var $Error = Error;
	var push = [].push;
	
	var $AggregateError = function AggregateError(errors, message /* , options */) {
	  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
	  var that;
	  if (setPrototypeOf) {
	    that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
	  } else {
	    that = isInstance ? this : create(AggregateErrorPrototype);
	    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
	  }
	  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
	  installErrorStack(that, $AggregateError, that.stack, 1);
	  if (arguments.length > 2) installErrorCause(that, arguments[2]);
	  var errorsArray = [];
	  iterate(errors, push, { that: errorsArray });
	  createNonEnumerableProperty(that, 'errors', errorsArray);
	  return that;
	};
	
	if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
	else copyConstructorProperties($AggregateError, $Error, { name: true });
	
	var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
	  constructor: createPropertyDescriptor(1, $AggregateError),
	  message: createPropertyDescriptor(1, ''),
	  name: createPropertyDescriptor(1, 'AggregateError')
	});
	
	// `AggregateError` constructor
	// https://tc39.es/ecma262/#sec-aggregate-error-constructor
	$({ global: true, constructor: true, arity: 2 }, {
	  AggregateError: $AggregateError
	});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1249);


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var arrayBufferModule = __webpack_require__(273);
	var setSpecies = __webpack_require__(189);
	
	var ARRAY_BUFFER = 'ArrayBuffer';
	var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
	var NativeArrayBuffer = globalThis[ARRAY_BUFFER];
	
	// `ArrayBuffer` constructor
	// https://tc39.es/ecma262/#sec-arraybuffer-constructor
	$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
	  ArrayBuffer: ArrayBuffer
	});
	
	setSpecies(ARRAY_BUFFER);


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var defineBuiltInAccessor = __webpack_require__(50);
	var isDetached = __webpack_require__(639);
	
	var ArrayBufferPrototype = ArrayBuffer.prototype;
	
	if (DESCRIPTORS && !('detached' in ArrayBufferPrototype)) {
	  defineBuiltInAccessor(ArrayBufferPrototype, 'detached', {
	    configurable: true,
	    get: function detached() {
	      return isDetached(this);
	    }
	  });
	}


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var ArrayBufferViewCore = __webpack_require__(26);
	
	var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
	
	// `ArrayBuffer.isView` method
	// https://tc39.es/ecma262/#sec-arraybuffer.isview
	$({ target: 'ArrayBuffer', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
	  isView: ArrayBufferViewCore.isView
	});


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(130);
	var fails = __webpack_require__(6);
	var ArrayBufferModule = __webpack_require__(273);
	var anObject = __webpack_require__(20);
	var toAbsoluteIndex = __webpack_require__(117);
	var toLength = __webpack_require__(76);
	var speciesConstructor = __webpack_require__(191);
	
	var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
	var DataView = ArrayBufferModule.DataView;
	var DataViewPrototype = DataView.prototype;
	var nativeArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
	var getUint8 = uncurryThis(DataViewPrototype.getUint8);
	var setUint8 = uncurryThis(DataViewPrototype.setUint8);
	
	var INCORRECT_SLICE = fails(function () {
	  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
	});
	
	// `ArrayBuffer.prototype.slice` method
	// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
	$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
	  slice: function slice(start, end) {
	    if (nativeArrayBufferSlice && end === undefined) {
	      return nativeArrayBufferSlice(anObject(this), start); // FF fix
	    }
	    var length = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
	    var viewSource = new DataView(this);
	    var viewTarget = new DataView(result);
	    var index = 0;
	    while (first < fin) {
	      setUint8(viewTarget, index++, getUint8(viewSource, first++));
	    } return result;
	  }
	});


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $transfer = __webpack_require__(640);
	
	// `ArrayBuffer.prototype.transferToFixedLength` method
	// https://tc39.es/proposal-arraybuffer-transfer/#sec-arraybuffer.prototype.transfertofixedlength
	if ($transfer) $({ target: 'ArrayBuffer', proto: true }, {
	  transferToFixedLength: function transferToFixedLength() {
	    return $transfer(this, arguments.length ? arguments[0] : undefined, false);
	  }
	});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $transfer = __webpack_require__(640);
	
	// `ArrayBuffer.prototype.transfer` method
	// https://tc39.es/proposal-arraybuffer-transfer/#sec-arraybuffer.prototype.transfer
	if ($transfer) $({ target: 'ArrayBuffer', proto: true }, {
	  transfer: function transfer() {
	    return $transfer(this, arguments.length ? arguments[0] : undefined, true);
	  }
	});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var toIntegerOrInfinity = __webpack_require__(44);
	var addToUnscopables = __webpack_require__(63);
	
	// `Array.prototype.at` method
	// https://tc39.es/ecma262/#sec-array.prototype.at
	$({ target: 'Array', proto: true }, {
	  at: function at(index) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var relativeIndex = toIntegerOrInfinity(index);
	    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
	    return (k < 0 || k >= len) ? undefined : O[k];
	  }
	});
	
	addToUnscopables('at');


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var isArray = __webpack_require__(131);
	var isObject = __webpack_require__(25);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var doesNotExceedSafeInteger = __webpack_require__(181);
	var createProperty = __webpack_require__(129);
	var arraySpeciesCreate = __webpack_require__(226);
	var arrayMethodHasSpeciesSupport = __webpack_require__(225);
	var wellKnownSymbol = __webpack_require__(27);
	var V8_VERSION = __webpack_require__(115);
	
	var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
	
	// We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679
	var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});
	
	var isConcatSpreadable = function (O) {
	  if (!isObject(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray(O);
	};
	
	var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');
	
	// `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species
	$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;
	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];
	      if (isConcatSpreadable(E)) {
	        len = lengthOfArrayLike(E);
	        doesNotExceedSafeInteger(n + len);
	        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
	      } else {
	        doesNotExceedSafeInteger(n + 1);
	        createProperty(A, n++, E);
	      }
	    }
	    A.length = n;
	    return A;
	  }
	});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var copyWithin = __webpack_require__(641);
	var addToUnscopables = __webpack_require__(63);
	
	// `Array.prototype.copyWithin` method
	// https://tc39.es/ecma262/#sec-array.prototype.copywithin
	$({ target: 'Array', proto: true }, {
	  copyWithin: copyWithin
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('copyWithin');


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $every = __webpack_require__(52).every;
	var arrayMethodIsStrict = __webpack_require__(114);
	
	var STRICT_METHOD = arrayMethodIsStrict('every');
	
	// `Array.prototype.every` method
	// https://tc39.es/ecma262/#sec-array.prototype.every
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fill = __webpack_require__(396);
	var addToUnscopables = __webpack_require__(63);
	
	// `Array.prototype.fill` method
	// https://tc39.es/ecma262/#sec-array.prototype.fill
	$({ target: 'Array', proto: true }, {
	  fill: fill
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('fill');


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $filter = __webpack_require__(52).filter;
	var arrayMethodHasSpeciesSupport = __webpack_require__(225);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
	
	// `Array.prototype.filter` method
	// https://tc39.es/ecma262/#sec-array.prototype.filter
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $findIndex = __webpack_require__(52).findIndex;
	var addToUnscopables = __webpack_require__(63);
	
	var FIND_INDEX = 'findIndex';
	var SKIPS_HOLES = true;
	
	// Shouldn't skip holes
	// eslint-disable-next-line es/no-array-prototype-findindex -- testing
	if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });
	
	// `Array.prototype.findIndex` method
	// https://tc39.es/ecma262/#sec-array.prototype.findindex
	$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND_INDEX);


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $findLastIndex = __webpack_require__(275).findLastIndex;
	var addToUnscopables = __webpack_require__(63);
	
	// `Array.prototype.findLastIndex` method
	// https://tc39.es/ecma262/#sec-array.prototype.findlastindex
	$({ target: 'Array', proto: true }, {
	  findLastIndex: function findLastIndex(callbackfn /* , that = undefined */) {
	    return $findLastIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	addToUnscopables('findLastIndex');


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $findLast = __webpack_require__(275).findLast;
	var addToUnscopables = __webpack_require__(63);
	
	// `Array.prototype.findLast` method
	// https://tc39.es/ecma262/#sec-array.prototype.findlast
	$({ target: 'Array', proto: true }, {
	  findLast: function findLast(callbackfn /* , that = undefined */) {
	    return $findLast(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	addToUnscopables('findLast');


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $find = __webpack_require__(52).find;
	var addToUnscopables = __webpack_require__(63);
	
	var FIND = 'find';
	var SKIPS_HOLES = true;
	
	// Shouldn't skip holes
	// eslint-disable-next-line es/no-array-prototype-find -- testing
	if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });
	
	// `Array.prototype.find` method
	// https://tc39.es/ecma262/#sec-array.prototype.find
	$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND);


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(660);
	var aCallable = __webpack_require__(39);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var arraySpeciesCreate = __webpack_require__(226);
	
	// `Array.prototype.flatMap` method
	// https://tc39.es/ecma262/#sec-array.prototype.flatmap
	$({ target: 'Array', proto: true }, {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen = lengthOfArrayLike(O);
	    var A;
	    aCallable(callbackfn);
	    A = arraySpeciesCreate(O, 0);
	    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    return A;
	  }
	});


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(660);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var toIntegerOrInfinity = __webpack_require__(44);
	var arraySpeciesCreate = __webpack_require__(226);
	
	// `Array.prototype.flat` method
	// https://tc39.es/ecma262/#sec-array.prototype.flat
	$({ target: 'Array', proto: true }, {
	  flat: function flat(/* depthArg = 1 */) {
	    var depthArg = arguments.length ? arguments[0] : undefined;
	    var O = toObject(this);
	    var sourceLen = lengthOfArrayLike(O);
	    var A = arraySpeciesCreate(O, 0);
	    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
	    return A;
	  }
	});


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var forEach = __webpack_require__(642);
	
	// `Array.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe
	$({ target: 'Array', proto: true, forced: [].forEach !== forEach }, {
	  forEach: forEach
	});


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var from = __webpack_require__(643);
	var checkCorrectnessOfIteration = __webpack_require__(277);
	
	var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
	  // eslint-disable-next-line es/no-array-from -- required for testing
	  Array.from(iterable);
	});
	
	// `Array.from` method
	// https://tc39.es/ecma262/#sec-array.from
	$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
	  from: from
	});


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $includes = __webpack_require__(224).includes;
	var fails = __webpack_require__(6);
	var addToUnscopables = __webpack_require__(63);
	
	// FF99+ bug
	var BROKEN_ON_SPARSE = fails(function () {
	  // eslint-disable-next-line es/no-array-prototype-includes -- detection
	  return !Array(1).includes();
	});
	
	// `Array.prototype.includes` method
	// https://tc39.es/ecma262/#sec-array.prototype.includes
	$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('includes');


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-array-prototype-indexof -- required for testing */
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(130);
	var $indexOf = __webpack_require__(224).indexOf;
	var arrayMethodIsStrict = __webpack_require__(114);
	
	var nativeIndexOf = uncurryThis([].indexOf);
	
	var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
	var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');
	
	// `Array.prototype.indexOf` method
	// https://tc39.es/ecma262/#sec-array.prototype.indexof
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? nativeIndexOf(this, searchElement, fromIndex) || 0
	      : $indexOf(this, searchElement, fromIndex);
	  }
	});


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isArray = __webpack_require__(131);
	
	// `Array.isArray` method
	// https://tc39.es/ecma262/#sec-array.isarray
	$({ target: 'Array', stat: true }, {
	  isArray: isArray
	});


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var IndexedObject = __webpack_require__(185);
	var toIndexedObject = __webpack_require__(51);
	var arrayMethodIsStrict = __webpack_require__(114);
	
	var nativeJoin = uncurryThis([].join);
	
	var ES3_STRINGS = IndexedObject !== Object;
	var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');
	
	// `Array.prototype.join` method
	// https://tc39.es/ecma262/#sec-array.prototype.join
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  join: function join(separator) {
	    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var lastIndexOf = __webpack_require__(644);
	
	// `Array.prototype.lastIndexOf` method
	// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
	// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
	$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
	  lastIndexOf: lastIndexOf
	});


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $map = __webpack_require__(52).map;
	var arrayMethodHasSpeciesSupport = __webpack_require__(225);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
	
	// `Array.prototype.map` method
	// https://tc39.es/ecma262/#sec-array.prototype.map
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var isConstructor = __webpack_require__(186);
	var createProperty = __webpack_require__(129);
	
	var $Array = Array;
	
	var ISNT_GENERIC = fails(function () {
	  function F() { /* empty */ }
	  // eslint-disable-next-line es/no-array-of -- safe
	  return !($Array.of.call(F) instanceof F);
	});
	
	// `Array.of` method
	// https://tc39.es/ecma262/#sec-array.of
	// WebKit Array.of isn't generic
	$({ target: 'Array', stat: true, forced: ISNT_GENERIC }, {
	  of: function of(/* ...args */) {
	    var index = 0;
	    var argumentsLength = arguments.length;
	    var result = new (isConstructor(this) ? this : $Array)(argumentsLength);
	    while (argumentsLength > index) createProperty(result, index, arguments[index++]);
	    result.length = argumentsLength;
	    return result;
	  }
	});


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var setArrayLength = __webpack_require__(397);
	var doesNotExceedSafeInteger = __webpack_require__(181);
	var fails = __webpack_require__(6);
	
	var INCORRECT_TO_LENGTH = fails(function () {
	  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
	});
	
	// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
	// https://bugs.chromium.org/p/v8/issues/detail?id=12681
	var properErrorOnNonWritableLength = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', { writable: false }).push();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};
	
	var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();
	
	// `Array.prototype.push` method
	// https://tc39.es/ecma262/#sec-array.prototype.push
	$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  push: function push(item) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var argCount = arguments.length;
	    doesNotExceedSafeInteger(len + argCount);
	    for (var i = 0; i < argCount; i++) {
	      O[len] = arguments[i];
	      len++;
	    }
	    setArrayLength(O, len);
	    return len;
	  }
	});


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $reduceRight = __webpack_require__(276).right;
	var arrayMethodIsStrict = __webpack_require__(114);
	var CHROME_VERSION = __webpack_require__(115);
	var IS_NODE = __webpack_require__(182);
	
	// Chrome 80-82 has a critical bug
	// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
	var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
	var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduceRight');
	
	// `Array.prototype.reduceRight` method
	// https://tc39.es/ecma262/#sec-array.prototype.reduceright
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $reduce = __webpack_require__(276).left;
	var arrayMethodIsStrict = __webpack_require__(114);
	var CHROME_VERSION = __webpack_require__(115);
	var IS_NODE = __webpack_require__(182);
	
	// Chrome 80-82 has a critical bug
	// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
	var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
	var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');
	
	// `Array.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-array.prototype.reduce
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    var length = arguments.length;
	    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var isArray = __webpack_require__(131);
	
	var nativeReverse = uncurryThis([].reverse);
	var test = [1, 2];
	
	// `Array.prototype.reverse` method
	// https://tc39.es/ecma262/#sec-array.prototype.reverse
	// fix for Safari 12.0 bug
	// https://bugs.webkit.org/show_bug.cgi?id=188794
	$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
	  reverse: function reverse() {
	    // eslint-disable-next-line no-self-assign -- dirty hack
	    if (isArray(this)) this.length = this.length;
	    return nativeReverse(this);
	  }
	});


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isArray = __webpack_require__(131);
	var isConstructor = __webpack_require__(186);
	var isObject = __webpack_require__(25);
	var toAbsoluteIndex = __webpack_require__(117);
	var lengthOfArrayLike = __webpack_require__(34);
	var toIndexedObject = __webpack_require__(51);
	var createProperty = __webpack_require__(129);
	var wellKnownSymbol = __webpack_require__(27);
	var arrayMethodHasSpeciesSupport = __webpack_require__(225);
	var nativeSlice = __webpack_require__(89);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
	
	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;
	var max = Math.max;
	
	// `Array.prototype.slice` method
	// https://tc39.es/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject(this);
	    var length = lengthOfArrayLike(O);
	    var k = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
	    var Constructor, result, n;
	    if (isArray(O)) {
	      Constructor = O.constructor;
	      // cross-realm fallback
	      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject(Constructor)) {
	        Constructor = Constructor[SPECIES];
	        if (Constructor === null) Constructor = undefined;
	      }
	      if (Constructor === $Array || Constructor === undefined) {
	        return nativeSlice(O, k, fin);
	      }
	    }
	    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
	    result.length = n;
	    return result;
	  }
	});


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $some = __webpack_require__(52).some;
	var arrayMethodIsStrict = __webpack_require__(114);
	
	var STRICT_METHOD = arrayMethodIsStrict('some');
	
	// `Array.prototype.some` method
	// https://tc39.es/ecma262/#sec-array.prototype.some
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(39);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var deletePropertyOrThrow = __webpack_require__(279);
	var toString = __webpack_require__(18);
	var fails = __webpack_require__(6);
	var internalSort = __webpack_require__(398);
	var arrayMethodIsStrict = __webpack_require__(114);
	var FF = __webpack_require__(654);
	var IE_OR_EDGE = __webpack_require__(655);
	var V8 = __webpack_require__(115);
	var WEBKIT = __webpack_require__(403);
	
	var test = [];
	var nativeSort = uncurryThis(test.sort);
	var push = uncurryThis(test.push);
	
	// IE8-
	var FAILS_ON_UNDEFINED = fails(function () {
	  test.sort(undefined);
	});
	// V8 bug
	var FAILS_ON_NULL = fails(function () {
	  test.sort(null);
	});
	// Old WebKit
	var STRICT_METHOD = arrayMethodIsStrict('sort');
	
	var STABLE_SORT = !fails(function () {
	  // feature detection can be too slow, so check engines versions
	  if (V8) return V8 < 70;
	  if (FF && FF > 3) return;
	  if (IE_OR_EDGE) return true;
	  if (WEBKIT) return WEBKIT < 603;
	
	  var result = '';
	  var code, chr, value, index;
	
	  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
	  for (code = 65; code < 76; code++) {
	    chr = String.fromCharCode(code);
	
	    switch (code) {
	      case 66: case 69: case 70: case 72: value = 3; break;
	      case 68: case 71: value = 4; break;
	      default: value = 2;
	    }
	
	    for (index = 0; index < 47; index++) {
	      test.push({ k: chr + index, v: value });
	    }
	  }
	
	  test.sort(function (a, b) { return b.v - a.v; });
	
	  for (index = 0; index < test.length; index++) {
	    chr = test[index].k.charAt(0);
	    if (result.charAt(result.length - 1) !== chr) result += chr;
	  }
	
	  return result !== 'DGBEFHACIJK';
	});
	
	var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
	
	var getSortCompare = function (comparefn) {
	  return function (x, y) {
	    if (y === undefined) return -1;
	    if (x === undefined) return 1;
	    if (comparefn !== undefined) return +comparefn(x, y) || 0;
	    return toString(x) > toString(y) ? 1 : -1;
	  };
	};
	
	// `Array.prototype.sort` method
	// https://tc39.es/ecma262/#sec-array.prototype.sort
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  sort: function sort(comparefn) {
	    if (comparefn !== undefined) aCallable(comparefn);
	
	    var array = toObject(this);
	
	    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
	
	    var items = [];
	    var arrayLength = lengthOfArrayLike(array);
	    var itemsLength, index;
	
	    for (index = 0; index < arrayLength; index++) {
	      if (index in array) push(items, array[index]);
	    }
	
	    internalSort(items, getSortCompare(comparefn));
	
	    itemsLength = lengthOfArrayLike(items);
	    index = 0;
	
	    while (index < itemsLength) array[index] = items[index++];
	    while (index < arrayLength) deletePropertyOrThrow(array, index++);
	
	    return array;
	  }
	});


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var setSpecies = __webpack_require__(189);
	
	// `Array[@@species]` getter
	// https://tc39.es/ecma262/#sec-get-array-@@species
	setSpecies('Array');


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var toObject = __webpack_require__(31);
	var toAbsoluteIndex = __webpack_require__(117);
	var toIntegerOrInfinity = __webpack_require__(44);
	var lengthOfArrayLike = __webpack_require__(34);
	var setArrayLength = __webpack_require__(397);
	var doesNotExceedSafeInteger = __webpack_require__(181);
	var arraySpeciesCreate = __webpack_require__(226);
	var createProperty = __webpack_require__(129);
	var deletePropertyOrThrow = __webpack_require__(279);
	var arrayMethodHasSpeciesSupport = __webpack_require__(225);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
	
	var max = Math.max;
	var min = Math.min;
	
	// `Array.prototype.splice` method
	// https://tc39.es/ecma262/#sec-array.prototype.splice
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  splice: function splice(start, deleteCount /* , ...items */) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var actualStart = toAbsoluteIndex(start, len);
	    var argumentsLength = arguments.length;
	    var insertCount, actualDeleteCount, A, k, from, to;
	    if (argumentsLength === 0) {
	      insertCount = actualDeleteCount = 0;
	    } else if (argumentsLength === 1) {
	      insertCount = 0;
	      actualDeleteCount = len - actualStart;
	    } else {
	      insertCount = argumentsLength - 2;
	      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
	    }
	    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
	    A = arraySpeciesCreate(O, actualDeleteCount);
	    for (k = 0; k < actualDeleteCount; k++) {
	      from = actualStart + k;
	      if (from in O) createProperty(A, k, O[from]);
	    }
	    A.length = actualDeleteCount;
	    if (insertCount < actualDeleteCount) {
	      for (k = actualStart; k < len - actualDeleteCount; k++) {
	        from = k + actualDeleteCount;
	        to = k + insertCount;
	        if (from in O) O[to] = O[from];
	        else deletePropertyOrThrow(O, to);
	      }
	      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
	    } else if (insertCount > actualDeleteCount) {
	      for (k = len - actualDeleteCount; k > actualStart; k--) {
	        from = k + actualDeleteCount - 1;
	        to = k + insertCount - 1;
	        if (from in O) O[to] = O[from];
	        else deletePropertyOrThrow(O, to);
	      }
	    }
	    for (k = 0; k < insertCount; k++) {
	      O[k + actualStart] = arguments[k + 2];
	    }
	    setArrayLength(O, len - actualDeleteCount + insertCount);
	    return A;
	  }
	});


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var arrayToReversed = __webpack_require__(645);
	var toIndexedObject = __webpack_require__(51);
	var addToUnscopables = __webpack_require__(63);
	
	var $Array = Array;
	
	// `Array.prototype.toReversed` method
	// https://tc39.es/ecma262/#sec-array.prototype.toreversed
	$({ target: 'Array', proto: true }, {
	  toReversed: function toReversed() {
	    return arrayToReversed(toIndexedObject(this), $Array);
	  }
	});
	
	addToUnscopables('toReversed');


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(39);
	var toIndexedObject = __webpack_require__(51);
	var arrayFromConstructorAndList = __webpack_require__(274);
	var getBuiltInPrototypeMethod = __webpack_require__(1229);
	var addToUnscopables = __webpack_require__(63);
	
	var $Array = Array;
	var sort = uncurryThis(getBuiltInPrototypeMethod('Array', 'sort'));
	
	// `Array.prototype.toSorted` method
	// https://tc39.es/ecma262/#sec-array.prototype.tosorted
	$({ target: 'Array', proto: true }, {
	  toSorted: function toSorted(compareFn) {
	    if (compareFn !== undefined) aCallable(compareFn);
	    var O = toIndexedObject(this);
	    var A = arrayFromConstructorAndList($Array, O);
	    return sort(A, compareFn);
	  }
	});
	
	addToUnscopables('toSorted');


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var addToUnscopables = __webpack_require__(63);
	var doesNotExceedSafeInteger = __webpack_require__(181);
	var lengthOfArrayLike = __webpack_require__(34);
	var toAbsoluteIndex = __webpack_require__(117);
	var toIndexedObject = __webpack_require__(51);
	var toIntegerOrInfinity = __webpack_require__(44);
	
	var $Array = Array;
	var max = Math.max;
	var min = Math.min;
	
	// `Array.prototype.toSpliced` method
	// https://tc39.es/ecma262/#sec-array.prototype.tospliced
	$({ target: 'Array', proto: true }, {
	  toSpliced: function toSpliced(start, deleteCount /* , ...items */) {
	    var O = toIndexedObject(this);
	    var len = lengthOfArrayLike(O);
	    var actualStart = toAbsoluteIndex(start, len);
	    var argumentsLength = arguments.length;
	    var k = 0;
	    var insertCount, actualDeleteCount, newLen, A;
	    if (argumentsLength === 0) {
	      insertCount = actualDeleteCount = 0;
	    } else if (argumentsLength === 1) {
	      insertCount = 0;
	      actualDeleteCount = len - actualStart;
	    } else {
	      insertCount = argumentsLength - 2;
	      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
	    }
	    newLen = doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
	    A = $Array(newLen);
	
	    for (; k < actualStart; k++) A[k] = O[k];
	    for (; k < actualStart + insertCount; k++) A[k] = arguments[k - actualStart + 2];
	    for (; k < newLen; k++) A[k] = O[k + actualDeleteCount - insertCount];
	
	    return A;
	  }
	});
	
	addToUnscopables('toSpliced');


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// this method was added to unscopables after implementation
	// in popular engines, so it's moved to a separate module
	var addToUnscopables = __webpack_require__(63);
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('flatMap');


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// this method was added to unscopables after implementation
	// in popular engines, so it's moved to a separate module
	var addToUnscopables = __webpack_require__(63);
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('flat');


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var toObject = __webpack_require__(31);
	var lengthOfArrayLike = __webpack_require__(34);
	var setArrayLength = __webpack_require__(397);
	var deletePropertyOrThrow = __webpack_require__(279);
	var doesNotExceedSafeInteger = __webpack_require__(181);
	
	// IE8-
	var INCORRECT_RESULT = [].unshift(0) !== 1;
	
	// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
	var properErrorOnNonWritableLength = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', { writable: false }).unshift();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};
	
	var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();
	
	// `Array.prototype.unshift` method
	// https://tc39.es/ecma262/#sec-array.prototype.unshift
	$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  unshift: function unshift(item) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var argCount = arguments.length;
	    if (argCount) {
	      doesNotExceedSafeInteger(len + argCount);
	      var k = len;
	      while (k--) {
	        var to = k + argCount;
	        if (k in O) O[to] = O[k];
	        else deletePropertyOrThrow(O, to);
	      }
	      for (var j = 0; j < argCount; j++) {
	        O[j] = arguments[j];
	      }
	    } return setArrayLength(O, len + argCount);
	  }
	});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var arrayWith = __webpack_require__(646);
	var toIndexedObject = __webpack_require__(51);
	
	var $Array = Array;
	
	// `Array.prototype.with` method
	// https://tc39.es/ecma262/#sec-array.prototype.with
	$({ target: 'Array', proto: true }, {
	  'with': function (index, value) {
	    return arrayWith(toIndexedObject(this), $Array, index, value);
	  }
	});


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var ArrayBufferModule = __webpack_require__(273);
	var NATIVE_ARRAY_BUFFER = __webpack_require__(394);
	
	// `DataView` constructor
	// https://tc39.es/ecma262/#sec-dataview-constructor
	$({ global: true, constructor: true, forced: !NATIVE_ARRAY_BUFFER }, {
	  DataView: ArrayBufferModule.DataView
	});


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1294);


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	
	// IE8- non-standard case
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-date-prototype-getyear-setyear -- detection
	  return new Date(16e11).getYear() !== 120;
	});
	
	var getFullYear = uncurryThis(Date.prototype.getFullYear);
	
	// `Date.prototype.getYear` method
	// https://tc39.es/ecma262/#sec-date.prototype.getyear
	$({ target: 'Date', proto: true, forced: FORCED }, {
	  getYear: function getYear() {
	    return getFullYear(this) - 1900;
	  }
	});


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	
	var $Date = Date;
	var thisTimeValue = uncurryThis($Date.prototype.getTime);
	
	// `Date.now` method
	// https://tc39.es/ecma262/#sec-date.now
	$({ target: 'Date', stat: true }, {
	  now: function now() {
	    return thisTimeValue(new $Date());
	  }
	});


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var toIntegerOrInfinity = __webpack_require__(44);
	
	var DatePrototype = Date.prototype;
	var thisTimeValue = uncurryThis(DatePrototype.getTime);
	var setFullYear = uncurryThis(DatePrototype.setFullYear);
	
	// `Date.prototype.setYear` method
	// https://tc39.es/ecma262/#sec-date.prototype.setyear
	$({ target: 'Date', proto: true }, {
	  setYear: function setYear(year) {
	    // validate
	    thisTimeValue(this);
	    var yi = toIntegerOrInfinity(year);
	    var yyyy = yi >= 0 && yi <= 99 ? yi + 1900 : yi;
	    return setFullYear(this, yyyy);
	  }
	});


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// `Date.prototype.toGMTString` method
	// https://tc39.es/ecma262/#sec-date.prototype.togmtstring
	$({ target: 'Date', proto: true }, {
	  toGMTString: Date.prototype.toUTCString
	});


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var toISOString = __webpack_require__(1225);
	
	// `Date.prototype.toISOString` method
	// https://tc39.es/ecma262/#sec-date.prototype.toisostring
	// PhantomJS / old WebKit has a broken implementations
	$({ target: 'Date', proto: true, forced: Date.prototype.toISOString !== toISOString }, {
	  toISOString: toISOString
	});


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var toObject = __webpack_require__(31);
	var toPrimitive = __webpack_require__(298);
	
	var FORCED = fails(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	});
	
	// `Date.prototype.toJSON` method
	// https://tc39.es/ecma262/#sec-date.prototype.tojson
	$({ target: 'Date', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O, 'number');
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(29);
	var defineBuiltIn = __webpack_require__(40);
	var dateToPrimitive = __webpack_require__(1226);
	var wellKnownSymbol = __webpack_require__(27);
	
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	var DatePrototype = Date.prototype;
	
	// `Date.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
	if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
	  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
	}


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var uncurryThis = __webpack_require__(8);
	var defineBuiltIn = __webpack_require__(40);
	
	var DatePrototype = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var nativeDateToString = uncurryThis(DatePrototype[TO_STRING]);
	var thisTimeValue = uncurryThis(DatePrototype.getTime);
	
	// `Date.prototype.toString` method
	// https://tc39.es/ecma262/#sec-date.prototype.tostring
	if (String(new Date(NaN)) !== INVALID_DATE) {
	  defineBuiltIn(DatePrototype, TO_STRING, function toString() {
	    var value = thisTimeValue(this);
	    // eslint-disable-next-line no-self-compare -- NaN check
	    return value === value ? nativeDateToString(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable no-unused-vars -- required for functions `.length` */
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var apply = __webpack_require__(90);
	var wrapErrorConstructorWithCause = __webpack_require__(700);
	
	var WEB_ASSEMBLY = 'WebAssembly';
	var WebAssembly = globalThis[WEB_ASSEMBLY];
	
	// eslint-disable-next-line es/no-error-cause -- feature detection
	var FORCED = new Error('e', { cause: 7 }).cause !== 7;
	
	var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
	  var O = {};
	  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
	  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
	};
	
	var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
	  if (WebAssembly && WebAssembly[ERROR_NAME]) {
	    var O = {};
	    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
	    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
	  }
	};
	
	// https://tc39.es/ecma262/#sec-nativeerror
	exportGlobalErrorCauseWrapper('Error', function (init) {
	  return function Error(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('EvalError', function (init) {
	  return function EvalError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('RangeError', function (init) {
	  return function RangeError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
	  return function ReferenceError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
	  return function SyntaxError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('TypeError', function (init) {
	  return function TypeError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('URIError', function (init) {
	  return function URIError(message) { return apply(init, this, arguments); };
	});
	exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
	  return function CompileError(message) { return apply(init, this, arguments); };
	});
	exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
	  return function LinkError(message) { return apply(init, this, arguments); };
	});
	exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
	  return function RuntimeError(message) { return apply(init, this, arguments); };
	});


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineBuiltIn = __webpack_require__(40);
	var errorToString = __webpack_require__(659);
	
	var ErrorPrototype = Error.prototype;
	
	// `Error.prototype.toString` method fix
	// https://tc39.es/ecma262/#sec-error.prototype.tostring
	if (ErrorPrototype.toString !== errorToString) {
	  defineBuiltIn(ErrorPrototype, 'toString', errorToString);
	}


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(18);
	
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var exec = uncurryThis(/./.exec);
	var numberToString = uncurryThis(1.0.toString);
	var toUpperCase = uncurryThis(''.toUpperCase);
	
	var raw = /[\w*+\-./@]/;
	
	var hex = function (code, length) {
	  var result = numberToString(code, 16);
	  while (result.length < length) result = '0' + result;
	  return result;
	};
	
	// `escape` method
	// https://tc39.es/ecma262/#sec-escape-string
	$({ global: true }, {
	  escape: function escape(string) {
	    var str = toString(string);
	    var result = '';
	    var length = str.length;
	    var index = 0;
	    var chr, code;
	    while (index < length) {
	      chr = charAt(str, index++);
	      if (exec(raw, chr)) {
	        result += chr;
	      } else {
	        code = charCodeAt(chr, 0);
	        if (code < 256) {
	          result += '%' + hex(code, 2);
	        } else {
	          result += '%u' + toUpperCase(hex(code, 4));
	        }
	      }
	    } return result;
	  }
	});


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var $ = __webpack_require__(2);
	var bind = __webpack_require__(661);
	
	// `Function.prototype.bind` method
	// https://tc39.es/ecma262/#sec-function.prototype.bind
	// eslint-disable-next-line es/no-function-prototype-bind -- detection
	$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
	  bind: bind
	});


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(28);
	var isObject = __webpack_require__(25);
	var definePropertyModule = __webpack_require__(42);
	var isPrototypeOf = __webpack_require__(74);
	var wellKnownSymbol = __webpack_require__(27);
	var makeBuiltIn = __webpack_require__(410);
	
	var HAS_INSTANCE = wellKnownSymbol('hasInstance');
	var FunctionPrototype = Function.prototype;
	
	// `Function.prototype[@@hasInstance]` method
	// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
	if (!(HAS_INSTANCE in FunctionPrototype)) {
	  definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, { value: makeBuiltIn(function (O) {
	    if (!isCallable(this) || !isObject(O)) return false;
	    var P = this.prototype;
	    return isObject(P) ? isPrototypeOf(P, O) : O instanceof this;
	  }, HAS_INSTANCE) });
	}


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var FUNCTION_NAME_EXISTS = __webpack_require__(184).EXISTS;
	var uncurryThis = __webpack_require__(8);
	var defineBuiltInAccessor = __webpack_require__(50);
	
	var FunctionPrototype = Function.prototype;
	var functionToString = uncurryThis(FunctionPrototype.toString);
	var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
	var regExpExec = uncurryThis(nameRE.exec);
	var NAME = 'name';
	
	// Function instances `.name` property
	// https://tc39.es/ecma262/#sec-function-instances-name
	if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
	  defineBuiltInAccessor(FunctionPrototype, NAME, {
	    configurable: true,
	    get: function () {
	      try {
	        return regExpExec(nameRE, functionToString(this))[1];
	      } catch (error) {
	        return '';
	      }
	    }
	  });
	}


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	
	// `globalThis` object
	// https://tc39.es/ecma262/#sec-globalthis
	$({ global: true, forced: globalThis.globalThis !== globalThis }, {
	  globalThis: globalThis
	});


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var setToStringTag = __webpack_require__(65);
	
	// JSON[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-json-@@tostringtag
	setToStringTag(globalThis.JSON, 'JSON', true);


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var collection = __webpack_require__(278);
	var collectionStrong = __webpack_require__(648);
	
	// `Map` constructor
	// https://tc39.es/ecma262/#sec-map-objects
	collection('Map', function (init) {
	  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(39);
	var requireObjectCoercible = __webpack_require__(41);
	var iterate = __webpack_require__(83);
	var MapHelpers = __webpack_require__(671);
	var IS_PURE = __webpack_require__(43);
	var fails = __webpack_require__(6);
	
	var Map = MapHelpers.Map;
	var has = MapHelpers.has;
	var get = MapHelpers.get;
	var set = MapHelpers.set;
	var push = uncurryThis([].push);
	
	var DOES_NOT_WORK_WITH_PRIMITIVES = IS_PURE || fails(function () {
	  return Map.groupBy('ab', function (it) {
	    return it;
	  }).get('a').length !== 1;
	});
	
	// `Map.groupBy` method
	// https://github.com/tc39/proposal-array-grouping
	$({ target: 'Map', stat: true, forced: IS_PURE || DOES_NOT_WORK_WITH_PRIMITIVES }, {
	  groupBy: function groupBy(items, callbackfn) {
	    requireObjectCoercible(items);
	    aCallable(callbackfn);
	    var map = new Map();
	    var k = 0;
	    iterate(items, function (value) {
	      var key = callbackfn(value, k++);
	      if (!has(map, key)) set(map, key, [value]);
	      else push(get(map, key), value);
	    });
	    return map;
	  }
	});


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1312);


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var log1p = __webpack_require__(674);
	
	// eslint-disable-next-line es/no-math-acosh -- required for testing
	var $acosh = Math.acosh;
	var log = Math.log;
	var sqrt = Math.sqrt;
	var LN2 = Math.LN2;
	
	var FORCED = !$acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  || Math.floor($acosh(Number.MAX_VALUE)) !== 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  || $acosh(Infinity) !== Infinity;
	
	// `Math.acosh` method
	// https://tc39.es/ecma262/#sec-math.acosh
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  acosh: function acosh(x) {
	    var n = +x;
	    return n < 1 ? NaN : n > 94906265.62425156
	      ? log(n) + LN2
	      : log1p(n - 1 + sqrt(n - 1) * sqrt(n + 1));
	  }
	});


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// eslint-disable-next-line es/no-math-asinh -- required for testing
	var $asinh = Math.asinh;
	var log = Math.log;
	var sqrt = Math.sqrt;
	
	function asinh(x) {
	  var n = +x;
	  return !isFinite(n) || n === 0 ? n : n < 0 ? -asinh(-n) : log(n + sqrt(n * n + 1));
	}
	
	var FORCED = !($asinh && 1 / $asinh(0) > 0);
	
	// `Math.asinh` method
	// https://tc39.es/ecma262/#sec-math.asinh
	// Tor Browser bug: Math.asinh(0) -> -0
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  asinh: asinh
	});


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// eslint-disable-next-line es/no-math-atanh -- required for testing
	var $atanh = Math.atanh;
	var log = Math.log;
	
	var FORCED = !($atanh && 1 / $atanh(-0) < 0);
	
	// `Math.atanh` method
	// https://tc39.es/ecma262/#sec-math.atanh
	// Tor Browser bug: Math.atanh(-0) -> 0
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  atanh: function atanh(x) {
	    var n = +x;
	    return n === 0 ? n : log((1 + n) / (1 - n)) / 2;
	  }
	});


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var sign = __webpack_require__(411);
	
	var abs = Math.abs;
	var pow = Math.pow;
	
	// `Math.cbrt` method
	// https://tc39.es/ecma262/#sec-math.cbrt
	$({ target: 'Math', stat: true }, {
	  cbrt: function cbrt(x) {
	    var n = +x;
	    return sign(n) * pow(abs(n), 1 / 3);
	  }
	});


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	var floor = Math.floor;
	var log = Math.log;
	var LOG2E = Math.LOG2E;
	
	// `Math.clz32` method
	// https://tc39.es/ecma262/#sec-math.clz32
	$({ target: 'Math', stat: true }, {
	  clz32: function clz32(x) {
	    var n = x >>> 0;
	    return n ? 31 - floor(log(n + 0.5) * LOG2E) : 32;
	  }
	});


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var expm1 = __webpack_require__(287);
	
	// eslint-disable-next-line es/no-math-cosh -- required for testing
	var $cosh = Math.cosh;
	var abs = Math.abs;
	var E = Math.E;
	
	var FORCED = !$cosh || $cosh(710) === Infinity;
	
	// `Math.cosh` method
	// https://tc39.es/ecma262/#sec-math.cosh
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  cosh: function cosh(x) {
	    var t = expm1(abs(x) - 1) + 1;
	    return (t + 1 / (t * E * E)) * (E / 2);
	  }
	});


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var expm1 = __webpack_require__(287);
	
	// `Math.expm1` method
	// https://tc39.es/ecma262/#sec-math.expm1
	// eslint-disable-next-line es/no-math-expm1 -- required for testing
	$({ target: 'Math', stat: true, forced: expm1 !== Math.expm1 }, { expm1: expm1 });


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fround = __webpack_require__(672);
	
	// `Math.fround` method
	// https://tc39.es/ecma262/#sec-math.fround
	$({ target: 'Math', stat: true }, { fround: fround });


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// eslint-disable-next-line es/no-math-hypot -- required for testing
	var $hypot = Math.hypot;
	var abs = Math.abs;
	var sqrt = Math.sqrt;
	
	// Chrome 77 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=9546
	var FORCED = !!$hypot && $hypot(Infinity, NaN) !== Infinity;
	
	// `Math.hypot` method
	// https://tc39.es/ecma262/#sec-math.hypot
	$({ target: 'Math', stat: true, arity: 2, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  hypot: function hypot(value1, value2) {
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * sqrt(sum);
	  }
	});


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	
	// eslint-disable-next-line es/no-math-imul -- required for testing
	var $imul = Math.imul;
	
	var FORCED = fails(function () {
	  return $imul(0xFFFFFFFF, 5) !== -5 || $imul.length !== 2;
	});
	
	// `Math.imul` method
	// https://tc39.es/ecma262/#sec-math.imul
	// some WebKit versions fails with big numbers, some has wrong arity
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  imul: function imul(x, y) {
	    var UINT16 = 0xFFFF;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var log10 = __webpack_require__(673);
	
	// `Math.log10` method
	// https://tc39.es/ecma262/#sec-math.log10
	$({ target: 'Math', stat: true }, {
	  log10: log10
	});


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var log1p = __webpack_require__(674);
	
	// `Math.log1p` method
	// https://tc39.es/ecma262/#sec-math.log1p
	$({ target: 'Math', stat: true }, { log1p: log1p });


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	var log = Math.log;
	var LN2 = Math.LN2;
	
	// `Math.log2` method
	// https://tc39.es/ecma262/#sec-math.log2
	$({ target: 'Math', stat: true }, {
	  log2: function log2(x) {
	    return log(x) / LN2;
	  }
	});


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var sign = __webpack_require__(411);
	
	// `Math.sign` method
	// https://tc39.es/ecma262/#sec-math.sign
	$({ target: 'Math', stat: true }, {
	  sign: sign
	});


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var expm1 = __webpack_require__(287);
	
	var abs = Math.abs;
	var exp = Math.exp;
	var E = Math.E;
	
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-math-sinh -- required for testing
	  return Math.sinh(-2e-17) !== -2e-17;
	});
	
	// `Math.sinh` method
	// https://tc39.es/ecma262/#sec-math.sinh
	// V8 near Chromium 38 has a problem with very small numbers
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  sinh: function sinh(x) {
	    var n = +x;
	    return abs(n) < 1 ? (expm1(n) - expm1(-n)) / 2 : (exp(n - 1) - exp(-n - 1)) * (E / 2);
	  }
	});


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var expm1 = __webpack_require__(287);
	
	var exp = Math.exp;
	
	// `Math.tanh` method
	// https://tc39.es/ecma262/#sec-math.tanh
	$({ target: 'Math', stat: true }, {
	  tanh: function tanh(x) {
	    var n = +x;
	    var a = expm1(n);
	    var b = expm1(-n);
	    return a === Infinity ? 1 : b === Infinity ? -1 : (a - b) / (exp(n) + exp(-n));
	  }
	});


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var setToStringTag = __webpack_require__(65);
	
	// Math[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-math-@@tostringtag
	setToStringTag(Math, 'Math', true);


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var trunc = __webpack_require__(675);
	
	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	$({ target: 'Math', stat: true }, {
	  trunc: trunc
	});


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var IS_PURE = __webpack_require__(43);
	var DESCRIPTORS = __webpack_require__(14);
	var globalThis = __webpack_require__(9);
	var path = __webpack_require__(417);
	var uncurryThis = __webpack_require__(8);
	var isForced = __webpack_require__(233);
	var hasOwn = __webpack_require__(29);
	var inheritIfRequired = __webpack_require__(148);
	var isPrototypeOf = __webpack_require__(74);
	var isSymbol = __webpack_require__(150);
	var toPrimitive = __webpack_require__(298);
	var fails = __webpack_require__(6);
	var getOwnPropertyNames = __webpack_require__(152).f;
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	var defineProperty = __webpack_require__(42).f;
	var thisNumberValue = __webpack_require__(297);
	var trim = __webpack_require__(192).trim;
	
	var NUMBER = 'Number';
	var NativeNumber = globalThis[NUMBER];
	var PureNumberNamespace = path[NUMBER];
	var NumberPrototype = NativeNumber.prototype;
	var TypeError = globalThis.TypeError;
	var stringSlice = uncurryThis(''.slice);
	var charCodeAt = uncurryThis(''.charCodeAt);
	
	// `ToNumeric` abstract operation
	// https://tc39.es/ecma262/#sec-tonumeric
	var toNumeric = function (value) {
	  var primValue = toPrimitive(value, 'number');
	  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
	};
	
	// `ToNumber` abstract operation
	// https://tc39.es/ecma262/#sec-tonumber
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, 'number');
	  var first, third, radix, maxCode, digits, length, index, code;
	  if (isSymbol(it)) throw new TypeError('Cannot convert a Symbol value to a number');
	  if (typeof it == 'string' && it.length > 2) {
	    it = trim(it);
	    first = charCodeAt(it, 0);
	    if (first === 43 || first === 45) {
	      third = charCodeAt(it, 2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (charCodeAt(it, 1)) {
	        // fast equal of /^0b[01]+$/i
	        case 66:
	        case 98:
	          radix = 2;
	          maxCode = 49;
	          break;
	        // fast equal of /^0o[0-7]+$/i
	        case 79:
	        case 111:
	          radix = 8;
	          maxCode = 55;
	          break;
	        default:
	          return +it;
	      }
	      digits = stringSlice(it, 2);
	      length = digits.length;
	      for (index = 0; index < length; index++) {
	        code = charCodeAt(digits, index);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));
	
	var calledWithNew = function (dummy) {
	  // includes check on 1..constructor(foo) case
	  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
	};
	
	// `Number` constructor
	// https://tc39.es/ecma262/#sec-number-constructor
	var NumberWrapper = function Number(value) {
	  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
	  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
	};
	
	NumberWrapper.prototype = NumberPrototype;
	if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;
	
	$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
	  Number: NumberWrapper
	});
	
	// Use `internal/copy-constructor-properties` helper in `core-js@4`
	var copyConstructorProperties = function (target, source) {
	  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES2015 (in case, if modules with ES2015 Number statics required before):
	    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
	    // ESNext
	    'fromString,range'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};
	
	if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
	if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// `Number.EPSILON` constant
	// https://tc39.es/ecma262/#sec-number.epsilon
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  EPSILON: Math.pow(2, -52)
	});


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var numberIsFinite = __webpack_require__(1235);
	
	// `Number.isFinite` method
	// https://tc39.es/ecma262/#sec-number.isfinite
	$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isIntegralNumber = __webpack_require__(407);
	
	// `Number.isInteger` method
	// https://tc39.es/ecma262/#sec-number.isinteger
	$({ target: 'Number', stat: true }, {
	  isInteger: isIntegralNumber
	});


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// `Number.isNaN` method
	// https://tc39.es/ecma262/#sec-number.isnan
	$({ target: 'Number', stat: true }, {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare -- NaN check
	    return number !== number;
	  }
	});


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isIntegralNumber = __webpack_require__(407);
	
	var abs = Math.abs;
	
	// `Number.isSafeInteger` method
	// https://tc39.es/ecma262/#sec-number.issafeinteger
	$({ target: 'Number', stat: true }, {
	  isSafeInteger: function isSafeInteger(number) {
	    return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
	  }
	});


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// `Number.MAX_SAFE_INTEGER` constant
	// https://tc39.es/ecma262/#sec-number.max_safe_integer
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
	});


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// `Number.MIN_SAFE_INTEGER` constant
	// https://tc39.es/ecma262/#sec-number.min_safe_integer
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
	});


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var parseFloat = __webpack_require__(677);
	
	// `Number.parseFloat` method
	// https://tc39.es/ecma262/#sec-number.parseFloat
	// eslint-disable-next-line es/no-number-parsefloat -- required for testing
	$({ target: 'Number', stat: true, forced: Number.parseFloat !== parseFloat }, {
	  parseFloat: parseFloat
	});


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var parseInt = __webpack_require__(678);
	
	// `Number.parseInt` method
	// https://tc39.es/ecma262/#sec-number.parseint
	// eslint-disable-next-line es/no-number-parseint -- required for testing
	$({ target: 'Number', stat: true, forced: Number.parseInt !== parseInt }, {
	  parseInt: parseInt
	});


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var toIntegerOrInfinity = __webpack_require__(44);
	var thisNumberValue = __webpack_require__(297);
	var $repeat = __webpack_require__(295);
	var log10 = __webpack_require__(673);
	var fails = __webpack_require__(6);
	
	var $RangeError = RangeError;
	var $String = String;
	var $isFinite = isFinite;
	var abs = Math.abs;
	var floor = Math.floor;
	var pow = Math.pow;
	var round = Math.round;
	var nativeToExponential = uncurryThis(1.0.toExponential);
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	
	// Edge 17-
	var ROUNDS_PROPERLY = nativeToExponential(-6.9e-11, 4) === '-6.9000e-11'
	  // IE11- && Edge 14-
	  && nativeToExponential(1.255, 2) === '1.25e+0'
	  // FF86-, V8 ~ Chrome 49-50
	  && nativeToExponential(12345, 3) === '1.235e+4'
	  // FF86-, V8 ~ Chrome 49-50
	  && nativeToExponential(25, 0) === '3e+1';
	
	// IE8-
	var throwsOnInfinityFraction = function () {
	  return fails(function () {
	    nativeToExponential(1, Infinity);
	  }) && fails(function () {
	    nativeToExponential(1, -Infinity);
	  });
	};
	
	// Safari <11 && FF <50
	var properNonFiniteThisCheck = function () {
	  return !fails(function () {
	    nativeToExponential(Infinity, Infinity);
	    nativeToExponential(NaN, Infinity);
	  });
	};
	
	var FORCED = !ROUNDS_PROPERLY || !throwsOnInfinityFraction() || !properNonFiniteThisCheck();
	
	// `Number.prototype.toExponential` method
	// https://tc39.es/ecma262/#sec-number.prototype.toexponential
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toExponential: function toExponential(fractionDigits) {
	    var x = thisNumberValue(this);
	    if (fractionDigits === undefined) return nativeToExponential(x);
	    var f = toIntegerOrInfinity(fractionDigits);
	    if (!$isFinite(x)) return String(x);
	    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
	    if (f < 0 || f > 20) throw new $RangeError('Incorrect fraction digits');
	    if (ROUNDS_PROPERLY) return nativeToExponential(x, f);
	    var s = '';
	    var m, e, c, d;
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x === 0) {
	      e = 0;
	      m = repeat('0', f + 1);
	    } else {
	      // this block is based on https://gist.github.com/SheetJSDev/1100ad56b9f856c95299ed0e068eea08
	      // TODO: improve accuracy with big fraction digits
	      var l = log10(x);
	      e = floor(l);
	      var w = pow(10, e - f);
	      var n = round(x / w);
	      if (2 * x >= (2 * n + 1) * w) {
	        n += 1;
	      }
	      if (n >= pow(10, f + 1)) {
	        n /= 10;
	        e += 1;
	      }
	      m = $String(n);
	    }
	    if (f !== 0) {
	      m = stringSlice(m, 0, 1) + '.' + stringSlice(m, 1);
	    }
	    if (e === 0) {
	      c = '+';
	      d = '0';
	    } else {
	      c = e > 0 ? '+' : '-';
	      d = $String(abs(e));
	    }
	    m += 'e' + c + d;
	    return s + m;
	  }
	});


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var toIntegerOrInfinity = __webpack_require__(44);
	var thisNumberValue = __webpack_require__(297);
	var $repeat = __webpack_require__(295);
	var fails = __webpack_require__(6);
	
	var $RangeError = RangeError;
	var $String = String;
	var floor = Math.floor;
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	var nativeToFixed = uncurryThis(1.0.toFixed);
	
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	var multiply = function (data, n, c) {
	  var index = -1;
	  var c2 = c;
	  while (++index < 6) {
	    c2 += n * data[index];
	    data[index] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	
	var divide = function (data, n) {
	  var index = 6;
	  var c = 0;
	  while (--index >= 0) {
	    c += data[index];
	    data[index] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	
	var dataToString = function (data) {
	  var index = 6;
	  var s = '';
	  while (--index >= 0) {
	    if (s !== '' || index === 0 || data[index] !== 0) {
	      var t = $String(data[index]);
	      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
	    }
	  } return s;
	};
	
	var FORCED = fails(function () {
	  return nativeToFixed(0.00008, 3) !== '0.000' ||
	    nativeToFixed(0.9, 0) !== '1' ||
	    nativeToFixed(1.255, 2) !== '1.25' ||
	    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
	}) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToFixed({});
	});
	
	// `Number.prototype.toFixed` method
	// https://tc39.es/ecma262/#sec-number.prototype.tofixed
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toFixed: function toFixed(fractionDigits) {
	    var number = thisNumberValue(this);
	    var fractDigits = toIntegerOrInfinity(fractionDigits);
	    var data = [0, 0, 0, 0, 0, 0];
	    var sign = '';
	    var result = '0';
	    var e, z, j, k;
	
	    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
	    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError('Incorrect fraction digits');
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (number !== number) return 'NaN';
	    if (number <= -1e21 || number >= 1e21) return $String(number);
	    if (number < 0) {
	      sign = '-';
	      number = -number;
	    }
	    if (number > 1e-21) {
	      e = log(number * pow(2, 69, 1)) - 69;
	      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(data, 0, z);
	        j = fractDigits;
	        while (j >= 7) {
	          multiply(data, 1e7, 0);
	          j -= 7;
	        }
	        multiply(data, pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(data, 1 << 23);
	          j -= 23;
	        }
	        divide(data, 1 << j);
	        multiply(data, 1, 1);
	        divide(data, 2);
	        result = dataToString(data);
	      } else {
	        multiply(data, 0, z);
	        multiply(data, 1 << -e, 0);
	        result = dataToString(data) + repeat('0', fractDigits);
	      }
	    }
	    if (fractDigits > 0) {
	      k = result.length;
	      result = sign + (k <= fractDigits
	        ? '0.' + repeat('0', fractDigits - k) + result
	        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
	    } else {
	      result = sign + result;
	    } return result;
	  }
	});


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	var thisNumberValue = __webpack_require__(297);
	
	var nativeToPrecision = uncurryThis(1.0.toPrecision);
	
	var FORCED = fails(function () {
	  // IE7-
	  return nativeToPrecision(1, undefined) !== '1';
	}) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToPrecision({});
	});
	
	// `Number.prototype.toPrecision` method
	// https://tc39.es/ecma262/#sec-number.prototype.toprecision
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toPrecision: function toPrecision(precision) {
	    return precision === undefined
	      ? nativeToPrecision(thisNumberValue(this))
	      : nativeToPrecision(thisNumberValue(this), precision);
	  }
	});


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var assign = __webpack_require__(679);
	
	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	// eslint-disable-next-line es/no-object-assign -- required for testing
	$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
	  assign: assign
	});


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var create = __webpack_require__(73);
	
	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
	  create: create
	});


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var FORCED = __webpack_require__(290);
	var aCallable = __webpack_require__(39);
	var toObject = __webpack_require__(31);
	var definePropertyModule = __webpack_require__(42);
	
	// `Object.prototype.__defineGetter__` method
	// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
	if (DESCRIPTORS) {
	  $({ target: 'Object', proto: true, forced: FORCED }, {
	    __defineGetter__: function __defineGetter__(P, getter) {
	      definePropertyModule.f(toObject(this), P, { get: aCallable(getter), enumerable: true, configurable: true });
	    }
	  });
	}


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var defineProperties = __webpack_require__(413).f;
	
	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	$({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties, sham: !DESCRIPTORS }, {
	  defineProperties: defineProperties
	});


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var defineProperty = __webpack_require__(42).f;
	
	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
	  defineProperty: defineProperty
	});


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var FORCED = __webpack_require__(290);
	var aCallable = __webpack_require__(39);
	var toObject = __webpack_require__(31);
	var definePropertyModule = __webpack_require__(42);
	
	// `Object.prototype.__defineSetter__` method
	// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
	if (DESCRIPTORS) {
	  $({ target: 'Object', proto: true, forced: FORCED }, {
	    __defineSetter__: function __defineSetter__(P, setter) {
	      definePropertyModule.f(toObject(this), P, { set: aCallable(setter), enumerable: true, configurable: true });
	    }
	  });
	}


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $entries = __webpack_require__(681).entries;
	
	// `Object.entries` method
	// https://tc39.es/ecma262/#sec-object.entries
	$({ target: 'Object', stat: true }, {
	  entries: function entries(O) {
	    return $entries(O);
	  }
	});


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var FREEZING = __webpack_require__(183);
	var fails = __webpack_require__(6);
	var isObject = __webpack_require__(25);
	var onFreeze = __webpack_require__(149).onFreeze;
	
	// eslint-disable-next-line es/no-object-freeze -- safe
	var $freeze = Object.freeze;
	var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });
	
	// `Object.freeze` method
	// https://tc39.es/ecma262/#sec-object.freeze
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
	  freeze: function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
	  }
	});


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var iterate = __webpack_require__(83);
	var createProperty = __webpack_require__(129);
	
	// `Object.fromEntries` method
	// https://github.com/tc39/proposal-object-from-entries
	$({ target: 'Object', stat: true }, {
	  fromEntries: function fromEntries(iterable) {
	    var obj = {};
	    iterate(iterable, function (k, v) {
	      createProperty(obj, k, v);
	    }, { AS_ENTRIES: true });
	    return obj;
	  }
	});


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var toIndexedObject = __webpack_require__(51);
	var nativeGetOwnPropertyDescriptor = __webpack_require__(59).f;
	var DESCRIPTORS = __webpack_require__(14);
	
	var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });
	
	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
	    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
	  }
	});


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var ownKeys = __webpack_require__(416);
	var toIndexedObject = __webpack_require__(51);
	var getOwnPropertyDescriptorModule = __webpack_require__(59);
	var createProperty = __webpack_require__(129);
	
	// `Object.getOwnPropertyDescriptors` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIndexedObject(object);
	    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var index = 0;
	    var key, descriptor;
	    while (keys.length > index) {
	      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
	      if (descriptor !== undefined) createProperty(result, key, descriptor);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var getOwnPropertyNames = __webpack_require__(414).f;
	
	// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
	var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });
	
	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
	  getOwnPropertyNames: getOwnPropertyNames
	});


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var NATIVE_SYMBOL = __webpack_require__(193);
	var fails = __webpack_require__(6);
	var getOwnPropertySymbolsModule = __webpack_require__(288);
	var toObject = __webpack_require__(31);
	
	// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });
	
	// `Object.getOwnPropertySymbols` method
	// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
	$({ target: 'Object', stat: true, forced: FORCED }, {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
	  }
	});


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var toObject = __webpack_require__(31);
	var nativeGetPrototypeOf = __webpack_require__(84);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(400);
	
	var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });
	
	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
	  getPrototypeOf: function getPrototypeOf(it) {
	    return nativeGetPrototypeOf(toObject(it));
	  }
	});
	


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(39);
	var requireObjectCoercible = __webpack_require__(41);
	var toPropertyKey = __webpack_require__(133);
	var iterate = __webpack_require__(83);
	var fails = __webpack_require__(6);
	
	// eslint-disable-next-line es/no-object-groupby -- testing
	var nativeGroupBy = Object.groupBy;
	var create = getBuiltIn('Object', 'create');
	var push = uncurryThis([].push);
	
	var DOES_NOT_WORK_WITH_PRIMITIVES = !nativeGroupBy || fails(function () {
	  return nativeGroupBy('ab', function (it) {
	    return it;
	  }).a.length !== 1;
	});
	
	// `Object.groupBy` method
	// https://github.com/tc39/proposal-array-grouping
	$({ target: 'Object', stat: true, forced: DOES_NOT_WORK_WITH_PRIMITIVES }, {
	  groupBy: function groupBy(items, callbackfn) {
	    requireObjectCoercible(items);
	    aCallable(callbackfn);
	    var obj = create(null);
	    var k = 0;
	    iterate(items, function (value) {
	      var key = toPropertyKey(callbackfn(value, k++));
	      // in some IE versions, `hasOwnProperty` returns incorrect result on integer keys
	      // but since it's a `null` prototype object, we can safely use `in`
	      if (key in obj) push(obj[key], value);
	      else obj[key] = [value];
	    });
	    return obj;
	  }
	});


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var hasOwn = __webpack_require__(29);
	
	// `Object.hasOwn` method
	// https://tc39.es/ecma262/#sec-object.hasown
	$({ target: 'Object', stat: true }, {
	  hasOwn: hasOwn
	});


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $isExtensible = __webpack_require__(415);
	
	// `Object.isExtensible` method
	// https://tc39.es/ecma262/#sec-object.isextensible
	// eslint-disable-next-line es/no-object-isextensible -- safe
	$({ target: 'Object', stat: true, forced: Object.isExtensible !== $isExtensible }, {
	  isExtensible: $isExtensible
	});


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var isObject = __webpack_require__(25);
	var classof = __webpack_require__(53);
	var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(395);
	
	// eslint-disable-next-line es/no-object-isfrozen -- safe
	var $isFrozen = Object.isFrozen;
	
	var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () { $isFrozen(1); });
	
	// `Object.isFrozen` method
	// https://tc39.es/ecma262/#sec-object.isfrozen
	$({ target: 'Object', stat: true, forced: FORCED }, {
	  isFrozen: function isFrozen(it) {
	    if (!isObject(it)) return true;
	    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return true;
	    return $isFrozen ? $isFrozen(it) : false;
	  }
	});


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var isObject = __webpack_require__(25);
	var classof = __webpack_require__(53);
	var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(395);
	
	// eslint-disable-next-line es/no-object-issealed -- safe
	var $isSealed = Object.isSealed;
	
	var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () { $isSealed(1); });
	
	// `Object.isSealed` method
	// https://tc39.es/ecma262/#sec-object.issealed
	$({ target: 'Object', stat: true, forced: FORCED }, {
	  isSealed: function isSealed(it) {
	    if (!isObject(it)) return true;
	    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return true;
	    return $isSealed ? $isSealed(it) : false;
	  }
	});


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var is = __webpack_require__(688);
	
	// `Object.is` method
	// https://tc39.es/ecma262/#sec-object.is
	$({ target: 'Object', stat: true }, {
	  is: is
	});


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var toObject = __webpack_require__(31);
	var nativeKeys = __webpack_require__(236);
	var fails = __webpack_require__(6);
	
	var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });
	
	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
	  keys: function keys(it) {
	    return nativeKeys(toObject(it));
	  }
	});


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var FORCED = __webpack_require__(290);
	var toObject = __webpack_require__(31);
	var toPropertyKey = __webpack_require__(133);
	var getPrototypeOf = __webpack_require__(84);
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	
	// `Object.prototype.__lookupGetter__` method
	// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
	if (DESCRIPTORS) {
	  $({ target: 'Object', proto: true, forced: FORCED }, {
	    __lookupGetter__: function __lookupGetter__(P) {
	      var O = toObject(this);
	      var key = toPropertyKey(P);
	      var desc;
	      do {
	        if (desc = getOwnPropertyDescriptor(O, key)) return desc.get;
	      } while (O = getPrototypeOf(O));
	    }
	  });
	}


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var FORCED = __webpack_require__(290);
	var toObject = __webpack_require__(31);
	var toPropertyKey = __webpack_require__(133);
	var getPrototypeOf = __webpack_require__(84);
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	
	// `Object.prototype.__lookupSetter__` method
	// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
	if (DESCRIPTORS) {
	  $({ target: 'Object', proto: true, forced: FORCED }, {
	    __lookupSetter__: function __lookupSetter__(P) {
	      var O = toObject(this);
	      var key = toPropertyKey(P);
	      var desc;
	      do {
	        if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
	      } while (O = getPrototypeOf(O));
	    }
	  });
	}


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isObject = __webpack_require__(25);
	var onFreeze = __webpack_require__(149).onFreeze;
	var FREEZING = __webpack_require__(183);
	var fails = __webpack_require__(6);
	
	// eslint-disable-next-line es/no-object-preventextensions -- safe
	var $preventExtensions = Object.preventExtensions;
	var FAILS_ON_PRIMITIVES = fails(function () { $preventExtensions(1); });
	
	// `Object.preventExtensions` method
	// https://tc39.es/ecma262/#sec-object.preventextensions
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
	  preventExtensions: function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(onFreeze(it)) : it;
	  }
	});


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var defineBuiltInAccessor = __webpack_require__(50);
	var isObject = __webpack_require__(25);
	var isPossiblePrototype = __webpack_require__(669);
	var toObject = __webpack_require__(31);
	var requireObjectCoercible = __webpack_require__(41);
	
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	var getPrototypeOf = Object.getPrototypeOf;
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	var setPrototypeOf = Object.setPrototypeOf;
	var ObjectPrototype = Object.prototype;
	var PROTO = '__proto__';
	
	// `Object.prototype.__proto__` accessor
	// https://tc39.es/ecma262/#sec-object.prototype.__proto__
	if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
	  defineBuiltInAccessor(ObjectPrototype, PROTO, {
	    configurable: true,
	    get: function __proto__() {
	      return getPrototypeOf(toObject(this));
	    },
	    set: function __proto__(proto) {
	      var O = requireObjectCoercible(this);
	      if (isPossiblePrototype(proto) && isObject(O)) {
	        setPrototypeOf(O, proto);
	      }
	    }
	  });
	} catch (error) { /* empty */ }


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isObject = __webpack_require__(25);
	var onFreeze = __webpack_require__(149).onFreeze;
	var FREEZING = __webpack_require__(183);
	var fails = __webpack_require__(6);
	
	// eslint-disable-next-line es/no-object-seal -- safe
	var $seal = Object.seal;
	var FAILS_ON_PRIMITIVES = fails(function () { $seal(1); });
	
	// `Object.seal` method
	// https://tc39.es/ecma262/#sec-object.seal
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
	  seal: function seal(it) {
	    return $seal && isObject(it) ? $seal(onFreeze(it)) : it;
	  }
	});


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var setPrototypeOf = __webpack_require__(100);
	
	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	$({ target: 'Object', stat: true }, {
	  setPrototypeOf: setPrototypeOf
	});


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(429);
	var defineBuiltIn = __webpack_require__(40);
	var toString = __webpack_require__(1236);
	
	// `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	if (!TO_STRING_TAG_SUPPORT) {
	  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
	}


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $values = __webpack_require__(681).values;
	
	// `Object.values` method
	// https://tc39.es/ecma262/#sec-object.values
	$({ target: 'Object', stat: true }, {
	  values: function values(O) {
	    return $values(O);
	  }
	});


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $parseFloat = __webpack_require__(677);
	
	// `parseFloat` method
	// https://tc39.es/ecma262/#sec-parsefloat-string
	$({ global: true, forced: parseFloat !== $parseFloat }, {
	  parseFloat: $parseFloat
	});


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $parseInt = __webpack_require__(678);
	
	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	$({ global: true, forced: parseInt !== $parseInt }, {
	  parseInt: $parseInt
	});


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var aCallable = __webpack_require__(39);
	var newPromiseCapabilityModule = __webpack_require__(132);
	var perform = __webpack_require__(237);
	var iterate = __webpack_require__(83);
	var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(291);
	
	// `Promise.allSettled` method
	// https://tc39.es/ecma262/#sec-promise.allsettled
	$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  allSettled: function allSettled(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var promiseResolve = aCallable(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        remaining++;
	        call(promiseResolve, C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = { status: 'fulfilled', value: value };
	          --remaining || resolve(values);
	        }, function (error) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = { status: 'rejected', reason: error };
	          --remaining || resolve(values);
	        });
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var aCallable = __webpack_require__(39);
	var newPromiseCapabilityModule = __webpack_require__(132);
	var perform = __webpack_require__(237);
	var iterate = __webpack_require__(83);
	var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(291);
	
	// `Promise.all` method
	// https://tc39.es/ecma262/#sec-promise.all
	$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var $promiseResolve = aCallable(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        remaining++;
	        call($promiseResolve, C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var aCallable = __webpack_require__(39);
	var getBuiltIn = __webpack_require__(33);
	var newPromiseCapabilityModule = __webpack_require__(132);
	var perform = __webpack_require__(237);
	var iterate = __webpack_require__(83);
	var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(291);
	
	var PROMISE_ANY_ERROR = 'No one promise resolved';
	
	// `Promise.any` method
	// https://tc39.es/ecma262/#sec-promise.any
	$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  any: function any(iterable) {
	    var C = this;
	    var AggregateError = getBuiltIn('AggregateError');
	    var capability = newPromiseCapabilityModule.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var promiseResolve = aCallable(C.resolve);
	      var errors = [];
	      var counter = 0;
	      var remaining = 1;
	      var alreadyResolved = false;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyRejected = false;
	        remaining++;
	        call(promiseResolve, C, promise).then(function (value) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyResolved = true;
	          resolve(value);
	        }, function (error) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyRejected = true;
	          errors[index] = error;
	          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
	        });
	      });
	      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var IS_PURE = __webpack_require__(43);
	var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(238).CONSTRUCTOR;
	var NativePromiseConstructor = __webpack_require__(187);
	var getBuiltIn = __webpack_require__(33);
	var isCallable = __webpack_require__(28);
	var defineBuiltIn = __webpack_require__(40);
	
	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
	
	// `Promise.prototype.catch` method
	// https://tc39.es/ecma262/#sec-promise.prototype.catch
	$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
	  'catch': function (onRejected) {
	    return this.then(undefined, onRejected);
	  }
	});
	
	// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
	if (!IS_PURE && isCallable(NativePromiseConstructor)) {
	  var method = getBuiltIn('Promise').prototype['catch'];
	  if (NativePromisePrototype['catch'] !== method) {
	    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
	  }
	}


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var IS_PURE = __webpack_require__(43);
	var IS_NODE = __webpack_require__(182);
	var globalThis = __webpack_require__(9);
	var call = __webpack_require__(19);
	var defineBuiltIn = __webpack_require__(40);
	var setPrototypeOf = __webpack_require__(100);
	var setToStringTag = __webpack_require__(65);
	var setSpecies = __webpack_require__(189);
	var aCallable = __webpack_require__(39);
	var isCallable = __webpack_require__(28);
	var isObject = __webpack_require__(25);
	var anInstance = __webpack_require__(97);
	var speciesConstructor = __webpack_require__(191);
	var task = __webpack_require__(296).set;
	var microtask = __webpack_require__(676);
	var hostReportErrors = __webpack_require__(1232);
	var perform = __webpack_require__(237);
	var Queue = __webpack_require__(685);
	var InternalStateModule = __webpack_require__(49);
	var NativePromiseConstructor = __webpack_require__(187);
	var PromiseConstructorDetection = __webpack_require__(238);
	var newPromiseCapabilityModule = __webpack_require__(132);
	
	var PROMISE = 'Promise';
	var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
	var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
	var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
	var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
	var setInternalState = InternalStateModule.set;
	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
	var PromiseConstructor = NativePromiseConstructor;
	var PromisePrototype = NativePromisePrototype;
	var TypeError = globalThis.TypeError;
	var document = globalThis.document;
	var process = globalThis.process;
	var newPromiseCapability = newPromiseCapabilityModule.f;
	var newGenericPromiseCapability = newPromiseCapability;
	
	var DISPATCH_EVENT = !!(document && document.createEvent && globalThis.dispatchEvent);
	var UNHANDLED_REJECTION = 'unhandledrejection';
	var REJECTION_HANDLED = 'rejectionhandled';
	var PENDING = 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	var HANDLED = 1;
	var UNHANDLED = 2;
	
	var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && isCallable(then = it.then) ? then : false;
	};
	
	var callReaction = function (reaction, state) {
	  var value = state.value;
	  var ok = state.state === FULFILLED;
	  var handler = ok ? reaction.ok : reaction.fail;
	  var resolve = reaction.resolve;
	  var reject = reaction.reject;
	  var domain = reaction.domain;
	  var result, then, exited;
	  try {
	    if (handler) {
	      if (!ok) {
	        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
	        state.rejection = HANDLED;
	      }
	      if (handler === true) result = value;
	      else {
	        if (domain) domain.enter();
	        result = handler(value); // can throw
	        if (domain) {
	          domain.exit();
	          exited = true;
	        }
	      }
	      if (result === reaction.promise) {
	        reject(new TypeError('Promise-chain cycle'));
	      } else if (then = isThenable(result)) {
	        call(then, result, resolve, reject);
	      } else resolve(result);
	    } else reject(value);
	  } catch (error) {
	    if (domain && !exited) domain.exit();
	    reject(error);
	  }
	};
	
	var notify = function (state, isReject) {
	  if (state.notified) return;
	  state.notified = true;
	  microtask(function () {
	    var reactions = state.reactions;
	    var reaction;
	    while (reaction = reactions.get()) {
	      callReaction(reaction, state);
	    }
	    state.notified = false;
	    if (isReject && !state.rejection) onUnhandled(state);
	  });
	};
	
	var dispatchEvent = function (name, promise, reason) {
	  var event, handler;
	  if (DISPATCH_EVENT) {
	    event = document.createEvent('Event');
	    event.promise = promise;
	    event.reason = reason;
	    event.initEvent(name, false, true);
	    globalThis.dispatchEvent(event);
	  } else event = { promise: promise, reason: reason };
	  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis['on' + name])) handler(event);
	  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
	};
	
	var onUnhandled = function (state) {
	  call(task, globalThis, function () {
	    var promise = state.facade;
	    var value = state.value;
	    var IS_UNHANDLED = isUnhandled(state);
	    var result;
	    if (IS_UNHANDLED) {
	      result = perform(function () {
	        if (IS_NODE) {
	          process.emit('unhandledRejection', value, promise);
	        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
	      if (result.error) throw result.value;
	    }
	  });
	};
	
	var isUnhandled = function (state) {
	  return state.rejection !== HANDLED && !state.parent;
	};
	
	var onHandleUnhandled = function (state) {
	  call(task, globalThis, function () {
	    var promise = state.facade;
	    if (IS_NODE) {
	      process.emit('rejectionHandled', promise);
	    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
	  });
	};
	
	var bind = function (fn, state, unwrap) {
	  return function (value) {
	    fn(state, value, unwrap);
	  };
	};
	
	var internalReject = function (state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  state.value = value;
	  state.state = REJECTED;
	  notify(state, true);
	};
	
	var internalResolve = function (state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  try {
	    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
	    var then = isThenable(value);
	    if (then) {
	      microtask(function () {
	        var wrapper = { done: false };
	        try {
	          call(then, value,
	            bind(internalResolve, wrapper, state),
	            bind(internalReject, wrapper, state)
	          );
	        } catch (error) {
	          internalReject(wrapper, error, state);
	        }
	      });
	    } else {
	      state.value = value;
	      state.state = FULFILLED;
	      notify(state, false);
	    }
	  } catch (error) {
	    internalReject({ done: false }, error, state);
	  }
	};
	
	// constructor polyfill
	if (FORCED_PROMISE_CONSTRUCTOR) {
	  // 25.4.3.1 Promise(executor)
	  PromiseConstructor = function Promise(executor) {
	    anInstance(this, PromisePrototype);
	    aCallable(executor);
	    call(Internal, this);
	    var state = getInternalPromiseState(this);
	    try {
	      executor(bind(internalResolve, state), bind(internalReject, state));
	    } catch (error) {
	      internalReject(state, error);
	    }
	  };
	
	  PromisePrototype = PromiseConstructor.prototype;
	
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  Internal = function Promise(executor) {
	    setInternalState(this, {
	      type: PROMISE,
	      done: false,
	      notified: false,
	      parent: false,
	      reactions: new Queue(),
	      rejection: false,
	      state: PENDING,
	      value: null
	    });
	  };
	
	  // `Promise.prototype.then` method
	  // https://tc39.es/ecma262/#sec-promise.prototype.then
	  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
	    var state = getInternalPromiseState(this);
	    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
	    state.parent = true;
	    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
	    reaction.fail = isCallable(onRejected) && onRejected;
	    reaction.domain = IS_NODE ? process.domain : undefined;
	    if (state.state === PENDING) state.reactions.add(reaction);
	    else microtask(function () {
	      callReaction(reaction, state);
	    });
	    return reaction.promise;
	  });
	
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    var state = getInternalPromiseState(promise);
	    this.promise = promise;
	    this.resolve = bind(internalResolve, state);
	    this.reject = bind(internalReject, state);
	  };
	
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === PromiseConstructor || C === PromiseWrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	
	  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
	    nativeThen = NativePromisePrototype.then;
	
	    if (!NATIVE_PROMISE_SUBCLASSING) {
	      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
	      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
	        var that = this;
	        return new PromiseConstructor(function (resolve, reject) {
	          call(nativeThen, that, resolve, reject);
	        }).then(onFulfilled, onRejected);
	      // https://github.com/zloirock/core-js/issues/640
	      }, { unsafe: true });
	    }
	
	    // make `.constructor === Promise` work for native promise-based APIs
	    try {
	      delete NativePromisePrototype.constructor;
	    } catch (error) { /* empty */ }
	
	    // make `instanceof Promise` work for native promise-based APIs
	    if (setPrototypeOf) {
	      setPrototypeOf(NativePromisePrototype, PromisePrototype);
	    }
	  }
	}
	
	$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
	  Promise: PromiseConstructor
	});
	
	setToStringTag(PromiseConstructor, PROMISE, false, true);
	setSpecies(PROMISE);


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var IS_PURE = __webpack_require__(43);
	var NativePromiseConstructor = __webpack_require__(187);
	var fails = __webpack_require__(6);
	var getBuiltIn = __webpack_require__(33);
	var isCallable = __webpack_require__(28);
	var speciesConstructor = __webpack_require__(191);
	var promiseResolve = __webpack_require__(683);
	var defineBuiltIn = __webpack_require__(40);
	
	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
	
	// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
	var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
	  // eslint-disable-next-line unicorn/no-thenable -- required for testing
	  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
	});
	
	// `Promise.prototype.finally` method
	// https://tc39.es/ecma262/#sec-promise.prototype.finally
	$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
	  'finally': function (onFinally) {
	    var C = speciesConstructor(this, getBuiltIn('Promise'));
	    var isFunction = isCallable(onFinally);
	    return this.then(
	      isFunction ? function (x) {
	        return promiseResolve(C, onFinally()).then(function () { return x; });
	      } : onFinally,
	      isFunction ? function (e) {
	        return promiseResolve(C, onFinally()).then(function () { throw e; });
	      } : onFinally
	    );
	  }
	});
	
	// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
	if (!IS_PURE && isCallable(NativePromiseConstructor)) {
	  var method = getBuiltIn('Promise').prototype['finally'];
	  if (NativePromisePrototype['finally'] !== method) {
	    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
	  }
	}


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1381);
	__webpack_require__(1378);
	__webpack_require__(1380);
	__webpack_require__(1384);
	__webpack_require__(1385);
	__webpack_require__(1386);


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var aCallable = __webpack_require__(39);
	var newPromiseCapabilityModule = __webpack_require__(132);
	var perform = __webpack_require__(237);
	var iterate = __webpack_require__(83);
	var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(291);
	
	// `Promise.race` method
	// https://tc39.es/ecma262/#sec-promise.race
	$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule.f(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      var $promiseResolve = aCallable(C.resolve);
	      iterate(iterable, function (promise) {
	        call($promiseResolve, C, promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var newPromiseCapabilityModule = __webpack_require__(132);
	var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(238).CONSTRUCTOR;
	
	// `Promise.reject` method
	// https://tc39.es/ecma262/#sec-promise.reject
	$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
	  reject: function reject(r) {
	    var capability = newPromiseCapabilityModule.f(this);
	    var capabilityReject = capability.reject;
	    capabilityReject(r);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var IS_PURE = __webpack_require__(43);
	var NativePromiseConstructor = __webpack_require__(187);
	var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(238).CONSTRUCTOR;
	var promiseResolve = __webpack_require__(683);
	
	var PromiseConstructorWrapper = getBuiltIn('Promise');
	var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;
	
	// `Promise.resolve` method
	// https://tc39.es/ecma262/#sec-promise.resolve
	$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
	  resolve: function resolve(x) {
	    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
	  }
	});


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var newPromiseCapabilityModule = __webpack_require__(132);
	
	// `Promise.withResolvers` method
	// https://github.com/tc39/proposal-promise-with-resolvers
	$({ target: 'Promise', stat: true }, {
	  withResolvers: function withResolvers() {
	    var promiseCapability = newPromiseCapabilityModule.f(this);
	    return {
	      promise: promiseCapability.promise,
	      resolve: promiseCapability.resolve,
	      reject: promiseCapability.reject
	    };
	  }
	});


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var functionApply = __webpack_require__(90);
	var aCallable = __webpack_require__(39);
	var anObject = __webpack_require__(20);
	var fails = __webpack_require__(6);
	
	// MS Edge argumentsList argument is optional
	var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
	  // eslint-disable-next-line es/no-reflect -- required for testing
	  Reflect.apply(function () { /* empty */ });
	});
	
	// `Reflect.apply` method
	// https://tc39.es/ecma262/#sec-reflect.apply
	$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
	  apply: function apply(target, thisArgument, argumentsList) {
	    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
	  }
	});


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var apply = __webpack_require__(90);
	var bind = __webpack_require__(661);
	var aConstructor = __webpack_require__(393);
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(25);
	var create = __webpack_require__(73);
	var fails = __webpack_require__(6);
	
	var nativeConstruct = getBuiltIn('Reflect', 'construct');
	var ObjectPrototype = Object.prototype;
	var push = [].push;
	
	// `Reflect.construct` method
	// https://tc39.es/ecma262/#sec-reflect.construct
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	
	var ARGS_BUG = !fails(function () {
	  nativeConstruct(function () { /* empty */ });
	});
	
	var FORCED = NEW_TARGET_BUG || ARGS_BUG;
	
	$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
	  construct: function construct(Target, args /* , newTarget */) {
	    aConstructor(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
	    if (Target === newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      apply(push, $args, args);
	      return new (apply(bind, Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : ObjectPrototype);
	    var result = apply(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var anObject = __webpack_require__(20);
	var toPropertyKey = __webpack_require__(133);
	var definePropertyModule = __webpack_require__(42);
	var fails = __webpack_require__(6);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	var ERROR_INSTEAD_OF_FALSE = fails(function () {
	  // eslint-disable-next-line es/no-reflect -- required for testing
	  Reflect.defineProperty(definePropertyModule.f({}, 1, { value: 1 }), 1, { value: 2 });
	});
	
	// `Reflect.defineProperty` method
	// https://tc39.es/ecma262/#sec-reflect.defineproperty
	$({ target: 'Reflect', stat: true, forced: ERROR_INSTEAD_OF_FALSE, sham: !DESCRIPTORS }, {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    var key = toPropertyKey(propertyKey);
	    anObject(attributes);
	    try {
	      definePropertyModule.f(target, key, attributes);
	      return true;
	    } catch (error) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var anObject = __webpack_require__(20);
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	
	// `Reflect.deleteProperty` method
	// https://tc39.es/ecma262/#sec-reflect.deleteproperty
	$({ target: 'Reflect', stat: true }, {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
	    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var anObject = __webpack_require__(20);
	var getOwnPropertyDescriptorModule = __webpack_require__(59);
	
	// `Reflect.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
	$({ target: 'Reflect', stat: true, sham: !DESCRIPTORS }, {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var anObject = __webpack_require__(20);
	var objectGetPrototypeOf = __webpack_require__(84);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(400);
	
	// `Reflect.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-reflect.getprototypeof
	$({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return objectGetPrototypeOf(anObject(target));
	  }
	});


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var isObject = __webpack_require__(25);
	var anObject = __webpack_require__(20);
	var isDataDescriptor = __webpack_require__(668);
	var getOwnPropertyDescriptorModule = __webpack_require__(59);
	var getPrototypeOf = __webpack_require__(84);
	
	// `Reflect.get` method
	// https://tc39.es/ecma262/#sec-reflect.get
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var descriptor, prototype;
	  if (anObject(target) === receiver) return target[propertyKey];
	  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
	  if (descriptor) return isDataDescriptor(descriptor)
	    ? descriptor.value
	    : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
	  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
	}
	
	$({ target: 'Reflect', stat: true }, {
	  get: get
	});


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	
	// `Reflect.has` method
	// https://tc39.es/ecma262/#sec-reflect.has
	$({ target: 'Reflect', stat: true }, {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var anObject = __webpack_require__(20);
	var $isExtensible = __webpack_require__(415);
	
	// `Reflect.isExtensible` method
	// https://tc39.es/ecma262/#sec-reflect.isextensible
	$({ target: 'Reflect', stat: true }, {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible(target);
	  }
	});


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var ownKeys = __webpack_require__(416);
	
	// `Reflect.ownKeys` method
	// https://tc39.es/ecma262/#sec-reflect.ownkeys
	$({ target: 'Reflect', stat: true }, {
	  ownKeys: ownKeys
	});


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var anObject = __webpack_require__(20);
	var FREEZING = __webpack_require__(183);
	
	// `Reflect.preventExtensions` method
	// https://tc39.es/ecma262/#sec-reflect.preventextensions
	$({ target: 'Reflect', stat: true, sham: !FREEZING }, {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
	      if (objectPreventExtensions) objectPreventExtensions(target);
	      return true;
	    } catch (error) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var anObject = __webpack_require__(20);
	var aPossiblePrototype = __webpack_require__(637);
	var objectSetPrototypeOf = __webpack_require__(100);
	
	// `Reflect.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-reflect.setprototypeof
	if (objectSetPrototypeOf) $({ target: 'Reflect', stat: true }, {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    anObject(target);
	    aPossiblePrototype(proto);
	    try {
	      objectSetPrototypeOf(target, proto);
	      return true;
	    } catch (error) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(25);
	var isDataDescriptor = __webpack_require__(668);
	var fails = __webpack_require__(6);
	var definePropertyModule = __webpack_require__(42);
	var getOwnPropertyDescriptorModule = __webpack_require__(59);
	var getPrototypeOf = __webpack_require__(84);
	var createPropertyDescriptor = __webpack_require__(82);
	
	// `Reflect.set` method
	// https://tc39.es/ecma262/#sec-reflect.set
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
	  var existingDescriptor, prototype, setter;
	  if (!ownDescriptor) {
	    if (isObject(prototype = getPrototypeOf(target))) {
	      return set(prototype, propertyKey, V, receiver);
	    }
	    ownDescriptor = createPropertyDescriptor(0);
	  }
	  if (isDataDescriptor(ownDescriptor)) {
	    if (ownDescriptor.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      definePropertyModule.f(receiver, propertyKey, existingDescriptor);
	    } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
	  } else {
	    setter = ownDescriptor.set;
	    if (setter === undefined) return false;
	    call(setter, receiver, V);
	  } return true;
	}
	
	// MS Edge 17-18 Reflect.set allows setting the property to object
	// with non-writable property on the prototype
	var MS_EDGE_BUG = fails(function () {
	  var Constructor = function () { /* empty */ };
	  var object = definePropertyModule.f(new Constructor(), 'a', { configurable: true });
	  // eslint-disable-next-line es/no-reflect -- required for testing
	  return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
	});
	
	$({ target: 'Reflect', stat: true, forced: MS_EDGE_BUG }, {
	  set: set
	});


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var setToStringTag = __webpack_require__(65);
	
	$({ global: true }, { Reflect: {} });
	
	// Reflect[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
	setToStringTag(globalThis.Reflect, 'Reflect', true);


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(8);
	var isForced = __webpack_require__(233);
	var inheritIfRequired = __webpack_require__(148);
	var createNonEnumerableProperty = __webpack_require__(58);
	var create = __webpack_require__(73);
	var getOwnPropertyNames = __webpack_require__(152).f;
	var isPrototypeOf = __webpack_require__(74);
	var isRegExp = __webpack_require__(285);
	var toString = __webpack_require__(18);
	var getRegExpFlags = __webpack_require__(240);
	var stickyHelpers = __webpack_require__(292);
	var proxyAccessor = __webpack_require__(684);
	var defineBuiltIn = __webpack_require__(40);
	var fails = __webpack_require__(6);
	var hasOwn = __webpack_require__(29);
	var enforceInternalState = __webpack_require__(49).enforce;
	var setSpecies = __webpack_require__(189);
	var wellKnownSymbol = __webpack_require__(27);
	var UNSUPPORTED_DOT_ALL = __webpack_require__(420);
	var UNSUPPORTED_NCG = __webpack_require__(686);
	
	var MATCH = wellKnownSymbol('match');
	var NativeRegExp = globalThis.RegExp;
	var RegExpPrototype = NativeRegExp.prototype;
	var SyntaxError = globalThis.SyntaxError;
	var exec = uncurryThis(RegExpPrototype.exec);
	var charAt = uncurryThis(''.charAt);
	var replace = uncurryThis(''.replace);
	var stringIndexOf = uncurryThis(''.indexOf);
	var stringSlice = uncurryThis(''.slice);
	// TODO: Use only proper RegExpIdentifierName
	var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
	var re1 = /a/g;
	var re2 = /a/g;
	
	// "new" should create a new object, old webkit bug
	var CORRECT_NEW = new NativeRegExp(re1) !== re1;
	
	var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
	var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
	
	var BASE_FORCED = DESCRIPTORS &&
	  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
	    re2[MATCH] = false;
	    // RegExp constructor can alter flags and IsRegExp works correct with @@match
	    // eslint-disable-next-line sonar/inconsistent-function-call -- required for testing
	    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
	  }));
	
	var handleDotAll = function (string) {
	  var length = string.length;
	  var index = 0;
	  var result = '';
	  var brackets = false;
	  var chr;
	  for (; index <= length; index++) {
	    chr = charAt(string, index);
	    if (chr === '\\') {
	      result += chr + charAt(string, ++index);
	      continue;
	    }
	    if (!brackets && chr === '.') {
	      result += '[\\s\\S]';
	    } else {
	      if (chr === '[') {
	        brackets = true;
	      } else if (chr === ']') {
	        brackets = false;
	      } result += chr;
	    }
	  } return result;
	};
	
	var handleNCG = function (string) {
	  var length = string.length;
	  var index = 0;
	  var result = '';
	  var named = [];
	  var names = create(null);
	  var brackets = false;
	  var ncg = false;
	  var groupid = 0;
	  var groupname = '';
	  var chr;
	  for (; index <= length; index++) {
	    chr = charAt(string, index);
	    if (chr === '\\') {
	      chr += charAt(string, ++index);
	    } else if (chr === ']') {
	      brackets = false;
	    } else if (!brackets) switch (true) {
	      case chr === '[':
	        brackets = true;
	        break;
	      case chr === '(':
	        result += chr;
	        // ignore non-capturing groups
	        if (stringSlice(string, index + 1, index + 3) === '?:') {
	          continue;
	        }
	        if (exec(IS_NCG, stringSlice(string, index + 1))) {
	          index += 2;
	          ncg = true;
	        }
	        groupid++;
	        continue;
	      case chr === '>' && ncg:
	        if (groupname === '' || hasOwn(names, groupname)) {
	          throw new SyntaxError('Invalid capture group name');
	        }
	        names[groupname] = true;
	        named[named.length] = [groupname, groupid];
	        ncg = false;
	        groupname = '';
	        continue;
	    }
	    if (ncg) groupname += chr;
	    else result += chr;
	  } return [result, named];
	};
	
	// `RegExp` constructor
	// https://tc39.es/ecma262/#sec-regexp-constructor
	if (isForced('RegExp', BASE_FORCED)) {
	  var RegExpWrapper = function RegExp(pattern, flags) {
	    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
	    var patternIsRegExp = isRegExp(pattern);
	    var flagsAreUndefined = flags === undefined;
	    var groups = [];
	    var rawPattern = pattern;
	    var rawFlags, dotAll, sticky, handled, result, state;
	
	    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
	      return pattern;
	    }
	
	    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
	      pattern = pattern.source;
	      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
	    }
	
	    pattern = pattern === undefined ? '' : toString(pattern);
	    flags = flags === undefined ? '' : toString(flags);
	    rawPattern = pattern;
	
	    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
	      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
	      if (dotAll) flags = replace(flags, /s/g, '');
	    }
	
	    rawFlags = flags;
	
	    if (MISSED_STICKY && 'sticky' in re1) {
	      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
	      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
	    }
	
	    if (UNSUPPORTED_NCG) {
	      handled = handleNCG(pattern);
	      pattern = handled[0];
	      groups = handled[1];
	    }
	
	    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
	
	    if (dotAll || sticky || groups.length) {
	      state = enforceInternalState(result);
	      if (dotAll) {
	        state.dotAll = true;
	        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
	      }
	      if (sticky) state.sticky = true;
	      if (groups.length) state.groups = groups;
	    }
	
	    if (pattern !== rawPattern) try {
	      // fails in old engines, but we have no alternatives for unsupported regex syntax
	      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
	    } catch (error) { /* empty */ }
	
	    return result;
	  };
	
	  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
	    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
	  }
	
	  RegExpPrototype.constructor = RegExpWrapper;
	  RegExpWrapper.prototype = RegExpPrototype;
	  defineBuiltIn(globalThis, 'RegExp', RegExpWrapper, { constructor: true });
	}
	
	// https://tc39.es/ecma262/#sec-get-regexp-@@species
	setSpecies('RegExp');


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var UNSUPPORTED_DOT_ALL = __webpack_require__(420);
	var classof = __webpack_require__(53);
	var defineBuiltInAccessor = __webpack_require__(50);
	var getInternalState = __webpack_require__(49).get;
	
	var RegExpPrototype = RegExp.prototype;
	var $TypeError = TypeError;
	
	// `RegExp.prototype.dotAll` getter
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
	if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
	  defineBuiltInAccessor(RegExpPrototype, 'dotAll', {
	    configurable: true,
	    get: function dotAll() {
	      if (this === RegExpPrototype) return;
	      // We can't use InternalStateModule.getterFor because
	      // we don't add metadata for regexps created by a literal.
	      if (classof(this) === 'RegExp') {
	        return !!getInternalState(this).dotAll;
	      }
	      throw new $TypeError('Incompatible receiver, RegExp required');
	    }
	  });
	}


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var DESCRIPTORS = __webpack_require__(14);
	var defineBuiltInAccessor = __webpack_require__(50);
	var regExpFlags = __webpack_require__(419);
	var fails = __webpack_require__(6);
	
	// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
	var RegExp = globalThis.RegExp;
	var RegExpPrototype = RegExp.prototype;
	
	var FORCED = DESCRIPTORS && fails(function () {
	  var INDICES_SUPPORT = true;
	  try {
	    RegExp('.', 'd');
	  } catch (error) {
	    INDICES_SUPPORT = false;
	  }
	
	  var O = {};
	  // modern V8 bug
	  var calls = '';
	  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
	
	  var addGetter = function (key, chr) {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty(O, key, { get: function () {
	      calls += chr;
	      return true;
	    } });
	  };
	
	  var pairs = {
	    dotAll: 's',
	    global: 'g',
	    ignoreCase: 'i',
	    multiline: 'm',
	    sticky: 'y'
	  };
	
	  if (INDICES_SUPPORT) pairs.hasIndices = 'd';
	
	  for (var key in pairs) addGetter(key, pairs[key]);
	
	  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	  var result = Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call(O);
	
	  return result !== expected || calls !== expected;
	});
	
	// `RegExp.prototype.flags` getter
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
	if (FORCED) defineBuiltInAccessor(RegExpPrototype, 'flags', {
	  configurable: true,
	  get: regExpFlags
	});


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var MISSED_STICKY = __webpack_require__(292).MISSED_STICKY;
	var classof = __webpack_require__(53);
	var defineBuiltInAccessor = __webpack_require__(50);
	var getInternalState = __webpack_require__(49).get;
	
	var RegExpPrototype = RegExp.prototype;
	var $TypeError = TypeError;
	
	// `RegExp.prototype.sticky` getter
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
	if (DESCRIPTORS && MISSED_STICKY) {
	  defineBuiltInAccessor(RegExpPrototype, 'sticky', {
	    configurable: true,
	    get: function sticky() {
	      if (this === RegExpPrototype) return;
	      // We can't use InternalStateModule.getterFor because
	      // we don't add metadata for regexps created by a literal.
	      if (classof(this) === 'RegExp') {
	        return !!getInternalState(this).sticky;
	      }
	      throw new $TypeError('Incompatible receiver, RegExp required');
	    }
	  });
	}


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4` since it's moved to entry points
	__webpack_require__(431);
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var isCallable = __webpack_require__(28);
	var anObject = __webpack_require__(20);
	var toString = __webpack_require__(18);
	
	var DELEGATES_TO_EXEC = function () {
	  var execCalled = false;
	  var re = /[ac]/;
	  re.exec = function () {
	    execCalled = true;
	    return /./.exec.apply(this, arguments);
	  };
	  return re.test('abc') === true && execCalled;
	}();
	
	var nativeTest = /./.test;
	
	// `RegExp.prototype.test` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.test
	$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
	  test: function (S) {
	    var R = anObject(this);
	    var string = toString(S);
	    var exec = R.exec;
	    if (!isCallable(exec)) return call(nativeTest, R, string);
	    var result = call(exec, R, string);
	    if (result === null) return false;
	    anObject(result);
	    return true;
	  }
	});


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var PROPER_FUNCTION_NAME = __webpack_require__(184).PROPER;
	var defineBuiltIn = __webpack_require__(40);
	var anObject = __webpack_require__(20);
	var $toString = __webpack_require__(18);
	var fails = __webpack_require__(6);
	var getRegExpFlags = __webpack_require__(240);
	
	var TO_STRING = 'toString';
	var RegExpPrototype = RegExp.prototype;
	var nativeToString = RegExpPrototype[TO_STRING];
	
	var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
	// FF44- RegExp#toString has a wrong name
	var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;
	
	// `RegExp.prototype.toString` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
	if (NOT_GENERIC || INCORRECT_NAME) {
	  defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
	    var R = anObject(this);
	    var pattern = $toString(R.source);
	    var flags = $toString(getRegExpFlags(R));
	    return '/' + pattern + '/' + flags;
	  }, { unsafe: true });
	}


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var collection = __webpack_require__(278);
	var collectionStrong = __webpack_require__(648);
	
	// `Set` constructor
	// https://tc39.es/ecma262/#sec-set-objects
	collection('Set', function (init) {
	  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var difference = __webpack_require__(1237);
	var setMethodAcceptSetLike = __webpack_require__(153);
	
	// `Set.prototype.difference` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('difference') }, {
	  difference: difference
	});


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var intersection = __webpack_require__(1238);
	var setMethodAcceptSetLike = __webpack_require__(153);
	
	var INCORRECT = !setMethodAcceptSetLike('intersection') || fails(function () {
	  // eslint-disable-next-line es/no-array-from, es/no-set -- testing
	  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
	});
	
	// `Set.prototype.intersection` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
	  intersection: intersection
	});


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isDisjointFrom = __webpack_require__(1239);
	var setMethodAcceptSetLike = __webpack_require__(153);
	
	// `Set.prototype.isDisjointFrom` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isDisjointFrom') }, {
	  isDisjointFrom: isDisjointFrom
	});


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isSubsetOf = __webpack_require__(1240);
	var setMethodAcceptSetLike = __webpack_require__(153);
	
	// `Set.prototype.isSubsetOf` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isSubsetOf') }, {
	  isSubsetOf: isSubsetOf
	});


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var isSupersetOf = __webpack_require__(1241);
	var setMethodAcceptSetLike = __webpack_require__(153);
	
	// `Set.prototype.isSupersetOf` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isSupersetOf') }, {
	  isSupersetOf: isSupersetOf
	});


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1408);


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var symmetricDifference = __webpack_require__(1242);
	var setMethodAcceptSetLike = __webpack_require__(153);
	
	// `Set.prototype.symmetricDifference` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('symmetricDifference') }, {
	  symmetricDifference: symmetricDifference
	});


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var union = __webpack_require__(1243);
	var setMethodAcceptSetLike = __webpack_require__(153);
	
	// `Set.prototype.union` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('union') }, {
	  union: union
	});


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.anchor` method
	// https://tc39.es/ecma262/#sec-string.prototype.anchor
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
	  anchor: function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  }
	});


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(41);
	var toIntegerOrInfinity = __webpack_require__(44);
	var toString = __webpack_require__(18);
	var fails = __webpack_require__(6);
	
	var charAt = uncurryThis(''.charAt);
	
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-string-prototype-at -- safe
	  return '𠮷'.at(-2) !== '\uD842';
	});
	
	// `String.prototype.at` method
	// https://tc39.es/ecma262/#sec-string.prototype.at
	$({ target: 'String', proto: true, forced: FORCED }, {
	  at: function at(index) {
	    var S = toString(requireObjectCoercible(this));
	    var len = S.length;
	    var relativeIndex = toIntegerOrInfinity(index);
	    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
	    return (k < 0 || k >= len) ? undefined : charAt(S, k);
	  }
	});


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.big` method
	// https://tc39.es/ecma262/#sec-string.prototype.big
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('big') }, {
	  big: function big() {
	    return createHTML(this, 'big', '', '');
	  }
	});


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.blink` method
	// https://tc39.es/ecma262/#sec-string.prototype.blink
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('blink') }, {
	  blink: function blink() {
	    return createHTML(this, 'blink', '', '');
	  }
	});


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.bold` method
	// https://tc39.es/ecma262/#sec-string.prototype.bold
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
	  bold: function bold() {
	    return createHTML(this, 'b', '', '');
	  }
	});


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var codeAt = __webpack_require__(294).codeAt;
	
	// `String.prototype.codePointAt` method
	// https://tc39.es/ecma262/#sec-string.prototype.codepointat
	$({ target: 'String', proto: true }, {
	  codePointAt: function codePointAt(pos) {
	    return codeAt(this, pos);
	  }
	});


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(130);
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	var toLength = __webpack_require__(76);
	var toString = __webpack_require__(18);
	var notARegExp = __webpack_require__(412);
	var requireObjectCoercible = __webpack_require__(41);
	var correctIsRegExpLogic = __webpack_require__(399);
	var IS_PURE = __webpack_require__(43);
	
	var slice = uncurryThis(''.slice);
	var min = Math.min;
	
	var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
	// https://github.com/zloirock/core-js/pull/702
	var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
	  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
	  return descriptor && !descriptor.writable;
	}();
	
	// `String.prototype.endsWith` method
	// https://tc39.es/ecma262/#sec-string.prototype.endswith
	$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = toString(requireObjectCoercible(this));
	    notARegExp(searchString);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = that.length;
	    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
	    var search = toString(searchString);
	    return slice(that, end - search.length, end) === search;
	  }
	});


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.fixed` method
	// https://tc39.es/ecma262/#sec-string.prototype.fixed
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
	  fixed: function fixed() {
	    return createHTML(this, 'tt', '', '');
	  }
	});


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.fontcolor` method
	// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontcolor') }, {
	  fontcolor: function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  }
	});


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.fontsize` method
	// https://tc39.es/ecma262/#sec-string.prototype.fontsize
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontsize') }, {
	  fontsize: function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  }
	});


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var notARegExp = __webpack_require__(412);
	var requireObjectCoercible = __webpack_require__(41);
	var toString = __webpack_require__(18);
	var correctIsRegExpLogic = __webpack_require__(399);
	
	var stringIndexOf = uncurryThis(''.indexOf);
	
	// `String.prototype.includes` method
	// https://tc39.es/ecma262/#sec-string.prototype.includes
	$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~stringIndexOf(
	      toString(requireObjectCoercible(this)),
	      toString(notARegExp(searchString)),
	      arguments.length > 1 ? arguments[1] : undefined
	    );
	  }
	});


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(41);
	var toString = __webpack_require__(18);
	
	var charCodeAt = uncurryThis(''.charCodeAt);
	
	// `String.prototype.isWellFormed` method
	// https://github.com/tc39/proposal-is-usv-string
	$({ target: 'String', proto: true }, {
	  isWellFormed: function isWellFormed() {
	    var S = toString(requireObjectCoercible(this));
	    var length = S.length;
	    for (var i = 0; i < length; i++) {
	      var charCode = charCodeAt(S, i);
	      // single UTF-16 code unit
	      if ((charCode & 0xF800) !== 0xD800) continue;
	      // unpaired surrogate
	      if (charCode >= 0xDC00 || ++i >= length || (charCodeAt(S, i) & 0xFC00) !== 0xDC00) return false;
	    } return true;
	  }
	});


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.italics` method
	// https://tc39.es/ecma262/#sec-string.prototype.italics
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
	  italics: function italics() {
	    return createHTML(this, 'i', '', '');
	  }
	});


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.link` method
	// https://tc39.es/ecma262/#sec-string.prototype.link
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
	  link: function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  }
	});


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-string-prototype-matchall -- safe */
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(130);
	var createIteratorConstructor = __webpack_require__(408);
	var createIterResultObject = __webpack_require__(228);
	var requireObjectCoercible = __webpack_require__(41);
	var toLength = __webpack_require__(76);
	var toString = __webpack_require__(18);
	var anObject = __webpack_require__(20);
	var isNullOrUndefined = __webpack_require__(64);
	var classof = __webpack_require__(53);
	var isRegExp = __webpack_require__(285);
	var getRegExpFlags = __webpack_require__(240);
	var getMethod = __webpack_require__(116);
	var defineBuiltIn = __webpack_require__(40);
	var fails = __webpack_require__(6);
	var wellKnownSymbol = __webpack_require__(27);
	var speciesConstructor = __webpack_require__(191);
	var advanceStringIndex = __webpack_require__(272);
	var regExpExec = __webpack_require__(239);
	var InternalStateModule = __webpack_require__(49);
	var IS_PURE = __webpack_require__(43);
	
	var MATCH_ALL = wellKnownSymbol('matchAll');
	var REGEXP_STRING = 'RegExp String';
	var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
	var RegExpPrototype = RegExp.prototype;
	var $TypeError = TypeError;
	var stringIndexOf = uncurryThis(''.indexOf);
	var nativeMatchAll = uncurryThis(''.matchAll);
	
	var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
	  nativeMatchAll('a', /./);
	});
	
	var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
	  setInternalState(this, {
	    type: REGEXP_STRING_ITERATOR,
	    regexp: regexp,
	    string: string,
	    global: $global,
	    unicode: fullUnicode,
	    done: false
	  });
	}, REGEXP_STRING, function next() {
	  var state = getInternalState(this);
	  if (state.done) return createIterResultObject(undefined, true);
	  var R = state.regexp;
	  var S = state.string;
	  var match = regExpExec(R, S);
	  if (match === null) {
	    state.done = true;
	    return createIterResultObject(undefined, true);
	  }
	  if (state.global) {
	    if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
	    return createIterResultObject(match, false);
	  }
	  state.done = true;
	  return createIterResultObject(match, false);
	});
	
	var $matchAll = function (string) {
	  var R = anObject(this);
	  var S = toString(string);
	  var C = speciesConstructor(R, RegExp);
	  var flags = toString(getRegExpFlags(R));
	  var matcher, $global, fullUnicode;
	  matcher = new C(C === RegExp ? R.source : R, flags);
	  $global = !!~stringIndexOf(flags, 'g');
	  fullUnicode = !!~stringIndexOf(flags, 'u');
	  matcher.lastIndex = toLength(R.lastIndex);
	  return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
	};
	
	// `String.prototype.matchAll` method
	// https://tc39.es/ecma262/#sec-string.prototype.matchall
	$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
	  matchAll: function matchAll(regexp) {
	    var O = requireObjectCoercible(this);
	    var flags, S, matcher, rx;
	    if (!isNullOrUndefined(regexp)) {
	      if (isRegExp(regexp)) {
	        flags = toString(requireObjectCoercible(getRegExpFlags(regexp)));
	        if (!~stringIndexOf(flags, 'g')) throw new $TypeError('`.matchAll` does not allow non-global regexes');
	      }
	      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
	      matcher = getMethod(regexp, MATCH_ALL);
	      if (matcher === undefined && IS_PURE && classof(regexp) === 'RegExp') matcher = $matchAll;
	      if (matcher) return call(matcher, regexp, O);
	    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
	    S = toString(O);
	    rx = new RegExp(regexp, 'g');
	    return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
	  }
	});
	
	IS_PURE || MATCH_ALL in RegExpPrototype || defineBuiltIn(RegExpPrototype, MATCH_ALL, $matchAll);


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(282);
	var anObject = __webpack_require__(20);
	var isNullOrUndefined = __webpack_require__(64);
	var toLength = __webpack_require__(76);
	var toString = __webpack_require__(18);
	var requireObjectCoercible = __webpack_require__(41);
	var getMethod = __webpack_require__(116);
	var advanceStringIndex = __webpack_require__(272);
	var regExpExec = __webpack_require__(239);
	
	// @@match logic
	fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.es/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = requireObjectCoercible(this);
	      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
	      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
	    function (string) {
	      var rx = anObject(this);
	      var S = toString(string);
	      var res = maybeCallNative(nativeMatch, rx, S);
	
	      if (res.done) return res.value;
	
	      if (!rx.global) return regExpExec(rx, S);
	
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = toString(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $padEnd = __webpack_require__(424).end;
	var WEBKIT_BUG = __webpack_require__(689);
	
	// `String.prototype.padEnd` method
	// https://tc39.es/ecma262/#sec-string.prototype.padend
	$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $padStart = __webpack_require__(424).start;
	var WEBKIT_BUG = __webpack_require__(689);
	
	// `String.prototype.padStart` method
	// https://tc39.es/ecma262/#sec-string.prototype.padstart
	$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var toIndexedObject = __webpack_require__(51);
	var toObject = __webpack_require__(31);
	var toString = __webpack_require__(18);
	var lengthOfArrayLike = __webpack_require__(34);
	
	var push = uncurryThis([].push);
	var join = uncurryThis([].join);
	
	// `String.raw` method
	// https://tc39.es/ecma262/#sec-string.raw
	$({ target: 'String', stat: true }, {
	  raw: function raw(template) {
	    var rawTemplate = toIndexedObject(toObject(template).raw);
	    var literalSegments = lengthOfArrayLike(rawTemplate);
	    if (!literalSegments) return '';
	    var argumentsLength = arguments.length;
	    var elements = [];
	    var i = 0;
	    while (true) {
	      push(elements, toString(rawTemplate[i++]));
	      if (i === literalSegments) return join(elements, '');
	      if (i < argumentsLength) push(elements, toString(arguments[i]));
	    }
	  }
	});


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var repeat = __webpack_require__(295);
	
	// `String.prototype.repeat` method
	// https://tc39.es/ecma262/#sec-string.prototype.repeat
	$({ target: 'String', proto: true }, {
	  repeat: repeat
	});


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(41);
	var isCallable = __webpack_require__(28);
	var isNullOrUndefined = __webpack_require__(64);
	var isRegExp = __webpack_require__(285);
	var toString = __webpack_require__(18);
	var getMethod = __webpack_require__(116);
	var getRegExpFlags = __webpack_require__(240);
	var getSubstitution = __webpack_require__(663);
	var wellKnownSymbol = __webpack_require__(27);
	var IS_PURE = __webpack_require__(43);
	
	var REPLACE = wellKnownSymbol('replace');
	var $TypeError = TypeError;
	var indexOf = uncurryThis(''.indexOf);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	var max = Math.max;
	
	// `String.prototype.replaceAll` method
	// https://tc39.es/ecma262/#sec-string.prototype.replaceall
	$({ target: 'String', proto: true }, {
	  replaceAll: function replaceAll(searchValue, replaceValue) {
	    var O = requireObjectCoercible(this);
	    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, position, replacement;
	    var endOfLastMatch = 0;
	    var result = '';
	    if (!isNullOrUndefined(searchValue)) {
	      IS_REG_EXP = isRegExp(searchValue);
	      if (IS_REG_EXP) {
	        flags = toString(requireObjectCoercible(getRegExpFlags(searchValue)));
	        if (!~indexOf(flags, 'g')) throw new $TypeError('`.replaceAll` does not allow non-global regexes');
	      }
	      replacer = getMethod(searchValue, REPLACE);
	      if (replacer) return call(replacer, searchValue, O, replaceValue);
	      if (IS_PURE && IS_REG_EXP) return replace(toString(O), searchValue, replaceValue);
	    }
	    string = toString(O);
	    searchString = toString(searchValue);
	    functionalReplace = isCallable(replaceValue);
	    if (!functionalReplace) replaceValue = toString(replaceValue);
	    searchLength = searchString.length;
	    advanceBy = max(1, searchLength);
	    position = indexOf(string, searchString);
	    while (position !== -1) {
	      replacement = functionalReplace
	        ? toString(replaceValue(searchString, position, string))
	        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
	      result += stringSlice(string, endOfLastMatch, position) + replacement;
	      endOfLastMatch = position + searchLength;
	      position = position + advanceBy > string.length ? -1 : indexOf(string, searchString, position + advanceBy);
	    }
	    if (endOfLastMatch < string.length) {
	      result += stringSlice(string, endOfLastMatch);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var apply = __webpack_require__(90);
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(282);
	var fails = __webpack_require__(6);
	var anObject = __webpack_require__(20);
	var isCallable = __webpack_require__(28);
	var isNullOrUndefined = __webpack_require__(64);
	var toIntegerOrInfinity = __webpack_require__(44);
	var toLength = __webpack_require__(76);
	var toString = __webpack_require__(18);
	var requireObjectCoercible = __webpack_require__(41);
	var advanceStringIndex = __webpack_require__(272);
	var getMethod = __webpack_require__(116);
	var getSubstitution = __webpack_require__(663);
	var regExpExec = __webpack_require__(239);
	var wellKnownSymbol = __webpack_require__(27);
	
	var REPLACE = wellKnownSymbol('replace');
	var max = Math.max;
	var min = Math.min;
	var concat = uncurryThis([].concat);
	var push = uncurryThis([].push);
	var stringIndexOf = uncurryThis(''.indexOf);
	var stringSlice = uncurryThis(''.slice);
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// IE <= 11 replaces $0 with the whole match, as if it was $&
	// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
	var REPLACE_KEEPS_$0 = (function () {
	  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
	  return 'a'.replace(/./, '$0') === '$0';
	})();
	
	// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
	var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
	  if (/./[REPLACE]) {
	    return /./[REPLACE]('a', '$0') === '';
	  }
	  return false;
	})();
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	// @@replace logic
	fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
	  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
	
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.es/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = requireObjectCoercible(this);
	      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
	      return replacer
	        ? call(replacer, searchValue, O, replaceValue)
	        : call(nativeReplace, toString(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
	    function (string, replaceValue) {
	      var rx = anObject(this);
	      var S = toString(string);
	
	      if (
	        typeof replaceValue == 'string' &&
	        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
	        stringIndexOf(replaceValue, '$<') === -1
	      ) {
	        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
	        if (res.done) return res.value;
	      }
	
	      var functionalReplace = isCallable(replaceValue);
	      if (!functionalReplace) replaceValue = toString(replaceValue);
	
	      var global = rx.global;
	      var fullUnicode;
	      if (global) {
	        fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	
	      var results = [];
	      var result;
	      while (true) {
	        result = regExpExec(rx, S);
	        if (result === null) break;
	
	        push(results, result);
	        if (!global) break;
	
	        var matchStr = toString(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	
	        var matched = toString(result[0]);
	        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
	        var captures = [];
	        var replacement;
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = concat([matched], captures, position, S);
	          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
	          replacement = toString(apply(replaceValue, undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	
	      return accumulatedResult + stringSlice(S, nextSourcePosition);
	    }
	  ];
	}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(282);
	var anObject = __webpack_require__(20);
	var isNullOrUndefined = __webpack_require__(64);
	var requireObjectCoercible = __webpack_require__(41);
	var sameValue = __webpack_require__(688);
	var toString = __webpack_require__(18);
	var getMethod = __webpack_require__(116);
	var regExpExec = __webpack_require__(239);
	
	// @@search logic
	fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.es/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = requireObjectCoercible(this);
	      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
	      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
	    function (string) {
	      var rx = anObject(this);
	      var S = toString(string);
	      var res = maybeCallNative(nativeSearch, rx, S);
	
	      if (res.done) return res.value;
	
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.small` method
	// https://tc39.es/ecma262/#sec-string.prototype.small
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
	  small: function small() {
	    return createHTML(this, 'small', '', '');
	  }
	});


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(282);
	var anObject = __webpack_require__(20);
	var isNullOrUndefined = __webpack_require__(64);
	var requireObjectCoercible = __webpack_require__(41);
	var speciesConstructor = __webpack_require__(191);
	var advanceStringIndex = __webpack_require__(272);
	var toLength = __webpack_require__(76);
	var toString = __webpack_require__(18);
	var getMethod = __webpack_require__(116);
	var regExpExec = __webpack_require__(239);
	var stickyHelpers = __webpack_require__(292);
	var fails = __webpack_require__(6);
	
	var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
	var MAX_UINT32 = 0xFFFFFFFF;
	var min = Math.min;
	var push = uncurryThis([].push);
	var stringSlice = uncurryThis(''.slice);
	
	// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	// Weex JS has frozen built-in prototypes, so use try / catch wrapper
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
	});
	
	var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  'test'.split(/(?:)/, -1).length !== 4 ||
	  'ab'.split(/(?:ab)*/).length !== 2 ||
	  '.'.split(/(.?)(.?)/).length !== 4 ||
	  // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
	  '.'.split(/()()/).length > 1 ||
	  ''.split(/.?/).length;
	
	// @@split logic
	fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
	  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
	    return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
	  } : nativeSplit;
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.es/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = requireObjectCoercible(this);
	      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
	      return splitter
	        ? call(splitter, separator, O, limit)
	        : call(internalSplit, toString(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (string, limit) {
	      var rx = anObject(this);
	      var S = toString(string);
	
	      if (!BUGGY) {
	        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
	        if (res.done) return res.value;
	      }
	
	      var C = speciesConstructor(rx, RegExp);
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (UNSUPPORTED_Y ? 'g' : 'y');
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return regExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
	        var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
	        var e;
	        if (
	          z === null ||
	          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          push(A, stringSlice(S, p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            push(A, z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      push(A, stringSlice(S, p));
	      return A;
	    }
	  ];
	}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(130);
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	var toLength = __webpack_require__(76);
	var toString = __webpack_require__(18);
	var notARegExp = __webpack_require__(412);
	var requireObjectCoercible = __webpack_require__(41);
	var correctIsRegExpLogic = __webpack_require__(399);
	var IS_PURE = __webpack_require__(43);
	
	var stringSlice = uncurryThis(''.slice);
	var min = Math.min;
	
	var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
	// https://github.com/zloirock/core-js/pull/702
	var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
	  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
	  return descriptor && !descriptor.writable;
	}();
	
	// `String.prototype.startsWith` method
	// https://tc39.es/ecma262/#sec-string.prototype.startswith
	$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = toString(requireObjectCoercible(this));
	    notARegExp(searchString);
	    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = toString(searchString);
	    return stringSlice(that, index, index + search.length) === search;
	  }
	});


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.strike` method
	// https://tc39.es/ecma262/#sec-string.prototype.strike
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('strike') }, {
	  strike: function strike() {
	    return createHTML(this, 'strike', '', '');
	  }
	});


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.sub` method
	// https://tc39.es/ecma262/#sec-string.prototype.sub
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
	  sub: function sub() {
	    return createHTML(this, 'sub', '', '');
	  }
	});


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(41);
	var toIntegerOrInfinity = __webpack_require__(44);
	var toString = __webpack_require__(18);
	
	var stringSlice = uncurryThis(''.slice);
	var max = Math.max;
	var min = Math.min;
	
	// eslint-disable-next-line unicorn/prefer-string-slice -- required for testing
	var FORCED = !''.substr || 'ab'.substr(-1) !== 'b';
	
	// `String.prototype.substr` method
	// https://tc39.es/ecma262/#sec-string.prototype.substr
	$({ target: 'String', proto: true, forced: FORCED }, {
	  substr: function substr(start, length) {
	    var that = toString(requireObjectCoercible(this));
	    var size = that.length;
	    var intStart = toIntegerOrInfinity(start);
	    var intLength, intEnd;
	    if (intStart === Infinity) intStart = 0;
	    if (intStart < 0) intStart = max(size + intStart, 0);
	    intLength = length === undefined ? size : toIntegerOrInfinity(length);
	    if (intLength <= 0 || intLength === Infinity) return '';
	    intEnd = min(intStart + intLength, size);
	    return intStart >= intEnd ? '' : stringSlice(that, intStart, intEnd);
	  }
	});


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var createHTML = __webpack_require__(72);
	var forcedStringHTMLMethod = __webpack_require__(75);
	
	// `String.prototype.sup` method
	// https://tc39.es/ecma262/#sec-string.prototype.sup
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sup') }, {
	  sup: function sup() {
	    return createHTML(this, 'sup', '', '');
	  }
	});


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(41);
	var toString = __webpack_require__(18);
	var fails = __webpack_require__(6);
	
	var $Array = Array;
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var join = uncurryThis([].join);
	// eslint-disable-next-line es/no-string-prototype-towellformed -- safe
	var $toWellFormed = ''.toWellFormed;
	var REPLACEMENT_CHARACTER = '\uFFFD';
	
	// Safari bug
	var TO_STRING_CONVERSION_BUG = $toWellFormed && fails(function () {
	  return call($toWellFormed, 1) !== '1';
	});
	
	// `String.prototype.toWellFormed` method
	// https://github.com/tc39/proposal-is-usv-string
	$({ target: 'String', proto: true, forced: TO_STRING_CONVERSION_BUG }, {
	  toWellFormed: function toWellFormed() {
	    var S = toString(requireObjectCoercible(this));
	    if (TO_STRING_CONVERSION_BUG) return call($toWellFormed, S);
	    var length = S.length;
	    var result = $Array(length);
	    for (var i = 0; i < length; i++) {
	      var charCode = charCodeAt(S, i);
	      // single UTF-16 code unit
	      if ((charCode & 0xF800) !== 0xD800) result[i] = charAt(S, i);
	      // unpaired surrogate
	      else if (charCode >= 0xDC00 || i + 1 >= length || (charCodeAt(S, i + 1) & 0xFC00) !== 0xDC00) result[i] = REPLACEMENT_CHARACTER;
	      // surrogate pair
	      else {
	        result[i] = charAt(S, i);
	        result[++i] = charAt(S, i);
	      }
	    } return join(result, '');
	  }
	});


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this line from `core-js@4`
	__webpack_require__(1450);
	var $ = __webpack_require__(2);
	var trimEnd = __webpack_require__(690);
	
	// `String.prototype.trimEnd` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimend
	// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
	$({ target: 'String', proto: true, name: 'trimEnd', forced: ''.trimEnd !== trimEnd }, {
	  trimEnd: trimEnd
	});


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var trimStart = __webpack_require__(691);
	
	// `String.prototype.trimLeft` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimleft
	// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
	$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimLeft !== trimStart }, {
	  trimLeft: trimStart
	});


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var trimEnd = __webpack_require__(690);
	
	// `String.prototype.trimRight` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimend
	// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
	$({ target: 'String', proto: true, name: 'trimEnd', forced: ''.trimRight !== trimEnd }, {
	  trimRight: trimEnd
	});


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this line from `core-js@4`
	__webpack_require__(1449);
	var $ = __webpack_require__(2);
	var trimStart = __webpack_require__(691);
	
	// `String.prototype.trimStart` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimstart
	// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
	$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimStart !== trimStart }, {
	  trimStart: trimStart
	});


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var $trim = __webpack_require__(192).trim;
	var forcedStringTrimMethod = __webpack_require__(425);
	
	// `String.prototype.trim` method
	// https://tc39.es/ecma262/#sec-string.prototype.trim
	$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
	  trim: function trim() {
	    return $trim(this);
	  }
	});


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.asyncIterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.asynciterator
	defineWellKnownSymbol('asyncIterator');


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var IS_PURE = __webpack_require__(43);
	var DESCRIPTORS = __webpack_require__(14);
	var NATIVE_SYMBOL = __webpack_require__(193);
	var fails = __webpack_require__(6);
	var hasOwn = __webpack_require__(29);
	var isPrototypeOf = __webpack_require__(74);
	var anObject = __webpack_require__(20);
	var toIndexedObject = __webpack_require__(51);
	var toPropertyKey = __webpack_require__(133);
	var $toString = __webpack_require__(18);
	var createPropertyDescriptor = __webpack_require__(82);
	var nativeObjectCreate = __webpack_require__(73);
	var objectKeys = __webpack_require__(236);
	var getOwnPropertyNamesModule = __webpack_require__(152);
	var getOwnPropertyNamesExternal = __webpack_require__(414);
	var getOwnPropertySymbolsModule = __webpack_require__(288);
	var getOwnPropertyDescriptorModule = __webpack_require__(59);
	var definePropertyModule = __webpack_require__(42);
	var definePropertiesModule = __webpack_require__(413);
	var propertyIsEnumerableModule = __webpack_require__(289);
	var defineBuiltIn = __webpack_require__(40);
	var defineBuiltInAccessor = __webpack_require__(50);
	var shared = __webpack_require__(190);
	var sharedKey = __webpack_require__(293);
	var hiddenKeys = __webpack_require__(232);
	var uid = __webpack_require__(194);
	var wellKnownSymbol = __webpack_require__(27);
	var wrappedWellKnownSymbolModule = __webpack_require__(699);
	var defineWellKnownSymbol = __webpack_require__(66);
	var defineSymbolToPrimitive = __webpack_require__(692);
	var setToStringTag = __webpack_require__(65);
	var InternalStateModule = __webpack_require__(49);
	var $forEach = __webpack_require__(52).forEach;
	
	var HIDDEN = sharedKey('hidden');
	var SYMBOL = 'Symbol';
	var PROTOTYPE = 'prototype';
	
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(SYMBOL);
	
	var ObjectPrototype = Object[PROTOTYPE];
	var $Symbol = globalThis.Symbol;
	var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
	var RangeError = globalThis.RangeError;
	var TypeError = globalThis.TypeError;
	var QObject = globalThis.QObject;
	var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	var nativeDefineProperty = definePropertyModule.f;
	var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
	var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
	var push = uncurryThis([].push);
	
	var AllSymbols = shared('symbols');
	var ObjectPrototypeSymbols = shared('op-symbols');
	var WellKnownSymbolsStore = shared('wks');
	
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var fallbackDefineProperty = function (O, P, Attributes) {
	  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
	  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
	  nativeDefineProperty(O, P, Attributes);
	  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
	    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
	  }
	};
	
	var setSymbolDescriptor = DESCRIPTORS && fails(function () {
	  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
	    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
	  })).a !== 7;
	}) ? fallbackDefineProperty : nativeDefineProperty;
	
	var wrap = function (tag, description) {
	  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
	  setInternalState(symbol, {
	    type: SYMBOL,
	    tag: tag,
	    description: description
	  });
	  if (!DESCRIPTORS) symbol.description = description;
	  return symbol;
	};
	
	var $defineProperty = function defineProperty(O, P, Attributes) {
	  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
	  anObject(O);
	  var key = toPropertyKey(P);
	  anObject(Attributes);
	  if (hasOwn(AllSymbols, key)) {
	    if (!Attributes.enumerable) {
	      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
	      O[HIDDEN][key] = true;
	    } else {
	      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
	      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
	    } return setSymbolDescriptor(O, key, Attributes);
	  } return nativeDefineProperty(O, key, Attributes);
	};
	
	var $defineProperties = function defineProperties(O, Properties) {
	  anObject(O);
	  var properties = toIndexedObject(Properties);
	  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
	  $forEach(keys, function (key) {
	    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
	  });
	  return O;
	};
	
	var $create = function create(O, Properties) {
	  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
	};
	
	var $propertyIsEnumerable = function propertyIsEnumerable(V) {
	  var P = toPropertyKey(V);
	  var enumerable = call(nativePropertyIsEnumerable, this, P);
	  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
	  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
	    ? enumerable : true;
	};
	
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
	  var it = toIndexedObject(O);
	  var key = toPropertyKey(P);
	  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
	  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
	  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
	    descriptor.enumerable = true;
	  }
	  return descriptor;
	};
	
	var $getOwnPropertyNames = function getOwnPropertyNames(O) {
	  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
	  var result = [];
	  $forEach(names, function (key) {
	    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
	  });
	  return result;
	};
	
	var $getOwnPropertySymbols = function (O) {
	  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
	  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
	  var result = [];
	  $forEach(names, function (key) {
	    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
	      push(result, AllSymbols[key]);
	    }
	  });
	  return result;
	};
	
	// `Symbol` constructor
	// https://tc39.es/ecma262/#sec-symbol-constructor
	if (!NATIVE_SYMBOL) {
	  $Symbol = function Symbol() {
	    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
	    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
	    var tag = uid(description);
	    var setter = function (value) {
	      var $this = this === undefined ? globalThis : this;
	      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
	      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
	      var descriptor = createPropertyDescriptor(1, value);
	      try {
	        setSymbolDescriptor($this, tag, descriptor);
	      } catch (error) {
	        if (!(error instanceof RangeError)) throw error;
	        fallbackDefineProperty($this, tag, descriptor);
	      }
	    };
	    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
	    return wrap(tag, description);
	  };
	
	  SymbolPrototype = $Symbol[PROTOTYPE];
	
	  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
	    return getInternalState(this).tag;
	  });
	
	  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
	    return wrap(uid(description), description);
	  });
	
	  propertyIsEnumerableModule.f = $propertyIsEnumerable;
	  definePropertyModule.f = $defineProperty;
	  definePropertiesModule.f = $defineProperties;
	  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
	  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
	  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
	
	  wrappedWellKnownSymbolModule.f = function (name) {
	    return wrap(wellKnownSymbol(name), name);
	  };
	
	  if (DESCRIPTORS) {
	    // https://github.com/tc39/proposal-Symbol-description
	    defineBuiltInAccessor(SymbolPrototype, 'description', {
	      configurable: true,
	      get: function description() {
	        return getInternalState(this).description;
	      }
	    });
	    if (!IS_PURE) {
	      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
	    }
	  }
	}
	
	$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
	  Symbol: $Symbol
	});
	
	$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
	  defineWellKnownSymbol(name);
	});
	
	$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
	  useSetter: function () { USE_SETTER = true; },
	  useSimple: function () { USE_SETTER = false; }
	});
	
	$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
	  // `Object.create` method
	  // https://tc39.es/ecma262/#sec-object.create
	  create: $create,
	  // `Object.defineProperty` method
	  // https://tc39.es/ecma262/#sec-object.defineproperty
	  defineProperty: $defineProperty,
	  // `Object.defineProperties` method
	  // https://tc39.es/ecma262/#sec-object.defineproperties
	  defineProperties: $defineProperties,
	  // `Object.getOwnPropertyDescriptor` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
	});
	
	$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
	  // `Object.getOwnPropertyNames` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertynames
	  getOwnPropertyNames: $getOwnPropertyNames
	});
	
	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive();
	
	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag($Symbol, SYMBOL);
	
	hiddenKeys[HIDDEN] = true;


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	// `Symbol.prototype.description` getter
	// https://tc39.es/ecma262/#sec-symbol.prototype.description
	'use strict';
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(8);
	var hasOwn = __webpack_require__(29);
	var isCallable = __webpack_require__(28);
	var isPrototypeOf = __webpack_require__(74);
	var toString = __webpack_require__(18);
	var defineBuiltInAccessor = __webpack_require__(50);
	var copyConstructorProperties = __webpack_require__(227);
	
	var NativeSymbol = globalThis.Symbol;
	var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
	
	if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
	  // Safari 12 bug
	  NativeSymbol().description !== undefined
	)) {
	  var EmptyStringDescriptionStore = {};
	  // wrap Symbol constructor for correct work with undefined description
	  var SymbolWrapper = function Symbol() {
	    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
	    var result = isPrototypeOf(SymbolPrototype, this)
	      // eslint-disable-next-line sonar/inconsistent-function-call -- ok
	      ? new NativeSymbol(description)
	      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
	      : description === undefined ? NativeSymbol() : NativeSymbol(description);
	    if (description === '') EmptyStringDescriptionStore[result] = true;
	    return result;
	  };
	
	  copyConstructorProperties(SymbolWrapper, NativeSymbol);
	  SymbolWrapper.prototype = SymbolPrototype;
	  SymbolPrototype.constructor = SymbolWrapper;
	
	  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
	  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
	  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
	  var regexp = /^Symbol\((.*)\)[^)]+$/;
	  var replace = uncurryThis(''.replace);
	  var stringSlice = uncurryThis(''.slice);
	
	  defineBuiltInAccessor(SymbolPrototype, 'description', {
	    configurable: true,
	    get: function description() {
	      var symbol = thisSymbolValue(this);
	      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
	      var string = symbolDescriptiveString(symbol);
	      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
	      return desc === '' ? undefined : desc;
	    }
	  });
	
	  $({ global: true, constructor: true, forced: true }, {
	    Symbol: SymbolWrapper
	  });
	}


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var hasOwn = __webpack_require__(29);
	var toString = __webpack_require__(18);
	var shared = __webpack_require__(190);
	var NATIVE_SYMBOL_REGISTRY = __webpack_require__(693);
	
	var StringToSymbolRegistry = shared('string-to-symbol-registry');
	var SymbolToStringRegistry = shared('symbol-to-string-registry');
	
	// `Symbol.for` method
	// https://tc39.es/ecma262/#sec-symbol.for
	$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  'for': function (key) {
	    var string = toString(key);
	    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
	    var symbol = getBuiltIn('Symbol')(string);
	    StringToSymbolRegistry[string] = symbol;
	    SymbolToStringRegistry[symbol] = string;
	    return symbol;
	  }
	});


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.hasInstance` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.hasinstance
	defineWellKnownSymbol('hasInstance');


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.isConcatSpreadable` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
	defineWellKnownSymbol('isConcatSpreadable');


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.iterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.iterator
	defineWellKnownSymbol('iterator');


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1454);
	__webpack_require__(1456);
	__webpack_require__(1461);
	__webpack_require__(701);
	__webpack_require__(1358);


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var hasOwn = __webpack_require__(29);
	var isSymbol = __webpack_require__(150);
	var tryToString = __webpack_require__(154);
	var shared = __webpack_require__(190);
	var NATIVE_SYMBOL_REGISTRY = __webpack_require__(693);
	
	var SymbolToStringRegistry = shared('symbol-to-string-registry');
	
	// `Symbol.keyFor` method
	// https://tc39.es/ecma262/#sec-symbol.keyfor
	$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
	    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
	  }
	});


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.matchAll` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.matchall
	defineWellKnownSymbol('matchAll');


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.match` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.match
	defineWellKnownSymbol('match');


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.replace` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.replace
	defineWellKnownSymbol('replace');


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.search` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.search
	defineWellKnownSymbol('search');


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.species` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.species
	defineWellKnownSymbol('species');


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.split` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.split
	defineWellKnownSymbol('split');


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	var defineSymbolToPrimitive = __webpack_require__(692);
	
	// `Symbol.toPrimitive` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.toprimitive
	defineWellKnownSymbol('toPrimitive');
	
	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive();


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(33);
	var defineWellKnownSymbol = __webpack_require__(66);
	var setToStringTag = __webpack_require__(65);
	
	// `Symbol.toStringTag` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.tostringtag
	defineWellKnownSymbol('toStringTag');
	
	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(66);
	
	// `Symbol.unscopables` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.unscopables
	defineWellKnownSymbol('unscopables');


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var lengthOfArrayLike = __webpack_require__(34);
	var toIntegerOrInfinity = __webpack_require__(44);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.at` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.at
	exportTypedArrayMethod('at', function at(index) {
	  var O = aTypedArray(this);
	  var len = lengthOfArrayLike(O);
	  var relativeIndex = toIntegerOrInfinity(index);
	  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
	  return (k < 0 || k >= len) ? undefined : O[k];
	});


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var ArrayBufferViewCore = __webpack_require__(26);
	var $ArrayCopyWithin = __webpack_require__(641);
	
	var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.copyWithin` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
	exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
	  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	});


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $every = __webpack_require__(52).every;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.every` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
	exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
	  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $fill = __webpack_require__(396);
	var toBigInt = __webpack_require__(427);
	var classof = __webpack_require__(98);
	var call = __webpack_require__(19);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var slice = uncurryThis(''.slice);
	
	// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
	var CONVERSION_BUG = fails(function () {
	  var count = 0;
	  // eslint-disable-next-line es/no-typed-arrays -- safe
	  new Int8Array(2).fill({ valueOf: function () { return count++; } });
	  return count !== 1;
	});
	
	// `%TypedArray%.prototype.fill` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
	exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
	  var length = arguments.length;
	  aTypedArray(this);
	  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
	  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
	}, CONVERSION_BUG);


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $filter = __webpack_require__(52).filter;
	var fromSpeciesAndList = __webpack_require__(1247);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.filter` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
	exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
	  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  return fromSpeciesAndList(this, list);
	});


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $findIndex = __webpack_require__(52).findIndex;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.findIndex` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
	exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
	  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $findLastIndex = __webpack_require__(275).findLastIndex;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.findLastIndex` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlastindex
	exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate /* , thisArg */) {
	  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $findLast = __webpack_require__(275).findLast;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.findLast` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlast
	exportTypedArrayMethod('findLast', function findLast(predicate /* , thisArg */) {
	  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $find = __webpack_require__(52).find;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.find` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
	exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
	  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Float32Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Float32', function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Float64Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Float64', function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $forEach = __webpack_require__(52).forEach;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
	exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
	  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(430);
	var exportTypedArrayStaticMethod = __webpack_require__(26).exportTypedArrayStaticMethod;
	var typedArrayFrom = __webpack_require__(695);
	
	// `%TypedArray%.from` method
	// https://tc39.es/ecma262/#sec-%typedarray%.from
	exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $includes = __webpack_require__(224).includes;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.includes` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
	exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
	  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $indexOf = __webpack_require__(224).indexOf;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.indexOf` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
	exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
	  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Int16Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Int16', function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Int32Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Int32', function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Int8Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Int8', function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var fails = __webpack_require__(6);
	var uncurryThis = __webpack_require__(8);
	var ArrayBufferViewCore = __webpack_require__(26);
	var ArrayIterators = __webpack_require__(302);
	var wellKnownSymbol = __webpack_require__(27);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var Uint8Array = globalThis.Uint8Array;
	var arrayValues = uncurryThis(ArrayIterators.values);
	var arrayKeys = uncurryThis(ArrayIterators.keys);
	var arrayEntries = uncurryThis(ArrayIterators.entries);
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;
	
	var GENERIC = !fails(function () {
	  TypedArrayPrototype[ITERATOR].call([1]);
	});
	
	var ITERATOR_IS_VALUES = !!TypedArrayPrototype
	  && TypedArrayPrototype.values
	  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
	  && TypedArrayPrototype.values.name === 'values';
	
	var typedArrayValues = function values() {
	  return arrayValues(aTypedArray(this));
	};
	
	// `%TypedArray%.prototype.entries` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
	exportTypedArrayMethod('entries', function entries() {
	  return arrayEntries(aTypedArray(this));
	}, GENERIC);
	// `%TypedArray%.prototype.keys` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
	exportTypedArrayMethod('keys', function keys() {
	  return arrayKeys(aTypedArray(this));
	}, GENERIC);
	// `%TypedArray%.prototype.values` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
	exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
	// `%TypedArray%.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
	exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var uncurryThis = __webpack_require__(8);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var $join = uncurryThis([].join);
	
	// `%TypedArray%.prototype.join` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
	exportTypedArrayMethod('join', function join(separator) {
	  return $join(aTypedArray(this), separator);
	});


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var apply = __webpack_require__(90);
	var $lastIndexOf = __webpack_require__(644);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.lastIndexOf` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
	exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
	  var length = arguments.length;
	  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
	});


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $map = __webpack_require__(52).map;
	var typedArraySpeciesConstructor = __webpack_require__(299);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.map` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
	exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
	  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
	    return new (typedArraySpeciesConstructor(O))(length);
	  });
	});


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(430);
	
	var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
	var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod;
	
	// `%TypedArray%.of` method
	// https://tc39.es/ecma262/#sec-%typedarray%.of
	exportTypedArrayStaticMethod('of', function of(/* ...items */) {
	  var index = 0;
	  var length = arguments.length;
	  var result = new (aTypedArrayConstructor(this))(length);
	  while (length > index) result[index] = arguments[index++];
	  return result;
	}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $reduceRight = __webpack_require__(276).right;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.reduceRight` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
	exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
	  var length = arguments.length;
	  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $reduce = __webpack_require__(276).left;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
	exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
	  var length = arguments.length;
	  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var floor = Math.floor;
	
	// `%TypedArray%.prototype.reverse` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
	exportTypedArrayMethod('reverse', function reverse() {
	  var that = this;
	  var length = aTypedArray(that).length;
	  var middle = floor(length / 2);
	  var index = 0;
	  var value;
	  while (index < middle) {
	    value = that[index];
	    that[index++] = that[--length];
	    that[length] = value;
	  } return that;
	});


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var call = __webpack_require__(19);
	var ArrayBufferViewCore = __webpack_require__(26);
	var lengthOfArrayLike = __webpack_require__(34);
	var toOffset = __webpack_require__(694);
	var toIndexedObject = __webpack_require__(31);
	var fails = __webpack_require__(6);
	
	var RangeError = globalThis.RangeError;
	var Int8Array = globalThis.Int8Array;
	var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
	var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
	  // eslint-disable-next-line es/no-typed-arrays -- required for testing
	  var array = new Uint8ClampedArray(2);
	  call($set, array, { length: 1, 0: 3 }, 1);
	  return array[1] !== 3;
	});
	
	// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
	var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
	  var array = new Int8Array(2);
	  array.set(1);
	  array.set('2', 1);
	  return array[0] !== 0 || array[1] !== 2;
	});
	
	// `%TypedArray%.prototype.set` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
	exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
	  aTypedArray(this);
	  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
	  var src = toIndexedObject(arrayLike);
	  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
	  var length = this.length;
	  var len = lengthOfArrayLike(src);
	  var index = 0;
	  if (len + offset > length) throw new RangeError('Wrong length');
	  while (index < len) this[offset + index] = src[index++];
	}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var typedArraySpeciesConstructor = __webpack_require__(299);
	var fails = __webpack_require__(6);
	var arraySlice = __webpack_require__(89);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-typed-arrays -- required for testing
	  new Int8Array(1).slice();
	});
	
	// `%TypedArray%.prototype.slice` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
	exportTypedArrayMethod('slice', function slice(start, end) {
	  var list = arraySlice(aTypedArray(this), start, end);
	  var C = typedArraySpeciesConstructor(this);
	  var index = 0;
	  var length = list.length;
	  var result = new C(length);
	  while (length > index) result[index] = list[index++];
	  return result;
	}, FORCED);


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var $some = __webpack_require__(52).some;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.some` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
	exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
	  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(130);
	var fails = __webpack_require__(6);
	var aCallable = __webpack_require__(39);
	var internalSort = __webpack_require__(398);
	var ArrayBufferViewCore = __webpack_require__(26);
	var FF = __webpack_require__(654);
	var IE_OR_EDGE = __webpack_require__(655);
	var V8 = __webpack_require__(115);
	var WEBKIT = __webpack_require__(403);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var Uint16Array = globalThis.Uint16Array;
	var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);
	
	// WebKit
	var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
	  nativeSort(new Uint16Array(2), null);
	}) && fails(function () {
	  nativeSort(new Uint16Array(2), {});
	}));
	
	var STABLE_SORT = !!nativeSort && !fails(function () {
	  // feature detection can be too slow, so check engines versions
	  if (V8) return V8 < 74;
	  if (FF) return FF < 67;
	  if (IE_OR_EDGE) return true;
	  if (WEBKIT) return WEBKIT < 602;
	
	  var array = new Uint16Array(516);
	  var expected = Array(516);
	  var index, mod;
	
	  for (index = 0; index < 516; index++) {
	    mod = index % 4;
	    array[index] = 515 - index;
	    expected[index] = index - 2 * mod + 3;
	  }
	
	  nativeSort(array, function (a, b) {
	    return (a / 4 | 0) - (b / 4 | 0);
	  });
	
	  for (index = 0; index < 516; index++) {
	    if (array[index] !== expected[index]) return true;
	  }
	});
	
	var getSortCompare = function (comparefn) {
	  return function (x, y) {
	    if (comparefn !== undefined) return +comparefn(x, y) || 0;
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (y !== y) return -1;
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (x !== x) return 1;
	    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
	    return x > y;
	  };
	};
	
	// `%TypedArray%.prototype.sort` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
	exportTypedArrayMethod('sort', function sort(comparefn) {
	  if (comparefn !== undefined) aCallable(comparefn);
	  if (STABLE_SORT) return nativeSort(this, comparefn);
	
	  return internalSort(aTypedArray(this), getSortCompare(comparefn));
	}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var toLength = __webpack_require__(76);
	var toAbsoluteIndex = __webpack_require__(117);
	var typedArraySpeciesConstructor = __webpack_require__(299);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.subarray` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
	exportTypedArrayMethod('subarray', function subarray(begin, end) {
	  var O = aTypedArray(this);
	  var length = O.length;
	  var beginIndex = toAbsoluteIndex(begin, length);
	  var C = typedArraySpeciesConstructor(O);
	  return new C(
	    O.buffer,
	    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
	    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
	  );
	});


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var apply = __webpack_require__(90);
	var ArrayBufferViewCore = __webpack_require__(26);
	var fails = __webpack_require__(6);
	var arraySlice = __webpack_require__(89);
	
	var Int8Array = globalThis.Int8Array;
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var $toLocaleString = [].toLocaleString;
	
	// iOS Safari 6.x fails here
	var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
	  $toLocaleString.call(new Int8Array(1));
	});
	
	var FORCED = fails(function () {
	  return [1, 2].toLocaleString() !== new Int8Array([1, 2]).toLocaleString();
	}) || !fails(function () {
	  Int8Array.prototype.toLocaleString.call([1, 2]);
	});
	
	// `%TypedArray%.prototype.toLocaleString` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
	exportTypedArrayMethod('toLocaleString', function toLocaleString() {
	  return apply(
	    $toLocaleString,
	    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
	    arraySlice(arguments)
	  );
	}, FORCED);


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var arrayToReversed = __webpack_require__(645);
	var ArrayBufferViewCore = __webpack_require__(26);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
	
	// `%TypedArray%.prototype.toReversed` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.toreversed
	exportTypedArrayMethod('toReversed', function toReversed() {
	  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
	});


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(26);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(39);
	var arrayFromConstructorAndList = __webpack_require__(274);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);
	
	// `%TypedArray%.prototype.toSorted` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tosorted
	exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
	  if (compareFn !== undefined) aCallable(compareFn);
	  var O = aTypedArray(this);
	  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
	  return sort(A, compareFn);
	});


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var exportTypedArrayMethod = __webpack_require__(26).exportTypedArrayMethod;
	var fails = __webpack_require__(6);
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(8);
	
	var Uint8Array = globalThis.Uint8Array;
	var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
	var arrayToString = [].toString;
	var join = uncurryThis([].join);
	
	if (fails(function () { arrayToString.call({}); })) {
	  arrayToString = function toString() {
	    return join(this);
	  };
	}
	
	var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;
	
	// `%TypedArray%.prototype.toString` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
	exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Uint16Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Uint16', function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Uint32Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Uint32', function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Uint8Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Uint8', function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(118);
	
	// `Uint8ClampedArray` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Uint8', function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var arrayWith = __webpack_require__(646);
	var ArrayBufferViewCore = __webpack_require__(26);
	var isBigIntArray = __webpack_require__(667);
	var toIntegerOrInfinity = __webpack_require__(44);
	var toBigInt = __webpack_require__(427);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	var PROPER_ORDER = !!function () {
	  try {
	    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
	    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
	  } catch (error) {
	    // some early implementations, like WebKit, does not follow the final semantic
	    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
	    return error === 8;
	  }
	}();
	
	// `%TypedArray%.prototype.with` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.with
	exportTypedArrayMethod('with', { 'with': function (index, value) {
	  var O = aTypedArray(this);
	  var relativeIndex = toIntegerOrInfinity(index);
	  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
	  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
	} }['with'], !PROPER_ORDER);


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(18);
	
	var fromCharCode = String.fromCharCode;
	var charAt = uncurryThis(''.charAt);
	var exec = uncurryThis(/./.exec);
	var stringSlice = uncurryThis(''.slice);
	
	var hex2 = /^[\da-f]{2}$/i;
	var hex4 = /^[\da-f]{4}$/i;
	
	// `unescape` method
	// https://tc39.es/ecma262/#sec-unescape-string
	$({ global: true }, {
	  unescape: function unescape(string) {
	    var str = toString(string);
	    var result = '';
	    var length = str.length;
	    var index = 0;
	    var chr, part;
	    while (index < length) {
	      chr = charAt(str, index++);
	      if (chr === '%') {
	        if (charAt(str, index) === 'u') {
	          part = stringSlice(str, index + 1, index + 5);
	          if (exec(hex4, part)) {
	            result += fromCharCode(parseInt(part, 16));
	            index += 5;
	            continue;
	          }
	        } else {
	          part = stringSlice(str, index, index + 2);
	          if (exec(hex2, part)) {
	            result += fromCharCode(parseInt(part, 16));
	            index += 2;
	            continue;
	          }
	        }
	      }
	      result += chr;
	    } return result;
	  }
	});


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var FREEZING = __webpack_require__(183);
	var globalThis = __webpack_require__(9);
	var uncurryThis = __webpack_require__(8);
	var defineBuiltIns = __webpack_require__(229);
	var InternalMetadataModule = __webpack_require__(149);
	var collection = __webpack_require__(278);
	var collectionWeak = __webpack_require__(649);
	var isObject = __webpack_require__(25);
	var enforceInternalState = __webpack_require__(49).enforce;
	var fails = __webpack_require__(6);
	var NATIVE_WEAK_MAP = __webpack_require__(698);
	
	var $Object = Object;
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray = Array.isArray;
	// eslint-disable-next-line es/no-object-isextensible -- safe
	var isExtensible = $Object.isExtensible;
	// eslint-disable-next-line es/no-object-isfrozen -- safe
	var isFrozen = $Object.isFrozen;
	// eslint-disable-next-line es/no-object-issealed -- safe
	var isSealed = $Object.isSealed;
	// eslint-disable-next-line es/no-object-freeze -- safe
	var freeze = $Object.freeze;
	// eslint-disable-next-line es/no-object-seal -- safe
	var seal = $Object.seal;
	
	var IS_IE11 = !globalThis.ActiveXObject && 'ActiveXObject' in globalThis;
	var InternalWeakMap;
	
	var wrapper = function (init) {
	  return function WeakMap() {
	    return init(this, arguments.length ? arguments[0] : undefined);
	  };
	};
	
	// `WeakMap` constructor
	// https://tc39.es/ecma262/#sec-weakmap-constructor
	var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
	var WeakMapPrototype = $WeakMap.prototype;
	var nativeSet = uncurryThis(WeakMapPrototype.set);
	
	// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
	var hasMSEdgeFreezingBug = function () {
	  return FREEZING && fails(function () {
	    var frozenArray = freeze([]);
	    nativeSet(new $WeakMap(), frozenArray, 1);
	    return !isFrozen(frozenArray);
	  });
	};
	
	// IE11 WeakMap frozen keys fix
	// We can't use feature detection because it crash some old IE builds
	// https://github.com/zloirock/core-js/issues/485
	if (NATIVE_WEAK_MAP) if (IS_IE11) {
	  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
	  InternalMetadataModule.enable();
	  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
	  var nativeHas = uncurryThis(WeakMapPrototype.has);
	  var nativeGet = uncurryThis(WeakMapPrototype.get);
	  defineBuiltIns(WeakMapPrototype, {
	    'delete': function (key) {
	      if (isObject(key) && !isExtensible(key)) {
	        var state = enforceInternalState(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeDelete(this, key) || state.frozen['delete'](key);
	      } return nativeDelete(this, key);
	    },
	    has: function has(key) {
	      if (isObject(key) && !isExtensible(key)) {
	        var state = enforceInternalState(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeHas(this, key) || state.frozen.has(key);
	      } return nativeHas(this, key);
	    },
	    get: function get(key) {
	      if (isObject(key) && !isExtensible(key)) {
	        var state = enforceInternalState(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
	      } return nativeGet(this, key);
	    },
	    set: function set(key, value) {
	      if (isObject(key) && !isExtensible(key)) {
	        var state = enforceInternalState(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
	      } else nativeSet(this, key, value);
	      return this;
	    }
	  });
	// Chakra Edge frozen keys fix
	} else if (hasMSEdgeFreezingBug()) {
	  defineBuiltIns(WeakMapPrototype, {
	    set: function set(key, value) {
	      var arrayIntegrityLevel;
	      if (isArray(key)) {
	        if (isFrozen(key)) arrayIntegrityLevel = freeze;
	        else if (isSealed(key)) arrayIntegrityLevel = seal;
	      }
	      nativeSet(this, key, value);
	      if (arrayIntegrityLevel) arrayIntegrityLevel(key);
	      return this;
	    }
	  });
	}


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1512);


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var collection = __webpack_require__(278);
	var collectionWeak = __webpack_require__(649);
	
	// `WeakSet` constructor
	// https://tc39.es/ecma262/#sec-weakset-constructor
	collection('WeakSet', function (init) {
	  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionWeak);


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1514);


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var getBuiltIn = __webpack_require__(33);
	var uncurryThis = __webpack_require__(8);
	var call = __webpack_require__(19);
	var fails = __webpack_require__(6);
	var toString = __webpack_require__(18);
	var validateArgumentsLength = __webpack_require__(85);
	var c2i = __webpack_require__(647).c2i;
	
	var disallowed = /[^\d+/a-z]/i;
	var whitespaces = /[\t\n\f\r ]+/g;
	var finalEq = /[=]{1,2}$/;
	
	var $atob = getBuiltIn('atob');
	var fromCharCode = String.fromCharCode;
	var charAt = uncurryThis(''.charAt);
	var replace = uncurryThis(''.replace);
	var exec = uncurryThis(disallowed.exec);
	
	var BASIC = !!$atob && !fails(function () {
	  return $atob('aGk=') !== 'hi';
	});
	
	var NO_SPACES_IGNORE = BASIC && fails(function () {
	  return $atob(' ') !== '';
	});
	
	var NO_ENCODING_CHECK = BASIC && !fails(function () {
	  $atob('a');
	});
	
	var NO_ARG_RECEIVING_CHECK = BASIC && !fails(function () {
	  $atob();
	});
	
	var WRONG_ARITY = BASIC && $atob.length !== 1;
	
	var FORCED = !BASIC || NO_SPACES_IGNORE || NO_ENCODING_CHECK || NO_ARG_RECEIVING_CHECK || WRONG_ARITY;
	
	// `atob` method
	// https://html.spec.whatwg.org/multipage/webappapis.html#dom-atob
	$({ global: true, bind: true, enumerable: true, forced: FORCED }, {
	  atob: function atob(data) {
	    validateArgumentsLength(arguments.length, 1);
	    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
	    if (BASIC && !NO_SPACES_IGNORE && !NO_ENCODING_CHECK) return call($atob, globalThis, data);
	    var string = replace(toString(data), whitespaces, '');
	    var output = '';
	    var position = 0;
	    var bc = 0;
	    var length, chr, bs;
	    if (string.length % 4 === 0) {
	      string = replace(string, finalEq, '');
	    }
	    length = string.length;
	    if (length % 4 === 1 || exec(disallowed, string)) {
	      throw new (getBuiltIn('DOMException'))('The string is not correctly encoded', 'InvalidCharacterError');
	    }
	    while (position < length) {
	      chr = charAt(string, position++);
	      bs = bc % 4 ? bs * 64 + c2i[chr] : c2i[chr];
	      if (bc++ % 4) output += fromCharCode(255 & bs >> (-2 * bc & 6));
	    } return output;
	  }
	});


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var getBuiltIn = __webpack_require__(33);
	var uncurryThis = __webpack_require__(8);
	var call = __webpack_require__(19);
	var fails = __webpack_require__(6);
	var toString = __webpack_require__(18);
	var validateArgumentsLength = __webpack_require__(85);
	var i2c = __webpack_require__(647).i2c;
	
	var $btoa = getBuiltIn('btoa');
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	
	var BASIC = !!$btoa && !fails(function () {
	  return $btoa('hi') !== 'aGk=';
	});
	
	var NO_ARG_RECEIVING_CHECK = BASIC && !fails(function () {
	  $btoa();
	});
	
	var WRONG_ARG_CONVERSION = BASIC && fails(function () {
	  return $btoa(null) !== 'bnVsbA==';
	});
	
	var WRONG_ARITY = BASIC && $btoa.length !== 1;
	
	// `btoa` method
	// https://html.spec.whatwg.org/multipage/webappapis.html#dom-btoa
	$({ global: true, bind: true, enumerable: true, forced: !BASIC || NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY }, {
	  btoa: function btoa(data) {
	    validateArgumentsLength(arguments.length, 1);
	    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
	    if (BASIC) return call($btoa, globalThis, toString(data));
	    var string = toString(data);
	    var output = '';
	    var position = 0;
	    var map = i2c;
	    var block, charCode;
	    while (charAt(string, position) || (map = '=', position % 1)) {
	      charCode = charCodeAt(string, position += 3 / 4);
	      if (charCode > 0xFF) {
	        throw new (getBuiltIn('DOMException'))('The string contains characters outside of the Latin1 range', 'InvalidCharacterError');
	      }
	      block = block << 8 | charCode;
	      output += charAt(map, 63 & block >> 8 - position % 1 * 8);
	    } return output;
	  }
	});


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var clearImmediate = __webpack_require__(296).clear;
	
	// `clearImmediate` method
	// http://w3c.github.io/setImmediate/#si-clearImmediate
	$({ global: true, bind: true, enumerable: true, forced: globalThis.clearImmediate !== clearImmediate }, {
	  clearImmediate: clearImmediate
	});


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var DOMIterables = __webpack_require__(652);
	var DOMTokenListPrototype = __webpack_require__(653);
	var forEach = __webpack_require__(642);
	var createNonEnumerableProperty = __webpack_require__(58);
	
	var handlePrototype = function (CollectionPrototype) {
	  // some Chrome versions have non-configurable methods on DOMTokenList
	  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
	    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
	  } catch (error) {
	    CollectionPrototype.forEach = forEach;
	  }
	};
	
	for (var COLLECTION_NAME in DOMIterables) {
	  if (DOMIterables[COLLECTION_NAME]) {
	    handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype);
	  }
	}
	
	handlePrototype(DOMTokenListPrototype);


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(9);
	var DOMIterables = __webpack_require__(652);
	var DOMTokenListPrototype = __webpack_require__(653);
	var ArrayIteratorMethods = __webpack_require__(302);
	var createNonEnumerableProperty = __webpack_require__(58);
	var setToStringTag = __webpack_require__(65);
	var wellKnownSymbol = __webpack_require__(27);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var ArrayValues = ArrayIteratorMethods.values;
	
	var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
	  if (CollectionPrototype) {
	    // some Chrome versions have non-configurable methods on DOMTokenList
	    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
	      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
	    } catch (error) {
	      CollectionPrototype[ITERATOR] = ArrayValues;
	    }
	    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
	    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
	      // some Chrome versions have non-configurable methods on DOMTokenList
	      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
	        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
	      } catch (error) {
	        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
	      }
	    }
	  }
	};
	
	for (var COLLECTION_NAME in DOMIterables) {
	  handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
	}
	
	handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var getBuiltInNodeModule = __webpack_require__(662);
	var fails = __webpack_require__(6);
	var create = __webpack_require__(73);
	var createPropertyDescriptor = __webpack_require__(82);
	var defineProperty = __webpack_require__(42).f;
	var defineBuiltIn = __webpack_require__(40);
	var defineBuiltInAccessor = __webpack_require__(50);
	var hasOwn = __webpack_require__(29);
	var anInstance = __webpack_require__(97);
	var anObject = __webpack_require__(20);
	var errorToString = __webpack_require__(659);
	var normalizeStringArgument = __webpack_require__(235);
	var DOMExceptionConstants = __webpack_require__(651);
	var clearErrorStack = __webpack_require__(404);
	var InternalStateModule = __webpack_require__(49);
	var DESCRIPTORS = __webpack_require__(14);
	var IS_PURE = __webpack_require__(43);
	
	var DOM_EXCEPTION = 'DOMException';
	var DATA_CLONE_ERR = 'DATA_CLONE_ERR';
	var Error = getBuiltIn('Error');
	// NodeJS < 17.0 does not expose `DOMException` to global
	var NativeDOMException = getBuiltIn(DOM_EXCEPTION) || (function () {
	  try {
	    // NodeJS < 15.0 does not expose `MessageChannel` to global
	    var MessageChannel = getBuiltIn('MessageChannel') || getBuiltInNodeModule('worker_threads').MessageChannel;
	    // eslint-disable-next-line es/no-weak-map, unicorn/require-post-message-target-origin -- safe
	    new MessageChannel().port1.postMessage(new WeakMap());
	  } catch (error) {
	    if (error.name === DATA_CLONE_ERR && error.code === 25) return error.constructor;
	  }
	})();
	var NativeDOMExceptionPrototype = NativeDOMException && NativeDOMException.prototype;
	var ErrorPrototype = Error.prototype;
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(DOM_EXCEPTION);
	var HAS_STACK = 'stack' in new Error(DOM_EXCEPTION);
	
	var codeFor = function (name) {
	  return hasOwn(DOMExceptionConstants, name) && DOMExceptionConstants[name].m ? DOMExceptionConstants[name].c : 0;
	};
	
	var $DOMException = function DOMException() {
	  anInstance(this, DOMExceptionPrototype);
	  var argumentsLength = arguments.length;
	  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
	  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
	  var code = codeFor(name);
	  setInternalState(this, {
	    type: DOM_EXCEPTION,
	    name: name,
	    message: message,
	    code: code
	  });
	  if (!DESCRIPTORS) {
	    this.name = name;
	    this.message = message;
	    this.code = code;
	  }
	  if (HAS_STACK) {
	    var error = new Error(message);
	    error.name = DOM_EXCEPTION;
	    defineProperty(this, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
	  }
	};
	
	var DOMExceptionPrototype = $DOMException.prototype = create(ErrorPrototype);
	
	var createGetterDescriptor = function (get) {
	  return { enumerable: true, configurable: true, get: get };
	};
	
	var getterFor = function (key) {
	  return createGetterDescriptor(function () {
	    return getInternalState(this)[key];
	  });
	};
	
	if (DESCRIPTORS) {
	  // `DOMException.prototype.code` getter
	  defineBuiltInAccessor(DOMExceptionPrototype, 'code', getterFor('code'));
	  // `DOMException.prototype.message` getter
	  defineBuiltInAccessor(DOMExceptionPrototype, 'message', getterFor('message'));
	  // `DOMException.prototype.name` getter
	  defineBuiltInAccessor(DOMExceptionPrototype, 'name', getterFor('name'));
	}
	
	defineProperty(DOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, $DOMException));
	
	// FF36- DOMException is a function, but can't be constructed
	var INCORRECT_CONSTRUCTOR = fails(function () {
	  return !(new NativeDOMException() instanceof Error);
	});
	
	// Safari 10.1 / Chrome 32- / IE8- DOMException.prototype.toString bugs
	var INCORRECT_TO_STRING = INCORRECT_CONSTRUCTOR || fails(function () {
	  return ErrorPrototype.toString !== errorToString || String(new NativeDOMException(1, 2)) !== '2: 1';
	});
	
	// Deno 1.6.3- DOMException.prototype.code just missed
	var INCORRECT_CODE = INCORRECT_CONSTRUCTOR || fails(function () {
	  return new NativeDOMException(1, 'DataCloneError').code !== 25;
	});
	
	// Deno 1.6.3- DOMException constants just missed
	var MISSED_CONSTANTS = INCORRECT_CONSTRUCTOR
	  || NativeDOMException[DATA_CLONE_ERR] !== 25
	  || NativeDOMExceptionPrototype[DATA_CLONE_ERR] !== 25;
	
	var FORCED_CONSTRUCTOR = IS_PURE ? INCORRECT_TO_STRING || INCORRECT_CODE || MISSED_CONSTANTS : INCORRECT_CONSTRUCTOR;
	
	// `DOMException` constructor
	// https://webidl.spec.whatwg.org/#idl-DOMException
	$({ global: true, constructor: true, forced: FORCED_CONSTRUCTOR }, {
	  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
	});
	
	var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
	var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;
	
	if (INCORRECT_TO_STRING && (IS_PURE || NativeDOMException === PolyfilledDOMException)) {
	  defineBuiltIn(PolyfilledDOMExceptionPrototype, 'toString', errorToString);
	}
	
	if (INCORRECT_CODE && DESCRIPTORS && NativeDOMException === PolyfilledDOMException) {
	  defineBuiltInAccessor(PolyfilledDOMExceptionPrototype, 'code', createGetterDescriptor(function () {
	    return codeFor(anObject(this).name);
	  }));
	}
	
	// `DOMException` constants
	for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
	  var constant = DOMExceptionConstants[key];
	  var constantName = constant.s;
	  var descriptor = createPropertyDescriptor(6, constant.c);
	  if (!hasOwn(PolyfilledDOMException, constantName)) {
	    defineProperty(PolyfilledDOMException, constantName, descriptor);
	  }
	  if (!hasOwn(PolyfilledDOMExceptionPrototype, constantName)) {
	    defineProperty(PolyfilledDOMExceptionPrototype, constantName, descriptor);
	  }
	}


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var getBuiltIn = __webpack_require__(33);
	var createPropertyDescriptor = __webpack_require__(82);
	var defineProperty = __webpack_require__(42).f;
	var hasOwn = __webpack_require__(29);
	var anInstance = __webpack_require__(97);
	var inheritIfRequired = __webpack_require__(148);
	var normalizeStringArgument = __webpack_require__(235);
	var DOMExceptionConstants = __webpack_require__(651);
	var clearErrorStack = __webpack_require__(404);
	var DESCRIPTORS = __webpack_require__(14);
	var IS_PURE = __webpack_require__(43);
	
	var DOM_EXCEPTION = 'DOMException';
	var Error = getBuiltIn('Error');
	var NativeDOMException = getBuiltIn(DOM_EXCEPTION);
	
	var $DOMException = function DOMException() {
	  anInstance(this, DOMExceptionPrototype);
	  var argumentsLength = arguments.length;
	  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
	  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
	  var that = new NativeDOMException(message, name);
	  var error = new Error(message);
	  error.name = DOM_EXCEPTION;
	  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
	  inheritIfRequired(that, this, $DOMException);
	  return that;
	};
	
	var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;
	
	var ERROR_HAS_STACK = 'stack' in new Error(DOM_EXCEPTION);
	var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(globalThis, DOM_EXCEPTION);
	
	// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
	// https://github.com/Jarred-Sumner/bun/issues/399
	var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);
	
	var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;
	
	// `DOMException` constructor patch for `.stack` where it's required
	// https://webidl.spec.whatwg.org/#es-DOMException-specialness
	$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
	  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
	});
	
	var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
	var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;
	
	if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
	  if (!IS_PURE) {
	    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
	  }
	
	  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
	    var constant = DOMExceptionConstants[key];
	    var constantName = constant.s;
	    if (!hasOwn(PolyfilledDOMException, constantName)) {
	      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
	    }
	  }
	}


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(33);
	var setToStringTag = __webpack_require__(65);
	
	var DOM_EXCEPTION = 'DOMException';
	
	// `DOMException.prototype[@@toStringTag]` property
	setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1518);
	__webpack_require__(1527);


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var microtask = __webpack_require__(676);
	var aCallable = __webpack_require__(39);
	var validateArgumentsLength = __webpack_require__(85);
	var fails = __webpack_require__(6);
	var DESCRIPTORS = __webpack_require__(14);
	
	// Bun ~ 1.0.30 bug
	// https://github.com/oven-sh/bun/issues/9249
	var WRONG_ARITY = fails(function () {
	  // getOwnPropertyDescriptor for prevent experimental warning in Node 11
	  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	  return DESCRIPTORS && Object.getOwnPropertyDescriptor(globalThis, 'queueMicrotask').value.length !== 1;
	});
	
	// `queueMicrotask` method
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
	$({ global: true, enumerable: true, dontCallGetSet: true, forced: WRONG_ARITY }, {
	  queueMicrotask: function queueMicrotask(fn) {
	    validateArgumentsLength(arguments.length, 1);
	    microtask(aCallable(fn));
	  }
	});


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var defineBuiltInAccessor = __webpack_require__(50);
	var DESCRIPTORS = __webpack_require__(14);
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	var INCORRECT_VALUE = globalThis.self !== globalThis;
	
	// `self` getter
	// https://html.spec.whatwg.org/multipage/window-object.html#dom-self
	try {
	  if (DESCRIPTORS) {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    var descriptor = Object.getOwnPropertyDescriptor(globalThis, 'self');
	    // some engines have `self`, but with incorrect descriptor
	    // https://github.com/denoland/deno/issues/15765
	    if (INCORRECT_VALUE || !descriptor || !descriptor.get || !descriptor.enumerable) {
	      defineBuiltInAccessor(globalThis, 'self', {
	        get: function self() {
	          return globalThis;
	        },
	        set: function self(value) {
	          if (this !== globalThis) throw new $TypeError('Illegal invocation');
	          defineProperty(globalThis, 'self', {
	            value: value,
	            writable: true,
	            configurable: true,
	            enumerable: true
	          });
	        },
	        configurable: true,
	        enumerable: true
	      });
	    }
	  } else $({ global: true, simple: true, forced: INCORRECT_VALUE }, {
	    self: globalThis
	  });
	} catch (error) { /* empty */ }


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var setTask = __webpack_require__(296).set;
	var schedulersFix = __webpack_require__(421);
	
	// https://github.com/oven-sh/bun/issues/1633
	var setImmediate = globalThis.setImmediate ? schedulersFix(setTask, false) : setTask;
	
	// `setImmediate` method
	// http://w3c.github.io/setImmediate/#si-setImmediate
	$({ global: true, bind: true, enumerable: true, forced: globalThis.setImmediate !== setImmediate }, {
	  setImmediate: setImmediate
	});


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var schedulersFix = __webpack_require__(421);
	
	var setInterval = schedulersFix(globalThis.setInterval, true);
	
	// Bun / IE9- setInterval additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
	$({ global: true, bind: true, forced: globalThis.setInterval !== setInterval }, {
	  setInterval: setInterval
	});


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var schedulersFix = __webpack_require__(421);
	
	var setTimeout = schedulersFix(globalThis.setTimeout, true);
	
	// Bun / IE9- setTimeout additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
	$({ global: true, bind: true, forced: globalThis.setTimeout !== setTimeout }, {
	  setTimeout: setTimeout
	});


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var IS_PURE = __webpack_require__(43);
	var $ = __webpack_require__(2);
	var globalThis = __webpack_require__(9);
	var getBuiltIn = __webpack_require__(33);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(6);
	var uid = __webpack_require__(194);
	var isCallable = __webpack_require__(28);
	var isConstructor = __webpack_require__(186);
	var isNullOrUndefined = __webpack_require__(64);
	var isObject = __webpack_require__(25);
	var isSymbol = __webpack_require__(150);
	var iterate = __webpack_require__(83);
	var anObject = __webpack_require__(20);
	var classof = __webpack_require__(98);
	var hasOwn = __webpack_require__(29);
	var createProperty = __webpack_require__(129);
	var createNonEnumerableProperty = __webpack_require__(58);
	var lengthOfArrayLike = __webpack_require__(34);
	var validateArgumentsLength = __webpack_require__(85);
	var getRegExpFlags = __webpack_require__(240);
	var MapHelpers = __webpack_require__(671);
	var SetHelpers = __webpack_require__(92);
	var setIterate = __webpack_require__(188);
	var detachTransferable = __webpack_require__(650);
	var ERROR_STACK_INSTALLABLE = __webpack_require__(658);
	var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(426);
	
	var Object = globalThis.Object;
	var Array = globalThis.Array;
	var Date = globalThis.Date;
	var Error = globalThis.Error;
	var TypeError = globalThis.TypeError;
	var PerformanceMark = globalThis.PerformanceMark;
	var DOMException = getBuiltIn('DOMException');
	var Map = MapHelpers.Map;
	var mapHas = MapHelpers.has;
	var mapGet = MapHelpers.get;
	var mapSet = MapHelpers.set;
	var Set = SetHelpers.Set;
	var setAdd = SetHelpers.add;
	var setHas = SetHelpers.has;
	var objectKeys = getBuiltIn('Object', 'keys');
	var push = uncurryThis([].push);
	var thisBooleanValue = uncurryThis(true.valueOf);
	var thisNumberValue = uncurryThis(1.0.valueOf);
	var thisStringValue = uncurryThis(''.valueOf);
	var thisTimeValue = uncurryThis(Date.prototype.getTime);
	var PERFORMANCE_MARK = uid('structuredClone');
	var DATA_CLONE_ERROR = 'DataCloneError';
	var TRANSFERRING = 'Transferring';
	
	var checkBasicSemantic = function (structuredCloneImplementation) {
	  return !fails(function () {
	    var set1 = new globalThis.Set([7]);
	    var set2 = structuredCloneImplementation(set1);
	    var number = structuredCloneImplementation(Object(7));
	    return set2 === set1 || !set2.has(7) || !isObject(number) || +number !== 7;
	  }) && structuredCloneImplementation;
	};
	
	var checkErrorsCloning = function (structuredCloneImplementation, $Error) {
	  return !fails(function () {
	    var error = new $Error();
	    var test = structuredCloneImplementation({ a: error, b: error });
	    return !(test && test.a === test.b && test.a instanceof $Error && test.a.stack === error.stack);
	  });
	};
	
	// https://github.com/whatwg/html/pull/5749
	var checkNewErrorsCloningSemantic = function (structuredCloneImplementation) {
	  return !fails(function () {
	    var test = structuredCloneImplementation(new globalThis.AggregateError([1], PERFORMANCE_MARK, { cause: 3 }));
	    return test.name !== 'AggregateError' || test.errors[0] !== 1 || test.message !== PERFORMANCE_MARK || test.cause !== 3;
	  });
	};
	
	// FF94+, Safari 15.4+, Chrome 98+, NodeJS 17.0+, Deno 1.13+
	// FF<103 and Safari implementations can't clone errors
	// https://bugzilla.mozilla.org/show_bug.cgi?id=1556604
	// FF103 can clone errors, but `.stack` of clone is an empty string
	// https://bugzilla.mozilla.org/show_bug.cgi?id=1778762
	// FF104+ fixed it on usual errors, but not on DOMExceptions
	// https://bugzilla.mozilla.org/show_bug.cgi?id=1777321
	// Chrome <102 returns `null` if cloned object contains multiple references to one error
	// https://bugs.chromium.org/p/v8/issues/detail?id=12542
	// NodeJS implementation can't clone DOMExceptions
	// https://github.com/nodejs/node/issues/41038
	// only FF103+ supports new (html/5749) error cloning semantic
	var nativeStructuredClone = globalThis.structuredClone;
	
	var FORCED_REPLACEMENT = IS_PURE
	  || !checkErrorsCloning(nativeStructuredClone, Error)
	  || !checkErrorsCloning(nativeStructuredClone, DOMException)
	  || !checkNewErrorsCloningSemantic(nativeStructuredClone);
	
	// Chrome 82+, Safari 14.1+, Deno 1.11+
	// Chrome 78-81 implementation swaps `.name` and `.message` of cloned `DOMException`
	// Chrome returns `null` if cloned object contains multiple references to one error
	// Safari 14.1 implementation doesn't clone some `RegExp` flags, so requires a workaround
	// Safari implementation can't clone errors
	// Deno 1.2-1.10 implementations too naive
	// NodeJS 16.0+ does not have `PerformanceMark` constructor
	// NodeJS <17.2 structured cloning implementation from `performance.mark` is too naive
	// and can't clone, for example, `RegExp` or some boxed primitives
	// https://github.com/nodejs/node/issues/40840
	// no one of those implementations supports new (html/5749) error cloning semantic
	var structuredCloneFromMark = !nativeStructuredClone && checkBasicSemantic(function (value) {
	  return new PerformanceMark(PERFORMANCE_MARK, { detail: value }).detail;
	});
	
	var nativeRestrictedStructuredClone = checkBasicSemantic(nativeStructuredClone) || structuredCloneFromMark;
	
	var throwUncloneable = function (type) {
	  throw new DOMException('Uncloneable type: ' + type, DATA_CLONE_ERROR);
	};
	
	var throwUnpolyfillable = function (type, action) {
	  throw new DOMException((action || 'Cloning') + ' of ' + type + ' cannot be properly polyfilled in this engine', DATA_CLONE_ERROR);
	};
	
	var tryNativeRestrictedStructuredClone = function (value, type) {
	  if (!nativeRestrictedStructuredClone) throwUnpolyfillable(type);
	  return nativeRestrictedStructuredClone(value);
	};
	
	var createDataTransfer = function () {
	  var dataTransfer;
	  try {
	    dataTransfer = new globalThis.DataTransfer();
	  } catch (error) {
	    try {
	      dataTransfer = new globalThis.ClipboardEvent('').clipboardData;
	    } catch (error2) { /* empty */ }
	  }
	  return dataTransfer && dataTransfer.items && dataTransfer.files ? dataTransfer : null;
	};
	
	var cloneBuffer = function (value, map, $type) {
	  if (mapHas(map, value)) return mapGet(map, value);
	
	  var type = $type || classof(value);
	  var clone, length, options, source, target, i;
	
	  if (type === 'SharedArrayBuffer') {
	    if (nativeRestrictedStructuredClone) clone = nativeRestrictedStructuredClone(value);
	    // SharedArrayBuffer should use shared memory, we can't polyfill it, so return the original
	    else clone = value;
	  } else {
	    var DataView = globalThis.DataView;
	
	    // `ArrayBuffer#slice` is not available in IE10
	    // `ArrayBuffer#slice` and `DataView` are not available in old FF
	    if (!DataView && !isCallable(value.slice)) throwUnpolyfillable('ArrayBuffer');
	    // detached buffers throws in `DataView` and `.slice`
	    try {
	      if (isCallable(value.slice) && !value.resizable) {
	        clone = value.slice(0);
	      } else {
	        length = value.byteLength;
	        options = 'maxByteLength' in value ? { maxByteLength: value.maxByteLength } : undefined;
	        // eslint-disable-next-line es/no-resizable-and-growable-arraybuffers -- safe
	        clone = new ArrayBuffer(length, options);
	        source = new DataView(value);
	        target = new DataView(clone);
	        for (i = 0; i < length; i++) {
	          target.setUint8(i, source.getUint8(i));
	        }
	      }
	    } catch (error) {
	      throw new DOMException('ArrayBuffer is detached', DATA_CLONE_ERROR);
	    }
	  }
	
	  mapSet(map, value, clone);
	
	  return clone;
	};
	
	var cloneView = function (value, type, offset, length, map) {
	  var C = globalThis[type];
	  // in some old engines like Safari 9, typeof C is 'object'
	  // on Uint8ClampedArray or some other constructors
	  if (!isObject(C)) throwUnpolyfillable(type);
	  return new C(cloneBuffer(value.buffer, map), offset, length);
	};
	
	var structuredCloneInternal = function (value, map) {
	  if (isSymbol(value)) throwUncloneable('Symbol');
	  if (!isObject(value)) return value;
	  // effectively preserves circular references
	  if (map) {
	    if (mapHas(map, value)) return mapGet(map, value);
	  } else map = new Map();
	
	  var type = classof(value);
	  var C, name, cloned, dataTransfer, i, length, keys, key;
	
	  switch (type) {
	    case 'Array':
	      cloned = Array(lengthOfArrayLike(value));
	      break;
	    case 'Object':
	      cloned = {};
	      break;
	    case 'Map':
	      cloned = new Map();
	      break;
	    case 'Set':
	      cloned = new Set();
	      break;
	    case 'RegExp':
	      // in this block because of a Safari 14.1 bug
	      // old FF does not clone regexes passed to the constructor, so get the source and flags directly
	      cloned = new RegExp(value.source, getRegExpFlags(value));
	      break;
	    case 'Error':
	      name = value.name;
	      switch (name) {
	        case 'AggregateError':
	          cloned = new (getBuiltIn(name))([]);
	          break;
	        case 'EvalError':
	        case 'RangeError':
	        case 'ReferenceError':
	        case 'SuppressedError':
	        case 'SyntaxError':
	        case 'TypeError':
	        case 'URIError':
	          cloned = new (getBuiltIn(name))();
	          break;
	        case 'CompileError':
	        case 'LinkError':
	        case 'RuntimeError':
	          cloned = new (getBuiltIn('WebAssembly', name))();
	          break;
	        default:
	          cloned = new Error();
	      }
	      break;
	    case 'DOMException':
	      cloned = new DOMException(value.message, value.name);
	      break;
	    case 'ArrayBuffer':
	    case 'SharedArrayBuffer':
	      cloned = cloneBuffer(value, map, type);
	      break;
	    case 'DataView':
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float16Array':
	    case 'Float32Array':
	    case 'Float64Array':
	    case 'BigInt64Array':
	    case 'BigUint64Array':
	      length = type === 'DataView' ? value.byteLength : value.length;
	      cloned = cloneView(value, type, value.byteOffset, length, map);
	      break;
	    case 'DOMQuad':
	      try {
	        cloned = new DOMQuad(
	          structuredCloneInternal(value.p1, map),
	          structuredCloneInternal(value.p2, map),
	          structuredCloneInternal(value.p3, map),
	          structuredCloneInternal(value.p4, map)
	        );
	      } catch (error) {
	        cloned = tryNativeRestrictedStructuredClone(value, type);
	      }
	      break;
	    case 'File':
	      if (nativeRestrictedStructuredClone) try {
	        cloned = nativeRestrictedStructuredClone(value);
	        // NodeJS 20.0.0 bug, https://github.com/nodejs/node/issues/47612
	        if (classof(cloned) !== type) cloned = undefined;
	      } catch (error) { /* empty */ }
	      if (!cloned) try {
	        cloned = new File([value], value.name, value);
	      } catch (error) { /* empty */ }
	      if (!cloned) throwUnpolyfillable(type);
	      break;
	    case 'FileList':
	      dataTransfer = createDataTransfer();
	      if (dataTransfer) {
	        for (i = 0, length = lengthOfArrayLike(value); i < length; i++) {
	          dataTransfer.items.add(structuredCloneInternal(value[i], map));
	        }
	        cloned = dataTransfer.files;
	      } else cloned = tryNativeRestrictedStructuredClone(value, type);
	      break;
	    case 'ImageData':
	      // Safari 9 ImageData is a constructor, but typeof ImageData is 'object'
	      try {
	        cloned = new ImageData(
	          structuredCloneInternal(value.data, map),
	          value.width,
	          value.height,
	          { colorSpace: value.colorSpace }
	        );
	      } catch (error) {
	        cloned = tryNativeRestrictedStructuredClone(value, type);
	      } break;
	    default:
	      if (nativeRestrictedStructuredClone) {
	        cloned = nativeRestrictedStructuredClone(value);
	      } else switch (type) {
	        case 'BigInt':
	          // can be a 3rd party polyfill
	          cloned = Object(value.valueOf());
	          break;
	        case 'Boolean':
	          cloned = Object(thisBooleanValue(value));
	          break;
	        case 'Number':
	          cloned = Object(thisNumberValue(value));
	          break;
	        case 'String':
	          cloned = Object(thisStringValue(value));
	          break;
	        case 'Date':
	          cloned = new Date(thisTimeValue(value));
	          break;
	        case 'Blob':
	          try {
	            cloned = value.slice(0, value.size, value.type);
	          } catch (error) {
	            throwUnpolyfillable(type);
	          } break;
	        case 'DOMPoint':
	        case 'DOMPointReadOnly':
	          C = globalThis[type];
	          try {
	            cloned = C.fromPoint
	              ? C.fromPoint(value)
	              : new C(value.x, value.y, value.z, value.w);
	          } catch (error) {
	            throwUnpolyfillable(type);
	          } break;
	        case 'DOMRect':
	        case 'DOMRectReadOnly':
	          C = globalThis[type];
	          try {
	            cloned = C.fromRect
	              ? C.fromRect(value)
	              : new C(value.x, value.y, value.width, value.height);
	          } catch (error) {
	            throwUnpolyfillable(type);
	          } break;
	        case 'DOMMatrix':
	        case 'DOMMatrixReadOnly':
	          C = globalThis[type];
	          try {
	            cloned = C.fromMatrix
	              ? C.fromMatrix(value)
	              : new C(value);
	          } catch (error) {
	            throwUnpolyfillable(type);
	          } break;
	        case 'AudioData':
	        case 'VideoFrame':
	          if (!isCallable(value.clone)) throwUnpolyfillable(type);
	          try {
	            cloned = value.clone();
	          } catch (error) {
	            throwUncloneable(type);
	          } break;
	        case 'CropTarget':
	        case 'CryptoKey':
	        case 'FileSystemDirectoryHandle':
	        case 'FileSystemFileHandle':
	        case 'FileSystemHandle':
	        case 'GPUCompilationInfo':
	        case 'GPUCompilationMessage':
	        case 'ImageBitmap':
	        case 'RTCCertificate':
	        case 'WebAssembly.Module':
	          throwUnpolyfillable(type);
	          // break omitted
	        default:
	          throwUncloneable(type);
	      }
	  }
	
	  mapSet(map, value, cloned);
	
	  switch (type) {
	    case 'Array':
	    case 'Object':
	      keys = objectKeys(value);
	      for (i = 0, length = lengthOfArrayLike(keys); i < length; i++) {
	        key = keys[i];
	        createProperty(cloned, key, structuredCloneInternal(value[key], map));
	      } break;
	    case 'Map':
	      value.forEach(function (v, k) {
	        mapSet(cloned, structuredCloneInternal(k, map), structuredCloneInternal(v, map));
	      });
	      break;
	    case 'Set':
	      value.forEach(function (v) {
	        setAdd(cloned, structuredCloneInternal(v, map));
	      });
	      break;
	    case 'Error':
	      createNonEnumerableProperty(cloned, 'message', structuredCloneInternal(value.message, map));
	      if (hasOwn(value, 'cause')) {
	        createNonEnumerableProperty(cloned, 'cause', structuredCloneInternal(value.cause, map));
	      }
	      if (name === 'AggregateError') {
	        cloned.errors = structuredCloneInternal(value.errors, map);
	      } else if (name === 'SuppressedError') {
	        cloned.error = structuredCloneInternal(value.error, map);
	        cloned.suppressed = structuredCloneInternal(value.suppressed, map);
	      } // break omitted
	    case 'DOMException':
	      if (ERROR_STACK_INSTALLABLE) {
	        createNonEnumerableProperty(cloned, 'stack', structuredCloneInternal(value.stack, map));
	      }
	  }
	
	  return cloned;
	};
	
	var tryToTransfer = function (rawTransfer, map) {
	  if (!isObject(rawTransfer)) throw new TypeError('Transfer option cannot be converted to a sequence');
	
	  var transfer = [];
	
	  iterate(rawTransfer, function (value) {
	    push(transfer, anObject(value));
	  });
	
	  var i = 0;
	  var length = lengthOfArrayLike(transfer);
	  var buffers = new Set();
	  var value, type, C, transferred, canvas, context;
	
	  while (i < length) {
	    value = transfer[i++];
	
	    type = classof(value);
	
	    if (type === 'ArrayBuffer' ? setHas(buffers, value) : mapHas(map, value)) {
	      throw new DOMException('Duplicate transferable', DATA_CLONE_ERROR);
	    }
	
	    if (type === 'ArrayBuffer') {
	      setAdd(buffers, value);
	      continue;
	    }
	
	    if (PROPER_STRUCTURED_CLONE_TRANSFER) {
	      transferred = nativeStructuredClone(value, { transfer: [value] });
	    } else switch (type) {
	      case 'ImageBitmap':
	        C = globalThis.OffscreenCanvas;
	        if (!isConstructor(C)) throwUnpolyfillable(type, TRANSFERRING);
	        try {
	          canvas = new C(value.width, value.height);
	          context = canvas.getContext('bitmaprenderer');
	          context.transferFromImageBitmap(value);
	          transferred = canvas.transferToImageBitmap();
	        } catch (error) { /* empty */ }
	        break;
	      case 'AudioData':
	      case 'VideoFrame':
	        if (!isCallable(value.clone) || !isCallable(value.close)) throwUnpolyfillable(type, TRANSFERRING);
	        try {
	          transferred = value.clone();
	          value.close();
	        } catch (error) { /* empty */ }
	        break;
	      case 'MediaSourceHandle':
	      case 'MessagePort':
	      case 'OffscreenCanvas':
	      case 'ReadableStream':
	      case 'TransformStream':
	      case 'WritableStream':
	        throwUnpolyfillable(type, TRANSFERRING);
	    }
	
	    if (transferred === undefined) throw new DOMException('This object cannot be transferred: ' + type, DATA_CLONE_ERROR);
	
	    mapSet(map, value, transferred);
	  }
	
	  return buffers;
	};
	
	var detachBuffers = function (buffers) {
	  setIterate(buffers, function (buffer) {
	    if (PROPER_STRUCTURED_CLONE_TRANSFER) {
	      nativeRestrictedStructuredClone(buffer, { transfer: [buffer] });
	    } else if (isCallable(buffer.transfer)) {
	      buffer.transfer();
	    } else if (detachTransferable) {
	      detachTransferable(buffer);
	    } else {
	      throwUnpolyfillable('ArrayBuffer', TRANSFERRING);
	    }
	  });
	};
	
	// `structuredClone` method
	// https://html.spec.whatwg.org/multipage/structured-data.html#dom-structuredclone
	$({ global: true, enumerable: true, sham: !PROPER_STRUCTURED_CLONE_TRANSFER, forced: FORCED_REPLACEMENT }, {
	  structuredClone: function structuredClone(value /* , { transfer } */) {
	    var options = validateArgumentsLength(arguments.length, 1) > 1 && !isNullOrUndefined(arguments[1]) ? anObject(arguments[1]) : undefined;
	    var transfer = options ? options.transfer : undefined;
	    var map, buffers;
	
	    if (transfer !== undefined) {
	      map = new Map();
	      buffers = tryToTransfer(transfer, map);
	    }
	
	    var clone = structuredCloneInternal(value, map);
	
	    // since of an issue with cloning views of transferred buffers, we a forced to detach them later
	    // https://github.com/zloirock/core-js/issues/1265
	    if (buffers) detachBuffers(buffers);
	
	    return clone;
	  }
	});


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1528);
	__webpack_require__(1529);


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineBuiltIn = __webpack_require__(40);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(18);
	var validateArgumentsLength = __webpack_require__(85);
	
	var $URLSearchParams = URLSearchParams;
	var URLSearchParamsPrototype = $URLSearchParams.prototype;
	var append = uncurryThis(URLSearchParamsPrototype.append);
	var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
	var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
	var push = uncurryThis([].push);
	var params = new $URLSearchParams('a=1&a=2&b=3');
	
	params['delete']('a', 1);
	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	params['delete']('b', undefined);
	
	if (params + '' !== 'a=2') {
	  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $delete(this, name);
	    var entries = [];
	    forEach(this, function (v, k) { // also validates `this`
	      push(entries, { key: k, value: v });
	    });
	    validateArgumentsLength(length, 1);
	    var key = toString(name);
	    var value = toString($value);
	    var index = 0;
	    var dindex = 0;
	    var found = false;
	    var entriesLength = entries.length;
	    var entry;
	    while (index < entriesLength) {
	      entry = entries[index++];
	      if (found || entry.key === key) {
	        found = true;
	        $delete(this, entry.key);
	      } else dindex++;
	    }
	    while (dindex < entriesLength) {
	      entry = entries[dindex++];
	      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
	    }
	  }, { enumerable: true, unsafe: true });
	}


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineBuiltIn = __webpack_require__(40);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(18);
	var validateArgumentsLength = __webpack_require__(85);
	
	var $URLSearchParams = URLSearchParams;
	var URLSearchParamsPrototype = $URLSearchParams.prototype;
	var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
	var $has = uncurryThis(URLSearchParamsPrototype.has);
	var params = new $URLSearchParams('a=1');
	
	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	if (params.has('a', 2) || !params.has('a', undefined)) {
	  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $has(this, name);
	    var values = getAll(this, name); // also validates `this`
	    validateArgumentsLength(length, 1);
	    var value = toString($value);
	    var index = 0;
	    while (index < values.length) {
	      if (values[index++] === value) return true;
	    } return false;
	  }, { enumerable: true, unsafe: true });
	}


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(704);


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(14);
	var uncurryThis = __webpack_require__(8);
	var defineBuiltInAccessor = __webpack_require__(50);
	
	var URLSearchParamsPrototype = URLSearchParams.prototype;
	var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
	
	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
	  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	    get: function size() {
	      var count = 0;
	      forEach(this, function () { count++; });
	      return count;
	    },
	    configurable: true,
	    enumerable: true
	  });
	}


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var fails = __webpack_require__(6);
	var validateArgumentsLength = __webpack_require__(85);
	var toString = __webpack_require__(18);
	var USE_NATIVE_URL = __webpack_require__(300);
	
	var URL = getBuiltIn('URL');
	
	// https://github.com/nodejs/node/issues/47505
	// https://github.com/denoland/deno/issues/18893
	var THROWS_WITHOUT_ARGUMENTS = USE_NATIVE_URL && fails(function () {
	  URL.canParse();
	});
	
	// Bun ~ 1.0.30 bug
	// https://github.com/oven-sh/bun/issues/9250
	var WRONG_ARITY = fails(function () {
	  return URL.canParse.length !== 1;
	});
	
	// `URL.canParse` method
	// https://url.spec.whatwg.org/#dom-url-canparse
	$({ target: 'URL', stat: true, forced: !THROWS_WITHOUT_ARGUMENTS || WRONG_ARITY }, {
	  canParse: function canParse(url) {
	    var length = validateArgumentsLength(arguments.length, 1);
	    var urlString = toString(url);
	    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
	    try {
	      return !!new URL(urlString, base);
	    } catch (error) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
	__webpack_require__(703);
	var $ = __webpack_require__(2);
	var DESCRIPTORS = __webpack_require__(14);
	var USE_NATIVE_URL = __webpack_require__(300);
	var globalThis = __webpack_require__(9);
	var bind = __webpack_require__(91);
	var uncurryThis = __webpack_require__(8);
	var defineBuiltIn = __webpack_require__(40);
	var defineBuiltInAccessor = __webpack_require__(50);
	var anInstance = __webpack_require__(97);
	var hasOwn = __webpack_require__(29);
	var assign = __webpack_require__(679);
	var arrayFrom = __webpack_require__(643);
	var arraySlice = __webpack_require__(89);
	var codeAt = __webpack_require__(294).codeAt;
	var toASCII = __webpack_require__(1244);
	var $toString = __webpack_require__(18);
	var setToStringTag = __webpack_require__(65);
	var validateArgumentsLength = __webpack_require__(85);
	var URLSearchParamsModule = __webpack_require__(704);
	var InternalStateModule = __webpack_require__(49);
	
	var setInternalState = InternalStateModule.set;
	var getInternalURLState = InternalStateModule.getterFor('URL');
	var URLSearchParams = URLSearchParamsModule.URLSearchParams;
	var getInternalSearchParamsState = URLSearchParamsModule.getState;
	
	var NativeURL = globalThis.URL;
	var TypeError = globalThis.TypeError;
	var parseInt = globalThis.parseInt;
	var floor = Math.floor;
	var pow = Math.pow;
	var charAt = uncurryThis(''.charAt);
	var exec = uncurryThis(/./.exec);
	var join = uncurryThis([].join);
	var numberToString = uncurryThis(1.0.toString);
	var pop = uncurryThis([].pop);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var shift = uncurryThis([].shift);
	var split = uncurryThis(''.split);
	var stringSlice = uncurryThis(''.slice);
	var toLowerCase = uncurryThis(''.toLowerCase);
	var unshift = uncurryThis([].unshift);
	
	var INVALID_AUTHORITY = 'Invalid authority';
	var INVALID_SCHEME = 'Invalid scheme';
	var INVALID_HOST = 'Invalid host';
	var INVALID_PORT = 'Invalid port';
	
	var ALPHA = /[a-z]/i;
	// eslint-disable-next-line regexp/no-obscure-range -- safe
	var ALPHANUMERIC = /[\d+-.a-z]/i;
	var DIGIT = /\d/;
	var HEX_START = /^0x/i;
	var OCT = /^[0-7]+$/;
	var DEC = /^\d+$/;
	var HEX = /^[\da-f]+$/i;
	/* eslint-disable regexp/no-control-character -- safe */
	var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
	var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
	var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
	var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
	var TAB_AND_NEW_LINE = /[\t\n\r]/g;
	/* eslint-enable regexp/no-control-character -- safe */
	var EOF;
	
	// https://url.spec.whatwg.org/#ipv4-number-parser
	var parseIPv4 = function (input) {
	  var parts = split(input, '.');
	  var partsLength, numbers, index, part, radix, number, ipv4;
	  if (parts.length && parts[parts.length - 1] === '') {
	    parts.length--;
	  }
	  partsLength = parts.length;
	  if (partsLength > 4) return input;
	  numbers = [];
	  for (index = 0; index < partsLength; index++) {
	    part = parts[index];
	    if (part === '') return input;
	    radix = 10;
	    if (part.length > 1 && charAt(part, 0) === '0') {
	      radix = exec(HEX_START, part) ? 16 : 8;
	      part = stringSlice(part, radix === 8 ? 1 : 2);
	    }
	    if (part === '') {
	      number = 0;
	    } else {
	      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
	      number = parseInt(part, radix);
	    }
	    push(numbers, number);
	  }
	  for (index = 0; index < partsLength; index++) {
	    number = numbers[index];
	    if (index === partsLength - 1) {
	      if (number >= pow(256, 5 - partsLength)) return null;
	    } else if (number > 255) return null;
	  }
	  ipv4 = pop(numbers);
	  for (index = 0; index < numbers.length; index++) {
	    ipv4 += numbers[index] * pow(256, 3 - index);
	  }
	  return ipv4;
	};
	
	// https://url.spec.whatwg.org/#concept-ipv6-parser
	// eslint-disable-next-line max-statements -- TODO
	var parseIPv6 = function (input) {
	  var address = [0, 0, 0, 0, 0, 0, 0, 0];
	  var pieceIndex = 0;
	  var compress = null;
	  var pointer = 0;
	  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
	
	  var chr = function () {
	    return charAt(input, pointer);
	  };
	
	  if (chr() === ':') {
	    if (charAt(input, 1) !== ':') return;
	    pointer += 2;
	    pieceIndex++;
	    compress = pieceIndex;
	  }
	  while (chr()) {
	    if (pieceIndex === 8) return;
	    if (chr() === ':') {
	      if (compress !== null) return;
	      pointer++;
	      pieceIndex++;
	      compress = pieceIndex;
	      continue;
	    }
	    value = length = 0;
	    while (length < 4 && exec(HEX, chr())) {
	      value = value * 16 + parseInt(chr(), 16);
	      pointer++;
	      length++;
	    }
	    if (chr() === '.') {
	      if (length === 0) return;
	      pointer -= length;
	      if (pieceIndex > 6) return;
	      numbersSeen = 0;
	      while (chr()) {
	        ipv4Piece = null;
	        if (numbersSeen > 0) {
	          if (chr() === '.' && numbersSeen < 4) pointer++;
	          else return;
	        }
	        if (!exec(DIGIT, chr())) return;
	        while (exec(DIGIT, chr())) {
	          number = parseInt(chr(), 10);
	          if (ipv4Piece === null) ipv4Piece = number;
	          else if (ipv4Piece === 0) return;
	          else ipv4Piece = ipv4Piece * 10 + number;
	          if (ipv4Piece > 255) return;
	          pointer++;
	        }
	        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
	        numbersSeen++;
	        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
	      }
	      if (numbersSeen !== 4) return;
	      break;
	    } else if (chr() === ':') {
	      pointer++;
	      if (!chr()) return;
	    } else if (chr()) return;
	    address[pieceIndex++] = value;
	  }
	  if (compress !== null) {
	    swaps = pieceIndex - compress;
	    pieceIndex = 7;
	    while (pieceIndex !== 0 && swaps > 0) {
	      swap = address[pieceIndex];
	      address[pieceIndex--] = address[compress + swaps - 1];
	      address[compress + --swaps] = swap;
	    }
	  } else if (pieceIndex !== 8) return;
	  return address;
	};
	
	var findLongestZeroSequence = function (ipv6) {
	  var maxIndex = null;
	  var maxLength = 1;
	  var currStart = null;
	  var currLength = 0;
	  var index = 0;
	  for (; index < 8; index++) {
	    if (ipv6[index] !== 0) {
	      if (currLength > maxLength) {
	        maxIndex = currStart;
	        maxLength = currLength;
	      }
	      currStart = null;
	      currLength = 0;
	    } else {
	      if (currStart === null) currStart = index;
	      ++currLength;
	    }
	  }
	  return currLength > maxLength ? currStart : maxIndex;
	};
	
	// https://url.spec.whatwg.org/#host-serializing
	var serializeHost = function (host) {
	  var result, index, compress, ignore0;
	
	  // ipv4
	  if (typeof host == 'number') {
	    result = [];
	    for (index = 0; index < 4; index++) {
	      unshift(result, host % 256);
	      host = floor(host / 256);
	    }
	    return join(result, '.');
	  }
	
	  // ipv6
	  if (typeof host == 'object') {
	    result = '';
	    compress = findLongestZeroSequence(host);
	    for (index = 0; index < 8; index++) {
	      if (ignore0 && host[index] === 0) continue;
	      if (ignore0) ignore0 = false;
	      if (compress === index) {
	        result += index ? ':' : '::';
	        ignore0 = true;
	      } else {
	        result += numberToString(host[index], 16);
	        if (index < 7) result += ':';
	      }
	    }
	    return '[' + result + ']';
	  }
	
	  return host;
	};
	
	var C0ControlPercentEncodeSet = {};
	var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
	  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
	});
	var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
	  '#': 1, '?': 1, '{': 1, '}': 1
	});
	var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
	  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
	});
	
	var percentEncode = function (chr, set) {
	  var code = codeAt(chr, 0);
	  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
	};
	
	// https://url.spec.whatwg.org/#special-scheme
	var specialSchemes = {
	  ftp: 21,
	  file: null,
	  http: 80,
	  https: 443,
	  ws: 80,
	  wss: 443
	};
	
	// https://url.spec.whatwg.org/#windows-drive-letter
	var isWindowsDriveLetter = function (string, normalized) {
	  var second;
	  return string.length === 2 && exec(ALPHA, charAt(string, 0))
	    && ((second = charAt(string, 1)) === ':' || (!normalized && second === '|'));
	};
	
	// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
	var startsWithWindowsDriveLetter = function (string) {
	  var third;
	  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
	    string.length === 2 ||
	    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
	  );
	};
	
	// https://url.spec.whatwg.org/#single-dot-path-segment
	var isSingleDot = function (segment) {
	  return segment === '.' || toLowerCase(segment) === '%2e';
	};
	
	// https://url.spec.whatwg.org/#double-dot-path-segment
	var isDoubleDot = function (segment) {
	  segment = toLowerCase(segment);
	  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
	};
	
	// States:
	var SCHEME_START = {};
	var SCHEME = {};
	var NO_SCHEME = {};
	var SPECIAL_RELATIVE_OR_AUTHORITY = {};
	var PATH_OR_AUTHORITY = {};
	var RELATIVE = {};
	var RELATIVE_SLASH = {};
	var SPECIAL_AUTHORITY_SLASHES = {};
	var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
	var AUTHORITY = {};
	var HOST = {};
	var HOSTNAME = {};
	var PORT = {};
	var FILE = {};
	var FILE_SLASH = {};
	var FILE_HOST = {};
	var PATH_START = {};
	var PATH = {};
	var CANNOT_BE_A_BASE_URL_PATH = {};
	var QUERY = {};
	var FRAGMENT = {};
	
	var URLState = function (url, isBase, base) {
	  var urlString = $toString(url);
	  var baseState, failure, searchParams;
	  if (isBase) {
	    failure = this.parse(urlString);
	    if (failure) throw new TypeError(failure);
	    this.searchParams = null;
	  } else {
	    if (base !== undefined) baseState = new URLState(base, true);
	    failure = this.parse(urlString, null, baseState);
	    if (failure) throw new TypeError(failure);
	    searchParams = getInternalSearchParamsState(new URLSearchParams());
	    searchParams.bindURL(this);
	    this.searchParams = searchParams;
	  }
	};
	
	URLState.prototype = {
	  type: 'URL',
	  // https://url.spec.whatwg.org/#url-parsing
	  // eslint-disable-next-line max-statements -- TODO
	  parse: function (input, stateOverride, base) {
	    var url = this;
	    var state = stateOverride || SCHEME_START;
	    var pointer = 0;
	    var buffer = '';
	    var seenAt = false;
	    var seenBracket = false;
	    var seenPasswordToken = false;
	    var codePoints, chr, bufferCodePoints, failure;
	
	    input = $toString(input);
	
	    if (!stateOverride) {
	      url.scheme = '';
	      url.username = '';
	      url.password = '';
	      url.host = null;
	      url.port = null;
	      url.path = [];
	      url.query = null;
	      url.fragment = null;
	      url.cannotBeABaseURL = false;
	      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
	      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
	    }
	
	    input = replace(input, TAB_AND_NEW_LINE, '');
	
	    codePoints = arrayFrom(input);
	
	    while (pointer <= codePoints.length) {
	      chr = codePoints[pointer];
	      switch (state) {
	        case SCHEME_START:
	          if (chr && exec(ALPHA, chr)) {
	            buffer += toLowerCase(chr);
	            state = SCHEME;
	          } else if (!stateOverride) {
	            state = NO_SCHEME;
	            continue;
	          } else return INVALID_SCHEME;
	          break;
	
	        case SCHEME:
	          if (chr && (exec(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
	            buffer += toLowerCase(chr);
	          } else if (chr === ':') {
	            if (stateOverride && (
	              (url.isSpecial() !== hasOwn(specialSchemes, buffer)) ||
	              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
	              (url.scheme === 'file' && !url.host)
	            )) return;
	            url.scheme = buffer;
	            if (stateOverride) {
	              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
	              return;
	            }
	            buffer = '';
	            if (url.scheme === 'file') {
	              state = FILE;
	            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
	              state = SPECIAL_RELATIVE_OR_AUTHORITY;
	            } else if (url.isSpecial()) {
	              state = SPECIAL_AUTHORITY_SLASHES;
	            } else if (codePoints[pointer + 1] === '/') {
	              state = PATH_OR_AUTHORITY;
	              pointer++;
	            } else {
	              url.cannotBeABaseURL = true;
	              push(url.path, '');
	              state = CANNOT_BE_A_BASE_URL_PATH;
	            }
	          } else if (!stateOverride) {
	            buffer = '';
	            state = NO_SCHEME;
	            pointer = 0;
	            continue;
	          } else return INVALID_SCHEME;
	          break;
	
	        case NO_SCHEME:
	          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
	          if (base.cannotBeABaseURL && chr === '#') {
	            url.scheme = base.scheme;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	            url.fragment = '';
	            url.cannotBeABaseURL = true;
	            state = FRAGMENT;
	            break;
	          }
	          state = base.scheme === 'file' ? FILE : RELATIVE;
	          continue;
	
	        case SPECIAL_RELATIVE_OR_AUTHORITY:
	          if (chr === '/' && codePoints[pointer + 1] === '/') {
	            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	            pointer++;
	          } else {
	            state = RELATIVE;
	            continue;
	          } break;
	
	        case PATH_OR_AUTHORITY:
	          if (chr === '/') {
	            state = AUTHORITY;
	            break;
	          } else {
	            state = PATH;
	            continue;
	          }
	
	        case RELATIVE:
	          url.scheme = base.scheme;
	          if (chr === EOF) {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
	            state = RELATIVE_SLASH;
	          } else if (chr === '?') {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = '';
	            state = QUERY;
	          } else if (chr === '#') {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	            url.fragment = '';
	            state = FRAGMENT;
	          } else {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.path.length--;
	            state = PATH;
	            continue;
	          } break;
	
	        case RELATIVE_SLASH:
	          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
	            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	          } else if (chr === '/') {
	            state = AUTHORITY;
	          } else {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            state = PATH;
	            continue;
	          } break;
	
	        case SPECIAL_AUTHORITY_SLASHES:
	          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	          if (chr !== '/' || charAt(buffer, pointer + 1) !== '/') continue;
	          pointer++;
	          break;
	
	        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
	          if (chr !== '/' && chr !== '\\') {
	            state = AUTHORITY;
	            continue;
	          } break;
	
	        case AUTHORITY:
	          if (chr === '@') {
	            if (seenAt) buffer = '%40' + buffer;
	            seenAt = true;
	            bufferCodePoints = arrayFrom(buffer);
	            for (var i = 0; i < bufferCodePoints.length; i++) {
	              var codePoint = bufferCodePoints[i];
	              if (codePoint === ':' && !seenPasswordToken) {
	                seenPasswordToken = true;
	                continue;
	              }
	              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
	              if (seenPasswordToken) url.password += encodedCodePoints;
	              else url.username += encodedCodePoints;
	            }
	            buffer = '';
	          } else if (
	            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
	            (chr === '\\' && url.isSpecial())
	          ) {
	            if (seenAt && buffer === '') return INVALID_AUTHORITY;
	            pointer -= arrayFrom(buffer).length + 1;
	            buffer = '';
	            state = HOST;
	          } else buffer += chr;
	          break;
	
	        case HOST:
	        case HOSTNAME:
	          if (stateOverride && url.scheme === 'file') {
	            state = FILE_HOST;
	            continue;
	          } else if (chr === ':' && !seenBracket) {
	            if (buffer === '') return INVALID_HOST;
	            failure = url.parseHost(buffer);
	            if (failure) return failure;
	            buffer = '';
	            state = PORT;
	            if (stateOverride === HOSTNAME) return;
	          } else if (
	            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
	            (chr === '\\' && url.isSpecial())
	          ) {
	            if (url.isSpecial() && buffer === '') return INVALID_HOST;
	            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
	            failure = url.parseHost(buffer);
	            if (failure) return failure;
	            buffer = '';
	            state = PATH_START;
	            if (stateOverride) return;
	            continue;
	          } else {
	            if (chr === '[') seenBracket = true;
	            else if (chr === ']') seenBracket = false;
	            buffer += chr;
	          } break;
	
	        case PORT:
	          if (exec(DIGIT, chr)) {
	            buffer += chr;
	          } else if (
	            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
	            (chr === '\\' && url.isSpecial()) ||
	            stateOverride
	          ) {
	            if (buffer !== '') {
	              var port = parseInt(buffer, 10);
	              if (port > 0xFFFF) return INVALID_PORT;
	              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
	              buffer = '';
	            }
	            if (stateOverride) return;
	            state = PATH_START;
	            continue;
	          } else return INVALID_PORT;
	          break;
	
	        case FILE:
	          url.scheme = 'file';
	          if (chr === '/' || chr === '\\') state = FILE_SLASH;
	          else if (base && base.scheme === 'file') {
	            switch (chr) {
	              case EOF:
	                url.host = base.host;
	                url.path = arraySlice(base.path);
	                url.query = base.query;
	                break;
	              case '?':
	                url.host = base.host;
	                url.path = arraySlice(base.path);
	                url.query = '';
	                state = QUERY;
	                break;
	              case '#':
	                url.host = base.host;
	                url.path = arraySlice(base.path);
	                url.query = base.query;
	                url.fragment = '';
	                state = FRAGMENT;
	                break;
	              default:
	                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
	                  url.host = base.host;
	                  url.path = arraySlice(base.path);
	                  url.shortenPath();
	                }
	                state = PATH;
	                continue;
	            }
	          } else {
	            state = PATH;
	            continue;
	          } break;
	
	        case FILE_SLASH:
	          if (chr === '/' || chr === '\\') {
	            state = FILE_HOST;
	            break;
	          }
	          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
	            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
	            else url.host = base.host;
	          }
	          state = PATH;
	          continue;
	
	        case FILE_HOST:
	          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
	            if (!stateOverride && isWindowsDriveLetter(buffer)) {
	              state = PATH;
	            } else if (buffer === '') {
	              url.host = '';
	              if (stateOverride) return;
	              state = PATH_START;
	            } else {
	              failure = url.parseHost(buffer);
	              if (failure) return failure;
	              if (url.host === 'localhost') url.host = '';
	              if (stateOverride) return;
	              buffer = '';
	              state = PATH_START;
	            } continue;
	          } else buffer += chr;
	          break;
	
	        case PATH_START:
	          if (url.isSpecial()) {
	            state = PATH;
	            if (chr !== '/' && chr !== '\\') continue;
	          } else if (!stateOverride && chr === '?') {
	            url.query = '';
	            state = QUERY;
	          } else if (!stateOverride && chr === '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr !== EOF) {
	            state = PATH;
	            if (chr !== '/') continue;
	          } break;
	
	        case PATH:
	          if (
	            chr === EOF || chr === '/' ||
	            (chr === '\\' && url.isSpecial()) ||
	            (!stateOverride && (chr === '?' || chr === '#'))
	          ) {
	            if (isDoubleDot(buffer)) {
	              url.shortenPath();
	              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
	                push(url.path, '');
	              }
	            } else if (isSingleDot(buffer)) {
	              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
	                push(url.path, '');
	              }
	            } else {
	              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
	                if (url.host) url.host = '';
	                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
	              }
	              push(url.path, buffer);
	            }
	            buffer = '';
	            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
	              while (url.path.length > 1 && url.path[0] === '') {
	                shift(url.path);
	              }
	            }
	            if (chr === '?') {
	              url.query = '';
	              state = QUERY;
	            } else if (chr === '#') {
	              url.fragment = '';
	              state = FRAGMENT;
	            }
	          } else {
	            buffer += percentEncode(chr, pathPercentEncodeSet);
	          } break;
	
	        case CANNOT_BE_A_BASE_URL_PATH:
	          if (chr === '?') {
	            url.query = '';
	            state = QUERY;
	          } else if (chr === '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr !== EOF) {
	            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
	          } break;
	
	        case QUERY:
	          if (!stateOverride && chr === '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr !== EOF) {
	            if (chr === "'" && url.isSpecial()) url.query += '%27';
	            else if (chr === '#') url.query += '%23';
	            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
	          } break;
	
	        case FRAGMENT:
	          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
	          break;
	      }
	
	      pointer++;
	    }
	  },
	  // https://url.spec.whatwg.org/#host-parsing
	  parseHost: function (input) {
	    var result, codePoints, index;
	    if (charAt(input, 0) === '[') {
	      if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
	      result = parseIPv6(stringSlice(input, 1, -1));
	      if (!result) return INVALID_HOST;
	      this.host = result;
	    // opaque host
	    } else if (!this.isSpecial()) {
	      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
	      result = '';
	      codePoints = arrayFrom(input);
	      for (index = 0; index < codePoints.length; index++) {
	        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
	      }
	      this.host = result;
	    } else {
	      input = toASCII(input);
	      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
	      result = parseIPv4(input);
	      if (result === null) return INVALID_HOST;
	      this.host = result;
	    }
	  },
	  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
	  cannotHaveUsernamePasswordPort: function () {
	    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
	  },
	  // https://url.spec.whatwg.org/#include-credentials
	  includesCredentials: function () {
	    return this.username !== '' || this.password !== '';
	  },
	  // https://url.spec.whatwg.org/#is-special
	  isSpecial: function () {
	    return hasOwn(specialSchemes, this.scheme);
	  },
	  // https://url.spec.whatwg.org/#shorten-a-urls-path
	  shortenPath: function () {
	    var path = this.path;
	    var pathSize = path.length;
	    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
	      path.length--;
	    }
	  },
	  // https://url.spec.whatwg.org/#concept-url-serializer
	  serialize: function () {
	    var url = this;
	    var scheme = url.scheme;
	    var username = url.username;
	    var password = url.password;
	    var host = url.host;
	    var port = url.port;
	    var path = url.path;
	    var query = url.query;
	    var fragment = url.fragment;
	    var output = scheme + ':';
	    if (host !== null) {
	      output += '//';
	      if (url.includesCredentials()) {
	        output += username + (password ? ':' + password : '') + '@';
	      }
	      output += serializeHost(host);
	      if (port !== null) output += ':' + port;
	    } else if (scheme === 'file') output += '//';
	    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
	    if (query !== null) output += '?' + query;
	    if (fragment !== null) output += '#' + fragment;
	    return output;
	  },
	  // https://url.spec.whatwg.org/#dom-url-href
	  setHref: function (href) {
	    var failure = this.parse(href);
	    if (failure) throw new TypeError(failure);
	    this.searchParams.update();
	  },
	  // https://url.spec.whatwg.org/#dom-url-origin
	  getOrigin: function () {
	    var scheme = this.scheme;
	    var port = this.port;
	    if (scheme === 'blob') try {
	      return new URLConstructor(scheme.path[0]).origin;
	    } catch (error) {
	      return 'null';
	    }
	    if (scheme === 'file' || !this.isSpecial()) return 'null';
	    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
	  },
	  // https://url.spec.whatwg.org/#dom-url-protocol
	  getProtocol: function () {
	    return this.scheme + ':';
	  },
	  setProtocol: function (protocol) {
	    this.parse($toString(protocol) + ':', SCHEME_START);
	  },
	  // https://url.spec.whatwg.org/#dom-url-username
	  getUsername: function () {
	    return this.username;
	  },
	  setUsername: function (username) {
	    var codePoints = arrayFrom($toString(username));
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    this.username = '';
	    for (var i = 0; i < codePoints.length; i++) {
	      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
	    }
	  },
	  // https://url.spec.whatwg.org/#dom-url-password
	  getPassword: function () {
	    return this.password;
	  },
	  setPassword: function (password) {
	    var codePoints = arrayFrom($toString(password));
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    this.password = '';
	    for (var i = 0; i < codePoints.length; i++) {
	      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
	    }
	  },
	  // https://url.spec.whatwg.org/#dom-url-host
	  getHost: function () {
	    var host = this.host;
	    var port = this.port;
	    return host === null ? ''
	      : port === null ? serializeHost(host)
	      : serializeHost(host) + ':' + port;
	  },
	  setHost: function (host) {
	    if (this.cannotBeABaseURL) return;
	    this.parse(host, HOST);
	  },
	  // https://url.spec.whatwg.org/#dom-url-hostname
	  getHostname: function () {
	    var host = this.host;
	    return host === null ? '' : serializeHost(host);
	  },
	  setHostname: function (hostname) {
	    if (this.cannotBeABaseURL) return;
	    this.parse(hostname, HOSTNAME);
	  },
	  // https://url.spec.whatwg.org/#dom-url-port
	  getPort: function () {
	    var port = this.port;
	    return port === null ? '' : $toString(port);
	  },
	  setPort: function (port) {
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    port = $toString(port);
	    if (port === '') this.port = null;
	    else this.parse(port, PORT);
	  },
	  // https://url.spec.whatwg.org/#dom-url-pathname
	  getPathname: function () {
	    var path = this.path;
	    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
	  },
	  setPathname: function (pathname) {
	    if (this.cannotBeABaseURL) return;
	    this.path = [];
	    this.parse(pathname, PATH_START);
	  },
	  // https://url.spec.whatwg.org/#dom-url-search
	  getSearch: function () {
	    var query = this.query;
	    return query ? '?' + query : '';
	  },
	  setSearch: function (search) {
	    search = $toString(search);
	    if (search === '') {
	      this.query = null;
	    } else {
	      if (charAt(search, 0) === '?') search = stringSlice(search, 1);
	      this.query = '';
	      this.parse(search, QUERY);
	    }
	    this.searchParams.update();
	  },
	  // https://url.spec.whatwg.org/#dom-url-searchparams
	  getSearchParams: function () {
	    return this.searchParams.facade;
	  },
	  // https://url.spec.whatwg.org/#dom-url-hash
	  getHash: function () {
	    var fragment = this.fragment;
	    return fragment ? '#' + fragment : '';
	  },
	  setHash: function (hash) {
	    hash = $toString(hash);
	    if (hash === '') {
	      this.fragment = null;
	      return;
	    }
	    if (charAt(hash, 0) === '#') hash = stringSlice(hash, 1);
	    this.fragment = '';
	    this.parse(hash, FRAGMENT);
	  },
	  update: function () {
	    this.query = this.searchParams.serialize() || null;
	  }
	};
	
	// `URL` constructor
	// https://url.spec.whatwg.org/#url-class
	var URLConstructor = function URL(url /* , base */) {
	  var that = anInstance(this, URLPrototype);
	  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
	  var state = setInternalState(that, new URLState(url, false, base));
	  if (!DESCRIPTORS) {
	    that.href = state.serialize();
	    that.origin = state.getOrigin();
	    that.protocol = state.getProtocol();
	    that.username = state.getUsername();
	    that.password = state.getPassword();
	    that.host = state.getHost();
	    that.hostname = state.getHostname();
	    that.port = state.getPort();
	    that.pathname = state.getPathname();
	    that.search = state.getSearch();
	    that.searchParams = state.getSearchParams();
	    that.hash = state.getHash();
	  }
	};
	
	var URLPrototype = URLConstructor.prototype;
	
	var accessorDescriptor = function (getter, setter) {
	  return {
	    get: function () {
	      return getInternalURLState(this)[getter]();
	    },
	    set: setter && function (value) {
	      return getInternalURLState(this)[setter](value);
	    },
	    configurable: true,
	    enumerable: true
	  };
	};
	
	if (DESCRIPTORS) {
	  // `URL.prototype.href` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-href
	  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
	  // `URL.prototype.origin` getter
	  // https://url.spec.whatwg.org/#dom-url-origin
	  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
	  // `URL.prototype.protocol` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-protocol
	  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
	  // `URL.prototype.username` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-username
	  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
	  // `URL.prototype.password` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-password
	  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
	  // `URL.prototype.host` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-host
	  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
	  // `URL.prototype.hostname` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-hostname
	  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
	  // `URL.prototype.port` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-port
	  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
	  // `URL.prototype.pathname` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-pathname
	  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
	  // `URL.prototype.search` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-search
	  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
	  // `URL.prototype.searchParams` getter
	  // https://url.spec.whatwg.org/#dom-url-searchparams
	  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
	  // `URL.prototype.hash` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-hash
	  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
	}
	
	// `URL.prototype.toJSON` method
	// https://url.spec.whatwg.org/#dom-url-tojson
	defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
	  return getInternalURLState(this).serialize();
	}, { enumerable: true });
	
	// `URL.prototype.toString` method
	// https://url.spec.whatwg.org/#URL-stringification-behavior
	defineBuiltIn(URLPrototype, 'toString', function toString() {
	  return getInternalURLState(this).serialize();
	}, { enumerable: true });
	
	if (NativeURL) {
	  var nativeCreateObjectURL = NativeURL.createObjectURL;
	  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
	  // `URL.createObjectURL` method
	  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
	  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
	  // `URL.revokeObjectURL` method
	  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
	  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
	}
	
	setToStringTag(URLConstructor, 'URL');
	
	$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
	  URL: URLConstructor
	});


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1537);


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var getBuiltIn = __webpack_require__(33);
	var validateArgumentsLength = __webpack_require__(85);
	var toString = __webpack_require__(18);
	var USE_NATIVE_URL = __webpack_require__(300);
	
	var URL = getBuiltIn('URL');
	
	// `URL.parse` method
	// https://url.spec.whatwg.org/#dom-url-canparse
	$({ target: 'URL', stat: true, forced: !USE_NATIVE_URL }, {
	  parse: function parse(url) {
	    var length = validateArgumentsLength(arguments.length, 1);
	    var urlString = toString(url);
	    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
	    try {
	      return new URL(urlString, base);
	    } catch (error) {
	      return null;
	    }
	  }
	});


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(2);
	var call = __webpack_require__(19);
	
	// `URL.prototype.toJSON` method
	// https://url.spec.whatwg.org/#dom-url-tojson
	$({ target: 'URL', proto: true, enumerable: true }, {
	  toJSON: function toJSON() {
	    return call(URL.prototype.toString, this);
	  }
	});


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(1460);
	__webpack_require__(1455);
	__webpack_require__(1453);
	__webpack_require__(1457);
	__webpack_require__(1458);
	__webpack_require__(1459);
	__webpack_require__(1463);
	__webpack_require__(1462);
	__webpack_require__(1464);
	__webpack_require__(1465);
	__webpack_require__(1466);
	__webpack_require__(1467);
	__webpack_require__(1468);
	__webpack_require__(1469);
	__webpack_require__(1470);
	__webpack_require__(1304);
	__webpack_require__(1305);
	__webpack_require__(1250);
	__webpack_require__(1248);
	__webpack_require__(1257);
	__webpack_require__(1258);
	__webpack_require__(1259);
	__webpack_require__(1260);
	__webpack_require__(1261);
	__webpack_require__(1262);
	__webpack_require__(1266);
	__webpack_require__(1263);
	__webpack_require__(1265);
	__webpack_require__(1264);
	__webpack_require__(1268);
	__webpack_require__(1267);
	__webpack_require__(1269);
	__webpack_require__(1270);
	__webpack_require__(1271);
	__webpack_require__(1272);
	__webpack_require__(1273);
	__webpack_require__(302);
	__webpack_require__(1274);
	__webpack_require__(1275);
	__webpack_require__(1276);
	__webpack_require__(1277);
	__webpack_require__(1278);
	__webpack_require__(1280);
	__webpack_require__(1279);
	__webpack_require__(1281);
	__webpack_require__(1282);
	__webpack_require__(1283);
	__webpack_require__(1284);
	__webpack_require__(1285);
	__webpack_require__(1286);
	__webpack_require__(1287);
	__webpack_require__(1288);
	__webpack_require__(1289);
	__webpack_require__(1291);
	__webpack_require__(1290);
	__webpack_require__(1292);
	__webpack_require__(1293);
	__webpack_require__(1251);
	__webpack_require__(1253);
	__webpack_require__(1254);
	__webpack_require__(1295);
	__webpack_require__(1252);
	__webpack_require__(1256);
	__webpack_require__(1255);
	__webpack_require__(1296);
	__webpack_require__(1297);
	__webpack_require__(1298);
	__webpack_require__(1299);
	__webpack_require__(1300);
	__webpack_require__(1301);
	__webpack_require__(1302);
	__webpack_require__(1303);
	__webpack_require__(1306);
	__webpack_require__(1307);
	__webpack_require__(1308);
	__webpack_require__(1309);
	__webpack_require__(1310);
	__webpack_require__(701);
	__webpack_require__(1311);
	__webpack_require__(1314);
	__webpack_require__(1313);
	__webpack_require__(1315);
	__webpack_require__(1316);
	__webpack_require__(1317);
	__webpack_require__(1318);
	__webpack_require__(1319);
	__webpack_require__(1320);
	__webpack_require__(1321);
	__webpack_require__(1322);
	__webpack_require__(1323);
	__webpack_require__(1324);
	__webpack_require__(1325);
	__webpack_require__(1326);
	__webpack_require__(1327);
	__webpack_require__(1328);
	__webpack_require__(1329);
	__webpack_require__(1330);
	__webpack_require__(1331);
	__webpack_require__(1332);
	__webpack_require__(1333);
	__webpack_require__(1334);
	__webpack_require__(1335);
	__webpack_require__(1336);
	__webpack_require__(1337);
	__webpack_require__(1338);
	__webpack_require__(1339);
	__webpack_require__(1340);
	__webpack_require__(1341);
	__webpack_require__(1342);
	__webpack_require__(1343);
	__webpack_require__(1344);
	__webpack_require__(1345);
	__webpack_require__(1346);
	__webpack_require__(1347);
	__webpack_require__(1348);
	__webpack_require__(1349);
	__webpack_require__(1350);
	__webpack_require__(1351);
	__webpack_require__(1352);
	__webpack_require__(1353);
	__webpack_require__(1354);
	__webpack_require__(1355);
	__webpack_require__(1356);
	__webpack_require__(1357);
	__webpack_require__(1359);
	__webpack_require__(1360);
	__webpack_require__(1361);
	__webpack_require__(1365);
	__webpack_require__(1362);
	__webpack_require__(1363);
	__webpack_require__(1364);
	__webpack_require__(1366);
	__webpack_require__(1367);
	__webpack_require__(1368);
	__webpack_require__(1369);
	__webpack_require__(1370);
	__webpack_require__(1371);
	__webpack_require__(1372);
	__webpack_require__(1373);
	__webpack_require__(1374);
	__webpack_require__(1375);
	__webpack_require__(1376);
	__webpack_require__(1383);
	__webpack_require__(1377);
	__webpack_require__(1379);
	__webpack_require__(1382);
	__webpack_require__(1387);
	__webpack_require__(1388);
	__webpack_require__(1389);
	__webpack_require__(1390);
	__webpack_require__(1391);
	__webpack_require__(1394);
	__webpack_require__(1392);
	__webpack_require__(1393);
	__webpack_require__(1395);
	__webpack_require__(1396);
	__webpack_require__(1397);
	__webpack_require__(1398);
	__webpack_require__(1400);
	__webpack_require__(1399);
	__webpack_require__(1401);
	__webpack_require__(1402);
	__webpack_require__(1403);
	__webpack_require__(431);
	__webpack_require__(1404);
	__webpack_require__(1405);
	__webpack_require__(1406);
	__webpack_require__(1407);
	__webpack_require__(1414);
	__webpack_require__(1409);
	__webpack_require__(1410);
	__webpack_require__(1411);
	__webpack_require__(1412);
	__webpack_require__(1413);
	__webpack_require__(1415);
	__webpack_require__(1416);
	__webpack_require__(1418);
	__webpack_require__(1422);
	__webpack_require__(1423);
	__webpack_require__(702);
	__webpack_require__(1427);
	__webpack_require__(1428);
	__webpack_require__(703);
	__webpack_require__(1432);
	__webpack_require__(1431);
	__webpack_require__(1433);
	__webpack_require__(1434);
	__webpack_require__(1435);
	__webpack_require__(1436);
	__webpack_require__(1438);
	__webpack_require__(1437);
	__webpack_require__(1439);
	__webpack_require__(1441);
	__webpack_require__(1442);
	__webpack_require__(1445);
	__webpack_require__(1447);
	__webpack_require__(1452);
	__webpack_require__(1448);
	__webpack_require__(1451);
	__webpack_require__(1417);
	__webpack_require__(1419);
	__webpack_require__(1420);
	__webpack_require__(1421);
	__webpack_require__(1424);
	__webpack_require__(1425);
	__webpack_require__(1426);
	__webpack_require__(1429);
	__webpack_require__(1430);
	__webpack_require__(1440);
	__webpack_require__(1443);
	__webpack_require__(1444);
	__webpack_require__(1446);
	__webpack_require__(1480);
	__webpack_require__(1481);
	__webpack_require__(1488);
	__webpack_require__(1486);
	__webpack_require__(1487);
	__webpack_require__(1508);
	__webpack_require__(1509);
	__webpack_require__(1506);
	__webpack_require__(1507);
	__webpack_require__(1471);
	__webpack_require__(1472);
	__webpack_require__(1473);
	__webpack_require__(1474);
	__webpack_require__(1475);
	__webpack_require__(1479);
	__webpack_require__(1476);
	__webpack_require__(1478);
	__webpack_require__(1477);
	__webpack_require__(1482);
	__webpack_require__(1483);
	__webpack_require__(1484);
	__webpack_require__(1485);
	__webpack_require__(1489);
	__webpack_require__(1490);
	__webpack_require__(1491);
	__webpack_require__(1492);
	__webpack_require__(1493);
	__webpack_require__(1495);
	__webpack_require__(1494);
	__webpack_require__(1496);
	__webpack_require__(1497);
	__webpack_require__(1498);
	__webpack_require__(1499);
	__webpack_require__(1500);
	__webpack_require__(1501);
	__webpack_require__(1502);
	__webpack_require__(1503);
	__webpack_require__(1504);
	__webpack_require__(1505);
	__webpack_require__(1510);
	__webpack_require__(1511);
	__webpack_require__(1513);
	__webpack_require__(1515);
	__webpack_require__(1516);
	__webpack_require__(1517);
	__webpack_require__(1519);
	__webpack_require__(1520);
	__webpack_require__(1521);
	__webpack_require__(1522);
	__webpack_require__(1523);
	__webpack_require__(1524);
	__webpack_require__(1525);
	__webpack_require__(1526);
	__webpack_require__(1530);
	__webpack_require__(1531);
	__webpack_require__(1538);
	__webpack_require__(1536);
	__webpack_require__(1539);
	__webpack_require__(1540);
	__webpack_require__(1534);
	__webpack_require__(1532);
	__webpack_require__(1533);
	__webpack_require__(1535);
	
	module.exports = __webpack_require__(417);


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(1025));
	var unitless = _interopDefault(__webpack_require__(1027));
	var hashString = _interopDefault(__webpack_require__(1024));
	var Stylis = _interopDefault(__webpack_require__(1026));
	var stylisRuleSheet = _interopDefault(__webpack_require__(2243));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    return oldProcessStyleValue(key, value);
	  };
	}
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        if (false) {
	          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
	        }
	
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = ("production") === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	    this.tags = [];
	    this.ctr = 0;
	    this.opts = options;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.inject = function inject() {
	    if (this.injected) {
	      throw new Error('already injected!');
	    }
	
	    this.tags[0] = makeStyleTag(this.opts);
	    this.injected = true;
	  };
	
	  _proto.speedy = function speedy(bool) {
	    if (this.ctr !== 0) {
	      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	      throw new Error("cannot change speedy now");
	    }
	
	    this.isSpeedy = !!bool;
	  };
	
	  _proto.insert = function insert(rule, sourceMap) {
	    // this is the ultrafast version, works across browsers
	    if (this.isSpeedy) {
	      var tag = this.tags[this.tags.length - 1];
	      var sheet = sheetForTag(tag);
	
	      try {
	        sheet.insertRule(rule, sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn('illegal rule', rule); // eslint-disable-line no-console
	        }
	      }
	    } else {
	      var _tag = makeStyleTag(this.opts);
	
	      this.tags.push(_tag);
	
	      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	    }
	
	    this.ctr++;
	
	    if (this.ctr % 65000 === 0) {
	      this.tags.push(makeStyleTag(this.opts));
	    }
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	    this.injected = false;
	  };
	
	  return StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (context.__SECRET_EMOTION__ !== undefined) {
	    return context.__SECRET_EMOTION__;
	  }
	
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (false) {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = stylisRuleSheet(insertRule);
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var caches = {
	    registered: {},
	    inserted: {},
	    nonce: options.nonce,
	    key: key
	  };
	  var sheet = new StyleSheet(options);
	
	  if (isBrowser) {
	    // 🚀
	    sheet.inject();
	  }
	
	  var stylis = new Stylis(stylisOptions);
	  stylis.use(options.stylisPlugins)(insertionPlugin);
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation.__emotion_styles !== undefined) {
	          var selector = interpolation.toString();
	
	          if (selector === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          return selector;
	        }
	
	        if (this === undefined && ("production") !== 'production') {
	          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    if (Array.isArray(obj)) {
	      obj.forEach(function (interpolation) {
	        string += handleInterpolation.call(this, interpolation, false);
	      }, this);
	    } else {
	      Object.keys(obj).forEach(function (key) {
	        if (typeof obj[key] !== 'object') {
	          if (caches.registered[obj[key]] !== undefined) {
	            string += key + "{" + caches.registered[obj[key]] + "}";
	          } else {
	            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	          }
	        } else {
	          if (key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
	            obj[key].forEach(function (value) {
	              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
	            });
	          } else {
	            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	          }
	        }
	      }, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var stylesWithLabel;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createClassName = function createClassName(styles, identifierName) {
	    return hashString(styles + identifierName) + identifierName;
	  };
	
	  if (false) {
	    var oldCreateClassName = createClassName;
	    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
	
	    createClassName = function createClassName(styles, identifierName) {
	      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
	        currentSourceMap = sourceMap;
	        return '';
	      }), identifierName);
	    };
	  }
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    stylesWithLabel = styles;
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = createClassName(styles, identifierName);
	    return styles;
	  };
	
	  if (false) {
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = stylesWithLabel;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  if (isBrowser) {
	    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(chunks, function (node) {
	      // $FlowFixMe
	      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	    });
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  context.__SECRET_EMOTION__ = emotion;
	  return emotion;
	}
	
	module.exports = createEmotion;


/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START_EVENT_NAME_MAP = {
	  transitionstart: {
	    transition: 'transitionstart',
	    WebkitTransition: 'webkitTransitionStart',
	    MozTransition: 'mozTransitionStart',
	    OTransition: 'oTransitionStart',
	    msTransition: 'MSTransitionStart'
	  },
	
	  animationstart: {
	    animation: 'animationstart',
	    WebkitAnimation: 'webkitAnimationStart',
	    MozAnimation: 'mozAnimationStart',
	    OAnimation: 'oAnimationStart',
	    msAnimation: 'MSAnimationStart'
	  }
	};
	
	var END_EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var startEvents = [];
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete START_EVENT_NAME_MAP.animationstart.animation;
	    delete END_EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete START_EVENT_NAME_MAP.transitionstart.transition;
	    delete END_EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  function process(EVENT_NAME_MAP, events) {
	    for (var baseEventName in EVENT_NAME_MAP) {
	      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	        var baseEvents = EVENT_NAME_MAP[baseEventName];
	        for (var styleName in baseEvents) {
	          if (styleName in style) {
	            events.push(baseEvents[styleName]);
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  process(START_EVENT_NAME_MAP, startEvents);
	  process(END_EVENT_NAME_MAP, endEvents);
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  // Start events
	  startEvents: startEvents,
	
	  addStartEventListener: function addStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      addEventListener(node, startEvent, eventListener);
	    });
	  },
	  removeStartEventListener: function removeStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      removeEventListener(node, startEvent, eventListener);
	    });
	  },
	
	
	  // End events
	  endEvents: endEvents,
	
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(376);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(1544);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(1221);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * cssfilter
	 *
	 * @author 老雷<leizongmin@gmail.com>
	 */
	
	var DEFAULT = __webpack_require__(706);
	var parseStyle = __webpack_require__(1547);
	var _ = __webpack_require__(707);
	
	
	/**
	 * 返回值是否为空
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 */
	function isNull (obj) {
	  return (obj === undefined || obj === null);
	}
	
	/**
	 * 浅拷贝对象
	 *
	 * @param {Object} obj
	 * @return {Object}
	 */
	function shallowCopyObject (obj) {
	  var ret = {};
	  for (var i in obj) {
	    ret[i] = obj[i];
	  }
	  return ret;
	}
	
	/**
	 * 创建CSS过滤器
	 *
	 * @param {Object} options
	 *   - {Object} whiteList
	 *   - {Function} onAttr
	 *   - {Function} onIgnoreAttr
	 *   - {Function} safeAttrValue
	 */
	function FilterCSS (options) {
	  options = shallowCopyObject(options || {});
	  options.whiteList = options.whiteList || DEFAULT.whiteList;
	  options.onAttr = options.onAttr || DEFAULT.onAttr;
	  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT.onIgnoreAttr;
	  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
	  this.options = options;
	}
	
	FilterCSS.prototype.process = function (css) {
	  // 兼容各种奇葩输入
	  css = css || '';
	  css = css.toString();
	  if (!css) return '';
	
	  var me = this;
	  var options = me.options;
	  var whiteList = options.whiteList;
	  var onAttr = options.onAttr;
	  var onIgnoreAttr = options.onIgnoreAttr;
	  var safeAttrValue = options.safeAttrValue;
	
	  var retCSS = parseStyle(css, function (sourcePosition, position, name, value, source) {
	
	    var check = whiteList[name];
	    var isWhite = false;
	    if (check === true) isWhite = check;
	    else if (typeof check === 'function') isWhite = check(value);
	    else if (check instanceof RegExp) isWhite = check.test(value);
	    if (isWhite !== true) isWhite = false;
	
	    // 如果过滤后 value 为空则直接忽略
	    value = safeAttrValue(name, value);
	    if (!value) return;
	
	    var opts = {
	      position: position,
	      sourcePosition: sourcePosition,
	      source: source,
	      isWhite: isWhite
	    };
	
	    if (isWhite) {
	
	      var ret = onAttr(name, value, opts);
	      if (isNull(ret)) {
	        return name + ':' + value;
	      } else {
	        return ret;
	      }
	
	    } else {
	
	      var ret = onIgnoreAttr(name, value, opts);
	      if (!isNull(ret)) {
	        return ret;
	      }
	
	    }
	  });
	
	  return retCSS;
	};
	
	
	module.exports = FilterCSS;


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * cssfilter
	 *
	 * @author 老雷<leizongmin@gmail.com>
	 */
	
	var _ = __webpack_require__(707);
	
	
	/**
	 * 解析style
	 *
	 * @param {String} css
	 * @param {Function} onAttr 处理属性的函数
	 *   参数格式： function (sourcePosition, position, name, value, source)
	 * @return {String}
	 */
	function parseStyle (css, onAttr) {
	  css = _.trimRight(css);
	  if (css[css.length - 1] !== ';') css += ';';
	  var cssLength = css.length;
	  var isParenthesisOpen = false;
	  var lastPos = 0;
	  var i = 0;
	  var retCSS = '';
	
	  function addNewAttr () {
	    // 如果没有正常的闭合圆括号，则直接忽略当前属性
	    if (!isParenthesisOpen) {
	      var source = _.trim(css.slice(lastPos, i));
	      var j = source.indexOf(':');
	      if (j !== -1) {
	        var name = _.trim(source.slice(0, j));
	        var value = _.trim(source.slice(j + 1));
	        // 必须有属性名称
	        if (name) {
	          var ret = onAttr(lastPos, retCSS.length, name, value, source);
	          if (ret) retCSS += ret + '; ';
	        }
	      }
	    }
	    lastPos = i + 1;
	  }
	
	  for (; i < cssLength; i++) {
	    var c = css[i];
	    if (c === '/' && css[i + 1] === '*') {
	      // 备注开始
	      var j = css.indexOf('*/', i + 2);
	      // 如果没有正常的备注结束，则后面的部分全部跳过
	      if (j === -1) break;
	      // 直接将当前位置调到备注结尾，并且初始化状态
	      i = j + 1;
	      lastPos = i + 1;
	      isParenthesisOpen = false;
	    } else if (c === '(') {
	      isParenthesisOpen = true;
	    } else if (c === ')') {
	      isParenthesisOpen = false;
	    } else if (c === ';') {
	      if (isParenthesisOpen) {
	        // 在圆括号里面，忽略
	      } else {
	        addNewAttr();
	      }
	    } else if (c === '\n') {
	      addNewAttr();
	    }
	  }
	
	  return _.trim(retCSS);
	}
	
	module.exports = parseStyle;


/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1548);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	var detectBrowser = __webpack_require__(1552);
	
	var agent;
	
	if (typeof navigator !== 'undefined' && navigator) {
	  agent = navigator.userAgent;
	}
	
	module.exports = detectBrowser(agent);


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	var detectOS = __webpack_require__(1553);
	
	module.exports = function detectBrowser(userAgentString) {
	  if (!userAgentString) return null;
	
	  var browsers = [
	    [ 'edge', /Edge\/([0-9\._]+)/ ],
	    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
	    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
	    [ 'kakaotalk', /KAKAOTALK\s([0-9\.]+)/ ],
	    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
	    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
	    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
	    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
	    [ 'ie', /MSIE\s(7\.0)/ ],
	    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
	    [ 'android', /Android\s([0-9\.]+)/ ],
	    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
	    [ 'safari', /Version\/([0-9\._]+).*Safari/ ]
	  ];
	
	  return browsers.map(function (rule) {
	      if (rule[1].test(userAgentString)) {
	          var match = rule[1].exec(userAgentString);
	          var version = match && match[1].split(/[._]/).slice(0,3);
	
	          if (version && version.length < 3) {
	              Array.prototype.push.apply(version, (version.length == 1) ? [0, 0] : [0]);
	          }
	
	          return {
	              name: rule[0],
	              version: version.join('.'),
	              os: detectOS(userAgentString)
	          };
	      }
	  }).filter(Boolean).shift();
	};


/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	module.exports = function detectOS(userAgentString) {
	  var operatingSystems = [
	    {
	      name: 'iOS',
	      rule: /iP(hone|od|ad)/
	    },
	    {
	      name: 'Android OS',
	      rule: /Android/
	    },
	    {
	      name: 'BlackBerry OS',
	      rule: /BlackBerry|BB10/
	    },
	    {
	      name: 'Windows Mobile',
	      rule: /IEMobile/
	    },
	    {
	      name: 'Amazon OS',
	      rule: /Kindle/
	    },
	    {
	      name: 'Windows 3.11',
	      rule: /Win16/
	    },
	    {
	      name: 'Windows 95',
	      rule: /(Windows 95)|(Win95)|(Windows_95)/
	    },
	    {
	      name: 'Windows 98',
	      rule: /(Windows 98)|(Win98)/
	    },
	    {
	      name: 'Windows 2000',
	      rule: /(Windows NT 5.0)|(Windows 2000)/
	    },
	    {
	      name: 'Windows XP',
	      rule: /(Windows NT 5.1)|(Windows XP)/
	    },
	    {
	      name: 'Windows Server 2003',
	      rule: /(Windows NT 5.2)/
	    },
	    {
	      name: 'Windows Vista',
	      rule: /(Windows NT 6.0)/
	    },
	    {
	      name: 'Windows 7',
	      rule: /(Windows NT 6.1)/
	    },
	    {
	      name: 'Windows 8',
	      rule: /(Windows NT 6.2)/
	    },
	    {
	      name: 'Windows 8.1',
	      rule: /(Windows NT 6.3)/
	    },
	    {
	      name: 'Windows 10',
	      rule: /(Windows NT 10.0)/
	    },
	    {
	      name: 'Windows ME',
	      rule: /Windows ME/
	    },
	    {
	      name: 'Open BSD',
	      rule: /OpenBSD/
	    },
	    {
	      name: 'Sun OS',
	      rule: /SunOS/
	    },
	    {
	      name: 'Linux',
	      rule: /(Linux)|(X11)/
	    },
	    {
	      name: 'Mac OS',
	      rule: /(Mac_PowerPC)|(Macintosh)/
	    },
	    {
	      name: 'QNX',
	      rule: /QNX/
	    },
	    {
	      name: 'BeOS',
	      rule: /BeOS/
	    },
	    {
	      name: 'OS/2',
	      rule: /OS\/2/
	    },
	    {
	      name: 'Search Bot',
	      rule: /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/
	    }
	  ];
	
	  var detected = operatingSystems.filter(function (os) {
	    if (userAgentString.match(os.rule)) {
	      return true;
	    }
	  });
	
	  return detected && detected[0] ? detected[0].name : null;
	};


/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendorPrefix;
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	function getTransitionName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
	}
	function getTransformName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
	}
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return {
	      x: parseFloat(matrix[12] || matrix[4], 0),
	      y: parseFloat(matrix[13] || matrix[5], 0)
	    };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, "matrix(".concat(arr.join(','), ")"));
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
	    }
	  } else {
	    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
	  }
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, _typeof(obj);
	}
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	var getComputedStyleX;
	
	// https://stackoverflow.com/a/3485654/3040605
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	  elem.style.display = originalStyle;
	}
	function css(el, name, v) {
	  var value = v;
	  if (_typeof(name) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = "".concat(value, "px");
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	function getClientPosition(elem) {
	  var box;
	  var x;
	  var y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = Math.floor(box.left);
	  y = Math.floor(box.top);
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}
	function getScroll(w, top) {
	  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
	  var method = "scroll".concat(top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	  if (node.nodeType === 9) {
	    return node;
	  }
	  return node.ownerDocument;
	}
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	  return val;
	}
	var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = getTransitionProperty(elem) || '';
	    setTransitionProperty(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = "".concat(presetH, "px");
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = "".concat(presetV, "px");
	  }
	  // force relayout
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  forceRelayout(elem);
	  if ('left' in offset || 'top' in offset) {
	    setTransitionProperty(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	function setTransform$1(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = getTransformXY(elem);
	  var resultXY = {
	    x: originalXY.x,
	    y: originalXY.y
	  };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  setTransformXY(elem, resultXY);
	}
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && getTransformName() in document.body.style) {
	    setTransform$1(elem, offset);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop;
	  var j;
	  var i;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = "".concat(prop).concat(which[i], "Width");
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	var domUtils = {
	  getParent: function getParent(element) {
	    var parent = element;
	    do {
	      if (parent.nodeType === 11 && parent.host) {
	        parent = parent.host;
	      } else {
	        parent = parent.parentNode;
	      }
	    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
	    return parent;
	  }
	};
	each(['Width', 'Height'], function (name) {
	  domUtils["doc".concat(name)] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement["scroll".concat(name)],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
	  };
	  domUtils["viewport".concat(name)] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = "client".concat(name);
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
	  var isBorderBox = isBorderBoxFn(elem);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
	}
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	  var val;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils["outer".concat(first)] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
	    }
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	mix(utils, domUtils);
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	var getParent = utils.getParent;
	function getOffsetParent(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return null;
	  }
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent;
	  var positionStyle = utils.css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
	  }
	  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
	    positionStyle = utils.css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	var getParent$1 = utils.getParent;
	function isAncestorFixed(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent = null;
	  for (parent = getParent$1(element);
	  // 修复元素位于 document.documentElement 下导致崩溃问题
	  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
	    var positionStyle = utils.css(parent, 'position');
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element, alwaysByViewport) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = getOffsetParent(element);
	  var doc = utils.getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
	      var pos = utils.offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = getOffsetParent(el);
	  }
	
	  // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	  var originalPosition = null;
	  if (!utils.isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = utils.css(element, 'position');
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight;
	
	  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
	  // We should cut this ourself.
	  var bodyStyle = window.getComputedStyle(body);
	  if (bodyStyle.overflowX === 'hidden') {
	    documentWidth = win.innerWidth;
	  }
	  if (bodyStyle.overflowY === 'hidden') {
	    documentHeight = win.innerHeight;
	  }
	
	  // Reset element position after calculate the visible area
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	  if (alwaysByViewport || isAncestorFixed(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = utils.clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	  return utils.mix(pos, size);
	}
	
	function getRegion(node) {
	  var offset;
	  var w;
	  var h;
	  if (!utils.isWindow(node) && node.nodeType !== 9) {
	    offset = utils.offset(node);
	    w = utils.outerWidth(node);
	    h = utils.outerHeight(node);
	  } else {
	    var win = utils.getWindow(node);
	    offset = {
	      left: utils.getWindowScrollLeft(win),
	      top: utils.getWindowScrollTop(win)
	    };
	    w = utils.viewportWidth(win);
	    h = utils.viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = region.left;
	  var y = region.top;
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = getAlignOffset(refNodeRegion, points[1]);
	  var p2 = getAlignOffset(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	  return {
	    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
	    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
	  };
	}
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	// http://yiminghe.iteye.com/blog/1124720
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	function flip(points, reg, map) {
	  var ret = [];
	  utils.each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	function convertOffset(str, offsetLen) {
	  var n;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
	  // 当前节点可以被放置的显示区域
	  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = getRegion(source);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = utils.merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	      utils.mix(newElRegion, elFuturePos);
	    }
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
	    // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	    if (isStillFailX || isStillFailY) {
	      var _newPoints2 = points;
	
	      // 重置对应部分的翻转逻辑
	      if (isStillFailX) {
	        _newPoints2 = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	      }
	      if (isStillFailY) {
	        _newPoints2 = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	      }
	      points = _newPoints2;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    }
	    // 2. 只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
	  }
	  if (newElRegion.height !== elRegion.height) {
	    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  utils.offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	function isOutOfVisibleRect(target, alwaysByViewport) {
	  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
	  var targetRegion = getRegion(target);
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = getRegion(target);
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
	  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	alignElement.__getOffsetParent = getOffsetParent;
	alignElement.__getVisibleRectForElement = getVisibleRectForElement;
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    enumerableOnly && (symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    })), keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = null != arguments[i] ? arguments[i] : {};
	    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
	      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	    });
	  }
	  return target;
	}
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX;
	  var pageY;
	  var doc = utils.getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
	
	  // Provide default target point
	  var points = [align.points[0], 'cc'];
	  return doAlign(el, tgtRegion, _objectSpread(_objectSpread({}, align), {}, {
	    points: points
	  }), pointInView);
	}
	
	exports.alignElement = alignElement;
	exports.alignPoint = alignPoint;
	exports.default = alignElement;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1021);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1556));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Resize detection strategy that injects objects to elements in order to detect resize events.
	 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
	 */
	
	"use strict";
	
	var browserDetector = __webpack_require__(710);
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	
	    if(!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        function listenerProxy() {
	            listener(element);
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support object, but supports the resize event directly on elements.
	            getState(element).object = {
	                proxy: listenerProxy
	            };
	            element.attachEvent("onresize", listenerProxy);
	        } else {
	            var object = getObject(element);
	
	            if(!object) {
	                throw new Error("Element is not detectable by this strategy.");
	            }
	
	            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
	        }
	    }
	
	    function buildCssTextString(rules) {
	        var seperator = options.important ? " !important; " : "; ";
	
	        return (rules.join(seperator) + seperator).trim();
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	        var debug = options.debug;
	
	        function injectObject(element, callback) {
	            var OBJECT_STYLE = buildCssTextString(["display: block", "position: absolute", "top: 0", "left: 0", "width: 100%", "height: 100%", "border: none", "padding: 0", "margin: 0", "opacity: 0", "z-index: -1000", "pointer-events: none"]);
	
	            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.
	
	            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
	            var positionCheckPerformed = false;
	
	            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
	            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
	            var style = window.getComputedStyle(element);
	            var width = element.offsetWidth;
	            var height = element.offsetHeight;
	
	            getState(element).startSize = {
	                width: width,
	                height: height
	            };
	
	            function mutateDom() {
	                function alterPositionStyles() {
	                    if(style.position === "static") {
	                        element.style.setProperty("position", "relative", options.important ? "important" : "");
	
	                        var removeRelativeStyles = function(reporter, element, style, property) {
	                            function getNumericalValue(value) {
	                                return value.replace(/[^-\d\.]/g, "");
	                            }
	
	                            var value = style[property];
	
	                            if(value !== "auto" && getNumericalValue(value) !== "0") {
	                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                                element.style.setProperty(property, "0", options.important ? "important" : "");
	                            }
	                        };
	
	                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                        removeRelativeStyles(reporter, element, style, "top");
	                        removeRelativeStyles(reporter, element, style, "right");
	                        removeRelativeStyles(reporter, element, style, "bottom");
	                        removeRelativeStyles(reporter, element, style, "left");
	                    }
	                }
	
	                function onObjectLoad() {
	                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
	                    if (!positionCheckPerformed) {
	                        alterPositionStyles();
	                    }
	
	                    /*jshint validthis: true */
	
	                    function getDocument(element, callback) {
	                        //Opera 12 seem to call the object.onload before the actual document has been created.
	                        //So if it is not present, poll it with an timeout until it is present.
	                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
	                        if(!element.contentDocument) {
	                            var state = getState(element);
	                            if (state.checkForObjectDocumentTimeoutId) {
	                                window.clearTimeout(state.checkForObjectDocumentTimeoutId);
	                            }
	                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
	                                state.checkForObjectDocumentTimeoutId = 0;
	                                getDocument(element, callback);
	                            }, 100);
	
	                            return;
	                        }
	
	                        callback(element.contentDocument);
	                    }
	
	                    //Mutating the object element here seems to fire another load event.
	                    //Mutating the inner document of the object element is fine though.
	                    var objectElement = this;
	
	                    //Create the style element to be added to the object.
	                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
	                        //Notify that the element is ready to be listened to.
	                        callback(element);
	                    });
	                }
	
	                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
	                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
	                if (style.position !== "") {
	                    alterPositionStyles(style);
	                    positionCheckPerformed = true;
	                }
	
	                //Add an object element as a child to the target element that will be listened to for resize events.
	                var object = document.createElement("object");
	                object.style.cssText = OBJECT_STYLE;
	                object.tabIndex = -1;
	                object.type = "text/html";
	                object.setAttribute("aria-hidden", "true");
	                object.onload = onObjectLoad;
	
	                //Safari: This must occur before adding the object to the DOM.
	                //IE: Does not like that this happens before, even if it is also added after.
	                if(!browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	
	                if (!getState(element)) {
	                    // The element has been uninstalled before the actual loading happened.
	                    return;
	                }
	
	                element.appendChild(object);
	                getState(element).object = object;
	
	                //IE: This must occur after adding the object to the DOM.
	                if(browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	            }
	
	            if(batchProcessor) {
	                batchProcessor.add(mutateDom);
	            } else {
	                mutateDom();
	            }
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support objects properly. Luckily they do support the resize event.
	            //So do not inject the object and notify that the element is already ready to be listened to.
	            //The event handler for the resize event is attached in the utils.addListener instead.
	            callback(element);
	        } else {
	            injectObject(element, callback);
	        }
	    }
	
	    /**
	     * Returns the child object of the target element.
	     * @private
	     * @param {element} element The target element.
	     * @returns The object element of the target.
	     */
	    function getObject(element) {
	        return getState(element).object;
	    }
	
	    function uninstall(element) {
	        if (!getState(element)) {
	            return;
	        }
	
	        var object = getObject(element);
	
	        if (!object) {
	            return;
	        }
	
	        if (browserDetector.isIE(8)) {
	            element.detachEvent("onresize", object.proxy);
	        } else {
	            element.removeChild(object);
	        }
	
	        if (getState(element).checkForObjectDocumentTimeoutId) {
	            window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
	        }
	
	        delete getState(element).object;
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall
	    };
	};


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
	 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
	 */
	
	"use strict";
	
	var forEach = __webpack_require__(711).forEach;
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	    var hasState        = options.stateHandler.hasState;
	    var idHandler       = options.idHandler;
	
	    if (!batchProcessor) {
	        throw new Error("Missing required dependency: batchProcessor");
	    }
	
	    if (!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    //TODO: Could this perhaps be done at installation time?
	    var scrollbarSizes = getScrollbarSizes();
	
	    var styleId = "erd_scroll_detection_scrollbar_style";
	    var detectionContainerClass = "erd_scroll_detection_container";
	
	    function initDocument(targetDocument) {
	        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
	        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
	        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
	    }
	
	    initDocument(window.document);
	
	    function buildCssTextString(rules) {
	        var seperator = options.important ? " !important; " : "; ";
	
	        return (rules.join(seperator) + seperator).trim();
	    }
	
	    function getScrollbarSizes() {
	        var width = 500;
	        var height = 500;
	
	        var child = document.createElement("div");
	        child.style.cssText = buildCssTextString(["position: absolute", "width: " + width*2 + "px", "height: " + height*2 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);
	
	        var container = document.createElement("div");
	        container.style.cssText = buildCssTextString(["position: absolute", "width: " + width + "px", "height: " + height + "px", "overflow: scroll", "visibility: none", "top: " + -width*3 + "px", "left: " + -height*3 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);
	
	        container.appendChild(child);
	
	        document.body.insertBefore(container, document.body.firstChild);
	
	        var widthSize = width - container.clientWidth;
	        var heightSize = height - container.clientHeight;
	
	        document.body.removeChild(container);
	
	        return {
	            width: widthSize,
	            height: heightSize
	        };
	    }
	
	    function injectScrollStyle(targetDocument, styleId, containerClass) {
	        function injectStyle(style, method) {
	            method = method || function (element) {
	                targetDocument.head.appendChild(element);
	            };
	
	            var styleElement = targetDocument.createElement("style");
	            styleElement.innerHTML = style;
	            styleElement.id = styleId;
	            method(styleElement);
	            return styleElement;
	        }
	
	        if (!targetDocument.getElementById(styleId)) {
	            var containerAnimationClass = containerClass + "_animation";
	            var containerAnimationActiveClass = containerClass + "_animation_active";
	            var style = "/* Created by the element-resize-detector library. */\n";
	            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString(["display: none"]) + " }\n\n";
	            style += "." + containerAnimationActiveClass + " { " + buildCssTextString(["-webkit-animation-duration: 0.1s", "animation-duration: 0.1s", "-webkit-animation-name: " + containerAnimationClass, "animation-name: " + containerAnimationClass]) + " }\n";
	            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
	            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
	            injectStyle(style);
	        }
	    }
	
	    function addAnimationClass(element) {
	        element.className += " " + detectionContainerClass + "_animation_active";
	    }
	
	    function addEvent(el, name, cb) {
	        if (el.addEventListener) {
	            el.addEventListener(name, cb);
	        } else if(el.attachEvent) {
	            el.attachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to add event listeners.");
	        }
	    }
	
	    function removeEvent(el, name, cb) {
	        if (el.removeEventListener) {
	            el.removeEventListener(name, cb);
	        } else if(el.detachEvent) {
	            el.detachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to remove event listeners.");
	        }
	    }
	
	    function getExpandElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
	    }
	
	    function getShrinkElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        var listeners = getState(element).listeners;
	
	        if (!listeners.push) {
	            throw new Error("Cannot add listener to an element that is not detectable.");
	        }
	
	        getState(element).listeners.push(listener);
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	
	        function debug() {
	            if (options.debug) {
	                var args = Array.prototype.slice.call(arguments);
	                args.unshift(idHandler.get(element), "Scroll: ");
	                if (reporter.log.apply) {
	                    reporter.log.apply(null, args);
	                } else {
	                    for (var i = 0; i < args.length; i++) {
	                        reporter.log(args[i]);
	                    }
	                }
	            }
	        }
	
	        function isDetached(element) {
	            function isInDocument(element) {
	                var isInShadowRoot = element.getRootNode && element.getRootNode().contains(element);
	                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element) || isInShadowRoot;
	            }
	
	            if (!isInDocument(element)) {
	                return true;
	            }
	
	            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
	            if (window.getComputedStyle(element) === null) {
	                return true;
	            }
	
	            return false;
	        }
	
	        function isUnrendered(element) {
	            // Check the absolute positioned container since the top level container is display: inline.
	            var container = getState(element).container.childNodes[0];
	            var style = window.getComputedStyle(container);
	            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
	        }
	
	        function getStyle() {
	            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
	            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
	            var elementStyle            = window.getComputedStyle(element);
	            var style                   = {};
	            style.position              = elementStyle.position;
	            style.width                 = element.offsetWidth;
	            style.height                = element.offsetHeight;
	            style.top                   = elementStyle.top;
	            style.right                 = elementStyle.right;
	            style.bottom                = elementStyle.bottom;
	            style.left                  = elementStyle.left;
	            style.widthCSS              = elementStyle.width;
	            style.heightCSS             = elementStyle.height;
	            return style;
	        }
	
	        function storeStartSize() {
	            var style = getStyle();
	            getState(element).startSize = {
	                width: style.width,
	                height: style.height
	            };
	            debug("Element start size", getState(element).startSize);
	        }
	
	        function initListeners() {
	            getState(element).listeners = [];
	        }
	
	        function storeStyle() {
	            debug("storeStyle invoked.");
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getStyle();
	            getState(element).style = style;
	        }
	
	        function storeCurrentSize(element, width, height) {
	            getState(element).lastWidth = width;
	            getState(element).lastHeight  = height;
	        }
	
	        function getExpandChildElement(element) {
	            return getExpandElement(element).childNodes[0];
	        }
	
	        function getWidthOffset() {
	            return 2 * scrollbarSizes.width + 1;
	        }
	
	        function getHeightOffset() {
	            return 2 * scrollbarSizes.height + 1;
	        }
	
	        function getExpandWidth(width) {
	            return width + 10 + getWidthOffset();
	        }
	
	        function getExpandHeight(height) {
	            return height + 10 + getHeightOffset();
	        }
	
	        function getShrinkWidth(width) {
	            return width * 2 + getWidthOffset();
	        }
	
	        function getShrinkHeight(height) {
	            return height * 2 + getHeightOffset();
	        }
	
	        function positionScrollbars(element, width, height) {
	            var expand          = getExpandElement(element);
	            var shrink          = getShrinkElement(element);
	            var expandWidth     = getExpandWidth(width);
	            var expandHeight    = getExpandHeight(height);
	            var shrinkWidth     = getShrinkWidth(width);
	            var shrinkHeight    = getShrinkHeight(height);
	            expand.scrollLeft   = expandWidth;
	            expand.scrollTop    = expandHeight;
	            shrink.scrollLeft   = shrinkWidth;
	            shrink.scrollTop    = shrinkHeight;
	        }
	
	        function injectContainerElement() {
	            var container = getState(element).container;
	
	            if (!container) {
	                container                   = document.createElement("div");
	                container.className         = detectionContainerClass;
	                container.style.cssText     = buildCssTextString(["visibility: hidden", "display: inline", "width: 0px", "height: 0px", "z-index: -1", "overflow: hidden", "margin: 0", "padding: 0"]);
	                getState(element).container = container;
	                addAnimationClass(container);
	                element.appendChild(container);
	
	                var onAnimationStart = function () {
	                    getState(element).onRendered && getState(element).onRendered();
	                };
	
	                addEvent(container, "animationstart", onAnimationStart);
	
	                // Store the event handler here so that they may be removed when uninstall is called.
	                // See uninstall function for an explanation why it is needed.
	                getState(element).onAnimationStart = onAnimationStart;
	            }
	
	            return container;
	        }
	
	        function injectScrollElements() {
	            function alterPositionStyles() {
	                var style = getState(element).style;
	
	                if(style.position === "static") {
	                    element.style.setProperty("position", "relative",options.important ? "important" : "");
	
	                    var removeRelativeStyles = function(reporter, element, style, property) {
	                        function getNumericalValue(value) {
	                            return value.replace(/[^-\d\.]/g, "");
	                        }
	
	                        var value = style[property];
	
	                        if(value !== "auto" && getNumericalValue(value) !== "0") {
	                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                            element.style[property] = 0;
	                        }
	                    };
	
	                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                    removeRelativeStyles(reporter, element, style, "top");
	                    removeRelativeStyles(reporter, element, style, "right");
	                    removeRelativeStyles(reporter, element, style, "bottom");
	                    removeRelativeStyles(reporter, element, style, "left");
	                }
	            }
	
	            function getLeftTopBottomRightCssText(left, top, bottom, right) {
	                left = (!left ? "0" : (left + "px"));
	                top = (!top ? "0" : (top + "px"));
	                bottom = (!bottom ? "0" : (bottom + "px"));
	                right = (!right ? "0" : (right + "px"));
	
	                return ["left: " + left, "top: " + top, "right: " + right, "bottom: " + bottom];
	            }
	
	            debug("Injecting elements");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            alterPositionStyles();
	
	            var rootContainer = getState(element).container;
	
	            if (!rootContainer) {
	                rootContainer = injectContainerElement();
	            }
	
	            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
	            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
	            // the targeted element.
	            // When the bug is resolved, "containerContainer" may be removed.
	
	            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
	            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.
	
	            var scrollbarWidth          = scrollbarSizes.width;
	            var scrollbarHeight         = scrollbarSizes.height;
	            var containerContainerStyle = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%", "left: 0px", "top: 0px"]);
	            var containerStyle          = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden"].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
	            var expandStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
	            var shrinkStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
	            var expandChildStyle        = buildCssTextString(["position: absolute", "left: 0", "top: 0"]);
	            var shrinkChildStyle        = buildCssTextString(["position: absolute", "width: 200%", "height: 200%"]);
	
	            var containerContainer      = document.createElement("div");
	            var container               = document.createElement("div");
	            var expand                  = document.createElement("div");
	            var expandChild             = document.createElement("div");
	            var shrink                  = document.createElement("div");
	            var shrinkChild             = document.createElement("div");
	
	            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
	            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
	            containerContainer.dir              = "ltr";
	
	            containerContainer.style.cssText    = containerContainerStyle;
	            containerContainer.className        = detectionContainerClass;
	            container.className                 = detectionContainerClass;
	            container.style.cssText             = containerStyle;
	            expand.style.cssText                = expandStyle;
	            expandChild.style.cssText           = expandChildStyle;
	            shrink.style.cssText                = shrinkStyle;
	            shrinkChild.style.cssText           = shrinkChildStyle;
	
	            expand.appendChild(expandChild);
	            shrink.appendChild(shrinkChild);
	            container.appendChild(expand);
	            container.appendChild(shrink);
	            containerContainer.appendChild(container);
	            rootContainer.appendChild(containerContainer);
	
	            function onExpandScroll() {
	                var state = getState(element);
	                if (state && state.onExpand) {
	                    state.onExpand();
	                } else {
	                    debug("Aborting expand scroll handler: element has been uninstalled");
	                }
	            }
	
	            function onShrinkScroll() {
	                var state = getState(element);
	                if (state && state.onShrink) {
	                    state.onShrink();
	                } else {
	                    debug("Aborting shrink scroll handler: element has been uninstalled");
	                }
	            }
	
	            addEvent(expand, "scroll", onExpandScroll);
	            addEvent(shrink, "scroll", onShrinkScroll);
	
	            // Store the event handlers here so that they may be removed when uninstall is called.
	            // See uninstall function for an explanation why it is needed.
	            getState(element).onExpandScroll = onExpandScroll;
	            getState(element).onShrinkScroll = onShrinkScroll;
	        }
	
	        function registerListenersAndPositionElements() {
	            function updateChildSizes(element, width, height) {
	                var expandChild             = getExpandChildElement(element);
	                var expandWidth             = getExpandWidth(width);
	                var expandHeight            = getExpandHeight(height);
	                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
	                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
	            }
	
	            function updateDetectorElements(done) {
	                var width           = element.offsetWidth;
	                var height          = element.offsetHeight;
	
	                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
	                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;
	
	                debug("Storing current size", width, height);
	
	                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
	                // Otherwise the if-check in handleScroll is useless.
	                storeCurrentSize(element, width, height);
	
	                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
	                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.
	
	                batchProcessor.add(0, function performUpdateChildSizes() {
	                    if (!sizeChanged) {
	                        return;
	                    }
	
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (!areElementsInjected()) {
	                        debug("Aborting because element container has not been initialized");
	                        return;
	                    }
	
	                    if (options.debug) {
	                        var w = element.offsetWidth;
	                        var h = element.offsetHeight;
	
	                        if (w !== width || h !== height) {
	                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
	                        }
	                    }
	
	                    updateChildSizes(element, width, height);
	                });
	
	                batchProcessor.add(1, function updateScrollbars() {
	                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
	                    // been restored to the original size, which will have changed the scrollbar positions.
	
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (!areElementsInjected()) {
	                        debug("Aborting because element container has not been initialized");
	                        return;
	                    }
	
	                    positionScrollbars(element, width, height);
	                });
	
	                if (sizeChanged && done) {
	                    batchProcessor.add(2, function () {
	                        if (!getState(element)) {
	                            debug("Aborting because element has been uninstalled");
	                            return;
	                        }
	
	                        if (!areElementsInjected()) {
	                          debug("Aborting because element container has not been initialized");
	                          return;
	                        }
	
	                        done();
	                    });
	                }
	            }
	
	            function areElementsInjected() {
	                return !!getState(element).container;
	            }
	
	            function notifyListenersIfNeeded() {
	                function isFirstNotify() {
	                    return getState(element).lastNotifiedWidth === undefined;
	                }
	
	                debug("notifyListenersIfNeeded invoked");
	
	                var state = getState(element);
	
	                // Don't notify if the current size is the start size, and this is the first notification.
	                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
	                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
	                }
	
	                // Don't notify if the size already has been notified.
	                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
	                    return debug("Not notifying: Size already notified");
	                }
	
	
	                debug("Current size not notified, notifying...");
	                state.lastNotifiedWidth = state.lastWidth;
	                state.lastNotifiedHeight = state.lastHeight;
	                forEach(getState(element).listeners, function (listener) {
	                    listener(element);
	                });
	            }
	
	            function handleRender() {
	                debug("startanimation triggered.");
	
	                if (isUnrendered(element)) {
	                    debug("Ignoring since element is still unrendered...");
	                    return;
	                }
	
	                debug("Element rendered.");
	                var expand = getExpandElement(element);
	                var shrink = getShrinkElement(element);
	                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
	                    debug("Scrollbars out of sync. Updating detector elements...");
	                    updateDetectorElements(notifyListenersIfNeeded);
	                }
	            }
	
	            function handleScroll() {
	                debug("Scroll detected.");
	
	                if (isUnrendered(element)) {
	                    // Element is still unrendered. Skip this scroll event.
	                    debug("Scroll event fired while unrendered. Ignoring...");
	                    return;
	                }
	
	                updateDetectorElements(notifyListenersIfNeeded);
	            }
	
	            debug("registerListenersAndPositionElements invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            getState(element).onRendered = handleRender;
	            getState(element).onExpand = handleScroll;
	            getState(element).onShrink = handleScroll;
	
	            var style = getState(element).style;
	            updateChildSizes(element, style.width, style.height);
	        }
	
	        function finalizeDomMutation() {
	            debug("finalizeDomMutation invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getState(element).style;
	            storeCurrentSize(element, style.width, style.height);
	            positionScrollbars(element, style.width, style.height);
	        }
	
	        function ready() {
	            callback(element);
	        }
	
	        function install() {
	            debug("Installing...");
	            initListeners();
	            storeStartSize();
	
	            batchProcessor.add(0, storeStyle);
	            batchProcessor.add(1, injectScrollElements);
	            batchProcessor.add(2, registerListenersAndPositionElements);
	            batchProcessor.add(3, finalizeDomMutation);
	            batchProcessor.add(4, ready);
	        }
	
	        debug("Making detectable...");
	
	        if (isDetached(element)) {
	            debug("Element is detached");
	
	            injectContainerElement();
	
	            debug("Waiting until element is attached...");
	
	            getState(element).onRendered = function () {
	                debug("Element is now attached");
	                install();
	            };
	        } else {
	            install();
	        }
	    }
	
	    function uninstall(element) {
	        var state = getState(element);
	
	        if (!state) {
	            // Uninstall has been called on a non-erd element.
	            return;
	        }
	
	        // Uninstall may have been called in the following scenarios:
	        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
	        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
	        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
	        // So to be on the safe side, let's check for each thing before removing.
	
	        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
	        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
	        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
	        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);
	
	        state.container && element.removeChild(state.container);
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall,
	        initDocument: initDocument
	    };
	};


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var forEach                 = __webpack_require__(711).forEach;
	var elementUtilsMaker       = __webpack_require__(1562);
	var listenerHandlerMaker    = __webpack_require__(1565);
	var idGeneratorMaker        = __webpack_require__(1563);
	var idHandlerMaker          = __webpack_require__(1564);
	var reporterMaker           = __webpack_require__(1566);
	var browserDetector         = __webpack_require__(710);
	var batchProcessorMaker     = __webpack_require__(1218);
	var stateHandler            = __webpack_require__(1567);
	
	//Detection strategies.
	var objectStrategyMaker     = __webpack_require__(1559);
	var scrollStrategyMaker     = __webpack_require__(1560);
	
	function isCollection(obj) {
	    return Array.isArray(obj) || obj.length !== undefined;
	}
	
	function toArray(collection) {
	    if (!Array.isArray(collection)) {
	        var array = [];
	        forEach(collection, function (obj) {
	            array.push(obj);
	        });
	        return array;
	    } else {
	        return collection;
	    }
	}
	
	function isElement(obj) {
	    return obj && obj.nodeType === 1;
	}
	
	/**
	 * @typedef idHandler
	 * @type {object}
	 * @property {function} get Gets the resize detector id of the element.
	 * @property {function} set Generate and sets the resize detector id of the element.
	 */
	
	/**
	 * @typedef Options
	 * @type {object}
	 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
	                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
	                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
	 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
	                                    If not provided, a default id handler will be used.
	 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
	                                    If not provided, a default id handler will be used.
	                                    If set to false, then nothing will be reported.
	 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
	 */
	
	/**
	 * Creates an element resize detector instance.
	 * @public
	 * @param {Options?} options Optional global options object that will decide how this instance will work.
	 */
	module.exports = function(options) {
	    options = options || {};
	
	    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var idHandler;
	
	    if (options.idHandler) {
	        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
	        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
	        idHandler = {
	            get: function (element) { return options.idHandler.get(element, true); },
	            set: options.idHandler.set
	        };
	    } else {
	        var idGenerator = idGeneratorMaker();
	        var defaultIdHandler = idHandlerMaker({
	            idGenerator: idGenerator,
	            stateHandler: stateHandler
	        });
	        idHandler = defaultIdHandler;
	    }
	
	    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var reporter = options.reporter;
	
	    if(!reporter) {
	        //If options.reporter is false, then the reporter should be quiet.
	        var quiet = reporter === false;
	        reporter = reporterMaker(quiet);
	    }
	
	    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));
	
	    //Options to be used as default for the listenTo function.
	    var globalOptions = {};
	    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
	    globalOptions.debug         = !!getOption(options, "debug", false);
	
	    var eventListenerHandler    = listenerHandlerMaker(idHandler);
	    var elementUtils            = elementUtilsMaker({
	        stateHandler: stateHandler
	    });
	
	    //The detection strategy to be used.
	    var detectionStrategy;
	    var desiredStrategy = getOption(options, "strategy", "object");
	    var importantCssRules = getOption(options, "important", false);
	    var strategyOptions = {
	        reporter: reporter,
	        batchProcessor: batchProcessor,
	        stateHandler: stateHandler,
	        idHandler: idHandler,
	        important: importantCssRules
	    };
	
	    if(desiredStrategy === "scroll") {
	        if (browserDetector.isLegacyOpera()) {
	            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
	            desiredStrategy = "object";
	        } else if (browserDetector.isIE(9)) {
	            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
	            desiredStrategy = "object";
	        }
	    }
	
	    if(desiredStrategy === "scroll") {
	        detectionStrategy = scrollStrategyMaker(strategyOptions);
	    } else if(desiredStrategy === "object") {
	        detectionStrategy = objectStrategyMaker(strategyOptions);
	    } else {
	        throw new Error("Invalid strategy name: " + desiredStrategy);
	    }
	
	    //Calls can be made to listenTo with elements that are still being installed.
	    //Also, same elements can occur in the elements list in the listenTo function.
	    //With this map, the ready callbacks can be synchronized between the calls
	    //so that the ready callback can always be called when an element is ready - even if
	    //it wasn't installed from the function itself.
	    var onReadyCallbacks = {};
	
	    /**
	     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
	     * @public
	     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
	     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
	     * @param {function} listener The callback to be executed for each resize event for each element.
	     */
	    function listenTo(options, elements, listener) {
	        function onResizeCallback(element) {
	            var listeners = eventListenerHandler.get(element);
	            forEach(listeners, function callListenerProxy(listener) {
	                listener(element);
	            });
	        }
	
	        function addListener(callOnAdd, element, listener) {
	            eventListenerHandler.add(element, listener);
	
	            if(callOnAdd) {
	                listener(element);
	            }
	        }
	
	        //Options object may be omitted.
	        if(!listener) {
	            listener = elements;
	            elements = options;
	            options = {};
	        }
	
	        if(!elements) {
	            throw new Error("At least one element required.");
	        }
	
	        if(!listener) {
	            throw new Error("Listener required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        var elementsReady = 0;
	
	        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
	        var onReadyCallback = getOption(options, "onReady", function noop() {});
	        var debug = getOption(options, "debug", globalOptions.debug);
	
	        forEach(elements, function attachListenerToElement(element) {
	            if (!stateHandler.getState(element)) {
	                stateHandler.initState(element);
	                idHandler.set(element);
	            }
	
	            var id = idHandler.get(element);
	
	            debug && reporter.log("Attaching listener to element", id, element);
	
	            if(!elementUtils.isDetectable(element)) {
	                debug && reporter.log(id, "Not detectable.");
	                if(elementUtils.isBusy(element)) {
	                    debug && reporter.log(id, "System busy making it detectable");
	
	                    //The element is being prepared to be detectable. Do not make it detectable.
	                    //Just add the listener, because the element will soon be detectable.
	                    addListener(callOnAdd, element, listener);
	                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
	                    onReadyCallbacks[id].push(function onReady() {
	                        elementsReady++;
	
	                        if(elementsReady === elements.length) {
	                            onReadyCallback();
	                        }
	                    });
	                    return;
	                }
	
	                debug && reporter.log(id, "Making detectable...");
	                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
	                elementUtils.markBusy(element, true);
	                return detectionStrategy.makeDetectable({ debug: debug, important: importantCssRules }, element, function onElementDetectable(element) {
	                    debug && reporter.log(id, "onElementDetectable");
	
	                    if (stateHandler.getState(element)) {
	                        elementUtils.markAsDetectable(element);
	                        elementUtils.markBusy(element, false);
	                        detectionStrategy.addListener(element, onResizeCallback);
	                        addListener(callOnAdd, element, listener);
	
	                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
	                        // so that a resize event may be emitted.
	                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
	                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
	                        var state = stateHandler.getState(element);
	                        if (state && state.startSize) {
	                            var width = element.offsetWidth;
	                            var height = element.offsetHeight;
	                            if (state.startSize.width !== width || state.startSize.height !== height) {
	                                onResizeCallback(element);
	                            }
	                        }
	
	                        if(onReadyCallbacks[id]) {
	                            forEach(onReadyCallbacks[id], function(callback) {
	                                callback();
	                            });
	                        }
	                    } else {
	                        // The element has been unisntalled before being detectable.
	                        debug && reporter.log(id, "Element uninstalled before being detectable.");
	                    }
	
	                    delete onReadyCallbacks[id];
	
	                    elementsReady++;
	                    if(elementsReady === elements.length) {
	                        onReadyCallback();
	                    }
	                });
	            }
	
	            debug && reporter.log(id, "Already detecable, adding listener.");
	
	            //The element has been prepared to be detectable and is ready to be listened to.
	            addListener(callOnAdd, element, listener);
	            elementsReady++;
	        });
	
	        if(elementsReady === elements.length) {
	            onReadyCallback();
	        }
	    }
	
	    function uninstall(elements) {
	        if(!elements) {
	            return reporter.error("At least one element is required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        forEach(elements, function (element) {
	            eventListenerHandler.removeAllListeners(element);
	            detectionStrategy.uninstall(element);
	            stateHandler.cleanState(element);
	        });
	    }
	
	    function initDocument(targetDocument) {
	        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
	    }
	
	    return {
	        listenTo: listenTo,
	        removeListener: eventListenerHandler.removeListener,
	        removeAllListeners: eventListenerHandler.removeAllListeners,
	        uninstall: uninstall,
	        initDocument: initDocument
	    };
	};
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}


/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(options) {
	    var getState = options.stateHandler.getState;
	
	    /**
	     * Tells if the element has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is detectable or not.
	     */
	    function isDetectable(element) {
	        var state = getState(element);
	        return state && !!state.isDetectable;
	    }
	
	    /**
	     * Marks the element that it has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to mark.
	     */
	    function markAsDetectable(element) {
	        getState(element).isDetectable = true;
	    }
	
	    /**
	     * Tells if the element is busy or not.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is busy or not.
	     */
	    function isBusy(element) {
	        return !!getState(element).busy;
	    }
	
	    /**
	     * Marks the object is busy and should not be made detectable.
	     * @public
	     * @param {element} element The element to mark.
	     * @param {boolean} busy If the element is busy or not.
	     */
	    function markBusy(element, busy) {
	        getState(element).busy = !!busy;
	    }
	
	    return {
	        isDetectable: isDetectable,
	        markAsDetectable: markAsDetectable,
	        isBusy: isBusy,
	        markBusy: markBusy
	    };
	};


/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function() {
	    var idCount = 1;
	
	    /**
	     * Generates a new unique id in the context.
	     * @public
	     * @returns {number} A unique id in the context.
	     */
	    function generate() {
	        return idCount++;
	    }
	
	    return {
	        generate: generate
	    };
	};


/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(options) {
	    var idGenerator     = options.idGenerator;
	    var getState        = options.stateHandler.getState;
	
	    /**
	     * Gets the resize detector id of the element.
	     * @public
	     * @param {element} element The target element to get the id of.
	     * @returns {string|number|null} The id of the element. Null if it has no id.
	     */
	    function getId(element) {
	        var state = getState(element);
	
	        if (state && state.id !== undefined) {
	            return state.id;
	        }
	
	        return null;
	    }
	
	    /**
	     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
	     * @public
	     * @param {element} element The target element to set the id of.
	     * @returns {string|number|null} The id of the element.
	     */
	    function setId(element) {
	        var state = getState(element);
	
	        if (!state) {
	            throw new Error("setId required the element to have a resize detection state.");
	        }
	
	        var id = idGenerator.generate();
	
	        state.id = id;
	
	        return id;
	    }
	
	    return {
	        get: getId,
	        set: setId
	    };
	};


/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(idHandler) {
	    var eventListeners = {};
	
	    /**
	     * Gets all listeners for the given element.
	     * @public
	     * @param {element} element The element to get all listeners for.
	     * @returns All listeners for the given element.
	     */
	    function getListeners(element) {
	        var id = idHandler.get(element);
	
	        if (id === undefined) {
	            return [];
	        }
	
	        return eventListeners[id] || [];
	    }
	
	    /**
	     * Stores the given listener for the given element. Will not actually add the listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The callback that the element has added.
	     */
	    function addListener(element, listener) {
	        var id = idHandler.get(element);
	
	        if(!eventListeners[id]) {
	            eventListeners[id] = [];
	        }
	
	        eventListeners[id].push(listener);
	    }
	
	    function removeListener(element, listener) {
	        var listeners = getListeners(element);
	        for (var i = 0, len = listeners.length; i < len; ++i) {
	            if (listeners[i] === listener) {
	              listeners.splice(i, 1);
	              break;
	            }
	        }
	    }
	
	    function removeAllListeners(element) {
	      var listeners = getListeners(element);
	      if (!listeners) { return; }
	      listeners.length = 0;
	    }
	
	    return {
	        get: getListeners,
	        add: addListener,
	        removeListener: removeListener,
	        removeAllListeners: removeAllListeners
	    };
	};


/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	"use strict";
	
	/* global console: false */
	
	/**
	 * Reporter that handles the reporting of logs, warnings and errors.
	 * @public
	 * @param {boolean} quiet Tells if the reporter should be quiet or not.
	 */
	module.exports = function(quiet) {
	    function noop() {
	        //Does nothing.
	    }
	
	    var reporter = {
	        log: noop,
	        warn: noop,
	        error: noop
	    };
	
	    if(!quiet && window.console) {
	        var attachFunction = function(reporter, name) {
	            //The proxy is needed to be able to call the method with the console context,
	            //since we cannot use bind.
	            reporter[name] = function reporterProxy() {
	                var f = console[name];
	                if (f.apply) { //IE9 does not support console.log.apply :)
	                    f.apply(console, arguments);
	                } else {
	                    for (var i = 0; i < arguments.length; i++) {
	                        f(arguments[i]);
	                    }
	                }
	            };
	        };
	
	        attachFunction(reporter, "log");
	        attachFunction(reporter, "warn");
	        attachFunction(reporter, "error");
	    }
	
	    return reporter;
	};

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	"use strict";
	
	var prop = "_erd";
	
	function initState(element) {
	    element[prop] = {};
	    return getState(element);
	}
	
	function getState(element) {
	    return element[prop];
	}
	
	function cleanState(element) {
	    delete element[prop];
	}
	
	module.exports = {
	    initState: initState,
	    getState: getState,
	    cleanState: cleanState
	};


/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 1574 */
713,
/* 1575 */
713,
/* 1576 */
713,
/* 1577 */
713,
/* 1578 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"markdown":"YjiqQOBv95Q6fH5KOk_zW","main-sub-div":"_31LhmaHH07GA9RiaqWwJuV","details-container":"_1j7nBeCPV2fAEIujUFVxB1","module-wrap":"_3ZR1T0KNzP3pDi0_cxJWV1","module-section":"apNwsmzVWKy8iPl9gZApf","module-section-heading":"_1FnZaMZtyHKrBS19UINcDv","module-section-content":"_36XXZ8e0knf27svtaa9MK","top-border":"_2Fqs76ypji2hf3bvQihsgi","bottom-border":"_3gKZBZsdmJWjMWUeuc7xbO","bottom-border-thick":"_2ZI-WuxwaHgkHgCfjh8_7g","border":"wTiAaFsKVOABucexYnLwa","green-link":"_3x9NQRwzcjBlj_x_XumdU","custom-select":"_23sRU_OqYnsvkITZkuZ3T5","greyButton":"_2HzuQVpKh-1jMev4N3AXuE","grayButtonFlex":"_1uoKTttAT8CY-IV3nL102V","refreshButton":"_3tM3QBF2QsboHvWtklb9AE","iconContainer":"_2N5kKTOhgwQhwQ1O-9a5Qw","btn":"_12cnbrtAqBhNgO7-kgCI6","green":"_1Ux93m5vP9dP7ahFNTShYS","inline-button":"_3_xCLWlN2aZo-kg5JlZWe","link-button":"_2GrNa01m7d9ZtzWEPb7oD4","dropdown-group":"a1v788xE0hJqp3tvr9kPQ","dropdown-indicator":"QWdOM2v_KZNlQnnGC5b5c","dropdown-arrow":"_2l5kEDFl5s5C_Z6vmgvYiw","buttonGreen":"_13yGns8ZLrW6bwSbDI1TO3","pull-left":"_1z7hJelXWr6UXnnFIQNG-k","pull-right":"_20HntS8lP0hO0PkmL9GhBZ","clearfix":"_1ZQdCfPKSY_LdP5G6jI25j","grey-color-theme":"D5rw3yIM6kMVDKktHjMso","grey-select":"_1iCp6z5RPxpvaCqvfoKi14","main-search":"gOiBNAyUNdZe4h9QGLJ1A","left-logo":"_20LCktF_vS-gI16hkcpKEX","small-input":"riAEiK3fpVC9mvcgv4zaH","app-container":"Jmqi9hn711WcA2EYjp9Ik","app-container-row":"WMLKLYUSpzgP-IZGQ3dAU","main-content-container":"_2beCMZzQg4xUrKpzVHsVsy","main":"_1bDo-1_PPy96yUklQNTZSA","mobile-header":"_3YZbN43V0_G5uLLkaUMnFH","button-menu":"_2bPitStFaKJxj6WjNSipBG","mobile-glyph-container":"_1UumMJmPzBqrxYDJgmD-Gs","text-menu":"_1ie9f9c5TPkz7IugpAxVPI","icon-menu":"_3ZVVLUHj6V4FeMP_u8Hgql","logo-glyph-white-m":"_3Aj-Zxkaj0ftnYlIRfaVwn","search-container":"_2BSu73hvAQ79N3Yygoe6sg","search-logo":"_3hZ79Zw4ZFTrKCZDO-ZPGJ","main-hr":"_3DQt9u2S3krDoct24Fthqw","main-title-div":"_1XkMe22AkmTiYVG0H9cLKz","main-checkbox":"_1-GrZRUAB4qixtYrBnRshk","main-nav-container":"_1mkhyxETBO_XoRjITMbFoW","expand":"_3fGlp2ghPRpqlRAJ2i7cQl","narrow":"_2EIPlveFL4qqpyLokFwvr4","nav-logo":"_3Ix_XXwhlvEQKSKxTI1MCt","nav-icon-text":"sbDLkjeu8xdQv0df7Zh-u","button-toggle":"_2rulY_KuG_SkQwOBZJI3qe","nav-wrapper":"_1nH2WqjOnkJ17M9iSL7kq4","inactive":"_26y-1xi-Dj3GcYK8t6z6hH","news":"_10CUfB4qlLgtudK3J_4VDG","inbox":"_3iah53v2Qhg84o-KNc-_jA","outbox":"_8Gt4iRdQ4G-UdTLiWXP3","agenda":"i2Ffx8obhCTFtOkVwBrZi","office":"_3I7LVx2bX86ulB947-jhLO","clients":"_1E6h5VlT4rVOrXd0iLBjqi","production":"ryN4tOdFrFKO5NNq9vaD8","claims":"ChZm_Y__rCMDeQiFEUAdY","willdoc":"_2bgYr6C0ta5crEkvyJwUo3","faq":"_3Rrvvh0Ok6labnj4KhikGh","links":"_27hyba6kKyhT8I6kwLWOsW","logout":"_2QfqEopoi2_Rxmp-jmhMdt","active":"_1iqUdQG4aRDFsG8Ha-U9Ev","disclaimer":"_1dJUcgGUNhO3YgBPDyonoQ","logo":"_2QwRudA6hlW7aHO3Hag0k8","will-logo":"_31HhqTD-aHT1CasPhzL4sb","logo-glyph-white":"_234szONKg3hL0MaAVpgfsn","nav-icon-div":"_2_QZ_m9EWsNil4sISPHRFU","nav-icon":"_20rxt__KwlVWQBPplu6ULT","icon-mid":"_1mcPj3oqmLtkuCoaxnv2-7","icon-container":"_2ePHiqxi2F2jAVn9b-Xlg2","st-menu-open":"_3rwGvOpH6hpTlcURPWH2LR","st-effect-2":"_21SDlV6nqeMkynFXSSJdg8","subNav":"_2tMcv6cOKTbzOwZqDlPjia","headingcell":"_2HAZbUme8aLOn4qe72ogXe","cell":"_3dTR14KFUeZAL9DFEdrl3M","arrow-row":"_2Mi3yk_uR1iYla_ZXHRrPA","table-row":"_3yXNAMA85RLU_7SBXq7Uv","hover-table":"_3GI6QV-efMR8J_1_AH8RfH","pointer-table":"_2XvMNZYLJN-EjplLv0L9QH","table-heading":"_2Z_vp_d9P1EIoszX8eaWda","table-content":"_3yiOximKxuyqs16-0IAysW","main-title-container":"_25ae4Eqc0tWuS0dWFFi9Xw","main-title":"_2Pb9sIMqcE9jSxoy_vG30R","sub-title":"_1pnB6yoC2N3ylDmjzK8pF1","group":"_38F631QRbS9BH9z8SnwR-6","clear":"_2O0D1CEJRPYJ2EaXEQ0fOJ","anIcon":"rhHsUGJW6dHknve7joRby","button":"_1SXcqLoAGVSlThKVK8TydH","inputDiv":"_2DsR7oRSgWi0oi8unt-Ogb","hidden":"_-dT_0OLJiz_BPV36Leeie","template":"jLabpULHL4AuSgRF0PN_m","app":"_9v4GlOELKRWGb_4b2UxyZ","grayBody":"_1EoyAx98gstBR1sc6psxaX","centerContent":"_2GMHc7pi5cS_VzPngJh4kB","centerPage":"_34BRhdalItc3Egdp1M_0M5","flex1":"gggJglSBRU6g4DItvr4CG","error":"_1EXbMJOoH2JeJ03iHDDjlJ","key-value-column":"_2hIL4qmy0wCKE5hwKfDGz8","keyValuePair":"_2xo6ymZAsol8jlClelHEvR","key":"_3wTOATTNmEHjB_2atSubOs","value":"b7AbNghLZyYzQWppF9X6y","drop-container":"_3ofNdYt2Fw1b5Sc33ArZLw","pdf-icon":"_1AYRkY1YCa-DjvqC90XbjM","reactable-header-sort-asc":"_2lgD-JeDcbYlAYCeSg5-SV","reactable-header-sort-desc":"_1aVSu0zSRpUkxpO0wQ-1wb","reactable-pagination":"_3R00qVehd4mT89X9fGGNK0","reactable-current-page":"Z2BVbbagyzYNMbLgHFlx-","upload":"XXai_rainx57NhfKupT8q","input-calendar-value":"_34wuXp8Z88gdSjplxVZ2MQ","input-calendar-clear":"_3lOwiVaL1mK1GdmiBjfXoc","input-calendar-wrapper":"_25KfN5mEvUKca8yKWOBbaT","today":"_1LjjocdzmzHEVd-oVFlBZA","view":"_1S99JA0aHdMN68gK-xlcSC","days-view":"_3Vq9qnZG6cDmcBqDVadGYR","navigation-wrapper":"_1_lSxdw_xVTp9Kx8CdgVda","undefined":"J4bZZSm5DzeNReSdXoZ0B","null":"VsnDdn61PQLC3hKXu69DD","false":"DUzzKRmjWK4JE9AaqZUke","tox":"_21aQr9G-bilkgq-dHk6bzQ","tox-editor-header":"_2oRWxCqrEdBAJdP5hydRH2","buttonsWrapper":"_2oJBoZAM0ZzQHoS5IpQ74n","modalButtons":"_3Utabtupd6adKNBmvtukje","cancel":"_1TGnA8hjFzwuHl6x6gK5pw","greenButton":"_5KwDn0FOgc4PvU6AIdIxQ","leftBtnContainer":"aWcnx3vXQYM9iy6pUFY7T"};

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"markdown":"_77D_-9XatJ4OxEAH_RDGL","main-sub-div":"V7B0GaGhZGkN6WLWF5_7d","details-container":"_3hbLFpTHVTmksqxTZ24yay","module-wrap":"_171lsD7MW7BDTdKHbesE-K","module-section":"_3uFdwzgplNYY94m87UvIc1","module-section-heading":"_1bWGMC13r6oaAicZBwJ_mL","module-section-content":"_23UurjOd76BrVpndzp5uCl","top-border":"_2hMtk3nhmxqcOGwtvvAPli","bottom-border":"_3szjjkBjudUDUjkRHDyRwk","bottom-border-thick":"CnbFAM02_NNhOCKjMHuKZ","border":"_2RCpeMWYYn4Xp8hIYv_IuR","green-link":"_3CSWK0UrUguzLrSEoEiGXQ","custom-select":"_3pLozbsZ1HGfZuTSyTyQnk","greyButton":"_3QYRxNfgU-pJQPbMtzrPd8","grayButtonFlex":"_2-GRXNgEmGYVgDWsGTHxHj","refreshButton":"yK191Y_AZasUGALHQrM4P","iconContainer":"_2rnPX2inKNE5c1LWxSX0fW","btn":"_3Bq4LxF8eB2chb6TeeIeRR","green":"_2fIdZYclNwsulAN9C7zt1K","inline-button":"SwQ1JvoAE8voyv__uLSot","link-button":"_2F7xvB5a74u01PA6j6BaZ1","dropdown-group":"_2XCGRwxyMG5TxXYqPgMXSu","dropdown-indicator":"_19veK33QXQ1I5cTXM06dGL","dropdown-arrow":"Ryf4lKItbzoU5Uc_1HA-7","buttonGreen":"UY3KoJDNT78PZn89ZgkQ5","pull-left":"_2vfJgoJ5eJLdeXvonYa5AD","pull-right":"_3TILqs1x3xZy0hNyiz8YZ0","clearfix":"_1AcljAjX6xxep-SIDKN6j_","grey-color-theme":"_1LzfcUSpBI_gkdYJX2Fojk","grey-select":"_2mbY8z3Am9hl0WOA1NGhfw","main-search":"_1vZz3nVTffb7PSlIgFqef2","left-logo":"D6pcL6EETb_aKCG4qBmo3","small-input":"_3cjfU4SDcASwQb9dVtj7ri","app-container":"m-OcSfEVj4k-N3NKIL2T0","app-container-row":"_2ue65tJfNSGMqQcFSfWinU","main-content-container":"_3xGgyLDdSz4CnRefLhtmoV","main":"_25d7OAmpNs-1CJxWRtfX-G","mobile-header":"N28phIjf5PtMVL_C9fk2Y","button-menu":"_38GFZU3imsg22lTcr2G3JJ","mobile-glyph-container":"_37i6i5xisZcTZandLB4xoa","text-menu":"_ILSwrMOoH_zeFoLmiQiP","icon-menu":"_1ih-SbmhZortymPAScUXOs","logo-glyph-white-m":"_2UxJC0XdgQX52TwfQA4Bru","search-container":"_2Kn14ax-p2GJ-Nfth_cWh-","search-logo":"_2hBZ4A_lePPO6Ntl7LbH9s","main-hr":"_2-hncfwrf9-G3CV9MaToZj","main-title-div":"_21iionjPffMijJQRA8ieQa","main-checkbox":"n1muKOUwhxdqI50SWkZLG","main-nav-container":"_2AuihyC1szT4izQ6Hcll7V","expand":"_2q09P1a3QnDFVagn2ehppe","narrow":"_3IdAyFUjelvbYl83xbheIE","nav-logo":"rR8sVuH8Mk-0LAfcDHVyy","nav-icon-text":"_2GgqLZn134K0Y2Ts58Tk9R","button-toggle":"y6rY-jTsMTEMlARt3QBYP","nav-wrapper":"_1Mk8oGbpkKZkg6wdtKDSGd","inactive":"_3ULAAVv7W1ptq25ilA2nI1","news":"_3LUMd2TAbtnIExIaY8-72L","inbox":"e3vVsg9JzL9YLcjgJadkr","outbox":"_476023aMIWHsLoFKVzE09","agenda":"_1WnDGtVy1REyImql934PcZ","office":"SkPmL7uwcrIVGOiaH2dIX","clients":"_2XJpUwNInt7Dt3R03qjldg","production":"_3NbQM3B18jTwyWVkB7pDLr","claims":"_3BultS52lao6Wi-zR46cfH","willdoc":"_2Jql2Df_a51w5HSmA3x1Fb","faq":"_1dsGC9jJrD45cEAeTqtIMV","links":"_3dhmX0qgR26Db1d8QvxdQs","logout":"_2XQISyvtfMQQQ5kLC548My","active":"_1RJedROK7-5eNNW7wNovJ7","disclaimer":"_335GLbZZpScyjM2M--AUkv","logo":"S_yWGlCPYsp5zIXn6TK9B","will-logo":"G_Hx6Crk9KVNjqZJo3VZ","logo-glyph-white":"_1WvSe39ifRA--9G732ivDj","nav-icon-div":"_32WQ__rIWf3Q5oiLJglw9h","nav-icon":"de7gDYgs_VULMKWHe8cLf","icon-mid":"_3wMtZkBRN33O8LkuJePEyA","icon-container":"_1OiS4hlzt0p9d9j_d4Wclz","st-menu-open":"_18b-0QPXfXVrggrmB62JQg","st-effect-2":"_1OmiMJMSxPLkAtOgma1S_g","subNav":"ctNfErzUgvtBEv9IQt5UT","headingcell":"_1gfhYgv_wBfGPASRedxjx9","cell":"YaaqPO09eGUEnjNmQfR2g","arrow-row":"_24I46YP2Q3YNXCcH6YDm6n","table-row":"_1IiWylavbBexxCYbFZOUrp","hover-table":"_2FU27OlPAtkCVMeXuy5P7r","pointer-table":"_1KMeASoGHmAjCsPBXQ84ym","table-heading":"rMdMOi0nhxRhPgepa9_Pb","table-content":"UGzwlSVwojlXPKotsNoqT","main-title-container":"_3LTEYtluYdJIxkGUGNwGzZ","main-title":"_1yg2Ghfq7Q2D0IA7VVmKGg","sub-title":"_1QZerReJTO9IXXK-UIRcnZ","group":"_33vFTUFMVgeWswBfw5cpIa","clear":"_1olb9p3iqIhBp5Um8aUTkN","anIcon":"_1H7cNSkI-tFoFAC7Y4lu4X","button":"ZfYd8-6-LTHU5JFOz7IeA","inputDiv":"_23-CagOPtoAhnPeqm6rjHt","hidden":"qLTugf_QtgDSAkQhlwdXL","template":"N7-xyiQdIzUVA4sl7glwD","app":"_1lmkWyW01pbQaSCSL53HlW","grayBody":"_3JJACEA3_FrWneyESjWw8x","centerContent":"_10wKN4SCF-EFtyGZLHEbbW","centerPage":"v_PPEq8GE6gVw669j00rM","flex1":"rBtiitTN8WRSFbJMsclyi","error":"k36xSSzITw_l6hSgRD6kx","key-value-column":"_3OUREbY1zEFKMaqRsnPkOR","keyValuePair":"_1AKfODmwcPUQpEaRgyjx2e","key":"V0E5qmDa76yWaLxa4tHPl","value":"mswZr4NfwIiAGcpGD7Uct","drop-container":"pb0y8jW_4pSTi7Vs_ox4k","pdf-icon":"_1W7rQullPiVn3SI5ZbF8qN","reactable-header-sort-asc":"TzWh5xp0ZkMHdWsbBkMQK","reactable-header-sort-desc":"_2pTDBAuz6ZGq97EeUpKcYM","reactable-pagination":"_1NwiZMDwXM3FSJejCQRCYn","reactable-current-page":"FEHWfL_RgAjBjJsh51PEX","upload":"_1RUWlTh_kpTpKM4OkraE-N","input-calendar-value":"_1tA1QT1zxmS1BfbgFtOneI","input-calendar-clear":"uVpNeHFS0rJJg4ph2EDZy","input-calendar-wrapper":"_3L98dRjbezOS_1RPImV82_","today":"rvPEwUf9kQpJbe4dbSUoS","view":"_9So1j-VQtLMoUkjkPON3U","days-view":"_13YtI8K09X6HUeQG4wZ6FP","navigation-wrapper":"_3ypBt1Bx-wEO76UChdXWIf","undefined":"_1IhjhErokyMOPzv_tlaPX5","null":"_26GcBfcL3Csl-aefkjiif-","false":"_33MEIJbEttL66d3TLdQFHn","tox":"_1PTJZzorqDrvlj0L0_2MBF","tox-editor-header":"_3MzDwoy3EOwSEfgaJqVB90","formInput":"_2gPgJTtIfdERrtW9wwVvvn","sizeL":"_2QfON1ue9XV7LzCB90Dum7","downArrowHolder":"_2YAtSCufASs627JyjlNimW","downArrow":"_3gOUGbtYNNKGO4pjC90WzY","creatableSelectInput":"_21S_Yx6Oqr98f0nxblx6v6","creatableOptionContainer":"tn-TAD9qWczJ_zwXGfkii","creatableOptionItem":"_1Js6xW-D-uAJW_JCo2t2zY"};

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cookies":"_3geCL81wB6k-Zyg3jRxU7-"};

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pHolderBody":"_3JSuvm4SFdK0Cm_w-oOzQh","pHolderDotButton":"_2HEymhE0JuZVrq05aOhigI","buttonMove":"_2qHrCa4eoxXiWQ4Zjct-tT","buttonRemove":"_3XeCAv-HsT428Uv7d8jH3s","buttonResize":"_3lZ63MHBXK4XE1ulhsk_kw","pHolderSelect":"_1Fd4uoPSvjf8K48vLi-HcQ","buttonRemoveIcon":"_1peuK6PFi6GqGXeKCV0fFZ","buttonResizeIcon":"_1_YlSoCbdltMZq-9IWeT7M","pageNumberHolderTextContainer":"_2j8q7mpvjttBVJS5MpNNpM","pageNumberHolderText":"_3wY45uz_blBPanhBda5iSg","jumpButtonsHolder":"XyxqkVpNvFwIAvm8AS45v","jumpButtonsLabel":"_3JD7DCeoBSyyaS1kqPr2N1","jumpButton":"_1-21-cvxAna0iYe3PwRIsX","jumpButtonIcon":"_3DlAvNNNZra4ZsriE0vlTv","jumpButtonIconHolder":"_3Imu4KjFoiGTJd153lvRKY","jumpButtonText":"_1kBOrcwlRNP2nh1YGIwi8I","placeholdersModalButtons":"_2NdEN0Sh1jf-pX_KCLpz6S","cancel":"_2w7gdkdTAOLa_L3NHyVfT3","greenButton":"_3_-P28OKN55mQB79weOcUq"};

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modalContent":"_2w3z-Mo6iCq_8LOFKtp8eS","modalButtons":"RvSMXuOA7VvxddkVe_iiU","greyButton":"_25QuAOc7pOKjxNyP2RPnR3","enabled":"_2avOymkDZ_5eMAsDXMfcSF","cancel":"_2dqpX0htV9QjWmV16EgjZz","title":"_3Xkr65hDlElkhqw4Bz5pqS","message":"_3lZfYLIjvDYhmdGRQJzhbX"};

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"moduleSectionContent":"KlXfl_Nq0vVNyi7LIkU2t","detailsContainer":"_2ZqK4M7sIV6YlsoYq5fQ2J","keyValueColumn":"_2_4iRyHsf8F_kIPVZmSUHo","keyValuePair":"_186ia1gptRbJ2evzVhaith","keyCont":"_3Jep3S5VHR9ZP5garsS_Oa","key":"_1QFxmP5qjg9qa9N5uhBoX_","valCont":"_2aKsuNo0BQeA8rSizW1FuT","value":"_2adx7PGTyvADkq79fMJdbj","divider":"_1jhviCIReVqLnB-_hO9Vpm"};

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"row":"_26W3wlyy_M6z5p7FaFJAz4","checkmark":"_3lxIHQDOQtrutQfiVGvsJe","checkmarkColumn":"_3Uhz9gmRxTH_200JFzHrsO","dateColumn":"_33zK2_Y_mxJJThoyyKWAgZ","subscribeButtonContainer":"_2-tvakBLIClv0DSvs0WYg_","subscribers":"_3QU2dmHWisdr8dOFEbALhx","agendaModule":"_17gOlqoIOTfrUqY2BUuLA_","mainSubDiv":"_2Y_y1qcxRzoty6VCTu-RJz","mainTitleDiv":"_3gf3fbTNKOPK64RjlmCokP","mainTitleContainer":"_1w530SPVWDivOk_Ym9toHy","gmapEmbedWrapper":"_3HKM0f7Ra1FmfNGuZjWFDH","headerContainer":"pNC7Tn4xLo5UzZ5JJMqS5","subscribeHeader":"_1PzZHkeaozMPlB0vEBT37K","eventsContainer":"anb-TNg65KpGedCRyYj_m","eventContainer":"_2wnwzae1FBy1rSqoW0Au4D","subsCont":"_1MZLRpHDgWtOjiEEip_r0b","subs":"_34sWr4zqWMwAwlxpLGW7eH","buttonContainer":"_2AFOLvzWqCcG689G1epgIh","content":"_1eJqIl7xyt-O-nbR_9Oimb","description":"_2RfyF5O8BsN8m5nRO1bMok","map":"_1SOQ9k9Po8x_rOhToLzGA5","dates":"_1D0DbSb5P2CPhmR6_z3Yxt","icon":"_2Mhl4ioODmo2HbCSmUDIRS","descriptionContent":"_24N2i8cpObrbrYmawY6T5z","address":"_1o_J8I9MpI1w3PCHYvxa3c"};

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"registerDialogContainer":"_2fkZ7D5yXy1D2LaWBHCSei","registerDialog":"E9QL3hLyxq_FTQOGbXult","description":"_2ARoDTp9-dYqxFOWDYRkJk","closeCross":"_2Nvrkm8HP5Q1-5oaW-4FKF","subscriberContainer":"_2L3mCf1H-yaRDHf5zKNQLv","dropdownContainer":"_19lXeQeM4tTEp9To0v0uuI","iconConatiner":"_3kGo4dPfqsA8fzaSl0ML15","subscriberDropdown":"_3seaDHPbZDWnGTP_c1r7LO","bottomContainer":"b35TDR5RZ89IFr102s5ro","closeBtn":"_3ENENkmM9Um2Ab5Bjj-LUl","freePlacesContainer":"KVmEFW_zcKTQXIi28Fn0","freePlaces":"_1w3XOEJp3JuN250SplU3cu","buttonContainer":"D7f23G6ptaZm_6fNCrTuA","buttonContainerLeft":"_167Q9NUYM84DFRaSQkuugL","buttonContainerRight":"_1VIDGw7Le2VaxPzubPY1vn"};

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"error":"_2_fje6AC2Eq9n9TQOH6ncX","form":"_142zw_6A6QEQkwJyc4EtPb","top":"_2Y-uui8-YzyXDb4feTWI51","logo":"dlb0ECr7YDK1okLXTB8Uc","language":"_3_KuJd20kUv3XH3U_f_m88","inputDiv":"_1hxZVXIXnLER84Ymv3ip0u","langInput":"_3nVxVX1NhXrvmUHdACBuoo","field-clientNumber":"k9J-KKuhQUo6bLXUr5StK","field-firstName":"_4IKVesA_KTT8OZ9Mkk4Xq","field-name":"nMqZMQkGD2i8VeySl22kd","field-street":"cmSZb7KEVGWU2JG0kUlKe","field-number":"_1sO9uRVRylSp4ctv9u06Q9","field-number-noBelgian":"cdtJYn3vxQOHvCt54fi8q","field-bus":"_298rOYtv1FrprF705psKRx","field-locality":"mbGK9PpLxR_YhMb7LOc-a","field-postalCode":"_4fZGasa7y2O9TbB0tbvFl","field-city":"_6hj1uXWqkE2MhoL9kwiK","field-city-noBelgian":"_1CcpvZzmtUR39-HDSOMLgp","field-zip":"_2IaX8c5ncOZFhrWAd12I74","field-zip-noBelgian":"_1Vskce0jamikcRSq8QOxzW","field-placeOfBirth":"_2xT5MG64XMAZsyGQ5vg955","field-dateOfBirth":"MEWevZb1Lg1y4e2UzIpEU","field-phone_code":"_1xZBqOmIBnPI5s5uw-YtoI","field-phoneNumber":"_3e4qR1nPF5MGNBMWLuPhgk","button":"IJElAHlWWxcukf9eGl9zz","backButton":"_2hxTHdgYVuP6rrrZspuSBh","dateOfBirth":"_13Au_2jlaEmeKUWG9TPh5k","registrationConfirmationContainer":"mD7Sy77Wcozplm5RJxJ54"};

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"moduleSection":"c6LufICZ4ZYzxE02ABedu","clientContractZoomContainer":"_31aeAl9zpfINLOS08uCvKZ","iconContainer":"_3ZHc8R_BBmSYl17y2pd30G"};

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"moduleSection":"_2aOpy25vcEVDrQ0aK0vLru","moduleSectionHeading":"_1xwWx_7lKNWf9sNW2xm20E","emailDefault":"_1uOBY5S-N5rmI4VznB162p","phoneDefault":"_3pbr0lBckZYmlMmDaoaNR6","email":"_1DXeI0-nXVWf_tisnJXF40","phone":"pv9ycLkp_BZtcUkHSmw6S","editClientProfile":"_133JTWb89syDPmQ1Xqqc1N"};

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"b2bCompanyClientZoomContainer":"_1fI5c28jW6ivkkIl8Gdu6V","content":"xrd8Eq9_x9D3Oh9T1qhlO","mainTitleDiv":"_22DBkh5Og7jjpy98o2P2Uf","mainTitleContainer":"_1YvyQ0O_N3_u_xzinKYNvn","mainTitle":"_3pLsOtxie9j8Dws6t332xa","subtitle":"_2fFuMTpYnDl4s2SpiNOcFG","moduleControls":"_20X5tk2X_u1S1zrN0HpOuf","greyButton":"_31x0pdTEhiZ9hkQWwGbAUk","clientZoom":"VZ7xGmsJJjDSUeKfZrUR5","subNav":"_2zwzWeyq_pxhw5zrha-C6r","headingDiv":"plgpYZWlAS8ZHfMJ7b70V","headingCell":"TrGK5-4LxUv41d6LMfW4-","active":"_35KTnY-3LoSzpBKQRHv_HW","moduleWrap":"_2JHDBqSLLYuzvxotZapC_3","actionSelectorsWrap":"_25byKK8oSFKtFuLFVCWhPK","actionSelectorsWrapRight":"_2SvPrsn9sHON9BHo_GwDjh","inputGroup":"_3b6W-3p-pnx7YhK8mjsdZ1","label":"_1xJueOfelP_lKmNiO375Em","actionSelector":"v_3pgej5Qg9JH2giceBdg","verifyModalContent":"R6I0TA1sUrAGdn84LElVQ","verifyModalButtons":"_3IhFGDi6F2XGeW9IJ-FKQb","cancel":"AgWNDXOU8hDAddMcVa4kf","enabled":"_3xUzWsZRYGItrue-0gr5Mx","title":"wwovfPpC2YGf2H7Fgc1oL","message":"_37Tp9U3rw1v9PXXxuF_WVO"};

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"moduleSection":"_2Bs4K-wdfgFCQILRbXgOXD","clientsTableContainer":"_3nROdE7x2wQsv8NprFcEoU","table":"_3TX4ZHTgh0cD9ZABmLAFTj","greyButton":"_1cZTKScXm2_xL2son6EvBj","iconContainer":"_1fTJZkCzrsfdvXxMcDtM73"};

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"downArrowHolder":"_2R1amOfQbkmjF01hKT2bbt","downArrow":"_30JyXh7QnJv6jclYY8y0bt","creatableSelectInput":"mHNEWKZ0s9USoSHnWmN_q"};

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"category":"_1PJ-kRfrIJW1dkwbdfed9a"};

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"claimsZoom":"_1UskAS_se20056WeYASfq6","mainTitleDiv":"_1V-3AF_nUJOW9776QiY6ay","mainTitleContainer":"_1Oa8IquE8b9bdEpBS_xiWN","mainTitle":"_26Gy2IMh9rvsdNOz5ogXr_","DSWizardButtonWrapper":"_3jsGTldfYRMZcKdvEmH2TG","agentClaimsZoom":"deiRw8l-vHAneiJQFEXg1","moduleSection":"_2GMXDMh_zY0eEAqamWTBHm","moduleSectionHeading":"vmzRcmNtXK1LbGXIsbCHi","subTitle":"_217MZ6OVYjNPRZeU9-kxGG","conexTitle":"_1Z39LDbga6ufBNLt8gOSI3","moduleSectionContent":"_2s6MoMLJo2mCuOWrQ6cfVP","detailsContainer":"_2Fi2CZiJLwWbK8VE8EVpPL","keyValueColumn":"_1GdBpL-PDaN90G3YXjSF76","keyValuePair":"dOill7rZOQ44FaNO4nZFV","keyCont":"_3K_CmwKWY3EnESOpqefs8f","key":"_8picr7cqaIoIVfZSr1QCI","valCont":"_6U24hhoHjXrnj9gxFGgu","value":"ejU94hnUodynK8t1Q_n12","missingInfo":"YqbKJkxvhnrMI71UiKHTv","missingInfoColumn":"ECwCZGMu805muMgmR4sjm","missingInfoTitle":"_1U2YJEMfswz5z-lMQoZU0N","missingInfoEnum":"pcq2fTXoNEx-hf-HOuMw","missingInfoRow":"_2PH8GzrEZCDrKapqo9_ho4","greyButton":"_2TdDAUhNxkz1-M4lMKnuN8"};

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"error":"eC7EIGBI_cG6Whve4_84y","multiFields":"_3gXSusOiKiSfFVRH79tXvF","multiFields2":"_1rUpFdbht0_oMhozyPKD2f","streetDiv":"_2xbFDNQHH1YyhabXs_wZn","smallDivsInput":"_3I1C21gUjLxxWdXq5nd1D1","removeFieldsButton":"_3VXX4dCDbHMGLCe-zdzgM_","greyButton":"_3lrlq_MWLVX23-NZ1kOzp6"};

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"moduleSection":"_2n-uyL_d4vmVA6CO4Y3yVd","clientClaimZoomContainer":"WQtv0kZxrzeiSayH-HOmv"};

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"clientClaimsZoomContainer":"_13MrfMaR6FSTYYtiv-lh1V","moduleControls":"aQ8WxAuuh23eAHsRp1phq","buttonOrganizer":"Ael0PrI8pU5_x2PYqTFGO","backToList":"_3ajsLaKlnlvapyl6yuHvmr","DSWizardButtonWrapper":"_3KpLgHTQXIJjRjtYCIOMDx","wizardButtonCorrection":"_3C3n1bCHhSBKUhXdW-iOkK","missingInfo":"_3JGZMP2ZGdc-yTqLnhyM6n","missingInfoColumn":"_2gP5pNTS7EZ2OEkGMy6msl","missingInfoTitle":"_1CjzkzG1EHudAkvW471xDT","missingInfoEnum":"_3KgfqykFkEj5QTPNWHmDQR","missingInfoRow":"_2JDhfcLK4Ilk__GgmwCcsl","subTitle":"_1ncDB0PK25QnaJ3YeZRGQf"};

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_1g-r-r-JaK58iJfd1Gz6XH","modal":"JVkXwPR_gGagDOzM7m0MI","title":"yfy-fhf50wuzSKEbgwnD_","contentWrapper":"_1x-DwCj8_16wWCfy4gPvEs","content":"_2zW6yPF80fMb9iLT-SxWUL","buttons":"_3KVA9l7LPUTUUSsHRt0Qov","next":"_2lysMJQPGJrVSPo-Yig7Y_","enabled":"_4Dey6nsyc7uddyiUWcKzc","gray":"_1_BhWvAc2re06pa1czV6Hp","disabled":"_1j8nOOLB0dLE-_pusS-hdO","cancel":"_2cz38J5lxCQIx0E40Gd6ze","contractStateIndicator":"_1i2LOSC_OhhcJYKG7cK_bW","contractStateIndicatorDisabled":"JdCx9UJDuJJLxT5tDta-0","downArrowHolder":"_2vAc766SyZhLwwkZK4tqVy","downArrow":"OfMhAPNZaHb3QUiK3X-Ah","form":"_1Xymw8BuEDaYRZw_0CKSkS","inputRow":"qeydO92dUxQtWiIAKIz_o","labelColumn":"_2yaoHqYWCYj1hGtcltth22","inputRowError":"_2O-yjff3Ld1HOFove2iJaT","column":"IE7ycaYav_vPfCoRJ_Ez3","pickerLabel":"_3ZvzlklbY8v9hFYLMGCuwc","inputLabel":"_1p2TxYAuA3WwLUjY1HPjiu","inputLabelSpaceHolder":"_3-PvpfO9xlcW9z51PeQfZQ","inputHintLabel":"PwltduTeS7Qra6KqVzBui","dueDateLabel":"_37beNwToHKG898M-CQD3IC","riskDescriptionsLabel":"_1IOOtMEVO05o2lbjln-YEA","confirmProposalText":"_2TvNfQvijNXIPQO3zrOAYZ","contractInput":"_297c4uXUfENmrWWHjfzYC7","instigatorInput":"_2RvNmOnipeA2w-TEQik8GO","contractDateInputContainer":"_2KvejQ0b2qI6cEIF0gK5QN","contractDateInputContainerLong":"_2oSG8QFhNvhekpRhPNoPcL","contractDateInput":"_3XjH6n_PVQ5cEe-QuvVhwK","contractDateInputDisabled":"_1U1hfne6-XobkDszRsuoGD","whitespacePre":"_2UWhyqUMHozeZvZQHJo8jV","changeRequestField":"_3lHGgeHWwnkEQlMe3H3Rir","changeRequestInputLabel":"_1HJF-PZDSW1wdIx4pSh0f4","changeRequest":"R_TMZkLNnosjvw89hBvfp","commentChangeRequestInputLabelWrapper":"_22tAbZNvuoUQmAiZha2otw","commentChangeRequestInputLabelDiv":"_39ICT9a7gCLQhBov4vMDsu","commentChangeRequestInputLabel":"nG6-Tts8vJrYdb2DmrHjn","commentChangeRequestText":"_183joLjdZ_6B5MmTLZpNG_"};

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"green-link":"_1PkwjP-Wdl-1n6Jpboe3U6","custom-select":"_2RVBLzQF4AIq3v6gXlOTUp","greyButton":"_29A-SK3Z9nlB5kKq3jv5yr","grayButtonFlex":"_1SNAT7xhfkSlUNe8wpESWG","refreshButton":"Q6di9neXFHvCIenPHMIji","iconContainer":"Ye0ZeGLhqZNeIdgD5xkDu","btn":"_3LMnQR0WvW6EfjG2gZypXX","green":"_3Bhmrzwlu5Fm2OSbO7EF98","inline-button":"_2PW_bDcdhMUFGOI6rdrgnk","link-button":"_3pMat2QSCWaRczQE97Fuss","dropdown-group":"_3YNZdQPUJ1H9OSBvrLUMSP","dropdown-indicator":"_3svg_S6purci-tA5Yh-jtG","dropdown-arrow":"cftTm69OEUt_W7q8M4_oB","buttonGreen":"_2x_5lG2v0K24w9wd7NodAS","moduleSection":"_3CQ2YL5kDl1ihmvZKAS-an","clientContractZoomContainer":"N8eG1tnO4Bth0-YS2xhHX"};

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"clientContractsZoomContainer":"_3cbJ0AdvwAmCNidyUWIx4x","moduleControls":"_1FpPailH-S4tgPMyWw4x76","buttonOrganizer":"_2WZ_z4DZAl-rLSIvPOS27y","backToList":"_1Zpc-Jv8D2tCJNbhxmUulq","moduleSection":"O9Cdw4avMqZkYLhW2-GYl","descLabel":"_1_a-e2I2F1pD1aj1sDtyUf","riskDescriptionContainer":"_27Zcmet3YSSIaDfpbqbQtg","riskDescLabel":"LgUuPemVcFeBdJzlrLPeS","riskDesc":"_3DM--Z3hWIuE1VsTUQJ2v9","clientsTableContainer":"U1hg0wjuFtmulllw3ExGt","wizardButtonCorrection":"wiG-lTgiluARRiK--RhHx"};

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"moduleSection":"_8BJm_wGSZHFsbQU1CeEOO","moduleSectionHeading":"_1ORJFX9uGOQDbqixwwq0zR","emailDefault":"_3jERc5O81gPReKwcM9W8tm","phoneDefault":"_3F57ZXI7Rf3rbs19RnkRHH","email":"iH4YyRqUVMeRiP9W6eJG8","phone":"_2ha_ZpYPKprD66TbmTw4yH","editClientProfile":"WkPLiXvUsJFxPAaqrAnQN","gray":"OUcq_EDF7IhKfsgBwSvA_","fullWidth":"_3I5BC_xwU-yetc6HYfW_KJ","addressContainer":"_8NsxQ6TnUvQ0rDkbxg-VX","addressColumn":"_2nlcAaTrOkHqsBG5EX_O4P","mapsLink":"EXSPddVn4R7vpeL73PrHk","mifidButtonCorrection":"_1mNrYRua_9X0tWNTFnJ5Jl","noteWrappper":"_3AksCSXL0i2-e9KAqJyAab","noteArea":"_1A7Bm_UHF5cZrbHgY9xoJx","noteView":"_1cZvg6zaH3UcJNM9nUsT7G","noteFieldError":"_3512qIMNIVinC7bjC0mujN","noteButtons":"_3ptUsilKw60ihkUPrDApZM","confirmationModalContent":"_3gG5ta2vzgXFd17cGPoEjw","columnContainer":"G-POkLDmqOepvcHkPw_q","oneRowItem":"xDD3sYjZjb3cJsC8Gou5E","autoHeight":"_260NlO2FjejoyVoxzii0Va","whitespacePre":"_2t-iWB3iNYCojLqGkz504p","modalFormContent":"_1mVf1Y8M5HOzdY8Wfig-cI","documentsModalButtons":"_2otoq30YBykyDYs-g01-a-","cancel":"_1o28SQwZEZcyZ_k9ZiSGAn","greenButton":"_3-w28_eLYYgICD0RwR_XV8","enabled":"_3YY2mKoCtXDiZwUKQXDH_1","title":"_3Ph2Gd0tO4uKUUZC6aJbBp","message":"_2d7gE85W9Q-8vDGag9b8Xp"};

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"error":"_4382LGAvHpbZztjn994pi","formError":"_1IaKhFN00R7Sp6HiGZx28A","greyButton":"_2eLOLKKrvYqZIEA9WuyUDV","informationTitle":"_3OIGb71WEZbs711Oxb0awU","informationTitleBorder":"_3Xt2DfZcfGMOQ6XA5x5kW7","moduleSection":"KF3b57Hq38NM6BjKr2r68","moduleSectionHeading":"_2VaSXn1BVYTjS2_wZ1t2wL","datepicker__input":"_3cf3RcD5Ry680Czgqhbaqy","mainTitleDiv":"_2wjQ1X_Tndd64o7p2krfG8","mainTitleContainer":"_2VBO3sAfoDwOf3-DQPDZWv","mainTitle":"_2DVR8PF7s5Ye32zPVElMho","subtitle":"_2glo_5Bd7x9pgwZlMVNxNR","moduleControls":"_1054ztDXgMpJKKdVk6kC2h","KeyValue":"_1Br_Q5cqUPOAaRmOmox8OJ","AddressKeyValue":"_2vCZrJvQnL2SpzAoN2XvbQ","clientProfileResultsWrapper":"_3uH2NQt7bY6anGaRhdqLpy","buttons":"_2TFYCMaNxV8Vsd6wt9a6fZ","cancel":"_2WMtu9kHqJgYIeMOgrAT0c","next":"_28tpvQmUDZ11B4aEHYvkbK","enabled":"OI44PFnp1Zky9BzhTI7l3","clientModalContent":"_3LmDwkZp-x4c9D2mJRQhcB","title":"_2jm1_73TDkA_1q6zupEZhM","datepicker__input-container":"_26x71HVPFHZOvf8oLlLbKj","clientModalButtons":"_1miuGcCUtaDmvY3o0Ae6wS","modalContentText":"_3UF-qUAQfV_GNagcvk9PiT","verifyModalContent":"_22odUn-qVRI-JG0xj5z913","verifyModalButtons":"_1Ge6D0zsfCA6r2C1cB0hyL","message":"_15JYbxBGM8GV2Y5PfkhO39"};

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_1C7mUfcc_AtEA2fUOrnwYt","modal":"_3B9ACsbeEbPN_rOkMgW2WN","title":"_31DRrODcI2q6c4FNK8ByQt","contentWrapper":"w36FNVT6739GUz0BbmdN_","content":"_1fgfG7S1zgV26uMrWu3p29","buttons":"_1JqiW5yCMD6ZnzVT-RFYuW","next":"_3qupYtEg9HfKjXqxBy6HkO","enabled":"_7OdOrCjZPDAS49SB422xg","gray":"_3Ycaug2nUiaANqcCE7yhu0","disabled":"_2KDlcOgmRHNSr5piFJAcDH","cancel":"_2rpWkgwvwHxh2wWxsSRdKx","form":"_2q5VWZfAH8pBlRWIp--MBx","inputRow":"EugEioj4uqHuluIwLoIV7","labelColumn":"_1uL6hYVbJbF8YpqEpTgt-5","inputRowError":"_2BSqZpOa5dnKBdygTA-xmP","column":"_3vePx1LLJL_MSxH3-O6oi6","pickerLabel":"_1vyFKLq6NUOTENtzXY9Nn3","inputLabel":"_4FXP-NQC0ujJ73v-lzRrt","inputLabelSpaceHolder":"_27n1zYbf1cdW45HI90lK38","inputHintLabel":"_1ZIRPU9dXp9609ywkZWfKq","dueDateLabel":"_3F8dixYnSDeuuvCLa4r56V","riskDescriptionsLabel":"ez1diPcxnkGGXLahXuHv-","confirmProposalText":"_1K3np_8gzqQqVU4inEgwcu"};

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"green-link":"_2OvSPhdIYZvcobEFFvCQed","custom-select":"_1b78uX6LyEJi69e4N_iyej","greyButton":"_2fpi6SbHmYbC8ip2Qh5laV","grayButtonFlex":"_1yZV28efzn0OhUuiQvn10i","refreshButton":"p1yQ4mKBJO7NeKPcHiwOr","iconContainer":"iLgpKAGtXLmr-G72W0lRN","btn":"ktLCogz33FI-8W7lWCGVB","green":"tvgGI5WlRLPPx4IqRplA0","inline-button":"_2HaiuaxBChjvCFhYtQvU2u","link-button":"_3cPZCOT5MopeRFORjFjKEp","dropdown-group":"_2fmxeJUgFW97r7u0vYbqvH","dropdown-indicator":"_1juk5HLbpXJ9NLA0Va-bq1","dropdown-arrow":"_3tmqMJafuaZy3zW95eOStA","buttonGreen":"_1q4QsFvJ74fQjukK2150lU","moduleSection":"_1_N5bPTbd4LhRgksmIEjt5","clientOffersZoomContainer":"_1rHgBrbONxkSd2e8_2l_0a"};

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"clientTarificationsZoomContainer":"_1Lbv8rgJMWL03_VjkQPobP","moduleControls":"_2KcNUwaQK2QPSwKoxUrK8i","buttonOrganizer":"LfZw5RPaU0Ti2_-WBrwjP","DSWizardButtonWrapper":"_14SgWajDjpqwIDWuWV-R1i","backToList":"_3Lz7ATNgBKBjIlgxh_xS7-","moduleSection":"_4YMi-TiPJRctDT93I2BRo","descLabel":"_1iYZM-lNwBoggkQ29ug1Bp","riskDescriptionContainer":"_1VLWJkT2BqXW94j8Xcd_sN","riskDescLabel":"_1KWp2kkRw4_6ckfijmBjKI","riskDesc":"_3r_OM3VvX-uegtYC8-UnIb","clientsTableContainer":"_30K_mD8peLJaQ4ul2uP__V","mifidButtonCorrection":"_1AE_Owz7wLNhXx2hvkfV0N","keyValuePairCorrection":"_1nQGnhH_vstWJGaJbGTa0v","createPrevButtonContainer":"_1ZyostISaqeR83SLJctVSF","prevButton":"FzZMVM_n9lspSFywj_fDw","disabled":"_2STp7jGpvNIx_in89wclA6"};

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"clientZoomContainer":"_1PqOpXuymGaNga-lM7BFBp","content":"_1tS3HMGnl4odd1LaVtvlu4","mainTitleDiv":"_32rMdYJJF9cNnvlO8MImpU","mainTitleContainer":"_1W-Hkr04uyOlvO_lyc5uim","mainTitle":"uw0181cp7ejLF-HLb6j4X","exclamationIcon":"_1BlPiaGdvgAQBxvZAeE2GM","icon":"_30nih86s8zIbliHHZr60mt","tooltip":"_3l3tQUW4J4hswW8O3aGVpp","subtitle":"_3Jz9UTIidnwz-DrurxD-dW","moduleControls":"LBRgBdQ25q5oBQ0qvGXck","greyButton":"_1qsbq9Jxd4S9Zcla3WFRwW","clientZoom":"_2c0JKMJhUwbGgRv_IV8rCh","subNav":"_3zrdLLUKUyakG1jmEvvINt","headingDiv":"_18KTqNWlhBJa2xlAMTpIU0","headingCell":"_1Yl2WIjK-CVect80-Ckenb","active":"_3sEuykADn9MeGm9zVpY3J5","verifyModalContent":"_3_HgzSdPHjBrlV-KjCGZ52","verifyModalButtons":"_2dx0Gll04qzw2JS9PyVVma","cancel":"_1V7hzCi3s9FudYrt8vGpZR","enabled":"_3OiqRGZm5jxnD5jJLMqdGU","title":"_-bOfm3H-CjDVDwqPXy5Va","message":"_3qm3lG5gjeMUcNozYKgoN"};

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_2q7cFwyM_zg7jJUT7Qti56","modal":"_3-LWM7dXRoH7RvfEMm-dKe","title":"_13Gh0CeZVPEep3Yo4g-arj","contentWrapper":"W67409TNyGq26v9hf8nf9","content":"_2gUJpxIp2dqr51nXhEBhni","rowIcon":"D4-KxMd1owtldFis9Ha_c","TabContainer":"_2rvrmC1uXwXagLHznxfxV","Tab":"_31FtwNsIgD5_QKFwQxQvAN","active":"_2aYdr_wS8Ng3yLgB7LzLNs","TabContentContainer":"dMOjpKvnMbggUYlzMU-3k","tabContent":"_3L2E9b1b1q0eeSl2iSOaI","hidden":"_2OPc9cfFoDGHc14VaRsy2X","buttons":"hTRgakEaO4F8T8mhTylEE","next":"V6BHwR_q9g-93y5l5gjhn","enabled":"PVzNyZE1JaPcsKWYJTsW3","gray":"_2ZdivKyTgtSK0_Xm9oOlkd"};

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_3kM-e-rM7lRcyFkXMPJ8Nd","modal":"qX1UMul9sl2cHLSHfEXT7","title":"_1Q9qCf4rcdBe44ZMEpLMUD","contentWrapper":"_1VrBPVekPmi94H1qSGPzvA","content":"_33N_1b8wp-A0UNC6kgyAgg","buttons":"LLOHhSl-Xhu8MHOkFj3TD","next":"_2JFR1X2Zu-8txx9PTF2qwt","enabled":"_39-aR9twMAb5PelALnDbts","gray":"_1iBfZj32LyYPIBYbHQqbSJ","cancel":"_2MV-_n4ByKj2bWS_1wCtSs"};

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_1bNkYo6ugChSjYgsyNmJoS","modal":"AX_GkPfs49Ptr6aZ8WTS3","title":"_1yZzax_Z6cwmkM9fhSUTi6","contentWrapper":"_3uVbqsk4tEUQhum1aFpMw8","content":"_38_RQ1DF2BbixtvxsVe0KC","buttons":"MjhlXoTLSxQDixhrje6cL","next":"_2M3hEF1q76pqWdjCIxiHzT","enabled":"_2LxfJuxHL-ggkE3rjWpAD-","gray":"J_gwGYTsqNASj8mRIvFBg","cancel":"_63_TwcUrt3z-3nNdStpF5","formInputContainer":"_3n3ZywYb0STSCJxC9Nj47S","titleLabel":"UkjKl3zFfZAZl-UwZM36A","formLabel":"_3BdaHsOH0m5TNDVxW6lYxv","formInput":"cNlrPmlQpEPXK8ZmHfXm0","errorMessage":"_3208ZagCxFNFHHvakrUXR-"};

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"arrow":"_2FiEE8NiUSTn3FdxXUo6US","faqModule":"_3Dp8tbfya_GmNKUr4Z0yAd","mainSubDiv":"_2K1a3IgdiTrQfPOiThasji","mainTitleDiv":"Ty8npS76sHi3hs2RJg12Q","mainTitleContainer":"_1BCLKcHTxyNW4Y7qjLGznh","catsContainer":"_3D3WEgGWLLJ5dAU1t5AE7-","cat":"zRFRkbq_HGndvXSeEDCgY","faq":"Zmls7ixB486UlEt5AYipD","questionCont":"_2qIzxxBiYdr-LWmvt7cN7y","printIcon":"_1h4GqPGwCqfAzQGVGZId5T","question":"_3Oqj_IInMzHiufm6e4L1jx","content":"bpJw2Gz82MbnHuNrhS_1T","answer":"_1rEWluy0xAkoyH2GRMJF5w","attachmentsCt":"_3IYtwDXuy27KJljHuHRRIn","attachment":"_1qRcr5vXktphJMsvAA1x9N","fileValCont":"WMu5ncqs9nZUgRsTgWtja"};

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_1L82yJ34IJDDE0cOh2yVbQ","modal":"_3P_m6Xusu5jC9QrKnOaEv7","title":"_38_mfpAv4wOWzTAjZwmnqU","contentWrapper":"_1XGUgQDtGFy3VDKSjKMsyf","content":"_2UsMIm12GdXGp1LHkZDxF-","buttons":"_-cVKPuDErzTxM6ogo03s3","next":"DaAajU-Zx1DX49slsp1Vc","enabled":"_2hVR104ShtZoJzAlQzhmGV","gray":"_3SUbMBIoz1WQeGc-81sDps","cancel":"_3YwHHk8JfUg1ytOR7dNjW8"};

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"inputContainer":"d_3wkamxCgD1zXiGA0USR","removeInput":"_31wLgj6bMQNbIG9K1JGJA-","cross":"_1jAGCsyWG4HJJ5r7ohSQ4p"};

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"linksModule":"_37nGi9aQVkyYgB3XA8TeTB","mainSubDiv":"_2tsN49n-RS2HDqAFsC1E0p","mainTitleDiv":"_2N8m_ES6tt4D9746yhGyWT","mainTitleContainer":"_3rCBx6BJpetOr_apnZuSJT","mainTitle":"mVN8ABQnr8xsDm2rm2DlD","bottomBorder":"_28kKR6dvNYE8O3D8lzktKj","link":"_1l7hJcDg5Ucpf-gZ-xfynj","text":"_2NM_kxToC79FFb_s2l3nLk","content":"_2KpFMhwd_B8-cdUpTg7dEh","ref":"_1G_MluUiYvnFLtFLKswhrk","textLink":"_1OLo4XB73JUq8L0M5ehMG7"};

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loaderWrapper":"_3yJqoh1cmJaKuq0zZeX3Am","spinner":"_2GndBGDC4LfACbhVCn9QLG","rotate":"_1H5w4DH5HNeXuWYRr5ol_k","dot1":"_2kD0KQ2be563CPIUQdHw-s","dot2":"_1GKgoMB9o9wVsdZdw2mHs4","bounce":"_1OBIJM_ew_ySPJAOGyQ4ol"};

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapApp":"K9gIOIfM0Qfe4YoUThyDK","verifyModalContent":"_1AQKvaPl9U2wefoCJRgf2","verifyModalButtons":"_3f2R5BojOsp7XE0nJNtEDe","cancel":"_3vK8TehgrPE1O49jodtpMG","greyButton":"_2WQ3-rD49T0_obetmt634u","enabled":"_2m4k3NL-aKDhs7T85P3qH2","title":"PBt4ZX3_amopSSI190eee","message":"_1faOeUB1terZrve6JEhH24"};

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mobileHeader":"TVCXLQDAOm_s_e5vJMdQW","backBtn":"gl2iVa0SvBbZzCqm1Ok5T","brandWillemot":"_1tlTezR2CXzYNttmXY7-tb","menu":"_1VW4-Rf3DUmBvyWpMhRw2p","logo":"RPYQl7rsF6QG7RdUOb2qM","brandEasinsure":"lRZkrv3t6ZEg5O4FUOuby","myEasinsure":"_3CtLQSXfW7h9M1HtZ4rdQI","willBroker":"_1HKslM5XlAycD4zsgJYAy4"};

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sidebarContainer":"_20qekXWyY9cjArXgWgy62j","isIE":"_3ncxrRV5UPmMmFey_GG42E","inboxCounter":"_3IO7SyFDI3Uqj6ylGoz9c-","sidebarWrapper":"_1HS7JWEbYvKMPVpbGfNj-v","navLogo":"_2kYLBe7VWFQ18Jmap5S2bp","linkWrapper":"_2IEydPueihs5IADFUa1GS2","link":"rsQS-kI1Swlwe4tEiyMS-","menuTitle":"_2qGnF4NGtCCLcb7ksYscxt","extraStyle":"_10KaOcKTGPaUIq1waJaV9l","tasklist":"_32Xrn3gVX_P51WmJBM-pRm","outbox":"_3a_ORy9GGDK_ZFgAy_LRDs","news":"_1-rIp9uEla6ghxDNyaVHPO","inbox":"_1towAPHNkW1TBcGwX0Q81E","active":"_3W4xSe-hgHE00anMXHaiMf","dsdocuments":"_3t52bJiGtvrZjnbpZVuLvg","agenda":"_2kcHUouH60L-D_HR_yEE0p","office":"_1GNbKuMss6HJbGGVbtBqCf","clients":"_2S_8_c1ASzgc6RiPvuwjIU","production":"oH1bC48lf1E491qls0YPC","b2b":"_1qWEAlYz9SizMmr863xAXU","b2bCompany":"_1sqLHU1Ax1iBtHh_qJWKUu","insurancecompany":"_2QruZlleBeRML1PsZPh34q","insuranceCompany2320":"_1xil-XmcPfUGXypu4CrYxz","insuranceCompany2321":"_2eDs5XTwtfJbErvFksCWDu","claims":"_3TkNd9O-dFL9p5OezB6RPT","willdoc":"_1r__0UhN0QKFgui6vAoCQ6","faq":"NhF7G4Mx3y6N69XSGO4zA","links":"_3MpCHCB3AEaMmP08fjl25q","logout":"_1Se5yGR0yy0rk8CaKHtz9Y","webapps":"pTpFNtlth_6OSlPd4Blgf","sidebarFooter":"_3D4tNV68xO5lmjXAEIxtlB","disclaimer":"_3KzyS-nFvex5woN8r6a4Gg","collapseArrow":"_2BZXLG7djvm8w5xkS50hoV","collapsed":"sRggdm2W9Po5C2DBDfwjB","mobile":"_17ohiWD1jqVFcQJJfaQrHz"};

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"metroUI":"_1qhGHpyWcO6i76rVUO-V8R","fadeOut":"_19DMKugYntJhQ8nzxAc6k","metroUIContainer":"_1i826YpywkpbBOa5NvNoga","metroUICenterContainer":"_3TQWcOpuRT8Sn6f5yrv8yY","metroUILogo":"_3UIGDp3HP_DOvxl8Om0Mt0","tile":"kWNIE4jxRtZjl8WsOqxhi","news":"_1obx196Q779b71VdSFFvgU","counter":"_1yBDCZT6faST_BVIzcfnog","inbox":"_11S8Q9Oir_iDwjdQq5EXWw","dsdocuments":"Nst5xN9iY01VoDNe_2Nsx","outbox":"_1AiPHEMOgYaGfIeOrTskLa","agenda":"_3-WC_5sTPNfPGGI2R6q9v3","tile-heading":"_3dIJmiQGsB2HtOvDjEfox_","icon-container":"_1AEspscdUn9dLigApQ5pSc","office":"_3g9JGGNH_7IV0gaa1OJoiG","clients":"_2_eJPQOWqBSv4kbQg976Vl","production":"_3c-hmVvuQXriRGA63EHLll","b2b":"r8MJrYA_DfuLn0Y1myn63","claims":"DsU9FEGRMe03LBjgRPt4a","willdoc":"_2c1NmvcPUdX1ud8w6owbKQ","faq":"_32kB5hUBitzkU6dE4p854B","links":"_3ln6WXIiyiLi-kqtXl49Dr","webapps":"_1OMwvBMgOicyHg8MrM_Ze5","logout":"_2hCoGcFdbRzPML-xq3QMDa","tasklist":"ROr_aVRe0hNi2E7Qnt_VC","flashOne":"_2Uz3kRsTOVLoTfEKkfhOmj","tileHeading":"_1bNhV1fQ9KriWISeqJi_1b","tileTeaser":"evOufRoiStFf-uMvD-iQL","flashTwo":"vFrK_PMtaSQLDgDl3S5OC","newsDoubleTile":"_2rp64AuesWUc6aZwgNWmAR","iconContainer":"_2WBSxlMC48vdPujSagldF5","tileTitle":"CuURkLUvYiWlnhC6csZ6r","mobile":"_1l3wSyXtRzcz7CJvT0HoQr","tileWrapper":"_38GG86cR6l42pbbWjtm0L9","flash":"_1wUPGsASGrxI6kEz0GONbG","noImg":"_3O7eLx4NJMtX6t37239u2i","disclaimer":"_1k-pzPWfrxDjGqevZscC7b","version":"kRU5CX9y-6k2z9k_tve4K"};

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"msgContainer":"_1ra7x8C65sEEaxuYQAab1C","msg":"yEkzvYhyeInXpf7TH4PxB","imageContainer":"i2eoatmE7Nkks2kCEdwqs","textContainer":"_1eA6-lpPklWfdYJnNqur9l"};

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"officeFinances":"_3ZBkBkUI924wRw_HqvcZzH","submitContainer":"_35nQ8jggcC-oWvc55tb3BG","inputContainer":"_1_9TX4v0w0afyClQBd868l","inputForm":"_1JrpZLhA7l-ivlFS82LCx8","submitButton":"QGeFik5FTekUJEOt20Hgi","results":"_2GUlXQFS8llkBxXXbd1E7S","subNavigationCont":"_2jAtRyzYoNZs_taByWDW5Z","subNav":"_1XX11zzoDRNB7nb0LjU9Nj","catCont":"_34TBAqBE-XseCoQDDd2iLq","active":"_31YtbVl6Cz08Spc-kJ-BdS","inactive":"_1o2WRK2-nlE9EvKvVCcpcC"};

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"transContainer":"bjBz_wGbxg9XT2qBrWy4q","summaryContainer":"_2U298bKepnKQov0lvbDlK0","summary":"zk4xsSNNsNMfcmfrOSqBh","field":"_3a0t4MuvWHhU-Onj-ZHSDs","label":"_1ebJ_u5aQVGKJDSP6Ry-Rx","input":"zzgARoeBLTTwtjTF-BcSm"};

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"markdown":"_1Dscb5ZdpWXM9tYQFulyXF","main-sub-div":"_2V0Tqv3sMxU6JREWOOSNWZ","details-container":"J31NdhGrJxbuwazXK3bvm","module-wrap":"_3yyoGi3iN70Q8HbwHiPPhC","module-section":"_3UYYT-5r8lJcwQksaW4ro0","module-section-heading":"rjSvHJUVH1OHshQpeJpmG","module-section-content":"Zvm7E11JwKO2PTasp0nfl","top-border":"_3S3gqiN0HbT_F-nvzYvidg","bottom-border":"_21t9ueCWkMi9TvpxBaJLy3","bottom-border-thick":"_1xMDUtfCL_uGxXcKnimUUu","border":"_2X0DWY5fOR2C3ptsmXCXXA","green-link":"F5Kcuvht7yIlu-0IwFVUf","custom-select":"nmWimWHY9rooA85Ns9TMr","greyButton":"_1Ewfckm_vVlvh7zGtl88JZ","grayButtonFlex":"_1zxtwdSI-YpWbqtHW1PIN8","refreshButton":"_2ET-j-oy9_BAbxaels3Jt8","iconContainer":"_2OmmN3dRFqDgaPxYD87se4","btn":"_2U4EdUKRKx8n_7fitp79eh","green":"_2oGUY0GwZQK8kAEYN4aYxV","inline-button":"_4g9Hh0WviIai4oRKJUO5v","link-button":"_3n7mSP63TWtfFr_MOe8D-D","dropdown-group":"EQIbpLrR527sYt7c2XYXe","dropdown-indicator":"_3PJ-SGNi1cuTyRLU5KI6OY","dropdown-arrow":"_1RiV62AhHhx7QB45TG7jx2","buttonGreen":"_3AFFDR32HQQyURHo-uf1pO","pull-left":"_23iROn4ORG16OkDahvHQrr","pull-right":"_3gkd-Od6pZv9X1wnOcTQ0M","clearfix":"_3BzXzmhmF3VvUKYEJuqilN","grey-color-theme":"_13JCMsrX8uAVG6LQfbPjqU","grey-select":"vEVD_CQ8ekVrrITF8kYDh","main-search":"_1HRtp4U9X3uWv4rVA62meU","left-logo":"_2Y-XJ_cNLdhvpWTB0IU7sz","small-input":"_1hMu-ns_QndJw0bUE0nm6U","app-container":"_3usk1_u6oAyzs3fxhxiRFb","app-container-row":"_1Jtctiq-WYn0wR_O-2MHHB","main-content-container":"Tk00eLJQ3jFF5E9k7FT2U","main":"_3SB5MC1lXr8jgHIY8k9g8r","mobile-header":"_3pKvVqdTUL35Na49Fydrpa","button-menu":"_1oeVgUpPbURKK8xPEUDvoS","mobile-glyph-container":"_1r-lNhJ118X6GxzI7renea","text-menu":"wjtyunydZR-UEvDKmc2H8","icon-menu":"_2CtHoVPQGfwxSOkmrZw1L2","logo-glyph-white-m":"Y6iVFUbzriKGvkXxgf1cT","search-container":"_1di3KW5FkPbs4MoxKFzKlP","search-logo":"_1Xw_NA5hGCrmIt3G8q4YPn","main-hr":"BZNVvriE5Ac_VHJ9nsF90","main-title-div":"_3K9rzsg3CVHxsr0NvOxB1Z","main-checkbox":"_2iDZys6jchRCoo5Ras1UMG","main-nav-container":"_3N7MK6PrjU5OScWFIhpZY2","expand":"_2pn6ZQHhq-tMH1sisSk7P5","narrow":"_10hO-M9E_X3gN1zgKNDcT1","nav-logo":"_100suC1MIGwFWQ27j_5HYB","nav-icon-text":"_247DxWMXuFYZSA-2C9Bp_C","button-toggle":"_2qKZn_6bmgNbRF3Zvcs3Od","nav-wrapper":"j5NtoC8vHVL7EeS_hnQSW","inactive":"_2MEQeZtKZoJzfG60x_77w4","news":"_1Tigacoxm-_6PpRzTGd30o","inbox":"_2fBMHJSjkfrUY9cGCjZSS7","outbox":"_3xTmdcvigJF-qS3hpR5DRD","agenda":"_3DJKNIqQX9Dn6XTieUtI38","office":"_1CXtku2cGZl-hCyQ9gGWp6","clients":"_2IC0xeNR5gUsi1YAKAr0Q8","production":"_1OlgNGTgK7opbjCsmni70A","claims":"_3IPCDSiiu7gwTldju4ozoK","willdoc":"_3htWgliGyHwWTjWLwPI7W7","faq":"_1tBFCQXUjEvFF9smrPehHj","links":"_16DWNZCudbJuiy8zLuLFZp","logout":"B5vTBBpdhC5T4eVt4crwg","active":"_1Z1LCzSdIi0DYl7B-Pj_8W","disclaimer":"_2d1DQxYHeu7rwslOk0L5Yj","logo":"_3g9UiclC7GVxRwozv0QBTl","will-logo":"_1F1Ul_TaowhxmiqoH43yuA","logo-glyph-white":"_3AIOmbsITjcNYvpeFCm1lS","nav-icon-div":"_3y5_oniG41bmnWcKV46GjI","nav-icon":"oAUP2ziebdRcOTBgXkFfE","icon-mid":"_2u64_kXMbNDcnr935YI-Lx","icon-container":"_2r1W9iguR57u_2RUCnyLs8","st-menu-open":"_27MpzT8tt2wVSkJ9XnxulZ","st-effect-2":"_1wuhCd6vPJeaRhAz00dtwN","subNav":"WuAHl5ar1iNsJori2MWwh","headingcell":"_3Imty-wicHglkGFfjRqtLI","cell":"_3vcSH5IIV9lG2M2ql5dtk-","arrow-row":"uBpm35j4FABnsZZNWZCJl","table-row":"cse4Z_oiJUHxsAtRaTsw7","hover-table":"ozjFmXq_nIq5dtkKq2DM-","pointer-table":"_2GvkgbdUXYKdDzxl8s8p9F","table-heading":"k_gVgcSOyKAb7IEj7LZrI","table-content":"_1TRiREySdYBtkSrnvjlQib","main-title-container":"_35KJZlTSK_Yk4lVt6a6nEk","main-title":"_2xeN2I6AJYsNJpqmoWvi3O","sub-title":"_3oGls_uy91b8cnoVcN1ioG","group":"_7TQ_NIMVbSZzk0sCmbJOQ","clear":"in6tLgFF-gp5zoRIr9YJS","anIcon":"_3RwcWlhRgggDr_zqfVWgWn","button":"_24TAqWoG5HJd6qH1v__jpP","inputDiv":"_3gvwftpy6vNcSYUGfeO6ZF","hidden":"_3U9hkiuRDr7yrnGV97fgmz","template":"_29fG8SWJVxCLk3pdIRDw9e","app":"w_i_DiIut0XfsLAUYhH-b","grayBody":"_1Pk0WTUfFx4_Ej1LXZ5rd-","centerContent":"_3myyZZrB6TRYw5z9ogxFgt","centerPage":"_3drtiGIe5Ry7V9uK6E0aJA","flex1":"_2c_bWIA6Ra1AB-5CCc-HhU","error":"_2Snz5hoElwIjFgfG4oA8RL","key-value-column":"_2pfNxoFEnbKMQUyefUkKPg","keyValuePair":"_1H3UfbNwZh2B0rQ5B4XCeA","key":"hJ8uLLRIXmgh5kb0H61nX","value":"_2HqLLJHN1q5xVnW_Bf4lUY","drop-container":"_3mgaT9qWwVv2IvGEbF460R","pdf-icon":"_1qP9oWn6ctpFmTj1gXGpMS","reactable-header-sort-asc":"_1zOGM96BcWptW7FNv0viN4","reactable-header-sort-desc":"eIJbsytSjQp8VswkQqThn","reactable-pagination":"_3XuxE4uJFiep52z76QmXsn","reactable-current-page":"_1WuqMzbX4JeDYCsrDUyuhB","upload":"_1p_h6xEytnTDuJwF4OKZRh","input-calendar-value":"_2lSbVex85kJ0_PsvJfuHkp","input-calendar-clear":"_3h7SpllTFTQy0ipMaXDpXK","input-calendar-wrapper":"_2N-odoB9JIM0AA9vkHbIqx","today":"_3v4Ij--cax_2pOZm6E9KJQ","view":"_331ZIMb6XDMGeSR4GXzlB2","days-view":"_1Qrx43y7IzxPNsXX_63_bt","navigation-wrapper":"_1TqdCeIrJOKdbIkflYSv5o","undefined":"_27T_x41wPe0nipgcBrEvh9","null":"_2Cpie5LRuP5-yyzLDRLkdp","false":"_2yub1GbgyxOOrnWud8tYxl","tox":"_2Tg0BuuMjvxDHvja3Evb9H","tox-editor-header":"_1V9vZe8q4VezbCv4vf_3x9","formInput":"_2eHARECNkXIzoLY3wbn6nz","sizeL":"_2tildAliqKFfm8fasW5Ia6","downArrowHolder":"_347YQZDJXy94ZNff_zV1Gu","downArrow":"_2Dz4sEUK25m1ja4WeiL0dI","creatableSelectInput":"_1B1iioamY8SYM_oYLqqOon","creatableOptionContainer":"yutn77VtEkRRYY83gWVet","creatableOptionItem":"V8BFghidbyrZoizz6SKtx"};

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"emailContainer":"_3VxmmH1Qd4kxv6qdfN8u6r","mainTitle":"_34rXfSxn7_oAL9JsTBB9cc","emailHeaderContainer":"_1HbpGFLnbLBbzxEadGY1Qw","row":"_2aIsJaDnEAz8fBFaMxNhJa","column":"_3mfj11P6p07JiXE_N7ppqx","subject":"_1z-Hp5DVCSrA1xBX1RKHEd","emailStatus":"_1MvSHuujQwGkTj9cp3GOL2","emailBodyContainer":"_1fufmhoCOnbB7gwPbvVvpM","content":"GbSxupkkniufkxCKwpz6g","attachmentContainer":"_utorLkobJv_ATOp1g9q3","attachmentTable":"_1QnfZint2vlPXEFK7Y1ftU","title":"_1rRrIjCzetH7wb7Pr_qD0U"};

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"CV3u6DB8joy6i02eylj_B","title":"_28c7uslGhjJXEBmlqM8EPO","contentWrapper":"DGze3dhhv-zt1FkvFee1C","content":"_35-yuCy2IEI-znPEBpyHuP","buttons":"_1oERUBeJu3vhWRbMjV1mCj","next":"_32VXQkSDhZTYZYzQpPIVYR","enabled":"_3qtIe0jmZ041EtL_lMF0J0","gray":"_3q14nDPd9pu6ez3MR_bnwj"};

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form-field":"_2A5AMxauYXv9bzFiOOOb0i","errorMessage":"_3zOCVRGtk9x1KaoHtDuLkm"};

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"colorSelect":"_1SXAm_1AQNA0vkMN68GXzq","colorValueContainer":"_3s-hSb7Jb469TotBIi-1bu","colorOption":"_2ptVZOGlkYJEiMBdDHPXuH","colorValue":"_3-CNgRDoAhDlKpqCoiV39Y","colorValueTodo":"_3w6itoHmAT40jUI0wpJpBa"};

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select":"ikW3xD3z591ujgGnUPH_M","downArrowHolder":"nUGvY8z4gpl5qCkDCVG_g","downArrow":"_2IZ2hUvfIqdB6H61pbUVxz","creatableSelectInput":"J98XiW8Z2XrCFufyzTWEi","noOptionsMessage":"c5SpXTN2EHh-h0mwmsT_o"};

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modalContent":"_1ut-7Y8-A_lIDZDTTwYQqh","modalTitle":"_1ucYTw-HmBFTWTjdZpVBBu","modalSubtitle":"_28S2ufv_tQsk8PU0vbWqb2","modalActions":"_1GHPsCdV3Uw0vh8FHfADQS","closeButton":"_3R-gT5PoBdb2uWNh_VFZ6g","greyButton":"_7oasjlfHS-PJfiWpKiJNp","enabled":"_3CvCMra9-ktBcaGx_NLoDQ","taskItemsList":"_1UebrMLQfc2HIHg9urTT8p","taskItem":"_2weYrNpw0Oddi4pBZpTApz","taskField":"_2IFbtigIhj8VjQX5M7vpuY","dateInput":"xEtKZcKItG_ION8MO2Kum","staffItemsList":"_2oZgrslvi2gK7yOucshSfN","archiveSubtitleLast":"w1MT3gX72p4kvoM56_knX","message":"_1TyCwK7-qbKkgWUOW5K_21","error":"_22QJ57UpZeF4tbzXnIilt_"};

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"msgContainer":"rvSXXb4mktO99FEjX20fY","msg":"_2l_ksGIcm4XWysh1GTsAxa","imageContainer":"_3atV43t7EcKKEuLJOI09fC","textContainer":"ZvUIcfSGS0tMJhQS-eDpV"};

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"userCommentContainer":"_21aGX0b_JSyyOCQcbrwKqp","userCommnetField":"_3-FAMBYiju53-QTRBFYYJM","removeInput":"d9RmxI1jHQftdgy_yyTJU","cross":"_2lVZlg7mubH5dcmLxgHzx"};

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_1TwT1As_Iu-hiLmwYJL7vs","barBg":"_1FZLrJuejw1w8K-QMKCCj9","bar":"_8b4OHuLxjCXrWKu5kzrdJ","barFill":"_1WGnlAEwHLQ6oCfJCXECCo","progress":"J8IhDy1vuY02IfiOYgC_N","gradient":"_1_EucWK16K5cxNN5jSBEKp"};

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wdFrame":"_1t2ER5yPBLPnsr9-5Pq509"};

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mainCon":"_2L8tTAmY8A7n7sHeCr8W6j","textCon":"_1zq7bmZLCgsvkwW3Qj52kj","xButton":"_1BD1XD6v2F71ICWTu7a7z4"};

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pageModule":"_2iSqS0onpa21pwiVZMV1ys","mainSubDiv":"_2PCtWbDBxRqUKLY-rUYHb","mainTitleDiv":"_3iaG-jesubBGIdZADP6HPZ","mainTitleContainer":"_1yXvn1HL1sIetw0rMrZdLV","moduleControls":"_60ogHrxhManihJDefSHqp","backToList":"_1mLU5cZwFk18CiPueu65TM","buttonOrganizer":"_2czypeBkrHIpXJaNYKtcN0","DSWizardButtonWrapper":"_2DhyHoWqwkwFJRVfHg7MFL"};

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mainCon":"_1w0r8spA-Tlgh5ZPdqmn7i","textCon":"CkjkkWzFPSTVrwaW5gjai","xButton":"_16zTtuPtwLlUNHk66lIDm4","buttonWrapper":"_2BnE00r2sNTw6iWrqv5QhN"};

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"searchContainer":"_3zQK1a9kqfhCJC-_VfK4nG","searchContent":"fftPfskzteOEAfhUQaf8z","searchLogo":"_27mC5wL1xxMR6ncgR2q8NY","search":"_2ojo1UdOe84uo5dK_93uI8","removeFilter":"_2OIb_EaG5dOIFXLZsn9MtP","cross":"_151U3DTbpDHu66e6EZYuF7"};

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"c0Ig7xsaZKllIXLOvQkQI","title":"_2mk__HZN1WGyAtIUsPbgVZ","pill":"_1wB6Py5HH2cl5r59FNWNKw","noPills":"_31ML1un-CB5xwP8YOQnhEE"};

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"withPointer":"_12nplyM96JEW4BDzf-AJe7","modal":"_1s_I4oVCT4t_T22YQf9Ooq","title":"VoyS6_LRHllfU7ASDvzEC","contentWrapper":"_2s7VlpVBB1yE-3gmLUIWlx","content":"_2_hzkZGgcVyWJZ7WIN5Dfe","buttons":"_2npmZK09-ZI3jyykJTmf8A","next":"_3aAmvpNvLb2RntILG3Jevk","enabled":"_1MxIFB8tGkHZZ2dRnnO6iN","gray":"_3GJg54BSZPsNOD-iYRXYL8","cancel":"_3--5CI6zrT45bpcaFkjaq0"};

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"downArrowHolder":"_3lId_vnfVA1hHZdTpBLul-","downArrow":"_2hkTj5l2XT2HYwJKFkmZ44","creatableSelectInput":"JHLaQsZbdyMIivAIpqrsY","noOptionsMessage":"_6sNg4vD5pSFoBzSuGfnJY"};

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cont":"XBW95xTegQNA9Uh5wyohd"};

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"scroll":"_2JfG8jzD2usfm7jLQaayps","holyGrail":"_25aZDa7IhJCk9vviBWZCQ7","stretch":"JaqZQbUo73CHJ2axu5RUR","header":"_1fTs-IwCwPVGh933N_cCv3","footer":"_2jmv0Bw3M0HLuTrCATfamE","ieWrap":"_3KC2mDxTXYoUJBQIfUaPQz","body":"j9GMESmS-Uolvp2s0DlnF","content":"_2ShahRFQg5v9HCl32ItO_Z","nav":"jFzRMMIxIbtZBZCCMeGDV","aside":"_21vGu_YUCF3EM5-KEODkkP","screenResizer":"_22ZUH4ppcDyCx53aMPqLjf"};

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1641);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1651);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var createArrayFromMixed = __webpack_require__(1644);
	var getMarkupWrap = __webpack_require__(1646);
	var invariant = __webpack_require__(21);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1648);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1650);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "76e2ee7d8a78e81ea8aa8c1f7f717cab.html";

/***/ }),
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(2324) !== null) && (__webpack_require__(2325) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	var isBuffer = __webpack_require__(1660)
	
	module.exports = flatten
	flatten.flatten = flatten
	flatten.unflatten = unflatten
	
	function flatten (target, opts) {
	  opts = opts || {}
	
	  var delimiter = opts.delimiter || '.'
	  var maxDepth = opts.maxDepth
	  var output = {}
	
	  function step (object, prev, currentDepth) {
	    currentDepth = currentDepth || 1
	    Object.keys(object).forEach(function (key) {
	      var value = object[key]
	      var isarray = opts.safe && Array.isArray(value)
	      var type = Object.prototype.toString.call(value)
	      var isbuffer = isBuffer(value)
	      var isobject = (
	        type === '[object Object]' ||
	        type === '[object Array]'
	      )
	
	      var newKey = prev
	        ? prev + delimiter + key
	        : key
	
	      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
	        (!opts.maxDepth || currentDepth < maxDepth)) {
	        return step(value, newKey, currentDepth + 1)
	      }
	
	      output[newKey] = value
	    })
	  }
	
	  step(target)
	
	  return output
	}
	
	function unflatten (target, opts) {
	  opts = opts || {}
	
	  var delimiter = opts.delimiter || '.'
	  var overwrite = opts.overwrite || false
	  var result = {}
	
	  var isbuffer = isBuffer(target)
	  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
	    return target
	  }
	
	  // safely ensure that the key is
	  // an integer.
	  function getkey (key) {
	    var parsedKey = Number(key)
	
	    return (
	      isNaN(parsedKey) ||
	      key.indexOf('.') !== -1 ||
	      opts.object
	    ) ? key
	      : parsedKey
	  }
	
	  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
	    return keyA.length - keyB.length
	  })
	
	  sortedKeys.forEach(function (key) {
	    var split = key.split(delimiter)
	    var key1 = getkey(split.shift())
	    var key2 = getkey(split[0])
	    var recipient = result
	
	    while (key2 !== undefined) {
	      if (key1 === '__proto__') {
	        return
	      }
	      var type = Object.prototype.toString.call(recipient[key1])
	      var isobject = (
	        type === '[object Object]' ||
	        type === '[object Array]'
	      )
	
	      // do not write over falsey, non-undefined values if overwrite is false
	      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
	        return
	      }
	
	      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
	        recipient[key1] = (
	          typeof key2 === 'number' &&
	          !opts.object ? [] : {}
	        )
	      }
	
	      recipient = recipient[key1]
	      if (split.length > 0) {
	        key1 = getkey(split.shift())
	        key2 = getkey(split[0])
	      }
	    }
	
	    // unflatten again for 'messy objects'
	    recipient[key1] = unflatten(target[key], opts)
	  })
	
	  return result
	}


/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	'use strict';
	
	var functionsHaveNames = function functionsHaveNames() {
		return typeof function f() {}.name === 'string';
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	if (gOPD) {
		try {
			gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			gOPD = null;
		}
	}
	
	functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
		if (!functionsHaveNames() || !gOPD) {
			return false;
		}
		var desc = gOPD(function () {}, 'name');
		return !!desc && !!desc.configurable;
	};
	
	var $bind = Function.prototype.bind;
	
	functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
		return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
	};
	
	module.exports = functionsHaveNames;


/***/ }),
/* 1663 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getCloneDimensions;
	
	function getCloneDimensions(node, options) {
	  var parentNode = node.parentNode;
	
	  var context = document.createElement('div');
	  var clone = node.cloneNode(true);
	  var style = getComputedStyle(clone);
	  var rect = {};
	
	  // give the node some context to measure off of
	  // no height and hidden overflow hide node copy
	  context.style.height = 0;
	  context.style.overflow = 'hidden';
	
	  // clean up any attributes that might cause a conflict with the original node
	  // i.e. inputs that should focus or submit data
	  clone.setAttribute('id', '');
	  clone.setAttribute('name', '');
	
	  // set props to get a true dimension calculation
	  clone.style.display = options.display || style.getPropertyValue('display');
	  if (style.getPropertyValue('width') !== '') {
	    clone.style.width = 'auto';
	  }
	  if (style.getPropertyValue('height') !== '') {
	    clone.style.height = 'auto';
	  }
	
	  // append copy to context
	  context.appendChild(clone);
	
	  // append context to DOM so we can measure
	  parentNode.appendChild(context);
	
	  // get accurate width and height
	  rect = clone.getBoundingClientRect();
	
	  // destroy clone
	  parentNode.removeChild(context);
	
	  return rect;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getNodeDimensions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _getCloneDimensions = __webpack_require__(1663);
	
	var _getCloneDimensions2 = _interopRequireDefault(_getCloneDimensions);
	
	function getNodeDimensions(node) {
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var rect = node.getBoundingClientRect();
	  var width = rect.width;
	  var height = rect.height;
	
	  if (!width || !height || options.clone) {
	    rect = (0, _getCloneDimensions2['default'])(node, options);
	    width = rect.width;
	    height = rect.height;
	  }
	
	  return {
	    width: width,
	    height: height,
	    top: rect.top,
	    right: rect.right,
	    bottom: rect.bottom,
	    left: rect.left
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	
		if (root === null) {
			throw new Error('Google-maps package can be used only in browser');
		}
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.GoogleMapsLoader = factory();
		}
	
	})(typeof window !== 'undefined' ? window : null, function() {
	
	
		'use strict';
	
	
		var googleVersion = '3.31';
	
		var script = null;
	
		var google = null;
	
		var loading = false;
	
		var callbacks = [];
	
		var onLoadEvents = [];
	
		var originalCreateLoaderMethod = null;
	
	
		var GoogleMapsLoader = {};
	
	
		GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';
	
		GoogleMapsLoader.KEY = null;
	
		GoogleMapsLoader.LIBRARIES = [];
	
		GoogleMapsLoader.CLIENT = null;
	
		GoogleMapsLoader.CHANNEL = null;
	
		GoogleMapsLoader.LANGUAGE = null;
	
		GoogleMapsLoader.REGION = null;
	
		GoogleMapsLoader.VERSION = googleVersion;
	
		GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';
	
	
		GoogleMapsLoader._googleMockApiObject = {};
	
	
		GoogleMapsLoader.load = function(fn) {
			if (google === null) {
				if (loading === true) {
					if (fn) {
						callbacks.push(fn);
					}
				} else {
					loading = true;
	
					window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function() {
						ready(fn);
					};
	
					GoogleMapsLoader.createLoader();
				}
			} else if (fn) {
				fn(google);
			}
		};
	
	
		GoogleMapsLoader.createLoader = function() {
			script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = GoogleMapsLoader.createUrl();
	
			document.body.appendChild(script);
		};
	
	
		GoogleMapsLoader.isLoaded = function() {
			return google !== null;
		};
	
	
		GoogleMapsLoader.createUrl = function() {
			var url = GoogleMapsLoader.URL;
	
			url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;
	
			if (GoogleMapsLoader.KEY) {
				url += '&key=' + GoogleMapsLoader.KEY;
			}
	
			if (GoogleMapsLoader.LIBRARIES.length > 0) {
				url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
			}
	
			if (GoogleMapsLoader.CLIENT) {
				url += '&client=' + GoogleMapsLoader.CLIENT;
			}
	
			if (GoogleMapsLoader.CHANNEL) {
				url += '&channel=' + GoogleMapsLoader.CHANNEL;
			}
	
			if (GoogleMapsLoader.LANGUAGE) {
				url += '&language=' + GoogleMapsLoader.LANGUAGE;
			}
	
			if (GoogleMapsLoader.REGION) {
				url += '&region=' + GoogleMapsLoader.REGION;
			}
	
			if (GoogleMapsLoader.VERSION) {
				url += '&v=' + GoogleMapsLoader.VERSION;
			}
	
			return url;
		};
	
	
		GoogleMapsLoader.release = function(fn) {
			var release = function() {
				GoogleMapsLoader.KEY = null;
				GoogleMapsLoader.LIBRARIES = [];
				GoogleMapsLoader.CLIENT = null;
				GoogleMapsLoader.CHANNEL = null;
				GoogleMapsLoader.LANGUAGE = null;
				GoogleMapsLoader.REGION = null;
				GoogleMapsLoader.VERSION = googleVersion;
	
				google = null;
				loading = false;
				callbacks = [];
				onLoadEvents = [];
	
				if (typeof window.google !== 'undefined') {
					delete window.google;
				}
	
				if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
					delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
				}
	
				if (originalCreateLoaderMethod !== null) {
					GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
					originalCreateLoaderMethod = null;
				}
	
				if (script !== null) {
					script.parentElement.removeChild(script);
					script = null;
				}
	
				if (fn) {
					fn();
				}
			};
	
			if (loading) {
				GoogleMapsLoader.load(function() {
					release();
				});
			} else {
				release();
			}
		};
	
	
		GoogleMapsLoader.onLoad = function(fn) {
			onLoadEvents.push(fn);
		};
	
	
		GoogleMapsLoader.makeMock = function() {
			originalCreateLoaderMethod = GoogleMapsLoader.createLoader;
	
			GoogleMapsLoader.createLoader = function() {
				window.google = GoogleMapsLoader._googleMockApiObject;
				window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
			};
		};
	
	
		var ready = function(fn) {
			var i;
	
			loading = false;
	
			if (google === null) {
				google = window.google;
			}
	
			for (i = 0; i < onLoadEvents.length; i++) {
				onLoadEvents[i](google);
			}
	
			if (fn) {
				fn(google);
			}
	
			for (i = 0; i < callbacks.length; i++) {
				callbacks[i](google);
			}
	
			callbacks = [];
		};
	
	
		return GoogleMapsLoader;
	
	});


/***/ }),
/* 1666 */
/***/ (function(module, exports) {

	'use strict';
	
	var test = {
		__proto__: null,
		foo: {}
	};
	
	var $Object = Object;
	
	/** @type {import('.')} */
	module.exports = function hasProto() {
		// @ts-expect-error: TS errors on an inherited property for some reason
		return { __proto__: test }.foo === test.foo
			&& !(test instanceof $Object);
	};


/***/ }),
/* 1667 */
[2345, 729],
/* 1668 */
[2347, 442],
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(860);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (typeof input === 'string') {
	      this.url = input
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split('\r\n').forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = global.fetch;
	}.call(global));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1671 */
[2348, 444, 633],
/* 1672 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 1673 */
[2349, 444],
/* 1674 */
[2350, 633, 444],
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Module dependencies.
	 */
	var os = __webpack_require__(1892);
	var lodashGet = __webpack_require__(1679);
	var lodashFlatten = __webpack_require__(1678);
	var lodashUniq = __webpack_require__(1681);
	var lodashSet = __webpack_require__(1680);
	var lodashCloneDeep = __webpack_require__(1677);
	var flatten = __webpack_require__(1659);
	
	/**
	 * @name Json2CsvParams
	 * @typedef {Object}
	 * @property {Array} data - array of JSON objects
	 * @property {Array} [fields] - see documentation for details
	 * @property {String[]} [fieldNames] - names for fields at the same indexes. Must be same length as fields array
	 *                                   (Optional. Maintained for backwards compatibility. Use fields config object for more features)
	 * @property {String} [del=","] - delimiter of columns
	 * @property {String} [defaultValue="<empty>"] - default value to use when missing data
	 * @property {String} [quotes='"'] - quotes around cell values and column names
	 * @property {String} [doubleQuotes='""'] - the value to replace double quotes in strings
	 * @property {Boolean} [hasCSVColumnTitle=true] - determines whether or not CSV file will contain a title column
	 * @property {String} [eol=''] - it gets added to each row of data
	 * @property {String} [newLine] - overrides the default OS line ending (\n on Unix \r\n on Windows)
	 * @property {Boolean} [flatten=false] - flattens nested JSON using flat (https://www.npmjs.com/package/flat)
	 * @property {String[]} [unwindPath] - similar to MongoDB's $unwind, Deconstructs an array field from the input JSON to output a row for each element
	 * @property {Boolean} [excelStrings] - converts string data into normalized Excel style data
	 * @property {Boolean} [includeEmptyRows=false] - includes empty rows
	 * @property {Boolean} [withBOM=false] - includes BOM character at the beginning of the csv
	 */
	
	/**
	 * Main function that converts json to csv.
	 *
	 * @param {Json2CsvParams} params Function parameters containing data, fields,
	 * delimiter (default is ','), hasCSVColumnTitle (default is true)
	 * and default value (default is '')
	 * @param {Function} [callback] Callback function
	 *   if error, returning error in call back.
	 *   if csv is created successfully, returning csv output to callback.
	 */
	module.exports = function (params, callback) {
	  var hasCallback = typeof callback === 'function';
	  var err;
	
	  try {
	    checkParams(params);
	  } catch (err) {
	    if (hasCallback) {
	      return process.nextTick(function () {
	        callback(err);
	      });
	    } else {
	      throw err;
	    }
	  }
	
	  var titles = createColumnTitles(params);
	  var csv = createColumnContent(params, titles);
	
	  if (hasCallback) {
	    return process.nextTick(function () {
	      callback(null, csv);
	    });
	  } else {
	    return csv;
	  }
	};
	
	
	/**
	 * Check passing params.
	 *
	 * Note that this modifies params.
	 *
	 * @param {Json2CsvParams} params Function parameters containing data, fields,
	 * delimiter, default value, mark quotes and hasCSVColumnTitle
	 */
	function checkParams(params) {
	  params.data = params.data || [];
	
	  // if data is an Object, not in array [{}], then just create 1 item array.
	  // So from now all data in array of object format.
	  if (!Array.isArray(params.data)) {
	    params.data = [params.data];
	  }
	
	  if (params.flatten) {
	    params.data = params.data.map(flatten);
	  }
	
	  // Set params.fields default to first data element's keys
	  if (!params.fields && (params.data.length === 0 || typeof params.data[0] !== 'object')) {
	    throw new Error('params should include "fields" and/or non-empty "data" array of objects');
	  }
	
	  if (!params.fields) {
	    var dataFields = params.data.map(function (item) {
	      return Object.keys(item);
	    });
	
	    dataFields = lodashFlatten(dataFields);
	    params.fields = lodashUniq(dataFields);
	  }
	
	
	  //#check fieldNames
	  if (params.fieldNames && params.fieldNames.length !== params.fields.length) {
	    throw new Error('fieldNames and fields should be of the same length, if fieldNames is provided.');
	  }
	
	  // Get fieldNames from fields
	  params.fieldNames = params.fields.map(function (field, i) {
	    if (params.fieldNames && typeof field === 'string') {
	      return params.fieldNames[i];
	    }
	    return (typeof field === 'string') ? field : (field.label || field.value);
	  });
	
	  //#check delimiter
	  params.del = params.del || ',';
	
	  //#check end of line character
	  params.eol = params.eol || '';
	
	  //#check quotation mark
	  params.quotes = typeof params.quotes === 'string' ? params.quotes : '"';
	
	  //#check double quotes
	  params.doubleQuotes = typeof params.doubleQuotes === 'string' ? params.doubleQuotes : Array(3).join(params.quotes);
	
	  //#check default value
	  params.defaultValue = params.defaultValue;
	
	  //#check hasCSVColumnTitle, if it is not explicitly set to false then true.
	  params.hasCSVColumnTitle = params.hasCSVColumnTitle !== false;
	
	  //#check include empty rows, defaults to false
	  params.includeEmptyRows = params.includeEmptyRows || false;
	
	  //#check with BOM, defaults to false
	  params.withBOM = params.withBOM || false;
	
	  //#check unwindPath, defaults to empty array
	  params.unwindPath = params.unwindPath || [];
	
	  // if unwindPath is not in array [{}], then just create 1 item array.
	  if (!Array.isArray(params.unwindPath)) {
	    params.unwindPath = [params.unwindPath];
	  }
	}
	
	/**
	 * Create the title row with all the provided fields as column headings
	 *
	 * @param {Json2CsvParams} params Function parameters containing data, fields and delimiter
	 * @returns {String} titles as a string
	 */
	function createColumnTitles(params) {
	  var str = '';
	
	  //if CSV has column title, then create it
	  if (params.hasCSVColumnTitle) {
	    params.fieldNames.forEach(function (element) {
	      if (str !== '') {
	        str += params.del;
	      }
	      str += JSON.stringify(element).replace(/\"/g, params.quotes);
	    });
	  }
	
	  return str;
	}
	
	/**
	 * Replace the quotation marks of the field element if needed (can be a not string-like item)
	 *
	 * @param {string} stringifiedElement The field element after JSON.stringify()
	 * @param {string} quotes The params.quotes value. At this point we know that is not equal to double (")
	 */
	function replaceQuotationMarks(stringifiedElement, quotes) {
	  var lastCharIndex = stringifiedElement.length - 1;
	
	  //check if it's an string-like element
	  if (stringifiedElement[0] === '"' && stringifiedElement[lastCharIndex] === '"') {
	    //split the stringified field element because Strings are immutable
	    var splitElement = stringifiedElement.split('');
	
	    //replace the quotation marks
	    splitElement[0] = quotes;
	    splitElement[lastCharIndex] = quotes;
	
	    //join again
	    stringifiedElement = splitElement.join('');
	  }
	
	  return stringifiedElement;
	}
	
	/**
	 * Create the content column by column and row by row below the title
	 *
	 * @param {Object} params Function parameters containing data, fields and delimiter
	 * @param {String} str Title row as a string
	 * @returns {String} csv string
	 */
	function createColumnContent(params, str) {
	  createDataRows(params.data, params.unwindPath).forEach(function (dataElement) {
	    //if null do nothing, if empty object without includeEmptyRows do nothing
	    if (dataElement && (Object.getOwnPropertyNames(dataElement).length > 0 || params.includeEmptyRows)) {
	      var line = '';
	      var eol = params.newLine || os.EOL || '\n';
	
	      params.fields.forEach(function (fieldElement) {
	        var val;
	        var defaultValue = params.defaultValue;
	        var stringify = true;
	        if (typeof fieldElement === 'object' && 'default' in fieldElement) {
	          defaultValue = fieldElement.default;
	        }
	
	        if (fieldElement && (typeof fieldElement === 'string' || typeof fieldElement.value === 'string')) {
	          var path = (typeof fieldElement === 'string') ? fieldElement : fieldElement.value;
	          val = lodashGet(dataElement, path, defaultValue);
	        } else if (fieldElement && typeof fieldElement.value === 'function') {
	          var field = {
	            label: fieldElement.label,
	            default: fieldElement.default
	          };
	          val = fieldElement.value(dataElement, field, params.data);
	          if (fieldElement.stringify !== undefined) {
	            stringify = fieldElement.stringify;
	          }
	        }
	
	        if (val === null || val === undefined){
	          val = defaultValue;
	        }
	
	        if (val !== undefined) {
	          if (params.preserveNewLinesInValues && typeof val === 'string') {
	            val = val
	              .replace(/\n/g, '\u2028')
	              .replace(/\r/g, '\u2029');
	          }
	
	          var stringifiedElement = val;
	          if (stringify) {
	            stringifiedElement = JSON.stringify(val);
	          }
	
	          if (params.preserveNewLinesInValues && typeof val === 'string') {
	            stringifiedElement = stringifiedElement
	              .replace(/\u2028/g, '\n')
	              .replace(/\u2029/g, '\r');
	          }
	
	          if (typeof val === 'object') {
	            // In some cases (e.g. val is a Date), stringifiedElement is already a quoted string.
	            // Strip the leading and trailing quotes if so, so we don't end up double-quoting it
	            stringifiedElement = replaceQuotationMarks(stringifiedElement, '');
	
	            // If val is a normal object, we want to escape its JSON so any commas etc
	            // don't get interpreted as field separators
	            stringifiedElement = JSON.stringify(stringifiedElement);
	          }
	
	          if (params.quotes !== '"') {
	            stringifiedElement = replaceQuotationMarks(stringifiedElement, params.quotes);
	          }
	
	          //JSON.stringify('\\') results in a string with two backslash
	          //characters in it. I.e. '\\\\'.
	          stringifiedElement = stringifiedElement.replace(/\\\\/g, '\\');
	
	          if (params.excelStrings && typeof val === 'string') {
	            stringifiedElement = '"="' + stringifiedElement + '""';
	          }
	
	          //Replace single quotes with double quotes.  Single quotes are preceeded by
	          //a backslash,  and it's not at the end of the stringifiedElement.
	          stringifiedElement = stringifiedElement.replace(/(\\")(?=.)/g, params.doubleQuotes);
	
	          line += stringifiedElement;
	        }
	
	        line += params.del;
	      });
	
	      //remove last delimeter by its length
	      line = line.substring(0, line.length - params.del.length);
	
	      //Remove the final excess backslashes from the stringified value.
	      line = line.replace(/\\\\/g,'\\');
	
	      //If header exists, add it, otherwise, print only content
	      if (str !== '') {
	        str += eol + line + params.eol;
	      } else {
	        str = line + params.eol;
	      }
	    }
	  });
	  // Add BOM character if required
	  if (params.withBOM) {
	    str = '\ufeff' + str;
	  }
	
	  return str;
	}
	
	/**
	 * Performs the unwind recursively in specified sequence
	 *
	 * @param {Array} originalData The params.data value. Original array of JSON objects
	 * @param {String[]} unwindPaths The params.unwindPath value. Unwind strings to be used to deconstruct array
	 * @returns {Array} Array of objects containing all rows after unwind of chosen paths
	 */
	function createDataRows(originalData, unwindPaths) {
	  var dataRows = [];
	  if (unwindPaths.length) {
	    originalData.forEach(function(dataElement) {
	      var dataRow = [dataElement];
	
	      unwindPaths.forEach(function(unwindPath) {
	        dataRow = unwindRows(dataRow, unwindPath);
	      });
	
	      Array.prototype.push.apply(dataRows, dataRow);
	    });
	  } else {
	    dataRows = originalData;
	  }
	
	  return dataRows;
	}
	
	/**
	 * Performs the unwind logic if necessary to convert single JSON document into multiple rows
	 *
	 * @param {Array} inputRows Array contaning single or multiple rows to unwind
	 * @param {String} unwindPath Single path to do unwind
	 * @returns {Array} Array of rows processed
	 */
	function unwindRows(inputRows, unwindPath) {
	  var outputRows = [];
	  inputRows.forEach(function(dataEl) {
	    var unwindArray = lodashGet(dataEl, unwindPath);
	    var isArr = Array.isArray(unwindArray);
	
	    if (isArr && unwindArray.length) {
	      unwindArray.forEach(function(unwindEl) {
	        var dataCopy = lodashCloneDeep(dataEl);
	        lodashSet(dataCopy, unwindPath, unwindEl);
	        outputRows.push(dataCopy);
	      });
	    } else if (isArr && !unwindArray.length) {
	      var dataCopy = lodashCloneDeep(dataEl);
	      lodashSet(dataCopy, unwindPath, undefined);
	      outputRows.push(dataCopy);
	    } else {
	      outputRows.push(dataEl);
	    }
	  });
	  return outputRows;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	// TODO custom objects, support Set, Map etc
	// TODO custom dictionary
	;(function(exports) {
		'use strict'
		var hasOwnProperty = new Object().hasOwnProperty
		var stringRE = /^[a-zA-Z]/
		var numRE = /^[\d-]/
		var TRUE = '_T'
		var FALSE = '_F'
		var NULL = '_N'
		var UNDEF = '_U'
		var NAN = '_n'
		var INF = '_I'
		var NINF = '_J'
	
		var dict = {
			T: true,
			F: false,
			N: null,
			U: undefined,
			n: NaN,
			I: Infinity,
			J: -Infinity,
		}
	
		var fromEscape = {
			'*': '*',
			_: '_',
			'-': '~',
			S: '$',
			P: '+',
			'"': "'",
			C: '(', // not necessary but we keep it for symmetry
			D: ')',
			L: '<',
			G: '>', // not necessary but we keep it for symmetry
			'.': '%',
			Q: '?',
			H: '#',
			A: '&',
			E: '=',
			B: '\\',
			N: '\n',
			R: '\r',
			U: '\u2028',
			Z: '\0',
		}
		var toEscape = {
			'*': '*',
			_: '_',
			'~': '-',
			$: 'S',
			'+': 'P',
			"'": '"',
			'(': 'C',
			')': 'D',
			'<': 'L',
			'>': 'G',
			'%': '.',
			'?': 'Q',
			'#': 'H',
			'&': 'A',
			'=': 'E',
			'\\': 'B',
			'\n': 'N',
			'\r': 'R',
			'\0': 'Z',
			'\u2028': 'U',
		}
		function origChar(s) {
			if (s === '_') {
				return ' '
			}
			var c = fromEscape[s.charAt(1)]
			if (!c) {
				throw new Error('Illegal escape code', s)
			}
			return c
		}
		function escCode(c) {
			if (c === ' ') {
				return '_'
			}
			return '*' + toEscape[c]
		}
		var escapeRE = /(_|\*.)/g
		function unescape(s) {
			// oddly enough, testing first is faster
			return escapeRE.test(s) ? s.replace(escapeRE, origChar) : s
		}
		// First half: encoding chars; second half: URI and script chars
		var replaceRE = /([*_~$+'() <>%?#&=\\\n\r\0\u2028])/g
		function escape(s) {
			// oddly enough, testing first is faster
			return replaceRE.test(s) ? s.replace(replaceRE, escCode) : s
		}
		function eat(a) {
			var j, c
			for (
				j = a.i;
				j < a.l && ((c = a.s.charAt(j)), c !== '~' && c !== ')');
				j++
			) {}
			var w = a.s.slice(a.i, j)
			if (c === '~') {
				j++
			}
			a.i = j
			return w
		}
		function peek(a) {
			return a.s.charAt(a.i)
		}
		function eatOne(a) {
			a.i++
		}
		var EOS = {} // unique symbol
		function decode(a) {
			var out, k, t
			var c = peek(a)
			if (!c) {
				return EOS
			}
			if (c === '(') {
				eatOne(a)
				out = {}
				while (((c = peek(a)), c && c !== ')')) {
					k = unescape(eat(a))
					c = peek(a)
					if (c && c !== ')') {
						t = decode(a)
					} else {
						t = true
					}
					out[k] = t
				}
				if (c === ')') {
					eatOne(a)
				}
			} else if (c === '!') {
				eatOne(a)
				out = []
				while (((c = peek(a)), c && c !== '~' && c !== ')')) {
					out.push(decode(a))
				}
				if (c === '~') {
					eatOne(a)
				}
			} else if (c === '_') {
				eatOne(a)
				k = unescape(eat(a))
				if (k.charAt(0) === 'D') {
					out = new Date(k.slice(1))
				} else if (k in dict) {
					out = dict[k]
				} else {
					throw new Error('Unknown dict reference', k)
				}
			} else if (c === '*') {
				eatOne(a)
				out = unescape(eat(a))
			} else if (c === '~') {
				eatOne(a)
				out = true
			} else if (numRE.test(c)) {
				out = Number(eat(a))
				if (isNaN(out)) {
					throw new Error('Not a number', c)
				}
			} else if (stringRE.test(c)) {
				out = unescape(eat(a))
			} else {
				throw new Error('Cannot decode part ' + [t].concat(a).join('~'))
			}
			return out
		}
	
		function encode(v, out, rich, depth) {
			var t,
				T = typeof v
	
			if (T === 'number') {
				out.push(
					isFinite(v)
						? v.toString()
						: rich
							? isNaN(v)
								? NAN
								: v > 0
									? INF
									: NINF
							: NULL
				)
			} else if (T === 'boolean') {
				out.push(v ? '' : FALSE)
			} else if (T === 'string') {
				t = escape(v)
				if (stringRE.test(t)) {
					out.push(t)
				} else {
					out.push('*' + t)
				}
			} else if (T === 'object') {
				if (!v) {
					out.push(NULL)
				} else if (rich && v instanceof Date) {
					out.push('_D' + v.toJSON().replace('T00:00:00.000Z', ''))
				} else if (typeof v.toJSON === 'function') {
					encode(v.toJSON(), out, rich, depth)
				} else if (Array.isArray(v)) {
					out.push('!')
					for (var i = 0; i < v.length; i++) {
						t = v[i]
						// Special case: only use full -T~ in arrays
						if (t === true) {
							out.push(TRUE)
						} else {
							encode(t, out, rich, depth + 1)
						}
					}
					out.push('')
				} else {
					out.push('(')
					for (var key in v) {
						if (hasOwnProperty.call(v, key)) {
							t = v[key]
							if (t !== undefined && typeof t !== 'function') {
								out.push(escape(key))
								encode(t, out, rich, depth + 1)
							}
						}
					}
					while (out[out.length - 1] === '') {
						out.pop()
					}
					out.push(')')
				}
			} else {
				// function or undefined
				out.push(rich || depth === 0 ? UNDEF : NULL)
			}
		}
	
		var antiJSON = {true: '*true', false: '*false', null: '*null'}
		exports.stringify = function(v, options) {
			var out = [],
				t,
				str = '',
				len,
				sep = false,
				short = options && options.short,
				rich = options && options.rich
			encode(v, out, rich, 0)
			// until where we have to stringify
			len = out.length - 1
			while (((t = out[len]), t === '' || (short && t === ')'))) {
				len--
			}
			// extended join('~')
			for (var i = 0; i <= len; i++) {
				t = out[i]
				if (sep && t !== ')') {
					str += '~'
				}
				str += t
				sep = !(t === '!' || t === '(' || t === ')')
			}
			if (short) {
				if (str.length < 6) {
					t = antiJSON[str]
					if (t) str = t
				}
			} else {
				str += '~'
			}
			return str
		}
	
		function clean(s) {
			var out = ''
			var i = 0
			var j = 0
			var c
			while (i < s.length) {
				c = s.charCodeAt(i)
				if (c === 37) {
					// %
					if (i > j) out += s.slice(j, i)
					i++
					while (c === 37) {
						c = parseInt(s.slice(i, i + 2), 16)
						i += 2
					}
					if (c > 32) {
						// not a control character or space
						out += String.fromCharCode(c)
					}
					j = i
				} else if (c <= 32) {
					if (i > j) out += s.slice(j, i)
					i++
					j = i
				} else {
					i++
				}
			}
			if (i > j) out += s.slice(j, i)
			return out
		}
	
		var JSONRE = /^({|\[|"|true$|false$|null$)/
		exports.parse = function(s, options) {
			if (options && options.deURI) s = clean(s)
			if (JSONRE.test(s)) return JSON.parse(s)
			var l = s.length
			// if (s.charAt(l - 1) !== '~') {
			// 	throw new Error('not a JSURL2 string')
			// }
			var r = decode({s: s, i: 0, l: l})
			return r === EOS ? true : r
		}
	
		exports.tryParse = function(s, def, options) {
			try {
				return exports.parse(s, options)
			} catch (ex) {
				return def
			}
		}
	})(
		 true ? exports : (window.JSURL = window.JSURL || {})
	)


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = cloneDeep;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(142)(module)))

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flatten;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    Set = getNative(root, 'Set'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each
	 * element is kept.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length)
	    ? baseUniq(array)
	    : [];
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = uniq;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(160),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1748),
	    hashDelete = __webpack_require__(1749),
	    hashGet = __webpack_require__(1750),
	    hashHas = __webpack_require__(1751),
	    hashSet = __webpack_require__(1752);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(160),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(160),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(448),
	    setCacheAdd = __webpack_require__(1774),
	    setCacheHas = __webpack_require__(1775);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(160),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEachRight` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEachRight(array, iteratee) {
	  var length = array == null ? 0 : array.length;
	
	  while (length--) {
	    if (iteratee(array[length], length, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEachRight;


/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduceRight` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the last element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	  var length = array == null ? 0 : array.length;
	  if (initAccum && length) {
	    accumulator = array[--length];
	  }
	  while (length--) {
	    accumulator = iteratee(accumulator, array[length], length, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduceRight;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(316),
	    copyArray = __webpack_require__(249),
	    shuffleSelf = __webpack_require__(325);
	
	/**
	 * A specialized version of `_.sampleSize` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to sample.
	 * @param {number} n The number of elements to sample.
	 * @returns {Array} Returns the random elements.
	 */
	function arraySampleSize(array, n) {
	  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	}
	
	module.exports = arraySampleSize;


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(249),
	    shuffleSelf = __webpack_require__(325);
	
	/**
	 * A specialized version of `_.shuffle` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 */
	function arrayShuffle(array) {
	  return shuffleSelf(copyArray(array));
	}
	
	module.exports = arrayShuffle;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(753);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(137);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(102),
	    keysIn = __webpack_require__(71);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	var get = __webpack_require__(327);
	
	/**
	 * The base implementation of `_.at` without support for individual paths.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Array} Returns the picked elements.
	 */
	function baseAt(object, paths) {
	  var index = -1,
	      length = paths.length,
	      result = Array(length),
	      skip = object == null;
	
	  while (++index < length) {
	    result[index] = skip ? undefined : get(object, paths[index]);
	  }
	  return result;
	}
	
	module.exports = baseAt;


/***/ }),
/* 1700 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.conformsTo` which accepts `props` to check.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	 */
	function baseConformsTo(object, source, props) {
	  var length = props.length;
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (length--) {
	    var key = props[length],
	        predicate = source[key],
	        value = object[key];
	
	    if ((value === undefined && !(key in object)) || !predicate(value)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = baseConformsTo;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(137);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ }),
/* 1702 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ }),
/* 1704 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(452),
	    baseIsNaN = __webpack_require__(1712),
	    strictIndexOf = __webpack_require__(1783);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(158);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48);
	
	var arrayBufferTag = '[object ArrayBuffer]';
	
	/**
	 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	 */
	function baseIsArrayBuffer(value) {
	  return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	}
	
	module.exports = baseIsArrayBuffer;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var dateTag = '[object Date]';
	
	/**
	 * The base implementation of `_.isDate` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	 */
	function baseIsDate(value) {
	  return isObjectLike(value) && baseGetTag(value) == dateTag;
	}
	
	module.exports = baseIsDate;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(311),
	    equalArrays = __webpack_require__(768),
	    equalByTag = __webpack_require__(1744),
	    equalObjects = __webpack_require__(1745),
	    getTag = __webpack_require__(119),
	    isArray = __webpack_require__(30),
	    isBuffer = __webpack_require__(162),
	    isTypedArray = __webpack_require__(207);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(119),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObjectLike(value) && baseGetTag(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(119),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isLength = __webpack_require__(328),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56),
	    isPrototype = __webpack_require__(250),
	    nativeKeysIn = __webpack_require__(1772);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(455),
	    getMatchData = __webpack_require__(461),
	    matchesStrictComparable = __webpack_require__(776);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(317),
	    get = __webpack_require__(327),
	    hasIn = __webpack_require__(465),
	    isKey = __webpack_require__(463),
	    isStrictComparable = __webpack_require__(775),
	    matchesStrictComparable = __webpack_require__(776),
	    toKey = __webpack_require__(140);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(740),
	    cloneBuffer = __webpack_require__(759),
	    cloneTypedArray = __webpack_require__(760),
	    copyArray = __webpack_require__(249),
	    initCloneObject = __webpack_require__(774),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(30),
	    isArrayLikeObject = __webpack_require__(792),
	    isBuffer = __webpack_require__(162),
	    isFunction = __webpack_require__(141),
	    isObject = __webpack_require__(56),
	    isPlainObject = __webpack_require__(120),
	    isTypedArray = __webpack_require__(207),
	    safeGet = __webpack_require__(780),
	    toPlainObject = __webpack_require__(806);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(752),
	    hasIn = __webpack_require__(465);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySample = __webpack_require__(738),
	    values = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.sample`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 */
	function baseSample(collection) {
	  return arraySample(values(collection));
	}
	
	module.exports = baseSample;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(316),
	    shuffleSelf = __webpack_require__(325),
	    values = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.sampleSize` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to sample.
	 * @param {number} n The number of elements to sample.
	 * @returns {Array} Returns the random elements.
	 */
	function baseSampleSize(collection, n) {
	  var array = values(collection);
	  return shuffleSelf(array, baseClamp(n, 0, array.length));
	}
	
	module.exports = baseSampleSize;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(787),
	    defineProperty = __webpack_require__(767),
	    identity = __webpack_require__(204);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	var shuffleSelf = __webpack_require__(325),
	    values = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.shuffle`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 */
	function baseShuffle(collection) {
	  return shuffleSelf(values(collection));
	}
	
	module.exports = baseShuffle;


/***/ }),
/* 1727 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(137);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(157);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(156),
	    arrayMap = __webpack_require__(157),
	    isArray = __webpack_require__(30),
	    isSymbol = __webpack_require__(206);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1787);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 1734 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(458);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(156);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(206);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1738);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(102),
	    getSymbols = __webpack_require__(462);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(102),
	    getSymbolsIn = __webpack_require__(771);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(457),
	    isObject = __webpack_require__(56);
	
	/**
	 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	 * objects into destination objects that are passed thru.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to merge.
	 * @param {Object} object The parent object of `objValue`.
	 * @param {Object} source The parent object of `srcValue`.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	  if (isObject(objValue) && isObject(srcValue)) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, objValue);
	    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	    stack['delete'](srcValue);
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsMerge;


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(120);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(156),
	    Uint8Array = __webpack_require__(736),
	    eq = __webpack_require__(161),
	    equalArrays = __webpack_require__(768),
	    mapToArray = __webpack_require__(464),
	    setToArray = __webpack_require__(781);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(770);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(156);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1747 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(324);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(324);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(324);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(324);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1753 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(458),
	    cloneDataView = __webpack_require__(1735),
	    cloneRegExp = __webpack_require__(1736),
	    cloneSymbol = __webpack_require__(1737),
	    cloneTypedArray = __webpack_require__(760);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(156),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(30);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1756 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(761),
	    isFunction = __webpack_require__(141),
	    stubFalse = __webpack_require__(802);
	
	/**
	 * Checks if `func` is capable of being masked.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	 */
	var isMaskable = coreJsData ? isFunction : stubFalse;
	
	module.exports = isMaskable;


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(761);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1759 */
/***/ (function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(315);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(315);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(315);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(315);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1683),
	    ListCache = __webpack_require__(310),
	    Map = __webpack_require__(447);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(321);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(321);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(321);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(321);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1857);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(777);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1772 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1773 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1775 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1776 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	module.exports = setToPairs;


/***/ }),
/* 1777 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(310);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1779 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1780 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1781 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(310),
	    Map = __webpack_require__(447),
	    MapCache = __webpack_require__(448);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1783 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(1695),
	    hasUnicode = __webpack_require__(773),
	    unicodeSize = __webpack_require__(1788);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(1696),
	    hasUnicode = __webpack_require__(773),
	    unicodeToArray = __webpack_require__(1789);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1770);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1787 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 1788 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ }),
/* 1789 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(314),
	    copyObject = __webpack_require__(102),
	    createAssigner = __webpack_require__(201),
	    isArrayLike = __webpack_require__(69),
	    isPrototype = __webpack_require__(250),
	    keys = __webpack_require__(70);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(102),
	    createAssigner = __webpack_require__(201),
	    keys = __webpack_require__(70);
	
	/**
	 * This method is like `_.assign` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignInWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keys(source), object, customizer);
	});
	
	module.exports = assignWith;


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAt = __webpack_require__(1699),
	    flatRest = __webpack_require__(459);
	
	/**
	 * Creates an array of values corresponding to `paths` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Array} Returns the picked values.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	 *
	 * _.at(object, ['a[0].b.c', 'a[1]']);
	 * // => [3, 4]
	 */
	var at = flatRest(baseAt);
	
	module.exports = at;


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(30);
	
	/**
	 * Casts `value` as an array if it's not one.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.4.0
	 * @category Lang
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast array.
	 * @example
	 *
	 * _.castArray(1);
	 * // => [1]
	 *
	 * _.castArray({ 'a': 1 });
	 * // => [{ 'a': 1 }]
	 *
	 * _.castArray('abc');
	 * // => ['abc']
	 *
	 * _.castArray(null);
	 * // => [null]
	 *
	 * _.castArray(undefined);
	 * // => [undefined]
	 *
	 * _.castArray();
	 * // => []
	 *
	 * var array = [1, 2, 3];
	 * console.log(_.castArray(array) === array);
	 * // => true
	 */
	function castArray() {
	  if (!arguments.length) {
	    return [];
	  }
	  var value = arguments[0];
	  return isArray(value) ? value : [value];
	}
	
	module.exports = castArray;


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(247);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(247);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.cloneWith` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.cloneWith
	 * @example
	 *
	 * function customizer(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(true);
	 *   }
	 * }
	 *
	 * var el = _.cloneDeepWith(document.body, customizer);
	 *
	 * console.log(el === document.body);
	 * // => false
	 * console.log(el.nodeName);
	 * // => 'BODY'
	 * console.log(el.childNodes.length);
	 * // => 20
	 */
	function cloneDeepWith(value, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	}
	
	module.exports = cloneDeepWith;


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(247);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it accepts `customizer` which
	 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	 * cloning is handled by the method instead. The `customizer` is invoked with
	 * up to four arguments; (value [, index|key, object, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeepWith
	 * @example
	 *
	 * function customizer(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(false);
	 *   }
	 * }
	 *
	 * var el = _.cloneWith(document.body, customizer);
	 *
	 * console.log(el === document.body);
	 * // => false
	 * console.log(el.nodeName);
	 * // => 'BODY'
	 * console.log(el.childNodes.length);
	 * // => 0
	 */
	function cloneWith(value, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	}
	
	module.exports = cloneWith;


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	var baseConformsTo = __webpack_require__(1700),
	    keys = __webpack_require__(70);
	
	/**
	 * Checks if `object` conforms to `source` by invoking the predicate
	 * properties of `source` with the corresponding property values of `object`.
	 *
	 * **Note:** This method is equivalent to `_.conforms` when `source` is
	 * partially applied.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.14.0
	 * @category Lang
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 *
	 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	 * // => true
	 *
	 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	 * // => false
	 */
	function conformsTo(object, source) {
	  return source == null || baseConformsTo(object, source, keys(source));
	}
	
	module.exports = conformsTo;


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(136),
	    createAggregator = __webpack_require__(319);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the number of times the key was returned by `iteratee`. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.countBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': 1, '6': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.countBy(['one', 'two', 'three'], 'length');
	 * // => { '3': 2, '5': 1 }
	 */
	var countBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    ++result[key];
	  } else {
	    baseAssignValue(result, key, 1);
	  }
	});
	
	module.exports = countBy;


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssign = __webpack_require__(741),
	    baseCreate = __webpack_require__(451);
	
	/**
	 * Creates an object that inherits from the `prototype` object. If a
	 * `properties` object is given, its own enumerable string keyed properties
	 * are assigned to the created object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Object
	 * @param {Object} prototype The object to inherit from.
	 * @param {Object} [properties] The properties to assign to the object.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * function Shape() {
	 *   this.x = 0;
	 *   this.y = 0;
	 * }
	 *
	 * function Circle() {
	 *   Shape.call(this);
	 * }
	 *
	 * Circle.prototype = _.create(Shape.prototype, {
	 *   'constructor': Circle
	 * });
	 *
	 * var circle = new Circle;
	 * circle instanceof Circle;
	 * // => true
	 *
	 * circle instanceof Shape;
	 * // => true
	 */
	function create(prototype, properties) {
	  var result = baseCreate(prototype);
	  return properties == null ? result : baseAssign(result, properties);
	}
	
	module.exports = create;


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(200),
	    eq = __webpack_require__(161),
	    isIterateeCall = __webpack_require__(202),
	    keysIn = __webpack_require__(71);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(312),
	    baseRest = __webpack_require__(200),
	    customDefaultsMerge = __webpack_require__(1742),
	    mergeWith = __webpack_require__(798);
	
	/**
	 * This method is like `_.defaults` except that it recursively assigns
	 * default properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaults
	 * @example
	 *
	 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	 * // => { 'a': { 'b': 2, 'c': 3 } }
	 */
	var defaultsDeep = baseRest(function(args) {
	  args.push(undefined, customDefaultsMerge);
	  return apply(mergeWith, undefined, args);
	});
	
	module.exports = defaultsDeep;


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(791);


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(804);


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(805);


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(1690),
	    baseEvery = __webpack_require__(1701),
	    baseIteratee = __webpack_require__(47),
	    isArray = __webpack_require__(30),
	    isIterateeCall = __webpack_require__(202);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(784);


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(785);


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(313),
	    baseFilter = __webpack_require__(743),
	    baseIteratee = __webpack_require__(47),
	    isArray = __webpack_require__(30);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(764),
	    findIndex = __webpack_require__(1810);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(452),
	    baseIteratee = __webpack_require__(47),
	    toInteger = __webpack_require__(121);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindKey = __webpack_require__(744),
	    baseForOwn = __webpack_require__(158),
	    baseIteratee = __webpack_require__(47);
	
	/**
	 * This method is like `_.find` except that it returns the key of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element,
	 *  else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findKey(users, function(o) { return o.age < 40; });
	 * // => 'barney' (iteration order is not guaranteed)
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findKey(users, { 'age': 1, 'active': true });
	 * // => 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findKey(users, 'active');
	 * // => 'barney'
	 */
	function findKey(object, predicate) {
	  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
	}
	
	module.exports = findKey;


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(764),
	    findLastIndex = __webpack_require__(1813);
	
	/**
	 * This method is like `_.find` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=collection.length-1] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * _.findLast([1, 2, 3, 4], function(n) {
	 *   return n % 2 == 1;
	 * });
	 * // => 3
	 */
	var findLast = createFind(findLastIndex);
	
	module.exports = findLast;


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(452),
	    baseIteratee = __webpack_require__(47),
	    toInteger = __webpack_require__(121);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * This method is like `_.findIndex` except that it iterates over elements
	 * of `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=array.length-1] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': true },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': false }
	 * ];
	 *
	 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	 * // => 2
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	 * // => 0
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findLastIndex(users, ['active', false]);
	 * // => 2
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findLastIndex(users, 'active');
	 * // => 0
	 */
	function findLastIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = length - 1;
	  if (fromIndex !== undefined) {
	    index = toInteger(fromIndex);
	    index = fromIndex < 0
	      ? nativeMax(length + index, 0)
	      : nativeMin(index, length - 1);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
	}
	
	module.exports = findLastIndex;


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindKey = __webpack_require__(744),
	    baseForOwnRight = __webpack_require__(454),
	    baseIteratee = __webpack_require__(47);
	
	/**
	 * This method is like `_.findKey` except that it iterates over elements of
	 * a collection in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element,
	 *  else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findLastKey(users, function(o) { return o.age < 40; });
	 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findLastKey(users, { 'age': 36, 'active': true });
	 * // => 'barney'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findLastKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findLastKey(users, 'active');
	 * // => 'pebbles'
	 */
	function findLastKey(object, predicate) {
	  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwnRight);
	}
	
	module.exports = findLastKey;


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(248),
	    map = __webpack_require__(87);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(248),
	    map = __webpack_require__(87);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * This method is like `_.flatMap` except that it recursively flattens the
	 * mapped results.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.7.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [[[n, n]]];
	 * }
	 *
	 * _.flatMapDeep([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMapDeep(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), INFINITY);
	}
	
	module.exports = flatMapDeep;


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(248),
	    map = __webpack_require__(87),
	    toInteger = __webpack_require__(121);
	
	/**
	 * This method is like `_.flatMap` except that it recursively flattens the
	 * mapped results up to `depth` times.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.7.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {number} [depth=1] The maximum recursion depth.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [[[n, n]]];
	 * }
	 *
	 * _.flatMapDepth([1, 2], duplicate, 2);
	 * // => [[1, 1], [2, 2]]
	 */
	function flatMapDepth(collection, iteratee, depth) {
	  depth = depth === undefined ? 1 : toInteger(depth);
	  return baseFlatten(map(collection, iteratee), depth);
	}
	
	module.exports = flatMapDepth;


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(248);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(453),
	    castFunction = __webpack_require__(138),
	    keysIn = __webpack_require__(71);
	
	/**
	 * Iterates over own and inherited enumerable string keyed properties of an
	 * object and invokes `iteratee` for each property. The iteratee is invoked
	 * with three arguments: (value, key, object). Iteratee functions may exit
	 * iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forInRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forIn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	 */
	function forIn(object, iteratee) {
	  return object == null
	    ? object
	    : baseFor(object, castFunction(iteratee), keysIn);
	}
	
	module.exports = forIn;


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForRight = __webpack_require__(745),
	    castFunction = __webpack_require__(138),
	    keysIn = __webpack_require__(71);
	
	/**
	 * This method is like `_.forIn` except that it iterates over properties of
	 * `object` in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forInRight(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	 */
	function forInRight(object, iteratee) {
	  return object == null
	    ? object
	    : baseForRight(object, castFunction(iteratee), keysIn);
	}
	
	module.exports = forInRight;


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwnRight = __webpack_require__(454),
	    castFunction = __webpack_require__(138);
	
	/**
	 * This method is like `_.forOwn` except that it iterates over properties of
	 * `object` in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwnRight(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	 */
	function forOwnRight(object, iteratee) {
	  return object && baseForOwnRight(object, castFunction(iteratee));
	}
	
	module.exports = forOwnRight;


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(746),
	    keys = __webpack_require__(70);
	
	/**
	 * Creates an array of function property names from own enumerable properties
	 * of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the function names.
	 * @see _.functionsIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = _.constant('a');
	 *   this.b = _.constant('b');
	 * }
	 *
	 * Foo.prototype.c = _.constant('c');
	 *
	 * _.functions(new Foo);
	 * // => ['a', 'b']
	 */
	function functions(object) {
	  return object == null ? [] : baseFunctions(object, keys(object));
	}
	
	module.exports = functions;


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(746),
	    keysIn = __webpack_require__(71);
	
	/**
	 * Creates an array of function property names from own and inherited
	 * enumerable properties of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the function names.
	 * @see _.functions
	 * @example
	 *
	 * function Foo() {
	 *   this.a = _.constant('a');
	 *   this.b = _.constant('b');
	 * }
	 *
	 * Foo.prototype.c = _.constant('c');
	 *
	 * _.functionsIn(new Foo);
	 * // => ['a', 'b', 'c']
	 */
	function functionsIn(object) {
	  return object == null ? [] : baseFunctions(object, keysIn(object));
	}
	
	module.exports = functionsIn;


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(136),
	    createAggregator = __webpack_require__(319);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGt = __webpack_require__(1702),
	    createRelationalOperation = __webpack_require__(320);
	
	/**
	 * Checks if `value` is greater than `other`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.9.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 * @see _.lt
	 * @example
	 *
	 * _.gt(3, 1);
	 * // => true
	 *
	 * _.gt(3, 3);
	 * // => false
	 *
	 * _.gt(1, 3);
	 * // => false
	 */
	var gt = createRelationalOperation(baseGt);
	
	module.exports = gt;


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	var createRelationalOperation = __webpack_require__(320);
	
	/**
	 * Checks if `value` is greater than or equal to `other`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.9.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than or equal to
	 *  `other`, else `false`.
	 * @see _.lte
	 * @example
	 *
	 * _.gte(3, 1);
	 * // => true
	 *
	 * _.gte(3, 3);
	 * // => true
	 *
	 * _.gte(1, 3);
	 * // => false
	 */
	var gte = createRelationalOperation(function(value, other) {
	  return value >= other;
	});
	
	module.exports = gte;


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(1703),
	    hasPath = __webpack_require__(772);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1705),
	    isArrayLike = __webpack_require__(69),
	    isString = __webpack_require__(251),
	    toInteger = __webpack_require__(121),
	    values = __webpack_require__(208);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(787),
	    createInverter = __webpack_require__(765),
	    identity = __webpack_require__(204);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite
	 * property assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  if (value != null &&
	      typeof value.toString != 'function') {
	    value = nativeObjectToString.call(value);
	  }
	
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(47),
	    createInverter = __webpack_require__(765);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * This method is like `_.invert` except that the inverted object is generated
	 * from the results of running each element of `object` thru `iteratee`. The
	 * corresponding inverted value of each inverted key is an array of keys
	 * responsible for generating the inverted value. The iteratee is invoked
	 * with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.1.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invertBy(object);
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 *
	 * _.invertBy(object, function(value) {
	 *   return 'group' + value;
	 * });
	 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	 */
	var invertBy = createInverter(function(result, value, key) {
	  if (value != null &&
	      typeof value.toString != 'function') {
	    value = nativeObjectToString.call(value);
	  }
	
	  if (hasOwnProperty.call(result, value)) {
	    result[value].push(key);
	  } else {
	    result[value] = [key];
	  }
	}, baseIteratee);
	
	module.exports = invertBy;


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	var baseInvoke = __webpack_require__(748),
	    baseRest = __webpack_require__(200);
	
	/**
	 * Invokes the method at `path` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {...*} [args] The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	 *
	 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	 * // => [2, 3]
	 */
	var invoke = baseRest(baseInvoke);
	
	module.exports = invoke;


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(312),
	    baseEach = __webpack_require__(137),
	    baseInvoke = __webpack_require__(748),
	    baseRest = __webpack_require__(200),
	    isArrayLike = __webpack_require__(69);
	
	/**
	 * Invokes the method at `path` of each element in `collection`, returning
	 * an array of the results of each invoked method. Any additional arguments
	 * are provided to each invoked method. If `path` is a function, it's invoked
	 * for, and `this` bound to, each element in `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|string} path The path of the method to invoke or
	 *  the function invoked per iteration.
	 * @param {...*} [args] The arguments to invoke each method with.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	 * // => [[1, 5, 7], [1, 2, 3]]
	 *
	 * _.invokeMap([123, 456], String.prototype.split, '');
	 * // => [['1', '2', '3'], ['4', '5', '6']]
	 */
	var invokeMap = baseRest(function(collection, path, args) {
	  var index = -1,
	      isFunc = typeof path == 'function',
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value) {
	    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	  });
	  return result;
	});
	
	module.exports = invokeMap;


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArrayBuffer = __webpack_require__(1708),
	    baseUnary = __webpack_require__(159),
	    nodeUtil = __webpack_require__(203);
	
	/* Node.js helper references. */
	var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer;
	
	/**
	 * Checks if `value` is classified as an `ArrayBuffer` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	 * @example
	 *
	 * _.isArrayBuffer(new ArrayBuffer(2));
	 * // => true
	 *
	 * _.isArrayBuffer(new Array(2));
	 * // => false
	 */
	var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	module.exports = isArrayBuffer;


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && baseGetTag(value) == boolTag);
	}
	
	module.exports = isBoolean;


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsDate = __webpack_require__(1709),
	    baseUnary = __webpack_require__(159),
	    nodeUtil = __webpack_require__(203);
	
	/* Node.js helper references. */
	var nodeIsDate = nodeUtil && nodeUtil.isDate;
	
	/**
	 * Checks if `value` is classified as a `Date` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	 * @example
	 *
	 * _.isDate(new Date);
	 * // => true
	 *
	 * _.isDate('Mon April 23 2012');
	 * // => false
	 */
	var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	module.exports = isDate;


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(48),
	    isPlainObject = __webpack_require__(120);
	
	/**
	 * Checks if `value` is likely a DOM element.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	 * @example
	 *
	 * _.isElement(document.body);
	 * // => true
	 *
	 * _.isElement('<body>');
	 * // => false
	 */
	function isElement(value) {
	  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	}
	
	module.exports = isElement;


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(456),
	    getTag = __webpack_require__(119),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(30),
	    isArrayLike = __webpack_require__(69),
	    isBuffer = __webpack_require__(162),
	    isPrototype = __webpack_require__(250),
	    isTypedArray = __webpack_require__(207);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(317);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(317);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48),
	    isPlainObject = __webpack_require__(120);
	
	/** `Object#toString` result references. */
	var domExcTag = '[object DOMException]',
	    errorTag = '[object Error]';
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike(value)) {
	    return false;
	  }
	  var tag = baseGetTag(value);
	  return tag == errorTag || tag == domExcTag ||
	    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	}
	
	module.exports = isError;


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite;
	
	/**
	 * Checks if `value` is a finite primitive number.
	 *
	 * **Note:** This method is based on
	 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	 * @example
	 *
	 * _.isFinite(3);
	 * // => true
	 *
	 * _.isFinite(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isFinite(Infinity);
	 * // => false
	 *
	 * _.isFinite('3');
	 * // => false
	 */
	function isFinite(value) {
	  return typeof value == 'number' && nativeIsFinite(value);
	}
	
	module.exports = isFinite;


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(455),
	    getMatchData = __webpack_require__(461);
	
	/**
	 * Performs a partial deep comparison between `object` and `source` to
	 * determine if `object` contains equivalent property values.
	 *
	 * **Note:** This method is equivalent to `_.matches` when `source` is
	 * partially applied.
	 *
	 * Partial comparisons will match empty array and empty object `source`
	 * values against any array or object value, respectively. See `_.isEqual`
	 * for a list of supported value comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 *
	 * _.isMatch(object, { 'b': 2 });
	 * // => true
	 *
	 * _.isMatch(object, { 'b': 1 });
	 * // => false
	 */
	function isMatch(object, source) {
	  return object === source || baseIsMatch(object, source, getMatchData(source));
	}
	
	module.exports = isMatch;


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(455),
	    getMatchData = __webpack_require__(461);
	
	/**
	 * This method is like `_.isMatch` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with five
	 * arguments: (objValue, srcValue, index|key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var object = { 'greeting': 'hello' };
	 * var source = { 'greeting': 'hi' };
	 *
	 * _.isMatchWith(object, source, customizer);
	 * // => true
	 */
	function isMatchWith(object, source, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return baseIsMatch(object, source, getMatchData(source), customizer);
	}
	
	module.exports = isMatchWith;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(795);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(749),
	    isMaskable = __webpack_require__(1757);
	
	/** Error message constants. */
	var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.';
	
	/**
	 * Checks if `value` is a pristine native function.
	 *
	 * **Note:** This method can't reliably detect native functions in the presence
	 * of the core-js package because core-js circumvents this kind of detection.
	 * Despite multiple requests, the core-js maintainer has made it clear: any
	 * attempt to fix the detection will be obstructed. As a result, we're left
	 * with little choice but to throw an error. Unfortunately, this also affects
	 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	 * which rely on core-js.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (isMaskable(value)) {
	    throw new Error(CORE_ERROR_TEXT);
	  }
	  return baseIsNative(value);
	}
	
	module.exports = isNative;


/***/ }),
/* 1846 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(1713),
	    baseUnary = __webpack_require__(159),
	    nodeUtil = __webpack_require__(203);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	var isInteger = __webpack_require__(793);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	 * double precision number which isn't the result of a rounded unsafe integer.
	 *
	 * **Note:** This method is based on
	 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	 * @example
	 *
	 * _.isSafeInteger(3);
	 * // => true
	 *
	 * _.isSafeInteger(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isSafeInteger(Infinity);
	 * // => false
	 *
	 * _.isSafeInteger('3');
	 * // => false
	 */
	function isSafeInteger(value) {
	  return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isSafeInteger;


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(119),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var weakMapTag = '[object WeakMap]';
	
	/**
	 * Checks if `value` is classified as a `WeakMap` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	 * @example
	 *
	 * _.isWeakMap(new WeakMap);
	 * // => true
	 *
	 * _.isWeakMap(new Map);
	 * // => false
	 */
	function isWeakMap(value) {
	  return isObjectLike(value) && getTag(value) == weakMapTag;
	}
	
	module.exports = isWeakMap;


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(68),
	    isObjectLike = __webpack_require__(48);
	
	/** `Object#toString` result references. */
	var weakSetTag = '[object WeakSet]';
	
	/**
	 * Checks if `value` is classified as a `WeakSet` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	 * @example
	 *
	 * _.isWeakSet(new WeakSet);
	 * // => true
	 *
	 * _.isWeakSet(new Set);
	 * // => false
	 */
	function isWeakSet(value) {
	  return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	}
	
	module.exports = isWeakSet;


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(136),
	    createAggregator = __webpack_require__(319);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	var baseLt = __webpack_require__(1717),
	    createRelationalOperation = __webpack_require__(320);
	
	/**
	 * Checks if `value` is less than `other`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.9.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 * @see _.gt
	 * @example
	 *
	 * _.lt(1, 3);
	 * // => true
	 *
	 * _.lt(3, 3);
	 * // => false
	 *
	 * _.lt(3, 1);
	 * // => false
	 */
	var lt = createRelationalOperation(baseLt);
	
	module.exports = lt;


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	var createRelationalOperation = __webpack_require__(320);
	
	/**
	 * Checks if `value` is less than or equal to `other`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.9.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than or equal to
	 *  `other`, else `false`.
	 * @see _.gte
	 * @example
	 *
	 * _.lte(1, 3);
	 * // => true
	 *
	 * _.lte(3, 3);
	 * // => true
	 *
	 * _.lte(3, 1);
	 * // => false
	 */
	var lte = createRelationalOperation(function(value, other) {
	  return value <= other;
	});
	
	module.exports = lte;


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(136),
	    baseForOwn = __webpack_require__(158),
	    baseIteratee = __webpack_require__(47);
	
	/**
	 * The opposite of `_.mapValues`; this method creates an object with the
	 * same values as `object` and keys generated by running each own enumerable
	 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	 * with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapValues
	 * @example
	 *
	 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   return key + value;
	 * });
	 * // => { 'a1': 1, 'b2': 2 }
	 */
	function mapKeys(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, iteratee(value, key, object), value);
	  });
	  return result;
	}
	
	module.exports = mapKeys;


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(136),
	    baseForOwn = __webpack_require__(158),
	    baseIteratee = __webpack_require__(47);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(448);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(157),
	    baseClone = __webpack_require__(247),
	    baseUnset = __webpack_require__(756),
	    castPath = __webpack_require__(139),
	    copyObject = __webpack_require__(102),
	    customOmitClone = __webpack_require__(1743),
	    flatRest = __webpack_require__(459),
	    getAllKeysIn = __webpack_require__(460);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(47),
	    negate = __webpack_require__(799),
	    pickBy = __webpack_require__(800);
	
	/**
	 * The opposite of `_.pickBy`; this method creates an object composed of
	 * the own and inherited enumerable string keyed properties of `object` that
	 * `predicate` doesn't return truthy for. The predicate is invoked with two
	 * arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omitBy(object, _.isNumber);
	 * // => { 'b': '2' }
	 */
	function omitBy(object, predicate) {
	  return pickBy(object, negate(baseIteratee(predicate)));
	}
	
	module.exports = omitBy;


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(751),
	    isArray = __webpack_require__(30);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(319);
	
	/**
	 * Creates an array of elements split into two groups, the first of which
	 * contains elements `predicate` returns truthy for, the second of which
	 * contains elements `predicate` returns falsey for. The predicate is
	 * invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of grouped elements.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': false },
	 *   { 'user': 'fred',    'age': 40, 'active': true },
	 *   { 'user': 'pebbles', 'age': 1,  'active': false }
	 * ];
	 *
	 * _.partition(users, function(o) { return o.active; });
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.partition(users, { 'age': 1, 'active': false });
	 * // => objects for [['pebbles'], ['barney', 'fred']]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.partition(users, ['active', false]);
	 * // => objects for [['barney', 'pebbles'], ['fred']]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.partition(users, 'active');
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 */
	var partition = createAggregator(function(result, value, key) {
	  result[key ? 0 : 1].push(value);
	}, function() { return [[], []]; });
	
	module.exports = partition;


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(1721),
	    flatRest = __webpack_require__(459);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(753),
	    basePropertyDeep = __webpack_require__(1722),
	    isKey = __webpack_require__(463),
	    toKey = __webpack_require__(140);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(1691),
	    baseEach = __webpack_require__(137),
	    baseIteratee = __webpack_require__(47),
	    baseReduce = __webpack_require__(755),
	    isArray = __webpack_require__(30);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduceRight = __webpack_require__(1692),
	    baseEachRight = __webpack_require__(742),
	    baseIteratee = __webpack_require__(47),
	    baseReduce = __webpack_require__(755),
	    isArray = __webpack_require__(30);
	
	/**
	 * This method is like `_.reduce` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduce
	 * @example
	 *
	 * var array = [[0, 1], [2, 3], [4, 5]];
	 *
	 * _.reduceRight(array, function(flattened, other) {
	 *   return flattened.concat(other);
	 * }, []);
	 * // => [4, 5, 2, 3, 0, 1]
	 */
	function reduceRight(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduceRight : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	}
	
	module.exports = reduceRight;


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(313),
	    baseFilter = __webpack_require__(743),
	    baseIteratee = __webpack_require__(47),
	    isArray = __webpack_require__(30),
	    negate = __webpack_require__(799);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, negate(baseIteratee(predicate, 3)));
	}
	
	module.exports = reject;


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(139),
	    isFunction = __webpack_require__(141),
	    toKey = __webpack_require__(140);
	
	/**
	 * This method is like `_.get` except that if the resolved value is a
	 * function it's invoked with the `this` binding of its parent object and
	 * its result is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to resolve.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	 *
	 * _.result(object, 'a[0].b.c1');
	 * // => 3
	 *
	 * _.result(object, 'a[0].b.c2');
	 * // => 4
	 *
	 * _.result(object, 'a[0].b.c3', 'default');
	 * // => 'default'
	 *
	 * _.result(object, 'a[0].b.c3', _.constant('default'));
	 * // => 'default'
	 */
	function result(object, path, defaultValue) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length;
	
	  // Ensure the loop is entered when path is empty.
	  if (!length) {
	    length = 1;
	    object = undefined;
	  }
	  while (++index < length) {
	    var value = object == null ? undefined : object[toKey(path[index])];
	    if (value === undefined) {
	      index = length;
	      value = defaultValue;
	    }
	    object = isFunction(value) ? value.call(object) : value;
	  }
	  return object;
	}
	
	module.exports = result;


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySample = __webpack_require__(738),
	    baseSample = __webpack_require__(1723),
	    isArray = __webpack_require__(30);
	
	/**
	 * Gets a random element from `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 * @example
	 *
	 * _.sample([1, 2, 3, 4]);
	 * // => 2
	 */
	function sample(collection) {
	  var func = isArray(collection) ? arraySample : baseSample;
	  return func(collection);
	}
	
	module.exports = sample;


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySampleSize = __webpack_require__(1693),
	    baseSampleSize = __webpack_require__(1724),
	    isArray = __webpack_require__(30),
	    isIterateeCall = __webpack_require__(202),
	    toInteger = __webpack_require__(121);
	
	/**
	 * Gets `n` random elements at unique keys from `collection` up to the
	 * size of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @param {number} [n=1] The number of elements to sample.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the random elements.
	 * @example
	 *
	 * _.sampleSize([1, 2, 3], 2);
	 * // => [3, 1]
	 *
	 * _.sampleSize([1, 2, 3], 4);
	 * // => [2, 3, 1]
	 */
	function sampleSize(collection, n, guard) {
	  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	    n = 1;
	  } else {
	    n = toInteger(n);
	  }
	  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	  return func(collection, n);
	}
	
	module.exports = sampleSize;


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(318);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(318);
	
	/**
	 * This method is like `_.set` except that it accepts `customizer` which is
	 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	 * path creation is handled by the method instead. The `customizer` is invoked
	 * with three arguments: (nsValue, key, nsObject).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {};
	 *
	 * _.setWith(object, '[0][1]', 'a', Object);
	 * // => { '0': { '1': 'a' } }
	 */
	function setWith(object, path, value, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return object == null ? object : baseSet(object, path, value, customizer);
	}
	
	module.exports = setWith;


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayShuffle = __webpack_require__(1694),
	    baseShuffle = __webpack_require__(1726),
	    isArray = __webpack_require__(30);
	
	/**
	 * Creates an array of shuffled values, using a version of the
	 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 * @example
	 *
	 * _.shuffle([1, 2, 3, 4]);
	 * // => [4, 1, 3, 2]
	 */
	function shuffle(collection) {
	  var func = isArray(collection) ? arrayShuffle : baseShuffle;
	  return func(collection);
	}
	
	module.exports = shuffle;


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(456),
	    getTag = __webpack_require__(119),
	    isArrayLike = __webpack_require__(69),
	    isString = __webpack_require__(251),
	    stringSize = __webpack_require__(1784);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable string keyed properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @returns {number} Returns the collection size.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  if (collection == null) {
	    return 0;
	  }
	  if (isArrayLike(collection)) {
	    return isString(collection) ? stringSize(collection) : collection.length;
	  }
	  var tag = getTag(collection);
	  if (tag == mapTag || tag == setTag) {
	    return collection.size;
	  }
	  return baseKeys(collection).length;
	}
	
	module.exports = size;


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(739),
	    baseIteratee = __webpack_require__(47),
	    baseSome = __webpack_require__(1728),
	    isArray = __webpack_require__(30),
	    isIterateeCall = __webpack_require__(202);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(248),
	    baseOrderBy = __webpack_require__(751),
	    baseRest = __webpack_require__(200),
	    isIterateeCall = __webpack_require__(202);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(788),
	    isObject = __webpack_require__(56);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(156),
	    copyArray = __webpack_require__(249),
	    getTag = __webpack_require__(119),
	    isArrayLike = __webpack_require__(69),
	    isString = __webpack_require__(251),
	    iteratorToArray = __webpack_require__(1759),
	    mapToArray = __webpack_require__(464),
	    setToArray = __webpack_require__(781),
	    stringToArray = __webpack_require__(1785),
	    values = __webpack_require__(208);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Built-in value references. */
	var symIterator = Symbol ? Symbol.iterator : undefined;
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike(value)) {
	    return isString(value) ? stringToArray(value) : copyArray(value);
	  }
	  if (symIterator && value[symIterator]) {
	    return iteratorToArray(value[symIterator]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	  return func(value);
	}
	
	module.exports = toArray;


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(316),
	    toInteger = __webpack_require__(121);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Converts `value` to an integer suitable for use as the length of an
	 * array-like object.
	 *
	 * **Note:** This method is based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toLength(3.2);
	 * // => 3
	 *
	 * _.toLength(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toLength(Infinity);
	 * // => 4294967295
	 *
	 * _.toLength('3.2');
	 * // => 3
	 */
	function toLength(value) {
	  return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	}
	
	module.exports = toLength;


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(316),
	    toInteger = __webpack_require__(121);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Converts `value` to a safe integer. A safe integer can be compared and
	 * represented correctly.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toSafeInteger(3.2);
	 * // => 3
	 *
	 * _.toSafeInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toSafeInteger(Infinity);
	 * // => 9007199254740991
	 *
	 * _.toSafeInteger('3.2');
	 * // => 3
	 */
	function toSafeInteger(value) {
	  return value
	    ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	    : (value === 0 ? value : 0);
	}
	
	module.exports = toSafeInteger;


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(449),
	    baseCreate = __webpack_require__(451),
	    baseForOwn = __webpack_require__(158),
	    baseIteratee = __webpack_require__(47),
	    getPrototype = __webpack_require__(322),
	    isArray = __webpack_require__(30),
	    isBuffer = __webpack_require__(162),
	    isFunction = __webpack_require__(141),
	    isObject = __webpack_require__(56),
	    isTypedArray = __webpack_require__(207);
	
	/**
	 * An alternative to `_.reduce`; this method transforms `object` to a new
	 * `accumulator` object which is the result of running each of its own
	 * enumerable string keyed properties thru `iteratee`, with each invocation
	 * potentially mutating the `accumulator` object. If `accumulator` is not
	 * provided, a new object with the same `[[Prototype]]` will be used. The
	 * iteratee is invoked with four arguments: (accumulator, value, key, object).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The custom accumulator value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.transform([2, 3, 4], function(result, n) {
	 *   result.push(n *= n);
	 *   return n % 2 == 0;
	 * }, []);
	 * // => [4, 9]
	 *
	 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 */
	function transform(object, iteratee, accumulator) {
	  var isArr = isArray(object),
	      isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	  iteratee = baseIteratee(iteratee, 4);
	  if (accumulator == null) {
	    var Ctor = object && object.constructor;
	    if (isArrLike) {
	      accumulator = isArr ? new Ctor : [];
	    }
	    else if (isObject(object)) {
	      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	    }
	    else {
	      accumulator = {};
	    }
	  }
	  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	    return iteratee(accumulator, value, index, object);
	  });
	  return accumulator;
	}
	
	module.exports = transform;


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUnset = __webpack_require__(756);
	
	/**
	 * Removes the property at `path` of `object`.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	 * _.unset(object, 'a[0].b.c');
	 * // => true
	 *
	 * console.log(object);
	 * // => { 'a': [{ 'b': {} }] };
	 *
	 * _.unset(object, ['a', '0', 'b', 'c']);
	 * // => true
	 *
	 * console.log(object);
	 * // => { 'a': [{ 'b': {} }] };
	 */
	function unset(object, path) {
	  return object == null ? true : baseUnset(object, path);
	}
	
	module.exports = unset;


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUpdate = __webpack_require__(757),
	    castFunction = __webpack_require__(138);
	
	/**
	 * This method is like `_.set` except that accepts `updater` to produce the
	 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	 * is invoked with one argument: (value).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.6.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {Function} updater The function to produce the updated value.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	 * console.log(object.a[0].b.c);
	 * // => 9
	 *
	 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	 * console.log(object.x[0].y.z);
	 * // => 0
	 */
	function update(object, path, updater) {
	  return object == null ? object : baseUpdate(object, path, castFunction(updater));
	}
	
	module.exports = update;


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUpdate = __webpack_require__(757),
	    castFunction = __webpack_require__(138);
	
	/**
	 * This method is like `_.update` except that it accepts `customizer` which is
	 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	 * path creation is handled by the method instead. The `customizer` is invoked
	 * with three arguments: (nsValue, key, nsObject).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.6.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {Function} updater The function to produce the updated value.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {};
	 *
	 * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	 * // => { '0': { '1': 'a' } }
	 */
	function updateWith(object, path, updater, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	}
	
	module.exports = updateWith;


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(758),
	    keysIn = __webpack_require__(71);
	
	/**
	 * Creates an array of the own and inherited enumerable string keyed property
	 * values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.valuesIn(new Foo);
	 * // => [1, 2, 3] (iteration order is not guaranteed)
	 */
	function valuesIn(object) {
	  return object == null ? [] : baseValues(object, keysIn(object));
	}
	
	module.exports = valuesIn;


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(1543),
	      utf8 = __webpack_require__(634).utf8,
	      isBuffer = __webpack_require__(1672),
	      bin = __webpack_require__(634).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en-au": 810,
		"./en-au.js": 810,
		"./en-ca": 811,
		"./en-ca.js": 811,
		"./en-gb": 812,
		"./en-gb.js": 812,
		"./en-ie": 813,
		"./en-ie.js": 813,
		"./en-il": 814,
		"./en-il.js": 814,
		"./en-in": 815,
		"./en-in.js": 815,
		"./en-nz": 816,
		"./en-nz.js": 816,
		"./en-sg": 817,
		"./en-sg.js": 817,
		"./fr": 820,
		"./fr-ca": 818,
		"./fr-ca.js": 818,
		"./fr-ch": 819,
		"./fr-ch.js": 819,
		"./fr.js": 820,
		"./nl": 822,
		"./nl-be": 821,
		"./nl-be.js": 821,
		"./nl.js": 822
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1887;


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(631)
	var ieee754 = __webpack_require__(730)
	var isArray = __webpack_require__(732)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1889 */
[2351, 243, 390, 823, 824, 1890],
/* 1890 */
[2353, 824, 243],
/* 1891 */
[2354, 826],
/* 1892 */
/***/ (function(module, exports) {

	exports.endianness = function () { return 'LE' };
	
	exports.hostname = function () {
	    if (typeof location !== 'undefined') {
	        return location.hostname
	    }
	    else return '';
	};
	
	exports.loadavg = function () { return [] };
	
	exports.uptime = function () { return 0 };
	
	exports.freemem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.totalmem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.cpus = function () { return [] };
	
	exports.type = function () { return 'Browser' };
	
	exports.release = function () {
	    if (typeof navigator !== 'undefined') {
	        return navigator.appVersion;
	    }
	    return '';
	};
	
	exports.networkInterfaces
	= exports.getNetworkInterfaces
	= function () { return {} };
	
	exports.arch = function () { return 'javascript' };
	
	exports.platform = function () { return 'browser' };
	
	exports.tmpdir = exports.tmpDir = function () {
	    return '/tmp';
	};
	
	exports.EOL = '\n';


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = require('./lib/has');
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(828);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(860);
	var assign = __webpack_require__(36);
	
	var ReactPropTypesSecret = __webpack_require__(828);
	var has = __webpack_require__(1897);
	var checkPropTypes = __webpack_require__(1894);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1897 */
/***/ (function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(375);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(1554);
	
	var _addEventListener = __webpack_require__(832);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _util = __webpack_require__(1900);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElement(func) {
	  if (typeof func !== 'function' || !func) return null;
	  return func();
	}
	
	function getPoint(point) {
	  if (typeof point !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          target = _this$props.target,
	          align = _this$props.align,
	          onAlign = _this$props.onAlign;
	
	      if (!disabled && target) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	
	        var result = void 0;
	        var element = getElement(target);
	        var point = getPoint(target);
	
	        // IE lose focus after element realign
	        // We should record activeElement and restore later
	        var activeElement = document.activeElement;
	
	        if (element) {
	          result = (0, _domAlign.alignElement)(source, element, align);
	        } else if (point) {
	          result = (0, _domAlign.alignPoint)(source, point, align);
	        }
	
	        (0, _util.restoreFocus)(activeElement, source);
	
	        if (onAlign) {
	          onAlign(source, result);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Align, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var props = this.props;
	      // if parent ref not attached .... use document.getElementById
	      this.forceAlign();
	      if (!props.disabled && props.monitorWindowResize) {
	        this.startMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var reAlign = false;
	      var props = this.props;
	
	      if (!props.disabled) {
	        var source = _reactDom2['default'].findDOMNode(this);
	        var sourceRect = source ? source.getBoundingClientRect() : null;
	
	        if (prevProps.disabled) {
	          reAlign = true;
	        } else {
	          var lastElement = getElement(prevProps.target);
	          var currentElement = getElement(props.target);
	          var lastPoint = getPoint(prevProps.target);
	          var currentPoint = getPoint(props.target);
	
	          if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) {
	            // Skip if is window
	            reAlign = false;
	          } else if (lastElement !== currentElement || // Element change
	          lastElement && !currentElement && currentPoint || // Change from element to point
	          lastPoint && currentPoint && currentElement || // Change from point to element
	          currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) {
	            reAlign = true;
	          }
	
	          // If source element size changed
	          var preRect = this.sourceRect || {};
	          if (!reAlign && source && (!(0, _util.isSimilarValue)(preRect.width, sourceRect.width) || !(0, _util.isSimilarValue)(preRect.height, sourceRect.height))) {
	            reAlign = true;
	          }
	        }
	
	        this.sourceRect = sourceRect;
	      }
	
	      if (reAlign) {
	        this.forceAlign();
	      }
	
	      if (props.monitorWindowResize && !props.disabled) {
	        this.startMonitorWindowResize();
	      } else {
	        this.stopMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopMonitorWindowResize();
	    }
	  }, {
	    key: 'startMonitorWindowResize',
	    value: function startMonitorWindowResize() {
	      if (!this.resizeHandler) {
	        this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
	        this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	      }
	    }
	  }, {
	    key: 'stopMonitorWindowResize',
	    value: function stopMonitorWindowResize() {
	      if (this.resizeHandler) {
	        this.bufferMonitor.clear();
	        this.resizeHandler.remove();
	        this.resizeHandler = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          childrenProps = _props.childrenProps,
	          children = _props.children;
	
	      var child = _react2['default'].Children.only(children);
	      if (childrenProps) {
	        var newProps = {};
	        var propList = Object.keys(childrenProps);
	        propList.forEach(function (prop) {
	          newProps[prop] = _this2.props[childrenProps[prop]];
	        });
	
	        return _react2['default'].cloneElement(child, newProps);
	      }
	      return child;
	    }
	  }]);
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].shape({
	    clientX: _propTypes2['default'].number,
	    clientY: _propTypes2['default'].number,
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })]),
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(1898);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffer = buffer;
	exports.isSamePoint = isSamePoint;
	exports.isWindow = isWindow;
	exports.isSimilarValue = isSimilarValue;
	exports.restoreFocus = restoreFocus;
	
	var _contains = __webpack_require__(833);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function isWindow(obj) {
	  return obj && typeof obj === 'object' && obj.window === obj;
	}
	
	function isSimilarValue(val1, val2) {
	  var int1 = Math.floor(val1);
	  var int2 = Math.floor(val2);
	  return Math.abs(int1 - int2) <= 1;
	}
	
	function restoreFocus(activeElement, container) {
	  // Focus back if is in the container
	  if (activeElement !== document.activeElement && (0, _contains2['default'])(container, activeElement)) {
	    activeElement.focus();
	  }
	}

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(221);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(1183);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(375);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(1913);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	var _ChildrenUtils = __webpack_require__(1903);
	
	var _AnimateChild = __webpack_require__(1902);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(829);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = (0, _unsafeLifecyclesPolyfill2['default'])(Animate);
	module.exports = exports['default'];

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(375);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(1545);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(829);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any,
	  animation: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Content = function (_React$Component) {
	  (0, _inherits3['default'])(Content, _React$Component);
	
	  function Content() {
	    (0, _classCallCheck3['default'])(this, Content);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Content.prototype.componentDidUpdate = function componentDidUpdate() {
	    var trigger = this.props.trigger;
	
	    if (trigger) {
	      trigger.forcePopupAlign();
	    }
	  };
	
	  Content.prototype.render = function render() {
	    var _props = this.props,
	        overlay = _props.overlay,
	        prefixCls = _props.prefixCls,
	        id = _props.id;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
	      typeof overlay === 'function' ? overlay() : overlay
	    );
	  };
	
	  return Content;
	}(_react2['default'].Component);
	
	Content.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  id: _propTypes2['default'].string,
	  trigger: _propTypes2['default'].any
	};
	exports['default'] = Content;
	module.exports = exports['default'];

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(221);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(620);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(1910);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _placements = __webpack_require__(1907);
	
	var _Content = __webpack_require__(1904);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tooltip = function (_Component) {
	  (0, _inherits3['default'])(Tooltip, _Component);
	
	  function Tooltip() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
	      var _this$props = _this.props,
	          arrowContent = _this$props.arrowContent,
	          overlay = _this$props.overlay,
	          prefixCls = _this$props.prefixCls,
	          id = _this$props.id;
	
	      return [_react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-arrow', key: 'arrow' },
	        arrowContent
	      ), _react2['default'].createElement(_Content2['default'], {
	        key: 'content',
	        trigger: _this.trigger,
	        prefixCls: prefixCls,
	        id: id,
	        overlay: overlay
	      })];
	    }, _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Tooltip.prototype.render = function render() {
	    var _props = this.props,
	        overlayClassName = _props.overlayClassName,
	        trigger = _props.trigger,
	        mouseEnterDelay = _props.mouseEnterDelay,
	        mouseLeaveDelay = _props.mouseLeaveDelay,
	        overlayStyle = _props.overlayStyle,
	        prefixCls = _props.prefixCls,
	        children = _props.children,
	        onVisibleChange = _props.onVisibleChange,
	        afterVisibleChange = _props.afterVisibleChange,
	        transitionName = _props.transitionName,
	        animation = _props.animation,
	        placement = _props.placement,
	        align = _props.align,
	        destroyTooltipOnHide = _props.destroyTooltipOnHide,
	        defaultVisible = _props.defaultVisible,
	        getTooltipContainer = _props.getTooltipContainer,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = (0, _extends3['default'])({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      (0, _extends3['default'])({
	        popupClassName: overlayClassName,
	        ref: this.saveTrigger,
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        afterPopupVisibleChange: afterVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  };
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  trigger: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  defaultVisible: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  animation: _propTypes2['default'].any,
	  onVisibleChange: _propTypes2['default'].func,
	  afterVisibleChange: _propTypes2['default'].func,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  overlayStyle: _propTypes2['default'].object,
	  overlayClassName: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  getTooltipContainer: _propTypes2['default'].func,
	  destroyTooltipOnHide: _propTypes2['default'].bool,
	  align: _propTypes2['default'].object,
	  arrowContent: _propTypes2['default'].any,
	  id: _propTypes2['default'].string
	};
	Tooltip.defaultProps = {
	  prefixCls: 'rc-tooltip',
	  mouseEnterDelay: 0,
	  destroyTooltipOnHide: false,
	  mouseLeaveDelay: 0.1,
	  align: {},
	  placement: 'right',
	  trigger: ['hover'],
	  arrowContent: null
	};
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Tooltip = __webpack_require__(1905);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tooltip2['default'];
	module.exports = exports['default'];

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(221);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(1899);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(1901);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(1909);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(830);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(831);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Used for stretch
	      stretchChecked: false,
	      targetWidth: undefined,
	      targetHeight: undefined
	    };
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	    this.setStretchSize();
	  };
	
	  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setStretchSize();
	  };
	
	  // Record size if stretch needed
	
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var _this2 = this;
	
	    var savePopupRef = this.savePopupRef;
	    var _state = this.state,
	        stretchChecked = _state.stretchChecked,
	        targetHeight = _state.targetHeight,
	        targetWidth = _state.targetWidth;
	    var _props = this.props,
	        align = _props.align,
	        visible = _props.visible,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        getClassNameFromAlign = _props.getClassNameFromAlign,
	        destroyPopupOnHide = _props.destroyPopupOnHide,
	        stretch = _props.stretch,
	        children = _props.children,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseLeave = _props.onMouseLeave,
	        onMouseDown = _props.onMouseDown,
	        onTouchStart = _props.onTouchStart;
	
	    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	
	    var sizeStyle = {};
	    if (stretch) {
	      // Stretch with target
	      if (stretch.indexOf('height') !== -1) {
	        sizeStyle.height = targetHeight;
	      } else if (stretch.indexOf('minHeight') !== -1) {
	        sizeStyle.minHeight = targetHeight;
	      }
	      if (stretch.indexOf('width') !== -1) {
	        sizeStyle.width = targetWidth;
	      } else if (stretch.indexOf('minWidth') !== -1) {
	        sizeStyle.minWidth = targetWidth;
	      }
	
	      // Delay force align to makes ui smooth
	      if (!stretchChecked) {
	        sizeStyle.visibility = 'hidden';
	        setTimeout(function () {
	          if (_this2.alignInstance) {
	            _this2.alignInstance.forceAlign();
	          }
	        }, 0);
	      }
	    }
	
	    var newStyle = (0, _extends3['default'])({}, sizeStyle, style, this.getZIndexStyle());
	
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDown: onMouseDown,
	      onTouchStart: onTouchStart,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getAlignTarget(),
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            children
	          )
	        ) : null
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getAlignTarget(),
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  stretch: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  point: _propTypes2['default'].shape({
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this3.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this3.currentAlignClassName !== currentAlignClassName) {
	      _this3.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this3.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.setStretchSize = function () {
	    var _props2 = _this3.props,
	        stretch = _props2.stretch,
	        getRootDomNode = _props2.getRootDomNode,
	        visible = _props2.visible;
	    var _state2 = _this3.state,
	        stretchChecked = _state2.stretchChecked,
	        targetHeight = _state2.targetHeight,
	        targetWidth = _state2.targetWidth;
	
	
	    if (!stretch || !visible) {
	      if (stretchChecked) {
	        _this3.setState({ stretchChecked: false });
	      }
	      return;
	    }
	
	    var $ele = getRootDomNode();
	    if (!$ele) return;
	
	    var height = $ele.offsetHeight;
	    var width = $ele.offsetWidth;
	
	    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
	      _this3.setState({
	        stretchChecked: true,
	        targetHeight: height,
	        targetWidth: width
	      });
	    }
	  };
	
	  this.getTargetElement = function () {
	    return _this3.props.getRootDomNode();
	  };
	
	  this.getAlignTarget = function () {
	    var point = _this3.props.point;
	
	    if (point) {
	      return point;
	    }
	    return _this3.getTargetElement;
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(830);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseDown: props.onMouseDown,
	        onTouchStart: props.onTouchStart,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(221);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(111);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(113);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(112);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactLifecyclesCompat = __webpack_require__(485);
	
	var _contains = __webpack_require__(833);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(832);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ContainerRender = __webpack_require__(1911);
	
	var _ContainerRender2 = _interopRequireDefault(_ContainerRender);
	
	var _Portal = __webpack_require__(1912);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(831);
	
	var _Popup = __webpack_require__(1908);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var contextTypes = {
	  rcTrigger: _propTypes2['default'].shape({
	    onPopupMouseDown: _propTypes2['default'].func
	  })
	};
	
	var Trigger = function (_React$Component) {
	  (0, _inherits3['default'])(Trigger, _React$Component);
	
	  function Trigger(props) {
	    (0, _classCallCheck3['default'])(this, Trigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    _this.state = {
	      prevPopupVisible: popupVisible,
	      popupVisible: popupVisible
	    };
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	    return _this;
	  }
	
	  Trigger.prototype.getChildContext = function getChildContext() {
	    return {
	      rcTrigger: {
	        onPopupMouseDown: this.onPopupMouseDown
	      }
	    };
	  };
	
	  Trigger.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  };
	
	  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	    clearTimeout(this.mouseDownTimeout);
	  };
	
	  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var popupVisible = _ref.popupVisible;
	
	    var newState = {};
	
	    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
	      newState.popupVisible = popupVisible;
	      newState.prevPopupVisible = prevState.popupVisible;
	    }
	
	    return newState;
	  };
	
	  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  };
	
	  Trigger.prototype.getPopupAlign = function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  };
	
	  /**
	   * @param popupVisible    Show or not the popup element
	   * @param event           SyntheticEvent, used for `pointAlign`
	   */
	  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
	    var alignPoint = this.props.alignPoint;
	    var prevPopupVisible = this.state.popupVisible;
	
	
	    this.clearDelayTimer();
	
	    if (prevPopupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	
	    // Always record the point position since mouseEnterDelay will delay the show
	    if (alignPoint && event) {
	      this.setPoint(event);
	    }
	  };
	
	  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible, point);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible, event);
	    }
	  };
	
	  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  };
	
	  Trigger.prototype.createTwoChains = function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  };
	
	  Trigger.prototype.isClickToShow = function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  };
	
	  Trigger.prototype.isClickToHide = function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  };
	
	  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  };
	
	  Trigger.prototype.isFocusToShow = function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  };
	
	  Trigger.prototype.isBlurToHide = function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  };
	
	  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  };
	
	  Trigger.prototype.fireEvents = function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  };
	
	  Trigger.prototype.close = function close() {
	    this.setPopupVisible(false);
	  };
	
	  Trigger.prototype.render = function render() {
	    var _this3 = this;
	
	    var popupVisible = this.state.popupVisible;
	    var _props8 = this.props,
	        children = _props8.children,
	        forceRender = _props8.forceRender,
	        alignPoint = _props8.alignPoint,
	        className = _props8.className;
	
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	      if (alignPoint) {
	        newChildProps.onMouseMove = this.onMouseMove;
	      }
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var childrenClassName = (0, _classnames2['default'])(child && child.props && child.props.className, className);
	    if (childrenClassName) {
	      newChildProps.className = childrenClassName;
	    }
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return _react2['default'].createElement(
	        _ContainerRender2['default'],
	        {
	          parent: this,
	          visible: popupVisible,
	          autoMount: false,
	          forceRender: forceRender,
	          getComponent: this.getComponent,
	          getContainer: this.getContainer
	        },
	        function (_ref2) {
	          var renderComponent = _ref2.renderComponent;
	
	          _this3.renderComponent = renderComponent;
	          return trigger;
	        }
	      );
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  };
	
	  return Trigger;
	}(_react2['default'].Component);
	
	Trigger.propTypes = {
	  children: _propTypes2['default'].any,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  showAction: _propTypes2['default'].any,
	  hideAction: _propTypes2['default'].any,
	  getPopupClassNameFromAlign: _propTypes2['default'].any,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  afterPopupVisibleChange: _propTypes2['default'].func,
	  popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  popupStyle: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  builtinPlacements: _propTypes2['default'].object,
	  popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  popupAnimation: _propTypes2['default'].any,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  zIndex: _propTypes2['default'].number,
	  focusDelay: _propTypes2['default'].number,
	  blurDelay: _propTypes2['default'].number,
	  getPopupContainer: _propTypes2['default'].func,
	  getDocument: _propTypes2['default'].func,
	  forceRender: _propTypes2['default'].bool,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  mask: _propTypes2['default'].bool,
	  maskClosable: _propTypes2['default'].bool,
	  onPopupAlign: _propTypes2['default'].func,
	  popupAlign: _propTypes2['default'].object,
	  popupVisible: _propTypes2['default'].bool,
	  defaultPopupVisible: _propTypes2['default'].bool,
	  maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  maskAnimation: _propTypes2['default'].string,
	  stretch: _propTypes2['default'].string,
	  alignPoint: _propTypes2['default'].bool // Maybe we can support user pass position in the future
	};
	Trigger.contextTypes = contextTypes;
	Trigger.childContextTypes = contextTypes;
	Trigger.defaultProps = {
	  prefixCls: 'rc-trigger-popup',
	  getPopupClassNameFromAlign: returnEmptyString,
	  getDocument: returnDocument,
	  onPopupVisibleChange: noop,
	  afterPopupVisibleChange: noop,
	  onPopupAlign: noop,
	  popupClassName: '',
	  mouseEnterDelay: 0,
	  mouseLeaveDelay: 0.1,
	  focusDelay: 0,
	  blurDelay: 0.15,
	  popupStyle: {},
	  destroyPopupOnHide: false,
	  popupAlign: {},
	  defaultPopupVisible: false,
	  mask: false,
	  maskClosable: true,
	  action: [],
	  showAction: [],
	  hideAction: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onMouseEnter = function (e) {
	    var mouseEnterDelay = _this4.props.mouseEnterDelay;
	
	    _this4.fireEvents('onMouseEnter', e);
	    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	  };
	
	  this.onMouseMove = function (e) {
	    _this4.fireEvents('onMouseMove', e);
	    _this4.setPoint(e);
	  };
	
	  this.onMouseLeave = function (e) {
	    _this4.fireEvents('onMouseLeave', e);
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onPopupMouseEnter = function () {
	    _this4.clearDelayTimer();
	  };
	
	  this.onPopupMouseLeave = function (e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && (0, _contains2['default'])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onFocus = function (e) {
	    _this4.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    _this4.clearDelayTimer();
	    if (_this4.isFocusToShow()) {
	      _this4.focusTime = Date.now();
	      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
	    }
	  };
	
	  this.onMouseDown = function (e) {
	    _this4.fireEvents('onMouseDown', e);
	    _this4.preClickTime = Date.now();
	  };
	
	  this.onTouchStart = function (e) {
	    _this4.fireEvents('onTouchStart', e);
	    _this4.preTouchTime = Date.now();
	  };
	
	  this.onBlur = function (e) {
	    _this4.fireEvents('onBlur', e);
	    _this4.clearDelayTimer();
	    if (_this4.isBlurToHide()) {
	      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
	    }
	  };
	
	  this.onContextMenu = function (e) {
	    e.preventDefault();
	    _this4.fireEvents('onContextMenu', e);
	    _this4.setPopupVisible(true, e);
	  };
	
	  this.onContextMenuClose = function () {
	    if (_this4.isContextMenuToShow()) {
	      _this4.close();
	    }
	  };
	
	  this.onClick = function (event) {
	    _this4.fireEvents('onClick', event);
	    // focus will trigger click
	    if (_this4.focusTime) {
	      var preTime = void 0;
	      if (_this4.preClickTime && _this4.preTouchTime) {
	        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
	      } else if (_this4.preClickTime) {
	        preTime = _this4.preClickTime;
	      } else if (_this4.preTouchTime) {
	        preTime = _this4.preTouchTime;
	      }
	      if (Math.abs(preTime - _this4.focusTime) < 20) {
	        return;
	      }
	      _this4.focusTime = 0;
	    }
	    _this4.preClickTime = 0;
	    _this4.preTouchTime = 0;
	
	    // Only prevent default when all the action is click.
	    // https://github.com/ant-design/ant-design/issues/17043
	    // https://github.com/ant-design/ant-design/issues/17291
	    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var nextVisible = !_this4.state.popupVisible;
	    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
	      _this4.setPopupVisible(!_this4.state.popupVisible, event);
	    }
	  };
	
	  this.onPopupMouseDown = function () {
	    var _context$rcTrigger = _this4.context.rcTrigger,
	        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
	
	    _this4.hasPopupMouseDown = true;
	
	    clearTimeout(_this4.mouseDownTimeout);
	    _this4.mouseDownTimeout = setTimeout(function () {
	      _this4.hasPopupMouseDown = false;
	    }, 0);
	
	    if (rcTrigger.onPopupMouseDown) {
	      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
	    }
	  };
	
	  this.onDocumentClick = function (event) {
	    if (_this4.props.mask && !_this4.props.maskClosable) {
	      return;
	    }
	
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(_this4);
	    if (!(0, _contains2['default'])(root, target) && !_this4.hasPopupMouseDown) {
	      _this4.close();
	    }
	  };
	
	  this.getRootDomNode = function () {
	    return (0, _reactDom.findDOMNode)(_this4);
	  };
	
	  this.getPopupClassNameFromAlign = function (align) {
	    var className = [];
	    var _props9 = _this4.props,
	        popupPlacement = _props9.popupPlacement,
	        builtinPlacements = _props9.builtinPlacements,
	        prefixCls = _props9.prefixCls,
	        alignPoint = _props9.alignPoint,
	        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	    }
	    if (getPopupClassNameFromAlign) {
	      className.push(getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  };
	
	  this.getComponent = function () {
	    var _props10 = _this4.props,
	        prefixCls = _props10.prefixCls,
	        destroyPopupOnHide = _props10.destroyPopupOnHide,
	        popupClassName = _props10.popupClassName,
	        action = _props10.action,
	        onPopupAlign = _props10.onPopupAlign,
	        popupAnimation = _props10.popupAnimation,
	        popupTransitionName = _props10.popupTransitionName,
	        popupStyle = _props10.popupStyle,
	        mask = _props10.mask,
	        maskAnimation = _props10.maskAnimation,
	        maskTransitionName = _props10.maskTransitionName,
	        zIndex = _props10.zIndex,
	        popup = _props10.popup,
	        stretch = _props10.stretch,
	        alignPoint = _props10.alignPoint;
	    var _state = _this4.state,
	        popupVisible = _state.popupVisible,
	        point = _state.point;
	
	
	    var align = _this4.getPopupAlign();
	
	    var mouseProps = {};
	    if (_this4.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
	    }
	    if (_this4.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
	    }
	
	    mouseProps.onMouseDown = _this4.onPopupMouseDown;
	    mouseProps.onTouchStart = _this4.onPopupMouseDown;
	
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: prefixCls,
	        destroyPopupOnHide: destroyPopupOnHide,
	        visible: popupVisible,
	        point: alignPoint && point,
	        className: popupClassName,
	        action: action,
	        align: align,
	        onAlign: onPopupAlign,
	        animation: popupAnimation,
	        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
	      }, mouseProps, {
	        stretch: stretch,
	        getRootDomNode: _this4.getRootDomNode,
	        style: popupStyle,
	        mask: mask,
	        zIndex: zIndex,
	        transitionName: popupTransitionName,
	        maskAnimation: maskAnimation,
	        maskTransitionName: maskTransitionName,
	        ref: _this4.savePopup
	      }),
	      typeof popup === 'function' ? popup() : popup
	    );
	  };
	
	  this.getContainer = function () {
	    var props = _this4.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this4)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  };
	
	  this.setPoint = function (point) {
	    var alignPoint = _this4.props.alignPoint;
	
	    if (!alignPoint || !point) return;
	
	    _this4.setState({
	      point: {
	        pageX: point.pageX,
	        pageY: point.pageY
	      }
	    });
	  };
	
	  this.handlePortalUpdate = function () {
	    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
	      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
	    }
	  };
	
	  this.savePopup = function (node) {
	    _this4._component = node;
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Trigger);
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(45));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ContainerRender = /*#__PURE__*/function (_React$Component) {
	  _inherits(ContainerRender, _React$Component);
	
	  var _super = _createSuper(ContainerRender);
	
	  function ContainerRender() {
	    var _this;
	
	    _classCallCheck(this, ContainerRender);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _this.removeContainer = function () {
	      if (_this.container) {
	        _reactDom.default.unmountComponentAtNode(_this.container);
	
	        _this.container.parentNode.removeChild(_this.container);
	
	        _this.container = null;
	      }
	    };
	
	    _this.renderComponent = function (props, ready) {
	      var _this$props = _this.props,
	          visible = _this$props.visible,
	          getComponent = _this$props.getComponent,
	          forceRender = _this$props.forceRender,
	          getContainer = _this$props.getContainer,
	          parent = _this$props.parent;
	
	      if (visible || parent._component || forceRender) {
	        if (!_this.container) {
	          _this.container = getContainer();
	        }
	
	        _reactDom.default.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
	          if (ready) {
	            ready.call(this);
	          }
	        });
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(ContainerRender, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.props.autoDestroy) {
	        this.removeContainer();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children({
	        renderComponent: this.renderComponent,
	        removeContainer: this.removeContainer
	      });
	    }
	  }]);
	
	  return ContainerRender;
	}(_react.default.Component);
	
	exports.default = ContainerRender;
	ContainerRender.propTypes = {
	  autoMount: _propTypes.default.bool,
	  autoDestroy: _propTypes.default.bool,
	  visible: _propTypes.default.bool,
	  forceRender: _propTypes.default.bool,
	  parent: _propTypes.default.any,
	  getComponent: _propTypes.default.func.isRequired,
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.func.isRequired
	};
	ContainerRender.defaultProps = {
	  autoMount: true,
	  autoDestroy: true,
	  forceRender: false
	};

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(45));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Portal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  var _super = _createSuper(Portal);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Portal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.createContainer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var didUpdate = this.props.didUpdate;
	
	      if (didUpdate) {
	        didUpdate(prevProps);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeContainer();
	    }
	  }, {
	    key: "createContainer",
	    value: function createContainer() {
	      this._container = this.props.getContainer();
	      this.forceUpdate();
	    }
	  }, {
	    key: "removeContainer",
	    value: function removeContainer() {
	      if (this._container) {
	        this._container.parentNode.removeChild(this._container);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this._container) {
	        return _reactDom.default.createPortal(this.props.children, this._container);
	      }
	
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.default.Component);
	
	exports.default = Portal;
	Portal.propTypes = {
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.node.isRequired,
	  didUpdate: _propTypes.default.func
	};

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  } // only handle componentWillReceiveProps
	
	
	  if (typeof prototype.componentWillReceiveProps !== 'function') {
	    return Component;
	  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
	  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler
	
	
	  if (!_react.default.Profiler) {
	    return Component;
	  } // Here polyfill get started
	
	
	  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
	  delete prototype.componentWillReceiveProps;
	  return Component;
	};
	
	var _default = unsafeLifecyclesPolyfill;
	exports.default = _default;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(340);
	
	var _reactHeight = __webpack_require__(859);
	
	var _reactHeight2 = _interopRequireDefault(_reactHeight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRECISION = 0.5;
	
	var stringHeight = function stringHeight(height) {
	  return Math.max(0, parseFloat(height)).toFixed(1);
	};
	
	var Collapse = function (_React$Component) {
	  _inherits(Collapse, _React$Component);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _this.onHeightReady = function (height) {
	      var _this$props = _this.props,
	          isOpened = _this$props.isOpened,
	          onHeightReady = _this$props.onHeightReady;
	
	
	      if (_this.renderStatic && isOpened) {
	        _this.height = stringHeight(height);
	      }
	
	      _this.setState({ height: isOpened || !_this.renderStatic ? height : 0 });
	
	      var reportHeight = isOpened ? height : 0;
	
	      if (_this.state.height !== reportHeight) {
	        onHeightReady(reportHeight);
	      }
	    };
	
	    _this.state = { height: -1, isOpenedChanged: false };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.height = stringHeight(0);
	      this.renderStatic = true;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var isOpened = _ref.isOpened;
	
	      this.setState({ isOpenedChanged: isOpened !== this.props.isOpened });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_ref2) {
	      var isOpened = _ref2.isOpened;
	
	      if (isOpened !== this.props.isOpened) {
	        var report = this.props.isOpened ? this.state.height : 0;
	
	        this.props.onHeightReady(report);
	      }
	    }
	  }, {
	    key: 'getMotionHeight',
	    value: function getMotionHeight(height) {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          springConfig = _props.springConfig,
	          fixedHeight = _props.fixedHeight;
	      var isOpenedChanged = this.state.isOpenedChanged;
	
	
	      var newHeight = isOpened ? Math.max(0, parseFloat(height)).toFixed(1) : stringHeight(0);
	
	      // No need to animate if content is closed and it was closed previously
	      // Also no need to animate if height did not change
	      var skipAnimation = !isOpenedChanged && !isOpened || this.height === newHeight && fixedHeight === -1;
	
	      var springHeight = (0, _reactMotion.spring)(isOpened ? Math.max(0, height) : 0, _extends({
	        precision: PRECISION
	      }, springConfig));
	      var instantHeight = isOpened ? Math.max(0, height) : 0;
	
	      return skipAnimation ? instantHeight : springHeight;
	    }
	  }, {
	    key: 'renderFixed',
	    value: function renderFixed() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          _springConfig = _props2.springConfig,
	          _onHeightReady = _props2.onHeightReady,
	          _onRest = _props2.onRest,
	          isOpened = _props2.isOpened,
	          style = _props2.style,
	          children = _props2.children,
	          fixedHeight = _props2.fixedHeight,
	          keepCollapsedContent = _props2.keepCollapsedContent,
	          props = _objectWithoutProperties(_props2, ['springConfig', 'onHeightReady', 'onRest', 'isOpened', 'style', 'children', 'fixedHeight', 'keepCollapsedContent']);
	
	      if (this.renderStatic) {
	        this.renderStatic = false;
	        var newStyle = { overflow: 'hidden', height: isOpened ? fixedHeight : 0 };
	
	        if (!keepCollapsedContent && !isOpened) {
	          return null;
	        }
	        this.height = stringHeight(fixedHeight);
	        return _react2.default.createElement(
	          'div',
	          _extends({ style: _extends({}, newStyle, style) }, props),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          defaultStyle: { height: isOpened ? 0 : fixedHeight },
	          style: { height: this.getMotionHeight(fixedHeight) } },
	        function (_ref3) {
	          var height = _ref3.height;
	
	          _this2.height = stringHeight(height);
	
	          // TODO: this should be done using onEnd from ReactMotion, which is not yet implemented
	          // See https://github.com/chenglou/react-motion/issues/235
	          if (!keepCollapsedContent && !isOpened && _this2.height === stringHeight(0)) {
	            return null;
	          }
	
	          var newStyle = { overflow: 'hidden', height: height };
	
	          return _react2.default.createElement(
	            'div',
	            _extends({ style: _extends({}, newStyle, style) }, props),
	            children
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          _springConfig = _props3.springConfig,
	          _onHeightReady = _props3.onHeightReady,
	          isOpened = _props3.isOpened,
	          style = _props3.style,
	          children = _props3.children,
	          fixedHeight = _props3.fixedHeight,
	          keepCollapsedContent = _props3.keepCollapsedContent,
	          onRest = _props3.onRest,
	          props = _objectWithoutProperties(_props3, ['springConfig', 'onHeightReady', 'isOpened', 'style', 'children', 'fixedHeight', 'keepCollapsedContent', 'onRest']);
	
	      if (fixedHeight > -1) {
	        return this.renderFixed();
	      }
	
	      var renderStatic = this.renderStatic;
	      var height = this.state.height;
	
	      var currentStringHeight = parseFloat(height).toFixed(1);
	
	      if (height > -1 && renderStatic) {
	        this.renderStatic = false;
	      }
	
	      // Cache Content so it is not re-rendered on each animation step
	      var content = _react2.default.createElement(
	        _reactHeight2.default,
	        { onHeightReady: this.onHeightReady },
	        children
	      );
	
	      if (renderStatic) {
	        var newStyle = isOpened ? { height: 'auto' } : { overflow: 'hidden', height: 0 };
	
	        if (!isOpened && height > -1) {
	          if (!keepCollapsedContent) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            'div',
	            _extends({ style: _extends({ height: 0, overflow: 'hidden' }, style) }, props),
	            content
	          );
	        }
	
	        // <Motion> to prevent loosing input after causing this component to rerender
	        return _react2.default.createElement(
	          _reactMotion.Motion,
	          {
	            defaultStyle: { height: Math.max(0, height) },
	            style: { height: Math.max(0, height) },
	            onRest: onRest },
	          function () {
	            return _react2.default.createElement(
	              'div',
	              _extends({ style: _extends({}, newStyle, style) }, props),
	              content
	            );
	          }
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          defaultStyle: { height: Math.max(0, height) },
	          onRest: onRest,
	          style: { height: this.getMotionHeight(height) } },
	        function (st) {
	          _this3.height = stringHeight(st.height);
	
	          // TODO: this should be done using onEnd from ReactMotion, which is not yet implemented
	          // See https://github.com/chenglou/react-motion/issues/235
	          if (!isOpened && _this3.height === '0.0') {
	            if (!keepCollapsedContent) {
	              return null;
	            }
	            return _react2.default.createElement(
	              'div',
	              _extends({ style: _extends({ height: 0, overflow: 'hidden' }, style) }, props),
	              content
	            );
	          }
	
	          var newStyle = isOpened && _this3.height === currentStringHeight ? { height: 'auto' } : {
	            height: st.height, overflow: 'hidden'
	          };
	
	          return _react2.default.createElement(
	            'div',
	            _extends({ style: _extends({}, newStyle, style) }, props),
	            content
	          );
	        }
	      );
	    }
	  }]);
	
	  return Collapse;
	}(_react2.default.Component);
	
	Collapse.defaultProps = {
	  fixedHeight: -1,
	  style: {},
	  keepCollapsedContent: false,
	  onHeightReady: function onHeightReady() {} // eslint-disable-line no-empty-function
	};
	exports.default = Collapse;
	//# sourceMappingURL=Collapse.js.map

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(38);
	
	var _AlphaPointer = __webpack_require__(1916);
	
	var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
	  var rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      direction = _ref.direction,
	      style = _ref.style,
	      renderers = _ref.renderers,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      alpha: {
	        radius: '2px',
	        style: style
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'alpha-picker ' + className },
	    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
	      rgb: rgb,
	      hsl: hsl,
	      pointer: pointer,
	      renderers: renderers,
	      onChange: onChange,
	      direction: direction
	    }))
	  );
	};
	
	AlphaPicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _AlphaPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = AlphaPointer;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Block = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	var _BlockSwatches = __webpack_require__(1918);
	
	var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = exports.Block = function Block(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var transparent = hex === 'transparent';
	  var handleChange = function handleChange(hexCode, e) {
	    color.isValidHex(hexCode) && onChange({
	      hex: hexCode,
	      source: 'hex'
	    }, e);
	  };
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        boxShadow: '0 1px rgba(0,0,0,.1)',
	        borderRadius: '6px',
	        position: 'relative'
	      },
	      head: {
	        height: '110px',
	        background: hex,
	        borderRadius: '6px 6px 0 0',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        position: 'relative'
	      },
	      body: {
	        padding: '10px'
	      },
	      label: {
	        fontSize: '18px',
	        color: color.getContrastingColor(hex),
	        position: 'relative'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 10px 10px 10px',
	        borderColor: 'transparent transparent ' + hex + ' transparent',
	        position: 'absolute',
	        top: '-10px',
	        left: '50%',
	        marginLeft: '-10px'
	      },
	      input: {
	        width: '100%',
	        fontSize: '12px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '22px',
	        boxShadow: 'inset 0 0 0 1px #ddd',
	        borderRadius: '4px',
	        padding: '0 7px',
	        boxSizing: 'border-box'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      }
	    }
	  }, passedStyles), { 'hide-triangle': triangle === 'hide' });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'block-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.label },
	        hex
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex,
	        onChange: handleChange
	      })
	    )
	  );
	};
	
	Block.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['top', 'hide']),
	  styles: _propTypes2.default.object
	};
	
	Block.defaultProps = {
	  width: 170,
	  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
	  triangle: 'top',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Block);

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlockSwatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(87);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
	  var colors = _ref.colors,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginRight: '-10px'
	      },
	      swatch: {
	        width: '22px',
	        height: '22px',
	        float: 'left',
	        marginRight: '10px',
	        marginBottom: '10px',
	        borderRadius: '4px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_common.Swatch, {
	        key: c,
	        color: c,
	        style: styles.swatch,
	        onClick: onClick,
	        onHover: onSwatchHover,
	        focusStyle: {
	          boxShadow: '0 0 4px ' + c
	        }
	      });
	    }),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = BlockSwatches;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(38);
	
	var _ChromeFields = __webpack_require__(1920);
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__(1921);
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__(1922);
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chrome = exports.Chrome = function Chrome(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      renderers = _ref.renderers,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      defaultView = _ref.defaultView;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        background: '#fff',
	        borderRadius: '2px',
	        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	        boxSizing: 'initial',
	        fontFamily: 'Menlo'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '55%',
	        position: 'relative',
	        borderRadius: '2px 2px 0 0',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '2px 2px 0 0'
	      },
	      body: {
	        padding: '16px 16px 12px'
	      },
	      controls: {
	        display: 'flex'
	      },
	      color: {
	        width: '32px'
	      },
	      swatch: {
	        marginTop: '6px',
	        width: '16px',
	        height: '16px',
	        borderRadius: '8px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      active: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '8px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
	        zIndex: '2'
	      },
	      toggles: {
	        flex: '1'
	      },
	      hue: {
	        height: '10px',
	        position: 'relative',
	        marginBottom: '8px'
	      },
	      Hue: {
	        radius: '2px'
	      },
	      alpha: {
	        height: '10px',
	        position: 'relative'
	      },
	      Alpha: {
	        radius: '2px'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        width: '22px'
	      },
	      alpha: {
	        display: 'none'
	      },
	      hue: {
	        marginBottom: '0px'
	      },
	      swatch: {
	        width: '10px',
	        height: '10px',
	        marginTop: '0px'
	      }
	    }
	  }, passedStyles), { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'chrome-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _ChromePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.color },
	          _react2.default.createElement(
	            'div',
	            { style: styles.swatch },
	            _react2.default.createElement('div', { style: styles.active }),
	            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggles },
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              style: styles.Hue,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              onChange: onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.Alpha, {
	              style: styles.Alpha,
	              rgb: rgb,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              renderers: renderers,
	              onChange: onChange
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_ChromeFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        view: defaultView,
	        onChange: onChange,
	        disableAlpha: disableAlpha
	      })
	    )
	  );
	};
	
	Chrome.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  disableAlpha: _propTypes2.default.bool,
	  styles: _propTypes2.default.object,
	  defaultView: _propTypes2.default.oneOf(["hex", "rgb", "hsl"])
	};
	
	Chrome.defaultProps = {
	  width: 225,
	  disableAlpha: false,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	var _isUndefined = __webpack_require__(797);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _common = __webpack_require__(38);
	
	var _UnfoldMoreHorizontalIcon = __webpack_require__(1029);
	
	var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault(_UnfoldMoreHorizontalIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields(props) {
	    _classCallCheck(this, ChromeFields);
	
	    var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
	
	    _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    };
	
	    _this.handleChange = function (data, e) {
	      if (data.hex) {
	        color.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        }, e);
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        }, e);
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        }, e);
	      } else if (data.h || data.s || data.l) {
	        // Remove any occurances of '%'.
	        if (typeof data.s === 'string' && data.s.includes('%')) {
	          data.s = data.s.replace('%', '');
	        }
	        if (typeof data.l === 'string' && data.l.includes('%')) {
	          data.l = data.l.replace('%', '');
	        }
	
	        // We store HSL as a unit interval so we need to override the 1 input to 0.01
	        if (data.s == 1) {
	          data.s = 0.01;
	        } else if (data.l == 1) {
	          data.l = 0.01;
	        }
	
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: Number(!(0, _isUndefined2.default)(data.s) ? data.s : _this.props.hsl.s),
	          l: Number(!(0, _isUndefined2.default)(data.l) ? data.l : _this.props.hsl.l),
	          source: 'hsl'
	        }, e);
	      }
	    };
	
	    _this.showHighlight = function (e) {
	      e.currentTarget.style.background = '#eee';
	    };
	
	    _this.hideHighlight = function (e) {
	      e.currentTarget.style.background = 'transparent';
	    };
	
	    if (props.hsl.a !== 1 && props.view === "hex") {
	      _this.state = {
	        view: "rgb"
	      };
	    } else {
	      _this.state = {
	        view: props.view
	      };
	    }
	    return _this;
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          },
	          svg: {
	            fill: '#333',
	            width: '24px',
	            height: '24px',
	            border: '1px transparent solid',
	            borderRadius: '5px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields = void 0;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'hex', value: this.props.hex,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'r',
	              value: this.props.rgb.r,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'g',
	              value: this.props.rgb.g,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'b',
	              value: this.props.rgb.b,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.rgb.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'h',
	              value: Math.round(this.props.hsl.h),
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 's',
	              value: Math.round(this.props.hsl.s * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'l',
	              value: Math.round(this.props.hsl.l * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.hsl.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
	                return _this2.icon = icon;
	              } },
	            _react2.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
	              style: styles.svg,
	              onMouseOver: this.showHighlight,
	              onMouseEnter: this.showHighlight,
	              onMouseOut: this.hideHighlight
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, state) {
	      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
	        return { view: 'rgb' };
	      }
	      return null;
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	ChromeFields.defaultProps = {
	  view: "hex"
	};
	
	exports.default = ChromeFields;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointer = exports.ChromePointer = function ChromePointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        transform: 'translate(-6px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointer;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointerCircle;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Circle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(87);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _materialColors = __webpack_require__(808);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(38);
	
	var _CircleSwatch = __webpack_require__(1924);
	
	var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = exports.Circle = function Circle(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      circleSize = _ref.circleSize,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      circleSpacing = _ref.circleSpacing,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        display: 'flex',
	        flexWrap: 'wrap',
	        marginRight: -circleSpacing,
	        marginBottom: -circleSpacing
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(hexCode, e) {
	    return onChange({ hex: hexCode, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'circle-picker ' + className },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_CircleSwatch2.default, {
	        key: c,
	        color: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover,
	        active: hex === c.toLowerCase(),
	        circleSize: circleSize,
	        circleSpacing: circleSpacing
	      });
	    })
	  );
	};
	
	Circle.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  circleSize: _propTypes2.default.number,
	  circleSpacing: _propTypes2.default.number,
	  styles: _propTypes2.default.object
	};
	
	Circle.defaultProps = {
	  width: 252,
	  circleSize: 28,
	  circleSpacing: 14,
	  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Circle);

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      hover = _ref.hover,
	      active = _ref.active,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: circleSize,
	        height: circleSize,
	        marginRight: circleSpacing,
	        marginBottom: circleSpacing,
	        transform: 'scale(1)',
	        transition: '100ms transform ease'
	      },
	      Swatch: {
	        borderRadius: '50%',
	        background: 'transparent',
	        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
	        transition: '100ms box-shadow ease'
	      }
	    },
	    'hover': {
	      swatch: {
	        transform: 'scale(1.2)'
	      }
	    },
	    'active': {
	      Swatch: {
	        boxShadow: 'inset 0 0 0 3px ' + color
	      }
	    }
	  }, { hover: hover, active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      style: styles.Swatch,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
	    })
	  );
	};
	
	CircleSwatch.defaultProps = {
	  circleSize: 28,
	  circleSpacing: 14
	};
	
	exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _alpha = __webpack_require__(1960);
	
	var alpha = _interopRequireWildcard(_alpha);
	
	var _Checkboard = __webpack_require__(468);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_ref) {
	  _inherits(Alpha, _ref);
	
	  function Alpha() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Alpha);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var change = alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
	      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var rgb = this.props.rgb;
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden',
	            borderRadius: this.props.radius
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          gradient: {
	            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
	          },
	          pointer: {
	            left: 0,
	            top: rgb.a * 100 + '%'
	          }
	        },
	        'overwrite': _extends({}, this.props.style)
	      }, {
	        vertical: this.props.direction === 'vertical',
	        overwrite: true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Alpha;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_ARROW_OFFSET = 1;
	
	var UP_KEY_CODE = 38;
	var DOWN_KEY_CODE = 40;
	var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
	var isValidKeyCode = function isValidKeyCode(keyCode) {
	  return VALID_KEY_CODES.indexOf(keyCode) > -1;
	};
	var getNumberValue = function getNumberValue(value) {
	  return Number(String(value).replace(/%/g, ''));
	};
	
	var idCounter = 1;
	
	var EditableInput = exports.EditableInput = function (_ref) {
	  _inherits(EditableInput, _ref);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      _this.setUpdatedValue(e.target.value, e);
	    };
	
	    _this.handleKeyDown = function (e) {
	      // In case `e.target.value` is a percentage remove the `%` character
	      // and update accordingly with a percentage
	      // https://github.com/casesandberg/react-color/issues/383
	      var value = getNumberValue(e.target.value);
	      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
	        var offset = _this.getArrowOffset();
	        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
	
	        _this.setUpdatedValue(updatedValue, e);
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleDrag);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	
	    _this.inputId = 'rc-editable-input-' + idCounter++;
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
	        if (this.input === document.activeElement) {
	          this.setState({ blurValue: String(this.props.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'getValueObjectWithLabel',
	    value: function getValueObjectWithLabel(value) {
	      return _defineProperty({}, this.props.label, value);
	    }
	  }, {
	    key: 'getArrowOffset',
	    value: function getArrowOffset() {
	      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
	    }
	  }, {
	    key: 'setUpdatedValue',
	    value: function setUpdatedValue(value, e) {
	      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
	      this.props.onChange && this.props.onChange(onChangeValue, e);
	
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          }
	        },
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('input', {
	          id: this.inputId,
	          style: styles.input,
	          ref: function ref(input) {
	            return _this2.input = input;
	          },
	          value: this.state.value,
	          onKeyDown: this.handleKeyDown,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          placeholder: this.props.placeholder,
	          spellCheck: 'false'
	        }),
	        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
	          'label',
	          {
	            htmlFor: this.inputId,
	            style: styles.label,
	            onMouseDown: this.handleMouseDown
	          },
	          this.props.label
	        ) : null
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react.PureComponent || _react.Component);
	
	exports.default = EditableInput;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _hue = __webpack_require__(1962);
	
	var hue = _interopRequireWildcard(_hue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_ref) {
	  _inherits(Hue, _ref);
	
	  function Hue() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hue);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var change = hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
	      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$direction = this.props.direction,
	          direction = _props$direction === undefined ? 'horizontal' : _props$direction;
	
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            padding: '0 2px',
	            position: 'relative',
	            height: '100%',
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, { vertical: direction === 'vertical' });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'hue-' + direction,
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'style',
	            null,
	            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Hue;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Raised = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Raised = exports.Raised = function Raised(_ref) {
	  var zDepth = _ref.zDepth,
	      radius = _ref.radius,
	      background = _ref.background,
	      children = _ref.children,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      wrap: {
	        position: 'relative',
	        display: 'inline-block'
	      },
	      content: {
	        position: 'relative'
	      },
	      bg: {
	        absolute: '0px 0px 0px 0px',
	        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
	        borderRadius: radius,
	        background: background
	      }
	    },
	    'zDepth-0': {
	      bg: {
	        boxShadow: 'none'
	      }
	    },
	
	    'zDepth-1': {
	      bg: {
	        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	      }
	    },
	    'zDepth-2': {
	      bg: {
	        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	      }
	    },
	    'zDepth-3': {
	      bg: {
	        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	      }
	    },
	    'zDepth-4': {
	      bg: {
	        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	      }
	    },
	    'zDepth-5': {
	      bg: {
	        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	      }
	    },
	    'square': {
	      bg: {
	        borderRadius: '0'
	      }
	    },
	    'circle': {
	      bg: {
	        borderRadius: '50%'
	      }
	    }
	  }, passedStyles), { 'zDepth-1': zDepth === 1 });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap },
	    _react2.default.createElement('div', { style: styles.bg }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.content },
	      children
	    )
	  );
	};
	
	Raised.propTypes = {
	  background: _propTypes2.default.string,
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
	  radius: _propTypes2.default.number,
	  styles: _propTypes2.default.object
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: 1,
	  radius: 2,
	  styles: {}
	};
	
	exports.default = Raised;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__(1877);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _saturation = __webpack_require__(1964);
	
	var saturation = _interopRequireWildcard(_saturation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_ref) {
	  _inherits(Saturation, _ref);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
	
	    _this.handleChange = function (e) {
	      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation.calculateChange(e, _this.props.hsl, _this.container), e);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      var renderWindow = _this.getContainerRenderWindow();
	      renderWindow.addEventListener('mousemove', _this.handleChange);
	      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
	      fn(data, e);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.throttle.cancel();
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'getContainerRenderWindow',
	    value: function getContainerRenderWindow() {
	      var container = this.container;
	
	      var renderWindow = window;
	      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
	        renderWindow = renderWindow.parent;
	      }
	      return renderWindow;
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      var renderWindow = this.getContainerRenderWindow();
	      renderWindow.removeEventListener('mousemove', this.handleChange);
	      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _ref2 = this.props.style || {},
	          color = _ref2.color,
	          white = _ref2.white,
	          black = _ref2.black,
	          pointer = _ref2.pointer,
	          circle = _ref2.circle;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        },
	        'custom': {
	          color: color,
	          white: white,
	          black: black,
	          pointer: pointer,
	          circle: circle
	        }
	      }, { 'custom': !!this.props.style });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles.color,
	          ref: function ref(container) {
	            return _this2.container = container;
	          },
	          onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange
	        },
	        _react2.default.createElement(
	          'style',
	          null,
	          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.white, className: 'saturation-white' },
	          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Saturation;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _interaction = __webpack_require__(1963);
	
	var _Checkboard = __webpack_require__(468);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENTER = 13;
	
	var Swatch = exports.Swatch = function Swatch(_ref) {
	  var color = _ref.color,
	      style = _ref.style,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onHover = _ref.onHover,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? color : _ref$title,
	      children = _ref.children,
	      focus = _ref.focus,
	      _ref$focusStyle = _ref.focusStyle,
	      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
	
	  var transparent = color === 'transparent';
	  var styles = (0, _reactcss2.default)({
	    default: {
	      swatch: _extends({
	        background: color,
	        height: '100%',
	        width: '100%',
	        cursor: 'pointer',
	        position: 'relative',
	        outline: 'none'
	      }, style, focus ? focusStyle : {})
	    }
	  });
	
	  var handleClick = function handleClick(e) {
	    return onClick(color, e);
	  };
	  var handleKeyDown = function handleKeyDown(e) {
	    return e.keyCode === ENTER && onClick(color, e);
	  };
	  var handleHover = function handleHover(e) {
	    return onHover(color, e);
	  };
	
	  var optionalEvents = {};
	  if (onHover) {
	    optionalEvents.onMouseOver = handleHover;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({
	      style: styles.swatch,
	      onClick: handleClick,
	      title: title,
	      tabIndex: 0,
	      onKeyDown: handleKeyDown
	    }, optionalEvents),
	    children,
	    transparent && _react2.default.createElement(_Checkboard2.default, {
	      borderRadius: styles.swatch.borderRadius,
	      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
	    })
	  );
	};
	
	exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(87);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	var _CompactColor = __webpack_require__(1932);
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__(1933);
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compact = exports.Compact = function Compact(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      Compact: {
	        background: '#f6f6f6',
	        radius: '4px'
	      },
	      compact: {
	        paddingTop: '5px',
	        paddingLeft: '5px',
	        boxSizing: 'initial',
	        width: '240px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else {
	      onChange(data, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    { style: styles.Compact, styles: passedStyles },
	    _react2.default.createElement(
	      'div',
	      { style: styles.compact, className: 'compact-picker ' + className },
	      _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(colors, function (c) {
	          return _react2.default.createElement(_CompactColor2.default, {
	            key: c,
	            color: c,
	            active: c.toLowerCase() === hex,
	            onClick: handleChange,
	            onSwatchHover: onSwatchHover
	          });
	        }),
	        _react2.default.createElement('div', { style: styles.clear })
	      ),
	      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
	    )
	  );
	};
	
	Compact.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  styles: _propTypes2.default.object
	};
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(94);
	
	var colorUtils = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactColor = exports.CompactColor = function CompactColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        background: color,
	        width: '15px',
	        height: '15px',
	        float: 'left',
	        marginRight: '5px',
	        marginBottom: '5px',
	        position: 'relative',
	        cursor: 'pointer'
	      },
	      dot: {
	        absolute: '5px 5px 5px 5px',
	        background: colorUtils.getContrastingColor(color),
	        borderRadius: '50%',
	        opacity: '0'
	      }
	    },
	    'active': {
	      dot: {
	        opacity: '1'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      dot: {
	        background: '#000'
	      }
	    },
	    'transparent': {
	      dot: {
	        background: '#000'
	      }
	    }
	  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      style: styles.color,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement('div', { style: styles.dot })
	  );
	};
	
	exports.default = CompactColor;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactFields = exports.CompactFields = function CompactFields(_ref) {
	  var hex = _ref.hex,
	      rgb = _ref.rgb,
	      onChange = _ref.onChange;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingBottom: '6px',
	        paddingRight: '5px',
	        position: 'relative'
	      },
	      active: {
	        position: 'absolute',
	        top: '6px',
	        left: '5px',
	        height: '9px',
	        width: '9px',
	        background: hex
	      },
	      HEXwrap: {
	        flex: '6',
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '80%',
	        padding: '0px',
	        paddingLeft: '20%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      HEXlabel: {
	        display: 'none'
	      },
	      RGBwrap: {
	        flex: '3',
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '70%',
	        padding: '0px',
	        paddingLeft: '30%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '3px',
	        left: '0px',
	        lineHeight: '16px',
	        textTransform: 'uppercase',
	        fontSize: '12px',
	        color: '#999'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else {
	      onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement('div', { style: styles.active }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: 'hex',
	      value: hex,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    })
	  );
	};
	
	exports.default = CompactFields;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Github = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(87);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(38);
	
	var _GithubSwatch = __webpack_require__(1935);
	
	var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Github = exports.Github = function Github(_ref) {
	  var width = _ref.width,
	      colors = _ref.colors,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '1px solid rgba(0,0,0,0.2)',
	        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
	        borderRadius: '4px',
	        position: 'relative',
	        padding: '5px',
	        display: 'flex',
	        flexWrap: 'wrap'
	      },
	      triangle: {
	        position: 'absolute',
	        border: '7px solid transparent',
	        borderBottomColor: '#fff'
	      },
	      triangleShadow: {
	        position: 'absolute',
	        border: '8px solid transparent',
	        borderBottomColor: 'rgba(0,0,0,0.15)'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-14px',
	        left: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        left: '9px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-14px',
	        right: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        right: '9px'
	      }
	    },
	    'bottom-left-triangle': {
	      triangle: {
	        top: '35px',
	        left: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        left: '9px',
	        transform: 'rotate(180deg)'
	      }
	    },
	    'bottom-right-triangle': {
	      triangle: {
	        top: '35px',
	        right: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        right: '9px',
	        transform: 'rotate(180deg)'
	      }
	    }
	  }, passedStyles), {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right',
	    'bottom-left-triangle': triangle === 'bottom-left',
	    'bottom-right-triangle': triangle === 'bottom-right'
	  });
	
	  var handleChange = function handleChange(hex, e) {
	    return onChange({ hex: hex, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'github-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_GithubSwatch2.default, {
	        color: c,
	        key: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	Github.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
	  styles: _propTypes2.default.object
	};
	
	Github.defaultProps = {
	  width: 200,
	  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
	  triangle: 'top-left',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Github);

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GithubSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
	  var hover = _ref.hover,
	      color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var hoverSwatch = {
	    position: 'relative',
	    zIndex: '2',
	    outline: '2px solid #fff',
	    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: '25px',
	        height: '25px',
	        fontSize: '0'
	      }
	    },
	    'hover': {
	      swatch: hoverSwatch
	    }
	  }, { hover: hover });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: hoverSwatch
	    })
	  );
	};
	
	exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Google = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(38);
	
	var _GooglePointerCircle = __webpack_require__(1939);
	
	var _GooglePointerCircle2 = _interopRequireDefault(_GooglePointerCircle);
	
	var _GooglePointer = __webpack_require__(1938);
	
	var _GooglePointer2 = _interopRequireDefault(_GooglePointer);
	
	var _GoogleFields = __webpack_require__(1937);
	
	var _GoogleFields2 = _interopRequireDefault(_GoogleFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Google = exports.Google = function Google(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      header = _ref.header,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        background: '#fff',
	        border: '1px solid #dfe1e5',
	        boxSizing: 'initial',
	        display: 'flex',
	        flexWrap: 'wrap',
	        borderRadius: '8px 8px 0px 0px'
	      },
	      head: {
	        height: '57px',
	        width: '100%',
	        paddingTop: '16px',
	        paddingBottom: '16px',
	        paddingLeft: '16px',
	        fontSize: '20px',
	        boxSizing: 'border-box',
	        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
	      },
	      saturation: {
	        width: '70%',
	        padding: '0px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      swatch: {
	        width: '30%',
	        height: '228px',
	        padding: '0px',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      body: {
	        margin: 'auto',
	        width: '95%'
	      },
	      controls: {
	        display: 'flex',
	        boxSizing: 'border-box',
	        height: '52px',
	        paddingTop: '22px'
	      },
	      color: {
	        width: '32px'
	      },
	      hue: {
	        height: '8px',
	        position: 'relative',
	        margin: '0px 16px 0px 16px',
	        width: '100%'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'google-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      header
	    ),
	    _react2.default.createElement('div', { style: styles.swatch }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _GooglePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            radius: '4px',
	            pointer: _GooglePointer2.default,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(_GoogleFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        hsv: hsv,
	        onChange: onChange
	      })
	    )
	  );
	};
	
	Google.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  styles: _propTypes2.default.object,
	  header: _propTypes2.default.string
	
	};
	
	Google.defaultProps = {
	  width: 652,
	  styles: {},
	  header: 'Color picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Google);

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GoogleFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleFields = exports.GoogleFields = function GoogleFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      hsv = _ref.hsv;
	
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.rgb) {
	      var values = data.rgb.split(',');
	      color.isvalidColorString(data.rgb, 'rgb') && onChange({
	        r: values[0],
	        g: values[1],
	        b: values[2],
	        a: 1,
	        source: 'rgb'
	      }, e);
	    } else if (data.hsv) {
	      var _values = data.hsv.split(',');
	      if (color.isvalidColorString(data.hsv, 'hsv')) {
	        _values[2] = _values[2].replace('%', '');
	        _values[1] = _values[1].replace('%', '');
	        _values[0] = _values[0].replace('°', '');
	        if (_values[1] == 1) {
	          _values[1] = 0.01;
	        } else if (_values[2] == 1) {
	          _values[2] = 0.01;
	        }
	        onChange({
	          h: Number(_values[0]),
	          s: Number(_values[1]),
	          v: Number(_values[2]),
	          source: 'hsv'
	        }, e);
	      }
	    } else if (data.hsl) {
	      var _values2 = data.hsl.split(',');
	      if (color.isvalidColorString(data.hsl, 'hsl')) {
	        _values2[2] = _values2[2].replace('%', '');
	        _values2[1] = _values2[1].replace('%', '');
	        _values2[0] = _values2[0].replace('°', '');
	        if (hsvValue[1] == 1) {
	          hsvValue[1] = 0.01;
	        } else if (hsvValue[2] == 1) {
	          hsvValue[2] = 0.01;
	        }
	        onChange({
	          h: Number(_values2[0]),
	          s: Number(_values2[1]),
	          v: Number(_values2[2]),
	          source: 'hsl'
	        }, e);
	      }
	    }
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      wrap: {
	        display: 'flex',
	        height: '100px',
	        marginTop: '4px'
	      },
	      fields: {
	        width: '100%'
	      },
	      column: {
	        paddingTop: '10px',
	        display: 'flex',
	        justifyContent: 'space-between'
	      },
	      double: {
	        padding: '0px 4.4px',
	        boxSizing: 'border-box'
	      },
	      input: {
	        width: '100%',
	        height: '38px',
	        boxSizing: 'border-box',
	        padding: '4px 10% 3px',
	        textAlign: 'center',
	        border: '1px solid #dadce0',
	        fontSize: '11px',
	        textTransform: 'lowercase',
	        borderRadius: '5px',
	        outline: 'none',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      input2: {
	        height: '38px',
	        width: '100%',
	        border: '1px solid #dadce0',
	        boxSizing: 'border-box',
	        fontSize: '11px',
	        textTransform: 'lowercase',
	        borderRadius: '5px',
	        outline: 'none',
	        paddingLeft: '10px',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      label: {
	        textAlign: 'center',
	        fontSize: '12px',
	        background: '#fff',
	        position: 'absolute',
	        textTransform: 'uppercase',
	        color: '#3c4043',
	        width: '35px',
	        top: '-6px',
	        left: '0',
	        right: '0',
	        marginLeft: 'auto',
	        marginRight: 'auto',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      label2: {
	        left: '10px',
	        textAlign: 'center',
	        fontSize: '12px',
	        background: '#fff',
	        position: 'absolute',
	        textTransform: 'uppercase',
	        color: '#3c4043',
	        width: '32px',
	        top: '-6px',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      single: {
	        flexGrow: '1',
	        margin: '0px 4.4px'
	      }
	    }
	  });
	
	  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
	  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
	  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.fields },
	      _react2.default.createElement(
	        'div',
	        { style: styles.double },
	        _react2.default.createElement(_common.EditableInput, {
	          style: { input: styles.input, label: styles.label },
	          label: 'hex',
	          value: hex,
	          onChange: handleChange
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.column },
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'rgb',
	            value: rgbValue,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'hsv',
	            value: hsvValue,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'hsl',
	            value: hslValue,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = GoogleFields;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GooglePointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePointer = exports.GooglePointer = function GooglePointer(props) {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '20px',
	        height: '20px',
	        borderRadius: '22px',
	        transform: 'translate(-10px, -7px)',
	        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
	        border: '2px white solid'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	GooglePointer.propTypes = {
	  hsl: _propTypes2.default.shape({
	    h: _propTypes2.default.number,
	    s: _propTypes2.default.number,
	    l: _propTypes2.default.number,
	    a: _propTypes2.default.number
	  })
	};
	
	GooglePointer.defaultProps = {
	  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
	};
	
	exports.default = GooglePointer;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GooglePointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePointerCircle = exports.GooglePointerCircle = function GooglePointerCircle(props) {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '20px',
	        height: '20px',
	        borderRadius: '22px',
	        border: '2px #fff solid',
	        transform: 'translate(-12px, -13px)',
	        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	GooglePointerCircle.propTypes = {
	  hsl: _propTypes2.default.shape({
	    h: _propTypes2.default.number,
	    s: _propTypes2.default.number,
	    l: _propTypes2.default.number,
	    a: _propTypes2.default.number
	  })
	};
	
	GooglePointerCircle.defaultProps = {
	  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
	};
	
	exports.default = GooglePointerCircle;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HuePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(38);
	
	var _HuePointer = __webpack_require__(1941);
	
	var _HuePointer2 = _interopRequireDefault(_HuePointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HuePicker = exports.HuePicker = function HuePicker(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      hsl = _ref.hsl,
	      direction = _ref.direction,
	      pointer = _ref.pointer,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	
	  // Overwrite to provide pure hue color
	  var handleChange = function handleChange(data) {
	    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'hue-picker ' + className },
	    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
	      hsl: hsl,
	      pointer: pointer,
	      onChange: handleChange,
	      direction: direction
	    }))
	  );
	};
	
	HuePicker.propTypes = {
	  styles: _propTypes2.default.object
	};
	HuePicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _HuePointer2.default,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Material = exports.Material = function Material(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      material: {
	        width: '98px',
	        height: '98px',
	        padding: '16px',
	        fontFamily: 'Roboto'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '2px solid ' + hex,
	        outline: 'none',
	        height: '30px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      Hex: {
	        style: {}
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '1px solid #eee',
	        outline: 'none',
	        height: '30px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      split: {
	        display: 'flex',
	        marginRight: '-10px',
	        paddingTop: '11px'
	      },
	      third: {
	        flex: '1',
	        paddingRight: '10px'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    { styles: passedStyles },
	    _react2.default.createElement(
	      'div',
	      { style: styles.material, className: 'material-picker ' + className },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	        label: 'hex',
	        value: hex,
	        onChange: handleChange
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.split, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'r', value: rgb.r,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'g',
	            value: rgb.g,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'b',
	            value: rgb.b,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(38);
	
	var _PhotoshopFields = __webpack_require__(1945);
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__(1947);
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__(1946);
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	var _PhotoshopButton = __webpack_require__(1944);
	
	var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);
	
	var _PhotoshopPreviews = __webpack_require__(1948);
	
	var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$styles = _props.styles,
	          passedStyles = _props$styles === undefined ? {} : _props$styles,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className;
	
	      var styles = (0, _reactcss2.default)((0, _merge2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          }
	        }
	      }, passedStyles));
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker, className: 'photoshop-picker ' + className },
	        _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, {
	              hsl: this.props.hsl,
	              hsv: this.props.hsv,
	              pointer: _PhotoshopPointerCircle2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              direction: 'vertical',
	              hsl: this.props.hsl,
	              pointer: _PhotoshopPointer2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(_PhotoshopPreviews2.default, {
	                  rgb: this.props.rgb,
	                  currentColor: this.state.currentColor
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
	                _react2.default.createElement(_PhotoshopFields2.default, {
	                  onChange: this.props.onChange,
	                  rgb: this.props.rgb,
	                  hsv: this.props.hsv,
	                  hex: this.props.hex
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.propTypes = {
	  header: _propTypes2.default.string,
	  styles: _propTypes2.default.object
	};
	
	Photoshop.defaultProps = {
	  header: 'Color Picker',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopButton = exports.PhotoshopButton = function PhotoshopButton(_ref) {
	  var onClick = _ref.onClick,
	      label = _ref.label,
	      children = _ref.children,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      button: {
	        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	        border: '1px solid #878787',
	        borderRadius: '2px',
	        height: '20px',
	        boxShadow: '0 1px 0 0 #EAEAEA',
	        fontSize: '14px',
	        color: '#000',
	        lineHeight: '20px',
	        textAlign: 'center',
	        marginBottom: '10px',
	        cursor: 'pointer'
	      }
	    },
	    'active': {
	      button: {
	        boxShadow: '0 0 0 1px #878787'
	      }
	    }
	  }, { active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.button, onClick: onClick },
	    label || children
	  );
	};
	
	exports.default = PhotoshopButton;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsv = _ref.hsv,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        paddingTop: '5px',
	        paddingBottom: '9px',
	        width: '80px',
	        position: 'relative'
	      },
	      divider: {
	        height: '5px'
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        marginLeft: '40%',
	        width: '40%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '5px',
	        fontSize: '13px',
	        paddingLeft: '3px',
	        marginRight: '10px'
	      },
	      RGBlabel: {
	        left: '0px',
	        top: '0px',
	        width: '34px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px',
	        position: 'absolute'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        marginLeft: '20%',
	        width: '80%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '6px',
	        fontSize: '13px',
	        paddingLeft: '3px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        width: '14px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px'
	      },
	      fieldSymbols: {
	        position: 'absolute',
	        top: '5px',
	        right: '-7px',
	        fontSize: '13px'
	      },
	      symbol: {
	        height: '20px',
	        lineHeight: '22px',
	        paddingBottom: '7px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data['#']) {
	      color.isValidHex(data['#']) && onChange({
	        hex: data['#'],
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else if (data.h || data.s || data.v) {
	      onChange({
	        h: data.h || hsv.h,
	        s: data.s || hsv.s,
	        v: data.v || hsv.v,
	        source: 'hsv'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields },
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'h',
	      value: Math.round(hsv.h),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 's',
	      value: Math.round(hsv.s * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'v',
	      value: Math.round(hsv.v * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: '#',
	      value: hex.replace('#', ''),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.fieldSymbols },
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '\xB0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = PhotoshopPicker;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      triangle: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '4px 0 4px 6px',
	        borderColor: 'transparent transparent transparent #fff',
	        position: 'absolute',
	        top: '1px',
	        left: '1px'
	      },
	      triangleBorder: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '5px 0 5px 8px',
	        borderColor: 'transparent transparent transparent #555'
	      },
	
	      left: {
	        Extend: 'triangleBorder',
	        transform: 'translate(-13px, -4px)'
	      },
	      leftInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      },
	
	      right: {
	        Extend: 'triangleBorder',
	        transform: 'translate(20px, -14px) rotate(180deg)'
	      },
	      rightInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.pointer },
	    _react2.default.createElement(
	      'div',
	      { style: styles.left },
	      _react2.default.createElement('div', { style: styles.leftInside })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.right },
	      _react2.default.createElement('div', { style: styles.rightInside })
	    )
	  );
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
	  var hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    },
	    'black-outline': {
	      picker: {
	        boxShadow: 'inset 0 0 0 1px #000'
	      }
	    }
	  }, { 'black-outline': hsl.l > 0.5 });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPreviews = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
	  var rgb = _ref.rgb,
	      currentColor = _ref.currentColor;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        border: '1px solid #B3B3B3',
	        borderBottom: '1px solid #F0F0F0',
	        marginBottom: '2px',
	        marginTop: '1px'
	      },
	      new: {
	        height: '34px',
	        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	      },
	      current: {
	        height: '34px',
	        background: currentColor,
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	      },
	      label: {
	        fontSize: '14px',
	        color: '#000',
	        textAlign: 'center'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'new'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement('div', { style: styles.new }),
	      _react2.default.createElement('div', { style: styles.current })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'current'
	    )
	  );
	};
	
	exports.default = PhotoshopPreviews;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(38);
	
	var _SketchFields = __webpack_require__(1950);
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__(1951);
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sketch = exports.Sketch = function Sketch(_ref) {
	  var width = _ref.width,
	      rgb = _ref.rgb,
	      hex = _ref.hex,
	      hsv = _ref.hsv,
	      hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      disableAlpha = _ref.disableAlpha,
	      presetColors = _ref.presetColors,
	      renderers = _ref.renderers,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': _extends({
	      picker: {
	        width: width,
	        padding: '10px 10px 0',
	        boxSizing: 'initial',
	        background: '#fff',
	        borderRadius: '4px',
	        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '75%',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '3px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      controls: {
	        display: 'flex'
	      },
	      sliders: {
	        padding: '4px 0',
	        flex: '1'
	      },
	      color: {
	        width: '24px',
	        height: '24px',
	        position: 'relative',
	        marginTop: '4px',
	        marginLeft: '4px',
	        borderRadius: '3px'
	      },
	      activeColor: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '2px',
	        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      hue: {
	        position: 'relative',
	        height: '10px',
	        overflow: 'hidden'
	      },
	      Hue: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	
	      alpha: {
	        position: 'relative',
	        height: '10px',
	        marginTop: '4px',
	        overflow: 'hidden'
	      },
	      Alpha: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      }
	    }, passedStyles),
	    'disableAlpha': {
	      color: {
	        height: '10px'
	      },
	      hue: {
	        height: '10px'
	      },
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, passedStyles), { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'sketch-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.controls, className: 'flexbox-fix' },
	      _react2.default.createElement(
	        'div',
	        { style: styles.sliders },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            onChange: onChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.Alpha, {
	            style: styles.Alpha,
	            rgb: rgb,
	            hsl: hsl,
	            renderers: renderers,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.color },
	        _react2.default.createElement(_common.Checkboard, null),
	        _react2.default.createElement('div', { style: styles.activeColor })
	      )
	    ),
	    _react2.default.createElement(_SketchFields2.default, {
	      rgb: rgb,
	      hsl: hsl,
	      hex: hex,
	      onChange: onChange,
	      disableAlpha: disableAlpha
	    }),
	    _react2.default.createElement(_SketchPresetColors2.default, {
	      colors: presetColors,
	      onClick: onChange,
	      onSwatchHover: onSwatchHover
	    })
	  );
	};
	
	Sketch.propTypes = {
	  disableAlpha: _propTypes2.default.bool,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  styles: _propTypes2.default.object
	};
	
	Sketch.defaultProps = {
	  disableAlpha: false,
	  width: 200,
	  styles: {},
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-param-reassign */
	
	var SketchFields = exports.SketchFields = function SketchFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      disableAlpha = _ref.disableAlpha;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingTop: '4px'
	      },
	      single: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      alpha: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      double: {
	        flex: '2'
	      },
	      input: {
	        width: '80%',
	        padding: '4px 10% 3px',
	        border: 'none',
	        boxShadow: 'inset 0 0 0 1px #ccc',
	        fontSize: '11px'
	      },
	      label: {
	        display: 'block',
	        textAlign: 'center',
	        fontSize: '11px',
	        color: '#222',
	        paddingTop: '3px',
	        paddingBottom: '4px',
	        textTransform: 'capitalize'
	      }
	    },
	    'disableAlpha': {
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        a: rgb.a,
	        source: 'rgb'
	      }, e);
	    } else if (data.a) {
	      if (data.a < 0) {
	        data.a = 0;
	      } else if (data.a > 100) {
	        data.a = 100;
	      }
	
	      data.a /= 100;
	      onChange({
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: data.a,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.double },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'hex',
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'r',
	        value: rgb.r,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'g',
	        value: rgb.g,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'b',
	        value: rgb.b,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.alpha },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'a',
	        value: Math.round(rgb.a * 100),
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '100'
	      })
	    )
	  );
	};
	
	exports.default = SketchFields;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
	  var colors = _ref.colors,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      colors: {
	        margin: '0 -10px',
	        padding: '10px 0 0 10px',
	        borderTop: '1px solid #eee',
	        display: 'flex',
	        flexWrap: 'wrap',
	        position: 'relative'
	      },
	      swatchWrap: {
	        width: '16px',
	        height: '16px',
	        margin: '0 10px 10px 0'
	      },
	      swatch: {
	        borderRadius: '3px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	      }
	    },
	    'no-presets': {
	      colors: {
	        display: 'none'
	      }
	    }
	  }, {
	    'no-presets': !colors || !colors.length
	  });
	
	  var handleClick = function handleClick(hex, e) {
	    onClick({
	      hex: hex,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.colors, className: 'flexbox-fix' },
	    colors.map(function (colorObjOrString) {
	      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
	      var key = '' + c.color + (c.title || '');
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: styles.swatchWrap },
	        _react2.default.createElement(_common.Swatch, _extends({}, c, {
	          style: styles.swatch,
	          onClick: handleClick,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
	          }
	        }))
	      );
	    })
	  );
	};
	
	SketchPresetColors.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    color: _propTypes2.default.string,
	    title: _propTypes2.default.string
	  })])).isRequired
	};
	
	exports.default = SketchPresetColors;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(38);
	
	var _SliderSwatches = __webpack_require__(1955);
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__(1953);
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = exports.Slider = function Slider(_ref) {
	  var hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      pointer = _ref.pointer,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      hue: {
	        height: '12px',
	        position: 'relative'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap || {}, className: 'slider-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.hue },
	      _react2.default.createElement(_common.Hue, {
	        style: styles.Hue,
	        hsl: hsl,
	        pointer: pointer,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
	    )
	  );
	};
	
	Slider.propTypes = {
	  styles: _propTypes2.default.object
	};
	Slider.defaultProps = {
	  pointer: _SliderPointer2.default,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '14px',
	        height: '14px',
	        borderRadius: '6px',
	        transform: 'translate(-7px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
	  var hsl = _ref.hsl,
	      offset = _ref.offset,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      active = _ref.active,
	      first = _ref.first,
	      last = _ref.last;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        height: '12px',
	        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
	        cursor: 'pointer'
	      }
	    },
	    'first': {
	      swatch: {
	        borderRadius: '2px 0 0 2px'
	      }
	    },
	    'last': {
	      swatch: {
	        borderRadius: '0 2px 2px 0'
	      }
	    },
	    'active': {
	      swatch: {
	        transform: 'scaleY(1.8)',
	        borderRadius: '3.6px/2px'
	      }
	    }
	  }, { active: active, first: first, last: last });
	
	  var handleClick = function handleClick(e) {
	    return onClick({
	      h: hsl.h,
	      s: 0.5,
	      l: offset,
	      source: 'hsl'
	    }, e);
	  };
	
	  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
	};
	
	exports.default = SliderSwatch;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _SliderSwatch = __webpack_require__(1954);
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
	  var onClick = _ref.onClick,
	      hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginTop: '20px'
	      },
	      swatch: {
	        boxSizing: 'border-box',
	        width: '20%',
	        paddingRight: '1px',
	        float: 'left'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  // Acceptible difference in floating point equality
	  var epsilon = 0.1;
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.80',
	        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick,
	        first: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.65',
	        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.50',
	        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.35',
	        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.20',
	        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick,
	        last: true
	      })
	    ),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = SliderSwatches;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(87);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _materialColors = __webpack_require__(808);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(38);
	
	var _SwatchesGroup = __webpack_require__(1958);
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swatches = exports.Swatches = function Swatches(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        height: height
	      },
	      overflow: {
	        height: height,
	        overflowY: 'scroll'
	      },
	      body: {
	        padding: '16px 0 6px 16px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    return onChange({ hex: data, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'swatches-picker ' + className },
	    _react2.default.createElement(
	      _common.Raised,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: styles.overflow },
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          (0, _map2.default)(colors, function (group) {
	            return _react2.default.createElement(_SwatchesGroup2.default, {
	              key: group.toString(),
	              group: group,
	              active: hex,
	              onClick: handleChange,
	              onSwatchHover: onSwatchHover
	            });
	          }),
	          _react2.default.createElement('div', { style: styles.clear })
	        )
	      )
	    )
	  );
	};
	
	Swatches.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)),
	  styles: _propTypes2.default.object
	
	  /* eslint-disable max-len */
	};Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(94);
	
	var colorUtils = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	var _CheckIcon = __webpack_require__(1028);
	
	var _CheckIcon2 = _interopRequireDefault(_CheckIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      first = _ref.first,
	      last = _ref.last,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        width: '40px',
	        height: '24px',
	        cursor: 'pointer',
	        background: color,
	        marginBottom: '1px'
	      },
	      check: {
	        color: colorUtils.getContrastingColor(color),
	        marginLeft: '8px',
	        display: 'none'
	      }
	    },
	    'first': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '2px 2px 0 0'
	      }
	    },
	    'last': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '0 0 2px 2px'
	      }
	    },
	    'active': {
	      check: {
	        display: 'block'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      check: {
	        color: '#333'
	      }
	    },
	    'transparent': {
	      check: {
	        color: '#333'
	      }
	    }
	  }, {
	    first: first,
	    last: last,
	    active: active,
	    'color-#FFFFFF': color === '#FFFFFF',
	    'transparent': color === 'transparent'
	  });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      color: color,
	      style: styles.color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: styles.check },
	      _react2.default.createElement(_CheckIcon2.default, null)
	    )
	  );
	};
	
	exports.default = SwatchesColor;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(87);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _SwatchesColor = __webpack_require__(1957);
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
	  var onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      group = _ref.group,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      group: {
	        paddingBottom: '10px',
	        width: '40px',
	        float: 'left',
	        marginRight: '10px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.group },
	    (0, _map2.default)(group, function (color, i) {
	      return _react2.default.createElement(_SwatchesColor2.default, {
	        key: color,
	        color: color,
	        active: color.toLowerCase() === active,
	        first: i === 0,
	        last: i === group.length - 1,
	        onClick: onClick,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	exports.default = SwatchesGroup;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(16);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(87);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(60);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(94);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Twitter = exports.Twitter = function Twitter(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '0 solid rgba(0,0,0,0.25)',
	        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
	        borderRadius: '4px',
	        position: 'relative'
	      },
	      body: {
	        padding: '15px 9px 9px 15px'
	      },
	      label: {
	        fontSize: '18px',
	        color: '#fff'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent #fff transparent',
	        position: 'absolute'
	      },
	      triangleShadow: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
	        position: 'absolute'
	      },
	      hash: {
	        background: '#F0F0F0',
	        height: '30px',
	        width: '30px',
	        borderRadius: '4px 0 0 4px',
	        float: 'left',
	        color: '#98A1A4',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      input: {
	        width: '100px',
	        fontSize: '14px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '28px',
	        boxShadow: 'inset 0 0 0 1px #F0F0F0',
	        boxSizing: 'content-box',
	        borderRadius: '0 4px 4px 0',
	        float: 'left',
	        paddingLeft: '8px'
	      },
	      swatch: {
	        width: '30px',
	        height: '30px',
	        float: 'left',
	        borderRadius: '4px',
	        margin: '0 6px 6px 0'
	      },
	      clear: {
	        clear: 'both'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-10px',
	        left: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        left: '12px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-10px',
	        right: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        right: '12px'
	      }
	    }
	  }, passedStyles), {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right'
	  });
	
	  var handleChange = function handleChange(hexcode, e) {
	    color.isValidHex(hexcode) && onChange({
	      hex: hexcode,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'twitter-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      (0, _map2.default)(colors, function (c, i) {
	        return _react2.default.createElement(_common.Swatch, {
	          key: i,
	          color: c,
	          hex: c,
	          style: styles.swatch,
	          onClick: handleChange,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: '0 0 4px ' + c
	          }
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.hash },
	        '#'
	      ),
	      _react2.default.createElement(_common.EditableInput, {
	        label: null,
	        style: { input: styles.input },
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      }),
	      _react2.default.createElement('div', { style: styles.clear })
	    )
	  );
	};
	
	Twitter.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  styles: _propTypes2.default.object
	};
	
	Twitter.defaultProps = {
	  width: 276,
	  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
	  triangle: 'top-left',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Twitter);

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (direction === 'vertical') {
	    var a = void 0;
	    if (top < 0) {
	      a = 0;
	    } else if (top > containerHeight) {
	      a = 1;
	    } else {
	      a = Math.round(top * 100 / containerHeight) / 100;
	    }
	
	    if (hsl.a !== a) {
	      return {
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _a = void 0;
	    if (left < 0) {
	      _a = 0;
	    } else if (left > containerWidth) {
	      _a = 1;
	    } else {
	      _a = Math.round(left * 100 / containerWidth) / 100;
	    }
	
	    if (initialA !== _a) {
	      return {
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: _a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	};

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var checkboardCache = {};
	
	var render = exports.render = function render(c1, c2, size, serverCanvas) {
	  if (typeof document === 'undefined' && !serverCanvas) {
	    return null;
	  }
	  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
	  canvas.width = size * 2;
	  canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) {
	    return null;
	  } // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	};
	
	var get = exports.get = function get(c1, c2, size, serverCanvas) {
	  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
	
	  if (checkboardCache[key]) {
	    return checkboardCache[key];
	  }
	
	  var checkboard = render(c1, c2, size, serverCanvas);
	  checkboardCache[key] = checkboard;
	  return checkboard;
	};

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, direction, hsl, container) {
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (direction === 'vertical') {
	    var h = void 0;
	    if (top < 0) {
	      h = 359;
	    } else if (top > containerHeight) {
	      h = 0;
	    } else {
	      var percent = -(top * 100 / containerHeight) + 100;
	      h = 360 * percent / 100;
	    }
	
	    if (hsl.h !== h) {
	      return {
	        h: h,
	        s: hsl.s,
	        l: hsl.l,
	        a: hsl.a,
	        source: 'hsl'
	      };
	    }
	  } else {
	    var _h = void 0;
	    if (left < 0) {
	      _h = 0;
	    } else if (left > containerWidth) {
	      _h = 359;
	    } else {
	      var _percent = left * 100 / containerWidth;
	      _h = 360 * _percent / 100;
	    }
	
	    if (hsl.h !== _h) {
	      return {
	        h: _h,
	        s: hsl.s,
	        l: hsl.l,
	        a: hsl.a,
	        source: 'hsl'
	      };
	    }
	  }
	  return null;
	};

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFocus = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */
	
	
	var handleFocus = exports.handleFocus = function handleFocus(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	  return function (_React$Component) {
	    _inherits(Focus, _React$Component);
	
	    function Focus() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Focus);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
	        return _this.setState({ focus: true });
	      }, _this.handleBlur = function () {
	        return _this.setState({ focus: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Focus, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          Span,
	          { onFocus: this.handleFocus, onBlur: this.handleBlur },
	          _react2.default.createElement(Component, _extends({}, this.props, this.state))
	        );
	      }
	    }]);
	
	    return Focus;
	  }(_react2.default.Component);
	};

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, hsl, container) {
	  var _container$getBoundin = container.getBoundingClientRect(),
	      containerWidth = _container$getBoundin.width,
	      containerHeight = _container$getBoundin.height;
	
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (left < 0) {
	    left = 0;
	  } else if (left > containerWidth) {
	    left = containerWidth;
	  }
	
	  if (top < 0) {
	    top = 0;
	  } else if (top > containerHeight) {
	    top = containerHeight;
	  }
	
	  var saturation = left / containerWidth;
	  var bright = 1 - top / containerHeight;
	
	  return {
	    h: hsl.h,
	    s: saturation,
	    v: bright,
	    a: hsl.a,
	    source: 'hsv'
	  };
	};

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomPicker = exports.GooglePicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;
	
	var _Alpha = __webpack_require__(1915);
	
	Object.defineProperty(exports, 'AlphaPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Block = __webpack_require__(1917);
	
	Object.defineProperty(exports, 'BlockPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Circle = __webpack_require__(1923);
	
	Object.defineProperty(exports, 'CirclePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Chrome = __webpack_require__(1919);
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__(1931);
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Github = __webpack_require__(1934);
	
	Object.defineProperty(exports, 'GithubPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Github).default;
	  }
	});
	
	var _Hue = __webpack_require__(1940);
	
	Object.defineProperty(exports, 'HuePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Material = __webpack_require__(1942);
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__(1943);
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__(1949);
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__(1952);
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__(1956);
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _Twitter = __webpack_require__(1959);
	
	Object.defineProperty(exports, 'TwitterPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitter).default;
	  }
	});
	
	var _Google = __webpack_require__(1936);
	
	Object.defineProperty(exports, 'GooglePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Google).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(834);
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(12),__webpack_require__(45),__webpack_require__(1),__webpack_require__(2074),__webpack_require__(2244)):"function"==typeof define&&define.amd?define(["moment","react-dom","react","react-onclickoutside","tether"],e):"object"==typeof exports?exports.DatePicker=e(require("moment"),require("react-dom"),require("react"),require("react-onclickoutside"),require("tether")):t.DatePicker=e(t.moment,t.ReactDOM,t.React,t.OnClickOutside,t.Tether)}(this,function(t,e,r,n,a){return function(t){function e(n){if(r[n])return r[n].exports;var a=r[n]={exports:{},id:n,loaded:!1};return t[n].call(a.exports,a,a.exports,e),a.loaded=!0,a.exports}var r={};return e.m=t,e.c=r,e.p="",e(0)}([function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}var a=r(1),s=n(a),i=r(26),o=n(i),l=r(27),u=n(l),c=r(32),p=n(c),d=r(64),h=n(d),f=r(29),y=n(f),m=r(28),v=n(m),g=y.default.createClass({displayName:"DatePicker",propTypes:{weekdays:y.default.PropTypes.arrayOf(y.default.PropTypes.string),locale:y.default.PropTypes.string,dateFormatCalendar:y.default.PropTypes.string,disabled:y.default.PropTypes.bool,id:y.default.PropTypes.string,popoverAttachment:y.default.PropTypes.string,popoverTargetAttachment:y.default.PropTypes.string,popoverTargetOffset:y.default.PropTypes.string,weekStart:y.default.PropTypes.string,showYearDropdown:y.default.PropTypes.bool,onChange:y.default.PropTypes.func.isRequired,onBlur:y.default.PropTypes.func,onFocus:y.default.PropTypes.func,onClear:y.default.PropTypes.func,tabIndex:y.default.PropTypes.number,isTypeable:y.default.PropTypes.bool,filterDate:y.default.PropTypes.func},getDefaultProps:function(){return{weekdays:["Su","Mo","Tu","We","Th","Fr","Sa"],locale:"en",dateFormatCalendar:"MMMM YYYY",moment:o.default,onChange:function(){},disabled:!1,onFocus:function(){},onBlur:function(){},onClear:function(){},isTypeable:!1}},getInitialState:function(){return{dateValid:!0,focus:!1,selected:this.props.selected}},componentWillReceiveProps:function(t){this.setState({selected:t.selected})},shouldComponentUpdate:function(t,e){return!((0,s.default)(t,this.props)&&(0,s.default)(e,this.state))},getValue:function(){return this.state.selected},handleFocus:function(){var t=this;this.state.focus||(this.props.onFocus(),setTimeout(function(){t.setState({focus:!0})},200))},handleBlur:function(){var t=this,e=this.state,r=e.focus,n=e.dateValid;e.selected;r&&setTimeout(function(){t.state.datePickerHasFocus||(t.props.onBlur(t.state.selected),n||t.props.dateError(!0),t.hideCalendar())},200)},hideCalendar:function(){var t=this;setTimeout(function(){t.setState({focus:!1})},0)},doesDatePickerContainElement:function(t){var e=v.default.findDOMNode(this.refs.calendar);return!!e&&e.contains(t)},reformatMoment:function(t){var e=this.props.dateFormat,r=t.format(e);return(0,o.default)(r,e)},handleSelect:function(t){var e=this.props,r=e.minDate,n=e.maxDate,a=e.dateFormat,s=this.reformatMoment(r),i=this.reformatMoment(n),l=(0,o.default)(t,a),u=this.reformatMoment(l),c=!1;!this.validateDate(t)||s&&!u.isSameOrAfter(s)||i&&!u.isSameOrBefore(i)?t&&0!==t.length||(c=!0):(c=!0,this.setSelected(l)),this.setState({dateValid:c})},validateDate:function(t){return!!((0,o.default)(t,"DD-MM-YYYY",!0).isValid()||(0,o.default)(t,"DD/MM/YYYY",!0).isValid()||(0,o.default)(t,"DD.MM.YYYY",!0).isValid()||(0,o.default)(t,"DD MM YYYY",!0).isValid())},setSelected:function(t){var e=this;this.setState({selected:t},function(){e.props.onChange(e.state.selected)})},invalidateSelected:function(){null!==this.state.selected&&this.props.onChange(null)},onInputClick:function(t){var e=this;this.state.focus;this.setState({focus:!0,datePickerHasFocus:this.doesDatePickerContainElement(t.target)},function(){e.forceUpdate()})},onClearClick:function(t){var e=this;t.preventDefault(),null!==this.state.selected&&this.setState({dateValid:!0,focus:!1,selected:null},function(){e.props.onClear(),e.props.onChange(null)})},calendar:function(){if(this.state.focus)return y.default.createElement(h.default,{attachment:this.props.popoverAttachment,targetAttachment:this.props.popoverTargetAttachment,targetOffset:this.props.popoverTargetOffset,constraints:this.props.tetherConstraints},y.default.createElement(p.default,{ref:"calendar",weekdays:this.props.weekdays,locale:this.props.locale,moment:this.props.moment,dateFormat:this.props.dateFormatCalendar,selected:this.state.selected,onSelect:this.handleSelect,hideCalendar:this.hideCalendar,minDate:this.props.minDate,maxDate:this.props.maxDate,startDate:this.props.startDate,endDate:this.props.endDate,excludeDates:this.props.excludeDates,filterDate:this.props.filterDate,handleClick:this.onInputClick,includeDates:this.props.includeDates,weekStart:this.props.weekStart,showYearDropdown:this.props.showYearDropdown}))},render:function(){var t=this.state.dateValid;return y.default.createElement("div",{className:"datepicker__input-container"},y.default.createElement(u.default,{ref:"input",id:this.props.id,name:this.props.name,date:this.state.selected,dateFormat:this.props.dateFormat,focus:this.state.focus,onFocus:this.handleFocus,onBlur:this.handleBlur,handleClick:this.onInputClick,handleEnter:this.hideCalendar,invalidateSelected:this.invalidateSelected,placeholderText:this.props.placeholderText,disabled:this.props.disabled,className:this.props.className,title:this.props.title,readOnly:this.props.readOnly,required:this.props.required,tabIndex:this.props.tabIndex,handleChange:this.handleSelect,isValid:t,dateError:this.props.dateError,isTypeable:this.props.isTypeable,isClearable:this.props.isClearable,handleClear:this.onClearClick}),this.props.disabled?null:this.calendar())}});t.exports=g},function(t,e,r){function n(t,e,r,n){r="function"==typeof r?s(r,n,3):void 0;var i=r?r(t,e):void 0;return void 0===i?a(t,e,r):!!i}var a=r(2),s=r(24);t.exports=n},function(t,e,r){function n(t,e,r,o,l,u){return t===e||(null==t||null==e||!s(t)&&!i(e)?t!==t&&e!==e:a(t,e,n,r,o,l,u))}var a=r(3),s=r(12),i=r(13);t.exports=n},function(t,e,r){function n(t,e,r,n,d,y,m){var v=o(t),g=o(e),_=c,k=c;v||(_=f.call(t),_==u?_=p:_!=p&&(v=l(t))),g||(k=f.call(e),k==u?k=p:k!=p&&(g=l(e)));var D=_==p,b=k==p,x=_==k;if(x&&!v&&!D)return s(t,e,_);if(!d){var C=D&&h.call(t,"__wrapped__"),P=b&&h.call(e,"__wrapped__");if(C||P)return r(C?t.value():t,P?e.value():e,n,d,y,m)}if(!x)return!1;y||(y=[]),m||(m=[]);for(var T=y.length;T--;)if(y[T]==t)return m[T]==e;y.push(t),m.push(e);var E=(v?a:i)(t,e,r,n,d,y,m);return y.pop(),m.pop(),E}var a=r(4),s=r(6),i=r(7),o=r(20),l=r(23),u="[object Arguments]",c="[object Array]",p="[object Object]",d=Object.prototype,h=d.hasOwnProperty,f=d.toString;t.exports=n},function(t,e,r){function n(t,e,r,n,s,i,o){var l=-1,u=t.length,c=e.length;if(u!=c&&!(s&&c>u))return!1;for(;++l<u;){var p=t[l],d=e[l],h=n?n(s?d:p,s?p:d,l):void 0;if(void 0!==h){if(h)continue;return!1}if(s){if(!a(e,function(t){return p===t||r(p,t,n,s,i,o)}))return!1}else if(p!==d&&!r(p,d,n,s,i,o))return!1}return!0}var a=r(5);t.exports=n},function(t,e){function r(t,e){for(var r=-1,n=t.length;++r<n;)if(e(t[r],r,t))return!0;return!1}t.exports=r},function(t,e){function r(t,e,r){switch(r){case n:case a:return+t==+e;case s:return t.name==e.name&&t.message==e.message;case i:return t!=+t?e!=+e:t==+e;case o:case l:return t==e+""}return!1}var n="[object Boolean]",a="[object Date]",s="[object Error]",i="[object Number]",o="[object RegExp]",l="[object String]";t.exports=r},function(t,e,r){function n(t,e,r,n,s,o,l){var u=a(t),c=u.length,p=a(e),d=p.length;if(c!=d&&!s)return!1;for(var h=c;h--;){var f=u[h];if(!(s?f in e:i.call(e,f)))return!1}for(var y=s;++h<c;){f=u[h];var m=t[f],v=e[f],g=n?n(s?v:m,s?m:v,f):void 0;if(!(void 0===g?r(m,v,n,s,o,l):g))return!1;y||(y="constructor"==f)}if(!y){var _=t.constructor,k=e.constructor;if(_!=k&&"constructor"in t&&"constructor"in e&&!("function"==typeof _&&_ instanceof _&&"function"==typeof k&&k instanceof k))return!1}return!0}var a=r(8),s=Object.prototype,i=s.hasOwnProperty;t.exports=n},function(t,e,r){var n=r(9),a=r(14),s=r(12),i=r(18),o=n(Object,"keys"),l=o?function(t){var e=null==t?void 0:t.constructor;return"function"==typeof e&&e.prototype===t||"function"!=typeof t&&a(t)?i(t):s(t)?o(t):[]}:i;t.exports=l},function(t,e,r){function n(t,e){var r=null==t?void 0:t[e];return a(r)?r:void 0}var a=r(10);t.exports=n},function(t,e,r){function n(t){return null!=t&&(a(t)?c.test(l.call(t)):s(t)&&i.test(t))}var a=r(11),s=r(13),i=/^\[object .+?Constructor\]$/,o=Object.prototype,l=Function.prototype.toString,u=o.hasOwnProperty,c=RegExp("^"+l.call(u).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=n},function(t,e,r){function n(t){return a(t)&&o.call(t)==s}var a=r(12),s="[object Function]",i=Object.prototype,o=i.toString;t.exports=n},function(t,e){function r(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}t.exports=r},function(t,e){function r(t){return!!t&&"object"==typeof t}t.exports=r},function(t,e,r){function n(t){return null!=t&&s(a(t))}var a=r(15),s=r(17);t.exports=n},function(t,e,r){var n=r(16),a=n("length");t.exports=a},function(t,e){function r(t){return function(e){return null==e?void 0:e[t]}}t.exports=r},function(t,e){function r(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=n}var n=9007199254740991;t.exports=r},function(t,e,r){function n(t){for(var e=l(t),r=e.length,n=r&&t.length,u=!!n&&o(n)&&(s(t)||a(t)),p=-1,d=[];++p<r;){var h=e[p];(u&&i(h,n)||c.call(t,h))&&d.push(h)}return d}var a=r(19),s=r(20),i=r(21),o=r(17),l=r(22),u=Object.prototype,c=u.hasOwnProperty;t.exports=n},function(t,e,r){function n(t){return s(t)&&a(t)&&o.call(t,"callee")&&!l.call(t,"callee")}var a=r(14),s=r(13),i=Object.prototype,o=i.hasOwnProperty,l=i.propertyIsEnumerable;t.exports=n},function(t,e,r){var n=r(9),a=r(17),s=r(13),i="[object Array]",o=Object.prototype,l=o.toString,u=n(Array,"isArray"),c=u||function(t){return s(t)&&a(t.length)&&l.call(t)==i};t.exports=c},function(t,e){function r(t,e){return t="number"==typeof t||n.test(t)?+t:-1,e=null==e?a:e,t>-1&&t%1==0&&t<e}var n=/^\d+$/,a=9007199254740991;t.exports=r},function(t,e,r){function n(t){if(null==t)return[];l(t)||(t=Object(t));var e=t.length;e=e&&o(e)&&(s(t)||a(t))&&e||0;for(var r=t.constructor,n=-1,u="function"==typeof r&&r.prototype===t,p=Array(e),d=e>0;++n<e;)p[n]=n+"";for(var h in t)d&&i(h,e)||"constructor"==h&&(u||!c.call(t,h))||p.push(h);return p}var a=r(19),s=r(20),i=r(21),o=r(17),l=r(12),u=Object.prototype,c=u.hasOwnProperty;t.exports=n},function(t,e,r){function n(t){return s(t)&&a(t.length)&&!!j[I.call(t)]}var a=r(17),s=r(13),i="[object Arguments]",o="[object Array]",l="[object Boolean]",u="[object Date]",c="[object Error]",p="[object Function]",d="[object Map]",h="[object Number]",f="[object Object]",y="[object RegExp]",m="[object Set]",v="[object String]",g="[object WeakMap]",_="[object ArrayBuffer]",k="[object Float32Array]",D="[object Float64Array]",b="[object Int8Array]",x="[object Int16Array]",C="[object Int32Array]",P="[object Uint8Array]",T="[object Uint8ClampedArray]",E="[object Uint16Array]",w="[object Uint32Array]",j={};j[k]=j[D]=j[b]=j[x]=j[C]=j[P]=j[T]=j[E]=j[w]=!0,j[i]=j[o]=j[_]=j[l]=j[u]=j[c]=j[p]=j[d]=j[h]=j[f]=j[y]=j[m]=j[v]=j[g]=!1;var S=Object.prototype,I=S.toString;t.exports=n},function(t,e,r){function n(t,e,r){if("function"!=typeof t)return a;if(void 0===e)return t;switch(r){case 1:return function(r){return t.call(e,r)};case 3:return function(r,n,a){return t.call(e,r,n,a)};case 4:return function(r,n,a,s){return t.call(e,r,n,a,s)};case 5:return function(r,n,a,s,i){return t.call(e,r,n,a,s,i)}}return function(){return t.apply(e,arguments)}}var a=r(25);t.exports=n},function(t,e){function r(t){return t}t.exports=r},function(e,r){e.exports=t},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}var a=r(26),s=(n(a),r(28)),i=(n(s),r(29)),o=n(i),l=r(30),u=(n(l),o.default.createClass({displayName:"DateInput",getDefaultProps:function(){return{dateFormat:"YYYY-MM-DD",className:"datepicker__input",onBlur:function(){}}},componentWillMount:function(){this.setState({maybeDate:this.safeDateFormat(this.props.date)})},componentDidMount:function(){this.toggleFocus(this.props.focus)},componentWillReceiveProps:function(t){this.toggleFocus(t.focus);var e=t.isTypeable&&t.focus&&!t.date;t.date==this.props.date||e||this.setState({maybeDate:this.safeDateFormat(t.date)})},toggleFocus:function(t){t?this.refs.input.focus():this.refs.input.blur()},handleChange:function t(e){var r=e.target.value,t=this.props.handleChange;this.setState({maybeDate:r}),t(r)},safeDateFormat:function(t){return t?t.format(this.props.dateFormat):null},handleKeyDown:function(t){switch(t.key){case"Enter":t.preventDefault(),this.props.handleEnter();break;case"Escape":t.preventDefault(),this.props.hideCalendar()}},handleClick:function(t){this.props.disabled||this.props.handleClick(t)},handleOnClear:function(t){this.props.handleClear(t),this.setState({maybeDate:null})},render:function(){var t=this.props,e=t.focus,r=t.isValid,n=t.placeholderText,a=this.state.maybeDate,s=null,i=a,l=i&&i.replace(/[^0-9]/g,"").length<8,u=r&&!l?void 0:"red",c=r||l?void 0:"red",p=e?c:u,d=i?p:void 0;return this.props.isClearable&&i&&i.length>0&&(s=o.default.createElement("a",{className:"close-icon",href:"#",onClick:this.handleOnClear})),o.default.createElement("div",null,o.default.createElement("input",{autoComplete:"off",style:{color:d},ref:"input",id:this.props.id,name:this.props.name,value:i||"",onClick:this.handleClick,onKeyDown:this.handleKeyDown,onFocus:this.props.onFocus,onBlur:this.props.onBlur,onChange:this.handleChange,className:"ignore-react-onclickoutside "+this.props.className,disabled:this.props.disabled,placeholder:n,readOnly:this.props.readOnly,required:this.props.required,tabIndex:this.props.tabIndex}),s)}}));t.exports=u},function(t,r){t.exports=e},function(t,e){t.exports=r},function(t,e,r){"use strict";function n(t,e){var r={};for(var n in t)e.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(t,n)&&(r[n]=t[n]);return r}function a(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function s(t){return(t.ctrlKey||t.metaKey)&&t.keyCode===(t.shiftKey?h:d)}function i(t){return(t.ctrlKey||t.metaKey)&&t.keyCode===(t.shiftKey?d:h)}function o(t){var e,r,n,a;if(void 0!==t.selectionStart)e=t.selectionStart,r=t.selectionEnd;else try{t.focus(),n=t.createTextRange(),a=n.duplicate(),n.moveToBookmark(document.selection.createRange().getBookmark()),a.setEndPoint("EndToStart",n),e=a.text.length,r=e+n.text.length}catch(t){}return{start:e,end:r}}function l(t,e){var r;try{void 0!==t.selectionStart?(t.focus(),t.setSelectionRange(e.start,e.end)):(t.focus(),r=t.createTextRange(),r.collapse(!0),r.moveStart("character",e.start),r.moveEnd("character",e.end-e.start),r.select())}catch(t){}}var u=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(t[n]=r[n])}return t},c=r(29),p=r(31),d=90,h=89,f=c.createClass({displayName:"MaskedInput",propTypes:{mask:c.PropTypes.string.isRequired,formatCharacters:c.PropTypes.object,placeholderChar:c.PropTypes.string},getDefaultProps:function(){return{value:""}},componentWillMount:function(){var t={pattern:this.props.mask,value:this.props.value,formatCharacters:this.props.formatCharacters};this.props.placeholderChar&&(t.placeholderChar=this.props.placeholderChar),this.mask=new p(t)},componentWillReceiveProps:function(t){this.props.mask!==t.mask&&this.props.value!==t.mask?this.mask.getValue()===this.mask.emptyValue?this.mask.setPattern(t.mask,{value:t.value}):this.mask.setPattern(t.mask,{value:this.mask.getRawValue()}):this.props.mask!==t.mask?this.mask.setPattern(t.mask,{value:this.mask.getRawValue()}):this.props.value!==t.value&&this.mask.setValue(t.value)},componentWillUpdate:function(t,e){t.mask!==this.props.mask&&this._updatePattern(t)},componentDidUpdate:function(t){t.mask!==this.props.mask&&this.mask.selection.start&&this._updateInputSelection()},_updatePattern:function(t){this.mask.setPattern(t.mask,{value:this.mask.getRawValue(),selection:o(this.input)})},_updateMaskSelection:function(){this.mask.selection=o(this.input)},_updateInputSelection:function(){l(this.input,this.mask.selection)},_onChange:function(t){var e=this.mask.getValue();if(t.target.value!==e){if(t.target.value.length<e.length){var r=e.length-t.target.value.length;this._updateMaskSelection(),this.mask.selection.end=this.mask.selection.start+r,this.mask.backspace()}var n=this._getDisplayValue();t.target.value=n,n&&this._updateInputSelection()}this.props.onChange&&this.props.onChange(t)},_onKeyDown:function(t){if(s(t))return t.preventDefault(),void(this.mask.undo()&&(t.target.value=this._getDisplayValue(),this._updateInputSelection(),this.props.onChange&&this.props.onChange(t)));if(i(t))return t.preventDefault(),void(this.mask.redo()&&(t.target.value=this._getDisplayValue(),this._updateInputSelection(),this.props.onChange&&this.props.onChange(t)));if("Backspace"===t.key&&(t.preventDefault(),this._updateMaskSelection(),this.mask.backspace())){var e=this._getDisplayValue();t.target.value=e,e&&this._updateInputSelection(),this.props.onChange&&this.props.onChange(t)}},_onKeyPress:function(t){t.metaKey||t.altKey||t.ctrlKey||"Enter"===t.key||(t.preventDefault(),this._updateMaskSelection(),this.mask.input(t.key||t.data)&&(t.target.value=this.mask.getValue(),this._updateInputSelection(),this.props.onChange&&this.props.onChange(t)))},_onPaste:function(t){t.preventDefault(),this._updateMaskSelection(),this.mask.paste(t.clipboardData.getData("Text"))&&(t.target.value=this.mask.getValue(),setTimeout(this._updateInputSelection,0),this.props.onChange&&this.props.onChange(t))},_getDisplayValue:function(){var t=this.mask.getValue();return t===this.mask.emptyValue?"":t},_keyPressPropName:function(){return"undefined"!=typeof navigator&&navigator.userAgent.match(/Android/i)?"onBeforeInput":"onKeyPress"},_getEventHandlers:function(){return a({onChange:this._onChange,onKeyDown:this._onKeyDown,onPaste:this._onPaste},this._keyPressPropName(),this._onKeyPress)},focus:function(){this.input.focus()},blur:function(){this.input.blur()},render:function(){var t=this,e=function(e){return t.input=e},r=this.mask.pattern.length,a=this._getDisplayValue(),s=this._getEventHandlers(),i=this.props,o=i.size,l=void 0===o?r:o,p=i.placeholder,d=void 0===p?this.mask.emptyValue:p,h=this.props,f=(h.placeholderChar,h.formatCharacters,n(h,["placeholderChar","formatCharacters"])),y=u({},f,s,{ref:e,maxLength:r,value:a,size:l,placeholder:d});return c.createElement("input",y)}});t.exports=f},function(t,e){"use strict";function r(t,e){if(e)for(var r=Object.keys(e),n=0,a=r.length;n<a;n++)t[r[n]]=e[r[n]];return t}function n(t){return r({},t)}function a(t){var e=n(d);if(t)for(var r=Object.keys(t),a=0,s=r.length;a<s;a++){var i=r[a];null==t[i]?delete e[i]:e[i]=t[i]}return e}function s(t,e,r,n){return this instanceof s?(this.placeholderChar=r||p,this.formatCharacters=e||d,this.source=t,this.pattern=[],this.length=0,this.firstEditableIndex=null,this.lastEditableIndex=null,this._editableIndices={},this.isRevealingMask=n||!1,void this._parse()):new s(t,e,r)}function i(t){if(!(this instanceof i))return new i(t);if(t=r({formatCharacters:null,pattern:null,isRevealingMask:!1,placeholderChar:p,selection:{start:0,end:0},value:""},t),null==t.pattern)throw new Error("InputMask: you must provide a pattern.");if("string"!=typeof t.placeholderChar||t.placeholderChar.length>1)throw new Error("InputMask: placeholderChar should be a single character or an empty string.");this.placeholderChar=t.placeholderChar,this.formatCharacters=a(t.formatCharacters),this.setPattern(t.pattern,{value:t.value,selection:t.selection,isRevealingMask:t.isRevealingMask})}var o="\\",l=/^\d$/,u=/^[A-Za-z]$/,c=/^[\dA-Za-z]$/,p="_",d={"*":{validate:function(t){return c.test(t)}},1:{validate:function(t){return l.test(t)}},a:{validate:function(t){return u.test(t)}},A:{validate:function(t){return u.test(t)},transform:function(t){return t.toUpperCase()}},"#":{validate:function(t){return c.test(t)},transform:function(t){return t.toUpperCase()}}};s.prototype._parse=function(){for(var t=this.source.split(""),e=0,r=[],n=0,a=t.length;n<a;n++){var s=t[n];if(s===o){if(n===a-1)throw new Error("InputMask: pattern ends with a raw "+o);s=t[++n]}else s in this.formatCharacters&&(null===this.firstEditableIndex&&(this.firstEditableIndex=e),this.lastEditableIndex=e,this._editableIndices[e]=!0);r.push(s),e++}if(null===this.firstEditableIndex)throw new Error('InputMask: pattern "'+this.source+'" does not contain any editable characters.');this.pattern=r,this.length=r.length},s.prototype.formatValue=function(t){for(var e=new Array(this.length),r=0,n=0,a=this.length;n<a;n++)if(this.isEditableIndex(n)){if(this.isRevealingMask&&t.length<=r&&!this.isValidAtIndex(t[r],n))break;e[n]=t.length>r&&this.isValidAtIndex(t[r],n)?this.transform(t[r],n):this.placeholderChar,r++}else e[n]=this.pattern[n],t.length>r&&t[r]===this.pattern[n]&&r++;return e},s.prototype.isEditableIndex=function(t){return!!this._editableIndices[t]},s.prototype.isValidAtIndex=function(t,e){return this.formatCharacters[this.pattern[e]].validate(t)},s.prototype.transform=function(t,e){var r=this.formatCharacters[this.pattern[e]];return"function"==typeof r.transform?r.transform(t):t},i.prototype.input=function(t){if(this.selection.start===this.selection.end&&this.selection.start===this.pattern.length)return!1;var e=n(this.selection),r=this.getValue(),a=this.selection.start;if(a<this.pattern.firstEditableIndex&&(a=this.pattern.firstEditableIndex),this.pattern.isEditableIndex(a)){if(!this.pattern.isValidAtIndex(t,a))return!1;this.value[a]=this.pattern.transform(t,a)}for(var s=this.selection.end-1;s>a;)this.pattern.isEditableIndex(s)&&(this.value[s]=this.placeholderChar),s--;for(this.selection.start=this.selection.end=a+1;this.pattern.length>this.selection.start&&!this.pattern.isEditableIndex(this.selection.start);)this.selection.start++,this.selection.end++;return null!=this._historyIndex&&(this._history.splice(this._historyIndex,this._history.length-this._historyIndex),this._historyIndex=null),("input"!==this._lastOp||e.start!==e.end||null!==this._lastSelection&&e.start!==this._lastSelection.start)&&this._history.push({value:r,selection:e,lastOp:this._lastOp}),this._lastOp="input",this._lastSelection=n(this.selection),!0},i.prototype.backspace=function(){if(0===this.selection.start&&0===this.selection.end)return!1;var t=n(this.selection),e=this.getValue();if(this.selection.start===this.selection.end)this.pattern.isEditableIndex(this.selection.start-1)&&(this.value[this.selection.start-1]=this.placeholderChar),this.selection.start--,this.selection.end--;else{for(var r=this.selection.end-1;r>=this.selection.start;)this.pattern.isEditableIndex(r)&&(this.value[r]=this.placeholderChar),r--;this.selection.end=this.selection.start}return null!=this._historyIndex&&this._history.splice(this._historyIndex,this._history.length-this._historyIndex),("backspace"!==this._lastOp||t.start!==t.end||null!==this._lastSelection&&t.start!==this._lastSelection.start)&&this._history.push({value:e,selection:t,lastOp:this._lastOp}),this._lastOp="backspace",this._lastSelection=n(this.selection),!0},i.prototype.paste=function(t){var e={value:this.value.slice(),selection:n(this.selection),_lastOp:this._lastOp,_history:this._history.slice(),_historyIndex:this._historyIndex,_lastSelection:n(this._lastSelection)};if(this.selection.start<this.pattern.firstEditableIndex){for(var a=0,s=this.pattern.firstEditableIndex-this.selection.start;a<s;a++)if(t.charAt(a)!==this.pattern.pattern[a])return!1;t=t.substring(this.pattern.firstEditableIndex-this.selection.start),this.selection.start=this.pattern.firstEditableIndex}for(a=0,s=t.length;a<s&&this.selection.start<=this.pattern.lastEditableIndex;a++){var i=this.input(t.charAt(a));if(!i){if(this.selection.start>0){var o=this.selection.start-1;if(!this.pattern.isEditableIndex(o)&&t.charAt(a)===this.pattern.pattern[o])continue}return r(this,e),!1}}return!0},i.prototype.undo=function(){if(0===this._history.length||0===this._historyIndex)return!1;var t;if(null==this._historyIndex){this._historyIndex=this._history.length-1,t=this._history[this._historyIndex];var e=this.getValue();t.value===e&&t.selection.start===this.selection.start&&t.selection.end===this.selection.end||this._history.push({value:e,selection:n(this.selection),lastOp:this._lastOp,startUndo:!0})}else t=this._history[--this._historyIndex];return this.value=t.value.split(""),this.selection=t.selection,this._lastOp=t.lastOp,!0},i.prototype.redo=function(){if(0===this._history.length||null==this._historyIndex)return!1;var t=this._history[++this._historyIndex];return this._historyIndex===this._history.length-1&&(this._historyIndex=null,t.startUndo&&this._history.pop()),this.value=t.value.split(""),this.selection=t.selection,this._lastOp=t.lastOp,!0},i.prototype.setPattern=function(t,e){e=r({selection:{start:0,end:0},value:""},e),this.pattern=new s(t,this.formatCharacters,this.placeholderChar,e.isRevealingMask),this.setValue(e.value),this.emptyValue=this.pattern.formatValue([]).join(""),this.selection=e.selection,this._resetHistory()},i.prototype.setSelection=function(t){if(this.selection=n(t),this.selection.start===this.selection.end){if(this.selection.start<this.pattern.firstEditableIndex)return this.selection.start=this.selection.end=this.pattern.firstEditableIndex,!0;for(var e=this.selection.start;e>=this.pattern.firstEditableIndex;){if(this.pattern.isEditableIndex(e-1)&&this.value[e-1]!==this.placeholderChar||e===this.pattern.firstEditableIndex){this.selection.start=this.selection.end=e;break}e--}return!0}return!1},i.prototype.setValue=function(t){null==t&&(t=""),this.value=this.pattern.formatValue(t.split(""))},i.prototype.getValue=function(){return this.value.join("")},i.prototype.getRawValue=function(){for(var t=[],e=0;e<this.value.length;e++)this.pattern._editableIndices[e]===!0&&t.push(this.value[e]);return t.join("")},i.prototype._resetHistory=function(){this._history=[],this._historyIndex=null,this._lastOp=null,this._lastSelection=n(this.selection)},i.Pattern=s,t.exports=i},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function a(t){var e=t.moment,r=t.selected,n=t.minDate,a=t.maxDate,s=e();return r?r:n&&n.isAfter(s)?n:a&&a.isSameOrBefore(s)?a:s}var s=r(33),i=n(s),o=r(36),l=n(o),u=r(29),c=n(u),p={nl:"Vandaag",fr:"Aujourd'hui",pl:"Dzisiaj",de:"Heute",en:"Today"},d=c.default.createClass({displayName:"Calendar",mixins:[r(35)],propTypes:{weekdays:c.default.PropTypes.array.isRequired,locale:c.default.PropTypes.string.isRequired,moment:c.default.PropTypes.func.isRequired,dateFormat:c.default.PropTypes.string.isRequired,onSelect:c.default.PropTypes.func.isRequired,handleClick:c.default.PropTypes.func.isRequired,minDate:c.default.PropTypes.object,maxDate:c.default.PropTypes.object,startDate:c.default.PropTypes.object,endDate:c.default.PropTypes.object,excludeDates:c.default.PropTypes.array,includeDates:c.default.PropTypes.array,filterDate:c.default.PropTypes.func,weekStart:c.default.PropTypes.string.isRequired,showYearDropdown:c.default.PropTypes.bool},handleClickOutside:function(t){this.props.handleClick(t)},getInitialState:function(){return{date:a(this.props)}},getDefaultProps:function(){return{weekStart:"1"}},componentWillMount:function(){this.initializeMomentLocale()},componentWillReceiveProps:function(t){null!==t.selected&&t.selected!==this.props.selected&&this.setState({date:t.selected})},initializeMomentLocale:function(){this.props.moment.locale(this.props.locale),this.setState({date:this.props.moment(this.state.date.toDate())})},increaseMonth:function(){this.setState({date:this.state.date.clone().add(1,"month")})},decreaseMonth:function(){this.setState({date:this.state.date.clone().subtract(1,"month")})},handleDayClick:function(t){this.props.onSelect(t)},changeYear:function(t){this.setState({date:this.state.date.clone().set("year",t)})},header:function(){var t=this.props.moment.weekdaysMin(),e=t[0];return t.shift(),e=t.concat(e),e.map(function(t,e){return c.default.createElement("div",{className:"datepicker__day",key:e},t)})},renderCurrentMonth:function(){var t=["datepicker__current-month"];return this.props.showYearDropdown&&t.push("datepicker__current-month--hasYearDropdown"),c.default.createElement("div",{className:t.join(" ")},this.state.date.format(this.props.dateFormat))},renderYearDropdown:function(){if(this.props.showYearDropdown)return c.default.createElement(i.default,{onChange:this.changeYear,year:this.state.date.year()})},renderTodayButton:function(){var t=this.props,e=t.moment,r=t.onSelect,n=t.locale;return c.default.createElement("div",{className:"datepicker__today-button",onClick:function(){return r(e())}},p[n])},render:function(){return c.default.createElement("div",{className:"datepicker",onClick:this.props.handleClick},c.default.createElement("div",{className:"datepicker__triangle"}),c.default.createElement("div",{className:"datepicker__header"},c.default.createElement("a",{className:"datepicker__navigation datepicker__navigation--previous",onClick:this.decreaseMonth}),this.renderCurrentMonth(),this.renderYearDropdown(),c.default.createElement("a",{className:"datepicker__navigation datepicker__navigation--next",onClick:this.increaseMonth}),c.default.createElement("div",null,this.header())),c.default.createElement(l.default,{day:this.state.date,onDayClick:this.handleDayClick,minDate:this.props.minDate,maxDate:this.props.maxDate,excludeDates:this.props.excludeDates,includeDates:this.props.includeDates,filterDate:this.props.filterDate,selected:this.props.selected,startDate:this.props.startDate,endDate:this.props.endDate}),c.default.createElement("div",null,this.renderTodayButton()))}});t.exports=d},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}var a=r(29),s=n(a),i=r(34),o=n(i),l=s.default.createClass({displayName:"YearDropdown",propTypes:{year:s.default.PropTypes.number.isRequired,onChange:s.default.PropTypes.func.isRequired},getInitialState:function(){return{dropdownVisible:!1}},renderReadView:function(){return s.default.createElement("div",{className:"datepicker__year-read-view",onClick:this.toggleDropdown},s.default.createElement("span",{className:"datepicker__year-read-view--selected-year"},this.props.year),s.default.createElement("span",{className:"datepicker__year-read-view--down-arrow"}))},renderDropdown:function(){return s.default.createElement(o.default,{ref:"options",year:this.props.year,onChange:this.onChange,onCancel:this.toggleDropdown})},onChange:function(t){this.toggleDropdown(),t!==this.props.year&&this.props.onChange(t)},toggleDropdown:function(){this.setState({dropdownVisible:!this.state.dropdownVisible})},render:function(){return s.default.createElement("div",null,this.state.dropdownVisible?this.renderDropdown():this.renderReadView())}});t.exports=l},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function a(t){for(var e=[],r=0;r<5;r++)e.push(t-r);return e}var s=r(29),i=n(s),o=i.default.createClass({displayName:"YearDropdownOptions",mixins:[r(35)],propTypes:{year:i.default.PropTypes.number.isRequired,onChange:i.default.PropTypes.func.isRequired,onCancel:i.default.PropTypes.func.isRequired},getInitialState:function(){return{yearsList:a(this.props.year)}},render:function(){return i.default.createElement("div",{className:"datepicker__year-dropdown"},this.renderOptions())},renderOptions:function(){var t=this,e=this.props.year,r=this.state.yearsList.map(function(r){return i.default.createElement("div",{className:"datepicker__year-option",key:r,onClick:t.onChange.bind(t,r)},e===r?i.default.createElement("span",{className:"datepicker__year-option--selected"},"✓"):"",r)});return r.unshift(i.default.createElement("div",{className:"datepicker__year-option",
	ref:"upcoming",key:"upcoming",onClick:this.incrementYears},i.default.createElement("a",{className:"datepicker__navigation datepicker__navigation--years datepicker__navigation--years-upcoming"}))),r.push(i.default.createElement("div",{className:"datepicker__year-option",ref:"previous",key:"previous",onClick:this.decrementYears},i.default.createElement("a",{className:"datepicker__navigation datepicker__navigation--years datepicker__navigation--years-previous"}))),r},onChange:function(t){this.props.onChange(t)},handleClickOutside:function(){this.props.onCancel()},shiftYears:function(t){var e=this.state.yearsList.map(function(e){return e+t});this.setState({yearsList:e})},incrementYears:function(){return this.shiftYears(4)},decrementYears:function(){return this.shiftYears(-4)}});t.exports=o},function(t,e){t.exports=n},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}var a=r(29),s=n(a),i=r(37),o=n(i),l=s.default.createClass({displayName:"Month",propTypes:{day:s.default.PropTypes.object.isRequired,onDayClick:s.default.PropTypes.func,minDate:s.default.PropTypes.object,maxDate:s.default.PropTypes.object,excludeDates:s.default.PropTypes.array,includeDates:s.default.PropTypes.array,filterDate:s.default.PropTypes.func,selected:s.default.PropTypes.object,startDate:s.default.PropTypes.object,endDate:s.default.PropTypes.object},handleDayClick:function(t){this.props.onDayClick&&this.props.onDayClick(t)},isWeekInMonth:function(t){var e=this.props.day,r=t.clone().add(6,"days");return t.isSame(e,"month")||r.isSame(e,"month")},renderWeeks:function(){var t=this,e=this.props.day.clone().startOf("month").startOf("week");return[0,1,2,3,4,5].map(function(t){return e.clone().add(t,"weeks")}).filter(function(e){return t.isWeekInMonth(e)}).map(function(e,r){return s.default.createElement(o.default,{key:r,day:e,month:t.props.day.month(),onDayClick:t.handleDayClick,minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,includeDates:t.props.includeDates,filterDate:t.props.filterDate,selected:t.props.selected,startDate:t.props.startDate,endDate:t.props.endDate})})},render:function(){return s.default.createElement("div",{className:"datepicker__month"},this.renderWeeks())}});t.exports=l},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}var a=r(29),s=n(a),i=r(38),o=n(i),l=s.default.createClass({displayName:"Week",propTypes:{day:s.default.PropTypes.object.isRequired,month:s.default.PropTypes.number,onDayClick:s.default.PropTypes.func,minDate:s.default.PropTypes.object,maxDate:s.default.PropTypes.object,excludeDates:s.default.PropTypes.array,includeDates:s.default.PropTypes.array,filterDate:s.default.PropTypes.func,selected:s.default.PropTypes.object,startDate:s.default.PropTypes.object,endDate:s.default.PropTypes.object},handleDayClick:function(t){this.props.onDayClick&&this.props.onDayClick(t)},renderDays:function(){var t=this,e=this.props.day.clone().startOf("week");return[0,1,2,3,4,5,6].map(function(r){var n=e.clone().add(r,"days");return s.default.createElement(o.default,{key:r,day:n,month:t.props.month,onClick:t.handleDayClick.bind(t,n),minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,includeDates:t.props.includeDates,filterDate:t.props.filterDate,selected:t.props.selected,startDate:t.props.startDate,endDate:t.props.endDate})})},render:function(){return s.default.createElement("div",{className:"datepicker__week"},this.renderDays())}});t.exports=l},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}var a=r(26),s=n(a),i=r(29),o=n(i),l=r(39),u=n(l),c=r(40),p=n(c),d=o.default.createClass({displayName:"Day",propTypes:{day:o.default.PropTypes.object.isRequired,month:o.default.PropTypes.number,onClick:o.default.PropTypes.func,minDate:o.default.PropTypes.object,maxDate:o.default.PropTypes.object,excludeDates:o.default.PropTypes.array,includeDates:o.default.PropTypes.array,filterDate:o.default.PropTypes.func,selected:o.default.PropTypes.object,startDate:o.default.PropTypes.object,endDate:o.default.PropTypes.object},handleClick:function(t){!this.isDisabled()&&this.props.onClick&&this.props.onClick(t)},isSameDay:function(t){return t&&this.props.day.isSame(t,"day")},isDisabled:function(){var t=this,e=this.props,r=e.day,n=e.minDate,a=e.maxDate,s=e.excludeDates,i=e.includeDates,o=e.filterDate;return n&&r.isBefore(n,"day")||a&&r.isAfter(a,"day")||(0,p.default)(s,function(e){return t.isSameDay(e)})||i&&!(0,p.default)(i,function(e){return t.isSameDay(e)})||o&&!o(r.clone())},isInRange:function(){var t=this.props,e=t.day,r=t.startDate,n=t.endDate;if(!r||!n)return!1;var a=r.clone().startOf("day").subtract(1,"seconds"),s=n.clone().startOf("day").add(1,"seconds");return e.clone().startOf("day").isBetween(a,s)},isWeekend:function(){var t=this.props.day.weekday();return 5===t||6===t},isOutsideMonth:function(){return void 0!==this.props.month&&this.props.month!==this.props.day.month()},getClassNames:function(){return(0,u.default)("datepicker__day",{"datepicker__day--disabled":this.isDisabled(),"datepicker__day--selected":this.isSameDay(this.props.selected),"datepicker__day--in-range":this.isInRange(),"datepicker__day--today":this.isSameDay((0,s.default)()),"datepicker__day--weekend":this.isWeekend(),"datepicker__day--outside-month":this.isOutsideMonth()})},render:function(){return o.default.createElement("div",{className:this.getClassNames(),onClick:this.handleClick},this.props.day.date())}});t.exports=d},function(t,e,r){var n,a;/*!
		  Copyright (c) 2017 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	!function(){"use strict";function r(){for(var t=[],e=0;e<arguments.length;e++){var n=arguments[e];if(n){var a=typeof n;if("string"===a||"number"===a)t.push(n);else if(Array.isArray(n)&&n.length){var i=r.apply(null,n);i&&t.push(i)}else if("object"===a)for(var o in n)s.call(n,o)&&n[o]&&t.push(o)}}return t.join(" ")}var s={}.hasOwnProperty;"undefined"!=typeof t&&t.exports?(r.default=r,t.exports=r):(n=[],a=function(){return r}.apply(e,n),!(void 0!==a&&(t.exports=a)))}()},function(t,e,r){function n(t,e,r){var n=o(t)?a:i;return r&&l(t,e,r)&&(e=void 0),"function"==typeof e&&void 0===r||(e=s(e,r,3)),n(t,e)}var a=r(5),s=r(41),i=r(57),o=r(20),l=r(63);t.exports=n},function(t,e,r){function n(t,e,r){var n=typeof t;return"function"==n?void 0===e?t:i(t,e,r):null==t?o:"object"==n?a(t):void 0===e?l(t):s(t,e)}var a=r(42),s=r(48),i=r(24),o=r(25),l=r(55);t.exports=n},function(t,e,r){function n(t){var e=s(t);if(1==e.length&&e[0][2]){var r=e[0][0],n=e[0][1];return function(t){return null!=t&&(t[r]===n&&(void 0!==n||r in i(t)))}}return function(t){return a(t,e)}}var a=r(43),s=r(45),i=r(44);t.exports=n},function(t,e,r){function n(t,e,r){var n=e.length,i=n,o=!r;if(null==t)return!i;for(t=s(t);n--;){var l=e[n];if(o&&l[2]?l[1]!==t[l[0]]:!(l[0]in t))return!1}for(;++n<i;){l=e[n];var u=l[0],c=t[u],p=l[1];if(o&&l[2]){if(void 0===c&&!(u in t))return!1}else{var d=r?r(c,p,u):void 0;if(!(void 0===d?a(p,c,r,!0):d))return!1}}return!0}var a=r(2),s=r(44);t.exports=n},function(t,e,r){function n(t){return a(t)?t:Object(t)}var a=r(12);t.exports=n},function(t,e,r){function n(t){for(var e=s(t),r=e.length;r--;)e[r][2]=a(e[r][1]);return e}var a=r(46),s=r(47);t.exports=n},function(t,e,r){function n(t){return t===t&&!a(t)}var a=r(12);t.exports=n},function(t,e,r){function n(t){t=s(t);for(var e=-1,r=a(t),n=r.length,i=Array(n);++e<n;){var o=r[e];i[e]=[o,t[o]]}return i}var a=r(8),s=r(44);t.exports=n},function(t,e,r){function n(t,e){var r=o(t),n=l(t)&&u(e),h=t+"";return t=d(t),function(o){if(null==o)return!1;var l=h;if(o=p(o),(r||!n)&&!(l in o)){if(o=1==t.length?o:a(o,i(t,0,-1)),null==o)return!1;l=c(t),o=p(o)}return o[l]===e?void 0!==e||l in o:s(e,o[l],void 0,!0)}}var a=r(49),s=r(2),i=r(50),o=r(20),l=r(51),u=r(46),c=r(52),p=r(44),d=r(53);t.exports=n},function(t,e,r){function n(t,e,r){if(null!=t){void 0!==r&&r in a(t)&&(e=[r]);for(var n=0,s=e.length;null!=t&&n<s;)t=t[e[n++]];return n&&n==s?t:void 0}}var a=r(44);t.exports=n},function(t,e){function r(t,e,r){var n=-1,a=t.length;e=null==e?0:+e||0,e<0&&(e=-e>a?0:a+e),r=void 0===r||r>a?a:+r||0,r<0&&(r+=a),a=e>r?0:r-e>>>0,e>>>=0;for(var s=Array(a);++n<a;)s[n]=t[n+e];return s}t.exports=r},function(t,e,r){function n(t,e){var r=typeof t;if("string"==r&&o.test(t)||"number"==r)return!0;if(a(t))return!1;var n=!i.test(t);return n||null!=e&&t in s(e)}var a=r(20),s=r(44),i=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,o=/^\w*$/;t.exports=n},function(t,e){function r(t){var e=t?t.length:0;return e?t[e-1]:void 0}t.exports=r},function(t,e,r){function n(t){if(s(t))return t;var e=[];return a(t).replace(i,function(t,r,n,a){e.push(n?a.replace(o,"$1"):r||t)}),e}var a=r(54),s=r(20),i=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g,o=/\\(\\)?/g;t.exports=n},function(t,e){function r(t){return null==t?"":t+""}t.exports=r},function(t,e,r){function n(t){return i(t)?a(t):s(t)}var a=r(16),s=r(56),i=r(51);t.exports=n},function(t,e,r){function n(t){var e=t+"";return t=s(t),function(r){return a(r,t,e)}}var a=r(49),s=r(53);t.exports=n},function(t,e,r){function n(t,e){var r;return a(t,function(t,n,a){return r=e(t,n,a),!r}),!!r}var a=r(58);t.exports=n},function(t,e,r){var n=r(59),a=r(62),s=a(n);t.exports=s},function(t,e,r){function n(t,e){return a(t,e,s)}var a=r(60),s=r(8);t.exports=n},function(t,e,r){var n=r(61),a=n();t.exports=a},function(t,e,r){function n(t){return function(e,r,n){for(var s=a(e),i=n(e),o=i.length,l=t?o:-1;t?l--:++l<o;){var u=i[l];if(r(s[u],u,s)===!1)break}return e}}var a=r(44);t.exports=n},function(t,e,r){function n(t,e){return function(r,n){var o=r?a(r):0;if(!s(o))return t(r,n);for(var l=e?o:-1,u=i(r);(e?l--:++l<o)&&n(u[l],l,u)!==!1;);return r}}var a=r(15),s=r(17),i=r(44);t.exports=n},function(t,e,r){function n(t,e,r){if(!i(r))return!1;var n=typeof e;if("number"==n?a(r)&&s(e,r.length):"string"==n&&e in r){var o=r[e];return t===t?t===o:o!==o}return!1}var a=r(14),s=r(21),i=r(12);t.exports=n},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}var a=r(29),s=n(a),i=r(28),o=n(i),l=s.default.createClass({displayName:"Popover",propTypes:{attachment:s.default.PropTypes.string,targetAttachment:s.default.PropTypes.string,targetOffset:s.default.PropTypes.string},getDefaultProps:function(){return{attachment:"top left",constraints:[{to:"window",attachment:"together"}],targetAttachment:"bottom left",targetOffset:"10px 0"}},componentWillMount:function(){var t=document.createElement("span");t.className="datepicker__container",this._popoverElement=t,document.querySelector("body").appendChild(this._popoverElement)},componentDidMount:function(){this._renderPopover()},componentDidUpdate:function(){this._renderPopover()},_popoverComponent:function(){var t=this.props.className;return s.default.createElement("div",{className:t},this.props.children)},_tetherOptions:function(){return{element:this._popoverElement,target:this.refs.span.parentElement.querySelector("input"),attachment:this.props.attachment,targetAttachment:this.props.targetAttachment,targetOffset:this.props.targetOffset,optimizations:{moveElement:!1},constraints:this.props.constraints}},_renderPopover:function(){if(o.default.render(this._popoverComponent(),this._popoverElement),null!=this._tether)this._tether.setOptions(this._tetherOptions());else if(window&&document){var t=r(65);this._tether=new t(this._tetherOptions())}},componentWillUnmount:function(){this._tether.destroy(),o.default.unmountComponentAtNode(this._popoverElement),this._popoverElement.parentNode&&this._popoverElement.parentNode.removeChild(this._popoverElement)},render:function(){return s.default.createElement("span",{ref:"span"})}});t.exports=l},function(t,e){t.exports=a}])});

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(46);
	
	var focusNode = __webpack_require__(726);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(253);
	var ExecutionEnvironment = __webpack_require__(67);
	var FallbackCompositionState = __webpack_require__(1975);
	var SyntheticCompositionEvent = __webpack_require__(2012);
	var SyntheticInputEvent = __webpack_require__(2015);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(836);
	var ExecutionEnvironment = __webpack_require__(67);
	var ReactInstrumentation = __webpack_require__(95);
	
	var camelizeStyleName = __webpack_require__(1642);
	var dangerousStyleValue = __webpack_require__(2021);
	var hyphenateStyleName = __webpack_require__(1649);
	var memoizeStringOnly = __webpack_require__(1652);
	var warning = __webpack_require__(35);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(252);
	var EventPropagators = __webpack_require__(253);
	var ExecutionEnvironment = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(104);
	var SyntheticEvent = __webpack_require__(122);
	
	var inputValueTracking = __webpack_require__(852);
	var getEventTarget = __webpack_require__(481);
	var isEventSupported = __webpack_require__(482);
	var isTextInputElement = __webpack_require__(854);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var DOMLazyTree = __webpack_require__(209);
	var ExecutionEnvironment = __webpack_require__(67);
	
	var createNodesFromMarkup = __webpack_require__(1645);
	var emptyFunction = __webpack_require__(93);
	var invariant = __webpack_require__(21);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(253);
	var ReactDOMComponentTree = __webpack_require__(46);
	var SyntheticMouseEvent = __webpack_require__(334);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(164);
	
	var getTextContentAccessor = __webpack_require__(851);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(210);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(211);
	
	var instantiateReactComponent = __webpack_require__(853);
	var KeyEscapeUtils = __webpack_require__(473);
	var shouldUpdateReactComponent = __webpack_require__(483);
	var traverseAllChildren = __webpack_require__(856);
	var warning = __webpack_require__(35);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","VERSION":"10.0-159-ge9cd7ea95","CLIENT":"","COOKIE_VERSION":"bd446f0a-08ae-41f0-8823-15e1acb0e459"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(896);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(469);
	var ReactDOMIDOperations = __webpack_require__(1985);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(36);
	
	var React = __webpack_require__(166);
	var ReactComponentEnvironment = __webpack_require__(475);
	var ReactCurrentOwner = __webpack_require__(123);
	var ReactErrorUtils = __webpack_require__(476);
	var ReactInstanceMap = __webpack_require__(254);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactNodeTypes = __webpack_require__(846);
	var ReactReconciler = __webpack_require__(211);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(307);
	var invariant = __webpack_require__(21);
	var shallowEqual = __webpack_require__(308);
	var shouldUpdateReactComponent = __webpack_require__(483);
	var warning = __webpack_require__(35);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDefaultInjection = __webpack_require__(1993);
	var ReactMount = __webpack_require__(845);
	var ReactReconciler = __webpack_require__(211);
	var ReactUpdates = __webpack_require__(104);
	var ReactVersion = __webpack_require__(2006);
	
	var findDOMNode = __webpack_require__(2022);
	var getHostComponentFromComposite = __webpack_require__(850);
	var renderSubtreeIntoContainer = __webpack_require__(2029);
	var warning = __webpack_require__(35);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(36);
	
	var AutoFocusUtils = __webpack_require__(1968);
	var CSSPropertyOperations = __webpack_require__(1970);
	var DOMLazyTree = __webpack_require__(209);
	var DOMNamespaces = __webpack_require__(470);
	var DOMProperty = __webpack_require__(210);
	var DOMPropertyOperations = __webpack_require__(838);
	var EventPluginHub = __webpack_require__(252);
	var EventPluginRegistry = __webpack_require__(471);
	var ReactBrowserEventEmitter = __webpack_require__(333);
	var ReactDOMComponentFlags = __webpack_require__(839);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDOMInput = __webpack_require__(1986);
	var ReactDOMOption = __webpack_require__(1987);
	var ReactDOMSelect = __webpack_require__(840);
	var ReactDOMTextarea = __webpack_require__(1990);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactMultiChild = __webpack_require__(1999);
	var ReactServerRenderingTransaction = __webpack_require__(2004);
	
	var emptyFunction = __webpack_require__(93);
	var escapeTextContentForBrowser = __webpack_require__(336);
	var invariant = __webpack_require__(21);
	var isEventSupported = __webpack_require__(482);
	var shallowEqual = __webpack_require__(308);
	var inputValueTracking = __webpack_require__(852);
	var validateDOMNesting = __webpack_require__(484);
	var warning = __webpack_require__(35);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(484);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var DOMLazyTree = __webpack_require__(209);
	var ReactDOMComponentTree = __webpack_require__(46);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(469);
	var ReactDOMComponentTree = __webpack_require__(46);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(36);
	
	var DOMPropertyOperations = __webpack_require__(838);
	var LinkedValueUtils = __webpack_require__(474);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(104);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(35);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var React = __webpack_require__(166);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDOMSelect = __webpack_require__(840);
	
	var warning = __webpack_require__(35);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var getNodeForCharacterOffset = __webpack_require__(2026);
	var getTextContentAccessor = __webpack_require__(851);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(36);
	
	var DOMChildrenOperations = __webpack_require__(469);
	var DOMLazyTree = __webpack_require__(209);
	var ReactDOMComponentTree = __webpack_require__(46);
	
	var escapeTextContentForBrowser = __webpack_require__(336);
	var invariant = __webpack_require__(21);
	var validateDOMNesting = __webpack_require__(484);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(36);
	
	var LinkedValueUtils = __webpack_require__(474);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(104);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(35);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactUpdates = __webpack_require__(104);
	var Transaction = __webpack_require__(335);
	
	var emptyFunction = __webpack_require__(93);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1967);
	var BeforeInputEventPlugin = __webpack_require__(1969);
	var ChangeEventPlugin = __webpack_require__(1971);
	var DefaultEventPluginOrder = __webpack_require__(1973);
	var EnterLeaveEventPlugin = __webpack_require__(1974);
	var HTMLDOMPropertyConfig = __webpack_require__(1976);
	var ReactComponentBrowserEnvironment = __webpack_require__(1978);
	var ReactDOMComponent = __webpack_require__(1981);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDOMEmptyComponent = __webpack_require__(1983);
	var ReactDOMTreeTraversal = __webpack_require__(1991);
	var ReactDOMTextComponent = __webpack_require__(1989);
	var ReactDefaultBatchingStrategy = __webpack_require__(1992);
	var ReactEventListener = __webpack_require__(1996);
	var ReactInjection = __webpack_require__(1997);
	var ReactReconcileTransaction = __webpack_require__(2002);
	var SVGDOMPropertyConfig = __webpack_require__(2007);
	var SelectEventPlugin = __webpack_require__(2008);
	var SimpleEventPlugin = __webpack_require__(2009);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1994 */
897,
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(252);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var EventListener = __webpack_require__(725);
	var ExecutionEnvironment = __webpack_require__(67);
	var PooledClass = __webpack_require__(164);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(104);
	
	var getEventTarget = __webpack_require__(481);
	var getUnboundedScrollPosition = __webpack_require__(1647);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(210);
	var EventPluginHub = __webpack_require__(252);
	var EventPluginUtils = __webpack_require__(472);
	var ReactComponentEnvironment = __webpack_require__(475);
	var ReactEmptyComponent = __webpack_require__(841);
	var ReactBrowserEventEmitter = __webpack_require__(333);
	var ReactHostComponent = __webpack_require__(843);
	var ReactUpdates = __webpack_require__(104);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(2020);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactComponentEnvironment = __webpack_require__(475);
	var ReactInstanceMap = __webpack_require__(254);
	var ReactInstrumentation = __webpack_require__(95);
	
	var ReactCurrentOwner = __webpack_require__(123);
	var ReactReconciler = __webpack_require__(211);
	var ReactChildReconciler = __webpack_require__(1977);
	
	var emptyFunction = __webpack_require__(93);
	var flattenChildren = __webpack_require__(2023);
	var invariant = __webpack_require__(21);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var CallbackQueue = __webpack_require__(837);
	var PooledClass = __webpack_require__(164);
	var ReactBrowserEventEmitter = __webpack_require__(333);
	var ReactInputSelection = __webpack_require__(844);
	var ReactInstrumentation = __webpack_require__(95);
	var Transaction = __webpack_require__(335);
	var ReactUpdateQueue = __webpack_require__(477);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(2000);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(164);
	var Transaction = __webpack_require__(335);
	var ReactInstrumentation = __webpack_require__(95);
	var ReactServerUpdateQueue = __webpack_require__(2005);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(477);
	
	var warning = __webpack_require__(35);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(253);
	var ExecutionEnvironment = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactInputSelection = __webpack_require__(844);
	var SyntheticEvent = __webpack_require__(122);
	
	var getActiveElement = __webpack_require__(727);
	var isTextInputElement = __webpack_require__(854);
	var shallowEqual = __webpack_require__(308);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var EventListener = __webpack_require__(725);
	var EventPropagators = __webpack_require__(253);
	var ReactDOMComponentTree = __webpack_require__(46);
	var SyntheticAnimationEvent = __webpack_require__(2010);
	var SyntheticClipboardEvent = __webpack_require__(2011);
	var SyntheticEvent = __webpack_require__(122);
	var SyntheticFocusEvent = __webpack_require__(2014);
	var SyntheticKeyboardEvent = __webpack_require__(2016);
	var SyntheticMouseEvent = __webpack_require__(334);
	var SyntheticDragEvent = __webpack_require__(2013);
	var SyntheticTouchEvent = __webpack_require__(2017);
	var SyntheticTransitionEvent = __webpack_require__(2018);
	var SyntheticUIEvent = __webpack_require__(255);
	var SyntheticWheelEvent = __webpack_require__(2019);
	
	var emptyFunction = __webpack_require__(93);
	var getEventCharCode = __webpack_require__(479);
	var invariant = __webpack_require__(21);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(122);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(122);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(122);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(334);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(255);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(122);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(255);
	
	var getEventCharCode = __webpack_require__(479);
	var getEventKey = __webpack_require__(2024);
	var getEventModifierState = __webpack_require__(480);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(255);
	
	var getEventModifierState = __webpack_require__(480);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(122);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(334);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(836);
	var warning = __webpack_require__(35);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(123);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactInstanceMap = __webpack_require__(254);
	
	var getHostComponentFromComposite = __webpack_require__(850);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(35);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(473);
	var traverseAllChildren = __webpack_require__(856);
	var warning = __webpack_require__(35);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","VERSION":"10.0-159-ge9cd7ea95","CLIENT":"","COOKIE_VERSION":"bd446f0a-08ae-41f0-8823-15e1acb0e459"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(896);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(479);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(336);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(845);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2034);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(2032);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ReactComponentWithPureRenderMixin = __webpack_require__(2139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint "react/no-did-mount-set-state":0 */
	/* eslint "react/no-did-update-set-state":0 */
	
	var getElementHeight = function getElementHeight(el) {
	  return el.clientHeight;
	};
	
	var ReactHeight = (0, _createReactClass2.default)({
	  propTypes: {
	    children: _propTypes2.default.node.isRequired,
	    onHeightReady: _propTypes2.default.func.isRequired,
	    hidden: _propTypes2.default.bool,
	    dirty: _propTypes2.default.bool,
	    getElementHeight: _propTypes2.default.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hidden: false,
	      dirty: true,
	      getElementHeight: getElementHeight
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      height: 0, dirty: this.props.dirty
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var height = this.props.getElementHeight(this.wrapper);
	    var dirty = false;
	
	    this.setState({ height: height, dirty: dirty }, function () {
	      return _this.props.onHeightReady(_this.state.height);
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var children = _ref.children,
	        dirty = _ref.dirty;
	
	    if (children !== this.props.children || dirty) {
	      this.setState({ dirty: true });
	    }
	  },
	
	
	  shouldComponentUpdate: _ReactComponentWithPureRenderMixin.shouldComponentUpdate,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var _this2 = this;
	
	    var height = this.props.getElementHeight(this.wrapper);
	    var dirty = false;
	
	    if (height === this.state.height) {
	      this.setState({ dirty: dirty });
	    } else {
	      this.setState({ height: height, dirty: dirty }, function () {
	        return _this2.props.onHeightReady(_this2.state.height);
	      });
	    }
	  },
	  setWrapperRef: function setWrapperRef(el) {
	    this.wrapper = el;
	  },
	  render: function render() {
	    var _props = this.props,
	        _onHeightReady = _props.onHeightReady,
	        _getElementHeight = _props.getElementHeight,
	        _dirty = _props.dirty,
	        hidden = _props.hidden,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['onHeightReady', 'getElementHeight', 'dirty', 'hidden', 'children']);
	
	    var dirty = this.state.dirty;
	
	
	    if (hidden && !dirty) {
	      return null;
	    }
	
	    if (hidden) {
	      return _react2.default.createElement(
	        'div',
	        { style: { height: 0, overflow: 'hidden' } },
	        _react2.default.createElement(
	          'div',
	          _extends({ ref: this.setWrapperRef }, props),
	          children
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ ref: this.setWrapperRef }, props),
	      children
	    );
	  }
	});
	
	exports.default = ReactHeight;
	//# sourceMappingURL=ReactHeight.js.map

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var emptyObject = __webpack_require__(307);
	var _invariant = __webpack_require__(21);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @nosideeffects
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function (Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function (Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function (Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	    },
	    contextTypes: function (Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function (Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function (Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function (Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function () {} };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	      }
	
	      return;
	    }
	
	    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	        } else if (!args.length) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedMixin = {
	    componentDidMount: function () {
	      this.__isMounted = true;
	    },
	    componentWillUnmount: function () {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function (newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function () {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function () {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedMixin);
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(2031);
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(93);
	var invariant = __webpack_require__(21);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2033)();
	}


/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(2097);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(2038);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _objectAssign = __webpack_require__(36);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(2036);
	
	var _PlainComponent = __webpack_require__(2037);
	
	var _PlainComponent2 = _interopRequireDefault(_PlainComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props[property]) {
	            return props[property];
	        }
	    }
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");
	
	    return innermostTitle || innermostDefaultTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        return typeof props[tagName] !== "undefined";
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    document.title = title || document.title;
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var htmlTag = document.getElementsByTagName(tagName)[0];
	    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	        htmlTag.setAttribute(attribute, value);
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        htmlTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else {
	        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === "innerHTML") {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === "cssText") {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
	    var attributeString = generateHtmlAttributesAsString(attributes);
	    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === "innerHTML" || attribute === "cssText");
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;
	
	        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    // assigning into an array to define toString function on it
	    var initProps = _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true);
	    var props = Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
	                }
	            };
	        case _HelmetConstants.TAG_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return tags;
	                },
	                toString: function toString() {
	                    return generateHtmlAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var htmlAttributes = _ref.htmlAttributes,
	        title = _ref.title,
	        titleAttributes = _ref.titleAttributes,
	        baseTag = _ref.baseTag,
	        metaTags = _ref.metaTags,
	        linkTags = _ref.linkTags,
	        scriptTags = _ref.scriptTags,
	        noscriptTags = _ref.noscriptTags,
	        styleTags = _ref.styleTags;
	    return {
	        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
	        }
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2.default)(this.props, nextProps);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2.default.createElement(Component, this.props);
	            }
	        }], [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	            /**
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {String} title: "Title"
	             * @param {String} defaultTitle: "Default Title"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             */
	
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        htmlAttributes: _react2.default.PropTypes.object,
	        title: _react2.default.PropTypes.string,
	        defaultTitle: _react2.default.PropTypes.string,
	        titleTemplate: _react2.default.PropTypes.string,
	        titleAttributes: _react2.default.PropTypes.object,
	        base: _react2.default.PropTypes.object,
	        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        onChangeClientState: _react2.default.PropTypes.func
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = mapStateOnServer({
	                htmlAttributes: {},
	                title: "",
	                titleAttributes: {},
	                baseTag: [],
	                metaTags: [],
	                linkTags: [],
	                scriptTags: [],
	                noscriptTags: [],
	                styleTags: []
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        onChangeClientState: getOnChangeClientState(propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var htmlAttributes = newState.htmlAttributes,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes,
	        baseTag = newState.baseTag,
	        metaTags = newState.metaTags,
	        linkTags = newState.linkTags,
	        scriptTags = newState.scriptTags,
	        noscriptTags = newState.noscriptTags,
	        styleTags = newState.styleTags,
	        onChangeClientState = newState.onChangeClientState;
	
	
	    updateAttributes("html", htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(_PlainComponent2.default);
	
	exports.default = Helmet(HelmetSideEffects);
	module.exports = exports["default"];

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var TAG_NAMES = exports.TAG_NAMES = {
	    HTML: "htmlAttributes",
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script",
	    NOSCRIPT: "noscript",
	    STYLE: "style"
	};
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src",
	    INNER_HTML: "innerHTML",
	    CSS_TEXT: "cssText",
	    ITEM_PROP: "itemprop"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv",
	    "itemprop": "itemProp",
	    "class": "className"
	};

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlainComponent = function (_React$Component) {
	    _inherits(PlainComponent, _React$Component);
	
	    function PlainComponent() {
	        _classCallCheck(this, PlainComponent);
	
	        return _possibleConstructorReturn(this, (PlainComponent.__proto__ || Object.getPrototypeOf(PlainComponent)).apply(this, arguments));
	    }
	
	    _createClass(PlainComponent, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PlainComponent;
	}(_react2.default.Component);
	
	exports.default = PlainComponent;
	module.exports = exports["default"];

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(2040);
	var isArguments = __webpack_require__(2039);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 2039 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 2040 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(339);
	
	var store = _interopRequireWildcard(_store);
	
	var _event_handlers = __webpack_require__(861);
	
	var _keys = __webpack_require__(338);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module componentWrapper
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * componentWrapper
	 *
	 * @access public
	 * @param {object} WrappedComponent React component class to be wrapped
	 * @param {array} [keys] The key(s) bound to the class
	 * @return {object} The higher-order function that wraps the decorated class
	 */
	function componentWrapper(WrappedComponent) {
	  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _keys.ALL_KEYS;
	
	  var KeyBoardHelper = function (_React$Component) {
	    _inherits(KeyBoardHelper, _React$Component);
	
	    function KeyBoardHelper(props) {
	      _classCallCheck(this, KeyBoardHelper);
	
	      var _this = _possibleConstructorReturn(this, (KeyBoardHelper.__proto__ || Object.getPrototypeOf(KeyBoardHelper)).call(this, props));
	
	      _this.state = {
	        event: null
	      };
	      return _this;
	    }
	
	    _createClass(KeyBoardHelper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        (0, _event_handlers.onMount)(this);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        (0, _event_handlers.onUnmount)(this);
	      }
	    }, {
	      key: 'handleKeyDown',
	      value: function handleKeyDown(event) {
	        var _this2 = this;
	
	        // to simulate a keypress, set the event and then clear it in the callback
	        this.setState({ event: event }, function () {
	          return _this2.setState({ event: null });
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { keydown: this.state }));
	      }
	    }]);
	
	    return KeyBoardHelper;
	  }(_react2.default.Component);
	
	  store.setBinding({ keys: [].concat(keys), fn: KeyBoardHelper.prototype.handleKeyDown, target: KeyBoardHelper.prototype });
	
	  return KeyBoardHelper;
	}
	
	exports.default = componentWrapper;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.keydownScoped = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * @module decorators
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               */
	
	
	var _class_decorator = __webpack_require__(2043);
	
	var _class_decorator2 = _interopRequireDefault(_class_decorator);
	
	var _method_decorator = __webpack_require__(2045);
	
	var _method_decorator2 = _interopRequireDefault(_method_decorator);
	
	var _method_decorator_scoped = __webpack_require__(2046);
	
	var _method_decorator_scoped2 = _interopRequireDefault(_method_decorator_scoped);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * noopDecorator
	 *
	 * @access private
	 * @return {undefined} Returns `undefined` so that the original undecorated instance/method is used
	 */
	function noopDecorator() {
	  return undefined;
	}
	
	/**
	 * _decorator
	 *
	 * @access private
	 * @param {Function} methodFn The method wrapper to delegate to, based on whether user has specified a scoped decorator or not
	 * @param {Array} ...args Remainder of arguments passed in
	 * @return {Function} The decorated class or method
	 */
	function _decorator(methodFn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  // check the first argument to see if it's a user-supplied keycode or array
	  // of keycodes, or if it's the wrapped class or method
	  var testArg = args[0];
	  var isArray = Array.isArray(testArg);
	
	  // if the test argument is not an object or function, it is user-supplied
	  // keycodes. else there are no arguments and it's just the wrapped class
	  if (isArray || ~['string', 'number', 'symbol'].indexOf(typeof testArg === 'undefined' ? 'undefined' : _typeof(testArg))) {
	    var keys = isArray ? testArg : args;
	
	    // return the decorator function, which on the next call will look for
	    // the presence of a method name to determine if this is a wrapped method
	    // or component
	    return function (target, methodName, descriptor) {
	      return methodName ? methodFn({ target: target, descriptor: descriptor, keys: keys }) : (0, _class_decorator2.default)(target, keys);
	    };
	  } else {
	    var WrappedComponent = args[0];
	    var methodName = args[1];
	
	    // method decorators without keycode (which) arguments are not allowed.
	    if (WrappedComponent && !methodName) {
	      return _class_decorator2.default.apply(undefined, args);
	    } else {
	      console.warn(methodName + ': Method decorators must have keycode arguments, so the decorator for this method will not do anything');
	      return noopDecorator;
	    }
	  }
	}
	
	/**
	 * keydownScoped
	 *
	 * Method decorator that will look for changes to its targeted component's
	 * `keydown` props to decide when to trigger, rather than responding directly
	 * to keydown events. This lets you specify a @keydown decorated class higher
	 * up in the view hierarchy for larger scoping of keydown events, or for
	 * programmatically sending keydown events as props into the components in order
	 * to trigger decorated methods with matching keys.
	 *
	 * @access public
	 * @param {Array} ...args  All (or no) arguments passed in from decoration
	 * @return {Function} The decorated class or method
	 */
	function keydownScoped() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return _decorator.apply(undefined, [_method_decorator_scoped2.default].concat(args));
	}
	
	/**
	 * keydown
	 *
	 * The main decorator and default export, handles both classes and methods.
	 *
	 * @access public
	 * @param {Array} ...args  All (or no) arguments passed in from decoration
	 * @return {Function} The decorated class or method
	 */
	function keydown() {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  return _decorator.apply(undefined, [_method_decorator2.default].concat(args));
	}
	
	exports.default = keydown;
	exports.keydownScoped = keydownScoped;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * @module methodWrapper
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               */
	
	
	var _store = __webpack_require__(339);
	
	var store = _interopRequireWildcard(_store);
	
	var _event_handlers = __webpack_require__(861);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * _isReactKeyDown
	 *
	 * @access private
	 * @param {object} event The possibly synthetic event passed as an argument with
	 * the method invocation.
	 * @return {boolean}
	 */
	function _isReactKeyDown(event) {
	  return event && (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' && event.nativeEvent instanceof window.KeyboardEvent && event.type === 'keydown';
	}
	
	/**
	 * methodWrapper
	 *
	 * @access public
	 * @param {object} args All arguments necessary for wrapping method
	 * @param {object} args.target The decorated class
	 * @param {object} args.descriptor Method descriptor
	 * @param {array} args.keys The array of keys bound to the given method
	 * @return {object} The method descriptor
	 */
	function methodWrapper(_ref) {
	  var target = _ref.target,
	      descriptor = _ref.descriptor,
	      keys = _ref.keys;
	
	
	  var fn = descriptor.value;
	
	  // if we haven't already created a binding for this class (via another
	  // decorated method), wrap these lifecycle methods.
	  if (!store.getBinding(target)) {
	    var componentDidMount = target.componentDidMount,
	        componentWillUnmount = target.componentWillUnmount;
	
	
	    target.componentDidMount = function () {
	      (0, _event_handlers.onMount)(this);
	      if (componentDidMount) return componentDidMount.call(this);
	    };
	
	    target.componentWillUnmount = function () {
	      (0, _event_handlers.onUnmount)(this);
	      if (componentWillUnmount) return componentWillUnmount.call(this);
	    };
	  }
	
	  // add this binding of keys and method to the target's bindings
	  store.setBinding({ keys: keys, target: target, fn: fn });
	
	  descriptor.value = function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var maybeEvent = args[0];
	
	    if (_isReactKeyDown(maybeEvent)) {
	      // proxy method in order to use @keydown as filter for keydown events coming
	      // from an actual onKeyDown binding (as identified by react's addition of
	      // 'nativeEvent' + type === 'keydown')
	      if (!maybeEvent.ctrlKey) {
	        // we already whitelist shortcuts with ctrl modifiers so if we were to
	        // fire it again here the method would trigger twice. see https://github.com/glortho/react-keydown/issues/38
	        return (0, _event_handlers._onKeyDown)(maybeEvent, true);
	      }
	    } else if (!maybeEvent || !(maybeEvent instanceof window.KeyboardEvent) || maybeEvent.type !== 'keydown') {
	      // if our first argument is a keydown event it is being handled by our
	      // binding system. if it's anything else, just pass through.
	      return fn.call.apply(fn, [this].concat(args));
	    }
	  };
	
	  return descriptor;
	}
	
	exports.default = methodWrapper;

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _match_keys = __webpack_require__(862);
	
	var _match_keys2 = _interopRequireDefault(_match_keys);
	
	var _parse_keys = __webpack_require__(863);
	
	var _parse_keys2 = _interopRequireDefault(_parse_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * methodWrapperScoped
	 *
	 * @access public
	 * @param {object} args All args necessary for decorating the method
	 * @param {object} args.target The decorated method's class object
	 * @param {object} args.descriptor The method's descriptor object
	 * @param {array} args.keys The key codes bound to the decorated method
	 * @return {object} The method's descriptor object
	 */
	/**
	 * @module methodWrapperScoped
	 *
	 */
	function methodWrapperScoped(_ref) {
	  var target = _ref.target,
	      descriptor = _ref.descriptor,
	      keys = _ref.keys;
	  var componentWillReceiveProps = target.componentWillReceiveProps;
	
	  var fn = descriptor.value;
	  if (!keys) {
	    console.warn(fn + ': keydownScoped requires one or more keys');
	  } else {
	
	    /**
	     * _shouldTrigger
	     *
	     * @access private
	     * @param {object} thisProps Exsting props from the wrapped component
	     * @param {object} thisProps.keydown The namespaced state from the higher-order
	     * component (class_decorator)
	     * @param {object} nextProps The incoming props from the wrapped component
	     * @param {object} nextProps.keydown The namescaped state from the higher-order
	     * component (class_decorator)
	     * @param {array} keys The keys bound to the decorated method
	     * @return {boolean} Whether all tests have passed
	     */
	    var _shouldTrigger = function _shouldTrigger(keydownThis, keydownNext) {
	      if (!(keydownNext && keydownNext.event && !keydownThis.event)) return false;
	
	      return keySets.some(function (keySet) {
	        return (0, _match_keys2.default)({ keySet: keySet, event: keydownNext.event });
	      });
	    };
	
	    // wrap the component's lifecycle method to intercept key codes coming down
	    // from the wrapped/scoped component up the view hierarchy. if new keydown
	    // event has arrived and the key codes match what was specified in the
	    // decorator, call the wrapped method.
	
	
	    var keySets = (0, _parse_keys2.default)(keys);target.componentWillReceiveProps = function (nextProps) {
	      var keydownNext = nextProps.keydown;
	      var keydownThis = this.props.keydown;
	
	
	      if (_shouldTrigger(keydownThis, keydownNext)) {
	        return fn.call(this, keydownNext.event);
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (componentWillReceiveProps) return componentWillReceiveProps.call.apply(componentWillReceiveProps, [this, nextProps].concat(args));
	    };
	  }
	
	  return descriptor;
	}
	
	exports.default = methodWrapperScoped;

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALL_PRINTABLE_KEYS = exports.ALL_KEYS = exports.Keys = exports.setBinding = exports.keydownScoped = exports.default = undefined;
	
	var _decorators = __webpack_require__(2044);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_decorators).default;
	  }
	});
	Object.defineProperty(exports, 'keydownScoped', {
	  enumerable: true,
	  get: function get() {
	    return _decorators.keydownScoped;
	  }
	});
	
	var _store = __webpack_require__(339);
	
	Object.defineProperty(exports, 'setBinding', {
	  enumerable: true,
	  get: function get() {
	    return _store.setBinding;
	  }
	});
	
	var _keys = __webpack_require__(338);
	
	Object.defineProperty(exports, 'Keys', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_keys).default;
	  }
	});
	Object.defineProperty(exports, 'ALL_KEYS', {
	  enumerable: true,
	  get: function get() {
	    return _keys.ALL_KEYS;
	  }
	});
	Object.defineProperty(exports, 'ALL_PRINTABLE_KEYS', {
	  enumerable: true,
	  get: function get() {
	    return _keys.ALL_PRINTABLE_KEYS;
	  }
	});
	
	__webpack_require__(2048);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

	'use strict';
	
	// Production steps of ECMA-262, Edition 6, 22.1.2.1
	// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
	if (!Array.from) {
	  Array.from = function () {
	    var toStr = Object.prototype.toString;
	    var isCallable = function isCallable(fn) {
	      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
	    };
	    var toInteger = function toInteger(value) {
	      var number = Number(value);
	      if (isNaN(number)) {
	        return 0;
	      }
	      if (number === 0 || !isFinite(number)) {
	        return number;
	      }
	      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
	    };
	    var maxSafeInteger = Math.pow(2, 53) - 1;
	    var toLength = function toLength(value) {
	      var len = toInteger(value);
	      return Math.min(Math.max(len, 0), maxSafeInteger);
	    };
	
	    // The length property of the from method is 1.
	    return function from(arrayLike /*, mapFn, thisArg */) {
	      // 1. Let C be the this value.
	      var C = this;
	
	      // 2. Let items be ToObject(arrayLike).
	      var items = Object(arrayLike);
	
	      // 3. ReturnIfAbrupt(items).
	      if (arrayLike == null) {
	        throw new TypeError("Array.from requires an array-like object - not null or undefined");
	      }
	
	      // 4. If mapfn is undefined, then let mapping be false.
	      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
	      var T;
	      if (typeof mapFn !== 'undefined') {
	        // 5. else
	        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
	        if (!isCallable(mapFn)) {
	          throw new TypeError('Array.from: when provided, the second argument must be a function');
	        }
	
	        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
	        if (arguments.length > 2) {
	          T = arguments[2];
	        }
	      }
	
	      // 10. Let lenValue be Get(items, "length").
	      // 11. Let len be ToLength(lenValue).
	      var len = toLength(items.length);
	
	      // 13. If IsConstructor(C) is true, then
	      // 13. a. Let A be the result of calling the [[Construct]] internal method 
	      // of C with an argument list containing the single item len.
	      // 14. a. Else, Let A be ArrayCreate(len).
	      var A = isCallable(C) ? Object(new C(len)) : new Array(len);
	
	      // 16. Let k be 0.
	      var k = 0;
	      // 17. Repeat, while k < len… (also steps a - h)
	      var kValue;
	      while (k < len) {
	        kValue = items[k];
	        if (mapFn) {
	          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
	        } else {
	          A[k] = kValue;
	        }
	        k += 1;
	      }
	      // 18. Let putStatus be Put(A, "length", len, true).
	      A.length = len;
	      // 20. Return A.
	      return A;
	    };
	  }();
	}

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(45);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusableSelector = 'a[href], button, input, object, select, textarea, [tabindex]';
	
	/**
	 * bindFocusables: Find any focusable child elements of the component instance and
	 * add an onFocus handler to focus our keydown handlers on the parent component
	 * when user keys applies focus to the element.
	 *
	 * NOTE: One limitation of this right now is that if you tab out of the
	 * component, _focusedInstance will still be set until next click or mount or
	 * controlled focus.
	 *
	 * @access public
	 * @param {object} instance The key-bound component instance
	 * @param {callback} activateOnFocus The fn to fire when element is focused
	 */
	/**
	 * @module domHelpers
	 *
	 */
	function bindFocusables(instance, activateOnFocus) {
	  if (document.querySelectorAll) {
	    try {
	      var node = _reactDom2.default.findDOMNode(instance);
	      if (node) {
	        var focusables = node.querySelectorAll(focusableSelector);
	        if (focusables.length) {
	          var onFocus = function onFocus(element) {
	            var onFocusPrev = element.onfocus;
	            return function (event) {
	              activateOnFocus(instance);
	              if (onFocusPrev) onFocusPrev.call(element, event);
	            };
	          };
	          Array.prototype.slice.call(focusables).forEach(function (element) {
	            return element.onfocus = onFocus(element);
	          });
	        }
	      }
	    } catch (error) {
	      // noop, mostly suppressing error here https://github.com/glortho/react-keydown/issues/76
	    }
	  }
	}
	
	/**
	 * findContainerNodes: Called by our click handler to find instances with nodes
	 * that are equal to or that contain the click target. Any that pass this test
	 * will be recipients of the next keydown event.
	 *
	 * @access public
	 * @param {object} target The click event.target DOM element
	 * @return {function} Reducer function
	 */
	function findContainerNodes(target) {
	  return function (memo, instance) {
	    try {
	      var node = _reactDom2.default.findDOMNode(instance);
	      if (node && (node === target || node.contains(target))) {
	        memo.push({ instance: instance, node: node });
	      }
	    } finally {
	      return memo;
	    }
	  };
	}
	
	/**
	 * sortByDOMPosition: Called by our click handler to sort a list of instances
	 * according to least -> most nested. This is so that if multiple keybound
	 * instances have nodes that are ancestors of the click target, they will be
	 * sorted to let the instance closest to the click target get first dibs on the
	 * next key down event.
	 */
	function sortByDOMPosition(a, b) {
	  return a.node.compareDocumentPosition(b.node) === 10 ? 1 : -1;
	}
	
	exports.default = { bindFocusables: bindFocusables, findContainerNodes: findContainerNodes, sortByDOMPosition: sortByDOMPosition };

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @module Listeners
	 *
	 */
	
	// flag for whether click listener has been bound to document
	var _clicksBound = false;
	
	// flag for whether keydown listener has been bound to document
	var _keysBound = false;
	
	var Listeners = {
	  /**
	   * _bindKeys
	   *
	   * @access public
	   */
	  bindKeys: function bindKeys(callback) {
	    if (!_keysBound) {
	      document.addEventListener('keydown', callback);
	      _keysBound = true;
	    }
	  },
	
	
	  /**
	   * unbindKeys
	   *
	   * @access public
	   */
	  unbindKeys: function unbindKeys(callback) {
	    if (_keysBound) {
	      document.removeEventListener('keydown', callback);
	      _keysBound = false;
	    }
	  },
	
	
	  /**
	   * bindClicks
	   *
	   * @access public
	   */
	  bindClicks: function bindClicks(callback) {
	    if (!_clicksBound) {
	      document.addEventListener('click', callback, true);
	      _clicksBound = true;
	    }
	  },
	
	
	  /**
	   * unbindClicks
	   *
	   * @access public
	   */
	  unbindClicks: function unbindClicks(callback) {
	    if (_clicksBound) {
	      document.removeEventListener('click', callback, true);
	      _clicksBound = false;
	    }
	  }
	};
	
	exports.default = Listeners;

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = uuid;
	// Counter being incremented. JS is single-threaded, so it'll Just Work™.
	var __counter = 1;
	
	/**
	 * Returns a process-wide unique identifier.
	 */
	function uuid() {
	  return "uid-" + __counter++;
	}

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _deepEqual = __webpack_require__(709);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function intersects(array1, array2) {
	  return !!(array1 && array2 && array1.some(function (item) {
	    return ~array2.indexOf(item);
	  }));
	}
	
	var LazyCache = (function () {
	  function LazyCache(component, calculators) {
	    var _this = this;
	
	    _classCallCheck(this, LazyCache);
	
	    this.component = component;
	    this.allProps = [];
	    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
	      var _extends2;
	
	      var calculator = calculators[key];
	      var fn = calculator.fn;
	      var paramNames = calculator.params;
	      paramNames.forEach(function (param) {
	        if (! ~_this.allProps.indexOf(param)) {
	          _this.allProps.push(param);
	        }
	      });
	      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
	        value: undefined,
	        props: paramNames,
	        fn: fn
	      }, _extends2));
	    }, {});
	  }
	
	  LazyCache.prototype.get = function get(key) {
	    var component = this.component;
	    var _cache$key = this.cache[key];
	    var value = _cache$key.value;
	    var fn = _cache$key.fn;
	    var props = _cache$key.props;
	
	    if (value !== undefined) {
	      return value;
	    }
	    var params = props.map(function (prop) {
	      return component.props[prop];
	    });
	    var result = fn.apply(undefined, params);
	    this.cache[key].value = result;
	    return result;
	  };
	
	  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var component = this.component;
	
	    var diffProps = [];
	    this.allProps.forEach(function (prop) {
	      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
	        diffProps.push(prop);
	      }
	    });
	    if (diffProps.length) {
	      Object.keys(this.cache).forEach(function (key) {
	        if (intersects(diffProps, _this2.cache[key].props)) {
	          delete _this2.cache[key].value; // uncache value
	        }
	      });
	    }
	  };
	
	  return LazyCache;
	})();
	
	exports['default'] = LazyCache;
	module.exports = exports['default'];

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2052);


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _resizeDetector = __webpack_require__(2056);
	
	var _resizeDetector2 = _interopRequireDefault(_resizeDetector);
	
	var _getNodeDimensions = __webpack_require__(1664);
	
	var _getNodeDimensions2 = _interopRequireDefault(_getNodeDimensions);
	
	var Measure = (function (_Component) {
	  _inherits(Measure, _Component);
	
	  _createClass(Measure, null, [{
	    key: 'propTypes',
	    value: {
	      accurate: _react.PropTypes.bool,
	      whitelist: _react.PropTypes.array,
	      blacklist: _react.PropTypes.array,
	      shouldMeasure: _react.PropTypes.bool,
	      onMeasure: _react.PropTypes.func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      accurate: false,
	      whitelist: ['width', 'height', 'top', 'right', 'bottom', 'left'],
	      blacklist: [],
	      shouldMeasure: true,
	      onMeasure: function onMeasure() {
	        return null;
	      }
	    },
	    enumerable: true
	  }]);
	
	  function Measure(props) {
	    var _this = this;
	
	    _classCallCheck(this, Measure);
	
	    _get(Object.getPrototypeOf(Measure.prototype), 'constructor', this).call(this, props);
	
	    this.measure = function () {
	      var accurate = arguments.length <= 0 || arguments[0] === undefined ? _this.props.accurate : arguments[0];
	
	      // bail out if we shouldn't measure
	      if (!_this.props.shouldMeasure) return;
	
	      var dimensions = _this.getDimensions(_this._node, accurate);
	      var isChildFunction = typeof _this.props.children === 'function';
	
	      // determine if we need to update our callback with new dimensions or not
	      _this._propsToMeasure.some(function (prop) {
	        if (dimensions[prop] !== _this._lastDimensions[prop]) {
	          // update our callback if we've found a dimension that has changed
	          _this.props.onMeasure(dimensions);
	
	          // update state to send dimensions to child function
	          if (isChildFunction) {
	            _this.setState({ dimensions: dimensions });
	          }
	
	          // store last dimensions to compare changes
	          _this._lastDimensions = dimensions;
	
	          // we don't need to look any further, bail out
	          return true;
	        }
	      });
	    };
	
	    this.state = {
	      dimensions: {}
	    };
	    this._node = null;
	    this._propsToMeasure = this._getPropsToMeasure(props);
	    this._lastDimensions = {};
	  }
	
	  _createClass(Measure, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this._node = _reactDom2['default'].findDOMNode(this);
	
	      // measure on first render
	      this.measure();
	
	      // add component to resize detector to detect changes on resize
	      (0, _resizeDetector2['default'])().listenTo(this._node, function () {
	        return _this2.measure();
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var config = _ref.config;
	      var whitelist = _ref.whitelist;
	      var blacklist = _ref.blacklist;
	
	      // we store the properties ourselves so we need to update them if the
	      // whitelist or blacklist props have changed
	      if (this.props.whitelist !== whitelist || this.props.blacklist !== blacklist) {
	        this._propsToMeasure = this._getPropsToMeasure({ whitelist: whitelist, blacklist: blacklist });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _resizeDetector2['default'])().removeAllListeners(this._node);
	      (0, _resizeDetector2['default'])().uninstall(this._node);
	      this._node = null;
	    }
	  }, {
	    key: 'getDimensions',
	    value: function getDimensions(node, clone) {
	      if (node === undefined) node = this._node;
	
	      return (0, _getNodeDimensions2['default'])(node, { clone: clone });
	    }
	  }, {
	    key: '_getPropsToMeasure',
	    value: function _getPropsToMeasure(_ref2) {
	      var whitelist = _ref2.whitelist;
	      var blacklist = _ref2.blacklist;
	
	      return whitelist.filter(function (prop) {
	        return blacklist.indexOf(prop) < 0;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react.Children.only(typeof children === 'function' ? children(this.state.dimensions) : children);
	    }
	  }]);
	
	  return Measure;
	})(_react.Component);
	
	exports['default'] = Measure;
	module.exports = exports['default'];

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Measure = __webpack_require__(2054);
	
	var _Measure2 = _interopRequireDefault(_Measure);
	
	exports['default'] = _Measure2['default'];
	module.exports = exports['default'];

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = resizeDetector;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _elementResizeDetector = __webpack_require__(1561);
	
	var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);
	
	var instance = null;
	
	function resizeDetector() {
	  if (!instance) {
	    instance = (0, _elementResizeDetector2['default'])({
	      strategy: 'scroll'
	    });
	  }
	  return instance;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(45);
	var DOMFactories = __webpack_require__(835);
	var PropTypes = __webpack_require__(13);
	var ExecutionEnvironment = __webpack_require__(1573);
	var ModalPortal = React.createFactory(__webpack_require__(2058));
	var ariaAppHider = __webpack_require__(2059);
	var refCount = __webpack_require__(2061);
	var elementClass = __webpack_require__(1558);
	var renderSubtreeIntoContainer = __webpack_require__(45).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(735);
	var createReactClass = __webpack_require__(134);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = createReactClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: PropTypes.bool.isRequired,
	    style: PropTypes.shape({
	      content: PropTypes.object,
	      overlay: PropTypes.object
	    }),
	    portalClassName: PropTypes.string,
	    bodyOpenClassName: PropTypes.string,
	    appElement: PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: PropTypes.func,
	    onRequestClose: PropTypes.func,
	    closeTimeoutMS: PropTypes.number,
	    ariaHideApp: PropTypes.bool,
	    shouldCloseOnOverlayClick: PropTypes.bool,
	    parentSelector: PropTypes.func,
	    role: PropTypes.string,
	    contentLabel: PropTypes.string.isRequired
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      portalClassName: 'ReactModalPortal',
	      bodyOpenClassName: 'ReactModal__Body--open',
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true,
	      parentSelector: function () { return document.body; }
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = this.props.portalClassName;
	
	    if (this.props.isOpen) refCount.add(this);
	
	    var parent = getParentElement(this.props.parentSelector);
	    parent.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillUpdate: function(newProps) {
	    if(newProps.portalClassName !== this.props.portalClassName) {
	      this.node.className = newProps.portalClassName;
	    }
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    if (newProps.isOpen) refCount.add(this);
	    if (!newProps.isOpen) refCount.remove(this);
	    var currentParent = getParentElement(this.props.parentSelector);
	    var newParent = getParentElement(newProps.parentSelector);
	
	    if(newParent !== currentParent) {
	      currentParent.removeChild(this.node);
	      newParent.appendChild(this.node);
	    }
	
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    if (!this.node) return;
	
	    refCount.remove(this);
	
	    if (this.props.ariaHideApp) {
	      ariaAppHider.show(this.props.appElement);
	    }
	
	    var state = this.portal.state;
	    var now = Date.now();
	    var closesAt = state.isOpen && this.props.closeTimeoutMS
	      && (state.closesAt
	        || now + this.props.closeTimeoutMS);
	
	    if (closesAt) {
	      if (!state.beforeClose) {
	        this.portal.closeWithTimeout();
	      }
	
	      var that = this;
	      setTimeout(function() { that.removePortal(); }, closesAt - now);
	    } else {
	      this.removePortal();
	    }
	  },
	
	  removePortal: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    var parent = getParentElement(this.props.parentSelector);
	    parent.removeChild(this.node);
	
	    if (refCount.count() === 0) {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen || refCount.count() > 0) {
	      elementClass(document.body).add(this.props.bodyOpenClassName);
	    } else {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return DOMFactories.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var DOMFactories = __webpack_require__(835);
	var focusManager = __webpack_require__(2060);
	var scopeTab = __webpack_require__(2062);
	var Assign = __webpack_require__(735);
	var createReactClass = __webpack_require__(134);
	
	var div = DOMFactories.div;
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: 'ReactModal__Overlay',
	  content: 'ReactModal__Content'
	};
	
	var ModalPortal = module.exports = createReactClass({
	
	  displayName: 'ModalPortal',
	  shouldClose: null,
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  afterClose: function () {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  open: function () {
	    if (this.state.afterOpen && this.state.beforeClose) {
	      clearTimeout(this.closeTimer);
	      this.setState({ beforeClose: false });
	    } else {
	      focusManager.setupScopedFocus(this.node);
	      focusManager.markForFocusLater();
	      this.setState({isOpen: true}, function() {
	        this.setState({afterOpen: true});
	
	        if (this.props.isOpen && this.props.onAfterOpen) {
	          this.props.onAfterOpen();
	        }
	      }.bind(this));
	    }
	  },
	
	  close: function() {
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    // Don't steal focus from inner elements
	    if (!this.contentHasFocus()) {
	      this.refs.content.focus();
	    }
	  },
	
	  closeWithTimeout: function() {
	    var closesAt = Date.now() + this.props.closeTimeoutMS;
	    this.setState({beforeClose: true, closesAt: closesAt}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      beforeClose: false,
	      isOpen: false,
	      afterOpen: false,
	      closesAt: null
	    }, this.afterClose);
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayOnClick: function (event) {
	    if (this.shouldClose === null) {
	      this.shouldClose = true;
	    }
	
	    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	    this.shouldClose = null;
	  },
	
	  handleContentOnClick: function () {
	    this.shouldClose = false;
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.state.isOpen && !this.state.beforeClose;
	  },
	
	  contentHasFocus: function() {
	    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
	  },
	
	  buildClassName: function(which, additional) {
	    var classNames = (typeof additional === 'object') ? additional : {
	      base: CLASS_NAMES[which],
	      afterOpen: CLASS_NAMES[which] + "--after-open",
	      beforeClose: CLASS_NAMES[which] + "--before-close"
	    };
	    var className = classNames.base;
	    if (this.state.afterOpen) { className += " " + classNames.afterOpen; }
	    if (this.state.beforeClose) { className += " " + classNames.beforeClose; }
	    return (typeof additional === 'string' && additional) ? [className, additional].join(" ") : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onClick: this.handleOverlayOnClick
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown,
	          onClick: this.handleContentOnClick,
	          role: this.props.role,
	          "aria-label": this.props.contentLabel
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ }),
/* 2059 */
/***/ (function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(864);
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElements.push(document.activeElement);
	};
	
	exports.returnFocus = function() {
	  var toFocus = null;
	  try {
	    toFocus = focusLaterElements.pop();
	    toFocus.focus();
	    return;
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
	  }
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};


/***/ }),
/* 2061 */
/***/ (function(module, exports) {

	var modals = [];
	
	module.exports = {
	  add: function (element) {
	    if (modals.indexOf(element) === -1) {
	      modals.push(element);
	    }
	  },
	  remove: function (element) {
	    var index = modals.indexOf(element);
	    if (index === -1) {
	      return;
	    }
	    modals.splice(index, 1);
	  },
	  count: function () {
	    return modals.length;
	  }
	};


/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(864);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(486);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(341);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(488);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(489);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(163);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(487);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(134);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    onRest: _propTypes2['default'].func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(486);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(341);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(488);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(489);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(163);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(487);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(134);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	    styles: _propTypes2['default'].func.isRequired,
	    children: _propTypes2['default'].func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(486);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(341);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(488);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(2066);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(489);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(163);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(487);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(134);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _createReactClass2['default']({
	  propTypes: {
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	    })),
	    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	    }))]).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    willEnter: _propTypes2['default'].func,
	    willLeave: _propTypes2['default'].func,
	    didLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // https://github.com/chenglou/react-motion/pull/420
	      // > if execution passes the conditional if (this.unmounting), then
	      // executes async defaultRaf and after that component unmounts and after
	      // that the callback of defaultRaf is called, then setState will be called
	      // on unmounted component.
	      if (_this.unmounting) {
	        return;
	      }
	
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ }),
/* 2066 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(865);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var createReactClass = __webpack_require__(134);
	var PropTypes = __webpack_require__(13);
	var NotificationItem = __webpack_require__(2070);
	var Constants = __webpack_require__(490);
	
	var NotificationContainer = createReactClass({
	
	  propTypes: {
	    position: PropTypes.string.isRequired,
	    notifications: PropTypes.array.isRequired,
	    getStyles: PropTypes.object
	  },
	
	  _style: {},
	
	  componentWillMount: function() {
	    // Fix position if width is overrided
	    this._style = this.props.getStyles.container(this.props.position);
	
	    if (this.props.getStyles.overrideWidth && (this.props.position === Constants.positions.tc || this.props.position === Constants.positions.bc)) {
	      this._style.marginLeft = -(this.props.getStyles.overrideWidth / 2);
	    }
	  },
	
	  render: function() {
	    var self = this;
	    var notifications;
	
	    if ([Constants.positions.bl, Constants.positions.br, Constants.positions.bc].indexOf(this.props.position) > -1) {
	      this.props.notifications.reverse();
	    }
	
	    notifications = this.props.notifications.map(function(notification) {
	      return (
	        React.createElement(NotificationItem, {
	          ref:  'notification-' + notification.uid, 
	          key:  notification.uid, 
	          notification:  notification, 
	          getStyles:  self.props.getStyles, 
	          onRemove:  self.props.onRemove, 
	          noAnimation:  self.props.noAnimation, 
	          allowHTML:  self.props.allowHTML, 
	          children:  self.props.children}
	        )
	      );
	    });
	
	    return (
	      React.createElement("div", {className:  'notifications-' + this.props.position, style:  this._style}, 
	         notifications 
	      )
	    );
	  }
	});
	
	
	module.exports = NotificationContainer;


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var createReactClass = __webpack_require__(134);
	var PropTypes = __webpack_require__(13);
	var ReactDOM = __webpack_require__(45);
	var Constants = __webpack_require__(490);
	var Helpers = __webpack_require__(2072);
	var merge = __webpack_require__(36);
	
	/* From Modernizr */
	var whichTransitionEvent = function() {
	  var el = document.createElement('fakeelement');
	  var transition;
	  var transitions = {
	    transition: 'transitionend',
	    OTransition: 'oTransitionEnd',
	    MozTransition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd'
	  };
	
	  Object.keys(transitions).forEach(function(transitionKey) {
	    if (el.style[transitionKey] !== undefined) {
	      transition = transitions[transitionKey];
	    }
	  });
	
	  return transition;
	};
	
	var NotificationItem = createReactClass({
	  propTypes: {
	    notification: PropTypes.object,
	    getStyles: PropTypes.object,
	    onRemove: PropTypes.func,
	    allowHTML: PropTypes.bool,
	    noAnimation: PropTypes.bool,
	    children: PropTypes.oneOfType([
	      PropTypes.string,
	      PropTypes.element
	    ])
	  },
	
	  getDefaultProps: function() {
	    return {
	      noAnimation: false,
	      onRemove: function() {},
	      allowHTML: false
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      visible: undefined,
	      removed: false
	    };
	  },
	
	  componentWillMount: function() {
	    var getStyles = this.props.getStyles;
	    var level = this.props.notification.level;
	    var dismissible = this.props.notification.dismissible;
	
	    this._noAnimation = this.props.noAnimation;
	
	    this._styles = {
	      notification: getStyles.byElement('notification')(level),
	      title: getStyles.byElement('title')(level),
	      dismiss: getStyles.byElement('dismiss')(level),
	      messageWrapper: getStyles.byElement('messageWrapper')(level),
	      actionWrapper: getStyles.byElement('actionWrapper')(level),
	      action: getStyles.byElement('action')(level)
	    };
	
	    if (!dismissible || dismissible === 'none' || dismissible === 'button') {
	      this._styles.notification.cursor = 'default';
	    }
	  },
	
	  _styles: {},
	
	  _notificationTimer: null,
	
	  _height: 0,
	
	  _noAnimation: null,
	
	  _isMounted: false,
	
	  _removeCount: 0,
	
	  _getCssPropertyByPosition: function() {
	    var position = this.props.notification.position;
	    var css = {};
	
	    switch (position) {
	    case Constants.positions.tl:
	    case Constants.positions.bl:
	      css = {
	        property: 'left',
	        value: -200
	      };
	      break;
	
	    case Constants.positions.tr:
	    case Constants.positions.br:
	      css = {
	        property: 'right',
	        value: -200
	      };
	      break;
	
	    case Constants.positions.tc:
	      css = {
	        property: 'top',
	        value: -100
	      };
	      break;
	
	    case Constants.positions.bc:
	      css = {
	        property: 'bottom',
	        value: -100
	      };
	      break;
	
	    default:
	    }
	
	    return css;
	  },
	
	  _defaultAction: function(event) {
	    var notification = this.props.notification;
	
	    event.preventDefault();
	    this._hideNotification();
	    if (typeof notification.action.callback === 'function') {
	      notification.action.callback();
	    }
	  },
	
	  _hideNotification: function() {
	    if (this._notificationTimer) {
	      this._notificationTimer.clear();
	    }
	
	    if (this._isMounted) {
	      this.setState({
	        visible: false,
	        removed: true
	      });
	    }
	
	    if (this._noAnimation) {
	      this._removeNotification();
	    }
	  },
	
	  _removeNotification: function() {
	    this.props.onRemove(this.props.notification.uid);
	  },
	
	  _dismiss: function() {
	    if (!this.props.notification.dismissible) {
	      return;
	    }
	
	    this._hideNotification();
	  },
	
	  _showNotification: function() {
	    var self = this;
	    setTimeout(function() {
	      if (self._isMounted) {
	        self.setState({
	          visible: true
	        });
	      }
	    }, 50);
	  },
	
	  _onTransitionEnd: function() {
	    if (this._removeCount > 0) return;
	    if (this.state.removed) {
	      this._removeCount += 1;
	      this._removeNotification();
	    }
	  },
	
	  componentDidMount: function() {
	    var self = this;
	    var transitionEvent = whichTransitionEvent();
	    var notification = this.props.notification;
	    var element = ReactDOM.findDOMNode(this);
	
	    this._height = element.offsetHeight;
	
	    this._isMounted = true;
	
	    // Watch for transition end
	    if (!this._noAnimation) {
	      if (transitionEvent) {
	        element.addEventListener(transitionEvent, this._onTransitionEnd);
	      } else {
	        this._noAnimation = true;
	      }
	    }
	
	
	    if (notification.autoDismiss) {
	      this._notificationTimer = new Helpers.Timer(function() {
	        self._hideNotification();
	      }, notification.autoDismiss * 1000);
	    }
	
	    this._showNotification();
	  },
	
	  _handleMouseEnter: function() {
	    var notification = this.props.notification;
	    if (notification.autoDismiss) {
	      this._notificationTimer.pause();
	    }
	  },
	
	  _handleMouseLeave: function() {
	    var notification = this.props.notification;
	    if (notification.autoDismiss) {
	      this._notificationTimer.resume();
	    }
	  },
	
	  _handleNotificationClick: function() {
	    var dismissible = this.props.notification.dismissible;
	    if (dismissible === 'both' || dismissible === 'click' || dismissible === true) {
	      this._dismiss();
	    }
	  },
	
	  componentWillUnmount: function() {
	    var element = ReactDOM.findDOMNode(this);
	    var transitionEvent = whichTransitionEvent();
	    element.removeEventListener(transitionEvent, this._onTransitionEnd);
	    this._isMounted = false;
	  },
	
	  _allowHTML: function(string) {
	    return { __html: string };
	  },
	
	  render: function() {
	    var notification = this.props.notification;
	    var className = 'notification notification-' + notification.level;
	    var notificationStyle = merge({}, this._styles.notification);
	    var cssByPos = this._getCssPropertyByPosition();
	    var dismiss = null;
	    var actionButton = null;
	    var title = null;
	    var message = null;
	
	    if (this.state.visible) {
	      className += ' notification-visible';
	    } else if (this.state.visible === false) {
	      className += ' notification-hidden';
	    }
	
	    if (notification.dismissible === 'none') {
	      className += ' notification-not-dismissible';
	    }
	
	    if (this.props.getStyles.overrideStyle) {
	      if (!this.state.visible && !this.state.removed) {
	        notificationStyle[cssByPos.property] = cssByPos.value;
	      }
	
	      if (this.state.visible && !this.state.removed) {
	        notificationStyle.height = this._height;
	        notificationStyle[cssByPos.property] = 0;
	      }
	
	      if (this.state.removed) {
	        notificationStyle.overlay = 'hidden';
	        notificationStyle.height = 0;
	        notificationStyle.marginTop = 0;
	        notificationStyle.paddingTop = 0;
	        notificationStyle.paddingBottom = 0;
	      }
	      notificationStyle.opacity = this.state.visible ? this._styles.notification.isVisible.opacity : this._styles.notification.isHidden.opacity;
	    }
	
	    if (notification.title) {
	      title = React.createElement("h4", {className: "notification-title", style:  this._styles.title},  notification.title);
	    }
	
	    if (notification.message) {
	      if (this.props.allowHTML) {
	        message = (
	          React.createElement("div", {className: "notification-message", style:  this._styles.messageWrapper, dangerouslySetInnerHTML:  this._allowHTML(notification.message) })
	        );
	      } else {
	        message = (
	          React.createElement("div", {className: "notification-message", style:  this._styles.messageWrapper},  notification.message)
	        );
	      }
	    }
	    if (notification.dismissible === 'both' || notification.dismissible === 'button' || notification.dismissible === true) {
	      dismiss = React.createElement("span", {className: "notification-dismiss", onClick:  this._dismiss, style:  this._styles.dismiss}, "×");
	    }
	
	    if (notification.action) {
	      actionButton = (
	        React.createElement("div", {className: "notification-action-wrapper", style:  this._styles.actionWrapper}, 
	          React.createElement("button", {className: "notification-action-button", 
	            onClick:  this._defaultAction, 
	            style:  this._styles.action}, 
	             notification.action.label
	          )
	        )
	      );
	    }
	
	    if (notification.children) {
	      actionButton = notification.children;
	    }
	
	    return (
	      React.createElement("div", {className:  className, onClick:  this._handleNotificationClick, onMouseEnter:  this._handleMouseEnter, onMouseLeave:  this._handleMouseLeave, style:  notificationStyle }, 
	         title, 
	         message, 
	         dismiss, 
	         actionButton 
	      )
	    );
	  }
	
	});
	
	module.exports = NotificationItem;


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var createReactClass = __webpack_require__(134);
	var PropTypes = __webpack_require__(13);
	var merge = __webpack_require__(36);
	var NotificationContainer = __webpack_require__(2069);
	var Constants = __webpack_require__(490);
	var Styles = __webpack_require__(2073);
	
	var NotificationSystem = createReactClass({
	
	  uid: 3400,
	
	  _isMounted: false,
	
	  _getStyles: {
	    overrideStyle: {},
	
	    overrideWidth: null,
	
	    setOverrideStyle: function(style) {
	      this.overrideStyle = style;
	    },
	
	    wrapper: function() {
	      if (!this.overrideStyle) return {};
	      return merge({}, Styles.Wrapper, this.overrideStyle.Wrapper);
	    },
	
	    container: function(position) {
	      var override = this.overrideStyle.Containers || {};
	      if (!this.overrideStyle) return {};
	
	      this.overrideWidth = Styles.Containers.DefaultStyle.width;
	
	      if (override.DefaultStyle && override.DefaultStyle.width) {
	        this.overrideWidth = override.DefaultStyle.width;
	      }
	
	      if (override[position] && override[position].width) {
	        this.overrideWidth = override[position].width;
	      }
	
	      return merge({}, Styles.Containers.DefaultStyle, Styles.Containers[position], override.DefaultStyle, override[position]);
	    },
	
	    elements: {
	      notification: 'NotificationItem',
	      title: 'Title',
	      messageWrapper: 'MessageWrapper',
	      dismiss: 'Dismiss',
	      action: 'Action',
	      actionWrapper: 'ActionWrapper'
	    },
	
	    byElement: function(element) {
	      var self = this;
	      return function(level) {
	        var _element = self.elements[element];
	        var override = self.overrideStyle[_element] || {};
	        if (!self.overrideStyle) return {};
	        return merge({}, Styles[_element].DefaultStyle, Styles[_element][level], override.DefaultStyle, override[level]);
	      };
	    }
	  },
	
	  _didNotificationRemoved: function(uid) {
	    var notification;
	    var notifications = this.state.notifications.filter(function(toCheck) {
	      if (toCheck.uid === uid) {
	        notification = toCheck;
	        return false;
	      }
	      return true;
	    });
	
	    if (this._isMounted) {
	      this.setState({ notifications: notifications });
	    }
	
	    if (notification && notification.onRemove) {
	      notification.onRemove(notification);
	    }
	  },
	
	  getInitialState: function() {
	    return {
	      notifications: []
	    };
	  },
	
	  propTypes: {
	    style: PropTypes.oneOfType([
	      PropTypes.bool,
	      PropTypes.object
	    ]),
	    noAnimation: PropTypes.bool,
	    allowHTML: PropTypes.bool
	  },
	
	  getDefaultProps: function() {
	    return {
	      style: {},
	      noAnimation: false,
	      allowHTML: false
	    };
	  },
	
	  addNotification: function(notification) {
	    var _notification = merge({}, Constants.notification, notification);
	    var notifications = this.state.notifications;
	    var i;
	
	    if (!_notification.level) {
	      throw new Error('notification level is required.');
	    }
	
	    if (Object.keys(Constants.levels).indexOf(_notification.level) === -1) {
	      throw new Error('\'' + _notification.level + '\' is not a valid level.');
	    }
	
	    // eslint-disable-next-line
	    if (isNaN(_notification.autoDismiss)) {
	      throw new Error('\'autoDismiss\' must be a number.');
	    }
	
	    if (Object.keys(Constants.positions).indexOf(_notification.position) === -1) {
	      throw new Error('\'' + _notification.position + '\' is not a valid position.');
	    }
	
	    // Some preparations
	    _notification.position = _notification.position.toLowerCase();
	    _notification.level = _notification.level.toLowerCase();
	    _notification.autoDismiss = parseInt(_notification.autoDismiss, 10);
	
	    _notification.uid = _notification.uid || this.uid;
	    _notification.ref = 'notification-' + _notification.uid;
	    this.uid += 1;
	
	    // do not add if the notification already exists based on supplied uid
	    for (i = 0; i < notifications.length; i += 1) {
	      if (notifications[i].uid === _notification.uid) {
	        return false;
	      }
	    }
	
	    notifications.push(_notification);
	
	    if (typeof _notification.onAdd === 'function') {
	      notification.onAdd(_notification);
	    }
	
	    this.setState({
	      notifications: notifications
	    });
	
	    return _notification;
	  },
	
	  getNotificationRef: function(notification) {
	    var self = this;
	    var foundNotification = null;
	
	    Object.keys(this.refs).forEach(function(container) {
	      if (container.indexOf('container') > -1) {
	        Object.keys(self.refs[container].refs).forEach(function(_notification) {
	          var uid = notification.uid ? notification.uid : notification;
	          if (_notification === 'notification-' + uid) {
	            // NOTE: Stop iterating further and return the found notification.
	            // Since UIDs are uniques and there won't be another notification found.
	            foundNotification = self.refs[container].refs[_notification];
	          }
	        });
	      }
	    });
	
	    return foundNotification;
	  },
	
	  removeNotification: function(notification) {
	    var foundNotification = this.getNotificationRef(notification);
	    return foundNotification && foundNotification._hideNotification();
	  },
	
	  editNotification: function(notification, newNotification) {
	    var foundNotification = null;
	    // NOTE: Find state notification to update by using
	    // `setState` and forcing React to re-render the component.
	    var uid = notification.uid ? notification.uid : notification;
	
	    var newNotifications = this.state.notifications.filter(function(stateNotification) {
	      if (uid === stateNotification.uid) {
	        foundNotification = stateNotification;
	        return false;
	      }
	
	      return true;
	    });
	
	
	    if (!foundNotification) {
	      return;
	    }
	
	    newNotifications.push(merge(
	      {},
	      foundNotification,
	      newNotification
	    ));
	
	    this.setState({
	      notifications: newNotifications
	    });
	  },
	
	  clearNotifications: function() {
	    var self = this;
	    Object.keys(this.refs).forEach(function(container) {
	      if (container.indexOf('container') > -1) {
	        Object.keys(self.refs[container].refs).forEach(function(_notification) {
	          self.refs[container].refs[_notification]._hideNotification();
	        });
	      }
	    });
	  },
	
	  componentDidMount: function() {
	    this._getStyles.setOverrideStyle(this.props.style);
	    this._isMounted = true;
	  },
	
	  componentWillUnmount: function() {
	    this._isMounted = false;
	  },
	
	  render: function() {
	    var self = this;
	    var containers = null;
	    var notifications = this.state.notifications;
	
	    if (notifications.length) {
	      containers = Object.keys(Constants.positions).map(function(position) {
	        var _notifications = notifications.filter(function(notification) {
	          return position === notification.position;
	        });
	
	        if (!_notifications.length) {
	          return null;
	        }
	
	        return (
	          React.createElement(NotificationContainer, {
	            ref:  'container-' + position, 
	            key:  position, 
	            position:  position, 
	            notifications:  _notifications, 
	            getStyles:  self._getStyles, 
	            onRemove:  self._didNotificationRemoved, 
	            noAnimation:  self.props.noAnimation, 
	            allowHTML:  self.props.allowHTML}
	          )
	        );
	      });
	    }
	
	
	    return (
	      React.createElement("div", {className: "notifications-wrapper", style:  this._getStyles.wrapper() }, 
	         containers 
	      )
	    );
	  }
	});
	
	module.exports = NotificationSystem;


/***/ }),
/* 2072 */
/***/ (function(module, exports) {

	var Helpers = {
	  Timer: function(callback, delay) {
	    var timerId;
	    var start;
	    var remaining = delay;
	
	    this.pause = function() {
	      clearTimeout(timerId);
	      remaining -= new Date() - start;
	    };
	
	    this.resume = function() {
	      start = new Date();
	      clearTimeout(timerId);
	      timerId = setTimeout(callback, remaining);
	    };
	
	    this.clear = function() {
	      clearTimeout(timerId);
	    };
	
	    this.resume();
	  }
	};
	
	module.exports = Helpers;


/***/ }),
/* 2073 */
/***/ (function(module, exports) {

	// Used for calculations
	var defaultWidth = 320;
	var defaultColors = {
	  success: {
	    rgb: '94, 164, 0',
	    hex: '#5ea400'
	  },
	  error: {
	    rgb: '236, 61, 61',
	    hex: '#ec3d3d'
	  },
	  warning: {
	    rgb: '235, 173, 23',
	    hex: '#ebad1a'
	  },
	  info: {
	    rgb: '54, 156, 199',
	    hex: '#369cc7'
	  }
	};
	var defaultShadowOpacity = '0.9';
	
	var STYLES = {
	
	  Wrapper: {},
	  Containers: {
	    DefaultStyle: {
	      fontFamily: 'inherit',
	      position: 'fixed',
	      width: defaultWidth,
	      padding: '0 10px 10px 10px',
	      zIndex: 9998,
	      WebkitBoxSizing: 'border-box',
	      MozBoxSizing: 'border-box',
	      boxSizing: 'border-box',
	      height: 'auto'
	    },
	
	    tl: {
	      top: '0px',
	      bottom: 'auto',
	      left: '0px',
	      right: 'auto'
	    },
	
	    tr: {
	      top: '0px',
	      bottom: 'auto',
	      left: 'auto',
	      right: '0px'
	    },
	
	    tc: {
	      top: '0px',
	      bottom: 'auto',
	      margin: '0 auto',
	      left: '50%',
	      marginLeft: -(defaultWidth / 2)
	    },
	
	    bl: {
	      top: 'auto',
	      bottom: '0px',
	      left: '0px',
	      right: 'auto'
	    },
	
	    br: {
	      top: 'auto',
	      bottom: '0px',
	      left: 'auto',
	      right: '0px'
	    },
	
	    bc: {
	      top: 'auto',
	      bottom: '0px',
	      margin: '0 auto',
	      left: '50%',
	      marginLeft: -(defaultWidth / 2)
	    }
	
	  },
	
	  NotificationItem: {
	    DefaultStyle: {
	      position: 'relative',
	      width: '100%',
	      cursor: 'pointer',
	      borderRadius: '2px',
	      fontSize: '13px',
	      margin: '10px 0 0',
	      padding: '10px',
	      display: 'block',
	      WebkitBoxSizing: 'border-box',
	      MozBoxSizing: 'border-box',
	      boxSizing: 'border-box',
	      opacity: 0,
	      transition: '0.3s ease-in-out',
	      WebkitTransform: 'translate3d(0, 0, 0)',
	      transform: 'translate3d(0, 0, 0)',
	      willChange: 'transform, opacity',
	
	      isHidden: {
	        opacity: 0
	      },
	
	      isVisible: {
	        opacity: 1
	      }
	    },
	
	    success: {
	      borderTop: '2px solid ' + defaultColors.success.hex,
	      backgroundColor: '#f0f5ea',
	      color: '#4b583a',
	      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')',
	      MozBoxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')',
	      boxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')'
	    },
	
	    error: {
	      borderTop: '2px solid ' + defaultColors.error.hex,
	      backgroundColor: '#f4e9e9',
	      color: '#412f2f',
	      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')',
	      MozBoxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')',
	      boxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')'
	    },
	
	    warning: {
	      borderTop: '2px solid ' + defaultColors.warning.hex,
	      backgroundColor: '#f9f6f0',
	      color: '#5a5343',
	      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')',
	      MozBoxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')',
	      boxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')'
	    },
	
	    info: {
	      borderTop: '2px solid ' + defaultColors.info.hex,
	      backgroundColor: '#e8f0f4',
	      color: '#41555d',
	      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')',
	      MozBoxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')',
	      boxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')'
	    }
	  },
	
	  Title: {
	    DefaultStyle: {
	      fontSize: '14px',
	      margin: '0 0 5px 0',
	      padding: 0,
	      fontWeight: 'bold'
	    },
	
	    success: {
	      color: defaultColors.success.hex
	    },
	
	    error: {
	      color: defaultColors.error.hex
	    },
	
	    warning: {
	      color: defaultColors.warning.hex
	    },
	
	    info: {
	      color: defaultColors.info.hex
	    }
	
	  },
	
	  MessageWrapper: {
	    DefaultStyle: {
	      margin: 0,
	      padding: 0
	    }
	  },
	
	  Dismiss: {
	    DefaultStyle: {
	      cursor: 'pointer',
	      fontFamily: 'Arial',
	      fontSize: '17px',
	      position: 'absolute',
	      top: '4px',
	      right: '5px',
	      lineHeight: '15px',
	      backgroundColor: '#dededf',
	      color: '#ffffff',
	      borderRadius: '50%',
	      width: '14px',
	      height: '14px',
	      fontWeight: 'bold',
	      textAlign: 'center'
	    },
	
	    success: {
	      color: '#f0f5ea',
	      backgroundColor: '#b0ca92'
	    },
	
	    error: {
	      color: '#f4e9e9',
	      backgroundColor: '#e4bebe'
	    },
	
	    warning: {
	      color: '#f9f6f0',
	      backgroundColor: '#e1cfac'
	    },
	
	    info: {
	      color: '#e8f0f4',
	      backgroundColor: '#a4becb'
	    }
	  },
	
	  Action: {
	    DefaultStyle: {
	      background: '#ffffff',
	      borderRadius: '2px',
	      padding: '6px 20px',
	      fontWeight: 'bold',
	      margin: '10px 0 0 0',
	      border: 0
	    },
	
	    success: {
	      backgroundColor: defaultColors.success.hex,
	      color: '#ffffff'
	    },
	
	    error: {
	      backgroundColor: defaultColors.error.hex,
	      color: '#ffffff'
	    },
	
	    warning: {
	      backgroundColor: defaultColors.warning.hex,
	      color: '#ffffff'
	    },
	
	    info: {
	      backgroundColor: defaultColors.info.hex,
	      color: '#ffffff'
	    }
	  },
	
	  ActionWrapper: {
	    DefaultStyle: {
	      margin: 0,
	      padding: 0
	    }
	  }
	};
	
	module.exports = STYLES;


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A mixin for handling (effectively) onClickOutside for React components.
	 * Note that we're not intercepting any events in this approach, and we're
	 * not using double events for capturing and discarding in layers or wrappers.
	 *
	 * The idea is that components define function
	 *
	 *   handleClickOutside: function() { ... }
	 *
	 * If no such function is defined, an error will be thrown, as this means
	 * either it still needs to be written, or the component should not be using
	 * this mixing since it will not exhibit onClickOutside behaviour.
	 *
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(45)], __WEBPACK_AMD_DEFINE_RESULT__ = function(reactDom) {
	      return factory(root, reactDom);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Note that this does not work with strict
	    // CommonJS, but only CommonJS-like environments
	    // that support module.exports
	    module.exports = factory(root, require('react-dom'));
	  } else {
	    // Browser globals (root is window)
	    root.OnClickOutside = factory(root, ReactDOM);
	  }
	}(this, function (root, ReactDOM) {
	  "use strict";
	
	  // Use a parallel array because we can't use
	  // objects as keys, they get toString-coerced
	  var registeredComponents = [];
	  var handlers = [];
	
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	
	  var isSourceFound = function(source, localNode, ignoreClass) {
	    if (source === localNode) {
	      return true;
	    }
	    // SVG <use/> elements do not technically reside in the rendered DOM, so
	    // they do not have classList directly, but they offer a link to their
	    // corresponding element, which can have classList. This extra check is for
	    // that case.
	    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	    if (source.correspondingElement) {
	      return source.correspondingElement.classList.contains(ignoreClass);
	    }
	    return source.classList.contains(ignoreClass);
	  };
	
	  return {
	    componentDidMount: function() {
	      if(typeof this.handleClickOutside !== "function")
	        throw new Error("Component lacks a handleClickOutside(event) function for processing outside click events.");
	
	      var fn = this.__outsideClickHandler = (function(localNode, eventHandler, ignoreClass) {
	        return function(evt) {
	          evt.stopPropagation();
	          var source = evt.target;
	          var found = false;
	          // If source=local then this event came from "somewhere"
	          // inside and should be ignored. We could handle this with
	          // a layered approach, too, but that requires going back to
	          // thinking in terms of Dom node nesting, running counter
	          // to React's "you shouldn't care about the DOM" philosophy.
	          while(source.parentNode) {
	            found = isSourceFound(source, localNode, ignoreClass);
	            if(found) return;
	            source = source.parentNode;
	          }
	          // If element is in detached DOM, consider it not clicked
	          // outside as it can't be known whether it was outside.
	          if(source !== document) return;
	          eventHandler(evt);
	        }
	      }(ReactDOM.findDOMNode(this), this.handleClickOutside, this.props.outsideClickIgnoreClass || IGNORE_CLASS));
	
	      var pos = registeredComponents.length;
	      registeredComponents.push(this);
	      handlers[pos] = fn;
	
	      // If there is a truthy disableOnClickOutside property for this
	      // component, don't immediately start listening for outside events.
	      if (!this.props.disableOnClickOutside) {
	        this.enableOnClickOutside();
	      }
	    },
	
	    componentWillUnmount: function() {
	      this.disableOnClickOutside();
	      this.__outsideClickHandler = false;
	      var pos = registeredComponents.indexOf(this);
	      if( pos>-1) {
	        if (handlers[pos]) {
	          // clean up so we don't leak memory
	          handlers.splice(pos, 1);
	          registeredComponents.splice(pos, 1);
	        }
	      }
	    },
	
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    enableOnClickOutside: function() {
	      var fn = this.__outsideClickHandler;
	      if (typeof document !== "undefined") {
	        document.addEventListener("mousedown", fn);
	        document.addEventListener("touchstart", fn);
	      }
	    },
	
	    /**
	     * Can be called to explicitly disable event listening
	     * for clicks and touches outside of this element.
	     */
	    disableOnClickOutside: function() {
	      var fn = this.__outsideClickHandler;
	      if (typeof document !== "undefined") {
	        document.removeEventListener("mousedown", fn);
	        document.removeEventListener("touchstart", fn);
	      }
	    }
	  };
	
	}));


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(866);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(867);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(866);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(2077);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(2078);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(867);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(120);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(1669);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(731);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(351);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _Async = __webpack_require__(868);
	
	var _Creatable = __webpack_require__(165);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(343));
	
	var _Select = _interopRequireDefault(__webpack_require__(342));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectCreatable = (0, _Creatable.makeCreatableSelect)(_Select.default);
	var SelectCreatableState = (0, _stateManager.default)(SelectCreatable);
	
	var _default = (0, _Async.makeAsyncSelect)(SelectCreatableState);
	
	exports.default = _default;

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resultsAriaMessage = exports.optionFocusAriaMessage = exports.valueFocusAriaMessage = exports.valueEventAriaMessage = exports.instructionsAriaMessage = void 0;
	
	var instructionsAriaMessage = function instructionsAriaMessage(event) {
	  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isSearchable = context.isSearchable,
	      isMulti = context.isMulti,
	      label = context.label,
	      isDisabled = context.isDisabled;
	
	  switch (event) {
	    case 'menu':
	      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");
	
	    case 'input':
	      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
	
	    case 'value':
	      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
	  }
	};
	
	exports.instructionsAriaMessage = instructionsAriaMessage;
	
	var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
	  var value = context.value,
	      isDisabled = context.isDisabled;
	  if (!value) return;
	
	  switch (event) {
	    case 'deselect-option':
	    case 'pop-value':
	    case 'remove-value':
	      return "option ".concat(value, ", deselected.");
	
	    case 'select-option':
	      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
	  }
	};
	
	exports.valueEventAriaMessage = valueEventAriaMessage;
	
	var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
	  var focusedValue = _ref.focusedValue,
	      getOptionLabel = _ref.getOptionLabel,
	      selectValue = _ref.selectValue;
	  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
	};
	
	exports.valueFocusAriaMessage = valueFocusAriaMessage;
	
	var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
	  var focusedOption = _ref2.focusedOption,
	      getOptionLabel = _ref2.getOptionLabel,
	      options = _ref2.options;
	  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
	};
	
	exports.optionFocusAriaMessage = optionFocusAriaMessage;
	
	var resultsAriaMessage = function resultsAriaMessage(_ref3) {
	  var inputValue = _ref3.inputValue,
	      screenReaderMessage = _ref3.screenReaderMessage;
	  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
	};
	
	exports.resultsAriaMessage = resultsAriaMessage;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// strip transition props off before spreading onto select component
	// note we need to be explicit about innerRef for flow
	var AnimatedInput = function AnimatedInput(WrappedComponent) {
	  return function (_ref) {
	    var inProp = _ref.in,
	        onExited = _ref.onExited,
	        appear = _ref.appear,
	        enter = _ref.enter,
	        exit = _ref.exit,
	        props = _objectWithoutProperties(_ref, ["in", "onExited", "appear", "enter", "exit"]);
	
	    return _react.default.createElement(WrappedComponent, props);
	  };
	};
	
	var _default = AnimatedInput;
	exports.default = _default;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// strip transition props off before spreading onto actual component
	var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
	  return function (_ref) {
	    var inProp = _ref.in,
	        onExited = _ref.onExited,
	        props = _objectWithoutProperties(_ref, ["in", "onExited"]);
	
	    return _react.default.createElement(_transitions.Collapse, {
	      in: inProp,
	      onExited: onExited
	    }, _react.default.createElement(WrappedComponent, _extends({
	      cropWithEllipsis: inProp
	    }, props)));
	  };
	};
	
	var _default = AnimatedMultiValue;
	exports.default = _default;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// fade in when last multi-value removed, otherwise instant
	var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_transitions.Fade, _extends({
	      component: WrappedComponent,
	      duration: props.isMulti ? _transitions.collapseDuration : 1
	    }, props));
	  };
	};
	
	var _default = AnimatedPlaceholder;
	exports.default = _default;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// instant fade; all transition-group children must be transitions
	var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_transitions.Fade, _extends({
	      component: WrappedComponent
	    }, props));
	  };
	};
	
	var _default = AnimatedSingleValue;
	exports.default = _default;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(883);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// make ValueContainer a transition group
	var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_reactTransitionGroup.TransitionGroup, _extends({
	      component: WrappedComponent
	    }, props));
	  };
	};
	
	var _default = AnimatedValueContainer;
	exports.default = _default;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ValueContainer = exports.SingleValue = exports.Placeholder = exports.MultiValue = exports.Input = void 0;
	
	var _memoizeOne = _interopRequireDefault(__webpack_require__(809));
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(878));
	
	var _index = __webpack_require__(493);
	
	var _Input = _interopRequireDefault(__webpack_require__(2081));
	
	var _MultiValue = _interopRequireDefault(__webpack_require__(2082));
	
	var _Placeholder = _interopRequireDefault(__webpack_require__(2083));
	
	var _SingleValue = _interopRequireDefault(__webpack_require__(2084));
	
	var _ValueContainer = _interopRequireDefault(__webpack_require__(2085));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var makeAnimated = function makeAnimated() {
	  var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var components = (0, _index.defaultComponents)({
	    components: externalComponents
	  });
	
	  var Input = components.Input,
	      MultiValue = components.MultiValue,
	      Placeholder = components.Placeholder,
	      SingleValue = components.SingleValue,
	      ValueContainer = components.ValueContainer,
	      rest = _objectWithoutProperties(components, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);
	
	  return _objectSpread({
	    Input: (0, _Input.default)(Input),
	    MultiValue: (0, _MultiValue.default)(MultiValue),
	    Placeholder: (0, _Placeholder.default)(Placeholder),
	    SingleValue: (0, _SingleValue.default)(SingleValue),
	    ValueContainer: (0, _ValueContainer.default)(ValueContainer)
	  }, rest);
	};
	
	var AnimatedComponents = makeAnimated();
	var Input = AnimatedComponents.Input;
	exports.Input = Input;
	var MultiValue = AnimatedComponents.MultiValue;
	exports.MultiValue = MultiValue;
	var Placeholder = AnimatedComponents.Placeholder;
	exports.Placeholder = Placeholder;
	var SingleValue = AnimatedComponents.SingleValue;
	exports.SingleValue = SingleValue;
	var ValueContainer = AnimatedComponents.ValueContainer;
	exports.ValueContainer = ValueContainer;
	
	var _default = (0, _memoizeOne.default)(makeAnimated, _reactFastCompare.default);
	
	exports.default = _default;

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isOptionDisabled = exports.getOptionValue = exports.getOptionLabel = exports.formatGroupLabel = void 0;
	
	var formatGroupLabel = function formatGroupLabel(group) {
	  return group.label;
	};
	
	exports.formatGroupLabel = formatGroupLabel;
	
	var getOptionLabel = function getOptionLabel(option) {
	  return option.label;
	};
	
	exports.getOptionLabel = getOptionLabel;
	
	var getOptionValue = function getOptionValue(option) {
	  return option.value;
	};
	
	exports.getOptionValue = getOptionValue;
	
	var isOptionDisabled = function isOptionDisabled(option) {
	  return !!option.isDisabled;
	};
	
	exports.isOptionDisabled = isOptionDisabled;

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripDiacritics = void 0;
	var diacritics = [{
	  base: 'A',
	  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
	}, {
	  base: 'AA',
	  letters: /[\uA732]/g
	}, {
	  base: 'AE',
	  letters: /[\u00C6\u01FC\u01E2]/g
	}, {
	  base: 'AO',
	  letters: /[\uA734]/g
	}, {
	  base: 'AU',
	  letters: /[\uA736]/g
	}, {
	  base: 'AV',
	  letters: /[\uA738\uA73A]/g
	}, {
	  base: 'AY',
	  letters: /[\uA73C]/g
	}, {
	  base: 'B',
	  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
	}, {
	  base: 'C',
	  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
	}, {
	  base: 'D',
	  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
	}, {
	  base: 'DZ',
	  letters: /[\u01F1\u01C4]/g
	}, {
	  base: 'Dz',
	  letters: /[\u01F2\u01C5]/g
	}, {
	  base: 'E',
	  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
	}, {
	  base: 'F',
	  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
	}, {
	  base: 'G',
	  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
	}, {
	  base: 'H',
	  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
	}, {
	  base: 'I',
	  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
	}, {
	  base: 'J',
	  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
	}, {
	  base: 'K',
	  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
	}, {
	  base: 'L',
	  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
	}, {
	  base: 'LJ',
	  letters: /[\u01C7]/g
	}, {
	  base: 'Lj',
	  letters: /[\u01C8]/g
	}, {
	  base: 'M',
	  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
	}, {
	  base: 'N',
	  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
	}, {
	  base: 'NJ',
	  letters: /[\u01CA]/g
	}, {
	  base: 'Nj',
	  letters: /[\u01CB]/g
	}, {
	  base: 'O',
	  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
	}, {
	  base: 'OI',
	  letters: /[\u01A2]/g
	}, {
	  base: 'OO',
	  letters: /[\uA74E]/g
	}, {
	  base: 'OU',
	  letters: /[\u0222]/g
	}, {
	  base: 'P',
	  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
	}, {
	  base: 'Q',
	  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
	}, {
	  base: 'R',
	  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
	}, {
	  base: 'S',
	  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
	}, {
	  base: 'T',
	  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
	}, {
	  base: 'TZ',
	  letters: /[\uA728]/g
	}, {
	  base: 'U',
	  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
	}, {
	  base: 'V',
	  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
	}, {
	  base: 'VY',
	  letters: /[\uA760]/g
	}, {
	  base: 'W',
	  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
	}, {
	  base: 'X',
	  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
	}, {
	  base: 'Y',
	  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
	}, {
	  base: 'Z',
	  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
	}, {
	  base: 'a',
	  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
	}, {
	  base: 'aa',
	  letters: /[\uA733]/g
	}, {
	  base: 'ae',
	  letters: /[\u00E6\u01FD\u01E3]/g
	}, {
	  base: 'ao',
	  letters: /[\uA735]/g
	}, {
	  base: 'au',
	  letters: /[\uA737]/g
	}, {
	  base: 'av',
	  letters: /[\uA739\uA73B]/g
	}, {
	  base: 'ay',
	  letters: /[\uA73D]/g
	}, {
	  base: 'b',
	  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
	}, {
	  base: 'c',
	  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
	}, {
	  base: 'd',
	  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
	}, {
	  base: 'dz',
	  letters: /[\u01F3\u01C6]/g
	}, {
	  base: 'e',
	  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
	}, {
	  base: 'f',
	  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
	}, {
	  base: 'g',
	  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
	}, {
	  base: 'h',
	  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
	}, {
	  base: 'hv',
	  letters: /[\u0195]/g
	}, {
	  base: 'i',
	  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
	}, {
	  base: 'j',
	  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
	}, {
	  base: 'k',
	  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
	}, {
	  base: 'l',
	  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
	}, {
	  base: 'lj',
	  letters: /[\u01C9]/g
	}, {
	  base: 'm',
	  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
	}, {
	  base: 'n',
	  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
	}, {
	  base: 'nj',
	  letters: /[\u01CC]/g
	}, {
	  base: 'o',
	  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
	}, {
	  base: 'oi',
	  letters: /[\u01A3]/g
	}, {
	  base: 'ou',
	  letters: /[\u0223]/g
	}, {
	  base: 'oo',
	  letters: /[\uA74F]/g
	}, {
	  base: 'p',
	  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
	}, {
	  base: 'q',
	  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
	}, {
	  base: 'r',
	  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
	}, {
	  base: 's',
	  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
	}, {
	  base: 't',
	  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
	}, {
	  base: 'tz',
	  letters: /[\uA729]/g
	}, {
	  base: 'u',
	  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
	}, {
	  base: 'v',
	  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
	}, {
	  base: 'vy',
	  letters: /[\uA761]/g
	}, {
	  base: 'w',
	  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
	}, {
	  base: 'x',
	  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
	}, {
	  base: 'y',
	  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
	}, {
	  base: 'z',
	  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
	}];
	
	var stripDiacritics = function stripDiacritics(str) {
	  for (var i = 0; i < diacritics.length; i++) {
	    str = str.replace(diacritics[i].letters, diacritics[i].base);
	  }
	
	  return str;
	};
	
	exports.stripDiacritics = stripDiacritics;

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// Assistive text to describe visual elements. Hidden for sighted users.
	var A11yText = function A11yText(props) {
	  return _react.default.createElement("span", _extends({
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      label: 'a11yText',
	      zIndex: 9999,
	      border: 0,
	      clip: 'rect(1px, 1px, 1px, 1px)',
	      height: 1,
	      width: 1,
	      position: 'absolute',
	      overflow: 'hidden',
	      padding: 0,
	      whiteSpace: 'nowrap',
	      backgroundColor: 'red',
	      color: 'blue'
	    })
	  }, props));
	};
	
	var _default = A11yText;
	exports.default = _default;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DummyInput =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DummyInput, _Component);
	
	  function DummyInput() {
	    _classCallCheck(this, DummyInput);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
	  }
	
	  _createClass(DummyInput, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          inProp = _this$props.in,
	          out = _this$props.out,
	          onExited = _this$props.onExited,
	          appear = _this$props.appear,
	          enter = _this$props.enter,
	          exit = _this$props.exit,
	          innerRef = _this$props.innerRef,
	          emotion = _this$props.emotion,
	          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
	
	      return _react.default.createElement("input", _extends({
	        ref: innerRef
	      }, props, {
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)({
	          label: 'dummyInput',
	          // get rid of any default styles
	          background: 0,
	          border: 0,
	          fontSize: 'inherit',
	          outline: 0,
	          padding: 0,
	          // important! without `width` browsers won't allow focus
	          width: 1,
	          // remove cursor on desktop
	          color: 'transparent',
	          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
	          left: -100,
	          opacity: 0,
	          position: 'relative',
	          transform: 'scale(0)'
	        })
	      }));
	    }
	  }]);
	
	  return DummyInput;
	}(_react.Component);
	
	exports.default = DummyInput;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(77);
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(495));
	
	var _index = _interopRequireDefault(__webpack_require__(2094));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// NOTE:
	// We shouldn't need this after updating to React v16.3.0, which introduces:
	// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
	// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
	var ScrollBlock =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ScrollBlock, _PureComponent);
	
	  function ScrollBlock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollBlock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      touchScrollTarget: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      if (ref === _this.state.touchScrollTarget) return;
	
	      _this.setState({
	        touchScrollTarget: ref
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollBlock, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          isEnabled = _this$props.isEnabled;
	      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
	
	      if (!isEnabled) return children;
	      /*
	       * Div
	       * ------------------------------
	       * blocks scrolling on non-body elements behind the menu
	        * NodeResolver
	       * ------------------------------
	       * we need a reference to the scrollable element to "unlock" scroll on
	       * mobile devices
	        * ScrollLock
	       * ------------------------------
	       * actually does the scroll locking
	       */
	
	      return _react.default.createElement("div", null, _react.default.createElement("div", {
	        onClick: this.blurSelectInput,
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)({
	          position: 'fixed',
	          left: 0,
	          bottom: 0,
	          right: 0,
	          top: 0
	        })
	      }), _react.default.createElement(_NodeResolver.default, {
	        innerRef: this.getScrollTarget
	      }, children), touchScrollTarget ? _react.default.createElement(_index.default, {
	        touchScrollTarget: touchScrollTarget
	      }) : null);
	    }
	  }]);
	
	  return ScrollBlock;
	}(_react.PureComponent);
	
	exports.default = ScrollBlock;

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(495));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ScrollCaptor =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollCaptor, _Component);
	
	  function ScrollCaptor() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollCaptor);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
	      var _this$props = _this.props,
	          onBottomArrive = _this$props.onBottomArrive,
	          onBottomLeave = _this$props.onBottomLeave,
	          onTopArrive = _this$props.onTopArrive,
	          onTopLeave = _this$props.onTopLeave;
	      var _this$scrollTarget = _this.scrollTarget,
	          scrollTop = _this$scrollTarget.scrollTop,
	          scrollHeight = _this$scrollTarget.scrollHeight,
	          clientHeight = _this$scrollTarget.clientHeight;
	      var target = _this.scrollTarget;
	      var isDeltaPositive = delta > 0;
	      var availableScroll = scrollHeight - clientHeight - scrollTop;
	      var shouldCancelScroll = false; // reset bottom/top flags
	
	      if (availableScroll > delta && _this.isBottom) {
	        if (onBottomLeave) onBottomLeave(event);
	        _this.isBottom = false;
	      }
	
	      if (isDeltaPositive && _this.isTop) {
	        if (onTopLeave) onTopLeave(event);
	        _this.isTop = false;
	      } // bottom limit
	
	
	      if (isDeltaPositive && delta > availableScroll) {
	        if (onBottomArrive && !_this.isBottom) {
	          onBottomArrive(event);
	        }
	
	        target.scrollTop = scrollHeight;
	        shouldCancelScroll = true;
	        _this.isBottom = true; // top limit
	      } else if (!isDeltaPositive && -delta > scrollTop) {
	        if (onTopArrive && !_this.isTop) {
	          onTopArrive(event);
	        }
	
	        target.scrollTop = 0;
	        shouldCancelScroll = true;
	        _this.isTop = true;
	      } // cancel scroll
	
	
	      if (shouldCancelScroll) {
	        _this.cancelScroll(event);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
	      _this.handleEventDelta(event, event.deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
	      // set touch start so we can calculate touchmove delta
	      _this.touchStart = event.changedTouches[0].clientY;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
	      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
	
	      _this.handleEventDelta(event, deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      _this.scrollTarget = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollCaptor, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListening(this.scrollTarget);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListening(this.scrollTarget);
	    }
	  }, {
	    key: "startListening",
	    value: function startListening(el) {
	      // bail early if no scroll available
	      if (!el) return;
	      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "stopListening",
	    value: function stopListening(el) {
	      // bail early if no scroll available
	      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react.default.createElement(_NodeResolver.default, {
	        innerRef: this.getScrollTarget
	      }, this.props.children);
	    }
	  }]);
	
	  return ScrollCaptor;
	}(_react.Component);
	
	var ScrollCaptorSwitch =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(ScrollCaptorSwitch, _Component2);
	
	  function ScrollCaptorSwitch() {
	    _classCallCheck(this, ScrollCaptorSwitch);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
	  }
	
	  _createClass(ScrollCaptorSwitch, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          isEnabled = _this$props2.isEnabled,
	          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);
	
	      return isEnabled ? _react.default.createElement(ScrollCaptor, props) : this.props.children;
	    }
	  }]);
	
	  return ScrollCaptorSwitch;
	}(_react.Component);
	
	exports.default = ScrollCaptorSwitch;
	
	_defineProperty(ScrollCaptorSwitch, "defaultProps", {
	  isEnabled: true
	});

/***/ }),
/* 2093 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LOCK_STYLES = exports.STYLE_KEYS = void 0;
	var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
	exports.STYLE_KEYS = STYLE_KEYS;
	var LOCK_STYLES = {
	  boxSizing: 'border-box',
	  // account for possible declaration `width: 100%;` on body
	  overflow: 'hidden',
	  position: 'relative',
	  height: '100%'
	};
	exports.LOCK_STYLES = LOCK_STYLES;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(2093);
	
	var _utils = __webpack_require__(2095);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var activeScrollLocks = 0;
	
	var ScrollLock =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollLock, _Component);
	
	  function ScrollLock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
	      capture: false,
	      passive: false
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollLock, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!canUseDOM) return;
	      var _this$props = this.props,
	          accountForScrollbars = _this$props.accountForScrollbars,
	          touchScrollTarget = _this$props.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style;
	
	      if (accountForScrollbars) {
	        // store any styles already applied to the body
	        _constants.STYLE_KEYS.forEach(function (key) {
	          var val = targetStyle && targetStyle[key];
	          _this2.originalStyles[key] = val;
	        });
	      } // apply the lock styles and padding if this is the first scroll lock
	
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
	        var clientWidth = document.body ? document.body.clientWidth : 0;
	        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	        Object.keys(_constants.LOCK_STYLES).forEach(function (key) {
	          var val = _constants.LOCK_STYLES[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	
	        if (targetStyle) {
	          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
	        }
	      } // account for touch devices
	
	
	      if (target && (0, _utils.isTouchDevice)()) {
	        // Mobile Safari ignores { overflow: hidden } declaration on the body.
	        target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions); // Allow scroll on provided target
	
	        if (touchScrollTarget) {
	          touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	        }
	      } // increment active scroll locks
	
	
	      activeScrollLocks += 1;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (!canUseDOM) return;
	      var _this$props2 = this.props,
	          accountForScrollbars = _this$props2.accountForScrollbars,
	          touchScrollTarget = _this$props2.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style; // safely decrement active scroll locks
	
	      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        _constants.STYLE_KEYS.forEach(function (key) {
	          var val = _this3.originalStyles[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	      } // remove touch listeners
	
	
	      if (target && (0, _utils.isTouchDevice)()) {
	        target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	        if (touchScrollTarget) {
	          touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.Component);
	
	exports.default = ScrollLock;
	
	_defineProperty(ScrollLock, "defaultProps", {
	  accountForScrollbars: true
	});

/***/ }),
/* 2095 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventTouchMove = preventTouchMove;
	exports.allowTouchMove = allowTouchMove;
	exports.preventInertiaScroll = preventInertiaScroll;
	exports.isTouchDevice = isTouchDevice;
	
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	} // `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	
	
	function isTouchDevice() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "A11yText", {
	  enumerable: true,
	  get: function get() {
	    return _A11yText.default;
	  }
	});
	Object.defineProperty(exports, "DummyInput", {
	  enumerable: true,
	  get: function get() {
	    return _DummyInput.default;
	  }
	});
	Object.defineProperty(exports, "NodeResolver", {
	  enumerable: true,
	  get: function get() {
	    return _NodeResolver.default;
	  }
	});
	Object.defineProperty(exports, "ScrollBlock", {
	  enumerable: true,
	  get: function get() {
	    return _ScrollBlock.default;
	  }
	});
	Object.defineProperty(exports, "ScrollCaptor", {
	  enumerable: true,
	  get: function get() {
	    return _ScrollCaptor.default;
	  }
	});
	
	var _A11yText = _interopRequireDefault(__webpack_require__(2089));
	
	var _DummyInput = _interopRequireDefault(__webpack_require__(2090));
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(495));
	
	var _ScrollBlock = _interopRequireDefault(__webpack_require__(2091));
	
	var _ScrollCaptor = _interopRequireDefault(__webpack_require__(2092));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(2241));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(1019));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(1022));
	var _assertThisInitialized = _interopDefault(__webpack_require__(1018));
	var _inheritsLoose = _interopDefault(__webpack_require__(1020));
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(13);
	
	var isIE =  !!document.documentElement.currentStyle ;
	var HIDDEN_TEXTAREA_STYLE = {
	  'min-height': '0',
	  'max-height': 'none',
	  height: '0',
	  visibility: 'hidden',
	  overflow: 'hidden',
	  position: 'absolute',
	  'z-index': '-1000',
	  top: '0',
	  right: '0'
	};
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
	var computedStyleCache = {};
	var hiddenTextarea =  document.createElement('textarea');
	
	var forceHiddenStyles = function forceHiddenStyles(node) {
	  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
	    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
	  });
	};
	
	{
	  hiddenTextarea.setAttribute('tab-index', '-1');
	  hiddenTextarea.setAttribute('aria-hidden', 'true');
	  forceHiddenStyles(hiddenTextarea);
	}
	
	function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
	  if (useCache === void 0) {
	    useCache = false;
	  }
	
	  if (minRows === void 0) {
	    minRows = null;
	  }
	
	  if (maxRows === void 0) {
	    maxRows = null;
	  }
	
	  if (hiddenTextarea.parentNode === null) {
	    document.body.appendChild(hiddenTextarea);
	  } // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	
	  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);
	
	  if (nodeStyling === null) {
	    return null;
	  }
	
	  var paddingSize = nodeStyling.paddingSize,
	      borderSize = nodeStyling.borderSize,
	      boxSizing = nodeStyling.boxSizing,
	      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	  Object.keys(sizingStyle).forEach(function (key) {
	    hiddenTextarea.style[key] = sizingStyle[key];
	  });
	  forceHiddenStyles(hiddenTextarea);
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
	  var minHeight = -Infinity;
	  var maxHeight = Infinity;
	  var height = hiddenTextarea.scrollHeight;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height = height - paddingSize;
	  } // measure height of a textarea with a single row
	
	
	  hiddenTextarea.value = 'x';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize; // Stores the value's rows count rendered in `hiddenTextarea`,
	  // regardless if `maxRows` or `minRows` props are passed
	
	  var valueRowCount = Math.floor(height / singleRowHeight);
	
	  if (minRows !== null) {
	    minHeight = singleRowHeight * minRows;
	
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	
	    height = Math.max(minHeight, height);
	  }
	
	  if (maxRows !== null) {
	    maxHeight = singleRowHeight * maxRows;
	
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	
	    height = Math.min(maxHeight, height);
	  }
	
	  var rowCount = Math.floor(height / singleRowHeight);
	  return {
	    height: height,
	    minHeight: minHeight,
	    maxHeight: maxHeight,
	    rowCount: rowCount,
	    valueRowCount: valueRowCount
	  };
	}
	
	function calculateNodeStyling(node, uid, useCache) {
	  if (useCache === void 0) {
	    useCache = false;
	  }
	
	  if (useCache && computedStyleCache[uid]) {
	    return computedStyleCache[uid];
	  }
	
	  var style = window.getComputedStyle(node);
	
	  if (style === null) {
	    return null;
	  }
	
	  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
	    obj[name] = style.getPropertyValue(name);
	    return obj;
	  }, {});
	  var boxSizing = sizingStyle['box-sizing']; // probably node is detached from DOM, can't read computed dimensions
	
	  if (boxSizing === '') {
	    return null;
	  } // IE (Edge has already correct behaviour) returns content width as computed width
	  // so we need to add manually padding and border widths
	
	
	  if (isIE && boxSizing === 'border-box') {
	    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
	  }
	
	  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
	  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache) {
	    computedStyleCache[uid] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	
	var purgeCache = function purgeCache(uid) {
	  delete computedStyleCache[uid];
	};
	
	var noop = function noop() {};
	
	var uid = 0;
	
	var TextareaAutosize =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TextareaAutosize, _React$Component);
	
	  function TextareaAutosize(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	
	    _this._onRef = function (node) {
	      _this._ref = node;
	      var inputRef = _this.props.inputRef;
	
	      if (typeof inputRef === 'function') {
	        inputRef(node);
	        return;
	      }
	
	      inputRef.current = node;
	    };
	
	    _this._onChange = function (event) {
	      if (!_this._controlled) {
	        _this._resizeComponent();
	      }
	
	      _this.props.onChange(event, _assertThisInitialized(_this));
	    };
	
	    _this._resizeComponent = function (callback) {
	      if (callback === void 0) {
	        callback = noop;
	      }
	
	      var nodeHeight = calculateNodeHeight(_this._ref, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);
	
	      if (nodeHeight === null) {
	        callback();
	        return;
	      }
	
	      var height = nodeHeight.height,
	          minHeight = nodeHeight.minHeight,
	          maxHeight = nodeHeight.maxHeight,
	          rowCount = nodeHeight.rowCount,
	          valueRowCount = nodeHeight.valueRowCount;
	      _this.rowCount = rowCount;
	      _this.valueRowCount = valueRowCount;
	
	      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
	        _this.setState({
	          height: height,
	          minHeight: minHeight,
	          maxHeight: maxHeight
	        }, callback);
	
	        return;
	      }
	
	      callback();
	    };
	
	    _this.state = {
	      height: props.style && props.style.height || 0,
	      minHeight: -Infinity,
	      maxHeight: Infinity
	    };
	    _this._uid = uid++;
	    _this._controlled = props.value !== undefined;
	    _this._resizeLock = false;
	    return _this;
	  }
	
	  var _proto = TextareaAutosize.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _inputRef = _this$props.inputRef,
	        _maxRows = _this$props.maxRows,
	        _minRows = _this$props.minRows,
	        _onHeightChange = _this$props.onHeightChange,
	        _useCacheForDOMMeasurements = _this$props.useCacheForDOMMeasurements,
	        props = _objectWithoutPropertiesLoose(_this$props, ["inputRef", "maxRows", "minRows", "onHeightChange", "useCacheForDOMMeasurements"]);
	
	    props.style = _extends({}, props.style, {
	      height: this.state.height
	    });
	    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);
	
	    if (maxHeight < this.state.height) {
	      props.style.overflow = 'hidden';
	    }
	
	    return React.createElement("textarea", _extends({}, props, {
	      onChange: this._onChange,
	      ref: this._onRef
	    }));
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
	    // causing competing rerenders (due to setState in the listener) in React.
	    // More can be found here - facebook/react#6324
	
	
	    this._resizeListener = function () {
	      if (_this2._resizeLock) {
	        return;
	      }
	
	      _this2._resizeLock = true;
	
	      _this2._resizeComponent(function () {
	        _this2._resizeLock = false;
	      });
	    };
	
	    window.addEventListener('resize', this._resizeListener);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps !== this.props) {
	      this._resizeComponent();
	    }
	
	    if (this.state.height !== prevState.height) {
	      this.props.onHeightChange(this.state.height, this);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this._resizeListener);
	    purgeCache(this._uid);
	  };
	
	  return TextareaAutosize;
	}(React.Component);
	
	TextareaAutosize.defaultProps = {
	  inputRef: noop,
	  onChange: noop,
	  onHeightChange: noop,
	  useCacheForDOMMeasurements: false
	};
	 false ? TextareaAutosize.propTypes = {
	  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
	    current: PropTypes.any
	  })]),
	  maxRows: PropTypes.number,
	  minRows: PropTypes.number,
	  onChange: PropTypes.func,
	  onHeightChange: PropTypes.func,
	  style: PropTypes.object,
	  useCacheForDOMMeasurements: PropTypes.bool,
	  value: PropTypes.string
	} : void 0;
	
	exports.default = TextareaAutosize;


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(13));
	
	var _addClass = _interopRequireDefault(__webpack_require__(1555));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1557));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(881));
	
	var _PropTypes = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(45);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(882));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
	 */
	var ArrowKeyStepper = function (_Component) {
	  _inherits(ArrowKeyStepper, _Component);
	
	  function ArrowKeyStepper(props, context) {
	    _classCallCheck(this, ArrowKeyStepper);
	
	    var _this = _possibleConstructorReturn(this, (ArrowKeyStepper.__proto__ || Object.getPrototypeOf(ArrowKeyStepper)).call(this, props, context));
	
	    _this.state = {
	      scrollToColumn: 0,
	      scrollToRow: 0
	    };
	
	    _this._columnStartIndex = 0;
	    _this._columnStopIndex = 0;
	    _this._rowStartIndex = 0;
	    _this._rowStopIndex = 0;
	
	    _this._onKeyDown = _this._onKeyDown.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(ArrowKeyStepper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var children = _props.children;
	      var _state = this.state;
	      var scrollToColumn = _state.scrollToColumn;
	      var scrollToRow = _state.scrollToRow;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          onKeyDown: this._onKeyDown
	        },
	        children({
	          onSectionRendered: this._onSectionRendered,
	          scrollToColumn: scrollToColumn,
	          scrollToRow: scrollToRow
	        })
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onKeyDown',
	    value: function _onKeyDown(event) {
	      var _props2 = this.props;
	      var columnCount = _props2.columnCount;
	      var rowCount = _props2.rowCount;
	
	      // The above cases all prevent default event event behavior.
	      // This is to keep the grid from scrolling after the snap-to update.
	
	      switch (event.key) {
	        case 'ArrowDown':
	          event.preventDefault();
	          this.setState({
	            scrollToRow: Math.min(this._rowStopIndex + 1, rowCount - 1)
	          });
	          break;
	        case 'ArrowLeft':
	          event.preventDefault();
	          this.setState({
	            scrollToColumn: Math.max(this._columnStartIndex - 1, 0)
	          });
	          break;
	        case 'ArrowRight':
	          event.preventDefault();
	          this.setState({
	            scrollToColumn: Math.min(this._columnStopIndex + 1, columnCount - 1)
	          });
	          break;
	        case 'ArrowUp':
	          event.preventDefault();
	          this.setState({
	            scrollToRow: Math.max(this._rowStartIndex - 1, 0)
	          });
	          break;
	      }
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref) {
	      var columnStartIndex = _ref.columnStartIndex;
	      var columnStopIndex = _ref.columnStopIndex;
	      var rowStartIndex = _ref.rowStartIndex;
	      var rowStopIndex = _ref.rowStopIndex;
	
	      this._columnStartIndex = columnStartIndex;
	      this._columnStopIndex = columnStopIndex;
	      this._rowStartIndex = rowStartIndex;
	      this._rowStopIndex = rowStopIndex;
	    }
	  }]);
	
	  return ArrowKeyStepper;
	}(_react.Component);
	
	ArrowKeyStepper.propTypes = {
	  children: _react.PropTypes.func.isRequired,
	  className: _react.PropTypes.string,
	  columnCount: _react.PropTypes.number.isRequired,
	  rowCount: _react.PropTypes.number.isRequired
	};
	exports.default = ArrowKeyStepper;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArrowKeyStepper = exports.default = undefined;
	
	var _ArrowKeyStepper2 = __webpack_require__(2102);
	
	var _ArrowKeyStepper3 = _interopRequireDefault(_ArrowKeyStepper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArrowKeyStepper3.default;
	exports.ArrowKeyStepper = _ArrowKeyStepper3.default;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Decorator component that automatically adjusts the width and height of a single child.
	 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
	 * All other properties will be passed through to the child component.
	 */
	var AutoSizer = function (_Component) {
	  _inherits(AutoSizer, _Component);
	
	  function AutoSizer(props) {
	    _classCallCheck(this, AutoSizer);
	
	    var _this = _possibleConstructorReturn(this, (AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call(this, props));
	
	    _this.state = {
	      height: 0,
	      width: 0
	    };
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutoSizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Delay access of parentNode until mount.
	      // This handles edge-cases where the component has already been unmounted before its ref has been set,
	      // As well as libraries like react-lite which have a slightly different lifecycle.
	      this._parentNode = this._autoSizer.parentNode;
	
	      // Defer requiring resize handler in order to support server-side rendering.
	      // See issue #41
	      this._detectElementResize = __webpack_require__(2134);
	      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	      this._onResize();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._detectElementResize) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var disableHeight = _props.disableHeight;
	      var disableWidth = _props.disableWidth;
	      var _state = this.state;
	      var height = _state.height;
	      var width = _state.width;
	
	      // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = { overflow: 'visible' };
	
	      if (!disableHeight) {
	        outerStyle.height = 0;
	      }
	
	      if (!disableWidth) {
	        outerStyle.width = 0;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setRef,
	          onScroll: this._onScroll,
	          style: outerStyle
	        },
	        children({ height: height, width: width })
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      var onResize = this.props.onResize;
	
	      // Gaurd against AutoSizer component being removed from the DOM immediately after being added.
	      // This can result in invalid style values which can result in NaN values if we don't handle them.
	      // See issue #150 for more context.
	
	      var boundingRect = this._parentNode.getBoundingClientRect();
	      var height = boundingRect.height || 0;
	      var width = boundingRect.width || 0;
	
	      var style = getComputedStyle(this._parentNode);
	      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
	      var paddingRight = parseInt(style.paddingRight, 10) || 0;
	      var paddingTop = parseInt(style.paddingTop, 10) || 0;
	      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
	
	      this.setState({
	        height: height - paddingTop - paddingBottom,
	        width: width - paddingLeft - paddingRight
	      });
	
	      onResize({ height: height, width: width });
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // Prevent detectElementResize library from being triggered by this scroll event.
	      event.stopPropagation();
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(autoSizer) {
	      this._autoSizer = autoSizer;
	    }
	  }]);
	
	  return AutoSizer;
	}(_react.Component);
	
	AutoSizer.propTypes = {
	  /**
	   * Function respondible for rendering children.
	   * This function should implement the following signature:
	   * ({ height, width }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Disable dynamic :height property */
	  disableHeight: _react.PropTypes.bool,
	
	  /** Disable dynamic :width property */
	  disableWidth: _react.PropTypes.bool,
	
	  /** Callback to be invoked on-resize: ({ height, width }) */
	  onResize: _react.PropTypes.func.isRequired
	};
	AutoSizer.defaultProps = {
	  onResize: function onResize() {}
	};
	exports.default = AutoSizer;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AutoSizer = exports.default = undefined;
	
	var _AutoSizer2 = __webpack_require__(2104);
	
	var _AutoSizer3 = _interopRequireDefault(_AutoSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoSizer3.default;
	exports.AutoSizer = _AutoSizer3.default;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _defaultCellSizeCache = __webpack_require__(885);
	
	var _defaultCellSizeCache2 = _interopRequireDefault(_defaultCellSizeCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Measures a Grid cell's contents by rendering them in a way that is not visible to the user.
	 * Either a fixed width or height may be provided if it is desirable to measure only in one direction.
	 */
	var CellMeasurer = function (_Component) {
	  _inherits(CellMeasurer, _Component);
	
	  function CellMeasurer(props, state) {
	    _classCallCheck(this, CellMeasurer);
	
	    var _this = _possibleConstructorReturn(this, (CellMeasurer.__proto__ || Object.getPrototypeOf(CellMeasurer)).call(this, props, state));
	
	    _this._cellSizeCache = props.cellSizeCache || new _defaultCellSizeCache2.default();
	
	    _this.getColumnWidth = _this.getColumnWidth.bind(_this);
	    _this.getRowHeight = _this.getRowHeight.bind(_this);
	    _this.resetMeasurements = _this.resetMeasurements.bind(_this);
	    _this.resetMeasurementForColumn = _this.resetMeasurementForColumn.bind(_this);
	    _this.resetMeasurementForRow = _this.resetMeasurementForRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(CellMeasurer, [{
	    key: 'getColumnWidth',
	    value: function getColumnWidth(_ref) {
	      var index = _ref.index;
	
	      if (this._cellSizeCache.hasColumnWidth(index)) {
	        return this._cellSizeCache.getColumnWidth(index);
	      }
	
	      var rowCount = this.props.rowCount;
	
	
	      var maxWidth = 0;
	
	      for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
	        var _measureCell2 = this._measureCell({
	          clientWidth: true,
	          columnIndex: index,
	          rowIndex: rowIndex
	        });
	
	        var width = _measureCell2.width;
	
	
	        maxWidth = Math.max(maxWidth, width);
	      }
	
	      this._cellSizeCache.setColumnWidth(index, maxWidth);
	
	      return maxWidth;
	    }
	  }, {
	    key: 'getRowHeight',
	    value: function getRowHeight(_ref2) {
	      var index = _ref2.index;
	
	      if (this._cellSizeCache.hasRowHeight(index)) {
	        return this._cellSizeCache.getRowHeight(index);
	      }
	
	      var columnCount = this.props.columnCount;
	
	
	      var maxHeight = 0;
	
	      for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
	        var _measureCell3 = this._measureCell({
	          clientHeight: true,
	          columnIndex: columnIndex,
	          rowIndex: index
	        });
	
	        var height = _measureCell3.height;
	
	
	        maxHeight = Math.max(maxHeight, height);
	      }
	
	      this._cellSizeCache.setRowHeight(index, maxHeight);
	
	      return maxHeight;
	    }
	  }, {
	    key: 'resetMeasurementForColumn',
	    value: function resetMeasurementForColumn(columnIndex) {
	      this._cellSizeCache.clearColumnWidth(columnIndex);
	    }
	  }, {
	    key: 'resetMeasurementForRow',
	    value: function resetMeasurementForRow(rowIndex) {
	      this._cellSizeCache.clearRowHeight(rowIndex);
	    }
	  }, {
	    key: 'resetMeasurements',
	    value: function resetMeasurements() {
	      this._cellSizeCache.clearAllColumnWidths();
	      this._cellSizeCache.clearAllRowHeights();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._renderAndMount();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var cellSizeCache = this.props.cellSizeCache;
	
	
	      if (cellSizeCache !== nextProps.cellSizeCache) {
	        this._cellSizeCache = nextProps.cellSizeCache;
	      }
	
	      this._updateDivDimensions(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unmountContainer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        getColumnWidth: this.getColumnWidth,
	        getRowHeight: this.getRowHeight,
	        resetMeasurements: this.resetMeasurements,
	        resetMeasurementForColumn: this.resetMeasurementForColumn,
	        resetMeasurementForRow: this.resetMeasurementForRow
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_getContainerNode',
	    value: function _getContainerNode(props) {
	      var container = props.container;
	
	
	      if (container) {
	        return _reactDom2.default.findDOMNode(typeof container === 'function' ? container() : container);
	      } else {
	        return document.body;
	      }
	    }
	  }, {
	    key: '_measureCell',
	    value: function _measureCell(_ref3) {
	      var _ref3$clientHeight = _ref3.clientHeight;
	      var clientHeight = _ref3$clientHeight === undefined ? false : _ref3$clientHeight;
	      var _ref3$clientWidth = _ref3.clientWidth;
	      var clientWidth = _ref3$clientWidth === undefined ? true : _ref3$clientWidth;
	      var columnIndex = _ref3.columnIndex;
	      var rowIndex = _ref3.rowIndex;
	      var cellRenderer = this.props.cellRenderer;
	
	
	      var rendered = cellRenderer({
	        columnIndex: columnIndex,
	        rowIndex: rowIndex
	      });
	
	      // Handle edge case where this method is called before the CellMeasurer has completed its initial render (and mounted).
	      this._renderAndMount();
	
	      // @TODO Keep an eye on this for future React updates as the interface may change:
	      // https://twitter.com/soprano/status/737316379712331776
	      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, rendered, this._div);
	
	      var measurements = {
	        height: clientHeight && this._div.clientHeight,
	        width: clientWidth && this._div.clientWidth
	      };
	
	      _reactDom2.default.unmountComponentAtNode(this._div);
	
	      return measurements;
	    }
	  }, {
	    key: '_renderAndMount',
	    value: function _renderAndMount() {
	      if (!this._div) {
	        this._div = document.createElement('div');
	        this._div.style.display = 'inline-block';
	        this._div.style.position = 'absolute';
	        this._div.style.visibility = 'hidden';
	        this._div.style.zIndex = -1;
	
	        this._updateDivDimensions(this.props);
	
	        this._containerNode = this._getContainerNode(this.props);
	        this._containerNode.appendChild(this._div);
	      }
	    }
	  }, {
	    key: '_unmountContainer',
	    value: function _unmountContainer() {
	      if (this._div) {
	        this._containerNode.removeChild(this._div);
	
	        this._div = null;
	      }
	
	      this._containerNode = null;
	    }
	  }, {
	    key: '_updateDivDimensions',
	    value: function _updateDivDimensions(props) {
	      var height = props.height;
	      var width = props.width;
	
	
	      if (height && height !== this._divHeight) {
	        this._divHeight = height;
	        this._div.style.height = height + 'px';
	      }
	
	      if (width && width !== this._divWidth) {
	        this._divWidth = width;
	        this._div.style.width = width + 'px';
	      }
	    }
	  }]);
	
	  return CellMeasurer;
	}(_react.Component);
	
	CellMeasurer.propTypes = {
	  /**
	   * Renders a cell given its indices.
	   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optional, custom caching strategy for cell sizes.
	   */
	  cellSizeCache: _react.PropTypes.object,
	
	  /**
	   * Function respondible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ getColumnWidth, getRowHeight, resetMeasurements }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of columns in grid.
	   */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * A Node, Component instance, or function that returns either.
	   * If this property is not specified the document body will be used.
	   */
	  container: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.func, _react2.default.PropTypes.node]),
	
	  /**
	   * Assign a fixed :height in order to measure dynamic text :width only.
	   */
	  height: _react.PropTypes.number,
	
	  /**
	   * Number of rows in grid.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Assign a fixed :width in order to measure dynamic text :height only.
	   */
	  width: _react.PropTypes.number
	};
	exports.default = CellMeasurer;

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultCellSizeCache = exports.CellMeasurer = exports.default = undefined;
	
	var _CellMeasurer2 = __webpack_require__(2106);
	
	var _CellMeasurer3 = _interopRequireDefault(_CellMeasurer2);
	
	var _defaultCellSizeCache2 = __webpack_require__(885);
	
	var _defaultCellSizeCache3 = _interopRequireDefault(_defaultCellSizeCache2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CellMeasurer3.default;
	exports.CellMeasurer = _CellMeasurer3.default;
	exports.defaultCellSizeCache = _defaultCellSizeCache3.default;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CollectionView = __webpack_require__(2109);
	
	var _CollectionView2 = _interopRequireDefault(_CollectionView);
	
	var _calculateSizeAndPositionData2 = __webpack_require__(2113);
	
	var _calculateSizeAndPositionData3 = _interopRequireDefault(_calculateSizeAndPositionData2);
	
	var _getUpdatedOffsetForIndex = __webpack_require__(2133);
	
	var _getUpdatedOffsetForIndex2 = _interopRequireDefault(_getUpdatedOffsetForIndex);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders scattered or non-linear data.
	 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
	 */
	var Collection = function (_Component) {
	  _inherits(Collection, _Component);
	
	  function Collection(props, context) {
	    _classCallCheck(this, Collection);
	
	    var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props, context));
	
	    _this._cellMetadata = [];
	    _this._lastRenderedCellIndices = [];
	
	    // Cell cache during scroll (for perforamnce)
	    _this._cellCache = [];
	
	    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
	    return _this;
	  }
	
	  /** See Collection#recomputeCellSizesAndPositions */
	
	
	  _createClass(Collection, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._cellCache = [];
	      this._collectionView.recomputeCellSizesAndPositions();
	    }
	
	    /** React lifecycle methods */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = _objectWithoutProperties(this.props, []);
	
	      return _react2.default.createElement(_CollectionView2.default, _extends({
	        cellLayoutManager: this,
	        isScrollingChange: this._isScrollingChange,
	        ref: function ref(_ref) {
	          _this2._collectionView = _ref;
	        }
	      }, props));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /** CellLayoutManager interface */
	
	  }, {
	    key: 'calculateSizeAndPositionData',
	    value: function calculateSizeAndPositionData() {
	      var _props = this.props;
	      var cellCount = _props.cellCount;
	      var cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter;
	      var sectionSize = _props.sectionSize;
	
	
	      var data = (0, _calculateSizeAndPositionData3.default)({
	        cellCount: cellCount,
	        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
	        sectionSize: sectionSize
	      });
	
	      this._cellMetadata = data.cellMetadata;
	      this._sectionManager = data.sectionManager;
	      this._height = data.height;
	      this._width = data.width;
	    }
	
	    /**
	     * Returns the most recently rendered set of cell indices.
	     */
	
	  }, {
	    key: 'getLastRenderedIndices',
	    value: function getLastRenderedIndices() {
	      return this._lastRenderedCellIndices;
	    }
	
	    /**
	     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
	     */
	
	  }, {
	    key: 'getScrollPositionForCell',
	    value: function getScrollPositionForCell(_ref2) {
	      var align = _ref2.align;
	      var cellIndex = _ref2.cellIndex;
	      var height = _ref2.height;
	      var scrollLeft = _ref2.scrollLeft;
	      var scrollTop = _ref2.scrollTop;
	      var width = _ref2.width;
	      var cellCount = this.props.cellCount;
	
	
	      if (cellIndex >= 0 && cellIndex < cellCount) {
	        var cellMetadata = this._cellMetadata[cellIndex];
	
	        scrollLeft = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.x,
	          cellSize: cellMetadata.width,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: cellIndex
	        });
	
	        scrollTop = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.y,
	          cellSize: cellMetadata.height,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: cellIndex
	        });
	      }
	
	      return {
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      };
	    }
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return {
	        height: this._height,
	        width: this._width
	      };
	    }
	  }, {
	    key: 'cellRenderers',
	    value: function cellRenderers(_ref3) {
	      var _this3 = this;
	
	      var height = _ref3.height;
	      var isScrolling = _ref3.isScrolling;
	      var width = _ref3.width;
	      var x = _ref3.x;
	      var y = _ref3.y;
	      var _props2 = this.props;
	      var cellGroupRenderer = _props2.cellGroupRenderer;
	      var cellRenderer = _props2.cellRenderer;
	
	      // Store for later calls to getLastRenderedIndices()
	
	      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
	        height: height,
	        width: width,
	        x: x,
	        y: y
	      });
	
	      return cellGroupRenderer({
	        cellCache: this._cellCache,
	        cellRenderer: cellRenderer,
	        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref4) {
	          var index = _ref4.index;
	          return _this3._sectionManager.getCellMetadata({ index: index });
	        },
	        indices: this._lastRenderedCellIndices,
	        isScrolling: isScrolling
	      });
	    }
	  }, {
	    key: '_isScrollingChange',
	    value: function _isScrollingChange(isScrolling) {
	      if (!isScrolling) {
	        this._cellCache = [];
	      }
	    }
	  }]);
	
	  return Collection;
	}(_react.Component);
	
	Collection.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Number of cells in Collection.
	   */
	  cellCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their indices.
	   * Should implement the following interface: ({
	   *   cellSizeAndPositionGetter:Function,
	   *   indices: Array<number>,
	   *   cellRenderer: Function
	   * }): Array<PropTypes.node>
	   */
	  cellGroupRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ index: number }): PropTypes.element
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback responsible for returning size and offset/position information for a given cell (index).
	   * ({ index: number }): { height: number, width: number, x: number, y: number }
	   */
	  cellSizeAndPositionGetter: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optionally override the size of the sections a Collection's cells are split into.
	   */
	  sectionSize: _react.PropTypes.number
	};
	Collection.defaultProps = {
	  'aria-label': 'grid',
	  cellGroupRenderer: defaultCellGroupRenderer
	};
	exports.default = Collection;
	
	
	function defaultCellGroupRenderer(_ref5) {
	  var cellCache = _ref5.cellCache;
	  var cellRenderer = _ref5.cellRenderer;
	  var cellSizeAndPositionGetter = _ref5.cellSizeAndPositionGetter;
	  var indices = _ref5.indices;
	  var isScrolling = _ref5.isScrolling;
	
	  return indices.map(function (index) {
	    var cellMetadata = cellSizeAndPositionGetter({ index: index });
	
	    // Avoid re-creating cells while scrolling.
	    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	    // If a scroll is in progress- cache and reuse cells.
	    // This cache will be thrown away once scrolling complets.
	    var renderedCell = void 0;
	
	    if (isScrolling) {
	      if (!(index in cellCache)) {
	        cellCache[index] = cellRenderer({
	          index: index,
	          isScrolling: isScrolling
	        });
	      }
	
	      renderedCell = cellCache[index];
	    } else {
	      renderedCell = cellRenderer({
	        index: index,
	        isScrolling: isScrolling
	      });
	    }
	
	    if (renderedCell == null || renderedCell === false) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'Collection__cell',
	        key: index,
	        style: {
	          height: cellMetadata.height,
	          left: cellMetadata.x,
	          top: cellMetadata.y,
	          width: cellMetadata.width
	        }
	      },
	      renderedCell
	    );
	  }).filter(function (renderedCell) {
	    return !!renderedCell;
	  });
	}

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createCallbackMemoizer = __webpack_require__(498);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _scrollbarSize = __webpack_require__(894);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _raf = __webpack_require__(163);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// @TODO It would be nice to refactor Grid to use this code as well.
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
	 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
	 */
	
	var CollectionView = function (_Component) {
	  _inherits(CollectionView, _Component);
	
	  function CollectionView(props, context) {
	    _classCallCheck(this, CollectionView);
	
	    var _this = _possibleConstructorReturn(this, (CollectionView.__proto__ || Object.getPrototypeOf(CollectionView)).call(this, props, context));
	
	    _this.state = {
	      calculateSizeAndPositionDataOnNextUpdate: false,
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    // Invokes callbacks only when their values have changed.
	    _this._onSectionRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around.
	    _this._invokeOnSectionRenderedHelper = _this._invokeOnSectionRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._updateScrollPositionForScrollToCell = _this._updateScrollPositionForScrollToCell.bind(_this);
	    return _this;
	  }
	
	  /**
	   * Forced recompute of cell sizes and positions.
	   * This function should be called if cell sizes have changed but nothing else has.
	   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
	   */
	
	
	  _createClass(CollectionView, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this.setState({
	        calculateSizeAndPositionDataOnNextUpdate: true
	      });
	    }
	
	    /* ---------------------------- Component lifecycle methods ---------------------------- */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props;
	      var cellLayoutManager = _props.cellLayoutManager;
	      var scrollLeft = _props.scrollLeft;
	      var scrollToCell = _props.scrollToCell;
	      var scrollTop = _props.scrollTop;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollToCell >= 0) {
	        this._updateScrollPositionForScrollToCell();
	      } else if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      // Update onSectionRendered callback.
	      this._invokeOnSectionRenderedHelper();
	
	      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge.height;
	      var totalWidth = _cellLayoutManager$ge.width;
	
	      // Initialize onScroll callback.
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalHeight: totalHeight,
	        totalWidth: totalWidth
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props;
	      var height = _props2.height;
	      var scrollToCell = _props2.scrollToCell;
	      var width = _props2.width;
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
	      var scrollToAlignment = _state.scrollToAlignment;
	      var scrollTop = _state.scrollTop;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToCell values requires it
	      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
	        this._updateScrollPositionForScrollToCell();
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnSectionRenderedHelper();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var cellLayoutManager = this.props.cellLayoutManager;
	
	
	      cellLayoutManager.calculateSizeAndPositionData();
	
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      if (this._setNextStateAnimationFrameId) {
	        _raf2.default.cancel(this._setNextStateAnimationFrameId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextProps.cellCount === 0 && (nextState.scrollLeft !== 0 || nextState.scrollTop !== 0)) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        this._setScrollPosition({
	          scrollLeft: nextProps.scrollLeft,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	
	      if (nextProps.cellCount !== this.props.cellCount || nextProps.cellLayoutManager !== this.props.cellLayoutManager || nextState.calculateSizeAndPositionDataOnNextUpdate) {
	        nextProps.cellLayoutManager.calculateSizeAndPositionData();
	      }
	
	      if (nextState.calculateSizeAndPositionDataOnNextUpdate) {
	        this.setState({
	          calculateSizeAndPositionDataOnNextUpdate: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props;
	      var autoHeight = _props3.autoHeight;
	      var cellCount = _props3.cellCount;
	      var cellLayoutManager = _props3.cellLayoutManager;
	      var className = _props3.className;
	      var height = _props3.height;
	      var horizontalOverscanSize = _props3.horizontalOverscanSize;
	      var noContentRenderer = _props3.noContentRenderer;
	      var style = _props3.style;
	      var verticalOverscanSize = _props3.verticalOverscanSize;
	      var width = _props3.width;
	      var _state2 = this.state;
	      var isScrolling = _state2.isScrolling;
	      var scrollLeft = _state2.scrollLeft;
	      var scrollTop = _state2.scrollTop;
	
	      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge2.height;
	      var totalWidth = _cellLayoutManager$ge2.width;
	
	      // Safely expand the rendered area by the specified overscan amount
	
	      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
	      var top = Math.max(0, scrollTop - verticalOverscanSize);
	      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
	      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
	
	      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
	        height: bottom - top,
	        isScrolling: isScrolling,
	        width: right - left,
	        x: left,
	        y: top
	      }) : [];
	
	      var collectionStyle = {
	        height: autoHeight ? 'auto' : height,
	        width: width
	      };
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;
	      if (totalWidth + verticalScrollBarSize <= width) {
	        collectionStyle.overflowX = 'hidden';
	      }
	      if (totalHeight + horizontalScrollBarSize <= height) {
	        collectionStyle.overflowY = 'hidden';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(_ref) {
	            _this2._scrollingContainer = _ref;
	          },
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('Collection', className),
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: _extends({}, collectionStyle, style),
	          tabIndex: 0
	        },
	        cellCount > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'Collection__innerScrollContainer',
	            style: {
	              height: totalHeight,
	              maxHeight: totalHeight,
	              maxWidth: totalWidth,
	              pointerEvents: isScrolling ? 'none' : '',
	              width: totalWidth
	            }
	          },
	          childrenToDisplay
	        ),
	        cellCount === 0 && noContentRenderer()
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Collection.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_enablePointerEventsAfterDelay',
	    value: function _enablePointerEventsAfterDelay() {
	      var _this3 = this;
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(function () {
	        var isScrollingChange = _this3.props.isScrollingChange;
	
	
	        isScrollingChange(false);
	
	        _this3._disablePointerEventsTimeoutId = null;
	        _this3.setState({
	          isScrolling: false
	        });
	      }, IS_SCROLLING_TIMEOUT);
	    }
	  }, {
	    key: '_invokeOnSectionRenderedHelper',
	    value: function _invokeOnSectionRenderedHelper() {
	      var _props4 = this.props;
	      var cellLayoutManager = _props4.cellLayoutManager;
	      var onSectionRendered = _props4.onSectionRendered;
	
	
	      this._onSectionRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          indices: cellLayoutManager.getLastRenderedIndices()
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref2) {
	      var _this4 = this;
	
	      var scrollLeft = _ref2.scrollLeft;
	      var scrollTop = _ref2.scrollTop;
	      var totalHeight = _ref2.totalHeight;
	      var totalWidth = _ref2.totalWidth;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref3) {
	          var scrollLeft = _ref3.scrollLeft;
	          var scrollTop = _ref3.scrollTop;
	          var _props5 = _this4.props;
	          var height = _props5.height;
	          var onScroll = _props5.onScroll;
	          var width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	
	    /**
	     * Updates the state during the next animation frame.
	     * Use this method to avoid multiple renders in a small span of time.
	     * This helps performance for bursty events (like onScroll).
	     */
	
	  }, {
	    key: '_setNextState',
	    value: function _setNextState(state) {
	      var _this5 = this;
	
	      if (this._setNextStateAnimationFrameId) {
	        _raf2.default.cancel(this._setNextStateAnimationFrameId);
	      }
	
	      this._setNextStateAnimationFrameId = (0, _raf2.default)(function () {
	        _this5._setNextStateAnimationFrameId = null;
	        _this5.setState(state);
	      });
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref4) {
	      var scrollLeft = _ref4.scrollLeft;
	      var scrollTop = _ref4.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_updateScrollPositionForScrollToCell',
	    value: function _updateScrollPositionForScrollToCell() {
	      var _props6 = this.props;
	      var cellLayoutManager = _props6.cellLayoutManager;
	      var height = _props6.height;
	      var scrollToAlignment = _props6.scrollToAlignment;
	      var scrollToCell = _props6.scrollToCell;
	      var width = _props6.width;
	      var _state3 = this.state;
	      var scrollLeft = _state3.scrollLeft;
	      var scrollTop = _state3.scrollTop;
	
	
	      if (scrollToCell >= 0) {
	        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
	          align: scrollToAlignment,
	          cellIndex: scrollToCell,
	          height: height,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          width: width
	        });
	
	        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
	          this._setScrollPosition(scrollPosition);
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._enablePointerEventsAfterDelay();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props7 = this.props;
	      var cellLayoutManager = _props7.cellLayoutManager;
	      var height = _props7.height;
	      var isScrollingChange = _props7.isScrollingChange;
	      var width = _props7.width;
	
	      var scrollbarSize = this._scrollbarSize;
	
	      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge3.height;
	      var totalWidth = _cellLayoutManager$ge3.width;
	
	      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
	      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
	        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
	        // All things considered, this seems to be the best current work around that I'm aware of.
	        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
	        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;
	
	        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
	        if (!this.state.isScrolling) {
	          isScrollingChange(true);
	
	          this.setState({
	            isScrolling: true
	          });
	        }
	
	        this._setNextState({
	          isScrolling: true,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: scrollPositionChangeReason,
	          scrollTop: scrollTop
	        });
	      }
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalWidth: totalWidth,
	        totalHeight: totalHeight
	      });
	    }
	  }]);
	
	  return CollectionView;
	}(_react.Component);
	
	CollectionView.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /**
	   * Number of cells in collection.
	   */
	  cellCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
	   */
	  cellLayoutManager: _react.PropTypes.object.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Collection element.
	   */
	  className: _react.PropTypes.string,
	
	  /**
	   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _react.PropTypes.number.isRequired,
	
	  /**
	   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  horizontalOverscanSize: _react.PropTypes.number.isRequired,
	
	  isScrollingChange: _react.PropTypes.func,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
	   */
	  noContentRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Collection that was just rendered.
	   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
	   */
	  onSectionRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Horizontal offset.
	   */
	  scrollLeft: _react.PropTypes.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Cell index to ensure visible (by forcefully scrolling if necessary).
	   */
	  scrollToCell: _react.PropTypes.number,
	
	  /**
	   * Vertical offset.
	   */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Optional custom inline style to attach to root Collection element.
	   */
	  style: _react.PropTypes.object,
	
	  /**
	   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  verticalOverscanSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _react.PropTypes.number.isRequired
	};
	CollectionView.defaultProps = {
	  'aria-label': 'grid',
	  horizontalOverscanSize: 0,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  scrollToAlignment: 'auto',
	  style: {},
	  verticalOverscanSize: 0
	};
	exports.default = CollectionView;

/***/ }),
/* 2110 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A section of the Window.
	 * Window Sections are used to group nearby cells.
	 * This enables us to more quickly determine which cells to display in a given region of the Window.
	 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
	 */
	var Section = function () {
	  function Section(_ref) {
	    var height = _ref.height;
	    var width = _ref.width;
	    var x = _ref.x;
	    var y = _ref.y;
	
	    _classCallCheck(this, Section);
	
	    this.height = height;
	    this.width = width;
	    this.x = x;
	    this.y = y;
	
	    this._indexMap = {};
	    this._indices = [];
	  }
	
	  /** Add a cell to this section. */
	
	
	  _createClass(Section, [{
	    key: 'addCellIndex',
	    value: function addCellIndex(_ref2) {
	      var index = _ref2.index;
	
	      if (!this._indexMap[index]) {
	        this._indexMap[index] = true;
	        this._indices.push(index);
	      }
	    }
	
	    /** Get all cell indices that have been added to this section. */
	
	  }, {
	    key: 'getCellIndices',
	    value: function getCellIndices() {
	      return this._indices;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
	    }
	  }]);
	
	  return Section;
	}(); /** @rlow */
	
	
	exports.default = Section;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Window Sections are used to group nearby cells.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This enables us to more quickly determine which cells to display in a given region of the Window.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _Section = __webpack_require__(2110);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SECTION_SIZE = 100;
	
	/**
	 * Contains 0 to many Sections.
	 * Grows (and adds Sections) dynamically as cells are registered.
	 * Automatically adds cells to the appropriate Section(s).
	 */
	var SectionManager = function () {
	  function SectionManager() {
	    var sectionSize = arguments.length <= 0 || arguments[0] === undefined ? SECTION_SIZE : arguments[0];
	
	    _classCallCheck(this, SectionManager);
	
	    this._sectionSize = sectionSize;
	
	    this._cellMetadata = [];
	    this._sections = {};
	  }
	
	  /**
	   * Gets all cell indices contained in the specified region.
	   * A region may encompass 1 or more Sections.
	   */
	
	
	  _createClass(SectionManager, [{
	    key: 'getCellIndices',
	    value: function getCellIndices(_ref) {
	      var height = _ref.height;
	      var width = _ref.width;
	      var x = _ref.x;
	      var y = _ref.y;
	
	      var indices = {};
	
	      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
	        return section.getCellIndices().forEach(function (index) {
	          indices[index] = index;
	        });
	      });
	
	      // Object keys are strings; this function returns numbers
	      return Object.keys(indices).map(function (index) {
	        return indices[index];
	      });
	    }
	
	    /** Get size and position information for the cell specified. */
	
	  }, {
	    key: 'getCellMetadata',
	    value: function getCellMetadata(_ref2) {
	      var index = _ref2.index;
	
	      return this._cellMetadata[index];
	    }
	
	    /** Get all Sections overlapping the specified region. */
	
	  }, {
	    key: 'getSections',
	    value: function getSections(_ref3) {
	      var height = _ref3.height;
	      var width = _ref3.width;
	      var x = _ref3.x;
	      var y = _ref3.y;
	
	      var sectionXStart = Math.floor(x / this._sectionSize);
	      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
	      var sectionYStart = Math.floor(y / this._sectionSize);
	      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
	
	      var sections = [];
	
	      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
	        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
	          var key = sectionX + '.' + sectionY;
	
	          if (!this._sections[key]) {
	            this._sections[key] = new _Section2.default({
	              height: this._sectionSize,
	              width: this._sectionSize,
	              x: sectionX * this._sectionSize,
	              y: sectionY * this._sectionSize
	            });
	          }
	
	          sections.push(this._sections[key]);
	        }
	      }
	
	      return sections;
	    }
	
	    /** Total number of Sections based on the currently registered cells. */
	
	  }, {
	    key: 'getTotalSectionCount',
	    value: function getTotalSectionCount() {
	      return Object.keys(this._sections).length;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var _this = this;
	
	      return Object.keys(this._sections).map(function (index) {
	        return _this._sections[index].toString();
	      });
	    }
	
	    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
	
	  }, {
	    key: 'registerCell',
	    value: function registerCell(_ref4) {
	      var cellMetadatum = _ref4.cellMetadatum;
	      var index = _ref4.index;
	
	      this._cellMetadata[index] = cellMetadatum;
	
	      this.getSections(cellMetadatum).forEach(function (section) {
	        return section.addCellIndex({ index: index });
	      });
	    }
	  }]);
	
	  return SectionManager;
	}();
	
	exports.default = SectionManager;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collection = exports.default = undefined;
	
	var _Collection2 = __webpack_require__(2108);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collection3.default;
	exports.Collection = _Collection3.default;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionData;
	
	var _SectionManager = __webpack_require__(2111);
	
	var _SectionManager2 = _interopRequireDefault(_SectionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateSizeAndPositionData(_ref) {
	  var cellCount = _ref.cellCount;
	  var cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter;
	  var sectionSize = _ref.sectionSize;
	
	  var cellMetadata = [];
	  var sectionManager = new _SectionManager2.default(sectionSize);
	  var height = 0;
	  var width = 0;
	
	  for (var index = 0; index < cellCount; index++) {
	    var cellMetadatum = cellSizeAndPositionGetter({ index: index });
	
	    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
	      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
	    }
	
	    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
	    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
	
	    cellMetadata[index] = cellMetadatum;
	    sectionManager.registerCell({
	      cellMetadatum: cellMetadatum,
	      index: index
	    });
	  }
	
	  return {
	    cellMetadata: cellMetadata,
	    height: height,
	    sectionManager: sectionManager,
	    width: width
	  };
	}

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Grid = __webpack_require__(345);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * High-order component that auto-calculates column-widths for `Grid` cells.
	 */
	var ColumnSizer = function (_Component) {
	  _inherits(ColumnSizer, _Component);
	
	  function ColumnSizer(props, context) {
	    _classCallCheck(this, ColumnSizer);
	
	    var _this = _possibleConstructorReturn(this, (ColumnSizer.__proto__ || Object.getPrototypeOf(ColumnSizer)).call(this, props, context));
	
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(ColumnSizer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props;
	      var columnMaxWidth = _props.columnMaxWidth;
	      var columnMinWidth = _props.columnMinWidth;
	      var columnCount = _props.columnCount;
	      var width = _props.width;
	
	
	      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
	        if (this._registeredChild) {
	          this._registeredChild.recomputeGridSize();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var children = _props2.children;
	      var columnMaxWidth = _props2.columnMaxWidth;
	      var columnMinWidth = _props2.columnMinWidth;
	      var columnCount = _props2.columnCount;
	      var width = _props2.width;
	
	
	      var safeColumnMinWidth = columnMinWidth || 1;
	
	      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
	
	      var columnWidth = width / columnCount;
	      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
	      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
	      columnWidth = Math.floor(columnWidth);
	
	      var adjustedWidth = Math.min(width, columnWidth * columnCount);
	
	      return children({
	        adjustedWidth: adjustedWidth,
	        getColumnWidth: function getColumnWidth() {
	          return columnWidth;
	        },
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(child) {
	      if (child !== null && !(child instanceof _Grid2.default)) {
	        throw Error('Unexpected child type registered; only Grid children are supported.');
	      }
	
	      this._registeredChild = child;
	
	      if (this._registeredChild) {
	        this._registeredChild.recomputeGridSize();
	      }
	    }
	  }]);
	
	  return ColumnSizer;
	}(_react.Component);
	
	ColumnSizer.propTypes = {
	  /**
	   * Function respondible for rendering a virtualized Grid.
	   * This function should implement the following signature:
	   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
	   *
	   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
	   * The :registerChild should be passed to the Grid's :ref property.
	   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Optional maximum allowed column width */
	  columnMaxWidth: _react.PropTypes.number,
	
	  /** Optional minimum allowed column width */
	  columnMinWidth: _react.PropTypes.number,
	
	  /** Number of columns in Grid or FlexTable child */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /** Width of Grid or FlexTable child */
	  width: _react.PropTypes.number.isRequired
	};
	exports.default = ColumnSizer;

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColumnSizer = exports.default = undefined;
	
	var _ColumnSizer2 = __webpack_require__(2114);
	
	var _ColumnSizer3 = _interopRequireDefault(_ColumnSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ColumnSizer3.default;
	exports.ColumnSizer = _ColumnSizer3.default;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FlexColumn = __webpack_require__(886);
	
	var _FlexColumn2 = _interopRequireDefault(_FlexColumn);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Grid = __webpack_require__(345);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _defaultRowRenderer = __webpack_require__(891);
	
	var _defaultRowRenderer2 = _interopRequireDefault(_defaultRowRenderer);
	
	var _SortDirection = __webpack_require__(497);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
	 * This component expects explicit width, height, and padding parameters.
	 */
	var FlexTable = function (_Component) {
	  _inherits(FlexTable, _Component);
	
	  function FlexTable(props) {
	    _classCallCheck(this, FlexTable);
	
	    var _this = _possibleConstructorReturn(this, (FlexTable.__proto__ || Object.getPrototypeOf(FlexTable)).call(this, props));
	
	    _this.state = {
	      scrollbarWidth: 0
	    };
	
	    _this._cellClassName = _this._cellClassName.bind(_this);
	    _this._cellStyle = _this._cellStyle.bind(_this);
	    _this._createColumn = _this._createColumn.bind(_this);
	    _this._createRow = _this._createRow.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(FlexTable, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	      this.forceUpdateGrid();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var disableHeader = _props.disableHeader;
	      var gridClassName = _props.gridClassName;
	      var gridStyle = _props.gridStyle;
	      var headerHeight = _props.headerHeight;
	      var height = _props.height;
	      var noRowsRenderer = _props.noRowsRenderer;
	      var rowClassName = _props.rowClassName;
	      var rowStyle = _props.rowStyle;
	      var scrollToIndex = _props.scrollToIndex;
	      var style = _props.style;
	      var width = _props.width;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var availableRowsHeight = height - headerHeight;
	
	      var rowClass = rowClassName instanceof Function ? rowClassName({ index: -1 }) : rowClassName;
	      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: -1 }) : rowStyle;
	
	      // Precompute and cache column styles before rendering rows and columns to speed things up
	      this._cachedColumnStyles = [];
	      _react2.default.Children.toArray(children).forEach(function (column, index) {
	        _this2._cachedColumnStyles[index] = _this2._getFlexStyleForColumn(column, column.props.style);
	      });
	
	      // Note that we specify :numChildren, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
	      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
	      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('FlexTable', className),
	          style: style
	        },
	        !disableHeader && _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('FlexTable__headerRow', rowClass),
	            style: _extends({}, rowStyleObject, {
	              height: headerHeight,
	              paddingRight: scrollbarWidth,
	              width: width
	            })
	          },
	          this._getRenderedHeaderRow()
	        ),
	        _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	          autoContainerWidth: true,
	          className: (0, _classnames2.default)('FlexTable__Grid', gridClassName),
	          cellClassName: this._cellClassName,
	          cellRenderer: this._createRow,
	          cellStyle: this._cellStyle,
	          columnWidth: width,
	          columnCount: 1,
	          height: availableRowsHeight,
	          noContentRenderer: noRowsRenderer,
	          onScroll: this._onScroll,
	          onSectionRendered: this._onSectionRendered,
	          ref: function ref(_ref) {
	            _this2.Grid = _ref;
	          },
	          scrollbarWidth: scrollbarWidth,
	          scrollToRow: scrollToIndex,
	          style: gridStyle
	        }))
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_cellClassName',
	    value: function _cellClassName(_ref2) {
	      var rowIndex = _ref2.rowIndex;
	      var rowWrapperClassName = this.props.rowWrapperClassName;
	
	
	      return rowWrapperClassName instanceof Function ? rowWrapperClassName({ index: rowIndex - 1 }) : rowWrapperClassName;
	    }
	  }, {
	    key: '_cellStyle',
	    value: function _cellStyle(_ref3) {
	      var rowIndex = _ref3.rowIndex;
	      var rowWrapperStyle = this.props.rowWrapperStyle;
	
	
	      return rowWrapperStyle instanceof Function ? rowWrapperStyle({ index: rowIndex - 1 }) : rowWrapperStyle;
	    }
	  }, {
	    key: '_createColumn',
	    value: function _createColumn(_ref4) {
	      var column = _ref4.column;
	      var columnIndex = _ref4.columnIndex;
	      var isScrolling = _ref4.isScrolling;
	      var rowData = _ref4.rowData;
	      var rowIndex = _ref4.rowIndex;
	      var _column$props = column.props;
	      var cellDataGetter = _column$props.cellDataGetter;
	      var cellRenderer = _column$props.cellRenderer;
	      var className = _column$props.className;
	      var columnData = _column$props.columnData;
	      var dataKey = _column$props.dataKey;
	
	
	      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
	      var renderedCell = cellRenderer({ cellData: cellData, columnData: columnData, dataKey: dataKey, isScrolling: isScrolling, rowData: rowData, rowIndex: rowIndex });
	
	      var style = this._cachedColumnStyles[columnIndex];
	
	      var title = typeof renderedCell === 'string' ? renderedCell : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: 'Row' + rowIndex + '-Col' + columnIndex,
	          className: (0, _classnames2.default)('FlexTable__rowColumn', className),
	          style: style,
	          title: title
	        },
	        renderedCell
	      );
	    }
	  }, {
	    key: '_createHeader',
	    value: function _createHeader(_ref5) {
	      var column = _ref5.column;
	      var index = _ref5.index;
	      var _props2 = this.props;
	      var headerClassName = _props2.headerClassName;
	      var headerStyle = _props2.headerStyle;
	      var onHeaderClick = _props2.onHeaderClick;
	      var sort = _props2.sort;
	      var sortBy = _props2.sortBy;
	      var sortDirection = _props2.sortDirection;
	      var _column$props2 = column.props;
	      var dataKey = _column$props2.dataKey;
	      var disableSort = _column$props2.disableSort;
	      var headerRenderer = _column$props2.headerRenderer;
	      var label = _column$props2.label;
	      var columnData = _column$props2.columnData;
	
	      var sortEnabled = !disableSort && sort;
	
	      var classNames = (0, _classnames2.default)('FlexTable__headerColumn', headerClassName, column.props.headerClassName, {
	        'FlexTable__sortableHeaderColumn': sortEnabled
	      });
	      var style = this._getFlexStyleForColumn(column, headerStyle);
	
	      var renderedHeader = headerRenderer({
	        columnData: columnData,
	        dataKey: dataKey,
	        disableSort: disableSort,
	        label: label,
	        sortBy: sortBy,
	        sortDirection: sortDirection
	      });
	
	      var a11yProps = {};
	
	      if (sortEnabled || onHeaderClick) {
	        (function () {
	          // If this is a sortable header, clicking it should update the table data's sorting.
	          var newSortDirection = sortBy !== dataKey || sortDirection === _SortDirection2.default.DESC ? _SortDirection2.default.ASC : _SortDirection2.default.DESC;
	
	          var onClick = function onClick() {
	            sortEnabled && sort({
	              sortBy: dataKey,
	              sortDirection: newSortDirection
	            });
	            onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey });
	          };
	
	          var onKeyDown = function onKeyDown(event) {
	            if (event.key === 'Enter' || event.key === ' ') {
	              onClick();
	            }
	          };
	
	          a11yProps['aria-label'] = column.props['aria-label'] || label || dataKey;
	          a11yProps.role = 'rowheader';
	          a11yProps.tabIndex = 0;
	          a11yProps.onClick = onClick;
	          a11yProps.onKeyDown = onKeyDown;
	        })();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, a11yProps, {
	          key: 'Header-Col' + index,
	          className: classNames,
	          style: style
	        }),
	        renderedHeader
	      );
	    }
	  }, {
	    key: '_createRow',
	    value: function _createRow(_ref6) {
	      var _this3 = this;
	
	      var index = _ref6.rowIndex;
	      var isScrolling = _ref6.isScrolling;
	      var _props3 = this.props;
	      var children = _props3.children;
	      var onRowClick = _props3.onRowClick;
	      var onRowDoubleClick = _props3.onRowDoubleClick;
	      var onRowMouseOver = _props3.onRowMouseOver;
	      var onRowMouseOut = _props3.onRowMouseOut;
	      var rowClassName = _props3.rowClassName;
	      var rowGetter = _props3.rowGetter;
	      var rowRenderer = _props3.rowRenderer;
	      var rowStyle = _props3.rowStyle;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var rowClass = rowClassName instanceof Function ? rowClassName({ index: index }) : rowClassName;
	      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: index }) : rowStyle;
	      var rowData = rowGetter({ index: index });
	
	      var columns = _react2.default.Children.toArray(children).map(function (column, columnIndex) {
	        return _this3._createColumn({
	          column: column,
	          columnIndex: columnIndex,
	          isScrolling: isScrolling,
	          rowData: rowData,
	          rowIndex: index,
	          scrollbarWidth: scrollbarWidth
	        });
	      });
	
	      var className = (0, _classnames2.default)('FlexTable__row', rowClass);
	      var style = _extends({}, rowStyleObject, {
	        height: this._getRowHeight(index),
	        paddingRight: scrollbarWidth
	      });
	
	      return rowRenderer({
	        className: className,
	        columns: columns,
	        index: index,
	        isScrolling: isScrolling,
	        onRowClick: onRowClick,
	        onRowDoubleClick: onRowDoubleClick,
	        onRowMouseOver: onRowMouseOver,
	        onRowMouseOut: onRowMouseOut,
	        rowData: rowData,
	        style: style
	      });
	    }
	
	    /**
	     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
	     */
	
	  }, {
	    key: '_getFlexStyleForColumn',
	    value: function _getFlexStyleForColumn(column) {
	      var customStyle = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';
	
	      var style = _extends({}, customStyle, {
	        flex: flexValue,
	        msFlex: flexValue,
	        WebkitFlex: flexValue
	      });
	
	      if (column.props.maxWidth) {
	        style.maxWidth = column.props.maxWidth;
	      }
	
	      if (column.props.minWidth) {
	        style.minWidth = column.props.minWidth;
	      }
	
	      return style;
	    }
	  }, {
	    key: '_getRenderedHeaderRow',
	    value: function _getRenderedHeaderRow() {
	      var _this4 = this;
	
	      var _props4 = this.props;
	      var children = _props4.children;
	      var disableHeader = _props4.disableHeader;
	
	      var items = disableHeader ? [] : _react2.default.Children.toArray(children);
	
	      return items.map(function (column, index) {
	        return _this4._createHeader({ column: column, index: index });
	      });
	    }
	  }, {
	    key: '_getRowHeight',
	    value: function _getRowHeight(rowIndex) {
	      var rowHeight = this.props.rowHeight;
	
	
	      return rowHeight instanceof Function ? rowHeight({ index: rowIndex }) : rowHeight;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref7) {
	      var clientHeight = _ref7.clientHeight;
	      var scrollHeight = _ref7.scrollHeight;
	      var scrollTop = _ref7.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref8) {
	      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex;
	      var rowOverscanStopIndex = _ref8.rowOverscanStopIndex;
	      var rowStartIndex = _ref8.rowStartIndex;
	      var rowStopIndex = _ref8.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }, {
	    key: '_setScrollbarWidth',
	    value: function _setScrollbarWidth() {
	      var Grid = (0, _reactDom.findDOMNode)(this.Grid);
	      var clientWidth = Grid.clientWidth || 0;
	      var offsetWidth = Grid.offsetWidth || 0;
	      var scrollbarWidth = offsetWidth - clientWidth;
	
	      this.setState({ scrollbarWidth: scrollbarWidth });
	    }
	  }]);
	
	  return FlexTable;
	}(_react.Component);
	
	FlexTable.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /** One or more FlexColumns describing the data displayed in this row */
	  children: function children(props, propName, componentName) {
	    var children = _react2.default.Children.toArray(props.children);
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].type !== _FlexColumn2.default) {
	        return new Error('FlexTable only accepts children of type FlexColumn');
	      }
	    }
	  },
	
	  /** Optional CSS class name */
	  className: _react.PropTypes.string,
	
	  /** Disable rendering the header at all */
	  disableHeader: _react.PropTypes.bool,
	
	  /**
	   * Used to estimate the total height of a FlexTable before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /** Optional custom CSS class name to attach to inner Grid element. */
	  gridClassName: _react.PropTypes.string,
	
	  /** Optional inline style to attach to inner Grid element. */
	  gridStyle: _react.PropTypes.object,
	
	  /** Optional CSS class to apply to all column headers */
	  headerClassName: _react.PropTypes.string,
	
	  /** Fixed height of header row */
	  headerHeight: _react.PropTypes.number.isRequired,
	
	  /** Fixed/available height for out DOM element */
	  height: _react.PropTypes.number.isRequired,
	
	  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
	  noRowsRenderer: _react.PropTypes.func,
	
	  /**
	  * Optional callback when a column's header is clicked.
	  * ({ columnData: any, dataKey: string }): void
	  */
	  onHeaderClick: _react.PropTypes.func,
	
	  /** Optional custom inline style to attach to table header columns. */
	  headerStyle: _react.PropTypes.object,
	
	  /**
	   * Callback invoked when a user clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowClick: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when a user double-clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowDoubleClick: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when the mouse leaves a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOut: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when a user moves the mouse over a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOver: _react.PropTypes.func,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _react.PropTypes.func,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional CSS class to apply to all table rows (including the header row).
	   * This property can be a CSS class name (string) or a function that returns a class name.
	   * If a function is provided its signature should be: ({ index: number }): string
	   */
	  rowClassName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	
	  /**
	   * Callback responsible for returning a data row given an index.
	   * ({ index: number }): any
	   */
	  rowGetter: _react.PropTypes.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Number of rows in table. */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: Array,
	   *   index: number,
	   *   isScrolling: boolean,
	   *   onRowClick: ?Function,
	   *   onRowDoubleClick: ?Function,
	   *   onRowMouseOver: ?Function,
	   *   onRowMouseOut: ?Function,
	   *   rowData: any,
	   *   style: any
	   * }): PropTypes.node
	   */
	  rowRenderer: _react.PropTypes.func,
	
	  /** Optional custom inline style to attach to table rows. */
	  rowStyle: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]).isRequired,
	
	  /** Optional custom CSS class for individual rows */
	  rowWrapperClassName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	
	  /** Optional custom CSS class for individual rows */
	  rowWrapperStyle: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]),
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Sort function to be called if a sortable header is clicked.
	   * ({ sortBy: string, sortDirection: SortDirection }): void
	   */
	  sort: _react.PropTypes.func,
	
	  /** FlexTable data is currently sorted by this :dataKey (if it is sorted at all) */
	  sortBy: _react.PropTypes.string,
	
	  /** FlexTable data is currently sorted in this direction (if it is sorted at all) */
	  sortDirection: _react.PropTypes.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC]),
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /** Width of list */
	  width: _react.PropTypes.number.isRequired
	};
	FlexTable.defaultProps = {
	  disableHeader: false,
	  estimatedRowSize: 30,
	  headerHeight: 0,
	  headerStyle: {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanRowCount: 10,
	  rowRenderer: _defaultRowRenderer2.default,
	  rowStyle: {},
	  scrollToAlignment: 'auto',
	  style: {}
	};
	exports.default = FlexTable;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SortIndicator = exports.SortDirection = exports.FlexColumn = exports.FlexTable = exports.defaultRowRenderer = exports.defaultHeaderRenderer = exports.defaultCellRenderer = exports.defaultCellDataGetter = exports.default = undefined;
	
	var _FlexTable2 = __webpack_require__(2116);
	
	var _FlexTable3 = _interopRequireDefault(_FlexTable2);
	
	var _defaultCellDataGetter2 = __webpack_require__(888);
	
	var _defaultCellDataGetter3 = _interopRequireDefault(_defaultCellDataGetter2);
	
	var _defaultCellRenderer2 = __webpack_require__(889);
	
	var _defaultCellRenderer3 = _interopRequireDefault(_defaultCellRenderer2);
	
	var _defaultHeaderRenderer2 = __webpack_require__(890);
	
	var _defaultHeaderRenderer3 = _interopRequireDefault(_defaultHeaderRenderer2);
	
	var _defaultRowRenderer2 = __webpack_require__(891);
	
	var _defaultRowRenderer3 = _interopRequireDefault(_defaultRowRenderer2);
	
	var _FlexColumn2 = __webpack_require__(886);
	
	var _FlexColumn3 = _interopRequireDefault(_FlexColumn2);
	
	var _SortDirection2 = __webpack_require__(497);
	
	var _SortDirection3 = _interopRequireDefault(_SortDirection2);
	
	var _SortIndicator2 = __webpack_require__(887);
	
	var _SortIndicator3 = _interopRequireDefault(_SortIndicator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlexTable3.default;
	exports.defaultCellDataGetter = _defaultCellDataGetter3.default;
	exports.defaultCellRenderer = _defaultCellRenderer3.default;
	exports.defaultHeaderRenderer = _defaultHeaderRenderer3.default;
	exports.defaultRowRenderer = _defaultRowRenderer3.default;
	exports.FlexTable = _FlexTable3.default;
	exports.FlexColumn = _FlexColumn3.default;
	exports.SortDirection = _SortDirection3.default;
	exports.SortIndicator = _SortIndicator3.default;

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(2121);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(2120);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _createCallbackMemoizer = __webpack_require__(498);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _getOverscanIndices = __webpack_require__(2122);
	
	var _getOverscanIndices2 = _interopRequireDefault(_getOverscanIndices);
	
	var _scrollbarSize = __webpack_require__(894);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _raf = __webpack_require__(163);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _updateScrollIndexHelper = __webpack_require__(2123);
	
	var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);
	
	var _defaultCellRangeRenderer = __webpack_require__(892);
	
	var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Renders tabular data with virtualization along the vertical and horizontal axes.
	 * Row heights and column widths must be known ahead of time and specified as properties.
	 */
	
	var Grid = function (_Component) {
	  _inherits(Grid, _Component);
	
	  function Grid(props, context) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props, context));
	
	    _this.state = {
	      isScrolling: false,
	      scrollDirectionHorizontal: _getOverscanIndices.SCROLL_DIRECTION_FIXED,
	      scrollDirectionVertical: _getOverscanIndices.SCROLL_DIRECTION_FIXED,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    // Invokes onSectionRendered callback only when start/stop row or column indices change
	    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around
	    _this._enablePointerEventsAfterDelayCallback = _this._enablePointerEventsAfterDelayCallback.bind(_this);
	    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._setNextStateCallback = _this._setNextStateCallback.bind(_this);
	    _this._updateScrollLeftForScrollToColumn = _this._updateScrollLeftForScrollToColumn.bind(_this);
	    _this._updateScrollTopForScrollToRow = _this._updateScrollTopForScrollToRow.bind(_this);
	
	    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
	    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);
	
	    _this._columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.columnCount,
	      cellSizeGetter: function cellSizeGetter(index) {
	        return _this._columnWidthGetter(index);
	      },
	      estimatedCellSize: _this._getEstimatedColumnSize(props)
	    });
	    _this._rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.rowCount,
	      cellSizeGetter: function cellSizeGetter(index) {
	        return _this._rowHeightGetter(index);
	      },
	      estimatedCellSize: _this._getEstimatedRowSize(props)
	    });
	
	    // See defaultCellRangeRenderer() for more information on the usage of this cache
	    _this._cellCache = {};
	    return _this;
	  }
	
	  /**
	   * Pre-measure all columns and rows in a Grid.
	   * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
	   * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
	   */
	
	
	  _createClass(Grid, [{
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      var _props = this.props;
	      var columnCount = _props.columnCount;
	      var rowCount = _props.rowCount;
	
	
	      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
	      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
	    }
	
	    /**
	     * Forced recompute of row heights and column widths.
	     * This function should be called if dynamic column or row sizes have changed but nothing else has.
	     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
	     */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var _ref$columnIndex = _ref.columnIndex;
	      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
	      var _ref$rowIndex = _ref.rowIndex;
	      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	
	      this._columnSizeAndPositionManager.resetCell(columnIndex);
	      this._rowSizeAndPositionManager.resetCell(rowIndex);
	
	      // Clear cell cache in case we are scrolling;
	      // Invalid row heights likely mean invalid cached content as well.
	      this._cellCache = {};
	
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props;
	      var scrollLeft = _props2.scrollLeft;
	      var scrollToColumn = _props2.scrollToColumn;
	      var scrollTop = _props2.scrollTop;
	      var scrollToRow = _props2.scrollToRow;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      if (scrollToColumn >= 0 || scrollToRow >= 0) {
	        this._updateScrollLeftForScrollToColumn();
	        this._updateScrollTopForScrollToRow();
	      }
	
	      // Update onRowsRendered callback
	      this._invokeOnGridRenderedHelper();
	
	      // Initialize onScroll callback
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
	        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
	      });
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) New scroll-to-cell props have been set
	     */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _props3 = this.props;
	      var autoHeight = _props3.autoHeight;
	      var columnCount = _props3.columnCount;
	      var height = _props3.height;
	      var rowCount = _props3.rowCount;
	      var scrollToAlignment = _props3.scrollToAlignment;
	      var scrollToColumn = _props3.scrollToColumn;
	      var scrollToRow = _props3.scrollToRow;
	      var width = _props3.width;
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
	      var scrollTop = _state.scrollTop;
	
	      // Handle edge case where column or row count has only just increased over 0.
	      // In this case we may have to restore a previously-specified scroll offset.
	      // For more info see bvaughn/react-virtualized/issues/218
	
	      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	
	        // @TRICKY :autoHeight property instructs Grid to leave :scrollTop management to an external HOC (eg WindowScroller).
	        // In this case we should avoid checking scrollingContainer.scrollTop since it forces layout/flow.
	        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
	      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
	      (0, _updateScrollIndexHelper2.default)({
	        cellSizeAndPositionManager: this._columnSizeAndPositionManager,
	        previousCellsCount: prevProps.columnCount,
	        previousCellSize: prevProps.columnWidth,
	        previousScrollToAlignment: prevProps.scrollToAlignment,
	        previousScrollToIndex: prevProps.scrollToColumn,
	        previousSize: prevProps.width,
	        scrollOffset: scrollLeft,
	        scrollToAlignment: scrollToAlignment,
	        scrollToIndex: scrollToColumn,
	        size: width,
	        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
	          return _this2._updateScrollLeftForScrollToColumn(_extends({}, _this2.props, { scrollToColumn: scrollToColumn }));
	        }
	      });
	      (0, _updateScrollIndexHelper2.default)({
	        cellSizeAndPositionManager: this._rowSizeAndPositionManager,
	        previousCellsCount: prevProps.rowCount,
	        previousCellSize: prevProps.rowHeight,
	        previousScrollToAlignment: prevProps.scrollToAlignment,
	        previousScrollToIndex: prevProps.scrollToRow,
	        previousSize: prevProps.height,
	        scrollOffset: scrollTop,
	        scrollToAlignment: scrollToAlignment,
	        scrollToIndex: scrollToRow,
	        size: height,
	        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
	          return _this2._updateScrollTopForScrollToRow(_extends({}, _this2.props, { scrollToRow: scrollToRow }));
	        }
	      });
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnGridRenderedHelper();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	
	      this._calculateChildrenToRender();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      if (this._setNextStateAnimationFrameId) {
	        _raf2.default.cancel(this._setNextStateAnimationFrameId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _this3 = this;
	
	      if (nextProps.columnCount === 0 && nextState.scrollLeft !== 0 || nextProps.rowCount === 0 && nextState.scrollTop !== 0) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        this._setScrollPosition({
	          scrollLeft: nextProps.scrollLeft,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	
	      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
	      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);
	
	      this._columnSizeAndPositionManager.configure({
	        cellCount: nextProps.columnCount,
	        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
	      });
	      this._rowSizeAndPositionManager.configure({
	        cellCount: nextProps.rowCount,
	        estimatedCellSize: this._getEstimatedRowSize(nextProps)
	      });
	
	      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: this.props.columnCount,
	        cellSize: this.props.columnWidth,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._columnSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.columnCount,
	        nextCellSize: nextProps.columnWidth,
	        nextScrollToIndex: nextProps.scrollToColumn,
	        scrollToIndex: this.props.scrollToColumn,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollLeftForScrollToColumn(nextProps, nextState);
	        }
	      });
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: this.props.rowCount,
	        cellSize: this.props.rowHeight,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._rowSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.rowCount,
	        nextCellSize: nextProps.rowHeight,
	        nextScrollToIndex: nextProps.scrollToRow,
	        scrollToIndex: this.props.scrollToRow,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollTopForScrollToRow(nextProps, nextState);
	        }
	      });
	
	      this._calculateChildrenToRender(nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props4 = this.props;
	      var autoContainerWidth = _props4.autoContainerWidth;
	      var autoHeight = _props4.autoHeight;
	      var className = _props4.className;
	      var height = _props4.height;
	      var noContentRenderer = _props4.noContentRenderer;
	      var style = _props4.style;
	      var tabIndex = _props4.tabIndex;
	      var width = _props4.width;
	      var isScrolling = this.state.isScrolling;
	
	
	      var gridStyle = {
	        height: autoHeight ? 'auto' : height,
	        width: width
	      };
	
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      var childrenToDisplay = this._childrenToDisplay;
	
	      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(_ref2) {
	            _this4._scrollingContainer = _ref2;
	          },
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('Grid', className),
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: _extends({}, gridStyle, style),
	          tabIndex: tabIndex
	        },
	        childrenToDisplay.length > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'Grid__innerScrollContainer',
	            style: {
	              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
	              height: totalRowsHeight,
	              maxWidth: totalColumnsWidth,
	              maxHeight: totalRowsHeight,
	              pointerEvents: isScrolling ? 'none' : ''
	            }
	          },
	          childrenToDisplay
	        ),
	        showNoContentRenderer && noContentRenderer()
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	  }, {
	    key: '_calculateChildrenToRender',
	    value: function _calculateChildrenToRender() {
	      var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	      var state = arguments.length <= 1 || arguments[1] === undefined ? this.state : arguments[1];
	      var cellClassName = props.cellClassName;
	      var cellRenderer = props.cellRenderer;
	      var cellRangeRenderer = props.cellRangeRenderer;
	      var cellStyle = props.cellStyle;
	      var columnCount = props.columnCount;
	      var height = props.height;
	      var overscanColumnCount = props.overscanColumnCount;
	      var overscanRowCount = props.overscanRowCount;
	      var rowCount = props.rowCount;
	      var width = props.width;
	      var isScrolling = state.isScrolling;
	      var scrollDirectionHorizontal = state.scrollDirectionHorizontal;
	      var scrollDirectionVertical = state.scrollDirectionVertical;
	      var scrollLeft = state.scrollLeft;
	      var scrollTop = state.scrollTop;
	
	
	      this._childrenToDisplay = [];
	
	      // Render only enough columns and rows to cover the visible area of the grid.
	      if (height > 0 && width > 0) {
	        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._renderedColumnStartIndex = visibleColumnIndices.start;
	        this._renderedColumnStopIndex = visibleColumnIndices.stop;
	        this._renderedRowStartIndex = visibleRowIndices.start;
	        this._renderedRowStopIndex = visibleRowIndices.stop;
	
	        var overscanColumnIndices = (0, _getOverscanIndices2.default)({
	          cellCount: columnCount,
	          overscanCellsCount: overscanColumnCount,
	          scrollDirection: scrollDirectionHorizontal,
	          startIndex: this._renderedColumnStartIndex,
	          stopIndex: this._renderedColumnStopIndex
	        });
	
	        var overscanRowIndices = (0, _getOverscanIndices2.default)({
	          cellCount: rowCount,
	          overscanCellsCount: overscanRowCount,
	          scrollDirection: scrollDirectionVertical,
	          startIndex: this._renderedRowStartIndex,
	          stopIndex: this._renderedRowStopIndex
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
	        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
	        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
	        this._rowStopIndex = overscanRowIndices.overscanStopIndex;
	
	        this._childrenToDisplay = cellRangeRenderer({
	          cellCache: this._cellCache,
	          cellClassName: this._wrapCellClassNameGetter(cellClassName),
	          cellRenderer: cellRenderer,
	          cellStyle: this._wrapCellStyleGetter(cellStyle),
	          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
	          columnStartIndex: this._columnStartIndex,
	          columnStopIndex: this._columnStopIndex,
	          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
	          isScrolling: isScrolling,
	          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
	          rowStartIndex: this._rowStartIndex,
	          rowStopIndex: this._rowStopIndex,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          verticalOffsetAdjustment: verticalOffsetAdjustment
	        });
	      }
	    }
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Grid.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_enablePointerEventsAfterDelay',
	    value: function _enablePointerEventsAfterDelay() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(this._enablePointerEventsAfterDelayCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_enablePointerEventsAfterDelayCallback',
	    value: function _enablePointerEventsAfterDelayCallback() {
	      this._disablePointerEventsTimeoutId = null;
	
	      // Throw away cell cache once scrolling is complete
	      this._cellCache = {};
	
	      this.setState({
	        isScrolling: false,
	        scrollDirectionHorizontal: _getOverscanIndices.SCROLL_DIRECTION_FIXED,
	        scrollDirectionVertical: _getOverscanIndices.SCROLL_DIRECTION_FIXED
	      });
	    }
	  }, {
	    key: '_getEstimatedColumnSize',
	    value: function _getEstimatedColumnSize(props) {
	      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
	    }
	  }, {
	    key: '_getEstimatedRowSize',
	    value: function _getEstimatedRowSize(props) {
	      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
	    }
	  }, {
	    key: '_invokeOnGridRenderedHelper',
	    value: function _invokeOnGridRenderedHelper() {
	      var onSectionRendered = this.props.onSectionRendered;
	
	
	      this._onGridRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          columnOverscanStartIndex: this._columnStartIndex,
	          columnOverscanStopIndex: this._columnStopIndex,
	          columnStartIndex: this._renderedColumnStartIndex,
	          columnStopIndex: this._renderedColumnStopIndex,
	          rowOverscanStartIndex: this._rowStartIndex,
	          rowOverscanStopIndex: this._rowStopIndex,
	          rowStartIndex: this._renderedRowStartIndex,
	          rowStopIndex: this._renderedRowStopIndex
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref3) {
	      var _this5 = this;
	
	      var scrollLeft = _ref3.scrollLeft;
	      var scrollTop = _ref3.scrollTop;
	      var totalColumnsWidth = _ref3.totalColumnsWidth;
	      var totalRowsHeight = _ref3.totalRowsHeight;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref4) {
	          var scrollLeft = _ref4.scrollLeft;
	          var scrollTop = _ref4.scrollTop;
	          var _props5 = _this5.props;
	          var height = _props5.height;
	          var onScroll = _props5.onScroll;
	          var width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalRowsHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalColumnsWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	
	    /**
	     * Updates the state during the next animation frame.
	     * Use this method to avoid multiple renders in a small span of time.
	     * This helps performance for bursty events (like onScroll).
	     */
	
	  }, {
	    key: '_setNextState',
	    value: function _setNextState(state) {
	      this._nextState = state;
	
	      if (!this._setNextStateAnimationFrameId) {
	        this._setNextStateAnimationFrameId = (0, _raf2.default)(this._setNextStateCallback);
	      }
	    }
	  }, {
	    key: '_setNextStateCallback',
	    value: function _setNextStateCallback() {
	      var state = this._nextState;
	
	      this._setNextStateAnimationFrameId = null;
	      this._nextState = null;
	
	      this.setState(state);
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref5) {
	      var scrollLeft = _ref5.scrollLeft;
	      var scrollTop = _ref5.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_wrapCellClassNameGetter',
	    value: function _wrapCellClassNameGetter(className) {
	      return this._wrapPropertyGetter(className);
	    }
	  }, {
	    key: '_wrapCellStyleGetter',
	    value: function _wrapCellStyleGetter(style) {
	      return this._wrapPropertyGetter(style);
	    }
	  }, {
	    key: '_wrapPropertyGetter',
	    value: function _wrapPropertyGetter(value) {
	      return value instanceof Function ? value : function () {
	        return value;
	      };
	    }
	  }, {
	    key: '_wrapSizeGetter',
	    value: function _wrapSizeGetter(size) {
	      return this._wrapPropertyGetter(size);
	    }
	  }, {
	    key: '_updateScrollLeftForScrollToColumn',
	    value: function _updateScrollLeftForScrollToColumn() {
	      var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	      var state = arguments.length <= 1 || arguments[1] === undefined ? this.state : arguments[1];
	      var columnCount = props.columnCount;
	      var scrollToAlignment = props.scrollToAlignment;
	      var scrollToColumn = props.scrollToColumn;
	      var width = props.width;
	      var scrollLeft = state.scrollLeft;
	
	
	      if (scrollToColumn >= 0 && columnCount > 0) {
	        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));
	
	        var calculatedScrollLeft = this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: targetIndex
	        });
	
	        if (scrollLeft !== calculatedScrollLeft) {
	          this._setScrollPosition({
	            scrollLeft: calculatedScrollLeft
	          });
	        }
	      }
	    }
	  }, {
	    key: '_updateScrollTopForScrollToRow',
	    value: function _updateScrollTopForScrollToRow() {
	      var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	      var state = arguments.length <= 1 || arguments[1] === undefined ? this.state : arguments[1];
	      var height = props.height;
	      var rowCount = props.rowCount;
	      var scrollToAlignment = props.scrollToAlignment;
	      var scrollToRow = props.scrollToRow;
	      var scrollTop = state.scrollTop;
	
	
	      if (scrollToRow >= 0 && rowCount > 0) {
	        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));
	
	        var calculatedScrollTop = this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: targetIndex
	        });
	
	        if (scrollTop !== calculatedScrollTop) {
	          this._setScrollPosition({
	            scrollTop: calculatedScrollTop
	          });
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._enablePointerEventsAfterDelay();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props6 = this.props;
	      var height = _props6.height;
	      var width = _props6.width;
	
	      var scrollbarSize = this._scrollbarSize;
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), event.target.scrollLeft);
	      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), event.target.scrollTop);
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
	        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
	        // All things considered, this seems to be the best current work around that I'm aware of.
	        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
	        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;
	
	        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
	        var scrollDirectionVertical = scrollTop > this.state.scrollTop ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        var scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	
	        if (!this.state.isScrolling) {
	          this.setState({
	            isScrolling: true
	          });
	        }
	
	        this._setNextState({
	          isScrolling: true,
	          scrollDirectionHorizontal: scrollDirectionHorizontal,
	          scrollDirectionVertical: scrollDirectionVertical,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: scrollPositionChangeReason,
	          scrollTop: scrollTop
	        });
	      }
	
	      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	    }
	  }]);
	
	  return Grid;
	}(_react.Component);
	
	Grid.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Set the width of the inner scrollable container to 'auto'.
	   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
	   */
	  autoContainerWidth: _react.PropTypes.bool,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /** Optional custom CSS class for individual cells */
	  cellClassName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	
	  /** Optional custom styles for individual cells */
	  cellStyle: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]),
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their index ranges.
	   * Should implement the following interface: ({
	   *   cellCache: Map,
	   *   cellRenderer: Function,
	   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
	   *   columnStartIndex: number,
	   *   columnStopIndex: number,
	   *   isScrolling: boolean,
	   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
	   *   rowStartIndex: number,
	   *   rowStopIndex: number,
	   *   scrollLeft: number,
	   *   scrollTop: number
	   * }): Array<PropTypes.node>
	   */
	  cellRangeRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Grid element.
	   */
	  className: _react.PropTypes.string,
	
	  /**
	   * Number of columns in grid.
	   */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Either a fixed column width (number) or a function that returns the width of a column given its index.
	   * Should implement the following interface: (index: number): number
	   */
	  columnWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /**
	   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
	   * The estimated total width is adjusted as columns are rendered.
	   */
	  estimatedColumnSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
	   */
	  noContentRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Grid that was just rendered.
	   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
	   */
	  onSectionRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of columns to render before/after the visible section of the grid.
	   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanColumnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible section of the grid.
	   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * Should implement the following interface: ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /**
	   * Number of rows in grid.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
	  scrollingResetTimeInterval: _react.PropTypes.number,
	
	  /** Horizontal offset. */
	  scrollLeft: _react.PropTypes.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Column index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToColumn: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Row index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToRow: _react.PropTypes.number,
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /**
	   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _react.PropTypes.number.isRequired
	};
	Grid.defaultProps = {
	  'aria-label': 'grid',
	  cellStyle: {},
	  cellRangeRenderer: _defaultCellRangeRenderer2.default,
	  estimatedColumnSize: 100,
	  estimatedRowSize: 30,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  overscanColumnCount: 0,
	  overscanRowCount: 10,
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  scrollToAlignment: 'auto',
	  style: {},
	  tabIndex: 0
	};
	exports.default = Grid;

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Just-in-time calculates and caches size and position information for a collection of cells.
	 */
	var CellSizeAndPositionManager = function () {
	  function CellSizeAndPositionManager(_ref) {
	    var cellCount = _ref.cellCount;
	    var cellSizeGetter = _ref.cellSizeGetter;
	    var estimatedCellSize = _ref.estimatedCellSize;
	
	    _classCallCheck(this, CellSizeAndPositionManager);
	
	    this._cellSizeGetter = cellSizeGetter;
	    this._cellCount = cellCount;
	    this._estimatedCellSize = estimatedCellSize;
	
	    // Cache of size and position data for cells, mapped by cell index.
	    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
	    this._cellSizeAndPositionData = {};
	
	    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
	    this._lastMeasuredIndex = -1;
	  }
	
	  _createClass(CellSizeAndPositionManager, [{
	    key: 'configure',
	    value: function configure(_ref2) {
	      var cellCount = _ref2.cellCount;
	      var estimatedCellSize = _ref2.estimatedCellSize;
	
	      this._cellCount = cellCount;
	      this._estimatedCellSize = estimatedCellSize;
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellCount;
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._estimatedCellSize;
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._lastMeasuredIndex;
	    }
	
	    /**
	     * This method returns the size and position for the cell at the specified index.
	     * It just-in-time calculates (or used cached values) for cells leading up to the index.
	     */
	
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      if (index < 0 || index >= this._cellCount) {
	        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
	      }
	
	      if (index > this._lastMeasuredIndex) {
	        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	
	        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
	          var _size = this._cellSizeGetter({ index: i });
	
	          if (_size == null || isNaN(_size)) {
	            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
	          }
	
	          this._cellSizeAndPositionData[i] = {
	            offset: _offset,
	            size: _size
	          };
	
	          _offset += _size;
	        }
	
	        this._lastMeasuredIndex = index;
	      }
	
	      return this._cellSizeAndPositionData[index];
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
	        offset: 0,
	        size: 0
	      };
	    }
	
	    /**
	     * Total size of all cells being measured.
	     * This value will be completedly estimated initially.
	     * As cells as measured the estimate will be updated.
	     */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	
	      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
	    }
	
	    /**
	     * Determines a new offset that ensures a certain cell is visible, given the current offset.
	     * If the cell is already visible then the current offset will be returned.
	     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	     *
	     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	     * @param containerSize Size (width or height) of the container viewport
	     * @param currentOffset Container's current (x or y) offset
	     * @param totalSize Total size (width or height) of all cells
	     * @return Offset to use to ensure the specified cell is visible
	     */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align;
	      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
	      var containerSize = _ref3.containerSize;
	      var currentOffset = _ref3.currentOffset;
	      var targetIndex = _ref3.targetIndex;
	
	      var datum = this.getSizeAndPositionOfCell(targetIndex);
	      var maxOffset = datum.offset;
	      var minOffset = maxOffset - containerSize + datum.size;
	
	      var idealOffset = void 0;
	
	      switch (align) {
	        case 'start':
	          idealOffset = maxOffset;
	          break;
	        case 'end':
	          idealOffset = minOffset;
	          break;
	        case 'center':
	          idealOffset = maxOffset - (containerSize - datum.size) / 2;
	          break;
	        default:
	          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
	          break;
	      }
	
	      var totalSize = this.getTotalSize();
	
	      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
	    }
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize;
	      var offset = _ref4.offset;
	
	      var totalSize = this.getTotalSize();
	
	      if (totalSize === 0) {
	        return {};
	      }
	
	      var maxOffset = offset + containerSize;
	      var start = this._findNearestCell(offset);
	
	      var datum = this.getSizeAndPositionOfCell(start);
	      offset = datum.offset + datum.size;
	
	      var stop = start;
	
	      while (offset < maxOffset && stop < this._cellCount - 1) {
	        stop++;
	
	        offset += this.getSizeAndPositionOfCell(stop).size;
	      }
	
	      return {
	        start: start,
	        stop: stop
	      };
	    }
	
	    /**
	     * Clear all cached values for cells after the specified index.
	     * This method should be called for any cell that has changed its size.
	     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
	     */
	
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
	    }
	  }, {
	    key: '_binarySearch',
	    value: function _binarySearch(_ref5) {
	      var high = _ref5.high;
	      var low = _ref5.low;
	      var offset = _ref5.offset;
	
	      var middle = void 0;
	      var currentOffset = void 0;
	
	      while (low <= high) {
	        middle = low + Math.floor((high - low) / 2);
	        currentOffset = this.getSizeAndPositionOfCell(middle).offset;
	
	        if (currentOffset === offset) {
	          return middle;
	        } else if (currentOffset < offset) {
	          low = middle + 1;
	        } else if (currentOffset > offset) {
	          high = middle - 1;
	        }
	      }
	
	      if (low > 0) {
	        return low - 1;
	      }
	    }
	  }, {
	    key: '_exponentialSearch',
	    value: function _exponentialSearch(_ref6) {
	      var index = _ref6.index;
	      var offset = _ref6.offset;
	
	      var interval = 1;
	
	      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
	        index += interval;
	        interval *= 2;
	      }
	
	      return this._binarySearch({
	        high: Math.min(index, this._cellCount - 1),
	        low: Math.floor(index / 2),
	        offset: offset
	      });
	    }
	
	    /**
	     * Searches for the cell (index) nearest the specified offset.
	     *
	     * If no exact match is found the next lowest cell index will be returned.
	     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
	     */
	
	  }, {
	    key: '_findNearestCell',
	    value: function _findNearestCell(offset) {
	      if (isNaN(offset)) {
	        throw Error('Invalid offset ' + offset + ' specified');
	      }
	
	      // Our search algorithms find the nearest match at or below the specified offset.
	      // So make sure the offset is at least 0 or no match will be found.
	      offset = Math.max(0, offset);
	
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
	
	      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
	        // If we've already measured cells within this range just use a binary search as it's faster.
	        return this._binarySearch({
	          high: lastMeasuredIndex,
	          low: 0,
	          offset: offset
	        });
	      } else {
	        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
	        // The overall complexity for this approach is O(log n).
	        return this._exponentialSearch({
	          index: lastMeasuredIndex,
	          offset: offset
	        });
	      }
	    }
	  }]);
	
	  return CellSizeAndPositionManager;
	}();
	
	exports.default = CellSizeAndPositionManager;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_MAX_SCROLL_SIZE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CellSizeAndPositionManager = __webpack_require__(2119);
	
	var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
	 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
	 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
	 */
	var DEFAULT_MAX_SCROLL_SIZE = exports.DEFAULT_MAX_SCROLL_SIZE = 1500000;
	
	/**
	 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
	 */
	
	var ScalingCellSizeAndPositionManager = function () {
	  function ScalingCellSizeAndPositionManager(_ref) {
	    var _ref$maxScrollSize = _ref.maxScrollSize;
	    var maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize;
	
	    var params = _objectWithoutProperties(_ref, ['maxScrollSize']);
	
	    _classCallCheck(this, ScalingCellSizeAndPositionManager);
	
	    // Favor composition over inheritance to simplify IE10 support
	    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
	    this._maxScrollSize = maxScrollSize;
	  }
	
	  _createClass(ScalingCellSizeAndPositionManager, [{
	    key: 'configure',
	    value: function configure(params) {
	      this._cellSizeAndPositionManager.configure(params);
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellSizeAndPositionManager.getCellCount();
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._cellSizeAndPositionManager.getEstimatedCellSize();
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
	    }
	
	    /**
	     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
	     * The offset passed to this function is scalled (safe) as well.
	     */
	
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment(_ref2) {
	      var containerSize = _ref2.containerSize;
	      var offset = _ref2.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	      var offsetPercentage = this._getOffsetPercentage({
	        containerSize: containerSize,
	        offset: offset,
	        totalSize: safeTotalSize
	      });
	
	      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
	    }
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
	    }
	
	    /** See CellSizeAndPositionManager#getTotalSize */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
	    }
	
	    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align;
	      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
	      var containerSize = _ref3.containerSize;
	      var currentOffset = _ref3.currentOffset;
	      var targetIndex = _ref3.targetIndex;
	      var totalSize = _ref3.totalSize;
	
	      currentOffset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: currentOffset
	      });
	
	      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
	        align: align,
	        containerSize: containerSize,
	        currentOffset: currentOffset,
	        targetIndex: targetIndex,
	        totalSize: totalSize
	      });
	
	      return this._offsetToSafeOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	
	    /** See CellSizeAndPositionManager#getVisibleCellRange */
	
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize;
	      var offset = _ref4.offset;
	
	      offset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	
	      return this._cellSizeAndPositionManager.getVisibleCellRange({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._cellSizeAndPositionManager.resetCell(index);
	    }
	  }, {
	    key: '_getOffsetPercentage',
	    value: function _getOffsetPercentage(_ref5) {
	      var containerSize = _ref5.containerSize;
	      var offset = _ref5.offset;
	      var totalSize = _ref5.totalSize;
	
	      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
	    }
	  }, {
	    key: '_offsetToSafeOffset',
	    value: function _offsetToSafeOffset(_ref6) {
	      var containerSize = _ref6.containerSize;
	      var offset = _ref6.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: totalSize
	        });
	
	        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
	      }
	    }
	  }, {
	    key: '_safeOffsetToOffset',
	    value: function _safeOffsetToOffset(_ref7) {
	      var containerSize = _ref7.containerSize;
	      var offset = _ref7.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: safeTotalSize
	        });
	
	        return Math.round(offsetPercentage * (totalSize - containerSize));
	      }
	    }
	  }]);
	
	  return ScalingCellSizeAndPositionManager;
	}();
	
	exports.default = ScalingCellSizeAndPositionManager;

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
	/**
	 * Helper method that determines when to recalculate row or column metadata.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param cellsSize Width or height of cells for the current axis
	 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
	 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
	 * @param nextCellsCount Newly updated number of rows or columns in the current axis
	 * @param nextCellsSize Newly updated width or height of cells for the current axis
	 * @param nextScrollToIndex Newly updated scroll-to-index
	 * @param scrollToIndex Scroll-to-index
	 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
	 */
	function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
	  var cellCount = _ref.cellCount;
	  var cellSize = _ref.cellSize;
	  var computeMetadataCallback = _ref.computeMetadataCallback;
	  var computeMetadataCallbackProps = _ref.computeMetadataCallbackProps;
	  var nextCellsCount = _ref.nextCellsCount;
	  var nextCellSize = _ref.nextCellSize;
	  var nextScrollToIndex = _ref.nextScrollToIndex;
	  var scrollToIndex = _ref.scrollToIndex;
	  var updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
	
	  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
	  // In that event users should use the manual recompute methods to inform of changes.
	  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
	    computeMetadataCallback(computeMetadataCallbackProps);
	
	    // Updated cell metadata may have hidden the previous scrolled-to item.
	    // In this case we should also update the scrollTop to ensure it stays visible.
	    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
	      updateScrollOffsetForScrollToIndex();
	    }
	  }
	}

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverscanIndices;
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	var SCROLL_DIRECTION_FIXED = exports.SCROLL_DIRECTION_FIXED = 0;
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD
	 * @param overscanCellsCount Maximum number of cells to over-render in either direction
	 * @param startIndex Begin of range of visible cells
	 * @param stopIndex End of range of visible cells
	 */
	function getOverscanIndices(_ref) {
	  var cellCount = _ref.cellCount;
	  var overscanCellsCount = _ref.overscanCellsCount;
	  var scrollDirection = _ref.scrollDirection;
	  var startIndex = _ref.startIndex;
	  var stopIndex = _ref.stopIndex;
	
	  var overscanStartIndex = void 0;
	  var overscanStopIndex = void 0;
	
	  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
	    overscanStartIndex = startIndex;
	    overscanStopIndex = stopIndex + overscanCellsCount * 2;
	  } else if (scrollDirection === SCROLL_DIRECTION_BACKWARD) {
	    overscanStartIndex = startIndex - overscanCellsCount * 2;
	    overscanStopIndex = stopIndex;
	  } else {
	    overscanStartIndex = startIndex - overscanCellsCount;
	    overscanStopIndex = stopIndex + overscanCellsCount;
	  }
	
	  return {
	    overscanStartIndex: Math.max(0, overscanStartIndex),
	    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
	  };
	}

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScrollIndexHelper;
	/**
	 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
	 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
	 *
	 * @param cellsSize Width or height of cells for the current axis
	 * @param cellSizeAndPositionManager Manages size and position metadata of cells
	 * @param previousCellsCount Previous number of rows or columns
	 * @param previousCellsSize Previous width or height of cells
	 * @param previousScrollToIndex Previous scroll-to-index
	 * @param previousSize Previous width or height of the virtualized container
	 * @param scrollOffset Current scrollLeft or scrollTop
	 * @param scrollToIndex Scroll-to-index
	 * @param size Width or height of the virtualized container
	 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
	 */
	function updateScrollIndexHelper(_ref) {
	  var cellSize = _ref.cellSize;
	  var cellSizeAndPositionManager = _ref.cellSizeAndPositionManager;
	  var previousCellsCount = _ref.previousCellsCount;
	  var previousCellSize = _ref.previousCellSize;
	  var previousScrollToAlignment = _ref.previousScrollToAlignment;
	  var previousScrollToIndex = _ref.previousScrollToIndex;
	  var previousSize = _ref.previousSize;
	  var scrollOffset = _ref.scrollOffset;
	  var scrollToAlignment = _ref.scrollToAlignment;
	  var scrollToIndex = _ref.scrollToIndex;
	  var size = _ref.size;
	  var updateScrollIndexCallback = _ref.updateScrollIndexCallback;
	
	  var cellCount = cellSizeAndPositionManager.getCellCount();
	  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
	  var sizeHasChanged = size !== previousSize || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
	
	  // If we have a new scroll target OR if height/row-height has changed,
	  // We should ensure that the scroll target is visible.
	  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
	    updateScrollIndexCallback(scrollToIndex);
	
	    // If we don't have a selected item but list size or number of children have decreased,
	    // Make sure we aren't scrolled too far past the current content.
	  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
	    // We need to ensure that the current scroll offset is still within the collection's range.
	    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
	    // Just check to make sure we're still okay.
	    // Only adjust the scroll position if we've scrolled below the last set of rows.
	    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
	      updateScrollIndexCallback(cellCount - 1);
	    }
	  }
	}

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.isRangeVisible = isRangeVisible;
	exports.scanForUnloadedRanges = scanForUnloadedRanges;
	exports.forceUpdateReactVirtualizedComponent = forceUpdateReactVirtualizedComponent;
	
	var _react = __webpack_require__(1);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _createCallbackMemoizer = __webpack_require__(498);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Higher-order component that manages lazy-loading for "infinite" data.
	 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
	 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
	 */
	var InfiniteLoader = function (_Component) {
	  _inherits(InfiniteLoader, _Component);
	
	  function InfiniteLoader(props, context) {
	    _classCallCheck(this, InfiniteLoader);
	
	    var _this = _possibleConstructorReturn(this, (InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call(this, props, context));
	
	    _this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	
	    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(InfiniteLoader, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        onRowsRendered: this._onRowsRendered,
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_loadUnloadedRanges',
	    value: function _loadUnloadedRanges(unloadedRanges) {
	      var _this2 = this;
	
	      var loadMoreRows = this.props.loadMoreRows;
	
	
	      unloadedRanges.forEach(function (unloadedRange) {
	        var promise = loadMoreRows(unloadedRange);
	        if (promise) {
	          promise.then(function () {
	            // Refresh the visible rows if any of them have just been loaded.
	            // Otherwise they will remain in their unloaded visual state.
	            if (isRangeVisible({
	              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
	              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
	              startIndex: unloadedRange.startIndex,
	              stopIndex: unloadedRange.stopIndex
	            })) {
	              if (_this2._registeredChild) {
	                forceUpdateReactVirtualizedComponent(_this2._registeredChild);
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_onRowsRendered',
	    value: function _onRowsRendered(_ref) {
	      var _this3 = this;
	
	      var startIndex = _ref.startIndex;
	      var stopIndex = _ref.stopIndex;
	      var _props = this.props;
	      var isRowLoaded = _props.isRowLoaded;
	      var minimumBatchSize = _props.minimumBatchSize;
	      var rowCount = _props.rowCount;
	      var threshold = _props.threshold;
	
	
	      this._lastRenderedStartIndex = startIndex;
	      this._lastRenderedStopIndex = stopIndex;
	
	      var unloadedRanges = scanForUnloadedRanges({
	        isRowLoaded: isRowLoaded,
	        minimumBatchSize: minimumBatchSize,
	        rowCount: rowCount,
	        startIndex: Math.max(0, startIndex - threshold),
	        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
	      });
	
	      // For memoize comparison
	      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
	        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
	      }, []);
	
	      this._loadMoreRowsMemoizer({
	        callback: function callback() {
	          _this3._loadUnloadedRanges(unloadedRanges);
	        },
	        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(registeredChild) {
	      this._registeredChild = registeredChild;
	    }
	  }]);
	
	  return InfiniteLoader;
	}(_react.Component);
	
	/**
	 * Determines if the specified start/stop range is visible based on the most recently rendered range.
	 */
	
	
	InfiniteLoader.propTypes = {
	  /**
	   * Function respondible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ onRowsRendered, registerChild }) => PropTypes.element
	   *
	   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
	   * The :registerChild callback should be set as the virtualized component's :ref.
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /**
	   * Function responsible for tracking the loaded state of each row.
	   * It should implement the following signature: ({ index: number }): boolean
	   */
	  isRowLoaded: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback to be invoked when more rows must be loaded.
	   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
	   * The returned Promise should be resolved once row data has finished loading.
	   * It will be used to determine when to refresh the list with the newly-loaded data.
	   * This callback may be called multiple times in reaction to a single scroll event.
	   */
	  loadMoreRows: _react.PropTypes.func.isRequired,
	
	  /**
	   * Minimum number of rows to be loaded at a time.
	   * This property can be used to batch requests to reduce HTTP requests.
	   */
	  minimumBatchSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Number of rows in list; can be arbitrary high number if actual number is unknown.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Threshold at which to pre-fetch data.
	   * A threshold X means that data will start loading when a user scrolls within X rows.
	   * This value defaults to 15.
	   */
	  threshold: _react.PropTypes.number.isRequired
	};
	InfiniteLoader.defaultProps = {
	  minimumBatchSize: 10,
	  rowCount: 0,
	  threshold: 15
	};
	exports.default = InfiniteLoader;
	function isRangeVisible(_ref2) {
	  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex;
	  var lastRenderedStopIndex = _ref2.lastRenderedStopIndex;
	  var startIndex = _ref2.startIndex;
	  var stopIndex = _ref2.stopIndex;
	
	  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
	}
	
	/**
	 * Returns all of the ranges within a larger range that contain unloaded rows.
	 */
	function scanForUnloadedRanges(_ref3) {
	  var isRowLoaded = _ref3.isRowLoaded;
	  var minimumBatchSize = _ref3.minimumBatchSize;
	  var rowCount = _ref3.rowCount;
	  var startIndex = _ref3.startIndex;
	  var stopIndex = _ref3.stopIndex;
	
	  var unloadedRanges = [];
	
	  var rangeStartIndex = null;
	  var rangeStopIndex = null;
	
	  for (var index = startIndex; index <= stopIndex; index++) {
	    var loaded = isRowLoaded({ index: index });
	
	    if (!loaded) {
	      rangeStopIndex = index;
	      if (rangeStartIndex === null) {
	        rangeStartIndex = index;
	      }
	    } else if (rangeStopIndex !== null) {
	      unloadedRanges.push({
	        startIndex: rangeStartIndex,
	        stopIndex: rangeStopIndex
	      });
	
	      rangeStartIndex = rangeStopIndex = null;
	    }
	  }
	
	  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
	  // Scan forward to try filling our :minimumBatchSize.
	  if (rangeStopIndex !== null) {
	    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
	
	    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
	      if (!isRowLoaded({ index: _index })) {
	        rangeStopIndex = _index;
	      } else {
	        break;
	      }
	    }
	
	    unloadedRanges.push({
	      startIndex: rangeStartIndex,
	      stopIndex: rangeStopIndex
	    });
	  }
	
	  // Check to see if our first range ended prematurely.
	  // In this case we should scan backwards to try filling our :minimumBatchSize.
	  if (unloadedRanges.length) {
	    var firstUnloadedRange = unloadedRanges[0];
	
	    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
	      var _index2 = firstUnloadedRange.startIndex - 1;
	
	      if (!isRowLoaded({ index: _index2 })) {
	        firstUnloadedRange.startIndex = _index2;
	      } else {
	        break;
	      }
	    }
	  }
	
	  return unloadedRanges;
	}
	
	/**
	 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
	 * However InfiniteLoader may wrap a Grid or it may wrap a FlexTable or VirtualScroll.
	 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
	 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
	 * Else the inner Grid will not be re-rendered and visuals may be stale.
	 */
	function forceUpdateReactVirtualizedComponent(component) {
	  typeof component.forceUpdateGrid === 'function' ? component.forceUpdateGrid() : component.forceUpdate();
	}

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfiniteLoader = exports.default = undefined;
	
	var _InfiniteLoader2 = __webpack_require__(2124);
	
	var _InfiniteLoader3 = _interopRequireDefault(_InfiniteLoader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfiniteLoader3.default;
	exports.InfiniteLoader = _InfiniteLoader3.default;

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
	 */
	var ScrollSync = function (_Component) {
	  _inherits(ScrollSync, _Component);
	
	  function ScrollSync(props, context) {
	    _classCallCheck(this, ScrollSync);
	
	    var _this = _possibleConstructorReturn(this, (ScrollSync.__proto__ || Object.getPrototypeOf(ScrollSync)).call(this, props, context));
	
	    _this.state = {
	      clientHeight: 0,
	      clientWidth: 0,
	      scrollHeight: 0,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollWidth: 0
	    };
	
	    _this._onScroll = _this._onScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollSync, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state;
	      var clientHeight = _state.clientHeight;
	      var clientWidth = _state.clientWidth;
	      var scrollHeight = _state.scrollHeight;
	      var scrollLeft = _state.scrollLeft;
	      var scrollTop = _state.scrollTop;
	      var scrollWidth = _state.scrollWidth;
	
	
	      return children({
	        clientHeight: clientHeight,
	        clientWidth: clientWidth,
	        onScroll: this._onScroll,
	        scrollHeight: scrollHeight,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        scrollWidth: scrollWidth
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref) {
	      var clientHeight = _ref.clientHeight;
	      var clientWidth = _ref.clientWidth;
	      var scrollHeight = _ref.scrollHeight;
	      var scrollLeft = _ref.scrollLeft;
	      var scrollTop = _ref.scrollTop;
	      var scrollWidth = _ref.scrollWidth;
	
	      this.setState({ clientHeight: clientHeight, clientWidth: clientWidth, scrollHeight: scrollHeight, scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth });
	    }
	  }]);
	
	  return ScrollSync;
	}(_react.Component);
	
	ScrollSync.propTypes = {
	  /**
	   * Function respondible for rendering 2 or more virtualized components.
	   * This function should implement the following signature:
	   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired
	};
	exports.default = ScrollSync;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollSync = exports.default = undefined;
	
	var _ScrollSync2 = __webpack_require__(2126);
	
	var _ScrollSync3 = _interopRequireDefault(_ScrollSync2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollSync3.default;
	exports.ScrollSync = _ScrollSync3.default;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Grid = __webpack_require__(345);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
	 * if only a few of those elements are visible. The primary purpose of this component is to improve
	 * performance by only rendering the DOM nodes that a user is able to see based on their current
	 * scroll position.
	 *
	 * This component renders a virtualized list of elements with either fixed or dynamic heights.
	 */
	var VirtualScroll = function (_Component) {
	  _inherits(VirtualScroll, _Component);
	
	  function VirtualScroll(props, context) {
	    _classCallCheck(this, VirtualScroll);
	
	    var _this = _possibleConstructorReturn(this, (VirtualScroll.__proto__ || Object.getPrototypeOf(VirtualScroll)).call(this, props, context));
	
	    _this._cellRenderer = _this._cellRenderer.bind(_this);
	    _this._createRowClassNameGetter = _this._createRowClassNameGetter.bind(_this);
	    _this._createRowStyleGetter = _this._createRowStyleGetter.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(VirtualScroll, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	      this.forceUpdateGrid();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var className = _props.className;
	      var noRowsRenderer = _props.noRowsRenderer;
	      var scrollToIndex = _props.scrollToIndex;
	      var width = _props.width;
	
	
	      var classNames = (0, _classnames2.default)('VirtualScroll', className);
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	        autoContainerWidth: true,
	        cellRenderer: this._cellRenderer,
	        cellClassName: this._createRowClassNameGetter(),
	        cellStyle: this._createRowStyleGetter(),
	        className: classNames,
	        columnWidth: width,
	        columnCount: 1,
	        noContentRenderer: noRowsRenderer,
	        onScroll: this._onScroll,
	        onSectionRendered: this._onSectionRendered,
	        ref: function ref(_ref) {
	          _this2.Grid = _ref;
	        },
	        scrollToRow: scrollToIndex
	      }));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_cellRenderer',
	    value: function _cellRenderer(_ref2) {
	      var columnIndex = _ref2.columnIndex;
	      var isScrolling = _ref2.isScrolling;
	      var rowIndex = _ref2.rowIndex;
	      var rowRenderer = this.props.rowRenderer;
	
	
	      return rowRenderer({
	        index: rowIndex,
	        isScrolling: isScrolling
	      });
	    }
	  }, {
	    key: '_createRowClassNameGetter',
	    value: function _createRowClassNameGetter() {
	      var rowClassName = this.props.rowClassName;
	
	
	      return rowClassName instanceof Function ? function (_ref3) {
	        var rowIndex = _ref3.rowIndex;
	        return rowClassName({ index: rowIndex });
	      } : function () {
	        return rowClassName;
	      };
	    }
	  }, {
	    key: '_createRowStyleGetter',
	    value: function _createRowStyleGetter() {
	      var rowStyle = this.props.rowStyle;
	
	
	      var wrapped = rowStyle instanceof Function ? rowStyle : function () {
	        return rowStyle;
	      };
	
	      // Default width to 100% to prevent list rows from flowing under the vertical scrollbar
	      return function (_ref4) {
	        var rowIndex = _ref4.rowIndex;
	        return _extends({
	          width: '100%'
	        }, wrapped({ index: rowIndex }));
	      };
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref5) {
	      var clientHeight = _ref5.clientHeight;
	      var scrollHeight = _ref5.scrollHeight;
	      var scrollTop = _ref5.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref6) {
	      var rowOverscanStartIndex = _ref6.rowOverscanStartIndex;
	      var rowOverscanStopIndex = _ref6.rowOverscanStopIndex;
	      var rowStartIndex = _ref6.rowStartIndex;
	      var rowStopIndex = _ref6.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }]);
	
	  return VirtualScroll;
	}(_react.Component);
	
	VirtualScroll.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /** Optional CSS class name */
	  className: _react.PropTypes.string,
	
	  /**
	   * Used to estimate the total height of a VirtualScroll before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /** Height constraint for list (determines how many actual rows are rendered) */
	  height: _react.PropTypes.number.isRequired,
	
	  /** Optional renderer to be used in place of rows when rowCount is 0 */
	  noRowsRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Responsbile for rendering a row given an index; ({ index: number }): node */
	  rowRenderer: _react.PropTypes.func.isRequired,
	
	  /** Optional custom CSS class for individual rows */
	  rowClassName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	
	  /** Number of rows in list. */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /** Optional custom styles for individual cells */
	  rowStyle: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]),
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /** Width of list */
	  width: _react.PropTypes.number.isRequired
	};
	VirtualScroll.defaultProps = {
	  estimatedRowSize: 30,
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanRowCount: 10,
	  scrollToAlignment: 'auto',
	  style: {}
	};
	exports.default = VirtualScroll;

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VirtualScroll = exports.default = undefined;
	
	var _VirtualScroll2 = __webpack_require__(2128);
	
	var _VirtualScroll3 = _interopRequireDefault(_VirtualScroll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VirtualScroll3.default;
	exports.VirtualScroll = _VirtualScroll3.default;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsShallowCompare = __webpack_require__(88);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _raf = __webpack_require__(163);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _onScroll = __webpack_require__(893);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WindowScroller = function (_Component) {
	  _inherits(WindowScroller, _Component);
	
	  function WindowScroller(props) {
	    _classCallCheck(this, WindowScroller);
	
	    var _this = _possibleConstructorReturn(this, (WindowScroller.__proto__ || Object.getPrototypeOf(WindowScroller)).call(this, props));
	
	    var height = typeof window !== 'undefined' ? window.innerHeight : 0;
	
	    _this.state = {
	      isScrolling: false,
	      height: height,
	      scrollTop: 0
	    };
	
	    _this._onScrollWindow = _this._onScrollWindow.bind(_this);
	    _this._onResizeWindow = _this._onResizeWindow.bind(_this);
	    _this._enablePointerEventsAfterDelayCallback = _this._enablePointerEventsAfterDelayCallback.bind(_this);
	    return _this;
	  }
	
	  _createClass(WindowScroller, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var height = this.state.height;
	
	      // Subtract documentElement top to handle edge-case where a user is navigating back (history) from an already-scrolled bage.
	      // In this case the body's top position will be a negative number and this element's top will be increased (by that amount).
	
	      this._positionFromTop = _reactDom2.default.findDOMNode(this).getBoundingClientRect().top - document.documentElement.getBoundingClientRect().top;
	
	      if (height !== window.innerHeight) {
	        this.setState({
	          height: window.innerHeight
	        });
	      }
	
	      (0, _onScroll.registerScrollListener)(this);
	      window.addEventListener('resize', this._onResizeWindow, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _onScroll.unregisterScrollListener)(this);
	
	      window.removeEventListener('resize', this._onResizeWindow, false);
	    }
	
	    /**
	     * Updates the state during the next animation frame.
	     * Use this method to avoid multiple renders in a small span of time.
	     * This helps performance for bursty events (like onScroll).
	     */
	
	  }, {
	    key: '_setNextState',
	    value: function _setNextState(state) {
	      var _this2 = this;
	
	      if (this._setNextStateAnimationFrameId) {
	        _raf2.default.cancel(this._setNextStateAnimationFrameId);
	      }
	
	      this._setNextStateAnimationFrameId = (0, _raf2.default)(function () {
	        _this2._setNextStateAnimationFrameId = null;
	        _this2.setState(state);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state;
	      var isScrolling = _state.isScrolling;
	      var scrollTop = _state.scrollTop;
	      var height = _state.height;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        children({
	          height: height,
	          isScrolling: isScrolling,
	          scrollTop: scrollTop
	        })
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_enablePointerEventsAfterDelayCallback',
	    value: function _enablePointerEventsAfterDelayCallback() {
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: '_onResizeWindow',
	    value: function _onResizeWindow(event) {
	      var onResize = this.props.onResize;
	
	
	      var height = window.innerHeight || 0;
	
	      this.setState({ height: height });
	
	      onResize({ height: height });
	    }
	  }, {
	    key: '_onScrollWindow',
	    value: function _onScrollWindow(event) {
	      var onScroll = this.props.onScroll;
	
	      // In IE10+ scrollY is undefined, so we replace that with the latter
	
	      var scrollY = 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop;
	
	      var scrollTop = Math.max(0, scrollY - this._positionFromTop);
	
	      var state = {
	        isScrolling: true,
	        scrollTop: scrollTop
	      };
	
	      if (!this.state.isScrolling) {
	        this.setState(state);
	      } else {
	        this._setNextState(state);
	      }
	
	      onScroll({ scrollTop: scrollTop });
	    }
	  }]);
	
	  return WindowScroller;
	}(_react.Component);
	
	WindowScroller.propTypes = {
	  /**
	   * Function respondible for rendering children.
	   * This function should implement the following signature:
	   * ({ height, scrollTop }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Callback to be invoked on-resize: ({ height }) */
	  onResize: _react.PropTypes.func.isRequired,
	
	  /** Callback to be invoked on-scroll: ({ scrollTop }) */
	  onScroll: _react.PropTypes.func.isRequired
	};
	WindowScroller.defaultProps = {
	  onResize: function onResize() {},
	  onScroll: function onScroll() {}
	};
	exports.default = WindowScroller;

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_SCROLLING_TIMEOUT = exports.WindowScroller = exports.default = undefined;
	
	var _WindowScroller2 = __webpack_require__(2130);
	
	var _WindowScroller3 = _interopRequireDefault(_WindowScroller2);
	
	var _onScroll = __webpack_require__(893);
	
	var _onScroll2 = _interopRequireDefault(_onScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WindowScroller3.default;
	exports.WindowScroller = _WindowScroller3.default;
	exports.IS_SCROLLING_TIMEOUT = _onScroll2.default;

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ArrowKeyStepper = __webpack_require__(2103);
	
	Object.defineProperty(exports, 'ArrowKeyStepper', {
	  enumerable: true,
	  get: function get() {
	    return _ArrowKeyStepper.ArrowKeyStepper;
	  }
	});
	
	var _AutoSizer = __webpack_require__(2105);
	
	Object.defineProperty(exports, 'AutoSizer', {
	  enumerable: true,
	  get: function get() {
	    return _AutoSizer.AutoSizer;
	  }
	});
	
	var _CellMeasurer = __webpack_require__(2107);
	
	Object.defineProperty(exports, 'CellMeasurer', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurer;
	  }
	});
	Object.defineProperty(exports, 'defaultCellMeasurerCellSizeCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.defaultCellSizeCache;
	  }
	});
	Object.defineProperty(exports, 'uniformSizeCellMeasurerCellSizeCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.defaultCellSizeCache;
	  }
	});
	
	var _Collection = __webpack_require__(2112);
	
	Object.defineProperty(exports, 'Collection', {
	  enumerable: true,
	  get: function get() {
	    return _Collection.Collection;
	  }
	});
	
	var _ColumnSizer = __webpack_require__(2115);
	
	Object.defineProperty(exports, 'ColumnSizer', {
	  enumerable: true,
	  get: function get() {
	    return _ColumnSizer.ColumnSizer;
	  }
	});
	
	var _FlexTable = __webpack_require__(2117);
	
	Object.defineProperty(exports, 'defaultFlexTableCellDataGetter', {
	  enumerable: true,
	  get: function get() {
	    return _FlexTable.defaultCellDataGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultFlexTableCellRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _FlexTable.defaultCellRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultFlexTableHeaderRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _FlexTable.defaultHeaderRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultFlexTableRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _FlexTable.defaultRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'FlexTable', {
	  enumerable: true,
	  get: function get() {
	    return _FlexTable.FlexTable;
	  }
	});
	Object.defineProperty(exports, 'FlexColumn', {
	  enumerable: true,
	  get: function get() {
	    return _FlexTable.FlexColumn;
	  }
	});
	Object.defineProperty(exports, 'SortDirection', {
	  enumerable: true,
	  get: function get() {
	    return _FlexTable.SortDirection;
	  }
	});
	Object.defineProperty(exports, 'SortIndicator', {
	  enumerable: true,
	  get: function get() {
	    return _FlexTable.SortIndicator;
	  }
	});
	
	var _Grid = __webpack_require__(345);
	
	Object.defineProperty(exports, 'defaultCellRangeRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultCellRangeRenderer;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.Grid;
	  }
	});
	
	var _InfiniteLoader = __webpack_require__(2125);
	
	Object.defineProperty(exports, 'InfiniteLoader', {
	  enumerable: true,
	  get: function get() {
	    return _InfiniteLoader.InfiniteLoader;
	  }
	});
	
	var _ScrollSync = __webpack_require__(2127);
	
	Object.defineProperty(exports, 'ScrollSync', {
	  enumerable: true,
	  get: function get() {
	    return _ScrollSync.ScrollSync;
	  }
	});
	
	var _VirtualScroll = __webpack_require__(2129);
	
	Object.defineProperty(exports, 'VirtualScroll', {
	  enumerable: true,
	  get: function get() {
	    return _VirtualScroll.VirtualScroll;
	  }
	});
	
	var _WindowScroller = __webpack_require__(2131);
	
	Object.defineProperty(exports, 'WindowScroller', {
	  enumerable: true,
	  get: function get() {
	    return _WindowScroller.WindowScroller;
	  }
	});

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUpdatedOffsetForIndex;
	/**
	 * Determines a new offset that ensures a certain cell is visible, given the current offset.
	 * If the cell is already visible then the current offset will be returned.
	 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	 *
	 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	 * @param cellOffset Offset (x or y) position for cell
	 * @param cellSize Size (width or height) of cell
	 * @param containerSize Total size (width or height) of the container
	 * @param currentOffset Container's current (x or y) offset
	 * @return Offset to use to ensure the specified cell is visible
	 */
	function getUpdatedOffsetForIndex(_ref) {
	  var _ref$align = _ref.align;
	  var align = _ref$align === undefined ? 'auto' : _ref$align;
	  var cellOffset = _ref.cellOffset;
	  var cellSize = _ref.cellSize;
	  var containerSize = _ref.containerSize;
	  var currentOffset = _ref.currentOffset;
	
	  var maxOffset = cellOffset;
	  var minOffset = maxOffset - containerSize + cellSize;
	
	  switch (align) {
	    case 'start':
	      return maxOffset;
	    case 'end':
	      return minOffset;
	    case 'center':
	      return maxOffset - (containerSize - cellSize) / 2;
	    default:
	      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
	  }
	}

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	* Detect Element Resize.
	* Forked in order to guard against unsafe 'window' and 'document' references.
	*
	* https://github.com/sdecima/javascript-detect-element-resize
	* Sebastian Decima
	*
	* version: 0.5.3
	**/
	
	// Check `document` and `window` in case of server-side rendering
	var _window;
	if (typeof window !== 'undefined') {
	  _window = window;
	} else if (typeof self !== 'undefined') {
	  _window = self;
	} else {
	  _window = undefined;
	}
	
	var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	var stylesCreated = false;
	
	if (!attachEvent) {
	  var requestFrame = function () {
	    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	      return _window.setTimeout(fn, 20);
	    };
	    return function (fn) {
	      return raf(fn);
	    };
	  }();
	
	  var cancelFrame = function () {
	    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	    return function (id) {
	      return cancel(id);
	    };
	  }();
	
	  var resetTriggers = function resetTriggers(element) {
	    var triggers = element.__resizeTriggers__,
	        expand = triggers.firstElementChild,
	        contract = triggers.lastElementChild,
	        expandChild = expand.firstElementChild;
	    contract.scrollLeft = contract.scrollWidth;
	    contract.scrollTop = contract.scrollHeight;
	    expandChild.style.width = expand.offsetWidth + 1 + 'px';
	    expandChild.style.height = expand.offsetHeight + 1 + 'px';
	    expand.scrollLeft = expand.scrollWidth;
	    expand.scrollTop = expand.scrollHeight;
	  };
	
	  var checkTriggers = function checkTriggers(element) {
	    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	  };
	
	  var scrollListener = function scrollListener(e) {
	    var element = this;
	    resetTriggers(this);
	    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	    this.__resizeRAF__ = requestFrame(function () {
	      if (checkTriggers(element)) {
	        element.__resizeLast__.width = element.offsetWidth;
	        element.__resizeLast__.height = element.offsetHeight;
	        element.__resizeListeners__.forEach(function (fn) {
	          fn.call(element, e);
	        });
	      }
	    });
	  };
	
	  /* Detect CSS Animations support to detect element display/re-attach */
	  var animation = false,
	      animationstring = 'animation',
	      keyframeprefix = '',
	      animationstartevent = 'animationstart',
	      domPrefixes = 'Webkit Moz O ms'.split(' '),
	      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	      pfx = '';
	  {
	    var elm = document.createElement('fakeelement');
	    if (elm.style.animationName !== undefined) {
	      animation = true;
	    }
	
	    if (animation === false) {
	      for (var i = 0; i < domPrefixes.length; i++) {
	        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	          pfx = domPrefixes[i];
	          animationstring = pfx + 'Animation';
	          keyframeprefix = '-' + pfx.toLowerCase() + '-';
	          animationstartevent = startEvents[i];
	          animation = true;
	          break;
	        }
	      }
	    }
	  }
	
	  var animationName = 'resizeanim';
	  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}
	
	var createStyles = function createStyles() {
	  if (!stylesCreated) {
	    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	        head = document.head || document.getElementsByTagName('head')[0],
	        style = document.createElement('style');
	
	    style.type = 'text/css';
	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	
	    head.appendChild(style);
	    stylesCreated = true;
	  }
	};
	
	var addResizeListener = function addResizeListener(element, fn) {
	  if (attachEvent) element.attachEvent('onresize', fn);else {
	    if (!element.__resizeTriggers__) {
	      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
	      createStyles();
	      element.__resizeLast__ = {};
	      element.__resizeListeners__ = [];
	      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	      element.appendChild(element.__resizeTriggers__);
	      resetTriggers(element);
	      element.addEventListener('scroll', scrollListener, true);
	
	      /* Listen for a css animation to detect element display/re-attach */
	      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
	        if (e.animationName == animationName) resetTriggers(element);
	      });
	    }
	    element.__resizeListeners__.push(fn);
	  }
	};
	
	var removeResizeListener = function removeResizeListener(element, fn) {
	  if (attachEvent) element.detachEvent('onresize', fn);else {
	    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	    if (!element.__resizeListeners__.length) {
	      element.removeEventListener('scroll', scrollListener, true);
	      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	    }
	  }
	};
	
	module.exports = {
	  addResizeListener: addResizeListener,
	  removeResizeListener: removeResizeListener
	};

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 2136 */
473,
/* 2137 */
[2356, 256],
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(2137);
	var ReactElement = __webpack_require__(213);
	
	var emptyFunction = __webpack_require__(93);
	var traverseAllChildren = __webpack_require__(2149);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var shallowCompare = __webpack_require__(2148);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 *
	 * See https://facebook.github.io/react/docs/pure-render-mixin.html
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function (nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(213);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(213),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(827);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(895),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(213),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(898);
	var factory = __webpack_require__(705);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 2144 */
2025,
/* 2145 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(256);
	
	var ReactElement = __webpack_require__(213);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(308);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(256);
	
	var ReactCurrentOwner = __webpack_require__(123);
	var REACT_ELEMENT_TYPE = __webpack_require__(897);
	
	var getIteratorFn = __webpack_require__(2144);
	var invariant = __webpack_require__(21);
	var KeyEscapeUtils = __webpack_require__(2136);
	var warning = __webpack_require__(35);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactableTable = __webpack_require__(2157);
	
	var _reactableTr = __webpack_require__(905);
	
	var _reactableTd = __webpack_require__(902);
	
	var _reactableTh = __webpack_require__(499);
	
	var _reactableTfoot = __webpack_require__(903);
	
	var _reactableThead = __webpack_require__(904);
	
	var _reactableSort = __webpack_require__(2156);
	
	var _reactableUnsafe = __webpack_require__(347);
	
	_react2['default'].Children.children = function (children) {
	    return _react2['default'].Children.map(children, function (x) {
	        return x;
	    }) || [];
	};
	
	// Array.prototype.find polyfill - see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	if (!Array.prototype.find) {
	    Object.defineProperty(Array.prototype, 'find', {
	        enumerable: false,
	        configurable: true,
	        writable: true,
	        value: function value(predicate) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.find called on null or undefined');
	            }
	            if (typeof predicate !== 'function') {
	                throw new TypeError('predicate must be a function');
	            }
	            var list = Object(this);
	            var length = list.length >>> 0;
	            var thisArg = arguments[1];
	            var value;
	            for (var i = 0; i < length; i++) {
	                if (i in list) {
	                    value = list[i];
	                    if (predicate.call(thisArg, value, i, list)) {
	                        return value;
	                    }
	                }
	            }
	            return undefined;
	        }
	    });
	}
	
	var Reactable = { Table: _reactableTable.Table, Tr: _reactableTr.Tr, Td: _reactableTd.Td, Th: _reactableTh.Th, Tfoot: _reactableTfoot.Tfoot, Thead: _reactableThead.Thead, Sort: _reactableSort.Sort, unsafe: _reactableUnsafe.unsafe };
	
	exports['default'] = Reactable;
	
	if (typeof window !== 'undefined') {
	    window.Reactable = Reactable;
	}
	module.exports = exports['default'];


/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var FiltererInput = (function (_React$Component) {
	    _inherits(FiltererInput, _React$Component);
	
	    function FiltererInput() {
	        _classCallCheck(this, FiltererInput);
	
	        _get(Object.getPrototypeOf(FiltererInput.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(FiltererInput, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props;
	            var onFilter = _props.onFilter;
	            var onClean = _props.onClean;
	            var filterCleanBtn = _props.filterCleanBtn;
	            var placeholder = _props.placeholder;
	            var value = _props.value;
	
	            return _react2["default"].createElement(
	                "div",
	                { className: "reactable-filter-input-container" },
	                _react2["default"].createElement("input", {
	                    className: "reactable-filter-input",
	                    placeholder: placeholder,
	                    value: value,
	                    onChange: function (ev) {
	                        return onFilter(ev.target.value);
	                    }
	                }),
	                filterCleanBtn && _react2["default"].createElement(
	                    "div",
	                    { onClick: function () {
	                            return onClean();
	                        }, className: "reactable-btn-clean" },
	                    "×"
	                )
	            );
	        }
	    }]);
	
	    return FiltererInput;
	})(_react2["default"].Component);
	
	exports.FiltererInput = FiltererInput;
	;
	
	var Filterer = (function (_React$Component2) {
	    _inherits(Filterer, _React$Component2);
	
	    function Filterer() {
	        _classCallCheck(this, Filterer);
	
	        _get(Object.getPrototypeOf(Filterer.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(Filterer, [{
	        key: "render",
	        value: function render() {
	            if (typeof this.props.colSpan === 'undefined') {
	                throw new TypeError('Must pass a colSpan argument to Filterer');
	            }
	
	            return _react2["default"].createElement(
	                "tr",
	                { className: "reactable-filterer" },
	                _react2["default"].createElement(
	                    "td",
	                    { colSpan: this.props.colSpan },
	                    _react2["default"].createElement(FiltererInput, {
	                        filterCleanBtn: this.props.filterCleanBtn,
	                        onClean: this.props.onClean,
	                        onFilter: this.props.onFilter,
	                        value: this.props.value,
	                        placeholder: this.props.placeholder
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Filterer;
	})(_react2["default"].Component);
	
	exports.Filterer = Filterer;
	;


/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.extractDataFrom = extractDataFrom;
	
	var _stringable = __webpack_require__(901);
	
	function extractDataFrom(key, column) {
	    var value;
	    if (typeof key !== 'undefined' && key !== null && key.__reactableMeta === true) {
	        value = key.data[column];
	    } else {
	        value = key[column];
	    }
	
	    if (typeof value !== 'undefined' && value !== null && value.__reactableMeta === true) {
	        value = typeof value.props.value !== 'undefined' && value.props.value !== null ? value.props.value : value.value;
	    }
	
	    return (0, _stringable.stringable)(value) ? value : '';
	}


/***/ }),
/* 2153 */
/***/ (function(module, exports) {

	// this is a bit hacky - it'd be nice if React exposed an API for this
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.isReactComponent = isReactComponent;
	
	function isReactComponent(thing) {
	    return thing !== null && typeof thing === 'object' && typeof thing.props !== 'undefined';
	}


/***/ }),
/* 2154 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toArray = toArray;
	
	function toArray(obj) {
	    var ret = [];
	    for (var attr in obj) {
	        ret[attr] = obj;
	    }
	
	    return ret;
	}


/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _btnPaginator = __webpack_require__(900);
	
	function pageHref(num) {
	    return '#page-' + (num + 1);
	}
	
	var Paginator = (function (_React$Component) {
	    _inherits(Paginator, _React$Component);
	
	    function Paginator() {
	        _classCallCheck(this, Paginator);
	
	        _get(Object.getPrototypeOf(Paginator.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Paginator, [{
	        key: 'handlePrevious',
	        value: function handlePrevious(e) {
	            e.preventDefault();
	            this.props.onPageChange(this.props.currentPage - 1);
	        }
	    }, {
	        key: 'handleNext',
	        value: function handleNext(e) {
	            e.preventDefault();
	            this.props.onPageChange(this.props.currentPage + 1);
	        }
	    }, {
	        key: 'handlePageButton',
	        value: function handlePageButton(page, e) {
	            e.preventDefault();
	            this.props.onPageChange(page);
	        }
	    }, {
	        key: 'renderPrevious',
	        value: function renderPrevious() {
	            var previousBtn = {
	                nl: "Vorige",
	                fr: "Précédente",
	                en: "Previous"
	            };
	            var locale = this.props.locale;
	
	            if (this.props.currentPage > 0) {
	                return _react2['default'].createElement(
	                    'a',
	                    { className: 'reactable-previous-page',
	                        href: pageHref(this.props.currentPage - 1),
	                        onClick: this.handlePrevious.bind(this) },
	                    previousBtn[locale] || previousBtn.en
	                );
	            }
	        }
	    }, {
	        key: 'renderNext',
	        value: function renderNext() {
	            var nextBtn = {
	                nl: "Volgende",
	                fr: "Suivante",
	                en: "Next"
	            };
	            var locale = this.props.locale;
	
	            if (this.props.currentPage < this.props.numPages - 1) {
	                return _react2['default'].createElement(
	                    'a',
	                    { className: 'reactable-next-page',
	                        href: pageHref(this.props.currentPage + 1),
	                        onClick: this.handleNext.bind(this) },
	                    nextBtn[locale] || nextBtn.en
	                );
	            }
	        }
	    }, {
	        key: 'renderPageButton',
	        value: function renderPageButton(className, pageNum) {
	            return _react2['default'].createElement(
	                'a',
	                { className: className,
	                    key: pageNum,
	                    href: pageHref(pageNum),
	                    onClick: this.handlePageButton.bind(this, pageNum) },
	                pageNum + 1
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (typeof this.props.colSpan === 'undefined') {
	                throw new TypeError('Must pass a colSpan argument to Paginator');
	            }
	
	            if (typeof this.props.numPages === 'undefined') {
	                throw new TypeError('Must pass a non-zero numPages argument to Paginator');
	            }
	
	            if (typeof this.props.currentPage === 'undefined') {
	                throw new TypeError('Must pass a currentPage argument to Paginator');
	            }
	
	            var pageButtons = [];
	            var _props = this.props;
	            var locale = _props.locale;
	            var bottomPaginationElem = _props.bottomPaginationElem;
	            var onPageChange = _props.onPageChange;
	            var itemsNumber = _props.itemsNumber;
	            var itemsPerPage = _props.itemsPerPage;
	            var bottomPagination = _props.bottomPagination;
	            var pageButtonLimit = _props.pageButtonLimit;
	            var currentPage = _props.currentPage;
	            var numPages = _props.numPages;
	
	            var lowerHalf = Math.round(pageButtonLimit / 2);
	            var upperHalf = pageButtonLimit - lowerHalf;
	
	            for (var i = 0; i < this.props.numPages; i++) {
	                var showPageButton = false;
	                var pageNum = i;
	                var className = "reactable-page-button";
	                if (currentPage === i) {
	                    className += " reactable-current-page";
	                }
	                pageButtons.push(this.renderPageButton(className, pageNum));
	            }
	
	            if (currentPage - pageButtonLimit + lowerHalf > 0) {
	                if (currentPage > numPages - lowerHalf) {
	                    pageButtons.splice(0, numPages - pageButtonLimit);
	                } else {
	                    pageButtons.splice(0, currentPage - pageButtonLimit + lowerHalf);
	                }
	            }
	
	            if (numPages - currentPage > upperHalf) {
	                pageButtons.splice(pageButtonLimit, pageButtons.length - pageButtonLimit);
	            }
	            return _react2['default'].createElement(
	                'tbody',
	                { className: 'reactable-pagination' },
	                bottomPagination ? _react2['default'].createElement(
	                    'tr',
	                    { className: 'reactable-btnPagination' },
	                    _react2['default'].createElement(
	                        'td',
	                        { colSpan: this.props.colSpan },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'reactable-bottomDesign' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'reactable-leftElem' },
	                                bottomPaginationElem.left
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'reactable-mainElem' },
	                                _react2['default'].createElement(_btnPaginator.BtnPaginator, {
	                                    locale: locale,
	                                    itemsPerPage: itemsPerPage,
	                                    itemsNumber: itemsNumber,
	                                    numPages: numPages,
	                                    currentPage: currentPage,
	                                    onPageChange: onPageChange,
	                                    key: 'paginator'
	                                })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'reactable-rightElem' },
	                                bottomPaginationElem.right
	                            )
	                        )
	                    )
	                ) : _react2['default'].createElement(
	                    'tr',
	                    null,
	                    _react2['default'].createElement(
	                        'td',
	                        { colSpan: this.props.colSpan },
	                        this.renderPrevious(),
	                        pageButtons,
	                        this.renderNext()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Paginator;
	})(_react2['default'].Component);
	
	exports.Paginator = Paginator;
	;


/***/ }),
/* 2156 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Sort = {
	    Numeric: function Numeric(a, b) {
	        var valA = parseFloat(a.toString().replace(/,/g, ''));
	        var valB = parseFloat(b.toString().replace(/,/g, ''));
	
	        // Sort non-numeric values alphabetically at the bottom of the list
	        if (isNaN(valA) && isNaN(valB)) {
	            valA = a;
	            valB = b;
	        } else {
	            if (isNaN(valA)) {
	                return 1;
	            }
	            if (isNaN(valB)) {
	                return -1;
	            }
	        }
	
	        if (valA < valB) {
	            return -1;
	        }
	        if (valA > valB) {
	            return 1;
	        }
	
	        return 0;
	    },
	
	    NumericInteger: function NumericInteger(a, b) {
	        if (isNaN(a) || isNaN(b)) {
	            return a > b ? 1 : -1;
	        }
	
	        return a - b;
	    },
	
	    Currency: function Currency(a, b) {
	        // Parse out dollar signs, then do a regular numeric sort
	        // TODO: handle non-American currency
	
	        if (a[0] === '$') {
	            a = a.substring(1);
	        }
	        if (b[0] === '$') {
	            b = b.substring(1);
	        }
	
	        return exports.Sort.Numeric(a, b);
	    },
	
	    Date: (function (_Date) {
	        function Date(_x, _x2) {
	            return _Date.apply(this, arguments);
	        }
	
	        Date.toString = function () {
	            return _Date.toString();
	        };
	
	        return Date;
	    })(function (a, b) {
	        // Note: this function tries to do a standard javascript string -> date conversion
	        // If you need more control over the date string format, consider using a different
	        // date library and writing your own function
	        var valA = Date.parse(a);
	        var valB = Date.parse(b);
	
	        // Handle non-date values with numeric sort
	        // Sort non-numeric values alphabetically at the bottom of the list
	        if (isNaN(valA) || isNaN(valB)) {
	            return exports.Sort.Numeric(a, b);
	        }
	
	        if (valA > valB) {
	            return 1;
	        }
	        if (valB > valA) {
	            return -1;
	        }
	
	        return 0;
	    }),
	
	    CaseInsensitive: function CaseInsensitive(a, b) {
	        return a.toLowerCase().localeCompare(b.toLowerCase());
	    }
	};
	exports.Sort = Sort;


/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _libFilter_props_from = __webpack_require__(346);
	
	var _libExtract_data_from = __webpack_require__(2152);
	
	var _unsafe = __webpack_require__(347);
	
	var _thead = __webpack_require__(904);
	
	var _th = __webpack_require__(499);
	
	var _tr = __webpack_require__(905);
	
	var _tfoot = __webpack_require__(903);
	
	var _paginator = __webpack_require__(2155);
	
	var Table = (function (_React$Component) {
	    _inherits(Table, _React$Component);
	
	    function Table(props) {
	        _classCallCheck(this, Table);
	
	        _get(Object.getPrototypeOf(Table.prototype), 'constructor', this).call(this, props);
	
	        this.state = {
	            currentPage: 0,
	            currentSort: {
	                column: null,
	                direction: this.props.defaultSortDescending ? -1 : 1
	            },
	            filter: ''
	        };
	
	        // Set the state of the current sort to the default sort
	        if (props.sortBy !== false || props.defaultSort !== false) {
	            var sortingColumn = props.sortBy || props.defaultSort;
	            this.state.currentSort = this.getCurrentSort(sortingColumn);
	        }
	    }
	
	    _createClass(Table, [{
	        key: 'filterBy',
	        value: function filterBy(filter) {
	            this.setState({ filter: filter });
	        }
	
	        // Translate a user defined column array to hold column objects if strings are specified
	        // (e.g. ['column1'] => [{key: 'column1', label: 'column1'}])
	    }, {
	        key: 'translateColumnsArray',
	        value: function translateColumnsArray(columns) {
	            return columns.map((function (column, i) {
	                if (typeof column === 'string') {
	                    return {
	                        key: column,
	                        label: column
	                    };
	                } else {
	                    if (typeof column.sortable !== 'undefined') {
	                        var sortFunction = column.sortable === true ? 'default' : column.sortable;
	                        this._sortable[column.key] = sortFunction;
	                    }
	
	                    return column;
	                }
	            }).bind(this));
	        }
	    }, {
	        key: 'parseChildData',
	        value: function parseChildData(props) {
	            var data = [],
	                tfoot = undefined;
	
	            // Transform any children back to a data array
	            if (typeof props.children !== 'undefined') {
	                _react2['default'].Children.forEach(props.children, (function (child) {
	                    if (typeof child === 'undefined' || child === null) {
	                        return;
	                    }
	
	                    switch (child.type) {
	                        case _tfoot.Tfoot:
	                            if (typeof tfoot !== 'undefined') {
	                                console.warn('You can only have one <Tfoot>, but more than one was specified.' + 'Ignoring all but the last one');
	                            }
	                            tfoot = child;
	                            break;
	                        case _tr.Tr:
	                            var childData = child.props.data || {};
	
	                            _react2['default'].Children.forEach(child.props.children, function (descendant) {
	                                // TODO
	                                /* if (descendant.type.ConvenienceConstructor === Td) { */
	                                if (typeof descendant !== 'object' || descendant == null) {
	                                    return;
	                                } else if (typeof descendant.props.column !== 'undefined') {
	                                    var value = undefined;
	
	                                    if (typeof descendant.props.data !== 'undefined') {
	                                        value = descendant.props.data;
	                                    } else if (typeof descendant.props.children !== 'undefined') {
	                                        value = descendant.props.children;
	                                    } else {
	                                        return;
	                                    }
	
	                                    childData[descendant.props.column] = {
	                                        value: value,
	                                        props: (0, _libFilter_props_from.filterPropsFrom)(descendant.props),
	                                        __reactableMeta: true
	                                    };
	                                } else {
	                                    console.warn('exports.Td specified without a ' + '`column` property, ignoring');
	                                }
	                            });
	
	                            data.push({
	                                data: childData,
	                                props: (0, _libFilter_props_from.filterPropsFrom)(child.props),
	                                __reactableMeta: true
	                            });
	                            break;
	                    }
	                }).bind(this));
	            }
	
	            return { data: data, tfoot: tfoot };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(props) {
	            this.data = props.data || [];
	
	            var _parseChildData = this.parseChildData(props);
	
	            var data = _parseChildData.data;
	            var tfoot = _parseChildData.tfoot;
	
	            this.data = this.data.concat(data);
	            this.tfoot = tfoot;
	
	            this.initializeSorts(props);
	        }
	    }, {
	        key: 'initializeSorts',
	        value: function initializeSorts() {
	            this._sortable = {};
	            // Transform sortable properties into a more friendly list
	            for (var i in this.props.sortable) {
	                var column = this.props.sortable[i];
	                var columnName = undefined,
	                    sortFunction = undefined;
	
	                if (column instanceof Object) {
	                    if (typeof column.column !== 'undefined') {
	                        columnName = column.column;
	                    } else {
	                        console.warn('Sortable column specified without column name');
	                        return;
	                    }
	
	                    if (typeof column.sortFunction === 'function') {
	                        sortFunction = column.sortFunction;
	                    } else {
	                        sortFunction = 'default';
	                    }
	                } else {
	                    columnName = column;
	                    sortFunction = 'default';
	                }
	
	                this._sortable[columnName] = sortFunction;
	            }
	        }
	    }, {
	        key: 'getCurrentSort',
	        value: function getCurrentSort(column) {
	            var columnName = undefined,
	                sortDirection = undefined;
	
	            if (column instanceof Object) {
	                if (typeof column.column !== 'undefined') {
	                    columnName = column.column;
	                } else {
	                    console.warn('Default column specified without column name');
	                    return;
	                }
	
	                if (typeof column.direction !== 'undefined') {
	                    if (column.direction === 1 || column.direction === 'asc') {
	                        sortDirection = 1;
	                    } else if (column.direction === -1 || column.direction === 'desc') {
	                        sortDirection = -1;
	                    } else {
	                        var defaultDirection = this.props.defaultSortDescending ? 'descending' : 'ascending';
	
	                        console.warn('Invalid default sort specified. Defaulting to ' + defaultDirection);
	                        sortDirection = this.props.defaultSortDescending ? -1 : 1;
	                    }
	                } else {
	                    sortDirection = this.props.defaultSortDescending ? -1 : 1;
	                }
	            } else {
	                columnName = column;
	                sortDirection = this.props.defaultSortDescending ? -1 : 1;
	            }
	
	            return {
	                column: columnName,
	                direction: sortDirection
	            };
	        }
	    }, {
	        key: 'updateCurrentSort',
	        value: function updateCurrentSort(sortBy) {
	            if (sortBy !== false && sortBy.column !== this.state.currentSort.column && sortBy.direction !== this.state.currentSort.direction) {
	
	                this.setState({ currentSort: this.getCurrentSort(sortBy) });
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.initialize(this.props);
	            this.sortByCurrentSort();
	            this.filterBy(this.props.filterBy != null ? this.props.filterBy : this.state.filter);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.initialize(nextProps);
	            this.updateCurrentSort(nextProps.sortBy);
	            this.sortByCurrentSort();
	            this.filterBy(nextProps.filterBy != null ? nextProps.filterBy : this.state.filter);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.diffChildren();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.diffChildren();
	        }
	    }, {
	        key: 'diffChildren',
	        value: function diffChildren() {
	            var onVisibleChange = this.props.onVisibleChange;
	            var lastChildren = this.lastChildren;
	            var lastIds = this.lastIds;
	            var currentChildren = this.currentChildren;
	
	            if (!onVisibleChange || !currentChildren) {
	                return;
	            }
	
	            if (lastChildren === currentChildren) {
	                return;
	            }
	            var currentIds = this.childrenToData(currentChildren, true);
	
	            var same = undefined;
	            if (lastIds && lastIds.length === currentIds.length) {
	                same = true;
	                for (var i = 0; i < currentIds.length; i++) {
	                    if (lastIds[i] !== currentIds[i]) {
	                        same = false;
	                        break;
	                    }
	                }
	            }
	
	            this.lastIds = currentIds;
	            this.lastChildren = currentChildren;
	            if (!same) {
	                onVisibleChange(currentIds);
	            }
	        }
	    }, {
	        key: 'applyFilter',
	        value: function applyFilter(filter, children) {
	            // Helper function to apply filter text to a list of table rows
	            filter = filter.toLowerCase();
	            var matchedChildren = [];
	
	            for (var i = 0; i < children.length; i++) {
	                var data = children[i].props.data;
	
	                for (var j = 0; j < this.props.filterable.length; j++) {
	                    var filterColumn = this.props.filterable[j];
	
	                    if (typeof data[filterColumn] !== 'undefined' && (0, _libExtract_data_from.extractDataFrom)(data, filterColumn).toString().toLowerCase().indexOf(filter) > -1) {
	                        matchedChildren.push(children[i]);
	                        break;
	                    }
	                }
	            }
	
	            return matchedChildren;
	        }
	    }, {
	        key: 'sortByCurrentSort',
	        value: function sortByCurrentSort() {
	            // Apply a sort function according to the current sort in the state.
	            // This allows us to perform a default sort even on a non sortable column.
	            var currentSort = this.state.currentSort;
	
	            if (currentSort.column === null) {
	                return;
	            }
	
	            this.data.sort((function (a, b) {
	                var keyA = (0, _libExtract_data_from.extractDataFrom)(a, currentSort.column);
	                keyA = (0, _unsafe.isUnsafe)(keyA) ? keyA.toString() : keyA || '';
	                var keyB = (0, _libExtract_data_from.extractDataFrom)(b, currentSort.column);
	                keyB = (0, _unsafe.isUnsafe)(keyB) ? keyB.toString() : keyB || '';
	
	                // Default sort
	                if (typeof this._sortable[currentSort.column] === 'undefined' || this._sortable[currentSort.column] === 'default') {
	
	                    // Reverse direction if we're doing a reverse sort
	                    if (keyA < keyB) {
	                        return -1 * currentSort.direction;
	                    }
	
	                    if (keyA > keyB) {
	                        return 1 * currentSort.direction;
	                    }
	
	                    return 0;
	                } else {
	                    // Reverse columns if we're doing a reverse sort
	                    if (currentSort.direction === 1) {
	                        return this._sortable[currentSort.column](keyA, keyB);
	                    } else {
	                        return this._sortable[currentSort.column](keyB, keyA);
	                    }
	                }
	            }).bind(this));
	        }
	    }, {
	        key: 'onSort',
	        value: function onSort(column) {
	            // Don't perform sort on unsortable columns
	            if (typeof this._sortable[column] === 'undefined') {
	                return;
	            }
	
	            var currentSort = this.state.currentSort;
	
	            if (currentSort.column === column) {
	                currentSort.direction *= -1;
	            } else {
	                currentSort.column = column;
	                currentSort.direction = this.props.defaultSortDescending ? -1 : 1;
	            }
	
	            // Set the current sort and pass it to the sort function
	            this.setState({ currentSort: currentSort });
	            if (this.props.externalPagination) {
	                if (typeof this.props.onSort === 'function') {
	                    this.props.onSort(currentSort);
	                }
	                return;
	            }
	            this.sortByCurrentSort();
	            if (typeof this.props.onSort === 'function') {
	                this.props.onSort(currentSort);
	            }
	        }
	    }, {
	        key: 'childrenToData',
	        value: function childrenToData(children, onlyIds) {
	            return children.map(function (row) {
	                var _row$props = row.props;
	                var i = _row$props.i;
	                var id = _row$props.id;
	
	                var iOrId = i != null ? i : id;
	                var idOrKey = iOrId != null ? iOrId : row.key;
	
	                if (onlyIds) {
	                    return idOrKey;
	                }
	
	                var data = { id: idOrKey };
	                Object.keys(row.props.data).forEach(function (key) {
	                    var col = row.props.data[key];
	                    data[key] = col.props.value != null ? col.props.value : col.value;
	                });
	
	                return data;
	            });
	        }
	    }, {
	        key: 'visibleItems',
	        value: function visibleItems(onlyIds) {
	            return this.childrenToData(onlyIds);
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.headEl) {
	                this.headEl.scrollIntoView();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var children = [];
	            var columns = undefined;
	            var userColumnsSpecified = false;
	
	            var externalPaginationData = null;
	            if (this.props.externalPagination) {
	                externalPaginationData = this.props.externalPagination;
	            }
	
	            var firstChild = null;
	
	            if (this.props.children && this.props.children.length > 0 && this.props.children[0].type === _thead.Thead) {
	                firstChild = this.props.children[0];
	            } else if (typeof this.props.children !== 'undefined' && this.props.children.type === _thead.Thead) {
	                firstChild = this.props.children;
	            }
	
	            if (firstChild !== null) {
	                columns = _thead.Thead.getColumns(firstChild);
	            } else {
	                columns = this.props.columns || [];
	            }
	
	            if (columns.length > 0) {
	                userColumnsSpecified = true;
	                columns = this.translateColumnsArray(columns);
	            }
	
	            // Build up table rows
	            if (this.data && typeof this.data.map === 'function') {
	                // Build up the columns array
	                children = children.concat(this.data.map((function (rawData, i) {
	                    var data = rawData;
	                    var props = {};
	                    if (rawData.__reactableMeta === true) {
	                        data = rawData.data;
	                        props = rawData.props;
	                    }
	
	                    // Loop through the keys in each data row and build a td for it
	                    for (var k in data) {
	                        if (data.hasOwnProperty(k)) {
	                            // Update the columns array with the data's keys if columns were not
	                            // already specified
	                            if (userColumnsSpecified === false) {
	                                (function () {
	                                    var column = {
	                                        key: k,
	                                        label: k
	                                    };
	
	                                    // Only add a new column if it doesn't already exist in the columns array
	                                    if (columns.find(function (element) {
	                                        return element.key === column.key;
	                                    }) === undefined) {
	                                        columns.push(column);
	                                    }
	                                })();
	                            }
	                        }
	                    }
	
	                    return _react2['default'].createElement(_tr.Tr, _extends({ columns: columns, key: i, data: data }, props));
	                }).bind(this)));
	            }
	
	            if (this.props.sortable === true) {
	                for (var i = 0; i < columns.length; i++) {
	                    this._sortable[columns[i].key] = 'default';
	                }
	            }
	
	            // Determine if we render the filter box
	            var filtering = false;
	            if (Array.isArray(this.props.filterable) && this.props.filterable.length > 0 && !this.props.hideFilterInput) {
	                filtering = true;
	            }
	
	            // Apply filters
	            var filterCleanBtn = this.props.filterCleanBtn && this.state.filter;
	            var filteredChildren = children;
	            if (this.state.filter !== '') {
	                filteredChildren = this.applyFilter(this.state.filter, filteredChildren);
	            }
	
	            // Determine pagination properties and which columns to display
	            var itemsPerPage = 0;
	            var pagination = false;
	            var topPagination = this.props.topPagination || false;
	            var middlePagination = this.props.middlePagination || false;
	            var bottomPagination = this.props.bottomPagination || false;
	            var numPages = undefined;
	            var currentPage = externalPaginationData && externalPaginationData.currentPage || this.state.currentPage;
	            var pageButtonLimit = this.props.pageButtonLimit || 10;
	
	            var currentChildren = filteredChildren;
	            if (this.props.itemsPerPage > 0 && !externalPaginationData) {
	                itemsPerPage = this.props.itemsPerPage;
	                numPages = Math.ceil(filteredChildren.length / itemsPerPage);
	
	                if (currentPage > numPages - 1) {
	                    currentPage = numPages - 1;
	                }
	
	                pagination = numPages > 1;
	                currentChildren = filteredChildren.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
	            } else if (this.props.itemsPerPage > 0) {
	                itemsPerPage = this.props.itemsPerPage;
	                numPages = Math.ceil(externalPaginationData.totalRecords / itemsPerPage);
	
	                if (currentPage > numPages - 1) {
	                    currentPage = numPages - 1;
	                }
	
	                pagination = numPages > 1;
	            }
	
	            // Manually transfer props
	            var props = (0, _libFilter_props_from.filterPropsFrom)(this.props);
	
	            var noDataText = this.props.noDataText ? _react2['default'].createElement(
	                'tr',
	                { className: 'reactable-no-data' },
	                _react2['default'].createElement(
	                    'td',
	                    { colSpan: columns.length },
	                    this.props.noDataText
	                )
	            ) : null;
	
	            this.currentChildren = currentChildren;
	            return _react2['default'].createElement(
	                'table',
	                null,
	                columns && columns.length > 0 ? _react2['default'].createElement(_thead.Thead, {
	                    ref: function (t) {
	                        return _this.headEl = t;
	                    },
	                    columns: columns,
	                    topPagination: topPagination,
	                    middlePagination: middlePagination,
	                    itemsNumber: externalPaginationData && externalPaginationData.totalRecords ? externalPaginationData.totalRecords : filteredChildren.length,
	                    itemsPerPage: itemsPerPage,
	                    numPages: numPages,
	                    currentPage: currentPage,
	                    topPaginationElem: {
	                        left: this.props.topPaginationElemL,
	                        right: this.props.topPaginationElemR
	                    },
	                    middlePaginationElem: this.props.middlePaginationElem,
	                    filtering: filtering,
	                    onFilter: function (filter) {
	                        //on external filtration add function call here
	
	                        _this.setState({ filter: filter });
	                    },
	                    filterCleanBtn: filterCleanBtn,
	                    onClean: function (filter) {
	                        _this.setState({ filter: '' });
	                    },
	                    onPageChange: function (page) {
	                        if (externalPaginationData) {
	                            externalPaginationData.onPageChange(page);
	                        } else {
	                            var onPageChange = _this.props.onPageChange;
	
	                            onPageChange && onPageChange(page);
	                            _this.setState({ currentPage: page });
	                        }
	                        _this.scrollToTop();
	                    },
	                    filterPlaceholder: this.props.filterPlaceholder,
	                    currentFilter: this.state.filter,
	                    sort: this.state.currentSort,
	                    sortableColumns: this._sortable,
	                    onSort: this.onSort.bind(this),
	                    key: 'thead',
	                    locale: this.props.locale
	                }) : null,
	                _react2['default'].createElement(
	                    'tbody',
	                    { className: 'reactable-data', key: 'tbody' },
	                    currentChildren.length > 0 ? currentChildren : noDataText
	                ),
	                pagination ? _react2['default'].createElement(_paginator.Paginator, { bottomPagination: bottomPagination,
	                    itemsNumber: externalPaginationData && externalPaginationData.totalRecords ? externalPaginationData.totalRecords : filteredChildren.length,
	                    itemsPerPage: itemsPerPage,
	                    locale: this.props.locale,
	                    colSpan: columns.length,
	                    pageButtonLimit: pageButtonLimit,
	                    numPages: numPages,
	                    currentPage: currentPage,
	                    bottomPaginationElem: {
	                        left: this.props.bottomPaginationElemL,
	                        right: this.props.bottomPaginationElemR
	                    },
	                    onPageChange: function (page) {
	                        if (externalPaginationData) {
	                            externalPaginationData.onPageChange(page);
	                        } else {
	                            _this.setState({ currentPage: page });
	                        }
	                        _this.scrollToTop();
	                    },
	                    key: 'paginator'
	                }) : null,
	                this.tfoot
	            );
	        }
	    }]);
	
	    return Table;
	})(_react2['default'].Component);
	
	exports.Table = Table;
	
	Table.defaultProps = {
	    sortBy: false,
	    defaultSort: false,
	    defaultSortDescending: false,
	    itemsPerPage: 0,
	    hideFilterInput: false,
	    locale: 'en'
	};


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoprefix = undefined;
	
	var _forOwn2 = __webpack_require__(326);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  borderRadius: function borderRadius(value) {
	    return {
	      msBorderRadius: value,
	      MozBorderRadius: value,
	      OBorderRadius: value,
	      WebkitBorderRadius: value,
	      borderRadius: value
	    };
	  },
	  boxShadow: function boxShadow(value) {
	    return {
	      msBoxShadow: value,
	      MozBoxShadow: value,
	      OBoxShadow: value,
	      WebkitBoxShadow: value,
	      boxShadow: value
	    };
	  },
	  userSelect: function userSelect(value) {
	    return {
	      WebkitTouchCallout: value,
	      KhtmlUserSelect: value,
	      MozUserSelect: value,
	      msUserSelect: value,
	      WebkitUserSelect: value,
	      userSelect: value
	    };
	  },
	
	  flex: function flex(value) {
	    return {
	      WebkitBoxFlex: value,
	      MozBoxFlex: value,
	      WebkitFlex: value,
	      msFlex: value,
	      flex: value
	    };
	  },
	  flexBasis: function flexBasis(value) {
	    return {
	      WebkitFlexBasis: value,
	      flexBasis: value
	    };
	  },
	  justifyContent: function justifyContent(value) {
	    return {
	      WebkitJustifyContent: value,
	      justifyContent: value
	    };
	  },
	
	  transition: function transition(value) {
	    return {
	      msTransition: value,
	      MozTransition: value,
	      OTransition: value,
	      WebkitTransition: value,
	      transition: value
	    };
	  },
	
	  transform: function transform(value) {
	    return {
	      msTransform: value,
	      MozTransform: value,
	      OTransform: value,
	      WebkitTransform: value,
	      transform: value
	    };
	  },
	  absolute: function absolute(value) {
	    var direction = value && value.split(' ');
	    return {
	      position: 'absolute',
	      top: direction && direction[0],
	      right: direction && direction[1],
	      bottom: direction && direction[2],
	      left: direction && direction[3]
	    };
	  },
	  extend: function extend(name, otherElementStyles) {
	    var otherStyle = otherElementStyles[name];
	    if (otherStyle) {
	      return otherStyle;
	    }
	    return {
	      'extend': name
	    };
	  }
	};
	
	var autoprefix = exports.autoprefix = function autoprefix(elements) {
	  var prefixed = {};
	  (0, _forOwn3.default)(elements, function (styles, element) {
	    var expanded = {};
	    (0, _forOwn3.default)(styles, function (value, key) {
	      var transform = transforms[key];
	      if (transform) {
	        expanded = _extends({}, expanded, transform(value));
	      } else {
	        expanded[key] = value;
	      }
	    });
	    prefixed[element] = expanded;
	  });
	  return prefixed;
	};
	
	exports.default = autoprefix;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.active = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var active = exports.active = function active(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Active, _React$Component);
	
	    function Active() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Active);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
	        return _this.setState({ active: true });
	      }, _this.handleMouseUp = function () {
	        return _this.setState({ active: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Active;
	  }(_react2.default.Component);
	};
	
	exports.default = active;

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hover = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hover = exports.hover = function hover(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Hover, _React$Component);
	
	    function Hover() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hover);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
	        return _this.setState({ hover: true });
	      }, _this.handleMouseOut = function () {
	        return _this.setState({ hover: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Hover;
	  }(_react2.default.Component);
	};
	
	exports.default = hover;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flattenNames = undefined;
	
	var _isString2 = __webpack_require__(251);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _forOwn2 = __webpack_require__(326);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _isPlainObject2 = __webpack_require__(120);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _map2 = __webpack_require__(87);
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenNames = exports.flattenNames = function flattenNames() {
	  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = [];
	
	  (0, _map3.default)(things, function (thing) {
	    if (Array.isArray(thing)) {
	      flattenNames(thing).map(function (name) {
	        return names.push(name);
	      });
	    } else if ((0, _isPlainObject3.default)(thing)) {
	      (0, _forOwn3.default)(thing, function (value, key) {
	        value === true && names.push(key);
	        names.push(key + '-' + value);
	      });
	    } else if ((0, _isString3.default)(thing)) {
	      names.push(thing);
	    }
	  });
	
	  return names;
	};
	
	exports.default = flattenNames;

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopable = function loopable(i, length) {
	  var props = {};
	  var setProp = function setProp(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    props[name] = value;
	  };
	
	  i === 0 && setProp('first-child');
	  i === length - 1 && setProp('last-child');
	  (i === 0 || i % 2 === 0) && setProp('even');
	  Math.abs(i % 2) === 1 && setProp('odd');
	  setProp('nth-child', i);
	
	  return props;
	};
	
	exports.default = loopable;

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeClasses = undefined;
	
	var _forOwn2 = __webpack_require__(326);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _cloneDeep2 = __webpack_require__(786);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
	  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
	  activeNames.map(function (name) {
	    var toMerge = classes[name];
	    if (toMerge) {
	      (0, _forOwn3.default)(toMerge, function (value, key) {
	        if (!styles[key]) {
	          styles[key] = {};
	        }
	
	        styles[key] = _extends({}, styles[key], toMerge[key]);
	      });
	    }
	
	    return name;
	  });
	  return styles;
	};
	
	exports.default = mergeClasses;

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(167);


/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(907);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(242));
	util.inherits = __webpack_require__(198);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(352).Buffer;
	var util = __webpack_require__(2334);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(501).PassThrough


/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(501).Transform


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(500);


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	// toAction:
	// * prevent move: thunk and don't call
	// * allow move to other part of site: return false
	// * preload data: thunk, preload, dispatch
	
	// toUrl:
	// * e.g. localized urls for localized blogposts
	
	// use constants to indicate views
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _history = __webpack_require__(2188);
	
	/*
		This code is adapted from the Page JS source code. Amazing work on handling all
		kinds of scenarios with hyperlinks, thanks!
	*/
	
	var isSameOrigin = function isSameOrigin(origin) {
		var myOrigin = location.protocol + '//' + location.hostname;
		if (location.port) {
			myOrigin += ':' + location.port;
		}
		return origin === myOrigin;
	};
	
	var getClickedHref = function getClickedHref(event) {
		// React already filters buttons so not checking for only-button-1
	
		// check for modifiers
		if (event.metaKey || event.ctrlKey || event.shiftKey) {
			return false;
		}
		if (event.defaultPrevented) {
			return false;
		}
	
		// ensure link
		var element = event.target;
		while (element && element.nodeName !== 'A') {
			element = element.parentNode;
		}
		if (!element || element.nodeName !== 'A') {
			return false;
		}
	
		// Ignore if tag has
		// 1. "download" attribute
		// 2. rel="external" attribute
		if (element.hasAttribute('download') || element.getAttribute('rel') === 'external') {
			return false;
		}
	
		// check target
		if (element.target) {
			return false;
		}
	
		// x-origin
		if (!isSameOrigin(element.origin)) {
			return false;
		}
	
		return element.href.slice(element.origin.length);
	};
	
	var BoundUrl = function BoundUrl(options) {
		var _this = this;
	
		_classCallCheck(this, BoundUrl);
	
		var store = options.store;
		var fromLoc = options.fromLoc;
		var toLoc = options.toLoc;
	
		if (!store || !fromLoc || !toLoc) {
			throw new Error("arguments");
		}
		var history = (0, _history.createHistory)();
	
		this.settingUrl = false;
		this.currentLocation = {};
	
		// Listen for changes to the current location.
		// The listener is called once immediately, use to initialize
		var unlisten1 = history.listenBefore(function (location) {
			console.log('listenBefore', location);
			if (!_this.settingUrl && location.action === 'PUSH') {
				var action = fromLoc(location);
				if (action !== false) {
					store.dispatch(action);
				}
				// Prevent URL update
				return false;
			}
			_this.settingUrl = false;
		});
	
		// Called on allowed changes and prev/next
		var unlisten2 = history.listen(function (location) {
			console.log('listen', location.pathname);
			_this.currentLocation = location;
			// Ignore expected updates that would mean duplicate data
			if (!_this.settingUrl && location.action === 'POP') {
				// Moving through the browser history, pre-approved
				var action = fromLoc(location);
				if (action !== false) {
					store.dispatch(action);
				}
			}
			_this.settingUrl = false;
		});
	
		// store.dispatch(fromLoc(location))
		var unlisten3 = store.subscribe(function () {
			var calcLoc = toLoc(store.getState());
	
			var newLoc = {};
			if (calcLoc.pathname) {
				newLoc.pathname = calcLoc.pathname;
			} else {
				newLoc.pathname = _this.currentLocation.pathname;
			}
			if (calcLoc.search) {
				newLoc.search = calcLoc.search;
			} else {
				newLoc.search = _this.currentLocation.search;
			}
			if (calcLoc.hash) {
				newLoc.hash = calcLoc.hash;
			} else {
				newLoc.hash = _this.currentLocation.hash;
			}
	
			var t = _this.currentLocation;
			if (!_this.settingUrl && (t.pathname !== newLoc.pathname || t.search !== newLoc.search || t.hash !== newLoc.hash)) {
				console.log("updateBar from", JSON.stringify(_this.currentLocation), ' to ', JSON.stringify(newLoc));
				_this.settingUrl = true;
				if (calcLoc.replace || t.pathname === newLoc.pathname) {
					history.replace(newLoc);
				} else {
					history.push(newLoc);
				}
			}
		});
	
		// Should this be an actionCreator?
		this.go = function (n) {
			return history.go(n);
		};
	
		this.interceptClicks = function (event) {
			var href = getClickedHref(event);
	
			if (href) {
				event.preventDefault();
				store.dispatch(fromLoc({ pathname: href }));
			}
		};
		this.cleanup = function () {
			unlisten1();
			unlisten2();
			unlisten3();
		};
	};
	
	var makeBoundUrl = function makeBoundUrl(options) {
		return new BoundUrl(options);
	};
	exports.makeBoundUrl = makeBoundUrl;
	exports['default'] = makeBoundUrl;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 2171 */
[2337, 923, 2190, 2193, 2192, 2197, 2191],
/* 2172 */
1568,
/* 2173 */
1569,
/* 2174 */
1570,
/* 2175 */
1571,
/* 2176 */
1572,
/* 2177 */
1661,
/* 2178 */
1662,
/* 2179 */
1666,
/* 2180 */
[2345, 913],
/* 2181 */
[2347, 505],
/* 2182 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0;
	  var isDone = false;
	
	  function done() {
	    isDone = true;
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) return;
	
	    if (currentTurn < turns) {
	      work.call(this, currentTurn++, next, done);
	    } else {
	      done.apply(this, arguments);
	    }
	  }
	
	  next();
	}

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(349);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(215);
	
	var _ExecutionEnvironment = __webpack_require__(259);
	
	var _DOMUtils = __webpack_require__(348);
	
	var _DOMStateStorage = __webpack_require__(914);
	
	var _createDOMHistory = __webpack_require__(915);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	var _parsePath = __webpack_require__(169);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    historyState = historyState || window.history.state || {};
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null, path);
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(170);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(349);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(215);
	
	var _ExecutionEnvironment = __webpack_require__(259);
	
	var _DOMUtils = __webpack_require__(348);
	
	var _DOMStateStorage = __webpack_require__(914);
	
	var _createDOMHistory = __webpack_require__(915);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	var _parsePath = __webpack_require__(169);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(170);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(349);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(215);
	
	var _createHistory = __webpack_require__(916);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _parsePath = __webpack_require__(169);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var key = entry.key;
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var state = undefined;
	    if (key) {
	      state = readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	      entry.key = key;
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(168);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useBeforeUnload = __webpack_require__(919);
	
	var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);
	
	exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
	module.exports = exports['default'];

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(168);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useQueries = __webpack_require__(920);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
	module.exports = exports['default'];

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(168);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _createLocation2 = __webpack_require__(917);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _createBrowserHistory = __webpack_require__(2183);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	exports.createHistory = _createBrowserHistory2['default'];
	
	var _createHashHistory2 = __webpack_require__(2184);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	exports.createHashHistory = _createHashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(2185);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];
	
	var _useBasename2 = __webpack_require__(2189);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	exports.useBasename = _useBasename3['default'];
	
	var _useBeforeUnload2 = __webpack_require__(919);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	exports.useBeforeUnload = _useBeforeUnload3['default'];
	
	var _useQueries2 = __webpack_require__(920);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	exports.useQueries = _useQueries3['default'];
	
	var _Actions2 = __webpack_require__(215);
	
	var _Actions3 = _interopRequireDefault(_Actions2);
	
	exports.Actions = _Actions3['default'];
	
	// deprecated
	
	var _enableBeforeUnload2 = __webpack_require__(2186);
	
	var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);
	
	exports.enableBeforeUnload = _enableBeforeUnload3['default'];
	
	var _enableQueries2 = __webpack_require__(2187);
	
	var _enableQueries3 = _interopRequireDefault(_enableQueries2);
	
	exports.enableQueries = _enableQueries3['default'];
	var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
	exports.createLocation = createLocation;

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _ExecutionEnvironment = __webpack_require__(259);
	
	var _runTransitionHook = __webpack_require__(508);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _extractPath = __webpack_require__(918);
	
	var _extractPath2 = _interopRequireDefault(_extractPath);
	
	var _parsePath = __webpack_require__(169);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(168);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var basename = options.basename;
	
	    var historyOptions = _objectWithoutProperties(options, ['basename']);
	
	    var history = createHistory(historyOptions);
	
	    // Automatically use the value of <base href> in HTML
	    // documents as basename if it's not explicitly given.
	    if (basename == null && _ExecutionEnvironment.canUseDOM) {
	      var base = document.getElementsByTagName('base')[0];
	
	      if (base) basename = _extractPath2['default'](base.href);
	    }
	
	    function addBasename(location) {
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation() {
	      return addBasename(history.createLocation.apply(history, arguments));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 2190 */
[2348, 507, 910],
/* 2191 */
[2349, 507],
/* 2192 */
[2350, 910, 507],
/* 2193 */
[2351, 257, 502, 921, 922, 2194],
/* 2194 */
[2353, 922, 257],
/* 2195 */
[2354, 924],
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(2201);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 2197 */
[2358, 257, 502, 925, 926, 2198],
/* 2198 */
[2360, 257, 926],
/* 2199 */
[2361, 258, 503, 506, 912, 214],
/* 2200 */
[2362, 503, 506, 2178, 214],
/* 2201 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(445);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(350);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (!(0, _isValid2.default)(errors)) {
	        stop(errors);
	        return Promise.reject();
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createAll;
	
	var _reducer = __webpack_require__(511);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _createReduxForm = __webpack_require__(2206);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _mapValues = __webpack_require__(510);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _bindActionData = __webpack_require__(928);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _actions = __webpack_require__(927);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(509);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _createPropTypes = __webpack_require__(2205);
	
	var _createPropTypes2 = _interopRequireDefault(_createPropTypes);
	
	var _getValuesFromState = __webpack_require__(936);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// bind form as first parameter of action creators
	var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
	  autofillWithKey: function autofillWithKey(key) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
	  },
	  changeWithKey: function changeWithKey(key) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
	  },
	  initializeWithKey: function initializeWithKey(key) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
	  },
	  reset: function reset(key) {
	    return (0, _bindActionData2.default)(actions.reset, { key: key })();
	  },
	  touchWithKey: function touchWithKey(key) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
	  },
	  untouchWithKey: function untouchWithKey(key) {
	    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      args[_key5 - 1] = arguments[_key5];
	    }
	
	    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
	  },
	  destroy: function destroy(key) {
	    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
	  }
	}), function (action) {
	  return function (form) {
	    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	      args[_key6 - 1] = arguments[_key6];
	    }
	
	    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
	  };
	}));
	
	var addArrayValue = boundActions.addArrayValue;
	var autofill = boundActions.autofill;
	var autofillWithKey = boundActions.autofillWithKey;
	var blur = boundActions.blur;
	var change = boundActions.change;
	var changeWithKey = boundActions.changeWithKey;
	var destroy = boundActions.destroy;
	var focus = boundActions.focus;
	var initialize = boundActions.initialize;
	var initializeWithKey = boundActions.initializeWithKey;
	var removeArrayValue = boundActions.removeArrayValue;
	var reset = boundActions.reset;
	var startAsyncValidation = boundActions.startAsyncValidation;
	var startSubmit = boundActions.startSubmit;
	var stopAsyncValidation = boundActions.stopAsyncValidation;
	var stopSubmit = boundActions.stopSubmit;
	var submitFailed = boundActions.submitFailed;
	var swapArrayValues = boundActions.swapArrayValues;
	var touch = boundActions.touch;
	var touchWithKey = boundActions.touchWithKey;
	var untouch = boundActions.untouch;
	var untouchWithKey = boundActions.untouchWithKey;
	
	function createAll(isReactNative, React, connect) {
	  return {
	    actionTypes: actionTypes,
	    addArrayValue: addArrayValue,
	    autofill: autofill,
	    autofillWithKey: autofillWithKey,
	    blur: blur,
	    change: change,
	    changeWithKey: changeWithKey,
	    destroy: destroy,
	    focus: focus,
	    getValues: _getValuesFromState2.default,
	    initialize: initialize,
	    initializeWithKey: initializeWithKey,
	    propTypes: (0, _createPropTypes2.default)(),
	    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
	    reducer: _reducer2.default,
	    removeArrayValue: removeArrayValue,
	    reset: reset,
	    startAsyncValidation: startAsyncValidation,
	    startSubmit: startSubmit,
	    stopAsyncValidation: stopAsyncValidation,
	    stopSubmit: stopSubmit,
	    submitFailed: submitFailed,
	    swapArrayValues: swapArrayValues,
	    touch: touch,
	    touchWithKey: touchWithKey,
	    untouch: untouch,
	    untouchWithKey: untouchWithKey
	  };
	}

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(927);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _getDisplayName = __webpack_require__(934);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _reducer = __webpack_require__(511);
	
	var _deepEqual = __webpack_require__(709);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _bindActionData = __webpack_require__(928);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _getValues = __webpack_require__(935);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _isValid = __webpack_require__(350);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _readFields = __webpack_require__(2217);
	
	var _readFields2 = _interopRequireDefault(_readFields);
	
	var _handleSubmit2 = __webpack_require__(2213);
	
	var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);
	
	var _asyncValidation = __webpack_require__(2202);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _silenceEvents = __webpack_require__(2212);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _silenceEvent = __webpack_require__(933);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _wrapMapDispatchToProps = __webpack_require__(2223);
	
	var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);
	
	var _wrapMapStateToProps = __webpack_require__(2224);
	
	var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);
	
	var _createInitialState = __webpack_require__(929);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Creates a HOC that knows how to create redux-connected sub-components.
	 */
	var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	  var Component = React.Component;
	
	  return function (reduxMountPoint, formName, formKey, getFormState) {
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxForm = function (_Component) {
	      _inherits(ReduxForm, _Component);
	
	      function ReduxForm(props) {
	        _classCallCheck(this, ReduxForm);
	
	        // bind functions
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.asyncValidate = _this.asyncValidate.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        var _this$props = _this.props,
	            initialValues = _this$props.initialValues,
	            submitPassback = _this$props.submitPassback;
	        // Check if form state was initialized, if not, initialize it.
	
	        var form = (0, _deepEqual2.default)(props.form, _reducer.initialState) ? (0, _createInitialState2.default)(initialValues, config.fields, {}, true, false) : props.form;
	        _this.fields = (0, _readFields2.default)(_extends({}, props, { form: form }), {}, {}, _this.asyncValidate, isReactNative);
	        submitPassback(function () {
	          return _this.handleSubmit();
	        }); // wrapped in function to disallow params
	        return _this;
	      }
	
	      ReduxForm.prototype.componentWillMount = function componentWillMount() {
	        var _props = this.props,
	            fields = _props.fields,
	            form = _props.form,
	            initialize = _props.initialize,
	            initialValues = _props.initialValues;
	
	        if (initialValues && !form._initialized) {
	          initialize(initialValues, fields);
	        }
	      };
	
	      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
	          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
	        }
	        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
	          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
	        }
	      };
	
	      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (config.destroyOnUnmount) {
	          this.props.destroy();
	        }
	      };
	
	      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            alwaysAsyncValidate = _props2.alwaysAsyncValidate,
	            asyncValidate = _props2.asyncValidate,
	            dispatch = _props2.dispatch,
	            fields = _props2.fields,
	            form = _props2.form,
	            startAsyncValidation = _props2.startAsyncValidation,
	            stopAsyncValidation = _props2.stopAsyncValidation,
	            validate = _props2.validate;
	
	        var isSubmitting = !name;
	        if (asyncValidate) {
	          var values = (0, _getValues2.default)(fields, form);
	          if (name) {
	            values[name] = value;
	          }
	          var syncErrors = validate(values, this.props);
	          var allPristine = this.fields._meta.allPristine;
	
	          var initialized = form._initialized;
	
	          // if blur validating, only run async validate if sync validation passes
	          // and submitting (not blur validation) or form is dirty or form was never initialized
	          // unless alwaysAsyncValidate is true
	          var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
	          if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
	            return (0, _asyncValidation2.default)(function () {
	              return asyncValidate(values, dispatch, _this2.props);
	            }, startAsyncValidation, stopAsyncValidation, name);
	          }
	        }
	      };
	
	      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
	        var _this3 = this;
	
	        var _props3 = this.props,
	            onSubmit = _props3.onSubmit,
	            fields = _props3.fields,
	            form = _props3.form;
	
	        var check = function check(submit) {
	          if (!submit || typeof submit !== 'function') {
	            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	          }
	          return submit;
	        };
	        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
	        // submitOrEvent is an event: fire submit
	        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
	        // submitOrEvent is the submit function: return deferred submit thunk
	        (0, _silenceEvents2.default)(function () {
	          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
	        });
	      };
	
	      ReduxForm.prototype.render = function render() {
	        var _this4 = this,
	            _ref2;
	
	        var allFields = this.fields;
	
	        var _props4 = this.props,
	            addArrayValue = _props4.addArrayValue,
	            asyncBlurFields = _props4.asyncBlurFields,
	            autofill = _props4.autofill,
	            blur = _props4.blur,
	            change = _props4.change,
	            destroy = _props4.destroy,
	            focus = _props4.focus,
	            fields = _props4.fields,
	            form = _props4.form,
	            initialValues = _props4.initialValues,
	            initialize = _props4.initialize,
	            onSubmit = _props4.onSubmit,
	            propNamespace = _props4.propNamespace,
	            reset = _props4.reset,
	            removeArrayValue = _props4.removeArrayValue,
	            returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise,
	            startAsyncValidation = _props4.startAsyncValidation,
	            startSubmit = _props4.startSubmit,
	            stopAsyncValidation = _props4.stopAsyncValidation,
	            stopSubmit = _props4.stopSubmit,
	            submitFailed = _props4.submitFailed,
	            swapArrayValues = _props4.swapArrayValues,
	            touch = _props4.touch,
	            untouch = _props4.untouch,
	            validate = _props4.validate,
	            passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare
	
	
	        var _allFields$_meta = allFields._meta,
	            allPristine = _allFields$_meta.allPristine,
	            allValid = _allFields$_meta.allValid,
	            errors = _allFields$_meta.errors,
	            formError = _allFields$_meta.formError,
	            values = _allFields$_meta.values;
	
	
	        var props = {
	          // State:
	          active: form._active,
	          asyncValidating: form._asyncValidating,
	          dirty: !allPristine,
	          error: formError,
	          errors: errors,
	          fields: allFields,
	          formKey: formKey,
	          invalid: !allValid,
	          pristine: allPristine,
	          submitting: form._submitting,
	          submitFailed: form._submitFailed,
	          valid: allValid,
	          values: values,
	
	          // Actions:
	          asyncValidate: (0, _silenceEvents2.default)(function () {
	            return _this4.asyncValidate();
	          }),
	          // ^ doesn't just pass this.asyncValidate to disallow values passing
	          destroyForm: (0, _silenceEvents2.default)(destroy),
	          handleSubmit: this.handleSubmit,
	          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
	            return initialize(initValues, fields);
	          }),
	          resetForm: (0, _silenceEvents2.default)(reset),
	          touch: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, arguments);
	          }),
	          touchAll: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, fields);
	          }),
	          untouch: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, arguments);
	          }),
	          untouchAll: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, fields);
	          })
	        };
	        var passedProps = propNamespace ? (_ref2 = {}, _ref2[propNamespace] = props, _ref2) : props;
	        if (withRef) {
	          return React.createElement(WrappedComponent, _extends({}, _extends({}, passableProps, passedProps), { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
	      };
	
	      return ReduxForm;
	    }(Component);
	
	    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxForm.WrappedComponent = WrappedComponent;
	    ReduxForm.propTypes = {
	      // props:
	      alwaysAsyncValidate: _propTypes2.default.bool,
	      asyncBlurFields: _propTypes2.default.arrayOf(_propTypes2.default.string),
	      asyncValidate: _propTypes2.default.func,
	      dispatch: _propTypes2.default.func.isRequired,
	      fields: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	      form: _propTypes2.default.object,
	      initialValues: _propTypes2.default.any,
	      onSubmit: _propTypes2.default.func,
	      onSubmitSuccess: _propTypes2.default.func,
	      onSubmitFail: _propTypes2.default.func,
	      overwriteOnInitialValuesChange: _propTypes2.default.bool.isRequired,
	      propNamespace: _propTypes2.default.string,
	      readonly: _propTypes2.default.bool,
	      returnRejectedSubmitPromise: _propTypes2.default.bool,
	      submitPassback: _propTypes2.default.func.isRequired,
	      validate: _propTypes2.default.func,
	
	      // actions:
	      addArrayValue: _propTypes2.default.func.isRequired,
	      autofill: _propTypes2.default.func.isRequired,
	      blur: _propTypes2.default.func.isRequired,
	      change: _propTypes2.default.func.isRequired,
	      destroy: _propTypes2.default.func.isRequired,
	      focus: _propTypes2.default.func.isRequired,
	      initialize: _propTypes2.default.func.isRequired,
	      removeArrayValue: _propTypes2.default.func.isRequired,
	      reset: _propTypes2.default.func.isRequired,
	      startAsyncValidation: _propTypes2.default.func.isRequired,
	      startSubmit: _propTypes2.default.func.isRequired,
	      stopAsyncValidation: _propTypes2.default.func.isRequired,
	      stopSubmit: _propTypes2.default.func.isRequired,
	      submitFailed: _propTypes2.default.func.isRequired,
	      swapArrayValues: _propTypes2.default.func.isRequired,
	      touch: _propTypes2.default.func.isRequired,
	      untouch: _propTypes2.default.func.isRequired
	    };
	    ReduxForm.defaultProps = {
	      asyncBlurFields: [],
	      form: _reducer.initialState,
	      readonly: false,
	      returnRejectedSubmitPromise: false,
	      validate: function validate() {
	        return {};
	      }
	    };
	
	    // bind touch flags to blur and change
	    var unboundActions = _extends({}, importedActions, {
	      blur: (0, _bindActionData2.default)(importedActions.blur, {
	        touch: !!config.touchOnBlur
	      }),
	      change: (0, _bindActionData2.default)(importedActions.change, {
	        touch: !!config.touchOnChange
	      })
	    });
	
	    // make redux connector with or without form key
	    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName] && formState[formName][formKey];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
	      form: formName,
	      key: formKey
	    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);
	
	    return decorate(ReduxForm);
	  };
	};
	
	exports.default = createHigherOrderComponent;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createPropTypes = function createPropTypes() {
	  return {
	    // State:
	    active: _propTypes2.default.string, // currently active field
	    asyncValidating: _propTypes2.default.bool.isRequired, // true if async validation is running
	    autofilled: _propTypes2.default.bool, // true if set programmatically by autofill
	    dirty: _propTypes2.default.bool.isRequired, // true if any values are different from initialValues
	    error: _propTypes2.default.any, // form-wide error from '_error' key in validation result
	    errors: _propTypes2.default.object, // a map of errors corresponding to structure of form data (result of validation)
	    fields: _propTypes2.default.object.isRequired, // the map of fields
	    formKey: _propTypes2.default.any, // the form key if one was provided (used when doing multirecord forms)
	    invalid: _propTypes2.default.bool.isRequired, // true if there are any validation errors
	    pristine: _propTypes2.default.bool.isRequired, // true if the values are the same as initialValues
	    submitting: _propTypes2.default.bool.isRequired, // true if the form is in the process of being submitted
	    submitFailed: _propTypes2.default.bool.isRequired, // true if the form was submitted and failed for any reason
	    valid: _propTypes2.default.bool.isRequired, // true if there are no validation errors
	    values: _propTypes2.default.object.isRequired, // the values of the form as they will be submitted
	
	    // Actions:
	    asyncValidate: _propTypes2.default.func.isRequired, // function to trigger async validation
	    destroyForm: _propTypes2.default.func.isRequired, // action to destroy the form's data in Redux
	    handleSubmit: _propTypes2.default.func.isRequired, // function to submit the form
	    initializeForm: _propTypes2.default.func.isRequired, // action to initialize form data
	    resetForm: _propTypes2.default.func.isRequired, // action to reset the form data to previously initialized values
	    touch: _propTypes2.default.func.isRequired, // action to mark fields as touched
	    touchAll: _propTypes2.default.func.isRequired, // action to mark ALL fields as touched
	    untouch: _propTypes2.default.func.isRequired, // action to mark fields as untouched
	    untouchAll: _propTypes2.default.func.isRequired // action to mark ALL fields as untouched
	  };
	};
	
	exports.default = createPropTypes;

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createReduxFormConnector = __webpack_require__(2207);
	
	var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);
	
	var _hoistNonReactStatics = __webpack_require__(2225);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(731);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(isReactNative, React, connect) {
	  var Component = React.Component;
	
	  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
	  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    return function (WrappedComponent) {
	      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);
	
	      var _ref = options || {},
	          _ref$withRef = _ref.withRef,
	          withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	      var configWithDefaults = _extends({
	        overwriteOnInitialValuesChange: true,
	        touchOnBlur: true,
	        touchOnChange: false,
	        destroyOnUnmount: true
	      }, config);
	
	      var ConnectedForm = function (_Component) {
	        _inherits(ConnectedForm, _Component);
	
	        function ConnectedForm(props) {
	          _classCallCheck(this, ConnectedForm);
	
	          var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
	          return _this;
	        }
	
	        ConnectedForm.prototype.getWrappedInstance = function getWrappedInstance() {
	          (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	          return this.refs.wrappedInstance.refs.wrappedInstance.getWrappedInstance().refs.wrappedInstance;
	        };
	
	        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
	          this.submit = submit;
	        };
	
	        ConnectedForm.prototype.render = function render() {
	          if (withRef) {
	            return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	              ref: 'wrappedInstance',
	              submitPassback: this.handleSubmitPassback }));
	          }
	          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	            submitPassback: this.handleSubmitPassback }));
	        };
	
	        return ConnectedForm;
	      }(Component);
	
	      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noGetters = __webpack_require__(2053);
	
	var _noGetters2 = _interopRequireDefault(_noGetters);
	
	var _getDisplayName = __webpack_require__(934);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _createHigherOrderComponent = __webpack_require__(2204);
	
	var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
	 * but if they do, the connected components below it need to be redefined.
	 */
	var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
	  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    var Component = React.Component;
	
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxFormConnector = function (_Component) {
	      _inherits(ReduxFormConnector, _Component);
	
	      function ReduxFormConnector(props) {
	        _classCallCheck(this, ReduxFormConnector);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.cache = new _noGetters2.default(_this, {
	          ReduxForm: {
	            params: [
	            // props that effect how redux-form connects to the redux store
	            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
	            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
	          }
	        });
	        return _this;
	      }
	
	      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.cache.componentWillReceiveProps(nextProps);
	      };
	
	      ReduxFormConnector.prototype.render = function render() {
	        var ReduxForm = this.cache.get('ReduxForm');
	        // remove some redux-form config-only props
	
	        var _props = this.props,
	            reduxMountPoint = _props.reduxMountPoint,
	            destroyOnUnmount = _props.destroyOnUnmount,
	            form = _props.form,
	            getFormState = _props.getFormState,
	            touchOnBlur = _props.touchOnBlur,
	            touchOnChange = _props.touchOnChange,
	            passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare
	
	
	        if (withRef) {
	          return React.createElement(ReduxForm, _extends({}, passableProps, { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(ReduxForm, passableProps);
	      };
	
	      return ReduxFormConnector;
	    }(Component);
	
	    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxFormConnector.WrappedComponent = WrappedComponent;
	    ReduxFormConnector.propTypes = {
	      destroyOnUnmount: _propTypes2.default.bool,
	      reduxMountPoint: _propTypes2.default.string,
	      form: _propTypes2.default.string.isRequired,
	      formKey: _propTypes2.default.string,
	      getFormState: _propTypes2.default.func,
	      touchOnBlur: _propTypes2.default.bool,
	      touchOnChange: _propTypes2.default.bool
	    };
	    ReduxFormConnector.defaultProps = {
	      reduxMountPoint: 'form',
	      getFormState: function getFormState(state, reduxMountPoint) {
	        return state[reduxMountPoint];
	      }
	    };
	    return ReduxFormConnector;
	  };
	};
	
	exports.default = createReduxFormConnector;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(931);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
	  return function (event) {
	    var value = (0, _getValue2.default)(event, isReactNative);
	    blur(name, value);
	    if (afterBlur) {
	      afterBlur(name, value);
	    }
	  };
	};
	exports.default = createOnBlur;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(931);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(name, change, isReactNative) {
	  return function (event) {
	    return change(name, (0, _getValue2.default)(event, isReactNative));
	  };
	};
	exports.default = createOnChange;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createOnDragStart = __webpack_require__(930);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
	  };
	};
	exports.default = createOnDrop;

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _silenceEvent = __webpack_require__(933);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(445);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(350);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
	  var dispatch = props.dispatch,
	      fields = props.fields,
	      onSubmitSuccess = props.onSubmitSuccess,
	      onSubmitFail = props.onSubmitFail,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      submitFailed = props.submitFailed,
	      returnRejectedSubmitPromise = props.returnRejectedSubmitPromise,
	      touch = props.touch,
	      validate = props.validate;
	
	  var syncErrors = validate(values, props);
	  touch.apply(undefined, fields); // touch all fields
	  if ((0, _isValid2.default)(syncErrors)) {
	    var doSubmit = function doSubmit() {
	      var result = submit(values, dispatch, props);
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult);
	          }
	          return submitResult;
	        }, function (submitError) {
	          stopSubmit(submitError);
	          if (onSubmitFail) {
	            onSubmitFail(submitError);
	          }
	          if (returnRejectedSubmitPromise) {
	            return Promise.reject(submitError);
	          }
	        });
	      }
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result);
	      }
	      return result;
	    };
	    var asyncValidateResult = asyncValidate();
	    return (0, _isPromise2.default)(asyncValidateResult) ?
	    // asyncValidateResult will be rejected if async validation failed
	    asyncValidateResult.then(doSubmit, function () {
	      submitFailed();
	      if (onSubmitFail) {
	        onSubmitFail();
	      }
	      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
	    }) : doSubmit(); // no async validation, so submit
	  }
	  submitFailed();
	
	  if (onSubmitFail) {
	    onSubmitFail(syncErrors);
	  }
	
	  if (returnRejectedSubmitPromise) {
	    return Promise.reject(syncErrors);
	  }
	};
	
	exports.default = handleSubmit;

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isPristine;
	function isPristine(initial, data) {
	  if (initial === data) {
	    return true;
	  }
	  if (typeof initial === 'boolean' || typeof data === 'boolean') {
	    return initial === data;
	  } else if (initial instanceof Date && data instanceof Date) {
	    return initial.getTime() === data.getTime();
	  } else if (initial && typeof initial === 'object') {
	    if (!data || typeof data !== 'object') {
	      return false;
	    }
	    var initialKeys = Object.keys(initial);
	    var dataKeys = Object.keys(data);
	    if (initialKeys.length !== dataKeys.length) {
	      return false;
	    }
	    for (var index = 0; index < dataKeys.length; index++) {
	      var key = dataKeys[index];
	      if (!isPristine(initial[key], data[key])) {
	        return false;
	      }
	    }
	  } else if (initial || data) {
	    // allow '' to equate to undefined or null
	    return initial === data;
	  } else if (initial === null && data === 0 || initial === 0 && data === null) {
	    return false;
	  }
	  return true;
	}

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = normalizeFields;
	
	var _fieldValue = __webpack_require__(216);
	
	function extractKey(field) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
	  var key = void 0;
	  var nestedPath = void 0;
	
	  if (isArray) {
	    key = field.substring(0, openIndex);
	    nestedPath = field.substring(closeIndex + 1);
	
	    if (nestedPath[0] === '.') {
	      nestedPath = nestedPath.substring(1);
	    }
	  } else if (dotIndex > 0) {
	    key = field.substring(0, dotIndex);
	    nestedPath = field.substring(dotIndex + 1);
	  } else {
	    key = field;
	  }
	
	  return { isArray: isArray, key: key, nestedPath: nestedPath };
	}
	
	function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
	  if (field.isArray) {
	    if (field.nestedPath) {
	      var array = state && state[field.key] || [];
	      var previousArray = previousState && previousState[field.key] || [];
	      var nestedField = extractKey(field.nestedPath);
	
	      return array.map(function (nestedState, i) {
	        nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);
	
	        return nestedState;
	      });
	    }
	
	    var _normalizer = normalizers[fullFieldPath];
	
	    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
	    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
	  } else if (field.nestedPath) {
	    var nestedState = state && state[field.key] || {};
	    var _nestedField = extractKey(field.nestedPath);
	
	    nestedState[_nestedField.key] = normalizeField(_nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);
	
	    return nestedState;
	  }
	
	  var finalField = state && Object.assign({}, state[field.key] || {});
	  var normalizer = normalizers[fullFieldPath];
	
	  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);
	
	  return (0, _fieldValue.makeFieldValue)(finalField);
	}
	
	function normalizeFields(normalizers, state, previousState, values, previousValues) {
	  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
	    var extracted = extractKey(field);
	
	    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);
	
	    return accumulator;
	  }, {});
	
	  return _extends({}, state, newState);
	}

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(2208);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(2209);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(930);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(2210);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(2211);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	var _silencePromise = __webpack_require__(2221);
	
	var _silencePromise2 = _interopRequireDefault(_silencePromise);
	
	var _read = __webpack_require__(939);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _updateField = __webpack_require__(2222);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	var _isChecked = __webpack_require__(938);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSuffix(input, closeIndex) {
	  var suffix = input.substring(closeIndex + 1);
	  if (suffix[0] === '.') {
	    suffix = suffix.substring(1);
	  }
	  return suffix;
	}
	
	var getNextKey = function getNextKey(path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    return path.substring(0, openIndex);
	  }
	  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
	};
	
	var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
	  return (
	    // remove array indices
	    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
	  );
	};
	
	var readField = function readField(state, fieldName) {
	  var pathToHere = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var fields = arguments[3];
	  var syncErrors = arguments[4];
	  var asyncValidate = arguments[5];
	  var isReactNative = arguments[6];
	  var props = arguments[7];
	  var callback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function () {
	    return null;
	  };
	  var prefix = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	  var asyncBlurFields = props.asyncBlurFields,
	      autofill = props.autofill,
	      blur = props.blur,
	      change = props.change,
	      focus = props.focus,
	      form = props.form,
	      initialValues = props.initialValues,
	      readonly = props.readonly,
	      addArrayValue = props.addArrayValue,
	      removeArrayValue = props.removeArrayValue,
	      swapArrayValues = props.swapArrayValues;
	
	  var dotIndex = fieldName.indexOf('.');
	  var openIndex = fieldName.indexOf('[');
	  var closeIndex = fieldName.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = fieldName.substring(0, openIndex);
	    var rest = getSuffix(fieldName, closeIndex);
	    var stateArray = state && state[key] || [];
	    var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
	    var subfields = props.fields.reduce(function (accumulator, field) {
	      if (field.indexOf(fullPrefix) === 0) {
	        accumulator.push(field);
	      }
	      return accumulator;
	    }, []).map(function (field) {
	      return getSuffix(field, prefix.length + closeIndex);
	    });
	    var addMethods = function addMethods(dest) {
	      Object.defineProperty(dest, 'addField', {
	        value: function value(_value, index) {
	          return addArrayValue(pathToHere + key, _value, index, subfields);
	        }
	      });
	      Object.defineProperty(dest, 'removeField', {
	        value: function value(index) {
	          return removeArrayValue(pathToHere + key, index);
	        }
	      });
	      Object.defineProperty(dest, 'swapFields', {
	        value: function value(indexA, indexB) {
	          return swapArrayValues(pathToHere + key, indexA, indexB);
	        }
	      });
	      return dest;
	    };
	    if (!fields[key] || fields[key].length !== stateArray.length) {
	      fields[key] = fields[key] ? [].concat(fields[key]) : [];
	      addMethods(fields[key]);
	    }
	    var fieldArray = fields[key];
	    var changed = false;
	    stateArray.forEach(function (fieldState, index) {
	      if (rest && !fieldArray[index]) {
	        fieldArray[index] = {};
	        changed = true;
	      }
	      var dest = rest ? fieldArray[index] : {};
	      var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
	      var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');
	
	      var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	      if (fieldArray[index] !== result) {
	        if (rest) {
	          // if something's after [] in field name, the array item is an object field
	          // we need it to compare !== to the original (so react re-renders appropriately)
	          result = _extends({}, dest);
	        }
	        fieldArray[index] = result;
	        changed = true;
	      }
	    });
	    if (fieldArray.length > stateArray.length) {
	      // remove extra items that aren't in state array
	      fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
	    }
	    if (changed) {
	      fieldArray = addMethods([].concat(fieldArray));
	    }
	    fields[key] = fieldArray;
	    return fieldArray;
	  }
	  if (dotIndex > 0) {
	    // subobject field
	    var _key = fieldName.substring(0, dotIndex);
	    var _rest = fieldName.substring(dotIndex + 1);
	    var subobject = fields[_key] || {};
	    var nextPath = pathToHere + _key + '.';
	    var nextKey = getNextKey(_rest);
	    var nextPrefix = prefix + _key + '.';
	    var previous = subobject[nextKey];
	    var result = readField(state[_key] || {}, _rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	    if (result !== previous) {
	      var _extends2;
	
	      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
	    }
	    fields[_key] = subobject;
	    return subobject;
	  }
	  var name = pathToHere + fieldName;
	  var field = fields[fieldName] || {};
	  if (field.name !== name) {
	    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
	    var initialFormValue = (0, _read2.default)(name + '.initial', form);
	    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
	    initialValue = initialValue === undefined ? '' : initialValue;
	    field.name = name;
	    field.checked = (0, _isChecked2.default)(initialValue);
	    field.value = initialValue;
	    field.initialValue = initialValue;
	    if (!readonly) {
	      field.autofill = function (value) {
	        return autofill(name, value);
	      };
	      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
	        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
	      });
	      field.onChange = onChange;
	      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
	        return field.value;
	      });
	      field.onDrop = (0, _createOnDrop2.default)(name, change);
	      field.onFocus = (0, _createOnFocus2.default)(name, focus);
	      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
	    }
	    field.valid = true;
	    field.invalid = false;
	    Object.defineProperty(field, '_isField', { value: true });
	  }
	
	  var fieldState = (fieldName ? state[fieldName] : state) || {};
	  var syncError = (0, _read2.default)(name, syncErrors);
	  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
	  if (fieldName || fields[fieldName] !== updated) {
	    fields[fieldName] = updated;
	  }
	  callback(updated);
	  return updated;
	};
	
	exports.default = readField;

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _readField = __webpack_require__(2216);
	
	var _readField2 = _interopRequireDefault(_readField);
	
	var _write = __webpack_require__(940);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValues = __webpack_require__(935);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _removeField = __webpack_require__(2218);
	
	var _removeField2 = _interopRequireDefault(_removeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Reads props and generates (or updates) field structure
	 */
	var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
	  var fields = props.fields,
	      form = props.form,
	      validate = props.validate;
	
	  var previousFields = previousProps.fields;
	  var values = (0, _getValues2.default)(fields, form);
	  var syncErrors = validate(values, props) || {};
	  var errors = {};
	  var formError = syncErrors._error || form._error;
	  var allValid = !formError;
	  var allPristine = true;
	  var tally = function tally(field) {
	    if (field.error) {
	      errors = (0, _write2.default)(field.name, field.error, errors);
	      allValid = false;
	    }
	    if (field.dirty) {
	      allPristine = false;
	    }
	  };
	  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
	    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
	  }, _extends({}, myFields)) : _extends({}, myFields);
	  fields.forEach(function (name) {
	    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
	  });
	  Object.defineProperty(fieldObjects, '_meta', {
	    value: {
	      allPristine: allPristine,
	      allValid: allValid,
	      values: values,
	      errors: errors,
	      formError: formError
	    }
	  });
	  return fieldObjects;
	};
	exports.default = readFields;

/***/ }),
/* 2218 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var without = function without(object, key) {
	  var copy = _extends({}, object);
	  delete copy[key];
	  return copy;
	};
	
	var removeField = function removeField(fields, path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = path.substring(0, openIndex);
	    if (!Array.isArray(fields[key])) {
	      return without(fields, key);
	    }
	    var rest = path.substring(closeIndex + 1);
	    if (rest[0] === '.') {
	      rest = rest.substring(1);
	    }
	    if (rest) {
	      var _extends2;
	
	      var copy = [];
	      fields[key].forEach(function (item, index) {
	        var result = removeField(item, rest);
	        if (Object.keys(result).length) {
	          copy[index] = result;
	        }
	      });
	      return copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key);
	    }
	    return without(fields, key);
	  }
	  if (dotIndex > 0) {
	    var _extends3;
	
	    // subobject field
	    var _key = path.substring(0, dotIndex);
	    var _rest = path.substring(dotIndex + 1);
	    if (!fields[_key]) {
	      return fields;
	    }
	    var result = removeField(fields[_key], _rest);
	    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[_key] = removeField(fields[_key], _rest), _extends3)) : without(fields, _key);
	  }
	  return without(fields, path);
	};
	
	exports.default = removeField;

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(216);
	
	var reset = function reset(value) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var resetState = function resetState(values) {
	  return values ? Object.keys(values).reduce(function (accumulator, key) {
	    var value = values[key];
	    if (Array.isArray(value)) {
	      accumulator[key] = value.map(function (item) {
	        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
	      });
	    } else if (value) {
	      if ((0, _fieldValue.isFieldValue)(value)) {
	        accumulator[key] = reset(value);
	      } else if (typeof value === 'object' && value !== null) {
	        accumulator[key] = resetState(value);
	      } else {
	        accumulator[key] = value;
	      }
	    }
	    return accumulator;
	  }, {}) : values;
	};
	
	exports.default = resetState;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(216);
	
	var isMetaKey = function isMetaKey(key) {
	  return key[0] === '_';
	};
	
	/**
	 * Sets an error on a field deep in the tree, returning a new copy of the state
	 */
	var setErrors = function setErrors(state, errors, destKey) {
	  var clear = function clear() {
	    if (Array.isArray(state)) {
	      return state.map(function (stateItem, index) {
	        return setErrors(stateItem, errors && errors[index], destKey);
	      });
	    }
	    if (state && typeof state === 'object') {
	      var result = Object.keys(state).reduce(function (accumulator, key) {
	        var _extends2;
	
	        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
	      }, state);
	      if ((0, _fieldValue.isFieldValue)(state)) {
	        (0, _fieldValue.makeFieldValue)(result);
	      }
	      return result;
	    }
	    return (0, _fieldValue.makeFieldValue)(state);
	  };
	  if (typeof File !== 'undefined' && state instanceof File) {
	    return state;
	  }
	  if (!errors) {
	    if (!state) {
	      return state;
	    }
	    if (state[destKey]) {
	      var copy = _extends({}, state);
	      delete copy[destKey];
	      return (0, _fieldValue.makeFieldValue)(copy);
	    }
	    return clear();
	  }
	  if (typeof errors === 'string') {
	    var _extends3;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
	  }
	  if (Array.isArray(errors)) {
	    if (!state || Array.isArray(state)) {
	      var _copy = (state || []).map(function (stateItem, index) {
	        return setErrors(stateItem, errors[index], destKey);
	      });
	      errors.forEach(function (errorItem, index) {
	        return _copy[index] = setErrors(_copy[index], errorItem, destKey);
	      });
	      return _copy;
	    }
	    return setErrors(state, errors[0], destKey); // use first error
	  }
	  if ((0, _fieldValue.isFieldValue)(state)) {
	    var _extends4;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
	  }
	  var errorKeys = Object.keys(errors);
	  if (!errorKeys.length && !state) {
	    return state;
	  }
	  return errorKeys.reduce(function (accumulator, key) {
	    var _extends5;
	
	    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
	  }, clear() || {});
	};
	
	exports.default = setErrors;

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(445);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {
	  return undefined;
	};
	
	var silencePromise = function silencePromise(promise) {
	  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
	};
	
	exports.default = silencePromise;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPristine = __webpack_require__(2214);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(350);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isChecked = __webpack_require__(938);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Updates a field object from the store values
	 */
	var updateField = function updateField(field, formField, active, syncError) {
	  var diff = {};
	  var formFieldValue = formField.value === undefined ? '' : formField.value;
	
	  // update field value
	  if (field.value !== formFieldValue) {
	    diff.value = formFieldValue;
	    diff.checked = (0, _isChecked2.default)(formFieldValue);
	  }
	
	  // update dirty/pristine
	  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
	  if (field.pristine !== pristine) {
	    diff.dirty = !pristine;
	    diff.pristine = pristine;
	  }
	
	  // update field error
	  var error = syncError || formField.submitError || formField.asyncError;
	  if (error !== field.error) {
	    diff.error = error;
	  }
	  var valid = (0, _isValid2.default)(error);
	  if (field.valid !== valid) {
	    diff.invalid = !valid;
	    diff.valid = valid;
	  }
	
	  if (active !== field.active) {
	    diff.active = active;
	  }
	  var touched = !!formField.touched;
	  if (touched !== field.touched) {
	    diff.touched = touched;
	  }
	  var visited = !!formField.visited;
	  if (visited !== field.visited) {
	    diff.visited = visited;
	  }
	  var autofilled = !!formField.autofilled;
	  if (autofilled !== field.autofilled) {
	    diff.autofilled = autofilled;
	  }
	
	  if ('initial' in formField && formField.initial !== field.initialValue) {
	    field.initialValue = formField.initial;
	  }
	
	  return Object.keys(diff).length ? _extends({}, field, diff) : field;
	};
	exports.default = updateField;

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(351);
	
	var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
	  if (mapDispatchToProps) {
	    if (typeof mapDispatchToProps === 'function') {
	      if (mapDispatchToProps.length > 1) {
	        return function (dispatch, ownProps) {
	          return _extends({
	            dispatch: dispatch
	          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	        };
	      }
	      return function (dispatch) {
	        return _extends({
	          dispatch: dispatch
	        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	      };
	    }
	    return function (dispatch) {
	      return _extends({
	        dispatch: dispatch
	      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	    };
	  }
	  return function (dispatch) {
	    return _extends({
	      dispatch: dispatch
	    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
	  };
	};
	
	exports.default = wrapMapDispatchToProps;

/***/ }),
/* 2224 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
	  if (mapStateToProps) {
	    if (typeof mapStateToProps !== 'function') {
	      throw new Error('mapStateToProps must be a function');
	    }
	    if (mapStateToProps.length > 1) {
	      return function (state, ownProps) {
	        return _extends({}, mapStateToProps(state, ownProps), {
	          form: getForm(state)
	        });
	      };
	    }
	    return function (state) {
	      return _extends({}, mapStateToProps(state), {
	        form: getForm(state)
	      });
	    };
	  }
	  return function (state) {
	    return {
	      form: getForm(state)
	    };
	  };
	};
	
	exports.default = wrapMapStateToProps;

/***/ }),
/* 2225 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(941);
	
	var _diff = __webpack_require__(2228);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ }),
/* 2227 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(1550);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(2226);
	
	var _helpers = __webpack_require__(941);
	
	var _defaults = __webpack_require__(2227);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      transformer = loggerOptions.transformer,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = createLogger();
	
	exports.defaults = _defaults2.default;
	exports.logger = defaultLogger;
	exports.default = createLogger;
	module.exports = exports['default'];


/***/ }),
/* 2230 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(942);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(943);
	
	var _isPlainObject = __webpack_require__(120);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(944);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2235);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(142)(module)))

/***/ }),
/* 2235 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 2236 */
[2358, 243, 390, 946, 947, 2237],
/* 2237 */
[2360, 243, 947],
/* 2238 */
[2361, 246, 433, 443, 728, 195],
/* 2239 */
[2362, 433, 443, 1662, 195],
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(103)))

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(435).EventEmitter;
	var inherits = __webpack_require__(198);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(501);
	Stream.Writable = __webpack_require__(2169);
	Stream.Duplex = __webpack_require__(2164);
	Stream.Transform = __webpack_require__(2168);
	Stream.PassThrough = __webpack_require__(2167);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)(module)))

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 1.4.7 */
	
	(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.Tether = factory();
	  }
	}(this, function() {
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var TetherBase = undefined;
	if (typeof TetherBase === 'undefined') {
	  TetherBase = { modules: [] };
	}
	
	var zeroElement = null;
	
	// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
	// if the element lies within a nested document (<frame> or <iframe>-like).
	function getActualBoundingClientRect(node) {
	  var boundingRect = node.getBoundingClientRect();
	
	  // The original object returned by getBoundingClientRect is immutable, so we clone it
	  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
	  var rect = {};
	  for (var k in boundingRect) {
	    rect[k] = boundingRect[k];
	  }
	
	  try {
	    if (node.ownerDocument !== document) {
	      var _frameElement = node.ownerDocument.defaultView.frameElement;
	      if (_frameElement) {
	        var frameRect = getActualBoundingClientRect(_frameElement);
	        rect.top += frameRect.top;
	        rect.bottom += frameRect.top;
	        rect.left += frameRect.left;
	        rect.right += frameRect.left;
	      }
	    }
	  } catch (err) {
	    // Ignore "Access is denied" in IE11/Edge
	  }
	
	  return rect;
	}
	
	function getScrollParents(el) {
	  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  var computedStyle = getComputedStyle(el) || {};
	  var position = computedStyle.position;
	  var parents = [];
	
	  if (position === 'fixed') {
	    return [el];
	  }
	
	  var parent = el;
	  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
	    var style = undefined;
	    try {
	      style = getComputedStyle(parent);
	    } catch (err) {}
	
	    if (typeof style === 'undefined' || style === null) {
	      parents.push(parent);
	      return parents;
	    }
	
	    var _style = style;
	    var overflow = _style.overflow;
	    var overflowX = _style.overflowX;
	    var overflowY = _style.overflowY;
	
	    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
	        parents.push(parent);
	      }
	    }
	  }
	
	  parents.push(el.ownerDocument.body);
	
	  // If the node is within a frame, account for the parent window scroll
	  if (el.ownerDocument !== document) {
	    parents.push(el.ownerDocument.defaultView);
	  }
	
	  return parents;
	}
	
	var uniqueId = (function () {
	  var id = 0;
	  return function () {
	    return ++id;
	  };
	})();
	
	var zeroPosCache = {};
	var getOrigin = function getOrigin() {
	  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
	  // jitter as the user scrolls that messes with our ability to detect if two positions
	  // are equivilant or not.  We place an element at the top left of the page that will
	  // get the same jitter, so we can cancel the two out.
	  var node = zeroElement;
	  if (!node || !document.body.contains(node)) {
	    node = document.createElement('div');
	    node.setAttribute('data-tether-id', uniqueId());
	    extend(node.style, {
	      top: 0,
	      left: 0,
	      position: 'absolute'
	    });
	
	    document.body.appendChild(node);
	
	    zeroElement = node;
	  }
	
	  var id = node.getAttribute('data-tether-id');
	  if (typeof zeroPosCache[id] === 'undefined') {
	    zeroPosCache[id] = getActualBoundingClientRect(node);
	
	    // Clear the cache when this position call is done
	    defer(function () {
	      delete zeroPosCache[id];
	    });
	  }
	
	  return zeroPosCache[id];
	};
	
	function removeUtilElements() {
	  if (zeroElement) {
	    document.body.removeChild(zeroElement);
	  }
	  zeroElement = null;
	};
	
	function getBounds(el) {
	  var doc = undefined;
	  if (el === document) {
	    doc = document;
	    el = document.documentElement;
	  } else {
	    doc = el.ownerDocument;
	  }
	
	  var docEl = doc.documentElement;
	
	  var box = getActualBoundingClientRect(el);
	
	  var origin = getOrigin();
	
	  box.top -= origin.top;
	  box.left -= origin.left;
	
	  if (typeof box.width === 'undefined') {
	    box.width = document.body.scrollWidth - box.left - box.right;
	  }
	  if (typeof box.height === 'undefined') {
	    box.height = document.body.scrollHeight - box.top - box.bottom;
	  }
	
	  box.top = box.top - docEl.clientTop;
	  box.left = box.left - docEl.clientLeft;
	  box.right = doc.body.clientWidth - box.width - box.left;
	  box.bottom = doc.body.clientHeight - box.height - box.top;
	
	  return box;
	}
	
	function getOffsetParent(el) {
	  return el.offsetParent || document.documentElement;
	}
	
	var _scrollBarSize = null;
	function getScrollBarSize() {
	  if (_scrollBarSize) {
	    return _scrollBarSize;
	  }
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  inner.style.height = '200px';
	
	  var outer = document.createElement('div');
	  extend(outer.style, {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    pointerEvents: 'none',
	    visibility: 'hidden',
	    width: '200px',
	    height: '150px',
	    overflow: 'hidden'
	  });
	
	  outer.appendChild(inner);
	
	  document.body.appendChild(outer);
	
	  var widthContained = inner.offsetWidth;
	  outer.style.overflow = 'scroll';
	  var widthScroll = inner.offsetWidth;
	
	  if (widthContained === widthScroll) {
	    widthScroll = outer.clientWidth;
	  }
	
	  document.body.removeChild(outer);
	
	  var width = widthContained - widthScroll;
	
	  _scrollBarSize = { width: width, height: width };
	  return _scrollBarSize;
	}
	
	function extend() {
	  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var args = [];
	
	  Array.prototype.push.apply(args, arguments);
	
	  args.slice(1).forEach(function (obj) {
	    if (obj) {
	      for (var key in obj) {
	        if (({}).hasOwnProperty.call(obj, key)) {
	          out[key] = obj[key];
	        }
	      }
	    }
	  });
	
	  return out;
	}
	
	function removeClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    name.split(' ').forEach(function (cls) {
	      if (cls.trim()) {
	        el.classList.remove(cls);
	      }
	    });
	  } else {
	    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
	    var className = getClassName(el).replace(regex, ' ');
	    setClassName(el, className);
	  }
	}
	
	function addClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    name.split(' ').forEach(function (cls) {
	      if (cls.trim()) {
	        el.classList.add(cls);
	      }
	    });
	  } else {
	    removeClass(el, name);
	    var cls = getClassName(el) + (' ' + name);
	    setClassName(el, cls);
	  }
	}
	
	function hasClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    return el.classList.contains(name);
	  }
	  var className = getClassName(el);
	  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
	}
	
	function getClassName(el) {
	  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
	  // completely separately SVGAnimatedString base classes
	  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
	    return el.className.baseVal;
	  }
	  return el.className;
	}
	
	function setClassName(el, className) {
	  el.setAttribute('class', className);
	}
	
	function updateClasses(el, add, all) {
	  // Of the set of 'all' classes, we need the 'add' classes, and only the
	  // 'add' classes to be set.
	  all.forEach(function (cls) {
	    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
	      removeClass(el, cls);
	    }
	  });
	
	  add.forEach(function (cls) {
	    if (!hasClass(el, cls)) {
	      addClass(el, cls);
	    }
	  });
	}
	
	var deferred = [];
	
	var defer = function defer(fn) {
	  deferred.push(fn);
	};
	
	var flush = function flush() {
	  var fn = undefined;
	  while (fn = deferred.pop()) {
	    fn();
	  }
	};
	
	var Evented = (function () {
	  function Evented() {
	    _classCallCheck(this, Evented);
	  }
	
	  _createClass(Evented, [{
	    key: 'on',
	    value: function on(event, handler, ctx) {
	      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	      if (typeof this.bindings === 'undefined') {
	        this.bindings = {};
	      }
	      if (typeof this.bindings[event] === 'undefined') {
	        this.bindings[event] = [];
	      }
	      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
	    }
	  }, {
	    key: 'once',
	    value: function once(event, handler, ctx) {
	      this.on(event, handler, ctx, true);
	    }
	  }, {
	    key: 'off',
	    value: function off(event, handler) {
	      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
	        return;
	      }
	
	      if (typeof handler === 'undefined') {
	        delete this.bindings[event];
	      } else {
	        var i = 0;
	        while (i < this.bindings[event].length) {
	          if (this.bindings[event][i].handler === handler) {
	            this.bindings[event].splice(i, 1);
	          } else {
	            ++i;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(event) {
	      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
	        var i = 0;
	
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        while (i < this.bindings[event].length) {
	          var _bindings$event$i = this.bindings[event][i];
	          var handler = _bindings$event$i.handler;
	          var ctx = _bindings$event$i.ctx;
	          var once = _bindings$event$i.once;
	
	          var context = ctx;
	          if (typeof context === 'undefined') {
	            context = this;
	          }
	
	          handler.apply(context, args);
	
	          if (once) {
	            this.bindings[event].splice(i, 1);
	          } else {
	            ++i;
	          }
	        }
	      }
	    }
	  }]);
	
	  return Evented;
	})();
	
	TetherBase.Utils = {
	  getActualBoundingClientRect: getActualBoundingClientRect,
	  getScrollParents: getScrollParents,
	  getBounds: getBounds,
	  getOffsetParent: getOffsetParent,
	  extend: extend,
	  addClass: addClass,
	  removeClass: removeClass,
	  hasClass: hasClass,
	  updateClasses: updateClasses,
	  defer: defer,
	  flush: flush,
	  uniqueId: uniqueId,
	  Evented: Evented,
	  getScrollBarSize: getScrollBarSize,
	  removeUtilElements: removeUtilElements
	};
	/* globals TetherBase, performance */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (typeof TetherBase === 'undefined') {
	  throw new Error('You must include the utils.js file before tether.js');
	}
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getScrollParents = _TetherBase$Utils.getScrollParents;
	var getBounds = _TetherBase$Utils.getBounds;
	var getOffsetParent = _TetherBase$Utils.getOffsetParent;
	var extend = _TetherBase$Utils.extend;
	var addClass = _TetherBase$Utils.addClass;
	var removeClass = _TetherBase$Utils.removeClass;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	var flush = _TetherBase$Utils.flush;
	var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
	var removeUtilElements = _TetherBase$Utils.removeUtilElements;
	
	function within(a, b) {
	  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
	
	  return a + diff >= b && b >= a - diff;
	}
	
	var transformKey = (function () {
	  if (typeof document === 'undefined') {
	    return '';
	  }
	  var el = document.createElement('div');
	
	  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
	  for (var i = 0; i < transforms.length; ++i) {
	    var key = transforms[i];
	    if (el.style[key] !== undefined) {
	      return key;
	    }
	  }
	})();
	
	var tethers = [];
	
	var position = function position() {
	  tethers.forEach(function (tether) {
	    tether.position(false);
	  });
	  flush();
	};
	
	function now() {
	  if (typeof performance === 'object' && typeof performance.now === 'function') {
	    return performance.now();
	  }
	  return +new Date();
	}
	
	(function () {
	  var lastCall = null;
	  var lastDuration = null;
	  var pendingTimeout = null;
	
	  var tick = function tick() {
	    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
	      // We voluntarily throttle ourselves if we can't manage 60fps
	      lastDuration = Math.min(lastDuration - 16, 250);
	
	      // Just in case this is the last event, remember to position just once more
	      pendingTimeout = setTimeout(tick, 250);
	      return;
	    }
	
	    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
	      // Some browsers call events a little too frequently, refuse to run more than is reasonable
	      return;
	    }
	
	    if (pendingTimeout != null) {
	      clearTimeout(pendingTimeout);
	      pendingTimeout = null;
	    }
	
	    lastCall = now();
	    position();
	    lastDuration = now() - lastCall;
	  };
	
	  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
	    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
	      window.addEventListener(event, tick);
	    });
	  }
	})();
	
	var MIRROR_LR = {
	  center: 'center',
	  left: 'right',
	  right: 'left'
	};
	
	var MIRROR_TB = {
	  middle: 'middle',
	  top: 'bottom',
	  bottom: 'top'
	};
	
	var OFFSET_MAP = {
	  top: 0,
	  left: 0,
	  middle: '50%',
	  center: '50%',
	  bottom: '100%',
	  right: '100%'
	};
	
	var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
	  var left = attachment.left;
	  var top = attachment.top;
	
	  if (left === 'auto') {
	    left = MIRROR_LR[relativeToAttachment.left];
	  }
	
	  if (top === 'auto') {
	    top = MIRROR_TB[relativeToAttachment.top];
	  }
	
	  return { left: left, top: top };
	};
	
	var attachmentToOffset = function attachmentToOffset(attachment) {
	  var left = attachment.left;
	  var top = attachment.top;
	
	  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
	    left = OFFSET_MAP[attachment.left];
	  }
	
	  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
	    top = OFFSET_MAP[attachment.top];
	  }
	
	  return { left: left, top: top };
	};
	
	function addOffset() {
	  var out = { top: 0, left: 0 };
	
	  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
	    offsets[_key] = arguments[_key];
	  }
	
	  offsets.forEach(function (_ref) {
	    var top = _ref.top;
	    var left = _ref.left;
	
	    if (typeof top === 'string') {
	      top = parseFloat(top, 10);
	    }
	    if (typeof left === 'string') {
	      left = parseFloat(left, 10);
	    }
	
	    out.top += top;
	    out.left += left;
	  });
	
	  return out;
	}
	
	function offsetToPx(offset, size) {
	  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
	    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
	  }
	  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
	    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
	  }
	
	  return offset;
	}
	
	var parseOffset = function parseOffset(value) {
	  var _value$split = value.split(' ');
	
	  var _value$split2 = _slicedToArray(_value$split, 2);
	
	  var top = _value$split2[0];
	  var left = _value$split2[1];
	
	  return { top: top, left: left };
	};
	var parseAttachment = parseOffset;
	
	var TetherClass = (function (_Evented) {
	  _inherits(TetherClass, _Evented);
	
	  function TetherClass(options) {
	    var _this = this;
	
	    _classCallCheck(this, TetherClass);
	
	    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
	    this.position = this.position.bind(this);
	
	    tethers.push(this);
	
	    this.history = [];
	
	    this.setOptions(options, false);
	
	    TetherBase.modules.forEach(function (module) {
	      if (typeof module.initialize !== 'undefined') {
	        module.initialize.call(_this);
	      }
	    });
	
	    this.position();
	  }
	
	  _createClass(TetherClass, [{
	    key: 'getClass',
	    value: function getClass() {
	      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	      var classes = this.options.classes;
	
	      if (typeof classes !== 'undefined' && classes[key]) {
	        return this.options.classes[key];
	      } else if (this.options.classPrefix) {
	        return this.options.classPrefix + '-' + key;
	      } else {
	        return key;
	      }
	    }
	  }, {
	    key: 'setOptions',
	    value: function setOptions(options) {
	      var _this2 = this;
	
	      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      var defaults = {
	        offset: '0 0',
	        targetOffset: '0 0',
	        targetAttachment: 'auto auto',
	        classPrefix: 'tether'
	      };
	
	      this.options = extend(defaults, options);
	
	      var _options = this.options;
	      var element = _options.element;
	      var target = _options.target;
	      var targetModifier = _options.targetModifier;
	
	      this.element = element;
	      this.target = target;
	      this.targetModifier = targetModifier;
	
	      if (this.target === 'viewport') {
	        this.target = document.body;
	        this.targetModifier = 'visible';
	      } else if (this.target === 'scroll-handle') {
	        this.target = document.body;
	        this.targetModifier = 'scroll-handle';
	      }
	
	      ['element', 'target'].forEach(function (key) {
	        if (typeof _this2[key] === 'undefined') {
	          throw new Error('Tether Error: Both element and target must be defined');
	        }
	
	        if (typeof _this2[key].jquery !== 'undefined') {
	          _this2[key] = _this2[key][0];
	        } else if (typeof _this2[key] === 'string') {
	          _this2[key] = document.querySelector(_this2[key]);
	        }
	      });
	
	      addClass(this.element, this.getClass('element'));
	      if (!(this.options.addTargetClasses === false)) {
	        addClass(this.target, this.getClass('target'));
	      }
	
	      if (!this.options.attachment) {
	        throw new Error('Tether Error: You must provide an attachment');
	      }
	
	      this.targetAttachment = parseAttachment(this.options.targetAttachment);
	      this.attachment = parseAttachment(this.options.attachment);
	      this.offset = parseOffset(this.options.offset);
	      this.targetOffset = parseOffset(this.options.targetOffset);
	
	      if (typeof this.scrollParents !== 'undefined') {
	        this.disable();
	      }
	
	      if (this.targetModifier === 'scroll-handle') {
	        this.scrollParents = [this.target];
	      } else {
	        this.scrollParents = getScrollParents(this.target);
	      }
	
	      if (!(this.options.enabled === false)) {
	        this.enable(pos);
	      }
	    }
	  }, {
	    key: 'getTargetBounds',
	    value: function getTargetBounds() {
	      if (typeof this.targetModifier !== 'undefined') {
	        if (this.targetModifier === 'visible') {
	          if (this.target === document.body) {
	            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
	          } else {
	            var bounds = getBounds(this.target);
	
	            var out = {
	              height: bounds.height,
	              width: bounds.width,
	              top: bounds.top,
	              left: bounds.left
	            };
	
	            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
	            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
	            out.height = Math.min(innerHeight, out.height);
	            out.height -= 2;
	
	            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
	            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
	            out.width = Math.min(innerWidth, out.width);
	            out.width -= 2;
	
	            if (out.top < pageYOffset) {
	              out.top = pageYOffset;
	            }
	            if (out.left < pageXOffset) {
	              out.left = pageXOffset;
	            }
	
	            return out;
	          }
	        } else if (this.targetModifier === 'scroll-handle') {
	          var bounds = undefined;
	          var target = this.target;
	          if (target === document.body) {
	            target = document.documentElement;
	
	            bounds = {
	              left: pageXOffset,
	              top: pageYOffset,
	              height: innerHeight,
	              width: innerWidth
	            };
	          } else {
	            bounds = getBounds(target);
	          }
	
	          var style = getComputedStyle(target);
	
	          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;
	
	          var scrollBottom = 0;
	          if (hasBottomScroll) {
	            scrollBottom = 15;
	          }
	
	          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;
	
	          var out = {
	            width: 15,
	            height: height * 0.975 * (height / target.scrollHeight),
	            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
	          };
	
	          var fitAdj = 0;
	          if (height < 408 && this.target === document.body) {
	            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
	          }
	
	          if (this.target !== document.body) {
	            out.height = Math.max(out.height, 24);
	          }
	
	          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
	          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);
	
	          if (this.target === document.body) {
	            out.height = Math.max(out.height, 24);
	          }
	
	          return out;
	        }
	      } else {
	        return getBounds(this.target);
	      }
	    }
	  }, {
	    key: 'clearCache',
	    value: function clearCache() {
	      this._cache = {};
	    }
	  }, {
	    key: 'cache',
	    value: function cache(k, getter) {
	      // More than one module will often need the same DOM info, so
	      // we keep a cache which is cleared on each position call
	      if (typeof this._cache === 'undefined') {
	        this._cache = {};
	      }
	
	      if (typeof this._cache[k] === 'undefined') {
	        this._cache[k] = getter.call(this);
	      }
	
	      return this._cache[k];
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var _this3 = this;
	
	      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      if (!(this.options.addTargetClasses === false)) {
	        addClass(this.target, this.getClass('enabled'));
	      }
	      addClass(this.element, this.getClass('enabled'));
	      this.enabled = true;
	
	      this.scrollParents.forEach(function (parent) {
	        if (parent !== _this3.target.ownerDocument) {
	          parent.addEventListener('scroll', _this3.position);
	        }
	      });
	
	      if (pos) {
	        this.position();
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      var _this4 = this;
	
	      removeClass(this.target, this.getClass('enabled'));
	      removeClass(this.element, this.getClass('enabled'));
	      this.enabled = false;
	
	      if (typeof this.scrollParents !== 'undefined') {
	        this.scrollParents.forEach(function (parent) {
	          parent.removeEventListener('scroll', _this4.position);
	        });
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _this5 = this;
	
	      this.disable();
	
	      tethers.forEach(function (tether, i) {
	        if (tether === _this5) {
	          tethers.splice(i, 1);
	        }
	      });
	
	      // Remove any elements we were using for convenience from the DOM
	      if (tethers.length === 0) {
	        removeUtilElements();
	      }
	    }
	  }, {
	    key: 'updateAttachClasses',
	    value: function updateAttachClasses(elementAttach, targetAttach) {
	      var _this6 = this;
	
	      elementAttach = elementAttach || this.attachment;
	      targetAttach = targetAttach || this.targetAttachment;
	      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];
	
	      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
	        // updateAttachClasses can be called more than once in a position call, so
	        // we need to clean up after ourselves such that when the last defer gets
	        // ran it doesn't add any extra classes from previous calls.
	        this._addAttachClasses.splice(0, this._addAttachClasses.length);
	      }
	
	      if (typeof this._addAttachClasses === 'undefined') {
	        this._addAttachClasses = [];
	      }
	      var add = this._addAttachClasses;
	
	      if (elementAttach.top) {
	        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
	      }
	      if (elementAttach.left) {
	        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
	      }
	      if (targetAttach.top) {
	        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
	      }
	      if (targetAttach.left) {
	        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
	      }
	
	      var all = [];
	      sides.forEach(function (side) {
	        all.push(_this6.getClass('element-attached') + '-' + side);
	        all.push(_this6.getClass('target-attached') + '-' + side);
	      });
	
	      defer(function () {
	        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
	          return;
	        }
	
	        updateClasses(_this6.element, _this6._addAttachClasses, all);
	        if (!(_this6.options.addTargetClasses === false)) {
	          updateClasses(_this6.target, _this6._addAttachClasses, all);
	        }
	
	        delete _this6._addAttachClasses;
	      });
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      var _this7 = this;
	
	      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
	      // tethers (in which case call Tether.Utils.flush yourself when you're done)
	
	      if (!this.enabled) {
	        return;
	      }
	
	      this.clearCache();
	
	      // Turn 'auto' attachments into the appropriate corner or edge
	      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);
	
	      this.updateAttachClasses(this.attachment, targetAttachment);
	
	      var elementPos = this.cache('element-bounds', function () {
	        return getBounds(_this7.element);
	      });
	
	      var width = elementPos.width;
	      var height = elementPos.height;
	
	      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
	        var _lastSize = this.lastSize;
	
	        // We cache the height and width to make it possible to position elements that are
	        // getting hidden.
	        width = _lastSize.width;
	        height = _lastSize.height;
	      } else {
	        this.lastSize = { width: width, height: height };
	      }
	
	      var targetPos = this.cache('target-bounds', function () {
	        return _this7.getTargetBounds();
	      });
	      var targetSize = targetPos;
	
	      // Get an actual px offset from the attachment
	      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
	      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);
	
	      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
	      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);
	
	      // Add the manually provided offset
	      offset = addOffset(offset, manualOffset);
	      targetOffset = addOffset(targetOffset, manualTargetOffset);
	
	      // It's now our goal to make (element position + offset) == (target position + target offset)
	      var left = targetPos.left + targetOffset.left - offset.left;
	      var top = targetPos.top + targetOffset.top - offset.top;
	
	      for (var i = 0; i < TetherBase.modules.length; ++i) {
	        var _module2 = TetherBase.modules[i];
	        var ret = _module2.position.call(this, {
	          left: left,
	          top: top,
	          targetAttachment: targetAttachment,
	          targetPos: targetPos,
	          elementPos: elementPos,
	          offset: offset,
	          targetOffset: targetOffset,
	          manualOffset: manualOffset,
	          manualTargetOffset: manualTargetOffset,
	          scrollbarSize: scrollbarSize,
	          attachment: this.attachment
	        });
	
	        if (ret === false) {
	          return false;
	        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
	          continue;
	        } else {
	          top = ret.top;
	          left = ret.left;
	        }
	      }
	
	      // We describe the position three different ways to give the optimizer
	      // a chance to decide the best possible way to position the element
	      // with the fewest repaints.
	      var next = {
	        // It's position relative to the page (absolute positioning when
	        // the element is a child of the body)
	        page: {
	          top: top,
	          left: left
	        },
	
	        // It's position relative to the viewport (fixed positioning)
	        viewport: {
	          top: top - pageYOffset,
	          bottom: pageYOffset - top - height + innerHeight,
	          left: left - pageXOffset,
	          right: pageXOffset - left - width + innerWidth
	        }
	      };
	
	      var doc = this.target.ownerDocument;
	      var win = doc.defaultView;
	
	      var scrollbarSize = undefined;
	      if (win.innerHeight > doc.documentElement.clientHeight) {
	        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	        next.viewport.bottom -= scrollbarSize.height;
	      }
	
	      if (win.innerWidth > doc.documentElement.clientWidth) {
	        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	        next.viewport.right -= scrollbarSize.width;
	      }
	
	      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
	        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
	        next.page.bottom = doc.body.scrollHeight - top - height;
	        next.page.right = doc.body.scrollWidth - left - width;
	      }
	
	      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
	        (function () {
	          var offsetParent = _this7.cache('target-offsetparent', function () {
	            return getOffsetParent(_this7.target);
	          });
	          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
	            return getBounds(offsetParent);
	          });
	          var offsetParentStyle = getComputedStyle(offsetParent);
	          var offsetParentSize = offsetPosition;
	
	          var offsetBorder = {};
	          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
	          });
	
	          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
	          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;
	
	          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
	            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
	              // We're within the visible part of the target's scroll parent
	              var scrollTop = offsetParent.scrollTop;
	              var scrollLeft = offsetParent.scrollLeft;
	
	              // It's position relative to the target's offset parent (absolute positioning when
	              // the element is moved to be a child of the target's offset parent).
	              next.offset = {
	                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
	                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
	              };
	            }
	          }
	        })();
	      }
	
	      // We could also travel up the DOM and try each containing context, rather than only
	      // looking at the body, but we're gonna get diminishing returns.
	
	      this.move(next);
	
	      this.history.unshift(next);
	
	      if (this.history.length > 3) {
	        this.history.pop();
	      }
	
	      if (flushChanges) {
	        flush();
	      }
	
	      return true;
	    }
	
	    // THE ISSUE
	  }, {
	    key: 'move',
	    value: function move(pos) {
	      var _this8 = this;
	
	      if (!(typeof this.element.parentNode !== 'undefined')) {
	        return;
	      }
	
	      var same = {};
	
	      for (var type in pos) {
	        same[type] = {};
	
	        for (var key in pos[type]) {
	          var found = false;
	
	          for (var i = 0; i < this.history.length; ++i) {
	            var point = this.history[i];
	            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
	              found = true;
	              break;
	            }
	          }
	
	          if (!found) {
	            same[type][key] = true;
	          }
	        }
	      }
	
	      var css = { top: '', left: '', right: '', bottom: '' };
	
	      var transcribe = function transcribe(_same, _pos) {
	        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
	        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
	        if (gpu !== false) {
	          var yPos = undefined,
	              xPos = undefined;
	          if (_same.top) {
	            css.top = 0;
	            yPos = _pos.top;
	          } else {
	            css.bottom = 0;
	            yPos = -_pos.bottom;
	          }
	
	          if (_same.left) {
	            css.left = 0;
	            xPos = _pos.left;
	          } else {
	            css.right = 0;
	            xPos = -_pos.right;
	          }
	
	          if (typeof window.devicePixelRatio === 'number' && devicePixelRatio % 1 === 0) {
	            xPos = Math.round(xPos * devicePixelRatio) / devicePixelRatio;
	            yPos = Math.round(yPos * devicePixelRatio) / devicePixelRatio;
	          }
	
	          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';
	
	          if (transformKey !== 'msTransform') {
	            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
	            // but IE9 doesn't support 3d transforms and will choke.
	            css[transformKey] += " translateZ(0)";
	          }
	        } else {
	          if (_same.top) {
	            css.top = _pos.top + 'px';
	          } else {
	            css.bottom = _pos.bottom + 'px';
	          }
	
	          if (_same.left) {
	            css.left = _pos.left + 'px';
	          } else {
	            css.right = _pos.right + 'px';
	          }
	        }
	      };
	
	      var moved = false;
	      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
	        css.position = 'absolute';
	        transcribe(same.page, pos.page);
	      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
	        css.position = 'fixed';
	        transcribe(same.viewport, pos.viewport);
	      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
	        (function () {
	          css.position = 'absolute';
	          var offsetParent = _this8.cache('target-offsetparent', function () {
	            return getOffsetParent(_this8.target);
	          });
	
	          if (getOffsetParent(_this8.element) !== offsetParent) {
	            defer(function () {
	              _this8.element.parentNode.removeChild(_this8.element);
	              offsetParent.appendChild(_this8.element);
	            });
	          }
	
	          transcribe(same.offset, pos.offset);
	          moved = true;
	        })();
	      } else {
	        css.position = 'absolute';
	        transcribe({ top: true, left: true }, pos.page);
	      }
	
	      if (!moved) {
	        if (this.options.bodyElement) {
	          if (this.element.parentNode !== this.options.bodyElement) {
	            this.options.bodyElement.appendChild(this.element);
	          }
	        } else {
	          var isFullscreenElement = function isFullscreenElement(e) {
	            var d = e.ownerDocument;
	            var fe = d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement;
	            return fe === e;
	          };
	
	          var offsetParentIsBody = true;
	
	          var currentNode = this.element.parentNode;
	          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY' && !isFullscreenElement(currentNode)) {
	            if (getComputedStyle(currentNode).position !== 'static') {
	              offsetParentIsBody = false;
	              break;
	            }
	
	            currentNode = currentNode.parentNode;
	          }
	
	          if (!offsetParentIsBody) {
	            this.element.parentNode.removeChild(this.element);
	            this.element.ownerDocument.body.appendChild(this.element);
	          }
	        }
	      }
	
	      // Any css change will trigger a repaint, so let's avoid one if nothing changed
	      var writeCSS = {};
	      var write = false;
	      for (var key in css) {
	        var val = css[key];
	        var elVal = this.element.style[key];
	
	        if (elVal !== val) {
	          write = true;
	          writeCSS[key] = val;
	        }
	      }
	
	      if (write) {
	        defer(function () {
	          extend(_this8.element.style, writeCSS);
	          _this8.trigger('repositioned');
	        });
	      }
	    }
	  }]);
	
	  return TetherClass;
	})(Evented);
	
	TetherClass.modules = [];
	
	TetherBase.position = position;
	
	var Tether = extend(TetherClass, TetherBase);
	/* globals TetherBase */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getBounds = _TetherBase$Utils.getBounds;
	var extend = _TetherBase$Utils.extend;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	
	var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];
	
	function getBoundingRect(tether, to) {
	  if (to === 'scrollParent') {
	    to = tether.scrollParents[0];
	  } else if (to === 'window') {
	    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
	  }
	
	  if (to === document) {
	    to = to.documentElement;
	  }
	
	  if (typeof to.nodeType !== 'undefined') {
	    (function () {
	      var node = to;
	      var size = getBounds(to);
	      var pos = size;
	      var style = getComputedStyle(to);
	
	      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];
	
	      // Account any parent Frames scroll offset
	      if (node.ownerDocument !== document) {
	        var win = node.ownerDocument.defaultView;
	        to[0] += win.pageXOffset;
	        to[1] += win.pageYOffset;
	        to[2] += win.pageXOffset;
	        to[3] += win.pageYOffset;
	      }
	
	      BOUNDS_FORMAT.forEach(function (side, i) {
	        side = side[0].toUpperCase() + side.substr(1);
	        if (side === 'Top' || side === 'Left') {
	          to[i] += parseFloat(style['border' + side + 'Width']);
	        } else {
	          to[i] -= parseFloat(style['border' + side + 'Width']);
	        }
	      });
	    })();
	  }
	
	  return to;
	}
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var _this = this;
	
	    var top = _ref.top;
	    var left = _ref.left;
	    var targetAttachment = _ref.targetAttachment;
	
	    if (!this.options.constraints) {
	      return true;
	    }
	
	    var _cache = this.cache('element-bounds', function () {
	      return getBounds(_this.element);
	    });
	
	    var height = _cache.height;
	    var width = _cache.width;
	
	    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
	      var _lastSize = this.lastSize;
	
	      // Handle the item getting hidden as a result of our positioning without glitching
	      // the classes in and out
	      width = _lastSize.width;
	      height = _lastSize.height;
	    }
	
	    var targetSize = this.cache('target-bounds', function () {
	      return _this.getTargetBounds();
	    });
	
	    var targetHeight = targetSize.height;
	    var targetWidth = targetSize.width;
	
	    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];
	
	    this.options.constraints.forEach(function (constraint) {
	      var outOfBoundsClass = constraint.outOfBoundsClass;
	      var pinnedClass = constraint.pinnedClass;
	
	      if (outOfBoundsClass) {
	        allClasses.push(outOfBoundsClass);
	      }
	      if (pinnedClass) {
	        allClasses.push(pinnedClass);
	      }
	    });
	
	    allClasses.forEach(function (cls) {
	      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
	        allClasses.push(cls + '-' + side);
	      });
	    });
	
	    var addClasses = [];
	
	    var tAttachment = extend({}, targetAttachment);
	    var eAttachment = extend({}, this.attachment);
	
	    this.options.constraints.forEach(function (constraint) {
	      var to = constraint.to;
	      var attachment = constraint.attachment;
	      var pin = constraint.pin;
	
	      if (typeof attachment === 'undefined') {
	        attachment = '';
	      }
	
	      var changeAttachX = undefined,
	          changeAttachY = undefined;
	      if (attachment.indexOf(' ') >= 0) {
	        var _attachment$split = attachment.split(' ');
	
	        var _attachment$split2 = _slicedToArray(_attachment$split, 2);
	
	        changeAttachY = _attachment$split2[0];
	        changeAttachX = _attachment$split2[1];
	      } else {
	        changeAttachX = changeAttachY = attachment;
	      }
	
	      var bounds = getBoundingRect(_this, to);
	
	      if (changeAttachY === 'target' || changeAttachY === 'both') {
	        if (top < bounds[1] && tAttachment.top === 'top') {
	          top += targetHeight;
	          tAttachment.top = 'bottom';
	        }
	
	        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
	          top -= targetHeight;
	          tAttachment.top = 'top';
	        }
	      }
	
	      if (changeAttachY === 'together') {
	        if (tAttachment.top === 'top') {
	          if (eAttachment.top === 'bottom' && top < bounds[1]) {
	            top += targetHeight;
	            tAttachment.top = 'bottom';
	
	            top += height;
	            eAttachment.top = 'top';
	          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
	            top -= height - targetHeight;
	            tAttachment.top = 'bottom';
	
	            eAttachment.top = 'bottom';
	          }
	        }
	
	        if (tAttachment.top === 'bottom') {
	          if (eAttachment.top === 'top' && top + height > bounds[3]) {
	            top -= targetHeight;
	            tAttachment.top = 'top';
	
	            top -= height;
	            eAttachment.top = 'bottom';
	          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
	            top += height - targetHeight;
	            tAttachment.top = 'top';
	
	            eAttachment.top = 'top';
	          }
	        }
	
	        if (tAttachment.top === 'middle') {
	          if (top + height > bounds[3] && eAttachment.top === 'top') {
	            top -= height;
	            eAttachment.top = 'bottom';
	          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
	            top += height;
	            eAttachment.top = 'top';
	          }
	        }
	      }
	
	      if (changeAttachX === 'target' || changeAttachX === 'both') {
	        if (left < bounds[0] && tAttachment.left === 'left') {
	          left += targetWidth;
	          tAttachment.left = 'right';
	        }
	
	        if (left + width > bounds[2] && tAttachment.left === 'right') {
	          left -= targetWidth;
	          tAttachment.left = 'left';
	        }
	      }
	
	      if (changeAttachX === 'together') {
	        if (left < bounds[0] && tAttachment.left === 'left') {
	          if (eAttachment.left === 'right') {
	            left += targetWidth;
	            tAttachment.left = 'right';
	
	            left += width;
	            eAttachment.left = 'left';
	          } else if (eAttachment.left === 'left') {
	            left += targetWidth;
	            tAttachment.left = 'right';
	
	            left -= width;
	            eAttachment.left = 'right';
	          }
	        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
	          if (eAttachment.left === 'left') {
	            left -= targetWidth;
	            tAttachment.left = 'left';
	
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (eAttachment.left === 'right') {
	            left -= targetWidth;
	            tAttachment.left = 'left';
	
	            left += width;
	            eAttachment.left = 'left';
	          }
	        } else if (tAttachment.left === 'center') {
	          if (left + width > bounds[2] && eAttachment.left === 'left') {
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (left < bounds[0] && eAttachment.left === 'right') {
	            left += width;
	            eAttachment.left = 'left';
	          }
	        }
	      }
	
	      if (changeAttachY === 'element' || changeAttachY === 'both') {
	        if (top < bounds[1] && eAttachment.top === 'bottom') {
	          top += height;
	          eAttachment.top = 'top';
	        }
	
	        if (top + height > bounds[3] && eAttachment.top === 'top') {
	          top -= height;
	          eAttachment.top = 'bottom';
	        }
	      }
	
	      if (changeAttachX === 'element' || changeAttachX === 'both') {
	        if (left < bounds[0]) {
	          if (eAttachment.left === 'right') {
	            left += width;
	            eAttachment.left = 'left';
	          } else if (eAttachment.left === 'center') {
	            left += width / 2;
	            eAttachment.left = 'left';
	          }
	        }
	
	        if (left + width > bounds[2]) {
	          if (eAttachment.left === 'left') {
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (eAttachment.left === 'center') {
	            left -= width / 2;
	            eAttachment.left = 'right';
	          }
	        }
	      }
	
	      if (typeof pin === 'string') {
	        pin = pin.split(',').map(function (p) {
	          return p.trim();
	        });
	      } else if (pin === true) {
	        pin = ['top', 'left', 'right', 'bottom'];
	      }
	
	      pin = pin || [];
	
	      var pinned = [];
	      var oob = [];
	
	      if (top < bounds[1]) {
	        if (pin.indexOf('top') >= 0) {
	          top = bounds[1];
	          pinned.push('top');
	        } else {
	          oob.push('top');
	        }
	      }
	
	      if (top + height > bounds[3]) {
	        if (pin.indexOf('bottom') >= 0) {
	          top = bounds[3] - height;
	          pinned.push('bottom');
	        } else {
	          oob.push('bottom');
	        }
	      }
	
	      if (left < bounds[0]) {
	        if (pin.indexOf('left') >= 0) {
	          left = bounds[0];
	          pinned.push('left');
	        } else {
	          oob.push('left');
	        }
	      }
	
	      if (left + width > bounds[2]) {
	        if (pin.indexOf('right') >= 0) {
	          left = bounds[2] - width;
	          pinned.push('right');
	        } else {
	          oob.push('right');
	        }
	      }
	
	      if (pinned.length) {
	        (function () {
	          var pinnedClass = undefined;
	          if (typeof _this.options.pinnedClass !== 'undefined') {
	            pinnedClass = _this.options.pinnedClass;
	          } else {
	            pinnedClass = _this.getClass('pinned');
	          }
	
	          addClasses.push(pinnedClass);
	          pinned.forEach(function (side) {
	            addClasses.push(pinnedClass + '-' + side);
	          });
	        })();
	      }
	
	      if (oob.length) {
	        (function () {
	          var oobClass = undefined;
	          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
	            oobClass = _this.options.outOfBoundsClass;
	          } else {
	            oobClass = _this.getClass('out-of-bounds');
	          }
	
	          addClasses.push(oobClass);
	          oob.forEach(function (side) {
	            addClasses.push(oobClass + '-' + side);
	          });
	        })();
	      }
	
	      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
	        eAttachment.left = tAttachment.left = false;
	      }
	      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
	        eAttachment.top = tAttachment.top = false;
	      }
	
	      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
	        _this.updateAttachClasses(eAttachment, tAttachment);
	        _this.trigger('update', {
	          attachment: eAttachment,
	          targetAttachment: tAttachment
	        });
	      }
	    });
	
	    defer(function () {
	      if (!(_this.options.addTargetClasses === false)) {
	        updateClasses(_this.target, addClasses, allClasses);
	      }
	      updateClasses(_this.element, addClasses, allClasses);
	    });
	
	    return { top: top, left: left };
	  }
	});
	/* globals TetherBase */
	
	'use strict';
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getBounds = _TetherBase$Utils.getBounds;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var _this = this;
	
	    var top = _ref.top;
	    var left = _ref.left;
	
	    var _cache = this.cache('element-bounds', function () {
	      return getBounds(_this.element);
	    });
	
	    var height = _cache.height;
	    var width = _cache.width;
	
	    var targetPos = this.getTargetBounds();
	
	    var bottom = top + height;
	    var right = left + width;
	
	    var abutted = [];
	    if (top <= targetPos.bottom && bottom >= targetPos.top) {
	      ['left', 'right'].forEach(function (side) {
	        var targetPosSide = targetPos[side];
	        if (targetPosSide === left || targetPosSide === right) {
	          abutted.push(side);
	        }
	      });
	    }
	
	    if (left <= targetPos.right && right >= targetPos.left) {
	      ['top', 'bottom'].forEach(function (side) {
	        var targetPosSide = targetPos[side];
	        if (targetPosSide === top || targetPosSide === bottom) {
	          abutted.push(side);
	        }
	      });
	    }
	
	    var allClasses = [];
	    var addClasses = [];
	
	    var sides = ['left', 'top', 'right', 'bottom'];
	    allClasses.push(this.getClass('abutted'));
	    sides.forEach(function (side) {
	      allClasses.push(_this.getClass('abutted') + '-' + side);
	    });
	
	    if (abutted.length) {
	      addClasses.push(this.getClass('abutted'));
	    }
	
	    abutted.forEach(function (side) {
	      addClasses.push(_this.getClass('abutted') + '-' + side);
	    });
	
	    defer(function () {
	      if (!(_this.options.addTargetClasses === false)) {
	        updateClasses(_this.target, addClasses, allClasses);
	      }
	      updateClasses(_this.element, addClasses, allClasses);
	    });
	
	    return true;
	  }
	});
	/* globals TetherBase */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var top = _ref.top;
	    var left = _ref.left;
	
	    if (!this.options.shift) {
	      return;
	    }
	
	    var shift = this.options.shift;
	    if (typeof this.options.shift === 'function') {
	      shift = this.options.shift.call(this, { top: top, left: left });
	    }
	
	    var shiftTop = undefined,
	        shiftLeft = undefined;
	    if (typeof shift === 'string') {
	      shift = shift.split(' ');
	      shift[1] = shift[1] || shift[0];
	
	      var _shift = shift;
	
	      var _shift2 = _slicedToArray(_shift, 2);
	
	      shiftTop = _shift2[0];
	      shiftLeft = _shift2[1];
	
	      shiftTop = parseFloat(shiftTop, 10);
	      shiftLeft = parseFloat(shiftLeft, 10);
	    } else {
	      shiftTop = shift.top;
	      shiftLeft = shift.left;
	    }
	
	    top += shiftTop;
	    left += shiftLeft;
	
	    return { top: top, left: left };
	  }
	});
	return Tether;
	
	}));


/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	// This file is autogenerated. It's used to publish CJS to npm.
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
	})(this, (function () { 'use strict';
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	      return typeof obj;
	    } : function (obj) {
	      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    }, _typeof(obj);
	  }
	
	  // https://github.com/bgrins/TinyColor
	  // Brian Grinstead, MIT License
	
	  var trimLeft = /^\s+/;
	  var trimRight = /\s+$/;
	  function tinycolor(color, opts) {
	    color = color ? color : "";
	    opts = opts || {};
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	      return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	      return new tinycolor(color, opts);
	    }
	    var rgb = inputToRGB(color);
	    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) this._r = Math.round(this._r);
	    if (this._g < 1) this._g = Math.round(this._g);
	    if (this._b < 1) this._b = Math.round(this._b);
	    this._ok = rgb.ok;
	  }
	  tinycolor.prototype = {
	    isDark: function isDark() {
	      return this.getBrightness() < 128;
	    },
	    isLight: function isLight() {
	      return !this.isDark();
	    },
	    isValid: function isValid() {
	      return this._ok;
	    },
	    getOriginalInput: function getOriginalInput() {
	      return this._originalInput;
	    },
	    getFormat: function getFormat() {
	      return this._format;
	    },
	    getAlpha: function getAlpha() {
	      return this._a;
	    },
	    getBrightness: function getBrightness() {
	      //http://www.w3.org/TR/AERT#color-contrast
	      var rgb = this.toRgb();
	      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function getLuminance() {
	      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	      var rgb = this.toRgb();
	      var RsRGB, GsRGB, BsRGB, R, G, B;
	      RsRGB = rgb.r / 255;
	      GsRGB = rgb.g / 255;
	      BsRGB = rgb.b / 255;
	      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
	      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
	      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
	      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
	    },
	    setAlpha: function setAlpha(value) {
	      this._a = boundAlpha(value);
	      this._roundA = Math.round(100 * this._a) / 100;
	      return this;
	    },
	    toHsv: function toHsv() {
	      var hsv = rgbToHsv(this._r, this._g, this._b);
	      return {
	        h: hsv.h * 360,
	        s: hsv.s,
	        v: hsv.v,
	        a: this._a
	      };
	    },
	    toHsvString: function toHsvString() {
	      var hsv = rgbToHsv(this._r, this._g, this._b);
	      var h = Math.round(hsv.h * 360),
	        s = Math.round(hsv.s * 100),
	        v = Math.round(hsv.v * 100);
	      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
	    },
	    toHsl: function toHsl() {
	      var hsl = rgbToHsl(this._r, this._g, this._b);
	      return {
	        h: hsl.h * 360,
	        s: hsl.s,
	        l: hsl.l,
	        a: this._a
	      };
	    },
	    toHslString: function toHslString() {
	      var hsl = rgbToHsl(this._r, this._g, this._b);
	      var h = Math.round(hsl.h * 360),
	        s = Math.round(hsl.s * 100),
	        l = Math.round(hsl.l * 100);
	      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
	    },
	    toHex: function toHex(allow3Char) {
	      return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function toHexString(allow3Char) {
	      return "#" + this.toHex(allow3Char);
	    },
	    toHex8: function toHex8(allow4Char) {
	      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function toHex8String(allow4Char) {
	      return "#" + this.toHex8(allow4Char);
	    },
	    toRgb: function toRgb() {
	      return {
	        r: Math.round(this._r),
	        g: Math.round(this._g),
	        b: Math.round(this._b),
	        a: this._a
	      };
	    },
	    toRgbString: function toRgbString() {
	      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function toPercentageRgb() {
	      return {
	        r: Math.round(bound01(this._r, 255) * 100) + "%",
	        g: Math.round(bound01(this._g, 255) * 100) + "%",
	        b: Math.round(bound01(this._b, 255) * 100) + "%",
	        a: this._a
	      };
	    },
	    toPercentageRgbString: function toPercentageRgbString() {
	      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function toName() {
	      if (this._a === 0) {
	        return "transparent";
	      }
	      if (this._a < 1) {
	        return false;
	      }
	      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function toFilter(secondColor) {
	      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	      var secondHex8String = hex8String;
	      var gradientType = this._gradientType ? "GradientType = 1, " : "";
	      if (secondColor) {
	        var s = tinycolor(secondColor);
	        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	      }
	      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
	    },
	    toString: function toString(format) {
	      var formatSet = !!format;
	      format = format || this._format;
	      var formattedString = false;
	      var hasAlpha = this._a < 1 && this._a >= 0;
	      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	      if (needsAlphaFormat) {
	        // Special case for "transparent", all other non-alpha formats
	        // will return rgba when there is transparency.
	        if (format === "name" && this._a === 0) {
	          return this.toName();
	        }
	        return this.toRgbString();
	      }
	      if (format === "rgb") {
	        formattedString = this.toRgbString();
	      }
	      if (format === "prgb") {
	        formattedString = this.toPercentageRgbString();
	      }
	      if (format === "hex" || format === "hex6") {
	        formattedString = this.toHexString();
	      }
	      if (format === "hex3") {
	        formattedString = this.toHexString(true);
	      }
	      if (format === "hex4") {
	        formattedString = this.toHex8String(true);
	      }
	      if (format === "hex8") {
	        formattedString = this.toHex8String();
	      }
	      if (format === "name") {
	        formattedString = this.toName();
	      }
	      if (format === "hsl") {
	        formattedString = this.toHslString();
	      }
	      if (format === "hsv") {
	        formattedString = this.toHsvString();
	      }
	      return formattedString || this.toHexString();
	    },
	    clone: function clone() {
	      return tinycolor(this.toString());
	    },
	    _applyModification: function _applyModification(fn, args) {
	      var color = fn.apply(null, [this].concat([].slice.call(args)));
	      this._r = color._r;
	      this._g = color._g;
	      this._b = color._b;
	      this.setAlpha(color._a);
	      return this;
	    },
	    lighten: function lighten() {
	      return this._applyModification(_lighten, arguments);
	    },
	    brighten: function brighten() {
	      return this._applyModification(_brighten, arguments);
	    },
	    darken: function darken() {
	      return this._applyModification(_darken, arguments);
	    },
	    desaturate: function desaturate() {
	      return this._applyModification(_desaturate, arguments);
	    },
	    saturate: function saturate() {
	      return this._applyModification(_saturate, arguments);
	    },
	    greyscale: function greyscale() {
	      return this._applyModification(_greyscale, arguments);
	    },
	    spin: function spin() {
	      return this._applyModification(_spin, arguments);
	    },
	    _applyCombination: function _applyCombination(fn, args) {
	      return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function analogous() {
	      return this._applyCombination(_analogous, arguments);
	    },
	    complement: function complement() {
	      return this._applyCombination(_complement, arguments);
	    },
	    monochromatic: function monochromatic() {
	      return this._applyCombination(_monochromatic, arguments);
	    },
	    splitcomplement: function splitcomplement() {
	      return this._applyCombination(_splitcomplement, arguments);
	    },
	    // Disabled until https://github.com/bgrins/TinyColor/issues/254
	    // polyad: function (number) {
	    //   return this._applyCombination(polyad, [number]);
	    // },
	    triad: function triad() {
	      return this._applyCombination(polyad, [3]);
	    },
	    tetrad: function tetrad() {
	      return this._applyCombination(polyad, [4]);
	    }
	  };
	
	  // If input is an object, force 1 into "1.0" to handle ratios properly
	  // String input requires "1.0" as input, so 1 will be treated as 1
	  tinycolor.fromRatio = function (color, opts) {
	    if (_typeof(color) == "object") {
	      var newColor = {};
	      for (var i in color) {
	        if (color.hasOwnProperty(i)) {
	          if (i === "a") {
	            newColor[i] = color[i];
	          } else {
	            newColor[i] = convertToPercentage(color[i]);
	          }
	        }
	      }
	      color = newColor;
	    }
	    return tinycolor(color, opts);
	  };
	
	  // Given a string or object, convert that input to RGB
	  // Possible string inputs:
	  //
	  //     "red"
	  //     "#f00" or "f00"
	  //     "#ff0000" or "ff0000"
	  //     "#ff000000" or "ff000000"
	  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
	  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	  //
	  function inputToRGB(color) {
	    var rgb = {
	      r: 0,
	      g: 0,
	      b: 0
	    };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	    if (typeof color == "string") {
	      color = stringInputToObject(color);
	    }
	    if (_typeof(color) == "object") {
	      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	        rgb = rgbToRgb(color.r, color.g, color.b);
	        ok = true;
	        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	        s = convertToPercentage(color.s);
	        v = convertToPercentage(color.v);
	        rgb = hsvToRgb(color.h, s, v);
	        ok = true;
	        format = "hsv";
	      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	        s = convertToPercentage(color.s);
	        l = convertToPercentage(color.l);
	        rgb = hslToRgb(color.h, s, l);
	        ok = true;
	        format = "hsl";
	      }
	      if (color.hasOwnProperty("a")) {
	        a = color.a;
	      }
	    }
	    a = boundAlpha(a);
	    return {
	      ok: ok,
	      format: color.format || format,
	      r: Math.min(255, Math.max(rgb.r, 0)),
	      g: Math.min(255, Math.max(rgb.g, 0)),
	      b: Math.min(255, Math.max(rgb.b, 0)),
	      a: a
	    };
	  }
	
	  // Conversion Functions
	  // --------------------
	
	  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	  // `rgbToRgb`
	  // Handle bounds / percentage checking to conform to CSS color spec
	  // <http://www.w3.org/TR/css3-color/>
	  // *Assumes:* r, g, b in [0, 255] or [0, 1]
	  // *Returns:* { r, g, b } in [0, 255]
	  function rgbToRgb(r, g, b) {
	    return {
	      r: bound01(r, 255) * 255,
	      g: bound01(g, 255) * 255,
	      b: bound01(b, 255) * 255
	    };
	  }
	
	  // `rgbToHsl`
	  // Converts an RGB color value to HSL.
	  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	  // *Returns:* { h, s, l } in [0,1]
	  function rgbToHsl(r, g, b) {
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	    var max = Math.max(r, g, b),
	      min = Math.min(r, g, b);
	    var h,
	      s,
	      l = (max + min) / 2;
	    if (max == min) {
	      h = s = 0; // achromatic
	    } else {
	      var d = max - min;
	      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	      switch (max) {
	        case r:
	          h = (g - b) / d + (g < b ? 6 : 0);
	          break;
	        case g:
	          h = (b - r) / d + 2;
	          break;
	        case b:
	          h = (r - g) / d + 4;
	          break;
	      }
	      h /= 6;
	    }
	    return {
	      h: h,
	      s: s,
	      l: l
	    };
	  }
	
	  // `hslToRgb`
	  // Converts an HSL color value to RGB.
	  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	  // *Returns:* { r, g, b } in the set [0, 255]
	  function hslToRgb(h, s, l) {
	    var r, g, b;
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	    function hue2rgb(p, q, t) {
	      if (t < 0) t += 1;
	      if (t > 1) t -= 1;
	      if (t < 1 / 6) return p + (q - p) * 6 * t;
	      if (t < 1 / 2) return q;
	      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	      return p;
	    }
	    if (s === 0) {
	      r = g = b = l; // achromatic
	    } else {
	      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	      var p = 2 * l - q;
	      r = hue2rgb(p, q, h + 1 / 3);
	      g = hue2rgb(p, q, h);
	      b = hue2rgb(p, q, h - 1 / 3);
	    }
	    return {
	      r: r * 255,
	      g: g * 255,
	      b: b * 255
	    };
	  }
	
	  // `rgbToHsv`
	  // Converts an RGB color value to HSV
	  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	  // *Returns:* { h, s, v } in [0,1]
	  function rgbToHsv(r, g, b) {
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	    var max = Math.max(r, g, b),
	      min = Math.min(r, g, b);
	    var h,
	      s,
	      v = max;
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	    if (max == min) {
	      h = 0; // achromatic
	    } else {
	      switch (max) {
	        case r:
	          h = (g - b) / d + (g < b ? 6 : 0);
	          break;
	        case g:
	          h = (b - r) / d + 2;
	          break;
	        case b:
	          h = (r - g) / d + 4;
	          break;
	      }
	      h /= 6;
	    }
	    return {
	      h: h,
	      s: s,
	      v: v
	    };
	  }
	
	  // `hsvToRgb`
	  // Converts an HSV color value to RGB.
	  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	  // *Returns:* { r, g, b } in the set [0, 255]
	  function hsvToRgb(h, s, v) {
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	    var i = Math.floor(h),
	      f = h - i,
	      p = v * (1 - s),
	      q = v * (1 - f * s),
	      t = v * (1 - (1 - f) * s),
	      mod = i % 6,
	      r = [v, q, p, p, t, v][mod],
	      g = [t, v, v, q, p, p][mod],
	      b = [p, p, t, v, v, q][mod];
	    return {
	      r: r * 255,
	      g: g * 255,
	      b: b * 255
	    };
	  }
	
	  // `rgbToHex`
	  // Converts an RGB color to hex
	  // Assumes r, g, and b are contained in the set [0, 255]
	  // Returns a 3 or 6 character hex
	  function rgbToHex(r, g, b, allow3Char) {
	    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	    return hex.join("");
	  }
	
	  // `rgbaToHex`
	  // Converts an RGBA color plus alpha transparency to hex
	  // Assumes r, g, b are contained in the set [0, 255] and
	  // a in [0, 1]. Returns a 4 or 8 character rgba hex
	  function rgbaToHex(r, g, b, a, allow4Char) {
	    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	    return hex.join("");
	  }
	
	  // `rgbaToArgbHex`
	  // Converts an RGBA color to an ARGB Hex8 string
	  // Rarely used, but required for "toFilter()"
	  function rgbaToArgbHex(r, g, b, a) {
	    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
	    return hex.join("");
	  }
	
	  // `equals`
	  // Can be called with any tinycolor input
	  tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) return false;
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	  };
	  tinycolor.random = function () {
	    return tinycolor.fromRatio({
	      r: Math.random(),
	      g: Math.random(),
	      b: Math.random()
	    });
	  };
	
	  // Modification Functions
	  // ----------------------
	  // Thanks to less.js for some of the basics here
	  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	  function _desaturate(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	  }
	  function _saturate(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	  }
	  function _greyscale(color) {
	    return tinycolor(color).desaturate(100);
	  }
	  function _lighten(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	  }
	  function _brighten(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
	    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
	    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
	    return tinycolor(rgb);
	  }
	  function _darken(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	  }
	
	  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	  // Values outside of this range will be wrapped into this range.
	  function _spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	  }
	
	  // Combination Functions
	  // ---------------------
	  // Thanks to jQuery xColor for some of the ideas behind these
	  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	  function _complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	  }
	  function polyad(color, number) {
	    if (isNaN(number) || number <= 0) {
	      throw new Error("Argument to polyad must be a positive number");
	    }
	    var hsl = tinycolor(color).toHsl();
	    var result = [tinycolor(color)];
	    var step = 360 / number;
	    for (var i = 1; i < number; i++) {
	      result.push(tinycolor({
	        h: (hsl.h + i * step) % 360,
	        s: hsl.s,
	        l: hsl.l
	      }));
	    }
	    return result;
	  }
	  function _splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [tinycolor(color), tinycolor({
	      h: (h + 72) % 360,
	      s: hsl.s,
	      l: hsl.l
	    }), tinycolor({
	      h: (h + 216) % 360,
	      s: hsl.s,
	      l: hsl.l
	    })];
	  }
	  function _analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
	      hsl.h = (hsl.h + part) % 360;
	      ret.push(tinycolor(hsl));
	    }
	    return ret;
	  }
	  function _monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h,
	      s = hsv.s,
	      v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	    while (results--) {
	      ret.push(tinycolor({
	        h: h,
	        s: s,
	        v: v
	      }));
	      v = (v + modification) % 1;
	    }
	    return ret;
	  }
	
	  // Utility Functions
	  // ---------------------
	
	  tinycolor.mix = function (color1, color2, amount) {
	    amount = amount === 0 ? 0 : amount || 50;
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	    var p = amount / 100;
	    var rgba = {
	      r: (rgb2.r - rgb1.r) * p + rgb1.r,
	      g: (rgb2.g - rgb1.g) * p + rgb1.g,
	      b: (rgb2.b - rgb1.b) * p + rgb1.b,
	      a: (rgb2.a - rgb1.a) * p + rgb1.a
	    };
	    return tinycolor(rgba);
	  };
	
	  // Readability Functions
	  // ---------------------
	  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	  // `contrast`
	  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	  tinycolor.readability = function (color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
	  };
	
	  // `isReadable`
	  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
	  // The third argument is an optional Object.
	  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	  // *Example*
	  //    tinycolor.isReadable("#000", "#111") => false
	  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	  tinycolor.isReadable = function (color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	    out = false;
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	      case "AAsmall":
	      case "AAAlarge":
	        out = readability >= 4.5;
	        break;
	      case "AAlarge":
	        out = readability >= 3;
	        break;
	      case "AAAsmall":
	        out = readability >= 7;
	        break;
	    }
	    return out;
	  };
	
	  // `mostReadable`
	  // Given a base color and a list of possible foreground or background
	  // colors for that base, returns the most readable color.
	  // Optionally returns Black or White if the most readable color is unreadable.
	  // *Example*
	  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	  tinycolor.mostReadable = function (baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors;
	    level = args.level;
	    size = args.size;
	    for (var i = 0; i < colorList.length; i++) {
	      readability = tinycolor.readability(baseColor, colorList[i]);
	      if (readability > bestScore) {
	        bestScore = readability;
	        bestColor = tinycolor(colorList[i]);
	      }
	    }
	    if (tinycolor.isReadable(baseColor, bestColor, {
	      level: level,
	      size: size
	    }) || !includeFallbackColors) {
	      return bestColor;
	    } else {
	      args.includeFallbackColors = false;
	      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
	    }
	  };
	
	  // Big List of Colors
	  // ------------------
	  // <https://www.w3.org/TR/css-color-4/#named-colors>
	  var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	  };
	
	  // Make it easy to access colors via `hexNames[hex]`
	  var hexNames = tinycolor.hexNames = flip(names);
	
	  // Utilities
	  // ---------
	
	  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	  function flip(o) {
	    var flipped = {};
	    for (var i in o) {
	      if (o.hasOwnProperty(i)) {
	        flipped[o[i]] = i;
	      }
	    }
	    return flipped;
	  }
	
	  // Return a valid alpha value [0,1] with all invalid values being set to 1
	  function boundAlpha(a) {
	    a = parseFloat(a);
	    if (isNaN(a) || a < 0 || a > 1) {
	      a = 1;
	    }
	    return a;
	  }
	
	  // Take input from [0, n] and return it as [0, 1]
	  function bound01(n, max) {
	    if (isOnePointZero(n)) n = "100%";
	    var processPercent = isPercentage(n);
	    n = Math.min(max, Math.max(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	      n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if (Math.abs(n - max) < 0.000001) {
	      return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return n % max / parseFloat(max);
	  }
	
	  // Force a number between 0 and 1
	  function clamp01(val) {
	    return Math.min(1, Math.max(0, val));
	  }
	
	  // Parse a base-16 hex value into a base-10 integer
	  function parseIntFromHex(val) {
	    return parseInt(val, 16);
	  }
	
	  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	  function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
	  }
	
	  // Check to see if string passed in is a percentage
	  function isPercentage(n) {
	    return typeof n === "string" && n.indexOf("%") != -1;
	  }
	
	  // Force a hex value to have 2 characters
	  function pad2(c) {
	    return c.length == 1 ? "0" + c : "" + c;
	  }
	
	  // Replace a decimal with it's percentage value
	  function convertToPercentage(n) {
	    if (n <= 1) {
	      n = n * 100 + "%";
	    }
	    return n;
	  }
	
	  // Converts a decimal to a hex value
	  function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	  }
	  // Converts a hex value to a decimal
	  function convertHexToDecimal(h) {
	    return parseIntFromHex(h) / 255;
	  }
	  var matchers = function () {
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    return {
	      CSS_UNIT: new RegExp(CSS_UNIT),
	      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	  }();
	
	  // `isValidCSSUnit`
	  // Take in a single string / number and check to see if it looks like a CSS unit
	  // (see `matchers` above for definition).
	  function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	  }
	
	  // `stringInputToObject`
	  // Permissive string parsing.  Take in a number of formats, and output an object
	  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	  function stringInputToObject(color) {
	    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
	    var named = false;
	    if (names[color]) {
	      color = names[color];
	      named = true;
	    } else if (color == "transparent") {
	      return {
	        r: 0,
	        g: 0,
	        b: 0,
	        a: 0,
	        format: "name"
	      };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if (match = matchers.rgb.exec(color)) {
	      return {
	        r: match[1],
	        g: match[2],
	        b: match[3]
	      };
	    }
	    if (match = matchers.rgba.exec(color)) {
	      return {
	        r: match[1],
	        g: match[2],
	        b: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hsl.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        l: match[3]
	      };
	    }
	    if (match = matchers.hsla.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        l: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hsv.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        v: match[3]
	      };
	    }
	    if (match = matchers.hsva.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        v: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hex8.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1]),
	        g: parseIntFromHex(match[2]),
	        b: parseIntFromHex(match[3]),
	        a: convertHexToDecimal(match[4]),
	        format: named ? "name" : "hex8"
	      };
	    }
	    if (match = matchers.hex6.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1]),
	        g: parseIntFromHex(match[2]),
	        b: parseIntFromHex(match[3]),
	        format: named ? "name" : "hex"
	      };
	    }
	    if (match = matchers.hex4.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1] + "" + match[1]),
	        g: parseIntFromHex(match[2] + "" + match[2]),
	        b: parseIntFromHex(match[3] + "" + match[3]),
	        a: convertHexToDecimal(match[4] + "" + match[4]),
	        format: named ? "name" : "hex8"
	      };
	    }
	    if (match = matchers.hex3.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1] + "" + match[1]),
	        g: parseIntFromHex(match[2] + "" + match[2]),
	        b: parseIntFromHex(match[3] + "" + match[3]),
	        format: named ? "name" : "hex"
	      };
	    }
	    return false;
	  }
	  function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {
	      level: "AA",
	      size: "small"
	    };
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	      level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	      size = "small";
	    }
	    return {
	      level: level,
	      size: size
	    };
	  }
	
	  return tinycolor;
	
	}));


/***/ }),
/* 2246 */
/***/ (function(module, exports) {

	tinymce.IconManager.add('default', {
	  icons: {
	    'accessibility-check': '<svg width="24" height="24"><path d="M12 2a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2c0-1.1.9-2 2-2zm8 7h-5v12c0 .6-.4 1-1 1a1 1 0 01-1-1v-5c0-.6-.4-1-1-1a1 1 0 00-1 1v5c0 .6-.4 1-1 1a1 1 0 01-1-1V9H4a1 1 0 110-2h16c.6 0 1 .4 1 1s-.4 1-1 1z" fill-rule="nonzero"/></svg>',
	    'action-next': '<svg width="24" height="24"><path fill-rule="nonzero" d="M5.7 7.3a1 1 0 00-1.4 1.4l7.7 7.7 7.7-7.7a1 1 0 10-1.4-1.4L12 13.6 5.7 7.3z"/></svg>',
	    'action-prev': '<svg width="24" height="24"><path fill-rule="nonzero" d="M18.3 15.7a1 1 0 001.4-1.4L12 6.6l-7.7 7.7a1 1 0 001.4 1.4L12 9.4l6.3 6.3z"/></svg>',
	    'align-center': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm3 4h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 110-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm-3-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'align-justify': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'align-left': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'align-none': '<svg width="24" height="24"><path d="M14.2 5L13 7H5a1 1 0 110-2h9.2zm4 0h.8a1 1 0 010 2h-2l1.2-2zm-6.4 4l-1.2 2H5a1 1 0 010-2h6.8zm4 0H19a1 1 0 010 2h-4.4l1.2-2zm-6.4 4l-1.2 2H5a1 1 0 010-2h4.4zm4 0H19a1 1 0 010 2h-6.8l1.2-2zM7 17l-1.2 2H5a1 1 0 010-2h2zm4 0h8a1 1 0 010 2H9.8l1.2-2zm5.2-13.5l1.3.7-9.7 16.3-1.3-.7 9.7-16.3z" fill-rule="evenodd"/></svg>',
	    'align-right': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm6 4h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm-6-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'arrow-left': '<svg width="24" height="24"><path d="M5.6 13l12 6a1 1 0 001.4-1V6a1 1 0 00-1.4-.9l-12 6a1 1 0 000 1.8z" fill-rule="evenodd"/></svg>',
	    'arrow-right': '<svg width="24" height="24"><path d="M18.5 13l-12 6A1 1 0 015 18V6a1 1 0 011.4-.9l12 6a1 1 0 010 1.8z" fill-rule="evenodd"/></svg>',
	    'bold': '<svg width="24" height="24"><path d="M7.8 19c-.3 0-.5 0-.6-.2l-.2-.5V5.7c0-.2 0-.4.2-.5l.6-.2h5c1.5 0 2.7.3 3.5 1 .7.6 1.1 1.4 1.1 2.5a3 3 0 01-.6 1.9c-.4.6-1 1-1.6 1.2.4.1.9.3 1.3.6s.8.7 1 1.2c.4.4.5 1 .5 1.6 0 1.3-.4 2.3-1.3 3-.8.7-2.1 1-3.8 1H7.8zm5-8.3c.6 0 1.2-.1 1.6-.5.4-.3.6-.7.6-1.3 0-1.1-.8-1.7-2.3-1.7H9.3v3.5h3.4zm.5 6c.7 0 1.3-.1 1.7-.4.4-.4.6-.9.6-1.5s-.2-1-.7-1.4c-.4-.3-1-.4-2-.4H9.4v3.8h4z" fill-rule="evenodd"/></svg>',
	    'bookmark': '<svg width="24" height="24"><path d="M6 4v17l6-4 6 4V4c0-.6-.4-1-1-1H7a1 1 0 00-1 1z" fill-rule="nonzero"/></svg>',
	    'border-style': '<svg width="24" height="24"><g fill-rule="evenodd"><rect width="18" height="2" x="3" y="6" rx="1"/><rect width="2.8" height="2" x="3" y="16" rx="1"/><rect width="2.8" height="2" x="6.8" y="16" rx="1"/><rect width="2.8" height="2" x="10.6" y="16" rx="1"/><rect width="2.8" height="2" x="14.4" y="16" rx="1"/><rect width="2.8" height="2" x="18.2" y="16" rx="1"/><rect width="8" height="2" x="3" y="11" rx="1"/><rect width="8" height="2" x="13" y="11" rx="1"/></g></svg>',
	    'border-width': '<svg width="24" height="24"><g fill-rule="evenodd"><rect width="18" height="5" x="3" y="5" rx="1"/><rect width="18" height="3.5" x="3" y="11.5" rx="1"/><rect width="18" height="2" x="3" y="17" rx="1"/></g></svg>',
	    'brightness': '<svg width="24" height="24"><path d="M12 17c.3 0 .5.1.7.3.2.2.3.4.3.7v1c0 .3-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.7-.3 1 1 0 01-.3-.7v-1c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3zm0-10a1 1 0 01-.7-.3A1 1 0 0111 6V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7v1c0 .3-.1.5-.3.7a1 1 0 01-.7.3zm7 4c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 01-.7.3h-1a1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h1zM7 12c0 .3-.1.5-.3.7a1 1 0 01-.7.3H5a1 1 0 01-.7-.3A1 1 0 014 12c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h1c.3 0 .5.1.7.3.2.2.3.4.3.7zm10 3.5l.7.8c.2.1.3.4.3.6 0 .3-.1.6-.3.8a1 1 0 01-.8.3 1 1 0 01-.6-.3l-.8-.7a1 1 0 01-.3-.8c0-.2.1-.5.3-.7a1 1 0 011.4 0zm-10-7l-.7-.8a1 1 0 01-.3-.6c0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.2 0 .5.1.7.3l.7.7c.2.2.3.5.3.8 0 .2-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.8-.3zm10 0a1 1 0 01-.8.3 1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.6.3-.8l.8-.7c.1-.2.4-.3.6-.3.3 0 .6.1.8.3.2.2.3.5.3.8 0 .2-.1.5-.3.7l-.7.7zm-10 7c.2-.2.5-.3.8-.3.2 0 .5.1.7.3a1 1 0 010 1.4l-.8.8a1 1 0 01-.6.3 1 1 0 01-.8-.3 1 1 0 01-.3-.8c0-.2.1-.5.3-.6l.7-.8zM12 8a4 4 0 013.7 2.4 4 4 0 010 3.2A4 4 0 0112 16a4 4 0 01-3.7-2.4 4 4 0 010-3.2A4 4 0 0112 8zm0 6.5c.7 0 1.3-.2 1.8-.7.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.7-1.8-.7s-1.3.2-1.8.7c-.5.5-.7 1.1-.7 1.8s.2 1.3.7 1.8c.5.5 1.1.7 1.8.7z" fill-rule="evenodd"/></svg>',
	    'browse': '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2h-4v-2h4V8H5v10h4v2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 9.4l-2.3 2.3a1 1 0 11-1.4-1.4l4-4a1 1 0 011.4 0l4 4a1 1 0 01-1.4 1.4L13 13.4V20a1 1 0 01-2 0v-6.6z" fill-rule="nonzero"/></svg>',
	    'cancel': '<svg width="24" height="24"><path d="M12 4.6a7.4 7.4 0 110 14.8 7.4 7.4 0 010-14.8zM12 3a9 9 0 100 18 9 9 0 000-18zm0 8L14.8 8l1 1.1-2.7 2.8 2.7 2.7-1.1 1.1-2.7-2.7-2.7 2.7-1-1.1 2.6-2.7-2.7-2.7 1-1.1 2.8 2.7z" fill-rule="nonzero"/></svg>',
	    'cell-background-color': '<svg width="24" height="24"><path d="M15.7 2l1.6 1.6-2.7 2.6 5.9 5.8c.7.7.7 1.7 0 2.4l-6.3 6.1a1.7 1.7 0 01-2.4 0l-6.3-6.1c-.7-.7-.7-1.7 0-2.4L15.7 2zM18 12l-4.5-4L9 12h9zM4 16s2 2.4 2 3.8C6 21 5.1 22 4 22s-2-1-2-2.2C2 18.4 4 16 4 16z"/></svg>',
	    'cell-border-color': '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M5 13v5h2v2H5a2 2 0 01-2-2v-5h2zm8-7V4h6a2 2 0 012 2h-8z" opacity=".2"/><path fill-rule="nonzero" d="M13 4v2H5v7H3V6c0-1.1.9-2 2-2h8zm-2.6 14.1l.1-.1.1.1.2.3.2.2.2.2c.4.6.8 1.2.8 1.7 0 .8-.7 1.5-1.5 1.5S9 21.3 9 20.5c0-.5.4-1.1.8-1.7l.2-.2.2-.2.2-.3z"/><path d="M13 11l-2 2H5v-2h6V6h2z"/><path fill-rule="nonzero" d="M18.4 8l1 1-1.8 1.9 4 4c.5.4.5 1.1 0 1.6l-4.3 4.2a1.2 1.2 0 01-1.6 0l-4.4-4.2c-.4-.5-.4-1.2 0-1.7l7-6.8zm1.6 7l-3-3-3 3h6z"/></g></svg>',
	    'change-case': '<svg width="24" height="24"><path d="M18.4 18.2v-.6c-.5.8-1.3 1.2-2.4 1.2-2.2 0-3.3-1.6-3.3-4.8 0-3.1 1-4.7 3.3-4.7 1.1 0 1.8.3 2.4 1.1v-.6c0-.5.4-.8.8-.8s.8.3.8.8v8.4c0 .5-.4.8-.8.8a.8.8 0 01-.8-.8zm-2-7.4c-1.3 0-1.8.9-1.8 3.2 0 2.4.5 3.3 1.7 3.3 1.3 0 1.8-.9 1.8-3.2 0-2.4-.5-3.3-1.7-3.3zM10 15.7H5.5l-.8 2.6a1 1 0 01-1 .7h-.2a.7.7 0 01-.7-1l4-12a1 1 0 012 0l4 12a.7.7 0 01-.8 1h-.2a1 1 0 01-1-.7l-.8-2.6zm-.3-1.5l-2-6.5-1.9 6.5h3.9z" fill-rule="evenodd"/></svg>',
	    'character-count': '<svg width="24" height="24"><path d="M4 11.5h16v1H4v-1zm4.8-6.8V10H7.7V5.8h-1v-1h2zM11 8.3V9h2v1h-3V7.7l2-1v-.9h-2v-1h3v2.4l-2 1zm6.3-3.4V10h-3.1V9h2.1V8h-2.1V6.8h2.1v-1h-2.1v-1h3.1zM5.8 16.4c0-.5.2-.8.5-1 .2-.2.6-.3 1.2-.3l.8.1c.2 0 .4.2.5.3l.4.4v2.8l.2.3H8.2v-.1-.2l-.6.3H7c-.4 0-.7 0-1-.2a1 1 0 01-.3-.9c0-.3 0-.6.3-.8.3-.2.7-.4 1.2-.4l.6-.2h.3v-.2l-.1-.2a.8.8 0 00-.5-.1 1 1 0 00-.4 0l-.3.4h-1zm2.3.8h-.2l-.2.1-.4.1a1 1 0 00-.4.2l-.2.2.1.3.5.1h.4l.4-.4v-.6zm2-3.4h1.2v1.7l.5-.3h.5c.5 0 .9.1 1.2.5.3.4.5.8.5 1.4 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.3.6l-.6-.1-.4-.4v.4h-1.1v-5.4zm1.1 3.3c0 .3 0 .6.2.8a.7.7 0 001.2 0l.2-.8c0-.4 0-.6-.2-.8a.7.7 0 00-.6-.3l-.6.3-.2.8zm6.1-.5c0-.2 0-.3-.2-.4a.8.8 0 00-.5-.2c-.3 0-.5.1-.6.3l-.2.9c0 .3 0 .6.2.8.1.2.3.3.6.3.2 0 .4 0 .5-.2l.2-.4h1.1c0 .5-.3.8-.6 1.1a2 2 0 01-1.3.4c-.5 0-1-.2-1.3-.6a2 2 0 01-.5-1.4c0-.6.1-1.1.5-1.5.3-.4.8-.5 1.4-.5.5 0 1 0 1.2.3.4.3.5.7.5 1.2h-1v-.1z" fill-rule="evenodd"/></svg>',
	    'checklist-rtl': '<svg width="24" height="24"><path d="M5 17h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm14.2 11c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 20c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 14c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 8c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8z" fill-rule="evenodd"/></svg>',
	    'checklist': '<svg width="24" height="24"><path d="M11 17h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8a1 1 0 010 2h-8a1 1 0 010-2zM7.2 16c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 20c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 14c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 8c-.2.3-.7.4-1 0L3.8 6.9a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8z" fill-rule="evenodd"/></svg>',
	    'checkmark': '<svg width="24" height="24"><path d="M18.2 5.4a1 1 0 011.6 1.2l-8 12a1 1 0 01-1.5.1l-5-5a1 1 0 111.4-1.4l4.1 4.1 7.4-11z" fill-rule="nonzero"/></svg>',
	    'chevron-down': '<svg width="10" height="10"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 010-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8z" fill-rule="nonzero"/></svg>',
	    'chevron-left': '<svg width="10" height="10"><path d="M7.8 1.3L4 5l3.8 3.7c.3.3.3.8 0 1-.4.4-.9.4-1.2 0L2.2 5.7a.8.8 0 010-1.2L6.6.2C7 0 7.4 0 7.8.2c.3.3.3.8 0 1.1z" fill-rule="nonzero"/></svg>',
	    'chevron-right': '<svg width="10" height="10"><path d="M2.2 1.3a.8.8 0 010-1c.4-.4.9-.4 1.2 0l4.4 4.1c.3.4.3.9 0 1.2L3.4 9.8c-.3.3-.8.3-1.2 0a.8.8 0 010-1.1L6 5 2.2 1.3z" fill-rule="nonzero"/></svg>',
	    'chevron-up': '<svg width="10" height="10"><path d="M8.7 7.8L5 4 1.3 7.8c-.3.3-.8.3-1 0a.8.8 0 010-1.2l4.1-4.4c.3-.3.9-.3 1.2 0l4.2 4.4c.3.3.3.9 0 1.2-.3.3-.8.3-1.1 0z" fill-rule="nonzero"/></svg>',
	    'close': '<svg width="24" height="24"><path d="M17.3 8.2L13.4 12l3.9 3.8a1 1 0 01-1.5 1.5L12 13.4l-3.8 3.9a1 1 0 01-1.5-1.5l3.9-3.8-3.9-3.8a1 1 0 011.5-1.5l3.8 3.9 3.8-3.9a1 1 0 011.5 1.5z" fill-rule="evenodd"/></svg>',
	    'code-sample': '<svg width="24" height="26"><path d="M7.1 11a2.8 2.8 0 01-.8 2 2.8 2.8 0 01.8 2v1.7c0 .3.1.6.4.8.2.3.5.4.8.4.3 0 .4.2.4.4v.8c0 .2-.1.4-.4.4-.7 0-1.4-.3-2-.8-.5-.6-.8-1.3-.8-2V15c0-.3-.1-.6-.4-.8-.2-.3-.5-.4-.8-.4a.4.4 0 01-.4-.4v-.8c0-.2.2-.4.4-.4.3 0 .6-.1.8-.4.3-.2.4-.5.4-.8V9.3c0-.7.3-1.4.8-2 .6-.5 1.3-.8 2-.8.3 0 .4.2.4.4v.8c0 .2-.1.4-.4.4-.3 0-.6.1-.8.4-.3.2-.4.5-.4.8V11zm9.8 0V9.3c0-.3-.1-.6-.4-.8-.2-.3-.5-.4-.8-.4a.4.4 0 01-.4-.4V7c0-.2.1-.4.4-.4.7 0 1.4.3 2 .8.5.6.8 1.3.8 2V11c0 .3.1.6.4.8.2.3.5.4.8.4.2 0 .4.2.4.4v.8c0 .2-.2.4-.4.4-.3 0-.6.1-.8.4-.3.2-.4.5-.4.8v1.7c0 .7-.3 1.4-.8 2-.6.5-1.3.8-2 .8a.4.4 0 01-.4-.4v-.8c0-.2.1-.4.4-.4.3 0 .6-.1.8-.4.3-.2.4-.5.4-.8V15a2.8 2.8 0 01.8-2 2.8 2.8 0 01-.8-2zm-3.3-.4c0 .4-.1.8-.5 1.1-.3.3-.7.5-1.1.5-.4 0-.8-.2-1.1-.5-.4-.3-.5-.7-.5-1.1 0-.5.1-.9.5-1.2.3-.3.7-.4 1.1-.4.4 0 .8.1 1.1.4.4.3.5.7.5 1.2zM12 13c.4 0 .8.1 1.1.5.4.3.5.7.5 1.1 0 1-.1 1.6-.5 2a3 3 0 01-1.1 1c-.4.3-.8.4-1.1.4a.5.5 0 01-.5-.5V17a3 3 0 001-.2l.6-.6c-.6 0-1-.2-1.3-.5-.2-.3-.3-.7-.3-1 0-.5.1-1 .5-1.2.3-.4.7-.5 1.1-.5z" fill-rule="evenodd"/></svg>',
	    'color-levels': '<svg width="24" height="24"><path d="M17.5 11.4A9 9 0 0118 14c0 .5 0 1-.2 1.4 0 .4-.3.9-.5 1.3a6.2 6.2 0 01-3.7 3 5.7 5.7 0 01-3.2 0A5.9 5.9 0 017.6 18a6.2 6.2 0 01-1.4-2.6 6.7 6.7 0 010-2.8c0-.4.1-.9.3-1.3a13.6 13.6 0 012.3-4A20 20 0 0112 4a26.4 26.4 0 013.2 3.4 18.2 18.2 0 012.3 4zm-2 4.5c.4-.7.5-1.4.5-2a7.3 7.3 0 00-1-3.2c.2.6.2 1.2.2 1.9a4.5 4.5 0 01-1.3 3 5.3 5.3 0 01-2.3 1.5 4.9 4.9 0 01-2 .1 4.3 4.3 0 002.4.8 4 4 0 002-.6 4 4 0 001.5-1.5z" fill-rule="evenodd"/></svg>',
	    'color-picker': '<svg width="24" height="24"><path d="M12 3a9 9 0 000 18 1.5 1.5 0 001.1-2.5c-.2-.3-.4-.6-.4-1 0-.8.7-1.5 1.5-1.5H16a5 5 0 005-5c0-4.4-4-8-9-8zm-5.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3-4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" fill-rule="nonzero"/></svg>',
	    'color-swatch-remove-color': '<svg width="24" height="24"><path stroke="#000" stroke-width="2" d="M21 3L3 21" fill-rule="evenodd"/></svg>',
	    'color-swatch': '<svg width="24" height="24"><rect x="3" y="3" width="18" height="18" rx="1" fill-rule="evenodd"/></svg>',
	    'comment-add': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M9 19l3-2h7c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H5a1 1 0 00-1 1v10c0 .6.4 1 1 1h4v2zm-2 4v-4H5a3 3 0 01-3-3V6a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3h-6.4L7 23z"/><path d="M13 10h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2V8a1 1 0 012 0v2z"/></g></svg>',
	    'comment': '<svg width="24" height="24"><path fill-rule="nonzero" d="M9 19l3-2h7c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H5a1 1 0 00-1 1v10c0 .6.4 1 1 1h4v2zm-2 4v-4H5a3 3 0 01-3-3V6a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3h-6.4L7 23z"/></svg>',
	    'contrast': '<svg width="24" height="24"><path d="M12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4zm-6 8a6 6 0 006 6V6a6 6 0 00-6 6z" fill-rule="evenodd"/></svg>',
	    'copy': '<svg width="24" height="24"><path d="M16 3H6a2 2 0 00-2 2v11h2V5h10V3zm1 4a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V9c0-1.2.9-2 2-2h7zm0 12V9h-7v10h7z" fill-rule="nonzero"/></svg>',
	    'crop': '<svg width="24" height="24"><path d="M17 8v7h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1a1 1 0 01-1-1v-2H7V9H5a1 1 0 110-2h2V5c0-.6.4-1 1-1s1 .4 1 1v2h7l3-3 1 1-3 3zM9 9v5l5-5H9zm1 6h5v-5l-5 5z" fill-rule="evenodd"/></svg>',
	    'cut-column': '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.2 4.5c.9 0 1.6.4 2.2 1A3.7 3.7 0 0110.5 8v.5l1 1 4-4 1-.5a3.3 3.3 0 012 0c.4 0 .7.3 1 .5L17 8h4v13h-6V10l-1.5 1.5.5.5v4l-2.5-2.5-1 1v.5c0 .4 0 .8-.3 1.2-.2.5-.4.9-.8 1.2-.6.7-1.3 1-2.2 1-.8.2-1.5 0-2-.6l-.5-.8-.2-1c0-.4 0-.8.3-1.2A3.9 3.9 0 017 12.7c.5-.2 1-.3 1.5-.2l1-1-1-1c-.5 0-1 0-1.5-.2-.5-.1-1-.4-1.4-.9-.4-.3-.6-.7-.8-1.2L4.5 7c0-.4 0-.7.2-1 0-.3.3-.6.5-.8.5-.5 1.2-.8 2-.7zm12.3 5h-3v10h3v-10zM8 13.8h-.3l-.4.2a2.8 2.8 0 00-.7.4v.1a2.8 2.8 0 00-.6.8l-.1.4v.7l.2.5.5.2h.7a2.6 2.6 0 00.8-.3 2.4 2.4 0 00.7-.7 2.5 2.5 0 00.3-.8 1.5 1.5 0 000-.8 1 1 0 00-.2-.4 1 1 0 00-.5-.2H8zm3.5-3.7c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4zM7 5.8h-.4a1 1 0 00-.5.3 1 1 0 00-.2.5v.7a2.5 2.5 0 00.3.8l.2.3h.1l.4.4.4.2.4.1h.7L9 9l.2-.4a1.6 1.6 0 000-.8 2.6 2.6 0 00-.3-.8A2.5 2.5 0 007.7 6l-.4-.1H7z"/></svg>',
	    'cut-row': '<svg width="24" height="24"><path fill-rule="evenodd" d="M22 3v5H9l3 3 2-2h4l-4 4 1 1h.5c.4 0 .8 0 1.2.3.5.2.9.4 1.2.8.7.6 1 1.3 1 2.2.2.8 0 1.5-.6 2l-.8.5-1 .2c-.4 0-.8 0-1.2-.3a3.9 3.9 0 01-2.1-2.2c-.2-.5-.3-1-.2-1.5l-1-1-1 1c0 .5 0 1-.2 1.5-.1.5-.4 1-.9 1.4-.3.4-.7.6-1.2.8l-1.2.3c-.4 0-.7 0-1-.2-.3 0-.6-.3-.8-.5-.5-.5-.8-1.2-.7-2 0-.9.4-1.6 1-2.2A3.7 3.7 0 018.6 14H9l1-1-4-4-.5-1a3.3 3.3 0 010-2c0-.4.3-.7.5-1l2 2V3h14zM8.5 15.3h-.3a2.6 2.6 0 00-.8.4 2.5 2.5 0 00-.9 1.1l-.1.4v.7l.2.5.5.2h.7a2.5 2.5 0 00.8-.3L9 18V18l.4-.4.2-.4.1-.4v-.3-.4a1 1 0 00-.2-.5 1 1 0 00-.4-.2h-.5zm7 0H15a1 1 0 00-.4.3 1 1 0 00-.2.5 1.5 1.5 0 000 .7v.4a2.8 2.8 0 00.5.7h.1a2.8 2.8 0 00.8.6l.4.1h.7l.5-.2.2-.5v-.4-.3a2.6 2.6 0 00-.3-.8 2.4 2.4 0 00-.7-.7 2.5 2.5 0 00-.8-.3h-.3zM12 11.6c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4zm8.5-7.1h-11v2h11v-2z"/></svg>',
	    'cut': '<svg width="24" height="24"><path d="M18 15c.6.7 1 1.4 1 2.3 0 .8-.2 1.5-.7 2l-.8.5-1 .2c-.4 0-.8 0-1.2-.3a3.9 3.9 0 01-2.1-2.2c-.2-.5-.3-1-.2-1.5l-1-1-1 1c0 .5 0 1-.2 1.5-.1.5-.4 1-.9 1.4-.3.4-.7.6-1.2.8l-1.2.3c-.4 0-.7 0-1-.2-.3 0-.6-.3-.8-.5-.5-.5-.8-1.2-.7-2 0-.9.4-1.6 1-2.2A3.7 3.7 0 018.6 14H9l1-1-4-4-.5-1a3.3 3.3 0 010-2c0-.4.3-.7.5-1l6 6 6-6 .5 1a3.3 3.3 0 010 2c0 .4-.3.7-.5 1l-4 4 1 1h.5c.4 0 .8 0 1.2.3.5.2.9.4 1.2.8zm-8.5 2.2l.1-.4v-.3-.4a1 1 0 00-.2-.5 1 1 0 00-.4-.2 1.6 1.6 0 00-.8 0 2.6 2.6 0 00-.8.3 2.5 2.5 0 00-.9 1.1l-.1.4v.7l.2.5.5.2h.7a2.5 2.5 0 00.8-.3 2.8 2.8 0 001-1zm2.5-2.8c.4 0 .7-.1 1-.4.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4s-.7.1-1 .4c-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4zm5.4 4l.2-.5v-.4-.3a2.6 2.6 0 00-.3-.8 2.4 2.4 0 00-.7-.7 2.5 2.5 0 00-.8-.3 1.5 1.5 0 00-.8 0 1 1 0 00-.4.2 1 1 0 00-.2.5 1.5 1.5 0 000 .7v.4l.3.4.3.4a2.8 2.8 0 00.8.5l.4.1h.7l.5-.2z" fill-rule="evenodd"/></svg>',
	    'document-properties': '<svg width="24" height="24"><path d="M14.4 3H7a2 2 0 00-2 2v14c0 1.1.9 2 2 2h10a2 2 0 002-2V7.6L14.4 3zM17 19H7V5h6v4h4v10z" fill-rule="nonzero"/></svg>',
	    'drag': '<svg width="24" height="24"><path d="M13 5h2v2h-2V5zm0 4h2v2h-2V9zM9 9h2v2H9V9zm4 4h2v2h-2v-2zm-4 0h2v2H9v-2zm0 4h2v2H9v-2zm4 0h2v2h-2v-2zM9 5h2v2H9V5z" fill-rule="evenodd"/></svg>',
	    'duplicate-column': '<svg width="24" height="24"><path d="M17 6v16h-7V6h7zm-2 2h-3v12h3V8zm-2-6v2H8v15H6V2h7z"/></svg>',
	    'duplicate-row': '<svg width="24" height="24"><path d="M22 11v7H6v-7h16zm-2 2H8v3h12v-3zm-1-6v2H4v5H2V7h17z"/></svg>',
	    'duplicate': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M16 3v2H6v11H4V5c0-1.1.9-2 2-2h10zm3 8h-2V9h-7v10h9a2 2 0 01-2 2h-7a2 2 0 01-2-2V9c0-1.2.9-2 2-2h7a2 2 0 012 2v2z"/><path d="M17 14h1a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1z"/></g></svg>',
	    'edit-block': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19.8 8.8l-9.4 9.4c-.2.2-.5.4-.9.4l-5.4 1.2 1.2-5.4.5-.8 9.4-9.4c.7-.7 1.8-.7 2.5 0l2.1 2.1c.7.7.7 1.8 0 2.5zm-2-.2l1-.9v-.3l-2.2-2.2a.3.3 0 00-.3 0l-1 1L18 8.5zm-1 1l-2.5-2.4-6 6 2.5 2.5 6-6zm-7 7.1l-2.6-2.4-.3.3-.1.2-.7 3 3.1-.6h.1l.4-.5z"/></svg>',
	    'edit-image': '<svg width="24" height="24"><path d="M18 16h2V7a2 2 0 00-2-2H7v2h11v9zM6 17h15a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1H6a2 2 0 01-2-2V7H3a1 1 0 110-2h1V4a1 1 0 112 0v13zm3-5.3l1.3 2 3-4.7 3.7 6H7l2-3.3z" fill-rule="nonzero"/></svg>',
	    'embed-page': '<svg width="24" height="24"><path d="M19 6V5H5v14h2A13 13 0 0119 6zm0 1.4c-.8.8-1.6 2.4-2.2 4.6H19V7.4zm0 5.6h-2.4c-.4 1.8-.6 3.8-.6 6h3v-6zm-4 6c0-2.2.2-4.2.6-6H13c-.7 1.8-1.1 3.8-1.1 6h3zm-4 0c0-2.2.4-4.2 1-6H9.6A12 12 0 008 19h3zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm11.8 9c.4-1.9 1-3.4 1.8-4.5a9.2 9.2 0 00-4 4.5h2.2zm-3.4 0a12 12 0 012.8-4 12 12 0 00-5 4h2.2z" fill-rule="nonzero"/></svg>',
	    'embed': '<svg width="24" height="24"><path d="M4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm1 2v14h14V5H5zm4.8 2.6l5.6 4a.5.5 0 010 .8l-5.6 4A.5.5 0 019 16V8a.5.5 0 01.8-.4z" fill-rule="nonzero"/></svg>',
	    'emoji': '<svg width="24" height="24"><path d="M9 11c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 00-1 1c0 .6.4 1 1 1zm6 0c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 00-1 1c0 .6.4 1 1 1zm-3 5.5c2.1 0 4-1.5 4.4-3.5H7.6c.5 2 2.3 3.5 4.4 3.5zM12 4a8 8 0 100 16 8 8 0 000-16zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z" fill-rule="nonzero"/></svg>',
	    'export': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M14.4 3L18 7v1h-5V5H7v14h9a1 1 0 012 0c0 1-.8 2-1.9 2H7c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2h7.5z"/><path d="M18.1 12c.5 0 .9.4.9 1 0 .5-.3 1-.8 1h-7.3c-.5 0-.9-.4-.9-1 0-.5.3-1 .8-1h7.3z"/><path d="M16.4 9.2a1 1 0 011.4.2l2.4 3.6-2.4 3.6a1 1 0 01-1.7-1v-.2l1.7-2.4-1.6-2.4a1 1 0 01.2-1.4z"/></g></svg>',
	    'fill': '<svg width="24" height="26"><path d="M16.6 12l-9-9-1.4 1.4 2.4 2.4-5.2 5.1c-.5.6-.5 1.6 0 2.2L9 19.6a1.5 1.5 0 002.2 0l5.5-5.5c.5-.6.5-1.6 0-2.2zM5.2 13L10 8.2l4.8 4.8H5.2zM19 14.5s-2 2.2-2 3.5c0 1.1.9 2 2 2a2 2 0 002-2c0-1.3-2-3.5-2-3.5z" fill-rule="nonzero"/></svg>',
	    'flip-horizontally': '<svg width="24" height="24"><path d="M14 19h2v-2h-2v2zm4-8h2V9h-2v2zM4 7v10c0 1.1.9 2 2 2h3v-2H6V7h3V5H6a2 2 0 00-2 2zm14-2v2h2a2 2 0 00-2-2zm-7 16h2V3h-2v18zm7-6h2v-2h-2v2zm-4-8h2V5h-2v2zm4 12a2 2 0 002-2h-2v2z" fill-rule="nonzero"/></svg>',
	    'flip-vertically': '<svg width="24" height="24"><path d="M5 14v2h2v-2H5zm8 4v2h2v-2h-2zm4-14H7a2 2 0 00-2 2v3h2V6h10v3h2V6a2 2 0 00-2-2zm2 14h-2v2a2 2 0 002-2zM3 11v2h18v-2H3zm6 7v2h2v-2H9zm8-4v2h2v-2h-2zM5 18c0 1.1.9 2 2 2v-2H5z" fill-rule="nonzero"/></svg>',
	    'format-painter': '<svg width="24" height="24"><path d="M18 5V4c0-.5-.4-1-1-1H5a1 1 0 00-1 1v4c0 .6.5 1 1 1h12c.6 0 1-.4 1-1V7h1v4H9v9c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-7h8V5h-3z" fill-rule="nonzero"/></svg>',
	    'format': '<svg width="24" height="24"><path fill-rule="evenodd" d="M17 5a1 1 0 010 2h-4v11a1 1 0 01-2 0V7H7a1 1 0 110-2h10z"/></svg>',
	    'fullscreen': '<svg width="24" height="24"><path d="M15.3 10l-1.2-1.3 2.9-3h-2.3a.9.9 0 110-1.7H19c.5 0 .9.4.9.9v4.4a.9.9 0 11-1.8 0V7l-2.9 3zm0 4l3 3v-2.3a.9.9 0 111.7 0V19c0 .5-.4.9-.9.9h-4.4a.9.9 0 110-1.8H17l-3-2.9 1.3-1.2zM10 15.4l-2.9 3h2.3a.9.9 0 110 1.7H5a.9.9 0 01-.9-.9v-4.4a.9.9 0 111.8 0V17l2.9-3 1.2 1.3zM8.7 10L5.7 7v2.3a.9.9 0 01-1.7 0V5c0-.5.4-.9.9-.9h4.4a.9.9 0 010 1.8H7l3 2.9-1.3 1.2z" fill-rule="nonzero"/></svg>',
	    'gallery': '<svg width="24" height="24"><path fill-rule="nonzero" d="M5 15.7l2.3-2.2c.3-.3.7-.3 1 0L11 16l5.1-5c.3-.4.8-.4 1 0l2 1.9V8H5v7.7zM5 18V19h3l1.8-1.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 6h16c.6 0 1 .4 1 1v13c0 .6-.4 1-1 1H4a1 1 0 01-1-1V7c0-.6.4-1 1-1zm6 7a2 2 0 110-4 2 2 0 010 4zM4.5 4h15a.5.5 0 110 1h-15a.5.5 0 010-1zm2-2h11a.5.5 0 110 1h-11a.5.5 0 010-1z"/></svg>',
	    'gamma': '<svg width="24" height="24"><path d="M4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm1 2v14h14V5H5zm6.5 11.8V14L9.2 8.7a5.1 5.1 0 00-.4-.8l-.1-.2H8 8v-1l.3-.1.3-.1h.7a1 1 0 01.6.5l.1.3a8.5 8.5 0 01.3.6l1.9 4.6 2-5.2a1 1 0 011-.6.5.5 0 01.5.6L13 14v2.8a.7.7 0 01-1.4 0z" fill-rule="nonzero"/></svg>',
	    'help': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M12 5.5a6.5 6.5 0 00-6 9 6.3 6.3 0 001.4 2l1 1a6.3 6.3 0 003.6 1 6.5 6.5 0 006-9 6.3 6.3 0 00-1.4-2l-1-1a6.3 6.3 0 00-3.6-1zM12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4z"/><path d="M9.6 9.7a.7.7 0 01-.7-.8c0-1.1 1.5-1.8 3.2-1.8 1.8 0 3.2.8 3.2 2.4 0 1.4-.4 2.1-1.5 2.8-.2 0-.3.1-.3.2a2 2 0 00-.8.8.8.8 0 01-1.4-.6c.3-.7.8-1 1.3-1.5l.4-.2c.7-.4.8-.6.8-1.5 0-.5-.6-.9-1.7-.9-.5 0-1 .1-1.4.3-.2 0-.3.1-.3.2v-.2c0 .4-.4.8-.8.8z" fill-rule="nonzero"/><circle cx="12" cy="16" r="1"/></g></svg>',
	    'highlight-bg-color': '<svg width="24" height="24"><g fill-rule="evenodd"><path id="tox-icon-highlight-bg-color__color" d="M3 18h18v3H3z"/><path fill-rule="nonzero" d="M7.7 16.7H3l3.3-3.3-.7-.8L10.2 8l4 4.1-4 4.2c-.2.2-.6.2-.8 0l-.6-.7-1.1 1.1zm5-7.5L11 7.4l3-2.9a2 2 0 012.6 0L18 6c.7.7.7 2 0 2.7l-2.9 2.9-1.8-1.8-.5-.6"/></g></svg>',
	    'home': '<svg width="24" height="24"><path fill-rule="nonzero" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>',
	    'horizontal-rule': '<svg width="24" height="24"><path d="M4 11h16v2H4z" fill-rule="evenodd"/></svg>',
	    'image-options': '<svg width="24" height="24"><path d="M6 10a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm12 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm-6 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2z" fill-rule="nonzero"/></svg>',
	    'image': '<svg width="24" height="24"><path d="M5 15.7l3.3-3.2c.3-.3.7-.3 1 0L12 15l4.1-4c.3-.4.8-.4 1 0l2 1.9V5H5v10.7zM5 18V19h3l2.8-2.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm6 8a2 2 0 100-4 2 2 0 000 4z" fill-rule="nonzero"/></svg>',
	    'indent': '<svg width="24" height="24"><path d="M7 5h12c.6 0 1 .4 1 1s-.4 1-1 1H7a1 1 0 110-2zm5 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm0 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm-5 4h12a1 1 0 010 2H7a1 1 0 010-2zm-2.6-3.8L6.2 12l-1.8-1.2a1 1 0 011.2-1.6l3 2a1 1 0 010 1.6l-3 2a1 1 0 11-1.2-1.6z" fill-rule="evenodd"/></svg>',
	    'info': '<svg width="24" height="24"><path d="M12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4zm-1 3v2h2V7h-2zm3 10v-1h-1v-5h-3v1h1v4h-1v1h4z" fill-rule="evenodd"/></svg>',
	    'insert-character': '<svg width="24" height="24"><path d="M15 18h4l1-2v4h-6v-3.3l1.4-1a6 6 0 001.8-2.9 6.3 6.3 0 00-.1-4.1 5.8 5.8 0 00-3-3.2c-.6-.3-1.3-.5-2.1-.5a5.1 5.1 0 00-3.9 1.8 6.3 6.3 0 00-1.3 6 6.2 6.2 0 001.8 3l1.4.9V20H4v-4l1 2h4v-.5l-2-1L5.4 15A6.5 6.5 0 014 11c0-1 .2-1.9.6-2.7A7 7 0 016.3 6C7.1 5.4 8 5 9 4.5c1-.3 2-.5 3.1-.5a8.8 8.8 0 015.7 2 7 7 0 011.7 2.3 6 6 0 01.2 4.8c-.2.7-.6 1.3-1 1.9a7.6 7.6 0 01-3.6 2.5v.5z" fill-rule="evenodd"/></svg>',
	    'insert-time': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M12 19a7 7 0 100-14 7 7 0 000 14zm0 2a9 9 0 110-18 9 9 0 010 18z"/><path d="M16 12h-3V7c0-.6-.4-1-1-1a1 1 0 00-1 1v7h5c.6 0 1-.4 1-1s-.4-1-1-1z"/></g></svg>',
	    'invert': '<svg width="24" height="24"><path d="M18 19.3L16.5 18a5.8 5.8 0 01-3.1 1.9 6.1 6.1 0 01-5.5-1.6A5.8 5.8 0 016 14v-.3l.1-1.2A13.9 13.9 0 017.7 9l-3-3 .7-.8 2.8 2.9 9 8.9 1.5 1.6-.7.6zm0-5.5v.3l-.1 1.1-.4 1-1.2-1.2a4.3 4.3 0 00.2-1v-.2c0-.4 0-.8-.2-1.3l-.5-1.4a14.8 14.8 0 00-3-4.2L12 6a26.1 26.1 0 00-2.2 2.5l-1-1a20.9 20.9 0 012.9-3.3L12 4l1 .8a22.2 22.2 0 014 5.4c.6 1.2 1 2.4 1 3.6z" fill-rule="evenodd"/></svg>',
	    'italic': '<svg width="24" height="24"><path d="M16.7 4.7l-.1.9h-.3c-.6 0-1 0-1.4.3-.3.3-.4.6-.5 1.1l-2.1 9.8v.6c0 .5.4.8 1.4.8h.2l-.2.8H8l.2-.8h.2c1.1 0 1.8-.5 2-1.5l2-9.8.1-.5c0-.6-.4-.8-1.4-.8h-.3l.2-.9h5.8z" fill-rule="evenodd"/></svg>',
	    'language': '<svg width="24" height="24"><path d="M12 3a9 9 0 110 18 9 9 0 010-18zm4.3 13.3c-.5 1-1.2 2-2 2.9a7.5 7.5 0 003.2-2.1l-.2-.2a6 6 0 00-1-.6zm-8.6 0c-.5.2-.9.5-1.2.8.9 1 2 1.7 3.2 2a10 10 0 01-2-2.8zm3.6-.8c-.8 0-1.6.1-2.2.3.5 1 1.2 1.9 2.1 2.7zm1.5 0v3c.9-.8 1.6-1.7 2.1-2.7-.6-.2-1.4-.3-2.1-.3zm-6-2.7H4.5c.2 1 .5 2.1 1 3h.3l1.3-1a10 10 0 01-.3-2zm12.7 0h-2.3c0 .7-.1 1.4-.3 2l1.6 1.1c.5-1 .9-2 1-3.1zm-3.8 0h-3V14c1 0 2 .1 2.7.4.2-.5.3-1 .3-1.6zm-4.4 0h-3l.3 1.6c.8-.3 1.7-.4 2.7-.4v-1.3zm-5.5-5c-.7 1-1.1 2.2-1.3 3.5h2.3c0-1 .2-1.8.5-2.6l-1.5-1zm2.9 1.4v.1c-.2.6-.4 1.3-.4 2h3V9.4c-1 0-1.8-.1-2.6-.3zm6.6 0h-.1l-2.4.3v1.8h3l-.5-2.1zm3-1.4l-.3.1-1.3.8c.3.8.5 1.6.5 2.6h2.3a7.5 7.5 0 00-1.3-3.5zm-9 0l2 .2V5.5a9 9 0 00-2 2.2zm3.5-2.3V8c.6 0 1.3 0 1.9-.2a9 9 0 00-2-2.3zm-3-.7h-.1c-1.1.4-2.1 1-3 1.8l1.2.7a10 10 0 011.9-2.5zm4.4 0l.1.1a10 10 0 011.8 2.4l1.1-.7a7.5 7.5 0 00-3-1.8z"/></svg>',
	    'line-height': '<svg width="24" height="24"><path d="M21 5a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zM7 3.6l3.7 3.7a1 1 0 01-1.3 1.5h-.1L8 7.3v9.2l1.3-1.3a1 1 0 011.3 0h.1c.4.4.4 1 0 1.3v.1L7 20.4l-3.7-3.7a1 1 0 011.3-1.5h.1L6 16.7V7.4L4.7 8.7a1 1 0 01-1.3 0h-.1a1 1 0 010-1.3v-.1L7 3.6z"/></svg>',
	    'line': '<svg width="24" height="24"><path d="M15 9l-8 8H4v-3l8-8 3 3zm1-1l-3-3 1-1h1c-.2 0 0 0 0 0l2 2s0 .2 0 0v1l-1 1zM4 18h16v2H4v-2z" fill-rule="evenodd"/></svg>',
	    'link': '<svg width="24" height="24"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2.1 2a2 2 0 102.7 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2-2a2 2 0 10-2.6-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2z" fill-rule="nonzero"/></svg>',
	    'list-bull-circle': '<svg width="48" height="48"><g fill-rule="evenodd"><path d="M11 16a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM11 26a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM11 36a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6z" fill-rule="nonzero"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
	    'list-bull-default': '<svg width="48" height="48"><g fill-rule="evenodd"><circle cx="11" cy="14" r="3"/><circle cx="11" cy="24" r="3"/><circle cx="11" cy="34" r="3"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
	    'list-bull-square': '<svg width="48" height="48"><g fill-rule="evenodd"><path d="M8 11h6v6H8zM8 21h6v6H8zM8 31h6v6H8z"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
	    'list-num-default-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M37.4 17v-4.8l-1.6 1v-1.1l1.6-1h1.2V17zM33.3 17.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm1.7 5.7c0-1.2 1-2 2.2-2 1.3 0 2.1.8 2.1 1.8 0 .7-.3 1.2-1.3 2.2l-1.2 1v.2h2.6v1h-4.3v-.9l2-1.9c.8-.8 1-1.1 1-1.5 0-.5-.4-.8-1-.8-.5 0-.9.3-.9.9H35zm-1.7 4.3c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm3.2 7.3v-1h.7c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7s-1 .3-1 .8H35c0-1.1 1-1.8 2.2-1.8 1.2 0 2.1.6 2.1 1.6 0 .7-.4 1.2-1 1.3v.1c.7.1 1.3.7 1.3 1.4 0 1-1 1.9-2.4 1.9-1.3 0-2.2-.8-2.3-2h1.2c0 .6.5 1 1.1 1 .6 0 1-.4 1-1 0-.5-.3-.8-1-.8h-.7zm-3.3 2.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7z"/></g></svg>',
	    'list-num-default': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10 17v-4.8l-1.5 1v-1.1l1.6-1h1.2V17h-1.2zm3.6.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm-5 5.7c0-1.2.8-2 2.1-2s2.1.8 2.1 1.8c0 .7-.3 1.2-1.4 2.2l-1.1 1v.2h2.6v1H8.6v-.9l2-1.9c.8-.8 1-1.1 1-1.5 0-.5-.4-.8-1-.8-.5 0-.9.3-.9.9H8.5zm6.3 4.3c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM10 34.4v-1h.7c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7s-1 .3-1 .8H8.6c0-1.1 1-1.8 2.2-1.8 1.3 0 2.1.6 2.1 1.6 0 .7-.4 1.2-1 1.3v.1c.8.1 1.3.7 1.3 1.4 0 1-1 1.9-2.4 1.9-1.3 0-2.2-.8-2.3-2h1.2c0 .6.5 1 1.1 1 .7 0 1-.4 1-1 0-.5-.3-.8-1-.8h-.7zm4.7 2.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7z"/></g></svg>',
	    'list-num-lower-alpha-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M36.5 16c-.9 0-1.5-.5-1.5-1.3s.6-1.3 1.8-1.4h1v-.4c0-.4-.2-.6-.7-.6-.4 0-.7.1-.8.4h-1.1c0-.8.8-1.4 2-1.4S39 12 39 13V16h-1.2v-.6c-.3.4-.8.7-1.4.7zm.4-.8c.6 0 1-.4 1-.9V14h-1c-.5.1-.7.3-.7.6 0 .4.3.6.7.6zM33.1 16.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zM37.7 26c-.7 0-1.2-.2-1.5-.7v.7H35v-6.3h1.2v2.5c.3-.5.8-.9 1.5-.9 1.1 0 1.8 1 1.8 2.4 0 1.5-.7 2.4-1.8 2.4zm-.5-3.6c-.6 0-1 .5-1 1.3s.4 1.4 1 1.4c.7 0 1-.6 1-1.4 0-.8-.3-1.3-1-1.3zM33.2 26.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zm6 7h-1c-.1-.5-.4-.8-1-.8s-1 .5-1 1.4c0 1 .4 1.4 1 1.4.5 0 .9-.2 1-.7h1c0 1-.8 1.7-2 1.7-1.4 0-2.2-.9-2.2-2.4s.8-2.4 2.2-2.4c1.2 0 2 .7 2 1.7zm-6.1 3c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-lower-alpha': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10.3 15.2c.5 0 1-.4 1-.9V14h-1c-.5.1-.8.3-.8.6 0 .4.3.6.8.6zm-.4.9c-1 0-1.5-.6-1.5-1.4 0-.8.6-1.3 1.7-1.4h1.1v-.4c0-.4-.2-.6-.7-.6-.5 0-.8.1-.9.4h-1c0-.8.8-1.4 2-1.4 1.1 0 1.8.6 1.8 1.6V16h-1.1v-.6h-.1c-.2.4-.7.7-1.3.7zm4.6 0c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-3.2 10c-.6 0-1.2-.3-1.4-.8v.7H8.5v-6.3H10v2.5c.3-.5.8-.9 1.4-.9 1.2 0 1.9 1 1.9 2.4 0 1.5-.7 2.4-1.9 2.4zm-.4-3.7c-.7 0-1 .5-1 1.3s.3 1.4 1 1.4c.6 0 1-.6 1-1.4 0-.8-.4-1.3-1-1.3zm4 3.7c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-2.2 7h-1.2c0-.5-.4-.8-.9-.8-.6 0-1 .5-1 1.4 0 1 .4 1.4 1 1.4.5 0 .8-.2 1-.7h1c0 1-.8 1.7-2 1.7-1.4 0-2.2-.9-2.2-2.4s.8-2.4 2.2-2.4c1.2 0 2 .7 2 1.7zm1.8 3c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-lower-greek-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M37.4 16c-1.2 0-2-.8-2-2.3 0-1.5.8-2.4 2-2.4.6 0 1 .4 1.3 1v-.9H40v3.2c0 .4.1.5.4.5h.2v.9h-.6c-.6 0-1-.2-1-.7h-.2c-.2.4-.7.8-1.3.8zm.3-1c.6 0 1-.5 1-1.3s-.4-1.3-1-1.3-1 .5-1 1.3.4 1.4 1 1.4zM33.3 16.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM36 21.9c0-1.5.8-2.3 2.1-2.3 1.2 0 2 .6 2 1.6 0 .6-.3 1-.9 1.3.9.3 1.3.8 1.3 1.7 0 1.2-.7 1.9-1.8 1.9-.6 0-1.1-.3-1.4-.8v2.2H36V22zm1.8 1.2v-1h.3c.5 0 .9-.2.9-.7 0-.5-.3-.8-.9-.8-.5 0-.8.3-.8 1v2.2c0 .8.4 1.3 1 1.3s1-.4 1-1-.4-1-1.2-1h-.3zM33.3 26.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM37.1 34.6L34.8 30h1.4l1.7 3.5 1.7-3.5h1.1l-2.2 4.6v.1c.5.8.7 1.4.7 1.8 0 .4-.2.8-.4 1-.2.2-.6.3-1 .3-.9 0-1.3-.4-1.3-1.2 0-.5.2-1 .5-1.7l.1-.2zm.7 1a2 2 0 00-.4.9c0 .3.1.4.4.4.3 0 .4-.1.4-.4 0-.2-.1-.6-.4-1zM33.3 36.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-lower-greek': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10.5 15c.7 0 1-.5 1-1.3s-.3-1.3-1-1.3c-.5 0-.9.5-.9 1.3s.4 1.4 1 1.4zm-.3 1c-1.1 0-1.8-.8-1.8-2.3 0-1.5.7-2.4 1.8-2.4.7 0 1.1.4 1.3 1h.1v-.9h1.2v3.2c0 .4.1.5.4.5h.2v.9h-.6c-.6 0-1-.2-1.1-.7h-.1c-.2.4-.7.8-1.4.8zm5 .1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zm-4.9 7v-1h.3c.6 0 1-.2 1-.7 0-.5-.4-.8-1-.8-.5 0-.8.3-.8 1v2.2c0 .8.4 1.3 1.1 1.3.6 0 1-.4 1-1s-.5-1-1.3-1h-.3zM8.6 22c0-1.5.7-2.3 2-2.3 1.2 0 2 .6 2 1.6 0 .6-.3 1-.8 1.3.8.3 1.3.8 1.3 1.7 0 1.2-.8 1.9-1.9 1.9-.6 0-1.1-.3-1.3-.8v2.2H8.5V22zm6.2 4.2c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm-4.5 8.5L8 30h1.4l1.7 3.5 1.7-3.5h1.1l-2.2 4.6v.1c.5.8.7 1.4.7 1.8 0 .4-.1.8-.4 1-.2.2-.6.3-1 .3-.9 0-1.3-.4-1.3-1.2 0-.5.2-1 .5-1.7l.1-.2zm.7 1a2 2 0 00-.4.9c0 .3.1.4.4.4.3 0 .4-.1.4-.4 0-.2-.1-.6-.4-1zm4.5.5c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-lower-roman-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M32.9 16v-1.2h-1.3V16H33zm0 10v-1.2h-1.3V26H33zm0 10v-1.2h-1.3V36H33z"/><path fill-rule="nonzero" d="M36 21h-1.5v5H36zM36 31h-1.5v5H36zM39 21h-1.5v5H39zM39 31h-1.5v5H39zM42 31h-1.5v5H42zM36 11h-1.5v5H36zM36 19h-1.5v1H36zM36 29h-1.5v1H36zM39 19h-1.5v1H39zM39 29h-1.5v1H39zM42 29h-1.5v1H42zM36 9h-1.5v1H36z"/></g></svg>',
	    'list-num-lower-roman': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M15.1 16v-1.2h1.3V16H15zm0 10v-1.2h1.3V26H15zm0 10v-1.2h1.3V36H15z"/><path fill-rule="nonzero" d="M12 21h1.5v5H12zM12 31h1.5v5H12zM9 21h1.5v5H9zM9 31h1.5v5H9zM6 31h1.5v5H6zM12 11h1.5v5H12zM12 19h1.5v1H12zM12 29h1.5v1H12zM9 19h1.5v1H9zM9 29h1.5v1H9zM6 29h1.5v1H6zM12 9h1.5v1H12z"/></g></svg>',
	    'list-num-upper-alpha-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M39.3 17l-.5-1.4h-2l-.5 1.4H35l2-6h1.6l2 6h-1.3zm-1.6-4.7l-.7 2.3h1.6l-.8-2.3zM33.4 17c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm4.7 9.9h-2.7v-6H38c1.2 0 1.9.6 1.9 1.5 0 .6-.5 1.2-1 1.3.7.1 1.3.7 1.3 1.5 0 1-.8 1.7-2 1.7zm-1.4-5v1.5h1c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7h-1zm0 4h1.1c.7 0 1.1-.3 1.1-.8 0-.6-.4-.9-1.1-.9h-1.1V26zM33 27.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm4.9 10c-1.8 0-2.8-1.1-2.8-3.1s1-3.1 2.8-3.1c1.4 0 2.5.9 2.6 2.2h-1.3c0-.7-.6-1.1-1.3-1.1-1 0-1.6.7-1.6 2s.6 2 1.6 2c.7 0 1.2-.4 1.4-1h1.2c-.1 1.3-1.2 2.2-2.6 2.2zm-4.5 0c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-upper-alpha': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M12.6 17l-.5-1.4h-2L9.5 17H8.3l2-6H12l2 6h-1.3zM11 12.3l-.7 2.3h1.6l-.8-2.3zm4.7 4.8c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zM11.4 27H8.7v-6h2.6c1.2 0 1.9.6 1.9 1.5 0 .6-.5 1.2-1 1.3.7.1 1.3.7 1.3 1.5 0 1-.8 1.7-2 1.7zM10 22v1.5h1c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7h-1zm0 4H11c.7 0 1.1-.3 1.1-.8 0-.6-.4-.9-1.1-.9H10V26zm5.4 1.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-4.1 10c-1.8 0-2.8-1.1-2.8-3.1s1-3.1 2.8-3.1c1.4 0 2.5.9 2.6 2.2h-1.3c0-.7-.6-1.1-1.3-1.1-1 0-1.6.7-1.6 2s.6 2 1.6 2c.7 0 1.2-.4 1.4-1h1.2c-.1 1.3-1.2 2.2-2.6 2.2zm4.5 0c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-upper-roman-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M31.6 17v-1.2H33V17h-1.3zm0 10v-1.2H33V27h-1.3zm0 10v-1.2H33V37h-1.3z"/><path fill-rule="nonzero" d="M34.5 20H36v7h-1.5zM34.5 30H36v7h-1.5zM37.5 20H39v7h-1.5zM37.5 30H39v7h-1.5zM40.5 30H42v7h-1.5zM34.5 10H36v7h-1.5z"/></g></svg>',
	    'list-num-upper-roman': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M15.1 17v-1.2h1.3V17H15zm0 10v-1.2h1.3V27H15zm0 10v-1.2h1.3V37H15z"/><path fill-rule="nonzero" d="M12 20h1.5v7H12zM12 30h1.5v7H12zM9 20h1.5v7H9zM9 30h1.5v7H9zM6 30h1.5v7H6zM12 10h1.5v7H12z"/></g></svg>',
	    'lock': '<svg width="24" height="24"><path d="M16.3 11c.2 0 .3 0 .5.2l.2.6v7.4c0 .3 0 .4-.2.6l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6v-7.4c0-.3 0-.4.2-.6l.5-.2H8V8c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h2c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v3h.3zM10 8v3h4V8a1 1 0 00-.3-.7A1 1 0 0013 7h-2a1 1 0 00-.7.3 1 1 0 00-.3.7z" fill-rule="evenodd"/></svg>',
	    'ltr': '<svg width="24" height="24"><path d="M11 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 017.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L11 5zM4.4 16.2L6.2 15l-1.8-1.2a1 1 0 011.2-1.6l3 2a1 1 0 010 1.6l-3 2a1 1 0 11-1.2-1.6z" fill-rule="evenodd"/></svg>',
	    'more-drawer': '<svg width="24" height="24"><path d="M6 10a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm12 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm-6 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2z" fill-rule="nonzero"/></svg>',
	    'new-document': '<svg width="24" height="24"><path d="M14.4 3H7a2 2 0 00-2 2v14c0 1.1.9 2 2 2h10a2 2 0 002-2V7.6L14.4 3zM17 19H7V5h6v4h4v10z" fill-rule="nonzero"/></svg>',
	    'new-tab': '<svg width="24" height="24"><path d="M15 13l2-2v8H5V7h8l-2 2H7v8h8v-4zm4-8v5.5l-2-2-5.6 5.5H10v-1.4L15.5 7l-2-2H19z" fill-rule="evenodd"/></svg>',
	    'non-breaking': '<svg width="24" height="24"><path d="M11 11H8a1 1 0 110-2h3V6c0-.6.4-1 1-1s1 .4 1 1v3h3c.6 0 1 .4 1 1s-.4 1-1 1h-3v3c0 .6-.4 1-1 1a1 1 0 01-1-1v-3zm10 4v5H3v-5c0-.6.4-1 1-1s1 .4 1 1v3h14v-3c0-.6.4-1 1-1s1 .4 1 1z" fill-rule="evenodd"/></svg>',
	    'notice': '<svg width="24" height="24"><path d="M17.8 9.8L15.4 4 20 8.5v7L15.5 20h-7L4 15.5v-7L8.5 4h7l2.3 5.8zm0 0l2.2 5.7-2.3-5.8zM13 17v-2h-2v2h2zm0-4V7h-2v6h2z" fill-rule="evenodd"/></svg>',
	    'ordered-list-rtl': '<svg width="24" height="24"><path d="M6 17h8a1 1 0 010 2H6a1 1 0 010-2zm0-6h8a1 1 0 010 2H6a1 1 0 010-2zm0-6h8a1 1 0 010 2H6a1 1 0 110-2zm13-1v3.5a.5.5 0 11-1 0V5h-.5a.5.5 0 110-1H19zm-1 8.8l.2.2h1.3a.5.5 0 110 1h-1.6a1 1 0 01-.9-1V13c0-.4.3-.8.6-1l1.2-.4.2-.3a.2.2 0 00-.2-.2h-1.3a.5.5 0 01-.5-.5c0-.3.2-.5.5-.5h1.6c.5 0 .9.4.9 1v.1c0 .4-.3.8-.6 1l-1.2.4-.2.3zm2 4.2v2c0 .6-.4 1-1 1h-1.5a.5.5 0 010-1h1.2a.3.3 0 100-.6h-1.3a.4.4 0 110-.8h1.3a.3.3 0 000-.6h-1.2a.5.5 0 110-1H19c.6 0 1 .4 1 1z" fill-rule="evenodd"/></svg>',
	    'ordered-list': '<svg width="24" height="24"><path d="M10 17h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 110-2zM6 4v3.5c0 .3-.2.5-.5.5a.5.5 0 01-.5-.5V5h-.5a.5.5 0 010-1H6zm-1 8.8l.2.2h1.3c.3 0 .5.2.5.5s-.2.5-.5.5H4.9a1 1 0 01-.9-1V13c0-.4.3-.8.6-1l1.2-.4.2-.3a.2.2 0 00-.2-.2H4.5a.5.5 0 01-.5-.5c0-.3.2-.5.5-.5h1.6c.5 0 .9.4.9 1v.1c0 .4-.3.8-.6 1l-1.2.4-.2.3zM7 17v2c0 .6-.4 1-1 1H4.5a.5.5 0 010-1h1.2c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.4a.4.4 0 110-.8h1.3c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.5a.5.5 0 110-1H6c.6 0 1 .4 1 1z" fill-rule="evenodd"/></svg>',
	    'orientation': '<svg width="24" height="24"><path d="M7.3 6.4L1 13l6.4 6.5 6.5-6.5-6.5-6.5zM3.7 13l3.6-3.7L11 13l-3.7 3.7-3.6-3.7zM12 6l2.8 2.7c.3.3.3.8 0 1-.3.4-.9.4-1.2 0L9.2 5.7a.8.8 0 010-1.2L13.6.2c.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.1L12 4h1a9 9 0 11-4.3 16.9l1.5-1.5A7 7 0 1013 6h-1z" fill-rule="nonzero"/></svg>',
	    'outdent': '<svg width="24" height="24"><path d="M7 5h12c.6 0 1 .4 1 1s-.4 1-1 1H7a1 1 0 110-2zm5 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm0 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm-5 4h12a1 1 0 010 2H7a1 1 0 010-2zm1.6-3.8a1 1 0 01-1.2 1.6l-3-2a1 1 0 010-1.6l3-2a1 1 0 011.2 1.6L6.8 12l1.8 1.2z" fill-rule="evenodd"/></svg>',
	    'page-break': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M5 11c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h1c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm4 0c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h1c.6 0 1 .4 1 1s-.4 1-1 1h-1a1 1 0 010-2zm4 0c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zM7 3v5h10V3c0-.6.4-1 1-1s1 .4 1 1v7H5V3c0-.6.4-1 1-1s1 .4 1 1zM6 22a1 1 0 01-1-1v-7h14v7c0 .6-.4 1-1 1a1 1 0 01-1-1v-5H7v5c0 .6-.4 1-1 1z"/></g></svg>',
	    'paragraph': '<svg width="24" height="24"><path fill-rule="evenodd" d="M10 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 016.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L10 5z"/></svg>',
	    'paste-column-after': '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V7h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h7v2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm8 7v12h-6V8h6zm-1.5 1.5h-3v9h3v-9zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
	    'paste-column-before': '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V18c0 1-.8 2-1.9 2H11v-2h7V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v2H4V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm-2 7v12H4V8h6zM8.5 9.5h-3v9h3v-9zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
	    'paste-row-after': '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V11h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h14c0 1-.8 2-1.9 2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm10 11v5H8v-5h14zm-1.5 1.5h-11v2h11v-2zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
	    'paste-row-before': '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V7h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h12v-4h2v4c0 1-.8 2-1.9 2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm10 7v5H8V8h14zm-1.5 1.5h-11v2h11v-2zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
	    'paste-text': '<svg width="24" height="24"><path d="M18 9V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h3V9h9zM9 20H6a2 2 0 01-2-2V5c0-1.1.9-2 2-2h3.2A3 3 0 0112 1a3 3 0 012.8 2H18a2 2 0 012 2v4h1v12H9v-1zm1.5-9.5v9h9v-9h-9zM12 3a1 1 0 00-1 1c0 .5.4 1 1 1s1-.5 1-1-.4-1-1-1zm0 9h6v2h-.5l-.5-1h-1v4h.8v1h-3.6v-1h.8v-4h-1l-.5 1H12v-2z" fill-rule="nonzero"/></svg>',
	    'paste': '<svg width="24" height="24"><path d="M18 9V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h3V9h9zM9 20H6a2 2 0 01-2-2V5c0-1.1.9-2 2-2h3.2A3 3 0 0112 1a3 3 0 012.8 2H18a2 2 0 012 2v4h1v12H9v-1zm1.5-9.5v9h9v-9h-9zM12 3a1 1 0 00-1 1c0 .5.4 1 1 1s1-.5 1-1-.4-1-1-1z" fill-rule="nonzero"/></svg>',
	    'permanent-pen': '<svg width="24" height="24"><path d="M10.5 17.5L8 20H3v-3l3.5-3.5a2 2 0 010-3L14 3l1 1-7.3 7.3a1 1 0 000 1.4l3.6 3.6c.4.4 1 .4 1.4 0L20 9l1 1-7.6 7.6a2 2 0 01-2.8 0l-.1-.1z" fill-rule="nonzero"/></svg>',
	    'plus': '<svg width="24" height="24"><path d="M12 4c.5 0 1 .4 1 .9V11h6a1 1 0 01.1 2H13v6a1 1 0 01-2 .1V13H5a1 1 0 01-.1-2H11V5c0-.6.4-1 1-1z"/></svg>',
	    'preferences': '<svg width="24" height="24"><path d="M20.1 13.5l-1.9.2a5.8 5.8 0 01-.6 1.5l1.2 1.5c.4.4.3 1 0 1.4l-.7.7a1 1 0 01-1.4 0l-1.5-1.2a6.2 6.2 0 01-1.5.6l-.2 1.9c0 .5-.5.9-1 .9h-1a1 1 0 01-1-.9l-.2-1.9a5.8 5.8 0 01-1.5-.6l-1.5 1.2a1 1 0 01-1.4 0l-.7-.7a1 1 0 010-1.4l1.2-1.5a6.2 6.2 0 01-.6-1.5l-1.9-.2a1 1 0 01-.9-1v-1c0-.5.4-1 .9-1l1.9-.2a5.8 5.8 0 01.6-1.5L5.2 7.3a1 1 0 010-1.4l.7-.7a1 1 0 011.4 0l1.5 1.2a6.2 6.2 0 011.5-.6l.2-1.9c0-.5.5-.9 1-.9h1c.5 0 1 .4 1 .9l.2 1.9a5.8 5.8 0 011.5.6l1.5-1.2a1 1 0 011.4 0l.7.7c.3.4.4 1 0 1.4l-1.2 1.5a6.2 6.2 0 01.6 1.5l1.9.2c.5 0 .9.5.9 1v1c0 .5-.4 1-.9 1zM12 15a3 3 0 100-6 3 3 0 000 6z" fill-rule="evenodd"/></svg>',
	    'preview': '<svg width="24" height="24"><path d="M3.5 12.5c.5.8 1.1 1.6 1.8 2.3 2 2 4.2 3.2 6.7 3.2s4.7-1.2 6.7-3.2a16.2 16.2 0 002.1-2.8 15.7 15.7 0 00-2.1-2.8c-2-2-4.2-3.2-6.7-3.2a9.3 9.3 0 00-6.7 3.2A16.2 16.2 0 003.2 12c0 .2.2.3.3.5zm-2.4-1l.7-1.2L4 7.8C6.2 5.4 8.9 4 12 4c3 0 5.8 1.4 8.1 3.8a18.2 18.2 0 012.8 3.7v1l-.7 1.2-2.1 2.5c-2.3 2.4-5 3.8-8.1 3.8-3 0-5.8-1.4-8.1-3.8a18.2 18.2 0 01-2.8-3.7 1 1 0 010-1zm12-3.3a2 2 0 102.7 2.6 4 4 0 11-2.6-2.6z" fill-rule="nonzero"/></svg>',
	    'print': '<svg width="24" height="24"><path d="M18 8H6a3 3 0 00-3 3v6h2v3h14v-3h2v-6a3 3 0 00-3-3zm-1 10H7v-4h10v4zm.5-5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm.5-8H6v2h12V5z" fill-rule="nonzero"/></svg>',
	    'quote': '<svg width="24" height="24"><path d="M7.5 17h.9c.4 0 .7-.2.9-.6L11 13V8c0-.6-.4-1-1-1H6a1 1 0 00-1 1v4c0 .6.4 1 1 1h2l-1.3 2.7a1 1 0 00.8 1.3zm8 0h.9c.4 0 .7-.2.9-.6L19 13V8c0-.6-.4-1-1-1h-4a1 1 0 00-1 1v4c0 .6.4 1 1 1h2l-1.3 2.7a1 1 0 00.8 1.3z" fill-rule="nonzero"/></svg>',
	    'redo': '<svg width="24" height="24"><path d="M17.6 10H12c-2.8 0-4.4 1.4-4.9 3.5-.4 2 .3 4 1.4 4.6a1 1 0 11-1 1.8c-2-1.2-2.9-4.1-2.3-6.8.6-3 3-5.1 6.8-5.1h5.6l-3.3-3.3a1 1 0 111.4-1.4l5 5a1 1 0 010 1.4l-5 5a1 1 0 01-1.4-1.4l3.3-3.3z" fill-rule="nonzero"/></svg>',
	    'reload': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M5 22.1l-1.2-4.7v-.2a1 1 0 011-1l5 .4a1 1 0 11-.2 2l-2.2-.2a7.8 7.8 0 008.4.2 7.5 7.5 0 003.5-6.4 1 1 0 112 0 9.5 9.5 0 01-4.5 8 9.9 9.9 0 01-10.2 0l.4 1.4a1 1 0 11-2 .5zM13.6 7.4c0-.5.5-1 1-.9l2.8.2a8 8 0 00-9.5-1 7.5 7.5 0 00-3.6 7 1 1 0 01-2 0 9.5 9.5 0 014.5-8.6 10 10 0 0110.9.3l-.3-1a1 1 0 012-.5l1.1 4.8a1 1 0 01-1 1.2l-5-.4a1 1 0 01-.9-1z"/></g></svg>',
	    'remove-formatting': '<svg width="24" height="24"><path d="M13.2 6a1 1 0 010 .2l-2.6 10a1 1 0 01-1 .8h-.2a.8.8 0 01-.8-1l2.6-10H8a1 1 0 110-2h9a1 1 0 010 2h-3.8zM5 18h7a1 1 0 010 2H5a1 1 0 010-2zm13 1.5L16.5 18 15 19.5a.7.7 0 01-1-1l1.5-1.5-1.5-1.5a.7.7 0 011-1l1.5 1.5 1.5-1.5a.7.7 0 011 1L17.5 17l1.5 1.5a.7.7 0 01-1 1z" fill-rule="evenodd"/></svg>',
	    'remove': '<svg width="24" height="24"><path d="M16 7h3a1 1 0 010 2h-1v9a3 3 0 01-3 3H9a3 3 0 01-3-3V9H5a1 1 0 110-2h3V6a3 3 0 013-3h2a3 3 0 013 3v1zm-2 0V6c0-.6-.4-1-1-1h-2a1 1 0 00-1 1v1h4zm2 2H8v9c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V9zm-7 3a1 1 0 012 0v4a1 1 0 01-2 0v-4zm4 0a1 1 0 012 0v4a1 1 0 01-2 0v-4z" fill-rule="nonzero"/></svg>',
	    'resize-handle': '<svg width="10" height="10"><g fill-rule="nonzero"><path d="M8.1 1.1A.5.5 0 119 2l-7 7A.5.5 0 111 8l7-7zM8.1 5.1A.5.5 0 119 6l-3 3A.5.5 0 115 8l3-3z"/></g></svg>',
	    'resize': '<svg width="24" height="24"><path d="M4 5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h6c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 01-.7.3H7.4L18 16.6V13c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7v6c0 .3-.1.5-.3.7a1 1 0 01-.7.3h-6a1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h3.6L6 7.4V11c0 .3-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.7-.3A1 1 0 014 11V5z" fill-rule="evenodd"/></svg>',
	    'restore-draft': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M17 13c0 .6-.4 1-1 1h-4V8c0-.6.4-1 1-1s1 .4 1 1v4h2c.6 0 1 .4 1 1z"/><path d="M4.7 10H9a1 1 0 010 2H3a1 1 0 01-1-1V5a1 1 0 112 0v3l2.5-2.4a9.2 9.2 0 0110.8-1.5A9 9 0 0113.4 21c-2.4.1-4.7-.7-6.5-2.2a1 1 0 111.3-1.5 7.2 7.2 0 0011.6-3.7 7 7 0 00-3.5-7.7A7.2 7.2 0 008 7L4.7 10z" fill-rule="nonzero"/></g></svg>',
	    'rotate-left': '<svg width="24" height="24"><path d="M4.7 10H9a1 1 0 010 2H3a1 1 0 01-1-1V5a1 1 0 112 0v3l2.5-2.4a9.2 9.2 0 0110.8-1.5A9 9 0 0113.4 21c-2.4.1-4.7-.7-6.5-2.2a1 1 0 111.3-1.5 7.2 7.2 0 0011.6-3.7 7 7 0 00-3.5-7.7A7.2 7.2 0 008 7L4.7 10z" fill-rule="nonzero"/></svg>',
	    'rotate-right': '<svg width="24" height="24"><path d="M20 8V5a1 1 0 012 0v6c0 .6-.4 1-1 1h-6a1 1 0 010-2h4.3L16 7A7.2 7.2 0 007.7 6a7 7 0 003 13.1c1.9.1 3.7-.5 5-1.7a1 1 0 011.4 1.5A9.2 9.2 0 012.2 14c-.9-3.9 1-8 4.5-9.9 3.5-1.9 8-1.3 10.8 1.5L20 8z" fill-rule="nonzero"/></svg>',
	    'rtl': '<svg width="24" height="24"><path d="M8 5h8v2h-2v12h-2V7h-2v12H8v-7c-.5 0-1 0-1.4-.3A3.4 3.4 0 014.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L8 5zm12 11.2a1 1 0 11-1 1.6l-3-2a1 1 0 010-1.6l3-2a1 1 0 111 1.6L18.4 15l1.8 1.2z" fill-rule="evenodd"/></svg>',
	    'save': '<svg width="24" height="24"><path d="M5 16h14a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2c0-1.1.9-2 2-2zm0 2v2h14v-2H5zm10 0h2v2h-2v-2zm-4-6.4L8.7 9.3a1 1 0 10-1.4 1.4l4 4c.4.4 1 .4 1.4 0l4-4a1 1 0 10-1.4-1.4L13 11.6V4a1 1 0 00-2 0v7.6z" fill-rule="nonzero"/></svg>',
	    'search': '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12z" fill-rule="nonzero"/></svg>',
	    'select-all': '<svg width="24" height="24"><path d="M3 5h2V3a2 2 0 00-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2a2 2 0 00-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8a2 2 0 002-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z" fill-rule="nonzero"/></svg>',
	    'selected': '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm3.6 10.9L7 12.3a.7.7 0 00-1 1L9.6 17 18 8.6a.7.7 0 000-1 .7.7 0 00-1 0l-7.4 7.3z"/></svg>',
	    'settings': '<svg width="24" height="24"><path d="M11 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8v.3c0 .2 0 .3-.2.5l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V8H5a1 1 0 110-2h2v-.3c0-.2 0-.3.2-.5l.5-.2h2.5c.3 0 .4 0 .6.2l.2.5V6zM8 8h2V6H8v2zm9 2.8v.2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v.3c0 .2 0 .3-.2.5l-.6.2h-2.4c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V13H5a1 1 0 010-2h8v-.3c0-.2 0-.3.2-.5l.6-.2h2.4c.3 0 .4 0 .6.2l.2.6zM14 13h2v-2h-2v2zm-3 2.8v.2h8c.6 0 1 .4 1 1s-.4 1-1 1h-8v.3c0 .2 0 .3-.2.5l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V18H5a1 1 0 010-2h2v-.3c0-.2 0-.3.2-.5l.5-.2h2.5c.3 0 .4 0 .6.2l.2.6zM8 18h2v-2H8v2z" fill-rule="evenodd"/></svg>',
	    'sharpen': '<svg width="24" height="24"><path d="M16 6l4 4-8 9-8-9 4-4h8zm-4 10.2l5.5-6.2-.1-.1H12v-.3h5.1l-.2-.2H12V9h4.6l-.2-.2H12v-.3h4.1l-.2-.2H12V8h3.6l-.2-.2H8.7L6.5 10l.1.1H12v.3H6.9l.2.2H12v.3H7.3l.2.2H12v.3H7.7l.3.2h4v.3H8.2l.2.2H12v.3H8.6l.3.2H12v.3H9l.3.2H12v.3H9.5l.2.2H12v.3h-2l.2.2H12v.3h-1.6l.2.2H12v.3h-1.1l.2.2h.9v.3h-.7l.2.2h.5v.3h-.3l.3.2z" fill-rule="evenodd"/></svg>',
	    'sourcecode': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M9.8 15.7c.3.3.3.8 0 1-.3.4-.9.4-1.2 0l-4.4-4.1a.8.8 0 010-1.2l4.4-4.2c.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.1L6 12l3.8 3.7zM14.2 15.7c-.3.3-.3.8 0 1 .4.4.9.4 1.2 0l4.4-4.1c.3-.3.3-.9 0-1.2l-4.4-4.2a.8.8 0 00-1.2 0c-.3.3-.3.8 0 1.1L18 12l-3.8 3.7z"/></g></svg>',
	    'spell-check': '<svg width="24" height="24"><path d="M6 8v3H5V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h2c.3 0 .5.1.7.3.2.2.3.4.3.7v6H8V8H6zm0-3v2h2V5H6zm13 0h-3v5h3v1h-3a1 1 0 01-.7-.3 1 1 0 01-.3-.7V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h3v1zm-5 1.5l-.1.7c-.1.2-.3.3-.6.3.3 0 .5.1.6.3l.1.7V10c0 .3-.1.5-.3.7a1 1 0 01-.7.3h-3V4h3c.3 0 .5.1.7.3.2.2.3.4.3.7v1.5zM13 10V8h-2v2h2zm0-3V5h-2v2h2zm3 5l1 1-6.5 7L7 15.5l1.3-1 2.2 2.2L16 12z" fill-rule="evenodd"/></svg>',
	    'strike-through': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M15.6 8.5c-.5-.7-1-1.1-1.3-1.3-.6-.4-1.3-.6-2-.6-2.7 0-2.8 1.7-2.8 2.1 0 1.6 1.8 2 3.2 2.3 4.4.9 4.6 2.8 4.6 3.9 0 1.4-.7 4.1-5 4.1A6.2 6.2 0 017 16.4l1.5-1.1c.4.6 1.6 2 3.7 2 1.6 0 2.5-.4 3-1.2.4-.8.3-2-.8-2.6-.7-.4-1.6-.7-2.9-1-1-.2-3.9-.8-3.9-3.6C7.6 6 10.3 5 12.4 5c2.9 0 4.2 1.6 4.7 2.4l-1.5 1.1z"/><path d="M5 11h14a1 1 0 010 2H5a1 1 0 010-2z" fill-rule="nonzero"/></g></svg>',
	    'subscript': '<svg width="24" height="24"><path d="M10.4 10l4.6 4.6-1.4 1.4L9 11.4 4.4 16 3 14.6 7.6 10 3 5.4 4.4 4 9 8.6 13.6 4 15 5.4 10.4 10zM21 19h-5v-1l1-.8 1.7-1.6c.3-.4.5-.8.5-1.2 0-.3 0-.6-.2-.7-.2-.2-.5-.3-.9-.3a2 2 0 00-.8.2l-.7.3-.4-1.1 1-.6 1.2-.2c.8 0 1.4.3 1.8.7.4.4.6.9.6 1.5s-.2 1.1-.5 1.6a8 8 0 01-1.3 1.3l-.6.6h2.6V19z" fill-rule="nonzero"/></svg>',
	    'superscript': '<svg width="24" height="24"><path d="M15 9.4L10.4 14l4.6 4.6-1.4 1.4L9 15.4 4.4 20 3 18.6 7.6 14 3 9.4 4.4 8 9 12.6 13.6 8 15 9.4zm5.9 1.6h-5v-1l1-.8 1.7-1.6c.3-.5.5-.9.5-1.3 0-.3 0-.5-.2-.7-.2-.2-.5-.3-.9-.3l-.8.2-.7.4-.4-1.2c.2-.2.5-.4 1-.5.3-.2.8-.2 1.2-.2.8 0 1.4.2 1.8.6.4.4.6 1 .6 1.6 0 .5-.2 1-.5 1.5l-1.3 1.4-.6.5h2.6V11z" fill-rule="nonzero"/></svg>',
	    'table-caption': '<svg width="24" height="24"><g fill-rule="nonzero"><rect width="12" height="2" x="3" y="4" rx="1"/><path d="M19 8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2v-8c0-1.1.9-2 2-2h14zM5 15v3h6v-3H5zm14 0h-6v3h6v-3zm0-5h-6v3h6v-3zM5 13h6v-3H5v3z"/></g></svg>',
	    'table-cell-classes': '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M13 4v9H3V6c0-1.1.9-2 2-2h8zm-2 2H5v5h6V6z"/><path fill-rule="nonzero" d="M13 4h6a2 2 0 012 2v7h-8v-2h6V6h-6V4z" opacity=".2"/><path d="M18 20l-2.6 1.6.7-3-2.4-2 3.1-.2 1.2-2.9 1.2 2.9 3 .2-2.3 2 .7 3z"/><path fill-rule="nonzero" d="M3 13v5c0 1.1.9 2 2 2h8v-7h-2v5H5v-5H3z" opacity=".2"/></g></svg>',
	    'table-cell-properties': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 9H5v5h6v-5zm8 0h-6v5h6v-5zm-8-7H5v5h6V6z"/></svg>',
	    'table-cell-select-all': '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v12h14V6z"/><path d="M13 6v5h6v2h-6v5h-2v-5H5v-2h6V6h2z" opacity=".2"/></g></svg>',
	    'table-cell-select-inner': '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v12h14V6z" opacity=".2"/><path d="M13 6v5h6v2h-6v5h-2v-5H5v-2h6V6h2z"/></g></svg>',
	    'table-classes': '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v7h-8v7H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 9H5v5h6v-5zm8-7h-6v5h6V6zm-8 0H5v5h6V6z"/><path d="M18 20l-2.6 1.6.7-3-2.4-2 3.1-.2 1.2-2.9 1.2 2.9 3 .2-2.3 2 .7 3z"/></g></svg>',
	    'table-delete-column': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-4 4h-2V6h-2v2H9V6H5v12h4v-2h2v2h2v-2h2v2h4V6h-4v2zm.3.5l1 1.2-3 2.3 3 2.3-1 1.2L12 13l-3.3 2.6-1-1.2 3-2.3-3-2.3 1-1.2L12 11l3.3-2.5z"/></svg>',
	    'table-delete-row': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v3h2.5v2H5v2h2.5v2H5v3h14v-3h-2.5v-2H19v-2h-2.5V9H19V6zm-4.7 1.8l1.2 1L13 12l2.6 3.3-1.2 1-2.3-3-2.3 3-1.2-1L11 12 8.5 8.7l1.2-1 2.3 3 2.3-3z"/></svg>',
	    'table-delete-table': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 6v12h14V6H5z"/><path d="M14.4 8.6l1 1-2.3 2.4 2.3 2.4-1 1-2.4-2.3-2.4 2.3-1-1 2.3-2.4-2.3-2.4 1-1 2.4 2.3z"/></g></svg>',
	    'table-insert-column-after': '<svg width="24" height="24"><path fill-rule="nonzero" d="M20 4c.6 0 1 .4 1 1v2a1 1 0 01-2 0V6h-8v12h8v-1a1 1 0 012 0v2c0 .5-.4 1-.9 1H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h15zM9 13H5v5h4v-5zm7-5c.5 0 1 .4 1 .9V11h2a1 1 0 01.1 2H17v2a1 1 0 01-2 .1V13h-2a1 1 0 01-.1-2H15V9c0-.6.4-1 1-1zM9 6H5v5h4V6z"/></svg>',
	    'table-insert-column-before': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H4a1 1 0 01-1-1v-2a1 1 0 012 0v1h8V6H5v1a1 1 0 11-2 0V5c0-.6.4-1 1-1h15zm0 9h-4v5h4v-5zM8 8c.5 0 1 .4 1 .9V11h2a1 1 0 01.1 2H9v2a1 1 0 01-2 .1V13H5a1 1 0 01-.1-2H7V9c0-.6.4-1 1-1zm11-2h-4v5h4V6z"/></svg>',
	    'table-insert-row-above': '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4a1 1 0 110 2H5v6h14V6h-1a1 1 0 010-2h2c.6 0 1 .4 1 1v13a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-.6.4-1 1-1h2zm5 10H5v4h6v-4zm8 0h-6v4h6v-4zM12 3c.5 0 1 .4 1 .9V6h2a1 1 0 010 2h-2v2a1 1 0 01-2 .1V8H9a1 1 0 010-2h2V4c0-.6.4-1 1-1z"/></svg>',
	    'table-insert-row-after': '<svg width="24" height="24"><path fill-rule="nonzero" d="M12 13c.5 0 1 .4 1 .9V16h2a1 1 0 01.1 2H13v2a1 1 0 01-2 .1V18H9a1 1 0 01-.1-2H11v-2c0-.6.4-1 1-1zm6 7a1 1 0 010-2h1v-6H5v6h1a1 1 0 010 2H4a1 1 0 01-1-1V6c0-1.1.9-2 2-2h14a2 2 0 012 2v13c0 .5-.4 1-.9 1H18zM11 6H5v4h6V6zm8 0h-6v4h6V6z"/></svg>',
	    'table-left-header': '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 9h-4v5h4v-5zm-6 0H9v5h4v-5zm0-7H9v5h4V6zm6 0h-4v5h4V6z"/></svg>',
	    'table-merge-cells': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 15.5V18h3v-2.5H5zm14-5h-9V18h9v-7.5zM19 6h-4v2.5h4V6zM8 6H5v2.5h3V6zm5 0h-3v2.5h3V6zm-8 7.5h3v-3H5v3z"/></svg>',
	    'table-row-numbering-rtl': '<svg width="24" height="24"><path d="M6 4a2 2 0 00-2 2v13c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H6zm0 12h8v3H6v-3zm11 0c.6 0 1 .4 1 1v1a1 1 0 01-2 0v-1c0-.6.4-1 1-1zM6 11h8v3H6v-3zm11 0c.6 0 1 .4 1 1v1a1 1 0 01-2 0v-1c0-.6.4-1 1-1zM6 6h8v3H6V6zm11 0c.6 0 1 .4 1 1v1a1 1 0 11-2 0V7c0-.6.4-1 1-1z"/></svg>',
	    'table-row-numbering': '<svg width="24" height="24"><path d="M18 4a2 2 0 012 2v13a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12zm0 12h-8v3h8v-3zM7 16a1 1 0 00-1 1v1a1 1 0 002 0v-1c0-.6-.4-1-1-1zm11-5h-8v3h8v-3zM7 11a1 1 0 00-1 1v1a1 1 0 002 0v-1c0-.6-.4-1-1-1zm11-5h-8v3h8V6zM7 6a1 1 0 00-1 1v1a1 1 0 102 0V7c0-.6-.4-1-1-1z"/></svg>',
	    'table-row-properties': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 15v3h6v-3H5zm14 0h-6v3h6v-3zm0-9h-6v3h6V6zM5 9h6V6H5v3z"/></svg>',
	    'table-split-cells': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM8 15.5H5V18h3v-2.5zm11-5h-9V18h9v-7.5zm-2.5 1l1 1-2 2 2 2-1 1-2-2-2 2-1-1 2-2-2-2 1-1 2 2 2-2zm-8.5-1H5v3h3v-3zM19 6h-4v2.5h4V6zM8 6H5v2.5h3V6zm5 0h-3v2.5h3V6z"/></svg>',
	    'table-top-header': '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 11H5v3h6v-3zm8 0h-6v3h6v-3zm0-5h-6v3h6v-3zM5 13h6v-3H5v3z"/></svg>',
	    'table': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 14v4h6v-4H5zm14 0h-6v4h6v-4zm0-6h-6v4h6V8zM5 12h6V8H5v4z"/></svg>',
	    'template': '<svg width="24" height="24"><path d="M19 19v-1H5v1h14zM9 16v-4a5 5 0 116 0v4h4a2 2 0 012 2v3H3v-3c0-1.1.9-2 2-2h4zm4 0v-5l.8-.6a3 3 0 10-3.6 0l.8.6v5h2z" fill-rule="nonzero"/></svg>',
	    'temporary-placeholder': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M9 7.6V6h2.5V4.5a.5.5 0 111 0V6H15v1.6a8 8 0 11-6 0zm-2.6 5.3a.5.5 0 00.3.6c.3 0 .6 0 .6-.3l.1-.2a5 5 0 013.3-2.8c.3-.1.4-.4.4-.6-.1-.3-.4-.5-.6-.4a6 6 0 00-4.1 3.7z"/><circle cx="14" cy="4" r="1"/><circle cx="12" cy="2" r="1"/><circle cx="10" cy="4" r="1"/></g></svg>',
	    'text-color': '<svg width="24" height="24"><g fill-rule="evenodd"><path id="tox-icon-text-color__color" d="M3 18h18v3H3z"/><path d="M8.7 16h-.8a.5.5 0 01-.5-.6l2.7-9c.1-.3.3-.4.5-.4h2.8c.2 0 .4.1.5.4l2.7 9a.5.5 0 01-.5.6h-.8a.5.5 0 01-.4-.4l-.7-2.2c0-.3-.3-.4-.5-.4h-3.4c-.2 0-.4.1-.5.4l-.7 2.2c0 .3-.2.4-.4.4zm2.6-7.6l-.6 2a.5.5 0 00.5.6h1.6a.5.5 0 00.5-.6l-.6-2c0-.3-.3-.4-.5-.4h-.4c-.2 0-.4.1-.5.4z"/></g></svg>',
	    'toc': '<svg width="24" height="24"><path d="M5 5c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 110-2zm3 0h11c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 110-2zm-3 8c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h11c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm0-4c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 110-2zm3 0h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm-3 8c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'translate': '<svg width="24" height="24"><path d="M12.7 14.3l-.3.7-.4.7-2.2-2.2-3.1 3c-.3.4-.8.4-1 0a.7.7 0 010-1l3.1-3A12.4 12.4 0 016.7 9H8a10.1 10.1 0 001.7 2.4c.5-.5 1-1.1 1.4-1.8l.9-2H4.7a.7.7 0 110-1.5h4.4v-.7c0-.4.3-.8.7-.8.4 0 .7.4.7.8v.7H15c.4 0 .8.3.8.7 0 .4-.4.8-.8.8h-1.4a12.3 12.3 0 01-1 2.4 13.5 13.5 0 01-1.7 2.3l1.9 1.8zm4.3-3l2.7 7.3a.5.5 0 01-.4.7 1 1 0 01-1-.7l-.6-1.5h-3.4l-.6 1.5a1 1 0 01-1 .7.5.5 0 01-.4-.7l2.7-7.4a1 1 0 012 0zm-2.2 4.4h2.4L16 12.5l-1.2 3.2z" fill-rule="evenodd"/></svg>',
	    'underline': '<svg width="24" height="24"><path d="M16 5c.6 0 1 .4 1 1v5.5a4 4 0 01-.4 1.8l-1 1.4a5.3 5.3 0 01-5.5 1 5 5 0 01-1.6-1c-.5-.4-.8-.9-1.1-1.4a4 4 0 01-.4-1.8V6c0-.6.4-1 1-1s1 .4 1 1v5.5c0 .3 0 .6.2 1l.6.7a3.3 3.3 0 002.2.8 3.4 3.4 0 002.2-.8c.3-.2.4-.5.6-.8l.2-.9V6c0-.6.4-1 1-1zM8 17h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'undo': '<svg width="24" height="24"><path d="M6.4 8H12c3.7 0 6.2 2 6.8 5.1.6 2.7-.4 5.6-2.3 6.8a1 1 0 01-1-1.8c1.1-.6 1.8-2.7 1.4-4.6-.5-2.1-2.1-3.5-4.9-3.5H6.4l3.3 3.3a1 1 0 11-1.4 1.4l-5-5a1 1 0 010-1.4l5-5a1 1 0 011.4 1.4L6.4 8z" fill-rule="nonzero"/></svg>',
	    'unlink': '<svg width="24" height="24"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2 2a2 2 0 102.6 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2.1-2a2 2 0 10-2.7-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2zM7.6 6.3a.8.8 0 01-1 1.1L3.3 4.2a.7.7 0 111-1l3.2 3.1zM5.1 8.6a.8.8 0 010 1.5H3a.8.8 0 010-1.5H5zm5-3.5a.8.8 0 01-1.5 0V3a.8.8 0 011.5 0V5zm6 11.8a.8.8 0 011-1l3.2 3.2a.8.8 0 01-1 1L16 17zm-2.2 2a.8.8 0 011.5 0V21a.8.8 0 01-1.5 0V19zm5-3.5a.7.7 0 110-1.5H21a.8.8 0 010 1.5H19z" fill-rule="nonzero"/></svg>',
	    'unlock': '<svg width="24" height="24"><path d="M16 5c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v3h-2V8a1 1 0 00-.3-.7A1 1 0 0016 7h-2a1 1 0 00-.7.3 1 1 0 00-.3.7v3h.3c.2 0 .3 0 .5.2l.2.6v7.4c0 .3 0 .4-.2.6l-.6.2H4.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6v-7.4c0-.3 0-.4.2-.6l.5-.2H11V8c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h2z" fill-rule="evenodd"/></svg>',
	    'unordered-list': '<svg width="24" height="24"><path d="M11 5h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zM4.5 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1z" fill-rule="evenodd"/></svg>',
	    'unselected': '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm0 1a1 1 0 00-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H6z"/></svg>',
	    'upload': '<svg width="24" height="24"><path d="M18 19v-2a1 1 0 012 0v3c0 .6-.4 1-1 1H5a1 1 0 01-1-1v-3a1 1 0 012 0v2h12zM11 6.4L8.7 8.7a1 1 0 01-1.4-1.4l4-4a1 1 0 011.4 0l4 4a1 1 0 11-1.4 1.4L13 6.4V16a1 1 0 01-2 0V6.4z" fill-rule="nonzero"/></svg>',
	    'user': '<svg width="24" height="24"><path d="M12 24a12 12 0 110-24 12 12 0 010 24zm-8.7-5.3a11 11 0 0017.4 0C19.4 16.3 14.6 15 12 15c-2.6 0-7.4 1.3-8.7 3.7zM12 13c2.2 0 4-2 4-4.5S14.2 4 12 4 8 6 8 8.5 9.8 13 12 13z" fill-rule="nonzero"/></svg>',
	    'vertical-align': '<svg width="24" height="24"><g fill-rule="nonzero"><rect width="18" height="2" x="3" y="11" rx="1"/><path d="M12 2c.6 0 1 .4 1 1v4l2-1.3a1 1 0 011.2 1.5l-.1.1-4.1 3-4-3a1 1 0 011-1.7l2 1.5V3c0-.6.4-1 1-1zm0 11.8l4 2.9a1 1 0 01-1 1.7l-2-1.5V21c0 .5-.4 1-.9 1H12a1 1 0 01-1-1v-4l-2 1.3a1 1 0 01-1.2-.1l-.1-.1a1 1 0 01.1-1.3l.1-.1 4.1-3z"/></g></svg>',
	    'visualblocks': '<svg width="24" height="24"><path d="M9 19v2H7v-2h2zm-4 0v2a2 2 0 01-2-2h2zm8 0v2h-2v-2h2zm8 0a2 2 0 01-2 2v-2h2zm-4 0v2h-2v-2h2zM15 7a1 1 0 010 2v7a1 1 0 01-2 0V9h-1v7a1 1 0 01-2 0v-4a2.5 2.5 0 01-.2-5H15zM5 15v2H3v-2h2zm16 0v2h-2v-2h2zM5 11v2H3v-2h2zm16 0v2h-2v-2h2zM5 7v2H3V7h2zm16 0v2h-2V7h2zM5 3v2H3c0-1.1.9-2 2-2zm8 0v2h-2V3h2zm6 0a2 2 0 012 2h-2V3zM9 3v2H7V3h2zm8 0v2h-2V3h2z" fill-rule="evenodd"/></svg>',
	    'visualchars': '<svg width="24" height="24"><path d="M10 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 016.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L10 5z" fill-rule="evenodd"/></svg>',
	    'warning': '<svg width="24" height="24"><path d="M19.8 18.3c.2.5.3.9 0 1.2-.1.3-.5.5-1 .5H5.2c-.5 0-.9-.2-1-.5-.3-.3-.2-.7 0-1.2L11 4.7l.5-.5.5-.2c.2 0 .3 0 .5.2.2 0 .3.3.5.5l6.8 13.6zM12 18c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7a1 1 0 00-.3-.7 1 1 0 00-.7-.3 1 1 0 00-.7.3 1 1 0 00-.3.7c0 .3.1.5.3.7.2.2.4.3.7.3zm.7-3l.3-4a1 1 0 00-.3-.7 1 1 0 00-.7-.3 1 1 0 00-.7.3 1 1 0 00-.3.7l.3 4h1.4z" fill-rule="evenodd"/></svg>',
	    'zoom-in': '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12zm-1-9a1 1 0 012 0v6a1 1 0 01-2 0V8zm-2 4a1 1 0 010-2h6a1 1 0 010 2H8z" fill-rule="nonzero"/></svg>',
	    'zoom-out': '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12zm-3-5a1 1 0 010-2h6a1 1 0 010 2H8z" fill-rule="nonzero"/></svg>',
	  }
	});

/***/ }),
/* 2247 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var fireInsertCustomChar = function (editor, chr) {
	      return editor.fire('insertCustomChar', { chr: chr });
	    };
	
	    var insertChar = function (editor, chr) {
	      var evtChr = fireInsertCustomChar(editor, chr).chr;
	      editor.execCommand('mceInsertContent', false, evtChr);
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var eq = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isArray$1 = isType('array');
	    var isNull = eq(null);
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray$1(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getCharMap$1 = function (editor) {
	      return editor.getParam('charmap');
	    };
	    var getCharMapAppend = function (editor) {
	      return editor.getParam('charmap_append');
	    };
	
	    var isArray = global$1.isArray;
	    var UserDefined = 'User Defined';
	    var getDefaultCharMap = function () {
	      return [
	        {
	          name: 'Currency',
	          characters: [
	            [
	              36,
	              'dollar sign'
	            ],
	            [
	              162,
	              'cent sign'
	            ],
	            [
	              8364,
	              'euro sign'
	            ],
	            [
	              163,
	              'pound sign'
	            ],
	            [
	              165,
	              'yen sign'
	            ],
	            [
	              164,
	              'currency sign'
	            ],
	            [
	              8352,
	              'euro-currency sign'
	            ],
	            [
	              8353,
	              'colon sign'
	            ],
	            [
	              8354,
	              'cruzeiro sign'
	            ],
	            [
	              8355,
	              'french franc sign'
	            ],
	            [
	              8356,
	              'lira sign'
	            ],
	            [
	              8357,
	              'mill sign'
	            ],
	            [
	              8358,
	              'naira sign'
	            ],
	            [
	              8359,
	              'peseta sign'
	            ],
	            [
	              8360,
	              'rupee sign'
	            ],
	            [
	              8361,
	              'won sign'
	            ],
	            [
	              8362,
	              'new sheqel sign'
	            ],
	            [
	              8363,
	              'dong sign'
	            ],
	            [
	              8365,
	              'kip sign'
	            ],
	            [
	              8366,
	              'tugrik sign'
	            ],
	            [
	              8367,
	              'drachma sign'
	            ],
	            [
	              8368,
	              'german penny symbol'
	            ],
	            [
	              8369,
	              'peso sign'
	            ],
	            [
	              8370,
	              'guarani sign'
	            ],
	            [
	              8371,
	              'austral sign'
	            ],
	            [
	              8372,
	              'hryvnia sign'
	            ],
	            [
	              8373,
	              'cedi sign'
	            ],
	            [
	              8374,
	              'livre tournois sign'
	            ],
	            [
	              8375,
	              'spesmilo sign'
	            ],
	            [
	              8376,
	              'tenge sign'
	            ],
	            [
	              8377,
	              'indian rupee sign'
	            ],
	            [
	              8378,
	              'turkish lira sign'
	            ],
	            [
	              8379,
	              'nordic mark sign'
	            ],
	            [
	              8380,
	              'manat sign'
	            ],
	            [
	              8381,
	              'ruble sign'
	            ],
	            [
	              20870,
	              'yen character'
	            ],
	            [
	              20803,
	              'yuan character'
	            ],
	            [
	              22291,
	              'yuan character, in hong kong and taiwan'
	            ],
	            [
	              22278,
	              'yen/yuan character variant one'
	            ]
	          ]
	        },
	        {
	          name: 'Text',
	          characters: [
	            [
	              169,
	              'copyright sign'
	            ],
	            [
	              174,
	              'registered sign'
	            ],
	            [
	              8482,
	              'trade mark sign'
	            ],
	            [
	              8240,
	              'per mille sign'
	            ],
	            [
	              181,
	              'micro sign'
	            ],
	            [
	              183,
	              'middle dot'
	            ],
	            [
	              8226,
	              'bullet'
	            ],
	            [
	              8230,
	              'three dot leader'
	            ],
	            [
	              8242,
	              'minutes / feet'
	            ],
	            [
	              8243,
	              'seconds / inches'
	            ],
	            [
	              167,
	              'section sign'
	            ],
	            [
	              182,
	              'paragraph sign'
	            ],
	            [
	              223,
	              'sharp s / ess-zed'
	            ]
	          ]
	        },
	        {
	          name: 'Quotations',
	          characters: [
	            [
	              8249,
	              'single left-pointing angle quotation mark'
	            ],
	            [
	              8250,
	              'single right-pointing angle quotation mark'
	            ],
	            [
	              171,
	              'left pointing guillemet'
	            ],
	            [
	              187,
	              'right pointing guillemet'
	            ],
	            [
	              8216,
	              'left single quotation mark'
	            ],
	            [
	              8217,
	              'right single quotation mark'
	            ],
	            [
	              8220,
	              'left double quotation mark'
	            ],
	            [
	              8221,
	              'right double quotation mark'
	            ],
	            [
	              8218,
	              'single low-9 quotation mark'
	            ],
	            [
	              8222,
	              'double low-9 quotation mark'
	            ],
	            [
	              60,
	              'less-than sign'
	            ],
	            [
	              62,
	              'greater-than sign'
	            ],
	            [
	              8804,
	              'less-than or equal to'
	            ],
	            [
	              8805,
	              'greater-than or equal to'
	            ],
	            [
	              8211,
	              'en dash'
	            ],
	            [
	              8212,
	              'em dash'
	            ],
	            [
	              175,
	              'macron'
	            ],
	            [
	              8254,
	              'overline'
	            ],
	            [
	              164,
	              'currency sign'
	            ],
	            [
	              166,
	              'broken bar'
	            ],
	            [
	              168,
	              'diaeresis'
	            ],
	            [
	              161,
	              'inverted exclamation mark'
	            ],
	            [
	              191,
	              'turned question mark'
	            ],
	            [
	              710,
	              'circumflex accent'
	            ],
	            [
	              732,
	              'small tilde'
	            ],
	            [
	              176,
	              'degree sign'
	            ],
	            [
	              8722,
	              'minus sign'
	            ],
	            [
	              177,
	              'plus-minus sign'
	            ],
	            [
	              247,
	              'division sign'
	            ],
	            [
	              8260,
	              'fraction slash'
	            ],
	            [
	              215,
	              'multiplication sign'
	            ],
	            [
	              185,
	              'superscript one'
	            ],
	            [
	              178,
	              'superscript two'
	            ],
	            [
	              179,
	              'superscript three'
	            ],
	            [
	              188,
	              'fraction one quarter'
	            ],
	            [
	              189,
	              'fraction one half'
	            ],
	            [
	              190,
	              'fraction three quarters'
	            ]
	          ]
	        },
	        {
	          name: 'Mathematical',
	          characters: [
	            [
	              402,
	              'function / florin'
	            ],
	            [
	              8747,
	              'integral'
	            ],
	            [
	              8721,
	              'n-ary sumation'
	            ],
	            [
	              8734,
	              'infinity'
	            ],
	            [
	              8730,
	              'square root'
	            ],
	            [
	              8764,
	              'similar to'
	            ],
	            [
	              8773,
	              'approximately equal to'
	            ],
	            [
	              8776,
	              'almost equal to'
	            ],
	            [
	              8800,
	              'not equal to'
	            ],
	            [
	              8801,
	              'identical to'
	            ],
	            [
	              8712,
	              'element of'
	            ],
	            [
	              8713,
	              'not an element of'
	            ],
	            [
	              8715,
	              'contains as member'
	            ],
	            [
	              8719,
	              'n-ary product'
	            ],
	            [
	              8743,
	              'logical and'
	            ],
	            [
	              8744,
	              'logical or'
	            ],
	            [
	              172,
	              'not sign'
	            ],
	            [
	              8745,
	              'intersection'
	            ],
	            [
	              8746,
	              'union'
	            ],
	            [
	              8706,
	              'partial differential'
	            ],
	            [
	              8704,
	              'for all'
	            ],
	            [
	              8707,
	              'there exists'
	            ],
	            [
	              8709,
	              'diameter'
	            ],
	            [
	              8711,
	              'backward difference'
	            ],
	            [
	              8727,
	              'asterisk operator'
	            ],
	            [
	              8733,
	              'proportional to'
	            ],
	            [
	              8736,
	              'angle'
	            ]
	          ]
	        },
	        {
	          name: 'Extended Latin',
	          characters: [
	            [
	              192,
	              'A - grave'
	            ],
	            [
	              193,
	              'A - acute'
	            ],
	            [
	              194,
	              'A - circumflex'
	            ],
	            [
	              195,
	              'A - tilde'
	            ],
	            [
	              196,
	              'A - diaeresis'
	            ],
	            [
	              197,
	              'A - ring above'
	            ],
	            [
	              256,
	              'A - macron'
	            ],
	            [
	              198,
	              'ligature AE'
	            ],
	            [
	              199,
	              'C - cedilla'
	            ],
	            [
	              200,
	              'E - grave'
	            ],
	            [
	              201,
	              'E - acute'
	            ],
	            [
	              202,
	              'E - circumflex'
	            ],
	            [
	              203,
	              'E - diaeresis'
	            ],
	            [
	              274,
	              'E - macron'
	            ],
	            [
	              204,
	              'I - grave'
	            ],
	            [
	              205,
	              'I - acute'
	            ],
	            [
	              206,
	              'I - circumflex'
	            ],
	            [
	              207,
	              'I - diaeresis'
	            ],
	            [
	              298,
	              'I - macron'
	            ],
	            [
	              208,
	              'ETH'
	            ],
	            [
	              209,
	              'N - tilde'
	            ],
	            [
	              210,
	              'O - grave'
	            ],
	            [
	              211,
	              'O - acute'
	            ],
	            [
	              212,
	              'O - circumflex'
	            ],
	            [
	              213,
	              'O - tilde'
	            ],
	            [
	              214,
	              'O - diaeresis'
	            ],
	            [
	              216,
	              'O - slash'
	            ],
	            [
	              332,
	              'O - macron'
	            ],
	            [
	              338,
	              'ligature OE'
	            ],
	            [
	              352,
	              'S - caron'
	            ],
	            [
	              217,
	              'U - grave'
	            ],
	            [
	              218,
	              'U - acute'
	            ],
	            [
	              219,
	              'U - circumflex'
	            ],
	            [
	              220,
	              'U - diaeresis'
	            ],
	            [
	              362,
	              'U - macron'
	            ],
	            [
	              221,
	              'Y - acute'
	            ],
	            [
	              376,
	              'Y - diaeresis'
	            ],
	            [
	              562,
	              'Y - macron'
	            ],
	            [
	              222,
	              'THORN'
	            ],
	            [
	              224,
	              'a - grave'
	            ],
	            [
	              225,
	              'a - acute'
	            ],
	            [
	              226,
	              'a - circumflex'
	            ],
	            [
	              227,
	              'a - tilde'
	            ],
	            [
	              228,
	              'a - diaeresis'
	            ],
	            [
	              229,
	              'a - ring above'
	            ],
	            [
	              257,
	              'a - macron'
	            ],
	            [
	              230,
	              'ligature ae'
	            ],
	            [
	              231,
	              'c - cedilla'
	            ],
	            [
	              232,
	              'e - grave'
	            ],
	            [
	              233,
	              'e - acute'
	            ],
	            [
	              234,
	              'e - circumflex'
	            ],
	            [
	              235,
	              'e - diaeresis'
	            ],
	            [
	              275,
	              'e - macron'
	            ],
	            [
	              236,
	              'i - grave'
	            ],
	            [
	              237,
	              'i - acute'
	            ],
	            [
	              238,
	              'i - circumflex'
	            ],
	            [
	              239,
	              'i - diaeresis'
	            ],
	            [
	              299,
	              'i - macron'
	            ],
	            [
	              240,
	              'eth'
	            ],
	            [
	              241,
	              'n - tilde'
	            ],
	            [
	              242,
	              'o - grave'
	            ],
	            [
	              243,
	              'o - acute'
	            ],
	            [
	              244,
	              'o - circumflex'
	            ],
	            [
	              245,
	              'o - tilde'
	            ],
	            [
	              246,
	              'o - diaeresis'
	            ],
	            [
	              248,
	              'o slash'
	            ],
	            [
	              333,
	              'o macron'
	            ],
	            [
	              339,
	              'ligature oe'
	            ],
	            [
	              353,
	              's - caron'
	            ],
	            [
	              249,
	              'u - grave'
	            ],
	            [
	              250,
	              'u - acute'
	            ],
	            [
	              251,
	              'u - circumflex'
	            ],
	            [
	              252,
	              'u - diaeresis'
	            ],
	            [
	              363,
	              'u - macron'
	            ],
	            [
	              253,
	              'y - acute'
	            ],
	            [
	              254,
	              'thorn'
	            ],
	            [
	              255,
	              'y - diaeresis'
	            ],
	            [
	              563,
	              'y - macron'
	            ],
	            [
	              913,
	              'Alpha'
	            ],
	            [
	              914,
	              'Beta'
	            ],
	            [
	              915,
	              'Gamma'
	            ],
	            [
	              916,
	              'Delta'
	            ],
	            [
	              917,
	              'Epsilon'
	            ],
	            [
	              918,
	              'Zeta'
	            ],
	            [
	              919,
	              'Eta'
	            ],
	            [
	              920,
	              'Theta'
	            ],
	            [
	              921,
	              'Iota'
	            ],
	            [
	              922,
	              'Kappa'
	            ],
	            [
	              923,
	              'Lambda'
	            ],
	            [
	              924,
	              'Mu'
	            ],
	            [
	              925,
	              'Nu'
	            ],
	            [
	              926,
	              'Xi'
	            ],
	            [
	              927,
	              'Omicron'
	            ],
	            [
	              928,
	              'Pi'
	            ],
	            [
	              929,
	              'Rho'
	            ],
	            [
	              931,
	              'Sigma'
	            ],
	            [
	              932,
	              'Tau'
	            ],
	            [
	              933,
	              'Upsilon'
	            ],
	            [
	              934,
	              'Phi'
	            ],
	            [
	              935,
	              'Chi'
	            ],
	            [
	              936,
	              'Psi'
	            ],
	            [
	              937,
	              'Omega'
	            ],
	            [
	              945,
	              'alpha'
	            ],
	            [
	              946,
	              'beta'
	            ],
	            [
	              947,
	              'gamma'
	            ],
	            [
	              948,
	              'delta'
	            ],
	            [
	              949,
	              'epsilon'
	            ],
	            [
	              950,
	              'zeta'
	            ],
	            [
	              951,
	              'eta'
	            ],
	            [
	              952,
	              'theta'
	            ],
	            [
	              953,
	              'iota'
	            ],
	            [
	              954,
	              'kappa'
	            ],
	            [
	              955,
	              'lambda'
	            ],
	            [
	              956,
	              'mu'
	            ],
	            [
	              957,
	              'nu'
	            ],
	            [
	              958,
	              'xi'
	            ],
	            [
	              959,
	              'omicron'
	            ],
	            [
	              960,
	              'pi'
	            ],
	            [
	              961,
	              'rho'
	            ],
	            [
	              962,
	              'final sigma'
	            ],
	            [
	              963,
	              'sigma'
	            ],
	            [
	              964,
	              'tau'
	            ],
	            [
	              965,
	              'upsilon'
	            ],
	            [
	              966,
	              'phi'
	            ],
	            [
	              967,
	              'chi'
	            ],
	            [
	              968,
	              'psi'
	            ],
	            [
	              969,
	              'omega'
	            ]
	          ]
	        },
	        {
	          name: 'Symbols',
	          characters: [
	            [
	              8501,
	              'alef symbol'
	            ],
	            [
	              982,
	              'pi symbol'
	            ],
	            [
	              8476,
	              'real part symbol'
	            ],
	            [
	              978,
	              'upsilon - hook symbol'
	            ],
	            [
	              8472,
	              'Weierstrass p'
	            ],
	            [
	              8465,
	              'imaginary part'
	            ]
	          ]
	        },
	        {
	          name: 'Arrows',
	          characters: [
	            [
	              8592,
	              'leftwards arrow'
	            ],
	            [
	              8593,
	              'upwards arrow'
	            ],
	            [
	              8594,
	              'rightwards arrow'
	            ],
	            [
	              8595,
	              'downwards arrow'
	            ],
	            [
	              8596,
	              'left right arrow'
	            ],
	            [
	              8629,
	              'carriage return'
	            ],
	            [
	              8656,
	              'leftwards double arrow'
	            ],
	            [
	              8657,
	              'upwards double arrow'
	            ],
	            [
	              8658,
	              'rightwards double arrow'
	            ],
	            [
	              8659,
	              'downwards double arrow'
	            ],
	            [
	              8660,
	              'left right double arrow'
	            ],
	            [
	              8756,
	              'therefore'
	            ],
	            [
	              8834,
	              'subset of'
	            ],
	            [
	              8835,
	              'superset of'
	            ],
	            [
	              8836,
	              'not a subset of'
	            ],
	            [
	              8838,
	              'subset of or equal to'
	            ],
	            [
	              8839,
	              'superset of or equal to'
	            ],
	            [
	              8853,
	              'circled plus'
	            ],
	            [
	              8855,
	              'circled times'
	            ],
	            [
	              8869,
	              'perpendicular'
	            ],
	            [
	              8901,
	              'dot operator'
	            ],
	            [
	              8968,
	              'left ceiling'
	            ],
	            [
	              8969,
	              'right ceiling'
	            ],
	            [
	              8970,
	              'left floor'
	            ],
	            [
	              8971,
	              'right floor'
	            ],
	            [
	              9001,
	              'left-pointing angle bracket'
	            ],
	            [
	              9002,
	              'right-pointing angle bracket'
	            ],
	            [
	              9674,
	              'lozenge'
	            ],
	            [
	              9824,
	              'black spade suit'
	            ],
	            [
	              9827,
	              'black club suit'
	            ],
	            [
	              9829,
	              'black heart suit'
	            ],
	            [
	              9830,
	              'black diamond suit'
	            ],
	            [
	              8194,
	              'en space'
	            ],
	            [
	              8195,
	              'em space'
	            ],
	            [
	              8201,
	              'thin space'
	            ],
	            [
	              8204,
	              'zero width non-joiner'
	            ],
	            [
	              8205,
	              'zero width joiner'
	            ],
	            [
	              8206,
	              'left-to-right mark'
	            ],
	            [
	              8207,
	              'right-to-left mark'
	            ]
	          ]
	        }
	      ];
	    };
	    var charmapFilter = function (charmap) {
	      return global$1.grep(charmap, function (item) {
	        return isArray(item) && item.length === 2;
	      });
	    };
	    var getCharsFromSetting = function (settingValue) {
	      if (isArray(settingValue)) {
	        return charmapFilter(settingValue);
	      }
	      if (typeof settingValue === 'function') {
	        return settingValue();
	      }
	      return [];
	    };
	    var extendCharMap = function (editor, charmap) {
	      var userCharMap = getCharMap$1(editor);
	      if (userCharMap) {
	        charmap = [{
	            name: UserDefined,
	            characters: getCharsFromSetting(userCharMap)
	          }];
	      }
	      var userCharMapAppend = getCharMapAppend(editor);
	      if (userCharMapAppend) {
	        var userDefinedGroup = global$1.grep(charmap, function (cg) {
	          return cg.name === UserDefined;
	        });
	        if (userDefinedGroup.length) {
	          userDefinedGroup[0].characters = [].concat(userDefinedGroup[0].characters).concat(getCharsFromSetting(userCharMapAppend));
	          return charmap;
	        }
	        return charmap.concat({
	          name: UserDefined,
	          characters: getCharsFromSetting(userCharMapAppend)
	        });
	      }
	      return charmap;
	    };
	    var getCharMap = function (editor) {
	      var groups = extendCharMap(editor, getDefaultCharMap());
	      return groups.length > 1 ? [{
	          name: 'All',
	          characters: bind(groups, function (g) {
	            return g.characters;
	          })
	        }].concat(groups) : groups;
	    };
	
	    var get = function (editor) {
	      var getCharMap$1 = function () {
	        return getCharMap(editor);
	      };
	      var insertChar$1 = function (chr) {
	        insertChar(editor, chr);
	      };
	      return {
	        getCharMap: getCharMap$1,
	        insertChar: insertChar$1
	      };
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var last = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (!isNull(timer)) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        cancel();
	        timer = setTimeout(function () {
	          timer = null;
	          fn.apply(null, args);
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var nativeFromCodePoint = String.fromCodePoint;
	    var contains = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var fromCodePoint = function () {
	      var codePoints = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        codePoints[_i] = arguments[_i];
	      }
	      if (nativeFromCodePoint) {
	        return nativeFromCodePoint.apply(void 0, codePoints);
	      } else {
	        var codeUnits = [];
	        var codeLen = 0;
	        var result = '';
	        for (var index = 0, len = codePoints.length; index !== len; ++index) {
	          var codePoint = +codePoints[index];
	          if (!(codePoint < 1114111 && codePoint >>> 0 === codePoint)) {
	            throw RangeError('Invalid code point: ' + codePoint);
	          }
	          if (codePoint <= 65535) {
	            codeLen = codeUnits.push(codePoint);
	          } else {
	            codePoint -= 65536;
	            codeLen = codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
	          }
	          if (codeLen >= 16383) {
	            result += String.fromCharCode.apply(null, codeUnits);
	            codeUnits.length = 0;
	          }
	        }
	        return result + String.fromCharCode.apply(null, codeUnits);
	      }
	    };
	
	    var charMatches = function (charCode, name, lowerCasePattern) {
	      if (contains(fromCodePoint(charCode).toLowerCase(), lowerCasePattern)) {
	        return true;
	      } else {
	        return contains(name.toLowerCase(), lowerCasePattern) || contains(name.toLowerCase().replace(/\s+/g, ''), lowerCasePattern);
	      }
	    };
	    var scan = function (group, pattern) {
	      var matches = [];
	      var lowerCasePattern = pattern.toLowerCase();
	      each(group.characters, function (g) {
	        if (charMatches(g[0], g[1], lowerCasePattern)) {
	          matches.push(g);
	        }
	      });
	      return map(matches, function (m) {
	        return {
	          text: m[1],
	          value: fromCodePoint(m[0]),
	          icon: fromCodePoint(m[0])
	        };
	      });
	    };
	
	    var patternName = 'pattern';
	    var open = function (editor, charMap) {
	      var makeGroupItems = function () {
	        return [
	          {
	            label: 'Search',
	            type: 'input',
	            name: patternName
	          },
	          {
	            type: 'collection',
	            name: 'results'
	          }
	        ];
	      };
	      var makeTabs = function () {
	        return map(charMap, function (charGroup) {
	          return {
	            title: charGroup.name,
	            name: charGroup.name,
	            items: makeGroupItems()
	          };
	        });
	      };
	      var makePanel = function () {
	        return {
	          type: 'panel',
	          items: makeGroupItems()
	        };
	      };
	      var makeTabPanel = function () {
	        return {
	          type: 'tabpanel',
	          tabs: makeTabs()
	        };
	      };
	      var currentTab = charMap.length === 1 ? Cell(UserDefined) : Cell('All');
	      var scanAndSet = function (dialogApi, pattern) {
	        find(charMap, function (group) {
	          return group.name === currentTab.get();
	        }).each(function (f) {
	          var items = scan(f, pattern);
	          dialogApi.setData({ results: items });
	        });
	      };
	      var SEARCH_DELAY = 40;
	      var updateFilter = last(function (dialogApi) {
	        var pattern = dialogApi.getData().pattern;
	        scanAndSet(dialogApi, pattern);
	      }, SEARCH_DELAY);
	      var body = charMap.length === 1 ? makePanel() : makeTabPanel();
	      var initialData = {
	        pattern: '',
	        results: scan(charMap[0], '')
	      };
	      var bridgeSpec = {
	        title: 'Special Character',
	        size: 'normal',
	        body: body,
	        buttons: [{
	            type: 'cancel',
	            name: 'close',
	            text: 'Close',
	            primary: true
	          }],
	        initialData: initialData,
	        onAction: function (api, details) {
	          if (details.name === 'results') {
	            insertChar(editor, details.value);
	            api.close();
	          }
	        },
	        onTabChange: function (dialogApi, details) {
	          currentTab.set(details.newTabName);
	          updateFilter.throttle(dialogApi);
	        },
	        onChange: function (dialogApi, changeData) {
	          if (changeData.name === patternName) {
	            updateFilter.throttle(dialogApi);
	          }
	        }
	      };
	      var dialogApi = editor.windowManager.open(bridgeSpec);
	      dialogApi.focus(patternName);
	    };
	
	    var register$1 = function (editor, charMap) {
	      editor.addCommand('mceShowCharmap', function () {
	        open(editor, charMap);
	      });
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var init = function (editor, all) {
	      editor.ui.registry.addAutocompleter('charmap', {
	        ch: ':',
	        columns: 'auto',
	        minChars: 2,
	        fetch: function (pattern, _maxResults) {
	          return new global(function (resolve, _reject) {
	            resolve(scan(all, pattern));
	          });
	        },
	        onAction: function (autocompleteApi, rng, value) {
	          editor.selection.setRng(rng);
	          editor.insertContent(value);
	          autocompleteApi.hide();
	        }
	      });
	    };
	
	    var register = function (editor) {
	      editor.ui.registry.addButton('charmap', {
	        icon: 'insert-character',
	        tooltip: 'Special character',
	        onAction: function () {
	          return editor.execCommand('mceShowCharmap');
	        }
	      });
	      editor.ui.registry.addMenuItem('charmap', {
	        icon: 'insert-character',
	        text: 'Special character...',
	        onAction: function () {
	          return editor.execCommand('mceShowCharmap');
	        }
	      });
	    };
	
	    function Plugin () {
	      global$2.add('charmap', function (editor) {
	        var charMap = getCharMap(editor);
	        register$1(editor, charMap);
	        register(editor);
	        init(editor, charMap[0]);
	        return get(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2248 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var setContent = function (editor, html) {
	      editor.focus();
	      editor.undoManager.transact(function () {
	        editor.setContent(html);
	      });
	      editor.selection.setCursorLocation();
	      editor.nodeChanged();
	    };
	    var getContent = function (editor) {
	      return editor.getContent({ source_view: true });
	    };
	
	    var open = function (editor) {
	      var editorContent = getContent(editor);
	      editor.windowManager.open({
	        title: 'Source Code',
	        size: 'large',
	        body: {
	          type: 'panel',
	          items: [{
	              type: 'textarea',
	              name: 'code'
	            }]
	        },
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: { code: editorContent },
	        onSubmit: function (api) {
	          setContent(editor, api.getData().code);
	          api.close();
	        }
	      });
	    };
	
	    var register$1 = function (editor) {
	      editor.addCommand('mceCodeEditor', function () {
	        open(editor);
	      });
	    };
	
	    var register = function (editor) {
	      var onAction = function () {
	        return editor.execCommand('mceCodeEditor');
	      };
	      editor.ui.registry.addButton('code', {
	        icon: 'sourcecode',
	        tooltip: 'Source code',
	        onAction: onAction
	      });
	      editor.ui.registry.addMenuItem('code', {
	        icon: 'sourcecode',
	        text: 'Source code',
	        onAction: onAction
	      });
	    };
	
	    function Plugin () {
	      global.add('code', function (editor) {
	        register$1(editor);
	        register(editor);
	        return {};
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2249 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var get$5 = function (fullscreenState) {
	      return {
	        isFullscreen: function () {
	          return fullscreenState.get() !== null;
	        }
	      };
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType$1 = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var isString = isType$1('string');
	    var isArray = isType$1('array');
	    var isBoolean = isSimpleType('boolean');
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var compose1 = function (fbc, fab) {
	      return function (a) {
	        return fbc(fab(a));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var singleton = function (doRevoke) {
	      var subject = Cell(Optional.none());
	      var revoke = function () {
	        return subject.get().each(doRevoke);
	      };
	      var clear = function () {
	        revoke();
	        subject.set(Optional.none());
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var get = function () {
	        return subject.get();
	      };
	      var set = function (s) {
	        revoke();
	        subject.set(Optional.some(s));
	      };
	      return {
	        clear: clear,
	        isSet: isSet,
	        get: get,
	        set: set
	      };
	    };
	    var unbindable = function () {
	      return singleton(function (s) {
	        return s.unbind();
	      });
	    };
	    var value = function () {
	      var subject = singleton(noop);
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return __assign(__assign({}, subject), { on: on });
	    };
	
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each$1 = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter$1 = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find$1 = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind$3 = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var get$4 = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get$4(xs, 0);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var keys = Object.keys;
	    var each = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	
	    var contains = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	
	    var isSupported$1 = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement = isType(ELEMENT);
	    var isText = isType(TEXT);
	    var isDocument = isType(DOCUMENT);
	    var isDocumentFragment = isType(DOCUMENT_FRAGMENT);
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var DeviceType = function (os, browser, userAgent, mediaMatch) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isMobile = os.isiOS() || os.isAndroid();
	      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
	      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
	      var isPhone = isiPhone || isMobile && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      var isDesktop = !isPhone && !isTablet && !iOSwebview;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview),
	        isDesktop: constant(isDesktop)
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu$2(group(1), group(2));
	    };
	    var detect$3 = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown$2();
	      }
	      return find(versionRegexes, cleanedAgent);
	    };
	    var unknown$2 = function () {
	      return nu$2(0, 0);
	    };
	    var nu$2 = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu$2,
	      detect: detect$3,
	      unknown: unknown$2
	    };
	
	    var detectBrowser$1 = function (browsers, userAgentData) {
	      return findMap(userAgentData.brands, function (uaBrand) {
	        var lcBrand = uaBrand.brand.toLowerCase();
	        return find$1(browsers, function (browser) {
	          var _a;
	          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
	        }).map(function (info) {
	          return {
	            current: info.name,
	            version: Version.nu(parseInt(uaBrand.version, 10), 0)
	          };
	        });
	      });
	    };
	
	    var detect$2 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find$1(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$2(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$2(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains(uastring, 'edge/') && contains(uastring, 'chrome') && contains(uastring, 'safari') && contains(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        brand: 'Chromium',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'chrome') && !contains(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'msie') || contains(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains(uastring, 'safari') || contains(uastring, 'mobile/')) && contains(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains(uastring, 'iphone') || contains(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('mac os x'),
	        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      },
	      {
	        name: 'ChromeOS',
	        search: checkContains('cros'),
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isBrowser = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge),
	        isChrome: isBrowser(chrome),
	        isIE: isBrowser(ie),
	        isOpera: isBrowser(opera),
	        isFirefox: isBrowser(firefox),
	        isSafari: isBrowser(safari)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var chromeos = 'ChromeOS';
	    var unknown = function () {
	      return nu({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isOS = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows),
	        isiOS: isOS(ios),
	        isAndroid: isOS(android),
	        isOSX: isOS(osx),
	        isLinux: isOS(linux),
	        isSolaris: isOS(solaris),
	        isFreeBSD: isOS(freebsd),
	        isChromeOS: isOS(chromeos)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown,
	      nu: nu,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd),
	      chromeos: constant(chromeos)
	    };
	
	    var detect$1 = function (userAgent, userAgentDataOpt, mediaMatch) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = userAgentDataOpt.bind(function (userAgentData) {
	        return detectBrowser$1(browsers, userAgentData);
	      }).orThunk(function () {
	        return detectBrowser(browsers, userAgent);
	      }).fold(Browser.unknown, Browser.nu);
	      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$1 };
	
	    var mediaMatch = function (query) {
	      return window.matchMedia(query).matches;
	    };
	    var platform = cached(function () {
	      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
	    });
	    var detect = function () {
	      return platform();
	    };
	
	    var is = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all$1 = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	
	    var owner = function (element) {
	      return SugarElement.fromDom(element.dom.ownerDocument);
	    };
	    var documentOrOwner = function (dos) {
	      return isDocument(dos) ? dos : owner(dos);
	    };
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var parents = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom;
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = SugarElement.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var siblings$2 = function (element) {
	      var filterSelf = function (elements) {
	        return filter$1(elements, function (x) {
	          return !eq(element, x);
	        });
	      };
	      return parent(element).map(children).map(filterSelf).getOr([]);
	    };
	    var children = function (element) {
	      return map(element.dom.childNodes, SugarElement.fromDom);
	    };
	
	    var isShadowRoot = function (dos) {
	      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
	    };
	    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
	    var isSupported = constant(supported);
	    var getRootNode = supported ? function (e) {
	      return SugarElement.fromDom(e.dom.getRootNode());
	    } : documentOrOwner;
	    var getShadowRoot = function (e) {
	      var r = getRootNode(e);
	      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
	    };
	    var getShadowHost = function (e) {
	      return SugarElement.fromDom(e.dom.host);
	    };
	    var getOriginalEventTarget = function (event) {
	      if (isSupported() && isNonNullable(event.target)) {
	        var el = SugarElement.fromDom(event.target);
	        if (isElement(el) && isOpenShadowHost(el)) {
	          if (event.composed && event.composedPath) {
	            var composedPath = event.composedPath();
	            if (composedPath) {
	              return head(composedPath);
	            }
	          }
	        }
	      }
	      return Optional.from(event.target);
	    };
	    var isOpenShadowHost = function (element) {
	      return isNonNullable(element.dom.shadowRoot);
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom.parentNode : element.dom;
	      if (dom === undefined || dom === null || dom.ownerDocument === null) {
	        return false;
	      }
	      var doc = dom.ownerDocument;
	      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
	        return doc.body.contains(dom);
	      }, compose1(inBody, getShadowHost));
	    };
	    var getBody = function (doc) {
	      var b = doc.dom.body;
	      if (b === null || b === undefined) {
	        throw new Error('Body is not available yet');
	      }
	      return SugarElement.fromDom(b);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var get$3 = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var remove = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported$1(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var setAll = function (element, css) {
	      var dom = element.dom;
	      each(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$2 = function (element, property) {
	      var dom = element.dom;
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported$1(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	
	    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
	      return {
	        target: target,
	        x: x,
	        y: y,
	        stop: stop,
	        prevent: prevent,
	        kill: kill,
	        raw: raw
	      };
	    };
	    var fromRawEvent = function (rawEvent) {
	      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
	      var stop = function () {
	        return rawEvent.stopPropagation();
	      };
	      var prevent = function () {
	        return rawEvent.preventDefault();
	      };
	      var kill = compose(prevent, stop);
	      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
	    };
	    var handle = function (filter, handler) {
	      return function (rawEvent) {
	        if (filter(rawEvent)) {
	          handler(fromRawEvent(rawEvent));
	        }
	      };
	    };
	    var binder = function (element, event, filter, handler, useCapture) {
	      var wrapped = handle(filter, handler);
	      element.dom.addEventListener(event, wrapped, useCapture);
	      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
	    };
	    var bind$2 = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, false);
	    };
	    var unbind = function (element, event, handler, useCapture) {
	      element.dom.removeEventListener(event, handler, useCapture);
	    };
	
	    var filter = always;
	    var bind$1 = function (element, event, handler) {
	      return bind$2(element, event, filter, handler);
	    };
	
	    var r = function (left, top) {
	      var translate = function (x, y) {
	        return r(left + x, top + y);
	      };
	      return {
	        left: left,
	        top: top,
	        translate: translate
	      };
	    };
	    var SugarPosition = r;
	
	    var get$1 = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return SugarPosition(x, y);
	    };
	
	    var get = function (_win) {
	      var win = _win === undefined ? window : _win;
	      if (detect().browser.isFirefox()) {
	        return Optional.none();
	      } else {
	        return Optional.from(win['visualViewport']);
	      }
	    };
	    var bounds = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        right: x + width,
	        bottom: y + height
	      };
	    };
	    var getBounds = function (_win) {
	      var win = _win === undefined ? window : _win;
	      var doc = win.document;
	      var scroll = get$1(SugarElement.fromDom(doc));
	      return get(win).fold(function () {
	        var html = win.document.documentElement;
	        var width = html.clientWidth;
	        var height = html.clientHeight;
	        return bounds(scroll.left, scroll.top, width, height);
	      }, function (visualViewport) {
	        return bounds(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
	      });
	    };
	    var bind = function (name, callback, _win) {
	      return get(_win).map(function (visualViewport) {
	        var handler = function (e) {
	          return callback(fromRawEvent(e));
	        };
	        visualViewport.addEventListener(name, handler);
	        return {
	          unbind: function () {
	            return visualViewport.removeEventListener(name, handler);
	          }
	        };
	      }).getOrThunk(function () {
	        return { unbind: noop };
	      });
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var fireFullscreenStateChanged = function (editor, state) {
	      editor.fire('FullscreenStateChanged', { state: state });
	      editor.fire('ResizeEditor');
	    };
	
	    var getFullscreenNative = function (editor) {
	      return editor.getParam('fullscreen_native', false, 'boolean');
	    };
	
	    var getFullscreenRoot = function (editor) {
	      var elem = SugarElement.fromDom(editor.getElement());
	      return getShadowRoot(elem).map(getShadowHost).getOrThunk(function () {
	        return getBody(owner(elem));
	      });
	    };
	    var getFullscreenElement = function (root) {
	      if (root.fullscreenElement !== undefined) {
	        return root.fullscreenElement;
	      } else if (root.msFullscreenElement !== undefined) {
	        return root.msFullscreenElement;
	      } else if (root.webkitFullscreenElement !== undefined) {
	        return root.webkitFullscreenElement;
	      } else {
	        return null;
	      }
	    };
	    var getFullscreenchangeEventName = function () {
	      if (document.fullscreenElement !== undefined) {
	        return 'fullscreenchange';
	      } else if (document.msFullscreenElement !== undefined) {
	        return 'MSFullscreenChange';
	      } else if (document.webkitFullscreenElement !== undefined) {
	        return 'webkitfullscreenchange';
	      } else {
	        return 'fullscreenchange';
	      }
	    };
	    var requestFullscreen = function (sugarElem) {
	      var elem = sugarElem.dom;
	      if (elem.requestFullscreen) {
	        elem.requestFullscreen();
	      } else if (elem.msRequestFullscreen) {
	        elem.msRequestFullscreen();
	      } else if (elem.webkitRequestFullScreen) {
	        elem.webkitRequestFullScreen();
	      }
	    };
	    var exitFullscreen = function (sugarDoc) {
	      var doc = sugarDoc.dom;
	      if (doc.exitFullscreen) {
	        doc.exitFullscreen();
	      } else if (doc.msExitFullscreen) {
	        doc.msExitFullscreen();
	      } else if (doc.webkitCancelFullScreen) {
	        doc.webkitCancelFullScreen();
	      }
	    };
	    var isFullscreenElement = function (elem) {
	      return elem.dom === getFullscreenElement(owner(elem).dom);
	    };
	
	    var ancestors$1 = function (scope, predicate, isRoot) {
	      return filter$1(parents(scope, isRoot), predicate);
	    };
	    var siblings$1 = function (scope, predicate) {
	      return filter$1(siblings$2(scope), predicate);
	    };
	
	    var all = function (selector) {
	      return all$1(selector);
	    };
	    var ancestors = function (scope, selector, isRoot) {
	      return ancestors$1(scope, function (e) {
	        return is(e, selector);
	      }, isRoot);
	    };
	    var siblings = function (scope, selector) {
	      return siblings$1(scope, function (e) {
	        return is(e, selector);
	      });
	    };
	
	    var attr = 'data-ephox-mobile-fullscreen-style';
	    var siblingStyles = 'display:none!important;';
	    var ancestorPosition = 'position:absolute!important;';
	    var ancestorStyles = 'top:0!important;left:0!important;margin:0!important;padding:0!important;width:100%!important;height:100%!important;overflow:visible!important;';
	    var bgFallback = 'background-color:rgb(255,255,255)!important;';
	    var isAndroid = global$1.os.isAndroid();
	    var matchColor = function (editorBody) {
	      var color = get$2(editorBody, 'background-color');
	      return color !== undefined && color !== '' ? 'background-color:' + color + '!important' : bgFallback;
	    };
	    var clobberStyles = function (dom, container, editorBody) {
	      var gatherSiblings = function (element) {
	        return siblings(element, '*:not(.tox-silver-sink)');
	      };
	      var clobber = function (clobberStyle) {
	        return function (element) {
	          var styles = get$3(element, 'style');
	          var backup = styles === undefined ? 'no-styles' : styles.trim();
	          if (backup === clobberStyle) {
	            return;
	          } else {
	            set(element, attr, backup);
	            setAll(element, dom.parseStyle(clobberStyle));
	          }
	        };
	      };
	      var ancestors$1 = ancestors(container, '*');
	      var siblings$1 = bind$3(ancestors$1, gatherSiblings);
	      var bgColor = matchColor(editorBody);
	      each$1(siblings$1, clobber(siblingStyles));
	      each$1(ancestors$1, clobber(ancestorPosition + ancestorStyles + bgColor));
	      var containerStyles = isAndroid === true ? '' : ancestorPosition;
	      clobber(containerStyles + ancestorStyles + bgColor)(container);
	    };
	    var restoreStyles = function (dom) {
	      var clobberedEls = all('[' + attr + ']');
	      each$1(clobberedEls, function (element) {
	        var restore = get$3(element, attr);
	        if (restore !== 'no-styles') {
	          setAll(element, dom.parseStyle(restore));
	        } else {
	          remove(element, 'style');
	        }
	        remove(element, attr);
	      });
	    };
	
	    var DOM = global$2.DOM;
	    var getScrollPos = function () {
	      return getBounds(window);
	    };
	    var setScrollPos = function (pos) {
	      return window.scrollTo(pos.x, pos.y);
	    };
	    var viewportUpdate = get().fold(function () {
	      return {
	        bind: noop,
	        unbind: noop
	      };
	    }, function (visualViewport) {
	      var editorContainer = value();
	      var resizeBinder = unbindable();
	      var scrollBinder = unbindable();
	      var refreshScroll = function () {
	        document.body.scrollTop = 0;
	        document.documentElement.scrollTop = 0;
	      };
	      var refreshVisualViewport = function () {
	        window.requestAnimationFrame(function () {
	          editorContainer.on(function (container) {
	            return setAll(container, {
	              top: visualViewport.offsetTop + 'px',
	              left: visualViewport.offsetLeft + 'px',
	              height: visualViewport.height + 'px',
	              width: visualViewport.width + 'px'
	            });
	          });
	        });
	      };
	      var update = global.throttle(function () {
	        refreshScroll();
	        refreshVisualViewport();
	      }, 50);
	      var bind$1 = function (element) {
	        editorContainer.set(element);
	        update();
	        resizeBinder.set(bind('resize', update));
	        scrollBinder.set(bind('scroll', update));
	      };
	      var unbind = function () {
	        editorContainer.on(function () {
	          resizeBinder.clear();
	          scrollBinder.clear();
	        });
	        editorContainer.clear();
	      };
	      return {
	        bind: bind$1,
	        unbind: unbind
	      };
	    });
	    var toggleFullscreen = function (editor, fullscreenState) {
	      var body = document.body;
	      var documentElement = document.documentElement;
	      var editorContainer = editor.getContainer();
	      var editorContainerS = SugarElement.fromDom(editorContainer);
	      var fullscreenRoot = getFullscreenRoot(editor);
	      var fullscreenInfo = fullscreenState.get();
	      var editorBody = SugarElement.fromDom(editor.getBody());
	      var isTouch = global$1.deviceType.isTouch();
	      var editorContainerStyle = editorContainer.style;
	      var iframe = editor.iframeElement;
	      var iframeStyle = iframe.style;
	      var handleClasses = function (handler) {
	        handler(body, 'tox-fullscreen');
	        handler(documentElement, 'tox-fullscreen');
	        handler(editorContainer, 'tox-fullscreen');
	        getShadowRoot(editorContainerS).map(function (root) {
	          return getShadowHost(root).dom;
	        }).each(function (host) {
	          handler(host, 'tox-fullscreen');
	          handler(host, 'tox-shadowhost');
	        });
	      };
	      var cleanup = function () {
	        if (isTouch) {
	          restoreStyles(editor.dom);
	        }
	        handleClasses(DOM.removeClass);
	        viewportUpdate.unbind();
	        Optional.from(fullscreenState.get()).each(function (info) {
	          return info.fullscreenChangeHandler.unbind();
	        });
	      };
	      if (!fullscreenInfo) {
	        var fullscreenChangeHandler = bind$1(owner(fullscreenRoot), getFullscreenchangeEventName(), function (_evt) {
	          if (getFullscreenNative(editor)) {
	            if (!isFullscreenElement(fullscreenRoot) && fullscreenState.get() !== null) {
	              toggleFullscreen(editor, fullscreenState);
	            }
	          }
	        });
	        var newFullScreenInfo = {
	          scrollPos: getScrollPos(),
	          containerWidth: editorContainerStyle.width,
	          containerHeight: editorContainerStyle.height,
	          containerTop: editorContainerStyle.top,
	          containerLeft: editorContainerStyle.left,
	          iframeWidth: iframeStyle.width,
	          iframeHeight: iframeStyle.height,
	          fullscreenChangeHandler: fullscreenChangeHandler
	        };
	        if (isTouch) {
	          clobberStyles(editor.dom, editorContainerS, editorBody);
	        }
	        iframeStyle.width = iframeStyle.height = '100%';
	        editorContainerStyle.width = editorContainerStyle.height = '';
	        handleClasses(DOM.addClass);
	        viewportUpdate.bind(editorContainerS);
	        editor.on('remove', cleanup);
	        fullscreenState.set(newFullScreenInfo);
	        if (getFullscreenNative(editor)) {
	          requestFullscreen(fullscreenRoot);
	        }
	        fireFullscreenStateChanged(editor, true);
	      } else {
	        fullscreenInfo.fullscreenChangeHandler.unbind();
	        if (getFullscreenNative(editor) && isFullscreenElement(fullscreenRoot)) {
	          exitFullscreen(owner(fullscreenRoot));
	        }
	        iframeStyle.width = fullscreenInfo.iframeWidth;
	        iframeStyle.height = fullscreenInfo.iframeHeight;
	        editorContainerStyle.width = fullscreenInfo.containerWidth;
	        editorContainerStyle.height = fullscreenInfo.containerHeight;
	        editorContainerStyle.top = fullscreenInfo.containerTop;
	        editorContainerStyle.left = fullscreenInfo.containerLeft;
	        cleanup();
	        setScrollPos(fullscreenInfo.scrollPos);
	        fullscreenState.set(null);
	        fireFullscreenStateChanged(editor, false);
	        editor.off('remove', cleanup);
	      }
	    };
	
	    var register$1 = function (editor, fullscreenState) {
	      editor.addCommand('mceFullScreen', function () {
	        toggleFullscreen(editor, fullscreenState);
	      });
	    };
	
	    var makeSetupHandler = function (editor, fullscreenState) {
	      return function (api) {
	        api.setActive(fullscreenState.get() !== null);
	        var editorEventCallback = function (e) {
	          return api.setActive(e.state);
	        };
	        editor.on('FullscreenStateChanged', editorEventCallback);
	        return function () {
	          return editor.off('FullscreenStateChanged', editorEventCallback);
	        };
	      };
	    };
	    var register = function (editor, fullscreenState) {
	      var onAction = function () {
	        return editor.execCommand('mceFullScreen');
	      };
	      editor.ui.registry.addToggleMenuItem('fullscreen', {
	        text: 'Fullscreen',
	        icon: 'fullscreen',
	        shortcut: 'Meta+Shift+F',
	        onAction: onAction,
	        onSetup: makeSetupHandler(editor, fullscreenState)
	      });
	      editor.ui.registry.addToggleButton('fullscreen', {
	        tooltip: 'Fullscreen',
	        icon: 'fullscreen',
	        onAction: onAction,
	        onSetup: makeSetupHandler(editor, fullscreenState)
	      });
	    };
	
	    function Plugin () {
	      global$3.add('fullscreen', function (editor) {
	        var fullscreenState = Cell(null);
	        if (editor.inline) {
	          return get$5(fullscreenState);
	        }
	        register$1(editor, fullscreenState);
	        register(editor, fullscreenState);
	        editor.addShortcut('Meta+Shift+F', '', 'mceFullScreen');
	        return get$5(fullscreenState);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2250 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isNull = eq(null);
	    var isBoolean = isSimpleType('boolean');
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	
	    var nativePush = Array.prototype.push;
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var get = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get(xs, 0);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var remove = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.URI');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var hasDimensions = function (editor) {
	      return editor.getParam('image_dimensions', true, 'boolean');
	    };
	    var hasAdvTab = function (editor) {
	      return editor.getParam('image_advtab', false, 'boolean');
	    };
	    var hasUploadTab = function (editor) {
	      return editor.getParam('image_uploadtab', true, 'boolean');
	    };
	    var getPrependUrl = function (editor) {
	      return editor.getParam('image_prepend_url', '', 'string');
	    };
	    var getClassList = function (editor) {
	      return editor.getParam('image_class_list');
	    };
	    var hasDescription = function (editor) {
	      return editor.getParam('image_description', true, 'boolean');
	    };
	    var hasImageTitle = function (editor) {
	      return editor.getParam('image_title', false, 'boolean');
	    };
	    var hasImageCaption = function (editor) {
	      return editor.getParam('image_caption', false, 'boolean');
	    };
	    var getImageList = function (editor) {
	      return editor.getParam('image_list', false);
	    };
	    var hasUploadUrl = function (editor) {
	      return isNonNullable(editor.getParam('images_upload_url'));
	    };
	    var hasUploadHandler = function (editor) {
	      return isNonNullable(editor.getParam('images_upload_handler'));
	    };
	    var showAccessibilityOptions = function (editor) {
	      return editor.getParam('a11y_advanced_options', false, 'boolean');
	    };
	    var isAutomaticUploadsEnabled = function (editor) {
	      return editor.getParam('automatic_uploads', true, 'boolean');
	    };
	
	    var parseIntAndGetMax = function (val1, val2) {
	      return Math.max(parseInt(val1, 10), parseInt(val2, 10));
	    };
	    var getImageSize = function (url) {
	      return new global$4(function (callback) {
	        var img = document.createElement('img');
	        var done = function (dimensions) {
	          img.onload = img.onerror = null;
	          if (img.parentNode) {
	            img.parentNode.removeChild(img);
	          }
	          callback(dimensions);
	        };
	        img.onload = function () {
	          var width = parseIntAndGetMax(img.width, img.clientWidth);
	          var height = parseIntAndGetMax(img.height, img.clientHeight);
	          var dimensions = {
	            width: width,
	            height: height
	          };
	          done(global$4.resolve(dimensions));
	        };
	        img.onerror = function () {
	          done(global$4.reject('Failed to get image dimensions for: ' + url));
	        };
	        var style = img.style;
	        style.visibility = 'hidden';
	        style.position = 'fixed';
	        style.bottom = style.left = '0px';
	        style.width = style.height = 'auto';
	        document.body.appendChild(img);
	        img.src = url;
	      });
	    };
	    var removePixelSuffix = function (value) {
	      if (value) {
	        value = value.replace(/px$/, '');
	      }
	      return value;
	    };
	    var addPixelSuffix = function (value) {
	      if (value.length > 0 && /^[0-9]+$/.test(value)) {
	        value += 'px';
	      }
	      return value;
	    };
	    var mergeMargins = function (css) {
	      if (css.margin) {
	        var splitMargin = String(css.margin).split(' ');
	        switch (splitMargin.length) {
	        case 1:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[0];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
	          css['margin-left'] = css['margin-left'] || splitMargin[0];
	          break;
	        case 2:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
	          css['margin-left'] = css['margin-left'] || splitMargin[1];
	          break;
	        case 3:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
	          css['margin-left'] = css['margin-left'] || splitMargin[1];
	          break;
	        case 4:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
	          css['margin-left'] = css['margin-left'] || splitMargin[3];
	        }
	        delete css.margin;
	      }
	      return css;
	    };
	    var createImageList = function (editor, callback) {
	      var imageList = getImageList(editor);
	      if (isString(imageList)) {
	        global$2.send({
	          url: imageList,
	          success: function (text) {
	            callback(JSON.parse(text));
	          }
	        });
	      } else if (isFunction(imageList)) {
	        imageList(callback);
	      } else {
	        callback(imageList);
	      }
	    };
	    var waitLoadImage = function (editor, data, imgElm) {
	      var selectImage = function () {
	        imgElm.onload = imgElm.onerror = null;
	        if (editor.selection) {
	          editor.selection.select(imgElm);
	          editor.nodeChanged();
	        }
	      };
	      imgElm.onload = function () {
	        if (!data.width && !data.height && hasDimensions(editor)) {
	          editor.dom.setAttribs(imgElm, {
	            width: String(imgElm.clientWidth),
	            height: String(imgElm.clientHeight)
	          });
	        }
	        selectImage();
	      };
	      imgElm.onerror = selectImage;
	    };
	    var blobToDataUri = function (blob) {
	      return new global$4(function (resolve, reject) {
	        var reader = new FileReader();
	        reader.onload = function () {
	          resolve(reader.result);
	        };
	        reader.onerror = function () {
	          reject(reader.error.message);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	    var isPlaceholderImage = function (imgElm) {
	      return imgElm.nodeName === 'IMG' && (imgElm.hasAttribute('data-mce-object') || imgElm.hasAttribute('data-mce-placeholder'));
	    };
	    var isSafeImageUrl = function (editor, src) {
	      return global$3.isDomSafe(src, 'img', editor.settings);
	    };
	
	    var DOM = global$5.DOM;
	    var getHspace = function (image) {
	      if (image.style.marginLeft && image.style.marginRight && image.style.marginLeft === image.style.marginRight) {
	        return removePixelSuffix(image.style.marginLeft);
	      } else {
	        return '';
	      }
	    };
	    var getVspace = function (image) {
	      if (image.style.marginTop && image.style.marginBottom && image.style.marginTop === image.style.marginBottom) {
	        return removePixelSuffix(image.style.marginTop);
	      } else {
	        return '';
	      }
	    };
	    var getBorder = function (image) {
	      if (image.style.borderWidth) {
	        return removePixelSuffix(image.style.borderWidth);
	      } else {
	        return '';
	      }
	    };
	    var getAttrib = function (image, name) {
	      if (image.hasAttribute(name)) {
	        return image.getAttribute(name);
	      } else {
	        return '';
	      }
	    };
	    var getStyle = function (image, name) {
	      return image.style[name] ? image.style[name] : '';
	    };
	    var hasCaption = function (image) {
	      return image.parentNode !== null && image.parentNode.nodeName === 'FIGURE';
	    };
	    var updateAttrib = function (image, name, value) {
	      if (value === '') {
	        image.removeAttribute(name);
	      } else {
	        image.setAttribute(name, value);
	      }
	    };
	    var wrapInFigure = function (image) {
	      var figureElm = DOM.create('figure', { class: 'image' });
	      DOM.insertAfter(figureElm, image);
	      figureElm.appendChild(image);
	      figureElm.appendChild(DOM.create('figcaption', { contentEditable: 'true' }, 'Caption'));
	      figureElm.contentEditable = 'false';
	    };
	    var removeFigure = function (image) {
	      var figureElm = image.parentNode;
	      DOM.insertAfter(image, figureElm);
	      DOM.remove(figureElm);
	    };
	    var toggleCaption = function (image) {
	      if (hasCaption(image)) {
	        removeFigure(image);
	      } else {
	        wrapInFigure(image);
	      }
	    };
	    var normalizeStyle = function (image, normalizeCss) {
	      var attrValue = image.getAttribute('style');
	      var value = normalizeCss(attrValue !== null ? attrValue : '');
	      if (value.length > 0) {
	        image.setAttribute('style', value);
	        image.setAttribute('data-mce-style', value);
	      } else {
	        image.removeAttribute('style');
	      }
	    };
	    var setSize = function (name, normalizeCss) {
	      return function (image, name, value) {
	        if (image.style[name]) {
	          image.style[name] = addPixelSuffix(value);
	          normalizeStyle(image, normalizeCss);
	        } else {
	          updateAttrib(image, name, value);
	        }
	      };
	    };
	    var getSize = function (image, name) {
	      if (image.style[name]) {
	        return removePixelSuffix(image.style[name]);
	      } else {
	        return getAttrib(image, name);
	      }
	    };
	    var setHspace = function (image, value) {
	      var pxValue = addPixelSuffix(value);
	      image.style.marginLeft = pxValue;
	      image.style.marginRight = pxValue;
	    };
	    var setVspace = function (image, value) {
	      var pxValue = addPixelSuffix(value);
	      image.style.marginTop = pxValue;
	      image.style.marginBottom = pxValue;
	    };
	    var setBorder = function (image, value) {
	      var pxValue = addPixelSuffix(value);
	      image.style.borderWidth = pxValue;
	    };
	    var setBorderStyle = function (image, value) {
	      image.style.borderStyle = value;
	    };
	    var getBorderStyle = function (image) {
	      return getStyle(image, 'borderStyle');
	    };
	    var isFigure = function (elm) {
	      return elm.nodeName === 'FIGURE';
	    };
	    var isImage = function (elm) {
	      return elm.nodeName === 'IMG';
	    };
	    var getIsDecorative = function (image) {
	      return DOM.getAttrib(image, 'alt').length === 0 && DOM.getAttrib(image, 'role') === 'presentation';
	    };
	    var getAlt = function (image) {
	      if (getIsDecorative(image)) {
	        return '';
	      } else {
	        return getAttrib(image, 'alt');
	      }
	    };
	    var defaultData = function () {
	      return {
	        src: '',
	        alt: '',
	        title: '',
	        width: '',
	        height: '',
	        class: '',
	        style: '',
	        caption: false,
	        hspace: '',
	        vspace: '',
	        border: '',
	        borderStyle: '',
	        isDecorative: false
	      };
	    };
	    var getStyleValue = function (normalizeCss, data) {
	      var image = document.createElement('img');
	      updateAttrib(image, 'style', data.style);
	      if (getHspace(image) || data.hspace !== '') {
	        setHspace(image, data.hspace);
	      }
	      if (getVspace(image) || data.vspace !== '') {
	        setVspace(image, data.vspace);
	      }
	      if (getBorder(image) || data.border !== '') {
	        setBorder(image, data.border);
	      }
	      if (getBorderStyle(image) || data.borderStyle !== '') {
	        setBorderStyle(image, data.borderStyle);
	      }
	      return normalizeCss(image.getAttribute('style'));
	    };
	    var create = function (normalizeCss, data) {
	      var image = document.createElement('img');
	      write(normalizeCss, __assign(__assign({}, data), { caption: false }), image);
	      setAlt(image, data.alt, data.isDecorative);
	      if (data.caption) {
	        var figure = DOM.create('figure', { class: 'image' });
	        figure.appendChild(image);
	        figure.appendChild(DOM.create('figcaption', { contentEditable: 'true' }, 'Caption'));
	        figure.contentEditable = 'false';
	        return figure;
	      } else {
	        return image;
	      }
	    };
	    var read = function (normalizeCss, image) {
	      return {
	        src: getAttrib(image, 'src'),
	        alt: getAlt(image),
	        title: getAttrib(image, 'title'),
	        width: getSize(image, 'width'),
	        height: getSize(image, 'height'),
	        class: getAttrib(image, 'class'),
	        style: normalizeCss(getAttrib(image, 'style')),
	        caption: hasCaption(image),
	        hspace: getHspace(image),
	        vspace: getVspace(image),
	        border: getBorder(image),
	        borderStyle: getStyle(image, 'borderStyle'),
	        isDecorative: getIsDecorative(image)
	      };
	    };
	    var updateProp = function (image, oldData, newData, name, set) {
	      if (newData[name] !== oldData[name]) {
	        set(image, name, newData[name]);
	      }
	    };
	    var setAlt = function (image, alt, isDecorative) {
	      if (isDecorative) {
	        DOM.setAttrib(image, 'role', 'presentation');
	        var sugarImage = SugarElement.fromDom(image);
	        set(sugarImage, 'alt', '');
	      } else {
	        if (isNull(alt)) {
	          var sugarImage = SugarElement.fromDom(image);
	          remove(sugarImage, 'alt');
	        } else {
	          var sugarImage = SugarElement.fromDom(image);
	          set(sugarImage, 'alt', alt);
	        }
	        if (DOM.getAttrib(image, 'role') === 'presentation') {
	          DOM.setAttrib(image, 'role', '');
	        }
	      }
	    };
	    var updateAlt = function (image, oldData, newData) {
	      if (newData.alt !== oldData.alt || newData.isDecorative !== oldData.isDecorative) {
	        setAlt(image, newData.alt, newData.isDecorative);
	      }
	    };
	    var normalized = function (set, normalizeCss) {
	      return function (image, name, value) {
	        set(image, value);
	        normalizeStyle(image, normalizeCss);
	      };
	    };
	    var write = function (normalizeCss, newData, image) {
	      var oldData = read(normalizeCss, image);
	      updateProp(image, oldData, newData, 'caption', function (image, _name, _value) {
	        return toggleCaption(image);
	      });
	      updateProp(image, oldData, newData, 'src', updateAttrib);
	      updateProp(image, oldData, newData, 'title', updateAttrib);
	      updateProp(image, oldData, newData, 'width', setSize('width', normalizeCss));
	      updateProp(image, oldData, newData, 'height', setSize('height', normalizeCss));
	      updateProp(image, oldData, newData, 'class', updateAttrib);
	      updateProp(image, oldData, newData, 'style', normalized(function (image, value) {
	        return updateAttrib(image, 'style', value);
	      }, normalizeCss));
	      updateProp(image, oldData, newData, 'hspace', normalized(setHspace, normalizeCss));
	      updateProp(image, oldData, newData, 'vspace', normalized(setVspace, normalizeCss));
	      updateProp(image, oldData, newData, 'border', normalized(setBorder, normalizeCss));
	      updateProp(image, oldData, newData, 'borderStyle', normalized(setBorderStyle, normalizeCss));
	      updateAlt(image, oldData, newData);
	    };
	
	    var normalizeCss$1 = function (editor, cssText) {
	      var css = editor.dom.styles.parse(cssText);
	      var mergedCss = mergeMargins(css);
	      var compressed = editor.dom.styles.parse(editor.dom.styles.serialize(mergedCss));
	      return editor.dom.styles.serialize(compressed);
	    };
	    var getSelectedImage = function (editor) {
	      var imgElm = editor.selection.getNode();
	      var figureElm = editor.dom.getParent(imgElm, 'figure.image');
	      if (figureElm) {
	        return editor.dom.select('img', figureElm)[0];
	      }
	      if (imgElm && (imgElm.nodeName !== 'IMG' || isPlaceholderImage(imgElm))) {
	        return null;
	      }
	      return imgElm;
	    };
	    var splitTextBlock = function (editor, figure) {
	      var dom = editor.dom;
	      var textBlockElements = filter(editor.schema.getTextBlockElements(), function (_, parentElm) {
	        return !editor.schema.isValidChild(parentElm, 'figure');
	      });
	      var textBlock = dom.getParent(figure.parentNode, function (node) {
	        return hasNonNullableKey(textBlockElements, node.nodeName);
	      }, editor.getBody());
	      if (textBlock) {
	        return dom.split(textBlock, figure);
	      } else {
	        return figure;
	      }
	    };
	    var readImageDataFromSelection = function (editor) {
	      var image = getSelectedImage(editor);
	      return image ? read(function (css) {
	        return normalizeCss$1(editor, css);
	      }, image) : defaultData();
	    };
	    var insertImageAtCaret = function (editor, data) {
	      var elm = create(function (css) {
	        return normalizeCss$1(editor, css);
	      }, data);
	      editor.dom.setAttrib(elm, 'data-mce-id', '__mcenew');
	      editor.focus();
	      editor.selection.setContent(elm.outerHTML);
	      var insertedElm = editor.dom.select('*[data-mce-id="__mcenew"]')[0];
	      editor.dom.setAttrib(insertedElm, 'data-mce-id', null);
	      if (isFigure(insertedElm)) {
	        var figure = splitTextBlock(editor, insertedElm);
	        editor.selection.select(figure);
	      } else {
	        editor.selection.select(insertedElm);
	      }
	    };
	    var syncSrcAttr = function (editor, image) {
	      editor.dom.setAttrib(image, 'src', image.getAttribute('src'));
	    };
	    var deleteImage = function (editor, image) {
	      if (image) {
	        var elm = editor.dom.is(image.parentNode, 'figure.image') ? image.parentNode : image;
	        editor.dom.remove(elm);
	        editor.focus();
	        editor.nodeChanged();
	        if (editor.dom.isEmpty(editor.getBody())) {
	          editor.setContent('');
	          editor.selection.setCursorLocation();
	        }
	      }
	    };
	    var writeImageDataToSelection = function (editor, data) {
	      var image = getSelectedImage(editor);
	      write(function (css) {
	        return normalizeCss$1(editor, css);
	      }, data, image);
	      syncSrcAttr(editor, image);
	      if (isFigure(image.parentNode)) {
	        var figure = image.parentNode;
	        splitTextBlock(editor, figure);
	        editor.selection.select(image.parentNode);
	      } else {
	        editor.selection.select(image);
	        waitLoadImage(editor, data, image);
	      }
	    };
	    var sanitizeImageData = function (editor, data) {
	      var src = data.src;
	      return __assign(__assign({}, data), { src: isSafeImageUrl(editor, src) ? src : '' });
	    };
	    var insertOrUpdateImage = function (editor, partialData) {
	      var image = getSelectedImage(editor);
	      if (image) {
	        var selectedImageData = read(function (css) {
	          return normalizeCss$1(editor, css);
	        }, image);
	        var data = __assign(__assign({}, selectedImageData), partialData);
	        var sanitizedData = sanitizeImageData(editor, data);
	        if (data.src) {
	          writeImageDataToSelection(editor, sanitizedData);
	        } else {
	          deleteImage(editor, image);
	        }
	      } else if (partialData.src) {
	        insertImageAtCaret(editor, __assign(__assign({}, defaultData()), partialData));
	      }
	    };
	
	    var deep = function (old, nu) {
	      var bothObjects = isObject(old) && isObject(nu);
	      return bothObjects ? deepMerge(old, nu) : nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          objects[_i] = arguments[_i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (has(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var deepMerge = baseMerge(deep);
	
	    var isNotEmpty = function (s) {
	      return s.length > 0;
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.ImageUploader');
	
	    var global = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getValue = function (item) {
	      return isString(item.value) ? item.value : '';
	    };
	    var getText = function (item) {
	      if (isString(item.text)) {
	        return item.text;
	      } else if (isString(item.title)) {
	        return item.title;
	      } else {
	        return '';
	      }
	    };
	    var sanitizeList = function (list, extractValue) {
	      var out = [];
	      global.each(list, function (item) {
	        var text = getText(item);
	        if (item.menu !== undefined) {
	          var items = sanitizeList(item.menu, extractValue);
	          out.push({
	            text: text,
	            items: items
	          });
	        } else {
	          var value = extractValue(item);
	          out.push({
	            text: text,
	            value: value
	          });
	        }
	      });
	      return out;
	    };
	    var sanitizer = function (extractor) {
	      if (extractor === void 0) {
	        extractor = getValue;
	      }
	      return function (list) {
	        if (list) {
	          return Optional.from(list).map(function (list) {
	            return sanitizeList(list, extractor);
	          });
	        } else {
	          return Optional.none();
	        }
	      };
	    };
	    var sanitize = function (list) {
	      return sanitizer(getValue)(list);
	    };
	    var isGroup = function (item) {
	      return has(item, 'items');
	    };
	    var findEntryDelegate = function (list, value) {
	      return findMap(list, function (item) {
	        if (isGroup(item)) {
	          return findEntryDelegate(item.items, value);
	        } else if (item.value === value) {
	          return Optional.some(item);
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var findEntry = function (optList, value) {
	      return optList.bind(function (list) {
	        return findEntryDelegate(list, value);
	      });
	    };
	    var ListUtils = {
	      sanitizer: sanitizer,
	      sanitize: sanitize,
	      findEntry: findEntry
	    };
	
	    var makeTab$2 = function (_info) {
	      return {
	        title: 'Advanced',
	        name: 'advanced',
	        items: [
	          {
	            type: 'input',
	            label: 'Style',
	            name: 'style'
	          },
	          {
	            type: 'grid',
	            columns: 2,
	            items: [
	              {
	                type: 'input',
	                label: 'Vertical space',
	                name: 'vspace',
	                inputMode: 'numeric'
	              },
	              {
	                type: 'input',
	                label: 'Horizontal space',
	                name: 'hspace',
	                inputMode: 'numeric'
	              },
	              {
	                type: 'input',
	                label: 'Border width',
	                name: 'border',
	                inputMode: 'numeric'
	              },
	              {
	                type: 'listbox',
	                name: 'borderstyle',
	                label: 'Border style',
	                items: [
	                  {
	                    text: 'Select...',
	                    value: ''
	                  },
	                  {
	                    text: 'Solid',
	                    value: 'solid'
	                  },
	                  {
	                    text: 'Dotted',
	                    value: 'dotted'
	                  },
	                  {
	                    text: 'Dashed',
	                    value: 'dashed'
	                  },
	                  {
	                    text: 'Double',
	                    value: 'double'
	                  },
	                  {
	                    text: 'Groove',
	                    value: 'groove'
	                  },
	                  {
	                    text: 'Ridge',
	                    value: 'ridge'
	                  },
	                  {
	                    text: 'Inset',
	                    value: 'inset'
	                  },
	                  {
	                    text: 'Outset',
	                    value: 'outset'
	                  },
	                  {
	                    text: 'None',
	                    value: 'none'
	                  },
	                  {
	                    text: 'Hidden',
	                    value: 'hidden'
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      };
	    };
	    var AdvTab = { makeTab: makeTab$2 };
	
	    var collect = function (editor) {
	      var urlListSanitizer = ListUtils.sanitizer(function (item) {
	        return editor.convertURL(item.value || item.url, 'src');
	      });
	      var futureImageList = new global$4(function (completer) {
	        createImageList(editor, function (imageList) {
	          completer(urlListSanitizer(imageList).map(function (items) {
	            return flatten([
	              [{
	                  text: 'None',
	                  value: ''
	                }],
	              items
	            ]);
	          }));
	        });
	      });
	      var classList = ListUtils.sanitize(getClassList(editor));
	      var hasAdvTab$1 = hasAdvTab(editor);
	      var hasUploadTab$1 = hasUploadTab(editor);
	      var hasUploadUrl$1 = hasUploadUrl(editor);
	      var hasUploadHandler$1 = hasUploadHandler(editor);
	      var image = readImageDataFromSelection(editor);
	      var hasDescription$1 = hasDescription(editor);
	      var hasImageTitle$1 = hasImageTitle(editor);
	      var hasDimensions$1 = hasDimensions(editor);
	      var hasImageCaption$1 = hasImageCaption(editor);
	      var hasAccessibilityOptions = showAccessibilityOptions(editor);
	      var automaticUploads = isAutomaticUploadsEnabled(editor);
	      var prependURL = Optional.some(getPrependUrl(editor)).filter(function (preUrl) {
	        return isString(preUrl) && preUrl.length > 0;
	      });
	      return futureImageList.then(function (imageList) {
	        return {
	          image: image,
	          imageList: imageList,
	          classList: classList,
	          hasAdvTab: hasAdvTab$1,
	          hasUploadTab: hasUploadTab$1,
	          hasUploadUrl: hasUploadUrl$1,
	          hasUploadHandler: hasUploadHandler$1,
	          hasDescription: hasDescription$1,
	          hasImageTitle: hasImageTitle$1,
	          hasDimensions: hasDimensions$1,
	          hasImageCaption: hasImageCaption$1,
	          prependURL: prependURL,
	          hasAccessibilityOptions: hasAccessibilityOptions,
	          automaticUploads: automaticUploads
	        };
	      });
	    };
	
	    var makeItems = function (info) {
	      var imageUrl = {
	        name: 'src',
	        type: 'urlinput',
	        filetype: 'image',
	        label: 'Source'
	      };
	      var imageList = info.imageList.map(function (items) {
	        return {
	          name: 'images',
	          type: 'listbox',
	          label: 'Image list',
	          items: items
	        };
	      });
	      var imageDescription = {
	        name: 'alt',
	        type: 'input',
	        label: 'Alternative description',
	        disabled: info.hasAccessibilityOptions && info.image.isDecorative
	      };
	      var imageTitle = {
	        name: 'title',
	        type: 'input',
	        label: 'Image title'
	      };
	      var imageDimensions = {
	        name: 'dimensions',
	        type: 'sizeinput'
	      };
	      var isDecorative = {
	        type: 'label',
	        label: 'Accessibility',
	        items: [{
	            name: 'isDecorative',
	            type: 'checkbox',
	            label: 'Image is decorative'
	          }]
	      };
	      var classList = info.classList.map(function (items) {
	        return {
	          name: 'classes',
	          type: 'listbox',
	          label: 'Class',
	          items: items
	        };
	      });
	      var caption = {
	        type: 'label',
	        label: 'Caption',
	        items: [{
	            type: 'checkbox',
	            name: 'caption',
	            label: 'Show caption'
	          }]
	      };
	      var getDialogContainerType = function (useColumns) {
	        return useColumns ? {
	          type: 'grid',
	          columns: 2
	        } : { type: 'panel' };
	      };
	      return flatten([
	        [imageUrl],
	        imageList.toArray(),
	        info.hasAccessibilityOptions && info.hasDescription ? [isDecorative] : [],
	        info.hasDescription ? [imageDescription] : [],
	        info.hasImageTitle ? [imageTitle] : [],
	        info.hasDimensions ? [imageDimensions] : [],
	        [__assign(__assign({}, getDialogContainerType(info.classList.isSome() && info.hasImageCaption)), {
	            items: flatten([
	              classList.toArray(),
	              info.hasImageCaption ? [caption] : []
	            ])
	          })]
	      ]);
	    };
	    var makeTab$1 = function (info) {
	      return {
	        title: 'General',
	        name: 'general',
	        items: makeItems(info)
	      };
	    };
	    var MainTab = {
	      makeTab: makeTab$1,
	      makeItems: makeItems
	    };
	
	    var makeTab = function (_info) {
	      var items = [{
	          type: 'dropzone',
	          name: 'fileinput'
	        }];
	      return {
	        title: 'Upload',
	        name: 'upload',
	        items: items
	      };
	    };
	    var UploadTab = { makeTab: makeTab };
	
	    var createState = function (info) {
	      return {
	        prevImage: ListUtils.findEntry(info.imageList, info.image.src),
	        prevAlt: info.image.alt,
	        open: true
	      };
	    };
	    var fromImageData = function (image) {
	      return {
	        src: {
	          value: image.src,
	          meta: {}
	        },
	        images: image.src,
	        alt: image.alt,
	        title: image.title,
	        dimensions: {
	          width: image.width,
	          height: image.height
	        },
	        classes: image.class,
	        caption: image.caption,
	        style: image.style,
	        vspace: image.vspace,
	        border: image.border,
	        hspace: image.hspace,
	        borderstyle: image.borderStyle,
	        fileinput: [],
	        isDecorative: image.isDecorative
	      };
	    };
	    var toImageData = function (data, removeEmptyAlt) {
	      return {
	        src: data.src.value,
	        alt: data.alt.length === 0 && removeEmptyAlt ? null : data.alt,
	        title: data.title,
	        width: data.dimensions.width,
	        height: data.dimensions.height,
	        class: data.classes,
	        style: data.style,
	        caption: data.caption,
	        hspace: data.hspace,
	        vspace: data.vspace,
	        border: data.border,
	        borderStyle: data.borderstyle,
	        isDecorative: data.isDecorative
	      };
	    };
	    var addPrependUrl2 = function (info, srcURL) {
	      if (!/^(?:[a-zA-Z]+:)?\/\//.test(srcURL)) {
	        return info.prependURL.bind(function (prependUrl) {
	          if (srcURL.substring(0, prependUrl.length) !== prependUrl) {
	            return Optional.some(prependUrl + srcURL);
	          }
	          return Optional.none();
	        });
	      }
	      return Optional.none();
	    };
	    var addPrependUrl = function (info, api) {
	      var data = api.getData();
	      addPrependUrl2(info, data.src.value).each(function (srcURL) {
	        api.setData({
	          src: {
	            value: srcURL,
	            meta: data.src.meta
	          }
	        });
	      });
	    };
	    var formFillFromMeta2 = function (info, data, meta) {
	      if (info.hasDescription && isString(meta.alt)) {
	        data.alt = meta.alt;
	      }
	      if (info.hasAccessibilityOptions) {
	        data.isDecorative = meta.isDecorative || data.isDecorative || false;
	      }
	      if (info.hasImageTitle && isString(meta.title)) {
	        data.title = meta.title;
	      }
	      if (info.hasDimensions) {
	        if (isString(meta.width)) {
	          data.dimensions.width = meta.width;
	        }
	        if (isString(meta.height)) {
	          data.dimensions.height = meta.height;
	        }
	      }
	      if (isString(meta.class)) {
	        ListUtils.findEntry(info.classList, meta.class).each(function (entry) {
	          data.classes = entry.value;
	        });
	      }
	      if (info.hasImageCaption) {
	        if (isBoolean(meta.caption)) {
	          data.caption = meta.caption;
	        }
	      }
	      if (info.hasAdvTab) {
	        if (isString(meta.style)) {
	          data.style = meta.style;
	        }
	        if (isString(meta.vspace)) {
	          data.vspace = meta.vspace;
	        }
	        if (isString(meta.border)) {
	          data.border = meta.border;
	        }
	        if (isString(meta.hspace)) {
	          data.hspace = meta.hspace;
	        }
	        if (isString(meta.borderstyle)) {
	          data.borderstyle = meta.borderstyle;
	        }
	      }
	    };
	    var formFillFromMeta = function (info, api) {
	      var data = api.getData();
	      var meta = data.src.meta;
	      if (meta !== undefined) {
	        var newData = deepMerge({}, data);
	        formFillFromMeta2(info, newData, meta);
	        api.setData(newData);
	      }
	    };
	    var calculateImageSize = function (helpers, info, state, api) {
	      var data = api.getData();
	      var url = data.src.value;
	      var meta = data.src.meta || {};
	      if (!meta.width && !meta.height && info.hasDimensions) {
	        if (isNotEmpty(url)) {
	          helpers.imageSize(url).then(function (size) {
	            if (state.open) {
	              api.setData({ dimensions: size });
	            }
	          }).catch(function (e) {
	            return console.error(e);
	          });
	        } else {
	          api.setData({
	            dimensions: {
	              width: '',
	              height: ''
	            }
	          });
	        }
	      }
	    };
	    var updateImagesDropdown = function (info, state, api) {
	      var data = api.getData();
	      var image = ListUtils.findEntry(info.imageList, data.src.value);
	      state.prevImage = image;
	      api.setData({
	        images: image.map(function (entry) {
	          return entry.value;
	        }).getOr('')
	      });
	    };
	    var changeSrc = function (helpers, info, state, api) {
	      addPrependUrl(info, api);
	      formFillFromMeta(info, api);
	      calculateImageSize(helpers, info, state, api);
	      updateImagesDropdown(info, state, api);
	    };
	    var changeImages = function (helpers, info, state, api) {
	      var data = api.getData();
	      var image = ListUtils.findEntry(info.imageList, data.images);
	      image.each(function (img) {
	        var updateAlt = data.alt === '' || state.prevImage.map(function (image) {
	          return image.text === data.alt;
	        }).getOr(false);
	        if (updateAlt) {
	          if (img.value === '') {
	            api.setData({
	              src: img,
	              alt: state.prevAlt
	            });
	          } else {
	            api.setData({
	              src: img,
	              alt: img.text
	            });
	          }
	        } else {
	          api.setData({ src: img });
	        }
	      });
	      state.prevImage = image;
	      changeSrc(helpers, info, state, api);
	    };
	    var calcVSpace = function (css) {
	      var matchingTopBottom = css['margin-top'] && css['margin-bottom'] && css['margin-top'] === css['margin-bottom'];
	      return matchingTopBottom ? removePixelSuffix(String(css['margin-top'])) : '';
	    };
	    var calcHSpace = function (css) {
	      var matchingLeftRight = css['margin-right'] && css['margin-left'] && css['margin-right'] === css['margin-left'];
	      return matchingLeftRight ? removePixelSuffix(String(css['margin-right'])) : '';
	    };
	    var calcBorderWidth = function (css) {
	      return css['border-width'] ? removePixelSuffix(String(css['border-width'])) : '';
	    };
	    var calcBorderStyle = function (css) {
	      return css['border-style'] ? String(css['border-style']) : '';
	    };
	    var calcStyle = function (parseStyle, serializeStyle, css) {
	      return serializeStyle(parseStyle(serializeStyle(css)));
	    };
	    var changeStyle2 = function (parseStyle, serializeStyle, data) {
	      var css = mergeMargins(parseStyle(data.style));
	      var dataCopy = deepMerge({}, data);
	      dataCopy.vspace = calcVSpace(css);
	      dataCopy.hspace = calcHSpace(css);
	      dataCopy.border = calcBorderWidth(css);
	      dataCopy.borderstyle = calcBorderStyle(css);
	      dataCopy.style = calcStyle(parseStyle, serializeStyle, css);
	      return dataCopy;
	    };
	    var changeStyle = function (helpers, api) {
	      var data = api.getData();
	      var newData = changeStyle2(helpers.parseStyle, helpers.serializeStyle, data);
	      api.setData(newData);
	    };
	    var changeAStyle = function (helpers, info, api) {
	      var data = deepMerge(fromImageData(info.image), api.getData());
	      var style = getStyleValue(helpers.normalizeCss, toImageData(data, false));
	      api.setData({ style: style });
	    };
	    var changeFileInput = function (helpers, info, state, api) {
	      var data = api.getData();
	      api.block('Uploading image');
	      head(data.fileinput).fold(function () {
	        api.unblock();
	      }, function (file) {
	        var blobUri = URL.createObjectURL(file);
	        var finalize = function () {
	          api.unblock();
	          URL.revokeObjectURL(blobUri);
	        };
	        var updateSrcAndSwitchTab = function (url) {
	          api.setData({
	            src: {
	              value: url,
	              meta: {}
	            }
	          });
	          api.showTab('general');
	          changeSrc(helpers, info, state, api);
	        };
	        blobToDataUri(file).then(function (dataUrl) {
	          var blobInfo = helpers.createBlobCache(file, blobUri, dataUrl);
	          if (info.automaticUploads) {
	            helpers.uploadImage(blobInfo).then(function (result) {
	              updateSrcAndSwitchTab(result.url);
	              finalize();
	            }).catch(function (err) {
	              finalize();
	              helpers.alertErr(err);
	            });
	          } else {
	            helpers.addToBlobCache(blobInfo);
	            updateSrcAndSwitchTab(blobInfo.blobUri());
	            api.unblock();
	          }
	        });
	      });
	    };
	    var changeHandler = function (helpers, info, state) {
	      return function (api, evt) {
	        if (evt.name === 'src') {
	          changeSrc(helpers, info, state, api);
	        } else if (evt.name === 'images') {
	          changeImages(helpers, info, state, api);
	        } else if (evt.name === 'alt') {
	          state.prevAlt = api.getData().alt;
	        } else if (evt.name === 'style') {
	          changeStyle(helpers, api);
	        } else if (evt.name === 'vspace' || evt.name === 'hspace' || evt.name === 'border' || evt.name === 'borderstyle') {
	          changeAStyle(helpers, info, api);
	        } else if (evt.name === 'fileinput') {
	          changeFileInput(helpers, info, state, api);
	        } else if (evt.name === 'isDecorative') {
	          if (api.getData().isDecorative) {
	            api.disable('alt');
	          } else {
	            api.enable('alt');
	          }
	        }
	      };
	    };
	    var closeHandler = function (state) {
	      return function () {
	        state.open = false;
	      };
	    };
	    var makeDialogBody = function (info) {
	      if (info.hasAdvTab || info.hasUploadUrl || info.hasUploadHandler) {
	        var tabPanel = {
	          type: 'tabpanel',
	          tabs: flatten([
	            [MainTab.makeTab(info)],
	            info.hasAdvTab ? [AdvTab.makeTab(info)] : [],
	            info.hasUploadTab && (info.hasUploadUrl || info.hasUploadHandler) ? [UploadTab.makeTab(info)] : []
	          ])
	        };
	        return tabPanel;
	      } else {
	        var panel = {
	          type: 'panel',
	          items: MainTab.makeItems(info)
	        };
	        return panel;
	      }
	    };
	    var makeDialog = function (helpers) {
	      return function (info) {
	        var state = createState(info);
	        return {
	          title: 'Insert/Edit Image',
	          size: 'normal',
	          body: makeDialogBody(info),
	          buttons: [
	            {
	              type: 'cancel',
	              name: 'cancel',
	              text: 'Cancel'
	            },
	            {
	              type: 'submit',
	              name: 'save',
	              text: 'Save',
	              primary: true
	            }
	          ],
	          initialData: fromImageData(info.image),
	          onSubmit: helpers.onSubmit(info),
	          onChange: changeHandler(helpers, info, state),
	          onClose: closeHandler(state)
	        };
	      };
	    };
	    var submitHandler = function (editor) {
	      return function (info) {
	        return function (api) {
	          var data = deepMerge(fromImageData(info.image), api.getData());
	          editor.execCommand('mceUpdateImage', false, toImageData(data, info.hasAccessibilityOptions));
	          editor.editorUpload.uploadImagesAuto();
	          api.close();
	        };
	      };
	    };
	    var imageSize = function (editor) {
	      return function (url) {
	        if (!isSafeImageUrl(editor, url)) {
	          return global$4.resolve({
	            width: '',
	            height: ''
	          });
	        } else {
	          return getImageSize(editor.documentBaseURI.toAbsolute(url)).then(function (dimensions) {
	            return {
	              width: String(dimensions.width),
	              height: String(dimensions.height)
	            };
	          });
	        }
	      };
	    };
	    var createBlobCache = function (editor) {
	      return function (file, blobUri, dataUrl) {
	        return editor.editorUpload.blobCache.create({
	          blob: file,
	          blobUri: blobUri,
	          name: file.name ? file.name.replace(/\.[^\.]+$/, '') : null,
	          filename: file.name,
	          base64: dataUrl.split(',')[1]
	        });
	      };
	    };
	    var addToBlobCache = function (editor) {
	      return function (blobInfo) {
	        editor.editorUpload.blobCache.add(blobInfo);
	      };
	    };
	    var alertErr = function (editor) {
	      return function (message) {
	        editor.windowManager.alert(message);
	      };
	    };
	    var normalizeCss = function (editor) {
	      return function (cssText) {
	        return normalizeCss$1(editor, cssText);
	      };
	    };
	    var parseStyle = function (editor) {
	      return function (cssText) {
	        return editor.dom.parseStyle(cssText);
	      };
	    };
	    var serializeStyle = function (editor) {
	      return function (stylesArg, name) {
	        return editor.dom.serializeStyle(stylesArg, name);
	      };
	    };
	    var uploadImage = function (editor) {
	      return function (blobInfo) {
	        return global$1(editor).upload([blobInfo], false).then(function (results) {
	          if (results.length === 0) {
	            return global$4.reject('Failed to upload image');
	          } else if (results[0].status === false) {
	            return global$4.reject(results[0].error.message);
	          } else {
	            return results[0];
	          }
	        });
	      };
	    };
	    var Dialog = function (editor) {
	      var helpers = {
	        onSubmit: submitHandler(editor),
	        imageSize: imageSize(editor),
	        addToBlobCache: addToBlobCache(editor),
	        createBlobCache: createBlobCache(editor),
	        alertErr: alertErr(editor),
	        normalizeCss: normalizeCss(editor),
	        parseStyle: parseStyle(editor),
	        serializeStyle: serializeStyle(editor),
	        uploadImage: uploadImage(editor)
	      };
	      var open = function () {
	        collect(editor).then(makeDialog(helpers)).then(editor.windowManager.open);
	      };
	      return { open: open };
	    };
	
	    var register$1 = function (editor) {
	      editor.addCommand('mceImage', Dialog(editor).open);
	      editor.addCommand('mceUpdateImage', function (_ui, data) {
	        editor.undoManager.transact(function () {
	          return insertOrUpdateImage(editor, data);
	        });
	      });
	    };
	
	    var hasImageClass = function (node) {
	      var className = node.attr('class');
	      return className && /\bimage\b/.test(className);
	    };
	    var toggleContentEditableState = function (state) {
	      return function (nodes) {
	        var i = nodes.length;
	        var toggleContentEditable = function (node) {
	          node.attr('contenteditable', state ? 'true' : null);
	        };
	        while (i--) {
	          var node = nodes[i];
	          if (hasImageClass(node)) {
	            node.attr('contenteditable', state ? 'false' : null);
	            global.each(node.getAll('figcaption'), toggleContentEditable);
	          }
	        }
	      };
	    };
	    var setup = function (editor) {
	      editor.on('PreInit', function () {
	        editor.parser.addNodeFilter('figure', toggleContentEditableState(true));
	        editor.serializer.addNodeFilter('figure', toggleContentEditableState(false));
	      });
	    };
	
	    var register = function (editor) {
	      editor.ui.registry.addToggleButton('image', {
	        icon: 'image',
	        tooltip: 'Insert/edit image',
	        onAction: Dialog(editor).open,
	        onSetup: function (buttonApi) {
	          buttonApi.setActive(isNonNullable(getSelectedImage(editor)));
	          return editor.selection.selectorChangedWithUnbind('img:not([data-mce-object],[data-mce-placeholder]),figure.image', buttonApi.setActive).unbind;
	        }
	      });
	      editor.ui.registry.addMenuItem('image', {
	        icon: 'image',
	        text: 'Image...',
	        onAction: Dialog(editor).open
	      });
	      editor.ui.registry.addContextMenu('image', {
	        update: function (element) {
	          return isFigure(element) || isImage(element) && !isPlaceholderImage(element) ? ['image'] : [];
	        }
	      });
	    };
	
	    function Plugin () {
	      global$6.add('image', function (editor) {
	        setup(editor);
	        register(editor);
	        register$1(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2251 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType('string');
	    var isArray = isType('array');
	    var isNull = eq(null);
	    var isBoolean = isSimpleType('boolean');
	    var isFunction = isSimpleType('function');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    var tripleEquals = function (a, b) {
	      return a === b;
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each$1 = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var foldl = function (xs, f, acc) {
	      each$1(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var is = function (lhs, rhs, comparator) {
	      if (comparator === void 0) {
	        comparator = tripleEquals;
	      }
	      return lhs.exists(function (left) {
	        return comparator(left, rhs);
	      });
	    };
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var someIf = function (b, a) {
	      return b ? Optional.some(a) : Optional.none();
	    };
	
	    var assumeExternalTargets = function (editor) {
	      var externalTargets = editor.getParam('link_assume_external_targets', false);
	      if (isBoolean(externalTargets) && externalTargets) {
	        return 1;
	      } else if (isString(externalTargets) && (externalTargets === 'http' || externalTargets === 'https')) {
	        return externalTargets;
	      }
	      return 0;
	    };
	    var hasContextToolbar = function (editor) {
	      return editor.getParam('link_context_toolbar', false, 'boolean');
	    };
	    var getLinkList = function (editor) {
	      return editor.getParam('link_list');
	    };
	    var getDefaultLinkTarget = function (editor) {
	      return editor.getParam('default_link_target');
	    };
	    var getTargetList = function (editor) {
	      return editor.getParam('target_list', true);
	    };
	    var getRelList = function (editor) {
	      return editor.getParam('rel_list', [], 'array');
	    };
	    var getLinkClassList = function (editor) {
	      return editor.getParam('link_class_list', [], 'array');
	    };
	    var shouldShowLinkTitle = function (editor) {
	      return editor.getParam('link_title', true, 'boolean');
	    };
	    var allowUnsafeLinkTarget = function (editor) {
	      return editor.getParam('allow_unsafe_link_target', false, 'boolean');
	    };
	    var useQuickLink = function (editor) {
	      return editor.getParam('link_quicklink', false, 'boolean');
	    };
	    var getDefaultLinkProtocol = function (editor) {
	      return editor.getParam('link_default_protocol', 'http', 'string');
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getValue = function (item) {
	      return isString(item.value) ? item.value : '';
	    };
	    var getText = function (item) {
	      if (isString(item.text)) {
	        return item.text;
	      } else if (isString(item.title)) {
	        return item.title;
	      } else {
	        return '';
	      }
	    };
	    var sanitizeList = function (list, extractValue) {
	      var out = [];
	      global$5.each(list, function (item) {
	        var text = getText(item);
	        if (item.menu !== undefined) {
	          var items = sanitizeList(item.menu, extractValue);
	          out.push({
	            text: text,
	            items: items
	          });
	        } else {
	          var value = extractValue(item);
	          out.push({
	            text: text,
	            value: value
	          });
	        }
	      });
	      return out;
	    };
	    var sanitizeWith = function (extracter) {
	      if (extracter === void 0) {
	        extracter = getValue;
	      }
	      return function (list) {
	        return Optional.from(list).map(function (list) {
	          return sanitizeList(list, extracter);
	        });
	      };
	    };
	    var sanitize = function (list) {
	      return sanitizeWith(getValue)(list);
	    };
	    var createUi = function (name, label) {
	      return function (items) {
	        return {
	          name: name,
	          type: 'listbox',
	          label: label,
	          items: items
	        };
	      };
	    };
	    var ListOptions = {
	      sanitize: sanitize,
	      sanitizeWith: sanitizeWith,
	      createUi: createUi,
	      getValue: getValue
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.URI');
	
	    var isAnchor = function (elm) {
	      return elm && elm.nodeName.toLowerCase() === 'a';
	    };
	    var isLink = function (elm) {
	      return isAnchor(elm) && !!getHref(elm);
	    };
	    var collectNodesInRange = function (rng, predicate) {
	      if (rng.collapsed) {
	        return [];
	      } else {
	        var contents = rng.cloneContents();
	        var walker = new global$4(contents.firstChild, contents);
	        var elements = [];
	        var current = contents.firstChild;
	        do {
	          if (predicate(current)) {
	            elements.push(current);
	          }
	        } while (current = walker.next());
	        return elements;
	      }
	    };
	    var hasProtocol = function (url) {
	      return /^\w+:/i.test(url);
	    };
	    var getHref = function (elm) {
	      var href = elm.getAttribute('data-mce-href');
	      return href ? href : elm.getAttribute('href');
	    };
	    var applyRelTargetRules = function (rel, isUnsafe) {
	      var rules = ['noopener'];
	      var rels = rel ? rel.split(/\s+/) : [];
	      var toString = function (rels) {
	        return global$5.trim(rels.sort().join(' '));
	      };
	      var addTargetRules = function (rels) {
	        rels = removeTargetRules(rels);
	        return rels.length > 0 ? rels.concat(rules) : rules;
	      };
	      var removeTargetRules = function (rels) {
	        return rels.filter(function (val) {
	          return global$5.inArray(rules, val) === -1;
	        });
	      };
	      var newRels = isUnsafe ? addTargetRules(rels) : removeTargetRules(rels);
	      return newRels.length > 0 ? toString(newRels) : '';
	    };
	    var trimCaretContainers = function (text) {
	      return text.replace(/\uFEFF/g, '');
	    };
	    var getAnchorElement = function (editor, selectedElm) {
	      selectedElm = selectedElm || editor.selection.getNode();
	      if (isImageFigure(selectedElm)) {
	        return editor.dom.select('a[href]', selectedElm)[0];
	      } else {
	        return editor.dom.getParent(selectedElm, 'a[href]');
	      }
	    };
	    var getAnchorText = function (selection, anchorElm) {
	      var text = anchorElm ? anchorElm.innerText || anchorElm.textContent : selection.getContent({ format: 'text' });
	      return trimCaretContainers(text);
	    };
	    var hasLinks = function (elements) {
	      return global$5.grep(elements, isLink).length > 0;
	    };
	    var hasLinksInSelection = function (rng) {
	      return collectNodesInRange(rng, isLink).length > 0;
	    };
	    var isOnlyTextSelected = function (editor) {
	      var inlineTextElements = editor.schema.getTextInlineElements();
	      var isElement = function (elm) {
	        return elm.nodeType === 1 && !isAnchor(elm) && !has(inlineTextElements, elm.nodeName.toLowerCase());
	      };
	      var elements = collectNodesInRange(editor.selection.getRng(), isElement);
	      return elements.length === 0;
	    };
	    var isImageFigure = function (elm) {
	      return elm && elm.nodeName === 'FIGURE' && /\bimage\b/i.test(elm.className);
	    };
	    var getLinkAttrs = function (data) {
	      var attrs = [
	        'title',
	        'rel',
	        'class',
	        'target'
	      ];
	      return foldl(attrs, function (acc, key) {
	        data[key].each(function (value) {
	          acc[key] = value.length > 0 ? value : null;
	        });
	        return acc;
	      }, { href: data.href });
	    };
	    var handleExternalTargets = function (href, assumeExternalTargets) {
	      if ((assumeExternalTargets === 'http' || assumeExternalTargets === 'https') && !hasProtocol(href)) {
	        return assumeExternalTargets + '://' + href;
	      }
	      return href;
	    };
	    var applyLinkOverrides = function (editor, linkAttrs) {
	      var newLinkAttrs = __assign({}, linkAttrs);
	      if (!(getRelList(editor).length > 0) && allowUnsafeLinkTarget(editor) === false) {
	        var newRel = applyRelTargetRules(newLinkAttrs.rel, newLinkAttrs.target === '_blank');
	        newLinkAttrs.rel = newRel ? newRel : null;
	      }
	      if (Optional.from(newLinkAttrs.target).isNone() && getTargetList(editor) === false) {
	        newLinkAttrs.target = getDefaultLinkTarget(editor);
	      }
	      newLinkAttrs.href = handleExternalTargets(newLinkAttrs.href, assumeExternalTargets(editor));
	      return newLinkAttrs;
	    };
	    var updateLink = function (editor, anchorElm, text, linkAttrs) {
	      text.each(function (text) {
	        if (has(anchorElm, 'innerText')) {
	          anchorElm.innerText = text;
	        } else {
	          anchorElm.textContent = text;
	        }
	      });
	      editor.dom.setAttribs(anchorElm, linkAttrs);
	      editor.selection.select(anchorElm);
	    };
	    var createLink = function (editor, selectedElm, text, linkAttrs) {
	      if (isImageFigure(selectedElm)) {
	        linkImageFigure(editor, selectedElm, linkAttrs);
	      } else {
	        text.fold(function () {
	          editor.execCommand('mceInsertLink', false, linkAttrs);
	        }, function (text) {
	          editor.insertContent(editor.dom.createHTML('a', linkAttrs, editor.dom.encode(text)));
	        });
	      }
	    };
	    var linkDomMutation = function (editor, attachState, data) {
	      var selectedElm = editor.selection.getNode();
	      var anchorElm = getAnchorElement(editor, selectedElm);
	      var linkAttrs = applyLinkOverrides(editor, getLinkAttrs(data));
	      editor.undoManager.transact(function () {
	        if (data.href === attachState.href) {
	          attachState.attach();
	        }
	        if (anchorElm) {
	          editor.focus();
	          updateLink(editor, anchorElm, data.text, linkAttrs);
	        } else {
	          createLink(editor, selectedElm, data.text, linkAttrs);
	        }
	      });
	    };
	    var unlinkSelection = function (editor) {
	      var dom = editor.dom, selection = editor.selection;
	      var bookmark = selection.getBookmark();
	      var rng = selection.getRng().cloneRange();
	      var startAnchorElm = dom.getParent(rng.startContainer, 'a[href]', editor.getBody());
	      var endAnchorElm = dom.getParent(rng.endContainer, 'a[href]', editor.getBody());
	      if (startAnchorElm) {
	        rng.setStartBefore(startAnchorElm);
	      }
	      if (endAnchorElm) {
	        rng.setEndAfter(endAnchorElm);
	      }
	      selection.setRng(rng);
	      editor.execCommand('unlink');
	      selection.moveToBookmark(bookmark);
	    };
	    var unlinkDomMutation = function (editor) {
	      editor.undoManager.transact(function () {
	        var node = editor.selection.getNode();
	        if (isImageFigure(node)) {
	          unlinkImageFigure(editor, node);
	        } else {
	          unlinkSelection(editor);
	        }
	        editor.focus();
	      });
	    };
	    var unwrapOptions = function (data) {
	      var cls = data.class, href = data.href, rel = data.rel, target = data.target, text = data.text, title = data.title;
	      return filter({
	        class: cls.getOrNull(),
	        href: href,
	        rel: rel.getOrNull(),
	        target: target.getOrNull(),
	        text: text.getOrNull(),
	        title: title.getOrNull()
	      }, function (v, _k) {
	        return isNull(v) === false;
	      });
	    };
	    var sanitizeData = function (editor, data) {
	      var href = data.href;
	      return __assign(__assign({}, data), { href: global$3.isDomSafe(href, 'a', editor.settings) ? href : '' });
	    };
	    var link = function (editor, attachState, data) {
	      var sanitizedData = sanitizeData(editor, data);
	      editor.hasPlugin('rtc', true) ? editor.execCommand('createlink', false, unwrapOptions(sanitizedData)) : linkDomMutation(editor, attachState, sanitizedData);
	    };
	    var unlink = function (editor) {
	      editor.hasPlugin('rtc', true) ? editor.execCommand('unlink') : unlinkDomMutation(editor);
	    };
	    var unlinkImageFigure = function (editor, fig) {
	      var img = editor.dom.select('img', fig)[0];
	      if (img) {
	        var a = editor.dom.getParents(img, 'a[href]', fig)[0];
	        if (a) {
	          a.parentNode.insertBefore(img, a);
	          editor.dom.remove(a);
	        }
	      }
	    };
	    var linkImageFigure = function (editor, fig, attrs) {
	      var img = editor.dom.select('img', fig)[0];
	      if (img) {
	        var a = editor.dom.create('a', attrs);
	        img.parentNode.insertBefore(a, img);
	        a.appendChild(img);
	      }
	    };
	
	    var isListGroup = function (item) {
	      return hasNonNullableKey(item, 'items');
	    };
	    var findTextByValue = function (value, catalog) {
	      return findMap(catalog, function (item) {
	        if (isListGroup(item)) {
	          return findTextByValue(value, item.items);
	        } else {
	          return someIf(item.value === value, item);
	        }
	      });
	    };
	    var getDelta = function (persistentText, fieldName, catalog, data) {
	      var value = data[fieldName];
	      var hasPersistentText = persistentText.length > 0;
	      return value !== undefined ? findTextByValue(value, catalog).map(function (i) {
	        return {
	          url: {
	            value: i.value,
	            meta: {
	              text: hasPersistentText ? persistentText : i.text,
	              attach: noop
	            }
	          },
	          text: hasPersistentText ? persistentText : i.text
	        };
	      }) : Optional.none();
	    };
	    var findCatalog = function (catalogs, fieldName) {
	      if (fieldName === 'link') {
	        return catalogs.link;
	      } else if (fieldName === 'anchor') {
	        return catalogs.anchor;
	      } else {
	        return Optional.none();
	      }
	    };
	    var init = function (initialData, linkCatalog) {
	      var persistentData = {
	        text: initialData.text,
	        title: initialData.title
	      };
	      var getTitleFromUrlChange = function (url) {
	        return someIf(persistentData.title.length <= 0, Optional.from(url.meta.title).getOr(''));
	      };
	      var getTextFromUrlChange = function (url) {
	        return someIf(persistentData.text.length <= 0, Optional.from(url.meta.text).getOr(url.value));
	      };
	      var onUrlChange = function (data) {
	        var text = getTextFromUrlChange(data.url);
	        var title = getTitleFromUrlChange(data.url);
	        if (text.isSome() || title.isSome()) {
	          return Optional.some(__assign(__assign({}, text.map(function (text) {
	            return { text: text };
	          }).getOr({})), title.map(function (title) {
	            return { title: title };
	          }).getOr({})));
	        } else {
	          return Optional.none();
	        }
	      };
	      var onCatalogChange = function (data, change) {
	        var catalog = findCatalog(linkCatalog, change.name).getOr([]);
	        return getDelta(persistentData.text, change.name, catalog, data);
	      };
	      var onChange = function (getData, change) {
	        var name = change.name;
	        if (name === 'url') {
	          return onUrlChange(getData());
	        } else if (contains([
	            'anchor',
	            'link'
	          ], name)) {
	          return onCatalogChange(getData(), change);
	        } else if (name === 'text' || name === 'title') {
	          persistentData[name] = getData()[name];
	          return Optional.none();
	        } else {
	          return Optional.none();
	        }
	      };
	      return { onChange: onChange };
	    };
	    var DialogChanges = {
	      init: init,
	      getDelta: getDelta
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var delayedConfirm = function (editor, message, callback) {
	      var rng = editor.selection.getRng();
	      global$2.setEditorTimeout(editor, function () {
	        editor.windowManager.confirm(message, function (state) {
	          editor.selection.setRng(rng);
	          callback(state);
	        });
	      });
	    };
	    var tryEmailTransform = function (data) {
	      var url = data.href;
	      var suggestMailTo = url.indexOf('@') > 0 && url.indexOf('/') === -1 && url.indexOf('mailto:') === -1;
	      return suggestMailTo ? Optional.some({
	        message: 'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?',
	        preprocess: function (oldData) {
	          return __assign(__assign({}, oldData), { href: 'mailto:' + url });
	        }
	      }) : Optional.none();
	    };
	    var tryProtocolTransform = function (assumeExternalTargets, defaultLinkProtocol) {
	      return function (data) {
	        var url = data.href;
	        var suggestProtocol = assumeExternalTargets === 1 && !hasProtocol(url) || assumeExternalTargets === 0 && /^\s*www(\.|\d\.)/i.test(url);
	        return suggestProtocol ? Optional.some({
	          message: 'The URL you entered seems to be an external link. Do you want to add the required ' + defaultLinkProtocol + ':// prefix?',
	          preprocess: function (oldData) {
	            return __assign(__assign({}, oldData), { href: defaultLinkProtocol + '://' + url });
	          }
	        }) : Optional.none();
	      };
	    };
	    var preprocess = function (editor, data) {
	      return findMap([
	        tryEmailTransform,
	        tryProtocolTransform(assumeExternalTargets(editor), getDefaultLinkProtocol(editor))
	      ], function (f) {
	        return f(data);
	      }).fold(function () {
	        return global$1.resolve(data);
	      }, function (transform) {
	        return new global$1(function (callback) {
	          delayedConfirm(editor, transform.message, function (state) {
	            callback(state ? transform.preprocess(data) : data);
	          });
	        });
	      });
	    };
	    var DialogConfirms = { preprocess: preprocess };
	
	    var getAnchors = function (editor) {
	      var anchorNodes = editor.dom.select('a:not([href])');
	      var anchors = bind(anchorNodes, function (anchor) {
	        var id = anchor.name || anchor.id;
	        return id ? [{
	            text: id,
	            value: '#' + id
	          }] : [];
	      });
	      return anchors.length > 0 ? Optional.some([{
	          text: 'None',
	          value: ''
	        }].concat(anchors)) : Optional.none();
	    };
	    var AnchorListOptions = { getAnchors: getAnchors };
	
	    var getClasses = function (editor) {
	      var list = getLinkClassList(editor);
	      if (list.length > 0) {
	        return ListOptions.sanitize(list);
	      }
	      return Optional.none();
	    };
	    var ClassListOptions = { getClasses: getClasses };
	
	    var global = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var parseJson = function (text) {
	      try {
	        return Optional.some(JSON.parse(text));
	      } catch (err) {
	        return Optional.none();
	      }
	    };
	    var getLinks = function (editor) {
	      var extractor = function (item) {
	        return editor.convertURL(item.value || item.url, 'href');
	      };
	      var linkList = getLinkList(editor);
	      return new global$1(function (callback) {
	        if (isString(linkList)) {
	          global.send({
	            url: linkList,
	            success: function (text) {
	              return callback(parseJson(text));
	            },
	            error: function (_) {
	              return callback(Optional.none());
	            }
	          });
	        } else if (isFunction(linkList)) {
	          linkList(function (output) {
	            return callback(Optional.some(output));
	          });
	        } else {
	          callback(Optional.from(linkList));
	        }
	      }).then(function (optItems) {
	        return optItems.bind(ListOptions.sanitizeWith(extractor)).map(function (items) {
	          if (items.length > 0) {
	            var noneItem = [{
	                text: 'None',
	                value: ''
	              }];
	            return noneItem.concat(items);
	          } else {
	            return items;
	          }
	        });
	      });
	    };
	    var LinkListOptions = { getLinks: getLinks };
	
	    var getRels = function (editor, initialTarget) {
	      var list = getRelList(editor);
	      if (list.length > 0) {
	        var isTargetBlank_1 = is(initialTarget, '_blank');
	        var enforceSafe = allowUnsafeLinkTarget(editor) === false;
	        var safeRelExtractor = function (item) {
	          return applyRelTargetRules(ListOptions.getValue(item), isTargetBlank_1);
	        };
	        var sanitizer = enforceSafe ? ListOptions.sanitizeWith(safeRelExtractor) : ListOptions.sanitize;
	        return sanitizer(list);
	      }
	      return Optional.none();
	    };
	    var RelOptions = { getRels: getRels };
	
	    var fallbacks = [
	      {
	        text: 'Current window',
	        value: ''
	      },
	      {
	        text: 'New window',
	        value: '_blank'
	      }
	    ];
	    var getTargets = function (editor) {
	      var list = getTargetList(editor);
	      if (isArray(list)) {
	        return ListOptions.sanitize(list).orThunk(function () {
	          return Optional.some(fallbacks);
	        });
	      } else if (list === false) {
	        return Optional.none();
	      }
	      return Optional.some(fallbacks);
	    };
	    var TargetOptions = { getTargets: getTargets };
	
	    var nonEmptyAttr = function (dom, elem, name) {
	      var val = dom.getAttrib(elem, name);
	      return val !== null && val.length > 0 ? Optional.some(val) : Optional.none();
	    };
	    var extractFromAnchor = function (editor, anchor) {
	      var dom = editor.dom;
	      var onlyText = isOnlyTextSelected(editor);
	      var text = onlyText ? Optional.some(getAnchorText(editor.selection, anchor)) : Optional.none();
	      var url = anchor ? Optional.some(dom.getAttrib(anchor, 'href')) : Optional.none();
	      var target = anchor ? Optional.from(dom.getAttrib(anchor, 'target')) : Optional.none();
	      var rel = nonEmptyAttr(dom, anchor, 'rel');
	      var linkClass = nonEmptyAttr(dom, anchor, 'class');
	      var title = nonEmptyAttr(dom, anchor, 'title');
	      return {
	        url: url,
	        text: text,
	        title: title,
	        target: target,
	        rel: rel,
	        linkClass: linkClass
	      };
	    };
	    var collect = function (editor, linkNode) {
	      return LinkListOptions.getLinks(editor).then(function (links) {
	        var anchor = extractFromAnchor(editor, linkNode);
	        return {
	          anchor: anchor,
	          catalogs: {
	            targets: TargetOptions.getTargets(editor),
	            rels: RelOptions.getRels(editor, anchor.target),
	            classes: ClassListOptions.getClasses(editor),
	            anchor: AnchorListOptions.getAnchors(editor),
	            link: links
	          },
	          optNode: Optional.from(linkNode),
	          flags: { titleEnabled: shouldShowLinkTitle(editor) }
	        };
	      });
	    };
	    var DialogInfo = { collect: collect };
	
	    var handleSubmit = function (editor, info) {
	      return function (api) {
	        var data = api.getData();
	        if (!data.url.value) {
	          unlink(editor);
	          api.close();
	          return;
	        }
	        var getChangedValue = function (key) {
	          return Optional.from(data[key]).filter(function (value) {
	            return !is(info.anchor[key], value);
	          });
	        };
	        var changedData = {
	          href: data.url.value,
	          text: getChangedValue('text'),
	          target: getChangedValue('target'),
	          rel: getChangedValue('rel'),
	          class: getChangedValue('linkClass'),
	          title: getChangedValue('title')
	        };
	        var attachState = {
	          href: data.url.value,
	          attach: data.url.meta !== undefined && data.url.meta.attach ? data.url.meta.attach : noop
	        };
	        DialogConfirms.preprocess(editor, changedData).then(function (pData) {
	          link(editor, attachState, pData);
	        });
	        api.close();
	      };
	    };
	    var collectData = function (editor) {
	      var anchorNode = getAnchorElement(editor);
	      return DialogInfo.collect(editor, anchorNode);
	    };
	    var getInitialData = function (info, defaultTarget) {
	      var anchor = info.anchor;
	      var url = anchor.url.getOr('');
	      return {
	        url: {
	          value: url,
	          meta: { original: { value: url } }
	        },
	        text: anchor.text.getOr(''),
	        title: anchor.title.getOr(''),
	        anchor: url,
	        link: url,
	        rel: anchor.rel.getOr(''),
	        target: anchor.target.or(defaultTarget).getOr(''),
	        linkClass: anchor.linkClass.getOr('')
	      };
	    };
	    var makeDialog = function (settings, onSubmit, editor) {
	      var urlInput = [{
	          name: 'url',
	          type: 'urlinput',
	          filetype: 'file',
	          label: 'URL'
	        }];
	      var displayText = settings.anchor.text.map(function () {
	        return {
	          name: 'text',
	          type: 'input',
	          label: 'Text to display'
	        };
	      }).toArray();
	      var titleText = settings.flags.titleEnabled ? [{
	          name: 'title',
	          type: 'input',
	          label: 'Title'
	        }] : [];
	      var defaultTarget = Optional.from(getDefaultLinkTarget(editor));
	      var initialData = getInitialData(settings, defaultTarget);
	      var catalogs = settings.catalogs;
	      var dialogDelta = DialogChanges.init(initialData, catalogs);
	      var body = {
	        type: 'panel',
	        items: flatten([
	          urlInput,
	          displayText,
	          titleText,
	          cat([
	            catalogs.anchor.map(ListOptions.createUi('anchor', 'Anchors')),
	            catalogs.rels.map(ListOptions.createUi('rel', 'Rel')),
	            catalogs.targets.map(ListOptions.createUi('target', 'Open link in...')),
	            catalogs.link.map(ListOptions.createUi('link', 'Link list')),
	            catalogs.classes.map(ListOptions.createUi('linkClass', 'Class'))
	          ])
	        ])
	      };
	      return {
	        title: 'Insert/Edit Link',
	        size: 'normal',
	        body: body,
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: initialData,
	        onChange: function (api, _a) {
	          var name = _a.name;
	          dialogDelta.onChange(api.getData, { name: name }).each(function (newData) {
	            api.setData(newData);
	          });
	        },
	        onSubmit: onSubmit
	      };
	    };
	    var open$1 = function (editor) {
	      var data = collectData(editor);
	      data.then(function (info) {
	        var onSubmit = handleSubmit(editor, info);
	        return makeDialog(info, onSubmit, editor);
	      }).then(function (spec) {
	        editor.windowManager.open(spec);
	      });
	    };
	
	    var appendClickRemove = function (link, evt) {
	      document.body.appendChild(link);
	      link.dispatchEvent(evt);
	      document.body.removeChild(link);
	    };
	    var open = function (url) {
	      var link = document.createElement('a');
	      link.target = '_blank';
	      link.href = url;
	      link.rel = 'noreferrer noopener';
	      var evt = document.createEvent('MouseEvents');
	      evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	      appendClickRemove(link, evt);
	    };
	
	    var getLink = function (editor, elm) {
	      return editor.dom.getParent(elm, 'a[href]');
	    };
	    var getSelectedLink = function (editor) {
	      return getLink(editor, editor.selection.getStart());
	    };
	    var hasOnlyAltModifier = function (e) {
	      return e.altKey === true && e.shiftKey === false && e.ctrlKey === false && e.metaKey === false;
	    };
	    var gotoLink = function (editor, a) {
	      if (a) {
	        var href = getHref(a);
	        if (/^#/.test(href)) {
	          var targetEl = editor.$(href);
	          if (targetEl.length) {
	            editor.selection.scrollIntoView(targetEl[0], true);
	          }
	        } else {
	          open(a.href);
	        }
	      }
	    };
	    var openDialog = function (editor) {
	      return function () {
	        open$1(editor);
	      };
	    };
	    var gotoSelectedLink = function (editor) {
	      return function () {
	        gotoLink(editor, getSelectedLink(editor));
	      };
	    };
	    var setupGotoLinks = function (editor) {
	      editor.on('click', function (e) {
	        var link = getLink(editor, e.target);
	        if (link && global$6.metaKeyPressed(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	      editor.on('keydown', function (e) {
	        var link = getSelectedLink(editor);
	        if (link && e.keyCode === 13 && hasOnlyAltModifier(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	    };
	    var toggleState = function (editor, toggler) {
	      editor.on('NodeChange', toggler);
	      return function () {
	        return editor.off('NodeChange', toggler);
	      };
	    };
	    var toggleActiveState = function (editor) {
	      return function (api) {
	        var updateState = function () {
	          return api.setActive(!editor.mode.isReadOnly() && getAnchorElement(editor, editor.selection.getNode()) !== null);
	        };
	        updateState();
	        return toggleState(editor, updateState);
	      };
	    };
	    var toggleEnabledState = function (editor) {
	      return function (api) {
	        var updateState = function () {
	          return api.setDisabled(getAnchorElement(editor, editor.selection.getNode()) === null);
	        };
	        updateState();
	        return toggleState(editor, updateState);
	      };
	    };
	    var toggleUnlinkState = function (editor) {
	      return function (api) {
	        var hasLinks$1 = function (parents) {
	          return hasLinks(parents) || hasLinksInSelection(editor.selection.getRng());
	        };
	        var parents = editor.dom.getParents(editor.selection.getStart());
	        api.setDisabled(!hasLinks$1(parents));
	        return toggleState(editor, function (e) {
	          return api.setDisabled(!hasLinks$1(e.parents));
	        });
	      };
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceLink', function () {
	        if (useQuickLink(editor)) {
	          editor.fire('contexttoolbar-show', { toolbarKey: 'quicklink' });
	        } else {
	          openDialog(editor)();
	        }
	      });
	    };
	
	    var setup = function (editor) {
	      editor.addShortcut('Meta+K', '', function () {
	        editor.execCommand('mceLink');
	      });
	    };
	
	    var setupButtons = function (editor) {
	      editor.ui.registry.addToggleButton('link', {
	        icon: 'link',
	        tooltip: 'Insert/edit link',
	        onAction: openDialog(editor),
	        onSetup: toggleActiveState(editor)
	      });
	      editor.ui.registry.addButton('openlink', {
	        icon: 'new-tab',
	        tooltip: 'Open link',
	        onAction: gotoSelectedLink(editor),
	        onSetup: toggleEnabledState(editor)
	      });
	      editor.ui.registry.addButton('unlink', {
	        icon: 'unlink',
	        tooltip: 'Remove link',
	        onAction: function () {
	          return unlink(editor);
	        },
	        onSetup: toggleUnlinkState(editor)
	      });
	    };
	    var setupMenuItems = function (editor) {
	      editor.ui.registry.addMenuItem('openlink', {
	        text: 'Open link',
	        icon: 'new-tab',
	        onAction: gotoSelectedLink(editor),
	        onSetup: toggleEnabledState(editor)
	      });
	      editor.ui.registry.addMenuItem('link', {
	        icon: 'link',
	        text: 'Link...',
	        shortcut: 'Meta+K',
	        onAction: openDialog(editor)
	      });
	      editor.ui.registry.addMenuItem('unlink', {
	        icon: 'unlink',
	        text: 'Remove link',
	        onAction: function () {
	          return unlink(editor);
	        },
	        onSetup: toggleUnlinkState(editor)
	      });
	    };
	    var setupContextMenu = function (editor) {
	      var inLink = 'link unlink openlink';
	      var noLink = 'link';
	      editor.ui.registry.addContextMenu('link', {
	        update: function (element) {
	          return hasLinks(editor.dom.getParents(element, 'a')) ? inLink : noLink;
	        }
	      });
	    };
	    var setupContextToolbars = function (editor) {
	      var collapseSelectionToEnd = function (editor) {
	        editor.selection.collapse(false);
	      };
	      var onSetupLink = function (buttonApi) {
	        var node = editor.selection.getNode();
	        buttonApi.setDisabled(!getAnchorElement(editor, node));
	        return noop;
	      };
	      var getLinkText = function (value) {
	        var anchor = getAnchorElement(editor);
	        var onlyText = isOnlyTextSelected(editor);
	        if (!anchor && onlyText) {
	          var text = getAnchorText(editor.selection, anchor);
	          return Optional.some(text.length > 0 ? text : value);
	        } else {
	          return Optional.none();
	        }
	      };
	      editor.ui.registry.addContextForm('quicklink', {
	        launch: {
	          type: 'contextformtogglebutton',
	          icon: 'link',
	          tooltip: 'Link',
	          onSetup: toggleActiveState(editor)
	        },
	        label: 'Link',
	        predicate: function (node) {
	          return !!getAnchorElement(editor, node) && hasContextToolbar(editor);
	        },
	        initValue: function () {
	          var elm = getAnchorElement(editor);
	          return !!elm ? getHref(elm) : '';
	        },
	        commands: [
	          {
	            type: 'contextformtogglebutton',
	            icon: 'link',
	            tooltip: 'Link',
	            primary: true,
	            onSetup: function (buttonApi) {
	              var node = editor.selection.getNode();
	              buttonApi.setActive(!!getAnchorElement(editor, node));
	              return toggleActiveState(editor)(buttonApi);
	            },
	            onAction: function (formApi) {
	              var value = formApi.getValue();
	              var text = getLinkText(value);
	              var attachState = {
	                href: value,
	                attach: noop
	              };
	              link(editor, attachState, {
	                href: value,
	                text: text,
	                title: Optional.none(),
	                rel: Optional.none(),
	                target: Optional.none(),
	                class: Optional.none()
	              });
	              collapseSelectionToEnd(editor);
	              formApi.hide();
	            }
	          },
	          {
	            type: 'contextformbutton',
	            icon: 'unlink',
	            tooltip: 'Remove link',
	            onSetup: onSetupLink,
	            onAction: function (formApi) {
	              unlink(editor);
	              formApi.hide();
	            }
	          },
	          {
	            type: 'contextformbutton',
	            icon: 'new-tab',
	            tooltip: 'Open link',
	            onSetup: onSetupLink,
	            onAction: function (formApi) {
	              gotoSelectedLink(editor)();
	              formApi.hide();
	            }
	          }
	        ]
	      });
	    };
	
	    function Plugin () {
	      global$7.add('link', function (editor) {
	        setupButtons(editor);
	        setupMenuItems(editor);
	        setupContextMenu(editor);
	        setupContextToolbars(editor);
	        setupGotoLinks(editor);
	        register(editor);
	        setup(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2252 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global$b = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var hasProPlugin = function (editor) {
	      if (editor.hasPlugin('powerpaste', true)) {
	        if (typeof window.console !== 'undefined' && window.console.log) {
	          window.console.log('PowerPaste is incompatible with Paste plugin! Remove \'paste\' from the \'plugins\' option.');
	        }
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    var get = function (clipboard) {
	      return { clipboard: clipboard };
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var isArray = isType('array');
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from$1 = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from$1
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var nativePush = Array.prototype.push;
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter$1 = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var from = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var singleton = function (doRevoke) {
	      var subject = Cell(Optional.none());
	      var revoke = function () {
	        return subject.get().each(doRevoke);
	      };
	      var clear = function () {
	        revoke();
	        subject.set(Optional.none());
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var get = function () {
	        return subject.get();
	      };
	      var set = function (s) {
	        revoke();
	        subject.set(Optional.some(s));
	      };
	      return {
	        clear: clear,
	        isSet: isSet,
	        get: get,
	        set: set
	      };
	    };
	    var value = function () {
	      var subject = singleton(noop);
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return __assign(__assign({}, subject), { on: on });
	    };
	
	    var checkRange = function (str, substr, start) {
	      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
	    };
	    var startsWith = function (str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	    var endsWith = function (str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	    var repeat = function (s, count) {
	      return count <= 0 ? '' : new Array(count + 1).join(s);
	    };
	
	    var global$a = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var firePastePreProcess = function (editor, html, internal, isWordHtml) {
	      return editor.fire('PastePreProcess', {
	        content: html,
	        internal: internal,
	        wordContent: isWordHtml
	      });
	    };
	    var firePastePostProcess = function (editor, node, internal, isWordHtml) {
	      return editor.fire('PastePostProcess', {
	        node: node,
	        internal: internal,
	        wordContent: isWordHtml
	      });
	    };
	    var firePastePlainTextToggle = function (editor, state) {
	      return editor.fire('PastePlainTextToggle', { state: state });
	    };
	    var firePaste = function (editor, ieFake) {
	      return editor.fire('paste', { ieFake: ieFake });
	    };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var shouldBlockDrop = function (editor) {
	      return editor.getParam('paste_block_drop', false);
	    };
	    var shouldPasteDataImages = function (editor) {
	      return editor.getParam('paste_data_images', false);
	    };
	    var shouldFilterDrop = function (editor) {
	      return editor.getParam('paste_filter_drop', true);
	    };
	    var getPreProcess = function (editor) {
	      return editor.getParam('paste_preprocess');
	    };
	    var getPostProcess = function (editor) {
	      return editor.getParam('paste_postprocess');
	    };
	    var getWebkitStyles = function (editor) {
	      return editor.getParam('paste_webkit_styles');
	    };
	    var shouldRemoveWebKitStyles = function (editor) {
	      return editor.getParam('paste_remove_styles_if_webkit', true);
	    };
	    var shouldMergeFormats = function (editor) {
	      return editor.getParam('paste_merge_formats', true);
	    };
	    var isSmartPasteEnabled = function (editor) {
	      return editor.getParam('smart_paste', true);
	    };
	    var isPasteAsTextEnabled = function (editor) {
	      return editor.getParam('paste_as_text', false);
	    };
	    var getRetainStyleProps = function (editor) {
	      return editor.getParam('paste_retain_style_properties');
	    };
	    var getWordValidElements = function (editor) {
	      var defaultValidElements = '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' + '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' + 'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody';
	      return editor.getParam('paste_word_valid_elements', defaultValidElements);
	    };
	    var shouldConvertWordFakeLists = function (editor) {
	      return editor.getParam('paste_convert_word_fake_lists', true);
	    };
	    var shouldUseDefaultFilters = function (editor) {
	      return editor.getParam('paste_enable_default_filters', true);
	    };
	    var getValidate = function (editor) {
	      return editor.getParam('validate');
	    };
	    var getAllowHtmlDataUrls = function (editor) {
	      return editor.getParam('allow_html_data_urls', false, 'boolean');
	    };
	    var getPasteDataImages = function (editor) {
	      return editor.getParam('paste_data_images', false, 'boolean');
	    };
	    var getImagesDataImgFilter = function (editor) {
	      return editor.getParam('images_dataimg_filter');
	    };
	    var getImagesReuseFilename = function (editor) {
	      return editor.getParam('images_reuse_filename');
	    };
	    var getForcedRootBlock = function (editor) {
	      return editor.getParam('forced_root_block');
	    };
	    var getForcedRootBlockAttrs = function (editor) {
	      return editor.getParam('forced_root_block_attrs');
	    };
	    var getTabSpaces = function (editor) {
	      return editor.getParam('paste_tab_spaces', 4, 'number');
	    };
	    var getAllowedImageFileTypes = function (editor) {
	      var defaultImageFileTypes = 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp';
	      return global$6.explode(editor.getParam('images_file_types', defaultImageFileTypes, 'string'));
	    };
	
	    var internalMimeType = 'x-tinymce/html';
	    var internalMark = '<!-- ' + internalMimeType + ' -->';
	    var mark = function (html) {
	      return internalMark + html;
	    };
	    var unmark = function (html) {
	      return html.replace(internalMark, '');
	    };
	    var isMarked = function (html) {
	      return html.indexOf(internalMark) !== -1;
	    };
	    var internalHtmlMime = constant(internalMimeType);
	
	    var hasOwnProperty = Object.hasOwnProperty;
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.html.Entities');
	
	    var isPlainText = function (text) {
	      return !/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(text);
	    };
	    var toBRs = function (text) {
	      return text.replace(/\r?\n/g, '<br>');
	    };
	    var openContainer = function (rootTag, rootAttrs) {
	      var attrs = [];
	      var tag = '<' + rootTag;
	      if (typeof rootAttrs === 'object') {
	        for (var key in rootAttrs) {
	          if (has(rootAttrs, key)) {
	            attrs.push(key + '="' + global$5.encodeAllRaw(rootAttrs[key]) + '"');
	          }
	        }
	        if (attrs.length) {
	          tag += ' ' + attrs.join(' ');
	        }
	      }
	      return tag + '>';
	    };
	    var toBlockElements = function (text, rootTag, rootAttrs) {
	      var blocks = text.split(/\n\n/);
	      var tagOpen = openContainer(rootTag, rootAttrs);
	      var tagClose = '</' + rootTag + '>';
	      var paragraphs = global$6.map(blocks, function (p) {
	        return p.split(/\n/).join('<br />');
	      });
	      var stitch = function (p) {
	        return tagOpen + p + tagClose;
	      };
	      return paragraphs.length === 1 ? paragraphs[0] : global$6.map(paragraphs, stitch).join('');
	    };
	    var convert = function (text, rootTag, rootAttrs) {
	      return rootTag ? toBlockElements(text, rootTag === true ? 'p' : rootTag, rootAttrs) : toBRs(text);
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.html.DomParser');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.html.Serializer');
	
	    var nbsp = '\xA0';
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.html.Node');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.html.Schema');
	
	    var isRegExp = function (val) {
	      return val.constructor === RegExp;
	    };
	    var filter = function (content, items) {
	      global$6.each(items, function (v) {
	        if (isRegExp(v)) {
	          content = content.replace(v, '');
	        } else {
	          content = content.replace(v[0], v[1]);
	        }
	      });
	      return content;
	    };
	    var innerText = function (html) {
	      var schema = global$1();
	      var domParser = global$4({}, schema);
	      var text = '';
	      var shortEndedElements = schema.getShortEndedElements();
	      var ignoreElements = global$6.makeMap('script noscript style textarea video audio iframe object', ' ');
	      var blockElements = schema.getBlockElements();
	      var walk = function (node) {
	        var name = node.name, currentNode = node;
	        if (name === 'br') {
	          text += '\n';
	          return;
	        }
	        if (name === 'wbr') {
	          return;
	        }
	        if (shortEndedElements[name]) {
	          text += ' ';
	        }
	        if (ignoreElements[name]) {
	          text += ' ';
	          return;
	        }
	        if (node.type === 3) {
	          text += node.value;
	        }
	        if (!node.shortEnded) {
	          if (node = node.firstChild) {
	            do {
	              walk(node);
	            } while (node = node.next);
	          }
	        }
	        if (blockElements[name] && currentNode.next) {
	          text += '\n';
	          if (name === 'p') {
	            text += '\n';
	          }
	        }
	      };
	      html = filter(html, [/<!\[[^\]]+\]>/g]);
	      walk(domParser.parse(html));
	      return text;
	    };
	    var trimHtml = function (html) {
	      var trimSpaces = function (all, s1, s2) {
	        if (!s1 && !s2) {
	          return ' ';
	        }
	        return nbsp;
	      };
	      html = filter(html, [
	        /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/ig,
	        /<!--StartFragment-->|<!--EndFragment-->/g,
	        [
	          /( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,
	          trimSpaces
	        ],
	        /<br class="Apple-interchange-newline">/g,
	        /<br>$/i
	      ]);
	      return html;
	    };
	    var createIdGenerator = function (prefix) {
	      var count = 0;
	      return function () {
	        return prefix + count++;
	      };
	    };
	    var getImageMimeType = function (ext) {
	      var lowerExt = ext.toLowerCase();
	      var mimeOverrides = {
	        jpg: 'jpeg',
	        jpe: 'jpeg',
	        jfi: 'jpeg',
	        jif: 'jpeg',
	        jfif: 'jpeg',
	        pjpeg: 'jpeg',
	        pjp: 'jpeg',
	        svg: 'svg+xml'
	      };
	      return global$6.hasOwn(mimeOverrides, lowerExt) ? 'image/' + mimeOverrides[lowerExt] : 'image/' + lowerExt;
	    };
	
	    var isWordContent = function (content) {
	      return /<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument/i.test(content) || /class="OutlineElement/.test(content) || /id="?docs\-internal\-guid\-/.test(content);
	    };
	    var isNumericList = function (text) {
	      var found = false;
	      var patterns = [
	        /^[IVXLMCD]+\.[ \u00a0]/,
	        /^[ivxlmcd]+\.[ \u00a0]/,
	        /^[a-z]{1,2}[\.\)][ \u00a0]/,
	        /^[A-Z]{1,2}[\.\)][ \u00a0]/,
	        /^[0-9]+\.[ \u00a0]/,
	        /^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/,
	        /^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/
	      ];
	      text = text.replace(/^[\u00a0 ]+/, '');
	      global$6.each(patterns, function (pattern) {
	        if (pattern.test(text)) {
	          found = true;
	          return false;
	        }
	      });
	      return found;
	    };
	    var isBulletList = function (text) {
	      return /^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(text);
	    };
	    var convertFakeListsToProperLists = function (node) {
	      var currentListNode, prevListNode, lastLevel = 1;
	      var getText = function (node) {
	        var txt = '';
	        if (node.type === 3) {
	          return node.value;
	        }
	        if (node = node.firstChild) {
	          do {
	            txt += getText(node);
	          } while (node = node.next);
	        }
	        return txt;
	      };
	      var trimListStart = function (node, regExp) {
	        if (node.type === 3) {
	          if (regExp.test(node.value)) {
	            node.value = node.value.replace(regExp, '');
	            return false;
	          }
	        }
	        if (node = node.firstChild) {
	          do {
	            if (!trimListStart(node, regExp)) {
	              return false;
	            }
	          } while (node = node.next);
	        }
	        return true;
	      };
	      var removeIgnoredNodes = function (node) {
	        if (node._listIgnore) {
	          node.remove();
	          return;
	        }
	        if (node = node.firstChild) {
	          do {
	            removeIgnoredNodes(node);
	          } while (node = node.next);
	        }
	      };
	      var convertParagraphToLi = function (paragraphNode, listName, start) {
	        var level = paragraphNode._listLevel || lastLevel;
	        if (level !== lastLevel) {
	          if (level < lastLevel) {
	            if (currentListNode) {
	              currentListNode = currentListNode.parent.parent;
	            }
	          } else {
	            prevListNode = currentListNode;
	            currentListNode = null;
	          }
	        }
	        if (!currentListNode || currentListNode.name !== listName) {
	          prevListNode = prevListNode || currentListNode;
	          currentListNode = new global$2(listName, 1);
	          if (start > 1) {
	            currentListNode.attr('start', '' + start);
	          }
	          paragraphNode.wrap(currentListNode);
	        } else {
	          currentListNode.append(paragraphNode);
	        }
	        paragraphNode.name = 'li';
	        if (level > lastLevel && prevListNode) {
	          prevListNode.lastChild.append(currentListNode);
	        }
	        lastLevel = level;
	        removeIgnoredNodes(paragraphNode);
	        trimListStart(paragraphNode, /^\u00a0+/);
	        trimListStart(paragraphNode, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/);
	        trimListStart(paragraphNode, /^\u00a0+/);
	      };
	      var elements = [];
	      var child = node.firstChild;
	      while (typeof child !== 'undefined' && child !== null) {
	        elements.push(child);
	        child = child.walk();
	        if (child !== null) {
	          while (typeof child !== 'undefined' && child.parent !== node) {
	            child = child.walk();
	          }
	        }
	      }
	      for (var i = 0; i < elements.length; i++) {
	        node = elements[i];
	        if (node.name === 'p' && node.firstChild) {
	          var nodeText = getText(node);
	          if (isBulletList(nodeText)) {
	            convertParagraphToLi(node, 'ul');
	            continue;
	          }
	          if (isNumericList(nodeText)) {
	            var matches = /([0-9]+)\./.exec(nodeText);
	            var start = 1;
	            if (matches) {
	              start = parseInt(matches[1], 10);
	            }
	            convertParagraphToLi(node, 'ol', start);
	            continue;
	          }
	          if (node._listLevel) {
	            convertParagraphToLi(node, 'ul', 1);
	            continue;
	          }
	          currentListNode = null;
	        } else {
	          prevListNode = currentListNode;
	          currentListNode = null;
	        }
	      }
	    };
	    var filterStyles = function (editor, validStyles, node, styleValue) {
	      var outputStyles = {};
	      var styles = editor.dom.parseStyle(styleValue);
	      global$6.each(styles, function (value, name) {
	        switch (name) {
	        case 'mso-list':
	          var matches = /\w+ \w+([0-9]+)/i.exec(styleValue);
	          if (matches) {
	            node._listLevel = parseInt(matches[1], 10);
	          }
	          if (/Ignore/i.test(value) && node.firstChild) {
	            node._listIgnore = true;
	            node.firstChild._listIgnore = true;
	          }
	          break;
	        case 'horiz-align':
	          name = 'text-align';
	          break;
	        case 'vert-align':
	          name = 'vertical-align';
	          break;
	        case 'font-color':
	        case 'mso-foreground':
	          name = 'color';
	          break;
	        case 'mso-background':
	        case 'mso-highlight':
	          name = 'background';
	          break;
	        case 'font-weight':
	        case 'font-style':
	          if (value !== 'normal') {
	            outputStyles[name] = value;
	          }
	          return;
	        case 'mso-element':
	          if (/^(comment|comment-list)$/i.test(value)) {
	            node.remove();
	            return;
	          }
	          break;
	        }
	        if (name.indexOf('mso-comment') === 0) {
	          node.remove();
	          return;
	        }
	        if (name.indexOf('mso-') === 0) {
	          return;
	        }
	        if (getRetainStyleProps(editor) === 'all' || validStyles && validStyles[name]) {
	          outputStyles[name] = value;
	        }
	      });
	      if (/(bold)/i.test(outputStyles['font-weight'])) {
	        delete outputStyles['font-weight'];
	        node.wrap(new global$2('b', 1));
	      }
	      if (/(italic)/i.test(outputStyles['font-style'])) {
	        delete outputStyles['font-style'];
	        node.wrap(new global$2('i', 1));
	      }
	      var outputStyle = editor.dom.serializeStyle(outputStyles, node.name);
	      if (outputStyle) {
	        return outputStyle;
	      }
	      return null;
	    };
	    var filterWordContent = function (editor, content) {
	      var validStyles;
	      var retainStyleProperties = getRetainStyleProps(editor);
	      if (retainStyleProperties) {
	        validStyles = global$6.makeMap(retainStyleProperties.split(/[, ]/));
	      }
	      content = filter(content, [
	        /<br class="?Apple-interchange-newline"?>/gi,
	        /<b[^>]+id="?docs-internal-[^>]*>/gi,
	        /<!--[\s\S]+?-->/gi,
	        /<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi,
	        [
	          /<(\/?)s>/gi,
	          '<$1strike>'
	        ],
	        [
	          /&nbsp;/gi,
	          nbsp
	        ],
	        [
	          /<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,
	          function (str, spaces) {
	            return spaces.length > 0 ? spaces.replace(/./, ' ').slice(Math.floor(spaces.length / 2)).split('').join(nbsp) : '';
	          }
	        ]
	      ]);
	      var validElements = getWordValidElements(editor);
	      var schema = global$1({
	        valid_elements: validElements,
	        valid_children: '-li[p]'
	      });
	      global$6.each(schema.elements, function (rule) {
	        if (!rule.attributes.class) {
	          rule.attributes.class = {};
	          rule.attributesOrder.push('class');
	        }
	        if (!rule.attributes.style) {
	          rule.attributes.style = {};
	          rule.attributesOrder.push('style');
	        }
	      });
	      var domParser = global$4({}, schema);
	      domParser.addAttributeFilter('style', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.attr('style', filterStyles(editor, validStyles, node, node.attr('style')));
	          if (node.name === 'span' && node.parent && !node.attributes.length) {
	            node.unwrap();
	          }
	        }
	      });
	      domParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, className;
	        while (i--) {
	          node = nodes[i];
	          className = node.attr('class');
	          if (/^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(className)) {
	            node.remove();
	          }
	          node.attr('class', null);
	        }
	      });
	      domParser.addNodeFilter('del', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          nodes[i].remove();
	        }
	      });
	      domParser.addNodeFilter('a', function (nodes) {
	        var i = nodes.length, node, href, name;
	        while (i--) {
	          node = nodes[i];
	          href = node.attr('href');
	          name = node.attr('name');
	          if (href && href.indexOf('#_msocom_') !== -1) {
	            node.remove();
	            continue;
	          }
	          if (href && href.indexOf('file://') === 0) {
	            href = href.split('#')[1];
	            if (href) {
	              href = '#' + href;
	            }
	          }
	          if (!href && !name) {
	            node.unwrap();
	          } else {
	            if (name && !/^_?(?:toc|edn|ftn)/i.test(name)) {
	              node.unwrap();
	              continue;
	            }
	            node.attr({
	              href: href,
	              name: name
	            });
	          }
	        }
	      });
	      var rootNode = domParser.parse(content);
	      if (shouldConvertWordFakeLists(editor)) {
	        convertFakeListsToProperLists(rootNode);
	      }
	      content = global$3({ validate: getValidate(editor) }, schema).serialize(rootNode);
	      return content;
	    };
	    var preProcess$1 = function (editor, content) {
	      return shouldUseDefaultFilters(editor) ? filterWordContent(editor, content) : content;
	    };
	
	    var preProcess = function (editor, html) {
	      var parser = global$4({}, editor.schema);
	      parser.addNodeFilter('meta', function (nodes) {
	        global$6.each(nodes, function (node) {
	          node.remove();
	        });
	      });
	      var fragment = parser.parse(html, {
	        forced_root_block: false,
	        isRootContent: true
	      });
	      return global$3({ validate: getValidate(editor) }, editor.schema).serialize(fragment);
	    };
	    var processResult = function (content, cancelled) {
	      return {
	        content: content,
	        cancelled: cancelled
	      };
	    };
	    var postProcessFilter = function (editor, html, internal, isWordHtml) {
	      var tempBody = editor.dom.create('div', { style: 'display:none' }, html);
	      var postProcessArgs = firePastePostProcess(editor, tempBody, internal, isWordHtml);
	      return processResult(postProcessArgs.node.innerHTML, postProcessArgs.isDefaultPrevented());
	    };
	    var filterContent = function (editor, content, internal, isWordHtml) {
	      var preProcessArgs = firePastePreProcess(editor, content, internal, isWordHtml);
	      var filteredContent = preProcess(editor, preProcessArgs.content);
	      if (editor.hasEventListeners('PastePostProcess') && !preProcessArgs.isDefaultPrevented()) {
	        return postProcessFilter(editor, filteredContent, internal, isWordHtml);
	      } else {
	        return processResult(filteredContent, preProcessArgs.isDefaultPrevented());
	      }
	    };
	    var process = function (editor, html, internal) {
	      var isWordHtml = isWordContent(html);
	      var content = isWordHtml ? preProcess$1(editor, html) : html;
	      return filterContent(editor, content, internal, isWordHtml);
	    };
	
	    var pasteHtml$1 = function (editor, html) {
	      editor.insertContent(html, {
	        merge: shouldMergeFormats(editor),
	        paste: true
	      });
	      return true;
	    };
	    var isAbsoluteUrl = function (url) {
	      return /^https?:\/\/[\w\-\/+=.,!;:&%@^~(){}?#]+$/i.test(url);
	    };
	    var isImageUrl = function (editor, url) {
	      return isAbsoluteUrl(url) && exists(getAllowedImageFileTypes(editor), function (type) {
	        return endsWith(url.toLowerCase(), '.' + type.toLowerCase());
	      });
	    };
	    var createImage = function (editor, url, pasteHtmlFn) {
	      editor.undoManager.extra(function () {
	        pasteHtmlFn(editor, url);
	      }, function () {
	        editor.insertContent('<img src="' + url + '">');
	      });
	      return true;
	    };
	    var createLink = function (editor, url, pasteHtmlFn) {
	      editor.undoManager.extra(function () {
	        pasteHtmlFn(editor, url);
	      }, function () {
	        editor.execCommand('mceInsertLink', false, url);
	      });
	      return true;
	    };
	    var linkSelection = function (editor, html, pasteHtmlFn) {
	      return editor.selection.isCollapsed() === false && isAbsoluteUrl(html) ? createLink(editor, html, pasteHtmlFn) : false;
	    };
	    var insertImage = function (editor, html, pasteHtmlFn) {
	      return isImageUrl(editor, html) ? createImage(editor, html, pasteHtmlFn) : false;
	    };
	    var smartInsertContent = function (editor, html) {
	      global$6.each([
	        linkSelection,
	        insertImage,
	        pasteHtml$1
	      ], function (action) {
	        return action(editor, html, pasteHtml$1) !== true;
	      });
	    };
	    var insertContent = function (editor, html, pasteAsText) {
	      if (pasteAsText || isSmartPasteEnabled(editor) === false) {
	        pasteHtml$1(editor, html);
	      } else {
	        smartInsertContent(editor, html);
	      }
	    };
	
	    var isCollapsibleWhitespace = function (c) {
	      return ' \f\t\x0B'.indexOf(c) !== -1;
	    };
	    var isNewLineChar = function (c) {
	      return c === '\n' || c === '\r';
	    };
	    var isNewline = function (text, idx) {
	      return idx < text.length && idx >= 0 ? isNewLineChar(text[idx]) : false;
	    };
	    var normalizeWhitespace = function (editor, text) {
	      var tabSpace = repeat(' ', getTabSpaces(editor));
	      var normalizedText = text.replace(/\t/g, tabSpace);
	      var result = foldl(normalizedText, function (acc, c) {
	        if (isCollapsibleWhitespace(c) || c === nbsp) {
	          if (acc.pcIsSpace || acc.str === '' || acc.str.length === normalizedText.length - 1 || isNewline(normalizedText, acc.str.length + 1)) {
	            return {
	              pcIsSpace: false,
	              str: acc.str + nbsp
	            };
	          } else {
	            return {
	              pcIsSpace: true,
	              str: acc.str + ' '
	            };
	          }
	        } else {
	          return {
	            pcIsSpace: isNewLineChar(c),
	            str: acc.str + c
	          };
	        }
	      }, {
	        pcIsSpace: false,
	        str: ''
	      });
	      return result.str;
	    };
	
	    var doPaste = function (editor, content, internal, pasteAsText) {
	      var args = process(editor, content, internal);
	      if (args.cancelled === false) {
	        insertContent(editor, args.content, pasteAsText);
	      }
	    };
	    var pasteHtml = function (editor, html, internalFlag) {
	      var internal = internalFlag ? internalFlag : isMarked(html);
	      doPaste(editor, unmark(html), internal, false);
	    };
	    var pasteText = function (editor, text) {
	      var encodedText = editor.dom.encode(text).replace(/\r\n/g, '\n');
	      var normalizedText = normalizeWhitespace(editor, encodedText);
	      var html = convert(normalizedText, getForcedRootBlock(editor), getForcedRootBlockAttrs(editor));
	      doPaste(editor, html, false, true);
	    };
	    var getDataTransferItems = function (dataTransfer) {
	      var items = {};
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      if (dataTransfer) {
	        if (dataTransfer.getData) {
	          var legacyText = dataTransfer.getData('Text');
	          if (legacyText && legacyText.length > 0) {
	            if (legacyText.indexOf(mceInternalUrlPrefix) === -1) {
	              items['text/plain'] = legacyText;
	            }
	          }
	        }
	        if (dataTransfer.types) {
	          for (var i = 0; i < dataTransfer.types.length; i++) {
	            var contentType = dataTransfer.types[i];
	            try {
	              items[contentType] = dataTransfer.getData(contentType);
	            } catch (ex) {
	              items[contentType] = '';
	            }
	          }
	        }
	      }
	      return items;
	    };
	    var getClipboardContent = function (editor, clipboardEvent) {
	      return getDataTransferItems(clipboardEvent.clipboardData || editor.getDoc().dataTransfer);
	    };
	    var hasContentType = function (clipboardContent, mimeType) {
	      return mimeType in clipboardContent && clipboardContent[mimeType].length > 0;
	    };
	    var hasHtmlOrText = function (content) {
	      return hasContentType(content, 'text/html') || hasContentType(content, 'text/plain');
	    };
	    var parseDataUri = function (uri) {
	      var matches = /data:([^;]+);base64,([a-z0-9\+\/=]+)/i.exec(uri);
	      if (matches) {
	        return {
	          type: matches[1],
	          data: decodeURIComponent(matches[2])
	        };
	      } else {
	        return {
	          type: null,
	          data: null
	        };
	      }
	    };
	    var isValidDataUriImage = function (editor, imgElm) {
	      var filter = getImagesDataImgFilter(editor);
	      return filter ? filter(imgElm) : true;
	    };
	    var extractFilename = function (editor, str) {
	      var m = str.match(/([\s\S]+?)(?:\.[a-z0-9.]+)$/i);
	      return isNonNullable(m) ? editor.dom.encode(m[1]) : null;
	    };
	    var uniqueId = createIdGenerator('mceclip');
	    var pasteImage = function (editor, imageItem) {
	      var _a = parseDataUri(imageItem.uri), base64 = _a.data, type = _a.type;
	      var id = uniqueId();
	      var file = imageItem.blob;
	      var img = new Image();
	      img.src = imageItem.uri;
	      if (isValidDataUriImage(editor, img)) {
	        var blobCache = editor.editorUpload.blobCache;
	        var blobInfo = void 0;
	        var existingBlobInfo = blobCache.getByData(base64, type);
	        if (!existingBlobInfo) {
	          var useFileName = getImagesReuseFilename(editor) && isNonNullable(file.name);
	          var name_1 = useFileName ? extractFilename(editor, file.name) : id;
	          var filename = useFileName ? file.name : undefined;
	          blobInfo = blobCache.create(id, file, base64, name_1, filename);
	          blobCache.add(blobInfo);
	        } else {
	          blobInfo = existingBlobInfo;
	        }
	        pasteHtml(editor, '<img src="' + blobInfo.blobUri() + '">', false);
	      } else {
	        pasteHtml(editor, '<img src="' + imageItem.uri + '">', false);
	      }
	    };
	    var isClipboardEvent = function (event) {
	      return event.type === 'paste';
	    };
	    var isDataTransferItem = function (item) {
	      return isNonNullable(item.getAsFile);
	    };
	    var readFilesAsDataUris = function (items) {
	      return global$8.all(map(items, function (item) {
	        return new global$8(function (resolve) {
	          var blob = isDataTransferItem(item) ? item.getAsFile() : item;
	          var reader = new window.FileReader();
	          reader.onload = function () {
	            resolve({
	              blob: blob,
	              uri: reader.result
	            });
	          };
	          reader.readAsDataURL(blob);
	        });
	      }));
	    };
	    var isImage = function (editor) {
	      var allowedExtensions = getAllowedImageFileTypes(editor);
	      return function (file) {
	        return startsWith(file.type, 'image/') && exists(allowedExtensions, function (extension) {
	          return getImageMimeType(extension) === file.type;
	        });
	      };
	    };
	    var getImagesFromDataTransfer = function (editor, dataTransfer) {
	      var items = dataTransfer.items ? bind(from(dataTransfer.items), function (item) {
	        return item.kind === 'file' ? [item.getAsFile()] : [];
	      }) : [];
	      var files = dataTransfer.files ? from(dataTransfer.files) : [];
	      return filter$1(items.length > 0 ? items : files, isImage(editor));
	    };
	    var pasteImageData = function (editor, e, rng) {
	      var dataTransfer = isClipboardEvent(e) ? e.clipboardData : e.dataTransfer;
	      if (getPasteDataImages(editor) && dataTransfer) {
	        var images = getImagesFromDataTransfer(editor, dataTransfer);
	        if (images.length > 0) {
	          e.preventDefault();
	          readFilesAsDataUris(images).then(function (fileResults) {
	            if (rng) {
	              editor.selection.setRng(rng);
	            }
	            each(fileResults, function (result) {
	              pasteImage(editor, result);
	            });
	          });
	          return true;
	        }
	      }
	      return false;
	    };
	    var isBrokenAndroidClipboardEvent = function (e) {
	      var clipboardData = e.clipboardData;
	      return navigator.userAgent.indexOf('Android') !== -1 && clipboardData && clipboardData.items && clipboardData.items.length === 0;
	    };
	    var isKeyboardPasteEvent = function (e) {
	      return global$7.metaKeyPressed(e) && e.keyCode === 86 || e.shiftKey && e.keyCode === 45;
	    };
	    var registerEventHandlers = function (editor, pasteBin, pasteFormat) {
	      var keyboardPasteEvent = value();
	      var keyboardPastePressed = value();
	      var keyboardPastePlainTextState;
	      editor.on('keyup', keyboardPastePressed.clear);
	      editor.on('keydown', function (e) {
	        var removePasteBinOnKeyUp = function (e) {
	          if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	            pasteBin.remove();
	          }
	        };
	        if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	          keyboardPastePlainTextState = e.shiftKey && e.keyCode === 86;
	          if (keyboardPastePlainTextState && global$a.webkit && navigator.userAgent.indexOf('Version/') !== -1) {
	            return;
	          }
	          e.stopImmediatePropagation();
	          keyboardPasteEvent.set(e);
	          keyboardPastePressed.set(true);
	          if (global$a.ie && keyboardPastePlainTextState) {
	            e.preventDefault();
	            firePaste(editor, true);
	            return;
	          }
	          pasteBin.remove();
	          pasteBin.create();
	          editor.once('keyup', removePasteBinOnKeyUp);
	          editor.once('paste', function () {
	            editor.off('keyup', removePasteBinOnKeyUp);
	          });
	        }
	      });
	      var insertClipboardContent = function (editor, clipboardContent, isKeyBoardPaste, plainTextMode, internal) {
	        var content;
	        if (hasContentType(clipboardContent, 'text/html')) {
	          content = clipboardContent['text/html'];
	        } else {
	          content = pasteBin.getHtml();
	          internal = internal ? internal : isMarked(content);
	          if (pasteBin.isDefaultContent(content)) {
	            plainTextMode = true;
	          }
	        }
	        content = trimHtml(content);
	        pasteBin.remove();
	        var isPlainTextHtml = internal === false && isPlainText(content);
	        var isAbsoluteUrl$1 = isAbsoluteUrl(content);
	        if (!content.length || isPlainTextHtml && !isAbsoluteUrl$1) {
	          plainTextMode = true;
	        }
	        if (plainTextMode || isAbsoluteUrl$1) {
	          if (hasContentType(clipboardContent, 'text/plain') && isPlainTextHtml) {
	            content = clipboardContent['text/plain'];
	          } else {
	            content = innerText(content);
	          }
	        }
	        if (pasteBin.isDefaultContent(content)) {
	          if (!isKeyBoardPaste) {
	            editor.windowManager.alert('Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.');
	          }
	          return;
	        }
	        if (plainTextMode) {
	          pasteText(editor, content);
	        } else {
	          pasteHtml(editor, content, internal);
	        }
	      };
	      var getLastRng = function () {
	        return pasteBin.getLastRng() || editor.selection.getRng();
	      };
	      editor.on('paste', function (e) {
	        var isKeyboardPaste = keyboardPasteEvent.isSet() || keyboardPastePressed.isSet();
	        if (isKeyboardPaste) {
	          keyboardPasteEvent.clear();
	        }
	        var clipboardContent = getClipboardContent(editor, e);
	        var plainTextMode = pasteFormat.get() === 'text' || keyboardPastePlainTextState;
	        var internal = hasContentType(clipboardContent, internalHtmlMime());
	        keyboardPastePlainTextState = false;
	        if (e.isDefaultPrevented() || isBrokenAndroidClipboardEvent(e)) {
	          pasteBin.remove();
	          return;
	        }
	        if (!hasHtmlOrText(clipboardContent) && pasteImageData(editor, e, getLastRng())) {
	          pasteBin.remove();
	          return;
	        }
	        if (!isKeyboardPaste) {
	          e.preventDefault();
	        }
	        if (global$a.ie && (!isKeyboardPaste || e.ieFake) && !hasContentType(clipboardContent, 'text/html')) {
	          pasteBin.create();
	          editor.dom.bind(pasteBin.getEl(), 'paste', function (e) {
	            e.stopPropagation();
	          });
	          editor.getDoc().execCommand('Paste', false, null);
	          clipboardContent['text/html'] = pasteBin.getHtml();
	        }
	        if (hasContentType(clipboardContent, 'text/html')) {
	          e.preventDefault();
	          if (!internal) {
	            internal = isMarked(clipboardContent['text/html']);
	          }
	          insertClipboardContent(editor, clipboardContent, isKeyboardPaste, plainTextMode, internal);
	        } else {
	          global$9.setEditorTimeout(editor, function () {
	            insertClipboardContent(editor, clipboardContent, isKeyboardPaste, plainTextMode, internal);
	          }, 0);
	        }
	      });
	    };
	    var registerEventsAndFilters = function (editor, pasteBin, pasteFormat) {
	      registerEventHandlers(editor, pasteBin, pasteFormat);
	      var src;
	      editor.parser.addNodeFilter('img', function (nodes, name, args) {
	        var isPasteInsert = function (args) {
	          return args.data && args.data.paste === true;
	        };
	        var remove = function (node) {
	          if (!node.attr('data-mce-object') && src !== global$a.transparentSrc) {
	            node.remove();
	          }
	        };
	        var isWebKitFakeUrl = function (src) {
	          return src.indexOf('webkit-fake-url') === 0;
	        };
	        var isDataUri = function (src) {
	          return src.indexOf('data:') === 0;
	        };
	        if (!getPasteDataImages(editor) && isPasteInsert(args)) {
	          var i = nodes.length;
	          while (i--) {
	            src = nodes[i].attr('src');
	            if (!src) {
	              continue;
	            }
	            if (isWebKitFakeUrl(src)) {
	              remove(nodes[i]);
	            } else if (!getAllowHtmlDataUrls(editor) && isDataUri(src)) {
	              remove(nodes[i]);
	            }
	          }
	        }
	      });
	    };
	
	    var getPasteBinParent = function (editor) {
	      return global$a.ie && editor.inline ? document.body : editor.getBody();
	    };
	    var isExternalPasteBin = function (editor) {
	      return getPasteBinParent(editor) !== editor.getBody();
	    };
	    var delegatePasteEvents = function (editor, pasteBinElm, pasteBinDefaultContent) {
	      if (isExternalPasteBin(editor)) {
	        editor.dom.bind(pasteBinElm, 'paste keyup', function (_e) {
	          if (!isDefault(editor, pasteBinDefaultContent)) {
	            editor.fire('paste');
	          }
	        });
	      }
	    };
	    var create = function (editor, lastRngCell, pasteBinDefaultContent) {
	      var dom = editor.dom, body = editor.getBody();
	      lastRngCell.set(editor.selection.getRng());
	      var pasteBinElm = editor.dom.add(getPasteBinParent(editor), 'div', {
	        'id': 'mcepastebin',
	        'class': 'mce-pastebin',
	        'contentEditable': true,
	        'data-mce-bogus': 'all',
	        'style': 'position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0'
	      }, pasteBinDefaultContent);
	      if (global$a.ie || global$a.gecko) {
	        dom.setStyle(pasteBinElm, 'left', dom.getStyle(body, 'direction', true) === 'rtl' ? 65535 : -65535);
	      }
	      dom.bind(pasteBinElm, 'beforedeactivate focusin focusout', function (e) {
	        e.stopPropagation();
	      });
	      delegatePasteEvents(editor, pasteBinElm, pasteBinDefaultContent);
	      pasteBinElm.focus();
	      editor.selection.select(pasteBinElm, true);
	    };
	    var remove = function (editor, lastRngCell) {
	      if (getEl(editor)) {
	        var pasteBinClone = void 0;
	        var lastRng = lastRngCell.get();
	        while (pasteBinClone = editor.dom.get('mcepastebin')) {
	          editor.dom.remove(pasteBinClone);
	          editor.dom.unbind(pasteBinClone);
	        }
	        if (lastRng) {
	          editor.selection.setRng(lastRng);
	        }
	      }
	      lastRngCell.set(null);
	    };
	    var getEl = function (editor) {
	      return editor.dom.get('mcepastebin');
	    };
	    var getHtml = function (editor) {
	      var copyAndRemove = function (toElm, fromElm) {
	        toElm.appendChild(fromElm);
	        editor.dom.remove(fromElm, true);
	      };
	      var pasteBinClones = global$6.grep(getPasteBinParent(editor).childNodes, function (elm) {
	        return elm.id === 'mcepastebin';
	      });
	      var pasteBinElm = pasteBinClones.shift();
	      global$6.each(pasteBinClones, function (pasteBinClone) {
	        copyAndRemove(pasteBinElm, pasteBinClone);
	      });
	      var dirtyWrappers = editor.dom.select('div[id=mcepastebin]', pasteBinElm);
	      for (var i = dirtyWrappers.length - 1; i >= 0; i--) {
	        var cleanWrapper = editor.dom.create('div');
	        pasteBinElm.insertBefore(cleanWrapper, dirtyWrappers[i]);
	        copyAndRemove(cleanWrapper, dirtyWrappers[i]);
	      }
	      return pasteBinElm ? pasteBinElm.innerHTML : '';
	    };
	    var isDefaultContent = function (pasteBinDefaultContent, content) {
	      return content === pasteBinDefaultContent;
	    };
	    var isPasteBin = function (elm) {
	      return elm && elm.id === 'mcepastebin';
	    };
	    var isDefault = function (editor, pasteBinDefaultContent) {
	      var pasteBinElm = getEl(editor);
	      return isPasteBin(pasteBinElm) && isDefaultContent(pasteBinDefaultContent, pasteBinElm.innerHTML);
	    };
	    var PasteBin = function (editor) {
	      var lastRng = Cell(null);
	      var pasteBinDefaultContent = '%MCEPASTEBIN%';
	      return {
	        create: function () {
	          return create(editor, lastRng, pasteBinDefaultContent);
	        },
	        remove: function () {
	          return remove(editor, lastRng);
	        },
	        getEl: function () {
	          return getEl(editor);
	        },
	        getHtml: function () {
	          return getHtml(editor);
	        },
	        getLastRng: lastRng.get,
	        isDefault: function () {
	          return isDefault(editor, pasteBinDefaultContent);
	        },
	        isDefaultContent: function (content) {
	          return isDefaultContent(pasteBinDefaultContent, content);
	        }
	      };
	    };
	
	    var Clipboard = function (editor, pasteFormat) {
	      var pasteBin = PasteBin(editor);
	      editor.on('PreInit', function () {
	        return registerEventsAndFilters(editor, pasteBin, pasteFormat);
	      });
	      return {
	        pasteFormat: pasteFormat,
	        pasteHtml: function (html, internalFlag) {
	          return pasteHtml(editor, html, internalFlag);
	        },
	        pasteText: function (text) {
	          return pasteText(editor, text);
	        },
	        pasteImageData: function (e, rng) {
	          return pasteImageData(editor, e, rng);
	        },
	        getDataTransferItems: getDataTransferItems,
	        hasHtmlOrText: hasHtmlOrText,
	        hasContentType: hasContentType
	      };
	    };
	
	    var togglePlainTextPaste = function (editor, clipboard) {
	      if (clipboard.pasteFormat.get() === 'text') {
	        clipboard.pasteFormat.set('html');
	        firePastePlainTextToggle(editor, false);
	      } else {
	        clipboard.pasteFormat.set('text');
	        firePastePlainTextToggle(editor, true);
	      }
	      editor.focus();
	    };
	
	    var register$2 = function (editor, clipboard) {
	      editor.addCommand('mceTogglePlainTextPaste', function () {
	        togglePlainTextPaste(editor, clipboard);
	      });
	      editor.addCommand('mceInsertClipboardContent', function (ui, value) {
	        if (value.content) {
	          clipboard.pasteHtml(value.content, value.internal);
	        }
	        if (value.text) {
	          clipboard.pasteText(value.text);
	        }
	      });
	    };
	
	    var hasWorkingClipboardApi = function (clipboardData) {
	      return global$a.iOS === false && typeof (clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.setData) === 'function';
	    };
	    var setHtml5Clipboard = function (clipboardData, html, text) {
	      if (hasWorkingClipboardApi(clipboardData)) {
	        try {
	          clipboardData.clearData();
	          clipboardData.setData('text/html', html);
	          clipboardData.setData('text/plain', text);
	          clipboardData.setData(internalHtmlMime(), html);
	          return true;
	        } catch (e) {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    };
	    var setClipboardData = function (evt, data, fallback, done) {
	      if (setHtml5Clipboard(evt.clipboardData, data.html, data.text)) {
	        evt.preventDefault();
	        done();
	      } else {
	        fallback(data.html, done);
	      }
	    };
	    var fallback = function (editor) {
	      return function (html, done) {
	        var markedHtml = mark(html);
	        var outer = editor.dom.create('div', {
	          'contenteditable': 'false',
	          'data-mce-bogus': 'all'
	        });
	        var inner = editor.dom.create('div', { contenteditable: 'true' }, markedHtml);
	        editor.dom.setStyles(outer, {
	          position: 'fixed',
	          top: '0',
	          left: '-3000px',
	          width: '1000px',
	          overflow: 'hidden'
	        });
	        outer.appendChild(inner);
	        editor.dom.add(editor.getBody(), outer);
	        var range = editor.selection.getRng();
	        inner.focus();
	        var offscreenRange = editor.dom.createRng();
	        offscreenRange.selectNodeContents(inner);
	        editor.selection.setRng(offscreenRange);
	        global$9.setTimeout(function () {
	          editor.selection.setRng(range);
	          outer.parentNode.removeChild(outer);
	          done();
	        }, 0);
	      };
	    };
	    var getData = function (editor) {
	      return {
	        html: editor.selection.getContent({ contextual: true }),
	        text: editor.selection.getContent({ format: 'text' })
	      };
	    };
	    var isTableSelection = function (editor) {
	      return !!editor.dom.getParent(editor.selection.getStart(), 'td[data-mce-selected],th[data-mce-selected]', editor.getBody());
	    };
	    var hasSelectedContent = function (editor) {
	      return !editor.selection.isCollapsed() || isTableSelection(editor);
	    };
	    var cut = function (editor) {
	      return function (evt) {
	        if (hasSelectedContent(editor)) {
	          setClipboardData(evt, getData(editor), fallback(editor), function () {
	            if (global$a.browser.isChrome() || global$a.browser.isFirefox()) {
	              var rng_1 = editor.selection.getRng();
	              global$9.setEditorTimeout(editor, function () {
	                editor.selection.setRng(rng_1);
	                editor.execCommand('Delete');
	              }, 0);
	            } else {
	              editor.execCommand('Delete');
	            }
	          });
	        }
	      };
	    };
	    var copy = function (editor) {
	      return function (evt) {
	        if (hasSelectedContent(editor)) {
	          setClipboardData(evt, getData(editor), fallback(editor), noop);
	        }
	      };
	    };
	    var register$1 = function (editor) {
	      editor.on('cut', cut(editor));
	      editor.on('copy', copy(editor));
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');
	
	    var getCaretRangeFromEvent = function (editor, e) {
	      return global.getCaretRangeFromPoint(e.clientX, e.clientY, editor.getDoc());
	    };
	    var isPlainTextFileUrl = function (content) {
	      var plainTextContent = content['text/plain'];
	      return plainTextContent ? plainTextContent.indexOf('file://') === 0 : false;
	    };
	    var setFocusedRange = function (editor, rng) {
	      editor.focus();
	      editor.selection.setRng(rng);
	    };
	    var setup$2 = function (editor, clipboard, draggingInternallyState) {
	      if (shouldBlockDrop(editor)) {
	        editor.on('dragend dragover draggesture dragdrop drop drag', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        });
	      }
	      if (!shouldPasteDataImages(editor)) {
	        editor.on('drop', function (e) {
	          var dataTransfer = e.dataTransfer;
	          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
	            e.preventDefault();
	          }
	        });
	      }
	      editor.on('drop', function (e) {
	        var rng = getCaretRangeFromEvent(editor, e);
	        if (e.isDefaultPrevented() || draggingInternallyState.get()) {
	          return;
	        }
	        var dropContent = clipboard.getDataTransferItems(e.dataTransfer);
	        var internal = clipboard.hasContentType(dropContent, internalHtmlMime());
	        if ((!clipboard.hasHtmlOrText(dropContent) || isPlainTextFileUrl(dropContent)) && clipboard.pasteImageData(e, rng)) {
	          return;
	        }
	        if (rng && shouldFilterDrop(editor)) {
	          var content_1 = dropContent['mce-internal'] || dropContent['text/html'] || dropContent['text/plain'];
	          if (content_1) {
	            e.preventDefault();
	            global$9.setEditorTimeout(editor, function () {
	              editor.undoManager.transact(function () {
	                if (dropContent['mce-internal']) {
	                  editor.execCommand('Delete');
	                }
	                setFocusedRange(editor, rng);
	                content_1 = trimHtml(content_1);
	                if (!dropContent['text/html']) {
	                  clipboard.pasteText(content_1);
	                } else {
	                  clipboard.pasteHtml(content_1, internal);
	                }
	              });
	            });
	          }
	        }
	      });
	      editor.on('dragstart', function (_e) {
	        draggingInternallyState.set(true);
	      });
	      editor.on('dragover dragend', function (e) {
	        if (shouldPasteDataImages(editor) && draggingInternallyState.get() === false) {
	          e.preventDefault();
	          setFocusedRange(editor, getCaretRangeFromEvent(editor, e));
	        }
	        if (e.type === 'dragend') {
	          draggingInternallyState.set(false);
	        }
	      });
	    };
	
	    var setup$1 = function (editor) {
	      var plugin = editor.plugins.paste;
	      var preProcess = getPreProcess(editor);
	      if (preProcess) {
	        editor.on('PastePreProcess', function (e) {
	          preProcess.call(plugin, plugin, e);
	        });
	      }
	      var postProcess = getPostProcess(editor);
	      if (postProcess) {
	        editor.on('PastePostProcess', function (e) {
	          postProcess.call(plugin, plugin, e);
	        });
	      }
	    };
	
	    var addPreProcessFilter = function (editor, filterFunc) {
	      editor.on('PastePreProcess', function (e) {
	        e.content = filterFunc(editor, e.content, e.internal, e.wordContent);
	      });
	    };
	    var addPostProcessFilter = function (editor, filterFunc) {
	      editor.on('PastePostProcess', function (e) {
	        filterFunc(editor, e.node);
	      });
	    };
	    var removeExplorerBrElementsAfterBlocks = function (editor, html) {
	      if (!isWordContent(html)) {
	        return html;
	      }
	      var blockElements = [];
	      global$6.each(editor.schema.getBlockElements(), function (block, blockName) {
	        blockElements.push(blockName);
	      });
	      var explorerBlocksRegExp = new RegExp('(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(' + blockElements.join('|') + ')[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*', 'g');
	      html = filter(html, [[
	          explorerBlocksRegExp,
	          '$1'
	        ]]);
	      html = filter(html, [
	        [
	          /<br><br>/g,
	          '<BR><BR>'
	        ],
	        [
	          /<br>/g,
	          ' '
	        ],
	        [
	          /<BR><BR>/g,
	          '<br>'
	        ]
	      ]);
	      return html;
	    };
	    var removeWebKitStyles = function (editor, content, internal, isWordHtml) {
	      if (isWordHtml || internal) {
	        return content;
	      }
	      var webKitStylesSetting = getWebkitStyles(editor);
	      var webKitStyles;
	      if (shouldRemoveWebKitStyles(editor) === false || webKitStylesSetting === 'all') {
	        return content;
	      }
	      if (webKitStylesSetting) {
	        webKitStyles = webKitStylesSetting.split(/[, ]/);
	      }
	      if (webKitStyles) {
	        var dom_1 = editor.dom, node_1 = editor.selection.getNode();
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function (all, before, value, after) {
	          var inputStyles = dom_1.parseStyle(dom_1.decode(value));
	          var outputStyles = {};
	          if (webKitStyles === 'none') {
	            return before + after;
	          }
	          for (var i = 0; i < webKitStyles.length; i++) {
	            var inputValue = inputStyles[webKitStyles[i]], currentValue = dom_1.getStyle(node_1, webKitStyles[i], true);
	            if (/color/.test(webKitStyles[i])) {
	              inputValue = dom_1.toHex(inputValue);
	              currentValue = dom_1.toHex(currentValue);
	            }
	            if (currentValue !== inputValue) {
	              outputStyles[webKitStyles[i]] = inputValue;
	            }
	          }
	          var outputStyle = dom_1.serializeStyle(outputStyles, 'span');
	          if (outputStyle) {
	            return before + ' style="' + outputStyle + '"' + after;
	          }
	          return before + after;
	        });
	      } else {
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, '$1$3');
	      }
	      content = content.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function (all, before, value, after) {
	        return before + ' style="' + value + '"' + after;
	      });
	      return content;
	    };
	    var removeUnderlineAndFontInAnchor = function (editor, root) {
	      editor.$('a', root).find('font,u').each(function (i, node) {
	        editor.dom.remove(node, true);
	      });
	    };
	    var setup = function (editor) {
	      if (global$a.webkit) {
	        addPreProcessFilter(editor, removeWebKitStyles);
	      }
	      if (global$a.ie) {
	        addPreProcessFilter(editor, removeExplorerBrElementsAfterBlocks);
	        addPostProcessFilter(editor, removeUnderlineAndFontInAnchor);
	      }
	    };
	
	    var makeSetupHandler = function (editor, clipboard) {
	      return function (api) {
	        api.setActive(clipboard.pasteFormat.get() === 'text');
	        var pastePlainTextToggleHandler = function (e) {
	          return api.setActive(e.state);
	        };
	        editor.on('PastePlainTextToggle', pastePlainTextToggleHandler);
	        return function () {
	          return editor.off('PastePlainTextToggle', pastePlainTextToggleHandler);
	        };
	      };
	    };
	    var register = function (editor, clipboard) {
	      var onAction = function () {
	        return editor.execCommand('mceTogglePlainTextPaste');
	      };
	      editor.ui.registry.addToggleButton('pastetext', {
	        active: false,
	        icon: 'paste-text',
	        tooltip: 'Paste as text',
	        onAction: onAction,
	        onSetup: makeSetupHandler(editor, clipboard)
	      });
	      editor.ui.registry.addToggleMenuItem('pastetext', {
	        text: 'Paste as text',
	        icon: 'paste-text',
	        onAction: onAction,
	        onSetup: makeSetupHandler(editor, clipboard)
	      });
	    };
	
	    function Plugin () {
	      global$b.add('paste', function (editor) {
	        if (hasProPlugin(editor) === false) {
	          var draggingInternallyState = Cell(false);
	          var pasteFormat = Cell(isPasteAsTextEnabled(editor) ? 'text' : 'html');
	          var clipboard = Clipboard(editor, pasteFormat);
	          setup(editor);
	          register(editor, clipboard);
	          register$2(editor, clipboard);
	          setup$1(editor);
	          register$1(editor);
	          setup$2(editor, clipboard, draggingInternallyState);
	          return get(clipboard);
	        }
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2253 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getContentStyle = function (editor) {
	      return editor.getParam('content_style', '', 'string');
	    };
	    var shouldUseContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors', false, 'boolean');
	    };
	    var getBodyClassByHash = function (editor) {
	      var bodyClass = editor.getParam('body_class', '', 'hash');
	      return bodyClass[editor.id] || '';
	    };
	    var getBodyClass = function (editor) {
	      var bodyClass = editor.getParam('body_class', '', 'string');
	      if (bodyClass.indexOf('=') === -1) {
	        return bodyClass;
	      } else {
	        return getBodyClassByHash(editor);
	      }
	    };
	    var getBodyIdByHash = function (editor) {
	      var bodyId = editor.getParam('body_id', '', 'hash');
	      return bodyId[editor.id] || bodyId;
	    };
	    var getBodyId = function (editor) {
	      var bodyId = editor.getParam('body_id', 'tinymce', 'string');
	      if (bodyId.indexOf('=') === -1) {
	        return bodyId;
	      } else {
	        return getBodyIdByHash(editor);
	      }
	    };
	
	    var getPreviewHtml = function (editor) {
	      var headHtml = '';
	      var encode = editor.dom.encode;
	      var contentStyle = getContentStyle(editor);
	      headHtml += '<base href="' + encode(editor.documentBaseURI.getURI()) + '">';
	      var cors = shouldUseContentCssCors(editor) ? ' crossorigin="anonymous"' : '';
	      global.each(editor.contentCSS, function (url) {
	        headHtml += '<link type="text/css" rel="stylesheet" href="' + encode(editor.documentBaseURI.toAbsolute(url)) + '"' + cors + '>';
	      });
	      if (contentStyle) {
	        headHtml += '<style type="text/css">' + contentStyle + '</style>';
	      }
	      var bodyId = getBodyId(editor);
	      var bodyClass = getBodyClass(editor);
	      var isMetaKeyPressed = global$1.mac ? 'e.metaKey' : 'e.ctrlKey && !e.altKey';
	      var preventClicksOnLinksScript = '<script>' + 'document.addEventListener && document.addEventListener("click", function(e) {' + 'for (var elm = e.target; elm; elm = elm.parentNode) {' + 'if (elm.nodeName === "A" && !(' + isMetaKeyPressed + ')) {' + 'e.preventDefault();' + '}' + '}' + '}, false);' + '</script> ';
	      var directionality = editor.getBody().dir;
	      var dirAttr = directionality ? ' dir="' + encode(directionality) + '"' : '';
	      var previewHtml = '<!DOCTYPE html>' + '<html>' + '<head>' + headHtml + '</head>' + '<body id="' + encode(bodyId) + '" class="mce-content-body ' + encode(bodyClass) + '"' + dirAttr + '>' + editor.getContent() + preventClicksOnLinksScript + '</body>' + '</html>';
	      return previewHtml;
	    };
	
	    var open = function (editor) {
	      var content = getPreviewHtml(editor);
	      var dataApi = editor.windowManager.open({
	        title: 'Preview',
	        size: 'large',
	        body: {
	          type: 'panel',
	          items: [{
	              name: 'preview',
	              type: 'iframe',
	              sandboxed: true
	            }]
	        },
	        buttons: [{
	            type: 'cancel',
	            name: 'close',
	            text: 'Close',
	            primary: true
	          }],
	        initialData: { preview: content }
	      });
	      dataApi.focus('close');
	    };
	
	    var register$1 = function (editor) {
	      editor.addCommand('mcePreview', function () {
	        open(editor);
	      });
	    };
	
	    var register = function (editor) {
	      var onAction = function () {
	        return editor.execCommand('mcePreview');
	      };
	      editor.ui.registry.addButton('preview', {
	        icon: 'preview',
	        tooltip: 'Preview',
	        onAction: onAction
	      });
	      editor.ui.registry.addMenuItem('preview', {
	        icon: 'preview',
	        text: 'Preview',
	        onAction: onAction
	      });
	    };
	
	    function Plugin () {
	      global$2.add('preview', function (editor) {
	        register$1(editor);
	        register(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2254 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType$1 = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var isString = isType$1('string');
	    var isArray = isType$1('array');
	    var isBoolean = isSimpleType('boolean');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var punctuationStr = '[!-#%-*,-\\/:;?@\\[-\\]_{}\xA1\xAB\xB7\xBB\xBF;\xB7\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1361-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u3008\u3009\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30\u2E31\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uff3f\uFF5B\uFF5D\uFF5F-\uFF65]';
	
	    var punctuation$1 = constant(punctuationStr);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var punctuation = punctuation$1;
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var groupBy = function (xs, f) {
	      if (xs.length === 0) {
	        return [];
	      } else {
	        var wasType = f(xs[0]);
	        var r = [];
	        var group = [];
	        for (var i = 0, len = xs.length; i < len; i++) {
	          var x = xs[i];
	          var type = f(x);
	          if (type !== wasType) {
	            r.push(group);
	            group = [];
	          }
	          wasType = type;
	          group.push(x);
	        }
	        if (group.length !== 0) {
	          r.push(group);
	        }
	        return r;
	      }
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var sort = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	
	    var hasOwnProperty = Object.hasOwnProperty;
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	
	    typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isText$1 = isType(TEXT);
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_PRECEDING);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var children = function (element) {
	      return map(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var spot = function (element, offset) {
	      return {
	        element: element,
	        offset: offset
	      };
	    };
	    var leaf = function (element, offset) {
	      var cs = children(element);
	      return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
	    };
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	    var wrap = function (element, wrapper) {
	      before(element, wrapper);
	      append(wrapper, element);
	    };
	
	    var NodeValue = function (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom.nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	
	    var api = NodeValue(isText$1, 'text');
	    var get$1 = function (element) {
	      return api.get(element);
	    };
	
	    var descendants = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');
	
	    var isSimpleBoundary = function (dom, node) {
	      return dom.isBlock(node) || has(dom.schema.getShortEndedElements(), node.nodeName);
	    };
	    var isContentEditableFalse = function (dom, node) {
	      return dom.getContentEditable(node) === 'false';
	    };
	    var isContentEditableTrueInCef = function (dom, node) {
	      return dom.getContentEditable(node) === 'true' && dom.getContentEditableParent(node.parentNode) === 'false';
	    };
	    var isHidden = function (dom, node) {
	      return !dom.isBlock(node) && has(dom.schema.getWhiteSpaceElements(), node.nodeName);
	    };
	    var isBoundary = function (dom, node) {
	      return isSimpleBoundary(dom, node) || isContentEditableFalse(dom, node) || isHidden(dom, node) || isContentEditableTrueInCef(dom, node);
	    };
	    var isText = function (node) {
	      return node.nodeType === 3;
	    };
	    var nuSection = function () {
	      return {
	        sOffset: 0,
	        fOffset: 0,
	        elements: []
	      };
	    };
	    var toLeaf = function (node, offset) {
	      return leaf(SugarElement.fromDom(node), offset);
	    };
	    var walk = function (dom, walkerFn, startNode, callbacks, endNode, skipStart) {
	      if (skipStart === void 0) {
	        skipStart = true;
	      }
	      var next = skipStart ? walkerFn(false) : startNode;
	      while (next) {
	        var isCefNode = isContentEditableFalse(dom, next);
	        if (isCefNode || isHidden(dom, next)) {
	          var stopWalking = isCefNode ? callbacks.cef(next) : callbacks.boundary(next);
	          if (stopWalking) {
	            break;
	          } else {
	            next = walkerFn(true);
	            continue;
	          }
	        } else if (isSimpleBoundary(dom, next)) {
	          if (callbacks.boundary(next)) {
	            break;
	          }
	        } else if (isText(next)) {
	          callbacks.text(next);
	        }
	        if (next === endNode) {
	          break;
	        } else {
	          next = walkerFn(false);
	        }
	      }
	    };
	    var collectTextToBoundary = function (dom, section, node, rootNode, forwards) {
	      if (isBoundary(dom, node)) {
	        return;
	      }
	      var rootBlock = dom.getParent(rootNode, dom.isBlock);
	      var walker = new global(node, rootBlock);
	      var walkerFn = forwards ? walker.next.bind(walker) : walker.prev.bind(walker);
	      walk(dom, walkerFn, node, {
	        boundary: always,
	        cef: always,
	        text: function (next) {
	          if (forwards) {
	            section.fOffset += next.length;
	          } else {
	            section.sOffset += next.length;
	          }
	          section.elements.push(SugarElement.fromDom(next));
	        }
	      });
	    };
	    var collect = function (dom, rootNode, startNode, endNode, callbacks, skipStart) {
	      if (skipStart === void 0) {
	        skipStart = true;
	      }
	      var walker = new global(startNode, rootNode);
	      var sections = [];
	      var current = nuSection();
	      collectTextToBoundary(dom, current, startNode, rootNode, false);
	      var finishSection = function () {
	        if (current.elements.length > 0) {
	          sections.push(current);
	          current = nuSection();
	        }
	        return false;
	      };
	      walk(dom, walker.next.bind(walker), startNode, {
	        boundary: finishSection,
	        cef: function (node) {
	          finishSection();
	          if (callbacks) {
	            sections.push.apply(sections, callbacks.cef(node));
	          }
	          return false;
	        },
	        text: function (next) {
	          current.elements.push(SugarElement.fromDom(next));
	          if (callbacks) {
	            callbacks.text(next, current);
	          }
	        }
	      }, endNode, skipStart);
	      if (endNode) {
	        collectTextToBoundary(dom, current, endNode, rootNode, true);
	      }
	      finishSection();
	      return sections;
	    };
	    var collectRangeSections = function (dom, rng) {
	      var start = toLeaf(rng.startContainer, rng.startOffset);
	      var startNode = start.element.dom;
	      var end = toLeaf(rng.endContainer, rng.endOffset);
	      var endNode = end.element.dom;
	      return collect(dom, rng.commonAncestorContainer, startNode, endNode, {
	        text: function (node, section) {
	          if (node === endNode) {
	            section.fOffset += node.length - end.offset;
	          } else if (node === startNode) {
	            section.sOffset += start.offset;
	          }
	        },
	        cef: function (node) {
	          var sections = bind(descendants(SugarElement.fromDom(node), '*[contenteditable=true]'), function (e) {
	            var ceTrueNode = e.dom;
	            return collect(dom, ceTrueNode, ceTrueNode);
	          });
	          return sort(sections, function (a, b) {
	            return documentPositionPreceding(a.elements[0].dom, b.elements[0].dom) ? 1 : -1;
	          });
	        }
	      }, false);
	    };
	    var fromRng = function (dom, rng) {
	      return rng.collapsed ? [] : collectRangeSections(dom, rng);
	    };
	    var fromNode = function (dom, node) {
	      var rng = dom.createRng();
	      rng.selectNode(node);
	      return fromRng(dom, rng);
	    };
	    var fromNodes = function (dom, nodes) {
	      return bind(nodes, function (node) {
	        return fromNode(dom, node);
	      });
	    };
	
	    var find$2 = function (text, pattern, start, finish) {
	      if (start === void 0) {
	        start = 0;
	      }
	      if (finish === void 0) {
	        finish = text.length;
	      }
	      var regex = pattern.regex;
	      regex.lastIndex = start;
	      var results = [];
	      var match;
	      while (match = regex.exec(text)) {
	        var matchedText = match[pattern.matchIndex];
	        var matchStart = match.index + match[0].indexOf(matchedText);
	        var matchFinish = matchStart + matchedText.length;
	        if (matchFinish > finish) {
	          break;
	        }
	        results.push({
	          start: matchStart,
	          finish: matchFinish
	        });
	        regex.lastIndex = matchFinish;
	      }
	      return results;
	    };
	    var extract = function (elements, matches) {
	      var nodePositions = foldl(elements, function (acc, element) {
	        var content = get$1(element);
	        var start = acc.last;
	        var finish = start + content.length;
	        var positions = bind(matches, function (match, matchIdx) {
	          if (match.start < finish && match.finish > start) {
	            return [{
	                element: element,
	                start: Math.max(start, match.start) - start,
	                finish: Math.min(finish, match.finish) - start,
	                matchId: matchIdx
	              }];
	          } else {
	            return [];
	          }
	        });
	        return {
	          results: acc.results.concat(positions),
	          last: finish
	        };
	      }, {
	        results: [],
	        last: 0
	      }).results;
	      return groupBy(nodePositions, function (position) {
	        return position.matchId;
	      });
	    };
	
	    var find$1 = function (pattern, sections) {
	      return bind(sections, function (section) {
	        var elements = section.elements;
	        var content = map(elements, get$1).join('');
	        var positions = find$2(content, pattern, section.sOffset, content.length - section.fOffset);
	        return extract(elements, positions);
	      });
	    };
	    var mark = function (matches, replacementNode) {
	      eachr(matches, function (match, idx) {
	        eachr(match, function (pos) {
	          var wrapper = SugarElement.fromDom(replacementNode.cloneNode(false));
	          set(wrapper, 'data-mce-index', idx);
	          var textNode = pos.element.dom;
	          if (textNode.length === pos.finish && pos.start === 0) {
	            wrap(pos.element, wrapper);
	          } else {
	            if (textNode.length !== pos.finish) {
	              textNode.splitText(pos.finish);
	            }
	            var matchNode = textNode.splitText(pos.start);
	            wrap(SugarElement.fromDom(matchNode), wrapper);
	          }
	        });
	      });
	    };
	    var findAndMark = function (dom, pattern, node, replacementNode) {
	      var textSections = fromNode(dom, node);
	      var matches = find$1(pattern, textSections);
	      mark(matches, replacementNode);
	      return matches.length;
	    };
	    var findAndMarkInSelection = function (dom, pattern, selection, replacementNode) {
	      var bookmark = selection.getBookmark();
	      var nodes = dom.select('td[data-mce-selected],th[data-mce-selected]');
	      var textSections = nodes.length > 0 ? fromNodes(dom, nodes) : fromRng(dom, selection.getRng());
	      var matches = find$1(pattern, textSections);
	      mark(matches, replacementNode);
	      selection.moveToBookmark(bookmark);
	      return matches.length;
	    };
	
	    var getElmIndex = function (elm) {
	      var value = elm.getAttribute('data-mce-index');
	      if (typeof value === 'number') {
	        return '' + value;
	      }
	      return value;
	    };
	    var markAllMatches = function (editor, currentSearchState, pattern, inSelection) {
	      var marker = editor.dom.create('span', { 'data-mce-bogus': 1 });
	      marker.className = 'mce-match-marker';
	      var node = editor.getBody();
	      done(editor, currentSearchState, false);
	      if (inSelection) {
	        return findAndMarkInSelection(editor.dom, pattern, editor.selection, marker);
	      } else {
	        return findAndMark(editor.dom, pattern, node, marker);
	      }
	    };
	    var unwrap = function (node) {
	      var parentNode = node.parentNode;
	      if (node.firstChild) {
	        parentNode.insertBefore(node.firstChild, node);
	      }
	      node.parentNode.removeChild(node);
	    };
	    var findSpansByIndex = function (editor, index) {
	      var spans = [];
	      var nodes = global$1.toArray(editor.getBody().getElementsByTagName('span'));
	      if (nodes.length) {
	        for (var i = 0; i < nodes.length; i++) {
	          var nodeIndex = getElmIndex(nodes[i]);
	          if (nodeIndex === null || !nodeIndex.length) {
	            continue;
	          }
	          if (nodeIndex === index.toString()) {
	            spans.push(nodes[i]);
	          }
	        }
	      }
	      return spans;
	    };
	    var moveSelection = function (editor, currentSearchState, forward) {
	      var searchState = currentSearchState.get();
	      var testIndex = searchState.index;
	      var dom = editor.dom;
	      forward = forward !== false;
	      if (forward) {
	        if (testIndex + 1 === searchState.count) {
	          testIndex = 0;
	        } else {
	          testIndex++;
	        }
	      } else {
	        if (testIndex - 1 === -1) {
	          testIndex = searchState.count - 1;
	        } else {
	          testIndex--;
	        }
	      }
	      dom.removeClass(findSpansByIndex(editor, searchState.index), 'mce-match-marker-selected');
	      var spans = findSpansByIndex(editor, testIndex);
	      if (spans.length) {
	        dom.addClass(findSpansByIndex(editor, testIndex), 'mce-match-marker-selected');
	        editor.selection.scrollIntoView(spans[0]);
	        return testIndex;
	      }
	      return -1;
	    };
	    var removeNode = function (dom, node) {
	      var parent = node.parentNode;
	      dom.remove(node);
	      if (dom.isEmpty(parent)) {
	        dom.remove(parent);
	      }
	    };
	    var escapeSearchText = function (text, wholeWord) {
	      var escapedText = text.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&').replace(/\s/g, '[^\\S\\r\\n\\uFEFF]');
	      var wordRegex = '(' + escapedText + ')';
	      return wholeWord ? '(?:^|\\s|' + punctuation() + ')' + wordRegex + ('(?=$|\\s|' + punctuation() + ')') : wordRegex;
	    };
	    var find = function (editor, currentSearchState, text, matchCase, wholeWord, inSelection) {
	      var selection = editor.selection;
	      var escapedText = escapeSearchText(text, wholeWord);
	      var isForwardSelection = selection.isForward();
	      var pattern = {
	        regex: new RegExp(escapedText, matchCase ? 'g' : 'gi'),
	        matchIndex: 1
	      };
	      var count = markAllMatches(editor, currentSearchState, pattern, inSelection);
	      if (global$2.browser.isSafari()) {
	        selection.setRng(selection.getRng(), isForwardSelection);
	      }
	      if (count) {
	        var newIndex = moveSelection(editor, currentSearchState, true);
	        currentSearchState.set({
	          index: newIndex,
	          count: count,
	          text: text,
	          matchCase: matchCase,
	          wholeWord: wholeWord,
	          inSelection: inSelection
	        });
	      }
	      return count;
	    };
	    var next = function (editor, currentSearchState) {
	      var index = moveSelection(editor, currentSearchState, true);
	      currentSearchState.set(__assign(__assign({}, currentSearchState.get()), { index: index }));
	    };
	    var prev = function (editor, currentSearchState) {
	      var index = moveSelection(editor, currentSearchState, false);
	      currentSearchState.set(__assign(__assign({}, currentSearchState.get()), { index: index }));
	    };
	    var isMatchSpan = function (node) {
	      var matchIndex = getElmIndex(node);
	      return matchIndex !== null && matchIndex.length > 0;
	    };
	    var replace = function (editor, currentSearchState, text, forward, all) {
	      var searchState = currentSearchState.get();
	      var currentIndex = searchState.index;
	      var currentMatchIndex, nextIndex = currentIndex;
	      forward = forward !== false;
	      var node = editor.getBody();
	      var nodes = global$1.grep(global$1.toArray(node.getElementsByTagName('span')), isMatchSpan);
	      for (var i = 0; i < nodes.length; i++) {
	        var nodeIndex = getElmIndex(nodes[i]);
	        var matchIndex = currentMatchIndex = parseInt(nodeIndex, 10);
	        if (all || matchIndex === searchState.index) {
	          if (text.length) {
	            nodes[i].firstChild.nodeValue = text;
	            unwrap(nodes[i]);
	          } else {
	            removeNode(editor.dom, nodes[i]);
	          }
	          while (nodes[++i]) {
	            matchIndex = parseInt(getElmIndex(nodes[i]), 10);
	            if (matchIndex === currentMatchIndex) {
	              removeNode(editor.dom, nodes[i]);
	            } else {
	              i--;
	              break;
	            }
	          }
	          if (forward) {
	            nextIndex--;
	          }
	        } else if (currentMatchIndex > currentIndex) {
	          nodes[i].setAttribute('data-mce-index', String(currentMatchIndex - 1));
	        }
	      }
	      currentSearchState.set(__assign(__assign({}, searchState), {
	        count: all ? 0 : searchState.count - 1,
	        index: nextIndex
	      }));
	      if (forward) {
	        next(editor, currentSearchState);
	      } else {
	        prev(editor, currentSearchState);
	      }
	      return !all && currentSearchState.get().count > 0;
	    };
	    var done = function (editor, currentSearchState, keepEditorSelection) {
	      var startContainer, endContainer;
	      var searchState = currentSearchState.get();
	      var nodes = global$1.toArray(editor.getBody().getElementsByTagName('span'));
	      for (var i = 0; i < nodes.length; i++) {
	        var nodeIndex = getElmIndex(nodes[i]);
	        if (nodeIndex !== null && nodeIndex.length) {
	          if (nodeIndex === searchState.index.toString()) {
	            if (!startContainer) {
	              startContainer = nodes[i].firstChild;
	            }
	            endContainer = nodes[i].firstChild;
	          }
	          unwrap(nodes[i]);
	        }
	      }
	      currentSearchState.set(__assign(__assign({}, searchState), {
	        index: -1,
	        count: 0,
	        text: ''
	      }));
	      if (startContainer && endContainer) {
	        var rng = editor.dom.createRng();
	        rng.setStart(startContainer, 0);
	        rng.setEnd(endContainer, endContainer.data.length);
	        if (keepEditorSelection !== false) {
	          editor.selection.setRng(rng);
	        }
	        return rng;
	      }
	    };
	    var hasNext = function (editor, currentSearchState) {
	      return currentSearchState.get().count > 1;
	    };
	    var hasPrev = function (editor, currentSearchState) {
	      return currentSearchState.get().count > 1;
	    };
	
	    var get = function (editor, currentState) {
	      var done$1 = function (keepEditorSelection) {
	        return done(editor, currentState, keepEditorSelection);
	      };
	      var find$1 = function (text, matchCase, wholeWord, inSelection) {
	        if (inSelection === void 0) {
	          inSelection = false;
	        }
	        return find(editor, currentState, text, matchCase, wholeWord, inSelection);
	      };
	      var next$1 = function () {
	        return next(editor, currentState);
	      };
	      var prev$1 = function () {
	        return prev(editor, currentState);
	      };
	      var replace$1 = function (text, forward, all) {
	        return replace(editor, currentState, text, forward, all);
	      };
	      return {
	        done: done$1,
	        find: find$1,
	        next: next$1,
	        prev: prev$1,
	        replace: replace$1
	      };
	    };
	
	    var singleton = function (doRevoke) {
	      var subject = Cell(Optional.none());
	      var revoke = function () {
	        return subject.get().each(doRevoke);
	      };
	      var clear = function () {
	        revoke();
	        subject.set(Optional.none());
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var get = function () {
	        return subject.get();
	      };
	      var set = function (s) {
	        revoke();
	        subject.set(Optional.some(s));
	      };
	      return {
	        clear: clear,
	        isSet: isSet,
	        get: get,
	        set: set
	      };
	    };
	    var value = function () {
	      var subject = singleton(noop);
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return __assign(__assign({}, subject), { on: on });
	    };
	
	    var open = function (editor, currentSearchState) {
	      var dialogApi = value();
	      editor.undoManager.add();
	      var selectedText = global$1.trim(editor.selection.getContent({ format: 'text' }));
	      var updateButtonStates = function (api) {
	        var updateNext = hasNext(editor, currentSearchState) ? api.enable : api.disable;
	        updateNext('next');
	        var updatePrev = hasPrev(editor, currentSearchState) ? api.enable : api.disable;
	        updatePrev('prev');
	      };
	      var updateSearchState = function (api) {
	        var data = api.getData();
	        var current = currentSearchState.get();
	        currentSearchState.set(__assign(__assign({}, current), {
	          matchCase: data.matchcase,
	          wholeWord: data.wholewords,
	          inSelection: data.inselection
	        }));
	      };
	      var disableAll = function (api, disable) {
	        var buttons = [
	          'replace',
	          'replaceall',
	          'prev',
	          'next'
	        ];
	        var toggle = disable ? api.disable : api.enable;
	        each(buttons, toggle);
	      };
	      var notFoundAlert = function (api) {
	        editor.windowManager.alert('Could not find the specified string.', function () {
	          api.focus('findtext');
	        });
	      };
	      var focusButtonIfRequired = function (api, name) {
	        if (global$2.browser.isSafari() && global$2.deviceType.isTouch() && (name === 'find' || name === 'replace' || name === 'replaceall')) {
	          api.focus(name);
	        }
	      };
	      var reset = function (api) {
	        done(editor, currentSearchState, false);
	        disableAll(api, true);
	        updateButtonStates(api);
	      };
	      var doFind = function (api) {
	        var data = api.getData();
	        var last = currentSearchState.get();
	        if (!data.findtext.length) {
	          reset(api);
	          return;
	        }
	        if (last.text === data.findtext && last.matchCase === data.matchcase && last.wholeWord === data.wholewords) {
	          next(editor, currentSearchState);
	        } else {
	          var count = find(editor, currentSearchState, data.findtext, data.matchcase, data.wholewords, data.inselection);
	          if (count <= 0) {
	            notFoundAlert(api);
	          }
	          disableAll(api, count === 0);
	        }
	        updateButtonStates(api);
	      };
	      var initialState = currentSearchState.get();
	      var initialData = {
	        findtext: selectedText,
	        replacetext: '',
	        wholewords: initialState.wholeWord,
	        matchcase: initialState.matchCase,
	        inselection: initialState.inSelection
	      };
	      var spec = {
	        title: 'Find and Replace',
	        size: 'normal',
	        body: {
	          type: 'panel',
	          items: [
	            {
	              type: 'bar',
	              items: [
	                {
	                  type: 'input',
	                  name: 'findtext',
	                  placeholder: 'Find',
	                  maximized: true,
	                  inputMode: 'search'
	                },
	                {
	                  type: 'button',
	                  name: 'prev',
	                  text: 'Previous',
	                  icon: 'action-prev',
	                  disabled: true,
	                  borderless: true
	                },
	                {
	                  type: 'button',
	                  name: 'next',
	                  text: 'Next',
	                  icon: 'action-next',
	                  disabled: true,
	                  borderless: true
	                }
	              ]
	            },
	            {
	              type: 'input',
	              name: 'replacetext',
	              placeholder: 'Replace with',
	              inputMode: 'search'
	            }
	          ]
	        },
	        buttons: [
	          {
	            type: 'menu',
	            name: 'options',
	            icon: 'preferences',
	            tooltip: 'Preferences',
	            align: 'start',
	            items: [
	              {
	                type: 'togglemenuitem',
	                name: 'matchcase',
	                text: 'Match case'
	              },
	              {
	                type: 'togglemenuitem',
	                name: 'wholewords',
	                text: 'Find whole words only'
	              },
	              {
	                type: 'togglemenuitem',
	                name: 'inselection',
	                text: 'Find in selection'
	              }
	            ]
	          },
	          {
	            type: 'custom',
	            name: 'find',
	            text: 'Find',
	            primary: true
	          },
	          {
	            type: 'custom',
	            name: 'replace',
	            text: 'Replace',
	            disabled: true
	          },
	          {
	            type: 'custom',
	            name: 'replaceall',
	            text: 'Replace all',
	            disabled: true
	          }
	        ],
	        initialData: initialData,
	        onChange: function (api, details) {
	          if (details.name === 'findtext' && currentSearchState.get().count > 0) {
	            reset(api);
	          }
	        },
	        onAction: function (api, details) {
	          var data = api.getData();
	          switch (details.name) {
	          case 'find':
	            doFind(api);
	            break;
	          case 'replace':
	            if (!replace(editor, currentSearchState, data.replacetext)) {
	              reset(api);
	            } else {
	              updateButtonStates(api);
	            }
	            break;
	          case 'replaceall':
	            replace(editor, currentSearchState, data.replacetext, true, true);
	            reset(api);
	            break;
	          case 'prev':
	            prev(editor, currentSearchState);
	            updateButtonStates(api);
	            break;
	          case 'next':
	            next(editor, currentSearchState);
	            updateButtonStates(api);
	            break;
	          case 'matchcase':
	          case 'wholewords':
	          case 'inselection':
	            updateSearchState(api);
	            reset(api);
	            break;
	          }
	          focusButtonIfRequired(api, details.name);
	        },
	        onSubmit: function (api) {
	          doFind(api);
	          focusButtonIfRequired(api, 'find');
	        },
	        onClose: function () {
	          editor.focus();
	          done(editor, currentSearchState);
	          editor.undoManager.add();
	        }
	      };
	      dialogApi.set(editor.windowManager.open(spec, { inline: 'toolbar' }));
	    };
	
	    var register$1 = function (editor, currentSearchState) {
	      editor.addCommand('SearchReplace', function () {
	        open(editor, currentSearchState);
	      });
	    };
	
	    var showDialog = function (editor, currentSearchState) {
	      return function () {
	        open(editor, currentSearchState);
	      };
	    };
	    var register = function (editor, currentSearchState) {
	      editor.ui.registry.addMenuItem('searchreplace', {
	        text: 'Find and replace...',
	        shortcut: 'Meta+F',
	        onAction: showDialog(editor, currentSearchState),
	        icon: 'search'
	      });
	      editor.ui.registry.addButton('searchreplace', {
	        tooltip: 'Find and replace',
	        onAction: showDialog(editor, currentSearchState),
	        icon: 'search'
	      });
	      editor.shortcuts.add('Meta+F', '', showDialog(editor, currentSearchState));
	    };
	
	    function Plugin () {
	      global$3.add('searchreplace', function (editor) {
	        var currentSearchState = Cell({
	          index: -1,
	          count: 0,
	          text: '',
	          matchCase: false,
	          wholeWord: false,
	          inSelection: false
	        });
	        register$1(editor, currentSearchState);
	        register(editor, currentSearchState);
	        return get(editor, currentSearchState);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2255 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType$1 = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq$2 = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType$1('string');
	    var isObject = isType$1('object');
	    var isArray = isType$1('array');
	    var isNull = eq$2(null);
	    var isBoolean = isSimpleType('boolean');
	    var isUndefined = eq$2(undefined);
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var compose1 = function (fbc, fab) {
	      return function (a) {
	        return fbc(fab(a));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    var tripleEquals = function (a, b) {
	      return a === b;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function (t) {
	        return !f(t);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none$2 = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none$2,
	        each: noop,
	        bind: none$2,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none$2();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from$1 = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none$2,
	      from: from$1
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var contains$2 = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var range$1 = function (num, f) {
	      var r = [];
	      for (var i = 0; i < num; i++) {
	        r.push(f(i));
	      }
	      return r;
	    };
	    var map$1 = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each$2 = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var partition = function (xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i) ? pass : fail;
	        arr.push(x);
	      }
	      return {
	        pass: pass,
	        fail: fail
	      };
	    };
	    var filter$2 = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each$2(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find$1 = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(i);
	        }
	      }
	      return Optional.none();
	    };
	    var flatten$1 = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind$2 = function (xs, f) {
	      return flatten$1(map$1(xs, f));
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var mapToObject = function (xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	    var pure = function (x) {
	      return [x];
	    };
	    var sort$1 = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	    var get$d = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get$d(xs, 0);
	    };
	    var last$2 = function (xs) {
	      return get$d(xs, xs.length - 1);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __spreadArray(to, from, pack) {
	      if (pack || arguments.length === 2)
	        for (var i = 0, l = from.length, ar; i < l; i++) {
	          if (ar || !(i in from)) {
	            if (!ar)
	              ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	          }
	        }
	      return to.concat(ar || Array.prototype.slice.call(from));
	    }
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var DeviceType = function (os, browser, userAgent, mediaMatch) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isMobile = os.isiOS() || os.isAndroid();
	      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
	      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
	      var isPhone = isiPhone || isMobile && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      var isDesktop = !isPhone && !isTablet && !iOSwebview;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview),
	        isDesktop: constant(isDesktop)
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu$2(group(1), group(2));
	    };
	    var detect$6 = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown$2();
	      }
	      return find(versionRegexes, cleanedAgent);
	    };
	    var unknown$2 = function () {
	      return nu$2(0, 0);
	    };
	    var nu$2 = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu$2,
	      detect: detect$6,
	      unknown: unknown$2
	    };
	
	    var detectBrowser$1 = function (browsers, userAgentData) {
	      return findMap(userAgentData.brands, function (uaBrand) {
	        var lcBrand = uaBrand.brand.toLowerCase();
	        return find$1(browsers, function (browser) {
	          var _a;
	          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
	        }).map(function (info) {
	          return {
	            current: info.name,
	            version: Version.nu(parseInt(uaBrand.version, 10), 0)
	          };
	        });
	      });
	    };
	
	    var detect$5 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find$1(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$5(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$5(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	
	    var removeFromStart = function (str, numChars) {
	      return str.substring(numChars);
	    };
	
	    var checkRange = function (str, substr, start) {
	      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
	    };
	    var removeLeading = function (str, prefix) {
	      return startsWith(str, prefix) ? removeFromStart(str, prefix.length) : str;
	    };
	    var contains$1 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var startsWith = function (str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	    var endsWith = function (str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	    var blank = function (r) {
	      return function (s) {
	        return s.replace(r, '');
	      };
	    };
	    var trim = blank(/^\s+|\s+$/g);
	    var isNotEmpty = function (s) {
	      return s.length > 0;
	    };
	    var isEmpty$1 = function (s) {
	      return !isNotEmpty(s);
	    };
	    var toFloat = function (value) {
	      var num = parseFloat(value);
	      return isNaN(num) ? Optional.none() : Optional.some(num);
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$1(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        brand: 'Chromium',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('mac os x'),
	        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      },
	      {
	        name: 'ChromeOS',
	        search: checkContains('cros'),
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isBrowser = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge),
	        isChrome: isBrowser(chrome),
	        isIE: isBrowser(ie),
	        isOpera: isBrowser(opera),
	        isFirefox: isBrowser(firefox),
	        isSafari: isBrowser(safari)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var chromeos = 'ChromeOS';
	    var unknown = function () {
	      return nu({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isOS = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows),
	        isiOS: isOS(ios),
	        isAndroid: isOS(android),
	        isOSX: isOS(osx),
	        isLinux: isOS(linux),
	        isSolaris: isOS(solaris),
	        isFreeBSD: isOS(freebsd),
	        isChromeOS: isOS(chromeos)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown,
	      nu: nu,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd),
	      chromeos: constant(chromeos)
	    };
	
	    var detect$4 = function (userAgent, userAgentDataOpt, mediaMatch) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = userAgentDataOpt.bind(function (userAgentData) {
	        return detectBrowser$1(browsers, userAgentData);
	      }).orThunk(function () {
	        return detectBrowser(browsers, userAgent);
	      }).fold(Browser.unknown, Browser.nu);
	      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$4 };
	
	    var mediaMatch = function (query) {
	      return window.matchMedia(query).matches;
	    };
	    var platform = cached(function () {
	      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
	    });
	    var detect$3 = function () {
	      return platform();
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    var COMMENT = 8;
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom$1(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom$1(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom$1(node);
	    };
	    var fromDom$1 = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint$1 = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom$1);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml$1,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom$1,
	      fromPoint: fromPoint$1
	    };
	
	    var is$2 = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all$1 = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map$1(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
	    };
	
	    var eq$1 = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom;
	      var d2 = e2.dom;
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return documentPositionContainedBy(e1.dom, e2.dom);
	    };
	    var contains = function (e1, e2) {
	      return detect$3().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
	    };
	    var is$1 = is$2;
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter$1 = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var mapToArray = function (obj, f) {
	      var r = [];
	      each$1(obj, function (value, name) {
	        r.push(f(value, name));
	      });
	      return r;
	    };
	    var values = function (obj) {
	      return mapToArray(obj, identity);
	    };
	    var size = function (obj) {
	      return keys(obj).length;
	    };
	    var get$c = function (obj, key) {
	      return has$1(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has$1 = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has$1(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	    var isEmpty = function (r) {
	      for (var x in r) {
	        if (hasOwnProperty.call(r, x)) {
	          return false;
	        }
	      }
	      return true;
	    };
	
	    var validSectionList = [
	      'tfoot',
	      'thead',
	      'tbody',
	      'colgroup'
	    ];
	    var isValidSection = function (parentName) {
	      return contains$2(validSectionList, parentName);
	    };
	    var grid = function (rows, columns) {
	      return {
	        rows: rows,
	        columns: columns
	      };
	    };
	    var address = function (row, column) {
	      return {
	        row: row,
	        column: column
	      };
	    };
	    var detail = function (element, rowspan, colspan) {
	      return {
	        element: element,
	        rowspan: rowspan,
	        colspan: colspan
	      };
	    };
	    var detailnew = function (element, rowspan, colspan, isNew) {
	      return {
	        element: element,
	        rowspan: rowspan,
	        colspan: colspan,
	        isNew: isNew
	      };
	    };
	    var extended = function (element, rowspan, colspan, row, column, isLocked) {
	      return {
	        element: element,
	        rowspan: rowspan,
	        colspan: colspan,
	        row: row,
	        column: column,
	        isLocked: isLocked
	      };
	    };
	    var rowdetail = function (element, cells, section) {
	      return {
	        element: element,
	        cells: cells,
	        section: section
	      };
	    };
	    var rowdetailnew = function (element, cells, section, isNew) {
	      return {
	        element: element,
	        cells: cells,
	        section: section,
	        isNew: isNew
	      };
	    };
	    var elementnew = function (element, isNew, isLocked) {
	      return {
	        element: element,
	        isNew: isNew,
	        isLocked: isLocked
	      };
	    };
	    var rowcells = function (element, cells, section, isNew) {
	      return {
	        element: element,
	        cells: cells,
	        section: section,
	        isNew: isNew
	      };
	    };
	    var bounds = function (startRow, startCol, finishRow, finishCol) {
	      return {
	        startRow: startRow,
	        startCol: startCol,
	        finishRow: finishRow,
	        finishCol: finishCol
	      };
	    };
	    var columnext = function (element, colspan, column) {
	      return {
	        element: element,
	        colspan: colspan,
	        column: column
	      };
	    };
	    var colgroup = function (element, columns) {
	      return {
	        element: element,
	        columns: columns
	      };
	    };
	
	    typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var name = function (element) {
	      var r = element.dom.nodeName;
	      return r.toLowerCase();
	    };
	    var type$1 = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType = function (t) {
	      return function (element) {
	        return type$1(element) === t;
	      };
	    };
	    var isComment = function (element) {
	      return type$1(element) === COMMENT || name(element) === '#comment';
	    };
	    var isElement = isType(ELEMENT);
	    var isText = isType(TEXT);
	    var isDocument = isType(DOCUMENT);
	    var isDocumentFragment = isType(DOCUMENT_FRAGMENT);
	    var isTag = function (tag) {
	      return function (e) {
	        return isElement(e) && name(e) === tag;
	      };
	    };
	
	    var owner = function (element) {
	      return SugarElement.fromDom(element.dom.ownerDocument);
	    };
	    var documentOrOwner = function (dos) {
	      return isDocument(dos) ? dos : owner(dos);
	    };
	    var defaultView = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
	    };
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var parentElement = function (element) {
	      return Optional.from(element.dom.parentElement).map(SugarElement.fromDom);
	    };
	    var parents = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom;
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = SugarElement.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var prevSibling = function (element) {
	      return Optional.from(element.dom.previousSibling).map(SugarElement.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
	    };
	    var children$3 = function (element) {
	      return map$1(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var child$3 = function (element, index) {
	      var cs = element.dom.childNodes;
	      return Optional.from(cs[index]).map(SugarElement.fromDom);
	    };
	    var firstChild = function (element) {
	      return child$3(element, 0);
	    };
	
	    var isShadowRoot = function (dos) {
	      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
	    };
	    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
	    var isSupported$1 = constant(supported);
	    var getRootNode = supported ? function (e) {
	      return SugarElement.fromDom(e.dom.getRootNode());
	    } : documentOrOwner;
	    var getShadowRoot = function (e) {
	      var r = getRootNode(e);
	      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
	    };
	    var getShadowHost = function (e) {
	      return SugarElement.fromDom(e.dom.host);
	    };
	    var getOriginalEventTarget = function (event) {
	      if (isSupported$1() && isNonNullable(event.target)) {
	        var el = SugarElement.fromDom(event.target);
	        if (isElement(el) && isOpenShadowHost(el)) {
	          if (event.composed && event.composedPath) {
	            var composedPath = event.composedPath();
	            if (composedPath) {
	              return head(composedPath);
	            }
	          }
	        }
	      }
	      return Optional.from(event.target);
	    };
	    var isOpenShadowHost = function (element) {
	      return isNonNullable(element.dom.shadowRoot);
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom.parentNode : element.dom;
	      if (dom === undefined || dom === null || dom.ownerDocument === null) {
	        return false;
	      }
	      var doc = dom.ownerDocument;
	      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
	        return doc.body.contains(dom);
	      }, compose1(inBody, getShadowHost));
	    };
	    var body$1 = function () {
	      return getBody$1(SugarElement.fromDom(document));
	    };
	    var getBody$1 = function (doc) {
	      var b = doc.dom.body;
	      if (b === null || b === undefined) {
	        throw new Error('Body is not available yet');
	      }
	      return SugarElement.fromDom(b);
	    };
	
	    var ancestors$4 = function (scope, predicate, isRoot) {
	      return filter$2(parents(scope, isRoot), predicate);
	    };
	    var children$2 = function (scope, predicate) {
	      return filter$2(children$3(scope), predicate);
	    };
	    var descendants$1 = function (scope, predicate) {
	      var result = [];
	      each$2(children$3(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([x]);
	        }
	        result = result.concat(descendants$1(x, predicate));
	      });
	      return result;
	    };
	
	    var ancestors$3 = function (scope, selector, isRoot) {
	      return ancestors$4(scope, function (e) {
	        return is$2(e, selector);
	      }, isRoot);
	    };
	    var children$1 = function (scope, selector) {
	      return children$2(scope, function (e) {
	        return is$2(e, selector);
	      });
	    };
	    var descendants = function (scope, selector) {
	      return all$1(selector, scope);
	    };
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      if (is(scope, a)) {
	        return Optional.some(scope);
	      } else if (isFunction(isRoot) && isRoot(scope)) {
	        return Optional.none();
	      } else {
	        return ancestor(scope, a, isRoot);
	      }
	    }
	
	    var ancestor$2 = function (scope, predicate, isRoot) {
	      var element = scope.dom;
	      var stop = isFunction(isRoot) ? isRoot : never;
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        if (predicate(el)) {
	          return Optional.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest$2 = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor$2, scope, predicate, isRoot);
	    };
	    var child$2 = function (scope, predicate) {
	      var pred = function (node) {
	        return predicate(SugarElement.fromDom(node));
	      };
	      var result = find$1(scope.dom.childNodes, pred);
	      return result.map(SugarElement.fromDom);
	    };
	    var descendant$1 = function (scope, predicate) {
	      var descend = function (node) {
	        for (var i = 0; i < node.childNodes.length; i++) {
	          var child_1 = SugarElement.fromDom(node.childNodes[i]);
	          if (predicate(child_1)) {
	            return Optional.some(child_1);
	          }
	          var res = descend(node.childNodes[i]);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Optional.none();
	      };
	      return descend(scope.dom);
	    };
	
	    var ancestor$1 = function (scope, selector, isRoot) {
	      return ancestor$2(scope, function (e) {
	        return is$2(e, selector);
	      }, isRoot);
	    };
	    var child$1 = function (scope, selector) {
	      return child$2(scope, function (e) {
	        return is$2(e, selector);
	      });
	    };
	    var descendant = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$1 = function (scope, selector, isRoot) {
	      var is = function (element, selector) {
	        return is$2(element, selector);
	      };
	      return ClosestOrAncestor(is, ancestor$1, scope, selector, isRoot);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set$2 = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var setAll$1 = function (element, attrs) {
	      var dom = element.dom;
	      each$1(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var setOptions = function (element, attrs) {
	      each$1(attrs, function (v, k) {
	        v.fold(function () {
	          remove$7(element, k);
	        }, function (value) {
	          rawSet(element.dom, k, value);
	        });
	      });
	    };
	    var get$b = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var getOpt = function (element, key) {
	      return Optional.from(get$b(element, key));
	    };
	    var remove$7 = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	    var clone$2 = function (element) {
	      return foldl(element.dom.attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var is = function (lhs, rhs, comparator) {
	      if (comparator === void 0) {
	        comparator = tripleEquals;
	      }
	      return lhs.exists(function (left) {
	        return comparator(left, rhs);
	      });
	    };
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
	    };
	    var bindFrom = function (a, f) {
	      return a !== undefined && a !== null ? f(a) : Optional.none();
	    };
	    var flatten = function (oot) {
	      return oot.bind(identity);
	    };
	    var someIf = function (b, a) {
	      return b ? Optional.some(a) : Optional.none();
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var internalRemove = function (dom, property) {
	      if (isSupported(dom)) {
	        dom.style.removeProperty(property);
	      }
	    };
	    var set$1 = function (element, property, value) {
	      var dom = element.dom;
	      internalSet(dom, property, value);
	    };
	    var setAll = function (element, css) {
	      var dom = element.dom;
	      each$1(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$a = function (element, property) {
	      var dom = element.dom;
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw$2 = function (element, property) {
	      var dom = element.dom;
	      var raw = getUnsafeProperty(dom, property);
	      return Optional.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var remove$6 = function (element, property) {
	      var dom = element.dom;
	      internalRemove(dom, property);
	      if (is(getOpt(element, 'style').map(trim), '')) {
	        remove$7(element, 'style');
	      }
	    };
	    var copy$2 = function (source, target) {
	      var sourceDom = source.dom;
	      var targetDom = target.dom;
	      if (isSupported(sourceDom) && isSupported(targetDom)) {
	        targetDom.style.cssText = sourceDom.style.cssText;
	      }
	    };
	
	    var getAttrValue = function (cell, name, fallback) {
	      if (fallback === void 0) {
	        fallback = 0;
	      }
	      return getOpt(cell, name).map(function (value) {
	        return parseInt(value, 10);
	      }).getOr(fallback);
	    };
	    var getSpan = function (cell, type) {
	      return getAttrValue(cell, type, 1);
	    };
	    var hasColspan = function (cellOrCol) {
	      if (isTag('col')(cellOrCol)) {
	        return getAttrValue(cellOrCol, 'span', 1) > 1;
	      } else {
	        return getSpan(cellOrCol, 'colspan') > 1;
	      }
	    };
	    var hasRowspan = function (cell) {
	      return getSpan(cell, 'rowspan') > 1;
	    };
	    var getCssValue = function (element, property) {
	      return parseInt(get$a(element, property), 10);
	    };
	    var minWidth = constant(10);
	    var minHeight = constant(10);
	
	    var firstLayer = function (scope, selector) {
	      return filterFirstLayer(scope, selector, always);
	    };
	    var filterFirstLayer = function (scope, selector, predicate) {
	      return bind$2(children$3(scope), function (x) {
	        if (is$2(x, selector)) {
	          return predicate(x) ? [x] : [];
	        } else {
	          return filterFirstLayer(x, selector, predicate);
	        }
	      });
	    };
	
	    var lookup = function (tags, element, isRoot) {
	      if (isRoot === void 0) {
	        isRoot = never;
	      }
	      if (isRoot(element)) {
	        return Optional.none();
	      }
	      if (contains$2(tags, name(element))) {
	        return Optional.some(element);
	      }
	      var isRootOrUpperTable = function (elm) {
	        return is$2(elm, 'table') || isRoot(elm);
	      };
	      return ancestor$1(element, tags.join(','), isRootOrUpperTable);
	    };
	    var cell = function (element, isRoot) {
	      return lookup([
	        'td',
	        'th'
	      ], element, isRoot);
	    };
	    var cells$1 = function (ancestor) {
	      return firstLayer(ancestor, 'th,td');
	    };
	    var columns$1 = function (ancestor) {
	      if (is$2(ancestor, 'colgroup')) {
	        return children$1(ancestor, 'col');
	      } else {
	        return bind$2(columnGroups(ancestor), function (columnGroup) {
	          return children$1(columnGroup, 'col');
	        });
	      }
	    };
	    var table = function (element, isRoot) {
	      return closest$1(element, 'table', isRoot);
	    };
	    var rows$1 = function (ancestor) {
	      return firstLayer(ancestor, 'tr');
	    };
	    var columnGroups = function (ancestor) {
	      return table(ancestor).fold(constant([]), function (table) {
	        return children$1(table, 'colgroup');
	      });
	    };
	
	    var fromRowsOrColGroups = function (elems, getSection) {
	      return map$1(elems, function (row) {
	        if (name(row) === 'colgroup') {
	          var cells = map$1(columns$1(row), function (column) {
	            var colspan = getAttrValue(column, 'span', 1);
	            return detail(column, 1, colspan);
	          });
	          return rowdetail(row, cells, 'colgroup');
	        } else {
	          var cells = map$1(cells$1(row), function (cell) {
	            var rowspan = getAttrValue(cell, 'rowspan', 1);
	            var colspan = getAttrValue(cell, 'colspan', 1);
	            return detail(cell, rowspan, colspan);
	          });
	          return rowdetail(row, cells, getSection(row));
	        }
	      });
	    };
	    var getParentSection = function (group) {
	      return parent(group).map(function (parent) {
	        var parentName = name(parent);
	        return isValidSection(parentName) ? parentName : 'tbody';
	      }).getOr('tbody');
	    };
	    var fromTable$1 = function (table) {
	      var rows = rows$1(table);
	      var columnGroups$1 = columnGroups(table);
	      var elems = __spreadArray(__spreadArray([], columnGroups$1, true), rows, true);
	      return fromRowsOrColGroups(elems, getParentSection);
	    };
	    var fromPastedRows = function (elems, section) {
	      return fromRowsOrColGroups(elems, function () {
	        return section;
	      });
	    };
	
	    var addCells = function (gridRow, index, cells) {
	      var existingCells = gridRow.cells;
	      var before = existingCells.slice(0, index);
	      var after = existingCells.slice(index);
	      var newCells = before.concat(cells).concat(after);
	      return setCells(gridRow, newCells);
	    };
	    var addCell = function (gridRow, index, cell) {
	      return addCells(gridRow, index, [cell]);
	    };
	    var mutateCell = function (gridRow, index, cell) {
	      var cells = gridRow.cells;
	      cells[index] = cell;
	    };
	    var setCells = function (gridRow, cells) {
	      return rowcells(gridRow.element, cells, gridRow.section, gridRow.isNew);
	    };
	    var mapCells = function (gridRow, f) {
	      var cells = gridRow.cells;
	      var r = map$1(cells, f);
	      return rowcells(gridRow.element, r, gridRow.section, gridRow.isNew);
	    };
	    var getCell = function (gridRow, index) {
	      return gridRow.cells[index];
	    };
	    var getCellElement = function (gridRow, index) {
	      return getCell(gridRow, index).element;
	    };
	    var cellLength = function (gridRow) {
	      return gridRow.cells.length;
	    };
	    var extractGridDetails = function (grid) {
	      var result = partition(grid, function (row) {
	        return row.section === 'colgroup';
	      });
	      return {
	        rows: result.fail,
	        cols: result.pass
	      };
	    };
	    var clone$1 = function (gridRow, cloneRow, cloneCell) {
	      var newCells = map$1(gridRow.cells, cloneCell);
	      return rowcells(cloneRow(gridRow.element), newCells, gridRow.section, true);
	    };
	
	    var LOCKED_COL_ATTR = 'data-snooker-locked-cols';
	    var getLockedColumnsFromTable = function (table) {
	      return getOpt(table, LOCKED_COL_ATTR).bind(function (lockedColStr) {
	        return Optional.from(lockedColStr.match(/\d+/g));
	      }).map(function (lockedCols) {
	        return mapToObject(lockedCols, always);
	      });
	    };
	    var getLockedColumnsFromGrid = function (grid) {
	      var locked = foldl(extractGridDetails(grid).rows, function (acc, row) {
	        each$2(row.cells, function (cell, idx) {
	          if (cell.isLocked) {
	            acc[idx] = true;
	          }
	        });
	        return acc;
	      }, {});
	      var lockedArr = mapToArray(locked, function (_val, key) {
	        return parseInt(key, 10);
	      });
	      return sort$1(lockedArr);
	    };
	
	    var key = function (row, column) {
	      return row + ',' + column;
	    };
	    var getAt = function (warehouse, row, column) {
	      return Optional.from(warehouse.access[key(row, column)]);
	    };
	    var findItem = function (warehouse, item, comparator) {
	      var filtered = filterItems(warehouse, function (detail) {
	        return comparator(item, detail.element);
	      });
	      return filtered.length > 0 ? Optional.some(filtered[0]) : Optional.none();
	    };
	    var filterItems = function (warehouse, predicate) {
	      var all = bind$2(warehouse.all, function (r) {
	        return r.cells;
	      });
	      return filter$2(all, predicate);
	    };
	    var generateColumns = function (rowData) {
	      var columnsGroup = {};
	      var index = 0;
	      each$2(rowData.cells, function (column) {
	        var colspan = column.colspan;
	        range$1(colspan, function (columnIndex) {
	          var colIndex = index + columnIndex;
	          columnsGroup[colIndex] = columnext(column.element, colspan, colIndex);
	        });
	        index += colspan;
	      });
	      return columnsGroup;
	    };
	    var generate$1 = function (list) {
	      var access = {};
	      var cells = [];
	      var tableOpt = head(list).map(function (rowData) {
	        return rowData.element;
	      }).bind(table);
	      var lockedColumns = tableOpt.bind(getLockedColumnsFromTable).getOr({});
	      var maxRows = 0;
	      var maxColumns = 0;
	      var rowCount = 0;
	      var _a = partition(list, function (rowData) {
	          return rowData.section === 'colgroup';
	        }), colgroupRows = _a.pass, rows = _a.fail;
	      each$2(rows, function (rowData) {
	        var currentRow = [];
	        each$2(rowData.cells, function (rowCell) {
	          var start = 0;
	          while (access[key(rowCount, start)] !== undefined) {
	            start++;
	          }
	          var isLocked = hasNonNullableKey(lockedColumns, start.toString());
	          var current = extended(rowCell.element, rowCell.rowspan, rowCell.colspan, rowCount, start, isLocked);
	          for (var occupiedColumnPosition = 0; occupiedColumnPosition < rowCell.colspan; occupiedColumnPosition++) {
	            for (var occupiedRowPosition = 0; occupiedRowPosition < rowCell.rowspan; occupiedRowPosition++) {
	              var rowPosition = rowCount + occupiedRowPosition;
	              var columnPosition = start + occupiedColumnPosition;
	              var newpos = key(rowPosition, columnPosition);
	              access[newpos] = current;
	              maxColumns = Math.max(maxColumns, columnPosition + 1);
	            }
	          }
	          currentRow.push(current);
	        });
	        maxRows++;
	        cells.push(rowdetail(rowData.element, currentRow, rowData.section));
	        rowCount++;
	      });
	      var _b = last$2(colgroupRows).map(function (rowData) {
	          var columns = generateColumns(rowData);
	          var colgroup$1 = colgroup(rowData.element, values(columns));
	          return {
	            colgroups: [colgroup$1],
	            columns: columns
	          };
	        }).getOrThunk(function () {
	          return {
	            colgroups: [],
	            columns: {}
	          };
	        }), columns = _b.columns, colgroups = _b.colgroups;
	      var grid$1 = grid(maxRows, maxColumns);
	      return {
	        grid: grid$1,
	        access: access,
	        all: cells,
	        columns: columns,
	        colgroups: colgroups
	      };
	    };
	    var fromTable = function (table) {
	      var list = fromTable$1(table);
	      return generate$1(list);
	    };
	    var justCells = function (warehouse) {
	      return bind$2(warehouse.all, function (w) {
	        return w.cells;
	      });
	    };
	    var justColumns = function (warehouse) {
	      return values(warehouse.columns);
	    };
	    var hasColumns = function (warehouse) {
	      return keys(warehouse.columns).length > 0;
	    };
	    var getColumnAt = function (warehouse, columnIndex) {
	      return Optional.from(warehouse.columns[columnIndex]);
	    };
	    var Warehouse = {
	      fromTable: fromTable,
	      generate: generate$1,
	      getAt: getAt,
	      findItem: findItem,
	      filterItems: filterItems,
	      justCells: justCells,
	      justColumns: justColumns,
	      hasColumns: hasColumns,
	      getColumnAt: getColumnAt
	    };
	
	    var inSelection = function (bounds, detail) {
	      var leftEdge = detail.column;
	      var rightEdge = detail.column + detail.colspan - 1;
	      var topEdge = detail.row;
	      var bottomEdge = detail.row + detail.rowspan - 1;
	      return leftEdge <= bounds.finishCol && rightEdge >= bounds.startCol && (topEdge <= bounds.finishRow && bottomEdge >= bounds.startRow);
	    };
	    var isWithin = function (bounds, detail) {
	      return detail.column >= bounds.startCol && detail.column + detail.colspan - 1 <= bounds.finishCol && detail.row >= bounds.startRow && detail.row + detail.rowspan - 1 <= bounds.finishRow;
	    };
	    var isRectangular = function (warehouse, bounds) {
	      var isRect = true;
	      var detailIsWithin = curry(isWithin, bounds);
	      for (var i = bounds.startRow; i <= bounds.finishRow; i++) {
	        for (var j = bounds.startCol; j <= bounds.finishCol; j++) {
	          isRect = isRect && Warehouse.getAt(warehouse, i, j).exists(detailIsWithin);
	        }
	      }
	      return isRect ? Optional.some(bounds) : Optional.none();
	    };
	
	    var getBounds = function (detailA, detailB) {
	      return bounds(Math.min(detailA.row, detailB.row), Math.min(detailA.column, detailB.column), Math.max(detailA.row + detailA.rowspan - 1, detailB.row + detailB.rowspan - 1), Math.max(detailA.column + detailA.colspan - 1, detailB.column + detailB.colspan - 1));
	    };
	    var getAnyBox = function (warehouse, startCell, finishCell) {
	      var startCoords = Warehouse.findItem(warehouse, startCell, eq$1);
	      var finishCoords = Warehouse.findItem(warehouse, finishCell, eq$1);
	      return startCoords.bind(function (sc) {
	        return finishCoords.map(function (fc) {
	          return getBounds(sc, fc);
	        });
	      });
	    };
	    var getBox$1 = function (warehouse, startCell, finishCell) {
	      return getAnyBox(warehouse, startCell, finishCell).bind(function (bounds) {
	        return isRectangular(warehouse, bounds);
	      });
	    };
	
	    var moveBy$1 = function (warehouse, cell, row, column) {
	      return Warehouse.findItem(warehouse, cell, eq$1).bind(function (detail) {
	        var startRow = row > 0 ? detail.row + detail.rowspan - 1 : detail.row;
	        var startCol = column > 0 ? detail.column + detail.colspan - 1 : detail.column;
	        var dest = Warehouse.getAt(warehouse, startRow + row, startCol + column);
	        return dest.map(function (d) {
	          return d.element;
	        });
	      });
	    };
	    var intercepts$1 = function (warehouse, start, finish) {
	      return getAnyBox(warehouse, start, finish).map(function (bounds) {
	        var inside = Warehouse.filterItems(warehouse, curry(inSelection, bounds));
	        return map$1(inside, function (detail) {
	          return detail.element;
	        });
	      });
	    };
	    var parentCell = function (warehouse, innerCell) {
	      var isContainedBy = function (c1, c2) {
	        return contains(c2, c1);
	      };
	      return Warehouse.findItem(warehouse, innerCell, isContainedBy).map(function (detail) {
	        return detail.element;
	      });
	    };
	
	    var moveBy = function (cell, deltaRow, deltaColumn) {
	      return table(cell).bind(function (table) {
	        var warehouse = getWarehouse(table);
	        return moveBy$1(warehouse, cell, deltaRow, deltaColumn);
	      });
	    };
	    var intercepts = function (table, first, last) {
	      var warehouse = getWarehouse(table);
	      return intercepts$1(warehouse, first, last);
	    };
	    var nestedIntercepts = function (table, first, firstTable, last, lastTable) {
	      var warehouse = getWarehouse(table);
	      var optStartCell = eq$1(table, firstTable) ? Optional.some(first) : parentCell(warehouse, first);
	      var optLastCell = eq$1(table, lastTable) ? Optional.some(last) : parentCell(warehouse, last);
	      return optStartCell.bind(function (startCell) {
	        return optLastCell.bind(function (lastCell) {
	          return intercepts$1(warehouse, startCell, lastCell);
	        });
	      });
	    };
	    var getBox = function (table, first, last) {
	      var warehouse = getWarehouse(table);
	      return getBox$1(warehouse, first, last);
	    };
	    var getWarehouse = Warehouse.fromTable;
	
	    var before$4 = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var after$5 = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append$1(v, element);
	        });
	      }, function (v) {
	        before$4(v, element);
	      });
	    };
	    var prepend = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append$1(parent, element);
	      }, function (v) {
	        parent.dom.insertBefore(element.dom, v.dom);
	      });
	    };
	    var append$1 = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	    var appendAt = function (parent, element, index) {
	      child$3(parent, index).fold(function () {
	        append$1(parent, element);
	      }, function (v) {
	        before$4(v, element);
	      });
	    };
	    var wrap = function (element, wrapper) {
	      before$4(element, wrapper);
	      append$1(wrapper, element);
	    };
	
	    var before$3 = function (marker, elements) {
	      each$2(elements, function (x) {
	        before$4(marker, x);
	      });
	    };
	    var after$4 = function (marker, elements) {
	      each$2(elements, function (x, i) {
	        var e = i === 0 ? marker : elements[i - 1];
	        after$5(e, x);
	      });
	    };
	    var append = function (parent, elements) {
	      each$2(elements, function (x) {
	        append$1(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom.textContent = '';
	      each$2(children$3(element), function (rogue) {
	        remove$5(rogue);
	      });
	    };
	    var remove$5 = function (element) {
	      var dom = element.dom;
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children = children$3(wrapper);
	      if (children.length > 0) {
	        before$3(wrapper, children);
	      }
	      remove$5(wrapper);
	    };
	
	    var NodeValue = function (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom.nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	
	    var api$2 = NodeValue(isText, 'text');
	    var get$9 = function (element) {
	      return api$2.get(element);
	    };
	    var getOption = function (element) {
	      return api$2.getOption(element);
	    };
	    var set = function (element, value) {
	      return api$2.set(element, value);
	    };
	
	    var TagBoundaries = [
	      'body',
	      'p',
	      'div',
	      'article',
	      'aside',
	      'figcaption',
	      'figure',
	      'footer',
	      'header',
	      'nav',
	      'section',
	      'ol',
	      'ul',
	      'li',
	      'table',
	      'thead',
	      'tbody',
	      'tfoot',
	      'caption',
	      'tr',
	      'td',
	      'th',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'blockquote',
	      'pre',
	      'address'
	    ];
	
	    function DomUniverse () {
	      var clone = function (element) {
	        return SugarElement.fromDom(element.dom.cloneNode(false));
	      };
	      var document = function (element) {
	        return documentOrOwner(element).dom;
	      };
	      var isBoundary = function (element) {
	        if (!isElement(element)) {
	          return false;
	        }
	        if (name(element) === 'body') {
	          return true;
	        }
	        return contains$2(TagBoundaries, name(element));
	      };
	      var isEmptyTag = function (element) {
	        if (!isElement(element)) {
	          return false;
	        }
	        return contains$2([
	          'br',
	          'img',
	          'hr',
	          'input'
	        ], name(element));
	      };
	      var isNonEditable = function (element) {
	        return isElement(element) && get$b(element, 'contenteditable') === 'false';
	      };
	      var comparePosition = function (element, other) {
	        return element.dom.compareDocumentPosition(other.dom);
	      };
	      var copyAttributesTo = function (source, destination) {
	        var as = clone$2(source);
	        setAll$1(destination, as);
	      };
	      var isSpecial = function (element) {
	        var tag = name(element);
	        return contains$2([
	          'script',
	          'noscript',
	          'iframe',
	          'noframes',
	          'noembed',
	          'title',
	          'style',
	          'textarea',
	          'xmp'
	        ], tag);
	      };
	      var getLanguage = function (element) {
	        return isElement(element) ? getOpt(element, 'lang') : Optional.none();
	      };
	      return {
	        up: constant({
	          selector: ancestor$1,
	          closest: closest$1,
	          predicate: ancestor$2,
	          all: parents
	        }),
	        down: constant({
	          selector: descendants,
	          predicate: descendants$1
	        }),
	        styles: constant({
	          get: get$a,
	          getRaw: getRaw$2,
	          set: set$1,
	          remove: remove$6
	        }),
	        attrs: constant({
	          get: get$b,
	          set: set$2,
	          remove: remove$7,
	          copyTo: copyAttributesTo
	        }),
	        insert: constant({
	          before: before$4,
	          after: after$5,
	          afterAll: after$4,
	          append: append$1,
	          appendAll: append,
	          prepend: prepend,
	          wrap: wrap
	        }),
	        remove: constant({
	          unwrap: unwrap,
	          remove: remove$5
	        }),
	        create: constant({
	          nu: SugarElement.fromTag,
	          clone: clone,
	          text: SugarElement.fromText
	        }),
	        query: constant({
	          comparePosition: comparePosition,
	          prevSibling: prevSibling,
	          nextSibling: nextSibling
	        }),
	        property: constant({
	          children: children$3,
	          name: name,
	          parent: parent,
	          document: document,
	          isText: isText,
	          isComment: isComment,
	          isElement: isElement,
	          isSpecial: isSpecial,
	          getLanguage: getLanguage,
	          getText: get$9,
	          setText: set,
	          isBoundary: isBoundary,
	          isEmptyTag: isEmptyTag,
	          isNonEditable: isNonEditable
	        }),
	        eq: eq$1,
	        is: is$1
	      };
	    }
	
	    var all = function (universe, look, elements, f) {
	      var head = elements[0];
	      var tail = elements.slice(1);
	      return f(universe, look, head, tail);
	    };
	    var oneAll = function (universe, look, elements) {
	      return elements.length > 0 ? all(universe, look, elements, unsafeOne) : Optional.none();
	    };
	    var unsafeOne = function (universe, look, head, tail) {
	      var start = look(universe, head);
	      return foldr(tail, function (b, a) {
	        var current = look(universe, a);
	        return commonElement(universe, b, current);
	      }, start);
	    };
	    var commonElement = function (universe, start, end) {
	      return start.bind(function (s) {
	        return end.filter(curry(universe.eq, s));
	      });
	    };
	
	    var eq = function (universe, item) {
	      return curry(universe.eq, item);
	    };
	    var ancestors$2 = function (universe, start, end, isRoot) {
	      if (isRoot === void 0) {
	        isRoot = never;
	      }
	      var ps1 = [start].concat(universe.up().all(start));
	      var ps2 = [end].concat(universe.up().all(end));
	      var prune = function (path) {
	        var index = findIndex(path, isRoot);
	        return index.fold(function () {
	          return path;
	        }, function (ind) {
	          return path.slice(0, ind + 1);
	        });
	      };
	      var pruned1 = prune(ps1);
	      var pruned2 = prune(ps2);
	      var shared = find$1(pruned1, function (x) {
	        return exists(pruned2, eq(universe, x));
	      });
	      return {
	        firstpath: pruned1,
	        secondpath: pruned2,
	        shared: shared
	      };
	    };
	
	    var sharedOne$1 = oneAll;
	    var ancestors$1 = ancestors$2;
	
	    var universe$3 = DomUniverse();
	    var sharedOne = function (look, elements) {
	      return sharedOne$1(universe$3, function (_universe, element) {
	        return look(element);
	      }, elements);
	    };
	    var ancestors = function (start, finish, isRoot) {
	      return ancestors$1(universe$3, start, finish, isRoot);
	    };
	
	    var lookupTable = function (container) {
	      return ancestor$1(container, 'table');
	    };
	    var identify = function (start, finish, isRoot) {
	      var getIsRoot = function (rootTable) {
	        return function (element) {
	          return isRoot !== undefined && isRoot(element) || eq$1(element, rootTable);
	        };
	      };
	      if (eq$1(start, finish)) {
	        return Optional.some({
	          boxes: Optional.some([start]),
	          start: start,
	          finish: finish
	        });
	      } else {
	        return lookupTable(start).bind(function (startTable) {
	          return lookupTable(finish).bind(function (finishTable) {
	            if (eq$1(startTable, finishTable)) {
	              return Optional.some({
	                boxes: intercepts(startTable, start, finish),
	                start: start,
	                finish: finish
	              });
	            } else if (contains(startTable, finishTable)) {
	              var ancestorCells = ancestors$3(finish, 'td,th', getIsRoot(startTable));
	              var finishCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : finish;
	              return Optional.some({
	                boxes: nestedIntercepts(startTable, start, startTable, finish, finishTable),
	                start: start,
	                finish: finishCell
	              });
	            } else if (contains(finishTable, startTable)) {
	              var ancestorCells = ancestors$3(start, 'td,th', getIsRoot(finishTable));
	              var startCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : start;
	              return Optional.some({
	                boxes: nestedIntercepts(finishTable, start, startTable, finish, finishTable),
	                start: start,
	                finish: startCell
	              });
	            } else {
	              return ancestors(start, finish).shared.bind(function (lca) {
	                return closest$1(lca, 'table', isRoot).bind(function (lcaTable) {
	                  var finishAncestorCells = ancestors$3(finish, 'td,th', getIsRoot(lcaTable));
	                  var finishCell = finishAncestorCells.length > 0 ? finishAncestorCells[finishAncestorCells.length - 1] : finish;
	                  var startAncestorCells = ancestors$3(start, 'td,th', getIsRoot(lcaTable));
	                  var startCell = startAncestorCells.length > 0 ? startAncestorCells[startAncestorCells.length - 1] : start;
	                  return Optional.some({
	                    boxes: nestedIntercepts(lcaTable, start, startTable, finish, finishTable),
	                    start: startCell,
	                    finish: finishCell
	                  });
	                });
	              });
	            }
	          });
	        });
	      }
	    };
	    var retrieve$1 = function (container, selector) {
	      var sels = descendants(container, selector);
	      return sels.length > 0 ? Optional.some(sels) : Optional.none();
	    };
	    var getLast = function (boxes, lastSelectedSelector) {
	      return find$1(boxes, function (box) {
	        return is$2(box, lastSelectedSelector);
	      });
	    };
	    var getEdges = function (container, firstSelectedSelector, lastSelectedSelector) {
	      return descendant(container, firstSelectedSelector).bind(function (first) {
	        return descendant(container, lastSelectedSelector).bind(function (last) {
	          return sharedOne(lookupTable, [
	            first,
	            last
	          ]).map(function (table) {
	            return {
	              first: first,
	              last: last,
	              table: table
	            };
	          });
	        });
	      });
	    };
	    var expandTo = function (finish, firstSelectedSelector) {
	      return ancestor$1(finish, 'table').bind(function (table) {
	        return descendant(table, firstSelectedSelector).bind(function (start) {
	          return identify(start, finish).bind(function (identified) {
	            return identified.boxes.map(function (boxes) {
	              return {
	                boxes: boxes,
	                start: identified.start,
	                finish: identified.finish
	              };
	            });
	          });
	        });
	      });
	    };
	    var shiftSelection = function (boxes, deltaRow, deltaColumn, firstSelectedSelector, lastSelectedSelector) {
	      return getLast(boxes, lastSelectedSelector).bind(function (last) {
	        return moveBy(last, deltaRow, deltaColumn).bind(function (finish) {
	          return expandTo(finish, firstSelectedSelector);
	        });
	      });
	    };
	
	    var retrieve = function (container, selector) {
	      return retrieve$1(container, selector);
	    };
	    var retrieveBox = function (container, firstSelectedSelector, lastSelectedSelector) {
	      return getEdges(container, firstSelectedSelector, lastSelectedSelector).bind(function (edges) {
	        var isRoot = function (ancestor) {
	          return eq$1(container, ancestor);
	        };
	        var sectionSelector = 'thead,tfoot,tbody,table';
	        var firstAncestor = ancestor$1(edges.first, sectionSelector, isRoot);
	        var lastAncestor = ancestor$1(edges.last, sectionSelector, isRoot);
	        return firstAncestor.bind(function (fA) {
	          return lastAncestor.bind(function (lA) {
	            return eq$1(fA, lA) ? getBox(edges.table, edges.first, edges.last) : Optional.none();
	          });
	        });
	      });
	    };
	
	    var generate = function (cases) {
	      if (!isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each$2(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          var argLength = args.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains$2(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              var foldArgs = [];
	              for (var _i = 0; _i < arguments.length; _i++) {
	                foldArgs[_i] = arguments[_i];
	              }
	              if (foldArgs.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
	              }
	              var target = foldArgs[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate };
	
	    var type = Adt.generate([
	      { none: [] },
	      { multiple: ['elements'] },
	      { single: ['element'] }
	    ]);
	    var cata$2 = function (subject, onNone, onMultiple, onSingle) {
	      return subject.fold(onNone, onMultiple, onSingle);
	    };
	    var none$1 = type.none;
	    var multiple = type.multiple;
	    var single = type.single;
	
	    var Selections = function (lazyRoot, getStart, selectedSelector) {
	      var get = function () {
	        return retrieve(lazyRoot(), selectedSelector).fold(function () {
	          return getStart().fold(none$1, single);
	        }, function (cells) {
	          return multiple(cells);
	        });
	      };
	      return { get: get };
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var clone = function (original, isDeep) {
	      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
	    };
	    var shallow = function (original) {
	      return clone(original, false);
	    };
	    var deep = function (original) {
	      return clone(original, true);
	    };
	    var shallowAs = function (original, tag) {
	      var nu = SugarElement.fromTag(tag);
	      var attributes = clone$2(original);
	      setAll$1(nu, attributes);
	      return nu;
	    };
	    var copy$1 = function (original, tag) {
	      var nu = shallowAs(original, tag);
	      var cloneChildren = children$3(deep(original));
	      append(nu, cloneChildren);
	      return nu;
	    };
	    var mutate$1 = function (original, tag) {
	      var nu = shallowAs(original, tag);
	      before$4(original, nu);
	      var children = children$3(original);
	      append(nu, children);
	      remove$5(original);
	      return nu;
	    };
	
	    var Dimension = function (name, getOffset) {
	      var set = function (element, h) {
	        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
	          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
	        }
	        var dom = element.dom;
	        if (isSupported(dom)) {
	          dom.style[name] = h + 'px';
	        }
	      };
	      var get = function (element) {
	        var r = getOffset(element);
	        if (r <= 0 || r === null) {
	          var css = get$a(element, name);
	          return parseFloat(css) || 0;
	        }
	        return r;
	      };
	      var getOuter = get;
	      var aggregate = function (element, properties) {
	        return foldl(properties, function (acc, property) {
	          var val = get$a(element, property);
	          var value = val === undefined ? 0 : parseInt(val, 10);
	          return isNaN(value) ? acc : acc + value;
	        }, 0);
	      };
	      var max = function (element, value, properties) {
	        var cumulativeInclusions = aggregate(element, properties);
	        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
	        return absoluteMax;
	      };
	      return {
	        set: set,
	        get: get,
	        getOuter: getOuter,
	        aggregate: aggregate,
	        max: max
	      };
	    };
	
	    var needManualCalc = function () {
	      var browser = detect$3().browser;
	      return browser.isIE() || browser.isEdge();
	    };
	    var toNumber = function (px, fallback) {
	      return toFloat(px).getOr(fallback);
	    };
	    var getProp = function (element, name, fallback) {
	      return toNumber(get$a(element, name), fallback);
	    };
	    var getBoxSizing = function (element) {
	      return get$a(element, 'box-sizing');
	    };
	    var calcContentBoxSize = function (element, size, upper, lower) {
	      var paddingUpper = getProp(element, 'padding-' + upper, 0);
	      var paddingLower = getProp(element, 'padding-' + lower, 0);
	      var borderUpper = getProp(element, 'border-' + upper + '-width', 0);
	      var borderLower = getProp(element, 'border-' + lower + '-width', 0);
	      return size - paddingUpper - paddingLower - borderUpper - borderLower;
	    };
	    var getCalculatedHeight = function (element, boxSizing) {
	      var dom = element.dom;
	      var height = dom.getBoundingClientRect().height || dom.offsetHeight;
	      return boxSizing === 'border-box' ? height : calcContentBoxSize(element, height, 'top', 'bottom');
	    };
	    var getCalculatedWidth = function (element, boxSizing) {
	      var dom = element.dom;
	      var width = dom.getBoundingClientRect().width || dom.offsetWidth;
	      return boxSizing === 'border-box' ? width : calcContentBoxSize(element, width, 'left', 'right');
	    };
	    var getHeight$1 = function (element) {
	      return needManualCalc() ? getCalculatedHeight(element, getBoxSizing(element)) : getProp(element, 'height', element.dom.offsetHeight);
	    };
	    var getWidth = function (element) {
	      return needManualCalc() ? getCalculatedWidth(element, getBoxSizing(element)) : getProp(element, 'width', element.dom.offsetWidth);
	    };
	    var getInnerWidth = function (element) {
	      return getCalculatedWidth(element, 'content-box');
	    };
	
	    var api$1 = Dimension('width', function (element) {
	      return element.dom.offsetWidth;
	    });
	    var get$8 = function (element) {
	      return api$1.get(element);
	    };
	    var getOuter$2 = function (element) {
	      return api$1.getOuter(element);
	    };
	    var getInner = getInnerWidth;
	    var getRuntime$1 = getWidth;
	
	    var columns = function (warehouse, isValidCell) {
	      if (isValidCell === void 0) {
	        isValidCell = always;
	      }
	      var grid = warehouse.grid;
	      var cols = range$1(grid.columns, identity);
	      var rowsArr = range$1(grid.rows, identity);
	      return map$1(cols, function (col) {
	        var getBlock = function () {
	          return bind$2(rowsArr, function (r) {
	            return Warehouse.getAt(warehouse, r, col).filter(function (detail) {
	              return detail.column === col;
	            }).toArray();
	          });
	        };
	        var isValid = function (detail) {
	          return detail.colspan === 1 && isValidCell(detail.element);
	        };
	        var getFallback = function () {
	          return Warehouse.getAt(warehouse, 0, col);
	        };
	        return decide(getBlock, isValid, getFallback);
	      });
	    };
	    var decide = function (getBlock, isValid, getFallback) {
	      var inBlock = getBlock();
	      var validInBlock = find$1(inBlock, isValid);
	      var detailOption = validInBlock.orThunk(function () {
	        return Optional.from(inBlock[0]).orThunk(getFallback);
	      });
	      return detailOption.map(function (detail) {
	        return detail.element;
	      });
	    };
	    var rows = function (warehouse) {
	      var grid = warehouse.grid;
	      var rowsArr = range$1(grid.rows, identity);
	      var cols = range$1(grid.columns, identity);
	      return map$1(rowsArr, function (row) {
	        var getBlock = function () {
	          return bind$2(cols, function (c) {
	            return Warehouse.getAt(warehouse, row, c).filter(function (detail) {
	              return detail.row === row;
	            }).fold(constant([]), function (detail) {
	              return [detail];
	            });
	          });
	        };
	        var isSingle = function (detail) {
	          return detail.rowspan === 1;
	        };
	        var getFallback = function () {
	          return Warehouse.getAt(warehouse, row, 0);
	        };
	        return decide(getBlock, isSingle, getFallback);
	      });
	    };
	
	    var deduce = function (xs, index) {
	      if (index < 0 || index >= xs.length - 1) {
	        return Optional.none();
	      }
	      var current = xs[index].fold(function () {
	        var rest = reverse(xs.slice(0, index));
	        return findMap(rest, function (a, i) {
	          return a.map(function (aa) {
	            return {
	              value: aa,
	              delta: i + 1
	            };
	          });
	        });
	      }, function (c) {
	        return Optional.some({
	          value: c,
	          delta: 0
	        });
	      });
	      var next = xs[index + 1].fold(function () {
	        var rest = xs.slice(index + 1);
	        return findMap(rest, function (a, i) {
	          return a.map(function (aa) {
	            return {
	              value: aa,
	              delta: i + 1
	            };
	          });
	        });
	      }, function (n) {
	        return Optional.some({
	          value: n,
	          delta: 1
	        });
	      });
	      return current.bind(function (c) {
	        return next.map(function (n) {
	          var extras = n.delta + c.delta;
	          return Math.abs(n.value - c.value) / extras;
	        });
	      });
	    };
	
	    var onDirection = function (isLtr, isRtl) {
	      return function (element) {
	        return getDirection(element) === 'rtl' ? isRtl : isLtr;
	      };
	    };
	    var getDirection = function (element) {
	      return get$a(element, 'direction') === 'rtl' ? 'rtl' : 'ltr';
	    };
	
	    var api = Dimension('height', function (element) {
	      var dom = element.dom;
	      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
	    });
	    var get$7 = function (element) {
	      return api.get(element);
	    };
	    var getOuter$1 = function (element) {
	      return api.getOuter(element);
	    };
	    var getRuntime = getHeight$1;
	
	    var r = function (left, top) {
	      var translate = function (x, y) {
	        return r(left + x, top + y);
	      };
	      return {
	        left: left,
	        top: top,
	        translate: translate
	      };
	    };
	    var SugarPosition = r;
	
	    var boxPosition = function (dom) {
	      var box = dom.getBoundingClientRect();
	      return SugarPosition(box.left, box.top);
	    };
	    var firstDefinedOrZero = function (a, b) {
	      if (a !== undefined) {
	        return a;
	      } else {
	        return b !== undefined ? b : 0;
	      }
	    };
	    var absolute = function (element) {
	      var doc = element.dom.ownerDocument;
	      var body = doc.body;
	      var win = doc.defaultView;
	      var html = doc.documentElement;
	      if (body === element.dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
	      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
	      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
	      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
	      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
	    };
	    var viewport = function (element) {
	      var dom = element.dom;
	      var doc = dom.ownerDocument;
	      var body = doc.body;
	      if (body === dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      if (!inBody(element)) {
	        return SugarPosition(0, 0);
	      }
	      return boxPosition(dom);
	    };
	
	    var rowInfo = function (row, y) {
	      return {
	        row: row,
	        y: y
	      };
	    };
	    var colInfo = function (col, x) {
	      return {
	        col: col,
	        x: x
	      };
	    };
	    var rtlEdge = function (cell) {
	      var pos = absolute(cell);
	      return pos.left + getOuter$2(cell);
	    };
	    var ltrEdge = function (cell) {
	      return absolute(cell).left;
	    };
	    var getLeftEdge = function (index, cell) {
	      return colInfo(index, ltrEdge(cell));
	    };
	    var getRightEdge = function (index, cell) {
	      return colInfo(index, rtlEdge(cell));
	    };
	    var getTop$1 = function (cell) {
	      return absolute(cell).top;
	    };
	    var getTopEdge = function (index, cell) {
	      return rowInfo(index, getTop$1(cell));
	    };
	    var getBottomEdge = function (index, cell) {
	      return rowInfo(index, getTop$1(cell) + getOuter$1(cell));
	    };
	    var findPositions = function (getInnerEdge, getOuterEdge, array) {
	      if (array.length === 0) {
	        return [];
	      }
	      var lines = map$1(array.slice(1), function (cellOption, index) {
	        return cellOption.map(function (cell) {
	          return getInnerEdge(index, cell);
	        });
	      });
	      var lastLine = array[array.length - 1].map(function (cell) {
	        return getOuterEdge(array.length - 1, cell);
	      });
	      return lines.concat([lastLine]);
	    };
	    var negate = function (step) {
	      return -step;
	    };
	    var height = {
	      delta: identity,
	      positions: function (optElements) {
	        return findPositions(getTopEdge, getBottomEdge, optElements);
	      },
	      edge: getTop$1
	    };
	    var ltr$1 = {
	      delta: identity,
	      edge: ltrEdge,
	      positions: function (optElements) {
	        return findPositions(getLeftEdge, getRightEdge, optElements);
	      }
	    };
	    var rtl$1 = {
	      delta: negate,
	      edge: rtlEdge,
	      positions: function (optElements) {
	        return findPositions(getRightEdge, getLeftEdge, optElements);
	      }
	    };
	    var detect$2 = onDirection(ltr$1, rtl$1);
	    var width = {
	      delta: function (amount, table) {
	        return detect$2(table).delta(amount, table);
	      },
	      positions: function (cols, table) {
	        return detect$2(table).positions(cols, table);
	      },
	      edge: function (cell) {
	        return detect$2(cell).edge(cell);
	      }
	    };
	
	    var units = {
	      unsupportedLength: [
	        'em',
	        'ex',
	        'cap',
	        'ch',
	        'ic',
	        'rem',
	        'lh',
	        'rlh',
	        'vw',
	        'vh',
	        'vi',
	        'vb',
	        'vmin',
	        'vmax',
	        'cm',
	        'mm',
	        'Q',
	        'in',
	        'pc',
	        'pt',
	        'px'
	      ],
	      fixed: [
	        'px',
	        'pt'
	      ],
	      relative: ['%'],
	      empty: ['']
	    };
	    var pattern = function () {
	      var decimalDigits = '[0-9]+';
	      var signedInteger = '[+-]?' + decimalDigits;
	      var exponentPart = '[eE]' + signedInteger;
	      var dot = '\\.';
	      var opt = function (input) {
	        return '(?:' + input + ')?';
	      };
	      var unsignedDecimalLiteral = [
	        'Infinity',
	        decimalDigits + dot + opt(decimalDigits) + opt(exponentPart),
	        dot + decimalDigits + opt(exponentPart),
	        decimalDigits + opt(exponentPart)
	      ].join('|');
	      var float = '[+-]?(?:' + unsignedDecimalLiteral + ')';
	      return new RegExp('^(' + float + ')(.*)$');
	    }();
	    var isUnit = function (unit, accepted) {
	      return exists(accepted, function (acc) {
	        return exists(units[acc], function (check) {
	          return unit === check;
	        });
	      });
	    };
	    var parse = function (input, accepted) {
	      var match = Optional.from(pattern.exec(input));
	      return match.bind(function (array) {
	        var value = Number(array[1]);
	        var unitRaw = array[2];
	        if (isUnit(unitRaw, accepted)) {
	          return Optional.some({
	            value: value,
	            unit: unitRaw
	          });
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	
	    var rPercentageBasedSizeRegex = /(\d+(\.\d+)?)%/;
	    var rPixelBasedSizeRegex = /(\d+(\.\d+)?)px|em/;
	    var isCol$2 = isTag('col');
	    var getPercentSize = function (elm, outerGetter, innerGetter) {
	      var relativeParent = parentElement(elm).getOrThunk(function () {
	        return getBody$1(owner(elm));
	      });
	      return outerGetter(elm) / innerGetter(relativeParent) * 100;
	    };
	    var setPixelWidth = function (cell, amount) {
	      set$1(cell, 'width', amount + 'px');
	    };
	    var setPercentageWidth = function (cell, amount) {
	      set$1(cell, 'width', amount + '%');
	    };
	    var setHeight = function (cell, amount) {
	      set$1(cell, 'height', amount + 'px');
	    };
	    var getHeightValue = function (cell) {
	      return getRuntime(cell) + 'px';
	    };
	    var convert = function (cell, number, getter, setter) {
	      var newSize = table(cell).map(function (table) {
	        var total = getter(table);
	        return Math.floor(number / 100 * total);
	      }).getOr(number);
	      setter(cell, newSize);
	      return newSize;
	    };
	    var normalizePixelSize = function (value, cell, getter, setter) {
	      var number = parseFloat(value);
	      return endsWith(value, '%') && name(cell) !== 'table' ? convert(cell, number, getter, setter) : number;
	    };
	    var getTotalHeight = function (cell) {
	      var value = getHeightValue(cell);
	      if (!value) {
	        return get$7(cell);
	      }
	      return normalizePixelSize(value, cell, get$7, setHeight);
	    };
	    var get$6 = function (cell, type, f) {
	      var v = f(cell);
	      var span = getSpan(cell, type);
	      return v / span;
	    };
	    var getRaw$1 = function (element, prop) {
	      return getRaw$2(element, prop).orThunk(function () {
	        return getOpt(element, prop).map(function (val) {
	          return val + 'px';
	        });
	      });
	    };
	    var getRawWidth$1 = function (element) {
	      return getRaw$1(element, 'width');
	    };
	    var getRawHeight = function (element) {
	      return getRaw$1(element, 'height');
	    };
	    var getPercentageWidth = function (cell) {
	      return getPercentSize(cell, get$8, getInner);
	    };
	    var getPixelWidth$1 = function (cell) {
	      return isCol$2(cell) ? get$8(cell) : getRuntime$1(cell);
	    };
	    var getHeight = function (cell) {
	      return get$6(cell, 'rowspan', getTotalHeight);
	    };
	    var getGenericWidth = function (cell) {
	      var width = getRawWidth$1(cell);
	      return width.bind(function (w) {
	        return parse(w, [
	          'fixed',
	          'relative',
	          'empty'
	        ]);
	      });
	    };
	    var setGenericWidth = function (cell, amount, unit) {
	      set$1(cell, 'width', amount + unit);
	    };
	    var getPixelTableWidth = function (table) {
	      return get$8(table) + 'px';
	    };
	    var getPercentTableWidth = function (table) {
	      return getPercentSize(table, get$8, getInner) + '%';
	    };
	    var isPercentSizing$1 = function (table) {
	      return getRawWidth$1(table).exists(function (size) {
	        return rPercentageBasedSizeRegex.test(size);
	      });
	    };
	    var isPixelSizing$1 = function (table) {
	      return getRawWidth$1(table).exists(function (size) {
	        return rPixelBasedSizeRegex.test(size);
	      });
	    };
	    var isNoneSizing$1 = function (table) {
	      return getRawWidth$1(table).isNone();
	    };
	    var percentageBasedSizeRegex = constant(rPercentageBasedSizeRegex);
	
	    var isCol$1 = isTag('col');
	    var getRawW = function (cell) {
	      return getRawWidth$1(cell).getOrThunk(function () {
	        return getPixelWidth$1(cell) + 'px';
	      });
	    };
	    var getRawH = function (cell) {
	      return getRawHeight(cell).getOrThunk(function () {
	        return getHeight(cell) + 'px';
	      });
	    };
	    var justCols = function (warehouse) {
	      return map$1(Warehouse.justColumns(warehouse), function (column) {
	        return Optional.from(column.element);
	      });
	    };
	    var isValidColumn = function (cell) {
	      var browser = detect$3().browser;
	      var supportsColWidths = browser.isChrome() || browser.isFirefox();
	      return isCol$1(cell) ? supportsColWidths : true;
	    };
	    var getDimension = function (cellOpt, index, backups, filter, getter, fallback) {
	      return cellOpt.filter(filter).fold(function () {
	        return fallback(deduce(backups, index));
	      }, function (cell) {
	        return getter(cell);
	      });
	    };
	    var getWidthFrom = function (warehouse, table, getWidth, fallback) {
	      var columnCells = columns(warehouse);
	      var columns$1 = Warehouse.hasColumns(warehouse) ? justCols(warehouse) : columnCells;
	      var backups = [Optional.some(width.edge(table))].concat(map$1(width.positions(columnCells, table), function (pos) {
	        return pos.map(function (p) {
	          return p.x;
	        });
	      }));
	      var colFilter = not(hasColspan);
	      return map$1(columns$1, function (cellOption, c) {
	        return getDimension(cellOption, c, backups, colFilter, function (column) {
	          if (isValidColumn(column)) {
	            return getWidth(column);
	          } else {
	            var cell = bindFrom(columnCells[c], identity);
	            return getDimension(cell, c, backups, colFilter, function (cell) {
	              return fallback(Optional.some(get$8(cell)));
	            }, fallback);
	          }
	        }, fallback);
	      });
	    };
	    var getDeduced = function (deduced) {
	      return deduced.map(function (d) {
	        return d + 'px';
	      }).getOr('');
	    };
	    var getRawWidths = function (warehouse, table) {
	      return getWidthFrom(warehouse, table, getRawW, getDeduced);
	    };
	    var getPercentageWidths = function (warehouse, table, tableSize) {
	      return getWidthFrom(warehouse, table, getPercentageWidth, function (deduced) {
	        return deduced.fold(function () {
	          return tableSize.minCellWidth();
	        }, function (cellWidth) {
	          return cellWidth / tableSize.pixelWidth() * 100;
	        });
	      });
	    };
	    var getPixelWidths = function (warehouse, table, tableSize) {
	      return getWidthFrom(warehouse, table, getPixelWidth$1, function (deduced) {
	        return deduced.getOrThunk(tableSize.minCellWidth);
	      });
	    };
	    var getHeightFrom = function (warehouse, table, direction, getHeight, fallback) {
	      var rows$1 = rows(warehouse);
	      var backups = [Optional.some(direction.edge(table))].concat(map$1(direction.positions(rows$1, table), function (pos) {
	        return pos.map(function (p) {
	          return p.y;
	        });
	      }));
	      return map$1(rows$1, function (cellOption, c) {
	        return getDimension(cellOption, c, backups, not(hasRowspan), getHeight, fallback);
	      });
	    };
	    var getPixelHeights = function (warehouse, table, direction) {
	      return getHeightFrom(warehouse, table, direction, getHeight, function (deduced) {
	        return deduced.getOrThunk(minHeight);
	      });
	    };
	    var getRawHeights = function (warehouse, table, direction) {
	      return getHeightFrom(warehouse, table, direction, getRawH, getDeduced);
	    };
	
	    var widthLookup = function (table, getter) {
	      return function () {
	        if (inBody(table)) {
	          return getter(table);
	        } else {
	          return parseFloat(getRaw$2(table, 'width').getOr('0'));
	        }
	      };
	    };
	    var noneSize = function (table) {
	      var getWidth = widthLookup(table, get$8);
	      var zero = constant(0);
	      var getWidths = function (warehouse, tableSize) {
	        return getPixelWidths(warehouse, table, tableSize);
	      };
	      return {
	        width: getWidth,
	        pixelWidth: getWidth,
	        getWidths: getWidths,
	        getCellDelta: zero,
	        singleColumnWidth: constant([0]),
	        minCellWidth: zero,
	        setElementWidth: noop,
	        adjustTableWidth: noop,
	        isRelative: true,
	        label: 'none'
	      };
	    };
	    var percentageSize = function (table) {
	      var getFloatWidth = widthLookup(table, function (elem) {
	        return parseFloat(getPercentTableWidth(elem));
	      });
	      var getWidth = widthLookup(table, get$8);
	      var getCellDelta = function (delta) {
	        return delta / getWidth() * 100;
	      };
	      var singleColumnWidth = function (w, _delta) {
	        return [100 - w];
	      };
	      var minCellWidth = function () {
	        return minWidth() / getWidth() * 100;
	      };
	      var adjustTableWidth = function (delta) {
	        var currentWidth = getFloatWidth();
	        var change = delta / 100 * currentWidth;
	        var newWidth = currentWidth + change;
	        setPercentageWidth(table, newWidth);
	      };
	      var getWidths = function (warehouse, tableSize) {
	        return getPercentageWidths(warehouse, table, tableSize);
	      };
	      return {
	        width: getFloatWidth,
	        pixelWidth: getWidth,
	        getWidths: getWidths,
	        getCellDelta: getCellDelta,
	        singleColumnWidth: singleColumnWidth,
	        minCellWidth: minCellWidth,
	        setElementWidth: setPercentageWidth,
	        adjustTableWidth: adjustTableWidth,
	        isRelative: true,
	        label: 'percent'
	      };
	    };
	    var pixelSize = function (table) {
	      var getWidth = widthLookup(table, get$8);
	      var getCellDelta = identity;
	      var singleColumnWidth = function (w, delta) {
	        var newNext = Math.max(minWidth(), w + delta);
	        return [newNext - w];
	      };
	      var adjustTableWidth = function (delta) {
	        var newWidth = getWidth() + delta;
	        setPixelWidth(table, newWidth);
	      };
	      var getWidths = function (warehouse, tableSize) {
	        return getPixelWidths(warehouse, table, tableSize);
	      };
	      return {
	        width: getWidth,
	        pixelWidth: getWidth,
	        getWidths: getWidths,
	        getCellDelta: getCellDelta,
	        singleColumnWidth: singleColumnWidth,
	        minCellWidth: minWidth,
	        setElementWidth: setPixelWidth,
	        adjustTableWidth: adjustTableWidth,
	        isRelative: false,
	        label: 'pixel'
	      };
	    };
	    var chooseSize = function (element, width) {
	      var percentMatch = percentageBasedSizeRegex().exec(width);
	      if (percentMatch !== null) {
	        return percentageSize(element);
	      } else {
	        return pixelSize(element);
	      }
	    };
	    var getTableSize = function (table) {
	      var width = getRawWidth$1(table);
	      return width.fold(function () {
	        return noneSize(table);
	      }, function (w) {
	        return chooseSize(table, w);
	      });
	    };
	    var TableSize = {
	      getTableSize: getTableSize,
	      pixelSize: pixelSize,
	      percentageSize: percentageSize,
	      noneSize: noneSize
	    };
	
	    var statsStruct = function (minRow, minCol, maxRow, maxCol, allCells, selectedCells) {
	      return {
	        minRow: minRow,
	        minCol: minCol,
	        maxRow: maxRow,
	        maxCol: maxCol,
	        allCells: allCells,
	        selectedCells: selectedCells
	      };
	    };
	    var findSelectedStats = function (house, isSelected) {
	      var totalColumns = house.grid.columns;
	      var totalRows = house.grid.rows;
	      var minRow = totalRows;
	      var minCol = totalColumns;
	      var maxRow = 0;
	      var maxCol = 0;
	      var allCells = [];
	      var selectedCells = [];
	      each$1(house.access, function (detail) {
	        allCells.push(detail);
	        if (isSelected(detail)) {
	          selectedCells.push(detail);
	          var startRow = detail.row;
	          var endRow = startRow + detail.rowspan - 1;
	          var startCol = detail.column;
	          var endCol = startCol + detail.colspan - 1;
	          if (startRow < minRow) {
	            minRow = startRow;
	          } else if (endRow > maxRow) {
	            maxRow = endRow;
	          }
	          if (startCol < minCol) {
	            minCol = startCol;
	          } else if (endCol > maxCol) {
	            maxCol = endCol;
	          }
	        }
	      });
	      return statsStruct(minRow, minCol, maxRow, maxCol, allCells, selectedCells);
	    };
	    var makeCell = function (list, seenSelected, rowIndex) {
	      var row = list[rowIndex].element;
	      var td = SugarElement.fromTag('td');
	      append$1(td, SugarElement.fromTag('br'));
	      var f = seenSelected ? append$1 : prepend;
	      f(row, td);
	    };
	    var fillInGaps = function (list, house, stats, isSelected) {
	      var totalColumns = house.grid.columns;
	      var totalRows = house.grid.rows;
	      for (var i = 0; i < totalRows; i++) {
	        var seenSelected = false;
	        for (var j = 0; j < totalColumns; j++) {
	          if (!(i < stats.minRow || i > stats.maxRow || j < stats.minCol || j > stats.maxCol)) {
	            var needCell = Warehouse.getAt(house, i, j).filter(isSelected).isNone();
	            if (needCell) {
	              makeCell(list, seenSelected, i);
	            } else {
	              seenSelected = true;
	            }
	          }
	        }
	      }
	    };
	    var clean = function (replica, stats, house, widthDelta) {
	      each$1(house.columns, function (col) {
	        if (col.column < stats.minCol || col.column > stats.maxCol) {
	          remove$5(col.element);
	        }
	      });
	      var emptyRows = filter$2(firstLayer(replica, 'tr'), function (row) {
	        return row.dom.childElementCount === 0;
	      });
	      each$2(emptyRows, remove$5);
	      if (stats.minCol === stats.maxCol || stats.minRow === stats.maxRow) {
	        each$2(firstLayer(replica, 'th,td'), function (cell) {
	          remove$7(cell, 'rowspan');
	          remove$7(cell, 'colspan');
	        });
	      }
	      remove$7(replica, LOCKED_COL_ATTR);
	      remove$7(replica, 'data-snooker-col-series');
	      var tableSize = TableSize.getTableSize(replica);
	      tableSize.adjustTableWidth(widthDelta);
	    };
	    var getTableWidthDelta = function (table, warehouse, tableSize, stats) {
	      if (stats.minCol === 0 && warehouse.grid.columns === stats.maxCol + 1) {
	        return 0;
	      }
	      var colWidths = getPixelWidths(warehouse, table, tableSize);
	      var allColsWidth = foldl(colWidths, function (acc, width) {
	        return acc + width;
	      }, 0);
	      var selectedColsWidth = foldl(colWidths.slice(stats.minCol, stats.maxCol + 1), function (acc, width) {
	        return acc + width;
	      }, 0);
	      var newWidth = selectedColsWidth / allColsWidth * tableSize.pixelWidth();
	      var delta = newWidth - tableSize.pixelWidth();
	      return tableSize.getCellDelta(delta);
	    };
	    var extract$1 = function (table, selectedSelector) {
	      var isSelected = function (detail) {
	        return is$2(detail.element, selectedSelector);
	      };
	      var replica = deep(table);
	      var list = fromTable$1(replica);
	      var tableSize = TableSize.getTableSize(table);
	      var replicaHouse = Warehouse.generate(list);
	      var replicaStats = findSelectedStats(replicaHouse, isSelected);
	      var selector = 'th:not(' + selectedSelector + ')' + ',td:not(' + selectedSelector + ')';
	      var unselectedCells = filterFirstLayer(replica, 'th,td', function (cell) {
	        return is$2(cell, selector);
	      });
	      each$2(unselectedCells, remove$5);
	      fillInGaps(list, replicaHouse, replicaStats, isSelected);
	      var house = Warehouse.fromTable(table);
	      var widthDelta = getTableWidthDelta(table, house, tableSize, replicaStats);
	      clean(replica, replicaStats, replicaHouse, widthDelta);
	      return replica;
	    };
	
	    var nbsp = '\xA0';
	
	    var getEnd = function (element) {
	      return name(element) === 'img' ? 1 : getOption(element).fold(function () {
	        return children$3(element).length;
	      }, function (v) {
	        return v.length;
	      });
	    };
	    var isTextNodeWithCursorPosition = function (el) {
	      return getOption(el).filter(function (text) {
	        return text.trim().length !== 0 || text.indexOf(nbsp) > -1;
	      }).isSome();
	    };
	    var elementsWithCursorPosition = [
	      'img',
	      'br'
	    ];
	    var isCursorPosition = function (elem) {
	      var hasCursorPosition = isTextNodeWithCursorPosition(elem);
	      return hasCursorPosition || contains$2(elementsWithCursorPosition, name(elem));
	    };
	
	    var first = function (element) {
	      return descendant$1(element, isCursorPosition);
	    };
	    var last$1 = function (element) {
	      return descendantRtl(element, isCursorPosition);
	    };
	    var descendantRtl = function (scope, predicate) {
	      var descend = function (element) {
	        var children = children$3(element);
	        for (var i = children.length - 1; i >= 0; i--) {
	          var child = children[i];
	          if (predicate(child)) {
	            return Optional.some(child);
	          }
	          var res = descend(child);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Optional.none();
	      };
	      return descend(scope);
	    };
	
	    var transferableAttributes = {
	      scope: [
	        'row',
	        'col'
	      ]
	    };
	    var createCell = function (doc) {
	      return function () {
	        var td = SugarElement.fromTag('td', doc.dom);
	        append$1(td, SugarElement.fromTag('br', doc.dom));
	        return td;
	      };
	    };
	    var createCol = function (doc) {
	      return function () {
	        return SugarElement.fromTag('col', doc.dom);
	      };
	    };
	    var createColgroup = function (doc) {
	      return function () {
	        return SugarElement.fromTag('colgroup', doc.dom);
	      };
	    };
	    var createRow$1 = function (doc) {
	      return function () {
	        return SugarElement.fromTag('tr', doc.dom);
	      };
	    };
	    var replace$1 = function (cell, tag, attrs) {
	      var replica = copy$1(cell, tag);
	      each$1(attrs, function (v, k) {
	        if (v === null) {
	          remove$7(replica, k);
	        } else {
	          set$2(replica, k, v);
	        }
	      });
	      return replica;
	    };
	    var pasteReplace = function (cell) {
	      return cell;
	    };
	    var cloneFormats = function (oldCell, newCell, formats) {
	      var first$1 = first(oldCell);
	      return first$1.map(function (firstText) {
	        var formatSelector = formats.join(',');
	        var parents = ancestors$3(firstText, formatSelector, function (element) {
	          return eq$1(element, oldCell);
	        });
	        return foldr(parents, function (last, parent) {
	          var clonedFormat = shallow(parent);
	          remove$7(clonedFormat, 'contenteditable');
	          append$1(last, clonedFormat);
	          return clonedFormat;
	        }, newCell);
	      }).getOr(newCell);
	    };
	    var cloneAppropriateAttributes = function (original, clone) {
	      each$1(transferableAttributes, function (validAttributes, attributeName) {
	        return getOpt(original, attributeName).filter(function (attribute) {
	          return contains$2(validAttributes, attribute);
	        }).each(function (attribute) {
	          return set$2(clone, attributeName, attribute);
	        });
	      });
	    };
	    var cellOperations = function (mutate, doc, formatsToClone) {
	      var cloneCss = function (prev, clone) {
	        copy$2(prev.element, clone);
	        remove$6(clone, 'height');
	        if (prev.colspan !== 1) {
	          remove$6(clone, 'width');
	        }
	      };
	      var newCell = function (prev) {
	        var td = SugarElement.fromTag(name(prev.element), doc.dom);
	        var formats = formatsToClone.getOr([
	          'strong',
	          'em',
	          'b',
	          'i',
	          'span',
	          'font',
	          'h1',
	          'h2',
	          'h3',
	          'h4',
	          'h5',
	          'h6',
	          'p',
	          'div'
	        ]);
	        var lastNode = formats.length > 0 ? cloneFormats(prev.element, td, formats) : td;
	        append$1(lastNode, SugarElement.fromTag('br'));
	        cloneCss(prev, td);
	        cloneAppropriateAttributes(prev.element, td);
	        mutate(prev.element, td);
	        return td;
	      };
	      var newCol = function (prev) {
	        var col = SugarElement.fromTag(name(prev.element), doc.dom);
	        cloneCss(prev, col);
	        mutate(prev.element, col);
	        return col;
	      };
	      return {
	        col: newCol,
	        colgroup: createColgroup(doc),
	        row: createRow$1(doc),
	        cell: newCell,
	        replace: replace$1,
	        colGap: createCol(doc),
	        gap: createCell(doc)
	      };
	    };
	    var paste$1 = function (doc) {
	      return {
	        col: createCol(doc),
	        colgroup: createColgroup(doc),
	        row: createRow$1(doc),
	        cell: createCell(doc),
	        replace: pasteReplace,
	        colGap: createCol(doc),
	        gap: createCell(doc)
	      };
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children$3(SugarElement.fromDom(div));
	    };
	    var fromDom = function (nodes) {
	      return map$1(nodes, SugarElement.fromDom);
	    };
	
	    var getNodeName = function (elm) {
	      return elm.nodeName.toLowerCase();
	    };
	    var getBody = function (editor) {
	      return SugarElement.fromDom(editor.getBody());
	    };
	    var getPixelWidth = function (elm) {
	      return elm.getBoundingClientRect().width;
	    };
	    var getPixelHeight = function (elm) {
	      return elm.getBoundingClientRect().height;
	    };
	    var getIsRoot = function (editor) {
	      return function (element) {
	        return eq$1(element, getBody(editor));
	      };
	    };
	    var removePxSuffix = function (size) {
	      return size ? size.replace(/px$/, '') : '';
	    };
	    var addPxSuffix = function (size) {
	      return /^\d+(\.\d+)?$/.test(size) ? size + 'px' : size;
	    };
	    var removeDataStyle = function (table) {
	      remove$7(table, 'data-mce-style');
	      var removeStyleAttribute = function (element) {
	        return remove$7(element, 'data-mce-style');
	      };
	      each$2(cells$1(table), removeStyleAttribute);
	      each$2(columns$1(table), removeStyleAttribute);
	      each$2(rows$1(table), removeStyleAttribute);
	    };
	    var getRawWidth = function (editor, elm) {
	      var raw = editor.dom.getStyle(elm, 'width') || editor.dom.getAttrib(elm, 'width');
	      return Optional.from(raw).filter(isNotEmpty);
	    };
	    var isPercentage$1 = function (value) {
	      return /^(\d+(\.\d+)?)%$/.test(value);
	    };
	    var isPixel = function (value) {
	      return /^(\d+(\.\d+)?)px$/.test(value);
	    };
	    var getSelectionStart = function (editor) {
	      return SugarElement.fromDom(editor.selection.getStart());
	    };
	    var getSelectionEnd = function (editor) {
	      return SugarElement.fromDom(editor.selection.getEnd());
	    };
	
	    var selection = function (selections) {
	      return cata$2(selections.get(), constant([]), identity, pure);
	    };
	    var unmergable = function (selections) {
	      var hasSpan = function (elem, type) {
	        return getOpt(elem, type).exists(function (span) {
	          return parseInt(span, 10) > 1;
	        });
	      };
	      var hasRowOrColSpan = function (elem) {
	        return hasSpan(elem, 'rowspan') || hasSpan(elem, 'colspan');
	      };
	      var candidates = selection(selections);
	      return candidates.length > 0 && forall(candidates, hasRowOrColSpan) ? Optional.some(candidates) : Optional.none();
	    };
	    var mergable = function (table, selections, ephemera) {
	      return cata$2(selections.get(), Optional.none, function (cells) {
	        if (cells.length <= 1) {
	          return Optional.none();
	        } else {
	          return retrieveBox(table, ephemera.firstSelectedSelector, ephemera.lastSelectedSelector).map(function (bounds) {
	            return {
	              bounds: bounds,
	              cells: cells
	            };
	          });
	        }
	      }, Optional.none);
	    };
	
	    var strSelected = 'data-mce-selected';
	    var strSelectedSelector = 'td[' + strSelected + '],th[' + strSelected + ']';
	    var strAttributeSelector = '[' + strSelected + ']';
	    var strFirstSelected = 'data-mce-first-selected';
	    var strFirstSelectedSelector = 'td[' + strFirstSelected + '],th[' + strFirstSelected + ']';
	    var strLastSelected = 'data-mce-last-selected';
	    var strLastSelectedSelector = 'td[' + strLastSelected + '],th[' + strLastSelected + ']';
	    var attributeSelector = strAttributeSelector;
	    var ephemera = {
	      selected: strSelected,
	      selectedSelector: strSelectedSelector,
	      firstSelected: strFirstSelected,
	      firstSelectedSelector: strFirstSelectedSelector,
	      lastSelected: strLastSelected,
	      lastSelectedSelector: strLastSelectedSelector
	    };
	
	    var noMenu = function (cell) {
	      return {
	        element: cell,
	        mergable: Optional.none(),
	        unmergable: Optional.none(),
	        selection: [cell]
	      };
	    };
	    var forMenu = function (selections, table, cell) {
	      return {
	        element: cell,
	        mergable: mergable(table, selections, ephemera),
	        unmergable: unmergable(selections),
	        selection: selection(selections)
	      };
	    };
	    var paste = function (element, clipboard, generators) {
	      return {
	        element: element,
	        clipboard: clipboard,
	        generators: generators
	      };
	    };
	    var pasteRows = function (selections, cell, clipboard, generators) {
	      return {
	        selection: selection(selections),
	        clipboard: clipboard,
	        generators: generators
	      };
	    };
	
	    var getSelectionCellFallback = function (element) {
	      return table(element).bind(function (table) {
	        return retrieve(table, ephemera.firstSelectedSelector);
	      }).fold(constant(element), function (cells) {
	        return cells[0];
	      });
	    };
	    var getSelectionFromSelector = function (selector) {
	      return function (initCell, isRoot) {
	        var cellName = name(initCell);
	        var cell = cellName === 'col' || cellName === 'colgroup' ? getSelectionCellFallback(initCell) : initCell;
	        return closest$1(cell, selector, isRoot);
	      };
	    };
	    var getSelectionCellOrCaption = getSelectionFromSelector('th,td,caption');
	    var getSelectionCell = getSelectionFromSelector('th,td');
	    var getCellsFromSelection = function (selections) {
	      return selection(selections);
	    };
	    var getRowsFromSelection = function (selected, selector) {
	      var cellOpt = getSelectionCell(selected);
	      var rowsOpt = cellOpt.bind(function (cell) {
	        return table(cell);
	      }).map(function (table) {
	        return rows$1(table);
	      });
	      return lift2(cellOpt, rowsOpt, function (cell, rows) {
	        return filter$2(rows, function (row) {
	          return exists(fromDom(row.dom.cells), function (rowCell) {
	            return get$b(rowCell, selector) === '1' || eq$1(rowCell, cell);
	          });
	        });
	      }).getOr([]);
	    };
	
	    var extractSelected = function (cells) {
	      return table(cells[0]).map(function (table) {
	        var replica = extract$1(table, attributeSelector);
	        removeDataStyle(replica);
	        return [replica];
	      });
	    };
	    var serializeElements = function (editor, elements) {
	      return map$1(elements, function (elm) {
	        return editor.selection.serializer.serialize(elm.dom, {});
	      }).join('');
	    };
	    var getTextContent = function (elements) {
	      return map$1(elements, function (element) {
	        return element.dom.innerText;
	      }).join('');
	    };
	    var registerEvents = function (editor, selections, actions) {
	      editor.on('BeforeGetContent', function (e) {
	        var multiCellContext = function (cells) {
	          e.preventDefault();
	          extractSelected(cells).each(function (elements) {
	            e.content = e.format === 'text' ? getTextContent(elements) : serializeElements(editor, elements);
	          });
	        };
	        if (e.selection === true) {
	          cata$2(selections.get(), noop, multiCellContext, noop);
	        }
	      });
	      editor.on('BeforeSetContent', function (e) {
	        if (e.selection === true && e.paste === true) {
	          var selectedCells = getCellsFromSelection(selections);
	          head(selectedCells).each(function (cell) {
	            table(cell).each(function (table) {
	              var elements = filter$2(fromHtml(e.content), function (content) {
	                return name(content) !== 'meta';
	              });
	              var isTable = isTag('table');
	              if (elements.length === 1 && isTable(elements[0])) {
	                e.preventDefault();
	                var doc = SugarElement.fromDom(editor.getDoc());
	                var generators = paste$1(doc);
	                var targets = paste(cell, elements[0], generators);
	                actions.pasteCells(table, targets).each(function () {
	                  editor.focus();
	                });
	              }
	            });
	          });
	        }
	      });
	    };
	
	    var adt$7 = Adt.generate([
	      { none: [] },
	      { only: ['index'] },
	      {
	        left: [
	          'index',
	          'next'
	        ]
	      },
	      {
	        middle: [
	          'prev',
	          'index',
	          'next'
	        ]
	      },
	      {
	        right: [
	          'prev',
	          'index'
	        ]
	      }
	    ]);
	    var ColumnContext = __assign({}, adt$7);
	
	    var neighbours = function (input, index) {
	      if (input.length === 0) {
	        return ColumnContext.none();
	      }
	      if (input.length === 1) {
	        return ColumnContext.only(0);
	      }
	      if (index === 0) {
	        return ColumnContext.left(0, 1);
	      }
	      if (index === input.length - 1) {
	        return ColumnContext.right(index - 1, index);
	      }
	      if (index > 0 && index < input.length - 1) {
	        return ColumnContext.middle(index - 1, index, index + 1);
	      }
	      return ColumnContext.none();
	    };
	    var determine = function (input, column, step, tableSize, resize) {
	      var result = input.slice(0);
	      var context = neighbours(input, column);
	      var onNone = constant(map$1(result, constant(0)));
	      var onOnly = function (index) {
	        return tableSize.singleColumnWidth(result[index], step);
	      };
	      var onLeft = function (index, next) {
	        return resize.calcLeftEdgeDeltas(result, index, next, step, tableSize.minCellWidth(), tableSize.isRelative);
	      };
	      var onMiddle = function (prev, index, next) {
	        return resize.calcMiddleDeltas(result, prev, index, next, step, tableSize.minCellWidth(), tableSize.isRelative);
	      };
	      var onRight = function (prev, index) {
	        return resize.calcRightEdgeDeltas(result, prev, index, step, tableSize.minCellWidth(), tableSize.isRelative);
	      };
	      return context.fold(onNone, onOnly, onLeft, onMiddle, onRight);
	    };
	
	    var total = function (start, end, measures) {
	      var r = 0;
	      for (var i = start; i < end; i++) {
	        r += measures[i] !== undefined ? measures[i] : 0;
	      }
	      return r;
	    };
	    var recalculateWidthForCells = function (warehouse, widths) {
	      var all = Warehouse.justCells(warehouse);
	      return map$1(all, function (cell) {
	        var width = total(cell.column, cell.column + cell.colspan, widths);
	        return {
	          element: cell.element,
	          width: width,
	          colspan: cell.colspan
	        };
	      });
	    };
	    var recalculateWidthForColumns = function (warehouse, widths) {
	      var groups = Warehouse.justColumns(warehouse);
	      return map$1(groups, function (column, index) {
	        return {
	          element: column.element,
	          width: widths[index],
	          colspan: column.colspan
	        };
	      });
	    };
	    var recalculateHeightForCells = function (warehouse, heights) {
	      var all = Warehouse.justCells(warehouse);
	      return map$1(all, function (cell) {
	        var height = total(cell.row, cell.row + cell.rowspan, heights);
	        return {
	          element: cell.element,
	          height: height,
	          rowspan: cell.rowspan
	        };
	      });
	    };
	    var matchRowHeight = function (warehouse, heights) {
	      return map$1(warehouse.all, function (row, i) {
	        return {
	          element: row.element,
	          height: heights[i]
	        };
	      });
	    };
	
	    var sumUp = function (newSize) {
	      return foldr(newSize, function (b, a) {
	        return b + a;
	      }, 0);
	    };
	    var recalculate = function (warehouse, widths) {
	      if (Warehouse.hasColumns(warehouse)) {
	        return recalculateWidthForColumns(warehouse, widths);
	      } else {
	        return recalculateWidthForCells(warehouse, widths);
	      }
	    };
	    var recalculateAndApply = function (warehouse, widths, tableSize) {
	      var newSizes = recalculate(warehouse, widths);
	      each$2(newSizes, function (cell) {
	        tableSize.setElementWidth(cell.element, cell.width);
	      });
	    };
	    var adjustWidth = function (table, delta, index, resizing, tableSize) {
	      var warehouse = Warehouse.fromTable(table);
	      var step = tableSize.getCellDelta(delta);
	      var widths = tableSize.getWidths(warehouse, tableSize);
	      var isLastColumn = index === warehouse.grid.columns - 1;
	      var clampedStep = resizing.clampTableDelta(widths, index, step, tableSize.minCellWidth(), isLastColumn);
	      var deltas = determine(widths, index, clampedStep, tableSize, resizing);
	      var newWidths = map$1(deltas, function (dx, i) {
	        return dx + widths[i];
	      });
	      recalculateAndApply(warehouse, newWidths, tableSize);
	      resizing.resizeTable(tableSize.adjustTableWidth, clampedStep, isLastColumn);
	    };
	    var adjustHeight = function (table, delta, index, direction) {
	      var warehouse = Warehouse.fromTable(table);
	      var heights = getPixelHeights(warehouse, table, direction);
	      var newHeights = map$1(heights, function (dy, i) {
	        return index === i ? Math.max(delta + dy, minHeight()) : dy;
	      });
	      var newCellSizes = recalculateHeightForCells(warehouse, newHeights);
	      var newRowSizes = matchRowHeight(warehouse, newHeights);
	      each$2(newRowSizes, function (row) {
	        setHeight(row.element, row.height);
	      });
	      each$2(newCellSizes, function (cell) {
	        setHeight(cell.element, cell.height);
	      });
	      var total = sumUp(newHeights);
	      setHeight(table, total);
	    };
	    var adjustAndRedistributeWidths$1 = function (_table, list, details, tableSize, resizeBehaviour) {
	      var warehouse = Warehouse.generate(list);
	      var sizes = tableSize.getWidths(warehouse, tableSize);
	      var tablePixelWidth = tableSize.pixelWidth();
	      var _a = resizeBehaviour.calcRedestributedWidths(sizes, tablePixelWidth, details.pixelDelta, tableSize.isRelative), newSizes = _a.newSizes, delta = _a.delta;
	      recalculateAndApply(warehouse, newSizes, tableSize);
	      tableSize.adjustTableWidth(delta);
	    };
	    var adjustWidthTo = function (_table, list, _info, tableSize) {
	      var warehouse = Warehouse.generate(list);
	      var widths = tableSize.getWidths(warehouse, tableSize);
	      recalculateAndApply(warehouse, widths, tableSize);
	    };
	
	    var zero = function (array) {
	      return map$1(array, constant(0));
	    };
	    var surround = function (sizes, startIndex, endIndex, results, f) {
	      return f(sizes.slice(0, startIndex)).concat(results).concat(f(sizes.slice(endIndex)));
	    };
	    var clampDeltaHelper = function (predicate) {
	      return function (sizes, index, delta, minCellSize) {
	        if (!predicate(delta)) {
	          return delta;
	        } else {
	          var newSize = Math.max(minCellSize, sizes[index] - Math.abs(delta));
	          var diff = Math.abs(newSize - sizes[index]);
	          return delta >= 0 ? diff : -diff;
	        }
	      };
	    };
	    var clampNegativeDelta = clampDeltaHelper(function (delta) {
	      return delta < 0;
	    });
	    var clampDelta = clampDeltaHelper(always);
	    var resizeTable = function () {
	      var calcFixedDeltas = function (sizes, index, next, delta, minCellSize) {
	        var clampedDelta = clampNegativeDelta(sizes, index, delta, minCellSize);
	        return surround(sizes, index, next + 1, [
	          clampedDelta,
	          0
	        ], zero);
	      };
	      var calcRelativeDeltas = function (sizes, index, delta, minCellSize) {
	        var ratio = (100 + delta) / 100;
	        var newThis = Math.max(minCellSize, (sizes[index] + delta) / ratio);
	        return map$1(sizes, function (size, idx) {
	          var newSize = idx === index ? newThis : size / ratio;
	          return newSize - size;
	        });
	      };
	      var calcLeftEdgeDeltas = function (sizes, index, next, delta, minCellSize, isRelative) {
	        if (isRelative) {
	          return calcRelativeDeltas(sizes, index, delta, minCellSize);
	        } else {
	          return calcFixedDeltas(sizes, index, next, delta, minCellSize);
	        }
	      };
	      var calcMiddleDeltas = function (sizes, _prev, index, next, delta, minCellSize, isRelative) {
	        return calcLeftEdgeDeltas(sizes, index, next, delta, minCellSize, isRelative);
	      };
	      var resizeTable = function (resizer, delta) {
	        return resizer(delta);
	      };
	      var calcRightEdgeDeltas = function (sizes, _prev, index, delta, minCellSize, isRelative) {
	        if (isRelative) {
	          return calcRelativeDeltas(sizes, index, delta, minCellSize);
	        } else {
	          var clampedDelta = clampNegativeDelta(sizes, index, delta, minCellSize);
	          return zero(sizes.slice(0, index)).concat([clampedDelta]);
	        }
	      };
	      var calcRedestributedWidths = function (sizes, totalWidth, pixelDelta, isRelative) {
	        if (isRelative) {
	          var tableWidth = totalWidth + pixelDelta;
	          var ratio_1 = tableWidth / totalWidth;
	          var newSizes = map$1(sizes, function (size) {
	            return size / ratio_1;
	          });
	          return {
	            delta: ratio_1 * 100 - 100,
	            newSizes: newSizes
	          };
	        } else {
	          return {
	            delta: pixelDelta,
	            newSizes: sizes
	          };
	        }
	      };
	      return {
	        resizeTable: resizeTable,
	        clampTableDelta: clampNegativeDelta,
	        calcLeftEdgeDeltas: calcLeftEdgeDeltas,
	        calcMiddleDeltas: calcMiddleDeltas,
	        calcRightEdgeDeltas: calcRightEdgeDeltas,
	        calcRedestributedWidths: calcRedestributedWidths
	      };
	    };
	    var preserveTable = function () {
	      var calcLeftEdgeDeltas = function (sizes, index, next, delta, minCellSize) {
	        var idx = delta >= 0 ? next : index;
	        var clampedDelta = clampDelta(sizes, idx, delta, minCellSize);
	        return surround(sizes, index, next + 1, [
	          clampedDelta,
	          -clampedDelta
	        ], zero);
	      };
	      var calcMiddleDeltas = function (sizes, _prev, index, next, delta, minCellSize) {
	        return calcLeftEdgeDeltas(sizes, index, next, delta, minCellSize);
	      };
	      var resizeTable = function (resizer, delta, isLastColumn) {
	        if (isLastColumn) {
	          resizer(delta);
	        }
	      };
	      var calcRightEdgeDeltas = function (sizes, _prev, _index, delta, _minCellSize, isRelative) {
	        if (isRelative) {
	          return zero(sizes);
	        } else {
	          var diff = delta / sizes.length;
	          return map$1(sizes, constant(diff));
	        }
	      };
	      var clampTableDelta = function (sizes, index, delta, minCellSize, isLastColumn) {
	        if (isLastColumn) {
	          if (delta >= 0) {
	            return delta;
	          } else {
	            var maxDelta = foldl(sizes, function (a, b) {
	              return a + b - minCellSize;
	            }, 0);
	            return Math.max(-maxDelta, delta);
	          }
	        } else {
	          return clampNegativeDelta(sizes, index, delta, minCellSize);
	        }
	      };
	      var calcRedestributedWidths = function (sizes, _totalWidth, _pixelDelta, _isRelative) {
	        return {
	          delta: 0,
	          newSizes: sizes
	        };
	      };
	      return {
	        resizeTable: resizeTable,
	        clampTableDelta: clampTableDelta,
	        calcLeftEdgeDeltas: calcLeftEdgeDeltas,
	        calcMiddleDeltas: calcMiddleDeltas,
	        calcRightEdgeDeltas: calcRightEdgeDeltas,
	        calcRedestributedWidths: calcRedestributedWidths
	      };
	    };
	
	    var only = function (element, isResizable) {
	      var parent = Optional.from(element.dom.documentElement).map(SugarElement.fromDom).getOr(element);
	      return {
	        parent: constant(parent),
	        view: constant(element),
	        origin: constant(SugarPosition(0, 0)),
	        isResizable: isResizable
	      };
	    };
	    var detached = function (editable, chrome, isResizable) {
	      var origin = function () {
	        return absolute(chrome);
	      };
	      return {
	        parent: constant(chrome),
	        view: constant(editable),
	        origin: origin,
	        isResizable: isResizable
	      };
	    };
	    var body = function (editable, chrome, isResizable) {
	      return {
	        parent: constant(chrome),
	        view: constant(editable),
	        origin: constant(SugarPosition(0, 0)),
	        isResizable: isResizable
	      };
	    };
	    var ResizeWire = {
	      only: only,
	      detached: detached,
	      body: body
	    };
	
	    var adt$6 = Adt.generate([
	      { invalid: ['raw'] },
	      { pixels: ['value'] },
	      { percent: ['value'] }
	    ]);
	    var validateFor = function (suffix, type, value) {
	      var rawAmount = value.substring(0, value.length - suffix.length);
	      var amount = parseFloat(rawAmount);
	      return rawAmount === amount.toString() ? type(amount) : adt$6.invalid(value);
	    };
	    var from = function (value) {
	      if (endsWith(value, '%')) {
	        return validateFor('%', adt$6.percent, value);
	      }
	      if (endsWith(value, 'px')) {
	        return validateFor('px', adt$6.pixels, value);
	      }
	      return adt$6.invalid(value);
	    };
	    var Size = __assign(__assign({}, adt$6), { from: from });
	
	    var redistributeToPercent = function (widths, totalWidth) {
	      return map$1(widths, function (w) {
	        var colType = Size.from(w);
	        return colType.fold(function () {
	          return w;
	        }, function (px) {
	          var ratio = px / totalWidth * 100;
	          return ratio + '%';
	        }, function (pc) {
	          return pc + '%';
	        });
	      });
	    };
	    var redistributeToPx = function (widths, totalWidth, newTotalWidth) {
	      var scale = newTotalWidth / totalWidth;
	      return map$1(widths, function (w) {
	        var colType = Size.from(w);
	        return colType.fold(function () {
	          return w;
	        }, function (px) {
	          return px * scale + 'px';
	        }, function (pc) {
	          return pc / 100 * newTotalWidth + 'px';
	        });
	      });
	    };
	    var redistributeEmpty = function (newWidthType, columns) {
	      var f = newWidthType.fold(function () {
	        return constant('');
	      }, function (pixels) {
	        var num = pixels / columns;
	        return constant(num + 'px');
	      }, function () {
	        var num = 100 / columns;
	        return constant(num + '%');
	      });
	      return range$1(columns, f);
	    };
	    var redistributeValues = function (newWidthType, widths, totalWidth) {
	      return newWidthType.fold(function () {
	        return widths;
	      }, function (px) {
	        return redistributeToPx(widths, totalWidth, px);
	      }, function (_pc) {
	        return redistributeToPercent(widths, totalWidth);
	      });
	    };
	    var redistribute$1 = function (widths, totalWidth, newWidth) {
	      var newType = Size.from(newWidth);
	      var floats = forall(widths, function (s) {
	        return s === '0px';
	      }) ? redistributeEmpty(newType, widths.length) : redistributeValues(newType, widths, totalWidth);
	      return normalize(floats);
	    };
	    var sum = function (values, fallback) {
	      if (values.length === 0) {
	        return fallback;
	      }
	      return foldr(values, function (rest, v) {
	        return Size.from(v).fold(constant(0), identity, identity) + rest;
	      }, 0);
	    };
	    var roundDown = function (num, unit) {
	      var floored = Math.floor(num);
	      return {
	        value: floored + unit,
	        remainder: num - floored
	      };
	    };
	    var add$3 = function (value, amount) {
	      return Size.from(value).fold(constant(value), function (px) {
	        return px + amount + 'px';
	      }, function (pc) {
	        return pc + amount + '%';
	      });
	    };
	    var normalize = function (values) {
	      if (values.length === 0) {
	        return values;
	      }
	      var scan = foldr(values, function (rest, value) {
	        var info = Size.from(value).fold(function () {
	          return {
	            value: value,
	            remainder: 0
	          };
	        }, function (num) {
	          return roundDown(num, 'px');
	        }, function (num) {
	          return {
	            value: num + '%',
	            remainder: 0
	          };
	        });
	        return {
	          output: [info.value].concat(rest.output),
	          remainder: rest.remainder + info.remainder
	        };
	      }, {
	        output: [],
	        remainder: 0
	      });
	      var r = scan.output;
	      return r.slice(0, r.length - 1).concat([add$3(r[r.length - 1], Math.round(scan.remainder))]);
	    };
	    var validate = Size.from;
	
	    var redistributeToW = function (newWidths, cells, unit) {
	      each$2(cells, function (cell) {
	        var widths = newWidths.slice(cell.column, cell.colspan + cell.column);
	        var w = sum(widths, minWidth());
	        set$1(cell.element, 'width', w + unit);
	      });
	    };
	    var redistributeToColumns = function (newWidths, columns, unit) {
	      each$2(columns, function (column, index) {
	        var width = sum([newWidths[index]], minWidth());
	        set$1(column.element, 'width', width + unit);
	      });
	    };
	    var redistributeToH = function (newHeights, rows, cells, unit) {
	      each$2(cells, function (cell) {
	        var heights = newHeights.slice(cell.row, cell.rowspan + cell.row);
	        var h = sum(heights, minHeight());
	        set$1(cell.element, 'height', h + unit);
	      });
	      each$2(rows, function (row, i) {
	        set$1(row.element, 'height', newHeights[i]);
	      });
	    };
	    var getUnit = function (newSize) {
	      return validate(newSize).fold(constant('px'), constant('px'), constant('%'));
	    };
	    var redistribute = function (table, optWidth, optHeight) {
	      var warehouse = Warehouse.fromTable(table);
	      var rows = warehouse.all;
	      var cells = Warehouse.justCells(warehouse);
	      var columns = Warehouse.justColumns(warehouse);
	      optWidth.each(function (newWidth) {
	        var widthUnit = getUnit(newWidth);
	        var totalWidth = get$8(table);
	        var oldWidths = getRawWidths(warehouse, table);
	        var nuWidths = redistribute$1(oldWidths, totalWidth, newWidth);
	        if (Warehouse.hasColumns(warehouse)) {
	          redistributeToColumns(nuWidths, columns, widthUnit);
	        } else {
	          redistributeToW(nuWidths, cells, widthUnit);
	        }
	        set$1(table, 'width', newWidth);
	      });
	      optHeight.each(function (newHeight) {
	        var hUnit = getUnit(newHeight);
	        var totalHeight = get$7(table);
	        var oldHeights = getRawHeights(warehouse, table, height);
	        var nuHeights = redistribute$1(oldHeights, totalHeight, newHeight);
	        redistributeToH(nuHeights, rows, cells, hUnit);
	        set$1(table, 'height', newHeight);
	      });
	    };
	    var isPercentSizing = isPercentSizing$1;
	    var isPixelSizing = isPixelSizing$1;
	    var isNoneSizing = isNoneSizing$1;
	
	    var getGridSize = function (table) {
	      var warehouse = Warehouse.fromTable(table);
	      return warehouse.grid;
	    };
	
	    var Event = function (fields) {
	      var handlers = [];
	      var bind = function (handler) {
	        if (handler === undefined) {
	          throw new Error('Event bind error: undefined handler');
	        }
	        handlers.push(handler);
	      };
	      var unbind = function (handler) {
	        handlers = filter$2(handlers, function (h) {
	          return h !== handler;
	        });
	      };
	      var trigger = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        var event = {};
	        each$2(fields, function (name, i) {
	          event[name] = args[i];
	        });
	        each$2(handlers, function (handler) {
	          handler(event);
	        });
	      };
	      return {
	        bind: bind,
	        unbind: unbind,
	        trigger: trigger
	      };
	    };
	
	    var create$4 = function (typeDefs) {
	      var registry = map(typeDefs, function (event) {
	        return {
	          bind: event.bind,
	          unbind: event.unbind
	        };
	      });
	      var trigger = map(typeDefs, function (event) {
	        return event.trigger;
	      });
	      return {
	        registry: registry,
	        trigger: trigger
	      };
	    };
	
	    var last = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (!isNull(timer)) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        cancel();
	        timer = setTimeout(function () {
	          timer = null;
	          fn.apply(null, args);
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var sort = function (arr) {
	      return arr.slice(0).sort();
	    };
	    var reqMessage = function (required, keys) {
	      throw new Error('All required keys (' + sort(required).join(', ') + ') were not specified. Specified keys were: ' + sort(keys).join(', ') + '.');
	    };
	    var unsuppMessage = function (unsupported) {
	      throw new Error('Unsupported keys for object: ' + sort(unsupported).join(', '));
	    };
	    var validateStrArr = function (label, array) {
	      if (!isArray(array)) {
	        throw new Error('The ' + label + ' fields must be an array. Was: ' + array + '.');
	      }
	      each$2(array, function (a) {
	        if (!isString(a)) {
	          throw new Error('The value ' + a + ' in the ' + label + ' fields was not a string.');
	        }
	      });
	    };
	    var invalidTypeMessage = function (incorrect, type) {
	      throw new Error('All values need to be of type: ' + type + '. Keys (' + sort(incorrect).join(', ') + ') were not.');
	    };
	    var checkDupes = function (everything) {
	      var sorted = sort(everything);
	      var dupe = find$1(sorted, function (s, i) {
	        return i < sorted.length - 1 && s === sorted[i + 1];
	      });
	      dupe.each(function (d) {
	        throw new Error('The field: ' + d + ' occurs more than once in the combined fields: [' + sorted.join(', ') + '].');
	      });
	    };
	
	    var base = function (handleUnsupported, required) {
	      return baseWith(handleUnsupported, required, {
	        validate: isFunction,
	        label: 'function'
	      });
	    };
	    var baseWith = function (handleUnsupported, required, pred) {
	      if (required.length === 0) {
	        throw new Error('You must specify at least one required field.');
	      }
	      validateStrArr('required', required);
	      checkDupes(required);
	      return function (obj) {
	        var keys$1 = keys(obj);
	        var allReqd = forall(required, function (req) {
	          return contains$2(keys$1, req);
	        });
	        if (!allReqd) {
	          reqMessage(required, keys$1);
	        }
	        handleUnsupported(required, keys$1);
	        var invalidKeys = filter$2(required, function (key) {
	          return !pred.validate(obj[key], key);
	        });
	        if (invalidKeys.length > 0) {
	          invalidTypeMessage(invalidKeys, pred.label);
	        }
	        return obj;
	      };
	    };
	    var handleExact = function (required, keys) {
	      var unsupported = filter$2(keys, function (key) {
	        return !contains$2(required, key);
	      });
	      if (unsupported.length > 0) {
	        unsuppMessage(unsupported);
	      }
	    };
	    var exactly = function (required) {
	      return base(handleExact, required);
	    };
	
	    var DragMode = exactly([
	      'compare',
	      'extract',
	      'mutate',
	      'sink'
	    ]);
	    var DragSink = exactly([
	      'element',
	      'start',
	      'stop',
	      'destroy'
	    ]);
	    var DragApi = exactly([
	      'forceDrop',
	      'drop',
	      'move',
	      'delayDrop'
	    ]);
	
	    var InDrag = function () {
	      var previous = Optional.none();
	      var reset = function () {
	        previous = Optional.none();
	      };
	      var update = function (mode, nu) {
	        var result = previous.map(function (old) {
	          return mode.compare(old, nu);
	        });
	        previous = Optional.some(nu);
	        return result;
	      };
	      var onEvent = function (event, mode) {
	        var dataOption = mode.extract(event);
	        dataOption.each(function (data) {
	          var offset = update(mode, data);
	          offset.each(function (d) {
	            events.trigger.move(d);
	          });
	        });
	      };
	      var events = create$4({ move: Event(['info']) });
	      return {
	        onEvent: onEvent,
	        reset: reset,
	        events: events.registry
	      };
	    };
	
	    var NoDrag = function () {
	      var events = create$4({ move: Event(['info']) });
	      return {
	        onEvent: noop,
	        reset: noop,
	        events: events.registry
	      };
	    };
	
	    var Movement = function () {
	      var noDragState = NoDrag();
	      var inDragState = InDrag();
	      var dragState = noDragState;
	      var on = function () {
	        dragState.reset();
	        dragState = inDragState;
	      };
	      var off = function () {
	        dragState.reset();
	        dragState = noDragState;
	      };
	      var onEvent = function (event, mode) {
	        dragState.onEvent(event, mode);
	      };
	      var isOn = function () {
	        return dragState === inDragState;
	      };
	      return {
	        on: on,
	        off: off,
	        isOn: isOn,
	        onEvent: onEvent,
	        events: inDragState.events
	      };
	    };
	
	    var setup = function (mutation, mode, settings) {
	      var active = false;
	      var events = create$4({
	        start: Event([]),
	        stop: Event([])
	      });
	      var movement = Movement();
	      var drop = function () {
	        sink.stop();
	        if (movement.isOn()) {
	          movement.off();
	          events.trigger.stop();
	        }
	      };
	      var throttledDrop = last(drop, 200);
	      var go = function (parent) {
	        sink.start(parent);
	        movement.on();
	        events.trigger.start();
	      };
	      var mousemove = function (event) {
	        throttledDrop.cancel();
	        movement.onEvent(event, mode);
	      };
	      movement.events.move.bind(function (event) {
	        mode.mutate(mutation, event.info);
	      });
	      var on = function () {
	        active = true;
	      };
	      var off = function () {
	        active = false;
	      };
	      var runIfActive = function (f) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          if (active) {
	            f.apply(null, args);
	          }
	        };
	      };
	      var sink = mode.sink(DragApi({
	        forceDrop: drop,
	        drop: runIfActive(drop),
	        move: runIfActive(mousemove),
	        delayDrop: runIfActive(throttledDrop.throttle)
	      }), settings);
	      var destroy = function () {
	        sink.destroy();
	      };
	      return {
	        element: sink.element,
	        go: go,
	        on: on,
	        off: off,
	        destroy: destroy,
	        events: events.registry
	      };
	    };
	
	    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
	      return {
	        target: target,
	        x: x,
	        y: y,
	        stop: stop,
	        prevent: prevent,
	        kill: kill,
	        raw: raw
	      };
	    };
	    var fromRawEvent$1 = function (rawEvent) {
	      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
	      var stop = function () {
	        return rawEvent.stopPropagation();
	      };
	      var prevent = function () {
	        return rawEvent.preventDefault();
	      };
	      var kill = compose(prevent, stop);
	      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
	    };
	    var handle$2 = function (filter, handler) {
	      return function (rawEvent) {
	        if (filter(rawEvent)) {
	          handler(fromRawEvent$1(rawEvent));
	        }
	      };
	    };
	    var binder = function (element, event, filter, handler, useCapture) {
	      var wrapped = handle$2(filter, handler);
	      element.dom.addEventListener(event, wrapped, useCapture);
	      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
	    };
	    var bind$1 = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, false);
	    };
	    var unbind = function (element, event, handler, useCapture) {
	      element.dom.removeEventListener(event, handler, useCapture);
	    };
	
	    var filter = always;
	    var bind = function (element, event, handler) {
	      return bind$1(element, event, filter, handler);
	    };
	    var fromRawEvent = fromRawEvent$1;
	
	    var read = function (element, attr) {
	      var value = get$b(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add$2 = function (element, attr, id) {
	      var old = read(element, attr);
	      var nu = old.concat([id]);
	      set$2(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$4 = function (element, attr, id) {
	      var nu = filter$2(read(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set$2(element, attr, nu.join(' '));
	      } else {
	        remove$7(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom.classList !== undefined;
	    };
	    var get$5 = function (element) {
	      return read(element, 'class');
	    };
	    var add$1 = function (element, clazz) {
	      return add$2(element, 'class', clazz);
	    };
	    var remove$3 = function (element, clazz) {
	      return remove$4(element, 'class', clazz);
	    };
	
	    var add = function (element, clazz) {
	      if (supports(element)) {
	        element.dom.classList.add(clazz);
	      } else {
	        add$1(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom.classList : get$5(element);
	      if (classList.length === 0) {
	        remove$7(element, 'class');
	      }
	    };
	    var remove$2 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom.classList;
	        classList.remove(clazz);
	      } else {
	        remove$3(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has = function (element, clazz) {
	      return supports(element) && element.dom.classList.contains(clazz);
	    };
	
	    var css = function (namespace) {
	      var dashNamespace = namespace.replace(/\./g, '-');
	      var resolve = function (str) {
	        return dashNamespace + '-' + str;
	      };
	      return { resolve: resolve };
	    };
	
	    var styles$1 = css('ephox-dragster');
	    var resolve$1 = styles$1.resolve;
	
	    var Blocker = function (options) {
	      var settings = __assign({ layerClass: resolve$1('blocker') }, options);
	      var div = SugarElement.fromTag('div');
	      set$2(div, 'role', 'presentation');
	      setAll(div, {
	        position: 'fixed',
	        left: '0px',
	        top: '0px',
	        width: '100%',
	        height: '100%'
	      });
	      add(div, resolve$1('blocker'));
	      add(div, settings.layerClass);
	      var element = constant(div);
	      var destroy = function () {
	        remove$5(div);
	      };
	      return {
	        element: element,
	        destroy: destroy
	      };
	    };
	
	    var compare = function (old, nu) {
	      return SugarPosition(nu.left - old.left, nu.top - old.top);
	    };
	    var extract = function (event) {
	      return Optional.some(SugarPosition(event.x, event.y));
	    };
	    var mutate = function (mutation, info) {
	      mutation.mutate(info.left, info.top);
	    };
	    var sink = function (dragApi, settings) {
	      var blocker = Blocker(settings);
	      var mdown = bind(blocker.element(), 'mousedown', dragApi.forceDrop);
	      var mup = bind(blocker.element(), 'mouseup', dragApi.drop);
	      var mmove = bind(blocker.element(), 'mousemove', dragApi.move);
	      var mout = bind(blocker.element(), 'mouseout', dragApi.delayDrop);
	      var destroy = function () {
	        blocker.destroy();
	        mup.unbind();
	        mmove.unbind();
	        mout.unbind();
	        mdown.unbind();
	      };
	      var start = function (parent) {
	        append$1(parent, blocker.element());
	      };
	      var stop = function () {
	        remove$5(blocker.element());
	      };
	      return DragSink({
	        element: blocker.element,
	        start: start,
	        stop: stop,
	        destroy: destroy
	      });
	    };
	    var MouseDrag = DragMode({
	      compare: compare,
	      extract: extract,
	      sink: sink,
	      mutate: mutate
	    });
	
	    var transform$1 = function (mutation, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var mode = settings.mode !== undefined ? settings.mode : MouseDrag;
	      return setup(mutation, mode, settings);
	    };
	
	    var closest = function (target) {
	      return closest$1(target, '[contenteditable]');
	    };
	    var isEditable$1 = function (element, assumeEditable) {
	      if (assumeEditable === void 0) {
	        assumeEditable = false;
	      }
	      if (!detect$3().browser.isIE() && inBody(element)) {
	        return element.dom.isContentEditable;
	      } else {
	        return closest(element).fold(constant(assumeEditable), function (editable) {
	          return getRaw(editable) === 'true';
	        });
	      }
	    };
	    var getRaw = function (element) {
	      return element.dom.contentEditable;
	    };
	
	    var styles = css('ephox-snooker');
	    var resolve = styles.resolve;
	
	    var Mutation = function () {
	      var events = create$4({
	        drag: Event([
	          'xDelta',
	          'yDelta'
	        ])
	      });
	      var mutate = function (x, y) {
	        events.trigger.drag(x, y);
	      };
	      return {
	        mutate: mutate,
	        events: events.registry
	      };
	    };
	
	    var BarMutation = function () {
	      var events = create$4({
	        drag: Event([
	          'xDelta',
	          'yDelta',
	          'target'
	        ])
	      });
	      var target = Optional.none();
	      var delegate = Mutation();
	      delegate.events.drag.bind(function (event) {
	        target.each(function (t) {
	          events.trigger.drag(event.xDelta, event.yDelta, t);
	        });
	      });
	      var assign = function (t) {
	        target = Optional.some(t);
	      };
	      var get = function () {
	        return target;
	      };
	      return {
	        assign: assign,
	        get: get,
	        mutate: delegate.mutate,
	        events: events.registry
	      };
	    };
	
	    var col = function (column, x, y, w, h) {
	      var bar = SugarElement.fromTag('div');
	      setAll(bar, {
	        position: 'absolute',
	        left: x - w / 2 + 'px',
	        top: y + 'px',
	        height: h + 'px',
	        width: w + 'px'
	      });
	      setAll$1(bar, {
	        'data-column': column,
	        'role': 'presentation'
	      });
	      return bar;
	    };
	    var row = function (r, x, y, w, h) {
	      var bar = SugarElement.fromTag('div');
	      setAll(bar, {
	        position: 'absolute',
	        left: x + 'px',
	        top: y - h / 2 + 'px',
	        height: h + 'px',
	        width: w + 'px'
	      });
	      setAll$1(bar, {
	        'data-row': r,
	        'role': 'presentation'
	      });
	      return bar;
	    };
	
	    var resizeBar = resolve('resizer-bar');
	    var resizeRowBar = resolve('resizer-rows');
	    var resizeColBar = resolve('resizer-cols');
	    var BAR_THICKNESS = 7;
	    var resizableRows = function (warehouse, isResizable) {
	      return bind$2(warehouse.all, function (row, i) {
	        return isResizable(row.element) ? [i] : [];
	      });
	    };
	    var resizableColumns = function (warehouse, isResizable) {
	      var resizableCols = [];
	      range$1(warehouse.grid.columns, function (index) {
	        var colElmOpt = Warehouse.getColumnAt(warehouse, index).map(function (col) {
	          return col.element;
	        });
	        if (colElmOpt.forall(isResizable)) {
	          resizableCols.push(index);
	        }
	      });
	      return filter$2(resizableCols, function (colIndex) {
	        var columnCells = Warehouse.filterItems(warehouse, function (cell) {
	          return cell.column === colIndex;
	        });
	        return forall(columnCells, function (cell) {
	          return isResizable(cell.element);
	        });
	      });
	    };
	    var destroy = function (wire) {
	      var previous = descendants(wire.parent(), '.' + resizeBar);
	      each$2(previous, remove$5);
	    };
	    var drawBar = function (wire, positions, create) {
	      var origin = wire.origin();
	      each$2(positions, function (cpOption) {
	        cpOption.each(function (cp) {
	          var bar = create(origin, cp);
	          add(bar, resizeBar);
	          append$1(wire.parent(), bar);
	        });
	      });
	    };
	    var refreshCol = function (wire, colPositions, position, tableHeight) {
	      drawBar(wire, colPositions, function (origin, cp) {
	        var colBar = col(cp.col, cp.x - origin.left, position.top - origin.top, BAR_THICKNESS, tableHeight);
	        add(colBar, resizeColBar);
	        return colBar;
	      });
	    };
	    var refreshRow = function (wire, rowPositions, position, tableWidth) {
	      drawBar(wire, rowPositions, function (origin, cp) {
	        var rowBar = row(cp.row, position.left - origin.left, cp.y - origin.top, tableWidth, BAR_THICKNESS);
	        add(rowBar, resizeRowBar);
	        return rowBar;
	      });
	    };
	    var refreshGrid = function (warhouse, wire, table, rows, cols) {
	      var position = absolute(table);
	      var isResizable = wire.isResizable;
	      var rowPositions = rows.length > 0 ? height.positions(rows, table) : [];
	      var resizableRowBars = rowPositions.length > 0 ? resizableRows(warhouse, isResizable) : [];
	      var resizableRowPositions = filter$2(rowPositions, function (_pos, i) {
	        return exists(resizableRowBars, function (barIndex) {
	          return i === barIndex;
	        });
	      });
	      refreshRow(wire, resizableRowPositions, position, getOuter$2(table));
	      var colPositions = cols.length > 0 ? width.positions(cols, table) : [];
	      var resizableColBars = colPositions.length > 0 ? resizableColumns(warhouse, isResizable) : [];
	      var resizableColPositions = filter$2(colPositions, function (_pos, i) {
	        return exists(resizableColBars, function (barIndex) {
	          return i === barIndex;
	        });
	      });
	      refreshCol(wire, resizableColPositions, position, getOuter$1(table));
	    };
	    var refresh = function (wire, table) {
	      destroy(wire);
	      if (wire.isResizable(table)) {
	        var warehouse = Warehouse.fromTable(table);
	        var rows$1 = rows(warehouse);
	        var cols = columns(warehouse);
	        refreshGrid(warehouse, wire, table, rows$1, cols);
	      }
	    };
	    var each = function (wire, f) {
	      var bars = descendants(wire.parent(), '.' + resizeBar);
	      each$2(bars, f);
	    };
	    var hide = function (wire) {
	      each(wire, function (bar) {
	        set$1(bar, 'display', 'none');
	      });
	    };
	    var show = function (wire) {
	      each(wire, function (bar) {
	        set$1(bar, 'display', 'block');
	      });
	    };
	    var isRowBar = function (element) {
	      return has(element, resizeRowBar);
	    };
	    var isColBar = function (element) {
	      return has(element, resizeColBar);
	    };
	
	    var resizeBarDragging = resolve('resizer-bar-dragging');
	    var BarManager = function (wire) {
	      var mutation = BarMutation();
	      var resizing = transform$1(mutation, {});
	      var hoverTable = Optional.none();
	      var getResizer = function (element, type) {
	        return Optional.from(get$b(element, type));
	      };
	      mutation.events.drag.bind(function (event) {
	        getResizer(event.target, 'data-row').each(function (_dataRow) {
	          var currentRow = getCssValue(event.target, 'top');
	          set$1(event.target, 'top', currentRow + event.yDelta + 'px');
	        });
	        getResizer(event.target, 'data-column').each(function (_dataCol) {
	          var currentCol = getCssValue(event.target, 'left');
	          set$1(event.target, 'left', currentCol + event.xDelta + 'px');
	        });
	      });
	      var getDelta = function (target, dir) {
	        var newX = getCssValue(target, dir);
	        var oldX = getAttrValue(target, 'data-initial-' + dir, 0);
	        return newX - oldX;
	      };
	      resizing.events.stop.bind(function () {
	        mutation.get().each(function (target) {
	          hoverTable.each(function (table) {
	            getResizer(target, 'data-row').each(function (row) {
	              var delta = getDelta(target, 'top');
	              remove$7(target, 'data-initial-top');
	              events.trigger.adjustHeight(table, delta, parseInt(row, 10));
	            });
	            getResizer(target, 'data-column').each(function (column) {
	              var delta = getDelta(target, 'left');
	              remove$7(target, 'data-initial-left');
	              events.trigger.adjustWidth(table, delta, parseInt(column, 10));
	            });
	            refresh(wire, table);
	          });
	        });
	      });
	      var handler = function (target, dir) {
	        events.trigger.startAdjust();
	        mutation.assign(target);
	        set$2(target, 'data-initial-' + dir, getCssValue(target, dir));
	        add(target, resizeBarDragging);
	        set$1(target, 'opacity', '0.2');
	        resizing.go(wire.parent());
	      };
	      var mousedown = bind(wire.parent(), 'mousedown', function (event) {
	        if (isRowBar(event.target)) {
	          handler(event.target, 'top');
	        }
	        if (isColBar(event.target)) {
	          handler(event.target, 'left');
	        }
	      });
	      var isRoot = function (e) {
	        return eq$1(e, wire.view());
	      };
	      var findClosestEditableTable = function (target) {
	        return closest$1(target, 'table', isRoot).filter(isEditable$1);
	      };
	      var mouseover = bind(wire.view(), 'mouseover', function (event) {
	        findClosestEditableTable(event.target).fold(function () {
	          if (inBody(event.target)) {
	            destroy(wire);
	          }
	        }, function (table) {
	          hoverTable = Optional.some(table);
	          refresh(wire, table);
	        });
	      });
	      var destroy$1 = function () {
	        mousedown.unbind();
	        mouseover.unbind();
	        resizing.destroy();
	        destroy(wire);
	      };
	      var refresh$1 = function (tbl) {
	        refresh(wire, tbl);
	      };
	      var events = create$4({
	        adjustHeight: Event([
	          'table',
	          'delta',
	          'row'
	        ]),
	        adjustWidth: Event([
	          'table',
	          'delta',
	          'column'
	        ]),
	        startAdjust: Event([])
	      });
	      return {
	        destroy: destroy$1,
	        refresh: refresh$1,
	        on: resizing.on,
	        off: resizing.off,
	        hideBars: curry(hide, wire),
	        showBars: curry(show, wire),
	        events: events.registry
	      };
	    };
	
	    var create$3 = function (wire, resizing, lazySizing) {
	      var hdirection = height;
	      var vdirection = width;
	      var manager = BarManager(wire);
	      var events = create$4({
	        beforeResize: Event([
	          'table',
	          'type'
	        ]),
	        afterResize: Event([
	          'table',
	          'type'
	        ]),
	        startDrag: Event([])
	      });
	      manager.events.adjustHeight.bind(function (event) {
	        var table = event.table;
	        events.trigger.beforeResize(table, 'row');
	        var delta = hdirection.delta(event.delta, table);
	        adjustHeight(table, delta, event.row, hdirection);
	        events.trigger.afterResize(table, 'row');
	      });
	      manager.events.startAdjust.bind(function (_event) {
	        events.trigger.startDrag();
	      });
	      manager.events.adjustWidth.bind(function (event) {
	        var table = event.table;
	        events.trigger.beforeResize(table, 'col');
	        var delta = vdirection.delta(event.delta, table);
	        var tableSize = lazySizing(table);
	        adjustWidth(table, delta, event.column, resizing, tableSize);
	        events.trigger.afterResize(table, 'col');
	      });
	      return {
	        on: manager.on,
	        off: manager.off,
	        hideBars: manager.hideBars,
	        showBars: manager.showBars,
	        destroy: manager.destroy,
	        events: events.registry
	      };
	    };
	    var TableResize = { create: create$3 };
	
	    var fireNewRow = function (editor, row) {
	      return editor.fire('newrow', { node: row });
	    };
	    var fireNewCell = function (editor, cell) {
	      return editor.fire('newcell', { node: cell });
	    };
	    var fireObjectResizeStart = function (editor, target, width, height, origin) {
	      editor.fire('ObjectResizeStart', {
	        target: target,
	        width: width,
	        height: height,
	        origin: origin
	      });
	    };
	    var fireObjectResized = function (editor, target, width, height, origin) {
	      editor.fire('ObjectResized', {
	        target: target,
	        width: width,
	        height: height,
	        origin: origin
	      });
	    };
	    var fireTableSelectionChange = function (editor, cells, start, finish, otherCells) {
	      editor.fire('TableSelectionChange', {
	        cells: cells,
	        start: start,
	        finish: finish,
	        otherCells: otherCells
	      });
	    };
	    var fireTableSelectionClear = function (editor) {
	      editor.fire('TableSelectionClear');
	    };
	    var fireTableModified = function (editor, table, data) {
	      editor.fire('TableModified', __assign(__assign({}, data), { table: table }));
	    };
	    var styleModified = {
	      structure: false,
	      style: true
	    };
	    var structureModified = {
	      structure: true,
	      style: false
	    };
	    var styleAndStructureModified = {
	      structure: true,
	      style: true
	    };
	
	    var defaultTableToolbar = 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol';
	    var defaultStyles = {
	      'border-collapse': 'collapse',
	      'width': '100%'
	    };
	    var defaultCellBorderWidths = range$1(5, function (i) {
	      var size = i + 1 + 'px';
	      return {
	        title: size,
	        value: size
	      };
	    });
	    var defaultCellBorderStyles = map$1([
	      'Solid',
	      'Dotted',
	      'Dashed',
	      'Double',
	      'Groove',
	      'Ridge',
	      'Inset',
	      'Outset',
	      'None',
	      'Hidden'
	    ], function (type) {
	      return {
	        title: type,
	        value: type.toLowerCase()
	      };
	    });
	    var determineDefaultStyles = function (editor) {
	      var _a;
	      if (isPixelsForced(editor)) {
	        var dom = editor.dom;
	        var parentBlock = (_a = dom.getParent(editor.selection.getStart(), dom.isBlock)) !== null && _a !== void 0 ? _a : editor.getBody();
	        var contentWidth = getInner(SugarElement.fromDom(parentBlock));
	        return __assign(__assign({}, defaultStyles), { width: contentWidth + 'px' });
	      } else if (isResponsiveForced(editor)) {
	        return filter$1(defaultStyles, function (_value, key) {
	          return key !== 'width';
	        });
	      } else {
	        return defaultStyles;
	      }
	    };
	    var defaultAttributes = { border: '1' };
	    var defaultColumnResizingBehaviour = 'preservetable';
	    var getTableSizingMode = function (editor) {
	      return editor.getParam('table_sizing_mode', 'auto');
	    };
	    var getTableResponseWidth = function (editor) {
	      return editor.getParam('table_responsive_width');
	    };
	    var getTableBorderWidths = function (editor) {
	      return editor.getParam('table_border_widths', defaultCellBorderWidths, 'array');
	    };
	    var getTableBorderStyles = function (editor) {
	      return editor.getParam('table_border_styles', defaultCellBorderStyles, 'array');
	    };
	    var getDefaultAttributes = function (editor) {
	      return editor.getParam('table_default_attributes', defaultAttributes, 'object');
	    };
	    var getDefaultStyles = function (editor) {
	      return editor.getParam('table_default_styles', determineDefaultStyles(editor), 'object');
	    };
	    var hasTableResizeBars = function (editor) {
	      return editor.getParam('table_resize_bars', true, 'boolean');
	    };
	    var hasTabNavigation = function (editor) {
	      return editor.getParam('table_tab_navigation', true, 'boolean');
	    };
	    var hasAdvancedCellTab = function (editor) {
	      return editor.getParam('table_cell_advtab', true, 'boolean');
	    };
	    var hasAdvancedRowTab = function (editor) {
	      return editor.getParam('table_row_advtab', true, 'boolean');
	    };
	    var hasAdvancedTableTab = function (editor) {
	      return editor.getParam('table_advtab', true, 'boolean');
	    };
	    var hasAppearanceOptions = function (editor) {
	      return editor.getParam('table_appearance_options', true, 'boolean');
	    };
	    var hasTableGrid = function (editor) {
	      return editor.getParam('table_grid', true, 'boolean');
	    };
	    var shouldStyleWithCss = function (editor) {
	      return editor.getParam('table_style_by_css', false, 'boolean');
	    };
	    var getCellClassList = function (editor) {
	      return editor.getParam('table_cell_class_list', [], 'array');
	    };
	    var getRowClassList = function (editor) {
	      return editor.getParam('table_row_class_list', [], 'array');
	    };
	    var getTableClassList = function (editor) {
	      return editor.getParam('table_class_list', [], 'array');
	    };
	    var isPercentagesForced = function (editor) {
	      return getTableSizingMode(editor) === 'relative' || getTableResponseWidth(editor) === true;
	    };
	    var isPixelsForced = function (editor) {
	      return getTableSizingMode(editor) === 'fixed' || getTableResponseWidth(editor) === false;
	    };
	    var isResponsiveForced = function (editor) {
	      return getTableSizingMode(editor) === 'responsive';
	    };
	    var getToolbar = function (editor) {
	      return editor.getParam('table_toolbar', defaultTableToolbar);
	    };
	    var useColumnGroup = function (editor) {
	      return editor.getParam('table_use_colgroups', false, 'boolean');
	    };
	    var getTableHeaderType = function (editor) {
	      var defaultValue = 'section';
	      var value = editor.getParam('table_header_type', defaultValue, 'string');
	      var validValues = [
	        'section',
	        'cells',
	        'sectionCells',
	        'auto'
	      ];
	      if (!contains$2(validValues, value)) {
	        return defaultValue;
	      } else {
	        return value;
	      }
	    };
	    var getColumnResizingBehaviour = function (editor) {
	      var validModes = [
	        'preservetable',
	        'resizetable'
	      ];
	      var givenMode = editor.getParam('table_column_resizing', defaultColumnResizingBehaviour, 'string');
	      return find$1(validModes, function (mode) {
	        return mode === givenMode;
	      }).getOr(defaultColumnResizingBehaviour);
	    };
	    var isPreserveTableColumnResizing = function (editor) {
	      return getColumnResizingBehaviour(editor) === 'preservetable';
	    };
	    var isResizeTableColumnResizing = function (editor) {
	      return getColumnResizingBehaviour(editor) === 'resizetable';
	    };
	    var getCloneElements = function (editor) {
	      var cloneElements = editor.getParam('table_clone_elements');
	      if (isString(cloneElements)) {
	        return Optional.some(cloneElements.split(/[ ,]/));
	      } else if (Array.isArray(cloneElements)) {
	        return Optional.some(cloneElements);
	      } else {
	        return Optional.none();
	      }
	    };
	    var hasObjectResizing = function (editor) {
	      var objectResizing = editor.getParam('object_resizing', true);
	      return isString(objectResizing) ? objectResizing === 'table' : objectResizing;
	    };
	    var getTableBackgroundColorMap = function (editor) {
	      return editor.getParam('table_background_color_map', [], 'array');
	    };
	    var getTableBorderColorMap = function (editor) {
	      return editor.getParam('table_border_color_map', [], 'array');
	    };
	
	    var get$4 = function (editor, table) {
	      if (isPercentagesForced(editor)) {
	        return TableSize.percentageSize(table);
	      } else if (isPixelsForced(editor)) {
	        return TableSize.pixelSize(table);
	      } else {
	        return TableSize.getTableSize(table);
	      }
	    };
	
	    var cleanupLegacyAttributes = function (element) {
	      remove$7(element, 'width');
	    };
	    var convertToPercentSize = function (table) {
	      var newWidth = getPercentTableWidth(table);
	      redistribute(table, Optional.some(newWidth), Optional.none());
	      cleanupLegacyAttributes(table);
	    };
	    var convertToPixelSize = function (table) {
	      var newWidth = getPixelTableWidth(table);
	      redistribute(table, Optional.some(newWidth), Optional.none());
	      cleanupLegacyAttributes(table);
	    };
	    var convertToNoneSize = function (table) {
	      remove$6(table, 'width');
	      var columns = columns$1(table);
	      var rowElements = columns.length > 0 ? columns : cells$1(table);
	      each$2(rowElements, function (cell) {
	        remove$6(cell, 'width');
	        cleanupLegacyAttributes(cell);
	      });
	      cleanupLegacyAttributes(table);
	    };
	
	    var enforcePercentage = convertToPercentSize;
	    var enforcePixels = convertToPixelSize;
	    var enforceNone = convertToNoneSize;
	    var syncPixels = function (table) {
	      var warehouse = Warehouse.fromTable(table);
	      if (!Warehouse.hasColumns(warehouse)) {
	        each$2(cells$1(table), function (cell) {
	          var computedWidth = get$a(cell, 'width');
	          set$1(cell, 'width', computedWidth);
	          remove$7(cell, 'width');
	        });
	      }
	    };
	
	    var createContainer = function () {
	      var container = SugarElement.fromTag('div');
	      setAll(container, {
	        position: 'static',
	        height: '0',
	        width: '0',
	        padding: '0',
	        margin: '0',
	        border: '0'
	      });
	      append$1(body$1(), container);
	      return container;
	    };
	    var get$3 = function (editor, isResizable) {
	      return editor.inline ? ResizeWire.body(getBody(editor), createContainer(), isResizable) : ResizeWire.only(SugarElement.fromDom(editor.getDoc()), isResizable);
	    };
	    var remove$1 = function (editor, wire) {
	      if (editor.inline) {
	        remove$5(wire.parent());
	      }
	    };
	
	    var barResizerPrefix = 'bar-';
	    var isResizable = function (elm) {
	      return get$b(elm, 'data-mce-resize') !== 'false';
	    };
	    var getResizeHandler = function (editor) {
	      var selectionRng = Optional.none();
	      var resize = Optional.none();
	      var wire = Optional.none();
	      var startW;
	      var startRawW;
	      var isTable = function (elm) {
	        return elm.nodeName === 'TABLE';
	      };
	      var lazyResize = function () {
	        return resize;
	      };
	      var lazyWire = function () {
	        return wire.getOr(ResizeWire.only(SugarElement.fromDom(editor.getBody()), isResizable));
	      };
	      var lazySizing = function (table) {
	        return get$4(editor, table);
	      };
	      var lazyResizingBehaviour = function () {
	        return isPreserveTableColumnResizing(editor) ? preserveTable() : resizeTable();
	      };
	      var getNumColumns = function (table) {
	        return getGridSize(table).columns;
	      };
	      var afterCornerResize = function (table, origin, width) {
	        var isRightEdgeResize = endsWith(origin, 'e');
	        if (startRawW === '') {
	          enforcePercentage(table);
	        }
	        if (width !== startW && startRawW !== '') {
	          set$1(table, 'width', startRawW);
	          var resizing = lazyResizingBehaviour();
	          var tableSize = lazySizing(table);
	          var col = isPreserveTableColumnResizing(editor) || isRightEdgeResize ? getNumColumns(table) - 1 : 0;
	          adjustWidth(table, width - startW, col, resizing, tableSize);
	        } else if (isPercentage$1(startRawW)) {
	          var percentW = parseFloat(startRawW.replace('%', ''));
	          var targetPercentW = width * percentW / startW;
	          set$1(table, 'width', targetPercentW + '%');
	        }
	        if (isPixel(startRawW)) {
	          syncPixels(table);
	        }
	      };
	      var destroy = function () {
	        resize.each(function (sz) {
	          sz.destroy();
	        });
	        wire.each(function (w) {
	          remove$1(editor, w);
	        });
	      };
	      editor.on('init', function () {
	        var rawWire = get$3(editor, isResizable);
	        wire = Optional.some(rawWire);
	        if (hasObjectResizing(editor) && hasTableResizeBars(editor)) {
	          var resizing = lazyResizingBehaviour();
	          var sz = TableResize.create(rawWire, resizing, lazySizing);
	          sz.on();
	          sz.events.startDrag.bind(function (_event) {
	            selectionRng = Optional.some(editor.selection.getRng());
	          });
	          sz.events.beforeResize.bind(function (event) {
	            var rawTable = event.table.dom;
	            fireObjectResizeStart(editor, rawTable, getPixelWidth(rawTable), getPixelHeight(rawTable), barResizerPrefix + event.type);
	          });
	          sz.events.afterResize.bind(function (event) {
	            var table = event.table;
	            var rawTable = table.dom;
	            removeDataStyle(table);
	            selectionRng.each(function (rng) {
	              editor.selection.setRng(rng);
	              editor.focus();
	            });
	            fireObjectResized(editor, rawTable, getPixelWidth(rawTable), getPixelHeight(rawTable), barResizerPrefix + event.type);
	            editor.undoManager.add();
	          });
	          resize = Optional.some(sz);
	        }
	      });
	      editor.on('ObjectResizeStart', function (e) {
	        var targetElm = e.target;
	        if (isTable(targetElm)) {
	          var table = SugarElement.fromDom(targetElm);
	          each$2(editor.dom.select('.mce-clonedresizable'), function (clone) {
	            editor.dom.addClass(clone, 'mce-' + getColumnResizingBehaviour(editor) + '-columns');
	          });
	          if (!isPixelSizing(table) && isPixelsForced(editor)) {
	            enforcePixels(table);
	          } else if (!isPercentSizing(table) && isPercentagesForced(editor)) {
	            enforcePercentage(table);
	          }
	          if (isNoneSizing(table) && startsWith(e.origin, barResizerPrefix)) {
	            enforcePercentage(table);
	          }
	          startW = e.width;
	          startRawW = isResponsiveForced(editor) ? '' : getRawWidth(editor, targetElm).getOr('');
	        }
	      });
	      editor.on('ObjectResized', function (e) {
	        var targetElm = e.target;
	        if (isTable(targetElm)) {
	          var table = SugarElement.fromDom(targetElm);
	          var origin_1 = e.origin;
	          if (startsWith(origin_1, 'corner-')) {
	            afterCornerResize(table, origin_1, e.width);
	          }
	          removeDataStyle(table);
	          fireTableModified(editor, table.dom, styleModified);
	        }
	      });
	      editor.on('SwitchMode', function () {
	        lazyResize().each(function (resize) {
	          if (editor.mode.isReadOnly()) {
	            resize.hideBars();
	          } else {
	            resize.showBars();
	          }
	        });
	      });
	      return {
	        lazyResize: lazyResize,
	        lazyWire: lazyWire,
	        destroy: destroy
	      };
	    };
	
	    var point = function (element, offset) {
	      return {
	        element: element,
	        offset: offset
	      };
	    };
	
	    var scan$1 = function (universe, element, direction) {
	      if (universe.property().isText(element) && universe.property().getText(element).trim().length === 0 || universe.property().isComment(element)) {
	        return direction(element).bind(function (elem) {
	          return scan$1(universe, elem, direction).orThunk(function () {
	            return Optional.some(elem);
	          });
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	    var toEnd = function (universe, element) {
	      if (universe.property().isText(element)) {
	        return universe.property().getText(element).length;
	      }
	      var children = universe.property().children(element);
	      return children.length;
	    };
	    var freefallRtl$2 = function (universe, element) {
	      var candidate = scan$1(universe, element, universe.query().prevSibling).getOr(element);
	      if (universe.property().isText(candidate)) {
	        return point(candidate, toEnd(universe, candidate));
	      }
	      var children = universe.property().children(candidate);
	      return children.length > 0 ? freefallRtl$2(universe, children[children.length - 1]) : point(candidate, toEnd(universe, candidate));
	    };
	
	    var freefallRtl$1 = freefallRtl$2;
	
	    var universe$2 = DomUniverse();
	    var freefallRtl = function (element) {
	      return freefallRtl$1(universe$2, element);
	    };
	
	    var halve = function (main, other) {
	      var colspan = getSpan(main, 'colspan');
	      if (colspan === 1) {
	        var width = getGenericWidth(main);
	        width.each(function (w) {
	          var newWidth = w.value / 2;
	          setGenericWidth(main, newWidth, w.unit);
	          setGenericWidth(other, newWidth, w.unit);
	        });
	      }
	    };
	
	    var isHeaderCell = isTag('th');
	    var isHeaderCells = function (cells) {
	      return forall(cells, function (cell) {
	        return isHeaderCell(cell.element);
	      });
	    };
	    var getRowHeaderType = function (isHeaderRow, isHeaderCells) {
	      if (isHeaderRow && isHeaderCells) {
	        return 'sectionCells';
	      } else if (isHeaderRow) {
	        return 'section';
	      } else {
	        return 'cells';
	      }
	    };
	    var getRowType$1 = function (row) {
	      var isHeaderRow = row.section === 'thead';
	      var isHeaderCells = is(findCommonCellType(row.cells), 'th');
	      if (isHeaderRow || isHeaderCells) {
	        return {
	          type: 'header',
	          subType: getRowHeaderType(isHeaderRow, isHeaderCells)
	        };
	      } else if (row.section === 'tfoot') {
	        return { type: 'footer' };
	      } else {
	        return { type: 'body' };
	      }
	    };
	    var findCommonCellType = function (cells) {
	      var headerCells = filter$2(cells, function (cell) {
	        return isHeaderCell(cell.element);
	      });
	      if (headerCells.length === 0) {
	        return Optional.some('td');
	      } else if (headerCells.length === cells.length) {
	        return Optional.some('th');
	      } else {
	        return Optional.none();
	      }
	    };
	    var findCommonRowType = function (rows) {
	      var rowTypes = map$1(rows, function (row) {
	        return getRowType$1(row).type;
	      });
	      var hasHeader = contains$2(rowTypes, 'header');
	      var hasFooter = contains$2(rowTypes, 'footer');
	      if (!hasHeader && !hasFooter) {
	        return Optional.some('body');
	      } else {
	        var hasBody = contains$2(rowTypes, 'body');
	        if (hasHeader && !hasBody && !hasFooter) {
	          return Optional.some('header');
	        } else if (!hasHeader && !hasBody && hasFooter) {
	          return Optional.some('footer');
	        } else {
	          return Optional.none();
	        }
	      }
	    };
	    var findTableRowHeaderType = function (warehouse) {
	      return findMap(warehouse.all, function (row) {
	        var rowType = getRowType$1(row);
	        return rowType.type === 'header' ? Optional.from(rowType.subType) : Optional.none();
	      });
	    };
	
	    var transformCell = function (cell, comparator, substitution) {
	      return elementnew(substitution(cell.element, comparator), true, cell.isLocked);
	    };
	    var transformRow = function (row, section) {
	      return row.section !== section ? rowcells(row.element, row.cells, section, row.isNew) : row;
	    };
	    var section = function () {
	      return {
	        transformRow: transformRow,
	        transformCell: function (cell, comparator, substitution) {
	          var newCell = substitution(cell.element, comparator);
	          var fixedCell = name(newCell) !== 'td' ? mutate$1(newCell, 'td') : newCell;
	          return elementnew(fixedCell, cell.isNew, cell.isLocked);
	        }
	      };
	    };
	    var sectionCells = function () {
	      return {
	        transformRow: transformRow,
	        transformCell: transformCell
	      };
	    };
	    var cells = function () {
	      return {
	        transformRow: function (row, section) {
	          var newSection = section === 'thead' ? 'tbody' : section;
	          return transformRow(row, newSection);
	        },
	        transformCell: transformCell
	      };
	    };
	    var fallback = function () {
	      return {
	        transformRow: identity,
	        transformCell: transformCell
	      };
	    };
	    var getTableSectionType = function (table, fallback) {
	      var warehouse = Warehouse.fromTable(table);
	      var type = findTableRowHeaderType(warehouse).getOr(fallback);
	      switch (type) {
	      case 'section':
	        return section();
	      case 'sectionCells':
	        return sectionCells();
	      case 'cells':
	        return cells();
	      }
	    };
	    var TableSection = {
	      getTableSectionType: getTableSectionType,
	      section: section,
	      sectionCells: sectionCells,
	      cells: cells,
	      fallback: fallback
	    };
	
	    var setIfNot = function (element, property, value, ignore) {
	      if (value === ignore) {
	        remove$7(element, property);
	      } else {
	        set$2(element, property, value);
	      }
	    };
	    var insert$1 = function (table, selector, element) {
	      last$2(children$1(table, selector)).fold(function () {
	        return prepend(table, element);
	      }, function (child) {
	        return after$5(child, element);
	      });
	    };
	    var generateSection = function (table, sectionName) {
	      var section = child$1(table, sectionName).getOrThunk(function () {
	        var newSection = SugarElement.fromTag(sectionName, owner(table).dom);
	        if (sectionName === 'thead') {
	          insert$1(table, 'caption,colgroup', newSection);
	        } else if (sectionName === 'colgroup') {
	          insert$1(table, 'caption', newSection);
	        } else {
	          append$1(table, newSection);
	        }
	        return newSection;
	      });
	      empty(section);
	      return section;
	    };
	    var render$1 = function (table, grid) {
	      var newRows = [];
	      var newCells = [];
	      var syncRows = function (gridSection) {
	        return map$1(gridSection, function (row) {
	          if (row.isNew) {
	            newRows.push(row.element);
	          }
	          var tr = row.element;
	          empty(tr);
	          each$2(row.cells, function (cell) {
	            if (cell.isNew) {
	              newCells.push(cell.element);
	            }
	            setIfNot(cell.element, 'colspan', cell.colspan, 1);
	            setIfNot(cell.element, 'rowspan', cell.rowspan, 1);
	            append$1(tr, cell.element);
	          });
	          return tr;
	        });
	      };
	      var syncColGroup = function (gridSection) {
	        return bind$2(gridSection, function (colGroup) {
	          return map$1(colGroup.cells, function (col) {
	            setIfNot(col.element, 'span', col.colspan, 1);
	            return col.element;
	          });
	        });
	      };
	      var renderSection = function (gridSection, sectionName) {
	        var section = generateSection(table, sectionName);
	        var sync = sectionName === 'colgroup' ? syncColGroup : syncRows;
	        var sectionElems = sync(gridSection);
	        append(section, sectionElems);
	      };
	      var removeSection = function (sectionName) {
	        child$1(table, sectionName).each(remove$5);
	      };
	      var renderOrRemoveSection = function (gridSection, sectionName) {
	        if (gridSection.length > 0) {
	          renderSection(gridSection, sectionName);
	        } else {
	          removeSection(sectionName);
	        }
	      };
	      var headSection = [];
	      var bodySection = [];
	      var footSection = [];
	      var columnGroupsSection = [];
	      each$2(grid, function (row) {
	        switch (row.section) {
	        case 'thead':
	          headSection.push(row);
	          break;
	        case 'tbody':
	          bodySection.push(row);
	          break;
	        case 'tfoot':
	          footSection.push(row);
	          break;
	        case 'colgroup':
	          columnGroupsSection.push(row);
	          break;
	        }
	      });
	      renderOrRemoveSection(columnGroupsSection, 'colgroup');
	      renderOrRemoveSection(headSection, 'thead');
	      renderOrRemoveSection(bodySection, 'tbody');
	      renderOrRemoveSection(footSection, 'tfoot');
	      return {
	        newRows: newRows,
	        newCells: newCells
	      };
	    };
	    var copy = function (grid) {
	      return map$1(grid, function (row) {
	        var tr = shallow(row.element);
	        each$2(row.cells, function (cell) {
	          var clonedCell = deep(cell.element);
	          setIfNot(clonedCell, 'colspan', cell.colspan, 1);
	          setIfNot(clonedCell, 'rowspan', cell.rowspan, 1);
	          append$1(tr, clonedCell);
	        });
	        return tr;
	      });
	    };
	
	    var getColumn = function (grid, index) {
	      return map$1(grid, function (row) {
	        return getCell(row, index);
	      });
	    };
	    var getRow = function (grid, index) {
	      return grid[index];
	    };
	    var findDiff = function (xs, comp) {
	      if (xs.length === 0) {
	        return 0;
	      }
	      var first = xs[0];
	      var index = findIndex(xs, function (x) {
	        return !comp(first.element, x.element);
	      });
	      return index.getOr(xs.length);
	    };
	    var subgrid = function (grid, row, column, comparator) {
	      var gridRow = getRow(grid, row);
	      var isColRow = gridRow.section === 'colgroup';
	      var colspan = findDiff(gridRow.cells.slice(column), comparator);
	      var rowspan = isColRow ? 1 : findDiff(getColumn(grid.slice(row), column), comparator);
	      return {
	        colspan: colspan,
	        rowspan: rowspan
	      };
	    };
	
	    var toDetails = function (grid, comparator) {
	      var seen = map$1(grid, function (row) {
	        return map$1(row.cells, never);
	      });
	      var updateSeen = function (rowIndex, columnIndex, rowspan, colspan) {
	        for (var row = rowIndex; row < rowIndex + rowspan; row++) {
	          for (var column = columnIndex; column < columnIndex + colspan; column++) {
	            seen[row][column] = true;
	          }
	        }
	      };
	      return map$1(grid, function (row, rowIndex) {
	        var details = bind$2(row.cells, function (cell, columnIndex) {
	          if (seen[rowIndex][columnIndex] === false) {
	            var result = subgrid(grid, rowIndex, columnIndex, comparator);
	            updateSeen(rowIndex, columnIndex, result.rowspan, result.colspan);
	            return [detailnew(cell.element, result.rowspan, result.colspan, cell.isNew)];
	          } else {
	            return [];
	          }
	        });
	        return rowdetailnew(row.element, details, row.section, row.isNew);
	      });
	    };
	    var toGrid = function (warehouse, generators, isNew) {
	      var grid = [];
	      each$2(warehouse.colgroups, function (colgroup) {
	        var colgroupCols = [];
	        for (var columnIndex = 0; columnIndex < warehouse.grid.columns; columnIndex++) {
	          var element = Warehouse.getColumnAt(warehouse, columnIndex).map(function (column) {
	            return elementnew(column.element, isNew, false);
	          }).getOrThunk(function () {
	            return elementnew(generators.colGap(), true, false);
	          });
	          colgroupCols.push(element);
	        }
	        grid.push(rowcells(colgroup.element, colgroupCols, 'colgroup', isNew));
	      });
	      for (var rowIndex = 0; rowIndex < warehouse.grid.rows; rowIndex++) {
	        var rowCells = [];
	        for (var columnIndex = 0; columnIndex < warehouse.grid.columns; columnIndex++) {
	          var element = Warehouse.getAt(warehouse, rowIndex, columnIndex).map(function (item) {
	            return elementnew(item.element, isNew, item.isLocked);
	          }).getOrThunk(function () {
	            return elementnew(generators.gap(), true, false);
	          });
	          rowCells.push(element);
	        }
	        var rowDetail = warehouse.all[rowIndex];
	        var row = rowcells(rowDetail.element, rowCells, rowDetail.section, isNew);
	        grid.push(row);
	      }
	      return grid;
	    };
	
	    var fromWarehouse = function (warehouse, generators) {
	      return toGrid(warehouse, generators, false);
	    };
	    var toDetailList = function (grid) {
	      return toDetails(grid, eq$1);
	    };
	    var findInWarehouse = function (warehouse, element) {
	      return findMap(warehouse.all, function (r) {
	        return find$1(r.cells, function (e) {
	          return eq$1(element, e.element);
	        });
	      });
	    };
	    var extractCells = function (warehouse, target, predicate) {
	      var details = map$1(target.selection, function (cell$1) {
	        return cell(cell$1).bind(function (lc) {
	          return findInWarehouse(warehouse, lc);
	        }).filter(predicate);
	      });
	      var cells = cat(details);
	      return someIf(cells.length > 0, cells);
	    };
	    var run = function (operation, extract, adjustment, postAction, genWrappers) {
	      return function (wire, table, target, generators, behaviours) {
	        var warehouse = Warehouse.fromTable(table);
	        var tableSection = Optional.from(behaviours === null || behaviours === void 0 ? void 0 : behaviours.section).getOrThunk(TableSection.fallback);
	        var output = extract(warehouse, target).map(function (info) {
	          var model = fromWarehouse(warehouse, generators);
	          var result = operation(model, info, eq$1, genWrappers(generators), tableSection);
	          var lockedColumns = getLockedColumnsFromGrid(result.grid);
	          var grid = toDetailList(result.grid);
	          return {
	            info: info,
	            grid: grid,
	            cursor: result.cursor,
	            lockedColumns: lockedColumns
	          };
	        });
	        return output.bind(function (out) {
	          var newElements = render$1(table, out.grid);
	          var tableSizing = Optional.from(behaviours === null || behaviours === void 0 ? void 0 : behaviours.sizing).getOrThunk(function () {
	            return TableSize.getTableSize(table);
	          });
	          var resizing = Optional.from(behaviours === null || behaviours === void 0 ? void 0 : behaviours.resize).getOrThunk(preserveTable);
	          adjustment(table, out.grid, out.info, {
	            sizing: tableSizing,
	            resize: resizing,
	            section: tableSection
	          });
	          postAction(table);
	          refresh(wire, table);
	          remove$7(table, LOCKED_COL_ATTR);
	          if (out.lockedColumns.length > 0) {
	            set$2(table, LOCKED_COL_ATTR, out.lockedColumns.join(','));
	          }
	          return Optional.some({
	            cursor: out.cursor,
	            newRows: newElements.newRows,
	            newCells: newElements.newCells
	          });
	        });
	      };
	    };
	    var onPaste = function (warehouse, target) {
	      return cell(target.element).bind(function (cell) {
	        return findInWarehouse(warehouse, cell).map(function (details) {
	          var value = __assign(__assign({}, details), {
	            generators: target.generators,
	            clipboard: target.clipboard
	          });
	          return value;
	        });
	      });
	    };
	    var onPasteByEditor = function (warehouse, target) {
	      return extractCells(warehouse, target, always).map(function (cells) {
	        return {
	          cells: cells,
	          generators: target.generators,
	          clipboard: target.clipboard
	        };
	      });
	    };
	    var onMergable = function (_warehouse, target) {
	      return target.mergable;
	    };
	    var onUnmergable = function (_warehouse, target) {
	      return target.unmergable;
	    };
	    var onCells = function (warehouse, target) {
	      return extractCells(warehouse, target, always);
	    };
	    var onUnlockedCells = function (warehouse, target) {
	      return extractCells(warehouse, target, function (detail) {
	        return !detail.isLocked;
	      });
	    };
	    var isUnlockedTableCell = function (warehouse, cell) {
	      return findInWarehouse(warehouse, cell).exists(function (detail) {
	        return !detail.isLocked;
	      });
	    };
	    var allUnlocked = function (warehouse, cells) {
	      return forall(cells, function (cell) {
	        return isUnlockedTableCell(warehouse, cell);
	      });
	    };
	    var onUnlockedMergable = function (warehouse, target) {
	      return onMergable(warehouse, target).filter(function (mergeable) {
	        return allUnlocked(warehouse, mergeable.cells);
	      });
	    };
	    var onUnlockedUnmergable = function (warehouse, target) {
	      return onUnmergable(warehouse, target).filter(function (cells) {
	        return allUnlocked(warehouse, cells);
	      });
	    };
	
	    var merge$2 = function (grid, bounds, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      if (rows.length === 0) {
	        return grid;
	      }
	      for (var i = bounds.startRow; i <= bounds.finishRow; i++) {
	        for (var j = bounds.startCol; j <= bounds.finishCol; j++) {
	          var row = rows[i];
	          var isLocked = getCell(row, j).isLocked;
	          mutateCell(row, j, elementnew(substitution(), false, isLocked));
	        }
	      }
	      return grid;
	    };
	    var unmerge = function (grid, target, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      var first = true;
	      for (var i = 0; i < rows.length; i++) {
	        for (var j = 0; j < cellLength(rows[0]); j++) {
	          var row = rows[i];
	          var currentCell = getCell(row, j);
	          var currentCellElm = currentCell.element;
	          var isToReplace = comparator(currentCellElm, target);
	          if (isToReplace === true && first === false) {
	            mutateCell(row, j, elementnew(substitution(), true, currentCell.isLocked));
	          } else if (isToReplace === true) {
	            first = false;
	          }
	        }
	      }
	      return grid;
	    };
	    var uniqueCells = function (row, comparator) {
	      return foldl(row, function (rest, cell) {
	        return exists(rest, function (currentCell) {
	          return comparator(currentCell.element, cell.element);
	        }) ? rest : rest.concat([cell]);
	      }, []);
	    };
	    var splitCols = function (grid, index, comparator, substitution) {
	      if (index > 0 && index < grid[0].cells.length) {
	        each$2(grid, function (row) {
	          var prevCell = row.cells[index - 1];
	          var current = row.cells[index];
	          var isToReplace = comparator(current.element, prevCell.element);
	          if (isToReplace) {
	            mutateCell(row, index, elementnew(substitution(), true, current.isLocked));
	          }
	        });
	      }
	      return grid;
	    };
	    var splitRows = function (grid, index, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      if (index > 0 && index < rows.length) {
	        var rowPrevCells = rows[index - 1].cells;
	        var cells = uniqueCells(rowPrevCells, comparator);
	        each$2(cells, function (cell) {
	          var replacement = Optional.none();
	          for (var i = index; i < rows.length; i++) {
	            var _loop_1 = function (j) {
	              var row = rows[i];
	              var current = getCell(row, j);
	              var isToReplace = comparator(current.element, cell.element);
	              if (isToReplace) {
	                if (replacement.isNone()) {
	                  replacement = Optional.some(substitution());
	                }
	                replacement.each(function (sub) {
	                  mutateCell(row, j, elementnew(sub, true, current.isLocked));
	                });
	              }
	            };
	            for (var j = 0; j < cellLength(rows[0]); j++) {
	              _loop_1(j);
	            }
	          }
	        });
	      }
	      return grid;
	    };
	
	    var value$1 = function (o) {
	      var or = function (_opt) {
	        return value$1(o);
	      };
	      var orThunk = function (_f) {
	        return value$1(o);
	      };
	      var map = function (f) {
	        return value$1(f(o));
	      };
	      var mapError = function (_f) {
	        return value$1(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOptional = function () {
	        return Optional.some(o);
	      };
	      return {
	        isValue: always,
	        isError: never,
	        getOr: constant(o),
	        getOrThunk: constant(o),
	        getOrDie: constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOptional: toOptional
	      };
	    };
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = identity;
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (_f) {
	        return error(message);
	      };
	      var mapError = function (f) {
	        return error(f(message));
	      };
	      var bind = function (_f) {
	        return error(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        isValue: never,
	        isError: always,
	        getOr: identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOptional: Optional.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error(err);
	      }, value$1);
	    };
	    var Result = {
	      value: value$1,
	      error: error,
	      fromOption: fromOption
	    };
	
	    var measure = function (startAddress, gridA, gridB) {
	      if (startAddress.row >= gridA.length || startAddress.column > cellLength(gridA[0])) {
	        return Result.error('invalid start address out of table bounds, row: ' + startAddress.row + ', column: ' + startAddress.column);
	      }
	      var rowRemainder = gridA.slice(startAddress.row);
	      var colRemainder = rowRemainder[0].cells.slice(startAddress.column);
	      var colRequired = cellLength(gridB[0]);
	      var rowRequired = gridB.length;
	      return Result.value({
	        rowDelta: rowRemainder.length - rowRequired,
	        colDelta: colRemainder.length - colRequired
	      });
	    };
	    var measureWidth = function (gridA, gridB) {
	      var colLengthA = cellLength(gridA[0]);
	      var colLengthB = cellLength(gridB[0]);
	      return {
	        rowDelta: 0,
	        colDelta: colLengthA - colLengthB
	      };
	    };
	    var measureHeight = function (gridA, gridB) {
	      var rowLengthA = gridA.length;
	      var rowLengthB = gridB.length;
	      return {
	        rowDelta: rowLengthA - rowLengthB,
	        colDelta: 0
	      };
	    };
	    var generateElements = function (amount, row, generators, isLocked) {
	      var generator = row.section === 'colgroup' ? generators.col : generators.cell;
	      return range$1(amount, function (idx) {
	        return elementnew(generator(), true, isLocked(idx));
	      });
	    };
	    var rowFill = function (grid, amount, generators, lockedColumns) {
	      var exampleRow = grid[grid.length - 1];
	      return grid.concat(range$1(amount, function () {
	        var generator = exampleRow.section === 'colgroup' ? generators.colgroup : generators.row;
	        var row = clone$1(exampleRow, generator, identity);
	        var elements = generateElements(row.cells.length, row, generators, function (idx) {
	          return has$1(lockedColumns, idx.toString());
	        });
	        return setCells(row, elements);
	      }));
	    };
	    var colFill = function (grid, amount, generators, startIndex) {
	      return map$1(grid, function (row) {
	        var newChildren = generateElements(amount, row, generators, never);
	        return addCells(row, startIndex, newChildren);
	      });
	    };
	    var lockedColFill = function (grid, generators, lockedColumns) {
	      return map$1(grid, function (row) {
	        return foldl(lockedColumns, function (acc, colNum) {
	          var newChild = generateElements(1, row, generators, always)[0];
	          return addCell(acc, colNum, newChild);
	        }, row);
	      });
	    };
	    var tailor = function (gridA, delta, generators) {
	      var fillCols = delta.colDelta < 0 ? colFill : identity;
	      var fillRows = delta.rowDelta < 0 ? rowFill : identity;
	      var lockedColumns = getLockedColumnsFromGrid(gridA);
	      var gridWidth = cellLength(gridA[0]);
	      var isLastColLocked = exists(lockedColumns, function (locked) {
	        return locked === gridWidth - 1;
	      });
	      var modifiedCols = fillCols(gridA, Math.abs(delta.colDelta), generators, isLastColLocked ? gridWidth - 1 : gridWidth);
	      var newLockedColumns = getLockedColumnsFromGrid(modifiedCols);
	      return fillRows(modifiedCols, Math.abs(delta.rowDelta), generators, mapToObject(newLockedColumns, always));
	    };
	
	    var isSpanning = function (grid, row, col, comparator) {
	      var candidate = getCell(grid[row], col);
	      var matching = curry(comparator, candidate.element);
	      var currentRow = grid[row];
	      return grid.length > 1 && cellLength(currentRow) > 1 && (col > 0 && matching(getCellElement(currentRow, col - 1)) || col < currentRow.cells.length - 1 && matching(getCellElement(currentRow, col + 1)) || row > 0 && matching(getCellElement(grid[row - 1], col)) || row < grid.length - 1 && matching(getCellElement(grid[row + 1], col)));
	    };
	    var mergeTables = function (startAddress, gridA, gridB, generator, comparator, lockedColumns) {
	      var startRow = startAddress.row;
	      var startCol = startAddress.column;
	      var mergeHeight = gridB.length;
	      var mergeWidth = cellLength(gridB[0]);
	      var endRow = startRow + mergeHeight;
	      var endCol = startCol + mergeWidth + lockedColumns.length;
	      var lockedColumnObj = mapToObject(lockedColumns, always);
	      for (var r = startRow; r < endRow; r++) {
	        var skippedCol = 0;
	        for (var c = startCol; c < endCol; c++) {
	          if (lockedColumnObj[c]) {
	            skippedCol++;
	            continue;
	          }
	          if (isSpanning(gridA, r, c, comparator)) {
	            unmerge(gridA, getCellElement(gridA[r], c), comparator, generator.cell);
	          }
	          var gridBColIndex = c - startCol - skippedCol;
	          var newCell = getCell(gridB[r - startRow], gridBColIndex);
	          var newCellElm = newCell.element;
	          var replacement = generator.replace(newCellElm);
	          mutateCell(gridA[r], c, elementnew(replacement, true, newCell.isLocked));
	        }
	      }
	      return gridA;
	    };
	    var getValidStartAddress = function (currentStartAddress, grid, lockedColumns) {
	      var gridColLength = cellLength(grid[0]);
	      var adjustedRowAddress = extractGridDetails(grid).cols.length + currentStartAddress.row;
	      var possibleColAddresses = range$1(gridColLength - currentStartAddress.column, function (num) {
	        return num + currentStartAddress.column;
	      });
	      var validColAddress = find$1(possibleColAddresses, function (num) {
	        return forall(lockedColumns, function (col) {
	          return col !== num;
	        });
	      }).getOr(gridColLength - 1);
	      return {
	        row: adjustedRowAddress,
	        column: validColAddress
	      };
	    };
	    var getLockedColumnsWithinBounds = function (startAddress, grid, lockedColumns) {
	      return filter$2(lockedColumns, function (colNum) {
	        return colNum >= startAddress.column && colNum <= cellLength(grid[0]) + startAddress.column;
	      });
	    };
	    var merge$1 = function (startAddress, gridA, gridB, generator, comparator) {
	      var lockedColumns = getLockedColumnsFromGrid(gridA);
	      var validStartAddress = getValidStartAddress(startAddress, gridA, lockedColumns);
	      var gridBRows = extractGridDetails(gridB).rows;
	      var lockedColumnsWithinBounds = getLockedColumnsWithinBounds(validStartAddress, gridBRows, lockedColumns);
	      var result = measure(validStartAddress, gridA, gridBRows);
	      return result.map(function (diff) {
	        var delta = __assign(__assign({}, diff), { colDelta: diff.colDelta - lockedColumnsWithinBounds.length });
	        var fittedGrid = tailor(gridA, delta, generator);
	        var newLockedColumns = getLockedColumnsFromGrid(fittedGrid);
	        var newLockedColumnsWithinBounds = getLockedColumnsWithinBounds(validStartAddress, gridBRows, newLockedColumns);
	        return mergeTables(validStartAddress, fittedGrid, gridBRows, generator, comparator, newLockedColumnsWithinBounds);
	      });
	    };
	    var insertCols = function (index, gridA, gridB, generator, comparator) {
	      splitCols(gridA, index, comparator, generator.cell);
	      var delta = measureHeight(gridB, gridA);
	      var fittedNewGrid = tailor(gridB, delta, generator);
	      var secondDelta = measureHeight(gridA, fittedNewGrid);
	      var fittedOldGrid = tailor(gridA, secondDelta, generator);
	      return map$1(fittedOldGrid, function (gridRow, i) {
	        return addCells(gridRow, index, fittedNewGrid[i].cells);
	      });
	    };
	    var insertRows = function (index, gridA, gridB, generator, comparator) {
	      splitRows(gridA, index, comparator, generator.cell);
	      var locked = getLockedColumnsFromGrid(gridA);
	      var diff = measureWidth(gridA, gridB);
	      var delta = __assign(__assign({}, diff), { colDelta: diff.colDelta - locked.length });
	      var fittedOldGrid = tailor(gridA, delta, generator);
	      var _a = extractGridDetails(fittedOldGrid), oldCols = _a.cols, oldRows = _a.rows;
	      var newLocked = getLockedColumnsFromGrid(fittedOldGrid);
	      var secondDiff = measureWidth(gridB, gridA);
	      var secondDelta = __assign(__assign({}, secondDiff), { colDelta: secondDiff.colDelta + newLocked.length });
	      var fittedGridB = lockedColFill(gridB, generator, newLocked);
	      var fittedNewGrid = tailor(fittedGridB, secondDelta, generator);
	      return oldCols.concat(oldRows.slice(0, index)).concat(fittedNewGrid).concat(oldRows.slice(index, oldRows.length));
	    };
	
	    var cloneRow = function (row, cloneCell, comparator, substitution) {
	      return clone$1(row, function (elem) {
	        return substitution(elem, comparator);
	      }, cloneCell);
	    };
	    var insertRowAt = function (grid, index, example, comparator, substitution) {
	      var _a = extractGridDetails(grid), rows = _a.rows, cols = _a.cols;
	      var before = rows.slice(0, index);
	      var after = rows.slice(index);
	      var newRow = cloneRow(rows[example], function (ex, c) {
	        var withinSpan = index > 0 && index < rows.length && comparator(getCellElement(rows[index - 1], c), getCellElement(rows[index], c));
	        var ret = withinSpan ? getCell(rows[index], c) : elementnew(substitution(ex.element, comparator), true, ex.isLocked);
	        return ret;
	      }, comparator, substitution);
	      return cols.concat(before).concat([newRow]).concat(after);
	    };
	    var getElementFor = function (row, column, section, withinSpan, example, comparator, substitution) {
	      if (section === 'colgroup' || !withinSpan) {
	        var cell = getCell(row, example);
	        return elementnew(substitution(cell.element, comparator), true, false);
	      } else {
	        return getCell(row, column);
	      }
	    };
	    var insertColumnAt = function (grid, index, example, comparator, substitution) {
	      return map$1(grid, function (row) {
	        var withinSpan = index > 0 && index < cellLength(row) && comparator(getCellElement(row, index - 1), getCellElement(row, index));
	        var sub = getElementFor(row, index, row.section, withinSpan, example, comparator, substitution);
	        return addCell(row, index, sub);
	      });
	    };
	    var deleteColumnsAt = function (grid, columns) {
	      return bind$2(grid, function (row) {
	        var existingCells = row.cells;
	        var cells = foldr(columns, function (acc, column) {
	          return column >= 0 && column < acc.length ? acc.slice(0, column).concat(acc.slice(column + 1)) : acc;
	        }, existingCells);
	        return cells.length > 0 ? [rowcells(row.element, cells, row.section, row.isNew)] : [];
	      });
	    };
	    var deleteRowsAt = function (grid, start, finish) {
	      var _a = extractGridDetails(grid), rows = _a.rows, cols = _a.cols;
	      return cols.concat(rows.slice(0, start)).concat(rows.slice(finish + 1));
	    };
	
	    var notInStartRow = function (grid, rowIndex, colIndex, comparator) {
	      return getCellElement(grid[rowIndex], colIndex) !== undefined && (rowIndex > 0 && comparator(getCellElement(grid[rowIndex - 1], colIndex), getCellElement(grid[rowIndex], colIndex)));
	    };
	    var notInStartColumn = function (row, index, comparator) {
	      return index > 0 && comparator(getCellElement(row, index - 1), getCellElement(row, index));
	    };
	    var isDuplicatedCell = function (grid, rowIndex, colIndex, comparator) {
	      return notInStartRow(grid, rowIndex, colIndex, comparator) || notInStartColumn(grid[rowIndex], colIndex, comparator);
	    };
	    var rowReplacerPredicate = function (targetRow, columnHeaders) {
	      var entireTableIsHeader = forall(columnHeaders, identity) && isHeaderCells(targetRow.cells);
	      return entireTableIsHeader ? always : function (cell, _rowIndex, colIndex) {
	        var type = name(cell.element);
	        return !(type === 'th' && columnHeaders[colIndex]);
	      };
	    };
	    var columnReplacePredicate = function (targetColumn, rowHeaders) {
	      var entireTableIsHeader = forall(rowHeaders, identity) && isHeaderCells(targetColumn);
	      return entireTableIsHeader ? always : function (cell, rowIndex, _colIndex) {
	        var type = name(cell.element);
	        return !(type === 'th' && rowHeaders[rowIndex]);
	      };
	    };
	    var determineScope = function (applyScope, element, newScope, isInHeader) {
	      var hasSpan = function (scope) {
	        return scope === 'row' ? hasRowspan(element) : hasColspan(element);
	      };
	      var getScope = function (scope) {
	        return hasSpan(scope) ? scope + 'group' : scope;
	      };
	      if (applyScope) {
	        return isHeaderCell(element) ? getScope(newScope) : null;
	      } else if (isInHeader && isHeaderCell(element)) {
	        var oppositeScope = newScope === 'row' ? 'col' : 'row';
	        return getScope(oppositeScope);
	      } else {
	        return null;
	      }
	    };
	    var rowScopeGenerator = function (applyScope, columnHeaders) {
	      return function (cell, rowIndex, columnIndex) {
	        return Optional.some(determineScope(applyScope, cell.element, 'col', columnHeaders[columnIndex]));
	      };
	    };
	    var columnScopeGenerator = function (applyScope, rowHeaders) {
	      return function (cell, rowIndex) {
	        return Optional.some(determineScope(applyScope, cell.element, 'row', rowHeaders[rowIndex]));
	      };
	    };
	    var replace = function (cell, comparator, substitute) {
	      return elementnew(substitute(cell.element, comparator), true, cell.isLocked);
	    };
	    var replaceIn = function (grid, targets, comparator, substitute, replacer, genScope, shouldReplace) {
	      var isTarget = function (cell) {
	        return exists(targets, function (target) {
	          return comparator(cell.element, target.element);
	        });
	      };
	      return map$1(grid, function (row, rowIndex) {
	        return mapCells(row, function (cell, colIndex) {
	          if (isTarget(cell)) {
	            var newCell_1 = shouldReplace(cell, rowIndex, colIndex) ? replacer(cell, comparator, substitute) : cell;
	            genScope(newCell_1, rowIndex, colIndex).each(function (scope) {
	              setOptions(newCell_1.element, { scope: Optional.from(scope) });
	            });
	            return newCell_1;
	          } else {
	            return cell;
	          }
	        });
	      });
	    };
	    var getColumnCells = function (rows, columnIndex, comparator) {
	      return bind$2(rows, function (row, i) {
	        return isDuplicatedCell(rows, i, columnIndex, comparator) ? [] : [getCell(row, columnIndex)];
	      });
	    };
	    var getRowCells = function (rows, rowIndex, comparator) {
	      var targetRow = rows[rowIndex];
	      return bind$2(targetRow.cells, function (item, i) {
	        return isDuplicatedCell(rows, rowIndex, i, comparator) ? [] : [item];
	      });
	    };
	    var replaceColumns = function (grid, indexes, applyScope, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      var targets = bind$2(indexes, function (index) {
	        return getColumnCells(rows, index, comparator);
	      });
	      var rowHeaders = map$1(grid, function (row) {
	        return isHeaderCells(row.cells);
	      });
	      var shouldReplaceCell = columnReplacePredicate(targets, rowHeaders);
	      var scopeGenerator = columnScopeGenerator(applyScope, rowHeaders);
	      return replaceIn(grid, targets, comparator, substitution, replace, scopeGenerator, shouldReplaceCell);
	    };
	    var replaceRows = function (grid, indexes, section, applyScope, comparator, substitution, tableSection) {
	      var _a = extractGridDetails(grid), cols = _a.cols, rows = _a.rows;
	      var targetRow = rows[indexes[0]];
	      var targets = bind$2(indexes, function (index) {
	        return getRowCells(rows, index, comparator);
	      });
	      var columnHeaders = map$1(targetRow.cells, function (_cell, index) {
	        return isHeaderCells(getColumnCells(rows, index, comparator));
	      });
	      var newRows = __spreadArray([], rows, true);
	      each$2(indexes, function (index) {
	        newRows[index] = tableSection.transformRow(rows[index], section);
	      });
	      var newGrid = cols.concat(newRows);
	      var shouldReplaceCell = rowReplacerPredicate(targetRow, columnHeaders);
	      var scopeGenerator = rowScopeGenerator(applyScope, columnHeaders);
	      return replaceIn(newGrid, targets, comparator, substitution, tableSection.transformCell, scopeGenerator, shouldReplaceCell);
	    };
	    var replaceCells = function (grid, details, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      var targetCells = map$1(details, function (detail) {
	        return getCell(rows[detail.row], detail.column);
	      });
	      return replaceIn(grid, targetCells, comparator, substitution, replace, Optional.none, always);
	    };
	
	    var uniqueColumns = function (details) {
	      var uniqueCheck = function (rest, detail) {
	        var columnExists = exists(rest, function (currentDetail) {
	          return currentDetail.column === detail.column;
	        });
	        return columnExists ? rest : rest.concat([detail]);
	      };
	      return foldl(details, uniqueCheck, []).sort(function (detailA, detailB) {
	        return detailA.column - detailB.column;
	      });
	    };
	
	    var isCol = isTag('col');
	    var isColgroup = isTag('colgroup');
	    var isRow$1 = function (element) {
	      return name(element) === 'tr' || isColgroup(element);
	    };
	    var elementToData = function (element) {
	      var colspan = getAttrValue(element, 'colspan', 1);
	      var rowspan = getAttrValue(element, 'rowspan', 1);
	      return {
	        element: element,
	        colspan: colspan,
	        rowspan: rowspan
	      };
	    };
	    var modification = function (generators, toData) {
	      if (toData === void 0) {
	        toData = elementToData;
	      }
	      var nuCell = function (data) {
	        return isCol(data.element) ? generators.col(data) : generators.cell(data);
	      };
	      var nuRow = function (data) {
	        return isColgroup(data.element) ? generators.colgroup(data) : generators.row(data);
	      };
	      var add = function (element) {
	        if (isRow$1(element)) {
	          return nuRow({ element: element });
	        } else {
	          var replacement = nuCell(toData(element));
	          recent = Optional.some({
	            item: element,
	            replacement: replacement
	          });
	          return replacement;
	        }
	      };
	      var recent = Optional.none();
	      var getOrInit = function (element, comparator) {
	        return recent.fold(function () {
	          return add(element);
	        }, function (p) {
	          return comparator(element, p.item) ? p.replacement : add(element);
	        });
	      };
	      return { getOrInit: getOrInit };
	    };
	    var transform = function (tag) {
	      return function (generators) {
	        var list = [];
	        var find = function (element, comparator) {
	          return find$1(list, function (x) {
	            return comparator(x.item, element);
	          });
	        };
	        var makeNew = function (element) {
	          var attrs = tag === 'td' ? { scope: null } : {};
	          var cell = generators.replace(element, tag, attrs);
	          list.push({
	            item: element,
	            sub: cell
	          });
	          return cell;
	        };
	        var replaceOrInit = function (element, comparator) {
	          if (isRow$1(element) || isCol(element)) {
	            return element;
	          } else {
	            return find(element, comparator).fold(function () {
	              return makeNew(element);
	            }, function (p) {
	              return comparator(element, p.item) ? p.sub : makeNew(element);
	            });
	          }
	        };
	        return { replaceOrInit: replaceOrInit };
	      };
	    };
	    var getScopeAttribute = function (cell) {
	      return getOpt(cell, 'scope').map(function (attribute) {
	        return attribute.substr(0, 3);
	      });
	    };
	    var merging = function (generators) {
	      var unmerge = function (cell) {
	        var scope = getScopeAttribute(cell);
	        scope.each(function (attribute) {
	          return set$2(cell, 'scope', attribute);
	        });
	        return function () {
	          var raw = generators.cell({
	            element: cell,
	            colspan: 1,
	            rowspan: 1
	          });
	          remove$6(raw, 'width');
	          remove$6(cell, 'width');
	          scope.each(function (attribute) {
	            return set$2(raw, 'scope', attribute);
	          });
	          return raw;
	        };
	      };
	      var merge = function (cells) {
	        var getScopeProperty = function () {
	          var stringAttributes = cat(map$1(cells, getScopeAttribute));
	          if (stringAttributes.length === 0) {
	            return Optional.none();
	          } else {
	            var baseScope_1 = stringAttributes[0];
	            var scopes_1 = [
	              'row',
	              'col'
	            ];
	            var isMixed = exists(stringAttributes, function (attribute) {
	              return attribute !== baseScope_1 && contains$2(scopes_1, attribute);
	            });
	            return isMixed ? Optional.none() : Optional.from(baseScope_1);
	          }
	        };
	        remove$6(cells[0], 'width');
	        getScopeProperty().fold(function () {
	          return remove$7(cells[0], 'scope');
	        }, function (attribute) {
	          return set$2(cells[0], 'scope', attribute + 'group');
	        });
	        return constant(cells[0]);
	      };
	      return {
	        unmerge: unmerge,
	        merge: merge
	      };
	    };
	    var Generators = {
	      modification: modification,
	      transform: transform,
	      merging: merging
	    };
	
	    var blockList = [
	      'body',
	      'p',
	      'div',
	      'article',
	      'aside',
	      'figcaption',
	      'figure',
	      'footer',
	      'header',
	      'nav',
	      'section',
	      'ol',
	      'ul',
	      'table',
	      'thead',
	      'tfoot',
	      'tbody',
	      'caption',
	      'tr',
	      'td',
	      'th',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'blockquote',
	      'pre',
	      'address'
	    ];
	    var isList$1 = function (universe, item) {
	      var tagName = universe.property().name(item);
	      return contains$2([
	        'ol',
	        'ul'
	      ], tagName);
	    };
	    var isBlock$1 = function (universe, item) {
	      var tagName = universe.property().name(item);
	      return contains$2(blockList, tagName);
	    };
	    var isEmptyTag$1 = function (universe, item) {
	      return contains$2([
	        'br',
	        'img',
	        'hr',
	        'input'
	      ], universe.property().name(item));
	    };
	
	    var universe$1 = DomUniverse();
	    var isBlock = function (element) {
	      return isBlock$1(universe$1, element);
	    };
	    var isList = function (element) {
	      return isList$1(universe$1, element);
	    };
	    var isEmptyTag = function (element) {
	      return isEmptyTag$1(universe$1, element);
	    };
	
	    var merge = function (cells) {
	      var isBr = function (el) {
	        return name(el) === 'br';
	      };
	      var advancedBr = function (children) {
	        return forall(children, function (c) {
	          return isBr(c) || isText(c) && get$9(c).trim().length === 0;
	        });
	      };
	      var isListItem = function (el) {
	        return name(el) === 'li' || ancestor$2(el, isList).isSome();
	      };
	      var siblingIsBlock = function (el) {
	        return nextSibling(el).map(function (rightSibling) {
	          if (isBlock(rightSibling)) {
	            return true;
	          }
	          if (isEmptyTag(rightSibling)) {
	            return name(rightSibling) === 'img' ? false : true;
	          }
	          return false;
	        }).getOr(false);
	      };
	      var markCell = function (cell) {
	        return last$1(cell).bind(function (rightEdge) {
	          var rightSiblingIsBlock = siblingIsBlock(rightEdge);
	          return parent(rightEdge).map(function (parent) {
	            return rightSiblingIsBlock === true || isListItem(parent) || isBr(rightEdge) || isBlock(parent) && !eq$1(cell, parent) ? [] : [SugarElement.fromTag('br')];
	          });
	        }).getOr([]);
	      };
	      var markContent = function () {
	        var content = bind$2(cells, function (cell) {
	          var children = children$3(cell);
	          return advancedBr(children) ? [] : children.concat(markCell(cell));
	        });
	        return content.length === 0 ? [SugarElement.fromTag('br')] : content;
	      };
	      var contents = markContent();
	      empty(cells[0]);
	      append(cells[0], contents);
	    };
	
	    var isEditable = function (elem) {
	      return isEditable$1(elem, true);
	    };
	    var prune = function (table) {
	      var cells = cells$1(table);
	      if (cells.length === 0) {
	        remove$5(table);
	      }
	    };
	    var outcome = function (grid, cursor) {
	      return {
	        grid: grid,
	        cursor: cursor
	      };
	    };
	    var findEditableCursorPosition = function (rows) {
	      return findMap(rows, function (row) {
	        return findMap(row.cells, function (cell) {
	          var elem = cell.element;
	          return someIf(isEditable(elem), elem);
	        });
	      });
	    };
	    var elementFromGrid = function (grid, row, column) {
	      var _a, _b;
	      var rows = extractGridDetails(grid).rows;
	      return Optional.from((_b = (_a = rows[row]) === null || _a === void 0 ? void 0 : _a.cells[column]) === null || _b === void 0 ? void 0 : _b.element).filter(isEditable).orThunk(function () {
	        return findEditableCursorPosition(rows);
	      });
	    };
	    var bundle = function (grid, row, column) {
	      var cursorElement = elementFromGrid(grid, row, column);
	      return outcome(grid, cursorElement);
	    };
	    var uniqueRows = function (details) {
	      var rowCompilation = function (rest, detail) {
	        var rowExists = exists(rest, function (currentDetail) {
	          return currentDetail.row === detail.row;
	        });
	        return rowExists ? rest : rest.concat([detail]);
	      };
	      return foldl(details, rowCompilation, []).sort(function (detailA, detailB) {
	        return detailA.row - detailB.row;
	      });
	    };
	    var opInsertRowsBefore = function (grid, details, comparator, genWrappers) {
	      var targetIndex = details[0].row;
	      var rows = uniqueRows(details);
	      var newGrid = foldr(rows, function (acc, row) {
	        var newG = insertRowAt(acc.grid, targetIndex, row.row + acc.delta, comparator, genWrappers.getOrInit);
	        return {
	          grid: newG,
	          delta: acc.delta + 1
	        };
	      }, {
	        grid: grid,
	        delta: 0
	      }).grid;
	      return bundle(newGrid, targetIndex, details[0].column);
	    };
	    var opInsertRowsAfter = function (grid, details, comparator, genWrappers) {
	      var rows = uniqueRows(details);
	      var target = rows[rows.length - 1];
	      var targetIndex = target.row + target.rowspan;
	      var newGrid = foldr(rows, function (newG, row) {
	        return insertRowAt(newG, targetIndex, row.row, comparator, genWrappers.getOrInit);
	      }, grid);
	      return bundle(newGrid, targetIndex, details[0].column);
	    };
	    var opInsertColumnsBefore = function (grid, extractDetail, comparator, genWrappers) {
	      var details = extractDetail.details;
	      var columns = uniqueColumns(details);
	      var targetIndex = columns[0].column;
	      var newGrid = foldr(columns, function (acc, col) {
	        var newG = insertColumnAt(acc.grid, targetIndex, col.column + acc.delta, comparator, genWrappers.getOrInit);
	        return {
	          grid: newG,
	          delta: acc.delta + 1
	        };
	      }, {
	        grid: grid,
	        delta: 0
	      }).grid;
	      return bundle(newGrid, details[0].row, targetIndex);
	    };
	    var opInsertColumnsAfter = function (grid, extractDetail, comparator, genWrappers) {
	      var details = extractDetail.details;
	      var target = details[details.length - 1];
	      var targetIndex = target.column + target.colspan;
	      var columns = uniqueColumns(details);
	      var newGrid = foldr(columns, function (newG, col) {
	        return insertColumnAt(newG, targetIndex, col.column, comparator, genWrappers.getOrInit);
	      }, grid);
	      return bundle(newGrid, details[0].row, targetIndex);
	    };
	    var opMakeColumnsHeader = function (initialGrid, details, comparator, genWrappers) {
	      var columns = uniqueColumns(details);
	      var columnIndexes = map$1(columns, function (detail) {
	        return detail.column;
	      });
	      var newGrid = replaceColumns(initialGrid, columnIndexes, true, comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, details[0].row, details[0].column);
	    };
	    var opMakeCellsHeader = function (initialGrid, details, comparator, genWrappers) {
	      var newGrid = replaceCells(initialGrid, details, comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, details[0].row, details[0].column);
	    };
	    var opUnmakeColumnsHeader = function (initialGrid, details, comparator, genWrappers) {
	      var columns = uniqueColumns(details);
	      var columnIndexes = map$1(columns, function (detail) {
	        return detail.column;
	      });
	      var newGrid = replaceColumns(initialGrid, columnIndexes, false, comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, details[0].row, details[0].column);
	    };
	    var opUnmakeCellsHeader = function (initialGrid, details, comparator, genWrappers) {
	      var newGrid = replaceCells(initialGrid, details, comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, details[0].row, details[0].column);
	    };
	    var makeRowsSection = function (section, applyScope) {
	      return function (initialGrid, details, comparator, genWrappers, tableSection) {
	        var rows = uniqueRows(details);
	        var rowIndexes = map$1(rows, function (detail) {
	          return detail.row;
	        });
	        var newGrid = replaceRows(initialGrid, rowIndexes, section, applyScope, comparator, genWrappers.replaceOrInit, tableSection);
	        return bundle(newGrid, details[0].row, details[0].column);
	      };
	    };
	    var opMakeRowsHeader = makeRowsSection('thead', true);
	    var opMakeRowsBody = makeRowsSection('tbody', false);
	    var opMakeRowsFooter = makeRowsSection('tfoot', false);
	    var opEraseColumns = function (grid, extractDetail, _comparator, _genWrappers) {
	      var columns = uniqueColumns(extractDetail.details);
	      var newGrid = deleteColumnsAt(grid, map$1(columns, function (column) {
	        return column.column;
	      }));
	      var maxColIndex = newGrid.length > 0 ? newGrid[0].cells.length - 1 : 0;
	      return bundle(newGrid, columns[0].row, Math.min(columns[0].column, maxColIndex));
	    };
	    var opEraseRows = function (grid, details, _comparator, _genWrappers) {
	      var rows = uniqueRows(details);
	      var newGrid = deleteRowsAt(grid, rows[0].row, rows[rows.length - 1].row);
	      var maxRowIndex = newGrid.length > 0 ? newGrid.length - 1 : 0;
	      return bundle(newGrid, Math.min(details[0].row, maxRowIndex), details[0].column);
	    };
	    var opMergeCells = function (grid, mergable, comparator, genWrappers) {
	      var cells = mergable.cells;
	      merge(cells);
	      var newGrid = merge$2(grid, mergable.bounds, comparator, genWrappers.merge(cells));
	      return outcome(newGrid, Optional.from(cells[0]));
	    };
	    var opUnmergeCells = function (grid, unmergable, comparator, genWrappers) {
	      var unmerge$1 = function (b, cell) {
	        return unmerge(b, cell, comparator, genWrappers.unmerge(cell));
	      };
	      var newGrid = foldr(unmergable, unmerge$1, grid);
	      return outcome(newGrid, Optional.from(unmergable[0]));
	    };
	    var opPasteCells = function (grid, pasteDetails, comparator, _genWrappers) {
	      var gridify = function (table, generators) {
	        var wh = Warehouse.fromTable(table);
	        return toGrid(wh, generators, true);
	      };
	      var gridB = gridify(pasteDetails.clipboard, pasteDetails.generators);
	      var startAddress = address(pasteDetails.row, pasteDetails.column);
	      var mergedGrid = merge$1(startAddress, grid, gridB, pasteDetails.generators, comparator);
	      return mergedGrid.fold(function () {
	        return outcome(grid, Optional.some(pasteDetails.element));
	      }, function (newGrid) {
	        return bundle(newGrid, pasteDetails.row, pasteDetails.column);
	      });
	    };
	    var gridifyRows = function (rows, generators, context) {
	      var pasteDetails = fromPastedRows(rows, context.section);
	      var wh = Warehouse.generate(pasteDetails);
	      return toGrid(wh, generators, true);
	    };
	    var opPasteColsBefore = function (grid, pasteDetails, comparator, _genWrappers) {
	      var rows = extractGridDetails(grid).rows;
	      var index = pasteDetails.cells[0].column;
	      var context = rows[pasteDetails.cells[0].row];
	      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
	      var mergedGrid = insertCols(index, grid, gridB, pasteDetails.generators, comparator);
	      return bundle(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
	    };
	    var opPasteColsAfter = function (grid, pasteDetails, comparator, _genWrappers) {
	      var rows = extractGridDetails(grid).rows;
	      var index = pasteDetails.cells[pasteDetails.cells.length - 1].column + pasteDetails.cells[pasteDetails.cells.length - 1].colspan;
	      var context = rows[pasteDetails.cells[0].row];
	      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
	      var mergedGrid = insertCols(index, grid, gridB, pasteDetails.generators, comparator);
	      return bundle(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
	    };
	    var opPasteRowsBefore = function (grid, pasteDetails, comparator, _genWrappers) {
	      var rows = extractGridDetails(grid).rows;
	      var index = pasteDetails.cells[0].row;
	      var context = rows[index];
	      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
	      var mergedGrid = insertRows(index, grid, gridB, pasteDetails.generators, comparator);
	      return bundle(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
	    };
	    var opPasteRowsAfter = function (grid, pasteDetails, comparator, _genWrappers) {
	      var rows = extractGridDetails(grid).rows;
	      var index = pasteDetails.cells[pasteDetails.cells.length - 1].row + pasteDetails.cells[pasteDetails.cells.length - 1].rowspan;
	      var context = rows[pasteDetails.cells[0].row];
	      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
	      var mergedGrid = insertRows(index, grid, gridB, pasteDetails.generators, comparator);
	      return bundle(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
	    };
	    var opGetColumnsType = function (table, target) {
	      var house = Warehouse.fromTable(table);
	      var details = onCells(house, target);
	      return details.bind(function (selectedCells) {
	        var lastSelectedCell = selectedCells[selectedCells.length - 1];
	        var minColRange = selectedCells[0].column;
	        var maxColRange = lastSelectedCell.column + lastSelectedCell.colspan;
	        var selectedColumnCells = flatten$1(map$1(house.all, function (row) {
	          return filter$2(row.cells, function (cell) {
	            return cell.column >= minColRange && cell.column < maxColRange;
	          });
	        }));
	        return findCommonCellType(selectedColumnCells);
	      }).getOr('');
	    };
	    var opGetCellsType = function (table, target) {
	      var house = Warehouse.fromTable(table);
	      var details = onCells(house, target);
	      return details.bind(findCommonCellType).getOr('');
	    };
	    var opGetRowsType = function (table, target) {
	      var house = Warehouse.fromTable(table);
	      var details = onCells(house, target);
	      return details.bind(function (selectedCells) {
	        var lastSelectedCell = selectedCells[selectedCells.length - 1];
	        var minRowRange = selectedCells[0].row;
	        var maxRowRange = lastSelectedCell.row + lastSelectedCell.rowspan;
	        var selectedRows = house.all.slice(minRowRange, maxRowRange);
	        return findCommonRowType(selectedRows);
	      }).getOr('');
	    };
	    var resize = function (table, list, details, behaviours) {
	      return adjustWidthTo(table, list, details, behaviours.sizing);
	    };
	    var adjustAndRedistributeWidths = function (table, list, details, behaviours) {
	      return adjustAndRedistributeWidths$1(table, list, details, behaviours.sizing, behaviours.resize);
	    };
	    var firstColumnIsLocked = function (_warehouse, details) {
	      return exists(details, function (detail) {
	        return detail.column === 0 && detail.isLocked;
	      });
	    };
	    var lastColumnIsLocked = function (warehouse, details) {
	      return exists(details, function (detail) {
	        return detail.column + detail.colspan >= warehouse.grid.columns && detail.isLocked;
	      });
	    };
	    var getColumnsWidth = function (warehouse, details) {
	      var columns$1 = columns(warehouse);
	      var uniqueCols = uniqueColumns(details);
	      return foldl(uniqueCols, function (acc, detail) {
	        var column = columns$1[detail.column];
	        var colWidth = column.map(getOuter$2).getOr(0);
	        return acc + colWidth;
	      }, 0);
	    };
	    var insertColumnsExtractor = function (before) {
	      return function (warehouse, target) {
	        return onCells(warehouse, target).filter(function (details) {
	          var checkLocked = before ? firstColumnIsLocked : lastColumnIsLocked;
	          return !checkLocked(warehouse, details);
	        }).map(function (details) {
	          return {
	            details: details,
	            pixelDelta: getColumnsWidth(warehouse, details)
	          };
	        });
	      };
	    };
	    var eraseColumnsExtractor = function (warehouse, target) {
	      return onUnlockedCells(warehouse, target).map(function (details) {
	        return {
	          details: details,
	          pixelDelta: -getColumnsWidth(warehouse, details)
	        };
	      });
	    };
	    var pasteColumnsExtractor = function (before) {
	      return function (warehouse, target) {
	        return onPasteByEditor(warehouse, target).filter(function (details) {
	          var checkLocked = before ? firstColumnIsLocked : lastColumnIsLocked;
	          return !checkLocked(warehouse, details.cells);
	        });
	      };
	    };
	    var headerCellGenerator = Generators.transform('th');
	    var bodyCellGenerator = Generators.transform('td');
	    var insertRowsBefore = run(opInsertRowsBefore, onCells, noop, noop, Generators.modification);
	    var insertRowsAfter = run(opInsertRowsAfter, onCells, noop, noop, Generators.modification);
	    var insertColumnsBefore = run(opInsertColumnsBefore, insertColumnsExtractor(true), adjustAndRedistributeWidths, noop, Generators.modification);
	    var insertColumnsAfter = run(opInsertColumnsAfter, insertColumnsExtractor(false), adjustAndRedistributeWidths, noop, Generators.modification);
	    var eraseColumns = run(opEraseColumns, eraseColumnsExtractor, adjustAndRedistributeWidths, prune, Generators.modification);
	    var eraseRows = run(opEraseRows, onCells, noop, prune, Generators.modification);
	    var makeColumnsHeader = run(opMakeColumnsHeader, onUnlockedCells, noop, noop, headerCellGenerator);
	    var unmakeColumnsHeader = run(opUnmakeColumnsHeader, onUnlockedCells, noop, noop, bodyCellGenerator);
	    var makeRowsHeader = run(opMakeRowsHeader, onUnlockedCells, noop, noop, headerCellGenerator);
	    var makeRowsBody = run(opMakeRowsBody, onUnlockedCells, noop, noop, bodyCellGenerator);
	    var makeRowsFooter = run(opMakeRowsFooter, onUnlockedCells, noop, noop, bodyCellGenerator);
	    var makeCellsHeader = run(opMakeCellsHeader, onUnlockedCells, noop, noop, headerCellGenerator);
	    var unmakeCellsHeader = run(opUnmakeCellsHeader, onUnlockedCells, noop, noop, bodyCellGenerator);
	    var mergeCells = run(opMergeCells, onUnlockedMergable, resize, noop, Generators.merging);
	    var unmergeCells = run(opUnmergeCells, onUnlockedUnmergable, resize, noop, Generators.merging);
	    var pasteCells = run(opPasteCells, onPaste, resize, noop, Generators.modification);
	    var pasteColsBefore = run(opPasteColsBefore, pasteColumnsExtractor(true), noop, noop, Generators.modification);
	    var pasteColsAfter = run(opPasteColsAfter, pasteColumnsExtractor(false), noop, noop, Generators.modification);
	    var pasteRowsBefore = run(opPasteRowsBefore, onPasteByEditor, noop, noop, Generators.modification);
	    var pasteRowsAfter = run(opPasteRowsAfter, onPasteByEditor, noop, noop, Generators.modification);
	    var getColumnsType = opGetColumnsType;
	    var getCellsType = opGetCellsType;
	    var getRowsType = opGetRowsType;
	
	    var TableActions = function (editor, cellSelection, lazyWire) {
	      var isTableBody = function (editor) {
	        return name(getBody(editor)) === 'table';
	      };
	      var lastRowGuard = function (table) {
	        return isTableBody(editor) === false || getGridSize(table).rows > 1;
	      };
	      var lastColumnGuard = function (table) {
	        return isTableBody(editor) === false || getGridSize(table).columns > 1;
	      };
	      var cloneFormats = getCloneElements(editor);
	      var colMutationOp = isResizeTableColumnResizing(editor) ? noop : halve;
	      var getTableSectionType = function (table) {
	        switch (getTableHeaderType(editor)) {
	        case 'section':
	          return TableSection.section();
	        case 'sectionCells':
	          return TableSection.sectionCells();
	        case 'cells':
	          return TableSection.cells();
	        default:
	          return TableSection.getTableSectionType(table, 'section');
	        }
	      };
	      var setSelectionFromAction = function (table, result) {
	        return result.cursor.fold(function () {
	          var cells = cells$1(table);
	          return head(cells).filter(inBody).map(function (firstCell) {
	            cellSelection.clear(table);
	            var rng = editor.dom.createRng();
	            rng.selectNode(firstCell.dom);
	            editor.selection.setRng(rng);
	            set$2(firstCell, 'data-mce-selected', '1');
	            return rng;
	          });
	        }, function (cell) {
	          var des = freefallRtl(cell);
	          var rng = editor.dom.createRng();
	          rng.setStart(des.element.dom, des.offset);
	          rng.setEnd(des.element.dom, des.offset);
	          editor.selection.setRng(rng);
	          cellSelection.clear(table);
	          return Optional.some(rng);
	        });
	      };
	      var execute = function (operation, guard, mutate, lazyWire, effect) {
	        return function (table, target, noEvents) {
	          if (noEvents === void 0) {
	            noEvents = false;
	          }
	          removeDataStyle(table);
	          var wire = lazyWire();
	          var doc = SugarElement.fromDom(editor.getDoc());
	          var generators = cellOperations(mutate, doc, cloneFormats);
	          var behaviours = {
	            sizing: get$4(editor, table),
	            resize: isResizeTableColumnResizing(editor) ? resizeTable() : preserveTable(),
	            section: getTableSectionType(table)
	          };
	          return guard(table) ? operation(wire, table, target, generators, behaviours).bind(function (result) {
	            each$2(result.newRows, function (row) {
	              fireNewRow(editor, row.dom);
	            });
	            each$2(result.newCells, function (cell) {
	              fireNewCell(editor, cell.dom);
	            });
	            var range = setSelectionFromAction(table, result);
	            if (inBody(table)) {
	              removeDataStyle(table);
	              if (!noEvents) {
	                fireTableModified(editor, table.dom, effect);
	              }
	            }
	            return range.map(function (rng) {
	              return {
	                rng: rng,
	                effect: effect
	              };
	            });
	          }) : Optional.none();
	        };
	      };
	      var deleteRow = execute(eraseRows, lastRowGuard, noop, lazyWire, structureModified);
	      var deleteColumn = execute(eraseColumns, lastColumnGuard, noop, lazyWire, structureModified);
	      var insertRowsBefore$1 = execute(insertRowsBefore, always, noop, lazyWire, structureModified);
	      var insertRowsAfter$1 = execute(insertRowsAfter, always, noop, lazyWire, structureModified);
	      var insertColumnsBefore$1 = execute(insertColumnsBefore, always, colMutationOp, lazyWire, structureModified);
	      var insertColumnsAfter$1 = execute(insertColumnsAfter, always, colMutationOp, lazyWire, structureModified);
	      var mergeCells$1 = execute(mergeCells, always, noop, lazyWire, structureModified);
	      var unmergeCells$1 = execute(unmergeCells, always, noop, lazyWire, structureModified);
	      var pasteColsBefore$1 = execute(pasteColsBefore, always, noop, lazyWire, structureModified);
	      var pasteColsAfter$1 = execute(pasteColsAfter, always, noop, lazyWire, structureModified);
	      var pasteRowsBefore$1 = execute(pasteRowsBefore, always, noop, lazyWire, structureModified);
	      var pasteRowsAfter$1 = execute(pasteRowsAfter, always, noop, lazyWire, structureModified);
	      var pasteCells$1 = execute(pasteCells, always, noop, lazyWire, styleAndStructureModified);
	      var makeCellsHeader$1 = execute(makeCellsHeader, always, noop, lazyWire, structureModified);
	      var unmakeCellsHeader$1 = execute(unmakeCellsHeader, always, noop, lazyWire, structureModified);
	      var makeColumnsHeader$1 = execute(makeColumnsHeader, always, noop, lazyWire, structureModified);
	      var unmakeColumnsHeader$1 = execute(unmakeColumnsHeader, always, noop, lazyWire, structureModified);
	      var makeRowsHeader$1 = execute(makeRowsHeader, always, noop, lazyWire, structureModified);
	      var makeRowsBody$1 = execute(makeRowsBody, always, noop, lazyWire, structureModified);
	      var makeRowsFooter$1 = execute(makeRowsFooter, always, noop, lazyWire, structureModified);
	      var getTableCellType = getCellsType;
	      var getTableColType = getColumnsType;
	      var getTableRowType = getRowsType;
	      return {
	        deleteRow: deleteRow,
	        deleteColumn: deleteColumn,
	        insertRowsBefore: insertRowsBefore$1,
	        insertRowsAfter: insertRowsAfter$1,
	        insertColumnsBefore: insertColumnsBefore$1,
	        insertColumnsAfter: insertColumnsAfter$1,
	        mergeCells: mergeCells$1,
	        unmergeCells: unmergeCells$1,
	        pasteColsBefore: pasteColsBefore$1,
	        pasteColsAfter: pasteColsAfter$1,
	        pasteRowsBefore: pasteRowsBefore$1,
	        pasteRowsAfter: pasteRowsAfter$1,
	        pasteCells: pasteCells$1,
	        makeCellsHeader: makeCellsHeader$1,
	        unmakeCellsHeader: unmakeCellsHeader$1,
	        makeColumnsHeader: makeColumnsHeader$1,
	        unmakeColumnsHeader: unmakeColumnsHeader$1,
	        makeRowsHeader: makeRowsHeader$1,
	        makeRowsBody: makeRowsBody$1,
	        makeRowsFooter: makeRowsFooter$1,
	        getTableRowType: getTableRowType,
	        getTableCellType: getTableCellType,
	        getTableColType: getTableColType
	      };
	    };
	
	    var DefaultRenderOptions = {
	      styles: {
	        'border-collapse': 'collapse',
	        'width': '100%'
	      },
	      attributes: { border: '1' },
	      colGroups: false
	    };
	    var tableHeaderCell = function () {
	      return SugarElement.fromTag('th');
	    };
	    var tableCell = function () {
	      return SugarElement.fromTag('td');
	    };
	    var tableColumn = function () {
	      return SugarElement.fromTag('col');
	    };
	    var createRow = function (columns, rowHeaders, columnHeaders, rowIndex) {
	      var tr = SugarElement.fromTag('tr');
	      for (var j = 0; j < columns; j++) {
	        var td = rowIndex < rowHeaders || j < columnHeaders ? tableHeaderCell() : tableCell();
	        if (j < columnHeaders) {
	          set$2(td, 'scope', 'row');
	        }
	        if (rowIndex < rowHeaders) {
	          set$2(td, 'scope', 'col');
	        }
	        append$1(td, SugarElement.fromTag('br'));
	        append$1(tr, td);
	      }
	      return tr;
	    };
	    var createGroupRow = function (columns) {
	      var columnGroup = SugarElement.fromTag('colgroup');
	      range$1(columns, function () {
	        return append$1(columnGroup, tableColumn());
	      });
	      return columnGroup;
	    };
	    var createRows = function (rows, columns, rowHeaders, columnHeaders) {
	      return range$1(rows, function (r) {
	        return createRow(columns, rowHeaders, columnHeaders, r);
	      });
	    };
	    var render = function (rows, columns, rowHeaders, columnHeaders, headerType, renderOpts) {
	      if (renderOpts === void 0) {
	        renderOpts = DefaultRenderOptions;
	      }
	      var table = SugarElement.fromTag('table');
	      var rowHeadersGoInThead = headerType !== 'cells';
	      setAll(table, renderOpts.styles);
	      setAll$1(table, renderOpts.attributes);
	      if (renderOpts.colGroups) {
	        append$1(table, createGroupRow(columns));
	      }
	      var actualRowHeaders = Math.min(rows, rowHeaders);
	      if (rowHeadersGoInThead && rowHeaders > 0) {
	        var thead = SugarElement.fromTag('thead');
	        append$1(table, thead);
	        var theadRowHeaders = headerType === 'sectionCells' ? actualRowHeaders : 0;
	        var theadRows = createRows(rowHeaders, columns, theadRowHeaders, columnHeaders);
	        append(thead, theadRows);
	      }
	      var tbody = SugarElement.fromTag('tbody');
	      append$1(table, tbody);
	      var numRows = rowHeadersGoInThead ? rows - actualRowHeaders : rows;
	      var numRowHeaders = rowHeadersGoInThead ? 0 : rowHeaders;
	      var tbodyRows = createRows(numRows, columns, numRowHeaders, columnHeaders);
	      append(tbody, tbodyRows);
	      return table;
	    };
	
	    var get$2 = function (element) {
	      return element.dom.innerHTML;
	    };
	    var getOuter = function (element) {
	      var container = SugarElement.fromTag('div');
	      var clone = SugarElement.fromDom(element.dom.cloneNode(true));
	      append$1(container, clone);
	      return get$2(container);
	    };
	
	    var placeCaretInCell = function (editor, cell) {
	      editor.selection.select(cell.dom, true);
	      editor.selection.collapse(true);
	    };
	    var selectFirstCellInTable = function (editor, tableElm) {
	      descendant(tableElm, 'td,th').each(curry(placeCaretInCell, editor));
	    };
	    var fireEvents = function (editor, table) {
	      each$2(descendants(table, 'tr'), function (row) {
	        fireNewRow(editor, row.dom);
	        each$2(descendants(row, 'th,td'), function (cell) {
	          fireNewCell(editor, cell.dom);
	        });
	      });
	    };
	    var isPercentage = function (width) {
	      return isString(width) && width.indexOf('%') !== -1;
	    };
	    var insert = function (editor, columns, rows, colHeaders, rowHeaders) {
	      var defaultStyles = getDefaultStyles(editor);
	      var options = {
	        styles: defaultStyles,
	        attributes: getDefaultAttributes(editor),
	        colGroups: useColumnGroup(editor)
	      };
	      editor.undoManager.ignore(function () {
	        var table = render(rows, columns, rowHeaders, colHeaders, getTableHeaderType(editor), options);
	        set$2(table, 'data-mce-id', '__mce');
	        var html = getOuter(table);
	        editor.insertContent(html);
	        editor.addVisual();
	      });
	      return descendant(getBody(editor), 'table[data-mce-id="__mce"]').map(function (table) {
	        if (isPixelsForced(editor)) {
	          enforcePixels(table);
	        } else if (isResponsiveForced(editor)) {
	          enforceNone(table);
	        } else if (isPercentagesForced(editor) || isPercentage(defaultStyles.width)) {
	          enforcePercentage(table);
	        }
	        removeDataStyle(table);
	        remove$7(table, 'data-mce-id');
	        fireEvents(editor, table);
	        selectFirstCellInTable(editor, table);
	        return table.dom;
	      }).getOr(null);
	    };
	    var insertTableWithDataValidation = function (editor, rows, columns, options, errorMsg) {
	      if (options === void 0) {
	        options = {};
	      }
	      var checkInput = function (val) {
	        return isNumber(val) && val > 0;
	      };
	      if (checkInput(rows) && checkInput(columns)) {
	        var headerRows = options.headerRows || 0;
	        var headerColumns = options.headerColumns || 0;
	        return insert(editor, columns, rows, headerColumns, headerRows);
	      } else {
	        console.error(errorMsg);
	        return null;
	      }
	    };
	
	    var getClipboardElements = function (getClipboard) {
	      return function () {
	        return getClipboard().fold(function () {
	          return [];
	        }, function (elems) {
	          return map$1(elems, function (e) {
	            return e.dom;
	          });
	        });
	      };
	    };
	    var setClipboardElements = function (setClipboard) {
	      return function (elems) {
	        var elmsOpt = elems.length > 0 ? Optional.some(fromDom(elems)) : Optional.none();
	        setClipboard(elmsOpt);
	      };
	    };
	    var insertTable = function (editor) {
	      return function (columns, rows, options) {
	        if (options === void 0) {
	          options = {};
	        }
	        var table = insertTableWithDataValidation(editor, rows, columns, options, 'Invalid values for insertTable - rows and columns values are required to insert a table.');
	        editor.undoManager.add();
	        return table;
	      };
	    };
	    var getApi = function (editor, clipboard, resizeHandler, selectionTargets) {
	      return {
	        insertTable: insertTable(editor),
	        setClipboardRows: setClipboardElements(clipboard.setRows),
	        getClipboardRows: getClipboardElements(clipboard.getRows),
	        setClipboardCols: setClipboardElements(clipboard.setColumns),
	        getClipboardCols: getClipboardElements(clipboard.getColumns),
	        resizeHandler: resizeHandler,
	        selectionTargets: selectionTargets
	      };
	    };
	
	    var constrainSpan = function (element, property, value) {
	      var currentColspan = getAttrValue(element, property, 1);
	      if (value === 1 || currentColspan <= 1) {
	        remove$7(element, property);
	      } else {
	        set$2(element, property, Math.min(value, currentColspan));
	      }
	    };
	    var generateColGroup = function (house, minColRange, maxColRange) {
	      if (Warehouse.hasColumns(house)) {
	        var colsToCopy = filter$2(Warehouse.justColumns(house), function (col) {
	          return col.column >= minColRange && col.column < maxColRange;
	        });
	        var copiedCols = map$1(colsToCopy, function (c) {
	          var clonedCol = deep(c.element);
	          constrainSpan(clonedCol, 'span', maxColRange - minColRange);
	          return clonedCol;
	        });
	        var fakeColgroup = SugarElement.fromTag('colgroup');
	        append(fakeColgroup, copiedCols);
	        return [fakeColgroup];
	      } else {
	        return [];
	      }
	    };
	    var generateRows = function (house, minColRange, maxColRange) {
	      return map$1(house.all, function (row) {
	        var cellsToCopy = filter$2(row.cells, function (cell) {
	          return cell.column >= minColRange && cell.column < maxColRange;
	        });
	        var copiedCells = map$1(cellsToCopy, function (cell) {
	          var clonedCell = deep(cell.element);
	          constrainSpan(clonedCell, 'colspan', maxColRange - minColRange);
	          return clonedCell;
	        });
	        var fakeTR = SugarElement.fromTag('tr');
	        append(fakeTR, copiedCells);
	        return fakeTR;
	      });
	    };
	    var copyCols = function (table, target) {
	      var house = Warehouse.fromTable(table);
	      var details = onUnlockedCells(house, target);
	      return details.map(function (selectedCells) {
	        var lastSelectedCell = selectedCells[selectedCells.length - 1];
	        var minColRange = selectedCells[0].column;
	        var maxColRange = lastSelectedCell.column + lastSelectedCell.colspan;
	        var fakeColGroups = generateColGroup(house, minColRange, maxColRange);
	        var fakeRows = generateRows(house, minColRange, maxColRange);
	        return __spreadArray(__spreadArray([], fakeColGroups, true), fakeRows, true);
	      });
	    };
	
	    var copyRows = function (table, target, generators) {
	      var warehouse = Warehouse.fromTable(table);
	      var details = onCells(warehouse, target);
	      return details.bind(function (selectedCells) {
	        var grid = toGrid(warehouse, generators, false);
	        var rows = extractGridDetails(grid).rows;
	        var slicedGrid = rows.slice(selectedCells[0].row, selectedCells[selectedCells.length - 1].row + selectedCells[selectedCells.length - 1].rowspan);
	        var filteredGrid = bind$2(slicedGrid, function (row) {
	          var newCells = filter$2(row.cells, function (cell) {
	            return !cell.isLocked;
	          });
	          return newCells.length > 0 ? [__assign(__assign({}, row), { cells: newCells })] : [];
	        });
	        var slicedDetails = toDetailList(filteredGrid);
	        return someIf(slicedDetails.length > 0, slicedDetails);
	      }).map(function (slicedDetails) {
	        return copy(slicedDetails);
	      });
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getTDTHOverallStyle = function (dom, elm, name) {
	      var cells = dom.select('td,th', elm);
	      var firstChildStyle;
	      var checkChildren = function (firstChildStyle, elms) {
	        for (var i = 0; i < elms.length; i++) {
	          var currentStyle = dom.getStyle(elms[i], name);
	          if (typeof firstChildStyle === 'undefined') {
	            firstChildStyle = currentStyle;
	          }
	          if (firstChildStyle !== currentStyle) {
	            return '';
	          }
	        }
	        return firstChildStyle;
	      };
	      return checkChildren(firstChildStyle, cells);
	    };
	    var applyAlign = function (editor, elm, name) {
	      if (name) {
	        editor.formatter.apply('align' + name, {}, elm);
	      }
	    };
	    var applyVAlign = function (editor, elm, name) {
	      if (name) {
	        editor.formatter.apply('valign' + name, {}, elm);
	      }
	    };
	    var unApplyAlign = function (editor, elm) {
	      global$2.each('left center right'.split(' '), function (name) {
	        editor.formatter.remove('align' + name, {}, elm);
	      });
	    };
	    var unApplyVAlign = function (editor, elm) {
	      global$2.each('top middle bottom'.split(' '), function (name) {
	        editor.formatter.remove('valign' + name, {}, elm);
	      });
	    };
	
	    var verticalAlignValues = [
	      {
	        text: 'None',
	        value: ''
	      },
	      {
	        text: 'Top',
	        value: 'top'
	      },
	      {
	        text: 'Middle',
	        value: 'middle'
	      },
	      {
	        text: 'Bottom',
	        value: 'bottom'
	      }
	    ];
	
	    var hexColour = function (value) {
	      return { value: value };
	    };
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    var longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
	    var isHexString = function (hex) {
	      return shorthandRegex.test(hex) || longformRegex.test(hex);
	    };
	    var normalizeHex = function (hex) {
	      return removeLeading(hex, '#').toUpperCase();
	    };
	    var fromString$1 = function (hex) {
	      return isHexString(hex) ? Optional.some({ value: normalizeHex(hex) }) : Optional.none();
	    };
	    var toHex = function (component) {
	      var hex = component.toString(16);
	      return (hex.length === 1 ? '0' + hex : hex).toUpperCase();
	    };
	    var fromRgba = function (rgbaColour) {
	      var value = toHex(rgbaColour.red) + toHex(rgbaColour.green) + toHex(rgbaColour.blue);
	      return hexColour(value);
	    };
	
	    var rgbRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
	    var rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d?(?:\.\d+)?)\)/;
	    var rgbaColour = function (red, green, blue, alpha) {
	      return {
	        red: red,
	        green: green,
	        blue: blue,
	        alpha: alpha
	      };
	    };
	    var fromStringValues = function (red, green, blue, alpha) {
	      var r = parseInt(red, 10);
	      var g = parseInt(green, 10);
	      var b = parseInt(blue, 10);
	      var a = parseFloat(alpha);
	      return rgbaColour(r, g, b, a);
	    };
	    var fromString = function (rgbaString) {
	      if (rgbaString === 'transparent') {
	        return Optional.some(rgbaColour(0, 0, 0, 0));
	      }
	      var rgbMatch = rgbRegex.exec(rgbaString);
	      if (rgbMatch !== null) {
	        return Optional.some(fromStringValues(rgbMatch[1], rgbMatch[2], rgbMatch[3], '1'));
	      }
	      var rgbaMatch = rgbaRegex.exec(rgbaString);
	      if (rgbaMatch !== null) {
	        return Optional.some(fromStringValues(rgbaMatch[1], rgbaMatch[2], rgbaMatch[3], rgbaMatch[4]));
	      }
	      return Optional.none();
	    };
	
	    var anyToHex = function (color) {
	      return fromString$1(color).orThunk(function () {
	        return fromString(color).map(fromRgba);
	      }).getOrThunk(function () {
	        var canvas = document.createElement('canvas');
	        canvas.height = 1;
	        canvas.width = 1;
	        var canvasContext = canvas.getContext('2d');
	        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
	        canvasContext.fillStyle = '#FFFFFF';
	        canvasContext.fillStyle = color;
	        canvasContext.fillRect(0, 0, 1, 1);
	        var rgba = canvasContext.getImageData(0, 0, 1, 1).data;
	        var r = rgba[0];
	        var g = rgba[1];
	        var b = rgba[2];
	        var a = rgba[3];
	        return fromRgba(rgbaColour(r, g, b, a));
	      });
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var singleton = function (doRevoke) {
	      var subject = Cell(Optional.none());
	      var revoke = function () {
	        return subject.get().each(doRevoke);
	      };
	      var clear = function () {
	        revoke();
	        subject.set(Optional.none());
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var get = function () {
	        return subject.get();
	      };
	      var set = function (s) {
	        revoke();
	        subject.set(Optional.some(s));
	      };
	      return {
	        clear: clear,
	        isSet: isSet,
	        get: get,
	        set: set
	      };
	    };
	    var unbindable = function () {
	      return singleton(function (s) {
	        return s.unbind();
	      });
	    };
	    var value = function () {
	      var subject = singleton(noop);
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return __assign(__assign({}, subject), { on: on });
	    };
	
	    var onSetupToggle = function (editor, selections, formatName, formatValue) {
	      return function (api) {
	        var boundCallback = unbindable();
	        var isNone = isEmpty$1(formatValue);
	        var init = function () {
	          var selectedCells = getCellsFromSelection(selections);
	          var checkNode = function (cell) {
	            return editor.formatter.match(formatName, { value: formatValue }, cell.dom, isNone);
	          };
	          if (isNone) {
	            api.setActive(!exists(selectedCells, checkNode));
	            boundCallback.set(editor.formatter.formatChanged(formatName, function (match) {
	              return api.setActive(!match);
	            }, true));
	          } else {
	            api.setActive(forall(selectedCells, checkNode));
	            boundCallback.set(editor.formatter.formatChanged(formatName, api.setActive, false, { value: formatValue }));
	          }
	        };
	        editor.initialized ? init() : editor.on('init', init);
	        return boundCallback.clear;
	      };
	    };
	    var isListGroup = function (item) {
	      return hasNonNullableKey(item, 'menu');
	    };
	    var buildListItems = function (items) {
	      return map$1(items, function (item) {
	        var text = item.text || item.title;
	        if (isListGroup(item)) {
	          return {
	            text: text,
	            items: buildListItems(item.menu)
	          };
	        } else {
	          return {
	            text: text,
	            value: item.value
	          };
	        }
	      });
	    };
	    var buildMenuItems = function (editor, selections, items, format, onAction) {
	      return map$1(items, function (item) {
	        var text = item.text || item.title;
	        if (isListGroup(item)) {
	          return {
	            type: 'nestedmenuitem',
	            text: text,
	            getSubmenuItems: function () {
	              return buildMenuItems(editor, selections, item.menu, format, onAction);
	            }
	          };
	        } else {
	          return {
	            text: text,
	            type: 'togglemenuitem',
	            onAction: function () {
	              return onAction(item.value);
	            },
	            onSetup: onSetupToggle(editor, selections, format, item.value)
	          };
	        }
	      });
	    };
	    var applyTableCellStyle = function (editor, style) {
	      return function (value) {
	        var _a;
	        editor.execCommand('mceTableApplyCellStyle', false, (_a = {}, _a[style] = value, _a));
	      };
	    };
	    var filterNoneItem = function (list) {
	      return bind$2(list, function (item) {
	        if (isListGroup(item)) {
	          return [__assign(__assign({}, item), { menu: filterNoneItem(item.menu) })];
	        } else {
	          return isNotEmpty(item.value) ? [item] : [];
	        }
	      });
	    };
	    var generateMenuItemsCallback = function (editor, selections, items, format, onAction) {
	      return function (callback) {
	        return callback(buildMenuItems(editor, selections, items, format, onAction));
	      };
	    };
	    var buildColorMenu = function (editor, colorList, style) {
	      var colorMap = map$1(colorList, function (entry) {
	        return {
	          text: entry.title,
	          value: '#' + anyToHex(entry.value).value,
	          type: 'choiceitem'
	        };
	      });
	      return [{
	          type: 'fancymenuitem',
	          fancytype: 'colorswatch',
	          initData: {
	            colors: colorMap.length > 0 ? colorMap : undefined,
	            allowCustomColors: false
	          },
	          onAction: function (data) {
	            var _a;
	            var value = data.value === 'remove' ? '' : data.value;
	            editor.execCommand('mceTableApplyCellStyle', false, (_a = {}, _a[style] = value, _a));
	          }
	        }];
	    };
	    var changeRowHeader = function (editor) {
	      return function () {
	        var currentType = editor.queryCommandValue('mceTableRowType');
	        var newType = currentType === 'header' ? 'body' : 'header';
	        editor.execCommand('mceTableRowType', false, { type: newType });
	      };
	    };
	    var changeColumnHeader = function (editor) {
	      return function () {
	        var currentType = editor.queryCommandValue('mceTableColType');
	        var newType = currentType === 'th' ? 'td' : 'th';
	        editor.execCommand('mceTableColType', false, { type: newType });
	      };
	    };
	
	    var getClassList$1 = function (editor) {
	      var classes = buildListItems(getCellClassList(editor));
	      if (classes.length > 0) {
	        return Optional.some({
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          items: classes
	        });
	      }
	      return Optional.none();
	    };
	    var children = [
	      {
	        name: 'width',
	        type: 'input',
	        label: 'Width'
	      },
	      {
	        name: 'height',
	        type: 'input',
	        label: 'Height'
	      },
	      {
	        name: 'celltype',
	        type: 'listbox',
	        label: 'Cell type',
	        items: [
	          {
	            text: 'Cell',
	            value: 'td'
	          },
	          {
	            text: 'Header cell',
	            value: 'th'
	          }
	        ]
	      },
	      {
	        name: 'scope',
	        type: 'listbox',
	        label: 'Scope',
	        items: [
	          {
	            text: 'None',
	            value: ''
	          },
	          {
	            text: 'Row',
	            value: 'row'
	          },
	          {
	            text: 'Column',
	            value: 'col'
	          },
	          {
	            text: 'Row group',
	            value: 'rowgroup'
	          },
	          {
	            text: 'Column group',
	            value: 'colgroup'
	          }
	        ]
	      },
	      {
	        name: 'halign',
	        type: 'listbox',
	        label: 'Horizontal align',
	        items: [
	          {
	            text: 'None',
	            value: ''
	          },
	          {
	            text: 'Left',
	            value: 'left'
	          },
	          {
	            text: 'Center',
	            value: 'center'
	          },
	          {
	            text: 'Right',
	            value: 'right'
	          }
	        ]
	      },
	      {
	        name: 'valign',
	        type: 'listbox',
	        label: 'Vertical align',
	        items: verticalAlignValues
	      }
	    ];
	    var getItems$2 = function (editor) {
	      return children.concat(getClassList$1(editor).toArray());
	    };
	
	    var getAdvancedTab = function (editor, dialogName) {
	      var emptyBorderStyle = [{
	          text: 'Select...',
	          value: ''
	        }];
	      var advTabItems = [
	        {
	          name: 'borderstyle',
	          type: 'listbox',
	          label: 'Border style',
	          items: emptyBorderStyle.concat(buildListItems(getTableBorderStyles(editor)))
	        },
	        {
	          name: 'bordercolor',
	          type: 'colorinput',
	          label: 'Border color'
	        },
	        {
	          name: 'backgroundcolor',
	          type: 'colorinput',
	          label: 'Background color'
	        }
	      ];
	      var borderWidth = {
	        name: 'borderwidth',
	        type: 'input',
	        label: 'Border width'
	      };
	      var items = dialogName === 'cell' ? [borderWidth].concat(advTabItems) : advTabItems;
	      return {
	        title: 'Advanced',
	        name: 'advanced',
	        items: items
	      };
	    };
	
	    var modifiers = function (testTruthy) {
	      return function (editor, node) {
	        var dom = editor.dom;
	        var setAttrib = function (attr, value) {
	          if (!testTruthy || value) {
	            dom.setAttrib(node, attr, value);
	          }
	        };
	        var setStyle = function (prop, value) {
	          if (!testTruthy || value) {
	            dom.setStyle(node, prop, value);
	          }
	        };
	        var setFormat = function (formatName, value) {
	          if (!testTruthy || value) {
	            if (value === '') {
	              editor.formatter.remove(formatName, { value: null }, node, true);
	            } else {
	              editor.formatter.apply(formatName, { value: value }, node);
	            }
	          }
	        };
	        return {
	          setAttrib: setAttrib,
	          setStyle: setStyle,
	          setFormat: setFormat
	        };
	      };
	    };
	    var DomModifier = {
	      normal: modifiers(false),
	      ifTruthy: modifiers(true)
	    };
	
	    var rgbToHex = function (dom) {
	      return function (value) {
	        return startsWith(value, 'rgb') ? dom.toHex(value) : value;
	      };
	    };
	    var extractAdvancedStyles = function (dom, elm) {
	      var element = SugarElement.fromDom(elm);
	      return {
	        borderwidth: getRaw$2(element, 'border-width').getOr(''),
	        borderstyle: getRaw$2(element, 'border-style').getOr(''),
	        bordercolor: getRaw$2(element, 'border-color').map(rgbToHex(dom)).getOr(''),
	        backgroundcolor: getRaw$2(element, 'background-color').map(rgbToHex(dom)).getOr('')
	      };
	    };
	    var getSharedValues = function (data) {
	      var baseData = data[0];
	      var comparisonData = data.slice(1);
	      each$2(comparisonData, function (items) {
	        each$2(keys(baseData), function (key) {
	          each$1(items, function (itemValue, itemKey) {
	            var comparisonValue = baseData[key];
	            if (comparisonValue !== '' && key === itemKey) {
	              if (comparisonValue !== itemValue) {
	                baseData[key] = '';
	              }
	            }
	          });
	        });
	      });
	      return baseData;
	    };
	    var getAlignment = function (formats, formatName, editor, elm) {
	      return find$1(formats, function (name) {
	        return !isUndefined(editor.formatter.matchNode(elm, formatName + name));
	      }).getOr('');
	    };
	    var getHAlignment = curry(getAlignment, [
	      'left',
	      'center',
	      'right'
	    ], 'align');
	    var getVAlignment = curry(getAlignment, [
	      'top',
	      'middle',
	      'bottom'
	    ], 'valign');
	    var extractDataFromSettings = function (editor, hasAdvTableTab) {
	      var style = getDefaultStyles(editor);
	      var attrs = getDefaultAttributes(editor);
	      var extractAdvancedStyleData = function (dom) {
	        return {
	          borderstyle: get$c(style, 'border-style').getOr(''),
	          bordercolor: rgbToHex(dom)(get$c(style, 'border-color').getOr('')),
	          backgroundcolor: rgbToHex(dom)(get$c(style, 'background-color').getOr(''))
	        };
	      };
	      var defaultData = {
	        height: '',
	        width: '100%',
	        cellspacing: '',
	        cellpadding: '',
	        caption: false,
	        class: '',
	        align: '',
	        border: ''
	      };
	      var getBorder = function () {
	        var borderWidth = style['border-width'];
	        if (shouldStyleWithCss(editor) && borderWidth) {
	          return { border: borderWidth };
	        }
	        return get$c(attrs, 'border').fold(function () {
	          return {};
	        }, function (border) {
	          return { border: border };
	        });
	      };
	      var advStyle = hasAdvTableTab ? extractAdvancedStyleData(editor.dom) : {};
	      var getCellPaddingCellSpacing = function () {
	        var spacing = get$c(style, 'border-spacing').or(get$c(attrs, 'cellspacing')).fold(function () {
	          return {};
	        }, function (cellspacing) {
	          return { cellspacing: cellspacing };
	        });
	        var padding = get$c(style, 'border-padding').or(get$c(attrs, 'cellpadding')).fold(function () {
	          return {};
	        }, function (cellpadding) {
	          return { cellpadding: cellpadding };
	        });
	        return __assign(__assign({}, spacing), padding);
	      };
	      var data = __assign(__assign(__assign(__assign(__assign(__assign({}, defaultData), style), attrs), advStyle), getBorder()), getCellPaddingCellSpacing());
	      return data;
	    };
	    var getRowType = function (elm) {
	      return table(SugarElement.fromDom(elm)).map(function (table) {
	        var target = { selection: fromDom(elm.cells) };
	        return getRowsType(table, target);
	      }).getOr('');
	    };
	    var extractDataFromTableElement = function (editor, elm, hasAdvTableTab) {
	      var getBorder = function (dom, elm) {
	        var optBorderWidth = getRaw$2(SugarElement.fromDom(elm), 'border-width');
	        if (shouldStyleWithCss(editor) && optBorderWidth.isSome()) {
	          return optBorderWidth.getOr('');
	        }
	        return dom.getAttrib(elm, 'border') || getTDTHOverallStyle(editor.dom, elm, 'border-width') || getTDTHOverallStyle(editor.dom, elm, 'border');
	      };
	      var dom = editor.dom;
	      var cellspacing = shouldStyleWithCss(editor) ? dom.getStyle(elm, 'border-spacing') || dom.getAttrib(elm, 'cellspacing') : dom.getAttrib(elm, 'cellspacing') || dom.getStyle(elm, 'border-spacing');
	      var cellpadding = shouldStyleWithCss(editor) ? getTDTHOverallStyle(dom, elm, 'padding') || dom.getAttrib(elm, 'cellpadding') : dom.getAttrib(elm, 'cellpadding') || getTDTHOverallStyle(dom, elm, 'padding');
	      return __assign({
	        width: dom.getStyle(elm, 'width') || dom.getAttrib(elm, 'width'),
	        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
	        cellspacing: cellspacing,
	        cellpadding: cellpadding,
	        border: getBorder(dom, elm),
	        caption: !!dom.select('caption', elm)[0],
	        class: dom.getAttrib(elm, 'class', ''),
	        align: getHAlignment(editor, elm)
	      }, hasAdvTableTab ? extractAdvancedStyles(dom, elm) : {});
	    };
	    var extractDataFromRowElement = function (editor, elm, hasAdvancedRowTab) {
	      var dom = editor.dom;
	      return __assign({
	        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
	        class: dom.getAttrib(elm, 'class', ''),
	        type: getRowType(elm),
	        align: getHAlignment(editor, elm)
	      }, hasAdvancedRowTab ? extractAdvancedStyles(dom, elm) : {});
	    };
	    var extractDataFromCellElement = function (editor, cell, hasAdvancedCellTab, column) {
	      var dom = editor.dom;
	      var colElm = column.getOr(cell);
	      var getStyle = function (element, style) {
	        return dom.getStyle(element, style) || dom.getAttrib(element, style);
	      };
	      return __assign({
	        width: getStyle(colElm, 'width'),
	        height: getStyle(cell, 'height'),
	        scope: dom.getAttrib(cell, 'scope'),
	        celltype: getNodeName(cell),
	        class: dom.getAttrib(cell, 'class', ''),
	        halign: getHAlignment(editor, cell),
	        valign: getVAlignment(editor, cell)
	      }, hasAdvancedCellTab ? extractAdvancedStyles(dom, cell) : {});
	    };
	
	    var getSelectedCells = function (table, cells) {
	      var warehouse = Warehouse.fromTable(table);
	      var allCells = Warehouse.justCells(warehouse);
	      var filtered = filter$2(allCells, function (cellA) {
	        return exists(cells, function (cellB) {
	          return eq$1(cellA.element, cellB);
	        });
	      });
	      return map$1(filtered, function (cell) {
	        return {
	          element: cell.element.dom,
	          column: Warehouse.getColumnAt(warehouse, cell.column).map(function (col) {
	            return col.element.dom;
	          })
	        };
	      });
	    };
	    var updateSimpleProps$1 = function (modifier, colModifier, data) {
	      modifier.setAttrib('scope', data.scope);
	      modifier.setAttrib('class', data.class);
	      modifier.setStyle('height', addPxSuffix(data.height));
	      colModifier.setStyle('width', addPxSuffix(data.width));
	    };
	    var updateAdvancedProps$1 = function (modifier, data) {
	      modifier.setFormat('tablecellbackgroundcolor', data.backgroundcolor);
	      modifier.setFormat('tablecellbordercolor', data.bordercolor);
	      modifier.setFormat('tablecellborderstyle', data.borderstyle);
	      modifier.setFormat('tablecellborderwidth', addPxSuffix(data.borderwidth));
	    };
	    var applyStyleData$1 = function (editor, cells, data) {
	      var isSingleCell = cells.length === 1;
	      each$2(cells, function (item) {
	        var cellElm = item.element;
	        var modifier = isSingleCell ? DomModifier.normal(editor, cellElm) : DomModifier.ifTruthy(editor, cellElm);
	        var colModifier = item.column.map(function (col) {
	          return isSingleCell ? DomModifier.normal(editor, col) : DomModifier.ifTruthy(editor, col);
	        }).getOr(modifier);
	        updateSimpleProps$1(modifier, colModifier, data);
	        if (hasAdvancedCellTab(editor)) {
	          updateAdvancedProps$1(modifier, data);
	        }
	        if (isSingleCell) {
	          unApplyAlign(editor, cellElm);
	          unApplyVAlign(editor, cellElm);
	        }
	        if (data.halign) {
	          applyAlign(editor, cellElm, data.halign);
	        }
	        if (data.valign) {
	          applyVAlign(editor, cellElm, data.valign);
	        }
	      });
	    };
	    var applyStructureData$1 = function (editor, data) {
	      editor.execCommand('mceTableCellType', false, {
	        type: data.celltype,
	        no_events: true
	      });
	    };
	    var applyCellData = function (editor, cells, oldData, data) {
	      var modifiedData = filter$1(data, function (value, key) {
	        return oldData[key] !== value;
	      });
	      if (size(modifiedData) > 0 && cells.length >= 1) {
	        table(cells[0]).each(function (table) {
	          var selectedCells = getSelectedCells(table, cells);
	          var styleModified = size(filter$1(modifiedData, function (_value, key) {
	            return key !== 'scope' && key !== 'celltype';
	          })) > 0;
	          var structureModified = has$1(modifiedData, 'celltype');
	          if (styleModified || has$1(modifiedData, 'scope')) {
	            applyStyleData$1(editor, selectedCells, data);
	          }
	          if (structureModified) {
	            applyStructureData$1(editor, data);
	          }
	          fireTableModified(editor, table.dom, {
	            structure: structureModified,
	            style: styleModified
	          });
	        });
	      }
	    };
	    var onSubmitCellForm = function (editor, cells, oldData, api) {
	      var data = api.getData();
	      api.close();
	      editor.undoManager.transact(function () {
	        applyCellData(editor, cells, oldData, data);
	        editor.focus();
	      });
	    };
	    var getData = function (editor, cells) {
	      var cellsData = table(cells[0]).map(function (table) {
	        return map$1(getSelectedCells(table, cells), function (item) {
	          return extractDataFromCellElement(editor, item.element, hasAdvancedCellTab(editor), item.column);
	        });
	      });
	      return getSharedValues(cellsData.getOrDie());
	    };
	    var open$2 = function (editor, selections) {
	      var cells = getCellsFromSelection(selections);
	      if (cells.length === 0) {
	        return;
	      }
	      var data = getData(editor, cells);
	      var dialogTabPanel = {
	        type: 'tabpanel',
	        tabs: [
	          {
	            title: 'General',
	            name: 'general',
	            items: getItems$2(editor)
	          },
	          getAdvancedTab(editor, 'cell')
	        ]
	      };
	      var dialogPanel = {
	        type: 'panel',
	        items: [{
	            type: 'grid',
	            columns: 2,
	            items: getItems$2(editor)
	          }]
	      };
	      editor.windowManager.open({
	        title: 'Cell Properties',
	        size: 'normal',
	        body: hasAdvancedCellTab(editor) ? dialogTabPanel : dialogPanel,
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: data,
	        onSubmit: curry(onSubmitCellForm, editor, cells, data)
	      });
	    };
	
	    var getClassList = function (editor) {
	      var classes = buildListItems(getRowClassList(editor));
	      if (classes.length > 0) {
	        return Optional.some({
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          items: classes
	        });
	      }
	      return Optional.none();
	    };
	    var formChildren = [
	      {
	        type: 'listbox',
	        name: 'type',
	        label: 'Row type',
	        items: [
	          {
	            text: 'Header',
	            value: 'header'
	          },
	          {
	            text: 'Body',
	            value: 'body'
	          },
	          {
	            text: 'Footer',
	            value: 'footer'
	          }
	        ]
	      },
	      {
	        type: 'listbox',
	        name: 'align',
	        label: 'Alignment',
	        items: [
	          {
	            text: 'None',
	            value: ''
	          },
	          {
	            text: 'Left',
	            value: 'left'
	          },
	          {
	            text: 'Center',
	            value: 'center'
	          },
	          {
	            text: 'Right',
	            value: 'right'
	          }
	        ]
	      },
	      {
	        label: 'Height',
	        name: 'height',
	        type: 'input'
	      }
	    ];
	    var getItems$1 = function (editor) {
	      return formChildren.concat(getClassList(editor).toArray());
	    };
	
	    var updateSimpleProps = function (modifier, data) {
	      modifier.setAttrib('class', data.class);
	      modifier.setStyle('height', addPxSuffix(data.height));
	    };
	    var updateAdvancedProps = function (modifier, data) {
	      modifier.setStyle('background-color', data.backgroundcolor);
	      modifier.setStyle('border-color', data.bordercolor);
	      modifier.setStyle('border-style', data.borderstyle);
	    };
	    var applyStyleData = function (editor, rows, data, oldData) {
	      var isSingleRow = rows.length === 1;
	      each$2(rows, function (rowElm) {
	        var modifier = isSingleRow ? DomModifier.normal(editor, rowElm) : DomModifier.ifTruthy(editor, rowElm);
	        updateSimpleProps(modifier, data);
	        if (hasAdvancedRowTab(editor)) {
	          updateAdvancedProps(modifier, data);
	        }
	        if (data.align !== oldData.align) {
	          unApplyAlign(editor, rowElm);
	          applyAlign(editor, rowElm, data.align);
	        }
	      });
	    };
	    var applyStructureData = function (editor, data) {
	      editor.execCommand('mceTableRowType', false, {
	        type: data.type,
	        no_events: true
	      });
	    };
	    var applyRowData = function (editor, rows, oldData, data) {
	      var modifiedData = filter$1(data, function (value, key) {
	        return oldData[key] !== value;
	      });
	      if (size(modifiedData) > 0) {
	        var typeModified_1 = has$1(modifiedData, 'type');
	        var styleModified_1 = typeModified_1 ? size(modifiedData) > 1 : true;
	        if (styleModified_1) {
	          applyStyleData(editor, rows, data, oldData);
	        }
	        if (typeModified_1) {
	          applyStructureData(editor, data);
	        }
	        table(SugarElement.fromDom(rows[0])).each(function (table) {
	          return fireTableModified(editor, table.dom, {
	            structure: typeModified_1,
	            style: styleModified_1
	          });
	        });
	      }
	    };
	    var onSubmitRowForm = function (editor, rows, oldData, api) {
	      var data = api.getData();
	      api.close();
	      editor.undoManager.transact(function () {
	        applyRowData(editor, rows, oldData, data);
	        editor.focus();
	      });
	    };
	    var open$1 = function (editor) {
	      var rows = getRowsFromSelection(getSelectionStart(editor), ephemera.selected);
	      if (rows.length === 0) {
	        return;
	      }
	      var rowsData = map$1(rows, function (rowElm) {
	        return extractDataFromRowElement(editor, rowElm.dom, hasAdvancedRowTab(editor));
	      });
	      var data = getSharedValues(rowsData);
	      var dialogTabPanel = {
	        type: 'tabpanel',
	        tabs: [
	          {
	            title: 'General',
	            name: 'general',
	            items: getItems$1(editor)
	          },
	          getAdvancedTab(editor, 'row')
	        ]
	      };
	      var dialogPanel = {
	        type: 'panel',
	        items: [{
	            type: 'grid',
	            columns: 2,
	            items: getItems$1(editor)
	          }]
	      };
	      editor.windowManager.open({
	        title: 'Row Properties',
	        size: 'normal',
	        body: hasAdvancedRowTab(editor) ? dialogTabPanel : dialogPanel,
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: data,
	        onSubmit: curry(onSubmitRowForm, editor, map$1(rows, function (r) {
	          return r.dom;
	        }), data)
	      });
	    };
	
	    var getItems = function (editor, classes, insertNewTable) {
	      var rowColCountItems = !insertNewTable ? [] : [
	        {
	          type: 'input',
	          name: 'cols',
	          label: 'Cols',
	          inputMode: 'numeric'
	        },
	        {
	          type: 'input',
	          name: 'rows',
	          label: 'Rows',
	          inputMode: 'numeric'
	        }
	      ];
	      var alwaysItems = [
	        {
	          type: 'input',
	          name: 'width',
	          label: 'Width'
	        },
	        {
	          type: 'input',
	          name: 'height',
	          label: 'Height'
	        }
	      ];
	      var appearanceItems = hasAppearanceOptions(editor) ? [
	        {
	          type: 'input',
	          name: 'cellspacing',
	          label: 'Cell spacing',
	          inputMode: 'numeric'
	        },
	        {
	          type: 'input',
	          name: 'cellpadding',
	          label: 'Cell padding',
	          inputMode: 'numeric'
	        },
	        {
	          type: 'input',
	          name: 'border',
	          label: 'Border width'
	        },
	        {
	          type: 'label',
	          label: 'Caption',
	          items: [{
	              type: 'checkbox',
	              name: 'caption',
	              label: 'Show caption'
	            }]
	        }
	      ] : [];
	      var alignmentItem = [{
	          type: 'listbox',
	          name: 'align',
	          label: 'Alignment',
	          items: [
	            {
	              text: 'None',
	              value: ''
	            },
	            {
	              text: 'Left',
	              value: 'left'
	            },
	            {
	              text: 'Center',
	              value: 'center'
	            },
	            {
	              text: 'Right',
	              value: 'right'
	            }
	          ]
	        }];
	      var classListItem = classes.length > 0 ? [{
	          type: 'listbox',
	          name: 'class',
	          label: 'Class',
	          items: classes
	        }] : [];
	      return rowColCountItems.concat(alwaysItems).concat(appearanceItems).concat(alignmentItem).concat(classListItem);
	    };
	
	    var styleTDTH = function (dom, elm, name, value) {
	      if (elm.tagName === 'TD' || elm.tagName === 'TH') {
	        if (isString(name)) {
	          dom.setStyle(elm, name, value);
	        } else {
	          dom.setStyle(elm, name);
	        }
	      } else {
	        if (elm.children) {
	          for (var i = 0; i < elm.children.length; i++) {
	            styleTDTH(dom, elm.children[i], name, value);
	          }
	        }
	      }
	    };
	    var applyDataToElement = function (editor, tableElm, data) {
	      var dom = editor.dom;
	      var attrs = {};
	      var styles = {};
	      attrs.class = data.class;
	      styles.height = addPxSuffix(data.height);
	      if (dom.getAttrib(tableElm, 'width') && !shouldStyleWithCss(editor)) {
	        attrs.width = removePxSuffix(data.width);
	      } else {
	        styles.width = addPxSuffix(data.width);
	      }
	      if (shouldStyleWithCss(editor)) {
	        styles['border-width'] = addPxSuffix(data.border);
	        styles['border-spacing'] = addPxSuffix(data.cellspacing);
	      } else {
	        attrs.border = data.border;
	        attrs.cellpadding = data.cellpadding;
	        attrs.cellspacing = data.cellspacing;
	      }
	      if (shouldStyleWithCss(editor) && tableElm.children) {
	        for (var i = 0; i < tableElm.children.length; i++) {
	          styleTDTH(dom, tableElm.children[i], {
	            'border-width': addPxSuffix(data.border),
	            'padding': addPxSuffix(data.cellpadding)
	          });
	          if (hasAdvancedTableTab(editor)) {
	            styleTDTH(dom, tableElm.children[i], { 'border-color': data.bordercolor });
	          }
	        }
	      }
	      if (hasAdvancedTableTab(editor)) {
	        styles['background-color'] = data.backgroundcolor;
	        styles['border-color'] = data.bordercolor;
	        styles['border-style'] = data.borderstyle;
	      }
	      attrs.style = dom.serializeStyle(__assign(__assign({}, getDefaultStyles(editor)), styles));
	      dom.setAttribs(tableElm, __assign(__assign({}, getDefaultAttributes(editor)), attrs));
	    };
	    var onSubmitTableForm = function (editor, tableElm, oldData, api) {
	      var dom = editor.dom;
	      var data = api.getData();
	      var modifiedData = filter$1(data, function (value, key) {
	        return oldData[key] !== value;
	      });
	      api.close();
	      if (data.class === '') {
	        delete data.class;
	      }
	      editor.undoManager.transact(function () {
	        if (!tableElm) {
	          var cols = parseInt(data.cols, 10) || 1;
	          var rows = parseInt(data.rows, 10) || 1;
	          tableElm = insert(editor, cols, rows, 0, 0);
	        }
	        if (size(modifiedData) > 0) {
	          applyDataToElement(editor, tableElm, data);
	          var captionElm = dom.select('caption', tableElm)[0];
	          if (captionElm && !data.caption || !captionElm && data.caption) {
	            editor.execCommand('mceTableToggleCaption');
	          }
	          if (data.align === '') {
	            unApplyAlign(editor, tableElm);
	          } else {
	            applyAlign(editor, tableElm, data.align);
	          }
	        }
	        editor.focus();
	        editor.addVisual();
	        if (size(modifiedData) > 0) {
	          var captionModified = has$1(modifiedData, 'caption');
	          var styleModified = captionModified ? size(modifiedData) > 1 : true;
	          fireTableModified(editor, tableElm, {
	            structure: captionModified,
	            style: styleModified
	          });
	        }
	      });
	    };
	    var open = function (editor, insertNewTable) {
	      var dom = editor.dom;
	      var tableElm;
	      var data = extractDataFromSettings(editor, hasAdvancedTableTab(editor));
	      if (insertNewTable === false) {
	        tableElm = dom.getParent(editor.selection.getStart(), 'table', editor.getBody());
	        if (tableElm) {
	          data = extractDataFromTableElement(editor, tableElm, hasAdvancedTableTab(editor));
	        } else {
	          if (hasAdvancedTableTab(editor)) {
	            data.borderstyle = '';
	            data.bordercolor = '';
	            data.backgroundcolor = '';
	          }
	        }
	      } else {
	        data.cols = '1';
	        data.rows = '1';
	        if (hasAdvancedTableTab(editor)) {
	          data.borderstyle = '';
	          data.bordercolor = '';
	          data.backgroundcolor = '';
	        }
	      }
	      var classes = buildListItems(getTableClassList(editor));
	      if (classes.length > 0) {
	        if (data.class) {
	          data.class = data.class.replace(/\s*mce\-item\-table\s*/g, '');
	        }
	      }
	      var generalPanel = {
	        type: 'grid',
	        columns: 2,
	        items: getItems(editor, classes, insertNewTable)
	      };
	      var nonAdvancedForm = function () {
	        return {
	          type: 'panel',
	          items: [generalPanel]
	        };
	      };
	      var advancedForm = function () {
	        return {
	          type: 'tabpanel',
	          tabs: [
	            {
	              title: 'General',
	              name: 'general',
	              items: [generalPanel]
	            },
	            getAdvancedTab(editor, 'table')
	          ]
	        };
	      };
	      var dialogBody = hasAdvancedTableTab(editor) ? advancedForm() : nonAdvancedForm();
	      editor.windowManager.open({
	        title: 'Table Properties',
	        size: 'normal',
	        body: dialogBody,
	        onSubmit: curry(onSubmitTableForm, editor, tableElm, data),
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: data
	      });
	    };
	
	    var getSelectionStartCellOrCaption = function (editor) {
	      return getSelectionCellOrCaption(getSelectionStart(editor), getIsRoot(editor));
	    };
	    var getSelectionStartCell = function (editor) {
	      return getSelectionCell(getSelectionStart(editor), getIsRoot(editor));
	    };
	    var registerCommands = function (editor, actions, cellSelection, selections, clipboard) {
	      var isRoot = getIsRoot(editor);
	      var eraseTable = function () {
	        return getSelectionStartCellOrCaption(editor).each(function (cellOrCaption) {
	          table(cellOrCaption, isRoot).filter(not(isRoot)).each(function (table) {
	            var cursor = SugarElement.fromText('');
	            after$5(table, cursor);
	            remove$5(table);
	            if (editor.dom.isEmpty(editor.getBody())) {
	              editor.setContent('');
	              editor.selection.setCursorLocation();
	            } else {
	              var rng = editor.dom.createRng();
	              rng.setStart(cursor.dom, 0);
	              rng.setEnd(cursor.dom, 0);
	              editor.selection.setRng(rng);
	              editor.nodeChanged();
	            }
	          });
	        });
	      };
	      var setSizingMode = function (sizing) {
	        return getSelectionStartCellOrCaption(editor).each(function (cellOrCaption) {
	          var isForcedSizing = isResponsiveForced(editor) || isPixelsForced(editor) || isPercentagesForced(editor);
	          if (!isForcedSizing) {
	            table(cellOrCaption, isRoot).each(function (table) {
	              if (sizing === 'relative' && !isPercentSizing(table)) {
	                enforcePercentage(table);
	              } else if (sizing === 'fixed' && !isPixelSizing(table)) {
	                enforcePixels(table);
	              } else if (sizing === 'responsive' && !isNoneSizing(table)) {
	                enforceNone(table);
	              }
	              removeDataStyle(table);
	              fireTableModified(editor, table.dom, structureModified);
	            });
	          }
	        });
	      };
	      var getTableFromCell = function (cell) {
	        return table(cell, isRoot);
	      };
	      var performActionOnSelection = function (action) {
	        return getSelectionStartCell(editor).bind(function (cell) {
	          return getTableFromCell(cell).map(function (table) {
	            return action(table, cell);
	          });
	        });
	      };
	      var toggleTableClass = function (_ui, clazz) {
	        performActionOnSelection(function (table) {
	          editor.formatter.toggle('tableclass', { value: clazz }, table.dom);
	          fireTableModified(editor, table.dom, styleModified);
	        });
	      };
	      var toggleTableCellClass = function (_ui, clazz) {
	        performActionOnSelection(function (table) {
	          var selectedCells = getCellsFromSelection(selections);
	          var allHaveClass = forall(selectedCells, function (cell) {
	            return editor.formatter.match('tablecellclass', { value: clazz }, cell.dom);
	          });
	          var formatterAction = allHaveClass ? editor.formatter.remove : editor.formatter.apply;
	          each$2(selectedCells, function (cell) {
	            return formatterAction('tablecellclass', { value: clazz }, cell.dom);
	          });
	          fireTableModified(editor, table.dom, styleModified);
	        });
	      };
	      var toggleCaption = function () {
	        getSelectionStartCellOrCaption(editor).each(function (cellOrCaption) {
	          table(cellOrCaption, isRoot).each(function (table) {
	            child$1(table, 'caption').fold(function () {
	              var caption = SugarElement.fromTag('caption');
	              append$1(caption, SugarElement.fromText('Caption'));
	              appendAt(table, caption, 0);
	              editor.selection.setCursorLocation(caption.dom, 0);
	            }, function (caption) {
	              if (isTag('caption')(cellOrCaption)) {
	                one('td', table).each(function (td) {
	                  return editor.selection.setCursorLocation(td.dom, 0);
	                });
	              }
	              remove$5(caption);
	            });
	            fireTableModified(editor, table.dom, structureModified);
	          });
	        });
	      };
	      var postExecute = function (_data) {
	        editor.focus();
	      };
	      var actOnSelection = function (execute, noEvents) {
	        if (noEvents === void 0) {
	          noEvents = false;
	        }
	        return performActionOnSelection(function (table, startCell) {
	          var targets = forMenu(selections, table, startCell);
	          execute(table, targets, noEvents).each(postExecute);
	        });
	      };
	      var copyRowSelection = function () {
	        return performActionOnSelection(function (table, startCell) {
	          var targets = forMenu(selections, table, startCell);
	          var generators = cellOperations(noop, SugarElement.fromDom(editor.getDoc()), Optional.none());
	          return copyRows(table, targets, generators);
	        });
	      };
	      var copyColSelection = function () {
	        return performActionOnSelection(function (table, startCell) {
	          var targets = forMenu(selections, table, startCell);
	          return copyCols(table, targets);
	        });
	      };
	      var pasteOnSelection = function (execute, getRows) {
	        return getRows().each(function (rows) {
	          var clonedRows = map$1(rows, function (row) {
	            return deep(row);
	          });
	          performActionOnSelection(function (table, startCell) {
	            var generators = paste$1(SugarElement.fromDom(editor.getDoc()));
	            var targets = pasteRows(selections, startCell, clonedRows, generators);
	            execute(table, targets).each(postExecute);
	          });
	        });
	      };
	      var actOnType = function (getAction) {
	        return function (_ui, args) {
	          return get$c(args, 'type').each(function (type) {
	            actOnSelection(getAction(type), args.no_events);
	          });
	        };
	      };
	      each$1({
	        mceTableSplitCells: function () {
	          return actOnSelection(actions.unmergeCells);
	        },
	        mceTableMergeCells: function () {
	          return actOnSelection(actions.mergeCells);
	        },
	        mceTableInsertRowBefore: function () {
	          return actOnSelection(actions.insertRowsBefore);
	        },
	        mceTableInsertRowAfter: function () {
	          return actOnSelection(actions.insertRowsAfter);
	        },
	        mceTableInsertColBefore: function () {
	          return actOnSelection(actions.insertColumnsBefore);
	        },
	        mceTableInsertColAfter: function () {
	          return actOnSelection(actions.insertColumnsAfter);
	        },
	        mceTableDeleteCol: function () {
	          return actOnSelection(actions.deleteColumn);
	        },
	        mceTableDeleteRow: function () {
	          return actOnSelection(actions.deleteRow);
	        },
	        mceTableCutCol: function () {
	          return copyColSelection().each(function (selection) {
	            clipboard.setColumns(selection);
	            actOnSelection(actions.deleteColumn);
	          });
	        },
	        mceTableCutRow: function () {
	          return copyRowSelection().each(function (selection) {
	            clipboard.setRows(selection);
	            actOnSelection(actions.deleteRow);
	          });
	        },
	        mceTableCopyCol: function () {
	          return copyColSelection().each(function (selection) {
	            return clipboard.setColumns(selection);
	          });
	        },
	        mceTableCopyRow: function () {
	          return copyRowSelection().each(function (selection) {
	            return clipboard.setRows(selection);
	          });
	        },
	        mceTablePasteColBefore: function () {
	          return pasteOnSelection(actions.pasteColsBefore, clipboard.getColumns);
	        },
	        mceTablePasteColAfter: function () {
	          return pasteOnSelection(actions.pasteColsAfter, clipboard.getColumns);
	        },
	        mceTablePasteRowBefore: function () {
	          return pasteOnSelection(actions.pasteRowsBefore, clipboard.getRows);
	        },
	        mceTablePasteRowAfter: function () {
	          return pasteOnSelection(actions.pasteRowsAfter, clipboard.getRows);
	        },
	        mceTableDelete: eraseTable,
	        mceTableCellToggleClass: toggleTableCellClass,
	        mceTableToggleClass: toggleTableClass,
	        mceTableToggleCaption: toggleCaption,
	        mceTableSizingMode: function (_ui, sizing) {
	          return setSizingMode(sizing);
	        },
	        mceTableCellType: actOnType(function (type) {
	          return type === 'th' ? actions.makeCellsHeader : actions.unmakeCellsHeader;
	        }),
	        mceTableColType: actOnType(function (type) {
	          return type === 'th' ? actions.makeColumnsHeader : actions.unmakeColumnsHeader;
	        }),
	        mceTableRowType: actOnType(function (type) {
	          switch (type) {
	          case 'header':
	            return actions.makeRowsHeader;
	          case 'footer':
	            return actions.makeRowsFooter;
	          default:
	            return actions.makeRowsBody;
	          }
	        })
	      }, function (func, name) {
	        return editor.addCommand(name, func);
	      });
	      each$1({
	        mceTableProps: curry(open, editor, false),
	        mceTableRowProps: curry(open$1, editor),
	        mceTableCellProps: curry(open$2, editor, selections)
	      }, function (func, name) {
	        return editor.addCommand(name, function () {
	          return func();
	        });
	      });
	      editor.addCommand('mceInsertTable', function (_ui, args) {
	        if (isObject(args) && keys(args).length > 0) {
	          insertTableWithDataValidation(editor, args.rows, args.columns, args.options, 'Invalid values for mceInsertTable - rows and columns values are required to insert a table.');
	        } else {
	          open(editor, true);
	        }
	      });
	      editor.addCommand('mceTableApplyCellStyle', function (_ui, args) {
	        var getFormatName = function (style) {
	          return 'tablecell' + style.toLowerCase().replace('-', '');
	        };
	        if (!isObject(args)) {
	          return;
	        }
	        var cells = getCellsFromSelection(selections);
	        if (cells.length === 0) {
	          return;
	        }
	        var validArgs = filter$1(args, function (value, style) {
	          return editor.formatter.has(getFormatName(style)) && isString(value);
	        });
	        if (isEmpty(validArgs)) {
	          return;
	        }
	        each$1(validArgs, function (value, style) {
	          each$2(cells, function (cell) {
	            DomModifier.normal(editor, cell.dom).setFormat(getFormatName(style), value);
	          });
	        });
	        getTableFromCell(cells[0]).each(function (table) {
	          return fireTableModified(editor, table.dom, styleModified);
	        });
	      });
	    };
	
	    var registerQueryCommands = function (editor, actions, selections) {
	      var isRoot = getIsRoot(editor);
	      var lookupOnSelection = function (action) {
	        return getSelectionCell(getSelectionStart(editor)).bind(function (cell) {
	          return table(cell, isRoot).map(function (table) {
	            var targets = forMenu(selections, table, cell);
	            return action(table, targets);
	          });
	        }).getOr('');
	      };
	      each$1({
	        mceTableRowType: function () {
	          return lookupOnSelection(actions.getTableRowType);
	        },
	        mceTableCellType: function () {
	          return lookupOnSelection(actions.getTableCellType);
	        },
	        mceTableColType: function () {
	          return lookupOnSelection(actions.getTableColType);
	        }
	      }, function (func, name) {
	        return editor.addQueryValueHandler(name, func);
	      });
	    };
	
	    var Clipboard = function () {
	      var rows = value();
	      var cols = value();
	      return {
	        getRows: rows.get,
	        setRows: function (r) {
	          r.fold(rows.clear, rows.set);
	          cols.clear();
	        },
	        clearRows: rows.clear,
	        getColumns: cols.get,
	        setColumns: function (c) {
	          c.fold(cols.clear, cols.set);
	          rows.clear();
	        },
	        clearColumns: cols.clear
	      };
	    };
	
	    var genericBase = {
	      remove_similar: true,
	      inherit: false
	    };
	    var cellBase = __assign({ selector: 'td,th' }, genericBase);
	    var cellFormats = {
	      tablecellbackgroundcolor: __assign({ styles: { backgroundColor: '%value' } }, cellBase),
	      tablecellverticalalign: __assign({ styles: { 'vertical-align': '%value' } }, cellBase),
	      tablecellbordercolor: __assign({ styles: { borderColor: '%value' } }, cellBase),
	      tablecellclass: __assign({ classes: ['%value'] }, cellBase),
	      tableclass: __assign({
	        selector: 'table',
	        classes: ['%value']
	      }, genericBase),
	      tablecellborderstyle: __assign({ styles: { borderStyle: '%value' } }, cellBase),
	      tablecellborderwidth: __assign({ styles: { borderWidth: '%value' } }, cellBase)
	    };
	    var registerFormats = function (editor) {
	      editor.formatter.register(cellFormats);
	    };
	
	    var adt$5 = Adt.generate([
	      { none: ['current'] },
	      { first: ['current'] },
	      {
	        middle: [
	          'current',
	          'target'
	        ]
	      },
	      { last: ['current'] }
	    ]);
	    var none = function (current) {
	      if (current === void 0) {
	        current = undefined;
	      }
	      return adt$5.none(current);
	    };
	    var CellLocation = __assign(__assign({}, adt$5), { none: none });
	
	    var walk = function (all, current, index, direction, isEligible) {
	      if (isEligible === void 0) {
	        isEligible = always;
	      }
	      var forwards = direction === 1;
	      if (!forwards && index <= 0) {
	        return CellLocation.first(all[0]);
	      } else if (forwards && index >= all.length - 1) {
	        return CellLocation.last(all[all.length - 1]);
	      } else {
	        var newIndex = index + direction;
	        var elem = all[newIndex];
	        return isEligible(elem) ? CellLocation.middle(current, elem) : walk(all, current, newIndex, direction, isEligible);
	      }
	    };
	    var detect$1 = function (current, isRoot) {
	      return table(current, isRoot).bind(function (table) {
	        var all = cells$1(table);
	        var index = findIndex(all, function (x) {
	          return eq$1(current, x);
	        });
	        return index.map(function (index) {
	          return {
	            index: index,
	            all: all
	          };
	        });
	      });
	    };
	    var next = function (current, isEligible, isRoot) {
	      var detection = detect$1(current, isRoot);
	      return detection.fold(function () {
	        return CellLocation.none(current);
	      }, function (info) {
	        return walk(info.all, current, info.index, 1, isEligible);
	      });
	    };
	    var prev = function (current, isEligible, isRoot) {
	      var detection = detect$1(current, isRoot);
	      return detection.fold(function () {
	        return CellLocation.none();
	      }, function (info) {
	        return walk(info.all, current, info.index, -1, isEligible);
	      });
	    };
	
	    var create$2 = function (start, soffset, finish, foffset) {
	      return {
	        start: start,
	        soffset: soffset,
	        finish: finish,
	        foffset: foffset
	      };
	    };
	    var SimRange = { create: create$2 };
	
	    var adt$4 = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata$1 = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart$1 = function (situ) {
	      return situ.fold(identity, identity, identity);
	    };
	    var before$2 = adt$4.before;
	    var on = adt$4.on;
	    var after$3 = adt$4.after;
	    var Situ = {
	      before: before$2,
	      on: on,
	      after: after$3,
	      cata: cata$1,
	      getStart: getStart$1
	    };
	
	    var adt$3 = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt$3.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
	    };
	    var getStart = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return SugarElement.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, _finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, _soffset, _finish, _foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt$3.domRange;
	    var relative = adt$3.relative;
	    var exact = adt$3.exact;
	    var getWin = function (selection) {
	      var start = getStart(selection);
	      return defaultView(start);
	    };
	    var range = SimRange.create;
	    var SimSelection = {
	      domRange: domRange,
	      relative: relative,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range
	    };
	
	    var selectNode = function (win, element) {
	      var rng = win.document.createRange();
	      rng.selectNode(element.dom);
	      return rng;
	    };
	    var selectNodeContents = function (win, element) {
	      var rng = win.document.createRange();
	      selectNodeContentsUsing(rng, element);
	      return rng;
	    };
	    var selectNodeContentsUsing = function (rng, element) {
	      return rng.selectNodeContents(element.dom);
	    };
	    var setStart = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setStartBefore(e.dom);
	      }, function (e, o) {
	        rng.setStart(e.dom, o);
	      }, function (e) {
	        rng.setStartAfter(e.dom);
	      });
	    };
	    var setFinish = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setEndBefore(e.dom);
	      }, function (e, o) {
	        rng.setEnd(e.dom, o);
	      }, function (e) {
	        rng.setEndAfter(e.dom);
	      });
	    };
	    var relativeToNative = function (win, startSitu, finishSitu) {
	      var range = win.document.createRange();
	      setStart(range, startSitu);
	      setFinish(range, finishSitu);
	      return range;
	    };
	    var exactToNative = function (win, start, soffset, finish, foffset) {
	      var rng = win.document.createRange();
	      rng.setStart(start.dom, soffset);
	      rng.setEnd(finish.dom, foffset);
	      return rng;
	    };
	    var toRect = function (rect) {
	      return {
	        left: rect.left,
	        top: rect.top,
	        right: rect.right,
	        bottom: rect.bottom,
	        width: rect.width,
	        height: rect.height
	      };
	    };
	    var getFirstRect$1 = function (rng) {
	      var rects = rng.getClientRects();
	      var rect = rects.length > 0 ? rects[0] : rng.getBoundingClientRect();
	      return rect.width > 0 || rect.height > 0 ? Optional.some(rect).map(toRect) : Optional.none();
	    };
	
	    var adt$2 = Adt.generate([
	      {
	        ltr: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      },
	      {
	        rtl: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var fromRange = function (win, type, range) {
	      return type(SugarElement.fromDom(range.startContainer), range.startOffset, SugarElement.fromDom(range.endContainer), range.endOffset);
	    };
	    var getRanges = function (win, selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return {
	            ltr: constant(rng),
	            rtl: Optional.none
	          };
	        },
	        relative: function (startSitu, finishSitu) {
	          return {
	            ltr: cached(function () {
	              return relativeToNative(win, startSitu, finishSitu);
	            }),
	            rtl: cached(function () {
	              return Optional.some(relativeToNative(win, finishSitu, startSitu));
	            })
	          };
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return {
	            ltr: cached(function () {
	              return exactToNative(win, start, soffset, finish, foffset);
	            }),
	            rtl: cached(function () {
	              return Optional.some(exactToNative(win, finish, foffset, start, soffset));
	            })
	          };
	        }
	      });
	    };
	    var doDiagnose = function (win, ranges) {
	      var rng = ranges.ltr();
	      if (rng.collapsed) {
	        var reversed = ranges.rtl().filter(function (rev) {
	          return rev.collapsed === false;
	        });
	        return reversed.map(function (rev) {
	          return adt$2.rtl(SugarElement.fromDom(rev.endContainer), rev.endOffset, SugarElement.fromDom(rev.startContainer), rev.startOffset);
	        }).getOrThunk(function () {
	          return fromRange(win, adt$2.ltr, rng);
	        });
	      } else {
	        return fromRange(win, adt$2.ltr, rng);
	      }
	    };
	    var diagnose = function (win, selection) {
	      var ranges = getRanges(win, selection);
	      return doDiagnose(win, ranges);
	    };
	    var asLtrRange = function (win, selection) {
	      var diagnosis = diagnose(win, selection);
	      return diagnosis.match({
	        ltr: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(start.dom, soffset);
	          rng.setEnd(finish.dom, foffset);
	          return rng;
	        },
	        rtl: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(finish.dom, foffset);
	          rng.setEnd(start.dom, soffset);
	          return rng;
	        }
	      });
	    };
	    adt$2.ltr;
	    adt$2.rtl;
	
	    var searchForPoint = function (rectForOffset, x, y, maxX, length) {
	      if (length === 0) {
	        return 0;
	      } else if (x === maxX) {
	        return length - 1;
	      }
	      var xDelta = maxX;
	      for (var i = 1; i < length; i++) {
	        var rect = rectForOffset(i);
	        var curDeltaX = Math.abs(x - rect.left);
	        if (y <= rect.bottom) {
	          if (y < rect.top || curDeltaX > xDelta) {
	            return i - 1;
	          } else {
	            xDelta = curDeltaX;
	          }
	        }
	      }
	      return 0;
	    };
	    var inRect = function (rect, x, y) {
	      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
	    };
	
	    var locateOffset = function (doc, textnode, x, y, rect) {
	      var rangeForOffset = function (o) {
	        var r = doc.dom.createRange();
	        r.setStart(textnode.dom, o);
	        r.collapse(true);
	        return r;
	      };
	      var rectForOffset = function (o) {
	        var r = rangeForOffset(o);
	        return r.getBoundingClientRect();
	      };
	      var length = get$9(textnode).length;
	      var offset = searchForPoint(rectForOffset, x, y, rect.right, length);
	      return rangeForOffset(offset);
	    };
	    var locate$1 = function (doc, node, x, y) {
	      var r = doc.dom.createRange();
	      r.selectNode(node.dom);
	      var rects = r.getClientRects();
	      var foundRect = findMap(rects, function (rect) {
	        return inRect(rect, x, y) ? Optional.some(rect) : Optional.none();
	      });
	      return foundRect.map(function (rect) {
	        return locateOffset(doc, node, x, y, rect);
	      });
	    };
	
	    var searchInChildren = function (doc, node, x, y) {
	      var r = doc.dom.createRange();
	      var nodes = children$3(node);
	      return findMap(nodes, function (n) {
	        r.selectNode(n.dom);
	        return inRect(r.getBoundingClientRect(), x, y) ? locateNode(doc, n, x, y) : Optional.none();
	      });
	    };
	    var locateNode = function (doc, node, x, y) {
	      return isText(node) ? locate$1(doc, node, x, y) : searchInChildren(doc, node, x, y);
	    };
	    var locate = function (doc, node, x, y) {
	      var r = doc.dom.createRange();
	      r.selectNode(node.dom);
	      var rect = r.getBoundingClientRect();
	      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
	      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
	      return locateNode(doc, node, boundedX, boundedY);
	    };
	
	    var COLLAPSE_TO_LEFT = true;
	    var COLLAPSE_TO_RIGHT = false;
	    var getCollapseDirection = function (rect, x) {
	      return x - rect.left < rect.right - x ? COLLAPSE_TO_LEFT : COLLAPSE_TO_RIGHT;
	    };
	    var createCollapsedNode = function (doc, target, collapseDirection) {
	      var r = doc.dom.createRange();
	      r.selectNode(target.dom);
	      r.collapse(collapseDirection);
	      return r;
	    };
	    var locateInElement = function (doc, node, x) {
	      var cursorRange = doc.dom.createRange();
	      cursorRange.selectNode(node.dom);
	      var rect = cursorRange.getBoundingClientRect();
	      var collapseDirection = getCollapseDirection(rect, x);
	      var f = collapseDirection === COLLAPSE_TO_LEFT ? first : last$1;
	      return f(node).map(function (target) {
	        return createCollapsedNode(doc, target, collapseDirection);
	      });
	    };
	    var locateInEmpty = function (doc, node, x) {
	      var rect = node.dom.getBoundingClientRect();
	      var collapseDirection = getCollapseDirection(rect, x);
	      return Optional.some(createCollapsedNode(doc, node, collapseDirection));
	    };
	    var search = function (doc, node, x) {
	      var f = children$3(node).length === 0 ? locateInEmpty : locateInElement;
	      return f(doc, node, x);
	    };
	
	    var caretPositionFromPoint = function (doc, x, y) {
	      var _a, _b;
	      return Optional.from((_b = (_a = doc.dom).caretPositionFromPoint) === null || _b === void 0 ? void 0 : _b.call(_a, x, y)).bind(function (pos) {
	        if (pos.offsetNode === null) {
	          return Optional.none();
	        }
	        var r = doc.dom.createRange();
	        r.setStart(pos.offsetNode, pos.offset);
	        r.collapse();
	        return Optional.some(r);
	      });
	    };
	    var caretRangeFromPoint = function (doc, x, y) {
	      var _a, _b;
	      return Optional.from((_b = (_a = doc.dom).caretRangeFromPoint) === null || _b === void 0 ? void 0 : _b.call(_a, x, y));
	    };
	    var searchTextNodes = function (doc, node, x, y) {
	      var r = doc.dom.createRange();
	      r.selectNode(node.dom);
	      var rect = r.getBoundingClientRect();
	      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
	      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
	      return locate(doc, node, boundedX, boundedY);
	    };
	    var searchFromPoint = function (doc, x, y) {
	      return SugarElement.fromPoint(doc, x, y).bind(function (elem) {
	        var fallback = function () {
	          return search(doc, elem, x);
	        };
	        return children$3(elem).length === 0 ? fallback() : searchTextNodes(doc, elem, x, y).orThunk(fallback);
	      });
	    };
	    var availableSearch = function () {
	      if (document.caretPositionFromPoint) {
	        return caretPositionFromPoint;
	      } else if (document.caretRangeFromPoint) {
	        return caretRangeFromPoint;
	      } else {
	        return searchFromPoint;
	      }
	    }();
	    var fromPoint = function (win, x, y) {
	      var doc = SugarElement.fromDom(win.document);
	      return availableSearch(doc, x, y).map(function (rng) {
	        return SimRange.create(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset);
	      });
	    };
	
	    var beforeSpecial = function (element, offset) {
	      var name$1 = name(element);
	      if ('input' === name$1) {
	        return Situ.after(element);
	      } else if (!contains$2([
	          'br',
	          'img'
	        ], name$1)) {
	        return Situ.on(element, offset);
	      } else {
	        return offset === 0 ? Situ.before(element) : Situ.after(element);
	      }
	    };
	    var preprocessRelative = function (startSitu, finishSitu) {
	      var start = startSitu.fold(Situ.before, beforeSpecial, Situ.after);
	      var finish = finishSitu.fold(Situ.before, beforeSpecial, Situ.after);
	      return SimSelection.relative(start, finish);
	    };
	    var preprocessExact = function (start, soffset, finish, foffset) {
	      var startSitu = beforeSpecial(start, soffset);
	      var finishSitu = beforeSpecial(finish, foffset);
	      return SimSelection.relative(startSitu, finishSitu);
	    };
	    var preprocess = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          var start = SugarElement.fromDom(rng.startContainer);
	          var finish = SugarElement.fromDom(rng.endContainer);
	          return preprocessExact(start, rng.startOffset, finish, rng.endOffset);
	        },
	        relative: preprocessRelative,
	        exact: preprocessExact
	      });
	    };
	
	    var makeRange = function (start, soffset, finish, foffset) {
	      var doc = owner(start);
	      var rng = doc.dom.createRange();
	      rng.setStart(start.dom, soffset);
	      rng.setEnd(finish.dom, foffset);
	      return rng;
	    };
	    var after$2 = function (start, soffset, finish, foffset) {
	      var r = makeRange(start, soffset, finish, foffset);
	      var same = eq$1(start, finish) && soffset === foffset;
	      return r.collapsed && !same;
	    };
	
	    var getNativeSelection = function (win) {
	      return Optional.from(win.getSelection());
	    };
	    var doSetNativeRange = function (win, rng) {
	      getNativeSelection(win).each(function (selection) {
	        selection.removeAllRanges();
	        selection.addRange(rng);
	      });
	    };
	    var doSetRange = function (win, start, soffset, finish, foffset) {
	      var rng = exactToNative(win, start, soffset, finish, foffset);
	      doSetNativeRange(win, rng);
	    };
	    var setLegacyRtlRange = function (win, selection, start, soffset, finish, foffset) {
	      selection.collapse(start.dom, soffset);
	      selection.extend(finish.dom, foffset);
	    };
	    var setRangeFromRelative = function (win, relative) {
	      return diagnose(win, relative).match({
	        ltr: function (start, soffset, finish, foffset) {
	          doSetRange(win, start, soffset, finish, foffset);
	        },
	        rtl: function (start, soffset, finish, foffset) {
	          getNativeSelection(win).each(function (selection) {
	            if (selection.setBaseAndExtent) {
	              selection.setBaseAndExtent(start.dom, soffset, finish.dom, foffset);
	            } else if (selection.extend) {
	              try {
	                setLegacyRtlRange(win, selection, start, soffset, finish, foffset);
	              } catch (e) {
	                doSetRange(win, finish, foffset, start, soffset);
	              }
	            } else {
	              doSetRange(win, finish, foffset, start, soffset);
	            }
	          });
	        }
	      });
	    };
	    var setExact = function (win, start, soffset, finish, foffset) {
	      var relative = preprocessExact(start, soffset, finish, foffset);
	      setRangeFromRelative(win, relative);
	    };
	    var setRelative = function (win, startSitu, finishSitu) {
	      var relative = preprocessRelative(startSitu, finishSitu);
	      setRangeFromRelative(win, relative);
	    };
	    var toNative = function (selection) {
	      var win = SimSelection.getWin(selection).dom;
	      var getDomRange = function (start, soffset, finish, foffset) {
	        return exactToNative(win, start, soffset, finish, foffset);
	      };
	      var filtered = preprocess(selection);
	      return diagnose(win, filtered).match({
	        ltr: getDomRange,
	        rtl: getDomRange
	      });
	    };
	    var readRange = function (selection) {
	      if (selection.rangeCount > 0) {
	        var firstRng = selection.getRangeAt(0);
	        var lastRng = selection.getRangeAt(selection.rangeCount - 1);
	        return Optional.some(SimRange.create(SugarElement.fromDom(firstRng.startContainer), firstRng.startOffset, SugarElement.fromDom(lastRng.endContainer), lastRng.endOffset));
	      } else {
	        return Optional.none();
	      }
	    };
	    var doGetExact = function (selection) {
	      if (selection.anchorNode === null || selection.focusNode === null) {
	        return readRange(selection);
	      } else {
	        var anchor = SugarElement.fromDom(selection.anchorNode);
	        var focus_1 = SugarElement.fromDom(selection.focusNode);
	        return after$2(anchor, selection.anchorOffset, focus_1, selection.focusOffset) ? Optional.some(SimRange.create(anchor, selection.anchorOffset, focus_1, selection.focusOffset)) : readRange(selection);
	      }
	    };
	    var setToElement = function (win, element, selectNodeContents$1) {
	      if (selectNodeContents$1 === void 0) {
	        selectNodeContents$1 = true;
	      }
	      var rngGetter = selectNodeContents$1 ? selectNodeContents : selectNode;
	      var rng = rngGetter(win, element);
	      doSetNativeRange(win, rng);
	    };
	    var getExact = function (win) {
	      return getNativeSelection(win).filter(function (sel) {
	        return sel.rangeCount > 0;
	      }).bind(doGetExact);
	    };
	    var get$1 = function (win) {
	      return getExact(win).map(function (range) {
	        return SimSelection.exact(range.start, range.soffset, range.finish, range.foffset);
	      });
	    };
	    var getFirstRect = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return getFirstRect$1(rng);
	    };
	    var getAtPoint = function (win, x, y) {
	      return fromPoint(win, x, y);
	    };
	    var clear = function (win) {
	      getNativeSelection(win).each(function (selection) {
	        return selection.removeAllRanges();
	      });
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var forward = function (editor, isRoot, cell) {
	      return go$1(editor, isRoot, next(cell, isEditable$1));
	    };
	    var backward = function (editor, isRoot, cell) {
	      return go$1(editor, isRoot, prev(cell, isEditable$1));
	    };
	    var getCellFirstCursorPosition = function (editor, cell) {
	      var selection = SimSelection.exact(cell, 0, cell, 0);
	      return toNative(selection);
	    };
	    var go$1 = function (editor, isRoot, cell) {
	      return cell.fold(Optional.none, Optional.none, function (current, next) {
	        return first(next).map(function (cell) {
	          return getCellFirstCursorPosition(editor, cell);
	        });
	      }, function (current) {
	        editor.execCommand('mceTableInsertRowAfter');
	        return forward(editor, isRoot, current);
	      });
	    };
	    var rootElements = [
	      'table',
	      'li',
	      'dl'
	    ];
	    var handle$1 = function (event, editor, cellSelection) {
	      if (event.keyCode === global$1.TAB) {
	        var body_1 = getBody(editor);
	        var isRoot_1 = function (element) {
	          var name$1 = name(element);
	          return eq$1(element, body_1) || contains$2(rootElements, name$1);
	        };
	        var rng = editor.selection.getRng();
	        var container = SugarElement.fromDom(event.shiftKey ? rng.startContainer : rng.endContainer);
	        cell(container, isRoot_1).each(function (cell) {
	          event.preventDefault();
	          table(cell, isRoot_1).each(cellSelection.clear);
	          editor.selection.collapse(event.shiftKey);
	          var navigation = event.shiftKey ? backward : forward;
	          var rng = navigation(editor, isRoot_1, cell);
	          rng.each(function (range) {
	            editor.selection.setRng(range);
	          });
	        });
	      }
	    };
	
	    var create$1 = function (selection, kill) {
	      return {
	        selection: selection,
	        kill: kill
	      };
	    };
	    var Response = { create: create$1 };
	
	    var create = function (start, soffset, finish, foffset) {
	      return {
	        start: Situ.on(start, soffset),
	        finish: Situ.on(finish, foffset)
	      };
	    };
	    var Situs = { create: create };
	
	    var convertToRange = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return SimRange.create(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset);
	    };
	    var makeSitus = Situs.create;
	
	    var sync = function (container, isRoot, start, soffset, finish, foffset, selectRange) {
	      if (!(eq$1(start, finish) && soffset === foffset)) {
	        return closest$1(start, 'td,th', isRoot).bind(function (s) {
	          return closest$1(finish, 'td,th', isRoot).bind(function (f) {
	            return detect(container, isRoot, s, f, selectRange);
	          });
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	    var detect = function (container, isRoot, start, finish, selectRange) {
	      if (!eq$1(start, finish)) {
	        return identify(start, finish, isRoot).bind(function (cellSel) {
	          var boxes = cellSel.boxes.getOr([]);
	          if (boxes.length > 1) {
	            selectRange(container, boxes, cellSel.start, cellSel.finish);
	            return Optional.some(Response.create(Optional.some(makeSitus(start, 0, start, getEnd(start))), true));
	          } else {
	            return Optional.none();
	          }
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	    var update = function (rows, columns, container, selected, annotations) {
	      var updateSelection = function (newSels) {
	        annotations.clearBeforeUpdate(container);
	        annotations.selectRange(container, newSels.boxes, newSels.start, newSels.finish);
	        return newSels.boxes;
	      };
	      return shiftSelection(selected, rows, columns, annotations.firstSelectedSelector, annotations.lastSelectedSelector).map(updateSelection);
	    };
	
	    var traverse = function (item, mode) {
	      return {
	        item: item,
	        mode: mode
	      };
	    };
	    var backtrack = function (universe, item, _direction, transition) {
	      if (transition === void 0) {
	        transition = sidestep;
	      }
	      return universe.property().parent(item).map(function (p) {
	        return traverse(p, transition);
	      });
	    };
	    var sidestep = function (universe, item, direction, transition) {
	      if (transition === void 0) {
	        transition = advance;
	      }
	      return direction.sibling(universe, item).map(function (p) {
	        return traverse(p, transition);
	      });
	    };
	    var advance = function (universe, item, direction, transition) {
	      if (transition === void 0) {
	        transition = advance;
	      }
	      var children = universe.property().children(item);
	      var result = direction.first(children);
	      return result.map(function (r) {
	        return traverse(r, transition);
	      });
	    };
	    var successors = [
	      {
	        current: backtrack,
	        next: sidestep,
	        fallback: Optional.none()
	      },
	      {
	        current: sidestep,
	        next: advance,
	        fallback: Optional.some(backtrack)
	      },
	      {
	        current: advance,
	        next: advance,
	        fallback: Optional.some(sidestep)
	      }
	    ];
	    var go = function (universe, item, mode, direction, rules) {
	      if (rules === void 0) {
	        rules = successors;
	      }
	      var ruleOpt = find$1(rules, function (succ) {
	        return succ.current === mode;
	      });
	      return ruleOpt.bind(function (rule) {
	        return rule.current(universe, item, direction, rule.next).orThunk(function () {
	          return rule.fallback.bind(function (fb) {
	            return go(universe, item, fb, direction);
	          });
	        });
	      });
	    };
	
	    var left$1 = function () {
	      var sibling = function (universe, item) {
	        return universe.query().prevSibling(item);
	      };
	      var first = function (children) {
	        return children.length > 0 ? Optional.some(children[children.length - 1]) : Optional.none();
	      };
	      return {
	        sibling: sibling,
	        first: first
	      };
	    };
	    var right$1 = function () {
	      var sibling = function (universe, item) {
	        return universe.query().nextSibling(item);
	      };
	      var first = function (children) {
	        return children.length > 0 ? Optional.some(children[0]) : Optional.none();
	      };
	      return {
	        sibling: sibling,
	        first: first
	      };
	    };
	    var Walkers = {
	      left: left$1,
	      right: right$1
	    };
	
	    var hone = function (universe, item, predicate, mode, direction, isRoot) {
	      var next = go(universe, item, mode, direction);
	      return next.bind(function (n) {
	        if (isRoot(n.item)) {
	          return Optional.none();
	        } else {
	          return predicate(n.item) ? Optional.some(n.item) : hone(universe, n.item, predicate, n.mode, direction, isRoot);
	        }
	      });
	    };
	    var left = function (universe, item, predicate, isRoot) {
	      return hone(universe, item, predicate, sidestep, Walkers.left(), isRoot);
	    };
	    var right = function (universe, item, predicate, isRoot) {
	      return hone(universe, item, predicate, sidestep, Walkers.right(), isRoot);
	    };
	
	    var isLeaf = function (universe) {
	      return function (element) {
	        return universe.property().children(element).length === 0;
	      };
	    };
	    var before$1 = function (universe, item, isRoot) {
	      return seekLeft$1(universe, item, isLeaf(universe), isRoot);
	    };
	    var after$1 = function (universe, item, isRoot) {
	      return seekRight$1(universe, item, isLeaf(universe), isRoot);
	    };
	    var seekLeft$1 = left;
	    var seekRight$1 = right;
	
	    var universe = DomUniverse();
	    var before = function (element, isRoot) {
	      return before$1(universe, element, isRoot);
	    };
	    var after = function (element, isRoot) {
	      return after$1(universe, element, isRoot);
	    };
	    var seekLeft = function (element, predicate, isRoot) {
	      return seekLeft$1(universe, element, predicate, isRoot);
	    };
	    var seekRight = function (element, predicate, isRoot) {
	      return seekRight$1(universe, element, predicate, isRoot);
	    };
	
	    var ancestor = function (scope, predicate, isRoot) {
	      return ancestor$2(scope, predicate, isRoot).isSome();
	    };
	
	    var adt$1 = Adt.generate([
	      { none: ['message'] },
	      { success: [] },
	      { failedUp: ['cell'] },
	      { failedDown: ['cell'] }
	    ]);
	    var isOverlapping = function (bridge, before, after) {
	      var beforeBounds = bridge.getRect(before);
	      var afterBounds = bridge.getRect(after);
	      return afterBounds.right > beforeBounds.left && afterBounds.left < beforeBounds.right;
	    };
	    var isRow = function (elem) {
	      return closest$1(elem, 'tr');
	    };
	    var verify = function (bridge, before, beforeOffset, after, afterOffset, failure, isRoot) {
	      return closest$1(after, 'td,th', isRoot).bind(function (afterCell) {
	        return closest$1(before, 'td,th', isRoot).map(function (beforeCell) {
	          if (!eq$1(afterCell, beforeCell)) {
	            return sharedOne(isRow, [
	              afterCell,
	              beforeCell
	            ]).fold(function () {
	              return isOverlapping(bridge, beforeCell, afterCell) ? adt$1.success() : failure(beforeCell);
	            }, function (_sharedRow) {
	              return failure(beforeCell);
	            });
	          } else {
	            return eq$1(after, afterCell) && getEnd(afterCell) === afterOffset ? failure(beforeCell) : adt$1.none('in same cell');
	          }
	        });
	      }).getOr(adt$1.none('default'));
	    };
	    var cata = function (subject, onNone, onSuccess, onFailedUp, onFailedDown) {
	      return subject.fold(onNone, onSuccess, onFailedUp, onFailedDown);
	    };
	    var BeforeAfter = __assign(__assign({}, adt$1), {
	      verify: verify,
	      cata: cata
	    });
	
	    var inParent = function (parent, children, element, index) {
	      return {
	        parent: parent,
	        children: children,
	        element: element,
	        index: index
	      };
	    };
	    var indexInParent = function (element) {
	      return parent(element).bind(function (parent) {
	        var children = children$3(parent);
	        return indexOf(children, element).map(function (index) {
	          return inParent(parent, children, element, index);
	        });
	      });
	    };
	    var indexOf = function (elements, element) {
	      return findIndex(elements, curry(eq$1, element));
	    };
	
	    var isBr = function (elem) {
	      return name(elem) === 'br';
	    };
	    var gatherer = function (cand, gather, isRoot) {
	      return gather(cand, isRoot).bind(function (target) {
	        return isText(target) && get$9(target).trim().length === 0 ? gatherer(target, gather, isRoot) : Optional.some(target);
	      });
	    };
	    var handleBr = function (isRoot, element, direction) {
	      return direction.traverse(element).orThunk(function () {
	        return gatherer(element, direction.gather, isRoot);
	      }).map(direction.relative);
	    };
	    var findBr = function (element, offset) {
	      return child$3(element, offset).filter(isBr).orThunk(function () {
	        return child$3(element, offset - 1).filter(isBr);
	      });
	    };
	    var handleParent = function (isRoot, element, offset, direction) {
	      return findBr(element, offset).bind(function (br) {
	        return direction.traverse(br).fold(function () {
	          return gatherer(br, direction.gather, isRoot).map(direction.relative);
	        }, function (adjacent) {
	          return indexInParent(adjacent).map(function (info) {
	            return Situ.on(info.parent, info.index);
	          });
	        });
	      });
	    };
	    var tryBr = function (isRoot, element, offset, direction) {
	      var target = isBr(element) ? handleBr(isRoot, element, direction) : handleParent(isRoot, element, offset, direction);
	      return target.map(function (tgt) {
	        return {
	          start: tgt,
	          finish: tgt
	        };
	      });
	    };
	    var process = function (analysis) {
	      return BeforeAfter.cata(analysis, function (_message) {
	        return Optional.none();
	      }, function () {
	        return Optional.none();
	      }, function (cell) {
	        return Optional.some(point(cell, 0));
	      }, function (cell) {
	        return Optional.some(point(cell, getEnd(cell)));
	      });
	    };
	
	    var moveDown = function (caret, amount) {
	      return {
	        left: caret.left,
	        top: caret.top + amount,
	        right: caret.right,
	        bottom: caret.bottom + amount
	      };
	    };
	    var moveUp = function (caret, amount) {
	      return {
	        left: caret.left,
	        top: caret.top - amount,
	        right: caret.right,
	        bottom: caret.bottom - amount
	      };
	    };
	    var translate = function (caret, xDelta, yDelta) {
	      return {
	        left: caret.left + xDelta,
	        top: caret.top + yDelta,
	        right: caret.right + xDelta,
	        bottom: caret.bottom + yDelta
	      };
	    };
	    var getTop = function (caret) {
	      return caret.top;
	    };
	    var getBottom = function (caret) {
	      return caret.bottom;
	    };
	
	    var getPartialBox = function (bridge, element, offset) {
	      if (offset >= 0 && offset < getEnd(element)) {
	        return bridge.getRangedRect(element, offset, element, offset + 1);
	      } else if (offset > 0) {
	        return bridge.getRangedRect(element, offset - 1, element, offset);
	      }
	      return Optional.none();
	    };
	    var toCaret = function (rect) {
	      return {
	        left: rect.left,
	        top: rect.top,
	        right: rect.right,
	        bottom: rect.bottom
	      };
	    };
	    var getElemBox = function (bridge, element) {
	      return Optional.some(bridge.getRect(element));
	    };
	    var getBoxAt = function (bridge, element, offset) {
	      if (isElement(element)) {
	        return getElemBox(bridge, element).map(toCaret);
	      } else if (isText(element)) {
	        return getPartialBox(bridge, element, offset).map(toCaret);
	      } else {
	        return Optional.none();
	      }
	    };
	    var getEntireBox = function (bridge, element) {
	      if (isElement(element)) {
	        return getElemBox(bridge, element).map(toCaret);
	      } else if (isText(element)) {
	        return bridge.getRangedRect(element, 0, element, getEnd(element)).map(toCaret);
	      } else {
	        return Optional.none();
	      }
	    };
	
	    var JUMP_SIZE = 5;
	    var NUM_RETRIES = 100;
	    var adt = Adt.generate([
	      { none: [] },
	      { retry: ['caret'] }
	    ]);
	    var isOutside = function (caret, box) {
	      return caret.left < box.left || Math.abs(box.right - caret.left) < 1 || caret.left > box.right;
	    };
	    var inOutsideBlock = function (bridge, element, caret) {
	      return closest$2(element, isBlock).fold(never, function (cell) {
	        return getEntireBox(bridge, cell).exists(function (box) {
	          return isOutside(caret, box);
	        });
	      });
	    };
	    var adjustDown = function (bridge, element, guessBox, original, caret) {
	      var lowerCaret = moveDown(caret, JUMP_SIZE);
	      if (Math.abs(guessBox.bottom - original.bottom) < 1) {
	        return adt.retry(lowerCaret);
	      } else if (guessBox.top > caret.bottom) {
	        return adt.retry(lowerCaret);
	      } else if (guessBox.top === caret.bottom) {
	        return adt.retry(moveDown(caret, 1));
	      } else {
	        return inOutsideBlock(bridge, element, caret) ? adt.retry(translate(lowerCaret, JUMP_SIZE, 0)) : adt.none();
	      }
	    };
	    var adjustUp = function (bridge, element, guessBox, original, caret) {
	      var higherCaret = moveUp(caret, JUMP_SIZE);
	      if (Math.abs(guessBox.top - original.top) < 1) {
	        return adt.retry(higherCaret);
	      } else if (guessBox.bottom < caret.top) {
	        return adt.retry(higherCaret);
	      } else if (guessBox.bottom === caret.top) {
	        return adt.retry(moveUp(caret, 1));
	      } else {
	        return inOutsideBlock(bridge, element, caret) ? adt.retry(translate(higherCaret, JUMP_SIZE, 0)) : adt.none();
	      }
	    };
	    var upMovement = {
	      point: getTop,
	      adjuster: adjustUp,
	      move: moveUp,
	      gather: before
	    };
	    var downMovement = {
	      point: getBottom,
	      adjuster: adjustDown,
	      move: moveDown,
	      gather: after
	    };
	    var isAtTable = function (bridge, x, y) {
	      return bridge.elementFromPoint(x, y).filter(function (elm) {
	        return name(elm) === 'table';
	      }).isSome();
	    };
	    var adjustForTable = function (bridge, movement, original, caret, numRetries) {
	      return adjustTil(bridge, movement, original, movement.move(caret, JUMP_SIZE), numRetries);
	    };
	    var adjustTil = function (bridge, movement, original, caret, numRetries) {
	      if (numRetries === 0) {
	        return Optional.some(caret);
	      }
	      if (isAtTable(bridge, caret.left, movement.point(caret))) {
	        return adjustForTable(bridge, movement, original, caret, numRetries - 1);
	      }
	      return bridge.situsFromPoint(caret.left, movement.point(caret)).bind(function (guess) {
	        return guess.start.fold(Optional.none, function (element) {
	          return getEntireBox(bridge, element).bind(function (guessBox) {
	            return movement.adjuster(bridge, element, guessBox, original, caret).fold(Optional.none, function (newCaret) {
	              return adjustTil(bridge, movement, original, newCaret, numRetries - 1);
	            });
	          }).orThunk(function () {
	            return Optional.some(caret);
	          });
	        }, Optional.none);
	      });
	    };
	    var ieTryDown = function (bridge, caret) {
	      return bridge.situsFromPoint(caret.left, caret.bottom + JUMP_SIZE);
	    };
	    var ieTryUp = function (bridge, caret) {
	      return bridge.situsFromPoint(caret.left, caret.top - JUMP_SIZE);
	    };
	    var checkScroll = function (movement, adjusted, bridge) {
	      if (movement.point(adjusted) > bridge.getInnerHeight()) {
	        return Optional.some(movement.point(adjusted) - bridge.getInnerHeight());
	      } else if (movement.point(adjusted) < 0) {
	        return Optional.some(-movement.point(adjusted));
	      } else {
	        return Optional.none();
	      }
	    };
	    var retry = function (movement, bridge, caret) {
	      var moved = movement.move(caret, JUMP_SIZE);
	      var adjusted = adjustTil(bridge, movement, caret, moved, NUM_RETRIES).getOr(moved);
	      return checkScroll(movement, adjusted, bridge).fold(function () {
	        return bridge.situsFromPoint(adjusted.left, movement.point(adjusted));
	      }, function (delta) {
	        bridge.scrollBy(0, delta);
	        return bridge.situsFromPoint(adjusted.left, movement.point(adjusted) - delta);
	      });
	    };
	    var Retries = {
	      tryUp: curry(retry, upMovement),
	      tryDown: curry(retry, downMovement),
	      ieTryUp: ieTryUp,
	      ieTryDown: ieTryDown,
	      getJumpSize: constant(JUMP_SIZE)
	    };
	
	    var MAX_RETRIES = 20;
	    var findSpot = function (bridge, isRoot, direction) {
	      return bridge.getSelection().bind(function (sel) {
	        return tryBr(isRoot, sel.finish, sel.foffset, direction).fold(function () {
	          return Optional.some(point(sel.finish, sel.foffset));
	        }, function (brNeighbour) {
	          var range = bridge.fromSitus(brNeighbour);
	          var analysis = BeforeAfter.verify(bridge, sel.finish, sel.foffset, range.finish, range.foffset, direction.failure, isRoot);
	          return process(analysis);
	        });
	      });
	    };
	    var scan = function (bridge, isRoot, element, offset, direction, numRetries) {
	      if (numRetries === 0) {
	        return Optional.none();
	      }
	      return tryCursor(bridge, isRoot, element, offset, direction).bind(function (situs) {
	        var range = bridge.fromSitus(situs);
	        var analysis = BeforeAfter.verify(bridge, element, offset, range.finish, range.foffset, direction.failure, isRoot);
	        return BeforeAfter.cata(analysis, function () {
	          return Optional.none();
	        }, function () {
	          return Optional.some(situs);
	        }, function (cell) {
	          if (eq$1(element, cell) && offset === 0) {
	            return tryAgain(bridge, element, offset, moveUp, direction);
	          } else {
	            return scan(bridge, isRoot, cell, 0, direction, numRetries - 1);
	          }
	        }, function (cell) {
	          if (eq$1(element, cell) && offset === getEnd(cell)) {
	            return tryAgain(bridge, element, offset, moveDown, direction);
	          } else {
	            return scan(bridge, isRoot, cell, getEnd(cell), direction, numRetries - 1);
	          }
	        });
	      });
	    };
	    var tryAgain = function (bridge, element, offset, move, direction) {
	      return getBoxAt(bridge, element, offset).bind(function (box) {
	        return tryAt(bridge, direction, move(box, Retries.getJumpSize()));
	      });
	    };
	    var tryAt = function (bridge, direction, box) {
	      var browser = detect$3().browser;
	      if (browser.isChrome() || browser.isSafari() || browser.isFirefox() || browser.isEdge()) {
	        return direction.otherRetry(bridge, box);
	      } else if (browser.isIE()) {
	        return direction.ieRetry(bridge, box);
	      } else {
	        return Optional.none();
	      }
	    };
	    var tryCursor = function (bridge, isRoot, element, offset, direction) {
	      return getBoxAt(bridge, element, offset).bind(function (box) {
	        return tryAt(bridge, direction, box);
	      });
	    };
	    var handle = function (bridge, isRoot, direction) {
	      return findSpot(bridge, isRoot, direction).bind(function (spot) {
	        return scan(bridge, isRoot, spot.element, spot.offset, direction, MAX_RETRIES).map(bridge.fromSitus);
	      });
	    };
	
	    var inSameTable = function (elem, table) {
	      return ancestor(elem, function (e) {
	        return parent(e).exists(function (p) {
	          return eq$1(p, table);
	        });
	      });
	    };
	    var simulate = function (bridge, isRoot, direction, initial, anchor) {
	      return closest$1(initial, 'td,th', isRoot).bind(function (start) {
	        return closest$1(start, 'table', isRoot).bind(function (table) {
	          if (!inSameTable(anchor, table)) {
	            return Optional.none();
	          }
	          return handle(bridge, isRoot, direction).bind(function (range) {
	            return closest$1(range.finish, 'td,th', isRoot).map(function (finish) {
	              return {
	                start: start,
	                finish: finish,
	                range: range
	              };
	            });
	          });
	        });
	      });
	    };
	    var navigate = function (bridge, isRoot, direction, initial, anchor, precheck) {
	      if (detect$3().browser.isIE()) {
	        return Optional.none();
	      } else {
	        return precheck(initial, isRoot).orThunk(function () {
	          return simulate(bridge, isRoot, direction, initial, anchor).map(function (info) {
	            var range = info.range;
	            return Response.create(Optional.some(makeSitus(range.start, range.soffset, range.finish, range.foffset)), true);
	          });
	        });
	      }
	    };
	    var firstUpCheck = function (initial, isRoot) {
	      return closest$1(initial, 'tr', isRoot).bind(function (startRow) {
	        return closest$1(startRow, 'table', isRoot).bind(function (table) {
	          var rows = descendants(table, 'tr');
	          if (eq$1(startRow, rows[0])) {
	            return seekLeft(table, function (element) {
	              return last$1(element).isSome();
	            }, isRoot).map(function (last) {
	              var lastOffset = getEnd(last);
	              return Response.create(Optional.some(makeSitus(last, lastOffset, last, lastOffset)), true);
	            });
	          } else {
	            return Optional.none();
	          }
	        });
	      });
	    };
	    var lastDownCheck = function (initial, isRoot) {
	      return closest$1(initial, 'tr', isRoot).bind(function (startRow) {
	        return closest$1(startRow, 'table', isRoot).bind(function (table) {
	          var rows = descendants(table, 'tr');
	          if (eq$1(startRow, rows[rows.length - 1])) {
	            return seekRight(table, function (element) {
	              return first(element).isSome();
	            }, isRoot).map(function (first) {
	              return Response.create(Optional.some(makeSitus(first, 0, first, 0)), true);
	            });
	          } else {
	            return Optional.none();
	          }
	        });
	      });
	    };
	    var select = function (bridge, container, isRoot, direction, initial, anchor, selectRange) {
	      return simulate(bridge, isRoot, direction, initial, anchor).bind(function (info) {
	        return detect(container, isRoot, info.start, info.finish, selectRange);
	      });
	    };
	
	    var findCell = function (target, isRoot) {
	      return closest$1(target, 'td,th', isRoot);
	    };
	    var MouseSelection = function (bridge, container, isRoot, annotations) {
	      var cursor = value();
	      var clearstate = cursor.clear;
	      var applySelection = function (event) {
	        cursor.on(function (start) {
	          annotations.clearBeforeUpdate(container);
	          findCell(event.target, isRoot).each(function (finish) {
	            identify(start, finish, isRoot).each(function (cellSel) {
	              var boxes = cellSel.boxes.getOr([]);
	              if (boxes.length === 1) {
	                var singleCell = boxes[0];
	                var isNonEditableCell = getRaw(singleCell) === 'false';
	                var isCellClosestContentEditable = is(closest(event.target), singleCell, eq$1);
	                if (isNonEditableCell && isCellClosestContentEditable) {
	                  annotations.selectRange(container, boxes, singleCell, singleCell);
	                  bridge.selectContents(singleCell);
	                }
	              } else if (boxes.length > 1) {
	                annotations.selectRange(container, boxes, cellSel.start, cellSel.finish);
	                bridge.selectContents(finish);
	              }
	            });
	          });
	        });
	      };
	      var mousedown = function (event) {
	        annotations.clear(container);
	        findCell(event.target, isRoot).each(cursor.set);
	      };
	      var mouseover = function (event) {
	        applySelection(event);
	      };
	      var mouseup = function (event) {
	        applySelection(event);
	        clearstate();
	      };
	      return {
	        clearstate: clearstate,
	        mousedown: mousedown,
	        mouseover: mouseover,
	        mouseup: mouseup
	      };
	    };
	
	    var down = {
	      traverse: nextSibling,
	      gather: after,
	      relative: Situ.before,
	      otherRetry: Retries.tryDown,
	      ieRetry: Retries.ieTryDown,
	      failure: BeforeAfter.failedDown
	    };
	    var up = {
	      traverse: prevSibling,
	      gather: before,
	      relative: Situ.before,
	      otherRetry: Retries.tryUp,
	      ieRetry: Retries.ieTryUp,
	      failure: BeforeAfter.failedUp
	    };
	
	    var isKey = function (key) {
	      return function (keycode) {
	        return keycode === key;
	      };
	    };
	    var isUp = isKey(38);
	    var isDown = isKey(40);
	    var isNavigation = function (keycode) {
	      return keycode >= 37 && keycode <= 40;
	    };
	    var ltr = {
	      isBackward: isKey(37),
	      isForward: isKey(39)
	    };
	    var rtl = {
	      isBackward: isKey(39),
	      isForward: isKey(37)
	    };
	
	    var get = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return SugarPosition(x, y);
	    };
	    var by = function (x, y, _DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var win = doc.defaultView;
	      if (win) {
	        win.scrollBy(x, y);
	      }
	    };
	
	    var WindowBridge = function (win) {
	      var elementFromPoint = function (x, y) {
	        return SugarElement.fromPoint(SugarElement.fromDom(win.document), x, y);
	      };
	      var getRect = function (element) {
	        return element.dom.getBoundingClientRect();
	      };
	      var getRangedRect = function (start, soffset, finish, foffset) {
	        var sel = SimSelection.exact(start, soffset, finish, foffset);
	        return getFirstRect(win, sel);
	      };
	      var getSelection = function () {
	        return get$1(win).map(function (exactAdt) {
	          return convertToRange(win, exactAdt);
	        });
	      };
	      var fromSitus = function (situs) {
	        var relative = SimSelection.relative(situs.start, situs.finish);
	        return convertToRange(win, relative);
	      };
	      var situsFromPoint = function (x, y) {
	        return getAtPoint(win, x, y).map(function (exact) {
	          return Situs.create(exact.start, exact.soffset, exact.finish, exact.foffset);
	        });
	      };
	      var clearSelection = function () {
	        clear(win);
	      };
	      var collapseSelection = function (toStart) {
	        if (toStart === void 0) {
	          toStart = false;
	        }
	        get$1(win).each(function (sel) {
	          return sel.fold(function (rng) {
	            return rng.collapse(toStart);
	          }, function (startSitu, finishSitu) {
	            var situ = toStart ? startSitu : finishSitu;
	            setRelative(win, situ, situ);
	          }, function (start, soffset, finish, foffset) {
	            var node = toStart ? start : finish;
	            var offset = toStart ? soffset : foffset;
	            setExact(win, node, offset, node, offset);
	          });
	        });
	      };
	      var selectNode = function (element) {
	        setToElement(win, element, false);
	      };
	      var selectContents = function (element) {
	        setToElement(win, element);
	      };
	      var setSelection = function (sel) {
	        setExact(win, sel.start, sel.soffset, sel.finish, sel.foffset);
	      };
	      var setRelativeSelection = function (start, finish) {
	        setRelative(win, start, finish);
	      };
	      var getInnerHeight = function () {
	        return win.innerHeight;
	      };
	      var getScrollY = function () {
	        var pos = get(SugarElement.fromDom(win.document));
	        return pos.top;
	      };
	      var scrollBy = function (x, y) {
	        by(x, y, SugarElement.fromDom(win.document));
	      };
	      return {
	        elementFromPoint: elementFromPoint,
	        getRect: getRect,
	        getRangedRect: getRangedRect,
	        getSelection: getSelection,
	        fromSitus: fromSitus,
	        situsFromPoint: situsFromPoint,
	        clearSelection: clearSelection,
	        collapseSelection: collapseSelection,
	        setSelection: setSelection,
	        setRelativeSelection: setRelativeSelection,
	        selectNode: selectNode,
	        selectContents: selectContents,
	        getInnerHeight: getInnerHeight,
	        getScrollY: getScrollY,
	        scrollBy: scrollBy
	      };
	    };
	
	    var rc = function (rows, cols) {
	      return {
	        rows: rows,
	        cols: cols
	      };
	    };
	    var mouse = function (win, container, isRoot, annotations) {
	      var bridge = WindowBridge(win);
	      var handlers = MouseSelection(bridge, container, isRoot, annotations);
	      return {
	        clearstate: handlers.clearstate,
	        mousedown: handlers.mousedown,
	        mouseover: handlers.mouseover,
	        mouseup: handlers.mouseup
	      };
	    };
	    var keyboard = function (win, container, isRoot, annotations) {
	      var bridge = WindowBridge(win);
	      var clearToNavigate = function () {
	        annotations.clear(container);
	        return Optional.none();
	      };
	      var keydown = function (event, start, soffset, finish, foffset, direction) {
	        var realEvent = event.raw;
	        var keycode = realEvent.which;
	        var shiftKey = realEvent.shiftKey === true;
	        var handler = retrieve$1(container, annotations.selectedSelector).fold(function () {
	          if (isNavigation(keycode) && !shiftKey) {
	            annotations.clearBeforeUpdate(container);
	          }
	          if (isDown(keycode) && shiftKey) {
	            return curry(select, bridge, container, isRoot, down, finish, start, annotations.selectRange);
	          } else if (isUp(keycode) && shiftKey) {
	            return curry(select, bridge, container, isRoot, up, finish, start, annotations.selectRange);
	          } else if (isDown(keycode)) {
	            return curry(navigate, bridge, isRoot, down, finish, start, lastDownCheck);
	          } else if (isUp(keycode)) {
	            return curry(navigate, bridge, isRoot, up, finish, start, firstUpCheck);
	          } else {
	            return Optional.none;
	          }
	        }, function (selected) {
	          var update$1 = function (attempts) {
	            return function () {
	              var navigation = findMap(attempts, function (delta) {
	                return update(delta.rows, delta.cols, container, selected, annotations);
	              });
	              return navigation.fold(function () {
	                return getEdges(container, annotations.firstSelectedSelector, annotations.lastSelectedSelector).map(function (edges) {
	                  var relative = isDown(keycode) || direction.isForward(keycode) ? Situ.after : Situ.before;
	                  bridge.setRelativeSelection(Situ.on(edges.first, 0), relative(edges.table));
	                  annotations.clear(container);
	                  return Response.create(Optional.none(), true);
	                });
	              }, function (_) {
	                return Optional.some(Response.create(Optional.none(), true));
	              });
	            };
	          };
	          if (isDown(keycode) && shiftKey) {
	            return update$1([rc(+1, 0)]);
	          } else if (isUp(keycode) && shiftKey) {
	            return update$1([rc(-1, 0)]);
	          } else if (direction.isBackward(keycode) && shiftKey) {
	            return update$1([
	              rc(0, -1),
	              rc(-1, 0)
	            ]);
	          } else if (direction.isForward(keycode) && shiftKey) {
	            return update$1([
	              rc(0, +1),
	              rc(+1, 0)
	            ]);
	          } else if (isNavigation(keycode) && !shiftKey) {
	            return clearToNavigate;
	          } else {
	            return Optional.none;
	          }
	        });
	        return handler();
	      };
	      var keyup = function (event, start, soffset, finish, foffset) {
	        return retrieve$1(container, annotations.selectedSelector).fold(function () {
	          var realEvent = event.raw;
	          var keycode = realEvent.which;
	          var shiftKey = realEvent.shiftKey === true;
	          if (!shiftKey) {
	            return Optional.none();
	          }
	          if (isNavigation(keycode)) {
	            return sync(container, isRoot, start, soffset, finish, foffset, annotations.selectRange);
	          } else {
	            return Optional.none();
	          }
	        }, Optional.none);
	      };
	      return {
	        keydown: keydown,
	        keyup: keyup
	      };
	    };
	    var external = function (win, container, isRoot, annotations) {
	      var bridge = WindowBridge(win);
	      return function (start, finish) {
	        annotations.clearBeforeUpdate(container);
	        identify(start, finish, isRoot).each(function (cellSel) {
	          var boxes = cellSel.boxes.getOr([]);
	          annotations.selectRange(container, boxes, cellSel.start, cellSel.finish);
	          bridge.selectContents(finish);
	          bridge.collapseSelection();
	        });
	      };
	    };
	
	    var remove = function (element, classes) {
	      each$2(classes, function (x) {
	        remove$2(element, x);
	      });
	    };
	
	    var addClass = function (clazz) {
	      return function (element) {
	        add(element, clazz);
	      };
	    };
	    var removeClasses = function (classes) {
	      return function (element) {
	        remove(element, classes);
	      };
	    };
	
	    var byClass = function (ephemera) {
	      var addSelectionClass = addClass(ephemera.selected);
	      var removeSelectionClasses = removeClasses([
	        ephemera.selected,
	        ephemera.lastSelected,
	        ephemera.firstSelected
	      ]);
	      var clear = function (container) {
	        var sels = descendants(container, ephemera.selectedSelector);
	        each$2(sels, removeSelectionClasses);
	      };
	      var selectRange = function (container, cells, start, finish) {
	        clear(container);
	        each$2(cells, addSelectionClass);
	        add(start, ephemera.firstSelected);
	        add(finish, ephemera.lastSelected);
	      };
	      return {
	        clearBeforeUpdate: clear,
	        clear: clear,
	        selectRange: selectRange,
	        selectedSelector: ephemera.selectedSelector,
	        firstSelectedSelector: ephemera.firstSelectedSelector,
	        lastSelectedSelector: ephemera.lastSelectedSelector
	      };
	    };
	    var byAttr = function (ephemera, onSelection, onClear) {
	      var removeSelectionAttributes = function (element) {
	        remove$7(element, ephemera.selected);
	        remove$7(element, ephemera.firstSelected);
	        remove$7(element, ephemera.lastSelected);
	      };
	      var addSelectionAttribute = function (element) {
	        set$2(element, ephemera.selected, '1');
	      };
	      var clear = function (container) {
	        clearBeforeUpdate(container);
	        onClear();
	      };
	      var clearBeforeUpdate = function (container) {
	        var sels = descendants(container, ephemera.selectedSelector + ',' + ephemera.firstSelectedSelector + ',' + ephemera.lastSelectedSelector);
	        each$2(sels, removeSelectionAttributes);
	      };
	      var selectRange = function (container, cells, start, finish) {
	        clear(container);
	        each$2(cells, addSelectionAttribute);
	        set$2(start, ephemera.firstSelected, '1');
	        set$2(finish, ephemera.lastSelected, '1');
	        onSelection(cells, start, finish);
	      };
	      return {
	        clearBeforeUpdate: clearBeforeUpdate,
	        clear: clear,
	        selectRange: selectRange,
	        selectedSelector: ephemera.selectedSelector,
	        firstSelectedSelector: ephemera.firstSelectedSelector,
	        lastSelectedSelector: ephemera.lastSelectedSelector
	      };
	    };
	    var SelectionAnnotation = {
	      byClass: byClass,
	      byAttr: byAttr
	    };
	
	    var getUpOrLeftCells = function (grid, selectedCells) {
	      var upGrid = grid.slice(0, selectedCells[selectedCells.length - 1].row + 1);
	      var upDetails = toDetailList(upGrid);
	      return bind$2(upDetails, function (detail) {
	        var slicedCells = detail.cells.slice(0, selectedCells[selectedCells.length - 1].column + 1);
	        return map$1(slicedCells, function (cell) {
	          return cell.element;
	        });
	      });
	    };
	    var getDownOrRightCells = function (grid, selectedCells) {
	      var downGrid = grid.slice(selectedCells[0].row + selectedCells[0].rowspan - 1, grid.length);
	      var downDetails = toDetailList(downGrid);
	      return bind$2(downDetails, function (detail) {
	        var slicedCells = detail.cells.slice(selectedCells[0].column + selectedCells[0].colspan - 1, detail.cells.length);
	        return map$1(slicedCells, function (cell) {
	          return cell.element;
	        });
	      });
	    };
	    var getOtherCells = function (table, target, generators) {
	      var warehouse = Warehouse.fromTable(table);
	      var details = onCells(warehouse, target);
	      return details.map(function (selectedCells) {
	        var grid = toGrid(warehouse, generators, false);
	        var upOrLeftCells = getUpOrLeftCells(grid, selectedCells);
	        var downOrRightCells = getDownOrRightCells(grid, selectedCells);
	        return {
	          upOrLeftCells: upOrLeftCells,
	          downOrRightCells: downOrRightCells
	        };
	      });
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var hasInternalTarget = function (e) {
	      return has(SugarElement.fromDom(e.target), 'ephox-snooker-resizer-bar') === false;
	    };
	    function CellSelection (editor, lazyResize, selectionTargets) {
	      var onSelection = function (cells, start, finish) {
	        selectionTargets.targets().each(function (targets) {
	          var tableOpt = table(start);
	          tableOpt.each(function (table) {
	            var cloneFormats = getCloneElements(editor);
	            var generators = cellOperations(noop, SugarElement.fromDom(editor.getDoc()), cloneFormats);
	            var otherCells = getOtherCells(table, targets, generators);
	            fireTableSelectionChange(editor, cells, start, finish, otherCells);
	          });
	        });
	      };
	      var onClear = function () {
	        return fireTableSelectionClear(editor);
	      };
	      var annotations = SelectionAnnotation.byAttr(ephemera, onSelection, onClear);
	      editor.on('init', function (_e) {
	        var win = editor.getWin();
	        var body = getBody(editor);
	        var isRoot = getIsRoot(editor);
	        var syncSelection = function () {
	          var sel = editor.selection;
	          var start = SugarElement.fromDom(sel.getStart());
	          var end = SugarElement.fromDom(sel.getEnd());
	          var shared = sharedOne(table, [
	            start,
	            end
	          ]);
	          shared.fold(function () {
	            return annotations.clear(body);
	          }, noop);
	        };
	        var mouseHandlers = mouse(win, body, isRoot, annotations);
	        var keyHandlers = keyboard(win, body, isRoot, annotations);
	        var external$1 = external(win, body, isRoot, annotations);
	        var hasShiftKey = function (event) {
	          return event.raw.shiftKey === true;
	        };
	        editor.on('TableSelectorChange', function (e) {
	          return external$1(e.start, e.finish);
	        });
	        var handleResponse = function (event, response) {
	          if (!hasShiftKey(event)) {
	            return;
	          }
	          if (response.kill) {
	            event.kill();
	          }
	          response.selection.each(function (ns) {
	            var relative = SimSelection.relative(ns.start, ns.finish);
	            var rng = asLtrRange(win, relative);
	            editor.selection.setRng(rng);
	          });
	        };
	        var keyup = function (event) {
	          var wrappedEvent = fromRawEvent(event);
	          if (wrappedEvent.raw.shiftKey && isNavigation(wrappedEvent.raw.which)) {
	            var rng = editor.selection.getRng();
	            var start = SugarElement.fromDom(rng.startContainer);
	            var end = SugarElement.fromDom(rng.endContainer);
	            keyHandlers.keyup(wrappedEvent, start, rng.startOffset, end, rng.endOffset).each(function (response) {
	              handleResponse(wrappedEvent, response);
	            });
	          }
	        };
	        var keydown = function (event) {
	          var wrappedEvent = fromRawEvent(event);
	          lazyResize().each(function (resize) {
	            return resize.hideBars();
	          });
	          var rng = editor.selection.getRng();
	          var start = SugarElement.fromDom(rng.startContainer);
	          var end = SugarElement.fromDom(rng.endContainer);
	          var direction = onDirection(ltr, rtl)(SugarElement.fromDom(editor.selection.getStart()));
	          keyHandlers.keydown(wrappedEvent, start, rng.startOffset, end, rng.endOffset, direction).each(function (response) {
	            handleResponse(wrappedEvent, response);
	          });
	          lazyResize().each(function (resize) {
	            return resize.showBars();
	          });
	        };
	        var isLeftMouse = function (raw) {
	          return raw.button === 0;
	        };
	        var isLeftButtonPressed = function (raw) {
	          if (raw.buttons === undefined) {
	            return true;
	          }
	          if (global.browser.isEdge() && raw.buttons === 0) {
	            return true;
	          }
	          return (raw.buttons & 1) !== 0;
	        };
	        var dragStart = function (_e) {
	          mouseHandlers.clearstate();
	        };
	        var mouseDown = function (e) {
	          if (isLeftMouse(e) && hasInternalTarget(e)) {
	            mouseHandlers.mousedown(fromRawEvent(e));
	          }
	        };
	        var mouseOver = function (e) {
	          if (isLeftButtonPressed(e) && hasInternalTarget(e)) {
	            mouseHandlers.mouseover(fromRawEvent(e));
	          }
	        };
	        var mouseUp = function (e) {
	          if (isLeftMouse(e) && hasInternalTarget(e)) {
	            mouseHandlers.mouseup(fromRawEvent(e));
	          }
	        };
	        var getDoubleTap = function () {
	          var lastTarget = Cell(SugarElement.fromDom(body));
	          var lastTimeStamp = Cell(0);
	          var touchEnd = function (t) {
	            var target = SugarElement.fromDom(t.target);
	            if (name(target) === 'td' || name(target) === 'th') {
	              var lT = lastTarget.get();
	              var lTS = lastTimeStamp.get();
	              if (eq$1(lT, target) && t.timeStamp - lTS < 300) {
	                t.preventDefault();
	                external$1(target, target);
	              }
	            }
	            lastTarget.set(target);
	            lastTimeStamp.set(t.timeStamp);
	          };
	          return { touchEnd: touchEnd };
	        };
	        var doubleTap = getDoubleTap();
	        editor.on('dragstart', dragStart);
	        editor.on('mousedown', mouseDown);
	        editor.on('mouseover', mouseOver);
	        editor.on('mouseup', mouseUp);
	        editor.on('touchend', doubleTap.touchEnd);
	        editor.on('keyup', keyup);
	        editor.on('keydown', keydown);
	        editor.on('NodeChange', syncSelection);
	      });
	      return { clear: annotations.clear };
	    }
	
	    var child = function (scope, selector) {
	      return child$1(scope, selector).isSome();
	    };
	
	    var getSelectionTargets = function (editor, selections) {
	      var targets = Cell(Optional.none());
	      var changeHandlers = Cell([]);
	      var selectionDetails = Optional.none();
	      var isCaption = isTag('caption');
	      var isDisabledForSelection = function (key) {
	        return selectionDetails.forall(function (details) {
	          return !details[key];
	        });
	      };
	      var getStart = function () {
	        return getSelectionCellOrCaption(getSelectionStart(editor), getIsRoot(editor));
	      };
	      var getEnd = function () {
	        return getSelectionCellOrCaption(getSelectionEnd(editor), getIsRoot(editor));
	      };
	      var findTargets = function () {
	        return getStart().bind(function (startCellOrCaption) {
	          return flatten(lift2(table(startCellOrCaption), getEnd().bind(table), function (startTable, endTable) {
	            if (eq$1(startTable, endTable)) {
	              if (isCaption(startCellOrCaption)) {
	                return Optional.some(noMenu(startCellOrCaption));
	              } else {
	                return Optional.some(forMenu(selections, startTable, startCellOrCaption));
	              }
	            }
	            return Optional.none();
	          }));
	        });
	      };
	      var getExtractedDetails = function (targets) {
	        var tableOpt = table(targets.element);
	        return tableOpt.map(function (table) {
	          var warehouse = Warehouse.fromTable(table);
	          var selectedCells = onCells(warehouse, targets).getOr([]);
	          var locked = foldl(selectedCells, function (acc, cell) {
	            if (cell.isLocked) {
	              acc.onAny = true;
	              if (cell.column === 0) {
	                acc.onFirst = true;
	              } else if (cell.column + cell.colspan >= warehouse.grid.columns) {
	                acc.onLast = true;
	              }
	            }
	            return acc;
	          }, {
	            onAny: false,
	            onFirst: false,
	            onLast: false
	          });
	          return {
	            mergeable: onUnlockedMergable(warehouse, targets).isSome(),
	            unmergeable: onUnlockedUnmergable(warehouse, targets).isSome(),
	            locked: locked
	          };
	        });
	      };
	      var resetTargets = function () {
	        targets.set(cached(findTargets)());
	        selectionDetails = targets.get().bind(getExtractedDetails);
	        each$2(changeHandlers.get(), function (handler) {
	          return handler();
	        });
	      };
	      var setupHandler = function (handler) {
	        handler();
	        changeHandlers.set(changeHandlers.get().concat([handler]));
	        return function () {
	          changeHandlers.set(filter$2(changeHandlers.get(), function (h) {
	            return h !== handler;
	          }));
	        };
	      };
	      var onSetup = function (api, isDisabled) {
	        return setupHandler(function () {
	          return targets.get().fold(function () {
	            api.setDisabled(true);
	          }, function (targets) {
	            api.setDisabled(isDisabled(targets));
	          });
	        });
	      };
	      var onSetupWithToggle = function (api, isDisabled, isActive) {
	        return setupHandler(function () {
	          return targets.get().fold(function () {
	            api.setDisabled(true);
	            api.setActive(false);
	          }, function (targets) {
	            api.setDisabled(isDisabled(targets));
	            api.setActive(isActive(targets));
	          });
	        });
	      };
	      var isDisabledFromLocked = function (lockedDisable) {
	        return selectionDetails.exists(function (details) {
	          return details.locked[lockedDisable];
	        });
	      };
	      var onSetupTable = function (api) {
	        return onSetup(api, function (_) {
	          return false;
	        });
	      };
	      var onSetupCellOrRow = function (api) {
	        return onSetup(api, function (targets) {
	          return isCaption(targets.element);
	        });
	      };
	      var onSetupColumn = function (lockedDisable) {
	        return function (api) {
	          return onSetup(api, function (targets) {
	            return isCaption(targets.element) || isDisabledFromLocked(lockedDisable);
	          });
	        };
	      };
	      var onSetupPasteable = function (getClipboardData) {
	        return function (api) {
	          return onSetup(api, function (targets) {
	            return isCaption(targets.element) || getClipboardData().isNone();
	          });
	        };
	      };
	      var onSetupPasteableColumn = function (getClipboardData, lockedDisable) {
	        return function (api) {
	          return onSetup(api, function (targets) {
	            return isCaption(targets.element) || getClipboardData().isNone() || isDisabledFromLocked(lockedDisable);
	          });
	        };
	      };
	      var onSetupMergeable = function (api) {
	        return onSetup(api, function (_targets) {
	          return isDisabledForSelection('mergeable');
	        });
	      };
	      var onSetupUnmergeable = function (api) {
	        return onSetup(api, function (_targets) {
	          return isDisabledForSelection('unmergeable');
	        });
	      };
	      var onSetupTableWithCaption = function (api) {
	        return onSetupWithToggle(api, never, function (targets) {
	          var tableOpt = table(targets.element, getIsRoot(editor));
	          return tableOpt.exists(function (table) {
	            return child(table, 'caption');
	          });
	        });
	      };
	      var onSetupTableHeaders = function (command, headerType) {
	        return function (api) {
	          return onSetupWithToggle(api, function (targets) {
	            return isCaption(targets.element);
	          }, function () {
	            return editor.queryCommandValue(command) === headerType;
	          });
	        };
	      };
	      var onSetupTableRowHeaders = onSetupTableHeaders('mceTableRowType', 'header');
	      var onSetupTableColumnHeaders = onSetupTableHeaders('mceTableColType', 'th');
	      editor.on('NodeChange ExecCommand TableSelectorChange', resetTargets);
	      return {
	        onSetupTable: onSetupTable,
	        onSetupCellOrRow: onSetupCellOrRow,
	        onSetupColumn: onSetupColumn,
	        onSetupPasteable: onSetupPasteable,
	        onSetupPasteableColumn: onSetupPasteableColumn,
	        onSetupMergeable: onSetupMergeable,
	        onSetupUnmergeable: onSetupUnmergeable,
	        resetTargets: resetTargets,
	        onSetupTableWithCaption: onSetupTableWithCaption,
	        onSetupTableRowHeaders: onSetupTableRowHeaders,
	        onSetupTableColumnHeaders: onSetupTableColumnHeaders,
	        targets: targets.get
	      };
	    };
	
	    var addButtons = function (editor, selections, selectionTargets, clipboard) {
	      editor.ui.registry.addMenuButton('table', {
	        tooltip: 'Table',
	        icon: 'table',
	        fetch: function (callback) {
	          return callback('inserttable | cell row column | advtablesort | tableprops deletetable');
	        }
	      });
	      var cmd = function (command) {
	        return function () {
	          return editor.execCommand(command);
	        };
	      };
	      editor.ui.registry.addButton('tableprops', {
	        tooltip: 'Table properties',
	        onAction: cmd('mceTableProps'),
	        icon: 'table',
	        onSetup: selectionTargets.onSetupTable
	      });
	      editor.ui.registry.addButton('tabledelete', {
	        tooltip: 'Delete table',
	        onAction: cmd('mceTableDelete'),
	        icon: 'table-delete-table',
	        onSetup: selectionTargets.onSetupTable
	      });
	      editor.ui.registry.addButton('tablecellprops', {
	        tooltip: 'Cell properties',
	        onAction: cmd('mceTableCellProps'),
	        icon: 'table-cell-properties',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tablemergecells', {
	        tooltip: 'Merge cells',
	        onAction: cmd('mceTableMergeCells'),
	        icon: 'table-merge-cells',
	        onSetup: selectionTargets.onSetupMergeable
	      });
	      editor.ui.registry.addButton('tablesplitcells', {
	        tooltip: 'Split cell',
	        onAction: cmd('mceTableSplitCells'),
	        icon: 'table-split-cells',
	        onSetup: selectionTargets.onSetupUnmergeable
	      });
	      editor.ui.registry.addButton('tableinsertrowbefore', {
	        tooltip: 'Insert row before',
	        onAction: cmd('mceTableInsertRowBefore'),
	        icon: 'table-insert-row-above',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tableinsertrowafter', {
	        tooltip: 'Insert row after',
	        onAction: cmd('mceTableInsertRowAfter'),
	        icon: 'table-insert-row-after',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tabledeleterow', {
	        tooltip: 'Delete row',
	        onAction: cmd('mceTableDeleteRow'),
	        icon: 'table-delete-row',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tablerowprops', {
	        tooltip: 'Row properties',
	        onAction: cmd('mceTableRowProps'),
	        icon: 'table-row-properties',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tableinsertcolbefore', {
	        tooltip: 'Insert column before',
	        onAction: cmd('mceTableInsertColBefore'),
	        icon: 'table-insert-column-before',
	        onSetup: selectionTargets.onSetupColumn('onFirst')
	      });
	      editor.ui.registry.addButton('tableinsertcolafter', {
	        tooltip: 'Insert column after',
	        onAction: cmd('mceTableInsertColAfter'),
	        icon: 'table-insert-column-after',
	        onSetup: selectionTargets.onSetupColumn('onLast')
	      });
	      editor.ui.registry.addButton('tabledeletecol', {
	        tooltip: 'Delete column',
	        onAction: cmd('mceTableDeleteCol'),
	        icon: 'table-delete-column',
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addButton('tablecutrow', {
	        tooltip: 'Cut row',
	        icon: 'cut-row',
	        onAction: cmd('mceTableCutRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tablecopyrow', {
	        tooltip: 'Copy row',
	        icon: 'duplicate-row',
	        onAction: cmd('mceTableCopyRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tablepasterowbefore', {
	        tooltip: 'Paste row before',
	        icon: 'paste-row-before',
	        onAction: cmd('mceTablePasteRowBefore'),
	        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
	      });
	      editor.ui.registry.addButton('tablepasterowafter', {
	        tooltip: 'Paste row after',
	        icon: 'paste-row-after',
	        onAction: cmd('mceTablePasteRowAfter'),
	        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
	      });
	      editor.ui.registry.addButton('tablecutcol', {
	        tooltip: 'Cut column',
	        icon: 'cut-column',
	        onAction: cmd('mceTableCutCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addButton('tablecopycol', {
	        tooltip: 'Copy column',
	        icon: 'duplicate-column',
	        onAction: cmd('mceTableCopyCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addButton('tablepastecolbefore', {
	        tooltip: 'Paste column before',
	        icon: 'paste-column-before',
	        onAction: cmd('mceTablePasteColBefore'),
	        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onFirst')
	      });
	      editor.ui.registry.addButton('tablepastecolafter', {
	        tooltip: 'Paste column after',
	        icon: 'paste-column-after',
	        onAction: cmd('mceTablePasteColAfter'),
	        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onLast')
	      });
	      editor.ui.registry.addButton('tableinsertdialog', {
	        tooltip: 'Insert table',
	        onAction: cmd('mceInsertTable'),
	        icon: 'table'
	      });
	      var tableClassList = filterNoneItem(getTableClassList(editor));
	      if (tableClassList.length !== 0) {
	        editor.ui.registry.addMenuButton('tableclass', {
	          icon: 'table-classes',
	          tooltip: 'Table styles',
	          fetch: generateMenuItemsCallback(editor, selections, tableClassList, 'tableclass', function (value) {
	            return editor.execCommand('mceTableToggleClass', false, value);
	          }),
	          onSetup: selectionTargets.onSetupTable
	        });
	      }
	      var tableCellClassList = filterNoneItem(getCellClassList(editor));
	      if (tableCellClassList.length !== 0) {
	        editor.ui.registry.addMenuButton('tablecellclass', {
	          icon: 'table-cell-classes',
	          tooltip: 'Cell styles',
	          fetch: generateMenuItemsCallback(editor, selections, tableCellClassList, 'tablecellclass', function (value) {
	            return editor.execCommand('mceTableCellToggleClass', false, value);
	          }),
	          onSetup: selectionTargets.onSetupCellOrRow
	        });
	      }
	      editor.ui.registry.addMenuButton('tablecellvalign', {
	        icon: 'vertical-align',
	        tooltip: 'Vertical align',
	        fetch: generateMenuItemsCallback(editor, selections, verticalAlignValues, 'tablecellverticalalign', applyTableCellStyle(editor, 'vertical-align')),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuButton('tablecellborderwidth', {
	        icon: 'border-width',
	        tooltip: 'Border width',
	        fetch: generateMenuItemsCallback(editor, selections, getTableBorderWidths(editor), 'tablecellborderwidth', applyTableCellStyle(editor, 'border-width')),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuButton('tablecellborderstyle', {
	        icon: 'border-style',
	        tooltip: 'Border style',
	        fetch: generateMenuItemsCallback(editor, selections, getTableBorderStyles(editor), 'tablecellborderstyle', applyTableCellStyle(editor, 'border-style')),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addToggleButton('tablecaption', {
	        tooltip: 'Table caption',
	        onAction: cmd('mceTableToggleCaption'),
	        icon: 'table-caption',
	        onSetup: selectionTargets.onSetupTableWithCaption
	      });
	      editor.ui.registry.addMenuButton('tablecellbackgroundcolor', {
	        icon: 'cell-background-color',
	        tooltip: 'Background color',
	        fetch: function (callback) {
	          return callback(buildColorMenu(editor, getTableBackgroundColorMap(editor), 'background-color'));
	        },
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuButton('tablecellbordercolor', {
	        icon: 'cell-border-color',
	        tooltip: 'Border color',
	        fetch: function (callback) {
	          return callback(buildColorMenu(editor, getTableBorderColorMap(editor), 'border-color'));
	        },
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addToggleButton('tablerowheader', {
	        tooltip: 'Row header',
	        icon: 'table-top-header',
	        onAction: changeRowHeader(editor),
	        onSetup: selectionTargets.onSetupTableRowHeaders
	      });
	      editor.ui.registry.addToggleButton('tablecolheader', {
	        tooltip: 'Column header',
	        icon: 'table-left-header',
	        onAction: changeColumnHeader(editor),
	        onSetup: selectionTargets.onSetupTableColumnHeaders
	      });
	    };
	    var addToolbars = function (editor) {
	      var isTable = function (table) {
	        return editor.dom.is(table, 'table') && editor.getBody().contains(table);
	      };
	      var toolbar = getToolbar(editor);
	      if (toolbar.length > 0) {
	        editor.ui.registry.addContextToolbar('table', {
	          predicate: isTable,
	          items: toolbar,
	          scope: 'node',
	          position: 'node'
	        });
	      }
	    };
	
	    var addMenuItems = function (editor, selections, selectionTargets, clipboard) {
	      var cmd = function (command) {
	        return function () {
	          return editor.execCommand(command);
	        };
	      };
	      var insertTableAction = function (data) {
	        editor.execCommand('mceInsertTable', false, {
	          rows: data.numRows,
	          columns: data.numColumns
	        });
	      };
	      var tableProperties = {
	        text: 'Table properties',
	        onSetup: selectionTargets.onSetupTable,
	        onAction: cmd('mceTableProps')
	      };
	      var deleteTable = {
	        text: 'Delete table',
	        icon: 'table-delete-table',
	        onSetup: selectionTargets.onSetupTable,
	        onAction: cmd('mceTableDelete')
	      };
	      editor.ui.registry.addMenuItem('tableinsertrowbefore', {
	        text: 'Insert row before',
	        icon: 'table-insert-row-above',
	        onAction: cmd('mceTableInsertRowBefore'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tableinsertrowafter', {
	        text: 'Insert row after',
	        icon: 'table-insert-row-after',
	        onAction: cmd('mceTableInsertRowAfter'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tabledeleterow', {
	        text: 'Delete row',
	        icon: 'table-delete-row',
	        onAction: cmd('mceTableDeleteRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablerowprops', {
	        text: 'Row properties',
	        icon: 'table-row-properties',
	        onAction: cmd('mceTableRowProps'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablecutrow', {
	        text: 'Cut row',
	        icon: 'cut-row',
	        onAction: cmd('mceTableCutRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablecopyrow', {
	        text: 'Copy row',
	        icon: 'duplicate-row',
	        onAction: cmd('mceTableCopyRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablepasterowbefore', {
	        text: 'Paste row before',
	        icon: 'paste-row-before',
	        onAction: cmd('mceTablePasteRowBefore'),
	        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
	      });
	      editor.ui.registry.addMenuItem('tablepasterowafter', {
	        text: 'Paste row after',
	        icon: 'paste-row-after',
	        onAction: cmd('mceTablePasteRowAfter'),
	        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
	      });
	      var row = {
	        type: 'nestedmenuitem',
	        text: 'Row',
	        getSubmenuItems: constant('tableinsertrowbefore tableinsertrowafter tabledeleterow tablerowprops | tablecutrow tablecopyrow tablepasterowbefore tablepasterowafter')
	      };
	      editor.ui.registry.addMenuItem('tableinsertcolumnbefore', {
	        text: 'Insert column before',
	        icon: 'table-insert-column-before',
	        onAction: cmd('mceTableInsertColBefore'),
	        onSetup: selectionTargets.onSetupColumn('onFirst')
	      });
	      editor.ui.registry.addMenuItem('tableinsertcolumnafter', {
	        text: 'Insert column after',
	        icon: 'table-insert-column-after',
	        onAction: cmd('mceTableInsertColAfter'),
	        onSetup: selectionTargets.onSetupColumn('onLast')
	      });
	      editor.ui.registry.addMenuItem('tabledeletecolumn', {
	        text: 'Delete column',
	        icon: 'table-delete-column',
	        onAction: cmd('mceTableDeleteCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addMenuItem('tablecutcolumn', {
	        text: 'Cut column',
	        icon: 'cut-column',
	        onAction: cmd('mceTableCutCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addMenuItem('tablecopycolumn', {
	        text: 'Copy column',
	        icon: 'duplicate-column',
	        onAction: cmd('mceTableCopyCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addMenuItem('tablepastecolumnbefore', {
	        text: 'Paste column before',
	        icon: 'paste-column-before',
	        onAction: cmd('mceTablePasteColBefore'),
	        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onFirst')
	      });
	      editor.ui.registry.addMenuItem('tablepastecolumnafter', {
	        text: 'Paste column after',
	        icon: 'paste-column-after',
	        onAction: cmd('mceTablePasteColAfter'),
	        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onLast')
	      });
	      var column = {
	        type: 'nestedmenuitem',
	        text: 'Column',
	        getSubmenuItems: constant('tableinsertcolumnbefore tableinsertcolumnafter tabledeletecolumn | tablecutcolumn tablecopycolumn tablepastecolumnbefore tablepastecolumnafter')
	      };
	      editor.ui.registry.addMenuItem('tablecellprops', {
	        text: 'Cell properties',
	        icon: 'table-cell-properties',
	        onAction: cmd('mceTableCellProps'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablemergecells', {
	        text: 'Merge cells',
	        icon: 'table-merge-cells',
	        onAction: cmd('mceTableMergeCells'),
	        onSetup: selectionTargets.onSetupMergeable
	      });
	      editor.ui.registry.addMenuItem('tablesplitcells', {
	        text: 'Split cell',
	        icon: 'table-split-cells',
	        onAction: cmd('mceTableSplitCells'),
	        onSetup: selectionTargets.onSetupUnmergeable
	      });
	      var cell = {
	        type: 'nestedmenuitem',
	        text: 'Cell',
	        getSubmenuItems: constant('tablecellprops tablemergecells tablesplitcells')
	      };
	      if (hasTableGrid(editor) === false) {
	        editor.ui.registry.addMenuItem('inserttable', {
	          text: 'Table',
	          icon: 'table',
	          onAction: cmd('mceInsertTable')
	        });
	      } else {
	        editor.ui.registry.addNestedMenuItem('inserttable', {
	          text: 'Table',
	          icon: 'table',
	          getSubmenuItems: function () {
	            return [{
	                type: 'fancymenuitem',
	                fancytype: 'inserttable',
	                onAction: insertTableAction
	              }];
	          }
	        });
	      }
	      editor.ui.registry.addMenuItem('inserttabledialog', {
	        text: 'Insert table',
	        icon: 'table',
	        onAction: cmd('mceInsertTable')
	      });
	      editor.ui.registry.addMenuItem('tableprops', tableProperties);
	      editor.ui.registry.addMenuItem('deletetable', deleteTable);
	      editor.ui.registry.addNestedMenuItem('row', row);
	      editor.ui.registry.addNestedMenuItem('column', column);
	      editor.ui.registry.addNestedMenuItem('cell', cell);
	      editor.ui.registry.addContextMenu('table', {
	        update: function () {
	          selectionTargets.resetTargets();
	          return selectionTargets.targets().fold(constant(''), function (targets) {
	            if (name(targets.element) === 'caption') {
	              return 'tableprops deletetable';
	            } else {
	              return 'cell row column | advtablesort | tableprops deletetable';
	            }
	          });
	        }
	      });
	      var tableClassList = filterNoneItem(getTableClassList(editor));
	      if (tableClassList.length !== 0) {
	        editor.ui.registry.addNestedMenuItem('tableclass', {
	          icon: 'table-classes',
	          text: 'Table styles',
	          getSubmenuItems: function () {
	            return buildMenuItems(editor, selections, tableClassList, 'tableclass', function (value) {
	              return editor.execCommand('mceTableToggleClass', false, value);
	            });
	          },
	          onSetup: selectionTargets.onSetupTable
	        });
	      }
	      var tableCellClassList = filterNoneItem(getCellClassList(editor));
	      if (tableCellClassList.length !== 0) {
	        editor.ui.registry.addNestedMenuItem('tablecellclass', {
	          icon: 'table-cell-classes',
	          text: 'Cell styles',
	          getSubmenuItems: function () {
	            return buildMenuItems(editor, selections, tableCellClassList, 'tablecellclass', function (value) {
	              return editor.execCommand('mceTableCellToggleClass', false, value);
	            });
	          },
	          onSetup: selectionTargets.onSetupCellOrRow
	        });
	      }
	      editor.ui.registry.addNestedMenuItem('tablecellvalign', {
	        icon: 'vertical-align',
	        text: 'Vertical align',
	        getSubmenuItems: function () {
	          return buildMenuItems(editor, selections, verticalAlignValues, 'tablecellverticalalign', applyTableCellStyle(editor, 'vertical-align'));
	        },
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addNestedMenuItem('tablecellborderwidth', {
	        icon: 'border-width',
	        text: 'Border width',
	        getSubmenuItems: function () {
	          return buildMenuItems(editor, selections, getTableBorderWidths(editor), 'tablecellborderwidth', applyTableCellStyle(editor, 'border-width'));
	        },
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addNestedMenuItem('tablecellborderstyle', {
	        icon: 'border-style',
	        text: 'Border style',
	        getSubmenuItems: function () {
	          return buildMenuItems(editor, selections, getTableBorderStyles(editor), 'tablecellborderstyle', applyTableCellStyle(editor, 'border-style'));
	        },
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addToggleMenuItem('tablecaption', {
	        icon: 'table-caption',
	        text: 'Table caption',
	        onAction: cmd('mceTableToggleCaption'),
	        onSetup: selectionTargets.onSetupTableWithCaption
	      });
	      editor.ui.registry.addNestedMenuItem('tablecellbackgroundcolor', {
	        icon: 'cell-background-color',
	        text: 'Background color',
	        getSubmenuItems: function () {
	          return buildColorMenu(editor, getTableBackgroundColorMap(editor), 'background-color');
	        },
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addNestedMenuItem('tablecellbordercolor', {
	        icon: 'cell-border-color',
	        text: 'Border color',
	        getSubmenuItems: function () {
	          return buildColorMenu(editor, getTableBorderColorMap(editor), 'border-color');
	        },
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addToggleMenuItem('tablerowheader', {
	        text: 'Row header',
	        icon: 'table-top-header',
	        onAction: changeRowHeader(editor),
	        onSetup: selectionTargets.onSetupTableRowHeaders
	      });
	      editor.ui.registry.addToggleMenuItem('tablecolheader', {
	        text: 'Column header',
	        icon: 'table-left-header',
	        onAction: changeColumnHeader(editor),
	        onSetup: selectionTargets.onSetupTableColumnHeaders
	      });
	    };
	
	    var Plugin = function (editor) {
	      var selections = Selections(function () {
	        return getBody(editor);
	      }, function () {
	        return getSelectionCell(getSelectionStart(editor), getIsRoot(editor));
	      }, ephemera.selectedSelector);
	      var selectionTargets = getSelectionTargets(editor, selections);
	      var resizeHandler = getResizeHandler(editor);
	      var cellSelection = CellSelection(editor, resizeHandler.lazyResize, selectionTargets);
	      var actions = TableActions(editor, cellSelection, resizeHandler.lazyWire);
	      var clipboard = Clipboard();
	      registerCommands(editor, actions, cellSelection, selections, clipboard);
	      registerQueryCommands(editor, actions, selections);
	      registerEvents(editor, selections, actions);
	      addMenuItems(editor, selections, selectionTargets, clipboard);
	      addButtons(editor, selections, selectionTargets, clipboard);
	      addToolbars(editor);
	      editor.on('PreInit', function () {
	        editor.serializer.addTempAttr(ephemera.firstSelected);
	        editor.serializer.addTempAttr(ephemera.lastSelected);
	        registerFormats(editor);
	      });
	      if (hasTabNavigation(editor)) {
	        editor.on('keydown', function (e) {
	          handle$1(e, editor, cellSelection);
	        });
	      }
	      editor.on('remove', function () {
	        resizeHandler.destroy();
	      });
	      return getApi(editor, clipboard, resizeHandler, selectionTargets);
	    };
	    function Plugin$1 () {
	      global$3.add('table', Plugin);
	    }
	
	    Plugin$1();
	
	}());


/***/ }),
/* 2256 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    function Plugin () {
	      global.add('textcolor', function () {
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2257 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var get$2 = function (toggleState) {
	      var isEnabled = function () {
	        return toggleState.get();
	      };
	      return { isEnabled: isEnabled };
	    };
	
	    var fireVisualChars = function (editor, state) {
	      return editor.fire('VisualChars', { state: state });
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType$1 = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var isString = isType$1('string');
	    var isBoolean = isSimpleType('boolean');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each$1 = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	
	    var keys = Object.keys;
	    var each = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	
	    typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var TEXT = 3;
	
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var value = function (element) {
	      return element.dom.nodeValue;
	    };
	    var isType = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isText = isType(TEXT);
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var get$1 = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var remove$3 = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	
	    var read = function (element, attr) {
	      var value = get$1(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add$2 = function (element, attr, id) {
	      var old = read(element, attr);
	      var nu = old.concat([id]);
	      set(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$2 = function (element, attr, id) {
	      var nu = filter(read(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set(element, attr, nu.join(' '));
	      } else {
	        remove$3(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom.classList !== undefined;
	    };
	    var get = function (element) {
	      return read(element, 'class');
	    };
	    var add$1 = function (element, clazz) {
	      return add$2(element, 'class', clazz);
	    };
	    var remove$1 = function (element, clazz) {
	      return remove$2(element, 'class', clazz);
	    };
	
	    var add = function (element, clazz) {
	      if (supports(element)) {
	        element.dom.classList.add(clazz);
	      } else {
	        add$1(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom.classList : get(element);
	      if (classList.length === 0) {
	        remove$3(element, 'class');
	      }
	    };
	    var remove = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom.classList;
	        classList.remove(clazz);
	      } else {
	        remove$1(element, clazz);
	      }
	      cleanClass(element);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var charMap = {
	      '\xA0': 'nbsp',
	      '\xAD': 'shy'
	    };
	    var charMapToRegExp = function (charMap, global) {
	      var regExp = '';
	      each(charMap, function (_value, key) {
	        regExp += key;
	      });
	      return new RegExp('[' + regExp + ']', global ? 'g' : '');
	    };
	    var charMapToSelector = function (charMap) {
	      var selector = '';
	      each(charMap, function (value) {
	        if (selector) {
	          selector += ',';
	        }
	        selector += 'span.mce-' + value;
	      });
	      return selector;
	    };
	    var regExp = charMapToRegExp(charMap);
	    var regExpGlobal = charMapToRegExp(charMap, true);
	    var selector = charMapToSelector(charMap);
	    var nbspClass = 'mce-nbsp';
	
	    var wrapCharWithSpan = function (value) {
	      return '<span data-mce-bogus="1" class="mce-' + charMap[value] + '">' + value + '</span>';
	    };
	
	    var isMatch = function (n) {
	      var value$1 = value(n);
	      return isText(n) && value$1 !== undefined && regExp.test(value$1);
	    };
	    var filterDescendants = function (scope, predicate) {
	      var result = [];
	      var dom = scope.dom;
	      var children = map(dom.childNodes, SugarElement.fromDom);
	      each$1(children, function (x) {
	        if (predicate(x)) {
	          result = result.concat([x]);
	        }
	        result = result.concat(filterDescendants(x, predicate));
	      });
	      return result;
	    };
	    var findParentElm = function (elm, rootElm) {
	      while (elm.parentNode) {
	        if (elm.parentNode === rootElm) {
	          return elm;
	        }
	        elm = elm.parentNode;
	      }
	    };
	    var replaceWithSpans = function (text) {
	      return text.replace(regExpGlobal, wrapCharWithSpan);
	    };
	
	    var isWrappedNbsp = function (node) {
	      return node.nodeName.toLowerCase() === 'span' && node.classList.contains('mce-nbsp-wrap');
	    };
	    var show = function (editor, rootElm) {
	      var nodeList = filterDescendants(SugarElement.fromDom(rootElm), isMatch);
	      each$1(nodeList, function (n) {
	        var parent = n.dom.parentNode;
	        if (isWrappedNbsp(parent)) {
	          add(SugarElement.fromDom(parent), nbspClass);
	        } else {
	          var withSpans = replaceWithSpans(editor.dom.encode(value(n)));
	          var div = editor.dom.create('div', null, withSpans);
	          var node = void 0;
	          while (node = div.lastChild) {
	            editor.dom.insertAfter(node, n.dom);
	          }
	          editor.dom.remove(n.dom);
	        }
	      });
	    };
	    var hide = function (editor, rootElm) {
	      var nodeList = editor.dom.select(selector, rootElm);
	      each$1(nodeList, function (node) {
	        if (isWrappedNbsp(node)) {
	          remove(SugarElement.fromDom(node), nbspClass);
	        } else {
	          editor.dom.remove(node, true);
	        }
	      });
	    };
	    var toggle = function (editor) {
	      var body = editor.getBody();
	      var bookmark = editor.selection.getBookmark();
	      var parentNode = findParentElm(editor.selection.getNode(), body);
	      parentNode = parentNode !== undefined ? parentNode : body;
	      hide(editor, parentNode);
	      show(editor, parentNode);
	      editor.selection.moveToBookmark(bookmark);
	    };
	
	    var applyVisualChars = function (editor, toggleState) {
	      fireVisualChars(editor, toggleState.get());
	      var body = editor.getBody();
	      if (toggleState.get() === true) {
	        show(editor, body);
	      } else {
	        hide(editor, body);
	      }
	    };
	    var toggleVisualChars = function (editor, toggleState) {
	      toggleState.set(!toggleState.get());
	      var bookmark = editor.selection.getBookmark();
	      applyVisualChars(editor, toggleState);
	      editor.selection.moveToBookmark(bookmark);
	    };
	
	    var register$1 = function (editor, toggleState) {
	      editor.addCommand('mceVisualChars', function () {
	        toggleVisualChars(editor, toggleState);
	      });
	    };
	
	    var isEnabledByDefault = function (editor) {
	      return editor.getParam('visualchars_default_state', false);
	    };
	    var hasForcedRootBlock = function (editor) {
	      return editor.getParam('forced_root_block') !== false;
	    };
	
	    var setup$1 = function (editor, toggleState) {
	      editor.on('init', function () {
	        applyVisualChars(editor, toggleState);
	      });
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var setup = function (editor, toggleState) {
	      var debouncedToggle = global.debounce(function () {
	        toggle(editor);
	      }, 300);
	      if (hasForcedRootBlock(editor)) {
	        editor.on('keydown', function (e) {
	          if (toggleState.get() === true) {
	            e.keyCode === 13 ? toggle(editor) : debouncedToggle();
	          }
	        });
	      }
	      editor.on('remove', debouncedToggle.stop);
	    };
	
	    var toggleActiveState = function (editor, enabledStated) {
	      return function (api) {
	        api.setActive(enabledStated.get());
	        var editorEventCallback = function (e) {
	          return api.setActive(e.state);
	        };
	        editor.on('VisualChars', editorEventCallback);
	        return function () {
	          return editor.off('VisualChars', editorEventCallback);
	        };
	      };
	    };
	    var register = function (editor, toggleState) {
	      var onAction = function () {
	        return editor.execCommand('mceVisualChars');
	      };
	      editor.ui.registry.addToggleButton('visualchars', {
	        tooltip: 'Show invisible characters',
	        icon: 'visualchars',
	        onAction: onAction,
	        onSetup: toggleActiveState(editor, toggleState)
	      });
	      editor.ui.registry.addToggleMenuItem('visualchars', {
	        text: 'Show invisible characters',
	        icon: 'visualchars',
	        onAction: onAction,
	        onSetup: toggleActiveState(editor, toggleState)
	      });
	    };
	
	    function Plugin () {
	      global$1.add('visualchars', function (editor) {
	        var toggleState = Cell(isEnabledByDefault(editor));
	        register$1(editor, toggleState);
	        register(editor, toggleState);
	        setup(editor, toggleState);
	        setup$1(editor, toggleState);
	        return get$2(toggleState);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.10.7 (2022-12-06)
	 */
	(function () {
	    'use strict';
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType$1 = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq$1 = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType$1('string');
	    var isObject = isType$1('object');
	    var isArray = isType$1('array');
	    var isNull = eq$1(null);
	    var isBoolean = isSimpleType('boolean');
	    var isUndefined = eq$1(undefined);
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	    var isArrayOf = function (value, pred) {
	      if (isArray(value)) {
	        for (var i = 0, len = value.length; i < len; ++i) {
	          if (!pred(value[i])) {
	            return false;
	          }
	        }
	        return true;
	      }
	      return false;
	    };
	
	    var noop = function () {
	    };
	    var noarg = function (f) {
	      return function () {
	        return f();
	      };
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var compose1 = function (fbc, fab) {
	      return function (a) {
	        return fbc(fab(a));
	      };
	    };
	    var constant$1 = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity$1 = function (x) {
	      return x;
	    };
	    var tripleEquals = function (a, b) {
	      return a === b;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function (t) {
	        return !f(t);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var never = constant$1(false);
	    var always = constant$1(true);
	
	    var global$g = tinymce.util.Tools.resolve('tinymce.ThemeManager');
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __rest(s, e) {
	      var t = {};
	      for (var p in s)
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	          t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	            t[p[i]] = s[p[i]];
	        }
	      return t;
	    }
	    function __spreadArray(to, from, pack) {
	      if (pack || arguments.length === 2)
	        for (var i = 0, l = from.length, ar; i < l; i++) {
	          if (ar || !(i in from)) {
	            if (!ar)
	              ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	          }
	        }
	      return to.concat(ar || Array.prototype.slice.call(from));
	    }
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = identity$1;
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant$1(null),
	        getOrUndefined: constant$1(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: function () {
	          return none();
	        },
	        toArray: function () {
	          return [];
	        },
	        toString: constant$1('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant$1(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	    var from$1 = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from$1
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var indexOf = function (xs, x) {
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Optional.none() : Optional.some(r);
	    };
	    var contains$2 = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var range$2 = function (num, f) {
	      var r = [];
	      for (var i = 0; i < num; i++) {
	        r.push(f(i));
	      }
	      return r;
	    };
	    var chunk$1 = function (array, size) {
	      var r = [];
	      for (var i = 0; i < array.length; i += size) {
	        var s = nativeSlice.call(array, i, i + size);
	        r.push(s);
	      }
	      return r;
	    };
	    var map$2 = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each$1 = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var partition$3 = function (xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i) ? pass : fail;
	        arr.push(x);
	      }
	      return {
	        pass: pass,
	        fail: fail
	      };
	    };
	    var filter$2 = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each$1(xs, function (x, i) {
	        acc = f(acc, x, i);
	      });
	      return acc;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find$5 = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var findIndex$1 = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(i);
	        }
	      }
	      return Optional.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind$3 = function (xs, f) {
	      return flatten(map$2(xs, f));
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var difference = function (a1, a2) {
	      return filter$2(a1, function (x) {
	        return !contains$2(a2, x);
	      });
	    };
	    var mapToObject = function (xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	    var pure$2 = function (x) {
	      return [x];
	    };
	    var sort = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	    var get$f = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get$f(xs, 0);
	    };
	    var last$2 = function (xs) {
	      return get$f(xs, xs.length - 1);
	    };
	    var from = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty$1 = Object.hasOwnProperty;
	    var each = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map$1 = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter$1 = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var mapToArray = function (obj, f) {
	      var r = [];
	      each(obj, function (value, name) {
	        r.push(f(value, name));
	      });
	      return r;
	    };
	    var find$4 = function (obj, pred) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        if (pred(x, i, obj)) {
	          return Optional.some(x);
	        }
	      }
	      return Optional.none();
	    };
	    var values = function (obj) {
	      return mapToArray(obj, identity$1);
	    };
	    var get$e = function (obj, key) {
	      return has$2(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has$2 = function (obj, key) {
	      return hasOwnProperty$1.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has$2(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	
	    var is$1 = function (lhs, rhs, comparator) {
	      if (comparator === void 0) {
	        comparator = tripleEquals;
	      }
	      return lhs.exists(function (left) {
	        return comparator(left, rhs);
	      });
	    };
	    var equals = function (lhs, rhs, comparator) {
	      if (comparator === void 0) {
	        comparator = tripleEquals;
	      }
	      return lift2(lhs, rhs, comparator).getOr(lhs.isNone() && rhs.isNone());
	    };
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var sequence = function (arr) {
	      var r = [];
	      for (var i = 0; i < arr.length; i++) {
	        var x = arr[i];
	        if (x.isSome()) {
	          r.push(x.getOrDie());
	        } else {
	          return Optional.none();
	        }
	      }
	      return Optional.some(r);
	    };
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
	    };
	    var lift3 = function (oa, ob, oc, f) {
	      return oa.isSome() && ob.isSome() && oc.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie(), oc.getOrDie())) : Optional.none();
	    };
	    var mapFrom = function (a, f) {
	      return a !== undefined && a !== null ? Optional.some(f(a)) : Optional.none();
	    };
	    var someIf = function (b, a) {
	      return b ? Optional.some(a) : Optional.none();
	    };
	
	    var addToEnd = function (str, suffix) {
	      return str + suffix;
	    };
	    var removeFromStart = function (str, numChars) {
	      return str.substring(numChars);
	    };
	
	    var checkRange = function (str, substr, start) {
	      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
	    };
	    var removeLeading = function (str, prefix) {
	      return startsWith(str, prefix) ? removeFromStart(str, prefix.length) : str;
	    };
	    var ensureTrailing = function (str, suffix) {
	      return endsWith(str, suffix) ? str : addToEnd(str, suffix);
	    };
	    var contains$1 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var startsWith = function (str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	    var endsWith = function (str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	    var blank = function (r) {
	      return function (s) {
	        return s.replace(r, '');
	      };
	    };
	    var trim$1 = blank(/^\s+|\s+$/g);
	    var isNotEmpty = function (s) {
	      return s.length > 0;
	    };
	    var isEmpty = function (s) {
	      return !isNotEmpty(s);
	    };
	
	    var isSupported$1 = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var fromHtml$2 = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml$2,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var name$2 = function (element) {
	      var r = element.dom.nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement$2 = isType(ELEMENT);
	    var isText$1 = isType(TEXT);
	    var isDocument = isType(DOCUMENT);
	    var isDocumentFragment = isType(DOCUMENT_FRAGMENT);
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var DeviceType = function (os, browser, userAgent, mediaMatch) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isMobile = os.isiOS() || os.isAndroid();
	      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
	      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
	      var isPhone = isiPhone || isMobile && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      var isDesktop = !isPhone && !isTablet && !iOSwebview;
	      return {
	        isiPad: constant$1(isiPad),
	        isiPhone: constant$1(isiPhone),
	        isTablet: constant$1(isTablet),
	        isPhone: constant$1(isPhone),
	        isTouch: constant$1(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant$1(iOSwebview),
	        isDesktop: constant$1(isDesktop)
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$3 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu$d(group(1), group(2));
	    };
	    var detect$4 = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown$3();
	      }
	      return find$3(versionRegexes, cleanedAgent);
	    };
	    var unknown$3 = function () {
	      return nu$d(0, 0);
	    };
	    var nu$d = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu$d,
	      detect: detect$4,
	      unknown: unknown$3
	    };
	
	    var detectBrowser$1 = function (browsers, userAgentData) {
	      return findMap(userAgentData.brands, function (uaBrand) {
	        var lcBrand = uaBrand.brand.toLowerCase();
	        return find$5(browsers, function (browser) {
	          var _a;
	          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
	        }).map(function (info) {
	          return {
	            current: info.name,
	            version: Version.nu(parseInt(uaBrand.version, 10), 0)
	          };
	        });
	      });
	    };
	
	    var detect$3 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find$5(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$3(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$3(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$1(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        brand: 'Chromium',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('mac os x'),
	        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      },
	      {
	        name: 'ChromeOS',
	        search: checkContains('cros'),
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant$1(browsers),
	      oses: constant$1(oses)
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var unknown$2 = function () {
	      return nu$c({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$c = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isBrowser = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge),
	        isChrome: isBrowser(chrome),
	        isIE: isBrowser(ie),
	        isOpera: isBrowser(opera),
	        isFirefox: isBrowser(firefox),
	        isSafari: isBrowser(safari)
	      };
	    };
	    var Browser = {
	      unknown: unknown$2,
	      nu: nu$c,
	      edge: constant$1(edge),
	      chrome: constant$1(chrome),
	      ie: constant$1(ie),
	      opera: constant$1(opera),
	      firefox: constant$1(firefox),
	      safari: constant$1(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var chromeos = 'ChromeOS';
	    var unknown$1 = function () {
	      return nu$b({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$b = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isOS = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows),
	        isiOS: isOS(ios),
	        isAndroid: isOS(android),
	        isOSX: isOS(osx),
	        isLinux: isOS(linux),
	        isSolaris: isOS(solaris),
	        isFreeBSD: isOS(freebsd),
	        isChromeOS: isOS(chromeos)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$1,
	      nu: nu$b,
	      windows: constant$1(windows),
	      ios: constant$1(ios),
	      android: constant$1(android),
	      linux: constant$1(linux),
	      osx: constant$1(osx),
	      solaris: constant$1(solaris),
	      freebsd: constant$1(freebsd),
	      chromeos: constant$1(chromeos)
	    };
	
	    var detect$2 = function (userAgent, userAgentDataOpt, mediaMatch) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = userAgentDataOpt.bind(function (userAgentData) {
	        return detectBrowser$1(browsers, userAgentData);
	      }).orThunk(function () {
	        return detectBrowser(browsers, userAgent);
	      }).fold(Browser.unknown, Browser.nu);
	      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var mediaMatch = function (query) {
	      return window.matchMedia(query).matches;
	    };
	    var platform = cached(function () {
	      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
	    });
	    var detect$1 = function () {
	      return platform();
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    var is = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all$3 = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map$2(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom;
	      var d2 = e2.dom;
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return documentPositionContainedBy(e1.dom, e2.dom);
	    };
	    var contains = function (e1, e2) {
	      return detect$1().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
	    };
	
	    var owner$4 = function (element) {
	      return SugarElement.fromDom(element.dom.ownerDocument);
	    };
	    var documentOrOwner = function (dos) {
	      return isDocument(dos) ? dos : owner$4(dos);
	    };
	    var documentElement = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.documentElement);
	    };
	    var defaultView = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
	    };
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var parentNode = function (element) {
	      return parent(element);
	    };
	    var offsetParent = function (element) {
	      return Optional.from(element.dom.offsetParent).map(SugarElement.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
	    };
	    var children = function (element) {
	      return map$2(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var child$2 = function (element, index) {
	      var cs = element.dom.childNodes;
	      return Optional.from(cs[index]).map(SugarElement.fromDom);
	    };
	    var firstChild = function (element) {
	      return child$2(element, 0);
	    };
	    var spot = function (element, offset) {
	      return {
	        element: element,
	        offset: offset
	      };
	    };
	    var leaf = function (element, offset) {
	      var cs = children(element);
	      return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
	    };
	
	    var isShadowRoot = function (dos) {
	      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
	    };
	    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
	    var isSupported = constant$1(supported);
	    var getRootNode = supported ? function (e) {
	      return SugarElement.fromDom(e.dom.getRootNode());
	    } : documentOrOwner;
	    var getContentContainer = function (dos) {
	      return isShadowRoot(dos) ? dos : SugarElement.fromDom(documentOrOwner(dos).dom.body);
	    };
	    var isInShadowRoot = function (e) {
	      return getShadowRoot(e).isSome();
	    };
	    var getShadowRoot = function (e) {
	      var r = getRootNode(e);
	      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
	    };
	    var getShadowHost = function (e) {
	      return SugarElement.fromDom(e.dom.host);
	    };
	    var getOriginalEventTarget = function (event) {
	      if (isSupported() && isNonNullable(event.target)) {
	        var el = SugarElement.fromDom(event.target);
	        if (isElement$2(el) && isOpenShadowHost(el)) {
	          if (event.composed && event.composedPath) {
	            var composedPath = event.composedPath();
	            if (composedPath) {
	              return head(composedPath);
	            }
	          }
	        }
	      }
	      return Optional.from(event.target);
	    };
	    var isOpenShadowHost = function (element) {
	      return isNonNullable(element.dom.shadowRoot);
	    };
	
	    var inBody = function (element) {
	      var dom = isText$1(element) ? element.dom.parentNode : element.dom;
	      if (dom === undefined || dom === null || dom.ownerDocument === null) {
	        return false;
	      }
	      var doc = dom.ownerDocument;
	      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
	        return doc.body.contains(dom);
	      }, compose1(inBody, getShadowHost));
	    };
	    var body = function () {
	      return getBody(SugarElement.fromDom(document));
	    };
	    var getBody = function (doc) {
	      var b = doc.dom.body;
	      if (b === null || b === undefined) {
	        throw new Error('Body is not available yet');
	      }
	      return SugarElement.fromDom(b);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set$8 = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var setAll$1 = function (element, attrs) {
	      var dom = element.dom;
	      each(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var get$d = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var getOpt = function (element, key) {
	      return Optional.from(get$d(element, key));
	    };
	    var has$1 = function (element, key) {
	      var dom = element.dom;
	      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
	    };
	    var remove$7 = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported$1(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var internalRemove = function (dom, property) {
	      if (isSupported$1(dom)) {
	        dom.style.removeProperty(property);
	      }
	    };
	    var set$7 = function (element, property, value) {
	      var dom = element.dom;
	      internalSet(dom, property, value);
	    };
	    var setAll = function (element, css) {
	      var dom = element.dom;
	      each(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var setOptions = function (element, css) {
	      var dom = element.dom;
	      each(css, function (v, k) {
	        v.fold(function () {
	          internalRemove(dom, k);
	        }, function (value) {
	          internalSet(dom, k, value);
	        });
	      });
	    };
	    var get$c = function (element, property) {
	      var dom = element.dom;
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported$1(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw = function (element, property) {
	      var dom = element.dom;
	      var raw = getUnsafeProperty(dom, property);
	      return Optional.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var getAllRaw = function (element) {
	      var css = {};
	      var dom = element.dom;
	      if (isSupported$1(dom)) {
	        for (var i = 0; i < dom.style.length; i++) {
	          var ruleName = dom.style.item(i);
	          css[ruleName] = dom.style[ruleName];
	        }
	      }
	      return css;
	    };
	    var isValidValue = function (tag, property, value) {
	      var element = SugarElement.fromTag(tag);
	      set$7(element, property, value);
	      var style = getRaw(element, property);
	      return style.isSome();
	    };
	    var remove$6 = function (element, property) {
	      var dom = element.dom;
	      internalRemove(dom, property);
	      if (is$1(getOpt(element, 'style').map(trim$1), '')) {
	        remove$7(element, 'style');
	      }
	    };
	    var reflow = function (e) {
	      return e.dom.offsetWidth;
	    };
	
	    var Dimension = function (name, getOffset) {
	      var set = function (element, h) {
	        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
	          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
	        }
	        var dom = element.dom;
	        if (isSupported$1(dom)) {
	          dom.style[name] = h + 'px';
	        }
	      };
	      var get = function (element) {
	        var r = getOffset(element);
	        if (r <= 0 || r === null) {
	          var css = get$c(element, name);
	          return parseFloat(css) || 0;
	        }
	        return r;
	      };
	      var getOuter = get;
	      var aggregate = function (element, properties) {
	        return foldl(properties, function (acc, property) {
	          var val = get$c(element, property);
	          var value = val === undefined ? 0 : parseInt(val, 10);
	          return isNaN(value) ? acc : acc + value;
	        }, 0);
	      };
	      var max = function (element, value, properties) {
	        var cumulativeInclusions = aggregate(element, properties);
	        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
	        return absoluteMax;
	      };
	      return {
	        set: set,
	        get: get,
	        getOuter: getOuter,
	        aggregate: aggregate,
	        max: max
	      };
	    };
	
	    var api$3 = Dimension('height', function (element) {
	      var dom = element.dom;
	      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
	    });
	    var get$b = function (element) {
	      return api$3.get(element);
	    };
	    var getOuter$2 = function (element) {
	      return api$3.getOuter(element);
	    };
	    var setMax$1 = function (element, value) {
	      var inclusions = [
	        'margin-top',
	        'border-top-width',
	        'padding-top',
	        'padding-bottom',
	        'border-bottom-width',
	        'margin-bottom'
	      ];
	      var absMax = api$3.max(element, value, inclusions);
	      set$7(element, 'max-height', absMax + 'px');
	    };
	
	    var r$1 = function (left, top) {
	      var translate = function (x, y) {
	        return r$1(left + x, top + y);
	      };
	      return {
	        left: left,
	        top: top,
	        translate: translate
	      };
	    };
	    var SugarPosition = r$1;
	
	    var boxPosition = function (dom) {
	      var box = dom.getBoundingClientRect();
	      return SugarPosition(box.left, box.top);
	    };
	    var firstDefinedOrZero = function (a, b) {
	      if (a !== undefined) {
	        return a;
	      } else {
	        return b !== undefined ? b : 0;
	      }
	    };
	    var absolute$3 = function (element) {
	      var doc = element.dom.ownerDocument;
	      var body = doc.body;
	      var win = doc.defaultView;
	      var html = doc.documentElement;
	      if (body === element.dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
	      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
	      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
	      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
	      return viewport$1(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
	    };
	    var viewport$1 = function (element) {
	      var dom = element.dom;
	      var doc = dom.ownerDocument;
	      var body = doc.body;
	      if (body === dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      if (!inBody(element)) {
	        return SugarPosition(0, 0);
	      }
	      return boxPosition(dom);
	    };
	
	    var api$2 = Dimension('width', function (element) {
	      return element.dom.offsetWidth;
	    });
	    var set$6 = function (element, h) {
	      return api$2.set(element, h);
	    };
	    var get$a = function (element) {
	      return api$2.get(element);
	    };
	    var getOuter$1 = function (element) {
	      return api$2.getOuter(element);
	    };
	    var setMax = function (element, value) {
	      var inclusions = [
	        'margin-left',
	        'border-left-width',
	        'padding-left',
	        'padding-right',
	        'border-right-width',
	        'margin-right'
	      ];
	      var absMax = api$2.max(element, value, inclusions);
	      set$7(element, 'max-width', absMax + 'px');
	    };
	
	    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
	      return {
	        target: target,
	        x: x,
	        y: y,
	        stop: stop,
	        prevent: prevent,
	        kill: kill,
	        raw: raw
	      };
	    };
	    var fromRawEvent$1 = function (rawEvent) {
	      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
	      var stop = function () {
	        return rawEvent.stopPropagation();
	      };
	      var prevent = function () {
	        return rawEvent.preventDefault();
	      };
	      var kill = compose(prevent, stop);
	      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
	    };
	    var handle = function (filter, handler) {
	      return function (rawEvent) {
	        if (filter(rawEvent)) {
	          handler(fromRawEvent$1(rawEvent));
	        }
	      };
	    };
	    var binder = function (element, event, filter, handler, useCapture) {
	      var wrapped = handle(filter, handler);
	      element.dom.addEventListener(event, wrapped, useCapture);
	      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
	    };
	    var bind$2 = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, false);
	    };
	    var capture$1 = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, true);
	    };
	    var unbind = function (element, event, handler, useCapture) {
	      element.dom.removeEventListener(event, handler, useCapture);
	    };
	
	    var before$2 = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var after$2 = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append$2(v, element);
	        });
	      }, function (v) {
	        before$2(v, element);
	      });
	    };
	    var prepend$1 = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append$2(parent, element);
	      }, function (v) {
	        parent.dom.insertBefore(element.dom, v.dom);
	      });
	    };
	    var append$2 = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	    var appendAt = function (parent, element, index) {
	      child$2(parent, index).fold(function () {
	        append$2(parent, element);
	      }, function (v) {
	        before$2(v, element);
	      });
	    };
	
	    var before$1 = function (marker, elements) {
	      each$1(elements, function (x) {
	        before$2(marker, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each$1(elements, function (x) {
	        append$2(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom.textContent = '';
	      each$1(children(element), function (rogue) {
	        remove$5(rogue);
	      });
	    };
	    var remove$5 = function (element) {
	      var dom = element.dom;
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children$1 = children(wrapper);
	      if (children$1.length > 0) {
	        before$1(wrapper, children$1);
	      }
	      remove$5(wrapper);
	    };
	
	    var get$9 = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return SugarPosition(x, y);
	    };
	    var to = function (x, y, _DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var win = doc.defaultView;
	      if (win) {
	        win.scrollTo(x, y);
	      }
	    };
	
	    var get$8 = function (_win) {
	      var win = _win === undefined ? window : _win;
	      if (detect$1().browser.isFirefox()) {
	        return Optional.none();
	      } else {
	        return Optional.from(win['visualViewport']);
	      }
	    };
	    var bounds$1 = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        right: x + width,
	        bottom: y + height
	      };
	    };
	    var getBounds$3 = function (_win) {
	      var win = _win === undefined ? window : _win;
	      var doc = win.document;
	      var scroll = get$9(SugarElement.fromDom(doc));
	      return get$8(win).fold(function () {
	        var html = win.document.documentElement;
	        var width = html.clientWidth;
	        var height = html.clientHeight;
	        return bounds$1(scroll.left, scroll.top, width, height);
	      }, function (visualViewport) {
	        return bounds$1(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
	      });
	    };
	
	    var walkUp = function (navigation, doc) {
	      var frame = navigation.view(doc);
	      return frame.fold(constant$1([]), function (f) {
	        var parent = navigation.owner(f);
	        var rest = walkUp(navigation, parent);
	        return [f].concat(rest);
	      });
	    };
	    var pathTo = function (element, navigation) {
	      var d = navigation.owner(element);
	      var paths = walkUp(navigation, d);
	      return Optional.some(paths);
	    };
	
	    var view = function (doc) {
	      var _a;
	      var element = doc.dom === document ? Optional.none() : Optional.from((_a = doc.dom.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement);
	      return element.map(SugarElement.fromDom);
	    };
	    var owner$3 = function (element) {
	      return owner$4(element);
	    };
	
	    var Navigation = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        view: view,
	        owner: owner$3
	    });
	
	    var find$2 = function (element) {
	      var doc = SugarElement.fromDom(document);
	      var scroll = get$9(doc);
	      var path = pathTo(element, Navigation);
	      return path.fold(curry(absolute$3, element), function (frames) {
	        var offset = viewport$1(element);
	        var r = foldr(frames, function (b, a) {
	          var loc = viewport$1(a);
	          return {
	            left: b.left + loc.left,
	            top: b.top + loc.top
	          };
	        }, {
	          left: 0,
	          top: 0
	        });
	        return SugarPosition(r.left + offset.left + scroll.left, r.top + offset.top + scroll.top);
	      });
	    };
	
	    var pointed = function (point, width, height) {
	      return {
	        point: point,
	        width: width,
	        height: height
	      };
	    };
	    var rect = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    };
	    var bounds = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        right: x + width,
	        bottom: y + height
	      };
	    };
	    var box$1 = function (element) {
	      var xy = absolute$3(element);
	      var w = getOuter$1(element);
	      var h = getOuter$2(element);
	      return bounds(xy.left, xy.top, w, h);
	    };
	    var absolute$2 = function (element) {
	      var position = find$2(element);
	      var width = getOuter$1(element);
	      var height = getOuter$2(element);
	      return bounds(position.left, position.top, width, height);
	    };
	    var win = function () {
	      return getBounds$3(window);
	    };
	
	    var value$3 = function (o) {
	      var or = function (_opt) {
	        return value$3(o);
	      };
	      var orThunk = function (_f) {
	        return value$3(o);
	      };
	      var map = function (f) {
	        return value$3(f(o));
	      };
	      var mapError = function (_f) {
	        return value$3(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOptional = function () {
	        return Optional.some(o);
	      };
	      return {
	        isValue: always,
	        isError: never,
	        getOr: constant$1(o),
	        getOrThunk: constant$1(o),
	        getOrDie: constant$1(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOptional: toOptional
	      };
	    };
	    var error$1 = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = identity$1;
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (_f) {
	        return error$1(message);
	      };
	      var mapError = function (f) {
	        return error$1(f(message));
	      };
	      var bind = function (_f) {
	        return error$1(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        isValue: never,
	        isError: always,
	        getOr: identity$1,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOptional: Optional.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error$1(err);
	      }, value$3);
	    };
	    var Result = {
	      value: value$3,
	      error: error$1,
	      fromOption: fromOption
	    };
	
	    var SimpleResultType;
	    (function (SimpleResultType) {
	      SimpleResultType[SimpleResultType['Error'] = 0] = 'Error';
	      SimpleResultType[SimpleResultType['Value'] = 1] = 'Value';
	    }(SimpleResultType || (SimpleResultType = {})));
	    var fold$1 = function (res, onError, onValue) {
	      return res.stype === SimpleResultType.Error ? onError(res.serror) : onValue(res.svalue);
	    };
	    var partition$2 = function (results) {
	      var values = [];
	      var errors = [];
	      each$1(results, function (obj) {
	        fold$1(obj, function (err) {
	          return errors.push(err);
	        }, function (val) {
	          return values.push(val);
	        });
	      });
	      return {
	        values: values,
	        errors: errors
	      };
	    };
	    var mapError = function (res, f) {
	      if (res.stype === SimpleResultType.Error) {
	        return {
	          stype: SimpleResultType.Error,
	          serror: f(res.serror)
	        };
	      } else {
	        return res;
	      }
	    };
	    var map = function (res, f) {
	      if (res.stype === SimpleResultType.Value) {
	        return {
	          stype: SimpleResultType.Value,
	          svalue: f(res.svalue)
	        };
	      } else {
	        return res;
	      }
	    };
	    var bind$1 = function (res, f) {
	      if (res.stype === SimpleResultType.Value) {
	        return f(res.svalue);
	      } else {
	        return res;
	      }
	    };
	    var bindError = function (res, f) {
	      if (res.stype === SimpleResultType.Error) {
	        return f(res.serror);
	      } else {
	        return res;
	      }
	    };
	    var svalue = function (v) {
	      return {
	        stype: SimpleResultType.Value,
	        svalue: v
	      };
	    };
	    var serror = function (e) {
	      return {
	        stype: SimpleResultType.Error,
	        serror: e
	      };
	    };
	    var toResult$1 = function (res) {
	      return fold$1(res, Result.error, Result.value);
	    };
	    var fromResult$1 = function (res) {
	      return res.fold(serror, svalue);
	    };
	    var SimpleResult = {
	      fromResult: fromResult$1,
	      toResult: toResult$1,
	      svalue: svalue,
	      partition: partition$2,
	      serror: serror,
	      bind: bind$1,
	      bindError: bindError,
	      map: map,
	      mapError: mapError,
	      fold: fold$1
	    };
	
	    var field$2 = function (key, newKey, presence, prop) {
	      return {
	        tag: 'field',
	        key: key,
	        newKey: newKey,
	        presence: presence,
	        prop: prop
	      };
	    };
	    var customField$1 = function (newKey, instantiator) {
	      return {
	        tag: 'custom',
	        newKey: newKey,
	        instantiator: instantiator
	      };
	    };
	    var fold = function (value, ifField, ifCustom) {
	      switch (value.tag) {
	      case 'field':
	        return ifField(value.key, value.newKey, value.presence, value.prop);
	      case 'custom':
	        return ifCustom(value.newKey, value.instantiator);
	      }
	    };
	
	    var shallow$1 = function (old, nu) {
	      return nu;
	    };
	    var deep = function (old, nu) {
	      var bothObjects = isObject(old) && isObject(nu);
	      return bothObjects ? deepMerge(old, nu) : nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          objects[_i] = arguments[_i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (has$2(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var deepMerge = baseMerge(deep);
	    var merge$1 = baseMerge(shallow$1);
	
	    var required$2 = function () {
	      return {
	        tag: 'required',
	        process: {}
	      };
	    };
	    var defaultedThunk = function (fallbackThunk) {
	      return {
	        tag: 'defaultedThunk',
	        process: fallbackThunk
	      };
	    };
	    var defaulted$1 = function (fallback) {
	      return defaultedThunk(constant$1(fallback));
	    };
	    var asOption = function () {
	      return {
	        tag: 'option',
	        process: {}
	      };
	    };
	    var mergeWithThunk = function (baseThunk) {
	      return {
	        tag: 'mergeWithThunk',
	        process: baseThunk
	      };
	    };
	    var mergeWith = function (base) {
	      return mergeWithThunk(constant$1(base));
	    };
	
	    var mergeValues$1 = function (values, base) {
	      return values.length > 0 ? SimpleResult.svalue(deepMerge(base, merge$1.apply(undefined, values))) : SimpleResult.svalue(base);
	    };
	    var mergeErrors$1 = function (errors) {
	      return compose(SimpleResult.serror, flatten)(errors);
	    };
	    var consolidateObj = function (objects, base) {
	      var partition = SimpleResult.partition(objects);
	      return partition.errors.length > 0 ? mergeErrors$1(partition.errors) : mergeValues$1(partition.values, base);
	    };
	    var consolidateArr = function (objects) {
	      var partitions = SimpleResult.partition(objects);
	      return partitions.errors.length > 0 ? mergeErrors$1(partitions.errors) : SimpleResult.svalue(partitions.values);
	    };
	    var ResultCombine = {
	      consolidateObj: consolidateObj,
	      consolidateArr: consolidateArr
	    };
	
	    var formatObj = function (input) {
	      return isObject(input) && keys(input).length > 100 ? ' removed due to size' : JSON.stringify(input, null, 2);
	    };
	    var formatErrors = function (errors) {
	      var es = errors.length > 10 ? errors.slice(0, 10).concat([{
	          path: [],
	          getErrorInfo: constant$1('... (only showing first ten failures)')
	        }]) : errors;
	      return map$2(es, function (e) {
	        return 'Failed path: (' + e.path.join(' > ') + ')\n' + e.getErrorInfo();
	      });
	    };
	
	    var nu$a = function (path, getErrorInfo) {
	      return SimpleResult.serror([{
	          path: path,
	          getErrorInfo: getErrorInfo
	        }]);
	    };
	    var missingRequired = function (path, key, obj) {
	      return nu$a(path, function () {
	        return 'Could not find valid *required* value for "' + key + '" in ' + formatObj(obj);
	      });
	    };
	    var missingKey = function (path, key) {
	      return nu$a(path, function () {
	        return 'Choice schema did not contain choice key: "' + key + '"';
	      });
	    };
	    var missingBranch = function (path, branches, branch) {
	      return nu$a(path, function () {
	        return 'The chosen schema: "' + branch + '" did not exist in branches: ' + formatObj(branches);
	      });
	    };
	    var unsupportedFields = function (path, unsupported) {
	      return nu$a(path, function () {
	        return 'There are unsupported fields: [' + unsupported.join(', ') + '] specified';
	      });
	    };
	    var custom = function (path, err) {
	      return nu$a(path, constant$1(err));
	    };
	
	    var value$2 = function (validator) {
	      var extract = function (path, val) {
	        return SimpleResult.bindError(validator(val), function (err) {
	          return custom(path, err);
	        });
	      };
	      var toString = constant$1('val');
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var anyValue$1 = value$2(SimpleResult.svalue);
	
	    var requiredAccess = function (path, obj, key, bundle) {
	      return get$e(obj, key).fold(function () {
	        return missingRequired(path, key, obj);
	      }, bundle);
	    };
	    var fallbackAccess = function (obj, key, fallback, bundle) {
	      var v = get$e(obj, key).getOrThunk(function () {
	        return fallback(obj);
	      });
	      return bundle(v);
	    };
	    var optionAccess = function (obj, key, bundle) {
	      return bundle(get$e(obj, key));
	    };
	    var optionDefaultedAccess = function (obj, key, fallback, bundle) {
	      var opt = get$e(obj, key).map(function (val) {
	        return val === true ? fallback(obj) : val;
	      });
	      return bundle(opt);
	    };
	    var extractField = function (field, path, obj, key, prop) {
	      var bundle = function (av) {
	        return prop.extract(path.concat([key]), av);
	      };
	      var bundleAsOption = function (optValue) {
	        return optValue.fold(function () {
	          return SimpleResult.svalue(Optional.none());
	        }, function (ov) {
	          var result = prop.extract(path.concat([key]), ov);
	          return SimpleResult.map(result, Optional.some);
	        });
	      };
	      switch (field.tag) {
	      case 'required':
	        return requiredAccess(path, obj, key, bundle);
	      case 'defaultedThunk':
	        return fallbackAccess(obj, key, field.process, bundle);
	      case 'option':
	        return optionAccess(obj, key, bundleAsOption);
	      case 'defaultedOptionThunk':
	        return optionDefaultedAccess(obj, key, field.process, bundleAsOption);
	      case 'mergeWithThunk': {
	          return fallbackAccess(obj, key, constant$1({}), function (v) {
	            var result = deepMerge(field.process(obj), v);
	            return bundle(result);
	          });
	        }
	      }
	    };
	    var extractFields = function (path, obj, fields) {
	      var success = {};
	      var errors = [];
	      for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
	        var field = fields_1[_i];
	        fold(field, function (key, newKey, presence, prop) {
	          var result = extractField(presence, path, obj, key, prop);
	          SimpleResult.fold(result, function (err) {
	            errors.push.apply(errors, err);
	          }, function (res) {
	            success[newKey] = res;
	          });
	        }, function (newKey, instantiator) {
	          success[newKey] = instantiator(obj);
	        });
	      }
	      return errors.length > 0 ? SimpleResult.serror(errors) : SimpleResult.svalue(success);
	    };
	    var valueThunk = function (getDelegate) {
	      var extract = function (path, val) {
	        return getDelegate().extract(path, val);
	      };
	      var toString = function () {
	        return getDelegate().toString();
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var getSetKeys = function (obj) {
	      return keys(filter$1(obj, isNonNullable));
	    };
	    var objOfOnly = function (fields) {
	      var delegate = objOf(fields);
	      var fieldNames = foldr(fields, function (acc, value) {
	        return fold(value, function (key) {
	          var _a;
	          return deepMerge(acc, (_a = {}, _a[key] = true, _a));
	        }, constant$1(acc));
	      }, {});
	      var extract = function (path, o) {
	        var keys = isBoolean(o) ? [] : getSetKeys(o);
	        var extra = filter$2(keys, function (k) {
	          return !hasNonNullableKey(fieldNames, k);
	        });
	        return extra.length === 0 ? delegate.extract(path, o) : unsupportedFields(path, extra);
	      };
	      return {
	        extract: extract,
	        toString: delegate.toString
	      };
	    };
	    var objOf = function (values) {
	      var extract = function (path, o) {
	        return extractFields(path, o, values);
	      };
	      var toString = function () {
	        var fieldStrings = map$2(values, function (value) {
	          return fold(value, function (key, _okey, _presence, prop) {
	            return key + ' -> ' + prop.toString();
	          }, function (newKey, _instantiator) {
	            return 'state(' + newKey + ')';
	          });
	        });
	        return 'obj{\n' + fieldStrings.join('\n') + '}';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var arrOf = function (prop) {
	      var extract = function (path, array) {
	        var results = map$2(array, function (a, i) {
	          return prop.extract(path.concat(['[' + i + ']']), a);
	        });
	        return ResultCombine.consolidateArr(results);
	      };
	      var toString = function () {
	        return 'array(' + prop.toString() + ')';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var oneOf = function (props) {
	      var extract = function (path, val) {
	        var errors = [];
	        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
	          var prop = props_1[_i];
	          var res = prop.extract(path, val);
	          if (res.stype === SimpleResultType.Value) {
	            return res;
	          }
	          errors.push(res);
	        }
	        return ResultCombine.consolidateArr(errors);
	      };
	      var toString = function () {
	        return 'oneOf(' + map$2(props, function (prop) {
	          return prop.toString();
	        }).join(', ') + ')';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var setOf$1 = function (validator, prop) {
	      var validateKeys = function (path, keys) {
	        return arrOf(value$2(validator)).extract(path, keys);
	      };
	      var extract = function (path, o) {
	        var keys$1 = keys(o);
	        var validatedKeys = validateKeys(path, keys$1);
	        return SimpleResult.bind(validatedKeys, function (validKeys) {
	          var schema = map$2(validKeys, function (vk) {
	            return field$2(vk, vk, required$2(), prop);
	          });
	          return objOf(schema).extract(path, o);
	        });
	      };
	      var toString = function () {
	        return 'setOf(' + prop.toString() + ')';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var thunk = function (_desc, processor) {
	      var getP = cached(processor);
	      var extract = function (path, val) {
	        return getP().extract(path, val);
	      };
	      var toString = function () {
	        return getP().toString();
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var arrOfObj = compose(arrOf, objOf);
	
	    var anyValue = constant$1(anyValue$1);
	    var typedValue = function (validator, expectedType) {
	      return value$2(function (a) {
	        var actualType = typeof a;
	        return validator(a) ? SimpleResult.svalue(a) : SimpleResult.serror('Expected type: ' + expectedType + ' but got: ' + actualType);
	      });
	    };
	    var number = typedValue(isNumber, 'number');
	    var string = typedValue(isString, 'string');
	    var boolean = typedValue(isBoolean, 'boolean');
	    var functionProcessor = typedValue(isFunction, 'function');
	    var isPostMessageable = function (val) {
	      if (Object(val) !== val) {
	        return true;
	      }
	      switch ({}.toString.call(val).slice(8, -1)) {
	      case 'Boolean':
	      case 'Number':
	      case 'String':
	      case 'Date':
	      case 'RegExp':
	      case 'Blob':
	      case 'FileList':
	      case 'ImageData':
	      case 'ImageBitmap':
	      case 'ArrayBuffer':
	        return true;
	      case 'Array':
	      case 'Object':
	        return Object.keys(val).every(function (prop) {
	          return isPostMessageable(val[prop]);
	        });
	      default:
	        return false;
	      }
	    };
	    var postMessageable = value$2(function (a) {
	      if (isPostMessageable(a)) {
	        return SimpleResult.svalue(a);
	      } else {
	        return SimpleResult.serror('Expected value to be acceptable for sending via postMessage');
	      }
	    });
	
	    var chooseFrom = function (path, input, branches, ch) {
	      var fields = get$e(branches, ch);
	      return fields.fold(function () {
	        return missingBranch(path, branches, ch);
	      }, function (vp) {
	        return vp.extract(path.concat(['branch: ' + ch]), input);
	      });
	    };
	    var choose$2 = function (key, branches) {
	      var extract = function (path, input) {
	        var choice = get$e(input, key);
	        return choice.fold(function () {
	          return missingKey(path, key);
	        }, function (chosen) {
	          return chooseFrom(path, input, branches, chosen);
	        });
	      };
	      var toString = function () {
	        return 'chooseOn(' + key + '). Possible values: ' + keys(branches);
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	
	    var arrOfVal = function () {
	      return arrOf(anyValue$1);
	    };
	    var valueOf = function (validator) {
	      return value$2(function (v) {
	        return validator(v).fold(SimpleResult.serror, SimpleResult.svalue);
	      });
	    };
	    var setOf = function (validator, prop) {
	      return setOf$1(function (v) {
	        return SimpleResult.fromResult(validator(v));
	      }, prop);
	    };
	    var extractValue = function (label, prop, obj) {
	      var res = prop.extract([label], obj);
	      return SimpleResult.mapError(res, function (errs) {
	        return {
	          input: obj,
	          errors: errs
	        };
	      });
	    };
	    var asRaw = function (label, prop, obj) {
	      return SimpleResult.toResult(extractValue(label, prop, obj));
	    };
	    var getOrDie = function (extraction) {
	      return extraction.fold(function (errInfo) {
	        throw new Error(formatError(errInfo));
	      }, identity$1);
	    };
	    var asRawOrDie$1 = function (label, prop, obj) {
	      return getOrDie(asRaw(label, prop, obj));
	    };
	    var formatError = function (errInfo) {
	      return 'Errors: \n' + formatErrors(errInfo.errors).join('\n') + '\n\nInput object: ' + formatObj(errInfo.input);
	    };
	    var choose$1 = function (key, branches) {
	      return choose$2(key, map$1(branches, objOf));
	    };
	    var thunkOf = function (desc, schema) {
	      return thunk(desc, schema);
	    };
	
	    var field$1 = field$2;
	    var customField = customField$1;
	    var validateEnum = function (values) {
	      return valueOf(function (value) {
	        return contains$2(values, value) ? Result.value(value) : Result.error('Unsupported value: "' + value + '", choose one of "' + values.join(', ') + '".');
	      });
	    };
	    var required$1 = function (key) {
	      return field$1(key, key, required$2(), anyValue());
	    };
	    var requiredOf = function (key, schema) {
	      return field$1(key, key, required$2(), schema);
	    };
	    var requiredNumber = function (key) {
	      return requiredOf(key, number);
	    };
	    var requiredString = function (key) {
	      return requiredOf(key, string);
	    };
	    var requiredStringEnum = function (key, values) {
	      return field$1(key, key, required$2(), validateEnum(values));
	    };
	    var requiredBoolean = function (key) {
	      return requiredOf(key, boolean);
	    };
	    var requiredFunction = function (key) {
	      return requiredOf(key, functionProcessor);
	    };
	    var forbid = function (key, message) {
	      return field$1(key, key, asOption(), value$2(function (_v) {
	        return SimpleResult.serror('The field: ' + key + ' is forbidden. ' + message);
	      }));
	    };
	    var requiredObjOf = function (key, objSchema) {
	      return field$1(key, key, required$2(), objOf(objSchema));
	    };
	    var requiredArrayOfObj = function (key, objFields) {
	      return field$1(key, key, required$2(), arrOfObj(objFields));
	    };
	    var requiredArrayOf = function (key, schema) {
	      return field$1(key, key, required$2(), arrOf(schema));
	    };
	    var option = function (key) {
	      return field$1(key, key, asOption(), anyValue());
	    };
	    var optionOf = function (key, schema) {
	      return field$1(key, key, asOption(), schema);
	    };
	    var optionNumber = function (key) {
	      return optionOf(key, number);
	    };
	    var optionString = function (key) {
	      return optionOf(key, string);
	    };
	    var optionFunction = function (key) {
	      return optionOf(key, functionProcessor);
	    };
	    var optionArrayOf = function (key, schema) {
	      return optionOf(key, arrOf(schema));
	    };
	    var optionObjOf = function (key, objSchema) {
	      return optionOf(key, objOf(objSchema));
	    };
	    var optionObjOfOnly = function (key, objSchema) {
	      return optionOf(key, objOfOnly(objSchema));
	    };
	    var defaulted = function (key, fallback) {
	      return field$1(key, key, defaulted$1(fallback), anyValue());
	    };
	    var defaultedOf = function (key, fallback, schema) {
	      return field$1(key, key, defaulted$1(fallback), schema);
	    };
	    var defaultedNumber = function (key, fallback) {
	      return defaultedOf(key, fallback, number);
	    };
	    var defaultedString = function (key, fallback) {
	      return defaultedOf(key, fallback, string);
	    };
	    var defaultedStringEnum = function (key, fallback, values) {
	      return defaultedOf(key, fallback, validateEnum(values));
	    };
	    var defaultedBoolean = function (key, fallback) {
	      return defaultedOf(key, fallback, boolean);
	    };
	    var defaultedFunction = function (key, fallback) {
	      return defaultedOf(key, fallback, functionProcessor);
	    };
	    var defaultedPostMsg = function (key, fallback) {
	      return defaultedOf(key, fallback, postMessageable);
	    };
	    var defaultedArrayOf = function (key, fallback, schema) {
	      return defaultedOf(key, fallback, arrOf(schema));
	    };
	    var defaultedObjOf = function (key, fallback, objSchema) {
	      return defaultedOf(key, fallback, objOf(objSchema));
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var generate$7 = function (cases) {
	      if (!isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each$1(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          var argLength = args.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains$2(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              var foldArgs = [];
	              for (var _i = 0; _i < arguments.length; _i++) {
	                foldArgs[_i] = arguments[_i];
	              }
	              if (foldArgs.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
	              }
	              var target = foldArgs[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate$7 };
	
	    Adt.generate([
	      {
	        bothErrors: [
	          'error1',
	          'error2'
	        ]
	      },
	      {
	        firstError: [
	          'error1',
	          'value2'
	        ]
	      },
	      {
	        secondError: [
	          'value1',
	          'error2'
	        ]
	      },
	      {
	        bothValues: [
	          'value1',
	          'value2'
	        ]
	      }
	    ]);
	    var partition$1 = function (results) {
	      var errors = [];
	      var values = [];
	      each$1(results, function (result) {
	        result.fold(function (err) {
	          errors.push(err);
	        }, function (value) {
	          values.push(value);
	        });
	      });
	      return {
	        errors: errors,
	        values: values
	      };
	    };
	
	    var exclude$1 = function (obj, fields) {
	      var r = {};
	      each(obj, function (v, k) {
	        if (!contains$2(fields, k)) {
	          r[k] = v;
	        }
	      });
	      return r;
	    };
	
	    var wrap$2 = function (key, value) {
	      var _a;
	      return _a = {}, _a[key] = value, _a;
	    };
	    var wrapAll$1 = function (keyvalues) {
	      var r = {};
	      each$1(keyvalues, function (kv) {
	        r[kv.key] = kv.value;
	      });
	      return r;
	    };
	
	    var exclude = function (obj, fields) {
	      return exclude$1(obj, fields);
	    };
	    var wrap$1 = function (key, value) {
	      return wrap$2(key, value);
	    };
	    var wrapAll = function (keyvalues) {
	      return wrapAll$1(keyvalues);
	    };
	    var mergeValues = function (values, base) {
	      return values.length === 0 ? Result.value(base) : Result.value(deepMerge(base, merge$1.apply(undefined, values)));
	    };
	    var mergeErrors = function (errors) {
	      return Result.error(flatten(errors));
	    };
	    var consolidate = function (objs, base) {
	      var partitions = partition$1(objs);
	      return partitions.errors.length > 0 ? mergeErrors(partitions.errors) : mergeValues(partitions.values, base);
	    };
	
	    var ensureIsRoot = function (isRoot) {
	      return isFunction(isRoot) ? isRoot : never;
	    };
	    var ancestor$2 = function (scope, transform, isRoot) {
	      var element = scope.dom;
	      var stop = ensureIsRoot(isRoot);
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        var transformed = transform(el);
	        if (transformed.isSome()) {
	          return transformed;
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest$4 = function (scope, transform, isRoot) {
	      var current = transform(scope);
	      var stop = ensureIsRoot(isRoot);
	      return current.orThunk(function () {
	        return stop(scope) ? Optional.none() : ancestor$2(scope, transform, stop);
	      });
	    };
	
	    var isSource = function (component, simulatedEvent) {
	      return eq(component.element, simulatedEvent.event.target);
	    };
	
	    var defaultEventHandler = {
	      can: always,
	      abort: never,
	      run: noop
	    };
	    var nu$9 = function (parts) {
	      if (!hasNonNullableKey(parts, 'can') && !hasNonNullableKey(parts, 'abort') && !hasNonNullableKey(parts, 'run')) {
	        throw new Error('EventHandler defined by: ' + JSON.stringify(parts, null, 2) + ' does not have can, abort, or run!');
	      }
	      return __assign(__assign({}, defaultEventHandler), parts);
	    };
	    var all$2 = function (handlers, f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return foldl(handlers, function (acc, handler) {
	          return acc && f(handler).apply(undefined, args);
	        }, true);
	      };
	    };
	    var any = function (handlers, f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return foldl(handlers, function (acc, handler) {
	          return acc || f(handler).apply(undefined, args);
	        }, false);
	      };
	    };
	    var read$2 = function (handler) {
	      return isFunction(handler) ? {
	        can: always,
	        abort: never,
	        run: handler
	      } : handler;
	    };
	    var fuse$1 = function (handlers) {
	      var can = all$2(handlers, function (handler) {
	        return handler.can;
	      });
	      var abort = any(handlers, function (handler) {
	        return handler.abort;
	      });
	      var run = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        each$1(handlers, function (handler) {
	          handler.run.apply(undefined, args);
	        });
	      };
	      return {
	        can: can,
	        abort: abort,
	        run: run
	      };
	    };
	
	    var constant = constant$1;
	    var touchstart = constant('touchstart');
	    var touchmove = constant('touchmove');
	    var touchend = constant('touchend');
	    var touchcancel = constant('touchcancel');
	    var mousedown = constant('mousedown');
	    var mousemove = constant('mousemove');
	    var mouseout = constant('mouseout');
	    var mouseup = constant('mouseup');
	    var mouseover = constant('mouseover');
	    var focusin = constant('focusin');
	    var focusout = constant('focusout');
	    var keydown = constant('keydown');
	    var keyup = constant('keyup');
	    var input = constant('input');
	    var change = constant('change');
	    var click = constant('click');
	    var transitioncancel = constant('transitioncancel');
	    var transitionend = constant('transitionend');
	    var transitionstart = constant('transitionstart');
	    var selectstart = constant('selectstart');
	
	    var prefixName = function (name) {
	      return constant$1('alloy.' + name);
	    };
	    var alloy = { tap: prefixName('tap') };
	    var focus$4 = prefixName('focus');
	    var postBlur = prefixName('blur.post');
	    var postPaste = prefixName('paste.post');
	    var receive = prefixName('receive');
	    var execute$5 = prefixName('execute');
	    var focusItem = prefixName('focus.item');
	    var tap = alloy.tap;
	    var longpress = prefixName('longpress');
	    var sandboxClose = prefixName('sandbox.close');
	    var typeaheadCancel = prefixName('typeahead.cancel');
	    var systemInit = prefixName('system.init');
	    var documentTouchmove = prefixName('system.touchmove');
	    var documentTouchend = prefixName('system.touchend');
	    var windowScroll = prefixName('system.scroll');
	    var windowResize = prefixName('system.resize');
	    var attachedToDom = prefixName('system.attached');
	    var detachedFromDom = prefixName('system.detached');
	    var dismissRequested = prefixName('system.dismissRequested');
	    var repositionRequested = prefixName('system.repositionRequested');
	    var focusShifted = prefixName('focusmanager.shifted');
	    var slotVisibility = prefixName('slotcontainer.visibility');
	    var changeTab = prefixName('change.tab');
	    var dismissTab = prefixName('dismiss.tab');
	    var highlight$1 = prefixName('highlight');
	    var dehighlight$1 = prefixName('dehighlight');
	
	    var emit = function (component, event) {
	      dispatchWith(component, component.element, event, {});
	    };
	    var emitWith = function (component, event, properties) {
	      dispatchWith(component, component.element, event, properties);
	    };
	    var emitExecute = function (component) {
	      emit(component, execute$5());
	    };
	    var dispatch = function (component, target, event) {
	      dispatchWith(component, target, event, {});
	    };
	    var dispatchWith = function (component, target, event, properties) {
	      var data = __assign({ target: target }, properties);
	      component.getSystem().triggerEvent(event, target, data);
	    };
	    var dispatchEvent = function (component, target, event, simulatedEvent) {
	      component.getSystem().triggerEvent(event, target, simulatedEvent.event);
	    };
	
	    var derive$2 = function (configs) {
	      return wrapAll(configs);
	    };
	    var abort = function (name, predicate) {
	      return {
	        key: name,
	        value: nu$9({ abort: predicate })
	      };
	    };
	    var can = function (name, predicate) {
	      return {
	        key: name,
	        value: nu$9({ can: predicate })
	      };
	    };
	    var preventDefault = function (name) {
	      return {
	        key: name,
	        value: nu$9({
	          run: function (component, simulatedEvent) {
	            simulatedEvent.event.prevent();
	          }
	        })
	      };
	    };
	    var run$1 = function (name, handler) {
	      return {
	        key: name,
	        value: nu$9({ run: handler })
	      };
	    };
	    var runActionExtra = function (name, action, extra) {
	      return {
	        key: name,
	        value: nu$9({
	          run: function (component, simulatedEvent) {
	            action.apply(undefined, [
	              component,
	              simulatedEvent
	            ].concat(extra));
	          }
	        })
	      };
	    };
	    var runOnName = function (name) {
	      return function (handler) {
	        return run$1(name, handler);
	      };
	    };
	    var runOnSourceName = function (name) {
	      return function (handler) {
	        return {
	          key: name,
	          value: nu$9({
	            run: function (component, simulatedEvent) {
	              if (isSource(component, simulatedEvent)) {
	                handler(component, simulatedEvent);
	              }
	            }
	          })
	        };
	      };
	    };
	    var redirectToUid = function (name, uid) {
	      return run$1(name, function (component, simulatedEvent) {
	        component.getSystem().getByUid(uid).each(function (redirectee) {
	          dispatchEvent(redirectee, redirectee.element, name, simulatedEvent);
	        });
	      });
	    };
	    var redirectToPart = function (name, detail, partName) {
	      var uid = detail.partUids[partName];
	      return redirectToUid(name, uid);
	    };
	    var runWithTarget = function (name, f) {
	      return run$1(name, function (component, simulatedEvent) {
	        var ev = simulatedEvent.event;
	        var target = component.getSystem().getByDom(ev.target).getOrThunk(function () {
	          var closest = closest$4(ev.target, function (el) {
	            return component.getSystem().getByDom(el).toOptional();
	          }, never);
	          return closest.getOr(component);
	        });
	        f(component, target, simulatedEvent);
	      });
	    };
	    var cutter = function (name) {
	      return run$1(name, function (component, simulatedEvent) {
	        simulatedEvent.cut();
	      });
	    };
	    var stopper = function (name) {
	      return run$1(name, function (component, simulatedEvent) {
	        simulatedEvent.stop();
	      });
	    };
	    var runOnSource = function (name, f) {
	      return runOnSourceName(name)(f);
	    };
	    var runOnAttached = runOnSourceName(attachedToDom());
	    var runOnDetached = runOnSourceName(detachedFromDom());
	    var runOnInit = runOnSourceName(systemInit());
	    var runOnExecute$1 = runOnName(execute$5());
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children(SugarElement.fromDom(div));
	    };
	
	    var get$7 = function (element) {
	      return element.dom.innerHTML;
	    };
	    var set$5 = function (element, content) {
	      var owner = owner$4(element);
	      var docDom = owner.dom;
	      var fragment = SugarElement.fromDom(docDom.createDocumentFragment());
	      var contentElements = fromHtml$1(content, docDom);
	      append$1(fragment, contentElements);
	      empty(element);
	      append$2(element, fragment);
	    };
	    var getOuter = function (element) {
	      var container = SugarElement.fromTag('div');
	      var clone = SugarElement.fromDom(element.dom.cloneNode(true));
	      append$2(container, clone);
	      return get$7(container);
	    };
	
	    var clone$2 = function (original, isDeep) {
	      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
	    };
	    var shallow = function (original) {
	      return clone$2(original, false);
	    };
	
	    var getHtml = function (element) {
	      if (isShadowRoot(element)) {
	        return '#shadow-root';
	      } else {
	        var clone = shallow(element);
	        return getOuter(clone);
	      }
	    };
	
	    var element = function (elem) {
	      return getHtml(elem);
	    };
	
	    var isRecursive = function (component, originator, target) {
	      return eq(originator, component.element) && !eq(originator, target);
	    };
	    var events$i = derive$2([can(focus$4(), function (component, simulatedEvent) {
	        var event = simulatedEvent.event;
	        var originator = event.originator;
	        var target = event.target;
	        if (isRecursive(component, originator, target)) {
	          console.warn(focus$4() + ' did not get interpreted by the desired target. ' + '\nOriginator: ' + element(originator) + '\nTarget: ' + element(target) + '\nCheck the ' + focus$4() + ' event handlers');
	          return false;
	        } else {
	          return true;
	        }
	      })]);
	
	    var DefaultEvents = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$i
	    });
	
	    var unique = 0;
	    var generate$6 = function (prefix) {
	      var date = new Date();
	      var time = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	      unique++;
	      return prefix + '_' + random + unique + String(time);
	    };
	
	    var prefix$1 = constant$1('alloy-id-');
	    var idAttr$1 = constant$1('data-alloy-id');
	
	    var prefix = prefix$1();
	    var idAttr = idAttr$1();
	    var write = function (label, elem) {
	      var id = generate$6(prefix + label);
	      writeOnly(elem, id);
	      return id;
	    };
	    var writeOnly = function (elem, uid) {
	      Object.defineProperty(elem.dom, idAttr, {
	        value: uid,
	        writable: true
	      });
	    };
	    var read$1 = function (elem) {
	      var id = isElement$2(elem) ? elem.dom[idAttr] : null;
	      return Optional.from(id);
	    };
	    var generate$5 = function (prefix) {
	      return generate$6(prefix);
	    };
	
	    var make$8 = identity$1;
	
	    var NoContextApi = function (getComp) {
	      var getMessage = function (event) {
	        return 'The component must be in a context to execute: ' + event + (getComp ? '\n' + element(getComp().element) + ' is not in context.' : '');
	      };
	      var fail = function (event) {
	        return function () {
	          throw new Error(getMessage(event));
	        };
	      };
	      var warn = function (event) {
	        return function () {
	          console.warn(getMessage(event));
	        };
	      };
	      return {
	        debugInfo: constant$1('fake'),
	        triggerEvent: warn('triggerEvent'),
	        triggerFocus: warn('triggerFocus'),
	        triggerEscape: warn('triggerEscape'),
	        broadcast: warn('broadcast'),
	        broadcastOn: warn('broadcastOn'),
	        broadcastEvent: warn('broadcastEvent'),
	        build: fail('build'),
	        addToWorld: fail('addToWorld'),
	        removeFromWorld: fail('removeFromWorld'),
	        addToGui: fail('addToGui'),
	        removeFromGui: fail('removeFromGui'),
	        getByUid: fail('getByUid'),
	        getByDom: fail('getByDom'),
	        isConnected: never
	      };
	    };
	    var singleton$1 = NoContextApi();
	
	    var markAsBehaviourApi = function (f, apiName, apiFunction) {
	      var delegate = apiFunction.toString();
	      var endIndex = delegate.indexOf(')') + 1;
	      var openBracketIndex = delegate.indexOf('(');
	      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
	      f.toFunctionAnnotation = function () {
	        return {
	          name: apiName,
	          parameters: cleanParameters(parameters.slice(0, 1).concat(parameters.slice(3)))
	        };
	      };
	      return f;
	    };
	    var cleanParameters = function (parameters) {
	      return map$2(parameters, function (p) {
	        return endsWith(p, '/*') ? p.substring(0, p.length - '/*'.length) : p;
	      });
	    };
	    var markAsExtraApi = function (f, extraName) {
	      var delegate = f.toString();
	      var endIndex = delegate.indexOf(')') + 1;
	      var openBracketIndex = delegate.indexOf('(');
	      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
	      f.toFunctionAnnotation = function () {
	        return {
	          name: extraName,
	          parameters: cleanParameters(parameters)
	        };
	      };
	      return f;
	    };
	    var markAsSketchApi = function (f, apiFunction) {
	      var delegate = apiFunction.toString();
	      var endIndex = delegate.indexOf(')') + 1;
	      var openBracketIndex = delegate.indexOf('(');
	      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
	      f.toFunctionAnnotation = function () {
	        return {
	          name: 'OVERRIDE',
	          parameters: cleanParameters(parameters.slice(1))
	        };
	      };
	      return f;
	    };
	
	    var premadeTag = generate$6('alloy-premade');
	    var premade$1 = function (comp) {
	      return wrap$1(premadeTag, comp);
	    };
	    var getPremade = function (spec) {
	      return get$e(spec, premadeTag);
	    };
	    var makeApi = function (f) {
	      return markAsSketchApi(function (component) {
	        var rest = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	          rest[_i - 1] = arguments[_i];
	        }
	        return f.apply(void 0, __spreadArray([
	          component.getApis(),
	          component
	        ], rest, false));
	      }, f);
	    };
	
	    var NoState = {
	      init: function () {
	        return nu$8({ readState: constant$1('No State required') });
	      }
	    };
	    var nu$8 = function (spec) {
	      return spec;
	    };
	
	    var generateFrom$1 = function (spec, all) {
	      var schema = map$2(all, function (a) {
	        return optionObjOf(a.name(), [
	          required$1('config'),
	          defaulted('state', NoState)
	        ]);
	      });
	      var validated = asRaw('component.behaviours', objOf(schema), spec.behaviours).fold(function (errInfo) {
	        throw new Error(formatError(errInfo) + '\nComplete spec:\n' + JSON.stringify(spec, null, 2));
	      }, identity$1);
	      return {
	        list: all,
	        data: map$1(validated, function (optBlobThunk) {
	          var output = optBlobThunk.map(function (blob) {
	            return {
	              config: blob.config,
	              state: blob.state.init(blob.config)
	            };
	          });
	          return constant$1(output);
	        })
	      };
	    };
	    var getBehaviours$3 = function (bData) {
	      return bData.list;
	    };
	    var getData$2 = function (bData) {
	      return bData.data;
	    };
	
	    var byInnerKey = function (data, tuple) {
	      var r = {};
	      each(data, function (detail, key) {
	        each(detail, function (value, indexKey) {
	          var chain = get$e(r, indexKey).getOr([]);
	          r[indexKey] = chain.concat([tuple(key, value)]);
	        });
	      });
	      return r;
	    };
	
	    var nu$7 = function (s) {
	      return {
	        classes: isUndefined(s.classes) ? [] : s.classes,
	        attributes: isUndefined(s.attributes) ? {} : s.attributes,
	        styles: isUndefined(s.styles) ? {} : s.styles
	      };
	    };
	    var merge = function (defnA, mod) {
	      return __assign(__assign({}, defnA), {
	        attributes: __assign(__assign({}, defnA.attributes), mod.attributes),
	        styles: __assign(__assign({}, defnA.styles), mod.styles),
	        classes: defnA.classes.concat(mod.classes)
	      });
	    };
	
	    var combine$2 = function (info, baseMod, behaviours, base) {
	      var modsByBehaviour = __assign({}, baseMod);
	      each$1(behaviours, function (behaviour) {
	        modsByBehaviour[behaviour.name()] = behaviour.exhibit(info, base);
	      });
	      var byAspect = byInnerKey(modsByBehaviour, function (name, modification) {
	        return {
	          name: name,
	          modification: modification
	        };
	      });
	      var combineObjects = function (objects) {
	        return foldr(objects, function (b, a) {
	          return __assign(__assign({}, a.modification), b);
	        }, {});
	      };
	      var combinedClasses = foldr(byAspect.classes, function (b, a) {
	        return a.modification.concat(b);
	      }, []);
	      var combinedAttributes = combineObjects(byAspect.attributes);
	      var combinedStyles = combineObjects(byAspect.styles);
	      return nu$7({
	        classes: combinedClasses,
	        attributes: combinedAttributes,
	        styles: combinedStyles
	      });
	    };
	
	    var sortKeys = function (label, keyName, array, order) {
	      try {
	        var sorted = sort(array, function (a, b) {
	          var aKey = a[keyName];
	          var bKey = b[keyName];
	          var aIndex = order.indexOf(aKey);
	          var bIndex = order.indexOf(bKey);
	          if (aIndex === -1) {
	            throw new Error('The ordering for ' + label + ' does not have an entry for ' + aKey + '.\nOrder specified: ' + JSON.stringify(order, null, 2));
	          }
	          if (bIndex === -1) {
	            throw new Error('The ordering for ' + label + ' does not have an entry for ' + bKey + '.\nOrder specified: ' + JSON.stringify(order, null, 2));
	          }
	          if (aIndex < bIndex) {
	            return -1;
	          } else if (bIndex < aIndex) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	        return Result.value(sorted);
	      } catch (err) {
	        return Result.error([err]);
	      }
	    };
	
	    var uncurried = function (handler, purpose) {
	      return {
	        handler: handler,
	        purpose: purpose
	      };
	    };
	    var curried = function (handler, purpose) {
	      return {
	        cHandler: handler,
	        purpose: purpose
	      };
	    };
	    var curryArgs = function (descHandler, extraArgs) {
	      return curried(curry.apply(undefined, [descHandler.handler].concat(extraArgs)), descHandler.purpose);
	    };
	    var getCurried = function (descHandler) {
	      return descHandler.cHandler;
	    };
	
	    var behaviourTuple = function (name, handler) {
	      return {
	        name: name,
	        handler: handler
	      };
	    };
	    var nameToHandlers = function (behaviours, info) {
	      var r = {};
	      each$1(behaviours, function (behaviour) {
	        r[behaviour.name()] = behaviour.handlers(info);
	      });
	      return r;
	    };
	    var groupByEvents = function (info, behaviours, base) {
	      var behaviourEvents = __assign(__assign({}, base), nameToHandlers(behaviours, info));
	      return byInnerKey(behaviourEvents, behaviourTuple);
	    };
	    var combine$1 = function (info, eventOrder, behaviours, base) {
	      var byEventName = groupByEvents(info, behaviours, base);
	      return combineGroups(byEventName, eventOrder);
	    };
	    var assemble = function (rawHandler) {
	      var handler = read$2(rawHandler);
	      return function (component, simulatedEvent) {
	        var rest = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	          rest[_i - 2] = arguments[_i];
	        }
	        var args = [
	          component,
	          simulatedEvent
	        ].concat(rest);
	        if (handler.abort.apply(undefined, args)) {
	          simulatedEvent.stop();
	        } else if (handler.can.apply(undefined, args)) {
	          handler.run.apply(undefined, args);
	        }
	      };
	    };
	    var missingOrderError = function (eventName, tuples) {
	      return Result.error(['The event (' + eventName + ') has more than one behaviour that listens to it.\nWhen this occurs, you must ' + 'specify an event ordering for the behaviours in your spec (e.g. [ "listing", "toggling" ]).\nThe behaviours that ' + 'can trigger it are: ' + JSON.stringify(map$2(tuples, function (c) {
	          return c.name;
	        }), null, 2)]);
	    };
	    var fuse = function (tuples, eventOrder, eventName) {
	      var order = eventOrder[eventName];
	      if (!order) {
	        return missingOrderError(eventName, tuples);
	      } else {
	        return sortKeys('Event: ' + eventName, 'name', tuples, order).map(function (sortedTuples) {
	          var handlers = map$2(sortedTuples, function (tuple) {
	            return tuple.handler;
	          });
	          return fuse$1(handlers);
	        });
	      }
	    };
	    var combineGroups = function (byEventName, eventOrder) {
	      var r = mapToArray(byEventName, function (tuples, eventName) {
	        var combined = tuples.length === 1 ? Result.value(tuples[0].handler) : fuse(tuples, eventOrder, eventName);
	        return combined.map(function (handler) {
	          var assembled = assemble(handler);
	          var purpose = tuples.length > 1 ? filter$2(eventOrder[eventName], function (o) {
	            return exists(tuples, function (t) {
	              return t.name === o;
	            });
	          }).join(' > ') : tuples[0].name;
	          return wrap$1(eventName, uncurried(assembled, purpose));
	        });
	      });
	      return consolidate(r, {});
	    };
	
	    var _a$2;
	    var baseBehaviour = 'alloy.base.behaviour';
	    var schema$z = objOf([
	      field$1('dom', 'dom', required$2(), objOf([
	        required$1('tag'),
	        defaulted('styles', {}),
	        defaulted('classes', []),
	        defaulted('attributes', {}),
	        option('value'),
	        option('innerHtml')
	      ])),
	      required$1('components'),
	      required$1('uid'),
	      defaulted('events', {}),
	      defaulted('apis', {}),
	      field$1('eventOrder', 'eventOrder', mergeWith((_a$2 = {}, _a$2[execute$5()] = [
	        'disabling',
	        baseBehaviour,
	        'toggling',
	        'typeaheadevents'
	      ], _a$2[focus$4()] = [
	        baseBehaviour,
	        'focusing',
	        'keying'
	      ], _a$2[systemInit()] = [
	        baseBehaviour,
	        'disabling',
	        'toggling',
	        'representing'
	      ], _a$2[input()] = [
	        baseBehaviour,
	        'representing',
	        'streaming',
	        'invalidating'
	      ], _a$2[detachedFromDom()] = [
	        baseBehaviour,
	        'representing',
	        'item-events',
	        'tooltipping'
	      ], _a$2[mousedown()] = [
	        'focusing',
	        baseBehaviour,
	        'item-type-events'
	      ], _a$2[touchstart()] = [
	        'focusing',
	        baseBehaviour,
	        'item-type-events'
	      ], _a$2[mouseover()] = [
	        'item-type-events',
	        'tooltipping'
	      ], _a$2[receive()] = [
	        'receiving',
	        'reflecting',
	        'tooltipping'
	      ], _a$2)), anyValue()),
	      option('domModification')
	    ]);
	    var toInfo = function (spec) {
	      return asRaw('custom.definition', schema$z, spec);
	    };
	    var toDefinition = function (detail) {
	      return __assign(__assign({}, detail.dom), {
	        uid: detail.uid,
	        domChildren: map$2(detail.components, function (comp) {
	          return comp.element;
	        })
	      });
	    };
	    var toModification = function (detail) {
	      return detail.domModification.fold(function () {
	        return nu$7({});
	      }, nu$7);
	    };
	    var toEvents = function (info) {
	      return info.events;
	    };
	
	    var read = function (element, attr) {
	      var value = get$d(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add$4 = function (element, attr, id) {
	      var old = read(element, attr);
	      var nu = old.concat([id]);
	      set$8(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$4 = function (element, attr, id) {
	      var nu = filter$2(read(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set$8(element, attr, nu.join(' '));
	      } else {
	        remove$7(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom.classList !== undefined;
	    };
	    var get$6 = function (element) {
	      return read(element, 'class');
	    };
	    var add$3 = function (element, clazz) {
	      return add$4(element, 'class', clazz);
	    };
	    var remove$3 = function (element, clazz) {
	      return remove$4(element, 'class', clazz);
	    };
	
	    var add$2 = function (element, clazz) {
	      if (supports(element)) {
	        element.dom.classList.add(clazz);
	      } else {
	        add$3(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom.classList : get$6(element);
	      if (classList.length === 0) {
	        remove$7(element, 'class');
	      }
	    };
	    var remove$2 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom.classList;
	        classList.remove(clazz);
	      } else {
	        remove$3(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has = function (element, clazz) {
	      return supports(element) && element.dom.classList.contains(clazz);
	    };
	
	    var add$1 = function (element, classes) {
	      each$1(classes, function (x) {
	        add$2(element, x);
	      });
	    };
	    var remove$1 = function (element, classes) {
	      each$1(classes, function (x) {
	        remove$2(element, x);
	      });
	    };
	    var hasAll = function (element, classes) {
	      return forall(classes, function (clazz) {
	        return has(element, clazz);
	      });
	    };
	
	    var get$5 = function (element) {
	      return element.dom.value;
	    };
	    var set$4 = function (element, value) {
	      if (value === undefined) {
	        throw new Error('Value.set was undefined');
	      }
	      element.dom.value = value;
	    };
	
	    var renderToDom = function (definition) {
	      var subject = SugarElement.fromTag(definition.tag);
	      setAll$1(subject, definition.attributes);
	      add$1(subject, definition.classes);
	      setAll(subject, definition.styles);
	      definition.innerHtml.each(function (html) {
	        return set$5(subject, html);
	      });
	      var children = definition.domChildren;
	      append$1(subject, children);
	      definition.value.each(function (value) {
	        set$4(subject, value);
	      });
	      if (!definition.uid) {
	        debugger;
	      }
	      writeOnly(subject, definition.uid);
	      return subject;
	    };
	
	    var getBehaviours$2 = function (spec) {
	      var behaviours = get$e(spec, 'behaviours').getOr({});
	      return bind$3(keys(behaviours), function (name) {
	        var behaviour = behaviours[name];
	        return isNonNullable(behaviour) ? [behaviour.me] : [];
	      });
	    };
	    var generateFrom = function (spec, all) {
	      return generateFrom$1(spec, all);
	    };
	    var generate$4 = function (spec) {
	      var all = getBehaviours$2(spec);
	      return generateFrom(spec, all);
	    };
	
	    var getDomDefinition = function (info, bList, bData) {
	      var definition = toDefinition(info);
	      var infoModification = toModification(info);
	      var baseModification = { 'alloy.base.modification': infoModification };
	      var modification = bList.length > 0 ? combine$2(bData, baseModification, bList, definition) : infoModification;
	      return merge(definition, modification);
	    };
	    var getEvents = function (info, bList, bData) {
	      var baseEvents = { 'alloy.base.behaviour': toEvents(info) };
	      return combine$1(bData, info.eventOrder, bList, baseEvents).getOrDie();
	    };
	    var build$2 = function (spec) {
	      var getMe = function () {
	        return me;
	      };
	      var systemApi = Cell(singleton$1);
	      var info = getOrDie(toInfo(spec));
	      var bBlob = generate$4(spec);
	      var bList = getBehaviours$3(bBlob);
	      var bData = getData$2(bBlob);
	      var modDefinition = getDomDefinition(info, bList, bData);
	      var item = renderToDom(modDefinition);
	      var events = getEvents(info, bList, bData);
	      var subcomponents = Cell(info.components);
	      var connect = function (newApi) {
	        systemApi.set(newApi);
	      };
	      var disconnect = function () {
	        systemApi.set(NoContextApi(getMe));
	      };
	      var syncComponents = function () {
	        var children$1 = children(item);
	        var subs = bind$3(children$1, function (child) {
	          return systemApi.get().getByDom(child).fold(function () {
	            return [];
	          }, pure$2);
	        });
	        subcomponents.set(subs);
	      };
	      var config = function (behaviour) {
	        var b = bData;
	        var f = isFunction(b[behaviour.name()]) ? b[behaviour.name()] : function () {
	          throw new Error('Could not find ' + behaviour.name() + ' in ' + JSON.stringify(spec, null, 2));
	        };
	        return f();
	      };
	      var hasConfigured = function (behaviour) {
	        return isFunction(bData[behaviour.name()]);
	      };
	      var getApis = function () {
	        return info.apis;
	      };
	      var readState = function (behaviourName) {
	        return bData[behaviourName]().map(function (b) {
	          return b.state.readState();
	        }).getOr('not enabled');
	      };
	      var me = {
	        uid: spec.uid,
	        getSystem: systemApi.get,
	        config: config,
	        hasConfigured: hasConfigured,
	        spec: spec,
	        readState: readState,
	        getApis: getApis,
	        connect: connect,
	        disconnect: disconnect,
	        element: item,
	        syncComponents: syncComponents,
	        components: subcomponents.get,
	        events: events
	      };
	      return me;
	    };
	
	    var buildSubcomponents = function (spec) {
	      var components = get$e(spec, 'components').getOr([]);
	      return map$2(components, build$1);
	    };
	    var buildFromSpec = function (userSpec) {
	      var _a = make$8(userSpec), specEvents = _a.events, spec = __rest(_a, ['events']);
	      var components = buildSubcomponents(spec);
	      var completeSpec = __assign(__assign({}, spec), {
	        events: __assign(__assign({}, DefaultEvents), specEvents),
	        components: components
	      });
	      return Result.value(build$2(completeSpec));
	    };
	    var text$1 = function (textContent) {
	      var element = SugarElement.fromText(textContent);
	      return external$2({ element: element });
	    };
	    var external$2 = function (spec) {
	      var extSpec = asRawOrDie$1('external.component', objOfOnly([
	        required$1('element'),
	        option('uid')
	      ]), spec);
	      var systemApi = Cell(NoContextApi());
	      var connect = function (newApi) {
	        systemApi.set(newApi);
	      };
	      var disconnect = function () {
	        systemApi.set(NoContextApi(function () {
	          return me;
	        }));
	      };
	      var uid = extSpec.uid.getOrThunk(function () {
	        return generate$5('external');
	      });
	      writeOnly(extSpec.element, uid);
	      var me = {
	        uid: uid,
	        getSystem: systemApi.get,
	        config: Optional.none,
	        hasConfigured: never,
	        connect: connect,
	        disconnect: disconnect,
	        getApis: function () {
	          return {};
	        },
	        element: extSpec.element,
	        spec: spec,
	        readState: constant$1('No state'),
	        syncComponents: noop,
	        components: constant$1([]),
	        events: {}
	      };
	      return premade$1(me);
	    };
	    var uids = generate$5;
	    var isSketchSpec$1 = function (spec) {
	      return has$2(spec, 'uid');
	    };
	    var build$1 = function (spec) {
	      return getPremade(spec).getOrThunk(function () {
	        var userSpecWithUid = isSketchSpec$1(spec) ? spec : __assign({ uid: uids('') }, spec);
	        return buildFromSpec(userSpecWithUid).getOrDie();
	      });
	    };
	    var premade = premade$1;
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      if (is(scope, a)) {
	        return Optional.some(scope);
	      } else if (isFunction(isRoot) && isRoot(scope)) {
	        return Optional.none();
	      } else {
	        return ancestor(scope, a, isRoot);
	      }
	    }
	
	    var ancestor$1 = function (scope, predicate, isRoot) {
	      var element = scope.dom;
	      var stop = isFunction(isRoot) ? isRoot : never;
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        if (predicate(el)) {
	          return Optional.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest$3 = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor$1, scope, predicate, isRoot);
	    };
	    var child$1 = function (scope, predicate) {
	      var pred = function (node) {
	        return predicate(SugarElement.fromDom(node));
	      };
	      var result = find$5(scope.dom.childNodes, pred);
	      return result.map(SugarElement.fromDom);
	    };
	    var descendant$1 = function (scope, predicate) {
	      var descend = function (node) {
	        for (var i = 0; i < node.childNodes.length; i++) {
	          var child_1 = SugarElement.fromDom(node.childNodes[i]);
	          if (predicate(child_1)) {
	            return Optional.some(child_1);
	          }
	          var res = descend(node.childNodes[i]);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Optional.none();
	      };
	      return descend(scope.dom);
	    };
	
	    var closest$2 = function (scope, predicate, isRoot) {
	      return closest$3(scope, predicate, isRoot).isSome();
	    };
	
	    var ancestor = function (scope, selector, isRoot) {
	      return ancestor$1(scope, function (e) {
	        return is(e, selector);
	      }, isRoot);
	    };
	    var child = function (scope, selector) {
	      return child$1(scope, function (e) {
	        return is(e, selector);
	      });
	    };
	    var descendant = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$1 = function (scope, selector, isRoot) {
	      var is$1 = function (element, selector) {
	        return is(element, selector);
	      };
	      return ClosestOrAncestor(is$1, ancestor, scope, selector, isRoot);
	    };
	
	    var find$1 = function (queryElem) {
	      var dependent = closest$3(queryElem, function (elem) {
	        if (!isElement$2(elem)) {
	          return false;
	        }
	        var id = get$d(elem, 'id');
	        return id !== undefined && id.indexOf('aria-owns') > -1;
	      });
	      return dependent.bind(function (dep) {
	        var id = get$d(dep, 'id');
	        var dos = getRootNode(dep);
	        return descendant(dos, '[aria-owns="' + id + '"]');
	      });
	    };
	    var manager = function () {
	      var ariaId = generate$6('aria-owns');
	      var link = function (elem) {
	        set$8(elem, 'aria-owns', ariaId);
	      };
	      var unlink = function (elem) {
	        remove$7(elem, 'aria-owns');
	      };
	      return {
	        id: ariaId,
	        link: link,
	        unlink: unlink
	      };
	    };
	
	    var isAriaPartOf = function (component, queryElem) {
	      return find$1(queryElem).exists(function (owner) {
	        return isPartOf$1(component, owner);
	      });
	    };
	    var isPartOf$1 = function (component, queryElem) {
	      return closest$2(queryElem, function (el) {
	        return eq(el, component.element);
	      }, never) || isAriaPartOf(component, queryElem);
	    };
	
	    var unknown = 'unknown';
	    var EventConfiguration;
	    (function (EventConfiguration) {
	      EventConfiguration[EventConfiguration['STOP'] = 0] = 'STOP';
	      EventConfiguration[EventConfiguration['NORMAL'] = 1] = 'NORMAL';
	      EventConfiguration[EventConfiguration['LOGGING'] = 2] = 'LOGGING';
	    }(EventConfiguration || (EventConfiguration = {})));
	    var eventConfig = Cell({});
	    var makeEventLogger = function (eventName, initialTarget) {
	      var sequence = [];
	      var startTime = new Date().getTime();
	      return {
	        logEventCut: function (_name, target, purpose) {
	          sequence.push({
	            outcome: 'cut',
	            target: target,
	            purpose: purpose
	          });
	        },
	        logEventStopped: function (_name, target, purpose) {
	          sequence.push({
	            outcome: 'stopped',
	            target: target,
	            purpose: purpose
	          });
	        },
	        logNoParent: function (_name, target, purpose) {
	          sequence.push({
	            outcome: 'no-parent',
	            target: target,
	            purpose: purpose
	          });
	        },
	        logEventNoHandlers: function (_name, target) {
	          sequence.push({
	            outcome: 'no-handlers-left',
	            target: target
	          });
	        },
	        logEventResponse: function (_name, target, purpose) {
	          sequence.push({
	            outcome: 'response',
	            purpose: purpose,
	            target: target
	          });
	        },
	        write: function () {
	          var finishTime = new Date().getTime();
	          if (contains$2([
	              'mousemove',
	              'mouseover',
	              'mouseout',
	              systemInit()
	            ], eventName)) {
	            return;
	          }
	          console.log(eventName, {
	            event: eventName,
	            time: finishTime - startTime,
	            target: initialTarget.dom,
	            sequence: map$2(sequence, function (s) {
	              if (!contains$2([
	                  'cut',
	                  'stopped',
	                  'response'
	                ], s.outcome)) {
	                return s.outcome;
	              } else {
	                return '{' + s.purpose + '} ' + s.outcome + ' at (' + element(s.target) + ')';
	              }
	            })
	          });
	        }
	      };
	    };
	    var processEvent = function (eventName, initialTarget, f) {
	      var status = get$e(eventConfig.get(), eventName).orThunk(function () {
	        var patterns = keys(eventConfig.get());
	        return findMap(patterns, function (p) {
	          return eventName.indexOf(p) > -1 ? Optional.some(eventConfig.get()[p]) : Optional.none();
	        });
	      }).getOr(EventConfiguration.NORMAL);
	      switch (status) {
	      case EventConfiguration.NORMAL:
	        return f(noLogger());
	      case EventConfiguration.LOGGING: {
	          var logger = makeEventLogger(eventName, initialTarget);
	          var output = f(logger);
	          logger.write();
	          return output;
	        }
	      case EventConfiguration.STOP:
	        return true;
	      }
	    };
	    var path = [
	      'alloy/data/Fields',
	      'alloy/debugging/Debugging'
	    ];
	    var getTrace = function () {
	      var err = new Error();
	      if (err.stack !== undefined) {
	        var lines = err.stack.split('\n');
	        return find$5(lines, function (line) {
	          return line.indexOf('alloy') > 0 && !exists(path, function (p) {
	            return line.indexOf(p) > -1;
	          });
	        }).getOr(unknown);
	      } else {
	        return unknown;
	      }
	    };
	    var ignoreEvent = {
	      logEventCut: noop,
	      logEventStopped: noop,
	      logNoParent: noop,
	      logEventNoHandlers: noop,
	      logEventResponse: noop,
	      write: noop
	    };
	    var monitorEvent = function (eventName, initialTarget, f) {
	      return processEvent(eventName, initialTarget, f);
	    };
	    var noLogger = constant$1(ignoreEvent);
	
	    var menuFields = constant$1([
	      required$1('menu'),
	      required$1('selectedMenu')
	    ]);
	    var itemFields = constant$1([
	      required$1('item'),
	      required$1('selectedItem')
	    ]);
	    constant$1(objOf(itemFields().concat(menuFields())));
	    var itemSchema$3 = constant$1(objOf(itemFields()));
	
	    var _initSize = requiredObjOf('initSize', [
	      required$1('numColumns'),
	      required$1('numRows')
	    ]);
	    var itemMarkers = function () {
	      return requiredOf('markers', itemSchema$3());
	    };
	    var tieredMenuMarkers = function () {
	      return requiredObjOf('markers', [required$1('backgroundMenu')].concat(menuFields()).concat(itemFields()));
	    };
	    var markers$1 = function (required) {
	      return requiredObjOf('markers', map$2(required, required$1));
	    };
	    var onPresenceHandler = function (label, fieldName, presence) {
	      getTrace();
	      return field$1(fieldName, fieldName, presence, valueOf(function (f) {
	        return Result.value(function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          return f.apply(undefined, args);
	        });
	      }));
	    };
	    var onHandler = function (fieldName) {
	      return onPresenceHandler('onHandler', fieldName, defaulted$1(noop));
	    };
	    var onKeyboardHandler = function (fieldName) {
	      return onPresenceHandler('onKeyboardHandler', fieldName, defaulted$1(Optional.none));
	    };
	    var onStrictHandler = function (fieldName) {
	      return onPresenceHandler('onHandler', fieldName, required$2());
	    };
	    var onStrictKeyboardHandler = function (fieldName) {
	      return onPresenceHandler('onKeyboardHandler', fieldName, required$2());
	    };
	    var output$1 = function (name, value) {
	      return customField(name, constant$1(value));
	    };
	    var snapshot = function (name) {
	      return customField(name, identity$1);
	    };
	    var initSize = constant$1(_initSize);
	
	    var nu$6 = function (x, y, bubble, direction, placement, boundsRestriction, labelPrefix, alwaysFit) {
	      if (alwaysFit === void 0) {
	        alwaysFit = false;
	      }
	      return {
	        x: x,
	        y: y,
	        bubble: bubble,
	        direction: direction,
	        placement: placement,
	        restriction: boundsRestriction,
	        label: labelPrefix + '-' + placement,
	        alwaysFit: alwaysFit
	      };
	    };
	
	    var adt$a = Adt.generate([
	      { southeast: [] },
	      { southwest: [] },
	      { northeast: [] },
	      { northwest: [] },
	      { south: [] },
	      { north: [] },
	      { east: [] },
	      { west: [] }
	    ]);
	    var cata$2 = function (subject, southeast, southwest, northeast, northwest, south, north, east, west) {
	      return subject.fold(southeast, southwest, northeast, northwest, south, north, east, west);
	    };
	    var cataVertical = function (subject, south, middle, north) {
	      return subject.fold(south, south, north, north, south, north, middle, middle);
	    };
	    var cataHorizontal = function (subject, east, middle, west) {
	      return subject.fold(east, west, east, west, middle, middle, east, west);
	    };
	    var southeast$3 = adt$a.southeast;
	    var southwest$3 = adt$a.southwest;
	    var northeast$3 = adt$a.northeast;
	    var northwest$3 = adt$a.northwest;
	    var south$3 = adt$a.south;
	    var north$3 = adt$a.north;
	    var east$3 = adt$a.east;
	    var west$3 = adt$a.west;
	
	    var cycleBy = function (value, delta, min, max) {
	      var r = value + delta;
	      if (r > max) {
	        return min;
	      } else if (r < min) {
	        return max;
	      } else {
	        return r;
	      }
	    };
	    var clamp$1 = function (value, min, max) {
	      return Math.min(Math.max(value, min), max);
	    };
	
	    var getRestriction = function (anchor, restriction) {
	      switch (restriction) {
	      case 1:
	        return anchor.x;
	      case 0:
	        return anchor.x + anchor.width;
	      case 2:
	        return anchor.y;
	      case 3:
	        return anchor.y + anchor.height;
	      }
	    };
	    var boundsRestriction = function (anchor, restrictions) {
	      return mapToObject([
	        'left',
	        'right',
	        'top',
	        'bottom'
	      ], function (dir) {
	        return get$e(restrictions, dir).map(function (restriction) {
	          return getRestriction(anchor, restriction);
	        });
	      });
	    };
	    var adjustBounds = function (bounds$1, restriction, bubbleOffset) {
	      var applyRestriction = function (dir, current) {
	        return restriction[dir].map(function (pos) {
	          var isVerticalAxis = dir === 'top' || dir === 'bottom';
	          var offset = isVerticalAxis ? bubbleOffset.top : bubbleOffset.left;
	          var comparator = dir === 'left' || dir === 'top' ? Math.max : Math.min;
	          var newPos = comparator(pos, current) + offset;
	          return isVerticalAxis ? clamp$1(newPos, bounds$1.y, bounds$1.bottom) : clamp$1(newPos, bounds$1.x, bounds$1.right);
	        }).getOr(current);
	      };
	      var adjustedLeft = applyRestriction('left', bounds$1.x);
	      var adjustedTop = applyRestriction('top', bounds$1.y);
	      var adjustedRight = applyRestriction('right', bounds$1.right);
	      var adjustedBottom = applyRestriction('bottom', bounds$1.bottom);
	      return bounds(adjustedLeft, adjustedTop, adjustedRight - adjustedLeft, adjustedBottom - adjustedTop);
	    };
	
	    var labelPrefix$2 = 'layout';
	    var eastX$1 = function (anchor) {
	      return anchor.x;
	    };
	    var middleX$1 = function (anchor, element) {
	      return anchor.x + anchor.width / 2 - element.width / 2;
	    };
	    var westX$1 = function (anchor, element) {
	      return anchor.x + anchor.width - element.width;
	    };
	    var northY$2 = function (anchor, element) {
	      return anchor.y - element.height;
	    };
	    var southY$2 = function (anchor) {
	      return anchor.y + anchor.height;
	    };
	    var centreY$1 = function (anchor, element) {
	      return anchor.y + anchor.height / 2 - element.height / 2;
	    };
	    var eastEdgeX$1 = function (anchor) {
	      return anchor.x + anchor.width;
	    };
	    var westEdgeX$1 = function (anchor, element) {
	      return anchor.x - element.width;
	    };
	    var southeast$2 = function (anchor, element, bubbles) {
	      return nu$6(eastX$1(anchor), southY$2(anchor), bubbles.southeast(), southeast$3(), 'southeast', boundsRestriction(anchor, {
	        left: 1,
	        top: 3
	      }), labelPrefix$2);
	    };
	    var southwest$2 = function (anchor, element, bubbles) {
	      return nu$6(westX$1(anchor, element), southY$2(anchor), bubbles.southwest(), southwest$3(), 'southwest', boundsRestriction(anchor, {
	        right: 0,
	        top: 3
	      }), labelPrefix$2);
	    };
	    var northeast$2 = function (anchor, element, bubbles) {
	      return nu$6(eastX$1(anchor), northY$2(anchor, element), bubbles.northeast(), northeast$3(), 'northeast', boundsRestriction(anchor, {
	        left: 1,
	        bottom: 2
	      }), labelPrefix$2);
	    };
	    var northwest$2 = function (anchor, element, bubbles) {
	      return nu$6(westX$1(anchor, element), northY$2(anchor, element), bubbles.northwest(), northwest$3(), 'northwest', boundsRestriction(anchor, {
	        right: 0,
	        bottom: 2
	      }), labelPrefix$2);
	    };
	    var north$2 = function (anchor, element, bubbles) {
	      return nu$6(middleX$1(anchor, element), northY$2(anchor, element), bubbles.north(), north$3(), 'north', boundsRestriction(anchor, { bottom: 2 }), labelPrefix$2);
	    };
	    var south$2 = function (anchor, element, bubbles) {
	      return nu$6(middleX$1(anchor, element), southY$2(anchor), bubbles.south(), south$3(), 'south', boundsRestriction(anchor, { top: 3 }), labelPrefix$2);
	    };
	    var east$2 = function (anchor, element, bubbles) {
	      return nu$6(eastEdgeX$1(anchor), centreY$1(anchor, element), bubbles.east(), east$3(), 'east', boundsRestriction(anchor, { left: 0 }), labelPrefix$2);
	    };
	    var west$2 = function (anchor, element, bubbles) {
	      return nu$6(westEdgeX$1(anchor, element), centreY$1(anchor, element), bubbles.west(), west$3(), 'west', boundsRestriction(anchor, { right: 1 }), labelPrefix$2);
	    };
	    var all$1 = function () {
	      return [
	        southeast$2,
	        southwest$2,
	        northeast$2,
	        northwest$2,
	        south$2,
	        north$2,
	        east$2,
	        west$2
	      ];
	    };
	    var allRtl$1 = function () {
	      return [
	        southwest$2,
	        southeast$2,
	        northwest$2,
	        northeast$2,
	        south$2,
	        north$2,
	        east$2,
	        west$2
	      ];
	    };
	    var aboveOrBelow = function () {
	      return [
	        northeast$2,
	        northwest$2,
	        southeast$2,
	        southwest$2,
	        north$2,
	        south$2
	      ];
	    };
	    var aboveOrBelowRtl = function () {
	      return [
	        northwest$2,
	        northeast$2,
	        southwest$2,
	        southeast$2,
	        north$2,
	        south$2
	      ];
	    };
	    var belowOrAbove = function () {
	      return [
	        southeast$2,
	        southwest$2,
	        northeast$2,
	        northwest$2,
	        south$2,
	        north$2
	      ];
	    };
	    var belowOrAboveRtl = function () {
	      return [
	        southwest$2,
	        southeast$2,
	        northwest$2,
	        northeast$2,
	        south$2,
	        north$2
	      ];
	    };
	
	    var chooseChannels = function (channels, message) {
	      return message.universal ? channels : filter$2(channels, function (ch) {
	        return contains$2(message.channels, ch);
	      });
	    };
	    var events$h = function (receiveConfig) {
	      return derive$2([run$1(receive(), function (component, message) {
	          var channelMap = receiveConfig.channels;
	          var channels = keys(channelMap);
	          var receivingData = message;
	          var targetChannels = chooseChannels(channels, receivingData);
	          each$1(targetChannels, function (ch) {
	            var channelInfo = channelMap[ch];
	            var channelSchema = channelInfo.schema;
	            var data = asRawOrDie$1('channel[' + ch + '] data\nReceiver: ' + element(component.element), channelSchema, receivingData.data);
	            channelInfo.onReceive(component, data);
	          });
	        })]);
	    };
	
	    var ActiveReceiving = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$h
	    });
	
	    var ReceivingSchema = [requiredOf('channels', setOf(Result.value, objOfOnly([
	        onStrictHandler('onReceive'),
	        defaulted('schema', anyValue())
	      ])))];
	
	    var executeEvent = function (bConfig, bState, executor) {
	      return runOnExecute$1(function (component) {
	        executor(component, bConfig, bState);
	      });
	    };
	    var loadEvent = function (bConfig, bState, f) {
	      return runOnInit(function (component, _simulatedEvent) {
	        f(component, bConfig, bState);
	      });
	    };
	    var create$9 = function (schema, name, active, apis, extra, state) {
	      var configSchema = objOfOnly(schema);
	      var schemaSchema = optionObjOf(name, [optionObjOfOnly('config', schema)]);
	      return doCreate(configSchema, schemaSchema, name, active, apis, extra, state);
	    };
	    var createModes$1 = function (modes, name, active, apis, extra, state) {
	      var configSchema = modes;
	      var schemaSchema = optionObjOf(name, [optionOf('config', modes)]);
	      return doCreate(configSchema, schemaSchema, name, active, apis, extra, state);
	    };
	    var wrapApi = function (bName, apiFunction, apiName) {
	      var f = function (component) {
	        var rest = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	          rest[_i - 1] = arguments[_i];
	        }
	        var args = [component].concat(rest);
	        return component.config({ name: constant$1(bName) }).fold(function () {
	          throw new Error('We could not find any behaviour configuration for: ' + bName + '. Using API: ' + apiName);
	        }, function (info) {
	          var rest = Array.prototype.slice.call(args, 1);
	          return apiFunction.apply(undefined, [
	            component,
	            info.config,
	            info.state
	          ].concat(rest));
	        });
	      };
	      return markAsBehaviourApi(f, apiName, apiFunction);
	    };
	    var revokeBehaviour = function (name) {
	      return {
	        key: name,
	        value: undefined
	      };
	    };
	    var doCreate = function (configSchema, schemaSchema, name, active, apis, extra, state) {
	      var getConfig = function (info) {
	        return hasNonNullableKey(info, name) ? info[name]() : Optional.none();
	      };
	      var wrappedApis = map$1(apis, function (apiF, apiName) {
	        return wrapApi(name, apiF, apiName);
	      });
	      var wrappedExtra = map$1(extra, function (extraF, extraName) {
	        return markAsExtraApi(extraF, extraName);
	      });
	      var me = __assign(__assign(__assign({}, wrappedExtra), wrappedApis), {
	        revoke: curry(revokeBehaviour, name),
	        config: function (spec) {
	          var prepared = asRawOrDie$1(name + '-config', configSchema, spec);
	          return {
	            key: name,
	            value: {
	              config: prepared,
	              me: me,
	              configAsRaw: cached(function () {
	                return asRawOrDie$1(name + '-config', configSchema, spec);
	              }),
	              initialConfig: spec,
	              state: state
	            }
	          };
	        },
	        schema: constant$1(schemaSchema),
	        exhibit: function (info, base) {
	          return lift2(getConfig(info), get$e(active, 'exhibit'), function (behaviourInfo, exhibitor) {
	            return exhibitor(base, behaviourInfo.config, behaviourInfo.state);
	          }).getOrThunk(function () {
	            return nu$7({});
	          });
	        },
	        name: constant$1(name),
	        handlers: function (info) {
	          return getConfig(info).map(function (behaviourInfo) {
	            var getEvents = get$e(active, 'events').getOr(function () {
	              return {};
	            });
	            return getEvents(behaviourInfo.config, behaviourInfo.state);
	          }).getOr({});
	        }
	      });
	      return me;
	    };
	
	    var derive$1 = function (capabilities) {
	      return wrapAll(capabilities);
	    };
	    var simpleSchema = objOfOnly([
	      required$1('fields'),
	      required$1('name'),
	      defaulted('active', {}),
	      defaulted('apis', {}),
	      defaulted('state', NoState),
	      defaulted('extra', {})
	    ]);
	    var create$8 = function (data) {
	      var value = asRawOrDie$1('Creating behaviour: ' + data.name, simpleSchema, data);
	      return create$9(value.fields, value.name, value.active, value.apis, value.extra, value.state);
	    };
	    var modeSchema = objOfOnly([
	      required$1('branchKey'),
	      required$1('branches'),
	      required$1('name'),
	      defaulted('active', {}),
	      defaulted('apis', {}),
	      defaulted('state', NoState),
	      defaulted('extra', {})
	    ]);
	    var createModes = function (data) {
	      var value = asRawOrDie$1('Creating behaviour: ' + data.name, modeSchema, data);
	      return createModes$1(choose$1(value.branchKey, value.branches), value.name, value.active, value.apis, value.extra, value.state);
	    };
	    var revoke = constant$1(undefined);
	
	    var Receiving = create$8({
	      fields: ReceivingSchema,
	      name: 'receiving',
	      active: ActiveReceiving
	    });
	
	    var exhibit$6 = function (base, posConfig) {
	      return nu$7({
	        classes: [],
	        styles: posConfig.useFixed() ? {} : { position: 'relative' }
	      });
	    };
	
	    var ActivePosition = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$6
	    });
	
	    var getDocument = function () {
	      return SugarElement.fromDom(document);
	    };
	
	    var focus$3 = function (element) {
	      return element.dom.focus();
	    };
	    var blur$1 = function (element) {
	      return element.dom.blur();
	    };
	    var hasFocus = function (element) {
	      var root = getRootNode(element).dom;
	      return element.dom === root.activeElement;
	    };
	    var active = function (root) {
	      if (root === void 0) {
	        root = getDocument();
	      }
	      return Optional.from(root.dom.activeElement).map(SugarElement.fromDom);
	    };
	    var search = function (element) {
	      return active(getRootNode(element)).filter(function (e) {
	        return element.dom.contains(e.dom);
	      });
	    };
	
	    var preserve$1 = function (f, container) {
	      var dos = getRootNode(container);
	      var refocus = active(dos).bind(function (focused) {
	        var hasFocus = function (elem) {
	          return eq(focused, elem);
	        };
	        return hasFocus(container) ? Optional.some(container) : descendant$1(container, hasFocus);
	      });
	      var result = f(container);
	      refocus.each(function (oldFocus) {
	        active(dos).filter(function (newFocus) {
	          return eq(newFocus, oldFocus);
	        }).fold(function () {
	          focus$3(oldFocus);
	        }, noop);
	      });
	      return result;
	    };
	
	    var NuPositionCss = function (position, left, top, right, bottom) {
	      var toPx = function (num) {
	        return num + 'px';
	      };
	      return {
	        position: position,
	        left: left.map(toPx),
	        top: top.map(toPx),
	        right: right.map(toPx),
	        bottom: bottom.map(toPx)
	      };
	    };
	    var toOptions = function (position) {
	      return __assign(__assign({}, position), { position: Optional.some(position.position) });
	    };
	    var applyPositionCss = function (element, position) {
	      setOptions(element, toOptions(position));
	    };
	
	    var adt$9 = Adt.generate([
	      { none: [] },
	      {
	        relative: [
	          'x',
	          'y',
	          'width',
	          'height'
	        ]
	      },
	      {
	        fixed: [
	          'x',
	          'y',
	          'width',
	          'height'
	        ]
	      }
	    ]);
	    var positionWithDirection = function (posName, decision, x, y, width, height) {
	      var decisionRect = decision.rect;
	      var decisionX = decisionRect.x - x;
	      var decisionY = decisionRect.y - y;
	      var decisionWidth = decisionRect.width;
	      var decisionHeight = decisionRect.height;
	      var decisionRight = width - (decisionX + decisionWidth);
	      var decisionBottom = height - (decisionY + decisionHeight);
	      var left = Optional.some(decisionX);
	      var top = Optional.some(decisionY);
	      var right = Optional.some(decisionRight);
	      var bottom = Optional.some(decisionBottom);
	      var none = Optional.none();
	      return cata$2(decision.direction, function () {
	        return NuPositionCss(posName, left, top, none, none);
	      }, function () {
	        return NuPositionCss(posName, none, top, right, none);
	      }, function () {
	        return NuPositionCss(posName, left, none, none, bottom);
	      }, function () {
	        return NuPositionCss(posName, none, none, right, bottom);
	      }, function () {
	        return NuPositionCss(posName, left, top, none, none);
	      }, function () {
	        return NuPositionCss(posName, left, none, none, bottom);
	      }, function () {
	        return NuPositionCss(posName, left, top, none, none);
	      }, function () {
	        return NuPositionCss(posName, none, top, right, none);
	      });
	    };
	    var reposition = function (origin, decision) {
	      return origin.fold(function () {
	        var decisionRect = decision.rect;
	        return NuPositionCss('absolute', Optional.some(decisionRect.x), Optional.some(decisionRect.y), Optional.none(), Optional.none());
	      }, function (x, y, width, height) {
	        return positionWithDirection('absolute', decision, x, y, width, height);
	      }, function (x, y, width, height) {
	        return positionWithDirection('fixed', decision, x, y, width, height);
	      });
	    };
	    var toBox = function (origin, element) {
	      var rel = curry(find$2, element);
	      var position = origin.fold(rel, rel, function () {
	        var scroll = get$9();
	        return find$2(element).translate(-scroll.left, -scroll.top);
	      });
	      var width = getOuter$1(element);
	      var height = getOuter$2(element);
	      return bounds(position.left, position.top, width, height);
	    };
	    var viewport = function (origin, getBounds) {
	      return getBounds.fold(function () {
	        return origin.fold(win, win, bounds);
	      }, function (b) {
	        return origin.fold(b, b, function () {
	          var bounds$1 = b();
	          var pos = translate$2(origin, bounds$1.x, bounds$1.y);
	          return bounds(pos.left, pos.top, bounds$1.width, bounds$1.height);
	        });
	      });
	    };
	    var translate$2 = function (origin, x, y) {
	      var pos = SugarPosition(x, y);
	      var removeScroll = function () {
	        var outerScroll = get$9();
	        return pos.translate(-outerScroll.left, -outerScroll.top);
	      };
	      return origin.fold(constant$1(pos), constant$1(pos), removeScroll);
	    };
	    var cata$1 = function (subject, onNone, onRelative, onFixed) {
	      return subject.fold(onNone, onRelative, onFixed);
	    };
	    adt$9.none;
	    var relative$1 = adt$9.relative;
	    var fixed$1 = adt$9.fixed;
	
	    var anchor = function (anchorBox, origin) {
	      return {
	        anchorBox: anchorBox,
	        origin: origin
	      };
	    };
	    var box = function (anchorBox, origin) {
	      return anchor(anchorBox, origin);
	    };
	
	    var placementAttribute = 'data-alloy-placement';
	    var setPlacement$1 = function (element, placement) {
	      set$8(element, placementAttribute, placement);
	    };
	    var getPlacement = function (element) {
	      return getOpt(element, placementAttribute);
	    };
	    var reset$2 = function (element) {
	      return remove$7(element, placementAttribute);
	    };
	
	    var adt$8 = Adt.generate([
	      { fit: ['reposition'] },
	      {
	        nofit: [
	          'reposition',
	          'visibleW',
	          'visibleH',
	          'isVisible'
	        ]
	      }
	    ]);
	    var determinePosition = function (box, bounds) {
	      var boundsX = bounds.x, boundsY = bounds.y, boundsRight = bounds.right, boundsBottom = bounds.bottom;
	      var x = box.x, y = box.y, right = box.right, bottom = box.bottom, width = box.width, height = box.height;
	      var xInBounds = x >= boundsX && x <= boundsRight;
	      var yInBounds = y >= boundsY && y <= boundsBottom;
	      var originInBounds = xInBounds && yInBounds;
	      var rightInBounds = right <= boundsRight && right >= boundsX;
	      var bottomInBounds = bottom <= boundsBottom && bottom >= boundsY;
	      var sizeInBounds = rightInBounds && bottomInBounds;
	      var visibleW = Math.min(width, x >= boundsX ? boundsRight - x : right - boundsX);
	      var visibleH = Math.min(height, y >= boundsY ? boundsBottom - y : bottom - boundsY);
	      return {
	        originInBounds: originInBounds,
	        sizeInBounds: sizeInBounds,
	        visibleW: visibleW,
	        visibleH: visibleH
	      };
	    };
	    var calcReposition = function (box, bounds$1) {
	      var boundsX = bounds$1.x, boundsY = bounds$1.y, boundsRight = bounds$1.right, boundsBottom = bounds$1.bottom;
	      var x = box.x, y = box.y, width = box.width, height = box.height;
	      var maxX = Math.max(boundsX, boundsRight - width);
	      var maxY = Math.max(boundsY, boundsBottom - height);
	      var restrictedX = clamp$1(x, boundsX, maxX);
	      var restrictedY = clamp$1(y, boundsY, maxY);
	      var restrictedWidth = Math.min(restrictedX + width, boundsRight) - restrictedX;
	      var restrictedHeight = Math.min(restrictedY + height, boundsBottom) - restrictedY;
	      return bounds(restrictedX, restrictedY, restrictedWidth, restrictedHeight);
	    };
	    var calcMaxSizes = function (direction, box, bounds) {
	      var upAvailable = constant$1(box.bottom - bounds.y);
	      var downAvailable = constant$1(bounds.bottom - box.y);
	      var maxHeight = cataVertical(direction, downAvailable, downAvailable, upAvailable);
	      var westAvailable = constant$1(box.right - bounds.x);
	      var eastAvailable = constant$1(bounds.right - box.x);
	      var maxWidth = cataHorizontal(direction, eastAvailable, eastAvailable, westAvailable);
	      return {
	        maxWidth: maxWidth,
	        maxHeight: maxHeight
	      };
	    };
	    var attempt = function (candidate, width, height, bounds$1) {
	      var bubble = candidate.bubble;
	      var bubbleOffset = bubble.offset;
	      var adjustedBounds = adjustBounds(bounds$1, candidate.restriction, bubbleOffset);
	      var newX = candidate.x + bubbleOffset.left;
	      var newY = candidate.y + bubbleOffset.top;
	      var box = bounds(newX, newY, width, height);
	      var _a = determinePosition(box, adjustedBounds), originInBounds = _a.originInBounds, sizeInBounds = _a.sizeInBounds, visibleW = _a.visibleW, visibleH = _a.visibleH;
	      var fits = originInBounds && sizeInBounds;
	      var fittedBox = fits ? box : calcReposition(box, adjustedBounds);
	      var isPartlyVisible = fittedBox.width > 0 && fittedBox.height > 0;
	      var _b = calcMaxSizes(candidate.direction, fittedBox, bounds$1), maxWidth = _b.maxWidth, maxHeight = _b.maxHeight;
	      var reposition = {
	        rect: fittedBox,
	        maxHeight: maxHeight,
	        maxWidth: maxWidth,
	        direction: candidate.direction,
	        placement: candidate.placement,
	        classes: {
	          on: bubble.classesOn,
	          off: bubble.classesOff
	        },
	        layout: candidate.label,
	        testY: newY
	      };
	      return fits || candidate.alwaysFit ? adt$8.fit(reposition) : adt$8.nofit(reposition, visibleW, visibleH, isPartlyVisible);
	    };
	    var attempts = function (element, candidates, anchorBox, elementBox, bubbles, bounds) {
	      var panelWidth = elementBox.width;
	      var panelHeight = elementBox.height;
	      var attemptBestFit = function (layout, reposition, visibleW, visibleH, isVisible) {
	        var next = layout(anchorBox, elementBox, bubbles, element, bounds);
	        var attemptLayout = attempt(next, panelWidth, panelHeight, bounds);
	        return attemptLayout.fold(constant$1(attemptLayout), function (newReposition, newVisibleW, newVisibleH, newIsVisible) {
	          var improved = isVisible === newIsVisible ? newVisibleH > visibleH || newVisibleW > visibleW : !isVisible && newIsVisible;
	          return improved ? attemptLayout : adt$8.nofit(reposition, visibleW, visibleH, isVisible);
	        });
	      };
	      var abc = foldl(candidates, function (b, a) {
	        var bestNext = curry(attemptBestFit, a);
	        return b.fold(constant$1(b), bestNext);
	      }, adt$8.nofit({
	        rect: anchorBox,
	        maxHeight: elementBox.height,
	        maxWidth: elementBox.width,
	        direction: southeast$3(),
	        placement: 'southeast',
	        classes: {
	          on: [],
	          off: []
	        },
	        layout: 'none',
	        testY: anchorBox.y
	      }, -1, -1, false));
	      return abc.fold(identity$1, identity$1);
	    };
	
	    var singleton = function (doRevoke) {
	      var subject = Cell(Optional.none());
	      var revoke = function () {
	        return subject.get().each(doRevoke);
	      };
	      var clear = function () {
	        revoke();
	        subject.set(Optional.none());
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var get = function () {
	        return subject.get();
	      };
	      var set = function (s) {
	        revoke();
	        subject.set(Optional.some(s));
	      };
	      return {
	        clear: clear,
	        isSet: isSet,
	        get: get,
	        set: set
	      };
	    };
	    var destroyable = function () {
	      return singleton(function (s) {
	        return s.destroy();
	      });
	    };
	    var unbindable = function () {
	      return singleton(function (s) {
	        return s.unbind();
	      });
	    };
	    var api$1 = function () {
	      var subject = destroyable();
	      var run = function (f) {
	        return subject.get().each(f);
	      };
	      return __assign(__assign({}, subject), { run: run });
	    };
	    var value$1 = function () {
	      var subject = singleton(noop);
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return __assign(__assign({}, subject), { on: on });
	    };
	
	    var filter = always;
	    var bind = function (element, event, handler) {
	      return bind$2(element, event, filter, handler);
	    };
	    var capture = function (element, event, handler) {
	      return capture$1(element, event, filter, handler);
	    };
	    var fromRawEvent = fromRawEvent$1;
	
	    var properties = [
	      'top',
	      'bottom',
	      'right',
	      'left'
	    ];
	    var timerAttr = 'data-alloy-transition-timer';
	    var isTransitioning$1 = function (element, transition) {
	      return hasAll(element, transition.classes);
	    };
	    var shouldApplyTransitionCss = function (transition, decision, lastPlacement) {
	      return lastPlacement.exists(function (placer) {
	        var mode = transition.mode;
	        return mode === 'all' ? true : placer[mode] !== decision[mode];
	      });
	    };
	    var hasChanges = function (position, intermediate) {
	      var round = function (value) {
	        return parseFloat(value).toFixed(3);
	      };
	      return find$4(intermediate, function (value, key) {
	        var newValue = position[key].map(round);
	        var val = value.map(round);
	        return !equals(newValue, val);
	      }).isSome();
	    };
	    var getTransitionDuration = function (element) {
	      var get = function (name) {
	        var style = get$c(element, name);
	        var times = isString(style) ? style.split(/\s*,\s*/) : [];
	        return filter$2(times, isNotEmpty);
	      };
	      var parse = function (value) {
	        if (isString(value) && /^[\d.]+/.test(value)) {
	          var num = parseFloat(value);
	          return endsWith(value, 'ms') ? num : num * 1000;
	        } else {
	          return 0;
	        }
	      };
	      var delay = get('transition-delay');
	      var duration = get('transition-duration');
	      return foldl(duration, function (acc, dur, i) {
	        var time = parse(delay[i]) + parse(dur);
	        return Math.max(acc, time);
	      }, 0);
	    };
	    var setupTransitionListeners = function (element, transition) {
	      var transitionEnd = unbindable();
	      var transitionCancel = unbindable();
	      var timer;
	      var isSourceTransition = function (e) {
	        var _a;
	        var pseudoElement = (_a = e.raw.pseudoElement) !== null && _a !== void 0 ? _a : '';
	        return eq(e.target, element) && isEmpty(pseudoElement) && contains$2(properties, e.raw.propertyName);
	      };
	      var transitionDone = function (e) {
	        if (isNullable(e) || isSourceTransition(e)) {
	          transitionEnd.clear();
	          transitionCancel.clear();
	          var type = e === null || e === void 0 ? void 0 : e.raw.type;
	          if (isNullable(type) || type === transitionend()) {
	            clearTimeout(timer);
	            remove$7(element, timerAttr);
	            remove$1(element, transition.classes);
	          }
	        }
	      };
	      var transitionStarted = function () {
	        transitionEnd.set(bind(element, transitionend(), transitionDone));
	        transitionCancel.set(bind(element, transitioncancel(), transitionDone));
	      };
	      if ('ontransitionstart' in element.dom) {
	        var transitionStart_1 = bind(element, transitionstart(), function (e) {
	          if (isSourceTransition(e)) {
	            transitionStart_1.unbind();
	            transitionStarted();
	          }
	        });
	      } else {
	        transitionStarted();
	      }
	      var duration = getTransitionDuration(element);
	      requestAnimationFrame(function () {
	        timer = setTimeout(transitionDone, duration + 17);
	        set$8(element, timerAttr, timer);
	      });
	    };
	    var startTransitioning = function (element, transition) {
	      add$1(element, transition.classes);
	      getOpt(element, timerAttr).each(function (timerId) {
	        clearTimeout(parseInt(timerId, 10));
	        remove$7(element, timerAttr);
	      });
	      setupTransitionListeners(element, transition);
	    };
	    var applyTransitionCss = function (element, origin, position, transition, decision, lastPlacement) {
	      var shouldTransition = shouldApplyTransitionCss(transition, decision, lastPlacement);
	      if (shouldTransition || isTransitioning$1(element, transition)) {
	        set$7(element, 'position', position.position);
	        var rect = toBox(origin, element);
	        var intermediatePosition_1 = reposition(origin, __assign(__assign({}, decision), { rect: rect }));
	        var intermediateCssOptions = mapToObject(properties, function (prop) {
	          return intermediatePosition_1[prop];
	        });
	        if (hasChanges(position, intermediateCssOptions)) {
	          setOptions(element, intermediateCssOptions);
	          if (shouldTransition) {
	            startTransitioning(element, transition);
	          }
	          reflow(element);
	        }
	      } else {
	        remove$1(element, transition.classes);
	      }
	    };
	
	    var elementSize = function (p) {
	      return {
	        width: getOuter$1(p),
	        height: getOuter$2(p)
	      };
	    };
	    var layout = function (anchorBox, element, bubbles, options) {
	      remove$6(element, 'max-height');
	      remove$6(element, 'max-width');
	      var elementBox = elementSize(element);
	      return attempts(element, options.preference, anchorBox, elementBox, bubbles, options.bounds);
	    };
	    var setClasses = function (element, decision) {
	      var classInfo = decision.classes;
	      remove$1(element, classInfo.off);
	      add$1(element, classInfo.on);
	    };
	    var setHeight = function (element, decision, options) {
	      var maxHeightFunction = options.maxHeightFunction;
	      maxHeightFunction(element, decision.maxHeight);
	    };
	    var setWidth = function (element, decision, options) {
	      var maxWidthFunction = options.maxWidthFunction;
	      maxWidthFunction(element, decision.maxWidth);
	    };
	    var position$2 = function (element, decision, options) {
	      var positionCss = reposition(options.origin, decision);
	      options.transition.each(function (transition) {
	        applyTransitionCss(element, options.origin, positionCss, transition, decision, options.lastPlacement);
	      });
	      applyPositionCss(element, positionCss);
	    };
	    var setPlacement = function (element, decision) {
	      setPlacement$1(element, decision.placement);
	    };
	
	    var setMaxHeight = function (element, maxHeight) {
	      setMax$1(element, Math.floor(maxHeight));
	    };
	    var anchored = constant$1(function (element, available) {
	      setMaxHeight(element, available);
	      setAll(element, {
	        'overflow-x': 'hidden',
	        'overflow-y': 'auto'
	      });
	    });
	    var expandable$1 = constant$1(function (element, available) {
	      setMaxHeight(element, available);
	    });
	
	    var defaultOr = function (options, key, dephault) {
	      return options[key] === undefined ? dephault : options[key];
	    };
	    var simple = function (anchor, element, bubble, layouts, lastPlacement, getBounds, overrideOptions, transition) {
	      var maxHeightFunction = defaultOr(overrideOptions, 'maxHeightFunction', anchored());
	      var maxWidthFunction = defaultOr(overrideOptions, 'maxWidthFunction', noop);
	      var anchorBox = anchor.anchorBox;
	      var origin = anchor.origin;
	      var options = {
	        bounds: viewport(origin, getBounds),
	        origin: origin,
	        preference: layouts,
	        maxHeightFunction: maxHeightFunction,
	        maxWidthFunction: maxWidthFunction,
	        lastPlacement: lastPlacement,
	        transition: transition
	      };
	      return go(anchorBox, element, bubble, options);
	    };
	    var go = function (anchorBox, element, bubble, options) {
	      var decision = layout(anchorBox, element, bubble, options);
	      position$2(element, decision, options);
	      setPlacement(element, decision);
	      setClasses(element, decision);
	      setHeight(element, decision, options);
	      setWidth(element, decision, options);
	      return {
	        layout: decision.layout,
	        placement: decision.placement
	      };
	    };
	
	    var allAlignments = [
	      'valignCentre',
	      'alignLeft',
	      'alignRight',
	      'alignCentre',
	      'top',
	      'bottom',
	      'left',
	      'right',
	      'inset'
	    ];
	    var nu$5 = function (xOffset, yOffset, classes, insetModifier) {
	      if (insetModifier === void 0) {
	        insetModifier = 1;
	      }
	      var insetXOffset = xOffset * insetModifier;
	      var insetYOffset = yOffset * insetModifier;
	      var getClasses = function (prop) {
	        return get$e(classes, prop).getOr([]);
	      };
	      var make = function (xDelta, yDelta, alignmentsOn) {
	        var alignmentsOff = difference(allAlignments, alignmentsOn);
	        return {
	          offset: SugarPosition(xDelta, yDelta),
	          classesOn: bind$3(alignmentsOn, getClasses),
	          classesOff: bind$3(alignmentsOff, getClasses)
	        };
	      };
	      return {
	        southeast: function () {
	          return make(-xOffset, yOffset, [
	            'top',
	            'alignLeft'
	          ]);
	        },
	        southwest: function () {
	          return make(xOffset, yOffset, [
	            'top',
	            'alignRight'
	          ]);
	        },
	        south: function () {
	          return make(-xOffset / 2, yOffset, [
	            'top',
	            'alignCentre'
	          ]);
	        },
	        northeast: function () {
	          return make(-xOffset, -yOffset, [
	            'bottom',
	            'alignLeft'
	          ]);
	        },
	        northwest: function () {
	          return make(xOffset, -yOffset, [
	            'bottom',
	            'alignRight'
	          ]);
	        },
	        north: function () {
	          return make(-xOffset / 2, -yOffset, [
	            'bottom',
	            'alignCentre'
	          ]);
	        },
	        east: function () {
	          return make(xOffset, -yOffset / 2, [
	            'valignCentre',
	            'left'
	          ]);
	        },
	        west: function () {
	          return make(-xOffset, -yOffset / 2, [
	            'valignCentre',
	            'right'
	          ]);
	        },
	        insetNortheast: function () {
	          return make(insetXOffset, insetYOffset, [
	            'top',
	            'alignLeft',
	            'inset'
	          ]);
	        },
	        insetNorthwest: function () {
	          return make(-insetXOffset, insetYOffset, [
	            'top',
	            'alignRight',
	            'inset'
	          ]);
	        },
	        insetNorth: function () {
	          return make(-insetXOffset / 2, insetYOffset, [
	            'top',
	            'alignCentre',
	            'inset'
	          ]);
	        },
	        insetSoutheast: function () {
	          return make(insetXOffset, -insetYOffset, [
	            'bottom',
	            'alignLeft',
	            'inset'
	          ]);
	        },
	        insetSouthwest: function () {
	          return make(-insetXOffset, -insetYOffset, [
	            'bottom',
	            'alignRight',
	            'inset'
	          ]);
	        },
	        insetSouth: function () {
	          return make(-insetXOffset / 2, -insetYOffset, [
	            'bottom',
	            'alignCentre',
	            'inset'
	          ]);
	        },
	        insetEast: function () {
	          return make(-insetXOffset, -insetYOffset / 2, [
	            'valignCentre',
	            'right',
	            'inset'
	          ]);
	        },
	        insetWest: function () {
	          return make(insetXOffset, -insetYOffset / 2, [
	            'valignCentre',
	            'left',
	            'inset'
	          ]);
	        }
	      };
	    };
	    var fallback = function () {
	      return nu$5(0, 0, {});
	    };
	
	    var nu$4 = identity$1;
	
	    var onDirection = function (isLtr, isRtl) {
	      return function (element) {
	        return getDirection(element) === 'rtl' ? isRtl : isLtr;
	      };
	    };
	    var getDirection = function (element) {
	      return get$c(element, 'direction') === 'rtl' ? 'rtl' : 'ltr';
	    };
	
	    var AttributeValue;
	    (function (AttributeValue) {
	      AttributeValue['TopToBottom'] = 'toptobottom';
	      AttributeValue['BottomToTop'] = 'bottomtotop';
	    }(AttributeValue || (AttributeValue = {})));
	    var Attribute = 'data-alloy-vertical-dir';
	    var isBottomToTopDir = function (el) {
	      return closest$2(el, function (current) {
	        return isElement$2(current) && get$d(current, 'data-alloy-vertical-dir') === AttributeValue.BottomToTop;
	      });
	    };
	
	    var schema$y = function () {
	      return optionObjOf('layouts', [
	        required$1('onLtr'),
	        required$1('onRtl'),
	        option('onBottomLtr'),
	        option('onBottomRtl')
	      ]);
	    };
	    var get$4 = function (elem, info, defaultLtr, defaultRtl, defaultBottomLtr, defaultBottomRtl, dirElement) {
	      var isBottomToTop = dirElement.map(isBottomToTopDir).getOr(false);
	      var customLtr = info.layouts.map(function (ls) {
	        return ls.onLtr(elem);
	      });
	      var customRtl = info.layouts.map(function (ls) {
	        return ls.onRtl(elem);
	      });
	      var ltr = isBottomToTop ? info.layouts.bind(function (ls) {
	        return ls.onBottomLtr.map(function (f) {
	          return f(elem);
	        });
	      }).or(customLtr).getOr(defaultBottomLtr) : customLtr.getOr(defaultLtr);
	      var rtl = isBottomToTop ? info.layouts.bind(function (ls) {
	        return ls.onBottomRtl.map(function (f) {
	          return f(elem);
	        });
	      }).or(customRtl).getOr(defaultBottomRtl) : customRtl.getOr(defaultRtl);
	      var f = onDirection(ltr, rtl);
	      return f(elem);
	    };
	
	    var placement$4 = function (component, anchorInfo, origin) {
	      var hotspot = anchorInfo.hotspot;
	      var anchorBox = toBox(origin, hotspot.element);
	      var layouts = get$4(component.element, anchorInfo, belowOrAbove(), belowOrAboveRtl(), aboveOrBelow(), aboveOrBelowRtl(), Optional.some(anchorInfo.hotspot.element));
	      return Optional.some(nu$4({
	        anchorBox: anchorBox,
	        bubble: anchorInfo.bubble.getOr(fallback()),
	        overrides: anchorInfo.overrides,
	        layouts: layouts,
	        placer: Optional.none()
	      }));
	    };
	    var HotspotAnchor = [
	      required$1('hotspot'),
	      option('bubble'),
	      defaulted('overrides', {}),
	      schema$y(),
	      output$1('placement', placement$4)
	    ];
	
	    var placement$3 = function (component, anchorInfo, origin) {
	      var pos = translate$2(origin, anchorInfo.x, anchorInfo.y);
	      var anchorBox = bounds(pos.left, pos.top, anchorInfo.width, anchorInfo.height);
	      var layouts = get$4(component.element, anchorInfo, all$1(), allRtl$1(), all$1(), allRtl$1(), Optional.none());
	      return Optional.some(nu$4({
	        anchorBox: anchorBox,
	        bubble: anchorInfo.bubble,
	        overrides: anchorInfo.overrides,
	        layouts: layouts,
	        placer: Optional.none()
	      }));
	    };
	    var MakeshiftAnchor = [
	      required$1('x'),
	      required$1('y'),
	      defaulted('height', 0),
	      defaulted('width', 0),
	      defaulted('bubble', fallback()),
	      defaulted('overrides', {}),
	      schema$y(),
	      output$1('placement', placement$3)
	    ];
	
	    var adt$7 = Adt.generate([
	      { screen: ['point'] },
	      {
	        absolute: [
	          'point',
	          'scrollLeft',
	          'scrollTop'
	        ]
	      }
	    ]);
	    var toFixed = function (pos) {
	      return pos.fold(identity$1, function (point, scrollLeft, scrollTop) {
	        return point.translate(-scrollLeft, -scrollTop);
	      });
	    };
	    var toAbsolute = function (pos) {
	      return pos.fold(identity$1, identity$1);
	    };
	    var sum = function (points) {
	      return foldl(points, function (b, a) {
	        return b.translate(a.left, a.top);
	      }, SugarPosition(0, 0));
	    };
	    var sumAsFixed = function (positions) {
	      var points = map$2(positions, toFixed);
	      return sum(points);
	    };
	    var sumAsAbsolute = function (positions) {
	      var points = map$2(positions, toAbsolute);
	      return sum(points);
	    };
	    var screen = adt$7.screen;
	    var absolute$1 = adt$7.absolute;
	
	    var getOffset = function (component, origin, anchorInfo) {
	      var win = defaultView(anchorInfo.root).dom;
	      var hasSameOwner = function (frame) {
	        var frameOwner = owner$4(frame);
	        var compOwner = owner$4(component.element);
	        return eq(frameOwner, compOwner);
	      };
	      return Optional.from(win.frameElement).map(SugarElement.fromDom).filter(hasSameOwner).map(absolute$3);
	    };
	    var getRootPoint = function (component, origin, anchorInfo) {
	      var doc = owner$4(component.element);
	      var outerScroll = get$9(doc);
	      var offset = getOffset(component, origin, anchorInfo).getOr(outerScroll);
	      return absolute$1(offset, outerScroll.left, outerScroll.top);
	    };
	
	    var getBox = function (left, top, width, height) {
	      var point = screen(SugarPosition(left, top));
	      return Optional.some(pointed(point, width, height));
	    };
	    var calcNewAnchor = function (optBox, rootPoint, anchorInfo, origin, elem) {
	      return optBox.map(function (box) {
	        var points = [
	          rootPoint,
	          box.point
	        ];
	        var topLeft = cata$1(origin, function () {
	          return sumAsAbsolute(points);
	        }, function () {
	          return sumAsAbsolute(points);
	        }, function () {
	          return sumAsFixed(points);
	        });
	        var anchorBox = rect(topLeft.left, topLeft.top, box.width, box.height);
	        var layoutsLtr = anchorInfo.showAbove ? aboveOrBelow() : belowOrAbove();
	        var layoutsRtl = anchorInfo.showAbove ? aboveOrBelowRtl() : belowOrAboveRtl();
	        var layouts = get$4(elem, anchorInfo, layoutsLtr, layoutsRtl, layoutsLtr, layoutsRtl, Optional.none());
	        return nu$4({
	          anchorBox: anchorBox,
	          bubble: anchorInfo.bubble.getOr(fallback()),
	          overrides: anchorInfo.overrides,
	          layouts: layouts,
	          placer: Optional.none()
	        });
	      });
	    };
	
	    var placement$2 = function (component, anchorInfo, origin) {
	      var rootPoint = getRootPoint(component, origin, anchorInfo);
	      return anchorInfo.node.filter(inBody).bind(function (target) {
	        var rect = target.dom.getBoundingClientRect();
	        var nodeBox = getBox(rect.left, rect.top, rect.width, rect.height);
	        var elem = anchorInfo.node.getOr(component.element);
	        return calcNewAnchor(nodeBox, rootPoint, anchorInfo, origin, elem);
	      });
	    };
	    var NodeAnchor = [
	      required$1('node'),
	      required$1('root'),
	      option('bubble'),
	      schema$y(),
	      defaulted('overrides', {}),
	      defaulted('showAbove', false),
	      output$1('placement', placement$2)
	    ];
	
	    var zeroWidth = '\uFEFF';
	    var nbsp = '\xA0';
	
	    var create$7 = function (start, soffset, finish, foffset) {
	      return {
	        start: start,
	        soffset: soffset,
	        finish: finish,
	        foffset: foffset
	      };
	    };
	    var SimRange = { create: create$7 };
	
	    var adt$6 = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart$1 = function (situ) {
	      return situ.fold(identity$1, identity$1, identity$1);
	    };
	    var before = adt$6.before;
	    var on$1 = adt$6.on;
	    var after$1 = adt$6.after;
	    var Situ = {
	      before: before,
	      on: on$1,
	      after: after$1,
	      cata: cata,
	      getStart: getStart$1
	    };
	
	    var adt$5 = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt$5.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
	    };
	    var getStart = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return SugarElement.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, _finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, _soffset, _finish, _foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt$5.domRange;
	    var relative = adt$5.relative;
	    var exact = adt$5.exact;
	    var getWin = function (selection) {
	      var start = getStart(selection);
	      return defaultView(start);
	    };
	    var range$1 = SimRange.create;
	    var SimSelection = {
	      domRange: domRange,
	      relative: relative,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range$1
	    };
	
	    var setStart = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setStartBefore(e.dom);
	      }, function (e, o) {
	        rng.setStart(e.dom, o);
	      }, function (e) {
	        rng.setStartAfter(e.dom);
	      });
	    };
	    var setFinish = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setEndBefore(e.dom);
	      }, function (e, o) {
	        rng.setEnd(e.dom, o);
	      }, function (e) {
	        rng.setEndAfter(e.dom);
	      });
	    };
	    var relativeToNative = function (win, startSitu, finishSitu) {
	      var range = win.document.createRange();
	      setStart(range, startSitu);
	      setFinish(range, finishSitu);
	      return range;
	    };
	    var exactToNative = function (win, start, soffset, finish, foffset) {
	      var rng = win.document.createRange();
	      rng.setStart(start.dom, soffset);
	      rng.setEnd(finish.dom, foffset);
	      return rng;
	    };
	    var toRect = function (rect) {
	      return {
	        left: rect.left,
	        top: rect.top,
	        right: rect.right,
	        bottom: rect.bottom,
	        width: rect.width,
	        height: rect.height
	      };
	    };
	    var getFirstRect$1 = function (rng) {
	      var rects = rng.getClientRects();
	      var rect = rects.length > 0 ? rects[0] : rng.getBoundingClientRect();
	      return rect.width > 0 || rect.height > 0 ? Optional.some(rect).map(toRect) : Optional.none();
	    };
	    var getBounds$2 = function (rng) {
	      var rect = rng.getBoundingClientRect();
	      return rect.width > 0 || rect.height > 0 ? Optional.some(rect).map(toRect) : Optional.none();
	    };
	
	    var adt$4 = Adt.generate([
	      {
	        ltr: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      },
	      {
	        rtl: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var fromRange = function (win, type, range) {
	      return type(SugarElement.fromDom(range.startContainer), range.startOffset, SugarElement.fromDom(range.endContainer), range.endOffset);
	    };
	    var getRanges = function (win, selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return {
	            ltr: constant$1(rng),
	            rtl: Optional.none
	          };
	        },
	        relative: function (startSitu, finishSitu) {
	          return {
	            ltr: cached(function () {
	              return relativeToNative(win, startSitu, finishSitu);
	            }),
	            rtl: cached(function () {
	              return Optional.some(relativeToNative(win, finishSitu, startSitu));
	            })
	          };
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return {
	            ltr: cached(function () {
	              return exactToNative(win, start, soffset, finish, foffset);
	            }),
	            rtl: cached(function () {
	              return Optional.some(exactToNative(win, finish, foffset, start, soffset));
	            })
	          };
	        }
	      });
	    };
	    var doDiagnose = function (win, ranges) {
	      var rng = ranges.ltr();
	      if (rng.collapsed) {
	        var reversed = ranges.rtl().filter(function (rev) {
	          return rev.collapsed === false;
	        });
	        return reversed.map(function (rev) {
	          return adt$4.rtl(SugarElement.fromDom(rev.endContainer), rev.endOffset, SugarElement.fromDom(rev.startContainer), rev.startOffset);
	        }).getOrThunk(function () {
	          return fromRange(win, adt$4.ltr, rng);
	        });
	      } else {
	        return fromRange(win, adt$4.ltr, rng);
	      }
	    };
	    var diagnose = function (win, selection) {
	      var ranges = getRanges(win, selection);
	      return doDiagnose(win, ranges);
	    };
	    var asLtrRange = function (win, selection) {
	      var diagnosis = diagnose(win, selection);
	      return diagnosis.match({
	        ltr: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(start.dom, soffset);
	          rng.setEnd(finish.dom, foffset);
	          return rng;
	        },
	        rtl: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(finish.dom, foffset);
	          rng.setEnd(start.dom, soffset);
	          return rng;
	        }
	      });
	    };
	    adt$4.ltr;
	    adt$4.rtl;
	
	    var NodeValue = function (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom.nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	
	    var api = NodeValue(isText$1, 'text');
	    var get$3 = function (element) {
	      return api.get(element);
	    };
	    var getOption = function (element) {
	      return api.getOption(element);
	    };
	
	    var getEnd = function (element) {
	      return name$2(element) === 'img' ? 1 : getOption(element).fold(function () {
	        return children(element).length;
	      }, function (v) {
	        return v.length;
	      });
	    };
	    var isTextNodeWithCursorPosition = function (el) {
	      return getOption(el).filter(function (text) {
	        return text.trim().length !== 0 || text.indexOf(nbsp) > -1;
	      }).isSome();
	    };
	    var elementsWithCursorPosition = [
	      'img',
	      'br'
	    ];
	    var isCursorPosition = function (elem) {
	      var hasCursorPosition = isTextNodeWithCursorPosition(elem);
	      return hasCursorPosition || contains$2(elementsWithCursorPosition, name$2(elem));
	    };
	
	    var last$1 = function (element) {
	      return descendantRtl(element, isCursorPosition);
	    };
	    var descendantRtl = function (scope, predicate) {
	      var descend = function (element) {
	        var children$1 = children(element);
	        for (var i = children$1.length - 1; i >= 0; i--) {
	          var child = children$1[i];
	          if (predicate(child)) {
	            return Optional.some(child);
	          }
	          var res = descend(child);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Optional.none();
	      };
	      return descend(scope);
	    };
	
	    var descendants = function (scope, selector) {
	      return all$3(selector, scope);
	    };
	
	    var makeRange = function (start, soffset, finish, foffset) {
	      var doc = owner$4(start);
	      var rng = doc.dom.createRange();
	      rng.setStart(start.dom, soffset);
	      rng.setEnd(finish.dom, foffset);
	      return rng;
	    };
	    var after = function (start, soffset, finish, foffset) {
	      var r = makeRange(start, soffset, finish, foffset);
	      var same = eq(start, finish) && soffset === foffset;
	      return r.collapsed && !same;
	    };
	
	    var getNativeSelection = function (win) {
	      return Optional.from(win.getSelection());
	    };
	    var readRange = function (selection) {
	      if (selection.rangeCount > 0) {
	        var firstRng = selection.getRangeAt(0);
	        var lastRng = selection.getRangeAt(selection.rangeCount - 1);
	        return Optional.some(SimRange.create(SugarElement.fromDom(firstRng.startContainer), firstRng.startOffset, SugarElement.fromDom(lastRng.endContainer), lastRng.endOffset));
	      } else {
	        return Optional.none();
	      }
	    };
	    var doGetExact = function (selection) {
	      if (selection.anchorNode === null || selection.focusNode === null) {
	        return readRange(selection);
	      } else {
	        var anchor = SugarElement.fromDom(selection.anchorNode);
	        var focus_1 = SugarElement.fromDom(selection.focusNode);
	        return after(anchor, selection.anchorOffset, focus_1, selection.focusOffset) ? Optional.some(SimRange.create(anchor, selection.anchorOffset, focus_1, selection.focusOffset)) : readRange(selection);
	      }
	    };
	    var getExact = function (win) {
	      return getNativeSelection(win).filter(function (sel) {
	        return sel.rangeCount > 0;
	      }).bind(doGetExact);
	    };
	    var getFirstRect = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return getFirstRect$1(rng);
	    };
	    var getBounds$1 = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return getBounds$2(rng);
	    };
	
	    var point$1 = function (element, offset) {
	      return {
	        element: element,
	        offset: offset
	      };
	    };
	    var descendOnce$1 = function (element, offset) {
	      var children$1 = children(element);
	      if (children$1.length === 0) {
	        return point$1(element, offset);
	      } else if (offset < children$1.length) {
	        return point$1(children$1[offset], 0);
	      } else {
	        var last = children$1[children$1.length - 1];
	        var len = isText$1(last) ? get$3(last).length : children(last).length;
	        return point$1(last, len);
	      }
	    };
	
	    var descendOnce = function (element, offset) {
	      return isText$1(element) ? point$1(element, offset) : descendOnce$1(element, offset);
	    };
	    var getAnchorSelection = function (win, anchorInfo) {
	      var getSelection = anchorInfo.getSelection.getOrThunk(function () {
	        return function () {
	          return getExact(win);
	        };
	      });
	      return getSelection().map(function (sel) {
	        var modStart = descendOnce(sel.start, sel.soffset);
	        var modFinish = descendOnce(sel.finish, sel.foffset);
	        return SimSelection.range(modStart.element, modStart.offset, modFinish.element, modFinish.offset);
	      });
	    };
	    var placement$1 = function (component, anchorInfo, origin) {
	      var win = defaultView(anchorInfo.root).dom;
	      var rootPoint = getRootPoint(component, origin, anchorInfo);
	      var selectionBox = getAnchorSelection(win, anchorInfo).bind(function (sel) {
	        var optRect = getBounds$1(win, SimSelection.exactFromRange(sel)).orThunk(function () {
	          var x = SugarElement.fromText(zeroWidth);
	          before$2(sel.start, x);
	          var rect = getFirstRect(win, SimSelection.exact(x, 0, x, 1));
	          remove$5(x);
	          return rect;
	        });
	        return optRect.bind(function (rawRect) {
	          return getBox(rawRect.left, rawRect.top, rawRect.width, rawRect.height);
	        });
	      });
	      var targetElement = getAnchorSelection(win, anchorInfo).bind(function (sel) {
	        return isElement$2(sel.start) ? Optional.some(sel.start) : parentNode(sel.start);
	      });
	      var elem = targetElement.getOr(component.element);
	      return calcNewAnchor(selectionBox, rootPoint, anchorInfo, origin, elem);
	    };
	    var SelectionAnchor = [
	      option('getSelection'),
	      required$1('root'),
	      option('bubble'),
	      schema$y(),
	      defaulted('overrides', {}),
	      defaulted('showAbove', false),
	      output$1('placement', placement$1)
	    ];
	
	    var labelPrefix$1 = 'link-layout';
	    var eastX = function (anchor) {
	      return anchor.x + anchor.width;
	    };
	    var westX = function (anchor, element) {
	      return anchor.x - element.width;
	    };
	    var northY$1 = function (anchor, element) {
	      return anchor.y - element.height + anchor.height;
	    };
	    var southY$1 = function (anchor) {
	      return anchor.y;
	    };
	    var southeast$1 = function (anchor, element, bubbles) {
	      return nu$6(eastX(anchor), southY$1(anchor), bubbles.southeast(), southeast$3(), 'southeast', boundsRestriction(anchor, {
	        left: 0,
	        top: 2
	      }), labelPrefix$1);
	    };
	    var southwest$1 = function (anchor, element, bubbles) {
	      return nu$6(westX(anchor, element), southY$1(anchor), bubbles.southwest(), southwest$3(), 'southwest', boundsRestriction(anchor, {
	        right: 1,
	        top: 2
	      }), labelPrefix$1);
	    };
	    var northeast$1 = function (anchor, element, bubbles) {
	      return nu$6(eastX(anchor), northY$1(anchor, element), bubbles.northeast(), northeast$3(), 'northeast', boundsRestriction(anchor, {
	        left: 0,
	        bottom: 3
	      }), labelPrefix$1);
	    };
	    var northwest$1 = function (anchor, element, bubbles) {
	      return nu$6(westX(anchor, element), northY$1(anchor, element), bubbles.northwest(), northwest$3(), 'northwest', boundsRestriction(anchor, {
	        right: 1,
	        bottom: 3
	      }), labelPrefix$1);
	    };
	    var all = function () {
	      return [
	        southeast$1,
	        southwest$1,
	        northeast$1,
	        northwest$1
	      ];
	    };
	    var allRtl = function () {
	      return [
	        southwest$1,
	        southeast$1,
	        northwest$1,
	        northeast$1
	      ];
	    };
	
	    var placement = function (component, submenuInfo, origin) {
	      var anchorBox = toBox(origin, submenuInfo.item.element);
	      var layouts = get$4(component.element, submenuInfo, all(), allRtl(), all(), allRtl(), Optional.none());
	      return Optional.some(nu$4({
	        anchorBox: anchorBox,
	        bubble: fallback(),
	        overrides: submenuInfo.overrides,
	        layouts: layouts,
	        placer: Optional.none()
	      }));
	    };
	    var SubmenuAnchor = [
	      required$1('item'),
	      schema$y(),
	      defaulted('overrides', {}),
	      output$1('placement', placement)
	    ];
	
	    var AnchorSchema = choose$1('type', {
	      selection: SelectionAnchor,
	      node: NodeAnchor,
	      hotspot: HotspotAnchor,
	      submenu: SubmenuAnchor,
	      makeshift: MakeshiftAnchor
	    });
	
	    var TransitionSchema = [
	      requiredArrayOf('classes', string),
	      defaultedStringEnum('mode', 'all', [
	        'all',
	        'layout',
	        'placement'
	      ])
	    ];
	    var PositionSchema = [
	      defaulted('useFixed', never),
	      option('getBounds')
	    ];
	    var PlacementSchema = [
	      requiredOf('anchor', AnchorSchema),
	      optionObjOf('transition', TransitionSchema)
	    ];
	
	    var getFixedOrigin = function () {
	      var html = document.documentElement;
	      return fixed$1(0, 0, html.clientWidth, html.clientHeight);
	    };
	    var getRelativeOrigin = function (component) {
	      var position = absolute$3(component.element);
	      var bounds = component.element.dom.getBoundingClientRect();
	      return relative$1(position.left, position.top, bounds.width, bounds.height);
	    };
	    var place = function (component, origin, anchoring, getBounds, placee, lastPlace, transition) {
	      var anchor = box(anchoring.anchorBox, origin);
	      return simple(anchor, placee.element, anchoring.bubble, anchoring.layouts, lastPlace, getBounds, anchoring.overrides, transition);
	    };
	    var position$1 = function (component, posConfig, posState, placee, placementSpec) {
	      positionWithin(component, posConfig, posState, placee, placementSpec, Optional.none());
	    };
	    var positionWithin = function (component, posConfig, posState, placee, placementSpec, boxElement) {
	      var boundsBox = boxElement.map(box$1);
	      return positionWithinBounds(component, posConfig, posState, placee, placementSpec, boundsBox);
	    };
	    var positionWithinBounds = function (component, posConfig, posState, placee, placementSpec, bounds) {
	      var placeeDetail = asRawOrDie$1('placement.info', objOf(PlacementSchema), placementSpec);
	      var anchorage = placeeDetail.anchor;
	      var element = placee.element;
	      var placeeState = posState.get(placee.uid);
	      preserve$1(function () {
	        set$7(element, 'position', 'fixed');
	        var oldVisibility = getRaw(element, 'visibility');
	        set$7(element, 'visibility', 'hidden');
	        var origin = posConfig.useFixed() ? getFixedOrigin() : getRelativeOrigin(component);
	        var placer = anchorage.placement;
	        var getBounds = bounds.map(constant$1).or(posConfig.getBounds);
	        placer(component, anchorage, origin).each(function (anchoring) {
	          var doPlace = anchoring.placer.getOr(place);
	          var newState = doPlace(component, origin, anchoring, getBounds, placee, placeeState, placeeDetail.transition);
	          posState.set(placee.uid, newState);
	        });
	        oldVisibility.fold(function () {
	          remove$6(element, 'visibility');
	        }, function (vis) {
	          set$7(element, 'visibility', vis);
	        });
	        if (getRaw(element, 'left').isNone() && getRaw(element, 'top').isNone() && getRaw(element, 'right').isNone() && getRaw(element, 'bottom').isNone() && is$1(getRaw(element, 'position'), 'fixed')) {
	          remove$6(element, 'position');
	        }
	      }, element);
	    };
	    var getMode = function (component, pConfig, _pState) {
	      return pConfig.useFixed() ? 'fixed' : 'absolute';
	    };
	    var reset$1 = function (component, pConfig, posState, placee) {
	      var element = placee.element;
	      each$1([
	        'position',
	        'left',
	        'right',
	        'top',
	        'bottom'
	      ], function (prop) {
	        return remove$6(element, prop);
	      });
	      reset$2(element);
	      posState.clear(placee.uid);
	    };
	
	    var PositionApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        position: position$1,
	        positionWithin: positionWithin,
	        positionWithinBounds: positionWithinBounds,
	        getMode: getMode,
	        reset: reset$1
	    });
	
	    var init$g = function () {
	      var state = {};
	      var set = function (id, data) {
	        state[id] = data;
	      };
	      var get = function (id) {
	        return get$e(state, id);
	      };
	      var clear = function (id) {
	        if (isNonNullable(id)) {
	          delete state[id];
	        } else {
	          state = {};
	        }
	      };
	      return nu$8({
	        readState: function () {
	          return state;
	        },
	        clear: clear,
	        set: set,
	        get: get
	      });
	    };
	
	    var PositioningState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$g
	    });
	
	    var Positioning = create$8({
	      fields: PositionSchema,
	      name: 'positioning',
	      active: ActivePosition,
	      apis: PositionApis,
	      state: PositioningState
	    });
	
	    var fireDetaching = function (component) {
	      emit(component, detachedFromDom());
	      var children = component.components();
	      each$1(children, fireDetaching);
	    };
	    var fireAttaching = function (component) {
	      var children = component.components();
	      each$1(children, fireAttaching);
	      emit(component, attachedToDom());
	    };
	    var attach$1 = function (parent, child) {
	      append$2(parent.element, child.element);
	    };
	    var detachChildren$1 = function (component) {
	      each$1(component.components(), function (childComp) {
	        return remove$5(childComp.element);
	      });
	      empty(component.element);
	      component.syncComponents();
	    };
	    var replaceChildren = function (component, newChildren) {
	      var subs = component.components();
	      detachChildren$1(component);
	      var deleted = difference(subs, newChildren);
	      each$1(deleted, function (comp) {
	        fireDetaching(comp);
	        component.getSystem().removeFromWorld(comp);
	      });
	      each$1(newChildren, function (childComp) {
	        if (!childComp.getSystem().isConnected()) {
	          component.getSystem().addToWorld(childComp);
	          attach$1(component, childComp);
	          if (inBody(component.element)) {
	            fireAttaching(childComp);
	          }
	        } else {
	          attach$1(component, childComp);
	        }
	        component.syncComponents();
	      });
	    };
	
	    var attach = function (parent, child) {
	      attachWith(parent, child, append$2);
	    };
	    var attachWith = function (parent, child, insertion) {
	      parent.getSystem().addToWorld(child);
	      insertion(parent.element, child.element);
	      if (inBody(parent.element)) {
	        fireAttaching(child);
	      }
	      parent.syncComponents();
	    };
	    var doDetach = function (component) {
	      fireDetaching(component);
	      remove$5(component.element);
	      component.getSystem().removeFromWorld(component);
	    };
	    var detach = function (component) {
	      var parent$1 = parent(component.element).bind(function (p) {
	        return component.getSystem().getByDom(p).toOptional();
	      });
	      doDetach(component);
	      parent$1.each(function (p) {
	        p.syncComponents();
	      });
	    };
	    var detachChildren = function (component) {
	      var subs = component.components();
	      each$1(subs, doDetach);
	      empty(component.element);
	      component.syncComponents();
	    };
	    var attachSystem = function (element, guiSystem) {
	      attachSystemWith(element, guiSystem, append$2);
	    };
	    var attachSystemAfter = function (element, guiSystem) {
	      attachSystemWith(element, guiSystem, after$2);
	    };
	    var attachSystemWith = function (element, guiSystem, inserter) {
	      inserter(element, guiSystem.element);
	      var children$1 = children(guiSystem.element);
	      each$1(children$1, function (child) {
	        guiSystem.getByDom(child).each(fireAttaching);
	      });
	    };
	    var detachSystem = function (guiSystem) {
	      var children$1 = children(guiSystem.element);
	      each$1(children$1, function (child) {
	        guiSystem.getByDom(child).each(fireDetaching);
	      });
	      remove$5(guiSystem.element);
	    };
	
	    var rebuild = function (sandbox, sConfig, sState, data) {
	      sState.get().each(function (_data) {
	        detachChildren(sandbox);
	      });
	      var point = sConfig.getAttachPoint(sandbox);
	      attach(point, sandbox);
	      var built = sandbox.getSystem().build(data);
	      attach(sandbox, built);
	      sState.set(built);
	      return built;
	    };
	    var open$1 = function (sandbox, sConfig, sState, data) {
	      var newState = rebuild(sandbox, sConfig, sState, data);
	      sConfig.onOpen(sandbox, newState);
	      return newState;
	    };
	    var setContent = function (sandbox, sConfig, sState, data) {
	      return sState.get().map(function () {
	        return rebuild(sandbox, sConfig, sState, data);
	      });
	    };
	    var openWhileCloaked = function (sandbox, sConfig, sState, data, transaction) {
	      cloak(sandbox, sConfig);
	      open$1(sandbox, sConfig, sState, data);
	      transaction();
	      decloak(sandbox, sConfig);
	    };
	    var close$1 = function (sandbox, sConfig, sState) {
	      sState.get().each(function (data) {
	        detachChildren(sandbox);
	        detach(sandbox);
	        sConfig.onClose(sandbox, data);
	        sState.clear();
	      });
	    };
	    var isOpen$1 = function (_sandbox, _sConfig, sState) {
	      return sState.isOpen();
	    };
	    var isPartOf = function (sandbox, sConfig, sState, queryElem) {
	      return isOpen$1(sandbox, sConfig, sState) && sState.get().exists(function (data) {
	        return sConfig.isPartOf(sandbox, data, queryElem);
	      });
	    };
	    var getState$2 = function (_sandbox, _sConfig, sState) {
	      return sState.get();
	    };
	    var store = function (sandbox, cssKey, attr, newValue) {
	      getRaw(sandbox.element, cssKey).fold(function () {
	        remove$7(sandbox.element, attr);
	      }, function (v) {
	        set$8(sandbox.element, attr, v);
	      });
	      set$7(sandbox.element, cssKey, newValue);
	    };
	    var restore = function (sandbox, cssKey, attr) {
	      getOpt(sandbox.element, attr).fold(function () {
	        return remove$6(sandbox.element, cssKey);
	      }, function (oldValue) {
	        return set$7(sandbox.element, cssKey, oldValue);
	      });
	    };
	    var cloak = function (sandbox, sConfig, _sState) {
	      var sink = sConfig.getAttachPoint(sandbox);
	      set$7(sandbox.element, 'position', Positioning.getMode(sink));
	      store(sandbox, 'visibility', sConfig.cloakVisibilityAttr, 'hidden');
	    };
	    var hasPosition = function (element) {
	      return exists([
	        'top',
	        'left',
	        'right',
	        'bottom'
	      ], function (pos) {
	        return getRaw(element, pos).isSome();
	      });
	    };
	    var decloak = function (sandbox, sConfig, _sState) {
	      if (!hasPosition(sandbox.element)) {
	        remove$6(sandbox.element, 'position');
	      }
	      restore(sandbox, 'visibility', sConfig.cloakVisibilityAttr);
	    };
	
	    var SandboxApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        cloak: cloak,
	        decloak: decloak,
	        open: open$1,
	        openWhileCloaked: openWhileCloaked,
	        close: close$1,
	        isOpen: isOpen$1,
	        isPartOf: isPartOf,
	        getState: getState$2,
	        setContent: setContent
	    });
	
	    var events$g = function (sandboxConfig, sandboxState) {
	      return derive$2([run$1(sandboxClose(), function (sandbox, _simulatedEvent) {
	          close$1(sandbox, sandboxConfig, sandboxState);
	        })]);
	    };
	
	    var ActiveSandbox = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$g
	    });
	
	    var SandboxSchema = [
	      onHandler('onOpen'),
	      onHandler('onClose'),
	      required$1('isPartOf'),
	      required$1('getAttachPoint'),
	      defaulted('cloakVisibilityAttr', 'data-precloak-visibility')
	    ];
	
	    var init$f = function () {
	      var contents = value$1();
	      var readState = constant$1('not-implemented');
	      return nu$8({
	        readState: readState,
	        isOpen: contents.isSet,
	        clear: contents.clear,
	        set: contents.set,
	        get: contents.get
	      });
	    };
	
	    var SandboxState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$f
	    });
	
	    var Sandboxing = create$8({
	      fields: SandboxSchema,
	      name: 'sandboxing',
	      active: ActiveSandbox,
	      apis: SandboxApis,
	      state: SandboxState
	    });
	
	    var dismissPopups = constant$1('dismiss.popups');
	    var repositionPopups = constant$1('reposition.popups');
	    var mouseReleased = constant$1('mouse.released');
	
	    var schema$x = objOfOnly([
	      defaulted('isExtraPart', never),
	      optionObjOf('fireEventInstead', [defaulted('event', dismissRequested())])
	    ]);
	    var receivingChannel$1 = function (rawSpec) {
	      var _a;
	      var detail = asRawOrDie$1('Dismissal', schema$x, rawSpec);
	      return _a = {}, _a[dismissPopups()] = {
	        schema: objOfOnly([required$1('target')]),
	        onReceive: function (sandbox, data) {
	          if (Sandboxing.isOpen(sandbox)) {
	            var isPart = Sandboxing.isPartOf(sandbox, data.target) || detail.isExtraPart(sandbox, data.target);
	            if (!isPart) {
	              detail.fireEventInstead.fold(function () {
	                return Sandboxing.close(sandbox);
	              }, function (fe) {
	                return emit(sandbox, fe.event);
	              });
	            }
	          }
	        }
	      }, _a;
	    };
	
	    var schema$w = objOfOnly([
	      optionObjOf('fireEventInstead', [defaulted('event', repositionRequested())]),
	      requiredFunction('doReposition')
	    ]);
	    var receivingChannel = function (rawSpec) {
	      var _a;
	      var detail = asRawOrDie$1('Reposition', schema$w, rawSpec);
	      return _a = {}, _a[repositionPopups()] = {
	        onReceive: function (sandbox) {
	          if (Sandboxing.isOpen(sandbox)) {
	            detail.fireEventInstead.fold(function () {
	              return detail.doReposition(sandbox);
	            }, function (fe) {
	              return emit(sandbox, fe.event);
	            });
	          }
	        }
	      }, _a;
	    };
	
	    var onLoad$5 = function (component, repConfig, repState) {
	      repConfig.store.manager.onLoad(component, repConfig, repState);
	    };
	    var onUnload$2 = function (component, repConfig, repState) {
	      repConfig.store.manager.onUnload(component, repConfig, repState);
	    };
	    var setValue$3 = function (component, repConfig, repState, data) {
	      repConfig.store.manager.setValue(component, repConfig, repState, data);
	    };
	    var getValue$3 = function (component, repConfig, repState) {
	      return repConfig.store.manager.getValue(component, repConfig, repState);
	    };
	    var getState$1 = function (component, repConfig, repState) {
	      return repState;
	    };
	
	    var RepresentApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        onLoad: onLoad$5,
	        onUnload: onUnload$2,
	        setValue: setValue$3,
	        getValue: getValue$3,
	        getState: getState$1
	    });
	
	    var events$f = function (repConfig, repState) {
	      var es = repConfig.resetOnDom ? [
	        runOnAttached(function (comp, _se) {
	          onLoad$5(comp, repConfig, repState);
	        }),
	        runOnDetached(function (comp, _se) {
	          onUnload$2(comp, repConfig, repState);
	        })
	      ] : [loadEvent(repConfig, repState, onLoad$5)];
	      return derive$2(es);
	    };
	
	    var ActiveRepresenting = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$f
	    });
	
	    var memory$1 = function () {
	      var data = Cell(null);
	      var readState = function () {
	        return {
	          mode: 'memory',
	          value: data.get()
	        };
	      };
	      var isNotSet = function () {
	        return data.get() === null;
	      };
	      var clear = function () {
	        data.set(null);
	      };
	      return nu$8({
	        set: data.set,
	        get: data.get,
	        isNotSet: isNotSet,
	        clear: clear,
	        readState: readState
	      });
	    };
	    var manual = function () {
	      var readState = noop;
	      return nu$8({ readState: readState });
	    };
	    var dataset = function () {
	      var dataByValue = Cell({});
	      var dataByText = Cell({});
	      var readState = function () {
	        return {
	          mode: 'dataset',
	          dataByValue: dataByValue.get(),
	          dataByText: dataByText.get()
	        };
	      };
	      var clear = function () {
	        dataByValue.set({});
	        dataByText.set({});
	      };
	      var lookup = function (itemString) {
	        return get$e(dataByValue.get(), itemString).orThunk(function () {
	          return get$e(dataByText.get(), itemString);
	        });
	      };
	      var update = function (items) {
	        var currentDataByValue = dataByValue.get();
	        var currentDataByText = dataByText.get();
	        var newDataByValue = {};
	        var newDataByText = {};
	        each$1(items, function (item) {
	          newDataByValue[item.value] = item;
	          get$e(item, 'meta').each(function (meta) {
	            get$e(meta, 'text').each(function (text) {
	              newDataByText[text] = item;
	            });
	          });
	        });
	        dataByValue.set(__assign(__assign({}, currentDataByValue), newDataByValue));
	        dataByText.set(__assign(__assign({}, currentDataByText), newDataByText));
	      };
	      return nu$8({
	        readState: readState,
	        lookup: lookup,
	        update: update,
	        clear: clear
	      });
	    };
	    var init$e = function (spec) {
	      return spec.store.manager.state(spec);
	    };
	
	    var RepresentState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        memory: memory$1,
	        dataset: dataset,
	        manual: manual,
	        init: init$e
	    });
	
	    var setValue$2 = function (component, repConfig, repState, data) {
	      var store = repConfig.store;
	      repState.update([data]);
	      store.setValue(component, data);
	      repConfig.onSetValue(component, data);
	    };
	    var getValue$2 = function (component, repConfig, repState) {
	      var store = repConfig.store;
	      var key = store.getDataKey(component);
	      return repState.lookup(key).getOrThunk(function () {
	        return store.getFallbackEntry(key);
	      });
	    };
	    var onLoad$4 = function (component, repConfig, repState) {
	      var store = repConfig.store;
	      store.initialValue.each(function (data) {
	        setValue$2(component, repConfig, repState, data);
	      });
	    };
	    var onUnload$1 = function (component, repConfig, repState) {
	      repState.clear();
	    };
	    var DatasetStore = [
	      option('initialValue'),
	      required$1('getFallbackEntry'),
	      required$1('getDataKey'),
	      required$1('setValue'),
	      output$1('manager', {
	        setValue: setValue$2,
	        getValue: getValue$2,
	        onLoad: onLoad$4,
	        onUnload: onUnload$1,
	        state: dataset
	      })
	    ];
	
	    var getValue$1 = function (component, repConfig, _repState) {
	      return repConfig.store.getValue(component);
	    };
	    var setValue$1 = function (component, repConfig, _repState, data) {
	      repConfig.store.setValue(component, data);
	      repConfig.onSetValue(component, data);
	    };
	    var onLoad$3 = function (component, repConfig, _repState) {
	      repConfig.store.initialValue.each(function (data) {
	        repConfig.store.setValue(component, data);
	      });
	    };
	    var ManualStore = [
	      required$1('getValue'),
	      defaulted('setValue', noop),
	      option('initialValue'),
	      output$1('manager', {
	        setValue: setValue$1,
	        getValue: getValue$1,
	        onLoad: onLoad$3,
	        onUnload: noop,
	        state: NoState.init
	      })
	    ];
	
	    var setValue = function (component, repConfig, repState, data) {
	      repState.set(data);
	      repConfig.onSetValue(component, data);
	    };
	    var getValue = function (component, repConfig, repState) {
	      return repState.get();
	    };
	    var onLoad$2 = function (component, repConfig, repState) {
	      repConfig.store.initialValue.each(function (initVal) {
	        if (repState.isNotSet()) {
	          repState.set(initVal);
	        }
	      });
	    };
	    var onUnload = function (component, repConfig, repState) {
	      repState.clear();
	    };
	    var MemoryStore = [
	      option('initialValue'),
	      output$1('manager', {
	        setValue: setValue,
	        getValue: getValue,
	        onLoad: onLoad$2,
	        onUnload: onUnload,
	        state: memory$1
	      })
	    ];
	
	    var RepresentSchema = [
	      defaultedOf('store', { mode: 'memory' }, choose$1('mode', {
	        memory: MemoryStore,
	        manual: ManualStore,
	        dataset: DatasetStore
	      })),
	      onHandler('onSetValue'),
	      defaulted('resetOnDom', false)
	    ];
	
	    var Representing = create$8({
	      fields: RepresentSchema,
	      name: 'representing',
	      active: ActiveRepresenting,
	      apis: RepresentApis,
	      extra: {
	        setValueFrom: function (component, source) {
	          var value = Representing.getValue(source);
	          Representing.setValue(component, value);
	        }
	      },
	      state: RepresentState
	    });
	
	    var field = function (name, forbidden) {
	      return defaultedObjOf(name, {}, map$2(forbidden, function (f) {
	        return forbid(f.name(), 'Cannot configure ' + f.name() + ' for ' + name);
	      }).concat([customField('dump', identity$1)]));
	    };
	    var get$2 = function (data) {
	      return data.dump;
	    };
	    var augment = function (data, original) {
	      return __assign(__assign({}, derive$1(original)), data.dump);
	    };
	    var SketchBehaviours = {
	      field: field,
	      augment: augment,
	      get: get$2
	    };
	
	    var _placeholder = 'placeholder';
	    var adt$3 = Adt.generate([
	      {
	        single: [
	          'required',
	          'valueThunk'
	        ]
	      },
	      {
	        multiple: [
	          'required',
	          'valueThunks'
	        ]
	      }
	    ]);
	    var isSubstituted = function (spec) {
	      return has$2(spec, 'uiType');
	    };
	    var subPlaceholder = function (owner, detail, compSpec, placeholders) {
	      if (owner.exists(function (o) {
	          return o !== compSpec.owner;
	        })) {
	        return adt$3.single(true, constant$1(compSpec));
	      }
	      return get$e(placeholders, compSpec.name).fold(function () {
	        throw new Error('Unknown placeholder component: ' + compSpec.name + '\nKnown: [' + keys(placeholders) + ']\nNamespace: ' + owner.getOr('none') + '\nSpec: ' + JSON.stringify(compSpec, null, 2));
	      }, function (newSpec) {
	        return newSpec.replace();
	      });
	    };
	    var scan = function (owner, detail, compSpec, placeholders) {
	      if (isSubstituted(compSpec) && compSpec.uiType === _placeholder) {
	        return subPlaceholder(owner, detail, compSpec, placeholders);
	      } else {
	        return adt$3.single(false, constant$1(compSpec));
	      }
	    };
	    var substitute = function (owner, detail, compSpec, placeholders) {
	      var base = scan(owner, detail, compSpec, placeholders);
	      return base.fold(function (req, valueThunk) {
	        var value = isSubstituted(compSpec) ? valueThunk(detail, compSpec.config, compSpec.validated) : valueThunk(detail);
	        var childSpecs = get$e(value, 'components').getOr([]);
	        var substituted = bind$3(childSpecs, function (c) {
	          return substitute(owner, detail, c, placeholders);
	        });
	        return [__assign(__assign({}, value), { components: substituted })];
	      }, function (req, valuesThunk) {
	        if (isSubstituted(compSpec)) {
	          var values = valuesThunk(detail, compSpec.config, compSpec.validated);
	          var preprocessor = compSpec.validated.preprocess.getOr(identity$1);
	          return preprocessor(values);
	        } else {
	          return valuesThunk(detail);
	        }
	      });
	    };
	    var substituteAll = function (owner, detail, components, placeholders) {
	      return bind$3(components, function (c) {
	        return substitute(owner, detail, c, placeholders);
	      });
	    };
	    var oneReplace = function (label, replacements) {
	      var called = false;
	      var used = function () {
	        return called;
	      };
	      var replace = function () {
	        if (called) {
	          throw new Error('Trying to use the same placeholder more than once: ' + label);
	        }
	        called = true;
	        return replacements;
	      };
	      var required = function () {
	        return replacements.fold(function (req, _) {
	          return req;
	        }, function (req, _) {
	          return req;
	        });
	      };
	      return {
	        name: constant$1(label),
	        required: required,
	        used: used,
	        replace: replace
	      };
	    };
	    var substitutePlaces = function (owner, detail, components, placeholders) {
	      var ps = map$1(placeholders, function (ph, name) {
	        return oneReplace(name, ph);
	      });
	      var outcome = substituteAll(owner, detail, components, ps);
	      each(ps, function (p) {
	        if (p.used() === false && p.required()) {
	          throw new Error('Placeholder: ' + p.name() + ' was not found in components list\nNamespace: ' + owner.getOr('none') + '\nComponents: ' + JSON.stringify(detail.components, null, 2));
	        }
	      });
	      return outcome;
	    };
	    var single$2 = adt$3.single;
	    var multiple = adt$3.multiple;
	    var placeholder = constant$1(_placeholder);
	
	    var adt$2 = Adt.generate([
	      { required: ['data'] },
	      { external: ['data'] },
	      { optional: ['data'] },
	      { group: ['data'] }
	    ]);
	    var fFactory = defaulted('factory', { sketch: identity$1 });
	    var fSchema = defaulted('schema', []);
	    var fName = required$1('name');
	    var fPname = field$1('pname', 'pname', defaultedThunk(function (typeSpec) {
	      return '<alloy.' + generate$6(typeSpec.name) + '>';
	    }), anyValue());
	    var fGroupSchema = customField('schema', function () {
	      return [option('preprocess')];
	    });
	    var fDefaults = defaulted('defaults', constant$1({}));
	    var fOverrides = defaulted('overrides', constant$1({}));
	    var requiredSpec = objOf([
	      fFactory,
	      fSchema,
	      fName,
	      fPname,
	      fDefaults,
	      fOverrides
	    ]);
	    var externalSpec = objOf([
	      fFactory,
	      fSchema,
	      fName,
	      fDefaults,
	      fOverrides
	    ]);
	    var optionalSpec = objOf([
	      fFactory,
	      fSchema,
	      fName,
	      fPname,
	      fDefaults,
	      fOverrides
	    ]);
	    var groupSpec = objOf([
	      fFactory,
	      fGroupSchema,
	      fName,
	      required$1('unit'),
	      fPname,
	      fDefaults,
	      fOverrides
	    ]);
	    var asNamedPart = function (part) {
	      return part.fold(Optional.some, Optional.none, Optional.some, Optional.some);
	    };
	    var name$1 = function (part) {
	      var get = function (data) {
	        return data.name;
	      };
	      return part.fold(get, get, get, get);
	    };
	    var asCommon = function (part) {
	      return part.fold(identity$1, identity$1, identity$1, identity$1);
	    };
	    var convert = function (adtConstructor, partSchema) {
	      return function (spec) {
	        var data = asRawOrDie$1('Converting part type', partSchema, spec);
	        return adtConstructor(data);
	      };
	    };
	    var required = convert(adt$2.required, requiredSpec);
	    var external$1 = convert(adt$2.external, externalSpec);
	    var optional = convert(adt$2.optional, optionalSpec);
	    var group = convert(adt$2.group, groupSpec);
	    var original = constant$1('entirety');
	
	    var PartType = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        required: required,
	        external: external$1,
	        optional: optional,
	        group: group,
	        asNamedPart: asNamedPart,
	        name: name$1,
	        asCommon: asCommon,
	        original: original
	    });
	
	    var combine = function (detail, data, partSpec, partValidated) {
	      return deepMerge(data.defaults(detail, partSpec, partValidated), partSpec, { uid: detail.partUids[data.name] }, data.overrides(detail, partSpec, partValidated));
	    };
	    var subs = function (owner, detail, parts) {
	      var internals = {};
	      var externals = {};
	      each$1(parts, function (part) {
	        part.fold(function (data) {
	          internals[data.pname] = single$2(true, function (detail, partSpec, partValidated) {
	            return data.factory.sketch(combine(detail, data, partSpec, partValidated));
	          });
	        }, function (data) {
	          var partSpec = detail.parts[data.name];
	          externals[data.name] = constant$1(data.factory.sketch(combine(detail, data, partSpec[original()]), partSpec));
	        }, function (data) {
	          internals[data.pname] = single$2(false, function (detail, partSpec, partValidated) {
	            return data.factory.sketch(combine(detail, data, partSpec, partValidated));
	          });
	        }, function (data) {
	          internals[data.pname] = multiple(true, function (detail, _partSpec, _partValidated) {
	            var units = detail[data.name];
	            return map$2(units, function (u) {
	              return data.factory.sketch(deepMerge(data.defaults(detail, u, _partValidated), u, data.overrides(detail, u)));
	            });
	          });
	        });
	      });
	      return {
	        internals: constant$1(internals),
	        externals: constant$1(externals)
	      };
	    };
	
	    var generate$3 = function (owner, parts) {
	      var r = {};
	      each$1(parts, function (part) {
	        asNamedPart(part).each(function (np) {
	          var g = doGenerateOne(owner, np.pname);
	          r[np.name] = function (config) {
	            var validated = asRawOrDie$1('Part: ' + np.name + ' in ' + owner, objOf(np.schema), config);
	            return __assign(__assign({}, g), {
	              config: config,
	              validated: validated
	            });
	          };
	        });
	      });
	      return r;
	    };
	    var doGenerateOne = function (owner, pname) {
	      return {
	        uiType: placeholder(),
	        owner: owner,
	        name: pname
	      };
	    };
	    var generateOne$1 = function (owner, pname, config) {
	      return {
	        uiType: placeholder(),
	        owner: owner,
	        name: pname,
	        config: config,
	        validated: {}
	      };
	    };
	    var schemas = function (parts) {
	      return bind$3(parts, function (part) {
	        return part.fold(Optional.none, Optional.some, Optional.none, Optional.none).map(function (data) {
	          return requiredObjOf(data.name, data.schema.concat([snapshot(original())]));
	        }).toArray();
	      });
	    };
	    var names = function (parts) {
	      return map$2(parts, name$1);
	    };
	    var substitutes = function (owner, detail, parts) {
	      return subs(owner, detail, parts);
	    };
	    var components$1 = function (owner, detail, internals) {
	      return substitutePlaces(Optional.some(owner), detail, detail.components, internals);
	    };
	    var getPart = function (component, detail, partKey) {
	      var uid = detail.partUids[partKey];
	      return component.getSystem().getByUid(uid).toOptional();
	    };
	    var getPartOrDie = function (component, detail, partKey) {
	      return getPart(component, detail, partKey).getOrDie('Could not find part: ' + partKey);
	    };
	    var getParts = function (component, detail, partKeys) {
	      var r = {};
	      var uids = detail.partUids;
	      var system = component.getSystem();
	      each$1(partKeys, function (pk) {
	        r[pk] = constant$1(system.getByUid(uids[pk]));
	      });
	      return r;
	    };
	    var getAllParts = function (component, detail) {
	      var system = component.getSystem();
	      return map$1(detail.partUids, function (pUid, _k) {
	        return constant$1(system.getByUid(pUid));
	      });
	    };
	    var getAllPartNames = function (detail) {
	      return keys(detail.partUids);
	    };
	    var getPartsOrDie = function (component, detail, partKeys) {
	      var r = {};
	      var uids = detail.partUids;
	      var system = component.getSystem();
	      each$1(partKeys, function (pk) {
	        r[pk] = constant$1(system.getByUid(uids[pk]).getOrDie());
	      });
	      return r;
	    };
	    var defaultUids = function (baseUid, partTypes) {
	      var partNames = names(partTypes);
	      return wrapAll(map$2(partNames, function (pn) {
	        return {
	          key: pn,
	          value: baseUid + '-' + pn
	        };
	      }));
	    };
	    var defaultUidsSchema = function (partTypes) {
	      return field$1('partUids', 'partUids', mergeWithThunk(function (spec) {
	        return defaultUids(spec.uid, partTypes);
	      }), anyValue());
	    };
	
	    var AlloyParts = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        generate: generate$3,
	        generateOne: generateOne$1,
	        schemas: schemas,
	        names: names,
	        substitutes: substitutes,
	        components: components$1,
	        defaultUids: defaultUids,
	        defaultUidsSchema: defaultUidsSchema,
	        getAllParts: getAllParts,
	        getAllPartNames: getAllPartNames,
	        getPart: getPart,
	        getPartOrDie: getPartOrDie,
	        getParts: getParts,
	        getPartsOrDie: getPartsOrDie
	    });
	
	    var base = function (partSchemas, partUidsSchemas) {
	      var ps = partSchemas.length > 0 ? [requiredObjOf('parts', partSchemas)] : [];
	      return ps.concat([
	        required$1('uid'),
	        defaulted('dom', {}),
	        defaulted('components', []),
	        snapshot('originalSpec'),
	        defaulted('debug.sketcher', {})
	      ]).concat(partUidsSchemas);
	    };
	    var asRawOrDie = function (label, schema, spec, partSchemas, partUidsSchemas) {
	      var baseS = base(partSchemas, partUidsSchemas);
	      return asRawOrDie$1(label + ' [SpecSchema]', objOfOnly(baseS.concat(schema)), spec);
	    };
	
	    var single$1 = function (owner, schema, factory, spec) {
	      var specWithUid = supplyUid(spec);
	      var detail = asRawOrDie(owner, schema, specWithUid, [], []);
	      return factory(detail, specWithUid);
	    };
	    var composite$1 = function (owner, schema, partTypes, factory, spec) {
	      var specWithUid = supplyUid(spec);
	      var partSchemas = schemas(partTypes);
	      var partUidsSchema = defaultUidsSchema(partTypes);
	      var detail = asRawOrDie(owner, schema, specWithUid, partSchemas, [partUidsSchema]);
	      var subs = substitutes(owner, detail, partTypes);
	      var components = components$1(owner, detail, subs.internals());
	      return factory(detail, components, specWithUid, subs.externals());
	    };
	    var hasUid = function (spec) {
	      return has$2(spec, 'uid');
	    };
	    var supplyUid = function (spec) {
	      return hasUid(spec) ? spec : __assign(__assign({}, spec), { uid: generate$5('uid') });
	    };
	
	    var isSketchSpec = function (spec) {
	      return spec.uid !== undefined;
	    };
	    var singleSchema = objOfOnly([
	      required$1('name'),
	      required$1('factory'),
	      required$1('configFields'),
	      defaulted('apis', {}),
	      defaulted('extraApis', {})
	    ]);
	    var compositeSchema = objOfOnly([
	      required$1('name'),
	      required$1('factory'),
	      required$1('configFields'),
	      required$1('partFields'),
	      defaulted('apis', {}),
	      defaulted('extraApis', {})
	    ]);
	    var single = function (rawConfig) {
	      var config = asRawOrDie$1('Sketcher for ' + rawConfig.name, singleSchema, rawConfig);
	      var sketch = function (spec) {
	        return single$1(config.name, config.configFields, config.factory, spec);
	      };
	      var apis = map$1(config.apis, makeApi);
	      var extraApis = map$1(config.extraApis, function (f, k) {
	        return markAsExtraApi(f, k);
	      });
	      return __assign(__assign({
	        name: config.name,
	        configFields: config.configFields,
	        sketch: sketch
	      }, apis), extraApis);
	    };
	    var composite = function (rawConfig) {
	      var config = asRawOrDie$1('Sketcher for ' + rawConfig.name, compositeSchema, rawConfig);
	      var sketch = function (spec) {
	        return composite$1(config.name, config.configFields, config.partFields, config.factory, spec);
	      };
	      var parts = generate$3(config.name, config.partFields);
	      var apis = map$1(config.apis, makeApi);
	      var extraApis = map$1(config.extraApis, function (f, k) {
	        return markAsExtraApi(f, k);
	      });
	      return __assign(__assign({
	        name: config.name,
	        partFields: config.partFields,
	        configFields: config.configFields,
	        sketch: sketch,
	        parts: parts
	      }, apis), extraApis);
	    };
	
	    var inside = function (target) {
	      return name$2(target) === 'input' && get$d(target, 'type') !== 'radio' || name$2(target) === 'textarea';
	    };
	
	    var getCurrent = function (component, composeConfig, _composeState) {
	      return composeConfig.find(component);
	    };
	
	    var ComposeApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getCurrent: getCurrent
	    });
	
	    var ComposeSchema = [required$1('find')];
	
	    var Composing = create$8({
	      fields: ComposeSchema,
	      name: 'composing',
	      apis: ComposeApis
	    });
	
	    var nativeDisabled = [
	      'input',
	      'button',
	      'textarea',
	      'select'
	    ];
	    var onLoad$1 = function (component, disableConfig, disableState) {
	      var f = disableConfig.disabled() ? disable$1 : enable$1;
	      f(component, disableConfig);
	    };
	    var hasNative = function (component, config) {
	      return config.useNative === true && contains$2(nativeDisabled, name$2(component.element));
	    };
	    var nativeIsDisabled = function (component) {
	      return has$1(component.element, 'disabled');
	    };
	    var nativeDisable = function (component) {
	      set$8(component.element, 'disabled', 'disabled');
	    };
	    var nativeEnable = function (component) {
	      remove$7(component.element, 'disabled');
	    };
	    var ariaIsDisabled = function (component) {
	      return get$d(component.element, 'aria-disabled') === 'true';
	    };
	    var ariaDisable = function (component) {
	      set$8(component.element, 'aria-disabled', 'true');
	    };
	    var ariaEnable = function (component) {
	      set$8(component.element, 'aria-disabled', 'false');
	    };
	    var disable$1 = function (component, disableConfig, _disableState) {
	      disableConfig.disableClass.each(function (disableClass) {
	        add$2(component.element, disableClass);
	      });
	      var f = hasNative(component, disableConfig) ? nativeDisable : ariaDisable;
	      f(component);
	      disableConfig.onDisabled(component);
	    };
	    var enable$1 = function (component, disableConfig, _disableState) {
	      disableConfig.disableClass.each(function (disableClass) {
	        remove$2(component.element, disableClass);
	      });
	      var f = hasNative(component, disableConfig) ? nativeEnable : ariaEnable;
	      f(component);
	      disableConfig.onEnabled(component);
	    };
	    var isDisabled = function (component, disableConfig) {
	      return hasNative(component, disableConfig) ? nativeIsDisabled(component) : ariaIsDisabled(component);
	    };
	    var set$3 = function (component, disableConfig, disableState, disabled) {
	      var f = disabled ? disable$1 : enable$1;
	      f(component, disableConfig);
	    };
	
	    var DisableApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        enable: enable$1,
	        disable: disable$1,
	        isDisabled: isDisabled,
	        onLoad: onLoad$1,
	        set: set$3
	    });
	
	    var exhibit$5 = function (base, disableConfig) {
	      return nu$7({ classes: disableConfig.disabled() ? disableConfig.disableClass.toArray() : [] });
	    };
	    var events$e = function (disableConfig, disableState) {
	      return derive$2([
	        abort(execute$5(), function (component, _simulatedEvent) {
	          return isDisabled(component, disableConfig);
	        }),
	        loadEvent(disableConfig, disableState, onLoad$1)
	      ]);
	    };
	
	    var ActiveDisable = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$5,
	        events: events$e
	    });
	
	    var DisableSchema = [
	      defaultedFunction('disabled', never),
	      defaulted('useNative', true),
	      option('disableClass'),
	      onHandler('onDisabled'),
	      onHandler('onEnabled')
	    ];
	
	    var Disabling = create$8({
	      fields: DisableSchema,
	      name: 'disabling',
	      active: ActiveDisable,
	      apis: DisableApis
	    });
	
	    var dehighlightAllExcept = function (component, hConfig, hState, skip) {
	      var highlighted = descendants(component.element, '.' + hConfig.highlightClass);
	      each$1(highlighted, function (h) {
	        if (!exists(skip, function (skipComp) {
	            return skipComp.element === h;
	          })) {
	          remove$2(h, hConfig.highlightClass);
	          component.getSystem().getByDom(h).each(function (target) {
	            hConfig.onDehighlight(component, target);
	            emit(target, dehighlight$1());
	          });
	        }
	      });
	    };
	    var dehighlightAll = function (component, hConfig, hState) {
	      return dehighlightAllExcept(component, hConfig, hState, []);
	    };
	    var dehighlight = function (component, hConfig, hState, target) {
	      if (isHighlighted(component, hConfig, hState, target)) {
	        remove$2(target.element, hConfig.highlightClass);
	        hConfig.onDehighlight(component, target);
	        emit(target, dehighlight$1());
	      }
	    };
	    var highlight = function (component, hConfig, hState, target) {
	      dehighlightAllExcept(component, hConfig, hState, [target]);
	      if (!isHighlighted(component, hConfig, hState, target)) {
	        add$2(target.element, hConfig.highlightClass);
	        hConfig.onHighlight(component, target);
	        emit(target, highlight$1());
	      }
	    };
	    var highlightFirst = function (component, hConfig, hState) {
	      getFirst(component, hConfig).each(function (firstComp) {
	        highlight(component, hConfig, hState, firstComp);
	      });
	    };
	    var highlightLast = function (component, hConfig, hState) {
	      getLast(component, hConfig).each(function (lastComp) {
	        highlight(component, hConfig, hState, lastComp);
	      });
	    };
	    var highlightAt = function (component, hConfig, hState, index) {
	      getByIndex(component, hConfig, hState, index).fold(function (err) {
	        throw err;
	      }, function (firstComp) {
	        highlight(component, hConfig, hState, firstComp);
	      });
	    };
	    var highlightBy = function (component, hConfig, hState, predicate) {
	      var candidates = getCandidates(component, hConfig);
	      var targetComp = find$5(candidates, predicate);
	      targetComp.each(function (c) {
	        highlight(component, hConfig, hState, c);
	      });
	    };
	    var isHighlighted = function (component, hConfig, hState, queryTarget) {
	      return has(queryTarget.element, hConfig.highlightClass);
	    };
	    var getHighlighted = function (component, hConfig, _hState) {
	      return descendant(component.element, '.' + hConfig.highlightClass).bind(function (e) {
	        return component.getSystem().getByDom(e).toOptional();
	      });
	    };
	    var getByIndex = function (component, hConfig, hState, index) {
	      var items = descendants(component.element, '.' + hConfig.itemClass);
	      return Optional.from(items[index]).fold(function () {
	        return Result.error(new Error('No element found with index ' + index));
	      }, component.getSystem().getByDom);
	    };
	    var getFirst = function (component, hConfig, _hState) {
	      return descendant(component.element, '.' + hConfig.itemClass).bind(function (e) {
	        return component.getSystem().getByDom(e).toOptional();
	      });
	    };
	    var getLast = function (component, hConfig, _hState) {
	      var items = descendants(component.element, '.' + hConfig.itemClass);
	      var last = items.length > 0 ? Optional.some(items[items.length - 1]) : Optional.none();
	      return last.bind(function (c) {
	        return component.getSystem().getByDom(c).toOptional();
	      });
	    };
	    var getDelta$2 = function (component, hConfig, hState, delta) {
	      var items = descendants(component.element, '.' + hConfig.itemClass);
	      var current = findIndex$1(items, function (item) {
	        return has(item, hConfig.highlightClass);
	      });
	      return current.bind(function (selected) {
	        var dest = cycleBy(selected, delta, 0, items.length - 1);
	        return component.getSystem().getByDom(items[dest]).toOptional();
	      });
	    };
	    var getPrevious = function (component, hConfig, hState) {
	      return getDelta$2(component, hConfig, hState, -1);
	    };
	    var getNext = function (component, hConfig, hState) {
	      return getDelta$2(component, hConfig, hState, +1);
	    };
	    var getCandidates = function (component, hConfig, _hState) {
	      var items = descendants(component.element, '.' + hConfig.itemClass);
	      return cat(map$2(items, function (i) {
	        return component.getSystem().getByDom(i).toOptional();
	      }));
	    };
	
	    var HighlightApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        dehighlightAll: dehighlightAll,
	        dehighlight: dehighlight,
	        highlight: highlight,
	        highlightFirst: highlightFirst,
	        highlightLast: highlightLast,
	        highlightAt: highlightAt,
	        highlightBy: highlightBy,
	        isHighlighted: isHighlighted,
	        getHighlighted: getHighlighted,
	        getFirst: getFirst,
	        getLast: getLast,
	        getPrevious: getPrevious,
	        getNext: getNext,
	        getCandidates: getCandidates
	    });
	
	    var HighlightSchema = [
	      required$1('highlightClass'),
	      required$1('itemClass'),
	      onHandler('onHighlight'),
	      onHandler('onDehighlight')
	    ];
	
	    var Highlighting = create$8({
	      fields: HighlightSchema,
	      name: 'highlighting',
	      apis: HighlightApis
	    });
	
	    var BACKSPACE = [8];
	    var TAB = [9];
	    var ENTER = [13];
	    var ESCAPE = [27];
	    var SPACE = [32];
	    var LEFT = [37];
	    var UP = [38];
	    var RIGHT = [39];
	    var DOWN = [40];
	
	    var cyclePrev = function (values, index, predicate) {
	      var before = reverse(values.slice(0, index));
	      var after = reverse(values.slice(index + 1));
	      return find$5(before.concat(after), predicate);
	    };
	    var tryPrev = function (values, index, predicate) {
	      var before = reverse(values.slice(0, index));
	      return find$5(before, predicate);
	    };
	    var cycleNext = function (values, index, predicate) {
	      var before = values.slice(0, index);
	      var after = values.slice(index + 1);
	      return find$5(after.concat(before), predicate);
	    };
	    var tryNext = function (values, index, predicate) {
	      var after = values.slice(index + 1);
	      return find$5(after, predicate);
	    };
	
	    var inSet = function (keys) {
	      return function (event) {
	        var raw = event.raw;
	        return contains$2(keys, raw.which);
	      };
	    };
	    var and = function (preds) {
	      return function (event) {
	        return forall(preds, function (pred) {
	          return pred(event);
	        });
	      };
	    };
	    var isShift = function (event) {
	      var raw = event.raw;
	      return raw.shiftKey === true;
	    };
	    var isControl = function (event) {
	      var raw = event.raw;
	      return raw.ctrlKey === true;
	    };
	    var isNotShift = not(isShift);
	
	    var rule = function (matches, action) {
	      return {
	        matches: matches,
	        classification: action
	      };
	    };
	    var choose = function (transitions, event) {
	      var transition = find$5(transitions, function (t) {
	        return t.matches(event);
	      });
	      return transition.map(function (t) {
	        return t.classification;
	      });
	    };
	
	    var reportFocusShifting = function (component, prevFocus, newFocus) {
	      var noChange = prevFocus.exists(function (p) {
	        return newFocus.exists(function (n) {
	          return eq(n, p);
	        });
	      });
	      if (!noChange) {
	        emitWith(component, focusShifted(), {
	          prevFocus: prevFocus,
	          newFocus: newFocus
	        });
	      }
	    };
	    var dom$2 = function () {
	      var get = function (component) {
	        return search(component.element);
	      };
	      var set = function (component, focusee) {
	        var prevFocus = get(component);
	        component.getSystem().triggerFocus(focusee, component.element);
	        var newFocus = get(component);
	        reportFocusShifting(component, prevFocus, newFocus);
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	    var highlights = function () {
	      var get = function (component) {
	        return Highlighting.getHighlighted(component).map(function (item) {
	          return item.element;
	        });
	      };
	      var set = function (component, element) {
	        var prevFocus = get(component);
	        component.getSystem().getByDom(element).fold(noop, function (item) {
	          Highlighting.highlight(component, item);
	        });
	        var newFocus = get(component);
	        reportFocusShifting(component, prevFocus, newFocus);
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var FocusInsideModes;
	    (function (FocusInsideModes) {
	      FocusInsideModes['OnFocusMode'] = 'onFocus';
	      FocusInsideModes['OnEnterOrSpaceMode'] = 'onEnterOrSpace';
	      FocusInsideModes['OnApiMode'] = 'onApi';
	    }(FocusInsideModes || (FocusInsideModes = {})));
	
	    var typical = function (infoSchema, stateInit, getKeydownRules, getKeyupRules, optFocusIn) {
	      var schema = function () {
	        return infoSchema.concat([
	          defaulted('focusManager', dom$2()),
	          defaultedOf('focusInside', 'onFocus', valueOf(function (val) {
	            return contains$2([
	              'onFocus',
	              'onEnterOrSpace',
	              'onApi'
	            ], val) ? Result.value(val) : Result.error('Invalid value for focusInside');
	          })),
	          output$1('handler', me),
	          output$1('state', stateInit),
	          output$1('sendFocusIn', optFocusIn)
	        ]);
	      };
	      var processKey = function (component, simulatedEvent, getRules, keyingConfig, keyingState) {
	        var rules = getRules(component, simulatedEvent, keyingConfig, keyingState);
	        return choose(rules, simulatedEvent.event).bind(function (rule) {
	          return rule(component, simulatedEvent, keyingConfig, keyingState);
	        });
	      };
	      var toEvents = function (keyingConfig, keyingState) {
	        var onFocusHandler = keyingConfig.focusInside !== FocusInsideModes.OnFocusMode ? Optional.none() : optFocusIn(keyingConfig).map(function (focusIn) {
	          return run$1(focus$4(), function (component, simulatedEvent) {
	            focusIn(component, keyingConfig, keyingState);
	            simulatedEvent.stop();
	          });
	        });
	        var tryGoInsideComponent = function (component, simulatedEvent) {
	          var isEnterOrSpace = inSet(SPACE.concat(ENTER))(simulatedEvent.event);
	          if (keyingConfig.focusInside === FocusInsideModes.OnEnterOrSpaceMode && isEnterOrSpace && isSource(component, simulatedEvent)) {
	            optFocusIn(keyingConfig).each(function (focusIn) {
	              focusIn(component, keyingConfig, keyingState);
	              simulatedEvent.stop();
	            });
	          }
	        };
	        var keyboardEvents = [
	          run$1(keydown(), function (component, simulatedEvent) {
	            processKey(component, simulatedEvent, getKeydownRules, keyingConfig, keyingState).fold(function () {
	              tryGoInsideComponent(component, simulatedEvent);
	            }, function (_) {
	              simulatedEvent.stop();
	            });
	          }),
	          run$1(keyup(), function (component, simulatedEvent) {
	            processKey(component, simulatedEvent, getKeyupRules, keyingConfig, keyingState).each(function (_) {
	              simulatedEvent.stop();
	            });
	          })
	        ];
	        return derive$2(onFocusHandler.toArray().concat(keyboardEvents));
	      };
	      var me = {
	        schema: schema,
	        processKey: processKey,
	        toEvents: toEvents
	      };
	      return me;
	    };
	
	    var create$6 = function (cyclicField) {
	      var schema = [
	        option('onEscape'),
	        option('onEnter'),
	        defaulted('selector', '[data-alloy-tabstop="true"]:not(:disabled)'),
	        defaulted('firstTabstop', 0),
	        defaulted('useTabstopAt', always),
	        option('visibilitySelector')
	      ].concat([cyclicField]);
	      var isVisible = function (tabbingConfig, element) {
	        var target = tabbingConfig.visibilitySelector.bind(function (sel) {
	          return closest$1(element, sel);
	        }).getOr(element);
	        return get$b(target) > 0;
	      };
	      var findInitial = function (component, tabbingConfig) {
	        var tabstops = descendants(component.element, tabbingConfig.selector);
	        var visibles = filter$2(tabstops, function (elem) {
	          return isVisible(tabbingConfig, elem);
	        });
	        return Optional.from(visibles[tabbingConfig.firstTabstop]);
	      };
	      var findCurrent = function (component, tabbingConfig) {
	        return tabbingConfig.focusManager.get(component).bind(function (elem) {
	          return closest$1(elem, tabbingConfig.selector);
	        });
	      };
	      var isTabstop = function (tabbingConfig, element) {
	        return isVisible(tabbingConfig, element) && tabbingConfig.useTabstopAt(element);
	      };
	      var focusIn = function (component, tabbingConfig, _tabbingState) {
	        findInitial(component, tabbingConfig).each(function (target) {
	          tabbingConfig.focusManager.set(component, target);
	        });
	      };
	      var goFromTabstop = function (component, tabstops, stopIndex, tabbingConfig, cycle) {
	        return cycle(tabstops, stopIndex, function (elem) {
	          return isTabstop(tabbingConfig, elem);
	        }).fold(function () {
	          return tabbingConfig.cyclic ? Optional.some(true) : Optional.none();
	        }, function (target) {
	          tabbingConfig.focusManager.set(component, target);
	          return Optional.some(true);
	        });
	      };
	      var go = function (component, _simulatedEvent, tabbingConfig, cycle) {
	        var tabstops = descendants(component.element, tabbingConfig.selector);
	        return findCurrent(component, tabbingConfig).bind(function (tabstop) {
	          var optStopIndex = findIndex$1(tabstops, curry(eq, tabstop));
	          return optStopIndex.bind(function (stopIndex) {
	            return goFromTabstop(component, tabstops, stopIndex, tabbingConfig, cycle);
	          });
	        });
	      };
	      var goBackwards = function (component, simulatedEvent, tabbingConfig) {
	        var navigate = tabbingConfig.cyclic ? cyclePrev : tryPrev;
	        return go(component, simulatedEvent, tabbingConfig, navigate);
	      };
	      var goForwards = function (component, simulatedEvent, tabbingConfig) {
	        var navigate = tabbingConfig.cyclic ? cycleNext : tryNext;
	        return go(component, simulatedEvent, tabbingConfig, navigate);
	      };
	      var execute = function (component, simulatedEvent, tabbingConfig) {
	        return tabbingConfig.onEnter.bind(function (f) {
	          return f(component, simulatedEvent);
	        });
	      };
	      var exit = function (component, simulatedEvent, tabbingConfig) {
	        return tabbingConfig.onEscape.bind(function (f) {
	          return f(component, simulatedEvent);
	        });
	      };
	      var getKeydownRules = constant$1([
	        rule(and([
	          isShift,
	          inSet(TAB)
	        ]), goBackwards),
	        rule(inSet(TAB), goForwards),
	        rule(inSet(ESCAPE), exit),
	        rule(and([
	          isNotShift,
	          inSet(ENTER)
	        ]), execute)
	      ]);
	      var getKeyupRules = constant$1([]);
	      return typical(schema, NoState.init, getKeydownRules, getKeyupRules, function () {
	        return Optional.some(focusIn);
	      });
	    };
	
	    var AcyclicType = create$6(customField('cyclic', never));
	
	    var CyclicType = create$6(customField('cyclic', always));
	
	    var doDefaultExecute = function (component, _simulatedEvent, focused) {
	      dispatch(component, focused, execute$5());
	      return Optional.some(true);
	    };
	    var defaultExecute = function (component, simulatedEvent, focused) {
	      var isComplex = inside(focused) && inSet(SPACE)(simulatedEvent.event);
	      return isComplex ? Optional.none() : doDefaultExecute(component, simulatedEvent, focused);
	    };
	    var stopEventForFirefox = function (_component, _simulatedEvent) {
	      return Optional.some(true);
	    };
	
	    var schema$v = [
	      defaulted('execute', defaultExecute),
	      defaulted('useSpace', false),
	      defaulted('useEnter', true),
	      defaulted('useControlEnter', false),
	      defaulted('useDown', false)
	    ];
	    var execute$4 = function (component, simulatedEvent, executeConfig) {
	      return executeConfig.execute(component, simulatedEvent, component.element);
	    };
	    var getKeydownRules$5 = function (component, _simulatedEvent, executeConfig, _executeState) {
	      var spaceExec = executeConfig.useSpace && !inside(component.element) ? SPACE : [];
	      var enterExec = executeConfig.useEnter ? ENTER : [];
	      var downExec = executeConfig.useDown ? DOWN : [];
	      var execKeys = spaceExec.concat(enterExec).concat(downExec);
	      return [rule(inSet(execKeys), execute$4)].concat(executeConfig.useControlEnter ? [rule(and([
	          isControl,
	          inSet(ENTER)
	        ]), execute$4)] : []);
	    };
	    var getKeyupRules$5 = function (component, _simulatedEvent, executeConfig, _executeState) {
	      return executeConfig.useSpace && !inside(component.element) ? [rule(inSet(SPACE), stopEventForFirefox)] : [];
	    };
	    var ExecutionType = typical(schema$v, NoState.init, getKeydownRules$5, getKeyupRules$5, function () {
	      return Optional.none();
	    });
	
	    var flatgrid$1 = function () {
	      var dimensions = value$1();
	      var setGridSize = function (numRows, numColumns) {
	        dimensions.set({
	          numRows: numRows,
	          numColumns: numColumns
	        });
	      };
	      var getNumRows = function () {
	        return dimensions.get().map(function (d) {
	          return d.numRows;
	        });
	      };
	      var getNumColumns = function () {
	        return dimensions.get().map(function (d) {
	          return d.numColumns;
	        });
	      };
	      return nu$8({
	        readState: function () {
	          return dimensions.get().map(function (d) {
	            return {
	              numRows: String(d.numRows),
	              numColumns: String(d.numColumns)
	            };
	          }).getOr({
	            numRows: '?',
	            numColumns: '?'
	          });
	        },
	        setGridSize: setGridSize,
	        getNumRows: getNumRows,
	        getNumColumns: getNumColumns
	      });
	    };
	    var init$d = function (spec) {
	      return spec.state(spec);
	    };
	
	    var KeyingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        flatgrid: flatgrid$1,
	        init: init$d
	    });
	
	    var useH = function (movement) {
	      return function (component, simulatedEvent, config, state) {
	        var move = movement(component.element);
	        return use(move, component, simulatedEvent, config, state);
	      };
	    };
	    var west$1 = function (moveLeft, moveRight) {
	      var movement = onDirection(moveLeft, moveRight);
	      return useH(movement);
	    };
	    var east$1 = function (moveLeft, moveRight) {
	      var movement = onDirection(moveRight, moveLeft);
	      return useH(movement);
	    };
	    var useV = function (move) {
	      return function (component, simulatedEvent, config, state) {
	        return use(move, component, simulatedEvent, config, state);
	      };
	    };
	    var use = function (move, component, simulatedEvent, config, state) {
	      var outcome = config.focusManager.get(component).bind(function (focused) {
	        return move(component.element, focused, config, state);
	      });
	      return outcome.map(function (newFocus) {
	        config.focusManager.set(component, newFocus);
	        return true;
	      });
	    };
	    var north$1 = useV;
	    var south$1 = useV;
	    var move$1 = useV;
	
	    var isHidden$1 = function (dom) {
	      return dom.offsetWidth <= 0 && dom.offsetHeight <= 0;
	    };
	    var isVisible = function (element) {
	      return !isHidden$1(element.dom);
	    };
	
	    var locate = function (candidates, predicate) {
	      return findIndex$1(candidates, predicate).map(function (index) {
	        return {
	          index: index,
	          candidates: candidates
	        };
	      });
	    };
	
	    var locateVisible = function (container, current, selector) {
	      var predicate = function (x) {
	        return eq(x, current);
	      };
	      var candidates = descendants(container, selector);
	      var visible = filter$2(candidates, isVisible);
	      return locate(visible, predicate);
	    };
	    var findIndex = function (elements, target) {
	      return findIndex$1(elements, function (elem) {
	        return eq(target, elem);
	      });
	    };
	
	    var withGrid = function (values, index, numCols, f) {
	      var oldRow = Math.floor(index / numCols);
	      var oldColumn = index % numCols;
	      return f(oldRow, oldColumn).bind(function (address) {
	        var newIndex = address.row * numCols + address.column;
	        return newIndex >= 0 && newIndex < values.length ? Optional.some(values[newIndex]) : Optional.none();
	      });
	    };
	    var cycleHorizontal$1 = function (values, index, numRows, numCols, delta) {
	      return withGrid(values, index, numCols, function (oldRow, oldColumn) {
	        var onLastRow = oldRow === numRows - 1;
	        var colsInRow = onLastRow ? values.length - oldRow * numCols : numCols;
	        var newColumn = cycleBy(oldColumn, delta, 0, colsInRow - 1);
	        return Optional.some({
	          row: oldRow,
	          column: newColumn
	        });
	      });
	    };
	    var cycleVertical$1 = function (values, index, numRows, numCols, delta) {
	      return withGrid(values, index, numCols, function (oldRow, oldColumn) {
	        var newRow = cycleBy(oldRow, delta, 0, numRows - 1);
	        var onLastRow = newRow === numRows - 1;
	        var colsInRow = onLastRow ? values.length - newRow * numCols : numCols;
	        var newCol = clamp$1(oldColumn, 0, colsInRow - 1);
	        return Optional.some({
	          row: newRow,
	          column: newCol
	        });
	      });
	    };
	    var cycleRight$1 = function (values, index, numRows, numCols) {
	      return cycleHorizontal$1(values, index, numRows, numCols, +1);
	    };
	    var cycleLeft$1 = function (values, index, numRows, numCols) {
	      return cycleHorizontal$1(values, index, numRows, numCols, -1);
	    };
	    var cycleUp$1 = function (values, index, numRows, numCols) {
	      return cycleVertical$1(values, index, numRows, numCols, -1);
	    };
	    var cycleDown$1 = function (values, index, numRows, numCols) {
	      return cycleVertical$1(values, index, numRows, numCols, +1);
	    };
	
	    var schema$u = [
	      required$1('selector'),
	      defaulted('execute', defaultExecute),
	      onKeyboardHandler('onEscape'),
	      defaulted('captureTab', false),
	      initSize()
	    ];
	    var focusIn$3 = function (component, gridConfig, _gridState) {
	      descendant(component.element, gridConfig.selector).each(function (first) {
	        gridConfig.focusManager.set(component, first);
	      });
	    };
	    var findCurrent$1 = function (component, gridConfig) {
	      return gridConfig.focusManager.get(component).bind(function (elem) {
	        return closest$1(elem, gridConfig.selector);
	      });
	    };
	    var execute$3 = function (component, simulatedEvent, gridConfig, _gridState) {
	      return findCurrent$1(component, gridConfig).bind(function (focused) {
	        return gridConfig.execute(component, simulatedEvent, focused);
	      });
	    };
	    var doMove$2 = function (cycle) {
	      return function (element, focused, gridConfig, gridState) {
	        return locateVisible(element, focused, gridConfig.selector).bind(function (identified) {
	          return cycle(identified.candidates, identified.index, gridState.getNumRows().getOr(gridConfig.initSize.numRows), gridState.getNumColumns().getOr(gridConfig.initSize.numColumns));
	        });
	      };
	    };
	    var handleTab = function (_component, _simulatedEvent, gridConfig) {
	      return gridConfig.captureTab ? Optional.some(true) : Optional.none();
	    };
	    var doEscape$1 = function (component, simulatedEvent, gridConfig) {
	      return gridConfig.onEscape(component, simulatedEvent);
	    };
	    var moveLeft$3 = doMove$2(cycleLeft$1);
	    var moveRight$3 = doMove$2(cycleRight$1);
	    var moveNorth$1 = doMove$2(cycleUp$1);
	    var moveSouth$1 = doMove$2(cycleDown$1);
	    var getKeydownRules$4 = constant$1([
	      rule(inSet(LEFT), west$1(moveLeft$3, moveRight$3)),
	      rule(inSet(RIGHT), east$1(moveLeft$3, moveRight$3)),
	      rule(inSet(UP), north$1(moveNorth$1)),
	      rule(inSet(DOWN), south$1(moveSouth$1)),
	      rule(and([
	        isShift,
	        inSet(TAB)
	      ]), handleTab),
	      rule(and([
	        isNotShift,
	        inSet(TAB)
	      ]), handleTab),
	      rule(inSet(ESCAPE), doEscape$1),
	      rule(inSet(SPACE.concat(ENTER)), execute$3)
	    ]);
	    var getKeyupRules$4 = constant$1([rule(inSet(SPACE), stopEventForFirefox)]);
	    var FlatgridType = typical(schema$u, flatgrid$1, getKeydownRules$4, getKeyupRules$4, function () {
	      return Optional.some(focusIn$3);
	    });
	
	    var horizontal = function (container, selector, current, delta) {
	      var isDisabledButton = function (candidate) {
	        return name$2(candidate) === 'button' && get$d(candidate, 'disabled') === 'disabled';
	      };
	      var tryCycle = function (initial, index, candidates) {
	        var newIndex = cycleBy(index, delta, 0, candidates.length - 1);
	        if (newIndex === initial) {
	          return Optional.none();
	        } else {
	          return isDisabledButton(candidates[newIndex]) ? tryCycle(initial, newIndex, candidates) : Optional.from(candidates[newIndex]);
	        }
	      };
	      return locateVisible(container, current, selector).bind(function (identified) {
	        var index = identified.index;
	        var candidates = identified.candidates;
	        return tryCycle(index, index, candidates);
	      });
	    };
	
	    var schema$t = [
	      required$1('selector'),
	      defaulted('getInitial', Optional.none),
	      defaulted('execute', defaultExecute),
	      onKeyboardHandler('onEscape'),
	      defaulted('executeOnMove', false),
	      defaulted('allowVertical', true)
	    ];
	    var findCurrent = function (component, flowConfig) {
	      return flowConfig.focusManager.get(component).bind(function (elem) {
	        return closest$1(elem, flowConfig.selector);
	      });
	    };
	    var execute$2 = function (component, simulatedEvent, flowConfig) {
	      return findCurrent(component, flowConfig).bind(function (focused) {
	        return flowConfig.execute(component, simulatedEvent, focused);
	      });
	    };
	    var focusIn$2 = function (component, flowConfig, _state) {
	      flowConfig.getInitial(component).orThunk(function () {
	        return descendant(component.element, flowConfig.selector);
	      }).each(function (first) {
	        flowConfig.focusManager.set(component, first);
	      });
	    };
	    var moveLeft$2 = function (element, focused, info) {
	      return horizontal(element, info.selector, focused, -1);
	    };
	    var moveRight$2 = function (element, focused, info) {
	      return horizontal(element, info.selector, focused, +1);
	    };
	    var doMove$1 = function (movement) {
	      return function (component, simulatedEvent, flowConfig, flowState) {
	        return movement(component, simulatedEvent, flowConfig, flowState).bind(function () {
	          return flowConfig.executeOnMove ? execute$2(component, simulatedEvent, flowConfig) : Optional.some(true);
	        });
	      };
	    };
	    var doEscape = function (component, simulatedEvent, flowConfig) {
	      return flowConfig.onEscape(component, simulatedEvent);
	    };
	    var getKeydownRules$3 = function (_component, _se, flowConfig, _flowState) {
	      var westMovers = LEFT.concat(flowConfig.allowVertical ? UP : []);
	      var eastMovers = RIGHT.concat(flowConfig.allowVertical ? DOWN : []);
	      return [
	        rule(inSet(westMovers), doMove$1(west$1(moveLeft$2, moveRight$2))),
	        rule(inSet(eastMovers), doMove$1(east$1(moveLeft$2, moveRight$2))),
	        rule(inSet(ENTER), execute$2),
	        rule(inSet(SPACE), execute$2),
	        rule(inSet(ESCAPE), doEscape)
	      ];
	    };
	    var getKeyupRules$3 = constant$1([rule(inSet(SPACE), stopEventForFirefox)]);
	    var FlowType = typical(schema$t, NoState.init, getKeydownRules$3, getKeyupRules$3, function () {
	      return Optional.some(focusIn$2);
	    });
	
	    var toCell = function (matrix, rowIndex, columnIndex) {
	      return Optional.from(matrix[rowIndex]).bind(function (row) {
	        return Optional.from(row[columnIndex]).map(function (cell) {
	          return {
	            rowIndex: rowIndex,
	            columnIndex: columnIndex,
	            cell: cell
	          };
	        });
	      });
	    };
	    var cycleHorizontal = function (matrix, rowIndex, startCol, deltaCol) {
	      var row = matrix[rowIndex];
	      var colsInRow = row.length;
	      var newColIndex = cycleBy(startCol, deltaCol, 0, colsInRow - 1);
	      return toCell(matrix, rowIndex, newColIndex);
	    };
	    var cycleVertical = function (matrix, colIndex, startRow, deltaRow) {
	      var nextRowIndex = cycleBy(startRow, deltaRow, 0, matrix.length - 1);
	      var colsInNextRow = matrix[nextRowIndex].length;
	      var nextColIndex = clamp$1(colIndex, 0, colsInNextRow - 1);
	      return toCell(matrix, nextRowIndex, nextColIndex);
	    };
	    var moveHorizontal = function (matrix, rowIndex, startCol, deltaCol) {
	      var row = matrix[rowIndex];
	      var colsInRow = row.length;
	      var newColIndex = clamp$1(startCol + deltaCol, 0, colsInRow - 1);
	      return toCell(matrix, rowIndex, newColIndex);
	    };
	    var moveVertical = function (matrix, colIndex, startRow, deltaRow) {
	      var nextRowIndex = clamp$1(startRow + deltaRow, 0, matrix.length - 1);
	      var colsInNextRow = matrix[nextRowIndex].length;
	      var nextColIndex = clamp$1(colIndex, 0, colsInNextRow - 1);
	      return toCell(matrix, nextRowIndex, nextColIndex);
	    };
	    var cycleRight = function (matrix, startRow, startCol) {
	      return cycleHorizontal(matrix, startRow, startCol, +1);
	    };
	    var cycleLeft = function (matrix, startRow, startCol) {
	      return cycleHorizontal(matrix, startRow, startCol, -1);
	    };
	    var cycleUp = function (matrix, startRow, startCol) {
	      return cycleVertical(matrix, startCol, startRow, -1);
	    };
	    var cycleDown = function (matrix, startRow, startCol) {
	      return cycleVertical(matrix, startCol, startRow, +1);
	    };
	    var moveLeft$1 = function (matrix, startRow, startCol) {
	      return moveHorizontal(matrix, startRow, startCol, -1);
	    };
	    var moveRight$1 = function (matrix, startRow, startCol) {
	      return moveHorizontal(matrix, startRow, startCol, +1);
	    };
	    var moveUp$1 = function (matrix, startRow, startCol) {
	      return moveVertical(matrix, startCol, startRow, -1);
	    };
	    var moveDown$1 = function (matrix, startRow, startCol) {
	      return moveVertical(matrix, startCol, startRow, +1);
	    };
	
	    var schema$s = [
	      requiredObjOf('selectors', [
	        required$1('row'),
	        required$1('cell')
	      ]),
	      defaulted('cycles', true),
	      defaulted('previousSelector', Optional.none),
	      defaulted('execute', defaultExecute)
	    ];
	    var focusIn$1 = function (component, matrixConfig, _state) {
	      var focused = matrixConfig.previousSelector(component).orThunk(function () {
	        var selectors = matrixConfig.selectors;
	        return descendant(component.element, selectors.cell);
	      });
	      focused.each(function (cell) {
	        matrixConfig.focusManager.set(component, cell);
	      });
	    };
	    var execute$1 = function (component, simulatedEvent, matrixConfig) {
	      return search(component.element).bind(function (focused) {
	        return matrixConfig.execute(component, simulatedEvent, focused);
	      });
	    };
	    var toMatrix = function (rows, matrixConfig) {
	      return map$2(rows, function (row) {
	        return descendants(row, matrixConfig.selectors.cell);
	      });
	    };
	    var doMove = function (ifCycle, ifMove) {
	      return function (element, focused, matrixConfig) {
	        var move = matrixConfig.cycles ? ifCycle : ifMove;
	        return closest$1(focused, matrixConfig.selectors.row).bind(function (inRow) {
	          var cellsInRow = descendants(inRow, matrixConfig.selectors.cell);
	          return findIndex(cellsInRow, focused).bind(function (colIndex) {
	            var allRows = descendants(element, matrixConfig.selectors.row);
	            return findIndex(allRows, inRow).bind(function (rowIndex) {
	              var matrix = toMatrix(allRows, matrixConfig);
	              return move(matrix, rowIndex, colIndex).map(function (next) {
	                return next.cell;
	              });
	            });
	          });
	        });
	      };
	    };
	    var moveLeft = doMove(cycleLeft, moveLeft$1);
	    var moveRight = doMove(cycleRight, moveRight$1);
	    var moveNorth = doMove(cycleUp, moveUp$1);
	    var moveSouth = doMove(cycleDown, moveDown$1);
	    var getKeydownRules$2 = constant$1([
	      rule(inSet(LEFT), west$1(moveLeft, moveRight)),
	      rule(inSet(RIGHT), east$1(moveLeft, moveRight)),
	      rule(inSet(UP), north$1(moveNorth)),
	      rule(inSet(DOWN), south$1(moveSouth)),
	      rule(inSet(SPACE.concat(ENTER)), execute$1)
	    ]);
	    var getKeyupRules$2 = constant$1([rule(inSet(SPACE), stopEventForFirefox)]);
	    var MatrixType = typical(schema$s, NoState.init, getKeydownRules$2, getKeyupRules$2, function () {
	      return Optional.some(focusIn$1);
	    });
	
	    var schema$r = [
	      required$1('selector'),
	      defaulted('execute', defaultExecute),
	      defaulted('moveOnTab', false)
	    ];
	    var execute = function (component, simulatedEvent, menuConfig) {
	      return menuConfig.focusManager.get(component).bind(function (focused) {
	        return menuConfig.execute(component, simulatedEvent, focused);
	      });
	    };
	    var focusIn = function (component, menuConfig, _state) {
	      descendant(component.element, menuConfig.selector).each(function (first) {
	        menuConfig.focusManager.set(component, first);
	      });
	    };
	    var moveUp = function (element, focused, info) {
	      return horizontal(element, info.selector, focused, -1);
	    };
	    var moveDown = function (element, focused, info) {
	      return horizontal(element, info.selector, focused, +1);
	    };
	    var fireShiftTab = function (component, simulatedEvent, menuConfig, menuState) {
	      return menuConfig.moveOnTab ? move$1(moveUp)(component, simulatedEvent, menuConfig, menuState) : Optional.none();
	    };
	    var fireTab = function (component, simulatedEvent, menuConfig, menuState) {
	      return menuConfig.moveOnTab ? move$1(moveDown)(component, simulatedEvent, menuConfig, menuState) : Optional.none();
	    };
	    var getKeydownRules$1 = constant$1([
	      rule(inSet(UP), move$1(moveUp)),
	      rule(inSet(DOWN), move$1(moveDown)),
	      rule(and([
	        isShift,
	        inSet(TAB)
	      ]), fireShiftTab),
	      rule(and([
	        isNotShift,
	        inSet(TAB)
	      ]), fireTab),
	      rule(inSet(ENTER), execute),
	      rule(inSet(SPACE), execute)
	    ]);
	    var getKeyupRules$1 = constant$1([rule(inSet(SPACE), stopEventForFirefox)]);
	    var MenuType = typical(schema$r, NoState.init, getKeydownRules$1, getKeyupRules$1, function () {
	      return Optional.some(focusIn);
	    });
	
	    var schema$q = [
	      onKeyboardHandler('onSpace'),
	      onKeyboardHandler('onEnter'),
	      onKeyboardHandler('onShiftEnter'),
	      onKeyboardHandler('onLeft'),
	      onKeyboardHandler('onRight'),
	      onKeyboardHandler('onTab'),
	      onKeyboardHandler('onShiftTab'),
	      onKeyboardHandler('onUp'),
	      onKeyboardHandler('onDown'),
	      onKeyboardHandler('onEscape'),
	      defaulted('stopSpaceKeyup', false),
	      option('focusIn')
	    ];
	    var getKeydownRules = function (component, simulatedEvent, specialInfo) {
	      return [
	        rule(inSet(SPACE), specialInfo.onSpace),
	        rule(and([
	          isNotShift,
	          inSet(ENTER)
	        ]), specialInfo.onEnter),
	        rule(and([
	          isShift,
	          inSet(ENTER)
	        ]), specialInfo.onShiftEnter),
	        rule(and([
	          isShift,
	          inSet(TAB)
	        ]), specialInfo.onShiftTab),
	        rule(and([
	          isNotShift,
	          inSet(TAB)
	        ]), specialInfo.onTab),
	        rule(inSet(UP), specialInfo.onUp),
	        rule(inSet(DOWN), specialInfo.onDown),
	        rule(inSet(LEFT), specialInfo.onLeft),
	        rule(inSet(RIGHT), specialInfo.onRight),
	        rule(inSet(SPACE), specialInfo.onSpace),
	        rule(inSet(ESCAPE), specialInfo.onEscape)
	      ];
	    };
	    var getKeyupRules = function (component, simulatedEvent, specialInfo) {
	      return specialInfo.stopSpaceKeyup ? [rule(inSet(SPACE), stopEventForFirefox)] : [];
	    };
	    var SpecialType = typical(schema$q, NoState.init, getKeydownRules, getKeyupRules, function (specialInfo) {
	      return specialInfo.focusIn;
	    });
	
	    var acyclic = AcyclicType.schema();
	    var cyclic = CyclicType.schema();
	    var flow = FlowType.schema();
	    var flatgrid = FlatgridType.schema();
	    var matrix = MatrixType.schema();
	    var execution = ExecutionType.schema();
	    var menu = MenuType.schema();
	    var special = SpecialType.schema();
	
	    var KeyboardBranches = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        acyclic: acyclic,
	        cyclic: cyclic,
	        flow: flow,
	        flatgrid: flatgrid,
	        matrix: matrix,
	        execution: execution,
	        menu: menu,
	        special: special
	    });
	
	    var isFlatgridState = function (keyState) {
	      return hasNonNullableKey(keyState, 'setGridSize');
	    };
	    var Keying = createModes({
	      branchKey: 'mode',
	      branches: KeyboardBranches,
	      name: 'keying',
	      active: {
	        events: function (keyingConfig, keyingState) {
	          var handler = keyingConfig.handler;
	          return handler.toEvents(keyingConfig, keyingState);
	        }
	      },
	      apis: {
	        focusIn: function (component, keyConfig, keyState) {
	          keyConfig.sendFocusIn(keyConfig).fold(function () {
	            component.getSystem().triggerFocus(component.element, component.element);
	          }, function (sendFocusIn) {
	            sendFocusIn(component, keyConfig, keyState);
	          });
	        },
	        setGridSize: function (component, keyConfig, keyState, numRows, numColumns) {
	          if (!isFlatgridState(keyState)) {
	            console.error('Layout does not support setGridSize');
	          } else {
	            keyState.setGridSize(numRows, numColumns);
	          }
	        }
	      },
	      state: KeyingState
	    });
	
	    var set$2 = function (component, replaceConfig, replaceState, data) {
	      preserve$1(function () {
	        var newChildren = map$2(data, component.getSystem().build);
	        replaceChildren(component, newChildren);
	      }, component.element);
	    };
	    var insert = function (component, replaceConfig, insertion, childSpec) {
	      var child = component.getSystem().build(childSpec);
	      attachWith(component, child, insertion);
	    };
	    var append = function (component, replaceConfig, replaceState, appendee) {
	      insert(component, replaceConfig, append$2, appendee);
	    };
	    var prepend = function (component, replaceConfig, replaceState, prependee) {
	      insert(component, replaceConfig, prepend$1, prependee);
	    };
	    var remove = function (component, replaceConfig, replaceState, removee) {
	      var children = contents(component);
	      var foundChild = find$5(children, function (child) {
	        return eq(removee.element, child.element);
	      });
	      foundChild.each(detach);
	    };
	    var contents = function (component, _replaceConfig) {
	      return component.components();
	    };
	    var replaceAt = function (component, replaceConfig, replaceState, replaceeIndex, replacer) {
	      var children = contents(component);
	      return Optional.from(children[replaceeIndex]).map(function (replacee) {
	        remove(component, replaceConfig, replaceState, replacee);
	        replacer.each(function (r) {
	          insert(component, replaceConfig, function (p, c) {
	            appendAt(p, c, replaceeIndex);
	          }, r);
	        });
	        return replacee;
	      });
	    };
	    var replaceBy = function (component, replaceConfig, replaceState, replaceePred, replacer) {
	      var children = contents(component);
	      return findIndex$1(children, replaceePred).bind(function (replaceeIndex) {
	        return replaceAt(component, replaceConfig, replaceState, replaceeIndex, replacer);
	      });
	    };
	
	    var ReplaceApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        append: append,
	        prepend: prepend,
	        remove: remove,
	        replaceAt: replaceAt,
	        replaceBy: replaceBy,
	        set: set$2,
	        contents: contents
	    });
	
	    var Replacing = create$8({
	      fields: [],
	      name: 'replacing',
	      apis: ReplaceApis
	    });
	
	    var events$d = function (name, eventHandlers) {
	      var events = derive$2(eventHandlers);
	      return create$8({
	        fields: [required$1('enabled')],
	        name: name,
	        active: { events: constant$1(events) }
	      });
	    };
	    var config = function (name, eventHandlers) {
	      var me = events$d(name, eventHandlers);
	      return {
	        key: name,
	        value: {
	          config: {},
	          me: me,
	          configAsRaw: constant$1({}),
	          initialConfig: {},
	          state: NoState
	        }
	      };
	    };
	
	    var focus$2 = function (component, focusConfig) {
	      if (!focusConfig.ignore) {
	        focus$3(component.element);
	        focusConfig.onFocus(component);
	      }
	    };
	    var blur = function (component, focusConfig) {
	      if (!focusConfig.ignore) {
	        blur$1(component.element);
	      }
	    };
	    var isFocused = function (component) {
	      return hasFocus(component.element);
	    };
	
	    var FocusApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        focus: focus$2,
	        blur: blur,
	        isFocused: isFocused
	    });
	
	    var exhibit$4 = function (base, focusConfig) {
	      var mod = focusConfig.ignore ? {} : { attributes: { tabindex: '-1' } };
	      return nu$7(mod);
	    };
	    var events$c = function (focusConfig) {
	      return derive$2([run$1(focus$4(), function (component, simulatedEvent) {
	          focus$2(component, focusConfig);
	          simulatedEvent.stop();
	        })].concat(focusConfig.stopMousedown ? [run$1(mousedown(), function (_, simulatedEvent) {
	          simulatedEvent.event.prevent();
	        })] : []));
	    };
	
	    var ActiveFocus = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$4,
	        events: events$c
	    });
	
	    var FocusSchema = [
	      onHandler('onFocus'),
	      defaulted('stopMousedown', false),
	      defaulted('ignore', false)
	    ];
	
	    var Focusing = create$8({
	      fields: FocusSchema,
	      name: 'focusing',
	      active: ActiveFocus,
	      apis: FocusApis
	    });
	
	    var SetupBehaviourCellState = function (initialState) {
	      var init = function () {
	        var cell = Cell(initialState);
	        var get = function () {
	          return cell.get();
	        };
	        var set = function (newState) {
	          return cell.set(newState);
	        };
	        var clear = function () {
	          return cell.set(initialState);
	        };
	        var readState = function () {
	          return cell.get();
	        };
	        return {
	          get: get,
	          set: set,
	          clear: clear,
	          readState: readState
	        };
	      };
	      return { init: init };
	    };
	
	    var updateAriaState = function (component, toggleConfig, toggleState) {
	      var ariaInfo = toggleConfig.aria;
	      ariaInfo.update(component, ariaInfo, toggleState.get());
	    };
	    var updateClass = function (component, toggleConfig, toggleState) {
	      toggleConfig.toggleClass.each(function (toggleClass) {
	        if (toggleState.get()) {
	          add$2(component.element, toggleClass);
	        } else {
	          remove$2(component.element, toggleClass);
	        }
	      });
	    };
	    var toggle$2 = function (component, toggleConfig, toggleState) {
	      set$1(component, toggleConfig, toggleState, !toggleState.get());
	    };
	    var on = function (component, toggleConfig, toggleState) {
	      toggleState.set(true);
	      updateClass(component, toggleConfig, toggleState);
	      updateAriaState(component, toggleConfig, toggleState);
	    };
	    var off = function (component, toggleConfig, toggleState) {
	      toggleState.set(false);
	      updateClass(component, toggleConfig, toggleState);
	      updateAriaState(component, toggleConfig, toggleState);
	    };
	    var set$1 = function (component, toggleConfig, toggleState, state) {
	      var action = state ? on : off;
	      action(component, toggleConfig, toggleState);
	    };
	    var isOn = function (component, toggleConfig, toggleState) {
	      return toggleState.get();
	    };
	    var onLoad = function (component, toggleConfig, toggleState) {
	      set$1(component, toggleConfig, toggleState, toggleConfig.selected);
	    };
	
	    var ToggleApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        onLoad: onLoad,
	        toggle: toggle$2,
	        isOn: isOn,
	        on: on,
	        off: off,
	        set: set$1
	    });
	
	    var exhibit$3 = function () {
	      return nu$7({});
	    };
	    var events$b = function (toggleConfig, toggleState) {
	      var execute = executeEvent(toggleConfig, toggleState, toggle$2);
	      var load = loadEvent(toggleConfig, toggleState, onLoad);
	      return derive$2(flatten([
	        toggleConfig.toggleOnExecute ? [execute] : [],
	        [load]
	      ]));
	    };
	
	    var ActiveToggle = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$3,
	        events: events$b
	    });
	
	    var updatePressed = function (component, ariaInfo, status) {
	      set$8(component.element, 'aria-pressed', status);
	      if (ariaInfo.syncWithExpanded) {
	        updateExpanded(component, ariaInfo, status);
	      }
	    };
	    var updateSelected = function (component, ariaInfo, status) {
	      set$8(component.element, 'aria-selected', status);
	    };
	    var updateChecked = function (component, ariaInfo, status) {
	      set$8(component.element, 'aria-checked', status);
	    };
	    var updateExpanded = function (component, ariaInfo, status) {
	      set$8(component.element, 'aria-expanded', status);
	    };
	
	    var ToggleSchema = [
	      defaulted('selected', false),
	      option('toggleClass'),
	      defaulted('toggleOnExecute', true),
	      defaultedOf('aria', { mode: 'none' }, choose$1('mode', {
	        pressed: [
	          defaulted('syncWithExpanded', false),
	          output$1('update', updatePressed)
	        ],
	        checked: [output$1('update', updateChecked)],
	        expanded: [output$1('update', updateExpanded)],
	        selected: [output$1('update', updateSelected)],
	        none: [output$1('update', noop)]
	      }))
	    ];
	
	    var Toggling = create$8({
	      fields: ToggleSchema,
	      name: 'toggling',
	      active: ActiveToggle,
	      apis: ToggleApis,
	      state: SetupBehaviourCellState(false)
	    });
	
	    var pointerEvents = function () {
	      var onClick = function (component, simulatedEvent) {
	        simulatedEvent.stop();
	        emitExecute(component);
	      };
	      return [
	        run$1(click(), onClick),
	        run$1(tap(), onClick),
	        cutter(touchstart()),
	        cutter(mousedown())
	      ];
	    };
	    var events$a = function (optAction) {
	      var executeHandler = function (action) {
	        return runOnExecute$1(function (component, simulatedEvent) {
	          action(component);
	          simulatedEvent.stop();
	        });
	      };
	      return derive$2(flatten([
	        optAction.map(executeHandler).toArray(),
	        pointerEvents()
	      ]));
	    };
	
	    var hoverEvent = 'alloy.item-hover';
	    var focusEvent = 'alloy.item-focus';
	    var onHover = function (item) {
	      if (search(item.element).isNone() || Focusing.isFocused(item)) {
	        if (!Focusing.isFocused(item)) {
	          Focusing.focus(item);
	        }
	        emitWith(item, hoverEvent, { item: item });
	      }
	    };
	    var onFocus$1 = function (item) {
	      emitWith(item, focusEvent, { item: item });
	    };
	    var hover = constant$1(hoverEvent);
	    var focus$1 = constant$1(focusEvent);
	
	    var builder$2 = function (detail) {
	      return {
	        dom: detail.dom,
	        domModification: __assign(__assign({}, detail.domModification), { attributes: __assign(__assign(__assign({ 'role': detail.toggling.isSome() ? 'menuitemcheckbox' : 'menuitem' }, detail.domModification.attributes), { 'aria-haspopup': detail.hasSubmenu }), detail.hasSubmenu ? { 'aria-expanded': false } : {}) }),
	        behaviours: SketchBehaviours.augment(detail.itemBehaviours, [
	          detail.toggling.fold(Toggling.revoke, function (tConfig) {
	            return Toggling.config(__assign({ aria: { mode: 'checked' } }, tConfig));
	          }),
	          Focusing.config({
	            ignore: detail.ignoreFocus,
	            stopMousedown: detail.ignoreFocus,
	            onFocus: function (component) {
	              onFocus$1(component);
	            }
	          }),
	          Keying.config({ mode: 'execution' }),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: detail.data
	            }
	          }),
	          config('item-type-events', __spreadArray(__spreadArray([], pointerEvents(), true), [
	            run$1(mouseover(), onHover),
	            run$1(focusItem(), Focusing.focus)
	          ], false))
	        ]),
	        components: detail.components,
	        eventOrder: detail.eventOrder
	      };
	    };
	    var schema$p = [
	      required$1('data'),
	      required$1('components'),
	      required$1('dom'),
	      defaulted('hasSubmenu', false),
	      option('toggling'),
	      SketchBehaviours.field('itemBehaviours', [
	        Toggling,
	        Focusing,
	        Keying,
	        Representing
	      ]),
	      defaulted('ignoreFocus', false),
	      defaulted('domModification', {}),
	      output$1('builder', builder$2),
	      defaulted('eventOrder', {})
	    ];
	
	    var builder$1 = function (detail) {
	      return {
	        dom: detail.dom,
	        components: detail.components,
	        events: derive$2([stopper(focusItem())])
	      };
	    };
	    var schema$o = [
	      required$1('dom'),
	      required$1('components'),
	      output$1('builder', builder$1)
	    ];
	
	    var owner$2 = constant$1('item-widget');
	    var parts$h = constant$1([required({
	        name: 'widget',
	        overrides: function (detail) {
	          return {
	            behaviours: derive$1([Representing.config({
	                store: {
	                  mode: 'manual',
	                  getValue: function (_component) {
	                    return detail.data;
	                  },
	                  setValue: noop
	                }
	              })])
	          };
	        }
	      })]);
	
	    var builder = function (detail) {
	      var subs = substitutes(owner$2(), detail, parts$h());
	      var components = components$1(owner$2(), detail, subs.internals());
	      var focusWidget = function (component) {
	        return getPart(component, detail, 'widget').map(function (widget) {
	          Keying.focusIn(widget);
	          return widget;
	        });
	      };
	      var onHorizontalArrow = function (component, simulatedEvent) {
	        return inside(simulatedEvent.event.target) ? Optional.none() : function () {
	          if (detail.autofocus) {
	            simulatedEvent.setSource(component.element);
	            return Optional.none();
	          } else {
	            return Optional.none();
	          }
	        }();
	      };
	      return {
	        dom: detail.dom,
	        components: components,
	        domModification: detail.domModification,
	        events: derive$2([
	          runOnExecute$1(function (component, simulatedEvent) {
	            focusWidget(component).each(function (_widget) {
	              simulatedEvent.stop();
	            });
	          }),
	          run$1(mouseover(), onHover),
	          run$1(focusItem(), function (component, _simulatedEvent) {
	            if (detail.autofocus) {
	              focusWidget(component);
	            } else {
	              Focusing.focus(component);
	            }
	          })
	        ]),
	        behaviours: SketchBehaviours.augment(detail.widgetBehaviours, [
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: detail.data
	            }
	          }),
	          Focusing.config({
	            ignore: detail.ignoreFocus,
	            onFocus: function (component) {
	              onFocus$1(component);
	            }
	          }),
	          Keying.config({
	            mode: 'special',
	            focusIn: detail.autofocus ? function (component) {
	              focusWidget(component);
	            } : revoke(),
	            onLeft: onHorizontalArrow,
	            onRight: onHorizontalArrow,
	            onEscape: function (component, simulatedEvent) {
	              if (!Focusing.isFocused(component) && !detail.autofocus) {
	                Focusing.focus(component);
	                return Optional.some(true);
	              } else if (detail.autofocus) {
	                simulatedEvent.setSource(component.element);
	                return Optional.none();
	              } else {
	                return Optional.none();
	              }
	            }
	          })
	        ])
	      };
	    };
	    var schema$n = [
	      required$1('uid'),
	      required$1('data'),
	      required$1('components'),
	      required$1('dom'),
	      defaulted('autofocus', false),
	      defaulted('ignoreFocus', false),
	      SketchBehaviours.field('widgetBehaviours', [
	        Representing,
	        Focusing,
	        Keying
	      ]),
	      defaulted('domModification', {}),
	      defaultUidsSchema(parts$h()),
	      output$1('builder', builder)
	    ];
	
	    var itemSchema$2 = choose$1('type', {
	      widget: schema$n,
	      item: schema$p,
	      separator: schema$o
	    });
	    var configureGrid = function (detail, movementInfo) {
	      return {
	        mode: 'flatgrid',
	        selector: '.' + detail.markers.item,
	        initSize: {
	          numColumns: movementInfo.initSize.numColumns,
	          numRows: movementInfo.initSize.numRows
	        },
	        focusManager: detail.focusManager
	      };
	    };
	    var configureMatrix = function (detail, movementInfo) {
	      return {
	        mode: 'matrix',
	        selectors: {
	          row: movementInfo.rowSelector,
	          cell: '.' + detail.markers.item
	        },
	        focusManager: detail.focusManager
	      };
	    };
	    var configureMenu = function (detail, movementInfo) {
	      return {
	        mode: 'menu',
	        selector: '.' + detail.markers.item,
	        moveOnTab: movementInfo.moveOnTab,
	        focusManager: detail.focusManager
	      };
	    };
	    var parts$g = constant$1([group({
	        factory: {
	          sketch: function (spec) {
	            var itemInfo = asRawOrDie$1('menu.spec item', itemSchema$2, spec);
	            return itemInfo.builder(itemInfo);
	          }
	        },
	        name: 'items',
	        unit: 'item',
	        defaults: function (detail, u) {
	          return has$2(u, 'uid') ? u : __assign(__assign({}, u), { uid: generate$5('item') });
	        },
	        overrides: function (detail, u) {
	          return {
	            type: u.type,
	            ignoreFocus: detail.fakeFocus,
	            domModification: { classes: [detail.markers.item] }
	          };
	        }
	      })]);
	    var schema$m = constant$1([
	      required$1('value'),
	      required$1('items'),
	      required$1('dom'),
	      required$1('components'),
	      defaulted('eventOrder', {}),
	      field('menuBehaviours', [
	        Highlighting,
	        Representing,
	        Composing,
	        Keying
	      ]),
	      defaultedOf('movement', {
	        mode: 'menu',
	        moveOnTab: true
	      }, choose$1('mode', {
	        grid: [
	          initSize(),
	          output$1('config', configureGrid)
	        ],
	        matrix: [
	          output$1('config', configureMatrix),
	          required$1('rowSelector')
	        ],
	        menu: [
	          defaulted('moveOnTab', true),
	          output$1('config', configureMenu)
	        ]
	      })),
	      itemMarkers(),
	      defaulted('fakeFocus', false),
	      defaulted('focusManager', dom$2()),
	      onHandler('onHighlight')
	    ]);
	
	    var focus = constant$1('alloy.menu-focus');
	
	    var make$7 = function (detail, components, _spec, _externals) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        markers: detail.markers,
	        behaviours: augment(detail.menuBehaviours, [
	          Highlighting.config({
	            highlightClass: detail.markers.selectedItem,
	            itemClass: detail.markers.item,
	            onHighlight: detail.onHighlight
	          }),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: detail.value
	            }
	          }),
	          Composing.config({ find: Optional.some }),
	          Keying.config(detail.movement.config(detail, detail.movement))
	        ]),
	        events: derive$2([
	          run$1(focus$1(), function (menu, simulatedEvent) {
	            var event = simulatedEvent.event;
	            menu.getSystem().getByDom(event.target).each(function (item) {
	              Highlighting.highlight(menu, item);
	              simulatedEvent.stop();
	              emitWith(menu, focus(), {
	                menu: menu,
	                item: item
	              });
	            });
	          }),
	          run$1(hover(), function (menu, simulatedEvent) {
	            var item = simulatedEvent.event.item;
	            Highlighting.highlight(menu, item);
	          })
	        ]),
	        components: components,
	        eventOrder: detail.eventOrder,
	        domModification: { attributes: { role: 'menu' } }
	      };
	    };
	
	    var Menu = composite({
	      name: 'Menu',
	      configFields: schema$m(),
	      partFields: parts$g(),
	      factory: make$7
	    });
	
	    var transpose$1 = function (obj) {
	      return tupleMap(obj, function (v, k) {
	        return {
	          k: v,
	          v: k
	        };
	      });
	    };
	    var trace = function (items, byItem, byMenu, finish) {
	      return get$e(byMenu, finish).bind(function (triggerItem) {
	        return get$e(items, triggerItem).bind(function (triggerMenu) {
	          var rest = trace(items, byItem, byMenu, triggerMenu);
	          return Optional.some([triggerMenu].concat(rest));
	        });
	      }).getOr([]);
	    };
	    var generate$2 = function (menus, expansions) {
	      var items = {};
	      each(menus, function (menuItems, menu) {
	        each$1(menuItems, function (item) {
	          items[item] = menu;
	        });
	      });
	      var byItem = expansions;
	      var byMenu = transpose$1(expansions);
	      var menuPaths = map$1(byMenu, function (_triggerItem, submenu) {
	        return [submenu].concat(trace(items, byItem, byMenu, submenu));
	      });
	      return map$1(items, function (menu) {
	        return get$e(menuPaths, menu).getOr([menu]);
	      });
	    };
	
	    var init$c = function () {
	      var expansions = Cell({});
	      var menus = Cell({});
	      var paths = Cell({});
	      var primary = value$1();
	      var directory = Cell({});
	      var clear = function () {
	        expansions.set({});
	        menus.set({});
	        paths.set({});
	        primary.clear();
	      };
	      var isClear = function () {
	        return primary.get().isNone();
	      };
	      var setMenuBuilt = function (menuName, built) {
	        var _a;
	        menus.set(__assign(__assign({}, menus.get()), (_a = {}, _a[menuName] = {
	          type: 'prepared',
	          menu: built
	        }, _a)));
	      };
	      var setContents = function (sPrimary, sMenus, sExpansions, dir) {
	        primary.set(sPrimary);
	        expansions.set(sExpansions);
	        menus.set(sMenus);
	        directory.set(dir);
	        var sPaths = generate$2(dir, sExpansions);
	        paths.set(sPaths);
	      };
	      var getTriggeringItem = function (menuValue) {
	        return find$4(expansions.get(), function (v, _k) {
	          return v === menuValue;
	        });
	      };
	      var getTriggerData = function (menuValue, getItemByValue, path) {
	        return getPreparedMenu(menuValue).bind(function (menu) {
	          return getTriggeringItem(menuValue).bind(function (triggeringItemValue) {
	            return getItemByValue(triggeringItemValue).map(function (triggeredItem) {
	              return {
	                triggeredMenu: menu,
	                triggeringItem: triggeredItem,
	                triggeringPath: path
	              };
	            });
	          });
	        });
	      };
	      var getTriggeringPath = function (itemValue, getItemByValue) {
	        var extraPath = filter$2(lookupItem(itemValue).toArray(), function (menuValue) {
	          return getPreparedMenu(menuValue).isSome();
	        });
	        return get$e(paths.get(), itemValue).bind(function (path) {
	          var revPath = reverse(extraPath.concat(path));
	          var triggers = bind$3(revPath, function (menuValue, menuIndex) {
	            return getTriggerData(menuValue, getItemByValue, revPath.slice(0, menuIndex + 1)).fold(function () {
	              return is$1(primary.get(), menuValue) ? [] : [Optional.none()];
	            }, function (data) {
	              return [Optional.some(data)];
	            });
	          });
	          return sequence(triggers);
	        });
	      };
	      var expand = function (itemValue) {
	        return get$e(expansions.get(), itemValue).map(function (menu) {
	          var current = get$e(paths.get(), itemValue).getOr([]);
	          return [menu].concat(current);
	        });
	      };
	      var collapse = function (itemValue) {
	        return get$e(paths.get(), itemValue).bind(function (path) {
	          return path.length > 1 ? Optional.some(path.slice(1)) : Optional.none();
	        });
	      };
	      var refresh = function (itemValue) {
	        return get$e(paths.get(), itemValue);
	      };
	      var getPreparedMenu = function (menuValue) {
	        return lookupMenu(menuValue).bind(extractPreparedMenu);
	      };
	      var lookupMenu = function (menuValue) {
	        return get$e(menus.get(), menuValue);
	      };
	      var lookupItem = function (itemValue) {
	        return get$e(expansions.get(), itemValue);
	      };
	      var otherMenus = function (path) {
	        var menuValues = directory.get();
	        return difference(keys(menuValues), path);
	      };
	      var getPrimary = function () {
	        return primary.get().bind(getPreparedMenu);
	      };
	      var getMenus = function () {
	        return menus.get();
	      };
	      return {
	        setMenuBuilt: setMenuBuilt,
	        setContents: setContents,
	        expand: expand,
	        refresh: refresh,
	        collapse: collapse,
	        lookupMenu: lookupMenu,
	        lookupItem: lookupItem,
	        otherMenus: otherMenus,
	        getPrimary: getPrimary,
	        getMenus: getMenus,
	        clear: clear,
	        isClear: isClear,
	        getTriggeringPath: getTriggeringPath
	      };
	    };
	    var extractPreparedMenu = function (prep) {
	      return prep.type === 'prepared' ? Optional.some(prep.menu) : Optional.none();
	    };
	    var LayeredState = {
	      init: init$c,
	      extractPreparedMenu: extractPreparedMenu
	    };
	
	    var make$6 = function (detail, _rawUiSpec) {
	      var submenuParentItems = value$1();
	      var buildMenus = function (container, primaryName, menus) {
	        return map$1(menus, function (spec, name) {
	          var makeSketch = function () {
	            return Menu.sketch(__assign(__assign({}, spec), {
	              value: name,
	              markers: detail.markers,
	              fakeFocus: detail.fakeFocus,
	              onHighlight: detail.onHighlight,
	              focusManager: detail.fakeFocus ? highlights() : dom$2()
	            }));
	          };
	          return name === primaryName ? {
	            type: 'prepared',
	            menu: container.getSystem().build(makeSketch())
	          } : {
	            type: 'notbuilt',
	            nbMenu: makeSketch
	          };
	        });
	      };
	      var layeredState = LayeredState.init();
	      var setup = function (container) {
	        var componentMap = buildMenus(container, detail.data.primary, detail.data.menus);
	        var directory = toDirectory();
	        layeredState.setContents(detail.data.primary, componentMap, detail.data.expansions, directory);
	        return layeredState.getPrimary();
	      };
	      var getItemValue = function (item) {
	        return Representing.getValue(item).value;
	      };
	      var getItemByValue = function (_container, menus, itemValue) {
	        return findMap(menus, function (menu) {
	          if (!menu.getSystem().isConnected()) {
	            return Optional.none();
	          }
	          var candidates = Highlighting.getCandidates(menu);
	          return find$5(candidates, function (c) {
	            return getItemValue(c) === itemValue;
	          });
	        });
	      };
	      var toDirectory = function (_container) {
	        return map$1(detail.data.menus, function (data, _menuName) {
	          return bind$3(data.items, function (item) {
	            return item.type === 'separator' ? [] : [item.data.value];
	          });
	        });
	      };
	      var setActiveMenu = function (container, menu) {
	        Highlighting.highlight(container, menu);
	        Highlighting.getHighlighted(menu).orThunk(function () {
	          return Highlighting.getFirst(menu);
	        }).each(function (item) {
	          dispatch(container, item.element, focusItem());
	        });
	      };
	      var getMenus = function (state, menuValues) {
	        return cat(map$2(menuValues, function (mv) {
	          return state.lookupMenu(mv).bind(function (prep) {
	            return prep.type === 'prepared' ? Optional.some(prep.menu) : Optional.none();
	          });
	        }));
	      };
	      var closeOthers = function (container, state, path) {
	        var others = getMenus(state, state.otherMenus(path));
	        each$1(others, function (o) {
	          remove$1(o.element, [detail.markers.backgroundMenu]);
	          if (!detail.stayInDom) {
	            Replacing.remove(container, o);
	          }
	        });
	      };
	      var getSubmenuParents = function (container) {
	        return submenuParentItems.get().getOrThunk(function () {
	          var r = {};
	          var items = descendants(container.element, '.' + detail.markers.item);
	          var parentItems = filter$2(items, function (i) {
	            return get$d(i, 'aria-haspopup') === 'true';
	          });
	          each$1(parentItems, function (i) {
	            container.getSystem().getByDom(i).each(function (itemComp) {
	              var key = getItemValue(itemComp);
	              r[key] = itemComp;
	            });
	          });
	          submenuParentItems.set(r);
	          return r;
	        });
	      };
	      var updateAriaExpansions = function (container, path) {
	        var parentItems = getSubmenuParents(container);
	        each(parentItems, function (v, k) {
	          var expanded = contains$2(path, k);
	          set$8(v.element, 'aria-expanded', expanded);
	        });
	      };
	      var updateMenuPath = function (container, state, path) {
	        return Optional.from(path[0]).bind(function (latestMenuName) {
	          return state.lookupMenu(latestMenuName).bind(function (menuPrep) {
	            if (menuPrep.type === 'notbuilt') {
	              return Optional.none();
	            } else {
	              var activeMenu = menuPrep.menu;
	              var rest = getMenus(state, path.slice(1));
	              each$1(rest, function (r) {
	                add$2(r.element, detail.markers.backgroundMenu);
	              });
	              if (!inBody(activeMenu.element)) {
	                Replacing.append(container, premade(activeMenu));
	              }
	              remove$1(activeMenu.element, [detail.markers.backgroundMenu]);
	              setActiveMenu(container, activeMenu);
	              closeOthers(container, state, path);
	              return Optional.some(activeMenu);
	            }
	          });
	        });
	      };
	      var ExpandHighlightDecision;
	      (function (ExpandHighlightDecision) {
	        ExpandHighlightDecision[ExpandHighlightDecision['HighlightSubmenu'] = 0] = 'HighlightSubmenu';
	        ExpandHighlightDecision[ExpandHighlightDecision['HighlightParent'] = 1] = 'HighlightParent';
	      }(ExpandHighlightDecision || (ExpandHighlightDecision = {})));
	      var buildIfRequired = function (container, menuName, menuPrep) {
	        if (menuPrep.type === 'notbuilt') {
	          var menu = container.getSystem().build(menuPrep.nbMenu());
	          layeredState.setMenuBuilt(menuName, menu);
	          return menu;
	        } else {
	          return menuPrep.menu;
	        }
	      };
	      var expandRight = function (container, item, decision) {
	        if (decision === void 0) {
	          decision = ExpandHighlightDecision.HighlightSubmenu;
	        }
	        if (item.hasConfigured(Disabling) && Disabling.isDisabled(item)) {
	          return Optional.some(item);
	        } else {
	          var value = getItemValue(item);
	          return layeredState.expand(value).bind(function (path) {
	            updateAriaExpansions(container, path);
	            return Optional.from(path[0]).bind(function (menuName) {
	              return layeredState.lookupMenu(menuName).bind(function (activeMenuPrep) {
	                var activeMenu = buildIfRequired(container, menuName, activeMenuPrep);
	                if (!inBody(activeMenu.element)) {
	                  Replacing.append(container, premade(activeMenu));
	                }
	                detail.onOpenSubmenu(container, item, activeMenu, reverse(path));
	                if (decision === ExpandHighlightDecision.HighlightSubmenu) {
	                  Highlighting.highlightFirst(activeMenu);
	                  return updateMenuPath(container, layeredState, path);
	                } else {
	                  Highlighting.dehighlightAll(activeMenu);
	                  return Optional.some(item);
	                }
	              });
	            });
	          });
	        }
	      };
	      var collapseLeft = function (container, item) {
	        var value = getItemValue(item);
	        return layeredState.collapse(value).bind(function (path) {
	          updateAriaExpansions(container, path);
	          return updateMenuPath(container, layeredState, path).map(function (activeMenu) {
	            detail.onCollapseMenu(container, item, activeMenu);
	            return activeMenu;
	          });
	        });
	      };
	      var updateView = function (container, item) {
	        var value = getItemValue(item);
	        return layeredState.refresh(value).bind(function (path) {
	          updateAriaExpansions(container, path);
	          return updateMenuPath(container, layeredState, path);
	        });
	      };
	      var onRight = function (container, item) {
	        return inside(item.element) ? Optional.none() : expandRight(container, item, ExpandHighlightDecision.HighlightSubmenu);
	      };
	      var onLeft = function (container, item) {
	        return inside(item.element) ? Optional.none() : collapseLeft(container, item);
	      };
	      var onEscape = function (container, item) {
	        return collapseLeft(container, item).orThunk(function () {
	          return detail.onEscape(container, item).map(function () {
	            return container;
	          });
	        });
	      };
	      var keyOnItem = function (f) {
	        return function (container, simulatedEvent) {
	          return closest$1(simulatedEvent.getSource(), '.' + detail.markers.item).bind(function (target) {
	            return container.getSystem().getByDom(target).toOptional().bind(function (item) {
	              return f(container, item).map(always);
	            });
	          });
	        };
	      };
	      var events = derive$2([
	        run$1(focus(), function (sandbox, simulatedEvent) {
	          var item = simulatedEvent.event.item;
	          layeredState.lookupItem(getItemValue(item)).each(function () {
	            var menu = simulatedEvent.event.menu;
	            Highlighting.highlight(sandbox, menu);
	            var value = getItemValue(simulatedEvent.event.item);
	            layeredState.refresh(value).each(function (path) {
	              return closeOthers(sandbox, layeredState, path);
	            });
	          });
	        }),
	        runOnExecute$1(function (component, simulatedEvent) {
	          var target = simulatedEvent.event.target;
	          component.getSystem().getByDom(target).each(function (item) {
	            var itemValue = getItemValue(item);
	            if (itemValue.indexOf('collapse-item') === 0) {
	              collapseLeft(component, item);
	            }
	            expandRight(component, item, ExpandHighlightDecision.HighlightSubmenu).fold(function () {
	              detail.onExecute(component, item);
	            }, noop);
	          });
	        }),
	        runOnAttached(function (container, _simulatedEvent) {
	          setup(container).each(function (primary) {
	            Replacing.append(container, premade(primary));
	            detail.onOpenMenu(container, primary);
	            if (detail.highlightImmediately) {
	              setActiveMenu(container, primary);
	            }
	          });
	        })
	      ].concat(detail.navigateOnHover ? [run$1(hover(), function (sandbox, simulatedEvent) {
	          var item = simulatedEvent.event.item;
	          updateView(sandbox, item);
	          expandRight(sandbox, item, ExpandHighlightDecision.HighlightParent);
	          detail.onHover(sandbox, item);
	        })] : []));
	      var getActiveItem = function (container) {
	        return Highlighting.getHighlighted(container).bind(Highlighting.getHighlighted);
	      };
	      var collapseMenuApi = function (container) {
	        getActiveItem(container).each(function (currentItem) {
	          collapseLeft(container, currentItem);
	        });
	      };
	      var highlightPrimary = function (container) {
	        layeredState.getPrimary().each(function (primary) {
	          setActiveMenu(container, primary);
	        });
	      };
	      var extractMenuFromContainer = function (container) {
	        return Optional.from(container.components()[0]).filter(function (comp) {
	          return get$d(comp.element, 'role') === 'menu';
	        });
	      };
	      var repositionMenus = function (container) {
	        var maybeActivePrimary = layeredState.getPrimary().bind(function (primary) {
	          return getActiveItem(container).bind(function (currentItem) {
	            var itemValue = getItemValue(currentItem);
	            var allMenus = values(layeredState.getMenus());
	            var preparedMenus = cat(map$2(allMenus, LayeredState.extractPreparedMenu));
	            return layeredState.getTriggeringPath(itemValue, function (v) {
	              return getItemByValue(container, preparedMenus, v);
	            });
	          }).map(function (triggeringPath) {
	            return {
	              primary: primary,
	              triggeringPath: triggeringPath
	            };
	          });
	        });
	        maybeActivePrimary.fold(function () {
	          extractMenuFromContainer(container).each(function (primaryMenu) {
	            detail.onRepositionMenu(container, primaryMenu, []);
	          });
	        }, function (_a) {
	          var primary = _a.primary, triggeringPath = _a.triggeringPath;
	          detail.onRepositionMenu(container, primary, triggeringPath);
	        });
	      };
	      var apis = {
	        collapseMenu: collapseMenuApi,
	        highlightPrimary: highlightPrimary,
	        repositionMenus: repositionMenus
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        markers: detail.markers,
	        behaviours: augment(detail.tmenuBehaviours, [
	          Keying.config({
	            mode: 'special',
	            onRight: keyOnItem(onRight),
	            onLeft: keyOnItem(onLeft),
	            onEscape: keyOnItem(onEscape),
	            focusIn: function (container, _keyInfo) {
	              layeredState.getPrimary().each(function (primary) {
	                dispatch(container, primary.element, focusItem());
	              });
	            }
	          }),
	          Highlighting.config({
	            highlightClass: detail.markers.selectedMenu,
	            itemClass: detail.markers.menu
	          }),
	          Composing.config({
	            find: function (container) {
	              return Highlighting.getHighlighted(container);
	            }
	          }),
	          Replacing.config({})
	        ]),
	        eventOrder: detail.eventOrder,
	        apis: apis,
	        events: events
	      };
	    };
	    var collapseItem$1 = constant$1('collapse-item');
	
	    var tieredData = function (primary, menus, expansions) {
	      return {
	        primary: primary,
	        menus: menus,
	        expansions: expansions
	      };
	    };
	    var singleData = function (name, menu) {
	      return {
	        primary: name,
	        menus: wrap$1(name, menu),
	        expansions: {}
	      };
	    };
	    var collapseItem = function (text) {
	      return {
	        value: generate$6(collapseItem$1()),
	        meta: { text: text }
	      };
	    };
	    var tieredMenu = single({
	      name: 'TieredMenu',
	      configFields: [
	        onStrictKeyboardHandler('onExecute'),
	        onStrictKeyboardHandler('onEscape'),
	        onStrictHandler('onOpenMenu'),
	        onStrictHandler('onOpenSubmenu'),
	        onHandler('onRepositionMenu'),
	        onHandler('onCollapseMenu'),
	        defaulted('highlightImmediately', true),
	        requiredObjOf('data', [
	          required$1('primary'),
	          required$1('menus'),
	          required$1('expansions')
	        ]),
	        defaulted('fakeFocus', false),
	        onHandler('onHighlight'),
	        onHandler('onHover'),
	        tieredMenuMarkers(),
	        required$1('dom'),
	        defaulted('navigateOnHover', true),
	        defaulted('stayInDom', false),
	        field('tmenuBehaviours', [
	          Keying,
	          Highlighting,
	          Composing,
	          Replacing
	        ]),
	        defaulted('eventOrder', {})
	      ],
	      apis: {
	        collapseMenu: function (apis, tmenu) {
	          apis.collapseMenu(tmenu);
	        },
	        highlightPrimary: function (apis, tmenu) {
	          apis.highlightPrimary(tmenu);
	        },
	        repositionMenus: function (apis, tmenu) {
	          apis.repositionMenus(tmenu);
	        }
	      },
	      factory: make$6,
	      extraApis: {
	        tieredData: tieredData,
	        singleData: singleData,
	        collapseItem: collapseItem
	      }
	    });
	
	    var makeMenu = function (detail, menuSandbox, placementSpec, menuSpec, getBounds) {
	      var lazySink = function () {
	        return detail.lazySink(menuSandbox);
	      };
	      var layouts = menuSpec.type === 'horizontal' ? {
	        layouts: {
	          onLtr: function () {
	            return belowOrAbove();
	          },
	          onRtl: function () {
	            return belowOrAboveRtl();
	          }
	        }
	      } : {};
	      var isFirstTierSubmenu = function (triggeringPaths) {
	        return triggeringPaths.length === 2;
	      };
	      var getSubmenuLayouts = function (triggeringPaths) {
	        return isFirstTierSubmenu(triggeringPaths) ? layouts : {};
	      };
	      return tieredMenu.sketch({
	        dom: { tag: 'div' },
	        data: menuSpec.data,
	        markers: menuSpec.menu.markers,
	        highlightImmediately: menuSpec.menu.highlightImmediately,
	        onEscape: function () {
	          Sandboxing.close(menuSandbox);
	          detail.onEscape.map(function (handler) {
	            return handler(menuSandbox);
	          });
	          return Optional.some(true);
	        },
	        onExecute: function () {
	          return Optional.some(true);
	        },
	        onOpenMenu: function (tmenu, menu) {
	          Positioning.positionWithinBounds(lazySink().getOrDie(), menu, placementSpec, getBounds());
	        },
	        onOpenSubmenu: function (tmenu, item, submenu, triggeringPaths) {
	          var sink = lazySink().getOrDie();
	          Positioning.position(sink, submenu, {
	            anchor: __assign({
	              type: 'submenu',
	              item: item
	            }, getSubmenuLayouts(triggeringPaths))
	          });
	        },
	        onRepositionMenu: function (tmenu, primaryMenu, submenuTriggers) {
	          var sink = lazySink().getOrDie();
	          Positioning.positionWithinBounds(sink, primaryMenu, placementSpec, getBounds());
	          each$1(submenuTriggers, function (st) {
	            var submenuLayouts = getSubmenuLayouts(st.triggeringPath);
	            Positioning.position(sink, st.triggeredMenu, {
	              anchor: __assign({
	                type: 'submenu',
	                item: st.triggeringItem
	              }, submenuLayouts)
	            });
	          });
	        }
	      });
	    };
	    var factory$m = function (detail, spec) {
	      var isPartOfRelated = function (sandbox, queryElem) {
	        var related = detail.getRelated(sandbox);
	        return related.exists(function (rel) {
	          return isPartOf$1(rel, queryElem);
	        });
	      };
	      var setContent = function (sandbox, thing) {
	        Sandboxing.setContent(sandbox, thing);
	      };
	      var showAt = function (sandbox, thing, placementSpec) {
	        showWithin(sandbox, thing, placementSpec, Optional.none());
	      };
	      var showWithin = function (sandbox, thing, placementSpec, boxElement) {
	        showWithinBounds(sandbox, thing, placementSpec, function () {
	          return boxElement.map(function (elem) {
	            return box$1(elem);
	          });
	        });
	      };
	      var showWithinBounds = function (sandbox, thing, placementSpec, getBounds) {
	        var sink = detail.lazySink(sandbox).getOrDie();
	        Sandboxing.openWhileCloaked(sandbox, thing, function () {
	          return Positioning.positionWithinBounds(sink, sandbox, placementSpec, getBounds());
	        });
	        Representing.setValue(sandbox, Optional.some({
	          mode: 'position',
	          config: placementSpec,
	          getBounds: getBounds
	        }));
	      };
	      var showMenuAt = function (sandbox, placementSpec, menuSpec) {
	        showMenuWithinBounds(sandbox, placementSpec, menuSpec, Optional.none);
	      };
	      var showMenuWithinBounds = function (sandbox, placementSpec, menuSpec, getBounds) {
	        var menu = makeMenu(detail, sandbox, placementSpec, menuSpec, getBounds);
	        Sandboxing.open(sandbox, menu);
	        Representing.setValue(sandbox, Optional.some({
	          mode: 'menu',
	          menu: menu
	        }));
	      };
	      var hide = function (sandbox) {
	        if (Sandboxing.isOpen(sandbox)) {
	          Representing.setValue(sandbox, Optional.none());
	          Sandboxing.close(sandbox);
	        }
	      };
	      var getContent = function (sandbox) {
	        return Sandboxing.getState(sandbox);
	      };
	      var reposition = function (sandbox) {
	        if (Sandboxing.isOpen(sandbox)) {
	          Representing.getValue(sandbox).each(function (state) {
	            switch (state.mode) {
	            case 'menu':
	              Sandboxing.getState(sandbox).each(tieredMenu.repositionMenus);
	              break;
	            case 'position':
	              var sink = detail.lazySink(sandbox).getOrDie();
	              Positioning.positionWithinBounds(sink, sandbox, state.config, state.getBounds());
	              break;
	            }
	          });
	        }
	      };
	      var apis = {
	        setContent: setContent,
	        showAt: showAt,
	        showWithin: showWithin,
	        showWithinBounds: showWithinBounds,
	        showMenuAt: showMenuAt,
	        showMenuWithinBounds: showMenuWithinBounds,
	        hide: hide,
	        getContent: getContent,
	        reposition: reposition,
	        isOpen: Sandboxing.isOpen
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        behaviours: augment(detail.inlineBehaviours, [
	          Sandboxing.config({
	            isPartOf: function (sandbox, data, queryElem) {
	              return isPartOf$1(data, queryElem) || isPartOfRelated(sandbox, queryElem);
	            },
	            getAttachPoint: function (sandbox) {
	              return detail.lazySink(sandbox).getOrDie();
	            },
	            onOpen: function (sandbox) {
	              detail.onShow(sandbox);
	            },
	            onClose: function (sandbox) {
	              detail.onHide(sandbox);
	            }
	          }),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: Optional.none()
	            }
	          }),
	          Receiving.config({
	            channels: __assign(__assign({}, receivingChannel$1(__assign({ isExtraPart: spec.isExtraPart }, detail.fireDismissalEventInstead.map(function (fe) {
	              return { fireEventInstead: { event: fe.event } };
	            }).getOr({})))), receivingChannel(__assign(__assign({}, detail.fireRepositionEventInstead.map(function (fe) {
	              return { fireEventInstead: { event: fe.event } };
	            }).getOr({})), { doReposition: reposition })))
	          })
	        ]),
	        eventOrder: detail.eventOrder,
	        apis: apis
	      };
	    };
	    var InlineView = single({
	      name: 'InlineView',
	      configFields: [
	        required$1('lazySink'),
	        onHandler('onShow'),
	        onHandler('onHide'),
	        optionFunction('onEscape'),
	        field('inlineBehaviours', [
	          Sandboxing,
	          Representing,
	          Receiving
	        ]),
	        optionObjOf('fireDismissalEventInstead', [defaulted('event', dismissRequested())]),
	        optionObjOf('fireRepositionEventInstead', [defaulted('event', repositionRequested())]),
	        defaulted('getRelated', Optional.none),
	        defaulted('isExtraPart', never),
	        defaulted('eventOrder', Optional.none)
	      ],
	      factory: factory$m,
	      apis: {
	        showAt: function (apis, component, anchor, thing) {
	          apis.showAt(component, anchor, thing);
	        },
	        showWithin: function (apis, component, anchor, thing, boxElement) {
	          apis.showWithin(component, anchor, thing, boxElement);
	        },
	        showWithinBounds: function (apis, component, anchor, thing, bounds) {
	          apis.showWithinBounds(component, anchor, thing, bounds);
	        },
	        showMenuAt: function (apis, component, anchor, menuSpec) {
	          apis.showMenuAt(component, anchor, menuSpec);
	        },
	        showMenuWithinBounds: function (apis, component, anchor, menuSpec, bounds) {
	          apis.showMenuWithinBounds(component, anchor, menuSpec, bounds);
	        },
	        hide: function (apis, component) {
	          apis.hide(component);
	        },
	        isOpen: function (apis, component) {
	          return apis.isOpen(component);
	        },
	        getContent: function (apis, component) {
	          return apis.getContent(component);
	        },
	        setContent: function (apis, component, thing) {
	          apis.setContent(component, thing);
	        },
	        reposition: function (apis, component) {
	          apis.reposition(component);
	        }
	      }
	    });
	
	    var labelPrefix = 'layout-inset';
	    var westEdgeX = function (anchor) {
	      return anchor.x;
	    };
	    var middleX = function (anchor, element) {
	      return anchor.x + anchor.width / 2 - element.width / 2;
	    };
	    var eastEdgeX = function (anchor, element) {
	      return anchor.x + anchor.width - element.width;
	    };
	    var northY = function (anchor) {
	      return anchor.y;
	    };
	    var southY = function (anchor, element) {
	      return anchor.y + anchor.height - element.height;
	    };
	    var centreY = function (anchor, element) {
	      return anchor.y + anchor.height / 2 - element.height / 2;
	    };
	    var southwest = function (anchor, element, bubbles) {
	      return nu$6(eastEdgeX(anchor, element), southY(anchor, element), bubbles.insetSouthwest(), northwest$3(), 'southwest', boundsRestriction(anchor, {
	        right: 0,
	        bottom: 3
	      }), labelPrefix);
	    };
	    var southeast = function (anchor, element, bubbles) {
	      return nu$6(westEdgeX(anchor), southY(anchor, element), bubbles.insetSoutheast(), northeast$3(), 'southeast', boundsRestriction(anchor, {
	        left: 1,
	        bottom: 3
	      }), labelPrefix);
	    };
	    var northwest = function (anchor, element, bubbles) {
	      return nu$6(eastEdgeX(anchor, element), northY(anchor), bubbles.insetNorthwest(), southwest$3(), 'northwest', boundsRestriction(anchor, {
	        right: 0,
	        top: 2
	      }), labelPrefix);
	    };
	    var northeast = function (anchor, element, bubbles) {
	      return nu$6(westEdgeX(anchor), northY(anchor), bubbles.insetNortheast(), southeast$3(), 'northeast', boundsRestriction(anchor, {
	        left: 1,
	        top: 2
	      }), labelPrefix);
	    };
	    var north = function (anchor, element, bubbles) {
	      return nu$6(middleX(anchor, element), northY(anchor), bubbles.insetNorth(), south$3(), 'north', boundsRestriction(anchor, { top: 2 }), labelPrefix);
	    };
	    var south = function (anchor, element, bubbles) {
	      return nu$6(middleX(anchor, element), southY(anchor, element), bubbles.insetSouth(), north$3(), 'south', boundsRestriction(anchor, { bottom: 3 }), labelPrefix);
	    };
	    var east = function (anchor, element, bubbles) {
	      return nu$6(eastEdgeX(anchor, element), centreY(anchor, element), bubbles.insetEast(), west$3(), 'east', boundsRestriction(anchor, { right: 0 }), labelPrefix);
	    };
	    var west = function (anchor, element, bubbles) {
	      return nu$6(westEdgeX(anchor), centreY(anchor, element), bubbles.insetWest(), east$3(), 'west', boundsRestriction(anchor, { left: 1 }), labelPrefix);
	    };
	    var lookupPreserveLayout = function (lastPlacement) {
	      switch (lastPlacement) {
	      case 'north':
	        return north;
	      case 'northeast':
	        return northeast;
	      case 'northwest':
	        return northwest;
	      case 'south':
	        return south;
	      case 'southeast':
	        return southeast;
	      case 'southwest':
	        return southwest;
	      case 'east':
	        return east;
	      case 'west':
	        return west;
	      }
	    };
	    var preserve = function (anchor, element, bubbles, placee, bounds) {
	      var layout = getPlacement(placee).map(lookupPreserveLayout).getOr(north);
	      return layout(anchor, element, bubbles, placee, bounds);
	    };
	    var lookupFlippedLayout = function (lastPlacement) {
	      switch (lastPlacement) {
	      case 'north':
	        return south;
	      case 'northeast':
	        return southeast;
	      case 'northwest':
	        return southwest;
	      case 'south':
	        return north;
	      case 'southeast':
	        return northeast;
	      case 'southwest':
	        return northwest;
	      case 'east':
	        return west;
	      case 'west':
	        return east;
	      }
	    };
	    var flip$2 = function (anchor, element, bubbles, placee, bounds) {
	      var layout = getPlacement(placee).map(lookupFlippedLayout).getOr(north);
	      return layout(anchor, element, bubbles, placee, bounds);
	    };
	
	    var global$f = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var factory$l = function (detail) {
	      var events = events$a(detail.action);
	      var tag = detail.dom.tag;
	      var lookupAttr = function (attr) {
	        return get$e(detail.dom, 'attributes').bind(function (attrs) {
	          return get$e(attrs, attr);
	        });
	      };
	      var getModAttributes = function () {
	        if (tag === 'button') {
	          var type = lookupAttr('type').getOr('button');
	          var roleAttrs = lookupAttr('role').map(function (role) {
	            return { role: role };
	          }).getOr({});
	          return __assign({ type: type }, roleAttrs);
	        } else {
	          var role = lookupAttr('role').getOr('button');
	          return { role: role };
	        }
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: detail.components,
	        events: events,
	        behaviours: SketchBehaviours.augment(detail.buttonBehaviours, [
	          Focusing.config({}),
	          Keying.config({
	            mode: 'execution',
	            useSpace: true,
	            useEnter: true
	          })
	        ]),
	        domModification: { attributes: getModAttributes() },
	        eventOrder: detail.eventOrder
	      };
	    };
	    var Button = single({
	      name: 'Button',
	      factory: factory$l,
	      configFields: [
	        defaulted('uid', undefined),
	        required$1('dom'),
	        defaulted('components', []),
	        SketchBehaviours.field('buttonBehaviours', [
	          Focusing,
	          Keying
	        ]),
	        option('action'),
	        option('role'),
	        defaulted('eventOrder', {})
	      ]
	    });
	
	    var record = function (spec) {
	      var uid = isSketchSpec(spec) && hasNonNullableKey(spec, 'uid') ? spec.uid : generate$5('memento');
	      var get = function (anyInSystem) {
	        return anyInSystem.getSystem().getByUid(uid).getOrDie();
	      };
	      var getOpt = function (anyInSystem) {
	        return anyInSystem.getSystem().getByUid(uid).toOptional();
	      };
	      var asSpec = function () {
	        return __assign(__assign({}, spec), { uid: uid });
	      };
	      return {
	        get: get,
	        getOpt: getOpt,
	        asSpec: asSpec
	      };
	    };
	
	    var global$e = tinymce.util.Tools.resolve('tinymce.util.I18n');
	
	    var rtlTransform = {
	      'indent': true,
	      'outdent': true,
	      'table-insert-column-after': true,
	      'table-insert-column-before': true,
	      'paste-column-after': true,
	      'paste-column-before': true,
	      'unordered-list': true,
	      'list-bull-circle': true,
	      'list-bull-default': true,
	      'list-bull-square': true
	    };
	    var defaultIconName = 'temporary-placeholder';
	    var defaultIcon = function (icons) {
	      return function () {
	        return get$e(icons, defaultIconName).getOr('!not found!');
	      };
	    };
	    var getIconName = function (name, icons) {
	      var lcName = name.toLowerCase();
	      if (global$e.isRtl()) {
	        var rtlName = ensureTrailing(lcName, '-rtl');
	        return has$2(icons, rtlName) ? rtlName : lcName;
	      } else {
	        return lcName;
	      }
	    };
	    var lookupIcon = function (name, icons) {
	      return get$e(icons, getIconName(name, icons));
	    };
	    var get$1 = function (name, iconProvider) {
	      var icons = iconProvider();
	      return lookupIcon(name, icons).getOrThunk(defaultIcon(icons));
	    };
	    var getOr = function (name, iconProvider, fallbackIcon) {
	      var icons = iconProvider();
	      return lookupIcon(name, icons).or(fallbackIcon).getOrThunk(defaultIcon(icons));
	    };
	    var needsRtlTransform = function (iconName) {
	      return global$e.isRtl() ? has$2(rtlTransform, iconName) : false;
	    };
	    var addFocusableBehaviour = function () {
	      return config('add-focusable', [runOnAttached(function (comp) {
	          child(comp.element, 'svg').each(function (svg) {
	            return set$8(svg, 'focusable', 'false');
	          });
	        })]);
	    };
	    var renderIcon$2 = function (spec, iconName, icons, fallbackIcon) {
	      var _a, _b;
	      var rtlIconClasses = needsRtlTransform(iconName) ? ['tox-icon--flip'] : [];
	      var iconHtml = get$e(icons, getIconName(iconName, icons)).or(fallbackIcon).getOrThunk(defaultIcon(icons));
	      return {
	        dom: {
	          tag: spec.tag,
	          attributes: (_a = spec.attributes) !== null && _a !== void 0 ? _a : {},
	          classes: spec.classes.concat(rtlIconClasses),
	          innerHtml: iconHtml
	        },
	        behaviours: derive$1(__spreadArray(__spreadArray([], (_b = spec.behaviours) !== null && _b !== void 0 ? _b : [], true), [addFocusableBehaviour()], false))
	      };
	    };
	    var render$3 = function (iconName, spec, iconProvider, fallbackIcon) {
	      if (fallbackIcon === void 0) {
	        fallbackIcon = Optional.none();
	      }
	      return renderIcon$2(spec, iconName, iconProvider(), fallbackIcon);
	    };
	    var renderFirst = function (iconNames, spec, iconProvider) {
	      var icons = iconProvider();
	      var iconName = find$5(iconNames, function (name) {
	        return has$2(icons, getIconName(name, icons));
	      });
	      return renderIcon$2(spec, iconName.getOr(defaultIconName), icons, Optional.none());
	    };
	
	    var notificationIconMap = {
	      success: 'checkmark',
	      error: 'warning',
	      err: 'error',
	      warning: 'warning',
	      warn: 'warning',
	      info: 'info'
	    };
	    var factory$k = function (detail) {
	      var memBannerText = record({
	        dom: {
	          tag: 'p',
	          innerHtml: detail.translationProvider(detail.text)
	        },
	        behaviours: derive$1([Replacing.config({})])
	      });
	      var renderPercentBar = function (percent) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-bar'],
	            attributes: { style: 'width: ' + percent + '%' }
	          }
	        };
	      };
	      var renderPercentText = function (percent) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-text'],
	            innerHtml: percent + '%'
	          }
	        };
	      };
	      var memBannerProgress = record({
	        dom: {
	          tag: 'div',
	          classes: detail.progress ? [
	            'tox-progress-bar',
	            'tox-progress-indicator'
	          ] : ['tox-progress-bar']
	        },
	        components: [
	          {
	            dom: {
	              tag: 'div',
	              classes: ['tox-bar-container']
	            },
	            components: [renderPercentBar(0)]
	          },
	          renderPercentText(0)
	        ],
	        behaviours: derive$1([Replacing.config({})])
	      });
	      var updateProgress = function (comp, percent) {
	        if (comp.getSystem().isConnected()) {
	          memBannerProgress.getOpt(comp).each(function (progress) {
	            Replacing.set(progress, [
	              {
	                dom: {
	                  tag: 'div',
	                  classes: ['tox-bar-container']
	                },
	                components: [renderPercentBar(percent)]
	              },
	              renderPercentText(percent)
	            ]);
	          });
	        }
	      };
	      var updateText = function (comp, text) {
	        if (comp.getSystem().isConnected()) {
	          var banner = memBannerText.get(comp);
	          Replacing.set(banner, [text$1(text)]);
	        }
	      };
	      var apis = {
	        updateProgress: updateProgress,
	        updateText: updateText
	      };
	      var iconChoices = flatten([
	        detail.icon.toArray(),
	        detail.level.toArray(),
	        detail.level.bind(function (level) {
	          return Optional.from(notificationIconMap[level]);
	        }).toArray()
	      ]);
	      var memButton = record(Button.sketch({
	        dom: {
	          tag: 'button',
	          classes: [
	            'tox-notification__dismiss',
	            'tox-button',
	            'tox-button--naked',
	            'tox-button--icon'
	          ]
	        },
	        components: [render$3('close', {
	            tag: 'div',
	            classes: ['tox-icon'],
	            attributes: { 'aria-label': detail.translationProvider('Close') }
	          }, detail.iconProvider)],
	        action: function (comp) {
	          detail.onAction(comp);
	        }
	      }));
	      var notificationIconSpec = renderFirst(iconChoices, {
	        tag: 'div',
	        classes: ['tox-notification__icon']
	      }, detail.iconProvider);
	      var notificationBodySpec = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-notification__body']
	        },
	        components: [memBannerText.asSpec()],
	        behaviours: derive$1([Replacing.config({})])
	      };
	      var components = [
	        notificationIconSpec,
	        notificationBodySpec
	      ];
	      return {
	        uid: detail.uid,
	        dom: {
	          tag: 'div',
	          attributes: { role: 'alert' },
	          classes: detail.level.map(function (level) {
	            return [
	              'tox-notification',
	              'tox-notification--in',
	              'tox-notification--' + level
	            ];
	          }).getOr([
	            'tox-notification',
	            'tox-notification--in'
	          ])
	        },
	        behaviours: derive$1([
	          Focusing.config({}),
	          config('notification-events', [run$1(focusin(), function (comp) {
	              memButton.getOpt(comp).each(Focusing.focus);
	            })])
	        ]),
	        components: components.concat(detail.progress ? [memBannerProgress.asSpec()] : []).concat(!detail.closeButton ? [] : [memButton.asSpec()]),
	        apis: apis
	      };
	    };
	    var Notification = single({
	      name: 'Notification',
	      factory: factory$k,
	      configFields: [
	        option('level'),
	        required$1('progress'),
	        required$1('icon'),
	        required$1('onAction'),
	        required$1('text'),
	        required$1('iconProvider'),
	        required$1('translationProvider'),
	        defaultedBoolean('closeButton', true)
	      ],
	      apis: {
	        updateProgress: function (apis, comp, percent) {
	          apis.updateProgress(comp, percent);
	        },
	        updateText: function (apis, comp, text) {
	          apis.updateText(comp, text);
	        }
	      }
	    });
	
	    function NotificationManagerImpl (editor, extras, uiMothership) {
	      var sharedBackstage = extras.backstage.shared;
	      var getLayoutDirection = function (rel) {
	        switch (rel) {
	        case 'bc-bc':
	          return south;
	        case 'tc-tc':
	          return north;
	        case 'tc-bc':
	          return north$2;
	        case 'bc-tc':
	        default:
	          return south$2;
	        }
	      };
	      var reposition = function (notifications) {
	        if (notifications.length > 0) {
	          each$1(notifications, function (notification, index) {
	            if (index === 0) {
	              notification.moveRel(null, 'banner');
	            } else {
	              notification.moveRel(notifications[index - 1].getEl(), 'bc-tc');
	            }
	          });
	        }
	      };
	      var open = function (settings, closeCallback) {
	        var hideCloseButton = !settings.closeButton && settings.timeout && (settings.timeout > 0 || settings.timeout < 0);
	        var close = function () {
	          closeCallback();
	          InlineView.hide(notificationWrapper);
	        };
	        var notification = build$1(Notification.sketch({
	          text: settings.text,
	          level: contains$2([
	            'success',
	            'error',
	            'warning',
	            'warn',
	            'info'
	          ], settings.type) ? settings.type : undefined,
	          progress: settings.progressBar === true,
	          icon: Optional.from(settings.icon),
	          closeButton: !hideCloseButton,
	          onAction: close,
	          iconProvider: sharedBackstage.providers.icons,
	          translationProvider: sharedBackstage.providers.translate
	        }));
	        var notificationWrapper = build$1(InlineView.sketch(__assign({
	          dom: {
	            tag: 'div',
	            classes: ['tox-notifications-container']
	          },
	          lazySink: sharedBackstage.getSink,
	          fireDismissalEventInstead: {}
	        }, sharedBackstage.header.isPositionedAtTop() ? {} : { fireRepositionEventInstead: {} })));
	        uiMothership.add(notificationWrapper);
	        if (settings.timeout > 0) {
	          global$f.setTimeout(function () {
	            close();
	          }, settings.timeout);
	        }
	        var getBounds = function () {
	          var contentArea = box$1(SugarElement.fromDom(editor.getContentAreaContainer()));
	          var win$1 = win();
	          var x = clamp$1(win$1.x, contentArea.x, contentArea.right);
	          var y = clamp$1(win$1.y, contentArea.y, contentArea.bottom);
	          var right = Math.max(contentArea.right, win$1.right);
	          var bottom = Math.max(contentArea.bottom, win$1.bottom);
	          return Optional.some(bounds(x, y, right - x, bottom - y));
	        };
	        return {
	          close: close,
	          moveTo: function (x, y) {
	            InlineView.showAt(notificationWrapper, premade(notification), {
	              anchor: {
	                type: 'makeshift',
	                x: x,
	                y: y
	              }
	            });
	          },
	          moveRel: function (element, rel) {
	            var notificationSpec = premade(notification);
	            var anchorOverrides = { maxHeightFunction: expandable$1() };
	            if (rel !== 'banner' && isNonNullable(element)) {
	              var layoutDirection_1 = getLayoutDirection(rel);
	              var nodeAnchor = {
	                type: 'node',
	                root: body(),
	                node: Optional.some(SugarElement.fromDom(element)),
	                overrides: anchorOverrides,
	                layouts: {
	                  onRtl: function () {
	                    return [layoutDirection_1];
	                  },
	                  onLtr: function () {
	                    return [layoutDirection_1];
	                  }
	                }
	              };
	              InlineView.showWithinBounds(notificationWrapper, notificationSpec, { anchor: nodeAnchor }, getBounds);
	            } else {
	              var anchor = __assign(__assign({}, sharedBackstage.anchors.banner()), { overrides: anchorOverrides });
	              InlineView.showWithinBounds(notificationWrapper, notificationSpec, { anchor: anchor }, getBounds);
	            }
	          },
	          text: function (nuText) {
	            Notification.updateText(notification, nuText);
	          },
	          settings: settings,
	          getEl: function () {
	            return notification.element.dom;
	          },
	          progressBar: {
	            value: function (percent) {
	              Notification.updateProgress(notification, percent);
	            }
	          }
	        };
	      };
	      var close = function (notification) {
	        notification.close();
	      };
	      var getArgs = function (notification) {
	        return notification.settings;
	      };
	      return {
	        open: open,
	        close: close,
	        reposition: reposition,
	        getArgs: getArgs
	      };
	    }
	
	    var first = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (!isNull(timer)) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (isNull(timer)) {
	          timer = setTimeout(function () {
	            timer = null;
	            fn.apply(null, args);
	          }, rate);
	        }
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	    var last = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (!isNull(timer)) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        cancel();
	        timer = setTimeout(function () {
	          timer = null;
	          fn.apply(null, args);
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var global$d = tinymce.util.Tools.resolve('tinymce.dom.TextSeeker');
	
	    var isBoundary = function (dom, node) {
	      return dom.isBlock(node) || contains$2([
	        'BR',
	        'IMG',
	        'HR',
	        'INPUT'
	      ], node.nodeName) || dom.getContentEditable(node) === 'false';
	    };
	    var repeatLeft = function (dom, node, offset, process, rootNode) {
	      var search = global$d(dom, function (node) {
	        return isBoundary(dom, node);
	      });
	      return Optional.from(search.backwards(node, offset, process, rootNode));
	    };
	
	    var autocompleteSelector = '[data-mce-autocompleter]';
	    var create$5 = function (editor, range) {
	      return detect(SugarElement.fromDom(editor.selection.getNode())).getOrThunk(function () {
	        var wrapper = SugarElement.fromHtml('<span data-mce-autocompleter="1" data-mce-bogus="1"></span>', editor.getDoc());
	        append$2(wrapper, SugarElement.fromDom(range.extractContents()));
	        range.insertNode(wrapper.dom);
	        parent(wrapper).each(function (elm) {
	          return elm.dom.normalize();
	        });
	        last$1(wrapper).map(function (last) {
	          editor.selection.setCursorLocation(last.dom, getEnd(last));
	        });
	        return wrapper;
	      });
	    };
	    var detect = function (elm) {
	      return closest$1(elm, autocompleteSelector);
	    };
	
	    var isValidTextRange = function (rng) {
	      return rng.collapsed && rng.startContainer.nodeType === 3;
	    };
	    var getText = function (rng) {
	      return rng.toString().replace(/\u00A0/g, ' ').replace(/\uFEFF/g, '');
	    };
	    var isWhitespace = function (chr) {
	      return chr !== '' && ' \xA0\f\n\r\t\x0B'.indexOf(chr) !== -1;
	    };
	
	    var stripTriggerChar = function (text, triggerCh) {
	      return text.substring(triggerCh.length);
	    };
	    var findChar = function (text, index, ch) {
	      var i;
	      for (i = index - 1; i >= 0; i--) {
	        var char = text.charAt(i);
	        if (isWhitespace(char)) {
	          return Optional.none();
	        }
	        if (char === ch) {
	          break;
	        }
	      }
	      return Optional.some(i);
	    };
	    var findStart = function (dom, initRange, ch, minChars) {
	      if (minChars === void 0) {
	        minChars = 0;
	      }
	      if (!isValidTextRange(initRange)) {
	        return Optional.none();
	      }
	      var findTriggerChIndex = function (element, offset, text) {
	        return findChar(text, offset, ch).getOr(offset);
	      };
	      var root = dom.getParent(initRange.startContainer, dom.isBlock) || dom.getRoot();
	      return repeatLeft(dom, initRange.startContainer, initRange.startOffset, findTriggerChIndex, root).bind(function (spot) {
	        var range = initRange.cloneRange();
	        range.setStart(spot.container, spot.offset);
	        range.setEnd(initRange.endContainer, initRange.endOffset);
	        if (range.collapsed) {
	          return Optional.none();
	        }
	        var text = getText(range);
	        var triggerCharIndex = text.lastIndexOf(ch);
	        if (triggerCharIndex !== 0 || stripTriggerChar(text, ch).length < minChars) {
	          return Optional.none();
	        } else {
	          return Optional.some({
	            text: stripTriggerChar(text, ch),
	            range: range,
	            triggerChar: ch
	          });
	        }
	      });
	    };
	    var getContext = function (dom, initRange, ch, minChars) {
	      if (minChars === void 0) {
	        minChars = 0;
	      }
	      return detect(SugarElement.fromDom(initRange.startContainer)).fold(function () {
	        return findStart(dom, initRange, ch, minChars);
	      }, function (elm) {
	        var range = dom.createRng();
	        range.selectNode(elm.dom);
	        var text = getText(range);
	        return Optional.some({
	          range: range,
	          text: stripTriggerChar(text, ch),
	          triggerChar: ch
	        });
	      });
	    };
	
	    var setup$e = function (api, editor) {
	      editor.on('keypress compositionend', api.onKeypress.throttle);
	      editor.on('remove', api.onKeypress.cancel);
	      var redirectKeyToItem = function (item, e) {
	        emitWith(item, keydown(), { raw: e });
	      };
	      editor.on('keydown', function (e) {
	        var getItem = function () {
	          return api.getView().bind(Highlighting.getHighlighted);
	        };
	        if (e.which === 8) {
	          api.onKeypress.throttle(e);
	        }
	        if (api.isActive()) {
	          if (e.which === 27) {
	            api.cancelIfNecessary();
	          }
	          if (api.isMenuOpen()) {
	            if (e.which === 13) {
	              getItem().each(emitExecute);
	              e.preventDefault();
	            } else if (e.which === 40) {
	              getItem().fold(function () {
	                api.getView().each(Highlighting.highlightFirst);
	              }, function (item) {
	                redirectKeyToItem(item, e);
	              });
	              e.preventDefault();
	              e.stopImmediatePropagation();
	            } else if (e.which === 37 || e.which === 38 || e.which === 39) {
	              getItem().each(function (item) {
	                redirectKeyToItem(item, e);
	                e.preventDefault();
	                e.stopImmediatePropagation();
	              });
	            }
	          } else {
	            if (e.which === 13 || e.which === 38 || e.which === 40) {
	              api.cancelIfNecessary();
	            }
	          }
	        }
	      });
	      editor.on('NodeChange', function (e) {
	        if (api.isActive() && !api.isProcessingAction() && detect(SugarElement.fromDom(e.element)).isNone()) {
	          api.cancelIfNecessary();
	        }
	      });
	    };
	    var AutocompleterEditorEvents = { setup: setup$e };
	
	    var global$c = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var point = function (container, offset) {
	      return {
	        container: container,
	        offset: offset
	      };
	    };
	
	    var isText = function (node) {
	      return node.nodeType === TEXT;
	    };
	    var isElement$1 = function (node) {
	      return node.nodeType === ELEMENT;
	    };
	    var toLast = function (node) {
	      if (isText(node)) {
	        return point(node, node.data.length);
	      } else {
	        var children = node.childNodes;
	        return children.length > 0 ? toLast(children[children.length - 1]) : point(node, children.length);
	      }
	    };
	    var toLeaf = function (node, offset) {
	      var children = node.childNodes;
	      if (children.length > 0 && offset < children.length) {
	        return toLeaf(children[offset], 0);
	      } else if (children.length > 0 && isElement$1(node) && children.length === offset) {
	        return toLast(children[children.length - 1]);
	      } else {
	        return point(node, offset);
	      }
	    };
	
	    var isPreviousCharContent = function (dom, leaf) {
	      return repeatLeft(dom, leaf.container, leaf.offset, function (element, offset) {
	        return offset === 0 ? -1 : offset;
	      }, dom.getRoot()).filter(function (spot) {
	        var char = spot.container.data.charAt(spot.offset - 1);
	        return !isWhitespace(char);
	      }).isSome();
	    };
	    var isStartOfWord = function (dom) {
	      return function (rng) {
	        var leaf = toLeaf(rng.startContainer, rng.startOffset);
	        return !isPreviousCharContent(dom, leaf);
	      };
	    };
	    var getTriggerContext = function (dom, initRange, database) {
	      return findMap(database.triggerChars, function (ch) {
	        return getContext(dom, initRange, ch);
	      });
	    };
	    var lookup$2 = function (editor, getDatabase) {
	      var database = getDatabase();
	      var rng = editor.selection.getRng();
	      return getTriggerContext(editor.dom, rng, database).bind(function (context) {
	        return lookupWithContext(editor, getDatabase, context);
	      });
	    };
	    var lookupWithContext = function (editor, getDatabase, context, fetchOptions) {
	      if (fetchOptions === void 0) {
	        fetchOptions = {};
	      }
	      var database = getDatabase();
	      var rng = editor.selection.getRng();
	      var startText = rng.startContainer.nodeValue;
	      var autocompleters = filter$2(database.lookupByChar(context.triggerChar), function (autocompleter) {
	        return context.text.length >= autocompleter.minChars && autocompleter.matches.getOrThunk(function () {
	          return isStartOfWord(editor.dom);
	        })(context.range, startText, context.text);
	      });
	      if (autocompleters.length === 0) {
	        return Optional.none();
	      }
	      var lookupData = global$c.all(map$2(autocompleters, function (ac) {
	        var fetchResult = ac.fetch(context.text, ac.maxResults, fetchOptions);
	        return fetchResult.then(function (results) {
	          return {
	            matchText: context.text,
	            items: results,
	            columns: ac.columns,
	            onAction: ac.onAction,
	            highlightOn: ac.highlightOn
	          };
	        });
	      }));
	      return Optional.some({
	        lookupData: lookupData,
	        context: context
	      });
	    };
	
	    var separatorMenuItemSchema = objOf([
	      requiredString('type'),
	      optionString('text')
	    ]);
	    var createSeparatorMenuItem = function (spec) {
	      return asRaw('separatormenuitem', separatorMenuItemSchema, spec);
	    };
	
	    var autocompleterItemSchema = objOf([
	      defaulted('type', 'autocompleteitem'),
	      defaulted('active', false),
	      defaulted('disabled', false),
	      defaulted('meta', {}),
	      requiredString('value'),
	      optionString('text'),
	      optionString('icon')
	    ]);
	    var autocompleterSchema = objOf([
	      requiredString('type'),
	      requiredString('ch'),
	      defaultedNumber('minChars', 1),
	      defaulted('columns', 1),
	      defaultedNumber('maxResults', 10),
	      optionFunction('matches'),
	      requiredFunction('fetch'),
	      requiredFunction('onAction'),
	      defaultedArrayOf('highlightOn', [], string)
	    ]);
	    var createSeparatorItem = function (spec) {
	      return asRaw('Autocompleter.Separator', separatorMenuItemSchema, spec);
	    };
	    var createAutocompleterItem = function (spec) {
	      return asRaw('Autocompleter.Item', autocompleterItemSchema, spec);
	    };
	    var createAutocompleter = function (spec) {
	      return asRaw('Autocompleter', autocompleterSchema, spec);
	    };
	
	    var baseToolbarButtonFields = [
	      defaultedBoolean('disabled', false),
	      optionString('tooltip'),
	      optionString('icon'),
	      optionString('text'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      })
	    ];
	    var toolbarButtonSchema = objOf([
	      requiredString('type'),
	      requiredFunction('onAction')
	    ].concat(baseToolbarButtonFields));
	    var createToolbarButton = function (spec) {
	      return asRaw('toolbarbutton', toolbarButtonSchema, spec);
	    };
	
	    var baseToolbarToggleButtonFields = [defaultedBoolean('active', false)].concat(baseToolbarButtonFields);
	    var toggleButtonSchema = objOf(baseToolbarToggleButtonFields.concat([
	      requiredString('type'),
	      requiredFunction('onAction')
	    ]));
	    var createToggleButton = function (spec) {
	      return asRaw('ToggleButton', toggleButtonSchema, spec);
	    };
	
	    var contextBarFields = [
	      defaultedFunction('predicate', never),
	      defaultedStringEnum('scope', 'node', [
	        'node',
	        'editor'
	      ]),
	      defaultedStringEnum('position', 'selection', [
	        'node',
	        'selection',
	        'line'
	      ])
	    ];
	
	    var contextButtonFields = baseToolbarButtonFields.concat([
	      defaulted('type', 'contextformbutton'),
	      defaulted('primary', false),
	      requiredFunction('onAction'),
	      customField('original', identity$1)
	    ]);
	    var contextToggleButtonFields = baseToolbarToggleButtonFields.concat([
	      defaulted('type', 'contextformbutton'),
	      defaulted('primary', false),
	      requiredFunction('onAction'),
	      customField('original', identity$1)
	    ]);
	    var launchButtonFields = baseToolbarButtonFields.concat([defaulted('type', 'contextformbutton')]);
	    var launchToggleButtonFields = baseToolbarToggleButtonFields.concat([defaulted('type', 'contextformtogglebutton')]);
	    var toggleOrNormal = choose$1('type', {
	      contextformbutton: contextButtonFields,
	      contextformtogglebutton: contextToggleButtonFields
	    });
	    var contextFormSchema = objOf([
	      defaulted('type', 'contextform'),
	      defaultedFunction('initValue', constant$1('')),
	      optionString('label'),
	      requiredArrayOf('commands', toggleOrNormal),
	      optionOf('launch', choose$1('type', {
	        contextformbutton: launchButtonFields,
	        contextformtogglebutton: launchToggleButtonFields
	      }))
	    ].concat(contextBarFields));
	    var createContextForm = function (spec) {
	      return asRaw('ContextForm', contextFormSchema, spec);
	    };
	
	    var contextToolbarSchema = objOf([
	      defaulted('type', 'contexttoolbar'),
	      requiredString('items')
	    ].concat(contextBarFields));
	    var createContextToolbar = function (spec) {
	      return asRaw('ContextToolbar', contextToolbarSchema, spec);
	    };
	
	    var stringArray = function (a) {
	      var all = {};
	      each$1(a, function (key) {
	        all[key] = {};
	      });
	      return keys(all);
	    };
	
	    var register$b = function (editor) {
	      var popups = editor.ui.registry.getAll().popups;
	      var dataset = map$1(popups, function (popup) {
	        return createAutocompleter(popup).fold(function (err) {
	          throw new Error(formatError(err));
	        }, identity$1);
	      });
	      var triggerChars = stringArray(mapToArray(dataset, function (v) {
	        return v.ch;
	      }));
	      var datasetValues = values(dataset);
	      var lookupByChar = function (ch) {
	        return filter$2(datasetValues, function (dv) {
	          return dv.ch === ch;
	        });
	      };
	      return {
	        dataset: dataset,
	        triggerChars: triggerChars,
	        lookupByChar: lookupByChar
	      };
	    };
	
	    var ItemResponse;
	    (function (ItemResponse) {
	      ItemResponse[ItemResponse['CLOSE_ON_EXECUTE'] = 0] = 'CLOSE_ON_EXECUTE';
	      ItemResponse[ItemResponse['BUBBLE_TO_SANDBOX'] = 1] = 'BUBBLE_TO_SANDBOX';
	    }(ItemResponse || (ItemResponse = {})));
	    var ItemResponse$1 = ItemResponse;
	
	    var navClass = 'tox-menu-nav__js';
	    var selectableClass = 'tox-collection__item';
	    var colorClass = 'tox-swatch';
	    var presetClasses = {
	      normal: navClass,
	      color: colorClass
	    };
	    var tickedClass = 'tox-collection__item--enabled';
	    var groupHeadingClass = 'tox-collection__group-heading';
	    var iconClass = 'tox-collection__item-icon';
	    var textClass = 'tox-collection__item-label';
	    var accessoryClass = 'tox-collection__item-accessory';
	    var caretClass = 'tox-collection__item-caret';
	    var checkmarkClass = 'tox-collection__item-checkmark';
	    var activeClass = 'tox-collection__item--active';
	    var containerClass = 'tox-collection__item-container';
	    var containerColumnClass = 'tox-collection__item-container--column';
	    var containerRowClass = 'tox-collection__item-container--row';
	    var containerAlignRightClass = 'tox-collection__item-container--align-right';
	    var containerAlignLeftClass = 'tox-collection__item-container--align-left';
	    var containerValignTopClass = 'tox-collection__item-container--valign-top';
	    var containerValignMiddleClass = 'tox-collection__item-container--valign-middle';
	    var containerValignBottomClass = 'tox-collection__item-container--valign-bottom';
	    var classForPreset = function (presets) {
	      return get$e(presetClasses, presets).getOr(navClass);
	    };
	
	    var forMenu = function (presets) {
	      if (presets === 'color') {
	        return 'tox-swatches';
	      } else {
	        return 'tox-menu';
	      }
	    };
	    var classes = function (presets) {
	      return {
	        backgroundMenu: 'tox-background-menu',
	        selectedMenu: 'tox-selected-menu',
	        selectedItem: 'tox-collection__item--active',
	        hasIcons: 'tox-menu--has-icons',
	        menu: forMenu(presets),
	        tieredMenu: 'tox-tiered-menu'
	      };
	    };
	
	    var markers = function (presets) {
	      var menuClasses = classes(presets);
	      return {
	        backgroundMenu: menuClasses.backgroundMenu,
	        selectedMenu: menuClasses.selectedMenu,
	        menu: menuClasses.menu,
	        selectedItem: menuClasses.selectedItem,
	        item: classForPreset(presets)
	      };
	    };
	    var dom$1 = function (hasIcons, columns, presets) {
	      var menuClasses = classes(presets);
	      return {
	        tag: 'div',
	        classes: flatten([
	          [
	            menuClasses.menu,
	            'tox-menu-' + columns + '-column'
	          ],
	          hasIcons ? [menuClasses.hasIcons] : []
	        ])
	      };
	    };
	    var components = [Menu.parts.items({})];
	    var part = function (hasIcons, columns, presets) {
	      var menuClasses = classes(presets);
	      var d = {
	        tag: 'div',
	        classes: flatten([[menuClasses.tieredMenu]])
	      };
	      return {
	        dom: d,
	        markers: markers(presets)
	      };
	    };
	
	    var chunk = function (rowDom, numColumns) {
	      return function (items) {
	        var chunks = chunk$1(items, numColumns);
	        return map$2(chunks, function (c) {
	          return {
	            dom: rowDom,
	            components: c
	          };
	        });
	      };
	    };
	    var forSwatch = function (columns) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-menu',
	            'tox-swatches-menu'
	          ]
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-swatches']
	            },
	            components: [Menu.parts.items({
	                preprocess: columns !== 'auto' ? chunk({
	                  tag: 'div',
	                  classes: ['tox-swatches__row']
	                }, columns) : identity$1
	              })]
	          }]
	      };
	    };
	    var forToolbar = function (columns) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-menu',
	            'tox-collection',
	            'tox-collection--toolbar',
	            'tox-collection--toolbar-lg'
	          ]
	        },
	        components: [Menu.parts.items({
	            preprocess: chunk({
	              tag: 'div',
	              classes: ['tox-collection__group']
	            }, columns)
	          })]
	      };
	    };
	    var preprocessCollection = function (items, isSeparator) {
	      var allSplits = [];
	      var currentSplit = [];
	      each$1(items, function (item, i) {
	        if (isSeparator(item, i)) {
	          if (currentSplit.length > 0) {
	            allSplits.push(currentSplit);
	          }
	          currentSplit = [];
	          if (has$2(item.dom, 'innerHtml')) {
	            currentSplit.push(item);
	          }
	        } else {
	          currentSplit.push(item);
	        }
	      });
	      if (currentSplit.length > 0) {
	        allSplits.push(currentSplit);
	      }
	      return map$2(allSplits, function (s) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-collection__group']
	          },
	          components: s
	        };
	      });
	    };
	    var forCollection = function (columns, initItems, _hasIcons) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-menu',
	            'tox-collection'
	          ].concat(columns === 1 ? ['tox-collection--list'] : ['tox-collection--grid'])
	        },
	        components: [Menu.parts.items({
	            preprocess: function (items) {
	              if (columns !== 'auto' && columns > 1) {
	                return chunk({
	                  tag: 'div',
	                  classes: ['tox-collection__group']
	                }, columns)(items);
	              } else {
	                return preprocessCollection(items, function (_item, i) {
	                  return initItems[i].type === 'separator';
	                });
	              }
	            }
	          })]
	      };
	    };
	    var forHorizontalCollection = function (initItems, _hasIcons) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-collection',
	            'tox-collection--horizontal'
	          ]
	        },
	        components: [Menu.parts.items({
	            preprocess: function (items) {
	              return preprocessCollection(items, function (_item, i) {
	                return initItems[i].type === 'separator';
	              });
	            }
	          })]
	      };
	    };
	
	    var menuHasIcons = function (xs) {
	      return exists(xs, function (item) {
	        return 'icon' in item && item.icon !== undefined;
	      });
	    };
	    var handleError = function (error) {
	      console.error(formatError(error));
	      console.log(error);
	      return Optional.none();
	    };
	    var createHorizontalPartialMenuWithAlloyItems = function (value, _hasIcons, items, _columns, _presets) {
	      var structure = forHorizontalCollection(items);
	      return {
	        value: value,
	        dom: structure.dom,
	        components: structure.components,
	        items: items
	      };
	    };
	    var createPartialMenuWithAlloyItems = function (value, hasIcons, items, columns, presets) {
	      if (presets === 'color') {
	        var structure = forSwatch(columns);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      if (presets === 'normal' && columns === 'auto') {
	        var structure = forCollection(columns, items);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      if (presets === 'normal' && columns === 1) {
	        var structure = forCollection(1, items);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      if (presets === 'normal') {
	        var structure = forCollection(columns, items);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      if (presets === 'listpreview' && columns !== 'auto') {
	        var structure = forToolbar(columns);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      return {
	        value: value,
	        dom: dom$1(hasIcons, columns, presets),
	        components: components,
	        items: items
	      };
	    };
	
	    var cardImageFields = [
	      requiredString('type'),
	      requiredString('src'),
	      optionString('alt'),
	      defaultedArrayOf('classes', [], string)
	    ];
	    var cardImageSchema = objOf(cardImageFields);
	
	    var cardTextFields = [
	      requiredString('type'),
	      requiredString('text'),
	      optionString('name'),
	      defaultedArrayOf('classes', ['tox-collection__item-label'], string)
	    ];
	    var cardTextSchema = objOf(cardTextFields);
	
	    var itemSchema$1 = valueThunk(function () {
	      return choose$2('type', {
	        cardimage: cardImageSchema,
	        cardtext: cardTextSchema,
	        cardcontainer: cardContainerSchema
	      });
	    });
	    var cardContainerSchema = objOf([
	      requiredString('type'),
	      defaultedString('direction', 'horizontal'),
	      defaultedString('align', 'left'),
	      defaultedString('valign', 'middle'),
	      requiredArrayOf('items', itemSchema$1)
	    ]);
	
	    var commonMenuItemFields = [
	      defaultedBoolean('disabled', false),
	      optionString('text'),
	      optionString('shortcut'),
	      field$1('value', 'value', defaultedThunk(function () {
	        return generate$6('menuitem-value');
	      }), anyValue()),
	      defaulted('meta', {})
	    ];
	
	    var cardMenuItemSchema = objOf([
	      requiredString('type'),
	      optionString('label'),
	      requiredArrayOf('items', itemSchema$1),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      defaultedFunction('onAction', noop)
	    ].concat(commonMenuItemFields));
	    var createCardMenuItem = function (spec) {
	      return asRaw('cardmenuitem', cardMenuItemSchema, spec);
	    };
	
	    var choiceMenuItemSchema = objOf([
	      requiredString('type'),
	      defaultedBoolean('active', false),
	      optionString('icon')
	    ].concat(commonMenuItemFields));
	    var createChoiceMenuItem = function (spec) {
	      return asRaw('choicemenuitem', choiceMenuItemSchema, spec);
	    };
	
	    var baseFields = [
	      requiredString('type'),
	      requiredString('fancytype'),
	      defaultedFunction('onAction', noop)
	    ];
	    var insertTableFields = [defaulted('initData', {})].concat(baseFields);
	    var colorSwatchFields = [defaultedObjOf('initData', {}, [
	        defaultedBoolean('allowCustomColors', true),
	        optionArrayOf('colors', anyValue())
	      ])].concat(baseFields);
	    var fancyMenuItemSchema = choose$1('fancytype', {
	      inserttable: insertTableFields,
	      colorswatch: colorSwatchFields
	    });
	    var createFancyMenuItem = function (spec) {
	      return asRaw('fancymenuitem', fancyMenuItemSchema, spec);
	    };
	
	    var menuItemSchema = objOf([
	      requiredString('type'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      defaultedFunction('onAction', noop),
	      optionString('icon')
	    ].concat(commonMenuItemFields));
	    var createMenuItem = function (spec) {
	      return asRaw('menuitem', menuItemSchema, spec);
	    };
	
	    var nestedMenuItemSchema = objOf([
	      requiredString('type'),
	      requiredFunction('getSubmenuItems'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      optionString('icon')
	    ].concat(commonMenuItemFields));
	    var createNestedMenuItem = function (spec) {
	      return asRaw('nestedmenuitem', nestedMenuItemSchema, spec);
	    };
	
	    var toggleMenuItemSchema = objOf([
	      requiredString('type'),
	      optionString('icon'),
	      defaultedBoolean('active', false),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      requiredFunction('onAction')
	    ].concat(commonMenuItemFields));
	    var createToggleMenuItem = function (spec) {
	      return asRaw('togglemenuitem', toggleMenuItemSchema, spec);
	    };
	
	    var detectSize = function (comp, margin, selectorClass) {
	      var descendants$1 = descendants(comp.element, '.' + selectorClass);
	      if (descendants$1.length > 0) {
	        var columnLength = findIndex$1(descendants$1, function (c) {
	          var thisTop = c.dom.getBoundingClientRect().top;
	          var cTop = descendants$1[0].dom.getBoundingClientRect().top;
	          return Math.abs(thisTop - cTop) > margin;
	        }).getOr(descendants$1.length);
	        return Optional.some({
	          numColumns: columnLength,
	          numRows: Math.ceil(descendants$1.length / columnLength)
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	
	    var namedEvents = function (name, handlers) {
	      return derive$1([config(name, handlers)]);
	    };
	    var unnamedEvents = function (handlers) {
	      return namedEvents(generate$6('unnamed-events'), handlers);
	    };
	    var SimpleBehaviours = {
	      namedEvents: namedEvents,
	      unnamedEvents: unnamedEvents
	    };
	
	    var ExclusivityChannel = generate$6('tooltip.exclusive');
	    var ShowTooltipEvent = generate$6('tooltip.show');
	    var HideTooltipEvent = generate$6('tooltip.hide');
	
	    var hideAllExclusive = function (component, _tConfig, _tState) {
	      component.getSystem().broadcastOn([ExclusivityChannel], {});
	    };
	    var setComponents = function (component, tConfig, tState, specs) {
	      tState.getTooltip().each(function (tooltip) {
	        if (tooltip.getSystem().isConnected()) {
	          Replacing.set(tooltip, specs);
	        }
	      });
	    };
	
	    var TooltippingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        hideAllExclusive: hideAllExclusive,
	        setComponents: setComponents
	    });
	
	    var events$9 = function (tooltipConfig, state) {
	      var hide = function (comp) {
	        state.getTooltip().each(function (p) {
	          detach(p);
	          tooltipConfig.onHide(comp, p);
	          state.clearTooltip();
	        });
	        state.clearTimer();
	      };
	      var show = function (comp) {
	        if (!state.isShowing()) {
	          hideAllExclusive(comp);
	          var sink = tooltipConfig.lazySink(comp).getOrDie();
	          var popup = comp.getSystem().build({
	            dom: tooltipConfig.tooltipDom,
	            components: tooltipConfig.tooltipComponents,
	            events: derive$2(tooltipConfig.mode === 'normal' ? [
	              run$1(mouseover(), function (_) {
	                emit(comp, ShowTooltipEvent);
	              }),
	              run$1(mouseout(), function (_) {
	                emit(comp, HideTooltipEvent);
	              })
	            ] : []),
	            behaviours: derive$1([Replacing.config({})])
	          });
	          state.setTooltip(popup);
	          attach(sink, popup);
	          tooltipConfig.onShow(comp, popup);
	          Positioning.position(sink, popup, { anchor: tooltipConfig.anchor(comp) });
	        }
	      };
	      return derive$2(flatten([
	        [
	          run$1(ShowTooltipEvent, function (comp) {
	            state.resetTimer(function () {
	              show(comp);
	            }, tooltipConfig.delay);
	          }),
	          run$1(HideTooltipEvent, function (comp) {
	            state.resetTimer(function () {
	              hide(comp);
	            }, tooltipConfig.delay);
	          }),
	          run$1(receive(), function (comp, message) {
	            var receivingData = message;
	            if (!receivingData.universal) {
	              if (contains$2(receivingData.channels, ExclusivityChannel)) {
	                hide(comp);
	              }
	            }
	          }),
	          runOnDetached(function (comp) {
	            hide(comp);
	          })
	        ],
	        tooltipConfig.mode === 'normal' ? [
	          run$1(focusin(), function (comp) {
	            emit(comp, ShowTooltipEvent);
	          }),
	          run$1(postBlur(), function (comp) {
	            emit(comp, HideTooltipEvent);
	          }),
	          run$1(mouseover(), function (comp) {
	            emit(comp, ShowTooltipEvent);
	          }),
	          run$1(mouseout(), function (comp) {
	            emit(comp, HideTooltipEvent);
	          })
	        ] : [
	          run$1(highlight$1(), function (comp, _se) {
	            emit(comp, ShowTooltipEvent);
	          }),
	          run$1(dehighlight$1(), function (comp) {
	            emit(comp, HideTooltipEvent);
	          })
	        ]
	      ]));
	    };
	
	    var ActiveTooltipping = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$9
	    });
	
	    var TooltippingSchema = [
	      required$1('lazySink'),
	      required$1('tooltipDom'),
	      defaulted('exclusive', true),
	      defaulted('tooltipComponents', []),
	      defaulted('delay', 300),
	      defaultedStringEnum('mode', 'normal', [
	        'normal',
	        'follow-highlight'
	      ]),
	      defaulted('anchor', function (comp) {
	        return {
	          type: 'hotspot',
	          hotspot: comp,
	          layouts: {
	            onLtr: constant$1([
	              south$2,
	              north$2,
	              southeast$2,
	              northeast$2,
	              southwest$2,
	              northwest$2
	            ]),
	            onRtl: constant$1([
	              south$2,
	              north$2,
	              southeast$2,
	              northeast$2,
	              southwest$2,
	              northwest$2
	            ])
	          }
	        };
	      }),
	      onHandler('onHide'),
	      onHandler('onShow')
	    ];
	
	    var init$b = function () {
	      var timer = value$1();
	      var popup = value$1();
	      var clearTimer = function () {
	        timer.on(clearTimeout);
	      };
	      var resetTimer = function (f, delay) {
	        clearTimer();
	        timer.set(setTimeout(f, delay));
	      };
	      var readState = constant$1('not-implemented');
	      return nu$8({
	        getTooltip: popup.get,
	        isShowing: popup.isSet,
	        setTooltip: popup.set,
	        clearTooltip: popup.clear,
	        clearTimer: clearTimer,
	        resetTimer: resetTimer,
	        readState: readState
	      });
	    };
	
	    var TooltippingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$b
	    });
	
	    var Tooltipping = create$8({
	      fields: TooltippingSchema,
	      name: 'tooltipping',
	      active: ActiveTooltipping,
	      state: TooltippingState,
	      apis: TooltippingApis
	    });
	
	    var escape = function (text) {
	      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	    };
	
	    var global$b = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$a = tinymce.util.Tools.resolve('tinymce.EditorManager');
	
	    var getSkinUrl = function (editor) {
	      var skin = editor.getParam('skin');
	      var skinUrl = editor.getParam('skin_url');
	      if (skin !== false) {
	        var skinName = skin ? skin : 'oxide';
	        if (skinUrl) {
	          skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
	        } else {
	          skinUrl = global$a.baseURL + '/skins/ui/' + skinName;
	        }
	      }
	      return skinUrl;
	    };
	    var isReadOnly = function (editor) {
	      return editor.getParam('readonly', false, 'boolean');
	    };
	    var isSkinDisabled = function (editor) {
	      return editor.getParam('skin') === false;
	    };
	    var getHeightSetting = function (editor) {
	      return editor.getParam('height', Math.max(editor.getElement().offsetHeight, 200));
	    };
	    var getWidthSetting = function (editor) {
	      return editor.getParam('width', global$b.DOM.getStyle(editor.getElement(), 'width'));
	    };
	    var getMinWidthSetting = function (editor) {
	      return Optional.from(editor.getParam('min_width')).filter(isNumber);
	    };
	    var getMinHeightSetting = function (editor) {
	      return Optional.from(editor.getParam('min_height')).filter(isNumber);
	    };
	    var getMaxWidthSetting = function (editor) {
	      return Optional.from(editor.getParam('max_width')).filter(isNumber);
	    };
	    var getMaxHeightSetting = function (editor) {
	      return Optional.from(editor.getParam('max_height')).filter(isNumber);
	    };
	    var getUserStyleFormats = function (editor) {
	      return Optional.from(editor.getParam('style_formats')).filter(isArray);
	    };
	    var isMergeStyleFormats = function (editor) {
	      return editor.getParam('style_formats_merge', false, 'boolean');
	    };
	    var getLineHeightFormats = function (editor) {
	      return editor.getParam('lineheight_formats', '1 1.1 1.2 1.3 1.4 1.5 2', 'string').split(' ');
	    };
	    var getContentLanguages = function (editor) {
	      return editor.getParam('content_langs', undefined, 'array');
	    };
	    var getRemovedMenuItems = function (editor) {
	      return editor.getParam('removed_menuitems', '');
	    };
	    var isMenubarEnabled = function (editor) {
	      return editor.getParam('menubar', true, 'boolean') !== false;
	    };
	    var isToolbarEnabled = function (editor) {
	      var toolbar = editor.getParam('toolbar', true);
	      var isToolbarTrue = toolbar === true;
	      var isToolbarString = isString(toolbar);
	      var isToolbarObjectArray = isArray(toolbar) && toolbar.length > 0;
	      return !isMultipleToolbars(editor) && (isToolbarObjectArray || isToolbarString || isToolbarTrue);
	    };
	    var getMultipleToolbarsSetting = function (editor) {
	      var toolbars = range$2(9, function (num) {
	        return editor.getParam('toolbar' + (num + 1), false, 'string');
	      });
	      var toolbarArray = filter$2(toolbars, function (toolbar) {
	        return typeof toolbar === 'string';
	      });
	      return toolbarArray.length > 0 ? Optional.some(toolbarArray) : Optional.none();
	    };
	    var isMultipleToolbars = function (editor) {
	      return getMultipleToolbarsSetting(editor).fold(function () {
	        var toolbar = editor.getParam('toolbar', [], 'string[]');
	        return toolbar.length > 0;
	      }, always);
	    };
	    var ToolbarMode;
	    (function (ToolbarMode) {
	      ToolbarMode['default'] = 'wrap';
	      ToolbarMode['floating'] = 'floating';
	      ToolbarMode['sliding'] = 'sliding';
	      ToolbarMode['scrolling'] = 'scrolling';
	    }(ToolbarMode || (ToolbarMode = {})));
	    var getToolbarMode = function (editor) {
	      return editor.getParam('toolbar_mode', '', 'string');
	    };
	    var ToolbarLocation;
	    (function (ToolbarLocation) {
	      ToolbarLocation['auto'] = 'auto';
	      ToolbarLocation['top'] = 'top';
	      ToolbarLocation['bottom'] = 'bottom';
	    }(ToolbarLocation || (ToolbarLocation = {})));
	    var getToolbarGroups = function (editor) {
	      return editor.getParam('toolbar_groups', {}, 'object');
	    };
	    var getToolbarLocation = function (editor) {
	      return editor.getParam('toolbar_location', ToolbarLocation.auto, 'string');
	    };
	    var isToolbarLocationBottom = function (editor) {
	      return getToolbarLocation(editor) === ToolbarLocation.bottom;
	    };
	    var fixedContainerSelector = function (editor) {
	      return editor.getParam('fixed_toolbar_container', '', 'string');
	    };
	    var fixedToolbarContainerTarget = function (editor) {
	      return editor.getParam('fixed_toolbar_container_target');
	    };
	    var isToolbarPersist = function (editor) {
	      return editor.getParam('toolbar_persist', false, 'boolean');
	    };
	    var fixedContainerTarget = function (editor) {
	      if (!editor.inline) {
	        return Optional.none();
	      }
	      var selector = fixedContainerSelector(editor);
	      if (selector.length > 0) {
	        return descendant(body(), selector);
	      }
	      var element = fixedToolbarContainerTarget(editor);
	      if (isNonNullable(element)) {
	        return Optional.some(SugarElement.fromDom(element));
	      }
	      return Optional.none();
	    };
	    var useFixedContainer = function (editor) {
	      return editor.inline && fixedContainerTarget(editor).isSome();
	    };
	    var getUiContainer = function (editor) {
	      var fixedContainer = fixedContainerTarget(editor);
	      return fixedContainer.getOrThunk(function () {
	        return getContentContainer(getRootNode(SugarElement.fromDom(editor.getElement())));
	      });
	    };
	    var isDistractionFree = function (editor) {
	      return editor.inline && !isMenubarEnabled(editor) && !isToolbarEnabled(editor) && !isMultipleToolbars(editor);
	    };
	    var isStickyToolbar = function (editor) {
	      var isStickyToolbar = editor.getParam('toolbar_sticky', false, 'boolean');
	      return (isStickyToolbar || editor.inline) && !useFixedContainer(editor) && !isDistractionFree(editor);
	    };
	    var getStickyToolbarOffset = function (editor) {
	      return editor.getParam('toolbar_sticky_offset', 0, 'number');
	    };
	    var isDraggableModal$1 = function (editor) {
	      return editor.getParam('draggable_modal', false, 'boolean');
	    };
	    var getMenus = function (editor) {
	      var menu = editor.getParam('menu');
	      if (menu) {
	        return map$1(menu, function (menu) {
	          return __assign(__assign({}, menu), { items: menu.items });
	        });
	      } else {
	        return {};
	      }
	    };
	    var getMenubar = function (editor) {
	      return editor.getParam('menubar');
	    };
	    var getToolbar = function (editor) {
	      return editor.getParam('toolbar', true);
	    };
	    var getFilePickerCallback = function (editor) {
	      return editor.getParam('file_picker_callback');
	    };
	    var getFilePickerTypes = function (editor) {
	      return editor.getParam('file_picker_types');
	    };
	    var getFileBrowserCallbackTypes = function (editor) {
	      return editor.getParam('file_browser_callback_types');
	    };
	    var noTypeaheadUrls = function (editor) {
	      return editor.getParam('typeahead_urls') === false;
	    };
	    var getAnchorTop = function (editor) {
	      return editor.getParam('anchor_top', '#top');
	    };
	    var getAnchorBottom = function (editor) {
	      return editor.getParam('anchor_bottom', '#bottom');
	    };
	    var getFilePickerValidatorHandler = function (editor) {
	      var handler = editor.getParam('file_picker_validator_handler', undefined, 'function');
	      if (handler === undefined) {
	        return editor.getParam('filepicker_validator_handler', undefined, 'function');
	      } else {
	        return handler;
	      }
	    };
	
	    var ReadOnlyChannel = 'silver.readonly';
	    var ReadOnlyDataSchema = objOf([requiredBoolean('readonly')]);
	    var broadcastReadonly = function (uiComponents, readonly) {
	      var outerContainer = uiComponents.outerContainer;
	      var target = outerContainer.element;
	      if (readonly) {
	        uiComponents.mothership.broadcastOn([dismissPopups()], { target: target });
	        uiComponents.uiMothership.broadcastOn([dismissPopups()], { target: target });
	      }
	      uiComponents.mothership.broadcastOn([ReadOnlyChannel], { readonly: readonly });
	      uiComponents.uiMothership.broadcastOn([ReadOnlyChannel], { readonly: readonly });
	    };
	    var setupReadonlyModeSwitch = function (editor, uiComponents) {
	      editor.on('init', function () {
	        if (editor.mode.isReadOnly()) {
	          broadcastReadonly(uiComponents, true);
	        }
	      });
	      editor.on('SwitchMode', function () {
	        return broadcastReadonly(uiComponents, editor.mode.isReadOnly());
	      });
	      if (isReadOnly(editor)) {
	        editor.setMode('readonly');
	      }
	    };
	    var receivingConfig = function () {
	      var _a;
	      return Receiving.config({
	        channels: (_a = {}, _a[ReadOnlyChannel] = {
	          schema: ReadOnlyDataSchema,
	          onReceive: function (comp, data) {
	            Disabling.set(comp, data.readonly);
	          }
	        }, _a)
	      });
	    };
	
	    var item = function (disabled) {
	      return Disabling.config({
	        disabled: disabled,
	        disableClass: 'tox-collection__item--state-disabled'
	      });
	    };
	    var button = function (disabled) {
	      return Disabling.config({ disabled: disabled });
	    };
	    var splitButton = function (disabled) {
	      return Disabling.config({
	        disabled: disabled,
	        disableClass: 'tox-tbtn--disabled'
	      });
	    };
	    var toolbarButton = function (disabled) {
	      return Disabling.config({
	        disabled: disabled,
	        disableClass: 'tox-tbtn--disabled',
	        useNative: false
	      });
	    };
	    var DisablingConfigs = {
	      item: item,
	      button: button,
	      splitButton: splitButton,
	      toolbarButton: toolbarButton
	    };
	
	    var runWithApi = function (info, comp) {
	      var api = info.getApi(comp);
	      return function (f) {
	        f(api);
	      };
	    };
	    var onControlAttached = function (info, editorOffCell) {
	      return runOnAttached(function (comp) {
	        var run = runWithApi(info, comp);
	        run(function (api) {
	          var onDestroy = info.onSetup(api);
	          if (isFunction(onDestroy)) {
	            editorOffCell.set(onDestroy);
	          }
	        });
	      });
	    };
	    var onControlDetached = function (getApi, editorOffCell) {
	      return runOnDetached(function (comp) {
	        return runWithApi(getApi, comp)(editorOffCell.get());
	      });
	    };
	
	    var _a$1;
	    var onMenuItemExecute = function (info, itemResponse) {
	      return runOnExecute$1(function (comp, simulatedEvent) {
	        runWithApi(info, comp)(info.onAction);
	        if (!info.triggersSubmenu && itemResponse === ItemResponse$1.CLOSE_ON_EXECUTE) {
	          emit(comp, sandboxClose());
	          simulatedEvent.stop();
	        }
	      });
	    };
	    var menuItemEventOrder = (_a$1 = {}, _a$1[execute$5()] = [
	      'disabling',
	      'alloy.base.behaviour',
	      'toggling',
	      'item-events'
	    ], _a$1);
	
	    var componentRenderPipeline = cat;
	    var renderCommonItem = function (spec, structure, itemResponse, providersbackstage) {
	      var editorOffCell = Cell(noop);
	      return {
	        type: 'item',
	        dom: structure.dom,
	        components: componentRenderPipeline(structure.optComponents),
	        data: spec.data,
	        eventOrder: menuItemEventOrder,
	        hasSubmenu: spec.triggersSubmenu,
	        itemBehaviours: derive$1([
	          config('item-events', [
	            onMenuItemExecute(spec, itemResponse),
	            onControlAttached(spec, editorOffCell),
	            onControlDetached(spec, editorOffCell)
	          ]),
	          DisablingConfigs.item(function () {
	            return spec.disabled || providersbackstage.isDisabled();
	          }),
	          receivingConfig(),
	          Replacing.config({})
	        ].concat(spec.itemBehaviours))
	      };
	    };
	    var buildData = function (source) {
	      return {
	        value: source.value,
	        meta: __assign({ text: source.text.getOr('') }, source.meta)
	      };
	    };
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var convertText = function (source) {
	      var mac = {
	        alt: '&#x2325;',
	        ctrl: '&#x2303;',
	        shift: '&#x21E7;',
	        meta: '&#x2318;',
	        access: '&#x2303;&#x2325;'
	      };
	      var other = {
	        meta: 'Ctrl',
	        access: 'Shift+Alt'
	      };
	      var replace = global$9.mac ? mac : other;
	      var shortcut = source.split('+');
	      var updated = map$2(shortcut, function (segment) {
	        var search = segment.toLowerCase().trim();
	        return has$2(replace, search) ? replace[search] : segment;
	      });
	      return global$9.mac ? updated.join('') : updated.join('+');
	    };
	
	    var renderIcon$1 = function (name, icons, classes) {
	      if (classes === void 0) {
	        classes = [iconClass];
	      }
	      return render$3(name, {
	        tag: 'div',
	        classes: classes
	      }, icons);
	    };
	    var renderText = function (text) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [textClass]
	        },
	        components: [text$1(global$e.translate(text))]
	      };
	    };
	    var renderHtml = function (html, classes) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: classes,
	          innerHtml: html
	        }
	      };
	    };
	    var renderStyledText = function (style, text) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [textClass]
	        },
	        components: [{
	            dom: {
	              tag: style.tag,
	              styles: style.styles
	            },
	            components: [text$1(global$e.translate(text))]
	          }]
	      };
	    };
	    var renderShortcut = function (shortcut) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [accessoryClass],
	          innerHtml: convertText(shortcut)
	        }
	      };
	    };
	    var renderCheckmark = function (icons) {
	      return renderIcon$1('checkmark', icons, [checkmarkClass]);
	    };
	    var renderSubmenuCaret = function (icons) {
	      return renderIcon$1('chevron-right', icons, [caretClass]);
	    };
	    var renderDownwardsCaret = function (icons) {
	      return renderIcon$1('chevron-down', icons, [caretClass]);
	    };
	    var renderContainer = function (container, components) {
	      var directionClass = container.direction === 'vertical' ? containerColumnClass : containerRowClass;
	      var alignClass = container.align === 'left' ? containerAlignLeftClass : containerAlignRightClass;
	      var getValignClass = function () {
	        switch (container.valign) {
	        case 'top':
	          return containerValignTopClass;
	        case 'middle':
	          return containerValignMiddleClass;
	        case 'bottom':
	          return containerValignBottomClass;
	        }
	      };
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            containerClass,
	            directionClass,
	            alignClass,
	            getValignClass()
	          ]
	        },
	        components: components
	      };
	    };
	    var renderImage = function (src, classes, alt) {
	      return {
	        dom: {
	          tag: 'img',
	          classes: classes,
	          attributes: {
	            src: src,
	            alt: alt.getOr('')
	          }
	        }
	      };
	    };
	
	    var renderColorStructure = function (item, providerBackstage, fallbackIcon) {
	      var colorPickerCommand = 'custom';
	      var removeColorCommand = 'remove';
	      var itemText = item.ariaLabel;
	      var itemValue = item.value;
	      var iconSvg = item.iconContent.map(function (name) {
	        return getOr(name, providerBackstage.icons, fallbackIcon);
	      });
	      var getDom = function () {
	        var common = colorClass;
	        var icon = iconSvg.getOr('');
	        var attributes = itemText.map(function (text) {
	          return { title: providerBackstage.translate(text) };
	        }).getOr({});
	        var baseDom = {
	          tag: 'div',
	          attributes: attributes,
	          classes: [common]
	        };
	        if (itemValue === colorPickerCommand) {
	          return __assign(__assign({}, baseDom), {
	            tag: 'button',
	            classes: __spreadArray(__spreadArray([], baseDom.classes, true), ['tox-swatches__picker-btn'], false),
	            innerHtml: icon
	          });
	        } else if (itemValue === removeColorCommand) {
	          return __assign(__assign({}, baseDom), {
	            classes: __spreadArray(__spreadArray([], baseDom.classes, true), ['tox-swatch--remove'], false),
	            innerHtml: icon
	          });
	        } else {
	          return __assign(__assign({}, baseDom), {
	            attributes: __assign(__assign({}, baseDom.attributes), { 'data-mce-color': itemValue }),
	            styles: { 'background-color': itemValue }
	          });
	        }
	      };
	      return {
	        dom: getDom(),
	        optComponents: []
	      };
	    };
	    var renderItemDomStructure = function (ariaLabel) {
	      var domTitle = ariaLabel.map(function (label) {
	        return { attributes: { title: global$e.translate(label) } };
	      }).getOr({});
	      return __assign({
	        tag: 'div',
	        classes: [
	          navClass,
	          selectableClass
	        ]
	      }, domTitle);
	    };
	    var renderNormalItemStructure = function (info, providersBackstage, renderIcons, fallbackIcon) {
	      var iconSpec = {
	        tag: 'div',
	        classes: [iconClass]
	      };
	      var renderIcon = function (iconName) {
	        return render$3(iconName, iconSpec, providersBackstage.icons, fallbackIcon);
	      };
	      var renderEmptyIcon = function () {
	        return Optional.some({ dom: iconSpec });
	      };
	      var leftIcon = renderIcons ? info.iconContent.map(renderIcon).orThunk(renderEmptyIcon) : Optional.none();
	      var checkmark = info.checkMark;
	      var textRender = Optional.from(info.meta).fold(function () {
	        return renderText;
	      }, function (meta) {
	        return has$2(meta, 'style') ? curry(renderStyledText, meta.style) : renderText;
	      });
	      var content = info.htmlContent.fold(function () {
	        return info.textContent.map(textRender);
	      }, function (html) {
	        return Optional.some(renderHtml(html, [textClass]));
	      });
	      var menuItem = {
	        dom: renderItemDomStructure(info.ariaLabel),
	        optComponents: [
	          leftIcon,
	          content,
	          info.shortcutContent.map(renderShortcut),
	          checkmark,
	          info.caret
	        ]
	      };
	      return menuItem;
	    };
	    var renderItemStructure = function (info, providersBackstage, renderIcons, fallbackIcon) {
	      if (fallbackIcon === void 0) {
	        fallbackIcon = Optional.none();
	      }
	      if (info.presets === 'color') {
	        return renderColorStructure(info, providersBackstage, fallbackIcon);
	      } else {
	        return renderNormalItemStructure(info, providersBackstage, renderIcons, fallbackIcon);
	      }
	    };
	
	    var tooltipBehaviour = function (meta, sharedBackstage) {
	      return get$e(meta, 'tooltipWorker').map(function (tooltipWorker) {
	        return [Tooltipping.config({
	            lazySink: sharedBackstage.getSink,
	            tooltipDom: {
	              tag: 'div',
	              classes: ['tox-tooltip-worker-container']
	            },
	            tooltipComponents: [],
	            anchor: function (comp) {
	              return {
	                type: 'submenu',
	                item: comp,
	                overrides: { maxHeightFunction: expandable$1 }
	              };
	            },
	            mode: 'follow-highlight',
	            onShow: function (component, _tooltip) {
	              tooltipWorker(function (elm) {
	                Tooltipping.setComponents(component, [external$2({ element: SugarElement.fromDom(elm) })]);
	              });
	            }
	          })];
	      }).getOr([]);
	    };
	    var encodeText = function (text) {
	      return global$b.DOM.encode(text);
	    };
	    var replaceText = function (text, matchText) {
	      var translated = global$e.translate(text);
	      var encoded = encodeText(translated);
	      if (matchText.length > 0) {
	        var escapedMatchRegex = new RegExp(escape(matchText), 'gi');
	        return encoded.replace(escapedMatchRegex, function (match) {
	          return '<span class="tox-autocompleter-highlight">' + match + '</span>';
	        });
	      } else {
	        return encoded;
	      }
	    };
	    var renderAutocompleteItem = function (spec, matchText, useText, presets, onItemValueHandler, itemResponse, sharedBackstage, renderIcons) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      var structure = renderItemStructure({
	        presets: presets,
	        textContent: Optional.none(),
	        htmlContent: useText ? spec.text.map(function (text) {
	          return replaceText(text, matchText);
	        }) : Optional.none(),
	        ariaLabel: spec.text,
	        iconContent: spec.icon,
	        shortcutContent: Optional.none(),
	        checkMark: Optional.none(),
	        caret: Optional.none(),
	        value: spec.value
	      }, sharedBackstage.providers, renderIcons, spec.icon);
	      return renderCommonItem({
	        data: buildData(spec),
	        disabled: spec.disabled,
	        getApi: constant$1({}),
	        onAction: function (_api) {
	          return onItemValueHandler(spec.value, spec.meta);
	        },
	        onSetup: constant$1(noop),
	        triggersSubmenu: false,
	        itemBehaviours: tooltipBehaviour(spec.meta, sharedBackstage)
	      }, structure, itemResponse, sharedBackstage.providers);
	    };
	
	    var render$2 = function (items, extras) {
	      return map$2(items, function (item) {
	        switch (item.type) {
	        case 'cardcontainer':
	          return renderContainer(item, render$2(item.items, extras));
	        case 'cardimage':
	          return renderImage(item.src, item.classes, item.alt);
	        case 'cardtext':
	          var shouldHighlight = item.name.exists(function (name) {
	            return contains$2(extras.cardText.highlightOn, name);
	          });
	          var matchText = shouldHighlight ? Optional.from(extras.cardText.matchText).getOr('') : '';
	          return renderHtml(replaceText(item.text, matchText), item.classes);
	        }
	      });
	    };
	    var renderCardMenuItem = function (spec, itemResponse, sharedBackstage, extras) {
	      var getApi = function (component) {
	        return {
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            Disabling.set(component, state);
	            each$1(descendants(component.element, '*'), function (elm) {
	              component.getSystem().getByDom(elm).each(function (comp) {
	                if (comp.hasConfigured(Disabling)) {
	                  Disabling.set(comp, state);
	                }
	              });
	            });
	          }
	        };
	      };
	      var structure = {
	        dom: renderItemDomStructure(spec.label),
	        optComponents: [Optional.some({
	            dom: {
	              tag: 'div',
	              classes: [
	                containerClass,
	                containerRowClass
	              ]
	            },
	            components: render$2(spec.items, extras)
	          })]
	      };
	      return renderCommonItem({
	        data: buildData(__assign({ text: Optional.none() }, spec)),
	        disabled: spec.disabled,
	        getApi: getApi,
	        onAction: spec.onAction,
	        onSetup: spec.onSetup,
	        triggersSubmenu: false,
	        itemBehaviours: Optional.from(extras.itemBehaviours).getOr([])
	      }, structure, itemResponse, sharedBackstage.providers);
	    };
	
	    var renderChoiceItem = function (spec, useText, presets, onItemValueHandler, isSelected, itemResponse, providersBackstage, renderIcons) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      var getApi = function (component) {
	        return {
	          setActive: function (state) {
	            Toggling.set(component, state);
	          },
	          isActive: function () {
	            return Toggling.isOn(component);
	          },
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(component, state);
	          }
	        };
	      };
	      var structure = renderItemStructure({
	        presets: presets,
	        textContent: useText ? spec.text : Optional.none(),
	        htmlContent: Optional.none(),
	        ariaLabel: spec.text,
	        iconContent: spec.icon,
	        shortcutContent: useText ? spec.shortcut : Optional.none(),
	        checkMark: useText ? Optional.some(renderCheckmark(providersBackstage.icons)) : Optional.none(),
	        caret: Optional.none(),
	        value: spec.value
	      }, providersBackstage, renderIcons);
	      return deepMerge(renderCommonItem({
	        data: buildData(spec),
	        disabled: spec.disabled,
	        getApi: getApi,
	        onAction: function (_api) {
	          return onItemValueHandler(spec.value);
	        },
	        onSetup: function (api) {
	          api.setActive(isSelected);
	          return noop;
	        },
	        triggersSubmenu: false,
	        itemBehaviours: []
	      }, structure, itemResponse, providersBackstage), {
	        toggling: {
	          toggleClass: tickedClass,
	          toggleOnExecute: false,
	          selected: spec.active
	        }
	      });
	    };
	
	    var parts$f = generate$3(owner$2(), parts$h());
	
	    var hexColour = function (value) {
	      return { value: value };
	    };
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    var longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
	    var isHexString = function (hex) {
	      return shorthandRegex.test(hex) || longformRegex.test(hex);
	    };
	    var normalizeHex = function (hex) {
	      return removeLeading(hex, '#').toUpperCase();
	    };
	    var fromString$1 = function (hex) {
	      return isHexString(hex) ? Optional.some({ value: normalizeHex(hex) }) : Optional.none();
	    };
	    var getLongForm = function (hex) {
	      var hexString = hex.value.replace(shorthandRegex, function (m, r, g, b) {
	        return r + r + g + g + b + b;
	      });
	      return { value: hexString };
	    };
	    var extractValues = function (hex) {
	      var longForm = getLongForm(hex);
	      var splitForm = longformRegex.exec(longForm.value);
	      return splitForm === null ? [
	        'FFFFFF',
	        'FF',
	        'FF',
	        'FF'
	      ] : splitForm;
	    };
	    var toHex = function (component) {
	      var hex = component.toString(16);
	      return (hex.length === 1 ? '0' + hex : hex).toUpperCase();
	    };
	    var fromRgba = function (rgbaColour) {
	      var value = toHex(rgbaColour.red) + toHex(rgbaColour.green) + toHex(rgbaColour.blue);
	      return hexColour(value);
	    };
	
	    var min = Math.min;
	    var max = Math.max;
	    var round$1 = Math.round;
	    var rgbRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
	    var rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d?(?:\.\d+)?)\)/;
	    var rgbaColour = function (red, green, blue, alpha) {
	      return {
	        red: red,
	        green: green,
	        blue: blue,
	        alpha: alpha
	      };
	    };
	    var isRgbaComponent = function (value) {
	      var num = parseInt(value, 10);
	      return num.toString() === value && num >= 0 && num <= 255;
	    };
	    var fromHsv = function (hsv) {
	      var r;
	      var g;
	      var b;
	      var hue = (hsv.hue || 0) % 360;
	      var saturation = hsv.saturation / 100;
	      var brightness = hsv.value / 100;
	      saturation = max(0, min(saturation, 1));
	      brightness = max(0, min(brightness, 1));
	      if (saturation === 0) {
	        r = g = b = round$1(255 * brightness);
	        return rgbaColour(r, g, b, 1);
	      }
	      var side = hue / 60;
	      var chroma = brightness * saturation;
	      var x = chroma * (1 - Math.abs(side % 2 - 1));
	      var match = brightness - chroma;
	      switch (Math.floor(side)) {
	      case 0:
	        r = chroma;
	        g = x;
	        b = 0;
	        break;
	      case 1:
	        r = x;
	        g = chroma;
	        b = 0;
	        break;
	      case 2:
	        r = 0;
	        g = chroma;
	        b = x;
	        break;
	      case 3:
	        r = 0;
	        g = x;
	        b = chroma;
	        break;
	      case 4:
	        r = x;
	        g = 0;
	        b = chroma;
	        break;
	      case 5:
	        r = chroma;
	        g = 0;
	        b = x;
	        break;
	      default:
	        r = g = b = 0;
	      }
	      r = round$1(255 * (r + match));
	      g = round$1(255 * (g + match));
	      b = round$1(255 * (b + match));
	      return rgbaColour(r, g, b, 1);
	    };
	    var fromHex = function (hexColour) {
	      var result = extractValues(hexColour);
	      var red = parseInt(result[1], 16);
	      var green = parseInt(result[2], 16);
	      var blue = parseInt(result[3], 16);
	      return rgbaColour(red, green, blue, 1);
	    };
	    var fromStringValues = function (red, green, blue, alpha) {
	      var r = parseInt(red, 10);
	      var g = parseInt(green, 10);
	      var b = parseInt(blue, 10);
	      var a = parseFloat(alpha);
	      return rgbaColour(r, g, b, a);
	    };
	    var fromString = function (rgbaString) {
	      if (rgbaString === 'transparent') {
	        return Optional.some(rgbaColour(0, 0, 0, 0));
	      }
	      var rgbMatch = rgbRegex.exec(rgbaString);
	      if (rgbMatch !== null) {
	        return Optional.some(fromStringValues(rgbMatch[1], rgbMatch[2], rgbMatch[3], '1'));
	      }
	      var rgbaMatch = rgbaRegex.exec(rgbaString);
	      if (rgbaMatch !== null) {
	        return Optional.some(fromStringValues(rgbaMatch[1], rgbaMatch[2], rgbaMatch[3], rgbaMatch[4]));
	      }
	      return Optional.none();
	    };
	    var toString = function (rgba) {
	      return 'rgba(' + rgba.red + ',' + rgba.green + ',' + rgba.blue + ',' + rgba.alpha + ')';
	    };
	    var red = rgbaColour(255, 0, 0, 1);
	
	    var fireSkinLoaded$1 = function (editor) {
	      return editor.fire('SkinLoaded');
	    };
	    var fireSkinLoadError$1 = function (editor, error) {
	      return editor.fire('SkinLoadError', error);
	    };
	    var fireResizeEditor = function (editor) {
	      return editor.fire('ResizeEditor');
	    };
	    var fireResizeContent = function (editor, e) {
	      return editor.fire('ResizeContent', e);
	    };
	    var fireScrollContent = function (editor, e) {
	      return editor.fire('ScrollContent', e);
	    };
	    var fireTextColorChange = function (editor, data) {
	      return editor.fire('TextColorChange', data);
	    };
	
	    var hsvColour = function (hue, saturation, value) {
	      return {
	        hue: hue,
	        saturation: saturation,
	        value: value
	      };
	    };
	    var fromRgb = function (rgbaColour) {
	      var h = 0;
	      var s = 0;
	      var v = 0;
	      var r = rgbaColour.red / 255;
	      var g = rgbaColour.green / 255;
	      var b = rgbaColour.blue / 255;
	      var minRGB = Math.min(r, Math.min(g, b));
	      var maxRGB = Math.max(r, Math.max(g, b));
	      if (minRGB === maxRGB) {
	        v = minRGB;
	        return hsvColour(0, 0, v * 100);
	      }
	      var d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
	      h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
	      h = 60 * (h - d / (maxRGB - minRGB));
	      s = (maxRGB - minRGB) / maxRGB;
	      v = maxRGB;
	      return hsvColour(Math.round(h), Math.round(s * 100), Math.round(v * 100));
	    };
	
	    var hexToHsv = function (hex) {
	      return fromRgb(fromHex(hex));
	    };
	    var hsvToHex = function (hsv) {
	      return fromRgba(fromHsv(hsv));
	    };
	    var anyToHex = function (color) {
	      return fromString$1(color).orThunk(function () {
	        return fromString(color).map(fromRgba);
	      }).getOrThunk(function () {
	        var canvas = document.createElement('canvas');
	        canvas.height = 1;
	        canvas.width = 1;
	        var canvasContext = canvas.getContext('2d');
	        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
	        canvasContext.fillStyle = '#FFFFFF';
	        canvasContext.fillStyle = color;
	        canvasContext.fillRect(0, 0, 1, 1);
	        var rgba = canvasContext.getImageData(0, 0, 1, 1).data;
	        var r = rgba[0];
	        var g = rgba[1];
	        var b = rgba[2];
	        var a = rgba[3];
	        return fromRgba(rgbaColour(r, g, b, a));
	      });
	    };
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.util.LocalStorage');
	
	    var storageName = 'tinymce-custom-colors';
	    function ColorCache (max) {
	      if (max === void 0) {
	        max = 10;
	      }
	      var storageString = global$8.getItem(storageName);
	      var localstorage = isString(storageString) ? JSON.parse(storageString) : [];
	      var prune = function (list) {
	        var diff = max - list.length;
	        return diff < 0 ? list.slice(0, max) : list;
	      };
	      var cache = prune(localstorage);
	      var add = function (key) {
	        indexOf(cache, key).each(remove);
	        cache.unshift(key);
	        if (cache.length > max) {
	          cache.pop();
	        }
	        global$8.setItem(storageName, JSON.stringify(cache));
	      };
	      var remove = function (idx) {
	        cache.splice(idx, 1);
	      };
	      var state = function () {
	        return cache.slice(0);
	      };
	      return {
	        add: add,
	        state: state
	      };
	    }
	
	    var choiceItem = 'choiceitem';
	    var defaultColors = [
	      {
	        type: choiceItem,
	        text: 'Light Green',
	        value: '#BFEDD2'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Yellow',
	        value: '#FBEEB8'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Red',
	        value: '#F8CAC6'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Purple',
	        value: '#ECCAFA'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Blue',
	        value: '#C2E0F4'
	      },
	      {
	        type: choiceItem,
	        text: 'Green',
	        value: '#2DC26B'
	      },
	      {
	        type: choiceItem,
	        text: 'Yellow',
	        value: '#F1C40F'
	      },
	      {
	        type: choiceItem,
	        text: 'Red',
	        value: '#E03E2D'
	      },
	      {
	        type: choiceItem,
	        text: 'Purple',
	        value: '#B96AD9'
	      },
	      {
	        type: choiceItem,
	        text: 'Blue',
	        value: '#3598DB'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Turquoise',
	        value: '#169179'
	      },
	      {
	        type: choiceItem,
	        text: 'Orange',
	        value: '#E67E23'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Red',
	        value: '#BA372A'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Purple',
	        value: '#843FA1'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Blue',
	        value: '#236FA1'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Gray',
	        value: '#ECF0F1'
	      },
	      {
	        type: choiceItem,
	        text: 'Medium Gray',
	        value: '#CED4D9'
	      },
	      {
	        type: choiceItem,
	        text: 'Gray',
	        value: '#95A5A6'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Gray',
	        value: '#7E8C8D'
	      },
	      {
	        type: choiceItem,
	        text: 'Navy Blue',
	        value: '#34495E'
	      },
	      {
	        type: choiceItem,
	        text: 'Black',
	        value: '#000000'
	      },
	      {
	        type: choiceItem,
	        text: 'White',
	        value: '#ffffff'
	      }
	    ];
	    var colorCache = ColorCache(10);
	    var mapColors = function (colorMap) {
	      var colors = [];
	      for (var i = 0; i < colorMap.length; i += 2) {
	        colors.push({
	          text: colorMap[i + 1],
	          value: '#' + anyToHex(colorMap[i]).value,
	          type: 'choiceitem'
	        });
	      }
	      return colors;
	    };
	    var getColorCols$2 = function (editor, defaultCols) {
	      return editor.getParam('color_cols', defaultCols, 'number');
	    };
	    var hasCustomColors$1 = function (editor) {
	      return editor.getParam('custom_colors') !== false;
	    };
	    var getColorMap = function (editor) {
	      return editor.getParam('color_map');
	    };
	    var getColors$2 = function (editor) {
	      var unmapped = getColorMap(editor);
	      return unmapped !== undefined ? mapColors(unmapped) : defaultColors;
	    };
	    var getCurrentColors = function () {
	      return map$2(colorCache.state(), function (color) {
	        return {
	          type: choiceItem,
	          text: color,
	          value: color
	        };
	      });
	    };
	    var addColor = function (color) {
	      colorCache.add(color);
	    };
	
	    var fallbackColor = '#000000';
	    var getCurrentColor = function (editor, format) {
	      var color;
	      editor.dom.getParents(editor.selection.getStart(), function (elm) {
	        var value;
	        if (value = elm.style[format === 'forecolor' ? 'color' : 'background-color']) {
	          color = color ? color : value;
	        }
	      });
	      return Optional.from(color);
	    };
	    var applyFormat = function (editor, format, value) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.apply(format, { value: value });
	        editor.nodeChanged();
	      });
	    };
	    var removeFormat = function (editor, format) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.remove(format, { value: null }, null, true);
	        editor.nodeChanged();
	      });
	    };
	    var registerCommands = function (editor) {
	      editor.addCommand('mceApplyTextcolor', function (format, value) {
	        applyFormat(editor, format, value);
	      });
	      editor.addCommand('mceRemoveTextcolor', function (format) {
	        removeFormat(editor, format);
	      });
	    };
	    var calcCols = function (colors) {
	      return Math.max(5, Math.ceil(Math.sqrt(colors)));
	    };
	    var getColorCols$1 = function (editor) {
	      var colors = getColors$2(editor);
	      var defaultCols = calcCols(colors.length);
	      return getColorCols$2(editor, defaultCols);
	    };
	    var getAdditionalColors = function (hasCustom) {
	      var type = 'choiceitem';
	      var remove = {
	        type: type,
	        text: 'Remove color',
	        icon: 'color-swatch-remove-color',
	        value: 'remove'
	      };
	      var custom = {
	        type: type,
	        text: 'Custom color',
	        icon: 'color-picker',
	        value: 'custom'
	      };
	      return hasCustom ? [
	        remove,
	        custom
	      ] : [remove];
	    };
	    var applyColor = function (editor, format, value, onChoice) {
	      if (value === 'custom') {
	        var dialog = colorPickerDialog(editor);
	        dialog(function (colorOpt) {
	          colorOpt.each(function (color) {
	            addColor(color);
	            editor.execCommand('mceApplyTextcolor', format, color);
	            onChoice(color);
	          });
	        }, fallbackColor);
	      } else if (value === 'remove') {
	        onChoice('');
	        editor.execCommand('mceRemoveTextcolor', format);
	      } else {
	        onChoice(value);
	        editor.execCommand('mceApplyTextcolor', format, value);
	      }
	    };
	    var getColors$1 = function (colors, hasCustom) {
	      return colors.concat(getCurrentColors().concat(getAdditionalColors(hasCustom)));
	    };
	    var getFetch$1 = function (colors, hasCustom) {
	      return function (callback) {
	        callback(getColors$1(colors, hasCustom));
	      };
	    };
	    var setIconColor = function (splitButtonApi, name, newColor) {
	      var id = name === 'forecolor' ? 'tox-icon-text-color__color' : 'tox-icon-highlight-bg-color__color';
	      splitButtonApi.setIconFill(id, newColor);
	    };
	    var registerTextColorButton = function (editor, name, format, tooltip, lastColor) {
	      editor.ui.registry.addSplitButton(name, {
	        tooltip: tooltip,
	        presets: 'color',
	        icon: name === 'forecolor' ? 'text-color' : 'highlight-bg-color',
	        select: function (value) {
	          var optCurrentRgb = getCurrentColor(editor, format);
	          return optCurrentRgb.bind(function (currentRgb) {
	            return fromString(currentRgb).map(function (rgba) {
	              var currentHex = fromRgba(rgba).value;
	              return contains$1(value.toLowerCase(), currentHex);
	            });
	          }).getOr(false);
	        },
	        columns: getColorCols$1(editor),
	        fetch: getFetch$1(getColors$2(editor), hasCustomColors$1(editor)),
	        onAction: function (_splitButtonApi) {
	          applyColor(editor, format, lastColor.get(), noop);
	        },
	        onItemAction: function (_splitButtonApi, value) {
	          applyColor(editor, format, value, function (newColor) {
	            lastColor.set(newColor);
	            fireTextColorChange(editor, {
	              name: name,
	              color: newColor
	            });
	          });
	        },
	        onSetup: function (splitButtonApi) {
	          setIconColor(splitButtonApi, name, lastColor.get());
	          var handler = function (e) {
	            if (e.name === name) {
	              setIconColor(splitButtonApi, e.name, e.color);
	            }
	          };
	          editor.on('TextColorChange', handler);
	          return function () {
	            editor.off('TextColorChange', handler);
	          };
	        }
	      });
	    };
	    var registerTextColorMenuItem = function (editor, name, format, text) {
	      editor.ui.registry.addNestedMenuItem(name, {
	        text: text,
	        icon: name === 'forecolor' ? 'text-color' : 'highlight-bg-color',
	        getSubmenuItems: function () {
	          return [{
	              type: 'fancymenuitem',
	              fancytype: 'colorswatch',
	              onAction: function (data) {
	                applyColor(editor, format, data.value, noop);
	              }
	            }];
	        }
	      });
	    };
	    var colorPickerDialog = function (editor) {
	      return function (callback, value) {
	        var isValid = false;
	        var onSubmit = function (api) {
	          var data = api.getData();
	          var hex = data.colorpicker;
	          if (isValid) {
	            callback(Optional.from(hex));
	            api.close();
	          } else {
	            editor.windowManager.alert(editor.translate([
	              'Invalid hex color code: {0}',
	              hex
	            ]));
	          }
	        };
	        var onAction = function (_api, details) {
	          if (details.name === 'hex-valid') {
	            isValid = details.value;
	          }
	        };
	        var initialData = { colorpicker: value };
	        editor.windowManager.open({
	          title: 'Color Picker',
	          size: 'normal',
	          body: {
	            type: 'panel',
	            items: [{
	                type: 'colorpicker',
	                name: 'colorpicker',
	                label: 'Color'
	              }]
	          },
	          buttons: [
	            {
	              type: 'cancel',
	              name: 'cancel',
	              text: 'Cancel'
	            },
	            {
	              type: 'submit',
	              name: 'save',
	              text: 'Save',
	              primary: true
	            }
	          ],
	          initialData: initialData,
	          onAction: onAction,
	          onSubmit: onSubmit,
	          onClose: noop,
	          onCancel: function () {
	            callback(Optional.none());
	          }
	        });
	      };
	    };
	    var register$a = function (editor) {
	      registerCommands(editor);
	      var lastForeColor = Cell(fallbackColor);
	      var lastBackColor = Cell(fallbackColor);
	      registerTextColorButton(editor, 'forecolor', 'forecolor', 'Text color', lastForeColor);
	      registerTextColorButton(editor, 'backcolor', 'hilitecolor', 'Background color', lastBackColor);
	      registerTextColorMenuItem(editor, 'forecolor', 'forecolor', 'Text color');
	      registerTextColorMenuItem(editor, 'backcolor', 'hilitecolor', 'Background color');
	    };
	
	    var createPartialChoiceMenu = function (value, items, onItemValueHandler, columns, presets, itemResponse, select, providersBackstage) {
	      var hasIcons = menuHasIcons(items);
	      var presetItemTypes = presets !== 'color' ? 'normal' : 'color';
	      var alloyItems = createChoiceItems(items, onItemValueHandler, columns, presetItemTypes, itemResponse, select, providersBackstage);
	      return createPartialMenuWithAlloyItems(value, hasIcons, alloyItems, columns, presets);
	    };
	    var createChoiceItems = function (items, onItemValueHandler, columns, itemPresets, itemResponse, select, providersBackstage) {
	      return cat(map$2(items, function (item) {
	        if (item.type === 'choiceitem') {
	          return createChoiceMenuItem(item).fold(handleError, function (d) {
	            return Optional.some(renderChoiceItem(d, columns === 1, itemPresets, onItemValueHandler, select(item.value), itemResponse, providersBackstage, menuHasIcons(items)));
	          });
	        } else {
	          return Optional.none();
	        }
	      }));
	    };
	
	    var deriveMenuMovement = function (columns, presets) {
	      var menuMarkers = markers(presets);
	      if (columns === 1) {
	        return {
	          mode: 'menu',
	          moveOnTab: true
	        };
	      } else if (columns === 'auto') {
	        return {
	          mode: 'grid',
	          selector: '.' + menuMarkers.item,
	          initSize: {
	            numColumns: 1,
	            numRows: 1
	          }
	        };
	      } else {
	        var rowClass = presets === 'color' ? 'tox-swatches__row' : 'tox-collection__group';
	        return {
	          mode: 'matrix',
	          rowSelector: '.' + rowClass
	        };
	      }
	    };
	    var deriveCollectionMovement = function (columns, presets) {
	      if (columns === 1) {
	        return {
	          mode: 'menu',
	          moveOnTab: false,
	          selector: '.tox-collection__item'
	        };
	      } else if (columns === 'auto') {
	        return {
	          mode: 'flatgrid',
	          selector: '.' + 'tox-collection__item',
	          initSize: {
	            numColumns: 1,
	            numRows: 1
	          }
	        };
	      } else {
	        return {
	          mode: 'matrix',
	          selectors: {
	            row: presets === 'color' ? '.tox-swatches__row' : '.tox-collection__group',
	            cell: presets === 'color' ? '.' + colorClass : '.' + selectableClass
	          }
	        };
	      }
	    };
	
	    var renderColorSwatchItem = function (spec, backstage) {
	      var items = getColorItems(spec, backstage);
	      var columns = backstage.colorinput.getColorCols();
	      var presets = 'color';
	      var menuSpec = createPartialChoiceMenu(generate$6('menu-value'), items, function (value) {
	        spec.onAction({ value: value });
	      }, columns, presets, ItemResponse$1.CLOSE_ON_EXECUTE, never, backstage.shared.providers);
	      var widgetSpec = __assign(__assign({}, menuSpec), {
	        markers: markers(presets),
	        movement: deriveMenuMovement(columns, presets)
	      });
	      return {
	        type: 'widget',
	        data: { value: generate$6('widget-id') },
	        dom: {
	          tag: 'div',
	          classes: ['tox-fancymenuitem']
	        },
	        autofocus: true,
	        components: [parts$f.widget(Menu.sketch(widgetSpec))]
	      };
	    };
	    var getColorItems = function (spec, backstage) {
	      var useCustomColors = spec.initData.allowCustomColors && backstage.colorinput.hasCustomColors();
	      return spec.initData.colors.fold(function () {
	        return getColors$1(backstage.colorinput.getColors(), useCustomColors);
	      }, function (colors) {
	        return colors.concat(getAdditionalColors(useCustomColors));
	      });
	    };
	
	    var cellOverEvent = generate$6('cell-over');
	    var cellExecuteEvent = generate$6('cell-execute');
	    var makeCell = function (row, col, labelId) {
	      var _a;
	      var emitCellOver = function (c) {
	        return emitWith(c, cellOverEvent, {
	          row: row,
	          col: col
	        });
	      };
	      var emitExecute = function (c) {
	        return emitWith(c, cellExecuteEvent, {
	          row: row,
	          col: col
	        });
	      };
	      var onClick = function (c, se) {
	        se.stop();
	        emitExecute(c);
	      };
	      return build$1({
	        dom: {
	          tag: 'div',
	          attributes: (_a = { role: 'button' }, _a['aria-labelledby'] = labelId, _a)
	        },
	        behaviours: derive$1([
	          config('insert-table-picker-cell', [
	            run$1(mouseover(), Focusing.focus),
	            run$1(execute$5(), emitExecute),
	            run$1(click(), onClick),
	            run$1(tap(), onClick)
	          ]),
	          Toggling.config({
	            toggleClass: 'tox-insert-table-picker__selected',
	            toggleOnExecute: false
	          }),
	          Focusing.config({ onFocus: emitCellOver })
	        ])
	      });
	    };
	    var makeCells = function (labelId, numRows, numCols) {
	      var cells = [];
	      for (var i = 0; i < numRows; i++) {
	        var row = [];
	        for (var j = 0; j < numCols; j++) {
	          row.push(makeCell(i, j, labelId));
	        }
	        cells.push(row);
	      }
	      return cells;
	    };
	    var selectCells = function (cells, selectedRow, selectedColumn, numRows, numColumns) {
	      for (var i = 0; i < numRows; i++) {
	        for (var j = 0; j < numColumns; j++) {
	          Toggling.set(cells[i][j], i <= selectedRow && j <= selectedColumn);
	        }
	      }
	    };
	    var makeComponents = function (cells) {
	      return bind$3(cells, function (cellRow) {
	        return map$2(cellRow, premade);
	      });
	    };
	    var makeLabelText = function (row, col) {
	      return text$1(col + 'x' + row);
	    };
	    var renderInsertTableMenuItem = function (spec) {
	      var numRows = 10;
	      var numColumns = 10;
	      var sizeLabelId = generate$6('size-label');
	      var cells = makeCells(sizeLabelId, numRows, numColumns);
	      var emptyLabelText = makeLabelText(0, 0);
	      var memLabel = record({
	        dom: {
	          tag: 'span',
	          classes: ['tox-insert-table-picker__label'],
	          attributes: { id: sizeLabelId }
	        },
	        components: [emptyLabelText],
	        behaviours: derive$1([Replacing.config({})])
	      });
	      return {
	        type: 'widget',
	        data: { value: generate$6('widget-id') },
	        dom: {
	          tag: 'div',
	          classes: ['tox-fancymenuitem']
	        },
	        autofocus: true,
	        components: [parts$f.widget({
	            dom: {
	              tag: 'div',
	              classes: ['tox-insert-table-picker']
	            },
	            components: makeComponents(cells).concat(memLabel.asSpec()),
	            behaviours: derive$1([
	              config('insert-table-picker', [
	                runOnAttached(function (c) {
	                  Replacing.set(memLabel.get(c), [emptyLabelText]);
	                }),
	                runWithTarget(cellOverEvent, function (c, t, e) {
	                  var _a = e.event, row = _a.row, col = _a.col;
	                  selectCells(cells, row, col, numRows, numColumns);
	                  Replacing.set(memLabel.get(c), [makeLabelText(row + 1, col + 1)]);
	                }),
	                runWithTarget(cellExecuteEvent, function (c, _, e) {
	                  var _a = e.event, row = _a.row, col = _a.col;
	                  spec.onAction({
	                    numRows: row + 1,
	                    numColumns: col + 1
	                  });
	                  emit(c, sandboxClose());
	                })
	              ]),
	              Keying.config({
	                initSize: {
	                  numRows: numRows,
	                  numColumns: numColumns
	                },
	                mode: 'flatgrid',
	                selector: '[role="button"]'
	              })
	            ])
	          })]
	      };
	    };
	
	    var fancyMenuItems = {
	      inserttable: renderInsertTableMenuItem,
	      colorswatch: renderColorSwatchItem
	    };
	    var renderFancyMenuItem = function (spec, backstage) {
	      return get$e(fancyMenuItems, spec.fancytype).map(function (render) {
	        return render(spec, backstage);
	      });
	    };
	
	    var renderNestedItem = function (spec, itemResponse, providersBackstage, renderIcons, downwardsCaret) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      if (downwardsCaret === void 0) {
	        downwardsCaret = false;
	      }
	      var caret = downwardsCaret ? renderDownwardsCaret(providersBackstage.icons) : renderSubmenuCaret(providersBackstage.icons);
	      var getApi = function (component) {
	        return {
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(component, state);
	          }
	        };
	      };
	      var structure = renderItemStructure({
	        presets: 'normal',
	        iconContent: spec.icon,
	        textContent: spec.text,
	        htmlContent: Optional.none(),
	        ariaLabel: spec.text,
	        caret: Optional.some(caret),
	        checkMark: Optional.none(),
	        shortcutContent: spec.shortcut
	      }, providersBackstage, renderIcons);
	      return renderCommonItem({
	        data: buildData(spec),
	        getApi: getApi,
	        disabled: spec.disabled,
	        onAction: noop,
	        onSetup: spec.onSetup,
	        triggersSubmenu: true,
	        itemBehaviours: []
	      }, structure, itemResponse, providersBackstage);
	    };
	
	    var renderNormalItem = function (spec, itemResponse, providersBackstage, renderIcons) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      var getApi = function (component) {
	        return {
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(component, state);
	          }
	        };
	      };
	      var structure = renderItemStructure({
	        presets: 'normal',
	        iconContent: spec.icon,
	        textContent: spec.text,
	        htmlContent: Optional.none(),
	        ariaLabel: spec.text,
	        caret: Optional.none(),
	        checkMark: Optional.none(),
	        shortcutContent: spec.shortcut
	      }, providersBackstage, renderIcons);
	      return renderCommonItem({
	        data: buildData(spec),
	        getApi: getApi,
	        disabled: spec.disabled,
	        onAction: spec.onAction,
	        onSetup: spec.onSetup,
	        triggersSubmenu: false,
	        itemBehaviours: []
	      }, structure, itemResponse, providersBackstage);
	    };
	
	    var renderSeparatorItem = function (spec) {
	      var innerHtml = spec.text.fold(function () {
	        return {};
	      }, function (text) {
	        return { innerHtml: text };
	      });
	      return {
	        type: 'separator',
	        dom: __assign({
	          tag: 'div',
	          classes: [
	            selectableClass,
	            groupHeadingClass
	          ]
	        }, innerHtml),
	        components: []
	      };
	    };
	
	    var renderToggleMenuItem = function (spec, itemResponse, providersBackstage, renderIcons) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      var getApi = function (component) {
	        return {
	          setActive: function (state) {
	            Toggling.set(component, state);
	          },
	          isActive: function () {
	            return Toggling.isOn(component);
	          },
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(component, state);
	          }
	        };
	      };
	      var structure = renderItemStructure({
	        iconContent: spec.icon,
	        textContent: spec.text,
	        htmlContent: Optional.none(),
	        ariaLabel: spec.text,
	        checkMark: Optional.some(renderCheckmark(providersBackstage.icons)),
	        caret: Optional.none(),
	        shortcutContent: spec.shortcut,
	        presets: 'normal',
	        meta: spec.meta
	      }, providersBackstage, renderIcons);
	      return deepMerge(renderCommonItem({
	        data: buildData(spec),
	        disabled: spec.disabled,
	        getApi: getApi,
	        onAction: spec.onAction,
	        onSetup: spec.onSetup,
	        triggersSubmenu: false,
	        itemBehaviours: []
	      }, structure, itemResponse, providersBackstage), {
	        toggling: {
	          toggleClass: tickedClass,
	          toggleOnExecute: false,
	          selected: spec.active
	        }
	      });
	    };
	
	    var autocomplete = renderAutocompleteItem;
	    var separator$3 = renderSeparatorItem;
	    var normal = renderNormalItem;
	    var nested = renderNestedItem;
	    var toggle$1 = renderToggleMenuItem;
	    var fancy = renderFancyMenuItem;
	    var card = renderCardMenuItem;
	
	    var FocusMode;
	    (function (FocusMode) {
	      FocusMode[FocusMode['ContentFocus'] = 0] = 'ContentFocus';
	      FocusMode[FocusMode['UiFocus'] = 1] = 'UiFocus';
	    }(FocusMode || (FocusMode = {})));
	    var createMenuItemFromBridge = function (item, itemResponse, backstage, menuHasIcons, isHorizontalMenu) {
	      var providersBackstage = backstage.shared.providers;
	      var parseForHorizontalMenu = function (menuitem) {
	        return !isHorizontalMenu ? menuitem : __assign(__assign({}, menuitem), {
	          shortcut: Optional.none(),
	          icon: menuitem.text.isSome() ? Optional.none() : menuitem.icon
	        });
	      };
	      switch (item.type) {
	      case 'menuitem':
	        return createMenuItem(item).fold(handleError, function (d) {
	          return Optional.some(normal(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons));
	        });
	      case 'nestedmenuitem':
	        return createNestedMenuItem(item).fold(handleError, function (d) {
	          return Optional.some(nested(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons, isHorizontalMenu));
	        });
	      case 'togglemenuitem':
	        return createToggleMenuItem(item).fold(handleError, function (d) {
	          return Optional.some(toggle$1(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons));
	        });
	      case 'separator':
	        return createSeparatorMenuItem(item).fold(handleError, function (d) {
	          return Optional.some(separator$3(d));
	        });
	      case 'fancymenuitem':
	        return createFancyMenuItem(item).fold(handleError, function (d) {
	          return fancy(parseForHorizontalMenu(d), backstage);
	        });
	      default: {
	          console.error('Unknown item in general menu', item);
	          return Optional.none();
	        }
	      }
	    };
	    var createAutocompleteItems = function (items, matchText, onItemValueHandler, columns, itemResponse, sharedBackstage, highlightOn) {
	      var renderText = columns === 1;
	      var renderIcons = !renderText || menuHasIcons(items);
	      return cat(map$2(items, function (item) {
	        switch (item.type) {
	        case 'separator':
	          return createSeparatorItem(item).fold(handleError, function (d) {
	            return Optional.some(separator$3(d));
	          });
	        case 'cardmenuitem':
	          return createCardMenuItem(item).fold(handleError, function (d) {
	            return Optional.some(card(__assign(__assign({}, d), {
	              onAction: function (api) {
	                d.onAction(api);
	                onItemValueHandler(d.value, d.meta);
	              }
	            }), itemResponse, sharedBackstage, {
	              itemBehaviours: tooltipBehaviour(d.meta, sharedBackstage),
	              cardText: {
	                matchText: matchText,
	                highlightOn: highlightOn
	              }
	            }));
	          });
	        case 'autocompleteitem':
	        default:
	          return createAutocompleterItem(item).fold(handleError, function (d) {
	            return Optional.some(autocomplete(d, matchText, renderText, 'normal', onItemValueHandler, itemResponse, sharedBackstage, renderIcons));
	          });
	        }
	      }));
	    };
	    var createPartialMenu = function (value, items, itemResponse, backstage, isHorizontalMenu) {
	      var hasIcons = menuHasIcons(items);
	      var alloyItems = cat(map$2(items, function (item) {
	        var itemHasIcon = function (i) {
	          return isHorizontalMenu ? !has$2(i, 'text') : hasIcons;
	        };
	        var createItem = function (i) {
	          return createMenuItemFromBridge(i, itemResponse, backstage, itemHasIcon(i), isHorizontalMenu);
	        };
	        if (item.type === 'nestedmenuitem' && item.getSubmenuItems().length <= 0) {
	          return createItem(__assign(__assign({}, item), { disabled: true }));
	        } else {
	          return createItem(item);
	        }
	      }));
	      var createPartial = isHorizontalMenu ? createHorizontalPartialMenuWithAlloyItems : createPartialMenuWithAlloyItems;
	      return createPartial(value, hasIcons, alloyItems, 1, 'normal');
	    };
	    var createTieredDataFrom = function (partialMenu) {
	      return tieredMenu.singleData(partialMenu.value, partialMenu);
	    };
	    var createMenuFrom = function (partialMenu, columns, focusMode, presets) {
	      var focusManager = focusMode === FocusMode.ContentFocus ? highlights() : dom$2();
	      var movement = deriveMenuMovement(columns, presets);
	      var menuMarkers = markers(presets);
	      return {
	        dom: partialMenu.dom,
	        components: partialMenu.components,
	        items: partialMenu.items,
	        value: partialMenu.value,
	        markers: {
	          selectedItem: menuMarkers.selectedItem,
	          item: menuMarkers.item
	        },
	        movement: movement,
	        fakeFocus: focusMode === FocusMode.ContentFocus,
	        focusManager: focusManager,
	        menuBehaviours: SimpleBehaviours.unnamedEvents(columns !== 'auto' ? [] : [runOnAttached(function (comp, _se) {
	            detectSize(comp, 4, menuMarkers.item).each(function (_a) {
	              var numColumns = _a.numColumns, numRows = _a.numRows;
	              Keying.setGridSize(comp, numRows, numColumns);
	            });
	          })])
	      };
	    };
	
	    var register$9 = function (editor, sharedBackstage) {
	      var activeAutocompleter = value$1();
	      var processingAction = Cell(false);
	      var autocompleter = build$1(InlineView.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-autocompleter']
	        },
	        components: [],
	        fireDismissalEventInstead: {},
	        inlineBehaviours: derive$1([config('dismissAutocompleter', [run$1(dismissRequested(), function () {
	              return cancelIfNecessary();
	            })])]),
	        lazySink: sharedBackstage.getSink
	      }));
	      var isMenuOpen = function () {
	        return InlineView.isOpen(autocompleter);
	      };
	      var isActive = function () {
	        return activeAutocompleter.get().isSome();
	      };
	      var hideIfNecessary = function () {
	        if (isActive()) {
	          InlineView.hide(autocompleter);
	        }
	      };
	      var cancelIfNecessary = function () {
	        if (isActive()) {
	          var lastElement = activeAutocompleter.get().map(function (ac) {
	            return ac.element;
	          });
	          detect(lastElement.getOr(SugarElement.fromDom(editor.selection.getNode()))).each(unwrap);
	          hideIfNecessary();
	          activeAutocompleter.clear();
	          processingAction.set(false);
	        }
	      };
	      var getAutocompleters = cached(function () {
	        return register$b(editor);
	      });
	      var getCombinedItems = function (triggerChar, matches) {
	        var columns = findMap(matches, function (m) {
	          return Optional.from(m.columns);
	        }).getOr(1);
	        return bind$3(matches, function (match) {
	          var choices = match.items;
	          return createAutocompleteItems(choices, match.matchText, function (itemValue, itemMeta) {
	            var nr = editor.selection.getRng();
	            getContext(editor.dom, nr, triggerChar).fold(function () {
	              return console.error('Lost context. Cursor probably moved');
	            }, function (_a) {
	              var range = _a.range;
	              var autocompleterApi = {
	                hide: function () {
	                  cancelIfNecessary();
	                },
	                reload: function (fetchOptions) {
	                  hideIfNecessary();
	                  load(fetchOptions);
	                }
	              };
	              processingAction.set(true);
	              match.onAction(autocompleterApi, range, itemValue, itemMeta);
	              processingAction.set(false);
	            });
	          }, columns, ItemResponse$1.BUBBLE_TO_SANDBOX, sharedBackstage, match.highlightOn);
	        });
	      };
	      var commenceIfNecessary = function (context) {
	        if (!isActive()) {
	          var wrapper = create$5(editor, context.range);
	          activeAutocompleter.set({
	            triggerChar: context.triggerChar,
	            element: wrapper,
	            matchLength: context.text.length
	          });
	          processingAction.set(false);
	        }
	      };
	      var display = function (ac, context, lookupData, items) {
	        ac.matchLength = context.text.length;
	        var columns = findMap(lookupData, function (ld) {
	          return Optional.from(ld.columns);
	        }).getOr(1);
	        InlineView.showAt(autocompleter, Menu.sketch(createMenuFrom(createPartialMenuWithAlloyItems('autocompleter-value', true, items, columns, 'normal'), columns, FocusMode.ContentFocus, 'normal')), {
	          anchor: {
	            type: 'node',
	            root: SugarElement.fromDom(editor.getBody()),
	            node: Optional.from(ac.element)
	          }
	        });
	        InlineView.getContent(autocompleter).each(Highlighting.highlightFirst);
	      };
	      var doLookup = function (fetchOptions) {
	        return activeAutocompleter.get().map(function (ac) {
	          return getContext(editor.dom, editor.selection.getRng(), ac.triggerChar).bind(function (newContext) {
	            return lookupWithContext(editor, getAutocompleters, newContext, fetchOptions);
	          });
	        }).getOrThunk(function () {
	          return lookup$2(editor, getAutocompleters);
	        });
	      };
	      var load = function (fetchOptions) {
	        doLookup(fetchOptions).fold(cancelIfNecessary, function (lookupInfo) {
	          commenceIfNecessary(lookupInfo.context);
	          lookupInfo.lookupData.then(function (lookupData) {
	            activeAutocompleter.get().map(function (ac) {
	              var context = lookupInfo.context;
	              if (ac.triggerChar === context.triggerChar) {
	                var combinedItems = getCombinedItems(context.triggerChar, lookupData);
	                if (combinedItems.length > 0) {
	                  display(ac, context, lookupData, combinedItems);
	                } else if (context.text.length - ac.matchLength >= 10) {
	                  cancelIfNecessary();
	                } else {
	                  hideIfNecessary();
	                }
	              }
	            });
	          });
	        });
	      };
	      var onKeypress = last(function (e) {
	        if (e.which === 27) {
	          return;
	        }
	        load();
	      }, 50);
	      var autocompleterUiApi = {
	        onKeypress: onKeypress,
	        cancelIfNecessary: cancelIfNecessary,
	        isMenuOpen: isMenuOpen,
	        isActive: isActive,
	        isProcessingAction: processingAction.get,
	        getView: function () {
	          return InlineView.getContent(autocompleter);
	        }
	      };
	      if (editor.hasPlugin('rtc') === false) {
	        AutocompleterEditorEvents.setup(autocompleterUiApi, editor);
	      }
	    };
	    var Autocompleter = { register: register$9 };
	
	    var closest = function (scope, selector, isRoot) {
	      return closest$1(scope, selector, isRoot).isSome();
	    };
	
	    var DelayedFunction = function (fun, delay) {
	      var ref = null;
	      var schedule = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        ref = setTimeout(function () {
	          fun.apply(null, args);
	          ref = null;
	        }, delay);
	      };
	      var cancel = function () {
	        if (ref !== null) {
	          clearTimeout(ref);
	          ref = null;
	        }
	      };
	      return {
	        cancel: cancel,
	        schedule: schedule
	      };
	    };
	
	    var SIGNIFICANT_MOVE = 5;
	    var LONGPRESS_DELAY = 400;
	    var getTouch = function (event) {
	      var raw = event.raw;
	      if (raw.touches === undefined || raw.touches.length !== 1) {
	        return Optional.none();
	      }
	      return Optional.some(raw.touches[0]);
	    };
	    var isFarEnough = function (touch, data) {
	      var distX = Math.abs(touch.clientX - data.x);
	      var distY = Math.abs(touch.clientY - data.y);
	      return distX > SIGNIFICANT_MOVE || distY > SIGNIFICANT_MOVE;
	    };
	    var monitor = function (settings) {
	      var startData = value$1();
	      var longpressFired = Cell(false);
	      var longpress$1 = DelayedFunction(function (event) {
	        settings.triggerEvent(longpress(), event);
	        longpressFired.set(true);
	      }, LONGPRESS_DELAY);
	      var handleTouchstart = function (event) {
	        getTouch(event).each(function (touch) {
	          longpress$1.cancel();
	          var data = {
	            x: touch.clientX,
	            y: touch.clientY,
	            target: event.target
	          };
	          longpress$1.schedule(event);
	          longpressFired.set(false);
	          startData.set(data);
	        });
	        return Optional.none();
	      };
	      var handleTouchmove = function (event) {
	        longpress$1.cancel();
	        getTouch(event).each(function (touch) {
	          startData.on(function (data) {
	            if (isFarEnough(touch, data)) {
	              startData.clear();
	            }
	          });
	        });
	        return Optional.none();
	      };
	      var handleTouchend = function (event) {
	        longpress$1.cancel();
	        var isSame = function (data) {
	          return eq(data.target, event.target);
	        };
	        return startData.get().filter(isSame).map(function (_data) {
	          if (longpressFired.get()) {
	            event.prevent();
	            return false;
	          } else {
	            return settings.triggerEvent(tap(), event);
	          }
	        });
	      };
	      var handlers = wrapAll([
	        {
	          key: touchstart(),
	          value: handleTouchstart
	        },
	        {
	          key: touchmove(),
	          value: handleTouchmove
	        },
	        {
	          key: touchend(),
	          value: handleTouchend
	        }
	      ]);
	      var fireIfReady = function (event, type) {
	        return get$e(handlers, type).bind(function (handler) {
	          return handler(event);
	        });
	      };
	      return { fireIfReady: fireIfReady };
	    };
	
	    var isDangerous = function (event) {
	      var keyEv = event.raw;
	      return keyEv.which === BACKSPACE[0] && !contains$2([
	        'input',
	        'textarea'
	      ], name$2(event.target)) && !closest(event.target, '[contenteditable="true"]');
	    };
	    var isFirefox = function () {
	      return detect$1().browser.isFirefox();
	    };
	    var bindFocus = function (container, handler) {
	      if (isFirefox()) {
	        return capture(container, 'focus', handler);
	      } else {
	        return bind(container, 'focusin', handler);
	      }
	    };
	    var bindBlur = function (container, handler) {
	      if (isFirefox()) {
	        return capture(container, 'blur', handler);
	      } else {
	        return bind(container, 'focusout', handler);
	      }
	    };
	    var setup$d = function (container, rawSettings) {
	      var settings = __assign({ stopBackspace: true }, rawSettings);
	      var pointerEvents = [
	        'touchstart',
	        'touchmove',
	        'touchend',
	        'touchcancel',
	        'gesturestart',
	        'mousedown',
	        'mouseup',
	        'mouseover',
	        'mousemove',
	        'mouseout',
	        'click'
	      ];
	      var tapEvent = monitor(settings);
	      var simpleEvents = map$2(pointerEvents.concat([
	        'selectstart',
	        'input',
	        'contextmenu',
	        'change',
	        'transitionend',
	        'transitioncancel',
	        'drag',
	        'dragstart',
	        'dragend',
	        'dragenter',
	        'dragleave',
	        'dragover',
	        'drop',
	        'keyup'
	      ]), function (type) {
	        return bind(container, type, function (event) {
	          tapEvent.fireIfReady(event, type).each(function (tapStopped) {
	            if (tapStopped) {
	              event.kill();
	            }
	          });
	          var stopped = settings.triggerEvent(type, event);
	          if (stopped) {
	            event.kill();
	          }
	        });
	      });
	      var pasteTimeout = value$1();
	      var onPaste = bind(container, 'paste', function (event) {
	        tapEvent.fireIfReady(event, 'paste').each(function (tapStopped) {
	          if (tapStopped) {
	            event.kill();
	          }
	        });
	        var stopped = settings.triggerEvent('paste', event);
	        if (stopped) {
	          event.kill();
	        }
	        pasteTimeout.set(setTimeout(function () {
	          settings.triggerEvent(postPaste(), event);
	        }, 0));
	      });
	      var onKeydown = bind(container, 'keydown', function (event) {
	        var stopped = settings.triggerEvent('keydown', event);
	        if (stopped) {
	          event.kill();
	        } else if (settings.stopBackspace && isDangerous(event)) {
	          event.prevent();
	        }
	      });
	      var onFocusIn = bindFocus(container, function (event) {
	        var stopped = settings.triggerEvent('focusin', event);
	        if (stopped) {
	          event.kill();
	        }
	      });
	      var focusoutTimeout = value$1();
	      var onFocusOut = bindBlur(container, function (event) {
	        var stopped = settings.triggerEvent('focusout', event);
	        if (stopped) {
	          event.kill();
	        }
	        focusoutTimeout.set(setTimeout(function () {
	          settings.triggerEvent(postBlur(), event);
	        }, 0));
	      });
	      var unbind = function () {
	        each$1(simpleEvents, function (e) {
	          e.unbind();
	        });
	        onKeydown.unbind();
	        onFocusIn.unbind();
	        onFocusOut.unbind();
	        onPaste.unbind();
	        pasteTimeout.on(clearTimeout);
	        focusoutTimeout.on(clearTimeout);
	      };
	      return { unbind: unbind };
	    };
	
	    var derive = function (rawEvent, rawTarget) {
	      var source = get$e(rawEvent, 'target').getOr(rawTarget);
	      return Cell(source);
	    };
	
	    var fromSource = function (event, source) {
	      var stopper = Cell(false);
	      var cutter = Cell(false);
	      var stop = function () {
	        stopper.set(true);
	      };
	      var cut = function () {
	        cutter.set(true);
	      };
	      return {
	        stop: stop,
	        cut: cut,
	        isStopped: stopper.get,
	        isCut: cutter.get,
	        event: event,
	        setSource: source.set,
	        getSource: source.get
	      };
	    };
	    var fromExternal = function (event) {
	      var stopper = Cell(false);
	      var stop = function () {
	        stopper.set(true);
	      };
	      return {
	        stop: stop,
	        cut: noop,
	        isStopped: stopper.get,
	        isCut: never,
	        event: event,
	        setSource: die('Cannot set source of a broadcasted event'),
	        getSource: die('Cannot get source of a broadcasted event')
	      };
	    };
	
	    var adt$1 = Adt.generate([
	      { stopped: [] },
	      { resume: ['element'] },
	      { complete: [] }
	    ]);
	    var doTriggerHandler = function (lookup, eventType, rawEvent, target, source, logger) {
	      var handler = lookup(eventType, target);
	      var simulatedEvent = fromSource(rawEvent, source);
	      return handler.fold(function () {
	        logger.logEventNoHandlers(eventType, target);
	        return adt$1.complete();
	      }, function (handlerInfo) {
	        var descHandler = handlerInfo.descHandler;
	        var eventHandler = getCurried(descHandler);
	        eventHandler(simulatedEvent);
	        if (simulatedEvent.isStopped()) {
	          logger.logEventStopped(eventType, handlerInfo.element, descHandler.purpose);
	          return adt$1.stopped();
	        } else if (simulatedEvent.isCut()) {
	          logger.logEventCut(eventType, handlerInfo.element, descHandler.purpose);
	          return adt$1.complete();
	        } else {
	          return parent(handlerInfo.element).fold(function () {
	            logger.logNoParent(eventType, handlerInfo.element, descHandler.purpose);
	            return adt$1.complete();
	          }, function (parent) {
	            logger.logEventResponse(eventType, handlerInfo.element, descHandler.purpose);
	            return adt$1.resume(parent);
	          });
	        }
	      });
	    };
	    var doTriggerOnUntilStopped = function (lookup, eventType, rawEvent, rawTarget, source, logger) {
	      return doTriggerHandler(lookup, eventType, rawEvent, rawTarget, source, logger).fold(always, function (parent) {
	        return doTriggerOnUntilStopped(lookup, eventType, rawEvent, parent, source, logger);
	      }, never);
	    };
	    var triggerHandler = function (lookup, eventType, rawEvent, target, logger) {
	      var source = derive(rawEvent, target);
	      return doTriggerHandler(lookup, eventType, rawEvent, target, source, logger);
	    };
	    var broadcast = function (listeners, rawEvent, _logger) {
	      var simulatedEvent = fromExternal(rawEvent);
	      each$1(listeners, function (listener) {
	        var descHandler = listener.descHandler;
	        var handler = getCurried(descHandler);
	        handler(simulatedEvent);
	      });
	      return simulatedEvent.isStopped();
	    };
	    var triggerUntilStopped = function (lookup, eventType, rawEvent, logger) {
	      return triggerOnUntilStopped(lookup, eventType, rawEvent, rawEvent.target, logger);
	    };
	    var triggerOnUntilStopped = function (lookup, eventType, rawEvent, rawTarget, logger) {
	      var source = derive(rawEvent, rawTarget);
	      return doTriggerOnUntilStopped(lookup, eventType, rawEvent, rawTarget, source, logger);
	    };
	
	    var eventHandler = function (element, descHandler) {
	      return {
	        element: element,
	        descHandler: descHandler
	      };
	    };
	    var broadcastHandler = function (id, handler) {
	      return {
	        id: id,
	        descHandler: handler
	      };
	    };
	    var EventRegistry = function () {
	      var registry = {};
	      var registerId = function (extraArgs, id, events) {
	        each(events, function (v, k) {
	          var handlers = registry[k] !== undefined ? registry[k] : {};
	          handlers[id] = curryArgs(v, extraArgs);
	          registry[k] = handlers;
	        });
	      };
	      var findHandler = function (handlers, elem) {
	        return read$1(elem).bind(function (id) {
	          return get$e(handlers, id);
	        }).map(function (descHandler) {
	          return eventHandler(elem, descHandler);
	        });
	      };
	      var filterByType = function (type) {
	        return get$e(registry, type).map(function (handlers) {
	          return mapToArray(handlers, function (f, id) {
	            return broadcastHandler(id, f);
	          });
	        }).getOr([]);
	      };
	      var find = function (isAboveRoot, type, target) {
	        return get$e(registry, type).bind(function (handlers) {
	          return closest$4(target, function (elem) {
	            return findHandler(handlers, elem);
	          }, isAboveRoot);
	        });
	      };
	      var unregisterId = function (id) {
	        each(registry, function (handlersById, _eventName) {
	          if (has$2(handlersById, id)) {
	            delete handlersById[id];
	          }
	        });
	      };
	      return {
	        registerId: registerId,
	        unregisterId: unregisterId,
	        filterByType: filterByType,
	        find: find
	      };
	    };
	
	    var Registry = function () {
	      var events = EventRegistry();
	      var components = {};
	      var readOrTag = function (component) {
	        var elem = component.element;
	        return read$1(elem).getOrThunk(function () {
	          return write('uid-', component.element);
	        });
	      };
	      var failOnDuplicate = function (component, tagId) {
	        var conflict = components[tagId];
	        if (conflict === component) {
	          unregister(component);
	        } else {
	          throw new Error('The tagId "' + tagId + '" is already used by: ' + element(conflict.element) + '\nCannot use it for: ' + element(component.element) + '\n' + 'The conflicting element is' + (inBody(conflict.element) ? ' ' : ' not ') + 'already in the DOM');
	        }
	      };
	      var register = function (component) {
	        var tagId = readOrTag(component);
	        if (hasNonNullableKey(components, tagId)) {
	          failOnDuplicate(component, tagId);
	        }
	        var extraArgs = [component];
	        events.registerId(extraArgs, tagId, component.events);
	        components[tagId] = component;
	      };
	      var unregister = function (component) {
	        read$1(component.element).each(function (tagId) {
	          delete components[tagId];
	          events.unregisterId(tagId);
	        });
	      };
	      var filter = function (type) {
	        return events.filterByType(type);
	      };
	      var find = function (isAboveRoot, type, target) {
	        return events.find(isAboveRoot, type, target);
	      };
	      var getById = function (id) {
	        return get$e(components, id);
	      };
	      return {
	        find: find,
	        filter: filter,
	        register: register,
	        unregister: unregister,
	        getById: getById
	      };
	    };
	
	    var factory$j = function (detail) {
	      var _a = detail.dom, attributes = _a.attributes, domWithoutAttributes = __rest(_a, ['attributes']);
	      return {
	        uid: detail.uid,
	        dom: __assign({
	          tag: 'div',
	          attributes: __assign({ role: 'presentation' }, attributes)
	        }, domWithoutAttributes),
	        components: detail.components,
	        behaviours: get$2(detail.containerBehaviours),
	        events: detail.events,
	        domModification: detail.domModification,
	        eventOrder: detail.eventOrder
	      };
	    };
	    var Container = single({
	      name: 'Container',
	      factory: factory$j,
	      configFields: [
	        defaulted('components', []),
	        field('containerBehaviours', []),
	        defaulted('events', {}),
	        defaulted('domModification', {}),
	        defaulted('eventOrder', {})
	      ]
	    });
	
	    var takeover = function (root) {
	      var isAboveRoot = function (el) {
	        return parent(root.element).fold(always, function (parent) {
	          return eq(el, parent);
	        });
	      };
	      var registry = Registry();
	      var lookup = function (eventName, target) {
	        return registry.find(isAboveRoot, eventName, target);
	      };
	      var domEvents = setup$d(root.element, {
	        triggerEvent: function (eventName, event) {
	          return monitorEvent(eventName, event.target, function (logger) {
	            return triggerUntilStopped(lookup, eventName, event, logger);
	          });
	        }
	      });
	      var systemApi = {
	        debugInfo: constant$1('real'),
	        triggerEvent: function (eventName, target, data) {
	          monitorEvent(eventName, target, function (logger) {
	            return triggerOnUntilStopped(lookup, eventName, data, target, logger);
	          });
	        },
	        triggerFocus: function (target, originator) {
	          read$1(target).fold(function () {
	            focus$3(target);
	          }, function (_alloyId) {
	            monitorEvent(focus$4(), target, function (logger) {
	              triggerHandler(lookup, focus$4(), {
	                originator: originator,
	                kill: noop,
	                prevent: noop,
	                target: target
	              }, target, logger);
	              return false;
	            });
	          });
	        },
	        triggerEscape: function (comp, simulatedEvent) {
	          systemApi.triggerEvent('keydown', comp.element, simulatedEvent.event);
	        },
	        getByUid: function (uid) {
	          return getByUid(uid);
	        },
	        getByDom: function (elem) {
	          return getByDom(elem);
	        },
	        build: build$1,
	        addToGui: function (c) {
	          add(c);
	        },
	        removeFromGui: function (c) {
	          remove(c);
	        },
	        addToWorld: function (c) {
	          addToWorld(c);
	        },
	        removeFromWorld: function (c) {
	          removeFromWorld(c);
	        },
	        broadcast: function (message) {
	          broadcast$1(message);
	        },
	        broadcastOn: function (channels, message) {
	          broadcastOn(channels, message);
	        },
	        broadcastEvent: function (eventName, event) {
	          broadcastEvent(eventName, event);
	        },
	        isConnected: always
	      };
	      var addToWorld = function (component) {
	        component.connect(systemApi);
	        if (!isText$1(component.element)) {
	          registry.register(component);
	          each$1(component.components(), addToWorld);
	          systemApi.triggerEvent(systemInit(), component.element, { target: component.element });
	        }
	      };
	      var removeFromWorld = function (component) {
	        if (!isText$1(component.element)) {
	          each$1(component.components(), removeFromWorld);
	          registry.unregister(component);
	        }
	        component.disconnect();
	      };
	      var add = function (component) {
	        attach(root, component);
	      };
	      var remove = function (component) {
	        detach(component);
	      };
	      var destroy = function () {
	        domEvents.unbind();
	        remove$5(root.element);
	      };
	      var broadcastData = function (data) {
	        var receivers = registry.filter(receive());
	        each$1(receivers, function (receiver) {
	          var descHandler = receiver.descHandler;
	          var handler = getCurried(descHandler);
	          handler(data);
	        });
	      };
	      var broadcast$1 = function (message) {
	        broadcastData({
	          universal: true,
	          data: message
	        });
	      };
	      var broadcastOn = function (channels, message) {
	        broadcastData({
	          universal: false,
	          channels: channels,
	          data: message
	        });
	      };
	      var broadcastEvent = function (eventName, event) {
	        var listeners = registry.filter(eventName);
	        return broadcast(listeners, event);
	      };
	      var getByUid = function (uid) {
	        return registry.getById(uid).fold(function () {
	          return Result.error(new Error('Could not find component with uid: "' + uid + '" in system.'));
	        }, Result.value);
	      };
	      var getByDom = function (elem) {
	        var uid = read$1(elem).getOr('not found');
	        return getByUid(uid);
	      };
	      addToWorld(root);
	      return {
	        root: root,
	        element: root.element,
	        destroy: destroy,
	        add: add,
	        remove: remove,
	        getByUid: getByUid,
	        getByDom: getByDom,
	        addToWorld: addToWorld,
	        removeFromWorld: removeFromWorld,
	        broadcast: broadcast$1,
	        broadcastOn: broadcastOn,
	        broadcastEvent: broadcastEvent
	      };
	    };
	
	    var renderBar = function (spec, backstage) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-bar',
	            'tox-form__controls-h-stack'
	          ]
	        },
	        components: map$2(spec.items, backstage.interpreter)
	      };
	    };
	
	    var schema$l = constant$1([
	      defaulted('prefix', 'form-field'),
	      field('fieldBehaviours', [
	        Composing,
	        Representing
	      ])
	    ]);
	    var parts$e = constant$1([
	      optional({
	        schema: [required$1('dom')],
	        name: 'label'
	      }),
	      optional({
	        factory: {
	          sketch: function (spec) {
	            return {
	              uid: spec.uid,
	              dom: {
	                tag: 'span',
	                styles: { display: 'none' },
	                attributes: { 'aria-hidden': 'true' },
	                innerHtml: spec.text
	              }
	            };
	          }
	        },
	        schema: [required$1('text')],
	        name: 'aria-descriptor'
	      }),
	      required({
	        factory: {
	          sketch: function (spec) {
	            var excludeFactory = exclude(spec, ['factory']);
	            return spec.factory.sketch(excludeFactory);
	          }
	        },
	        schema: [required$1('factory')],
	        name: 'field'
	      })
	    ]);
	
	    var factory$i = function (detail, components, _spec, _externals) {
	      var behaviours = augment(detail.fieldBehaviours, [
	        Composing.config({
	          find: function (container) {
	            return getPart(container, detail, 'field');
	          }
	        }),
	        Representing.config({
	          store: {
	            mode: 'manual',
	            getValue: function (field) {
	              return Composing.getCurrent(field).bind(Representing.getValue);
	            },
	            setValue: function (field, value) {
	              Composing.getCurrent(field).each(function (current) {
	                Representing.setValue(current, value);
	              });
	            }
	          }
	        })
	      ]);
	      var events = derive$2([runOnAttached(function (component, _simulatedEvent) {
	          var ps = getParts(component, detail, [
	            'label',
	            'field',
	            'aria-descriptor'
	          ]);
	          ps.field().each(function (field) {
	            var id = generate$6(detail.prefix);
	            ps.label().each(function (label) {
	              set$8(label.element, 'for', id);
	              set$8(field.element, 'id', id);
	            });
	            ps['aria-descriptor']().each(function (descriptor) {
	              var descriptorId = generate$6(detail.prefix);
	              set$8(descriptor.element, 'id', descriptorId);
	              set$8(field.element, 'aria-describedby', descriptorId);
	            });
	          });
	        })]);
	      var apis = {
	        getField: function (container) {
	          return getPart(container, detail, 'field');
	        },
	        getLabel: function (container) {
	          return getPart(container, detail, 'label');
	        }
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: behaviours,
	        events: events,
	        apis: apis
	      };
	    };
	    var FormField = composite({
	      name: 'FormField',
	      configFields: schema$l(),
	      partFields: parts$e(),
	      factory: factory$i,
	      apis: {
	        getField: function (apis, comp) {
	          return apis.getField(comp);
	        },
	        getLabel: function (apis, comp) {
	          return apis.getLabel(comp);
	        }
	      }
	    });
	
	    var exhibit$2 = function (base, tabConfig) {
	      return nu$7({
	        attributes: wrapAll([{
	            key: tabConfig.tabAttr,
	            value: 'true'
	          }])
	      });
	    };
	
	    var ActiveTabstopping = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$2
	    });
	
	    var TabstopSchema = [defaulted('tabAttr', 'data-alloy-tabstop')];
	
	    var Tabstopping = create$8({
	      fields: TabstopSchema,
	      name: 'tabstopping',
	      active: ActiveTabstopping
	    });
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.html.Entities');
	
	    var renderFormFieldWith = function (pLabel, pField, extraClasses, extraBehaviours) {
	      var spec = renderFormFieldSpecWith(pLabel, pField, extraClasses, extraBehaviours);
	      return FormField.sketch(spec);
	    };
	    var renderFormField = function (pLabel, pField) {
	      return renderFormFieldWith(pLabel, pField, [], []);
	    };
	    var renderFormFieldSpecWith = function (pLabel, pField, extraClasses, extraBehaviours) {
	      return {
	        dom: renderFormFieldDomWith(extraClasses),
	        components: pLabel.toArray().concat([pField]),
	        fieldBehaviours: derive$1(extraBehaviours)
	      };
	    };
	    var renderFormFieldDom = function () {
	      return renderFormFieldDomWith([]);
	    };
	    var renderFormFieldDomWith = function (extraClasses) {
	      return {
	        tag: 'div',
	        classes: ['tox-form__group'].concat(extraClasses)
	      };
	    };
	    var renderLabel$2 = function (label, providersBackstage) {
	      return FormField.parts.label({
	        dom: {
	          tag: 'label',
	          classes: ['tox-label'],
	          innerHtml: providersBackstage.translate(label)
	        }
	      });
	    };
	
	    var formChangeEvent = generate$6('form-component-change');
	    var formCloseEvent = generate$6('form-close');
	    var formCancelEvent = generate$6('form-cancel');
	    var formActionEvent = generate$6('form-action');
	    var formSubmitEvent = generate$6('form-submit');
	    var formBlockEvent = generate$6('form-block');
	    var formUnblockEvent = generate$6('form-unblock');
	    var formTabChangeEvent = generate$6('form-tabchange');
	    var formResizeEvent = generate$6('form-resize');
	
	    var renderCollection = function (spec, providersBackstage) {
	      var _a;
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel$2(label, providersBackstage);
	      });
	      var runOnItem = function (f) {
	        return function (comp, se) {
	          closest$1(se.event.target, '[data-collection-item-value]').each(function (target) {
	            f(comp, se, target, get$d(target, 'data-collection-item-value'));
	          });
	        };
	      };
	      var setContents = function (comp, items) {
	        var htmlLines = map$2(items, function (item) {
	          var itemText = global$e.translate(item.text);
	          var textContent = spec.columns === 1 ? '<div class="tox-collection__item-label">' + itemText + '</div>' : '';
	          var iconContent = '<div class="tox-collection__item-icon">' + item.icon + '</div>';
	          var mapItemName = {
	            '_': ' ',
	            ' - ': ' ',
	            '-': ' '
	          };
	          var ariaLabel = itemText.replace(/\_| \- |\-/g, function (match) {
	            return mapItemName[match];
	          });
	          var disabledClass = providersBackstage.isDisabled() ? ' tox-collection__item--state-disabled' : '';
	          return '<div class="tox-collection__item' + disabledClass + '" tabindex="-1" data-collection-item-value="' + global$7.encodeAllRaw(item.value) + '" title="' + ariaLabel + '" aria-label="' + ariaLabel + '">' + iconContent + textContent + '</div>';
	        });
	        var chunks = spec.columns !== 'auto' && spec.columns > 1 ? chunk$1(htmlLines, spec.columns) : [htmlLines];
	        var html = map$2(chunks, function (ch) {
	          return '<div class="tox-collection__group">' + ch.join('') + '</div>';
	        });
	        set$5(comp.element, html.join(''));
	      };
	      var onClick = runOnItem(function (comp, se, tgt, itemValue) {
	        se.stop();
	        if (!providersBackstage.isDisabled()) {
	          emitWith(comp, formActionEvent, {
	            name: spec.name,
	            value: itemValue
	          });
	        }
	      });
	      var collectionEvents = [
	        run$1(mouseover(), runOnItem(function (comp, se, tgt) {
	          focus$3(tgt);
	        })),
	        run$1(click(), onClick),
	        run$1(tap(), onClick),
	        run$1(focusin(), runOnItem(function (comp, se, tgt) {
	          descendant(comp.element, '.' + activeClass).each(function (currentActive) {
	            remove$2(currentActive, activeClass);
	          });
	          add$2(tgt, activeClass);
	        })),
	        run$1(focusout(), runOnItem(function (comp) {
	          descendant(comp.element, '.' + activeClass).each(function (currentActive) {
	            remove$2(currentActive, activeClass);
	          });
	        })),
	        runOnExecute$1(runOnItem(function (comp, se, tgt, itemValue) {
	          emitWith(comp, formActionEvent, {
	            name: spec.name,
	            value: itemValue
	          });
	        }))
	      ];
	      var iterCollectionItems = function (comp, applyAttributes) {
	        return map$2(descendants(comp.element, '.tox-collection__item'), applyAttributes);
	      };
	      var pField = FormField.parts.field({
	        dom: {
	          tag: 'div',
	          classes: ['tox-collection'].concat(spec.columns !== 1 ? ['tox-collection--grid'] : ['tox-collection--list'])
	        },
	        components: [],
	        factory: { sketch: identity$1 },
	        behaviours: derive$1([
	          Disabling.config({
	            disabled: providersBackstage.isDisabled,
	            onDisabled: function (comp) {
	              iterCollectionItems(comp, function (childElm) {
	                add$2(childElm, 'tox-collection__item--state-disabled');
	                set$8(childElm, 'aria-disabled', true);
	              });
	            },
	            onEnabled: function (comp) {
	              iterCollectionItems(comp, function (childElm) {
	                remove$2(childElm, 'tox-collection__item--state-disabled');
	                remove$7(childElm, 'aria-disabled');
	              });
	            }
	          }),
	          receivingConfig(),
	          Replacing.config({}),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: []
	            },
	            onSetValue: function (comp, items) {
	              setContents(comp, items);
	              if (spec.columns === 'auto') {
	                detectSize(comp, 5, 'tox-collection__item').each(function (_a) {
	                  var numRows = _a.numRows, numColumns = _a.numColumns;
	                  Keying.setGridSize(comp, numRows, numColumns);
	                });
	              }
	              emit(comp, formResizeEvent);
	            }
	          }),
	          Tabstopping.config({}),
	          Keying.config(deriveCollectionMovement(spec.columns, 'normal')),
	          config('collection-events', collectionEvents)
	        ]),
	        eventOrder: (_a = {}, _a[execute$5()] = [
	          'disabling',
	          'alloy.base.behaviour',
	          'collection-events'
	        ], _a)
	      });
	      var extraClasses = ['tox-form__group--collection'];
	      return renderFormFieldWith(pLabel, pField, extraClasses, []);
	    };
	
	    var schema$k = constant$1([
	      option('data'),
	      defaulted('inputAttributes', {}),
	      defaulted('inputStyles', {}),
	      defaulted('tag', 'input'),
	      defaulted('inputClasses', []),
	      onHandler('onSetValue'),
	      defaulted('styles', {}),
	      defaulted('eventOrder', {}),
	      field('inputBehaviours', [
	        Representing,
	        Focusing
	      ]),
	      defaulted('selectOnFocus', true)
	    ]);
	    var focusBehaviours = function (detail) {
	      return derive$1([Focusing.config({
	          onFocus: !detail.selectOnFocus ? noop : function (component) {
	            var input = component.element;
	            var value = get$5(input);
	            input.dom.setSelectionRange(0, value.length);
	          }
	        })]);
	    };
	    var behaviours = function (detail) {
	      return __assign(__assign({}, focusBehaviours(detail)), augment(detail.inputBehaviours, [Representing.config({
	          store: __assign(__assign({ mode: 'manual' }, detail.data.map(function (data) {
	            return { initialValue: data };
	          }).getOr({})), {
	            getValue: function (input) {
	              return get$5(input.element);
	            },
	            setValue: function (input, data) {
	              var current = get$5(input.element);
	              if (current !== data) {
	                set$4(input.element, data);
	              }
	            }
	          }),
	          onSetValue: detail.onSetValue
	        })]));
	    };
	    var dom = function (detail) {
	      return {
	        tag: detail.tag,
	        attributes: __assign({ type: 'text' }, detail.inputAttributes),
	        styles: detail.inputStyles,
	        classes: detail.inputClasses
	      };
	    };
	
	    var factory$h = function (detail, _spec) {
	      return {
	        uid: detail.uid,
	        dom: dom(detail),
	        components: [],
	        behaviours: behaviours(detail),
	        eventOrder: detail.eventOrder
	      };
	    };
	    var Input = single({
	      name: 'Input',
	      configFields: schema$k(),
	      factory: factory$h
	    });
	
	    var exports$1 = {}, module = { exports: exports$1 };
	    (function (define, exports, module, require) {
	      (function (global, factory) {
	        typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.EphoxContactWrapper = factory());
	      }(this, function () {
	        var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	        var promise = { exports: {} };
	        (function (module) {
	          (function (root) {
	            var setTimeoutFunc = setTimeout;
	            function noop() {
	            }
	            function bind(fn, thisArg) {
	              return function () {
	                fn.apply(thisArg, arguments);
	              };
	            }
	            function Promise(fn) {
	              if (typeof this !== 'object')
	                throw new TypeError('Promises must be constructed via new');
	              if (typeof fn !== 'function')
	                throw new TypeError('not a function');
	              this._state = 0;
	              this._handled = false;
	              this._value = undefined;
	              this._deferreds = [];
	              doResolve(fn, this);
	            }
	            function handle(self, deferred) {
	              while (self._state === 3) {
	                self = self._value;
	              }
	              if (self._state === 0) {
	                self._deferreds.push(deferred);
	                return;
	              }
	              self._handled = true;
	              Promise._immediateFn(function () {
	                var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	                if (cb === null) {
	                  (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	                  return;
	                }
	                var ret;
	                try {
	                  ret = cb(self._value);
	                } catch (e) {
	                  reject(deferred.promise, e);
	                  return;
	                }
	                resolve(deferred.promise, ret);
	              });
	            }
	            function resolve(self, newValue) {
	              try {
	                if (newValue === self)
	                  throw new TypeError('A promise cannot be resolved with itself.');
	                if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                  var then = newValue.then;
	                  if (newValue instanceof Promise) {
	                    self._state = 3;
	                    self._value = newValue;
	                    finale(self);
	                    return;
	                  } else if (typeof then === 'function') {
	                    doResolve(bind(then, newValue), self);
	                    return;
	                  }
	                }
	                self._state = 1;
	                self._value = newValue;
	                finale(self);
	              } catch (e) {
	                reject(self, e);
	              }
	            }
	            function reject(self, newValue) {
	              self._state = 2;
	              self._value = newValue;
	              finale(self);
	            }
	            function finale(self) {
	              if (self._state === 2 && self._deferreds.length === 0) {
	                Promise._immediateFn(function () {
	                  if (!self._handled) {
	                    Promise._unhandledRejectionFn(self._value);
	                  }
	                });
	              }
	              for (var i = 0, len = self._deferreds.length; i < len; i++) {
	                handle(self, self._deferreds[i]);
	              }
	              self._deferreds = null;
	            }
	            function Handler(onFulfilled, onRejected, promise) {
	              this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	              this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	              this.promise = promise;
	            }
	            function doResolve(fn, self) {
	              var done = false;
	              try {
	                fn(function (value) {
	                  if (done)
	                    return;
	                  done = true;
	                  resolve(self, value);
	                }, function (reason) {
	                  if (done)
	                    return;
	                  done = true;
	                  reject(self, reason);
	                });
	              } catch (ex) {
	                if (done)
	                  return;
	                done = true;
	                reject(self, ex);
	              }
	            }
	            Promise.prototype['catch'] = function (onRejected) {
	              return this.then(null, onRejected);
	            };
	            Promise.prototype.then = function (onFulfilled, onRejected) {
	              var prom = new this.constructor(noop);
	              handle(this, new Handler(onFulfilled, onRejected, prom));
	              return prom;
	            };
	            Promise.all = function (arr) {
	              var args = Array.prototype.slice.call(arr);
	              return new Promise(function (resolve, reject) {
	                if (args.length === 0)
	                  return resolve([]);
	                var remaining = args.length;
	                function res(i, val) {
	                  try {
	                    if (val && (typeof val === 'object' || typeof val === 'function')) {
	                      var then = val.then;
	                      if (typeof then === 'function') {
	                        then.call(val, function (val) {
	                          res(i, val);
	                        }, reject);
	                        return;
	                      }
	                    }
	                    args[i] = val;
	                    if (--remaining === 0) {
	                      resolve(args);
	                    }
	                  } catch (ex) {
	                    reject(ex);
	                  }
	                }
	                for (var i = 0; i < args.length; i++) {
	                  res(i, args[i]);
	                }
	              });
	            };
	            Promise.resolve = function (value) {
	              if (value && typeof value === 'object' && value.constructor === Promise) {
	                return value;
	              }
	              return new Promise(function (resolve) {
	                resolve(value);
	              });
	            };
	            Promise.reject = function (value) {
	              return new Promise(function (resolve, reject) {
	                reject(value);
	              });
	            };
	            Promise.race = function (values) {
	              return new Promise(function (resolve, reject) {
	                for (var i = 0, len = values.length; i < len; i++) {
	                  values[i].then(resolve, reject);
	                }
	              });
	            };
	            Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
	              setImmediate(fn);
	            } : function (fn) {
	              setTimeoutFunc(fn, 0);
	            };
	            Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	              if (typeof console !== 'undefined' && console) {
	                console.warn('Possible Unhandled Promise Rejection:', err);
	              }
	            };
	            Promise._setImmediateFn = function _setImmediateFn(fn) {
	              Promise._immediateFn = fn;
	            };
	            Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	              Promise._unhandledRejectionFn = fn;
	            };
	            if (module.exports) {
	              module.exports = Promise;
	            } else if (!root.Promise) {
	              root.Promise = Promise;
	            }
	          }(commonjsGlobal));
	        }(promise));
	        var promisePolyfill = promise.exports;
	        var Global = function () {
	          if (typeof window !== 'undefined') {
	            return window;
	          } else {
	            return Function('return this;')();
	          }
	        }();
	        var promisePolyfill_1 = { boltExport: Global.Promise || promisePolyfill };
	        return promisePolyfill_1;
	      }));
	    }(undefined, exports$1, module));
	    var Promise$1 = module.exports.boltExport;
	
	    var nu$3 = function (baseFn) {
	      var data = Optional.none();
	      var callbacks = [];
	      var map = function (f) {
	        return nu$3(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	      var get = function (nCallback) {
	        if (isReady()) {
	          call(nCallback);
	        } else {
	          callbacks.push(nCallback);
	        }
	      };
	      var set = function (x) {
	        if (!isReady()) {
	          data = Optional.some(x);
	          run(callbacks);
	          callbacks = [];
	        }
	      };
	      var isReady = function () {
	        return data.isSome();
	      };
	      var run = function (cbs) {
	        each$1(cbs, call);
	      };
	      var call = function (cb) {
	        data.each(function (x) {
	          setTimeout(function () {
	            cb(x);
	          }, 0);
	        });
	      };
	      baseFn(set);
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	    var pure$1 = function (a) {
	      return nu$3(function (callback) {
	        callback(a);
	      });
	    };
	    var LazyValue = {
	      nu: nu$3,
	      pure: pure$1
	    };
	
	    var errorReporter = function (err) {
	      setTimeout(function () {
	        throw err;
	      }, 0);
	    };
	    var make$5 = function (run) {
	      var get = function (callback) {
	        run().then(callback, errorReporter);
	      };
	      var map = function (fab) {
	        return make$5(function () {
	          return run().then(fab);
	        });
	      };
	      var bind = function (aFutureB) {
	        return make$5(function () {
	          return run().then(function (v) {
	            return aFutureB(v).toPromise();
	          });
	        });
	      };
	      var anonBind = function (futureB) {
	        return make$5(function () {
	          return run().then(function () {
	            return futureB.toPromise();
	          });
	        });
	      };
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	      var toCached = function () {
	        var cache = null;
	        return make$5(function () {
	          if (cache === null) {
	            cache = run();
	          }
	          return cache;
	        });
	      };
	      var toPromise = run;
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        toCached: toCached,
	        toPromise: toPromise,
	        get: get
	      };
	    };
	    var nu$2 = function (baseFn) {
	      return make$5(function () {
	        return new Promise$1(baseFn);
	      });
	    };
	    var pure = function (a) {
	      return make$5(function () {
	        return Promise$1.resolve(a);
	      });
	    };
	    var Future = {
	      nu: nu$2,
	      pure: pure
	    };
	
	    var ariaElements = [
	      'input',
	      'textarea'
	    ];
	    var isAriaElement = function (elem) {
	      var name = name$2(elem);
	      return contains$2(ariaElements, name);
	    };
	    var markValid = function (component, invalidConfig) {
	      var elem = invalidConfig.getRoot(component).getOr(component.element);
	      remove$2(elem, invalidConfig.invalidClass);
	      invalidConfig.notify.each(function (notifyInfo) {
	        if (isAriaElement(component.element)) {
	          set$8(component.element, 'aria-invalid', false);
	        }
	        notifyInfo.getContainer(component).each(function (container) {
	          set$5(container, notifyInfo.validHtml);
	        });
	        notifyInfo.onValid(component);
	      });
	    };
	    var markInvalid = function (component, invalidConfig, invalidState, text) {
	      var elem = invalidConfig.getRoot(component).getOr(component.element);
	      add$2(elem, invalidConfig.invalidClass);
	      invalidConfig.notify.each(function (notifyInfo) {
	        if (isAriaElement(component.element)) {
	          set$8(component.element, 'aria-invalid', true);
	        }
	        notifyInfo.getContainer(component).each(function (container) {
	          set$5(container, text);
	        });
	        notifyInfo.onInvalid(component, text);
	      });
	    };
	    var query = function (component, invalidConfig, _invalidState) {
	      return invalidConfig.validator.fold(function () {
	        return Future.pure(Result.value(true));
	      }, function (validatorInfo) {
	        return validatorInfo.validate(component);
	      });
	    };
	    var run = function (component, invalidConfig, invalidState) {
	      invalidConfig.notify.each(function (notifyInfo) {
	        notifyInfo.onValidate(component);
	      });
	      return query(component, invalidConfig).map(function (valid) {
	        if (component.getSystem().isConnected()) {
	          return valid.fold(function (err) {
	            markInvalid(component, invalidConfig, invalidState, err);
	            return Result.error(err);
	          }, function (v) {
	            markValid(component, invalidConfig);
	            return Result.value(v);
	          });
	        } else {
	          return Result.error('No longer in system');
	        }
	      });
	    };
	    var isInvalid = function (component, invalidConfig) {
	      var elem = invalidConfig.getRoot(component).getOr(component.element);
	      return has(elem, invalidConfig.invalidClass);
	    };
	
	    var InvalidateApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        markValid: markValid,
	        markInvalid: markInvalid,
	        query: query,
	        run: run,
	        isInvalid: isInvalid
	    });
	
	    var events$8 = function (invalidConfig, invalidState) {
	      return invalidConfig.validator.map(function (validatorInfo) {
	        return derive$2([run$1(validatorInfo.onEvent, function (component) {
	            run(component, invalidConfig, invalidState).get(identity$1);
	          })].concat(validatorInfo.validateOnLoad ? [runOnAttached(function (component) {
	            run(component, invalidConfig, invalidState).get(noop);
	          })] : []));
	      }).getOr({});
	    };
	
	    var ActiveInvalidate = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$8
	    });
	
	    var InvalidateSchema = [
	      required$1('invalidClass'),
	      defaulted('getRoot', Optional.none),
	      optionObjOf('notify', [
	        defaulted('aria', 'alert'),
	        defaulted('getContainer', Optional.none),
	        defaulted('validHtml', ''),
	        onHandler('onValid'),
	        onHandler('onInvalid'),
	        onHandler('onValidate')
	      ]),
	      optionObjOf('validator', [
	        required$1('validate'),
	        defaulted('onEvent', 'input'),
	        defaulted('validateOnLoad', true)
	      ])
	    ];
	
	    var Invalidating = create$8({
	      fields: InvalidateSchema,
	      name: 'invalidating',
	      active: ActiveInvalidate,
	      apis: InvalidateApis,
	      extra: {
	        validation: function (validator) {
	          return function (component) {
	            var v = Representing.getValue(component);
	            return Future.pure(validator(v));
	          };
	        }
	      }
	    });
	
	    var getCoupled = function (component, coupleConfig, coupleState, name) {
	      return coupleState.getOrCreate(component, coupleConfig, name);
	    };
	
	    var CouplingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getCoupled: getCoupled
	    });
	
	    var CouplingSchema = [requiredOf('others', setOf(Result.value, anyValue()))];
	
	    var init$a = function () {
	      var coupled = {};
	      var getOrCreate = function (component, coupleConfig, name) {
	        var available = keys(coupleConfig.others);
	        if (!available) {
	          throw new Error('Cannot find coupled component: ' + name + '. Known coupled components: ' + JSON.stringify(available, null, 2));
	        } else {
	          return get$e(coupled, name).getOrThunk(function () {
	            var builder = get$e(coupleConfig.others, name).getOrDie('No information found for coupled component: ' + name);
	            var spec = builder(component);
	            var built = component.getSystem().build(spec);
	            coupled[name] = built;
	            return built;
	          });
	        }
	      };
	      var readState = constant$1({});
	      return nu$8({
	        readState: readState,
	        getOrCreate: getOrCreate
	      });
	    };
	
	    var CouplingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$a
	    });
	
	    var Coupling = create$8({
	      fields: CouplingSchema,
	      name: 'coupling',
	      apis: CouplingApis,
	      state: CouplingState
	    });
	
	    var suffix = constant$1('sink');
	    var partType$1 = constant$1(optional({
	      name: suffix(),
	      overrides: constant$1({
	        dom: { tag: 'div' },
	        behaviours: derive$1([Positioning.config({ useFixed: always })]),
	        events: derive$2([
	          cutter(keydown()),
	          cutter(mousedown()),
	          cutter(click())
	        ])
	      })
	    }));
	
	    var HighlightOnOpen;
	    (function (HighlightOnOpen) {
	      HighlightOnOpen[HighlightOnOpen['HighlightFirst'] = 0] = 'HighlightFirst';
	      HighlightOnOpen[HighlightOnOpen['HighlightNone'] = 1] = 'HighlightNone';
	    }(HighlightOnOpen || (HighlightOnOpen = {})));
	    var getAnchor = function (detail, component) {
	      var hotspot = detail.getHotspot(component).getOr(component);
	      var type = 'hotspot';
	      var overrides = detail.getAnchorOverrides();
	      return detail.layouts.fold(function () {
	        return {
	          type: type,
	          hotspot: hotspot,
	          overrides: overrides
	        };
	      }, function (layouts) {
	        return {
	          type: type,
	          hotspot: hotspot,
	          overrides: overrides,
	          layouts: layouts
	        };
	      });
	    };
	    var fetch = function (detail, mapFetch, component) {
	      var fetcher = detail.fetch;
	      return fetcher(component).map(mapFetch);
	    };
	    var openF = function (detail, mapFetch, anchor, component, sandbox, externals, highlightOnOpen) {
	      var futureData = fetch(detail, mapFetch, component);
	      var getLazySink = getSink(component, detail);
	      return futureData.map(function (tdata) {
	        return tdata.bind(function (data) {
	          return Optional.from(tieredMenu.sketch(__assign(__assign({}, externals.menu()), {
	            uid: generate$5(''),
	            data: data,
	            highlightImmediately: highlightOnOpen === HighlightOnOpen.HighlightFirst,
	            onOpenMenu: function (tmenu, menu) {
	              var sink = getLazySink().getOrDie();
	              Positioning.position(sink, menu, { anchor: anchor });
	              Sandboxing.decloak(sandbox);
	            },
	            onOpenSubmenu: function (tmenu, item, submenu) {
	              var sink = getLazySink().getOrDie();
	              Positioning.position(sink, submenu, {
	                anchor: {
	                  type: 'submenu',
	                  item: item
	                }
	              });
	              Sandboxing.decloak(sandbox);
	            },
	            onRepositionMenu: function (tmenu, primaryMenu, submenuTriggers) {
	              var sink = getLazySink().getOrDie();
	              Positioning.position(sink, primaryMenu, { anchor: anchor });
	              each$1(submenuTriggers, function (st) {
	                Positioning.position(sink, st.triggeredMenu, {
	                  anchor: {
	                    type: 'submenu',
	                    item: st.triggeringItem
	                  }
	                });
	              });
	            },
	            onEscape: function () {
	              Focusing.focus(component);
	              Sandboxing.close(sandbox);
	              return Optional.some(true);
	            }
	          })));
	        });
	      });
	    };
	    var open = function (detail, mapFetch, hotspot, sandbox, externals, onOpenSync, highlightOnOpen) {
	      var anchor = getAnchor(detail, hotspot);
	      var processed = openF(detail, mapFetch, anchor, hotspot, sandbox, externals, highlightOnOpen);
	      return processed.map(function (tdata) {
	        tdata.fold(function () {
	          if (Sandboxing.isOpen(sandbox)) {
	            Sandboxing.close(sandbox);
	          }
	        }, function (data) {
	          Sandboxing.cloak(sandbox);
	          Sandboxing.open(sandbox, data);
	          onOpenSync(sandbox);
	        });
	        return sandbox;
	      });
	    };
	    var close = function (detail, mapFetch, component, sandbox, _externals, _onOpenSync, _highlightOnOpen) {
	      Sandboxing.close(sandbox);
	      return Future.pure(sandbox);
	    };
	    var togglePopup = function (detail, mapFetch, hotspot, externals, onOpenSync, highlightOnOpen) {
	      var sandbox = Coupling.getCoupled(hotspot, 'sandbox');
	      var showing = Sandboxing.isOpen(sandbox);
	      var action = showing ? close : open;
	      return action(detail, mapFetch, hotspot, sandbox, externals, onOpenSync, highlightOnOpen);
	    };
	    var matchWidth = function (hotspot, container, useMinWidth) {
	      var menu = Composing.getCurrent(container).getOr(container);
	      var buttonWidth = get$a(hotspot.element);
	      if (useMinWidth) {
	        set$7(menu.element, 'min-width', buttonWidth + 'px');
	      } else {
	        set$6(menu.element, buttonWidth);
	      }
	    };
	    var getSink = function (anyInSystem, sinkDetail) {
	      return anyInSystem.getSystem().getByUid(sinkDetail.uid + '-' + suffix()).map(function (internalSink) {
	        return function () {
	          return Result.value(internalSink);
	        };
	      }).getOrThunk(function () {
	        return sinkDetail.lazySink.fold(function () {
	          return function () {
	            return Result.error(new Error('No internal sink is specified, nor could an external sink be found'));
	          };
	        }, function (lazySinkFn) {
	          return function () {
	            return lazySinkFn(anyInSystem);
	          };
	        });
	      });
	    };
	    var doRepositionMenus = function (sandbox) {
	      Sandboxing.getState(sandbox).each(function (tmenu) {
	        tieredMenu.repositionMenus(tmenu);
	      });
	    };
	    var makeSandbox$1 = function (detail, hotspot, extras) {
	      var ariaOwner = manager();
	      var onOpen = function (component, menu) {
	        var anchor = getAnchor(detail, hotspot);
	        ariaOwner.link(hotspot.element);
	        if (detail.matchWidth) {
	          matchWidth(anchor.hotspot, menu, detail.useMinWidth);
	        }
	        detail.onOpen(anchor, component, menu);
	        if (extras !== undefined && extras.onOpen !== undefined) {
	          extras.onOpen(component, menu);
	        }
	      };
	      var onClose = function (component, menu) {
	        ariaOwner.unlink(hotspot.element);
	        if (extras !== undefined && extras.onClose !== undefined) {
	          extras.onClose(component, menu);
	        }
	      };
	      var lazySink = getSink(hotspot, detail);
	      return {
	        dom: {
	          tag: 'div',
	          classes: detail.sandboxClasses,
	          attributes: {
	            id: ariaOwner.id,
	            role: 'listbox'
	          }
	        },
	        behaviours: SketchBehaviours.augment(detail.sandboxBehaviours, [
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: hotspot
	            }
	          }),
	          Sandboxing.config({
	            onOpen: onOpen,
	            onClose: onClose,
	            isPartOf: function (container, data, queryElem) {
	              return isPartOf$1(data, queryElem) || isPartOf$1(hotspot, queryElem);
	            },
	            getAttachPoint: function () {
	              return lazySink().getOrDie();
	            }
	          }),
	          Composing.config({
	            find: function (sandbox) {
	              return Sandboxing.getState(sandbox).bind(function (menu) {
	                return Composing.getCurrent(menu);
	              });
	            }
	          }),
	          Receiving.config({ channels: __assign(__assign({}, receivingChannel$1({ isExtraPart: never })), receivingChannel({ doReposition: doRepositionMenus })) })
	        ])
	      };
	    };
	    var repositionMenus = function (comp) {
	      var sandbox = Coupling.getCoupled(comp, 'sandbox');
	      doRepositionMenus(sandbox);
	    };
	
	    var sandboxFields = function () {
	      return [
	        defaulted('sandboxClasses', []),
	        SketchBehaviours.field('sandboxBehaviours', [
	          Composing,
	          Receiving,
	          Sandboxing,
	          Representing
	        ])
	      ];
	    };
	
	    var schema$j = constant$1([
	      required$1('dom'),
	      required$1('fetch'),
	      onHandler('onOpen'),
	      onKeyboardHandler('onExecute'),
	      defaulted('getHotspot', Optional.some),
	      defaulted('getAnchorOverrides', constant$1({})),
	      schema$y(),
	      field('dropdownBehaviours', [
	        Toggling,
	        Coupling,
	        Keying,
	        Focusing
	      ]),
	      required$1('toggleClass'),
	      defaulted('eventOrder', {}),
	      option('lazySink'),
	      defaulted('matchWidth', false),
	      defaulted('useMinWidth', false),
	      option('role')
	    ].concat(sandboxFields()));
	    var parts$d = constant$1([
	      external$1({
	        schema: [tieredMenuMarkers()],
	        name: 'menu',
	        defaults: function (detail) {
	          return { onExecute: detail.onExecute };
	        }
	      }),
	      partType$1()
	    ]);
	
	    var factory$g = function (detail, components, _spec, externals) {
	      var _a;
	      var lookupAttr = function (attr) {
	        return get$e(detail.dom, 'attributes').bind(function (attrs) {
	          return get$e(attrs, attr);
	        });
	      };
	      var switchToMenu = function (sandbox) {
	        Sandboxing.getState(sandbox).each(function (tmenu) {
	          tieredMenu.highlightPrimary(tmenu);
	        });
	      };
	      var action = function (component) {
	        var onOpenSync = switchToMenu;
	        togglePopup(detail, identity$1, component, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	      };
	      var apis = {
	        expand: function (comp) {
	          if (!Toggling.isOn(comp)) {
	            togglePopup(detail, identity$1, comp, externals, noop, HighlightOnOpen.HighlightNone).get(noop);
	          }
	        },
	        open: function (comp) {
	          if (!Toggling.isOn(comp)) {
	            togglePopup(detail, identity$1, comp, externals, noop, HighlightOnOpen.HighlightFirst).get(noop);
	          }
	        },
	        isOpen: Toggling.isOn,
	        close: function (comp) {
	          if (Toggling.isOn(comp)) {
	            togglePopup(detail, identity$1, comp, externals, noop, HighlightOnOpen.HighlightFirst).get(noop);
	          }
	        },
	        repositionMenus: function (comp) {
	          if (Toggling.isOn(comp)) {
	            repositionMenus(comp);
	          }
	        }
	      };
	      var triggerExecute = function (comp, _se) {
	        emitExecute(comp);
	        return Optional.some(true);
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.dropdownBehaviours, [
	          Toggling.config({
	            toggleClass: detail.toggleClass,
	            aria: { mode: 'expanded' }
	          }),
	          Coupling.config({
	            others: {
	              sandbox: function (hotspot) {
	                return makeSandbox$1(detail, hotspot, {
	                  onOpen: function () {
	                    return Toggling.on(hotspot);
	                  },
	                  onClose: function () {
	                    return Toggling.off(hotspot);
	                  }
	                });
	              }
	            }
	          }),
	          Keying.config({
	            mode: 'special',
	            onSpace: triggerExecute,
	            onEnter: triggerExecute,
	            onDown: function (comp, _se) {
	              if (Dropdown.isOpen(comp)) {
	                var sandbox = Coupling.getCoupled(comp, 'sandbox');
	                switchToMenu(sandbox);
	              } else {
	                Dropdown.open(comp);
	              }
	              return Optional.some(true);
	            },
	            onEscape: function (comp, _se) {
	              if (Dropdown.isOpen(comp)) {
	                Dropdown.close(comp);
	                return Optional.some(true);
	              } else {
	                return Optional.none();
	              }
	            }
	          }),
	          Focusing.config({})
	        ]),
	        events: events$a(Optional.some(action)),
	        eventOrder: __assign(__assign({}, detail.eventOrder), (_a = {}, _a[execute$5()] = [
	          'disabling',
	          'toggling',
	          'alloy.base.behaviour'
	        ], _a)),
	        apis: apis,
	        domModification: {
	          attributes: __assign(__assign({ 'aria-haspopup': 'true' }, detail.role.fold(function () {
	            return {};
	          }, function (role) {
	            return { role: role };
	          })), detail.dom.tag === 'button' ? { type: lookupAttr('type').getOr('button') } : {})
	        }
	      };
	    };
	    var Dropdown = composite({
	      name: 'Dropdown',
	      configFields: schema$j(),
	      partFields: parts$d(),
	      factory: factory$g,
	      apis: {
	        open: function (apis, comp) {
	          return apis.open(comp);
	        },
	        expand: function (apis, comp) {
	          return apis.expand(comp);
	        },
	        close: function (apis, comp) {
	          return apis.close(comp);
	        },
	        isOpen: function (apis, comp) {
	          return apis.isOpen(comp);
	        },
	        repositionMenus: function (apis, comp) {
	          return apis.repositionMenus(comp);
	        }
	      }
	    });
	
	    var exhibit$1 = function () {
	      return nu$7({
	        styles: {
	          '-webkit-user-select': 'none',
	          'user-select': 'none',
	          '-ms-user-select': 'none',
	          '-moz-user-select': '-moz-none'
	        },
	        attributes: { unselectable: 'on' }
	      });
	    };
	    var events$7 = function () {
	      return derive$2([abort(selectstart(), always)]);
	    };
	
	    var ActiveUnselecting = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$7,
	        exhibit: exhibit$1
	    });
	
	    var Unselecting = create$8({
	      fields: [],
	      name: 'unselecting',
	      active: ActiveUnselecting
	    });
	
	    var renderPanelButton = function (spec, sharedBackstage) {
	      return Dropdown.sketch({
	        dom: spec.dom,
	        components: spec.components,
	        toggleClass: 'mce-active',
	        dropdownBehaviours: derive$1([
	          DisablingConfigs.button(sharedBackstage.providers.isDisabled),
	          receivingConfig(),
	          Unselecting.config({}),
	          Tabstopping.config({})
	        ]),
	        layouts: spec.layouts,
	        sandboxClasses: ['tox-dialog__popups'],
	        lazySink: sharedBackstage.getSink,
	        fetch: function (comp) {
	          return Future.nu(function (callback) {
	            return spec.fetch(callback);
	          }).map(function (items) {
	            return Optional.from(createTieredDataFrom(deepMerge(createPartialChoiceMenu(generate$6('menu-value'), items, function (value) {
	              spec.onItemAction(comp, value);
	            }, spec.columns, spec.presets, ItemResponse$1.CLOSE_ON_EXECUTE, never, sharedBackstage.providers), { movement: deriveMenuMovement(spec.columns, spec.presets) })));
	          });
	        },
	        parts: { menu: part(false, 1, spec.presets) }
	      });
	    };
	
	    var colorInputChangeEvent = generate$6('color-input-change');
	    var colorSwatchChangeEvent = generate$6('color-swatch-change');
	    var colorPickerCancelEvent = generate$6('color-picker-cancel');
	    var renderColorInput = function (spec, sharedBackstage, colorInputBackstage) {
	      var pField = FormField.parts.field({
	        factory: Input,
	        inputClasses: ['tox-textfield'],
	        onSetValue: function (c) {
	          return Invalidating.run(c).get(noop);
	        },
	        inputBehaviours: derive$1([
	          Disabling.config({ disabled: sharedBackstage.providers.isDisabled }),
	          receivingConfig(),
	          Tabstopping.config({}),
	          Invalidating.config({
	            invalidClass: 'tox-textbox-field-invalid',
	            getRoot: function (comp) {
	              return parent(comp.element);
	            },
	            notify: {
	              onValid: function (comp) {
	                var val = Representing.getValue(comp);
	                emitWith(comp, colorInputChangeEvent, { color: val });
	              }
	            },
	            validator: {
	              validateOnLoad: false,
	              validate: function (input) {
	                var inputValue = Representing.getValue(input);
	                if (inputValue.length === 0) {
	                  return Future.pure(Result.value(true));
	                } else {
	                  var span = SugarElement.fromTag('span');
	                  set$7(span, 'background-color', inputValue);
	                  var res = getRaw(span, 'background-color').fold(function () {
	                    return Result.error('blah');
	                  }, function (_) {
	                    return Result.value(inputValue);
	                  });
	                  return Future.pure(res);
	                }
	              }
	            }
	          })
	        ]),
	        selectOnFocus: false
	      });
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel$2(label, sharedBackstage.providers);
	      });
	      var emitSwatchChange = function (colorBit, value) {
	        emitWith(colorBit, colorSwatchChangeEvent, { value: value });
	      };
	      var onItemAction = function (comp, value) {
	        memColorButton.getOpt(comp).each(function (colorBit) {
	          if (value === 'custom') {
	            colorInputBackstage.colorPicker(function (valueOpt) {
	              valueOpt.fold(function () {
	                return emit(colorBit, colorPickerCancelEvent);
	              }, function (value) {
	                emitSwatchChange(colorBit, value);
	                addColor(value);
	              });
	            }, '#ffffff');
	          } else if (value === 'remove') {
	            emitSwatchChange(colorBit, '');
	          } else {
	            emitSwatchChange(colorBit, value);
	          }
	        });
	      };
	      var memColorButton = record(renderPanelButton({
	        dom: {
	          tag: 'span',
	          attributes: { 'aria-label': sharedBackstage.providers.translate('Color swatch') }
	        },
	        layouts: {
	          onRtl: function () {
	            return [
	              southwest$2,
	              southeast$2,
	              south$2
	            ];
	          },
	          onLtr: function () {
	            return [
	              southeast$2,
	              southwest$2,
	              south$2
	            ];
	          }
	        },
	        components: [],
	        fetch: getFetch$1(colorInputBackstage.getColors(), colorInputBackstage.hasCustomColors()),
	        columns: colorInputBackstage.getColorCols(),
	        presets: 'color',
	        onItemAction: onItemAction
	      }, sharedBackstage));
	      return FormField.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: pLabel.toArray().concat([{
	            dom: {
	              tag: 'div',
	              classes: ['tox-color-input']
	            },
	            components: [
	              pField,
	              memColorButton.asSpec()
	            ]
	          }]),
	        fieldBehaviours: derive$1([config('form-field-events', [
	            run$1(colorInputChangeEvent, function (comp, se) {
	              memColorButton.getOpt(comp).each(function (colorButton) {
	                set$7(colorButton.element, 'background-color', se.event.color);
	              });
	              emitWith(comp, formChangeEvent, { name: spec.name });
	            }),
	            run$1(colorSwatchChangeEvent, function (comp, se) {
	              FormField.getField(comp).each(function (field) {
	                Representing.setValue(field, se.event.value);
	                Composing.getCurrent(comp).each(Focusing.focus);
	              });
	            }),
	            run$1(colorPickerCancelEvent, function (comp, _se) {
	              FormField.getField(comp).each(function (_field) {
	                Composing.getCurrent(comp).each(Focusing.focus);
	              });
	            })
	          ])])
	      });
	    };
	
	    var labelPart = optional({
	      schema: [required$1('dom')],
	      name: 'label'
	    });
	    var edgePart = function (name) {
	      return optional({
	        name: '' + name + '-edge',
	        overrides: function (detail) {
	          var action = detail.model.manager.edgeActions[name];
	          return action.fold(function () {
	            return {};
	          }, function (a) {
	            return {
	              events: derive$2([
	                runActionExtra(touchstart(), function (comp, se, d) {
	                  return a(comp, d);
	                }, [detail]),
	                runActionExtra(mousedown(), function (comp, se, d) {
	                  return a(comp, d);
	                }, [detail]),
	                runActionExtra(mousemove(), function (comp, se, det) {
	                  if (det.mouseIsDown.get()) {
	                    a(comp, det);
	                  }
	                }, [detail])
	              ])
	            };
	          });
	        }
	      });
	    };
	    var tlEdgePart = edgePart('top-left');
	    var tedgePart = edgePart('top');
	    var trEdgePart = edgePart('top-right');
	    var redgePart = edgePart('right');
	    var brEdgePart = edgePart('bottom-right');
	    var bedgePart = edgePart('bottom');
	    var blEdgePart = edgePart('bottom-left');
	    var ledgePart = edgePart('left');
	    var thumbPart = required({
	      name: 'thumb',
	      defaults: constant$1({ dom: { styles: { position: 'absolute' } } }),
	      overrides: function (detail) {
	        return {
	          events: derive$2([
	            redirectToPart(touchstart(), detail, 'spectrum'),
	            redirectToPart(touchmove(), detail, 'spectrum'),
	            redirectToPart(touchend(), detail, 'spectrum'),
	            redirectToPart(mousedown(), detail, 'spectrum'),
	            redirectToPart(mousemove(), detail, 'spectrum'),
	            redirectToPart(mouseup(), detail, 'spectrum')
	          ])
	        };
	      }
	    });
	    var spectrumPart = required({
	      schema: [customField('mouseIsDown', function () {
	          return Cell(false);
	        })],
	      name: 'spectrum',
	      overrides: function (detail) {
	        var modelDetail = detail.model;
	        var model = modelDetail.manager;
	        var setValueFrom = function (component, simulatedEvent) {
	          return model.getValueFromEvent(simulatedEvent).map(function (value) {
	            return model.setValueFrom(component, detail, value);
	          });
	        };
	        return {
	          behaviours: derive$1([
	            Keying.config({
	              mode: 'special',
	              onLeft: function (spectrum) {
	                return model.onLeft(spectrum, detail);
	              },
	              onRight: function (spectrum) {
	                return model.onRight(spectrum, detail);
	              },
	              onUp: function (spectrum) {
	                return model.onUp(spectrum, detail);
	              },
	              onDown: function (spectrum) {
	                return model.onDown(spectrum, detail);
	              }
	            }),
	            Focusing.config({})
	          ]),
	          events: derive$2([
	            run$1(touchstart(), setValueFrom),
	            run$1(touchmove(), setValueFrom),
	            run$1(mousedown(), setValueFrom),
	            run$1(mousemove(), function (spectrum, se) {
	              if (detail.mouseIsDown.get()) {
	                setValueFrom(spectrum, se);
	              }
	            })
	          ])
	        };
	      }
	    });
	    var SliderParts = [
	      labelPart,
	      ledgePart,
	      redgePart,
	      tedgePart,
	      bedgePart,
	      tlEdgePart,
	      trEdgePart,
	      blEdgePart,
	      brEdgePart,
	      thumbPart,
	      spectrumPart
	    ];
	
	    var _sliderChangeEvent = 'slider.change.value';
	    var sliderChangeEvent = constant$1(_sliderChangeEvent);
	    var isTouchEvent$2 = function (evt) {
	      return evt.type.indexOf('touch') !== -1;
	    };
	    var getEventSource = function (simulatedEvent) {
	      var evt = simulatedEvent.event.raw;
	      if (isTouchEvent$2(evt)) {
	        var touchEvent = evt;
	        return touchEvent.touches !== undefined && touchEvent.touches.length === 1 ? Optional.some(touchEvent.touches[0]).map(function (t) {
	          return SugarPosition(t.clientX, t.clientY);
	        }) : Optional.none();
	      } else {
	        var mouseEvent = evt;
	        return mouseEvent.clientX !== undefined ? Optional.some(mouseEvent).map(function (me) {
	          return SugarPosition(me.clientX, me.clientY);
	        }) : Optional.none();
	      }
	    };
	
	    var t = 'top', r = 'right', b = 'bottom', l = 'left';
	    var minX = function (detail) {
	      return detail.model.minX;
	    };
	    var minY = function (detail) {
	      return detail.model.minY;
	    };
	    var min1X = function (detail) {
	      return detail.model.minX - 1;
	    };
	    var min1Y = function (detail) {
	      return detail.model.minY - 1;
	    };
	    var maxX = function (detail) {
	      return detail.model.maxX;
	    };
	    var maxY = function (detail) {
	      return detail.model.maxY;
	    };
	    var max1X = function (detail) {
	      return detail.model.maxX + 1;
	    };
	    var max1Y = function (detail) {
	      return detail.model.maxY + 1;
	    };
	    var range = function (detail, max, min) {
	      return max(detail) - min(detail);
	    };
	    var xRange = function (detail) {
	      return range(detail, maxX, minX);
	    };
	    var yRange = function (detail) {
	      return range(detail, maxY, minY);
	    };
	    var halfX = function (detail) {
	      return xRange(detail) / 2;
	    };
	    var halfY = function (detail) {
	      return yRange(detail) / 2;
	    };
	    var step = function (detail) {
	      return detail.stepSize;
	    };
	    var snap = function (detail) {
	      return detail.snapToGrid;
	    };
	    var snapStart = function (detail) {
	      return detail.snapStart;
	    };
	    var rounded = function (detail) {
	      return detail.rounded;
	    };
	    var hasEdge = function (detail, edgeName) {
	      return detail[edgeName + '-edge'] !== undefined;
	    };
	    var hasLEdge = function (detail) {
	      return hasEdge(detail, l);
	    };
	    var hasREdge = function (detail) {
	      return hasEdge(detail, r);
	    };
	    var hasTEdge = function (detail) {
	      return hasEdge(detail, t);
	    };
	    var hasBEdge = function (detail) {
	      return hasEdge(detail, b);
	    };
	    var currentValue = function (detail) {
	      return detail.model.value.get();
	    };
	
	    var xValue = function (x) {
	      return { x: x };
	    };
	    var yValue = function (y) {
	      return { y: y };
	    };
	    var xyValue = function (x, y) {
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var fireSliderChange$3 = function (component, value) {
	      emitWith(component, sliderChangeEvent(), { value: value });
	    };
	    var setToTLEdgeXY = function (edge, detail) {
	      fireSliderChange$3(edge, xyValue(min1X(detail), min1Y(detail)));
	    };
	    var setToTEdge = function (edge, detail) {
	      fireSliderChange$3(edge, yValue(min1Y(detail)));
	    };
	    var setToTEdgeXY = function (edge, detail) {
	      fireSliderChange$3(edge, xyValue(halfX(detail), min1Y(detail)));
	    };
	    var setToTREdgeXY = function (edge, detail) {
	      fireSliderChange$3(edge, xyValue(max1X(detail), min1Y(detail)));
	    };
	    var setToREdge = function (edge, detail) {
	      fireSliderChange$3(edge, xValue(max1X(detail)));
	    };
	    var setToREdgeXY = function (edge, detail) {
	      fireSliderChange$3(edge, xyValue(max1X(detail), halfY(detail)));
	    };
	    var setToBREdgeXY = function (edge, detail) {
	      fireSliderChange$3(edge, xyValue(max1X(detail), max1Y(detail)));
	    };
	    var setToBEdge = function (edge, detail) {
	      fireSliderChange$3(edge, yValue(max1Y(detail)));
	    };
	    var setToBEdgeXY = function (edge, detail) {
	      fireSliderChange$3(edge, xyValue(halfX(detail), max1Y(detail)));
	    };
	    var setToBLEdgeXY = function (edge, detail) {
	      fireSliderChange$3(edge, xyValue(min1X(detail), max1Y(detail)));
	    };
	    var setToLEdge = function (edge, detail) {
	      fireSliderChange$3(edge, xValue(min1X(detail)));
	    };
	    var setToLEdgeXY = function (edge, detail) {
	      fireSliderChange$3(edge, xyValue(min1X(detail), halfY(detail)));
	    };
	
	    var reduceBy = function (value, min, max, step) {
	      if (value < min) {
	        return value;
	      } else if (value > max) {
	        return max;
	      } else if (value === min) {
	        return min - 1;
	      } else {
	        return Math.max(min, value - step);
	      }
	    };
	    var increaseBy = function (value, min, max, step) {
	      if (value > max) {
	        return value;
	      } else if (value < min) {
	        return min;
	      } else if (value === max) {
	        return max + 1;
	      } else {
	        return Math.min(max, value + step);
	      }
	    };
	    var capValue = function (value, min, max) {
	      return Math.max(min, Math.min(max, value));
	    };
	    var snapValueOf = function (value, min, max, step, snapStart) {
	      return snapStart.fold(function () {
	        var initValue = value - min;
	        var extraValue = Math.round(initValue / step) * step;
	        return capValue(min + extraValue, min - 1, max + 1);
	      }, function (start) {
	        var remainder = (value - start) % step;
	        var adjustment = Math.round(remainder / step);
	        var rawSteps = Math.floor((value - start) / step);
	        var maxSteps = Math.floor((max - start) / step);
	        var numSteps = Math.min(maxSteps, rawSteps + adjustment);
	        var r = start + numSteps * step;
	        return Math.max(start, r);
	      });
	    };
	    var findOffsetOf = function (value, min, max) {
	      return Math.min(max, Math.max(value, min)) - min;
	    };
	    var findValueOf = function (args) {
	      var min = args.min, max = args.max, range = args.range, value = args.value, step = args.step, snap = args.snap, snapStart = args.snapStart, rounded = args.rounded, hasMinEdge = args.hasMinEdge, hasMaxEdge = args.hasMaxEdge, minBound = args.minBound, maxBound = args.maxBound, screenRange = args.screenRange;
	      var capMin = hasMinEdge ? min - 1 : min;
	      var capMax = hasMaxEdge ? max + 1 : max;
	      if (value < minBound) {
	        return capMin;
	      } else if (value > maxBound) {
	        return capMax;
	      } else {
	        var offset = findOffsetOf(value, minBound, maxBound);
	        var newValue = capValue(offset / screenRange * range + min, capMin, capMax);
	        if (snap && newValue >= min && newValue <= max) {
	          return snapValueOf(newValue, min, max, step, snapStart);
	        } else if (rounded) {
	          return Math.round(newValue);
	        } else {
	          return newValue;
	        }
	      }
	    };
	    var findOffsetOfValue$2 = function (args) {
	      var min = args.min, max = args.max, range = args.range, value = args.value, hasMinEdge = args.hasMinEdge, hasMaxEdge = args.hasMaxEdge, maxBound = args.maxBound, maxOffset = args.maxOffset, centerMinEdge = args.centerMinEdge, centerMaxEdge = args.centerMaxEdge;
	      if (value < min) {
	        return hasMinEdge ? 0 : centerMinEdge;
	      } else if (value > max) {
	        return hasMaxEdge ? maxBound : centerMaxEdge;
	      } else {
	        return (value - min) / range * maxOffset;
	      }
	    };
	
	    var top = 'top', right = 'right', bottom = 'bottom', left = 'left', width = 'width', height = 'height';
	    var getBounds = function (component) {
	      return component.element.dom.getBoundingClientRect();
	    };
	    var getBoundsProperty = function (bounds, property) {
	      return bounds[property];
	    };
	    var getMinXBounds = function (component) {
	      var bounds = getBounds(component);
	      return getBoundsProperty(bounds, left);
	    };
	    var getMaxXBounds = function (component) {
	      var bounds = getBounds(component);
	      return getBoundsProperty(bounds, right);
	    };
	    var getMinYBounds = function (component) {
	      var bounds = getBounds(component);
	      return getBoundsProperty(bounds, top);
	    };
	    var getMaxYBounds = function (component) {
	      var bounds = getBounds(component);
	      return getBoundsProperty(bounds, bottom);
	    };
	    var getXScreenRange = function (component) {
	      var bounds = getBounds(component);
	      return getBoundsProperty(bounds, width);
	    };
	    var getYScreenRange = function (component) {
	      var bounds = getBounds(component);
	      return getBoundsProperty(bounds, height);
	    };
	    var getCenterOffsetOf = function (componentMinEdge, componentMaxEdge, spectrumMinEdge) {
	      return (componentMinEdge + componentMaxEdge) / 2 - spectrumMinEdge;
	    };
	    var getXCenterOffSetOf = function (component, spectrum) {
	      var componentBounds = getBounds(component);
	      var spectrumBounds = getBounds(spectrum);
	      var componentMinEdge = getBoundsProperty(componentBounds, left);
	      var componentMaxEdge = getBoundsProperty(componentBounds, right);
	      var spectrumMinEdge = getBoundsProperty(spectrumBounds, left);
	      return getCenterOffsetOf(componentMinEdge, componentMaxEdge, spectrumMinEdge);
	    };
	    var getYCenterOffSetOf = function (component, spectrum) {
	      var componentBounds = getBounds(component);
	      var spectrumBounds = getBounds(spectrum);
	      var componentMinEdge = getBoundsProperty(componentBounds, top);
	      var componentMaxEdge = getBoundsProperty(componentBounds, bottom);
	      var spectrumMinEdge = getBoundsProperty(spectrumBounds, top);
	      return getCenterOffsetOf(componentMinEdge, componentMaxEdge, spectrumMinEdge);
	    };
	
	    var fireSliderChange$2 = function (spectrum, value) {
	      emitWith(spectrum, sliderChangeEvent(), { value: value });
	    };
	    var sliderValue$2 = function (x) {
	      return { x: x };
	    };
	    var findValueOfOffset$1 = function (spectrum, detail, left) {
	      var args = {
	        min: minX(detail),
	        max: maxX(detail),
	        range: xRange(detail),
	        value: left,
	        step: step(detail),
	        snap: snap(detail),
	        snapStart: snapStart(detail),
	        rounded: rounded(detail),
	        hasMinEdge: hasLEdge(detail),
	        hasMaxEdge: hasREdge(detail),
	        minBound: getMinXBounds(spectrum),
	        maxBound: getMaxXBounds(spectrum),
	        screenRange: getXScreenRange(spectrum)
	      };
	      return findValueOf(args);
	    };
	    var setValueFrom$2 = function (spectrum, detail, value) {
	      var xValue = findValueOfOffset$1(spectrum, detail, value);
	      var sliderVal = sliderValue$2(xValue);
	      fireSliderChange$2(spectrum, sliderVal);
	      return xValue;
	    };
	    var setToMin$2 = function (spectrum, detail) {
	      var min = minX(detail);
	      fireSliderChange$2(spectrum, sliderValue$2(min));
	    };
	    var setToMax$2 = function (spectrum, detail) {
	      var max = maxX(detail);
	      fireSliderChange$2(spectrum, sliderValue$2(max));
	    };
	    var moveBy$2 = function (direction, spectrum, detail) {
	      var f = direction > 0 ? increaseBy : reduceBy;
	      var xValue = f(currentValue(detail).x, minX(detail), maxX(detail), step(detail));
	      fireSliderChange$2(spectrum, sliderValue$2(xValue));
	      return Optional.some(xValue);
	    };
	    var handleMovement$2 = function (direction) {
	      return function (spectrum, detail) {
	        return moveBy$2(direction, spectrum, detail).map(always);
	      };
	    };
	    var getValueFromEvent$2 = function (simulatedEvent) {
	      var pos = getEventSource(simulatedEvent);
	      return pos.map(function (p) {
	        return p.left;
	      });
	    };
	    var findOffsetOfValue$1 = function (spectrum, detail, value, minEdge, maxEdge) {
	      var minOffset = 0;
	      var maxOffset = getXScreenRange(spectrum);
	      var centerMinEdge = minEdge.bind(function (edge) {
	        return Optional.some(getXCenterOffSetOf(edge, spectrum));
	      }).getOr(minOffset);
	      var centerMaxEdge = maxEdge.bind(function (edge) {
	        return Optional.some(getXCenterOffSetOf(edge, spectrum));
	      }).getOr(maxOffset);
	      var args = {
	        min: minX(detail),
	        max: maxX(detail),
	        range: xRange(detail),
	        value: value,
	        hasMinEdge: hasLEdge(detail),
	        hasMaxEdge: hasREdge(detail),
	        minBound: getMinXBounds(spectrum),
	        minOffset: minOffset,
	        maxBound: getMaxXBounds(spectrum),
	        maxOffset: maxOffset,
	        centerMinEdge: centerMinEdge,
	        centerMaxEdge: centerMaxEdge
	      };
	      return findOffsetOfValue$2(args);
	    };
	    var findPositionOfValue$1 = function (slider, spectrum, value, minEdge, maxEdge, detail) {
	      var offset = findOffsetOfValue$1(spectrum, detail, value, minEdge, maxEdge);
	      return getMinXBounds(spectrum) - getMinXBounds(slider) + offset;
	    };
	    var setPositionFromValue$2 = function (slider, thumb, detail, edges) {
	      var value = currentValue(detail);
	      var pos = findPositionOfValue$1(slider, edges.getSpectrum(slider), value.x, edges.getLeftEdge(slider), edges.getRightEdge(slider), detail);
	      var thumbRadius = get$a(thumb.element) / 2;
	      set$7(thumb.element, 'left', pos - thumbRadius + 'px');
	    };
	    var onLeft$2 = handleMovement$2(-1);
	    var onRight$2 = handleMovement$2(1);
	    var onUp$2 = Optional.none;
	    var onDown$2 = Optional.none;
	    var edgeActions$2 = {
	      'top-left': Optional.none(),
	      'top': Optional.none(),
	      'top-right': Optional.none(),
	      'right': Optional.some(setToREdge),
	      'bottom-right': Optional.none(),
	      'bottom': Optional.none(),
	      'bottom-left': Optional.none(),
	      'left': Optional.some(setToLEdge)
	    };
	
	    var HorizontalModel = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setValueFrom: setValueFrom$2,
	        setToMin: setToMin$2,
	        setToMax: setToMax$2,
	        findValueOfOffset: findValueOfOffset$1,
	        getValueFromEvent: getValueFromEvent$2,
	        findPositionOfValue: findPositionOfValue$1,
	        setPositionFromValue: setPositionFromValue$2,
	        onLeft: onLeft$2,
	        onRight: onRight$2,
	        onUp: onUp$2,
	        onDown: onDown$2,
	        edgeActions: edgeActions$2
	    });
	
	    var fireSliderChange$1 = function (spectrum, value) {
	      emitWith(spectrum, sliderChangeEvent(), { value: value });
	    };
	    var sliderValue$1 = function (y) {
	      return { y: y };
	    };
	    var findValueOfOffset = function (spectrum, detail, top) {
	      var args = {
	        min: minY(detail),
	        max: maxY(detail),
	        range: yRange(detail),
	        value: top,
	        step: step(detail),
	        snap: snap(detail),
	        snapStart: snapStart(detail),
	        rounded: rounded(detail),
	        hasMinEdge: hasTEdge(detail),
	        hasMaxEdge: hasBEdge(detail),
	        minBound: getMinYBounds(spectrum),
	        maxBound: getMaxYBounds(spectrum),
	        screenRange: getYScreenRange(spectrum)
	      };
	      return findValueOf(args);
	    };
	    var setValueFrom$1 = function (spectrum, detail, value) {
	      var yValue = findValueOfOffset(spectrum, detail, value);
	      var sliderVal = sliderValue$1(yValue);
	      fireSliderChange$1(spectrum, sliderVal);
	      return yValue;
	    };
	    var setToMin$1 = function (spectrum, detail) {
	      var min = minY(detail);
	      fireSliderChange$1(spectrum, sliderValue$1(min));
	    };
	    var setToMax$1 = function (spectrum, detail) {
	      var max = maxY(detail);
	      fireSliderChange$1(spectrum, sliderValue$1(max));
	    };
	    var moveBy$1 = function (direction, spectrum, detail) {
	      var f = direction > 0 ? increaseBy : reduceBy;
	      var yValue = f(currentValue(detail).y, minY(detail), maxY(detail), step(detail));
	      fireSliderChange$1(spectrum, sliderValue$1(yValue));
	      return Optional.some(yValue);
	    };
	    var handleMovement$1 = function (direction) {
	      return function (spectrum, detail) {
	        return moveBy$1(direction, spectrum, detail).map(always);
	      };
	    };
	    var getValueFromEvent$1 = function (simulatedEvent) {
	      var pos = getEventSource(simulatedEvent);
	      return pos.map(function (p) {
	        return p.top;
	      });
	    };
	    var findOffsetOfValue = function (spectrum, detail, value, minEdge, maxEdge) {
	      var minOffset = 0;
	      var maxOffset = getYScreenRange(spectrum);
	      var centerMinEdge = minEdge.bind(function (edge) {
	        return Optional.some(getYCenterOffSetOf(edge, spectrum));
	      }).getOr(minOffset);
	      var centerMaxEdge = maxEdge.bind(function (edge) {
	        return Optional.some(getYCenterOffSetOf(edge, spectrum));
	      }).getOr(maxOffset);
	      var args = {
	        min: minY(detail),
	        max: maxY(detail),
	        range: yRange(detail),
	        value: value,
	        hasMinEdge: hasTEdge(detail),
	        hasMaxEdge: hasBEdge(detail),
	        minBound: getMinYBounds(spectrum),
	        minOffset: minOffset,
	        maxBound: getMaxYBounds(spectrum),
	        maxOffset: maxOffset,
	        centerMinEdge: centerMinEdge,
	        centerMaxEdge: centerMaxEdge
	      };
	      return findOffsetOfValue$2(args);
	    };
	    var findPositionOfValue = function (slider, spectrum, value, minEdge, maxEdge, detail) {
	      var offset = findOffsetOfValue(spectrum, detail, value, minEdge, maxEdge);
	      return getMinYBounds(spectrum) - getMinYBounds(slider) + offset;
	    };
	    var setPositionFromValue$1 = function (slider, thumb, detail, edges) {
	      var value = currentValue(detail);
	      var pos = findPositionOfValue(slider, edges.getSpectrum(slider), value.y, edges.getTopEdge(slider), edges.getBottomEdge(slider), detail);
	      var thumbRadius = get$b(thumb.element) / 2;
	      set$7(thumb.element, 'top', pos - thumbRadius + 'px');
	    };
	    var onLeft$1 = Optional.none;
	    var onRight$1 = Optional.none;
	    var onUp$1 = handleMovement$1(-1);
	    var onDown$1 = handleMovement$1(1);
	    var edgeActions$1 = {
	      'top-left': Optional.none(),
	      'top': Optional.some(setToTEdge),
	      'top-right': Optional.none(),
	      'right': Optional.none(),
	      'bottom-right': Optional.none(),
	      'bottom': Optional.some(setToBEdge),
	      'bottom-left': Optional.none(),
	      'left': Optional.none()
	    };
	
	    var VerticalModel = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setValueFrom: setValueFrom$1,
	        setToMin: setToMin$1,
	        setToMax: setToMax$1,
	        findValueOfOffset: findValueOfOffset,
	        getValueFromEvent: getValueFromEvent$1,
	        findPositionOfValue: findPositionOfValue,
	        setPositionFromValue: setPositionFromValue$1,
	        onLeft: onLeft$1,
	        onRight: onRight$1,
	        onUp: onUp$1,
	        onDown: onDown$1,
	        edgeActions: edgeActions$1
	    });
	
	    var fireSliderChange = function (spectrum, value) {
	      emitWith(spectrum, sliderChangeEvent(), { value: value });
	    };
	    var sliderValue = function (x, y) {
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var setValueFrom = function (spectrum, detail, value) {
	      var xValue = findValueOfOffset$1(spectrum, detail, value.left);
	      var yValue = findValueOfOffset(spectrum, detail, value.top);
	      var val = sliderValue(xValue, yValue);
	      fireSliderChange(spectrum, val);
	      return val;
	    };
	    var moveBy = function (direction, isVerticalMovement, spectrum, detail) {
	      var f = direction > 0 ? increaseBy : reduceBy;
	      var xValue = isVerticalMovement ? currentValue(detail).x : f(currentValue(detail).x, minX(detail), maxX(detail), step(detail));
	      var yValue = !isVerticalMovement ? currentValue(detail).y : f(currentValue(detail).y, minY(detail), maxY(detail), step(detail));
	      fireSliderChange(spectrum, sliderValue(xValue, yValue));
	      return Optional.some(xValue);
	    };
	    var handleMovement = function (direction, isVerticalMovement) {
	      return function (spectrum, detail) {
	        return moveBy(direction, isVerticalMovement, spectrum, detail).map(always);
	      };
	    };
	    var setToMin = function (spectrum, detail) {
	      var mX = minX(detail);
	      var mY = minY(detail);
	      fireSliderChange(spectrum, sliderValue(mX, mY));
	    };
	    var setToMax = function (spectrum, detail) {
	      var mX = maxX(detail);
	      var mY = maxY(detail);
	      fireSliderChange(spectrum, sliderValue(mX, mY));
	    };
	    var getValueFromEvent = function (simulatedEvent) {
	      return getEventSource(simulatedEvent);
	    };
	    var setPositionFromValue = function (slider, thumb, detail, edges) {
	      var value = currentValue(detail);
	      var xPos = findPositionOfValue$1(slider, edges.getSpectrum(slider), value.x, edges.getLeftEdge(slider), edges.getRightEdge(slider), detail);
	      var yPos = findPositionOfValue(slider, edges.getSpectrum(slider), value.y, edges.getTopEdge(slider), edges.getBottomEdge(slider), detail);
	      var thumbXRadius = get$a(thumb.element) / 2;
	      var thumbYRadius = get$b(thumb.element) / 2;
	      set$7(thumb.element, 'left', xPos - thumbXRadius + 'px');
	      set$7(thumb.element, 'top', yPos - thumbYRadius + 'px');
	    };
	    var onLeft = handleMovement(-1, false);
	    var onRight = handleMovement(1, false);
	    var onUp = handleMovement(-1, true);
	    var onDown = handleMovement(1, true);
	    var edgeActions = {
	      'top-left': Optional.some(setToTLEdgeXY),
	      'top': Optional.some(setToTEdgeXY),
	      'top-right': Optional.some(setToTREdgeXY),
	      'right': Optional.some(setToREdgeXY),
	      'bottom-right': Optional.some(setToBREdgeXY),
	      'bottom': Optional.some(setToBEdgeXY),
	      'bottom-left': Optional.some(setToBLEdgeXY),
	      'left': Optional.some(setToLEdgeXY)
	    };
	
	    var TwoDModel = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setValueFrom: setValueFrom,
	        setToMin: setToMin,
	        setToMax: setToMax,
	        getValueFromEvent: getValueFromEvent,
	        setPositionFromValue: setPositionFromValue,
	        onLeft: onLeft,
	        onRight: onRight,
	        onUp: onUp,
	        onDown: onDown,
	        edgeActions: edgeActions
	    });
	
	    var SliderSchema = [
	      defaulted('stepSize', 1),
	      defaulted('onChange', noop),
	      defaulted('onChoose', noop),
	      defaulted('onInit', noop),
	      defaulted('onDragStart', noop),
	      defaulted('onDragEnd', noop),
	      defaulted('snapToGrid', false),
	      defaulted('rounded', true),
	      option('snapStart'),
	      requiredOf('model', choose$1('mode', {
	        x: [
	          defaulted('minX', 0),
	          defaulted('maxX', 100),
	          customField('value', function (spec) {
	            return Cell(spec.mode.minX);
	          }),
	          required$1('getInitialValue'),
	          output$1('manager', HorizontalModel)
	        ],
	        y: [
	          defaulted('minY', 0),
	          defaulted('maxY', 100),
	          customField('value', function (spec) {
	            return Cell(spec.mode.minY);
	          }),
	          required$1('getInitialValue'),
	          output$1('manager', VerticalModel)
	        ],
	        xy: [
	          defaulted('minX', 0),
	          defaulted('maxX', 100),
	          defaulted('minY', 0),
	          defaulted('maxY', 100),
	          customField('value', function (spec) {
	            return Cell({
	              x: spec.mode.minX,
	              y: spec.mode.minY
	            });
	          }),
	          required$1('getInitialValue'),
	          output$1('manager', TwoDModel)
	        ]
	      })),
	      field('sliderBehaviours', [
	        Keying,
	        Representing
	      ]),
	      customField('mouseIsDown', function () {
	        return Cell(false);
	      })
	    ];
	
	    var sketch$2 = function (detail, components, _spec, _externals) {
	      var _a;
	      var getThumb = function (component) {
	        return getPartOrDie(component, detail, 'thumb');
	      };
	      var getSpectrum = function (component) {
	        return getPartOrDie(component, detail, 'spectrum');
	      };
	      var getLeftEdge = function (component) {
	        return getPart(component, detail, 'left-edge');
	      };
	      var getRightEdge = function (component) {
	        return getPart(component, detail, 'right-edge');
	      };
	      var getTopEdge = function (component) {
	        return getPart(component, detail, 'top-edge');
	      };
	      var getBottomEdge = function (component) {
	        return getPart(component, detail, 'bottom-edge');
	      };
	      var modelDetail = detail.model;
	      var model = modelDetail.manager;
	      var refresh = function (slider, thumb) {
	        model.setPositionFromValue(slider, thumb, detail, {
	          getLeftEdge: getLeftEdge,
	          getRightEdge: getRightEdge,
	          getTopEdge: getTopEdge,
	          getBottomEdge: getBottomEdge,
	          getSpectrum: getSpectrum
	        });
	      };
	      var setValue = function (slider, newValue) {
	        modelDetail.value.set(newValue);
	        var thumb = getThumb(slider);
	        refresh(slider, thumb);
	      };
	      var changeValue = function (slider, newValue) {
	        setValue(slider, newValue);
	        var thumb = getThumb(slider);
	        detail.onChange(slider, thumb, newValue);
	        return Optional.some(true);
	      };
	      var resetToMin = function (slider) {
	        model.setToMin(slider, detail);
	      };
	      var resetToMax = function (slider) {
	        model.setToMax(slider, detail);
	      };
	      var choose = function (slider) {
	        var fireOnChoose = function () {
	          getPart(slider, detail, 'thumb').each(function (thumb) {
	            var value = modelDetail.value.get();
	            detail.onChoose(slider, thumb, value);
	          });
	        };
	        var wasDown = detail.mouseIsDown.get();
	        detail.mouseIsDown.set(false);
	        if (wasDown) {
	          fireOnChoose();
	        }
	      };
	      var onDragStart = function (slider, simulatedEvent) {
	        simulatedEvent.stop();
	        detail.mouseIsDown.set(true);
	        detail.onDragStart(slider, getThumb(slider));
	      };
	      var onDragEnd = function (slider, simulatedEvent) {
	        simulatedEvent.stop();
	        detail.onDragEnd(slider, getThumb(slider));
	        choose(slider);
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.sliderBehaviours, [
	          Keying.config({
	            mode: 'special',
	            focusIn: function (slider) {
	              return getPart(slider, detail, 'spectrum').map(Keying.focusIn).map(always);
	            }
	          }),
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (_) {
	                return modelDetail.value.get();
	              }
	            }
	          }),
	          Receiving.config({ channels: (_a = {}, _a[mouseReleased()] = { onReceive: choose }, _a) })
	        ]),
	        events: derive$2([
	          run$1(sliderChangeEvent(), function (slider, simulatedEvent) {
	            changeValue(slider, simulatedEvent.event.value);
	          }),
	          runOnAttached(function (slider, _simulatedEvent) {
	            var getInitial = modelDetail.getInitialValue();
	            modelDetail.value.set(getInitial);
	            var thumb = getThumb(slider);
	            refresh(slider, thumb);
	            var spectrum = getSpectrum(slider);
	            detail.onInit(slider, thumb, spectrum, modelDetail.value.get());
	          }),
	          run$1(touchstart(), onDragStart),
	          run$1(touchend(), onDragEnd),
	          run$1(mousedown(), onDragStart),
	          run$1(mouseup(), onDragEnd)
	        ]),
	        apis: {
	          resetToMin: resetToMin,
	          resetToMax: resetToMax,
	          setValue: setValue,
	          refresh: refresh
	        },
	        domModification: { styles: { position: 'relative' } }
	      };
	    };
	
	    var Slider = composite({
	      name: 'Slider',
	      configFields: SliderSchema,
	      partFields: SliderParts,
	      factory: sketch$2,
	      apis: {
	        setValue: function (apis, slider, value) {
	          apis.setValue(slider, value);
	        },
	        resetToMin: function (apis, slider) {
	          apis.resetToMin(slider);
	        },
	        resetToMax: function (apis, slider) {
	          apis.resetToMax(slider);
	        },
	        refresh: function (apis, slider) {
	          apis.refresh(slider);
	        }
	      }
	    });
	
	    var fieldsUpdate = generate$6('rgb-hex-update');
	    var sliderUpdate = generate$6('slider-update');
	    var paletteUpdate = generate$6('palette-update');
	
	    var sliderFactory = function (translate, getClass) {
	      var spectrum = Slider.parts.spectrum({
	        dom: {
	          tag: 'div',
	          classes: [getClass('hue-slider-spectrum')],
	          attributes: { role: 'presentation' }
	        }
	      });
	      var thumb = Slider.parts.thumb({
	        dom: {
	          tag: 'div',
	          classes: [getClass('hue-slider-thumb')],
	          attributes: { role: 'presentation' }
	        }
	      });
	      return Slider.sketch({
	        dom: {
	          tag: 'div',
	          classes: [getClass('hue-slider')],
	          attributes: { role: 'presentation' }
	        },
	        rounded: false,
	        model: {
	          mode: 'y',
	          getInitialValue: constant$1({ y: 0 })
	        },
	        components: [
	          spectrum,
	          thumb
	        ],
	        sliderBehaviours: derive$1([Focusing.config({})]),
	        onChange: function (slider, _thumb, value) {
	          emitWith(slider, sliderUpdate, { value: value });
	        }
	      });
	    };
	
	    var owner$1 = 'form';
	    var schema$i = [field('formBehaviours', [Representing])];
	    var getPartName$1 = function (name) {
	      return '<alloy.field.' + name + '>';
	    };
	    var sketch$1 = function (fSpec) {
	      var parts = function () {
	        var record = [];
	        var field = function (name, config) {
	          record.push(name);
	          return generateOne$1(owner$1, getPartName$1(name), config);
	        };
	        return {
	          field: field,
	          record: constant$1(record)
	        };
	      }();
	      var spec = fSpec(parts);
	      var partNames = parts.record();
	      var fieldParts = map$2(partNames, function (n) {
	        return required({
	          name: n,
	          pname: getPartName$1(n)
	        });
	      });
	      return composite$1(owner$1, schema$i, fieldParts, make$4, spec);
	    };
	    var toResult = function (o, e) {
	      return o.fold(function () {
	        return Result.error(e);
	      }, Result.value);
	    };
	    var make$4 = function (detail, components) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.formBehaviours, [Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (form) {
	                var resPs = getAllParts(form, detail);
	                return map$1(resPs, function (resPThunk, pName) {
	                  return resPThunk().bind(function (v) {
	                    var opt = Composing.getCurrent(v);
	                    return toResult(opt, new Error('Cannot find a current component to extract the value from for form part \'' + pName + '\': ' + element(v.element)));
	                  }).map(Representing.getValue);
	                });
	              },
	              setValue: function (form, values) {
	                each(values, function (newValue, key) {
	                  getPart(form, detail, key).each(function (wrapper) {
	                    Composing.getCurrent(wrapper).each(function (field) {
	                      Representing.setValue(field, newValue);
	                    });
	                  });
	                });
	              }
	            }
	          })]),
	        apis: {
	          getField: function (form, key) {
	            return getPart(form, detail, key).bind(Composing.getCurrent);
	          }
	        }
	      };
	    };
	    var Form = {
	      getField: makeApi(function (apis, component, key) {
	        return apis.getField(component, key);
	      }),
	      sketch: sketch$1
	    };
	
	    var validInput = generate$6('valid-input');
	    var invalidInput = generate$6('invalid-input');
	    var validatingInput = generate$6('validating-input');
	    var translatePrefix = 'colorcustom.rgb.';
	    var rgbFormFactory = function (translate, getClass, onValidHexx, onInvalidHexx) {
	      var invalidation = function (label, isValid) {
	        return Invalidating.config({
	          invalidClass: getClass('invalid'),
	          notify: {
	            onValidate: function (comp) {
	              emitWith(comp, validatingInput, { type: label });
	            },
	            onValid: function (comp) {
	              emitWith(comp, validInput, {
	                type: label,
	                value: Representing.getValue(comp)
	              });
	            },
	            onInvalid: function (comp) {
	              emitWith(comp, invalidInput, {
	                type: label,
	                value: Representing.getValue(comp)
	              });
	            }
	          },
	          validator: {
	            validate: function (comp) {
	              var value = Representing.getValue(comp);
	              var res = isValid(value) ? Result.value(true) : Result.error(translate('aria.input.invalid'));
	              return Future.pure(res);
	            },
	            validateOnLoad: false
	          }
	        });
	      };
	      var renderTextField = function (isValid, name, label, description, data) {
	        var helptext = translate(translatePrefix + 'range');
	        var pLabel = FormField.parts.label({
	          dom: {
	            tag: 'label',
	            innerHtml: label,
	            attributes: { 'aria-label': description }
	          }
	        });
	        var pField = FormField.parts.field({
	          data: data,
	          factory: Input,
	          inputAttributes: __assign({ type: 'text' }, name === 'hex' ? { 'aria-live': 'polite' } : {}),
	          inputClasses: [getClass('textfield')],
	          inputBehaviours: derive$1([
	            invalidation(name, isValid),
	            Tabstopping.config({})
	          ]),
	          onSetValue: function (input) {
	            if (Invalidating.isInvalid(input)) {
	              var run = Invalidating.run(input);
	              run.get(noop);
	            }
	          }
	        });
	        var comps = [
	          pLabel,
	          pField
	        ];
	        var concats = name !== 'hex' ? [FormField.parts['aria-descriptor']({ text: helptext })] : [];
	        var components = comps.concat(concats);
	        return {
	          dom: {
	            tag: 'div',
	            attributes: { role: 'presentation' }
	          },
	          components: components
	        };
	      };
	      var copyRgbToHex = function (form, rgba) {
	        var hex = fromRgba(rgba);
	        Form.getField(form, 'hex').each(function (hexField) {
	          if (!Focusing.isFocused(hexField)) {
	            Representing.setValue(form, { hex: hex.value });
	          }
	        });
	        return hex;
	      };
	      var copyRgbToForm = function (form, rgb) {
	        var red = rgb.red;
	        var green = rgb.green;
	        var blue = rgb.blue;
	        Representing.setValue(form, {
	          red: red,
	          green: green,
	          blue: blue
	        });
	      };
	      var memPreview = record({
	        dom: {
	          tag: 'div',
	          classes: [getClass('rgba-preview')],
	          styles: { 'background-color': 'white' },
	          attributes: { role: 'presentation' }
	        }
	      });
	      var updatePreview = function (anyInSystem, hex) {
	        memPreview.getOpt(anyInSystem).each(function (preview) {
	          set$7(preview.element, 'background-color', '#' + hex.value);
	        });
	      };
	      var factory = function () {
	        var state = {
	          red: Cell(Optional.some(255)),
	          green: Cell(Optional.some(255)),
	          blue: Cell(Optional.some(255)),
	          hex: Cell(Optional.some('ffffff'))
	        };
	        var copyHexToRgb = function (form, hex) {
	          var rgb = fromHex(hex);
	          copyRgbToForm(form, rgb);
	          setValueRgb(rgb);
	        };
	        var get = function (prop) {
	          return state[prop].get();
	        };
	        var set = function (prop, value) {
	          state[prop].set(value);
	        };
	        var getValueRgb = function () {
	          return get('red').bind(function (red) {
	            return get('green').bind(function (green) {
	              return get('blue').map(function (blue) {
	                return rgbaColour(red, green, blue, 1);
	              });
	            });
	          });
	        };
	        var setValueRgb = function (rgb) {
	          var red = rgb.red;
	          var green = rgb.green;
	          var blue = rgb.blue;
	          set('red', Optional.some(red));
	          set('green', Optional.some(green));
	          set('blue', Optional.some(blue));
	        };
	        var onInvalidInput = function (form, simulatedEvent) {
	          var data = simulatedEvent.event;
	          if (data.type !== 'hex') {
	            set(data.type, Optional.none());
	          } else {
	            onInvalidHexx(form);
	          }
	        };
	        var onValidHex = function (form, value) {
	          onValidHexx(form);
	          var hex = hexColour(value);
	          set('hex', Optional.some(value));
	          var rgb = fromHex(hex);
	          copyRgbToForm(form, rgb);
	          setValueRgb(rgb);
	          emitWith(form, fieldsUpdate, { hex: hex });
	          updatePreview(form, hex);
	        };
	        var onValidRgb = function (form, prop, value) {
	          var val = parseInt(value, 10);
	          set(prop, Optional.some(val));
	          getValueRgb().each(function (rgb) {
	            var hex = copyRgbToHex(form, rgb);
	            emitWith(form, fieldsUpdate, { hex: hex });
	            updatePreview(form, hex);
	          });
	        };
	        var isHexInputEvent = function (data) {
	          return data.type === 'hex';
	        };
	        var onValidInput = function (form, simulatedEvent) {
	          var data = simulatedEvent.event;
	          if (isHexInputEvent(data)) {
	            onValidHex(form, data.value);
	          } else {
	            onValidRgb(form, data.type, data.value);
	          }
	        };
	        var formPartStrings = function (key) {
	          return {
	            label: translate(translatePrefix + key + '.label'),
	            description: translate(translatePrefix + key + '.description')
	          };
	        };
	        var redStrings = formPartStrings('red');
	        var greenStrings = formPartStrings('green');
	        var blueStrings = formPartStrings('blue');
	        var hexStrings = formPartStrings('hex');
	        return deepMerge(Form.sketch(function (parts) {
	          return {
	            dom: {
	              tag: 'form',
	              classes: [getClass('rgb-form')],
	              attributes: { 'aria-label': translate('aria.color.picker') }
	            },
	            components: [
	              parts.field('red', FormField.sketch(renderTextField(isRgbaComponent, 'red', redStrings.label, redStrings.description, 255))),
	              parts.field('green', FormField.sketch(renderTextField(isRgbaComponent, 'green', greenStrings.label, greenStrings.description, 255))),
	              parts.field('blue', FormField.sketch(renderTextField(isRgbaComponent, 'blue', blueStrings.label, blueStrings.description, 255))),
	              parts.field('hex', FormField.sketch(renderTextField(isHexString, 'hex', hexStrings.label, hexStrings.description, 'ffffff'))),
	              memPreview.asSpec()
	            ],
	            formBehaviours: derive$1([
	              Invalidating.config({ invalidClass: getClass('form-invalid') }),
	              config('rgb-form-events', [
	                run$1(validInput, onValidInput),
	                run$1(invalidInput, onInvalidInput),
	                run$1(validatingInput, onInvalidInput)
	              ])
	            ])
	          };
	        }), {
	          apis: {
	            updateHex: function (form, hex) {
	              Representing.setValue(form, { hex: hex.value });
	              copyHexToRgb(form, hex);
	              updatePreview(form, hex);
	            }
	          }
	        });
	      };
	      var rgbFormSketcher = single({
	        factory: factory,
	        name: 'RgbForm',
	        configFields: [],
	        apis: {
	          updateHex: function (apis, form, hex) {
	            apis.updateHex(form, hex);
	          }
	        },
	        extraApis: {}
	      });
	      return rgbFormSketcher;
	    };
	
	    var paletteFactory = function (_translate, getClass) {
	      var spectrumPart = Slider.parts.spectrum({
	        dom: {
	          tag: 'canvas',
	          attributes: { role: 'presentation' },
	          classes: [getClass('sv-palette-spectrum')]
	        }
	      });
	      var thumbPart = Slider.parts.thumb({
	        dom: {
	          tag: 'div',
	          attributes: { role: 'presentation' },
	          classes: [getClass('sv-palette-thumb')],
	          innerHtml: '<div class=' + getClass('sv-palette-inner-thumb') + ' role="presentation"></div>'
	        }
	      });
	      var setColour = function (canvas, rgba) {
	        var width = canvas.width, height = canvas.height;
	        var ctx = canvas.getContext('2d');
	        if (ctx === null) {
	          return;
	        }
	        ctx.fillStyle = rgba;
	        ctx.fillRect(0, 0, width, height);
	        var grdWhite = ctx.createLinearGradient(0, 0, width, 0);
	        grdWhite.addColorStop(0, 'rgba(255,255,255,1)');
	        grdWhite.addColorStop(1, 'rgba(255,255,255,0)');
	        ctx.fillStyle = grdWhite;
	        ctx.fillRect(0, 0, width, height);
	        var grdBlack = ctx.createLinearGradient(0, 0, 0, height);
	        grdBlack.addColorStop(0, 'rgba(0,0,0,0)');
	        grdBlack.addColorStop(1, 'rgba(0,0,0,1)');
	        ctx.fillStyle = grdBlack;
	        ctx.fillRect(0, 0, width, height);
	      };
	      var setPaletteHue = function (slider, hue) {
	        var canvas = slider.components()[0].element.dom;
	        var hsv = hsvColour(hue, 100, 100);
	        var rgba = fromHsv(hsv);
	        setColour(canvas, toString(rgba));
	      };
	      var setPaletteThumb = function (slider, hex) {
	        var hsv = fromRgb(fromHex(hex));
	        Slider.setValue(slider, {
	          x: hsv.saturation,
	          y: 100 - hsv.value
	        });
	      };
	      var factory = function (_detail) {
	        var getInitialValue = constant$1({
	          x: 0,
	          y: 0
	        });
	        var onChange = function (slider, _thumb, value) {
	          emitWith(slider, paletteUpdate, { value: value });
	        };
	        var onInit = function (_slider, _thumb, spectrum, _value) {
	          setColour(spectrum.element.dom, toString(red));
	        };
	        var sliderBehaviours = derive$1([
	          Composing.config({ find: Optional.some }),
	          Focusing.config({})
	        ]);
	        return Slider.sketch({
	          dom: {
	            tag: 'div',
	            attributes: { role: 'presentation' },
	            classes: [getClass('sv-palette')]
	          },
	          model: {
	            mode: 'xy',
	            getInitialValue: getInitialValue
	          },
	          rounded: false,
	          components: [
	            spectrumPart,
	            thumbPart
	          ],
	          onChange: onChange,
	          onInit: onInit,
	          sliderBehaviours: sliderBehaviours
	        });
	      };
	      var saturationBrightnessPaletteSketcher = single({
	        factory: factory,
	        name: 'SaturationBrightnessPalette',
	        configFields: [],
	        apis: {
	          setHue: function (_apis, slider, hue) {
	            setPaletteHue(slider, hue);
	          },
	          setThumb: function (_apis, slider, hex) {
	            setPaletteThumb(slider, hex);
	          }
	        },
	        extraApis: {}
	      });
	      return saturationBrightnessPaletteSketcher;
	    };
	
	    var makeFactory = function (translate, getClass) {
	      var factory = function (detail) {
	        var rgbForm = rgbFormFactory(translate, getClass, detail.onValidHex, detail.onInvalidHex);
	        var sbPalette = paletteFactory(translate, getClass);
	        var hueSliderToDegrees = function (hue) {
	          return (100 - hue) / 100 * 360;
	        };
	        var hueDegreesToSlider = function (hue) {
	          return 100 - hue / 360 * 100;
	        };
	        var state = {
	          paletteRgba: Cell(red),
	          paletteHue: Cell(0)
	        };
	        var memSlider = record(sliderFactory(translate, getClass));
	        var memPalette = record(sbPalette.sketch({}));
	        var memRgb = record(rgbForm.sketch({}));
	        var updatePalette = function (anyInSystem, _hex, hue) {
	          memPalette.getOpt(anyInSystem).each(function (palette) {
	            sbPalette.setHue(palette, hue);
	          });
	        };
	        var updateFields = function (anyInSystem, hex) {
	          memRgb.getOpt(anyInSystem).each(function (form) {
	            rgbForm.updateHex(form, hex);
	          });
	        };
	        var updateSlider = function (anyInSystem, _hex, hue) {
	          memSlider.getOpt(anyInSystem).each(function (slider) {
	            Slider.setValue(slider, { y: hueDegreesToSlider(hue) });
	          });
	        };
	        var updatePaletteThumb = function (anyInSystem, hex) {
	          memPalette.getOpt(anyInSystem).each(function (palette) {
	            sbPalette.setThumb(palette, hex);
	          });
	        };
	        var updateState = function (hex, hue) {
	          var rgba = fromHex(hex);
	          state.paletteRgba.set(rgba);
	          state.paletteHue.set(hue);
	        };
	        var runUpdates = function (anyInSystem, hex, hue, updates) {
	          updateState(hex, hue);
	          each$1(updates, function (update) {
	            update(anyInSystem, hex, hue);
	          });
	        };
	        var onPaletteUpdate = function () {
	          var updates = [updateFields];
	          return function (form, simulatedEvent) {
	            var value = simulatedEvent.event.value;
	            var oldHue = state.paletteHue.get();
	            var newHsv = hsvColour(oldHue, value.x, 100 - value.y);
	            var newHex = hsvToHex(newHsv);
	            runUpdates(form, newHex, oldHue, updates);
	          };
	        };
	        var onSliderUpdate = function () {
	          var updates = [
	            updatePalette,
	            updateFields
	          ];
	          return function (form, simulatedEvent) {
	            var hue = hueSliderToDegrees(simulatedEvent.event.value.y);
	            var oldRgb = state.paletteRgba.get();
	            var oldHsv = fromRgb(oldRgb);
	            var newHsv = hsvColour(hue, oldHsv.saturation, oldHsv.value);
	            var newHex = hsvToHex(newHsv);
	            runUpdates(form, newHex, hue, updates);
	          };
	        };
	        var onFieldsUpdate = function () {
	          var updates = [
	            updatePalette,
	            updateSlider,
	            updatePaletteThumb
	          ];
	          return function (form, simulatedEvent) {
	            var hex = simulatedEvent.event.hex;
	            var hsv = hexToHsv(hex);
	            runUpdates(form, hex, hsv.hue, updates);
	          };
	        };
	        return {
	          uid: detail.uid,
	          dom: detail.dom,
	          components: [
	            memPalette.asSpec(),
	            memSlider.asSpec(),
	            memRgb.asSpec()
	          ],
	          behaviours: derive$1([
	            config('colour-picker-events', [
	              run$1(fieldsUpdate, onFieldsUpdate()),
	              run$1(paletteUpdate, onPaletteUpdate()),
	              run$1(sliderUpdate, onSliderUpdate())
	            ]),
	            Composing.config({
	              find: function (comp) {
	                return memRgb.getOpt(comp);
	              }
	            }),
	            Keying.config({ mode: 'acyclic' })
	          ])
	        };
	      };
	      var colourPickerSketcher = single({
	        name: 'ColourPicker',
	        configFields: [
	          required$1('dom'),
	          defaulted('onValidHex', noop),
	          defaulted('onInvalidHex', noop)
	        ],
	        factory: factory
	      });
	      return colourPickerSketcher;
	    };
	
	    var self$1 = function () {
	      return Composing.config({ find: Optional.some });
	    };
	    var memento$1 = function (mem) {
	      return Composing.config({ find: mem.getOpt });
	    };
	    var childAt = function (index) {
	      return Composing.config({
	        find: function (comp) {
	          return child$2(comp.element, index).bind(function (element) {
	            return comp.getSystem().getByDom(element).toOptional();
	          });
	        }
	      });
	    };
	    var ComposingConfigs = {
	      self: self$1,
	      memento: memento$1,
	      childAt: childAt
	    };
	
	    var english = {
	      'colorcustom.rgb.red.label': 'R',
	      'colorcustom.rgb.red.description': 'Red component',
	      'colorcustom.rgb.green.label': 'G',
	      'colorcustom.rgb.green.description': 'Green component',
	      'colorcustom.rgb.blue.label': 'B',
	      'colorcustom.rgb.blue.description': 'Blue component',
	      'colorcustom.rgb.hex.label': '#',
	      'colorcustom.rgb.hex.description': 'Hex color code',
	      'colorcustom.rgb.range': 'Range 0 to 255',
	      'colorcustom.sb.saturation': 'Saturation',
	      'colorcustom.sb.brightness': 'Brightness',
	      'colorcustom.sb.picker': 'Saturation and Brightness Picker',
	      'colorcustom.sb.palette': 'Saturation and Brightness Palette',
	      'colorcustom.sb.instructions': 'Use arrow keys to select saturation and brightness, on x and y axes',
	      'colorcustom.hue.hue': 'Hue',
	      'colorcustom.hue.slider': 'Hue Slider',
	      'colorcustom.hue.palette': 'Hue Palette',
	      'colorcustom.hue.instructions': 'Use arrow keys to select a hue',
	      'aria.color.picker': 'Color Picker',
	      'aria.input.invalid': 'Invalid input'
	    };
	    var getEnglishText = function (key) {
	      return english[key];
	    };
	    var translate$1 = function (key) {
	      return getEnglishText(key);
	    };
	    var renderColorPicker = function (_spec) {
	      var getClass = function (key) {
	        return 'tox-' + key;
	      };
	      var colourPickerFactory = makeFactory(translate$1, getClass);
	      var onValidHex = function (form) {
	        emitWith(form, formActionEvent, {
	          name: 'hex-valid',
	          value: true
	        });
	      };
	      var onInvalidHex = function (form) {
	        emitWith(form, formActionEvent, {
	          name: 'hex-valid',
	          value: false
	        });
	      };
	      var memPicker = record(colourPickerFactory.sketch({
	        dom: {
	          tag: 'div',
	          classes: [getClass('color-picker-container')],
	          attributes: { role: 'presentation' }
	        },
	        onValidHex: onValidHex,
	        onInvalidHex: onInvalidHex
	      }));
	      return {
	        dom: { tag: 'div' },
	        components: [memPicker.asSpec()],
	        behaviours: derive$1([
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (comp) {
	                var picker = memPicker.get(comp);
	                var optRgbForm = Composing.getCurrent(picker);
	                var optHex = optRgbForm.bind(function (rgbForm) {
	                  var formValues = Representing.getValue(rgbForm);
	                  return formValues.hex;
	                });
	                return optHex.map(function (hex) {
	                  return '#' + hex;
	                }).getOr('');
	              },
	              setValue: function (comp, newValue) {
	                var pattern = /^#([a-fA-F0-9]{3}(?:[a-fA-F0-9]{3})?)/;
	                var m = pattern.exec(newValue);
	                var picker = memPicker.get(comp);
	                var optRgbForm = Composing.getCurrent(picker);
	                optRgbForm.fold(function () {
	                  console.log('Can not find form');
	                }, function (rgbForm) {
	                  Representing.setValue(rgbForm, { hex: Optional.from(m[1]).getOr('') });
	                  Form.getField(rgbForm, 'hex').each(function (hexField) {
	                    emit(hexField, input());
	                  });
	                });
	              }
	            }
	          }),
	          ComposingConfigs.self()
	        ])
	      };
	    };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.Resource');
	
	    var isOldCustomEditor = function (spec) {
	      return has$2(spec, 'init');
	    };
	    var renderCustomEditor = function (spec) {
	      var editorApi = value$1();
	      var memReplaced = record({ dom: { tag: spec.tag } });
	      var initialValue = value$1();
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-custom-editor']
	        },
	        behaviours: derive$1([
	          config('custom-editor-events', [runOnAttached(function (component) {
	              memReplaced.getOpt(component).each(function (ta) {
	                (isOldCustomEditor(spec) ? spec.init(ta.element.dom) : global$6.load(spec.scriptId, spec.scriptUrl).then(function (init) {
	                  return init(ta.element.dom, spec.settings);
	                })).then(function (ea) {
	                  initialValue.on(function (cvalue) {
	                    ea.setValue(cvalue);
	                  });
	                  initialValue.clear();
	                  editorApi.set(ea);
	                });
	              });
	            })]),
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function () {
	                return editorApi.get().fold(function () {
	                  return initialValue.get().getOr('');
	                }, function (ed) {
	                  return ed.getValue();
	                });
	              },
	              setValue: function (component, value) {
	                editorApi.get().fold(function () {
	                  initialValue.set(value);
	                }, function (ed) {
	                  return ed.setValue(value);
	                });
	              }
	            }
	          }),
	          ComposingConfigs.self()
	        ]),
	        components: [memReplaced.asSpec()]
	      };
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var processors = objOf([
	      defaulted('preprocess', identity$1),
	      defaulted('postprocess', identity$1)
	    ]);
	    var memento = function (mem, rawProcessors) {
	      var ps = asRawOrDie$1('RepresentingConfigs.memento processors', processors, rawProcessors);
	      return Representing.config({
	        store: {
	          mode: 'manual',
	          getValue: function (comp) {
	            var other = mem.get(comp);
	            var rawValue = Representing.getValue(other);
	            return ps.postprocess(rawValue);
	          },
	          setValue: function (comp, rawValue) {
	            var newValue = ps.preprocess(rawValue);
	            var other = mem.get(comp);
	            Representing.setValue(other, newValue);
	          }
	        }
	      });
	    };
	    var withComp = function (optInitialValue, getter, setter) {
	      return Representing.config(deepMerge({
	        store: {
	          mode: 'manual',
	          getValue: getter,
	          setValue: setter
	        }
	      }, optInitialValue.map(function (initialValue) {
	        return { store: { initialValue: initialValue } };
	      }).getOr({})));
	    };
	    var withElement = function (initialValue, getter, setter) {
	      return withComp(initialValue, function (c) {
	        return getter(c.element);
	      }, function (c, v) {
	        return setter(c.element, v);
	      });
	    };
	    var domValue = function (optInitialValue) {
	      return withElement(optInitialValue, get$5, set$4);
	    };
	    var domHtml = function (optInitialValue) {
	      return withElement(optInitialValue, get$7, set$5);
	    };
	    var memory = function (initialValue) {
	      return Representing.config({
	        store: {
	          mode: 'memory',
	          initialValue: initialValue
	        }
	      });
	    };
	    var RepresentingConfigs = {
	      memento: memento,
	      withElement: withElement,
	      withComp: withComp,
	      domValue: domValue,
	      domHtml: domHtml,
	      memory: memory
	    };
	
	    var defaultImageFileTypes = 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp';
	    var filterByExtension = function (files, providersBackstage) {
	      var allowedImageFileTypes = global$5.explode(providersBackstage.getSetting('images_file_types', defaultImageFileTypes, 'string'));
	      var isFileInAllowedTypes = function (file) {
	        return exists(allowedImageFileTypes, function (type) {
	          return endsWith(file.name.toLowerCase(), '.' + type.toLowerCase());
	        });
	      };
	      return filter$2(from(files), isFileInAllowedTypes);
	    };
	    var renderDropZone = function (spec, providersBackstage) {
	      var stopper = function (_, se) {
	        se.stop();
	      };
	      var sequence = function (actions) {
	        return function (comp, se) {
	          each$1(actions, function (a) {
	            a(comp, se);
	          });
	        };
	      };
	      var onDrop = function (comp, se) {
	        if (!Disabling.isDisabled(comp)) {
	          var transferEvent = se.event.raw;
	          handleFiles(comp, transferEvent.dataTransfer.files);
	        }
	      };
	      var onSelect = function (component, simulatedEvent) {
	        var input = simulatedEvent.event.raw.target;
	        handleFiles(component, input.files);
	      };
	      var handleFiles = function (component, files) {
	        Representing.setValue(component, filterByExtension(files, providersBackstage));
	        emitWith(component, formChangeEvent, { name: spec.name });
	      };
	      var memInput = record({
	        dom: {
	          tag: 'input',
	          attributes: {
	            type: 'file',
	            accept: 'image/*'
	          },
	          styles: { display: 'none' }
	        },
	        behaviours: derive$1([config('input-file-events', [
	            cutter(click()),
	            cutter(tap())
	          ])])
	      });
	      var renderField = function (s) {
	        return {
	          uid: s.uid,
	          dom: {
	            tag: 'div',
	            classes: ['tox-dropzone-container']
	          },
	          behaviours: derive$1([
	            RepresentingConfigs.memory([]),
	            ComposingConfigs.self(),
	            Disabling.config({}),
	            Toggling.config({
	              toggleClass: 'dragenter',
	              toggleOnExecute: false
	            }),
	            config('dropzone-events', [
	              run$1('dragenter', sequence([
	                stopper,
	                Toggling.toggle
	              ])),
	              run$1('dragleave', sequence([
	                stopper,
	                Toggling.toggle
	              ])),
	              run$1('dragover', stopper),
	              run$1('drop', sequence([
	                stopper,
	                onDrop
	              ])),
	              run$1(change(), onSelect)
	            ])
	          ]),
	          components: [{
	              dom: {
	                tag: 'div',
	                classes: ['tox-dropzone'],
	                styles: {}
	              },
	              components: [
	                {
	                  dom: {
	                    tag: 'p',
	                    innerHtml: providersBackstage.translate('Drop an image here')
	                  }
	                },
	                Button.sketch({
	                  dom: {
	                    tag: 'button',
	                    innerHtml: providersBackstage.translate('Browse for an image'),
	                    styles: { position: 'relative' },
	                    classes: [
	                      'tox-button',
	                      'tox-button--secondary'
	                    ]
	                  },
	                  components: [memInput.asSpec()],
	                  action: function (comp) {
	                    var inputComp = memInput.get(comp);
	                    inputComp.element.dom.click();
	                  },
	                  buttonBehaviours: derive$1([
	                    Tabstopping.config({}),
	                    DisablingConfigs.button(providersBackstage.isDisabled),
	                    receivingConfig()
	                  ])
	                })
	              ]
	            }]
	        };
	      };
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel$2(label, providersBackstage);
	      });
	      var pField = FormField.parts.field({ factory: { sketch: renderField } });
	      return renderFormFieldWith(pLabel, pField, ['tox-form__group--stretched'], []);
	    };
	
	    var renderGrid = function (spec, backstage) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-form__grid',
	            'tox-form__grid--' + spec.columns + 'col'
	          ]
	        },
	        components: map$2(spec.items, backstage.interpreter)
	      };
	    };
	
	    var beforeObject = generate$6('alloy-fake-before-tabstop');
	    var afterObject = generate$6('alloy-fake-after-tabstop');
	    var craftWithClasses = function (classes) {
	      return {
	        dom: {
	          tag: 'div',
	          styles: {
	            width: '1px',
	            height: '1px',
	            outline: 'none'
	          },
	          attributes: { tabindex: '0' },
	          classes: classes
	        },
	        behaviours: derive$1([
	          Focusing.config({ ignore: true }),
	          Tabstopping.config({})
	        ])
	      };
	    };
	    var craft = function (spec) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-navobj']
	        },
	        components: [
	          craftWithClasses([beforeObject]),
	          spec,
	          craftWithClasses([afterObject])
	        ],
	        behaviours: derive$1([ComposingConfigs.childAt(1)])
	      };
	    };
	    var triggerTab = function (placeholder, shiftKey) {
	      emitWith(placeholder, keydown(), {
	        raw: {
	          which: 9,
	          shiftKey: shiftKey
	        }
	      });
	    };
	    var onFocus = function (container, targetComp) {
	      var target = targetComp.element;
	      if (has(target, beforeObject)) {
	        triggerTab(container, true);
	      } else if (has(target, afterObject)) {
	        triggerTab(container, false);
	      }
	    };
	    var isPseudoStop = function (element) {
	      return closest(element, [
	        '.' + beforeObject,
	        '.' + afterObject
	      ].join(','), never);
	    };
	
	    var platformNeedsSandboxing = !(detect$1().browser.isIE() || detect$1().browser.isEdge());
	    var getDynamicSource = function (isSandbox) {
	      var cachedValue = Cell('');
	      return {
	        getValue: function (_frameComponent) {
	          return cachedValue.get();
	        },
	        setValue: function (frameComponent, html) {
	          if (!isSandbox) {
	            set$8(frameComponent.element, 'src', 'javascript:\'\'');
	            var doc = frameComponent.element.dom.contentWindow.document;
	            doc.open();
	            doc.write(html);
	            doc.close();
	          } else {
	            set$8(frameComponent.element, 'srcdoc', html);
	          }
	          cachedValue.set(html);
	        }
	      };
	    };
	    var renderIFrame = function (spec, providersBackstage) {
	      var isSandbox = platformNeedsSandboxing && spec.sandboxed;
	      var attributes = __assign(__assign({}, spec.label.map(function (title) {
	        return { title: title };
	      }).getOr({})), isSandbox ? { sandbox: 'allow-scripts allow-same-origin' } : {});
	      var sourcing = getDynamicSource(isSandbox);
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel$2(label, providersBackstage);
	      });
	      var factory = function (newSpec) {
	        return craft({
	          uid: newSpec.uid,
	          dom: {
	            tag: 'iframe',
	            attributes: attributes
	          },
	          behaviours: derive$1([
	            Tabstopping.config({}),
	            Focusing.config({}),
	            RepresentingConfigs.withComp(Optional.none(), sourcing.getValue, sourcing.setValue)
	          ])
	        });
	      };
	      var pField = FormField.parts.field({ factory: { sketch: factory } });
	      return renderFormFieldWith(pLabel, pField, ['tox-form__group--stretched'], []);
	    };
	
	    var create$4 = function (width, height) {
	      return resize$3(document.createElement('canvas'), width, height);
	    };
	    var clone$1 = function (canvas) {
	      var tCanvas = create$4(canvas.width, canvas.height);
	      var ctx = get2dContext(tCanvas);
	      ctx.drawImage(canvas, 0, 0);
	      return tCanvas;
	    };
	    var get2dContext = function (canvas) {
	      return canvas.getContext('2d');
	    };
	    var resize$3 = function (canvas, width, height) {
	      canvas.width = width;
	      canvas.height = height;
	      return canvas;
	    };
	
	    var getWidth$1 = function (image) {
	      return image.naturalWidth || image.width;
	    };
	    var getHeight$1 = function (image) {
	      return image.naturalHeight || image.height;
	    };
	
	    var blobToImage = function (blob) {
	      return new Promise$1(function (resolve, reject) {
	        var blobUrl = URL.createObjectURL(blob);
	        var image = new Image();
	        var removeListeners = function () {
	          image.removeEventListener('load', loaded);
	          image.removeEventListener('error', error);
	        };
	        var loaded = function () {
	          removeListeners();
	          resolve(image);
	        };
	        var error = function () {
	          removeListeners();
	          reject('Unable to load data of type ' + blob.type + ': ' + blobUrl);
	        };
	        image.addEventListener('load', loaded);
	        image.addEventListener('error', error);
	        image.src = blobUrl;
	        if (image.complete) {
	          setTimeout(loaded, 0);
	        }
	      });
	    };
	    var dataUriToBlobSync = function (uri) {
	      var data = uri.split(',');
	      var matches = /data:([^;]+)/.exec(data[0]);
	      if (!matches) {
	        return Optional.none();
	      }
	      var mimetype = matches[1];
	      var base64 = data[1];
	      var sliceSize = 1024;
	      var byteCharacters = atob(base64);
	      var bytesLength = byteCharacters.length;
	      var slicesCount = Math.ceil(bytesLength / sliceSize);
	      var byteArrays = new Array(slicesCount);
	      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
	        var begin = sliceIndex * sliceSize;
	        var end = Math.min(begin + sliceSize, bytesLength);
	        var bytes = new Array(end - begin);
	        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
	          bytes[i] = byteCharacters[offset].charCodeAt(0);
	        }
	        byteArrays[sliceIndex] = new Uint8Array(bytes);
	      }
	      return Optional.some(new Blob(byteArrays, { type: mimetype }));
	    };
	    var dataUriToBlob = function (uri) {
	      return new Promise$1(function (resolve, reject) {
	        dataUriToBlobSync(uri).fold(function () {
	          reject('uri is not base64: ' + uri);
	        }, resolve);
	      });
	    };
	    var canvasToBlob = function (canvas, type, quality) {
	      type = type || 'image/png';
	      if (isFunction(HTMLCanvasElement.prototype.toBlob)) {
	        return new Promise$1(function (resolve, reject) {
	          canvas.toBlob(function (blob) {
	            if (blob) {
	              resolve(blob);
	            } else {
	              reject();
	            }
	          }, type, quality);
	        });
	      } else {
	        return dataUriToBlob(canvas.toDataURL(type, quality));
	      }
	    };
	    var canvasToDataURL = function (canvas, type, quality) {
	      type = type || 'image/png';
	      return canvas.toDataURL(type, quality);
	    };
	    var blobToCanvas = function (blob) {
	      return blobToImage(blob).then(function (image) {
	        revokeImageUrl(image);
	        var canvas = create$4(getWidth$1(image), getHeight$1(image));
	        var context = get2dContext(canvas);
	        context.drawImage(image, 0, 0);
	        return canvas;
	      });
	    };
	    var blobToDataUri = function (blob) {
	      return new Promise$1(function (resolve) {
	        var reader = new FileReader();
	        reader.onloadend = function () {
	          resolve(reader.result);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	    var revokeImageUrl = function (image) {
	      URL.revokeObjectURL(image.src);
	    };
	
	    var create$3 = function (getCanvas, blob, uri) {
	      var initialType = blob.type;
	      var getType = constant$1(initialType);
	      var toBlob = function () {
	        return Promise$1.resolve(blob);
	      };
	      var toDataURL = constant$1(uri);
	      var toBase64 = function () {
	        return uri.split(',')[1];
	      };
	      var toAdjustedBlob = function (type, quality) {
	        return getCanvas.then(function (canvas) {
	          return canvasToBlob(canvas, type, quality);
	        });
	      };
	      var toAdjustedDataURL = function (type, quality) {
	        return getCanvas.then(function (canvas) {
	          return canvasToDataURL(canvas, type, quality);
	        });
	      };
	      var toAdjustedBase64 = function (type, quality) {
	        return toAdjustedDataURL(type, quality).then(function (dataurl) {
	          return dataurl.split(',')[1];
	        });
	      };
	      var toCanvas = function () {
	        return getCanvas.then(clone$1);
	      };
	      return {
	        getType: getType,
	        toBlob: toBlob,
	        toDataURL: toDataURL,
	        toBase64: toBase64,
	        toAdjustedBlob: toAdjustedBlob,
	        toAdjustedDataURL: toAdjustedDataURL,
	        toAdjustedBase64: toAdjustedBase64,
	        toCanvas: toCanvas
	      };
	    };
	    var fromBlob = function (blob) {
	      return blobToDataUri(blob).then(function (uri) {
	        return create$3(blobToCanvas(blob), blob, uri);
	      });
	    };
	    var fromCanvas = function (canvas, type) {
	      return canvasToBlob(canvas, type).then(function (blob) {
	        return create$3(Promise$1.resolve(canvas), blob, canvas.toDataURL());
	      });
	    };
	
	    var blobToImageResult = function (blob) {
	      return fromBlob(blob);
	    };
	
	    var clamp = function (value, min, max) {
	      var parsedValue = typeof value === 'string' ? parseFloat(value) : value;
	      if (parsedValue > max) {
	        parsedValue = max;
	      } else if (parsedValue < min) {
	        parsedValue = min;
	      }
	      return parsedValue;
	    };
	    var identity = function () {
	      return [
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1
	      ];
	    };
	    var DELTA_INDEX = [
	      0,
	      0.01,
	      0.02,
	      0.04,
	      0.05,
	      0.06,
	      0.07,
	      0.08,
	      0.1,
	      0.11,
	      0.12,
	      0.14,
	      0.15,
	      0.16,
	      0.17,
	      0.18,
	      0.2,
	      0.21,
	      0.22,
	      0.24,
	      0.25,
	      0.27,
	      0.28,
	      0.3,
	      0.32,
	      0.34,
	      0.36,
	      0.38,
	      0.4,
	      0.42,
	      0.44,
	      0.46,
	      0.48,
	      0.5,
	      0.53,
	      0.56,
	      0.59,
	      0.62,
	      0.65,
	      0.68,
	      0.71,
	      0.74,
	      0.77,
	      0.8,
	      0.83,
	      0.86,
	      0.89,
	      0.92,
	      0.95,
	      0.98,
	      1,
	      1.06,
	      1.12,
	      1.18,
	      1.24,
	      1.3,
	      1.36,
	      1.42,
	      1.48,
	      1.54,
	      1.6,
	      1.66,
	      1.72,
	      1.78,
	      1.84,
	      1.9,
	      1.96,
	      2,
	      2.12,
	      2.25,
	      2.37,
	      2.5,
	      2.62,
	      2.75,
	      2.87,
	      3,
	      3.2,
	      3.4,
	      3.6,
	      3.8,
	      4,
	      4.3,
	      4.7,
	      4.9,
	      5,
	      5.5,
	      6,
	      6.5,
	      6.8,
	      7,
	      7.3,
	      7.5,
	      7.8,
	      8,
	      8.4,
	      8.7,
	      9,
	      9.4,
	      9.6,
	      9.8,
	      10
	    ];
	    var multiply = function (matrix1, matrix2) {
	      var col = [];
	      var out = new Array(25);
	      var val;
	      for (var i = 0; i < 5; i++) {
	        for (var j = 0; j < 5; j++) {
	          col[j] = matrix2[j + i * 5];
	        }
	        for (var j = 0; j < 5; j++) {
	          val = 0;
	          for (var k = 0; k < 5; k++) {
	            val += matrix1[j + k * 5] * col[k];
	          }
	          out[j + i * 5] = val;
	        }
	      }
	      return out;
	    };
	    var adjustContrast = function (matrix, value) {
	      var x;
	      value = clamp(value, -1, 1);
	      value *= 100;
	      if (value < 0) {
	        x = 127 + value / 100 * 127;
	      } else {
	        x = value % 1;
	        if (x === 0) {
	          x = DELTA_INDEX[value];
	        } else {
	          x = DELTA_INDEX[Math.floor(value)] * (1 - x) + DELTA_INDEX[Math.floor(value) + 1] * x;
	        }
	        x = x * 127 + 127;
	      }
	      return multiply(matrix, [
	        x / 127,
	        0,
	        0,
	        0,
	        0.5 * (127 - x),
	        0,
	        x / 127,
	        0,
	        0,
	        0.5 * (127 - x),
	        0,
	        0,
	        x / 127,
	        0,
	        0.5 * (127 - x),
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1
	      ]);
	    };
	    var adjustBrightness = function (matrix, value) {
	      value = clamp(255 * value, -255, 255);
	      return multiply(matrix, [
	        1,
	        0,
	        0,
	        0,
	        value,
	        0,
	        1,
	        0,
	        0,
	        value,
	        0,
	        0,
	        1,
	        0,
	        value,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1
	      ]);
	    };
	    var adjustColors = function (matrix, adjustR, adjustG, adjustB) {
	      adjustR = clamp(adjustR, 0, 2);
	      adjustG = clamp(adjustG, 0, 2);
	      adjustB = clamp(adjustB, 0, 2);
	      return multiply(matrix, [
	        adjustR,
	        0,
	        0,
	        0,
	        0,
	        0,
	        adjustG,
	        0,
	        0,
	        0,
	        0,
	        0,
	        adjustB,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1
	      ]);
	    };
	
	    var colorFilter = function (ir, matrix) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyColorFilter(canvas, ir.getType(), matrix);
	      });
	    };
	    var applyColorFilter = function (canvas, type, matrix) {
	      var context = get2dContext(canvas);
	      var applyMatrix = function (pixelsData, m) {
	        var r, g, b, a;
	        var data = pixelsData.data, m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5], m6 = m[6], m7 = m[7], m8 = m[8], m9 = m[9], m10 = m[10], m11 = m[11], m12 = m[12], m13 = m[13], m14 = m[14], m15 = m[15], m16 = m[16], m17 = m[17], m18 = m[18], m19 = m[19];
	        for (var i = 0; i < data.length; i += 4) {
	          r = data[i];
	          g = data[i + 1];
	          b = data[i + 2];
	          a = data[i + 3];
	          data[i] = r * m0 + g * m1 + b * m2 + a * m3 + m4;
	          data[i + 1] = r * m5 + g * m6 + b * m7 + a * m8 + m9;
	          data[i + 2] = r * m10 + g * m11 + b * m12 + a * m13 + m14;
	          data[i + 3] = r * m15 + g * m16 + b * m17 + a * m18 + m19;
	        }
	        return pixelsData;
	      };
	      var pixels = applyMatrix(context.getImageData(0, 0, canvas.width, canvas.height), matrix);
	      context.putImageData(pixels, 0, 0);
	      return fromCanvas(canvas, type);
	    };
	    var convoluteFilter = function (ir, matrix) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyConvoluteFilter(canvas, ir.getType(), matrix);
	      });
	    };
	    var applyConvoluteFilter = function (canvas, type, matrix) {
	      var context = get2dContext(canvas);
	      var applyMatrix = function (pIn, pOut, aMatrix) {
	        var clamp = function (value, min, max) {
	          if (value > max) {
	            value = max;
	          } else if (value < min) {
	            value = min;
	          }
	          return value;
	        };
	        var side = Math.round(Math.sqrt(aMatrix.length));
	        var halfSide = Math.floor(side / 2);
	        var rgba = pIn.data;
	        var drgba = pOut.data;
	        var w = pIn.width;
	        var h = pIn.height;
	        for (var y = 0; y < h; y++) {
	          for (var x = 0; x < w; x++) {
	            var r = 0;
	            var g = 0;
	            var b = 0;
	            for (var cy = 0; cy < side; cy++) {
	              for (var cx = 0; cx < side; cx++) {
	                var scx = clamp(x + cx - halfSide, 0, w - 1);
	                var scy = clamp(y + cy - halfSide, 0, h - 1);
	                var innerOffset = (scy * w + scx) * 4;
	                var wt = aMatrix[cy * side + cx];
	                r += rgba[innerOffset] * wt;
	                g += rgba[innerOffset + 1] * wt;
	                b += rgba[innerOffset + 2] * wt;
	              }
	            }
	            var offset = (y * w + x) * 4;
	            drgba[offset] = clamp(r, 0, 255);
	            drgba[offset + 1] = clamp(g, 0, 255);
	            drgba[offset + 2] = clamp(b, 0, 255);
	          }
	        }
	        return pOut;
	      };
	      var pixelsIn = context.getImageData(0, 0, canvas.width, canvas.height);
	      var pixelsOut = context.getImageData(0, 0, canvas.width, canvas.height);
	      pixelsOut = applyMatrix(pixelsIn, pixelsOut, matrix);
	      context.putImageData(pixelsOut, 0, 0);
	      return fromCanvas(canvas, type);
	    };
	    var functionColorFilter = function (colorFn) {
	      var filterImpl = function (canvas, type, value) {
	        var context = get2dContext(canvas);
	        var lookup = new Array(256);
	        var applyLookup = function (pixelsData, lookupData) {
	          var data = pixelsData.data;
	          for (var i = 0; i < data.length; i += 4) {
	            data[i] = lookupData[data[i]];
	            data[i + 1] = lookupData[data[i + 1]];
	            data[i + 2] = lookupData[data[i + 2]];
	          }
	          return pixelsData;
	        };
	        for (var i = 0; i < lookup.length; i++) {
	          lookup[i] = colorFn(i, value);
	        }
	        var pixels = applyLookup(context.getImageData(0, 0, canvas.width, canvas.height), lookup);
	        context.putImageData(pixels, 0, 0);
	        return fromCanvas(canvas, type);
	      };
	      return function (ir, value) {
	        return ir.toCanvas().then(function (canvas) {
	          return filterImpl(canvas, ir.getType(), value);
	        });
	      };
	    };
	    var complexAdjustableColorFilter = function (matrixAdjustFn) {
	      return function (ir, adjust) {
	        return colorFilter(ir, matrixAdjustFn(identity(), adjust));
	      };
	    };
	    var basicColorFilter = function (matrix) {
	      return function (ir) {
	        return colorFilter(ir, matrix);
	      };
	    };
	    var basicConvolutionFilter = function (kernel) {
	      return function (ir) {
	        return convoluteFilter(ir, kernel);
	      };
	    };
	    var invert$1 = basicColorFilter([
	      -1,
	      0,
	      0,
	      0,
	      255,
	      0,
	      -1,
	      0,
	      0,
	      255,
	      0,
	      0,
	      -1,
	      0,
	      255,
	      0,
	      0,
	      0,
	      1,
	      0,
	      0,
	      0,
	      0,
	      0,
	      1
	    ]);
	    var brightness$1 = complexAdjustableColorFilter(adjustBrightness);
	    var contrast$1 = complexAdjustableColorFilter(adjustContrast);
	    var colorize$1 = function (ir, adjustR, adjustG, adjustB) {
	      return colorFilter(ir, adjustColors(identity(), adjustR, adjustG, adjustB));
	    };
	    var sharpen$1 = basicConvolutionFilter([
	      0,
	      -1,
	      0,
	      -1,
	      5,
	      -1,
	      0,
	      -1,
	      0
	    ]);
	    var gamma$1 = functionColorFilter(function (color, value) {
	      return Math.pow(color / 255, 1 - value) * 255;
	    });
	
	    var scale = function (image, dW, dH) {
	      var sW = getWidth$1(image);
	      var sH = getHeight$1(image);
	      var wRatio = dW / sW;
	      var hRatio = dH / sH;
	      var scaleCapped = false;
	      if (wRatio < 0.5 || wRatio > 2) {
	        wRatio = wRatio < 0.5 ? 0.5 : 2;
	        scaleCapped = true;
	      }
	      if (hRatio < 0.5 || hRatio > 2) {
	        hRatio = hRatio < 0.5 ? 0.5 : 2;
	        scaleCapped = true;
	      }
	      var scaled = _scale(image, wRatio, hRatio);
	      return !scaleCapped ? scaled : scaled.then(function (tCanvas) {
	        return scale(tCanvas, dW, dH);
	      });
	    };
	    var _scale = function (image, wRatio, hRatio) {
	      return new Promise$1(function (resolve) {
	        var sW = getWidth$1(image);
	        var sH = getHeight$1(image);
	        var dW = Math.floor(sW * wRatio);
	        var dH = Math.floor(sH * hRatio);
	        var canvas = create$4(dW, dH);
	        var context = get2dContext(canvas);
	        context.drawImage(image, 0, 0, sW, sH, 0, 0, dW, dH);
	        resolve(canvas);
	      });
	    };
	
	    var ceilWithPrecision = function (num, precision) {
	      if (precision === void 0) {
	        precision = 2;
	      }
	      var mul = Math.pow(10, precision);
	      var upper = Math.round(num * mul);
	      return Math.ceil(upper / mul);
	    };
	    var rotate$1 = function (ir, angle) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyRotate(canvas, ir.getType(), angle);
	      });
	    };
	    var applyRotate = function (image, type, angle) {
	      var degrees = angle < 0 ? 360 + angle : angle;
	      var rad = degrees * Math.PI / 180;
	      var width = image.width;
	      var height = image.height;
	      var sin = Math.sin(rad);
	      var cos = Math.cos(rad);
	      var newWidth = ceilWithPrecision(Math.abs(width * cos) + Math.abs(height * sin));
	      var newHeight = ceilWithPrecision(Math.abs(width * sin) + Math.abs(height * cos));
	      var canvas = create$4(newWidth, newHeight);
	      var context = get2dContext(canvas);
	      context.translate(newWidth / 2, newHeight / 2);
	      context.rotate(rad);
	      context.drawImage(image, -width / 2, -height / 2);
	      return fromCanvas(canvas, type);
	    };
	    var flip$1 = function (ir, axis) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyFlip(canvas, ir.getType(), axis);
	      });
	    };
	    var applyFlip = function (image, type, axis) {
	      var canvas = create$4(image.width, image.height);
	      var context = get2dContext(canvas);
	      if (axis === 'v') {
	        context.scale(1, -1);
	        context.drawImage(image, 0, -canvas.height);
	      } else {
	        context.scale(-1, 1);
	        context.drawImage(image, -canvas.width, 0);
	      }
	      return fromCanvas(canvas, type);
	    };
	    var crop$1 = function (ir, x, y, w, h) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyCrop(canvas, ir.getType(), x, y, w, h);
	      });
	    };
	    var applyCrop = function (image, type, x, y, w, h) {
	      var canvas = create$4(w, h);
	      var context = get2dContext(canvas);
	      context.drawImage(image, -x, -y);
	      return fromCanvas(canvas, type);
	    };
	    var resize$2 = function (ir, w, h) {
	      return ir.toCanvas().then(function (canvas) {
	        return scale(canvas, w, h).then(function (newCanvas) {
	          return fromCanvas(newCanvas, ir.getType());
	        });
	      });
	    };
	
	    var invert = function (ir) {
	      return invert$1(ir);
	    };
	    var sharpen = function (ir) {
	      return sharpen$1(ir);
	    };
	    var gamma = function (ir, value) {
	      return gamma$1(ir, value);
	    };
	    var colorize = function (ir, adjustR, adjustG, adjustB) {
	      return colorize$1(ir, adjustR, adjustG, adjustB);
	    };
	    var brightness = function (ir, adjust) {
	      return brightness$1(ir, adjust);
	    };
	    var contrast = function (ir, adjust) {
	      return contrast$1(ir, adjust);
	    };
	    var flip = function (ir, axis) {
	      return flip$1(ir, axis);
	    };
	    var crop = function (ir, x, y, w, h) {
	      return crop$1(ir, x, y, w, h);
	    };
	    var resize$1 = function (ir, w, h) {
	      return resize$2(ir, w, h);
	    };
	    var rotate = function (ir, angle) {
	      return rotate$1(ir, angle);
	    };
	
	    var renderIcon = function (iconName, iconsProvider, behaviours) {
	      return render$3(iconName, {
	        tag: 'span',
	        classes: [
	          'tox-icon',
	          'tox-tbtn__icon-wrap'
	        ],
	        behaviours: behaviours
	      }, iconsProvider);
	    };
	    var renderIconFromPack = function (iconName, iconsProvider) {
	      return renderIcon(iconName, iconsProvider, []);
	    };
	    var renderReplacableIconFromPack = function (iconName, iconsProvider) {
	      return renderIcon(iconName, iconsProvider, [Replacing.config({})]);
	    };
	    var renderLabel$1 = function (text, prefix, providersBackstage) {
	      return {
	        dom: {
	          tag: 'span',
	          innerHtml: providersBackstage.translate(text),
	          classes: [prefix + '__select-label']
	        },
	        behaviours: derive$1([Replacing.config({})])
	      };
	    };
	
	    var _a;
	    var internalToolbarButtonExecute = generate$6('toolbar.button.execute');
	    var onToolbarButtonExecute = function (info) {
	      return runOnExecute$1(function (comp, _simulatedEvent) {
	        runWithApi(info, comp)(function (itemApi) {
	          emitWith(comp, internalToolbarButtonExecute, { buttonApi: itemApi });
	          info.onAction(itemApi);
	        });
	      });
	    };
	    var toolbarButtonEventOrder = (_a = {}, _a[execute$5()] = [
	      'disabling',
	      'alloy.base.behaviour',
	      'toggling',
	      'toolbar-button-events'
	    ], _a);
	
	    var updateMenuText = generate$6('update-menu-text');
	    var updateMenuIcon = generate$6('update-menu-icon');
	    var renderCommonDropdown = function (spec, prefix, sharedBackstage) {
	      var editorOffCell = Cell(noop);
	      var optMemDisplayText = spec.text.map(function (text) {
	        return record(renderLabel$1(text, prefix, sharedBackstage.providers));
	      });
	      var optMemDisplayIcon = spec.icon.map(function (iconName) {
	        return record(renderReplacableIconFromPack(iconName, sharedBackstage.providers.icons));
	      });
	      var onLeftOrRightInMenu = function (comp, se) {
	        var dropdown = Representing.getValue(comp);
	        Focusing.focus(dropdown);
	        emitWith(dropdown, 'keydown', { raw: se.event.raw });
	        Dropdown.close(dropdown);
	        return Optional.some(true);
	      };
	      var role = spec.role.fold(function () {
	        return {};
	      }, function (role) {
	        return { role: role };
	      });
	      var tooltipAttributes = spec.tooltip.fold(function () {
	        return {};
	      }, function (tooltip) {
	        var translatedTooltip = sharedBackstage.providers.translate(tooltip);
	        return {
	          'title': translatedTooltip,
	          'aria-label': translatedTooltip
	        };
	      });
	      var iconSpec = render$3('chevron-down', {
	        tag: 'div',
	        classes: [prefix + '__select-chevron']
	      }, sharedBackstage.providers.icons);
	      var memDropdown = record(Dropdown.sketch(__assign(__assign(__assign({}, spec.uid ? { uid: spec.uid } : {}), role), {
	        dom: {
	          tag: 'button',
	          classes: [
	            prefix,
	            prefix + '--select'
	          ].concat(map$2(spec.classes, function (c) {
	            return prefix + '--' + c;
	          })),
	          attributes: __assign({}, tooltipAttributes)
	        },
	        components: componentRenderPipeline([
	          optMemDisplayIcon.map(function (mem) {
	            return mem.asSpec();
	          }),
	          optMemDisplayText.map(function (mem) {
	            return mem.asSpec();
	          }),
	          Optional.some(iconSpec)
	        ]),
	        matchWidth: true,
	        useMinWidth: true,
	        dropdownBehaviours: derive$1(__spreadArray(__spreadArray([], spec.dropdownBehaviours, true), [
	          DisablingConfigs.button(function () {
	            return spec.disabled || sharedBackstage.providers.isDisabled();
	          }),
	          receivingConfig(),
	          Unselecting.config({}),
	          Replacing.config({}),
	          config('dropdown-events', [
	            onControlAttached(spec, editorOffCell),
	            onControlDetached(spec, editorOffCell)
	          ]),
	          config('menubutton-update-display-text', [
	            run$1(updateMenuText, function (comp, se) {
	              optMemDisplayText.bind(function (mem) {
	                return mem.getOpt(comp);
	              }).each(function (displayText) {
	                Replacing.set(displayText, [text$1(sharedBackstage.providers.translate(se.event.text))]);
	              });
	            }),
	            run$1(updateMenuIcon, function (comp, se) {
	              optMemDisplayIcon.bind(function (mem) {
	                return mem.getOpt(comp);
	              }).each(function (displayIcon) {
	                Replacing.set(displayIcon, [renderReplacableIconFromPack(se.event.icon, sharedBackstage.providers.icons)]);
	              });
	            })
	          ])
	        ], false)),
	        eventOrder: deepMerge(toolbarButtonEventOrder, {
	          mousedown: [
	            'focusing',
	            'alloy.base.behaviour',
	            'item-type-events',
	            'normal-dropdown-events'
	          ]
	        }),
	        sandboxBehaviours: derive$1([Keying.config({
	            mode: 'special',
	            onLeft: onLeftOrRightInMenu,
	            onRight: onLeftOrRightInMenu
	          })]),
	        lazySink: sharedBackstage.getSink,
	        toggleClass: prefix + '--active',
	        parts: { menu: part(false, spec.columns, spec.presets) },
	        fetch: function (comp) {
	          return Future.nu(curry(spec.fetch, comp));
	        }
	      })));
	      return memDropdown.asSpec();
	    };
	
	    var isMenuItemReference = function (item) {
	      return isString(item);
	    };
	    var isSeparator$1 = function (item) {
	      return item.type === 'separator';
	    };
	    var isExpandingMenuItem = function (item) {
	      return has$2(item, 'getSubmenuItems');
	    };
	    var separator$2 = { type: 'separator' };
	    var unwrapReferences = function (items, menuItems) {
	      var realItems = foldl(items, function (acc, item) {
	        if (isMenuItemReference(item)) {
	          if (item === '') {
	            return acc;
	          } else if (item === '|') {
	            return acc.length > 0 && !isSeparator$1(acc[acc.length - 1]) ? acc.concat([separator$2]) : acc;
	          } else if (has$2(menuItems, item.toLowerCase())) {
	            return acc.concat([menuItems[item.toLowerCase()]]);
	          } else {
	            return acc;
	          }
	        } else {
	          return acc.concat([item]);
	        }
	      }, []);
	      if (realItems.length > 0 && isSeparator$1(realItems[realItems.length - 1])) {
	        realItems.pop();
	      }
	      return realItems;
	    };
	    var getFromExpandingItem = function (item, menuItems) {
	      var submenuItems = item.getSubmenuItems();
	      var rest = expand(submenuItems, menuItems);
	      var newMenus = deepMerge(rest.menus, wrap$1(item.value, rest.items));
	      var newExpansions = deepMerge(rest.expansions, wrap$1(item.value, item.value));
	      return {
	        item: item,
	        menus: newMenus,
	        expansions: newExpansions
	      };
	    };
	    var getFromItem = function (item, menuItems) {
	      return isExpandingMenuItem(item) ? getFromExpandingItem(item, menuItems) : {
	        item: item,
	        menus: {},
	        expansions: {}
	      };
	    };
	    var generateValueIfRequired = function (item) {
	      if (isSeparator$1(item)) {
	        return item;
	      } else {
	        var itemValue = get$e(item, 'value').getOrThunk(function () {
	          return generate$6('generated-menu-item');
	        });
	        return deepMerge({ value: itemValue }, item);
	      }
	    };
	    var expand = function (items, menuItems) {
	      var realItems = unwrapReferences(isString(items) ? items.split(' ') : items, menuItems);
	      return foldr(realItems, function (acc, item) {
	        var itemWithValue = generateValueIfRequired(item);
	        var newData = getFromItem(itemWithValue, menuItems);
	        return {
	          menus: deepMerge(acc.menus, newData.menus),
	          items: [newData.item].concat(acc.items),
	          expansions: deepMerge(acc.expansions, newData.expansions)
	        };
	      }, {
	        menus: {},
	        expansions: {},
	        items: []
	      });
	    };
	
	    var build = function (items, itemResponse, backstage, isHorizontalMenu) {
	      var primary = generate$6('primary-menu');
	      var data = expand(items, backstage.shared.providers.menuItems());
	      if (data.items.length === 0) {
	        return Optional.none();
	      }
	      var mainMenu = createPartialMenu(primary, data.items, itemResponse, backstage, isHorizontalMenu);
	      var submenus = map$1(data.menus, function (menuItems, menuName) {
	        return createPartialMenu(menuName, menuItems, itemResponse, backstage, false);
	      });
	      var menus = deepMerge(submenus, wrap$1(primary, mainMenu));
	      return Optional.from(tieredMenu.tieredData(primary, menus, data.expansions));
	    };
	
	    var getMenuButtonApi = function (component) {
	      return {
	        isDisabled: function () {
	          return Disabling.isDisabled(component);
	        },
	        setDisabled: function (state) {
	          return Disabling.set(component, state);
	        },
	        setActive: function (state) {
	          var elm = component.element;
	          if (state) {
	            add$2(elm, 'tox-tbtn--enabled');
	            set$8(elm, 'aria-pressed', true);
	          } else {
	            remove$2(elm, 'tox-tbtn--enabled');
	            remove$7(elm, 'aria-pressed');
	          }
	        },
	        isActive: function () {
	          return has(component.element, 'tox-tbtn--enabled');
	        }
	      };
	    };
	    var renderMenuButton = function (spec, prefix, backstage, role) {
	      return renderCommonDropdown({
	        text: spec.text,
	        icon: spec.icon,
	        tooltip: spec.tooltip,
	        role: role,
	        fetch: function (_comp, callback) {
	          spec.fetch(function (items) {
	            callback(build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false));
	          });
	        },
	        onSetup: spec.onSetup,
	        getApi: getMenuButtonApi,
	        columns: 1,
	        presets: 'normal',
	        classes: [],
	        dropdownBehaviours: [Tabstopping.config({})]
	      }, prefix, backstage.shared);
	    };
	    var getFetch = function (items, getButton, backstage) {
	      var getMenuItemAction = function (item) {
	        return function (api) {
	          var newValue = !api.isActive();
	          api.setActive(newValue);
	          item.storage.set(newValue);
	          backstage.shared.getSink().each(function (sink) {
	            getButton().getOpt(sink).each(function (orig) {
	              focus$3(orig.element);
	              emitWith(orig, formActionEvent, {
	                name: item.name,
	                value: item.storage.get()
	              });
	            });
	          });
	        };
	      };
	      var getMenuItemSetup = function (item) {
	        return function (api) {
	          api.setActive(item.storage.get());
	        };
	      };
	      return function (success) {
	        success(map$2(items, function (item) {
	          var text = item.text.fold(function () {
	            return {};
	          }, function (text) {
	            return { text: text };
	          });
	          return __assign(__assign({
	            type: item.type,
	            active: false
	          }, text), {
	            onAction: getMenuItemAction(item),
	            onSetup: getMenuItemSetup(item)
	          });
	        }));
	      };
	    };
	
	    var renderCommonSpec = function (spec, actionOpt, extraBehaviours, dom, components, providersBackstage) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      var action = actionOpt.fold(function () {
	        return {};
	      }, function (action) {
	        return { action: action };
	      });
	      var common = __assign({
	        buttonBehaviours: derive$1([
	          DisablingConfigs.button(function () {
	            return spec.disabled || providersBackstage.isDisabled();
	          }),
	          receivingConfig(),
	          Tabstopping.config({}),
	          config('button press', [
	            preventDefault('click'),
	            preventDefault('mousedown')
	          ])
	        ].concat(extraBehaviours)),
	        eventOrder: {
	          click: [
	            'button press',
	            'alloy.base.behaviour'
	          ],
	          mousedown: [
	            'button press',
	            'alloy.base.behaviour'
	          ]
	        }
	      }, action);
	      var domFinal = deepMerge(common, { dom: dom });
	      return deepMerge(domFinal, { components: components });
	    };
	    var renderIconButtonSpec = function (spec, action, providersBackstage, extraBehaviours) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      var tooltipAttributes = spec.tooltip.map(function (tooltip) {
	        return {
	          'aria-label': providersBackstage.translate(tooltip),
	          'title': providersBackstage.translate(tooltip)
	        };
	      }).getOr({});
	      var dom = {
	        tag: 'button',
	        classes: ['tox-tbtn'],
	        attributes: tooltipAttributes
	      };
	      var icon = spec.icon.map(function (iconName) {
	        return renderIconFromPack(iconName, providersBackstage.icons);
	      });
	      var components = componentRenderPipeline([icon]);
	      return renderCommonSpec(spec, action, extraBehaviours, dom, components, providersBackstage);
	    };
	    var renderIconButton = function (spec, action, providersBackstage, extraBehaviours) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      var iconButtonSpec = renderIconButtonSpec(spec, Optional.some(action), providersBackstage, extraBehaviours);
	      return Button.sketch(iconButtonSpec);
	    };
	    var renderButtonSpec = function (spec, action, providersBackstage, extraBehaviours, extraClasses) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      if (extraClasses === void 0) {
	        extraClasses = [];
	      }
	      var translatedText = providersBackstage.translate(spec.text);
	      var icon = spec.icon ? spec.icon.map(function (iconName) {
	        return renderIconFromPack(iconName, providersBackstage.icons);
	      }) : Optional.none();
	      var components = icon.isSome() ? componentRenderPipeline([icon]) : [];
	      var innerHtml = icon.isSome() ? {} : { innerHtml: translatedText };
	      var classes = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], !spec.primary && !spec.borderless ? [
	        'tox-button',
	        'tox-button--secondary'
	      ] : ['tox-button'], true), icon.isSome() ? ['tox-button--icon'] : [], true), spec.borderless ? ['tox-button--naked'] : [], true), extraClasses, true);
	      var dom = __assign(__assign({
	        tag: 'button',
	        classes: classes
	      }, innerHtml), { attributes: { title: translatedText } });
	      return renderCommonSpec(spec, action, extraBehaviours, dom, components, providersBackstage);
	    };
	    var renderButton = function (spec, action, providersBackstage, extraBehaviours, extraClasses) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      if (extraClasses === void 0) {
	        extraClasses = [];
	      }
	      var buttonSpec = renderButtonSpec(spec, Optional.some(action), providersBackstage, extraBehaviours, extraClasses);
	      return Button.sketch(buttonSpec);
	    };
	    var getAction = function (name, buttonType) {
	      return function (comp) {
	        if (buttonType === 'custom') {
	          emitWith(comp, formActionEvent, {
	            name: name,
	            value: {}
	          });
	        } else if (buttonType === 'submit') {
	          emit(comp, formSubmitEvent);
	        } else if (buttonType === 'cancel') {
	          emit(comp, formCancelEvent);
	        } else {
	          console.error('Unknown button type: ', buttonType);
	        }
	      };
	    };
	    var isMenuFooterButtonSpec = function (spec, buttonType) {
	      return buttonType === 'menu';
	    };
	    var isNormalFooterButtonSpec = function (spec, buttonType) {
	      return buttonType === 'custom' || buttonType === 'cancel' || buttonType === 'submit';
	    };
	    var renderFooterButton = function (spec, buttonType, backstage) {
	      if (isMenuFooterButtonSpec(spec, buttonType)) {
	        var getButton = function () {
	          return memButton_1;
	        };
	        var menuButtonSpec = spec;
	        var fixedSpec = __assign(__assign({}, spec), {
	          onSetup: function (api) {
	            api.setDisabled(spec.disabled);
	            return noop;
	          },
	          fetch: getFetch(menuButtonSpec.items, getButton, backstage)
	        });
	        var memButton_1 = record(renderMenuButton(fixedSpec, 'tox-tbtn', backstage, Optional.none()));
	        return memButton_1.asSpec();
	      } else if (isNormalFooterButtonSpec(spec, buttonType)) {
	        var action = getAction(spec.name, buttonType);
	        var buttonSpec = __assign(__assign({}, spec), { borderless: false });
	        return renderButton(buttonSpec, action, backstage.shared.providers, []);
	      } else {
	        console.error('Unknown footer button type: ', buttonType);
	      }
	    };
	    var renderDialogButton = function (spec, providersBackstage) {
	      var action = getAction(spec.name, 'custom');
	      return renderFormField(Optional.none(), FormField.parts.field(__assign({ factory: Button }, renderButtonSpec(spec, Optional.some(action), providersBackstage, [
	        RepresentingConfigs.memory(''),
	        ComposingConfigs.self()
	      ]))));
	    };
	
	    var schema$h = constant$1([
	      defaulted('field1Name', 'field1'),
	      defaulted('field2Name', 'field2'),
	      onStrictHandler('onLockedChange'),
	      markers$1(['lockClass']),
	      defaulted('locked', false),
	      SketchBehaviours.field('coupledFieldBehaviours', [
	        Composing,
	        Representing
	      ])
	    ]);
	    var getField = function (comp, detail, partName) {
	      return getPart(comp, detail, partName).bind(Composing.getCurrent);
	    };
	    var coupledPart = function (selfName, otherName) {
	      return required({
	        factory: FormField,
	        name: selfName,
	        overrides: function (detail) {
	          return {
	            fieldBehaviours: derive$1([config('coupled-input-behaviour', [run$1(input(), function (me) {
	                  getField(me, detail, otherName).each(function (other) {
	                    getPart(me, detail, 'lock').each(function (lock) {
	                      if (Toggling.isOn(lock)) {
	                        detail.onLockedChange(me, other, lock);
	                      }
	                    });
	                  });
	                })])])
	          };
	        }
	      });
	    };
	    var parts$c = constant$1([
	      coupledPart('field1', 'field2'),
	      coupledPart('field2', 'field1'),
	      required({
	        factory: Button,
	        schema: [required$1('dom')],
	        name: 'lock',
	        overrides: function (detail) {
	          return {
	            buttonBehaviours: derive$1([Toggling.config({
	                selected: detail.locked,
	                toggleClass: detail.markers.lockClass,
	                aria: { mode: 'pressed' }
	              })])
	          };
	        }
	      })
	    ]);
	
	    var factory$f = function (detail, components, _spec, _externals) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: SketchBehaviours.augment(detail.coupledFieldBehaviours, [
	          Composing.config({ find: Optional.some }),
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (comp) {
	                var _a;
	                var parts = getPartsOrDie(comp, detail, [
	                  'field1',
	                  'field2'
	                ]);
	                return _a = {}, _a[detail.field1Name] = Representing.getValue(parts.field1()), _a[detail.field2Name] = Representing.getValue(parts.field2()), _a;
	              },
	              setValue: function (comp, value) {
	                var parts = getPartsOrDie(comp, detail, [
	                  'field1',
	                  'field2'
	                ]);
	                if (hasNonNullableKey(value, detail.field1Name)) {
	                  Representing.setValue(parts.field1(), value[detail.field1Name]);
	                }
	                if (hasNonNullableKey(value, detail.field2Name)) {
	                  Representing.setValue(parts.field2(), value[detail.field2Name]);
	                }
	              }
	            }
	          })
	        ]),
	        apis: {
	          getField1: function (component) {
	            return getPart(component, detail, 'field1');
	          },
	          getField2: function (component) {
	            return getPart(component, detail, 'field2');
	          },
	          getLock: function (component) {
	            return getPart(component, detail, 'lock');
	          }
	        }
	      };
	    };
	    var FormCoupledInputs = composite({
	      name: 'FormCoupledInputs',
	      configFields: schema$h(),
	      partFields: parts$c(),
	      factory: factory$f,
	      apis: {
	        getField1: function (apis, component) {
	          return apis.getField1(component);
	        },
	        getField2: function (apis, component) {
	          return apis.getField2(component);
	        },
	        getLock: function (apis, component) {
	          return apis.getLock(component);
	        }
	      }
	    });
	
	    var formatSize = function (size) {
	      var unitDec = {
	        '': 0,
	        'px': 0,
	        'pt': 1,
	        'mm': 1,
	        'pc': 2,
	        'ex': 2,
	        'em': 2,
	        'ch': 2,
	        'rem': 2,
	        'cm': 3,
	        'in': 4,
	        '%': 4
	      };
	      var maxDecimal = function (unit) {
	        return unit in unitDec ? unitDec[unit] : 1;
	      };
	      var numText = size.value.toFixed(maxDecimal(size.unit));
	      if (numText.indexOf('.') !== -1) {
	        numText = numText.replace(/\.?0*$/, '');
	      }
	      return numText + size.unit;
	    };
	    var parseSize = function (sizeText) {
	      var numPattern = /^\s*(\d+(?:\.\d+)?)\s*(|cm|mm|in|px|pt|pc|em|ex|ch|rem|vw|vh|vmin|vmax|%)\s*$/;
	      var match = numPattern.exec(sizeText);
	      if (match !== null) {
	        var value = parseFloat(match[1]);
	        var unit = match[2];
	        return Result.value({
	          value: value,
	          unit: unit
	        });
	      } else {
	        return Result.error(sizeText);
	      }
	    };
	    var convertUnit = function (size, unit) {
	      var inInch = {
	        '': 96,
	        'px': 96,
	        'pt': 72,
	        'cm': 2.54,
	        'pc': 12,
	        'mm': 25.4,
	        'in': 1
	      };
	      var supported = function (u) {
	        return has$2(inInch, u);
	      };
	      if (size.unit === unit) {
	        return Optional.some(size.value);
	      } else if (supported(size.unit) && supported(unit)) {
	        if (inInch[size.unit] === inInch[unit]) {
	          return Optional.some(size.value);
	        } else {
	          return Optional.some(size.value / inInch[size.unit] * inInch[unit]);
	        }
	      } else {
	        return Optional.none();
	      }
	    };
	    var noSizeConversion = function (_input) {
	      return Optional.none();
	    };
	    var ratioSizeConversion = function (scale, unit) {
	      return function (size) {
	        return convertUnit(size, unit).map(function (value) {
	          return {
	            value: value * scale,
	            unit: unit
	          };
	        });
	      };
	    };
	    var makeRatioConverter = function (currentFieldText, otherFieldText) {
	      var cValue = parseSize(currentFieldText).toOptional();
	      var oValue = parseSize(otherFieldText).toOptional();
	      return lift2(cValue, oValue, function (cSize, oSize) {
	        return convertUnit(cSize, oSize.unit).map(function (val) {
	          return oSize.value / val;
	        }).map(function (r) {
	          return ratioSizeConversion(r, oSize.unit);
	        }).getOr(noSizeConversion);
	      }).getOr(noSizeConversion);
	    };
	
	    var renderSizeInput = function (spec, providersBackstage) {
	      var converter = noSizeConversion;
	      var ratioEvent = generate$6('ratio-event');
	      var makeIcon = function (iconName) {
	        return render$3(iconName, {
	          tag: 'span',
	          classes: [
	            'tox-icon',
	            'tox-lock-icon__' + iconName
	          ]
	        }, providersBackstage.icons);
	      };
	      var pLock = FormCoupledInputs.parts.lock({
	        dom: {
	          tag: 'button',
	          classes: [
	            'tox-lock',
	            'tox-button',
	            'tox-button--naked',
	            'tox-button--icon'
	          ],
	          attributes: { title: providersBackstage.translate(spec.label.getOr('Constrain proportions')) }
	        },
	        components: [
	          makeIcon('lock'),
	          makeIcon('unlock')
	        ],
	        buttonBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            }
	          }),
	          receivingConfig(),
	          Tabstopping.config({})
	        ])
	      });
	      var formGroup = function (components) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-form__group']
	          },
	          components: components
	        };
	      };
	      var getFieldPart = function (isField1) {
	        return FormField.parts.field({
	          factory: Input,
	          inputClasses: ['tox-textfield'],
	          inputBehaviours: derive$1([
	            Disabling.config({
	              disabled: function () {
	                return spec.disabled || providersBackstage.isDisabled();
	              }
	            }),
	            receivingConfig(),
	            Tabstopping.config({}),
	            config('size-input-events', [
	              run$1(focusin(), function (component, _simulatedEvent) {
	                emitWith(component, ratioEvent, { isField1: isField1 });
	              }),
	              run$1(change(), function (component, _simulatedEvent) {
	                emitWith(component, formChangeEvent, { name: spec.name });
	              })
	            ])
	          ]),
	          selectOnFocus: false
	        });
	      };
	      var getLabel = function (label) {
	        return {
	          dom: {
	            tag: 'label',
	            classes: ['tox-label'],
	            innerHtml: providersBackstage.translate(label)
	          }
	        };
	      };
	      var widthField = FormCoupledInputs.parts.field1(formGroup([
	        FormField.parts.label(getLabel('Width')),
	        getFieldPart(true)
	      ]));
	      var heightField = FormCoupledInputs.parts.field2(formGroup([
	        FormField.parts.label(getLabel('Height')),
	        getFieldPart(false)
	      ]));
	      return FormCoupledInputs.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-form__controls-h-stack']
	            },
	            components: [
	              widthField,
	              heightField,
	              formGroup([
	                getLabel('&nbsp;'),
	                pLock
	              ])
	            ]
	          }],
	        field1Name: 'width',
	        field2Name: 'height',
	        locked: true,
	        markers: { lockClass: 'tox-locked' },
	        onLockedChange: function (current, other, _lock) {
	          parseSize(Representing.getValue(current)).each(function (size) {
	            converter(size).each(function (newSize) {
	              Representing.setValue(other, formatSize(newSize));
	            });
	          });
	        },
	        coupledFieldBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            },
	            onDisabled: function (comp) {
	              FormCoupledInputs.getField1(comp).bind(FormField.getField).each(Disabling.disable);
	              FormCoupledInputs.getField2(comp).bind(FormField.getField).each(Disabling.disable);
	              FormCoupledInputs.getLock(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormCoupledInputs.getField1(comp).bind(FormField.getField).each(Disabling.enable);
	              FormCoupledInputs.getField2(comp).bind(FormField.getField).each(Disabling.enable);
	              FormCoupledInputs.getLock(comp).each(Disabling.enable);
	            }
	          }),
	          receivingConfig(),
	          config('size-input-events2', [run$1(ratioEvent, function (component, simulatedEvent) {
	              var isField1 = simulatedEvent.event.isField1;
	              var optCurrent = isField1 ? FormCoupledInputs.getField1(component) : FormCoupledInputs.getField2(component);
	              var optOther = isField1 ? FormCoupledInputs.getField2(component) : FormCoupledInputs.getField1(component);
	              var value1 = optCurrent.map(Representing.getValue).getOr('');
	              var value2 = optOther.map(Representing.getValue).getOr('');
	              converter = makeRatioConverter(value1, value2);
	            })])
	        ])
	      });
	    };
	
	    var undo = constant$1(generate$6('undo'));
	    var redo = constant$1(generate$6('redo'));
	    var zoom = constant$1(generate$6('zoom'));
	    var back = constant$1(generate$6('back'));
	    var apply$1 = constant$1(generate$6('apply'));
	    var swap = constant$1(generate$6('swap'));
	    var transform$1 = constant$1(generate$6('transform'));
	    var tempTransform = constant$1(generate$6('temp-transform'));
	    var transformApply = constant$1(generate$6('transform-apply'));
	    var internal = {
	      undo: undo,
	      redo: redo,
	      zoom: zoom,
	      back: back,
	      apply: apply$1,
	      swap: swap,
	      transform: transform$1,
	      tempTransform: tempTransform,
	      transformApply: transformApply
	    };
	    var saveState = constant$1('save-state');
	    var disable = constant$1('disable');
	    var enable = constant$1('enable');
	    var external = {
	      formActionEvent: formActionEvent,
	      saveState: saveState,
	      disable: disable,
	      enable: enable
	    };
	
	    var renderEditPanel = function (imagePanel, providersBackstage) {
	      var createButton = function (text, action, disabled, primary) {
	        return record(renderButton({
	          name: text,
	          text: text,
	          disabled: disabled,
	          primary: primary,
	          icon: Optional.none(),
	          borderless: false
	        }, action, providersBackstage));
	      };
	      var createIconButton = function (icon, tooltip, action, disabled) {
	        return record(renderIconButton({
	          name: icon,
	          icon: Optional.some(icon),
	          tooltip: Optional.some(tooltip),
	          disabled: disabled,
	          primary: false,
	          borderless: false
	        }, action, providersBackstage));
	      };
	      var disableAllComponents = function (comps, eventcomp) {
	        comps.map(function (mem) {
	          var component = mem.get(eventcomp);
	          if (component.hasConfigured(Disabling)) {
	            Disabling.disable(component);
	          }
	        });
	      };
	      var enableAllComponents = function (comps, eventcomp) {
	        comps.map(function (mem) {
	          var component = mem.get(eventcomp);
	          if (component.hasConfigured(Disabling)) {
	            Disabling.enable(component);
	          }
	        });
	      };
	      var panelDom = {
	        tag: 'div',
	        classes: [
	          'tox-image-tools__toolbar',
	          'tox-image-tools-edit-panel'
	        ]
	      };
	      var noop$1 = noop;
	      var emit$1 = function (comp, event, data) {
	        emitWith(comp, event, data);
	      };
	      var emitDisable = function (component) {
	        return emit(component, external.disable());
	      };
	      var emitEnable = function (component) {
	        return emit(component, external.enable());
	      };
	      var emitTransform = function (comp, transform) {
	        emitDisable(comp);
	        emit$1(comp, internal.transform(), { transform: transform });
	        emitEnable(comp);
	      };
	      var emitTempTransform = function (comp, transform) {
	        emitDisable(comp);
	        emit$1(comp, internal.tempTransform(), { transform: transform });
	        emitEnable(comp);
	      };
	      var getBackSwap = function (anyInSystem) {
	        return function () {
	          memContainer.getOpt(anyInSystem).each(function (container) {
	            Replacing.set(container, [ButtonPanel]);
	          });
	        };
	      };
	      var emitTransformApply = function (comp, transform) {
	        emitDisable(comp);
	        emit$1(comp, internal.transformApply(), {
	          transform: transform,
	          swap: getBackSwap(comp)
	        });
	        emitEnable(comp);
	      };
	      var createBackButton = function () {
	        return createButton('Back', function (button) {
	          return emit$1(button, internal.back(), { swap: getBackSwap(button) });
	        }, false, false);
	      };
	      var createSpacer = function () {
	        return record({
	          dom: {
	            tag: 'div',
	            classes: ['tox-spacer']
	          },
	          behaviours: derive$1([Disabling.config({})])
	        });
	      };
	      var createApplyButton = function () {
	        return createButton('Apply', function (button) {
	          return emit$1(button, internal.apply(), { swap: getBackSwap(button) });
	        }, true, true);
	      };
	      var makeCropTransform = function () {
	        return function (ir) {
	          var rect = imagePanel.getRect();
	          return crop(ir, rect.x, rect.y, rect.w, rect.h);
	        };
	      };
	      var cropPanelComponents = [
	        createBackButton(),
	        createSpacer(),
	        createButton('Apply', function (button) {
	          var transform = makeCropTransform();
	          emitTransformApply(button, transform);
	          imagePanel.hideCrop();
	        }, false, true)
	      ];
	      var CropPanel = Container.sketch({
	        dom: panelDom,
	        components: cropPanelComponents.map(function (mem) {
	          return mem.asSpec();
	        }),
	        containerBehaviours: derive$1([config('image-tools-crop-buttons-events', [
	            run$1(external.disable(), function (comp, _se) {
	              disableAllComponents(cropPanelComponents, comp);
	            }),
	            run$1(external.enable(), function (comp, _se) {
	              enableAllComponents(cropPanelComponents, comp);
	            })
	          ])])
	      });
	      var memSize = record(renderSizeInput({
	        name: 'size',
	        label: Optional.none(),
	        constrain: true,
	        disabled: false
	      }, providersBackstage));
	      var makeResizeTransform = function (width, height) {
	        return function (ir) {
	          return resize$1(ir, width, height);
	        };
	      };
	      var resizePanelComponents = [
	        createBackButton(),
	        createSpacer(),
	        memSize,
	        createSpacer(),
	        createButton('Apply', function (button) {
	          memSize.getOpt(button).each(function (sizeInput) {
	            var value = Representing.getValue(sizeInput);
	            var width = parseInt(value.width, 10);
	            var height = parseInt(value.height, 10);
	            var transform = makeResizeTransform(width, height);
	            emitTransformApply(button, transform);
	          });
	        }, false, true)
	      ];
	      var ResizePanel = Container.sketch({
	        dom: panelDom,
	        components: resizePanelComponents.map(function (mem) {
	          return mem.asSpec();
	        }),
	        containerBehaviours: derive$1([config('image-tools-resize-buttons-events', [
	            run$1(external.disable(), function (comp, _se) {
	              disableAllComponents(resizePanelComponents, comp);
	            }),
	            run$1(external.enable(), function (comp, _se) {
	              enableAllComponents(resizePanelComponents, comp);
	            })
	          ])])
	      });
	      var makeValueTransform = function (transform, value) {
	        return function (ir) {
	          return transform(ir, value);
	        };
	      };
	      var horizontalFlip = makeValueTransform(flip, 'h');
	      var verticalFlip = makeValueTransform(flip, 'v');
	      var counterclockwiseRotate = makeValueTransform(rotate, -90);
	      var clockwiseRotate = makeValueTransform(rotate, 90);
	      var flipRotateOnAction = function (comp, operation) {
	        emitTempTransform(comp, operation);
	      };
	      var flipRotateComponents = [
	        createBackButton(),
	        createSpacer(),
	        createIconButton('flip-horizontally', 'Flip horizontally', function (button) {
	          flipRotateOnAction(button, horizontalFlip);
	        }, false),
	        createIconButton('flip-vertically', 'Flip vertically', function (button) {
	          flipRotateOnAction(button, verticalFlip);
	        }, false),
	        createIconButton('rotate-left', 'Rotate counterclockwise', function (button) {
	          flipRotateOnAction(button, counterclockwiseRotate);
	        }, false),
	        createIconButton('rotate-right', 'Rotate clockwise', function (button) {
	          flipRotateOnAction(button, clockwiseRotate);
	        }, false),
	        createSpacer(),
	        createApplyButton()
	      ];
	      var FlipRotatePanel = Container.sketch({
	        dom: panelDom,
	        components: flipRotateComponents.map(function (mem) {
	          return mem.asSpec();
	        }),
	        containerBehaviours: derive$1([config('image-tools-fliprotate-buttons-events', [
	            run$1(external.disable(), function (comp, _se) {
	              disableAllComponents(flipRotateComponents, comp);
	            }),
	            run$1(external.enable(), function (comp, _se) {
	              enableAllComponents(flipRotateComponents, comp);
	            })
	          ])])
	      });
	      var makeSlider = function (label, onChoose, min, value, max) {
	        var labelPart = Slider.parts.label({
	          dom: {
	            tag: 'label',
	            classes: ['tox-label'],
	            innerHtml: providersBackstage.translate(label)
	          }
	        });
	        var spectrum = Slider.parts.spectrum({
	          dom: {
	            tag: 'div',
	            classes: ['tox-slider__rail'],
	            attributes: { role: 'presentation' }
	          }
	        });
	        var thumb = Slider.parts.thumb({
	          dom: {
	            tag: 'div',
	            classes: ['tox-slider__handle'],
	            attributes: { role: 'presentation' }
	          }
	        });
	        return record(Slider.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-slider'],
	            attributes: { role: 'presentation' }
	          },
	          model: {
	            mode: 'x',
	            minX: min,
	            maxX: max,
	            getInitialValue: constant$1({ x: value })
	          },
	          components: [
	            labelPart,
	            spectrum,
	            thumb
	          ],
	          sliderBehaviours: derive$1([Focusing.config({})]),
	          onChoose: onChoose
	        }));
	      };
	      var makeVariableSlider = function (label, transform, min, value, max) {
	        var onChoose = function (slider, _thumb, value) {
	          var valTransform = makeValueTransform(transform, value.x / 100);
	          emitTransform(slider, valTransform);
	        };
	        return makeSlider(label, onChoose, min, value, max);
	      };
	      var variableFilterPanelComponents = function (label, transform, min, value, max) {
	        return [
	          createBackButton(),
	          makeVariableSlider(label, transform, min, value, max),
	          createApplyButton()
	        ];
	      };
	      var createVariableFilterPanel = function (label, transform, min, value, max) {
	        var filterPanelComponents = variableFilterPanelComponents(label, transform, min, value, max);
	        return Container.sketch({
	          dom: panelDom,
	          components: filterPanelComponents.map(function (mem) {
	            return mem.asSpec();
	          }),
	          containerBehaviours: derive$1([config('image-tools-filter-panel-buttons-events', [
	              run$1(external.disable(), function (comp, _se) {
	                disableAllComponents(filterPanelComponents, comp);
	              }),
	              run$1(external.enable(), function (comp, _se) {
	                enableAllComponents(filterPanelComponents, comp);
	              })
	            ])])
	        });
	      };
	      var filterPanelComponents = [
	        createBackButton(),
	        createSpacer(),
	        createApplyButton()
	      ];
	      var FilterPanel = Container.sketch({
	        dom: panelDom,
	        components: filterPanelComponents.map(function (mem) {
	          return mem.asSpec();
	        })
	      });
	      var BrightnessPanel = createVariableFilterPanel('Brightness', brightness, -100, 0, 100);
	      var ContrastPanel = createVariableFilterPanel('Contrast', contrast, -100, 0, 100);
	      var GammaPanel = createVariableFilterPanel('Gamma', gamma, -100, 0, 100);
	      var makeColorTransform = function (red, green, blue) {
	        return function (ir) {
	          return colorize(ir, red, green, blue);
	        };
	      };
	      var makeColorSlider = function (label) {
	        var onChoose = function (slider, _thumb, _value) {
	          var redOpt = memRed.getOpt(slider);
	          var blueOpt = memBlue.getOpt(slider);
	          var greenOpt = memGreen.getOpt(slider);
	          redOpt.each(function (red) {
	            blueOpt.each(function (blue) {
	              greenOpt.each(function (green) {
	                var r = Representing.getValue(red).x / 100;
	                var g = Representing.getValue(green).x / 100;
	                var b = Representing.getValue(blue).x / 100;
	                var transform = makeColorTransform(r, g, b);
	                emitTransform(slider, transform);
	              });
	            });
	          });
	        };
	        return makeSlider(label, onChoose, 0, 100, 200);
	      };
	      var memRed = makeColorSlider('R');
	      var memGreen = makeColorSlider('G');
	      var memBlue = makeColorSlider('B');
	      var colorizePanelComponents = [
	        createBackButton(),
	        memRed,
	        memGreen,
	        memBlue,
	        createApplyButton()
	      ];
	      var ColorizePanel = Container.sketch({
	        dom: panelDom,
	        components: colorizePanelComponents.map(function (mem) {
	          return mem.asSpec();
	        })
	      });
	      var getTransformPanelEvent = function (panel, transform, update) {
	        return function (button) {
	          var swap = function () {
	            memContainer.getOpt(button).each(function (container) {
	              Replacing.set(container, [panel]);
	              update(container);
	            });
	          };
	          emit$1(button, internal.swap(), {
	            transform: transform,
	            swap: swap
	          });
	        };
	      };
	      var cropPanelUpdate = function (_anyInSystem) {
	        imagePanel.showCrop();
	      };
	      var resizePanelUpdate = function (anyInSystem) {
	        memSize.getOpt(anyInSystem).each(function (sizeInput) {
	          var measurements = imagePanel.getMeasurements();
	          var width = measurements.width;
	          var height = measurements.height;
	          Representing.setValue(sizeInput, {
	            width: width,
	            height: height
	          });
	        });
	      };
	      var sharpenTransform = Optional.some(sharpen);
	      var invertTransform = Optional.some(invert);
	      var buttonPanelComponents = [
	        createIconButton('crop', 'Crop', getTransformPanelEvent(CropPanel, Optional.none(), cropPanelUpdate), false),
	        createIconButton('resize', 'Resize', getTransformPanelEvent(ResizePanel, Optional.none(), resizePanelUpdate), false),
	        createIconButton('orientation', 'Orientation', getTransformPanelEvent(FlipRotatePanel, Optional.none(), noop$1), false),
	        createIconButton('brightness', 'Brightness', getTransformPanelEvent(BrightnessPanel, Optional.none(), noop$1), false),
	        createIconButton('sharpen', 'Sharpen', getTransformPanelEvent(FilterPanel, sharpenTransform, noop$1), false),
	        createIconButton('contrast', 'Contrast', getTransformPanelEvent(ContrastPanel, Optional.none(), noop$1), false),
	        createIconButton('color-levels', 'Color levels', getTransformPanelEvent(ColorizePanel, Optional.none(), noop$1), false),
	        createIconButton('gamma', 'Gamma', getTransformPanelEvent(GammaPanel, Optional.none(), noop$1), false),
	        createIconButton('invert', 'Invert', getTransformPanelEvent(FilterPanel, invertTransform, noop$1), false)
	      ];
	      var ButtonPanel = Container.sketch({
	        dom: panelDom,
	        components: buttonPanelComponents.map(function (mem) {
	          return mem.asSpec();
	        })
	      });
	      var container = Container.sketch({
	        dom: { tag: 'div' },
	        components: [ButtonPanel],
	        containerBehaviours: derive$1([Replacing.config({})])
	      });
	      var memContainer = record(container);
	      var getApplyButton = function (anyInSystem) {
	        return memContainer.getOpt(anyInSystem).map(function (container) {
	          var panel = container.components()[0];
	          return panel.components()[panel.components().length - 1];
	        });
	      };
	      return {
	        memContainer: memContainer,
	        getApplyButton: getApplyButton
	      };
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.geom.Rect');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Observable');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var getDocumentSize = function (doc) {
	      var max = Math.max;
	      var documentElement = doc.documentElement;
	      var body = doc.body;
	      var scrollWidth = max(documentElement.scrollWidth, body.scrollWidth);
	      var clientWidth = max(documentElement.clientWidth, body.clientWidth);
	      var offsetWidth = max(documentElement.offsetWidth, body.offsetWidth);
	      var scrollHeight = max(documentElement.scrollHeight, body.scrollHeight);
	      var clientHeight = max(documentElement.clientHeight, body.clientHeight);
	      var offsetHeight = max(documentElement.offsetHeight, body.offsetHeight);
	      return {
	        width: scrollWidth < offsetWidth ? clientWidth : scrollWidth,
	        height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
	      };
	    };
	    var isTouchEvent$1 = function (e) {
	      return isNonNullable(e.changedTouches);
	    };
	    var updateWithTouchData = function (e) {
	      if (isTouchEvent$1(e)) {
	        var keys = 'screenX screenY pageX pageY clientX clientY'.split(' ');
	        for (var i = 0; i < keys.length; i++) {
	          e[keys[i]] = e.changedTouches[0][keys[i]];
	        }
	      }
	    };
	    function DragHelper (id, settings) {
	      var _a, _b, _c;
	      var eventOverlay;
	      var handleEvents = [];
	      var overlayEvents = [];
	      var doc = (_a = settings.document) !== null && _a !== void 0 ? _a : document;
	      var root = (_b = settings.root) !== null && _b !== void 0 ? _b : doc;
	      var sugarDoc = SugarElement.fromDom(doc);
	      var downButton;
	      var startX;
	      var startY;
	      var handleElement = SugarElement.fromDom(root.getElementById((_c = settings.handle) !== null && _c !== void 0 ? _c : id));
	      var start = function (e) {
	        var rawEvent = e.raw;
	        var docSize = getDocumentSize(doc);
	        updateWithTouchData(rawEvent);
	        e.prevent();
	        downButton = rawEvent.button;
	        startX = rawEvent.screenX;
	        startY = rawEvent.screenY;
	        var cursor = get$c(handleElement, 'cursor');
	        eventOverlay = SugarElement.fromTag('div', doc);
	        setAll(eventOverlay, {
	          'position': 'absolute',
	          'top': '0',
	          'left': '0',
	          'width': docSize.width + 'px',
	          'height': docSize.height + 'px',
	          'z-index': 2147483647 + '',
	          'opacity': '0.0001',
	          cursor: cursor
	        });
	        append$2(getBody(sugarDoc), eventOverlay);
	        overlayEvents.push(bind(sugarDoc, 'mousemove', drag), bind(sugarDoc, 'touchmove', drag), bind(sugarDoc, 'mouseup', stop), bind(sugarDoc, 'touchend', stop));
	        settings.start(rawEvent);
	      };
	      var drag = function (e) {
	        var rawEvent = e.raw;
	        updateWithTouchData(rawEvent);
	        if (rawEvent.button !== downButton) {
	          return stop(e);
	        }
	        rawEvent.deltaX = rawEvent.screenX - startX;
	        rawEvent.deltaY = rawEvent.screenY - startY;
	        e.prevent();
	        settings.drag(rawEvent);
	      };
	      var stop = function (e) {
	        updateWithTouchData(e.raw);
	        each$1(overlayEvents, function (e) {
	          return e.unbind();
	        });
	        overlayEvents = [];
	        remove$5(eventOverlay);
	        if (settings.stop) {
	          settings.stop(e.raw);
	        }
	      };
	      var destroy = function () {
	        each$1(overlayEvents.concat(handleEvents), function (e) {
	          return e.unbind();
	        });
	        overlayEvents = [];
	        handleEvents = [];
	        if (isNonNullable(eventOverlay)) {
	          remove$5(eventOverlay);
	        }
	      };
	      handleEvents.push(bind(handleElement, 'mousedown', start), bind(handleElement, 'touchstart', start));
	      return { destroy: destroy };
	    }
	
	    var count = 0;
	    var create$2 = function (currentRect, viewPortRect, clampRect, containerElm, action) {
	      var dragHelpers;
	      var events = [];
	      var prefix = 'tox-';
	      var id = prefix + 'crid-' + count++;
	      var container = SugarElement.fromDom(containerElm);
	      var handles = [
	        {
	          name: 'move',
	          xMul: 0,
	          yMul: 0,
	          deltaX: 1,
	          deltaY: 1,
	          deltaW: 0,
	          deltaH: 0,
	          label: 'Crop Mask'
	        },
	        {
	          name: 'nw',
	          xMul: 0,
	          yMul: 0,
	          deltaX: 1,
	          deltaY: 1,
	          deltaW: -1,
	          deltaH: -1,
	          label: 'Top Left Crop Handle'
	        },
	        {
	          name: 'ne',
	          xMul: 1,
	          yMul: 0,
	          deltaX: 0,
	          deltaY: 1,
	          deltaW: 1,
	          deltaH: -1,
	          label: 'Top Right Crop Handle'
	        },
	        {
	          name: 'sw',
	          xMul: 0,
	          yMul: 1,
	          deltaX: 1,
	          deltaY: 0,
	          deltaW: -1,
	          deltaH: 1,
	          label: 'Bottom Left Crop Handle'
	        },
	        {
	          name: 'se',
	          xMul: 1,
	          yMul: 1,
	          deltaX: 0,
	          deltaY: 0,
	          deltaW: 1,
	          deltaH: 1,
	          label: 'Bottom Right Crop Handle'
	        }
	      ];
	      var blockers = [
	        'top',
	        'right',
	        'bottom',
	        'left'
	      ];
	      var getAbsoluteRect = function (outerRect, relativeRect) {
	        return {
	          x: relativeRect.x + outerRect.x,
	          y: relativeRect.y + outerRect.y,
	          w: relativeRect.w,
	          h: relativeRect.h
	        };
	      };
	      var getRelativeRect = function (outerRect, innerRect) {
	        return {
	          x: innerRect.x - outerRect.x,
	          y: innerRect.y - outerRect.y,
	          w: innerRect.w,
	          h: innerRect.h
	        };
	      };
	      var getInnerRect = function () {
	        return getRelativeRect(clampRect, currentRect);
	      };
	      var moveRect = function (handle, startRect, deltaX, deltaY) {
	        var x = startRect.x + deltaX * handle.deltaX;
	        var y = startRect.y + deltaY * handle.deltaY;
	        var w = Math.max(20, startRect.w + deltaX * handle.deltaW);
	        var h = Math.max(20, startRect.h + deltaY * handle.deltaH);
	        var rect = currentRect = global$4.clamp({
	          x: x,
	          y: y,
	          w: w,
	          h: h
	        }, clampRect, handle.name === 'move');
	        rect = getRelativeRect(clampRect, rect);
	        instance.fire('updateRect', { rect: rect });
	        setInnerRect(rect);
	      };
	      var render = function () {
	        var createDragHelper = function (handle) {
	          var startRect;
	          return DragHelper(id, {
	            document: containerElm.ownerDocument,
	            root: getRootNode(container).dom,
	            handle: id + '-' + handle.name,
	            start: function () {
	              startRect = currentRect;
	            },
	            drag: function (e) {
	              moveRect(handle, startRect, e.deltaX, e.deltaY);
	            }
	          });
	        };
	        var cropContainer = SugarElement.fromTag('div');
	        setAll$1(cropContainer, {
	          id: id,
	          'class': prefix + 'croprect-container',
	          'role': 'grid',
	          'aria-dropeffect': 'execute'
	        });
	        append$2(container, cropContainer);
	        each$1(blockers, function (blocker) {
	          descendant(container, '#' + id).each(function (blockerElm) {
	            var cropBlocker = SugarElement.fromTag('div');
	            setAll$1(cropBlocker, {
	              'id': id + '-' + blocker,
	              'class': prefix + 'croprect-block',
	              'data-mce-bogus': 'all'
	            });
	            set$7(cropBlocker, 'display', 'none');
	            append$2(blockerElm, cropBlocker);
	          });
	        });
	        each$1(handles, function (handle) {
	          descendant(container, '#' + id).each(function (handleElm) {
	            var cropHandle = SugarElement.fromTag('div');
	            setAll$1(cropHandle, {
	              'id': id + '-' + handle.name,
	              'aria-label': handle.label,
	              'aria-grabbed': 'false',
	              'data-mce-bogus': 'all',
	              'role': 'gridcell',
	              'tabindex': '-1',
	              'title': handle.label
	            });
	            add$1(cropHandle, [
	              prefix + 'croprect-handle',
	              prefix + 'croprect-handle-' + handle.name
	            ]);
	            set$7(cropHandle, 'display', 'none');
	            append$2(handleElm, cropHandle);
	          });
	        });
	        dragHelpers = map$2(handles, createDragHelper);
	        repaint(currentRect);
	        var handleFocus = function (e) {
	          set$8(e.target, 'aria-grabbed', e.raw.type === 'focus' ? 'true' : 'false');
	        };
	        var handleKeydown = function (e) {
	          var activeHandle;
	          each$1(handles, function (handle) {
	            if (get$d(e.target, 'id') === id + '-' + handle.name) {
	              activeHandle = handle;
	              return false;
	            }
	          });
	          var moveAndBlock = function (evt, handle, startRect, deltaX, deltaY) {
	            evt.stopPropagation();
	            evt.preventDefault();
	            moveRect(activeHandle, startRect, deltaX, deltaY);
	          };
	          switch (e.raw.keyCode) {
	          case global$2.LEFT:
	            moveAndBlock(e, activeHandle, currentRect, -10, 0);
	            break;
	          case global$2.RIGHT:
	            moveAndBlock(e, activeHandle, currentRect, 10, 0);
	            break;
	          case global$2.UP:
	            moveAndBlock(e, activeHandle, currentRect, 0, -10);
	            break;
	          case global$2.DOWN:
	            moveAndBlock(e, activeHandle, currentRect, 0, 10);
	            break;
	          case global$2.ENTER:
	          case global$2.SPACEBAR:
	            e.prevent();
	            action();
	            break;
	          }
	        };
	        events.push(bind(container, 'focusin', handleFocus), bind(container, 'focusout', handleFocus), bind(container, 'keydown', handleKeydown));
	      };
	      var toggleVisibility = function (state) {
	        var selectors = __spreadArray(__spreadArray([], map$2(handles, function (handle) {
	          return '#' + id + '-' + handle.name;
	        }), true), map$2(blockers, function (blocker) {
	          return '#' + id + '-' + blocker;
	        }), true).join(',');
	        var elems = descendants(container, selectors);
	        if (state) {
	          each$1(elems, function (elm) {
	            return remove$6(elm, 'display');
	          });
	        } else {
	          each$1(elems, function (elm) {
	            return set$7(elm, 'display', 'none');
	          });
	        }
	      };
	      var repaint = function (rect) {
	        var updateElementRect = function (name, newRect) {
	          descendant(container, '#' + id + '-' + name).each(function (elm) {
	            setAll(elm, {
	              left: newRect.x + 'px',
	              top: newRect.y + 'px',
	              width: Math.max(0, newRect.w) + 'px',
	              height: Math.max(0, newRect.h) + 'px'
	            });
	          });
	        };
	        each$1(handles, function (handle) {
	          descendant(container, '#' + id + '-' + handle.name).each(function (elm) {
	            setAll(elm, {
	              left: rect.w * handle.xMul + rect.x + 'px',
	              top: rect.h * handle.yMul + rect.y + 'px'
	            });
	          });
	        });
	        updateElementRect('top', {
	          x: viewPortRect.x,
	          y: viewPortRect.y,
	          w: viewPortRect.w,
	          h: rect.y - viewPortRect.y
	        });
	        updateElementRect('right', {
	          x: rect.x + rect.w,
	          y: rect.y,
	          w: viewPortRect.w - rect.x - rect.w + viewPortRect.x,
	          h: rect.h
	        });
	        updateElementRect('bottom', {
	          x: viewPortRect.x,
	          y: rect.y + rect.h,
	          w: viewPortRect.w,
	          h: viewPortRect.h - rect.y - rect.h + viewPortRect.y
	        });
	        updateElementRect('left', {
	          x: viewPortRect.x,
	          y: rect.y,
	          w: rect.x - viewPortRect.x,
	          h: rect.h
	        });
	        updateElementRect('move', rect);
	      };
	      var setRect = function (rect) {
	        currentRect = rect;
	        repaint(currentRect);
	      };
	      var setViewPortRect = function (rect) {
	        viewPortRect = rect;
	        repaint(currentRect);
	      };
	      var setInnerRect = function (rect) {
	        setRect(getAbsoluteRect(clampRect, rect));
	      };
	      var setClampRect = function (rect) {
	        clampRect = rect;
	        repaint(currentRect);
	      };
	      var destroy = function () {
	        each$1(dragHelpers, function (helper) {
	          return helper.destroy();
	        });
	        dragHelpers = [];
	        each$1(events, function (e) {
	          return e.unbind();
	        });
	        events = [];
	      };
	      render();
	      var instance = __assign(__assign({}, global$3), {
	        toggleVisibility: toggleVisibility,
	        setClampRect: setClampRect,
	        setRect: setRect,
	        getInnerRect: getInnerRect,
	        setInnerRect: setInnerRect,
	        setViewPortRect: setViewPortRect,
	        destroy: destroy
	      });
	      return instance;
	    };
	    var CropRect = { create: create$2 };
	
	    var loadImage = function (image) {
	      return new global$c(function (resolve) {
	        var loaded = function () {
	          image.removeEventListener('load', loaded);
	          resolve(image);
	        };
	        if (image.complete) {
	          resolve(image);
	        } else {
	          image.addEventListener('load', loaded);
	        }
	      });
	    };
	    var renderImagePanel = function (initialUrl) {
	      var memBg = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-image-tools__image-bg'],
	          attributes: { role: 'presentation' }
	        }
	      });
	      var zoomState = Cell(1);
	      var cropRect = api$1();
	      var rectState = Cell({
	        x: 0,
	        y: 0,
	        w: 1,
	        h: 1
	      });
	      var viewRectState = Cell({
	        x: 0,
	        y: 0,
	        w: 1,
	        h: 1
	      });
	      var repaintImg = function (anyInSystem, img) {
	        memContainer.getOpt(anyInSystem).each(function (panel) {
	          var zoom = zoomState.get();
	          var panelW = get$a(panel.element);
	          var panelH = get$b(panel.element);
	          var width = img.dom.naturalWidth * zoom;
	          var height = img.dom.naturalHeight * zoom;
	          var left = Math.max(0, panelW / 2 - width / 2);
	          var top = Math.max(0, panelH / 2 - height / 2);
	          var css = {
	            left: left.toString() + 'px',
	            top: top.toString() + 'px',
	            width: width.toString() + 'px',
	            height: height.toString() + 'px',
	            position: 'absolute'
	          };
	          setAll(img, css);
	          memBg.getOpt(panel).each(function (bg) {
	            setAll(bg.element, css);
	          });
	          cropRect.run(function (cRect) {
	            var rect = rectState.get();
	            cRect.setRect({
	              x: rect.x * zoom + left,
	              y: rect.y * zoom + top,
	              w: rect.w * zoom,
	              h: rect.h * zoom
	            });
	            cRect.setClampRect({
	              x: left,
	              y: top,
	              w: width,
	              h: height
	            });
	            cRect.setViewPortRect({
	              x: 0,
	              y: 0,
	              w: panelW,
	              h: panelH
	            });
	          });
	        });
	      };
	      var zoomFit = function (anyInSystem, img) {
	        memContainer.getOpt(anyInSystem).each(function (panel) {
	          var panelW = get$a(panel.element);
	          var panelH = get$b(panel.element);
	          var width = img.dom.naturalWidth;
	          var height = img.dom.naturalHeight;
	          var zoom = Math.min(panelW / width, panelH / height);
	          if (zoom >= 1) {
	            zoomState.set(1);
	          } else {
	            zoomState.set(zoom);
	          }
	        });
	      };
	      var updateSrc = function (anyInSystem, url) {
	        var img = SugarElement.fromTag('img');
	        set$8(img, 'src', url);
	        return loadImage(img.dom).then(function () {
	          if (anyInSystem.getSystem().isConnected()) {
	            memContainer.getOpt(anyInSystem).map(function (panel) {
	              var aImg = external$2({ element: img });
	              Replacing.replaceAt(panel, 1, Optional.some(aImg));
	              var lastViewRect = viewRectState.get();
	              var viewRect = {
	                x: 0,
	                y: 0,
	                w: img.dom.naturalWidth,
	                h: img.dom.naturalHeight
	              };
	              viewRectState.set(viewRect);
	              var rect = global$4.inflate(viewRect, -20, -20);
	              rectState.set(rect);
	              if (lastViewRect.w !== viewRect.w || lastViewRect.h !== viewRect.h) {
	                zoomFit(panel, img);
	              }
	              repaintImg(panel, img);
	            });
	          }
	        });
	      };
	      var zoom = function (anyInSystem, direction) {
	        var currentZoom = zoomState.get();
	        var newZoom = direction > 0 ? Math.min(2, currentZoom + 0.1) : Math.max(0.1, currentZoom - 0.1);
	        zoomState.set(newZoom);
	        memContainer.getOpt(anyInSystem).each(function (panel) {
	          var img = panel.components()[1].element;
	          repaintImg(panel, img);
	        });
	      };
	      var showCrop = function () {
	        cropRect.run(function (cRect) {
	          cRect.toggleVisibility(true);
	        });
	      };
	      var hideCrop = function () {
	        cropRect.run(function (cRect) {
	          cRect.toggleVisibility(false);
	        });
	      };
	      var getRect = function () {
	        return rectState.get();
	      };
	      var container = Container.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-image-tools__image']
	        },
	        components: [
	          memBg.asSpec(),
	          {
	            dom: {
	              tag: 'img',
	              attributes: { src: initialUrl }
	            }
	          },
	          {
	            dom: { tag: 'div' },
	            behaviours: derive$1([config('image-panel-crop-events', [
	                runOnAttached(function (comp) {
	                  memContainer.getOpt(comp).each(function (container) {
	                    var el = container.element.dom;
	                    var cRect = CropRect.create({
	                      x: 10,
	                      y: 10,
	                      w: 100,
	                      h: 100
	                    }, {
	                      x: 0,
	                      y: 0,
	                      w: 200,
	                      h: 200
	                    }, {
	                      x: 0,
	                      y: 0,
	                      w: 200,
	                      h: 200
	                    }, el, noop);
	                    cRect.toggleVisibility(false);
	                    cRect.on('updateRect', function (e) {
	                      var rect = e.rect;
	                      var zoom = zoomState.get();
	                      var newRect = {
	                        x: Math.round(rect.x / zoom),
	                        y: Math.round(rect.y / zoom),
	                        w: Math.round(rect.w / zoom),
	                        h: Math.round(rect.h / zoom)
	                      };
	                      rectState.set(newRect);
	                    });
	                    cropRect.set(cRect);
	                  });
	                }),
	                runOnDetached(function () {
	                  cropRect.clear();
	                })
	              ])])
	          }
	        ],
	        containerBehaviours: derive$1([
	          Replacing.config({}),
	          config('image-panel-events', [runOnAttached(function (comp) {
	              updateSrc(comp, initialUrl);
	            })])
	        ])
	      });
	      var memContainer = record(container);
	      var getMeasurements = function () {
	        var viewRect = viewRectState.get();
	        return {
	          width: viewRect.w,
	          height: viewRect.h
	        };
	      };
	      return {
	        memContainer: memContainer,
	        updateSrc: updateSrc,
	        zoom: zoom,
	        showCrop: showCrop,
	        hideCrop: hideCrop,
	        getRect: getRect,
	        getMeasurements: getMeasurements
	      };
	    };
	
	    var createButton = function (innerHtml, icon, disabled, action, providersBackstage) {
	      return renderIconButton({
	        name: innerHtml,
	        icon: Optional.some(icon),
	        disabled: disabled,
	        tooltip: Optional.some(innerHtml),
	        primary: false,
	        borderless: false
	      }, action, providersBackstage);
	    };
	    var setButtonEnabled = function (button, enabled) {
	      if (enabled) {
	        Disabling.enable(button);
	      } else {
	        Disabling.disable(button);
	      }
	    };
	    var renderSideBar = function (providersBackstage) {
	      var updateButtonUndoStates = function (anyInSystem, undoEnabled, redoEnabled) {
	        memUndo.getOpt(anyInSystem).each(function (undo) {
	          setButtonEnabled(undo, undoEnabled);
	        });
	        memRedo.getOpt(anyInSystem).each(function (redo) {
	          setButtonEnabled(redo, redoEnabled);
	        });
	      };
	      var memUndo = record(createButton('Undo', 'undo', true, function (button) {
	        emitWith(button, internal.undo(), { direction: 1 });
	      }, providersBackstage));
	      var memRedo = record(createButton('Redo', 'redo', true, function (button) {
	        emitWith(button, internal.redo(), { direction: 1 });
	      }, providersBackstage));
	      var container = Container.sketch({
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-image-tools__toolbar',
	            'tox-image-tools__sidebar'
	          ]
	        },
	        components: [
	          memUndo.asSpec(),
	          memRedo.asSpec(),
	          createButton('Zoom in', 'zoom-in', false, function (button) {
	            emitWith(button, internal.zoom(), { direction: 1 });
	          }, providersBackstage),
	          createButton('Zoom out', 'zoom-out', false, function (button) {
	            emitWith(button, internal.zoom(), { direction: -1 });
	          }, providersBackstage)
	        ]
	      });
	      return {
	        container: container,
	        updateButtonUndoStates: updateButtonUndoStates
	      };
	    };
	
	    function UndoStack () {
	      var data = [];
	      var index = -1;
	      var add = function (state) {
	        var removed = data.splice(++index);
	        data.push(state);
	        return {
	          state: state,
	          removed: removed
	        };
	      };
	      var undo = function () {
	        if (canUndo()) {
	          return data[--index];
	        }
	      };
	      var redo = function () {
	        if (canRedo()) {
	          return data[++index];
	        }
	      };
	      var canUndo = function () {
	        return index > 0;
	      };
	      var canRedo = function () {
	        return index !== -1 && index < data.length - 1;
	      };
	      return {
	        data: data,
	        add: add,
	        undo: undo,
	        redo: redo,
	        canUndo: canUndo,
	        canRedo: canRedo
	      };
	    }
	
	    var makeState = function (initialState) {
	      var blobState = Cell(initialState);
	      var tempState = value$1();
	      var undoStack = UndoStack();
	      undoStack.add(initialState);
	      var getBlobState = function () {
	        return blobState.get();
	      };
	      var setBlobState = function (state) {
	        blobState.set(state);
	      };
	      var getTempState = function () {
	        return tempState.get().getOrThunk(blobState.get);
	      };
	      var updateTempState = function (blob) {
	        var newTempState = createState(blob);
	        destroyTempState();
	        tempState.set(newTempState);
	        return newTempState.url;
	      };
	      var createState = function (blob) {
	        return {
	          blob: blob,
	          url: URL.createObjectURL(blob)
	        };
	      };
	      var destroyState = function (state) {
	        URL.revokeObjectURL(state.url);
	      };
	      var destroyStates = function (states) {
	        global$5.each(states, destroyState);
	      };
	      var destroyTempState = function () {
	        tempState.on(destroyState);
	        tempState.clear();
	      };
	      var addBlobState = function (blob) {
	        var newState = createState(blob);
	        setBlobState(newState);
	        var removed = undoStack.add(newState).removed;
	        destroyStates(removed);
	        return newState.url;
	      };
	      var addTempState = function (blob) {
	        var newState = createState(blob);
	        tempState.set(newState);
	        return newState.url;
	      };
	      var applyTempState = function (postApply) {
	        return tempState.get().fold(noop, function (temp) {
	          addBlobState(temp.blob);
	          postApply();
	        });
	      };
	      var undo = function () {
	        var currentState = undoStack.undo();
	        setBlobState(currentState);
	        return currentState.url;
	      };
	      var redo = function () {
	        var currentState = undoStack.redo();
	        setBlobState(currentState);
	        return currentState.url;
	      };
	      var getHistoryStates = function () {
	        var undoEnabled = undoStack.canUndo();
	        var redoEnabled = undoStack.canRedo();
	        return {
	          undoEnabled: undoEnabled,
	          redoEnabled: redoEnabled
	        };
	      };
	      return {
	        getBlobState: getBlobState,
	        setBlobState: setBlobState,
	        addBlobState: addBlobState,
	        getTempState: getTempState,
	        updateTempState: updateTempState,
	        addTempState: addTempState,
	        applyTempState: applyTempState,
	        destroyTempState: destroyTempState,
	        undo: undo,
	        redo: redo,
	        getHistoryStates: getHistoryStates
	      };
	    };
	
	    var renderImageTools = function (detail, providersBackstage) {
	      var state = makeState(detail.currentState);
	      var zoom = function (anyInSystem, simulatedEvent) {
	        var direction = simulatedEvent.event.direction;
	        imagePanel.zoom(anyInSystem, direction);
	      };
	      var updateButtonUndoStates = function (anyInSystem) {
	        var historyStates = state.getHistoryStates();
	        sideBar.updateButtonUndoStates(anyInSystem, historyStates.undoEnabled, historyStates.redoEnabled);
	        emitWith(anyInSystem, external.formActionEvent, {
	          name: external.saveState(),
	          value: historyStates.undoEnabled
	        });
	      };
	      var disableUndoRedo = function (anyInSystem) {
	        sideBar.updateButtonUndoStates(anyInSystem, false, false);
	      };
	      var undo = function (anyInSystem, _simulatedEvent) {
	        var url = state.undo();
	        updateSrc(anyInSystem, url).then(function (_oImg) {
	          unblock(anyInSystem);
	          updateButtonUndoStates(anyInSystem);
	        });
	      };
	      var redo = function (anyInSystem, _simulatedEvent) {
	        var url = state.redo();
	        updateSrc(anyInSystem, url).then(function (_oImg) {
	          unblock(anyInSystem);
	          updateButtonUndoStates(anyInSystem);
	        });
	      };
	      var imageResultToBlob = function (ir) {
	        return ir.toBlob();
	      };
	      var block = function (anyInSystem) {
	        emitWith(anyInSystem, external.formActionEvent, {
	          name: external.disable(),
	          value: {}
	        });
	      };
	      var unblock = function (anyInSystem) {
	        editPanel.getApplyButton(anyInSystem).each(function (applyButton) {
	          Disabling.enable(applyButton);
	        });
	        emitWith(anyInSystem, external.formActionEvent, {
	          name: external.enable(),
	          value: {}
	        });
	      };
	      var updateSrc = function (anyInSystem, src) {
	        block(anyInSystem);
	        return imagePanel.updateSrc(anyInSystem, src);
	      };
	      var blobManipulate = function (anyInSystem, blob, filter, action, swap) {
	        block(anyInSystem);
	        blobToImageResult(blob).then(filter).then(imageResultToBlob).then(action).then(function (url) {
	          return updateSrc(anyInSystem, url);
	        }).then(function () {
	          updateButtonUndoStates(anyInSystem);
	          swap();
	          unblock(anyInSystem);
	        }).catch(function (err) {
	          console.log(err);
	          if (anyInSystem.getSystem().isConnected()) {
	            unblock(anyInSystem);
	          }
	        });
	      };
	      var manipulate = function (anyInSystem, filter, swap) {
	        var blob = state.getBlobState().blob;
	        var action = function (blob) {
	          return state.updateTempState(blob);
	        };
	        blobManipulate(anyInSystem, blob, filter, action, swap);
	      };
	      var tempManipulate = function (anyInSystem, filter) {
	        var blob = state.getTempState().blob;
	        var action = function (blob) {
	          return state.addTempState(blob);
	        };
	        blobManipulate(anyInSystem, blob, filter, action, noop);
	      };
	      var manipulateApply = function (anyInSystem, filter, swap) {
	        var blob = state.getBlobState().blob;
	        var action = function (blob) {
	          var url = state.addBlobState(blob);
	          destroyTempState(anyInSystem);
	          return url;
	        };
	        blobManipulate(anyInSystem, blob, filter, action, swap);
	      };
	      var apply = function (anyInSystem, simulatedEvent) {
	        var postApply = function () {
	          destroyTempState(anyInSystem);
	          var swap = simulatedEvent.event.swap;
	          swap();
	        };
	        state.applyTempState(postApply);
	      };
	      var destroyTempState = function (anyInSystem) {
	        var currentUrl = state.getBlobState().url;
	        state.destroyTempState();
	        updateButtonUndoStates(anyInSystem);
	        return currentUrl;
	      };
	      var cancel = function (anyInSystem) {
	        var currentUrl = destroyTempState(anyInSystem);
	        updateSrc(anyInSystem, currentUrl).then(function (_oImg) {
	          unblock(anyInSystem);
	        });
	      };
	      var back = function (anyInSystem, simulatedEvent) {
	        cancel(anyInSystem);
	        var swap = simulatedEvent.event.swap;
	        swap();
	        imagePanel.hideCrop();
	      };
	      var transform = function (anyInSystem, simulatedEvent) {
	        return manipulate(anyInSystem, simulatedEvent.event.transform, noop);
	      };
	      var tempTransform = function (anyInSystem, simulatedEvent) {
	        return tempManipulate(anyInSystem, simulatedEvent.event.transform);
	      };
	      var transformApply = function (anyInSystem, simulatedEvent) {
	        return manipulateApply(anyInSystem, simulatedEvent.event.transform, simulatedEvent.event.swap);
	      };
	      var imagePanel = renderImagePanel(detail.currentState.url);
	      var sideBar = renderSideBar(providersBackstage);
	      var editPanel = renderEditPanel(imagePanel, providersBackstage);
	      var swap = function (anyInSystem, simulatedEvent) {
	        disableUndoRedo(anyInSystem);
	        var transform = simulatedEvent.event.transform;
	        var swap = simulatedEvent.event.swap;
	        transform.fold(function () {
	          swap();
	        }, function (transform) {
	          manipulate(anyInSystem, transform, swap);
	        });
	      };
	      return {
	        dom: {
	          tag: 'div',
	          attributes: { role: 'presentation' }
	        },
	        components: [
	          editPanel.memContainer.asSpec(),
	          imagePanel.memContainer.asSpec(),
	          sideBar.container
	        ],
	        behaviours: derive$1([
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function () {
	                return state.getBlobState();
	              }
	            }
	          }),
	          config('image-tools-events', [
	            run$1(internal.undo(), undo),
	            run$1(internal.redo(), redo),
	            run$1(internal.zoom(), zoom),
	            run$1(internal.back(), back),
	            run$1(internal.apply(), apply),
	            run$1(internal.transform(), transform),
	            run$1(internal.tempTransform(), tempTransform),
	            run$1(internal.transformApply(), transformApply),
	            run$1(internal.swap(), swap)
	          ]),
	          ComposingConfigs.self()
	        ])
	      };
	    };
	
	    var renderLabel = function (spec, backstageShared) {
	      var label = {
	        dom: {
	          tag: 'label',
	          innerHtml: backstageShared.providers.translate(spec.label),
	          classes: ['tox-label']
	        }
	      };
	      var comps = map$2(spec.items, backstageShared.interpreter);
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: [label].concat(comps),
	        behaviours: derive$1([
	          ComposingConfigs.self(),
	          Replacing.config({}),
	          RepresentingConfigs.domHtml(Optional.none()),
	          Keying.config({ mode: 'acyclic' })
	        ])
	      };
	    };
	
	    var isSingleListItem = function (item) {
	      return !has$2(item, 'items');
	    };
	    var dataAttribute = 'data-value';
	    var fetchItems = function (dropdownComp, name, items, selectedValue) {
	      return map$2(items, function (item) {
	        if (!isSingleListItem(item)) {
	          return {
	            type: 'nestedmenuitem',
	            text: item.text,
	            getSubmenuItems: function () {
	              return fetchItems(dropdownComp, name, item.items, selectedValue);
	            }
	          };
	        } else {
	          return {
	            type: 'togglemenuitem',
	            text: item.text,
	            value: item.value,
	            active: item.value === selectedValue,
	            onAction: function () {
	              Representing.setValue(dropdownComp, item.value);
	              emitWith(dropdownComp, formChangeEvent, { name: name });
	              Focusing.focus(dropdownComp);
	            }
	          };
	        }
	      });
	    };
	    var findItemByValue = function (items, value) {
	      return findMap(items, function (item) {
	        if (!isSingleListItem(item)) {
	          return findItemByValue(item.items, value);
	        } else {
	          return someIf(item.value === value, item);
	        }
	      });
	    };
	    var renderListBox = function (spec, backstage) {
	      var providersBackstage = backstage.shared.providers;
	      var initialItem = head(spec.items).filter(isSingleListItem);
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel$2(label, providersBackstage);
	      });
	      var pField = FormField.parts.field({
	        dom: {},
	        factory: {
	          sketch: function (sketchSpec) {
	            return renderCommonDropdown({
	              uid: sketchSpec.uid,
	              text: initialItem.map(function (item) {
	                return item.text;
	              }),
	              icon: Optional.none(),
	              tooltip: spec.label,
	              role: Optional.none(),
	              fetch: function (comp, callback) {
	                var items = fetchItems(comp, spec.name, spec.items, Representing.getValue(comp));
	                callback(build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false));
	              },
	              onSetup: constant$1(noop),
	              getApi: constant$1({}),
	              columns: 1,
	              presets: 'normal',
	              classes: [],
	              dropdownBehaviours: [
	                Tabstopping.config({}),
	                Representing.config({
	                  store: {
	                    mode: 'manual',
	                    initialValue: initialItem.map(function (item) {
	                      return item.value;
	                    }).getOr(''),
	                    getValue: function (comp) {
	                      return get$d(comp.element, dataAttribute);
	                    },
	                    setValue: function (comp, data) {
	                      findItemByValue(spec.items, data).each(function (item) {
	                        set$8(comp.element, dataAttribute, item.value);
	                        emitWith(comp, updateMenuText, { text: item.text });
	                      });
	                    }
	                  }
	                })
	              ]
	            }, 'tox-listbox', backstage.shared);
	          }
	        }
	      });
	      var listBoxWrap = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-listboxfield']
	        },
	        components: [pField]
	      };
	      return FormField.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: flatten([
	          pLabel.toArray(),
	          [listBoxWrap]
	        ]),
	        fieldBehaviours: derive$1([Disabling.config({
	            disabled: constant$1(spec.disabled),
	            onDisabled: function (comp) {
	              FormField.getField(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormField.getField(comp).each(Disabling.enable);
	            }
	          })])
	      });
	    };
	
	    var renderPanel = function (spec, backstage) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: spec.classes
	        },
	        components: map$2(spec.items, backstage.shared.interpreter)
	      };
	    };
	
	    var factory$e = function (detail, _spec) {
	      var options = map$2(detail.options, function (option) {
	        return {
	          dom: {
	            tag: 'option',
	            value: option.value,
	            innerHtml: option.text
	          }
	        };
	      });
	      var initialValues = detail.data.map(function (v) {
	        return wrap$1('initialValue', v);
	      }).getOr({});
	      return {
	        uid: detail.uid,
	        dom: {
	          tag: 'select',
	          classes: detail.selectClasses,
	          attributes: detail.selectAttributes
	        },
	        components: options,
	        behaviours: augment(detail.selectBehaviours, [
	          Focusing.config({}),
	          Representing.config({
	            store: __assign({
	              mode: 'manual',
	              getValue: function (select) {
	                return get$5(select.element);
	              },
	              setValue: function (select, newValue) {
	                var found = find$5(detail.options, function (opt) {
	                  return opt.value === newValue;
	                });
	                if (found.isSome()) {
	                  set$4(select.element, newValue);
	                }
	              }
	            }, initialValues)
	          })
	        ])
	      };
	    };
	    var HtmlSelect = single({
	      name: 'HtmlSelect',
	      configFields: [
	        required$1('options'),
	        field('selectBehaviours', [
	          Focusing,
	          Representing
	        ]),
	        defaulted('selectClasses', []),
	        defaulted('selectAttributes', {}),
	        option('data')
	      ],
	      factory: factory$e
	    });
	
	    var renderSelectBox = function (spec, providersBackstage) {
	      var translatedOptions = map$2(spec.items, function (item) {
	        return {
	          text: providersBackstage.translate(item.text),
	          value: item.value
	        };
	      });
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel$2(label, providersBackstage);
	      });
	      var pField = FormField.parts.field({
	        dom: {},
	        selectAttributes: { size: spec.size },
	        options: translatedOptions,
	        factory: HtmlSelect,
	        selectBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            }
	          }),
	          Tabstopping.config({}),
	          config('selectbox-change', [run$1(change(), function (component, _) {
	              emitWith(component, formChangeEvent, { name: spec.name });
	            })])
	        ])
	      });
	      var chevron = spec.size > 1 ? Optional.none() : Optional.some(render$3('chevron-down', {
	        tag: 'div',
	        classes: ['tox-selectfield__icon-js']
	      }, providersBackstage.icons));
	      var selectWrap = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-selectfield']
	        },
	        components: flatten([
	          [pField],
	          chevron.toArray()
	        ])
	      };
	      return FormField.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: flatten([
	          pLabel.toArray(),
	          [selectWrap]
	        ]),
	        fieldBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            },
	            onDisabled: function (comp) {
	              FormField.getField(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormField.getField(comp).each(Disabling.enable);
	            }
	          }),
	          receivingConfig()
	        ])
	      });
	    };
	
	    var renderTable = function (spec, providersBackstage) {
	      var renderTh = function (text) {
	        return {
	          dom: {
	            tag: 'th',
	            innerHtml: providersBackstage.translate(text)
	          }
	        };
	      };
	      var renderHeader = function (header) {
	        return {
	          dom: { tag: 'thead' },
	          components: [{
	              dom: { tag: 'tr' },
	              components: map$2(header, renderTh)
	            }]
	        };
	      };
	      var renderTd = function (text) {
	        return {
	          dom: {
	            tag: 'td',
	            innerHtml: providersBackstage.translate(text)
	          }
	        };
	      };
	      var renderTr = function (row) {
	        return {
	          dom: { tag: 'tr' },
	          components: map$2(row, renderTd)
	        };
	      };
	      var renderRows = function (rows) {
	        return {
	          dom: { tag: 'tbody' },
	          components: map$2(rows, renderTr)
	        };
	      };
	      return {
	        dom: {
	          tag: 'table',
	          classes: ['tox-dialog__table']
	        },
	        components: [
	          renderHeader(spec.header),
	          renderRows(spec.cells)
	        ],
	        behaviours: derive$1([
	          Tabstopping.config({}),
	          Focusing.config({})
	        ])
	      };
	    };
	
	    var renderTextField = function (spec, providersBackstage) {
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel$2(label, providersBackstage);
	      });
	      var baseInputBehaviours = [
	        Disabling.config({
	          disabled: function () {
	            return spec.disabled || providersBackstage.isDisabled();
	          }
	        }),
	        receivingConfig(),
	        Keying.config({
	          mode: 'execution',
	          useEnter: spec.multiline !== true,
	          useControlEnter: spec.multiline === true,
	          execute: function (comp) {
	            emit(comp, formSubmitEvent);
	            return Optional.some(true);
	          }
	        }),
	        config('textfield-change', [
	          run$1(input(), function (component, _) {
	            emitWith(component, formChangeEvent, { name: spec.name });
	          }),
	          run$1(postPaste(), function (component, _) {
	            emitWith(component, formChangeEvent, { name: spec.name });
	          })
	        ]),
	        Tabstopping.config({})
	      ];
	      var validatingBehaviours = spec.validation.map(function (vl) {
	        return Invalidating.config({
	          getRoot: function (input) {
	            return parent(input.element);
	          },
	          invalidClass: 'tox-invalid',
	          validator: {
	            validate: function (input) {
	              var v = Representing.getValue(input);
	              var result = vl.validator(v);
	              return Future.pure(result === true ? Result.value(v) : Result.error(result));
	            },
	            validateOnLoad: vl.validateOnLoad
	          }
	        });
	      }).toArray();
	      var placeholder = spec.placeholder.fold(constant$1({}), function (p) {
	        return { placeholder: providersBackstage.translate(p) };
	      });
	      var inputMode = spec.inputMode.fold(constant$1({}), function (mode) {
	        return { inputmode: mode };
	      });
	      var inputAttributes = __assign(__assign({}, placeholder), inputMode);
	      var pField = FormField.parts.field({
	        tag: spec.multiline === true ? 'textarea' : 'input',
	        inputAttributes: inputAttributes,
	        inputClasses: [spec.classname],
	        inputBehaviours: derive$1(flatten([
	          baseInputBehaviours,
	          validatingBehaviours
	        ])),
	        selectOnFocus: false,
	        factory: Input
	      });
	      var extraClasses = spec.flex ? ['tox-form__group--stretched'] : [];
	      var extraClasses2 = extraClasses.concat(spec.maximized ? ['tox-form-group--maximize'] : []);
	      var extraBehaviours = [
	        Disabling.config({
	          disabled: function () {
	            return spec.disabled || providersBackstage.isDisabled();
	          },
	          onDisabled: function (comp) {
	            FormField.getField(comp).each(Disabling.disable);
	          },
	          onEnabled: function (comp) {
	            FormField.getField(comp).each(Disabling.enable);
	          }
	        }),
	        receivingConfig()
	      ];
	      return renderFormFieldWith(pLabel, pField, extraClasses2, extraBehaviours);
	    };
	    var renderInput = function (spec, providersBackstage) {
	      return renderTextField({
	        name: spec.name,
	        multiline: false,
	        label: spec.label,
	        inputMode: spec.inputMode,
	        placeholder: spec.placeholder,
	        flex: false,
	        disabled: spec.disabled,
	        classname: 'tox-textfield',
	        validation: Optional.none(),
	        maximized: spec.maximized
	      }, providersBackstage);
	    };
	    var renderTextarea = function (spec, providersBackstage) {
	      return renderTextField({
	        name: spec.name,
	        multiline: true,
	        label: spec.label,
	        inputMode: Optional.none(),
	        placeholder: spec.placeholder,
	        flex: true,
	        disabled: spec.disabled,
	        classname: 'tox-textarea',
	        validation: Optional.none(),
	        maximized: spec.maximized
	      }, providersBackstage);
	    };
	
	    var events$6 = function (streamConfig, streamState) {
	      var streams = streamConfig.stream.streams;
	      var processor = streams.setup(streamConfig, streamState);
	      return derive$2([
	        run$1(streamConfig.event, processor),
	        runOnDetached(function () {
	          return streamState.cancel();
	        })
	      ].concat(streamConfig.cancelEvent.map(function (e) {
	        return [run$1(e, function () {
	            return streamState.cancel();
	          })];
	      }).getOr([])));
	    };
	
	    var ActiveStreaming = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$6
	    });
	
	    var throttle = function (_config) {
	      var state = Cell(null);
	      var readState = function () {
	        return { timer: state.get() !== null ? 'set' : 'unset' };
	      };
	      var setTimer = function (t) {
	        state.set(t);
	      };
	      var cancel = function () {
	        var t = state.get();
	        if (t !== null) {
	          t.cancel();
	        }
	      };
	      return nu$8({
	        readState: readState,
	        setTimer: setTimer,
	        cancel: cancel
	      });
	    };
	    var init$9 = function (spec) {
	      return spec.stream.streams.state(spec);
	    };
	
	    var StreamingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        throttle: throttle,
	        init: init$9
	    });
	
	    var setup$c = function (streamInfo, streamState) {
	      var sInfo = streamInfo.stream;
	      var throttler = last(streamInfo.onStream, sInfo.delay);
	      streamState.setTimer(throttler);
	      return function (component, simulatedEvent) {
	        throttler.throttle(component, simulatedEvent);
	        if (sInfo.stopEvent) {
	          simulatedEvent.stop();
	        }
	      };
	    };
	    var StreamingSchema = [
	      requiredOf('stream', choose$1('mode', {
	        throttle: [
	          required$1('delay'),
	          defaulted('stopEvent', true),
	          output$1('streams', {
	            setup: setup$c,
	            state: throttle
	          })
	        ]
	      })),
	      defaulted('event', 'input'),
	      option('cancelEvent'),
	      onStrictHandler('onStream')
	    ];
	
	    var Streaming = create$8({
	      fields: StreamingSchema,
	      name: 'streaming',
	      active: ActiveStreaming,
	      state: StreamingState
	    });
	
	    var setValueFromItem = function (model, input, item) {
	      var itemData = Representing.getValue(item);
	      Representing.setValue(input, itemData);
	      setCursorAtEnd(input);
	    };
	    var setSelectionOn = function (input, f) {
	      var el = input.element;
	      var value = get$5(el);
	      var node = el.dom;
	      if (get$d(el, 'type') !== 'number') {
	        f(node, value);
	      }
	    };
	    var setCursorAtEnd = function (input) {
	      setSelectionOn(input, function (node, value) {
	        return node.setSelectionRange(value.length, value.length);
	      });
	    };
	    var setSelectionToEnd = function (input, startOffset) {
	      setSelectionOn(input, function (node, value) {
	        return node.setSelectionRange(startOffset, value.length);
	      });
	    };
	    var attemptSelectOver = function (model, input, item) {
	      if (!model.selectsOver) {
	        return Optional.none();
	      } else {
	        var currentValue = Representing.getValue(input);
	        var inputDisplay_1 = model.getDisplayText(currentValue);
	        var itemValue = Representing.getValue(item);
	        var itemDisplay = model.getDisplayText(itemValue);
	        return itemDisplay.indexOf(inputDisplay_1) === 0 ? Optional.some(function () {
	          setValueFromItem(model, input, item);
	          setSelectionToEnd(input, inputDisplay_1.length);
	        }) : Optional.none();
	      }
	    };
	
	    var itemExecute = constant$1('alloy.typeahead.itemexecute');
	
	    var make$3 = function (detail, components, spec, externals) {
	      var navigateList = function (comp, simulatedEvent, highlighter) {
	        detail.previewing.set(false);
	        var sandbox = Coupling.getCoupled(comp, 'sandbox');
	        if (Sandboxing.isOpen(sandbox)) {
	          Composing.getCurrent(sandbox).each(function (menu) {
	            Highlighting.getHighlighted(menu).fold(function () {
	              highlighter(menu);
	            }, function () {
	              dispatchEvent(sandbox, menu.element, 'keydown', simulatedEvent);
	            });
	          });
	        } else {
	          var onOpenSync = function (sandbox) {
	            Composing.getCurrent(sandbox).each(highlighter);
	          };
	          open(detail, mapFetch(comp), comp, sandbox, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	        }
	      };
	      var focusBehaviours$1 = focusBehaviours(detail);
	      var mapFetch = function (comp) {
	        return function (tdata) {
	          return tdata.map(function (data) {
	            var menus = values(data.menus);
	            var items = bind$3(menus, function (menu) {
	              return filter$2(menu.items, function (item) {
	                return item.type === 'item';
	              });
	            });
	            var repState = Representing.getState(comp);
	            repState.update(map$2(items, function (item) {
	              return item.data;
	            }));
	            return data;
	          });
	        };
	      };
	      var behaviours = [
	        Focusing.config({}),
	        Representing.config({
	          onSetValue: detail.onSetValue,
	          store: __assign({
	            mode: 'dataset',
	            getDataKey: function (comp) {
	              return get$5(comp.element);
	            },
	            getFallbackEntry: function (itemString) {
	              return {
	                value: itemString,
	                meta: {}
	              };
	            },
	            setValue: function (comp, data) {
	              set$4(comp.element, detail.model.getDisplayText(data));
	            }
	          }, detail.initialData.map(function (d) {
	            return wrap$1('initialValue', d);
	          }).getOr({}))
	        }),
	        Streaming.config({
	          stream: {
	            mode: 'throttle',
	            delay: detail.responseTime,
	            stopEvent: false
	          },
	          onStream: function (component, _simulatedEvent) {
	            var sandbox = Coupling.getCoupled(component, 'sandbox');
	            var focusInInput = Focusing.isFocused(component);
	            if (focusInInput) {
	              if (get$5(component.element).length >= detail.minChars) {
	                var previousValue_1 = Composing.getCurrent(sandbox).bind(function (menu) {
	                  return Highlighting.getHighlighted(menu).map(Representing.getValue);
	                });
	                detail.previewing.set(true);
	                var onOpenSync = function (_sandbox) {
	                  Composing.getCurrent(sandbox).each(function (menu) {
	                    previousValue_1.fold(function () {
	                      if (detail.model.selectsOver) {
	                        Highlighting.highlightFirst(menu);
	                      }
	                    }, function (pv) {
	                      Highlighting.highlightBy(menu, function (item) {
	                        var itemData = Representing.getValue(item);
	                        return itemData.value === pv.value;
	                      });
	                      Highlighting.getHighlighted(menu).orThunk(function () {
	                        Highlighting.highlightFirst(menu);
	                        return Optional.none();
	                      });
	                    });
	                  });
	                };
	                open(detail, mapFetch(component), component, sandbox, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	              }
	            }
	          },
	          cancelEvent: typeaheadCancel()
	        }),
	        Keying.config({
	          mode: 'special',
	          onDown: function (comp, simulatedEvent) {
	            navigateList(comp, simulatedEvent, Highlighting.highlightFirst);
	            return Optional.some(true);
	          },
	          onEscape: function (comp) {
	            var sandbox = Coupling.getCoupled(comp, 'sandbox');
	            if (Sandboxing.isOpen(sandbox)) {
	              Sandboxing.close(sandbox);
	              return Optional.some(true);
	            }
	            return Optional.none();
	          },
	          onUp: function (comp, simulatedEvent) {
	            navigateList(comp, simulatedEvent, Highlighting.highlightLast);
	            return Optional.some(true);
	          },
	          onEnter: function (comp) {
	            var sandbox = Coupling.getCoupled(comp, 'sandbox');
	            var sandboxIsOpen = Sandboxing.isOpen(sandbox);
	            if (sandboxIsOpen && !detail.previewing.get()) {
	              return Composing.getCurrent(sandbox).bind(function (menu) {
	                return Highlighting.getHighlighted(menu);
	              }).map(function (item) {
	                emitWith(comp, itemExecute(), { item: item });
	                return true;
	              });
	            } else {
	              var currentValue = Representing.getValue(comp);
	              emit(comp, typeaheadCancel());
	              detail.onExecute(sandbox, comp, currentValue);
	              if (sandboxIsOpen) {
	                Sandboxing.close(sandbox);
	              }
	              return Optional.some(true);
	            }
	          }
	        }),
	        Toggling.config({
	          toggleClass: detail.markers.openClass,
	          aria: { mode: 'expanded' }
	        }),
	        Coupling.config({
	          others: {
	            sandbox: function (hotspot) {
	              return makeSandbox$1(detail, hotspot, {
	                onOpen: function () {
	                  return Toggling.on(hotspot);
	                },
	                onClose: function () {
	                  return Toggling.off(hotspot);
	                }
	              });
	            }
	          }
	        }),
	        config('typeaheadevents', [
	          runOnExecute$1(function (comp) {
	            var onOpenSync = noop;
	            togglePopup(detail, mapFetch(comp), comp, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	          }),
	          run$1(itemExecute(), function (comp, se) {
	            var sandbox = Coupling.getCoupled(comp, 'sandbox');
	            setValueFromItem(detail.model, comp, se.event.item);
	            emit(comp, typeaheadCancel());
	            detail.onItemExecute(comp, sandbox, se.event.item, Representing.getValue(comp));
	            Sandboxing.close(sandbox);
	            setCursorAtEnd(comp);
	          })
	        ].concat(detail.dismissOnBlur ? [run$1(postBlur(), function (typeahead) {
	            var sandbox = Coupling.getCoupled(typeahead, 'sandbox');
	            if (search(sandbox.element).isNone()) {
	              Sandboxing.close(sandbox);
	            }
	          })] : []))
	      ];
	      return {
	        uid: detail.uid,
	        dom: dom(deepMerge(detail, {
	          inputAttributes: {
	            'role': 'combobox',
	            'aria-autocomplete': 'list',
	            'aria-haspopup': 'true'
	          }
	        })),
	        behaviours: __assign(__assign({}, focusBehaviours$1), augment(detail.typeaheadBehaviours, behaviours)),
	        eventOrder: detail.eventOrder
	      };
	    };
	
	    var schema$g = constant$1([
	      option('lazySink'),
	      required$1('fetch'),
	      defaulted('minChars', 5),
	      defaulted('responseTime', 1000),
	      onHandler('onOpen'),
	      defaulted('getHotspot', Optional.some),
	      defaulted('getAnchorOverrides', constant$1({})),
	      defaulted('layouts', Optional.none()),
	      defaulted('eventOrder', {}),
	      defaultedObjOf('model', {}, [
	        defaulted('getDisplayText', function (itemData) {
	          return itemData.meta !== undefined && itemData.meta.text !== undefined ? itemData.meta.text : itemData.value;
	        }),
	        defaulted('selectsOver', true),
	        defaulted('populateFromBrowse', true)
	      ]),
	      onHandler('onSetValue'),
	      onKeyboardHandler('onExecute'),
	      onHandler('onItemExecute'),
	      defaulted('inputClasses', []),
	      defaulted('inputAttributes', {}),
	      defaulted('inputStyles', {}),
	      defaulted('matchWidth', true),
	      defaulted('useMinWidth', false),
	      defaulted('dismissOnBlur', true),
	      markers$1(['openClass']),
	      option('initialData'),
	      field('typeaheadBehaviours', [
	        Focusing,
	        Representing,
	        Streaming,
	        Keying,
	        Toggling,
	        Coupling
	      ]),
	      customField('previewing', function () {
	        return Cell(true);
	      })
	    ].concat(schema$k()).concat(sandboxFields()));
	    var parts$b = constant$1([external$1({
	        schema: [tieredMenuMarkers()],
	        name: 'menu',
	        overrides: function (detail) {
	          return {
	            fakeFocus: true,
	            onHighlight: function (menu, item) {
	              if (!detail.previewing.get()) {
	                menu.getSystem().getByUid(detail.uid).each(function (input) {
	                  if (detail.model.populateFromBrowse) {
	                    setValueFromItem(detail.model, input, item);
	                  }
	                });
	              } else {
	                menu.getSystem().getByUid(detail.uid).each(function (input) {
	                  attemptSelectOver(detail.model, input, item).fold(function () {
	                    return Highlighting.dehighlight(menu, item);
	                  }, function (fn) {
	                    return fn();
	                  });
	                });
	              }
	              detail.previewing.set(false);
	            },
	            onExecute: function (menu, item) {
	              return menu.getSystem().getByUid(detail.uid).toOptional().map(function (typeahead) {
	                emitWith(typeahead, itemExecute(), { item: item });
	                return true;
	              });
	            },
	            onHover: function (menu, item) {
	              detail.previewing.set(false);
	              menu.getSystem().getByUid(detail.uid).each(function (input) {
	                if (detail.model.populateFromBrowse) {
	                  setValueFromItem(detail.model, input, item);
	                }
	              });
	            }
	          };
	        }
	      })]);
	
	    var Typeahead = composite({
	      name: 'Typeahead',
	      configFields: schema$g(),
	      partFields: parts$b(),
	      factory: make$3
	    });
	
	    var wrap = function (delegate) {
	      var toCached = function () {
	        return wrap(delegate.toCached());
	      };
	      var bindFuture = function (f) {
	        return wrap(delegate.bind(function (resA) {
	          return resA.fold(function (err) {
	            return Future.pure(Result.error(err));
	          }, function (a) {
	            return f(a);
	          });
	        }));
	      };
	      var bindResult = function (f) {
	        return wrap(delegate.map(function (resA) {
	          return resA.bind(f);
	        }));
	      };
	      var mapResult = function (f) {
	        return wrap(delegate.map(function (resA) {
	          return resA.map(f);
	        }));
	      };
	      var mapError = function (f) {
	        return wrap(delegate.map(function (resA) {
	          return resA.mapError(f);
	        }));
	      };
	      var foldResult = function (whenError, whenValue) {
	        return delegate.map(function (res) {
	          return res.fold(whenError, whenValue);
	        });
	      };
	      var withTimeout = function (timeout, errorThunk) {
	        return wrap(Future.nu(function (callback) {
	          var timedOut = false;
	          var timer = setTimeout(function () {
	            timedOut = true;
	            callback(Result.error(errorThunk()));
	          }, timeout);
	          delegate.get(function (result) {
	            if (!timedOut) {
	              clearTimeout(timer);
	              callback(result);
	            }
	          });
	        }));
	      };
	      return __assign(__assign({}, delegate), {
	        toCached: toCached,
	        bindFuture: bindFuture,
	        bindResult: bindResult,
	        mapResult: mapResult,
	        mapError: mapError,
	        foldResult: foldResult,
	        withTimeout: withTimeout
	      });
	    };
	    var nu$1 = function (worker) {
	      return wrap(Future.nu(worker));
	    };
	    var value = function (value) {
	      return wrap(Future.pure(Result.value(value)));
	    };
	    var error = function (error) {
	      return wrap(Future.pure(Result.error(error)));
	    };
	    var fromResult = function (result) {
	      return wrap(Future.pure(result));
	    };
	    var fromFuture = function (future) {
	      return wrap(future.map(Result.value));
	    };
	    var fromPromise = function (promise) {
	      return nu$1(function (completer) {
	        promise.then(function (value) {
	          completer(Result.value(value));
	        }, function (error) {
	          completer(Result.error(error));
	        });
	      });
	    };
	    var FutureResult = {
	      nu: nu$1,
	      wrap: wrap,
	      pure: value,
	      value: value,
	      error: error,
	      fromResult: fromResult,
	      fromFuture: fromFuture,
	      fromPromise: fromPromise
	    };
	
	    var separator$1 = { type: 'separator' };
	    var toMenuItem = function (target) {
	      return {
	        type: 'menuitem',
	        value: target.url,
	        text: target.title,
	        meta: { attach: target.attach },
	        onAction: noop
	      };
	    };
	    var staticMenuItem = function (title, url) {
	      return {
	        type: 'menuitem',
	        value: url,
	        text: title,
	        meta: { attach: undefined },
	        onAction: noop
	      };
	    };
	    var toMenuItems = function (targets) {
	      return map$2(targets, toMenuItem);
	    };
	    var filterLinkTargets = function (type, targets) {
	      return filter$2(targets, function (target) {
	        return target.type === type;
	      });
	    };
	    var filteredTargets = function (type, targets) {
	      return toMenuItems(filterLinkTargets(type, targets));
	    };
	    var headerTargets = function (linkInfo) {
	      return filteredTargets('header', linkInfo.targets);
	    };
	    var anchorTargets = function (linkInfo) {
	      return filteredTargets('anchor', linkInfo.targets);
	    };
	    var anchorTargetTop = function (linkInfo) {
	      return Optional.from(linkInfo.anchorTop).map(function (url) {
	        return staticMenuItem('<top>', url);
	      }).toArray();
	    };
	    var anchorTargetBottom = function (linkInfo) {
	      return Optional.from(linkInfo.anchorBottom).map(function (url) {
	        return staticMenuItem('<bottom>', url);
	      }).toArray();
	    };
	    var historyTargets = function (history) {
	      return map$2(history, function (url) {
	        return staticMenuItem(url, url);
	      });
	    };
	    var joinMenuLists = function (items) {
	      return foldl(items, function (a, b) {
	        var bothEmpty = a.length === 0 || b.length === 0;
	        return bothEmpty ? a.concat(b) : a.concat(separator$1, b);
	      }, []);
	    };
	    var filterByQuery = function (term, menuItems) {
	      var lowerCaseTerm = term.toLowerCase();
	      return filter$2(menuItems, function (item) {
	        var text = item.meta !== undefined && item.meta.text !== undefined ? item.meta.text : item.text;
	        return contains$1(text.toLowerCase(), lowerCaseTerm) || contains$1(item.value.toLowerCase(), lowerCaseTerm);
	      });
	    };
	
	    var getItems = function (fileType, input, urlBackstage) {
	      var urlInputValue = Representing.getValue(input);
	      var term = urlInputValue.meta.text !== undefined ? urlInputValue.meta.text : urlInputValue.value;
	      var info = urlBackstage.getLinkInformation();
	      return info.fold(function () {
	        return [];
	      }, function (linkInfo) {
	        var history = filterByQuery(term, historyTargets(urlBackstage.getHistory(fileType)));
	        return fileType === 'file' ? joinMenuLists([
	          history,
	          filterByQuery(term, headerTargets(linkInfo)),
	          filterByQuery(term, flatten([
	            anchorTargetTop(linkInfo),
	            anchorTargets(linkInfo),
	            anchorTargetBottom(linkInfo)
	          ]))
	        ]) : history;
	      });
	    };
	    var errorId = generate$6('aria-invalid');
	    var renderUrlInput = function (spec, backstage, urlBackstage) {
	      var _a;
	      var providersBackstage = backstage.shared.providers;
	      var updateHistory = function (component) {
	        var urlEntry = Representing.getValue(component);
	        urlBackstage.addToHistory(urlEntry.value, spec.filetype);
	      };
	      var pField = FormField.parts.field({
	        factory: Typeahead,
	        dismissOnBlur: true,
	        inputClasses: ['tox-textfield'],
	        sandboxClasses: ['tox-dialog__popups'],
	        inputAttributes: {
	          'aria-errormessage': errorId,
	          'type': 'url'
	        },
	        minChars: 0,
	        responseTime: 0,
	        fetch: function (input) {
	          var items = getItems(spec.filetype, input, urlBackstage);
	          var tdata = build(items, ItemResponse$1.BUBBLE_TO_SANDBOX, backstage, false);
	          return Future.pure(tdata);
	        },
	        getHotspot: function (comp) {
	          return memUrlBox.getOpt(comp);
	        },
	        onSetValue: function (comp, _newValue) {
	          if (comp.hasConfigured(Invalidating)) {
	            Invalidating.run(comp).get(noop);
	          }
	        },
	        typeaheadBehaviours: derive$1(flatten([
	          urlBackstage.getValidationHandler().map(function (handler) {
	            return Invalidating.config({
	              getRoot: function (comp) {
	                return parent(comp.element);
	              },
	              invalidClass: 'tox-control-wrap--status-invalid',
	              notify: {
	                onInvalid: function (comp, err) {
	                  memInvalidIcon.getOpt(comp).each(function (invalidComp) {
	                    set$8(invalidComp.element, 'title', providersBackstage.translate(err));
	                  });
	                }
	              },
	              validator: {
	                validate: function (input) {
	                  var urlEntry = Representing.getValue(input);
	                  return FutureResult.nu(function (completer) {
	                    handler({
	                      type: spec.filetype,
	                      url: urlEntry.value
	                    }, function (validation) {
	                      if (validation.status === 'invalid') {
	                        var err = Result.error(validation.message);
	                        completer(err);
	                      } else {
	                        var val = Result.value(validation.message);
	                        completer(val);
	                      }
	                    });
	                  });
	                },
	                validateOnLoad: false
	              }
	            });
	          }).toArray(),
	          [
	            Disabling.config({
	              disabled: function () {
	                return spec.disabled || providersBackstage.isDisabled();
	              }
	            }),
	            Tabstopping.config({}),
	            config('urlinput-events', flatten([
	              spec.filetype === 'file' ? [run$1(input(), function (comp) {
	                  emitWith(comp, formChangeEvent, { name: spec.name });
	                })] : [],
	              [
	                run$1(change(), function (comp) {
	                  emitWith(comp, formChangeEvent, { name: spec.name });
	                  updateHistory(comp);
	                }),
	                run$1(postPaste(), function (comp) {
	                  emitWith(comp, formChangeEvent, { name: spec.name });
	                  updateHistory(comp);
	                })
	              ]
	            ]))
	          ]
	        ])),
	        eventOrder: (_a = {}, _a[input()] = [
	          'streaming',
	          'urlinput-events',
	          'invalidating'
	        ], _a),
	        model: {
	          getDisplayText: function (itemData) {
	            return itemData.value;
	          },
	          selectsOver: false,
	          populateFromBrowse: false
	        },
	        markers: { openClass: 'tox-textfield--popup-open' },
	        lazySink: backstage.shared.getSink,
	        parts: { menu: part(false, 1, 'normal') },
	        onExecute: function (_menu, component, _entry) {
	          emitWith(component, formSubmitEvent, {});
	        },
	        onItemExecute: function (typeahead, _sandbox, _item, _value) {
	          updateHistory(typeahead);
	          emitWith(typeahead, formChangeEvent, { name: spec.name });
	        }
	      });
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel$2(label, providersBackstage);
	      });
	      var makeIcon = function (name, errId, icon, label) {
	        if (icon === void 0) {
	          icon = name;
	        }
	        if (label === void 0) {
	          label = name;
	        }
	        return render$3(icon, {
	          tag: 'div',
	          classes: [
	            'tox-icon',
	            'tox-control-wrap__status-icon-' + name
	          ],
	          attributes: __assign({
	            'title': providersBackstage.translate(label),
	            'aria-live': 'polite'
	          }, errId.fold(function () {
	            return {};
	          }, function (id) {
	            return { id: id };
	          }))
	        }, providersBackstage.icons);
	      };
	      var memInvalidIcon = record(makeIcon('invalid', Optional.some(errorId), 'warning'));
	      var memStatus = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-control-wrap__status-icon-wrap']
	        },
	        components: [memInvalidIcon.asSpec()]
	      });
	      var optUrlPicker = urlBackstage.getUrlPicker(spec.filetype);
	      var browseUrlEvent = generate$6('browser.url.event');
	      var memUrlBox = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-control-wrap']
	        },
	        components: [
	          pField,
	          memStatus.asSpec()
	        ],
	        behaviours: derive$1([Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            }
	          })])
	      });
	      var memUrlPickerButton = record(renderButton({
	        name: spec.name,
	        icon: Optional.some('browse'),
	        text: spec.label.getOr(''),
	        disabled: spec.disabled,
	        primary: false,
	        borderless: true
	      }, function (component) {
	        return emit(component, browseUrlEvent);
	      }, providersBackstage, [], ['tox-browse-url']));
	      var controlHWrapper = function () {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-form__controls-h-stack']
	          },
	          components: flatten([
	            [memUrlBox.asSpec()],
	            optUrlPicker.map(function () {
	              return memUrlPickerButton.asSpec();
	            }).toArray()
	          ])
	        };
	      };
	      var openUrlPicker = function (comp) {
	        Composing.getCurrent(comp).each(function (field) {
	          var componentData = Representing.getValue(field);
	          var urlData = __assign({ fieldname: spec.name }, componentData);
	          optUrlPicker.each(function (picker) {
	            picker(urlData).get(function (chosenData) {
	              Representing.setValue(field, chosenData);
	              emitWith(comp, formChangeEvent, { name: spec.name });
	            });
	          });
	        });
	      };
	      return FormField.sketch({
	        dom: renderFormFieldDom(),
	        components: pLabel.toArray().concat([controlHWrapper()]),
	        fieldBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            },
	            onDisabled: function (comp) {
	              FormField.getField(comp).each(Disabling.disable);
	              memUrlPickerButton.getOpt(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormField.getField(comp).each(Disabling.enable);
	              memUrlPickerButton.getOpt(comp).each(Disabling.enable);
	            }
	          }),
	          receivingConfig(),
	          config('url-input-events', [run$1(browseUrlEvent, openUrlPicker)])
	        ])
	      });
	    };
	
	    var renderAlertBanner = function (spec, providersBackstage) {
	      return Container.sketch({
	        dom: {
	          tag: 'div',
	          attributes: { role: 'alert' },
	          classes: [
	            'tox-notification',
	            'tox-notification--in',
	            'tox-notification--' + spec.level
	          ]
	        },
	        components: [
	          {
	            dom: {
	              tag: 'div',
	              classes: ['tox-notification__icon']
	            },
	            components: [Button.sketch({
	                dom: {
	                  tag: 'button',
	                  classes: [
	                    'tox-button',
	                    'tox-button--naked',
	                    'tox-button--icon'
	                  ],
	                  innerHtml: get$1(spec.icon, providersBackstage.icons),
	                  attributes: { title: providersBackstage.translate(spec.iconTooltip) }
	                },
	                action: function (comp) {
	                  emitWith(comp, formActionEvent, {
	                    name: 'alert-banner',
	                    value: spec.url
	                  });
	                },
	                buttonBehaviours: derive$1([addFocusableBehaviour()])
	              })]
	          },
	          {
	            dom: {
	              tag: 'div',
	              classes: ['tox-notification__body'],
	              innerHtml: providersBackstage.translate(spec.text)
	            }
	          }
	        ]
	      });
	    };
	
	    var renderCheckbox = function (spec, providerBackstage) {
	      var repBehaviour = Representing.config({
	        store: {
	          mode: 'manual',
	          getValue: function (comp) {
	            var el = comp.element.dom;
	            return el.checked;
	          },
	          setValue: function (comp, value) {
	            var el = comp.element.dom;
	            el.checked = value;
	          }
	        }
	      });
	      var toggleCheckboxHandler = function (comp) {
	        comp.element.dom.click();
	        return Optional.some(true);
	      };
	      var pField = FormField.parts.field({
	        factory: { sketch: identity$1 },
	        dom: {
	          tag: 'input',
	          classes: ['tox-checkbox__input'],
	          attributes: { type: 'checkbox' }
	        },
	        behaviours: derive$1([
	          ComposingConfigs.self(),
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providerBackstage.isDisabled();
	            }
	          }),
	          Tabstopping.config({}),
	          Focusing.config({}),
	          repBehaviour,
	          Keying.config({
	            mode: 'special',
	            onEnter: toggleCheckboxHandler,
	            onSpace: toggleCheckboxHandler,
	            stopSpaceKeyup: true
	          }),
	          config('checkbox-events', [run$1(change(), function (component, _) {
	              emitWith(component, formChangeEvent, { name: spec.name });
	            })])
	        ])
	      });
	      var pLabel = FormField.parts.label({
	        dom: {
	          tag: 'span',
	          classes: ['tox-checkbox__label'],
	          innerHtml: providerBackstage.translate(spec.label)
	        },
	        behaviours: derive$1([Unselecting.config({})])
	      });
	      var makeIcon = function (className) {
	        var iconName = className === 'checked' ? 'selected' : 'unselected';
	        return render$3(iconName, {
	          tag: 'span',
	          classes: [
	            'tox-icon',
	            'tox-checkbox-icon__' + className
	          ]
	        }, providerBackstage.icons);
	      };
	      var memIcons = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-checkbox__icons']
	        },
	        components: [
	          makeIcon('checked'),
	          makeIcon('unchecked')
	        ]
	      });
	      return FormField.sketch({
	        dom: {
	          tag: 'label',
	          classes: ['tox-checkbox']
	        },
	        components: [
	          pField,
	          memIcons.asSpec(),
	          pLabel
	        ],
	        fieldBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providerBackstage.isDisabled();
	            },
	            disableClass: 'tox-checkbox--disabled',
	            onDisabled: function (comp) {
	              FormField.getField(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormField.getField(comp).each(Disabling.enable);
	            }
	          }),
	          receivingConfig()
	        ])
	      });
	    };
	
	    var renderHtmlPanel = function (spec) {
	      if (spec.presets === 'presentation') {
	        return Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-form__group'],
	            innerHtml: spec.html
	          }
	        });
	      } else {
	        return Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-form__group'],
	            innerHtml: spec.html,
	            attributes: { role: 'document' }
	          },
	          containerBehaviours: derive$1([
	            Tabstopping.config({}),
	            Focusing.config({})
	          ])
	        });
	      }
	    };
	
	    var make$2 = function (render) {
	      return function (parts, spec, backstage) {
	        return get$e(spec, 'name').fold(function () {
	          return render(spec, backstage);
	        }, function (fieldName) {
	          return parts.field(fieldName, render(spec, backstage));
	        });
	      };
	    };
	    var makeIframe = function (render) {
	      return function (parts, spec, backstage) {
	        var iframeSpec = deepMerge(spec, { source: 'dynamic' });
	        return make$2(render)(parts, iframeSpec, backstage);
	      };
	    };
	    var factories = {
	      bar: make$2(function (spec, backstage) {
	        return renderBar(spec, backstage.shared);
	      }),
	      collection: make$2(function (spec, backstage) {
	        return renderCollection(spec, backstage.shared.providers);
	      }),
	      alertbanner: make$2(function (spec, backstage) {
	        return renderAlertBanner(spec, backstage.shared.providers);
	      }),
	      input: make$2(function (spec, backstage) {
	        return renderInput(spec, backstage.shared.providers);
	      }),
	      textarea: make$2(function (spec, backstage) {
	        return renderTextarea(spec, backstage.shared.providers);
	      }),
	      label: make$2(function (spec, backstage) {
	        return renderLabel(spec, backstage.shared);
	      }),
	      iframe: makeIframe(function (spec, backstage) {
	        return renderIFrame(spec, backstage.shared.providers);
	      }),
	      button: make$2(function (spec, backstage) {
	        return renderDialogButton(spec, backstage.shared.providers);
	      }),
	      checkbox: make$2(function (spec, backstage) {
	        return renderCheckbox(spec, backstage.shared.providers);
	      }),
	      colorinput: make$2(function (spec, backstage) {
	        return renderColorInput(spec, backstage.shared, backstage.colorinput);
	      }),
	      colorpicker: make$2(renderColorPicker),
	      dropzone: make$2(function (spec, backstage) {
	        return renderDropZone(spec, backstage.shared.providers);
	      }),
	      grid: make$2(function (spec, backstage) {
	        return renderGrid(spec, backstage.shared);
	      }),
	      listbox: make$2(function (spec, backstage) {
	        return renderListBox(spec, backstage);
	      }),
	      selectbox: make$2(function (spec, backstage) {
	        return renderSelectBox(spec, backstage.shared.providers);
	      }),
	      sizeinput: make$2(function (spec, backstage) {
	        return renderSizeInput(spec, backstage.shared.providers);
	      }),
	      urlinput: make$2(function (spec, backstage) {
	        return renderUrlInput(spec, backstage, backstage.urlinput);
	      }),
	      customeditor: make$2(renderCustomEditor),
	      htmlpanel: make$2(renderHtmlPanel),
	      imagetools: make$2(function (spec, backstage) {
	        return renderImageTools(spec, backstage.shared.providers);
	      }),
	      table: make$2(function (spec, backstage) {
	        return renderTable(spec, backstage.shared.providers);
	      }),
	      panel: make$2(function (spec, backstage) {
	        return renderPanel(spec, backstage);
	      })
	    };
	    var noFormParts = {
	      field: function (_name, spec) {
	        return spec;
	      }
	    };
	    var interpretInForm = function (parts, spec, oldBackstage) {
	      var newBackstage = deepMerge(oldBackstage, {
	        shared: {
	          interpreter: function (childSpec) {
	            return interpretParts(parts, childSpec, newBackstage);
	          }
	        }
	      });
	      return interpretParts(parts, spec, newBackstage);
	    };
	    var interpretParts = function (parts, spec, backstage) {
	      return get$e(factories, spec.type).fold(function () {
	        console.error('Unknown factory type "' + spec.type + '", defaulting to container: ', spec);
	        return spec;
	      }, function (factory) {
	        return factory(parts, spec, backstage);
	      });
	    };
	    var interpretWithoutForm = function (spec, backstage) {
	      var parts = noFormParts;
	      return interpretParts(parts, spec, backstage);
	    };
	
	    var bubbleAlignments$2 = {
	      valignCentre: [],
	      alignCentre: [],
	      alignLeft: [],
	      alignRight: [],
	      right: [],
	      left: [],
	      bottom: [],
	      top: []
	    };
	    var getInlineDialogAnchor = function (contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor) {
	      var bubbleSize = 12;
	      var overrides = { maxHeightFunction: expandable$1() };
	      var editableAreaAnchor = function () {
	        return {
	          type: 'node',
	          root: getContentContainer(contentAreaElement()),
	          node: Optional.from(contentAreaElement()),
	          bubble: nu$5(bubbleSize, bubbleSize, bubbleAlignments$2),
	          layouts: {
	            onRtl: function () {
	              return [northeast];
	            },
	            onLtr: function () {
	              return [northwest];
	            }
	          },
	          overrides: overrides
	        };
	      };
	      var standardAnchor = function () {
	        return {
	          type: 'hotspot',
	          hotspot: lazyAnchorbar(),
	          bubble: nu$5(-bubbleSize, bubbleSize, bubbleAlignments$2),
	          layouts: {
	            onRtl: function () {
	              return [southeast$2];
	            },
	            onLtr: function () {
	              return [southwest$2];
	            }
	          },
	          overrides: overrides
	        };
	      };
	      return function () {
	        return lazyUseEditableAreaAnchor() ? editableAreaAnchor() : standardAnchor();
	      };
	    };
	    var getBannerAnchor = function (contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor) {
	      var editableAreaAnchor = function () {
	        return {
	          type: 'node',
	          root: getContentContainer(contentAreaElement()),
	          node: Optional.from(contentAreaElement()),
	          layouts: {
	            onRtl: function () {
	              return [north];
	            },
	            onLtr: function () {
	              return [north];
	            }
	          }
	        };
	      };
	      var standardAnchor = function () {
	        return {
	          type: 'hotspot',
	          hotspot: lazyAnchorbar(),
	          layouts: {
	            onRtl: function () {
	              return [south$2];
	            },
	            onLtr: function () {
	              return [south$2];
	            }
	          }
	        };
	      };
	      return function () {
	        return lazyUseEditableAreaAnchor() ? editableAreaAnchor() : standardAnchor();
	      };
	    };
	    var getCursorAnchor = function (editor, bodyElement) {
	      return function () {
	        return {
	          type: 'selection',
	          root: bodyElement(),
	          getSelection: function () {
	            var rng = editor.selection.getRng();
	            return Optional.some(SimSelection.range(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset));
	          }
	        };
	      };
	    };
	    var getNodeAnchor$1 = function (bodyElement) {
	      return function (element) {
	        return {
	          type: 'node',
	          root: bodyElement(),
	          node: element
	        };
	      };
	    };
	    var getAnchors = function (editor, lazyAnchorbar, isToolbarTop) {
	      var useFixedToolbarContainer = useFixedContainer(editor);
	      var bodyElement = function () {
	        return SugarElement.fromDom(editor.getBody());
	      };
	      var contentAreaElement = function () {
	        return SugarElement.fromDom(editor.getContentAreaContainer());
	      };
	      var lazyUseEditableAreaAnchor = function () {
	        return useFixedToolbarContainer || !isToolbarTop();
	      };
	      return {
	        inlineDialog: getInlineDialogAnchor(contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor),
	        banner: getBannerAnchor(contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor),
	        cursor: getCursorAnchor(editor, bodyElement),
	        node: getNodeAnchor$1(bodyElement)
	      };
	    };
	
	    var colorPicker = function (editor) {
	      return function (callback, value) {
	        var dialog = colorPickerDialog(editor);
	        dialog(callback, value);
	      };
	    };
	    var hasCustomColors = function (editor) {
	      return function () {
	        return hasCustomColors$1(editor);
	      };
	    };
	    var getColors = function (editor) {
	      return function () {
	        return getColors$2(editor);
	      };
	    };
	    var getColorCols = function (editor) {
	      return function () {
	        return getColorCols$1(editor);
	      };
	    };
	    var ColorInputBackstage = function (editor) {
	      return {
	        colorPicker: colorPicker(editor),
	        hasCustomColors: hasCustomColors(editor),
	        getColors: getColors(editor),
	        getColorCols: getColorCols(editor)
	      };
	    };
	
	    var isDraggableModal = function (editor) {
	      return function () {
	        return isDraggableModal$1(editor);
	      };
	    };
	    var DialogBackstage = function (editor) {
	      return { isDraggableModal: isDraggableModal(editor) };
	    };
	
	    var HeaderBackstage = function (editor) {
	      var mode = Cell(isToolbarLocationBottom(editor) ? 'bottom' : 'top');
	      return {
	        isPositionedAtTop: function () {
	          return mode.get() === 'top';
	        },
	        getDockingMode: mode.get,
	        setDockingMode: mode.set
	      };
	    };
	
	    var defaultStyleFormats = [
	      {
	        title: 'Headings',
	        items: [
	          {
	            title: 'Heading 1',
	            format: 'h1'
	          },
	          {
	            title: 'Heading 2',
	            format: 'h2'
	          },
	          {
	            title: 'Heading 3',
	            format: 'h3'
	          },
	          {
	            title: 'Heading 4',
	            format: 'h4'
	          },
	          {
	            title: 'Heading 5',
	            format: 'h5'
	          },
	          {
	            title: 'Heading 6',
	            format: 'h6'
	          }
	        ]
	      },
	      {
	        title: 'Inline',
	        items: [
	          {
	            title: 'Bold',
	            format: 'bold'
	          },
	          {
	            title: 'Italic',
	            format: 'italic'
	          },
	          {
	            title: 'Underline',
	            format: 'underline'
	          },
	          {
	            title: 'Strikethrough',
	            format: 'strikethrough'
	          },
	          {
	            title: 'Superscript',
	            format: 'superscript'
	          },
	          {
	            title: 'Subscript',
	            format: 'subscript'
	          },
	          {
	            title: 'Code',
	            format: 'code'
	          }
	        ]
	      },
	      {
	        title: 'Blocks',
	        items: [
	          {
	            title: 'Paragraph',
	            format: 'p'
	          },
	          {
	            title: 'Blockquote',
	            format: 'blockquote'
	          },
	          {
	            title: 'Div',
	            format: 'div'
	          },
	          {
	            title: 'Pre',
	            format: 'pre'
	          }
	        ]
	      },
	      {
	        title: 'Align',
	        items: [
	          {
	            title: 'Left',
	            format: 'alignleft'
	          },
	          {
	            title: 'Center',
	            format: 'aligncenter'
	          },
	          {
	            title: 'Right',
	            format: 'alignright'
	          },
	          {
	            title: 'Justify',
	            format: 'alignjustify'
	          }
	        ]
	      }
	    ];
	    var isNestedFormat = function (format) {
	      return has$2(format, 'items');
	    };
	    var isBlockFormat = function (format) {
	      return has$2(format, 'block');
	    };
	    var isInlineFormat = function (format) {
	      return has$2(format, 'inline');
	    };
	    var isSelectorFormat = function (format) {
	      return has$2(format, 'selector');
	    };
	    var mapFormats = function (userFormats) {
	      return foldl(userFormats, function (acc, fmt) {
	        if (isNestedFormat(fmt)) {
	          var result = mapFormats(fmt.items);
	          return {
	            customFormats: acc.customFormats.concat(result.customFormats),
	            formats: acc.formats.concat([{
	                title: fmt.title,
	                items: result.formats
	              }])
	          };
	        } else if (isInlineFormat(fmt) || isBlockFormat(fmt) || isSelectorFormat(fmt)) {
	          var formatName = isString(fmt.name) ? fmt.name : fmt.title.toLowerCase();
	          var formatNameWithPrefix = 'custom-' + formatName;
	          return {
	            customFormats: acc.customFormats.concat([{
	                name: formatNameWithPrefix,
	                format: fmt
	              }]),
	            formats: acc.formats.concat([{
	                title: fmt.title,
	                format: formatNameWithPrefix,
	                icon: fmt.icon
	              }])
	          };
	        } else {
	          return __assign(__assign({}, acc), { formats: acc.formats.concat(fmt) });
	        }
	      }, {
	        customFormats: [],
	        formats: []
	      });
	    };
	    var registerCustomFormats = function (editor, userFormats) {
	      var result = mapFormats(userFormats);
	      var registerFormats = function (customFormats) {
	        each$1(customFormats, function (fmt) {
	          if (!editor.formatter.has(fmt.name)) {
	            editor.formatter.register(fmt.name, fmt.format);
	          }
	        });
	      };
	      if (editor.formatter) {
	        registerFormats(result.customFormats);
	      } else {
	        editor.on('init', function () {
	          registerFormats(result.customFormats);
	        });
	      }
	      return result.formats;
	    };
	    var getStyleFormats = function (editor) {
	      return getUserStyleFormats(editor).map(function (userFormats) {
	        var registeredUserFormats = registerCustomFormats(editor, userFormats);
	        return isMergeStyleFormats(editor) ? defaultStyleFormats.concat(registeredUserFormats) : registeredUserFormats;
	      }).getOr(defaultStyleFormats);
	    };
	
	    var processBasic = function (item, isSelectedFor, getPreviewFor) {
	      var formatterSpec = {
	        type: 'formatter',
	        isSelected: isSelectedFor(item.format),
	        getStylePreview: getPreviewFor(item.format)
	      };
	      return deepMerge(item, formatterSpec);
	    };
	    var register$8 = function (editor, formats, isSelectedFor, getPreviewFor) {
	      var enrichSupported = function (item) {
	        return processBasic(item, isSelectedFor, getPreviewFor);
	      };
	      var enrichMenu = function (item) {
	        var submenuSpec = { type: 'submenu' };
	        return deepMerge(item, submenuSpec);
	      };
	      var enrichCustom = function (item) {
	        var formatName = isString(item.name) ? item.name : generate$6(item.title);
	        var formatNameWithPrefix = 'custom-' + formatName;
	        var customSpec = {
	          type: 'formatter',
	          format: formatNameWithPrefix,
	          isSelected: isSelectedFor(formatNameWithPrefix),
	          getStylePreview: getPreviewFor(formatNameWithPrefix)
	        };
	        var newItem = deepMerge(item, customSpec);
	        editor.formatter.register(formatName, newItem);
	        return newItem;
	      };
	      var doEnrich = function (items) {
	        return map$2(items, function (item) {
	          var keys$1 = keys(item);
	          if (hasNonNullableKey(item, 'items')) {
	            var newItems = doEnrich(item.items);
	            return deepMerge(enrichMenu(item), { getStyleItems: constant$1(newItems) });
	          } else if (hasNonNullableKey(item, 'format')) {
	            return enrichSupported(item);
	          } else if (keys$1.length === 1 && contains$2(keys$1, 'title')) {
	            return deepMerge(item, { type: 'separator' });
	          } else {
	            return enrichCustom(item);
	          }
	        });
	      };
	      return doEnrich(formats);
	    };
	
	    var init$8 = function (editor) {
	      var isSelectedFor = function (format) {
	        return function () {
	          return editor.formatter.match(format);
	        };
	      };
	      var getPreviewFor = function (format) {
	        return function () {
	          var fmt = editor.formatter.get(format);
	          return fmt !== undefined ? Optional.some({
	            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
	            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
	          }) : Optional.none();
	        };
	      };
	      var flatten = function (fmt) {
	        var subs = fmt.items;
	        return subs !== undefined && subs.length > 0 ? bind$3(subs, flatten) : [fmt.format];
	      };
	      var settingsFormats = Cell([]);
	      var settingsFlattenedFormats = Cell([]);
	      var eventsFormats = Cell([]);
	      var eventsFlattenedFormats = Cell([]);
	      var replaceSettings = Cell(false);
	      editor.on('PreInit', function (_e) {
	        var formats = getStyleFormats(editor);
	        var enriched = register$8(editor, formats, isSelectedFor, getPreviewFor);
	        settingsFormats.set(enriched);
	        settingsFlattenedFormats.set(bind$3(enriched, flatten));
	      });
	      editor.on('addStyleModifications', function (e) {
	        var modifications = register$8(editor, e.items, isSelectedFor, getPreviewFor);
	        eventsFormats.set(modifications);
	        replaceSettings.set(e.replace);
	        eventsFlattenedFormats.set(bind$3(modifications, flatten));
	      });
	      var getData = function () {
	        var fromSettings = replaceSettings.get() ? [] : settingsFormats.get();
	        var fromEvents = eventsFormats.get();
	        return fromSettings.concat(fromEvents);
	      };
	      var getFlattenedKeys = function () {
	        var fromSettings = replaceSettings.get() ? [] : settingsFlattenedFormats.get();
	        var fromEvents = eventsFlattenedFormats.get();
	        return fromSettings.concat(fromEvents);
	      };
	      return {
	        getData: getData,
	        getFlattenedKeys: getFlattenedKeys
	      };
	    };
	
	    var isElement = function (node) {
	      return isNonNullable(node) && node.nodeType === 1;
	    };
	    var trim = global$5.trim;
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (isElement(node)) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var isContentEditableTrue = hasContentEditableState('true');
	    var isContentEditableFalse = hasContentEditableState('false');
	    var create$1 = function (type, title, url, level, attach) {
	      return {
	        type: type,
	        title: title,
	        url: url,
	        level: level,
	        attach: attach
	      };
	    };
	    var isChildOfContentEditableTrue = function (node) {
	      while (node = node.parentNode) {
	        var value = node.contentEditable;
	        if (value && value !== 'inherit') {
	          return isContentEditableTrue(node);
	        }
	      }
	      return false;
	    };
	    var select = function (selector, root) {
	      return map$2(descendants(SugarElement.fromDom(root), selector), function (element) {
	        return element.dom;
	      });
	    };
	    var getElementText = function (elm) {
	      return elm.innerText || elm.textContent;
	    };
	    var getOrGenerateId = function (elm) {
	      return elm.id ? elm.id : generate$6('h');
	    };
	    var isAnchor = function (elm) {
	      return elm && elm.nodeName === 'A' && (elm.id || elm.name) !== undefined;
	    };
	    var isValidAnchor = function (elm) {
	      return isAnchor(elm) && isEditable(elm);
	    };
	    var isHeader = function (elm) {
	      return elm && /^(H[1-6])$/.test(elm.nodeName);
	    };
	    var isEditable = function (elm) {
	      return isChildOfContentEditableTrue(elm) && !isContentEditableFalse(elm);
	    };
	    var isValidHeader = function (elm) {
	      return isHeader(elm) && isEditable(elm);
	    };
	    var getLevel = function (elm) {
	      return isHeader(elm) ? parseInt(elm.nodeName.substr(1), 10) : 0;
	    };
	    var headerTarget = function (elm) {
	      var headerId = getOrGenerateId(elm);
	      var attach = function () {
	        elm.id = headerId;
	      };
	      return create$1('header', getElementText(elm), '#' + headerId, getLevel(elm), attach);
	    };
	    var anchorTarget = function (elm) {
	      var anchorId = elm.id || elm.name;
	      var anchorText = getElementText(elm);
	      return create$1('anchor', anchorText ? anchorText : '#' + anchorId, '#' + anchorId, 0, noop);
	    };
	    var getHeaderTargets = function (elms) {
	      return map$2(filter$2(elms, isValidHeader), headerTarget);
	    };
	    var getAnchorTargets = function (elms) {
	      return map$2(filter$2(elms, isValidAnchor), anchorTarget);
	    };
	    var getTargetElements = function (elm) {
	      var elms = select('h1,h2,h3,h4,h5,h6,a:not([href])', elm);
	      return elms;
	    };
	    var hasTitle = function (target) {
	      return trim(target.title).length > 0;
	    };
	    var find = function (elm) {
	      var elms = getTargetElements(elm);
	      return filter$2(getHeaderTargets(elms).concat(getAnchorTargets(elms)), hasTitle);
	    };
	    var LinkTargets = { find: find };
	
	    var STORAGE_KEY = 'tinymce-url-history';
	    var HISTORY_LENGTH = 5;
	    var isHttpUrl = function (url) {
	      return isString(url) && /^https?/.test(url);
	    };
	    var isArrayOfUrl = function (a) {
	      return isArray(a) && a.length <= HISTORY_LENGTH && forall(a, isHttpUrl);
	    };
	    var isRecordOfUrlArray = function (r) {
	      return isObject(r) && find$4(r, function (value) {
	        return !isArrayOfUrl(value);
	      }).isNone();
	    };
	    var getAllHistory = function () {
	      var unparsedHistory = global$8.getItem(STORAGE_KEY);
	      if (unparsedHistory === null) {
	        return {};
	      }
	      var history;
	      try {
	        history = JSON.parse(unparsedHistory);
	      } catch (e) {
	        if (e instanceof SyntaxError) {
	          console.log('Local storage ' + STORAGE_KEY + ' was not valid JSON', e);
	          return {};
	        }
	        throw e;
	      }
	      if (!isRecordOfUrlArray(history)) {
	        console.log('Local storage ' + STORAGE_KEY + ' was not valid format', history);
	        return {};
	      }
	      return history;
	    };
	    var setAllHistory = function (history) {
	      if (!isRecordOfUrlArray(history)) {
	        throw new Error('Bad format for history:\n' + JSON.stringify(history));
	      }
	      global$8.setItem(STORAGE_KEY, JSON.stringify(history));
	    };
	    var getHistory = function (fileType) {
	      var history = getAllHistory();
	      return get$e(history, fileType).getOr([]);
	    };
	    var addToHistory = function (url, fileType) {
	      if (!isHttpUrl(url)) {
	        return;
	      }
	      var history = getAllHistory();
	      var items = get$e(history, fileType).getOr([]);
	      var itemsWithoutUrl = filter$2(items, function (item) {
	        return item !== url;
	      });
	      history[fileType] = [url].concat(itemsWithoutUrl).slice(0, HISTORY_LENGTH);
	      setAllHistory(history);
	    };
	
	    var isTruthy = function (value) {
	      return !!value;
	    };
	    var makeMap = function (value) {
	      return map$1(global$5.makeMap(value, /[, ]/), isTruthy);
	    };
	    var getPicker = function (editor) {
	      return Optional.from(getFilePickerCallback(editor)).filter(isFunction);
	    };
	    var getPickerTypes = function (editor) {
	      var optFileTypes = Optional.some(getFilePickerTypes(editor)).filter(isTruthy);
	      var optLegacyTypes = Optional.some(getFileBrowserCallbackTypes(editor)).filter(isTruthy);
	      var optTypes = optFileTypes.or(optLegacyTypes).map(makeMap);
	      return getPicker(editor).fold(never, function (_picker) {
	        return optTypes.fold(always, function (types) {
	          return keys(types).length > 0 ? types : false;
	        });
	      });
	    };
	    var getPickerSetting = function (editor, filetype) {
	      var pickerTypes = getPickerTypes(editor);
	      if (isBoolean(pickerTypes)) {
	        return pickerTypes ? getPicker(editor) : Optional.none();
	      } else {
	        return pickerTypes[filetype] ? getPicker(editor) : Optional.none();
	      }
	    };
	    var getUrlPicker = function (editor, filetype) {
	      return getPickerSetting(editor, filetype).map(function (picker) {
	        return function (entry) {
	          return Future.nu(function (completer) {
	            var handler = function (value, meta) {
	              if (!isString(value)) {
	                throw new Error('Expected value to be string');
	              }
	              if (meta !== undefined && !isObject(meta)) {
	                throw new Error('Expected meta to be a object');
	              }
	              var r = {
	                value: value,
	                meta: meta
	              };
	              completer(r);
	            };
	            var meta = __assign({
	              filetype: filetype,
	              fieldname: entry.fieldname
	            }, Optional.from(entry.meta).getOr({}));
	            picker.call(editor, handler, entry.value, meta);
	          });
	        };
	      });
	    };
	    var getTextSetting = function (value) {
	      return Optional.from(value).filter(isString).getOrUndefined();
	    };
	    var getLinkInformation = function (editor) {
	      if (noTypeaheadUrls(editor)) {
	        return Optional.none();
	      }
	      return Optional.some({
	        targets: LinkTargets.find(editor.getBody()),
	        anchorTop: getTextSetting(getAnchorTop(editor)),
	        anchorBottom: getTextSetting(getAnchorBottom(editor))
	      });
	    };
	    var getValidationHandler = function (editor) {
	      return Optional.from(getFilePickerValidatorHandler(editor));
	    };
	    var UrlInputBackstage = function (editor) {
	      return {
	        getHistory: getHistory,
	        addToHistory: addToHistory,
	        getLinkInformation: function () {
	          return getLinkInformation(editor);
	        },
	        getValidationHandler: function () {
	          return getValidationHandler(editor);
	        },
	        getUrlPicker: function (filetype) {
	          return getUrlPicker(editor, filetype);
	        }
	      };
	    };
	
	    var init$7 = function (sink, editor, lazyAnchorbar) {
	      var contextMenuState = Cell(false);
	      var toolbar = HeaderBackstage(editor);
	      var backstage = {
	        shared: {
	          providers: {
	            icons: function () {
	              return editor.ui.registry.getAll().icons;
	            },
	            menuItems: function () {
	              return editor.ui.registry.getAll().menuItems;
	            },
	            translate: global$e.translate,
	            isDisabled: function () {
	              return editor.mode.isReadOnly() || editor.ui.isDisabled();
	            },
	            getSetting: editor.getParam.bind(editor)
	          },
	          interpreter: function (s) {
	            return interpretWithoutForm(s, backstage);
	          },
	          anchors: getAnchors(editor, lazyAnchorbar, toolbar.isPositionedAtTop),
	          header: toolbar,
	          getSink: function () {
	            return Result.value(sink);
	          }
	        },
	        urlinput: UrlInputBackstage(editor),
	        styleselect: init$8(editor),
	        colorinput: ColorInputBackstage(editor),
	        dialog: DialogBackstage(editor),
	        isContextMenuOpen: function () {
	          return contextMenuState.get();
	        },
	        setContextMenuState: function (state) {
	          return contextMenuState.set(state);
	        }
	      };
	      return backstage;
	    };
	
	    var setup$b = function (editor, mothership, uiMothership) {
	      var broadcastEvent = function (name, evt) {
	        each$1([
	          mothership,
	          uiMothership
	        ], function (ship) {
	          ship.broadcastEvent(name, evt);
	        });
	      };
	      var broadcastOn = function (channel, message) {
	        each$1([
	          mothership,
	          uiMothership
	        ], function (ship) {
	          ship.broadcastOn([channel], message);
	        });
	      };
	      var fireDismissPopups = function (evt) {
	        return broadcastOn(dismissPopups(), { target: evt.target });
	      };
	      var doc = getDocument();
	      var onTouchstart = bind(doc, 'touchstart', fireDismissPopups);
	      var onTouchmove = bind(doc, 'touchmove', function (evt) {
	        return broadcastEvent(documentTouchmove(), evt);
	      });
	      var onTouchend = bind(doc, 'touchend', function (evt) {
	        return broadcastEvent(documentTouchend(), evt);
	      });
	      var onMousedown = bind(doc, 'mousedown', fireDismissPopups);
	      var onMouseup = bind(doc, 'mouseup', function (evt) {
	        if (evt.raw.button === 0) {
	          broadcastOn(mouseReleased(), { target: evt.target });
	        }
	      });
	      var onContentClick = function (raw) {
	        return broadcastOn(dismissPopups(), { target: SugarElement.fromDom(raw.target) });
	      };
	      var onContentMouseup = function (raw) {
	        if (raw.button === 0) {
	          broadcastOn(mouseReleased(), { target: SugarElement.fromDom(raw.target) });
	        }
	      };
	      var onContentMousedown = function () {
	        each$1(editor.editorManager.get(), function (loopEditor) {
	          if (editor !== loopEditor) {
	            loopEditor.fire('DismissPopups', { relatedTarget: editor });
	          }
	        });
	      };
	      var onWindowScroll = function (evt) {
	        return broadcastEvent(windowScroll(), fromRawEvent(evt));
	      };
	      var onWindowResize = function (evt) {
	        broadcastOn(repositionPopups(), {});
	        broadcastEvent(windowResize(), fromRawEvent(evt));
	      };
	      var onEditorResize = function () {
	        return broadcastOn(repositionPopups(), {});
	      };
	      var onEditorProgress = function (evt) {
	        if (evt.state) {
	          broadcastOn(dismissPopups(), { target: SugarElement.fromDom(editor.getContainer()) });
	        }
	      };
	      var onDismissPopups = function (event) {
	        broadcastOn(dismissPopups(), { target: SugarElement.fromDom(event.relatedTarget.getContainer()) });
	      };
	      editor.on('PostRender', function () {
	        editor.on('click', onContentClick);
	        editor.on('tap', onContentClick);
	        editor.on('mouseup', onContentMouseup);
	        editor.on('mousedown', onContentMousedown);
	        editor.on('ScrollWindow', onWindowScroll);
	        editor.on('ResizeWindow', onWindowResize);
	        editor.on('ResizeEditor', onEditorResize);
	        editor.on('AfterProgressState', onEditorProgress);
	        editor.on('DismissPopups', onDismissPopups);
	      });
	      editor.on('remove', function () {
	        editor.off('click', onContentClick);
	        editor.off('tap', onContentClick);
	        editor.off('mouseup', onContentMouseup);
	        editor.off('mousedown', onContentMousedown);
	        editor.off('ScrollWindow', onWindowScroll);
	        editor.off('ResizeWindow', onWindowResize);
	        editor.off('ResizeEditor', onEditorResize);
	        editor.off('AfterProgressState', onEditorProgress);
	        editor.off('DismissPopups', onDismissPopups);
	        onMousedown.unbind();
	        onTouchstart.unbind();
	        onTouchmove.unbind();
	        onTouchend.unbind();
	        onMouseup.unbind();
	      });
	      editor.on('detach', function () {
	        detachSystem(mothership);
	        detachSystem(uiMothership);
	        mothership.destroy();
	        uiMothership.destroy();
	      });
	    };
	
	    var parts$a = AlloyParts;
	    var partType = PartType;
	
	    var schema$f = constant$1([
	      defaulted('shell', false),
	      required$1('makeItem'),
	      defaulted('setupItem', noop),
	      SketchBehaviours.field('listBehaviours', [Replacing])
	    ]);
	    var customListDetail = function () {
	      return { behaviours: derive$1([Replacing.config({})]) };
	    };
	    var itemsPart = optional({
	      name: 'items',
	      overrides: customListDetail
	    });
	    var parts$9 = constant$1([itemsPart]);
	    var name = constant$1('CustomList');
	
	    var factory$d = function (detail, components, _spec, _external) {
	      var setItems = function (list, items) {
	        getListContainer(list).fold(function () {
	          console.error('Custom List was defined to not be a shell, but no item container was specified in components');
	          throw new Error('Custom List was defined to not be a shell, but no item container was specified in components');
	        }, function (container) {
	          var itemComps = Replacing.contents(container);
	          var numListsRequired = items.length;
	          var numListsToAdd = numListsRequired - itemComps.length;
	          var itemsToAdd = numListsToAdd > 0 ? range$2(numListsToAdd, function () {
	            return detail.makeItem();
	          }) : [];
	          var itemsToRemove = itemComps.slice(numListsRequired);
	          each$1(itemsToRemove, function (item) {
	            return Replacing.remove(container, item);
	          });
	          each$1(itemsToAdd, function (item) {
	            return Replacing.append(container, item);
	          });
	          var builtLists = Replacing.contents(container);
	          each$1(builtLists, function (item, i) {
	            detail.setupItem(list, item, items[i], i);
	          });
	        });
	      };
	      var extra = detail.shell ? {
	        behaviours: [Replacing.config({})],
	        components: []
	      } : {
	        behaviours: [],
	        components: components
	      };
	      var getListContainer = function (component) {
	        return detail.shell ? Optional.some(component) : getPart(component, detail, 'items');
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: extra.components,
	        behaviours: augment(detail.listBehaviours, extra.behaviours),
	        apis: { setItems: setItems }
	      };
	    };
	    var CustomList = composite({
	      name: name(),
	      configFields: schema$f(),
	      partFields: parts$9(),
	      factory: factory$d,
	      apis: {
	        setItems: function (apis, list, items) {
	          apis.setItems(list, items);
	        }
	      }
	    });
	
	    var schema$e = constant$1([
	      required$1('dom'),
	      defaulted('shell', true),
	      field('toolbarBehaviours', [Replacing])
	    ]);
	    var enhanceGroups = function () {
	      return { behaviours: derive$1([Replacing.config({})]) };
	    };
	    var parts$8 = constant$1([optional({
	        name: 'groups',
	        overrides: enhanceGroups
	      })]);
	
	    var factory$c = function (detail, components, _spec, _externals) {
	      var setGroups = function (toolbar, groups) {
	        getGroupContainer(toolbar).fold(function () {
	          console.error('Toolbar was defined to not be a shell, but no groups container was specified in components');
	          throw new Error('Toolbar was defined to not be a shell, but no groups container was specified in components');
	        }, function (container) {
	          Replacing.set(container, groups);
	        });
	      };
	      var getGroupContainer = function (component) {
	        return detail.shell ? Optional.some(component) : getPart(component, detail, 'groups');
	      };
	      var extra = detail.shell ? {
	        behaviours: [Replacing.config({})],
	        components: []
	      } : {
	        behaviours: [],
	        components: components
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: extra.components,
	        behaviours: augment(detail.toolbarBehaviours, extra.behaviours),
	        apis: { setGroups: setGroups },
	        domModification: { attributes: { role: 'group' } }
	      };
	    };
	    var Toolbar = composite({
	      name: 'Toolbar',
	      configFields: schema$e(),
	      partFields: parts$8(),
	      factory: factory$c,
	      apis: {
	        setGroups: function (apis, toolbar, groups) {
	          apis.setGroups(toolbar, groups);
	        }
	      }
	    });
	
	    var setup$a = noop;
	    var isDocked$2 = never;
	    var getBehaviours$1 = constant$1([]);
	
	    var StaticHeader = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setup: setup$a,
	        isDocked: isDocked$2,
	        getBehaviours: getBehaviours$1
	    });
	
	    var getOffsetParent = function (element) {
	      var isFixed = is$1(getRaw(element, 'position'), 'fixed');
	      var offsetParent$1 = isFixed ? Optional.none() : offsetParent(element);
	      return offsetParent$1.orThunk(function () {
	        var marker = SugarElement.fromTag('span');
	        return parent(element).bind(function (parent) {
	          append$2(parent, marker);
	          var offsetParent$1 = offsetParent(marker);
	          remove$5(marker);
	          return offsetParent$1;
	        });
	      });
	    };
	    var getOrigin = function (element) {
	      return getOffsetParent(element).map(absolute$3).getOrThunk(function () {
	        return SugarPosition(0, 0);
	      });
	    };
	
	    var morphAdt = Adt.generate([
	      { static: [] },
	      { absolute: ['positionCss'] },
	      { fixed: ['positionCss'] }
	    ]);
	    var appear = function (component, contextualInfo) {
	      var elem = component.element;
	      add$2(elem, contextualInfo.transitionClass);
	      remove$2(elem, contextualInfo.fadeOutClass);
	      add$2(elem, contextualInfo.fadeInClass);
	      contextualInfo.onShow(component);
	    };
	    var disappear = function (component, contextualInfo) {
	      var elem = component.element;
	      add$2(elem, contextualInfo.transitionClass);
	      remove$2(elem, contextualInfo.fadeInClass);
	      add$2(elem, contextualInfo.fadeOutClass);
	      contextualInfo.onHide(component);
	    };
	    var isPartiallyVisible = function (box, viewport) {
	      return box.y < viewport.bottom && box.bottom > viewport.y;
	    };
	    var isTopCompletelyVisible = function (box, viewport) {
	      return box.y >= viewport.y;
	    };
	    var isBottomCompletelyVisible = function (box, viewport) {
	      return box.bottom <= viewport.bottom;
	    };
	    var isVisibleForModes = function (modes, box, viewport) {
	      return forall(modes, function (mode) {
	        switch (mode) {
	        case 'bottom':
	          return isBottomCompletelyVisible(box, viewport);
	        case 'top':
	          return isTopCompletelyVisible(box, viewport);
	        }
	      });
	    };
	    var getPrior = function (elem, state) {
	      return state.getInitialPos().map(function (pos) {
	        return bounds(pos.bounds.x, pos.bounds.y, get$a(elem), get$b(elem));
	      });
	    };
	    var storePrior = function (elem, box, state) {
	      state.setInitialPos({
	        style: getAllRaw(elem),
	        position: get$c(elem, 'position') || 'static',
	        bounds: box
	      });
	    };
	    var revertToOriginal = function (elem, box, state) {
	      return state.getInitialPos().bind(function (position) {
	        state.clearInitialPos();
	        switch (position.position) {
	        case 'static':
	          return Optional.some(morphAdt.static());
	        case 'absolute':
	          var offsetBox_1 = getOffsetParent(elem).map(box$1).getOrThunk(function () {
	            return box$1(body());
	          });
	          return Optional.some(morphAdt.absolute(NuPositionCss('absolute', get$e(position.style, 'left').map(function (_left) {
	            return box.x - offsetBox_1.x;
	          }), get$e(position.style, 'top').map(function (_top) {
	            return box.y - offsetBox_1.y;
	          }), get$e(position.style, 'right').map(function (_right) {
	            return offsetBox_1.right - box.right;
	          }), get$e(position.style, 'bottom').map(function (_bottom) {
	            return offsetBox_1.bottom - box.bottom;
	          }))));
	        default:
	          return Optional.none();
	        }
	      });
	    };
	    var morphToOriginal = function (elem, viewport, state) {
	      return getPrior(elem, state).filter(function (box) {
	        return isVisibleForModes(state.getModes(), box, viewport);
	      }).bind(function (box) {
	        return revertToOriginal(elem, box, state);
	      });
	    };
	    var morphToFixed = function (elem, viewport, state) {
	      var box = box$1(elem);
	      if (!isVisibleForModes(state.getModes(), box, viewport)) {
	        storePrior(elem, box, state);
	        var winBox = win();
	        var left = box.x - winBox.x;
	        var top_1 = viewport.y - winBox.y;
	        var bottom = winBox.bottom - viewport.bottom;
	        var isTop = box.y <= viewport.y;
	        return Optional.some(morphAdt.fixed(NuPositionCss('fixed', Optional.some(left), isTop ? Optional.some(top_1) : Optional.none(), Optional.none(), !isTop ? Optional.some(bottom) : Optional.none())));
	      } else {
	        return Optional.none();
	      }
	    };
	    var getMorph = function (component, viewport, state) {
	      var elem = component.element;
	      var isDocked = is$1(getRaw(elem, 'position'), 'fixed');
	      return isDocked ? morphToOriginal(elem, viewport, state) : morphToFixed(elem, viewport, state);
	    };
	    var getMorphToOriginal = function (component, state) {
	      var elem = component.element;
	      return getPrior(elem, state).bind(function (box) {
	        return revertToOriginal(elem, box, state);
	      });
	    };
	
	    var morphToStatic = function (component, config, state) {
	      state.setDocked(false);
	      each$1([
	        'left',
	        'right',
	        'top',
	        'bottom',
	        'position'
	      ], function (prop) {
	        return remove$6(component.element, prop);
	      });
	      config.onUndocked(component);
	    };
	    var morphToCoord = function (component, config, state, position) {
	      var isDocked = position.position === 'fixed';
	      state.setDocked(isDocked);
	      applyPositionCss(component.element, position);
	      var method = isDocked ? config.onDocked : config.onUndocked;
	      method(component);
	    };
	    var updateVisibility = function (component, config, state, viewport, morphToDocked) {
	      if (morphToDocked === void 0) {
	        morphToDocked = false;
	      }
	      config.contextual.each(function (contextInfo) {
	        contextInfo.lazyContext(component).each(function (box) {
	          var isVisible = isPartiallyVisible(box, viewport);
	          if (isVisible !== state.isVisible()) {
	            state.setVisible(isVisible);
	            if (morphToDocked && !isVisible) {
	              add$1(component.element, [contextInfo.fadeOutClass]);
	              contextInfo.onHide(component);
	            } else {
	              var method = isVisible ? appear : disappear;
	              method(component, contextInfo);
	            }
	          }
	        });
	      });
	    };
	    var refreshInternal = function (component, config, state) {
	      var viewport = config.lazyViewport(component);
	      var isDocked = state.isDocked();
	      if (isDocked) {
	        updateVisibility(component, config, state, viewport);
	      }
	      getMorph(component, viewport, state).each(function (morph) {
	        morph.fold(function () {
	          return morphToStatic(component, config, state);
	        }, function (position) {
	          return morphToCoord(component, config, state, position);
	        }, function (position) {
	          updateVisibility(component, config, state, viewport, true);
	          morphToCoord(component, config, state, position);
	        });
	      });
	    };
	    var resetInternal = function (component, config, state) {
	      var elem = component.element;
	      state.setDocked(false);
	      getMorphToOriginal(component, state).each(function (morph) {
	        morph.fold(function () {
	          return morphToStatic(component, config, state);
	        }, function (position) {
	          return morphToCoord(component, config, state, position);
	        }, noop);
	      });
	      state.setVisible(true);
	      config.contextual.each(function (contextInfo) {
	        remove$1(elem, [
	          contextInfo.fadeInClass,
	          contextInfo.fadeOutClass,
	          contextInfo.transitionClass
	        ]);
	        contextInfo.onShow(component);
	      });
	      refresh$4(component, config, state);
	    };
	    var refresh$4 = function (component, config, state) {
	      if (component.getSystem().isConnected()) {
	        refreshInternal(component, config, state);
	      }
	    };
	    var reset = function (component, config, state) {
	      if (state.isDocked()) {
	        resetInternal(component, config, state);
	      }
	    };
	    var isDocked$1 = function (component, config, state) {
	      return state.isDocked();
	    };
	    var setModes = function (component, config, state, modes) {
	      return state.setModes(modes);
	    };
	    var getModes = function (component, config, state) {
	      return state.getModes();
	    };
	
	    var DockingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        refresh: refresh$4,
	        reset: reset,
	        isDocked: isDocked$1,
	        getModes: getModes,
	        setModes: setModes
	    });
	
	    var events$5 = function (dockInfo, dockState) {
	      return derive$2([
	        runOnSource(transitionend(), function (component, simulatedEvent) {
	          dockInfo.contextual.each(function (contextInfo) {
	            if (has(component.element, contextInfo.transitionClass)) {
	              remove$1(component.element, [
	                contextInfo.transitionClass,
	                contextInfo.fadeInClass
	              ]);
	              var notify = dockState.isVisible() ? contextInfo.onShown : contextInfo.onHidden;
	              notify(component);
	            }
	            simulatedEvent.stop();
	          });
	        }),
	        run$1(windowScroll(), function (component, _) {
	          refresh$4(component, dockInfo, dockState);
	        }),
	        run$1(windowResize(), function (component, _) {
	          reset(component, dockInfo, dockState);
	        })
	      ]);
	    };
	
	    var ActiveDocking = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$5
	    });
	
	    var DockingSchema = [
	      optionObjOf('contextual', [
	        requiredString('fadeInClass'),
	        requiredString('fadeOutClass'),
	        requiredString('transitionClass'),
	        requiredFunction('lazyContext'),
	        onHandler('onShow'),
	        onHandler('onShown'),
	        onHandler('onHide'),
	        onHandler('onHidden')
	      ]),
	      defaultedFunction('lazyViewport', win),
	      defaultedArrayOf('modes', [
	        'top',
	        'bottom'
	      ], string),
	      onHandler('onDocked'),
	      onHandler('onUndocked')
	    ];
	
	    var init$6 = function (spec) {
	      var docked = Cell(false);
	      var visible = Cell(true);
	      var initialBounds = value$1();
	      var modes = Cell(spec.modes);
	      var readState = function () {
	        return 'docked:  ' + docked.get() + ', visible: ' + visible.get() + ', modes: ' + modes.get().join(',');
	      };
	      return nu$8({
	        isDocked: docked.get,
	        setDocked: docked.set,
	        getInitialPos: initialBounds.get,
	        setInitialPos: initialBounds.set,
	        clearInitialPos: initialBounds.clear,
	        isVisible: visible.get,
	        setVisible: visible.set,
	        getModes: modes.get,
	        setModes: modes.set,
	        readState: readState
	      });
	    };
	
	    var DockingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$6
	    });
	
	    var Docking = create$8({
	      fields: DockingSchema,
	      name: 'docking',
	      active: ActiveDocking,
	      apis: DockingApis,
	      state: DockingState
	    });
	
	    var toolbarHeightChange = constant$1(generate$6('toolbar-height-change'));
	
	    var visibility = {
	      fadeInClass: 'tox-editor-dock-fadein',
	      fadeOutClass: 'tox-editor-dock-fadeout',
	      transitionClass: 'tox-editor-dock-transition'
	    };
	    var editorStickyOnClass = 'tox-tinymce--toolbar-sticky-on';
	    var editorStickyOffClass = 'tox-tinymce--toolbar-sticky-off';
	    var scrollFromBehindHeader = function (e, containerHeader) {
	      var doc = owner$4(containerHeader);
	      var viewHeight = doc.dom.defaultView.innerHeight;
	      var scrollPos = get$9(doc);
	      var markerElement = SugarElement.fromDom(e.elm);
	      var markerPos = absolute$2(markerElement);
	      var markerHeight = get$b(markerElement);
	      var markerTop = markerPos.y;
	      var markerBottom = markerTop + markerHeight;
	      var editorHeaderPos = absolute$3(containerHeader);
	      var editorHeaderHeight = get$b(containerHeader);
	      var editorHeaderTop = editorHeaderPos.top;
	      var editorHeaderBottom = editorHeaderTop + editorHeaderHeight;
	      var editorHeaderDockedAtTop = Math.abs(editorHeaderTop - scrollPos.top) < 2;
	      var editorHeaderDockedAtBottom = Math.abs(editorHeaderBottom - (scrollPos.top + viewHeight)) < 2;
	      if (editorHeaderDockedAtTop && markerTop < editorHeaderBottom) {
	        to(scrollPos.left, markerTop - editorHeaderHeight, doc);
	      } else if (editorHeaderDockedAtBottom && markerBottom > editorHeaderTop) {
	        var y = markerTop - viewHeight + markerHeight + editorHeaderHeight;
	        to(scrollPos.left, y, doc);
	      }
	    };
	    var isDockedMode = function (header, mode) {
	      return contains$2(Docking.getModes(header), mode);
	    };
	    var updateIframeContentFlow = function (header) {
	      var getOccupiedHeight = function (elm) {
	        return getOuter$2(elm) + (parseInt(get$c(elm, 'margin-top'), 10) || 0) + (parseInt(get$c(elm, 'margin-bottom'), 10) || 0);
	      };
	      var elm = header.element;
	      parent(elm).each(function (parentElem) {
	        var padding = 'padding-' + Docking.getModes(header)[0];
	        if (Docking.isDocked(header)) {
	          var parentWidth = get$a(parentElem);
	          set$7(elm, 'width', parentWidth + 'px');
	          set$7(parentElem, padding, getOccupiedHeight(elm) + 'px');
	        } else {
	          remove$6(elm, 'width');
	          remove$6(parentElem, padding);
	        }
	      });
	    };
	    var updateSinkVisibility = function (sinkElem, visible) {
	      if (visible) {
	        remove$2(sinkElem, visibility.fadeOutClass);
	        add$1(sinkElem, [
	          visibility.transitionClass,
	          visibility.fadeInClass
	        ]);
	      } else {
	        remove$2(sinkElem, visibility.fadeInClass);
	        add$1(sinkElem, [
	          visibility.fadeOutClass,
	          visibility.transitionClass
	        ]);
	      }
	    };
	    var updateEditorClasses = function (editor, docked) {
	      var editorContainer = SugarElement.fromDom(editor.getContainer());
	      if (docked) {
	        add$2(editorContainer, editorStickyOnClass);
	        remove$2(editorContainer, editorStickyOffClass);
	      } else {
	        add$2(editorContainer, editorStickyOffClass);
	        remove$2(editorContainer, editorStickyOnClass);
	      }
	    };
	    var restoreFocus = function (headerElem, focusedElem) {
	      var ownerDoc = owner$4(focusedElem);
	      active(ownerDoc).filter(function (activeElm) {
	        return !eq(focusedElem, activeElm);
	      }).filter(function (activeElm) {
	        return eq(activeElm, SugarElement.fromDom(ownerDoc.dom.body)) || contains(headerElem, activeElm);
	      }).each(function () {
	        return focus$3(focusedElem);
	      });
	    };
	    var findFocusedElem = function (rootElm, lazySink) {
	      return search(rootElm).orThunk(function () {
	        return lazySink().toOptional().bind(function (sink) {
	          return search(sink.element);
	        });
	      });
	    };
	    var setup$9 = function (editor, sharedBackstage, lazyHeader) {
	      if (!editor.inline) {
	        if (!sharedBackstage.header.isPositionedAtTop()) {
	          editor.on('ResizeEditor', function () {
	            lazyHeader().each(Docking.reset);
	          });
	        }
	        editor.on('ResizeWindow ResizeEditor', function () {
	          lazyHeader().each(updateIframeContentFlow);
	        });
	        editor.on('SkinLoaded', function () {
	          lazyHeader().each(function (comp) {
	            Docking.isDocked(comp) ? Docking.reset(comp) : Docking.refresh(comp);
	          });
	        });
	        editor.on('FullscreenStateChanged', function () {
	          lazyHeader().each(Docking.reset);
	        });
	      }
	      editor.on('AfterScrollIntoView', function (e) {
	        lazyHeader().each(function (header) {
	          Docking.refresh(header);
	          var headerElem = header.element;
	          if (isVisible(headerElem)) {
	            scrollFromBehindHeader(e, headerElem);
	          }
	        });
	      });
	      editor.on('PostRender', function () {
	        updateEditorClasses(editor, false);
	      });
	    };
	    var isDocked = function (lazyHeader) {
	      return lazyHeader().map(Docking.isDocked).getOr(false);
	    };
	    var getIframeBehaviours = function () {
	      var _a;
	      return [Receiving.config({ channels: (_a = {}, _a[toolbarHeightChange()] = { onReceive: updateIframeContentFlow }, _a) })];
	    };
	    var getBehaviours = function (editor, sharedBackstage) {
	      var focusedElm = value$1();
	      var lazySink = sharedBackstage.getSink;
	      var runOnSinkElement = function (f) {
	        lazySink().each(function (sink) {
	          return f(sink.element);
	        });
	      };
	      var onDockingSwitch = function (comp) {
	        if (!editor.inline) {
	          updateIframeContentFlow(comp);
	        }
	        updateEditorClasses(editor, Docking.isDocked(comp));
	        comp.getSystem().broadcastOn([repositionPopups()], {});
	        lazySink().each(function (sink) {
	          return sink.getSystem().broadcastOn([repositionPopups()], {});
	        });
	      };
	      var additionalBehaviours = editor.inline ? [] : getIframeBehaviours();
	      return __spreadArray([
	        Focusing.config({}),
	        Docking.config({
	          contextual: __assign({
	            lazyContext: function (comp) {
	              var headerHeight = getOuter$2(comp.element);
	              var container = editor.inline ? editor.getContentAreaContainer() : editor.getContainer();
	              var box = box$1(SugarElement.fromDom(container));
	              var boxHeight = box.height - headerHeight;
	              var topBound = box.y + (isDockedMode(comp, 'top') ? 0 : headerHeight);
	              return Optional.some(bounds(box.x, topBound, box.width, boxHeight));
	            },
	            onShow: function () {
	              runOnSinkElement(function (elem) {
	                return updateSinkVisibility(elem, true);
	              });
	            },
	            onShown: function (comp) {
	              runOnSinkElement(function (elem) {
	                return remove$1(elem, [
	                  visibility.transitionClass,
	                  visibility.fadeInClass
	                ]);
	              });
	              focusedElm.get().each(function (elem) {
	                restoreFocus(comp.element, elem);
	                focusedElm.clear();
	              });
	            },
	            onHide: function (comp) {
	              findFocusedElem(comp.element, lazySink).fold(focusedElm.clear, focusedElm.set);
	              runOnSinkElement(function (elem) {
	                return updateSinkVisibility(elem, false);
	              });
	            },
	            onHidden: function () {
	              runOnSinkElement(function (elem) {
	                return remove$1(elem, [visibility.transitionClass]);
	              });
	            }
	          }, visibility),
	          lazyViewport: function (comp) {
	            var win$1 = win();
	            var offset = getStickyToolbarOffset(editor);
	            var top = win$1.y + (isDockedMode(comp, 'top') ? offset : 0);
	            var height = win$1.height - (isDockedMode(comp, 'bottom') ? offset : 0);
	            return bounds(win$1.x, top, win$1.width, height);
	          },
	          modes: [sharedBackstage.header.getDockingMode()],
	          onDocked: onDockingSwitch,
	          onUndocked: onDockingSwitch
	        })
	      ], additionalBehaviours, true);
	    };
	
	    var StickyHeader = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setup: setup$9,
	        isDocked: isDocked,
	        getBehaviours: getBehaviours
	    });
	
	    var renderHeader = function (spec) {
	      var editor = spec.editor;
	      var getBehaviours$2 = spec.sticky ? getBehaviours : getBehaviours$1;
	      return {
	        uid: spec.uid,
	        dom: spec.dom,
	        components: spec.components,
	        behaviours: derive$1(getBehaviours$2(editor, spec.sharedBackstage))
	      };
	    };
	
	    var groupToolbarButtonSchema = objOf([
	      requiredString('type'),
	      requiredOf('items', oneOf([
	        arrOfObj([
	          requiredString('name'),
	          requiredArrayOf('items', string)
	        ]),
	        string
	      ]))
	    ].concat(baseToolbarButtonFields));
	    var createGroupToolbarButton = function (spec) {
	      return asRaw('GroupToolbarButton', groupToolbarButtonSchema, spec);
	    };
	
	    var baseMenuButtonFields = [
	      optionString('text'),
	      optionString('tooltip'),
	      optionString('icon'),
	      requiredFunction('fetch'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      })
	    ];
	
	    var MenuButtonSchema = objOf(__spreadArray([requiredString('type')], baseMenuButtonFields, true));
	    var createMenuButton = function (spec) {
	      return asRaw('menubutton', MenuButtonSchema, spec);
	    };
	
	    var splitButtonSchema = objOf([
	      requiredString('type'),
	      optionString('tooltip'),
	      optionString('icon'),
	      optionString('text'),
	      optionFunction('select'),
	      requiredFunction('fetch'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      defaultedStringEnum('presets', 'normal', [
	        'normal',
	        'color',
	        'listpreview'
	      ]),
	      defaulted('columns', 1),
	      requiredFunction('onAction'),
	      requiredFunction('onItemAction')
	    ]);
	    var createSplitButton = function (spec) {
	      return asRaw('SplitButton', splitButtonSchema, spec);
	    };
	
	    var factory$b = function (detail, spec) {
	      var setMenus = function (comp, menus) {
	        var newMenus = map$2(menus, function (m) {
	          var buttonSpec = {
	            type: 'menubutton',
	            text: m.text,
	            fetch: function (callback) {
	              callback(m.getItems());
	            }
	          };
	          var internal = createMenuButton(buttonSpec).mapError(function (errInfo) {
	            return formatError(errInfo);
	          }).getOrDie();
	          return renderMenuButton(internal, 'tox-mbtn', spec.backstage, Optional.some('menuitem'));
	        });
	        Replacing.set(comp, newMenus);
	      };
	      var apis = {
	        focus: Keying.focusIn,
	        setMenus: setMenus
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: [],
	        behaviours: derive$1([
	          Replacing.config({}),
	          config('menubar-events', [
	            runOnAttached(function (component) {
	              detail.onSetup(component);
	            }),
	            run$1(mouseover(), function (comp, se) {
	              descendant(comp.element, '.' + 'tox-mbtn--active').each(function (activeButton) {
	                closest$1(se.event.target, '.' + 'tox-mbtn').each(function (hoveredButton) {
	                  if (!eq(activeButton, hoveredButton)) {
	                    comp.getSystem().getByDom(activeButton).each(function (activeComp) {
	                      comp.getSystem().getByDom(hoveredButton).each(function (hoveredComp) {
	                        Dropdown.expand(hoveredComp);
	                        Dropdown.close(activeComp);
	                        Focusing.focus(hoveredComp);
	                      });
	                    });
	                  }
	                });
	              });
	            }),
	            run$1(focusShifted(), function (comp, se) {
	              se.event.prevFocus.bind(function (prev) {
	                return comp.getSystem().getByDom(prev).toOptional();
	              }).each(function (prev) {
	                se.event.newFocus.bind(function (nu) {
	                  return comp.getSystem().getByDom(nu).toOptional();
	                }).each(function (nu) {
	                  if (Dropdown.isOpen(prev)) {
	                    Dropdown.expand(nu);
	                    Dropdown.close(prev);
	                  }
	                });
	              });
	            })
	          ]),
	          Keying.config({
	            mode: 'flow',
	            selector: '.' + 'tox-mbtn',
	            onEscape: function (comp) {
	              detail.onEscape(comp);
	              return Optional.some(true);
	            }
	          }),
	          Tabstopping.config({})
	        ]),
	        apis: apis,
	        domModification: { attributes: { role: 'menubar' } }
	      };
	    };
	    var SilverMenubar = single({
	      factory: factory$b,
	      name: 'silver.Menubar',
	      configFields: [
	        required$1('dom'),
	        required$1('uid'),
	        required$1('onEscape'),
	        required$1('backstage'),
	        defaulted('onSetup', noop)
	      ],
	      apis: {
	        focus: function (apis, comp) {
	          apis.focus(comp);
	        },
	        setMenus: function (apis, comp, menus) {
	          apis.setMenus(comp, menus);
	        }
	      }
	    });
	
	    var getAnimationRoot = function (component, slideConfig) {
	      return slideConfig.getAnimationRoot.fold(function () {
	        return component.element;
	      }, function (get) {
	        return get(component);
	      });
	    };
	
	    var getDimensionProperty = function (slideConfig) {
	      return slideConfig.dimension.property;
	    };
	    var getDimension = function (slideConfig, elem) {
	      return slideConfig.dimension.getDimension(elem);
	    };
	    var disableTransitions = function (component, slideConfig) {
	      var root = getAnimationRoot(component, slideConfig);
	      remove$1(root, [
	        slideConfig.shrinkingClass,
	        slideConfig.growingClass
	      ]);
	    };
	    var setShrunk = function (component, slideConfig) {
	      remove$2(component.element, slideConfig.openClass);
	      add$2(component.element, slideConfig.closedClass);
	      set$7(component.element, getDimensionProperty(slideConfig), '0px');
	      reflow(component.element);
	    };
	    var setGrown = function (component, slideConfig) {
	      remove$2(component.element, slideConfig.closedClass);
	      add$2(component.element, slideConfig.openClass);
	      remove$6(component.element, getDimensionProperty(slideConfig));
	    };
	    var doImmediateShrink = function (component, slideConfig, slideState, _calculatedSize) {
	      slideState.setCollapsed();
	      set$7(component.element, getDimensionProperty(slideConfig), getDimension(slideConfig, component.element));
	      reflow(component.element);
	      disableTransitions(component, slideConfig);
	      setShrunk(component, slideConfig);
	      slideConfig.onStartShrink(component);
	      slideConfig.onShrunk(component);
	    };
	    var doStartShrink = function (component, slideConfig, slideState, calculatedSize) {
	      var size = calculatedSize.getOrThunk(function () {
	        return getDimension(slideConfig, component.element);
	      });
	      slideState.setCollapsed();
	      set$7(component.element, getDimensionProperty(slideConfig), size);
	      reflow(component.element);
	      var root = getAnimationRoot(component, slideConfig);
	      remove$2(root, slideConfig.growingClass);
	      add$2(root, slideConfig.shrinkingClass);
	      setShrunk(component, slideConfig);
	      slideConfig.onStartShrink(component);
	    };
	    var doStartSmartShrink = function (component, slideConfig, slideState) {
	      var size = getDimension(slideConfig, component.element);
	      var shrinker = size === '0px' ? doImmediateShrink : doStartShrink;
	      shrinker(component, slideConfig, slideState, Optional.some(size));
	    };
	    var doStartGrow = function (component, slideConfig, slideState) {
	      var root = getAnimationRoot(component, slideConfig);
	      var wasShrinking = has(root, slideConfig.shrinkingClass);
	      var beforeSize = getDimension(slideConfig, component.element);
	      setGrown(component, slideConfig);
	      var fullSize = getDimension(slideConfig, component.element);
	      var startPartialGrow = function () {
	        set$7(component.element, getDimensionProperty(slideConfig), beforeSize);
	        reflow(component.element);
	      };
	      var startCompleteGrow = function () {
	        setShrunk(component, slideConfig);
	      };
	      var setStartSize = wasShrinking ? startPartialGrow : startCompleteGrow;
	      setStartSize();
	      remove$2(root, slideConfig.shrinkingClass);
	      add$2(root, slideConfig.growingClass);
	      setGrown(component, slideConfig);
	      set$7(component.element, getDimensionProperty(slideConfig), fullSize);
	      slideState.setExpanded();
	      slideConfig.onStartGrow(component);
	    };
	    var refresh$3 = function (component, slideConfig, slideState) {
	      if (slideState.isExpanded()) {
	        remove$6(component.element, getDimensionProperty(slideConfig));
	        var fullSize = getDimension(slideConfig, component.element);
	        set$7(component.element, getDimensionProperty(slideConfig), fullSize);
	      }
	    };
	    var grow = function (component, slideConfig, slideState) {
	      if (!slideState.isExpanded()) {
	        doStartGrow(component, slideConfig, slideState);
	      }
	    };
	    var shrink = function (component, slideConfig, slideState) {
	      if (slideState.isExpanded()) {
	        doStartSmartShrink(component, slideConfig, slideState);
	      }
	    };
	    var immediateShrink = function (component, slideConfig, slideState) {
	      if (slideState.isExpanded()) {
	        doImmediateShrink(component, slideConfig, slideState);
	      }
	    };
	    var hasGrown = function (component, slideConfig, slideState) {
	      return slideState.isExpanded();
	    };
	    var hasShrunk = function (component, slideConfig, slideState) {
	      return slideState.isCollapsed();
	    };
	    var isGrowing = function (component, slideConfig, _slideState) {
	      var root = getAnimationRoot(component, slideConfig);
	      return has(root, slideConfig.growingClass) === true;
	    };
	    var isShrinking = function (component, slideConfig, _slideState) {
	      var root = getAnimationRoot(component, slideConfig);
	      return has(root, slideConfig.shrinkingClass) === true;
	    };
	    var isTransitioning = function (component, slideConfig, slideState) {
	      return isGrowing(component, slideConfig) || isShrinking(component, slideConfig);
	    };
	    var toggleGrow = function (component, slideConfig, slideState) {
	      var f = slideState.isExpanded() ? doStartSmartShrink : doStartGrow;
	      f(component, slideConfig, slideState);
	    };
	
	    var SlidingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        refresh: refresh$3,
	        grow: grow,
	        shrink: shrink,
	        immediateShrink: immediateShrink,
	        hasGrown: hasGrown,
	        hasShrunk: hasShrunk,
	        isGrowing: isGrowing,
	        isShrinking: isShrinking,
	        isTransitioning: isTransitioning,
	        toggleGrow: toggleGrow,
	        disableTransitions: disableTransitions
	    });
	
	    var exhibit = function (base, slideConfig, _slideState) {
	      var expanded = slideConfig.expanded;
	      return expanded ? nu$7({
	        classes: [slideConfig.openClass],
	        styles: {}
	      }) : nu$7({
	        classes: [slideConfig.closedClass],
	        styles: wrap$1(slideConfig.dimension.property, '0px')
	      });
	    };
	    var events$4 = function (slideConfig, slideState) {
	      return derive$2([runOnSource(transitionend(), function (component, simulatedEvent) {
	          var raw = simulatedEvent.event.raw;
	          if (raw.propertyName === slideConfig.dimension.property) {
	            disableTransitions(component, slideConfig);
	            if (slideState.isExpanded()) {
	              remove$6(component.element, slideConfig.dimension.property);
	            }
	            var notify = slideState.isExpanded() ? slideConfig.onGrown : slideConfig.onShrunk;
	            notify(component);
	          }
	        })]);
	    };
	
	    var ActiveSliding = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit,
	        events: events$4
	    });
	
	    var SlidingSchema = [
	      required$1('closedClass'),
	      required$1('openClass'),
	      required$1('shrinkingClass'),
	      required$1('growingClass'),
	      option('getAnimationRoot'),
	      onHandler('onShrunk'),
	      onHandler('onStartShrink'),
	      onHandler('onGrown'),
	      onHandler('onStartGrow'),
	      defaulted('expanded', false),
	      requiredOf('dimension', choose$1('property', {
	        width: [
	          output$1('property', 'width'),
	          output$1('getDimension', function (elem) {
	            return get$a(elem) + 'px';
	          })
	        ],
	        height: [
	          output$1('property', 'height'),
	          output$1('getDimension', function (elem) {
	            return get$b(elem) + 'px';
	          })
	        ]
	      }))
	    ];
	
	    var init$5 = function (spec) {
	      var state = Cell(spec.expanded);
	      var readState = function () {
	        return 'expanded: ' + state.get();
	      };
	      return nu$8({
	        isExpanded: function () {
	          return state.get() === true;
	        },
	        isCollapsed: function () {
	          return state.get() === false;
	        },
	        setCollapsed: curry(state.set, false),
	        setExpanded: curry(state.set, true),
	        readState: readState
	      });
	    };
	
	    var SlidingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$5
	    });
	
	    var Sliding = create$8({
	      fields: SlidingSchema,
	      name: 'sliding',
	      active: ActiveSliding,
	      apis: SlidingApis,
	      state: SlidingState
	    });
	
	    var owner = 'container';
	    var schema$d = [field('slotBehaviours', [])];
	    var getPartName = function (name) {
	      return '<alloy.field.' + name + '>';
	    };
	    var sketch = function (sSpec) {
	      var parts = function () {
	        var record = [];
	        var slot = function (name, config) {
	          record.push(name);
	          return generateOne$1(owner, getPartName(name), config);
	        };
	        return {
	          slot: slot,
	          record: constant$1(record)
	        };
	      }();
	      var spec = sSpec(parts);
	      var partNames = parts.record();
	      var fieldParts = map$2(partNames, function (n) {
	        return required({
	          name: n,
	          pname: getPartName(n)
	        });
	      });
	      return composite$1(owner, schema$d, fieldParts, make$1, spec);
	    };
	    var make$1 = function (detail, components) {
	      var getSlotNames = function (_) {
	        return getAllPartNames(detail);
	      };
	      var getSlot = function (container, key) {
	        return getPart(container, detail, key);
	      };
	      var onSlot = function (f, def) {
	        return function (container, key) {
	          return getPart(container, detail, key).map(function (slot) {
	            return f(slot, key);
	          }).getOr(def);
	        };
	      };
	      var onSlots = function (f) {
	        return function (container, keys) {
	          each$1(keys, function (key) {
	            return f(container, key);
	          });
	        };
	      };
	      var doShowing = function (comp, _key) {
	        return get$d(comp.element, 'aria-hidden') !== 'true';
	      };
	      var doShow = function (comp, key) {
	        if (!doShowing(comp)) {
	          var element = comp.element;
	          remove$6(element, 'display');
	          remove$7(element, 'aria-hidden');
	          emitWith(comp, slotVisibility(), {
	            name: key,
	            visible: true
	          });
	        }
	      };
	      var doHide = function (comp, key) {
	        if (doShowing(comp)) {
	          var element = comp.element;
	          set$7(element, 'display', 'none');
	          set$8(element, 'aria-hidden', 'true');
	          emitWith(comp, slotVisibility(), {
	            name: key,
	            visible: false
	          });
	        }
	      };
	      var isShowing = onSlot(doShowing, false);
	      var hideSlot = onSlot(doHide);
	      var hideSlots = onSlots(hideSlot);
	      var hideAllSlots = function (container) {
	        return hideSlots(container, getSlotNames());
	      };
	      var showSlot = onSlot(doShow);
	      var apis = {
	        getSlotNames: getSlotNames,
	        getSlot: getSlot,
	        isShowing: isShowing,
	        hideSlot: hideSlot,
	        hideAllSlots: hideAllSlots,
	        showSlot: showSlot
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: get$2(detail.slotBehaviours),
	        apis: apis
	      };
	    };
	    var slotApis = map$1({
	      getSlotNames: function (apis, c) {
	        return apis.getSlotNames(c);
	      },
	      getSlot: function (apis, c, key) {
	        return apis.getSlot(c, key);
	      },
	      isShowing: function (apis, c, key) {
	        return apis.isShowing(c, key);
	      },
	      hideSlot: function (apis, c, key) {
	        return apis.hideSlot(c, key);
	      },
	      hideAllSlots: function (apis, c) {
	        return apis.hideAllSlots(c);
	      },
	      showSlot: function (apis, c, key) {
	        return apis.showSlot(c, key);
	      }
	    }, function (value) {
	      return makeApi(value);
	    });
	    var SlotContainer = __assign(__assign({}, slotApis), { sketch: sketch });
	
	    var sidebarSchema = objOf([
	      optionString('icon'),
	      optionString('tooltip'),
	      defaultedFunction('onShow', noop),
	      defaultedFunction('onHide', noop),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      })
	    ]);
	    var createSidebar = function (spec) {
	      return asRaw('sidebar', sidebarSchema, spec);
	    };
	
	    var setup$8 = function (editor) {
	      var sidebars = editor.ui.registry.getAll().sidebars;
	      each$1(keys(sidebars), function (name) {
	        var spec = sidebars[name];
	        var isActive = function () {
	          return is$1(Optional.from(editor.queryCommandValue('ToggleSidebar')), name);
	        };
	        editor.ui.registry.addToggleButton(name, {
	          icon: spec.icon,
	          tooltip: spec.tooltip,
	          onAction: function (buttonApi) {
	            editor.execCommand('ToggleSidebar', false, name);
	            buttonApi.setActive(isActive());
	          },
	          onSetup: function (buttonApi) {
	            var handleToggle = function () {
	              return buttonApi.setActive(isActive());
	            };
	            editor.on('ToggleSidebar', handleToggle);
	            return function () {
	              editor.off('ToggleSidebar', handleToggle);
	            };
	          }
	        });
	      });
	    };
	    var getApi = function (comp) {
	      return {
	        element: function () {
	          return comp.element.dom;
	        }
	      };
	    };
	    var makePanels = function (parts, panelConfigs) {
	      var specs = map$2(keys(panelConfigs), function (name) {
	        var spec = panelConfigs[name];
	        var bridged = getOrDie(createSidebar(spec));
	        return {
	          name: name,
	          getApi: getApi,
	          onSetup: bridged.onSetup,
	          onShow: bridged.onShow,
	          onHide: bridged.onHide
	        };
	      });
	      return map$2(specs, function (spec) {
	        var editorOffCell = Cell(noop);
	        return parts.slot(spec.name, {
	          dom: {
	            tag: 'div',
	            classes: ['tox-sidebar__pane']
	          },
	          behaviours: SimpleBehaviours.unnamedEvents([
	            onControlAttached(spec, editorOffCell),
	            onControlDetached(spec, editorOffCell),
	            run$1(slotVisibility(), function (sidepanel, se) {
	              var data = se.event;
	              var optSidePanelSpec = find$5(specs, function (config) {
	                return config.name === data.name;
	              });
	              optSidePanelSpec.each(function (sidePanelSpec) {
	                var handler = data.visible ? sidePanelSpec.onShow : sidePanelSpec.onHide;
	                handler(sidePanelSpec.getApi(sidepanel));
	              });
	            })
	          ])
	        });
	      });
	    };
	    var makeSidebar = function (panelConfigs) {
	      return SlotContainer.sketch(function (parts) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-sidebar__pane-container']
	          },
	          components: makePanels(parts, panelConfigs),
	          slotBehaviours: SimpleBehaviours.unnamedEvents([runOnAttached(function (slotContainer) {
	              return SlotContainer.hideAllSlots(slotContainer);
	            })])
	        };
	      });
	    };
	    var setSidebar = function (sidebar, panelConfigs) {
	      var optSlider = Composing.getCurrent(sidebar);
	      optSlider.each(function (slider) {
	        return Replacing.set(slider, [makeSidebar(panelConfigs)]);
	      });
	    };
	    var toggleSidebar = function (sidebar, name) {
	      var optSlider = Composing.getCurrent(sidebar);
	      optSlider.each(function (slider) {
	        var optSlotContainer = Composing.getCurrent(slider);
	        optSlotContainer.each(function (slotContainer) {
	          if (Sliding.hasGrown(slider)) {
	            if (SlotContainer.isShowing(slotContainer, name)) {
	              Sliding.shrink(slider);
	            } else {
	              SlotContainer.hideAllSlots(slotContainer);
	              SlotContainer.showSlot(slotContainer, name);
	            }
	          } else {
	            SlotContainer.hideAllSlots(slotContainer);
	            SlotContainer.showSlot(slotContainer, name);
	            Sliding.grow(slider);
	          }
	        });
	      });
	    };
	    var whichSidebar = function (sidebar) {
	      var optSlider = Composing.getCurrent(sidebar);
	      return optSlider.bind(function (slider) {
	        var sidebarOpen = Sliding.isGrowing(slider) || Sliding.hasGrown(slider);
	        if (sidebarOpen) {
	          var optSlotContainer = Composing.getCurrent(slider);
	          return optSlotContainer.bind(function (slotContainer) {
	            return find$5(SlotContainer.getSlotNames(slotContainer), function (name) {
	              return SlotContainer.isShowing(slotContainer, name);
	            });
	          });
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var fixSize = generate$6('FixSizeEvent');
	    var autoSize = generate$6('AutoSizeEvent');
	    var renderSidebar = function (spec) {
	      return {
	        uid: spec.uid,
	        dom: {
	          tag: 'div',
	          classes: ['tox-sidebar'],
	          attributes: { role: 'complementary' }
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-sidebar__slider']
	            },
	            components: [],
	            behaviours: derive$1([
	              Tabstopping.config({}),
	              Focusing.config({}),
	              Sliding.config({
	                dimension: { property: 'width' },
	                closedClass: 'tox-sidebar--sliding-closed',
	                openClass: 'tox-sidebar--sliding-open',
	                shrinkingClass: 'tox-sidebar--sliding-shrinking',
	                growingClass: 'tox-sidebar--sliding-growing',
	                onShrunk: function (slider) {
	                  var optSlotContainer = Composing.getCurrent(slider);
	                  optSlotContainer.each(SlotContainer.hideAllSlots);
	                  emit(slider, autoSize);
	                },
	                onGrown: function (slider) {
	                  emit(slider, autoSize);
	                },
	                onStartGrow: function (slider) {
	                  emitWith(slider, fixSize, { width: getRaw(slider.element, 'width').getOr('') });
	                },
	                onStartShrink: function (slider) {
	                  emitWith(slider, fixSize, { width: get$a(slider.element) + 'px' });
	                }
	              }),
	              Replacing.config({}),
	              Composing.config({
	                find: function (comp) {
	                  var children = Replacing.contents(comp);
	                  return head(children);
	                }
	              })
	            ])
	          }],
	        behaviours: derive$1([
	          ComposingConfigs.childAt(0),
	          config('sidebar-sliding-events', [
	            run$1(fixSize, function (comp, se) {
	              set$7(comp.element, 'width', se.event.width);
	            }),
	            run$1(autoSize, function (comp, _se) {
	              remove$6(comp.element, 'width');
	            })
	          ])
	        ])
	      };
	    };
	
	    var block = function (component, config, state, getBusySpec) {
	      set$8(component.element, 'aria-busy', true);
	      var root = config.getRoot(component).getOr(component);
	      var blockerBehaviours = derive$1([
	        Keying.config({
	          mode: 'special',
	          onTab: function () {
	            return Optional.some(true);
	          },
	          onShiftTab: function () {
	            return Optional.some(true);
	          }
	        }),
	        Focusing.config({})
	      ]);
	      var blockSpec = getBusySpec(root, blockerBehaviours);
	      var blocker = root.getSystem().build(blockSpec);
	      Replacing.append(root, premade(blocker));
	      if (blocker.hasConfigured(Keying) && config.focus) {
	        Keying.focusIn(blocker);
	      }
	      if (!state.isBlocked()) {
	        config.onBlock(component);
	      }
	      state.blockWith(function () {
	        return Replacing.remove(root, blocker);
	      });
	    };
	    var unblock = function (component, config, state) {
	      remove$7(component.element, 'aria-busy');
	      if (state.isBlocked()) {
	        config.onUnblock(component);
	      }
	      state.clear();
	    };
	
	    var BlockingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        block: block,
	        unblock: unblock
	    });
	
	    var BlockingSchema = [
	      defaultedFunction('getRoot', Optional.none),
	      defaultedBoolean('focus', true),
	      onHandler('onBlock'),
	      onHandler('onUnblock')
	    ];
	
	    var init$4 = function () {
	      var blocker = destroyable();
	      var blockWith = function (destroy) {
	        blocker.set({ destroy: destroy });
	      };
	      return nu$8({
	        readState: blocker.isSet,
	        blockWith: blockWith,
	        clear: blocker.clear,
	        isBlocked: blocker.isSet
	      });
	    };
	
	    var BlockingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$4
	    });
	
	    var Blocking = create$8({
	      fields: BlockingSchema,
	      name: 'blocking',
	      apis: BlockingApis,
	      state: BlockingState
	    });
	
	    var getAttrs = function (elem) {
	      var attributes = elem.dom.attributes !== undefined ? elem.dom.attributes : [];
	      return foldl(attributes, function (b, attr) {
	        var _a;
	        if (attr.name === 'class') {
	          return b;
	        } else {
	          return __assign(__assign({}, b), (_a = {}, _a[attr.name] = attr.value, _a));
	        }
	      }, {});
	    };
	    var getClasses = function (elem) {
	      return Array.prototype.slice.call(elem.dom.classList, 0);
	    };
	    var fromHtml = function (html) {
	      var elem = SugarElement.fromHtml(html);
	      var children$1 = children(elem);
	      var attrs = getAttrs(elem);
	      var classes = getClasses(elem);
	      var contents = children$1.length === 0 ? {} : { innerHtml: get$7(elem) };
	      return __assign({
	        tag: name$2(elem),
	        classes: classes,
	        attributes: attrs
	      }, contents);
	    };
	
	    var getBusySpec$1 = function (providerBackstage) {
	      return function (_root, _behaviours) {
	        return {
	          dom: {
	            tag: 'div',
	            attributes: {
	              'aria-label': providerBackstage.translate('Loading...'),
	              'tabindex': '0'
	            },
	            classes: ['tox-throbber__busy-spinner']
	          },
	          components: [{ dom: fromHtml('<div class="tox-spinner"><div></div><div></div><div></div></div>') }]
	        };
	      };
	    };
	    var focusBusyComponent = function (throbber) {
	      return Composing.getCurrent(throbber).each(function (comp) {
	        return focus$3(comp.element);
	      });
	    };
	    var toggleEditorTabIndex = function (editor, state) {
	      var tabIndexAttr = 'tabindex';
	      var dataTabIndexAttr = 'data-mce-' + tabIndexAttr;
	      Optional.from(editor.iframeElement).map(SugarElement.fromDom).each(function (iframe) {
	        if (state) {
	          getOpt(iframe, tabIndexAttr).each(function (tabIndex) {
	            return set$8(iframe, dataTabIndexAttr, tabIndex);
	          });
	          set$8(iframe, tabIndexAttr, -1);
	        } else {
	          remove$7(iframe, tabIndexAttr);
	          getOpt(iframe, dataTabIndexAttr).each(function (tabIndex) {
	            set$8(iframe, tabIndexAttr, tabIndex);
	            remove$7(iframe, dataTabIndexAttr);
	          });
	        }
	      });
	    };
	    var toggleThrobber = function (editor, comp, state, providerBackstage) {
	      var element = comp.element;
	      toggleEditorTabIndex(editor, state);
	      if (state) {
	        Blocking.block(comp, getBusySpec$1(providerBackstage));
	        remove$6(element, 'display');
	        remove$7(element, 'aria-hidden');
	        if (editor.hasFocus()) {
	          focusBusyComponent(comp);
	        }
	      } else {
	        var throbberFocus = Composing.getCurrent(comp).exists(function (busyComp) {
	          return hasFocus(busyComp.element);
	        });
	        Blocking.unblock(comp);
	        set$7(element, 'display', 'none');
	        set$8(element, 'aria-hidden', 'true');
	        if (throbberFocus) {
	          editor.focus();
	        }
	      }
	    };
	    var renderThrobber = function (spec) {
	      return {
	        uid: spec.uid,
	        dom: {
	          tag: 'div',
	          attributes: { 'aria-hidden': 'true' },
	          classes: ['tox-throbber'],
	          styles: { display: 'none' }
	        },
	        behaviours: derive$1([
	          Replacing.config({}),
	          Blocking.config({ focus: false }),
	          Composing.config({
	            find: function (comp) {
	              return head(comp.components());
	            }
	          })
	        ]),
	        components: []
	      };
	    };
	    var isFocusEvent = function (event) {
	      return event.type === 'focusin';
	    };
	    var isPasteBinTarget = function (event) {
	      if (isFocusEvent(event)) {
	        var node = event.composed ? head(event.composedPath()) : Optional.from(event.target);
	        return node.map(SugarElement.fromDom).filter(isElement$2).exists(function (targetElm) {
	          return has(targetElm, 'mce-pastebin');
	        });
	      } else {
	        return false;
	      }
	    };
	    var setup$7 = function (editor, lazyThrobber, sharedBackstage) {
	      var throbberState = Cell(false);
	      var timer = value$1();
	      var stealFocus = function (e) {
	        if (throbberState.get() && !isPasteBinTarget(e)) {
	          e.preventDefault();
	          focusBusyComponent(lazyThrobber());
	          editor.editorManager.setActive(editor);
	        }
	      };
	      if (!editor.inline) {
	        editor.on('PreInit', function () {
	          editor.dom.bind(editor.getWin(), 'focusin', stealFocus);
	          editor.on('BeforeExecCommand', function (e) {
	            if (e.command.toLowerCase() === 'mcefocus' && e.value !== true) {
	              stealFocus(e);
	            }
	          });
	        });
	      }
	      var toggle = function (state) {
	        if (state !== throbberState.get()) {
	          throbberState.set(state);
	          toggleThrobber(editor, lazyThrobber(), state, sharedBackstage.providers);
	          editor.fire('AfterProgressState', { state: state });
	        }
	      };
	      editor.on('ProgressState', function (e) {
	        timer.on(global$f.clearTimeout);
	        if (isNumber(e.time)) {
	          var timerId = global$f.setEditorTimeout(editor, function () {
	            return toggle(e.state);
	          }, e.time);
	          timer.set(timerId);
	        } else {
	          toggle(e.state);
	          timer.clear();
	        }
	      });
	    };
	
	    var generate$1 = function (xs, f) {
	      var init = {
	        len: 0,
	        list: []
	      };
	      var r = foldl(xs, function (b, a) {
	        var value = f(a, b.len);
	        return value.fold(constant$1(b), function (v) {
	          return {
	            len: v.finish,
	            list: b.list.concat([v])
	          };
	        });
	      }, init);
	      return r.list;
	    };
	
	    var output = function (within, extra, withinWidth) {
	      return {
	        within: within,
	        extra: extra,
	        withinWidth: withinWidth
	      };
	    };
	    var apportion = function (units, total, len) {
	      var parray = generate$1(units, function (unit, current) {
	        var width = len(unit);
	        return Optional.some({
	          element: unit,
	          start: current,
	          finish: current + width,
	          width: width
	        });
	      });
	      var within = filter$2(parray, function (unit) {
	        return unit.finish <= total;
	      });
	      var withinWidth = foldr(within, function (acc, el) {
	        return acc + el.width;
	      }, 0);
	      var extra = parray.slice(within.length);
	      return {
	        within: within,
	        extra: extra,
	        withinWidth: withinWidth
	      };
	    };
	    var toUnit = function (parray) {
	      return map$2(parray, function (unit) {
	        return unit.element;
	      });
	    };
	    var fitLast = function (within, extra, withinWidth) {
	      var fits = toUnit(within.concat(extra));
	      return output(fits, [], withinWidth);
	    };
	    var overflow = function (within, extra, overflower, withinWidth) {
	      var fits = toUnit(within).concat([overflower]);
	      return output(fits, toUnit(extra), withinWidth);
	    };
	    var fitAll = function (within, extra, withinWidth) {
	      return output(toUnit(within), [], withinWidth);
	    };
	    var tryFit = function (total, units, len) {
	      var divide = apportion(units, total, len);
	      return divide.extra.length === 0 ? Optional.some(divide) : Optional.none();
	    };
	    var partition = function (total, units, len, overflower) {
	      var divide = tryFit(total, units, len).getOrThunk(function () {
	        return apportion(units, total - len(overflower), len);
	      });
	      var within = divide.within;
	      var extra = divide.extra;
	      var withinWidth = divide.withinWidth;
	      if (extra.length === 1 && extra[0].width <= len(overflower)) {
	        return fitLast(within, extra, withinWidth);
	      } else if (extra.length >= 1) {
	        return overflow(within, extra, overflower, withinWidth);
	      } else {
	        return fitAll(within, extra, withinWidth);
	      }
	    };
	
	    var setGroups$1 = function (toolbar, storedGroups) {
	      var bGroups = map$2(storedGroups, function (g) {
	        return premade(g);
	      });
	      Toolbar.setGroups(toolbar, bGroups);
	    };
	    var findFocusedComp = function (comps) {
	      return findMap(comps, function (comp) {
	        return search(comp.element).bind(function (focusedElm) {
	          return comp.getSystem().getByDom(focusedElm).toOptional();
	        });
	      });
	    };
	    var refresh$2 = function (toolbar, detail, setOverflow) {
	      var builtGroups = detail.builtGroups.get();
	      if (builtGroups.length === 0) {
	        return;
	      }
	      var primary = getPartOrDie(toolbar, detail, 'primary');
	      var overflowGroup = Coupling.getCoupled(toolbar, 'overflowGroup');
	      set$7(primary.element, 'visibility', 'hidden');
	      var groups = builtGroups.concat([overflowGroup]);
	      var focusedComp = findFocusedComp(groups);
	      setOverflow([]);
	      setGroups$1(primary, groups);
	      var availableWidth = get$a(primary.element);
	      var overflows = partition(availableWidth, detail.builtGroups.get(), function (comp) {
	        return get$a(comp.element);
	      }, overflowGroup);
	      if (overflows.extra.length === 0) {
	        Replacing.remove(primary, overflowGroup);
	        setOverflow([]);
	      } else {
	        setGroups$1(primary, overflows.within);
	        setOverflow(overflows.extra);
	      }
	      remove$6(primary.element, 'visibility');
	      reflow(primary.element);
	      focusedComp.each(Focusing.focus);
	    };
	
	    var schema$c = constant$1([
	      field('splitToolbarBehaviours', [Coupling]),
	      customField('builtGroups', function () {
	        return Cell([]);
	      })
	    ]);
	
	    var schema$b = constant$1([
	      markers$1(['overflowToggledClass']),
	      optionFunction('getOverflowBounds'),
	      required$1('lazySink'),
	      customField('overflowGroups', function () {
	        return Cell([]);
	      })
	    ].concat(schema$c()));
	    var parts$7 = constant$1([
	      required({
	        factory: Toolbar,
	        schema: schema$e(),
	        name: 'primary'
	      }),
	      external$1({
	        schema: schema$e(),
	        name: 'overflow'
	      }),
	      external$1({ name: 'overflow-button' }),
	      external$1({ name: 'overflow-group' })
	    ]);
	
	    var expandable = constant$1(function (element, available) {
	      setMax(element, Math.floor(available));
	    });
	
	    var schema$a = constant$1([
	      markers$1(['toggledClass']),
	      required$1('lazySink'),
	      requiredFunction('fetch'),
	      optionFunction('getBounds'),
	      optionObjOf('fireDismissalEventInstead', [defaulted('event', dismissRequested())]),
	      schema$y()
	    ]);
	    var parts$6 = constant$1([
	      external$1({
	        name: 'button',
	        overrides: function (detail) {
	          return {
	            dom: { attributes: { 'aria-haspopup': 'true' } },
	            buttonBehaviours: derive$1([Toggling.config({
	                toggleClass: detail.markers.toggledClass,
	                aria: { mode: 'expanded' },
	                toggleOnExecute: false
	              })])
	          };
	        }
	      }),
	      external$1({
	        factory: Toolbar,
	        schema: schema$e(),
	        name: 'toolbar',
	        overrides: function (detail) {
	          return {
	            toolbarBehaviours: derive$1([Keying.config({
	                mode: 'cyclic',
	                onEscape: function (comp) {
	                  getPart(comp, detail, 'button').each(Focusing.focus);
	                  return Optional.none();
	                }
	              })])
	          };
	        }
	      })
	    ]);
	
	    var toggle = function (button, externals) {
	      var toolbarSandbox = Coupling.getCoupled(button, 'toolbarSandbox');
	      if (Sandboxing.isOpen(toolbarSandbox)) {
	        Sandboxing.close(toolbarSandbox);
	      } else {
	        Sandboxing.open(toolbarSandbox, externals.toolbar());
	      }
	    };
	    var position = function (button, toolbar, detail, layouts) {
	      var bounds = detail.getBounds.map(function (bounder) {
	        return bounder();
	      });
	      var sink = detail.lazySink(button).getOrDie();
	      Positioning.positionWithinBounds(sink, toolbar, {
	        anchor: {
	          type: 'hotspot',
	          hotspot: button,
	          layouts: layouts,
	          overrides: { maxWidthFunction: expandable() }
	        }
	      }, bounds);
	    };
	    var setGroups = function (button, toolbar, detail, layouts, groups) {
	      Toolbar.setGroups(toolbar, groups);
	      position(button, toolbar, detail, layouts);
	      Toggling.on(button);
	    };
	    var makeSandbox = function (button, spec, detail) {
	      var ariaOwner = manager();
	      var onOpen = function (sandbox, toolbar) {
	        detail.fetch().get(function (groups) {
	          setGroups(button, toolbar, detail, spec.layouts, groups);
	          ariaOwner.link(button.element);
	          Keying.focusIn(toolbar);
	        });
	      };
	      var onClose = function () {
	        Toggling.off(button);
	        Focusing.focus(button);
	        ariaOwner.unlink(button.element);
	      };
	      return {
	        dom: {
	          tag: 'div',
	          attributes: { id: ariaOwner.id }
	        },
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'special',
	            onEscape: function (comp) {
	              Sandboxing.close(comp);
	              return Optional.some(true);
	            }
	          }),
	          Sandboxing.config({
	            onOpen: onOpen,
	            onClose: onClose,
	            isPartOf: function (container, data, queryElem) {
	              return isPartOf$1(data, queryElem) || isPartOf$1(button, queryElem);
	            },
	            getAttachPoint: function () {
	              return detail.lazySink(button).getOrDie();
	            }
	          }),
	          Receiving.config({
	            channels: __assign(__assign({}, receivingChannel$1(__assign({ isExtraPart: never }, detail.fireDismissalEventInstead.map(function (fe) {
	              return { fireEventInstead: { event: fe.event } };
	            }).getOr({})))), receivingChannel({
	              doReposition: function () {
	                Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
	                  position(button, toolbar, detail, spec.layouts);
	                });
	              }
	            }))
	          })
	        ])
	      };
	    };
	    var factory$a = function (detail, components, spec, externals) {
	      return __assign(__assign({}, Button.sketch(__assign(__assign({}, externals.button()), {
	        action: function (button) {
	          toggle(button, externals);
	        },
	        buttonBehaviours: SketchBehaviours.augment({ dump: externals.button().buttonBehaviours }, [Coupling.config({
	            others: {
	              toolbarSandbox: function (button) {
	                return makeSandbox(button, spec, detail);
	              }
	            }
	          })])
	      }))), {
	        apis: {
	          setGroups: function (button, groups) {
	            Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
	              setGroups(button, toolbar, detail, spec.layouts, groups);
	            });
	          },
	          reposition: function (button) {
	            Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
	              position(button, toolbar, detail, spec.layouts);
	            });
	          },
	          toggle: function (button) {
	            toggle(button, externals);
	          },
	          getToolbar: function (button) {
	            return Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox'));
	          },
	          isOpen: function (button) {
	            return Sandboxing.isOpen(Coupling.getCoupled(button, 'toolbarSandbox'));
	          }
	        }
	      });
	    };
	    var FloatingToolbarButton = composite({
	      name: 'FloatingToolbarButton',
	      factory: factory$a,
	      configFields: schema$a(),
	      partFields: parts$6(),
	      apis: {
	        setGroups: function (apis, button, groups) {
	          apis.setGroups(button, groups);
	        },
	        reposition: function (apis, button) {
	          apis.reposition(button);
	        },
	        toggle: function (apis, button) {
	          apis.toggle(button);
	        },
	        getToolbar: function (apis, button) {
	          return apis.getToolbar(button);
	        },
	        isOpen: function (apis, button) {
	          return apis.isOpen(button);
	        }
	      }
	    });
	
	    var schema$9 = constant$1([
	      required$1('items'),
	      markers$1(['itemSelector']),
	      field('tgroupBehaviours', [Keying])
	    ]);
	    var parts$5 = constant$1([group({
	        name: 'items',
	        unit: 'item'
	      })]);
	
	    var factory$9 = function (detail, components, _spec, _externals) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.tgroupBehaviours, [Keying.config({
	            mode: 'flow',
	            selector: detail.markers.itemSelector
	          })]),
	        domModification: { attributes: { role: 'toolbar' } }
	      };
	    };
	    var ToolbarGroup = composite({
	      name: 'ToolbarGroup',
	      configFields: schema$9(),
	      partFields: parts$5(),
	      factory: factory$9
	    });
	
	    var buildGroups = function (comps) {
	      return map$2(comps, function (g) {
	        return premade(g);
	      });
	    };
	    var refresh$1 = function (toolbar, memFloatingToolbarButton, detail) {
	      refresh$2(toolbar, detail, function (overflowGroups) {
	        detail.overflowGroups.set(overflowGroups);
	        memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
	          FloatingToolbarButton.setGroups(floatingToolbarButton, buildGroups(overflowGroups));
	        });
	      });
	    };
	    var factory$8 = function (detail, components, spec, externals) {
	      var memFloatingToolbarButton = record(FloatingToolbarButton.sketch({
	        fetch: function () {
	          return Future.nu(function (resolve) {
	            resolve(buildGroups(detail.overflowGroups.get()));
	          });
	        },
	        layouts: {
	          onLtr: function () {
	            return [
	              southwest$2,
	              southeast$2
	            ];
	          },
	          onRtl: function () {
	            return [
	              southeast$2,
	              southwest$2
	            ];
	          },
	          onBottomLtr: function () {
	            return [
	              northwest$2,
	              northeast$2
	            ];
	          },
	          onBottomRtl: function () {
	            return [
	              northeast$2,
	              northwest$2
	            ];
	          }
	        },
	        getBounds: spec.getOverflowBounds,
	        lazySink: detail.lazySink,
	        fireDismissalEventInstead: {},
	        markers: { toggledClass: detail.markers.overflowToggledClass },
	        parts: {
	          button: externals['overflow-button'](),
	          toolbar: externals.overflow()
	        }
	      }));
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.splitToolbarBehaviours, [Coupling.config({
	            others: {
	              overflowGroup: function () {
	                return ToolbarGroup.sketch(__assign(__assign({}, externals['overflow-group']()), { items: [memFloatingToolbarButton.asSpec()] }));
	              }
	            }
	          })]),
	        apis: {
	          setGroups: function (toolbar, groups) {
	            detail.builtGroups.set(map$2(groups, toolbar.getSystem().build));
	            refresh$1(toolbar, memFloatingToolbarButton, detail);
	          },
	          refresh: function (toolbar) {
	            return refresh$1(toolbar, memFloatingToolbarButton, detail);
	          },
	          toggle: function (toolbar) {
	            memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
	              FloatingToolbarButton.toggle(floatingToolbarButton);
	            });
	          },
	          isOpen: function (toolbar) {
	            return memFloatingToolbarButton.getOpt(toolbar).map(FloatingToolbarButton.isOpen).getOr(false);
	          },
	          reposition: function (toolbar) {
	            memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
	              FloatingToolbarButton.reposition(floatingToolbarButton);
	            });
	          },
	          getOverflow: function (toolbar) {
	            return memFloatingToolbarButton.getOpt(toolbar).bind(FloatingToolbarButton.getToolbar);
	          }
	        },
	        domModification: { attributes: { role: 'group' } }
	      };
	    };
	    var SplitFloatingToolbar = composite({
	      name: 'SplitFloatingToolbar',
	      configFields: schema$b(),
	      partFields: parts$7(),
	      factory: factory$8,
	      apis: {
	        setGroups: function (apis, toolbar, groups) {
	          apis.setGroups(toolbar, groups);
	        },
	        refresh: function (apis, toolbar) {
	          apis.refresh(toolbar);
	        },
	        reposition: function (apis, toolbar) {
	          apis.reposition(toolbar);
	        },
	        toggle: function (apis, toolbar) {
	          apis.toggle(toolbar);
	        },
	        isOpen: function (apis, toolbar) {
	          return apis.isOpen(toolbar);
	        },
	        getOverflow: function (apis, toolbar) {
	          return apis.getOverflow(toolbar);
	        }
	      }
	    });
	
	    var schema$8 = constant$1([
	      markers$1([
	        'closedClass',
	        'openClass',
	        'shrinkingClass',
	        'growingClass',
	        'overflowToggledClass'
	      ]),
	      onHandler('onOpened'),
	      onHandler('onClosed')
	    ].concat(schema$c()));
	    var parts$4 = constant$1([
	      required({
	        factory: Toolbar,
	        schema: schema$e(),
	        name: 'primary'
	      }),
	      required({
	        factory: Toolbar,
	        schema: schema$e(),
	        name: 'overflow',
	        overrides: function (detail) {
	          return {
	            toolbarBehaviours: derive$1([
	              Sliding.config({
	                dimension: { property: 'height' },
	                closedClass: detail.markers.closedClass,
	                openClass: detail.markers.openClass,
	                shrinkingClass: detail.markers.shrinkingClass,
	                growingClass: detail.markers.growingClass,
	                onShrunk: function (comp) {
	                  getPart(comp, detail, 'overflow-button').each(function (button) {
	                    Toggling.off(button);
	                    Focusing.focus(button);
	                  });
	                  detail.onClosed(comp);
	                },
	                onGrown: function (comp) {
	                  Keying.focusIn(comp);
	                  detail.onOpened(comp);
	                },
	                onStartGrow: function (comp) {
	                  getPart(comp, detail, 'overflow-button').each(Toggling.on);
	                }
	              }),
	              Keying.config({
	                mode: 'acyclic',
	                onEscape: function (comp) {
	                  getPart(comp, detail, 'overflow-button').each(Focusing.focus);
	                  return Optional.some(true);
	                }
	              })
	            ])
	          };
	        }
	      }),
	      external$1({
	        name: 'overflow-button',
	        overrides: function (detail) {
	          return {
	            buttonBehaviours: derive$1([Toggling.config({
	                toggleClass: detail.markers.overflowToggledClass,
	                aria: { mode: 'pressed' },
	                toggleOnExecute: false
	              })])
	          };
	        }
	      }),
	      external$1({ name: 'overflow-group' })
	    ]);
	
	    var isOpen = function (toolbar, detail) {
	      return getPart(toolbar, detail, 'overflow').map(Sliding.hasGrown).getOr(false);
	    };
	    var toggleToolbar = function (toolbar, detail) {
	      getPart(toolbar, detail, 'overflow-button').bind(function () {
	        return getPart(toolbar, detail, 'overflow');
	      }).each(function (overf) {
	        refresh(toolbar, detail);
	        Sliding.toggleGrow(overf);
	      });
	    };
	    var refresh = function (toolbar, detail) {
	      getPart(toolbar, detail, 'overflow').each(function (overflow) {
	        refresh$2(toolbar, detail, function (groups) {
	          var builtGroups = map$2(groups, function (g) {
	            return premade(g);
	          });
	          Toolbar.setGroups(overflow, builtGroups);
	        });
	        getPart(toolbar, detail, 'overflow-button').each(function (button) {
	          if (Sliding.hasGrown(overflow)) {
	            Toggling.on(button);
	          }
	        });
	        Sliding.refresh(overflow);
	      });
	    };
	    var factory$7 = function (detail, components, spec, externals) {
	      var toolbarToggleEvent = 'alloy.toolbar.toggle';
	      var doSetGroups = function (toolbar, groups) {
	        var built = map$2(groups, toolbar.getSystem().build);
	        detail.builtGroups.set(built);
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.splitToolbarBehaviours, [
	          Coupling.config({
	            others: {
	              overflowGroup: function (toolbar) {
	                return ToolbarGroup.sketch(__assign(__assign({}, externals['overflow-group']()), {
	                  items: [Button.sketch(__assign(__assign({}, externals['overflow-button']()), {
	                      action: function (_button) {
	                        emit(toolbar, toolbarToggleEvent);
	                      }
	                    }))]
	                }));
	              }
	            }
	          }),
	          config('toolbar-toggle-events', [run$1(toolbarToggleEvent, function (toolbar) {
	              toggleToolbar(toolbar, detail);
	            })])
	        ]),
	        apis: {
	          setGroups: function (toolbar, groups) {
	            doSetGroups(toolbar, groups);
	            refresh(toolbar, detail);
	          },
	          refresh: function (toolbar) {
	            return refresh(toolbar, detail);
	          },
	          toggle: function (toolbar) {
	            return toggleToolbar(toolbar, detail);
	          },
	          isOpen: function (toolbar) {
	            return isOpen(toolbar, detail);
	          }
	        },
	        domModification: { attributes: { role: 'group' } }
	      };
	    };
	    var SplitSlidingToolbar = composite({
	      name: 'SplitSlidingToolbar',
	      configFields: schema$8(),
	      partFields: parts$4(),
	      factory: factory$7,
	      apis: {
	        setGroups: function (apis, toolbar, groups) {
	          apis.setGroups(toolbar, groups);
	        },
	        refresh: function (apis, toolbar) {
	          apis.refresh(toolbar);
	        },
	        toggle: function (apis, toolbar) {
	          apis.toggle(toolbar);
	        },
	        isOpen: function (apis, toolbar) {
	          return apis.isOpen(toolbar);
	        }
	      }
	    });
	
	    var renderToolbarGroupCommon = function (toolbarGroup) {
	      var attributes = toolbarGroup.title.fold(function () {
	        return {};
	      }, function (title) {
	        return { attributes: { title: title } };
	      });
	      return {
	        dom: __assign({
	          tag: 'div',
	          classes: ['tox-toolbar__group']
	        }, attributes),
	        components: [ToolbarGroup.parts.items({})],
	        items: toolbarGroup.items,
	        markers: { itemSelector: '*:not(.tox-split-button) > .tox-tbtn:not([disabled]), ' + '.tox-split-button:not([disabled]), ' + '.tox-toolbar-nav-js:not([disabled])' },
	        tgroupBehaviours: derive$1([
	          Tabstopping.config({}),
	          Focusing.config({})
	        ])
	      };
	    };
	    var renderToolbarGroup = function (toolbarGroup) {
	      return ToolbarGroup.sketch(renderToolbarGroupCommon(toolbarGroup));
	    };
	    var getToolbarbehaviours = function (toolbarSpec, modeName) {
	      var onAttached = runOnAttached(function (component) {
	        var groups = map$2(toolbarSpec.initGroups, renderToolbarGroup);
	        Toolbar.setGroups(component, groups);
	      });
	      return derive$1([
	        DisablingConfigs.toolbarButton(toolbarSpec.providers.isDisabled),
	        receivingConfig(),
	        Keying.config({
	          mode: modeName,
	          onEscape: toolbarSpec.onEscape,
	          selector: '.tox-toolbar__group'
	        }),
	        config('toolbar-events', [onAttached])
	      ]);
	    };
	    var renderMoreToolbarCommon = function (toolbarSpec) {
	      var modeName = toolbarSpec.cyclicKeying ? 'cyclic' : 'acyclic';
	      return {
	        uid: toolbarSpec.uid,
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar-overlord']
	        },
	        parts: {
	          'overflow-group': renderToolbarGroupCommon({
	            title: Optional.none(),
	            items: []
	          }),
	          'overflow-button': renderIconButtonSpec({
	            name: 'more',
	            icon: Optional.some('more-drawer'),
	            disabled: false,
	            tooltip: Optional.some('More...'),
	            primary: false,
	            borderless: false
	          }, Optional.none(), toolbarSpec.providers)
	        },
	        splitToolbarBehaviours: getToolbarbehaviours(toolbarSpec, modeName)
	      };
	    };
	    var renderFloatingMoreToolbar = function (toolbarSpec) {
	      var baseSpec = renderMoreToolbarCommon(toolbarSpec);
	      var overflowXOffset = 4;
	      var primary = SplitFloatingToolbar.parts.primary({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar__primary']
	        }
	      });
	      return SplitFloatingToolbar.sketch(__assign(__assign({}, baseSpec), {
	        lazySink: toolbarSpec.getSink,
	        getOverflowBounds: function () {
	          var headerElem = toolbarSpec.moreDrawerData.lazyHeader().element;
	          var headerBounds = absolute$2(headerElem);
	          var docElem = documentElement(headerElem);
	          var docBounds = absolute$2(docElem);
	          var height = Math.max(docElem.dom.scrollHeight, docBounds.height);
	          return bounds(headerBounds.x + overflowXOffset, docBounds.y, headerBounds.width - overflowXOffset * 2, height);
	        },
	        parts: __assign(__assign({}, baseSpec.parts), {
	          overflow: {
	            dom: {
	              tag: 'div',
	              classes: ['tox-toolbar__overflow'],
	              attributes: toolbarSpec.attributes
	            }
	          }
	        }),
	        components: [primary],
	        markers: { overflowToggledClass: 'tox-tbtn--enabled' }
	      }));
	    };
	    var renderSlidingMoreToolbar = function (toolbarSpec) {
	      var primary = SplitSlidingToolbar.parts.primary({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar__primary']
	        }
	      });
	      var overflow = SplitSlidingToolbar.parts.overflow({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar__overflow']
	        }
	      });
	      var baseSpec = renderMoreToolbarCommon(toolbarSpec);
	      return SplitSlidingToolbar.sketch(__assign(__assign({}, baseSpec), {
	        components: [
	          primary,
	          overflow
	        ],
	        markers: {
	          openClass: 'tox-toolbar__overflow--open',
	          closedClass: 'tox-toolbar__overflow--closed',
	          growingClass: 'tox-toolbar__overflow--growing',
	          shrinkingClass: 'tox-toolbar__overflow--shrinking',
	          overflowToggledClass: 'tox-tbtn--enabled'
	        },
	        onOpened: function (comp) {
	          comp.getSystem().broadcastOn([toolbarHeightChange()], { type: 'opened' });
	        },
	        onClosed: function (comp) {
	          comp.getSystem().broadcastOn([toolbarHeightChange()], { type: 'closed' });
	        }
	      }));
	    };
	    var renderToolbar = function (toolbarSpec) {
	      var modeName = toolbarSpec.cyclicKeying ? 'cyclic' : 'acyclic';
	      return Toolbar.sketch({
	        uid: toolbarSpec.uid,
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar'].concat(toolbarSpec.type === ToolbarMode.scrolling ? ['tox-toolbar--scrolling'] : [])
	        },
	        components: [Toolbar.parts.groups({})],
	        toolbarBehaviours: getToolbarbehaviours(toolbarSpec, modeName)
	      });
	    };
	
	    var factory$6 = function (detail, components, _spec) {
	      var apis = {
	        getSocket: function (comp) {
	          return parts$a.getPart(comp, detail, 'socket');
	        },
	        setSidebar: function (comp, panelConfigs) {
	          parts$a.getPart(comp, detail, 'sidebar').each(function (sidebar) {
	            return setSidebar(sidebar, panelConfigs);
	          });
	        },
	        toggleSidebar: function (comp, name) {
	          parts$a.getPart(comp, detail, 'sidebar').each(function (sidebar) {
	            return toggleSidebar(sidebar, name);
	          });
	        },
	        whichSidebar: function (comp) {
	          return parts$a.getPart(comp, detail, 'sidebar').bind(whichSidebar).getOrNull();
	        },
	        getHeader: function (comp) {
	          return parts$a.getPart(comp, detail, 'header');
	        },
	        getToolbar: function (comp) {
	          return parts$a.getPart(comp, detail, 'toolbar');
	        },
	        setToolbar: function (comp, groups) {
	          parts$a.getPart(comp, detail, 'toolbar').each(function (toolbar) {
	            toolbar.getApis().setGroups(toolbar, groups);
	          });
	        },
	        setToolbars: function (comp, toolbars) {
	          parts$a.getPart(comp, detail, 'multiple-toolbar').each(function (mToolbar) {
	            CustomList.setItems(mToolbar, toolbars);
	          });
	        },
	        refreshToolbar: function (comp) {
	          var toolbar = parts$a.getPart(comp, detail, 'toolbar');
	          toolbar.each(function (toolbar) {
	            return toolbar.getApis().refresh(toolbar);
	          });
	        },
	        toggleToolbarDrawer: function (comp) {
	          parts$a.getPart(comp, detail, 'toolbar').each(function (toolbar) {
	            mapFrom(toolbar.getApis().toggle, function (toggle) {
	              return toggle(toolbar);
	            });
	          });
	        },
	        isToolbarDrawerToggled: function (comp) {
	          return parts$a.getPart(comp, detail, 'toolbar').bind(function (toolbar) {
	            return Optional.from(toolbar.getApis().isOpen).map(function (isOpen) {
	              return isOpen(toolbar);
	            });
	          }).getOr(false);
	        },
	        getThrobber: function (comp) {
	          return parts$a.getPart(comp, detail, 'throbber');
	        },
	        focusToolbar: function (comp) {
	          var optToolbar = parts$a.getPart(comp, detail, 'toolbar').orThunk(function () {
	            return parts$a.getPart(comp, detail, 'multiple-toolbar');
	          });
	          optToolbar.each(function (toolbar) {
	            Keying.focusIn(toolbar);
	          });
	        },
	        setMenubar: function (comp, menus) {
	          parts$a.getPart(comp, detail, 'menubar').each(function (menubar) {
	            SilverMenubar.setMenus(menubar, menus);
	          });
	        },
	        focusMenubar: function (comp) {
	          parts$a.getPart(comp, detail, 'menubar').each(function (menubar) {
	            SilverMenubar.focus(menubar);
	          });
	        }
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        apis: apis,
	        behaviours: detail.behaviours
	      };
	    };
	    var partMenubar = partType.optional({
	      factory: SilverMenubar,
	      name: 'menubar',
	      schema: [required$1('backstage')]
	    });
	    var toolbarFactory = function (spec) {
	      if (spec.type === ToolbarMode.sliding) {
	        return renderSlidingMoreToolbar;
	      } else if (spec.type === ToolbarMode.floating) {
	        return renderFloatingMoreToolbar;
	      } else {
	        return renderToolbar;
	      }
	    };
	    var partMultipleToolbar = partType.optional({
	      factory: {
	        sketch: function (spec) {
	          return CustomList.sketch({
	            uid: spec.uid,
	            dom: spec.dom,
	            listBehaviours: derive$1([Keying.config({
	                mode: 'acyclic',
	                selector: '.tox-toolbar'
	              })]),
	            makeItem: function () {
	              return renderToolbar({
	                type: spec.type,
	                uid: generate$6('multiple-toolbar-item'),
	                cyclicKeying: false,
	                initGroups: [],
	                providers: spec.providers,
	                onEscape: function () {
	                  spec.onEscape();
	                  return Optional.some(true);
	                }
	              });
	            },
	            setupItem: function (_mToolbar, tc, data, _index) {
	              Toolbar.setGroups(tc, data);
	            },
	            shell: true
	          });
	        }
	      },
	      name: 'multiple-toolbar',
	      schema: [
	        required$1('dom'),
	        required$1('onEscape')
	      ]
	    });
	    var partToolbar = partType.optional({
	      factory: {
	        sketch: function (spec) {
	          var renderer = toolbarFactory(spec);
	          var toolbarSpec = {
	            type: spec.type,
	            uid: spec.uid,
	            onEscape: function () {
	              spec.onEscape();
	              return Optional.some(true);
	            },
	            cyclicKeying: false,
	            initGroups: [],
	            getSink: spec.getSink,
	            providers: spec.providers,
	            moreDrawerData: {
	              lazyToolbar: spec.lazyToolbar,
	              lazyMoreButton: spec.lazyMoreButton,
	              lazyHeader: spec.lazyHeader
	            },
	            attributes: spec.attributes
	          };
	          return renderer(toolbarSpec);
	        }
	      },
	      name: 'toolbar',
	      schema: [
	        required$1('dom'),
	        required$1('onEscape'),
	        required$1('getSink')
	      ]
	    });
	    var partHeader = partType.optional({
	      factory: { sketch: renderHeader },
	      name: 'header',
	      schema: [required$1('dom')]
	    });
	    var partSocket = partType.optional({
	      name: 'socket',
	      schema: [required$1('dom')]
	    });
	    var partSidebar = partType.optional({
	      factory: { sketch: renderSidebar },
	      name: 'sidebar',
	      schema: [required$1('dom')]
	    });
	    var partThrobber = partType.optional({
	      factory: { sketch: renderThrobber },
	      name: 'throbber',
	      schema: [required$1('dom')]
	    });
	    var OuterContainer = composite({
	      name: 'OuterContainer',
	      factory: factory$6,
	      configFields: [
	        required$1('dom'),
	        required$1('behaviours')
	      ],
	      partFields: [
	        partHeader,
	        partMenubar,
	        partToolbar,
	        partMultipleToolbar,
	        partSocket,
	        partSidebar,
	        partThrobber
	      ],
	      apis: {
	        getSocket: function (apis, comp) {
	          return apis.getSocket(comp);
	        },
	        setSidebar: function (apis, comp, panelConfigs) {
	          apis.setSidebar(comp, panelConfigs);
	        },
	        toggleSidebar: function (apis, comp, name) {
	          apis.toggleSidebar(comp, name);
	        },
	        whichSidebar: function (apis, comp) {
	          return apis.whichSidebar(comp);
	        },
	        getHeader: function (apis, comp) {
	          return apis.getHeader(comp);
	        },
	        getToolbar: function (apis, comp) {
	          return apis.getToolbar(comp);
	        },
	        setToolbar: function (apis, comp, grps) {
	          var groups = map$2(grps, function (grp) {
	            return renderToolbarGroup(grp);
	          });
	          apis.setToolbar(comp, groups);
	        },
	        setToolbars: function (apis, comp, ts) {
	          var renderedToolbars = map$2(ts, function (g) {
	            return map$2(g, renderToolbarGroup);
	          });
	          apis.setToolbars(comp, renderedToolbars);
	        },
	        refreshToolbar: function (apis, comp) {
	          return apis.refreshToolbar(comp);
	        },
	        toggleToolbarDrawer: function (apis, comp) {
	          apis.toggleToolbarDrawer(comp);
	        },
	        isToolbarDrawerToggled: function (apis, comp) {
	          return apis.isToolbarDrawerToggled(comp);
	        },
	        getThrobber: function (apis, comp) {
	          return apis.getThrobber(comp);
	        },
	        setMenubar: function (apis, comp, menus) {
	          apis.setMenubar(comp, menus);
	        },
	        focusMenubar: function (apis, comp) {
	          apis.focusMenubar(comp);
	        },
	        focusToolbar: function (apis, comp) {
	          apis.focusToolbar(comp);
	        }
	      }
	    });
	
	    var defaultMenubar = 'file edit view insert format tools table help';
	    var defaultMenus = {
	      file: {
	        title: 'File',
	        items: 'newdocument restoredraft | preview | export print | deleteallconversations'
	      },
	      edit: {
	        title: 'Edit',
	        items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
	      },
	      view: {
	        title: 'View',
	        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
	      },
	      insert: {
	        title: 'Insert',
	        items: 'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime'
	      },
	      format: {
	        title: 'Format',
	        items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | language | removeformat'
	      },
	      tools: {
	        title: 'Tools',
	        items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount'
	      },
	      table: {
	        title: 'Table',
	        items: 'inserttable | cell row column | advtablesort | tableprops deletetable'
	      },
	      help: {
	        title: 'Help',
	        items: 'help'
	      }
	    };
	    var make = function (menu, registry, editor) {
	      var removedMenuItems = getRemovedMenuItems(editor).split(/[ ,]/);
	      return {
	        text: menu.title,
	        getItems: function () {
	          return bind$3(menu.items, function (i) {
	            var itemName = i.toLowerCase();
	            if (itemName.trim().length === 0) {
	              return [];
	            } else if (exists(removedMenuItems, function (removedMenuItem) {
	                return removedMenuItem === itemName;
	              })) {
	              return [];
	            } else if (itemName === 'separator' || itemName === '|') {
	              return [{ type: 'separator' }];
	            } else if (registry.menuItems[itemName]) {
	              return [registry.menuItems[itemName]];
	            } else {
	              return [];
	            }
	          });
	        }
	      };
	    };
	    var parseItemsString = function (items) {
	      if (typeof items === 'string') {
	        return items.split(' ');
	      }
	      return items;
	    };
	    var identifyMenus = function (editor, registry) {
	      var rawMenuData = __assign(__assign({}, defaultMenus), registry.menus);
	      var userDefinedMenus = keys(registry.menus).length > 0;
	      var menubar = registry.menubar === undefined || registry.menubar === true ? parseItemsString(defaultMenubar) : parseItemsString(registry.menubar === false ? '' : registry.menubar);
	      var validMenus = filter$2(menubar, function (menuName) {
	        var isDefaultMenu = has$2(defaultMenus, menuName);
	        if (userDefinedMenus) {
	          return isDefaultMenu || get$e(registry.menus, menuName).exists(function (menu) {
	            return has$2(menu, 'items');
	          });
	        } else {
	          return isDefaultMenu;
	        }
	      });
	      var menus = map$2(validMenus, function (menuName) {
	        var menuData = rawMenuData[menuName];
	        return make({
	          title: menuData.title,
	          items: parseItemsString(menuData.items)
	        }, registry, editor);
	      });
	      return filter$2(menus, function (menu) {
	        var isNotSeparator = function (item) {
	          return item.type !== 'separator';
	        };
	        return menu.getItems().length > 0 && exists(menu.getItems(), isNotSeparator);
	      });
	    };
	
	    var fireSkinLoaded = function (editor) {
	      var done = function () {
	        editor._skinLoaded = true;
	        fireSkinLoaded$1(editor);
	      };
	      return function () {
	        if (editor.initialized) {
	          done();
	        } else {
	          editor.on('init', done);
	        }
	      };
	    };
	    var fireSkinLoadError = function (editor, err) {
	      return function () {
	        return fireSkinLoadError$1(editor, { message: err });
	      };
	    };
	
	    var loadStylesheet = function (editor, stylesheetUrl, styleSheetLoader) {
	      return new global$c(function (resolve, reject) {
	        styleSheetLoader.load(stylesheetUrl, resolve, reject);
	        editor.on('remove', function () {
	          return styleSheetLoader.unload(stylesheetUrl);
	        });
	      });
	    };
	    var loadUiSkins = function (editor, skinUrl) {
	      var skinUiCss = skinUrl + '/skin.min.css';
	      return loadStylesheet(editor, skinUiCss, editor.ui.styleSheetLoader);
	    };
	    var loadShadowDomUiSkins = function (editor, skinUrl) {
	      var isInShadowRoot$1 = isInShadowRoot(SugarElement.fromDom(editor.getElement()));
	      if (isInShadowRoot$1) {
	        var shadowDomSkinCss = skinUrl + '/skin.shadowdom.min.css';
	        return loadStylesheet(editor, shadowDomSkinCss, global$b.DOM.styleSheetLoader);
	      } else {
	        return global$c.resolve();
	      }
	    };
	    var loadSkin = function (isInline, editor) {
	      var skinUrl = getSkinUrl(editor);
	      if (skinUrl) {
	        editor.contentCSS.push(skinUrl + (isInline ? '/content.inline' : '/content') + '.min.css');
	      }
	      if (isSkinDisabled(editor) === false && isString(skinUrl)) {
	        global$c.all([
	          loadUiSkins(editor, skinUrl),
	          loadShadowDomUiSkins(editor, skinUrl)
	        ]).then(fireSkinLoaded(editor), fireSkinLoadError(editor, 'Skin could not be loaded'));
	      } else {
	        fireSkinLoaded(editor)();
	      }
	    };
	    var iframe = curry(loadSkin, false);
	    var inline = curry(loadSkin, true);
	
	    var onSetupFormatToggle = function (editor, name) {
	      return function (api) {
	        var boundCallback = unbindable();
	        var init = function () {
	          api.setActive(editor.formatter.match(name));
	          var binding = editor.formatter.formatChanged(name, api.setActive);
	          boundCallback.set(binding);
	        };
	        editor.initialized ? init() : editor.once('init', init);
	        return function () {
	          editor.off('init', init);
	          boundCallback.clear();
	        };
	      };
	    };
	    var onSetupEvent = function (editor, event, f) {
	      return function (api) {
	        var handleEvent = function () {
	          return f(api);
	        };
	        var init = function () {
	          f(api);
	          editor.on(event, handleEvent);
	        };
	        editor.initialized ? init() : editor.once('init', init);
	        return function () {
	          editor.off('init', init);
	          editor.off(event, handleEvent);
	        };
	      };
	    };
	    var onActionToggleFormat$1 = function (editor) {
	      return function (rawItem) {
	        return function () {
	          editor.undoManager.transact(function () {
	            editor.focus();
	            editor.execCommand('mceToggleFormat', false, rawItem.format);
	          });
	        };
	      };
	    };
	    var onActionExecCommand = function (editor, command) {
	      return function () {
	        return editor.execCommand(command);
	      };
	    };
	
	    var generateSelectItems = function (_editor, backstage, spec) {
	      var generateItem = function (rawItem, response, disabled, value) {
	        var translatedText = backstage.shared.providers.translate(rawItem.title);
	        if (rawItem.type === 'separator') {
	          return Optional.some({
	            type: 'separator',
	            text: translatedText
	          });
	        } else if (rawItem.type === 'submenu') {
	          var items = bind$3(rawItem.getStyleItems(), function (si) {
	            return validate(si, response, value);
	          });
	          if (response === 0 && items.length <= 0) {
	            return Optional.none();
	          } else {
	            return Optional.some({
	              type: 'nestedmenuitem',
	              text: translatedText,
	              disabled: items.length <= 0,
	              getSubmenuItems: function () {
	                return bind$3(rawItem.getStyleItems(), function (si) {
	                  return validate(si, response, value);
	                });
	              }
	            });
	          }
	        } else {
	          return Optional.some(__assign({
	            type: 'togglemenuitem',
	            text: translatedText,
	            icon: rawItem.icon,
	            active: rawItem.isSelected(value),
	            disabled: disabled,
	            onAction: spec.onAction(rawItem)
	          }, rawItem.getStylePreview().fold(function () {
	            return {};
	          }, function (preview) {
	            return { meta: { style: preview } };
	          })));
	        }
	      };
	      var validate = function (item, response, value) {
	        var invalid = item.type === 'formatter' && spec.isInvalid(item);
	        if (response === 0) {
	          return invalid ? [] : generateItem(item, response, false, value).toArray();
	        } else {
	          return generateItem(item, response, invalid, value).toArray();
	        }
	      };
	      var validateItems = function (preItems) {
	        var value = spec.getCurrentValue();
	        var response = spec.shouldHide ? 0 : 1;
	        return bind$3(preItems, function (item) {
	          return validate(item, response, value);
	        });
	      };
	      var getFetch = function (backstage, getStyleItems) {
	        return function (comp, callback) {
	          var preItems = getStyleItems();
	          var items = validateItems(preItems);
	          var menu = build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false);
	          callback(menu);
	        };
	      };
	      return {
	        validateItems: validateItems,
	        getFetch: getFetch
	      };
	    };
	    var createMenuItems = function (editor, backstage, spec) {
	      var dataset = spec.dataset;
	      var getStyleItems = dataset.type === 'basic' ? function () {
	        return map$2(dataset.data, function (d) {
	          return processBasic(d, spec.isSelectedFor, spec.getPreviewFor);
	        });
	      } : dataset.getData;
	      return {
	        items: generateSelectItems(editor, backstage, spec),
	        getStyleItems: getStyleItems
	      };
	    };
	    var createSelectButton = function (editor, backstage, spec) {
	      var _a = createMenuItems(editor, backstage, spec), items = _a.items, getStyleItems = _a.getStyleItems;
	      var getApi = function (comp) {
	        return { getComponent: constant$1(comp) };
	      };
	      var onSetup = onSetupEvent(editor, 'NodeChange', function (api) {
	        var comp = api.getComponent();
	        spec.updateText(comp);
	      });
	      return renderCommonDropdown({
	        text: spec.icon.isSome() ? Optional.none() : spec.text,
	        icon: spec.icon,
	        tooltip: Optional.from(spec.tooltip),
	        role: Optional.none(),
	        fetch: items.getFetch(backstage, getStyleItems),
	        onSetup: onSetup,
	        getApi: getApi,
	        columns: 1,
	        presets: 'normal',
	        classes: spec.icon.isSome() ? [] : ['bespoke'],
	        dropdownBehaviours: []
	      }, 'tox-tbtn', backstage.shared);
	    };
	
	    var process = function (rawFormats) {
	      return map$2(rawFormats, function (item) {
	        var title = item, format = item;
	        var values = item.split('=');
	        if (values.length > 1) {
	          title = values[0];
	          format = values[1];
	        }
	        return {
	          title: title,
	          format: format
	        };
	      });
	    };
	    var buildBasicStaticDataset = function (data) {
	      return {
	        type: 'basic',
	        data: data
	      };
	    };
	    var Delimiter;
	    (function (Delimiter) {
	      Delimiter[Delimiter['SemiColon'] = 0] = 'SemiColon';
	      Delimiter[Delimiter['Space'] = 1] = 'Space';
	    }(Delimiter || (Delimiter = {})));
	    var split = function (rawFormats, delimiter) {
	      if (delimiter === Delimiter.SemiColon) {
	        return rawFormats.replace(/;$/, '').split(';');
	      } else {
	        return rawFormats.split(' ');
	      }
	    };
	    var buildBasicSettingsDataset = function (editor, settingName, defaults, delimiter) {
	      var rawFormats = editor.getParam(settingName, defaults, 'string');
	      var data = process(split(rawFormats, delimiter));
	      return {
	        type: 'basic',
	        data: data
	      };
	    };
	
	    var alignMenuItems = [
	      {
	        title: 'Left',
	        icon: 'align-left',
	        format: 'alignleft',
	        command: 'JustifyLeft'
	      },
	      {
	        title: 'Center',
	        icon: 'align-center',
	        format: 'aligncenter',
	        command: 'JustifyCenter'
	      },
	      {
	        title: 'Right',
	        icon: 'align-right',
	        format: 'alignright',
	        command: 'JustifyRight'
	      },
	      {
	        title: 'Justify',
	        icon: 'align-justify',
	        format: 'alignjustify',
	        command: 'JustifyFull'
	      }
	    ];
	    var getSpec$4 = function (editor) {
	      var getMatchingValue = function () {
	        return find$5(alignMenuItems, function (item) {
	          return editor.formatter.match(item.format);
	        });
	      };
	      var isSelectedFor = function (format) {
	        return function () {
	          return editor.formatter.match(format);
	        };
	      };
	      var getPreviewFor = function (_format) {
	        return Optional.none;
	      };
	      var updateSelectMenuIcon = function (comp) {
	        var match = getMatchingValue();
	        var alignment = match.fold(constant$1('left'), function (item) {
	          return item.title.toLowerCase();
	        });
	        emitWith(comp, updateMenuIcon, { icon: 'align-' + alignment });
	      };
	      var dataset = buildBasicStaticDataset(alignMenuItems);
	      var onAction = function (rawItem) {
	        return function () {
	          return find$5(alignMenuItems, function (item) {
	            return item.format === rawItem.format;
	          }).each(function (item) {
	            return editor.execCommand(item.command);
	          });
	        };
	      };
	      return {
	        tooltip: 'Align',
	        text: Optional.none(),
	        icon: Optional.some('align-left'),
	        isSelectedFor: isSelectedFor,
	        getCurrentValue: Optional.none,
	        getPreviewFor: getPreviewFor,
	        onAction: onAction,
	        updateText: updateSelectMenuIcon,
	        dataset: dataset,
	        shouldHide: false,
	        isInvalid: function (item) {
	          return !editor.formatter.canApply(item.format);
	        }
	      };
	    };
	    var createAlignSelect = function (editor, backstage) {
	      return createSelectButton(editor, backstage, getSpec$4(editor));
	    };
	    var alignSelectMenu = function (editor, backstage) {
	      var menuItems = createMenuItems(editor, backstage, getSpec$4(editor));
	      editor.ui.registry.addNestedMenuItem('align', {
	        text: backstage.shared.providers.translate('Align'),
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var defaultFontsFormats = 'Andale Mono=andale mono,monospace;' + 'Arial=arial,helvetica,sans-serif;' + 'Arial Black=arial black,sans-serif;' + 'Book Antiqua=book antiqua,palatino,serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Courier New=courier new,courier,monospace;' + 'Georgia=georgia,palatino,serif;' + 'Helvetica=helvetica,arial,sans-serif;' + 'Impact=impact,sans-serif;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' + 'Terminal=terminal,monaco,monospace;' + 'Times New Roman=times new roman,times,serif;' + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;' + 'Verdana=verdana,geneva,sans-serif;' + 'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats';
	    var systemStackFonts = [
	      '-apple-system',
	      'Segoe UI',
	      'Roboto',
	      'Helvetica Neue',
	      'sans-serif'
	    ];
	    var splitFonts = function (fontFamily) {
	      var fonts = fontFamily.split(/\s*,\s*/);
	      return map$2(fonts, function (font) {
	        return font.replace(/^['"]+|['"]+$/g, '');
	      });
	    };
	    var isSystemFontStack = function (fontFamily) {
	      var matchesSystemStack = function () {
	        var fonts = splitFonts(fontFamily.toLowerCase());
	        return forall(systemStackFonts, function (font) {
	          return fonts.indexOf(font.toLowerCase()) > -1;
	        });
	      };
	      return fontFamily.indexOf('-apple-system') === 0 && matchesSystemStack();
	    };
	    var getSpec$3 = function (editor) {
	      var systemFont = 'System Font';
	      var getMatchingValue = function () {
	        var getFirstFont = function (fontFamily) {
	          return fontFamily ? splitFonts(fontFamily)[0] : '';
	        };
	        var fontFamily = editor.queryCommandValue('FontName');
	        var items = dataset.data;
	        var font = fontFamily ? fontFamily.toLowerCase() : '';
	        var matchOpt = find$5(items, function (item) {
	          var format = item.format;
	          return format.toLowerCase() === font || getFirstFont(format).toLowerCase() === getFirstFont(font).toLowerCase();
	        }).orThunk(function () {
	          return someIf(isSystemFontStack(font), {
	            title: systemFont,
	            format: font
	          });
	        });
	        return {
	          matchOpt: matchOpt,
	          font: fontFamily
	        };
	      };
	      var isSelectedFor = function (item) {
	        return function (valueOpt) {
	          return valueOpt.exists(function (value) {
	            return value.format === item;
	          });
	        };
	      };
	      var getCurrentValue = function () {
	        var matchOpt = getMatchingValue().matchOpt;
	        return matchOpt;
	      };
	      var getPreviewFor = function (item) {
	        return function () {
	          return Optional.some({
	            tag: 'div',
	            styles: item.indexOf('dings') === -1 ? { 'font-family': item } : {}
	          });
	        };
	      };
	      var onAction = function (rawItem) {
	        return function () {
	          editor.undoManager.transact(function () {
	            editor.focus();
	            editor.execCommand('FontName', false, rawItem.format);
	          });
	        };
	      };
	      var updateSelectMenuText = function (comp) {
	        var _a = getMatchingValue(), matchOpt = _a.matchOpt, font = _a.font;
	        var text = matchOpt.fold(constant$1(font), function (item) {
	          return item.title;
	        });
	        emitWith(comp, updateMenuText, { text: text });
	      };
	      var dataset = buildBasicSettingsDataset(editor, 'font_formats', defaultFontsFormats, Delimiter.SemiColon);
	      return {
	        tooltip: 'Fonts',
	        text: Optional.some(systemFont),
	        icon: Optional.none(),
	        isSelectedFor: isSelectedFor,
	        getCurrentValue: getCurrentValue,
	        getPreviewFor: getPreviewFor,
	        onAction: onAction,
	        updateText: updateSelectMenuText,
	        dataset: dataset,
	        shouldHide: false,
	        isInvalid: never
	      };
	    };
	    var createFontSelect = function (editor, backstage) {
	      return createSelectButton(editor, backstage, getSpec$3(editor));
	    };
	    var fontSelectMenu = function (editor, backstage) {
	      var menuItems = createMenuItems(editor, backstage, getSpec$3(editor));
	      editor.ui.registry.addNestedMenuItem('fontformats', {
	        text: backstage.shared.providers.translate('Fonts'),
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
	    var legacyFontSizes = {
	      '8pt': '1',
	      '10pt': '2',
	      '12pt': '3',
	      '14pt': '4',
	      '18pt': '5',
	      '24pt': '6',
	      '36pt': '7'
	    };
	    var keywordFontSizes = {
	      'xx-small': '7pt',
	      'x-small': '8pt',
	      'small': '10pt',
	      'medium': '12pt',
	      'large': '14pt',
	      'x-large': '18pt',
	      'xx-large': '24pt'
	    };
	    var round = function (number, precision) {
	      var factor = Math.pow(10, precision);
	      return Math.round(number * factor) / factor;
	    };
	    var toPt = function (fontSize, precision) {
	      if (/[0-9.]+px$/.test(fontSize)) {
	        return round(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
	      } else {
	        return get$e(keywordFontSizes, fontSize).getOr(fontSize);
	      }
	    };
	    var toLegacy = function (fontSize) {
	      return get$e(legacyFontSizes, fontSize).getOr('');
	    };
	    var getSpec$2 = function (editor) {
	      var getMatchingValue = function () {
	        var matchOpt = Optional.none();
	        var items = dataset.data;
	        var fontSize = editor.queryCommandValue('FontSize');
	        if (fontSize) {
	          var _loop_1 = function (precision) {
	            var pt = toPt(fontSize, precision);
	            var legacy = toLegacy(pt);
	            matchOpt = find$5(items, function (item) {
	              return item.format === fontSize || item.format === pt || item.format === legacy;
	            });
	          };
	          for (var precision = 3; matchOpt.isNone() && precision >= 0; precision--) {
	            _loop_1(precision);
	          }
	        }
	        return {
	          matchOpt: matchOpt,
	          size: fontSize
	        };
	      };
	      var isSelectedFor = function (item) {
	        return function (valueOpt) {
	          return valueOpt.exists(function (value) {
	            return value.format === item;
	          });
	        };
	      };
	      var getCurrentValue = function () {
	        var matchOpt = getMatchingValue().matchOpt;
	        return matchOpt;
	      };
	      var getPreviewFor = constant$1(Optional.none);
	      var onAction = function (rawItem) {
	        return function () {
	          editor.undoManager.transact(function () {
	            editor.focus();
	            editor.execCommand('FontSize', false, rawItem.format);
	          });
	        };
	      };
	      var updateSelectMenuText = function (comp) {
	        var _a = getMatchingValue(), matchOpt = _a.matchOpt, size = _a.size;
	        var text = matchOpt.fold(constant$1(size), function (match) {
	          return match.title;
	        });
	        emitWith(comp, updateMenuText, { text: text });
	      };
	      var dataset = buildBasicSettingsDataset(editor, 'fontsize_formats', defaultFontsizeFormats, Delimiter.Space);
	      return {
	        tooltip: 'Font sizes',
	        text: Optional.some('12pt'),
	        icon: Optional.none(),
	        isSelectedFor: isSelectedFor,
	        getPreviewFor: getPreviewFor,
	        getCurrentValue: getCurrentValue,
	        onAction: onAction,
	        updateText: updateSelectMenuText,
	        dataset: dataset,
	        shouldHide: false,
	        isInvalid: never
	      };
	    };
	    var createFontsizeSelect = function (editor, backstage) {
	      return createSelectButton(editor, backstage, getSpec$2(editor));
	    };
	    var fontsizeSelectMenu = function (editor, backstage) {
	      var menuItems = createMenuItems(editor, backstage, getSpec$2(editor));
	      editor.ui.registry.addNestedMenuItem('fontsizes', {
	        text: 'Font sizes',
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var findNearest = function (editor, getStyles) {
	      var styles = getStyles();
	      var formats = map$2(styles, function (style) {
	        return style.format;
	      });
	      return Optional.from(editor.formatter.closest(formats)).bind(function (fmt) {
	        return find$5(styles, function (data) {
	          return data.format === fmt;
	        });
	      }).orThunk(function () {
	        return someIf(editor.formatter.match('p'), {
	          title: 'Paragraph',
	          format: 'p'
	        });
	      });
	    };
	
	    var defaultBlocks = 'Paragraph=p;' + 'Heading 1=h1;' + 'Heading 2=h2;' + 'Heading 3=h3;' + 'Heading 4=h4;' + 'Heading 5=h5;' + 'Heading 6=h6;' + 'Preformatted=pre';
	    var getSpec$1 = function (editor) {
	      var fallbackFormat = 'Paragraph';
	      var isSelectedFor = function (format) {
	        return function () {
	          return editor.formatter.match(format);
	        };
	      };
	      var getPreviewFor = function (format) {
	        return function () {
	          var fmt = editor.formatter.get(format);
	          return Optional.some({
	            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
	            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
	          });
	        };
	      };
	      var updateSelectMenuText = function (comp) {
	        var detectedFormat = findNearest(editor, function () {
	          return dataset.data;
	        });
	        var text = detectedFormat.fold(constant$1(fallbackFormat), function (fmt) {
	          return fmt.title;
	        });
	        emitWith(comp, updateMenuText, { text: text });
	      };
	      var dataset = buildBasicSettingsDataset(editor, 'block_formats', defaultBlocks, Delimiter.SemiColon);
	      return {
	        tooltip: 'Blocks',
	        text: Optional.some(fallbackFormat),
	        icon: Optional.none(),
	        isSelectedFor: isSelectedFor,
	        getCurrentValue: Optional.none,
	        getPreviewFor: getPreviewFor,
	        onAction: onActionToggleFormat$1(editor),
	        updateText: updateSelectMenuText,
	        dataset: dataset,
	        shouldHide: false,
	        isInvalid: function (item) {
	          return !editor.formatter.canApply(item.format);
	        }
	      };
	    };
	    var createFormatSelect = function (editor, backstage) {
	      return createSelectButton(editor, backstage, getSpec$1(editor));
	    };
	    var formatSelectMenu = function (editor, backstage) {
	      var menuItems = createMenuItems(editor, backstage, getSpec$1(editor));
	      editor.ui.registry.addNestedMenuItem('blockformats', {
	        text: 'Blocks',
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var getSpec = function (editor, dataset) {
	      var fallbackFormat = 'Paragraph';
	      var isSelectedFor = function (format) {
	        return function () {
	          return editor.formatter.match(format);
	        };
	      };
	      var getPreviewFor = function (format) {
	        return function () {
	          var fmt = editor.formatter.get(format);
	          return fmt !== undefined ? Optional.some({
	            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
	            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
	          }) : Optional.none();
	        };
	      };
	      var updateSelectMenuText = function (comp) {
	        var getFormatItems = function (fmt) {
	          var subs = fmt.items;
	          return subs !== undefined && subs.length > 0 ? bind$3(subs, getFormatItems) : [{
	              title: fmt.title,
	              format: fmt.format
	            }];
	        };
	        var flattenedItems = bind$3(getStyleFormats(editor), getFormatItems);
	        var detectedFormat = findNearest(editor, constant$1(flattenedItems));
	        var text = detectedFormat.fold(constant$1(fallbackFormat), function (fmt) {
	          return fmt.title;
	        });
	        emitWith(comp, updateMenuText, { text: text });
	      };
	      return {
	        tooltip: 'Formats',
	        text: Optional.some(fallbackFormat),
	        icon: Optional.none(),
	        isSelectedFor: isSelectedFor,
	        getCurrentValue: Optional.none,
	        getPreviewFor: getPreviewFor,
	        onAction: onActionToggleFormat$1(editor),
	        updateText: updateSelectMenuText,
	        shouldHide: editor.getParam('style_formats_autohide', false, 'boolean'),
	        isInvalid: function (item) {
	          return !editor.formatter.canApply(item.format);
	        },
	        dataset: dataset
	      };
	    };
	    var createStyleSelect = function (editor, backstage) {
	      var dataset = __assign({ type: 'advanced' }, backstage.styleselect);
	      return createSelectButton(editor, backstage, getSpec(editor, dataset));
	    };
	    var styleSelectMenu = function (editor, backstage) {
	      var dataset = __assign({ type: 'advanced' }, backstage.styleselect);
	      var menuItems = createMenuItems(editor, backstage, getSpec(editor, dataset));
	      editor.ui.registry.addNestedMenuItem('formats', {
	        text: 'Formats',
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var events$3 = function (reflectingConfig, reflectingState) {
	      var update = function (component, data) {
	        reflectingConfig.updateState.each(function (updateState) {
	          var newState = updateState(component, data);
	          reflectingState.set(newState);
	        });
	        reflectingConfig.renderComponents.each(function (renderComponents) {
	          var newComponents = renderComponents(data, reflectingState.get());
	          var newChildren = map$2(newComponents, component.getSystem().build);
	          replaceChildren(component, newChildren);
	        });
	      };
	      return derive$2([
	        run$1(receive(), function (component, message) {
	          var receivingData = message;
	          if (!receivingData.universal) {
	            var channel = reflectingConfig.channel;
	            if (contains$2(receivingData.channels, channel)) {
	              update(component, receivingData.data);
	            }
	          }
	        }),
	        runOnAttached(function (comp, _se) {
	          reflectingConfig.initialData.each(function (rawData) {
	            update(comp, rawData);
	          });
	        })
	      ]);
	    };
	
	    var ActiveReflecting = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$3
	    });
	
	    var getState = function (component, replaceConfig, reflectState) {
	      return reflectState;
	    };
	
	    var ReflectingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getState: getState
	    });
	
	    var ReflectingSchema = [
	      required$1('channel'),
	      option('renderComponents'),
	      option('updateState'),
	      option('initialData')
	    ];
	
	    var init$3 = function () {
	      var cell = Cell(Optional.none());
	      var clear = function () {
	        return cell.set(Optional.none());
	      };
	      var readState = function () {
	        return cell.get().getOr('none');
	      };
	      return {
	        readState: readState,
	        get: cell.get,
	        set: cell.set,
	        clear: clear
	      };
	    };
	
	    var ReflectingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$3
	    });
	
	    var Reflecting = create$8({
	      fields: ReflectingSchema,
	      name: 'reflecting',
	      active: ActiveReflecting,
	      apis: ReflectingApis,
	      state: ReflectingState
	    });
	
	    var schema$7 = constant$1([
	      required$1('toggleClass'),
	      required$1('fetch'),
	      onStrictHandler('onExecute'),
	      defaulted('getHotspot', Optional.some),
	      defaulted('getAnchorOverrides', constant$1({})),
	      schema$y(),
	      onStrictHandler('onItemExecute'),
	      option('lazySink'),
	      required$1('dom'),
	      onHandler('onOpen'),
	      field('splitDropdownBehaviours', [
	        Coupling,
	        Keying,
	        Focusing
	      ]),
	      defaulted('matchWidth', false),
	      defaulted('useMinWidth', false),
	      defaulted('eventOrder', {}),
	      option('role')
	    ].concat(sandboxFields()));
	    var arrowPart = required({
	      factory: Button,
	      schema: [required$1('dom')],
	      name: 'arrow',
	      defaults: function () {
	        return { buttonBehaviours: derive$1([Focusing.revoke()]) };
	      },
	      overrides: function (detail) {
	        return {
	          dom: {
	            tag: 'span',
	            attributes: { role: 'presentation' }
	          },
	          action: function (arrow) {
	            arrow.getSystem().getByUid(detail.uid).each(emitExecute);
	          },
	          buttonBehaviours: derive$1([Toggling.config({
	              toggleOnExecute: false,
	              toggleClass: detail.toggleClass
	            })])
	        };
	      }
	    });
	    var buttonPart = required({
	      factory: Button,
	      schema: [required$1('dom')],
	      name: 'button',
	      defaults: function () {
	        return { buttonBehaviours: derive$1([Focusing.revoke()]) };
	      },
	      overrides: function (detail) {
	        return {
	          dom: {
	            tag: 'span',
	            attributes: { role: 'presentation' }
	          },
	          action: function (btn) {
	            btn.getSystem().getByUid(detail.uid).each(function (splitDropdown) {
	              detail.onExecute(splitDropdown, btn);
	            });
	          }
	        };
	      }
	    });
	    var parts$3 = constant$1([
	      arrowPart,
	      buttonPart,
	      optional({
	        factory: {
	          sketch: function (spec) {
	            return {
	              uid: spec.uid,
	              dom: {
	                tag: 'span',
	                styles: { display: 'none' },
	                attributes: { 'aria-hidden': 'true' },
	                innerHtml: spec.text
	              }
	            };
	          }
	        },
	        schema: [required$1('text')],
	        name: 'aria-descriptor'
	      }),
	      external$1({
	        schema: [tieredMenuMarkers()],
	        name: 'menu',
	        defaults: function (detail) {
	          return {
	            onExecute: function (tmenu, item) {
	              tmenu.getSystem().getByUid(detail.uid).each(function (splitDropdown) {
	                detail.onItemExecute(splitDropdown, tmenu, item);
	              });
	            }
	          };
	        }
	      }),
	      partType$1()
	    ]);
	
	    var factory$5 = function (detail, components, spec, externals) {
	      var _a;
	      var switchToMenu = function (sandbox) {
	        Composing.getCurrent(sandbox).each(function (current) {
	          Highlighting.highlightFirst(current);
	          Keying.focusIn(current);
	        });
	      };
	      var action = function (component) {
	        var onOpenSync = switchToMenu;
	        togglePopup(detail, identity$1, component, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	      };
	      var openMenu = function (comp) {
	        action(comp);
	        return Optional.some(true);
	      };
	      var executeOnButton = function (comp) {
	        var button = getPartOrDie(comp, detail, 'button');
	        emitExecute(button);
	        return Optional.some(true);
	      };
	      var buttonEvents = __assign(__assign({}, derive$2([runOnAttached(function (component, _simulatedEvent) {
	          var ariaDescriptor = getPart(component, detail, 'aria-descriptor');
	          ariaDescriptor.each(function (descriptor) {
	            var descriptorId = generate$6('aria');
	            set$8(descriptor.element, 'id', descriptorId);
	            set$8(component.element, 'aria-describedby', descriptorId);
	          });
	        })])), events$a(Optional.some(action)));
	      var apis = {
	        repositionMenus: function (comp) {
	          if (Toggling.isOn(comp)) {
	            repositionMenus(comp);
	          }
	        }
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        apis: apis,
	        eventOrder: __assign(__assign({}, detail.eventOrder), (_a = {}, _a[execute$5()] = [
	          'disabling',
	          'toggling',
	          'alloy.base.behaviour'
	        ], _a)),
	        events: buttonEvents,
	        behaviours: augment(detail.splitDropdownBehaviours, [
	          Coupling.config({
	            others: {
	              sandbox: function (hotspot) {
	                var arrow = getPartOrDie(hotspot, detail, 'arrow');
	                var extras = {
	                  onOpen: function () {
	                    Toggling.on(arrow);
	                    Toggling.on(hotspot);
	                  },
	                  onClose: function () {
	                    Toggling.off(arrow);
	                    Toggling.off(hotspot);
	                  }
	                };
	                return makeSandbox$1(detail, hotspot, extras);
	              }
	            }
	          }),
	          Keying.config({
	            mode: 'special',
	            onSpace: executeOnButton,
	            onEnter: executeOnButton,
	            onDown: openMenu
	          }),
	          Focusing.config({}),
	          Toggling.config({
	            toggleOnExecute: false,
	            aria: { mode: 'expanded' }
	          })
	        ]),
	        domModification: {
	          attributes: {
	            'role': detail.role.getOr('button'),
	            'aria-haspopup': true
	          }
	        }
	      };
	    };
	    var SplitDropdown = composite({
	      name: 'SplitDropdown',
	      configFields: schema$7(),
	      partFields: parts$3(),
	      factory: factory$5,
	      apis: {
	        repositionMenus: function (apis, comp) {
	          return apis.repositionMenus(comp);
	        }
	      }
	    });
	
	    var getButtonApi = function (component) {
	      return {
	        isDisabled: function () {
	          return Disabling.isDisabled(component);
	        },
	        setDisabled: function (state) {
	          return Disabling.set(component, state);
	        }
	      };
	    };
	    var getToggleApi = function (component) {
	      return {
	        setActive: function (state) {
	          Toggling.set(component, state);
	        },
	        isActive: function () {
	          return Toggling.isOn(component);
	        },
	        isDisabled: function () {
	          return Disabling.isDisabled(component);
	        },
	        setDisabled: function (state) {
	          return Disabling.set(component, state);
	        }
	      };
	    };
	    var getTooltipAttributes = function (tooltip, providersBackstage) {
	      return tooltip.map(function (tooltip) {
	        return {
	          'aria-label': providersBackstage.translate(tooltip),
	          'title': providersBackstage.translate(tooltip)
	        };
	      }).getOr({});
	    };
	    var focusButtonEvent = generate$6('focus-button');
	    var renderCommonStructure = function (icon, text, tooltip, receiver, behaviours, providersBackstage) {
	      var _d;
	      return {
	        dom: {
	          tag: 'button',
	          classes: ['tox-tbtn'].concat(text.isSome() ? ['tox-tbtn--select'] : []),
	          attributes: getTooltipAttributes(tooltip, providersBackstage)
	        },
	        components: componentRenderPipeline([
	          icon.map(function (iconName) {
	            return renderIconFromPack(iconName, providersBackstage.icons);
	          }),
	          text.map(function (text) {
	            return renderLabel$1(text, 'tox-tbtn', providersBackstage);
	          })
	        ]),
	        eventOrder: (_d = {}, _d[mousedown()] = [
	          'focusing',
	          'alloy.base.behaviour',
	          'common-button-display-events'
	        ], _d),
	        buttonBehaviours: derive$1([
	          DisablingConfigs.toolbarButton(providersBackstage.isDisabled),
	          receivingConfig(),
	          config('common-button-display-events', [run$1(mousedown(), function (button, se) {
	              se.event.prevent();
	              emit(button, focusButtonEvent);
	            })])
	        ].concat(receiver.map(function (r) {
	          return Reflecting.config({
	            channel: r,
	            initialData: {
	              icon: icon,
	              text: text
	            },
	            renderComponents: function (data, _state) {
	              return componentRenderPipeline([
	                data.icon.map(function (iconName) {
	                  return renderIconFromPack(iconName, providersBackstage.icons);
	                }),
	                data.text.map(function (text) {
	                  return renderLabel$1(text, 'tox-tbtn', providersBackstage);
	                })
	              ]);
	            }
	          });
	        }).toArray()).concat(behaviours.getOr([])))
	      };
	    };
	    var renderFloatingToolbarButton = function (spec, backstage, identifyButtons, attributes) {
	      var sharedBackstage = backstage.shared;
	      return FloatingToolbarButton.sketch({
	        lazySink: sharedBackstage.getSink,
	        fetch: function () {
	          return Future.nu(function (resolve) {
	            resolve(map$2(identifyButtons(spec.items), renderToolbarGroup));
	          });
	        },
	        markers: { toggledClass: 'tox-tbtn--enabled' },
	        parts: {
	          button: renderCommonStructure(spec.icon, spec.text, spec.tooltip, Optional.none(), Optional.none(), sharedBackstage.providers),
	          toolbar: {
	            dom: {
	              tag: 'div',
	              classes: ['tox-toolbar__overflow'],
	              attributes: attributes
	            }
	          }
	        }
	      });
	    };
	    var renderCommonToolbarButton = function (spec, specialisation, providersBackstage) {
	      var editorOffCell = Cell(noop);
	      var structure = renderCommonStructure(spec.icon, spec.text, spec.tooltip, Optional.none(), Optional.none(), providersBackstage);
	      return Button.sketch({
	        dom: structure.dom,
	        components: structure.components,
	        eventOrder: toolbarButtonEventOrder,
	        buttonBehaviours: derive$1([
	          config('toolbar-button-events', [
	            onToolbarButtonExecute({
	              onAction: spec.onAction,
	              getApi: specialisation.getApi
	            }),
	            onControlAttached(specialisation, editorOffCell),
	            onControlDetached(specialisation, editorOffCell)
	          ]),
	          DisablingConfigs.toolbarButton(function () {
	            return spec.disabled || providersBackstage.isDisabled();
	          }),
	          receivingConfig()
	        ].concat(specialisation.toolbarButtonBehaviours))
	      });
	    };
	    var renderToolbarButton = function (spec, providersBackstage) {
	      return renderToolbarButtonWith(spec, providersBackstage, []);
	    };
	    var renderToolbarButtonWith = function (spec, providersBackstage, bonusEvents) {
	      return renderCommonToolbarButton(spec, {
	        toolbarButtonBehaviours: [].concat(bonusEvents.length > 0 ? [config('toolbarButtonWith', bonusEvents)] : []),
	        getApi: getButtonApi,
	        onSetup: spec.onSetup
	      }, providersBackstage);
	    };
	    var renderToolbarToggleButton = function (spec, providersBackstage) {
	      return renderToolbarToggleButtonWith(spec, providersBackstage, []);
	    };
	    var renderToolbarToggleButtonWith = function (spec, providersBackstage, bonusEvents) {
	      return deepMerge(renderCommonToolbarButton(spec, {
	        toolbarButtonBehaviours: [
	          Replacing.config({}),
	          Toggling.config({
	            toggleClass: 'tox-tbtn--enabled',
	            aria: { mode: 'pressed' },
	            toggleOnExecute: false
	          })
	        ].concat(bonusEvents.length > 0 ? [config('toolbarToggleButtonWith', bonusEvents)] : []),
	        getApi: getToggleApi,
	        onSetup: spec.onSetup
	      }, providersBackstage));
	    };
	    var fetchChoices = function (getApi, spec, providersBackstage) {
	      return function (comp) {
	        return Future.nu(function (callback) {
	          return spec.fetch(callback);
	        }).map(function (items) {
	          return Optional.from(createTieredDataFrom(deepMerge(createPartialChoiceMenu(generate$6('menu-value'), items, function (value) {
	            spec.onItemAction(getApi(comp), value);
	          }, spec.columns, spec.presets, ItemResponse$1.CLOSE_ON_EXECUTE, spec.select.getOr(never), providersBackstage), {
	            movement: deriveMenuMovement(spec.columns, spec.presets),
	            menuBehaviours: SimpleBehaviours.unnamedEvents(spec.columns !== 'auto' ? [] : [runOnAttached(function (comp, _se) {
	                detectSize(comp, 4, classForPreset(spec.presets)).each(function (_d) {
	                  var numRows = _d.numRows, numColumns = _d.numColumns;
	                  Keying.setGridSize(comp, numRows, numColumns);
	                });
	              })])
	          })));
	        });
	      };
	    };
	    var renderSplitButton = function (spec, sharedBackstage) {
	      var _d;
	      var displayChannel = generate$6('channel-update-split-dropdown-display');
	      var getApi = function (comp) {
	        return {
	          isDisabled: function () {
	            return Disabling.isDisabled(comp);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(comp, state);
	          },
	          setIconFill: function (id, value) {
	            descendant(comp.element, 'svg path[id="' + id + '"], rect[id="' + id + '"]').each(function (underlinePath) {
	              set$8(underlinePath, 'fill', value);
	            });
	          },
	          setIconStroke: function (id, value) {
	            descendant(comp.element, 'svg path[id="' + id + '"], rect[id="' + id + '"]').each(function (underlinePath) {
	              set$8(underlinePath, 'stroke', value);
	            });
	          },
	          setActive: function (state) {
	            set$8(comp.element, 'aria-pressed', state);
	            descendant(comp.element, 'span').each(function (button) {
	              comp.getSystem().getByDom(button).each(function (buttonComp) {
	                return Toggling.set(buttonComp, state);
	              });
	            });
	          },
	          isActive: function () {
	            return descendant(comp.element, 'span').exists(function (button) {
	              return comp.getSystem().getByDom(button).exists(Toggling.isOn);
	            });
	          }
	        };
	      };
	      var editorOffCell = Cell(noop);
	      var specialisation = {
	        getApi: getApi,
	        onSetup: spec.onSetup
	      };
	      return SplitDropdown.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-split-button'],
	          attributes: __assign({ 'aria-pressed': false }, getTooltipAttributes(spec.tooltip, sharedBackstage.providers))
	        },
	        onExecute: function (button) {
	          spec.onAction(getApi(button));
	        },
	        onItemExecute: function (_a, _b, _c) {
	        },
	        splitDropdownBehaviours: derive$1([
	          DisablingConfigs.splitButton(sharedBackstage.providers.isDisabled),
	          receivingConfig(),
	          config('split-dropdown-events', [
	            run$1(focusButtonEvent, Focusing.focus),
	            onControlAttached(specialisation, editorOffCell),
	            onControlDetached(specialisation, editorOffCell)
	          ]),
	          Unselecting.config({})
	        ]),
	        eventOrder: (_d = {}, _d[attachedToDom()] = [
	          'alloy.base.behaviour',
	          'split-dropdown-events'
	        ], _d),
	        toggleClass: 'tox-tbtn--enabled',
	        lazySink: sharedBackstage.getSink,
	        fetch: fetchChoices(getApi, spec, sharedBackstage.providers),
	        parts: { menu: part(false, spec.columns, spec.presets) },
	        components: [
	          SplitDropdown.parts.button(renderCommonStructure(spec.icon, spec.text, Optional.none(), Optional.some(displayChannel), Optional.some([Toggling.config({
	              toggleClass: 'tox-tbtn--enabled',
	              toggleOnExecute: false
	            })]), sharedBackstage.providers)),
	          SplitDropdown.parts.arrow({
	            dom: {
	              tag: 'button',
	              classes: [
	                'tox-tbtn',
	                'tox-split-button__chevron'
	              ],
	              innerHtml: get$1('chevron-down', sharedBackstage.providers.icons)
	            },
	            buttonBehaviours: derive$1([
	              DisablingConfigs.splitButton(sharedBackstage.providers.isDisabled),
	              receivingConfig(),
	              addFocusableBehaviour()
	            ])
	          }),
	          SplitDropdown.parts['aria-descriptor']({ text: sharedBackstage.providers.translate('To open the popup, press Shift+Enter') })
	        ]
	      });
	    };
	
	    var defaultToolbar = [
	      {
	        name: 'history',
	        items: [
	          'undo',
	          'redo'
	        ]
	      },
	      {
	        name: 'styles',
	        items: ['styleselect']
	      },
	      {
	        name: 'formatting',
	        items: [
	          'bold',
	          'italic'
	        ]
	      },
	      {
	        name: 'alignment',
	        items: [
	          'alignleft',
	          'aligncenter',
	          'alignright',
	          'alignjustify'
	        ]
	      },
	      {
	        name: 'indentation',
	        items: [
	          'outdent',
	          'indent'
	        ]
	      },
	      {
	        name: 'permanent pen',
	        items: ['permanentpen']
	      },
	      {
	        name: 'comments',
	        items: ['addcomment']
	      }
	    ];
	    var renderFromBridge = function (bridgeBuilder, render) {
	      return function (spec, extras, editor) {
	        var internal = bridgeBuilder(spec).mapError(function (errInfo) {
	          return formatError(errInfo);
	        }).getOrDie();
	        return render(internal, extras, editor);
	      };
	    };
	    var types = {
	      button: renderFromBridge(createToolbarButton, function (s, extras) {
	        return renderToolbarButton(s, extras.backstage.shared.providers);
	      }),
	      togglebutton: renderFromBridge(createToggleButton, function (s, extras) {
	        return renderToolbarToggleButton(s, extras.backstage.shared.providers);
	      }),
	      menubutton: renderFromBridge(createMenuButton, function (s, extras) {
	        return renderMenuButton(s, 'tox-tbtn', extras.backstage, Optional.none());
	      }),
	      splitbutton: renderFromBridge(createSplitButton, function (s, extras) {
	        return renderSplitButton(s, extras.backstage.shared);
	      }),
	      grouptoolbarbutton: renderFromBridge(createGroupToolbarButton, function (s, extras, editor) {
	        var _a;
	        var buttons = editor.ui.registry.getAll().buttons;
	        var identify = function (toolbar) {
	          return identifyButtons(editor, {
	            buttons: buttons,
	            toolbar: toolbar,
	            allowToolbarGroups: false
	          }, extras, Optional.none());
	        };
	        var attributes = (_a = {}, _a[Attribute] = extras.backstage.shared.header.isPositionedAtTop() ? AttributeValue.TopToBottom : AttributeValue.BottomToTop, _a);
	        switch (getToolbarMode(editor)) {
	        case ToolbarMode.floating:
	          return renderFloatingToolbarButton(s, extras.backstage, identify, attributes);
	        default:
	          throw new Error('Toolbar groups are only supported when using floating toolbar mode');
	        }
	      }),
	      styleSelectButton: function (editor, extras) {
	        return createStyleSelect(editor, extras.backstage);
	      },
	      fontsizeSelectButton: function (editor, extras) {
	        return createFontsizeSelect(editor, extras.backstage);
	      },
	      fontSelectButton: function (editor, extras) {
	        return createFontSelect(editor, extras.backstage);
	      },
	      formatButton: function (editor, extras) {
	        return createFormatSelect(editor, extras.backstage);
	      },
	      alignMenuButton: function (editor, extras) {
	        return createAlignSelect(editor, extras.backstage);
	      }
	    };
	    var extractFrom = function (spec, extras, editor) {
	      return get$e(types, spec.type).fold(function () {
	        console.error('skipping button defined by', spec);
	        return Optional.none();
	      }, function (render) {
	        return Optional.some(render(spec, extras, editor));
	      });
	    };
	    var bespokeButtons = {
	      styleselect: types.styleSelectButton,
	      fontsizeselect: types.fontsizeSelectButton,
	      fontselect: types.fontSelectButton,
	      formatselect: types.formatButton,
	      align: types.alignMenuButton
	    };
	    var removeUnusedDefaults = function (buttons) {
	      var filteredItemGroups = map$2(defaultToolbar, function (group) {
	        var items = filter$2(group.items, function (subItem) {
	          return has$2(buttons, subItem) || has$2(bespokeButtons, subItem);
	        });
	        return {
	          name: group.name,
	          items: items
	        };
	      });
	      return filter$2(filteredItemGroups, function (group) {
	        return group.items.length > 0;
	      });
	    };
	    var convertStringToolbar = function (strToolbar) {
	      var groupsStrings = strToolbar.split('|');
	      return map$2(groupsStrings, function (g) {
	        return { items: g.trim().split(' ') };
	      });
	    };
	    var isToolbarGroupSettingArray = function (toolbar) {
	      return isArrayOf(toolbar, function (t) {
	        return has$2(t, 'name') && has$2(t, 'items');
	      });
	    };
	    var createToolbar = function (toolbarConfig) {
	      var toolbar = toolbarConfig.toolbar;
	      var buttons = toolbarConfig.buttons;
	      if (toolbar === false) {
	        return [];
	      } else if (toolbar === undefined || toolbar === true) {
	        return removeUnusedDefaults(buttons);
	      } else if (isString(toolbar)) {
	        return convertStringToolbar(toolbar);
	      } else if (isToolbarGroupSettingArray(toolbar)) {
	        return toolbar;
	      } else {
	        console.error('Toolbar type should be string, string[], boolean or ToolbarGroup[]');
	        return [];
	      }
	    };
	    var lookupButton = function (editor, buttons, toolbarItem, allowToolbarGroups, extras, prefixes) {
	      return get$e(buttons, toolbarItem.toLowerCase()).orThunk(function () {
	        return prefixes.bind(function (ps) {
	          return findMap(ps, function (prefix) {
	            return get$e(buttons, prefix + toolbarItem.toLowerCase());
	          });
	        });
	      }).fold(function () {
	        return get$e(bespokeButtons, toolbarItem.toLowerCase()).map(function (r) {
	          return r(editor, extras);
	        }).orThunk(function () {
	          return Optional.none();
	        });
	      }, function (spec) {
	        if (spec.type === 'grouptoolbarbutton' && !allowToolbarGroups) {
	          console.warn('Ignoring the \'' + toolbarItem + '\' toolbar button. Group toolbar buttons are only supported when using floating toolbar mode and cannot be nested.');
	          return Optional.none();
	        } else {
	          return extractFrom(spec, extras, editor);
	        }
	      });
	    };
	    var identifyButtons = function (editor, toolbarConfig, extras, prefixes) {
	      var toolbarGroups = createToolbar(toolbarConfig);
	      var groups = map$2(toolbarGroups, function (group) {
	        var items = bind$3(group.items, function (toolbarItem) {
	          return toolbarItem.trim().length === 0 ? [] : lookupButton(editor, toolbarConfig.buttons, toolbarItem, toolbarConfig.allowToolbarGroups, extras, prefixes).toArray();
	        });
	        return {
	          title: Optional.from(editor.translate(group.name)),
	          items: items
	        };
	      });
	      return filter$2(groups, function (group) {
	        return group.items.length > 0;
	      });
	    };
	
	    var setToolbar = function (editor, uiComponents, rawUiConfig, backstage) {
	      var comp = uiComponents.outerContainer;
	      var toolbarConfig = rawUiConfig.toolbar;
	      var toolbarButtonsConfig = rawUiConfig.buttons;
	      if (isArrayOf(toolbarConfig, isString)) {
	        var toolbars = toolbarConfig.map(function (t) {
	          var config = {
	            toolbar: t,
	            buttons: toolbarButtonsConfig,
	            allowToolbarGroups: rawUiConfig.allowToolbarGroups
	          };
	          return identifyButtons(editor, config, { backstage: backstage }, Optional.none());
	        });
	        OuterContainer.setToolbars(comp, toolbars);
	      } else {
	        OuterContainer.setToolbar(comp, identifyButtons(editor, rawUiConfig, { backstage: backstage }, Optional.none()));
	      }
	    };
	
	    var detection = detect$1();
	    var isiOS12 = detection.os.isiOS() && detection.os.version.major <= 12;
	    var setupEvents$1 = function (editor, uiComponents) {
	      var dom = editor.dom;
	      var contentWindow = editor.getWin();
	      var initialDocEle = editor.getDoc().documentElement;
	      var lastWindowDimensions = Cell(SugarPosition(contentWindow.innerWidth, contentWindow.innerHeight));
	      var lastDocumentDimensions = Cell(SugarPosition(initialDocEle.offsetWidth, initialDocEle.offsetHeight));
	      var resizeWindow = function () {
	        var outer = lastWindowDimensions.get();
	        if (outer.left !== contentWindow.innerWidth || outer.top !== contentWindow.innerHeight) {
	          lastWindowDimensions.set(SugarPosition(contentWindow.innerWidth, contentWindow.innerHeight));
	          fireResizeContent(editor);
	        }
	      };
	      var resizeDocument = function () {
	        var docEle = editor.getDoc().documentElement;
	        var inner = lastDocumentDimensions.get();
	        if (inner.left !== docEle.offsetWidth || inner.top !== docEle.offsetHeight) {
	          lastDocumentDimensions.set(SugarPosition(docEle.offsetWidth, docEle.offsetHeight));
	          fireResizeContent(editor);
	        }
	      };
	      var scroll = function (e) {
	        return fireScrollContent(editor, e);
	      };
	      dom.bind(contentWindow, 'resize', resizeWindow);
	      dom.bind(contentWindow, 'scroll', scroll);
	      var elementLoad = capture(SugarElement.fromDom(editor.getBody()), 'load', resizeDocument);
	      var mothership = uiComponents.uiMothership.element;
	      editor.on('hide', function () {
	        set$7(mothership, 'display', 'none');
	      });
	      editor.on('show', function () {
	        remove$6(mothership, 'display');
	      });
	      editor.on('NodeChange', resizeDocument);
	      editor.on('remove', function () {
	        elementLoad.unbind();
	        dom.unbind(contentWindow, 'resize', resizeWindow);
	        dom.unbind(contentWindow, 'scroll', scroll);
	        contentWindow = null;
	      });
	    };
	    var render$1 = function (editor, uiComponents, rawUiConfig, backstage, args) {
	      var lastToolbarWidth = Cell(0);
	      var outerContainer = uiComponents.outerContainer;
	      iframe(editor);
	      var eTargetNode = SugarElement.fromDom(args.targetNode);
	      var uiRoot = getContentContainer(getRootNode(eTargetNode));
	      attachSystemAfter(eTargetNode, uiComponents.mothership);
	      attachSystem(uiRoot, uiComponents.uiMothership);
	      editor.on('PostRender', function () {
	        setToolbar(editor, uiComponents, rawUiConfig, backstage);
	        lastToolbarWidth.set(editor.getWin().innerWidth);
	        OuterContainer.setMenubar(outerContainer, identifyMenus(editor, rawUiConfig));
	        OuterContainer.setSidebar(outerContainer, rawUiConfig.sidebar);
	        setupEvents$1(editor, uiComponents);
	      });
	      var socket = OuterContainer.getSocket(outerContainer).getOrDie('Could not find expected socket element');
	      if (isiOS12) {
	        setAll(socket.element, {
	          'overflow': 'scroll',
	          '-webkit-overflow-scrolling': 'touch'
	        });
	        var limit = first(function () {
	          editor.fire('ScrollContent');
	        }, 20);
	        var unbinder = bind(socket.element, 'scroll', limit.throttle);
	        editor.on('remove', unbinder.unbind);
	      }
	      setupReadonlyModeSwitch(editor, uiComponents);
	      editor.addCommand('ToggleSidebar', function (_ui, value) {
	        OuterContainer.toggleSidebar(outerContainer, value);
	        editor.fire('ToggleSidebar');
	      });
	      editor.addQueryValueHandler('ToggleSidebar', function () {
	        return OuterContainer.whichSidebar(outerContainer);
	      });
	      var toolbarMode = getToolbarMode(editor);
	      var refreshDrawer = function () {
	        OuterContainer.refreshToolbar(uiComponents.outerContainer);
	      };
	      if (toolbarMode === ToolbarMode.sliding || toolbarMode === ToolbarMode.floating) {
	        editor.on('ResizeWindow ResizeEditor ResizeContent', function () {
	          var width = editor.getWin().innerWidth;
	          if (width !== lastToolbarWidth.get()) {
	            refreshDrawer();
	            lastToolbarWidth.set(width);
	          }
	        });
	      }
	      var api = {
	        enable: function () {
	          broadcastReadonly(uiComponents, false);
	        },
	        disable: function () {
	          broadcastReadonly(uiComponents, true);
	        },
	        isDisabled: function () {
	          return Disabling.isDisabled(outerContainer);
	        }
	      };
	      return {
	        iframeContainer: socket.element.dom,
	        editorContainer: outerContainer.element.dom,
	        api: api
	      };
	    };
	
	    var Iframe = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        render: render$1
	    });
	
	    var parseToInt = function (val) {
	      var re = /^[0-9\.]+(|px)$/i;
	      if (re.test('' + val)) {
	        return Optional.some(parseInt('' + val, 10));
	      }
	      return Optional.none();
	    };
	    var numToPx = function (val) {
	      return isNumber(val) ? val + 'px' : val;
	    };
	    var calcCappedSize = function (size, minSize, maxSize) {
	      var minOverride = minSize.filter(function (min) {
	        return size < min;
	      });
	      var maxOverride = maxSize.filter(function (max) {
	        return size > max;
	      });
	      return minOverride.or(maxOverride).getOr(size);
	    };
	
	    var getHeight = function (editor) {
	      var baseHeight = getHeightSetting(editor);
	      var minHeight = getMinHeightSetting(editor);
	      var maxHeight = getMaxHeightSetting(editor);
	      return parseToInt(baseHeight).map(function (height) {
	        return calcCappedSize(height, minHeight, maxHeight);
	      });
	    };
	    var getHeightWithFallback = function (editor) {
	      var height = getHeight(editor);
	      return height.getOr(getHeightSetting(editor));
	    };
	    var getWidth = function (editor) {
	      var baseWidth = getWidthSetting(editor);
	      var minWidth = getMinWidthSetting(editor);
	      var maxWidth = getMaxWidthSetting(editor);
	      return parseToInt(baseWidth).map(function (width) {
	        return calcCappedSize(width, minWidth, maxWidth);
	      });
	    };
	    var getWidthWithFallback = function (editor) {
	      var width = getWidth(editor);
	      return width.getOr(getWidthSetting(editor));
	    };
	
	    var InlineHeader = function (editor, targetElm, uiComponents, backstage, floatContainer) {
	      var uiMothership = uiComponents.uiMothership, outerContainer = uiComponents.outerContainer;
	      var DOM = global$b.DOM;
	      var useFixedToolbarContainer = useFixedContainer(editor);
	      var isSticky = isStickyToolbar(editor);
	      var editorMaxWidthOpt = getMaxWidthSetting(editor).or(getWidth(editor));
	      var headerBackstage = backstage.shared.header;
	      var isPositionedAtTop = headerBackstage.isPositionedAtTop;
	      var toolbarMode = getToolbarMode(editor);
	      var isSplitToolbar = toolbarMode === ToolbarMode.sliding || toolbarMode === ToolbarMode.floating;
	      var visible = Cell(false);
	      var isVisible = function () {
	        return visible.get() && !editor.removed;
	      };
	      var calcToolbarOffset = function (toolbar) {
	        return isSplitToolbar ? toolbar.fold(constant$1(0), function (tbar) {
	          return tbar.components().length > 1 ? get$b(tbar.components()[1].element) : 0;
	        }) : 0;
	      };
	      var calcMode = function (container) {
	        switch (getToolbarLocation(editor)) {
	        case ToolbarLocation.auto:
	          var toolbar_1 = OuterContainer.getToolbar(outerContainer);
	          var offset = calcToolbarOffset(toolbar_1);
	          var toolbarHeight = get$b(container.element) - offset;
	          var targetBounds = box$1(targetElm);
	          var roomAtTop = targetBounds.y > toolbarHeight;
	          if (roomAtTop) {
	            return 'top';
	          } else {
	            var doc = documentElement(targetElm);
	            var docHeight = Math.max(doc.dom.scrollHeight, get$b(doc));
	            var roomAtBottom = targetBounds.bottom < docHeight - toolbarHeight;
	            if (roomAtBottom) {
	              return 'bottom';
	            } else {
	              var winBounds = win();
	              var isRoomAtBottomViewport = winBounds.bottom < targetBounds.bottom - toolbarHeight;
	              return isRoomAtBottomViewport ? 'bottom' : 'top';
	            }
	          }
	        case ToolbarLocation.bottom:
	          return 'bottom';
	        case ToolbarLocation.top:
	        default:
	          return 'top';
	        }
	      };
	      var setupMode = function (mode) {
	        var container = floatContainer.get();
	        Docking.setModes(container, [mode]);
	        headerBackstage.setDockingMode(mode);
	        var verticalDir = isPositionedAtTop() ? AttributeValue.TopToBottom : AttributeValue.BottomToTop;
	        set$8(container.element, Attribute, verticalDir);
	      };
	      var updateChromeWidth = function () {
	        var maxWidth = editorMaxWidthOpt.getOrThunk(function () {
	          var bodyMargin = parseToInt(get$c(body(), 'margin-left')).getOr(0);
	          return get$a(body()) - absolute$3(targetElm).left + bodyMargin;
	        });
	        set$7(floatContainer.get().element, 'max-width', maxWidth + 'px');
	      };
	      var updateChromePosition = function () {
	        var toolbar = OuterContainer.getToolbar(outerContainer);
	        var offset = calcToolbarOffset(toolbar);
	        var targetBounds = box$1(targetElm);
	        var top = isPositionedAtTop() ? Math.max(targetBounds.y - get$b(floatContainer.get().element) + offset, 0) : targetBounds.bottom;
	        setAll(outerContainer.element, {
	          position: 'absolute',
	          top: Math.round(top) + 'px',
	          left: Math.round(targetBounds.x) + 'px'
	        });
	      };
	      var repositionPopups$1 = function () {
	        uiMothership.broadcastOn([repositionPopups()], {});
	      };
	      var updateChromeUi = function (resetDocking) {
	        if (resetDocking === void 0) {
	          resetDocking = false;
	        }
	        if (!isVisible()) {
	          return;
	        }
	        if (!useFixedToolbarContainer) {
	          updateChromeWidth();
	        }
	        if (isSplitToolbar) {
	          OuterContainer.refreshToolbar(outerContainer);
	        }
	        if (!useFixedToolbarContainer) {
	          updateChromePosition();
	        }
	        if (isSticky) {
	          var floatContainerComp = floatContainer.get();
	          resetDocking ? Docking.reset(floatContainerComp) : Docking.refresh(floatContainerComp);
	        }
	        repositionPopups$1();
	      };
	      var updateMode = function (updateUi) {
	        if (updateUi === void 0) {
	          updateUi = true;
	        }
	        if (useFixedToolbarContainer || !isSticky || !isVisible()) {
	          return;
	        }
	        var currentMode = headerBackstage.getDockingMode();
	        var newMode = calcMode(floatContainer.get());
	        if (newMode !== currentMode) {
	          setupMode(newMode);
	          if (updateUi) {
	            updateChromeUi(true);
	          }
	        }
	      };
	      var show = function () {
	        visible.set(true);
	        set$7(outerContainer.element, 'display', 'flex');
	        DOM.addClass(editor.getBody(), 'mce-edit-focus');
	        remove$6(uiMothership.element, 'display');
	        updateMode(false);
	        updateChromeUi();
	      };
	      var hide = function () {
	        visible.set(false);
	        if (uiComponents.outerContainer) {
	          set$7(outerContainer.element, 'display', 'none');
	          DOM.removeClass(editor.getBody(), 'mce-edit-focus');
	        }
	        set$7(uiMothership.element, 'display', 'none');
	      };
	      return {
	        isVisible: isVisible,
	        isPositionedAtTop: isPositionedAtTop,
	        show: show,
	        hide: hide,
	        update: updateChromeUi,
	        updateMode: updateMode,
	        repositionPopups: repositionPopups$1
	      };
	    };
	
	    var getTargetPosAndBounds = function (targetElm, isToolbarTop) {
	      var bounds = box$1(targetElm);
	      return {
	        pos: isToolbarTop ? bounds.y : bounds.bottom,
	        bounds: bounds
	      };
	    };
	    var setupEvents = function (editor, targetElm, ui, toolbarPersist) {
	      var prevPosAndBounds = Cell(getTargetPosAndBounds(targetElm, ui.isPositionedAtTop()));
	      var resizeContent = function (e) {
	        var _a = getTargetPosAndBounds(targetElm, ui.isPositionedAtTop()), pos = _a.pos, bounds = _a.bounds;
	        var _b = prevPosAndBounds.get(), prevPos = _b.pos, prevBounds = _b.bounds;
	        var hasResized = bounds.height !== prevBounds.height || bounds.width !== prevBounds.width;
	        prevPosAndBounds.set({
	          pos: pos,
	          bounds: bounds
	        });
	        if (hasResized) {
	          fireResizeContent(editor, e);
	        }
	        if (ui.isVisible()) {
	          if (prevPos !== pos) {
	            ui.update(true);
	          } else if (hasResized) {
	            ui.updateMode();
	            ui.repositionPopups();
	          }
	        }
	      };
	      if (!toolbarPersist) {
	        editor.on('activate', ui.show);
	        editor.on('deactivate', ui.hide);
	      }
	      editor.on('SkinLoaded ResizeWindow', function () {
	        return ui.update(true);
	      });
	      editor.on('NodeChange keydown', function (e) {
	        global$f.requestAnimationFrame(function () {
	          return resizeContent(e);
	        });
	      });
	      editor.on('ScrollWindow', function () {
	        return ui.updateMode();
	      });
	      var elementLoad = unbindable();
	      elementLoad.set(capture(SugarElement.fromDom(editor.getBody()), 'load', resizeContent));
	      editor.on('remove', function () {
	        elementLoad.clear();
	      });
	    };
	    var render = function (editor, uiComponents, rawUiConfig, backstage, args) {
	      var mothership = uiComponents.mothership, uiMothership = uiComponents.uiMothership, outerContainer = uiComponents.outerContainer;
	      var floatContainer = Cell(null);
	      var targetElm = SugarElement.fromDom(args.targetNode);
	      var ui = InlineHeader(editor, targetElm, uiComponents, backstage, floatContainer);
	      var toolbarPersist = isToolbarPersist(editor);
	      inline(editor);
	      var render = function () {
	        if (floatContainer.get()) {
	          ui.show();
	          return;
	        }
	        floatContainer.set(OuterContainer.getHeader(outerContainer).getOrDie());
	        var uiContainer = getUiContainer(editor);
	        attachSystem(uiContainer, mothership);
	        attachSystem(uiContainer, uiMothership);
	        setToolbar(editor, uiComponents, rawUiConfig, backstage);
	        OuterContainer.setMenubar(outerContainer, identifyMenus(editor, rawUiConfig));
	        ui.show();
	        setupEvents(editor, targetElm, ui, toolbarPersist);
	        editor.nodeChanged();
	      };
	      editor.on('show', render);
	      editor.on('hide', ui.hide);
	      if (!toolbarPersist) {
	        editor.on('focus', render);
	        editor.on('blur', ui.hide);
	      }
	      editor.on('init', function () {
	        if (editor.hasFocus() || toolbarPersist) {
	          render();
	        }
	      });
	      setupReadonlyModeSwitch(editor, uiComponents);
	      var api = {
	        show: function () {
	          ui.show();
	        },
	        hide: function () {
	          ui.hide();
	        },
	        enable: function () {
	          broadcastReadonly(uiComponents, false);
	        },
	        disable: function () {
	          broadcastReadonly(uiComponents, true);
	        },
	        isDisabled: function () {
	          return Disabling.isDisabled(outerContainer);
	        }
	      };
	      return {
	        editorContainer: outerContainer.element.dom,
	        api: api
	      };
	    };
	
	    var Inline = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        render: render
	    });
	
	    var showContextToolbarEvent = 'contexttoolbar-show';
	    var hideContextToolbarEvent = 'contexttoolbar-hide';
	
	    var getFormApi = function (input) {
	      return {
	        hide: function () {
	          return emit(input, sandboxClose());
	        },
	        getValue: function () {
	          return Representing.getValue(input);
	        }
	      };
	    };
	    var runOnExecute = function (memInput, original) {
	      return run$1(internalToolbarButtonExecute, function (comp, se) {
	        var input = memInput.get(comp);
	        var formApi = getFormApi(input);
	        original.onAction(formApi, se.event.buttonApi);
	      });
	    };
	    var renderContextButton = function (memInput, button, extras) {
	      var _a = button.original; _a.primary; var rest = __rest(_a, ['primary']);
	      var bridged = getOrDie(createToolbarButton(__assign(__assign({}, rest), {
	        type: 'button',
	        onAction: noop
	      })));
	      return renderToolbarButtonWith(bridged, extras.backstage.shared.providers, [runOnExecute(memInput, button)]);
	    };
	    var renderContextToggleButton = function (memInput, button, extras) {
	      var _a = button.original; _a.primary; var rest = __rest(_a, ['primary']);
	      var bridged = getOrDie(createToggleButton(__assign(__assign({}, rest), {
	        type: 'togglebutton',
	        onAction: noop
	      })));
	      return renderToolbarToggleButtonWith(bridged, extras.backstage.shared.providers, [runOnExecute(memInput, button)]);
	    };
	    var generateOne = function (memInput, button, providersBackstage) {
	      var extras = { backstage: { shared: { providers: providersBackstage } } };
	      if (button.type === 'contextformtogglebutton') {
	        return renderContextToggleButton(memInput, button, extras);
	      } else {
	        return renderContextButton(memInput, button, extras);
	      }
	    };
	    var generate = function (memInput, buttons, providersBackstage) {
	      var mementos = map$2(buttons, function (button) {
	        return record(generateOne(memInput, button, providersBackstage));
	      });
	      var asSpecs = function () {
	        return map$2(mementos, function (mem) {
	          return mem.asSpec();
	        });
	      };
	      var findPrimary = function (compInSystem) {
	        return findMap(buttons, function (button, i) {
	          if (button.primary) {
	            return Optional.from(mementos[i]).bind(function (mem) {
	              return mem.getOpt(compInSystem);
	            }).filter(not(Disabling.isDisabled));
	          } else {
	            return Optional.none();
	          }
	        });
	      };
	      return {
	        asSpecs: asSpecs,
	        findPrimary: findPrimary
	      };
	    };
	
	    var buildInitGroups = function (ctx, providers) {
	      var inputAttributes = ctx.label.fold(function () {
	        return {};
	      }, function (label) {
	        return { 'aria-label': label };
	      });
	      var memInput = record(Input.sketch({
	        inputClasses: [
	          'tox-toolbar-textfield',
	          'tox-toolbar-nav-js'
	        ],
	        data: ctx.initValue(),
	        inputAttributes: inputAttributes,
	        selectOnFocus: true,
	        inputBehaviours: derive$1([Keying.config({
	            mode: 'special',
	            onEnter: function (input) {
	              return commands.findPrimary(input).map(function (primary) {
	                emitExecute(primary);
	                return true;
	              });
	            },
	            onLeft: function (comp, se) {
	              se.cut();
	              return Optional.none();
	            },
	            onRight: function (comp, se) {
	              se.cut();
	              return Optional.none();
	            }
	          })])
	      }));
	      var commands = generate(memInput, ctx.commands, providers);
	      return [
	        {
	          title: Optional.none(),
	          items: [memInput.asSpec()]
	        },
	        {
	          title: Optional.none(),
	          items: commands.asSpecs()
	        }
	      ];
	    };
	    var renderContextForm = function (toolbarType, ctx, providers) {
	      return renderToolbar({
	        type: toolbarType,
	        uid: generate$6('context-toolbar'),
	        initGroups: buildInitGroups(ctx, providers),
	        onEscape: Optional.none,
	        cyclicKeying: true,
	        providers: providers
	      });
	    };
	    var ContextForm = {
	      renderContextForm: renderContextForm,
	      buildInitGroups: buildInitGroups
	    };
	
	    var isVerticalOverlap = function (a, b, threshold) {
	      if (threshold === void 0) {
	        threshold = 0.01;
	      }
	      return b.bottom - a.y >= threshold && a.bottom - b.y >= threshold;
	    };
	    var getRangeRect = function (rng) {
	      var rect = rng.getBoundingClientRect();
	      if (rect.height <= 0 && rect.width <= 0) {
	        var leaf$1 = leaf(SugarElement.fromDom(rng.startContainer), rng.startOffset).element;
	        var elm = isText$1(leaf$1) ? parent(leaf$1) : Optional.some(leaf$1);
	        return elm.filter(isElement$2).map(function (e) {
	          return e.dom.getBoundingClientRect();
	        }).getOr(rect);
	      } else {
	        return rect;
	      }
	    };
	    var getSelectionBounds = function (editor) {
	      var rng = editor.selection.getRng();
	      var rect = getRangeRect(rng);
	      if (editor.inline) {
	        var scroll_1 = get$9();
	        return bounds(scroll_1.left + rect.left, scroll_1.top + rect.top, rect.width, rect.height);
	      } else {
	        var bodyPos = absolute$2(SugarElement.fromDom(editor.getBody()));
	        return bounds(bodyPos.x + rect.left, bodyPos.y + rect.top, rect.width, rect.height);
	      }
	    };
	    var getAnchorElementBounds = function (editor, lastElement) {
	      return lastElement.filter(inBody).map(absolute$2).getOrThunk(function () {
	        return getSelectionBounds(editor);
	      });
	    };
	    var getHorizontalBounds = function (contentAreaBox, viewportBounds, margin) {
	      var x = Math.max(contentAreaBox.x + margin, viewportBounds.x);
	      var right = Math.min(contentAreaBox.right - margin, viewportBounds.right);
	      return {
	        x: x,
	        width: right - x
	      };
	    };
	    var getVerticalBounds = function (editor, contentAreaBox, viewportBounds, isToolbarLocationTop, toolbarType, margin) {
	      var container = SugarElement.fromDom(editor.getContainer());
	      var header = descendant(container, '.tox-editor-header').getOr(container);
	      var headerBox = box$1(header);
	      var isToolbarBelowContentArea = headerBox.y >= contentAreaBox.bottom;
	      var isToolbarAbove = isToolbarLocationTop && !isToolbarBelowContentArea;
	      if (editor.inline && isToolbarAbove) {
	        return {
	          y: Math.max(headerBox.bottom + margin, viewportBounds.y),
	          bottom: viewportBounds.bottom
	        };
	      }
	      if (editor.inline && !isToolbarAbove) {
	        return {
	          y: viewportBounds.y,
	          bottom: Math.min(headerBox.y - margin, viewportBounds.bottom)
	        };
	      }
	      var containerBounds = toolbarType === 'line' ? box$1(container) : contentAreaBox;
	      if (isToolbarAbove) {
	        return {
	          y: Math.max(headerBox.bottom + margin, viewportBounds.y),
	          bottom: Math.min(containerBounds.bottom - margin, viewportBounds.bottom)
	        };
	      }
	      return {
	        y: Math.max(containerBounds.y + margin, viewportBounds.y),
	        bottom: Math.min(headerBox.y - margin, viewportBounds.bottom)
	      };
	    };
	    var getContextToolbarBounds = function (editor, sharedBackstage, toolbarType, margin) {
	      if (margin === void 0) {
	        margin = 0;
	      }
	      var viewportBounds = getBounds$3(window);
	      var contentAreaBox = box$1(SugarElement.fromDom(editor.getContentAreaContainer()));
	      var toolbarOrMenubarEnabled = isMenubarEnabled(editor) || isToolbarEnabled(editor) || isMultipleToolbars(editor);
	      var _a = getHorizontalBounds(contentAreaBox, viewportBounds, margin), x = _a.x, width = _a.width;
	      if (editor.inline && !toolbarOrMenubarEnabled) {
	        return bounds(x, viewportBounds.y, width, viewportBounds.height);
	      } else {
	        var isToolbarTop = sharedBackstage.header.isPositionedAtTop();
	        var _b = getVerticalBounds(editor, contentAreaBox, viewportBounds, isToolbarTop, toolbarType, margin), y = _b.y, bottom = _b.bottom;
	        return bounds(x, y, width, bottom - y);
	      }
	    };
	
	    var bubbleSize$1 = 12;
	    var bubbleAlignments$1 = {
	      valignCentre: [],
	      alignCentre: [],
	      alignLeft: ['tox-pop--align-left'],
	      alignRight: ['tox-pop--align-right'],
	      right: ['tox-pop--right'],
	      left: ['tox-pop--left'],
	      bottom: ['tox-pop--bottom'],
	      top: ['tox-pop--top'],
	      inset: ['tox-pop--inset']
	    };
	    var anchorOverrides = {
	      maxHeightFunction: expandable$1(),
	      maxWidthFunction: expandable()
	    };
	    var isEntireElementSelected = function (editor, elem) {
	      var rng = editor.selection.getRng();
	      var leaf$1 = leaf(SugarElement.fromDom(rng.startContainer), rng.startOffset);
	      return rng.startContainer === rng.endContainer && rng.startOffset === rng.endOffset - 1 && eq(leaf$1.element, elem);
	    };
	    var preservePosition = function (elem, position, f) {
	      var currentPosition = getRaw(elem, 'position');
	      set$7(elem, 'position', position);
	      var result = f(elem);
	      currentPosition.each(function (pos) {
	        return set$7(elem, 'position', pos);
	      });
	      return result;
	    };
	    var shouldUseInsetLayouts = function (position) {
	      return position === 'node';
	    };
	    var determineInsetLayout = function (editor, contextbar, elem, data, bounds) {
	      var selectionBounds = getSelectionBounds(editor);
	      var isSameAnchorElement = data.lastElement().exists(function (prev) {
	        return eq(elem, prev);
	      });
	      if (isEntireElementSelected(editor, elem)) {
	        return isSameAnchorElement ? preserve : north;
	      } else if (isSameAnchorElement) {
	        return preservePosition(contextbar, data.getMode(), function () {
	          var isOverlapping = isVerticalOverlap(selectionBounds, box$1(contextbar));
	          return isOverlapping && !data.isReposition() ? flip$2 : preserve;
	        });
	      } else {
	        var yBounds = data.getMode() === 'fixed' ? bounds.y + get$9().top : bounds.y;
	        var contextbarHeight = get$b(contextbar) + bubbleSize$1;
	        return yBounds + contextbarHeight <= selectionBounds.y ? north : south;
	      }
	    };
	    var getAnchorSpec$2 = function (editor, mobile, data, position) {
	      var smartInsetLayout = function (elem) {
	        return function (anchor, element, bubbles, placee, bounds) {
	          var layout = determineInsetLayout(editor, placee, elem, data, bounds);
	          var newAnchor = __assign(__assign({}, anchor), {
	            y: bounds.y,
	            height: bounds.height
	          });
	          return __assign(__assign({}, layout(newAnchor, element, bubbles, placee, bounds)), { alwaysFit: true });
	        };
	      };
	      var getInsetLayouts = function (elem) {
	        return shouldUseInsetLayouts(position) ? [smartInsetLayout(elem)] : [];
	      };
	      var desktopAnchorSpecLayouts = {
	        onLtr: function (elem) {
	          return [
	            north$2,
	            south$2,
	            northeast$2,
	            southeast$2,
	            northwest$2,
	            southwest$2
	          ].concat(getInsetLayouts(elem));
	        },
	        onRtl: function (elem) {
	          return [
	            north$2,
	            south$2,
	            northwest$2,
	            southwest$2,
	            northeast$2,
	            southeast$2
	          ].concat(getInsetLayouts(elem));
	        }
	      };
	      var mobileAnchorSpecLayouts = {
	        onLtr: function (elem) {
	          return [
	            south$2,
	            southeast$2,
	            southwest$2,
	            northeast$2,
	            northwest$2,
	            north$2
	          ].concat(getInsetLayouts(elem));
	        },
	        onRtl: function (elem) {
	          return [
	            south$2,
	            southwest$2,
	            southeast$2,
	            northwest$2,
	            northeast$2,
	            north$2
	          ].concat(getInsetLayouts(elem));
	        }
	      };
	      return mobile ? mobileAnchorSpecLayouts : desktopAnchorSpecLayouts;
	    };
	    var getAnchorLayout = function (editor, position, isTouch, data) {
	      if (position === 'line') {
	        return {
	          bubble: nu$5(bubbleSize$1, 0, bubbleAlignments$1),
	          layouts: {
	            onLtr: function () {
	              return [east$2];
	            },
	            onRtl: function () {
	              return [west$2];
	            }
	          },
	          overrides: anchorOverrides
	        };
	      } else {
	        return {
	          bubble: nu$5(0, bubbleSize$1, bubbleAlignments$1, 1 / bubbleSize$1),
	          layouts: getAnchorSpec$2(editor, isTouch, data, position),
	          overrides: anchorOverrides
	        };
	      }
	    };
	
	    var matchTargetWith = function (elem, candidates) {
	      var ctxs = filter$2(candidates, function (toolbarApi) {
	        return toolbarApi.predicate(elem.dom);
	      });
	      var _a = partition$3(ctxs, function (t) {
	          return t.type === 'contexttoolbar';
	        }), pass = _a.pass, fail = _a.fail;
	      return {
	        contextToolbars: pass,
	        contextForms: fail
	      };
	    };
	    var filterByPositionForStartNode = function (toolbars) {
	      if (toolbars.length <= 1) {
	        return toolbars;
	      } else {
	        var doesPositionExist = function (value) {
	          return exists(toolbars, function (t) {
	            return t.position === value;
	          });
	        };
	        var filterToolbarsByPosition = function (value) {
	          return filter$2(toolbars, function (t) {
	            return t.position === value;
	          });
	        };
	        var hasSelectionToolbars = doesPositionExist('selection');
	        var hasNodeToolbars = doesPositionExist('node');
	        if (hasSelectionToolbars || hasNodeToolbars) {
	          if (hasNodeToolbars && hasSelectionToolbars) {
	            var nodeToolbars = filterToolbarsByPosition('node');
	            var selectionToolbars = map$2(filterToolbarsByPosition('selection'), function (t) {
	              return __assign(__assign({}, t), { position: 'node' });
	            });
	            return nodeToolbars.concat(selectionToolbars);
	          } else {
	            return hasSelectionToolbars ? filterToolbarsByPosition('selection') : filterToolbarsByPosition('node');
	          }
	        } else {
	          return filterToolbarsByPosition('line');
	        }
	      }
	    };
	    var filterByPositionForAncestorNode = function (toolbars) {
	      if (toolbars.length <= 1) {
	        return toolbars;
	      } else {
	        var findPosition_1 = function (value) {
	          return find$5(toolbars, function (t) {
	            return t.position === value;
	          });
	        };
	        var basePosition = findPosition_1('selection').orThunk(function () {
	          return findPosition_1('node');
	        }).orThunk(function () {
	          return findPosition_1('line');
	        }).map(function (t) {
	          return t.position;
	        });
	        return basePosition.fold(function () {
	          return [];
	        }, function (pos) {
	          return filter$2(toolbars, function (t) {
	            return t.position === pos;
	          });
	        });
	      }
	    };
	    var matchStartNode = function (elem, nodeCandidates, editorCandidates) {
	      var nodeMatches = matchTargetWith(elem, nodeCandidates);
	      if (nodeMatches.contextForms.length > 0) {
	        return Optional.some({
	          elem: elem,
	          toolbars: [nodeMatches.contextForms[0]]
	        });
	      } else {
	        var editorMatches = matchTargetWith(elem, editorCandidates);
	        if (editorMatches.contextForms.length > 0) {
	          return Optional.some({
	            elem: elem,
	            toolbars: [editorMatches.contextForms[0]]
	          });
	        } else if (nodeMatches.contextToolbars.length > 0 || editorMatches.contextToolbars.length > 0) {
	          var toolbars = filterByPositionForStartNode(nodeMatches.contextToolbars.concat(editorMatches.contextToolbars));
	          return Optional.some({
	            elem: elem,
	            toolbars: toolbars
	          });
	        } else {
	          return Optional.none();
	        }
	      }
	    };
	    var matchAncestor = function (isRoot, startNode, scopes) {
	      if (isRoot(startNode)) {
	        return Optional.none();
	      } else {
	        return ancestor$2(startNode, function (ancestorElem) {
	          if (isElement$2(ancestorElem)) {
	            var _a = matchTargetWith(ancestorElem, scopes.inNodeScope), contextToolbars = _a.contextToolbars, contextForms = _a.contextForms;
	            var toolbars = contextForms.length > 0 ? contextForms : filterByPositionForAncestorNode(contextToolbars);
	            return toolbars.length > 0 ? Optional.some({
	              elem: ancestorElem,
	              toolbars: toolbars
	            }) : Optional.none();
	          } else {
	            return Optional.none();
	          }
	        }, isRoot);
	      }
	    };
	    var lookup$1 = function (scopes, editor) {
	      var rootElem = SugarElement.fromDom(editor.getBody());
	      var isRoot = function (elem) {
	        return eq(elem, rootElem);
	      };
	      var isOutsideRoot = function (startNode) {
	        return !isRoot(startNode) && !contains(rootElem, startNode);
	      };
	      var startNode = SugarElement.fromDom(editor.selection.getNode());
	      if (isOutsideRoot(startNode)) {
	        return Optional.none();
	      }
	      return matchStartNode(startNode, scopes.inNodeScope, scopes.inEditorScope).orThunk(function () {
	        return matchAncestor(isRoot, startNode, scopes);
	      });
	    };
	
	    var categorise = function (contextToolbars, navigate) {
	      var forms = {};
	      var inNodeScope = [];
	      var inEditorScope = [];
	      var formNavigators = {};
	      var lookupTable = {};
	      var registerForm = function (key, toolbarSpec) {
	        var contextForm = getOrDie(createContextForm(toolbarSpec));
	        forms[key] = contextForm;
	        contextForm.launch.map(function (launch) {
	          formNavigators['form:' + key + ''] = __assign(__assign({}, toolbarSpec.launch), {
	            type: launch.type === 'contextformtogglebutton' ? 'togglebutton' : 'button',
	            onAction: function () {
	              navigate(contextForm);
	            }
	          });
	        });
	        if (contextForm.scope === 'editor') {
	          inEditorScope.push(contextForm);
	        } else {
	          inNodeScope.push(contextForm);
	        }
	        lookupTable[key] = contextForm;
	      };
	      var registerToolbar = function (key, toolbarSpec) {
	        createContextToolbar(toolbarSpec).each(function (contextToolbar) {
	          if (toolbarSpec.scope === 'editor') {
	            inEditorScope.push(contextToolbar);
	          } else {
	            inNodeScope.push(contextToolbar);
	          }
	          lookupTable[key] = contextToolbar;
	        });
	      };
	      var keys$1 = keys(contextToolbars);
	      each$1(keys$1, function (key) {
	        var toolbarApi = contextToolbars[key];
	        if (toolbarApi.type === 'contextform') {
	          registerForm(key, toolbarApi);
	        } else if (toolbarApi.type === 'contexttoolbar') {
	          registerToolbar(key, toolbarApi);
	        }
	      });
	      return {
	        forms: forms,
	        inNodeScope: inNodeScope,
	        inEditorScope: inEditorScope,
	        lookupTable: lookupTable,
	        formNavigators: formNavigators
	      };
	    };
	
	    var forwardSlideEvent = generate$6('forward-slide');
	    var backSlideEvent = generate$6('backward-slide');
	    var changeSlideEvent = generate$6('change-slide-event');
	    var resizingClass = 'tox-pop--resizing';
	    var renderContextToolbar = function (spec) {
	      var stack = Cell([]);
	      return InlineView.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-pop']
	        },
	        fireDismissalEventInstead: { event: 'doNotDismissYet' },
	        onShow: function (comp) {
	          stack.set([]);
	          InlineView.getContent(comp).each(function (c) {
	            remove$6(c.element, 'visibility');
	          });
	          remove$2(comp.element, resizingClass);
	          remove$6(comp.element, 'width');
	        },
	        inlineBehaviours: derive$1([
	          config('context-toolbar-events', [
	            runOnSource(transitionend(), function (comp, se) {
	              if (se.event.raw.propertyName === 'width') {
	                remove$2(comp.element, resizingClass);
	                remove$6(comp.element, 'width');
	              }
	            }),
	            run$1(changeSlideEvent, function (comp, se) {
	              var elem = comp.element;
	              remove$6(elem, 'width');
	              var currentWidth = get$a(elem);
	              InlineView.setContent(comp, se.event.contents);
	              add$2(elem, resizingClass);
	              var newWidth = get$a(elem);
	              set$7(elem, 'width', currentWidth + 'px');
	              InlineView.getContent(comp).each(function (newContents) {
	                se.event.focus.bind(function (f) {
	                  focus$3(f);
	                  return search(elem);
	                }).orThunk(function () {
	                  Keying.focusIn(newContents);
	                  return active(getRootNode(elem));
	                });
	              });
	              global$f.setTimeout(function () {
	                set$7(comp.element, 'width', newWidth + 'px');
	              }, 0);
	            }),
	            run$1(forwardSlideEvent, function (comp, se) {
	              InlineView.getContent(comp).each(function (oldContents) {
	                stack.set(stack.get().concat([{
	                    bar: oldContents,
	                    focus: active(getRootNode(comp.element))
	                  }]));
	              });
	              emitWith(comp, changeSlideEvent, {
	                contents: se.event.forwardContents,
	                focus: Optional.none()
	              });
	            }),
	            run$1(backSlideEvent, function (comp, _se) {
	              last$2(stack.get()).each(function (last) {
	                stack.set(stack.get().slice(0, stack.get().length - 1));
	                emitWith(comp, changeSlideEvent, {
	                  contents: premade(last.bar),
	                  focus: last.focus
	                });
	              });
	            })
	          ]),
	          Keying.config({
	            mode: 'special',
	            onEscape: function (comp) {
	              return last$2(stack.get()).fold(function () {
	                return spec.onEscape();
	              }, function (_) {
	                emit(comp, backSlideEvent);
	                return Optional.some(true);
	              });
	            }
	          })
	        ]),
	        lazySink: function () {
	          return Result.value(spec.sink);
	        }
	      });
	    };
	
	    var transitionClass = 'tox-pop--transition';
	    var register$7 = function (editor, registryContextToolbars, sink, extras) {
	      var backstage = extras.backstage;
	      var sharedBackstage = backstage.shared;
	      var isTouch = detect$1().deviceType.isTouch;
	      var lastElement = value$1();
	      var lastTrigger = value$1();
	      var lastContextPosition = value$1();
	      var contextbar = build$1(renderContextToolbar({
	        sink: sink,
	        onEscape: function () {
	          editor.focus();
	          return Optional.some(true);
	        }
	      }));
	      var getBounds = function () {
	        var position = lastContextPosition.get().getOr('node');
	        var margin = shouldUseInsetLayouts(position) ? 1 : 0;
	        return getContextToolbarBounds(editor, sharedBackstage, position, margin);
	      };
	      var canLaunchToolbar = function () {
	        return !editor.removed && !(isTouch() && backstage.isContextMenuOpen());
	      };
	      var isSameLaunchElement = function (elem) {
	        return is$1(lift2(elem, lastElement.get(), eq), true);
	      };
	      var shouldContextToolbarHide = function () {
	        if (!canLaunchToolbar()) {
	          return true;
	        } else {
	          var contextToolbarBounds = getBounds();
	          var anchorBounds = is$1(lastContextPosition.get(), 'node') ? getAnchorElementBounds(editor, lastElement.get()) : getSelectionBounds(editor);
	          return contextToolbarBounds.height <= 0 || !isVerticalOverlap(anchorBounds, contextToolbarBounds);
	        }
	      };
	      var close = function () {
	        lastElement.clear();
	        lastTrigger.clear();
	        lastContextPosition.clear();
	        InlineView.hide(contextbar);
	      };
	      var hideOrRepositionIfNecessary = function () {
	        if (InlineView.isOpen(contextbar)) {
	          var contextBarEle = contextbar.element;
	          remove$6(contextBarEle, 'display');
	          if (shouldContextToolbarHide()) {
	            set$7(contextBarEle, 'display', 'none');
	          } else {
	            lastTrigger.set(0);
	            InlineView.reposition(contextbar);
	          }
	        }
	      };
	      var wrapInPopDialog = function (toolbarSpec) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-pop__dialog']
	          },
	          components: [toolbarSpec],
	          behaviours: derive$1([
	            Keying.config({ mode: 'acyclic' }),
	            config('pop-dialog-wrap-events', [
	              runOnAttached(function (comp) {
	                editor.shortcuts.add('ctrl+F9', 'focus statusbar', function () {
	                  return Keying.focusIn(comp);
	                });
	              }),
	              runOnDetached(function (_comp) {
	                editor.shortcuts.remove('ctrl+F9');
	              })
	            ])
	          ])
	        };
	      };
	      var getScopes = cached(function () {
	        return categorise(registryContextToolbars, function (toolbarApi) {
	          var alloySpec = buildToolbar([toolbarApi]);
	          emitWith(contextbar, forwardSlideEvent, { forwardContents: wrapInPopDialog(alloySpec) });
	        });
	      });
	      var buildContextToolbarGroups = function (allButtons, ctx) {
	        return identifyButtons(editor, {
	          buttons: allButtons,
	          toolbar: ctx.items,
	          allowToolbarGroups: false
	        }, extras, Optional.some(['form:']));
	      };
	      var buildContextFormGroups = function (ctx, providers) {
	        return ContextForm.buildInitGroups(ctx, providers);
	      };
	      var buildToolbar = function (toolbars) {
	        var buttons = editor.ui.registry.getAll().buttons;
	        var scopes = getScopes();
	        var allButtons = __assign(__assign({}, buttons), scopes.formNavigators);
	        var toolbarType = getToolbarMode(editor) === ToolbarMode.scrolling ? ToolbarMode.scrolling : ToolbarMode.default;
	        var initGroups = flatten(map$2(toolbars, function (ctx) {
	          return ctx.type === 'contexttoolbar' ? buildContextToolbarGroups(allButtons, ctx) : buildContextFormGroups(ctx, sharedBackstage.providers);
	        }));
	        return renderToolbar({
	          type: toolbarType,
	          uid: generate$6('context-toolbar'),
	          initGroups: initGroups,
	          onEscape: Optional.none,
	          cyclicKeying: true,
	          providers: sharedBackstage.providers
	        });
	      };
	      var getAnchor = function (position, element) {
	        var anchorage = position === 'node' ? sharedBackstage.anchors.node(element) : sharedBackstage.anchors.cursor();
	        var anchorLayout = getAnchorLayout(editor, position, isTouch(), {
	          lastElement: lastElement.get,
	          isReposition: function () {
	            return is$1(lastTrigger.get(), 0);
	          },
	          getMode: function () {
	            return Positioning.getMode(sink);
	          }
	        });
	        return deepMerge(anchorage, anchorLayout);
	      };
	      var launchContext = function (toolbarApi, elem) {
	        launchContextToolbar.cancel();
	        if (!canLaunchToolbar()) {
	          return;
	        }
	        var toolbarSpec = buildToolbar(toolbarApi);
	        var position = toolbarApi[0].position;
	        var anchor = getAnchor(position, elem);
	        lastContextPosition.set(position);
	        lastTrigger.set(1);
	        var contextBarEle = contextbar.element;
	        remove$6(contextBarEle, 'display');
	        if (!isSameLaunchElement(elem)) {
	          remove$2(contextBarEle, transitionClass);
	          Positioning.reset(sink, contextbar);
	        }
	        InlineView.showWithinBounds(contextbar, wrapInPopDialog(toolbarSpec), {
	          anchor: anchor,
	          transition: {
	            classes: [transitionClass],
	            mode: 'placement'
	          }
	        }, function () {
	          return Optional.some(getBounds());
	        });
	        elem.fold(lastElement.clear, lastElement.set);
	        if (shouldContextToolbarHide()) {
	          set$7(contextBarEle, 'display', 'none');
	        }
	      };
	      var launchContextToolbar = last(function () {
	        if (!editor.hasFocus() || editor.removed) {
	          return;
	        }
	        if (has(contextbar.element, transitionClass)) {
	          launchContextToolbar.throttle();
	        } else {
	          var scopes = getScopes();
	          lookup$1(scopes, editor).fold(close, function (info) {
	            launchContext(info.toolbars, Optional.some(info.elem));
	          });
	        }
	      }, 17);
	      editor.on('init', function () {
	        editor.on('remove', close);
	        editor.on('ScrollContent ScrollWindow ObjectResized ResizeEditor longpress', hideOrRepositionIfNecessary);
	        editor.on('click keyup focus SetContent', launchContextToolbar.throttle);
	        editor.on(hideContextToolbarEvent, close);
	        editor.on(showContextToolbarEvent, function (e) {
	          var scopes = getScopes();
	          get$e(scopes.lookupTable, e.toolbarKey).each(function (ctx) {
	            launchContext([ctx], someIf(e.target !== editor, e.target));
	            InlineView.getContent(contextbar).each(Keying.focusIn);
	          });
	        });
	        editor.on('focusout', function (_e) {
	          global$f.setEditorTimeout(editor, function () {
	            if (search(sink.element).isNone() && search(contextbar.element).isNone()) {
	              close();
	            }
	          }, 0);
	        });
	        editor.on('SwitchMode', function () {
	          if (editor.mode.isReadOnly()) {
	            close();
	          }
	        });
	        editor.on('AfterProgressState', function (event) {
	          if (event.state) {
	            close();
	          } else if (editor.hasFocus()) {
	            launchContextToolbar.throttle();
	          }
	        });
	        editor.on('NodeChange', function (_e) {
	          search(contextbar.element).fold(launchContextToolbar.throttle, noop);
	        });
	      });
	    };
	
	    var register$6 = function (editor) {
	      var alignToolbarButtons = [
	        {
	          name: 'alignleft',
	          text: 'Align left',
	          cmd: 'JustifyLeft',
	          icon: 'align-left'
	        },
	        {
	          name: 'aligncenter',
	          text: 'Align center',
	          cmd: 'JustifyCenter',
	          icon: 'align-center'
	        },
	        {
	          name: 'alignright',
	          text: 'Align right',
	          cmd: 'JustifyRight',
	          icon: 'align-right'
	        },
	        {
	          name: 'alignjustify',
	          text: 'Justify',
	          cmd: 'JustifyFull',
	          icon: 'align-justify'
	        }
	      ];
	      each$1(alignToolbarButtons, function (item) {
	        editor.ui.registry.addToggleButton(item.name, {
	          tooltip: item.text,
	          icon: item.icon,
	          onAction: onActionExecCommand(editor, item.cmd),
	          onSetup: onSetupFormatToggle(editor, item.name)
	        });
	      });
	      editor.ui.registry.addButton('alignnone', {
	        tooltip: 'No alignment',
	        icon: 'align-none',
	        onAction: onActionExecCommand(editor, 'JustifyNone')
	      });
	    };
	
	    var units = {
	      unsupportedLength: [
	        'em',
	        'ex',
	        'cap',
	        'ch',
	        'ic',
	        'rem',
	        'lh',
	        'rlh',
	        'vw',
	        'vh',
	        'vi',
	        'vb',
	        'vmin',
	        'vmax',
	        'cm',
	        'mm',
	        'Q',
	        'in',
	        'pc',
	        'pt',
	        'px'
	      ],
	      fixed: [
	        'px',
	        'pt'
	      ],
	      relative: ['%'],
	      empty: ['']
	    };
	    var pattern = function () {
	      var decimalDigits = '[0-9]+';
	      var signedInteger = '[+-]?' + decimalDigits;
	      var exponentPart = '[eE]' + signedInteger;
	      var dot = '\\.';
	      var opt = function (input) {
	        return '(?:' + input + ')?';
	      };
	      var unsignedDecimalLiteral = [
	        'Infinity',
	        decimalDigits + dot + opt(decimalDigits) + opt(exponentPart),
	        dot + decimalDigits + opt(exponentPart),
	        decimalDigits + opt(exponentPart)
	      ].join('|');
	      var float = '[+-]?(?:' + unsignedDecimalLiteral + ')';
	      return new RegExp('^(' + float + ')(.*)$');
	    }();
	    var isUnit = function (unit, accepted) {
	      return exists(accepted, function (acc) {
	        return exists(units[acc], function (check) {
	          return unit === check;
	        });
	      });
	    };
	    var parse = function (input, accepted) {
	      var match = Optional.from(pattern.exec(input));
	      return match.bind(function (array) {
	        var value = Number(array[1]);
	        var unitRaw = array[2];
	        if (isUnit(unitRaw, accepted)) {
	          return Optional.some({
	            value: value,
	            unit: unitRaw
	          });
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var normalise = function (input, accepted) {
	      return parse(input, accepted).map(function (_a) {
	        var value = _a.value, unit = _a.unit;
	        return value + unit;
	      });
	    };
	
	    var registerController = function (editor, spec) {
	      var getMenuItems = function () {
	        var options = spec.getOptions(editor);
	        var initial = spec.getCurrent(editor).map(spec.hash);
	        var current = value$1();
	        return map$2(options, function (value) {
	          return {
	            type: 'togglemenuitem',
	            text: spec.display(value),
	            onSetup: function (api) {
	              var setActive = function (active) {
	                if (active) {
	                  current.on(function (oldApi) {
	                    return oldApi.setActive(false);
	                  });
	                  current.set(api);
	                }
	                api.setActive(active);
	              };
	              setActive(is$1(initial, spec.hash(value)));
	              var unbindWatcher = spec.watcher(editor, value, setActive);
	              return function () {
	                current.clear();
	                unbindWatcher();
	              };
	            },
	            onAction: function () {
	              return spec.setCurrent(editor, value);
	            }
	          };
	        });
	      };
	      editor.ui.registry.addMenuButton(spec.name, {
	        tooltip: spec.text,
	        icon: spec.icon,
	        fetch: function (callback) {
	          return callback(getMenuItems());
	        },
	        onSetup: spec.onToolbarSetup
	      });
	      editor.ui.registry.addNestedMenuItem(spec.name, {
	        type: 'nestedmenuitem',
	        text: spec.text,
	        getSubmenuItems: getMenuItems,
	        onSetup: spec.onMenuSetup
	      });
	    };
	    var lineHeightSpec = {
	      name: 'lineheight',
	      text: 'Line height',
	      icon: 'line-height',
	      getOptions: getLineHeightFormats,
	      hash: function (input) {
	        return normalise(input, [
	          'fixed',
	          'relative',
	          'empty'
	        ]).getOr(input);
	      },
	      display: identity$1,
	      watcher: function (editor, value, callback) {
	        return editor.formatter.formatChanged('lineheight', callback, false, { value: value }).unbind;
	      },
	      getCurrent: function (editor) {
	        return Optional.from(editor.queryCommandValue('LineHeight'));
	      },
	      setCurrent: function (editor, value) {
	        return editor.execCommand('LineHeight', false, value);
	      }
	    };
	    var languageSpec = function (editor) {
	      var settingsOpt = Optional.from(getContentLanguages(editor));
	      return settingsOpt.map(function (settings) {
	        return {
	          name: 'language',
	          text: 'Language',
	          icon: 'language',
	          getOptions: constant$1(settings),
	          hash: function (input) {
	            return isUndefined(input.customCode) ? input.code : input.code + '/' + input.customCode;
	          },
	          display: function (input) {
	            return input.title;
	          },
	          watcher: function (editor, value, callback) {
	            return editor.formatter.formatChanged('lang', callback, false, {
	              value: value.code,
	              customValue: value.customCode
	            }).unbind;
	          },
	          getCurrent: function (editor) {
	            var node = SugarElement.fromDom(editor.selection.getNode());
	            return closest$4(node, function (n) {
	              return Optional.some(n).filter(isElement$2).bind(function (ele) {
	                var codeOpt = getOpt(ele, 'lang');
	                return codeOpt.map(function (code) {
	                  var customCode = getOpt(ele, 'data-mce-lang').getOrUndefined();
	                  return {
	                    code: code,
	                    customCode: customCode,
	                    title: ''
	                  };
	                });
	              });
	            });
	          },
	          setCurrent: function (editor, lang) {
	            return editor.execCommand('Lang', false, lang);
	          },
	          onToolbarSetup: function (api) {
	            var unbinder = unbindable();
	            api.setActive(editor.formatter.match('lang', {}, undefined, true));
	            unbinder.set(editor.formatter.formatChanged('lang', api.setActive, true));
	            return unbinder.clear;
	          }
	        };
	      });
	    };
	    var register$5 = function (editor) {
	      registerController(editor, lineHeightSpec);
	      languageSpec(editor).each(function (spec) {
	        return registerController(editor, spec);
	      });
	    };
	
	    var register$4 = function (editor, backstage) {
	      alignSelectMenu(editor, backstage);
	      fontSelectMenu(editor, backstage);
	      styleSelectMenu(editor, backstage);
	      formatSelectMenu(editor, backstage);
	      fontsizeSelectMenu(editor, backstage);
	    };
	
	    var onSetupOutdentState = function (editor) {
	      return onSetupEvent(editor, 'NodeChange', function (api) {
	        api.setDisabled(!editor.queryCommandState('outdent'));
	      });
	    };
	    var registerButtons$2 = function (editor) {
	      editor.ui.registry.addButton('outdent', {
	        tooltip: 'Decrease indent',
	        icon: 'outdent',
	        onSetup: onSetupOutdentState(editor),
	        onAction: onActionExecCommand(editor, 'outdent')
	      });
	      editor.ui.registry.addButton('indent', {
	        tooltip: 'Increase indent',
	        icon: 'indent',
	        onAction: onActionExecCommand(editor, 'indent')
	      });
	    };
	    var register$3 = function (editor) {
	      registerButtons$2(editor);
	    };
	
	    var onActionToggleFormat = function (editor, fmt) {
	      return function () {
	        editor.execCommand('mceToggleFormat', false, fmt);
	      };
	    };
	    var registerFormatButtons = function (editor) {
	      global$5.each([
	        {
	          name: 'bold',
	          text: 'Bold',
	          icon: 'bold'
	        },
	        {
	          name: 'italic',
	          text: 'Italic',
	          icon: 'italic'
	        },
	        {
	          name: 'underline',
	          text: 'Underline',
	          icon: 'underline'
	        },
	        {
	          name: 'strikethrough',
	          text: 'Strikethrough',
	          icon: 'strike-through'
	        },
	        {
	          name: 'subscript',
	          text: 'Subscript',
	          icon: 'subscript'
	        },
	        {
	          name: 'superscript',
	          text: 'Superscript',
	          icon: 'superscript'
	        }
	      ], function (btn, _idx) {
	        editor.ui.registry.addToggleButton(btn.name, {
	          tooltip: btn.text,
	          icon: btn.icon,
	          onSetup: onSetupFormatToggle(editor, btn.name),
	          onAction: onActionToggleFormat(editor, btn.name)
	        });
	      });
	      for (var i = 1; i <= 6; i++) {
	        var name_1 = 'h' + i;
	        editor.ui.registry.addToggleButton(name_1, {
	          text: name_1.toUpperCase(),
	          tooltip: 'Heading ' + i,
	          onSetup: onSetupFormatToggle(editor, name_1),
	          onAction: onActionToggleFormat(editor, name_1)
	        });
	      }
	    };
	    var registerCommandButtons = function (editor) {
	      global$5.each([
	        {
	          name: 'cut',
	          text: 'Cut',
	          action: 'Cut',
	          icon: 'cut'
	        },
	        {
	          name: 'copy',
	          text: 'Copy',
	          action: 'Copy',
	          icon: 'copy'
	        },
	        {
	          name: 'paste',
	          text: 'Paste',
	          action: 'Paste',
	          icon: 'paste'
	        },
	        {
	          name: 'help',
	          text: 'Help',
	          action: 'mceHelp',
	          icon: 'help'
	        },
	        {
	          name: 'selectall',
	          text: 'Select all',
	          action: 'SelectAll',
	          icon: 'select-all'
	        },
	        {
	          name: 'newdocument',
	          text: 'New document',
	          action: 'mceNewDocument',
	          icon: 'new-document'
	        },
	        {
	          name: 'removeformat',
	          text: 'Clear formatting',
	          action: 'RemoveFormat',
	          icon: 'remove-formatting'
	        },
	        {
	          name: 'remove',
	          text: 'Remove',
	          action: 'Delete',
	          icon: 'remove'
	        }
	      ], function (btn) {
	        editor.ui.registry.addButton(btn.name, {
	          tooltip: btn.text,
	          icon: btn.icon,
	          onAction: onActionExecCommand(editor, btn.action)
	        });
	      });
	    };
	    var registerCommandToggleButtons = function (editor) {
	      global$5.each([{
	          name: 'blockquote',
	          text: 'Blockquote',
	          action: 'mceBlockQuote',
	          icon: 'quote'
	        }], function (btn) {
	        editor.ui.registry.addToggleButton(btn.name, {
	          tooltip: btn.text,
	          icon: btn.icon,
	          onAction: onActionExecCommand(editor, btn.action),
	          onSetup: onSetupFormatToggle(editor, btn.name)
	        });
	      });
	    };
	    var registerButtons$1 = function (editor) {
	      registerFormatButtons(editor);
	      registerCommandButtons(editor);
	      registerCommandToggleButtons(editor);
	    };
	    var registerMenuItems$2 = function (editor) {
	      global$5.each([
	        {
	          name: 'bold',
	          text: 'Bold',
	          action: 'Bold',
	          icon: 'bold',
	          shortcut: 'Meta+B'
	        },
	        {
	          name: 'italic',
	          text: 'Italic',
	          action: 'Italic',
	          icon: 'italic',
	          shortcut: 'Meta+I'
	        },
	        {
	          name: 'underline',
	          text: 'Underline',
	          action: 'Underline',
	          icon: 'underline',
	          shortcut: 'Meta+U'
	        },
	        {
	          name: 'strikethrough',
	          text: 'Strikethrough',
	          action: 'Strikethrough',
	          icon: 'strike-through',
	          shortcut: ''
	        },
	        {
	          name: 'subscript',
	          text: 'Subscript',
	          action: 'Subscript',
	          icon: 'subscript',
	          shortcut: ''
	        },
	        {
	          name: 'superscript',
	          text: 'Superscript',
	          action: 'Superscript',
	          icon: 'superscript',
	          shortcut: ''
	        },
	        {
	          name: 'removeformat',
	          text: 'Clear formatting',
	          action: 'RemoveFormat',
	          icon: 'remove-formatting',
	          shortcut: ''
	        },
	        {
	          name: 'newdocument',
	          text: 'New document',
	          action: 'mceNewDocument',
	          icon: 'new-document',
	          shortcut: ''
	        },
	        {
	          name: 'cut',
	          text: 'Cut',
	          action: 'Cut',
	          icon: 'cut',
	          shortcut: 'Meta+X'
	        },
	        {
	          name: 'copy',
	          text: 'Copy',
	          action: 'Copy',
	          icon: 'copy',
	          shortcut: 'Meta+C'
	        },
	        {
	          name: 'paste',
	          text: 'Paste',
	          action: 'Paste',
	          icon: 'paste',
	          shortcut: 'Meta+V'
	        },
	        {
	          name: 'selectall',
	          text: 'Select all',
	          action: 'SelectAll',
	          icon: 'select-all',
	          shortcut: 'Meta+A'
	        }
	      ], function (btn) {
	        editor.ui.registry.addMenuItem(btn.name, {
	          text: btn.text,
	          icon: btn.icon,
	          shortcut: btn.shortcut,
	          onAction: onActionExecCommand(editor, btn.action)
	        });
	      });
	      editor.ui.registry.addMenuItem('codeformat', {
	        text: 'Code',
	        icon: 'sourcecode',
	        onAction: onActionToggleFormat(editor, 'code')
	      });
	    };
	    var register$2 = function (editor) {
	      registerButtons$1(editor);
	      registerMenuItems$2(editor);
	    };
	
	    var onSetupUndoRedoState = function (editor, type) {
	      return onSetupEvent(editor, 'Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', function (api) {
	        api.setDisabled(editor.mode.isReadOnly() || !editor.undoManager[type]());
	      });
	    };
	    var registerMenuItems$1 = function (editor) {
	      editor.ui.registry.addMenuItem('undo', {
	        text: 'Undo',
	        icon: 'undo',
	        shortcut: 'Meta+Z',
	        onSetup: onSetupUndoRedoState(editor, 'hasUndo'),
	        onAction: onActionExecCommand(editor, 'undo')
	      });
	      editor.ui.registry.addMenuItem('redo', {
	        text: 'Redo',
	        icon: 'redo',
	        shortcut: 'Meta+Y',
	        onSetup: onSetupUndoRedoState(editor, 'hasRedo'),
	        onAction: onActionExecCommand(editor, 'redo')
	      });
	    };
	    var registerButtons = function (editor) {
	      editor.ui.registry.addButton('undo', {
	        tooltip: 'Undo',
	        icon: 'undo',
	        disabled: true,
	        onSetup: onSetupUndoRedoState(editor, 'hasUndo'),
	        onAction: onActionExecCommand(editor, 'undo')
	      });
	      editor.ui.registry.addButton('redo', {
	        tooltip: 'Redo',
	        icon: 'redo',
	        disabled: true,
	        onSetup: onSetupUndoRedoState(editor, 'hasRedo'),
	        onAction: onActionExecCommand(editor, 'redo')
	      });
	    };
	    var register$1 = function (editor) {
	      registerMenuItems$1(editor);
	      registerButtons(editor);
	    };
	
	    var onSetupVisualAidState = function (editor) {
	      return onSetupEvent(editor, 'VisualAid', function (api) {
	        api.setActive(editor.hasVisual);
	      });
	    };
	    var registerMenuItems = function (editor) {
	      editor.ui.registry.addToggleMenuItem('visualaid', {
	        text: 'Visual aids',
	        onSetup: onSetupVisualAidState(editor),
	        onAction: onActionExecCommand(editor, 'mceToggleVisualAid')
	      });
	    };
	    var registerToolbarButton = function (editor) {
	      editor.ui.registry.addButton('visualaid', {
	        tooltip: 'Visual aids',
	        text: 'Visual aids',
	        onAction: onActionExecCommand(editor, 'mceToggleVisualAid')
	      });
	    };
	    var register = function (editor) {
	      registerToolbarButton(editor);
	      registerMenuItems(editor);
	    };
	
	    var setup$6 = function (editor, backstage) {
	      register$6(editor);
	      register$2(editor);
	      register$4(editor, backstage);
	      register$1(editor);
	      register$a(editor);
	      register(editor);
	      register$3(editor);
	      register$5(editor);
	    };
	
	    var nu = function (x, y) {
	      return {
	        type: 'makeshift',
	        x: x,
	        y: y
	      };
	    };
	    var transpose = function (pos, dx, dy) {
	      return nu(pos.x + dx, pos.y + dy);
	    };
	    var isTouchEvent = function (e) {
	      return e.type === 'longpress' || e.type.indexOf('touch') === 0;
	    };
	    var fromPageXY = function (e) {
	      if (isTouchEvent(e)) {
	        var touch = e.touches[0];
	        return nu(touch.pageX, touch.pageY);
	      } else {
	        return nu(e.pageX, e.pageY);
	      }
	    };
	    var fromClientXY = function (e) {
	      if (isTouchEvent(e)) {
	        var touch = e.touches[0];
	        return nu(touch.clientX, touch.clientY);
	      } else {
	        return nu(e.clientX, e.clientY);
	      }
	    };
	    var transposeContentAreaContainer = function (element, pos) {
	      var containerPos = global$b.DOM.getPos(element);
	      return transpose(pos, containerPos.x, containerPos.y);
	    };
	    var getPointAnchor = function (editor, e) {
	      if (e.type === 'contextmenu' || e.type === 'longpress') {
	        if (editor.inline) {
	          return fromPageXY(e);
	        } else {
	          return transposeContentAreaContainer(editor.getContentAreaContainer(), fromClientXY(e));
	        }
	      } else {
	        return getSelectionAnchor(editor);
	      }
	    };
	    var getSelectionAnchor = function (editor) {
	      return {
	        type: 'selection',
	        root: SugarElement.fromDom(editor.selection.getNode())
	      };
	    };
	    var getNodeAnchor = function (editor) {
	      return {
	        type: 'node',
	        node: Optional.some(SugarElement.fromDom(editor.selection.getNode())),
	        root: SugarElement.fromDom(editor.getBody())
	      };
	    };
	    var getAnchorSpec$1 = function (editor, e, anchorType) {
	      switch (anchorType) {
	      case 'node':
	        return getNodeAnchor(editor);
	      case 'point':
	        return getPointAnchor(editor, e);
	      case 'selection':
	        return getSelectionAnchor(editor);
	      }
	    };
	
	    var initAndShow$1 = function (editor, e, buildMenu, backstage, contextmenu, anchorType) {
	      var items = buildMenu();
	      var anchorSpec = getAnchorSpec$1(editor, e, anchorType);
	      build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false).map(function (menuData) {
	        e.preventDefault();
	        InlineView.showMenuAt(contextmenu, { anchor: anchorSpec }, {
	          menu: { markers: markers('normal') },
	          data: menuData
	        });
	      });
	    };
	
	    var layouts = {
	      onLtr: function () {
	        return [
	          south$2,
	          southeast$2,
	          southwest$2,
	          northeast$2,
	          northwest$2,
	          north$2,
	          north,
	          south,
	          northeast,
	          southeast,
	          northwest,
	          southwest
	        ];
	      },
	      onRtl: function () {
	        return [
	          south$2,
	          southwest$2,
	          southeast$2,
	          northwest$2,
	          northeast$2,
	          north$2,
	          north,
	          south,
	          northwest,
	          southwest,
	          northeast,
	          southeast
	        ];
	      }
	    };
	    var bubbleSize = 12;
	    var bubbleAlignments = {
	      valignCentre: [],
	      alignCentre: [],
	      alignLeft: ['tox-pop--align-left'],
	      alignRight: ['tox-pop--align-right'],
	      right: ['tox-pop--right'],
	      left: ['tox-pop--left'],
	      bottom: ['tox-pop--bottom'],
	      top: ['tox-pop--top']
	    };
	    var isTouchWithinSelection = function (editor, e) {
	      var selection = editor.selection;
	      if (selection.isCollapsed() || e.touches.length < 1) {
	        return false;
	      } else {
	        var touch_1 = e.touches[0];
	        var rng = selection.getRng();
	        var rngRectOpt = getFirstRect(editor.getWin(), SimSelection.domRange(rng));
	        return rngRectOpt.exists(function (rngRect) {
	          return rngRect.left <= touch_1.clientX && rngRect.right >= touch_1.clientX && rngRect.top <= touch_1.clientY && rngRect.bottom >= touch_1.clientY;
	        });
	      }
	    };
	    var setupiOSOverrides = function (editor) {
	      var originalSelection = editor.selection.getRng();
	      var selectionReset = function () {
	        global$f.setEditorTimeout(editor, function () {
	          editor.selection.setRng(originalSelection);
	        }, 10);
	        unbindEventListeners();
	      };
	      editor.once('touchend', selectionReset);
	      var preventMousedown = function (e) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      };
	      editor.on('mousedown', preventMousedown, true);
	      var clearSelectionReset = function () {
	        return unbindEventListeners();
	      };
	      editor.once('longpresscancel', clearSelectionReset);
	      var unbindEventListeners = function () {
	        editor.off('touchend', selectionReset);
	        editor.off('longpresscancel', clearSelectionReset);
	        editor.off('mousedown', preventMousedown);
	      };
	    };
	    var getAnchorSpec = function (editor, e, anchorType) {
	      var anchorSpec = getAnchorSpec$1(editor, e, anchorType);
	      var bubbleYOffset = anchorType === 'point' ? bubbleSize : 0;
	      return __assign({
	        bubble: nu$5(0, bubbleYOffset, bubbleAlignments),
	        layouts: layouts,
	        overrides: {
	          maxWidthFunction: expandable(),
	          maxHeightFunction: expandable$1()
	        }
	      }, anchorSpec);
	    };
	    var show = function (editor, e, items, backstage, contextmenu, anchorType, highlightImmediately) {
	      var anchorSpec = getAnchorSpec(editor, e, anchorType);
	      build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, true).map(function (menuData) {
	        e.preventDefault();
	        InlineView.showMenuWithinBounds(contextmenu, { anchor: anchorSpec }, {
	          menu: {
	            markers: markers('normal'),
	            highlightImmediately: highlightImmediately
	          },
	          data: menuData,
	          type: 'horizontal'
	        }, function () {
	          return Optional.some(getContextToolbarBounds(editor, backstage.shared, anchorType === 'node' ? 'node' : 'selection'));
	        });
	        editor.fire(hideContextToolbarEvent);
	      });
	    };
	    var initAndShow = function (editor, e, buildMenu, backstage, contextmenu, anchorType) {
	      var detection = detect$1();
	      var isiOS = detection.os.isiOS();
	      var isOSX = detection.os.isOSX();
	      var isAndroid = detection.os.isAndroid();
	      var isTouch = detection.deviceType.isTouch();
	      var shouldHighlightImmediately = function () {
	        return !(isAndroid || isiOS || isOSX && isTouch);
	      };
	      var open = function () {
	        var items = buildMenu();
	        show(editor, e, items, backstage, contextmenu, anchorType, shouldHighlightImmediately());
	      };
	      if ((isOSX || isiOS) && anchorType !== 'node') {
	        var openiOS_1 = function () {
	          setupiOSOverrides(editor);
	          open();
	        };
	        if (isTouchWithinSelection(editor, e)) {
	          openiOS_1();
	        } else {
	          editor.once('selectionchange', openiOS_1);
	          editor.once('touchend', function () {
	            return editor.off('selectionchange', openiOS_1);
	          });
	        }
	      } else {
	        open();
	      }
	    };
	
	    var patchPipeConfig = function (config) {
	      return typeof config === 'string' ? config.split(/[ ,]/) : config;
	    };
	    var shouldNeverUseNative = function (editor) {
	      return editor.getParam('contextmenu_never_use_native', false, 'boolean');
	    };
	    var getMenuItems = function (editor, name, defaultItems) {
	      var contextMenus = editor.ui.registry.getAll().contextMenus;
	      return Optional.from(editor.getParam(name)).map(patchPipeConfig).getOrThunk(function () {
	        return filter$2(patchPipeConfig(defaultItems), function (item) {
	          return has$2(contextMenus, item);
	        });
	      });
	    };
	    var isContextMenuDisabled = function (editor) {
	      return editor.getParam('contextmenu') === false;
	    };
	    var getContextMenu = function (editor) {
	      return getMenuItems(editor, 'contextmenu', 'link linkchecker image imagetools table spellchecker configurepermanentpen');
	    };
	    var getAvoidOverlapSelector = function (editor) {
	      return editor.getParam('contextmenu_avoid_overlap', '', 'string');
	    };
	
	    var isSeparator = function (item) {
	      return isString(item) ? item === '|' : item.type === 'separator';
	    };
	    var separator = { type: 'separator' };
	    var makeContextItem = function (item) {
	      var commonMenuItem = function (item) {
	        return {
	          text: item.text,
	          icon: item.icon,
	          disabled: item.disabled,
	          shortcut: item.shortcut
	        };
	      };
	      if (isString(item)) {
	        return item;
	      } else {
	        switch (item.type) {
	        case 'separator':
	          return separator;
	        case 'submenu':
	          return __assign(__assign({ type: 'nestedmenuitem' }, commonMenuItem(item)), {
	            getSubmenuItems: function () {
	              var items = item.getSubmenuItems();
	              if (isString(items)) {
	                return items;
	              } else {
	                return map$2(items, makeContextItem);
	              }
	            }
	          });
	        default:
	          return __assign(__assign({ type: 'menuitem' }, commonMenuItem(item)), { onAction: noarg(item.onAction) });
	        }
	      }
	    };
	    var addContextMenuGroup = function (xs, groupItems) {
	      if (groupItems.length === 0) {
	        return xs;
	      }
	      var lastMenuItem = last$2(xs).filter(function (item) {
	        return !isSeparator(item);
	      });
	      var before = lastMenuItem.fold(function () {
	        return [];
	      }, function (_) {
	        return [separator];
	      });
	      return xs.concat(before).concat(groupItems).concat([separator]);
	    };
	    var generateContextMenu = function (contextMenus, menuConfig, selectedElement) {
	      var sections = foldl(menuConfig, function (acc, name) {
	        return get$e(contextMenus, name.toLowerCase()).map(function (menu) {
	          var items = menu.update(selectedElement);
	          if (isString(items)) {
	            return addContextMenuGroup(acc, items.split(' '));
	          } else if (items.length > 0) {
	            var allItems = map$2(items, makeContextItem);
	            return addContextMenuGroup(acc, allItems);
	          } else {
	            return acc;
	          }
	        }).getOrThunk(function () {
	          return acc.concat([name]);
	        });
	      }, []);
	      if (sections.length > 0 && isSeparator(sections[sections.length - 1])) {
	        sections.pop();
	      }
	      return sections;
	    };
	    var isNativeOverrideKeyEvent = function (editor, e) {
	      return e.ctrlKey && !shouldNeverUseNative(editor);
	    };
	    var isTriggeredByKeyboard = function (editor, e) {
	      return e.type !== 'longpress' && (e.button !== 2 || e.target === editor.getBody() && e.pointerType === '');
	    };
	    var getSelectedElement = function (editor, e) {
	      return isTriggeredByKeyboard(editor, e) ? editor.selection.getStart(true) : e.target;
	    };
	    var getAnchorType = function (editor, e) {
	      var selector = getAvoidOverlapSelector(editor);
	      var anchorType = isTriggeredByKeyboard(editor, e) ? 'selection' : 'point';
	      if (isNotEmpty(selector)) {
	        var target = getSelectedElement(editor, e);
	        var selectorExists = closest(SugarElement.fromDom(target), selector);
	        return selectorExists ? 'node' : anchorType;
	      } else {
	        return anchorType;
	      }
	    };
	    var setup$5 = function (editor, lazySink, backstage) {
	      var detection = detect$1();
	      var isTouch = detection.deviceType.isTouch;
	      var contextmenu = build$1(InlineView.sketch({
	        dom: { tag: 'div' },
	        lazySink: lazySink,
	        onEscape: function () {
	          return editor.focus();
	        },
	        onShow: function () {
	          return backstage.setContextMenuState(true);
	        },
	        onHide: function () {
	          return backstage.setContextMenuState(false);
	        },
	        fireDismissalEventInstead: {},
	        inlineBehaviours: derive$1([config('dismissContextMenu', [run$1(dismissRequested(), function (comp, _se) {
	              Sandboxing.close(comp);
	              editor.focus();
	            })])])
	      }));
	      var hideContextMenu = function (_e) {
	        return InlineView.hide(contextmenu);
	      };
	      var showContextMenu = function (e) {
	        if (shouldNeverUseNative(editor)) {
	          e.preventDefault();
	        }
	        if (isNativeOverrideKeyEvent(editor, e) || isContextMenuDisabled(editor)) {
	          return;
	        }
	        var anchorType = getAnchorType(editor, e);
	        var buildMenu = function () {
	          var selectedElement = getSelectedElement(editor, e);
	          var registry = editor.ui.registry.getAll();
	          var menuConfig = getContextMenu(editor);
	          return generateContextMenu(registry.contextMenus, menuConfig, selectedElement);
	        };
	        var initAndShow$2 = isTouch() ? initAndShow : initAndShow$1;
	        initAndShow$2(editor, e, buildMenu, backstage, contextmenu, anchorType);
	      };
	      editor.on('init', function () {
	        var hideEvents = 'ResizeEditor ScrollContent ScrollWindow longpresscancel' + (isTouch() ? '' : ' ResizeWindow');
	        editor.on(hideEvents, hideContextMenu);
	        editor.on('longpress contextmenu', showContextMenu);
	      });
	    };
	
	    var adt = Adt.generate([
	      {
	        offset: [
	          'x',
	          'y'
	        ]
	      },
	      {
	        absolute: [
	          'x',
	          'y'
	        ]
	      },
	      {
	        fixed: [
	          'x',
	          'y'
	        ]
	      }
	    ]);
	    var subtract = function (change) {
	      return function (point) {
	        return point.translate(-change.left, -change.top);
	      };
	    };
	    var add = function (change) {
	      return function (point) {
	        return point.translate(change.left, change.top);
	      };
	    };
	    var transform = function (changes) {
	      return function (x, y) {
	        return foldl(changes, function (rest, f) {
	          return f(rest);
	        }, SugarPosition(x, y));
	      };
	    };
	    var asFixed = function (coord, scroll, origin) {
	      return coord.fold(transform([
	        add(origin),
	        subtract(scroll)
	      ]), transform([subtract(scroll)]), transform([]));
	    };
	    var asAbsolute = function (coord, scroll, origin) {
	      return coord.fold(transform([add(origin)]), transform([]), transform([add(scroll)]));
	    };
	    var asOffset = function (coord, scroll, origin) {
	      return coord.fold(transform([]), transform([subtract(origin)]), transform([
	        add(scroll),
	        subtract(origin)
	      ]));
	    };
	    var withinRange = function (coord1, coord2, xRange, yRange, scroll, origin) {
	      var a1 = asAbsolute(coord1, scroll, origin);
	      var a2 = asAbsolute(coord2, scroll, origin);
	      return Math.abs(a1.left - a2.left) <= xRange && Math.abs(a1.top - a2.top) <= yRange;
	    };
	    var getDeltas = function (coord1, coord2, xRange, yRange, scroll, origin) {
	      var a1 = asAbsolute(coord1, scroll, origin);
	      var a2 = asAbsolute(coord2, scroll, origin);
	      var left = Math.abs(a1.left - a2.left);
	      var top = Math.abs(a1.top - a2.top);
	      return SugarPosition(left, top);
	    };
	    var toStyles = function (coord, scroll, origin) {
	      var stylesOpt = coord.fold(function (x, y) {
	        return {
	          position: Optional.some('absolute'),
	          left: Optional.some(x + 'px'),
	          top: Optional.some(y + 'px')
	        };
	      }, function (x, y) {
	        return {
	          position: Optional.some('absolute'),
	          left: Optional.some(x - origin.left + 'px'),
	          top: Optional.some(y - origin.top + 'px')
	        };
	      }, function (x, y) {
	        return {
	          position: Optional.some('fixed'),
	          left: Optional.some(x + 'px'),
	          top: Optional.some(y + 'px')
	        };
	      });
	      return __assign({
	        right: Optional.none(),
	        bottom: Optional.none()
	      }, stylesOpt);
	    };
	    var translate = function (coord, deltaX, deltaY) {
	      return coord.fold(function (x, y) {
	        return offset(x + deltaX, y + deltaY);
	      }, function (x, y) {
	        return absolute(x + deltaX, y + deltaY);
	      }, function (x, y) {
	        return fixed(x + deltaX, y + deltaY);
	      });
	    };
	    var absorb = function (partialCoord, originalCoord, scroll, origin) {
	      var absorbOne = function (stencil, nu) {
	        return function (optX, optY) {
	          var original = stencil(originalCoord, scroll, origin);
	          return nu(optX.getOr(original.left), optY.getOr(original.top));
	        };
	      };
	      return partialCoord.fold(absorbOne(asOffset, offset), absorbOne(asAbsolute, absolute), absorbOne(asFixed, fixed));
	    };
	    var offset = adt.offset;
	    var absolute = adt.absolute;
	    var fixed = adt.fixed;
	
	    var parseAttrToInt = function (element, name) {
	      var value = get$d(element, name);
	      return isUndefined(value) ? NaN : parseInt(value, 10);
	    };
	    var get = function (component, snapsInfo) {
	      var element = component.element;
	      var x = parseAttrToInt(element, snapsInfo.leftAttr);
	      var y = parseAttrToInt(element, snapsInfo.topAttr);
	      return isNaN(x) || isNaN(y) ? Optional.none() : Optional.some(SugarPosition(x, y));
	    };
	    var set = function (component, snapsInfo, pt) {
	      var element = component.element;
	      set$8(element, snapsInfo.leftAttr, pt.left + 'px');
	      set$8(element, snapsInfo.topAttr, pt.top + 'px');
	    };
	    var clear = function (component, snapsInfo) {
	      var element = component.element;
	      remove$7(element, snapsInfo.leftAttr);
	      remove$7(element, snapsInfo.topAttr);
	    };
	
	    var getCoords = function (component, snapInfo, coord, delta) {
	      return get(component, snapInfo).fold(function () {
	        return coord;
	      }, function (fixed$1) {
	        return fixed(fixed$1.left + delta.left, fixed$1.top + delta.top);
	      });
	    };
	    var moveOrSnap = function (component, snapInfo, coord, delta, scroll, origin) {
	      var newCoord = getCoords(component, snapInfo, coord, delta);
	      var snap = snapInfo.mustSnap ? findClosestSnap(component, snapInfo, newCoord, scroll, origin) : findSnap(component, snapInfo, newCoord, scroll, origin);
	      var fixedCoord = asFixed(newCoord, scroll, origin);
	      set(component, snapInfo, fixedCoord);
	      return snap.fold(function () {
	        return {
	          coord: fixed(fixedCoord.left, fixedCoord.top),
	          extra: Optional.none()
	        };
	      }, function (spanned) {
	        return {
	          coord: spanned.output,
	          extra: spanned.extra
	        };
	      });
	    };
	    var stopDrag = function (component, snapInfo) {
	      clear(component, snapInfo);
	    };
	    var findMatchingSnap = function (snaps, newCoord, scroll, origin) {
	      return findMap(snaps, function (snap) {
	        var sensor = snap.sensor;
	        var inRange = withinRange(newCoord, sensor, snap.range.left, snap.range.top, scroll, origin);
	        return inRange ? Optional.some({
	          output: absorb(snap.output, newCoord, scroll, origin),
	          extra: snap.extra
	        }) : Optional.none();
	      });
	    };
	    var findClosestSnap = function (component, snapInfo, newCoord, scroll, origin) {
	      var snaps = snapInfo.getSnapPoints(component);
	      var matchSnap = findMatchingSnap(snaps, newCoord, scroll, origin);
	      return matchSnap.orThunk(function () {
	        var bestSnap = foldl(snaps, function (acc, snap) {
	          var sensor = snap.sensor;
	          var deltas = getDeltas(newCoord, sensor, snap.range.left, snap.range.top, scroll, origin);
	          return acc.deltas.fold(function () {
	            return {
	              deltas: Optional.some(deltas),
	              snap: Optional.some(snap)
	            };
	          }, function (bestDeltas) {
	            var currAvg = (deltas.left + deltas.top) / 2;
	            var bestAvg = (bestDeltas.left + bestDeltas.top) / 2;
	            if (currAvg <= bestAvg) {
	              return {
	                deltas: Optional.some(deltas),
	                snap: Optional.some(snap)
	              };
	            } else {
	              return acc;
	            }
	          });
	        }, {
	          deltas: Optional.none(),
	          snap: Optional.none()
	        });
	        return bestSnap.snap.map(function (snap) {
	          return {
	            output: absorb(snap.output, newCoord, scroll, origin),
	            extra: snap.extra
	          };
	        });
	      });
	    };
	    var findSnap = function (component, snapInfo, newCoord, scroll, origin) {
	      var snaps = snapInfo.getSnapPoints(component);
	      return findMatchingSnap(snaps, newCoord, scroll, origin);
	    };
	    var snapTo$1 = function (snap, scroll, origin) {
	      return {
	        coord: absorb(snap.output, snap.output, scroll, origin),
	        extra: snap.extra
	      };
	    };
	
	    var snapTo = function (component, dragConfig, _state, snap) {
	      var target = dragConfig.getTarget(component.element);
	      if (dragConfig.repositionTarget) {
	        var doc = owner$4(component.element);
	        var scroll_1 = get$9(doc);
	        var origin_1 = getOrigin(target);
	        var snapPin = snapTo$1(snap, scroll_1, origin_1);
	        var styles = toStyles(snapPin.coord, scroll_1, origin_1);
	        setOptions(target, styles);
	      }
	    };
	
	    var DraggingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        snapTo: snapTo
	    });
	
	    var initialAttribute = 'data-initial-z-index';
	    var resetZIndex = function (blocker) {
	      parent(blocker.element).filter(isElement$2).each(function (root) {
	        getOpt(root, initialAttribute).fold(function () {
	          return remove$6(root, 'z-index');
	        }, function (zIndex) {
	          return set$7(root, 'z-index', zIndex);
	        });
	        remove$7(root, initialAttribute);
	      });
	    };
	    var changeZIndex = function (blocker) {
	      parent(blocker.element).filter(isElement$2).each(function (root) {
	        getRaw(root, 'z-index').each(function (zindex) {
	          set$8(root, initialAttribute, zindex);
	        });
	        set$7(root, 'z-index', get$c(blocker.element, 'z-index'));
	      });
	    };
	    var instigate = function (anyComponent, blocker) {
	      anyComponent.getSystem().addToGui(blocker);
	      changeZIndex(blocker);
	    };
	    var discard = function (blocker) {
	      resetZIndex(blocker);
	      blocker.getSystem().removeFromGui(blocker);
	    };
	    var createComponent = function (component, blockerClass, blockerEvents) {
	      return component.getSystem().build(Container.sketch({
	        dom: {
	          styles: {
	            'left': '0px',
	            'top': '0px',
	            'width': '100%',
	            'height': '100%',
	            'position': 'fixed',
	            'z-index': '1000000000000000'
	          },
	          classes: [blockerClass]
	        },
	        events: blockerEvents
	      }));
	    };
	
	    var SnapSchema = optionObjOf('snaps', [
	      required$1('getSnapPoints'),
	      onHandler('onSensor'),
	      required$1('leftAttr'),
	      required$1('topAttr'),
	      defaulted('lazyViewport', win),
	      defaulted('mustSnap', false)
	    ]);
	
	    var schema$6 = [
	      defaulted('useFixed', never),
	      required$1('blockerClass'),
	      defaulted('getTarget', identity$1),
	      defaulted('onDrag', noop),
	      defaulted('repositionTarget', true),
	      defaulted('onDrop', noop),
	      defaultedFunction('getBounds', win),
	      SnapSchema
	    ];
	
	    var getCurrentCoord = function (target) {
	      return lift3(getRaw(target, 'left'), getRaw(target, 'top'), getRaw(target, 'position'), function (left, top, position) {
	        var nu = position === 'fixed' ? fixed : offset;
	        return nu(parseInt(left, 10), parseInt(top, 10));
	      }).getOrThunk(function () {
	        var location = absolute$3(target);
	        return absolute(location.left, location.top);
	      });
	    };
	    var clampCoords = function (component, coords, scroll, origin, startData) {
	      var bounds = startData.bounds;
	      var absoluteCoord = asAbsolute(coords, scroll, origin);
	      var newX = clamp$1(absoluteCoord.left, bounds.x, bounds.x + bounds.width - startData.width);
	      var newY = clamp$1(absoluteCoord.top, bounds.y, bounds.y + bounds.height - startData.height);
	      var newCoords = absolute(newX, newY);
	      return coords.fold(function () {
	        var offset$1 = asOffset(newCoords, scroll, origin);
	        return offset(offset$1.left, offset$1.top);
	      }, constant$1(newCoords), function () {
	        var fixed$1 = asFixed(newCoords, scroll, origin);
	        return fixed(fixed$1.left, fixed$1.top);
	      });
	    };
	    var calcNewCoord = function (component, optSnaps, currentCoord, scroll, origin, delta, startData) {
	      var newCoord = optSnaps.fold(function () {
	        var translated = translate(currentCoord, delta.left, delta.top);
	        var fixedCoord = asFixed(translated, scroll, origin);
	        return fixed(fixedCoord.left, fixedCoord.top);
	      }, function (snapInfo) {
	        var snapping = moveOrSnap(component, snapInfo, currentCoord, delta, scroll, origin);
	        snapping.extra.each(function (extra) {
	          snapInfo.onSensor(component, extra);
	        });
	        return snapping.coord;
	      });
	      return clampCoords(component, newCoord, scroll, origin, startData);
	    };
	    var dragBy = function (component, dragConfig, startData, delta) {
	      var target = dragConfig.getTarget(component.element);
	      if (dragConfig.repositionTarget) {
	        var doc = owner$4(component.element);
	        var scroll_1 = get$9(doc);
	        var origin_1 = getOrigin(target);
	        var currentCoord = getCurrentCoord(target);
	        var newCoord = calcNewCoord(component, dragConfig.snaps, currentCoord, scroll_1, origin_1, delta, startData);
	        var styles = toStyles(newCoord, scroll_1, origin_1);
	        setOptions(target, styles);
	      }
	      dragConfig.onDrag(component, target, delta);
	    };
	
	    var calcStartData = function (dragConfig, comp) {
	      return {
	        bounds: dragConfig.getBounds(),
	        height: getOuter$2(comp.element),
	        width: getOuter$1(comp.element)
	      };
	    };
	    var move = function (component, dragConfig, dragState, dragMode, event) {
	      var delta = dragState.update(dragMode, event);
	      var dragStartData = dragState.getStartData().getOrThunk(function () {
	        return calcStartData(dragConfig, component);
	      });
	      delta.each(function (dlt) {
	        dragBy(component, dragConfig, dragStartData, dlt);
	      });
	    };
	    var stop = function (component, blocker, dragConfig, dragState) {
	      blocker.each(discard);
	      dragConfig.snaps.each(function (snapInfo) {
	        stopDrag(component, snapInfo);
	      });
	      var target = dragConfig.getTarget(component.element);
	      dragState.reset();
	      dragConfig.onDrop(component, target);
	    };
	    var handlers = function (events) {
	      return function (dragConfig, dragState) {
	        var updateStartState = function (comp) {
	          dragState.setStartData(calcStartData(dragConfig, comp));
	        };
	        return derive$2(__spreadArray([run$1(windowScroll(), function (comp) {
	            dragState.getStartData().each(function () {
	              return updateStartState(comp);
	            });
	          })], events(dragConfig, dragState, updateStartState), true));
	      };
	    };
	
	    var init$2 = function (dragApi) {
	      return derive$2([
	        run$1(mousedown(), dragApi.forceDrop),
	        run$1(mouseup(), dragApi.drop),
	        run$1(mousemove(), function (comp, simulatedEvent) {
	          dragApi.move(simulatedEvent.event);
	        }),
	        run$1(mouseout(), dragApi.delayDrop)
	      ]);
	    };
	
	    var getData$1 = function (event) {
	      return Optional.from(SugarPosition(event.x, event.y));
	    };
	    var getDelta$1 = function (old, nu) {
	      return SugarPosition(nu.left - old.left, nu.top - old.top);
	    };
	
	    var MouseData = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getData: getData$1,
	        getDelta: getDelta$1
	    });
	
	    var events$2 = function (dragConfig, dragState, updateStartState) {
	      return [run$1(mousedown(), function (component, simulatedEvent) {
	          var raw = simulatedEvent.event.raw;
	          if (raw.button !== 0) {
	            return;
	          }
	          simulatedEvent.stop();
	          var stop$1 = function () {
	            return stop(component, Optional.some(blocker), dragConfig, dragState);
	          };
	          var delayDrop = DelayedFunction(stop$1, 200);
	          var dragApi = {
	            drop: stop$1,
	            delayDrop: delayDrop.schedule,
	            forceDrop: stop$1,
	            move: function (event) {
	              delayDrop.cancel();
	              move(component, dragConfig, dragState, MouseData, event);
	            }
	          };
	          var blocker = createComponent(component, dragConfig.blockerClass, init$2(dragApi));
	          var start = function () {
	            updateStartState(component);
	            instigate(component, blocker);
	          };
	          start();
	        })];
	    };
	    var schema$5 = __spreadArray(__spreadArray([], schema$6, true), [output$1('dragger', { handlers: handlers(events$2) })], false);
	
	    var init$1 = function (dragApi) {
	      return derive$2([
	        run$1(touchstart(), dragApi.forceDrop),
	        run$1(touchend(), dragApi.drop),
	        run$1(touchcancel(), dragApi.drop),
	        run$1(touchmove(), function (comp, simulatedEvent) {
	          dragApi.move(simulatedEvent.event);
	        })
	      ]);
	    };
	
	    var getDataFrom = function (touches) {
	      var touch = touches[0];
	      return Optional.some(SugarPosition(touch.clientX, touch.clientY));
	    };
	    var getData = function (event) {
	      var raw = event.raw;
	      var touches = raw.touches;
	      return touches.length === 1 ? getDataFrom(touches) : Optional.none();
	    };
	    var getDelta = function (old, nu) {
	      return SugarPosition(nu.left - old.left, nu.top - old.top);
	    };
	
	    var TouchData = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getData: getData,
	        getDelta: getDelta
	    });
	
	    var events$1 = function (dragConfig, dragState, updateStartState) {
	      var blockerSingleton = value$1();
	      var stopBlocking = function (component) {
	        stop(component, blockerSingleton.get(), dragConfig, dragState);
	        blockerSingleton.clear();
	      };
	      return [
	        run$1(touchstart(), function (component, simulatedEvent) {
	          simulatedEvent.stop();
	          var stop = function () {
	            return stopBlocking(component);
	          };
	          var dragApi = {
	            drop: stop,
	            delayDrop: noop,
	            forceDrop: stop,
	            move: function (event) {
	              move(component, dragConfig, dragState, TouchData, event);
	            }
	          };
	          var blocker = createComponent(component, dragConfig.blockerClass, init$1(dragApi));
	          blockerSingleton.set(blocker);
	          var start = function () {
	            updateStartState(component);
	            instigate(component, blocker);
	          };
	          start();
	        }),
	        run$1(touchmove(), function (component, simulatedEvent) {
	          simulatedEvent.stop();
	          move(component, dragConfig, dragState, TouchData, simulatedEvent.event);
	        }),
	        run$1(touchend(), function (component, simulatedEvent) {
	          simulatedEvent.stop();
	          stopBlocking(component);
	        }),
	        run$1(touchcancel(), stopBlocking)
	      ];
	    };
	    var schema$4 = __spreadArray(__spreadArray([], schema$6, true), [output$1('dragger', { handlers: handlers(events$1) })], false);
	
	    var events = function (dragConfig, dragState, updateStartState) {
	      return __spreadArray(__spreadArray([], events$2(dragConfig, dragState, updateStartState), true), events$1(dragConfig, dragState, updateStartState), true);
	    };
	    var schema$3 = __spreadArray(__spreadArray([], schema$6, true), [output$1('dragger', { handlers: handlers(events) })], false);
	
	    var mouse = schema$5;
	    var touch = schema$4;
	    var mouseOrTouch = schema$3;
	
	    var DraggingBranches = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        mouse: mouse,
	        touch: touch,
	        mouseOrTouch: mouseOrTouch
	    });
	
	    var init = function () {
	      var previous = Optional.none();
	      var startData = Optional.none();
	      var reset = function () {
	        previous = Optional.none();
	        startData = Optional.none();
	      };
	      var calculateDelta = function (mode, nu) {
	        var result = previous.map(function (old) {
	          return mode.getDelta(old, nu);
	        });
	        previous = Optional.some(nu);
	        return result;
	      };
	      var update = function (mode, dragEvent) {
	        return mode.getData(dragEvent).bind(function (nuData) {
	          return calculateDelta(mode, nuData);
	        });
	      };
	      var setStartData = function (data) {
	        startData = Optional.some(data);
	      };
	      var getStartData = function () {
	        return startData;
	      };
	      var readState = constant$1({});
	      return nu$8({
	        readState: readState,
	        reset: reset,
	        update: update,
	        getStartData: getStartData,
	        setStartData: setStartData
	      });
	    };
	
	    var DragState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init
	    });
	
	    var Dragging = createModes({
	      branchKey: 'mode',
	      branches: DraggingBranches,
	      name: 'dragging',
	      active: {
	        events: function (dragConfig, dragState) {
	          var dragger = dragConfig.dragger;
	          return dragger.handlers(dragConfig, dragState);
	        }
	      },
	      extra: {
	        snap: function (sConfig) {
	          return {
	            sensor: sConfig.sensor,
	            range: sConfig.range,
	            output: sConfig.output,
	            extra: Optional.from(sConfig.extra)
	          };
	        }
	      },
	      state: DragState,
	      apis: DraggingApis
	    });
	
	    var snapWidth = 40;
	    var snapOffset = snapWidth / 2;
	    var calcSnap = function (selectorOpt, td, x, y, width, height) {
	      return selectorOpt.fold(function () {
	        return Dragging.snap({
	          sensor: absolute(x - snapOffset, y - snapOffset),
	          range: SugarPosition(width, height),
	          output: absolute(Optional.some(x), Optional.some(y)),
	          extra: { td: td }
	        });
	      }, function (selectorHandle) {
	        var sensorLeft = x - snapOffset;
	        var sensorTop = y - snapOffset;
	        var sensorWidth = snapWidth;
	        var sensorHeight = snapWidth;
	        var rect = selectorHandle.element.dom.getBoundingClientRect();
	        return Dragging.snap({
	          sensor: absolute(sensorLeft, sensorTop),
	          range: SugarPosition(sensorWidth, sensorHeight),
	          output: absolute(Optional.some(x - rect.width / 2), Optional.some(y - rect.height / 2)),
	          extra: { td: td }
	        });
	      });
	    };
	    var getSnapsConfig = function (getSnapPoints, cell, onChange) {
	      var isSameCell = function (cellOpt, td) {
	        return cellOpt.exists(function (currentTd) {
	          return eq(currentTd, td);
	        });
	      };
	      return {
	        getSnapPoints: getSnapPoints,
	        leftAttr: 'data-drag-left',
	        topAttr: 'data-drag-top',
	        onSensor: function (component, extra) {
	          var td = extra.td;
	          if (!isSameCell(cell.get(), td)) {
	            cell.set(td);
	            onChange(td);
	          }
	        },
	        mustSnap: true
	      };
	    };
	    var createSelector = function (snaps) {
	      return record(Button.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-selector']
	        },
	        buttonBehaviours: derive$1([
	          Dragging.config({
	            mode: 'mouseOrTouch',
	            blockerClass: 'blocker',
	            snaps: snaps
	          }),
	          Unselecting.config({})
	        ]),
	        eventOrder: {
	          mousedown: [
	            'dragging',
	            'alloy.base.behaviour'
	          ],
	          touchstart: [
	            'dragging',
	            'alloy.base.behaviour'
	          ]
	        }
	      }));
	    };
	    var setup$4 = function (editor, sink) {
	      var tlTds = Cell([]);
	      var brTds = Cell([]);
	      var isVisible = Cell(false);
	      var startCell = value$1();
	      var finishCell = value$1();
	      var getTopLeftSnap = function (td) {
	        var box = absolute$2(td);
	        return calcSnap(memTopLeft.getOpt(sink), td, box.x, box.y, box.width, box.height);
	      };
	      var getTopLeftSnaps = function () {
	        return map$2(tlTds.get(), function (td) {
	          return getTopLeftSnap(td);
	        });
	      };
	      var getBottomRightSnap = function (td) {
	        var box = absolute$2(td);
	        return calcSnap(memBottomRight.getOpt(sink), td, box.right, box.bottom, box.width, box.height);
	      };
	      var getBottomRightSnaps = function () {
	        return map$2(brTds.get(), function (td) {
	          return getBottomRightSnap(td);
	        });
	      };
	      var topLeftSnaps = getSnapsConfig(getTopLeftSnaps, startCell, function (start) {
	        finishCell.get().each(function (finish) {
	          editor.fire('TableSelectorChange', {
	            start: start,
	            finish: finish
	          });
	        });
	      });
	      var bottomRightSnaps = getSnapsConfig(getBottomRightSnaps, finishCell, function (finish) {
	        startCell.get().each(function (start) {
	          editor.fire('TableSelectorChange', {
	            start: start,
	            finish: finish
	          });
	        });
	      });
	      var memTopLeft = createSelector(topLeftSnaps);
	      var memBottomRight = createSelector(bottomRightSnaps);
	      var topLeft = build$1(memTopLeft.asSpec());
	      var bottomRight = build$1(memBottomRight.asSpec());
	      var showOrHideHandle = function (selector, cell, isAbove, isBelow) {
	        var cellRect = cell.dom.getBoundingClientRect();
	        remove$6(selector.element, 'display');
	        var viewportHeight = defaultView(SugarElement.fromDom(editor.getBody())).dom.innerHeight;
	        var aboveViewport = isAbove(cellRect);
	        var belowViewport = isBelow(cellRect, viewportHeight);
	        if (aboveViewport || belowViewport) {
	          set$7(selector.element, 'display', 'none');
	        }
	      };
	      var snapTo = function (selector, cell, getSnapConfig, pos) {
	        var snap = getSnapConfig(cell);
	        Dragging.snapTo(selector, snap);
	        var isAbove = function (rect) {
	          return rect[pos] < 0;
	        };
	        var isBelow = function (rect, viewportHeight) {
	          return rect[pos] > viewportHeight;
	        };
	        showOrHideHandle(selector, cell, isAbove, isBelow);
	      };
	      var snapTopLeft = function (cell) {
	        return snapTo(topLeft, cell, getTopLeftSnap, 'top');
	      };
	      var snapLastTopLeft = function () {
	        return startCell.get().each(snapTopLeft);
	      };
	      var snapBottomRight = function (cell) {
	        return snapTo(bottomRight, cell, getBottomRightSnap, 'bottom');
	      };
	      var snapLastBottomRight = function () {
	        return finishCell.get().each(snapBottomRight);
	      };
	      if (detect$1().deviceType.isTouch()) {
	        editor.on('TableSelectionChange', function (e) {
	          if (!isVisible.get()) {
	            attach(sink, topLeft);
	            attach(sink, bottomRight);
	            isVisible.set(true);
	          }
	          startCell.set(e.start);
	          finishCell.set(e.finish);
	          e.otherCells.each(function (otherCells) {
	            tlTds.set(otherCells.upOrLeftCells);
	            brTds.set(otherCells.downOrRightCells);
	            snapTopLeft(e.start);
	            snapBottomRight(e.finish);
	          });
	        });
	        editor.on('ResizeEditor ResizeWindow ScrollContent', function () {
	          snapLastTopLeft();
	          snapLastBottomRight();
	        });
	        editor.on('TableSelectionClear', function () {
	          if (isVisible.get()) {
	            detach(topLeft);
	            detach(bottomRight);
	            isVisible.set(false);
	          }
	          startCell.clear();
	          finishCell.clear();
	        });
	      }
	    };
	
	    var isHidden = function (elm) {
	      if (elm.nodeType === 1) {
	        if (elm.nodeName === 'BR' || !!elm.getAttribute('data-mce-bogus')) {
	          return true;
	        }
	        if (elm.getAttribute('data-mce-type') === 'bookmark') {
	          return true;
	        }
	      }
	      return false;
	    };
	    var renderElementPath = function (editor, settings, providersBackstage) {
	      if (!settings.delimiter) {
	        settings.delimiter = '\xBB';
	      }
	      var getDataPath = function (data) {
	        var parts = data || [];
	        var newPathElements = map$2(parts, function (part, index) {
	          return Button.sketch({
	            dom: {
	              tag: 'div',
	              classes: ['tox-statusbar__path-item'],
	              attributes: {
	                'role': 'button',
	                'data-index': index,
	                'tab-index': -1,
	                'aria-level': index + 1
	              },
	              innerHtml: part.name
	            },
	            action: function (_btn) {
	              editor.focus();
	              editor.selection.select(part.element);
	              editor.nodeChanged();
	            },
	            buttonBehaviours: derive$1([
	              DisablingConfigs.button(providersBackstage.isDisabled),
	              receivingConfig()
	            ])
	          });
	        });
	        var divider = {
	          dom: {
	            tag: 'div',
	            classes: ['tox-statusbar__path-divider'],
	            attributes: { 'aria-hidden': true },
	            innerHtml: ' ' + settings.delimiter + ' '
	          }
	        };
	        return foldl(newPathElements.slice(1), function (acc, element) {
	          var newAcc = acc;
	          newAcc.push(divider);
	          newAcc.push(element);
	          return newAcc;
	        }, [newPathElements[0]]);
	      };
	      var updatePath = function (parents) {
	        var newPath = [];
	        var i = parents.length;
	        while (i-- > 0) {
	          var parent_1 = parents[i];
	          if (parent_1.nodeType === 1 && !isHidden(parent_1)) {
	            var args = editor.fire('ResolveName', {
	              name: parent_1.nodeName.toLowerCase(),
	              target: parent_1
	            });
	            if (!args.isDefaultPrevented()) {
	              newPath.push({
	                name: args.name,
	                element: parent_1
	              });
	            }
	            if (args.isPropagationStopped()) {
	              break;
	            }
	          }
	        }
	        return newPath;
	      };
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-statusbar__path'],
	          attributes: { role: 'navigation' }
	        },
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'flow',
	            selector: 'div[role=button]'
	          }),
	          Disabling.config({ disabled: providersBackstage.isDisabled }),
	          receivingConfig(),
	          Tabstopping.config({}),
	          Replacing.config({}),
	          config('elementPathEvents', [runOnAttached(function (comp, _e) {
	              editor.shortcuts.add('alt+F11', 'focus statusbar elementpath', function () {
	                return Keying.focusIn(comp);
	              });
	              editor.on('NodeChange', function (e) {
	                var newPath = updatePath(e.parents);
	                if (newPath.length > 0) {
	                  Replacing.set(comp, getDataPath(newPath));
	                } else {
	                  Replacing.set(comp, []);
	                }
	              });
	            })])
	        ]),
	        components: []
	      };
	    };
	
	    var ResizeTypes;
	    (function (ResizeTypes) {
	      ResizeTypes[ResizeTypes['None'] = 0] = 'None';
	      ResizeTypes[ResizeTypes['Both'] = 1] = 'Both';
	      ResizeTypes[ResizeTypes['Vertical'] = 2] = 'Vertical';
	    }(ResizeTypes || (ResizeTypes = {})));
	    var getDimensions = function (editor, deltas, resizeType, originalHeight, originalWidth) {
	      var dimensions = {};
	      dimensions.height = calcCappedSize(originalHeight + deltas.top, getMinHeightSetting(editor), getMaxHeightSetting(editor));
	      if (resizeType === ResizeTypes.Both) {
	        dimensions.width = calcCappedSize(originalWidth + deltas.left, getMinWidthSetting(editor), getMaxWidthSetting(editor));
	      }
	      return dimensions;
	    };
	    var resize = function (editor, deltas, resizeType) {
	      var container = SugarElement.fromDom(editor.getContainer());
	      var dimensions = getDimensions(editor, deltas, resizeType, get$b(container), get$a(container));
	      each(dimensions, function (val, dim) {
	        return set$7(container, dim, numToPx(val));
	      });
	      fireResizeEditor(editor);
	    };
	
	    var getResizeType = function (editor) {
	      var fallback = !editor.hasPlugin('autoresize');
	      var resize = editor.getParam('resize', fallback);
	      if (resize === false) {
	        return ResizeTypes.None;
	      } else if (resize === 'both') {
	        return ResizeTypes.Both;
	      } else {
	        return ResizeTypes.Vertical;
	      }
	    };
	    var keyboardHandler = function (editor, resizeType, x, y) {
	      var scale = 20;
	      var delta = SugarPosition(x * scale, y * scale);
	      resize(editor, delta, resizeType);
	      return Optional.some(true);
	    };
	    var renderResizeHandler = function (editor, providersBackstage) {
	      var resizeType = getResizeType(editor);
	      if (resizeType === ResizeTypes.None) {
	        return Optional.none();
	      }
	      return Optional.some(render$3('resize-handle', {
	        tag: 'div',
	        classes: ['tox-statusbar__resize-handle'],
	        attributes: { title: providersBackstage.translate('Resize') },
	        behaviours: [
	          Dragging.config({
	            mode: 'mouse',
	            repositionTarget: false,
	            onDrag: function (_comp, _target, delta) {
	              return resize(editor, delta, resizeType);
	            },
	            blockerClass: 'tox-blocker'
	          }),
	          Keying.config({
	            mode: 'special',
	            onLeft: function () {
	              return keyboardHandler(editor, resizeType, -1, 0);
	            },
	            onRight: function () {
	              return keyboardHandler(editor, resizeType, 1, 0);
	            },
	            onUp: function () {
	              return keyboardHandler(editor, resizeType, 0, -1);
	            },
	            onDown: function () {
	              return keyboardHandler(editor, resizeType, 0, 1);
	            }
	          }),
	          Tabstopping.config({}),
	          Focusing.config({})
	        ]
	      }, providersBackstage.icons));
	    };
	
	    var renderWordCount = function (editor, providersBackstage) {
	      var _a;
	      var replaceCountText = function (comp, count, mode) {
	        return Replacing.set(comp, [text$1(providersBackstage.translate([
	            '{0} ' + mode,
	            count[mode]
	          ]))]);
	      };
	      return Button.sketch({
	        dom: {
	          tag: 'button',
	          classes: ['tox-statusbar__wordcount']
	        },
	        components: [],
	        buttonBehaviours: derive$1([
	          DisablingConfigs.button(providersBackstage.isDisabled),
	          receivingConfig(),
	          Tabstopping.config({}),
	          Replacing.config({}),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: {
	                mode: 'words',
	                count: {
	                  words: 0,
	                  characters: 0
	                }
	              }
	            }
	          }),
	          config('wordcount-events', [
	            runOnExecute$1(function (comp) {
	              var currentVal = Representing.getValue(comp);
	              var newMode = currentVal.mode === 'words' ? 'characters' : 'words';
	              Representing.setValue(comp, {
	                mode: newMode,
	                count: currentVal.count
	              });
	              replaceCountText(comp, currentVal.count, newMode);
	            }),
	            runOnAttached(function (comp) {
	              editor.on('wordCountUpdate', function (e) {
	                var mode = Representing.getValue(comp).mode;
	                Representing.setValue(comp, {
	                  mode: mode,
	                  count: e.wordCount
	                });
	                replaceCountText(comp, e.wordCount, mode);
	              });
	            })
	          ])
	        ]),
	        eventOrder: (_a = {}, _a[execute$5()] = [
	          'disabling',
	          'alloy.base.behaviour',
	          'wordcount-events'
	        ], _a)
	      });
	    };
	
	    var renderStatusbar = function (editor, providersBackstage) {
	      var renderBranding = function () {
	        var label = global$e.translate([
	          'Powered by {0}',
	          'Tiny'
	        ]);
	        var linkHtml = '<a href="https://www.tiny.cloud/?utm_campaign=editor_referral&amp;utm_medium=poweredby&amp;utm_source=tinymce&amp;utm_content=v5" rel="noopener" target="_blank" tabindex="-1" aria-label="' + label + '">' + label + '</a>';
	        return {
	          dom: {
	            tag: 'span',
	            classes: ['tox-statusbar__branding'],
	            innerHtml: linkHtml
	          }
	        };
	      };
	      var getTextComponents = function () {
	        var components = [];
	        if (editor.getParam('elementpath', true, 'boolean')) {
	          components.push(renderElementPath(editor, {}, providersBackstage));
	        }
	        if (editor.hasPlugin('wordcount')) {
	          components.push(renderWordCount(editor, providersBackstage));
	        }
	        if (editor.getParam('branding', true, 'boolean')) {
	          components.push(renderBranding());
	        }
	        if (components.length > 0) {
	          return [{
	              dom: {
	                tag: 'div',
	                classes: ['tox-statusbar__text-container']
	              },
	              components: components
	            }];
	        }
	        return [];
	      };
	      var getComponents = function () {
	        var components = getTextComponents();
	        var resizeHandler = renderResizeHandler(editor, providersBackstage);
	        return components.concat(resizeHandler.toArray());
	      };
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-statusbar']
	        },
	        components: getComponents()
	      };
	    };
	
	    var setup$3 = function (editor) {
	      var _a;
	      var isInline = editor.inline;
	      var mode = isInline ? Inline : Iframe;
	      var header = isStickyToolbar(editor) ? StickyHeader : StaticHeader;
	      var lazyOuterContainer = Optional.none();
	      var platform = detect$1();
	      var isIE = platform.browser.isIE();
	      var platformClasses = isIE ? ['tox-platform-ie'] : [];
	      var isTouch = platform.deviceType.isTouch();
	      var touchPlatformClass = 'tox-platform-touch';
	      var deviceClasses = isTouch ? [touchPlatformClass] : [];
	      var isToolbarBottom = isToolbarLocationBottom(editor);
	      var uiContainer = getUiContainer(editor);
	      var dirAttributes = global$e.isRtl() ? { attributes: { dir: 'rtl' } } : {};
	      var verticalDirAttributes = { attributes: (_a = {}, _a[Attribute] = isToolbarBottom ? AttributeValue.BottomToTop : AttributeValue.TopToBottom, _a) };
	      var lazyHeader = function () {
	        return lazyOuterContainer.bind(OuterContainer.getHeader);
	      };
	      var isHeaderDocked = function () {
	        return header.isDocked(lazyHeader);
	      };
	      var resizeUiMothership = function () {
	        set$7(uiMothership.element, 'width', document.body.clientWidth + 'px');
	      };
	      var makeSinkDefinition = function () {
	        var isGridUiContainer = eq(body(), uiContainer) && get$c(uiContainer, 'display') === 'grid';
	        var sinkSpec = {
	          dom: __assign({
	            tag: 'div',
	            classes: [
	              'tox',
	              'tox-silver-sink',
	              'tox-tinymce-aux'
	            ].concat(platformClasses).concat(deviceClasses)
	          }, dirAttributes),
	          behaviours: derive$1([Positioning.config({
	              useFixed: function () {
	                return isHeaderDocked();
	              }
	            })])
	        };
	        var reactiveWidthSpec = {
	          dom: { styles: { width: document.body.clientWidth + 'px' } },
	          events: derive$2([run$1(windowResize(), resizeUiMothership)])
	        };
	        return deepMerge(sinkSpec, isGridUiContainer ? reactiveWidthSpec : {});
	      };
	      var sink = build$1(makeSinkDefinition());
	      var lazySink = function () {
	        return Result.value(sink);
	      };
	      var memAnchorBar = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-anchorbar']
	        }
	      });
	      var lazyAnchorBar = function () {
	        return lazyOuterContainer.bind(function (container) {
	          return memAnchorBar.getOpt(container);
	        }).getOrDie('Could not find a anchor bar element');
	      };
	      var lazyToolbar = function () {
	        return lazyOuterContainer.bind(function (container) {
	          return OuterContainer.getToolbar(container);
	        }).getOrDie('Could not find more toolbar element');
	      };
	      var lazyThrobber = function () {
	        return lazyOuterContainer.bind(function (container) {
	          return OuterContainer.getThrobber(container);
	        }).getOrDie('Could not find throbber element');
	      };
	      var backstage = init$7(sink, editor, lazyAnchorBar);
	      var partMenubar = OuterContainer.parts.menubar({
	        dom: {
	          tag: 'div',
	          classes: ['tox-menubar']
	        },
	        backstage: backstage,
	        onEscape: function () {
	          editor.focus();
	        }
	      });
	      var toolbarMode = getToolbarMode(editor);
	      var partToolbar = OuterContainer.parts.toolbar(__assign({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar']
	        },
	        getSink: lazySink,
	        providers: backstage.shared.providers,
	        onEscape: function () {
	          editor.focus();
	        },
	        type: toolbarMode,
	        lazyToolbar: lazyToolbar,
	        lazyHeader: function () {
	          return lazyHeader().getOrDie('Could not find header element');
	        }
	      }, verticalDirAttributes));
	      var partMultipleToolbar = OuterContainer.parts['multiple-toolbar']({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar-overlord']
	        },
	        providers: backstage.shared.providers,
	        onEscape: function () {
	          editor.focus();
	        },
	        type: toolbarMode
	      });
	      var partSocket = OuterContainer.parts.socket({
	        dom: {
	          tag: 'div',
	          classes: ['tox-edit-area']
	        }
	      });
	      var partSidebar = OuterContainer.parts.sidebar({
	        dom: {
	          tag: 'div',
	          classes: ['tox-sidebar']
	        }
	      });
	      var partThrobber = OuterContainer.parts.throbber({
	        dom: {
	          tag: 'div',
	          classes: ['tox-throbber']
	        },
	        backstage: backstage
	      });
	      var sb = editor.getParam('statusbar', true, 'boolean');
	      var statusbar = sb && !isInline ? Optional.some(renderStatusbar(editor, backstage.shared.providers)) : Optional.none();
	      var socketSidebarContainer = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-sidebar-wrap']
	        },
	        components: [
	          partSocket,
	          partSidebar
	        ]
	      };
	      var hasMultipleToolbar = isMultipleToolbars(editor);
	      var hasToolbar = isToolbarEnabled(editor);
	      var hasMenubar = isMenubarEnabled(editor);
	      var getPartToolbar = function () {
	        if (hasMultipleToolbar) {
	          return [partMultipleToolbar];
	        } else if (hasToolbar) {
	          return [partToolbar];
	        } else {
	          return [];
	        }
	      };
	      var partHeader = OuterContainer.parts.header({
	        dom: __assign({
	          tag: 'div',
	          classes: ['tox-editor-header']
	        }, verticalDirAttributes),
	        components: flatten([
	          hasMenubar ? [partMenubar] : [],
	          getPartToolbar(),
	          useFixedContainer(editor) ? [] : [memAnchorBar.asSpec()]
	        ]),
	        sticky: isStickyToolbar(editor),
	        editor: editor,
	        sharedBackstage: backstage.shared
	      });
	      var editorComponents = flatten([
	        isToolbarBottom ? [] : [partHeader],
	        isInline ? [] : [socketSidebarContainer],
	        isToolbarBottom ? [partHeader] : []
	      ]);
	      var editorContainer = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-editor-container']
	        },
	        components: editorComponents
	      };
	      var containerComponents = flatten([
	        [editorContainer],
	        isInline ? [] : statusbar.toArray(),
	        [partThrobber]
	      ]);
	      var isHidden = isDistractionFree(editor);
	      var attributes = __assign(__assign({ role: 'application' }, global$e.isRtl() ? { dir: 'rtl' } : {}), isHidden ? { 'aria-hidden': 'true' } : {});
	      var outerContainer = build$1(OuterContainer.sketch({
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox',
	            'tox-tinymce'
	          ].concat(isInline ? ['tox-tinymce-inline'] : []).concat(isToolbarBottom ? ['tox-tinymce--toolbar-bottom'] : []).concat(deviceClasses).concat(platformClasses),
	          styles: __assign({ visibility: 'hidden' }, isHidden ? {
	            opacity: '0',
	            border: '0'
	          } : {}),
	          attributes: attributes
	        },
	        components: containerComponents,
	        behaviours: derive$1([
	          receivingConfig(),
	          Disabling.config({ disableClass: 'tox-tinymce--disabled' }),
	          Keying.config({
	            mode: 'cyclic',
	            selector: '.tox-menubar, .tox-toolbar, .tox-toolbar__primary, .tox-toolbar__overflow--open, .tox-sidebar__overflow--open, .tox-statusbar__path, .tox-statusbar__wordcount, .tox-statusbar__branding a, .tox-statusbar__resize-handle'
	          })
	        ])
	      }));
	      lazyOuterContainer = Optional.some(outerContainer);
	      editor.shortcuts.add('alt+F9', 'focus menubar', function () {
	        OuterContainer.focusMenubar(outerContainer);
	      });
	      editor.shortcuts.add('alt+F10', 'focus toolbar', function () {
	        OuterContainer.focusToolbar(outerContainer);
	      });
	      editor.addCommand('ToggleToolbarDrawer', function () {
	        OuterContainer.toggleToolbarDrawer(outerContainer);
	      });
	      editor.addQueryStateHandler('ToggleToolbarDrawer', function () {
	        return OuterContainer.isToolbarDrawerToggled(outerContainer);
	      });
	      var mothership = takeover(outerContainer);
	      var uiMothership = takeover(sink);
	      setup$b(editor, mothership, uiMothership);
	      var getUi = function () {
	        var channels = {
	          broadcastAll: uiMothership.broadcast,
	          broadcastOn: uiMothership.broadcastOn,
	          register: noop
	        };
	        return { channels: channels };
	      };
	      var setEditorSize = function () {
	        var parsedHeight = numToPx(getHeightWithFallback(editor));
	        var parsedWidth = numToPx(getWidthWithFallback(editor));
	        if (!editor.inline) {
	          if (isValidValue('div', 'width', parsedWidth)) {
	            set$7(outerContainer.element, 'width', parsedWidth);
	          }
	          if (isValidValue('div', 'height', parsedHeight)) {
	            set$7(outerContainer.element, 'height', parsedHeight);
	          } else {
	            set$7(outerContainer.element, 'height', '200px');
	          }
	        }
	        return parsedHeight;
	      };
	      var renderUI = function () {
	        header.setup(editor, backstage.shared, lazyHeader);
	        setup$6(editor, backstage);
	        setup$5(editor, lazySink, backstage);
	        setup$8(editor);
	        setup$7(editor, lazyThrobber, backstage.shared);
	        map$1(getToolbarGroups(editor), function (toolbarGroupButtonConfig, name) {
	          editor.ui.registry.addGroupToolbarButton(name, toolbarGroupButtonConfig);
	        });
	        var _a = editor.ui.registry.getAll(), buttons = _a.buttons, menuItems = _a.menuItems, contextToolbars = _a.contextToolbars, sidebars = _a.sidebars;
	        var toolbarOpt = getMultipleToolbarsSetting(editor);
	        var rawUiConfig = {
	          menuItems: menuItems,
	          menus: getMenus(editor),
	          menubar: getMenubar(editor),
	          toolbar: toolbarOpt.getOrThunk(function () {
	            return getToolbar(editor);
	          }),
	          allowToolbarGroups: toolbarMode === ToolbarMode.floating,
	          buttons: buttons,
	          sidebar: sidebars
	        };
	        register$7(editor, contextToolbars, sink, { backstage: backstage });
	        setup$4(editor, sink);
	        var elm = editor.getElement();
	        var height = setEditorSize();
	        var uiComponents = {
	          mothership: mothership,
	          uiMothership: uiMothership,
	          outerContainer: outerContainer
	        };
	        var args = {
	          targetNode: elm,
	          height: height
	        };
	        return mode.render(editor, uiComponents, rawUiConfig, backstage, args);
	      };
	      return {
	        mothership: mothership,
	        uiMothership: uiMothership,
	        backstage: backstage,
	        renderUI: renderUI,
	        getUi: getUi
	      };
	    };
	
	    var describedBy = function (describedElement, describeElement) {
	      var describeId = Optional.from(get$d(describedElement, 'id')).fold(function () {
	        var id = generate$6('dialog-describe');
	        set$8(describeElement, 'id', id);
	        return id;
	      }, identity$1);
	      set$8(describedElement, 'aria-describedby', describeId);
	    };
	
	    var labelledBy = function (labelledElement, labelElement) {
	      var labelId = getOpt(labelledElement, 'id').fold(function () {
	        var id = generate$6('dialog-label');
	        set$8(labelElement, 'id', id);
	        return id;
	      }, identity$1);
	      set$8(labelledElement, 'aria-labelledby', labelId);
	    };
	
	    var schema$2 = constant$1([
	      required$1('lazySink'),
	      option('dragBlockClass'),
	      defaultedFunction('getBounds', win),
	      defaulted('useTabstopAt', always),
	      defaulted('eventOrder', {}),
	      field('modalBehaviours', [Keying]),
	      onKeyboardHandler('onExecute'),
	      onStrictKeyboardHandler('onEscape')
	    ]);
	    var basic = { sketch: identity$1 };
	    var parts$2 = constant$1([
	      optional({
	        name: 'draghandle',
	        overrides: function (detail, spec) {
	          return {
	            behaviours: derive$1([Dragging.config({
	                mode: 'mouse',
	                getTarget: function (handle) {
	                  return ancestor(handle, '[role="dialog"]').getOr(handle);
	                },
	                blockerClass: detail.dragBlockClass.getOrDie(new Error('The drag blocker class was not specified for a dialog with a drag handle: \n' + JSON.stringify(spec, null, 2)).message),
	                getBounds: detail.getDragBounds
	              })])
	          };
	        }
	      }),
	      required({
	        schema: [required$1('dom')],
	        name: 'title'
	      }),
	      required({
	        factory: basic,
	        schema: [required$1('dom')],
	        name: 'close'
	      }),
	      required({
	        factory: basic,
	        schema: [required$1('dom')],
	        name: 'body'
	      }),
	      optional({
	        factory: basic,
	        schema: [required$1('dom')],
	        name: 'footer'
	      }),
	      external$1({
	        factory: {
	          sketch: function (spec, detail) {
	            return __assign(__assign({}, spec), {
	              dom: detail.dom,
	              components: detail.components
	            });
	          }
	        },
	        schema: [
	          defaulted('dom', {
	            tag: 'div',
	            styles: {
	              position: 'fixed',
	              left: '0px',
	              top: '0px',
	              right: '0px',
	              bottom: '0px'
	            }
	          }),
	          defaulted('components', [])
	        ],
	        name: 'blocker'
	      })
	    ]);
	
	    var factory$4 = function (detail, components, spec, externals) {
	      var _a;
	      var dialogComp = value$1();
	      var showDialog = function (dialog) {
	        dialogComp.set(dialog);
	        var sink = detail.lazySink(dialog).getOrDie();
	        var externalBlocker = externals.blocker();
	        var blocker = sink.getSystem().build(__assign(__assign({}, externalBlocker), {
	          components: externalBlocker.components.concat([premade(dialog)]),
	          behaviours: derive$1([
	            Focusing.config({}),
	            config('dialog-blocker-events', [runOnSource(focusin(), function () {
	                Keying.focusIn(dialog);
	              })])
	          ])
	        }));
	        attach(sink, blocker);
	        Keying.focusIn(dialog);
	      };
	      var hideDialog = function (dialog) {
	        dialogComp.clear();
	        parent(dialog.element).each(function (blockerDom) {
	          dialog.getSystem().getByDom(blockerDom).each(function (blocker) {
	            detach(blocker);
	          });
	        });
	      };
	      var getDialogBody = function (dialog) {
	        return getPartOrDie(dialog, detail, 'body');
	      };
	      var getDialogFooter = function (dialog) {
	        return getPartOrDie(dialog, detail, 'footer');
	      };
	      var setBusy = function (dialog, getBusySpec) {
	        Blocking.block(dialog, getBusySpec);
	      };
	      var setIdle = function (dialog) {
	        Blocking.unblock(dialog);
	      };
	      var modalEventsId = generate$6('modal-events');
	      var eventOrder = __assign(__assign({}, detail.eventOrder), (_a = {}, _a[attachedToDom()] = [modalEventsId].concat(detail.eventOrder['alloy.system.attached'] || []), _a));
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        apis: {
	          show: showDialog,
	          hide: hideDialog,
	          getBody: getDialogBody,
	          getFooter: getDialogFooter,
	          setIdle: setIdle,
	          setBusy: setBusy
	        },
	        eventOrder: eventOrder,
	        domModification: {
	          attributes: {
	            'role': 'dialog',
	            'aria-modal': 'true'
	          }
	        },
	        behaviours: augment(detail.modalBehaviours, [
	          Replacing.config({}),
	          Keying.config({
	            mode: 'cyclic',
	            onEnter: detail.onExecute,
	            onEscape: detail.onEscape,
	            useTabstopAt: detail.useTabstopAt
	          }),
	          Blocking.config({ getRoot: dialogComp.get }),
	          config(modalEventsId, [runOnAttached(function (c) {
	              labelledBy(c.element, getPartOrDie(c, detail, 'title').element);
	              describedBy(c.element, getPartOrDie(c, detail, 'body').element);
	            })])
	        ])
	      };
	    };
	    var ModalDialog = composite({
	      name: 'ModalDialog',
	      configFields: schema$2(),
	      partFields: parts$2(),
	      factory: factory$4,
	      apis: {
	        show: function (apis, dialog) {
	          apis.show(dialog);
	        },
	        hide: function (apis, dialog) {
	          apis.hide(dialog);
	        },
	        getBody: function (apis, dialog) {
	          return apis.getBody(dialog);
	        },
	        getFooter: function (apis, dialog) {
	          return apis.getFooter(dialog);
	        },
	        setBusy: function (apis, dialog, getBusySpec) {
	          apis.setBusy(dialog, getBusySpec);
	        },
	        setIdle: function (apis, dialog) {
	          apis.setIdle(dialog);
	        }
	      }
	    });
	
	    var dialogToggleMenuItemSchema = objOf([
	      requiredString('type'),
	      requiredString('name')
	    ].concat(commonMenuItemFields));
	    var dialogToggleMenuItemDataProcessor = boolean;
	
	    var baseFooterButtonFields = [
	      field$1('name', 'name', defaultedThunk(function () {
	        return generate$6('button-name');
	      }), string),
	      optionString('icon'),
	      defaultedStringEnum('align', 'end', [
	        'start',
	        'end'
	      ]),
	      defaultedBoolean('primary', false),
	      defaultedBoolean('disabled', false)
	    ];
	    var dialogFooterButtonFields = __spreadArray(__spreadArray([], baseFooterButtonFields, true), [requiredString('text')], false);
	    var normalFooterButtonFields = __spreadArray([requiredStringEnum('type', [
	        'submit',
	        'cancel',
	        'custom'
	      ])], dialogFooterButtonFields, true);
	    var menuFooterButtonFields = __spreadArray([
	      requiredStringEnum('type', ['menu']),
	      optionString('text'),
	      optionString('tooltip'),
	      optionString('icon'),
	      requiredArrayOf('items', dialogToggleMenuItemSchema)
	    ], baseFooterButtonFields, true);
	    var dialogFooterButtonSchema = choose$1('type', {
	      submit: normalFooterButtonFields,
	      cancel: normalFooterButtonFields,
	      custom: normalFooterButtonFields,
	      menu: menuFooterButtonFields
	    });
	
	    var alertBannerFields = [
	      requiredString('type'),
	      requiredString('text'),
	      requiredStringEnum('level', [
	        'info',
	        'warn',
	        'error',
	        'success'
	      ]),
	      requiredString('icon'),
	      defaulted('url', '')
	    ];
	    var alertBannerSchema = objOf(alertBannerFields);
	
	    var createBarFields = function (itemsField) {
	      return [
	        requiredString('type'),
	        itemsField
	      ];
	    };
	
	    var buttonFields = [
	      requiredString('type'),
	      requiredString('text'),
	      defaultedBoolean('disabled', false),
	      defaultedBoolean('primary', false),
	      field$1('name', 'name', defaultedThunk(function () {
	        return generate$6('button-name');
	      }), string),
	      optionString('icon'),
	      defaultedBoolean('borderless', false)
	    ];
	    var buttonSchema = objOf(buttonFields);
	
	    var checkboxFields = [
	      requiredString('type'),
	      requiredString('name'),
	      requiredString('label'),
	      defaultedBoolean('disabled', false)
	    ];
	    var checkboxSchema = objOf(checkboxFields);
	    var checkboxDataProcessor = boolean;
	
	    var formComponentFields = [
	      requiredString('type'),
	      requiredString('name')
	    ];
	    var formComponentWithLabelFields = formComponentFields.concat([optionString('label')]);
	
	    var collectionFields = formComponentWithLabelFields.concat([defaulted('columns', 'auto')]);
	    var collectionSchema = objOf(collectionFields);
	    var collectionDataProcessor = arrOfObj([
	      requiredString('value'),
	      requiredString('text'),
	      requiredString('icon')
	    ]);
	
	    var colorInputFields = formComponentWithLabelFields;
	    var colorInputSchema = objOf(colorInputFields);
	    var colorInputDataProcessor = string;
	
	    var colorPickerFields = formComponentWithLabelFields;
	    var colorPickerSchema = objOf(colorPickerFields);
	    var colorPickerDataProcessor = string;
	
	    var customEditorFields = formComponentFields.concat([
	      defaultedString('tag', 'textarea'),
	      requiredString('scriptId'),
	      requiredString('scriptUrl'),
	      defaultedPostMsg('settings', undefined)
	    ]);
	    var customEditorFieldsOld = formComponentFields.concat([
	      defaultedString('tag', 'textarea'),
	      requiredFunction('init')
	    ]);
	    var customEditorSchema = valueOf(function (v) {
	      return asRaw('customeditor.old', objOfOnly(customEditorFieldsOld), v).orThunk(function () {
	        return asRaw('customeditor.new', objOfOnly(customEditorFields), v);
	      });
	    });
	    var customEditorDataProcessor = string;
	
	    var dropZoneFields = formComponentWithLabelFields;
	    var dropZoneSchema = objOf(dropZoneFields);
	    var dropZoneDataProcessor = arrOfVal();
	
	    var createGridFields = function (itemsField) {
	      return [
	        requiredString('type'),
	        requiredNumber('columns'),
	        itemsField
	      ];
	    };
	
	    var htmlPanelFields = [
	      requiredString('type'),
	      requiredString('html'),
	      defaultedStringEnum('presets', 'presentation', [
	        'presentation',
	        'document'
	      ])
	    ];
	    var htmlPanelSchema = objOf(htmlPanelFields);
	
	    var iframeFields = formComponentWithLabelFields.concat([defaultedBoolean('sandboxed', true)]);
	    var iframeSchema = objOf(iframeFields);
	    var iframeDataProcessor = string;
	
	    var imageToolsFields = formComponentWithLabelFields.concat([requiredOf('currentState', objOf([
	        required$1('blob'),
	        requiredString('url')
	      ]))]);
	    var imageToolsSchema = objOf(imageToolsFields);
	
	    var inputFields = formComponentWithLabelFields.concat([
	      optionString('inputMode'),
	      optionString('placeholder'),
	      defaultedBoolean('maximized', false),
	      defaultedBoolean('disabled', false)
	    ]);
	    var inputSchema = objOf(inputFields);
	    var inputDataProcessor = string;
	
	    var createLabelFields = function (itemsField) {
	      return [
	        requiredString('type'),
	        requiredString('label'),
	        itemsField
	      ];
	    };
	
	    var listBoxSingleItemFields = [
	      requiredString('text'),
	      requiredString('value')
	    ];
	    var listBoxNestedItemFields = [
	      requiredString('text'),
	      requiredArrayOf('items', thunkOf('items', function () {
	        return listBoxItemSchema;
	      }))
	    ];
	    var listBoxItemSchema = oneOf([
	      objOf(listBoxSingleItemFields),
	      objOf(listBoxNestedItemFields)
	    ]);
	    var listBoxFields = formComponentWithLabelFields.concat([
	      requiredArrayOf('items', listBoxItemSchema),
	      defaultedBoolean('disabled', false)
	    ]);
	    var listBoxSchema = objOf(listBoxFields);
	    var listBoxDataProcessor = string;
	
	    var selectBoxFields = formComponentWithLabelFields.concat([
	      requiredArrayOfObj('items', [
	        requiredString('text'),
	        requiredString('value')
	      ]),
	      defaultedNumber('size', 1),
	      defaultedBoolean('disabled', false)
	    ]);
	    var selectBoxSchema = objOf(selectBoxFields);
	    var selectBoxDataProcessor = string;
	
	    var sizeInputFields = formComponentWithLabelFields.concat([
	      defaultedBoolean('constrain', true),
	      defaultedBoolean('disabled', false)
	    ]);
	    var sizeInputSchema = objOf(sizeInputFields);
	    var sizeInputDataProcessor = objOf([
	      requiredString('width'),
	      requiredString('height')
	    ]);
	
	    var tableFields = [
	      requiredString('type'),
	      requiredArrayOf('header', string),
	      requiredArrayOf('cells', arrOf(string))
	    ];
	    var tableSchema = objOf(tableFields);
	
	    var textAreaFields = formComponentWithLabelFields.concat([
	      optionString('placeholder'),
	      defaultedBoolean('maximized', false),
	      defaultedBoolean('disabled', false)
	    ]);
	    var textAreaSchema = objOf(textAreaFields);
	    var textAreaDataProcessor = string;
	
	    var urlInputFields = formComponentWithLabelFields.concat([
	      defaultedStringEnum('filetype', 'file', [
	        'image',
	        'media',
	        'file'
	      ]),
	      defaulted('disabled', false)
	    ]);
	    var urlInputSchema = objOf(urlInputFields);
	    var urlInputDataProcessor = objOf([
	      requiredString('value'),
	      defaulted('meta', {})
	    ]);
	
	    var createItemsField = function (name) {
	      return field$1('items', 'items', required$2(), arrOf(valueOf(function (v) {
	        return asRaw('Checking item of ' + name, itemSchema, v).fold(function (sErr) {
	          return Result.error(formatError(sErr));
	        }, function (passValue) {
	          return Result.value(passValue);
	        });
	      })));
	    };
	    var itemSchema = valueThunk(function () {
	      return choose$2('type', {
	        alertbanner: alertBannerSchema,
	        bar: objOf(createBarFields(createItemsField('bar'))),
	        button: buttonSchema,
	        checkbox: checkboxSchema,
	        colorinput: colorInputSchema,
	        colorpicker: colorPickerSchema,
	        dropzone: dropZoneSchema,
	        grid: objOf(createGridFields(createItemsField('grid'))),
	        iframe: iframeSchema,
	        input: inputSchema,
	        listbox: listBoxSchema,
	        selectbox: selectBoxSchema,
	        sizeinput: sizeInputSchema,
	        textarea: textAreaSchema,
	        urlinput: urlInputSchema,
	        customeditor: customEditorSchema,
	        htmlpanel: htmlPanelSchema,
	        imagetools: imageToolsSchema,
	        collection: collectionSchema,
	        label: objOf(createLabelFields(createItemsField('label'))),
	        table: tableSchema,
	        panel: panelSchema
	      });
	    });
	    var panelFields = [
	      requiredString('type'),
	      defaulted('classes', []),
	      requiredArrayOf('items', itemSchema)
	    ];
	    var panelSchema = objOf(panelFields);
	
	    var tabFields = [
	      field$1('name', 'name', defaultedThunk(function () {
	        return generate$6('tab-name');
	      }), string),
	      requiredString('title'),
	      requiredArrayOf('items', itemSchema)
	    ];
	    var tabPanelFields = [
	      requiredString('type'),
	      requiredArrayOfObj('tabs', tabFields)
	    ];
	    var tabPanelSchema = objOf(tabPanelFields);
	
	    var dialogButtonFields = dialogFooterButtonFields;
	    var dialogButtonSchema = dialogFooterButtonSchema;
	    var dialogSchema = objOf([
	      requiredString('title'),
	      requiredOf('body', choose$2('type', {
	        panel: panelSchema,
	        tabpanel: tabPanelSchema
	      })),
	      defaultedString('size', 'normal'),
	      requiredArrayOf('buttons', dialogButtonSchema),
	      defaulted('initialData', {}),
	      defaultedFunction('onAction', noop),
	      defaultedFunction('onChange', noop),
	      defaultedFunction('onSubmit', noop),
	      defaultedFunction('onClose', noop),
	      defaultedFunction('onCancel', noop),
	      defaulted('onTabChange', noop)
	    ]);
	    var createDialog = function (spec) {
	      return asRaw('dialog', dialogSchema, spec);
	    };
	
	    var urlDialogButtonSchema = objOf(__spreadArray([requiredStringEnum('type', [
	        'cancel',
	        'custom'
	      ])], dialogButtonFields, true));
	    var urlDialogSchema = objOf([
	      requiredString('title'),
	      requiredString('url'),
	      optionNumber('height'),
	      optionNumber('width'),
	      optionArrayOf('buttons', urlDialogButtonSchema),
	      defaultedFunction('onAction', noop),
	      defaultedFunction('onCancel', noop),
	      defaultedFunction('onClose', noop),
	      defaultedFunction('onMessage', noop)
	    ]);
	    var createUrlDialog = function (spec) {
	      return asRaw('dialog', urlDialogSchema, spec);
	    };
	
	    var getAllObjects = function (obj) {
	      if (isObject(obj)) {
	        return [obj].concat(bind$3(values(obj), getAllObjects));
	      } else if (isArray(obj)) {
	        return bind$3(obj, getAllObjects);
	      } else {
	        return [];
	      }
	    };
	
	    var isNamedItem = function (obj) {
	      return isString(obj.type) && isString(obj.name);
	    };
	    var dataProcessors = {
	      checkbox: checkboxDataProcessor,
	      colorinput: colorInputDataProcessor,
	      colorpicker: colorPickerDataProcessor,
	      dropzone: dropZoneDataProcessor,
	      input: inputDataProcessor,
	      iframe: iframeDataProcessor,
	      sizeinput: sizeInputDataProcessor,
	      selectbox: selectBoxDataProcessor,
	      listbox: listBoxDataProcessor,
	      size: sizeInputDataProcessor,
	      textarea: textAreaDataProcessor,
	      urlinput: urlInputDataProcessor,
	      customeditor: customEditorDataProcessor,
	      collection: collectionDataProcessor,
	      togglemenuitem: dialogToggleMenuItemDataProcessor
	    };
	    var getDataProcessor = function (item) {
	      return Optional.from(dataProcessors[item.type]);
	    };
	    var getNamedItems = function (structure) {
	      return filter$2(getAllObjects(structure), isNamedItem);
	    };
	
	    var createDataValidator = function (structure) {
	      var namedItems = getNamedItems(structure);
	      var fields = bind$3(namedItems, function (item) {
	        return getDataProcessor(item).fold(function () {
	          return [];
	        }, function (schema) {
	          return [requiredOf(item.name, schema)];
	        });
	      });
	      return objOf(fields);
	    };
	
	    var extract = function (structure) {
	      var internalDialog = getOrDie(createDialog(structure));
	      var dataValidator = createDataValidator(structure);
	      var initialData = structure.initialData;
	      return {
	        internalDialog: internalDialog,
	        dataValidator: dataValidator,
	        initialData: initialData
	      };
	    };
	    var DialogManager = {
	      open: function (factory, structure) {
	        var extraction = extract(structure);
	        return factory(extraction.internalDialog, extraction.initialData, extraction.dataValidator);
	      },
	      openUrl: function (factory, structure) {
	        var internalDialog = getOrDie(createUrlDialog(structure));
	        return factory(internalDialog);
	      },
	      redial: function (structure) {
	        return extract(structure);
	      }
	    };
	
	    var toValidValues = function (values) {
	      var errors = [];
	      var result = {};
	      each(values, function (value, name) {
	        value.fold(function () {
	          errors.push(name);
	        }, function (v) {
	          result[name] = v;
	        });
	      });
	      return errors.length > 0 ? Result.error(errors) : Result.value(result);
	    };
	
	    var renderBodyPanel = function (spec, backstage) {
	      var memForm = record(Form.sketch(function (parts) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-form'].concat(spec.classes)
	          },
	          components: map$2(spec.items, function (item) {
	            return interpretInForm(parts, item, backstage);
	          })
	        };
	      }));
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__body']
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-content']
	            },
	            components: [memForm.asSpec()]
	          }],
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'acyclic',
	            useTabstopAt: not(isPseudoStop)
	          }),
	          ComposingConfigs.memento(memForm),
	          RepresentingConfigs.memento(memForm, {
	            postprocess: function (formValue) {
	              return toValidValues(formValue).fold(function (err) {
	                console.error(err);
	                return {};
	              }, identity$1);
	            }
	          })
	        ])
	      };
	    };
	
	    var factory$3 = function (detail, _spec) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: detail.components,
	        events: events$a(detail.action),
	        behaviours: augment(detail.tabButtonBehaviours, [
	          Focusing.config({}),
	          Keying.config({
	            mode: 'execution',
	            useSpace: true,
	            useEnter: true
	          }),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: detail.value
	            }
	          })
	        ]),
	        domModification: detail.domModification
	      };
	    };
	    var TabButton = single({
	      name: 'TabButton',
	      configFields: [
	        defaulted('uid', undefined),
	        required$1('value'),
	        field$1('dom', 'dom', mergeWithThunk(function () {
	          return {
	            attributes: {
	              'role': 'tab',
	              'id': generate$6('aria'),
	              'aria-selected': 'false'
	            }
	          };
	        }), anyValue()),
	        option('action'),
	        defaulted('domModification', {}),
	        field('tabButtonBehaviours', [
	          Focusing,
	          Keying,
	          Representing
	        ]),
	        required$1('view')
	      ],
	      factory: factory$3
	    });
	
	    var schema$1 = constant$1([
	      required$1('tabs'),
	      required$1('dom'),
	      defaulted('clickToDismiss', false),
	      field('tabbarBehaviours', [
	        Highlighting,
	        Keying
	      ]),
	      markers$1([
	        'tabClass',
	        'selectedClass'
	      ])
	    ]);
	    var tabsPart = group({
	      factory: TabButton,
	      name: 'tabs',
	      unit: 'tab',
	      overrides: function (barDetail) {
	        var dismissTab$1 = function (tabbar, button) {
	          Highlighting.dehighlight(tabbar, button);
	          emitWith(tabbar, dismissTab(), {
	            tabbar: tabbar,
	            button: button
	          });
	        };
	        var changeTab$1 = function (tabbar, button) {
	          Highlighting.highlight(tabbar, button);
	          emitWith(tabbar, changeTab(), {
	            tabbar: tabbar,
	            button: button
	          });
	        };
	        return {
	          action: function (button) {
	            var tabbar = button.getSystem().getByUid(barDetail.uid).getOrDie();
	            var activeButton = Highlighting.isHighlighted(tabbar, button);
	            var response = function () {
	              if (activeButton && barDetail.clickToDismiss) {
	                return dismissTab$1;
	              } else if (!activeButton) {
	                return changeTab$1;
	              } else {
	                return noop;
	              }
	            }();
	            response(tabbar, button);
	          },
	          domModification: { classes: [barDetail.markers.tabClass] }
	        };
	      }
	    });
	    var parts$1 = constant$1([tabsPart]);
	
	    var factory$2 = function (detail, components, _spec, _externals) {
	      return {
	        'uid': detail.uid,
	        'dom': detail.dom,
	        components: components,
	        'debug.sketcher': 'Tabbar',
	        'domModification': { attributes: { role: 'tablist' } },
	        'behaviours': augment(detail.tabbarBehaviours, [
	          Highlighting.config({
	            highlightClass: detail.markers.selectedClass,
	            itemClass: detail.markers.tabClass,
	            onHighlight: function (tabbar, tab) {
	              set$8(tab.element, 'aria-selected', 'true');
	            },
	            onDehighlight: function (tabbar, tab) {
	              set$8(tab.element, 'aria-selected', 'false');
	            }
	          }),
	          Keying.config({
	            mode: 'flow',
	            getInitial: function (tabbar) {
	              return Highlighting.getHighlighted(tabbar).map(function (tab) {
	                return tab.element;
	              });
	            },
	            selector: '.' + detail.markers.tabClass,
	            executeOnMove: true
	          })
	        ])
	      };
	    };
	    var Tabbar = composite({
	      name: 'Tabbar',
	      configFields: schema$1(),
	      partFields: parts$1(),
	      factory: factory$2
	    });
	
	    var factory$1 = function (detail, _spec) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        behaviours: augment(detail.tabviewBehaviours, [Replacing.config({})]),
	        domModification: { attributes: { role: 'tabpanel' } }
	      };
	    };
	    var Tabview = single({
	      name: 'Tabview',
	      configFields: [field('tabviewBehaviours', [Replacing])],
	      factory: factory$1
	    });
	
	    var schema = constant$1([
	      defaulted('selectFirst', true),
	      onHandler('onChangeTab'),
	      onHandler('onDismissTab'),
	      defaulted('tabs', []),
	      field('tabSectionBehaviours', [])
	    ]);
	    var barPart = required({
	      factory: Tabbar,
	      schema: [
	        required$1('dom'),
	        requiredObjOf('markers', [
	          required$1('tabClass'),
	          required$1('selectedClass')
	        ])
	      ],
	      name: 'tabbar',
	      defaults: function (detail) {
	        return { tabs: detail.tabs };
	      }
	    });
	    var viewPart = required({
	      factory: Tabview,
	      name: 'tabview'
	    });
	    var parts = constant$1([
	      barPart,
	      viewPart
	    ]);
	
	    var factory = function (detail, components, _spec, _externals) {
	      var changeTab$1 = function (button) {
	        var tabValue = Representing.getValue(button);
	        getPart(button, detail, 'tabview').each(function (tabview) {
	          var tabWithValue = find$5(detail.tabs, function (t) {
	            return t.value === tabValue;
	          });
	          tabWithValue.each(function (tabData) {
	            var panel = tabData.view();
	            getOpt(button.element, 'id').each(function (id) {
	              set$8(tabview.element, 'aria-labelledby', id);
	            });
	            Replacing.set(tabview, panel);
	            detail.onChangeTab(tabview, button, panel);
	          });
	        });
	      };
	      var changeTabBy = function (section, byPred) {
	        getPart(section, detail, 'tabbar').each(function (tabbar) {
	          byPred(tabbar).each(emitExecute);
	        });
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: get$2(detail.tabSectionBehaviours),
	        events: derive$2(flatten([
	          detail.selectFirst ? [runOnAttached(function (section, _simulatedEvent) {
	              changeTabBy(section, Highlighting.getFirst);
	            })] : [],
	          [
	            run$1(changeTab(), function (section, simulatedEvent) {
	              var button = simulatedEvent.event.button;
	              changeTab$1(button);
	            }),
	            run$1(dismissTab(), function (section, simulatedEvent) {
	              var button = simulatedEvent.event.button;
	              detail.onDismissTab(section, button);
	            })
	          ]
	        ])),
	        apis: {
	          getViewItems: function (section) {
	            return getPart(section, detail, 'tabview').map(function (tabview) {
	              return Replacing.contents(tabview);
	            }).getOr([]);
	          },
	          showTab: function (section, tabKey) {
	            var getTabIfNotActive = function (tabbar) {
	              var candidates = Highlighting.getCandidates(tabbar);
	              var optTab = find$5(candidates, function (c) {
	                return Representing.getValue(c) === tabKey;
	              });
	              return optTab.filter(function (tab) {
	                return !Highlighting.isHighlighted(tabbar, tab);
	              });
	            };
	            changeTabBy(section, getTabIfNotActive);
	          }
	        }
	      };
	    };
	    var TabSection = composite({
	      name: 'TabSection',
	      configFields: schema(),
	      partFields: parts(),
	      factory: factory,
	      apis: {
	        getViewItems: function (apis, component) {
	          return apis.getViewItems(component);
	        },
	        showTab: function (apis, component, tabKey) {
	          apis.showTab(component, tabKey);
	        }
	      }
	    });
	
	    var measureHeights = function (allTabs, tabview, tabviewComp) {
	      return map$2(allTabs, function (_tab, i) {
	        Replacing.set(tabviewComp, allTabs[i].view());
	        var rect = tabview.dom.getBoundingClientRect();
	        Replacing.set(tabviewComp, []);
	        return rect.height;
	      });
	    };
	    var getMaxHeight = function (heights) {
	      return head(sort(heights, function (a, b) {
	        if (a > b) {
	          return -1;
	        } else if (a < b) {
	          return +1;
	        } else {
	          return 0;
	        }
	      }));
	    };
	    var getMaxTabviewHeight = function (dialog, tabview, tablist) {
	      var documentElement$1 = documentElement(dialog).dom;
	      var rootElm = ancestor(dialog, '.tox-dialog-wrap').getOr(dialog);
	      var isFixed = get$c(rootElm, 'position') === 'fixed';
	      var maxHeight;
	      if (isFixed) {
	        maxHeight = Math.max(documentElement$1.clientHeight, window.innerHeight);
	      } else {
	        maxHeight = Math.max(documentElement$1.offsetHeight, documentElement$1.scrollHeight);
	      }
	      var tabviewHeight = get$b(tabview);
	      var isTabListBeside = tabview.dom.offsetLeft >= tablist.dom.offsetLeft + get$a(tablist);
	      var currentTabHeight = isTabListBeside ? Math.max(get$b(tablist), tabviewHeight) : tabviewHeight;
	      var dialogTopMargin = parseInt(get$c(dialog, 'margin-top'), 10) || 0;
	      var dialogBottomMargin = parseInt(get$c(dialog, 'margin-bottom'), 10) || 0;
	      var dialogHeight = get$b(dialog) + dialogTopMargin + dialogBottomMargin;
	      var chromeHeight = dialogHeight - currentTabHeight;
	      return maxHeight - chromeHeight;
	    };
	    var showTab = function (allTabs, comp) {
	      head(allTabs).each(function (tab) {
	        return TabSection.showTab(comp, tab.value);
	      });
	    };
	    var setTabviewHeight = function (tabview, height) {
	      set$7(tabview, 'height', height + 'px');
	      if (!detect$1().browser.isIE()) {
	        set$7(tabview, 'flex-basis', height + 'px');
	      } else {
	        remove$6(tabview, 'flex-basis');
	      }
	    };
	    var updateTabviewHeight = function (dialogBody, tabview, maxTabHeight) {
	      ancestor(dialogBody, '[role="dialog"]').each(function (dialog) {
	        descendant(dialog, '[role="tablist"]').each(function (tablist) {
	          maxTabHeight.get().map(function (height) {
	            set$7(tabview, 'height', '0');
	            set$7(tabview, 'flex-basis', '0');
	            return Math.min(height, getMaxTabviewHeight(dialog, tabview, tablist));
	          }).each(function (height) {
	            setTabviewHeight(tabview, height);
	          });
	        });
	      });
	    };
	    var getTabview = function (dialog) {
	      return descendant(dialog, '[role="tabpanel"]');
	    };
	    var setMode = function (allTabs) {
	      var smartTabHeight = function () {
	        var maxTabHeight = value$1();
	        var extraEvents = [
	          runOnAttached(function (comp) {
	            var dialog = comp.element;
	            getTabview(dialog).each(function (tabview) {
	              set$7(tabview, 'visibility', 'hidden');
	              comp.getSystem().getByDom(tabview).toOptional().each(function (tabviewComp) {
	                var heights = measureHeights(allTabs, tabview, tabviewComp);
	                var maxTabHeightOpt = getMaxHeight(heights);
	                maxTabHeightOpt.fold(maxTabHeight.clear, maxTabHeight.set);
	              });
	              updateTabviewHeight(dialog, tabview, maxTabHeight);
	              remove$6(tabview, 'visibility');
	              showTab(allTabs, comp);
	              global$f.requestAnimationFrame(function () {
	                updateTabviewHeight(dialog, tabview, maxTabHeight);
	              });
	            });
	          }),
	          run$1(windowResize(), function (comp) {
	            var dialog = comp.element;
	            getTabview(dialog).each(function (tabview) {
	              updateTabviewHeight(dialog, tabview, maxTabHeight);
	            });
	          }),
	          run$1(formResizeEvent, function (comp, _se) {
	            var dialog = comp.element;
	            getTabview(dialog).each(function (tabview) {
	              var oldFocus = active(getRootNode(tabview));
	              set$7(tabview, 'visibility', 'hidden');
	              var oldHeight = getRaw(tabview, 'height').map(function (h) {
	                return parseInt(h, 10);
	              });
	              remove$6(tabview, 'height');
	              remove$6(tabview, 'flex-basis');
	              var newHeight = tabview.dom.getBoundingClientRect().height;
	              var hasGrown = oldHeight.forall(function (h) {
	                return newHeight > h;
	              });
	              if (hasGrown) {
	                maxTabHeight.set(newHeight);
	                updateTabviewHeight(dialog, tabview, maxTabHeight);
	              } else {
	                oldHeight.each(function (h) {
	                  setTabviewHeight(tabview, h);
	                });
	              }
	              remove$6(tabview, 'visibility');
	              oldFocus.each(focus$3);
	            });
	          })
	        ];
	        var selectFirst = false;
	        return {
	          extraEvents: extraEvents,
	          selectFirst: selectFirst
	        };
	      }();
	      var naiveTabHeight = function () {
	        var extraEvents = [];
	        var selectFirst = true;
	        return {
	          extraEvents: extraEvents,
	          selectFirst: selectFirst
	        };
	      }();
	      return {
	        smartTabHeight: smartTabHeight,
	        naiveTabHeight: naiveTabHeight
	      };
	    };
	
	    var SendDataToSectionChannel = 'send-data-to-section';
	    var SendDataToViewChannel = 'send-data-to-view';
	    var renderTabPanel = function (spec, backstage) {
	      var storedValue = Cell({});
	      var updateDataWithForm = function (form) {
	        var formData = Representing.getValue(form);
	        var validData = toValidValues(formData).getOr({});
	        var currentData = storedValue.get();
	        var newData = deepMerge(currentData, validData);
	        storedValue.set(newData);
	      };
	      var setDataOnForm = function (form) {
	        var tabData = storedValue.get();
	        Representing.setValue(form, tabData);
	      };
	      var oldTab = Cell(null);
	      var allTabs = map$2(spec.tabs, function (tab) {
	        return {
	          value: tab.name,
	          dom: {
	            tag: 'div',
	            classes: ['tox-dialog__body-nav-item'],
	            innerHtml: backstage.shared.providers.translate(tab.title)
	          },
	          view: function () {
	            return [Form.sketch(function (parts) {
	                return {
	                  dom: {
	                    tag: 'div',
	                    classes: ['tox-form']
	                  },
	                  components: map$2(tab.items, function (item) {
	                    return interpretInForm(parts, item, backstage);
	                  }),
	                  formBehaviours: derive$1([
	                    Keying.config({
	                      mode: 'acyclic',
	                      useTabstopAt: not(isPseudoStop)
	                    }),
	                    config('TabView.form.events', [
	                      runOnAttached(setDataOnForm),
	                      runOnDetached(updateDataWithForm)
	                    ]),
	                    Receiving.config({
	                      channels: wrapAll([
	                        {
	                          key: SendDataToSectionChannel,
	                          value: { onReceive: updateDataWithForm }
	                        },
	                        {
	                          key: SendDataToViewChannel,
	                          value: { onReceive: setDataOnForm }
	                        }
	                      ])
	                    })
	                  ])
	                };
	              })];
	          }
	        };
	      });
	      var tabMode = setMode(allTabs).smartTabHeight;
	      return TabSection.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__body']
	        },
	        onChangeTab: function (section, button, _viewItems) {
	          var name = Representing.getValue(button);
	          emitWith(section, formTabChangeEvent, {
	            name: name,
	            oldName: oldTab.get()
	          });
	          oldTab.set(name);
	        },
	        tabs: allTabs,
	        components: [
	          TabSection.parts.tabbar({
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-nav']
	            },
	            components: [Tabbar.parts.tabs({})],
	            markers: {
	              tabClass: 'tox-tab',
	              selectedClass: 'tox-dialog__body-nav-item--active'
	            },
	            tabbarBehaviours: derive$1([Tabstopping.config({})])
	          }),
	          TabSection.parts.tabview({
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-content']
	            }
	          })
	        ],
	        selectFirst: tabMode.selectFirst,
	        tabSectionBehaviours: derive$1([
	          config('tabpanel', tabMode.extraEvents),
	          Keying.config({ mode: 'acyclic' }),
	          Composing.config({
	            find: function (comp) {
	              return head(TabSection.getViewItems(comp));
	            }
	          }),
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (tsection) {
	                tsection.getSystem().broadcastOn([SendDataToSectionChannel], {});
	                return storedValue.get();
	              },
	              setValue: function (tsection, value) {
	                storedValue.set(value);
	                tsection.getSystem().broadcastOn([SendDataToViewChannel], {});
	              }
	            }
	          })
	        ])
	      });
	    };
	
	    var dialogChannel = generate$6('update-dialog');
	    var titleChannel = generate$6('update-title');
	    var bodyChannel = generate$6('update-body');
	    var footerChannel = generate$6('update-footer');
	    var bodySendMessageChannel = generate$6('body-send-message');
	
	    var renderBody = function (spec, id, backstage, ariaAttrs) {
	      var renderComponents = function (incoming) {
	        switch (incoming.body.type) {
	        case 'tabpanel': {
	            return [renderTabPanel(incoming.body, backstage)];
	          }
	        default: {
	            return [renderBodyPanel(incoming.body, backstage)];
	          }
	        }
	      };
	      var updateState = function (_comp, incoming) {
	        return Optional.some({
	          isTabPanel: function () {
	            return incoming.body.type === 'tabpanel';
	          }
	        });
	      };
	      var ariaAttributes = { 'aria-live': 'polite' };
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__content-js'],
	          attributes: __assign(__assign({}, id.map(function (x) {
	            return { id: x };
	          }).getOr({})), ariaAttrs ? ariaAttributes : {})
	        },
	        components: [],
	        behaviours: derive$1([
	          ComposingConfigs.childAt(0),
	          Reflecting.config({
	            channel: bodyChannel,
	            updateState: updateState,
	            renderComponents: renderComponents,
	            initialData: spec
	          })
	        ])
	      };
	    };
	    var renderInlineBody = function (spec, contentId, backstage, ariaAttrs) {
	      return renderBody(spec, Optional.some(contentId), backstage, ariaAttrs);
	    };
	    var renderModalBody = function (spec, backstage) {
	      var bodySpec = renderBody(spec, Optional.none(), backstage, false);
	      return ModalDialog.parts.body(bodySpec);
	    };
	    var renderIframeBody = function (spec) {
	      var bodySpec = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__content-js']
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-iframe']
	            },
	            components: [craft({
	                dom: {
	                  tag: 'iframe',
	                  attributes: { src: spec.url }
	                },
	                behaviours: derive$1([
	                  Tabstopping.config({}),
	                  Focusing.config({})
	                ])
	              })]
	          }],
	        behaviours: derive$1([Keying.config({
	            mode: 'acyclic',
	            useTabstopAt: not(isPseudoStop)
	          })])
	      };
	      return ModalDialog.parts.body(bodySpec);
	    };
	
	    function _typeof(obj) {
	      '@babel/helpers - typeof';
	      return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
	        return typeof obj;
	      } : function (obj) {
	        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
	      }, _typeof(obj);
	    }
	    function _setPrototypeOf(o, p) {
	      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	        o.__proto__ = p;
	        return o;
	      };
	      return _setPrototypeOf(o, p);
	    }
	    function _isNativeReflectConstruct() {
	      if (typeof Reflect === 'undefined' || !Reflect.construct)
	        return false;
	      if (Reflect.construct.sham)
	        return false;
	      if (typeof Proxy === 'function')
	        return true;
	      try {
	        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
	        }));
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }
	    function _construct(Parent, args, Class) {
	      if (_isNativeReflectConstruct()) {
	        _construct = Reflect.construct;
	      } else {
	        _construct = function _construct(Parent, args, Class) {
	          var a = [null];
	          a.push.apply(a, args);
	          var Constructor = Function.bind.apply(Parent, a);
	          var instance = new Constructor();
	          if (Class)
	            _setPrototypeOf(instance, Class.prototype);
	          return instance;
	        };
	      }
	      return _construct.apply(null, arguments);
	    }
	    function _toConsumableArray(arr) {
	      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	    }
	    function _arrayWithoutHoles(arr) {
	      if (Array.isArray(arr))
	        return _arrayLikeToArray(arr);
	    }
	    function _iterableToArray(iter) {
	      if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
	        return Array.from(iter);
	    }
	    function _unsupportedIterableToArray(o, minLen) {
	      if (!o)
	        return;
	      if (typeof o === 'string')
	        return _arrayLikeToArray(o, minLen);
	      var n = Object.prototype.toString.call(o).slice(8, -1);
	      if (n === 'Object' && o.constructor)
	        n = o.constructor.name;
	      if (n === 'Map' || n === 'Set')
	        return Array.from(o);
	      if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
	        return _arrayLikeToArray(o, minLen);
	    }
	    function _arrayLikeToArray(arr, len) {
	      if (len == null || len > arr.length)
	        len = arr.length;
	      for (var i = 0, arr2 = new Array(len); i < len; i++)
	        arr2[i] = arr[i];
	      return arr2;
	    }
	    function _nonIterableSpread() {
	      throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
	    }
	    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var freeze = Object.freeze, seal = Object.seal, create = Object.create;
	    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
	    if (!apply) {
	      apply = function apply(fun, thisValue, args) {
	        return fun.apply(thisValue, args);
	      };
	    }
	    if (!freeze) {
	      freeze = function freeze(x) {
	        return x;
	      };
	    }
	    if (!seal) {
	      seal = function seal(x) {
	        return x;
	      };
	    }
	    if (!construct) {
	      construct = function construct(Func, args) {
	        return _construct(Func, _toConsumableArray(args));
	      };
	    }
	    var arrayForEach = unapply(Array.prototype.forEach);
	    var arrayPop = unapply(Array.prototype.pop);
	    var arrayPush = unapply(Array.prototype.push);
	    var stringToLowerCase = unapply(String.prototype.toLowerCase);
	    var stringMatch = unapply(String.prototype.match);
	    var stringReplace = unapply(String.prototype.replace);
	    var stringIndexOf = unapply(String.prototype.indexOf);
	    var stringTrim = unapply(String.prototype.trim);
	    var regExpTest = unapply(RegExp.prototype.test);
	    var typeErrorCreate = unconstruct(TypeError);
	    function unapply(func) {
	      return function (thisArg) {
	        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	        return apply(func, thisArg, args);
	      };
	    }
	    function unconstruct(func) {
	      return function () {
	        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	        return construct(func, args);
	      };
	    }
	    function addToSet(set, array) {
	      if (setPrototypeOf) {
	        setPrototypeOf(set, null);
	      }
	      var l = array.length;
	      while (l--) {
	        var element = array[l];
	        if (typeof element === 'string') {
	          var lcElement = stringToLowerCase(element);
	          if (lcElement !== element) {
	            if (!isFrozen(array)) {
	              array[l] = lcElement;
	            }
	            element = lcElement;
	          }
	        }
	        set[element] = true;
	      }
	      return set;
	    }
	    function clone(object) {
	      var newObject = create(null);
	      var property;
	      for (property in object) {
	        if (apply(hasOwnProperty, object, [property])) {
	          newObject[property] = object[property];
	        }
	      }
	      return newObject;
	    }
	    function lookupGetter(object, prop) {
	      while (object !== null) {
	        var desc = getOwnPropertyDescriptor(object, prop);
	        if (desc) {
	          if (desc.get) {
	            return unapply(desc.get);
	          }
	          if (typeof desc.value === 'function') {
	            return unapply(desc.value);
	          }
	        }
	        object = getPrototypeOf(object);
	      }
	      function fallbackValue(element) {
	        console.warn('fallback value for', element);
	        return null;
	      }
	      return fallbackValue;
	    }
	    var html$1 = freeze([
	      'a',
	      'abbr',
	      'acronym',
	      'address',
	      'area',
	      'article',
	      'aside',
	      'audio',
	      'b',
	      'bdi',
	      'bdo',
	      'big',
	      'blink',
	      'blockquote',
	      'body',
	      'br',
	      'button',
	      'canvas',
	      'caption',
	      'center',
	      'cite',
	      'code',
	      'col',
	      'colgroup',
	      'content',
	      'data',
	      'datalist',
	      'dd',
	      'decorator',
	      'del',
	      'details',
	      'dfn',
	      'dialog',
	      'dir',
	      'div',
	      'dl',
	      'dt',
	      'element',
	      'em',
	      'fieldset',
	      'figcaption',
	      'figure',
	      'font',
	      'footer',
	      'form',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'head',
	      'header',
	      'hgroup',
	      'hr',
	      'html',
	      'i',
	      'img',
	      'input',
	      'ins',
	      'kbd',
	      'label',
	      'legend',
	      'li',
	      'main',
	      'map',
	      'mark',
	      'marquee',
	      'menu',
	      'menuitem',
	      'meter',
	      'nav',
	      'nobr',
	      'ol',
	      'optgroup',
	      'option',
	      'output',
	      'p',
	      'picture',
	      'pre',
	      'progress',
	      'q',
	      'rp',
	      'rt',
	      'ruby',
	      's',
	      'samp',
	      'section',
	      'select',
	      'shadow',
	      'small',
	      'source',
	      'spacer',
	      'span',
	      'strike',
	      'strong',
	      'style',
	      'sub',
	      'summary',
	      'sup',
	      'table',
	      'tbody',
	      'td',
	      'template',
	      'textarea',
	      'tfoot',
	      'th',
	      'thead',
	      'time',
	      'tr',
	      'track',
	      'tt',
	      'u',
	      'ul',
	      'var',
	      'video',
	      'wbr'
	    ]);
	    var svg$1 = freeze([
	      'svg',
	      'a',
	      'altglyph',
	      'altglyphdef',
	      'altglyphitem',
	      'animatecolor',
	      'animatemotion',
	      'animatetransform',
	      'circle',
	      'clippath',
	      'defs',
	      'desc',
	      'ellipse',
	      'filter',
	      'font',
	      'g',
	      'glyph',
	      'glyphref',
	      'hkern',
	      'image',
	      'line',
	      'lineargradient',
	      'marker',
	      'mask',
	      'metadata',
	      'mpath',
	      'path',
	      'pattern',
	      'polygon',
	      'polyline',
	      'radialgradient',
	      'rect',
	      'stop',
	      'style',
	      'switch',
	      'symbol',
	      'text',
	      'textpath',
	      'title',
	      'tref',
	      'tspan',
	      'view',
	      'vkern'
	    ]);
	    var svgFilters = freeze([
	      'feBlend',
	      'feColorMatrix',
	      'feComponentTransfer',
	      'feComposite',
	      'feConvolveMatrix',
	      'feDiffuseLighting',
	      'feDisplacementMap',
	      'feDistantLight',
	      'feFlood',
	      'feFuncA',
	      'feFuncB',
	      'feFuncG',
	      'feFuncR',
	      'feGaussianBlur',
	      'feImage',
	      'feMerge',
	      'feMergeNode',
	      'feMorphology',
	      'feOffset',
	      'fePointLight',
	      'feSpecularLighting',
	      'feSpotLight',
	      'feTile',
	      'feTurbulence'
	    ]);
	    var svgDisallowed = freeze([
	      'animate',
	      'color-profile',
	      'cursor',
	      'discard',
	      'fedropshadow',
	      'font-face',
	      'font-face-format',
	      'font-face-name',
	      'font-face-src',
	      'font-face-uri',
	      'foreignobject',
	      'hatch',
	      'hatchpath',
	      'mesh',
	      'meshgradient',
	      'meshpatch',
	      'meshrow',
	      'missing-glyph',
	      'script',
	      'set',
	      'solidcolor',
	      'unknown',
	      'use'
	    ]);
	    var mathMl$1 = freeze([
	      'math',
	      'menclose',
	      'merror',
	      'mfenced',
	      'mfrac',
	      'mglyph',
	      'mi',
	      'mlabeledtr',
	      'mmultiscripts',
	      'mn',
	      'mo',
	      'mover',
	      'mpadded',
	      'mphantom',
	      'mroot',
	      'mrow',
	      'ms',
	      'mspace',
	      'msqrt',
	      'mstyle',
	      'msub',
	      'msup',
	      'msubsup',
	      'mtable',
	      'mtd',
	      'mtext',
	      'mtr',
	      'munder',
	      'munderover'
	    ]);
	    var mathMlDisallowed = freeze([
	      'maction',
	      'maligngroup',
	      'malignmark',
	      'mlongdiv',
	      'mscarries',
	      'mscarry',
	      'msgroup',
	      'mstack',
	      'msline',
	      'msrow',
	      'semantics',
	      'annotation',
	      'annotation-xml',
	      'mprescripts',
	      'none'
	    ]);
	    var text = freeze(['#text']);
	    var html = freeze([
	      'accept',
	      'action',
	      'align',
	      'alt',
	      'autocapitalize',
	      'autocomplete',
	      'autopictureinpicture',
	      'autoplay',
	      'background',
	      'bgcolor',
	      'border',
	      'capture',
	      'cellpadding',
	      'cellspacing',
	      'checked',
	      'cite',
	      'class',
	      'clear',
	      'color',
	      'cols',
	      'colspan',
	      'controls',
	      'controlslist',
	      'coords',
	      'crossorigin',
	      'datetime',
	      'decoding',
	      'default',
	      'dir',
	      'disabled',
	      'disablepictureinpicture',
	      'disableremoteplayback',
	      'download',
	      'draggable',
	      'enctype',
	      'enterkeyhint',
	      'face',
	      'for',
	      'headers',
	      'height',
	      'hidden',
	      'high',
	      'href',
	      'hreflang',
	      'id',
	      'inputmode',
	      'integrity',
	      'ismap',
	      'kind',
	      'label',
	      'lang',
	      'list',
	      'loading',
	      'loop',
	      'low',
	      'max',
	      'maxlength',
	      'media',
	      'method',
	      'min',
	      'minlength',
	      'multiple',
	      'muted',
	      'name',
	      'nonce',
	      'noshade',
	      'novalidate',
	      'nowrap',
	      'open',
	      'optimum',
	      'pattern',
	      'placeholder',
	      'playsinline',
	      'poster',
	      'preload',
	      'pubdate',
	      'radiogroup',
	      'readonly',
	      'rel',
	      'required',
	      'rev',
	      'reversed',
	      'role',
	      'rows',
	      'rowspan',
	      'spellcheck',
	      'scope',
	      'selected',
	      'shape',
	      'size',
	      'sizes',
	      'span',
	      'srclang',
	      'start',
	      'src',
	      'srcset',
	      'step',
	      'style',
	      'summary',
	      'tabindex',
	      'title',
	      'translate',
	      'type',
	      'usemap',
	      'valign',
	      'value',
	      'width',
	      'xmlns',
	      'slot'
	    ]);
	    var svg = freeze([
	      'accent-height',
	      'accumulate',
	      'additive',
	      'alignment-baseline',
	      'ascent',
	      'attributename',
	      'attributetype',
	      'azimuth',
	      'basefrequency',
	      'baseline-shift',
	      'begin',
	      'bias',
	      'by',
	      'class',
	      'clip',
	      'clippathunits',
	      'clip-path',
	      'clip-rule',
	      'color',
	      'color-interpolation',
	      'color-interpolation-filters',
	      'color-profile',
	      'color-rendering',
	      'cx',
	      'cy',
	      'd',
	      'dx',
	      'dy',
	      'diffuseconstant',
	      'direction',
	      'display',
	      'divisor',
	      'dur',
	      'edgemode',
	      'elevation',
	      'end',
	      'fill',
	      'fill-opacity',
	      'fill-rule',
	      'filter',
	      'filterunits',
	      'flood-color',
	      'flood-opacity',
	      'font-family',
	      'font-size',
	      'font-size-adjust',
	      'font-stretch',
	      'font-style',
	      'font-variant',
	      'font-weight',
	      'fx',
	      'fy',
	      'g1',
	      'g2',
	      'glyph-name',
	      'glyphref',
	      'gradientunits',
	      'gradienttransform',
	      'height',
	      'href',
	      'id',
	      'image-rendering',
	      'in',
	      'in2',
	      'k',
	      'k1',
	      'k2',
	      'k3',
	      'k4',
	      'kerning',
	      'keypoints',
	      'keysplines',
	      'keytimes',
	      'lang',
	      'lengthadjust',
	      'letter-spacing',
	      'kernelmatrix',
	      'kernelunitlength',
	      'lighting-color',
	      'local',
	      'marker-end',
	      'marker-mid',
	      'marker-start',
	      'markerheight',
	      'markerunits',
	      'markerwidth',
	      'maskcontentunits',
	      'maskunits',
	      'max',
	      'mask',
	      'media',
	      'method',
	      'mode',
	      'min',
	      'name',
	      'numoctaves',
	      'offset',
	      'operator',
	      'opacity',
	      'order',
	      'orient',
	      'orientation',
	      'origin',
	      'overflow',
	      'paint-order',
	      'path',
	      'pathlength',
	      'patterncontentunits',
	      'patterntransform',
	      'patternunits',
	      'points',
	      'preservealpha',
	      'preserveaspectratio',
	      'primitiveunits',
	      'r',
	      'rx',
	      'ry',
	      'radius',
	      'refx',
	      'refy',
	      'repeatcount',
	      'repeatdur',
	      'restart',
	      'result',
	      'rotate',
	      'scale',
	      'seed',
	      'shape-rendering',
	      'specularconstant',
	      'specularexponent',
	      'spreadmethod',
	      'startoffset',
	      'stddeviation',
	      'stitchtiles',
	      'stop-color',
	      'stop-opacity',
	      'stroke-dasharray',
	      'stroke-dashoffset',
	      'stroke-linecap',
	      'stroke-linejoin',
	      'stroke-miterlimit',
	      'stroke-opacity',
	      'stroke',
	      'stroke-width',
	      'style',
	      'surfacescale',
	      'systemlanguage',
	      'tabindex',
	      'targetx',
	      'targety',
	      'transform',
	      'transform-origin',
	      'text-anchor',
	      'text-decoration',
	      'text-rendering',
	      'textlength',
	      'type',
	      'u1',
	      'u2',
	      'unicode',
	      'values',
	      'viewbox',
	      'visibility',
	      'version',
	      'vert-adv-y',
	      'vert-origin-x',
	      'vert-origin-y',
	      'width',
	      'word-spacing',
	      'wrap',
	      'writing-mode',
	      'xchannelselector',
	      'ychannelselector',
	      'x',
	      'x1',
	      'x2',
	      'xmlns',
	      'y',
	      'y1',
	      'y2',
	      'z',
	      'zoomandpan'
	    ]);
	    var mathMl = freeze([
	      'accent',
	      'accentunder',
	      'align',
	      'bevelled',
	      'close',
	      'columnsalign',
	      'columnlines',
	      'columnspan',
	      'denomalign',
	      'depth',
	      'dir',
	      'display',
	      'displaystyle',
	      'encoding',
	      'fence',
	      'frame',
	      'height',
	      'href',
	      'id',
	      'largeop',
	      'length',
	      'linethickness',
	      'lspace',
	      'lquote',
	      'mathbackground',
	      'mathcolor',
	      'mathsize',
	      'mathvariant',
	      'maxsize',
	      'minsize',
	      'movablelimits',
	      'notation',
	      'numalign',
	      'open',
	      'rowalign',
	      'rowlines',
	      'rowspacing',
	      'rowspan',
	      'rspace',
	      'rquote',
	      'scriptlevel',
	      'scriptminsize',
	      'scriptsizemultiplier',
	      'selection',
	      'separator',
	      'separators',
	      'stretchy',
	      'subscriptshift',
	      'supscriptshift',
	      'symmetric',
	      'voffset',
	      'width',
	      'xmlns'
	    ]);
	    var xml = freeze([
	      'xlink:href',
	      'xml:id',
	      'xlink:title',
	      'xml:space',
	      'xmlns:xlink'
	    ]);
	    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm);
	    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
	    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/);
	    var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
	    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
	    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
	    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
	    var DOCTYPE_NAME = seal(/^html$/i);
	    var getGlobal = function getGlobal() {
	      return typeof window === 'undefined' ? null : window;
	    };
	    var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
	      if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
	        return null;
	      }
	      var suffix = null;
	      var ATTR_NAME = 'data-tt-policy-suffix';
	      if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
	        suffix = document.currentScript.getAttribute(ATTR_NAME);
	      }
	      var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
	      try {
	        return trustedTypes.createPolicy(policyName, {
	          createHTML: function createHTML(html) {
	            return html;
	          }
	        });
	      } catch (_) {
	        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
	        return null;
	      }
	    };
	    function createDOMPurify() {
	      var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
	      var DOMPurify = function DOMPurify(root) {
	        return createDOMPurify(root);
	      };
	      DOMPurify.version = '2.3.8';
	      DOMPurify.removed = [];
	      if (!window || !window.document || window.document.nodeType !== 9) {
	        DOMPurify.isSupported = false;
	        return DOMPurify;
	      }
	      var originalDocument = window.document;
	      var document = window.document;
	      var DocumentFragment = window.DocumentFragment, HTMLTemplateElement = window.HTMLTemplateElement, Node = window.Node, Element = window.Element, NodeFilter = window.NodeFilter, _window$NamedNodeMap = window.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window.HTMLFormElement, DOMParser = window.DOMParser, trustedTypes = window.trustedTypes;
	      var ElementPrototype = Element.prototype;
	      var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
	      var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
	      var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
	      var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
	      if (typeof HTMLTemplateElement === 'function') {
	        var template = document.createElement('template');
	        if (template.content && template.content.ownerDocument) {
	          document = template.content.ownerDocument;
	        }
	      }
	      var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
	      var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
	      var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
	      var importNode = originalDocument.importNode;
	      var documentMode = {};
	      try {
	        documentMode = clone(document).documentMode ? document.documentMode : {};
	      } catch (_) {
	      }
	      var hooks = {};
	      DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
	      var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
	      var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
	      var ALLOWED_TAGS = null;
	      var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
	      var ALLOWED_ATTR = null;
	      var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
	      var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
	        tagNameCheck: {
	          writable: true,
	          configurable: false,
	          enumerable: true,
	          value: null
	        },
	        attributeNameCheck: {
	          writable: true,
	          configurable: false,
	          enumerable: true,
	          value: null
	        },
	        allowCustomizedBuiltInElements: {
	          writable: true,
	          configurable: false,
	          enumerable: true,
	          value: false
	        }
	      }));
	      var FORBID_TAGS = null;
	      var FORBID_ATTR = null;
	      var ALLOW_ARIA_ATTR = true;
	      var ALLOW_DATA_ATTR = true;
	      var ALLOW_UNKNOWN_PROTOCOLS = false;
	      var SAFE_FOR_TEMPLATES = false;
	      var WHOLE_DOCUMENT = false;
	      var SET_CONFIG = false;
	      var FORCE_BODY = false;
	      var RETURN_DOM = false;
	      var RETURN_DOM_FRAGMENT = false;
	      var RETURN_TRUSTED_TYPE = false;
	      var SANITIZE_DOM = true;
	      var KEEP_CONTENT = true;
	      var IN_PLACE = false;
	      var USE_PROFILES = {};
	      var FORBID_CONTENTS = null;
	      var DEFAULT_FORBID_CONTENTS = addToSet({}, [
	        'annotation-xml',
	        'audio',
	        'colgroup',
	        'desc',
	        'foreignobject',
	        'head',
	        'iframe',
	        'math',
	        'mi',
	        'mn',
	        'mo',
	        'ms',
	        'mtext',
	        'noembed',
	        'noframes',
	        'noscript',
	        'plaintext',
	        'script',
	        'style',
	        'svg',
	        'template',
	        'thead',
	        'title',
	        'video',
	        'xmp'
	      ]);
	      var DATA_URI_TAGS = null;
	      var DEFAULT_DATA_URI_TAGS = addToSet({}, [
	        'audio',
	        'video',
	        'img',
	        'source',
	        'image',
	        'track'
	      ]);
	      var URI_SAFE_ATTRIBUTES = null;
	      var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
	        'alt',
	        'class',
	        'for',
	        'id',
	        'label',
	        'name',
	        'pattern',
	        'placeholder',
	        'role',
	        'summary',
	        'title',
	        'value',
	        'style',
	        'xmlns'
	      ]);
	      var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
	      var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
	      var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
	      var NAMESPACE = HTML_NAMESPACE;
	      var IS_EMPTY_INPUT = false;
	      var PARSER_MEDIA_TYPE;
	      var SUPPORTED_PARSER_MEDIA_TYPES = [
	        'application/xhtml+xml',
	        'text/html'
	      ];
	      var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
	      var transformCaseFunc;
	      var CONFIG = null;
	      var formElement = document.createElement('form');
	      var isRegexOrFunction = function isRegexOrFunction(testValue) {
	        return testValue instanceof RegExp || testValue instanceof Function;
	      };
	      var _parseConfig = function _parseConfig(cfg) {
	        if (CONFIG && CONFIG === cfg) {
	          return;
	        }
	        if (!cfg || _typeof(cfg) !== 'object') {
	          cfg = {};
	        }
	        cfg = clone(cfg);
	        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
	        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
	        URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
	        DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
	        FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS) : DEFAULT_FORBID_CONTENTS;
	        FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
	        FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
	        USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
	        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
	        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
	        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
	        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
	        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
	        RETURN_DOM = cfg.RETURN_DOM || false;
	        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
	        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
	        FORCE_BODY = cfg.FORCE_BODY || false;
	        SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
	        KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
	        IN_PLACE = cfg.IN_PLACE || false;
	        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
	        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
	        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
	          CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
	        }
	        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
	          CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
	        }
	        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
	          CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
	        }
	        PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
	        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? function (x) {
	          return x;
	        } : stringToLowerCase;
	        if (SAFE_FOR_TEMPLATES) {
	          ALLOW_DATA_ATTR = false;
	        }
	        if (RETURN_DOM_FRAGMENT) {
	          RETURN_DOM = true;
	        }
	        if (USE_PROFILES) {
	          ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
	          ALLOWED_ATTR = [];
	          if (USE_PROFILES.html === true) {
	            addToSet(ALLOWED_TAGS, html$1);
	            addToSet(ALLOWED_ATTR, html);
	          }
	          if (USE_PROFILES.svg === true) {
	            addToSet(ALLOWED_TAGS, svg$1);
	            addToSet(ALLOWED_ATTR, svg);
	            addToSet(ALLOWED_ATTR, xml);
	          }
	          if (USE_PROFILES.svgFilters === true) {
	            addToSet(ALLOWED_TAGS, svgFilters);
	            addToSet(ALLOWED_ATTR, svg);
	            addToSet(ALLOWED_ATTR, xml);
	          }
	          if (USE_PROFILES.mathMl === true) {
	            addToSet(ALLOWED_TAGS, mathMl$1);
	            addToSet(ALLOWED_ATTR, mathMl);
	            addToSet(ALLOWED_ATTR, xml);
	          }
	        }
	        if (cfg.ADD_TAGS) {
	          if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
	            ALLOWED_TAGS = clone(ALLOWED_TAGS);
	          }
	          addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
	        }
	        if (cfg.ADD_ATTR) {
	          if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
	            ALLOWED_ATTR = clone(ALLOWED_ATTR);
	          }
	          addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
	        }
	        if (cfg.ADD_URI_SAFE_ATTR) {
	          addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
	        }
	        if (cfg.FORBID_CONTENTS) {
	          if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
	            FORBID_CONTENTS = clone(FORBID_CONTENTS);
	          }
	          addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS);
	        }
	        if (KEEP_CONTENT) {
	          ALLOWED_TAGS['#text'] = true;
	        }
	        if (WHOLE_DOCUMENT) {
	          addToSet(ALLOWED_TAGS, [
	            'html',
	            'head',
	            'body'
	          ]);
	        }
	        if (ALLOWED_TAGS.table) {
	          addToSet(ALLOWED_TAGS, ['tbody']);
	          delete FORBID_TAGS.tbody;
	        }
	        if (freeze) {
	          freeze(cfg);
	        }
	        CONFIG = cfg;
	      };
	      var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
	        'mi',
	        'mo',
	        'mn',
	        'ms',
	        'mtext'
	      ]);
	      var HTML_INTEGRATION_POINTS = addToSet({}, [
	        'foreignobject',
	        'desc',
	        'title',
	        'annotation-xml'
	      ]);
	      var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
	        'title',
	        'style',
	        'font',
	        'a',
	        'script'
	      ]);
	      var ALL_SVG_TAGS = addToSet({}, svg$1);
	      addToSet(ALL_SVG_TAGS, svgFilters);
	      addToSet(ALL_SVG_TAGS, svgDisallowed);
	      var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
	      addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
	      var _checkValidNamespace = function _checkValidNamespace(element) {
	        var parent = getParentNode(element);
	        if (!parent || !parent.tagName) {
	          parent = {
	            namespaceURI: HTML_NAMESPACE,
	            tagName: 'template'
	          };
	        }
	        var tagName = stringToLowerCase(element.tagName);
	        var parentTagName = stringToLowerCase(parent.tagName);
	        if (element.namespaceURI === SVG_NAMESPACE) {
	          if (parent.namespaceURI === HTML_NAMESPACE) {
	            return tagName === 'svg';
	          }
	          if (parent.namespaceURI === MATHML_NAMESPACE) {
	            return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
	          }
	          return Boolean(ALL_SVG_TAGS[tagName]);
	        }
	        if (element.namespaceURI === MATHML_NAMESPACE) {
	          if (parent.namespaceURI === HTML_NAMESPACE) {
	            return tagName === 'math';
	          }
	          if (parent.namespaceURI === SVG_NAMESPACE) {
	            return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
	          }
	          return Boolean(ALL_MATHML_TAGS[tagName]);
	        }
	        if (element.namespaceURI === HTML_NAMESPACE) {
	          if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
	            return false;
	          }
	          if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
	            return false;
	          }
	          return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
	        }
	        return false;
	      };
	      var _forceRemove = function _forceRemove(node) {
	        arrayPush(DOMPurify.removed, { element: node });
	        try {
	          node.parentNode.removeChild(node);
	        } catch (_) {
	          try {
	            node.outerHTML = emptyHTML;
	          } catch (_) {
	            node.remove();
	          }
	        }
	      };
	      var _removeAttribute = function _removeAttribute(name, node) {
	        try {
	          arrayPush(DOMPurify.removed, {
	            attribute: node.getAttributeNode(name),
	            from: node
	          });
	        } catch (_) {
	          arrayPush(DOMPurify.removed, {
	            attribute: null,
	            from: node
	          });
	        }
	        node.removeAttribute(name);
	        if (name === 'is' && !ALLOWED_ATTR[name]) {
	          if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
	            try {
	              _forceRemove(node);
	            } catch (_) {
	            }
	          } else {
	            try {
	              node.setAttribute(name, '');
	            } catch (_) {
	            }
	          }
	        }
	      };
	      var _initDocument = function _initDocument(dirty) {
	        var doc;
	        var leadingWhitespace;
	        if (FORCE_BODY) {
	          dirty = '<remove></remove>' + dirty;
	        } else {
	          var matches = stringMatch(dirty, /^[\r\n\t ]+/);
	          leadingWhitespace = matches && matches[0];
	        }
	        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml') {
	          dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
	        }
	        var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
	        if (NAMESPACE === HTML_NAMESPACE) {
	          try {
	            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
	          } catch (_) {
	          }
	        }
	        if (!doc || !doc.documentElement) {
	          doc = implementation.createDocument(NAMESPACE, 'template', null);
	          try {
	            doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
	          } catch (_) {
	          }
	        }
	        var body = doc.body || doc.documentElement;
	        if (dirty && leadingWhitespace) {
	          body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
	        }
	        if (NAMESPACE === HTML_NAMESPACE) {
	          return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
	        }
	        return WHOLE_DOCUMENT ? doc.documentElement : body;
	      };
	      var _createIterator = function _createIterator(root) {
	        return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
	      };
	      var _isClobbered = function _isClobbered(elm) {
	        return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function');
	      };
	      var _isNode = function _isNode(object) {
	        return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
	      };
	      var _executeHook = function _executeHook(entryPoint, currentNode, data) {
	        if (!hooks[entryPoint]) {
	          return;
	        }
	        arrayForEach(hooks[entryPoint], function (hook) {
	          hook.call(DOMPurify, currentNode, data, CONFIG);
	        });
	      };
	      var _sanitizeElements = function _sanitizeElements(currentNode) {
	        var content;
	        _executeHook('beforeSanitizeElements', currentNode, null);
	        if (_isClobbered(currentNode)) {
	          _forceRemove(currentNode);
	          return true;
	        }
	        if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
	          _forceRemove(currentNode);
	          return true;
	        }
	        var tagName = transformCaseFunc(currentNode.nodeName);
	        _executeHook('uponSanitizeElement', currentNode, {
	          tagName: tagName,
	          allowedTags: ALLOWED_TAGS
	        });
	        if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
	          _forceRemove(currentNode);
	          return true;
	        }
	        if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
	          _forceRemove(currentNode);
	          return true;
	        }
	        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
	          if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
	            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName))
	              return false;
	            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName))
	              return false;
	          }
	          if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
	            var parentNode = getParentNode(currentNode) || currentNode.parentNode;
	            var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
	            if (childNodes && parentNode) {
	              var childCount = childNodes.length;
	              for (var i = childCount - 1; i >= 0; --i) {
	                parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
	              }
	            }
	          }
	          _forceRemove(currentNode);
	          return true;
	        }
	        if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
	          _forceRemove(currentNode);
	          return true;
	        }
	        if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
	          _forceRemove(currentNode);
	          return true;
	        }
	        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
	          content = currentNode.textContent;
	          content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
	          content = stringReplace(content, ERB_EXPR$1, ' ');
	          if (currentNode.textContent !== content) {
	            arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
	            currentNode.textContent = content;
	          }
	        }
	        _executeHook('afterSanitizeElements', currentNode, null);
	        return false;
	      };
	      var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
	        if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
	          return false;
	        }
	        if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName));
	        else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName));
	        else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
	          if (_basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value)));
	          else {
	            return false;
	          }
	        } else if (URI_SAFE_ATTRIBUTES[lcName]);
	        else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, '')));
	        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]);
	        else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, '')));
	        else if (!value);
	        else {
	          return false;
	        }
	        return true;
	      };
	      var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
	        return tagName.indexOf('-') > 0;
	      };
	      var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
	        var attr;
	        var value;
	        var lcName;
	        var l;
	        _executeHook('beforeSanitizeAttributes', currentNode, null);
	        var attributes = currentNode.attributes;
	        if (!attributes) {
	          return;
	        }
	        var hookEvent = {
	          attrName: '',
	          attrValue: '',
	          keepAttr: true,
	          allowedAttributes: ALLOWED_ATTR
	        };
	        l = attributes.length;
	        while (l--) {
	          attr = attributes[l];
	          var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
	          value = name === 'value' ? attr.value : stringTrim(attr.value);
	          lcName = transformCaseFunc(name);
	          hookEvent.attrName = lcName;
	          hookEvent.attrValue = value;
	          hookEvent.keepAttr = true;
	          hookEvent.forceKeepAttr = undefined;
	          _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
	          value = hookEvent.attrValue;
	          if (hookEvent.forceKeepAttr) {
	            continue;
	          }
	          _removeAttribute(name, currentNode);
	          if (!hookEvent.keepAttr) {
	            continue;
	          }
	          if (regExpTest(/\/>/i, value)) {
	            _removeAttribute(name, currentNode);
	            continue;
	          }
	          if (SAFE_FOR_TEMPLATES) {
	            value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
	            value = stringReplace(value, ERB_EXPR$1, ' ');
	          }
	          var lcTag = transformCaseFunc(currentNode.nodeName);
	          if (!_isValidAttribute(lcTag, lcName, value)) {
	            continue;
	          }
	          try {
	            if (namespaceURI) {
	              currentNode.setAttributeNS(namespaceURI, name, value);
	            } else {
	              currentNode.setAttribute(name, value);
	            }
	            arrayPop(DOMPurify.removed);
	          } catch (_) {
	          }
	        }
	        _executeHook('afterSanitizeAttributes', currentNode, null);
	      };
	      var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
	        var shadowNode;
	        var shadowIterator = _createIterator(fragment);
	        _executeHook('beforeSanitizeShadowDOM', fragment, null);
	        while (shadowNode = shadowIterator.nextNode()) {
	          _executeHook('uponSanitizeShadowNode', shadowNode, null);
	          if (_sanitizeElements(shadowNode)) {
	            continue;
	          }
	          if (shadowNode.content instanceof DocumentFragment) {
	            _sanitizeShadowDOM(shadowNode.content);
	          }
	          _sanitizeAttributes(shadowNode);
	        }
	        _executeHook('afterSanitizeShadowDOM', fragment, null);
	      };
	      DOMPurify.sanitize = function (dirty, cfg) {
	        var body;
	        var importedNode;
	        var currentNode;
	        var oldNode;
	        var returnNode;
	        IS_EMPTY_INPUT = !dirty;
	        if (IS_EMPTY_INPUT) {
	          dirty = '<!-->';
	        }
	        if (typeof dirty !== 'string' && !_isNode(dirty)) {
	          if (typeof dirty.toString !== 'function') {
	            throw typeErrorCreate('toString is not a function');
	          } else {
	            dirty = dirty.toString();
	            if (typeof dirty !== 'string') {
	              throw typeErrorCreate('dirty is not a string, aborting');
	            }
	          }
	        }
	        if (!DOMPurify.isSupported) {
	          if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
	            if (typeof dirty === 'string') {
	              return window.toStaticHTML(dirty);
	            }
	            if (_isNode(dirty)) {
	              return window.toStaticHTML(dirty.outerHTML);
	            }
	          }
	          return dirty;
	        }
	        if (!SET_CONFIG) {
	          _parseConfig(cfg);
	        }
	        DOMPurify.removed = [];
	        if (typeof dirty === 'string') {
	          IN_PLACE = false;
	        }
	        if (IN_PLACE) {
	          if (dirty.nodeName) {
	            var tagName = transformCaseFunc(dirty.nodeName);
	            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
	              throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
	            }
	          }
	        } else if (dirty instanceof Node) {
	          body = _initDocument('<!---->');
	          importedNode = body.ownerDocument.importNode(dirty, true);
	          if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
	            body = importedNode;
	          } else if (importedNode.nodeName === 'HTML') {
	            body = importedNode;
	          } else {
	            body.appendChild(importedNode);
	          }
	        } else {
	          if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
	            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
	          }
	          body = _initDocument(dirty);
	          if (!body) {
	            return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
	          }
	        }
	        if (body && FORCE_BODY) {
	          _forceRemove(body.firstChild);
	        }
	        var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
	        while (currentNode = nodeIterator.nextNode()) {
	          if (currentNode.nodeType === 3 && currentNode === oldNode) {
	            continue;
	          }
	          if (_sanitizeElements(currentNode)) {
	            continue;
	          }
	          if (currentNode.content instanceof DocumentFragment) {
	            _sanitizeShadowDOM(currentNode.content);
	          }
	          _sanitizeAttributes(currentNode);
	          oldNode = currentNode;
	        }
	        oldNode = null;
	        if (IN_PLACE) {
	          return dirty;
	        }
	        if (RETURN_DOM) {
	          if (RETURN_DOM_FRAGMENT) {
	            returnNode = createDocumentFragment.call(body.ownerDocument);
	            while (body.firstChild) {
	              returnNode.appendChild(body.firstChild);
	            }
	          } else {
	            returnNode = body;
	          }
	          if (ALLOWED_ATTR.shadowroot) {
	            returnNode = importNode.call(originalDocument, returnNode, true);
	          }
	          return returnNode;
	        }
	        var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
	        if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
	          serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
	        }
	        if (SAFE_FOR_TEMPLATES) {
	          serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
	          serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
	        }
	        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
	      };
	      DOMPurify.setConfig = function (cfg) {
	        _parseConfig(cfg);
	        SET_CONFIG = true;
	      };
	      DOMPurify.clearConfig = function () {
	        CONFIG = null;
	        SET_CONFIG = false;
	      };
	      DOMPurify.isValidAttribute = function (tag, attr, value) {
	        if (!CONFIG) {
	          _parseConfig({});
	        }
	        var lcTag = transformCaseFunc(tag);
	        var lcName = transformCaseFunc(attr);
	        return _isValidAttribute(lcTag, lcName, value);
	      };
	      DOMPurify.addHook = function (entryPoint, hookFunction) {
	        if (typeof hookFunction !== 'function') {
	          return;
	        }
	        hooks[entryPoint] = hooks[entryPoint] || [];
	        arrayPush(hooks[entryPoint], hookFunction);
	      };
	      DOMPurify.removeHook = function (entryPoint) {
	        if (hooks[entryPoint]) {
	          return arrayPop(hooks[entryPoint]);
	        }
	      };
	      DOMPurify.removeHooks = function (entryPoint) {
	        if (hooks[entryPoint]) {
	          hooks[entryPoint] = [];
	        }
	      };
	      DOMPurify.removeAllHooks = function () {
	        hooks = {};
	      };
	      return DOMPurify;
	    }
	    var purify = createDOMPurify();
	
	    var sanitizeHtmlString = function (html) {
	      return purify().sanitize(html);
	    };
	
	    var isTouch = global$9.deviceType.isTouch();
	    var hiddenHeader = function (title, close) {
	      return {
	        dom: {
	          tag: 'div',
	          styles: { display: 'none' },
	          classes: ['tox-dialog__header']
	        },
	        components: [
	          title,
	          close
	        ]
	      };
	    };
	    var pClose = function (onClose, providersBackstage) {
	      return ModalDialog.parts.close(Button.sketch({
	        dom: {
	          tag: 'button',
	          classes: [
	            'tox-button',
	            'tox-button--icon',
	            'tox-button--naked'
	          ],
	          attributes: {
	            'type': 'button',
	            'aria-label': providersBackstage.translate('Close')
	          }
	        },
	        action: onClose,
	        buttonBehaviours: derive$1([Tabstopping.config({})])
	      }));
	    };
	    var pUntitled = function () {
	      return ModalDialog.parts.title({
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__title'],
	          innerHtml: '',
	          styles: { display: 'none' }
	        }
	      });
	    };
	    var pBodyMessage = function (message, providersBackstage) {
	      return ModalDialog.parts.body({
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__body']
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-content']
	            },
	            components: [{ dom: fromHtml('<p>' + sanitizeHtmlString(providersBackstage.translate(message)) + '</p>') }]
	          }]
	      });
	    };
	    var pFooter = function (buttons) {
	      return ModalDialog.parts.footer({
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__footer']
	        },
	        components: buttons
	      });
	    };
	    var pFooterGroup = function (startButtons, endButtons) {
	      return [
	        Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-dialog__footer-start']
	          },
	          components: startButtons
	        }),
	        Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-dialog__footer-end']
	          },
	          components: endButtons
	        })
	      ];
	    };
	    var renderDialog$1 = function (spec) {
	      var _a;
	      var dialogClass = 'tox-dialog';
	      var blockerClass = dialogClass + '-wrap';
	      var blockerBackdropClass = blockerClass + '__backdrop';
	      var scrollLockClass = dialogClass + '__disable-scroll';
	      return ModalDialog.sketch({
	        lazySink: spec.lazySink,
	        onEscape: function (comp) {
	          spec.onEscape(comp);
	          return Optional.some(true);
	        },
	        useTabstopAt: function (elem) {
	          return !isPseudoStop(elem);
	        },
	        dom: {
	          tag: 'div',
	          classes: [dialogClass].concat(spec.extraClasses),
	          styles: __assign({ position: 'relative' }, spec.extraStyles)
	        },
	        components: __spreadArray([
	          spec.header,
	          spec.body
	        ], spec.footer.toArray(), true),
	        parts: {
	          blocker: {
	            dom: fromHtml('<div class="' + blockerClass + '"></div>'),
	            components: [{
	                dom: {
	                  tag: 'div',
	                  classes: isTouch ? [
	                    blockerBackdropClass,
	                    blockerBackdropClass + '--opaque'
	                  ] : [blockerBackdropClass]
	                }
	              }]
	          }
	        },
	        dragBlockClass: blockerClass,
	        modalBehaviours: derive$1(__spreadArray([
	          Focusing.config({}),
	          config('dialog-events', spec.dialogEvents.concat([runOnSource(focusin(), function (comp, _se) {
	              Keying.focusIn(comp);
	            })])),
	          config('scroll-lock', [
	            runOnAttached(function () {
	              add$2(body(), scrollLockClass);
	            }),
	            runOnDetached(function () {
	              remove$2(body(), scrollLockClass);
	            })
	          ])
	        ], spec.extraBehaviours, true)),
	        eventOrder: __assign((_a = {}, _a[execute$5()] = ['dialog-events'], _a[attachedToDom()] = [
	          'scroll-lock',
	          'dialog-events',
	          'alloy.base.behaviour'
	        ], _a[detachedFromDom()] = [
	          'alloy.base.behaviour',
	          'dialog-events',
	          'scroll-lock'
	        ], _a), spec.eventOrder)
	      });
	    };
	
	    var renderClose = function (providersBackstage) {
	      return Button.sketch({
	        dom: {
	          tag: 'button',
	          classes: [
	            'tox-button',
	            'tox-button--icon',
	            'tox-button--naked'
	          ],
	          attributes: {
	            'type': 'button',
	            'aria-label': providersBackstage.translate('Close'),
	            'title': providersBackstage.translate('Close')
	          }
	        },
	        components: [render$3('close', {
	            tag: 'div',
	            classes: ['tox-icon']
	          }, providersBackstage.icons)],
	        action: function (comp) {
	          emit(comp, formCancelEvent);
	        }
	      });
	    };
	    var renderTitle = function (spec, id, providersBackstage) {
	      var renderComponents = function (data) {
	        return [text$1(providersBackstage.translate(data.title))];
	      };
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__title'],
	          attributes: __assign({}, id.map(function (x) {
	            return { id: x };
	          }).getOr({}))
	        },
	        components: renderComponents(spec),
	        behaviours: derive$1([Reflecting.config({
	            channel: titleChannel,
	            renderComponents: renderComponents
	          })])
	      };
	    };
	    var renderDragHandle = function () {
	      return { dom: fromHtml('<div class="tox-dialog__draghandle"></div>') };
	    };
	    var renderInlineHeader = function (spec, titleId, providersBackstage) {
	      return Container.sketch({
	        dom: fromHtml('<div class="tox-dialog__header"></div>'),
	        components: [
	          renderTitle(spec, Optional.some(titleId), providersBackstage),
	          renderDragHandle(),
	          renderClose(providersBackstage)
	        ],
	        containerBehaviours: derive$1([Dragging.config({
	            mode: 'mouse',
	            blockerClass: 'blocker',
	            getTarget: function (handle) {
	              return closest$1(handle, '[role="dialog"]').getOrDie();
	            },
	            snaps: {
	              getSnapPoints: function () {
	                return [];
	              },
	              leftAttr: 'data-drag-left',
	              topAttr: 'data-drag-top'
	            }
	          })])
	      });
	    };
	    var renderModalHeader = function (spec, providersBackstage) {
	      var pTitle = ModalDialog.parts.title(renderTitle(spec, Optional.none(), providersBackstage));
	      var pHandle = ModalDialog.parts.draghandle(renderDragHandle());
	      var pClose = ModalDialog.parts.close(renderClose(providersBackstage));
	      var components = [pTitle].concat(spec.draggable ? [pHandle] : []).concat([pClose]);
	      return Container.sketch({
	        dom: fromHtml('<div class="tox-dialog__header"></div>'),
	        components: components
	      });
	    };
	
	    var getHeader = function (title, backstage) {
	      return renderModalHeader({
	        title: backstage.shared.providers.translate(title),
	        draggable: backstage.dialog.isDraggableModal()
	      }, backstage.shared.providers);
	    };
	    var getBusySpec = function (message, bs, providers) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__busy-spinner'],
	          attributes: { 'aria-label': providers.translate(message) },
	          styles: {
	            left: '0px',
	            right: '0px',
	            bottom: '0px',
	            top: '0px',
	            position: 'absolute'
	          }
	        },
	        behaviours: bs,
	        components: [{ dom: fromHtml('<div class="tox-spinner"><div></div><div></div><div></div></div>') }]
	      };
	    };
	    var getEventExtras = function (lazyDialog, providers, extra) {
	      return {
	        onClose: function () {
	          return extra.closeWindow();
	        },
	        onBlock: function (blockEvent) {
	          ModalDialog.setBusy(lazyDialog(), function (_comp, bs) {
	            return getBusySpec(blockEvent.message, bs, providers);
	          });
	        },
	        onUnblock: function () {
	          ModalDialog.setIdle(lazyDialog());
	        }
	      };
	    };
	    var renderModalDialog = function (spec, initialData, dialogEvents, backstage) {
	      var _a;
	      var updateState = function (_comp, incoming) {
	        return Optional.some(incoming);
	      };
	      return build$1(renderDialog$1(__assign(__assign({}, spec), {
	        lazySink: backstage.shared.getSink,
	        extraBehaviours: __spreadArray([
	          Reflecting.config({
	            channel: dialogChannel,
	            updateState: updateState,
	            initialData: initialData
	          }),
	          RepresentingConfigs.memory({})
	        ], spec.extraBehaviours, true),
	        onEscape: function (comp) {
	          emit(comp, formCancelEvent);
	        },
	        dialogEvents: dialogEvents,
	        eventOrder: (_a = {}, _a[receive()] = [
	          Reflecting.name(),
	          Receiving.name()
	        ], _a[attachedToDom()] = [
	          'scroll-lock',
	          Reflecting.name(),
	          'messages',
	          'dialog-events',
	          'alloy.base.behaviour'
	        ], _a[detachedFromDom()] = [
	          'alloy.base.behaviour',
	          'dialog-events',
	          'messages',
	          Reflecting.name(),
	          'scroll-lock'
	        ], _a)
	      })));
	    };
	    var mapMenuButtons = function (buttons) {
	      var mapItems = function (button) {
	        var items = map$2(button.items, function (item) {
	          var cell = Cell(false);
	          return __assign(__assign({}, item), { storage: cell });
	        });
	        return __assign(__assign({}, button), { items: items });
	      };
	      return map$2(buttons, function (button) {
	        if (button.type === 'menu') {
	          return mapItems(button);
	        }
	        return button;
	      });
	    };
	    var extractCellsToObject = function (buttons) {
	      return foldl(buttons, function (acc, button) {
	        if (button.type === 'menu') {
	          var menuButton = button;
	          return foldl(menuButton.items, function (innerAcc, item) {
	            innerAcc[item.name] = item.storage;
	            return innerAcc;
	          }, acc);
	        }
	        return acc;
	      }, {});
	    };
	
	    var initCommonEvents = function (fireApiEvent, extras) {
	      return [
	        runWithTarget(focusin(), onFocus),
	        fireApiEvent(formCloseEvent, function (_api, spec) {
	          extras.onClose();
	          spec.onClose();
	        }),
	        fireApiEvent(formCancelEvent, function (api, spec, _event, self) {
	          spec.onCancel(api);
	          emit(self, formCloseEvent);
	        }),
	        run$1(formUnblockEvent, function (_c, _se) {
	          return extras.onUnblock();
	        }),
	        run$1(formBlockEvent, function (_c, se) {
	          return extras.onBlock(se.event);
	        })
	      ];
	    };
	    var initUrlDialog = function (getInstanceApi, extras) {
	      var fireApiEvent = function (eventName, f) {
	        return run$1(eventName, function (c, se) {
	          withSpec(c, function (spec, _c) {
	            f(getInstanceApi(), spec, se.event, c);
	          });
	        });
	      };
	      var withSpec = function (c, f) {
	        Reflecting.getState(c).get().each(function (currentDialog) {
	          f(currentDialog, c);
	        });
	      };
	      return __spreadArray(__spreadArray([], initCommonEvents(fireApiEvent, extras), true), [fireApiEvent(formActionEvent, function (api, spec, event) {
	          spec.onAction(api, { name: event.name });
	        })], false);
	    };
	    var initDialog = function (getInstanceApi, extras, getSink) {
	      var fireApiEvent = function (eventName, f) {
	        return run$1(eventName, function (c, se) {
	          withSpec(c, function (spec, _c) {
	            f(getInstanceApi(), spec, se.event, c);
	          });
	        });
	      };
	      var withSpec = function (c, f) {
	        Reflecting.getState(c).get().each(function (currentDialogInit) {
	          f(currentDialogInit.internalDialog, c);
	        });
	      };
	      return __spreadArray(__spreadArray([], initCommonEvents(fireApiEvent, extras), true), [
	        fireApiEvent(formSubmitEvent, function (api, spec) {
	          return spec.onSubmit(api);
	        }),
	        fireApiEvent(formChangeEvent, function (api, spec, event) {
	          spec.onChange(api, { name: event.name });
	        }),
	        fireApiEvent(formActionEvent, function (api, spec, event, component) {
	          var focusIn = function () {
	            return Keying.focusIn(component);
	          };
	          var isDisabled = function (focused) {
	            return has$1(focused, 'disabled') || getOpt(focused, 'aria-disabled').exists(function (val) {
	              return val === 'true';
	            });
	          };
	          var rootNode = getRootNode(component.element);
	          var current = active(rootNode);
	          spec.onAction(api, {
	            name: event.name,
	            value: event.value
	          });
	          active(rootNode).fold(focusIn, function (focused) {
	            if (isDisabled(focused)) {
	              focusIn();
	            } else if (current.exists(function (cur) {
	                return contains(focused, cur) && isDisabled(cur);
	              })) {
	              focusIn();
	            } else {
	              getSink().toOptional().filter(function (sink) {
	                return !contains(sink.element, focused);
	              }).each(focusIn);
	            }
	          });
	        }),
	        fireApiEvent(formTabChangeEvent, function (api, spec, event) {
	          spec.onTabChange(api, {
	            newTabName: event.name,
	            oldTabName: event.oldName
	          });
	        }),
	        runOnDetached(function (component) {
	          var api = getInstanceApi();
	          Representing.setValue(component, api.getData());
	        })
	      ], false);
	    };
	    var SilverDialogEvents = {
	      initUrlDialog: initUrlDialog,
	      initDialog: initDialog
	    };
	
	    var makeButton = function (button, backstage) {
	      return renderFooterButton(button, button.type, backstage);
	    };
	    var lookup = function (compInSystem, footerButtons, buttonName) {
	      return find$5(footerButtons, function (button) {
	        return button.name === buttonName;
	      }).bind(function (memButton) {
	        return memButton.memento.getOpt(compInSystem);
	      });
	    };
	    var renderComponents = function (_data, state) {
	      var footerButtons = state.map(function (s) {
	        return s.footerButtons;
	      }).getOr([]);
	      var buttonGroups = partition$3(footerButtons, function (button) {
	        return button.align === 'start';
	      });
	      var makeGroup = function (edge, buttons) {
	        return Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-dialog__footer-' + edge]
	          },
	          components: map$2(buttons, function (button) {
	            return button.memento.asSpec();
	          })
	        });
	      };
	      var startButtons = makeGroup('start', buttonGroups.pass);
	      var endButtons = makeGroup('end', buttonGroups.fail);
	      return [
	        startButtons,
	        endButtons
	      ];
	    };
	    var renderFooter = function (initSpec, backstage) {
	      var updateState = function (_comp, data) {
	        var footerButtons = map$2(data.buttons, function (button) {
	          var memButton = record(makeButton(button, backstage));
	          return {
	            name: button.name,
	            align: button.align,
	            memento: memButton
	          };
	        });
	        var lookupByName = function (compInSystem, buttonName) {
	          return lookup(compInSystem, footerButtons, buttonName);
	        };
	        return Optional.some({
	          lookupByName: lookupByName,
	          footerButtons: footerButtons
	        });
	      };
	      return {
	        dom: fromHtml('<div class="tox-dialog__footer"></div>'),
	        components: [],
	        behaviours: derive$1([Reflecting.config({
	            channel: footerChannel,
	            initialData: initSpec,
	            updateState: updateState,
	            renderComponents: renderComponents
	          })])
	      };
	    };
	    var renderInlineFooter = function (initSpec, backstage) {
	      return renderFooter(initSpec, backstage);
	    };
	    var renderModalFooter = function (initSpec, backstage) {
	      return ModalDialog.parts.footer(renderFooter(initSpec, backstage));
	    };
	
	    var getCompByName = function (access, name) {
	      var root = access.getRoot();
	      if (root.getSystem().isConnected()) {
	        var form_1 = Composing.getCurrent(access.getFormWrapper()).getOr(access.getFormWrapper());
	        return Form.getField(form_1, name).fold(function () {
	          var footer = access.getFooter();
	          var footerState = Reflecting.getState(footer);
	          return footerState.get().bind(function (f) {
	            return f.lookupByName(form_1, name);
	          });
	        }, function (comp) {
	          return Optional.some(comp);
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	    var validateData$1 = function (access, data) {
	      var root = access.getRoot();
	      return Reflecting.getState(root).get().map(function (dialogState) {
	        return getOrDie(asRaw('data', dialogState.dataValidator, data));
	      }).getOr(data);
	    };
	    var getDialogApi = function (access, doRedial, menuItemStates) {
	      var withRoot = function (f) {
	        var root = access.getRoot();
	        if (root.getSystem().isConnected()) {
	          f(root);
	        }
	      };
	      var getData = function () {
	        var root = access.getRoot();
	        var valueComp = root.getSystem().isConnected() ? access.getFormWrapper() : root;
	        var representedValues = Representing.getValue(valueComp);
	        var menuItemCurrentState = map$1(menuItemStates, function (cell) {
	          return cell.get();
	        });
	        return __assign(__assign({}, representedValues), menuItemCurrentState);
	      };
	      var setData = function (newData) {
	        withRoot(function (_) {
	          var prevData = instanceApi.getData();
	          var mergedData = __assign(__assign({}, prevData), newData);
	          var newInternalData = validateData$1(access, mergedData);
	          var form = access.getFormWrapper();
	          Representing.setValue(form, newInternalData);
	          each(menuItemStates, function (v, k) {
	            if (has$2(mergedData, k)) {
	              v.set(mergedData[k]);
	            }
	          });
	        });
	      };
	      var disable = function (name) {
	        getCompByName(access, name).each(Disabling.disable);
	      };
	      var enable = function (name) {
	        getCompByName(access, name).each(Disabling.enable);
	      };
	      var focus = function (name) {
	        getCompByName(access, name).each(Focusing.focus);
	      };
	      var block = function (message) {
	        if (!isString(message)) {
	          throw new Error('The dialogInstanceAPI.block function should be passed a blocking message of type string as an argument');
	        }
	        withRoot(function (root) {
	          emitWith(root, formBlockEvent, { message: message });
	        });
	      };
	      var unblock = function () {
	        withRoot(function (root) {
	          emit(root, formUnblockEvent);
	        });
	      };
	      var showTab = function (name) {
	        withRoot(function (_) {
	          var body = access.getBody();
	          var bodyState = Reflecting.getState(body);
	          if (bodyState.get().exists(function (b) {
	              return b.isTabPanel();
	            })) {
	            Composing.getCurrent(body).each(function (tabSection) {
	              TabSection.showTab(tabSection, name);
	            });
	          }
	        });
	      };
	      var redial = function (d) {
	        withRoot(function (root) {
	          var dialogInit = doRedial(d);
	          root.getSystem().broadcastOn([dialogChannel], dialogInit);
	          root.getSystem().broadcastOn([titleChannel], dialogInit.internalDialog);
	          root.getSystem().broadcastOn([bodyChannel], dialogInit.internalDialog);
	          root.getSystem().broadcastOn([footerChannel], dialogInit.internalDialog);
	          instanceApi.setData(dialogInit.initialData);
	        });
	      };
	      var close = function () {
	        withRoot(function (root) {
	          emit(root, formCloseEvent);
	        });
	      };
	      var instanceApi = {
	        getData: getData,
	        setData: setData,
	        disable: disable,
	        enable: enable,
	        focus: focus,
	        block: block,
	        unblock: unblock,
	        showTab: showTab,
	        redial: redial,
	        close: close
	      };
	      return instanceApi;
	    };
	
	    var getDialogSizeClasses = function (size) {
	      switch (size) {
	      case 'large':
	        return ['tox-dialog--width-lg'];
	      case 'medium':
	        return ['tox-dialog--width-md'];
	      default:
	        return [];
	      }
	    };
	    var renderDialog = function (dialogInit, extra, backstage) {
	      var header = getHeader(dialogInit.internalDialog.title, backstage);
	      var body = renderModalBody({ body: dialogInit.internalDialog.body }, backstage);
	      var storagedMenuButtons = mapMenuButtons(dialogInit.internalDialog.buttons);
	      var objOfCells = extractCellsToObject(storagedMenuButtons);
	      var footer = renderModalFooter({ buttons: storagedMenuButtons }, backstage);
	      var dialogEvents = SilverDialogEvents.initDialog(function () {
	        return instanceApi;
	      }, getEventExtras(function () {
	        return dialog;
	      }, backstage.shared.providers, extra), backstage.shared.getSink);
	      var dialogSize = getDialogSizeClasses(dialogInit.internalDialog.size);
	      var spec = {
	        header: header,
	        body: body,
	        footer: Optional.some(footer),
	        extraClasses: dialogSize,
	        extraBehaviours: [],
	        extraStyles: {}
	      };
	      var dialog = renderModalDialog(spec, dialogInit, dialogEvents, backstage);
	      var modalAccess = function () {
	        var getForm = function () {
	          var outerForm = ModalDialog.getBody(dialog);
	          return Composing.getCurrent(outerForm).getOr(outerForm);
	        };
	        return {
	          getRoot: constant$1(dialog),
	          getBody: function () {
	            return ModalDialog.getBody(dialog);
	          },
	          getFooter: function () {
	            return ModalDialog.getFooter(dialog);
	          },
	          getFormWrapper: getForm
	        };
	      }();
	      var instanceApi = getDialogApi(modalAccess, extra.redial, objOfCells);
	      return {
	        dialog: dialog,
	        instanceApi: instanceApi
	      };
	    };
	
	    var renderInlineDialog = function (dialogInit, extra, backstage, ariaAttrs) {
	      var _a, _b;
	      var dialogLabelId = generate$6('dialog-label');
	      var dialogContentId = generate$6('dialog-content');
	      var updateState = function (_comp, incoming) {
	        return Optional.some(incoming);
	      };
	      var memHeader = record(renderInlineHeader({
	        title: dialogInit.internalDialog.title,
	        draggable: true
	      }, dialogLabelId, backstage.shared.providers));
	      var memBody = record(renderInlineBody({ body: dialogInit.internalDialog.body }, dialogContentId, backstage, ariaAttrs));
	      var storagedMenuButtons = mapMenuButtons(dialogInit.internalDialog.buttons);
	      var objOfCells = extractCellsToObject(storagedMenuButtons);
	      var memFooter = record(renderInlineFooter({ buttons: storagedMenuButtons }, backstage));
	      var dialogEvents = SilverDialogEvents.initDialog(function () {
	        return instanceApi;
	      }, {
	        onBlock: function (event) {
	          Blocking.block(dialog, function (_comp, bs) {
	            return getBusySpec(event.message, bs, backstage.shared.providers);
	          });
	        },
	        onUnblock: function () {
	          Blocking.unblock(dialog);
	        },
	        onClose: function () {
	          return extra.closeWindow();
	        }
	      }, backstage.shared.getSink);
	      var dialog = build$1({
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-dialog',
	            'tox-dialog-inline'
	          ],
	          attributes: (_a = { role: 'dialog' }, _a['aria-labelledby'] = dialogLabelId, _a['aria-describedby'] = dialogContentId, _a)
	        },
	        eventOrder: (_b = {}, _b[receive()] = [
	          Reflecting.name(),
	          Receiving.name()
	        ], _b[execute$5()] = ['execute-on-form'], _b[attachedToDom()] = [
	          'reflecting',
	          'execute-on-form'
	        ], _b),
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'cyclic',
	            onEscape: function (c) {
	              emit(c, formCloseEvent);
	              return Optional.some(true);
	            },
	            useTabstopAt: function (elem) {
	              return !isPseudoStop(elem) && (name$2(elem) !== 'button' || get$d(elem, 'disabled') !== 'disabled');
	            }
	          }),
	          Reflecting.config({
	            channel: dialogChannel,
	            updateState: updateState,
	            initialData: dialogInit
	          }),
	          Focusing.config({}),
	          config('execute-on-form', dialogEvents.concat([runOnSource(focusin(), function (comp, _se) {
	              Keying.focusIn(comp);
	            })])),
	          Blocking.config({
	            getRoot: function () {
	              return Optional.some(dialog);
	            }
	          }),
	          Replacing.config({}),
	          RepresentingConfigs.memory({})
	        ]),
	        components: [
	          memHeader.asSpec(),
	          memBody.asSpec(),
	          memFooter.asSpec()
	        ]
	      });
	      var instanceApi = getDialogApi({
	        getRoot: constant$1(dialog),
	        getFooter: function () {
	          return memFooter.get(dialog);
	        },
	        getBody: function () {
	          return memBody.get(dialog);
	        },
	        getFormWrapper: function () {
	          var body = memBody.get(dialog);
	          return Composing.getCurrent(body).getOr(body);
	        }
	      }, extra.redial, objOfCells);
	      return {
	        dialog: dialog,
	        instanceApi: instanceApi
	      };
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.URI');
	
	    var getUrlDialogApi = function (root) {
	      var withRoot = function (f) {
	        if (root.getSystem().isConnected()) {
	          f(root);
	        }
	      };
	      var block = function (message) {
	        if (!isString(message)) {
	          throw new Error('The urlDialogInstanceAPI.block function should be passed a blocking message of type string as an argument');
	        }
	        withRoot(function (root) {
	          emitWith(root, formBlockEvent, { message: message });
	        });
	      };
	      var unblock = function () {
	        withRoot(function (root) {
	          emit(root, formUnblockEvent);
	        });
	      };
	      var close = function () {
	        withRoot(function (root) {
	          emit(root, formCloseEvent);
	        });
	      };
	      var sendMessage = function (data) {
	        withRoot(function (root) {
	          root.getSystem().broadcastOn([bodySendMessageChannel], data);
	        });
	      };
	      return {
	        block: block,
	        unblock: unblock,
	        close: close,
	        sendMessage: sendMessage
	      };
	    };
	
	    var SUPPORTED_MESSAGE_ACTIONS = [
	      'insertContent',
	      'setContent',
	      'execCommand',
	      'close',
	      'block',
	      'unblock'
	    ];
	    var isSupportedMessage = function (data) {
	      return isObject(data) && SUPPORTED_MESSAGE_ACTIONS.indexOf(data.mceAction) !== -1;
	    };
	    var isCustomMessage = function (data) {
	      return !isSupportedMessage(data) && isObject(data) && has$2(data, 'mceAction');
	    };
	    var handleMessage = function (editor, api, data) {
	      switch (data.mceAction) {
	      case 'insertContent':
	        editor.insertContent(data.content);
	        break;
	      case 'setContent':
	        editor.setContent(data.content);
	        break;
	      case 'execCommand':
	        var ui = isBoolean(data.ui) ? data.ui : false;
	        editor.execCommand(data.cmd, ui, data.value);
	        break;
	      case 'close':
	        api.close();
	        break;
	      case 'block':
	        api.block(data.message);
	        break;
	      case 'unblock':
	        api.unblock();
	        break;
	      }
	    };
	    var renderUrlDialog = function (internalDialog, extra, editor, backstage) {
	      var _a;
	      var header = getHeader(internalDialog.title, backstage);
	      var body = renderIframeBody(internalDialog);
	      var footer = internalDialog.buttons.bind(function (buttons) {
	        if (buttons.length === 0) {
	          return Optional.none();
	        } else {
	          return Optional.some(renderModalFooter({ buttons: buttons }, backstage));
	        }
	      });
	      var dialogEvents = SilverDialogEvents.initUrlDialog(function () {
	        return instanceApi;
	      }, getEventExtras(function () {
	        return dialog;
	      }, backstage.shared.providers, extra));
	      var styles = __assign(__assign({}, internalDialog.height.fold(function () {
	        return {};
	      }, function (height) {
	        return {
	          'height': height + 'px',
	          'max-height': height + 'px'
	        };
	      })), internalDialog.width.fold(function () {
	        return {};
	      }, function (width) {
	        return {
	          'width': width + 'px',
	          'max-width': width + 'px'
	        };
	      }));
	      var classes = internalDialog.width.isNone() && internalDialog.height.isNone() ? ['tox-dialog--width-lg'] : [];
	      var iframeUri = new global$1(internalDialog.url, { base_uri: new global$1(window.location.href) });
	      var iframeDomain = iframeUri.protocol + '://' + iframeUri.host + (iframeUri.port ? ':' + iframeUri.port : '');
	      var messageHandlerUnbinder = unbindable();
	      var extraBehaviours = [
	        config('messages', [
	          runOnAttached(function () {
	            var unbind = bind(SugarElement.fromDom(window), 'message', function (e) {
	              if (iframeUri.isSameOrigin(new global$1(e.raw.origin))) {
	                var data = e.raw.data;
	                if (isSupportedMessage(data)) {
	                  handleMessage(editor, instanceApi, data);
	                } else if (isCustomMessage(data)) {
	                  internalDialog.onMessage(instanceApi, data);
	                }
	              }
	            });
	            messageHandlerUnbinder.set(unbind);
	          }),
	          runOnDetached(messageHandlerUnbinder.clear)
	        ]),
	        Receiving.config({
	          channels: (_a = {}, _a[bodySendMessageChannel] = {
	            onReceive: function (comp, data) {
	              descendant(comp.element, 'iframe').each(function (iframeEle) {
	                var iframeWin = iframeEle.dom.contentWindow;
	                iframeWin.postMessage(data, iframeDomain);
	              });
	            }
	          }, _a)
	        })
	      ];
	      var spec = {
	        header: header,
	        body: body,
	        footer: footer,
	        extraClasses: classes,
	        extraBehaviours: extraBehaviours,
	        extraStyles: styles
	      };
	      var dialog = renderModalDialog(spec, internalDialog, dialogEvents, backstage);
	      var instanceApi = getUrlDialogApi(dialog);
	      return {
	        dialog: dialog,
	        instanceApi: instanceApi
	      };
	    };
	
	    var setup$2 = function (extras) {
	      var sharedBackstage = extras.backstage.shared;
	      var open = function (message, callback) {
	        var closeDialog = function () {
	          ModalDialog.hide(alertDialog);
	          callback();
	        };
	        var memFooterClose = record(renderFooterButton({
	          name: 'close-alert',
	          text: 'OK',
	          primary: true,
	          align: 'end',
	          disabled: false,
	          icon: Optional.none()
	        }, 'cancel', extras.backstage));
	        var titleSpec = pUntitled();
	        var closeSpec = pClose(closeDialog, sharedBackstage.providers);
	        var alertDialog = build$1(renderDialog$1({
	          lazySink: function () {
	            return sharedBackstage.getSink();
	          },
	          header: hiddenHeader(titleSpec, closeSpec),
	          body: pBodyMessage(message, sharedBackstage.providers),
	          footer: Optional.some(pFooter(pFooterGroup([], [memFooterClose.asSpec()]))),
	          onEscape: closeDialog,
	          extraClasses: ['tox-alert-dialog'],
	          extraBehaviours: [],
	          extraStyles: {},
	          dialogEvents: [run$1(formCancelEvent, closeDialog)],
	          eventOrder: {}
	        }));
	        ModalDialog.show(alertDialog);
	        var footerCloseButton = memFooterClose.get(alertDialog);
	        Focusing.focus(footerCloseButton);
	      };
	      return { open: open };
	    };
	
	    var setup$1 = function (extras) {
	      var sharedBackstage = extras.backstage.shared;
	      var open = function (message, callback) {
	        var closeDialog = function (state) {
	          ModalDialog.hide(confirmDialog);
	          callback(state);
	        };
	        var memFooterYes = record(renderFooterButton({
	          name: 'yes',
	          text: 'Yes',
	          primary: true,
	          align: 'end',
	          disabled: false,
	          icon: Optional.none()
	        }, 'submit', extras.backstage));
	        var footerNo = renderFooterButton({
	          name: 'no',
	          text: 'No',
	          primary: false,
	          align: 'end',
	          disabled: false,
	          icon: Optional.none()
	        }, 'cancel', extras.backstage);
	        var titleSpec = pUntitled();
	        var closeSpec = pClose(function () {
	          return closeDialog(false);
	        }, sharedBackstage.providers);
	        var confirmDialog = build$1(renderDialog$1({
	          lazySink: function () {
	            return sharedBackstage.getSink();
	          },
	          header: hiddenHeader(titleSpec, closeSpec),
	          body: pBodyMessage(message, sharedBackstage.providers),
	          footer: Optional.some(pFooter(pFooterGroup([], [
	            footerNo,
	            memFooterYes.asSpec()
	          ]))),
	          onEscape: function () {
	            return closeDialog(false);
	          },
	          extraClasses: ['tox-confirm-dialog'],
	          extraBehaviours: [],
	          extraStyles: {},
	          dialogEvents: [
	            run$1(formCancelEvent, function () {
	              return closeDialog(false);
	            }),
	            run$1(formSubmitEvent, function () {
	              return closeDialog(true);
	            })
	          ],
	          eventOrder: {}
	        }));
	        ModalDialog.show(confirmDialog);
	        var footerYesButton = memFooterYes.get(confirmDialog);
	        Focusing.focus(footerYesButton);
	      };
	      return { open: open };
	    };
	
	    var validateData = function (data, validator) {
	      return getOrDie(asRaw('data', validator, data));
	    };
	    var isAlertOrConfirmDialog = function (target) {
	      return closest(target, '.tox-alert-dialog') || closest(target, '.tox-confirm-dialog');
	    };
	    var inlineAdditionalBehaviours = function (editor, isStickyToolbar, isToolbarLocationTop) {
	      if (isStickyToolbar && isToolbarLocationTop) {
	        return [];
	      } else {
	        return [Docking.config({
	            contextual: {
	              lazyContext: function () {
	                return Optional.some(box$1(SugarElement.fromDom(editor.getContentAreaContainer())));
	              },
	              fadeInClass: 'tox-dialog-dock-fadein',
	              fadeOutClass: 'tox-dialog-dock-fadeout',
	              transitionClass: 'tox-dialog-dock-transition'
	            },
	            modes: ['top']
	          })];
	      }
	    };
	    var setup = function (extras) {
	      var backstage = extras.backstage;
	      var editor = extras.editor;
	      var isStickyToolbar$1 = isStickyToolbar(editor);
	      var alertDialog = setup$2(extras);
	      var confirmDialog = setup$1(extras);
	      var open = function (config, params, closeWindow) {
	        if (params !== undefined && params.inline === 'toolbar') {
	          return openInlineDialog(config, backstage.shared.anchors.inlineDialog(), closeWindow, params.ariaAttrs);
	        } else if (params !== undefined && params.inline === 'cursor') {
	          return openInlineDialog(config, backstage.shared.anchors.cursor(), closeWindow, params.ariaAttrs);
	        } else {
	          return openModalDialog(config, closeWindow);
	        }
	      };
	      var openUrl = function (config, closeWindow) {
	        return openModalUrlDialog(config, closeWindow);
	      };
	      var openModalUrlDialog = function (config, closeWindow) {
	        var factory = function (contents) {
	          var dialog = renderUrlDialog(contents, {
	            closeWindow: function () {
	              ModalDialog.hide(dialog.dialog);
	              closeWindow(dialog.instanceApi);
	            }
	          }, editor, backstage);
	          ModalDialog.show(dialog.dialog);
	          return dialog.instanceApi;
	        };
	        return DialogManager.openUrl(factory, config);
	      };
	      var openModalDialog = function (config, closeWindow) {
	        var factory = function (contents, internalInitialData, dataValidator) {
	          var initialData = internalInitialData;
	          var dialogInit = {
	            dataValidator: dataValidator,
	            initialData: initialData,
	            internalDialog: contents
	          };
	          var dialog = renderDialog(dialogInit, {
	            redial: DialogManager.redial,
	            closeWindow: function () {
	              ModalDialog.hide(dialog.dialog);
	              closeWindow(dialog.instanceApi);
	            }
	          }, backstage);
	          ModalDialog.show(dialog.dialog);
	          dialog.instanceApi.setData(initialData);
	          return dialog.instanceApi;
	        };
	        return DialogManager.open(factory, config);
	      };
	      var openInlineDialog = function (config$1, anchor, closeWindow, ariaAttrs) {
	        var factory = function (contents, internalInitialData, dataValidator) {
	          var initialData = validateData(internalInitialData, dataValidator);
	          var inlineDialog = value$1();
	          var isToolbarLocationTop = backstage.shared.header.isPositionedAtTop();
	          var dialogInit = {
	            dataValidator: dataValidator,
	            initialData: initialData,
	            internalDialog: contents
	          };
	          var refreshDocking = function () {
	            return inlineDialog.on(function (dialog) {
	              InlineView.reposition(dialog);
	              Docking.refresh(dialog);
	            });
	          };
	          var dialogUi = renderInlineDialog(dialogInit, {
	            redial: DialogManager.redial,
	            closeWindow: function () {
	              inlineDialog.on(InlineView.hide);
	              editor.off('ResizeEditor', refreshDocking);
	              inlineDialog.clear();
	              closeWindow(dialogUi.instanceApi);
	            }
	          }, backstage, ariaAttrs);
	          var inlineDialogComp = build$1(InlineView.sketch(__assign(__assign({
	            lazySink: backstage.shared.getSink,
	            dom: {
	              tag: 'div',
	              classes: []
	            },
	            fireDismissalEventInstead: {}
	          }, isToolbarLocationTop ? {} : { fireRepositionEventInstead: {} }), {
	            inlineBehaviours: derive$1(__spreadArray([config('window-manager-inline-events', [run$1(dismissRequested(), function (_comp, _se) {
	                  emit(dialogUi.dialog, formCancelEvent);
	                })])], inlineAdditionalBehaviours(editor, isStickyToolbar$1, isToolbarLocationTop), true)),
	            isExtraPart: function (_comp, target) {
	              return isAlertOrConfirmDialog(target);
	            }
	          })));
	          inlineDialog.set(inlineDialogComp);
	          InlineView.showWithin(inlineDialogComp, premade(dialogUi.dialog), { anchor: anchor }, Optional.some(body()));
	          if (!isStickyToolbar$1 || !isToolbarLocationTop) {
	            Docking.refresh(inlineDialogComp);
	            editor.on('ResizeEditor', refreshDocking);
	          }
	          dialogUi.instanceApi.setData(initialData);
	          Keying.focusIn(dialogUi.dialog);
	          return dialogUi.instanceApi;
	        };
	        return DialogManager.open(factory, config$1);
	      };
	      var confirm = function (message, callback) {
	        confirmDialog.open(message, function (state) {
	          callback(state);
	        });
	      };
	      var alert = function (message, callback) {
	        alertDialog.open(message, function () {
	          callback();
	        });
	      };
	      var close = function (instanceApi) {
	        instanceApi.close();
	      };
	      return {
	        open: open,
	        openUrl: openUrl,
	        alert: alert,
	        close: close,
	        confirm: confirm
	      };
	    };
	
	    function Theme () {
	      global$g.add('silver', function (editor) {
	        var _a = setup$3(editor), uiMothership = _a.uiMothership, backstage = _a.backstage, renderUI = _a.renderUI, getUi = _a.getUi;
	        Autocompleter.register(editor, backstage.shared);
	        var windowMgr = setup({
	          editor: editor,
	          backstage: backstage
	        });
	        return {
	          renderUI: renderUI,
	          getWindowManagerImpl: constant$1(windowMgr),
	          getNotificationManagerImpl: function () {
	            return NotificationManagerImpl(editor, { backstage: backstage }, uiMothership);
	          },
	          ui: getUi()
	        };
	      });
	    }
	
	    Theme();
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(512).setImmediate))

/***/ }),
/* 2259 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iMzJweCIgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMyIDMyOyIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzMnB4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNMjgsMTRIOC44bDQuNjItNC42MkMxMy44MTQsOC45ODYsMTQsOC41MTYsMTQsOGMwLTAuOTg0LTAuODEzLTItMi0yYy0wLjUzMSwwLTAuOTk0LDAuMTkzLTEuMzgsMC41OGwtNy45NTgsNy45NTggIEMyLjMzNCwxNC44NjYsMiwxNS4yNzEsMiwxNnMwLjI3OSwxLjA4LDAuNjQ2LDEuNDQ3bDcuOTc0LDcuOTczQzExLjAwNiwyNS44MDcsMTEuNDY5LDI2LDEyLDI2YzEuMTg4LDAsMi0xLjAxNiwyLTIgIGMwLTAuNTE2LTAuMTg2LTAuOTg2LTAuNTgtMS4zOEw4LjgsMThIMjhjMS4xMDQsMCwyLTAuODk2LDItMlMyOS4xMDQsMTQsMjgsMTR6Ii8+PC9zdmc+Cg=="

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/easinsure/easinsure-logotype-slogan.jpg";

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/easinsure/easinsure-logotype.svg";

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/icn-folder.svg";

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/icn-refresh.svg";

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/icn-upload-lock.svg";

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/Willemot_wefacilitateyourbusiness__1_RGB.png";

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/Willemot_wefacilitateyourbusiness__1_RGB_400achtergrondBroker (1).jpg";

/***/ }),
/* 2267 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAAXNSR0IArs4c6QAAAL5JREFUKBVjXLttVycjEAhysDQ5Ojp+YcADmJgYGXn+//9f+u77nxsbdu4Jx6OWgQkh+V/6799/K9Zt27V33e7dmghxBAtJMUTwPwOD0/8/DBfXbd/dtX//fh6EUgZkk5GE//9nxeY0FiQlWJggp/0HOS2NkYE5DcMZWHTAhQiYzPiUmZmxOMDdZSVIB3bFjIy/GRkYJqCHPYZioKJ9QCNyglxdr8PthzKQFKNaia4QxGcBhutXYGx3o1uJTTEAp6VGdmz5croAAAAASUVORK5CYII="

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAvklEQVQ4y2NgIAH8//+fMSu/aHJmXuF/IP0IxCdRc/FUoOb7xcXFImBDCoqjSdRcdByIT2XmF3WADCgoaBAgSXNZWRlvfnGxKZD9FWhIKMmaswvLtYEaX2YXloTRXjNQ8bSB1ZzV0MBDP80gkJlfuIZszdkFJZbZ+UU/s/ILJxcUVCiQpBkEgBqPZRQUJQFdcCezoOgJSZpzCkqcgBrfAQ25CMHFxaRkMKDfizaD0nVOfpEfAzkgt7JSlIECAADQn7fdYoHx0AAAAABJRU5ErkJggg=="

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4ggYCgo47f/xWgAAAQRJREFUOI2V0T1LA0EUheH3Zl0sQoqIU4mm2BS2sRpbIYKgrbBWtkIshPyNNKJ/wGZBrYS0wSLFFIKthVsFq4DGIgQSw1gkLhHyMXPKGZ7DnTuCR6JYC3BN19Rko9KxwXop54lvZDw8RmllP1+3gTOngj8Mds8GYReoT6+aaz4Y5BDYpf/xjNKnaWJ64ol3ZNRv2TB/mSbmHmBhgQteWDDFt2Ary/DcAh8MkFuCq6vwvwnm4NIqDDD7jQ9gt3xw9oQo1vt8vZ+AvACbrjgrANugWL6Q8ehIfgZtVwwgUawPGPYeCQudyUlwlyam4YJhsoMrvt+KKH2eJubJFWaJYq280Ux+AfgchpLr8ZzoAAAAAElFTkSuQmCC"

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/a-edit_1x_green.png";

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABrklEQVR42pVTTShEURQefyVJEomFpSSJsrGSpbKUrCwscO+bd+895848zaxebCyEiEwWUkpNyZLdSHYWimytKGoiZSNpnMOT8ean5tbp1ek73/nud78XCR+tF7qksp7QeCo1XgsF5/Tdk8ZOpFKpukipk06na6SBdakgS8PbUWPHhI71C4ARoey80JCh/o1Ssb6C4VwuVyU1XBLowlrb+tt3IDaZj3MMzpCiXBS8oX8EQuEuyfxkovw+g8PLHAVTpOQpam3Pd4NlckP6fmMYTKT7xa7LHpHiowBktxwN8UgFh80k1c9aJ9uJDe8cxO6CLQYXSdm7McmO4irwgBROs8w33/cbwgDX95vYVIk4WoyAyJf5KsQEr8b4zcVBkClDsCYMIr/ArTTxgQoJWPkxPzObuCK0XaqEgF9MangBgJYgupBlR8sRhHPDaf1rGEwQ4xWbGTh8QhI/8ssxseGfYTvLAStYSKBNTqOLOEhE1VS1+cX/SrDo0U0k2iIljJmj7Q9UZ+wwx5byLxyFGyT5no2Lel5n2ZTRtnpH4zhtWiVzD2loh5PqWtsb/lf4fAG9M+oS/q/98QAAAABJRU5ErkJggg=="

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAIxAAACMQB8nZHkwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAHPSURBVEiJ3ZM9axRRFIafc2dnEjDKgJWQOlpY2qQQRHFV2IRs4hY2gr8gH4Km3MJS4lgKgrVL3I2kCLumEEGx8QcENIiFIAjOCtHsOjPHYic6blZ3ZpLKt7vvPee5L/eeK6TUpcbiTUXvJqz1Vtmb3ltcqC9NWBJtJXsKaeEJbYN8AX2XNMUOdwnMm95KTwFHssOF262Ze6v99ubU/Q/AGYBiY+EVMGmyB0+v1MnDH85DrG7DjFmfhtWqCa5qYI8eLNp/K0lbWKzPl8SY62EoK5tzK6//Wbu2cEeQidTTImJOqmrFWNH40GLlvKpWMs+5KJMX6/OCysdnc97LPX/66a2j38POZQCB40qOH6qwJCIgrAO/vv9OGJywRGpxDWSBSxS9wGI5ccrb5H4h0M84uvxHD0CxsbgNuH+Pq99as97wu+5TL7lG7xFzrI84ApyOIzhZwb22AarUqk7b9leBqdjaaZW9sazwfaN47lF1tG37azF4A9ja15UHXqlVHcf1a8AVgWbXd2dROgeGJ69CoNnx3ZnnN6q7ecEQP2gP3H4ClA4LDGB+g/VQwQCmbfuPQUvAxiCwCF9R/Dzwgqg8UFG6vnttUOJm2TubMzg/AdfTqm9BuMCMAAAAAElFTkSuQmCC"

/***/ }),
/* 2273 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAB2ElEQVR42oVSQUtVQRiddBOIm1wIrYIIwXAhSlSUkCBJLUQXEqRtWsTM3Ddzv2/uvfok4bkJ14ZibVy5eQsJAt0oCEVuXASFmCs3GkUt+gWv8+GD+9T79IPh3vnuOXPO+eaqs0VE14ynYDxv4rmH9V3erafUlssd6qIC2BhHf0B4b4iGLU3dLoXQHfnwGL1l7fmvccEXkm3MWjuqOZfeaiZQStObgrGO35xVfikfvJ/pVJeUxDCOj0RQSSVJ0obGzxJzbzNSpVK5qmMuR1l2XfYRUQ/i/MqyrF1ZR8+w+diMaD077elYHEZxMpi75jWsF/KyIhGKiGIVQ/0AzCusT6dnFiYhvKoA2pApS7NarbY2EiUWDmuBg4NGdSnD/Aj9LSVAxBiVJoiHYlWuUmxbH+ZMHJ7n6nnpOHkKzLpEeIsBsTS9z7riePqGLJCHtOPdc+r5zUUQe4ch8hNsvpy7c0ofCrlIve5221Iyomq12hUofYXVsUYAHAxInCJ1EMcxwG8ynxM15rvI/U+70JdPObkHdwuF2WVOPjyot3KCfJArU00KqhMQ+m2Y7xcD4AC5PyPfD4DnbcwWS8u/j/4+ou6UiO6oyyqirN96eo1DlmB1EQfOSq8I+x+ya/puzVq1TwAAAABJRU5ErkJggg=="

/***/ }),
/* 2274 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAIxAAACMQB8nZHkwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAI/SURBVEiJrVU9b9NQFD3HEQNiKC0DLGytxEKlShESFRtN4gxpKBPdGJnyYZBg6/PWDiRl6z9oJ4ptocZtQSyoCBUk9mbsiEoWRBXiy5AYvcSu86Ge6ele33Pe/fIDxoDpWCrnVtfHiUmNQy6UNQAPZlfvX21ufzm8NAGNPMTIIkMFNPJfADoA2gB+A1iae7LIk52jT0nxRiK5Z5V65GeBIANIC5BW94wzoayZnlWaWICp9lsA30CYB8X6cWg/KNaPDeFDAN/xN3CTOIZDwPCYcyunObdyGue7CJEMTM+yMl5p7r+BkAujNV/2nXU7rlx9AqZjKRF5bUhqVymVWL4+CEhDdkXkjelYKlZAn5ZA8FQpFUQuLJKnSD4uk0DwDGHjNRH2kRMtAFm/UP868u015B1rIaAcApgBsOEv11+xb4mIFgU/IxUgH/uF2g/dlvWe3zEkeB/9FjcgmOpmTHv0Ok8IAkDOtV4Csn6ZJRKK2i9sdjPwl2sbFNoQTEHQyDjVdByB6ZTnTac8H+fLONV0QPkAYIZCe7+waQPaFDWKNUWhDWDaILbilkjIPSH3IuwCGsQWgGkK7UaxpkJXXw8axZoiWZaAK4kLNghCJOAKybJOPhKy/otr4XnwV6H7LkLiFGXdSp7nnWbOq94b9OUda4HnnZOsV3k0sQAFaQA3IfD1xvca+hHALQa4m8iR5AQiD86VnrkN4PpgQycSALQ90RDO+bDYkd7k5vbR59nVxT8AlsYhHxumY6nB3/Ew/AMawxSAdREy9wAAAABJRU5ErkJggg=="

/***/ }),
/* 2275 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAACC0lEQVR42n1TTahNURS+iAgpRAZG9BS9gf+8UoyIAUrJgJTR2fuevfda+/z0XnqdGZmKXBMjk1tKBqRIUgwZvJShCSmvlFAm1/dd93Du6ebU6Z71963vW2vdTvsRkfXGSzRen+L3Hd4FflsvuZ2d3dD534NkY5x8QcEdI3LcSrkrjXFn18dj8N1OvC4aF/3EYhs0JE4GVnWq9vV6veWmqtZUVbWCdprn25DzK/Hxervz5cTLR+/nNtNGwUrr1cH3AYy+EZjsGKMM2miYDIuzLFttnH5KVXfXgEzg632xYzAYLKEM2iHMbWG8KzINOZ+LoliL7noOXR4yMOq+lMmkXvv6/f6yxOlPEVnVYH0ftRcJcJcSmpL+UMz31HYq+WH6CP5vZvECWNzrgP5jTrm5xiED1a1/u4lspy/GuLH2IX4UM3oGAHlgnZxpMqA+BJ/XNldHgLGckJ1EziNKuJEEVTob6DN1x7Is1/E7FTkwDhBT3kbHOj2BGbxq3wWG9rYbsiMEI6N2HMUvrGSnhlMHwBsgnuaUTYjnIesJ948VbyILAHzlOXNwXPuo6QK3M0KL+6HnO6lSF1fLK2xeJIDPct3MweB/2JAdajLihU0huGiCXmrTHVsd/isi5fSEMHXHvej+Eh3eg/Y1G9TyZEH36tDn9LX12cFW2WQg6+UKQG5B3k3Imu9KsW9S7m+g8B2cwiKoFwAAAABJRU5ErkJggg=="

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAJ2AAACdgBx6C5rQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAD9SURBVEiJtdYxCsIwFAbgP9IUV6GDV+jSxQsUQQd1cfEObkLxFC5u3sHFoSqo6ODepYtH0M1VSUqdRGwrJunr2woNHyHv/QnrriYpFGo/nDOV/7JVM1mkU1bm+2IJ3t6OZjcq4LODFDEAV1pi54eBQw5w++kDLAKDZ8vk3FtOm6TAZrC4c/7oACwC4EouThTI1yFXgeS6iBopbFNK5OccUCF/p7O/HjeEqB+AtAWDOVEa/zKIcr6YIloBZoJoJ6Qq8k5p7TTV7S6juNZBjO8DVaTUhaOCGF2D2So6eMnFlQwAAD8MHFskRzB4SBGDwSMFgNxOUApQfY1U/qp4AWFws2TPEKVdAAAAAElFTkSuQmCC"

/***/ }),
/* 2277 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhDAwJNC72x/WJAAAAqUlEQVQoz5XRQWrCQBQG4C8SEAwuBG8Q5hTuXPQEnkA8gZUeomBP0mu47bZCbyDiJiaQTdtFJqR0XOhb/fx8zBt4mWE2SjCzc+3LDMECrLyDYOoDHHxlmNp7k87WsypH5eJ4A1xUjP4UTwhCTHE68AOWKJUxxbYDrXGyYKwdQK1IQKF+ADQ3QfPQikkCJnf+IY9gjk+ciKlwHnSwTl5YC/014dX3PzDyAr+g3ib9snaiXAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0xMi0xMlQwOTo1Mjo0NiswMTowMKNkmCoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMTItMTJUMDk6NTI6NDYrMDE6MDDSOSCWAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="

/***/ }),
/* 2278 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAVUlEQVQI12Nw31Qw331z4WQGNOCxqWiS2+bCBSBGutumgv8emwvb4ZJANlgMKAcWcN9SWAwSANJVbpuKqqHsYlQjNxc1gCQgphU1MGADQLf0gDCyGAAeRi1WOuEa+AAAAABJRU5ErkJggg=="

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAFCAYAAACeuGYRAAAAf0lEQVQYlWNmYGBg+P//P+Nxkw+lqlHWAneWH7/NQAAw+m0s4/3B+DOWgZHxFTPz382ENHznFP7L8oPxTx4jE5Ml499/K/4xsMb9//+fEacN/xmYOP98vM7C8Z9l0o9/P9//Z2L8wcz8ezUxNjHA/OS2Ob/UY3ORFyFNDAwMDADkcTETz/syZQAAAABJRU5ErkJggg=="

/***/ }),
/* 2280 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAABNElEQVR42oWQP0vEQBDFI1jb2finsNHKwkZBsRUbEcQvIGiR2Ww2M7sJXOPFQjhO/AwiNtZWIoJcoYiNH0JrFUHb+IbcQZSAC4+FmfdmfrtR8yRFMRWnXMVOXpvSmhVZiv475OSWMgm2KGZGIs43jQsrcSpvzDzdGrSdziSMG5TyS1mW481enHkLgi/juB87vkuyfI1EVm1ZTtRh5mVFJMfvaMy2LUB/z3DYBuE5fI+Uyr1mEuZFxb5E4UQ3o0mW8/U61k5qMr+fhDCnGfxPLwLWMd7dHX7ep96U+Z2/YSMyX5PKk97G+T50BAI/gJ4x6EONJOEAhm9tNgXPAwZfqUepdQgoukpwCPVGheGWgdabQu2s7nmuafniF6JzxQKecG1SOa2qaixqOSDYxaAb4rA1qv0Atdm1xDz5q4AAAAAASUVORK5CYII="

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAABkklEQVR42pVTPUsDQRCNFoqI2Ah2ImIhoiAYRfyoFOxsREtREMl97s7u5S6kMVY2YpHG0tgIipA6pYKdlTYGRSSCloJ/4HxzXrRJzGXhcbO3M+/NzM6mkiyb/LQp1L3hUmjL7EKqnSVEfjAKFGodWGNbytxwYgJT6EXTVdW/vaoZ5K0kJiCiHlYFyS2Cz9guFApdLQPDMOywyNtkeJ7Xawh1ZQo60VoPJFJGwIMh6D1Wr7bVOIeySxxY34Pgw3LVcmICm2iSCYIg6Pd9v49tw9XTDZ0toVxDUgkNKrueN8FXxIEZQTkOZFhC55uqRTVKtc0NQs2fSPfVxBeET5ajpG37aVvrsX8J4jr3oXTwW7fMTjEJmvlVzwT2BnAJoUfTpQtcZ2dTAktQFgSnMcpxphVL6l0M1xHvnWKxOyIQIhhC2odwvHa0Ho8aKfQqznZ+oDNEuRGcb0HoBeoVkMzwrKT4kQC1KEWpSzh843/cOIdo1iQaBcEezwJ8bkyl5ltOoKPUHDI6Nlx1BzyD8JzfRCP/b4YR5x3GFE2qAAAAAElFTkSuQmCC"

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAABdUlEQVR42o2RzysFURTHHzYoSUKJxMoKZSv/gI1sZEEs546Z+9OdGVLPwsLKH8DLVk/+ASn/gLLyF7BQSPkDjPO9r1t33nvK1OncOfeez/mec2rhV6/Xe1kqX6JUlhFXr4zL22az2Vf774dE2L4xs0ypaZwZV5e4K8uyh/PDCWPMeFcoqrtkred9jBS8RUInETcLUaouSNUn2TugAFYASVGMAZBl2bCvSEnPMEq4xl2oNOZ6tUMF+o6F3q60JPQ6PM3mxhWydsoptXayC0Ce0uWPOwuz5gB5PgIP6S2oXsa/tXaoA+AfY1jU/xP6dnGZzznZWs/Ao6VKopRygHo6IZkfsVDCw6jqN6l6YFyvsFQdM6G3ACC/QUPvd8lYGYJU7RGrC8FYF1XbaSWpM98Cxe5J4Rf5TQzunA5XQV63FQ8CEsbiohhFzA2O6Ed/JfuVhoBwS1CQkYI7qPBG/TbgQ/OA9pin74VGinbbY4lSiwBU3x0s/QIydfvitHJb4gAAAABJRU5ErkJggg=="

/***/ }),
/* 2283 */
2282,
/* 2284 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAQCAYAAADAvYV+AAABp0lEQVR42oWSQShmURTHH2MhhhFhKVKmZkOZlY2yEBtDfSsbCxbvvve9e8+9z3u+ibpiY0NKamRDSn3Z2diIlR2RiMUsWEjUTGZKkfrmf/o8KYxbp3vvub///91z7nOSIYgaRUBXvgrbnfeGtbbQDSgHwY0r9Rr2xf8VuMp8E4HehugHC9PWlr8N00iDK+mM13CfF5J2wjAsfRXO5XIFgP5EUVTGe7gvC2noBQiHmjiOP+HOf5OcZ0ydG+hfUn6vfQL9MKyH46FPUSsO97nY5Aw1TOJsJq/OZKq4GA4kr3FPk81mPzwZqeE25HbzSqlnuXqh9ADmB1+ZLsz3KHRLKVvBQsC/iaiSP3MqZdQEXSIeQiwivwIDmy9UH3kUf+HDW34ARIknzTj2516gO3ClFGIj30Y68Y35DJgO0lq3AOhmUKjhZga8gHoBr8OkCPAFd8bxJI0CWhLWfmQY4mmhTD+An5j7HtebDo90JlMNhztE/NjXOVeaVY/CHu4vd8mXptNJBr8YHI8B7gGc8JQZRHFTyF3y//LWU6cAWVxnAd0Yw1N/fc78A/Km1o1rf6OJAAAAAElFTkSuQmCC"

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAABMklEQVR42o2SO0rHQBDGo7UgWgo+TyB4Dk8giJY7iTs7szEJYpFCtLHTwlIbWz2BFxCvoPjAQhEL7Sw0X/hHJdliB34wzM5880iSkBHrUcMnWXk0rE/Gyrdz1UISayhIvZ8n1dkW1nNifxhOlmoJBYblmVgfRnz8+sDKS8Mr/H+cjMaVd+NU0Ym5nIulnZJlF/t+he8g1+hkWN+M9SuDd+uLdi0ohQS6w5HVPdB/T9nvpFb3+wLofGNY7hFvbIwkX4UPMElQINS5LMvJLoadu0miBBo2yW0v/02l68bqcZyA81vGySnidV2PE0sGn1gvTFVNhQUC1hY53eh3Dgpg52GCWmI9IyuXIjI9/Ix6RSwHCTm/BpEmcGtY7mJAPqC6nkhgWVHMYIoszxdjwO+P+6D2B7j0CZaLg5g3AAAAAElFTkSuQmCC"

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAABE0lEQVQokWNgwAHKysp4s/ILz2YVFEeD+FkFRQnZBUVJ2QWlRrj0oGs+BtRUnZVX9BxkSGZe0ezs/OJ5mXmF/xsaGlgIa84vnA7i5xQXawDZLzLzi2LALskv+j1z5kxWojTDQH5+mTrIJSBDgAbMWrVqFTPRmrEZQrJmvIYAA4SNGM04DcnLK1UlVjO6If///2dkyCwo8QYJAgXuEaMZmBaygRYWgwxBiU5Q/IJNBLHzS/RAfKChD8A4v/A8TA6UNjLzC1sxTEY2AKipFshfVFBQoQDCyImHeAPyi5uR5P7QxwBgKouD4OKpaAb8z84rjofKT8ZqAFBTIcjfIJyVV7ipsLBQCC6XV5yPLJddWSkMkwMARhraugpl9VgAAAAASUVORK5CYII="

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABdUlEQVR42o1Tu0rFQBBdH4gPLCwE0UJQwdJCsBAs7AQRf0BEsHE3Zjezm4TcQrjiL1hYaGElXMRCsLMQUbFR7CwErQQfYG8h8UyxBEKUDEyReZwzc3Yi2JrNZqcydl9p+yy1vQ8iG+V53sa5wLlRjsNf4dfS2BWO+8Z2NP7Az41JJ6V20wB44O/Q2impKVeG1jfTdFhZO680fTC4YEPxBpI3HsxPAoZ3bgwoXvZxPwnHw0ZjUIDhTEbxoiiZjGyDi1qtVkc5x2QhJXPc/BQmyXiRKtaBd4sKQ8+hiuwao9xil1lR37jnLiSaEdK4IyCt1m2UWTYAQb/SNO0XiuIlZq/Nqu0WyPb8bl3S0Eud0YloBK/wqYgmCjSiBQYAUO//rHQaGLddNc4Bo/rLKhu02UHNBd+AqHoaJB8BcFy5J59okgxVARf7a7qEmrv+OAJDCQC/JWVjooYoPVDzBBpcyciFrEUcx32irvHeyrhMGXrjH+Kvul8zxLkw/jFS4QAAAABJRU5ErkJggg=="

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAAAXNSR0IArs4c6QAAAlNJREFUKBVtUk1oE1EQnnm7m00iNaRga5CKtWAjFIoKYnPr1ZOXIuJBkF6MJjHtJkUQyUEN2mZtkiYpCoLXSsGDepSCioX6Q3sIhnooejJCg7W0brr7xtlI/EHn8h4z830z880g/GHJZNJnEU4QwUUBWN4T7LhRb3wbJJI5RPAhKvHS9NSrNgTbn+jl8TNENAmAz1VdSTmWXWCSIY7rQoABKDallCYDXmigpfP5Wx8xk8monxsb7xCoCQrGBvv7l5ar7+NAcIUQH/F7lAksJr3kVWT1u4QUEyTZNytCoRDjaICrvEYS+5ertSoHhlVQhyp5c7Sczx0DoLuI8onl4IyKYpUAtgmwr9V2LDZ2xEaY56ReFHhbOXjgWjEe52q/LR43Bmx05rhIDwh8MBw5kRBu2EZ6i4Czqlfr4TYPOR/WahcSYyNuzDCMrmgiWbHBeQYg7ule7ThIiCy8XFxogbn8HIA0HGvnVFdw9wgpdI5HucqglS1b1pBwi/x6vwbqfNPauQ5IQSTItsDlwp3TQtFOckuZeuPrCoCiAYLOIh1mn2ThSGxbo01qVkmCpvb1hksF82kL7La3y4OriBjg9tMgnTLv2eDVqapfD3NnnSxQRAFR5HmrbT1+gX0+vg9OZiX3dQcD4VLefOySFrPZL6V87rwHPUmJFGPXG9fvWkvtn1+AaCq1F5rOQ1bdj6BEJTmL3Z0BX319Y4J9MURhMtHNdv5f4LaTr+0sn+QkKx9i+jWusYQKjJdN81M7x33/C3YD6XS6Y7PpVHj2+zPTU7ymf+0Hj4HuhPAdJSkAAAAASUVORK5CYII="

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAABTUlEQVR42pVRu0oEQRBcMBAjudQXamgo4geYCv6BgWAy+5ie7ll3F58oaCremZsYbWKkIhiYngoa+QGCif8gZ/e4u8wJd3ADRdNdPTVFTTDshEA/SmNvIABPm2WfiMAe1wJlWY7x4qHMBLFJ17juRprO+l/TdCQQAd9BbOhAZj6fgN3vE0isXWLygS/cVC62KvRioA2pzH0K3Myke42AWHQLhp54eK2ASl68EkRA2jkhmgXI5wR5nk8qk647J4irQZxlU6HG72DEww+eOBcxZish4MuoAk2QxhTzoaav2mpk7GaTTZbN+D0iTkvvC8hwok7ZVcA3rl0mL/8CpfdQm2fOpOPxr7z/6AQis7Mc8kABfnC9lVfdRWO7PLur+4hFud6LC8cDnStVtFjAbift9rgqipYQ1Zdd/Os7kn7dK3Y3MByFxaLfx2m6MIz/BW8C9FhVraurAAAAAElFTkSuQmCC"

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAABRklEQVR42p1RPUvEQBCNqKiVnf4D7cTK1t9gpyKoheLsXnZ2ZnMGrjqxsbE5UEghfpQp/BMiFmJnZaWNCKLdYRlnIBzeJcLpwiPz9d7uvER1x3hOAPkdHH8ax2fGh7VomNNutyeFuCGkZ4vUjGNaMi6gCN2Bo6u405n4lYy4P2+QHgHpCXxyrDdL/ibETITHRDiXuFsUxUiFnKbptDQLg7zzs05EU2X9WnONdb2KgA4IzutelmXZOCAfASYLSZLMSPyB2JrtH3D8pfsP45OsdgtEy70C+BAD0qtBvhyEdbRSfW04UWN7Bd0LXNi1LmwOwvjm4qCAxdACDId9AqJ6A54uhoFFftjzdK9xnuejkWWeK93dUtiYU4MU6gDIpzor2NbZ3i/VoiZlswtIL3XQfgNpveKsNsSwVf1G/zlqopLFoIO/cr8B5f/eSoKjVjEAAAAASUVORK5CYII="

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAAXNSR0IArs4c6QAAAKlJREFUOBGVk8sNgzAQBX3KiR7SUU4caSrtcI3SCV2AMPMsr/IRZtdIDwzsjFc2pJzzkzxS5yFGbOI0k5WMUYdqKzNLMJBXfeBKqDNYzFAm1YC4klPY2vYkl7AnCcEtSRd8ItkQKJ8FsyLvCjSRvWby6n/eA9lWvRkr8e/kCy5tcx/a4tLBP2xthSQtOCTx4EtJFG5KECyka5+pt4Vd9Dfeyc1miF7FiD0AFhaY/psVfm0AAAAASUVORK5CYII="

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAjElEQVR4Ae3LMQ7BMRQG8LqC3RFcx2gw6au81+8Lm9ER/GeJIziKK0gkFokDSLWRmhpdDYbf+HNiPIvi0uKV9xUwzVzlvCIJOWkyPr3x9kk1ZK6lhID1rKZeKFKIXCwVgygeKaXR1xAigxgPhTdeg2HTDq1s2Ipy9w8/FMQ47/HK/TtEMqdjjyhOAMYvP2AtP/3h8XgAAAAASUVORK5CYII="

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/dropdown-arrow_1x.png";

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAABeUlEQVR42p1STSsGURidhZJiI5aEnfRaKFnRnZn79dx572AxFghv2ZCFEjbKG0sbNn4Ae6IUO/ErrC1EsbSx4DmTkY9JMfXUvec55zwfd4Lvn/e+TRhaDxVdctwgcAaGXPDbFxlaFpqeQk37sXZKyqqIDa3gDAw5cErFXGVNKPsqk6RHaLsdajcUWusYP8uyrAlCKV2FOS9stPNVrO0ig7eRqda09t2h8X18n7J2rCsyriZNIiNNxIaxMVkrCvF9IRezezOTH6RzFSJqRyextf0/OjRuknlHOIPLRe/TNG0JUInjmNveZNJEzi4X30nvO8EBF2axstM8uz2IlJtDa58N6vV6Q2hoC+YQ8256gYMDLpvMCu0OYXDO7axicTzv/MeLKNrFrAhe6F6BY8kwfn+Zi4CFV5GkpUi7DU7MFES8gFD0nC9M2fECx2LBjU0yzPnr3ICBkfL/wg/wQgfLcoUBRjjhER7xjH8KjKfpNCCiRq1HO/4T0L4BfXW2mG2In4MAAAAASUVORK5CYII="

/***/ }),
/* 2295 */
982,
/* 2296 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABcUlEQVR42pWSO0vEQBDHzxe+bWwEGwtBRBErCxuzSXZ3ZvPQA4OID1JIbARBv8AV2looBzbC9TZWfgBRFL+CrYpY2lnFGTXCmXjEhUDm8WNm/jOVMk8ocyQkvggFNw7ADPtKgnhsKby0fX/UUbhM/69KedPlQIn3URT1Zj5bQmRJSGu1WuffoDR7nISIQ79j7Lc17hSCTrU6zAkAS2NhGA7SzPUsxi1zzBgzkgMZoJbaLWm2qcVVav3a0rjPMdfzJsl+F+DpHEjznQgJT5TQ4IoMksKNn24UPJNga0XrqFPyXZIkXa723G/wVEozy2oLiY+FIDnPqeotVyNlO75AfUb+FUTstrXZEogLeVCbXRaAoAG24zju4YppmrZRtUNeVxOQl92fy2ytw3EGWU2a8UFos9jiEOCCvyYfhBMsnCNhveUV8aXwjLbCA16R0MEUiyM0bpa6X6U2+qnFKxLojcegPYaV/7xPVZU3HwRBX1nmA1Ytim+dineVAAAAAElFTkSuQmCC"

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA9ElEQVR42uVRO0oEQRR8GigmmupNDBT6jdOvu1ojoSNBcO8gGM4NFAVvIIh4Bj+xJmIuHkOj8VVg4KrrzqYWFN3UD2ZaNOeiMV+p4WII2WFXmlQOXHh3joJhbxoy63zjKYRaOXTjua11Rf4AM8yy88VoIk404g7A4m9lemq494Hjb2bf93P8LrLruvlxn5qXr52XzMpPqLUuhJhvPXQ67oWIs2D5hhmZBADLanhqLB99arxToyfTIKXdNY141YR9kndqMgRtzhtqeAwRD1tpe5PawIGdwFfhP/EB/ecDfQuszzTAshrOZRaUUlaD5Zda69Kk3AfH04gZbmZtIwAAAABJRU5ErkJggg=="

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/l-logo_1x.png";

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAWCAYAAAAxSueLAAAAAXNSR0IArs4c6QAAAuZJREFUSA2VlV1ozWEcx8/ZG4tpM+aliV3QLETylgual5QS5UZoV4orpd1I3HLFDXLhQlzsQlI0ml0gCgnRhAtLWhvb8tKsvdiLz+fsPKd/Z/9zmm99zvOc3+/3PL/z/z2//3MSiRwaHx8vgKVwEl7BYZgbwpkXQg00Qis0wPzgn/LIomI4Aj0QNMLkNWyBUjgIHRA0zOQZ7PifRP7iehiAbI1ieA+HIPpDQpx+Ey6fUkIC/dXXIJfc8EcuJ/ZOaIxLVhBj1FYTYw8m/RXhS8xYim1hjD0Rl2ycwM644LRN/2Ae/xC+3jh/XLJhApvATbOl7Sucgv5sZ/p7F2NLDt9kMzWfBmdgEILGmHyB/TATTkAfBOn/AAcm7zhhSeZysKgQ3zrYB3OgDe4kk8nPjAn8RQyrYA94Rh+hGf8nxlilkrFwAd5KCMkdLdl3Fnfjn8XchCVgEv1jMAKeXzeMwjyYDa4Nx2C5e9inz19oSd6BL+XfLCzbTniYZY/GWcqrcAx+gS9/1N/F9+NQYrILkEueg8G+W/nkBdCbJ8AXfZcl8Swsh/MBeADFsBiq0oSuNa4d7MhaqAY1HSxtB3wDO7IcNoPSZqlTh21nKR//NpRBEVTBavAytjxD0Aq7oQ2U11YDLINyKIGN8BJUC2xKJQofGM7pQSa8BTMiPl+FsxDk+SqvraOROO/VDfAC1FPYHvyZEaN/KTdAudl1sDwpMa8AGyHoN5PTEb/r18CjdIBnvRdCh4fQzIaVOO+lgy3ZZfAsbaRquAtB/Uwugk+dhDq4D8pmsVKefbxwushNn4MyoYu03QRlh/5JzSbG88zXQvD7xFegLD5LxEqQCWvBq0e5efiTNLlPvg3egBoBX3zl0zZB5h89snX8lGDrvx5CEqapxnnCuAjsVDuuHYK8R5thSfyueawssrO8PX6CT/cW6sIS5ra4fp/KDn4MK4P/v0cWm7AePI9MorARNhNuhUuwIthzjf8Aw3pgf+Cs6tYAAAAASUVORK5CYII="

/***/ }),
/* 2300 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAAAXNSR0IArs4c6QAAAgpJREFUOBGNk01LVVEUhj2m+EEDMSgaiQqGmkOhURNBnHgHQQPDH9DEf9AvaBBFMwcqOkmiRkEhyJ2ETqJB2kwkwUmBEzX87vY8x71hc+7x6gvP3Wuv9a7F3uee09RUolqtlsEEVOEF3I8245CrsurJYq3hirEVZiHVNpuHAeNUelsbDrWIaTrtSuI1YinT9E0GL5R1XpNbKA5uLibYn5XkTJ0Hysp1PWWDP9F5Wuj+x34lYJxKrz2NxZVb4CUcwBH8hW8wEDA2Z02P3pbi1PxVoXCbwq1CcZj9CBzCKhyB6oAxsGcDfkKqiyzLDn1fO8nOwB1I38kv7H/DU2iD+Nh8FCfwHu7BBNhXC+yxvvX1moKocwJRW/A1jy5/Llgkypoelfa5n/LZDILX9Iq78Ac8vVcdAk/iiX6B6gNz1vzjtsFT3oUecNagJ26HRTiFH/AI+uExPIddUK/hTR5d5qzp0WuPvc5YgnaG519bN5t3cAJ+Xf5xuYgr4HCbxLiS1IfZr4O9zuiOtTigl2QVfI6fod8Cayd8hKgPBP7h1jytXnuq0Gu+ThRGwSspr2TjE/CU+wFjc9b0KHtG6wamCQyTsANqGfznj2EuYGzOmtI7mc64MsY4DpugHPQKugLG5pSe8SsHFQuYm+EZfId58DXKZQzzYE1P/HCipfFKQxtU4EHRaS7U/CJL9R/MVgKaLHloTAAAAABJRU5ErkJggg=="

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/logo_1x.png";

/***/ }),
/* 2302 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAdCAQAAABofAZ2AAABb0lEQVR4Ae2UzysEURzAZ2XtshcXDootxUltimwu+y9wc+DgsAe1FzfJRaktp40cFhd7VCKRlJubOCgUQjY/dpQi+b27H2vbppl539GOg5PPu73P6zO96b2nqdDLOjo5nthhjHq0coZ9wkMKK2la3IeG2EVl022omiwSd25DlbwhcWFaU0EPcVZYI0HEeWurSKQMX8u2xcw7hWaRmCzZcfKKi0ihGj6QuMdT9HuC65dCjchk8RX9nGJyBOWtbSBg/IlpxdzglUMhJOpK9lFwHXLIxyt2rg2ro9LldEWWsDNluKTizvE7hZq5xcyV6dIGldCwfI6k7yYtbt/i8rT9NtTJg3BQhZCfKGnbIxLFb1oRNsyy06UNMIKOhF4wgdKqdmN2UQp5iZHhJzLEqKKBSzA4YYKQORTmgHI4ppsmzrBySpzW71Af75TLJwOFmEqeUfngO/OMJj5/hxpu0XhB5ehPQ/+hBbZcDY0EM8oY/ALnuIutBZrc3QAAAABJRU5ErkJggg=="

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAaCAQAAAB1eTbOAAABmElEQVR4AdXMsUuUYQDH8cdFeM9I+xMCAwcXBwcHl6aEUHQQbhaFw6klsCHqKFoSoUmCwFEUonAREc2gMJKmGwxamkToEhrEG3w/vdDBy/ty9yA49fluv+EXutGvas2eY3+yju1ZU9UvdK7zPGFbSyct2yaudjRiF3G7RuJHPepSZStZZamnerodJTYAtEw7AyxkAWemtQBsSDodJQ7lUoNWykdWDErlDiXKR9YVLRsC1LKAIcuK1stHS4A3PgCaKhrgZxY0VPxWtiQ/MuwS8ErFPuCHXHH57BuAS8P50ZZcXZ8vYnYl1uS22kfGFb30Vnf7Kl4oGv939N7VfdSnruydEFScg0kzDsR9csNjAAdmTIJzSTAFOFLVa9SFbg7d9AhwYVSvqiPAVLAqd2pTqrOv+j0EcGnTqdxqsCNu3T13Lbvlge52goaY10K7+2IaQVPMHaHdbTHNAHhmPmuxfGtAaDegqGnRfNZzIADq5rJq5SOzQrtZRb/UzGXVgSDuxJggGHMiKogj9T0r5bpHgP/xaMGT62fhL1BPTcZDKBYWAAAAAElFTkSuQmCC"

/***/ }),
/* 2304 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAA4klEQVR4Ae3MIYoCUQCA4V/EIJgME7YY7J7BtjfwBMsk8QpWz2D0BjZPYLK4RQSrwWa0yL/pgYg6b+YNm+Y7wId767DH3DrkiHNTzQURl6ZYSojarq1qbdsQiV23VrG1K48R9j1Y1sG+PEc48GwZZwfyKsKRV2NdHcm7CMfejHFzLJ8inHi3yN2JFEU4s8hMYiJc+MlCYqOWK99Z2YqPsOPGVzZ2pEyEPXc+29mTshFmnnx0MpMqEQ69GFwcStUIpwZTSYlyg7yJmqiJ/iX6qSc6mtURHf2S9Cg0SdG3vzGN/AEdZtdBHj6jkAAAAABJRU5ErkJggg=="

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/m-logo_1x.png";

/***/ }),
/* 2306 */
2304,
/* 2307 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAOCAYAAAArMezNAAAAAXNSR0IArs4c6QAAADhJREFUOBFj/P///yUGBgZdIKYmuMwINDgSaKI6NU0FmnWTyuaNGoclBECRN5oqsATMiBYaeqkCAOx0G3bu7BZWAAAAAElFTkSuQmCC"

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAABCAYAAADn9T9+AAAAFUlEQVQIW2PIzC+6nJlX9B0vBqoBAL/kFjs4Trf0AAAAAElFTkSuQmCC"

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAMAAAAocOYLAAABI1BMVEUAAAClrKz///+hqqqmra7S29uvtrarsbG6wsLDysqvtrmipqqgp6mmrq6mr6+jpqqhqKihqanV3d6hqamxubm5wcGlra67w8OZn6HW3t+epqefpqaboaKnrq+do6aepKeXnp+gp6ifpaWmsLCjrbGvtbewt7ersLOjqq2Xnp+Wnp6irKyYn6CYnZ+fpqfV3d6fpqfAx8nU3N23vb+0u73O1te+xcfJ0NKrsrOwt7nHztClrK3R2duosLGvtrfCysq+xselra68w8S7w8TT29zN1NW5wMGiqqu0vL3DysumrrDS2tunrrCjqavM09WfpajN1dbGzs+qsbS/xsipsLKxubqhqaqmrK7I0dGgpqmutbekq622vsDL09SfpqjT2tumrK+nPwOjAAAAL3RSTlMAJQEbq+S4sL3FuUJrprJFakT7Qb3Cp7/F/Ka4s7Or5L37sE1OucK/Tr/CTbm5vb8+NwIAAAFMSURBVHhebdLlmuIwFIDhUy+lLRQfYJBx3RS3cXd33fu/ikGSkxT4/pH3CY0BT7EdQ0/oRspWYCI57JoaGaWZblgOsqSGiFhIlUSOWDMkWMyKcF5IksnS84y9NJlWkv6DtMigWnl+eH2qd+lPSxqwrLJv3+z4o2p0Darc9zhb+du7z2rQXYT7PktoXz72TYdcAMVkXkP++aVuKhDVmD+itwlNs8EhrDv0PRxLgYF+j36AboCOfojeQdchgd5Cb6InhPnkP/MtYb7BvU55m2AGONwbLyPf5e4M9o91htzjrNl4ftz3uZuKcP6k+jH0zyN0V7i/45OeP+r0rCXcn6zG+lPP277YRfOS3T9IFuleMcCuK/T9AHhLtwhCy/iCV1an8No6YN5GeUzLmx4ISYVMgDMFCQLJ8XypSLFYysdlmEiJZudy/3Jz2ajC4Q9KoocxncIjCAAAAABJRU5ErkJggg=="

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAAAXNSR0IArs4c6QAAATBJREFUKBV9kT1LxEAQhmc2OfwAKzs7sfMqK4sr7PwDgWxOMXcWdta24uE/0EZBDHIQki6dndYaSxu5wkrBA+3uELIZZyMLIcndwO7MvPPwMuwCNESSJCtBGF5WR6Iq6P57MrkAENPqrAYHUeQAQY/P81w4DJM1UPmVhgjzp5kwEeEvTG8JYBUQx4fd7nsVto0QhNEx++3qHoFqrv8638M43swy9cKui1psCiHwSKRp2sqUGs4DEeHel/LGfn0bDRjcanIrNISPZcvyEZFsAvwBpDMDs7hEOZ3onmslLLHnuu646A1k8l0c76hMPRZDgad9zxuYWe1TSKlOAQI+9KQ8N6DONTgn7CDAl7XQ2uc18pmw/hh+423e0z9wnM8yqGurLGy02+vsTH1PXpd1U/8B/alkYflXO9QAAAAASUVORK5CYII="

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAQCAYAAADAvYV+AAAAAXNSR0IArs4c6QAAAHxJREFUKBVjnL9sxQ4Ghv8cDFgAIxPjyvjw8BmMjIz/QdIsQIXuWNSBhf7/Y+pYsGqV/////zeCNDDhUggWZ/z7g0FMbAdUAyN+xUAdiY6OYA2LVq70Y5y/bDnYPXhtgEoSNBnZkFHFgzA0WBiYGC0Z/mNPosjuZWBk/AEASNglJqdMg0UAAAAASUVORK5CYII="

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAABU0lEQVR42o1RPUvEQBCNaGHhB36h/0CwsRDkwELwF4iC2NipsJtLdmfnLrkciPsPBG39BbERsVWwVLBVEcVSbPwLcV5xaORiHAi7mXlv3szboC6axm1qQw/K0JOyvB78J8KYtpVxH5FzjaZtr+CuLW/8rWRbazp27xHzQi8nDRZVTEWapuN9SRHRMgDGJPNRls0kSTLaqyGvjdvrS9TWtaR4Y0x3VlQfvffDyEvuBMQ8zwfLO1mnBHjNzNOKeUnF7iU03EVNWZeJQc/a+5GyiiGW7z6k1lZo7a6AXqEshhxJswO4qtvtuRJJiim6hVk2pTqdCbm/CfgQu0kzLSOeYtdf4/EO5sY++AcBYLiJfKXtKCqi1R+WN3BCFQ9fQYMCnQvgsiiKge+Hd8cy3h3cqySK1UPS/QomENGkinlf3LyNvB8L6gLvJMpnQviU8wKW13G+APlOo5STImQOAAAAAElFTkSuQmCC"

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAA50lEQVR42pXQvw4BQRAGcH8SKpGoVWq8AU+hUGll99yuWWdPVNdqT+INNKcRagWNN1DohVYpkZzZ5La6zOFLptjk++0kk8vKCKDFBWy5VEcm4GTHkZM5iZj02lyoO6IhFrsuTDt2EL9pJOHBx5OeeSMe4Cc3IbymeSOMyU0WuVrXTZFJtUqAhTQyCYKgYIpcwoVJOFiYiWwAoGYO4oZh2ff9Km5/pVFGtNYVJtSZj9XifyTVMtkGV0dA/x+UQLXmAjZRFBV/RfZqJcT7NKYRjWmUjc35CURjhDucJ4HoxHGcZzBrfOt9AGnLrxSQVO/XAAAAAElFTkSuQmCC"

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAAUVJREFUeAHt3CsOwkAUheHe4RESEhy+ogbFUlAYQLMcdgEGxU5AIVpRj0PxKAy9CSScNcxfBbj+/XocYzFGO9f1LMawMIvjLKHr/YrXJjb7aVFs7ViWq+FguBn0e2MzSyhDlrUIstvjeXk293XoWneeYgR/4v7g/d79bQihY6PUJPyz93v3SQj/P6b8mRDfp08IQugQIAIRiNACiNAebAQiEKEFEKE92AhEIEILIEJ7sBGIQIQWQIT2YCMQgQgtgAjtwUYgAhFaABHag41ABCK0ACK0BxuBCERoAURoDzYCEYjQAojQHmwEIhChBRChPdgIRCBCCyBCe7ARiECEFkCE9mAjEIEILYAI7cFGIAIRWuAnoj014eL/mk/18nv34xOC2XvnRwekGON3bIKfIWHtFztV1dKPT/CTA1KS4W+DQ5jk+eEDj89QYuO4dU0AAAAASUVORK5CYII="

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/images/p-avatar_1x.png";

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAP0lEQVQY02NgQAOZBcW5WfmFOQyEQHZ+cWNmfmEdHRSC3VRQ1ADDmXmFB4AK96GIAdUQr3AAPYOpsCgPW4ADAP4+QPCYhdDVAAAAAElFTkSuQmCC"

/***/ }),
/* 2317 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAAAXNSR0IArs4c6QAAAKFJREFUGBljZEADu3fv5v/2j0mfGVl827YTfF///dz1n4GBgwkmARL8wfh5J5BvDhIDS2w8coT3O+On7f///7eAKWTav38/z59P37Yz/GewggmCdbz//nsdkGGNLAiW+M/ANIuRkfEPhkSwl8saRkaGaKDEX2RJsOWBHq6rGBmZYpAl4c4N8nRZwcTIEAuTZETWDmKv27YnmoHpvya6OJwPAEeAMnqgKe2XAAAAAElFTkSuQmCC"

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAAXNSR0IArs4c6QAAAM5JREFUGBljvGyiV8rIyHRA5/SF0wxo4JKJbjozA9N5JmZmpg3//v3desXUwBRZDUgBI8P/ajZRqYtg8cvGOt6XjHVfwRSCFFw20Xl0w0xPEaSAEaYbpPA/A+N8oO45QNEYViYme41Tl+7D5OH0JSPtyZdMdP5cNdH1hwsCGUwwDtgNTIz+QKPT/v5nmA2zGiQPVgRzJMgK3TNX5gGtTET2DOMlc11jxr//16O7AeRGoCELmHhFFJmY/jLYoSsAWaF79srW/4yM8Yzf3+kAAMgoTw01J847AAAAAElFTkSuQmCC"

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAqUlEQVR42p1ROw5CMQyrxAq3gZGvmLhJ8x4NSR+Z33k6s3MBJAZuwcoBACOWQoeCl8q2XKepA1JKAwrRfNATBbnhBIfuPgHRsxyJ5UAcJ9T3Q5zg0L9CuAmmKwA6/ExEfSs2LgXQBD8TMTPGKAXMbAT/twbWyz9vKG8JTdmWgtyboJssUPoHjPHi0q2f/NruupWrxVb2U4RIdVkdajjO3k2L6pAXmRPL+QHrenMgJaItnwAAAABJRU5ErkJggg=="

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/imgIcon.svg";

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "_/resources/upload.svg";

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(1013);
	var bytesToUuid = __webpack_require__(1012);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/uuidjs/uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),
/* 2324 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 2325 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2327);


/***/ }),
/* 2327 */
/***/ (function(module, exports) {

	
	function isFalse(s) {
	  return typeof s !== 'number' && !s;
	}
	
	function strval(s) {
	  if (typeof s == 'string') {
	    return s;
	  }
	  else if (typeof s == 'number') {
	    return s+'';
	  }
	  else if (typeof s == 'function') {
	    return s();
	  }
	  else if (s instanceof XMLWriter) {
	    return s.toString();
	  }
	  else throw Error('Bad Parameter');
	}
	
	function XMLWriter(indent, callback) {
	
	    if (!(this instanceof XMLWriter)) {
	        return new XMLWriter();
	    }
	
	    this.name_regex = /[_:A-Za-z][-._:A-Za-z0-9]*/;
	    this.indent = indent ? true : false;
	    this.indentString = this.indent && typeof indent === 'string' ? indent : '    ';
	    this.output = '';
	    this.stack = [];
	    this.tags = 0;
	    this.attributes = 0;
	    this.attribute = 0;
	    this.texts = 0;
	    this.comment = 0;
	    this.dtd = 0;
	    this.root = '';
	    this.pi = 0;
	    this.cdata = 0;
	    this.started_write = false;
	    this.writer;
	    this.writer_encoding = 'UTF-8';
	
	    if (typeof callback == 'function') {
	        this.writer = callback;
	    } else {
	        this.writer = function (s, e) {
	            this.output += s;
	        }
	    }
	}
	
	XMLWriter.prototype = {
	    toString : function () {
	        this.flush();
	        return this.output;
	    },
	
	    indenter : function () {
	      if (this.indent) {
	        this.write('\n');
	        for (var i = 1; i < this.tags; i++) {
	          this.write(this.indentString);
	        }
	      }
	    },
	
	    write : function () {
	        for (var i = 0; i < arguments.length; i++) {
	            this.writer(arguments[i], this.writer_encoding);
	        }
	    },
	
	
	    flush : function () {
	        for (var i = this.tags; i > 0; i--) {
	            this.endElement();
	        }
	        this.tags = 0;
	    },
	
	    startDocument : function (version, encoding, standalone) {
	        if (this.tags || this.attributes) return this;
	
	        this.startPI('xml');
	        this.startAttribute('version');
	        this.text(typeof version == "string" ? version : "1.0");
	        this.endAttribute();
	        if (typeof encoding == "string") {
	            this.startAttribute('encoding');
	            this.text(encoding);
	            this.endAttribute();
	            this.writer_encoding = encoding;
	        }
	        if (standalone) {
	            this.startAttribute('standalone');
	            this.text("yes");
	            this.endAttribute();
	        }
	        this.endPI();
	        if (!this.indent) {
	          this.write('\n');
	        }
	        return this;
	    },
	
	    endDocument : function () {
	        if (this.attributes) this.endAttributes();
	        return this;
	    },
	
	    writeElement : function (name, content) {
	        return this.startElement(name).text(content).endElement();
	    },
	
	    writeElementNS : function (prefix, name, uri, content) {
	        if (!content) {
	            content = uri;
	        }
	        return this.startElementNS(prefix, name, uri).text(content).endElement();
	    },
	
	    startElement : function (name) {
	        name = strval(name);
	        if (!name.match(this.name_regex)) throw Error('Invalid Parameter');
	        if (this.tags === 0 && this.root && this.root !== name) throw Error('Invalid Parameter');
	        if (this.attributes) this.endAttributes();
	        ++this.tags;
	        this.texts = 0;
	        if (this.stack.length > 0)
	          this.stack[this.stack.length-1].containsTag = true;
	
	        this.stack.push({
	            name: name,
	            tags: this.tags
	        });
	        if (this.started_write) this.indenter();
	        this.write('<', name);
	        this.startAttributes();
	        this.started_write = true;
	        return this;
	    },
	    startElementNS : function (prefix, name, uri) {
	        prefix = strval(prefix);
	        name = strval(name);
	
	        if (!prefix.match(this.name_regex)) throw Error('Invalid Parameter');
	        if (!name.match(this.name_regex)) throw Error('Invalid Parameter');
	        if (this.attributes) this.endAttributes();
	        ++this.tags;
	        this.texts = 0;
	        if (this.stack.length > 0)
	          this.stack[this.stack.length-1].containsTag = true;
	
	        this.stack.push({
	            name: prefix + ':' + name,
	            tags: this.tags
	        });
	        if (this.started_write) this.indenter();
	        this.write('<', prefix + ':' + name);
	        this.startAttributes();
	        this.started_write = true;
	        return this;
	    },
	
	    endElement : function () {
	        if (!this.tags) return this;
	        var t = this.stack.pop();
	        if (this.attributes > 0) {
	            if (this.attribute) {
	                if (this.texts) this.endAttribute();
	                this.endAttribute();
	            }
	            this.write('/');
	            this.endAttributes();
	        } else {
	            if (t.containsTag) this.indenter();
	            this.write('</', t.name, '>');
	        }
	        --this.tags;
	        this.texts = 0;
	        return this;
	    },
	
	    writeAttribute : function (name, content) {
	        if (typeof content == 'function') {
	          content = content();
	        }
	        if (isFalse(content)) {
	           return this;
	        }
	        return this.startAttribute(name).text(content).endAttribute();
	    },
	    writeAttributeNS : function (prefix, name, uri, content) {
	        if (!content) {
	            content = uri;
	        }
	        if (typeof content == 'function') {
	          content = content();
	        }
	        if (isFalse(content)) {
	          return this;
	        }
	        return this.startAttributeNS(prefix, name, uri).text(content).endAttribute();
	    },
	
	    startAttributes : function () {
	        this.attributes = 1;
	        return this;
	    },
	
	    endAttributes : function () {
	        if (!this.attributes) return this;
	        if (this.attribute) this.endAttribute();
	        this.attributes = 0;
	        this.attribute = 0;
	        this.texts = 0;
	        this.write('>');
	        return this;
	    },
	
	    startAttribute : function (name) {
	        name = strval(name);
	        if (!name.match(this.name_regex)) throw Error('Invalid Parameter');
	        if (!this.attributes && !this.pi) return this;
	        if (this.attribute) return this;
	        this.attribute = 1;
	        this.write(' ', name, '="');
	        return this;
	    },
	    startAttributeNS : function (prefix, name, uri) {
	        prefix = strval(prefix);
	        name = strval(name);
	
	        if (!prefix.match(this.name_regex)) throw Error('Invalid Parameter');
	        if (!name.match(this.name_regex)) throw Error('Invalid Parameter');
	        if (!this.attributes && !this.pi) return this;
	        if (this.attribute) return this;
	        this.attribute = 1;
	        this.write(' ', prefix + ':' + name, '="');
	        return this;
	    },
	    endAttribute : function () {
	        if (!this.attribute) return this;
	        this.attribute = 0;
	        this.texts = 0;
	        this.write('"');
	        return this;
	    },
	
	    text : function (content) {
	        content = strval(content);
	        if (!this.tags && !this.comment && !this.pi && !this.cdata) return this;
	        if (this.attributes && this.attribute) {
	            ++this.texts;
	            this.write(content
	                       .replace(/&/g, '&amp;')
	                       .replace(/</g, '&lt;')
	                       .replace(/"/g, '&quot;')
	                       .replace(/\t/g, '&#x9;')
	                       .replace(/\n/g, '&#xA;')
	                       .replace(/\r/g, '&#xD;')
	                      );
	            return this;
	        } else if (this.attributes && !this.attribute) {
	            this.endAttributes();
	        }
	        if (this.comment || this.cdata) {
	            this.write(content);
	        }
	        else {
	          this.write(content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
	        }
	        ++this.texts;
	        this.started_write = true;
	        return this;
	    },
	
	    writeComment : function (content) {
	        return this.startComment().text(content).endComment();
	    },
	
	    startComment : function () {
	        if (this.comment) return this;
	        if (this.attributes) this.endAttributes();
	        this.indenter();
	        this.write('<!--');
	        this.comment = 1;
	        this.started_write = true;
	        return this;
	    },
	
	    endComment : function () {
	        if (!this.comment) return this;
	        this.write('-->');
	        this.comment = 0;
	        return this;
	    },
	
	    writeDocType : function (name, pubid, sysid, subset) {
	        return this.startDocType(name, pubid, sysid, subset).endDocType()
	    },
	
	    startDocType : function (name, pubid, sysid, subset) {
	        if (this.dtd || this.tags) return this;
	
	        name = strval(name);
	        pubid = pubid ? strval(pubid) : pubid;
	        sysid = sysid ? strval(sysid) : sysid;
	        subset = subset ? strval(subset) : subset;
	
	        if (!name.match(this.name_regex)) throw Error('Invalid Parameter');
	        if (pubid && !pubid.match(/^[\w\-][\w\s\-\/\+\:\.]*/)) throw Error('Invalid Parameter');
	        if (sysid && !sysid.match(/^[\w\.][\w\-\/\\\:\.]*/)) throw Error('Invalid Parameter');
	        if (subset && !subset.match(/[\w\s\<\>\+\.\!\#\-\?\*\,\(\)\|]*/)) throw Error('Invalid Parameter');
	
	        pubid = pubid ? ' PUBLIC "' + pubid + '"' : (sysid) ? ' SYSTEM' : '';
	        sysid = sysid ? ' "' + sysid + '"' : '';
	        subset = subset ? ' [' + subset + ']': '';
	
	        if (this.started_write) this.indenter();
	        this.write('<!DOCTYPE ', name, pubid, sysid, subset);
	        this.root = name;
	        this.dtd = 1;
	        this.started_write = true;
	        return this;
	    },
	
	    endDocType : function () {
	        if (!this.dtd) return this;
	        this.write('>');
	        return this;
	    },
	
	    writePI : function (name, content) {
	        return this.startPI(name).text(content).endPI()
	    },
	
	    startPI : function (name) {
	        name = strval(name);
	        if (!name.match(this.name_regex)) throw Error('Invalid Parameter');
	        if (this.pi) return this;
	        if (this.attributes) this.endAttributes();
	        if (this.started_write) this.indenter();
	        this.write('<?', name);
	        this.pi = 1;
	        this.started_write = true;
	        return this;
	    },
	
	    endPI : function () {
	        if (!this.pi) return this;
	        this.write('?>');
	        this.pi = 0;
	        return this;
	    },
	
	    writeCData : function (content) {
	        return this.startCData().text(content).endCData();
	    },
	
	    startCData : function () {
	        if (this.cdata) return this;
	        if (this.attributes) this.endAttributes();
	        this.indenter();
	        this.write('<![CDATA[');
	        this.cdata = 1;
	        this.started_write = true;
	        return this;
	    },
	
	    endCData : function () {
	        if (!this.cdata) return this;
	        this.write(']]>');
	        this.cdata = 0;
	        return this;
	    },
	
	    writeRaw : function(content) {
	        content = strval(content);
	        if (!this.tags && !this.comment && !this.pi && !this.cdata) return this;
	        if (this.attributes && this.attribute) {
	            ++this.texts;
	            this.write(content.replace('&', '&amp;').replace('"', '&quot;'));
	            return this;
	        } else if (this.attributes && !this.attribute) {
	            this.endAttributes();
	        }
	        ++this.texts;
	        this.write(content);
	        this.started_write = true;
	        return this;
	    }
	
	}
	
	module.exports = XMLWriter;


/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2329);


/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

	/* ================================================================
	 * xml2map by xdf(xudafeng[at]126.com)
	 *
	 * first created at : Mon Jun 16 2014 14:49:10 GMT+0800 (CST)
	 *
	 * ================================================================
	 * Copyright 2014 xdf
	 *
	 * xml2map is based on node-xml-mapping
	 *
	 * repository: https://github.com/xudafeng/xml2map
	 * contribute by Joe Ibershoff, Yura Zenevich, Thorsten, Lorenz, ntgn81, Rowell Cruz, and JT
	 *
	 * Licensed under the MIT License
	 * You may not use this file except in compliance with the License.
	 *
	 * ================================================================ */
	
	"use strict";
	
	var XMLWriter = __webpack_require__(2326);
	var default_tag_name = 'row';
	
	function isEmptyObject( obj ) {
	  for ( var name in obj ) {
	    return false;
	  }
	  return true;
	}
	
	function clone(obj) {
	  if (typeof (obj) != 'object') {
	    return obj;
	  }
	  var re = {};
	  if (obj.constructor == Array) {
	    re = [];
	  };
	  for (var i in obj) {
	    if(i === '$t'){
	      re = obj[i];
	    } else if(!isEmptyObject(obj[i])) {
	      re[i] = clone(obj[i]);
	    }
	  }
	  return re;
	}
	
	exports.toxml = function(obj, options) {
	  options = options || {};
	
	  if (typeof obj != "object") {
	    return obj;
	  }
	  //    if (typeof xw != XMLWriter) 
	  var	xw = new XMLWriter(options.indent);
	  if (options.header) {
	    xw.startDocument(options.version || '1.0', options.encoding || 'utf-8');
	  }
	
	  var getype = function(o) {
	    if (!o) {
	      return 'undefined';
	    } else if (Array.isArray(o)) {
	      return 'array';
	    } else {
	      return typeof o;
	    }
	  }
	
	  var getval = function(o) {
	    return '' + o; // !TODO 
	  }
	
	  var getname = function(n) {
	    return n.replace('$', ':');
	  }
	
	  var sortKeys = function(o) {
	    var keys = [];
	    for (var key in o) {
	      if (Object.hasOwnProperty.call(o, key) && o[key] != null && o[key] !== undefined) {
	        keys.push(key);
	      }
	    }
	    function keyComparator(a, b) {
	      var a0 = a.charAt(0);
	      var b0 = b.charAt(0);
	      var compA = typeof o[a] === 'object' ? 1 : -1;
	      var compB = typeof o[b] === 'object' ? 1 : -1;
	      if (compA - compB !== 0) {
	        return compA - compB;
	      }
	      compA = a0 === '$' || a0 === '#' ? 1 : -1;
	      compB = b0 === '$' || b0 === '#' ? 1 : -1;
	      return compA - compB;
	    }
	    keys.sort(keyComparator);
	    return keys;
	  };
	
	  var parse = function(o) {
	    if (getype(o) != 'object') {
	      return;
	    }
	    var keys = sortKeys(o);
	    for (var index in keys) {
	      var key = keys[index];
	      var val = o[key];
	      var type1 = getype(val);
	      if (type1 == 'object') {
	        xw.startElement(getname(key));
	        parse(val);
	        xw.endElement();
	      } else if (type1 == 'array' && val.length <= 0) {
	        xw.startElement(getname(key)).endElement();
	      } else if (type1 == 'array' && val.length > 0) {
	        var type2 = getype(val[0]);
	        if (type2 == 'object') {
	          val.forEach(function(item, index) {
	            if (key == '$element' || key == '$e' || key == '#element') {
	              parse(item);
	            }
	            else {
	              xw.startElement(getname(key));
	              parse(item);
	              xw.endElement();
	            }
	          }
	          );
	        } else {
	          val.forEach(function(item, index) {
	            if (key == '$element' || key == '$e' || key == '#element') {
	              xw.startCData().text(getval(item)).endCData();
	            }
	            else {
	              xw.startElement(getname(key));
	              xw.startCData().text(getval(item)).endCData();
	              xw.endElement();
	            }
	          }
	          );
	        }
	      } else {
	        if (key == '$text' || key == '$t' || key == '#text') {
	          xw.text(getval(val));
	        } else if (key == '$comment' || key == '$c' || key == '#comment') {
	          xw.startComment().text(getval(val)).endComment();
	        } else if (key == '$cdata' || key == '$cd' || key == '#cdata' || key == '#cd') {
	          xw.startCData().text(getval(val)).endCData();
	        }
	        else  {
	          xw.startAttribute(getname(key)).text(getval(val)).endAttribute();
	        }
	      }
	    }
	  }
	  var o = {};
	  if (Object.keys(obj).length == 1) {
	    o = obj;
	  }
	  else {
	    o[default_tag_name] = obj;
	  }
	  parse(o);
	
	  return xw.toString();
	
	};
	exports.tojson = function(str, options) {
	  options = options || {};
	  if (typeof str != "string") {
	    if (options.throwErrors) {
	      throw new Error("Input was " + (typeof str) + ", expected a string");
	    }
	    return str;
	  }
	  var parser = __webpack_require__(2330).parser(true, {trim : true, xmlns : false});
	  var result = {},
	      stack = [],
	      cdata = '',
	      nested = { check : [], previous : '', memory : [], buffer: '', name: [] },
	      path = [];
	
	  function cvalue(n, v, isXmlNode) {
	    n = n.replace(':', '$');
	    var o = stack[stack.length - 1];
	    if(typeof o === 'string'){
	      return
	    }
	    if (o === undefined) {
	      o = {};
	      o[n] = v;
	      return o[n];
	    } else if (o[n] === undefined) {
	      if (isXmlNode && options.arrays && options.arrays.indexOf("/" + path.join("/")) !== -1) {
	        // Create new array only if current item is a XML node,
	        // meaning it is not text, cdata or comment
	        o[n] = new Array(v);
	        return o[n][0];
	      }
	      else {
	        o[n] = v;
	        return o[n];
	      }
	    } else if (!Array.isArray(o[n])) {
	      var x = o[n];
	      o[n] = new Array(x, v);
	      return o[n][1];
	    }
	    else {
	      var i = o[n].push(v);
	      return o[n][i - 1];
	    }
	  }
	  function cattr(o) {
	    var r = {};
	    for (var key in o) {
	      if (o.hasOwnProperty(key) && o[key]) {
	        r[key.replace(':', '$')] = o[key];
	      }
	    }
	    return r;
	  }
	
	  if (!options.throwErrors) {
	    parser.onerror = function(e) {
	      // an error happened.
	    };
	  }
	  parser.onprocessinginstruction = function(pi) {
	  };
	  parser.ontext = function(v) {
	    if (options.nested) {
	      if (nested.previous === 'C') {
	        nested.check[nested.check.length - 1] = true;
	      }
	      nested.buffer = v;
	      nested.memory.map(function(item) { return item.text(v) });
	      nested.previous = 'T';
	    }
	    else {
	      cvalue('$t', v);
	    }
	  };
	  parser.oncomment = function(v) {
	    if (options.comments === undefined || options.comments !== false) {
	      cvalue('$c', v);
	    }
	  };
	  parser.oncdata = function(v) {
	    cdata += v;
	  };
	  parser.onopencdata = function() {
	    cdata = '';
	  };
	  parser.onclosecdata = function() {
	    cvalue('$cd', cdata);
	    cdata = '';
	  };
	  parser.onopentag = function(node) {
	    if (options.arrays) {
	      path.push(node.name);
	    }
	    if (options.nested) {
	      if (nested.previous === 'T') {
	        nested.check[nested.check.length - 1] = true;
	      }
	      nested.buffer = '';
	      nested.name.push(node.name);
	      nested.memory.push(new XMLWriter());
	      nested.check.push(false);
	      nested.previous = 'O';
	
	      nested.memory.map(function(item) { 
	        return Object.keys(node.attributes).reduce(function(prev, cur) { 
	          return prev.writeAttribute(cur, node.attributes[cur])
	        }, item.startElement(node.name))
	      });
	    }
	
	    if (stack.length == 1 && node.name == default_tag_name) {
	      result = cattr(node.attributes);
	      stack.push(result);
	    }
	    else {
	      stack.push(cvalue(node.name, cattr(node.attributes), true));
	    }
	  };
	  parser.onclosetag = function() {
	    if (options.arrays) {
	      path.pop();
	    }
	    if (options.nested) {
	      nested.memory.map(function(item) {
	        return item.endElement()
	      });
	      var ne = nested.name.pop();
	      var xv = nested.memory.pop();
	      if (nested.check.pop() === true) {
	        var r1 = RegExp('(^<' + ne + '[^>]*>)', 'g'),
	          r2 = RegExp('(</' + ne + '[^>]*>$)', 'g');
	        cvalue('$t', xv.toString().replace(r1, '').replace(r2, ''));
	      }
	      else {
	        if (nested.buffer) {
	          cvalue('$t', nested.buffer);
	        }
	      }
	      xv = null;
	      nested.buffer = '';
	      nested.previous = 'C';
	    }
	
	    stack.pop();
	  };
	  parser.onready = function() {
	  };
	  parser.onend = function() {
	  };
	
	  if (options.throwErrors) {
	    stack.push(result);
	    parser.write(str);
	    var line = parser.line;
	    var column = parser.column;
	    parser.close();
	    stack.pop();
	
	    if (stack.length !== 0) {
	      var er = "Unexpected end of input";
	      er += "\nLine: " + line +
	        "\nColumn: " + column +
	        "\nChar: null";
	      throw new Error(er);
	    }
	  } else {
	    stack.push(result);
	    try {
	      parser.write(str).close();
	    }
	    catch (e) {
	      return str;
	    }
	    stack.pop();
	  }
	  result = clone(result);
	  return result;
	}
	


/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

	// wrapper for non-node envs
	;(function (sax) {
	
	sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
	sax.SAXParser = SAXParser
	sax.SAXStream = SAXStream
	sax.createStream = createStream
	
	// When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
	// When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
	// since that's the earliest that a buffer overrun could occur.  This way, checks are
	// as rare as required, but as often as necessary to ensure never crossing this bound.
	// Furthermore, buffers are only tested at most once per write(), so passing a very
	// large string into write() might have undesirable effects, but this is manageable by
	// the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
	// edge case, result in creating at most one complete copy of the string passed in.
	// Set to Infinity to have unlimited buffers.
	sax.MAX_BUFFER_LENGTH = 64 * 1024
	
	var buffers = [
	  "comment", "sgmlDecl", "textNode", "tagName", "doctype",
	  "procInstName", "procInstBody", "entity", "attribName",
	  "attribValue", "cdata", "script"
	]
	
	sax.EVENTS = // for discoverability.
	  [ "text"
	  , "processinginstruction"
	  , "sgmldeclaration"
	  , "doctype"
	  , "comment"
	  , "attribute"
	  , "opentag"
	  , "closetag"
	  , "opencdata"
	  , "cdata"
	  , "closecdata"
	  , "error"
	  , "end"
	  , "ready"
	  , "script"
	  , "opennamespace"
	  , "closenamespace"
	  ]
	
	function SAXParser (strict, opt) {
	  if (!(this instanceof SAXParser)) return new SAXParser(strict, opt)
	
	  var parser = this
	  clearBuffers(parser)
	  parser.q = parser.c = ""
	  parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
	  parser.opt = opt || {}
	  parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
	  parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase"
	  parser.tags = []
	  parser.closed = parser.closedRoot = parser.sawRoot = false
	  parser.tag = parser.error = null
	  parser.strict = !!strict
	  parser.noscript = !!(strict || parser.opt.noscript)
	  parser.state = S.BEGIN
	  parser.ENTITIES = Object.create(sax.ENTITIES)
	  parser.attribList = []
	
	  // namespaces form a prototype chain.
	  // it always points at the current tag,
	  // which protos to its parent tag.
	  if (parser.opt.xmlns) parser.ns = Object.create(rootNS)
	
	  // mostly just for error reporting
	  parser.trackPosition = parser.opt.position !== false
	  if (parser.trackPosition) {
	    parser.position = parser.line = parser.column = 0
	  }
	  emit(parser, "onready")
	}
	
	if (!Object.create) Object.create = function (o) {
	  function f () { this.__proto__ = o }
	  f.prototype = o
	  return new f
	}
	
	if (!Object.getPrototypeOf) Object.getPrototypeOf = function (o) {
	  return o.__proto__
	}
	
	if (!Object.keys) Object.keys = function (o) {
	  var a = []
	  for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
	  return a
	}
	
	function checkBufferLength (parser) {
	  var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
	    , maxActual = 0
	  for (var i = 0, l = buffers.length; i < l; i ++) {
	    var len = parser[buffers[i]].length
	    if (len > maxAllowed) {
	      // Text/cdata nodes can get big, and since they're buffered,
	      // we can get here under normal conditions.
	      // Avoid issues by emitting the text node now,
	      // so at least it won't get any bigger.
	      switch (buffers[i]) {
	        case "textNode":
	          closeText(parser)
	        break
	
	        case "cdata":
	          emitNode(parser, "oncdata", parser.cdata)
	          parser.cdata = ""
	        break
	
	        case "script":
	          emitNode(parser, "onscript", parser.script)
	          parser.script = ""
	        break
	
	        default:
	          error(parser, "Max buffer length exceeded: "+buffers[i])
	      }
	    }
	    maxActual = Math.max(maxActual, len)
	  }
	  // schedule the next check for the earliest possible buffer overrun.
	  parser.bufferCheckPosition = (sax.MAX_BUFFER_LENGTH - maxActual)
	                             + parser.position
	}
	
	function clearBuffers (parser) {
	  for (var i = 0, l = buffers.length; i < l; i ++) {
	    parser[buffers[i]] = ""
	  }
	}
	
	SAXParser.prototype =
	  { end: function () { end(this) }
	  , write: write
	  , resume: function () { this.error = null; return this }
	  , close: function () { return this.write(null) }
	  }
	
	try {
	  var Stream = __webpack_require__(2242).Stream
	} catch (ex) {
	  var Stream = function () {}
	}
	
	
	var streamWraps = sax.EVENTS.filter(function (ev) {
	  return ev !== "error" && ev !== "end"
	})
	
	function createStream (strict, opt) {
	  return new SAXStream(strict, opt)
	}
	
	function SAXStream (strict, opt) {
	  if (!(this instanceof SAXStream)) return new SAXStream(strict, opt)
	
	  Stream.apply(me)
	
	  this._parser = new SAXParser(strict, opt)
	  this.writable = true
	  this.readable = true
	
	
	  var me = this
	
	  this._parser.onend = function () {
	    me.emit("end")
	  }
	
	  this._parser.onerror = function (er) {
	    me.emit("error", er)
	
	    // if didn't throw, then means error was handled.
	    // go ahead and clear error, so we can write again.
	    me._parser.error = null
	  }
	
	  streamWraps.forEach(function (ev) {
	    Object.defineProperty(me, "on" + ev, {
	      get: function () { return me._parser["on" + ev] },
	      set: function (h) {
	        if (!h) {
	          me.removeAllListeners(ev)
	          return me._parser["on"+ev] = h
	        }
	        me.on(ev, h)
	      },
	      enumerable: true,
	      configurable: false
	    })
	  })
	}
	
	SAXStream.prototype = Object.create(Stream.prototype,
	  { constructor: { value: SAXStream } })
	
	SAXStream.prototype.write = function (data) {
	  this._parser.write(data.toString())
	  this.emit("data", data)
	  return true
	}
	
	SAXStream.prototype.end = function (chunk) {
	  if (chunk && chunk.length) this._parser.write(chunk.toString())
	  this._parser.end()
	  return true
	}
	
	SAXStream.prototype.on = function (ev, handler) {
	  var me = this
	  if (!me._parser["on"+ev] && streamWraps.indexOf(ev) !== -1) {
	    me._parser["on"+ev] = function () {
	      var args = arguments.length === 1 ? [arguments[0]]
	               : Array.apply(null, arguments)
	      args.splice(0, 0, ev)
	      me.emit.apply(me, args)
	    }
	  }
	
	  return Stream.prototype.on.call(me, ev, handler)
	}
	
	
	
	// character classes and tokens
	var whitespace = "\r\n\t "
	  // this really needs to be replaced with character classes.
	  // XML allows all manner of ridiculous numbers and digits.
	  , number = "0124356789"
	  , letter = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
	  // (Letter | "_" | ":")
	  , nameStart = letter+"_:"
	  , nameBody = nameStart+number+"-."
	  , quote = "'\""
	  , entity = number+letter+"#"
	  , attribEnd = whitespace + ">"
	  , CDATA = "[CDATA["
	  , DOCTYPE = "DOCTYPE"
	  , XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace"
	  , XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/"
	  , rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }
	
	// turn all the string character sets into character class objects.
	whitespace = charClass(whitespace)
	number = charClass(number)
	letter = charClass(letter)
	nameStart = charClass(nameStart)
	nameBody = charClass(nameBody)
	quote = charClass(quote)
	entity = charClass(entity)
	attribEnd = charClass(attribEnd)
	
	function charClass (str) {
	  return str.split("").reduce(function (s, c) {
	    s[c] = true
	    return s
	  }, {})
	}
	
	function is (charclass, c) {
	  return charclass[c]
	}
	
	function not (charclass, c) {
	  return !charclass[c]
	}
	
	var S = 0
	sax.STATE =
	{ BEGIN                     : S++
	, TEXT                      : S++ // general stuff
	, TEXT_ENTITY               : S++ // &amp and such.
	, OPEN_WAKA                 : S++ // <
	, SGML_DECL                 : S++ // <!BLARG
	, SGML_DECL_QUOTED          : S++ // <!BLARG foo "bar
	, DOCTYPE                   : S++ // <!DOCTYPE
	, DOCTYPE_QUOTED            : S++ // <!DOCTYPE "//blah
	, DOCTYPE_DTD               : S++ // <!DOCTYPE "//blah" [ ...
	, DOCTYPE_DTD_QUOTED        : S++ // <!DOCTYPE "//blah" [ "foo
	, COMMENT_STARTING          : S++ // <!-
	, COMMENT                   : S++ // <!--
	, COMMENT_ENDING            : S++ // <!-- blah -
	, COMMENT_ENDED             : S++ // <!-- blah --
	, CDATA                     : S++ // <![CDATA[ something
	, CDATA_ENDING              : S++ // ]
	, CDATA_ENDING_2            : S++ // ]]
	, PROC_INST                 : S++ // <?hi
	, PROC_INST_BODY            : S++ // <?hi there
	, PROC_INST_QUOTED          : S++ // <?hi "there
	, PROC_INST_ENDING          : S++ // <?hi "there" ?
	, OPEN_TAG                  : S++ // <strong
	, OPEN_TAG_SLASH            : S++ // <strong /
	, ATTRIB                    : S++ // <a
	, ATTRIB_NAME               : S++ // <a foo
	, ATTRIB_NAME_SAW_WHITE     : S++ // <a foo _
	, ATTRIB_VALUE              : S++ // <a foo=
	, ATTRIB_VALUE_QUOTED       : S++ // <a foo="bar
	, ATTRIB_VALUE_UNQUOTED     : S++ // <a foo=bar
	, ATTRIB_VALUE_ENTITY_Q     : S++ // <foo bar="&quot;"
	, ATTRIB_VALUE_ENTITY_U     : S++ // <foo bar=&quot;
	, CLOSE_TAG                 : S++ // </a
	, CLOSE_TAG_SAW_WHITE       : S++ // </a   >
	, SCRIPT                    : S++ // <script> ...
	, SCRIPT_ENDING             : S++ // <script> ... <
	}
	
	sax.ENTITIES =
	{ "apos" : "'"
	, "quot" : "\""
	, "amp"  : "&"
	, "gt"   : ">"
	, "lt"   : "<"
	}
	
	for (var S in sax.STATE) sax.STATE[sax.STATE[S]] = S
	
	// shorthand
	S = sax.STATE
	
	function emit (parser, event, data) {
	  parser[event] && parser[event](data)
	}
	
	function emitNode (parser, nodeType, data) {
	  if (parser.textNode) closeText(parser)
	  emit(parser, nodeType, data)
	}
	
	function closeText (parser) {
	  parser.textNode = textopts(parser.opt, parser.textNode)
	  if (parser.textNode) emit(parser, "ontext", parser.textNode)
	  parser.textNode = ""
	}
	
	function textopts (opt, text) {
	  if (opt.trim) text = text.trim()
	  if (opt.normalize) text = text.replace(/\s+/g, " ")
	  return text
	}
	
	function error (parser, er) {
	  closeText(parser)
	  if (parser.trackPosition) {
	    er += "\nLine: "+parser.line+
	          "\nColumn: "+parser.column+
	          "\nChar: "+parser.c
	  }
	  er = new Error(er)
	  parser.error = er
	  emit(parser, "onerror", er)
	  return parser
	}
	
	function end (parser) {
	  if (parser.state !== S.TEXT) error(parser, "Unexpected end")
	  closeText(parser)
	  parser.c = ""
	  parser.closed = true
	  emit(parser, "onend")
	  SAXParser.call(parser, parser.strict, parser.opt)
	  return parser
	}
	
	function strictFail (parser, message) {
	  if (parser.strict) error(parser, message)
	}
	
	function newTag (parser) {
	  if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
	  var parent = parser.tags[parser.tags.length - 1] || parser
	    , tag = parser.tag = { name : parser.tagName, attributes : {} }
	
	  // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
	  if (parser.opt.xmlns) tag.ns = parent.ns
	  parser.attribList.length = 0
	}
	
	function qname (name) {
	  var i = name.indexOf(":")
	    , qualName = i < 0 ? [ "", name ] : name.split(":")
	    , prefix = qualName[0]
	    , local = qualName[1]
	
	  // <x "xmlns"="http://foo">
	  if (name === "xmlns") {
	    prefix = "xmlns"
	    local = ""
	  }
	
	  return { prefix: prefix, local: local }
	}
	
	function attrib (parser) {
	  if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]()
	  if (parser.opt.xmlns) {
	    var qn = qname(parser.attribName)
	      , prefix = qn.prefix
	      , local = qn.local
	
	    if (prefix === "xmlns") {
	      // namespace binding attribute; push the binding into scope
	      if (local === "xml" && parser.attribValue !== XML_NAMESPACE) {
	        strictFail( parser
	                  , "xml: prefix must be bound to " + XML_NAMESPACE + "\n"
	                  + "Actual: " + parser.attribValue )
	      } else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) {
	        strictFail( parser
	                  , "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\n"
	                  + "Actual: " + parser.attribValue )
	      } else {
	        var tag = parser.tag
	          , parent = parser.tags[parser.tags.length - 1] || parser
	        if (tag.ns === parent.ns) {
	          tag.ns = Object.create(parent.ns)
	        }
	        tag.ns[local] = parser.attribValue
	      }
	    }
	
	    // defer onattribute events until all attributes have been seen
	    // so any new bindings can take effect; preserve attribute order
	    // so deferred events can be emitted in document order
	    parser.attribList.push([parser.attribName, parser.attribValue])
	  } else {
	    // in non-xmlns mode, we can emit the event right away
	    parser.tag.attributes[parser.attribName] = parser.attribValue
	    emitNode( parser
	            , "onattribute"
	            , { name: parser.attribName
	              , value: parser.attribValue } )
	  }
	
	  parser.attribName = parser.attribValue = ""
	}
	
	function openTag (parser, selfClosing) {
	  if (parser.opt.xmlns) {
	    // emit namespace binding events
	    var tag = parser.tag
	
	    // add namespace info to tag
	    var qn = qname(parser.tagName)
	    tag.prefix = qn.prefix
	    tag.local = qn.local
	    tag.uri = tag.ns[qn.prefix] || qn.prefix
	
	    if (tag.prefix && !tag.uri) {
	      strictFail(parser, "Unbound namespace prefix: "
	                       + JSON.stringify(parser.tagName))
	    }
	
	    var parent = parser.tags[parser.tags.length - 1] || parser
	    if (tag.ns && parent.ns !== tag.ns) {
	      Object.keys(tag.ns).forEach(function (p) {
	        emitNode( parser
	                , "onopennamespace"
	                , { prefix: p , uri: tag.ns[p] } )
	      })
	    }
	
	    // handle deferred onattribute events
	    // Note: do not apply default ns to attributes:
	    //   http://www.w3.org/TR/REC-xml-names/#defaulting
	    for (var i = 0, l = parser.attribList.length; i < l; i ++) {
	      var nv = parser.attribList[i]
	      var name = nv[0]
	        , value = nv[1]
	        , qualName = qname(name)
	        , prefix = qualName.prefix
	        , local = qualName.local
	        , uri = prefix == "" ? "" : (tag.ns[prefix] || "")
	        , a = { name: name
	              , value: value
	              , prefix: prefix
	              , local: local
	              , uri: uri
	              }
	
	      // if there's any attributes with an undefined namespace,
	      // then fail on them now.
	      if (prefix && prefix != "xmlns" && !uri) {
	        strictFail(parser, "Unbound namespace prefix: "
	                         + JSON.stringify(prefix))
	        a.uri = prefix
	      }
	      parser.tag.attributes[name] = a
	      emitNode(parser, "onattribute", a)
	    }
	    parser.attribList.length = 0
	  }
	
	  // process the tag
	  parser.sawRoot = true
	  parser.tags.push(parser.tag)
	  emitNode(parser, "onopentag", parser.tag)
	  if (!selfClosing) {
	    // special case for <script> in non-strict mode.
	    if (!parser.noscript && parser.tagName.toLowerCase() === "script") {
	      parser.state = S.SCRIPT
	    } else {
	      parser.state = S.TEXT
	    }
	    parser.tag = null
	    parser.tagName = ""
	  }
	  parser.attribName = parser.attribValue = ""
	  parser.attribList.length = 0
	}
	
	function closeTag (parser) {
	  if (!parser.tagName) {
	    strictFail(parser, "Weird empty close tag.")
	    parser.textNode += "</>"
	    parser.state = S.TEXT
	    return
	  }
	  // first make sure that the closing tag actually exists.
	  // <a><b></c></b></a> will close everything, otherwise.
	  var t = parser.tags.length
	  var tagName = parser.tagName
	  if (!parser.strict) tagName = tagName[parser.looseCase]()
	  var closeTo = tagName
	  while (t --) {
	    var close = parser.tags[t]
	    if (close.name !== closeTo) {
	      // fail the first time in strict mode
	      strictFail(parser, "Unexpected close tag")
	    } else break
	  }
	
	  // didn't find it.  we already failed for strict, so just abort.
	  if (t < 0) {
	    strictFail(parser, "Unmatched closing tag: "+parser.tagName)
	    parser.textNode += "</" + parser.tagName + ">"
	    parser.state = S.TEXT
	    return
	  }
	  parser.tagName = tagName
	  var s = parser.tags.length
	  while (s --> t) {
	    var tag = parser.tag = parser.tags.pop()
	    parser.tagName = parser.tag.name
	    emitNode(parser, "onclosetag", parser.tagName)
	
	    var x = {}
	    for (var i in tag.ns) x[i] = tag.ns[i]
	
	    var parent = parser.tags[parser.tags.length - 1] || parser
	    if (parser.opt.xmlns && tag.ns !== parent.ns) {
	      // remove namespace bindings introduced by tag
	      Object.keys(tag.ns).forEach(function (p) {
	        var n = tag.ns[p]
	        emitNode(parser, "onclosenamespace", { prefix: p, uri: n })
	      })
	    }
	  }
	  if (t === 0) parser.closedRoot = true
	  parser.tagName = parser.attribValue = parser.attribName = ""
	  parser.attribList.length = 0
	  parser.state = S.TEXT
	}
	
	function parseEntity (parser) {
	  var entity = parser.entity.toLowerCase()
	    , num
	    , numStr = ""
	  if (parser.ENTITIES[entity]) return parser.ENTITIES[entity]
	  if (entity.charAt(0) === "#") {
	    if (entity.charAt(1) === "x") {
	      entity = entity.slice(2)
	      num = parseInt(entity, 16)
	      numStr = num.toString(16)
	    } else {
	      entity = entity.slice(1)
	      num = parseInt(entity, 10)
	      numStr = num.toString(10)
	    }
	  }
	  entity = entity.replace(/^0+/, "")
	  if (numStr.toLowerCase() !== entity) {
	    strictFail(parser, "Invalid character entity")
	    return "&"+parser.entity + ";"
	  }
	  return String.fromCharCode(num)
	}
	
	function write (chunk) {
	  var parser = this
	  if (this.error) throw this.error
	  if (parser.closed) return error(parser,
	    "Cannot write after close. Assign an onready handler.")
	  if (chunk === null) return end(parser)
	  var i = 0, c = ""
	  while (parser.c = c = chunk.charAt(i++)) {
	    if (parser.trackPosition) {
	      parser.position ++
	      if (c === "\n") {
	        parser.line ++
	        parser.column = 0
	      } else parser.column ++
	    }
	    switch (parser.state) {
	
	      case S.BEGIN:
	        if (c === "<") parser.state = S.OPEN_WAKA
	        else if (not(whitespace,c)) {
	          // have to process this as a text node.
	          // weird, but happens.
	          strictFail(parser, "Non-whitespace before first tag.")
	          parser.textNode = c
	          parser.state = S.TEXT
	        }
	      continue
	
	      case S.TEXT:
	        if (parser.sawRoot && !parser.closedRoot) {
	          var starti = i-1
	          while (c && c!=="<" && c!=="&") {
	            c = chunk.charAt(i++)
	            if (c && parser.trackPosition) {
	              parser.position ++
	              if (c === "\n") {
	                parser.line ++
	                parser.column = 0
	              } else parser.column ++
	            }
	          }
	          parser.textNode += chunk.substring(starti, i-1)
	        }
	        if (c === "<") parser.state = S.OPEN_WAKA
	        else {
	          if (not(whitespace, c) && (!parser.sawRoot || parser.closedRoot))
	            strictFail("Text data outside of root node.")
	          if (c === "&") parser.state = S.TEXT_ENTITY
	          else parser.textNode += c
	        }
	      continue
	
	      case S.SCRIPT:
	        // only non-strict
	        if (c === "<") {
	          parser.state = S.SCRIPT_ENDING
	        } else parser.script += c
	      continue
	
	      case S.SCRIPT_ENDING:
	        if (c === "/") {
	          emitNode(parser, "onscript", parser.script)
	          parser.state = S.CLOSE_TAG
	          parser.script = ""
	          parser.tagName = ""
	        } else {
	          parser.script += "<" + c
	          parser.state = S.SCRIPT
	        }
	      continue
	
	      case S.OPEN_WAKA:
	        // either a /, ?, !, or text is coming next.
	        if (c === "!") {
	          parser.state = S.SGML_DECL
	          parser.sgmlDecl = ""
	        } else if (is(whitespace, c)) {
	          // wait for it...
	        } else if (is(nameStart,c)) {
	          parser.startTagPosition = parser.position - 1
	          parser.state = S.OPEN_TAG
	          parser.tagName = c
	        } else if (c === "/") {
	          parser.startTagPosition = parser.position - 1
	          parser.state = S.CLOSE_TAG
	          parser.tagName = ""
	        } else if (c === "?") {
	          parser.state = S.PROC_INST
	          parser.procInstName = parser.procInstBody = ""
	        } else {
	          strictFail(parser, "Unencoded <")
	          parser.textNode += "<" + c
	          parser.state = S.TEXT
	        }
	      continue
	
	      case S.SGML_DECL:
	        if ((parser.sgmlDecl+c).toUpperCase() === CDATA) {
	          emitNode(parser, "onopencdata")
	          parser.state = S.CDATA
	          parser.sgmlDecl = ""
	          parser.cdata = ""
	        } else if (parser.sgmlDecl+c === "--") {
	          parser.state = S.COMMENT
	          parser.comment = ""
	          parser.sgmlDecl = ""
	        } else if ((parser.sgmlDecl+c).toUpperCase() === DOCTYPE) {
	          parser.state = S.DOCTYPE
	          if (parser.doctype || parser.sawRoot) strictFail(parser,
	            "Inappropriately located doctype declaration")
	          parser.doctype = ""
	          parser.sgmlDecl = ""
	        } else if (c === ">") {
	          emitNode(parser, "onsgmldeclaration", parser.sgmlDecl)
	          parser.sgmlDecl = ""
	          parser.state = S.TEXT
	        } else if (is(quote, c)) {
	          parser.state = S.SGML_DECL_QUOTED
	          parser.sgmlDecl += c
	        } else parser.sgmlDecl += c
	      continue
	
	      case S.SGML_DECL_QUOTED:
	        if (c === parser.q) {
	          parser.state = S.SGML_DECL
	          parser.q = ""
	        }
	        parser.sgmlDecl += c
	      continue
	
	      case S.DOCTYPE:
	        if (c === ">") {
	          parser.state = S.TEXT
	          emitNode(parser, "ondoctype", parser.doctype)
	          parser.doctype = true // just remember that we saw it.
	        } else {
	          parser.doctype += c
	          if (c === "[") parser.state = S.DOCTYPE_DTD
	          else if (is(quote, c)) {
	            parser.state = S.DOCTYPE_QUOTED
	            parser.q = c
	          }
	        }
	      continue
	
	      case S.DOCTYPE_QUOTED:
	        parser.doctype += c
	        if (c === parser.q) {
	          parser.q = ""
	          parser.state = S.DOCTYPE
	        }
	      continue
	
	      case S.DOCTYPE_DTD:
	        parser.doctype += c
	        if (c === "]") parser.state = S.DOCTYPE
	        else if (is(quote,c)) {
	          parser.state = S.DOCTYPE_DTD_QUOTED
	          parser.q = c
	        }
	      continue
	
	      case S.DOCTYPE_DTD_QUOTED:
	        parser.doctype += c
	        if (c === parser.q) {
	          parser.state = S.DOCTYPE_DTD
	          parser.q = ""
	        }
	      continue
	
	      case S.COMMENT:
	        if (c === "-") parser.state = S.COMMENT_ENDING
	        else parser.comment += c
	      continue
	
	      case S.COMMENT_ENDING:
	        if (c === "-") {
	          parser.state = S.COMMENT_ENDED
	          parser.comment = textopts(parser.opt, parser.comment)
	          if (parser.comment) emitNode(parser, "oncomment", parser.comment)
	          parser.comment = ""
	        } else {
	          parser.comment += "-" + c
	          parser.state = S.COMMENT
	        }
	      continue
	
	      case S.COMMENT_ENDED:
	        if (c !== ">") {
	          strictFail(parser, "Malformed comment")
	          // allow <!-- blah -- bloo --> in non-strict mode,
	          // which is a comment of " blah -- bloo "
	          parser.comment += "--" + c
	          parser.state = S.COMMENT
	        } else parser.state = S.TEXT
	      continue
	
	      case S.CDATA:
	        if (c === "]") parser.state = S.CDATA_ENDING
	        else parser.cdata += c
	      continue
	
	      case S.CDATA_ENDING:
	        if (c === "]") parser.state = S.CDATA_ENDING_2
	        else {
	          parser.cdata += "]" + c
	          parser.state = S.CDATA
	        }
	      continue
	
	      case S.CDATA_ENDING_2:
	        if (c === ">") {
	          if (parser.cdata) emitNode(parser, "oncdata", parser.cdata)
	          emitNode(parser, "onclosecdata")
	          parser.cdata = ""
	          parser.state = S.TEXT
	        } else if (c === "]") {
	          parser.cdata += "]"
	        } else {
	          parser.cdata += "]]" + c
	          parser.state = S.CDATA
	        }
	      continue
	
	      case S.PROC_INST:
	        if (c === "?") parser.state = S.PROC_INST_ENDING
	        else if (is(whitespace, c)) parser.state = S.PROC_INST_BODY
	        else parser.procInstName += c
	      continue
	
	      case S.PROC_INST_BODY:
	        if (!parser.procInstBody && is(whitespace, c)) continue
	        else if (c === "?") parser.state = S.PROC_INST_ENDING
	        else if (is(quote, c)) {
	          parser.state = S.PROC_INST_QUOTED
	          parser.q = c
	          parser.procInstBody += c
	        } else parser.procInstBody += c
	      continue
	
	      case S.PROC_INST_ENDING:
	        if (c === ">") {
	          emitNode(parser, "onprocessinginstruction", {
	            name : parser.procInstName,
	            body : parser.procInstBody
	          })
	          parser.procInstName = parser.procInstBody = ""
	          parser.state = S.TEXT
	        } else {
	          parser.procInstBody += "?" + c
	          parser.state = S.PROC_INST_BODY
	        }
	      continue
	
	      case S.PROC_INST_QUOTED:
	        parser.procInstBody += c
	        if (c === parser.q) {
	          parser.state = S.PROC_INST_BODY
	          parser.q = ""
	        }
	      continue
	
	      case S.OPEN_TAG:
	        if (is(nameBody, c)) parser.tagName += c
	        else {
	          newTag(parser)
	          if (c === ">") openTag(parser)
	          else if (c === "/") parser.state = S.OPEN_TAG_SLASH
	          else {
	            if (not(whitespace, c)) strictFail(
	              parser, "Invalid character in tag name")
	            parser.state = S.ATTRIB
	          }
	        }
	      continue
	
	      case S.OPEN_TAG_SLASH:
	        if (c === ">") {
	          openTag(parser, true)
	          closeTag(parser)
	        } else {
	          strictFail(parser, "Forward-slash in opening tag not followed by >")
	          parser.state = S.ATTRIB
	        }
	      continue
	
	      case S.ATTRIB:
	        // haven't read the attribute name yet.
	        if (is(whitespace, c)) continue
	        else if (c === ">") openTag(parser)
	        else if (c === "/") parser.state = S.OPEN_TAG_SLASH
	        else if (is(nameStart, c)) {
	          parser.attribName = c
	          parser.attribValue = ""
	          parser.state = S.ATTRIB_NAME
	        } else strictFail(parser, "Invalid attribute name")
	      continue
	
	      case S.ATTRIB_NAME:
	        if (c === "=") parser.state = S.ATTRIB_VALUE
	        else if (is(whitespace, c)) parser.state = S.ATTRIB_NAME_SAW_WHITE
	        else if (is(nameBody, c)) parser.attribName += c
	        else strictFail(parser, "Invalid attribute name")
	      continue
	
	      case S.ATTRIB_NAME_SAW_WHITE:
	        if (c === "=") parser.state = S.ATTRIB_VALUE
	        else if (is(whitespace, c)) continue
	        else {
	          strictFail(parser, "Attribute without value")
	          parser.tag.attributes[parser.attribName] = ""
	          parser.attribValue = ""
	          emitNode(parser, "onattribute",
	                   { name : parser.attribName, value : "" })
	          parser.attribName = ""
	          if (c === ">") openTag(parser)
	          else if (is(nameStart, c)) {
	            parser.attribName = c
	            parser.state = S.ATTRIB_NAME
	          } else {
	            strictFail(parser, "Invalid attribute name")
	            parser.state = S.ATTRIB
	          }
	        }
	      continue
	
	      case S.ATTRIB_VALUE:
	        if (is(whitespace, c)) continue
	        else if (is(quote, c)) {
	          parser.q = c
	          parser.state = S.ATTRIB_VALUE_QUOTED
	        } else {
	          strictFail(parser, "Unquoted attribute value")
	          parser.state = S.ATTRIB_VALUE_UNQUOTED
	          parser.attribValue = c
	        }
	      continue
	
	      case S.ATTRIB_VALUE_QUOTED:
	        if (c !== parser.q) {
	          if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q
	          else parser.attribValue += c
	          continue
	        }
	        attrib(parser)
	        parser.q = ""
	        parser.state = S.ATTRIB
	      continue
	
	      case S.ATTRIB_VALUE_UNQUOTED:
	        if (not(attribEnd,c)) {
	          if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U
	          else parser.attribValue += c
	          continue
	        }
	        attrib(parser)
	        if (c === ">") openTag(parser)
	        else parser.state = S.ATTRIB
	      continue
	
	      case S.CLOSE_TAG:
	        if (!parser.tagName) {
	          if (is(whitespace, c)) continue
	          else if (not(nameStart, c)) strictFail(parser,
	            "Invalid tagname in closing tag.")
	          else parser.tagName = c
	        }
	        else if (c === ">") closeTag(parser)
	        else if (is(nameBody, c)) parser.tagName += c
	        else {
	          if (not(whitespace, c)) strictFail(parser,
	            "Invalid tagname in closing tag")
	          parser.state = S.CLOSE_TAG_SAW_WHITE
	        }
	      continue
	
	      case S.CLOSE_TAG_SAW_WHITE:
	        if (is(whitespace, c)) continue
	        if (c === ">") closeTag(parser)
	        else strictFail("Invalid characters in closing tag")
	      continue
	
	      case S.TEXT_ENTITY:
	      case S.ATTRIB_VALUE_ENTITY_Q:
	      case S.ATTRIB_VALUE_ENTITY_U:
	        switch(parser.state) {
	          case S.TEXT_ENTITY:
	            var returnState = S.TEXT, buffer = "textNode"
	          break
	
	          case S.ATTRIB_VALUE_ENTITY_Q:
	            var returnState = S.ATTRIB_VALUE_QUOTED, buffer = "attribValue"
	          break
	
	          case S.ATTRIB_VALUE_ENTITY_U:
	            var returnState = S.ATTRIB_VALUE_UNQUOTED, buffer = "attribValue"
	          break
	        }
	        if (c === ";") {
	          parser[buffer] += parseEntity(parser)
	          parser.entity = ""
	          parser.state = returnState
	        }
	        else if (is(entity, c)) parser.entity += c
	        else {
	          strictFail("Invalid character entity")
	          parser[buffer] += "&" + parser.entity + c
	          parser.entity = ""
	          parser.state = returnState
	        }
	      continue
	
	      default:
	        throw new Error(parser, "Unknown state: " + parser.state)
	    }
	  } // while
	  // cdata blocks can get very big under normal conditions. emit and move on.
	  // if (parser.state === S.CDATA && parser.cdata) {
	  //   emitNode(parser, "oncdata", parser.cdata)
	  //   parser.cdata = ""
	  // }
	  if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser)
	  return parser
	}
	
	})( false ? sax = {} : exports)


/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * filter xss
	 *
	 * @author Zongmin Lei<leizongmin@gmail.com>
	 */
	
	var FilterCSS = __webpack_require__(432).FilterCSS;
	var DEFAULT = __webpack_require__(1014);
	var parser = __webpack_require__(1016);
	var parseTag = parser.parseTag;
	var parseAttr = parser.parseAttr;
	var _ = __webpack_require__(590);
	
	/**
	 * returns `true` if the input value is `undefined` or `null`
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 */
	function isNull(obj) {
	  return obj === undefined || obj === null;
	}
	
	/**
	 * get attributes for a tag
	 *
	 * @param {String} html
	 * @return {Object}
	 *   - {String} html
	 *   - {Boolean} closing
	 */
	function getAttrs(html) {
	  var i = _.spaceIndex(html);
	  if (i === -1) {
	    return {
	      html: "",
	      closing: html[html.length - 2] === "/",
	    };
	  }
	  html = _.trim(html.slice(i + 1, -1));
	  var isClosing = html[html.length - 1] === "/";
	  if (isClosing) html = _.trim(html.slice(0, -1));
	  return {
	    html: html,
	    closing: isClosing,
	  };
	}
	
	/**
	 * shallow copy
	 *
	 * @param {Object} obj
	 * @return {Object}
	 */
	function shallowCopyObject(obj) {
	  var ret = {};
	  for (var i in obj) {
	    ret[i] = obj[i];
	  }
	  return ret;
	}
	
	function keysToLowerCase(obj) {
	  var ret = {};
	  for (var i in obj) {
	    if (Array.isArray(obj[i])) {
	      ret[i.toLowerCase()] = obj[i].map(function (item) {
	        return item.toLowerCase();
	      });
	    } else {
	      ret[i.toLowerCase()] = obj[i];
	    }
	  }
	  return ret;
	}
	
	/**
	 * FilterXSS class
	 *
	 * @param {Object} options
	 *        whiteList (or allowList), onTag, onTagAttr, onIgnoreTag,
	 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
	 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
	 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
	 */
	function FilterXSS(options) {
	  options = shallowCopyObject(options || {});
	
	  if (options.stripIgnoreTag) {
	    if (options.onIgnoreTag) {
	      console.error(
	        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
	      );
	    }
	    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
	  }
	  if (options.whiteList || options.allowList) {
	    options.whiteList = keysToLowerCase(options.whiteList || options.allowList);
	  } else {
	    options.whiteList = DEFAULT.whiteList;
	  }
	
	  options.onTag = options.onTag || DEFAULT.onTag;
	  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
	  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
	  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
	  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
	  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
	  this.options = options;
	
	  if (options.css === false) {
	    this.cssFilter = false;
	  } else {
	    options.css = options.css || {};
	    this.cssFilter = new FilterCSS(options.css);
	  }
	}
	
	/**
	 * start process and returns result
	 *
	 * @param {String} html
	 * @return {String}
	 */
	FilterXSS.prototype.process = function (html) {
	  // compatible with the input
	  html = html || "";
	  html = html.toString();
	  if (!html) return "";
	
	  var me = this;
	  var options = me.options;
	  var whiteList = options.whiteList;
	  var onTag = options.onTag;
	  var onIgnoreTag = options.onIgnoreTag;
	  var onTagAttr = options.onTagAttr;
	  var onIgnoreTagAttr = options.onIgnoreTagAttr;
	  var safeAttrValue = options.safeAttrValue;
	  var escapeHtml = options.escapeHtml;
	  var cssFilter = me.cssFilter;
	
	  // remove invisible characters
	  if (options.stripBlankChar) {
	    html = DEFAULT.stripBlankChar(html);
	  }
	
	  // remove html comments
	  if (!options.allowCommentTag) {
	    html = DEFAULT.stripCommentTag(html);
	  }
	
	  // if enable stripIgnoreTagBody
	  var stripIgnoreTagBody = false;
	  if (options.stripIgnoreTagBody) {
	    stripIgnoreTagBody = DEFAULT.StripTagBody(
	      options.stripIgnoreTagBody,
	      onIgnoreTag
	    );
	    onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
	  }
	
	  var retHtml = parseTag(
	    html,
	    function (sourcePosition, position, tag, html, isClosing) {
	      var info = {
	        sourcePosition: sourcePosition,
	        position: position,
	        isClosing: isClosing,
	        isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag),
	      };
	
	      // call `onTag()`
	      var ret = onTag(tag, html, info);
	      if (!isNull(ret)) return ret;
	
	      if (info.isWhite) {
	        if (info.isClosing) {
	          return "</" + tag + ">";
	        }
	
	        var attrs = getAttrs(html);
	        var whiteAttrList = whiteList[tag];
	        var attrsHtml = parseAttr(attrs.html, function (name, value) {
	          // call `onTagAttr()`
	          var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
	          var ret = onTagAttr(tag, name, value, isWhiteAttr);
	          if (!isNull(ret)) return ret;
	
	          if (isWhiteAttr) {
	            // call `safeAttrValue()`
	            value = safeAttrValue(tag, name, value, cssFilter);
	            if (value) {
	              return name + '="' + value + '"';
	            } else {
	              return name;
	            }
	          } else {
	            // call `onIgnoreTagAttr()`
	            ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
	            if (!isNull(ret)) return ret;
	            return;
	          }
	        });
	
	        // build new tag html
	        html = "<" + tag;
	        if (attrsHtml) html += " " + attrsHtml;
	        if (attrs.closing) html += " /";
	        html += ">";
	        return html;
	      } else {
	        // call `onIgnoreTag()`
	        ret = onIgnoreTag(tag, html, info);
	        if (!isNull(ret)) return ret;
	        return escapeHtml(html);
	      }
	    },
	    escapeHtml
	  );
	
	  // if enable stripIgnoreTagBody
	  if (stripIgnoreTagBody) {
	    retHtml = stripIgnoreTagBody.remove(retHtml);
	  }
	
	  return retHtml;
	};
	
	module.exports = FilterXSS;


/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./icn-claimWizard-white.svg": 356,
		"./icn-dsdocuments-white.svg": 357,
		"./icn-inbox-white.svg": 358
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2332;


/***/ }),
/* 2333 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2334 */
2333,
/* 2335 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(__webpack_module_template_argument_0__);
	
	var callBind = __webpack_require__(__webpack_module_template_argument_1__);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	
	var bind = __webpack_require__(__webpack_module_template_argument_0__);
	var GetIntrinsic = __webpack_require__(__webpack_module_template_argument_1__);
	var setFunctionLength = __webpack_require__(__webpack_module_template_argument_2__);
	
	var $TypeError = __webpack_require__(__webpack_module_template_argument_3__);
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_4__);
	var $max = GetIntrinsic('%Math.max%');
	
	module.exports = function callBind(originalFunction) {
		if (typeof originalFunction !== 'function') {
			throw new $TypeError('a function is required');
		}
		var func = $reflectApply(bind, $call, arguments);
		return setFunctionLength(
			func,
			1 + $max(0, originalFunction.length - (arguments.length - 1)),
			true
		);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var objectKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var isArguments = __webpack_require__(__webpack_module_template_argument_1__);
	var is = __webpack_require__(__webpack_module_template_argument_2__);
	var isRegex = __webpack_require__(__webpack_module_template_argument_3__);
	var flags = __webpack_require__(__webpack_module_template_argument_4__);
	var isDate = __webpack_require__(__webpack_module_template_argument_5__);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
	var $SyntaxError = __webpack_require__(__webpack_module_template_argument_1__);
	var $TypeError = __webpack_require__(__webpack_module_template_argument_2__);
	
	var gopd = __webpack_require__(__webpack_module_template_argument_3__);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	var keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(__webpack_module_template_argument_1__);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(__webpack_module_template_argument_2__)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** @type {import('.')} */
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var implementation = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__) {

	'use strict';
	
	var undefined;
	
	var $Error = __webpack_require__(__webpack_module_template_argument_0__);
	var $EvalError = __webpack_require__(__webpack_module_template_argument_1__);
	var $RangeError = __webpack_require__(__webpack_module_template_argument_2__);
	var $ReferenceError = __webpack_require__(__webpack_module_template_argument_3__);
	var $SyntaxError = __webpack_require__(__webpack_module_template_argument_4__);
	var $TypeError = __webpack_require__(__webpack_module_template_argument_5__);
	var $URIError = __webpack_require__(__webpack_module_template_argument_6__);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(__webpack_module_template_argument_7__)();
	var hasProto = __webpack_require__(__webpack_module_template_argument_8__)();
	
	var getProto = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(__webpack_module_template_argument_9__);
	var hasOwn = __webpack_require__(__webpack_module_template_argument_10__);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	var $exec = bind.call(Function.call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(__webpack_module_template_argument_0__);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(__webpack_module_template_argument_0__)();
	var callBound = __webpack_require__(__webpack_module_template_argument_1__);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(__webpack_module_template_argument_0__)();
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	var callBound = __webpack_require__(__webpack_module_template_argument_0__);
	var hasToStringTag = __webpack_require__(__webpack_module_template_argument_1__)();
	var has;
	var $exec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		has = callBound('Object.prototype.hasOwnProperty');
		$exec = callBound('RegExp.prototype.exec');
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var $toString = callBound('Object.prototype.toString');
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				$exec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};


/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	
	var define = __webpack_require__(__webpack_module_template_argument_0__);
	var callBind = __webpack_require__(__webpack_module_template_argument_1__);
	
	var implementation = __webpack_require__(__webpack_module_template_argument_2__);
	var getPolyfill = __webpack_require__(__webpack_module_template_argument_3__);
	var shim = __webpack_require__(__webpack_module_template_argument_4__);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var implementation = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(__webpack_module_template_argument_0__);
	var define = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(__webpack_module_template_argument_0__); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(__webpack_module_template_argument_0__);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(__webpack_module_template_argument_1__);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	var setFunctionName = __webpack_require__(__webpack_module_template_argument_0__);
	var $TypeError = __webpack_require__(__webpack_module_template_argument_1__);
	
	var $Object = Object;
	
	module.exports = setFunctionName(function flags() {
		if (this == null || this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.hasIndices) {
			result += 'd';
		}
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.unicodeSets) {
			result += 'v';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	}, 'get flags', true);
	


/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	
	var define = __webpack_require__(__webpack_module_template_argument_0__);
	var callBind = __webpack_require__(__webpack_module_template_argument_1__);
	
	var implementation = __webpack_require__(__webpack_module_template_argument_2__);
	var getPolyfill = __webpack_require__(__webpack_module_template_argument_3__);
	var shim = __webpack_require__(__webpack_module_template_argument_4__);
	
	var flagsBound = callBind(getPolyfill());
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	var implementation = __webpack_require__(__webpack_module_template_argument_0__);
	
	var supportsDescriptors = __webpack_require__(__webpack_module_template_argument_1__).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	
	module.exports = function getPolyfill() {
		if (supportsDescriptors && (/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (
				descriptor
				&& typeof descriptor.get === 'function'
				&& 'dotAll' in RegExp.prototype
				&& 'hasIndices' in RegExp.prototype
			) {
				/* eslint getter-return: 0 */
				var calls = '';
				var o = {};
				Object.defineProperty(o, 'hasIndices', {
					get: function () {
						calls += 'd';
					}
				});
				Object.defineProperty(o, 'sticky', {
					get: function () {
						calls += 'y';
					}
				});
	
				descriptor.get.call(o);
	
				if (calls === 'dy') {
					return descriptor.get;
				}
			}
		}
		return implementation;
	};


/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(__webpack_module_template_argument_0__).supportsDescriptors;
	var getPolyfill = __webpack_require__(__webpack_module_template_argument_1__);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(__webpack_module_template_argument_0__);
	var define = __webpack_require__(__webpack_module_template_argument_1__);
	var hasDescriptors = __webpack_require__(__webpack_module_template_argument_2__)();
	var gOPD = __webpack_require__(__webpack_module_template_argument_3__);
	
	var $TypeError = __webpack_require__(__webpack_module_template_argument_4__);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	var define = __webpack_require__(__webpack_module_template_argument_0__);
	var hasDescriptors = __webpack_require__(__webpack_module_template_argument_1__)();
	var functionsHaveConfigurableNames = __webpack_require__(__webpack_module_template_argument_2__).functionsHaveConfigurableNames();
	
	var $TypeError = __webpack_require__(__webpack_module_template_argument_3__);
	
	/** @type {import('.')} */
	module.exports = function setFunctionName(fn, name) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		var loose = arguments.length > 2 && !!arguments[2];
		if (!loose || functionsHaveConfigurableNames) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
			}
		}
		return fn;
	};


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// bundle.js